(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bRvn3", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $8a2cfa87cf2f491f$export$6503ec6e8aabbaf; }, function (v) { return $8a2cfa87cf2f491f$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $8a2cfa87cf2f491f$export$f7ad0328861e2f03; }, function (v) { return $8a2cfa87cf2f491f$export$f7ad0328861e2f03 = v; });
var $8a2cfa87cf2f491f$export$6503ec6e8aabbaf;
var $8a2cfa87cf2f491f$export$f7ad0328861e2f03;
"use strict";
var $8a2cfa87cf2f491f$var$mapping = new Map();
function $8a2cfa87cf2f491f$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$8a2cfa87cf2f491f$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $8a2cfa87cf2f491f$var$resolve(id) {
    var resolved = $8a2cfa87cf2f491f$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$8a2cfa87cf2f491f$export$6503ec6e8aabbaf = $8a2cfa87cf2f491f$var$register;
$8a2cfa87cf2f491f$export$f7ad0328861e2f03 = $8a2cfa87cf2f491f$var$resolve;

});

parcelRegister("6Aq0R", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $4cba487fb552c90c$export$bdfd709ae4826697; }, function (v) { return $4cba487fb552c90c$export$bdfd709ae4826697 = v; });
var $4cba487fb552c90c$export$bdfd709ae4826697;
var $4cba487fb552c90c$export$c9e73fbda7da57b6;
var $4cba487fb552c90c$export$5a759dc7a1cfb72a;
"use strict";
var $4cba487fb552c90c$var$bundleURL = {};
function $4cba487fb552c90c$var$getBundleURLCached(id) {
    var value = $4cba487fb552c90c$var$bundleURL[id];
    if (!value) {
        value = $4cba487fb552c90c$var$getBundleURL();
        $4cba487fb552c90c$var$bundleURL[id] = value;
    }
    return value;
}
function $4cba487fb552c90c$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $4cba487fb552c90c$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $4cba487fb552c90c$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $4cba487fb552c90c$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$4cba487fb552c90c$export$bdfd709ae4826697 = $4cba487fb552c90c$var$getBundleURLCached;
$4cba487fb552c90c$export$c9e73fbda7da57b6 = $4cba487fb552c90c$var$getBaseURL;
$4cba487fb552c90c$export$5a759dc7a1cfb72a = $4cba487fb552c90c$var$getOrigin;

});

parcelRegister("gCajc", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $ccdd478cccd12ef1$export$2cd8252107eb640b; });

var $1rY3h = parcelRequire("1rY3h");
parcelRequire("1Mpn7");

var $3ltji = parcelRequire("3ltji");

var $cZ38z = parcelRequire("cZ38z");

var $9MEdR = parcelRequire("9MEdR");

var $lx9pt = parcelRequire("lx9pt");
window.BUILD_KEY = "p-11106";
window.featureGateBootstrapValues = window.featureGateBootstrapValues || {
    identifiers: {
        analyticsAnonymousId: (0, $cZ38z.default)()
    }
};
var $ccdd478cccd12ef1$export$2cd8252107eb640b = function(Component) {
    var isStatic = typeof window !== "undefined" && window.IS_STATIC;
    (0, $9MEdR.initializeFeatureGatesClient)(window.featureGateBootstrapValues).then(function() {
        if (isStatic) {
            // @ts-ignore
            var root = (0, $3ltji.createRoot)(document.getElementById("wac"));
            root.render(/*#__PURE__*/ (0, $1rY3h.jsx)((0, $lx9pt.Layout), {
                location: window.location,
                messages: window.SSR_languagePack,
                pureClientMode: true,
                children: Component
            }));
        } else {
            var compiledCss = document.getElementById("ssr_style");
            (0, $3ltji.hydrateRoot)(document, /*#__PURE__*/ (0, $1rY3h.jsx)((0, $lx9pt.Layout), {
                location: window.location,
                messages: window.SSR_languagePack,
                inlineCss: (compiledCss === null || compiledCss === void 0 ? void 0 : compiledCss.textContent) || "",
                pricing: window.prices,
                availableProducts: window.availableProducts,
                signupUserTraits: window.signupUserTraits,
                templates: window.templates,
                collections: window.collections,
                userProfile: window.userProfile,
                countryCode: window.countryCode,
                themeStyles: window.themeStyles,
                children: Component
            }));
        }
    });
};

});
parcelRegister("1rY3h", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $10e6e522325e77d8$export$ffb0004e005737fa; });
$parcel$export(module.exports, "jsx", function () { return $10e6e522325e77d8$export$34b9dba7ce09269b; });
$parcel$export(module.exports, "jsxs", function () { return $10e6e522325e77d8$export$25062201e9e25d76; });

var $amul4 = parcelRequire("amul4");

var $7qdHr = parcelRequire("7qdHr");
parcelRequire("1Mpn7");
parcelRequire("9t3nQ");
parcelRequire("fjkYW");
parcelRequire("eZw11");

parcelRequire("knVHJ");
parcelRequire("2B9xT");
parcelRequire("dvoqA");
parcelRequire("dkd4E");
var $10e6e522325e77d8$export$ffb0004e005737fa = $amul4.Fragment;
function $10e6e522325e77d8$export$34b9dba7ce09269b(type, props, key) {
    if (!(0, $7qdHr.h).call(props, "css")) return $amul4.jsx(type, props, key);
    return $amul4.jsx((0, $7qdHr.E), (0, $7qdHr.c)(type, props), key);
}
function $10e6e522325e77d8$export$25062201e9e25d76(type, props, key) {
    if (!(0, $7qdHr.h).call(props, "css")) return $amul4.jsxs(type, props, key);
    return $amul4.jsxs((0, $7qdHr.E), (0, $7qdHr.c)(type, props), key);
}

});
parcelRegister("amul4", function(module, exports) {
"use strict";

module.exports = (parcelRequire("hxSYn"));

});
parcelRegister("hxSYn", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $cc60292f8145080b$export$ffb0004e005737fa; }, function (v) { return $cc60292f8145080b$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $cc60292f8145080b$export$34b9dba7ce09269b; }, function (v) { return $cc60292f8145080b$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $cc60292f8145080b$export$25062201e9e25d76; }, function (v) { return $cc60292f8145080b$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $cc60292f8145080b$export$ffb0004e005737fa;
var $cc60292f8145080b$export$34b9dba7ce09269b;
var $cc60292f8145080b$export$25062201e9e25d76;
"use strict";

var $1Mpn7 = parcelRequire("1Mpn7");
var $cc60292f8145080b$var$k = Symbol.for("react.element"), $cc60292f8145080b$var$l = Symbol.for("react.fragment"), $cc60292f8145080b$var$m = Object.prototype.hasOwnProperty, $cc60292f8145080b$var$n = $1Mpn7.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $cc60292f8145080b$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $cc60292f8145080b$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$cc60292f8145080b$var$m.call(a, b) && !$cc60292f8145080b$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $cc60292f8145080b$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $cc60292f8145080b$var$n.current
    };
}
$cc60292f8145080b$export$ffb0004e005737fa = $cc60292f8145080b$var$l;
$cc60292f8145080b$export$34b9dba7ce09269b = $cc60292f8145080b$var$q;
$cc60292f8145080b$export$25062201e9e25d76 = $cc60292f8145080b$var$q;

});
parcelRegister("1Mpn7", function(module, exports) {
"use strict";

module.exports = (parcelRequire("hq3pV"));

});
parcelRegister("hq3pV", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $cae783ed169ac813$export$dca3b0875bd9a954; }, function (v) { return $cae783ed169ac813$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $cae783ed169ac813$export$16fa2f45be04daa8; }, function (v) { return $cae783ed169ac813$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $cae783ed169ac813$export$ffb0004e005737fa; }, function (v) { return $cae783ed169ac813$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $cae783ed169ac813$export$e2c29f18771995cb; }, function (v) { return $cae783ed169ac813$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $cae783ed169ac813$export$221d75b3f55bb0bd; }, function (v) { return $cae783ed169ac813$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $cae783ed169ac813$export$5f8d39834fd61797; }, function (v) { return $cae783ed169ac813$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $cae783ed169ac813$export$74bf444e3cd11ea5; }, function (v) { return $cae783ed169ac813$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $cae783ed169ac813$export$ae55be85d98224ed; }, function (v) { return $cae783ed169ac813$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $cae783ed169ac813$export$e530037191fcd5d7; }, function (v) { return $cae783ed169ac813$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $cae783ed169ac813$export$fd42f52fd3ae1109; }, function (v) { return $cae783ed169ac813$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $cae783ed169ac813$export$c8a8987d4410bf2d; }, function (v) { return $cae783ed169ac813$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $cae783ed169ac813$export$d38cd72104c1f0e9; }, function (v) { return $cae783ed169ac813$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $cae783ed169ac813$export$7d1e3a5e95ceca43; }, function (v) { return $cae783ed169ac813$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $cae783ed169ac813$export$257a8862b851cb5b; }, function (v) { return $cae783ed169ac813$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $cae783ed169ac813$export$a8257692ac88316c; }, function (v) { return $cae783ed169ac813$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $cae783ed169ac813$export$488013bae63b21da; }, function (v) { return $cae783ed169ac813$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $cae783ed169ac813$export$7c73462e0d25e514; }, function (v) { return $cae783ed169ac813$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $cae783ed169ac813$export$7568632d0d33d16d; }, function (v) { return $cae783ed169ac813$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $cae783ed169ac813$export$88948ce120ea2619; }, function (v) { return $cae783ed169ac813$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $cae783ed169ac813$export$35808ee640e87ca7; }, function (v) { return $cae783ed169ac813$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $cae783ed169ac813$export$fae74005e78b1a27; }, function (v) { return $cae783ed169ac813$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $cae783ed169ac813$export$dc8fbce3eb94dc1e; }, function (v) { return $cae783ed169ac813$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $cae783ed169ac813$export$6a7bc4e911dc01cf; }, function (v) { return $cae783ed169ac813$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $cae783ed169ac813$export$6d9c69b0de29b591; }, function (v) { return $cae783ed169ac813$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $cae783ed169ac813$export$f680877a34711e37; }, function (v) { return $cae783ed169ac813$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $cae783ed169ac813$export$d5a552a76deda3c2; }, function (v) { return $cae783ed169ac813$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $cae783ed169ac813$export$aaabe4eda9ed9969; }, function (v) { return $cae783ed169ac813$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $cae783ed169ac813$export$e5c5a5f917a5871c; }, function (v) { return $cae783ed169ac813$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $cae783ed169ac813$export$1538c33de8887b59; }, function (v) { return $cae783ed169ac813$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $cae783ed169ac813$export$13e3392192263954; }, function (v) { return $cae783ed169ac813$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $cae783ed169ac813$export$b8f5890fc79d6aca; }, function (v) { return $cae783ed169ac813$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $cae783ed169ac813$export$60241385465d0a34; }, function (v) { return $cae783ed169ac813$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $cae783ed169ac813$export$306c0aa65ff9ec16; }, function (v) { return $cae783ed169ac813$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $cae783ed169ac813$export$7b286972b8d8ccbf; }, function (v) { return $cae783ed169ac813$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $cae783ed169ac813$export$83d89fbfd8236492; }, function (v) { return $cae783ed169ac813$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $l0HdX = parcelRequire("l0HdX");
var $cae783ed169ac813$export$dca3b0875bd9a954;
var $cae783ed169ac813$export$16fa2f45be04daa8;
var $cae783ed169ac813$export$ffb0004e005737fa;
var $cae783ed169ac813$export$e2c29f18771995cb;
var $cae783ed169ac813$export$221d75b3f55bb0bd;
var $cae783ed169ac813$export$5f8d39834fd61797;
var $cae783ed169ac813$export$74bf444e3cd11ea5;
var $cae783ed169ac813$export$ae55be85d98224ed;
var $cae783ed169ac813$export$e530037191fcd5d7;
var $cae783ed169ac813$export$fd42f52fd3ae1109;
var $cae783ed169ac813$export$c8a8987d4410bf2d;
var $cae783ed169ac813$export$d38cd72104c1f0e9;
var $cae783ed169ac813$export$7d1e3a5e95ceca43;
var $cae783ed169ac813$export$257a8862b851cb5b;
var $cae783ed169ac813$export$a8257692ac88316c;
var $cae783ed169ac813$export$488013bae63b21da;
var $cae783ed169ac813$export$7c73462e0d25e514;
var $cae783ed169ac813$export$7568632d0d33d16d;
var $cae783ed169ac813$export$88948ce120ea2619;
var $cae783ed169ac813$export$35808ee640e87ca7;
var $cae783ed169ac813$export$fae74005e78b1a27;
var $cae783ed169ac813$export$dc8fbce3eb94dc1e;
var $cae783ed169ac813$export$6a7bc4e911dc01cf;
var $cae783ed169ac813$export$6d9c69b0de29b591;
var $cae783ed169ac813$export$f680877a34711e37;
var $cae783ed169ac813$export$d5a552a76deda3c2;
var $cae783ed169ac813$export$aaabe4eda9ed9969;
var $cae783ed169ac813$export$e5c5a5f917a5871c;
var $cae783ed169ac813$export$1538c33de8887b59;
var $cae783ed169ac813$export$13e3392192263954;
var $cae783ed169ac813$export$b8f5890fc79d6aca;
var $cae783ed169ac813$export$60241385465d0a34;
var $cae783ed169ac813$export$306c0aa65ff9ec16;
var $cae783ed169ac813$export$7b286972b8d8ccbf;
var $cae783ed169ac813$export$83d89fbfd8236492;
"use strict";
var $cae783ed169ac813$var$l = Symbol.for("react.element"), $cae783ed169ac813$var$n = Symbol.for("react.portal"), $cae783ed169ac813$var$p = Symbol.for("react.fragment"), $cae783ed169ac813$var$q = Symbol.for("react.strict_mode"), $cae783ed169ac813$var$r = Symbol.for("react.profiler"), $cae783ed169ac813$var$t = Symbol.for("react.provider"), $cae783ed169ac813$var$u = Symbol.for("react.context"), $cae783ed169ac813$var$v = Symbol.for("react.forward_ref"), $cae783ed169ac813$var$w = Symbol.for("react.suspense"), $cae783ed169ac813$var$x = Symbol.for("react.memo"), $cae783ed169ac813$var$y = Symbol.for("react.lazy"), $cae783ed169ac813$var$z = Symbol.iterator;
function $cae783ed169ac813$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $cae783ed169ac813$var$z && a[$cae783ed169ac813$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $cae783ed169ac813$var$B = {
    isMounted: function isMounted() {
        return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate() {},
    enqueueReplaceState: function enqueueReplaceState() {},
    enqueueSetState: function enqueueSetState() {}
}, $cae783ed169ac813$var$C = Object.assign, $cae783ed169ac813$var$D = {};
function $cae783ed169ac813$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $cae783ed169ac813$var$D;
    this.updater = e || $cae783ed169ac813$var$B;
}
$cae783ed169ac813$var$E.prototype.isReactComponent = {};
$cae783ed169ac813$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$cae783ed169ac813$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $cae783ed169ac813$var$F() {}
$cae783ed169ac813$var$F.prototype = $cae783ed169ac813$var$E.prototype;
function $cae783ed169ac813$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $cae783ed169ac813$var$D;
    this.updater = e || $cae783ed169ac813$var$B;
}
var $cae783ed169ac813$var$H = $cae783ed169ac813$var$G.prototype = new $cae783ed169ac813$var$F;
$cae783ed169ac813$var$H.constructor = $cae783ed169ac813$var$G;
$cae783ed169ac813$var$C($cae783ed169ac813$var$H, $cae783ed169ac813$var$E.prototype);
$cae783ed169ac813$var$H.isPureReactComponent = !0;
var $cae783ed169ac813$var$I = Array.isArray, $cae783ed169ac813$var$J = Object.prototype.hasOwnProperty, $cae783ed169ac813$var$K = {
    current: null
}, $cae783ed169ac813$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $cae783ed169ac813$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$cae783ed169ac813$var$J.call(b, d) && !$cae783ed169ac813$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $cae783ed169ac813$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $cae783ed169ac813$var$K.current
    };
}
function $cae783ed169ac813$var$N(a, b) {
    return {
        $$typeof: $cae783ed169ac813$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $cae783ed169ac813$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $cae783ed169ac813$var$l;
}
function $cae783ed169ac813$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $cae783ed169ac813$var$P = /\/+/g;
function $cae783ed169ac813$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $cae783ed169ac813$var$escape("" + a.key) : b.toString(36);
}
function $cae783ed169ac813$var$R(a, b, e, d, c) {
    var k = typeof a === "undefined" ? "undefined" : (0, $l0HdX._)(a);
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $cae783ed169ac813$var$l:
                case $cae783ed169ac813$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $cae783ed169ac813$var$Q(h, 0) : d, $cae783ed169ac813$var$I(c) ? (e = "", null != a && (e = a.replace($cae783ed169ac813$var$P, "$&/") + "/"), $cae783ed169ac813$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($cae783ed169ac813$var$O(c) && (c = $cae783ed169ac813$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($cae783ed169ac813$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($cae783ed169ac813$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $cae783ed169ac813$var$Q(k, g);
        h += $cae783ed169ac813$var$R(k, b, e, f, c);
    }
    else if (f = $cae783ed169ac813$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $cae783ed169ac813$var$Q(k, g++), h += $cae783ed169ac813$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $cae783ed169ac813$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $cae783ed169ac813$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $cae783ed169ac813$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $cae783ed169ac813$var$U = {
    current: null
}, $cae783ed169ac813$var$V = {
    transition: null
}, $cae783ed169ac813$var$W = {
    ReactCurrentDispatcher: $cae783ed169ac813$var$U,
    ReactCurrentBatchConfig: $cae783ed169ac813$var$V,
    ReactCurrentOwner: $cae783ed169ac813$var$K
};
$cae783ed169ac813$export$dca3b0875bd9a954 = {
    map: $cae783ed169ac813$var$S,
    forEach: function forEach(a, b, e) {
        $cae783ed169ac813$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function count(a) {
        var b = 0;
        $cae783ed169ac813$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function toArray(a) {
        return $cae783ed169ac813$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function only(a) {
        if (!$cae783ed169ac813$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$cae783ed169ac813$export$16fa2f45be04daa8 = $cae783ed169ac813$var$E;
$cae783ed169ac813$export$ffb0004e005737fa = $cae783ed169ac813$var$p;
$cae783ed169ac813$export$e2c29f18771995cb = $cae783ed169ac813$var$r;
$cae783ed169ac813$export$221d75b3f55bb0bd = $cae783ed169ac813$var$G;
$cae783ed169ac813$export$5f8d39834fd61797 = $cae783ed169ac813$var$q;
$cae783ed169ac813$export$74bf444e3cd11ea5 = $cae783ed169ac813$var$w;
$cae783ed169ac813$export$ae55be85d98224ed = $cae783ed169ac813$var$W;
$cae783ed169ac813$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $cae783ed169ac813$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $cae783ed169ac813$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$cae783ed169ac813$var$J.call(b, f) && !$cae783ed169ac813$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $cae783ed169ac813$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$cae783ed169ac813$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $cae783ed169ac813$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $cae783ed169ac813$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$cae783ed169ac813$export$c8a8987d4410bf2d = $cae783ed169ac813$var$M;
$cae783ed169ac813$export$d38cd72104c1f0e9 = function(a) {
    var b = $cae783ed169ac813$var$M.bind(null, a);
    b.type = a;
    return b;
};
$cae783ed169ac813$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$cae783ed169ac813$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $cae783ed169ac813$var$v,
        render: a
    };
};
$cae783ed169ac813$export$a8257692ac88316c = $cae783ed169ac813$var$O;
$cae783ed169ac813$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $cae783ed169ac813$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $cae783ed169ac813$var$T
    };
};
$cae783ed169ac813$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $cae783ed169ac813$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$cae783ed169ac813$export$7568632d0d33d16d = function(a) {
    var b = $cae783ed169ac813$var$V.transition;
    $cae783ed169ac813$var$V.transition = {};
    try {
        a();
    } finally{
        $cae783ed169ac813$var$V.transition = b;
    }
};
$cae783ed169ac813$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$cae783ed169ac813$export$35808ee640e87ca7 = function(a, b) {
    return $cae783ed169ac813$var$U.current.useCallback(a, b);
};
$cae783ed169ac813$export$fae74005e78b1a27 = function(a) {
    return $cae783ed169ac813$var$U.current.useContext(a);
};
$cae783ed169ac813$export$dc8fbce3eb94dc1e = function() {};
$cae783ed169ac813$export$6a7bc4e911dc01cf = function(a) {
    return $cae783ed169ac813$var$U.current.useDeferredValue(a);
};
$cae783ed169ac813$export$6d9c69b0de29b591 = function(a, b) {
    return $cae783ed169ac813$var$U.current.useEffect(a, b);
};
$cae783ed169ac813$export$f680877a34711e37 = function() {
    return $cae783ed169ac813$var$U.current.useId();
};
$cae783ed169ac813$export$d5a552a76deda3c2 = function(a, b, e) {
    return $cae783ed169ac813$var$U.current.useImperativeHandle(a, b, e);
};
$cae783ed169ac813$export$aaabe4eda9ed9969 = function(a, b) {
    return $cae783ed169ac813$var$U.current.useInsertionEffect(a, b);
};
$cae783ed169ac813$export$e5c5a5f917a5871c = function(a, b) {
    return $cae783ed169ac813$var$U.current.useLayoutEffect(a, b);
};
$cae783ed169ac813$export$1538c33de8887b59 = function(a, b) {
    return $cae783ed169ac813$var$U.current.useMemo(a, b);
};
$cae783ed169ac813$export$13e3392192263954 = function(a, b, e) {
    return $cae783ed169ac813$var$U.current.useReducer(a, b, e);
};
$cae783ed169ac813$export$b8f5890fc79d6aca = function(a) {
    return $cae783ed169ac813$var$U.current.useRef(a);
};
$cae783ed169ac813$export$60241385465d0a34 = function(a) {
    return $cae783ed169ac813$var$U.current.useState(a);
};
$cae783ed169ac813$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $cae783ed169ac813$var$U.current.useSyncExternalStore(a, b, e);
};
$cae783ed169ac813$export$7b286972b8d8ccbf = function() {
    return $cae783ed169ac813$var$U.current.useTransition();
};
$cae783ed169ac813$export$83d89fbfd8236492 = "18.2.0";

});
parcelRegister("l0HdX", function(module, exports) {

$parcel$export(module.exports, "_type_of", function () { return $f4bb2077aa61b74c$export$5f0017c582d45a2d; });
$parcel$export(module.exports, "_", function () { return $f4bb2077aa61b74c$export$5f0017c582d45a2d; });
function $f4bb2077aa61b74c$export$5f0017c582d45a2d(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});





parcelRegister("7qdHr", function(module, exports) {

$parcel$export(module.exports, "i", function () { return $56759698f8a76ea1$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "h", function () { return $56759698f8a76ea1$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "C", function () { return $56759698f8a76ea1$export$e7094788287c5e9b; });
$parcel$export(module.exports, "_", function () { return $56759698f8a76ea1$export$71511d61b312f219; });
$parcel$export(module.exports, "w", function () { return $56759698f8a76ea1$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $56759698f8a76ea1$export$971d5caa766a69d7; });
$parcel$export(module.exports, "u", function () { return $56759698f8a76ea1$export$3b14a55fb2447963; });
$parcel$export(module.exports, "a", function () { return $56759698f8a76ea1$export$407448d2b89b1813; });
$parcel$export(module.exports, "b", function () { return $56759698f8a76ea1$export$8b22cf2602fb60ce; });
$parcel$export(module.exports, "c", function () { return $56759698f8a76ea1$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $56759698f8a76ea1$export$a9c23c6ac3fc3eca; });

var $1Mpn7 = parcelRequire("1Mpn7");

var $9t3nQ = parcelRequire("9t3nQ");

var $iunch = parcelRequire("iunch");

var $eZw11 = parcelRequire("eZw11");

var $dFqaQ = parcelRequire("dFqaQ");

var $2B9xT = parcelRequire("2B9xT");

var $dvoqA = parcelRequire("dvoqA");

var $dkd4E = parcelRequire("dkd4E");
var $56759698f8a76ea1$export$23f2a1d2818174ef = true;
var $56759698f8a76ea1$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $56759698f8a76ea1$var$EmotionCacheContext = /* #__PURE__ */ $1Mpn7.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $9t3nQ.default)({
    key: "css"
}) : null);
var $56759698f8a76ea1$export$e7094788287c5e9b = $56759698f8a76ea1$var$EmotionCacheContext.Provider;
var $56759698f8a76ea1$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $1Mpn7.useContext)($56759698f8a76ea1$var$EmotionCacheContext);
};
var $56759698f8a76ea1$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $1Mpn7.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $1Mpn7.useContext)($56759698f8a76ea1$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$56759698f8a76ea1$export$23f2a1d2818174ef) $56759698f8a76ea1$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $1Mpn7.useContext)($56759698f8a76ea1$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $9t3nQ.default)({
                key: "css"
            });
            return /*#__PURE__*/ $1Mpn7.createElement($56759698f8a76ea1$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $56759698f8a76ea1$export$971d5caa766a69d7 = /* #__PURE__ */ $1Mpn7.createContext({});
var $56759698f8a76ea1$export$3b14a55fb2447963 = function useTheme() {
    return $1Mpn7.useContext($56759698f8a76ea1$export$971d5caa766a69d7);
};
var $56759698f8a76ea1$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $iunch.default)({}, outerTheme, theme);
};
var $56759698f8a76ea1$var$createCacheWithTheme = /* #__PURE__ */ (0, $eZw11.default)(function(outerTheme) {
    return (0, $eZw11.default)(function(theme) {
        return $56759698f8a76ea1$var$getTheme(outerTheme, theme);
    });
});
var $56759698f8a76ea1$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $1Mpn7.useContext($56759698f8a76ea1$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $56759698f8a76ea1$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $1Mpn7.createElement($56759698f8a76ea1$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $56759698f8a76ea1$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = $1Mpn7.useContext($56759698f8a76ea1$export$971d5caa766a69d7);
        return /*#__PURE__*/ $1Mpn7.createElement(Component, (0, $iunch.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ $1Mpn7.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $dFqaQ.default)(WithTheme, Component);
}
var $56759698f8a76ea1$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split(".");
    return parts[parts.length - 1];
};
var $56759698f8a76ea1$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $56759698f8a76ea1$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $56759698f8a76ea1$var$getLastPart(match[1]);
    return undefined;
};
var $56759698f8a76ea1$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    "renderWithHooks",
    "processChild",
    "finishClassComponent",
    "renderToString"
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $56759698f8a76ea1$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var $56759698f8a76ea1$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split("\n");
    for(var i = 0; i < lines.length; i++){
        var functionName = $56759698f8a76ea1$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($56759698f8a76ea1$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $56759698f8a76ea1$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $56759698f8a76ea1$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $56759698f8a76ea1$var$labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var $56759698f8a76ea1$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($56759698f8a76ea1$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$56759698f8a76ea1$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $56759698f8a76ea1$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $2B9xT.registerStyles)(cache, serialized, isStringTag);
    (0, $dkd4E.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $2B9xT.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $56759698f8a76ea1$var$Emotion = /* #__PURE__ */ $56759698f8a76ea1$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$56759698f8a76ea1$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $2B9xT.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $dvoqA.serializeStyles)(registeredStyles, undefined, $1Mpn7.useContext($56759698f8a76ea1$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($56759698f8a76ea1$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $56759698f8a76ea1$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ $1Mpn7.createElement($1Mpn7.Fragment, null, /*#__PURE__*/ $1Mpn7.createElement($56759698f8a76ea1$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $1Mpn7.createElement(WrappedComponent, newProps));
});
var $56759698f8a76ea1$export$a9c23c6ac3fc3eca = $56759698f8a76ea1$var$Emotion;

});
parcelRegister("9t3nQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01c760d01c89dad7$export$2e2bcd8739ae039; });

var $9VBY6 = parcelRequire("9VBY6");

var $cjQOx = parcelRequire("cjQOx");
parcelRequire("eZw11");
parcelRequire("1Jcta");
var $01c760d01c89dad7$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $cjQOx.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $cjQOx.token)(character)) break;
        (0, $cjQOx.next)();
    }
    return (0, $cjQOx.slice)(begin, (0, $cjQOx.position));
};
var $01c760d01c89dad7$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $cjQOx.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $cjQOx.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $01c760d01c89dad7$var$identifierWithPointTracking((0, $cjQOx.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $cjQOx.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $cjQOx.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $cjQOx.from)(character);
    }
    while (character = (0, $cjQOx.next)());
    return parsed;
};
var $01c760d01c89dad7$var$getRules = function getRules(value, points) {
    return (0, $cjQOx.dealloc)($01c760d01c89dad7$var$toRules((0, $cjQOx.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $01c760d01c89dad7$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $01c760d01c89dad7$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$01c760d01c89dad7$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $01c760d01c89dad7$var$fixedElements.set(element, true);
    var points = [];
    var rules = $01c760d01c89dad7$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $01c760d01c89dad7$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var $01c760d01c89dad7$var$ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var $01c760d01c89dad7$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf($01c760d01c89dad7$var$ignoreFlag) > -1;
};
var $01c760d01c89dad7$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($01c760d01c89dad7$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var $01c760d01c89dad7$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $01c760d01c89dad7$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$01c760d01c89dad7$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $01c760d01c89dad7$var$nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var $01c760d01c89dad7$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$01c760d01c89dad7$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $01c760d01c89dad7$var$nullifyElement(element);
    } else if ($01c760d01c89dad7$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $01c760d01c89dad7$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $01c760d01c89dad7$var$prefix(value, length) {
    switch((0, $cjQOx.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $cjQOx.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $cjQOx.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $cjQOx.WEBKIT) + value + (0, $cjQOx.MOZ) + value + (0, $cjQOx.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $cjQOx.WEBKIT) + value + (0, $cjQOx.MS) + value + value;
        // order
        case 6165:
            return (0, $cjQOx.WEBKIT) + value + (0, $cjQOx.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $cjQOx.WEBKIT) + value + (0, $cjQOx.replace)(value, /(\w+).+(:[^]+)/, (0, $cjQOx.WEBKIT) + "box-$1$2" + (0, $cjQOx.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $cjQOx.WEBKIT) + value + (0, $cjQOx.MS) + "flex-item-" + (0, $cjQOx.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $cjQOx.WEBKIT) + value + (0, $cjQOx.MS) + "flex-line-pack" + (0, $cjQOx.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $cjQOx.WEBKIT) + value + (0, $cjQOx.MS) + (0, $cjQOx.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $cjQOx.WEBKIT) + value + (0, $cjQOx.MS) + (0, $cjQOx.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $cjQOx.WEBKIT) + "box-" + (0, $cjQOx.replace)(value, "-grow", "") + (0, $cjQOx.WEBKIT) + value + (0, $cjQOx.MS) + (0, $cjQOx.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $cjQOx.WEBKIT) + (0, $cjQOx.replace)(value, /([^-])(transform)/g, "$1" + (0, $cjQOx.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $cjQOx.replace)((0, $cjQOx.replace)((0, $cjQOx.replace)(value, /(zoom-|grab)/, (0, $cjQOx.WEBKIT) + "$1"), /(image-set)/, (0, $cjQOx.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $cjQOx.replace)(value, /(image-set\([^]*)/, (0, $cjQOx.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $cjQOx.replace)((0, $cjQOx.replace)(value, /(.+:)(flex-)?(.*)/, (0, $cjQOx.WEBKIT) + "box-pack:$3" + (0, $cjQOx.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $cjQOx.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $cjQOx.replace)(value, /(.+)-inline(.+)/, (0, $cjQOx.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $cjQOx.strlen)(value) - 1 - length > 6) switch((0, $cjQOx.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $cjQOx.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $cjQOx.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $cjQOx.WEBKIT) + "$2-$3" + "$1" + (0, $cjQOx.MOZ) + ((0, $cjQOx.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $cjQOx.indexof)(value, "stretch") ? $01c760d01c89dad7$var$prefix((0, $cjQOx.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $cjQOx.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $cjQOx.charat)(value, (0, $cjQOx.strlen)(value) - 3 - (~(0, $cjQOx.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $cjQOx.replace)(value, ":", ":" + (0, $cjQOx.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $cjQOx.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $cjQOx.WEBKIT) + ((0, $cjQOx.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $cjQOx.WEBKIT) + "$2$3" + "$1" + (0, $cjQOx.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $cjQOx.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $cjQOx.WEBKIT) + value + (0, $cjQOx.MS) + (0, $cjQOx.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $cjQOx.WEBKIT) + value + (0, $cjQOx.MS) + (0, $cjQOx.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $cjQOx.WEBKIT) + value + (0, $cjQOx.MS) + (0, $cjQOx.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $cjQOx.WEBKIT) + value + (0, $cjQOx.MS) + value + value;
    }
    return value;
}
var $01c760d01c89dad7$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $cjQOx.DECLARATION:
                element["return"] = $01c760d01c89dad7$var$prefix(element.value, element.length);
                break;
            case 0, $cjQOx.KEYFRAMES:
                return (0, $cjQOx.serialize)([
                    (0, $cjQOx.copy)(element, {
                        value: (0, $cjQOx.replace)(element.value, "@", "@" + (0, $cjQOx.WEBKIT))
                    })
                ], callback);
            case 0, $cjQOx.RULESET:
                if (element.length) return (0, $cjQOx.combine)(element.props, function(value) {
                    switch((0, $cjQOx.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $cjQOx.serialize)([
                                (0, $cjQOx.copy)(element, {
                                    props: [
                                        (0, $cjQOx.replace)(value, /:(read-\w+)/, ":" + (0, $cjQOx.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $cjQOx.serialize)([
                                (0, $cjQOx.copy)(element, {
                                    props: [
                                        (0, $cjQOx.replace)(value, /:(plac\w+)/, ":" + (0, $cjQOx.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, $cjQOx.copy)(element, {
                                    props: [
                                        (0, $cjQOx.replace)(value, /:(plac\w+)/, ":" + (0, $cjQOx.MOZ) + "$1")
                                    ]
                                }),
                                (0, $cjQOx.copy)(element, {
                                    props: [
                                        (0, $cjQOx.replace)(value, /:(plac\w+)/, (0, $cjQOx.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $01c760d01c89dad7$var$defaultStylisPlugins = [
    $01c760d01c89dad7$var$prefixer
];
var $01c760d01c89dad7$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $01c760d01c89dad7$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $01c760d01c89dad7$var$compat,
        $01c760d01c89dad7$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $cjQOx.stringify),
        (0, $cjQOx.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $cjQOx.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $cjQOx.serialize)((0, $cjQOx.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $9VBY6.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("9VBY6", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $73a6e3a7c04712a4$export$9d753cd7ae895cce; });
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $73a6e3a7c04712a4$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $73a6e3a7c04712a4$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $73a6e3a7c04712a4$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($73a6e3a7c04712a4$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $73a6e3a7c04712a4$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("cjQOx", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $aabb59e57493b9ac$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $aabb59e57493b9ac$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $aabb59e57493b9ac$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "RULESET", function () { return $aabb59e57493b9ac$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $aabb59e57493b9ac$export$527d108ccf083c2b; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $aabb59e57493b9ac$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "from", function () { return $aabb59e57493b9ac$export$6788812c4e6611e6; });
$parcel$export(module.exports, "hash", function () { return $aabb59e57493b9ac$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $aabb59e57493b9ac$export$a9db5e087081082d; });
$parcel$export(module.exports, "match", function () { return $aabb59e57493b9ac$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $aabb59e57493b9ac$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $aabb59e57493b9ac$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "strlen", function () { return $aabb59e57493b9ac$export$36776f635604f274; });
$parcel$export(module.exports, "combine", function () { return $aabb59e57493b9ac$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "position", function () { return $aabb59e57493b9ac$export$5880b8b5730aff45; });
$parcel$export(module.exports, "copy", function () { return $aabb59e57493b9ac$export$784d13d8ee351f07; });
$parcel$export(module.exports, "next", function () { return $aabb59e57493b9ac$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $aabb59e57493b9ac$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "slice", function () { return $aabb59e57493b9ac$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $aabb59e57493b9ac$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $aabb59e57493b9ac$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $aabb59e57493b9ac$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $aabb59e57493b9ac$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "compile", function () { return $aabb59e57493b9ac$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $aabb59e57493b9ac$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $aabb59e57493b9ac$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $aabb59e57493b9ac$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $aabb59e57493b9ac$export$38bcb760f1d4871c; });
var $aabb59e57493b9ac$export$71ad59f2e432cfe8 = "-ms-";
var $aabb59e57493b9ac$export$2c0f367103c8d01c = "-moz-";
var $aabb59e57493b9ac$export$39dfd62a25e0fe93 = "-webkit-";
var $aabb59e57493b9ac$export$a29989082612d0d9 = "comm";
var $aabb59e57493b9ac$export$aa3a2e812ca8570d = "rule";
var $aabb59e57493b9ac$export$527d108ccf083c2b = "decl";
var $aabb59e57493b9ac$export$d3d35020fa5b54f0 = "@page";
var $aabb59e57493b9ac$export$500415a86c544f73 = "@media";
var $aabb59e57493b9ac$export$a763edbf796b780a = "@import";
var $aabb59e57493b9ac$export$2790aeb8b4e5c826 = "@charset";
var $aabb59e57493b9ac$export$1cc683e23b84b133 = "@viewport";
var $aabb59e57493b9ac$export$9447a5efea57e862 = "@supports";
var $aabb59e57493b9ac$export$ef011b4e114b1fba = "@document";
var $aabb59e57493b9ac$export$6aad947bda0f3f46 = "@namespace";
var $aabb59e57493b9ac$export$b44a8529a35fcb60 = "@keyframes";
var $aabb59e57493b9ac$export$2c16de31893252e6 = "@font-face";
var $aabb59e57493b9ac$export$3d846dd52e150c6f = "@counter-style";
var $aabb59e57493b9ac$export$22314bfbb57653fe = "@font-feature-values";
var $aabb59e57493b9ac$export$d773506282b3cfe6 = "@layer";
var $aabb59e57493b9ac$export$2335f513bbd82c6d = Math.abs;
var $aabb59e57493b9ac$export$6788812c4e6611e6 = String.fromCharCode;
var $aabb59e57493b9ac$export$e6e34fd1f2686227 = Object.assign;
function $aabb59e57493b9ac$export$d6af199866bfb566(e, r) {
    return $aabb59e57493b9ac$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $aabb59e57493b9ac$export$a9db5e087081082d(e, 0)) << 2 ^ $aabb59e57493b9ac$export$a9db5e087081082d(e, 1)) << 2 ^ $aabb59e57493b9ac$export$a9db5e087081082d(e, 2)) << 2 ^ $aabb59e57493b9ac$export$a9db5e087081082d(e, 3) : 0;
}
function $aabb59e57493b9ac$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $aabb59e57493b9ac$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $aabb59e57493b9ac$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $aabb59e57493b9ac$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $aabb59e57493b9ac$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $aabb59e57493b9ac$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $aabb59e57493b9ac$export$36776f635604f274(e) {
    return e.length;
}
function $aabb59e57493b9ac$export$f9084667e487ed46(e) {
    return e.length;
}
function $aabb59e57493b9ac$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $aabb59e57493b9ac$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $aabb59e57493b9ac$export$53f1d5ea8de3d7c = 1;
var $aabb59e57493b9ac$export$4e0c71f277ca26b3 = 1;
var $aabb59e57493b9ac$export$f24224f1c91d8156 = 0;
var $aabb59e57493b9ac$export$5880b8b5730aff45 = 0;
var $aabb59e57493b9ac$export$c0306caf338ac095 = 0;
var $aabb59e57493b9ac$export$30a86d91af8ff6e6 = "";
function $aabb59e57493b9ac$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $aabb59e57493b9ac$export$53f1d5ea8de3d7c,
        column: $aabb59e57493b9ac$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $aabb59e57493b9ac$export$784d13d8ee351f07(e, r) {
    return $aabb59e57493b9ac$export$e6e34fd1f2686227($aabb59e57493b9ac$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $aabb59e57493b9ac$export$eba6f6f03b0a92e7() {
    return $aabb59e57493b9ac$export$c0306caf338ac095;
}
function $aabb59e57493b9ac$export$232faf9add678146() {
    $aabb59e57493b9ac$export$c0306caf338ac095 = $aabb59e57493b9ac$export$5880b8b5730aff45 > 0 ? $aabb59e57493b9ac$export$a9db5e087081082d($aabb59e57493b9ac$export$30a86d91af8ff6e6, --$aabb59e57493b9ac$export$5880b8b5730aff45) : 0;
    if ($aabb59e57493b9ac$export$4e0c71f277ca26b3--, $aabb59e57493b9ac$export$c0306caf338ac095 === 10) $aabb59e57493b9ac$export$4e0c71f277ca26b3 = 1, $aabb59e57493b9ac$export$53f1d5ea8de3d7c--;
    return $aabb59e57493b9ac$export$c0306caf338ac095;
}
function $aabb59e57493b9ac$export$48cfd1e771a65c4f() {
    $aabb59e57493b9ac$export$c0306caf338ac095 = $aabb59e57493b9ac$export$5880b8b5730aff45 < $aabb59e57493b9ac$export$f24224f1c91d8156 ? $aabb59e57493b9ac$export$a9db5e087081082d($aabb59e57493b9ac$export$30a86d91af8ff6e6, $aabb59e57493b9ac$export$5880b8b5730aff45++) : 0;
    if ($aabb59e57493b9ac$export$4e0c71f277ca26b3++, $aabb59e57493b9ac$export$c0306caf338ac095 === 10) $aabb59e57493b9ac$export$4e0c71f277ca26b3 = 1, $aabb59e57493b9ac$export$53f1d5ea8de3d7c++;
    return $aabb59e57493b9ac$export$c0306caf338ac095;
}
function $aabb59e57493b9ac$export$4d3fb11e950abb9e() {
    return $aabb59e57493b9ac$export$a9db5e087081082d($aabb59e57493b9ac$export$30a86d91af8ff6e6, $aabb59e57493b9ac$export$5880b8b5730aff45);
}
function $aabb59e57493b9ac$export$e88cb2efb12ae807() {
    return $aabb59e57493b9ac$export$5880b8b5730aff45;
}
function $aabb59e57493b9ac$export$58adb3bec8346d0f(e, r) {
    return $aabb59e57493b9ac$export$2f35ab04d2335697($aabb59e57493b9ac$export$30a86d91af8ff6e6, e, r);
}
function $aabb59e57493b9ac$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $aabb59e57493b9ac$export$2de70f21292aac9e(e) {
    return $aabb59e57493b9ac$export$53f1d5ea8de3d7c = $aabb59e57493b9ac$export$4e0c71f277ca26b3 = 1, $aabb59e57493b9ac$export$f24224f1c91d8156 = $aabb59e57493b9ac$export$36776f635604f274($aabb59e57493b9ac$export$30a86d91af8ff6e6 = e), $aabb59e57493b9ac$export$5880b8b5730aff45 = 0, [];
}
function $aabb59e57493b9ac$export$45918ac1574455b1(e) {
    return $aabb59e57493b9ac$export$30a86d91af8ff6e6 = "", e;
}
function $aabb59e57493b9ac$export$410ac95b9ec204b8(e) {
    return $aabb59e57493b9ac$export$87c2784dc9fc4ab($aabb59e57493b9ac$export$58adb3bec8346d0f($aabb59e57493b9ac$export$5880b8b5730aff45 - 1, $aabb59e57493b9ac$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $aabb59e57493b9ac$export$660b2ee2d4fb4eff(e) {
    return $aabb59e57493b9ac$export$45918ac1574455b1($aabb59e57493b9ac$export$5f8c09e3ae6f64e1($aabb59e57493b9ac$export$2de70f21292aac9e(e)));
}
function $aabb59e57493b9ac$export$7af1228ff777d175(e) {
    while($aabb59e57493b9ac$export$c0306caf338ac095 = $aabb59e57493b9ac$export$4d3fb11e950abb9e())if ($aabb59e57493b9ac$export$c0306caf338ac095 < 33) $aabb59e57493b9ac$export$48cfd1e771a65c4f();
    else break;
    return $aabb59e57493b9ac$export$9e1725a4cfeada27(e) > 2 || $aabb59e57493b9ac$export$9e1725a4cfeada27($aabb59e57493b9ac$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $aabb59e57493b9ac$export$5f8c09e3ae6f64e1(e) {
    while($aabb59e57493b9ac$export$48cfd1e771a65c4f())switch($aabb59e57493b9ac$export$9e1725a4cfeada27($aabb59e57493b9ac$export$c0306caf338ac095)){
        case 0:
            $aabb59e57493b9ac$export$10d8903dec122b9d($aabb59e57493b9ac$export$c2ab62c7bf24634($aabb59e57493b9ac$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $aabb59e57493b9ac$export$10d8903dec122b9d($aabb59e57493b9ac$export$410ac95b9ec204b8($aabb59e57493b9ac$export$c0306caf338ac095), e);
            break;
        default:
            $aabb59e57493b9ac$export$10d8903dec122b9d($aabb59e57493b9ac$export$6788812c4e6611e6($aabb59e57493b9ac$export$c0306caf338ac095), e);
    }
    return e;
}
function $aabb59e57493b9ac$export$955ba06d119e085e(e, r) {
    while(--r && $aabb59e57493b9ac$export$48cfd1e771a65c4f())if ($aabb59e57493b9ac$export$c0306caf338ac095 < 48 || $aabb59e57493b9ac$export$c0306caf338ac095 > 102 || $aabb59e57493b9ac$export$c0306caf338ac095 > 57 && $aabb59e57493b9ac$export$c0306caf338ac095 < 65 || $aabb59e57493b9ac$export$c0306caf338ac095 > 70 && $aabb59e57493b9ac$export$c0306caf338ac095 < 97) break;
    return $aabb59e57493b9ac$export$58adb3bec8346d0f(e, $aabb59e57493b9ac$export$e88cb2efb12ae807() + (r < 6 && $aabb59e57493b9ac$export$4d3fb11e950abb9e() == 32 && $aabb59e57493b9ac$export$48cfd1e771a65c4f() == 32));
}
function $aabb59e57493b9ac$export$c889f2fcc19dbf12(e) {
    while($aabb59e57493b9ac$export$48cfd1e771a65c4f())switch($aabb59e57493b9ac$export$c0306caf338ac095){
        case e:
            return $aabb59e57493b9ac$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $aabb59e57493b9ac$export$c889f2fcc19dbf12($aabb59e57493b9ac$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $aabb59e57493b9ac$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $aabb59e57493b9ac$export$48cfd1e771a65c4f();
            break;
    }
    return $aabb59e57493b9ac$export$5880b8b5730aff45;
}
function $aabb59e57493b9ac$export$4254d4e2b3745c4c(e, r) {
    while($aabb59e57493b9ac$export$48cfd1e771a65c4f())if (e + $aabb59e57493b9ac$export$c0306caf338ac095 === 57) break;
    else if (e + $aabb59e57493b9ac$export$c0306caf338ac095 === 84 && $aabb59e57493b9ac$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $aabb59e57493b9ac$export$58adb3bec8346d0f(r, $aabb59e57493b9ac$export$5880b8b5730aff45 - 1) + "*" + $aabb59e57493b9ac$export$6788812c4e6611e6(e === 47 ? e : $aabb59e57493b9ac$export$48cfd1e771a65c4f());
}
function $aabb59e57493b9ac$export$c2ab62c7bf24634(e) {
    while(!$aabb59e57493b9ac$export$9e1725a4cfeada27($aabb59e57493b9ac$export$4d3fb11e950abb9e()))$aabb59e57493b9ac$export$48cfd1e771a65c4f();
    return $aabb59e57493b9ac$export$58adb3bec8346d0f(e, $aabb59e57493b9ac$export$5880b8b5730aff45);
}
function $aabb59e57493b9ac$export$ef7acd7185315e22(e) {
    return $aabb59e57493b9ac$export$45918ac1574455b1($aabb59e57493b9ac$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $aabb59e57493b9ac$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $aabb59e57493b9ac$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $aabb59e57493b9ac$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $aabb59e57493b9ac$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($aabb59e57493b9ac$export$f8e21b1e77979a08(j += $aabb59e57493b9ac$export$77ad94ebf1c2b9ed($aabb59e57493b9ac$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $aabb59e57493b9ac$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $aabb59e57493b9ac$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $aabb59e57493b9ac$export$955ba06d119e085e($aabb59e57493b9ac$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($aabb59e57493b9ac$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $aabb59e57493b9ac$export$10d8903dec122b9d($aabb59e57493b9ac$export$4a34f930e789283c($aabb59e57493b9ac$export$4254d4e2b3745c4c($aabb59e57493b9ac$export$48cfd1e771a65c4f(), $aabb59e57493b9ac$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $aabb59e57493b9ac$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $aabb59e57493b9ac$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $aabb59e57493b9ac$export$36776f635604f274(j) - l) $aabb59e57493b9ac$export$10d8903dec122b9d(p > 32 ? $aabb59e57493b9ac$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $aabb59e57493b9ac$export$f8483753829ec8f3($aabb59e57493b9ac$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $aabb59e57493b9ac$export$10d8903dec122b9d(y = $aabb59e57493b9ac$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $aabb59e57493b9ac$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $aabb59e57493b9ac$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $aabb59e57493b9ac$export$98e6a39c04603d36(e, y, y, n && $aabb59e57493b9ac$export$10d8903dec122b9d($aabb59e57493b9ac$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $aabb59e57493b9ac$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $aabb59e57493b9ac$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $aabb59e57493b9ac$export$232faf9add678146() == 125) continue;
            }
            switch(j += $aabb59e57493b9ac$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($aabb59e57493b9ac$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($aabb59e57493b9ac$export$4d3fb11e950abb9e() === 45) j += $aabb59e57493b9ac$export$410ac95b9ec204b8($aabb59e57493b9ac$export$48cfd1e771a65c4f());
                    v = $aabb59e57493b9ac$export$4d3fb11e950abb9e(), o = l = $aabb59e57493b9ac$export$36776f635604f274(g = j += $aabb59e57493b9ac$export$c2ab62c7bf24634($aabb59e57493b9ac$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $aabb59e57493b9ac$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $aabb59e57493b9ac$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $aabb59e57493b9ac$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $aabb59e57493b9ac$export$2f35ab04d2335697(e, v + 1, v = $aabb59e57493b9ac$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $aabb59e57493b9ac$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $aabb59e57493b9ac$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $aabb59e57493b9ac$export$35059013cd4a06db(e, r, a, s === 0 ? $aabb59e57493b9ac$export$aa3a2e812ca8570d : i, f, o, l);
}
function $aabb59e57493b9ac$export$4a34f930e789283c(e, r, a) {
    return $aabb59e57493b9ac$export$35059013cd4a06db(e, r, a, $aabb59e57493b9ac$export$a29989082612d0d9, $aabb59e57493b9ac$export$6788812c4e6611e6($aabb59e57493b9ac$export$eba6f6f03b0a92e7()), $aabb59e57493b9ac$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $aabb59e57493b9ac$export$f8483753829ec8f3(e, r, a, n) {
    return $aabb59e57493b9ac$export$35059013cd4a06db(e, r, a, $aabb59e57493b9ac$export$527d108ccf083c2b, $aabb59e57493b9ac$export$2f35ab04d2335697(e, 0, n), $aabb59e57493b9ac$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $aabb59e57493b9ac$export$82e9f45cca5ba907(n, c, s) {
    switch($aabb59e57493b9ac$export$d6af199866bfb566(n, c)){
        case 5103:
            return $aabb59e57493b9ac$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $aabb59e57493b9ac$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $aabb59e57493b9ac$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $aabb59e57493b9ac$export$39dfd62a25e0fe93 + n + $aabb59e57493b9ac$export$2c0f367103c8d01c + n + $aabb59e57493b9ac$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($aabb59e57493b9ac$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $aabb59e57493b9ac$export$39dfd62a25e0fe93 + n + $aabb59e57493b9ac$export$71ad59f2e432cfe8 + $aabb59e57493b9ac$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $aabb59e57493b9ac$export$39dfd62a25e0fe93 + n + $aabb59e57493b9ac$export$71ad59f2e432cfe8 + $aabb59e57493b9ac$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $aabb59e57493b9ac$export$39dfd62a25e0fe93 + n + $aabb59e57493b9ac$export$71ad59f2e432cfe8 + $aabb59e57493b9ac$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $aabb59e57493b9ac$export$39dfd62a25e0fe93 + n + $aabb59e57493b9ac$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $aabb59e57493b9ac$export$39dfd62a25e0fe93 + n + $aabb59e57493b9ac$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $aabb59e57493b9ac$export$39dfd62a25e0fe93 + n + $aabb59e57493b9ac$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $aabb59e57493b9ac$export$39dfd62a25e0fe93 + "box-$1$2" + $aabb59e57493b9ac$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $aabb59e57493b9ac$export$39dfd62a25e0fe93 + n + $aabb59e57493b9ac$export$71ad59f2e432cfe8 + "flex-item-" + $aabb59e57493b9ac$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$aabb59e57493b9ac$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $aabb59e57493b9ac$export$71ad59f2e432cfe8 + "grid-row-" + $aabb59e57493b9ac$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $aabb59e57493b9ac$export$39dfd62a25e0fe93 + n + $aabb59e57493b9ac$export$71ad59f2e432cfe8 + "flex-line-pack" + $aabb59e57493b9ac$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $aabb59e57493b9ac$export$39dfd62a25e0fe93 + n + $aabb59e57493b9ac$export$71ad59f2e432cfe8 + $aabb59e57493b9ac$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $aabb59e57493b9ac$export$39dfd62a25e0fe93 + n + $aabb59e57493b9ac$export$71ad59f2e432cfe8 + $aabb59e57493b9ac$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $aabb59e57493b9ac$export$39dfd62a25e0fe93 + "box-" + $aabb59e57493b9ac$export$77ad94ebf1c2b9ed(n, "-grow", "") + $aabb59e57493b9ac$export$39dfd62a25e0fe93 + n + $aabb59e57493b9ac$export$71ad59f2e432cfe8 + $aabb59e57493b9ac$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $aabb59e57493b9ac$export$39dfd62a25e0fe93 + $aabb59e57493b9ac$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $aabb59e57493b9ac$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $aabb59e57493b9ac$export$77ad94ebf1c2b9ed($aabb59e57493b9ac$export$77ad94ebf1c2b9ed($aabb59e57493b9ac$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $aabb59e57493b9ac$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $aabb59e57493b9ac$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $aabb59e57493b9ac$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $aabb59e57493b9ac$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $aabb59e57493b9ac$export$77ad94ebf1c2b9ed($aabb59e57493b9ac$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $aabb59e57493b9ac$export$39dfd62a25e0fe93 + "box-pack:$3" + $aabb59e57493b9ac$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $aabb59e57493b9ac$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$aabb59e57493b9ac$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $aabb59e57493b9ac$export$71ad59f2e432cfe8 + "grid-column-align" + $aabb59e57493b9ac$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $aabb59e57493b9ac$export$71ad59f2e432cfe8 + $aabb59e57493b9ac$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $aabb59e57493b9ac$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$aabb59e57493b9ac$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $aabb59e57493b9ac$export$71ad59f2e432cfe8 + $aabb59e57493b9ac$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $aabb59e57493b9ac$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$aabb59e57493b9ac$export$f8e21b1e77979a08(s, "span") ? $aabb59e57493b9ac$export$4659b591c19bdf3d(s, /\d+/) : +$aabb59e57493b9ac$export$4659b591c19bdf3d(s, /\d+/) - +$aabb59e57493b9ac$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $aabb59e57493b9ac$export$71ad59f2e432cfe8 + $aabb59e57493b9ac$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $aabb59e57493b9ac$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $aabb59e57493b9ac$export$71ad59f2e432cfe8 + $aabb59e57493b9ac$export$77ad94ebf1c2b9ed($aabb59e57493b9ac$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $aabb59e57493b9ac$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $aabb59e57493b9ac$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($aabb59e57493b9ac$export$36776f635604f274(n) - 1 - c > 6) switch($aabb59e57493b9ac$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($aabb59e57493b9ac$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $aabb59e57493b9ac$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $aabb59e57493b9ac$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $aabb59e57493b9ac$export$2c0f367103c8d01c + ($aabb59e57493b9ac$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$aabb59e57493b9ac$export$f8e21b1e77979a08(n, "stretch") ? $aabb59e57493b9ac$export$82e9f45cca5ba907($aabb59e57493b9ac$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $aabb59e57493b9ac$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $aabb59e57493b9ac$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $aabb59e57493b9ac$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($aabb59e57493b9ac$export$a9db5e087081082d(n, c + 6) === 121) return $aabb59e57493b9ac$export$77ad94ebf1c2b9ed(n, ":", ":" + $aabb59e57493b9ac$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($aabb59e57493b9ac$export$a9db5e087081082d(n, $aabb59e57493b9ac$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $aabb59e57493b9ac$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $aabb59e57493b9ac$export$39dfd62a25e0fe93 + ($aabb59e57493b9ac$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $aabb59e57493b9ac$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $aabb59e57493b9ac$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $aabb59e57493b9ac$export$77ad94ebf1c2b9ed(n, ":", ":" + $aabb59e57493b9ac$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $aabb59e57493b9ac$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $aabb59e57493b9ac$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $aabb59e57493b9ac$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $aabb59e57493b9ac$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $aabb59e57493b9ac$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $aabb59e57493b9ac$export$a763edbf796b780a:
        case $aabb59e57493b9ac$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $aabb59e57493b9ac$export$a29989082612d0d9:
            return "";
        case $aabb59e57493b9ac$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $aabb59e57493b9ac$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $aabb59e57493b9ac$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $aabb59e57493b9ac$export$36776f635604f274(a = $aabb59e57493b9ac$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $aabb59e57493b9ac$export$5a7767152ae0305f(e) {
    var r = $aabb59e57493b9ac$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $aabb59e57493b9ac$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $aabb59e57493b9ac$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $aabb59e57493b9ac$export$527d108ccf083c2b:
                n.return = $aabb59e57493b9ac$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $aabb59e57493b9ac$export$b44a8529a35fcb60:
                return $aabb59e57493b9ac$export$dfdc1655ccc5b9cb([
                    $aabb59e57493b9ac$export$784d13d8ee351f07(n, {
                        value: $aabb59e57493b9ac$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $aabb59e57493b9ac$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $aabb59e57493b9ac$export$aa3a2e812ca8570d:
                if (n.length) return $aabb59e57493b9ac$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($aabb59e57493b9ac$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $aabb59e57493b9ac$export$dfdc1655ccc5b9cb([
                                $aabb59e57493b9ac$export$784d13d8ee351f07(n, {
                                    props: [
                                        $aabb59e57493b9ac$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $aabb59e57493b9ac$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $aabb59e57493b9ac$export$dfdc1655ccc5b9cb([
                                $aabb59e57493b9ac$export$784d13d8ee351f07(n, {
                                    props: [
                                        $aabb59e57493b9ac$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $aabb59e57493b9ac$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $aabb59e57493b9ac$export$784d13d8ee351f07(n, {
                                    props: [
                                        $aabb59e57493b9ac$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $aabb59e57493b9ac$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $aabb59e57493b9ac$export$784d13d8ee351f07(n, {
                                    props: [
                                        $aabb59e57493b9ac$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $aabb59e57493b9ac$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $aabb59e57493b9ac$export$76a88f7de6507443(e) {
    switch(e.type){
        case $aabb59e57493b9ac$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $aabb59e57493b9ac$export$1be1fc439b849fdf($aabb59e57493b9ac$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($aabb59e57493b9ac$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $aabb59e57493b9ac$export$2f35ab04d2335697(r, 1, $aabb59e57493b9ac$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $aabb59e57493b9ac$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $aabb59e57493b9ac$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $aabb59e57493b9ac$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("eZw11", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae9f98d259b7d1d1$export$2e2bcd8739ae039; });
var $ae9f98d259b7d1d1$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("1Jcta", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1423aa965bc622c7$export$2e2bcd8739ae039; });
function $1423aa965bc622c7$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("iunch", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d75d05c7d3900b7c$export$2e2bcd8739ae039; });
function $d75d05c7d3900b7c$export$2e2bcd8739ae039() {
    $d75d05c7d3900b7c$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d75d05c7d3900b7c$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("dFqaQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f33684fbbde7891$export$2e2bcd8739ae039; });

var $knVHJ = parcelRequire("knVHJ");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $9f33684fbbde7891$export$2e2bcd8739ae039 = function hoistNonReactStatics(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($knVHJ)))(targetComponent, sourceComponent);
};

});
parcelRegister("knVHJ", function(module, exports) {
"use strict";

var $7gLRM = parcelRequire("7gLRM");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $03d46e509d407e42$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $03d46e509d407e42$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $03d46e509d407e42$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $03d46e509d407e42$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $03d46e509d407e42$var$TYPE_STATICS = {};
$03d46e509d407e42$var$TYPE_STATICS[$7gLRM.ForwardRef] = $03d46e509d407e42$var$FORWARD_REF_STATICS;
$03d46e509d407e42$var$TYPE_STATICS[$7gLRM.Memo] = $03d46e509d407e42$var$MEMO_STATICS;
function $03d46e509d407e42$var$getStatics(component) {
    // React v16.11 and below
    if ($7gLRM.isMemo(component)) return $03d46e509d407e42$var$MEMO_STATICS;
     // React v16.12 and above
    return $03d46e509d407e42$var$TYPE_STATICS[component["$$typeof"]] || $03d46e509d407e42$var$REACT_STATICS;
}
var $03d46e509d407e42$var$defineProperty = Object.defineProperty;
var $03d46e509d407e42$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $03d46e509d407e42$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $03d46e509d407e42$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $03d46e509d407e42$var$getPrototypeOf = Object.getPrototypeOf;
var $03d46e509d407e42$var$objectPrototype = Object.prototype;
function $03d46e509d407e42$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($03d46e509d407e42$var$objectPrototype) {
            var inheritedComponent = $03d46e509d407e42$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $03d46e509d407e42$var$objectPrototype) $03d46e509d407e42$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $03d46e509d407e42$var$getOwnPropertyNames(sourceComponent);
        if ($03d46e509d407e42$var$getOwnPropertySymbols) keys = keys.concat($03d46e509d407e42$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $03d46e509d407e42$var$getStatics(targetComponent);
        var sourceStatics = $03d46e509d407e42$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$03d46e509d407e42$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $03d46e509d407e42$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $03d46e509d407e42$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $03d46e509d407e42$var$hoistNonReactStatics;

});
parcelRegister("7gLRM", function(module, exports) {
"use strict";

module.exports = (parcelRequire("hwp41"));

});
parcelRegister("hwp41", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $cc18de02337931fa$export$2b8d127b894957b9; }, function (v) { return $cc18de02337931fa$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $cc18de02337931fa$export$cea3a54a6425200c; }, function (v) { return $cc18de02337931fa$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $cc18de02337931fa$export$a7c73072b1a182ae; }, function (v) { return $cc18de02337931fa$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $cc18de02337931fa$export$9f27bc3417b4524d; }, function (v) { return $cc18de02337931fa$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $cc18de02337931fa$export$db77ccec0bb4ccac; }, function (v) { return $cc18de02337931fa$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $cc18de02337931fa$export$8392c0c9d3dcbd35; }, function (v) { return $cc18de02337931fa$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $cc18de02337931fa$export$ffb0004e005737fa; }, function (v) { return $cc18de02337931fa$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $cc18de02337931fa$export$b624eff549462981; }, function (v) { return $cc18de02337931fa$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $cc18de02337931fa$export$7897aa7841a5380c; }, function (v) { return $cc18de02337931fa$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $cc18de02337931fa$export$602eac185826482c; }, function (v) { return $cc18de02337931fa$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $cc18de02337931fa$export$e2c29f18771995cb; }, function (v) { return $cc18de02337931fa$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $cc18de02337931fa$export$5f8d39834fd61797; }, function (v) { return $cc18de02337931fa$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $cc18de02337931fa$export$74bf444e3cd11ea5; }, function (v) { return $cc18de02337931fa$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $cc18de02337931fa$export$92387174baf9b227; }, function (v) { return $cc18de02337931fa$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $cc18de02337931fa$export$ec112efeb987d9c6; }, function (v) { return $cc18de02337931fa$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $cc18de02337931fa$export$b706b080d889d2c9; }, function (v) { return $cc18de02337931fa$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $cc18de02337931fa$export$5be5a87408f70ddc; }, function (v) { return $cc18de02337931fa$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $cc18de02337931fa$export$45a5e7f76e0caa8d; }, function (v) { return $cc18de02337931fa$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $cc18de02337931fa$export$455c2e768291efa6; }, function (v) { return $cc18de02337931fa$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $cc18de02337931fa$export$9522e17588c12572; }, function (v) { return $cc18de02337931fa$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $cc18de02337931fa$export$2110ac352bb060b9; }, function (v) { return $cc18de02337931fa$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $cc18de02337931fa$export$56885ab8b9c456ab; }, function (v) { return $cc18de02337931fa$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $cc18de02337931fa$export$d927fcb6adf8f9de; }, function (v) { return $cc18de02337931fa$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $cc18de02337931fa$export$b82d16f27459e05a; }, function (v) { return $cc18de02337931fa$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $cc18de02337931fa$export$522c17b4f5e123e8; }, function (v) { return $cc18de02337931fa$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $cc18de02337931fa$export$1aabd8a0274ecfd6; }, function (v) { return $cc18de02337931fa$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $cc18de02337931fa$export$9b621391a187a31a; }, function (v) { return $cc18de02337931fa$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $cc18de02337931fa$export$f5bbd400c2f4426f; }, function (v) { return $cc18de02337931fa$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $cc18de02337931fa$export$2b8d127b894957b9;
var $cc18de02337931fa$export$cea3a54a6425200c;
var $cc18de02337931fa$export$a7c73072b1a182ae;
var $cc18de02337931fa$export$9f27bc3417b4524d;
var $cc18de02337931fa$export$db77ccec0bb4ccac;
var $cc18de02337931fa$export$8392c0c9d3dcbd35;
var $cc18de02337931fa$export$ffb0004e005737fa;
var $cc18de02337931fa$export$b624eff549462981;
var $cc18de02337931fa$export$7897aa7841a5380c;
var $cc18de02337931fa$export$602eac185826482c;
var $cc18de02337931fa$export$e2c29f18771995cb;
var $cc18de02337931fa$export$5f8d39834fd61797;
var $cc18de02337931fa$export$74bf444e3cd11ea5;
var $cc18de02337931fa$export$92387174baf9b227;
var $cc18de02337931fa$export$ec112efeb987d9c6;
var $cc18de02337931fa$export$b706b080d889d2c9;
var $cc18de02337931fa$export$5be5a87408f70ddc;
var $cc18de02337931fa$export$45a5e7f76e0caa8d;
var $cc18de02337931fa$export$455c2e768291efa6;
var $cc18de02337931fa$export$9522e17588c12572;
var $cc18de02337931fa$export$2110ac352bb060b9;
var $cc18de02337931fa$export$56885ab8b9c456ab;
var $cc18de02337931fa$export$d927fcb6adf8f9de;
var $cc18de02337931fa$export$b82d16f27459e05a;
var $cc18de02337931fa$export$522c17b4f5e123e8;
var $cc18de02337931fa$export$1aabd8a0274ecfd6;
var $cc18de02337931fa$export$9b621391a187a31a;
var $cc18de02337931fa$export$f5bbd400c2f4426f;
"use strict";
var $cc18de02337931fa$var$b = "function" === typeof Symbol && Symbol.for, $cc18de02337931fa$var$c = $cc18de02337931fa$var$b ? Symbol.for("react.element") : 60103, $cc18de02337931fa$var$d = $cc18de02337931fa$var$b ? Symbol.for("react.portal") : 60106, $cc18de02337931fa$var$e = $cc18de02337931fa$var$b ? Symbol.for("react.fragment") : 60107, $cc18de02337931fa$var$f = $cc18de02337931fa$var$b ? Symbol.for("react.strict_mode") : 60108, $cc18de02337931fa$var$g = $cc18de02337931fa$var$b ? Symbol.for("react.profiler") : 60114, $cc18de02337931fa$var$h = $cc18de02337931fa$var$b ? Symbol.for("react.provider") : 60109, $cc18de02337931fa$var$k = $cc18de02337931fa$var$b ? Symbol.for("react.context") : 60110, $cc18de02337931fa$var$l = $cc18de02337931fa$var$b ? Symbol.for("react.async_mode") : 60111, $cc18de02337931fa$var$m = $cc18de02337931fa$var$b ? Symbol.for("react.concurrent_mode") : 60111, $cc18de02337931fa$var$n = $cc18de02337931fa$var$b ? Symbol.for("react.forward_ref") : 60112, $cc18de02337931fa$var$p = $cc18de02337931fa$var$b ? Symbol.for("react.suspense") : 60113, $cc18de02337931fa$var$q = $cc18de02337931fa$var$b ? Symbol.for("react.suspense_list") : 60120, $cc18de02337931fa$var$r = $cc18de02337931fa$var$b ? Symbol.for("react.memo") : 60115, $cc18de02337931fa$var$t = $cc18de02337931fa$var$b ? Symbol.for("react.lazy") : 60116, $cc18de02337931fa$var$v = $cc18de02337931fa$var$b ? Symbol.for("react.block") : 60121, $cc18de02337931fa$var$w = $cc18de02337931fa$var$b ? Symbol.for("react.fundamental") : 60117, $cc18de02337931fa$var$x = $cc18de02337931fa$var$b ? Symbol.for("react.responder") : 60118, $cc18de02337931fa$var$y = $cc18de02337931fa$var$b ? Symbol.for("react.scope") : 60119;
function $cc18de02337931fa$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $cc18de02337931fa$var$c:
                switch(a = a.type, a){
                    case $cc18de02337931fa$var$l:
                    case $cc18de02337931fa$var$m:
                    case $cc18de02337931fa$var$e:
                    case $cc18de02337931fa$var$g:
                    case $cc18de02337931fa$var$f:
                    case $cc18de02337931fa$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $cc18de02337931fa$var$k:
                            case $cc18de02337931fa$var$n:
                            case $cc18de02337931fa$var$t:
                            case $cc18de02337931fa$var$r:
                            case $cc18de02337931fa$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $cc18de02337931fa$var$d:
                return u;
        }
    }
}
function $cc18de02337931fa$var$A(a) {
    return $cc18de02337931fa$var$z(a) === $cc18de02337931fa$var$m;
}
$cc18de02337931fa$export$2b8d127b894957b9 = $cc18de02337931fa$var$l;
$cc18de02337931fa$export$cea3a54a6425200c = $cc18de02337931fa$var$m;
$cc18de02337931fa$export$a7c73072b1a182ae = $cc18de02337931fa$var$k;
$cc18de02337931fa$export$9f27bc3417b4524d = $cc18de02337931fa$var$h;
$cc18de02337931fa$export$db77ccec0bb4ccac = $cc18de02337931fa$var$c;
$cc18de02337931fa$export$8392c0c9d3dcbd35 = $cc18de02337931fa$var$n;
$cc18de02337931fa$export$ffb0004e005737fa = $cc18de02337931fa$var$e;
$cc18de02337931fa$export$b624eff549462981 = $cc18de02337931fa$var$t;
$cc18de02337931fa$export$7897aa7841a5380c = $cc18de02337931fa$var$r;
$cc18de02337931fa$export$602eac185826482c = $cc18de02337931fa$var$d;
$cc18de02337931fa$export$e2c29f18771995cb = $cc18de02337931fa$var$g;
$cc18de02337931fa$export$5f8d39834fd61797 = $cc18de02337931fa$var$f;
$cc18de02337931fa$export$74bf444e3cd11ea5 = $cc18de02337931fa$var$p;
$cc18de02337931fa$export$92387174baf9b227 = function(a) {
    return $cc18de02337931fa$var$A(a) || $cc18de02337931fa$var$z(a) === $cc18de02337931fa$var$l;
};
$cc18de02337931fa$export$ec112efeb987d9c6 = $cc18de02337931fa$var$A;
$cc18de02337931fa$export$b706b080d889d2c9 = function(a) {
    return $cc18de02337931fa$var$z(a) === $cc18de02337931fa$var$k;
};
$cc18de02337931fa$export$5be5a87408f70ddc = function(a) {
    return $cc18de02337931fa$var$z(a) === $cc18de02337931fa$var$h;
};
$cc18de02337931fa$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $cc18de02337931fa$var$c;
};
$cc18de02337931fa$export$455c2e768291efa6 = function(a) {
    return $cc18de02337931fa$var$z(a) === $cc18de02337931fa$var$n;
};
$cc18de02337931fa$export$9522e17588c12572 = function(a) {
    return $cc18de02337931fa$var$z(a) === $cc18de02337931fa$var$e;
};
$cc18de02337931fa$export$2110ac352bb060b9 = function(a) {
    return $cc18de02337931fa$var$z(a) === $cc18de02337931fa$var$t;
};
$cc18de02337931fa$export$56885ab8b9c456ab = function(a) {
    return $cc18de02337931fa$var$z(a) === $cc18de02337931fa$var$r;
};
$cc18de02337931fa$export$d927fcb6adf8f9de = function(a) {
    return $cc18de02337931fa$var$z(a) === $cc18de02337931fa$var$d;
};
$cc18de02337931fa$export$b82d16f27459e05a = function(a) {
    return $cc18de02337931fa$var$z(a) === $cc18de02337931fa$var$g;
};
$cc18de02337931fa$export$522c17b4f5e123e8 = function(a) {
    return $cc18de02337931fa$var$z(a) === $cc18de02337931fa$var$f;
};
$cc18de02337931fa$export$1aabd8a0274ecfd6 = function(a) {
    return $cc18de02337931fa$var$z(a) === $cc18de02337931fa$var$p;
};
$cc18de02337931fa$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $cc18de02337931fa$var$e || a === $cc18de02337931fa$var$m || a === $cc18de02337931fa$var$g || a === $cc18de02337931fa$var$f || a === $cc18de02337931fa$var$p || a === $cc18de02337931fa$var$q || "object" === typeof a && null !== a && (a.$$typeof === $cc18de02337931fa$var$t || a.$$typeof === $cc18de02337931fa$var$r || a.$$typeof === $cc18de02337931fa$var$h || a.$$typeof === $cc18de02337931fa$var$k || a.$$typeof === $cc18de02337931fa$var$n || a.$$typeof === $cc18de02337931fa$var$w || a.$$typeof === $cc18de02337931fa$var$x || a.$$typeof === $cc18de02337931fa$var$y || a.$$typeof === $cc18de02337931fa$var$v);
};
$cc18de02337931fa$export$f5bbd400c2f4426f = $cc18de02337931fa$var$z;

});




parcelRegister("2B9xT", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $1e46710a960e34c0$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $1e46710a960e34c0$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $1e46710a960e34c0$export$6f077d94b33a01aa; });
var $1e46710a960e34c0$var$isBrowser = true;
function $1e46710a960e34c0$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $1e46710a960e34c0$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $1e46710a960e34c0$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $1e46710a960e34c0$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $1e46710a960e34c0$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRegister("dvoqA", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $9d511e7da9795806$export$6321afa313b251b5; });

var $l0HdX = parcelRequire("l0HdX");

var $kf8kW = parcelRequire("kf8kW");

var $242sM = parcelRequire("242sM");

var $1Jcta = parcelRequire("1Jcta");
var $9d511e7da9795806$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $9d511e7da9795806$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $9d511e7da9795806$var$hyphenateRegex = /[A-Z]|^ms/g;
var $9d511e7da9795806$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $9d511e7da9795806$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $9d511e7da9795806$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $9d511e7da9795806$var$processStyleName = /* #__PURE__ */ (0, $1Jcta.default)(function(styleName) {
    return $9d511e7da9795806$var$isCustomProperty(styleName) ? styleName : styleName.replace($9d511e7da9795806$var$hyphenateRegex, "-$&").toLowerCase();
});
var $9d511e7da9795806$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($9d511e7da9795806$var$animationRegex, function(match, p1, p2) {
                $9d511e7da9795806$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $9d511e7da9795806$var$cursor
                };
                return p1;
            });
    }
    if ((0, $242sM.default)[key] !== 1 && !$9d511e7da9795806$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $9d511e7da9795806$var$contentValuePattern, $9d511e7da9795806$var$contentValues, $9d511e7da9795806$var$oldProcessStyleValue, $9d511e7da9795806$var$msPattern, $9d511e7da9795806$var$hyphenPattern, $9d511e7da9795806$var$hyphenatedCache;
var $9d511e7da9795806$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $9d511e7da9795806$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation === "undefined" ? "undefined" : (0, $l0HdX._)(interpolation)){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $9d511e7da9795806$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $9d511e7da9795806$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $9d511e7da9795806$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $9d511e7da9795806$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $9d511e7da9795806$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $9d511e7da9795806$var$cursor;
                var result = interpolation(mergedProps);
                $9d511e7da9795806$var$cursor = previousCursor;
                return $9d511e7da9795806$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $9d511e7da9795806$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $9d511e7da9795806$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($9d511e7da9795806$var$isProcessableValue(value)) string += $9d511e7da9795806$var$processStyleName(_key) + ":" + $9d511e7da9795806$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($9d511e7da9795806$var$isProcessableValue(value[_i])) string += $9d511e7da9795806$var$processStyleName(_key) + ":" + $9d511e7da9795806$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $9d511e7da9795806$var$handleInterpolation(mergedProps, registered, value);
            switch(_key){
                case "animation":
                case "animationName":
                    string += $9d511e7da9795806$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $9d511e7da9795806$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $9d511e7da9795806$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $9d511e7da9795806$var$cursor;
var $9d511e7da9795806$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $9d511e7da9795806$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $9d511e7da9795806$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $9d511e7da9795806$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $9d511e7da9795806$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $9d511e7da9795806$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $kf8kW.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $9d511e7da9795806$var$cursor
    };
};

});
parcelRegister("kf8kW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ebcbacdfd2a0e057$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $ebcbacdfd2a0e057$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("242sM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $180ddda2cd93600f$export$2e2bcd8739ae039; });
var $180ddda2cd93600f$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("dkd4E", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $9b3748dd416b04bf$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $9b3748dd416b04bf$export$811a713a7276cb9d; });

var $1Mpn7 = parcelRequire("1Mpn7");
var $9b3748dd416b04bf$var$syncFallback = function syncFallback(create) {
    return create();
};
var $9b3748dd416b04bf$var$useInsertionEffect = $1Mpn7.useInsertionEffect ? $1Mpn7.useInsertionEffect : false;
var $9b3748dd416b04bf$export$db21c7ffa21794e7 = $9b3748dd416b04bf$var$useInsertionEffect || $9b3748dd416b04bf$var$syncFallback;
var $9b3748dd416b04bf$export$811a713a7276cb9d = $9b3748dd416b04bf$var$useInsertionEffect || $1Mpn7.useLayoutEffect;

});


parcelRegister("fjkYW", function(module, exports) {
function $b258e7f638dfbc49$var$_extends() {
    module.exports = $b258e7f638dfbc49$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $b258e7f638dfbc49$var$_extends.apply(this, arguments);
}
module.exports = $b258e7f638dfbc49$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("3ltji", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $26fa11aab20bccf7$export$882461b6382ed46c; }, function (v) { return $26fa11aab20bccf7$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $26fa11aab20bccf7$export$757ceba2d55c277e; }, function (v) { return $26fa11aab20bccf7$export$757ceba2d55c277e = v; });
var $26fa11aab20bccf7$export$882461b6382ed46c;
var $26fa11aab20bccf7$export$757ceba2d55c277e;
"use strict";

var $eaouD = parcelRequire("eaouD");
var $26fa11aab20bccf7$var$i;
$26fa11aab20bccf7$export$882461b6382ed46c = $eaouD.createRoot;
$26fa11aab20bccf7$export$757ceba2d55c277e = $eaouD.hydrateRoot;

});
parcelRegister("eaouD", function(module, exports) {
"use strict";
function $a504ffb23be6b2c4$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($a504ffb23be6b2c4$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$a504ffb23be6b2c4$var$checkDCE();

module.exports = (parcelRequire("fXYSg"));

});
parcelRegister("fXYSg", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $b9fb96103a9b59e3$export$ae55be85d98224ed; }, function (v) { return $b9fb96103a9b59e3$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $b9fb96103a9b59e3$export$d39a5bbd09211389; }, function (v) { return $b9fb96103a9b59e3$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $b9fb96103a9b59e3$export$882461b6382ed46c; }, function (v) { return $b9fb96103a9b59e3$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $b9fb96103a9b59e3$export$466bfc07425424d5; }, function (v) { return $b9fb96103a9b59e3$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $b9fb96103a9b59e3$export$cd75ccfd720a3cd4; }, function (v) { return $b9fb96103a9b59e3$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $b9fb96103a9b59e3$export$fa8d919ba61d84db; }, function (v) { return $b9fb96103a9b59e3$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $b9fb96103a9b59e3$export$757ceba2d55c277e; }, function (v) { return $b9fb96103a9b59e3$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $b9fb96103a9b59e3$export$b3890eb0ae9dca99; }, function (v) { return $b9fb96103a9b59e3$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $b9fb96103a9b59e3$export$502457920280e6be; }, function (v) { return $b9fb96103a9b59e3$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $b9fb96103a9b59e3$export$c78a37762a8d58e1; }, function (v) { return $b9fb96103a9b59e3$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $b9fb96103a9b59e3$export$dc54d992c10e8a18; }, function (v) { return $b9fb96103a9b59e3$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $b9fb96103a9b59e3$export$83d89fbfd8236492; }, function (v) { return $b9fb96103a9b59e3$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.profiling.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $l0HdX = parcelRequire("l0HdX");
var $b9fb96103a9b59e3$export$ae55be85d98224ed;
var $b9fb96103a9b59e3$export$d39a5bbd09211389;
var $b9fb96103a9b59e3$export$882461b6382ed46c;
var $b9fb96103a9b59e3$export$466bfc07425424d5;
var $b9fb96103a9b59e3$export$cd75ccfd720a3cd4;
var $b9fb96103a9b59e3$export$fa8d919ba61d84db;
var $b9fb96103a9b59e3$export$757ceba2d55c277e;
var $b9fb96103a9b59e3$export$b3890eb0ae9dca99;
var $b9fb96103a9b59e3$export$502457920280e6be;
var $b9fb96103a9b59e3$export$c78a37762a8d58e1;
var $b9fb96103a9b59e3$export$dc54d992c10e8a18;
var $b9fb96103a9b59e3$export$83d89fbfd8236492;
"use strict";
/* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ "use strict";

var $1Mpn7 = parcelRequire("1Mpn7");

var $3rCRi = parcelRequire("3rCRi");
function $b9fb96103a9b59e3$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $b9fb96103a9b59e3$var$da = new Set, $b9fb96103a9b59e3$var$ea = {};
function $b9fb96103a9b59e3$var$fa(a, b) {
    $b9fb96103a9b59e3$var$ha(a, b);
    $b9fb96103a9b59e3$var$ha(a + "Capture", b);
}
function $b9fb96103a9b59e3$var$ha(a, b) {
    $b9fb96103a9b59e3$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$b9fb96103a9b59e3$var$da.add(b[a]);
}
var $b9fb96103a9b59e3$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $b9fb96103a9b59e3$var$ja = Object.prototype.hasOwnProperty, $b9fb96103a9b59e3$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $b9fb96103a9b59e3$var$la = {}, $b9fb96103a9b59e3$var$ma = {};
function $b9fb96103a9b59e3$var$na(a) {
    if ($b9fb96103a9b59e3$var$ja.call($b9fb96103a9b59e3$var$ma, a)) return !0;
    if ($b9fb96103a9b59e3$var$ja.call($b9fb96103a9b59e3$var$la, a)) return !1;
    if ($b9fb96103a9b59e3$var$ka.test(a)) return $b9fb96103a9b59e3$var$ma[a] = !0;
    $b9fb96103a9b59e3$var$la[a] = !0;
    return !1;
}
function $b9fb96103a9b59e3$var$oa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b === "undefined" ? "undefined" : (0, $l0HdX._)(b)){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $b9fb96103a9b59e3$var$pa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $b9fb96103a9b59e3$var$oa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $b9fb96103a9b59e3$var$qa(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $b9fb96103a9b59e3$var$t = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $b9fb96103a9b59e3$var$t[a] = new $b9fb96103a9b59e3$var$qa(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $b9fb96103a9b59e3$var$t[b] = new $b9fb96103a9b59e3$var$qa(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $b9fb96103a9b59e3$var$t[a] = new $b9fb96103a9b59e3$var$qa(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $b9fb96103a9b59e3$var$t[a] = new $b9fb96103a9b59e3$var$qa(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $b9fb96103a9b59e3$var$t[a] = new $b9fb96103a9b59e3$var$qa(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $b9fb96103a9b59e3$var$t[a] = new $b9fb96103a9b59e3$var$qa(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $b9fb96103a9b59e3$var$t[a] = new $b9fb96103a9b59e3$var$qa(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $b9fb96103a9b59e3$var$t[a] = new $b9fb96103a9b59e3$var$qa(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $b9fb96103a9b59e3$var$t[a] = new $b9fb96103a9b59e3$var$qa(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $b9fb96103a9b59e3$var$ra = /[\-:]([a-z])/g;
function $b9fb96103a9b59e3$var$ta(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($b9fb96103a9b59e3$var$ra, $b9fb96103a9b59e3$var$ta);
    $b9fb96103a9b59e3$var$t[b] = new $b9fb96103a9b59e3$var$qa(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($b9fb96103a9b59e3$var$ra, $b9fb96103a9b59e3$var$ta);
    $b9fb96103a9b59e3$var$t[b] = new $b9fb96103a9b59e3$var$qa(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($b9fb96103a9b59e3$var$ra, $b9fb96103a9b59e3$var$ta);
    $b9fb96103a9b59e3$var$t[b] = new $b9fb96103a9b59e3$var$qa(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $b9fb96103a9b59e3$var$t[a] = new $b9fb96103a9b59e3$var$qa(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$b9fb96103a9b59e3$var$t.xlinkHref = new $b9fb96103a9b59e3$var$qa("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $b9fb96103a9b59e3$var$t[a] = new $b9fb96103a9b59e3$var$qa(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $b9fb96103a9b59e3$var$ua(a, b, c, d) {
    var e = $b9fb96103a9b59e3$var$t.hasOwnProperty(b) ? $b9fb96103a9b59e3$var$t[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $b9fb96103a9b59e3$var$pa(b, c, e, d) && (c = null), d || null === e ? $b9fb96103a9b59e3$var$na(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $b9fb96103a9b59e3$var$va = $1Mpn7.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $b9fb96103a9b59e3$var$wa = Symbol.for("react.element"), $b9fb96103a9b59e3$var$xa = Symbol.for("react.portal"), $b9fb96103a9b59e3$var$ya = Symbol.for("react.fragment"), $b9fb96103a9b59e3$var$za = Symbol.for("react.strict_mode"), $b9fb96103a9b59e3$var$Aa = Symbol.for("react.profiler"), $b9fb96103a9b59e3$var$Ba = Symbol.for("react.provider"), $b9fb96103a9b59e3$var$Ca = Symbol.for("react.context"), $b9fb96103a9b59e3$var$Da = Symbol.for("react.forward_ref"), $b9fb96103a9b59e3$var$Ea = Symbol.for("react.suspense"), $b9fb96103a9b59e3$var$Fa = Symbol.for("react.suspense_list"), $b9fb96103a9b59e3$var$Ga = Symbol.for("react.memo"), $b9fb96103a9b59e3$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $b9fb96103a9b59e3$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $b9fb96103a9b59e3$var$Ja = Symbol.iterator;
function $b9fb96103a9b59e3$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $b9fb96103a9b59e3$var$Ja && a[$b9fb96103a9b59e3$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $b9fb96103a9b59e3$var$u = Object.assign, $b9fb96103a9b59e3$var$La;
function $b9fb96103a9b59e3$var$Ma(a) {
    if (void 0 === $b9fb96103a9b59e3$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $b9fb96103a9b59e3$var$La = b && b[1] || "";
    }
    return "\n" + $b9fb96103a9b59e3$var$La + a;
}
var $b9fb96103a9b59e3$var$Na = !1;
function $b9fb96103a9b59e3$var$Oa(a, b) {
    if (!a || $b9fb96103a9b59e3$var$Na) return "";
    $b9fb96103a9b59e3$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function b() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function set() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $b9fb96103a9b59e3$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $b9fb96103a9b59e3$var$Ma(a) : "";
}
function $b9fb96103a9b59e3$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $b9fb96103a9b59e3$var$Ma(a.type);
        case 16:
            return $b9fb96103a9b59e3$var$Ma("Lazy");
        case 13:
            return $b9fb96103a9b59e3$var$Ma("Suspense");
        case 19:
            return $b9fb96103a9b59e3$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $b9fb96103a9b59e3$var$Oa(a.type, !1), a;
        case 11:
            return a = $b9fb96103a9b59e3$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $b9fb96103a9b59e3$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $b9fb96103a9b59e3$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $b9fb96103a9b59e3$var$ya:
            return "Fragment";
        case $b9fb96103a9b59e3$var$xa:
            return "Portal";
        case $b9fb96103a9b59e3$var$Aa:
            return "Profiler";
        case $b9fb96103a9b59e3$var$za:
            return "StrictMode";
        case $b9fb96103a9b59e3$var$Ea:
            return "Suspense";
        case $b9fb96103a9b59e3$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $b9fb96103a9b59e3$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $b9fb96103a9b59e3$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $b9fb96103a9b59e3$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $b9fb96103a9b59e3$var$Ga:
            return b = a.displayName || null, null !== b ? b : $b9fb96103a9b59e3$var$Qa(a.type) || "Memo";
        case $b9fb96103a9b59e3$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $b9fb96103a9b59e3$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $b9fb96103a9b59e3$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $b9fb96103a9b59e3$var$Qa(b);
        case 8:
            return b === $b9fb96103a9b59e3$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $b9fb96103a9b59e3$var$Sa(a) {
    switch(typeof a === "undefined" ? "undefined" : (0, $l0HdX._)(a)){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $b9fb96103a9b59e3$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $b9fb96103a9b59e3$var$Ua(a) {
    var b = $b9fb96103a9b59e3$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function get() {
                return e.call(this);
            },
            set: function set(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function getValue() {
                return d;
            },
            setValue: function setValue(a) {
                d = "" + a;
            },
            stopTracking: function stopTracking() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $b9fb96103a9b59e3$var$Va(a) {
    a._valueTracker || (a._valueTracker = $b9fb96103a9b59e3$var$Ua(a));
}
function $b9fb96103a9b59e3$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $b9fb96103a9b59e3$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $b9fb96103a9b59e3$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $b9fb96103a9b59e3$var$Ya(a, b) {
    var c = b.checked;
    return $b9fb96103a9b59e3$var$u({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $b9fb96103a9b59e3$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $b9fb96103a9b59e3$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $b9fb96103a9b59e3$var$$a(a, b) {
    b = b.checked;
    null != b && $b9fb96103a9b59e3$var$ua(a, "checked", b, !1);
}
function $b9fb96103a9b59e3$var$ab(a, b) {
    $b9fb96103a9b59e3$var$$a(a, b);
    var c = $b9fb96103a9b59e3$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $b9fb96103a9b59e3$var$bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $b9fb96103a9b59e3$var$bb(a, b.type, $b9fb96103a9b59e3$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $b9fb96103a9b59e3$var$cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $b9fb96103a9b59e3$var$bb(a, b, c) {
    if ("number" !== b || $b9fb96103a9b59e3$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $b9fb96103a9b59e3$var$db = Array.isArray;
function $b9fb96103a9b59e3$var$eb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $b9fb96103a9b59e3$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $b9fb96103a9b59e3$var$fb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($b9fb96103a9b59e3$var$p(91));
    return $b9fb96103a9b59e3$var$u({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $b9fb96103a9b59e3$var$gb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($b9fb96103a9b59e3$var$p(92));
            if ($b9fb96103a9b59e3$var$db(c)) {
                if (1 < c.length) throw Error($b9fb96103a9b59e3$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $b9fb96103a9b59e3$var$Sa(c)
    };
}
function $b9fb96103a9b59e3$var$hb(a, b) {
    var c = $b9fb96103a9b59e3$var$Sa(b.value), d = $b9fb96103a9b59e3$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $b9fb96103a9b59e3$var$ib(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $b9fb96103a9b59e3$var$jb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $b9fb96103a9b59e3$var$kb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $b9fb96103a9b59e3$var$jb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $b9fb96103a9b59e3$var$lb, $b9fb96103a9b59e3$var$mb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $b9fb96103a9b59e3$var$lb = $b9fb96103a9b59e3$var$lb || document.createElement("div");
        $b9fb96103a9b59e3$var$lb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $b9fb96103a9b59e3$var$lb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $b9fb96103a9b59e3$var$nb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $b9fb96103a9b59e3$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $b9fb96103a9b59e3$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($b9fb96103a9b59e3$var$pb).forEach(function(a) {
    $b9fb96103a9b59e3$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $b9fb96103a9b59e3$var$pb[b] = $b9fb96103a9b59e3$var$pb[a];
    });
});
function $b9fb96103a9b59e3$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $b9fb96103a9b59e3$var$pb.hasOwnProperty(a) && $b9fb96103a9b59e3$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $b9fb96103a9b59e3$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $b9fb96103a9b59e3$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $b9fb96103a9b59e3$var$tb = $b9fb96103a9b59e3$var$u({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $b9fb96103a9b59e3$var$ub(a, b) {
    if (b) {
        if ($b9fb96103a9b59e3$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($b9fb96103a9b59e3$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($b9fb96103a9b59e3$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($b9fb96103a9b59e3$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($b9fb96103a9b59e3$var$p(62));
    }
}
function $b9fb96103a9b59e3$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $b9fb96103a9b59e3$var$wb = null;
function $b9fb96103a9b59e3$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $b9fb96103a9b59e3$var$yb = null, $b9fb96103a9b59e3$var$zb = null, $b9fb96103a9b59e3$var$Ab = null;
function $b9fb96103a9b59e3$var$Bb(a) {
    if (a = $b9fb96103a9b59e3$var$Cb(a)) {
        if ("function" !== typeof $b9fb96103a9b59e3$var$yb) throw Error($b9fb96103a9b59e3$var$p(280));
        var b = a.stateNode;
        b && (b = $b9fb96103a9b59e3$var$Db(b), $b9fb96103a9b59e3$var$yb(a.stateNode, a.type, b));
    }
}
function $b9fb96103a9b59e3$var$Eb(a) {
    $b9fb96103a9b59e3$var$zb ? $b9fb96103a9b59e3$var$Ab ? $b9fb96103a9b59e3$var$Ab.push(a) : $b9fb96103a9b59e3$var$Ab = [
        a
    ] : $b9fb96103a9b59e3$var$zb = a;
}
function $b9fb96103a9b59e3$var$Fb() {
    if ($b9fb96103a9b59e3$var$zb) {
        var a = $b9fb96103a9b59e3$var$zb, b = $b9fb96103a9b59e3$var$Ab;
        $b9fb96103a9b59e3$var$Ab = $b9fb96103a9b59e3$var$zb = null;
        $b9fb96103a9b59e3$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$b9fb96103a9b59e3$var$Bb(b[a]);
    }
}
function $b9fb96103a9b59e3$var$Gb(a, b) {
    return a(b);
}
function $b9fb96103a9b59e3$var$Hb() {}
var $b9fb96103a9b59e3$var$Ib = !1;
function $b9fb96103a9b59e3$var$Jb(a, b, c) {
    if ($b9fb96103a9b59e3$var$Ib) return a(b, c);
    $b9fb96103a9b59e3$var$Ib = !0;
    try {
        return $b9fb96103a9b59e3$var$Gb(a, b, c);
    } finally{
        if ($b9fb96103a9b59e3$var$Ib = !1, null !== $b9fb96103a9b59e3$var$zb || null !== $b9fb96103a9b59e3$var$Ab) $b9fb96103a9b59e3$var$Hb(), $b9fb96103a9b59e3$var$Fb();
    }
}
function $b9fb96103a9b59e3$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $b9fb96103a9b59e3$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($b9fb96103a9b59e3$var$p(231, b, typeof c === "undefined" ? "undefined" : (0, $l0HdX._)(c)));
    return c;
}
var $b9fb96103a9b59e3$var$Lb = !1;
if ($b9fb96103a9b59e3$var$ia) try {
    var $b9fb96103a9b59e3$var$Mb = {};
    Object.defineProperty($b9fb96103a9b59e3$var$Mb, "passive", {
        get: function get() {
            $b9fb96103a9b59e3$var$Lb = !0;
        }
    });
    window.addEventListener("test", $b9fb96103a9b59e3$var$Mb, $b9fb96103a9b59e3$var$Mb);
    window.removeEventListener("test", $b9fb96103a9b59e3$var$Mb, $b9fb96103a9b59e3$var$Mb);
} catch (a) {
    $b9fb96103a9b59e3$var$Lb = !1;
}
function $b9fb96103a9b59e3$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var $b9fb96103a9b59e3$var$Ob = !1, $b9fb96103a9b59e3$var$Pb = null, $b9fb96103a9b59e3$var$Qb = !1, $b9fb96103a9b59e3$var$Rb = null, $b9fb96103a9b59e3$var$Sb = {
    onError: function onError(a) {
        $b9fb96103a9b59e3$var$Ob = !0;
        $b9fb96103a9b59e3$var$Pb = a;
    }
};
function $b9fb96103a9b59e3$var$Tb(a, b, c, d, e, f, g, h, k) {
    $b9fb96103a9b59e3$var$Ob = !1;
    $b9fb96103a9b59e3$var$Pb = null;
    $b9fb96103a9b59e3$var$Nb.apply($b9fb96103a9b59e3$var$Sb, arguments);
}
function $b9fb96103a9b59e3$var$Ub(a, b, c, d, e, f, g, h, k) {
    $b9fb96103a9b59e3$var$Tb.apply(this, arguments);
    if ($b9fb96103a9b59e3$var$Ob) {
        if ($b9fb96103a9b59e3$var$Ob) {
            var l = $b9fb96103a9b59e3$var$Pb;
            $b9fb96103a9b59e3$var$Ob = !1;
            $b9fb96103a9b59e3$var$Pb = null;
        } else throw Error($b9fb96103a9b59e3$var$p(198));
        $b9fb96103a9b59e3$var$Qb || ($b9fb96103a9b59e3$var$Qb = !0, $b9fb96103a9b59e3$var$Rb = l);
    }
}
function $b9fb96103a9b59e3$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b9fb96103a9b59e3$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $b9fb96103a9b59e3$var$Xb(a) {
    if ($b9fb96103a9b59e3$var$Vb(a) !== a) throw Error($b9fb96103a9b59e3$var$p(188));
}
function $b9fb96103a9b59e3$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $b9fb96103a9b59e3$var$Vb(a);
        if (null === b) throw Error($b9fb96103a9b59e3$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $b9fb96103a9b59e3$var$Xb(e), a;
                if (f === d) return $b9fb96103a9b59e3$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($b9fb96103a9b59e3$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($b9fb96103a9b59e3$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($b9fb96103a9b59e3$var$p(190));
    }
    if (3 !== c.tag) throw Error($b9fb96103a9b59e3$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $b9fb96103a9b59e3$var$Zb(a) {
    a = $b9fb96103a9b59e3$var$Yb(a);
    return null !== a ? $b9fb96103a9b59e3$var$$b(a) : null;
}
function $b9fb96103a9b59e3$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b9fb96103a9b59e3$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $b9fb96103a9b59e3$var$ac = $3rCRi.unstable_scheduleCallback, $b9fb96103a9b59e3$var$bc = $3rCRi.unstable_cancelCallback, $b9fb96103a9b59e3$var$cc = $3rCRi.unstable_shouldYield, $b9fb96103a9b59e3$var$dc = $3rCRi.unstable_requestPaint, $b9fb96103a9b59e3$var$A = $3rCRi.unstable_now, $b9fb96103a9b59e3$var$ec = $3rCRi.unstable_getCurrentPriorityLevel, $b9fb96103a9b59e3$var$fc = $3rCRi.unstable_ImmediatePriority, $b9fb96103a9b59e3$var$gc = $3rCRi.unstable_UserBlockingPriority, $b9fb96103a9b59e3$var$hc = $3rCRi.unstable_NormalPriority, $b9fb96103a9b59e3$var$ic = $3rCRi.unstable_LowPriority, $b9fb96103a9b59e3$var$jc = $3rCRi.unstable_IdlePriority, $b9fb96103a9b59e3$var$kc = null, $b9fb96103a9b59e3$var$lc = null, $b9fb96103a9b59e3$var$B = null, $b9fb96103a9b59e3$var$mc = "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__;
function $b9fb96103a9b59e3$var$nc(a, b) {
    if ($b9fb96103a9b59e3$var$lc && "function" === typeof $b9fb96103a9b59e3$var$lc.onCommitFiberRoot) try {
        var c = 128 === (a.current.flags & 128);
        switch(b){
            case 1:
                var d = $b9fb96103a9b59e3$var$fc;
                break;
            case 4:
                d = $b9fb96103a9b59e3$var$gc;
                break;
            case 16:
                d = $b9fb96103a9b59e3$var$hc;
                break;
            case 536870912:
                d = $b9fb96103a9b59e3$var$jc;
                break;
            default:
                d = $b9fb96103a9b59e3$var$hc;
        }
        $b9fb96103a9b59e3$var$lc.onCommitFiberRoot($b9fb96103a9b59e3$var$kc, a, d, c);
    } catch (e) {}
}
function $b9fb96103a9b59e3$var$oc(a) {
    $b9fb96103a9b59e3$var$B = a;
}
function $b9fb96103a9b59e3$var$pc() {
    for(var a = new Map, b = 1, c = 0; 31 > c; c++){
        var d = $b9fb96103a9b59e3$var$qc(b);
        a.set(b, d);
        b *= 2;
    }
    return a;
}
function $b9fb96103a9b59e3$var$rc() {
    null !== $b9fb96103a9b59e3$var$B && "function" === typeof $b9fb96103a9b59e3$var$B.markCommitStopped && $b9fb96103a9b59e3$var$B.markCommitStopped();
}
function $b9fb96103a9b59e3$var$sc(a) {
    null !== $b9fb96103a9b59e3$var$B && "function" === typeof $b9fb96103a9b59e3$var$B.markComponentRenderStarted && $b9fb96103a9b59e3$var$B.markComponentRenderStarted(a);
}
function $b9fb96103a9b59e3$var$tc() {
    null !== $b9fb96103a9b59e3$var$B && "function" === typeof $b9fb96103a9b59e3$var$B.markComponentRenderStopped && $b9fb96103a9b59e3$var$B.markComponentRenderStopped();
}
function $b9fb96103a9b59e3$var$uc(a) {
    null !== $b9fb96103a9b59e3$var$B && "function" === typeof $b9fb96103a9b59e3$var$B.markComponentLayoutEffectUnmountStarted && $b9fb96103a9b59e3$var$B.markComponentLayoutEffectUnmountStarted(a);
}
function $b9fb96103a9b59e3$var$vc() {
    null !== $b9fb96103a9b59e3$var$B && "function" === typeof $b9fb96103a9b59e3$var$B.markComponentLayoutEffectUnmountStopped && $b9fb96103a9b59e3$var$B.markComponentLayoutEffectUnmountStopped();
}
function $b9fb96103a9b59e3$var$wc(a) {
    null !== $b9fb96103a9b59e3$var$B && "function" === typeof $b9fb96103a9b59e3$var$B.markRenderStarted && $b9fb96103a9b59e3$var$B.markRenderStarted(a);
}
function $b9fb96103a9b59e3$var$xc() {
    null !== $b9fb96103a9b59e3$var$B && "function" === typeof $b9fb96103a9b59e3$var$B.markRenderStopped && $b9fb96103a9b59e3$var$B.markRenderStopped();
}
function $b9fb96103a9b59e3$var$yc(a, b) {
    null !== $b9fb96103a9b59e3$var$B && "function" === typeof $b9fb96103a9b59e3$var$B.markStateUpdateScheduled && $b9fb96103a9b59e3$var$B.markStateUpdateScheduled(a, b);
}
var $b9fb96103a9b59e3$var$Ac = Math.clz32 ? Math.clz32 : $b9fb96103a9b59e3$var$zc, $b9fb96103a9b59e3$var$Bc = Math.log, $b9fb96103a9b59e3$var$Cc = Math.LN2;
function $b9fb96103a9b59e3$var$zc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($b9fb96103a9b59e3$var$Bc(a) / $b9fb96103a9b59e3$var$Cc | 0) | 0;
}
function $b9fb96103a9b59e3$var$qc(a) {
    if (a & 1) return "Sync";
    if (a & 2) return "InputContinuousHydration";
    if (a & 4) return "InputContinuous";
    if (a & 8) return "DefaultHydration";
    if (a & 16) return "Default";
    if (a & 32) return "TransitionHydration";
    if (a & 4194240) return "Transition";
    if (a & 130023424) return "Retry";
    if (a & 134217728) return "SelectiveHydration";
    if (a & 268435456) return "IdleHydration";
    if (a & 536870912) return "Idle";
    if (a & 1073741824) return "Offscreen";
}
var $b9fb96103a9b59e3$var$Dc = 64, $b9fb96103a9b59e3$var$Ec = 4194304;
function $b9fb96103a9b59e3$var$Fc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $b9fb96103a9b59e3$var$Gc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $b9fb96103a9b59e3$var$Fc(h) : (f &= g, 0 !== f && (d = $b9fb96103a9b59e3$var$Fc(f)));
    } else g = c & ~e, 0 !== g ? d = $b9fb96103a9b59e3$var$Fc(g) : 0 !== f && (d = $b9fb96103a9b59e3$var$Fc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $b9fb96103a9b59e3$var$Ac(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $b9fb96103a9b59e3$var$Hc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $b9fb96103a9b59e3$var$Ic(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $b9fb96103a9b59e3$var$Ac(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $b9fb96103a9b59e3$var$Hc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $b9fb96103a9b59e3$var$Jc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $b9fb96103a9b59e3$var$Kc() {
    var a = $b9fb96103a9b59e3$var$Dc;
    $b9fb96103a9b59e3$var$Dc <<= 1;
    0 === ($b9fb96103a9b59e3$var$Dc & 4194240) && ($b9fb96103a9b59e3$var$Dc = 64);
    return a;
}
function $b9fb96103a9b59e3$var$Lc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $b9fb96103a9b59e3$var$Mc(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $b9fb96103a9b59e3$var$Ac(b);
    a[b] = c;
}
function $b9fb96103a9b59e3$var$Nc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $b9fb96103a9b59e3$var$Ac(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $b9fb96103a9b59e3$var$Oc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $b9fb96103a9b59e3$var$Ac(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
function $b9fb96103a9b59e3$var$Pc(a, b, c) {
    if ($b9fb96103a9b59e3$var$mc) for(a = a.pendingUpdatersLaneMap; 0 < c;){
        var d = 31 - $b9fb96103a9b59e3$var$Ac(c), e = 1 << d;
        a[d].add(b);
        c &= ~e;
    }
}
function $b9fb96103a9b59e3$var$Qc(a, b) {
    if ($b9fb96103a9b59e3$var$mc) for(var c = a.pendingUpdatersLaneMap, d = a.memoizedUpdaters; 0 < b;){
        var e = 31 - $b9fb96103a9b59e3$var$Ac(b);
        a = 1 << e;
        e = c[e];
        0 < e.size && (e.forEach(function(a) {
            var _$b = a.alternate;
            null !== _$b && d.has(_$b) || d.add(a);
        }), e.clear());
        b &= ~a;
    }
}
var $b9fb96103a9b59e3$var$E = 0;
function $b9fb96103a9b59e3$var$Rc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $b9fb96103a9b59e3$var$Sc, $b9fb96103a9b59e3$var$Tc, $b9fb96103a9b59e3$var$Uc, $b9fb96103a9b59e3$var$Vc, $b9fb96103a9b59e3$var$Wc, $b9fb96103a9b59e3$var$Xc = !1, $b9fb96103a9b59e3$var$Yc = [], $b9fb96103a9b59e3$var$Zc = null, $b9fb96103a9b59e3$var$$c = null, $b9fb96103a9b59e3$var$ad = null, $b9fb96103a9b59e3$var$bd = new Map, $b9fb96103a9b59e3$var$cd = new Map, $b9fb96103a9b59e3$var$dd = [], $b9fb96103a9b59e3$var$ed = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $b9fb96103a9b59e3$var$fd(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $b9fb96103a9b59e3$var$Zc = null;
            break;
        case "dragenter":
        case "dragleave":
            $b9fb96103a9b59e3$var$$c = null;
            break;
        case "mouseover":
        case "mouseout":
            $b9fb96103a9b59e3$var$ad = null;
            break;
        case "pointerover":
        case "pointerout":
            $b9fb96103a9b59e3$var$bd.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $b9fb96103a9b59e3$var$cd.delete(b.pointerId);
    }
}
function $b9fb96103a9b59e3$var$gd(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $b9fb96103a9b59e3$var$Cb(b), null !== b && $b9fb96103a9b59e3$var$Tc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $b9fb96103a9b59e3$var$hd(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $b9fb96103a9b59e3$var$Zc = $b9fb96103a9b59e3$var$gd($b9fb96103a9b59e3$var$Zc, a, b, c, d, e), !0;
        case "dragenter":
            return $b9fb96103a9b59e3$var$$c = $b9fb96103a9b59e3$var$gd($b9fb96103a9b59e3$var$$c, a, b, c, d, e), !0;
        case "mouseover":
            return $b9fb96103a9b59e3$var$ad = $b9fb96103a9b59e3$var$gd($b9fb96103a9b59e3$var$ad, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $b9fb96103a9b59e3$var$bd.set(f, $b9fb96103a9b59e3$var$gd($b9fb96103a9b59e3$var$bd.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $b9fb96103a9b59e3$var$cd.set(f, $b9fb96103a9b59e3$var$gd($b9fb96103a9b59e3$var$cd.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $b9fb96103a9b59e3$var$id(a) {
    var b = $b9fb96103a9b59e3$var$jd(a.target);
    if (null !== b) {
        var c = $b9fb96103a9b59e3$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b9fb96103a9b59e3$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $b9fb96103a9b59e3$var$Wc(a.priority, function() {
                        $b9fb96103a9b59e3$var$Uc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $b9fb96103a9b59e3$var$kd(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $b9fb96103a9b59e3$var$ld(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $b9fb96103a9b59e3$var$wb = d;
            c.target.dispatchEvent(d);
            $b9fb96103a9b59e3$var$wb = null;
        } else return b = $b9fb96103a9b59e3$var$Cb(c), null !== b && $b9fb96103a9b59e3$var$Tc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $b9fb96103a9b59e3$var$md(a, b, c) {
    $b9fb96103a9b59e3$var$kd(a) && c.delete(b);
}
function $b9fb96103a9b59e3$var$nd() {
    $b9fb96103a9b59e3$var$Xc = !1;
    null !== $b9fb96103a9b59e3$var$Zc && $b9fb96103a9b59e3$var$kd($b9fb96103a9b59e3$var$Zc) && ($b9fb96103a9b59e3$var$Zc = null);
    null !== $b9fb96103a9b59e3$var$$c && $b9fb96103a9b59e3$var$kd($b9fb96103a9b59e3$var$$c) && ($b9fb96103a9b59e3$var$$c = null);
    null !== $b9fb96103a9b59e3$var$ad && $b9fb96103a9b59e3$var$kd($b9fb96103a9b59e3$var$ad) && ($b9fb96103a9b59e3$var$ad = null);
    $b9fb96103a9b59e3$var$bd.forEach($b9fb96103a9b59e3$var$md);
    $b9fb96103a9b59e3$var$cd.forEach($b9fb96103a9b59e3$var$md);
}
function $b9fb96103a9b59e3$var$od(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $b9fb96103a9b59e3$var$Xc || ($b9fb96103a9b59e3$var$Xc = !0, $3rCRi.unstable_scheduleCallback($3rCRi.unstable_NormalPriority, $b9fb96103a9b59e3$var$nd)));
}
function $b9fb96103a9b59e3$var$pd(a) {
    function b(b) {
        return $b9fb96103a9b59e3$var$od(b, a);
    }
    if (0 < $b9fb96103a9b59e3$var$Yc.length) {
        $b9fb96103a9b59e3$var$od($b9fb96103a9b59e3$var$Yc[0], a);
        for(var c = 1; c < $b9fb96103a9b59e3$var$Yc.length; c++){
            var d = $b9fb96103a9b59e3$var$Yc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $b9fb96103a9b59e3$var$Zc && $b9fb96103a9b59e3$var$od($b9fb96103a9b59e3$var$Zc, a);
    null !== $b9fb96103a9b59e3$var$$c && $b9fb96103a9b59e3$var$od($b9fb96103a9b59e3$var$$c, a);
    null !== $b9fb96103a9b59e3$var$ad && $b9fb96103a9b59e3$var$od($b9fb96103a9b59e3$var$ad, a);
    $b9fb96103a9b59e3$var$bd.forEach(b);
    $b9fb96103a9b59e3$var$cd.forEach(b);
    for(c = 0; c < $b9fb96103a9b59e3$var$dd.length; c++)d = $b9fb96103a9b59e3$var$dd[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $b9fb96103a9b59e3$var$dd.length && (c = $b9fb96103a9b59e3$var$dd[0], null === c.blockedOn);)$b9fb96103a9b59e3$var$id(c), null === c.blockedOn && $b9fb96103a9b59e3$var$dd.shift();
}
var $b9fb96103a9b59e3$var$qd = $b9fb96103a9b59e3$var$va.ReactCurrentBatchConfig, $b9fb96103a9b59e3$var$rd = !0;
function $b9fb96103a9b59e3$var$sd(a, b, c, d) {
    var e = $b9fb96103a9b59e3$var$E, f = $b9fb96103a9b59e3$var$qd.transition;
    $b9fb96103a9b59e3$var$qd.transition = null;
    try {
        $b9fb96103a9b59e3$var$E = 1, $b9fb96103a9b59e3$var$td(a, b, c, d);
    } finally{
        $b9fb96103a9b59e3$var$E = e, $b9fb96103a9b59e3$var$qd.transition = f;
    }
}
function $b9fb96103a9b59e3$var$ud(a, b, c, d) {
    var e = $b9fb96103a9b59e3$var$E, f = $b9fb96103a9b59e3$var$qd.transition;
    $b9fb96103a9b59e3$var$qd.transition = null;
    try {
        $b9fb96103a9b59e3$var$E = 4, $b9fb96103a9b59e3$var$td(a, b, c, d);
    } finally{
        $b9fb96103a9b59e3$var$E = e, $b9fb96103a9b59e3$var$qd.transition = f;
    }
}
function $b9fb96103a9b59e3$var$td(a, b, c, d) {
    if ($b9fb96103a9b59e3$var$rd) {
        var e = $b9fb96103a9b59e3$var$ld(a, b, c, d);
        if (null === e) $b9fb96103a9b59e3$var$vd(a, b, d, $b9fb96103a9b59e3$var$wd, c), $b9fb96103a9b59e3$var$fd(a, d);
        else if ($b9fb96103a9b59e3$var$hd(e, a, b, c, d)) d.stopPropagation();
        else if ($b9fb96103a9b59e3$var$fd(a, d), b & 4 && -1 < $b9fb96103a9b59e3$var$ed.indexOf(a)) {
            for(; null !== e;){
                var f = $b9fb96103a9b59e3$var$Cb(e);
                null !== f && $b9fb96103a9b59e3$var$Sc(f);
                f = $b9fb96103a9b59e3$var$ld(a, b, c, d);
                null === f && $b9fb96103a9b59e3$var$vd(a, b, d, $b9fb96103a9b59e3$var$wd, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $b9fb96103a9b59e3$var$vd(a, b, d, null, c);
    }
}
var $b9fb96103a9b59e3$var$wd = null;
function $b9fb96103a9b59e3$var$ld(a, b, c, d) {
    $b9fb96103a9b59e3$var$wd = null;
    a = $b9fb96103a9b59e3$var$xb(d);
    a = $b9fb96103a9b59e3$var$jd(a);
    if (null !== a) {
        if (b = $b9fb96103a9b59e3$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $b9fb96103a9b59e3$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $b9fb96103a9b59e3$var$wd = a;
    return null;
}
function $b9fb96103a9b59e3$var$xd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($b9fb96103a9b59e3$var$ec()){
                case $b9fb96103a9b59e3$var$fc:
                    return 1;
                case $b9fb96103a9b59e3$var$gc:
                    return 4;
                case $b9fb96103a9b59e3$var$hc:
                case $b9fb96103a9b59e3$var$ic:
                    return 16;
                case $b9fb96103a9b59e3$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $b9fb96103a9b59e3$var$yd = null, $b9fb96103a9b59e3$var$zd = null, $b9fb96103a9b59e3$var$Ad = null;
function $b9fb96103a9b59e3$var$Bd() {
    if ($b9fb96103a9b59e3$var$Ad) return $b9fb96103a9b59e3$var$Ad;
    var a, b = $b9fb96103a9b59e3$var$zd, c = b.length, d, e = "value" in $b9fb96103a9b59e3$var$yd ? $b9fb96103a9b59e3$var$yd.value : $b9fb96103a9b59e3$var$yd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $b9fb96103a9b59e3$var$Ad = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $b9fb96103a9b59e3$var$Cd(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $b9fb96103a9b59e3$var$Dd() {
    return !0;
}
function $b9fb96103a9b59e3$var$Ed() {
    return !1;
}
function $b9fb96103a9b59e3$var$Fd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $b9fb96103a9b59e3$var$Dd : $b9fb96103a9b59e3$var$Ed;
        this.isPropagationStopped = $b9fb96103a9b59e3$var$Ed;
        return this;
    }
    $b9fb96103a9b59e3$var$u(b.prototype, {
        preventDefault: function preventDefault() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== (0, $l0HdX._)(a.returnValue) && (a.returnValue = !1), this.isDefaultPrevented = $b9fb96103a9b59e3$var$Dd);
        },
        stopPropagation: function stopPropagation() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== (0, $l0HdX._)(a.cancelBubble) && (a.cancelBubble = !0), this.isPropagationStopped = $b9fb96103a9b59e3$var$Dd);
        },
        persist: function persist() {},
        isPersistent: $b9fb96103a9b59e3$var$Dd
    });
    return b;
}
var $b9fb96103a9b59e3$var$Gd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function timeStamp(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $b9fb96103a9b59e3$var$Hd = $b9fb96103a9b59e3$var$Fd($b9fb96103a9b59e3$var$Gd), $b9fb96103a9b59e3$var$Id = $b9fb96103a9b59e3$var$u({}, $b9fb96103a9b59e3$var$Gd, {
    view: 0,
    detail: 0
}), $b9fb96103a9b59e3$var$Jd = $b9fb96103a9b59e3$var$Fd($b9fb96103a9b59e3$var$Id), $b9fb96103a9b59e3$var$Kd, $b9fb96103a9b59e3$var$Ld, $b9fb96103a9b59e3$var$Md, $b9fb96103a9b59e3$var$Od = $b9fb96103a9b59e3$var$u({}, $b9fb96103a9b59e3$var$Id, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $b9fb96103a9b59e3$var$Nd,
    button: 0,
    buttons: 0,
    relatedTarget: function relatedTarget(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function movementX(a) {
        if ("movementX" in a) return a.movementX;
        a !== $b9fb96103a9b59e3$var$Md && ($b9fb96103a9b59e3$var$Md && "mousemove" === a.type ? ($b9fb96103a9b59e3$var$Kd = a.screenX - $b9fb96103a9b59e3$var$Md.screenX, $b9fb96103a9b59e3$var$Ld = a.screenY - $b9fb96103a9b59e3$var$Md.screenY) : $b9fb96103a9b59e3$var$Ld = $b9fb96103a9b59e3$var$Kd = 0, $b9fb96103a9b59e3$var$Md = a);
        return $b9fb96103a9b59e3$var$Kd;
    },
    movementY: function movementY(a) {
        return "movementY" in a ? a.movementY : $b9fb96103a9b59e3$var$Ld;
    }
}), $b9fb96103a9b59e3$var$Pd = $b9fb96103a9b59e3$var$Fd($b9fb96103a9b59e3$var$Od), $b9fb96103a9b59e3$var$Qd = $b9fb96103a9b59e3$var$u({}, $b9fb96103a9b59e3$var$Od, {
    dataTransfer: 0
}), $b9fb96103a9b59e3$var$Rd = $b9fb96103a9b59e3$var$Fd($b9fb96103a9b59e3$var$Qd), $b9fb96103a9b59e3$var$Sd = $b9fb96103a9b59e3$var$u({}, $b9fb96103a9b59e3$var$Id, {
    relatedTarget: 0
}), $b9fb96103a9b59e3$var$Td = $b9fb96103a9b59e3$var$Fd($b9fb96103a9b59e3$var$Sd), $b9fb96103a9b59e3$var$Ud = $b9fb96103a9b59e3$var$u({}, $b9fb96103a9b59e3$var$Gd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b9fb96103a9b59e3$var$Vd = $b9fb96103a9b59e3$var$Fd($b9fb96103a9b59e3$var$Ud), $b9fb96103a9b59e3$var$Wd = $b9fb96103a9b59e3$var$u({}, $b9fb96103a9b59e3$var$Gd, {
    clipboardData: function clipboardData(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $b9fb96103a9b59e3$var$Xd = $b9fb96103a9b59e3$var$Fd($b9fb96103a9b59e3$var$Wd), $b9fb96103a9b59e3$var$Yd = $b9fb96103a9b59e3$var$u({}, $b9fb96103a9b59e3$var$Gd, {
    data: 0
}), $b9fb96103a9b59e3$var$Zd = $b9fb96103a9b59e3$var$Fd($b9fb96103a9b59e3$var$Yd), $b9fb96103a9b59e3$var$$d = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $b9fb96103a9b59e3$var$ae = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $b9fb96103a9b59e3$var$be = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $b9fb96103a9b59e3$var$ce(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $b9fb96103a9b59e3$var$be[a]) ? !!b[a] : !1;
}
function $b9fb96103a9b59e3$var$Nd() {
    return $b9fb96103a9b59e3$var$ce;
}
var $b9fb96103a9b59e3$var$de = $b9fb96103a9b59e3$var$u({}, $b9fb96103a9b59e3$var$Id, {
    key: function key(a) {
        if (a.key) {
            var b = $b9fb96103a9b59e3$var$$d[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $b9fb96103a9b59e3$var$Cd(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $b9fb96103a9b59e3$var$ae[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $b9fb96103a9b59e3$var$Nd,
    charCode: function charCode(a) {
        return "keypress" === a.type ? $b9fb96103a9b59e3$var$Cd(a) : 0;
    },
    keyCode: function keyCode(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function which(a) {
        return "keypress" === a.type ? $b9fb96103a9b59e3$var$Cd(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $b9fb96103a9b59e3$var$ee = $b9fb96103a9b59e3$var$Fd($b9fb96103a9b59e3$var$de), $b9fb96103a9b59e3$var$fe = $b9fb96103a9b59e3$var$u({}, $b9fb96103a9b59e3$var$Od, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $b9fb96103a9b59e3$var$ge = $b9fb96103a9b59e3$var$Fd($b9fb96103a9b59e3$var$fe), $b9fb96103a9b59e3$var$he = $b9fb96103a9b59e3$var$u({}, $b9fb96103a9b59e3$var$Id, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $b9fb96103a9b59e3$var$Nd
}), $b9fb96103a9b59e3$var$ie = $b9fb96103a9b59e3$var$Fd($b9fb96103a9b59e3$var$he), $b9fb96103a9b59e3$var$je = $b9fb96103a9b59e3$var$u({}, $b9fb96103a9b59e3$var$Gd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b9fb96103a9b59e3$var$ke = $b9fb96103a9b59e3$var$Fd($b9fb96103a9b59e3$var$je), $b9fb96103a9b59e3$var$le = $b9fb96103a9b59e3$var$u({}, $b9fb96103a9b59e3$var$Od, {
    deltaX: function deltaX(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function deltaY(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $b9fb96103a9b59e3$var$me = $b9fb96103a9b59e3$var$Fd($b9fb96103a9b59e3$var$le), $b9fb96103a9b59e3$var$ne = [
    9,
    13,
    27,
    32
], $b9fb96103a9b59e3$var$oe = $b9fb96103a9b59e3$var$ia && "CompositionEvent" in window, $b9fb96103a9b59e3$var$pe = null;
$b9fb96103a9b59e3$var$ia && "documentMode" in document && ($b9fb96103a9b59e3$var$pe = document.documentMode);
var $b9fb96103a9b59e3$var$qe = $b9fb96103a9b59e3$var$ia && "TextEvent" in window && !$b9fb96103a9b59e3$var$pe, $b9fb96103a9b59e3$var$re = $b9fb96103a9b59e3$var$ia && (!$b9fb96103a9b59e3$var$oe || $b9fb96103a9b59e3$var$pe && 8 < $b9fb96103a9b59e3$var$pe && 11 >= $b9fb96103a9b59e3$var$pe), $b9fb96103a9b59e3$var$se = String.fromCharCode(32), $b9fb96103a9b59e3$var$te = !1;
function $b9fb96103a9b59e3$var$ue(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $b9fb96103a9b59e3$var$ne.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $b9fb96103a9b59e3$var$ve(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $b9fb96103a9b59e3$var$we = !1;
function $b9fb96103a9b59e3$var$xe(a, b) {
    switch(a){
        case "compositionend":
            return $b9fb96103a9b59e3$var$ve(b);
        case "keypress":
            if (32 !== b.which) return null;
            $b9fb96103a9b59e3$var$te = !0;
            return $b9fb96103a9b59e3$var$se;
        case "textInput":
            return a = b.data, a === $b9fb96103a9b59e3$var$se && $b9fb96103a9b59e3$var$te ? null : a;
        default:
            return null;
    }
}
function $b9fb96103a9b59e3$var$ye(a, b) {
    if ($b9fb96103a9b59e3$var$we) return "compositionend" === a || !$b9fb96103a9b59e3$var$oe && $b9fb96103a9b59e3$var$ue(a, b) ? (a = $b9fb96103a9b59e3$var$Bd(), $b9fb96103a9b59e3$var$Ad = $b9fb96103a9b59e3$var$zd = $b9fb96103a9b59e3$var$yd = null, $b9fb96103a9b59e3$var$we = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $b9fb96103a9b59e3$var$re && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $b9fb96103a9b59e3$var$ze = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $b9fb96103a9b59e3$var$Ae(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$b9fb96103a9b59e3$var$ze[a.type] : "textarea" === b ? !0 : !1;
}
function $b9fb96103a9b59e3$var$Be(a, b, c, d) {
    $b9fb96103a9b59e3$var$Eb(d);
    b = $b9fb96103a9b59e3$var$Ce(b, "onChange");
    0 < b.length && (c = new $b9fb96103a9b59e3$var$Hd("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $b9fb96103a9b59e3$var$De = null, $b9fb96103a9b59e3$var$Ee = null;
function $b9fb96103a9b59e3$var$Fe(a) {
    $b9fb96103a9b59e3$var$Ge(a, 0);
}
function $b9fb96103a9b59e3$var$He(a) {
    var b = $b9fb96103a9b59e3$var$Ie(a);
    if ($b9fb96103a9b59e3$var$Wa(b)) return a;
}
function $b9fb96103a9b59e3$var$Je(a, b) {
    if ("change" === a) return b;
}
var $b9fb96103a9b59e3$var$Ke = !1;
if ($b9fb96103a9b59e3$var$ia) {
    var $b9fb96103a9b59e3$var$Le;
    if ($b9fb96103a9b59e3$var$ia) {
        var $b9fb96103a9b59e3$var$Me = "oninput" in document;
        if (!$b9fb96103a9b59e3$var$Me) {
            var $b9fb96103a9b59e3$var$Ne = document.createElement("div");
            $b9fb96103a9b59e3$var$Ne.setAttribute("oninput", "return;");
            $b9fb96103a9b59e3$var$Me = "function" === typeof $b9fb96103a9b59e3$var$Ne.oninput;
        }
        $b9fb96103a9b59e3$var$Le = $b9fb96103a9b59e3$var$Me;
    } else $b9fb96103a9b59e3$var$Le = !1;
    $b9fb96103a9b59e3$var$Ke = $b9fb96103a9b59e3$var$Le && (!document.documentMode || 9 < document.documentMode);
}
function $b9fb96103a9b59e3$var$Oe() {
    $b9fb96103a9b59e3$var$De && ($b9fb96103a9b59e3$var$De.detachEvent("onpropertychange", $b9fb96103a9b59e3$var$Pe), $b9fb96103a9b59e3$var$Ee = $b9fb96103a9b59e3$var$De = null);
}
function $b9fb96103a9b59e3$var$Pe(a) {
    if ("value" === a.propertyName && $b9fb96103a9b59e3$var$He($b9fb96103a9b59e3$var$Ee)) {
        var b = [];
        $b9fb96103a9b59e3$var$Be(b, $b9fb96103a9b59e3$var$Ee, a, $b9fb96103a9b59e3$var$xb(a));
        $b9fb96103a9b59e3$var$Jb($b9fb96103a9b59e3$var$Fe, b);
    }
}
function $b9fb96103a9b59e3$var$Qe(a, b, c) {
    "focusin" === a ? ($b9fb96103a9b59e3$var$Oe(), $b9fb96103a9b59e3$var$De = b, $b9fb96103a9b59e3$var$Ee = c, $b9fb96103a9b59e3$var$De.attachEvent("onpropertychange", $b9fb96103a9b59e3$var$Pe)) : "focusout" === a && $b9fb96103a9b59e3$var$Oe();
}
function $b9fb96103a9b59e3$var$Re(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $b9fb96103a9b59e3$var$He($b9fb96103a9b59e3$var$Ee);
}
function $b9fb96103a9b59e3$var$Se(a, b) {
    if ("click" === a) return $b9fb96103a9b59e3$var$He(b);
}
function $b9fb96103a9b59e3$var$Te(a, b) {
    if ("input" === a || "change" === a) return $b9fb96103a9b59e3$var$He(b);
}
function $b9fb96103a9b59e3$var$Ue(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $b9fb96103a9b59e3$var$Ve = "function" === typeof Object.is ? Object.is : $b9fb96103a9b59e3$var$Ue;
function $b9fb96103a9b59e3$var$We(a, b) {
    if ($b9fb96103a9b59e3$var$Ve(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$b9fb96103a9b59e3$var$ja.call(b, e) || !$b9fb96103a9b59e3$var$Ve(a[e], b[e])) return !1;
    }
    return !0;
}
function $b9fb96103a9b59e3$var$Xe(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $b9fb96103a9b59e3$var$Ye(a, b) {
    var c = $b9fb96103a9b59e3$var$Xe(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $b9fb96103a9b59e3$var$Xe(c);
    }
}
function $b9fb96103a9b59e3$var$Ze(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $b9fb96103a9b59e3$var$Ze(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $b9fb96103a9b59e3$var$$e() {
    for(var a = window, b = $b9fb96103a9b59e3$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $b9fb96103a9b59e3$var$Xa(a.document);
    }
    return b;
}
function $b9fb96103a9b59e3$var$af(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $b9fb96103a9b59e3$var$bf(a) {
    var b = $b9fb96103a9b59e3$var$$e(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $b9fb96103a9b59e3$var$Ze(c.ownerDocument.documentElement, c)) {
        if (null !== d && $b9fb96103a9b59e3$var$af(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $b9fb96103a9b59e3$var$Ye(c, f);
                var g = $b9fb96103a9b59e3$var$Ye(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $b9fb96103a9b59e3$var$cf = $b9fb96103a9b59e3$var$ia && "documentMode" in document && 11 >= document.documentMode, $b9fb96103a9b59e3$var$df = null, $b9fb96103a9b59e3$var$ef = null, $b9fb96103a9b59e3$var$ff = null, $b9fb96103a9b59e3$var$gf = !1;
function $b9fb96103a9b59e3$var$hf(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $b9fb96103a9b59e3$var$gf || null == $b9fb96103a9b59e3$var$df || $b9fb96103a9b59e3$var$df !== $b9fb96103a9b59e3$var$Xa(d) || (d = $b9fb96103a9b59e3$var$df, "selectionStart" in d && $b9fb96103a9b59e3$var$af(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $b9fb96103a9b59e3$var$ff && $b9fb96103a9b59e3$var$We($b9fb96103a9b59e3$var$ff, d) || ($b9fb96103a9b59e3$var$ff = d, d = $b9fb96103a9b59e3$var$Ce($b9fb96103a9b59e3$var$ef, "onSelect"), 0 < d.length && (b = new $b9fb96103a9b59e3$var$Hd("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $b9fb96103a9b59e3$var$df)));
}
function $b9fb96103a9b59e3$var$jf(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $b9fb96103a9b59e3$var$kf = {
    animationend: $b9fb96103a9b59e3$var$jf("Animation", "AnimationEnd"),
    animationiteration: $b9fb96103a9b59e3$var$jf("Animation", "AnimationIteration"),
    animationstart: $b9fb96103a9b59e3$var$jf("Animation", "AnimationStart"),
    transitionend: $b9fb96103a9b59e3$var$jf("Transition", "TransitionEnd")
}, $b9fb96103a9b59e3$var$lf = {}, $b9fb96103a9b59e3$var$mf = {};
$b9fb96103a9b59e3$var$ia && ($b9fb96103a9b59e3$var$mf = document.createElement("div").style, "AnimationEvent" in window || (delete $b9fb96103a9b59e3$var$kf.animationend.animation, delete $b9fb96103a9b59e3$var$kf.animationiteration.animation, delete $b9fb96103a9b59e3$var$kf.animationstart.animation), "TransitionEvent" in window || delete $b9fb96103a9b59e3$var$kf.transitionend.transition);
function $b9fb96103a9b59e3$var$nf(a) {
    if ($b9fb96103a9b59e3$var$lf[a]) return $b9fb96103a9b59e3$var$lf[a];
    if (!$b9fb96103a9b59e3$var$kf[a]) return a;
    var b = $b9fb96103a9b59e3$var$kf[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $b9fb96103a9b59e3$var$mf) return $b9fb96103a9b59e3$var$lf[a] = b[c];
    return a;
}
var $b9fb96103a9b59e3$var$of = $b9fb96103a9b59e3$var$nf("animationend"), $b9fb96103a9b59e3$var$pf = $b9fb96103a9b59e3$var$nf("animationiteration"), $b9fb96103a9b59e3$var$qf = $b9fb96103a9b59e3$var$nf("animationstart"), $b9fb96103a9b59e3$var$rf = $b9fb96103a9b59e3$var$nf("transitionend"), $b9fb96103a9b59e3$var$sf = new Map, $b9fb96103a9b59e3$var$tf = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $b9fb96103a9b59e3$var$uf(a, b) {
    $b9fb96103a9b59e3$var$sf.set(a, b);
    $b9fb96103a9b59e3$var$fa(b, [
        a
    ]);
}
for(var $b9fb96103a9b59e3$var$vf = 0; $b9fb96103a9b59e3$var$vf < $b9fb96103a9b59e3$var$tf.length; $b9fb96103a9b59e3$var$vf++){
    var $b9fb96103a9b59e3$var$wf = $b9fb96103a9b59e3$var$tf[$b9fb96103a9b59e3$var$vf], $b9fb96103a9b59e3$var$xf = $b9fb96103a9b59e3$var$wf.toLowerCase(), $b9fb96103a9b59e3$var$yf = $b9fb96103a9b59e3$var$wf[0].toUpperCase() + $b9fb96103a9b59e3$var$wf.slice(1);
    $b9fb96103a9b59e3$var$uf($b9fb96103a9b59e3$var$xf, "on" + $b9fb96103a9b59e3$var$yf);
}
$b9fb96103a9b59e3$var$uf($b9fb96103a9b59e3$var$of, "onAnimationEnd");
$b9fb96103a9b59e3$var$uf($b9fb96103a9b59e3$var$pf, "onAnimationIteration");
$b9fb96103a9b59e3$var$uf($b9fb96103a9b59e3$var$qf, "onAnimationStart");
$b9fb96103a9b59e3$var$uf("dblclick", "onDoubleClick");
$b9fb96103a9b59e3$var$uf("focusin", "onFocus");
$b9fb96103a9b59e3$var$uf("focusout", "onBlur");
$b9fb96103a9b59e3$var$uf($b9fb96103a9b59e3$var$rf, "onTransitionEnd");
$b9fb96103a9b59e3$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$b9fb96103a9b59e3$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$b9fb96103a9b59e3$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$b9fb96103a9b59e3$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$b9fb96103a9b59e3$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$b9fb96103a9b59e3$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$b9fb96103a9b59e3$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$b9fb96103a9b59e3$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$b9fb96103a9b59e3$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$b9fb96103a9b59e3$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $b9fb96103a9b59e3$var$zf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $b9fb96103a9b59e3$var$Af = new Set("cancel close invalid load scroll toggle".split(" ").concat($b9fb96103a9b59e3$var$zf));
function $b9fb96103a9b59e3$var$Bf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $b9fb96103a9b59e3$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $b9fb96103a9b59e3$var$Ge(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b9fb96103a9b59e3$var$Bf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b9fb96103a9b59e3$var$Bf(e, h, l);
                f = k;
            }
        }
    }
    if ($b9fb96103a9b59e3$var$Qb) throw a = $b9fb96103a9b59e3$var$Rb, $b9fb96103a9b59e3$var$Qb = !1, $b9fb96103a9b59e3$var$Rb = null, a;
}
function $b9fb96103a9b59e3$var$F(a, b) {
    var c = b[$b9fb96103a9b59e3$var$Cf];
    void 0 === c && (c = b[$b9fb96103a9b59e3$var$Cf] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($b9fb96103a9b59e3$var$Df(b, a, 2, !1), c.add(d));
}
function $b9fb96103a9b59e3$var$Ef(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $b9fb96103a9b59e3$var$Df(c, a, d, b);
}
var $b9fb96103a9b59e3$var$Ff = "_reactListening" + Math.random().toString(36).slice(2);
function $b9fb96103a9b59e3$var$Gf(a) {
    if (!a[$b9fb96103a9b59e3$var$Ff]) {
        a[$b9fb96103a9b59e3$var$Ff] = !0;
        $b9fb96103a9b59e3$var$da.forEach(function(b) {
            "selectionchange" !== b && ($b9fb96103a9b59e3$var$Af.has(b) || $b9fb96103a9b59e3$var$Ef(b, !1, a), $b9fb96103a9b59e3$var$Ef(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$b9fb96103a9b59e3$var$Ff] || (b[$b9fb96103a9b59e3$var$Ff] = !0, $b9fb96103a9b59e3$var$Ef("selectionchange", !1, b));
    }
}
function $b9fb96103a9b59e3$var$Df(a, b, c, d) {
    switch($b9fb96103a9b59e3$var$xd(b)){
        case 1:
            var e = $b9fb96103a9b59e3$var$sd;
            break;
        case 4:
            e = $b9fb96103a9b59e3$var$ud;
            break;
        default:
            e = $b9fb96103a9b59e3$var$td;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$b9fb96103a9b59e3$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $b9fb96103a9b59e3$var$vd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $b9fb96103a9b59e3$var$jd(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $b9fb96103a9b59e3$var$Jb(function() {
        var _$d = f, _$e = $b9fb96103a9b59e3$var$xb(c), g = [];
        a: {
            var h = $b9fb96103a9b59e3$var$sf.get(a);
            if (void 0 !== h) {
                var k = $b9fb96103a9b59e3$var$Hd, m = a;
                switch(a){
                    case "keypress":
                        if (0 === $b9fb96103a9b59e3$var$Cd(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $b9fb96103a9b59e3$var$ee;
                        break;
                    case "focusin":
                        m = "focus";
                        k = $b9fb96103a9b59e3$var$Td;
                        break;
                    case "focusout":
                        m = "blur";
                        k = $b9fb96103a9b59e3$var$Td;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $b9fb96103a9b59e3$var$Td;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $b9fb96103a9b59e3$var$Pd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $b9fb96103a9b59e3$var$Rd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $b9fb96103a9b59e3$var$ie;
                        break;
                    case $b9fb96103a9b59e3$var$of:
                    case $b9fb96103a9b59e3$var$pf:
                    case $b9fb96103a9b59e3$var$qf:
                        k = $b9fb96103a9b59e3$var$Vd;
                        break;
                    case $b9fb96103a9b59e3$var$rf:
                        k = $b9fb96103a9b59e3$var$ke;
                        break;
                    case "scroll":
                        k = $b9fb96103a9b59e3$var$Jd;
                        break;
                    case "wheel":
                        k = $b9fb96103a9b59e3$var$me;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $b9fb96103a9b59e3$var$Xd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $b9fb96103a9b59e3$var$ge;
                }
                var w = 0 !== (b & 4), C = !w && "scroll" === a, x = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var y = _$d, v; null !== y;){
                    v = y;
                    var D = v.stateNode;
                    5 === v.tag && null !== D && (v = D, null !== x && (D = $b9fb96103a9b59e3$var$Kb(y, x), null != D && w.push($b9fb96103a9b59e3$var$Hf(y, D, v))));
                    if (C) break;
                    y = y.return;
                }
                0 < w.length && (h = new k(h, m, null, c, _$e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $b9fb96103a9b59e3$var$wb && (m = c.relatedTarget || c.fromElement) && ($b9fb96103a9b59e3$var$jd(m) || m[$b9fb96103a9b59e3$var$If])) break a;
                if (k || h) {
                    h = _$e.window === _$e ? _$e : (h = _$e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (m = c.relatedTarget || c.toElement, k = _$d, m = m ? $b9fb96103a9b59e3$var$jd(m) : null, null !== m && (C = $b9fb96103a9b59e3$var$Vb(m), m !== C || 5 !== m.tag && 6 !== m.tag)) m = null;
                    } else k = null, m = _$d;
                    if (k !== m) {
                        w = $b9fb96103a9b59e3$var$Pd;
                        D = "onMouseLeave";
                        x = "onMouseEnter";
                        y = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = $b9fb96103a9b59e3$var$ge, D = "onPointerLeave", x = "onPointerEnter", y = "pointer";
                        C = null == k ? h : $b9fb96103a9b59e3$var$Ie(k);
                        v = null == m ? h : $b9fb96103a9b59e3$var$Ie(m);
                        h = new w(D, y + "leave", k, c, _$e);
                        h.target = C;
                        h.relatedTarget = v;
                        D = null;
                        $b9fb96103a9b59e3$var$jd(_$e) === _$d && (w = new w(x, y + "enter", m, c, _$e), w.target = v, w.relatedTarget = C, D = w);
                        C = D;
                        if (k && m) b: {
                            w = k;
                            x = m;
                            y = 0;
                            for(v = w; v; v = $b9fb96103a9b59e3$var$Jf(v))y++;
                            v = 0;
                            for(D = x; D; D = $b9fb96103a9b59e3$var$Jf(D))v++;
                            for(; 0 < y - v;)w = $b9fb96103a9b59e3$var$Jf(w), y--;
                            for(; 0 < v - y;)x = $b9fb96103a9b59e3$var$Jf(x), v--;
                            for(; y--;){
                                if (w === x || null !== x && w === x.alternate) break b;
                                w = $b9fb96103a9b59e3$var$Jf(w);
                                x = $b9fb96103a9b59e3$var$Jf(x);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && $b9fb96103a9b59e3$var$Kf(g, h, k, w, !1);
                        null !== m && null !== C && $b9fb96103a9b59e3$var$Kf(g, C, m, w, !0);
                    }
                }
            }
            a: {
                h = _$d ? $b9fb96103a9b59e3$var$Ie(_$d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var ca = $b9fb96103a9b59e3$var$Je;
                else if ($b9fb96103a9b59e3$var$Ae(h)) {
                    if ($b9fb96103a9b59e3$var$Ke) ca = $b9fb96103a9b59e3$var$Te;
                    else {
                        ca = $b9fb96103a9b59e3$var$Re;
                        var R = $b9fb96103a9b59e3$var$Qe;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (ca = $b9fb96103a9b59e3$var$Se);
                if (ca && (ca = ca(a, _$d))) {
                    $b9fb96103a9b59e3$var$Be(g, ca, c, _$e);
                    break a;
                }
                R && R(a, h, _$d);
                "focusout" === a && (R = h._wrapperState) && R.controlled && "number" === h.type && $b9fb96103a9b59e3$var$bb(h, "number", h.value);
            }
            R = _$d ? $b9fb96103a9b59e3$var$Ie(_$d) : window;
            switch(a){
                case "focusin":
                    if ($b9fb96103a9b59e3$var$Ae(R) || "true" === R.contentEditable) $b9fb96103a9b59e3$var$df = R, $b9fb96103a9b59e3$var$ef = _$d, $b9fb96103a9b59e3$var$ff = null;
                    break;
                case "focusout":
                    $b9fb96103a9b59e3$var$ff = $b9fb96103a9b59e3$var$ef = $b9fb96103a9b59e3$var$df = null;
                    break;
                case "mousedown":
                    $b9fb96103a9b59e3$var$gf = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $b9fb96103a9b59e3$var$gf = !1;
                    $b9fb96103a9b59e3$var$hf(g, c, _$e);
                    break;
                case "selectionchange":
                    if ($b9fb96103a9b59e3$var$cf) break;
                case "keydown":
                case "keyup":
                    $b9fb96103a9b59e3$var$hf(g, c, _$e);
            }
            var sa;
            if ($b9fb96103a9b59e3$var$oe) b: {
                switch(a){
                    case "compositionstart":
                        var V = "onCompositionStart";
                        break b;
                    case "compositionend":
                        V = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        V = "onCompositionUpdate";
                        break b;
                }
                V = void 0;
            }
            else $b9fb96103a9b59e3$var$we ? $b9fb96103a9b59e3$var$ue(a, c) && (V = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (V = "onCompositionStart");
            V && ($b9fb96103a9b59e3$var$re && "ko" !== c.locale && ($b9fb96103a9b59e3$var$we || "onCompositionStart" !== V ? "onCompositionEnd" === V && $b9fb96103a9b59e3$var$we && (sa = $b9fb96103a9b59e3$var$Bd()) : ($b9fb96103a9b59e3$var$yd = _$e, $b9fb96103a9b59e3$var$zd = "value" in $b9fb96103a9b59e3$var$yd ? $b9fb96103a9b59e3$var$yd.value : $b9fb96103a9b59e3$var$yd.textContent, $b9fb96103a9b59e3$var$we = !0)), R = $b9fb96103a9b59e3$var$Ce(_$d, V), 0 < R.length && (V = new $b9fb96103a9b59e3$var$Zd(V, a, null, c, _$e), g.push({
                event: V,
                listeners: R
            }), sa ? V.data = sa : (sa = $b9fb96103a9b59e3$var$ve(c), null !== sa && (V.data = sa))));
            if (sa = $b9fb96103a9b59e3$var$qe ? $b9fb96103a9b59e3$var$xe(a, c) : $b9fb96103a9b59e3$var$ye(a, c)) _$d = $b9fb96103a9b59e3$var$Ce(_$d, "onBeforeInput"), 0 < _$d.length && (_$e = new $b9fb96103a9b59e3$var$Zd("onBeforeInput", "beforeinput", null, c, _$e), g.push({
                event: _$e,
                listeners: _$d
            }), _$e.data = sa);
        }
        $b9fb96103a9b59e3$var$Ge(g, b);
    });
}
function $b9fb96103a9b59e3$var$Hf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $b9fb96103a9b59e3$var$Ce(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $b9fb96103a9b59e3$var$Kb(a, c), null != f && d.unshift($b9fb96103a9b59e3$var$Hf(a, f, e)), f = $b9fb96103a9b59e3$var$Kb(a, b), null != f && d.push($b9fb96103a9b59e3$var$Hf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $b9fb96103a9b59e3$var$Jf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $b9fb96103a9b59e3$var$Kf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $b9fb96103a9b59e3$var$Kb(c, f), null != k && g.unshift($b9fb96103a9b59e3$var$Hf(c, k, h))) : e || (k = $b9fb96103a9b59e3$var$Kb(c, f), null != k && g.push($b9fb96103a9b59e3$var$Hf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $b9fb96103a9b59e3$var$Lf = /\r\n?/g, $b9fb96103a9b59e3$var$Mf = /\u0000|\uFFFD/g;
function $b9fb96103a9b59e3$var$Nf(a) {
    return ("string" === typeof a ? a : "" + a).replace($b9fb96103a9b59e3$var$Lf, "\n").replace($b9fb96103a9b59e3$var$Mf, "");
}
function $b9fb96103a9b59e3$var$Of(a, b, c) {
    b = $b9fb96103a9b59e3$var$Nf(b);
    if ($b9fb96103a9b59e3$var$Nf(a) !== b && c) throw Error($b9fb96103a9b59e3$var$p(425));
}
function $b9fb96103a9b59e3$var$Pf() {}
var $b9fb96103a9b59e3$var$Qf = null, $b9fb96103a9b59e3$var$Rf = null;
function $b9fb96103a9b59e3$var$Sf(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $b9fb96103a9b59e3$var$Tf = "function" === typeof setTimeout ? setTimeout : void 0, $b9fb96103a9b59e3$var$Uf = "function" === typeof clearTimeout ? clearTimeout : void 0, $b9fb96103a9b59e3$var$Vf = "function" === typeof Promise ? Promise : void 0, $b9fb96103a9b59e3$var$Xf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $b9fb96103a9b59e3$var$Vf ? function Xf(a) {
    return $b9fb96103a9b59e3$var$Vf.resolve(null).then(a).catch($b9fb96103a9b59e3$var$Wf);
} : $b9fb96103a9b59e3$var$Tf;
function $b9fb96103a9b59e3$var$Wf(a) {
    setTimeout(function() {
        throw a;
    });
}
function $b9fb96103a9b59e3$var$Yf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $b9fb96103a9b59e3$var$pd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $b9fb96103a9b59e3$var$pd(b);
}
function $b9fb96103a9b59e3$var$Zf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $b9fb96103a9b59e3$var$$f(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $b9fb96103a9b59e3$var$ag = Math.random().toString(36).slice(2), $b9fb96103a9b59e3$var$bg = "__reactFiber$" + $b9fb96103a9b59e3$var$ag, $b9fb96103a9b59e3$var$cg = "__reactProps$" + $b9fb96103a9b59e3$var$ag, $b9fb96103a9b59e3$var$If = "__reactContainer$" + $b9fb96103a9b59e3$var$ag, $b9fb96103a9b59e3$var$Cf = "__reactEvents$" + $b9fb96103a9b59e3$var$ag, $b9fb96103a9b59e3$var$dg = "__reactListeners$" + $b9fb96103a9b59e3$var$ag, $b9fb96103a9b59e3$var$eg = "__reactHandles$" + $b9fb96103a9b59e3$var$ag;
function $b9fb96103a9b59e3$var$jd(a) {
    var b = a[$b9fb96103a9b59e3$var$bg];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$b9fb96103a9b59e3$var$If] || c[$b9fb96103a9b59e3$var$bg]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $b9fb96103a9b59e3$var$$f(a); null !== a;){
                if (c = a[$b9fb96103a9b59e3$var$bg]) return c;
                a = $b9fb96103a9b59e3$var$$f(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $b9fb96103a9b59e3$var$Cb(a) {
    a = a[$b9fb96103a9b59e3$var$bg] || a[$b9fb96103a9b59e3$var$If];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $b9fb96103a9b59e3$var$Ie(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($b9fb96103a9b59e3$var$p(33));
}
function $b9fb96103a9b59e3$var$Db(a) {
    return a[$b9fb96103a9b59e3$var$cg] || null;
}
var $b9fb96103a9b59e3$var$fg = [], $b9fb96103a9b59e3$var$gg = -1;
function $b9fb96103a9b59e3$var$hg(a) {
    return {
        current: a
    };
}
function $b9fb96103a9b59e3$var$G(a) {
    0 > $b9fb96103a9b59e3$var$gg || (a.current = $b9fb96103a9b59e3$var$fg[$b9fb96103a9b59e3$var$gg], $b9fb96103a9b59e3$var$fg[$b9fb96103a9b59e3$var$gg] = null, $b9fb96103a9b59e3$var$gg--);
}
function $b9fb96103a9b59e3$var$H(a, b) {
    $b9fb96103a9b59e3$var$gg++;
    $b9fb96103a9b59e3$var$fg[$b9fb96103a9b59e3$var$gg] = a.current;
    a.current = b;
}
var $b9fb96103a9b59e3$var$ig = {}, $b9fb96103a9b59e3$var$I = $b9fb96103a9b59e3$var$hg($b9fb96103a9b59e3$var$ig), $b9fb96103a9b59e3$var$jg = $b9fb96103a9b59e3$var$hg(!1), $b9fb96103a9b59e3$var$kg = $b9fb96103a9b59e3$var$ig;
function $b9fb96103a9b59e3$var$lg(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $b9fb96103a9b59e3$var$ig;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $b9fb96103a9b59e3$var$mg(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $b9fb96103a9b59e3$var$ng() {
    $b9fb96103a9b59e3$var$G($b9fb96103a9b59e3$var$jg);
    $b9fb96103a9b59e3$var$G($b9fb96103a9b59e3$var$I);
}
function $b9fb96103a9b59e3$var$og(a, b, c) {
    if ($b9fb96103a9b59e3$var$I.current !== $b9fb96103a9b59e3$var$ig) throw Error($b9fb96103a9b59e3$var$p(168));
    $b9fb96103a9b59e3$var$H($b9fb96103a9b59e3$var$I, b);
    $b9fb96103a9b59e3$var$H($b9fb96103a9b59e3$var$jg, c);
}
function $b9fb96103a9b59e3$var$pg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($b9fb96103a9b59e3$var$p(108, $b9fb96103a9b59e3$var$Ra(a) || "Unknown", e));
    return $b9fb96103a9b59e3$var$u({}, c, d);
}
function $b9fb96103a9b59e3$var$qg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $b9fb96103a9b59e3$var$ig;
    $b9fb96103a9b59e3$var$kg = $b9fb96103a9b59e3$var$I.current;
    $b9fb96103a9b59e3$var$H($b9fb96103a9b59e3$var$I, a);
    $b9fb96103a9b59e3$var$H($b9fb96103a9b59e3$var$jg, $b9fb96103a9b59e3$var$jg.current);
    return !0;
}
function $b9fb96103a9b59e3$var$rg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($b9fb96103a9b59e3$var$p(169));
    c ? (a = $b9fb96103a9b59e3$var$pg(a, b, $b9fb96103a9b59e3$var$kg), d.__reactInternalMemoizedMergedChildContext = a, $b9fb96103a9b59e3$var$G($b9fb96103a9b59e3$var$jg), $b9fb96103a9b59e3$var$G($b9fb96103a9b59e3$var$I), $b9fb96103a9b59e3$var$H($b9fb96103a9b59e3$var$I, a)) : $b9fb96103a9b59e3$var$G($b9fb96103a9b59e3$var$jg);
    $b9fb96103a9b59e3$var$H($b9fb96103a9b59e3$var$jg, c);
}
var $b9fb96103a9b59e3$var$sg = null, $b9fb96103a9b59e3$var$tg = !1, $b9fb96103a9b59e3$var$ug = !1;
function $b9fb96103a9b59e3$var$vg(a) {
    null === $b9fb96103a9b59e3$var$sg ? $b9fb96103a9b59e3$var$sg = [
        a
    ] : $b9fb96103a9b59e3$var$sg.push(a);
}
function $b9fb96103a9b59e3$var$wg(a) {
    $b9fb96103a9b59e3$var$tg = !0;
    $b9fb96103a9b59e3$var$vg(a);
}
function $b9fb96103a9b59e3$var$xg() {
    if (!$b9fb96103a9b59e3$var$ug && null !== $b9fb96103a9b59e3$var$sg) {
        $b9fb96103a9b59e3$var$ug = !0;
        var a = 0, b = $b9fb96103a9b59e3$var$E;
        try {
            var c = $b9fb96103a9b59e3$var$sg;
            for($b9fb96103a9b59e3$var$E = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $b9fb96103a9b59e3$var$sg = null;
            $b9fb96103a9b59e3$var$tg = !1;
        } catch (e) {
            throw null !== $b9fb96103a9b59e3$var$sg && ($b9fb96103a9b59e3$var$sg = $b9fb96103a9b59e3$var$sg.slice(a + 1)), $b9fb96103a9b59e3$var$ac($b9fb96103a9b59e3$var$fc, $b9fb96103a9b59e3$var$xg), e;
        } finally{
            $b9fb96103a9b59e3$var$E = b, $b9fb96103a9b59e3$var$ug = !1;
        }
    }
    return null;
}
var $b9fb96103a9b59e3$var$yg = [], $b9fb96103a9b59e3$var$zg = 0, $b9fb96103a9b59e3$var$Ag = null, $b9fb96103a9b59e3$var$Bg = 0, $b9fb96103a9b59e3$var$Cg = [], $b9fb96103a9b59e3$var$Dg = 0, $b9fb96103a9b59e3$var$Eg = null, $b9fb96103a9b59e3$var$Fg = 1, $b9fb96103a9b59e3$var$Gg = "";
function $b9fb96103a9b59e3$var$Hg(a, b) {
    $b9fb96103a9b59e3$var$yg[$b9fb96103a9b59e3$var$zg++] = $b9fb96103a9b59e3$var$Bg;
    $b9fb96103a9b59e3$var$yg[$b9fb96103a9b59e3$var$zg++] = $b9fb96103a9b59e3$var$Ag;
    $b9fb96103a9b59e3$var$Ag = a;
    $b9fb96103a9b59e3$var$Bg = b;
}
function $b9fb96103a9b59e3$var$Ig(a, b, c) {
    $b9fb96103a9b59e3$var$Cg[$b9fb96103a9b59e3$var$Dg++] = $b9fb96103a9b59e3$var$Fg;
    $b9fb96103a9b59e3$var$Cg[$b9fb96103a9b59e3$var$Dg++] = $b9fb96103a9b59e3$var$Gg;
    $b9fb96103a9b59e3$var$Cg[$b9fb96103a9b59e3$var$Dg++] = $b9fb96103a9b59e3$var$Eg;
    $b9fb96103a9b59e3$var$Eg = a;
    var d = $b9fb96103a9b59e3$var$Fg;
    a = $b9fb96103a9b59e3$var$Gg;
    var e = 32 - $b9fb96103a9b59e3$var$Ac(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $b9fb96103a9b59e3$var$Ac(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $b9fb96103a9b59e3$var$Fg = 1 << 32 - $b9fb96103a9b59e3$var$Ac(b) + e | c << e | d;
        $b9fb96103a9b59e3$var$Gg = f + a;
    } else $b9fb96103a9b59e3$var$Fg = 1 << f | c << e | d, $b9fb96103a9b59e3$var$Gg = a;
}
function $b9fb96103a9b59e3$var$Jg(a) {
    null !== a.return && ($b9fb96103a9b59e3$var$Hg(a, 1), $b9fb96103a9b59e3$var$Ig(a, 1, 0));
}
function $b9fb96103a9b59e3$var$Kg(a) {
    for(; a === $b9fb96103a9b59e3$var$Ag;)$b9fb96103a9b59e3$var$Ag = $b9fb96103a9b59e3$var$yg[--$b9fb96103a9b59e3$var$zg], $b9fb96103a9b59e3$var$yg[$b9fb96103a9b59e3$var$zg] = null, $b9fb96103a9b59e3$var$Bg = $b9fb96103a9b59e3$var$yg[--$b9fb96103a9b59e3$var$zg], $b9fb96103a9b59e3$var$yg[$b9fb96103a9b59e3$var$zg] = null;
    for(; a === $b9fb96103a9b59e3$var$Eg;)$b9fb96103a9b59e3$var$Eg = $b9fb96103a9b59e3$var$Cg[--$b9fb96103a9b59e3$var$Dg], $b9fb96103a9b59e3$var$Cg[$b9fb96103a9b59e3$var$Dg] = null, $b9fb96103a9b59e3$var$Gg = $b9fb96103a9b59e3$var$Cg[--$b9fb96103a9b59e3$var$Dg], $b9fb96103a9b59e3$var$Cg[$b9fb96103a9b59e3$var$Dg] = null, $b9fb96103a9b59e3$var$Fg = $b9fb96103a9b59e3$var$Cg[--$b9fb96103a9b59e3$var$Dg], $b9fb96103a9b59e3$var$Cg[$b9fb96103a9b59e3$var$Dg] = null;
}
var $b9fb96103a9b59e3$var$Lg = null, $b9fb96103a9b59e3$var$Mg = null, $b9fb96103a9b59e3$var$J = !1, $b9fb96103a9b59e3$var$Ng = null;
function $b9fb96103a9b59e3$var$Og(a, b) {
    var c = $b9fb96103a9b59e3$var$Pg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $b9fb96103a9b59e3$var$Qg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $b9fb96103a9b59e3$var$Lg = a, $b9fb96103a9b59e3$var$Mg = $b9fb96103a9b59e3$var$Zf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $b9fb96103a9b59e3$var$Lg = a, $b9fb96103a9b59e3$var$Mg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $b9fb96103a9b59e3$var$Eg ? {
                id: $b9fb96103a9b59e3$var$Fg,
                overflow: $b9fb96103a9b59e3$var$Gg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $b9fb96103a9b59e3$var$Pg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $b9fb96103a9b59e3$var$Lg = a, $b9fb96103a9b59e3$var$Mg = null, !0) : !1;
        default:
            return !1;
    }
}
function $b9fb96103a9b59e3$var$Rg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $b9fb96103a9b59e3$var$Sg(a) {
    if ($b9fb96103a9b59e3$var$J) {
        var b = $b9fb96103a9b59e3$var$Mg;
        if (b) {
            var c = b;
            if (!$b9fb96103a9b59e3$var$Qg(a, b)) {
                if ($b9fb96103a9b59e3$var$Rg(a)) throw Error($b9fb96103a9b59e3$var$p(418));
                b = $b9fb96103a9b59e3$var$Zf(c.nextSibling);
                var d = $b9fb96103a9b59e3$var$Lg;
                b && $b9fb96103a9b59e3$var$Qg(a, b) ? $b9fb96103a9b59e3$var$Og(d, c) : (a.flags = a.flags & -4097 | 2, $b9fb96103a9b59e3$var$J = !1, $b9fb96103a9b59e3$var$Lg = a);
            }
        } else {
            if ($b9fb96103a9b59e3$var$Rg(a)) throw Error($b9fb96103a9b59e3$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $b9fb96103a9b59e3$var$J = !1;
            $b9fb96103a9b59e3$var$Lg = a;
        }
    }
}
function $b9fb96103a9b59e3$var$Tg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $b9fb96103a9b59e3$var$Lg = a;
}
function $b9fb96103a9b59e3$var$Ug(a) {
    if (a !== $b9fb96103a9b59e3$var$Lg) return !1;
    if (!$b9fb96103a9b59e3$var$J) return $b9fb96103a9b59e3$var$Tg(a), $b9fb96103a9b59e3$var$J = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$b9fb96103a9b59e3$var$Sf(a.type, a.memoizedProps));
    if (b && (b = $b9fb96103a9b59e3$var$Mg)) {
        if ($b9fb96103a9b59e3$var$Rg(a)) throw $b9fb96103a9b59e3$var$Vg(), Error($b9fb96103a9b59e3$var$p(418));
        for(; b;)$b9fb96103a9b59e3$var$Og(a, b), b = $b9fb96103a9b59e3$var$Zf(b.nextSibling);
    }
    $b9fb96103a9b59e3$var$Tg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($b9fb96103a9b59e3$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $b9fb96103a9b59e3$var$Mg = $b9fb96103a9b59e3$var$Zf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $b9fb96103a9b59e3$var$Mg = null;
        }
    } else $b9fb96103a9b59e3$var$Mg = $b9fb96103a9b59e3$var$Lg ? $b9fb96103a9b59e3$var$Zf(a.stateNode.nextSibling) : null;
    return !0;
}
function $b9fb96103a9b59e3$var$Vg() {
    for(var a = $b9fb96103a9b59e3$var$Mg; a;)a = $b9fb96103a9b59e3$var$Zf(a.nextSibling);
}
function $b9fb96103a9b59e3$var$Wg() {
    $b9fb96103a9b59e3$var$Mg = $b9fb96103a9b59e3$var$Lg = null;
    $b9fb96103a9b59e3$var$J = !1;
}
function $b9fb96103a9b59e3$var$Xg(a) {
    null === $b9fb96103a9b59e3$var$Ng ? $b9fb96103a9b59e3$var$Ng = [
        a
    ] : $b9fb96103a9b59e3$var$Ng.push(a);
}
var $b9fb96103a9b59e3$var$Yg = $b9fb96103a9b59e3$var$va.ReactCurrentBatchConfig;
function $b9fb96103a9b59e3$var$Zg(a, b) {
    if (a && a.defaultProps) {
        b = $b9fb96103a9b59e3$var$u({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $b9fb96103a9b59e3$var$$g = $b9fb96103a9b59e3$var$hg(null), $b9fb96103a9b59e3$var$ah = null, $b9fb96103a9b59e3$var$bh = null, $b9fb96103a9b59e3$var$ch = null;
function $b9fb96103a9b59e3$var$dh() {
    $b9fb96103a9b59e3$var$ch = $b9fb96103a9b59e3$var$bh = $b9fb96103a9b59e3$var$ah = null;
}
function $b9fb96103a9b59e3$var$eh(a) {
    var b = $b9fb96103a9b59e3$var$$g.current;
    $b9fb96103a9b59e3$var$G($b9fb96103a9b59e3$var$$g);
    a._currentValue = b;
}
function $b9fb96103a9b59e3$var$fh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $b9fb96103a9b59e3$var$gh(a, b) {
    $b9fb96103a9b59e3$var$ah = a;
    $b9fb96103a9b59e3$var$ch = $b9fb96103a9b59e3$var$bh = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($b9fb96103a9b59e3$var$hh = !0), a.firstContext = null);
}
function $b9fb96103a9b59e3$var$ih(a) {
    var b = a._currentValue;
    if ($b9fb96103a9b59e3$var$ch !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $b9fb96103a9b59e3$var$bh) {
            if (null === $b9fb96103a9b59e3$var$ah) throw Error($b9fb96103a9b59e3$var$p(308));
            $b9fb96103a9b59e3$var$bh = a;
            $b9fb96103a9b59e3$var$ah.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $b9fb96103a9b59e3$var$bh = $b9fb96103a9b59e3$var$bh.next = a;
    }
    return b;
}
var $b9fb96103a9b59e3$var$jh = null;
function $b9fb96103a9b59e3$var$kh(a) {
    null === $b9fb96103a9b59e3$var$jh ? $b9fb96103a9b59e3$var$jh = [
        a
    ] : $b9fb96103a9b59e3$var$jh.push(a);
}
function $b9fb96103a9b59e3$var$lh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $b9fb96103a9b59e3$var$kh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $b9fb96103a9b59e3$var$mh(a, d);
}
function $b9fb96103a9b59e3$var$mh(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $b9fb96103a9b59e3$var$nh = !1;
function $b9fb96103a9b59e3$var$oh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $b9fb96103a9b59e3$var$ph(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $b9fb96103a9b59e3$var$qh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $b9fb96103a9b59e3$var$rh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($b9fb96103a9b59e3$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $b9fb96103a9b59e3$var$mh(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $b9fb96103a9b59e3$var$kh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $b9fb96103a9b59e3$var$mh(a, c);
}
function $b9fb96103a9b59e3$var$sh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b9fb96103a9b59e3$var$Oc(a, c);
    }
}
function $b9fb96103a9b59e3$var$th(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $b9fb96103a9b59e3$var$uh(a, b, c, d) {
    var e = a.updateQueue;
    $b9fb96103a9b59e3$var$nh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        null !== n && (n = n.updateQueue, h = n.lastBaseUpdate, h !== g && (null === h ? n.firstBaseUpdate = l : h.next = l, n.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        n = l = k = null;
        h = f;
        do {
            var r = h.lane, z = h.eventTime;
            if ((d & r) === r) {
                null !== n && (n = n.next = {
                    eventTime: z,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var m = a, w = h;
                    r = b;
                    z = c;
                    switch(w.tag){
                        case 1:
                            m = w.payload;
                            if ("function" === typeof m) {
                                q = m.call(z, q, r);
                                break a;
                            }
                            q = m;
                            break a;
                        case 3:
                            m.flags = m.flags & -65537 | 128;
                        case 0:
                            m = w.payload;
                            r = "function" === typeof m ? m.call(z, q, r) : m;
                            if (null === r || void 0 === r) break a;
                            q = $b9fb96103a9b59e3$var$u({}, q, r);
                            break a;
                        case 2:
                            $b9fb96103a9b59e3$var$nh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else z = {
                eventTime: z,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === n ? (l = n = z, k = q) : n = n.next = z, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $b9fb96103a9b59e3$var$vh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $b9fb96103a9b59e3$var$wh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($b9fb96103a9b59e3$var$p(191, e));
            e.call(d);
        }
    }
}
var $b9fb96103a9b59e3$var$xh = (new $1Mpn7.Component).refs;
function $b9fb96103a9b59e3$var$yh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $b9fb96103a9b59e3$var$u({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $b9fb96103a9b59e3$var$Ch = {
    isMounted: function isMounted(a) {
        return (a = a._reactInternals) ? $b9fb96103a9b59e3$var$Vb(a) === a : !1;
    },
    enqueueSetState: function enqueueSetState(a, b, c) {
        a = a._reactInternals;
        var d = $b9fb96103a9b59e3$var$zh(), e = $b9fb96103a9b59e3$var$Ah(a), f = $b9fb96103a9b59e3$var$qh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b9fb96103a9b59e3$var$rh(a, f, e);
        null !== b && ($b9fb96103a9b59e3$var$Bh(b, a, e, d), $b9fb96103a9b59e3$var$sh(b, a, e));
        $b9fb96103a9b59e3$var$yc(a, e);
    },
    enqueueReplaceState: function enqueueReplaceState(a, b, c) {
        a = a._reactInternals;
        var d = $b9fb96103a9b59e3$var$zh(), e = $b9fb96103a9b59e3$var$Ah(a), f = $b9fb96103a9b59e3$var$qh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b9fb96103a9b59e3$var$rh(a, f, e);
        null !== b && ($b9fb96103a9b59e3$var$Bh(b, a, e, d), $b9fb96103a9b59e3$var$sh(b, a, e));
        $b9fb96103a9b59e3$var$yc(a, e);
    },
    enqueueForceUpdate: function enqueueForceUpdate(a, b) {
        a = a._reactInternals;
        var c = $b9fb96103a9b59e3$var$zh(), d = $b9fb96103a9b59e3$var$Ah(a), e = $b9fb96103a9b59e3$var$qh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $b9fb96103a9b59e3$var$rh(a, e, d);
        null !== b && ($b9fb96103a9b59e3$var$Bh(b, a, d, c), $b9fb96103a9b59e3$var$sh(b, a, d));
        null !== $b9fb96103a9b59e3$var$B && "function" === typeof $b9fb96103a9b59e3$var$B.markForceUpdateScheduled && $b9fb96103a9b59e3$var$B.markForceUpdateScheduled(a, d);
    }
};
function $b9fb96103a9b59e3$var$Dh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$b9fb96103a9b59e3$var$We(c, d) || !$b9fb96103a9b59e3$var$We(e, f) : !0;
}
function $b9fb96103a9b59e3$var$Eh(a, b, c) {
    var d = !1, e = $b9fb96103a9b59e3$var$ig;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $b9fb96103a9b59e3$var$ih(f) : (e = $b9fb96103a9b59e3$var$mg(b) ? $b9fb96103a9b59e3$var$kg : $b9fb96103a9b59e3$var$I.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $b9fb96103a9b59e3$var$lg(a, e) : $b9fb96103a9b59e3$var$ig);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $b9fb96103a9b59e3$var$Ch;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $b9fb96103a9b59e3$var$Fh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $b9fb96103a9b59e3$var$Ch.enqueueReplaceState(b, b.state, null);
}
function $b9fb96103a9b59e3$var$Gh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $b9fb96103a9b59e3$var$xh;
    $b9fb96103a9b59e3$var$oh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $b9fb96103a9b59e3$var$ih(f) : (f = $b9fb96103a9b59e3$var$mg(b) ? $b9fb96103a9b59e3$var$kg : $b9fb96103a9b59e3$var$I.current, e.context = $b9fb96103a9b59e3$var$lg(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($b9fb96103a9b59e3$var$yh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $b9fb96103a9b59e3$var$Ch.enqueueReplaceState(e, e.state, null), $b9fb96103a9b59e3$var$uh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $b9fb96103a9b59e3$var$Hh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($b9fb96103a9b59e3$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($b9fb96103a9b59e3$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function b(a) {
                var _$b = e.refs;
                _$b === $b9fb96103a9b59e3$var$xh && (_$b = e.refs = {});
                null === a ? delete _$b[f] : _$b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($b9fb96103a9b59e3$var$p(284));
        if (!c._owner) throw Error($b9fb96103a9b59e3$var$p(290, a));
    }
    return a;
}
function $b9fb96103a9b59e3$var$Ih(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($b9fb96103a9b59e3$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $b9fb96103a9b59e3$var$Jh(a) {
    var b = a._init;
    return b(a._payload);
}
function $b9fb96103a9b59e3$var$Kh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $b9fb96103a9b59e3$var$Lh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $b9fb96103a9b59e3$var$Mh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $b9fb96103a9b59e3$var$ya) return n(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $b9fb96103a9b59e3$var$Ha && $b9fb96103a9b59e3$var$Jh(f) === b.type)) return d = e(b, c.props), d.ref = $b9fb96103a9b59e3$var$Hh(a, b, c), d.return = a, d;
        d = $b9fb96103a9b59e3$var$Nh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $b9fb96103a9b59e3$var$Hh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $b9fb96103a9b59e3$var$Oh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $b9fb96103a9b59e3$var$Ph(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $b9fb96103a9b59e3$var$Mh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $b9fb96103a9b59e3$var$wa:
                    return c = $b9fb96103a9b59e3$var$Nh(b.type, b.key, b.props, null, a.mode, c), c.ref = $b9fb96103a9b59e3$var$Hh(a, null, b), c.return = a, c;
                case $b9fb96103a9b59e3$var$xa:
                    return b = $b9fb96103a9b59e3$var$Oh(b, a.mode, c), b.return = a, b;
                case $b9fb96103a9b59e3$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($b9fb96103a9b59e3$var$db(b) || $b9fb96103a9b59e3$var$Ka(b)) return b = $b9fb96103a9b59e3$var$Ph(b, a.mode, c, null), b.return = a, b;
            $b9fb96103a9b59e3$var$Ih(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $b9fb96103a9b59e3$var$wa:
                    return c.key === e ? k(a, b, c, d) : null;
                case $b9fb96103a9b59e3$var$xa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $b9fb96103a9b59e3$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($b9fb96103a9b59e3$var$db(c) || $b9fb96103a9b59e3$var$Ka(c)) return null !== e ? null : n(a, b, c, d, null);
            $b9fb96103a9b59e3$var$Ih(a, c);
        }
        return null;
    }
    function z(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $b9fb96103a9b59e3$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $b9fb96103a9b59e3$var$xa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $b9fb96103a9b59e3$var$Ha:
                    var f = d._init;
                    return z(a, b, c, f(d._payload), e);
            }
            if ($b9fb96103a9b59e3$var$db(d) || $b9fb96103a9b59e3$var$Ka(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            $b9fb96103a9b59e3$var$Ih(b, d);
        }
        return null;
    }
    function m(e, g, h, k) {
        for(var l = null, v = null, n = g, m = g = 0, y = null; null !== n && m < h.length; m++){
            n.index > m ? (y = n, n = null) : y = n.sibling;
            var x = r(e, n, h[m], k);
            if (null === x) {
                null === n && (n = y);
                break;
            }
            a && n && null === x.alternate && b(e, n);
            g = f(x, g, m);
            null === v ? l = x : v.sibling = x;
            v = x;
            n = y;
        }
        if (m === h.length) return c(e, n), $b9fb96103a9b59e3$var$J && $b9fb96103a9b59e3$var$Hg(e, m), l;
        if (null === n) {
            for(; m < h.length; m++)n = q(e, h[m], k), null !== n && (g = f(n, g, m), null === v ? l = n : v.sibling = n, v = n);
            $b9fb96103a9b59e3$var$J && $b9fb96103a9b59e3$var$Hg(e, m);
            return l;
        }
        for(n = d(e, n); m < h.length; m++)y = z(n, e, m, h[m], k), null !== y && (a && null !== y.alternate && n.delete(null === y.key ? m : y.key), g = f(y, g, m), null === v ? l = y : v.sibling = y, v = y);
        a && n.forEach(function(a) {
            return b(e, a);
        });
        $b9fb96103a9b59e3$var$J && $b9fb96103a9b59e3$var$Hg(e, m);
        return l;
    }
    function w(e, g, h, k) {
        var l = $b9fb96103a9b59e3$var$Ka(h);
        if ("function" !== typeof l) throw Error($b9fb96103a9b59e3$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($b9fb96103a9b59e3$var$p(151));
        for(var n = l = null, m = g, v = g = 0, y = null, x = h.next(); null !== m && !x.done; v++, x = h.next()){
            m.index > v ? (y = m, m = null) : y = m.sibling;
            var w = r(e, m, x.value, k);
            if (null === w) {
                null === m && (m = y);
                break;
            }
            a && m && null === w.alternate && b(e, m);
            g = f(w, g, v);
            null === n ? l = w : n.sibling = w;
            n = w;
            m = y;
        }
        if (x.done) return c(e, m), $b9fb96103a9b59e3$var$J && $b9fb96103a9b59e3$var$Hg(e, v), l;
        if (null === m) {
            for(; !x.done; v++, x = h.next())x = q(e, x.value, k), null !== x && (g = f(x, g, v), null === n ? l = x : n.sibling = x, n = x);
            $b9fb96103a9b59e3$var$J && $b9fb96103a9b59e3$var$Hg(e, v);
            return l;
        }
        for(m = d(e, m); !x.done; v++, x = h.next())x = z(m, e, v, x.value, k), null !== x && (a && null !== x.alternate && m.delete(null === x.key ? v : x.key), g = f(x, g, v), null === n ? l = x : n.sibling = x, n = x);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $b9fb96103a9b59e3$var$J && $b9fb96103a9b59e3$var$Hg(e, v);
        return l;
    }
    function C(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $b9fb96103a9b59e3$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $b9fb96103a9b59e3$var$wa:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $b9fb96103a9b59e3$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $b9fb96103a9b59e3$var$Ha && $b9fb96103a9b59e3$var$Jh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $b9fb96103a9b59e3$var$Hh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $b9fb96103a9b59e3$var$ya ? (d = $b9fb96103a9b59e3$var$Ph(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $b9fb96103a9b59e3$var$Nh(f.type, f.key, f.props, null, a.mode, h), h.ref = $b9fb96103a9b59e3$var$Hh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $b9fb96103a9b59e3$var$xa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $b9fb96103a9b59e3$var$Oh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $b9fb96103a9b59e3$var$Ha:
                    return l = f._init, C(a, d, l(f._payload), h);
            }
            if ($b9fb96103a9b59e3$var$db(f)) return m(a, d, f, h);
            if ($b9fb96103a9b59e3$var$Ka(f)) return w(a, d, f, h);
            $b9fb96103a9b59e3$var$Ih(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $b9fb96103a9b59e3$var$Mh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return C;
}
var $b9fb96103a9b59e3$var$Qh = $b9fb96103a9b59e3$var$Kh(!0), $b9fb96103a9b59e3$var$Rh = $b9fb96103a9b59e3$var$Kh(!1), $b9fb96103a9b59e3$var$Sh = {}, $b9fb96103a9b59e3$var$Th = $b9fb96103a9b59e3$var$hg($b9fb96103a9b59e3$var$Sh), $b9fb96103a9b59e3$var$Uh = $b9fb96103a9b59e3$var$hg($b9fb96103a9b59e3$var$Sh), $b9fb96103a9b59e3$var$Vh = $b9fb96103a9b59e3$var$hg($b9fb96103a9b59e3$var$Sh);
function $b9fb96103a9b59e3$var$Wh(a) {
    if (a === $b9fb96103a9b59e3$var$Sh) throw Error($b9fb96103a9b59e3$var$p(174));
    return a;
}
function $b9fb96103a9b59e3$var$Xh(a, b) {
    $b9fb96103a9b59e3$var$H($b9fb96103a9b59e3$var$Vh, b);
    $b9fb96103a9b59e3$var$H($b9fb96103a9b59e3$var$Uh, a);
    $b9fb96103a9b59e3$var$H($b9fb96103a9b59e3$var$Th, $b9fb96103a9b59e3$var$Sh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $b9fb96103a9b59e3$var$kb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $b9fb96103a9b59e3$var$kb(b, a);
    }
    $b9fb96103a9b59e3$var$G($b9fb96103a9b59e3$var$Th);
    $b9fb96103a9b59e3$var$H($b9fb96103a9b59e3$var$Th, b);
}
function $b9fb96103a9b59e3$var$Yh() {
    $b9fb96103a9b59e3$var$G($b9fb96103a9b59e3$var$Th);
    $b9fb96103a9b59e3$var$G($b9fb96103a9b59e3$var$Uh);
    $b9fb96103a9b59e3$var$G($b9fb96103a9b59e3$var$Vh);
}
function $b9fb96103a9b59e3$var$Zh(a) {
    $b9fb96103a9b59e3$var$Wh($b9fb96103a9b59e3$var$Vh.current);
    var b = $b9fb96103a9b59e3$var$Wh($b9fb96103a9b59e3$var$Th.current);
    var c = $b9fb96103a9b59e3$var$kb(b, a.type);
    b !== c && ($b9fb96103a9b59e3$var$H($b9fb96103a9b59e3$var$Uh, a), $b9fb96103a9b59e3$var$H($b9fb96103a9b59e3$var$Th, c));
}
function $b9fb96103a9b59e3$var$$h(a) {
    $b9fb96103a9b59e3$var$Uh.current === a && ($b9fb96103a9b59e3$var$G($b9fb96103a9b59e3$var$Th), $b9fb96103a9b59e3$var$G($b9fb96103a9b59e3$var$Uh));
}
var $b9fb96103a9b59e3$var$L = $b9fb96103a9b59e3$var$hg(0);
function $b9fb96103a9b59e3$var$ai(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $b9fb96103a9b59e3$var$bi = [];
function $b9fb96103a9b59e3$var$ci() {
    for(var a = 0; a < $b9fb96103a9b59e3$var$bi.length; a++)$b9fb96103a9b59e3$var$bi[a]._workInProgressVersionPrimary = null;
    $b9fb96103a9b59e3$var$bi.length = 0;
}
var $b9fb96103a9b59e3$var$di = $b9fb96103a9b59e3$var$va.ReactCurrentDispatcher, $b9fb96103a9b59e3$var$ei = $b9fb96103a9b59e3$var$va.ReactCurrentBatchConfig, $b9fb96103a9b59e3$var$fi = 0, $b9fb96103a9b59e3$var$M = null, $b9fb96103a9b59e3$var$N = null, $b9fb96103a9b59e3$var$O = null, $b9fb96103a9b59e3$var$gi = !1, $b9fb96103a9b59e3$var$hi = !1, $b9fb96103a9b59e3$var$ii = 0, $b9fb96103a9b59e3$var$ji = 0;
function $b9fb96103a9b59e3$var$P() {
    throw Error($b9fb96103a9b59e3$var$p(321));
}
function $b9fb96103a9b59e3$var$ki(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$b9fb96103a9b59e3$var$Ve(a[c], b[c])) return !1;
    return !0;
}
function $b9fb96103a9b59e3$var$li(a, b, c, d, e, f) {
    $b9fb96103a9b59e3$var$fi = f;
    $b9fb96103a9b59e3$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $b9fb96103a9b59e3$var$di.current = null === a || null === a.memoizedState ? $b9fb96103a9b59e3$var$mi : $b9fb96103a9b59e3$var$ni;
    a = c(d, e);
    if ($b9fb96103a9b59e3$var$hi) {
        f = 0;
        do {
            $b9fb96103a9b59e3$var$hi = !1;
            $b9fb96103a9b59e3$var$ii = 0;
            if (25 <= f) throw Error($b9fb96103a9b59e3$var$p(301));
            f += 1;
            $b9fb96103a9b59e3$var$O = $b9fb96103a9b59e3$var$N = null;
            b.updateQueue = null;
            $b9fb96103a9b59e3$var$di.current = $b9fb96103a9b59e3$var$oi;
            a = c(d, e);
        }while ($b9fb96103a9b59e3$var$hi);
    }
    $b9fb96103a9b59e3$var$di.current = $b9fb96103a9b59e3$var$pi;
    b = null !== $b9fb96103a9b59e3$var$N && null !== $b9fb96103a9b59e3$var$N.next;
    $b9fb96103a9b59e3$var$fi = 0;
    $b9fb96103a9b59e3$var$O = $b9fb96103a9b59e3$var$N = $b9fb96103a9b59e3$var$M = null;
    $b9fb96103a9b59e3$var$gi = !1;
    if (b) throw Error($b9fb96103a9b59e3$var$p(300));
    return a;
}
function $b9fb96103a9b59e3$var$qi() {
    var a = 0 !== $b9fb96103a9b59e3$var$ii;
    $b9fb96103a9b59e3$var$ii = 0;
    return a;
}
function $b9fb96103a9b59e3$var$ri() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $b9fb96103a9b59e3$var$O ? $b9fb96103a9b59e3$var$M.memoizedState = $b9fb96103a9b59e3$var$O = a : $b9fb96103a9b59e3$var$O = $b9fb96103a9b59e3$var$O.next = a;
    return $b9fb96103a9b59e3$var$O;
}
function $b9fb96103a9b59e3$var$si() {
    if (null === $b9fb96103a9b59e3$var$N) {
        var a = $b9fb96103a9b59e3$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $b9fb96103a9b59e3$var$N.next;
    var b = null === $b9fb96103a9b59e3$var$O ? $b9fb96103a9b59e3$var$M.memoizedState : $b9fb96103a9b59e3$var$O.next;
    if (null !== b) $b9fb96103a9b59e3$var$O = b, $b9fb96103a9b59e3$var$N = a;
    else {
        if (null === a) throw Error($b9fb96103a9b59e3$var$p(310));
        $b9fb96103a9b59e3$var$N = a;
        a = {
            memoizedState: $b9fb96103a9b59e3$var$N.memoizedState,
            baseState: $b9fb96103a9b59e3$var$N.baseState,
            baseQueue: $b9fb96103a9b59e3$var$N.baseQueue,
            queue: $b9fb96103a9b59e3$var$N.queue,
            next: null
        };
        null === $b9fb96103a9b59e3$var$O ? $b9fb96103a9b59e3$var$M.memoizedState = $b9fb96103a9b59e3$var$O = a : $b9fb96103a9b59e3$var$O = $b9fb96103a9b59e3$var$O.next = a;
    }
    return $b9fb96103a9b59e3$var$O;
}
function $b9fb96103a9b59e3$var$ti(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $b9fb96103a9b59e3$var$ui(a) {
    var b = $b9fb96103a9b59e3$var$si(), c = b.queue;
    if (null === c) throw Error($b9fb96103a9b59e3$var$p(311));
    c.lastRenderedReducer = a;
    var d = $b9fb96103a9b59e3$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var n = l.lane;
            if (($b9fb96103a9b59e3$var$fi & n) === n) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: n,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $b9fb96103a9b59e3$var$M.lanes |= n;
                $b9fb96103a9b59e3$var$vh |= n;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $b9fb96103a9b59e3$var$Ve(d, b.memoizedState) || ($b9fb96103a9b59e3$var$hh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $b9fb96103a9b59e3$var$M.lanes |= f, $b9fb96103a9b59e3$var$vh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $b9fb96103a9b59e3$var$vi(a) {
    var b = $b9fb96103a9b59e3$var$si(), c = b.queue;
    if (null === c) throw Error($b9fb96103a9b59e3$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $b9fb96103a9b59e3$var$Ve(f, b.memoizedState) || ($b9fb96103a9b59e3$var$hh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $b9fb96103a9b59e3$var$wi() {}
function $b9fb96103a9b59e3$var$xi(a, b) {
    var c = $b9fb96103a9b59e3$var$M, d = $b9fb96103a9b59e3$var$si(), e = b(), f = !$b9fb96103a9b59e3$var$Ve(d.memoizedState, e);
    f && (d.memoizedState = e, $b9fb96103a9b59e3$var$hh = !0);
    d = d.queue;
    $b9fb96103a9b59e3$var$yi($b9fb96103a9b59e3$var$zi.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $b9fb96103a9b59e3$var$O && $b9fb96103a9b59e3$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $b9fb96103a9b59e3$var$Ai(9, $b9fb96103a9b59e3$var$Bi.bind(null, c, d, e, b), void 0, null);
        if (null === $b9fb96103a9b59e3$var$Q) throw Error($b9fb96103a9b59e3$var$p(349));
        0 !== ($b9fb96103a9b59e3$var$fi & 30) || $b9fb96103a9b59e3$var$Ci(c, b, e);
    }
    return e;
}
function $b9fb96103a9b59e3$var$Ci(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $b9fb96103a9b59e3$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b9fb96103a9b59e3$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $b9fb96103a9b59e3$var$Bi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $b9fb96103a9b59e3$var$Di(b) && $b9fb96103a9b59e3$var$Ei(a);
}
function $b9fb96103a9b59e3$var$zi(a, b, c) {
    return c(function() {
        $b9fb96103a9b59e3$var$Di(b) && $b9fb96103a9b59e3$var$Ei(a);
    });
}
function $b9fb96103a9b59e3$var$Di(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$b9fb96103a9b59e3$var$Ve(a, c);
    } catch (d) {
        return !0;
    }
}
function $b9fb96103a9b59e3$var$Ei(a) {
    var b = $b9fb96103a9b59e3$var$mh(a, 1);
    null !== b && $b9fb96103a9b59e3$var$Bh(b, a, 1, -1);
}
function $b9fb96103a9b59e3$var$Fi(a) {
    var b = $b9fb96103a9b59e3$var$ri();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $b9fb96103a9b59e3$var$ti,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $b9fb96103a9b59e3$var$Gi.bind(null, $b9fb96103a9b59e3$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $b9fb96103a9b59e3$var$Ai(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $b9fb96103a9b59e3$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b9fb96103a9b59e3$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $b9fb96103a9b59e3$var$Ji() {
    return $b9fb96103a9b59e3$var$si().memoizedState;
}
function $b9fb96103a9b59e3$var$Ki(a, b, c, d) {
    var e = $b9fb96103a9b59e3$var$ri();
    $b9fb96103a9b59e3$var$M.flags |= a;
    e.memoizedState = $b9fb96103a9b59e3$var$Ai(1 | b, c, void 0, void 0 === d ? null : d);
}
function $b9fb96103a9b59e3$var$Li(a, b, c, d) {
    var e = $b9fb96103a9b59e3$var$si();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $b9fb96103a9b59e3$var$N) {
        var g = $b9fb96103a9b59e3$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $b9fb96103a9b59e3$var$ki(d, g.deps)) {
            e.memoizedState = $b9fb96103a9b59e3$var$Ai(b, c, f, d);
            return;
        }
    }
    $b9fb96103a9b59e3$var$M.flags |= a;
    e.memoizedState = $b9fb96103a9b59e3$var$Ai(1 | b, c, f, d);
}
function $b9fb96103a9b59e3$var$Mi(a, b) {
    return $b9fb96103a9b59e3$var$Ki(8390656, 8, a, b);
}
function $b9fb96103a9b59e3$var$yi(a, b) {
    return $b9fb96103a9b59e3$var$Li(2048, 8, a, b);
}
function $b9fb96103a9b59e3$var$Ni(a, b) {
    return $b9fb96103a9b59e3$var$Li(4, 2, a, b);
}
function $b9fb96103a9b59e3$var$Oi(a, b) {
    return $b9fb96103a9b59e3$var$Li(4, 4, a, b);
}
function $b9fb96103a9b59e3$var$Pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $b9fb96103a9b59e3$var$Qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $b9fb96103a9b59e3$var$Li(4, 4, $b9fb96103a9b59e3$var$Pi.bind(null, b, a), c);
}
function $b9fb96103a9b59e3$var$Ri() {}
function $b9fb96103a9b59e3$var$Si(a, b) {
    var c = $b9fb96103a9b59e3$var$si();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b9fb96103a9b59e3$var$ki(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b9fb96103a9b59e3$var$Ti(a, b) {
    var c = $b9fb96103a9b59e3$var$si();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b9fb96103a9b59e3$var$ki(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b9fb96103a9b59e3$var$Ui(a, b, c) {
    if (0 === ($b9fb96103a9b59e3$var$fi & 21)) return a.baseState && (a.baseState = !1, $b9fb96103a9b59e3$var$hh = !0), a.memoizedState = c;
    $b9fb96103a9b59e3$var$Ve(c, b) || (c = $b9fb96103a9b59e3$var$Kc(), $b9fb96103a9b59e3$var$M.lanes |= c, $b9fb96103a9b59e3$var$vh |= c, a.baseState = !0);
    return b;
}
function $b9fb96103a9b59e3$var$Vi(a, b) {
    var c = $b9fb96103a9b59e3$var$E;
    $b9fb96103a9b59e3$var$E = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $b9fb96103a9b59e3$var$ei.transition;
    $b9fb96103a9b59e3$var$ei.transition = {};
    try {
        a(!1), b();
    } finally{
        $b9fb96103a9b59e3$var$E = c, $b9fb96103a9b59e3$var$ei.transition = d;
    }
}
function $b9fb96103a9b59e3$var$Wi() {
    return $b9fb96103a9b59e3$var$si().memoizedState;
}
function $b9fb96103a9b59e3$var$Xi(a, b, c) {
    var d = $b9fb96103a9b59e3$var$Ah(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b9fb96103a9b59e3$var$Yi(a)) $b9fb96103a9b59e3$var$Zi(b, c);
    else if (c = $b9fb96103a9b59e3$var$lh(a, b, c, d), null !== c) {
        var e = $b9fb96103a9b59e3$var$zh();
        $b9fb96103a9b59e3$var$Bh(c, a, d, e);
        $b9fb96103a9b59e3$var$$i(c, b, d);
    }
    $b9fb96103a9b59e3$var$yc(a, d);
}
function $b9fb96103a9b59e3$var$Gi(a, b, c) {
    var d = $b9fb96103a9b59e3$var$Ah(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b9fb96103a9b59e3$var$Yi(a)) $b9fb96103a9b59e3$var$Zi(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($b9fb96103a9b59e3$var$Ve(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $b9fb96103a9b59e3$var$kh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $b9fb96103a9b59e3$var$lh(a, b, e, d);
        null !== c && (e = $b9fb96103a9b59e3$var$zh(), $b9fb96103a9b59e3$var$Bh(c, a, d, e), $b9fb96103a9b59e3$var$$i(c, b, d));
    }
    $b9fb96103a9b59e3$var$yc(a, d);
}
function $b9fb96103a9b59e3$var$Yi(a) {
    var b = a.alternate;
    return a === $b9fb96103a9b59e3$var$M || null !== b && b === $b9fb96103a9b59e3$var$M;
}
function $b9fb96103a9b59e3$var$Zi(a, b) {
    $b9fb96103a9b59e3$var$hi = $b9fb96103a9b59e3$var$gi = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $b9fb96103a9b59e3$var$$i(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b9fb96103a9b59e3$var$Oc(a, c);
    }
}
var $b9fb96103a9b59e3$var$pi = {
    readContext: $b9fb96103a9b59e3$var$ih,
    useCallback: $b9fb96103a9b59e3$var$P,
    useContext: $b9fb96103a9b59e3$var$P,
    useEffect: $b9fb96103a9b59e3$var$P,
    useImperativeHandle: $b9fb96103a9b59e3$var$P,
    useInsertionEffect: $b9fb96103a9b59e3$var$P,
    useLayoutEffect: $b9fb96103a9b59e3$var$P,
    useMemo: $b9fb96103a9b59e3$var$P,
    useReducer: $b9fb96103a9b59e3$var$P,
    useRef: $b9fb96103a9b59e3$var$P,
    useState: $b9fb96103a9b59e3$var$P,
    useDebugValue: $b9fb96103a9b59e3$var$P,
    useDeferredValue: $b9fb96103a9b59e3$var$P,
    useTransition: $b9fb96103a9b59e3$var$P,
    useMutableSource: $b9fb96103a9b59e3$var$P,
    useSyncExternalStore: $b9fb96103a9b59e3$var$P,
    useId: $b9fb96103a9b59e3$var$P,
    unstable_isNewReconciler: !1
}, $b9fb96103a9b59e3$var$mi = {
    readContext: $b9fb96103a9b59e3$var$ih,
    useCallback: function useCallback(a, b) {
        $b9fb96103a9b59e3$var$ri().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $b9fb96103a9b59e3$var$ih,
    useEffect: $b9fb96103a9b59e3$var$Mi,
    useImperativeHandle: function useImperativeHandle(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $b9fb96103a9b59e3$var$Ki(4194308, 4, $b9fb96103a9b59e3$var$Pi.bind(null, b, a), c);
    },
    useLayoutEffect: function useLayoutEffect(a, b) {
        return $b9fb96103a9b59e3$var$Ki(4194308, 4, a, b);
    },
    useInsertionEffect: function useInsertionEffect(a, b) {
        return $b9fb96103a9b59e3$var$Ki(4, 2, a, b);
    },
    useMemo: function useMemo(a, b) {
        var c = $b9fb96103a9b59e3$var$ri();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function useReducer(a, b, c) {
        var d = $b9fb96103a9b59e3$var$ri();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $b9fb96103a9b59e3$var$Xi.bind(null, $b9fb96103a9b59e3$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function useRef(a) {
        var b = $b9fb96103a9b59e3$var$ri();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $b9fb96103a9b59e3$var$Fi,
    useDebugValue: $b9fb96103a9b59e3$var$Ri,
    useDeferredValue: function useDeferredValue(a) {
        return $b9fb96103a9b59e3$var$ri().memoizedState = a;
    },
    useTransition: function useTransition() {
        var a = $b9fb96103a9b59e3$var$Fi(!1), b = a[0];
        a = $b9fb96103a9b59e3$var$Vi.bind(null, a[1]);
        $b9fb96103a9b59e3$var$ri().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function useMutableSource() {},
    useSyncExternalStore: function useSyncExternalStore(a, b, c) {
        var d = $b9fb96103a9b59e3$var$M, e = $b9fb96103a9b59e3$var$ri();
        if ($b9fb96103a9b59e3$var$J) {
            if (void 0 === c) throw Error($b9fb96103a9b59e3$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $b9fb96103a9b59e3$var$Q) throw Error($b9fb96103a9b59e3$var$p(349));
            0 !== ($b9fb96103a9b59e3$var$fi & 30) || $b9fb96103a9b59e3$var$Ci(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $b9fb96103a9b59e3$var$Mi($b9fb96103a9b59e3$var$zi.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $b9fb96103a9b59e3$var$Ai(9, $b9fb96103a9b59e3$var$Bi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function useId() {
        var a = $b9fb96103a9b59e3$var$ri(), b = $b9fb96103a9b59e3$var$Q.identifierPrefix;
        if ($b9fb96103a9b59e3$var$J) {
            var c = $b9fb96103a9b59e3$var$Gg;
            var d = $b9fb96103a9b59e3$var$Fg;
            c = (d & ~(1 << 32 - $b9fb96103a9b59e3$var$Ac(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $b9fb96103a9b59e3$var$ii++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $b9fb96103a9b59e3$var$ji++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $b9fb96103a9b59e3$var$ni = {
    readContext: $b9fb96103a9b59e3$var$ih,
    useCallback: $b9fb96103a9b59e3$var$Si,
    useContext: $b9fb96103a9b59e3$var$ih,
    useEffect: $b9fb96103a9b59e3$var$yi,
    useImperativeHandle: $b9fb96103a9b59e3$var$Qi,
    useInsertionEffect: $b9fb96103a9b59e3$var$Ni,
    useLayoutEffect: $b9fb96103a9b59e3$var$Oi,
    useMemo: $b9fb96103a9b59e3$var$Ti,
    useReducer: $b9fb96103a9b59e3$var$ui,
    useRef: $b9fb96103a9b59e3$var$Ji,
    useState: function useState() {
        return $b9fb96103a9b59e3$var$ui($b9fb96103a9b59e3$var$ti);
    },
    useDebugValue: $b9fb96103a9b59e3$var$Ri,
    useDeferredValue: function useDeferredValue(a) {
        var b = $b9fb96103a9b59e3$var$si();
        return $b9fb96103a9b59e3$var$Ui(b, $b9fb96103a9b59e3$var$N.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $b9fb96103a9b59e3$var$ui($b9fb96103a9b59e3$var$ti)[0], b = $b9fb96103a9b59e3$var$si().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b9fb96103a9b59e3$var$wi,
    useSyncExternalStore: $b9fb96103a9b59e3$var$xi,
    useId: $b9fb96103a9b59e3$var$Wi,
    unstable_isNewReconciler: !1
}, $b9fb96103a9b59e3$var$oi = {
    readContext: $b9fb96103a9b59e3$var$ih,
    useCallback: $b9fb96103a9b59e3$var$Si,
    useContext: $b9fb96103a9b59e3$var$ih,
    useEffect: $b9fb96103a9b59e3$var$yi,
    useImperativeHandle: $b9fb96103a9b59e3$var$Qi,
    useInsertionEffect: $b9fb96103a9b59e3$var$Ni,
    useLayoutEffect: $b9fb96103a9b59e3$var$Oi,
    useMemo: $b9fb96103a9b59e3$var$Ti,
    useReducer: $b9fb96103a9b59e3$var$vi,
    useRef: $b9fb96103a9b59e3$var$Ji,
    useState: function useState() {
        return $b9fb96103a9b59e3$var$vi($b9fb96103a9b59e3$var$ti);
    },
    useDebugValue: $b9fb96103a9b59e3$var$Ri,
    useDeferredValue: function useDeferredValue(a) {
        var b = $b9fb96103a9b59e3$var$si();
        return null === $b9fb96103a9b59e3$var$N ? b.memoizedState = a : $b9fb96103a9b59e3$var$Ui(b, $b9fb96103a9b59e3$var$N.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $b9fb96103a9b59e3$var$vi($b9fb96103a9b59e3$var$ti)[0], b = $b9fb96103a9b59e3$var$si().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b9fb96103a9b59e3$var$wi,
    useSyncExternalStore: $b9fb96103a9b59e3$var$xi,
    useId: $b9fb96103a9b59e3$var$Wi,
    unstable_isNewReconciler: !1
}, $b9fb96103a9b59e3$var$aj = $3rCRi.unstable_now, $b9fb96103a9b59e3$var$bj = 0, $b9fb96103a9b59e3$var$cj = -1, $b9fb96103a9b59e3$var$dj = -1, $b9fb96103a9b59e3$var$ej = -1, $b9fb96103a9b59e3$var$fj = !1, $b9fb96103a9b59e3$var$gj = !1;
function $b9fb96103a9b59e3$var$hj(a, b) {
    if (0 <= $b9fb96103a9b59e3$var$dj) {
        var c = $b9fb96103a9b59e3$var$aj() - $b9fb96103a9b59e3$var$dj;
        a.actualDuration += c;
        b && (a.selfBaseDuration = c);
        $b9fb96103a9b59e3$var$dj = -1;
    }
}
function $b9fb96103a9b59e3$var$ij(a) {
    if (0 <= $b9fb96103a9b59e3$var$cj) {
        var b = $b9fb96103a9b59e3$var$aj() - $b9fb96103a9b59e3$var$cj;
        $b9fb96103a9b59e3$var$cj = -1;
        for(a = a.return; null !== a;){
            switch(a.tag){
                case 3:
                    a.stateNode.effectDuration += b;
                    return;
                case 12:
                    a.stateNode.effectDuration += b;
                    return;
            }
            a = a.return;
        }
    }
}
function $b9fb96103a9b59e3$var$jj(a) {
    if (0 <= $b9fb96103a9b59e3$var$ej) {
        var b = $b9fb96103a9b59e3$var$aj() - $b9fb96103a9b59e3$var$ej;
        $b9fb96103a9b59e3$var$ej = -1;
        for(a = a.return; null !== a;){
            switch(a.tag){
                case 3:
                    a = a.stateNode;
                    null !== a && (a.passiveEffectDuration += b);
                    return;
                case 12:
                    a = a.stateNode;
                    null !== a && (a.passiveEffectDuration += b);
                    return;
            }
            a = a.return;
        }
    }
}
function $b9fb96103a9b59e3$var$kj() {
    $b9fb96103a9b59e3$var$cj = $b9fb96103a9b59e3$var$aj();
}
function $b9fb96103a9b59e3$var$lj(a) {
    for(var b = a.child; b;)a.actualDuration += b.actualDuration, b = b.sibling;
}
function $b9fb96103a9b59e3$var$mj(a, b) {
    try {
        var c = "", d = b;
        do c += $b9fb96103a9b59e3$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $b9fb96103a9b59e3$var$nj(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $b9fb96103a9b59e3$var$oj(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $b9fb96103a9b59e3$var$pj = "function" === typeof WeakMap ? WeakMap : Map;
function $b9fb96103a9b59e3$var$qj(a, b, c) {
    c = $b9fb96103a9b59e3$var$qh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $b9fb96103a9b59e3$var$rj || ($b9fb96103a9b59e3$var$rj = !0, $b9fb96103a9b59e3$var$sj = d);
        $b9fb96103a9b59e3$var$oj(a, b);
    };
    return c;
}
function $b9fb96103a9b59e3$var$tj(a, b, c) {
    c = $b9fb96103a9b59e3$var$qh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $b9fb96103a9b59e3$var$oj(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $b9fb96103a9b59e3$var$oj(a, b);
        "function" !== typeof d && (null === $b9fb96103a9b59e3$var$uj ? $b9fb96103a9b59e3$var$uj = new Set([
            this
        ]) : $b9fb96103a9b59e3$var$uj.add(this));
        var _$c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== _$c ? _$c : ""
        });
    });
    return c;
}
function $b9fb96103a9b59e3$var$vj(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $b9fb96103a9b59e3$var$pj;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), d = $b9fb96103a9b59e3$var$wj.bind(null, a, b, c), $b9fb96103a9b59e3$var$mc && $b9fb96103a9b59e3$var$xj(a, c), b.then(d, d));
}
function $b9fb96103a9b59e3$var$yj(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $b9fb96103a9b59e3$var$zj(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $b9fb96103a9b59e3$var$qh(-1, 1), b.tag = 2, $b9fb96103a9b59e3$var$rh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $b9fb96103a9b59e3$var$Aj = $b9fb96103a9b59e3$var$va.ReactCurrentOwner, $b9fb96103a9b59e3$var$hh = !1;
function $b9fb96103a9b59e3$var$Bj(a, b, c, d) {
    b.child = null === a ? $b9fb96103a9b59e3$var$Rh(b, null, c, d) : $b9fb96103a9b59e3$var$Qh(b, a.child, c, d);
}
function $b9fb96103a9b59e3$var$Cj(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $b9fb96103a9b59e3$var$gh(b, e);
    $b9fb96103a9b59e3$var$sc(b);
    d = $b9fb96103a9b59e3$var$li(a, b, c, d, f, e);
    c = $b9fb96103a9b59e3$var$qi();
    $b9fb96103a9b59e3$var$tc();
    if (null !== a && !$b9fb96103a9b59e3$var$hh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b9fb96103a9b59e3$var$Dj(a, b, e);
    $b9fb96103a9b59e3$var$J && c && $b9fb96103a9b59e3$var$Jg(b);
    b.flags |= 1;
    $b9fb96103a9b59e3$var$Bj(a, b, d, e);
    return b.child;
}
function $b9fb96103a9b59e3$var$Ej(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$b9fb96103a9b59e3$var$Fj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $b9fb96103a9b59e3$var$Gj(a, b, f, d, e);
        a = $b9fb96103a9b59e3$var$Nh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $b9fb96103a9b59e3$var$We;
        if (c(g, d) && a.ref === b.ref) return $b9fb96103a9b59e3$var$Dj(a, b, e);
    }
    b.flags |= 1;
    a = $b9fb96103a9b59e3$var$Lh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $b9fb96103a9b59e3$var$Gj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($b9fb96103a9b59e3$var$We(f, d) && a.ref === b.ref) {
            if ($b9fb96103a9b59e3$var$hh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($b9fb96103a9b59e3$var$hh = !0);
            else return b.lanes = a.lanes, $b9fb96103a9b59e3$var$Dj(a, b, e);
        }
    }
    return $b9fb96103a9b59e3$var$Hj(a, b, c, d, e);
}
function $b9fb96103a9b59e3$var$Ij(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $b9fb96103a9b59e3$var$H($b9fb96103a9b59e3$var$Jj, $b9fb96103a9b59e3$var$Kj), $b9fb96103a9b59e3$var$Kj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $b9fb96103a9b59e3$var$H($b9fb96103a9b59e3$var$Jj, $b9fb96103a9b59e3$var$Kj), $b9fb96103a9b59e3$var$Kj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $b9fb96103a9b59e3$var$H($b9fb96103a9b59e3$var$Jj, $b9fb96103a9b59e3$var$Kj);
            $b9fb96103a9b59e3$var$Kj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $b9fb96103a9b59e3$var$H($b9fb96103a9b59e3$var$Jj, $b9fb96103a9b59e3$var$Kj), $b9fb96103a9b59e3$var$Kj |= d;
    $b9fb96103a9b59e3$var$Bj(a, b, e, c);
    return b.child;
}
function $b9fb96103a9b59e3$var$Lj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $b9fb96103a9b59e3$var$Hj(a, b, c, d, e) {
    var f = $b9fb96103a9b59e3$var$mg(c) ? $b9fb96103a9b59e3$var$kg : $b9fb96103a9b59e3$var$I.current;
    f = $b9fb96103a9b59e3$var$lg(b, f);
    $b9fb96103a9b59e3$var$gh(b, e);
    $b9fb96103a9b59e3$var$sc(b);
    c = $b9fb96103a9b59e3$var$li(a, b, c, d, f, e);
    d = $b9fb96103a9b59e3$var$qi();
    $b9fb96103a9b59e3$var$tc();
    if (null !== a && !$b9fb96103a9b59e3$var$hh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b9fb96103a9b59e3$var$Dj(a, b, e);
    $b9fb96103a9b59e3$var$J && d && $b9fb96103a9b59e3$var$Jg(b);
    b.flags |= 1;
    $b9fb96103a9b59e3$var$Bj(a, b, c, e);
    return b.child;
}
function $b9fb96103a9b59e3$var$Mj(a, b, c, d, e) {
    if ($b9fb96103a9b59e3$var$mg(c)) {
        var f = !0;
        $b9fb96103a9b59e3$var$qg(b);
    } else f = !1;
    $b9fb96103a9b59e3$var$gh(b, e);
    if (null === b.stateNode) $b9fb96103a9b59e3$var$Nj(a, b), $b9fb96103a9b59e3$var$Eh(b, c, d), $b9fb96103a9b59e3$var$Gh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $b9fb96103a9b59e3$var$ih(l) : (l = $b9fb96103a9b59e3$var$mg(c) ? $b9fb96103a9b59e3$var$kg : $b9fb96103a9b59e3$var$I.current, l = $b9fb96103a9b59e3$var$lg(b, l));
        var n = c.getDerivedStateFromProps, q = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $b9fb96103a9b59e3$var$Fh(b, g, d, l);
        $b9fb96103a9b59e3$var$nh = !1;
        var r = b.memoizedState;
        g.state = r;
        $b9fb96103a9b59e3$var$uh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $b9fb96103a9b59e3$var$jg.current || $b9fb96103a9b59e3$var$nh ? ("function" === typeof n && ($b9fb96103a9b59e3$var$yh(b, c, n, d), k = b.memoizedState), (h = $b9fb96103a9b59e3$var$nh || $b9fb96103a9b59e3$var$Dh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $b9fb96103a9b59e3$var$ph(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $b9fb96103a9b59e3$var$Zg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $b9fb96103a9b59e3$var$ih(k) : (k = $b9fb96103a9b59e3$var$mg(c) ? $b9fb96103a9b59e3$var$kg : $b9fb96103a9b59e3$var$I.current, k = $b9fb96103a9b59e3$var$lg(b, k));
        var z = c.getDerivedStateFromProps;
        (n = "function" === typeof z || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $b9fb96103a9b59e3$var$Fh(b, g, d, k);
        $b9fb96103a9b59e3$var$nh = !1;
        r = b.memoizedState;
        g.state = r;
        $b9fb96103a9b59e3$var$uh(b, d, g, e);
        var m = b.memoizedState;
        h !== q || r !== m || $b9fb96103a9b59e3$var$jg.current || $b9fb96103a9b59e3$var$nh ? ("function" === typeof z && ($b9fb96103a9b59e3$var$yh(b, c, z, d), m = b.memoizedState), (l = $b9fb96103a9b59e3$var$nh || $b9fb96103a9b59e3$var$Dh(b, c, l, d, r, m, k) || !1) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, m, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, m, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = m), g.props = d, g.state = m, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $b9fb96103a9b59e3$var$Oj(a, b, c, d, f, e);
}
function $b9fb96103a9b59e3$var$Oj(a, b, c, d, e, f) {
    $b9fb96103a9b59e3$var$Lj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $b9fb96103a9b59e3$var$rg(b, c, !1), $b9fb96103a9b59e3$var$Dj(a, b, f);
    d = b.stateNode;
    $b9fb96103a9b59e3$var$Aj.current = b;
    if (g && "function" !== typeof c.getDerivedStateFromError) {
        var h = null;
        $b9fb96103a9b59e3$var$dj = -1;
    } else $b9fb96103a9b59e3$var$sc(b), h = d.render(), $b9fb96103a9b59e3$var$tc();
    b.flags |= 1;
    null !== a && g ? (g = h, b.child = $b9fb96103a9b59e3$var$Qh(b, a.child, null, f), b.child = $b9fb96103a9b59e3$var$Qh(b, null, g, f)) : $b9fb96103a9b59e3$var$Bj(a, b, h, f);
    b.memoizedState = d.state;
    e && $b9fb96103a9b59e3$var$rg(b, c, !0);
    return b.child;
}
function $b9fb96103a9b59e3$var$Pj(a) {
    var b = a.stateNode;
    b.pendingContext ? $b9fb96103a9b59e3$var$og(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $b9fb96103a9b59e3$var$og(a, b.context, !1);
    $b9fb96103a9b59e3$var$Xh(a, b.containerInfo);
}
function $b9fb96103a9b59e3$var$Qj(a, b, c, d, e) {
    $b9fb96103a9b59e3$var$Wg();
    $b9fb96103a9b59e3$var$Xg(e);
    b.flags |= 256;
    $b9fb96103a9b59e3$var$Bj(a, b, c, d);
    return b.child;
}
var $b9fb96103a9b59e3$var$Tj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $b9fb96103a9b59e3$var$Uj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $b9fb96103a9b59e3$var$Vj(a, b, c) {
    var d = b.pendingProps, e = $b9fb96103a9b59e3$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $b9fb96103a9b59e3$var$H($b9fb96103a9b59e3$var$L, e & 1);
    if (null === a) {
        $b9fb96103a9b59e3$var$Sg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g, b.mode & 2 && (f.actualDuration = 0, f.actualStartTime = -1, f.selfBaseDuration = 0, f.treeBaseDuration = 0)) : f = $b9fb96103a9b59e3$var$Wj(g, d, 0, null), a = $b9fb96103a9b59e3$var$Ph(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $b9fb96103a9b59e3$var$Uj(c), b.memoizedState = $b9fb96103a9b59e3$var$Tj, a) : $b9fb96103a9b59e3$var$Xj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $b9fb96103a9b59e3$var$Yj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.mode & 2 && (d.actualDuration = 0, d.actualStartTime = -1, d.selfBaseDuration = e.selfBaseDuration, d.treeBaseDuration = e.treeBaseDuration), b.deletions = null) : (d = $b9fb96103a9b59e3$var$Lh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $b9fb96103a9b59e3$var$Lh(h, f) : (f = $b9fb96103a9b59e3$var$Ph(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $b9fb96103a9b59e3$var$Uj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $b9fb96103a9b59e3$var$Tj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $b9fb96103a9b59e3$var$Lh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $b9fb96103a9b59e3$var$Xj(a, b) {
    b = $b9fb96103a9b59e3$var$Wj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $b9fb96103a9b59e3$var$Zj(a, b, c, d) {
    null !== d && $b9fb96103a9b59e3$var$Xg(d);
    $b9fb96103a9b59e3$var$Qh(b, a.child, null, c);
    a = $b9fb96103a9b59e3$var$Xj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $b9fb96103a9b59e3$var$Yj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $b9fb96103a9b59e3$var$nj(Error($b9fb96103a9b59e3$var$p(422))), $b9fb96103a9b59e3$var$Zj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $b9fb96103a9b59e3$var$Wj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $b9fb96103a9b59e3$var$Ph(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $b9fb96103a9b59e3$var$Qh(b, a.child, null, g);
        b.child.memoizedState = $b9fb96103a9b59e3$var$Uj(g);
        b.memoizedState = $b9fb96103a9b59e3$var$Tj;
        return f;
    }
    if (0 === (b.mode & 1)) return $b9fb96103a9b59e3$var$Zj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($b9fb96103a9b59e3$var$p(419));
        d = $b9fb96103a9b59e3$var$nj(f, d, void 0);
        return $b9fb96103a9b59e3$var$Zj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($b9fb96103a9b59e3$var$hh || h) {
        d = $b9fb96103a9b59e3$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $b9fb96103a9b59e3$var$mh(a, e), $b9fb96103a9b59e3$var$Bh(d, a, e, -1));
        }
        $b9fb96103a9b59e3$var$ak();
        d = $b9fb96103a9b59e3$var$nj(Error($b9fb96103a9b59e3$var$p(421)));
        return $b9fb96103a9b59e3$var$Zj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $b9fb96103a9b59e3$var$bk.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $b9fb96103a9b59e3$var$Mg = $b9fb96103a9b59e3$var$Zf(e.nextSibling);
    $b9fb96103a9b59e3$var$Lg = b;
    $b9fb96103a9b59e3$var$J = !0;
    $b9fb96103a9b59e3$var$Ng = null;
    null !== a && ($b9fb96103a9b59e3$var$Cg[$b9fb96103a9b59e3$var$Dg++] = $b9fb96103a9b59e3$var$Fg, $b9fb96103a9b59e3$var$Cg[$b9fb96103a9b59e3$var$Dg++] = $b9fb96103a9b59e3$var$Gg, $b9fb96103a9b59e3$var$Cg[$b9fb96103a9b59e3$var$Dg++] = $b9fb96103a9b59e3$var$Eg, $b9fb96103a9b59e3$var$Fg = a.id, $b9fb96103a9b59e3$var$Gg = a.overflow, $b9fb96103a9b59e3$var$Eg = b);
    b = $b9fb96103a9b59e3$var$Xj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $b9fb96103a9b59e3$var$ck(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $b9fb96103a9b59e3$var$fh(a.return, b, c);
}
function $b9fb96103a9b59e3$var$dk(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $b9fb96103a9b59e3$var$ek(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $b9fb96103a9b59e3$var$Bj(a, b, d.children, c);
    d = $b9fb96103a9b59e3$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $b9fb96103a9b59e3$var$ck(a, c, b);
            else if (19 === a.tag) $b9fb96103a9b59e3$var$ck(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $b9fb96103a9b59e3$var$H($b9fb96103a9b59e3$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $b9fb96103a9b59e3$var$ai(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $b9fb96103a9b59e3$var$dk(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $b9fb96103a9b59e3$var$ai(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $b9fb96103a9b59e3$var$dk(b, !0, c, null, f);
            break;
        case "together":
            $b9fb96103a9b59e3$var$dk(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $b9fb96103a9b59e3$var$Nj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $b9fb96103a9b59e3$var$Dj(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $b9fb96103a9b59e3$var$dj = -1;
    $b9fb96103a9b59e3$var$vh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($b9fb96103a9b59e3$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $b9fb96103a9b59e3$var$Lh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $b9fb96103a9b59e3$var$Lh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $b9fb96103a9b59e3$var$fk(a, b, c) {
    switch(b.tag){
        case 3:
            $b9fb96103a9b59e3$var$Pj(b);
            $b9fb96103a9b59e3$var$Wg();
            break;
        case 5:
            $b9fb96103a9b59e3$var$Zh(b);
            break;
        case 1:
            $b9fb96103a9b59e3$var$mg(b.type) && $b9fb96103a9b59e3$var$qg(b);
            break;
        case 4:
            $b9fb96103a9b59e3$var$Xh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $b9fb96103a9b59e3$var$H($b9fb96103a9b59e3$var$$g, d._currentValue);
            d._currentValue = e;
            break;
        case 12:
            0 !== (c & b.childLanes) && (b.flags |= 4);
            d = b.stateNode;
            d.effectDuration = 0;
            d.passiveEffectDuration = 0;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $b9fb96103a9b59e3$var$H($b9fb96103a9b59e3$var$L, $b9fb96103a9b59e3$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $b9fb96103a9b59e3$var$Vj(a, b, c);
                $b9fb96103a9b59e3$var$H($b9fb96103a9b59e3$var$L, $b9fb96103a9b59e3$var$L.current & 1);
                a = $b9fb96103a9b59e3$var$Dj(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $b9fb96103a9b59e3$var$H($b9fb96103a9b59e3$var$L, $b9fb96103a9b59e3$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $b9fb96103a9b59e3$var$ek(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $b9fb96103a9b59e3$var$H($b9fb96103a9b59e3$var$L, $b9fb96103a9b59e3$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $b9fb96103a9b59e3$var$Ij(a, b, c);
    }
    return $b9fb96103a9b59e3$var$Dj(a, b, c);
}
var $b9fb96103a9b59e3$var$gk, $b9fb96103a9b59e3$var$hk, $b9fb96103a9b59e3$var$ik, $b9fb96103a9b59e3$var$jk;
$b9fb96103a9b59e3$var$gk = function gk(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$b9fb96103a9b59e3$var$hk = function hk() {};
$b9fb96103a9b59e3$var$ik = function ik(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $b9fb96103a9b59e3$var$Wh($b9fb96103a9b59e3$var$Th.current);
        var f = null;
        switch(c){
            case "input":
                e = $b9fb96103a9b59e3$var$Ya(a, e);
                d = $b9fb96103a9b59e3$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $b9fb96103a9b59e3$var$u({}, e, {
                    value: void 0
                });
                d = $b9fb96103a9b59e3$var$u({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $b9fb96103a9b59e3$var$fb(a, e);
                d = $b9fb96103a9b59e3$var$fb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $b9fb96103a9b59e3$var$Pf);
        }
        $b9fb96103a9b59e3$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($b9fb96103a9b59e3$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($b9fb96103a9b59e3$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $b9fb96103a9b59e3$var$F("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$b9fb96103a9b59e3$var$jk = function jk(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $b9fb96103a9b59e3$var$kk(a, b) {
    if (!$b9fb96103a9b59e3$var$J) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $b9fb96103a9b59e3$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) {
        if (0 !== (a.mode & 2)) {
            for(var e = a.selfBaseDuration, f = a.child; null !== f;)c |= f.lanes | f.childLanes, d |= f.subtreeFlags & 14680064, d |= f.flags & 14680064, e += f.treeBaseDuration, f = f.sibling;
            a.treeBaseDuration = e;
        } else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    } else if (0 !== (a.mode & 2)) {
        e = a.actualDuration;
        f = a.selfBaseDuration;
        for(var g = a.child; null !== g;)c |= g.lanes | g.childLanes, d |= g.subtreeFlags, d |= g.flags, e += g.actualDuration, f += g.treeBaseDuration, g = g.sibling;
        a.actualDuration = e;
        a.treeBaseDuration = f;
    } else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $b9fb96103a9b59e3$var$lk(a, b, c) {
    var d = b.pendingProps;
    $b9fb96103a9b59e3$var$Kg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $b9fb96103a9b59e3$var$S(b), null;
        case 1:
            return $b9fb96103a9b59e3$var$mg(b.type) && $b9fb96103a9b59e3$var$ng(), $b9fb96103a9b59e3$var$S(b), null;
        case 3:
            d = b.stateNode;
            $b9fb96103a9b59e3$var$Yh();
            $b9fb96103a9b59e3$var$G($b9fb96103a9b59e3$var$jg);
            $b9fb96103a9b59e3$var$G($b9fb96103a9b59e3$var$I);
            $b9fb96103a9b59e3$var$ci();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $b9fb96103a9b59e3$var$Ug(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $b9fb96103a9b59e3$var$Ng && ($b9fb96103a9b59e3$var$mk($b9fb96103a9b59e3$var$Ng), $b9fb96103a9b59e3$var$Ng = null));
            $b9fb96103a9b59e3$var$hk(a, b);
            $b9fb96103a9b59e3$var$S(b);
            return null;
        case 5:
            $b9fb96103a9b59e3$var$$h(b);
            var e = $b9fb96103a9b59e3$var$Wh($b9fb96103a9b59e3$var$Vh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $b9fb96103a9b59e3$var$ik(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($b9fb96103a9b59e3$var$p(166));
                    $b9fb96103a9b59e3$var$S(b);
                    return null;
                }
                a = $b9fb96103a9b59e3$var$Wh($b9fb96103a9b59e3$var$Th.current);
                if ($b9fb96103a9b59e3$var$Ug(b)) {
                    d = b.stateNode;
                    a = b.type;
                    c = b.memoizedProps;
                    d[$b9fb96103a9b59e3$var$bg] = b;
                    d[$b9fb96103a9b59e3$var$cg] = c;
                    var f = 0 !== (b.mode & 1);
                    switch(a){
                        case "dialog":
                            $b9fb96103a9b59e3$var$F("cancel", d);
                            $b9fb96103a9b59e3$var$F("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $b9fb96103a9b59e3$var$F("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $b9fb96103a9b59e3$var$zf.length; e++)$b9fb96103a9b59e3$var$F($b9fb96103a9b59e3$var$zf[e], d);
                            break;
                        case "source":
                            $b9fb96103a9b59e3$var$F("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $b9fb96103a9b59e3$var$F("error", d);
                            $b9fb96103a9b59e3$var$F("load", d);
                            break;
                        case "details":
                            $b9fb96103a9b59e3$var$F("toggle", d);
                            break;
                        case "input":
                            $b9fb96103a9b59e3$var$Za(d, c);
                            $b9fb96103a9b59e3$var$F("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!c.multiple
                            };
                            $b9fb96103a9b59e3$var$F("invalid", d);
                            break;
                        case "textarea":
                            $b9fb96103a9b59e3$var$gb(d, c), $b9fb96103a9b59e3$var$F("invalid", d);
                    }
                    $b9fb96103a9b59e3$var$ub(a, c);
                    e = null;
                    for(var g in c)if (c.hasOwnProperty(g)) {
                        var h = c[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== c.suppressHydrationWarning && $b9fb96103a9b59e3$var$Of(d.textContent, h, f), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== c.suppressHydrationWarning && $b9fb96103a9b59e3$var$Of(d.textContent, h, f), e = [
                            "children",
                            "" + h
                        ]) : $b9fb96103a9b59e3$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $b9fb96103a9b59e3$var$F("scroll", d);
                    }
                    switch(a){
                        case "input":
                            $b9fb96103a9b59e3$var$Va(d);
                            $b9fb96103a9b59e3$var$cb(d, c, !0);
                            break;
                        case "textarea":
                            $b9fb96103a9b59e3$var$Va(d);
                            $b9fb96103a9b59e3$var$ib(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof c.onClick && (d.onclick = $b9fb96103a9b59e3$var$Pf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $b9fb96103a9b59e3$var$jb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$b9fb96103a9b59e3$var$bg] = b;
                    a[$b9fb96103a9b59e3$var$cg] = d;
                    $b9fb96103a9b59e3$var$gk(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $b9fb96103a9b59e3$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $b9fb96103a9b59e3$var$F("cancel", a);
                                $b9fb96103a9b59e3$var$F("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $b9fb96103a9b59e3$var$F("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $b9fb96103a9b59e3$var$zf.length; e++)$b9fb96103a9b59e3$var$F($b9fb96103a9b59e3$var$zf[e], a);
                                e = d;
                                break;
                            case "source":
                                $b9fb96103a9b59e3$var$F("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $b9fb96103a9b59e3$var$F("error", a);
                                $b9fb96103a9b59e3$var$F("load", a);
                                e = d;
                                break;
                            case "details":
                                $b9fb96103a9b59e3$var$F("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $b9fb96103a9b59e3$var$Za(a, d);
                                e = $b9fb96103a9b59e3$var$Ya(a, d);
                                $b9fb96103a9b59e3$var$F("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $b9fb96103a9b59e3$var$u({}, d, {
                                    value: void 0
                                });
                                $b9fb96103a9b59e3$var$F("invalid", a);
                                break;
                            case "textarea":
                                $b9fb96103a9b59e3$var$gb(a, d);
                                e = $b9fb96103a9b59e3$var$fb(a, d);
                                $b9fb96103a9b59e3$var$F("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $b9fb96103a9b59e3$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $b9fb96103a9b59e3$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $b9fb96103a9b59e3$var$mb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $b9fb96103a9b59e3$var$nb(a, k) : "number" === typeof k && $b9fb96103a9b59e3$var$nb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($b9fb96103a9b59e3$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $b9fb96103a9b59e3$var$F("scroll", a) : null != k && $b9fb96103a9b59e3$var$ua(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $b9fb96103a9b59e3$var$Va(a);
                                $b9fb96103a9b59e3$var$cb(a, d, !1);
                                break;
                            case "textarea":
                                $b9fb96103a9b59e3$var$Va(a);
                                $b9fb96103a9b59e3$var$ib(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $b9fb96103a9b59e3$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $b9fb96103a9b59e3$var$eb(a, !!d.multiple, f, !1) : null != d.defaultValue && $b9fb96103a9b59e3$var$eb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $b9fb96103a9b59e3$var$Pf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $b9fb96103a9b59e3$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $b9fb96103a9b59e3$var$jk(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($b9fb96103a9b59e3$var$p(166));
                a = $b9fb96103a9b59e3$var$Wh($b9fb96103a9b59e3$var$Vh.current);
                $b9fb96103a9b59e3$var$Wh($b9fb96103a9b59e3$var$Th.current);
                if ($b9fb96103a9b59e3$var$Ug(b)) {
                    d = b.stateNode;
                    a = b.memoizedProps;
                    d[$b9fb96103a9b59e3$var$bg] = b;
                    if (c = d.nodeValue !== a) {
                        if (f = $b9fb96103a9b59e3$var$Lg, null !== f) switch(f.tag){
                            case 3:
                                $b9fb96103a9b59e3$var$Of(d.nodeValue, a, 0 !== (f.mode & 1));
                                break;
                            case 5:
                                !0 !== f.memoizedProps.suppressHydrationWarning && $b9fb96103a9b59e3$var$Of(d.nodeValue, a, 0 !== (f.mode & 1));
                        }
                    }
                    c && (b.flags |= 4);
                } else d = (9 === a.nodeType ? a : a.ownerDocument).createTextNode(d), d[$b9fb96103a9b59e3$var$bg] = b, b.stateNode = d;
            }
            $b9fb96103a9b59e3$var$S(b);
            return null;
        case 13:
            $b9fb96103a9b59e3$var$G($b9fb96103a9b59e3$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($b9fb96103a9b59e3$var$J && null !== $b9fb96103a9b59e3$var$Mg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $b9fb96103a9b59e3$var$Vg(), $b9fb96103a9b59e3$var$Wg(), b.flags |= 98560, f = !1;
                else if (f = $b9fb96103a9b59e3$var$Ug(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($b9fb96103a9b59e3$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($b9fb96103a9b59e3$var$p(317));
                        f[$b9fb96103a9b59e3$var$bg] = b;
                        $b9fb96103a9b59e3$var$S(b);
                        0 !== (b.mode & 2) && null !== d && (f = b.child, null !== f && (b.treeBaseDuration -= f.treeBaseDuration));
                    } else $b9fb96103a9b59e3$var$Wg(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4, $b9fb96103a9b59e3$var$S(b), 0 !== (b.mode & 2) && null !== d && (f = b.child, null !== f && (b.treeBaseDuration -= f.treeBaseDuration));
                    f = !1;
                } else null !== $b9fb96103a9b59e3$var$Ng && ($b9fb96103a9b59e3$var$mk($b9fb96103a9b59e3$var$Ng), $b9fb96103a9b59e3$var$Ng = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, 0 !== (b.mode & 2) && $b9fb96103a9b59e3$var$lj(b), b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($b9fb96103a9b59e3$var$L.current & 1) ? 0 === $b9fb96103a9b59e3$var$T && ($b9fb96103a9b59e3$var$T = 3) : $b9fb96103a9b59e3$var$ak()));
            null !== b.updateQueue && (b.flags |= 4);
            $b9fb96103a9b59e3$var$S(b);
            0 !== (b.mode & 2) && d && (d = b.child, null !== d && (b.treeBaseDuration -= d.treeBaseDuration));
            return null;
        case 4:
            return $b9fb96103a9b59e3$var$Yh(), $b9fb96103a9b59e3$var$hk(a, b), null === a && $b9fb96103a9b59e3$var$Gf(b.stateNode.containerInfo), $b9fb96103a9b59e3$var$S(b), null;
        case 10:
            return $b9fb96103a9b59e3$var$eh(b.type._context), $b9fb96103a9b59e3$var$S(b), null;
        case 17:
            return $b9fb96103a9b59e3$var$mg(b.type) && $b9fb96103a9b59e3$var$ng(), $b9fb96103a9b59e3$var$S(b), null;
        case 19:
            $b9fb96103a9b59e3$var$G($b9fb96103a9b59e3$var$L);
            f = b.memoizedState;
            if (null === f) return $b9fb96103a9b59e3$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $b9fb96103a9b59e3$var$kk(f, !1);
                else {
                    if (0 !== $b9fb96103a9b59e3$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $b9fb96103a9b59e3$var$ai(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $b9fb96103a9b59e3$var$kk(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(a = b.child; null !== a;)c = a, g = d, c.flags &= 14680066, f = c.alternate, null === f ? (c.childLanes = 0, c.lanes = g, c.child = null, c.subtreeFlags = 0, c.memoizedProps = null, c.memoizedState = null, c.updateQueue = null, c.dependencies = null, c.stateNode = null, c.selfBaseDuration = 0, c.treeBaseDuration = 0) : (c.childLanes = f.childLanes, c.lanes = f.lanes, c.child = f.child, c.subtreeFlags = 0, c.deletions = null, c.memoizedProps = f.memoizedProps, c.memoizedState = f.memoizedState, c.updateQueue = f.updateQueue, c.type = f.type, g = f.dependencies, c.dependencies = null === g ? null : {
                                lanes: g.lanes,
                                firstContext: g.firstContext
                            }, c.selfBaseDuration = f.selfBaseDuration, c.treeBaseDuration = f.treeBaseDuration), a = a.sibling;
                            $b9fb96103a9b59e3$var$H($b9fb96103a9b59e3$var$L, $b9fb96103a9b59e3$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $b9fb96103a9b59e3$var$A() > $b9fb96103a9b59e3$var$nk && (b.flags |= 128, d = !0, $b9fb96103a9b59e3$var$kk(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $b9fb96103a9b59e3$var$ai(g), null !== a) {
                        if (b.flags |= 128, d = !0, a = a.updateQueue, null !== a && (b.updateQueue = a, b.flags |= 4), $b9fb96103a9b59e3$var$kk(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$b9fb96103a9b59e3$var$J) return $b9fb96103a9b59e3$var$S(b), null;
                    } else 2 * $b9fb96103a9b59e3$var$A() - f.renderingStartTime > $b9fb96103a9b59e3$var$nk && 1073741824 !== c && (b.flags |= 128, d = !0, $b9fb96103a9b59e3$var$kk(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (a = f.last, null !== a ? a.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $b9fb96103a9b59e3$var$A(), b.sibling = null, a = $b9fb96103a9b59e3$var$L.current, $b9fb96103a9b59e3$var$H($b9fb96103a9b59e3$var$L, d ? a & 1 | 2 : a & 1), b;
            $b9fb96103a9b59e3$var$S(b);
            return null;
        case 22:
        case 23:
            return $b9fb96103a9b59e3$var$ok(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($b9fb96103a9b59e3$var$Kj & 1073741824) && ($b9fb96103a9b59e3$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $b9fb96103a9b59e3$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($b9fb96103a9b59e3$var$p(156, b.tag));
}
function $b9fb96103a9b59e3$var$pk(a, b) {
    $b9fb96103a9b59e3$var$Kg(b);
    switch(b.tag){
        case 1:
            return $b9fb96103a9b59e3$var$mg(b.type) && $b9fb96103a9b59e3$var$ng(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, 0 !== (b.mode & 2) && $b9fb96103a9b59e3$var$lj(b), b) : null;
        case 3:
            return $b9fb96103a9b59e3$var$Yh(), $b9fb96103a9b59e3$var$G($b9fb96103a9b59e3$var$jg), $b9fb96103a9b59e3$var$G($b9fb96103a9b59e3$var$I), $b9fb96103a9b59e3$var$ci(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $b9fb96103a9b59e3$var$$h(b), null;
        case 13:
            $b9fb96103a9b59e3$var$G($b9fb96103a9b59e3$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($b9fb96103a9b59e3$var$p(340));
                $b9fb96103a9b59e3$var$Wg();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, 0 !== (b.mode & 2) && $b9fb96103a9b59e3$var$lj(b), b) : null;
        case 19:
            return $b9fb96103a9b59e3$var$G($b9fb96103a9b59e3$var$L), null;
        case 4:
            return $b9fb96103a9b59e3$var$Yh(), null;
        case 10:
            return $b9fb96103a9b59e3$var$eh(b.type._context), null;
        case 22:
        case 23:
            return $b9fb96103a9b59e3$var$ok(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $b9fb96103a9b59e3$var$qk = !1, $b9fb96103a9b59e3$var$rk = !1, $b9fb96103a9b59e3$var$sk = "function" === typeof WeakSet ? WeakSet : Set, $b9fb96103a9b59e3$var$U = null, $b9fb96103a9b59e3$var$tk = null, $b9fb96103a9b59e3$var$uk = null;
function $b9fb96103a9b59e3$var$vk(a, b) {
    b.props = a.memoizedProps;
    b.state = a.memoizedState;
    if (a.mode & 2) try {
        $b9fb96103a9b59e3$var$kj(), b.componentWillUnmount();
    } finally{
        $b9fb96103a9b59e3$var$ij(a);
    }
    else b.componentWillUnmount();
}
function $b9fb96103a9b59e3$var$wk(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            if (a.mode & 2) try {
                $b9fb96103a9b59e3$var$kj(), c(null);
            } finally{
                $b9fb96103a9b59e3$var$ij(a);
            }
            else c(null);
        } catch (d) {
            $b9fb96103a9b59e3$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $b9fb96103a9b59e3$var$xk(a, b, c) {
    try {
        c();
    } catch (d) {
        $b9fb96103a9b59e3$var$W(a, b, d);
    }
}
var $b9fb96103a9b59e3$var$yk = !1;
function $b9fb96103a9b59e3$var$zk(a, b) {
    $b9fb96103a9b59e3$var$Qf = $b9fb96103a9b59e3$var$rd;
    a = $b9fb96103a9b59e3$var$$e();
    if ($b9fb96103a9b59e3$var$af(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (D) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, n = 0, q = a, r = null;
                b: for(;;){
                    for(var z;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (z = q.firstChild)) break;
                        r = q;
                        q = z;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++n === d && (k = g);
                        if (null !== (z = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = z;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $b9fb96103a9b59e3$var$Rf = {
        focusedElem: a,
        selectionRange: c
    };
    $b9fb96103a9b59e3$var$rd = !1;
    for($b9fb96103a9b59e3$var$U = b; null !== $b9fb96103a9b59e3$var$U;)if (b = $b9fb96103a9b59e3$var$U, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $b9fb96103a9b59e3$var$U = a;
    else for(; null !== $b9fb96103a9b59e3$var$U;){
        b = $b9fb96103a9b59e3$var$U;
        try {
            var m = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== m) {
                        var w = m.memoizedProps, C = m.memoizedState, x = b.stateNode, y = x.getSnapshotBeforeUpdate(b.elementType === b.type ? w : $b9fb96103a9b59e3$var$Zg(b.type, w), C);
                        x.__reactInternalSnapshotBeforeUpdate = y;
                    }
                    break;
                case 3:
                    var v = b.stateNode.containerInfo;
                    1 === v.nodeType ? v.textContent = "" : 9 === v.nodeType && v.documentElement && v.removeChild(v.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($b9fb96103a9b59e3$var$p(163));
            }
        } catch (D) {
            $b9fb96103a9b59e3$var$W(b, b.return, D);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $b9fb96103a9b59e3$var$U = a;
            break;
        }
        $b9fb96103a9b59e3$var$U = b.return;
    }
    m = $b9fb96103a9b59e3$var$yk;
    $b9fb96103a9b59e3$var$yk = !1;
    return m;
}
function $b9fb96103a9b59e3$var$Ak(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && (0 !== (a & 8) ? null !== $b9fb96103a9b59e3$var$B && "function" === typeof $b9fb96103a9b59e3$var$B.markComponentPassiveEffectUnmountStarted && $b9fb96103a9b59e3$var$B.markComponentPassiveEffectUnmountStarted(b) : 0 !== (a & 4) && $b9fb96103a9b59e3$var$uc(b), $b9fb96103a9b59e3$var$xk(b, c, f), 0 !== (a & 8) ? null !== $b9fb96103a9b59e3$var$B && "function" === typeof $b9fb96103a9b59e3$var$B.markComponentPassiveEffectUnmountStopped && $b9fb96103a9b59e3$var$B.markComponentPassiveEffectUnmountStopped() : 0 !== (a & 4) && $b9fb96103a9b59e3$var$vc());
            }
            e = e.next;
        }while (e !== d);
    }
}
function $b9fb96103a9b59e3$var$Bk(a, b) {
    var c = b.updateQueue;
    c = null !== c ? c.lastEffect : null;
    if (null !== c) {
        var d = c = c.next;
        do {
            if ((d.tag & a) === a) {
                0 !== (a & 8) ? null !== $b9fb96103a9b59e3$var$B && "function" === typeof $b9fb96103a9b59e3$var$B.markComponentPassiveEffectMountStarted && $b9fb96103a9b59e3$var$B.markComponentPassiveEffectMountStarted(b) : 0 !== (a & 4) && null !== $b9fb96103a9b59e3$var$B && "function" === typeof $b9fb96103a9b59e3$var$B.markComponentLayoutEffectMountStarted && $b9fb96103a9b59e3$var$B.markComponentLayoutEffectMountStarted(b);
                var e = d.create;
                d.destroy = e();
                0 !== (a & 8) ? null !== $b9fb96103a9b59e3$var$B && "function" === typeof $b9fb96103a9b59e3$var$B.markComponentPassiveEffectMountStopped && $b9fb96103a9b59e3$var$B.markComponentPassiveEffectMountStopped() : 0 !== (a & 4) && null !== $b9fb96103a9b59e3$var$B && "function" === typeof $b9fb96103a9b59e3$var$B.markComponentLayoutEffectMountStopped && $b9fb96103a9b59e3$var$B.markComponentLayoutEffectMountStopped();
            }
            d = d.next;
        }while (d !== c);
    }
}
function $b9fb96103a9b59e3$var$Ck(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        if ("function" === typeof b) {
            if (a.mode & 2) try {
                $b9fb96103a9b59e3$var$kj(), b(c);
            } finally{
                $b9fb96103a9b59e3$var$ij(a);
            }
            else b(c);
        } else b.current = c;
    }
}
function $b9fb96103a9b59e3$var$Dk(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $b9fb96103a9b59e3$var$Dk(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$b9fb96103a9b59e3$var$bg], delete b[$b9fb96103a9b59e3$var$cg], delete b[$b9fb96103a9b59e3$var$Cf], delete b[$b9fb96103a9b59e3$var$dg], delete b[$b9fb96103a9b59e3$var$eg]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $b9fb96103a9b59e3$var$Ek(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $b9fb96103a9b59e3$var$Fk(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $b9fb96103a9b59e3$var$Ek(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $b9fb96103a9b59e3$var$Gk(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $b9fb96103a9b59e3$var$Pf));
    else if (4 !== d && (a = a.child, null !== a)) for($b9fb96103a9b59e3$var$Gk(a, b, c), a = a.sibling; null !== a;)$b9fb96103a9b59e3$var$Gk(a, b, c), a = a.sibling;
}
function $b9fb96103a9b59e3$var$Hk(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($b9fb96103a9b59e3$var$Hk(a, b, c), a = a.sibling; null !== a;)$b9fb96103a9b59e3$var$Hk(a, b, c), a = a.sibling;
}
var $b9fb96103a9b59e3$var$X = null, $b9fb96103a9b59e3$var$Ik = !1;
function $b9fb96103a9b59e3$var$Jk(a, b, c) {
    for(c = c.child; null !== c;)$b9fb96103a9b59e3$var$Kk(a, b, c), c = c.sibling;
}
function $b9fb96103a9b59e3$var$Kk(a, b, c) {
    if ($b9fb96103a9b59e3$var$lc && "function" === typeof $b9fb96103a9b59e3$var$lc.onCommitFiberUnmount) try {
        $b9fb96103a9b59e3$var$lc.onCommitFiberUnmount($b9fb96103a9b59e3$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $b9fb96103a9b59e3$var$rk || $b9fb96103a9b59e3$var$wk(c, b);
        case 6:
            var d = $b9fb96103a9b59e3$var$X, e = $b9fb96103a9b59e3$var$Ik;
            $b9fb96103a9b59e3$var$X = null;
            $b9fb96103a9b59e3$var$Jk(a, b, c);
            $b9fb96103a9b59e3$var$X = d;
            $b9fb96103a9b59e3$var$Ik = e;
            null !== $b9fb96103a9b59e3$var$X && ($b9fb96103a9b59e3$var$Ik ? (a = $b9fb96103a9b59e3$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $b9fb96103a9b59e3$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $b9fb96103a9b59e3$var$X && ($b9fb96103a9b59e3$var$Ik ? (a = $b9fb96103a9b59e3$var$X, c = c.stateNode, 8 === a.nodeType ? $b9fb96103a9b59e3$var$Yf(a.parentNode, c) : 1 === a.nodeType && $b9fb96103a9b59e3$var$Yf(a, c), $b9fb96103a9b59e3$var$pd(a)) : $b9fb96103a9b59e3$var$Yf($b9fb96103a9b59e3$var$X, c.stateNode));
            break;
        case 4:
            d = $b9fb96103a9b59e3$var$X;
            e = $b9fb96103a9b59e3$var$Ik;
            $b9fb96103a9b59e3$var$X = c.stateNode.containerInfo;
            $b9fb96103a9b59e3$var$Ik = !0;
            $b9fb96103a9b59e3$var$Jk(a, b, c);
            $b9fb96103a9b59e3$var$X = d;
            $b9fb96103a9b59e3$var$Ik = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$b9fb96103a9b59e3$var$rk && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $b9fb96103a9b59e3$var$xk(c, b, g) : 0 !== (f & 4) && ($b9fb96103a9b59e3$var$uc(c), c.mode & 2 ? ($b9fb96103a9b59e3$var$kj(), $b9fb96103a9b59e3$var$xk(c, b, g), $b9fb96103a9b59e3$var$ij(c)) : $b9fb96103a9b59e3$var$xk(c, b, g), $b9fb96103a9b59e3$var$vc()));
                    e = e.next;
                }while (e !== d);
            }
            $b9fb96103a9b59e3$var$Jk(a, b, c);
            break;
        case 1:
            if (!$b9fb96103a9b59e3$var$rk && ($b9fb96103a9b59e3$var$wk(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                $b9fb96103a9b59e3$var$vk(c, d);
            } catch (h) {
                $b9fb96103a9b59e3$var$W(c, b, h);
            }
            $b9fb96103a9b59e3$var$Jk(a, b, c);
            break;
        case 21:
            $b9fb96103a9b59e3$var$Jk(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($b9fb96103a9b59e3$var$rk = (d = $b9fb96103a9b59e3$var$rk) || null !== c.memoizedState, $b9fb96103a9b59e3$var$Jk(a, b, c), $b9fb96103a9b59e3$var$rk = d) : $b9fb96103a9b59e3$var$Jk(a, b, c);
            break;
        default:
            $b9fb96103a9b59e3$var$Jk(a, b, c);
    }
}
function $b9fb96103a9b59e3$var$Lk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $b9fb96103a9b59e3$var$sk);
        b.forEach(function(b) {
            var d = $b9fb96103a9b59e3$var$Mk.bind(null, a, b);
            if (!c.has(b)) {
                c.add(b);
                if ($b9fb96103a9b59e3$var$mc) {
                    if (null !== $b9fb96103a9b59e3$var$tk && null !== $b9fb96103a9b59e3$var$uk) $b9fb96103a9b59e3$var$xj($b9fb96103a9b59e3$var$uk, $b9fb96103a9b59e3$var$tk);
                    else throw Error($b9fb96103a9b59e3$var$p(413));
                }
                b.then(d, d);
            }
        });
    }
}
function $b9fb96103a9b59e3$var$Nk(a, b, c) {
    $b9fb96103a9b59e3$var$tk = c;
    $b9fb96103a9b59e3$var$uk = a;
    $b9fb96103a9b59e3$var$Ok(b, a);
    $b9fb96103a9b59e3$var$uk = $b9fb96103a9b59e3$var$tk = null;
}
function $b9fb96103a9b59e3$var$Pk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $b9fb96103a9b59e3$var$X = h.stateNode;
                        $b9fb96103a9b59e3$var$Ik = !1;
                        break a;
                    case 3:
                        $b9fb96103a9b59e3$var$X = h.stateNode.containerInfo;
                        $b9fb96103a9b59e3$var$Ik = !0;
                        break a;
                    case 4:
                        $b9fb96103a9b59e3$var$X = h.stateNode.containerInfo;
                        $b9fb96103a9b59e3$var$Ik = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $b9fb96103a9b59e3$var$X) throw Error($b9fb96103a9b59e3$var$p(160));
            $b9fb96103a9b59e3$var$Kk(f, g, e);
            $b9fb96103a9b59e3$var$X = null;
            $b9fb96103a9b59e3$var$Ik = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $b9fb96103a9b59e3$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$b9fb96103a9b59e3$var$Ok(b, a), b = b.sibling;
}
function $b9fb96103a9b59e3$var$Ok(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $b9fb96103a9b59e3$var$Pk(b, a);
            $b9fb96103a9b59e3$var$Qk(a);
            if (d & 4) {
                try {
                    $b9fb96103a9b59e3$var$Ak(3, a, a.return), $b9fb96103a9b59e3$var$Bk(3, a);
                } catch (m) {
                    $b9fb96103a9b59e3$var$W(a, a.return, m);
                }
                if (a.mode & 2) {
                    try {
                        $b9fb96103a9b59e3$var$kj(), $b9fb96103a9b59e3$var$Ak(5, a, a.return);
                    } catch (m) {
                        $b9fb96103a9b59e3$var$W(a, a.return, m);
                    }
                    $b9fb96103a9b59e3$var$ij(a);
                } else try {
                    $b9fb96103a9b59e3$var$Ak(5, a, a.return);
                } catch (m) {
                    $b9fb96103a9b59e3$var$W(a, a.return, m);
                }
            }
            break;
        case 1:
            $b9fb96103a9b59e3$var$Pk(b, a);
            $b9fb96103a9b59e3$var$Qk(a);
            d & 512 && null !== c && $b9fb96103a9b59e3$var$wk(c, c.return);
            break;
        case 5:
            $b9fb96103a9b59e3$var$Pk(b, a);
            $b9fb96103a9b59e3$var$Qk(a);
            d & 512 && null !== c && $b9fb96103a9b59e3$var$wk(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $b9fb96103a9b59e3$var$nb(e, "");
                } catch (m) {
                    $b9fb96103a9b59e3$var$W(a, a.return, m);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $b9fb96103a9b59e3$var$$a(e, f);
                    $b9fb96103a9b59e3$var$vb(h, g);
                    var l = $b9fb96103a9b59e3$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var n = k[g], q = k[g + 1];
                        "style" === n ? $b9fb96103a9b59e3$var$sb(e, q) : "dangerouslySetInnerHTML" === n ? $b9fb96103a9b59e3$var$mb(e, q) : "children" === n ? $b9fb96103a9b59e3$var$nb(e, q) : $b9fb96103a9b59e3$var$ua(e, n, q, l);
                    }
                    switch(h){
                        case "input":
                            $b9fb96103a9b59e3$var$ab(e, f);
                            break;
                        case "textarea":
                            $b9fb96103a9b59e3$var$hb(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var z = f.value;
                            null != z ? $b9fb96103a9b59e3$var$eb(e, !!f.multiple, z, !1) : r !== !!f.multiple && (null != f.defaultValue ? $b9fb96103a9b59e3$var$eb(e, !!f.multiple, f.defaultValue, !0) : $b9fb96103a9b59e3$var$eb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$b9fb96103a9b59e3$var$cg] = f;
                } catch (m) {
                    $b9fb96103a9b59e3$var$W(a, a.return, m);
                }
            }
            break;
        case 6:
            $b9fb96103a9b59e3$var$Pk(b, a);
            $b9fb96103a9b59e3$var$Qk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($b9fb96103a9b59e3$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (m) {
                    $b9fb96103a9b59e3$var$W(a, a.return, m);
                }
            }
            break;
        case 3:
            $b9fb96103a9b59e3$var$Pk(b, a);
            $b9fb96103a9b59e3$var$Qk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $b9fb96103a9b59e3$var$pd(b.containerInfo);
            } catch (m) {
                $b9fb96103a9b59e3$var$W(a, a.return, m);
            }
            break;
        case 4:
            $b9fb96103a9b59e3$var$Pk(b, a);
            $b9fb96103a9b59e3$var$Qk(a);
            break;
        case 13:
            $b9fb96103a9b59e3$var$Pk(b, a);
            $b9fb96103a9b59e3$var$Qk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($b9fb96103a9b59e3$var$Rk = $b9fb96103a9b59e3$var$A()));
            d & 4 && $b9fb96103a9b59e3$var$Lk(a);
            break;
        case 22:
            n = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($b9fb96103a9b59e3$var$rk = (l = $b9fb96103a9b59e3$var$rk) || n, $b9fb96103a9b59e3$var$Pk(b, a), $b9fb96103a9b59e3$var$rk = l) : $b9fb96103a9b59e3$var$Pk(b, a);
            $b9fb96103a9b59e3$var$Qk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !n && 0 !== (a.mode & 1)) for($b9fb96103a9b59e3$var$U = a, n = a.child; null !== n;){
                    for(q = $b9fb96103a9b59e3$var$U = n; null !== $b9fb96103a9b59e3$var$U;){
                        r = $b9fb96103a9b59e3$var$U;
                        z = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                if (r.mode & 2) try {
                                    $b9fb96103a9b59e3$var$kj(), $b9fb96103a9b59e3$var$Ak(4, r, r.return);
                                } finally{
                                    $b9fb96103a9b59e3$var$ij(r);
                                }
                                else $b9fb96103a9b59e3$var$Ak(4, r, r.return);
                                break;
                            case 1:
                                $b9fb96103a9b59e3$var$wk(r, r.return);
                                d = r.stateNode;
                                if ("function" === typeof d.componentWillUnmount) {
                                    c = r;
                                    b = r.return;
                                    try {
                                        $b9fb96103a9b59e3$var$vk(c, d);
                                    } catch (m) {
                                        $b9fb96103a9b59e3$var$W(c, b, m);
                                    }
                                }
                                break;
                            case 5:
                                $b9fb96103a9b59e3$var$wk(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $b9fb96103a9b59e3$var$Sk(q);
                                    continue;
                                }
                        }
                        null !== z ? (z.return = r, $b9fb96103a9b59e3$var$U = z) : $b9fb96103a9b59e3$var$Sk(q);
                    }
                    n = n.sibling;
                }
                a: for(n = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === n) {
                            n = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $b9fb96103a9b59e3$var$rb("display", g));
                            } catch (m) {
                                $b9fb96103a9b59e3$var$W(a, a.return, m);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === n) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (m) {
                            $b9fb96103a9b59e3$var$W(a, a.return, m);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        n === q && (n = null);
                        q = q.return;
                    }
                    n === q && (n = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $b9fb96103a9b59e3$var$Pk(b, a);
            $b9fb96103a9b59e3$var$Qk(a);
            d & 4 && $b9fb96103a9b59e3$var$Lk(a);
            break;
        case 21:
            break;
        default:
            $b9fb96103a9b59e3$var$Pk(b, a), $b9fb96103a9b59e3$var$Qk(a);
    }
}
function $b9fb96103a9b59e3$var$Qk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($b9fb96103a9b59e3$var$Ek(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($b9fb96103a9b59e3$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($b9fb96103a9b59e3$var$nb(e, ""), d.flags &= -33);
                    var f = $b9fb96103a9b59e3$var$Fk(a);
                    $b9fb96103a9b59e3$var$Hk(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $b9fb96103a9b59e3$var$Fk(a);
                    $b9fb96103a9b59e3$var$Gk(a, h, g);
                    break;
                default:
                    throw Error($b9fb96103a9b59e3$var$p(161));
            }
        } catch (k) {
            $b9fb96103a9b59e3$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $b9fb96103a9b59e3$var$Tk(a, b, c) {
    $b9fb96103a9b59e3$var$tk = c;
    $b9fb96103a9b59e3$var$uk = b;
    $b9fb96103a9b59e3$var$U = a;
    $b9fb96103a9b59e3$var$Uk(a, b, c);
    $b9fb96103a9b59e3$var$uk = $b9fb96103a9b59e3$var$tk = null;
}
function $b9fb96103a9b59e3$var$Uk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $b9fb96103a9b59e3$var$U;){
        var e = $b9fb96103a9b59e3$var$U, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $b9fb96103a9b59e3$var$qk;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $b9fb96103a9b59e3$var$rk;
                h = $b9fb96103a9b59e3$var$qk;
                var l = $b9fb96103a9b59e3$var$rk;
                $b9fb96103a9b59e3$var$qk = g;
                if (($b9fb96103a9b59e3$var$rk = k) && !l) for($b9fb96103a9b59e3$var$U = e; null !== $b9fb96103a9b59e3$var$U;)g = $b9fb96103a9b59e3$var$U, k = g.child, 22 === g.tag && null !== g.memoizedState ? $b9fb96103a9b59e3$var$Vk(e) : null !== k ? (k.return = g, $b9fb96103a9b59e3$var$U = k) : $b9fb96103a9b59e3$var$Vk(e);
                for(; null !== f;)$b9fb96103a9b59e3$var$U = f, $b9fb96103a9b59e3$var$Uk(f, b, c), f = f.sibling;
                $b9fb96103a9b59e3$var$U = e;
                $b9fb96103a9b59e3$var$qk = h;
                $b9fb96103a9b59e3$var$rk = l;
            }
            $b9fb96103a9b59e3$var$Wk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $b9fb96103a9b59e3$var$U = f) : $b9fb96103a9b59e3$var$Wk(a, b, c);
    }
}
function $b9fb96103a9b59e3$var$Wk(a) {
    for(; null !== $b9fb96103a9b59e3$var$U;){
        var b = $b9fb96103a9b59e3$var$U;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        if (!$b9fb96103a9b59e3$var$rk) {
                            if (b.mode & 2) try {
                                $b9fb96103a9b59e3$var$kj(), $b9fb96103a9b59e3$var$Bk(5, b);
                            } finally{
                                $b9fb96103a9b59e3$var$ij(b);
                            }
                            else $b9fb96103a9b59e3$var$Bk(5, b);
                        }
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$b9fb96103a9b59e3$var$rk) {
                            if (null === c) {
                                if (b.mode & 2) try {
                                    $b9fb96103a9b59e3$var$kj(), d.componentDidMount();
                                } finally{
                                    $b9fb96103a9b59e3$var$ij(b);
                                }
                                else d.componentDidMount();
                            } else {
                                var e = b.elementType === b.type ? c.memoizedProps : $b9fb96103a9b59e3$var$Zg(b.type, c.memoizedProps), f = c.memoizedState;
                                if (b.mode & 2) try {
                                    $b9fb96103a9b59e3$var$kj(), d.componentDidUpdate(e, f, d.__reactInternalSnapshotBeforeUpdate);
                                } finally{
                                    $b9fb96103a9b59e3$var$ij(b);
                                }
                                else d.componentDidUpdate(e, f, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var g = b.updateQueue;
                        null !== g && $b9fb96103a9b59e3$var$wh(b, g, d);
                        break;
                    case 3:
                        var h = b.updateQueue;
                        if (null !== h) {
                            var k = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    k = b.child.stateNode;
                                    break;
                                case 1:
                                    k = b.child.stateNode;
                            }
                            $b9fb96103a9b59e3$var$wh(b, h, k);
                        }
                        break;
                    case 5:
                        var l = b.stateNode;
                        if (null === c && b.flags & 4) {
                            k = l;
                            var n = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    n.autoFocus && k.focus();
                                    break;
                                case "img":
                                    n.src && (k.src = n.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        var q = b.memoizedProps, r = q.onCommit, z = q.onRender, m = b.stateNode.effectDuration;
                        k = $b9fb96103a9b59e3$var$bj;
                        c = null === c ? "mount" : "update";
                        $b9fb96103a9b59e3$var$fj && (c = "nested-update");
                        "function" === typeof z && z(b.memoizedProps.id, c, b.actualDuration, b.treeBaseDuration, b.actualStartTime, k);
                        "function" === typeof r && r(b.memoizedProps.id, c, m, k);
                        $b9fb96103a9b59e3$var$Xk(b);
                        var w = b.return;
                        a: for(; null !== w;){
                            switch(w.tag){
                                case 3:
                                    w.stateNode.effectDuration += m;
                                    break a;
                                case 12:
                                    w.stateNode.effectDuration += m;
                                    break a;
                            }
                            w = w.return;
                        }
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var C = b.alternate;
                            if (null !== C) {
                                var x = C.memoizedState;
                                if (null !== x) {
                                    var y = x.dehydrated;
                                    null !== y && $b9fb96103a9b59e3$var$pd(y);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($b9fb96103a9b59e3$var$p(163));
                }
                $b9fb96103a9b59e3$var$rk || b.flags & 512 && $b9fb96103a9b59e3$var$Ck(b);
            } catch (v) {
                $b9fb96103a9b59e3$var$W(b, b.return, v);
            }
        }
        if (b === a) {
            $b9fb96103a9b59e3$var$U = null;
            break;
        }
        k = b.sibling;
        if (null !== k) {
            k.return = b.return;
            $b9fb96103a9b59e3$var$U = k;
            break;
        }
        $b9fb96103a9b59e3$var$U = b.return;
    }
}
function $b9fb96103a9b59e3$var$Sk(a) {
    for(; null !== $b9fb96103a9b59e3$var$U;){
        var b = $b9fb96103a9b59e3$var$U;
        if (b === a) {
            $b9fb96103a9b59e3$var$U = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b9fb96103a9b59e3$var$U = c;
            break;
        }
        $b9fb96103a9b59e3$var$U = b.return;
    }
}
function $b9fb96103a9b59e3$var$Vk(a) {
    for(; null !== $b9fb96103a9b59e3$var$U;){
        var b = $b9fb96103a9b59e3$var$U;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    if (b.mode & 2) try {
                        $b9fb96103a9b59e3$var$kj();
                        var c = b.return;
                        try {
                            $b9fb96103a9b59e3$var$Bk(4, b);
                        } catch (l) {
                            $b9fb96103a9b59e3$var$W(b, c, l);
                        }
                    } finally{
                        $b9fb96103a9b59e3$var$ij(b);
                    }
                    else {
                        var d = b.return;
                        try {
                            $b9fb96103a9b59e3$var$Bk(4, b);
                        } catch (l) {
                            $b9fb96103a9b59e3$var$W(b, d, l);
                        }
                    }
                    break;
                case 1:
                    var e = b.stateNode;
                    if ("function" === typeof e.componentDidMount) {
                        var f = b.return;
                        try {
                            e.componentDidMount();
                        } catch (l) {
                            $b9fb96103a9b59e3$var$W(b, f, l);
                        }
                    }
                    var g = b.return;
                    try {
                        $b9fb96103a9b59e3$var$Ck(b);
                    } catch (l) {
                        $b9fb96103a9b59e3$var$W(b, g, l);
                    }
                    break;
                case 5:
                    var h = b.return;
                    try {
                        $b9fb96103a9b59e3$var$Ck(b);
                    } catch (l) {
                        $b9fb96103a9b59e3$var$W(b, h, l);
                    }
            }
        } catch (l) {
            $b9fb96103a9b59e3$var$W(b, b.return, l);
        }
        if (b === a) {
            $b9fb96103a9b59e3$var$U = null;
            break;
        }
        var k = b.sibling;
        if (null !== k) {
            k.return = b.return;
            $b9fb96103a9b59e3$var$U = k;
            break;
        }
        $b9fb96103a9b59e3$var$U = b.return;
    }
}
var $b9fb96103a9b59e3$var$Yk = Math.ceil, $b9fb96103a9b59e3$var$Zk = $b9fb96103a9b59e3$var$va.ReactCurrentDispatcher, $b9fb96103a9b59e3$var$$k = $b9fb96103a9b59e3$var$va.ReactCurrentOwner, $b9fb96103a9b59e3$var$al = $b9fb96103a9b59e3$var$va.ReactCurrentBatchConfig, $b9fb96103a9b59e3$var$K = 0, $b9fb96103a9b59e3$var$Q = null, $b9fb96103a9b59e3$var$Y = null, $b9fb96103a9b59e3$var$Z = 0, $b9fb96103a9b59e3$var$Kj = 0, $b9fb96103a9b59e3$var$Jj = $b9fb96103a9b59e3$var$hg(0), $b9fb96103a9b59e3$var$T = 0, $b9fb96103a9b59e3$var$bl = null, $b9fb96103a9b59e3$var$vh = 0, $b9fb96103a9b59e3$var$cl = 0, $b9fb96103a9b59e3$var$dl = 0, $b9fb96103a9b59e3$var$el = null, $b9fb96103a9b59e3$var$fl = null, $b9fb96103a9b59e3$var$Rk = 0, $b9fb96103a9b59e3$var$nk = Infinity, $b9fb96103a9b59e3$var$gl = null, $b9fb96103a9b59e3$var$rj = !1, $b9fb96103a9b59e3$var$sj = null, $b9fb96103a9b59e3$var$uj = null, $b9fb96103a9b59e3$var$hl = !1, $b9fb96103a9b59e3$var$il = null, $b9fb96103a9b59e3$var$jl = 0, $b9fb96103a9b59e3$var$kl = [], $b9fb96103a9b59e3$var$ll = 0, $b9fb96103a9b59e3$var$ml = null, $b9fb96103a9b59e3$var$nl = -1, $b9fb96103a9b59e3$var$ol = 0;
function $b9fb96103a9b59e3$var$zh() {
    return 0 !== ($b9fb96103a9b59e3$var$K & 6) ? $b9fb96103a9b59e3$var$A() : -1 !== $b9fb96103a9b59e3$var$nl ? $b9fb96103a9b59e3$var$nl : $b9fb96103a9b59e3$var$nl = $b9fb96103a9b59e3$var$A();
}
function $b9fb96103a9b59e3$var$Ah(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($b9fb96103a9b59e3$var$K & 2) && 0 !== $b9fb96103a9b59e3$var$Z) return $b9fb96103a9b59e3$var$Z & -$b9fb96103a9b59e3$var$Z;
    if (null !== $b9fb96103a9b59e3$var$Yg.transition) return 0 === $b9fb96103a9b59e3$var$ol && ($b9fb96103a9b59e3$var$ol = $b9fb96103a9b59e3$var$Kc()), $b9fb96103a9b59e3$var$ol;
    a = $b9fb96103a9b59e3$var$E;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $b9fb96103a9b59e3$var$xd(a.type);
    return a;
}
function $b9fb96103a9b59e3$var$Bh(a, b, c, d) {
    if (50 < $b9fb96103a9b59e3$var$ll) throw $b9fb96103a9b59e3$var$ll = 0, $b9fb96103a9b59e3$var$ml = null, Error($b9fb96103a9b59e3$var$p(185));
    $b9fb96103a9b59e3$var$Mc(a, c, d);
    if (0 === ($b9fb96103a9b59e3$var$K & 2) || a !== $b9fb96103a9b59e3$var$Q) $b9fb96103a9b59e3$var$mc && $b9fb96103a9b59e3$var$Pc(a, b, c), a === $b9fb96103a9b59e3$var$Q && (0 === ($b9fb96103a9b59e3$var$K & 2) && ($b9fb96103a9b59e3$var$cl |= c), 4 === $b9fb96103a9b59e3$var$T && $b9fb96103a9b59e3$var$pl(a, $b9fb96103a9b59e3$var$Z)), $b9fb96103a9b59e3$var$ql(a, d), 1 === c && 0 === $b9fb96103a9b59e3$var$K && 0 === (b.mode & 1) && ($b9fb96103a9b59e3$var$nk = $b9fb96103a9b59e3$var$A() + 500, $b9fb96103a9b59e3$var$tg && $b9fb96103a9b59e3$var$xg());
}
function $b9fb96103a9b59e3$var$ql(a, b) {
    var c = a.callbackNode;
    $b9fb96103a9b59e3$var$Ic(a, b);
    var d = $b9fb96103a9b59e3$var$Gc(a, a === $b9fb96103a9b59e3$var$Q ? $b9fb96103a9b59e3$var$Z : 0);
    if (0 === d) null !== c && $b9fb96103a9b59e3$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $b9fb96103a9b59e3$var$bc(c);
        if (1 === b) 0 === a.tag ? $b9fb96103a9b59e3$var$wg($b9fb96103a9b59e3$var$rl.bind(null, a)) : $b9fb96103a9b59e3$var$vg($b9fb96103a9b59e3$var$rl.bind(null, a)), $b9fb96103a9b59e3$var$Xf(function() {
            0 === ($b9fb96103a9b59e3$var$K & 6) && $b9fb96103a9b59e3$var$xg();
        }), c = null;
        else {
            switch($b9fb96103a9b59e3$var$Rc(d)){
                case 1:
                    c = $b9fb96103a9b59e3$var$fc;
                    break;
                case 4:
                    c = $b9fb96103a9b59e3$var$gc;
                    break;
                case 16:
                    c = $b9fb96103a9b59e3$var$hc;
                    break;
                case 536870912:
                    c = $b9fb96103a9b59e3$var$jc;
                    break;
                default:
                    c = $b9fb96103a9b59e3$var$hc;
            }
            c = $b9fb96103a9b59e3$var$sl(c, $b9fb96103a9b59e3$var$tl.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $b9fb96103a9b59e3$var$tl(a, b) {
    $b9fb96103a9b59e3$var$gj = $b9fb96103a9b59e3$var$fj = !1;
    $b9fb96103a9b59e3$var$nl = -1;
    $b9fb96103a9b59e3$var$ol = 0;
    if (0 !== ($b9fb96103a9b59e3$var$K & 6)) throw Error($b9fb96103a9b59e3$var$p(327));
    var c = a.callbackNode;
    if ($b9fb96103a9b59e3$var$ul() && a.callbackNode !== c) return null;
    var d = $b9fb96103a9b59e3$var$Gc(a, a === $b9fb96103a9b59e3$var$Q ? $b9fb96103a9b59e3$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $b9fb96103a9b59e3$var$vl(a, d);
    else {
        b = d;
        var e = $b9fb96103a9b59e3$var$K;
        $b9fb96103a9b59e3$var$K |= 2;
        var f = $b9fb96103a9b59e3$var$wl();
        if ($b9fb96103a9b59e3$var$Q !== a || $b9fb96103a9b59e3$var$Z !== b) {
            if ($b9fb96103a9b59e3$var$mc) {
                var g = a.memoizedUpdaters;
                0 < g.size && ($b9fb96103a9b59e3$var$xj(a, $b9fb96103a9b59e3$var$Z), g.clear());
                $b9fb96103a9b59e3$var$Qc(a, b);
            }
            $b9fb96103a9b59e3$var$gl = null;
            $b9fb96103a9b59e3$var$nk = $b9fb96103a9b59e3$var$A() + 500;
            $b9fb96103a9b59e3$var$xl(a, b);
        }
        $b9fb96103a9b59e3$var$wc(b);
        for(;;)try {
            $b9fb96103a9b59e3$var$yl();
            break;
        } catch (h) {
            $b9fb96103a9b59e3$var$zl(a, h);
        }
        $b9fb96103a9b59e3$var$dh();
        $b9fb96103a9b59e3$var$Zk.current = f;
        $b9fb96103a9b59e3$var$K = e;
        null !== $b9fb96103a9b59e3$var$Y ? (null !== $b9fb96103a9b59e3$var$B && "function" === typeof $b9fb96103a9b59e3$var$B.markRenderYielded && $b9fb96103a9b59e3$var$B.markRenderYielded(), b = 0) : ($b9fb96103a9b59e3$var$xc(), $b9fb96103a9b59e3$var$Q = null, $b9fb96103a9b59e3$var$Z = 0, b = $b9fb96103a9b59e3$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $b9fb96103a9b59e3$var$Jc(a), 0 !== e && (d = e, b = $b9fb96103a9b59e3$var$Al(a, e)));
        if (1 === b) throw c = $b9fb96103a9b59e3$var$bl, $b9fb96103a9b59e3$var$xl(a, 0), $b9fb96103a9b59e3$var$pl(a, d), $b9fb96103a9b59e3$var$ql(a, $b9fb96103a9b59e3$var$A()), c;
        if (6 === b) $b9fb96103a9b59e3$var$pl(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$b9fb96103a9b59e3$var$Bl(e) && (b = $b9fb96103a9b59e3$var$vl(a, d), 2 === b && (f = $b9fb96103a9b59e3$var$Jc(a), 0 !== f && (d = f, b = $b9fb96103a9b59e3$var$Al(a, f))), 1 === b)) throw c = $b9fb96103a9b59e3$var$bl, $b9fb96103a9b59e3$var$xl(a, 0), $b9fb96103a9b59e3$var$pl(a, d), $b9fb96103a9b59e3$var$ql(a, $b9fb96103a9b59e3$var$A()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($b9fb96103a9b59e3$var$p(345));
                case 2:
                    $b9fb96103a9b59e3$var$Dl(a, $b9fb96103a9b59e3$var$fl, $b9fb96103a9b59e3$var$gl);
                    break;
                case 3:
                    $b9fb96103a9b59e3$var$pl(a, d);
                    if ((d & 130023424) === d && (b = $b9fb96103a9b59e3$var$Rk + 500 - $b9fb96103a9b59e3$var$A(), 10 < b)) {
                        if (0 !== $b9fb96103a9b59e3$var$Gc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $b9fb96103a9b59e3$var$zh();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $b9fb96103a9b59e3$var$Tf($b9fb96103a9b59e3$var$Dl.bind(null, a, $b9fb96103a9b59e3$var$fl, $b9fb96103a9b59e3$var$gl), b);
                        break;
                    }
                    $b9fb96103a9b59e3$var$Dl(a, $b9fb96103a9b59e3$var$fl, $b9fb96103a9b59e3$var$gl);
                    break;
                case 4:
                    $b9fb96103a9b59e3$var$pl(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;)g = 31 - $b9fb96103a9b59e3$var$Ac(d), f = 1 << g, g = b[g], g > e && (e = g), d &= ~f;
                    d = e;
                    d = $b9fb96103a9b59e3$var$A() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $b9fb96103a9b59e3$var$Yk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $b9fb96103a9b59e3$var$Tf($b9fb96103a9b59e3$var$Dl.bind(null, a, $b9fb96103a9b59e3$var$fl, $b9fb96103a9b59e3$var$gl), d);
                        break;
                    }
                    $b9fb96103a9b59e3$var$Dl(a, $b9fb96103a9b59e3$var$fl, $b9fb96103a9b59e3$var$gl);
                    break;
                case 5:
                    $b9fb96103a9b59e3$var$Dl(a, $b9fb96103a9b59e3$var$fl, $b9fb96103a9b59e3$var$gl);
                    break;
                default:
                    throw Error($b9fb96103a9b59e3$var$p(329));
            }
        }
    }
    $b9fb96103a9b59e3$var$ql(a, $b9fb96103a9b59e3$var$A());
    return a.callbackNode === c ? $b9fb96103a9b59e3$var$tl.bind(null, a) : null;
}
function $b9fb96103a9b59e3$var$Al(a, b) {
    var c = $b9fb96103a9b59e3$var$el;
    a.current.memoizedState.isDehydrated && ($b9fb96103a9b59e3$var$xl(a, b).flags |= 256);
    a = $b9fb96103a9b59e3$var$vl(a, b);
    2 !== a && (b = $b9fb96103a9b59e3$var$fl, $b9fb96103a9b59e3$var$fl = c, null !== b && $b9fb96103a9b59e3$var$mk(b));
    return a;
}
function $b9fb96103a9b59e3$var$mk(a) {
    null === $b9fb96103a9b59e3$var$fl ? $b9fb96103a9b59e3$var$fl = a : $b9fb96103a9b59e3$var$fl.push.apply($b9fb96103a9b59e3$var$fl, a);
}
function $b9fb96103a9b59e3$var$Bl(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$b9fb96103a9b59e3$var$Ve(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $b9fb96103a9b59e3$var$pl(a, b) {
    b &= ~$b9fb96103a9b59e3$var$dl;
    b &= ~$b9fb96103a9b59e3$var$cl;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $b9fb96103a9b59e3$var$Ac(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $b9fb96103a9b59e3$var$rl(a) {
    $b9fb96103a9b59e3$var$fj = $b9fb96103a9b59e3$var$gj;
    $b9fb96103a9b59e3$var$gj = !1;
    if (0 !== ($b9fb96103a9b59e3$var$K & 6)) throw Error($b9fb96103a9b59e3$var$p(327));
    $b9fb96103a9b59e3$var$ul();
    var b = $b9fb96103a9b59e3$var$Gc(a, 0);
    if (0 === (b & 1)) return $b9fb96103a9b59e3$var$ql(a, $b9fb96103a9b59e3$var$A()), null;
    var c = $b9fb96103a9b59e3$var$vl(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $b9fb96103a9b59e3$var$Jc(a);
        0 !== d && (b = d, c = $b9fb96103a9b59e3$var$Al(a, d));
    }
    if (1 === c) throw c = $b9fb96103a9b59e3$var$bl, $b9fb96103a9b59e3$var$xl(a, 0), $b9fb96103a9b59e3$var$pl(a, b), $b9fb96103a9b59e3$var$ql(a, $b9fb96103a9b59e3$var$A()), c;
    if (6 === c) throw Error($b9fb96103a9b59e3$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $b9fb96103a9b59e3$var$Dl(a, $b9fb96103a9b59e3$var$fl, $b9fb96103a9b59e3$var$gl);
    $b9fb96103a9b59e3$var$ql(a, $b9fb96103a9b59e3$var$A());
    return null;
}
function $b9fb96103a9b59e3$var$El(a, b) {
    var c = $b9fb96103a9b59e3$var$K;
    $b9fb96103a9b59e3$var$K |= 1;
    try {
        return a(b);
    } finally{
        $b9fb96103a9b59e3$var$K = c, 0 === $b9fb96103a9b59e3$var$K && ($b9fb96103a9b59e3$var$nk = $b9fb96103a9b59e3$var$A() + 500, $b9fb96103a9b59e3$var$tg && $b9fb96103a9b59e3$var$xg());
    }
}
function $b9fb96103a9b59e3$var$Fl(a) {
    null !== $b9fb96103a9b59e3$var$il && 0 === $b9fb96103a9b59e3$var$il.tag && 0 === ($b9fb96103a9b59e3$var$K & 6) && $b9fb96103a9b59e3$var$ul();
    var b = $b9fb96103a9b59e3$var$K;
    $b9fb96103a9b59e3$var$K |= 1;
    var c = $b9fb96103a9b59e3$var$al.transition, d = $b9fb96103a9b59e3$var$E;
    try {
        if ($b9fb96103a9b59e3$var$al.transition = null, $b9fb96103a9b59e3$var$E = 1, a) return a();
    } finally{
        $b9fb96103a9b59e3$var$E = d, $b9fb96103a9b59e3$var$al.transition = c, $b9fb96103a9b59e3$var$K = b, 0 === ($b9fb96103a9b59e3$var$K & 6) && $b9fb96103a9b59e3$var$xg();
    }
}
function $b9fb96103a9b59e3$var$ok() {
    $b9fb96103a9b59e3$var$Kj = $b9fb96103a9b59e3$var$Jj.current;
    $b9fb96103a9b59e3$var$G($b9fb96103a9b59e3$var$Jj);
}
function $b9fb96103a9b59e3$var$xl(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $b9fb96103a9b59e3$var$Uf(c));
    if (null !== $b9fb96103a9b59e3$var$Y) for(c = $b9fb96103a9b59e3$var$Y.return; null !== c;){
        var d = c;
        $b9fb96103a9b59e3$var$Kg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $b9fb96103a9b59e3$var$ng();
                break;
            case 3:
                $b9fb96103a9b59e3$var$Yh();
                $b9fb96103a9b59e3$var$G($b9fb96103a9b59e3$var$jg);
                $b9fb96103a9b59e3$var$G($b9fb96103a9b59e3$var$I);
                $b9fb96103a9b59e3$var$ci();
                break;
            case 5:
                $b9fb96103a9b59e3$var$$h(d);
                break;
            case 4:
                $b9fb96103a9b59e3$var$Yh();
                break;
            case 13:
                $b9fb96103a9b59e3$var$G($b9fb96103a9b59e3$var$L);
                break;
            case 19:
                $b9fb96103a9b59e3$var$G($b9fb96103a9b59e3$var$L);
                break;
            case 10:
                $b9fb96103a9b59e3$var$eh(d.type._context);
                break;
            case 22:
            case 23:
                $b9fb96103a9b59e3$var$ok();
        }
        c = c.return;
    }
    $b9fb96103a9b59e3$var$Q = a;
    $b9fb96103a9b59e3$var$Y = a = $b9fb96103a9b59e3$var$Lh(a.current, null);
    $b9fb96103a9b59e3$var$Z = $b9fb96103a9b59e3$var$Kj = b;
    $b9fb96103a9b59e3$var$T = 0;
    $b9fb96103a9b59e3$var$bl = null;
    $b9fb96103a9b59e3$var$dl = $b9fb96103a9b59e3$var$cl = $b9fb96103a9b59e3$var$vh = 0;
    $b9fb96103a9b59e3$var$fl = $b9fb96103a9b59e3$var$el = null;
    if (null !== $b9fb96103a9b59e3$var$jh) {
        for(b = 0; b < $b9fb96103a9b59e3$var$jh.length; b++)if (c = $b9fb96103a9b59e3$var$jh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $b9fb96103a9b59e3$var$jh = null;
    }
    return a;
}
function $b9fb96103a9b59e3$var$zl(a, b) {
    do {
        var c = $b9fb96103a9b59e3$var$Y;
        try {
            $b9fb96103a9b59e3$var$dh();
            $b9fb96103a9b59e3$var$di.current = $b9fb96103a9b59e3$var$pi;
            if ($b9fb96103a9b59e3$var$gi) {
                for(var d = $b9fb96103a9b59e3$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $b9fb96103a9b59e3$var$gi = !1;
            }
            $b9fb96103a9b59e3$var$fi = 0;
            $b9fb96103a9b59e3$var$O = $b9fb96103a9b59e3$var$N = $b9fb96103a9b59e3$var$M = null;
            $b9fb96103a9b59e3$var$hi = !1;
            $b9fb96103a9b59e3$var$ii = 0;
            $b9fb96103a9b59e3$var$$k.current = null;
            if (null === c || null === c.return) {
                $b9fb96103a9b59e3$var$T = 1;
                $b9fb96103a9b59e3$var$bl = b;
                $b9fb96103a9b59e3$var$Y = null;
                break;
            }
            c.mode & 2 && $b9fb96103a9b59e3$var$hj(c, !0);
            $b9fb96103a9b59e3$var$tc();
            if (null !== b && "object" === typeof b && "function" === typeof b.then) {
                var f = b;
                null !== $b9fb96103a9b59e3$var$B && "function" === typeof $b9fb96103a9b59e3$var$B.markComponentSuspended && $b9fb96103a9b59e3$var$B.markComponentSuspended(c, f, $b9fb96103a9b59e3$var$Z);
            } else null !== $b9fb96103a9b59e3$var$B && "function" === typeof $b9fb96103a9b59e3$var$B.markComponentErrored && $b9fb96103a9b59e3$var$B.markComponentErrored(c, b, $b9fb96103a9b59e3$var$Z);
            a: {
                var g = a, h = c.return, k = c;
                f = b;
                b = $b9fb96103a9b59e3$var$Z;
                k.flags |= 32768;
                $b9fb96103a9b59e3$var$mc && $b9fb96103a9b59e3$var$xj(g, b);
                if (null !== f && "object" === typeof f && "function" === typeof f.then) {
                    var l = f, n = k, q = n.tag;
                    if (0 === (n.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = n.alternate;
                        r ? (n.updateQueue = r.updateQueue, n.memoizedState = r.memoizedState, n.lanes = r.lanes) : (n.updateQueue = null, n.memoizedState = null);
                    }
                    var z = $b9fb96103a9b59e3$var$yj(h);
                    if (null !== z) {
                        z.flags &= -257;
                        $b9fb96103a9b59e3$var$zj(z, h, k, g, b);
                        z.mode & 1 && $b9fb96103a9b59e3$var$vj(g, l, b);
                        b = z;
                        f = l;
                        var m = b.updateQueue;
                        if (null === m) {
                            var w = new Set;
                            w.add(f);
                            b.updateQueue = w;
                        } else m.add(f);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $b9fb96103a9b59e3$var$vj(g, l, b);
                            $b9fb96103a9b59e3$var$ak();
                            break a;
                        }
                        f = Error($b9fb96103a9b59e3$var$p(426));
                    }
                } else if ($b9fb96103a9b59e3$var$J && k.mode & 1) {
                    var C = $b9fb96103a9b59e3$var$yj(h);
                    if (null !== C) {
                        0 === (C.flags & 65536) && (C.flags |= 256);
                        $b9fb96103a9b59e3$var$zj(C, h, k, g, b);
                        $b9fb96103a9b59e3$var$Xg($b9fb96103a9b59e3$var$mj(f, k));
                        break a;
                    }
                }
                g = f = $b9fb96103a9b59e3$var$mj(f, k);
                4 !== $b9fb96103a9b59e3$var$T && ($b9fb96103a9b59e3$var$T = 2);
                null === $b9fb96103a9b59e3$var$el ? $b9fb96103a9b59e3$var$el = [
                    g
                ] : $b9fb96103a9b59e3$var$el.push(g);
                g = h;
                do {
                    switch(g.tag){
                        case 3:
                            g.flags |= 65536;
                            b &= -b;
                            g.lanes |= b;
                            var x = $b9fb96103a9b59e3$var$qj(g, f, b);
                            $b9fb96103a9b59e3$var$th(g, x);
                            break a;
                        case 1:
                            k = f;
                            var y = g.type, v = g.stateNode;
                            if (0 === (g.flags & 128) && ("function" === typeof y.getDerivedStateFromError || null !== v && "function" === typeof v.componentDidCatch && (null === $b9fb96103a9b59e3$var$uj || !$b9fb96103a9b59e3$var$uj.has(v)))) {
                                g.flags |= 65536;
                                b &= -b;
                                g.lanes |= b;
                                var D = $b9fb96103a9b59e3$var$tj(g, k, b);
                                $b9fb96103a9b59e3$var$th(g, D);
                                break a;
                            }
                    }
                    g = g.return;
                }while (null !== g);
            }
            $b9fb96103a9b59e3$var$Gl(c);
        } catch (ca) {
            b = ca;
            $b9fb96103a9b59e3$var$Y === c && null !== c && ($b9fb96103a9b59e3$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $b9fb96103a9b59e3$var$wl() {
    var a = $b9fb96103a9b59e3$var$Zk.current;
    $b9fb96103a9b59e3$var$Zk.current = $b9fb96103a9b59e3$var$pi;
    return null === a ? $b9fb96103a9b59e3$var$pi : a;
}
function $b9fb96103a9b59e3$var$ak() {
    if (0 === $b9fb96103a9b59e3$var$T || 3 === $b9fb96103a9b59e3$var$T || 2 === $b9fb96103a9b59e3$var$T) $b9fb96103a9b59e3$var$T = 4;
    null === $b9fb96103a9b59e3$var$Q || 0 === ($b9fb96103a9b59e3$var$vh & 268435455) && 0 === ($b9fb96103a9b59e3$var$cl & 268435455) || $b9fb96103a9b59e3$var$pl($b9fb96103a9b59e3$var$Q, $b9fb96103a9b59e3$var$Z);
}
function $b9fb96103a9b59e3$var$vl(a, b) {
    var c = $b9fb96103a9b59e3$var$K;
    $b9fb96103a9b59e3$var$K |= 2;
    var d = $b9fb96103a9b59e3$var$wl();
    if ($b9fb96103a9b59e3$var$Q !== a || $b9fb96103a9b59e3$var$Z !== b) {
        if ($b9fb96103a9b59e3$var$mc) {
            var e = a.memoizedUpdaters;
            0 < e.size && ($b9fb96103a9b59e3$var$xj(a, $b9fb96103a9b59e3$var$Z), e.clear());
            $b9fb96103a9b59e3$var$Qc(a, b);
        }
        $b9fb96103a9b59e3$var$gl = null;
        $b9fb96103a9b59e3$var$xl(a, b);
    }
    $b9fb96103a9b59e3$var$wc(b);
    for(;;)try {
        $b9fb96103a9b59e3$var$Hl();
        break;
    } catch (f) {
        $b9fb96103a9b59e3$var$zl(a, f);
    }
    $b9fb96103a9b59e3$var$dh();
    $b9fb96103a9b59e3$var$K = c;
    $b9fb96103a9b59e3$var$Zk.current = d;
    if (null !== $b9fb96103a9b59e3$var$Y) throw Error($b9fb96103a9b59e3$var$p(261));
    $b9fb96103a9b59e3$var$xc();
    $b9fb96103a9b59e3$var$Q = null;
    $b9fb96103a9b59e3$var$Z = 0;
    return $b9fb96103a9b59e3$var$T;
}
function $b9fb96103a9b59e3$var$Hl() {
    for(; null !== $b9fb96103a9b59e3$var$Y;)$b9fb96103a9b59e3$var$Il($b9fb96103a9b59e3$var$Y);
}
function $b9fb96103a9b59e3$var$yl() {
    for(; null !== $b9fb96103a9b59e3$var$Y && !$b9fb96103a9b59e3$var$cc();)$b9fb96103a9b59e3$var$Il($b9fb96103a9b59e3$var$Y);
}
function $b9fb96103a9b59e3$var$Il(a) {
    var b = a.alternate;
    0 !== (a.mode & 2) ? ($b9fb96103a9b59e3$var$dj = $b9fb96103a9b59e3$var$aj(), 0 > a.actualStartTime && (a.actualStartTime = $b9fb96103a9b59e3$var$aj()), b = $b9fb96103a9b59e3$var$Jl(b, a, $b9fb96103a9b59e3$var$Kj), $b9fb96103a9b59e3$var$hj(a, !0)) : b = $b9fb96103a9b59e3$var$Jl(b, a, $b9fb96103a9b59e3$var$Kj);
    a.memoizedProps = a.pendingProps;
    null === b ? $b9fb96103a9b59e3$var$Gl(a) : $b9fb96103a9b59e3$var$Y = b;
    $b9fb96103a9b59e3$var$$k.current = null;
}
function $b9fb96103a9b59e3$var$Gl(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (0 === (b.mode & 2)) c = $b9fb96103a9b59e3$var$lk(c, b, $b9fb96103a9b59e3$var$Kj);
            else {
                var d = b;
                $b9fb96103a9b59e3$var$dj = $b9fb96103a9b59e3$var$aj();
                0 > d.actualStartTime && (d.actualStartTime = $b9fb96103a9b59e3$var$aj());
                c = $b9fb96103a9b59e3$var$lk(c, b, $b9fb96103a9b59e3$var$Kj);
                $b9fb96103a9b59e3$var$hj(b, !1);
            }
            if (null !== c) {
                $b9fb96103a9b59e3$var$Y = c;
                return;
            }
        } else {
            c = $b9fb96103a9b59e3$var$pk(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $b9fb96103a9b59e3$var$Y = c;
                return;
            }
            if (0 !== (b.mode & 2)) {
                $b9fb96103a9b59e3$var$hj(b, !1);
                c = b.actualDuration;
                for(d = b.child; null !== d;)c += d.actualDuration, d = d.sibling;
                b.actualDuration = c;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $b9fb96103a9b59e3$var$T = 6;
                $b9fb96103a9b59e3$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $b9fb96103a9b59e3$var$Y = b;
            return;
        }
        $b9fb96103a9b59e3$var$Y = b = a;
    }while (null !== b);
    0 === $b9fb96103a9b59e3$var$T && ($b9fb96103a9b59e3$var$T = 5);
}
function $b9fb96103a9b59e3$var$Dl(a, b, c) {
    var d = $b9fb96103a9b59e3$var$E, e = $b9fb96103a9b59e3$var$al.transition;
    try {
        $b9fb96103a9b59e3$var$al.transition = null, $b9fb96103a9b59e3$var$E = 1, $b9fb96103a9b59e3$var$Kl(a, b, c, d);
    } finally{
        $b9fb96103a9b59e3$var$al.transition = e, $b9fb96103a9b59e3$var$E = d;
    }
    return null;
}
function $b9fb96103a9b59e3$var$Kl(a, b, c, d) {
    do $b9fb96103a9b59e3$var$ul();
    while (null !== $b9fb96103a9b59e3$var$il);
    if (0 !== ($b9fb96103a9b59e3$var$K & 6)) throw Error($b9fb96103a9b59e3$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    null !== $b9fb96103a9b59e3$var$B && "function" === typeof $b9fb96103a9b59e3$var$B.markCommitStarted && $b9fb96103a9b59e3$var$B.markCommitStarted(e);
    if (null === c) return $b9fb96103a9b59e3$var$rc(), null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($b9fb96103a9b59e3$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $b9fb96103a9b59e3$var$Nc(a, f);
    a === $b9fb96103a9b59e3$var$Q && ($b9fb96103a9b59e3$var$Y = $b9fb96103a9b59e3$var$Q = null, $b9fb96103a9b59e3$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $b9fb96103a9b59e3$var$hl || ($b9fb96103a9b59e3$var$hl = !0, $b9fb96103a9b59e3$var$sl($b9fb96103a9b59e3$var$hc, function() {
        $b9fb96103a9b59e3$var$ul();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $b9fb96103a9b59e3$var$al.transition;
        $b9fb96103a9b59e3$var$al.transition = null;
        var g = $b9fb96103a9b59e3$var$E;
        $b9fb96103a9b59e3$var$E = 1;
        var h = $b9fb96103a9b59e3$var$K;
        $b9fb96103a9b59e3$var$K |= 4;
        $b9fb96103a9b59e3$var$$k.current = null;
        $b9fb96103a9b59e3$var$zk(a, c);
        $b9fb96103a9b59e3$var$bj = $b9fb96103a9b59e3$var$aj();
        $b9fb96103a9b59e3$var$Nk(a, c, e);
        $b9fb96103a9b59e3$var$bf($b9fb96103a9b59e3$var$Rf);
        $b9fb96103a9b59e3$var$rd = !!$b9fb96103a9b59e3$var$Qf;
        $b9fb96103a9b59e3$var$Rf = $b9fb96103a9b59e3$var$Qf = null;
        a.current = c;
        null !== $b9fb96103a9b59e3$var$B && "function" === typeof $b9fb96103a9b59e3$var$B.markLayoutEffectsStarted && $b9fb96103a9b59e3$var$B.markLayoutEffectsStarted(e);
        $b9fb96103a9b59e3$var$Tk(c, a, e);
        null !== $b9fb96103a9b59e3$var$B && "function" === typeof $b9fb96103a9b59e3$var$B.markLayoutEffectsStopped && $b9fb96103a9b59e3$var$B.markLayoutEffectsStopped();
        $b9fb96103a9b59e3$var$dc();
        $b9fb96103a9b59e3$var$K = h;
        $b9fb96103a9b59e3$var$E = g;
        $b9fb96103a9b59e3$var$al.transition = f;
    } else a.current = c, $b9fb96103a9b59e3$var$bj = $b9fb96103a9b59e3$var$aj();
    $b9fb96103a9b59e3$var$hl && ($b9fb96103a9b59e3$var$hl = !1, $b9fb96103a9b59e3$var$il = a, $b9fb96103a9b59e3$var$jl = e);
    f = a.pendingLanes;
    0 === f && ($b9fb96103a9b59e3$var$uj = null);
    $b9fb96103a9b59e3$var$nc(c.stateNode, d);
    $b9fb96103a9b59e3$var$mc && a.memoizedUpdaters.clear();
    $b9fb96103a9b59e3$var$ql(a, $b9fb96103a9b59e3$var$A());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($b9fb96103a9b59e3$var$rj) throw $b9fb96103a9b59e3$var$rj = !1, a = $b9fb96103a9b59e3$var$sj, $b9fb96103a9b59e3$var$sj = null, a;
    0 !== ($b9fb96103a9b59e3$var$jl & 1) && 0 !== a.tag && $b9fb96103a9b59e3$var$ul();
    f = a.pendingLanes;
    0 !== (f & 1) ? ($b9fb96103a9b59e3$var$gj = !0, a === $b9fb96103a9b59e3$var$ml ? $b9fb96103a9b59e3$var$ll++ : ($b9fb96103a9b59e3$var$ll = 0, $b9fb96103a9b59e3$var$ml = a)) : $b9fb96103a9b59e3$var$ll = 0;
    $b9fb96103a9b59e3$var$xg();
    $b9fb96103a9b59e3$var$rc();
    return null;
}
function $b9fb96103a9b59e3$var$ul() {
    if (null !== $b9fb96103a9b59e3$var$il) {
        var a = $b9fb96103a9b59e3$var$Rc($b9fb96103a9b59e3$var$jl), b = $b9fb96103a9b59e3$var$al.transition, c = $b9fb96103a9b59e3$var$E;
        try {
            $b9fb96103a9b59e3$var$al.transition = null;
            $b9fb96103a9b59e3$var$E = 16 > a ? 16 : a;
            if (null === $b9fb96103a9b59e3$var$il) var d = !1;
            else {
                a = $b9fb96103a9b59e3$var$il;
                var e = $b9fb96103a9b59e3$var$jl;
                $b9fb96103a9b59e3$var$il = null;
                $b9fb96103a9b59e3$var$jl = 0;
                if (0 !== ($b9fb96103a9b59e3$var$K & 6)) throw Error($b9fb96103a9b59e3$var$p(331));
                null !== $b9fb96103a9b59e3$var$B && "function" === typeof $b9fb96103a9b59e3$var$B.markPassiveEffectsStarted && $b9fb96103a9b59e3$var$B.markPassiveEffectsStarted(e);
                e = $b9fb96103a9b59e3$var$K;
                $b9fb96103a9b59e3$var$K |= 4;
                for($b9fb96103a9b59e3$var$U = a.current; null !== $b9fb96103a9b59e3$var$U;){
                    var f = $b9fb96103a9b59e3$var$U, g = f.child;
                    if (0 !== ($b9fb96103a9b59e3$var$U.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($b9fb96103a9b59e3$var$U = l; null !== $b9fb96103a9b59e3$var$U;){
                                    var n = $b9fb96103a9b59e3$var$U, q = n;
                                    switch(q.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            q.mode & 2 ? ($b9fb96103a9b59e3$var$ej = $b9fb96103a9b59e3$var$aj(), $b9fb96103a9b59e3$var$Ak(8, q, f), $b9fb96103a9b59e3$var$jj(q)) : $b9fb96103a9b59e3$var$Ak(8, q, f);
                                    }
                                    var r = n.child;
                                    if (null !== r) r.return = n, $b9fb96103a9b59e3$var$U = r;
                                    else for(; null !== $b9fb96103a9b59e3$var$U;){
                                        n = $b9fb96103a9b59e3$var$U;
                                        var z = n.sibling, m = n.return;
                                        $b9fb96103a9b59e3$var$Dk(n);
                                        if (n === l) {
                                            $b9fb96103a9b59e3$var$U = null;
                                            break;
                                        }
                                        if (null !== z) {
                                            z.return = m;
                                            $b9fb96103a9b59e3$var$U = z;
                                            break;
                                        }
                                        $b9fb96103a9b59e3$var$U = m;
                                    }
                                }
                            }
                            var w = f.alternate;
                            if (null !== w) {
                                var C = w.child;
                                if (null !== C) {
                                    w.child = null;
                                    do {
                                        var x = C.sibling;
                                        C.sibling = null;
                                        C = x;
                                    }while (null !== C);
                                }
                            }
                            $b9fb96103a9b59e3$var$U = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $b9fb96103a9b59e3$var$U = g;
                    else b: for(; null !== $b9fb96103a9b59e3$var$U;){
                        f = $b9fb96103a9b59e3$var$U;
                        if (0 !== (f.flags & 2048)) switch(k = f, k.tag){
                            case 0:
                            case 11:
                            case 15:
                                k.mode & 2 ? ($b9fb96103a9b59e3$var$ej = $b9fb96103a9b59e3$var$aj(), $b9fb96103a9b59e3$var$Ak(9, k, k.return), $b9fb96103a9b59e3$var$jj(k)) : $b9fb96103a9b59e3$var$Ak(9, k, k.return);
                        }
                        var y = f.sibling;
                        if (null !== y) {
                            y.return = f.return;
                            $b9fb96103a9b59e3$var$U = y;
                            break b;
                        }
                        $b9fb96103a9b59e3$var$U = f.return;
                    }
                }
                var v = a.current;
                for($b9fb96103a9b59e3$var$U = v; null !== $b9fb96103a9b59e3$var$U;){
                    g = $b9fb96103a9b59e3$var$U;
                    var D = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== D) D.return = g, $b9fb96103a9b59e3$var$U = D;
                    else b: for(g = v; null !== $b9fb96103a9b59e3$var$U;){
                        h = $b9fb96103a9b59e3$var$U;
                        if (0 !== (h.flags & 2048)) try {
                            switch(l = h, l.tag){
                                case 0:
                                case 11:
                                case 15:
                                    if (l.mode & 2) {
                                        $b9fb96103a9b59e3$var$ej = $b9fb96103a9b59e3$var$aj();
                                        try {
                                            $b9fb96103a9b59e3$var$Bk(9, l);
                                        } finally{
                                            $b9fb96103a9b59e3$var$jj(l);
                                        }
                                    } else $b9fb96103a9b59e3$var$Bk(9, l);
                            }
                        } catch (Rj) {
                            $b9fb96103a9b59e3$var$W(h, h.return, Rj);
                        }
                        if (h === g) {
                            $b9fb96103a9b59e3$var$U = null;
                            break b;
                        }
                        var ca = h.sibling;
                        if (null !== ca) {
                            ca.return = h.return;
                            $b9fb96103a9b59e3$var$U = ca;
                            break b;
                        }
                        $b9fb96103a9b59e3$var$U = h.return;
                    }
                }
                v = $b9fb96103a9b59e3$var$kl;
                $b9fb96103a9b59e3$var$kl = [];
                for(D = 0; D < v.length; D++){
                    var R = v[D];
                    if (0 !== (R.flags & 4)) switch(R.tag){
                        case 12:
                            var sa = R.stateNode.passiveEffectDuration, V = R.memoizedProps, Cl = V.id, Hi = V.onPostCommit;
                            ca = $b9fb96103a9b59e3$var$bj;
                            var Ii = null === R.alternate ? "mount" : "update";
                            $b9fb96103a9b59e3$var$fj && (Ii = "nested-update");
                            "function" === typeof Hi && Hi(Cl, Ii, sa, ca);
                            var ob = R.return;
                            b: for(; null !== ob;){
                                switch(ob.tag){
                                    case 3:
                                        ob.stateNode.passiveEffectDuration += sa;
                                        break b;
                                    case 12:
                                        ob.stateNode.passiveEffectDuration += sa;
                                        break b;
                                }
                                ob = ob.return;
                            }
                    }
                }
                null !== $b9fb96103a9b59e3$var$B && "function" === typeof $b9fb96103a9b59e3$var$B.markPassiveEffectsStopped && $b9fb96103a9b59e3$var$B.markPassiveEffectsStopped();
                $b9fb96103a9b59e3$var$K = e;
                $b9fb96103a9b59e3$var$xg();
                if ($b9fb96103a9b59e3$var$lc && "function" === typeof $b9fb96103a9b59e3$var$lc.onPostCommitFiberRoot) try {
                    $b9fb96103a9b59e3$var$lc.onPostCommitFiberRoot($b9fb96103a9b59e3$var$kc, a);
                } catch (Rj) {}
                var Sj = a.current.stateNode;
                Sj.effectDuration = 0;
                Sj.passiveEffectDuration = 0;
                d = !0;
            }
            return d;
        } finally{
            $b9fb96103a9b59e3$var$E = c, $b9fb96103a9b59e3$var$al.transition = b;
        }
    }
    return !1;
}
function $b9fb96103a9b59e3$var$Xk(a) {
    $b9fb96103a9b59e3$var$kl.push(a);
    $b9fb96103a9b59e3$var$hl || ($b9fb96103a9b59e3$var$hl = !0, $b9fb96103a9b59e3$var$sl($b9fb96103a9b59e3$var$hc, function() {
        $b9fb96103a9b59e3$var$ul();
        return null;
    }));
}
function $b9fb96103a9b59e3$var$Ll(a, b, c) {
    b = $b9fb96103a9b59e3$var$mj(c, b);
    b = $b9fb96103a9b59e3$var$qj(a, b, 1);
    a = $b9fb96103a9b59e3$var$rh(a, b, 1);
    b = $b9fb96103a9b59e3$var$zh();
    null !== a && ($b9fb96103a9b59e3$var$Mc(a, 1, b), $b9fb96103a9b59e3$var$ql(a, b));
}
function $b9fb96103a9b59e3$var$W(a, b, c) {
    if (3 === a.tag) $b9fb96103a9b59e3$var$Ll(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $b9fb96103a9b59e3$var$Ll(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $b9fb96103a9b59e3$var$uj || !$b9fb96103a9b59e3$var$uj.has(d))) {
                a = $b9fb96103a9b59e3$var$mj(c, a);
                a = $b9fb96103a9b59e3$var$tj(b, a, 1);
                b = $b9fb96103a9b59e3$var$rh(b, a, 1);
                a = $b9fb96103a9b59e3$var$zh();
                null !== b && ($b9fb96103a9b59e3$var$Mc(b, 1, a), $b9fb96103a9b59e3$var$ql(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $b9fb96103a9b59e3$var$wj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $b9fb96103a9b59e3$var$zh();
    a.pingedLanes |= a.suspendedLanes & c;
    $b9fb96103a9b59e3$var$Q === a && ($b9fb96103a9b59e3$var$Z & c) === c && (4 === $b9fb96103a9b59e3$var$T || 3 === $b9fb96103a9b59e3$var$T && ($b9fb96103a9b59e3$var$Z & 130023424) === $b9fb96103a9b59e3$var$Z && 500 > $b9fb96103a9b59e3$var$A() - $b9fb96103a9b59e3$var$Rk ? $b9fb96103a9b59e3$var$xl(a, 0) : $b9fb96103a9b59e3$var$dl |= c);
    $b9fb96103a9b59e3$var$ql(a, b);
}
function $b9fb96103a9b59e3$var$Ml(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $b9fb96103a9b59e3$var$Ec, $b9fb96103a9b59e3$var$Ec <<= 1, 0 === ($b9fb96103a9b59e3$var$Ec & 130023424) && ($b9fb96103a9b59e3$var$Ec = 4194304)));
    var c = $b9fb96103a9b59e3$var$zh();
    a = $b9fb96103a9b59e3$var$mh(a, b);
    null !== a && ($b9fb96103a9b59e3$var$Mc(a, b, c), $b9fb96103a9b59e3$var$ql(a, c));
}
function $b9fb96103a9b59e3$var$bk(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $b9fb96103a9b59e3$var$Ml(a, c);
}
function $b9fb96103a9b59e3$var$Mk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($b9fb96103a9b59e3$var$p(314));
    }
    null !== d && d.delete(b);
    $b9fb96103a9b59e3$var$Ml(a, c);
}
var $b9fb96103a9b59e3$var$Jl;
$b9fb96103a9b59e3$var$Jl = function Jl(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $b9fb96103a9b59e3$var$jg.current) $b9fb96103a9b59e3$var$hh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $b9fb96103a9b59e3$var$hh = !1, $b9fb96103a9b59e3$var$fk(a, b, c);
            $b9fb96103a9b59e3$var$hh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $b9fb96103a9b59e3$var$hh = !1, $b9fb96103a9b59e3$var$J && 0 !== (b.flags & 1048576) && $b9fb96103a9b59e3$var$Ig(b, $b9fb96103a9b59e3$var$Bg, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $b9fb96103a9b59e3$var$Nj(a, b);
            a = b.pendingProps;
            var e = $b9fb96103a9b59e3$var$lg(b, $b9fb96103a9b59e3$var$I.current);
            $b9fb96103a9b59e3$var$gh(b, c);
            $b9fb96103a9b59e3$var$sc(b);
            e = $b9fb96103a9b59e3$var$li(null, b, d, a, e, c);
            var f = $b9fb96103a9b59e3$var$qi();
            $b9fb96103a9b59e3$var$tc();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $b9fb96103a9b59e3$var$mg(d) ? (f = !0, $b9fb96103a9b59e3$var$qg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $b9fb96103a9b59e3$var$oh(b), e.updater = $b9fb96103a9b59e3$var$Ch, b.stateNode = e, e._reactInternals = b, $b9fb96103a9b59e3$var$Gh(b, d, a, c), b = $b9fb96103a9b59e3$var$Oj(null, b, d, !0, f, c)) : (b.tag = 0, $b9fb96103a9b59e3$var$J && f && $b9fb96103a9b59e3$var$Jg(b), $b9fb96103a9b59e3$var$Bj(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $b9fb96103a9b59e3$var$Nj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $b9fb96103a9b59e3$var$Nl(d);
                a = $b9fb96103a9b59e3$var$Zg(d, a);
                switch(e){
                    case 0:
                        b = $b9fb96103a9b59e3$var$Hj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $b9fb96103a9b59e3$var$Mj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $b9fb96103a9b59e3$var$Cj(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $b9fb96103a9b59e3$var$Ej(null, b, d, $b9fb96103a9b59e3$var$Zg(d.type, a), c);
                        break a;
                }
                throw Error($b9fb96103a9b59e3$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b9fb96103a9b59e3$var$Zg(d, e), $b9fb96103a9b59e3$var$Hj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b9fb96103a9b59e3$var$Zg(d, e), $b9fb96103a9b59e3$var$Mj(a, b, d, e, c);
        case 3:
            a: {
                $b9fb96103a9b59e3$var$Pj(b);
                if (null === a) throw Error($b9fb96103a9b59e3$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $b9fb96103a9b59e3$var$ph(a, b);
                $b9fb96103a9b59e3$var$uh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $b9fb96103a9b59e3$var$mj(Error($b9fb96103a9b59e3$var$p(423)), b);
                        b = $b9fb96103a9b59e3$var$Qj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $b9fb96103a9b59e3$var$mj(Error($b9fb96103a9b59e3$var$p(424)), b);
                        b = $b9fb96103a9b59e3$var$Qj(a, b, d, c, e);
                        break a;
                    } else for($b9fb96103a9b59e3$var$Mg = $b9fb96103a9b59e3$var$Zf(b.stateNode.containerInfo.firstChild), $b9fb96103a9b59e3$var$Lg = b, $b9fb96103a9b59e3$var$J = !0, $b9fb96103a9b59e3$var$Ng = null, c = $b9fb96103a9b59e3$var$Rh(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $b9fb96103a9b59e3$var$Wg();
                    if (d === e) {
                        b = $b9fb96103a9b59e3$var$Dj(a, b, c);
                        break a;
                    }
                    $b9fb96103a9b59e3$var$Bj(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $b9fb96103a9b59e3$var$Zh(b), null === a && $b9fb96103a9b59e3$var$Sg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $b9fb96103a9b59e3$var$Sf(d, e) ? g = null : null !== f && $b9fb96103a9b59e3$var$Sf(d, f) && (b.flags |= 32), $b9fb96103a9b59e3$var$Lj(a, b), $b9fb96103a9b59e3$var$Bj(a, b, g, c), b.child;
        case 6:
            return null === a && $b9fb96103a9b59e3$var$Sg(b), null;
        case 13:
            return $b9fb96103a9b59e3$var$Vj(a, b, c);
        case 4:
            return $b9fb96103a9b59e3$var$Xh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $b9fb96103a9b59e3$var$Qh(b, null, d, c) : $b9fb96103a9b59e3$var$Bj(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b9fb96103a9b59e3$var$Zg(d, e), $b9fb96103a9b59e3$var$Cj(a, b, d, e, c);
        case 7:
            return $b9fb96103a9b59e3$var$Bj(a, b, b.pendingProps, c), b.child;
        case 8:
            return $b9fb96103a9b59e3$var$Bj(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return b.flags |= 4, d = b.stateNode, d.effectDuration = 0, d.passiveEffectDuration = 0, $b9fb96103a9b59e3$var$Bj(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $b9fb96103a9b59e3$var$H($b9fb96103a9b59e3$var$$g, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($b9fb96103a9b59e3$var$Ve(f.value, g)) {
                        if (f.children === e.children && !$b9fb96103a9b59e3$var$jg.current) {
                            b = $b9fb96103a9b59e3$var$Dj(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $b9fb96103a9b59e3$var$qh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var n = l.pending;
                                            null === n ? k.next = k : (k.next = n.next, n.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $b9fb96103a9b59e3$var$fh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($b9fb96103a9b59e3$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $b9fb96103a9b59e3$var$fh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $b9fb96103a9b59e3$var$Bj(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $b9fb96103a9b59e3$var$gh(b, c), e = $b9fb96103a9b59e3$var$ih(e), $b9fb96103a9b59e3$var$sc(b), d = d(e), $b9fb96103a9b59e3$var$tc(), b.flags |= 1, $b9fb96103a9b59e3$var$Bj(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $b9fb96103a9b59e3$var$Zg(d, b.pendingProps), e = $b9fb96103a9b59e3$var$Zg(d.type, e), $b9fb96103a9b59e3$var$Ej(a, b, d, e, c);
        case 15:
            return $b9fb96103a9b59e3$var$Gj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b9fb96103a9b59e3$var$Zg(d, e), $b9fb96103a9b59e3$var$Nj(a, b), b.tag = 1, $b9fb96103a9b59e3$var$mg(d) ? (a = !0, $b9fb96103a9b59e3$var$qg(b)) : a = !1, $b9fb96103a9b59e3$var$gh(b, c), $b9fb96103a9b59e3$var$Eh(b, d, e), $b9fb96103a9b59e3$var$Gh(b, d, e, c), $b9fb96103a9b59e3$var$Oj(null, b, d, !0, a, c);
        case 19:
            return $b9fb96103a9b59e3$var$ek(a, b, c);
        case 22:
            return $b9fb96103a9b59e3$var$Ij(a, b, c);
    }
    throw Error($b9fb96103a9b59e3$var$p(156, b.tag));
};
function $b9fb96103a9b59e3$var$xj(a, b) {
    $b9fb96103a9b59e3$var$mc && a.memoizedUpdaters.forEach(function(c) {
        $b9fb96103a9b59e3$var$Pc(a, c, b);
    });
}
function $b9fb96103a9b59e3$var$sl(a, b) {
    return $b9fb96103a9b59e3$var$ac(a, b);
}
function $b9fb96103a9b59e3$var$Ol(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
    this.actualDuration = 0;
    this.actualStartTime = -1;
    this.treeBaseDuration = this.selfBaseDuration = 0;
}
function $b9fb96103a9b59e3$var$Pg(a, b, c, d) {
    return new $b9fb96103a9b59e3$var$Ol(a, b, c, d);
}
function $b9fb96103a9b59e3$var$Fj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $b9fb96103a9b59e3$var$Nl(a) {
    if ("function" === typeof a) return $b9fb96103a9b59e3$var$Fj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $b9fb96103a9b59e3$var$Da) return 11;
        if (a === $b9fb96103a9b59e3$var$Ga) return 14;
    }
    return 2;
}
function $b9fb96103a9b59e3$var$Lh(a, b) {
    var c = a.alternate;
    null === c ? (c = $b9fb96103a9b59e3$var$Pg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null, c.actualDuration = 0, c.actualStartTime = -1);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    c.selfBaseDuration = a.selfBaseDuration;
    c.treeBaseDuration = a.treeBaseDuration;
    return c;
}
function $b9fb96103a9b59e3$var$Nh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $b9fb96103a9b59e3$var$Fj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $b9fb96103a9b59e3$var$ya:
            return $b9fb96103a9b59e3$var$Ph(c.children, e, f, b);
        case $b9fb96103a9b59e3$var$za:
            g = 8;
            e |= 8;
            break;
        case $b9fb96103a9b59e3$var$Aa:
            return a = $b9fb96103a9b59e3$var$Pg(12, c, b, e | 2), a.elementType = $b9fb96103a9b59e3$var$Aa, a.lanes = f, a.stateNode = {
                effectDuration: 0,
                passiveEffectDuration: 0
            }, a;
        case $b9fb96103a9b59e3$var$Ea:
            return a = $b9fb96103a9b59e3$var$Pg(13, c, b, e), a.elementType = $b9fb96103a9b59e3$var$Ea, a.lanes = f, a;
        case $b9fb96103a9b59e3$var$Fa:
            return a = $b9fb96103a9b59e3$var$Pg(19, c, b, e), a.elementType = $b9fb96103a9b59e3$var$Fa, a.lanes = f, a;
        case $b9fb96103a9b59e3$var$Ia:
            return $b9fb96103a9b59e3$var$Wj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $b9fb96103a9b59e3$var$Ba:
                    g = 10;
                    break a;
                case $b9fb96103a9b59e3$var$Ca:
                    g = 9;
                    break a;
                case $b9fb96103a9b59e3$var$Da:
                    g = 11;
                    break a;
                case $b9fb96103a9b59e3$var$Ga:
                    g = 14;
                    break a;
                case $b9fb96103a9b59e3$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($b9fb96103a9b59e3$var$p(130, null == a ? a : typeof a === "undefined" ? "undefined" : (0, $l0HdX._)(a), ""));
    }
    b = $b9fb96103a9b59e3$var$Pg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $b9fb96103a9b59e3$var$Ph(a, b, c, d) {
    a = $b9fb96103a9b59e3$var$Pg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $b9fb96103a9b59e3$var$Wj(a, b, c, d) {
    a = $b9fb96103a9b59e3$var$Pg(22, a, d, b);
    a.elementType = $b9fb96103a9b59e3$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $b9fb96103a9b59e3$var$Mh(a, b, c) {
    a = $b9fb96103a9b59e3$var$Pg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $b9fb96103a9b59e3$var$Oh(a, b, c) {
    b = $b9fb96103a9b59e3$var$Pg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $b9fb96103a9b59e3$var$Pl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $b9fb96103a9b59e3$var$Lc(0);
    this.expirationTimes = $b9fb96103a9b59e3$var$Lc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $b9fb96103a9b59e3$var$Lc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
    this.passiveEffectDuration = this.effectDuration = 0;
    this.memoizedUpdaters = new Set;
    a = this.pendingUpdatersLaneMap = [];
    for(b = 0; 31 > b; b++)a.push(new Set);
}
function $b9fb96103a9b59e3$var$Ql(a, b, c, d, e, f, g, h, k) {
    a = new $b9fb96103a9b59e3$var$Pl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    $b9fb96103a9b59e3$var$mc && (b |= 2);
    f = $b9fb96103a9b59e3$var$Pg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $b9fb96103a9b59e3$var$oh(f);
    return a;
}
function $b9fb96103a9b59e3$var$Rl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $b9fb96103a9b59e3$var$xa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $b9fb96103a9b59e3$var$Sl(a) {
    if (!a) return $b9fb96103a9b59e3$var$ig;
    a = a._reactInternals;
    a: {
        if ($b9fb96103a9b59e3$var$Vb(a) !== a || 1 !== a.tag) throw Error($b9fb96103a9b59e3$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($b9fb96103a9b59e3$var$mg(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($b9fb96103a9b59e3$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($b9fb96103a9b59e3$var$mg(c)) return $b9fb96103a9b59e3$var$pg(a, c, b);
    }
    return b;
}
function $b9fb96103a9b59e3$var$Tl(a, b, c, d, e, f, g, h, k) {
    a = $b9fb96103a9b59e3$var$Ql(c, d, !0, a, e, f, g, h, k);
    a.context = $b9fb96103a9b59e3$var$Sl(null);
    c = a.current;
    d = $b9fb96103a9b59e3$var$zh();
    e = $b9fb96103a9b59e3$var$Ah(c);
    f = $b9fb96103a9b59e3$var$qh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $b9fb96103a9b59e3$var$rh(c, f, e);
    a.current.lanes = e;
    $b9fb96103a9b59e3$var$Mc(a, e, d);
    $b9fb96103a9b59e3$var$ql(a, d);
    return a;
}
function $b9fb96103a9b59e3$var$Ul(a, b, c, d) {
    var e = b.current, f = $b9fb96103a9b59e3$var$zh(), g = $b9fb96103a9b59e3$var$Ah(e);
    null !== $b9fb96103a9b59e3$var$B && "function" === typeof $b9fb96103a9b59e3$var$B.markRenderScheduled && $b9fb96103a9b59e3$var$B.markRenderScheduled(g);
    c = $b9fb96103a9b59e3$var$Sl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $b9fb96103a9b59e3$var$qh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $b9fb96103a9b59e3$var$rh(e, b, g);
    null !== a && ($b9fb96103a9b59e3$var$Bh(a, e, g, f), $b9fb96103a9b59e3$var$sh(a, e, g));
    return g;
}
function $b9fb96103a9b59e3$var$Vl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $b9fb96103a9b59e3$var$Wl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $b9fb96103a9b59e3$var$Xl(a, b) {
    $b9fb96103a9b59e3$var$Wl(a, b);
    (a = a.alternate) && $b9fb96103a9b59e3$var$Wl(a, b);
}
function $b9fb96103a9b59e3$var$Yl() {
    return null;
}
var $b9fb96103a9b59e3$var$Zl = "function" === typeof reportError ? reportError : function Zl(a) {
    console.error(a);
};
function $b9fb96103a9b59e3$var$$l(a) {
    this._internalRoot = a;
}
$b9fb96103a9b59e3$var$am.prototype.render = $b9fb96103a9b59e3$var$$l.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($b9fb96103a9b59e3$var$p(409));
    $b9fb96103a9b59e3$var$Ul(a, b, null, null);
};
$b9fb96103a9b59e3$var$am.prototype.unmount = $b9fb96103a9b59e3$var$$l.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $b9fb96103a9b59e3$var$Fl(function() {
            $b9fb96103a9b59e3$var$Ul(null, a, null, null);
        });
        b[$b9fb96103a9b59e3$var$If] = null;
    }
};
function $b9fb96103a9b59e3$var$am(a) {
    this._internalRoot = a;
}
$b9fb96103a9b59e3$var$am.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $b9fb96103a9b59e3$var$Vc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $b9fb96103a9b59e3$var$dd.length && 0 !== b && b < $b9fb96103a9b59e3$var$dd[c].priority; c++);
        $b9fb96103a9b59e3$var$dd.splice(c, 0, a);
        0 === c && $b9fb96103a9b59e3$var$id(a);
    }
};
function $b9fb96103a9b59e3$var$bm(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $b9fb96103a9b59e3$var$cm(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $b9fb96103a9b59e3$var$dm() {}
function $b9fb96103a9b59e3$var$em(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function d() {
                var _$a = $b9fb96103a9b59e3$var$Vl(g);
                f.call(_$a);
            };
        }
        var g = $b9fb96103a9b59e3$var$Tl(b, d, a, 0, null, !1, !1, "", $b9fb96103a9b59e3$var$dm);
        a._reactRootContainer = g;
        a[$b9fb96103a9b59e3$var$If] = g.current;
        $b9fb96103a9b59e3$var$Gf(8 === a.nodeType ? a.parentNode : a);
        $b9fb96103a9b59e3$var$Fl();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function d() {
            var _$a = $b9fb96103a9b59e3$var$Vl(k);
            h.call(_$a);
        };
    }
    var k = $b9fb96103a9b59e3$var$Ql(a, 0, !1, null, null, !1, !1, "", $b9fb96103a9b59e3$var$dm);
    a._reactRootContainer = k;
    a[$b9fb96103a9b59e3$var$If] = k.current;
    $b9fb96103a9b59e3$var$Gf(8 === a.nodeType ? a.parentNode : a);
    $b9fb96103a9b59e3$var$Fl(function() {
        $b9fb96103a9b59e3$var$Ul(b, k, c, d);
    });
    return k;
}
function $b9fb96103a9b59e3$var$fm(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function e() {
                var _$a = $b9fb96103a9b59e3$var$Vl(g);
                h.call(_$a);
            };
        }
        $b9fb96103a9b59e3$var$Ul(b, g, a, e);
    } else g = $b9fb96103a9b59e3$var$em(c, b, a, e, d);
    return $b9fb96103a9b59e3$var$Vl(g);
}
$b9fb96103a9b59e3$var$Sc = function Sc(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $b9fb96103a9b59e3$var$Fc(b.pendingLanes);
                0 !== c && ($b9fb96103a9b59e3$var$Oc(b, c | 1), $b9fb96103a9b59e3$var$ql(b, $b9fb96103a9b59e3$var$A()), 0 === ($b9fb96103a9b59e3$var$K & 6) && ($b9fb96103a9b59e3$var$nk = $b9fb96103a9b59e3$var$A() + 500, $b9fb96103a9b59e3$var$xg()));
            }
            break;
        case 13:
            $b9fb96103a9b59e3$var$Fl(function() {
                var b = $b9fb96103a9b59e3$var$mh(a, 1);
                if (null !== b) {
                    var c = $b9fb96103a9b59e3$var$zh();
                    $b9fb96103a9b59e3$var$Bh(b, a, 1, c);
                }
            }), $b9fb96103a9b59e3$var$Xl(a, 1);
    }
};
$b9fb96103a9b59e3$var$Tc = function Tc(a) {
    if (13 === a.tag) {
        var b = $b9fb96103a9b59e3$var$mh(a, 134217728);
        if (null !== b) {
            var c = $b9fb96103a9b59e3$var$zh();
            $b9fb96103a9b59e3$var$Bh(b, a, 134217728, c);
        }
        $b9fb96103a9b59e3$var$Xl(a, 134217728);
    }
};
$b9fb96103a9b59e3$var$Uc = function Uc(a) {
    if (13 === a.tag) {
        var b = $b9fb96103a9b59e3$var$Ah(a), c = $b9fb96103a9b59e3$var$mh(a, b);
        if (null !== c) {
            var d = $b9fb96103a9b59e3$var$zh();
            $b9fb96103a9b59e3$var$Bh(c, a, b, d);
        }
        $b9fb96103a9b59e3$var$Xl(a, b);
    }
};
$b9fb96103a9b59e3$var$Vc = function Vc() {
    return $b9fb96103a9b59e3$var$E;
};
$b9fb96103a9b59e3$var$Wc = function Wc(a, b) {
    var c = $b9fb96103a9b59e3$var$E;
    try {
        return $b9fb96103a9b59e3$var$E = a, b();
    } finally{
        $b9fb96103a9b59e3$var$E = c;
    }
};
$b9fb96103a9b59e3$var$yb = function yb(a, b, c) {
    switch(b){
        case "input":
            $b9fb96103a9b59e3$var$ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $b9fb96103a9b59e3$var$Db(d);
                        if (!e) throw Error($b9fb96103a9b59e3$var$p(90));
                        $b9fb96103a9b59e3$var$Wa(d);
                        $b9fb96103a9b59e3$var$ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $b9fb96103a9b59e3$var$hb(a, c);
            break;
        case "select":
            b = c.value, null != b && $b9fb96103a9b59e3$var$eb(a, !!c.multiple, b, !1);
    }
};
$b9fb96103a9b59e3$var$Gb = $b9fb96103a9b59e3$var$El;
$b9fb96103a9b59e3$var$Hb = $b9fb96103a9b59e3$var$Fl;
var $b9fb96103a9b59e3$var$gm = {
    usingClientEntryPoint: !1,
    Events: [
        $b9fb96103a9b59e3$var$Cb,
        $b9fb96103a9b59e3$var$Ie,
        $b9fb96103a9b59e3$var$Db,
        $b9fb96103a9b59e3$var$Eb,
        $b9fb96103a9b59e3$var$Fb,
        $b9fb96103a9b59e3$var$El
    ]
}, $b9fb96103a9b59e3$var$hm = {
    findFiberByHostInstance: $b9fb96103a9b59e3$var$jd,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
(function(a) {
    if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
    var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (b.isDisabled || !b.supportsFiber) return !0;
    try {
        a = $b9fb96103a9b59e3$var$u({}, a, {
            getLaneLabelMap: $b9fb96103a9b59e3$var$pc,
            injectProfilingHooks: $b9fb96103a9b59e3$var$oc
        }), $b9fb96103a9b59e3$var$kc = b.inject(a), $b9fb96103a9b59e3$var$lc = b;
    } catch (c) {}
    return b.checkDCE ? !0 : !1;
})({
    bundleType: $b9fb96103a9b59e3$var$hm.bundleType,
    version: $b9fb96103a9b59e3$var$hm.version,
    rendererPackageName: $b9fb96103a9b59e3$var$hm.rendererPackageName,
    rendererConfig: $b9fb96103a9b59e3$var$hm.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $b9fb96103a9b59e3$var$va.ReactCurrentDispatcher,
    findHostInstanceByFiber: function findHostInstanceByFiber(a) {
        a = $b9fb96103a9b59e3$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $b9fb96103a9b59e3$var$hm.findFiberByHostInstance || $b9fb96103a9b59e3$var$Yl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
});
$b9fb96103a9b59e3$export$ae55be85d98224ed = $b9fb96103a9b59e3$var$gm;
$b9fb96103a9b59e3$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$b9fb96103a9b59e3$var$bm(b)) throw Error($b9fb96103a9b59e3$var$p(200));
    return $b9fb96103a9b59e3$var$Rl(a, b, null, c);
};
$b9fb96103a9b59e3$export$882461b6382ed46c = function(a, b) {
    if (!$b9fb96103a9b59e3$var$bm(a)) throw Error($b9fb96103a9b59e3$var$p(299));
    var c = !1, d = "", e = $b9fb96103a9b59e3$var$Zl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $b9fb96103a9b59e3$var$Ql(a, 1, !1, null, null, c, !1, d, e);
    a[$b9fb96103a9b59e3$var$If] = b.current;
    $b9fb96103a9b59e3$var$Gf(8 === a.nodeType ? a.parentNode : a);
    return new $b9fb96103a9b59e3$var$$l(b);
};
$b9fb96103a9b59e3$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($b9fb96103a9b59e3$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($b9fb96103a9b59e3$var$p(268, a));
    }
    a = $b9fb96103a9b59e3$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$b9fb96103a9b59e3$export$cd75ccfd720a3cd4 = function(a) {
    return $b9fb96103a9b59e3$var$Fl(a);
};
$b9fb96103a9b59e3$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$b9fb96103a9b59e3$var$cm(b)) throw Error($b9fb96103a9b59e3$var$p(200));
    return $b9fb96103a9b59e3$var$fm(null, a, b, !0, c);
};
$b9fb96103a9b59e3$export$757ceba2d55c277e = function(a, b, c) {
    if (!$b9fb96103a9b59e3$var$bm(a)) throw Error($b9fb96103a9b59e3$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $b9fb96103a9b59e3$var$Zl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $b9fb96103a9b59e3$var$Tl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$b9fb96103a9b59e3$var$If] = b.current;
    $b9fb96103a9b59e3$var$Gf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $b9fb96103a9b59e3$var$am(b);
};
$b9fb96103a9b59e3$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$b9fb96103a9b59e3$var$cm(b)) throw Error($b9fb96103a9b59e3$var$p(200));
    return $b9fb96103a9b59e3$var$fm(null, a, b, !1, c);
};
$b9fb96103a9b59e3$export$502457920280e6be = function(a) {
    if (!$b9fb96103a9b59e3$var$cm(a)) throw Error($b9fb96103a9b59e3$var$p(40));
    return a._reactRootContainer ? ($b9fb96103a9b59e3$var$Fl(function() {
        $b9fb96103a9b59e3$var$fm(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$b9fb96103a9b59e3$var$If] = null;
        });
    }), !0) : !1;
};
$b9fb96103a9b59e3$export$c78a37762a8d58e1 = $b9fb96103a9b59e3$var$El;
$b9fb96103a9b59e3$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$b9fb96103a9b59e3$var$cm(c)) throw Error($b9fb96103a9b59e3$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($b9fb96103a9b59e3$var$p(38));
    return $b9fb96103a9b59e3$var$fm(a, b, c, !1, d);
};
$b9fb96103a9b59e3$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";
/* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());

});
parcelRegister("3rCRi", function(module, exports) {
"use strict";

module.exports = (parcelRequire("fcIYe"));

});
parcelRegister("fcIYe", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $b11adc311ce2c52a$export$c4744153514ff05d; }, function (v) { return $b11adc311ce2c52a$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $b11adc311ce2c52a$export$3e506c1ccc9cc1a7; }, function (v) { return $b11adc311ce2c52a$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $b11adc311ce2c52a$export$e26fe2ed2fa76875; }, function (v) { return $b11adc311ce2c52a$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $b11adc311ce2c52a$export$502329bbf4b505b1; }, function (v) { return $b11adc311ce2c52a$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $b11adc311ce2c52a$export$6e3807111c4874c4; }, function (v) { return $b11adc311ce2c52a$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $b11adc311ce2c52a$export$c27134553091fb3a; }, function (v) { return $b11adc311ce2c52a$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $b11adc311ce2c52a$export$33ee1acdc04fd2a2; }, function (v) { return $b11adc311ce2c52a$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $b11adc311ce2c52a$export$b00a404bbd5edef2; }, function (v) { return $b11adc311ce2c52a$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $b11adc311ce2c52a$export$8352ce38b91d0c62; }, function (v) { return $b11adc311ce2c52a$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $b11adc311ce2c52a$export$d66a1c1c77bd778b; }, function (v) { return $b11adc311ce2c52a$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $b11adc311ce2c52a$export$d3dfb8e4810cb555; }, function (v) { return $b11adc311ce2c52a$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $b11adc311ce2c52a$export$839f9183b0465a69; }, function (v) { return $b11adc311ce2c52a$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $b11adc311ce2c52a$export$72fdf0e06517287b; }, function (v) { return $b11adc311ce2c52a$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $b11adc311ce2c52a$export$4b844e58a3e414b4; }, function (v) { return $b11adc311ce2c52a$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $b11adc311ce2c52a$export$816d2913ae6b83b1; }, function (v) { return $b11adc311ce2c52a$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $b11adc311ce2c52a$export$61bcfe829111a1d0; }, function (v) { return $b11adc311ce2c52a$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $b11adc311ce2c52a$export$7ee8c9beb337bc3f; }, function (v) { return $b11adc311ce2c52a$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $b11adc311ce2c52a$export$b5836b71941fa3ed; }, function (v) { return $b11adc311ce2c52a$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $b11adc311ce2c52a$export$cf845f2c119da08a; }, function (v) { return $b11adc311ce2c52a$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b11adc311ce2c52a$export$c4744153514ff05d;
var $b11adc311ce2c52a$export$3e506c1ccc9cc1a7;
var $b11adc311ce2c52a$export$e26fe2ed2fa76875;
var $b11adc311ce2c52a$export$502329bbf4b505b1;
var $b11adc311ce2c52a$export$6e3807111c4874c4;
var $b11adc311ce2c52a$export$c27134553091fb3a;
var $b11adc311ce2c52a$export$33ee1acdc04fd2a2;
var $b11adc311ce2c52a$export$b00a404bbd5edef2;
var $b11adc311ce2c52a$export$8352ce38b91d0c62;
var $b11adc311ce2c52a$export$d66a1c1c77bd778b;
var $b11adc311ce2c52a$export$d3dfb8e4810cb555;
var $b11adc311ce2c52a$export$839f9183b0465a69;
var $b11adc311ce2c52a$export$72fdf0e06517287b;
var $b11adc311ce2c52a$export$4b844e58a3e414b4;
var $b11adc311ce2c52a$export$816d2913ae6b83b1;
var $b11adc311ce2c52a$export$61bcfe829111a1d0;
var $b11adc311ce2c52a$export$7ee8c9beb337bc3f;
var $b11adc311ce2c52a$export$b5836b71941fa3ed;
var $b11adc311ce2c52a$export$cf845f2c119da08a;
"use strict";
function $b11adc311ce2c52a$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $b11adc311ce2c52a$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $b11adc311ce2c52a$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $b11adc311ce2c52a$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $b11adc311ce2c52a$var$g(C, c)) n < e && 0 > $b11adc311ce2c52a$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $b11adc311ce2c52a$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $b11adc311ce2c52a$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $b11adc311ce2c52a$var$l = performance;
    $b11adc311ce2c52a$export$c4744153514ff05d = function() {
        return $b11adc311ce2c52a$var$l.now();
    };
} else {
    var $b11adc311ce2c52a$var$p = Date, $b11adc311ce2c52a$var$q = $b11adc311ce2c52a$var$p.now();
    $b11adc311ce2c52a$export$c4744153514ff05d = function() {
        return $b11adc311ce2c52a$var$p.now() - $b11adc311ce2c52a$var$q;
    };
}
var $b11adc311ce2c52a$var$r = [], $b11adc311ce2c52a$var$t = [], $b11adc311ce2c52a$var$u = 1, $b11adc311ce2c52a$var$v = null, $b11adc311ce2c52a$var$y = 3, $b11adc311ce2c52a$var$z = !1, $b11adc311ce2c52a$var$A = !1, $b11adc311ce2c52a$var$B = !1, $b11adc311ce2c52a$var$D = "function" === typeof setTimeout ? setTimeout : null, $b11adc311ce2c52a$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $b11adc311ce2c52a$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $b11adc311ce2c52a$var$G(a) {
    for(var b = $b11adc311ce2c52a$var$h($b11adc311ce2c52a$var$t); null !== b;){
        if (null === b.callback) $b11adc311ce2c52a$var$k($b11adc311ce2c52a$var$t);
        else if (b.startTime <= a) $b11adc311ce2c52a$var$k($b11adc311ce2c52a$var$t), b.sortIndex = b.expirationTime, $b11adc311ce2c52a$var$f($b11adc311ce2c52a$var$r, b);
        else break;
        b = $b11adc311ce2c52a$var$h($b11adc311ce2c52a$var$t);
    }
}
function $b11adc311ce2c52a$var$H(a) {
    $b11adc311ce2c52a$var$B = !1;
    $b11adc311ce2c52a$var$G(a);
    if (!$b11adc311ce2c52a$var$A) {
        if (null !== $b11adc311ce2c52a$var$h($b11adc311ce2c52a$var$r)) $b11adc311ce2c52a$var$A = !0, $b11adc311ce2c52a$var$I($b11adc311ce2c52a$var$J);
        else {
            var b = $b11adc311ce2c52a$var$h($b11adc311ce2c52a$var$t);
            null !== b && $b11adc311ce2c52a$var$K($b11adc311ce2c52a$var$H, b.startTime - a);
        }
    }
}
function $b11adc311ce2c52a$var$J(a, b) {
    $b11adc311ce2c52a$var$A = !1;
    $b11adc311ce2c52a$var$B && ($b11adc311ce2c52a$var$B = !1, $b11adc311ce2c52a$var$E($b11adc311ce2c52a$var$L), $b11adc311ce2c52a$var$L = -1);
    $b11adc311ce2c52a$var$z = !0;
    var c = $b11adc311ce2c52a$var$y;
    try {
        $b11adc311ce2c52a$var$G(b);
        for($b11adc311ce2c52a$var$v = $b11adc311ce2c52a$var$h($b11adc311ce2c52a$var$r); null !== $b11adc311ce2c52a$var$v && (!($b11adc311ce2c52a$var$v.expirationTime > b) || a && !$b11adc311ce2c52a$var$M());){
            var d = $b11adc311ce2c52a$var$v.callback;
            if ("function" === typeof d) {
                $b11adc311ce2c52a$var$v.callback = null;
                $b11adc311ce2c52a$var$y = $b11adc311ce2c52a$var$v.priorityLevel;
                var e = d($b11adc311ce2c52a$var$v.expirationTime <= b);
                b = $b11adc311ce2c52a$export$c4744153514ff05d();
                "function" === typeof e ? $b11adc311ce2c52a$var$v.callback = e : $b11adc311ce2c52a$var$v === $b11adc311ce2c52a$var$h($b11adc311ce2c52a$var$r) && $b11adc311ce2c52a$var$k($b11adc311ce2c52a$var$r);
                $b11adc311ce2c52a$var$G(b);
            } else $b11adc311ce2c52a$var$k($b11adc311ce2c52a$var$r);
            $b11adc311ce2c52a$var$v = $b11adc311ce2c52a$var$h($b11adc311ce2c52a$var$r);
        }
        if (null !== $b11adc311ce2c52a$var$v) var w = !0;
        else {
            var m = $b11adc311ce2c52a$var$h($b11adc311ce2c52a$var$t);
            null !== m && $b11adc311ce2c52a$var$K($b11adc311ce2c52a$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $b11adc311ce2c52a$var$v = null, $b11adc311ce2c52a$var$y = c, $b11adc311ce2c52a$var$z = !1;
    }
}
var $b11adc311ce2c52a$var$N = !1, $b11adc311ce2c52a$var$O = null, $b11adc311ce2c52a$var$L = -1, $b11adc311ce2c52a$var$P = 5, $b11adc311ce2c52a$var$Q = -1;
function $b11adc311ce2c52a$var$M() {
    return $b11adc311ce2c52a$export$c4744153514ff05d() - $b11adc311ce2c52a$var$Q < $b11adc311ce2c52a$var$P ? !1 : !0;
}
function $b11adc311ce2c52a$var$R() {
    if (null !== $b11adc311ce2c52a$var$O) {
        var a = $b11adc311ce2c52a$export$c4744153514ff05d();
        $b11adc311ce2c52a$var$Q = a;
        var b = !0;
        try {
            b = $b11adc311ce2c52a$var$O(!0, a);
        } finally{
            b ? $b11adc311ce2c52a$var$S() : ($b11adc311ce2c52a$var$N = !1, $b11adc311ce2c52a$var$O = null);
        }
    } else $b11adc311ce2c52a$var$N = !1;
}
var $b11adc311ce2c52a$var$S;
if ("function" === typeof $b11adc311ce2c52a$var$F) $b11adc311ce2c52a$var$S = function S() {
    $b11adc311ce2c52a$var$F($b11adc311ce2c52a$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $b11adc311ce2c52a$var$T = new MessageChannel, $b11adc311ce2c52a$var$U = $b11adc311ce2c52a$var$T.port2;
    $b11adc311ce2c52a$var$T.port1.onmessage = $b11adc311ce2c52a$var$R;
    $b11adc311ce2c52a$var$S = function S() {
        $b11adc311ce2c52a$var$U.postMessage(null);
    };
} else $b11adc311ce2c52a$var$S = function S() {
    $b11adc311ce2c52a$var$D($b11adc311ce2c52a$var$R, 0);
};
function $b11adc311ce2c52a$var$I(a) {
    $b11adc311ce2c52a$var$O = a;
    $b11adc311ce2c52a$var$N || ($b11adc311ce2c52a$var$N = !0, $b11adc311ce2c52a$var$S());
}
function $b11adc311ce2c52a$var$K(a, b) {
    $b11adc311ce2c52a$var$L = $b11adc311ce2c52a$var$D(function() {
        a($b11adc311ce2c52a$export$c4744153514ff05d());
    }, b);
}
$b11adc311ce2c52a$export$3e506c1ccc9cc1a7 = 5;
$b11adc311ce2c52a$export$e26fe2ed2fa76875 = 1;
$b11adc311ce2c52a$export$502329bbf4b505b1 = 4;
$b11adc311ce2c52a$export$6e3807111c4874c4 = 3;
$b11adc311ce2c52a$export$c27134553091fb3a = null;
$b11adc311ce2c52a$export$33ee1acdc04fd2a2 = 2;
$b11adc311ce2c52a$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$b11adc311ce2c52a$export$8352ce38b91d0c62 = function() {
    $b11adc311ce2c52a$var$A || $b11adc311ce2c52a$var$z || ($b11adc311ce2c52a$var$A = !0, $b11adc311ce2c52a$var$I($b11adc311ce2c52a$var$J));
};
$b11adc311ce2c52a$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $b11adc311ce2c52a$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$b11adc311ce2c52a$export$d3dfb8e4810cb555 = function() {
    return $b11adc311ce2c52a$var$y;
};
$b11adc311ce2c52a$export$839f9183b0465a69 = function() {
    return $b11adc311ce2c52a$var$h($b11adc311ce2c52a$var$r);
};
$b11adc311ce2c52a$export$72fdf0e06517287b = function(a) {
    switch($b11adc311ce2c52a$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $b11adc311ce2c52a$var$y;
    }
    var c = $b11adc311ce2c52a$var$y;
    $b11adc311ce2c52a$var$y = b;
    try {
        return a();
    } finally{
        $b11adc311ce2c52a$var$y = c;
    }
};
$b11adc311ce2c52a$export$4b844e58a3e414b4 = function() {};
$b11adc311ce2c52a$export$816d2913ae6b83b1 = function() {};
$b11adc311ce2c52a$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $b11adc311ce2c52a$var$y;
    $b11adc311ce2c52a$var$y = a;
    try {
        return b();
    } finally{
        $b11adc311ce2c52a$var$y = c;
    }
};
$b11adc311ce2c52a$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $b11adc311ce2c52a$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $b11adc311ce2c52a$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $b11adc311ce2c52a$var$f($b11adc311ce2c52a$var$t, a), null === $b11adc311ce2c52a$var$h($b11adc311ce2c52a$var$r) && a === $b11adc311ce2c52a$var$h($b11adc311ce2c52a$var$t) && ($b11adc311ce2c52a$var$B ? ($b11adc311ce2c52a$var$E($b11adc311ce2c52a$var$L), $b11adc311ce2c52a$var$L = -1) : $b11adc311ce2c52a$var$B = !0, $b11adc311ce2c52a$var$K($b11adc311ce2c52a$var$H, c - d))) : (a.sortIndex = e, $b11adc311ce2c52a$var$f($b11adc311ce2c52a$var$r, a), $b11adc311ce2c52a$var$A || $b11adc311ce2c52a$var$z || ($b11adc311ce2c52a$var$A = !0, $b11adc311ce2c52a$var$I($b11adc311ce2c52a$var$J)));
    return a;
};
$b11adc311ce2c52a$export$b5836b71941fa3ed = $b11adc311ce2c52a$var$M;
$b11adc311ce2c52a$export$cf845f2c119da08a = function(a) {
    var b = $b11adc311ce2c52a$var$y;
    return function() {
        var c = $b11adc311ce2c52a$var$y;
        $b11adc311ce2c52a$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $b11adc311ce2c52a$var$y = c;
        }
    };
};

});





parcelRegister("cZ38z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $973d9d85a769721b$export$2e2bcd8739ae039; });

var $c8XwH = parcelRequire("c8XwH");

var $hFggt = parcelRequire("hFggt");

var $0FR1f = parcelRequire("0FR1f");
function $973d9d85a769721b$var$v4(options, buf, offset) {
    if ((0, $c8XwH.default).randomUUID && !buf && !options) return (0, $c8XwH.default).randomUUID();
    options = options || {};
    var rnds = options.random || (options.rng || (0, $hFggt.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $0FR1f.unsafeStringify)(rnds);
}
var $973d9d85a769721b$export$2e2bcd8739ae039 = $973d9d85a769721b$var$v4;

});
parcelRegister("c8XwH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d746814f11e4d95$export$2e2bcd8739ae039; });
var $8d746814f11e4d95$var$randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $8d746814f11e4d95$export$2e2bcd8739ae039 = {
    randomUUID: $8d746814f11e4d95$var$randomUUID
};

});

parcelRegister("hFggt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cdc2e1d0e0d2ec64$export$2e2bcd8739ae039; });
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var $cdc2e1d0e0d2ec64$var$getRandomValues;
var $cdc2e1d0e0d2ec64$var$rnds8 = new Uint8Array(16);
function $cdc2e1d0e0d2ec64$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$cdc2e1d0e0d2ec64$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $cdc2e1d0e0d2ec64$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$cdc2e1d0e0d2ec64$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $cdc2e1d0e0d2ec64$var$getRandomValues($cdc2e1d0e0d2ec64$var$rnds8);
}

});

parcelRegister("0FR1f", function(module, exports) {

$parcel$export(module.exports, "unsafeStringify", function () { return $002077903b45a435$export$8fb373d660548968; });

var $agcbr = parcelRequire("agcbr");
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $002077903b45a435$var$byteToHex = [];
for(var $002077903b45a435$var$i = 0; $002077903b45a435$var$i < 256; ++$002077903b45a435$var$i)$002077903b45a435$var$byteToHex.push(($002077903b45a435$var$i + 0x100).toString(16).slice(1));
function $002077903b45a435$export$8fb373d660548968(arr) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $002077903b45a435$var$byteToHex[arr[offset + 0]] + $002077903b45a435$var$byteToHex[arr[offset + 1]] + $002077903b45a435$var$byteToHex[arr[offset + 2]] + $002077903b45a435$var$byteToHex[arr[offset + 3]] + "-" + $002077903b45a435$var$byteToHex[arr[offset + 4]] + $002077903b45a435$var$byteToHex[arr[offset + 5]] + "-" + $002077903b45a435$var$byteToHex[arr[offset + 6]] + $002077903b45a435$var$byteToHex[arr[offset + 7]] + "-" + $002077903b45a435$var$byteToHex[arr[offset + 8]] + $002077903b45a435$var$byteToHex[arr[offset + 9]] + "-" + $002077903b45a435$var$byteToHex[arr[offset + 10]] + $002077903b45a435$var$byteToHex[arr[offset + 11]] + $002077903b45a435$var$byteToHex[arr[offset + 12]] + $002077903b45a435$var$byteToHex[arr[offset + 13]] + $002077903b45a435$var$byteToHex[arr[offset + 14]] + $002077903b45a435$var$byteToHex[arr[offset + 15]];
}
function $002077903b45a435$var$stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    var uuid = $002077903b45a435$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $agcbr.default)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $002077903b45a435$export$2e2bcd8739ae039 = $002077903b45a435$var$stringify;

});
parcelRegister("agcbr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7784d9692e20e659$export$2e2bcd8739ae039; });

var $dPnGR = parcelRequire("dPnGR");
function $7784d9692e20e659$var$validate(uuid) {
    return typeof uuid === "string" && (0, $dPnGR.default).test(uuid);
}
var $7784d9692e20e659$export$2e2bcd8739ae039 = $7784d9692e20e659$var$validate;

});
parcelRegister("dPnGR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a1126a2b14a73422$export$2e2bcd8739ae039; });
var $a1126a2b14a73422$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

});




parcelRegister("9MEdR", function(module, exports) {

$parcel$export(module.exports, "initializeFeatureGatesClient", function () { return $dd1960f916e7cf23$export$933af3c61da21c8d; });

var $kSuI9 = parcelRequire("kSuI9");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $l29cN = parcelRequire("l29cN");

var $coBSS = parcelRequire("coBSS");
var $dd1960f916e7cf23$export$5a16cf6d9176400b = "bxp-web-platform_web";
var $dd1960f916e7cf23$var$getEnvironment = function() {
    return (0, $coBSS.FeatureGateEnvironment).Production;
};
var $dd1960f916e7cf23$export$933af3c61da21c8d = function() {
    var _ref = (0, $kSuI9._)(function(bootstrapValues) {
        var options;
        var _arguments = arguments;
        return (0, $l29cN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    return [
                        4,
                        (0, (/*@__PURE__*/$parcel$interopDefault($coBSS))).initializeFromValues((0, $cxjpp._)((0, $do9pw._)({}, options), {
                            environment: $dd1960f916e7cf23$var$getEnvironment(),
                            targetApp: $dd1960f916e7cf23$export$5a16cf6d9176400b,
                            sdkKey: bootstrapValues.clientSdkKey,
                            eventLoggingApi: "https://xp.atlassian.com/v1/"
                        }), bootstrapValues.identifiers, bootstrapValues.customAttributes, bootstrapValues.experimentValues)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function initializeFeatureGatesClient(bootstrapValues) {
        return _ref.apply(this, arguments);
    };
}();

});
parcelRegister("kSuI9", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f330ac5f61e1368d$export$7c398597f8905a1; });
function $f330ac5f61e1368d$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $f330ac5f61e1368d$export$7c398597f8905a1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $f330ac5f61e1368d$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $f330ac5f61e1368d$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRegister("do9pw", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $9bf4d105a019f48b$export$581ff339ea0ba762; });

var $3sHb8 = parcelRequire("3sHb8");
function $9bf4d105a019f48b$export$581ff339ea0ba762(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $3sHb8._define_property)(target, key, source[key]);
        });
    }
    return target;
}

});
parcelRegister("3sHb8", function(module, exports) {

$parcel$export(module.exports, "_define_property", function () { return $28557b013f37bb6b$export$1e71eb4bef00f6b0; });
$parcel$export(module.exports, "_", function () { return $28557b013f37bb6b$export$1e71eb4bef00f6b0; });
function $28557b013f37bb6b$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRegister("cxjpp", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $92079f442e5d1061$export$4fa2f4023c9cbda5; });
function $92079f442e5d1061$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $92079f442e5d1061$export$4fa2f4023c9cbda5(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $92079f442e5d1061$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});

parcelRegister("l29cN", function(module, exports) {

$parcel$export(module.exports, "__extends", function () { return $f500ece5c74d6d3d$export$a8ba968b8961cb8a; });
$parcel$export(module.exports, "__assign", function () { return $f500ece5c74d6d3d$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__rest", function () { return $f500ece5c74d6d3d$export$3c9a16f847548506; });
$parcel$export(module.exports, "__generator", function () { return $f500ece5c74d6d3d$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__exportStar", function () { return $f500ece5c74d6d3d$export$f33643c0debef087; });
$parcel$export(module.exports, "__values", function () { return $f500ece5c74d6d3d$export$19a8beecd37a4c45; });
$parcel$export(module.exports, "__spread", function () { return $f500ece5c74d6d3d$export$afc72e2116322959; });
$parcel$export(module.exports, "__spreadArrays", function () { return $f500ece5c74d6d3d$export$6388937ca91ccae8; });
$parcel$export(module.exports, "__spreadArray", function () { return $f500ece5c74d6d3d$export$1216008129fb82ed; });
$parcel$export(module.exports, "__importDefault", function () { return $f500ece5c74d6d3d$export$da59b14a69baef04; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ 
var $l0HdX = parcelRequire("l0HdX");
var $f500ece5c74d6d3d$var$extendStatics = function extendStatics1(d, b) {
    $f500ece5c74d6d3d$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $f500ece5c74d6d3d$var$extendStatics(d, b);
};
function $f500ece5c74d6d3d$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $f500ece5c74d6d3d$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $f500ece5c74d6d3d$export$18ce0697a983be9b = function __assign1() {
    $f500ece5c74d6d3d$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f500ece5c74d6d3d$export$18ce0697a983be9b.apply(this, arguments);
};
function $f500ece5c74d6d3d$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $f500ece5c74d6d3d$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $f500ece5c74d6d3d$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $f500ece5c74d6d3d$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $f500ece5c74d6d3d$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $f500ece5c74d6d3d$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $l0HdX._)(x)) === "symbol" ? x : "".concat(x);
}
function $f500ece5c74d6d3d$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $l0HdX._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $f500ece5c74d6d3d$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $f500ece5c74d6d3d$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $f500ece5c74d6d3d$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $f500ece5c74d6d3d$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $f500ece5c74d6d3d$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $f500ece5c74d6d3d$export$45d3717a4c69092e(o, m, p);
}
function $f500ece5c74d6d3d$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $f500ece5c74d6d3d$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $f500ece5c74d6d3d$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($f500ece5c74d6d3d$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $f500ece5c74d6d3d$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $f500ece5c74d6d3d$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $f500ece5c74d6d3d$export$10c90e4f7922046c(v) {
    return this instanceof $f500ece5c74d6d3d$export$10c90e4f7922046c ? (this.v = v, this) : new $f500ece5c74d6d3d$export$10c90e4f7922046c(v);
}
function $f500ece5c74d6d3d$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $f500ece5c74d6d3d$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $f500ece5c74d6d3d$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $f500ece5c74d6d3d$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $f500ece5c74d6d3d$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $f500ece5c74d6d3d$export$19a8beecd37a4c45 === "function" ? $f500ece5c74d6d3d$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $f500ece5c74d6d3d$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $f500ece5c74d6d3d$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $f500ece5c74d6d3d$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $f500ece5c74d6d3d$export$45d3717a4c69092e(result, mod, k);
    }
    $f500ece5c74d6d3d$var$__setModuleDefault(result, mod);
    return result;
}
function $f500ece5c74d6d3d$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $f500ece5c74d6d3d$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $f500ece5c74d6d3d$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $f500ece5c74d6d3d$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $f500ece5c74d6d3d$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $f500ece5c74d6d3d$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $f500ece5c74d6d3d$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $f500ece5c74d6d3d$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $f500ece5c74d6d3d$export$2e2bcd8739ae039 = {
    __extends: $f500ece5c74d6d3d$export$a8ba968b8961cb8a,
    __assign: $f500ece5c74d6d3d$export$18ce0697a983be9b,
    __rest: $f500ece5c74d6d3d$export$3c9a16f847548506,
    __decorate: $f500ece5c74d6d3d$export$29e00dfd3077644b,
    __param: $f500ece5c74d6d3d$export$d5ad3fd78186038f,
    __metadata: $f500ece5c74d6d3d$export$f1db080c865becb9,
    __awaiter: $f500ece5c74d6d3d$export$1050f835b63b671e,
    __generator: $f500ece5c74d6d3d$export$67ebef60e6f28a6,
    __createBinding: $f500ece5c74d6d3d$export$45d3717a4c69092e,
    __exportStar: $f500ece5c74d6d3d$export$f33643c0debef087,
    __values: $f500ece5c74d6d3d$export$19a8beecd37a4c45,
    __read: $f500ece5c74d6d3d$export$8d051b38c9118094,
    __spread: $f500ece5c74d6d3d$export$afc72e2116322959,
    __spreadArrays: $f500ece5c74d6d3d$export$6388937ca91ccae8,
    __spreadArray: $f500ece5c74d6d3d$export$1216008129fb82ed,
    __await: $f500ece5c74d6d3d$export$10c90e4f7922046c,
    __asyncGenerator: $f500ece5c74d6d3d$export$e427f37a30a4de9b,
    __asyncDelegator: $f500ece5c74d6d3d$export$bbd80228419bb833,
    __asyncValues: $f500ece5c74d6d3d$export$e3b29a3d6162315f,
    __makeTemplateObject: $f500ece5c74d6d3d$export$4fb47efe1390b86f,
    __importStar: $f500ece5c74d6d3d$export$c21735bcef00d192,
    __importDefault: $f500ece5c74d6d3d$export$da59b14a69baef04,
    __classPrivateFieldGet: $f500ece5c74d6d3d$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $f500ece5c74d6d3d$export$d40a35129aaff81f,
    __classPrivateFieldIn: $f500ece5c74d6d3d$export$81fdc39f203e4e04,
    __addDisposableResource: $f500ece5c74d6d3d$export$88ac25d8e944e405,
    __disposeResources: $f500ece5c74d6d3d$export$8f076105dc360e92
};

});

parcelRegister("coBSS", function(module, exports) {

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $cv9Rk = parcelRequire("cv9Rk");

var $l29cN = parcelRequire("l29cN");
"use strict";
var $90651cedd69a9f0f$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $90651cedd69a9f0f$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $90651cedd69a9f0f$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $90651cedd69a9f0f$var$__createBinding(result, mod, k);
    }
    $90651cedd69a9f0f$var$__setModuleDefault(result, mod);
    return result;
};
var $90651cedd69a9f0f$var$__exportStar = undefined && undefined.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $90651cedd69a9f0f$var$__createBinding(exports1, m, p);
};
var $90651cedd69a9f0f$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $90651cedd69a9f0f$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EvaluationReason = module.exports.DynamicConfig = void 0;

var $90651cedd69a9f0f$var$statsig_js_lite_1 = $90651cedd69a9f0f$var$__importStar((parcelRequire("4a2N3")));

Object.defineProperty(module.exports, "DynamicConfig", {
    enumerable: true,
    get: function get() {
        return (parcelRequire("4a2N3")).DynamicConfig;
    }
});
Object.defineProperty(module.exports, "EvaluationReason", {
    enumerable: true,
    get: function get() {
        return (parcelRequire("4a2N3")).EvaluationReason;
    }
});

var $90651cedd69a9f0f$var$fetcher_1 = $90651cedd69a9f0f$var$__importDefault((parcelRequire("1wwwU")));

$90651cedd69a9f0f$var$__exportStar((parcelRequire("fPNo7")), module.exports);
var $90651cedd69a9f0f$var$DEFAULT_CLIENT_KEY = "client-default-key";
// the default event logging api is the Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $90651cedd69a9f0f$var$DEFAULT_EVENT_LOGGING_API = "https://xp.atlassian.com/v1/";
var $90651cedd69a9f0f$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, $4GJKx._)(this, FeatureGates);
    }
    (0, $1wc17._)(FeatureGates, null, [
        {
            key: "initialize",
            value: function initialize(clientOptions, identifiers, customAttributes) {
                return (0, $kSuI9._)(function() {
                    return (0, $l29cN.__generator)(this, function(_state) {
                        if (FeatureGates.initPromise) {
                            if (!FeatureGates.shallowEquals(clientOptions, FeatureGates.initOptions)) console.warn("Feature Gates client already initialized with different options. New options were not applied.");
                            return [
                                2,
                                FeatureGates.initPromise
                            ];
                        }
                        FeatureGates.initOptions = clientOptions;
                        FeatureGates.initPromise = FeatureGates.init(clientOptions, identifiers, customAttributes).then(function() {
                            FeatureGates.initCompleted = true;
                        });
                        return [
                            2,
                            FeatureGates.initPromise
                        ];
                    });
                })();
            }
        },
        {
            key: "initializeFromValues",
            value: function initializeFromValues(clientOptions, identifiers, customAttributes) {
                var initializeValues = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
                return (0, $kSuI9._)(function() {
                    return (0, $l29cN.__generator)(this, function(_state) {
                        if (FeatureGates.initPromise) {
                            if (!FeatureGates.shallowEquals(clientOptions, FeatureGates.initOptions)) console.warn("Feature Gates client already initialized with different options. New options were not applied.");
                            return [
                                2,
                                FeatureGates.initPromise
                            ];
                        }
                        FeatureGates.initOptions = clientOptions;
                        FeatureGates.initPromise = FeatureGates.initFromValues(clientOptions, identifiers, customAttributes, initializeValues).then(function() {
                            FeatureGates.initCompleted = true;
                        });
                        return [
                            2,
                            FeatureGates.initPromise
                        ];
                    });
                })();
            }
        },
        {
            key: "updateUser",
            value: /**
     * This method updates the user using a network call to fetch the new set of values.
     * @param fetchOptions {FetcherOptions}
     * @param identifiers {Identifiers}
     * @param customAttributes {CustomAttributes}
     */ function updateUser(fetchOptions, identifiers, customAttributes) {
                return (0, $kSuI9._)(function() {
                    var initializeValuesProducer;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                initializeValuesProducer = function() {
                                    return $90651cedd69a9f0f$var$fetcher_1.default.fetchExperimentValues(fetchOptions, identifiers, customAttributes).then(function(param) {
                                        var experimentValues = param.experimentValues, _$customAttributes = param.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: _$customAttributes
                                        };
                                    });
                                };
                                return [
                                    4,
                                    FeatureGates.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updateUserWithValues",
            value: /**
     * This method updates the user given a new set of bootstrap values obtained from one of the server-side SDKs.
     *
     * @param identifiers {Identifiers}
     * @param customAttributes {CustomAttributes}
     * @param initializeValues {Record<string,unknown>}
     */ function updateUserWithValues(identifiers, customAttributes) {
                var initializeValues = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                return (0, $kSuI9._)(function() {
                    var initializeValuesProducer;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                initializeValuesProducer = function() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                return [
                                    4,
                                    FeatureGates.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return FeatureGates.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return FeatureGates.initCompleted;
            }
        },
        {
            key: "checkGate",
            value: /**
     * Returns the value for a feature gate. Returns false if there are errors.
     * @param gateName - The name of the feature gate.
     */ function checkGate(gateName) {
                try {
                    return $90651cedd69a9f0f$var$statsig_js_lite_1.default.checkGate(gateName);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!FeatureGates.hasCheckGateErrorOccurred) {
                        console.warn({
                            msg: "An error has occurred checking the feature gate. Only the first occurrence of this error is logged.",
                            gateName: gateName,
                            error: error
                        });
                        FeatureGates.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "getExperiment",
            value: /**
     * Returns the entire config for a given experiment.
     *
     * @param {string} experimentName - The name of the experiment
     * @param {Object} options
     * @param {boolean} options.fireExperimentExposure - Whether or not to fire the exposure event for the experiment. Defaults to true. To log an exposure event manually at a later time, use {@link manuallyLogExperimentExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
     * @returns The config for an experiment
     * @example
     * ```ts
     * const experimentConfig = FeatureGates.getExperiment('example-experiment-name');
     * const backgroundColor: string = experimentConfig.get('backgroundColor', 'yellow');
     * ```
     */ function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                try {
                    var _options_fireExperimentExposure = options.fireExperimentExposure, fireExperimentExposure = _options_fireExperimentExposure === void 0 ? true : _options_fireExperimentExposure;
                    var evalMethod = fireExperimentExposure ? $90651cedd69a9f0f$var$statsig_js_lite_1.default.getExperiment.bind($90651cedd69a9f0f$var$statsig_js_lite_1.default) : $90651cedd69a9f0f$var$statsig_js_lite_1.default.getExperimentWithExposureLoggingDisabled.bind($90651cedd69a9f0f$var$statsig_js_lite_1.default);
                    return evalMethod(experimentName);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!FeatureGates.hasGetExperimentErrorOccurred) {
                        console.warn({
                            msg: "An error has occurred getting the experiment. Only the first occurrence of this error is logged.",
                            experimentName: experimentName,
                            error: error
                        });
                        FeatureGates.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new $90651cedd69a9f0f$var$statsig_js_lite_1.DynamicConfig(experimentName, {}, "", {
                        time: Date.now(),
                        reason: $90651cedd69a9f0f$var$statsig_js_lite_1.EvaluationReason.Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: /**
     * Returns the value of a given parameter in an experiment config.
     *
     * @template T
     * @param {string} experimentName - The name of the experiment
     * @param {string} parameterName - The name of the parameter to fetch from the experiment config
     * @param {T} defaultValue - The value to serve if the experiment or parameter do not exist, or if the returned value does not match the expected type.
     * @param {Object} options
     * @param {boolean} options.fireExperimentExposure - Whether or not to fire the exposure event for the experiment. Defaults to true. To log an exposure event manually at a later time, use {@link manuallyLogExperimentExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-))
     * @param {function} options.typeGuard - A function that asserts that the return value has the expected type. If this function returns false, then the default value will be returned instead. This can be set to protect your code from unexpected values being set remotely. By default, this will be done by asserting that the default value and value are the same primitive type.
     * @returns The value of the parameter if the experiment and parameter both exist, otherwise the default value.
     * @example
     ``` ts
     type ValidColor = 'blue' | 'red' | 'yellow';
     type ValidColorTypeCheck = (value: unknown) => value is ValidColor;

     const isValidColor: ValidColorTypeCheck =
        (value: unknown) => typeof value === 'string' && ['blue', 'red', 'yellow'].includes(value);

     const buttonColor: ValidColor = FeatureGates.getExperimentValue(
        'example-experiment-name',
        'backgroundColor',
        'yellow',
        {
            typeGuard: isValidColor
        }
     );
     ```
    */ function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
                var experiment = FeatureGates.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!FeatureGates.hasGetExperimentValueErrorOccurred) {
                        console.warn({
                            msg: "An error has occurred getting the experiment value. Only the first occurrence of this error is logged.",
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        FeatureGates.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: /**
     * Manually log an experiment exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
     * This is useful if you have evaluated an experiment earlier via {@link getExperimentValue} or
     * {@link getExperiment} where <code>options.fireExperimentExposure</code> is false.
     * @param experimentName
     */ function manuallyLogExperimentExposure(experimentName) {
                $90651cedd69a9f0f$var$statsig_js_lite_1.default.manuallyLogExperimentExposure(experimentName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                $90651cedd69a9f0f$var$statsig_js_lite_1.default.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: /**
     * Adds a new override for the given gate.
     *
     * This method is additive, meaning you can call it multiple times with different gate names to build
     * your full set of overrides.
     *
     * Overrides are persisted to the `STATSIG_JS_LITE_LOCAL_OVERRIDES` key in localStorage, so they will
     * continue to affect every client that is initialized on the same domain after this method is called.
     * If you are using this API for testing purposes, you should call ${@link clearGateOverride} after
     * your tests are completed to remove this localStorage entry.
     *
     * @param {string} gateName
     * @param {boolean} value
     */ function overrideGate(gateName, value) {
                $90651cedd69a9f0f$var$statsig_js_lite_1.default.overrideGate(gateName, value);
            }
        },
        {
            key: "clearGateOverride",
            value: /**
     * Removes any overrides that have been set for the given gate.
     * @param {string} gateName
     */ function clearGateOverride(gateName) {
                $90651cedd69a9f0f$var$statsig_js_lite_1.default.overrideGate(gateName, null);
            }
        },
        {
            key: "overrideConfig",
            value: /**
     * Adds a new override for the given config (or experiment).
     *
     * This method is additive, meaning you can call it multiple times with different experiment names to build
     * your full set of overrides.
     *
     * Overrides are persisted to the `STATSIG_JS_LITE_LOCAL_OVERRIDES` key in localStorage, so they will
     * continue to affect every client that is initialized on the same domain after this method is called.
     * If you are using this API for testing purposes, you should call ${@link clearConfigOverride} after
     * your tests are completed to remove this localStorage entry.
     *
     * @param {string} experimentName
     * @param {object} values
     */ function overrideConfig(experimentName, values) {
                $90651cedd69a9f0f$var$statsig_js_lite_1.default.overrideConfig(experimentName, values);
            }
        },
        {
            key: "clearConfigOverride",
            value: /**
     * Removes any overrides that have been set for the given experiment.
     * @param {string} experimentName
     */ function clearConfigOverride(experimentName) {
                $90651cedd69a9f0f$var$statsig_js_lite_1.default.overrideConfig(experimentName, null);
            }
        },
        {
            key: "setOverrides",
            value: /**
     * Set overrides for gates, experiments and layers in batch.
     *
     * Note that these overrides are **not** additive and will completely replace any that have been added
     * via prior calls to {@link overrideConfig} or {@link overrideGate}.
     *
     * Overrides are persisted to the `STATSIG_JS_LITE_LOCAL_OVERRIDES` key in localStorage, so they will
     * continue to affect every client that is initialized on the same domain after this method is called.
     * If you are using this API for testing purposes, you should call ${@link clearAllOverrides} after
     * your tests are completed to remove this localStorage entry.
     *
     * @param {object} overrides
     */ function setOverrides(overrides) {
                $90651cedd69a9f0f$var$statsig_js_lite_1.default.setOverrides(Object.assign({
                    gates: {},
                    configs: {},
                    layers: {}
                }, overrides));
            }
        },
        {
            key: "clearAllOverrides",
            value: /**
     * Clears overrides for all gates, configs (including experiments) and layers.
     */ function clearAllOverrides() {
                $90651cedd69a9f0f$var$statsig_js_lite_1.default.setOverrides(null);
            }
        },
        {
            key: "isCurrentUser",
            value: /**
     * Returns whether the given identifiers and customAttributes align with the current
     * set that is being used by the client.
     *
     * If this method returns false, then the {@link updateUser} or {@link updateUserWithValues}
     * methods can be used to re-align these values.
     *
     * @param identifiers
     * @param customAttributes
     * @returns a flag indicating whether the clients current configuration aligns with the given values
     */ function isCurrentUser(identifiers, customAttributes) {
                return FeatureGates.shallowEquals(FeatureGates.currentIdentifiers, identifiers) && FeatureGates.shallowEquals(FeatureGates.currentAttributes, customAttributes);
            }
        },
        {
            key: "init",
            value: /**
     * This method initializes the client using a network call to fetch the bootstrap values for the given user.
     *
     * @param clientOptions
     * @param identifiers
     * @param customAttributes
     * @private
     */ function init(clientOptions, identifiers, customAttributes) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _ref, experimentValuesResult, error;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                fromValuesClientOptions = Object.assign(Object.assign({}, clientOptions), {
                                    disableCurrentPageLogging: true
                                });
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    5
                                ]);
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for the experiment
                                // values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = $90651cedd69a9f0f$var$fetcher_1.default.fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = $90651cedd69a9f0f$var$fetcher_1.default.fetchExperimentValues(clientOptions, identifiers, customAttributes);
                                return [
                                    4,
                                    Promise.all([
                                        clientSdkKeyPromise,
                                        experimentValuesPromise
                                    ])
                                ];
                            case 2:
                                _ref = (0, $cv9Rk._).apply(void 0, [
                                    _state.sent(),
                                    2
                                ]), experimentValuesResult = _ref[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                return [
                                    3,
                                    5
                                ];
                            case 3:
                                error = _state.sent();
                                if (error instanceof Error) console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(error === null || error === void 0 ? void 0 : error.message));
                                console.warn("Initialising Statsig client without values");
                                return [
                                    4,
                                    FeatureGates.initFromValues(fromValuesClientOptions, identifiers, customAttributes)
                                ];
                            case 4:
                                _state.sent();
                                throw error;
                            case 5:
                                return [
                                    4,
                                    _this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues)
                                ];
                            case 6:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "initFromValues",
            value: /**
     * This method initializes the client using a set of boostrap values obtained from one of the server-side SDKs.
     *
     * @param clientOptions
     * @param identifiers
     * @param customAttributes
     * @param initializeValues
     * @private
     */ function initFromValues(clientOptions, identifiers, customAttributes) {
                var initializeValues = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var user, sdkKey, statsigOptions, error;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                user = _this.toStatsigUser(identifiers, customAttributes);
                                FeatureGates.currentIdentifiers = identifiers;
                                FeatureGates.currentAttributes = customAttributes;
                                if (!clientOptions.sdkKey) clientOptions.sdkKey = $90651cedd69a9f0f$var$DEFAULT_CLIENT_KEY;
                                if (!clientOptions.eventLoggingApi) clientOptions.eventLoggingApi = $90651cedd69a9f0f$var$DEFAULT_EVENT_LOGGING_API;
                                sdkKey = clientOptions.sdkKey;
                                statsigOptions = _this.toStatsigOptions(clientOptions, initializeValues);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    $90651cedd69a9f0f$var$statsig_js_lite_1.default.initialize(sdkKey, user, statsigOptions)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 3:
                                error = _state.sent();
                                if (error instanceof Error) console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(error === null || error === void 0 ? void 0 : error.message));
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                return [
                                    4,
                                    $90651cedd69a9f0f$var$statsig_js_lite_1.default.initialize($90651cedd69a9f0f$var$DEFAULT_CLIENT_KEY, user, Object.assign(Object.assign({}, statsigOptions), {
                                        initializeValues: {}
                                    }))
                                ];
                            case 4:
                                _state.sent();
                                throw error;
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "toStatsigUser",
            value: /**
     * This method creates an instance of StatsigUser from the given set of identifiers and attributes.
     *
     * @param identifiers
     * @param customAttributes
     * @private
     */ function toStatsigUser(identifiers, customAttributes) {
                var user = {
                    customIDs: identifiers,
                    custom: customAttributes
                };
                if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
                return user;
            }
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: /**
     * This method updates the user for this client with the bootstrap values returned from a given Promise.
     * It uses the customAttributes from fetching experiment values to update the Statsig user but
     * uses the customAttributes from given input to check if the user has changed.
     *
     * @param identifiers
     * @param customAttributes
     * @param initializeValuesPromise
     * @private
     */ function updateUserUsingInitializeValuesProducer(getInitializeValues, identifiers, customAttributes) {
                return (0, $kSuI9._)(function() {
                    var originalInitPromise, err, initializeValuesPromise, updateUserPromise;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!FeatureGates.initPromise) throw new Error("The FeatureGates client must be initialized before you can update the user.");
                                // If the user isn't changing at all, then exit immediately
                                if (FeatureGates.isCurrentUser(identifiers, customAttributes)) return [
                                    2,
                                    FeatureGates.initPromise
                                ];
                                // Wait for the current initialize/update to finish
                                originalInitPromise = FeatureGates.initPromise;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    FeatureGates.initPromise
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                err = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = FeatureGates.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes);
                                // We replace the init promise here since we are essentially re-initializing the client at this point.
                                // Any subsequent calls to await FeatureGates.initialize() or FeatureGates.updateUser() will now also await this user update.
                                FeatureGates.initPromise = updateUserPromise.catch(function() {
                                    // If the update failed then it changed nothing, so revert back to the original promise.
                                    FeatureGates.initPromise = originalInitPromise;
                                });
                                return [
                                    2,
                                    updateUserPromise
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updateStatsigClientUser",
            value: /**
     * This method updates the user on the nested Statsig client
     *
     * @param identifiers
     * @param customAttributes
     * @param initializeValuesPromise
     * @private
     */ function updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes) {
                return (0, $kSuI9._)(function() {
                    var _a, _b, initializeValues, user, err, errMsg, success;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    initializeValuesPromise
                                ];
                            case 1:
                                initializeValues = _state.sent();
                                user = FeatureGates.toStatsigUser(identifiers, initializeValues.customAttributesFromFetch);
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will already invoke the callback itself.
                                errMsg = err instanceof Error ? err.message : JSON.stringify(err);
                                (_b = (_a = FeatureGates.initOptions).updateUserCompletionCallback) === null || _b === void 0 || _b.call(_a, false, errMsg);
                                throw err;
                            case 3:
                                success = $90651cedd69a9f0f$var$statsig_js_lite_1.default.updateUserWithValues(user, initializeValues.experimentValues);
                                if (success) {
                                    FeatureGates.currentIdentifiers = identifiers;
                                    FeatureGates.currentAttributes = customAttributes;
                                } else throw new Error("Failed to update user. An unexpected error occured.");
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "toStatsigOptions",
            value: /**
     * This method transforms the options given by the user into the format accepted by the Statsig client.
     *
     * @param options
     * @private
     */ function toStatsigOptions(options, initializeValues) {
                var // De-structured to remove from restClientOptions
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                sdkKey = options.sdkKey, // De-structured to remove from restClientOptions
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                updateUserCompletionCallback = options.updateUserCompletionCallback, restClientOptions = $90651cedd69a9f0f$var$__rest(options, [
                    "sdkKey",
                    "updateUserCompletionCallback"
                ]);
                return Object.assign(Object.assign(Object.assign({}, restClientOptions), {
                    initializeValues: initializeValues,
                    environment: {
                        tier: options.environment
                    },
                    disableCurrentPageLogging: true
                }), options.updateUserCompletionCallback && {
                    updateUserCompletionCallback: FeatureGates.toStatsigUpdateUserCompletionCallback(options.updateUserCompletionCallback)
                });
            }
        },
        {
            key: "toStatsigUpdateUserCompletionCallback",
            value: /**
     * This method transforms an UpdateUserCompletionCallback in our own format into the format accepted by the Statsig client.
     *
     * @param callback
     * @private
     */ function toStatsigUpdateUserCompletionCallback(callback) {
                /**
         * The duration passed to the callback indicates how long the update took, but it is deceptive since it only times the
         * Statsig code and doesn't account for all of the extra custom work we do to obtain the bootstrap values.
         * As a result, we just suppress this parameter in our own callback rather than trying to keep it accurate.
         */ return function(_duration, success, message) {
                    callback(success, message);
                };
            }
        },
        {
            key: "shallowEquals",
            value: function shallowEquals(objectA, objectB) {
                if (!objectA && !objectB) return true;
                if (!objectA || !objectB) return false;
                var aEntries = Object.entries(objectA);
                var bEntries = Object.entries(objectB);
                if (aEntries.length !== bEntries.length) return false;
                var ascendingKeyOrder = function(param, param1) {
                    var _param = (0, $cv9Rk._)(param, 1), key1 = _param[0], _param1 = (0, $cv9Rk._)(param1, 1), key2 = _param1[0];
                    return key1.localeCompare(key2);
                };
                aEntries.sort(ascendingKeyOrder);
                bEntries.sort(ascendingKeyOrder);
                for(var i = 0; i < aEntries.length; i++){
                    var _aEntries_i = (0, $cv9Rk._)(aEntries[i], 2), aValue = _aEntries_i[1];
                    var _bEntries_i = (0, $cv9Rk._)(bEntries[i], 2), bValue = _bEntries_i[1];
                    if (aValue !== bValue) return false;
                }
                return true;
            }
        }
    ]);
    return FeatureGates;
}();
$90651cedd69a9f0f$var$FeatureGates.initPromise = null;
$90651cedd69a9f0f$var$FeatureGates.initCompleted = false;
$90651cedd69a9f0f$var$FeatureGates.hasGetExperimentErrorOccurred = false;
$90651cedd69a9f0f$var$FeatureGates.hasGetExperimentValueErrorOccurred = false;
$90651cedd69a9f0f$var$FeatureGates.hasCheckGateErrorOccurred = false;
module.exports.default = $90651cedd69a9f0f$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cyprus tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== "undefined") window.__FEATUREGATES_JS__ = $90651cedd69a9f0f$var$FeatureGates;

});
parcelRegister("4GJKx", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $369e92947825c2b5$export$2996f80ef42b8419; });
function $369e92947825c2b5$export$2996f80ef42b8419(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("1wc17", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $11b219ef186b1c94$export$d60067ff2358eee8; });
function $11b219ef186b1c94$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $11b219ef186b1c94$export$d60067ff2358eee8(Constructor, protoProps, staticProps) {
    if (protoProps) $11b219ef186b1c94$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $11b219ef186b1c94$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("cv9Rk", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $91a007218046315e$export$fdf2a89c76341bbf; });

var $hrk7H = parcelRequire("hrk7H");

var $fBJYg = parcelRequire("fBJYg");

var $e8oCh = parcelRequire("e8oCh");

var $1hjNY = parcelRequire("1hjNY");
function $91a007218046315e$export$fdf2a89c76341bbf(arr, i) {
    return (0, $hrk7H._array_with_holes)(arr) || (0, $fBJYg._iterable_to_array_limit)(arr, i) || (0, $1hjNY._unsupported_iterable_to_array)(arr, i) || (0, $e8oCh._non_iterable_rest)();
}

});
parcelRegister("hrk7H", function(module, exports) {

$parcel$export(module.exports, "_array_with_holes", function () { return $cb24915816a1cfc9$export$e6256bf45c68d561; });
function $cb24915816a1cfc9$export$e6256bf45c68d561(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("fBJYg", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array_limit", function () { return $b5cdf895c6f08ea2$export$2fd15edff6687200; });
function $b5cdf895c6f08ea2$export$2fd15edff6687200(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("e8oCh", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_rest", function () { return $a4a4e8541bb818da$export$60dbc22abd7da546; });
function $a4a4e8541bb818da$export$60dbc22abd7da546() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("1hjNY", function(module, exports) {

$parcel$export(module.exports, "_unsupported_iterable_to_array", function () { return $0ee6bdd820e270f4$export$a5be06335b3a083c; });

var $QCMVH = parcelRequire("QCMVH");
function $0ee6bdd820e270f4$export$a5be06335b3a083c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $QCMVH._array_like_to_array)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $QCMVH._array_like_to_array)(o, minLen);
}

});
parcelRegister("QCMVH", function(module, exports) {

$parcel$export(module.exports, "_array_like_to_array", function () { return $09e2f1f84ceddf09$export$79e617b1955a2616; });
function $09e2f1f84ceddf09$export$79e617b1955a2616(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



parcelRegister("4a2N3", function(module, exports) {
"use strict";
var $307a42a86889970e$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $307a42a86889970e$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $307a42a86889970e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EvaluationReason = module.exports.DynamicConfig = void 0;

var $bhGgQ = parcelRequire("bhGgQ");

var $307a42a86889970e$var$StatsigClient_1 = $307a42a86889970e$var$__importDefault((parcelRequire("wERwh")));

var $5CQ4E = parcelRequire("5CQ4E");

var $fA4Ix = parcelRequire("fA4Ix");
Object.defineProperty(module.exports, "DynamicConfig", {
    enumerable: true,
    get: function get() {
        return $307a42a86889970e$var$__importDefault($fA4Ix).default;
    }
});

var $5CQ4E = parcelRequire("5CQ4E");
Object.defineProperty(module.exports, "EvaluationReason", {
    enumerable: true,
    get: function get() {
        return $5CQ4E.EvaluationReason;
    }
});
var $307a42a86889970e$var$Statsig = /** @class */ function() {
    function Statsig() {}
    Statsig.initialize = function(sdkKey, user, options) {
        var _a;
        return $307a42a86889970e$var$__awaiter(this, void 0, void 0, function() {
            var inst;
            return $307a42a86889970e$var$__generator(this, function(_b) {
                inst = (_a = Statsig.instance) !== null && _a !== void 0 ? _a : new $307a42a86889970e$var$StatsigClient_1.default(sdkKey, user, options);
                if (!Statsig.instance) Statsig.instance = inst;
                return [
                    2 /*return*/ ,
                    inst.initializeAsync()
                ];
            });
        });
    };
    Statsig.setInitializeValues = function(initializeValues) {
        Statsig._getClientX().setInitializeValues(initializeValues);
    };
    // Gate
    Statsig.checkGate = function(gateName) {
        return Statsig._getClientX().checkGate(gateName);
    };
    Statsig.checkGateWithExposureLoggingDisabled = function(gateName) {
        return Statsig._getClientX().checkGateWithExposureLoggingDisabled(gateName);
    };
    Statsig.manuallyLogGateExposure = function(gateName) {
        Statsig._getClientX().logGateExposure(gateName);
    };
    // Config
    Statsig.getConfig = function(configName) {
        return Statsig._getClientX().getConfig(configName);
    };
    Statsig.getConfigWithExposureLoggingDisabled = function(configName) {
        return Statsig._getClientX().getConfigWithExposureLoggingDisabled(configName);
    };
    Statsig.manuallyLogConfigExposure = function(configName) {
        Statsig._getClientX().logConfigExposure(configName);
    };
    // Experiment
    Statsig.getExperiment = function(experimentName) {
        return Statsig._getClientX().getExperiment(experimentName);
    };
    Statsig.getExperimentWithExposureLoggingDisabled = function(experimentName) {
        return Statsig._getClientX().getExperimentWithExposureLoggingDisabled(experimentName);
    };
    Statsig.manuallyLogExperimentExposure = function(configName) {
        Statsig._getClientX().logExperimentExposure(configName);
    };
    // Layer
    Statsig.getLayer = function(layerName) {
        return Statsig._getClientX().getLayer(layerName);
    };
    Statsig.getLayerWithExposureLoggingDisabled = function(layerName) {
        return Statsig._getClientX().getLayerWithExposureLoggingDisabled(layerName);
    };
    Statsig.manuallyLogLayerParameterExposure = function(layerName, parameterName) {
        Statsig._getClientX().logLayerParameterExposure(layerName, parameterName);
    };
    Statsig.logEvent = function(eventName, value, metadata) {
        if (value === void 0) value = null;
        if (metadata === void 0) metadata = null;
        return Statsig._getClientX().logEvent(eventName, value, metadata);
    };
    Statsig.updateUser = function(user) {
        return Statsig._getClientX().updateUser(user);
    };
    Statsig.updateUserWithValues = function(user, values) {
        return Statsig._getClientX().updateUserWithValues(user, values);
    };
    Statsig.shutdown = function() {
        Statsig._getClientX().shutdown();
        Statsig.instance = null;
    };
    Statsig.overrideGate = function(gate, result) {
        Statsig._getClientX().overrideGate(gate, result);
    };
    Statsig.overrideConfig = function(config, result) {
        Statsig._getClientX().overrideConfig(config, result);
    };
    Statsig.overrideLayer = function(layer, result) {
        Statsig._getClientX().overrideLayer(layer, result);
    };
    Statsig.setOverrides = function(overrides) {
        Statsig._getClientX().setOverrides(overrides);
    };
    Statsig.getOverrides = function() {
        return Statsig._getClientX().getOverrides();
    };
    /**
     * @returns The Statsig stable ID used for device level experiments
     */ Statsig.getStableID = function() {
        return Statsig._getClientX().getStableID();
    };
    /**
     *
     * @returns The reason and time associated with the evaluation for the current set
     * of gates and configs
     */ Statsig.getEvaluationDetails = function() {
        var _a, _b;
        return (_b = (_a = Statsig.instance) === null || _a === void 0 ? void 0 : _a.getEvaluationDetails()) !== null && _b !== void 0 ? _b : {
            reason: $5CQ4E.EvaluationReason.Uninitialized,
            time: 0
        };
    };
    /**
     *
     * @returns true if initialize has already been called, false otherwise
     */ Statsig.initializeCalled = function() {
        return Statsig.instance != null && Statsig.instance.initializeCalled();
    };
    Statsig._getClientX = function() {
        if (!Statsig.instance) throw new $bhGgQ.StatsigUninitializedError();
        return Statsig.instance;
    };
    Statsig.instance = null;
    return Statsig;
}();
module.exports.default = $307a42a86889970e$var$Statsig;

});
parcelRegister("bhGgQ", function(module, exports) {
"use strict";
var $8372124ece2a460e$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function extendStatics1(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigInvalidArgumentError = module.exports.StatsigUninitializedError = module.exports.StatsigErrorMessage = void 0;
var $8372124ece2a460e$var$StatsigErrorMessage;
(function(StatsigErrorMessage) {
    StatsigErrorMessage["REQUIRE_ASYNC_INITIALIZE"] = "Call initialize() first.";
    StatsigErrorMessage["REQUIRE_SYNC_INITIALIZE"] = "Call and wait for initialize() to finish first.";
    StatsigErrorMessage["REQUIRE_INITIALIZE_FOR_LOG_EVENT"] = "Must initialize() before logging events.";
})($8372124ece2a460e$var$StatsigErrorMessage = module.exports.StatsigErrorMessage || (module.exports.StatsigErrorMessage = {}));
var $8372124ece2a460e$var$StatsigUninitializedError = /** @class */ function(_super) {
    $8372124ece2a460e$var$__extends(StatsigUninitializedError, _super);
    function StatsigUninitializedError(message) {
        var _this = _super.call(this, message !== null && message !== void 0 ? message : $8372124ece2a460e$var$StatsigErrorMessage.REQUIRE_SYNC_INITIALIZE) || this;
        Object.setPrototypeOf(_this, StatsigUninitializedError.prototype);
        return _this;
    }
    return StatsigUninitializedError;
}(Error);
module.exports.StatsigUninitializedError = $8372124ece2a460e$var$StatsigUninitializedError;
var $8372124ece2a460e$var$StatsigInvalidArgumentError = /** @class */ function(_super) {
    $8372124ece2a460e$var$__extends(StatsigInvalidArgumentError, _super);
    function StatsigInvalidArgumentError(message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, StatsigInvalidArgumentError.prototype);
        return _this;
    }
    return StatsigInvalidArgumentError;
}(Error);
module.exports.StatsigInvalidArgumentError = $8372124ece2a460e$var$StatsigInvalidArgumentError;

});

parcelRegister("wERwh", function(module, exports) {
"use strict";
var $0622afa8c843497c$var$__assign = module.exports && module.exports.__assign || function() {
    $0622afa8c843497c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0622afa8c843497c$var$__assign.apply(this, arguments);
};
var $0622afa8c843497c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0622afa8c843497c$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $0622afa8c843497c$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $0622afa8c843497c$var$__createBinding(result, mod, k);
    }
    $0622afa8c843497c$var$__setModuleDefault(result, mod);
    return result;
};
var $0622afa8c843497c$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $0622afa8c843497c$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $0622afa8c843497c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $0622afa8c843497c$var$DynamicConfig_1 = $0622afa8c843497c$var$__importDefault((parcelRequire("fA4Ix")));

var $0622afa8c843497c$var$ErrorBoundary_1 = $0622afa8c843497c$var$__importDefault((parcelRequire("9KoGf")));

var $bhGgQ = parcelRequire("bhGgQ");

var $0622afa8c843497c$var$Layer_1 = $0622afa8c843497c$var$__importDefault((parcelRequire("ffWtM")));

var $0622afa8c843497c$var$StatsigIdentity_1 = $0622afa8c843497c$var$__importDefault((parcelRequire("9zRE1")));

var $0622afa8c843497c$var$StatsigLogger_1 = $0622afa8c843497c$var$__importDefault((parcelRequire("79GLI")));

var $0622afa8c843497c$var$StatsigNetwork_1 = $0622afa8c843497c$var$__importDefault((parcelRequire("7hd5D")));

var $0622afa8c843497c$var$StatsigSDKOptions_1 = $0622afa8c843497c$var$__importDefault((parcelRequire("1RaDd")));

var $0622afa8c843497c$var$StatsigStore_1 = $0622afa8c843497c$var$__importStar((parcelRequire("5CQ4E")));

var $0622afa8c843497c$var$StatsigLocalStorage_1 = $0622afa8c843497c$var$__importDefault((parcelRequire("5Jgq0")));

var $eof7c = parcelRequire("eof7c");

var $0622afa8c843497c$var$LogEvent_1 = $0622afa8c843497c$var$__importDefault((parcelRequire("bmARL")));

var $16J7V = parcelRequire("16J7V");
var $0622afa8c843497c$var$StatsigClient = /** @class */ function() {
    function StatsigClient(sdkKey, user, options) {
        var _this = this;
        this._initCalled = false;
        this._pendingInitPromise = null;
        this._logLayerParameterExposureForLayer = function(layer, parameterName, isManualExposure) {
            if (isManualExposure === void 0) isManualExposure = false;
            var allocatedExperiment = "";
            var exposures = layer._undelegatedSecondaryExposures;
            var isExplicit = layer._explicitParameters.includes(parameterName);
            if (isExplicit) {
                allocatedExperiment = layer._allocatedExperimentName;
                exposures = layer._secondaryExposures;
            }
            _this._logger.logLayerExposure(_this._identity._user, layer._name, layer._ruleID, exposures, allocatedExperiment, parameterName, isExplicit, layer._evaluationDetails, isManualExposure);
        };
        if ((options === null || options === void 0 ? void 0 : options.localMode) !== true && (typeof sdkKey !== "string" || !sdkKey.startsWith("client-"))) throw new $bhGgQ.StatsigInvalidArgumentError("Invalid key provided.  You must use a Client SDK Key from the Statsig console to initialize the sdk");
        this._startTime = (0, $eof7c.now)();
        this._errorBoundary = new $0622afa8c843497c$var$ErrorBoundary_1.default(sdkKey);
        this._ready = false;
        this._options = new $0622afa8c843497c$var$StatsigSDKOptions_1.default(options);
        $0622afa8c843497c$var$StatsigLocalStorage_1.default.disabled = this._options.disableLocalStorage;
        this._overrides = (0, $16J7V.loadOverridesFromLocalStorage)();
        this._identity = new $0622afa8c843497c$var$StatsigIdentity_1.default(sdkKey, this._normalizeUser(user !== null && user !== void 0 ? user : null), this._options.overrideStableID);
        this._network = new $0622afa8c843497c$var$StatsigNetwork_1.default(this._options, this._identity, this._errorBoundary);
        this._logger = new $0622afa8c843497c$var$StatsigLogger_1.default(this._options, this._identity, this._network, this._errorBoundary);
        this._store = new $0622afa8c843497c$var$StatsigStore_1.default(this._identity, this._logger.logConfigDefaultValueFallback, this._options.initializeValues);
        this._errorBoundary._setStatsigMetadata(this._identity._statsigMetadata);
        if (this._options.initializeValues != null) {
            this._ready = true;
            this._initCalled = true;
            setTimeout(function() {
                return _this._delayedSetup();
            }, 20);
        }
    }
    StatsigClient.prototype.setInitializeValues = function(initializeValues) {
        var _this = this;
        this._errorBoundary._capture("setInitializeValues", function() {
            _this._store.bootstrap(initializeValues);
            if (!_this._ready) {
                // the sdk is usable and considered initialized when configured
                // with initializeValues
                _this._ready = true;
                _this._initCalled = true;
            }
            // we wont have access to window/document/localStorage if these run on the server
            // so try to run whenever this is called
            _this._logger.sendSavedRequests();
        }, function() {
            _this._ready = true;
            _this._initCalled = true;
        });
    };
    StatsigClient.prototype.initializeAsync = function() {
        return $0622afa8c843497c$var$__awaiter(this, void 0, void 0, function() {
            var _this = this;
            return $0622afa8c843497c$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this._errorBoundary._capture("initializeAsync", function() {
                        return $0622afa8c843497c$var$__awaiter(_this, void 0, void 0, function() {
                            var user;
                            var _this = this;
                            return $0622afa8c843497c$var$__generator(this, function(_a) {
                                if (this._pendingInitPromise != null) return [
                                    2 /*return*/ ,
                                    this._pendingInitPromise
                                ];
                                if (this._ready) return [
                                    2 /*return*/ ,
                                    Promise.resolve()
                                ];
                                this._initCalled = true;
                                if (this._options.localMode) return [
                                    2 /*return*/ ,
                                    Promise.resolve()
                                ];
                                user = this._identity._user;
                                this._pendingInitPromise = this._fetchAndSaveValues(user, this._options.initTimeoutMs).then(function() {
                                    return;
                                }).catch(function(e) {
                                    _this._errorBoundary._logError("initializeAsync:fetchAndSaveValues", e);
                                    return {
                                        success: false,
                                        message: e.message
                                    };
                                }).then(function() {
                                    return;
                                }).finally(function() {
                                    return $0622afa8c843497c$var$__awaiter(_this, void 0, void 0, function() {
                                        return $0622afa8c843497c$var$__generator(this, function(_a) {
                                            this._pendingInitPromise = null;
                                            this._ready = true;
                                            this._delayedSetup();
                                            return [
                                                2 /*return*/ 
                                            ];
                                        });
                                    });
                                });
                                return [
                                    2 /*return*/ ,
                                    this._pendingInitPromise
                                ];
                            });
                        });
                    }, function() {
                        _this._ready = true;
                        _this._initCalled = true;
                        return Promise.resolve();
                    })
                ];
            });
        });
    };
    StatsigClient.prototype.getEvaluationDetails = function() {
        var _this = this;
        return this._errorBoundary._capture("getEvaluationDetails", function() {
            return _this._store.getGlobalEvaluationDetails();
        }, function() {
            return {
                time: Date.now(),
                reason: $0622afa8c843497c$var$StatsigStore_1.EvaluationReason.Error
            };
        });
    };
    /**
     * Checks the value of a gate for the current user
     * @param {string} gateName - the name of the gate to check
     * @returns {boolean} - value of a gate for the user. Gates are "off" (return false) by default
     * @throws Error if initialize() is not called first, or gateName is not a string
     */ StatsigClient.prototype.checkGate = function(gateName) {
        return this._checkGateImpl(gateName, "checkGate");
    };
    StatsigClient.prototype.checkGateWithExposureLoggingDisabled = function(gateName) {
        return this._checkGateImpl(gateName, "checkGateWithExposureLoggingDisabled");
    };
    StatsigClient.prototype.logGateExposure = function(gateName) {
        var _this = this;
        this._errorBoundary._swallow("logGateExposure", function() {
            _this._logGateExposureImpl(gateName);
        });
    };
    /**
     * Checks the value of a config for the current user
     * @param {string} configName - the name of the config to get
     * @returns {DynamicConfig} - value of a config for the user
     * @throws Error if initialize() is not called first, or configName is not a string
     */ StatsigClient.prototype.getConfig = function(configName) {
        return this._getConfigImpl(configName, "getConfig");
    };
    StatsigClient.prototype.getConfigWithExposureLoggingDisabled = function(configName) {
        return this._getConfigImpl(configName, "getConfigWithExposureLoggingDisabled");
    };
    StatsigClient.prototype.logConfigExposure = function(configName) {
        var _this = this;
        this._errorBoundary._swallow("logConfigExposure", function() {
            _this._logConfigExposureImpl(configName);
        });
    };
    StatsigClient.prototype.getExperiment = function(experimentName) {
        return this.getConfig(experimentName);
    };
    StatsigClient.prototype.getExperimentWithExposureLoggingDisabled = function(experimentName) {
        return this.getConfigWithExposureLoggingDisabled(experimentName);
    };
    StatsigClient.prototype.logExperimentExposure = function(experimentName) {
        this.logConfigExposure(experimentName);
    };
    StatsigClient.prototype.getLayer = function(layerName) {
        return this._getLayerImpl(layerName, "getLayer");
    };
    StatsigClient.prototype.getLayerWithExposureLoggingDisabled = function(layerName) {
        return this._getLayerImpl(layerName, "getLayerWithExposureLoggingDisabled");
    };
    StatsigClient.prototype.logLayerParameterExposure = function(layerName, parameterName) {
        var _this = this;
        this._errorBoundary._swallow("logLayerParameterExposure", function() {
            var layer = _this._getLayerFromStore(null, layerName);
            _this._logLayerParameterExposureForLayer(layer, parameterName, true);
        });
    };
    StatsigClient.prototype.logEvent = function(eventName, value, metadata) {
        var _this = this;
        if (value === void 0) value = null;
        if (metadata === void 0) metadata = null;
        this._errorBoundary._swallow("logEvent", function() {
            if (!_this._logger || !_this._identity._sdkKey) throw new $bhGgQ.StatsigUninitializedError($bhGgQ.StatsigErrorMessage.REQUIRE_INITIALIZE_FOR_LOG_EVENT);
            if (typeof eventName !== "string" || eventName.length === 0) return;
            var event = (0, $0622afa8c843497c$var$LogEvent_1.default)(eventName, _this._identity._user, _this._identity._statsigMetadata, value, metadata);
            _this._logger.log(event);
        });
    };
    StatsigClient.prototype.updateUserWithValues = function(user, values) {
        var _this = this;
        var updateStartTime = Date.now();
        var fireCompletionCallback;
        return this._errorBoundary._capture("updateUserWithValues", function() {
            if (!_this.initializeCalled()) throw new $bhGgQ.StatsigUninitializedError($bhGgQ.StatsigErrorMessage.REQUIRE_ASYNC_INITIALIZE);
            fireCompletionCallback = function fireCompletionCallback(success, error) {
                var cb = _this._options.updateUserCompletionCallback;
                cb === null || cb === void 0 || cb(Date.now() - updateStartTime, success, error);
            };
            _this._identity._user = _this._normalizeUser(user);
            _this._store.bootstrap(values);
            fireCompletionCallback(true, null);
            return true;
        }, function() {
            fireCompletionCallback === null || fireCompletionCallback === void 0 || fireCompletionCallback(false, "Failed to update user. An unexpected error occured.");
            return false;
        });
    };
    StatsigClient.prototype.updateUser = function(user) {
        return $0622afa8c843497c$var$__awaiter(this, void 0, void 0, function() {
            var updateStartTime, fireCompletionCallback;
            var _this = this;
            return $0622afa8c843497c$var$__generator(this, function(_a) {
                updateStartTime = Date.now();
                return [
                    2 /*return*/ ,
                    this._errorBoundary._capture("updateUser", function() {
                        return $0622afa8c843497c$var$__awaiter(_this, void 0, void 0, function() {
                            var currentUser;
                            var _this = this;
                            return $0622afa8c843497c$var$__generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if (!this.initializeCalled()) throw new $bhGgQ.StatsigUninitializedError($bhGgQ.StatsigErrorMessage.REQUIRE_ASYNC_INITIALIZE);
                                        fireCompletionCallback = function fireCompletionCallback(success, error) {
                                            var cb = _this._options.updateUserCompletionCallback;
                                            cb === null || cb === void 0 || cb(Date.now() - updateStartTime, success, error);
                                        };
                                        this._identity._user = this._normalizeUser(user);
                                        this._store.updateUser();
                                        this._logger.resetDedupeKeys();
                                        if (!(this._pendingInitPromise != null)) return [
                                            3 /*break*/ ,
                                            2
                                        ];
                                        return [
                                            4 /*yield*/ ,
                                            this._pendingInitPromise
                                        ];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2:
                                        if (this._options.localMode) {
                                            fireCompletionCallback(true, null);
                                            return [
                                                2 /*return*/ ,
                                                Promise.resolve(true)
                                            ];
                                        }
                                        currentUser = this._identity._user;
                                        this._pendingInitPromise = this._fetchAndSaveValues(currentUser).finally(function() {
                                            _this._pendingInitPromise = null;
                                        });
                                        return [
                                            2 /*return*/ ,
                                            this._pendingInitPromise.then(function() {
                                                fireCompletionCallback(true, null);
                                                return Promise.resolve(true);
                                            }).catch(function(error) {
                                                fireCompletionCallback(false, "Failed to update user: ".concat(error));
                                                return Promise.resolve(false);
                                            })
                                        ];
                                }
                            });
                        });
                    }, function() {
                        fireCompletionCallback(false, "Failed to update user. An unexpected error occured.");
                        return Promise.resolve(false);
                    })
                ];
            });
        });
    };
    /**
     * Informs the statsig SDK that the client is closing or shutting down
     * so the SDK can clean up internal state
     */ StatsigClient.prototype.shutdown = function() {
        var _this = this;
        this._errorBoundary._swallow("shutdown", function() {
            _this._logger.shutdown();
        });
    };
    /**
     * @returns The Statsig stable ID used for device level experiments
     */ StatsigClient.prototype.getStableID = function() {
        var _this = this;
        return this._errorBoundary._capture("getStableID", function() {
            return _this._identity._statsigMetadata.stableID;
        }, function() {
            return "";
        });
    };
    StatsigClient.prototype.initializeCalled = function() {
        return this._initCalled;
    };
    StatsigClient.prototype.overrideGate = function(gate, result) {
        this._setOverride("gates", gate, result);
    };
    StatsigClient.prototype.overrideConfig = function(config, result) {
        this._setOverride("configs", config, result);
    };
    StatsigClient.prototype.overrideLayer = function(layer, result) {
        this._setOverride("layers", layer, result);
    };
    StatsigClient.prototype.setOverrides = function(overrides) {
        var _this = this;
        this._errorBoundary._swallow("setOverrides", function() {
            _this._overrides = overrides !== null && overrides !== void 0 ? overrides : (0, $16J7V.makeEmptyOverrides)();
            (0, $16J7V.saveOverridesToLocalStorage)(_this._overrides);
        });
    };
    StatsigClient.prototype.getOverrides = function() {
        var _this = this;
        return this._errorBoundary._capture("getOverrides", function() {
            return _this._overrides;
        }, function() {
            return (0, $16J7V.makeEmptyOverrides)();
        });
    };
    // Private
    StatsigClient.prototype._delayedSetup = function() {
        var _this = this;
        this._errorBoundary._swallow("delayedSetup", function() {
            _this._identity.saveStableID();
            _this._logger.sendSavedRequests().then(function() {
            /* noop */ });
        });
    };
    StatsigClient.prototype._normalizeUser = function(user) {
        var userCopy = {};
        try {
            userCopy = JSON.parse(JSON.stringify(user));
        } catch (error) {
            throw new $bhGgQ.StatsigInvalidArgumentError("User object must be convertable to JSON string.");
        }
        if (this._options.environment != null) userCopy = $0622afa8c843497c$var$__assign($0622afa8c843497c$var$__assign({}, userCopy), {
            statsigEnvironment: this._options.environment
        });
        return userCopy;
    };
    StatsigClient.prototype._ensureStoreLoaded = function() {
        if (!this._store.isLoaded()) throw new $bhGgQ.StatsigUninitializedError();
    };
    StatsigClient.prototype._getEvaluationDetailsForError = function() {
        return {
            time: Date.now(),
            reason: $0622afa8c843497c$var$StatsigStore_1.EvaluationReason.Error
        };
    };
    StatsigClient.prototype._fetchAndSaveValues = function(user, timeout) {
        if (timeout === void 0) timeout = this._options.initTimeoutMs;
        return $0622afa8c843497c$var$__awaiter(this, void 0, void 0, function() {
            var sinceTime, previousDerivedFields;
            var _this = this;
            return $0622afa8c843497c$var$__generator(this, function(_a) {
                sinceTime = null;
                sinceTime = this._store.getLastUpdateTime(user);
                previousDerivedFields = this._store.getPreviousDerivedFields(user);
                return [
                    2 /*return*/ ,
                    this._network.fetchValues(user, sinceTime, timeout, previousDerivedFields).eventually(function(json) {
                        if (json === null || json === void 0 ? void 0 : json.has_updates) _this._store.save(user, json, false);
                    }).then(function(json) {
                        return $0622afa8c843497c$var$__awaiter(_this, void 0, void 0, function() {
                            var _this = this;
                            return $0622afa8c843497c$var$__generator(this, function(_a) {
                                return [
                                    2 /*return*/ ,
                                    this._errorBoundary._swallow("fetchAndSaveValues", function() {
                                        return $0622afa8c843497c$var$__awaiter(_this, void 0, void 0, function() {
                                            return $0622afa8c843497c$var$__generator(this, function(_a) {
                                                switch(_a.label){
                                                    case 0:
                                                        if (!(json === null || json === void 0 ? void 0 : json.has_updates)) return [
                                                            3 /*break*/ ,
                                                            2
                                                        ];
                                                        return [
                                                            4 /*yield*/ ,
                                                            this._store.save(user, json)
                                                        ];
                                                    case 1:
                                                        _a.sent();
                                                        return [
                                                            3 /*break*/ ,
                                                            3
                                                        ];
                                                    case 2:
                                                        if (json === null || json === void 0 ? void 0 : json.is_no_content) this._store.setEvaluationReason($0622afa8c843497c$var$StatsigStore_1.EvaluationReason.NetworkNotModified);
                                                        _a.label = 3;
                                                    case 3:
                                                        return [
                                                            2 /*return*/ 
                                                        ];
                                                }
                                            });
                                        });
                                    })
                                ];
                            });
                        });
                    })
                ];
            });
        });
    };
    StatsigClient.prototype._checkGateImpl = function(gateName, callsite) {
        var _this = this;
        return this._errorBoundary._capture(callsite, function() {
            if (typeof _this._overrides.gates[gateName] === "boolean") return _this._overrides.gates[gateName];
            var result = _this._getGateFromStore(gateName);
            if (callsite === "checkGate") _this._logGateExposureImpl(gateName, result);
            return result.gate.value === true;
        }, function() {
            return false;
        });
    };
    StatsigClient.prototype._getGateFromStore = function(gateName) {
        this._ensureStoreLoaded();
        if (typeof gateName !== "string" || gateName.length === 0) throw new $bhGgQ.StatsigInvalidArgumentError("Must pass a valid string as the gateName.");
        return this._store.checkGate(gateName);
    };
    StatsigClient.prototype._logGateExposureImpl = function(gateName, fetchResult) {
        var isManualExposure = !fetchResult;
        var result = fetchResult !== null && fetchResult !== void 0 ? fetchResult : this._getGateFromStore(gateName);
        var gate = result.gate;
        this._logger.logGateExposure(this._identity._user, gateName, gate.value, gate.rule_id, gate.secondary_exposures, result.evaluationDetails, isManualExposure);
    };
    StatsigClient.prototype._getConfigImpl = function(configName, callsite) {
        var _this = this;
        return this._errorBoundary._capture(callsite, function() {
            if (_this._overrides.configs[configName]) return new $0622afa8c843497c$var$DynamicConfig_1.default(configName, _this._overrides.configs[configName], "local_override", {
                reason: $0622afa8c843497c$var$StatsigStore_1.EvaluationReason.LocalOverride,
                time: Date.now()
            });
            var result = _this._getConfigFromStore(configName);
            if (callsite === "getConfig") _this._logConfigExposureImpl(configName, result);
            return result;
        }, function() {
            return _this._getEmptyConfig(configName);
        });
    };
    StatsigClient.prototype._getConfigFromStore = function(configName) {
        this._ensureStoreLoaded();
        if (typeof configName !== "string" || configName.length === 0) throw new $bhGgQ.StatsigInvalidArgumentError("Must pass a valid string as the configName.");
        return this._store.getConfig(configName);
    };
    StatsigClient.prototype._logConfigExposureImpl = function(configName, config) {
        var isManualExposure = !config;
        var localConfig = config !== null && config !== void 0 ? config : this._getConfigFromStore(configName);
        this._logger.logConfigExposure(this._identity._user, configName, localConfig._ruleID, localConfig._secondaryExposures, localConfig._evaluationDetails, isManualExposure);
    };
    StatsigClient.prototype._getLayerImpl = function(layerName, callsite) {
        var _this = this;
        return this._errorBoundary._capture(callsite, function() {
            if (_this._overrides.layers[layerName]) return $0622afa8c843497c$var$Layer_1.default._create(layerName, _this._overrides.layers[layerName], "local_override", {
                reason: $0622afa8c843497c$var$StatsigStore_1.EvaluationReason.LocalOverride,
                time: Date.now()
            });
            var logFunc = callsite === "getLayer" ? _this._logLayerParameterExposureForLayer : null;
            return _this._getLayerFromStore(logFunc, layerName);
        }, function() {
            return $0622afa8c843497c$var$Layer_1.default._create(layerName, {}, "", _this._getEvaluationDetailsForError());
        });
    };
    StatsigClient.prototype._getLayerFromStore = function(logParameterFunction, layerName) {
        this._ensureStoreLoaded();
        if (typeof layerName !== "string" || layerName.length === 0) throw new $bhGgQ.StatsigInvalidArgumentError("Must pass a valid string as the layerName.");
        return this._store.getLayer(logParameterFunction, layerName);
    };
    StatsigClient.prototype._getEmptyConfig = function(configName) {
        return new $0622afa8c843497c$var$DynamicConfig_1.default(configName, {}, "", this._getEvaluationDetailsForError());
    };
    StatsigClient.prototype._setOverride = function(type, key, result) {
        if (result == null) delete this._overrides[type][key];
        else this._overrides[type][key] = result;
        this.setOverrides(this._overrides);
    };
    return StatsigClient;
}();
module.exports.default = $0622afa8c843497c$var$StatsigClient;

});
parcelRegister("fA4Ix", function(module, exports) {

var $l0HdX = parcelRequire("l0HdX");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $b57de0924ec1e91b$var$DynamicConfig = /** @class */ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails, secondaryExposures, allocatedExperimentName, onDefaultValueFallback) {
        if (secondaryExposures === void 0) secondaryExposures = [];
        if (allocatedExperimentName === void 0) allocatedExperimentName = "";
        if (onDefaultValueFallback === void 0) onDefaultValueFallback = null;
        this._onDefaultValueFallback = null;
        this.value = JSON.parse(JSON.stringify(configValue !== null && configValue !== void 0 ? configValue : {}));
        this._name = configName;
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : "";
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    DynamicConfig.prototype.get = function(key, defaultValue, typeGuard) {
        var _a, _b;
        var val = this.getValue(key, defaultValue);
        if (val == null) return defaultValue;
        var expectedType = Array.isArray(defaultValue) ? "array" : typeof defaultValue === "undefined" ? "undefined" : (0, $l0HdX._)(defaultValue);
        var actualType = Array.isArray(val) ? "array" : typeof val === "undefined" ? "undefined" : (0, $l0HdX._)(val);
        if (typeGuard) {
            if (typeGuard(val)) return val;
            (_a = this._onDefaultValueFallback) === null || _a === void 0 || _a.call(this, this, key, expectedType, actualType);
            return defaultValue;
        }
        if (defaultValue == null || expectedType === actualType) return val;
        (_b = this._onDefaultValueFallback) === null || _b === void 0 || _b.call(this, this, key, expectedType, actualType);
        return defaultValue;
    };
    DynamicConfig.prototype.getValue = function(key, defaultValue) {
        if (key == null) return this.value;
        if (defaultValue == null) defaultValue = null;
        if (this.value[key] == null) return defaultValue;
        return this.value[key];
    };
    return DynamicConfig;
}();
module.exports.default = $b57de0924ec1e91b$var$DynamicConfig;

});

parcelRegister("9KoGf", function(module, exports) {
"use strict";
var $718b8df9abc64ba4$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $718b8df9abc64ba4$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExceptionEndpoint = void 0;

var $bhGgQ = parcelRequire("bhGgQ");
module.exports.ExceptionEndpoint = "https://statsigapi.net/v1/sdk_exception";
var $718b8df9abc64ba4$var$ErrorBoundary = /** @class */ function() {
    function ErrorBoundary(sdkKey) {
        this._seen = new Set();
        this._sdkKey = sdkKey;
    }
    ErrorBoundary.prototype._setStatsigMetadata = function(statsigMetadata) {
        this._statsigMetadata = statsigMetadata;
    };
    ErrorBoundary.prototype._swallow = function(tag, task) {
        this._capture(tag, task, function() {
            return undefined;
        });
    };
    ErrorBoundary.prototype._capture = function(tag, task, recover, getExtraData) {
        var _this = this;
        try {
            var result = task();
            if (result instanceof Promise) return result.catch(function(e) {
                return _this._onCaught(tag, e, recover, getExtraData);
            });
            return result;
        } catch (error) {
            return this._onCaught(tag, error, recover, getExtraData);
        }
    };
    ErrorBoundary.prototype._logError = function(tag, error, getExtraData) {
        var _this = this;
        try {
            var impl = function impl() {
                return $718b8df9abc64ba4$var$__awaiter(_this, void 0, void 0, function() {
                    var extra, _a, unwrapped, isError, name, info, metadata, body;
                    var _b;
                    return $718b8df9abc64ba4$var$__generator(this, function(_c) {
                        switch(_c.label){
                            case 0:
                                if (!(typeof getExtraData === "function")) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                return [
                                    4 /*yield*/ ,
                                    getExtraData()
                                ];
                            case 1:
                                _a = _c.sent();
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case 2:
                                _a = null;
                                _c.label = 3;
                            case 3:
                                extra = _a;
                                unwrapped = error !== null && error !== void 0 ? error : Error("[Statsig] Error was empty");
                                isError = unwrapped instanceof Error;
                                name = isError ? unwrapped.name : "No Name";
                                if (this._seen.has(name)) return [
                                    2 /*return*/ 
                                ];
                                this._seen.add(name);
                                info = isError ? unwrapped.stack : this._getDescription(unwrapped);
                                metadata = (_b = this._statsigMetadata) !== null && _b !== void 0 ? _b : {};
                                body = JSON.stringify({
                                    tag: tag,
                                    exception: name,
                                    info: info,
                                    statsigMetadata: metadata,
                                    extra: extra !== null && extra !== void 0 ? extra : {}
                                });
                                return [
                                    2 /*return*/ ,
                                    fetch(module.exports.ExceptionEndpoint, {
                                        method: "POST",
                                        headers: {
                                            "STATSIG-API-KEY": this._sdkKey,
                                            "STATSIG-SDK-TYPE": String(metadata["sdkType"]),
                                            "STATSIG-SDK-VERSION": String(metadata["sdkVersion"]),
                                            "Content-Type": "application/json",
                                            "Content-Length": "".concat(body.length)
                                        },
                                        body: body
                                    })
                                ];
                        }
                    });
                });
            };
            impl().then(function() {
            /* noop */ }).catch(function() {
            /* noop */ });
        } catch (_error) {
        /* noop */ }
    };
    ErrorBoundary.prototype._onCaught = function(tag, error, recover, getExtraData) {
        if (error instanceof $bhGgQ.StatsigUninitializedError || error instanceof $bhGgQ.StatsigInvalidArgumentError) throw error; // Don't catch these
        console.error("[Statsig] An unexpected exception occurred.", error);
        this._logError(tag, error, getExtraData);
        return recover();
    };
    ErrorBoundary.prototype._getDescription = function(obj) {
        try {
            return JSON.stringify(obj);
        } catch (_a) {
            return "[Statsig] Failed to get string for error.";
        }
    };
    return ErrorBoundary;
}();
module.exports.default = $718b8df9abc64ba4$var$ErrorBoundary;

});

parcelRegister("ffWtM", function(module, exports) {

var $l0HdX = parcelRequire("l0HdX");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $b1b59e84b5cff64d$var$Layer = /** @class */ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails, logParameterFunction, secondaryExposures, undelegatedSecondaryExposures, allocatedExperimentName, explicitParameters) {
        if (logParameterFunction === void 0) logParameterFunction = null;
        if (secondaryExposures === void 0) secondaryExposures = [];
        if (undelegatedSecondaryExposures === void 0) undelegatedSecondaryExposures = [];
        if (allocatedExperimentName === void 0) allocatedExperimentName = "";
        if (explicitParameters === void 0) explicitParameters = [];
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : "";
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    Layer._create = function(name, value, ruleID, evaluationDetails, logParameterFunction, secondaryExposures, undelegatedSecondaryExposures, allocatedExperimentName, explicitParameters) {
        if (logParameterFunction === void 0) logParameterFunction = null;
        if (secondaryExposures === void 0) secondaryExposures = [];
        if (undelegatedSecondaryExposures === void 0) undelegatedSecondaryExposures = [];
        if (allocatedExperimentName === void 0) allocatedExperimentName = "";
        if (explicitParameters === void 0) explicitParameters = [];
        return new Layer(name, value, ruleID, evaluationDetails, logParameterFunction, secondaryExposures, undelegatedSecondaryExposures, allocatedExperimentName, explicitParameters);
    };
    Layer.prototype.get = function(key, defaultValue, typeGuard) {
        var _this = this;
        var val = this._value[key];
        if (val == null) return defaultValue;
        var logAndReturn = function logAndReturn() {
            _this._logLayerParameterExposure(key);
            return val;
        };
        if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
        if (defaultValue == null) return logAndReturn();
        if ((typeof val === "undefined" ? "undefined" : (0, $l0HdX._)(val)) === (typeof defaultValue === "undefined" ? "undefined" : (0, $l0HdX._)(defaultValue)) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
        return defaultValue;
    };
    Layer.prototype.getValue = function(key, defaultValue) {
        if (defaultValue == undefined) defaultValue = null;
        var val = this._value[key];
        if (val != null) this._logLayerParameterExposure(key);
        return val !== null && val !== void 0 ? val : defaultValue;
    };
    Layer.prototype._logLayerParameterExposure = function(parameterName) {
        var _a;
        (_a = this._logParameterFunction) === null || _a === void 0 || _a.call(this, this, parameterName);
    };
    return Layer;
}();
module.exports.default = $b1b59e84b5cff64d$var$Layer;

});

parcelRegister("9zRE1", function(module, exports) {
"use strict";
var $6f90fe9a6f767be9$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $e1dzV = parcelRequire("e1dzV");

var $6X6PU = parcelRequire("6X6PU");

var $6f90fe9a6f767be9$var$StatsigLocalStorage_1 = $6f90fe9a6f767be9$var$__importDefault((parcelRequire("5Jgq0")));

var $ebF6O = parcelRequire("ebF6O");
var $6f90fe9a6f767be9$var$Identity = /** @class */ function() {
    function Identity(sdkKey, user, overrideStableID) {
        var _a;
        this._sdkType = "js-lite";
        this._sdkKey = sdkKey;
        this._user = user;
        this._sdkVersion = $ebF6O.version;
        var stableID = overrideStableID;
        stableID = (_a = stableID !== null && stableID !== void 0 ? stableID : $6f90fe9a6f767be9$var$StatsigLocalStorage_1.default.getItem($e1dzV.STATSIG_STABLE_ID_KEY)) !== null && _a !== void 0 ? _a : this._getUUID();
        this._statsigMetadata = {
            stableID: stableID,
            sdkType: this._sdkType,
            sdkVersion: this._sdkVersion
        };
    }
    Identity.prototype.saveStableID = function() {
        if (this._statsigMetadata.stableID != null) $6f90fe9a6f767be9$var$StatsigLocalStorage_1.default.setItem($e1dzV.STATSIG_STABLE_ID_KEY, this._statsigMetadata.stableID);
    };
    Identity.prototype.getUserCacheKey = function() {
        return (0, $6X6PU.getUserCacheKey)(this._user);
    };
    Identity.prototype._getUUID = function() {
        var uuid = "";
        for(var i = 0; i < 32; i++){
            if (i === 8 || i === 12 || i === 16 || i === 20) uuid += "-";
            var randomDigit = Math.random() * 16 | 0;
            if (i === 12) uuid += "4";
            else if (i === 16) uuid += (randomDigit & 3 | 8).toString(16);
            else uuid += randomDigit.toString(16);
        }
        return uuid;
    };
    return Identity;
}();
module.exports.default = $6f90fe9a6f767be9$var$Identity;

});
parcelRegister("e1dzV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LOCAL_STORAGE_KEYS = module.exports.STATSIG_LOCAL_STORAGE_LOGGING_REQUEST_KEY = module.exports.STATSIG_STABLE_ID_KEY = module.exports.INTERNAL_STORE_KEY = void 0;
module.exports.INTERNAL_STORE_KEY = "STATSIG_STORE";
module.exports.STATSIG_STABLE_ID_KEY = "STATSIG_STABLE_ID";
module.exports.STATSIG_LOCAL_STORAGE_LOGGING_REQUEST_KEY = "STATSIG_LOGS";
module.exports.LOCAL_STORAGE_KEYS = {
    INTERNAL_STORE_KEY: true,
    STATSIG_STABLE_ID_KEY: true,
    STATSIG_LOCAL_STORAGE_LOGGING_REQUEST_KEY: true
};

});

parcelRegister("6X6PU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getUserCacheKey = module.exports.getSortedObject = module.exports.djb2HashForObject = module.exports.getHashValue = module.exports.SimpleHash = void 0;
function $50fd8e4714b7a0a0$var$SimpleHash(value) {
    var hash = 0;
    for(var i = 0; i < value.length; i++){
        var character = value.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash; // Convert to 32bit integer
    }
    return String(hash >>> 0);
}
module.exports.SimpleHash = $50fd8e4714b7a0a0$var$SimpleHash;
function $50fd8e4714b7a0a0$var$getHashValue(value) {
    return $50fd8e4714b7a0a0$var$SimpleHash(value);
}
module.exports.getHashValue = $50fd8e4714b7a0a0$var$getHashValue;
function $50fd8e4714b7a0a0$var$djb2HashForObject(object) {
    return $50fd8e4714b7a0a0$var$SimpleHash(JSON.stringify($50fd8e4714b7a0a0$var$getSortedObject(object)));
}
module.exports.djb2HashForObject = $50fd8e4714b7a0a0$var$djb2HashForObject;
function $50fd8e4714b7a0a0$var$getSortedObject(object) {
    if (object == null) return null;
    var keys = Object.keys(object).sort();
    var sortedObject = {};
    keys.forEach(function(key) {
        var value = object[key];
        if (value instanceof Object) value = $50fd8e4714b7a0a0$var$getSortedObject(value);
        sortedObject[key] = value;
    });
    return sortedObject;
}
module.exports.getSortedObject = $50fd8e4714b7a0a0$var$getSortedObject;
function $50fd8e4714b7a0a0$var$getUserCacheKey(user) {
    var _a;
    var key = "userID:".concat(String((_a = user === null || user === void 0 ? void 0 : user.userID) !== null && _a !== void 0 ? _a : ""));
    var customIDs = user === null || user === void 0 ? void 0 : user.customIDs;
    if (customIDs != null) for(var _i = 0, _b = Object.entries(customIDs); _i < _b.length; _i++){
        var _c = _b[_i], type = _c[0], value = _c[1];
        key += ";".concat(type, ":").concat(value);
    }
    return $50fd8e4714b7a0a0$var$SimpleHash(key);
}
module.exports.getUserCacheKey = $50fd8e4714b7a0a0$var$getUserCacheKey;

});

parcelRegister("5Jgq0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $42bde40edc08c918$var$StatsigLocalStorage = /** @class */ function() {
    function StatsigLocalStorage() {}
    StatsigLocalStorage.getItem = function(key) {
        var _a;
        try {
            if (this.isStorageAccessible()) return window.localStorage.getItem(key);
        } catch (e) {}
        return (_a = this.fallbackSessionCache[key]) !== null && _a !== void 0 ? _a : null;
    };
    StatsigLocalStorage.setItem = function(key, value) {
        try {
            if (this.isStorageAccessible()) {
                window.localStorage.setItem(key, value);
                return;
            }
        } catch (e) {}
        this.fallbackSessionCache[key] = value;
    };
    StatsigLocalStorage.removeItem = function(key) {
        try {
            if (this.isStorageAccessible()) {
                window.localStorage.removeItem(key);
                return;
            }
        } catch (e) {}
        delete this.fallbackSessionCache[key];
    };
    StatsigLocalStorage.isStorageAccessible = function(ignoreDisabledOption) {
        if (ignoreDisabledOption === void 0) ignoreDisabledOption = false;
        if (this.canAccessStorageAccessible == null) this.canAccessStorageAccessible = typeof Storage !== "undefined" && typeof window !== "undefined" && window != null && window.localStorage != null;
        var canAccess = this.canAccessStorageAccessible;
        if (ignoreDisabledOption) return canAccess;
        return !this.disabled && canAccess;
    };
    StatsigLocalStorage.disabled = false;
    StatsigLocalStorage.fallbackSessionCache = {};
    StatsigLocalStorage.canAccessStorageAccessible = null;
    return StatsigLocalStorage;
}();
module.exports.default = $42bde40edc08c918$var$StatsigLocalStorage;

});

parcelRegister("ebF6O", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.version = void 0;
// Generated by genversion.
module.exports.version = "1.2.1";

});


parcelRegister("79GLI", function(module, exports) {
"use strict";
var $535a8ca046c55b25$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $535a8ca046c55b25$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $535a8ca046c55b25$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $535a8ca046c55b25$var$LogEvent_1 = $535a8ca046c55b25$var$__importDefault((parcelRequire("bmARL")));

var $7hd5D = parcelRequire("7hd5D");

var $e1dzV = parcelRequire("e1dzV");

var $535a8ca046c55b25$var$StatsigLocalStorage_1 = $535a8ca046c55b25$var$__importDefault((parcelRequire("5Jgq0")));
var $535a8ca046c55b25$var$INTERNAL_EVENT_PREFIX = "statsig::";
var $535a8ca046c55b25$var$CONFIG_EXPOSURE_EVENT = $535a8ca046c55b25$var$INTERNAL_EVENT_PREFIX + "config_exposure";
var $535a8ca046c55b25$var$LAYER_EXPOSURE_EVENT = $535a8ca046c55b25$var$INTERNAL_EVENT_PREFIX + "layer_exposure";
var $535a8ca046c55b25$var$GATE_EXPOSURE_EVENT = $535a8ca046c55b25$var$INTERNAL_EVENT_PREFIX + "gate_exposure";
var $535a8ca046c55b25$var$LOG_FAILURE_EVENT = $535a8ca046c55b25$var$INTERNAL_EVENT_PREFIX + "log_event_failed";
var $535a8ca046c55b25$var$DEFAULT_VALUE_WARNING = $535a8ca046c55b25$var$INTERNAL_EVENT_PREFIX + "default_value_type_mismatch";
var $535a8ca046c55b25$var$MS_RETRY_LOGS_CUTOFF = 432000000;
var $535a8ca046c55b25$var$MAX_BATCHES_TO_RETRY = 100;
var $535a8ca046c55b25$var$MAX_FAILED_EVENTS = 1000;
var $535a8ca046c55b25$var$MAX_LOCAL_STORAGE_SIZE = 1024 * $535a8ca046c55b25$var$MAX_FAILED_EVENTS;
var $535a8ca046c55b25$var$StatsigLogger = /** @class */ function() {
    function StatsigLogger(options, identity, network, errorBoundary) {
        var _this = this;
        this._failedLogEventCount = 0;
        this.logConfigDefaultValueFallback = function(user, message, metadata) {
            var defaultValueEvent = (0, $535a8ca046c55b25$var$LogEvent_1.default)($535a8ca046c55b25$var$DEFAULT_VALUE_WARNING, user, _this._identity._statsigMetadata, message, metadata);
            _this.log(defaultValueEvent);
            _this._loggedErrors.add(message);
        };
        this._options = options;
        this._identity = identity;
        this._network = network;
        this._errorBoundary = errorBoundary;
        this._queue = [];
        this._flushInterval = null;
        this._loggedErrors = new Set();
        this._failedLogEvents = [];
        this._exposureDedupeKeys = {};
        this._failedLogEventCount = 0;
        this._init();
    }
    StatsigLogger.prototype.log = function(event) {
        try {
            if (!this._options.disableCurrentPageLogging && typeof window !== "undefined" && window != null && typeof window.location === "object" && typeof window.location.href === "string") {
                // https://stackoverflow.com/questions/6257463/how-to-get-the-url-without-any-parameters-in-javascript
                var parts = window.location.href.split(/[?#]/);
                if ((parts === null || parts === void 0 ? void 0 : parts.length) > 0) event.statsigMetadata.currentPage = parts[0];
            }
        } catch (_e) {}
        this._queue.push(event);
        if (this._queue.length >= this._options.loggingBufferMaxSize) this.flush();
    };
    StatsigLogger.prototype.resetDedupeKeys = function() {
        this._exposureDedupeKeys = {};
    };
    StatsigLogger.prototype.logGateExposure = function(user, gateName, gateValue, ruleID, secondaryExposures, details, isManualExposure) {
        var dedupeKey = gateName + String(gateValue) + ruleID + details.reason;
        if (!this._shouldLogExposure(dedupeKey)) return;
        var metadata = {
            gate: gateName,
            gateValue: String(gateValue),
            ruleID: ruleID,
            reason: details.reason,
            time: details.time
        };
        if (isManualExposure) metadata["isManualExposure"] = "true";
        var gateExposure = (0, $535a8ca046c55b25$var$LogEvent_1.default)($535a8ca046c55b25$var$GATE_EXPOSURE_EVENT, user, this._identity._statsigMetadata, null, metadata, secondaryExposures);
        this.log(gateExposure);
    };
    StatsigLogger.prototype.logConfigExposure = function(user, configName, ruleID, secondaryExposures, details, isManualExposure) {
        var dedupeKey = configName + ruleID + details.reason;
        if (!this._shouldLogExposure(dedupeKey)) return;
        var metadata = {
            config: configName,
            ruleID: ruleID,
            reason: details.reason,
            time: details.time
        };
        if (isManualExposure) metadata["isManualExposure"] = "true";
        var configExposure = (0, $535a8ca046c55b25$var$LogEvent_1.default)($535a8ca046c55b25$var$CONFIG_EXPOSURE_EVENT, user, this._identity._statsigMetadata, null, metadata, secondaryExposures);
        this.log(configExposure);
    };
    StatsigLogger.prototype.logLayerExposure = function(user, configName, ruleID, secondaryExposures, allocatedExperiment, parameterName, isExplicitParameter, details, isManualExposure) {
        var dedupeKey = [
            configName,
            ruleID,
            allocatedExperiment,
            parameterName,
            String(isExplicitParameter),
            details.reason
        ].join("|");
        if (!this._shouldLogExposure(dedupeKey)) return;
        var metadata = {
            config: configName,
            ruleID: ruleID,
            allocatedExperiment: allocatedExperiment,
            parameterName: parameterName,
            isExplicitParameter: String(isExplicitParameter),
            reason: details.reason,
            time: details.time
        };
        if (isManualExposure) metadata["isManualExposure"] = "true";
        var configExposure = (0, $535a8ca046c55b25$var$LogEvent_1.default)($535a8ca046c55b25$var$LAYER_EXPOSURE_EVENT, user, this._identity._statsigMetadata, null, metadata, secondaryExposures);
        this.log(configExposure);
    };
    StatsigLogger.prototype.shutdown = function() {
        if (this._flushInterval) {
            clearInterval(this._flushInterval);
            this._flushInterval = null;
        }
        this.flush(true);
    };
    StatsigLogger.prototype.flush = function(isClosing) {
        var _this = this;
        if (isClosing === void 0) isClosing = false;
        if (this._queue.length === 0) return;
        var statsigMetadata = this._identity._statsigMetadata;
        var oldQueue = this._queue;
        this._queue = [];
        if (isClosing && !this._network.supportsKeepalive() && typeof navigator !== "undefined" && navigator != null && // @ts-ignore
        navigator.sendBeacon) {
            var beacon = this._network.sendLogBeacon({
                events: oldQueue,
                statsigMetadata: statsigMetadata
            });
            if (!beacon) {
                this._queue = oldQueue.concat(this._queue);
                if (this._queue.length > 0) {
                    this._addFailedRequest({
                        events: this._queue,
                        statsigMetadata: statsigMetadata,
                        time: Date.now()
                    });
                    this._queue = [];
                }
                this._saveFailedRequests();
            }
            return;
        }
        var processor = this;
        this._network.postToEndpoint($7hd5D.StatsigEndpoint.Rgstr, {
            events: oldQueue,
            statsigMetadata: statsigMetadata
        }, 3 /* retries */ , 1000 /* backoff */ , isClosing /* useKeepalive */ ).then(function(response) {
            if (!response.ok) throw response;
        }).catch(function(error) {
            if (typeof error.text === "function") error.text().then(function(errorText) {
                _this._errorBoundary._logError($535a8ca046c55b25$var$LOG_FAILURE_EVENT, error, function() {
                    return $535a8ca046c55b25$var$__awaiter(_this, void 0, void 0, function() {
                        return $535a8ca046c55b25$var$__generator(this, function(_a) {
                            return [
                                2 /*return*/ ,
                                {
                                    eventCount: oldQueue.length,
                                    error: errorText
                                }
                            ];
                        });
                    });
                });
            });
            else _this._errorBoundary._logError($535a8ca046c55b25$var$LOG_FAILURE_EVENT, error, function() {
                return $535a8ca046c55b25$var$__awaiter(_this, void 0, void 0, function() {
                    return $535a8ca046c55b25$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            {
                                eventCount: oldQueue.length,
                                error: error.message
                            }
                        ];
                    });
                });
            });
            processor._newFailedRequest($535a8ca046c55b25$var$LOG_FAILURE_EVENT, oldQueue);
        }).finally(function() {
            return $535a8ca046c55b25$var$__awaiter(_this, void 0, void 0, function() {
                return $535a8ca046c55b25$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!isClosing) return [
                                3 /*break*/ ,
                                2
                            ];
                            if (this._queue.length > 0) {
                                this._addFailedRequest({
                                    events: this._queue,
                                    statsigMetadata: statsigMetadata,
                                    time: Date.now()
                                });
                                // on app background/window blur, save unsent events as a request and clean up the queue (in case app foregrounds)
                                this._queue = [];
                            }
                            return [
                                4 /*yield*/ ,
                                processor._saveFailedRequests()
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        });
    };
    StatsigLogger.prototype.sendSavedRequests = function() {
        return $535a8ca046c55b25$var$__awaiter(this, void 0, void 0, function() {
            var failedRequests, fireAndForget, requestBodies, _loop_1, this_1, _i, requestBodies_1, requestBody;
            var _this = this;
            return $535a8ca046c55b25$var$__generator(this, function(_a) {
                fireAndForget = false;
                failedRequests = $535a8ca046c55b25$var$StatsigLocalStorage_1.default.getItem($e1dzV.STATSIG_LOCAL_STORAGE_LOGGING_REQUEST_KEY);
                if (failedRequests == null) {
                    this._clearLocalStorageRequests();
                    return [
                        2 /*return*/ 
                    ];
                }
                if (failedRequests.length > $535a8ca046c55b25$var$MAX_LOCAL_STORAGE_SIZE) fireAndForget = true;
                requestBodies = [];
                try {
                    requestBodies = JSON.parse(failedRequests);
                    _loop_1 = function _loop_1(requestBody) {
                        if (requestBody != null && requestBody.events && Array.isArray(requestBody.events)) this_1._network.postToEndpoint($7hd5D.StatsigEndpoint.Rgstr, requestBody).then(function(response) {
                            if (!response.ok) throw Error(response.status + "");
                        }).catch(function(_e) {
                            if (fireAndForget) return;
                            _this._addFailedRequest(requestBody);
                        });
                    };
                    this_1 = this;
                    for(_i = 0, requestBodies_1 = requestBodies; _i < requestBodies_1.length; _i++){
                        requestBody = requestBodies_1[_i];
                        _loop_1(requestBody);
                    }
                } catch (_e) {} finally{
                    this._clearLocalStorageRequests();
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    StatsigLogger.prototype._init = function() {
        var _this = this;
        if (typeof window !== "undefined" && typeof window.addEventListener === "function") {
            window.addEventListener("blur", function() {
                return _this.flush(true);
            });
            window.addEventListener("beforeunload", function() {
                return _this.flush(true);
            });
            window.addEventListener("load", function() {
                setTimeout(function() {
                    return _this.flush();
                }, 100);
                setTimeout(function() {
                    return _this.flush();
                }, 1000);
            });
        }
        if (typeof document !== "undefined" && typeof document.addEventListener === "function") document.addEventListener("visibilitychange", function() {
            _this.flush(document.visibilityState !== "visible");
        });
        if (!this._options.ignoreWindowUndefined && (typeof window === "undefined" || window == null)) // dont set the flush interval outside of client browser environments
        return;
        if (this._options.localMode) // unnecessary interval in local mode since logs dont flush anyway
        return;
        var me = this;
        this._flushInterval = setInterval(function() {
            me.flush();
        }, this._options.loggingIntervalMillis);
        // Quick flush
        setTimeout(function() {
            return _this.flush();
        }, 100);
        setTimeout(function() {
            return _this.flush();
        }, 1000);
    };
    StatsigLogger.prototype._shouldLogExposure = function(key) {
        var lastTime = this._exposureDedupeKeys[key];
        var now = Date.now();
        if (lastTime == null) {
            this._exposureDedupeKeys[key] = now;
            return true;
        }
        if (lastTime >= now - 600000) return false;
        this._exposureDedupeKeys[key] = now;
        return true;
    };
    StatsigLogger.prototype._saveFailedRequests = function() {
        return $535a8ca046c55b25$var$__awaiter(this, void 0, void 0, function() {
            var requestsCopy;
            return $535a8ca046c55b25$var$__generator(this, function(_a) {
                if (this._failedLogEvents.length > 0) {
                    requestsCopy = JSON.stringify(this._failedLogEvents);
                    if (requestsCopy.length > $535a8ca046c55b25$var$MAX_LOCAL_STORAGE_SIZE) {
                        this._clearLocalStorageRequests();
                        return [
                            2 /*return*/ 
                        ];
                    }
                    $535a8ca046c55b25$var$StatsigLocalStorage_1.default.setItem($e1dzV.STATSIG_LOCAL_STORAGE_LOGGING_REQUEST_KEY, requestsCopy);
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    StatsigLogger.prototype._addFailedRequest = function(requestBody) {
        if (requestBody.time < Date.now() - $535a8ca046c55b25$var$MS_RETRY_LOGS_CUTOFF) return;
        if (this._failedLogEvents.length > $535a8ca046c55b25$var$MAX_BATCHES_TO_RETRY) return;
        var additionalEvents = requestBody.events.length;
        if (this._failedLogEventCount + additionalEvents > $535a8ca046c55b25$var$MAX_FAILED_EVENTS) return;
        this._failedLogEvents.push(requestBody);
        this._failedLogEventCount += additionalEvents;
    };
    StatsigLogger.prototype._clearLocalStorageRequests = function() {
        $535a8ca046c55b25$var$StatsigLocalStorage_1.default.removeItem($e1dzV.STATSIG_LOCAL_STORAGE_LOGGING_REQUEST_KEY);
    };
    StatsigLogger.prototype._newFailedRequest = function(name, queue) {
        if (this._loggedErrors.has(name)) return;
        this._loggedErrors.add(name);
        this._failedLogEvents.push({
            events: queue,
            statsigMetadata: this._identity._statsigMetadata,
            time: Date.now()
        });
        this._saveFailedRequests().then(function() {});
    };
    return StatsigLogger;
}();
module.exports.default = $535a8ca046c55b25$var$StatsigLogger;

});
parcelRegister("bmARL", function(module, exports) {
"use strict";
var $845e58a43b00106f$var$__assign = module.exports && module.exports.__assign || function() {
    $845e58a43b00106f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $845e58a43b00106f$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $845e58a43b00106f$var$makeLogEvent(eventName, user, statsigMetadata, value, metadata, secondaryExposures) {
    if (value === void 0) value = null;
    if (metadata === void 0) metadata = null;
    var logUser = user;
    if (logUser === null || logUser === void 0 ? void 0 : logUser.privateAttributes) {
        logUser = $845e58a43b00106f$var$__assign({}, user);
        delete logUser.privateAttributes;
    }
    return {
        time: Date.now(),
        eventName: eventName,
        statsigMetadata: statsigMetadata,
        user: logUser,
        value: value,
        metadata: metadata,
        secondaryExposures: secondaryExposures
    };
}
module.exports.default = $845e58a43b00106f$var$makeLogEvent;

});

parcelRegister("7hd5D", function(module, exports) {

var $l0HdX = parcelRequire("l0HdX");
"use strict";
var $54c4464a02357e3b$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $54c4464a02357e3b$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigEndpoint = void 0;
var $54c4464a02357e3b$var$StatsigEndpoint;
(function(StatsigEndpoint) {
    StatsigEndpoint["Initialize"] = "initialize";
    StatsigEndpoint["Rgstr"] = "rgstr";
    StatsigEndpoint["LogEventBeacon"] = "log_event_beacon";
})($54c4464a02357e3b$var$StatsigEndpoint = module.exports.StatsigEndpoint || (module.exports.StatsigEndpoint = {}));
var $54c4464a02357e3b$var$NO_CONTENT = 204;
var $54c4464a02357e3b$var$StatsigNetwork = /** @class */ function() {
    function StatsigNetwork(options, identity, errorBoundary) {
        this.retryCodes = {
            408: true,
            500: true,
            502: true,
            503: true,
            504: true,
            522: true,
            524: true,
            599: true
        };
        this.canUseKeepalive = false;
        this._options = options;
        this._identity = identity;
        this._errorBoundary = errorBoundary;
        this.leakyBucket = {};
        this._init();
    }
    StatsigNetwork.prototype.fetchValues = function(user, sinceTime, timeout, previousDerivedFields) {
        var input = {
            user: user,
            statsigMetadata: this._identity._statsigMetadata,
            sinceTime: sinceTime !== null && sinceTime !== void 0 ? sinceTime : undefined,
            hash: "djb2",
            previousDerivedFields: previousDerivedFields
        };
        return this._postWithTimeout($54c4464a02357e3b$var$StatsigEndpoint.Initialize, input, timeout, 3);
    };
    StatsigNetwork.prototype.sendLogBeacon = function(payload) {
        if (this._options.localMode) return true;
        var url = new URL(this._options.eventLoggingApi + $54c4464a02357e3b$var$StatsigEndpoint.LogEventBeacon);
        url.searchParams.append("k", this._identity._sdkKey);
        payload.clientTime = Date.now() + "";
        var stringPayload = null;
        try {
            stringPayload = JSON.stringify(payload);
        } catch (_e) {
            return false;
        }
        return navigator.sendBeacon(url.toString(), stringPayload);
    };
    StatsigNetwork.prototype.postToEndpoint = function(endpointName, body, retries, backoff, useKeepalive) {
        if (retries === void 0) retries = 0;
        if (backoff === void 0) backoff = 1000;
        if (useKeepalive === void 0) useKeepalive = false;
        return $54c4464a02357e3b$var$__awaiter(this, void 0, void 0, function() {
            var api, url, counter, postBody, statsigMetadata, params;
            var _this = this;
            return $54c4464a02357e3b$var$__generator(this, function(_a) {
                if (this._options.localMode) return [
                    2 /*return*/ ,
                    Promise.reject("no network requests in localMode")
                ];
                if (typeof fetch !== "function") // fetch is not defined in this environment, short circuit
                return [
                    2 /*return*/ ,
                    Promise.reject("fetch is not defined")
                ];
                if (typeof window === "undefined" && !this._options.ignoreWindowUndefined) // by default, dont issue requests from the server
                return [
                    2 /*return*/ ,
                    Promise.reject("window is not defined")
                ];
                api = [
                    $54c4464a02357e3b$var$StatsigEndpoint.Initialize
                ].includes(endpointName) ? this._options.api : this._options.eventLoggingApi;
                url = api + endpointName;
                counter = this.leakyBucket[url];
                if (counter != null && counter >= 30) return [
                    2 /*return*/ ,
                    Promise.reject(new Error("Request failed because you are making the same request too frequently."))
                ];
                if (counter == null) this.leakyBucket[url] = 1;
                else this.leakyBucket[url] = counter + 1;
                postBody = JSON.stringify(body);
                statsigMetadata = this._identity._statsigMetadata;
                params = {
                    method: "POST",
                    body: postBody,
                    headers: {
                        "Content-type": "application/json; charset=UTF-8",
                        "STATSIG-API-KEY": this._identity._sdkKey,
                        "STATSIG-CLIENT-TIME": Date.now() + "",
                        "STATSIG-SDK-TYPE": statsigMetadata.sdkType,
                        "STATSIG-SDK-VERSION": statsigMetadata.sdkVersion
                    }
                };
                if (this.canUseKeepalive && useKeepalive) params.keepalive = true;
                return [
                    2 /*return*/ ,
                    fetch(url, params).then(function(res) {
                        return $54c4464a02357e3b$var$__awaiter(_this, void 0, void 0, function() {
                            var networkResponse, text, errorText;
                            return $54c4464a02357e3b$var$__generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if (!res.ok) return [
                                            3 /*break*/ ,
                                            4
                                        ];
                                        networkResponse = res;
                                        if (!(res.status === $54c4464a02357e3b$var$NO_CONTENT)) return [
                                            3 /*break*/ ,
                                            1
                                        ];
                                        networkResponse.data = {
                                            has_updates: false,
                                            is_no_content: true
                                        };
                                        return [
                                            3 /*break*/ ,
                                            3
                                        ];
                                    case 1:
                                        return [
                                            4 /*yield*/ ,
                                            res.text()
                                        ];
                                    case 2:
                                        text = _a.sent();
                                        networkResponse.data = JSON.parse(text);
                                        _a.label = 3;
                                    case 3:
                                        return [
                                            2 /*return*/ ,
                                            Promise.resolve(networkResponse)
                                        ];
                                    case 4:
                                        if (!this.retryCodes[res.status]) retries = 0;
                                        return [
                                            4 /*yield*/ ,
                                            res.text()
                                        ];
                                    case 5:
                                        errorText = _a.sent();
                                        return [
                                            2 /*return*/ ,
                                            Promise.reject(new Error("".concat(res.status, ": ").concat(errorText)))
                                        ];
                                }
                            });
                        });
                    }).catch(function(e) {
                        if (retries > 0) return new Promise(function(resolve, reject) {
                            setTimeout(function() {
                                _this.leakyBucket[url] = Math.max(_this.leakyBucket[url] - 1, 0);
                                _this.postToEndpoint(endpointName, body, retries - 1, backoff * 2, useKeepalive).then(resolve).catch(reject);
                            }, backoff);
                        });
                        return Promise.reject(e);
                    }).finally(function() {
                        _this.leakyBucket[url] = Math.max(_this.leakyBucket[url] - 1, 0);
                    })
                ];
            });
        });
    };
    StatsigNetwork.prototype.supportsKeepalive = function() {
        return this.canUseKeepalive;
    };
    StatsigNetwork.prototype._init = function() {
        if (!this._options.disableNetworkKeepalive) try {
            this.canUseKeepalive = "keepalive" in new Request("");
        } catch (_e) {}
    };
    StatsigNetwork.prototype._postWithTimeout = function(endpointName, body, timeout, retries, backoff) {
        var _this = this;
        if (timeout === void 0) timeout = 0;
        if (retries === void 0) retries = 0;
        if (backoff === void 0) backoff = 1000;
        var hasTimedOut = false;
        var timer = null;
        var cachedReturnValue = null;
        var eventuals = [];
        var eventually = function eventually(boundScope) {
            return function(fn) {
                if (hasTimedOut && cachedReturnValue) fn(cachedReturnValue);
                else eventuals.push(fn);
                return boundScope;
            };
        };
        if (timeout != 0) timer = new Promise(function(resolve, reject) {
            setTimeout(function() {
                hasTimedOut = true;
                reject(new Error("The initialization timeout of ".concat(timeout, "ms has been hit before the network request has completed.")));
            }, timeout);
        });
        var fetchPromise = this.postToEndpoint(endpointName, body, retries, backoff).then(function(res) {
            if (!res.ok) return Promise.reject(new Error("Request to ".concat(endpointName, " failed with status ").concat(res.status)));
            if (typeof res.data !== "object") {
                var error = new Error("Request to ".concat(endpointName, " received invalid response type. Expected 'object' but got '").concat((0, $l0HdX._)(res.data), "'"));
                _this._errorBoundary._logError("postWithTimeoutInvalidRes", error, function() {
                    return $54c4464a02357e3b$var$__awaiter(_this, void 0, void 0, function() {
                        return $54c4464a02357e3b$var$__generator(this, function(_a) {
                            return [
                                2 /*return*/ ,
                                this._getErrorData(endpointName, body, retries, backoff, res)
                            ];
                        });
                    });
                });
                return Promise.reject(error);
            }
            var json = res.data;
            return _this._errorBoundary._capture("postWithTimeout", function() {
                return $54c4464a02357e3b$var$__awaiter(_this, void 0, void 0, function() {
                    return $54c4464a02357e3b$var$__generator(this, function(_a) {
                        cachedReturnValue = json;
                        if (hasTimedOut) {
                            eventuals.forEach(function(fn) {
                                return fn(json);
                            });
                            eventuals = [];
                        }
                        return [
                            2 /*return*/ ,
                            Promise.resolve(json)
                        ];
                    });
                });
            }, function() {
                return Promise.resolve({});
            }, function() {
                return $54c4464a02357e3b$var$__awaiter(_this, void 0, void 0, function() {
                    return $54c4464a02357e3b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            this._getErrorData(endpointName, body, retries, backoff, res)
                        ];
                    });
                });
            });
        }).catch(function(e) {
            return Promise.reject(e);
        });
        var racingPromise = timer ? Promise.race([
            fetchPromise,
            timer
        ]) : fetchPromise;
        racingPromise.eventually = eventually(racingPromise);
        return racingPromise;
    };
    StatsigNetwork.prototype._getErrorData = function(endpointName, body, retries, backoff, res) {
        var _a;
        return $54c4464a02357e3b$var$__awaiter(this, void 0, void 0, function() {
            var headers_1;
            return $54c4464a02357e3b$var$__generator(this, function(_b) {
                try {
                    headers_1 = {};
                    ((_a = res.headers) !== null && _a !== void 0 ? _a : []).forEach(function(value, key) {
                        headers_1[key] = value;
                    });
                    return [
                        2 /*return*/ ,
                        {
                            responseInfo: {
                                headers: headers_1,
                                status: res.status,
                                statusText: res.statusText,
                                type: res.type,
                                url: res.url,
                                redirected: res.redirected,
                                bodySnippet: res.data ? JSON.stringify(res.data).slice(0, 500) : null
                            },
                            requestInfo: {
                                endpointName: endpointName,
                                bodySnippet: JSON.stringify(body).slice(0, 500),
                                retries: retries,
                                backoff: backoff
                            }
                        }
                    ];
                } catch (_e) {
                    return [
                        2 /*return*/ ,
                        {
                            statusText: "statsig::failed to extract extra data"
                        }
                    ];
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return StatsigNetwork;
}();
module.exports.default = $54c4464a02357e3b$var$StatsigNetwork;

});


parcelRegister("1RaDd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.INIT_TIMEOUT_DEFAULT_MS = void 0;
var $15a2fcdabf853166$var$DEFAULT_FEATURE_GATE_API = "https://featuregates.org/v1/";
var $15a2fcdabf853166$var$DEFAULT_EVENT_LOGGING_API = "https://events.statsigapi.net/v1/";
module.exports.INIT_TIMEOUT_DEFAULT_MS = 3000;
var $15a2fcdabf853166$var$StatsigSDKOptions = /** @class */ function() {
    function StatsigSDKOptions(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        if (options == null) options = {};
        var api = (_a = options.api) !== null && _a !== void 0 ? _a : $15a2fcdabf853166$var$DEFAULT_FEATURE_GATE_API;
        this.api = api.endsWith("/") ? api : api + "/";
        this.disableCurrentPageLogging = (_b = options.disableCurrentPageLogging) !== null && _b !== void 0 ? _b : false;
        this.environment = (_c = options.environment) !== null && _c !== void 0 ? _c : null;
        this.loggingIntervalMillis = this.normalizeNumberInput(options.loggingIntervalMillis, {
            default: 10000,
            min: 1000,
            max: 60000
        });
        this.loggingBufferMaxSize = this.normalizeNumberInput(options.loggingBufferMaxSize, {
            default: 100,
            min: 2,
            max: 500
        });
        this.disableNetworkKeepalive = (_d = options.disableNetworkKeepalive) !== null && _d !== void 0 ? _d : false;
        this.overrideStableID = (_e = options.overrideStableID) !== null && _e !== void 0 ? _e : null;
        this.localMode = (_f = options.localMode) !== null && _f !== void 0 ? _f : false;
        this.initTimeoutMs = options.initTimeoutMs && options.initTimeoutMs >= 0 ? options.initTimeoutMs : module.exports.INIT_TIMEOUT_DEFAULT_MS;
        this.disableErrorLogging = (_g = options.disableErrorLogging) !== null && _g !== void 0 ? _g : false;
        this.disableAutoMetricsLogging = (_h = options.disableAutoMetricsLogging) !== null && _h !== void 0 ? _h : false;
        this.initializeValues = (_j = options.initializeValues) !== null && _j !== void 0 ? _j : null;
        var eventLoggingApi = (_l = (_k = options.eventLoggingApi) !== null && _k !== void 0 ? _k : options.api) !== null && _l !== void 0 ? _l : $15a2fcdabf853166$var$DEFAULT_EVENT_LOGGING_API;
        this.eventLoggingApi = eventLoggingApi.endsWith("/") ? eventLoggingApi : eventLoggingApi + "/";
        this.disableLocalStorage = (_m = options.disableLocalStorage) !== null && _m !== void 0 ? _m : false;
        this.ignoreWindowUndefined = (_o = options === null || options === void 0 ? void 0 : options.ignoreWindowUndefined) !== null && _o !== void 0 ? _o : false;
        this.updateUserCompletionCallback = (_p = options === null || options === void 0 ? void 0 : options.updateUserCompletionCallback) !== null && _p !== void 0 ? _p : null;
    }
    StatsigSDKOptions.prototype.normalizeNumberInput = function(input, bounds) {
        if (input == null) return bounds.default;
        return Math.max(Math.min(input, bounds.max), bounds.min);
    };
    return StatsigSDKOptions;
}();
module.exports.default = $15a2fcdabf853166$var$StatsigSDKOptions;

});

parcelRegister("5CQ4E", function(module, exports) {
"use strict";
var $4188e52ee82087da$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $4188e52ee82087da$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $4188e52ee82087da$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EvaluationReason = void 0;

var $4188e52ee82087da$var$DynamicConfig_1 = $4188e52ee82087da$var$__importDefault((parcelRequire("fA4Ix")));

var $4188e52ee82087da$var$Layer_1 = $4188e52ee82087da$var$__importDefault((parcelRequire("ffWtM")));

var $4188e52ee82087da$var$BootstrapValidator_1 = $4188e52ee82087da$var$__importDefault((parcelRequire("eto07")));

var $e1dzV = parcelRequire("e1dzV");

var $6X6PU = parcelRequire("6X6PU");

var $4188e52ee82087da$var$StatsigLocalStorage_1 = $4188e52ee82087da$var$__importDefault((parcelRequire("5Jgq0")));
var $4188e52ee82087da$var$EvaluationReason;
(function(EvaluationReason) {
    EvaluationReason["Network"] = "Network";
    EvaluationReason["Bootstrap"] = "Bootstrap";
    EvaluationReason["InvalidBootstrap"] = "InvalidBootstrap";
    EvaluationReason["Cache"] = "Cache";
    EvaluationReason["Unrecognized"] = "Unrecognized";
    EvaluationReason["Uninitialized"] = "Uninitialized";
    EvaluationReason["Error"] = "Error";
    EvaluationReason["NetworkNotModified"] = "NetworkNotModified";
    EvaluationReason["LocalOverride"] = "LocalOverride";
})($4188e52ee82087da$var$EvaluationReason = module.exports.EvaluationReason || (module.exports.EvaluationReason = {}));
var $4188e52ee82087da$var$MAX_USER_VALUE_CACHED = 10;
var $4188e52ee82087da$var$StatsigStore = /** @class */ function() {
    function StatsigStore(identity, onDefaultValueFallback, initializeValues) {
        this._identity = identity;
        this._onDefaultValueFallback = onDefaultValueFallback;
        this._userCacheKey = this._identity.getUserCacheKey();
        this._values = {};
        this._userValues = this._getDefaultUserCacheValues();
        this._loaded = false;
        this._reason = $4188e52ee82087da$var$EvaluationReason.Uninitialized;
        if (initializeValues) this.bootstrap(initializeValues);
        else this._loadFromLocalStorage();
    }
    StatsigStore.prototype.updateUser = function() {
        this._userCacheKey = this._identity.getUserCacheKey();
        return this._setUserValueFromCache();
    };
    StatsigStore.prototype.bootstrap = function(initializeValues) {
        var _a, _b, _c;
        var key = this._identity.getUserCacheKey();
        var user = this._identity._user;
        var reason = $4188e52ee82087da$var$BootstrapValidator_1.default.isValid(user, initializeValues) ? $4188e52ee82087da$var$EvaluationReason.Bootstrap : $4188e52ee82087da$var$EvaluationReason.InvalidBootstrap;
        // clients are going to assume that the SDK is bootstrapped after this method runs
        // if we fail to parse, we will fall back to defaults, but we dont want to throw
        // when clients try to check gates/configs/etc after this point
        this._loaded = true;
        try {
            this._userValues.feature_gates = (_a = initializeValues.feature_gates) !== null && _a !== void 0 ? _a : {};
            this._userValues.dynamic_configs = (_b = initializeValues.dynamic_configs) !== null && _b !== void 0 ? _b : {};
            this._userValues.layer_configs = (_c = initializeValues.layer_configs) !== null && _c !== void 0 ? _c : {};
            this._userValues.evaluation_time = Date.now();
            this._userValues.time = Date.now();
            this._values[key] = this._userValues;
            this._reason = reason;
        } catch (_e) {
            return;
        }
    };
    StatsigStore.prototype.isLoaded = function() {
        return this._loaded;
    };
    StatsigStore.prototype.getLastUpdateTime = function(user) {
        var userHash = (0, $6X6PU.djb2HashForObject)(user);
        if (this._userValues.user_hash == userHash) return this._userValues.time;
        return null;
    };
    StatsigStore.prototype.getPreviousDerivedFields = function(user) {
        var userHash = (0, $6X6PU.djb2HashForObject)(user);
        if (this._userValues.user_hash == userHash) return this._userValues.derived_fields;
        return undefined;
    };
    StatsigStore.prototype.setEvaluationReason = function(evalReason) {
        this._reason = evalReason;
    };
    StatsigStore.prototype.save = function(user, jsonConfigs, updateState) {
        if (updateState === void 0) updateState = true;
        return $4188e52ee82087da$var$__awaiter(this, void 0, void 0, function() {
            var requestedUserCacheKey, initResponse, userValues, _a;
            return $4188e52ee82087da$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        requestedUserCacheKey = (0, $6X6PU.getUserCacheKey)(user);
                        initResponse = jsonConfigs;
                        this._mergeInitializeResponseIntoUserMap(initResponse, this._values, requestedUserCacheKey, user, function(userValues) {
                            return userValues;
                        });
                        if (updateState) {
                            userValues = this._values[requestedUserCacheKey];
                            if (userValues && requestedUserCacheKey && requestedUserCacheKey == this._userCacheKey) {
                                this._userValues = userValues;
                                this._reason = $4188e52ee82087da$var$EvaluationReason.Network;
                            }
                        }
                        _a = this;
                        return [
                            4 /*yield*/ ,
                            this._writeValuesToStorage(this._values)
                        ];
                    case 1:
                        _a._values = _b.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    StatsigStore.prototype.checkGate = function(gateName) {
        var _a;
        var gateNameHash = (0, $6X6PU.getHashValue)(gateName);
        var gateValue = {
            name: gateName,
            value: false,
            rule_id: "",
            secondary_exposures: []
        };
        var details;
        var value = (_a = this._userValues) === null || _a === void 0 ? void 0 : _a.feature_gates[gateNameHash];
        if (value) gateValue = value;
        details = this._getEvaluationDetails(value != null);
        return {
            evaluationDetails: details,
            gate: gateValue
        };
    };
    StatsigStore.prototype.getConfig = function(configName) {
        var _a, _b;
        var configNameHash = (0, $6X6PU.getHashValue)(configName);
        var configValue;
        var details;
        if (((_a = this._userValues) === null || _a === void 0 ? void 0 : _a.dynamic_configs[configNameHash]) != null) {
            var rawConfigValue = (_b = this._userValues) === null || _b === void 0 ? void 0 : _b.dynamic_configs[configNameHash];
            details = this._getEvaluationDetails(true);
            configValue = this._createDynamicConfig(configName, rawConfigValue, details);
        } else {
            details = this._getEvaluationDetails(false);
            configValue = new $4188e52ee82087da$var$DynamicConfig_1.default(configName, {}, "", details);
        }
        return configValue;
    };
    StatsigStore.prototype.getLayer = function(logParameterFunction, layerName) {
        var _a, _b, _c;
        var latestValue = this._getLatestValue(layerName, "layer_configs");
        var details = this._getEvaluationDetails(latestValue != null);
        return $4188e52ee82087da$var$Layer_1.default._create(layerName, (_a = latestValue === null || latestValue === void 0 ? void 0 : latestValue.value) !== null && _a !== void 0 ? _a : {}, (_b = latestValue === null || latestValue === void 0 ? void 0 : latestValue.rule_id) !== null && _b !== void 0 ? _b : "", details, logParameterFunction, latestValue === null || latestValue === void 0 ? void 0 : latestValue.secondary_exposures, latestValue === null || latestValue === void 0 ? void 0 : latestValue.undelegated_secondary_exposures, (_c = latestValue === null || latestValue === void 0 ? void 0 : latestValue.allocated_experiment_name) !== null && _c !== void 0 ? _c : "", latestValue === null || latestValue === void 0 ? void 0 : latestValue.explicit_parameters);
    };
    StatsigStore.prototype.getGlobalEvaluationDetails = function() {
        var _a, _b;
        return {
            reason: (_a = this._reason) !== null && _a !== void 0 ? _a : $4188e52ee82087da$var$EvaluationReason.Uninitialized,
            time: (_b = this._userValues.evaluation_time) !== null && _b !== void 0 ? _b : 0
        };
    };
    StatsigStore.prototype._loadFromLocalStorage = function() {
        this._parseCachedValues($4188e52ee82087da$var$StatsigLocalStorage_1.default.getItem($e1dzV.INTERNAL_STORE_KEY));
        this._loaded = true;
    };
    StatsigStore.prototype._parseCachedValues = function(allValues) {
        try {
            this._values = allValues ? JSON.parse(allValues) : this._values;
            this._setUserValueFromCache();
        } catch (e) {
            // Cached value corrupted, remove cache
            this._removeFromStorage($e1dzV.INTERNAL_STORE_KEY);
        }
    };
    StatsigStore.prototype._setUserValueFromCache = function() {
        var _a;
        var cachedValues = this._values[this._userCacheKey];
        if (cachedValues == null) {
            this._resetUserValues();
            this._reason = $4188e52ee82087da$var$EvaluationReason.Uninitialized;
            return null;
        }
        this._userValues = cachedValues;
        this._reason = $4188e52ee82087da$var$EvaluationReason.Cache;
        return (_a = cachedValues.evaluation_time) !== null && _a !== void 0 ? _a : 0;
    };
    StatsigStore.prototype._removeFromStorage = function(key) {
        $4188e52ee82087da$var$StatsigLocalStorage_1.default.removeItem(key);
    };
    /**
     * Merges the provided init configs into the provided config map, according to the provided merge function
     */ StatsigStore.prototype._mergeInitializeResponseIntoUserMap = function(data, configMap, requestedUserCacheKey, user, mergeFn) {
        if (requestedUserCacheKey) {
            var requestedUserValues = this._convertAPIDataToCacheValues(data, requestedUserCacheKey);
            if (data.has_updates && data.time) {
                var userHash = (0, $6X6PU.djb2HashForObject)(user);
                requestedUserValues.user_hash = userHash;
            }
            configMap[requestedUserCacheKey] = mergeFn(requestedUserValues, requestedUserCacheKey);
        }
    };
    StatsigStore.prototype._getDefaultUserCacheValues = function() {
        return {
            feature_gates: {},
            layer_configs: {},
            dynamic_configs: {},
            time: 0,
            evaluation_time: 0,
            has_updates: false
        };
    };
    /**
     * Writes the provided values to storage, truncating down to
     * MAX_USER_VALUE_CACHED number entries.
     * @returns The truncated entry list
     */ StatsigStore.prototype._writeValuesToStorage = function(valuesToWrite) {
        return $4188e52ee82087da$var$__awaiter(this, void 0, void 0, function() {
            var filteredValues;
            return $4188e52ee82087da$var$__generator(this, function(_a) {
                filteredValues = Object.entries(valuesToWrite).sort(function(_a, _b) {
                    var _c, _d;
                    var a = _a[1];
                    var b = _b[1];
                    if (a == null) return 1;
                    if (b == null) return -1;
                    return ((_c = b === null || b === void 0 ? void 0 : b.evaluation_time) !== null && _c !== void 0 ? _c : b === null || b === void 0 ? void 0 : b.time) - ((_d = a === null || a === void 0 ? void 0 : a.evaluation_time) !== null && _d !== void 0 ? _d : a === null || a === void 0 ? void 0 : a.time);
                }).slice(0, $4188e52ee82087da$var$MAX_USER_VALUE_CACHED);
                valuesToWrite = Object.fromEntries(filteredValues);
                $4188e52ee82087da$var$StatsigLocalStorage_1.default.setItem($e1dzV.INTERNAL_STORE_KEY, JSON.stringify(valuesToWrite));
                return [
                    2 /*return*/ ,
                    valuesToWrite
                ];
            });
        });
    };
    StatsigStore.prototype._getLatestValue = function(name, topLevelKey) {
        var _a, _b, _c, _d, _f;
        var hash = (0, $6X6PU.getHashValue)(name);
        return (_c = (_b = (_a = this._userValues) === null || _a === void 0 ? void 0 : _a[topLevelKey]) === null || _b === void 0 ? void 0 : _b[hash]) !== null && _c !== void 0 ? _c : (_f = (_d = this._userValues) === null || _d === void 0 ? void 0 : _d[topLevelKey]) === null || _f === void 0 ? void 0 : _f[name];
    };
    StatsigStore.prototype._createDynamicConfig = function(name, apiConfig, details) {
        var _a, _b, _c;
        return new $4188e52ee82087da$var$DynamicConfig_1.default(name, (_a = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.value) !== null && _a !== void 0 ? _a : {}, (_b = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.rule_id) !== null && _b !== void 0 ? _b : "", details, apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.secondary_exposures, (_c = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.allocated_experiment_name) !== null && _c !== void 0 ? _c : "", this._makeOnConfigDefaultValueFallback(this._identity._user));
    };
    StatsigStore.prototype._getEvaluationDetails = function(valueExists, reasonOverride) {
        var _a;
        if (valueExists) return {
            reason: this._reason,
            time: (_a = this._userValues.evaluation_time) !== null && _a !== void 0 ? _a : Date.now()
        };
        else return {
            reason: reasonOverride !== null && reasonOverride !== void 0 ? reasonOverride : this._reason == $4188e52ee82087da$var$EvaluationReason.Uninitialized ? $4188e52ee82087da$var$EvaluationReason.Uninitialized : $4188e52ee82087da$var$EvaluationReason.Unrecognized,
            time: Date.now()
        };
    };
    StatsigStore.prototype._resetUserValues = function() {
        this._userValues = this._getDefaultUserCacheValues();
    };
    StatsigStore.prototype._convertAPIDataToCacheValues = function(data, cacheKey) {
        // Specifically pulling keys from data here to avoid pulling in unwanted keys
        return {
            feature_gates: data.feature_gates,
            layer_configs: data.layer_configs,
            dynamic_configs: data.dynamic_configs,
            time: data.time == null || isNaN(data.time) ? 0 : data.time,
            evaluation_time: Date.now(),
            derived_fields: data.derived_fields
        };
    };
    StatsigStore.prototype._makeOnConfigDefaultValueFallback = function(user) {
        var _this = this;
        return function(config, parameter, defaultValueType, valueType) {
            if (!_this.isLoaded()) return;
            _this._onDefaultValueFallback(user, "Parameter ".concat(parameter, " is a value of type ").concat(valueType, ".\n          Returning requested defaultValue type ").concat(defaultValueType), {
                name: config._name,
                ruleID: config._ruleID,
                parameter: parameter,
                defaultValueType: defaultValueType,
                valueType: valueType
            });
        };
    };
    return StatsigStore;
}();
module.exports.default = $4188e52ee82087da$var$StatsigStore;

});
parcelRegister("eto07", function(module, exports) {

var $l0HdX = parcelRequire("l0HdX");
"use strict";
var $a8966436a2ac03c6$var$__assign = undefined && undefined.__assign || function() {
    $a8966436a2ac03c6$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a8966436a2ac03c6$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $a8966436a2ac03c6$var$BootstrapValidator = /** @class */ function() {
    function BootstrapValidator() {}
    BootstrapValidator.isValid = function(user, values) {
        try {
            var evaluatedKeys = values["evaluated_keys"];
            if (!evaluatedKeys || typeof evaluatedKeys !== "object") return true;
            var evaluatedKeysRecord = this.copyObject(evaluatedKeys);
            var userToCompare = user == null ? null : this.copyObject(user);
            return BootstrapValidator.validate(evaluatedKeysRecord, userToCompare) && BootstrapValidator.validate(userToCompare, evaluatedKeysRecord);
        } catch (error) {
        // This is best-effort. If we fail, return true.
        }
        return true;
    };
    BootstrapValidator.validate = function(one, two) {
        if (one == null) return two == null;
        else if (two == null) return false;
        for(var _i = 0, _a = Object.entries(one); _i < _a.length; _i++){
            var _b = _a[_i], key = _b[0], value = _b[1];
            if (key === "stableID") continue;
            if ((typeof value === "undefined" ? "undefined" : (0, $l0HdX._)(value)) !== (0, $l0HdX._)(two[key])) return false;
            if (typeof value === "string") {
                if (value !== two[key]) return false;
            } else if (typeof value === "object") return this.validate(value, two[key]);
            else // unexpected
            return false;
        }
        return true;
    };
    BootstrapValidator.copyObject = function(obj) {
        if (obj == null) return null;
        var copy = {};
        if (obj === null || obj === void 0 ? void 0 : obj.userID) copy["userID"] = obj === null || obj === void 0 ? void 0 : obj.userID;
        if (obj === null || obj === void 0 ? void 0 : obj.customIDs) {
            var customIDs = $a8966436a2ac03c6$var$__assign({}, obj.customIDs);
            delete customIDs["stableID"];
            if (Object.keys(customIDs).length !== 0) copy["customIDs"] = customIDs;
        }
        return copy;
    };
    return BootstrapValidator;
}();
module.exports.default = $a8966436a2ac03c6$var$BootstrapValidator;

});


parcelRegister("eof7c", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.difference = module.exports.now = void 0;
function $a79f08242adc6cd6$var$now() {
    if (typeof performance === "undefined" || !performance) return Date.now();
    return performance.now() | 0;
}
module.exports.now = $a79f08242adc6cd6$var$now;
function $a79f08242adc6cd6$var$difference(time) {
    return $a79f08242adc6cd6$var$now() - time;
}
module.exports.difference = $a79f08242adc6cd6$var$difference;

});

parcelRegister("16J7V", function(module, exports) {
"use strict";
var $0ce95b3817e706c9$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.saveOverridesToLocalStorage = module.exports.loadOverridesFromLocalStorage = module.exports.makeEmptyOverrides = module.exports.STORAGE_KEY = void 0;

var $0ce95b3817e706c9$var$StatsigLocalStorage_1 = $0ce95b3817e706c9$var$__importDefault((parcelRequire("5Jgq0")));
module.exports.STORAGE_KEY = "STATSIG_JS_LITE_LOCAL_OVERRIDES";
function $0ce95b3817e706c9$var$makeEmptyOverrides() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
}
module.exports.makeEmptyOverrides = $0ce95b3817e706c9$var$makeEmptyOverrides;
function $0ce95b3817e706c9$var$loadOverridesFromLocalStorage() {
    var raw = $0ce95b3817e706c9$var$StatsigLocalStorage_1.default.getItem(module.exports.STORAGE_KEY);
    if (raw) try {
        return JSON.parse(raw);
    } catch (error) {
    // noop
    }
    return $0ce95b3817e706c9$var$makeEmptyOverrides();
}
module.exports.loadOverridesFromLocalStorage = $0ce95b3817e706c9$var$loadOverridesFromLocalStorage;
function $0ce95b3817e706c9$var$saveOverridesToLocalStorage(overrides) {
    $0ce95b3817e706c9$var$StatsigLocalStorage_1.default.setItem(module.exports.STORAGE_KEY, JSON.stringify(overrides));
}
module.exports.saveOverridesToLocalStorage = $0ce95b3817e706c9$var$saveOverridesToLocalStorage;

});



parcelRegister("1wwwU", function(module, exports) {
"use strict";
var $11c203575af31320$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a9Mh4 = parcelRequire("a9Mh4");
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function get() {
        return $11c203575af31320$var$__importDefault($a9Mh4).default;
    }
});

});
parcelRegister("a9Mh4", function(module, exports) {

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $l29cN = parcelRequire("l29cN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $kfA8Q = parcelRequire("kfA8Q");

var $fPNo7 = parcelRequire("fPNo7");

var $amHA9 = parcelRequire("amHA9");
var $765030f0be6a8dd6$var$DEFAULT_REQUEST_TIMEOUT_MS = 2000;
var $765030f0be6a8dd6$var$PROD_BASE_URL = "https://api.atlassian.com/flags";
var $765030f0be6a8dd6$var$STAGING_BASE_URL = "https://api.stg.atlassian.com/flags";
var $765030f0be6a8dd6$var$DEV_BASE_URL = "https://api.dev.atlassian.com/flags";
var $765030f0be6a8dd6$var$GATEWAY_BASE_URL = "/gateway/api/flags";
var $765030f0be6a8dd6$var$Fetcher = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, $4GJKx._)(this, Fetcher);
    }
    (0, $1wc17._)(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function fetchClientSdk(fetcherOptions) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var targetApp, url, error;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _this.fetchRequest(url, "GET", fetcherOptions)
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 3:
                                error = _state.sent();
                                if (error instanceof Error) throw error;
                                throw Error("Failed to retrieve client sdk key");
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "fetchExperimentValues",
            value: function fetchExperimentValues(fetcherOptions, identifiers, customAttributes) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var requestBody, error;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _this.fetchRequest("/api/v2/frontend/experimentValues", "POST", fetcherOptions, requestBody)
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 3:
                                error = _state.sent();
                                if (error instanceof Error) throw error;
                                throw Error("Failed to retrieve experiment values");
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "handleResponseError",
            value: function handleResponseError(response) {
                return (0, $kSuI9._)(function() {
                    var body;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!response.ok) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    response.text()
                                ];
                            case 1:
                                body = _state.sent();
                                throw new $kfA8Q.ResponseError("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 2:
                                if (response.status === 204) throw new $kfA8Q.ResponseError("Unexpected 204 response");
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "extractResponseBody",
            value: function extractResponseBody(response) {
                return (0, $kSuI9._)(function() {
                    var value;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    response.text()
                                ];
                            case 1:
                                value = _state.sent();
                                return [
                                    2,
                                    JSON.parse(value)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                if (useGatewayUrl) return $765030f0be6a8dd6$var$GATEWAY_BASE_URL;
                switch(serviceEnv){
                    case $fPNo7.FeatureGateEnvironment.Development:
                        return $765030f0be6a8dd6$var$DEV_BASE_URL;
                    case $fPNo7.FeatureGateEnvironment.Staging:
                        return $765030f0be6a8dd6$var$STAGING_BASE_URL;
                    default:
                        return $765030f0be6a8dd6$var$PROD_BASE_URL;
                }
            }
        },
        {
            key: "fetchRequest",
            value: function fetchRequest(path, method, fetcherOptions, body) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $765030f0be6a8dd6$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                return [
                                    4,
                                    fetch("".concat(baseUrl).concat(path), Object.assign({
                                        method: method,
                                        headers: {
                                            "Content-Type": "application/json",
                                            "X-Client-Name": "feature-gate-js-client",
                                            "X-Client-Version": $amHA9.CLIENT_VERSION,
                                            "X-API-KEY": fetcherOptions.apiKey
                                        },
                                        signal: abortSignal
                                    }, body && {
                                        body: JSON.stringify(body)
                                    }))
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    4,
                                    _this.handleResponseError(response)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    4,
                                    _this.extractResponseBody(response)
                                ];
                            case 3:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return Fetcher;
}();
module.exports.default = $765030f0be6a8dd6$var$Fetcher;

});
parcelRegister("kfA8Q", function(module, exports) {

var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $FuVm8 = parcelRequire("FuVm8");

var $ohfOJ = parcelRequire("ohfOJ");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ResponseError = void 0;
var $ebe13e5afffd564e$var$ResponseError = /*#__PURE__*/ function(Error1) {
    (0, $dcsZi._)(ResponseError, Error1);
    var _super = (0, $ohfOJ._)(ResponseError);
    function ResponseError(message) {
        (0, $4GJKx._)(this, ResponseError);
        return _super.call(this, message);
    }
    return ResponseError;
}((0, $FuVm8._)(Error));
module.exports.ResponseError = $ebe13e5afffd564e$var$ResponseError;

});
parcelRegister("dcsZi", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $99c2e1b2c4a01e52$export$7e4530ad35d3bb8; });

var $koVwh = parcelRequire("koVwh");
function $99c2e1b2c4a01e52$export$7e4530ad35d3bb8(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $koVwh._set_prototype_of)(subClass, superClass);
}

});
parcelRegister("koVwh", function(module, exports) {

$parcel$export(module.exports, "_set_prototype_of", function () { return $eda2aabf2c4b7bd6$export$c2c98ac76e997b63; });
function $eda2aabf2c4b7bd6$export$c2c98ac76e997b63(o, p) {
    $eda2aabf2c4b7bd6$export$c2c98ac76e997b63 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $eda2aabf2c4b7bd6$export$c2c98ac76e997b63(o, p);
}

});


parcelRegister("FuVm8", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $07cbd154cab12773$export$2466d533fda16e33; });

var $5Gbgo = parcelRequire("5Gbgo");

var $b8Rim = parcelRequire("b8Rim");

var $19aQU = parcelRequire("19aQU");

var $koVwh = parcelRequire("koVwh");
function $07cbd154cab12773$export$2466d533fda16e33(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $07cbd154cab12773$export$2466d533fda16e33 = function(Class) {
        if (Class === null || !(0, $19aQU._is_native_function)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $5Gbgo._construct)(Class, arguments, (0, $b8Rim._get_prototype_of)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $koVwh._set_prototype_of)(Wrapper, Class);
    };
    return $07cbd154cab12773$export$2466d533fda16e33(Class);
}

});
parcelRegister("5Gbgo", function(module, exports) {

$parcel$export(module.exports, "_construct", function () { return $42299caecbd14337$export$2d841144c5f8c4ab; });

var $9yjJS = parcelRequire("9yjJS");

var $koVwh = parcelRequire("koVwh");
function $42299caecbd14337$export$2d841144c5f8c4ab(Parent, args, Class) {
    if ((0, $9yjJS._is_native_reflect_construct)()) $42299caecbd14337$export$2d841144c5f8c4ab = Reflect.construct;
    else $42299caecbd14337$export$2d841144c5f8c4ab = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $koVwh._set_prototype_of)(instance, Class.prototype);
        return instance;
    };
    return $42299caecbd14337$export$2d841144c5f8c4ab.apply(null, arguments);
}

});
parcelRegister("9yjJS", function(module, exports) {

$parcel$export(module.exports, "_is_native_reflect_construct", function () { return $6f4699ca644cfb51$export$685354647fba1516; });
function $6f4699ca644cfb51$export$685354647fba1516() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}

});


parcelRegister("b8Rim", function(module, exports) {

$parcel$export(module.exports, "_get_prototype_of", function () { return $81c9c858187986cb$export$f09211a7d3c496a1; });
$parcel$export(module.exports, "_", function () { return $81c9c858187986cb$export$f09211a7d3c496a1; });
function $81c9c858187986cb$export$f09211a7d3c496a1(o) {
    $81c9c858187986cb$export$f09211a7d3c496a1 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $81c9c858187986cb$export$f09211a7d3c496a1(o);
}

});

parcelRegister("19aQU", function(module, exports) {

$parcel$export(module.exports, "_is_native_function", function () { return $0d5f0cc57e65a7f7$export$514eda94019f4334; });
function $0d5f0cc57e65a7f7$export$514eda94019f4334(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

});


parcelRegister("ohfOJ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $048fa05071cfee44$export$8dd05c13f5255580; });

var $b8Rim = parcelRequire("b8Rim");

var $9yjJS = parcelRequire("9yjJS");

var $3U0IP = parcelRequire("3U0IP");
function $048fa05071cfee44$export$8dd05c13f5255580(Derived) {
    var hasNativeReflectConstruct = (0, $9yjJS._is_native_reflect_construct)();
    return function _createSuperInternal() {
        var Super = (0, $b8Rim._get_prototype_of)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $b8Rim._get_prototype_of)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $3U0IP._possible_constructor_return)(this, result);
    };
}

});
parcelRegister("3U0IP", function(module, exports) {

$parcel$export(module.exports, "_possible_constructor_return", function () { return $2d772972bd4fe337$export$ef97c660ca164e52; });

var $d3H5E = parcelRequire("d3H5E");

var $l0HdX = parcelRequire("l0HdX");
function $2d772972bd4fe337$export$ef97c660ca164e52(self, call) {
    if (call && ((0, $l0HdX._type_of)(call) === "object" || typeof call === "function")) return call;
    return (0, $d3H5E._assert_this_initialized)(self);
}

});
parcelRegister("d3H5E", function(module, exports) {

$parcel$export(module.exports, "_assert_this_initialized", function () { return $981cfaf5c821609e$export$f3b8ed2e4a5d10b8; });
$parcel$export(module.exports, "_", function () { return $981cfaf5c821609e$export$f3b8ed2e4a5d10b8; });
function $981cfaf5c821609e$export$f3b8ed2e4a5d10b8(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});




parcelRegister("fPNo7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FeatureGateEnvironment = void 0;
var $b871edd898fa61ce$var$FeatureGateEnvironment;
(function(FeatureGateEnvironment) {
    FeatureGateEnvironment["Development"] = "development";
    FeatureGateEnvironment["Staging"] = "staging";
    FeatureGateEnvironment["Production"] = "production";
})($b871edd898fa61ce$var$FeatureGateEnvironment || (module.exports.FeatureGateEnvironment = $b871edd898fa61ce$var$FeatureGateEnvironment = {}));

});

parcelRegister("amHA9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CLIENT_VERSION = void 0;
module.exports.CLIENT_VERSION = "4.7.1";

});





parcelRegister("lx9pt", function(module, exports) {

$parcel$export(module.exports, "Layout", function () { return $d60f90d1f24dac1b$export$c84671f46d6a1ca; });

var $do9pw = parcelRequire("do9pw");

var $1rY3h = parcelRequire("1rY3h");


var $1Mpn7 = parcelRequire("1Mpn7");

var $9t3nQ = parcelRequire("9t3nQ");

var $7qdHr = parcelRequire("7qdHr");

var $bsawD = parcelRequire("bsawD");
var $7J1do = parcelRequire("7J1do");
var $9wtIr = parcelRequire("9wtIr");

var $kMa9P = parcelRequire("kMa9P");

var $1gvUl = parcelRequire("1gvUl");

var $jNNT0 = parcelRequire("jNNT0");

var $haFsC = parcelRequire("haFsC");

var $jpiYS = parcelRequire("jpiYS");

var $2ygkX = parcelRequire("2ygkX");
parcelRequire("1HWyq");
var $ifIti = parcelRequire("ifIti");
parcelRequire("8l3nP");
var $2NtzU = parcelRequire("2NtzU");
parcelRequire("eb65f");
var $8JWVu = parcelRequire("8JWVu");

var $iw4d3 = parcelRequire("iw4d3");

var $af5n8 = parcelRequire("af5n8");

var $idnzS = parcelRequire("idnzS");
var $d60f90d1f24dac1b$var$emotionCache = (0, $9t3nQ.default)({
    key: "emotion-prefix-key",
    stylisPlugins: []
});
var $d60f90d1f24dac1b$export$c84671f46d6a1ca = function(props) {
    var hasAutoAtlAnalytics = true;
    (0, $1Mpn7.useEffect)(function() {
        $9wtIr.init({
            dsn: "https://a48c5247caec7a2e0ad0b8ef86376ee1@o55978.ingest.sentry.io/4505919063457792",
            environment: "production",
            integrations: [
                new $bsawD.BrowserTracing({
                    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
                    tracePropagationTargets: [
                        "localhost",
                        /^https:\/\/atlassian\.com/
                    ]
                })
            ],
            // Performance Monitoring
            tracesSampleRate: 1.0,
            // Capture 100% of the transactions, reduce in production!
            enabled: true
        });
    }, []);
    var pageViewProperties = {};
    var baseUrl = "https://www.atlassian.com";
    var _parseRoute = (0, $idnzS.parseRoute)(location), locale = _parseRoute.locale, path = _parseRoute.path, variant = _parseRoute.variant;
    var isBrowser = function() {
        return typeof window !== "undefined";
    };
    if (isBrowser()) {
        var ufoName = (0, $haFsC.default)(path.length ? "/" + path : "home");
        (0, $2ygkX.default)(ufoName, ufoName); // (ufoName, route.name);
        pageViewProperties.originProduct = "wac" + (window.location.pathname === "/" ? "" : window.location.pathname.replace(new RegExp("/", "g"), "-"));
    }
    return /*#__PURE__*/ (0, $1rY3h.jsxs)($7J1do.ErrorBoundary, {
        //@ts-ignore
        beforeCapture: function(scope) {
            scope.setTag("service", "wac-web-fe");
        },
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsx)((0, $jNNT0.InitUFO), {}),
            /*#__PURE__*/ (0, $1rY3h.jsx)((0, $7qdHr.C), {
                value: $d60f90d1f24dac1b$var$emotionCache,
                children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $kMa9P.default), {
                    locale: locale,
                    messages: props.messages,
                    children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $jpiYS.default), {
                        name: "wac",
                        children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $iw4d3.PageWrapper), {
                            baseUrl: baseUrl,
                            // we don't want a trailing slash for the homepage
                            route: path.length ? "/" + path : "",
                            variant: variant,
                            inlineCss: props.inlineCss,
                            pureClientMode: !!props.pureClientMode,
                            themeStyles: props.themeStyles,
                            templates: props.templates,
                            collections: props.collections,
                            children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $8JWVu.BxpWebStargateClientProvider), {
                                baseUrl: "https://www.atlassian.com/gateway/api",
                                children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $af5n8.LoggedInUserProvider), {
                                    children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $2NtzU.WacAnalyticsClientProvider), {
                                        children: /*#__PURE__*/ (0, $1rY3h.jsxs)((0, $2NtzU.WacAnalyticsListener), {
                                            children: [
                                                /*#__PURE__*/ (0, $1rY3h.jsx)((0, $1gvUl.default), {
                                                    children: /*#__PURE__*/ (0, $1rY3h.jsx)(props.children, (0, $do9pw._)({}, props))
                                                }),
                                                hasAutoAtlAnalytics && /*#__PURE__*/ (0, $1rY3h.jsx)((0, $ifIti.InitializeAutoAtlAnalytics), {
                                                    pageViewProperties: pageViewProperties
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            })
        ]
    });
};

});
parcelRegister("bsawD", function(module, exports) {

$parcel$export(module.exports, "BrowserTracing", function () { return $856a795743e963c2$export$46d3bbd0375f5fa4; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $7vf2h = parcelRequire("7vf2h");
var $8wQCP = parcelRequire("8wQCP");
var $lYB5d = parcelRequire("lYB5d");

var $2Qsdx = parcelRequire("2Qsdx");
var $fNn7q = parcelRequire("fNn7q");
var $eedhm = parcelRequire("eedhm");

var $iwzVz = parcelRequire("iwzVz");

var $jJ0r2 = parcelRequire("jJ0r2");

var $3njn2 = parcelRequire("3njn2");

var $c57Gp = parcelRequire("c57Gp");

var $5ecgN = parcelRequire("5ecgN");
var $856a795743e963c2$export$bbd2089f30bd3708 = "BrowserTracing";
/** Options for Browser Tracing integration */ var $856a795743e963c2$var$DEFAULT_BROWSER_TRACING_OPTIONS = (0, $do9pw._)((0, $cxjpp._)((0, $do9pw._)({}, (0, $lYB5d.TRACING_DEFAULTS)), {
    markBackgroundTransactions: true,
    routingInstrumentation: (0, $c57Gp.instrumentRoutingWithDefaults),
    startTransactionOnLocationChange: true,
    startTransactionOnPageLoad: true,
    enableLongTask: true,
    _experiments: {}
}), (0, $3njn2.defaultRequestInstrumentationOptions));
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 */ var $856a795743e963c2$export$46d3bbd0375f5fa4 = /*#__PURE__*/ function() {
    "use strict";
    function BrowserTracing(_options) {
        (0, $4GJKx._)(this, BrowserTracing);
        this.name = $856a795743e963c2$export$bbd2089f30bd3708;
        this._hasSetTracePropagationTargets = false;
        (0, $7vf2h.addTracingExtensions)();
        if (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) this._hasSetTracePropagationTargets = !!(_options && // eslint-disable-next-line deprecation/deprecation
        (_options.tracePropagationTargets || _options.tracingOrigins));
        this.options = (0, $do9pw._)({}, $856a795743e963c2$var$DEFAULT_BROWSER_TRACING_OPTIONS, _options);
        // Special case: enableLongTask can be set in _experiments
        // TODO (v8): Remove this in v8
        if (this.options._experiments.enableLongTask !== undefined) this.options.enableLongTask = this.options._experiments.enableLongTask;
        // TODO (v8): remove this block after tracingOrigins is removed
        // Set tracePropagationTargets to tracingOrigins if specified by the user
        // In case both are specified, tracePropagationTargets takes precedence
        // eslint-disable-next-line deprecation/deprecation
        if (_options && !_options.tracePropagationTargets && _options.tracingOrigins) // eslint-disable-next-line deprecation/deprecation
        this.options.tracePropagationTargets = _options.tracingOrigins;
        this._collectWebVitals = (0, $jJ0r2.startTrackingWebVitals)();
        if (this.options.enableLongTask) (0, $jJ0r2.startTrackingLongTasks)();
        if (this.options._experiments.enableInteractions) (0, $jJ0r2.startTrackingInteractions)();
    }
    (0, $1wc17._)(BrowserTracing, [
        {
            /**
   * @inheritDoc
   */ key: "setupOnce",
            value: function setupOnce(_, getCurrentHub) {
                var _this = this;
                this._getCurrentHub = getCurrentHub;
                var hub = getCurrentHub();
                var client = hub.getClient();
                var clientOptions = client && client.getOptions();
                var _this_options = this.options, instrumentRouting = _this_options.routingInstrumentation, startTransactionOnLocationChange = _this_options.startTransactionOnLocationChange, startTransactionOnPageLoad = _this_options.startTransactionOnPageLoad, markBackgroundTransactions = _this_options.markBackgroundTransactions, traceFetch = _this_options.traceFetch, traceXHR = _this_options.traceXHR, shouldCreateSpanForRequest = _this_options.shouldCreateSpanForRequest, enableHTTPTimings = _this_options.enableHTTPTimings, _experiments = _this_options._experiments;
                var clientOptionsTracePropagationTargets = clientOptions && clientOptions.tracePropagationTargets;
                // There are three ways to configure tracePropagationTargets:
                // 1. via top level client option `tracePropagationTargets`
                // 2. via BrowserTracing option `tracePropagationTargets`
                // 3. via BrowserTracing option `tracingOrigins` (deprecated)
                //
                // To avoid confusion, favour top level client option `tracePropagationTargets`, and fallback to
                // BrowserTracing option `tracePropagationTargets` and then `tracingOrigins` (deprecated).
                // This is done as it minimizes bundle size (we don't have to have undefined checks).
                //
                // If both 1 and either one of 2 or 3 are set (from above), we log out a warning.
                // eslint-disable-next-line deprecation/deprecation
                var tracePropagationTargets = clientOptionsTracePropagationTargets || this.options.tracePropagationTargets;
                if ((typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && this._hasSetTracePropagationTargets && clientOptionsTracePropagationTargets) (0, $fNn7q.logger).warn("[Tracing] The `tracePropagationTargets` option was set in the BrowserTracing integration and top level `Sentry.init`. The top level `Sentry.init` value is being used.");
                instrumentRouting(function(context) {
                    var transaction = _this._createRouteTransaction(context);
                    _this.options._experiments.onStartRouteTransaction && _this.options._experiments.onStartRouteTransaction(transaction, context, getCurrentHub);
                    return transaction;
                }, startTransactionOnPageLoad, startTransactionOnLocationChange);
                if (markBackgroundTransactions) (0, $iwzVz.registerBackgroundTabDetection)();
                if (_experiments.enableInteractions) this._registerInteractionListener();
                (0, $3njn2.instrumentOutgoingRequests)({
                    traceFetch: traceFetch,
                    traceXHR: traceXHR,
                    tracePropagationTargets: tracePropagationTargets,
                    shouldCreateSpanForRequest: shouldCreateSpanForRequest,
                    enableHTTPTimings: enableHTTPTimings
                });
            }
        },
        {
            /** Create routing idle transaction. */ key: "_createRouteTransaction",
            value: function _createRouteTransaction(context) {
                var _this = this;
                if (!this._getCurrentHub) {
                    (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).warn("[Tracing] Did not create ".concat(context.op, " transaction because _getCurrentHub is invalid."));
                    return undefined;
                }
                var hub = this._getCurrentHub();
                var _this_options = this.options, beforeNavigate = _this_options.beforeNavigate, idleTimeout = _this_options.idleTimeout, finalTimeout = _this_options.finalTimeout, heartbeatInterval = _this_options.heartbeatInterval;
                var isPageloadTransaction = context.op === "pageload";
                var sentryTrace = isPageloadTransaction ? $856a795743e963c2$export$f147b32b03c9cf11("sentry-trace") : "";
                var baggage = isPageloadTransaction ? $856a795743e963c2$export$f147b32b03c9cf11("baggage") : "";
                var _tracingContextFromHeaders = (0, $eedhm.tracingContextFromHeaders)(sentryTrace, baggage), traceparentData = _tracingContextFromHeaders.traceparentData, dynamicSamplingContext = _tracingContextFromHeaders.dynamicSamplingContext, propagationContext = _tracingContextFromHeaders.propagationContext;
                var expandedContext = (0, $cxjpp._)((0, $do9pw._)({}, context, traceparentData), {
                    metadata: (0, $cxjpp._)((0, $do9pw._)({}, context.metadata), {
                        dynamicSamplingContext: traceparentData && !dynamicSamplingContext ? {} : dynamicSamplingContext
                    }),
                    trimEnd: true
                });
                var modifiedContext = typeof beforeNavigate === "function" ? beforeNavigate(expandedContext) : expandedContext;
                // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
                // from being sent to Sentry).
                var finalContext = modifiedContext === undefined ? (0, $cxjpp._)((0, $do9pw._)({}, expandedContext), {
                    sampled: false
                }) : modifiedContext;
                // If `beforeNavigate` set a custom name, record that fact
                finalContext.metadata = finalContext.name !== expandedContext.name ? (0, $cxjpp._)((0, $do9pw._)({}, finalContext.metadata), {
                    source: "custom"
                }) : finalContext.metadata;
                this._latestRouteName = finalContext.name;
                this._latestRouteSource = finalContext.metadata && finalContext.metadata.source;
                if (finalContext.sampled === false) (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).log("[Tracing] Will not send ".concat(finalContext.op, " transaction because of beforeNavigate."));
                (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).log("[Tracing] Starting ".concat(finalContext.op, " transaction on scope"));
                var location = (0, $5ecgN.WINDOW).location;
                var idleTransaction = (0, $7vf2h.startIdleTransaction)(hub, finalContext, idleTimeout, finalTimeout, true, {
                    location: location
                }, heartbeatInterval);
                var scope = hub.getScope();
                // If it's a pageload and there is a meta tag set
                // use the traceparentData as the propagation context
                if (isPageloadTransaction && traceparentData) scope.setPropagationContext(propagationContext);
                else // Navigation transactions should set a new propagation context based on the
                // created idle transaction.
                scope.setPropagationContext({
                    traceId: idleTransaction.traceId,
                    spanId: idleTransaction.spanId,
                    parentSpanId: idleTransaction.parentSpanId,
                    sampled: idleTransaction.sampled
                });
                idleTransaction.registerBeforeFinishCallback(function(transaction) {
                    _this._collectWebVitals();
                    (0, $jJ0r2.addPerformanceEntries)(transaction);
                });
                return idleTransaction;
            }
        },
        {
            /** Start listener for interaction transactions */ key: "_registerInteractionListener",
            value: function _registerInteractionListener() {
                var _this = this;
                var inflightInteractionTransaction;
                var registerInteractionTransaction = function() {
                    var _this_options = _this.options, idleTimeout = _this_options.idleTimeout, finalTimeout = _this_options.finalTimeout, heartbeatInterval = _this_options.heartbeatInterval;
                    var op = "ui.action.click";
                    var currentTransaction = (0, $8wQCP.getActiveTransaction)();
                    if (currentTransaction && currentTransaction.op && [
                        "navigation",
                        "pageload"
                    ].includes(currentTransaction.op)) {
                        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).warn("[Tracing] Did not create ".concat(op, " transaction because a pageload or navigation transaction is in progress."));
                        return undefined;
                    }
                    if (inflightInteractionTransaction) {
                        inflightInteractionTransaction.setFinishReason("interactionInterrupted");
                        inflightInteractionTransaction.finish();
                        inflightInteractionTransaction = undefined;
                    }
                    if (!_this._getCurrentHub) {
                        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).warn("[Tracing] Did not create ".concat(op, " transaction because _getCurrentHub is invalid."));
                        return undefined;
                    }
                    if (!_this._latestRouteName) {
                        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).warn("[Tracing] Did not create ".concat(op, " transaction because _latestRouteName is missing."));
                        return undefined;
                    }
                    var hub = _this._getCurrentHub();
                    var location = (0, $5ecgN.WINDOW).location;
                    var context = {
                        name: _this._latestRouteName,
                        op: op,
                        trimEnd: true,
                        metadata: {
                            source: _this._latestRouteSource || "url"
                        }
                    };
                    inflightInteractionTransaction = (0, $7vf2h.startIdleTransaction)(hub, context, idleTimeout, finalTimeout, true, {
                        location: location
                    }, heartbeatInterval);
                };
                [
                    "click"
                ].forEach(function(type) {
                    addEventListener(type, registerInteractionTransaction, {
                        once: false,
                        capture: true
                    });
                });
            }
        }
    ]);
    return BrowserTracing;
}();
/** Returns the value of a meta tag */ function $856a795743e963c2$export$f147b32b03c9cf11(metaName) {
    // Can't specify generic to `getDomElement` because tracing can be used
    // in a variety of environments, have to disable `no-unsafe-member-access`
    // as a result.
    var metaTag = (0, $2Qsdx.getDomElement)("meta[name=".concat(metaName, "]"));
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return metaTag ? metaTag.getAttribute("content") : undefined;
}

});
parcelRegister("7vf2h", function(module, exports) {

$parcel$export(module.exports, "startIdleTransaction", function () { return $5767177660d1dcb6$export$479dbd817e392a4f; });
$parcel$export(module.exports, "addTracingExtensions", function () { return $5767177660d1dcb6$export$653d0ef2bad9cdf9; });

var $do9pw = parcelRequire("do9pw");

var $fNn7q = parcelRequire("fNn7q");

var $1uvy1 = parcelRequire("1uvy1");

var $7cLK3 = parcelRequire("7cLK3");

var $lYB5d = parcelRequire("lYB5d");

var $coDEo = parcelRequire("coDEo");

var $cxSLN = parcelRequire("cxSLN");
/** Returns all trace headers that are currently on the top scope. */ function $5767177660d1dcb6$var$traceHeaders() {
    var scope = this.getScope();
    var span = scope.getSpan();
    return span ? {
        "sentry-trace": span.toTraceparent()
    } : {};
}
/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */ function $5767177660d1dcb6$var$_startTransaction(transactionContext, customSamplingContext) {
    var client = this.getClient();
    var options = client && client.getOptions() || {};
    var configInstrumenter = options.instrumenter || "sentry";
    var transactionInstrumenter = transactionContext.instrumenter || "sentry";
    if (configInstrumenter !== transactionInstrumenter) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).error("A transaction was started with instrumenter=`".concat(transactionInstrumenter, "`, but the SDK is configured with the `").concat(configInstrumenter, "` instrumenter.\nThe transaction will not be sampled. Please use the ").concat(configInstrumenter, " instrumentation to start transactions."));
        transactionContext.sampled = false;
    }
    var transaction = new (0, $cxSLN.Transaction)(transactionContext, this);
    transaction = (0, $coDEo.sampleTransaction)(transaction, options, (0, $do9pw._)({
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext
    }, customSamplingContext));
    if (transaction.sampled) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit("startTransaction", transaction);
    return transaction;
}
/**
 * Create new idle transaction.
 */ function $5767177660d1dcb6$export$479dbd817e392a4f(hub, transactionContext, idleTimeout, finalTimeout, onScope, customSamplingContext, heartbeatInterval) {
    var client = hub.getClient();
    var options = client && client.getOptions() || {};
    var transaction = new (0, $lYB5d.IdleTransaction)(transactionContext, hub, idleTimeout, finalTimeout, heartbeatInterval, onScope);
    transaction = (0, $coDEo.sampleTransaction)(transaction, options, (0, $do9pw._)({
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext
    }, customSamplingContext));
    if (transaction.sampled) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit("startTransaction", transaction);
    return transaction;
}
/**
 * Adds tracing extensions to the global hub.
 */ function $5767177660d1dcb6$export$653d0ef2bad9cdf9() {
    var carrier = (0, $1uvy1.getMainCarrier)();
    if (!carrier.__SENTRY__) return;
    carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
    if (!carrier.__SENTRY__.extensions.startTransaction) carrier.__SENTRY__.extensions.startTransaction = $5767177660d1dcb6$var$_startTransaction;
    if (!carrier.__SENTRY__.extensions.traceHeaders) carrier.__SENTRY__.extensions.traceHeaders = $5767177660d1dcb6$var$traceHeaders;
    (0, $7cLK3.registerErrorInstrumentation)();
}

});
parcelRegister("fNn7q", function(module, exports) {

$parcel$export(module.exports, "CONSOLE_LEVELS", function () { return $b7fd5d854875705c$export$2a2b1d2252a69ecb; });
$parcel$export(module.exports, "originalConsoleMethods", function () { return $b7fd5d854875705c$export$77c4ce905194557b; });
$parcel$export(module.exports, "consoleSandbox", function () { return $b7fd5d854875705c$export$cda52e2a8927a2ca; });
$parcel$export(module.exports, "logger", function () { return $b7fd5d854875705c$export$af88d00dbe7f521; });

var $c6Xmf = parcelRequire("c6Xmf");

var $3rn7c = parcelRequire("3rn7c");
/** Prefix for logging strings */ var $b7fd5d854875705c$var$PREFIX = "Sentry Logger ";
var $b7fd5d854875705c$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
/** This may be mutated by the console instrumentation. */ var $b7fd5d854875705c$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $b7fd5d854875705c$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $3rn7c.GLOBAL_OBJ))) return callback();
    var console = (0, $3rn7c.GLOBAL_OBJ).console;
    var wrappedFuncs = {};
    var wrappedLevels = Object.keys($b7fd5d854875705c$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach(function(level) {
        var originalConsoleMethod = $b7fd5d854875705c$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach(function(level) {
            console[level] = wrappedFuncs[level];
        });
    }
}
function $b7fd5d854875705c$var$makeLogger() {
    var enabled = false;
    var logger = {
        enable: function() {
            enabled = true;
        },
        disable: function() {
            enabled = false;
        },
        isEnabled: function() {
            return enabled;
        }
    };
    if (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) $b7fd5d854875705c$export$2a2b1d2252a69ecb.forEach(function(name) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (enabled) $b7fd5d854875705c$export$cda52e2a8927a2ca(function() {
                var _GLOBAL_OBJ_console;
                (_GLOBAL_OBJ_console = (0, $3rn7c.GLOBAL_OBJ).console)[name].apply(_GLOBAL_OBJ_console, [
                    "".concat($b7fd5d854875705c$var$PREFIX, "[").concat(name, "]:")
                ].concat((0, $c6Xmf._)(args)));
            });
        };
    });
    else $b7fd5d854875705c$export$2a2b1d2252a69ecb.forEach(function(name) {
        logger[name] = function() {
            return undefined;
        };
    });
    return logger;
}
var $b7fd5d854875705c$export$af88d00dbe7f521 = $b7fd5d854875705c$var$makeLogger();

});
parcelRegister("c6Xmf", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8d1416c8f734345e$export$1b5e630bc3aea29f; });

var $2BACi = parcelRequire("2BACi");

var $djrl5 = parcelRequire("djrl5");

var $jix3C = parcelRequire("jix3C");

var $1hjNY = parcelRequire("1hjNY");
function $8d1416c8f734345e$export$1b5e630bc3aea29f(arr) {
    return (0, $2BACi._array_without_holes)(arr) || (0, $djrl5._iterable_to_array)(arr) || (0, $1hjNY._unsupported_iterable_to_array)(arr) || (0, $jix3C._non_iterable_spread)();
}

});
parcelRegister("2BACi", function(module, exports) {

$parcel$export(module.exports, "_array_without_holes", function () { return $1e5b70c2c2307a84$export$7e0947b5ad3404e2; });

var $QCMVH = parcelRequire("QCMVH");
function $1e5b70c2c2307a84$export$7e0947b5ad3404e2(arr) {
    if (Array.isArray(arr)) return (0, $QCMVH._array_like_to_array)(arr);
}

});

parcelRegister("djrl5", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array", function () { return $9b1241b318447a2a$export$1eb58a6e75231000; });
function $9b1241b318447a2a$export$1eb58a6e75231000(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("jix3C", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_spread", function () { return $e0c9573dc9b3384a$export$e6f3c4780d19eb2b; });
function $e0c9573dc9b3384a$export$e6f3c4780d19eb2b() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("3rn7c", function(module, exports) {

$parcel$export(module.exports, "GLOBAL_OBJ", function () { return $2815d2e90e668992$export$f1a6cdb1459e81d1; });
$parcel$export(module.exports, "getGlobalObject", function () { return $2815d2e90e668992$export$256479dc0cea61c4; });
$parcel$export(module.exports, "getGlobalSingleton", function () { return $2815d2e90e668992$export$7e223ec222791509; });
/** Internal global with common properties and Sentry extensions  */ // The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
/** Returns 'obj' if it's the global object, otherwise returns undefined */ function $2815d2e90e668992$var$isGlobalObj(obj) {
    return obj && obj.Math == Math ? obj : undefined;
}
/** Get's the global object for the current JavaScript runtime */ var $2815d2e90e668992$export$f1a6cdb1459e81d1 = typeof globalThis == "object" && $2815d2e90e668992$var$isGlobalObj(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == "object" && $2815d2e90e668992$var$isGlobalObj(window) || typeof self == "object" && $2815d2e90e668992$var$isGlobalObj(self) || typeof $parcel$global == "object" && $2815d2e90e668992$var$isGlobalObj($parcel$global) || function() {
    return this;
}() || {};
/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */ function $2815d2e90e668992$export$256479dc0cea61c4() {
    return $2815d2e90e668992$export$f1a6cdb1459e81d1;
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $2815d2e90e668992$export$7e223ec222791509(name, creator, obj) {
    var gbl = obj || $2815d2e90e668992$export$f1a6cdb1459e81d1;
    var __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});


parcelRegister("1uvy1", function(module, exports) {

$parcel$export(module.exports, "getMainCarrier", function () { return $1161107e8976bdfe$export$19eade501500c6c1; });
$parcel$export(module.exports, "getCurrentHub", function () { return $1161107e8976bdfe$export$a07cdf6544bbd7c; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $fNn7q = parcelRequire("fNn7q");
var $kfF30 = parcelRequire("kfF30");
var $3rn7c = parcelRequire("3rn7c");
var $9MzNF = parcelRequire("9MzNF");

var $lqQO8 = parcelRequire("lqQO8");

var $3Rd92 = parcelRequire("3Rd92");

var $aBCNn = parcelRequire("aBCNn");
/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */ var $1161107e8976bdfe$export$24a86ef7798177e4 = 4;
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ var $1161107e8976bdfe$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @inheritDoc
 */ var $1161107e8976bdfe$export$8c41bb232f1008b1 = /*#__PURE__*/ function() {
    "use strict";
    function Hub(client) {
        var scope = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new (0, $3Rd92.Scope)(), _version = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $1161107e8976bdfe$export$24a86ef7798177e4;
        (0, $4GJKx._)(this, Hub);
        this._version = _version;
        this._stack = [
            {
                scope: scope
            }
        ];
        if (client) this.bindClient(client);
    }
    (0, $1wc17._)(Hub, [
        {
            /**
   * @inheritDoc
   */ key: "isOlderThan",
            value: function isOlderThan(version) {
                return this._version < version;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "bindClient",
            value: function bindClient(client) {
                var top = this.getStackTop();
                top.client = client;
                if (client && client.setupIntegrations) client.setupIntegrations();
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "pushScope",
            value: function pushScope() {
                // We want to clone the content of prev scope
                var scope = (0, $3Rd92.Scope).clone(this.getScope());
                this.getStack().push({
                    client: this.getClient(),
                    scope: scope
                });
                return scope;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "popScope",
            value: function popScope() {
                if (this.getStack().length <= 1) return false;
                return !!this.getStack().pop();
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "withScope",
            value: function withScope(callback) {
                var scope = this.pushScope();
                try {
                    callback(scope);
                } finally{
                    this.popScope();
                }
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getClient",
            value: function getClient() {
                return this.getStackTop().client;
            }
        },
        {
            /** Returns the scope of the top stack. */ key: "getScope",
            value: function getScope() {
                return this.getStackTop().scope;
            }
        },
        {
            /** Returns the scope stack for domains or the process. */ key: "getStack",
            value: function getStack() {
                return this._stack;
            }
        },
        {
            /** Returns the topmost scope layer in the order domain > local > process. */ key: "getStackTop",
            value: function getStackTop() {
                return this._stack[this._stack.length - 1];
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "captureException",
            value: function captureException(exception, hint) {
                var eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $9MzNF.uuid4)();
                var syntheticException = new Error("Sentry syntheticException");
                this._withClient(function(client, scope) {
                    client.captureException(exception, (0, $cxjpp._)((0, $do9pw._)({
                        originalException: exception,
                        syntheticException: syntheticException
                    }, hint), {
                        event_id: eventId
                    }), scope);
                });
                return eventId;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "captureMessage",
            value: function captureMessage(message, // eslint-disable-next-line deprecation/deprecation
            level, hint) {
                var eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $9MzNF.uuid4)();
                var syntheticException = new Error(message);
                this._withClient(function(client, scope) {
                    client.captureMessage(message, level, (0, $cxjpp._)((0, $do9pw._)({
                        originalException: message,
                        syntheticException: syntheticException
                    }, hint), {
                        event_id: eventId
                    }), scope);
                });
                return eventId;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "captureEvent",
            value: function captureEvent(event, hint) {
                var eventId = hint && hint.event_id ? hint.event_id : (0, $9MzNF.uuid4)();
                if (!event.type) this._lastEventId = eventId;
                this._withClient(function(client, scope) {
                    client.captureEvent(event, (0, $cxjpp._)((0, $do9pw._)({}, hint), {
                        event_id: eventId
                    }), scope);
                });
                return eventId;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "lastEventId",
            value: function lastEventId() {
                return this._lastEventId;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "addBreadcrumb",
            value: function addBreadcrumb(breadcrumb, hint) {
                var _this_getStackTop = this.getStackTop(), scope = _this_getStackTop.scope, client = _this_getStackTop.client;
                if (!client) return;
                var _ref = client.getOptions && client.getOptions() || {}, _ref_beforeBreadcrumb = _ref.beforeBreadcrumb, beforeBreadcrumb = _ref_beforeBreadcrumb === void 0 ? null : _ref_beforeBreadcrumb, _ref_maxBreadcrumbs = _ref.maxBreadcrumbs, maxBreadcrumbs = _ref_maxBreadcrumbs === void 0 ? $1161107e8976bdfe$var$DEFAULT_BREADCRUMBS : _ref_maxBreadcrumbs;
                if (maxBreadcrumbs <= 0) return;
                var timestamp = (0, $kfF30.dateTimestampInSeconds)();
                var mergedBreadcrumb = (0, $do9pw._)({
                    timestamp: timestamp
                }, breadcrumb);
                var finalBreadcrumb = beforeBreadcrumb ? (0, $fNn7q.consoleSandbox)(function() {
                    return beforeBreadcrumb(mergedBreadcrumb, hint);
                }) : mergedBreadcrumb;
                if (finalBreadcrumb === null) return;
                if (client.emit) client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
                scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setUser",
            value: function setUser(user) {
                this.getScope().setUser(user);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setTags",
            value: function setTags(tags) {
                this.getScope().setTags(tags);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setExtras",
            value: function setExtras(extras) {
                this.getScope().setExtras(extras);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setTag",
            value: function setTag(key, value) {
                this.getScope().setTag(key, value);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setExtra",
            value: function setExtra(key, extra) {
                this.getScope().setExtra(key, extra);
            }
        },
        {
            /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
            key: "setContext",
            value: function setContext(name, context) {
                this.getScope().setContext(name, context);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "configureScope",
            value: function configureScope(callback) {
                var _this_getStackTop = this.getStackTop(), scope = _this_getStackTop.scope, client = _this_getStackTop.client;
                if (client) callback(scope);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "run",
            value: function run(callback) {
                var oldHub = $1161107e8976bdfe$export$4188a14ad302d1bc(this);
                try {
                    callback(this);
                } finally{
                    $1161107e8976bdfe$export$4188a14ad302d1bc(oldHub);
                }
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getIntegration",
            value: function getIntegration(integration) {
                var client = this.getClient();
                if (!client) return null;
                try {
                    return client.getIntegration(integration);
                } catch (_oO) {
                    (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).warn("Cannot retrieve integration ".concat(integration.id, " from the current Hub"));
                    return null;
                }
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "startTransaction",
            value: function startTransaction(context, customSamplingContext) {
                var result = this._callExtensionMethod("startTransaction", context, customSamplingContext);
                if ((typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && !result) {
                    var client = this.getClient();
                    if (!client) // eslint-disable-next-line no-console
                    console.warn("Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'");
                    else // eslint-disable-next-line no-console
                    console.warn("Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':\nSentry.addTracingExtensions();\nSentry.init({...});\n");
                }
                return result;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "traceHeaders",
            value: function traceHeaders() {
                return this._callExtensionMethod("traceHeaders");
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "captureSession",
            value: function captureSession() {
                var endSession = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                // both send the update and pull the session from the scope
                if (endSession) return this.endSession();
                // only send the update
                this._sendSessionUpdate();
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "endSession",
            value: function endSession() {
                var layer = this.getStackTop();
                var scope = layer.scope;
                var session = scope.getSession();
                if (session) (0, $aBCNn.closeSession)(session);
                this._sendSessionUpdate();
                // the session is over; take it off of the scope
                scope.setSession();
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "startSession",
            value: function startSession(context) {
                var _this_getStackTop = this.getStackTop(), scope = _this_getStackTop.scope, client = _this_getStackTop.client;
                var _ref = client && client.getOptions() || {}, release = _ref.release, _ref_environment = _ref.environment, environment = _ref_environment === void 0 ? (0, $lqQO8.DEFAULT_ENVIRONMENT) : _ref_environment;
                // Will fetch userAgent if called from browser sdk
                var userAgent = ((0, $3rn7c.GLOBAL_OBJ).navigator || {}).userAgent;
                var session = (0, $aBCNn.makeSession)((0, $do9pw._)({
                    release: release,
                    environment: environment,
                    user: scope.getUser()
                }, userAgent && {
                    userAgent: userAgent
                }, context));
                // End existing session if there's one
                var currentSession = scope.getSession && scope.getSession();
                if (currentSession && currentSession.status === "ok") (0, $aBCNn.updateSession)(currentSession, {
                    status: "exited"
                });
                this.endSession();
                // Afterwards we set the new session on the scope
                scope.setSession(session);
                return session;
            }
        },
        {
            /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   */ key: "shouldSendDefaultPii",
            value: function shouldSendDefaultPii() {
                var client = this.getClient();
                var options = client && client.getOptions();
                return Boolean(options && options.sendDefaultPii);
            }
        },
        {
            /**
   * Sends the current Session on the scope
   */ key: "_sendSessionUpdate",
            value: function _sendSessionUpdate() {
                var _this_getStackTop = this.getStackTop(), scope = _this_getStackTop.scope, client = _this_getStackTop.client;
                var session = scope.getSession();
                if (session && client && client.captureSession) client.captureSession(session);
            }
        },
        {
            /**
   * Internal helper function to call a method on the top client if it exists.
   *
   * @param method The method to call on the client.
   * @param args Arguments to pass to the client function.
   */ key: "_withClient",
            value: function _withClient(callback) {
                var _this_getStackTop = this.getStackTop(), scope = _this_getStackTop.scope, client = _this_getStackTop.client;
                if (client) callback(client, scope);
            }
        },
        {
            /**
   * Calls global extension method and binding current instance to the function call
   */ // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            key: "_callExtensionMethod",
            value: function _callExtensionMethod(method) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                var carrier = $1161107e8976bdfe$export$19eade501500c6c1();
                var sentry = carrier.__SENTRY__;
                if (sentry && sentry.extensions && typeof sentry.extensions[method] === "function") return sentry.extensions[method].apply(this, args);
                (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).warn("Extension method ".concat(method, " couldn't be found, doing nothing."));
            }
        }
    ]);
    return Hub;
}();
/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $1161107e8976bdfe$export$19eade501500c6c1() {
    (0, $3rn7c.GLOBAL_OBJ).__SENTRY__ = (0, $3rn7c.GLOBAL_OBJ).__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return 0, $3rn7c.GLOBAL_OBJ;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 */ function $1161107e8976bdfe$export$4188a14ad302d1bc(hub) {
    var registry = $1161107e8976bdfe$export$19eade501500c6c1();
    var oldHub = $1161107e8976bdfe$export$bfa8a924a84a76b7(registry);
    $1161107e8976bdfe$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 */ function $1161107e8976bdfe$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    var registry = $1161107e8976bdfe$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
        var hub = registry.__SENTRY__.acs.getCurrentHub();
        if (hub) return hub;
    }
    // Return hub that lives on a global object
    return $1161107e8976bdfe$var$getGlobalHub(registry);
}
function $1161107e8976bdfe$var$getGlobalHub() {
    var registry = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $1161107e8976bdfe$export$19eade501500c6c1();
    // If there's no hub, or its an old API, assign a new one
    if (!$1161107e8976bdfe$var$hasHubOnCarrier(registry) || $1161107e8976bdfe$export$bfa8a924a84a76b7(registry).isOlderThan($1161107e8976bdfe$export$24a86ef7798177e4)) $1161107e8976bdfe$export$849f05434e95d2f2(registry, new $1161107e8976bdfe$export$8c41bb232f1008b1());
    // Return hub that lives on a global object
    return $1161107e8976bdfe$export$bfa8a924a84a76b7(registry);
}
/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */ function $1161107e8976bdfe$export$236689a79f5aa020(carrier) {
    var parent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1161107e8976bdfe$var$getGlobalHub();
    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!$1161107e8976bdfe$var$hasHubOnCarrier(carrier) || $1161107e8976bdfe$export$bfa8a924a84a76b7(carrier).isOlderThan($1161107e8976bdfe$export$24a86ef7798177e4)) {
        var globalHubTopStack = parent.getStackTop();
        $1161107e8976bdfe$export$849f05434e95d2f2(carrier, new $1161107e8976bdfe$export$8c41bb232f1008b1(globalHubTopStack.client, (0, $3Rd92.Scope).clone(globalHubTopStack.scope)));
    }
}
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $1161107e8976bdfe$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    var registry = $1161107e8976bdfe$export$19eade501500c6c1();
    registry.__SENTRY__ = registry.__SENTRY__ || {};
    registry.__SENTRY__.acs = strategy;
}
/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */ function $1161107e8976bdfe$export$70d775fb1f267027(callback) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var registry = $1161107e8976bdfe$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
    // if there was no strategy, fallback to just calling the callback
    return callback();
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $1161107e8976bdfe$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */ function $1161107e8976bdfe$export$bfa8a924a84a76b7(carrier) {
    return (0, $3rn7c.getGlobalSingleton)("hub", function() {
        return new $1161107e8976bdfe$export$8c41bb232f1008b1();
    }, carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */ function $1161107e8976bdfe$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    var __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}

});
parcelRegister("kfF30", function(module, exports) {

$parcel$export(module.exports, "dateTimestampInSeconds", function () { return dateTimestampInSeconds; });
$parcel$export(module.exports, "timestampInSeconds", function () { return timestampInSeconds; });
$parcel$export(module.exports, "browserPerformanceTimeOrigin", function () { return browserPerformanceTimeOrigin; });

var $5OUFg = parcelRequire("5OUFg");

var $3rn7c = parcelRequire("3rn7c");
// eslint-disable-next-line deprecation/deprecation
var WINDOW = (0, $3rn7c.getGlobalObject)();
/**
 * An object that can return the current timestamp in seconds since the UNIX epoch.
 */ /**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ var dateTimestampSource = {
    nowSeconds: function() {
        return Date.now() / 1000;
    }
};
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    var performance = WINDOW.performance;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function() {
            return performance.now();
        },
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        var perfHooks = (0, $5OUFg.dynamicRequire)(module, "perf_hooks");
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ var platformPerformance = (0, $5OUFg.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: function() {
        return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000;
    }
};
/**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */ var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * See `usingPerformanceAPI` to test whether the Performance API is used.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */ var timestampWithMs = timestampInSeconds;
/**
 * A boolean that is true when timestampInSeconds uses the Performance API to produce monotonic timestamps.
 */ var usingPerformanceAPI = platformPerformance !== undefined;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ var _browserPerformanceTimeOriginMode;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ var browserPerformanceTimeOrigin = function() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = WINDOW.performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = "none";
        return undefined;
    }
    var threshold = 3600000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === "number";
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = "timeOrigin";
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = "navigationStart";
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = "dateNow";
    return dateNow;
}();

});
parcelRegister("5OUFg", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", function () { return isNodeEnv; });
$parcel$export(module.exports, "dynamicRequire", function () { return dynamicRequire; });

var $iq6WK = parcelRequire("iq6WK");

var $3qWgZ = parcelRequire("3qWgZ");
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ /**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */ function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $iq6WK.isBrowserBundle)() && Object.prototype.toString.call(typeof $3qWgZ !== "undefined" ? $3qWgZ : 0) === "[object process]";
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */ function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        var cwd = dynamicRequire(module, "process").cwd;
        mod = dynamicRequire(module, "".concat(cwd(), "/node_modules/").concat(moduleName));
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("iq6WK", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", function () { return $d6900b25beb4f9ca$export$2928c40372e623c0; });
$parcel$export(module.exports, "getSDKSource", function () { return $d6900b25beb4f9ca$export$8ad33f488b1ab046; });
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $d6900b25beb4f9ca$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $d6900b25beb4f9ca$export$8ad33f488b1ab046() {
    // @ts-expect-error "npm" is injected by rollup during build process
    return "npm";
}

});

parcelRegister("3qWgZ", function(module, exports) {
// shim for using process in browser
var $28010097cfd45d35$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $28010097cfd45d35$var$cachedSetTimeout;
var $28010097cfd45d35$var$cachedClearTimeout;
function $28010097cfd45d35$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $28010097cfd45d35$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $28010097cfd45d35$var$cachedSetTimeout = setTimeout;
        else $28010097cfd45d35$var$cachedSetTimeout = $28010097cfd45d35$var$defaultSetTimout;
    } catch (e) {
        $28010097cfd45d35$var$cachedSetTimeout = $28010097cfd45d35$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $28010097cfd45d35$var$cachedClearTimeout = clearTimeout;
        else $28010097cfd45d35$var$cachedClearTimeout = $28010097cfd45d35$var$defaultClearTimeout;
    } catch (e) {
        $28010097cfd45d35$var$cachedClearTimeout = $28010097cfd45d35$var$defaultClearTimeout;
    }
})();
function $28010097cfd45d35$var$runTimeout(fun) {
    if ($28010097cfd45d35$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($28010097cfd45d35$var$cachedSetTimeout === $28010097cfd45d35$var$defaultSetTimout || !$28010097cfd45d35$var$cachedSetTimeout) && setTimeout) {
        $28010097cfd45d35$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $28010097cfd45d35$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $28010097cfd45d35$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $28010097cfd45d35$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $28010097cfd45d35$var$runClearTimeout(marker) {
    if ($28010097cfd45d35$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($28010097cfd45d35$var$cachedClearTimeout === $28010097cfd45d35$var$defaultClearTimeout || !$28010097cfd45d35$var$cachedClearTimeout) && clearTimeout) {
        $28010097cfd45d35$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $28010097cfd45d35$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $28010097cfd45d35$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $28010097cfd45d35$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $28010097cfd45d35$var$queue = [];
var $28010097cfd45d35$var$draining = false;
var $28010097cfd45d35$var$currentQueue;
var $28010097cfd45d35$var$queueIndex = -1;
function $28010097cfd45d35$var$cleanUpNextTick() {
    if (!$28010097cfd45d35$var$draining || !$28010097cfd45d35$var$currentQueue) return;
    $28010097cfd45d35$var$draining = false;
    if ($28010097cfd45d35$var$currentQueue.length) $28010097cfd45d35$var$queue = $28010097cfd45d35$var$currentQueue.concat($28010097cfd45d35$var$queue);
    else $28010097cfd45d35$var$queueIndex = -1;
    if ($28010097cfd45d35$var$queue.length) $28010097cfd45d35$var$drainQueue();
}
function $28010097cfd45d35$var$drainQueue() {
    if ($28010097cfd45d35$var$draining) return;
    var timeout = $28010097cfd45d35$var$runTimeout($28010097cfd45d35$var$cleanUpNextTick);
    $28010097cfd45d35$var$draining = true;
    var len = $28010097cfd45d35$var$queue.length;
    while(len){
        $28010097cfd45d35$var$currentQueue = $28010097cfd45d35$var$queue;
        $28010097cfd45d35$var$queue = [];
        while(++$28010097cfd45d35$var$queueIndex < len)if ($28010097cfd45d35$var$currentQueue) $28010097cfd45d35$var$currentQueue[$28010097cfd45d35$var$queueIndex].run();
        $28010097cfd45d35$var$queueIndex = -1;
        len = $28010097cfd45d35$var$queue.length;
    }
    $28010097cfd45d35$var$currentQueue = null;
    $28010097cfd45d35$var$draining = false;
    $28010097cfd45d35$var$runClearTimeout(timeout);
}
$28010097cfd45d35$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $28010097cfd45d35$var$queue.push(new $28010097cfd45d35$var$Item(fun, args));
    if ($28010097cfd45d35$var$queue.length === 1 && !$28010097cfd45d35$var$draining) $28010097cfd45d35$var$runTimeout($28010097cfd45d35$var$drainQueue);
};
// v8 likes predictible objects
function $28010097cfd45d35$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$28010097cfd45d35$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$28010097cfd45d35$var$process.title = "browser";
$28010097cfd45d35$var$process.browser = true;
$28010097cfd45d35$var$process.env = {};
$28010097cfd45d35$var$process.argv = [];
$28010097cfd45d35$var$process.version = ""; // empty string to avoid regexp issues
$28010097cfd45d35$var$process.versions = {};
function $28010097cfd45d35$var$noop() {}
$28010097cfd45d35$var$process.on = $28010097cfd45d35$var$noop;
$28010097cfd45d35$var$process.addListener = $28010097cfd45d35$var$noop;
$28010097cfd45d35$var$process.once = $28010097cfd45d35$var$noop;
$28010097cfd45d35$var$process.off = $28010097cfd45d35$var$noop;
$28010097cfd45d35$var$process.removeListener = $28010097cfd45d35$var$noop;
$28010097cfd45d35$var$process.removeAllListeners = $28010097cfd45d35$var$noop;
$28010097cfd45d35$var$process.emit = $28010097cfd45d35$var$noop;
$28010097cfd45d35$var$process.prependListener = $28010097cfd45d35$var$noop;
$28010097cfd45d35$var$process.prependOnceListener = $28010097cfd45d35$var$noop;
$28010097cfd45d35$var$process.listeners = function(name) {
    return [];
};
$28010097cfd45d35$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$28010097cfd45d35$var$process.cwd = function() {
    return "/";
};
$28010097cfd45d35$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$28010097cfd45d35$var$process.umask = function() {
    return 0;
};

});



parcelRegister("9MzNF", function(module, exports) {

$parcel$export(module.exports, "uuid4", function () { return $71f45de1b2c8dd6c$export$19f53698e68b2496; });
$parcel$export(module.exports, "getEventDescription", function () { return $71f45de1b2c8dd6c$export$4157119e2b157127; });
$parcel$export(module.exports, "addExceptionTypeValue", function () { return $71f45de1b2c8dd6c$export$f26508487bf83ee7; });
$parcel$export(module.exports, "addExceptionMechanism", function () { return $71f45de1b2c8dd6c$export$c69a9a0313b03bb1; });
$parcel$export(module.exports, "checkOrSetAlreadyCaught", function () { return $71f45de1b2c8dd6c$export$6de4ffac6a2f1098; });
$parcel$export(module.exports, "arrayify", function () { return $71f45de1b2c8dd6c$export$3131421a7d01b4fb; });

var $do9pw = parcelRequire("do9pw");

var $9QLqp = parcelRequire("9QLqp");

var $11858 = parcelRequire("11858");

var $3rn7c = parcelRequire("3rn7c");
/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $71f45de1b2c8dd6c$export$19f53698e68b2496() {
    var gbl = (0, $3rn7c.GLOBAL_OBJ);
    var crypto = gbl.crypto || gbl.msCrypto;
    var getRandomByte = function() {
        return Math.random() * 16;
    };
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, "");
        if (crypto && crypto.getRandomValues) getRandomByte = function() {
            return crypto.getRandomValues(new Uint8Array(1))[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, function(c) {
        return(// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
    });
}
function $71f45de1b2c8dd6c$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $71f45de1b2c8dd6c$export$4157119e2b157127(event) {
    var message = event.message, eventId = event.event_id;
    if (message) return message;
    var firstException = $71f45de1b2c8dd6c$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return "".concat(firstException.type, ": ").concat(firstException.value);
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $71f45de1b2c8dd6c$export$f26508487bf83ee7(event, value, type) {
    var exception = event.exception = event.exception || {};
    var values = exception.values = exception.values || [];
    var firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $71f45de1b2c8dd6c$export$c69a9a0313b03bb1(event, newMechanism) {
    var firstException = $71f45de1b2c8dd6c$var$getFirstException(event);
    if (!firstException) return;
    var defaultMechanism = {
        type: "generic",
        handled: true
    };
    var currentMechanism = firstException.mechanism;
    firstException.mechanism = (0, $do9pw._)({}, defaultMechanism, currentMechanism, newMechanism);
    if (newMechanism && "data" in newMechanism) {
        var mergedData = (0, $do9pw._)({}, currentMechanism && currentMechanism.data, newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var $71f45de1b2c8dd6c$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $71f45de1b2c8dd6c$export$d364f2020ab30578(input) {
    var match = input.match($71f45de1b2c8dd6c$var$SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $71f45de1b2c8dd6c$export$ec2291bfc64632f0(lines, frame) {
    var linesOfContext = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 5;
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map(function(line) {
        return (0, $11858.snipLine)(line, 0);
    });
    frame.context_line = (0, $11858.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map(function(line) {
        return (0, $11858.snipLine)(line, 0);
    });
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $71f45de1b2c8dd6c$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $9QLqp.addNonEnumerableProperty)(exception, "__sentry_captured__", true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function $71f45de1b2c8dd6c$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}

});
parcelRegister("9QLqp", function(module, exports) {

$parcel$export(module.exports, "fill", function () { return $72bdc1fc111e4fdc$export$9563e054e6f787fb; });
$parcel$export(module.exports, "markFunctionWrapped", function () { return $72bdc1fc111e4fdc$export$5c1499e2e5d010ae; });
$parcel$export(module.exports, "addNonEnumerableProperty", function () { return $72bdc1fc111e4fdc$export$e73679ffaf56810e; });
$parcel$export(module.exports, "getOriginalFunction", function () { return $72bdc1fc111e4fdc$export$e6cc1e135e2092e5; });
$parcel$export(module.exports, "urlEncode", function () { return $72bdc1fc111e4fdc$export$9ef804feabbcbaf1; });
$parcel$export(module.exports, "convertToPlainObject", function () { return $72bdc1fc111e4fdc$export$62ff257738bf57f5; });
$parcel$export(module.exports, "extractExceptionKeysForMessage", function () { return $72bdc1fc111e4fdc$export$b0244d5063c0b61b; });
$parcel$export(module.exports, "dropUndefinedKeys", function () { return $72bdc1fc111e4fdc$export$d25f2688db1bb433; });

var $do9pw = parcelRequire("do9pw");

var $l0HdX = parcelRequire("l0HdX");

var $2Qsdx = parcelRequire("2Qsdx");

var $fFQTh = parcelRequire("fFQTh");

var $fNn7q = parcelRequire("fNn7q");

var $11858 = parcelRequire("11858");
/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $72bdc1fc111e4fdc$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === "function") $72bdc1fc111e4fdc$export$5c1499e2e5d010ae(wrapped, original);
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $72bdc1fc111e4fdc$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).log('Failed to add non-enumerable property "'.concat(name, '" to object'), obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $72bdc1fc111e4fdc$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        var proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $72bdc1fc111e4fdc$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function $72bdc1fc111e4fdc$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function $72bdc1fc111e4fdc$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map(function(key) {
        return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(object[key]));
    }).join("&");
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function $72bdc1fc111e4fdc$export$62ff257738bf57f5(value) {
    if ((0, $fFQTh.isError)(value)) return (0, $do9pw._)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, $72bdc1fc111e4fdc$var$getOwnProperties(value));
    else if ((0, $fFQTh.isEvent)(value)) {
        var newObj = (0, $do9pw._)({
            type: value.type,
            target: $72bdc1fc111e4fdc$var$serializeEventTarget(value.target),
            currentTarget: $72bdc1fc111e4fdc$var$serializeEventTarget(value.currentTarget)
        }, $72bdc1fc111e4fdc$var$getOwnProperties(value));
        if (typeof CustomEvent !== "undefined" && (0, $fFQTh.isInstanceOf)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $72bdc1fc111e4fdc$var$serializeEventTarget(target) {
    try {
        return (0, $fFQTh.isElement)(target) ? (0, $2Qsdx.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return "<unknown>";
    }
}
/** Filters out all but an object's own properties */ function $72bdc1fc111e4fdc$var$getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) {
        var extractedProps = {};
        for(var property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $72bdc1fc111e4fdc$export$b0244d5063c0b61b(exception) {
    var maxLength = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 40;
    var keys = Object.keys($72bdc1fc111e4fdc$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return "[object has no keys]";
    if (keys[0].length >= maxLength) return (0, $11858.truncate)(keys[0], maxLength);
    for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
        var serialized = keys.slice(0, includedKeys).join(", ");
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $11858.truncate)(serialized, maxLength);
    }
    return "";
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $72bdc1fc111e4fdc$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    var memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $72bdc1fc111e4fdc$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $72bdc1fc111e4fdc$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ((0, $fFQTh.isPlainObject)(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        var memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        var returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.keys(inputValue)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                if (typeof inputValue[key] !== "undefined") returnValue[key] = $72bdc1fc111e4fdc$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        var memoVal1 = memoizationMap.get(inputValue);
        if (memoVal1 !== undefined) return memoVal1;
        var returnValue1 = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue1);
        inputValue.forEach(function(item) {
            returnValue1.push($72bdc1fc111e4fdc$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue1;
    }
    return inputValue;
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $72bdc1fc111e4fdc$export$92b78acdbe066b6b(wat) {
    var objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case (typeof wat === "undefined" ? "undefined" : (0, $l0HdX._)(wat)) === "symbol" || (typeof wat === "undefined" ? "undefined" : (0, $l0HdX._)(wat)) === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $fFQTh.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("2Qsdx", function(module, exports) {

$parcel$export(module.exports, "htmlTreeAsString", function () { return $2126537420a3abf7$export$5647df6b7814ac86; });
$parcel$export(module.exports, "getLocationHref", function () { return $2126537420a3abf7$export$1cfafeee2987818b; });
$parcel$export(module.exports, "getDomElement", function () { return $2126537420a3abf7$export$c660c1f3ab49225c; });

var $fFQTh = parcelRequire("fFQTh");

var $3rn7c = parcelRequire("3rn7c");
// eslint-disable-next-line deprecation/deprecation
var $2126537420a3abf7$var$WINDOW = (0, $3rn7c.getGlobalObject)();
var $2126537420a3abf7$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $2126537420a3abf7$export$5647df6b7814ac86(elem) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = " > ";
        var sepLength = separator.length;
        var nextStr;
        var keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        var maxStringLength = !Array.isArray(options) && options.maxStringLength || $2126537420a3abf7$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $2126537420a3abf7$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return "<unknown>";
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $2126537420a3abf7$var$_htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) return "";
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter(function(keyAttr) {
        return elem.getAttribute(keyAttr);
    }).map(function(keyAttr) {
        return [
            keyAttr,
            elem.getAttribute(keyAttr)
        ];
    }) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach(function(keyAttrPair) {
        out.push("[".concat(keyAttrPair[0], '="').concat(keyAttrPair[1], '"]'));
    });
    else {
        if (elem.id) out.push("#".concat(elem.id));
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $fFQTh.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push(".".concat(classes[i]));
        }
    }
    var allowedAttrs = [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push("[".concat(key, '="').concat(attr, '"]'));
    }
    return out.join("");
}
/**
 * A safe form of location.href
 */ function $2126537420a3abf7$export$1cfafeee2987818b() {
    try {
        return $2126537420a3abf7$var$WINDOW.document.location.href;
    } catch (oO) {
        return "";
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $2126537420a3abf7$export$c660c1f3ab49225c(selector) {
    if ($2126537420a3abf7$var$WINDOW.document && $2126537420a3abf7$var$WINDOW.document.querySelector) return $2126537420a3abf7$var$WINDOW.document.querySelector(selector);
    return null;
}

});
parcelRegister("fFQTh", function(module, exports) {

$parcel$export(module.exports, "isError", function () { return $b693b6565cfb6627$export$e6127cc7fe7395c3; });
$parcel$export(module.exports, "isInstanceOf", function () { return $b693b6565cfb6627$export$49034edbe6b62415; });
$parcel$export(module.exports, "isErrorEvent", function () { return $b693b6565cfb6627$export$9f9636d330b71954; });
$parcel$export(module.exports, "isDOMError", function () { return $b693b6565cfb6627$export$ef9e2056653f0c8e; });
$parcel$export(module.exports, "isDOMException", function () { return $b693b6565cfb6627$export$12e869b2a583f783; });
$parcel$export(module.exports, "isString", function () { return $b693b6565cfb6627$export$844ec244b1367d54; });
$parcel$export(module.exports, "isPrimitive", function () { return $b693b6565cfb6627$export$c3825b437cbdea5c; });
$parcel$export(module.exports, "isPlainObject", function () { return $b693b6565cfb6627$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "isEvent", function () { return $b693b6565cfb6627$export$9671ea99bd126ace; });
$parcel$export(module.exports, "isElement", function () { return $b693b6565cfb6627$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isRegExp", function () { return $b693b6565cfb6627$export$49841c62b9eff15; });
$parcel$export(module.exports, "isThenable", function () { return $b693b6565cfb6627$export$f5b060c2914b97c8; });
$parcel$export(module.exports, "isSyntheticEvent", function () { return $b693b6565cfb6627$export$bc2894c7158efbac; });
$parcel$export(module.exports, "isNaN", function () { return $b693b6565cfb6627$export$c9f5652083b8129d; });
$parcel$export(module.exports, "isVueViewModel", function () { return $b693b6565cfb6627$export$7916fad0ebc23f48; });
// eslint-disable-next-line @typescript-eslint/unbound-method
var $b693b6565cfb6627$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $b693b6565cfb6627$export$e6127cc7fe7395c3(wat) {
    switch($b693b6565cfb6627$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
            return true;
        default:
            return $b693b6565cfb6627$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $b693b6565cfb6627$var$isBuiltin(wat, className) {
    return $b693b6565cfb6627$var$objectToString.call(wat) === "[object ".concat(className, "]");
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $b693b6565cfb6627$export$9f9636d330b71954(wat) {
    return $b693b6565cfb6627$var$isBuiltin(wat, "ErrorEvent");
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $b693b6565cfb6627$export$ef9e2056653f0c8e(wat) {
    return $b693b6565cfb6627$var$isBuiltin(wat, "DOMError");
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $b693b6565cfb6627$export$12e869b2a583f783(wat) {
    return $b693b6565cfb6627$var$isBuiltin(wat, "DOMException");
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $b693b6565cfb6627$export$844ec244b1367d54(wat) {
    return $b693b6565cfb6627$var$isBuiltin(wat, "String");
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $b693b6565cfb6627$export$c3825b437cbdea5c(wat) {
    return wat === null || typeof wat !== "object" && typeof wat !== "function";
}
/**
 * Checks whether given value's type is an object literal
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $b693b6565cfb6627$export$53b83ca8eaab0383(wat) {
    return $b693b6565cfb6627$var$isBuiltin(wat, "Object");
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $b693b6565cfb6627$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $b693b6565cfb6627$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $b693b6565cfb6627$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $b693b6565cfb6627$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $b693b6565cfb6627$export$49841c62b9eff15(wat) {
    return $b693b6565cfb6627$var$isBuiltin(wat, "RegExp");
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $b693b6565cfb6627$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === "function");
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $b693b6565cfb6627$export$bc2894c7158efbac(wat) {
    return $b693b6565cfb6627$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $b693b6565cfb6627$export$c9f5652083b8129d(wat) {
    return typeof wat === "number" && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $b693b6565cfb6627$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $b693b6565cfb6627$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue));
}

});


parcelRegister("11858", function(module, exports) {

$parcel$export(module.exports, "truncate", function () { return $0bdc274ce2057a56$export$6a506b36fdea397d; });
$parcel$export(module.exports, "snipLine", function () { return $0bdc274ce2057a56$export$4215662d762d6f9d; });
$parcel$export(module.exports, "safeJoin", function () { return $0bdc274ce2057a56$export$465e9d514283d4fd; });
$parcel$export(module.exports, "stringMatchesSomePattern", function () { return $0bdc274ce2057a56$export$a7a5ec66062ea5d; });

var $fFQTh = parcelRequire("fFQTh");
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $0bdc274ce2057a56$export$6a506b36fdea397d(str) {
    var max = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : "".concat(str.slice(0, max), "...");
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $0bdc274ce2057a56$export$4215662d762d6f9d(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    var start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = "'{snip} ".concat(newLine);
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $0bdc274ce2057a56$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $fFQTh.isVueViewModel)(value)) output.push("[VueViewModel]");
            else output.push(String(value));
        } catch (e) {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $0bdc274ce2057a56$export$cdded5b28a5f8c6d(value, pattern) {
    var requireExactStringMatch = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (!(0, $fFQTh.isString)(value)) return false;
    if ((0, $fFQTh.isRegExp)(pattern)) return pattern.test(value);
    if ((0, $fFQTh.isString)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $0bdc274ce2057a56$export$a7a5ec66062ea5d(testString) {
    var patterns = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], requireExactStringMatch = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return patterns.some(function(pattern) {
        return $0bdc274ce2057a56$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch);
    });
}

});



parcelRegister("lqQO8", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ENVIRONMENT", function () { return $f9a4fd2c4fbc5ba7$export$849dbeeeda01ae98; });
var $f9a4fd2c4fbc5ba7$export$849dbeeeda01ae98 = "production";

});

parcelRegister("3Rd92", function(module, exports) {

$parcel$export(module.exports, "Scope", function () { return $2cf0849f1e204ed6$export$775b6bb06e53a214; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $3sHb8 = parcelRequire("3sHb8");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $c6Xmf = parcelRequire("c6Xmf");

var $9MzNF = parcelRequire("9MzNF");
var $kfF30 = parcelRequire("kfF30");
var $fFQTh = parcelRequire("fFQTh");

var $bCXHP = parcelRequire("bCXHP");

var $aBCNn = parcelRequire("aBCNn");
/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ var $2cf0849f1e204ed6$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ var $2cf0849f1e204ed6$export$775b6bb06e53a214 = /*#__PURE__*/ function() {
    "use strict";
    function Scope() {
        (0, $4GJKx._)(this, Scope);
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = $2cf0849f1e204ed6$var$generatePropagationContext();
    }
    (0, $1wc17._)(Scope, [
        {
            /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */ key: "addScopeListener",
            value: function addScopeListener(callback) {
                this._scopeListeners.push(callback);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "addEventProcessor",
            value: function addEventProcessor(callback) {
                this._eventProcessors.push(callback);
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setUser",
            value: function setUser(user) {
                this._user = user || {};
                if (this._session) (0, $aBCNn.updateSession)(this._session, {
                    user: user
                });
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getUser",
            value: function getUser() {
                return this._user;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getRequestSession",
            value: function getRequestSession() {
                return this._requestSession;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setRequestSession",
            value: function setRequestSession(requestSession) {
                this._requestSession = requestSession;
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setTags",
            value: function setTags(tags) {
                this._tags = (0, $do9pw._)({}, this._tags, tags);
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setTag",
            value: function setTag(key, value) {
                this._tags = (0, $cxjpp._)((0, $do9pw._)({}, this._tags), (0, $3sHb8._)({}, key, value));
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setExtras",
            value: function setExtras(extras) {
                this._extra = (0, $do9pw._)({}, this._extra, extras);
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setExtra",
            value: function setExtra(key, extra) {
                this._extra = (0, $cxjpp._)((0, $do9pw._)({}, this._extra), (0, $3sHb8._)({}, key, extra));
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setFingerprint",
            value: function setFingerprint(fingerprint) {
                this._fingerprint = fingerprint;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setLevel",
            value: function setLevel(// eslint-disable-next-line deprecation/deprecation
            level) {
                this._level = level;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setTransactionName",
            value: function setTransactionName(name) {
                this._transactionName = name;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setContext",
            value: function setContext(key, context) {
                if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                delete this._contexts[key];
                else this._contexts[key] = context;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setSpan",
            value: function setSpan(span) {
                this._span = span;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getSpan",
            value: function getSpan() {
                return this._span;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getTransaction",
            value: function getTransaction() {
                // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
                // have a pointer to the currently-active transaction.
                var span = this.getSpan();
                return span && span.transaction;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setSession",
            value: function setSession(session) {
                if (!session) delete this._session;
                else this._session = session;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getSession",
            value: function getSession() {
                return this._session;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "update",
            value: function update(captureContext) {
                if (!captureContext) return this;
                if (typeof captureContext === "function") {
                    var updatedScope = captureContext(this);
                    return updatedScope instanceof Scope ? updatedScope : this;
                }
                if (captureContext instanceof Scope) {
                    this._tags = (0, $do9pw._)({}, this._tags, captureContext._tags);
                    this._extra = (0, $do9pw._)({}, this._extra, captureContext._extra);
                    this._contexts = (0, $do9pw._)({}, this._contexts, captureContext._contexts);
                    if (captureContext._user && Object.keys(captureContext._user).length) this._user = captureContext._user;
                    if (captureContext._level) this._level = captureContext._level;
                    if (captureContext._fingerprint) this._fingerprint = captureContext._fingerprint;
                    if (captureContext._requestSession) this._requestSession = captureContext._requestSession;
                    if (captureContext._propagationContext) this._propagationContext = captureContext._propagationContext;
                } else if ((0, $fFQTh.isPlainObject)(captureContext)) {
                    // eslint-disable-next-line no-param-reassign
                    captureContext;
                    this._tags = (0, $do9pw._)({}, this._tags, captureContext.tags);
                    this._extra = (0, $do9pw._)({}, this._extra, captureContext.extra);
                    this._contexts = (0, $do9pw._)({}, this._contexts, captureContext.contexts);
                    if (captureContext.user) this._user = captureContext.user;
                    if (captureContext.level) this._level = captureContext.level;
                    if (captureContext.fingerprint) this._fingerprint = captureContext.fingerprint;
                    if (captureContext.requestSession) this._requestSession = captureContext.requestSession;
                    if (captureContext.propagationContext) this._propagationContext = captureContext.propagationContext;
                }
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "clear",
            value: function clear() {
                this._breadcrumbs = [];
                this._tags = {};
                this._extra = {};
                this._user = {};
                this._contexts = {};
                this._level = undefined;
                this._transactionName = undefined;
                this._fingerprint = undefined;
                this._requestSession = undefined;
                this._span = undefined;
                this._session = undefined;
                this._notifyScopeListeners();
                this._attachments = [];
                this._propagationContext = $2cf0849f1e204ed6$var$generatePropagationContext();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "addBreadcrumb",
            value: function addBreadcrumb(breadcrumb, maxBreadcrumbs) {
                var maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $2cf0849f1e204ed6$var$DEFAULT_MAX_BREADCRUMBS;
                // No data has been changed, so don't notify scope listeners
                if (maxCrumbs <= 0) return this;
                var mergedBreadcrumb = (0, $do9pw._)({
                    timestamp: (0, $kfF30.dateTimestampInSeconds)()
                }, breadcrumb);
                var breadcrumbs = this._breadcrumbs;
                breadcrumbs.push(mergedBreadcrumb);
                this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getLastBreadcrumb",
            value: function getLastBreadcrumb() {
                return this._breadcrumbs[this._breadcrumbs.length - 1];
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "clearBreadcrumbs",
            value: function clearBreadcrumbs() {
                this._breadcrumbs = [];
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "addAttachment",
            value: function addAttachment(attachment) {
                this._attachments.push(attachment);
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getAttachments",
            value: function getAttachments() {
                return this._attachments;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "clearAttachments",
            value: function clearAttachments() {
                this._attachments = [];
                return this;
            }
        },
        {
            /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   */ key: "applyToEvent",
            value: function applyToEvent(event) {
                var hint = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, additionalEventProcessors = arguments.length > 2 ? arguments[2] : void 0;
                if (this._extra && Object.keys(this._extra).length) event.extra = (0, $do9pw._)({}, this._extra, event.extra);
                if (this._tags && Object.keys(this._tags).length) event.tags = (0, $do9pw._)({}, this._tags, event.tags);
                if (this._user && Object.keys(this._user).length) event.user = (0, $do9pw._)({}, this._user, event.user);
                if (this._contexts && Object.keys(this._contexts).length) event.contexts = (0, $do9pw._)({}, this._contexts, event.contexts);
                if (this._level) event.level = this._level;
                if (this._transactionName) event.transaction = this._transactionName;
                // We want to set the trace context for normal events only if there isn't already
                // a trace context on the event. There is a product feature in place where we link
                // errors with transaction and it relies on that.
                if (this._span) {
                    event.contexts = (0, $do9pw._)({
                        trace: this._span.getTraceContext()
                    }, event.contexts);
                    var transaction = this._span.transaction;
                    if (transaction) {
                        event.sdkProcessingMetadata = (0, $do9pw._)({
                            dynamicSamplingContext: transaction.getDynamicSamplingContext()
                        }, event.sdkProcessingMetadata);
                        var transactionName = transaction.name;
                        if (transactionName) event.tags = (0, $do9pw._)({
                            transaction: transactionName
                        }, event.tags);
                    }
                }
                this._applyFingerprint(event);
                var scopeBreadcrumbs = this._getBreadcrumbs();
                var breadcrumbs = (0, $c6Xmf._)(event.breadcrumbs || []).concat((0, $c6Xmf._)(scopeBreadcrumbs));
                event.breadcrumbs = breadcrumbs.length > 0 ? breadcrumbs : undefined;
                event.sdkProcessingMetadata = (0, $cxjpp._)((0, $do9pw._)({}, event.sdkProcessingMetadata, this._sdkProcessingMetadata), {
                    propagationContext: this._propagationContext
                });
                // TODO (v8): Update this order to be: Global > Client > Scope
                return (0, $bCXHP.notifyEventProcessors)((0, $c6Xmf._)(additionalEventProcessors || []).concat((0, $c6Xmf._)((0, $bCXHP.getGlobalEventProcessors)()), (0, $c6Xmf._)(this._eventProcessors)), event, hint);
            }
        },
        {
            /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */ key: "setSDKProcessingMetadata",
            value: function setSDKProcessingMetadata(newData) {
                this._sdkProcessingMetadata = (0, $do9pw._)({}, this._sdkProcessingMetadata, newData);
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setPropagationContext",
            value: function setPropagationContext(context) {
                this._propagationContext = context;
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getPropagationContext",
            value: function getPropagationContext() {
                return this._propagationContext;
            }
        },
        {
            /**
   * Get the breadcrumbs for this scope.
   */ key: "_getBreadcrumbs",
            value: function _getBreadcrumbs() {
                return this._breadcrumbs;
            }
        },
        {
            /**
   * This will be called on every set call.
   */ key: "_notifyScopeListeners",
            value: function _notifyScopeListeners() {
                var _this = this;
                // We need this check for this._notifyingListeners to be able to work on scope during updates
                // If this check is not here we'll produce endless recursion when something is done with the scope
                // during the callback.
                if (!this._notifyingListeners) {
                    this._notifyingListeners = true;
                    this._scopeListeners.forEach(function(callback) {
                        callback(_this);
                    });
                    this._notifyingListeners = false;
                }
            }
        },
        {
            /**
   * Applies fingerprint from the scope to the event if there's one,
   * uses message if there's one instead or get rid of empty fingerprint
   */ key: "_applyFingerprint",
            value: function _applyFingerprint(event) {
                // Make sure it's an array first and we actually have something in place
                event.fingerprint = event.fingerprint ? (0, $9MzNF.arrayify)(event.fingerprint) : [];
                // If we have something on the scope, then merge it with event
                if (this._fingerprint) event.fingerprint = event.fingerprint.concat(this._fingerprint);
                // If we have no data at all, remove empty array default
                if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
            }
        }
    ], [
        {
            key: "clone",
            value: /**
   * Inherit values from the parent scope.
   * @param scope to clone.
   */ function clone(scope) {
                var newScope = new Scope();
                if (scope) {
                    newScope._breadcrumbs = (0, $c6Xmf._)(scope._breadcrumbs);
                    newScope._tags = (0, $do9pw._)({}, scope._tags);
                    newScope._extra = (0, $do9pw._)({}, scope._extra);
                    newScope._contexts = (0, $do9pw._)({}, scope._contexts);
                    newScope._user = scope._user;
                    newScope._level = scope._level;
                    newScope._span = scope._span;
                    newScope._session = scope._session;
                    newScope._transactionName = scope._transactionName;
                    newScope._fingerprint = scope._fingerprint;
                    newScope._eventProcessors = (0, $c6Xmf._)(scope._eventProcessors);
                    newScope._requestSession = scope._requestSession;
                    newScope._attachments = (0, $c6Xmf._)(scope._attachments);
                    newScope._sdkProcessingMetadata = (0, $do9pw._)({}, scope._sdkProcessingMetadata);
                    newScope._propagationContext = (0, $do9pw._)({}, scope._propagationContext);
                }
                return newScope;
            }
        }
    ]);
    return Scope;
}();
function $2cf0849f1e204ed6$var$generatePropagationContext() {
    return {
        traceId: (0, $9MzNF.uuid4)(),
        spanId: (0, $9MzNF.uuid4)().substring(16)
    };
}

});
parcelRegister("bCXHP", function(module, exports) {

$parcel$export(module.exports, "getGlobalEventProcessors", function () { return $87718ea641849488$export$3c4238858b85e8ac; });
$parcel$export(module.exports, "addGlobalEventProcessor", function () { return $87718ea641849488$export$8e4e25f54d456511; });
$parcel$export(module.exports, "notifyEventProcessors", function () { return $87718ea641849488$export$bf2a096c3e883e79; });

var $do9pw = parcelRequire("do9pw");

var $3rn7c = parcelRequire("3rn7c");
var $fFQTh = parcelRequire("fFQTh");
var $fNn7q = parcelRequire("fNn7q");
var $dvm65 = parcelRequire("dvm65");
/**
 * Returns the global event processors.
 */ function $87718ea641849488$export$3c4238858b85e8ac() {
    return (0, $3rn7c.getGlobalSingleton)("globalEventProcessors", function() {
        return [];
    });
}
/**
 * Add a EventProcessor to be kept globally.
 * @param callback EventProcessor to add
 */ function $87718ea641849488$export$8e4e25f54d456511(callback) {
    $87718ea641849488$export$3c4238858b85e8ac().push(callback);
}
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $87718ea641849488$export$bf2a096c3e883e79(processors, event, hint) {
    var index = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    return new (0, $dvm65.SyncPromise)(function(resolve, reject) {
        var processor = processors[index];
        if (event === null || typeof processor !== "function") resolve(event);
        else {
            var result = processor((0, $do9pw._)({}, event), hint);
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && processor.id && result === null && (0, $fNn7q.logger).log('Event processor "'.concat(processor.id, '" dropped event'));
            if ((0, $fFQTh.isThenable)(result)) result.then(function(final) {
                return $87718ea641849488$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve);
            }).then(null, reject);
            else $87718ea641849488$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}

});
parcelRegister("dvm65", function(module, exports) {

$parcel$export(module.exports, "resolvedSyncPromise", function () { return $9d4f4fa5d3f07d5d$export$1fda8aa4d135f8aa; });
$parcel$export(module.exports, "SyncPromise", function () { return $9d4f4fa5d3f07d5d$export$6f292d4960313241; });
$parcel$export(module.exports, "rejectedSyncPromise", function () { return $9d4f4fa5d3f07d5d$export$78e43115b553f358; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $fFQTh = parcelRequire("fFQTh");
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /** SyncPromise internal states */ var $9d4f4fa5d3f07d5d$var$States;
(function(States) {
    /** Pending */ var PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ var RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ var REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($9d4f4fa5d3f07d5d$var$States || ($9d4f4fa5d3f07d5d$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $9d4f4fa5d3f07d5d$export$1fda8aa4d135f8aa(value) {
    return new $9d4f4fa5d3f07d5d$export$6f292d4960313241(function(resolve) {
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $9d4f4fa5d3f07d5d$export$78e43115b553f358(reason) {
    return new $9d4f4fa5d3f07d5d$export$6f292d4960313241(function(_, reject) {
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ var $9d4f4fa5d3f07d5d$export$6f292d4960313241 = /*#__PURE__*/ function() {
    "use strict";
    function SyncPromise(executor) {
        (0, $4GJKx._)(this, SyncPromise);
        SyncPromise.prototype.__init.call(this);
        SyncPromise.prototype.__init2.call(this);
        SyncPromise.prototype.__init3.call(this);
        SyncPromise.prototype.__init4.call(this);
        this._state = $9d4f4fa5d3f07d5d$var$States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    (0, $1wc17._)(SyncPromise, [
        {
            /** JSDoc */ key: "then",
            value: function then(onfulfilled, onrejected) {
                var _this = this;
                return new SyncPromise(function(resolve, reject) {
                    _this._handlers.push([
                        false,
                        function(result) {
                            if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                            // TODO: FIXME
                            resolve(result);
                            else try {
                                resolve(onfulfilled(result));
                            } catch (e) {
                                reject(e);
                            }
                        },
                        function(reason) {
                            if (!onrejected) reject(reason);
                            else try {
                                resolve(onrejected(reason));
                            } catch (e) {
                                reject(e);
                            }
                        }
                    ]);
                    _this._executeHandlers();
                });
            }
        },
        {
            /** JSDoc */ key: "catch",
            value: function _catch(onrejected) {
                return this.then(function(val) {
                    return val;
                }, onrejected);
            }
        },
        {
            /** JSDoc */ key: "finally",
            value: function _finally(onfinally) {
                var _this = this;
                return new SyncPromise(function(resolve, reject) {
                    var val;
                    var isRejected;
                    return _this.then(function(value) {
                        isRejected = false;
                        val = value;
                        if (onfinally) onfinally();
                    }, function(reason) {
                        isRejected = true;
                        val = reason;
                        if (onfinally) onfinally();
                    }).then(function() {
                        if (isRejected) {
                            reject(val);
                            return;
                        }
                        resolve(val);
                    });
                });
            }
        },
        {
            /** JSDoc */ key: "__init",
            value: function __init() {
                var _this = this;
                this._resolve = function(value) {
                    _this._setResult($9d4f4fa5d3f07d5d$var$States.RESOLVED, value);
                };
            }
        },
        {
            /** JSDoc */ key: "__init2",
            value: function __init2() {
                var _this = this;
                this._reject = function(reason) {
                    _this._setResult($9d4f4fa5d3f07d5d$var$States.REJECTED, reason);
                };
            }
        },
        {
            /** JSDoc */ key: "__init3",
            value: function __init3() {
                var _this = this;
                this._setResult = function(state, value) {
                    if (_this._state !== $9d4f4fa5d3f07d5d$var$States.PENDING) return;
                    if ((0, $fFQTh.isThenable)(value)) {
                        value.then(_this._resolve, _this._reject);
                        return;
                    }
                    _this._state = state;
                    _this._value = value;
                    _this._executeHandlers();
                };
            }
        },
        {
            /** JSDoc */ key: "__init4",
            value: function __init4() {
                var _this = this;
                this._executeHandlers = function() {
                    if (_this._state === $9d4f4fa5d3f07d5d$var$States.PENDING) return;
                    var cachedHandlers = _this._handlers.slice();
                    _this._handlers = [];
                    cachedHandlers.forEach(function(handler) {
                        if (handler[0]) return;
                        if (_this._state === $9d4f4fa5d3f07d5d$var$States.RESOLVED) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                        handler[1](_this._value);
                        if (_this._state === $9d4f4fa5d3f07d5d$var$States.REJECTED) handler[2](_this._value);
                        handler[0] = true;
                    });
                };
            }
        }
    ]);
    return SyncPromise;
}();

});


parcelRegister("aBCNn", function(module, exports) {

$parcel$export(module.exports, "makeSession", function () { return $01fe1ec669932e3a$export$14a186326edbb264; });
$parcel$export(module.exports, "updateSession", function () { return $01fe1ec669932e3a$export$531818e825e774db; });
$parcel$export(module.exports, "closeSession", function () { return $01fe1ec669932e3a$export$56521d9ba90f62ee; });

var $9QLqp = parcelRequire("9QLqp");
var $kfF30 = parcelRequire("kfF30");
var $9MzNF = parcelRequire("9MzNF");
/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $01fe1ec669932e3a$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    var startingTime = (0, $kfF30.timestampInSeconds)();
    var session = {
        sid: (0, $9MzNF.uuid4)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: function() {
            return $01fe1ec669932e3a$var$sessionToJSON(session);
        }
    };
    if (context) $01fe1ec669932e3a$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $01fe1ec669932e3a$export$531818e825e774db(session) {
    var context = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $kfF30.timestampInSeconds)();
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $9MzNF.uuid4)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = "".concat(context.did);
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        var duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $01fe1ec669932e3a$export$56521d9ba90f62ee(session, status) {
    var context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $01fe1ec669932e3a$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $01fe1ec669932e3a$var$sessionToJSON(session) {
    return (0, $9QLqp.dropUndefinedKeys)({
        sid: "".concat(session.sid),
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? "".concat(session.did) : undefined,
        duration: session.duration,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}

});



parcelRegister("7cLK3", function(module, exports) {

$parcel$export(module.exports, "registerErrorInstrumentation", function () { return $53eeafe86d61cf31$export$637857c1d87b640c; });

var $MsrRH = parcelRequire("MsrRH");
var $fNn7q = parcelRequire("fNn7q");

var $8wQCP = parcelRequire("8wQCP");
var $53eeafe86d61cf31$var$errorsInstrumented = false;
/**
 * Configures global error listeners
 */ function $53eeafe86d61cf31$export$637857c1d87b640c() {
    if ($53eeafe86d61cf31$var$errorsInstrumented) return;
    $53eeafe86d61cf31$var$errorsInstrumented = true;
    (0, $MsrRH.addInstrumentationHandler)("error", $53eeafe86d61cf31$var$errorCallback);
    (0, $MsrRH.addInstrumentationHandler)("unhandledrejection", $53eeafe86d61cf31$var$errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */ function $53eeafe86d61cf31$var$errorCallback() {
    var activeTransaction = (0, $8wQCP.getActiveTransaction)();
    if (activeTransaction) {
        var status = "internal_error";
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).log("[Tracing] Transaction: ".concat(status, " -> Global error occured"));
        activeTransaction.setStatus(status);
    }
}
// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
$53eeafe86d61cf31$var$errorCallback.tag = "sentry_tracingErrorCallback";

});
parcelRegister("MsrRH", function(module, exports) {

$parcel$export(module.exports, "SENTRY_XHR_DATA_KEY", function () { return $091a8d139ed3907b$export$55b6bb1e45c6cf59; });
$parcel$export(module.exports, "addInstrumentationHandler", function () { return $091a8d139ed3907b$export$285b9172a3741fb7; });

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $cv9Rk = parcelRequire("cv9Rk");

var $fFQTh = parcelRequire("fFQTh");

var $fNn7q = parcelRequire("fNn7q");

var $9QLqp = parcelRequire("9QLqp");

var $5cx56 = parcelRequire("5cx56");

var $2D0U7 = parcelRequire("2D0U7");

var $3rn7c = parcelRequire("3rn7c");

var $2iCdx = parcelRequire("2iCdx");
// eslint-disable-next-line deprecation/deprecation
var $091a8d139ed3907b$var$WINDOW = (0, $3rn7c.getGlobalObject)();
var $091a8d139ed3907b$export$55b6bb1e45c6cf59 = "__sentry_xhr_v2__";
/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */ var $091a8d139ed3907b$var$handlers = {};
var $091a8d139ed3907b$var$instrumented = {};
/** Instruments given API */ function $091a8d139ed3907b$var$instrument(type) {
    if ($091a8d139ed3907b$var$instrumented[type]) return;
    $091a8d139ed3907b$var$instrumented[type] = true;
    switch(type){
        case "console":
            $091a8d139ed3907b$var$instrumentConsole();
            break;
        case "dom":
            $091a8d139ed3907b$export$3014bbf0af0e1d4a();
            break;
        case "xhr":
            $091a8d139ed3907b$export$c67d533bf77cbf54();
            break;
        case "fetch":
            $091a8d139ed3907b$var$instrumentFetch();
            break;
        case "history":
            $091a8d139ed3907b$var$instrumentHistory();
            break;
        case "error":
            $091a8d139ed3907b$var$instrumentError();
            break;
        case "unhandledrejection":
            $091a8d139ed3907b$var$instrumentUnhandledRejection();
            break;
        default:
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).warn("unknown instrumentation type:", type);
            return;
    }
}
/**
 * Add handler that will be called when given type of instrumentation triggers.
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $091a8d139ed3907b$export$285b9172a3741fb7(type, callback) {
    $091a8d139ed3907b$var$handlers[type] = $091a8d139ed3907b$var$handlers[type] || [];
    $091a8d139ed3907b$var$handlers[type].push(callback);
    $091a8d139ed3907b$var$instrument(type);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $091a8d139ed3907b$export$b17eab759a1cb5fe() {
    Object.keys($091a8d139ed3907b$var$handlers).forEach(function(key) {
        $091a8d139ed3907b$var$handlers[key] = undefined;
    });
}
/** JSDoc */ function $091a8d139ed3907b$var$triggerHandlers(type, data) {
    if (!type || !$091a8d139ed3907b$var$handlers[type]) return;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = ($091a8d139ed3907b$var$handlers[type] || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var handler = _step.value;
            try {
                handler(data);
            } catch (e) {
                (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).error("Error while triggering instrumentation handler.\nType: ".concat(type, "\nName: ").concat((0, $5cx56.getFunctionName)(handler), "\nError:"), e);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
/** JSDoc */ function $091a8d139ed3907b$var$instrumentConsole() {
    if (!("console" in (0, $3rn7c.GLOBAL_OBJ))) return;
    (0, $fNn7q.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in (0, $3rn7c.GLOBAL_OBJ).console)) return;
        (0, $9QLqp.fill)((0, $3rn7c.GLOBAL_OBJ).console, level, function(originalConsoleMethod) {
            (0, $fNn7q.originalConsoleMethods)[level] = originalConsoleMethod;
            return function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                $091a8d139ed3907b$var$triggerHandlers("console", {
                    args: args,
                    level: level
                });
                var log = (0, $fNn7q.originalConsoleMethods)[level];
                log && log.apply((0, $3rn7c.GLOBAL_OBJ).console, args);
            };
        });
    });
}
/** JSDoc */ function $091a8d139ed3907b$var$instrumentFetch() {
    if (!(0, $2D0U7.supportsNativeFetch)()) return;
    (0, $9QLqp.fill)((0, $3rn7c.GLOBAL_OBJ), "fetch", function(originalFetch) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _parseFetchArgs = $091a8d139ed3907b$export$f7a71163cc309d9a(args), method = _parseFetchArgs.method, url = _parseFetchArgs.url;
            var handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: Date.now()
            };
            $091a8d139ed3907b$var$triggerHandlers("fetch", (0, $do9pw._)({}, handlerData));
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $3rn7c.GLOBAL_OBJ), args).then(function(response) {
                $091a8d139ed3907b$var$triggerHandlers("fetch", (0, $cxjpp._)((0, $do9pw._)({}, handlerData), {
                    endTimestamp: Date.now(),
                    response: response
                }));
                return response;
            }, function(error) {
                $091a8d139ed3907b$var$triggerHandlers("fetch", (0, $cxjpp._)((0, $do9pw._)({}, handlerData), {
                    endTimestamp: Date.now(),
                    error: error
                }));
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
function $091a8d139ed3907b$var$hasProp(obj, prop) {
    return !!obj && typeof obj === "object" && !!obj[prop];
}
function $091a8d139ed3907b$var$getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if ($091a8d139ed3907b$var$hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request
 */ function $091a8d139ed3907b$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        var _fetchArgs = (0, $cv9Rk._)(fetchArgs, 2), url = _fetchArgs[0], options = _fetchArgs[1];
        return {
            url: $091a8d139ed3907b$var$getUrlFromResource(url),
            method: $091a8d139ed3907b$var$hasProp(options, "method") ? String(options.method).toUpperCase() : "GET"
        };
    }
    var arg = fetchArgs[0];
    return {
        url: $091a8d139ed3907b$var$getUrlFromResource(arg),
        method: $091a8d139ed3907b$var$hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}
/** JSDoc */ function $091a8d139ed3907b$export$c67d533bf77cbf54() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (!$091a8d139ed3907b$var$WINDOW.XMLHttpRequest) return;
    var xhrproto = XMLHttpRequest.prototype;
    (0, $9QLqp.fill)(xhrproto, "open", function(originalOpen) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _this = this;
            var url = args[1];
            var xhrInfo = this[$091a8d139ed3907b$export$55b6bb1e45c6cf59] = {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                method: (0, $fFQTh.isString)(args[0]) ? args[0].toUpperCase() : args[0],
                url: args[1],
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if ((0, $fFQTh.isString)(url) && xhrInfo.method === "POST" && url.match(/sentry_key/)) this.__sentry_own_request__ = true;
            var onreadystatechangeHandler = function() {
                // For whatever reason, this is not the same instance here as from the outer method
                var xhrInfo = _this[$091a8d139ed3907b$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (_this.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = _this.status;
                    } catch (e) {
                    /* do nothing */ }
                    $091a8d139ed3907b$var$triggerHandlers("xhr", {
                        args: args,
                        endTimestamp: Date.now(),
                        startTimestamp: Date.now(),
                        xhr: _this
                    });
                }
            };
            if ("onreadystatechange" in this && typeof this.onreadystatechange === "function") (0, $9QLqp.fill)(this, "onreadystatechange", function(original) {
                return function() {
                    for(var _len = arguments.length, readyStateArgs = new Array(_len), _key = 0; _key < _len; _key++){
                        readyStateArgs[_key] = arguments[_key];
                    }
                    onreadystatechangeHandler();
                    return original.apply(this, readyStateArgs);
                };
            });
            else this.addEventListener("readystatechange", onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            (0, $9QLqp.fill)(this, "setRequestHeader", function(original) {
                return function() {
                    for(var _len = arguments.length, setRequestHeaderArgs = new Array(_len), _key = 0; _key < _len; _key++){
                        setRequestHeaderArgs[_key] = arguments[_key];
                    }
                    var _setRequestHeaderArgs = (0, $cv9Rk._)(setRequestHeaderArgs, 2), header = _setRequestHeaderArgs[0], value = _setRequestHeaderArgs[1];
                    var xhrInfo = this[$091a8d139ed3907b$export$55b6bb1e45c6cf59];
                    if (xhrInfo) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return original.apply(this, setRequestHeaderArgs);
                };
            });
            return originalOpen.apply(this, args);
        };
    });
    (0, $9QLqp.fill)(xhrproto, "send", function(originalSend) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var sentryXhrData = this[$091a8d139ed3907b$export$55b6bb1e45c6cf59];
            if (sentryXhrData && args[0] !== undefined) sentryXhrData.body = args[0];
            $091a8d139ed3907b$var$triggerHandlers("xhr", {
                args: args,
                startTimestamp: Date.now(),
                xhr: this
            });
            return originalSend.apply(this, args);
        };
    });
}
var $091a8d139ed3907b$var$lastHref;
/** JSDoc */ function $091a8d139ed3907b$var$instrumentHistory() {
    if (!(0, $2iCdx.supportsHistory)()) return;
    var oldOnPopState = $091a8d139ed3907b$var$WINDOW.onpopstate;
    $091a8d139ed3907b$var$WINDOW.onpopstate = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var to = $091a8d139ed3907b$var$WINDOW.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        var from = $091a8d139ed3907b$var$lastHref;
        $091a8d139ed3907b$var$lastHref = to;
        $091a8d139ed3907b$var$triggerHandlers("history", {
            from: from,
            to: to
        });
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    /** @hidden */ function historyReplacementFunction(originalHistoryFunction) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                var from = $091a8d139ed3907b$var$lastHref;
                var to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $091a8d139ed3907b$var$lastHref = to;
                $091a8d139ed3907b$var$triggerHandlers("history", {
                    from: from,
                    to: to
                });
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $9QLqp.fill)($091a8d139ed3907b$var$WINDOW.history, "pushState", historyReplacementFunction);
    (0, $9QLqp.fill)($091a8d139ed3907b$var$WINDOW.history, "replaceState", historyReplacementFunction);
}
var $091a8d139ed3907b$var$DEBOUNCE_DURATION = 1000;
var $091a8d139ed3907b$var$debounceTimerID;
var $091a8d139ed3907b$var$lastCapturedEvent;
/**
 * Check whether two DOM events are similar to eachother. For example, two click events on the same button.
 */ function $091a8d139ed3907b$var$areSimilarDomEvents(a, b) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (a.type !== b.type) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (a.target !== b.target) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $091a8d139ed3907b$var$shouldSkipDOMEvent(event) {
    // We are only interested in filtering `keypress` events for now.
    if (event.type !== "keypress") return false;
    try {
        var target = event.target;
        if (!target || !target.tagName) return true;
        // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
        // e.g.tabbing through elements, hotkeys, etc.
        if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param handler function that will be triggered
 * @param globalListener indicates whether event was captured by the global event listener
 * @returns wrapped breadcrumb events handler
 * @hidden
 */ function $091a8d139ed3907b$var$makeDOMEventHandler(handler) {
    var globalListener = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return function(event) {
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event["_sentryCaptured"]) return;
        // We always want to skip _some_ events.
        if ($091a8d139ed3907b$var$shouldSkipDOMEvent(event)) return;
        // Mark event as "seen"
        (0, $9QLqp.addNonEnumerableProperty)(event, "_sentryCaptured", true);
        var name = event.type === "keypress" ? "input" : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if ($091a8d139ed3907b$var$lastCapturedEvent === undefined || !$091a8d139ed3907b$var$areSimilarDomEvents($091a8d139ed3907b$var$lastCapturedEvent, event)) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            $091a8d139ed3907b$var$lastCapturedEvent = event;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($091a8d139ed3907b$var$debounceTimerID);
        $091a8d139ed3907b$var$debounceTimerID = $091a8d139ed3907b$var$WINDOW.setTimeout(function() {
            $091a8d139ed3907b$var$lastCapturedEvent = undefined;
        }, $091a8d139ed3907b$var$DEBOUNCE_DURATION);
    };
}
/** JSDoc */ function $091a8d139ed3907b$export$3014bbf0af0e1d4a() {
    if (!$091a8d139ed3907b$var$WINDOW.document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    var triggerDOMHandler = $091a8d139ed3907b$var$triggerHandlers.bind(null, "dom");
    var globalDOMEventHandler = $091a8d139ed3907b$var$makeDOMEventHandler(triggerDOMHandler, true);
    $091a8d139ed3907b$var$WINDOW.document.addEventListener("click", globalDOMEventHandler, false);
    $091a8d139ed3907b$var$WINDOW.document.addEventListener("keypress", globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        "EventTarget",
        "Node"
    ].forEach(function(target) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        var proto = $091a8d139ed3907b$var$WINDOW[target] && $091a8d139ed3907b$var$WINDOW[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
        (0, $9QLqp.fill)(proto, "addEventListener", function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    var el = this;
                    var handlers = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    var handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        var handler = $091a8d139ed3907b$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $9QLqp.fill)(proto, "removeEventListener", function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    var el = this;
                    var handlers = el.__sentry_instrumentation_handlers__ || {};
                    var handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
var $091a8d139ed3907b$var$_oldOnErrorHandler = null;
/** JSDoc */ function $091a8d139ed3907b$var$instrumentError() {
    $091a8d139ed3907b$var$_oldOnErrorHandler = $091a8d139ed3907b$var$WINDOW.onerror;
    $091a8d139ed3907b$var$WINDOW.onerror = function(msg, url, line, column, error) {
        $091a8d139ed3907b$var$triggerHandlers("error", {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        });
        if ($091a8d139ed3907b$var$_oldOnErrorHandler && !$091a8d139ed3907b$var$_oldOnErrorHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $091a8d139ed3907b$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    $091a8d139ed3907b$var$WINDOW.onerror.__SENTRY_INSTRUMENTED__ = true;
}
var $091a8d139ed3907b$var$_oldOnUnhandledRejectionHandler = null;
/** JSDoc */ function $091a8d139ed3907b$var$instrumentUnhandledRejection() {
    $091a8d139ed3907b$var$_oldOnUnhandledRejectionHandler = $091a8d139ed3907b$var$WINDOW.onunhandledrejection;
    $091a8d139ed3907b$var$WINDOW.onunhandledrejection = function(e) {
        $091a8d139ed3907b$var$triggerHandlers("unhandledrejection", e);
        if ($091a8d139ed3907b$var$_oldOnUnhandledRejectionHandler && !$091a8d139ed3907b$var$_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $091a8d139ed3907b$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    $091a8d139ed3907b$var$WINDOW.onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}

});
parcelRegister("5cx56", function(module, exports) {

$parcel$export(module.exports, "createStackParser", function () { return $3c97bc02b6850b64$export$a5739666fb2d03d4; });
$parcel$export(module.exports, "stackParserFromStackParserOptions", function () { return $3c97bc02b6850b64$export$1d5cf88b347146d4; });
$parcel$export(module.exports, "getFunctionName", function () { return $3c97bc02b6850b64$export$aad197c7121a6651; });

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $c6Xmf = parcelRequire("c6Xmf");

var $d4w3k = parcelRequire("d4w3k");
var $3c97bc02b6850b64$var$STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
var $3c97bc02b6850b64$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
var $3c97bc02b6850b64$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $3c97bc02b6850b64$export$a5739666fb2d03d4() {
    for(var _len = arguments.length, parsers = new Array(_len), _key = 0; _key < _len; _key++){
        parsers[_key] = arguments[_key];
    }
    var sortedParsers = parsers.sort(function(a, b) {
        return a[0] - b[0];
    }).map(function(p) {
        return p[1];
    });
    return function(stack) {
        var skipFirst = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        var frames = [];
        var lines = stack.split("\n");
        for(var i = skipFirst; i < lines.length; i++){
            var line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            var cleanedLine = $3c97bc02b6850b64$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($3c97bc02b6850b64$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = sortedParsers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var parser = _step.value;
                    var frame = parser(cleanedLine);
                    if (frame) {
                        frames.push(frame);
                        break;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            if (frames.length >= $3c97bc02b6850b64$var$STACKTRACE_FRAME_LIMIT) break;
        }
        return $3c97bc02b6850b64$export$c55c24c0eeba0205(frames);
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $3c97bc02b6850b64$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $3c97bc02b6850b64$export$a5739666fb2d03d4.apply(void 0, (0, $c6Xmf._)(stackParser));
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $3c97bc02b6850b64$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    var localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test(localStack[localStack.length - 1].function || "")) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($3c97bc02b6850b64$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($3c97bc02b6850b64$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) localStack.pop();
    }
    return localStack.slice(0, $3c97bc02b6850b64$var$STACKTRACE_FRAME_LIMIT).map(function(frame) {
        return (0, $cxjpp._)((0, $do9pw._)({}, frame), {
            filename: frame.filename || localStack[localStack.length - 1].filename,
            function: frame.function || "?"
        });
    });
}
var $3c97bc02b6850b64$var$defaultFunctionName = "<anonymous>";
/**
 * Safely extract function name from itself
 */ function $3c97bc02b6850b64$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $3c97bc02b6850b64$var$defaultFunctionName;
        return fn.name || $3c97bc02b6850b64$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $3c97bc02b6850b64$var$defaultFunctionName;
    }
}
/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */ function $3c97bc02b6850b64$export$673345a0da635a78(getModule) {
    return [
        90,
        (0, $d4w3k.node)(getModule)
    ];
}

});
parcelRegister("d4w3k", function(module, exports) {

$parcel$export(module.exports, "node", function () { return $984483114f97b5af$export$35059013cd4a06db; });
/**
 * Does this filename look like it's part of the app code?
 */ function $984483114f97b5af$export$1de92f38f4de99a8(filename) {
    var isNative = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var isInternal = isNative || filename && // It's not internal if it's an absolute linux path
    !filename.startsWith("/") && // It's not internal if it's an absolute windows path
    !filename.includes(":\\") && // It's not internal if the path is starting with a dot
    !filename.startsWith(".") && // It's not internal if the frame has a protocol. In node, this is usually the case if the file got pre-processed with a bundler like webpack
    !filename.match(/^[a-zA-Z]([a-zA-Z0-9.\-+])*:\/\//); // Schema from: https://stackoverflow.com/a/3641782
    // in_app is all that's not an internal Node function or a module within node_modules
    // note that isNative appears to return true even for node core libraries
    // see https://github.com/getsentry/raven-node/issues/176
    return !isInternal && filename !== undefined && !filename.includes("node_modules/");
}
/** Node Stack line parser */ // eslint-disable-next-line complexity
function $984483114f97b5af$export$35059013cd4a06db(getModule) {
    var FILENAME_MATCH = /^\s*[-]{4,}$/;
    var FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;
    // eslint-disable-next-line complexity
    return function(line) {
        var lineMatch = line.match(FULL_MATCH);
        if (lineMatch) {
            var object;
            var method;
            var functionName;
            var typeName;
            var methodName;
            if (lineMatch[1]) {
                functionName = lineMatch[1];
                var methodStart = functionName.lastIndexOf(".");
                if (functionName[methodStart - 1] === ".") methodStart--;
                if (methodStart > 0) {
                    object = functionName.slice(0, methodStart);
                    method = functionName.slice(methodStart + 1);
                    var objectEnd = object.indexOf(".Module");
                    if (objectEnd > 0) {
                        functionName = functionName.slice(objectEnd + 1);
                        object = object.slice(0, objectEnd);
                    }
                }
                typeName = undefined;
            }
            if (method) {
                typeName = object;
                methodName = method;
            }
            if (method === "<anonymous>") {
                methodName = undefined;
                functionName = undefined;
            }
            if (functionName === undefined) {
                methodName = methodName || "<anonymous>";
                functionName = typeName ? "".concat(typeName, ".").concat(methodName) : methodName;
            }
            var filename = lineMatch[2] && lineMatch[2].startsWith("file://") ? lineMatch[2].slice(7) : lineMatch[2];
            var isNative = lineMatch[5] === "native";
            if (!filename && lineMatch[5] && !isNative) filename = lineMatch[5];
            return {
                filename: filename,
                module: getModule ? getModule(filename) : undefined,
                function: functionName,
                lineno: parseInt(lineMatch[3], 10) || undefined,
                colno: parseInt(lineMatch[4], 10) || undefined,
                in_app: $984483114f97b5af$export$1de92f38f4de99a8(filename, isNative)
            };
        }
        if (line.match(FILENAME_MATCH)) return {
            filename: line
        };
        return undefined;
    };
}

});


parcelRegister("2D0U7", function(module, exports) {

$parcel$export(module.exports, "supportsFetch", function () { return $1e9fecd353fbc722$export$edf3cb81fd7d2a3e; });
$parcel$export(module.exports, "isNativeFetch", function () { return $1e9fecd353fbc722$export$18cf36ed71d733e7; });
$parcel$export(module.exports, "supportsNativeFetch", function () { return $1e9fecd353fbc722$export$c82d238e23c40b21; });

var $fNn7q = parcelRequire("fNn7q");

var $3rn7c = parcelRequire("3rn7c");
// eslint-disable-next-line deprecation/deprecation
var $1e9fecd353fbc722$var$WINDOW = (0, $3rn7c.getGlobalObject)();
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $1e9fecd353fbc722$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $1e9fecd353fbc722$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $1e9fecd353fbc722$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $1e9fecd353fbc722$export$edf3cb81fd7d2a3e() {
    if (!("fetch" in $1e9fecd353fbc722$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("http://www.example.com");
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $1e9fecd353fbc722$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $1e9fecd353fbc722$export$c82d238e23c40b21() {
    if (!$1e9fecd353fbc722$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($1e9fecd353fbc722$export$18cf36ed71d733e7($1e9fecd353fbc722$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    var result = false;
    var doc = $1e9fecd353fbc722$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === "function") try {
        var sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $1e9fecd353fbc722$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $1e9fecd353fbc722$export$531055a6c684a70a() {
    return "ReportingObserver" in $1e9fecd353fbc722$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $1e9fecd353fbc722$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$1e9fecd353fbc722$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch (e) {
        return false;
    }
}

});

parcelRegister("2iCdx", function(module, exports) {

$parcel$export(module.exports, "supportsHistory", function () { return $1acae85f4c2edf9b$export$67fc34576016d6ec; });

var $3rn7c = parcelRequire("3rn7c");
// Based on https://github.com/angular/angular.js/pull/13945/files
// eslint-disable-next-line deprecation/deprecation
var $1acae85f4c2edf9b$var$WINDOW = (0, $3rn7c.getGlobalObject)();
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $1acae85f4c2edf9b$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var chrome = $1acae85f4c2edf9b$var$WINDOW.chrome;
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ var hasHistoryApi = "history" in $1acae85f4c2edf9b$var$WINDOW && !!$1acae85f4c2edf9b$var$WINDOW.history.pushState && !!$1acae85f4c2edf9b$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}

});


parcelRegister("8wQCP", function(module, exports) {

$parcel$export(module.exports, "getActiveTransaction", function () { return $635a222a336ba196$export$a7feb32fdd923295; });

var $1uvy1 = parcelRequire("1uvy1");

/** Grabs active transaction off scope, if any */ function $635a222a336ba196$export$a7feb32fdd923295(maybeHub) {
    var hub = maybeHub || (0, $1uvy1.getCurrentHub)();
    var scope = hub.getScope();
    return scope.getTransaction();
}

});


parcelRegister("lYB5d", function(module, exports) {

$parcel$export(module.exports, "TRACING_DEFAULTS", function () { return $fffbf78276c2eb16$export$809a2b7987fd5306; });
$parcel$export(module.exports, "IdleTransaction", function () { return $fffbf78276c2eb16$export$b279e6bd7040371f; });

var $d3H5E = parcelRequire("d3H5E");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $04RAu = parcelRequire("04RAu");

var $b8Rim = parcelRequire("b8Rim");

var $dcsZi = parcelRequire("dcsZi");

var $ohfOJ = parcelRequire("ohfOJ");

var $fNn7q = parcelRequire("fNn7q");
var $kfF30 = parcelRequire("kfF30");

var $cMfbJ = parcelRequire("cMfbJ");

var $cxSLN = parcelRequire("cxSLN");
var $fffbf78276c2eb16$export$809a2b7987fd5306 = {
    idleTimeout: 1000,
    finalTimeout: 30000,
    heartbeatInterval: 5000
};
var $fffbf78276c2eb16$var$FINISH_REASON_TAG = "finishReason";
var $fffbf78276c2eb16$var$IDLE_TRANSACTION_FINISH_REASONS = [
    "heartbeatFailed",
    "idleTimeout",
    "documentHidden",
    "finalTimeout",
    "externalFinish",
    "cancelled"
];
/**
 * @inheritDoc
 */ var $fffbf78276c2eb16$export$370d6113c18ba86c = /*#__PURE__*/ function(SpanRecorder) {
    "use strict";
    (0, $dcsZi._)(IdleTransactionSpanRecorder, SpanRecorder);
    var _super = (0, $ohfOJ._)(IdleTransactionSpanRecorder);
    function IdleTransactionSpanRecorder(_pushActivity, _popActivity, transactionSpanId, maxlen) {
        (0, $4GJKx._)(this, IdleTransactionSpanRecorder);
        var _this;
        _this = _super.call(this, maxlen);
        _this._pushActivity = _pushActivity;
        _this._popActivity = _popActivity;
        _this.transactionSpanId = transactionSpanId;
        return _this;
    }
    (0, $1wc17._)(IdleTransactionSpanRecorder, [
        {
            /**
   * @inheritDoc
   */ key: "add",
            value: function add(span) {
                var _this = this;
                // We should make sure we do not push and pop activities for
                // the transaction that this span recorder belongs to.
                if (span.spanId !== this.transactionSpanId) {
                    // We patch span.finish() to pop an activity after setting an endTimestamp.
                    span.finish = function(endTimestamp) {
                        span.endTimestamp = typeof endTimestamp === "number" ? endTimestamp : (0, $kfF30.timestampInSeconds)();
                        _this._popActivity(span.spanId);
                    };
                    // We should only push new activities if the span does not have an end timestamp.
                    if (span.endTimestamp === undefined) this._pushActivity(span.spanId);
                }
                (0, $04RAu._)((0, $b8Rim._)(IdleTransactionSpanRecorder.prototype), "add", this).call(this, span);
            }
        }
    ]);
    return IdleTransactionSpanRecorder;
}((0, $cMfbJ.SpanRecorder));
/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */ var $fffbf78276c2eb16$export$b279e6bd7040371f = /*#__PURE__*/ function(Transaction) {
    "use strict";
    (0, $dcsZi._)(IdleTransaction, Transaction);
    var _super = (0, $ohfOJ._)(IdleTransaction);
    function IdleTransaction(transactionContext, _idleHub) {
        var /**
     * The time to wait in ms until the idle transaction will be finished. This timer is started each time
     * there are no active spans on this transaction.
     */ _idleTimeout = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $fffbf78276c2eb16$export$809a2b7987fd5306.idleTimeout, /**
     * The final value in ms that a transaction cannot exceed
     */ _finalTimeout = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $fffbf78276c2eb16$export$809a2b7987fd5306.finalTimeout, _heartbeatInterval = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : $fffbf78276c2eb16$export$809a2b7987fd5306.heartbeatInterval, // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
        _onScope = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false;
        (0, $4GJKx._)(this, IdleTransaction);
        var _this;
        _this = _super.call(this, transactionContext, _idleHub);
        _this._idleHub = _idleHub;
        _this._idleTimeout = _idleTimeout;
        _this._finalTimeout = _finalTimeout;
        _this._heartbeatInterval = _heartbeatInterval;
        _this._onScope = _onScope;
        _this.activities = {};
        _this._heartbeatCounter = 0;
        _this._finished = false;
        _this._idleTimeoutCanceledPermanently = false;
        _this._beforeFinishCallbacks = [];
        _this._finishReason = $fffbf78276c2eb16$var$IDLE_TRANSACTION_FINISH_REASONS[4];
        if (_onScope) {
            // We set the transaction here on the scope so error events pick up the trace
            // context and attach it to the error.
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).log("Setting idle transaction on scope. Span ID: ".concat(_this.spanId));
            _idleHub.configureScope(function(scope) {
                return scope.setSpan((0, $d3H5E._)(_this));
            });
        }
        _this._restartIdleTimeout();
        setTimeout(function() {
            if (!_this._finished) {
                _this.setStatus("deadline_exceeded");
                _this._finishReason = $fffbf78276c2eb16$var$IDLE_TRANSACTION_FINISH_REASONS[3];
                _this.finish();
            }
        }, _this._finalTimeout);
        return _this;
    }
    (0, $1wc17._)(IdleTransaction, [
        {
            /** {@inheritDoc} */ key: "finish",
            value: function finish() {
                var endTimestamp = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $kfF30.timestampInSeconds)();
                var _this = this;
                this._finished = true;
                this.activities = {};
                if (this.op === "ui.action.click") this.setTag($fffbf78276c2eb16$var$FINISH_REASON_TAG, this._finishReason);
                if (this.spanRecorder) {
                    (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).log("[Tracing] finishing IdleTransaction", new Date(endTimestamp * 1000).toISOString(), this.op);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = this._beforeFinishCallbacks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var callback = _step.value;
                            callback(this, endTimestamp);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    this.spanRecorder.spans = this.spanRecorder.spans.filter(function(span) {
                        // If we are dealing with the transaction itself, we just return it
                        if (span.spanId === _this.spanId) return true;
                        // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
                        if (!span.endTimestamp) {
                            span.endTimestamp = endTimestamp;
                            span.setStatus("cancelled");
                            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).log("[Tracing] cancelling span since transaction ended early", JSON.stringify(span, undefined, 2));
                        }
                        var spanStartedBeforeTransactionFinish = span.startTimestamp < endTimestamp;
                        // Add a delta with idle timeout so that we prevent false positives
                        var timeoutWithMarginOfError = (_this._finalTimeout + _this._idleTimeout) / 1000;
                        var spanEndedBeforeFinalTimeout = span.endTimestamp - _this.startTimestamp < timeoutWithMarginOfError;
                        if (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) {
                            var stringifiedSpan = JSON.stringify(span, undefined, 2);
                            if (!spanStartedBeforeTransactionFinish) (0, $fNn7q.logger).log("[Tracing] discarding Span since it happened after Transaction was finished", stringifiedSpan);
                            else if (!spanEndedBeforeFinalTimeout) (0, $fNn7q.logger).log("[Tracing] discarding Span since it finished after Transaction final timeout", stringifiedSpan);
                        }
                        return spanStartedBeforeTransactionFinish && spanEndedBeforeFinalTimeout;
                    });
                    (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).log("[Tracing] flushing IdleTransaction");
                } else (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).log("[Tracing] No active IdleTransaction");
                // if `this._onScope` is `true`, the transaction put itself on the scope when it started
                if (this._onScope) {
                    var scope = this._idleHub.getScope();
                    if (scope.getTransaction() === this) scope.setSpan(undefined);
                }
                return (0, $04RAu._)((0, $b8Rim._)(IdleTransaction.prototype), "finish", this).call(this, endTimestamp);
            }
        },
        {
            /**
   * Register a callback function that gets excecuted before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */ key: "registerBeforeFinishCallback",
            value: function registerBeforeFinishCallback(callback) {
                this._beforeFinishCallbacks.push(callback);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "initSpanRecorder",
            value: function initSpanRecorder(maxlen) {
                var _this = this;
                if (!this.spanRecorder) {
                    var pushActivity = function(id) {
                        if (_this._finished) return;
                        _this._pushActivity(id);
                    };
                    var popActivity = function(id) {
                        if (_this._finished) return;
                        _this._popActivity(id);
                    };
                    this.spanRecorder = new $fffbf78276c2eb16$export$370d6113c18ba86c(pushActivity, popActivity, this.spanId, maxlen);
                    // Start heartbeat so that transactions do not run forever.
                    (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).log("Starting heartbeat");
                    this._pingHeartbeat();
                }
                this.spanRecorder.add(this);
            }
        },
        {
            /**
   * Cancels the existing idle timeout, if there is one.
   * @param restartOnChildSpanChange Default is `true`.
   *                                 If set to false the transaction will end
   *                                 with the last child span.
   */ key: "cancelIdleTimeout",
            value: function cancelIdleTimeout(endTimestamp) {
                var restartOnChildSpanChange = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
                    restartOnChildSpanChange: true
                }).restartOnChildSpanChange;
                this._idleTimeoutCanceledPermanently = restartOnChildSpanChange === false;
                if (this._idleTimeoutID) {
                    clearTimeout(this._idleTimeoutID);
                    this._idleTimeoutID = undefined;
                    if (Object.keys(this.activities).length === 0 && this._idleTimeoutCanceledPermanently) {
                        this._finishReason = $fffbf78276c2eb16$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                        this.finish(endTimestamp);
                    }
                }
            }
        },
        {
            /**
   * Temporary method used to externally set the transaction's `finishReason`
   *
   * ** WARNING**
   * This is for the purpose of experimentation only and will be removed in the near future, do not use!
   *
   * @internal
   *
   */ key: "setFinishReason",
            value: function setFinishReason(reason) {
                this._finishReason = reason;
            }
        },
        {
            /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */ key: "_restartIdleTimeout",
            value: function _restartIdleTimeout(endTimestamp) {
                var _this = this;
                this.cancelIdleTimeout();
                this._idleTimeoutID = setTimeout(function() {
                    if (!_this._finished && Object.keys(_this.activities).length === 0) {
                        _this._finishReason = $fffbf78276c2eb16$var$IDLE_TRANSACTION_FINISH_REASONS[1];
                        _this.finish(endTimestamp);
                    }
                }, this._idleTimeout);
            }
        },
        {
            /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ key: "_pushActivity",
            value: function _pushActivity(spanId) {
                this.cancelIdleTimeout(undefined, {
                    restartOnChildSpanChange: !this._idleTimeoutCanceledPermanently
                });
                (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).log("[Tracing] pushActivity: ".concat(spanId));
                this.activities[spanId] = true;
                (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).log("[Tracing] new activities count", Object.keys(this.activities).length);
            }
        },
        {
            /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ key: "_popActivity",
            value: function _popActivity(spanId) {
                if (this.activities[spanId]) {
                    (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).log("[Tracing] popActivity ".concat(spanId));
                    // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                    delete this.activities[spanId];
                    (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).log("[Tracing] new activities count", Object.keys(this.activities).length);
                }
                if (Object.keys(this.activities).length === 0) {
                    var endTimestamp = (0, $kfF30.timestampInSeconds)();
                    if (this._idleTimeoutCanceledPermanently) {
                        this._finishReason = $fffbf78276c2eb16$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                        this.finish(endTimestamp);
                    } else // We need to add the timeout here to have the real endtimestamp of the transaction
                    // Remember timestampInSeconds is in seconds, timeout is in ms
                    this._restartIdleTimeout(endTimestamp + this._idleTimeout / 1000);
                }
            }
        },
        {
            /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */ key: "_beat",
            value: function _beat() {
                // We should not be running heartbeat if the idle transaction is finished.
                if (this._finished) return;
                var heartbeatString = Object.keys(this.activities).join("");
                if (heartbeatString === this._prevHeartbeatString) this._heartbeatCounter++;
                else this._heartbeatCounter = 1;
                this._prevHeartbeatString = heartbeatString;
                if (this._heartbeatCounter >= 3) {
                    (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).log("[Tracing] Transaction finished because of no change for 3 heart beats");
                    this.setStatus("deadline_exceeded");
                    this._finishReason = $fffbf78276c2eb16$var$IDLE_TRANSACTION_FINISH_REASONS[0];
                    this.finish();
                } else this._pingHeartbeat();
            }
        },
        {
            /**
   * Pings the heartbeat
   */ key: "_pingHeartbeat",
            value: function _pingHeartbeat() {
                var _this = this;
                (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).log("pinging Heartbeat -> current counter: ".concat(this._heartbeatCounter));
                setTimeout(function() {
                    _this._beat();
                }, this._heartbeatInterval);
            }
        }
    ]);
    return IdleTransaction;
}((0, $cxSLN.Transaction));

});
parcelRegister("04RAu", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $00e9f136d8b86c33$export$afb3516d9d608401; });

var $9Fj1i = parcelRequire("9Fj1i");
function $00e9f136d8b86c33$export$afb3516d9d608401(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $00e9f136d8b86c33$export$afb3516d9d608401 = Reflect.get;
    else $00e9f136d8b86c33$export$afb3516d9d608401 = function get(target, property, receiver) {
        var base = (0, $9Fj1i._super_prop_base)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $00e9f136d8b86c33$export$afb3516d9d608401(target, property, receiver || target);
}

});
parcelRegister("9Fj1i", function(module, exports) {

$parcel$export(module.exports, "_super_prop_base", function () { return $7096b25b59c4b2c1$export$e4187255aefbc259; });

var $b8Rim = parcelRequire("b8Rim");
function $7096b25b59c4b2c1$export$e4187255aefbc259(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $b8Rim._get_prototype_of)(object);
        if (object === null) break;
    }
    return object;
}

});


parcelRegister("cMfbJ", function(module, exports) {

$parcel$export(module.exports, "SpanRecorder", function () { return $94d5bfc5d2baadaf$export$10c95c129cd0d4fe; });
$parcel$export(module.exports, "Span", function () { return $94d5bfc5d2baadaf$export$5f1714a13ed34c01; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $3sHb8 = parcelRequire("3sHb8");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $9QLqp = parcelRequire("9QLqp");
var $eedhm = parcelRequire("eedhm");
var $fNn7q = parcelRequire("fNn7q");
var $kfF30 = parcelRequire("kfF30");
var $9MzNF = parcelRequire("9MzNF");
/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */ var $94d5bfc5d2baadaf$export$10c95c129cd0d4fe = /*#__PURE__*/ function() {
    "use strict";
    function SpanRecorder() {
        var maxlen = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1000;
        (0, $4GJKx._)(this, SpanRecorder);
        this._maxlen = maxlen;
        this.spans = [];
    }
    (0, $1wc17._)(SpanRecorder, [
        {
            /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */ key: "add",
            value: function add(span) {
                if (this.spans.length > this._maxlen) span.spanRecorder = undefined;
                else this.spans.push(span);
            }
        }
    ]);
    return SpanRecorder;
}();
/**
 * Span contains all data about a span
 */ var $94d5bfc5d2baadaf$export$5f1714a13ed34c01 = /*#__PURE__*/ function() {
    "use strict";
    function Span() {
        var spanContext = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, $4GJKx._)(this, Span);
        this.traceId = spanContext.traceId || (0, $9MzNF.uuid4)();
        this.spanId = spanContext.spanId || (0, $9MzNF.uuid4)().substring(16);
        this.startTimestamp = spanContext.startTimestamp || (0, $kfF30.timestampInSeconds)();
        this.tags = spanContext.tags || {};
        this.data = spanContext.data || {};
        this.instrumenter = spanContext.instrumenter || "sentry";
        this.origin = spanContext.origin || "manual";
        if (spanContext.parentSpanId) this.parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ("sampled" in spanContext) this.sampled = spanContext.sampled;
        if (spanContext.op) this.op = spanContext.op;
        if (spanContext.description) this.description = spanContext.description;
        if (spanContext.name) this.description = spanContext.name;
        if (spanContext.status) this.status = spanContext.status;
        if (spanContext.endTimestamp) this.endTimestamp = spanContext.endTimestamp;
    }
    (0, $1wc17._)(Span, [
        {
            key: "name",
            get: /** An alias for `description` of the Span. */ function get() {
                return this.description || "";
            },
            set: /** Update the name of the span. */ function set(name) {
                this.setName(name);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "startChild",
            value: function startChild(spanContext) {
                var childSpan = new Span((0, $cxjpp._)((0, $do9pw._)({}, spanContext), {
                    parentSpanId: this.spanId,
                    sampled: this.sampled,
                    traceId: this.traceId
                }));
                childSpan.spanRecorder = this.spanRecorder;
                if (childSpan.spanRecorder) childSpan.spanRecorder.add(childSpan);
                childSpan.transaction = this.transaction;
                if ((typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && childSpan.transaction) {
                    var opStr = spanContext && spanContext.op || "< unknown op >";
                    var nameStr = childSpan.transaction.name || "< unknown name >";
                    var idStr = childSpan.transaction.spanId;
                    var logMessage = "[Tracing] Starting '".concat(opStr, "' span on transaction '").concat(nameStr, "' (").concat(idStr, ").");
                    childSpan.transaction.metadata.spanMetadata[childSpan.spanId] = {
                        logMessage: logMessage
                    };
                    (0, $fNn7q.logger).log(logMessage);
                }
                return childSpan;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setTag",
            value: function setTag(key, value) {
                this.tags = (0, $cxjpp._)((0, $do9pw._)({}, this.tags), (0, $3sHb8._)({}, key, value));
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
            key: "setData",
            value: function setData(key, value) {
                this.data = (0, $cxjpp._)((0, $do9pw._)({}, this.data), (0, $3sHb8._)({}, key, value));
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setStatus",
            value: function setStatus(value) {
                this.status = value;
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setHttpStatus",
            value: function setHttpStatus(httpStatus) {
                this.setTag("http.status_code", String(httpStatus));
                this.setData("http.response.status_code", httpStatus);
                var spanStatus = $94d5bfc5d2baadaf$export$ac65c70d78fcdb55(httpStatus);
                if (spanStatus !== "unknown_error") this.setStatus(spanStatus);
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setName",
            value: function setName(name) {
                this.description = name;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "isSuccess",
            value: function isSuccess() {
                return this.status === "ok";
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "finish",
            value: function finish(endTimestamp) {
                if ((typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && // Don't call this for transactions
                this.transaction && this.transaction.spanId !== this.spanId) {
                    var logMessage = this.transaction.metadata.spanMetadata[this.spanId].logMessage;
                    if (logMessage) (0, $fNn7q.logger).log(logMessage.replace("Starting", "Finishing"));
                }
                this.endTimestamp = typeof endTimestamp === "number" ? endTimestamp : (0, $kfF30.timestampInSeconds)();
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "toTraceparent",
            value: function toTraceparent() {
                return (0, $eedhm.generateSentryTraceHeader)(this.traceId, this.spanId, this.sampled);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "toContext",
            value: function toContext() {
                return (0, $9QLqp.dropUndefinedKeys)({
                    data: this.data,
                    description: this.description,
                    endTimestamp: this.endTimestamp,
                    op: this.op,
                    parentSpanId: this.parentSpanId,
                    sampled: this.sampled,
                    spanId: this.spanId,
                    startTimestamp: this.startTimestamp,
                    status: this.status,
                    tags: this.tags,
                    traceId: this.traceId
                });
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "updateWithContext",
            value: function updateWithContext(spanContext) {
                this.data = spanContext.data || {};
                this.description = spanContext.description;
                this.endTimestamp = spanContext.endTimestamp;
                this.op = spanContext.op;
                this.parentSpanId = spanContext.parentSpanId;
                this.sampled = spanContext.sampled;
                this.spanId = spanContext.spanId || this.spanId;
                this.startTimestamp = spanContext.startTimestamp || this.startTimestamp;
                this.status = spanContext.status;
                this.tags = spanContext.tags || {};
                this.traceId = spanContext.traceId || this.traceId;
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getTraceContext",
            value: function getTraceContext() {
                return (0, $9QLqp.dropUndefinedKeys)({
                    data: Object.keys(this.data).length > 0 ? this.data : undefined,
                    description: this.description,
                    op: this.op,
                    parent_span_id: this.parentSpanId,
                    span_id: this.spanId,
                    status: this.status,
                    tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
                    trace_id: this.traceId
                });
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "toJSON",
            value: function toJSON() {
                return (0, $9QLqp.dropUndefinedKeys)({
                    data: Object.keys(this.data).length > 0 ? this.data : undefined,
                    description: this.description,
                    op: this.op,
                    parent_span_id: this.parentSpanId,
                    span_id: this.spanId,
                    start_timestamp: this.startTimestamp,
                    status: this.status,
                    tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
                    timestamp: this.endTimestamp,
                    trace_id: this.traceId,
                    origin: this.origin
                });
            }
        }
    ]);
    return Span;
}();
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ function $94d5bfc5d2baadaf$export$ac65c70d78fcdb55(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return "ok";
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return "unauthenticated";
        case 403:
            return "permission_denied";
        case 404:
            return "not_found";
        case 409:
            return "already_exists";
        case 413:
            return "failed_precondition";
        case 429:
            return "resource_exhausted";
        default:
            return "invalid_argument";
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return "unimplemented";
        case 503:
            return "unavailable";
        case 504:
            return "deadline_exceeded";
        default:
            return "internal_error";
    }
    return "unknown_error";
}

});
parcelRegister("eedhm", function(module, exports) {

$parcel$export(module.exports, "tracingContextFromHeaders", function () { return $a5bcac719f43b2b1$export$ca5c066532785b6e; });
$parcel$export(module.exports, "generateSentryTraceHeader", function () { return $a5bcac719f43b2b1$export$f35d907436da45cf; });

var $gsjqs = parcelRequire("gsjqs");

var $9MzNF = parcelRequire("9MzNF");
var $a5bcac719f43b2b1$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $a5bcac719f43b2b1$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    var matches = traceparent.match($a5bcac719f43b2b1$export$394a210812ba3012);
    if (!matches) return undefined;
    var parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create tracing context from incoming headers.
 */ function $a5bcac719f43b2b1$export$ca5c066532785b6e(sentryTrace, baggage) {
    var traceparentData = $a5bcac719f43b2b1$export$8e9a29865c0a1226(sentryTrace);
    var dynamicSamplingContext = (0, $gsjqs.baggageHeaderToDynamicSamplingContext)(baggage);
    var _ref = traceparentData || {}, traceId = _ref.traceId, parentSpanId = _ref.parentSpanId, parentSampled = _ref.parentSampled;
    var propagationContext = {
        traceId: traceId || (0, $9MzNF.uuid4)(),
        spanId: (0, $9MzNF.uuid4)().substring(16),
        sampled: parentSampled
    };
    if (parentSpanId) propagationContext.parentSpanId = parentSpanId;
    if (dynamicSamplingContext) propagationContext.dsc = dynamicSamplingContext;
    return {
        traceparentData: traceparentData,
        dynamicSamplingContext: dynamicSamplingContext,
        propagationContext: propagationContext
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $a5bcac719f43b2b1$export$f35d907436da45cf() {
    var traceId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $9MzNF.uuid4)(), spanId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, $9MzNF.uuid4)().substring(16), sampled = arguments.length > 2 ? arguments[2] : void 0;
    var sampledString = "";
    if (sampled !== undefined) sampledString = sampled ? "-1" : "-0";
    return "".concat(traceId, "-").concat(spanId).concat(sampledString);
}

});
parcelRegister("gsjqs", function(module, exports) {

$parcel$export(module.exports, "BAGGAGE_HEADER_NAME", function () { return $bfae546e0ef3aae4$export$9ca9946bd449ac06; });
$parcel$export(module.exports, "baggageHeaderToDynamicSamplingContext", function () { return $bfae546e0ef3aae4$export$5b96ee2c8421f107; });
$parcel$export(module.exports, "dynamicSamplingContextToSentryBaggageHeader", function () { return $bfae546e0ef3aae4$export$56766feef403f365; });

var $do9pw = parcelRequire("do9pw");

var $cv9Rk = parcelRequire("cv9Rk");

var $fFQTh = parcelRequire("fFQTh");

var $fNn7q = parcelRequire("fNn7q");
var $bfae546e0ef3aae4$export$9ca9946bd449ac06 = "baggage";
var $bfae546e0ef3aae4$export$6e69537d67fa20f = "sentry-";
var $bfae546e0ef3aae4$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ var $bfae546e0ef3aae4$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $bfae546e0ef3aae4$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    if (!(0, $fFQTh.isString)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    // Intermediary object to store baggage key value pairs of incoming baggage headers on.
    // It is later used to read Sentry-DSC-values from.
    var baggageObject = {};
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce(function(acc, curr) {
        var currBaggageObject = $bfae546e0ef3aae4$var$baggageHeaderToObject(curr);
        return (0, $do9pw._)({}, acc, currBaggageObject);
    }, {});
    else {
        // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
        // this is how we choose to handle it)
        if (!baggageHeader) return undefined;
        baggageObject = $bfae546e0ef3aae4$var$baggageHeaderToObject(baggageHeader);
    }
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    var dynamicSamplingContext = Object.entries(baggageObject).reduce(function(acc, param) {
        var _param = (0, $cv9Rk._)(param, 2), key = _param[0], value = _param[1];
        if (key.match($bfae546e0ef3aae4$export$eb0401070c617ea5)) {
            var nonPrefixedKey = key.slice($bfae546e0ef3aae4$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $bfae546e0ef3aae4$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    var sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce(function(acc, param) {
        var _param = (0, $cv9Rk._)(param, 2), dscKey = _param[0], dscValue = _param[1];
        if (dscValue) acc["".concat($bfae546e0ef3aae4$export$6e69537d67fa20f).concat(dscKey)] = dscValue;
        return acc;
    }, {});
    return $bfae546e0ef3aae4$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $bfae546e0ef3aae4$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map(function(baggageEntry) {
        return baggageEntry.split("=").map(function(keyOrValue) {
            return decodeURIComponent(keyOrValue.trim());
        });
    }).reduce(function(acc, param) {
        var _param = (0, $cv9Rk._)(param, 2), key = _param[0], value = _param[1];
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $bfae546e0ef3aae4$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce(function(baggageHeader, param, currentIndex) {
        var _param = (0, $cv9Rk._)(param, 2), objectKey = _param[0], objectValue = _param[1];
        var baggageEntry = "".concat(encodeURIComponent(objectKey), "=").concat(encodeURIComponent(objectValue));
        var newBaggageHeader = currentIndex === 0 ? baggageEntry : "".concat(baggageHeader, ",").concat(baggageEntry);
        if (newBaggageHeader.length > $bfae546e0ef3aae4$export$bdd844ddb2def819) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).warn("Not adding key: ".concat(objectKey, " with val: ").concat(objectValue, " to baggage header due to exceeding baggage size limits."));
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}

});



parcelRegister("cxSLN", function(module, exports) {

$parcel$export(module.exports, "Transaction", function () { return $92230d4195ee4868$export$febc5573c75cefb0; });

var $d3H5E = parcelRequire("d3H5E");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $04RAu = parcelRequire("04RAu");

var $b8Rim = parcelRequire("b8Rim");

var $dcsZi = parcelRequire("dcsZi");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $ohfOJ = parcelRequire("ohfOJ");

var $9QLqp = parcelRequire("9QLqp");
var $fNn7q = parcelRequire("fNn7q");

var $1uvy1 = parcelRequire("1uvy1");

var $kzlIx = parcelRequire("kzlIx");

var $cMfbJ = parcelRequire("cMfbJ");
/** JSDoc */ var $92230d4195ee4868$export$febc5573c75cefb0 = /*#__PURE__*/ function(Span) {
    "use strict";
    (0, $dcsZi._)(Transaction, Span);
    var _super = (0, $ohfOJ._)(Transaction);
    function Transaction(transactionContext, hub) {
        (0, $4GJKx._)(this, Transaction);
        var _this;
        _this = _super.call(this, transactionContext);
        // We need to delete description since it's set by the Span class constructor
        // but not needed for transactions.
        delete _this.description;
        _this._measurements = {};
        _this._contexts = {};
        _this._hub = hub || (0, $1uvy1.getCurrentHub)();
        _this._name = transactionContext.name || "";
        _this.metadata = (0, $cxjpp._)((0, $do9pw._)({
            source: "custom"
        }, transactionContext.metadata), {
            spanMetadata: {}
        });
        _this._trimEnd = transactionContext.trimEnd;
        // this is because transactions are also spans, and spans have a transaction pointer
        _this.transaction = (0, $d3H5E._)(_this);
        // If Dynamic Sampling Context is provided during the creation of the transaction, we freeze it as it usually means
        // there is incoming Dynamic Sampling Context. (Either through an incoming request, a baggage meta-tag, or other means)
        var incomingDynamicSamplingContext = _this.metadata.dynamicSamplingContext;
        if (incomingDynamicSamplingContext) // We shallow copy this in case anything writes to the original reference of the passed in `dynamicSamplingContext`
        _this._frozenDynamicSamplingContext = (0, $do9pw._)({}, incomingDynamicSamplingContext);
        return _this;
    }
    (0, $1wc17._)(Transaction, [
        {
            key: "name",
            get: /** Getter for `name` property */ function get() {
                return this._name;
            },
            set: /** Setter for `name` property, which also sets `source` as custom */ function set(newName) {
                this.setName(newName);
            }
        },
        {
            /**
   * JSDoc
   */ key: "setName",
            value: function setName(name) {
                var source = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "custom";
                this._name = name;
                this.metadata.source = source;
            }
        },
        {
            /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */ key: "initSpanRecorder",
            value: function initSpanRecorder() {
                var maxlen = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1000;
                if (!this.spanRecorder) this.spanRecorder = new (0, $cMfbJ.SpanRecorder)(maxlen);
                this.spanRecorder.add(this);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setContext",
            value: function setContext(key, context) {
                if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                delete this._contexts[key];
                else this._contexts[key] = context;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setMeasurement",
            value: function setMeasurement(name, value) {
                var unit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
                this._measurements[name] = {
                    value: value,
                    unit: unit
                };
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setMetadata",
            value: function setMetadata(newMetadata) {
                this.metadata = (0, $do9pw._)({}, this.metadata, newMetadata);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "finish",
            value: function finish(endTimestamp) {
                var transaction = this._finishTransaction(endTimestamp);
                if (!transaction) return undefined;
                return this._hub.captureEvent(transaction);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "toContext",
            value: function toContext() {
                var spanContext = (0, $04RAu._)((0, $b8Rim._)(Transaction.prototype), "toContext", this).call(this);
                return (0, $9QLqp.dropUndefinedKeys)((0, $cxjpp._)((0, $do9pw._)({}, spanContext), {
                    name: this.name,
                    trimEnd: this._trimEnd
                }));
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "updateWithContext",
            value: function updateWithContext(transactionContext) {
                (0, $04RAu._)((0, $b8Rim._)(Transaction.prototype), "updateWithContext", this).call(this, transactionContext);
                this.name = transactionContext.name || "";
                this._trimEnd = transactionContext.trimEnd;
                return this;
            }
        },
        {
            /**
   * @inheritdoc
   *
   * @experimental
   */ key: "getDynamicSamplingContext",
            value: function getDynamicSamplingContext() {
                if (this._frozenDynamicSamplingContext) return this._frozenDynamicSamplingContext;
                var hub = this._hub || (0, $1uvy1.getCurrentHub)();
                var client = hub.getClient();
                if (!client) return {};
                var scope = hub.getScope();
                var dsc = (0, $kzlIx.getDynamicSamplingContextFromClient)(this.traceId, client, scope);
                var maybeSampleRate = this.metadata.sampleRate;
                if (maybeSampleRate !== undefined) dsc.sample_rate = "".concat(maybeSampleRate);
                // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
                var source = this.metadata.source;
                if (source && source !== "url") dsc.transaction = this.name;
                if (this.sampled !== undefined) dsc.sampled = String(this.sampled);
                // Uncomment if we want to make DSC immutable
                // this._frozenDynamicSamplingContext = dsc;
                return dsc;
            }
        },
        {
            /**
   * Override the current hub with a new one.
   * Used if you want another hub to finish the transaction.
   *
   * @internal
   */ key: "setHub",
            value: function setHub(hub) {
                this._hub = hub;
            }
        },
        {
            /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ key: "_finishTransaction",
            value: function _finishTransaction(endTimestamp) {
                var _this = this;
                // This transaction is already finished, so we should not flush it again.
                if (this.endTimestamp !== undefined) return undefined;
                if (!this.name) {
                    (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
                    this.name = "<unlabeled transaction>";
                }
                // just sets the end timestamp
                (0, $04RAu._)((0, $b8Rim._)(Transaction.prototype), "finish", this).call(this, endTimestamp);
                var client = this._hub.getClient();
                if (client && client.emit) client.emit("finishTransaction", this);
                if (this.sampled !== true) {
                    // At this point if `sampled !== true` we want to discard the transaction.
                    (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).log("[Tracing] Discarding transaction because its trace was not chosen to be sampled.");
                    if (client) client.recordDroppedEvent("sample_rate", "transaction");
                    return undefined;
                }
                var finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter(function(s) {
                    return s !== _this && s.endTimestamp;
                }) : [];
                if (this._trimEnd && finishedSpans.length > 0) this.endTimestamp = finishedSpans.reduce(function(prev, current) {
                    if (prev.endTimestamp && current.endTimestamp) return prev.endTimestamp > current.endTimestamp ? prev : current;
                    return prev;
                }).endTimestamp;
                var metadata = this.metadata;
                var transaction = (0, $do9pw._)({
                    contexts: (0, $cxjpp._)((0, $do9pw._)({}, this._contexts), {
                        // We don't want to override trace context
                        trace: this.getTraceContext()
                    }),
                    spans: finishedSpans,
                    start_timestamp: this.startTimestamp,
                    tags: this.tags,
                    timestamp: this.endTimestamp,
                    transaction: this.name,
                    type: "transaction",
                    sdkProcessingMetadata: (0, $cxjpp._)((0, $do9pw._)({}, metadata), {
                        dynamicSamplingContext: this.getDynamicSamplingContext()
                    })
                }, metadata.source && {
                    transaction_info: {
                        source: metadata.source
                    }
                });
                var hasMeasurements = Object.keys(this._measurements).length > 0;
                if (hasMeasurements) {
                    (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).log("[Measurements] Adding measurements to transaction", JSON.stringify(this._measurements, undefined, 2));
                    transaction.measurements = this._measurements;
                }
                (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).log("[Tracing] Finishing ".concat(this.op, " transaction: ").concat(this.name, "."));
                return transaction;
            }
        }
    ]);
    return Transaction;
}((0, $cMfbJ.Span));

});
parcelRegister("kzlIx", function(module, exports) {

$parcel$export(module.exports, "getDynamicSamplingContextFromClient", function () { return $ef97ec22d9002b32$export$366bad00d6815eed; });

var $9QLqp = parcelRequire("9QLqp");

var $lqQO8 = parcelRequire("lqQO8");
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatchs the `createDsc` lifecycle hook as a side effect.
 */ function $ef97ec22d9002b32$export$366bad00d6815eed(trace_id, client, scope) {
    var options = client.getOptions();
    var _ref = client.getDsn() || {}, public_key = _ref.publicKey;
    var _ref1 = scope && scope.getUser() || {}, user_segment = _ref1.segment;
    var dsc = (0, $9QLqp.dropUndefinedKeys)({
        environment: options.environment || (0, $lqQO8.DEFAULT_ENVIRONMENT),
        release: options.release,
        user_segment: user_segment,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit && client.emit("createDsc", dsc);
    return dsc;
}

});



parcelRegister("coDEo", function(module, exports) {

$parcel$export(module.exports, "sampleTransaction", function () { return $90667bb6e51c1c76$export$b3258c3993bc9b71; });

var $l0HdX = parcelRequire("l0HdX");

var $fFQTh = parcelRequire("fFQTh");
var $fNn7q = parcelRequire("fNn7q");

var $eodu0 = parcelRequire("eodu0");
/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * This method muttes the given `transaction` and will set the `sampled` value on it.
 * It returns the same transaction, for convenience.
 */ function $90667bb6e51c1c76$export$b3258c3993bc9b71(transaction, options, samplingContext) {
    // nothing to do if tracing is not enabled
    if (!(0, $eodu0.hasTracingEnabled)(options)) {
        transaction.sampled = false;
        return transaction;
    }
    // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
    if (transaction.sampled !== undefined) {
        transaction.setMetadata({
            sampleRate: Number(transaction.sampled)
        });
        return transaction;
    }
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
    // work; prefer the hook if so
    var sampleRate;
    if (typeof options.tracesSampler === "function") {
        sampleRate = options.tracesSampler(samplingContext);
        transaction.setMetadata({
            sampleRate: Number(sampleRate)
        });
    } else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== "undefined") {
        sampleRate = options.tracesSampleRate;
        transaction.setMetadata({
            sampleRate: Number(sampleRate)
        });
    } else {
        // When `enableTracing === true`, we use a sample rate of 100%
        sampleRate = 1;
        transaction.setMetadata({
            sampleRate: sampleRate
        });
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!$90667bb6e51c1c76$var$isValidSampleRate(sampleRate)) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).warn("[Tracing] Discarding transaction because of invalid sample rate.");
        transaction.sampled = false;
        return transaction;
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!sampleRate) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).log("[Tracing] Discarding transaction because ".concat(typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"));
        transaction.sampled = false;
        return transaction;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    transaction.sampled = Math.random() < sampleRate;
    // if we're not going to keep it, we're done
    if (!transaction.sampled) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).log("[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ".concat(Number(sampleRate), ")"));
        return transaction;
    }
    (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).log("[Tracing] starting ".concat(transaction.op, " transaction - ").concat(transaction.name));
    return transaction;
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */ function $90667bb6e51c1c76$var$isValidSampleRate(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((0, $fFQTh.isNaN)(rate) || !(typeof rate === "number" || typeof rate === "boolean")) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).warn("[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ".concat(JSON.stringify(rate), " of type ").concat(JSON.stringify(typeof rate === "undefined" ? "undefined" : (0, $l0HdX._)(rate)), "."));
        return false;
    }
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).warn("[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ".concat(rate, "."));
        return false;
    }
    return true;
}

});
parcelRegister("eodu0", function(module, exports) {

$parcel$export(module.exports, "hasTracingEnabled", function () { return $02b417ce88d6d881$export$5008da00b1b6dee6; });

var $1uvy1 = parcelRequire("1uvy1");
// Treeshakable guard to remove all code related to tracing
/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */ function $02b417ce88d6d881$export$5008da00b1b6dee6(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) return false;
    var client = (0, $1uvy1.getCurrentHub)().getClient();
    var options = maybeOptions || client && client.getOptions();
    return !!options && (options.enableTracing || "tracesSampleRate" in options || "tracesSampler" in options);
}

});



parcelRegister("iwzVz", function(module, exports) {

$parcel$export(module.exports, "registerBackgroundTabDetection", function () { return $d7c7159c10e9233b$export$6f18f55521af71a1; });

var $8wQCP = parcelRequire("8wQCP");

var $fNn7q = parcelRequire("fNn7q");

var $5ecgN = parcelRequire("5ecgN");
/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */ function $d7c7159c10e9233b$export$6f18f55521af71a1() {
    if ((0, $5ecgN.WINDOW) && (0, $5ecgN.WINDOW).document) (0, $5ecgN.WINDOW).document.addEventListener("visibilitychange", function() {
        var activeTransaction = (0, $8wQCP.getActiveTransaction)();
        if ((0, $5ecgN.WINDOW).document.hidden && activeTransaction) {
            var statusType = "cancelled";
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).log("[Tracing] Transaction: ".concat(statusType, " -> since tab moved to the background, op: ").concat(activeTransaction.op));
            // We should not set status if it is already set, this prevent important statuses like
            // error or data loss from being overwritten on transaction.
            if (!activeTransaction.status) activeTransaction.setStatus(statusType);
            activeTransaction.setTag("visibilitychange", "document.hidden");
            activeTransaction.finish();
        }
    });
    else (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).warn("[Tracing] Could not set up background tab detection due to lack of global document");
}

});
parcelRegister("5ecgN", function(module, exports) {

$parcel$export(module.exports, "WINDOW", function () { return $3ce7c71fe194830a$export$56d8a8a25bd48b81; });

var $3rn7c = parcelRequire("3rn7c");
var $3ce7c71fe194830a$export$56d8a8a25bd48b81 = (0, $3rn7c.GLOBAL_OBJ);

});


parcelRegister("jJ0r2", function(module, exports) {

$parcel$export(module.exports, "startTrackingWebVitals", function () { return $e5c28eaf501dda1e$export$7c69f0412d101b88; });
$parcel$export(module.exports, "startTrackingLongTasks", function () { return $e5c28eaf501dda1e$export$f396d19077034ad2; });
$parcel$export(module.exports, "startTrackingInteractions", function () { return $e5c28eaf501dda1e$export$e27543e0976315e4; });
$parcel$export(module.exports, "addPerformanceEntries", function () { return $e5c28eaf501dda1e$export$5f8fa6b3467a7443; });

var $8wQCP = parcelRequire("8wQCP");

var $kfF30 = parcelRequire("kfF30");
var $2Qsdx = parcelRequire("2Qsdx");
var $fNn7q = parcelRequire("fNn7q");

var $5ecgN = parcelRequire("5ecgN");

var $cL6Gq = parcelRequire("cL6Gq");

var $7kzmm = parcelRequire("7kzmm");

var $eua4y = parcelRequire("eua4y");

var $fz0QK = parcelRequire("fz0QK");

var $1pcuY = parcelRequire("1pcuY");

var $lauwa = parcelRequire("lauwa");
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */ function $e5c28eaf501dda1e$var$msToSec(time) {
    return time / 1000;
}
function $e5c28eaf501dda1e$var$getBrowserPerformanceAPI() {
    // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
    return (0, $5ecgN.WINDOW) && (0, $5ecgN.WINDOW).addEventListener && (0, $5ecgN.WINDOW).performance;
}
var $e5c28eaf501dda1e$var$_performanceCursor = 0;
var $e5c28eaf501dda1e$var$_measurements = {};
var $e5c28eaf501dda1e$var$_lcpEntry;
var $e5c28eaf501dda1e$var$_clsEntry;
/**
 * Start tracking web vitals
 *
 * @returns A function that forces web vitals collection
 */ function $e5c28eaf501dda1e$export$7c69f0412d101b88() {
    var performance = $e5c28eaf501dda1e$var$getBrowserPerformanceAPI();
    if (performance && (0, $kfF30.browserPerformanceTimeOrigin)) {
        // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
        if (performance.mark) (0, $5ecgN.WINDOW).performance.mark("sentry-tracing-init");
        $e5c28eaf501dda1e$var$_trackFID();
        var clsCallback = $e5c28eaf501dda1e$var$_trackCLS();
        var lcpCallback = $e5c28eaf501dda1e$var$_trackLCP();
        return function() {
            if (clsCallback) clsCallback();
            if (lcpCallback) lcpCallback();
        };
    }
    return function() {
        return undefined;
    };
}
/**
 * Start tracking long tasks.
 */ function $e5c28eaf501dda1e$export$f396d19077034ad2() {
    var entryHandler = function(entries) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entry = _step.value;
                var transaction = (0, $8wQCP.getActiveTransaction)();
                if (!transaction) return;
                var startTime = $e5c28eaf501dda1e$var$msToSec((0, $kfF30.browserPerformanceTimeOrigin) + entry.startTime);
                var duration = $e5c28eaf501dda1e$var$msToSec(entry.duration);
                transaction.startChild({
                    description: "Main UI thread blocked",
                    op: "ui.long-task",
                    origin: "auto.ui.browser.metrics",
                    startTimestamp: startTime,
                    endTimestamp: startTime + duration
                });
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
    (0, $1pcuY.observe)("longtask", entryHandler);
}
/**
 * Start tracking interaction events.
 */ function $e5c28eaf501dda1e$export$e27543e0976315e4() {
    var entryHandler = function(entries) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entry = _step.value;
                var transaction = (0, $8wQCP.getActiveTransaction)();
                if (!transaction) return;
                if (entry.name === "click") {
                    var startTime = $e5c28eaf501dda1e$var$msToSec((0, $kfF30.browserPerformanceTimeOrigin) + entry.startTime);
                    var duration = $e5c28eaf501dda1e$var$msToSec(entry.duration);
                    transaction.startChild({
                        description: (0, $2Qsdx.htmlTreeAsString)(entry.target),
                        op: "ui.interaction.".concat(entry.name),
                        origin: "auto.ui.browser.metrics",
                        startTimestamp: startTime,
                        endTimestamp: startTime + duration
                    });
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
    (0, $1pcuY.observe)("event", entryHandler, {
        durationThreshold: 0
    });
}
/** Starts tracking the Cumulative Layout Shift on the current page. */ function $e5c28eaf501dda1e$var$_trackCLS() {
    // See:
    // https://web.dev/evolving-cls/
    // https://web.dev/cls-web-tooling/
    return (0, $cL6Gq.onCLS)(function(metric) {
        var entry = metric.entries.pop();
        if (!entry) return;
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).log("[Measurements] Adding CLS");
        $e5c28eaf501dda1e$var$_measurements["cls"] = {
            value: metric.value,
            unit: ""
        };
        $e5c28eaf501dda1e$var$_clsEntry = entry;
    });
}
/** Starts tracking the Largest Contentful Paint on the current page. */ function $e5c28eaf501dda1e$var$_trackLCP() {
    return (0, $eua4y.onLCP)(function(metric) {
        var entry = metric.entries.pop();
        if (!entry) return;
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).log("[Measurements] Adding LCP");
        $e5c28eaf501dda1e$var$_measurements["lcp"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $e5c28eaf501dda1e$var$_lcpEntry = entry;
    });
}
/** Starts tracking the First Input Delay on the current page. */ function $e5c28eaf501dda1e$var$_trackFID() {
    (0, $7kzmm.onFID)(function(metric) {
        var entry = metric.entries.pop();
        if (!entry) return;
        var timeOrigin = $e5c28eaf501dda1e$var$msToSec((0, $kfF30.browserPerformanceTimeOrigin));
        var startTime = $e5c28eaf501dda1e$var$msToSec(entry.startTime);
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).log("[Measurements] Adding FID");
        $e5c28eaf501dda1e$var$_measurements["fid"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $e5c28eaf501dda1e$var$_measurements["mark.fid"] = {
            value: timeOrigin + startTime,
            unit: "second"
        };
    });
}
/** Add performance related spans to a transaction */ function $e5c28eaf501dda1e$export$5f8fa6b3467a7443(transaction) {
    var performance = $e5c28eaf501dda1e$var$getBrowserPerformanceAPI();
    if (!performance || !(0, $5ecgN.WINDOW).performance.getEntries || !(0, $kfF30.browserPerformanceTimeOrigin)) // Gatekeeper if performance API not available
    return;
    (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).log("[Tracing] Adding & adjusting spans using Performance API");
    var timeOrigin = $e5c28eaf501dda1e$var$msToSec((0, $kfF30.browserPerformanceTimeOrigin));
    var performanceEntries = performance.getEntries();
    var responseStartTimestamp;
    var requestStartTimestamp;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    performanceEntries.slice($e5c28eaf501dda1e$var$_performanceCursor).forEach(function(entry) {
        var startTime = $e5c28eaf501dda1e$var$msToSec(entry.startTime);
        var duration = $e5c28eaf501dda1e$var$msToSec(entry.duration);
        if (transaction.op === "navigation" && timeOrigin + startTime < transaction.startTimestamp) return;
        switch(entry.entryType){
            case "navigation":
                $e5c28eaf501dda1e$var$_addNavigationSpans(transaction, entry, timeOrigin);
                responseStartTimestamp = timeOrigin + $e5c28eaf501dda1e$var$msToSec(entry.responseStart);
                requestStartTimestamp = timeOrigin + $e5c28eaf501dda1e$var$msToSec(entry.requestStart);
                break;
            case "mark":
            case "paint":
            case "measure":
                {
                    $e5c28eaf501dda1e$export$bc93b84e4d45912d(transaction, entry, startTime, duration, timeOrigin);
                    // capture web vitals
                    var firstHidden = (0, $fz0QK.getVisibilityWatcher)();
                    // Only report if the page wasn't hidden prior to the web vital.
                    var shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === "first-paint" && shouldRecord) {
                        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).log("[Measurements] Adding FP");
                        $e5c28eaf501dda1e$var$_measurements["fp"] = {
                            value: entry.startTime,
                            unit: "millisecond"
                        };
                    }
                    if (entry.name === "first-contentful-paint" && shouldRecord) {
                        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).log("[Measurements] Adding FCP");
                        $e5c28eaf501dda1e$var$_measurements["fcp"] = {
                            value: entry.startTime,
                            unit: "millisecond"
                        };
                    }
                    break;
                }
            case "resource":
                {
                    var resourceName = entry.name.replace((0, $5ecgN.WINDOW).location.origin, "");
                    $e5c28eaf501dda1e$export$c82fe1a70634f317(transaction, entry, resourceName, startTime, duration, timeOrigin);
                    break;
                }
        }
    });
    $e5c28eaf501dda1e$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $e5c28eaf501dda1e$var$_trackNavigator(transaction);
    // Measurements are only available for pageload transactions
    if (transaction.op === "pageload") {
        // Generate TTFB (Time to First Byte), which measured as the time between the beginning of the transaction and the
        // start of the response in milliseconds
        if (typeof responseStartTimestamp === "number") {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).log("[Measurements] Adding TTFB");
            $e5c28eaf501dda1e$var$_measurements["ttfb"] = {
                value: (responseStartTimestamp - transaction.startTimestamp) * 1000,
                unit: "millisecond"
            };
            if (typeof requestStartTimestamp === "number" && requestStartTimestamp <= responseStartTimestamp) // Capture the time spent making the request and receiving the first byte of the response.
            // This is the time between the start of the request and the start of the response in milliseconds.
            $e5c28eaf501dda1e$var$_measurements["ttfb.requestTime"] = {
                value: (responseStartTimestamp - requestStartTimestamp) * 1000,
                unit: "millisecond"
            };
        }
        [
            "fcp",
            "fp",
            "lcp"
        ].forEach(function(name) {
            if (!$e5c28eaf501dda1e$var$_measurements[name] || timeOrigin >= transaction.startTimestamp) return;
            // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
            // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
            // to be adjusted to be relative to transaction.startTimestamp.
            var oldValue = $e5c28eaf501dda1e$var$_measurements[name].value;
            var measurementTimestamp = timeOrigin + $e5c28eaf501dda1e$var$msToSec(oldValue);
            // normalizedValue should be in milliseconds
            var normalizedValue = Math.abs((measurementTimestamp - transaction.startTimestamp) * 1000);
            var delta = normalizedValue - oldValue;
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).log("[Measurements] Normalized ".concat(name, " from ").concat(oldValue, " to ").concat(normalizedValue, " (").concat(delta, ")"));
            $e5c28eaf501dda1e$var$_measurements[name].value = normalizedValue;
        });
        var fidMark = $e5c28eaf501dda1e$var$_measurements["mark.fid"];
        if (fidMark && $e5c28eaf501dda1e$var$_measurements["fid"]) {
            // create span for FID
            (0, $lauwa._startChild)(transaction, {
                description: "first input delay",
                endTimestamp: fidMark.value + $e5c28eaf501dda1e$var$msToSec($e5c28eaf501dda1e$var$_measurements["fid"].value),
                op: "ui.action",
                origin: "auto.ui.browser.metrics",
                startTimestamp: fidMark.value
            });
            // Delete mark.fid as we don't want it to be part of final payload
            delete $e5c28eaf501dda1e$var$_measurements["mark.fid"];
        }
        // If FCP is not recorded we should not record the cls value
        // according to the new definition of CLS.
        if (!("fcp" in $e5c28eaf501dda1e$var$_measurements)) delete $e5c28eaf501dda1e$var$_measurements.cls;
        Object.keys($e5c28eaf501dda1e$var$_measurements).forEach(function(measurementName) {
            transaction.setMeasurement(measurementName, $e5c28eaf501dda1e$var$_measurements[measurementName].value, $e5c28eaf501dda1e$var$_measurements[measurementName].unit);
        });
        $e5c28eaf501dda1e$var$_tagMetricInfo(transaction);
    }
    $e5c28eaf501dda1e$var$_lcpEntry = undefined;
    $e5c28eaf501dda1e$var$_clsEntry = undefined;
    $e5c28eaf501dda1e$var$_measurements = {};
}
/** Create measure related spans */ function $e5c28eaf501dda1e$export$bc93b84e4d45912d(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, startTime, duration, timeOrigin) {
    var measureStartTimestamp = timeOrigin + startTime;
    var measureEndTimestamp = measureStartTimestamp + duration;
    (0, $lauwa._startChild)(transaction, {
        description: entry.name,
        endTimestamp: measureEndTimestamp,
        op: entry.entryType,
        origin: "auto.resource.browser.metrics",
        startTimestamp: measureStartTimestamp
    });
    return measureStartTimestamp;
}
/** Instrument navigation entries */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e5c28eaf501dda1e$var$_addNavigationSpans(transaction, entry, timeOrigin) {
    [
        "unloadEvent",
        "redirect",
        "domContentLoadedEvent",
        "loadEvent",
        "connect"
    ].forEach(function(event) {
        $e5c28eaf501dda1e$var$_addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
    });
    $e5c28eaf501dda1e$var$_addPerformanceNavigationTiming(transaction, entry, "secureConnection", timeOrigin, "TLS/SSL", "connectEnd");
    $e5c28eaf501dda1e$var$_addPerformanceNavigationTiming(transaction, entry, "fetch", timeOrigin, "cache", "domainLookupStart");
    $e5c28eaf501dda1e$var$_addPerformanceNavigationTiming(transaction, entry, "domainLookup", timeOrigin, "DNS");
    $e5c28eaf501dda1e$var$_addRequest(transaction, entry, timeOrigin);
}
/** Create performance navigation related spans */ function $e5c28eaf501dda1e$var$_addPerformanceNavigationTiming(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, event, timeOrigin, description, eventEnd) {
    var end = eventEnd ? entry[eventEnd] : entry["".concat(event, "End")];
    var start = entry["".concat(event, "Start")];
    if (!start || !end) return;
    (0, $lauwa._startChild)(transaction, {
        op: "browser",
        origin: "auto.browser.browser.metrics",
        description: description || event,
        startTimestamp: timeOrigin + $e5c28eaf501dda1e$var$msToSec(start),
        endTimestamp: timeOrigin + $e5c28eaf501dda1e$var$msToSec(end)
    });
}
/** Create request and response related spans */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e5c28eaf501dda1e$var$_addRequest(transaction, entry, timeOrigin) {
    (0, $lauwa._startChild)(transaction, {
        op: "browser",
        origin: "auto.browser.browser.metrics",
        description: "request",
        startTimestamp: timeOrigin + $e5c28eaf501dda1e$var$msToSec(entry.requestStart),
        endTimestamp: timeOrigin + $e5c28eaf501dda1e$var$msToSec(entry.responseEnd)
    });
    (0, $lauwa._startChild)(transaction, {
        op: "browser",
        origin: "auto.browser.browser.metrics",
        description: "response",
        startTimestamp: timeOrigin + $e5c28eaf501dda1e$var$msToSec(entry.responseStart),
        endTimestamp: timeOrigin + $e5c28eaf501dda1e$var$msToSec(entry.responseEnd)
    });
}
/** Create resource-related spans */ function $e5c28eaf501dda1e$export$c82fe1a70634f317(transaction, entry, resourceName, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === "xmlhttprequest" || entry.initiatorType === "fetch") return;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var data = {};
    if ("transferSize" in entry) data["http.response_transfer_size"] = entry.transferSize;
    if ("encodedBodySize" in entry) data["http.response_content_length"] = entry.encodedBodySize;
    if ("decodedBodySize" in entry) data["http.decoded_response_content_length"] = entry.decodedBodySize;
    if ("renderBlockingStatus" in entry) data["resource.render_blocking_status"] = entry.renderBlockingStatus;
    var startTimestamp = timeOrigin + startTime;
    var endTimestamp = startTimestamp + duration;
    (0, $lauwa._startChild)(transaction, {
        description: resourceName,
        endTimestamp: endTimestamp,
        op: entry.initiatorType ? "resource.".concat(entry.initiatorType) : "resource.other",
        origin: "auto.resource.browser.metrics",
        startTimestamp: startTimestamp,
        data: data
    });
}
/**
 * Capture the information of the user agent.
 */ function $e5c28eaf501dda1e$var$_trackNavigator(transaction) {
    var navigator = (0, $5ecgN.WINDOW).navigator;
    if (!navigator) return;
    // track network connectivity
    var connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) transaction.setTag("effectiveConnectionType", connection.effectiveType);
        if (connection.type) transaction.setTag("connectionType", connection.type);
        if ((0, $lauwa.isMeasurementValue)(connection.rtt)) $e5c28eaf501dda1e$var$_measurements["connection.rtt"] = {
            value: connection.rtt,
            unit: "millisecond"
        };
    }
    if ((0, $lauwa.isMeasurementValue)(navigator.deviceMemory)) transaction.setTag("deviceMemory", "".concat(navigator.deviceMemory, " GB"));
    if ((0, $lauwa.isMeasurementValue)(navigator.hardwareConcurrency)) transaction.setTag("hardwareConcurrency", String(navigator.hardwareConcurrency));
}
/** Add LCP / CLS data to transaction to allow debugging */ function $e5c28eaf501dda1e$var$_tagMetricInfo(transaction) {
    if ($e5c28eaf501dda1e$var$_lcpEntry) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).log("[Measurements] Adding LCP Data");
        // Capture Properties of the LCP element that contributes to the LCP.
        if ($e5c28eaf501dda1e$var$_lcpEntry.element) transaction.setTag("lcp.element", (0, $2Qsdx.htmlTreeAsString)($e5c28eaf501dda1e$var$_lcpEntry.element));
        if ($e5c28eaf501dda1e$var$_lcpEntry.id) transaction.setTag("lcp.id", $e5c28eaf501dda1e$var$_lcpEntry.id);
        if ($e5c28eaf501dda1e$var$_lcpEntry.url) // Trim URL to the first 200 characters.
        transaction.setTag("lcp.url", $e5c28eaf501dda1e$var$_lcpEntry.url.trim().slice(0, 200));
        transaction.setTag("lcp.size", $e5c28eaf501dda1e$var$_lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if ($e5c28eaf501dda1e$var$_clsEntry && $e5c28eaf501dda1e$var$_clsEntry.sources) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).log("[Measurements] Adding CLS Data");
        $e5c28eaf501dda1e$var$_clsEntry.sources.forEach(function(source, index) {
            return transaction.setTag("cls.source.".concat(index + 1), (0, $2Qsdx.htmlTreeAsString)(source.node));
        });
    }
}

});
parcelRegister("cL6Gq", function(module, exports) {

$parcel$export(module.exports, "onCLS", function () { return $949f0efca4241b94$export$a7873055838e5ad8; });

var $dm1Gl = parcelRequire("dm1Gl");

var $dkA2Y = parcelRequire("dkA2Y");

var $1pcuY = parcelRequire("1pcuY");

var $bp3S2 = parcelRequire("bp3S2");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [CLS](https://web.dev/cls/) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/cls/#layout-shift-score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ var $949f0efca4241b94$export$a7873055838e5ad8 = function(onReport) {
    var metric = (0, $dkA2Y.initMetric)("CLS", 0);
    var report;
    var sessionValue = 0;
    var sessionEntries = [];
    // const handleEntries = (entries: Metric['entries']) => {
    var handleEntries = function(entries) {
        entries.forEach(function(entry) {
            // Only count layout shifts without recent user input.
            if (!entry.hadRecentInput) {
                var firstSessionEntry = sessionEntries[0];
                var lastSessionEntry = sessionEntries[sessionEntries.length - 1];
                // If the entry occurred less than 1 second after the previous entry and
                // less than 5 seconds after the first entry in the session, include the
                // entry in the current session. Otherwise, start a new session.
                if (sessionValue && sessionEntries.length !== 0 && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
                    sessionValue += entry.value;
                    sessionEntries.push(entry);
                } else {
                    sessionValue = entry.value;
                    sessionEntries = [
                        entry
                    ];
                }
                // If the current session value is larger than the current CLS value,
                // update CLS and the entries contributing to it.
                if (sessionValue > metric.value) {
                    metric.value = sessionValue;
                    metric.entries = sessionEntries;
                    if (report) report();
                }
            }
        });
    };
    var po = (0, $1pcuY.observe)("layout-shift", handleEntries);
    if (po) {
        report = (0, $dm1Gl.bindReporter)(onReport, metric);
        var stopListening = function() {
            handleEntries(po.takeRecords());
            report(true);
        };
        (0, $bp3S2.onHidden)(stopListening);
        return stopListening;
    }
    return;
};

});
parcelRegister("dm1Gl", function(module, exports) {

$parcel$export(module.exports, "bindReporter", function () { return $9b8ea26d2e1deae6$export$17679dccdd551979; });
var $9b8ea26d2e1deae6$export$17679dccdd551979 = function(callback, metric, reportAllChanges) {
    var prevValue;
    var delta;
    return function(forceReport) {
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (delta || prevValue === undefined) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    callback(metric);
                }
            }
        }
    };
};

});

parcelRegister("dkA2Y", function(module, exports) {

$parcel$export(module.exports, "initMetric", function () { return $9b491ace5d42e3a5$export$3c29b44508a0612b; });

var $5ecgN = parcelRequire("5ecgN");

var $dqx0s = parcelRequire("dqx0s");

var $2Yr7H = parcelRequire("2Yr7H");

var $ePM4O = parcelRequire("ePM4O");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $9b491ace5d42e3a5$export$3c29b44508a0612b = function(name, value) {
    var navEntry = (0, $ePM4O.getNavigationEntry)();
    var navigationType = "navigate";
    if (navEntry) {
        if ((0, $5ecgN.WINDOW).document.prerendering || (0, $2Yr7H.getActivationStart)() > 0) navigationType = "prerender";
        else navigationType = navEntry.type.replace(/_/g, "-");
    }
    return {
        name: name,
        value: typeof value === "undefined" ? -1 : value,
        rating: "good",
        delta: 0,
        entries: [],
        id: (0, $dqx0s.generateUniqueID)(),
        navigationType: navigationType
    };
};

});
parcelRegister("dqx0s", function(module, exports) {

$parcel$export(module.exports, "generateUniqueID", function () { return $9c674e72674a6670$export$407ea409d1f3b539; });
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ var $9c674e72674a6670$export$407ea409d1f3b539 = function() {
    return "v3-".concat(Date.now(), "-").concat(Math.floor(Math.random() * (9e12 - 1)) + 1e12);
};

});

parcelRegister("2Yr7H", function(module, exports) {

$parcel$export(module.exports, "getActivationStart", function () { return $22a63979c4d203cb$export$d3e828b3c7b5b845; });

var $ePM4O = parcelRequire("ePM4O");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $22a63979c4d203cb$export$d3e828b3c7b5b845 = function() {
    var navEntry = (0, $ePM4O.getNavigationEntry)();
    return navEntry && navEntry.activationStart || 0;
};

});
parcelRegister("ePM4O", function(module, exports) {

$parcel$export(module.exports, "getNavigationEntry", function () { return $accb1f1ae7f18f34$export$6431553786c94949; });

var $5ecgN = parcelRequire("5ecgN");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $accb1f1ae7f18f34$var$getNavigationEntryFromPerformanceTiming = function() {
    // eslint-disable-next-line deprecation/deprecation
    var timing = (0, $5ecgN.WINDOW).performance.timing;
    // eslint-disable-next-line deprecation/deprecation
    var type = (0, $5ecgN.WINDOW).performance.navigation.type;
    var navigationEntry = {
        entryType: "navigation",
        startTime: 0,
        type: type == 2 ? "back_forward" : type === 1 ? "reload" : "navigate"
    };
    for(var key in timing)if (key !== "navigationStart" && key !== "toJSON") // eslint-disable-next-line deprecation/deprecation
    navigationEntry[key] = Math.max(timing[key] - timing.navigationStart, 0);
    return navigationEntry;
};
var $accb1f1ae7f18f34$export$6431553786c94949 = function() {
    if ((0, $5ecgN.WINDOW).__WEB_VITALS_POLYFILL__) return (0, $5ecgN.WINDOW).performance && (performance.getEntriesByType && performance.getEntriesByType("navigation")[0] || $accb1f1ae7f18f34$var$getNavigationEntryFromPerformanceTiming());
    else return (0, $5ecgN.WINDOW).performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
};

});



parcelRegister("1pcuY", function(module, exports) {

$parcel$export(module.exports, "observe", function () { return $1061d22f935be4d2$export$d1203567a167490e; });
/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ var $1061d22f935be4d2$export$d1203567a167490e = function(type, callback, opts) {
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            var po = new PerformanceObserver(function(list) {
                callback(list.getEntries());
            });
            po.observe(Object.assign({
                type: type,
                buffered: true
            }, opts || {}));
            return po;
        }
    } catch (e) {
    // Do nothing.
    }
    return;
};

});

parcelRegister("bp3S2", function(module, exports) {

$parcel$export(module.exports, "onHidden", function () { return $84d5081b774af3d5$export$91ec2be6fdd8f1b4; });

var $5ecgN = parcelRequire("5ecgN");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $84d5081b774af3d5$export$91ec2be6fdd8f1b4 = function(cb, once) {
    var onHiddenOrPageHide = function(event) {
        if (event.type === "pagehide" || (0, $5ecgN.WINDOW).document.visibilityState === "hidden") {
            cb(event);
            if (once) {
                removeEventListener("visibilitychange", onHiddenOrPageHide, true);
                removeEventListener("pagehide", onHiddenOrPageHide, true);
            }
        }
    };
    addEventListener("visibilitychange", onHiddenOrPageHide, true);
    // Some browsers have buggy implementations of visibilitychange,
    // so we use pagehide in addition, just to be safe.
    addEventListener("pagehide", onHiddenOrPageHide, true);
};

});


parcelRegister("7kzmm", function(module, exports) {

$parcel$export(module.exports, "onFID", function () { return $5565d45447a90243$export$39705a25c49af873; });

var $dm1Gl = parcelRequire("dm1Gl");

var $fz0QK = parcelRequire("fz0QK");

var $dkA2Y = parcelRequire("dkA2Y");

var $1pcuY = parcelRequire("1pcuY");

var $bp3S2 = parcelRequire("bp3S2");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [FID](https://web.dev/fid/) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */ var $5565d45447a90243$export$39705a25c49af873 = function(onReport) {
    var visibilityWatcher = (0, $fz0QK.getVisibilityWatcher)();
    var metric = (0, $dkA2Y.initMetric)("FID");
    // eslint-disable-next-line prefer-const
    var report;
    var handleEntry = function(entry) {
        // Only report if the page wasn't hidden prior to the first input.
        if (entry.startTime < visibilityWatcher.firstHiddenTime) {
            metric.value = entry.processingStart - entry.startTime;
            metric.entries.push(entry);
            report(true);
        }
    };
    var handleEntries = function(entries) {
        entries.forEach(handleEntry);
    };
    var po = (0, $1pcuY.observe)("first-input", handleEntries);
    report = (0, $dm1Gl.bindReporter)(onReport, metric);
    if (po) (0, $bp3S2.onHidden)(function() {
        handleEntries(po.takeRecords());
        po.disconnect();
    }, true);
};

});
parcelRegister("fz0QK", function(module, exports) {

$parcel$export(module.exports, "getVisibilityWatcher", function () { return $b54ac8a175de8a0a$export$443f86b2c77012c4; });

var $5ecgN = parcelRequire("5ecgN");

var $bp3S2 = parcelRequire("bp3S2");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $b54ac8a175de8a0a$var$firstHiddenTime = -1;
var $b54ac8a175de8a0a$var$initHiddenTime = function() {
    // If the document is hidden and not prerendering, assume it was always
    // hidden and the page was loaded in the background.
    return (0, $5ecgN.WINDOW).document.visibilityState === "hidden" && !(0, $5ecgN.WINDOW).document.prerendering ? 0 : Infinity;
};
var $b54ac8a175de8a0a$var$trackChanges = function() {
    // Update the time if/when the document becomes hidden.
    (0, $bp3S2.onHidden)(function(param) {
        var timeStamp = param.timeStamp;
        $b54ac8a175de8a0a$var$firstHiddenTime = timeStamp;
    }, true);
};
var $b54ac8a175de8a0a$export$443f86b2c77012c4 = function() {
    if ($b54ac8a175de8a0a$var$firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        $b54ac8a175de8a0a$var$firstHiddenTime = $b54ac8a175de8a0a$var$initHiddenTime();
        $b54ac8a175de8a0a$var$trackChanges();
    }
    return {
        get firstHiddenTime () {
            return $b54ac8a175de8a0a$var$firstHiddenTime;
        }
    };
};

});


parcelRegister("eua4y", function(module, exports) {

$parcel$export(module.exports, "onLCP", function () { return $a8bbae327abb303e$export$947b1626ab8d5632; });

var $dm1Gl = parcelRequire("dm1Gl");

var $2Yr7H = parcelRequire("2Yr7H");

var $fz0QK = parcelRequire("fz0QK");

var $dkA2Y = parcelRequire("dkA2Y");

var $1pcuY = parcelRequire("1pcuY");

var $bp3S2 = parcelRequire("bp3S2");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $a8bbae327abb303e$var$reportedMetricIDs = {};
/**
 * Calculates the [LCP](https://web.dev/lcp/) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 */ var $a8bbae327abb303e$export$947b1626ab8d5632 = function(onReport) {
    var visibilityWatcher = (0, $fz0QK.getVisibilityWatcher)();
    var metric = (0, $dkA2Y.initMetric)("LCP");
    var report;
    var handleEntries = function(entries) {
        var lastEntry = entries[entries.length - 1];
        if (lastEntry) {
            // The startTime attribute returns the value of the renderTime if it is
            // not 0, and the value of the loadTime otherwise. The activationStart
            // reference is used because LCP should be relative to page activation
            // rather than navigation start if the page was prerendered.
            var value = Math.max(lastEntry.startTime - (0, $2Yr7H.getActivationStart)(), 0);
            // Only report if the page wasn't hidden prior to LCP.
            if (value < visibilityWatcher.firstHiddenTime) {
                metric.value = value;
                metric.entries = [
                    lastEntry
                ];
                report();
            }
        }
    };
    var po = (0, $1pcuY.observe)("largest-contentful-paint", handleEntries);
    if (po) {
        report = (0, $dm1Gl.bindReporter)(onReport, metric);
        var stopListening = function() {
            if (!$a8bbae327abb303e$var$reportedMetricIDs[metric.id]) {
                handleEntries(po.takeRecords());
                po.disconnect();
                $a8bbae327abb303e$var$reportedMetricIDs[metric.id] = true;
                report(true);
            }
        };
        // Stop listening after input. Note: while scrolling is an input that
        // stop LCP observation, it's unreliable since it can be programmatically
        // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
        [
            "keydown",
            "click"
        ].forEach(function(type) {
            addEventListener(type, stopListening, {
                once: true,
                capture: true
            });
        });
        (0, $bp3S2.onHidden)(stopListening, true);
        return stopListening;
    }
    return;
};

});

parcelRegister("lauwa", function(module, exports) {

$parcel$export(module.exports, "isMeasurementValue", function () { return $f692345e1896c6ac$export$27169ccae1b439e3; });
$parcel$export(module.exports, "_startChild", function () { return $f692345e1896c6ac$export$8bd469e1f37aa721; });
/**
 * Checks if a given value is a valid measurement value.
 */ 
var $do9pw = parcelRequire("do9pw");

var $dRLPW = parcelRequire("dRLPW");
function $f692345e1896c6ac$export$27169ccae1b439e3(value) {
    return typeof value === "number" && isFinite(value);
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 */ function $f692345e1896c6ac$export$8bd469e1f37aa721(transaction, _param) {
    var startTimestamp = _param.startTimestamp, ctx = (0, $dRLPW._)(_param, [
        "startTimestamp"
    ]);
    if (startTimestamp && transaction.startTimestamp > startTimestamp) transaction.startTimestamp = startTimestamp;
    return transaction.startChild((0, $do9pw._)({
        startTimestamp: startTimestamp
    }, ctx));
}

});
parcelRegister("dRLPW", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a18554f914d0c57d$export$69fdd232f62cde60; });

var $8vV5y = parcelRequire("8vV5y");
function $a18554f914d0c57d$export$69fdd232f62cde60(source, excluded) {
    if (source == null) return {};
    var target = (0, $8vV5y._object_without_properties_loose)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});
parcelRegister("8vV5y", function(module, exports) {

$parcel$export(module.exports, "_object_without_properties_loose", function () { return $632d808f00de0e4b$export$7a4a7e38737aceb4; });
function $632d808f00de0e4b$export$7a4a7e38737aceb4(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});




parcelRegister("3njn2", function(module, exports) {

$parcel$export(module.exports, "defaultRequestInstrumentationOptions", function () { return $27528bad51355504$export$cc17fb3c0bc95cd7; });
$parcel$export(module.exports, "instrumentOutgoingRequests", function () { return $27528bad51355504$export$864489cb3478db3e; });

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");

var $1uvy1 = parcelRequire("1uvy1");
var $kzlIx = parcelRequire("kzlIx");
var $eodu0 = parcelRequire("eodu0");

var $MsrRH = parcelRequire("MsrRH");
var $gsjqs = parcelRequire("gsjqs");
var $kfF30 = parcelRequire("kfF30");
var $eedhm = parcelRequire("eedhm");
var $fFQTh = parcelRequire("fFQTh");
var $11858 = parcelRequire("11858");
/* eslint-disable max-lines */ var $27528bad51355504$export$15bd0305d05ad07b = [
    "localhost",
    /^\/(?!\/)/
];
/** Options for Request Instrumentation */ var $27528bad51355504$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true,
    // TODO (v8): Remove this property
    tracingOrigins: $27528bad51355504$export$15bd0305d05ad07b,
    tracePropagationTargets: $27528bad51355504$export$15bd0305d05ad07b
};
/** Registers span creators for xhr and fetch requests  */ function $27528bad51355504$export$864489cb3478db3e(_options) {
    var _$_object_spread = (0, $do9pw._)({
        traceFetch: $27528bad51355504$export$cc17fb3c0bc95cd7.traceFetch,
        traceXHR: $27528bad51355504$export$cc17fb3c0bc95cd7.traceXHR
    }, _options), traceFetch = _$_object_spread.traceFetch, traceXHR = _$_object_spread.traceXHR, // eslint-disable-next-line deprecation/deprecation
    tracePropagationTargets = _$_object_spread.tracePropagationTargets, // eslint-disable-next-line deprecation/deprecation
    tracingOrigins = _$_object_spread.tracingOrigins, shouldCreateSpanForRequest = _$_object_spread.shouldCreateSpanForRequest, enableHTTPTimings = _$_object_spread.enableHTTPTimings;
    var shouldCreateSpan = typeof shouldCreateSpanForRequest === "function" ? shouldCreateSpanForRequest : function(_) {
        return true;
    };
    // TODO(v8) Remove tracingOrigins here
    // The only reason we're passing it in here is because this instrumentOutgoingRequests function is publicly exported
    // and we don't want to break the API. We can remove it in v8.
    var shouldAttachHeadersWithTargets = function(url) {
        return $27528bad51355504$export$c260386ab3f0b3dd(url, tracePropagationTargets || tracingOrigins);
    };
    var spans = {};
    if (traceFetch) (0, $MsrRH.addInstrumentationHandler)("fetch", function(handlerData) {
        var createdSpan = $27528bad51355504$export$cd8846dd8ea4bd7a(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        if (enableHTTPTimings && createdSpan) $27528bad51355504$var$addHTTPTimings(createdSpan);
    });
    if (traceXHR) (0, $MsrRH.addInstrumentationHandler)("xhr", function(handlerData) {
        var createdSpan = $27528bad51355504$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        if (enableHTTPTimings && createdSpan) $27528bad51355504$var$addHTTPTimings(createdSpan);
    });
}
function $27528bad51355504$var$isPerformanceResourceTiming(entry) {
    return entry.entryType === "resource" && "initiatorType" in entry && typeof entry.nextHopProtocol === "string" && (entry.initiatorType === "fetch" || entry.initiatorType === "xmlhttprequest");
}
/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */ function $27528bad51355504$var$addHTTPTimings(span) {
    var url = span.data.url;
    var observer = new PerformanceObserver(function(list) {
        var entries = list.getEntries();
        entries.forEach(function(entry) {
            if ($27528bad51355504$var$isPerformanceResourceTiming(entry) && entry.name.endsWith(url)) {
                var _span;
                var spanData = $27528bad51355504$var$resourceTimingEntryToSpanData(entry);
                spanData.forEach(function(data) {
                    return (_span = span).setData.apply(_span, (0, $c6Xmf._)(data));
                });
                observer.disconnect();
            }
        });
    });
    observer.observe({
        entryTypes: [
            "resource"
        ]
    });
}
/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */ function $27528bad51355504$export$57c6f824442f9fe1(nextHopProtocol) {
    var name = "unknown";
    var version = "unknown";
    var _name = "";
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = nextHopProtocol[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var char = _step.value;
            // http/1.1 etc.
            if (char === "/") {
                var ref;
                ref = (0, $cv9Rk._)(nextHopProtocol.split("/"), 2), name = ref[0], version = ref[1], ref;
                break;
            }
            // h2, h3 etc.
            if (!isNaN(Number(char))) {
                name = _name === "h" ? "http" : _name;
                version = nextHopProtocol.split(_name)[1];
                break;
            }
            _name += char;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (_name === nextHopProtocol) // webrtc, ftp, etc.
    name = _name;
    return {
        name: name,
        version: version
    };
}
function $27528bad51355504$var$getAbsoluteTime() {
    var time = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return (((0, $kfF30.browserPerformanceTimeOrigin) || performance.timeOrigin) + time) / 1000;
}
function $27528bad51355504$var$resourceTimingEntryToSpanData(resourceTiming) {
    var _extractNetworkProtocol = $27528bad51355504$export$57c6f824442f9fe1(resourceTiming.nextHopProtocol), name = _extractNetworkProtocol.name, version = _extractNetworkProtocol.version;
    var timingSpanData = [];
    timingSpanData.push([
        "network.protocol.version",
        version
    ], [
        "network.protocol.name",
        name
    ]);
    if (!(0, $kfF30.browserPerformanceTimeOrigin)) return timingSpanData;
    return (0, $c6Xmf._)(timingSpanData).concat([
        [
            "http.request.redirect_start",
            $27528bad51355504$var$getAbsoluteTime(resourceTiming.redirectStart)
        ],
        [
            "http.request.fetch_start",
            $27528bad51355504$var$getAbsoluteTime(resourceTiming.fetchStart)
        ],
        [
            "http.request.domain_lookup_start",
            $27528bad51355504$var$getAbsoluteTime(resourceTiming.domainLookupStart)
        ],
        [
            "http.request.domain_lookup_end",
            $27528bad51355504$var$getAbsoluteTime(resourceTiming.domainLookupEnd)
        ],
        [
            "http.request.connect_start",
            $27528bad51355504$var$getAbsoluteTime(resourceTiming.connectStart)
        ],
        [
            "http.request.secure_connection_start",
            $27528bad51355504$var$getAbsoluteTime(resourceTiming.secureConnectionStart)
        ],
        [
            "http.request.connection_end",
            $27528bad51355504$var$getAbsoluteTime(resourceTiming.connectEnd)
        ],
        [
            "http.request.request_start",
            $27528bad51355504$var$getAbsoluteTime(resourceTiming.requestStart)
        ],
        [
            "http.request.response_start",
            $27528bad51355504$var$getAbsoluteTime(resourceTiming.responseStart)
        ],
        [
            "http.request.response_end",
            $27528bad51355504$var$getAbsoluteTime(resourceTiming.responseEnd)
        ]
    ]);
}
/**
 * A function that determines whether to attach tracing headers to a request.
 * This was extracted from `instrumentOutgoingRequests` to make it easier to test shouldAttachHeaders.
 * We only export this fuction for testing purposes.
 */ function $27528bad51355504$export$c260386ab3f0b3dd(url, tracePropagationTargets) {
    return (0, $11858.stringMatchesSomePattern)(url, tracePropagationTargets || $27528bad51355504$export$15bd0305d05ad07b);
}
/**
 * Create and track fetch request spans
 *
 * @returns Span if a span was created, otherwise void.
 */ function $27528bad51355504$export$cd8846dd8ea4bd7a(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    if (!(0, $eodu0.hasTracingEnabled)() || !handlerData.fetchData) return undefined;
    var shouldCreateSpanResult = shouldCreateSpan(handlerData.fetchData.url);
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        var spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        var span = spans[spanId];
        if (span) {
            if (handlerData.response) {
                // TODO (kmclb) remove this once types PR goes through
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                span.setHttpStatus(handlerData.response.status);
                var contentLength = // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                handlerData.response && handlerData.response.headers && handlerData.response.headers.get("content-length");
                var contentLengthNum = parseInt(contentLength);
                if (contentLengthNum > 0) span.setData("http.response_content_length", contentLengthNum);
            } else if (handlerData.error) span.setStatus("internal_error");
            span.finish();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    var hub = (0, $1uvy1.getCurrentHub)();
    var scope = hub.getScope();
    var client = hub.getClient();
    var parentSpan = scope.getSpan();
    var _handlerData_fetchData = handlerData.fetchData, method = _handlerData_fetchData.method, url = _handlerData_fetchData.url;
    var span1 = shouldCreateSpanResult && parentSpan ? parentSpan.startChild({
        data: {
            url: url,
            type: "fetch",
            "http.method": method
        },
        description: "".concat(method, " ").concat(url),
        op: "http.client",
        origin: "auto.http.browser"
    }) : undefined;
    if (span1) {
        handlerData.fetchData.__span = span1.spanId;
        spans[span1.spanId] = span1;
    }
    if (shouldAttachHeaders(handlerData.fetchData.url) && client) {
        var request = handlerData.args[0];
        // In case the user hasn't set the second argument of a fetch call we default it to `{}`.
        handlerData.args[1] = handlerData.args[1] || {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var options = handlerData.args[1];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
        options.headers = $27528bad51355504$export$6717acf674206871(request, client, scope, options, span1);
    }
    return span1;
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers
 */ function $27528bad51355504$export$6717acf674206871(request, client, scope, options, requestSpan) {
    var span = requestSpan || scope.getSpan();
    var transaction = span && span.transaction;
    var _scope_getPropagationContext = scope.getPropagationContext(), traceId = _scope_getPropagationContext.traceId, sampled = _scope_getPropagationContext.sampled, dsc = _scope_getPropagationContext.dsc;
    var sentryTraceHeader = span ? span.toTraceparent() : (0, $eedhm.generateSentryTraceHeader)(traceId, undefined, sampled);
    var dynamicSamplingContext = transaction ? transaction.getDynamicSamplingContext() : dsc ? dsc : (0, $kzlIx.getDynamicSamplingContextFromClient)(traceId, client, scope);
    var sentryBaggageHeader = (0, $gsjqs.dynamicSamplingContextToSentryBaggageHeader)(dynamicSamplingContext);
    var headers = typeof Request !== "undefined" && (0, $fFQTh.isInstanceOf)(request, Request) ? request.headers : options.headers;
    if (!headers) return {
        "sentry-trace": sentryTraceHeader,
        baggage: sentryBaggageHeader
    };
    else if (typeof Headers !== "undefined" && (0, $fFQTh.isInstanceOf)(headers, Headers)) {
        var newHeaders = new Headers(headers);
        newHeaders.append("sentry-trace", sentryTraceHeader);
        if (sentryBaggageHeader) // If the same header is appended multiple times the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.append((0, $gsjqs.BAGGAGE_HEADER_NAME), sentryBaggageHeader);
        return newHeaders;
    } else if (Array.isArray(headers)) {
        var newHeaders1 = (0, $c6Xmf._)(headers).concat([
            [
                "sentry-trace",
                sentryTraceHeader
            ]
        ]);
        if (sentryBaggageHeader) // If there are multiple entries with the same key, the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders1.push([
            (0, $gsjqs.BAGGAGE_HEADER_NAME),
            sentryBaggageHeader
        ]);
        return newHeaders1;
    } else {
        var _newBaggageHeaders;
        var existingBaggageHeader = "baggage" in headers ? headers.baggage : undefined;
        var newBaggageHeaders = [];
        if (Array.isArray(existingBaggageHeader)) (_newBaggageHeaders = newBaggageHeaders).push.apply(_newBaggageHeaders, (0, $c6Xmf._)(existingBaggageHeader));
        else if (existingBaggageHeader) newBaggageHeaders.push(existingBaggageHeader);
        if (sentryBaggageHeader) newBaggageHeaders.push(sentryBaggageHeader);
        return (0, $cxjpp._)((0, $do9pw._)({}, headers), {
            "sentry-trace": sentryTraceHeader,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(",") : undefined
        });
    }
}
/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */ // eslint-disable-next-line complexity
function $27528bad51355504$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    var xhr = handlerData.xhr;
    var sentryXhrData = xhr && xhr[0, $MsrRH.SENTRY_XHR_DATA_KEY];
    if (!(0, $eodu0.hasTracingEnabled)() || xhr && xhr.__sentry_own_request__ || !xhr || !sentryXhrData) return undefined;
    var shouldCreateSpanResult = shouldCreateSpan(sentryXhrData.url);
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        var spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        var span = spans[spanId];
        if (span) {
            span.setHttpStatus(sentryXhrData.status_code);
            span.finish();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    var hub = (0, $1uvy1.getCurrentHub)();
    var scope = hub.getScope();
    var parentSpan = scope.getSpan();
    var span1 = shouldCreateSpanResult && parentSpan ? parentSpan.startChild({
        data: (0, $cxjpp._)((0, $do9pw._)({}, sentryXhrData.data), {
            type: "xhr",
            "http.method": sentryXhrData.method,
            url: sentryXhrData.url
        }),
        description: "".concat(sentryXhrData.method, " ").concat(sentryXhrData.url),
        op: "http.client",
        origin: "auto.http.browser"
    }) : undefined;
    if (span1) {
        xhr.__sentry_xhr_span_id__ = span1.spanId;
        spans[xhr.__sentry_xhr_span_id__] = span1;
    }
    if (xhr.setRequestHeader && shouldAttachHeaders(sentryXhrData.url)) {
        if (span1) {
            var transaction = span1 && span1.transaction;
            var dynamicSamplingContext = transaction && transaction.getDynamicSamplingContext();
            var sentryBaggageHeader = (0, $gsjqs.dynamicSamplingContextToSentryBaggageHeader)(dynamicSamplingContext);
            $27528bad51355504$var$setHeaderOnXhr(xhr, span1.toTraceparent(), sentryBaggageHeader);
        } else {
            var client = hub.getClient();
            var _scope_getPropagationContext = scope.getPropagationContext(), traceId = _scope_getPropagationContext.traceId, sampled = _scope_getPropagationContext.sampled, dsc = _scope_getPropagationContext.dsc;
            var sentryTraceHeader = (0, $eedhm.generateSentryTraceHeader)(traceId, undefined, sampled);
            var dynamicSamplingContext1 = dsc || (client ? (0, $kzlIx.getDynamicSamplingContextFromClient)(traceId, client, scope) : undefined);
            var sentryBaggageHeader1 = (0, $gsjqs.dynamicSamplingContextToSentryBaggageHeader)(dynamicSamplingContext1);
            $27528bad51355504$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader1);
        }
    }
    return span1;
}
function $27528bad51355504$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader("sentry-trace", sentryTraceHeader);
        if (sentryBaggageHeader) // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
        // We can therefore simply set a baggage header without checking what was there before
        // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader((0, $gsjqs.BAGGAGE_HEADER_NAME), sentryBaggageHeader);
    } catch (_) {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
    }
}

});

parcelRegister("c57Gp", function(module, exports) {

$parcel$export(module.exports, "instrumentRoutingWithDefaults", function () { return $8cbbe957fe92a2c3$export$86649cc09fe75143; });

var $MsrRH = parcelRequire("MsrRH");
var $kfF30 = parcelRequire("kfF30");
var $fNn7q = parcelRequire("fNn7q");

var $5ecgN = parcelRequire("5ecgN");
/**
 * Default function implementing pageload and navigation transactions
 */ function $8cbbe957fe92a2c3$export$86649cc09fe75143(customStartTransaction) {
    var startTransactionOnPageLoad = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, startTransactionOnLocationChange = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (!(0, $5ecgN.WINDOW) || !(0, $5ecgN.WINDOW).location) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).warn("Could not initialize routing instrumentation due to invalid location");
        return;
    }
    var startingUrl = (0, $5ecgN.WINDOW).location.href;
    var activeTransaction;
    if (startTransactionOnPageLoad) activeTransaction = customStartTransaction({
        name: (0, $5ecgN.WINDOW).location.pathname,
        // pageload should always start at timeOrigin (and needs to be in s, not ms)
        startTimestamp: (0, $kfF30.browserPerformanceTimeOrigin) ? (0, $kfF30.browserPerformanceTimeOrigin) / 1000 : undefined,
        op: "pageload",
        origin: "auto.pageload.browser",
        metadata: {
            source: "url"
        }
    });
    if (startTransactionOnLocationChange) (0, $MsrRH.addInstrumentationHandler)("history", function(param) {
        var to = param.to, from = param.from;
        /**
       * This early return is there to account for some cases where a navigation transaction starts right after
       * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
       * create an uneccessary navigation transaction.
       *
       * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
       * only be caused in certain development environments where the usage of a hot module reloader is causing
       * errors.
       */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
            startingUrl = undefined;
            return;
        }
        if (from !== to) {
            startingUrl = undefined;
            if (activeTransaction) {
                (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).log("[Tracing] Finishing current transaction with op: ".concat(activeTransaction.op));
                // If there's an open transaction on the scope, we need to finish it before creating an new one.
                activeTransaction.finish();
            }
            activeTransaction = customStartTransaction({
                name: (0, $5ecgN.WINDOW).location.pathname,
                op: "navigation",
                origin: "auto.navigation.browser",
                metadata: {
                    source: "url"
                }
            });
        }
    });
}

});


parcelRegister("7J1do", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", function () { return $59fdadabfbe3845c$export$e926676385687eaf; });

var $d3H5E = parcelRequire("d3H5E");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $ohfOJ = parcelRequire("ohfOJ");

var $krMfp = parcelRequire("krMfp");
var $1uvy1 = parcelRequire("1uvy1");
var $jI6fQ = parcelRequire("jI6fQ");

var $9MzNF = parcelRequire("9MzNF");
var $fFQTh = parcelRequire("fFQTh");
var $fNn7q = parcelRequire("fNn7q");

var $knVHJ = parcelRequire("knVHJ");

var $1Mpn7 = parcelRequire("1Mpn7");
var $59fdadabfbe3845c$var$_jsxFileName = "/home/runner/work/sentry-javascript/sentry-javascript/packages/react/src/errorboundary.tsx";
function $59fdadabfbe3845c$export$a87138b73900f5b(version) {
    var major = version.match(/^([^.]+)/);
    return major !== null && parseInt(major[0]) >= 17;
}
var $59fdadabfbe3845c$export$6ef4c0367e27f2d5 = "unknown";
var $59fdadabfbe3845c$var$INITIAL_STATE = {
    componentStack: null,
    error: null,
    eventId: null
};
function $59fdadabfbe3845c$var$setCause(error, cause) {
    var seenErrors = new WeakMap();
    function recurse(error, cause) {
        // If we've already seen the error, there is a recursive loop somewhere in the error's
        // cause chain. Let's just bail out then to prevent a stack overflow.
        if (seenErrors.has(error)) return;
        if (error.cause) {
            seenErrors.set(error, true);
            return recurse(error.cause, cause);
        }
        error.cause = cause;
    }
    recurse(error, cause);
}
/**
 * A ErrorBoundary component that logs errors to Sentry. Requires React >= 16.
 * NOTE: If you are a Sentry user, and you are seeing this stack frame, it means the
 * Sentry React SDK ErrorBoundary caught an error invoking your application code. This
 * is expected behavior and NOT indicative of a bug with the Sentry React SDK.
 */ var $59fdadabfbe3845c$export$e926676385687eaf = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $dcsZi._)(ErrorBoundary, _React_Component);
    var _super = (0, $ohfOJ._)(ErrorBoundary);
    function ErrorBoundary(props) {
        (0, $4GJKx._)(this, ErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        ErrorBoundary.prototype.__init.call((0, $d3H5E._)(_this));
        _this.state = $59fdadabfbe3845c$var$INITIAL_STATE;
        _this._openFallbackReportDialog = true;
        var client = (0, $1uvy1.getCurrentHub)().getClient();
        if (client && client.on && props.showDialog) {
            _this._openFallbackReportDialog = false;
            client.on("afterSendEvent", function(event) {
                if (!event.type && event.event_id === _this._lastEventId) (0, $jI6fQ.showReportDialog)((0, $cxjpp._)((0, $do9pw._)({}, props.dialogOptions), {
                    eventId: _this._lastEventId
                }));
            });
        }
        return _this;
    }
    (0, $1wc17._)(ErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, param) {
                var componentStack = param.componentStack;
                var _this = this;
                var _this_props = this.props, beforeCapture = _this_props.beforeCapture, onError = _this_props.onError, showDialog = _this_props.showDialog, dialogOptions = _this_props.dialogOptions;
                (0, $krMfp.withScope)(function(scope) {
                    // If on React version >= 17, create stack trace from componentStack param and links
                    // to to the original error using `error.cause` otherwise relies on error param for stacktrace.
                    // Linking errors requires the `LinkedErrors` integration be enabled.
                    // See: https://reactjs.org/blog/2020/08/10/react-v17-rc.html#native-component-stacks
                    //
                    // Although `componentDidCatch` is typed to accept an `Error` object, it can also be invoked
                    // with non-error objects. This is why we need to check if the error is an error-like object.
                    // See: https://github.com/getsentry/sentry-javascript/issues/6167
                    if ($59fdadabfbe3845c$export$a87138b73900f5b($1Mpn7.version) && (0, $fFQTh.isError)(error)) {
                        var errorBoundaryError = new Error(error.message);
                        errorBoundaryError.name = "React ErrorBoundary ".concat(error.name);
                        errorBoundaryError.stack = componentStack;
                        // Using the `LinkedErrors` integration to link the errors together.
                        $59fdadabfbe3845c$var$setCause(error, errorBoundaryError);
                    }
                    if (beforeCapture) beforeCapture(scope, error, componentStack);
                    scope.addEventProcessor(function(event) {
                        (0, $9MzNF.addExceptionMechanism)(event, {
                            handled: false
                        });
                        return event;
                    });
                    var eventId = (0, $krMfp.captureException)(error, {
                        contexts: {
                            react: {
                                componentStack: componentStack
                            }
                        }
                    });
                    if (onError) onError(error, componentStack, eventId);
                    if (showDialog) {
                        _this._lastEventId = eventId;
                        if (_this._openFallbackReportDialog) (0, $jI6fQ.showReportDialog)((0, $cxjpp._)((0, $do9pw._)({}, dialogOptions), {
                            eventId: eventId
                        }));
                    }
                    // componentDidCatch is used over getDerivedStateFromError
                    // so that componentStack is accessible through state.
                    _this.setState({
                        error: error,
                        componentStack: componentStack,
                        eventId: eventId
                    });
                });
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var onMount = this.props.onMount;
                if (onMount) onMount();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                var _this_state = this.state, error = _this_state.error, componentStack = _this_state.componentStack, eventId = _this_state.eventId;
                var onUnmount = this.props.onUnmount;
                if (onUnmount) onUnmount(error, componentStack, eventId);
            }
        },
        {
            key: "__init",
            value: function __init() {
                var _this = this;
                this.resetErrorBoundary = function() {
                    var onReset = _this.props.onReset;
                    var _this_state = _this.state, error = _this_state.error, componentStack = _this_state.componentStack, eventId = _this_state.eventId;
                    if (onReset) onReset(error, componentStack, eventId);
                    _this.setState($59fdadabfbe3845c$var$INITIAL_STATE);
                };
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, fallback = _this_props.fallback, children = _this_props.children;
                var state = this.state;
                if (state.error) {
                    var element = undefined;
                    if (typeof fallback === "function") element = fallback({
                        error: state.error,
                        componentStack: state.componentStack,
                        resetError: this.resetErrorBoundary,
                        eventId: state.eventId
                    });
                    else element = fallback;
                    if ($1Mpn7.isValidElement(element)) return element;
                    if (fallback) (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).warn("fallback did not produce a valid ReactElement");
                    // Fail gracefully if no fallback provided or is not valid
                    return null;
                }
                if (typeof children === "function") return children();
                return children;
            }
        }
    ]);
    return ErrorBoundary;
}($1Mpn7.Component);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $59fdadabfbe3845c$export$f0c7a449e0cfaec7(WrappedComponent, errorBoundaryOptions) {
    var _this = this;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    var componentDisplayName = WrappedComponent.displayName || WrappedComponent.name || $59fdadabfbe3845c$export$6ef4c0367e27f2d5;
    var Wrapped = function(props) {
        return $1Mpn7.createElement($59fdadabfbe3845c$export$e926676385687eaf, (0, $cxjpp._)((0, $do9pw._)({}, errorBoundaryOptions), {
            __self: _this,
            __source: {
                fileName: $59fdadabfbe3845c$var$_jsxFileName,
                lineNumber: 234
            }
        }), $1Mpn7.createElement(WrappedComponent, (0, $cxjpp._)((0, $do9pw._)({}, props), {
            __self: _this,
            __source: {
                fileName: $59fdadabfbe3845c$var$_jsxFileName,
                lineNumber: 235
            }
        })));
    };
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    Wrapped.displayName = "errorBoundary(".concat(componentDisplayName, ")");
    // Copy over static methods from Wrapped component to Profiler HOC
    // See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
    (0, (/*@__PURE__*/$parcel$interopDefault($knVHJ)))(Wrapped, WrappedComponent);
    return Wrapped;
}

});
parcelRegister("krMfp", function(module, exports) {

$parcel$export(module.exports, "captureException", function () { return $03d76a578dfc21ed$export$f5282963edea4a68; });
$parcel$export(module.exports, "withScope", function () { return $03d76a578dfc21ed$export$ec58d9285c204497; });

var $kSuI9 = parcelRequire("kSuI9");

var $do9pw = parcelRequire("do9pw");

var $l29cN = parcelRequire("l29cN");

var $fNn7q = parcelRequire("fNn7q");
var $9MzNF = parcelRequire("9MzNF");

var $1uvy1 = parcelRequire("1uvy1");
// Note: All functions in this file are typed with a return value of `ReturnType<Hub[HUB_FUNCTION]>`,
// where HUB_FUNCTION is some method on the Hub class.
//
// This is done to make sure the top level SDK methods stay in sync with the hub methods.
// Although every method here has an explicit return type, some of them (that map to void returns) do not
// contain `return` keywords. This is done to save on bundle size, as `return` is not minifiable.
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception An exception-like object.
 * @param captureContext Additional scope data to apply to exception event.
 * @returns The generated eventId.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function $03d76a578dfc21ed$export$f5282963edea4a68(exception, captureContext) {
    return (0, $1uvy1.getCurrentHub)().captureException(exception, {
        captureContext: captureContext
    });
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param Severity Define the level of the message.
 * @returns The generated eventId.
 */ function $03d76a578dfc21ed$export$45654777c133ae80(message, // eslint-disable-next-line deprecation/deprecation
captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    var level = typeof captureContext === "string" ? captureContext : undefined;
    var context = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : undefined;
    return (0, $1uvy1.getCurrentHub)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @returns The generated eventId.
 */ function $03d76a578dfc21ed$export$1462b974fdcf6ba2(event, hint) {
    return (0, $1uvy1.getCurrentHub)().captureEvent(event, hint);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 */ function $03d76a578dfc21ed$export$99d44f04437e9cb8(callback) {
    (0, $1uvy1.getCurrentHub)().configureScope(callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */ function $03d76a578dfc21ed$export$efda9a273d7a036d(breadcrumb) {
    (0, $1uvy1.getCurrentHub)().addBreadcrumb(breadcrumb);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $03d76a578dfc21ed$export$2f04de43fe27971a(name, context) {
    (0, $1uvy1.getCurrentHub)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function $03d76a578dfc21ed$export$bb4922da0dd51b92(extras) {
    (0, $1uvy1.getCurrentHub)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function $03d76a578dfc21ed$export$8e8e7789d42ed61d(key, extra) {
    (0, $1uvy1.getCurrentHub)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function $03d76a578dfc21ed$export$74a8fb34822092e6(tags) {
    (0, $1uvy1.getCurrentHub)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function $03d76a578dfc21ed$export$a37d07ee78eb4569(key, value) {
    (0, $1uvy1.getCurrentHub)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function $03d76a578dfc21ed$export$8b6bb3dd62a01be2(user) {
    (0, $1uvy1.getCurrentHub)().setUser(user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 *
 * @param callback that will be enclosed into push/popScope.
 */ function $03d76a578dfc21ed$export$ec58d9285c204497(callback) {
    (0, $1uvy1.getCurrentHub)().withScope(callback);
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.finish()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 */ function $03d76a578dfc21ed$export$e262da7ae6480481(context, customSamplingContext) {
    return (0, $1uvy1.getCurrentHub)().startTransaction((0, $do9pw._)({}, context), customSamplingContext);
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $03d76a578dfc21ed$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    var hub = (0, $1uvy1.getCurrentHub)();
    var scope = hub.getScope();
    var client = hub.getClient();
    if (!client) (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).warn("Cannot capture check-in. No client defined.");
    else if (!client.captureCheckIn) (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).warn("Cannot capture check-in. Client does not support sending check-ins.");
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $9MzNF.uuid4)();
}
function $03d76a578dfc21ed$export$4909b86c8034bf73(timeout) {
    return $03d76a578dfc21ed$var$_flush.apply(this, arguments);
}
function $03d76a578dfc21ed$var$_flush() {
    $03d76a578dfc21ed$var$_flush = /**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ (0, $kSuI9._)(function(timeout) {
        var client;
        return (0, $l29cN.__generator)(this, function(_state) {
            client = (0, $1uvy1.getCurrentHub)().getClient();
            if (client) return [
                2,
                client.flush(timeout)
            ];
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).warn("Cannot flush events. No client defined.");
            return [
                2,
                Promise.resolve(false)
            ];
        });
    });
    return $03d76a578dfc21ed$var$_flush.apply(this, arguments);
}
function $03d76a578dfc21ed$export$8360e631d277ea4d(timeout) {
    return $03d76a578dfc21ed$var$_close.apply(this, arguments);
}
function $03d76a578dfc21ed$var$_close() {
    $03d76a578dfc21ed$var$_close = /**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ (0, $kSuI9._)(function(timeout) {
        var client;
        return (0, $l29cN.__generator)(this, function(_state) {
            client = (0, $1uvy1.getCurrentHub)().getClient();
            if (client) return [
                2,
                client.close(timeout)
            ];
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).warn("Cannot flush events and disable SDK. No client defined.");
            return [
                2,
                Promise.resolve(false)
            ];
        });
    });
    return $03d76a578dfc21ed$var$_close.apply(this, arguments);
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */ function $03d76a578dfc21ed$export$5d4e9fd7fac8e617() {
    return (0, $1uvy1.getCurrentHub)().lastEventId();
}

});

parcelRegister("jI6fQ", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $e596fa6e073f9282$export$2cd8252107eb640b; });
$parcel$export(module.exports, "showReportDialog", function () { return $e596fa6e073f9282$export$3a8fd680da42627b; });

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $1uvy1 = parcelRequire("1uvy1");
var $4cPVl = parcelRequire("4cPVl");
var $9SEP8 = parcelRequire("9SEP8");
var $bFwPW = parcelRequire("bFwPW");
var $kZOwK = parcelRequire("kZOwK");

var $MsrRH = parcelRequire("MsrRH");
var $fNn7q = parcelRequire("fNn7q");
var $5cx56 = parcelRequire("5cx56");
var $2D0U7 = parcelRequire("2D0U7");

var $4aKu9 = parcelRequire("4aKu9");

var $1OIkc = parcelRequire("1OIkc");

var $3GhmO = parcelRequire("3GhmO");

var $kmUcC = parcelRequire("kmUcC");

var $ggWN2 = parcelRequire("ggWN2");

var $aFeNW = parcelRequire("aFeNW");

var $gOg06 = parcelRequire("gOg06");

var $8RDo5 = parcelRequire("8RDo5");

var $9H2dV = parcelRequire("9H2dV");

var $gBeZr = parcelRequire("gBeZr");

var $3V7vj = parcelRequire("3V7vj");
var $e596fa6e073f9282$export$5ef831fccfce35e5 = [
    new (0, $kZOwK).InboundFilters(),
    new (0, $kZOwK).FunctionToString(),
    new (0, $kmUcC.TryCatch)(),
    new (0, $ggWN2.Breadcrumbs)(),
    new (0, $3GhmO.GlobalHandlers)(),
    new (0, $aFeNW.LinkedErrors)(),
    new (0, $8RDo5.Dedupe)(),
    new (0, $gOg06.HttpContext)()
];
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $e596fa6e073f9282$export$2cd8252107eb640b() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $e596fa6e073f9282$export$5ef831fccfce35e5;
    if (options.release === undefined) {
        // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
        if (typeof __SENTRY_RELEASE__ === "string") options.release = __SENTRY_RELEASE__;
        // This supports the variable that sentry-webpack-plugin injects
        if ((0, $1OIkc.WINDOW).SENTRY_RELEASE && (0, $1OIkc.WINDOW).SENTRY_RELEASE.id) options.release = (0, $1OIkc.WINDOW).SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    var clientOptions = (0, $cxjpp._)((0, $do9pw._)({}, options), {
        stackParser: (0, $5cx56.stackParserFromStackParserOptions)(options.stackParser || (0, $9H2dV.defaultStackParser)),
        integrations: (0, $4cPVl.getIntegrationsToSetup)(options),
        transport: options.transport || ((0, $2D0U7.supportsFetch)() ? (0, $gBeZr.makeFetchTransport) : (0, $3V7vj.makeXHRTransport))
    });
    (0, $bFwPW.initAndBind)((0, $4aKu9.BrowserClient), clientOptions);
    if (options.autoSessionTracking) $e596fa6e073f9282$var$startSessionTracking();
}
/**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */ function $e596fa6e073f9282$export$3a8fd680da42627b() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, hub = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, $1uvy1.getCurrentHub)();
    // doesn't work without a document (React Native)
    if (!(0, $1OIkc.WINDOW).document) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).error("Global document not defined in showReportDialog call");
        return;
    }
    var _hub_getStackTop = hub.getStackTop(), client = _hub_getStackTop.client, scope = _hub_getStackTop.scope;
    var dsn = options.dsn || client && client.getDsn();
    if (!dsn) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).error("DSN not configured for showReportDialog call");
        return;
    }
    if (scope) options.user = (0, $do9pw._)({}, scope.getUser(), options.user);
    if (!options.eventId) options.eventId = hub.lastEventId();
    var script = (0, $1OIkc.WINDOW).document.createElement("script");
    script.async = true;
    script.crossOrigin = "anonymous";
    script.src = (0, $9SEP8.getReportDialogEndpoint)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    var injectionPoint = (0, $1OIkc.WINDOW).document.head || (0, $1OIkc.WINDOW).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).error("Not injecting report dialog. No injection point found in HTML");
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $e596fa6e073f9282$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $e596fa6e073f9282$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @deprecated This function will be removed in v8.
 * It is not part of Sentry's official API and it's easily replaceable by using a try/catch block
 * and calling Sentry.captureException.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */ // TODO(v8): Remove this function
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e596fa6e073f9282$export$4997ffc0176396a6(fn) {
    return (0, $1OIkc.wrap)(fn)();
}
function $e596fa6e073f9282$var$startSessionOnHub(hub) {
    hub.startSession({
        ignoreDuration: true
    });
    hub.captureSession();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $e596fa6e073f9282$var$startSessionTracking() {
    if (typeof (0, $1OIkc.WINDOW).document === "undefined") {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).warn("Session tracking in non-browser environment with @sentry/browser is not supported.");
        return;
    }
    var hub = (0, $1uvy1.getCurrentHub)();
    // The only way for this to be false is for there to be a version mismatch between @sentry/browser (>= 6.0.0) and
    // @sentry/hub (< 5.27.0). In the simple case, there won't ever be such a mismatch, because the two packages are
    // pinned at the same version in package.json, but there are edge cases where it's possible. See
    // https://github.com/getsentry/sentry-javascript/issues/3207 and
    // https://github.com/getsentry/sentry-javascript/issues/3234 and
    // https://github.com/getsentry/sentry-javascript/issues/3278.
    if (!hub.captureSession) return;
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    $e596fa6e073f9282$var$startSessionOnHub(hub);
    // We want to create a session for every navigation as well
    (0, $MsrRH.addInstrumentationHandler)("history", function(param) {
        var from = param.from, to = param.to;
        // Don't create an additional session for the initial route or if the location did not change
        if (!(from === undefined || from === to)) $e596fa6e073f9282$var$startSessionOnHub((0, $1uvy1.getCurrentHub)());
    });
}
/**
 * Captures user feedback and sends it to Sentry.
 */ function $e596fa6e073f9282$export$88cefaf72d1e58a3(feedback) {
    var client = (0, $1uvy1.getCurrentHub)().getClient();
    if (client) client.captureUserFeedback(feedback);
}

});
parcelRegister("4cPVl", function(module, exports) {

$parcel$export(module.exports, "getIntegrationsToSetup", function () { return $31008f6fb8fe11e5$export$68bc4c01ab8ae766; });
$parcel$export(module.exports, "setupIntegrations", function () { return $31008f6fb8fe11e5$export$51abed9797baa598; });
$parcel$export(module.exports, "setupIntegration", function () { return $31008f6fb8fe11e5$export$e7390a03b70a6f2f; });

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");

var $9MzNF = parcelRequire("9MzNF");
var $fNn7q = parcelRequire("fNn7q");

var $bCXHP = parcelRequire("bCXHP");

var $1uvy1 = parcelRequire("1uvy1");
var $31008f6fb8fe11e5$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */ function $31008f6fb8fe11e5$var$filterDuplicates(integrations) {
    var integrationsByName = {};
    integrations.forEach(function(currentInstance) {
        var name = currentInstance.name;
        var existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.keys(integrationsByName).map(function(k) {
        return integrationsByName[k];
    });
}
/** Gets integrations to install */ function $31008f6fb8fe11e5$export$68bc4c01ab8ae766(options) {
    var defaultIntegrations = options.defaultIntegrations || [];
    var userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach(function(integration) {
        integration.isDefaultInstance = true;
    });
    var integrations;
    if (Array.isArray(userIntegrations)) integrations = (0, $c6Xmf._)(defaultIntegrations).concat((0, $c6Xmf._)(userIntegrations));
    else if (typeof userIntegrations === "function") integrations = (0, $9MzNF.arrayify)(userIntegrations(defaultIntegrations));
    else integrations = defaultIntegrations;
    var finalIntegrations = $31008f6fb8fe11e5$var$filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    var debugIndex = $31008f6fb8fe11e5$var$findIndex(finalIntegrations, function(integration) {
        return integration.name === "Debug";
    });
    if (debugIndex !== -1) {
        var _finalIntegrations_splice = (0, $cv9Rk._)(finalIntegrations.splice(debugIndex, 1), 1), debugInstance = _finalIntegrations_splice[0];
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $31008f6fb8fe11e5$export$51abed9797baa598(client, integrations) {
    var integrationIndex = {};
    integrations.forEach(function(integration) {
        // guard against empty provided integrations
        if (integration) $31008f6fb8fe11e5$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/** Setup a single integration.  */ function $31008f6fb8fe11e5$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    integrationIndex[integration.name] = integration;
    if ($31008f6fb8fe11e5$export$b14a8888f80a0b3e.indexOf(integration.name) === -1) {
        integration.setupOnce((0, $bCXHP.addGlobalEventProcessor), (0, $1uvy1.getCurrentHub));
        $31008f6fb8fe11e5$export$b14a8888f80a0b3e.push(integration.name);
    }
    if (client.on && typeof integration.preprocessEvent === "function") {
        var callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", function(event, hint) {
            return callback(event, hint, client);
        });
    }
    if (client.addEventProcessor && typeof integration.processEvent === "function") {
        var callback1 = integration.processEvent.bind(integration);
        var processor = Object.assign(function(event, hint) {
            return callback1(event, hint, client);
        }, {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).log("Integration installed: ".concat(integration.name));
}
/** Add an integration to the current hub's client. */ function $31008f6fb8fe11e5$export$2d8f5188773bcddd(integration) {
    var client = (0, $1uvy1.getCurrentHub)().getClient();
    if (!client || !client.addIntegration) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).warn('Cannot add integration "'.concat(integration.name, '" because no SDK Client is available.'));
        return;
    }
    client.addIntegration(integration);
}
// Polyfill for Array.findIndex(), which is not supported in ES5
function $31008f6fb8fe11e5$var$findIndex(arr, callback) {
    for(var i = 0; i < arr.length; i++){
        if (callback(arr[i]) === true) return i;
    }
    return -1;
}

});

parcelRegister("9SEP8", function(module, exports) {

$parcel$export(module.exports, "getEnvelopeEndpointWithUrlEncodedAuth", function () { return $7318d2f7289cc8e7$export$9964600bfe84e6a3; });
$parcel$export(module.exports, "getReportDialogEndpoint", function () { return $7318d2f7289cc8e7$export$671c7ed8e40a7a57; });

var $do9pw = parcelRequire("do9pw");

var $lfm44 = parcelRequire("lfm44");
var $9QLqp = parcelRequire("9QLqp");
var $7318d2f7289cc8e7$var$SENTRY_API_VERSION = "7";
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $7318d2f7289cc8e7$var$getBaseApiEndpoint(dsn) {
    var protocol = dsn.protocol ? "".concat(dsn.protocol, ":") : "";
    var port = dsn.port ? ":".concat(dsn.port) : "";
    return "".concat(protocol, "//").concat(dsn.host).concat(port).concat(dsn.path ? "/".concat(dsn.path) : "", "/api/");
}
/** Returns the ingest API endpoint for target. */ function $7318d2f7289cc8e7$var$_getIngestEndpoint(dsn) {
    return "".concat($7318d2f7289cc8e7$var$getBaseApiEndpoint(dsn)).concat(dsn.projectId, "/envelope/");
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $7318d2f7289cc8e7$var$_encodedAuth(dsn, sdkInfo) {
    return (0, $9QLqp.urlEncode)((0, $do9pw._)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $7318d2f7289cc8e7$var$SENTRY_API_VERSION
    }, sdkInfo && {
        sentry_client: "".concat(sdkInfo.name, "/").concat(sdkInfo.version)
    }));
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $7318d2f7289cc8e7$export$9964600bfe84e6a3(dsn) {
    var // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
    // options: ClientOptions = {} as ClientOptions,
    tunnelOrOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    // TODO (v8): Use this code instead
    // const { tunnel, _metadata = {} } = options;
    // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;
    var tunnel = typeof tunnelOrOptions === "string" ? tunnelOrOptions : tunnelOrOptions.tunnel;
    var sdkInfo = typeof tunnelOrOptions === "string" || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;
    return tunnel ? tunnel : "".concat($7318d2f7289cc8e7$var$_getIngestEndpoint(dsn), "?").concat($7318d2f7289cc8e7$var$_encodedAuth(dsn, sdkInfo));
}
/** Returns the url to the report dialog endpoint. */ function $7318d2f7289cc8e7$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    var dsn = (0, $lfm44.makeDsn)(dsnLike);
    if (!dsn) return "";
    var endpoint = "".concat($7318d2f7289cc8e7$var$getBaseApiEndpoint(dsn), "embed/error-page/");
    var encodedOptions = "dsn=".concat((0, $lfm44.dsnToString)(dsn));
    for(var key in dialogOptions){
        if (key === "dsn") continue;
        if (key === "user") {
            var user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += "&name=".concat(encodeURIComponent(user.name));
            if (user.email) encodedOptions += "&email=".concat(encodeURIComponent(user.email));
        } else encodedOptions += "&".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(dialogOptions[key]));
    }
    return "".concat(endpoint, "?").concat(encodedOptions);
}

});
parcelRegister("lfm44", function(module, exports) {

$parcel$export(module.exports, "dsnToString", function () { return $f77c1d4559c4eb8a$export$44d472fbb931a776; });
$parcel$export(module.exports, "makeDsn", function () { return $f77c1d4559c4eb8a$export$128827c3562ec0cb; });

var $cv9Rk = parcelRequire("cv9Rk");

var $fNn7q = parcelRequire("fNn7q");
/** Regular expression used to parse a Dsn. */ var $f77c1d4559c4eb8a$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $f77c1d4559c4eb8a$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $f77c1d4559c4eb8a$export$44d472fbb931a776(dsn) {
    var withPassword = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var host = dsn.host, path = dsn.path, pass = dsn.pass, port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol, publicKey = dsn.publicKey;
    return "".concat(protocol, "://").concat(publicKey).concat(withPassword && pass ? ":".concat(pass) : "") + "@".concat(host).concat(port ? ":".concat(port) : "", "/").concat(path ? "".concat(path, "/") : path).concat(projectId);
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $f77c1d4559c4eb8a$export$b892860177f70a30(str) {
    var match = $f77c1d4559c4eb8a$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        // eslint-disable-next-line no-console
        console.error("Invalid Sentry Dsn: ".concat(str));
        return undefined;
    }
    var _match_slice = (0, $cv9Rk._)(match.slice(1), 6), protocol = _match_slice[0], publicKey = _match_slice[1], tmp = _match_slice[2], pass = tmp === void 0 ? "" : tmp, host = _match_slice[3], tmp1 = _match_slice[4], port = tmp1 === void 0 ? "" : tmp1, lastPath = _match_slice[5];
    var path = "";
    var projectId = lastPath;
    var split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        var projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $f77c1d4559c4eb8a$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $f77c1d4559c4eb8a$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $f77c1d4559c4eb8a$var$validateDsn(dsn) {
    if (!(typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__)) return true;
    var port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol;
    var requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    var hasMissingRequiredComponent = requiredComponents.find(function(component) {
        if (!dsn[component]) {
            (0, $fNn7q.logger).error("Invalid Sentry Dsn: ".concat(component, " missing"));
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $fNn7q.logger).error("Invalid Sentry Dsn: Invalid projectId ".concat(projectId));
        return false;
    }
    if (!$f77c1d4559c4eb8a$var$isValidProtocol(protocol)) {
        (0, $fNn7q.logger).error("Invalid Sentry Dsn: Invalid protocol ".concat(protocol));
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $fNn7q.logger).error("Invalid Sentry Dsn: Invalid port ".concat(port));
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $f77c1d4559c4eb8a$export$128827c3562ec0cb(from) {
    var components = typeof from === "string" ? $f77c1d4559c4eb8a$export$b892860177f70a30(from) : $f77c1d4559c4eb8a$var$dsnFromComponents(from);
    if (!components || !$f77c1d4559c4eb8a$var$validateDsn(components)) return undefined;
    return components;
}

});


parcelRegister("bFwPW", function(module, exports) {

$parcel$export(module.exports, "initAndBind", function () { return $87ecfec107a6f02e$export$5333c3f1c58d9bc1; });

var $fNn7q = parcelRequire("fNn7q");

var $1uvy1 = parcelRequire("1uvy1");
/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $87ecfec107a6f02e$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) (0, $fNn7q.logger).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        // eslint-disable-next-line no-console
        console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
    }
    var hub = (0, $1uvy1.getCurrentHub)();
    var scope = hub.getScope();
    scope.update(options.initialScope);
    var client = new clientClass(options);
    hub.bindClient(client);
}

});

parcelRegister("kZOwK", function(module, exports) {

$parcel$export(module.exports, "FunctionToString", function () { return (parcelRequire("lAUbD")).FunctionToString; });
$parcel$export(module.exports, "InboundFilters", function () { return (parcelRequire("5lHhV")).InboundFilters; });

var $lAUbD = parcelRequire("lAUbD");

var $5lHhV = parcelRequire("5lHhV");

});
parcelRegister("lAUbD", function(module, exports) {

$parcel$export(module.exports, "FunctionToString", function () { return $fb888b48f59efc07$export$da4704525c20ae79; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $9QLqp = parcelRequire("9QLqp");
var $fb888b48f59efc07$var$originalFunctionToString;
/** Patch toString calls to return proper name for wrapped functions */ var $fb888b48f59efc07$export$da4704525c20ae79 = /*#__PURE__*/ function() {
    "use strict";
    function FunctionToString() {
        (0, $4GJKx._)(this, FunctionToString);
        this.name = FunctionToString.id;
    }
    (0, $1wc17._)(FunctionToString, [
        {
            /**
   * @inheritDoc
   */ key: "setupOnce",
            value: function setupOnce() {
                // eslint-disable-next-line @typescript-eslint/unbound-method
                $fb888b48f59efc07$var$originalFunctionToString = Function.prototype.toString;
                // intrinsics (like Function.prototype) might be immutable in some environments
                // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
                try {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    Function.prototype.toString = function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                            args[_key] = arguments[_key];
                        }
                        var context = (0, $9QLqp.getOriginalFunction)(this) || this;
                        return $fb888b48f59efc07$var$originalFunctionToString.apply(context, args);
                    };
                } catch (e) {
                // ignore errors here, just don't patch this
                }
            }
        }
    ], [
        {
            key: "__initStatic",
            value: /**
   * @inheritDoc
   */ function __initStatic() {
                this.id = "FunctionToString";
            }
        }
    ]);
    return FunctionToString;
}();
$fb888b48f59efc07$export$da4704525c20ae79.__initStatic();

});

parcelRegister("5lHhV", function(module, exports) {

$parcel$export(module.exports, "InboundFilters", function () { return $3e507e0cc3ad6d82$export$2ffbb5359dcc6be4; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $c6Xmf = parcelRequire("c6Xmf");

var $9MzNF = parcelRequire("9MzNF");
var $fNn7q = parcelRequire("fNn7q");
var $11858 = parcelRequire("11858");
// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
var $3e507e0cc3ad6d82$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/
];
var $3e507e0cc3ad6d82$var$DEFAULT_IGNORE_TRANSACTIONS = [
    /^.*\/healthcheck$/,
    /^.*\/healthy$/,
    /^.*\/live$/,
    /^.*\/ready$/,
    /^.*\/heartbeat$/,
    /^.*\/health$/,
    /^.*\/healthz$/
];
/** Options for the InboundFilters integration */ /** Inbound filters configurable by the user */ var $3e507e0cc3ad6d82$export$2ffbb5359dcc6be4 = /*#__PURE__*/ function() {
    "use strict";
    function InboundFilters() {
        var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, $4GJKx._)(this, InboundFilters);
        this.name = InboundFilters.id;
        this._options = options;
    }
    (0, $1wc17._)(InboundFilters, [
        {
            /**
   * @inheritDoc
   */ key: "setupOnce",
            value: function setupOnce(_addGlobaleventProcessor, _getCurrentHub) {
            // noop
            }
        },
        {
            /** @inheritDoc */ key: "processEvent",
            value: function processEvent(event, _eventHint, client) {
                var clientOptions = client.getOptions();
                var options = $3e507e0cc3ad6d82$export$6620a151868b99aa(this._options, clientOptions);
                return $3e507e0cc3ad6d82$export$3c6361fddf6cd929(event, options) ? null : event;
            }
        }
    ], [
        {
            key: "__initStatic",
            value: /**
   * @inheritDoc
   */ function __initStatic() {
                this.id = "InboundFilters";
            }
        }
    ]);
    return InboundFilters;
}();
$3e507e0cc3ad6d82$export$2ffbb5359dcc6be4.__initStatic();
/** JSDoc */ function $3e507e0cc3ad6d82$export$6620a151868b99aa() {
    var internalOptions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, clientOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return {
        allowUrls: (0, $c6Xmf._)(internalOptions.allowUrls || []).concat((0, $c6Xmf._)(clientOptions.allowUrls || [])),
        denyUrls: (0, $c6Xmf._)(internalOptions.denyUrls || []).concat((0, $c6Xmf._)(clientOptions.denyUrls || [])),
        ignoreErrors: (0, $c6Xmf._)(internalOptions.ignoreErrors || []).concat((0, $c6Xmf._)(clientOptions.ignoreErrors || []), (0, $c6Xmf._)(internalOptions.disableErrorDefaults ? [] : $3e507e0cc3ad6d82$var$DEFAULT_IGNORE_ERRORS)),
        ignoreTransactions: (0, $c6Xmf._)(internalOptions.ignoreTransactions || []).concat((0, $c6Xmf._)(clientOptions.ignoreTransactions || []), (0, $c6Xmf._)(internalOptions.disableTransactionDefaults ? [] : $3e507e0cc3ad6d82$var$DEFAULT_IGNORE_TRANSACTIONS)),
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
/** JSDoc */ function $3e507e0cc3ad6d82$export$3c6361fddf6cd929(event, options) {
    if (options.ignoreInternal && $3e507e0cc3ad6d82$var$_isSentryError(event)) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).warn("Event dropped due to being internal Sentry Error.\nEvent: ".concat((0, $9MzNF.getEventDescription)(event)));
        return true;
    }
    if ($3e507e0cc3ad6d82$var$_isIgnoredError(event, options.ignoreErrors)) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: ".concat((0, $9MzNF.getEventDescription)(event)));
        return true;
    }
    if ($3e507e0cc3ad6d82$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).warn("Event dropped due to being matched by `ignoreTransactions` option.\nEvent: ".concat((0, $9MzNF.getEventDescription)(event)));
        return true;
    }
    if ($3e507e0cc3ad6d82$var$_isDeniedUrl(event, options.denyUrls)) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).warn("Event dropped due to being matched by `denyUrls` option.\nEvent: ".concat((0, $9MzNF.getEventDescription)(event), ".\nUrl: ").concat($3e507e0cc3ad6d82$var$_getEventFilterUrl(event)));
        return true;
    }
    if (!$3e507e0cc3ad6d82$var$_isAllowedUrl(event, options.allowUrls)) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).warn("Event dropped due to not being matched by `allowUrls` option.\nEvent: ".concat((0, $9MzNF.getEventDescription)(event), ".\nUrl: ").concat($3e507e0cc3ad6d82$var$_getEventFilterUrl(event)));
        return true;
    }
    return false;
}
function $3e507e0cc3ad6d82$var$_isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) return false;
    return $3e507e0cc3ad6d82$var$_getPossibleEventMessages(event).some(function(message) {
        return (0, $11858.stringMatchesSomePattern)(message, ignoreErrors);
    });
}
function $3e507e0cc3ad6d82$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== "transaction" || !ignoreTransactions || !ignoreTransactions.length) return false;
    var name = event.transaction;
    return name ? (0, $11858.stringMatchesSomePattern)(name, ignoreTransactions) : false;
}
function $3e507e0cc3ad6d82$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    var url = $3e507e0cc3ad6d82$var$_getEventFilterUrl(event);
    return !url ? false : (0, $11858.stringMatchesSomePattern)(url, denyUrls);
}
function $3e507e0cc3ad6d82$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    var url = $3e507e0cc3ad6d82$var$_getEventFilterUrl(event);
    return !url ? true : (0, $11858.stringMatchesSomePattern)(url, allowUrls);
}
function $3e507e0cc3ad6d82$var$_getPossibleEventMessages(event) {
    var possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    var lastException;
    try {
        // @ts-expect-error Try catching to save bundle size
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        lastException = event.exception.values[event.exception.values.length - 1];
    } catch (e) {
    // try catching to save bundle size checking existence of variables
    }
    if (lastException) {
        if (lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push("".concat(lastException.type, ": ").concat(lastException.value));
        }
    }
    if ((typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && possibleMessages.length === 0) (0, $fNn7q.logger).error("Could not extract message for event ".concat((0, $9MzNF.getEventDescription)(event)));
    return possibleMessages;
}
function $3e507e0cc3ad6d82$var$_isSentryError(event) {
    try {
        // @ts-expect-error can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === "SentryError";
    } catch (e) {
    // ignore
    }
    return false;
}
function $3e507e0cc3ad6d82$var$_getLastValidUrl() {
    var frames = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    for(var i = frames.length - 1; i >= 0; i--){
        var frame = frames[i];
        if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") return frame.filename || null;
    }
    return null;
}
function $3e507e0cc3ad6d82$var$_getEventFilterUrl(event) {
    try {
        var frames;
        try {
            // @ts-expect-error we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? $3e507e0cc3ad6d82$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).error("Cannot extract url for event ".concat((0, $9MzNF.getEventDescription)(event)));
        return null;
    }
}

});


parcelRegister("4aKu9", function(module, exports) {

$parcel$export(module.exports, "BrowserClient", function () { return $309c279df4dbc95a$export$1df9218a526d318d; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $04RAu = parcelRequire("04RAu");

var $b8Rim = parcelRequire("b8Rim");

var $dcsZi = parcelRequire("dcsZi");

var $ohfOJ = parcelRequire("ohfOJ");

var $3a0AF = parcelRequire("3a0AF");
var $987Jv = parcelRequire("987Jv");

var $dmqSm = parcelRequire("dmqSm");
var $lfm44 = parcelRequire("lfm44");
var $iq6WK = parcelRequire("iq6WK");
var $fNn7q = parcelRequire("fNn7q");

var $fmHq3 = parcelRequire("fmHq3");

var $1OIkc = parcelRequire("1OIkc");

var $6GiuV = parcelRequire("6GiuV");
/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ var $309c279df4dbc95a$export$1df9218a526d318d = /*#__PURE__*/ function(BaseClient) {
    "use strict";
    (0, $dcsZi._)(BrowserClient, BaseClient);
    var _super = (0, $ohfOJ._)(BrowserClient);
    function BrowserClient(options) {
        (0, $4GJKx._)(this, BrowserClient);
        var _this;
        var sdkSource = (0, $1OIkc.WINDOW).SENTRY_SDK_SOURCE || (0, $iq6WK.getSDKSource)();
        options._metadata = options._metadata || {};
        options._metadata.sdk = options._metadata.sdk || {
            name: "sentry.javascript.browser",
            packages: [
                {
                    name: "".concat(sdkSource, ":@sentry/browser"),
                    version: (0, $987Jv.SDK_VERSION)
                }
            ],
            version: (0, $987Jv.SDK_VERSION)
        };
        _this = _super.call(this, options);
        if (options.sendClientReports && (0, $1OIkc.WINDOW).document) (0, $1OIkc.WINDOW).document.addEventListener("visibilitychange", function() {
            if ((0, $1OIkc.WINDOW).document.visibilityState === "hidden") _this._flushOutcomes();
        });
        return _this;
    }
    (0, $1wc17._)(BrowserClient, [
        {
            /**
   * @inheritDoc
   */ key: "eventFromException",
            value: function eventFromException1(exception, hint) {
                return (0, $fmHq3.eventFromException)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "eventFromMessage",
            value: function eventFromMessage1(message) {
                var // eslint-disable-next-line deprecation/deprecation
                level = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "info", hint = arguments.length > 2 ? arguments[2] : void 0;
                return (0, $fmHq3.eventFromMessage)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
            }
        },
        {
            /**
   * Sends user feedback to Sentry.
   */ key: "captureUserFeedback",
            value: function captureUserFeedback(feedback) {
                if (!this._isEnabled()) {
                    (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).warn("SDK not enabled, will not capture user feedback.");
                    return;
                }
                var envelope = (0, $6GiuV.createUserFeedbackEnvelope)(feedback, {
                    metadata: this.getSdkMetadata(),
                    dsn: this.getDsn(),
                    tunnel: this.getOptions().tunnel
                });
                this._sendEnvelope(envelope);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "_prepareEvent",
            value: function _prepareEvent(event, hint, scope) {
                event.platform = event.platform || "javascript";
                return (0, $04RAu._)((0, $b8Rim._)(BrowserClient.prototype), "_prepareEvent", this).call(this, event, hint, scope);
            }
        },
        {
            /**
   * Sends client reports as an envelope.
   */ key: "_flushOutcomes",
            value: function _flushOutcomes() {
                var outcomes = this._clearOutcomes();
                if (outcomes.length === 0) {
                    (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).log("No outcomes to send");
                    return;
                }
                // This is really the only place where we want to check for a DSN and only send outcomes then
                if (!this._dsn) {
                    (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).log("No dsn provided, will not send outcomes");
                    return;
                }
                (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).log("Sending outcomes:", outcomes);
                var envelope = (0, $dmqSm.createClientReportEnvelope)(outcomes, this._options.tunnel && (0, $lfm44.dsnToString)(this._dsn));
                this._sendEnvelope(envelope);
            }
        }
    ]);
    return BrowserClient;
}((0, $3a0AF.BaseClient));

});
parcelRegister("3a0AF", function(module, exports) {

$parcel$export(module.exports, "BaseClient", function () { return $24d2c383bac53b6c$export$4f22f74eddb7716a; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");

var $gWN4v = parcelRequire("gWN4v");
var $9MzNF = parcelRequire("9MzNF");
var $fFQTh = parcelRequire("fFQTh");
var $fNn7q = parcelRequire("fNn7q");
var $lfm44 = parcelRequire("lfm44");
var $dvm65 = parcelRequire("dvm65");
var $4adLA = parcelRequire("4adLA");

var $9SEP8 = parcelRequire("9SEP8");

var $cXk4I = parcelRequire("cXk4I");

var $4cPVl = parcelRequire("4cPVl");

var $aBCNn = parcelRequire("aBCNn");

var $kzlIx = parcelRequire("kzlIx");

var $iIeal = parcelRequire("iIeal");
var $24d2c383bac53b6c$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ var $24d2c383bac53b6c$export$4f22f74eddb7716a = /*#__PURE__*/ function() {
    "use strict";
    function BaseClient(options) {
        (0, $4GJKx._)(this, BaseClient);
        this._options = options;
        this._integrations = {};
        this._integrationsInitialized = false;
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $lfm44.makeDsn)(options.dsn);
        else (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).warn("No DSN provided, client will not send events.");
        if (this._dsn) {
            var url = (0, $9SEP8.getEnvelopeEndpointWithUrlEncodedAuth)(this._dsn, options);
            this._transport = options.transport((0, $cxjpp._)((0, $do9pw._)({
                recordDroppedEvent: this.recordDroppedEvent.bind(this)
            }, options.transportOptions), {
                url: url
            }));
        }
    }
    (0, $1wc17._)(BaseClient, [
        {
            /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
            key: "captureException",
            value: function captureException(exception, hint, scope) {
                var _this = this;
                // ensure we haven't captured this very object before
                if ((0, $9MzNF.checkOrSetAlreadyCaught)(exception)) {
                    (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).log($24d2c383bac53b6c$var$ALREADY_SEEN_ERROR);
                    return;
                }
                var eventId = hint && hint.event_id;
                this._process(this.eventFromException(exception, hint).then(function(event) {
                    return _this._captureEvent(event, hint, scope);
                }).then(function(result) {
                    eventId = result;
                }));
                return eventId;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "captureMessage",
            value: function captureMessage(message, // eslint-disable-next-line deprecation/deprecation
            level, hint, scope) {
                var _this = this;
                var eventId = hint && hint.event_id;
                var promisedEvent = (0, $fFQTh.isPrimitive)(message) ? this.eventFromMessage(String(message), level, hint) : this.eventFromException(message, hint);
                this._process(promisedEvent.then(function(event) {
                    return _this._captureEvent(event, hint, scope);
                }).then(function(result) {
                    eventId = result;
                }));
                return eventId;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "captureEvent",
            value: function captureEvent(event, hint, scope) {
                // ensure we haven't captured this very object before
                if (hint && hint.originalException && (0, $9MzNF.checkOrSetAlreadyCaught)(hint.originalException)) {
                    (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).log($24d2c383bac53b6c$var$ALREADY_SEEN_ERROR);
                    return;
                }
                var eventId = hint && hint.event_id;
                this._process(this._captureEvent(event, hint, scope).then(function(result) {
                    eventId = result;
                }));
                return eventId;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "captureSession",
            value: function captureSession(session) {
                if (!(typeof session.release === "string")) (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).warn("Discarded session because of missing or non-string release");
                else {
                    this.sendSession(session);
                    // After sending, we set init false to indicate it's not the first occurrence
                    (0, $aBCNn.updateSession)(session, {
                        init: false
                    });
                }
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getDsn",
            value: function getDsn() {
                return this._dsn;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getOptions",
            value: function getOptions() {
                return this._options;
            }
        },
        {
            /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */ key: "getSdkMetadata",
            value: function getSdkMetadata() {
                return this._options._metadata;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getTransport",
            value: function getTransport() {
                return this._transport;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "flush",
            value: function flush(timeout) {
                var transport = this._transport;
                if (transport) return this._isClientDoneProcessing(timeout).then(function(clientFinished) {
                    return transport.flush(timeout).then(function(transportFlushed) {
                        return clientFinished && transportFlushed;
                    });
                });
                else return (0, $dvm65.resolvedSyncPromise)(true);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "close",
            value: function close(timeout) {
                var _this = this;
                return this.flush(timeout).then(function(result) {
                    _this.getOptions().enabled = false;
                    return result;
                });
            }
        },
        {
            /** Get all installed event processors. */ key: "getEventProcessors",
            value: function getEventProcessors() {
                return this._eventProcessors;
            }
        },
        {
            /** @inheritDoc */ key: "addEventProcessor",
            value: function addEventProcessor(eventProcessor) {
                this._eventProcessors.push(eventProcessor);
            }
        },
        {
            /**
   * Sets up the integrations
   */ key: "setupIntegrations",
            value: function setupIntegrations1(forceInitialize) {
                if (forceInitialize && !this._integrationsInitialized || this._isEnabled() && !this._integrationsInitialized) {
                    this._integrations = (0, $4cPVl.setupIntegrations)(this, this._options.integrations);
                    this._integrationsInitialized = true;
                }
            }
        },
        {
            /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   */ key: "getIntegrationById",
            value: function getIntegrationById(integrationId) {
                return this._integrations[integrationId];
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getIntegration",
            value: function getIntegration(integration) {
                try {
                    return this._integrations[integration.id] || null;
                } catch (_oO) {
                    (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).warn("Cannot retrieve integration ".concat(integration.id, " from the current Client"));
                    return null;
                }
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "addIntegration",
            value: function addIntegration(integration) {
                (0, $4cPVl.setupIntegration)(this, integration, this._integrations);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "sendEvent",
            value: function sendEvent(event) {
                var hint = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _this = this;
                this.emit("beforeSendEvent", event, hint);
                var env = (0, $cXk4I.createEventEnvelope)(event, this._dsn, this._options._metadata, this._options.tunnel);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = (hint.attachments || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var attachment = _step.value;
                        env = (0, $gWN4v.addItemToEnvelope)(env, (0, $gWN4v.createAttachmentEnvelopeItem)(attachment, this._options.transportOptions && this._options.transportOptions.textEncoder));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var promise = this._sendEnvelope(env);
                if (promise) promise.then(function(sendResponse) {
                    return _this.emit("afterSendEvent", event, sendResponse);
                }, null);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "sendSession",
            value: function sendSession(session) {
                var env = (0, $cXk4I.createSessionEnvelope)(session, this._dsn, this._options._metadata, this._options.tunnel);
                this._sendEnvelope(env);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "recordDroppedEvent",
            value: function recordDroppedEvent(reason, category, _event) {
                // Note: we use `event` in replay, where we overwrite this hook.
                if (this._options.sendClientReports) {
                    // We want to track each category (error, transaction, session, replay_event) separately
                    // but still keep the distinction between different type of outcomes.
                    // We could use nested maps, but it's much easier to read and type this way.
                    // A correct type for map-based implementation if we want to go that route
                    // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
                    // With typescript 4.1 we could even use template literal types
                    var key = "".concat(reason, ":").concat(category);
                    (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).log('Adding outcome: "'.concat(key, '"'));
                    // The following works because undefined + 1 === NaN and NaN is falsy
                    this._outcomes[key] = this._outcomes[key] + 1 || 1;
                }
            }
        },
        {
            // Keep on() & emit() signatures in sync with types' client.ts interface
            /* eslint-disable @typescript-eslint/unified-signatures */ /** @inheritdoc */ /** @inheritdoc */ key: "on",
            value: function on(hook, callback) {
                if (!this._hooks[hook]) this._hooks[hook] = [];
                // @ts-expect-error We assue the types are correct
                this._hooks[hook].push(callback);
            }
        },
        {
            /** @inheritdoc */ /** @inheritdoc */ key: "emit",
            value: function emit(hook) {
                for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    rest[_key - 1] = arguments[_key];
                }
                if (this._hooks[hook]) this._hooks[hook].forEach(function(callback) {
                    return callback.apply(void 0, (0, $c6Xmf._)(rest));
                });
            }
        },
        {
            /* eslint-enable @typescript-eslint/unified-signatures */ /** Updates existing session based on the provided event */ key: "_updateSessionFromEvent",
            value: function _updateSessionFromEvent(session, event) {
                var crashed = false;
                var errored = false;
                var exceptions = event.exception && event.exception.values;
                if (exceptions) {
                    errored = true;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = exceptions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var ex = _step.value;
                            var mechanism = ex.mechanism;
                            if (mechanism && mechanism.handled === false) {
                                crashed = true;
                                break;
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                // A session is updated and that session update is sent in only one of the two following scenarios:
                // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
                // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
                var sessionNonTerminal = session.status === "ok";
                var shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
                if (shouldUpdateAndSend) {
                    (0, $aBCNn.updateSession)(session, (0, $cxjpp._)((0, $do9pw._)({}, crashed && {
                        status: "crashed"
                    }), {
                        errors: session.errors || Number(errored || crashed)
                    }));
                    this.captureSession(session);
                }
            }
        },
        {
            /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ key: "_isClientDoneProcessing",
            value: function _isClientDoneProcessing(timeout) {
                var _this = this;
                return new (0, $dvm65.SyncPromise)(function(resolve) {
                    var ticked = 0;
                    var tick = 1;
                    var interval = setInterval(function() {
                        if (_this._numProcessing == 0) {
                            clearInterval(interval);
                            resolve(true);
                        } else {
                            ticked += tick;
                            if (timeout && ticked >= timeout) {
                                clearInterval(interval);
                                resolve(false);
                            }
                        }
                    }, tick);
                });
            }
        },
        {
            /** Determines whether this SDK is enabled and a transport is present. */ key: "_isEnabled",
            value: function _isEnabled() {
                return this.getOptions().enabled !== false && this._transport !== undefined;
            }
        },
        {
            /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */ key: "_prepareEvent",
            value: function _prepareEvent(event, hint, scope) {
                var _this = this;
                var options = this.getOptions();
                var integrations = Object.keys(this._integrations);
                if (!hint.integrations && integrations.length > 0) hint.integrations = integrations;
                this.emit("preprocessEvent", event, hint);
                return (0, $iIeal.prepareEvent)(options, event, hint, scope, this).then(function(evt) {
                    if (evt === null) return evt;
                    // If a trace context is not set on the event, we use the propagationContext set on the event to
                    // generate a trace context. If the propagationContext does not have a dynamic sampling context, we
                    // also generate one for it.
                    var propagationContext = (evt.sdkProcessingMetadata || {}).propagationContext;
                    var trace = evt.contexts && evt.contexts.trace;
                    if (!trace && propagationContext) {
                        var trace_id = propagationContext.traceId, spanId = propagationContext.spanId, parentSpanId = propagationContext.parentSpanId, dsc = propagationContext.dsc;
                        evt.contexts = (0, $do9pw._)({
                            trace: {
                                trace_id: trace_id,
                                span_id: spanId,
                                parent_span_id: parentSpanId
                            }
                        }, evt.contexts);
                        var dynamicSamplingContext = dsc ? dsc : (0, $kzlIx.getDynamicSamplingContextFromClient)(trace_id, _this, scope);
                        evt.sdkProcessingMetadata = (0, $do9pw._)({
                            dynamicSamplingContext: dynamicSamplingContext
                        }, evt.sdkProcessingMetadata);
                    }
                    return evt;
                });
            }
        },
        {
            /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ key: "_captureEvent",
            value: function _captureEvent(event) {
                var hint = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, scope = arguments.length > 2 ? arguments[2] : void 0;
                return this._processEvent(event, hint, scope).then(function(finalEvent) {
                    return finalEvent.event_id;
                }, function(reason) {
                    if (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) {
                        // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                        // control flow, log just the message (no stack) as a log-level log.
                        var sentryError = reason;
                        if (sentryError.logLevel === "log") (0, $fNn7q.logger).log(sentryError.message);
                        else (0, $fNn7q.logger).warn(sentryError);
                    }
                    return undefined;
                });
            }
        },
        {
            /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ key: "_processEvent",
            value: function _processEvent(event, hint, scope) {
                var _this = this;
                var options = this.getOptions();
                var sampleRate = options.sampleRate;
                var isTransaction = $24d2c383bac53b6c$var$isTransactionEvent(event);
                var isError = $24d2c383bac53b6c$var$isErrorEvent(event);
                var eventType = event.type || "error";
                var beforeSendLabel = "before send for type `".concat(eventType, "`");
                // 1.0 === 100% events are sent
                // 0.0 === 0% events are sent
                // Sampling for transaction happens somewhere else
                if (isError && typeof sampleRate === "number" && Math.random() > sampleRate) {
                    this.recordDroppedEvent("sample_rate", "error", event);
                    return (0, $dvm65.rejectedSyncPromise)(new (0, $4adLA.SentryError)("Discarding event because it's not included in the random sample (sampling rate = ".concat(sampleRate, ")"), "log"));
                }
                var dataCategory = eventType === "replay_event" ? "replay" : eventType;
                return this._prepareEvent(event, hint, scope).then(function(prepared) {
                    if (prepared === null) {
                        _this.recordDroppedEvent("event_processor", dataCategory, event);
                        throw new (0, $4adLA.SentryError)("An event processor returned `null`, will not send event.", "log");
                    }
                    var isInternalException = hint.data && hint.data.__sentry__ === true;
                    if (isInternalException) return prepared;
                    var result = $24d2c383bac53b6c$var$processBeforeSend(options, prepared, hint);
                    return $24d2c383bac53b6c$var$_validateBeforeSendResult(result, beforeSendLabel);
                }).then(function(processedEvent) {
                    if (processedEvent === null) {
                        _this.recordDroppedEvent("before_send", dataCategory, event);
                        throw new (0, $4adLA.SentryError)("".concat(beforeSendLabel, " returned `null`, will not send event."), "log");
                    }
                    var session = scope && scope.getSession();
                    if (!isTransaction && session) _this._updateSessionFromEvent(session, processedEvent);
                    // None of the Sentry built event processor will update transaction name,
                    // so if the transaction name has been changed by an event processor, we know
                    // it has to come from custom event processor added by a user
                    var transactionInfo = processedEvent.transaction_info;
                    if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                        var source = "custom";
                        processedEvent.transaction_info = (0, $cxjpp._)((0, $do9pw._)({}, transactionInfo), {
                            source: source
                        });
                    }
                    _this.sendEvent(processedEvent, hint);
                    return processedEvent;
                }).then(null, function(reason) {
                    if (reason instanceof (0, $4adLA.SentryError)) throw reason;
                    _this.captureException(reason, {
                        data: {
                            __sentry__: true
                        },
                        originalException: reason
                    });
                    throw new (0, $4adLA.SentryError)("Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ".concat(reason));
                });
            }
        },
        {
            /**
   * Occupies the client with processing and event
   */ key: "_process",
            value: function _process(promise) {
                var _this = this;
                this._numProcessing++;
                promise.then(function(value) {
                    _this._numProcessing--;
                    return value;
                }, function(reason) {
                    _this._numProcessing--;
                    return reason;
                });
            }
        },
        {
            /**
   * @inheritdoc
   */ key: "_sendEnvelope",
            value: function _sendEnvelope(envelope) {
                this.emit("beforeEnvelope", envelope);
                if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, function(reason) {
                    (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).error("Error while sending event:", reason);
                });
                else (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).error("Transport disabled");
            }
        },
        {
            /**
   * Clears outcomes on this client and returns them.
   */ key: "_clearOutcomes",
            value: function _clearOutcomes() {
                var outcomes = this._outcomes;
                this._outcomes = {};
                return Object.keys(outcomes).map(function(key) {
                    var _key_split = (0, $cv9Rk._)(key.split(":"), 2), reason = _key_split[0], category = _key_split[1];
                    return {
                        reason: reason,
                        category: category,
                        quantity: outcomes[key]
                    };
                });
            }
        }
    ]);
    return BaseClient;
}();
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $24d2c383bac53b6c$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    var invalidValueError = "".concat(beforeSendLabel, " must return `null` or a valid event.");
    if ((0, $fFQTh.isThenable)(beforeSendResult)) return beforeSendResult.then(function(event) {
        if (!(0, $fFQTh.isPlainObject)(event) && event !== null) throw new (0, $4adLA.SentryError)(invalidValueError);
        return event;
    }, function(e) {
        throw new (0, $4adLA.SentryError)("".concat(beforeSendLabel, " rejected with ").concat(e));
    });
    else if (!(0, $fFQTh.isPlainObject)(beforeSendResult) && beforeSendResult !== null) throw new (0, $4adLA.SentryError)(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $24d2c383bac53b6c$var$processBeforeSend(options, event, hint) {
    var beforeSend = options.beforeSend, beforeSendTransaction = options.beforeSendTransaction;
    if ($24d2c383bac53b6c$var$isErrorEvent(event) && beforeSend) return beforeSend(event, hint);
    if ($24d2c383bac53b6c$var$isTransactionEvent(event) && beforeSendTransaction) return beforeSendTransaction(event, hint);
    return event;
}
function $24d2c383bac53b6c$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $24d2c383bac53b6c$var$isTransactionEvent(event) {
    return event.type === "transaction";
}

});
parcelRegister("gWN4v", function(module, exports) {

$parcel$export(module.exports, "createEnvelope", function () { return $c56820bfe49b381b$export$f93f7f385160c44e; });
$parcel$export(module.exports, "addItemToEnvelope", function () { return $c56820bfe49b381b$export$d650323442802f6f; });
$parcel$export(module.exports, "forEachEnvelopeItem", function () { return $c56820bfe49b381b$export$c56c55acf0136fd3; });
$parcel$export(module.exports, "serializeEnvelope", function () { return $c56820bfe49b381b$export$32f9b428425aac85; });
$parcel$export(module.exports, "createAttachmentEnvelopeItem", function () { return $c56820bfe49b381b$export$d8fc80952cc31fa4; });
$parcel$export(module.exports, "envelopeItemTypeToDataCategory", function () { return $c56820bfe49b381b$export$b11169581eeaf237; });
$parcel$export(module.exports, "getSdkMetadataForEnvelopeHeader", function () { return $c56820bfe49b381b$export$d369f3b2758f6743; });
$parcel$export(module.exports, "createEventEnvelopeHeaders", function () { return $c56820bfe49b381b$export$92b6093782fe661b; });

var $do9pw = parcelRequire("do9pw");

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");

var $lfm44 = parcelRequire("lfm44");

var $cwbEd = parcelRequire("cwbEd");

var $9QLqp = parcelRequire("9QLqp");
/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $c56820bfe49b381b$export$f93f7f385160c44e(headers) {
    var items = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $c56820bfe49b381b$export$d650323442802f6f(envelope, newItem) {
    var _envelope = (0, $cv9Rk._)(envelope, 2), headers = _envelope[0], items = _envelope[1];
    return [
        headers,
        (0, $c6Xmf._)(items).concat([
            newItem
        ])
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $c56820bfe49b381b$export$c56c55acf0136fd3(envelope, callback) {
    var envelopeItems = envelope[1];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = envelopeItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var envelopeItem = _step.value;
            var envelopeItemType = envelopeItem[0].type;
            var result = callback(envelopeItem, envelopeItemType);
            if (result) return true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $c56820bfe49b381b$export$604a45d95a155e2b(envelope, types) {
    return $c56820bfe49b381b$export$c56c55acf0136fd3(envelope, function(_, type) {
        return types.includes(type);
    });
}
/**
 * Encode a string to UTF8.
 */ function $c56820bfe49b381b$var$encodeUTF8(input, textEncoder) {
    var utf8 = textEncoder || new TextEncoder();
    return utf8.encode(input);
}
/**
 * Serializes an envelope.
 */ function $c56820bfe49b381b$export$32f9b428425aac85(envelope, textEncoder) {
    var _envelope = (0, $cv9Rk._)(envelope, 2), envHeaders = _envelope[0], items = _envelope[1];
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    var parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $c56820bfe49b381b$var$encodeUTF8(parts, textEncoder),
            next
        ];
        else parts.push(typeof next === "string" ? $c56820bfe49b381b$var$encodeUTF8(next, textEncoder) : next);
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            var _item = (0, $cv9Rk._)(item, 2), itemHeaders = _item[0], payload = _item[1];
            append("\n".concat(JSON.stringify(itemHeaders), "\n"));
            if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
            else {
                var stringifiedPayload = void 0;
                try {
                    stringifiedPayload = JSON.stringify(payload);
                } catch (e) {
                    // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
                    // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                    // performance impact but in this case a performance hit is better than throwing.
                    stringifiedPayload = JSON.stringify((0, $cwbEd.normalize)(payload));
                }
                append(stringifiedPayload);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return typeof parts === "string" ? parts : $c56820bfe49b381b$var$concatBuffers(parts);
}
function $c56820bfe49b381b$var$concatBuffers(buffers) {
    var totalLength = buffers.reduce(function(acc, buf) {
        return acc + buf.length;
    }, 0);
    var merged = new Uint8Array(totalLength);
    var offset = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = buffers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var buffer = _step.value;
            merged.set(buffer, offset);
            offset += buffer.length;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $c56820bfe49b381b$export$3338d0c7b6e17a2b(env, textEncoder, textDecoder) {
    var buffer = typeof env === "string" ? textEncoder.encode(env) : env;
    function readBinary(length) {
        var bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        var i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse(textDecoder.decode(readBinary(i)));
    }
    var envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var items = [];
    while(buffer.length){
        var itemHeader = readJson();
        var binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates attachment envelope items
 */ function $c56820bfe49b381b$export$d8fc80952cc31fa4(attachment, textEncoder) {
    var buffer = typeof attachment.data === "string" ? $c56820bfe49b381b$var$encodeUTF8(attachment.data, textEncoder) : attachment.data;
    return [
        (0, $9QLqp.dropUndefinedKeys)({
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
var $c56820bfe49b381b$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: "session",
    sessions: "session",
    attachment: "attachment",
    transaction: "transaction",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor"
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $c56820bfe49b381b$export$b11169581eeaf237(type) {
    return $c56820bfe49b381b$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from from the metadata or an events */ function $c56820bfe49b381b$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) return;
    var _metadataOrEvent_sdk = metadataOrEvent.sdk, name = _metadataOrEvent_sdk.name, version = _metadataOrEvent_sdk.version;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $c56820bfe49b381b$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    var dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return (0, $do9pw._)({
        event_id: event.event_id,
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }, !!tunnel && dsn && {
        dsn: (0, $lfm44.dsnToString)(dsn)
    }, dynamicSamplingContext && {
        trace: (0, $9QLqp.dropUndefinedKeys)((0, $do9pw._)({}, dynamicSamplingContext))
    });
}

});
parcelRegister("cwbEd", function(module, exports) {

$parcel$export(module.exports, "normalize", function () { return $91d18228c37fe692$export$a3295358bff77e; });
$parcel$export(module.exports, "normalizeToSize", function () { return $91d18228c37fe692$export$23fbbb20bed71033; });

var $cv9Rk = parcelRequire("cv9Rk");

var $l0HdX = parcelRequire("l0HdX");

var $fFQTh = parcelRequire("fFQTh");

var $4Fjhv = parcelRequire("4Fjhv");

var $9QLqp = parcelRequire("9QLqp");

var $5cx56 = parcelRequire("5cx56");
/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $91d18228c37fe692$export$a3295358bff77e(input) {
    var depth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100, maxProperties = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Infinity;
    try {
        // since we're at the outermost level, we don't provide a key
        return $91d18228c37fe692$export$588732934346abbf("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: "**non-serializable** (".concat(err, ")")
        };
    }
}
/** JSDoc */ function $91d18228c37fe692$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object) {
    var // Default Node.js REPL depth
    depth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
    maxSize = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 102400;
    var normalized = $91d18228c37fe692$export$a3295358bff77e(object, depth);
    if ($91d18228c37fe692$var$jsonSize(normalized) > maxSize) return $91d18228c37fe692$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $91d18228c37fe692$export$588732934346abbf(key, value) {
    var depth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Infinity, maxProperties = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Infinity, memo = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : (0, $4Fjhv.memoBuilder)();
    var _memo = (0, $cv9Rk._)(memo, 2), memoize = _memo[0], unmemoize = _memo[1];
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "number",
        "boolean",
        "string"
    ].includes(typeof value === "undefined" ? "undefined" : (0, $l0HdX._)(value)) && !(0, $fFQTh.isNaN)(value)) return value;
    var stringified = $91d18228c37fe692$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith("[object ")) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value["__sentry_skip_normalization__"]) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    var remainingDepth = typeof value["__sentry_override_normalization_depth__"] === "number" ? value["__sentry_override_normalization_depth__"] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace("object ", "");
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return "[Circular ~]";
    // If the value has a `toJSON` method, we call it to extract more information
    var valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        var jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $91d18228c37fe692$export$588732934346abbf("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    var normalized = Array.isArray(value) ? [] : {};
    var numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    var visitable = (0, $9QLqp.convertToPlainObject)(value);
    for(var visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        // Recursively visit all the child nodes
        var visitValue = visitable[visitKey];
        normalized[visitKey] = $91d18228c37fe692$export$588732934346abbf(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $91d18228c37fe692$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === "domain" && value && typeof value === "object" && value._events) return "[Domain]";
        if (key === "domainEmitter") return "[DomainEmitter]";
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== "undefined" && value === window) return "[Window]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== "undefined" && value === document) return "[Document]";
        if ((0, $fFQTh.isVueViewModel)(value)) return "[VueViewModel]";
        // React's SyntheticEvent thingy
        if ((0, $fFQTh.isSyntheticEvent)(value)) return "[SyntheticEvent]";
        if (typeof value === "number" && value !== value) return "[NaN]";
        if (typeof value === "function") return "[Function: ".concat((0, $5cx56.getFunctionName)(value), "]");
        if ((typeof value === "undefined" ? "undefined" : (0, $l0HdX._)(value)) === "symbol") return "[".concat(String(value), "]");
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if ((typeof value === "undefined" ? "undefined" : (0, $l0HdX._)(value)) === "bigint") return "[BigInt: ".concat(String(value), "]");
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        var objName = $91d18228c37fe692$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return "[HTMLElement: ".concat(objName, "]");
        return "[object ".concat(objName, "]");
    } catch (err) {
        return "**non-serializable** (".concat(err, ")");
    }
}
/* eslint-enable complexity */ function $91d18228c37fe692$var$getConstructorName(value) {
    var prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : "null prototype";
}
/** Calculates bytes size of input string */ function $91d18228c37fe692$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $91d18228c37fe692$var$jsonSize(value) {
    return $91d18228c37fe692$var$utf8Length(JSON.stringify(value));
}

});
parcelRegister("4Fjhv", function(module, exports) {

$parcel$export(module.exports, "memoBuilder", function () { return $3659f2a34cf60639$export$8115b0b78e956ab3; });
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $3659f2a34cf60639$export$8115b0b78e956ab3() {
    var hasWeakSet = typeof WeakSet === "function";
    var inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(var i = 0; i < inner.length; i++){
            var value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(var i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}

});



parcelRegister("4adLA", function(module, exports) {

$parcel$export(module.exports, "SentryError", function () { return $3082c656ce8f8131$export$5949942ba2a7c0e2; });
/** An error emitted by Sentry SDKs and related utilities. */ 
var $d3H5E = parcelRequire("d3H5E");

var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $FuVm8 = parcelRequire("FuVm8");

var $ohfOJ = parcelRequire("ohfOJ");
var $3082c656ce8f8131$export$5949942ba2a7c0e2 = /*#__PURE__*/ function _target(Error1) {
    "use strict";
    (0, $dcsZi._)(SentryError, Error1);
    var _super = (0, $ohfOJ._)(SentryError);
    function SentryError(message) {
        var logLevel = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "warn";
        (0, $4GJKx._)(this, SentryError);
        var _this;
        _this = _super.call(this, message);
        _this.message = message;
        _this.name = (this instanceof SentryError ? this.constructor : void 0).prototype.constructor.name;
        // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
        // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
        // instances of `SentryError` fail `obj instanceof SentryError` checks.
        Object.setPrototypeOf((0, $d3H5E._)(_this), (this instanceof SentryError ? this.constructor : void 0).prototype);
        _this.logLevel = logLevel;
        return _this;
    }
    return SentryError;
}((0, $FuVm8._)(Error));

});

parcelRegister("cXk4I", function(module, exports) {

$parcel$export(module.exports, "createSessionEnvelope", function () { return $96ea91382757b3a4$export$124b03c077baa2f3; });
$parcel$export(module.exports, "createEventEnvelope", function () { return $96ea91382757b3a4$export$c31057337a18010f; });

var $do9pw = parcelRequire("do9pw");

var $c6Xmf = parcelRequire("c6Xmf");

var $gWN4v = parcelRequire("gWN4v");
var $lfm44 = parcelRequire("lfm44");
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $96ea91382757b3a4$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = (0, $c6Xmf._)(event.sdk.integrations || []).concat((0, $c6Xmf._)(sdkInfo.integrations || []));
    event.sdk.packages = (0, $c6Xmf._)(event.sdk.packages || []).concat((0, $c6Xmf._)(sdkInfo.packages || []));
    return event;
}
/** Creates an envelope from a Session */ function $96ea91382757b3a4$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    var sdkInfo = (0, $gWN4v.getSdkMetadataForEnvelopeHeader)(metadata);
    var envelopeHeaders = (0, $do9pw._)({
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }, !!tunnel && dsn && {
        dsn: (0, $lfm44.dsnToString)(dsn)
    });
    var envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return (0, $gWN4v.createEnvelope)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $96ea91382757b3a4$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    var sdkInfo = (0, $gWN4v.getSdkMetadataForEnvelopeHeader)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ var eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $96ea91382757b3a4$var$enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    var envelopeHeaders = (0, $gWN4v.createEventEnvelopeHeaders)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    var eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $gWN4v.createEnvelope)(envelopeHeaders, [
        eventItem
    ]);
}

});

parcelRegister("iIeal", function(module, exports) {

$parcel$export(module.exports, "prepareEvent", function () { return $d9f7531a01c14a61$export$2d67fb380bd11267; });

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $c6Xmf = parcelRequire("c6Xmf");

var $kfF30 = parcelRequire("kfF30");
var $3rn7c = parcelRequire("3rn7c");
var $cwbEd = parcelRequire("cwbEd");
var $dvm65 = parcelRequire("dvm65");
var $11858 = parcelRequire("11858");
var $9MzNF = parcelRequire("9MzNF");

var $lqQO8 = parcelRequire("lqQO8");

var $bCXHP = parcelRequire("bCXHP");

var $3Rd92 = parcelRequire("3Rd92");
/**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $d9f7531a01c14a61$export$2d67fb380bd11267(options, event, hint, scope, client) {
    var _options_normalizeDepth = options.normalizeDepth, normalizeDepth = _options_normalizeDepth === void 0 ? 3 : _options_normalizeDepth, _options_normalizeMaxBreadth = options.normalizeMaxBreadth, normalizeMaxBreadth = _options_normalizeMaxBreadth === void 0 ? 1000 : _options_normalizeMaxBreadth;
    var prepared = (0, $cxjpp._)((0, $do9pw._)({}, event), {
        event_id: event.event_id || hint.event_id || (0, $9MzNF.uuid4)(),
        timestamp: event.timestamp || (0, $kfF30.dateTimestampInSeconds)()
    });
    var integrations = hint.integrations || options.integrations.map(function(i) {
        return i.name;
    });
    $d9f7531a01c14a61$var$applyClientOptions(prepared, options);
    $d9f7531a01c14a61$var$applyIntegrationsMetadata(prepared, integrations);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $d9f7531a01c14a61$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    var finalScope = scope;
    if (hint.captureContext) finalScope = (0, $3Rd92.Scope).clone(finalScope).update(hint.captureContext);
    // We prepare the result here with a resolved Event.
    var result = (0, $dvm65.resolvedSyncPromise)(prepared);
    var clientEventProcessors = client && client.getEventProcessors ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.
    //
    // We need to check for the existence of `finalScope.getAttachments`
    // because `getAttachments` can be undefined if users are using an older version
    // of `@sentry/core` that does not have the `getAttachments` method.
    // See: https://github.com/getsentry/sentry-javascript/issues/5229
    if (finalScope) {
        // Collect attachments from the hint and scope
        if (finalScope.getAttachments) {
            var attachments = (0, $c6Xmf._)(hint.attachments || []).concat((0, $c6Xmf._)(finalScope.getAttachments()));
            if (attachments.length) hint.attachments = attachments;
        }
        // In case we have a hub we reassign it.
        result = finalScope.applyToEvent(prepared, hint, clientEventProcessors);
    } else // Apply client & global event processors even if there is no scope
    // TODO (v8): Update the order to be Global > Client
    result = (0, $bCXHP.notifyEventProcessors)((0, $c6Xmf._)(clientEventProcessors).concat((0, $c6Xmf._)((0, $bCXHP.getGlobalEventProcessors)())), prepared, hint);
    return result.then(function(evt) {
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $d9f7531a01c14a61$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) return $d9f7531a01c14a61$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */ function $d9f7531a01c14a61$var$applyClientOptions(event, options) {
    var environment = options.environment, release = options.release, dist = options.dist, _options_maxValueLength = options.maxValueLength, maxValueLength = _options_maxValueLength === void 0 ? 250 : _options_maxValueLength;
    if (!("environment" in event)) event.environment = "environment" in options ? environment : (0, $lqQO8.DEFAULT_ENVIRONMENT);
    if (event.release === undefined && release !== undefined) event.release = release;
    if (event.dist === undefined && dist !== undefined) event.dist = dist;
    if (event.message) event.message = (0, $11858.truncate)(event.message, maxValueLength);
    var exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $11858.truncate)(exception.value, maxValueLength);
    var request = event.request;
    if (request && request.url) request.url = (0, $11858.truncate)(request.url, maxValueLength);
}
var $d9f7531a01c14a61$var$debugIdStackParserCache = new WeakMap();
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $d9f7531a01c14a61$export$63042efc86f043e7(event, stackParser) {
    var debugIdMap = (0, $3rn7c.GLOBAL_OBJ)._sentryDebugIds;
    if (!debugIdMap) return;
    var debugIdStackFramesCache;
    var cachedDebugIdStackFrameCache = $d9f7531a01c14a61$var$debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        $d9f7531a01c14a61$var$debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    var filenameDebugIdMap = Object.keys(debugIdMap).reduce(function(acc, debugIdStackTrace) {
        var parsedStack;
        var cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(var i = parsedStack.length - 1; i >= 0; i--){
            var stackFrame = parsedStack[i];
            if (stackFrame.filename) {
                acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach(function(exception) {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach(function(frame) {
                if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $d9f7531a01c14a61$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    var filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach(function(exception) {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach(function(frame) {
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    var images = event.debug_meta.images;
    Object.keys(filenameDebugIdMap).forEach(function(filename) {
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: filenameDebugIdMap[filename]
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $d9f7531a01c14a61$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = (0, $c6Xmf._)(event.sdk.integrations || []).concat((0, $c6Xmf._)(integrationNames));
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $d9f7531a01c14a61$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    var normalized = (0, $do9pw._)({}, event, event.breadcrumbs && {
        breadcrumbs: event.breadcrumbs.map(function(b) {
            return (0, $do9pw._)({}, b, b.data && {
                data: (0, $cwbEd.normalize)(b.data, depth, maxBreadth)
            });
        })
    }, event.user && {
        user: (0, $cwbEd.normalize)(event.user, depth, maxBreadth)
    }, event.contexts && {
        contexts: (0, $cwbEd.normalize)(event.contexts, depth, maxBreadth)
    }, event.extra && {
        extra: (0, $cwbEd.normalize)(event.extra, depth, maxBreadth)
    });
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $cwbEd.normalize)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map(function(span) {
        // We cannot use the spread operator here because `toJSON` on `span` is non-enumerable
        if (span.data) span.data = (0, $cwbEd.normalize)(span.data, depth, maxBreadth);
        return span;
    });
    return normalized;
}

});


parcelRegister("987Jv", function(module, exports) {

$parcel$export(module.exports, "SDK_VERSION", function () { return $6a5adc0095ebfe81$export$31499a9cd224b78c; });
var $6a5adc0095ebfe81$export$31499a9cd224b78c = "7.74.1";

});

parcelRegister("dmqSm", function(module, exports) {

$parcel$export(module.exports, "createClientReportEnvelope", function () { return $9ba22d688fb1fa39$export$f3b9ed77c03eeb00; });

var $gWN4v = parcelRequire("gWN4v");

var $kfF30 = parcelRequire("kfF30");
/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $9ba22d688fb1fa39$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    var clientReportItem = [
        {
            type: "client_report"
        },
        {
            timestamp: timestamp || (0, $kfF30.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $gWN4v.createEnvelope)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}

});

parcelRegister("fmHq3", function(module, exports) {

$parcel$export(module.exports, "exceptionFromError", function () { return $b2fa973835d057fa$export$a6c2d27607295951; });
$parcel$export(module.exports, "eventFromException", function () { return $b2fa973835d057fa$export$ea3ec7e569b823fc; });
$parcel$export(module.exports, "eventFromUnknownInput", function () { return $b2fa973835d057fa$export$9dd56ed1ef0c3420; });
$parcel$export(module.exports, "eventFromMessage", function () { return $b2fa973835d057fa$export$5425b53185d13d6c; });

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $1uvy1 = parcelRequire("1uvy1");

var $9MzNF = parcelRequire("9MzNF");
var $9QLqp = parcelRequire("9QLqp");
var $fFQTh = parcelRequire("fFQTh");
var $cwbEd = parcelRequire("cwbEd");
var $dvm65 = parcelRequire("dvm65");
/**
 * This function creates an exception from a JavaScript Error
 */ function $b2fa973835d057fa$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    var frames = $b2fa973835d057fa$export$d478b2c12fbcfdda(stackParser, ex);
    var exception = {
        type: ex && ex.name,
        value: $b2fa973835d057fa$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === "") exception.value = "Unrecoverable error caught";
    return exception;
}
/**
 * @hidden
 */ function $b2fa973835d057fa$export$a6a5dd73e489caf(stackParser, exception, syntheticException, isUnhandledRejection) {
    var hub = (0, $1uvy1.getCurrentHub)();
    var client = hub.getClient();
    var normalizeDepth = client && client.getOptions().normalizeDepth;
    var event = {
        exception: {
            values: [
                {
                    type: (0, $fFQTh.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
                    value: $b2fa973835d057fa$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: {
            __serialized__: (0, $cwbEd.normalizeToSize)(exception, normalizeDepth)
        }
    };
    if (syntheticException) {
        var frames = $b2fa973835d057fa$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
/**
 * @hidden
 */ function $b2fa973835d057fa$export$73fbea5a0a5234af(stackParser, ex) {
    return {
        exception: {
            values: [
                $b2fa973835d057fa$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $b2fa973835d057fa$export$d478b2c12fbcfdda(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    var stacktrace = ex.stacktrace || ex.stack || "";
    var popSize = $b2fa973835d057fa$var$getPopSize(ex);
    try {
        return stackParser(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
var $b2fa973835d057fa$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $b2fa973835d057fa$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === "number") return ex.framesToPop;
        if ($b2fa973835d057fa$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $b2fa973835d057fa$var$extractMessage(ex) {
    var message = ex && ex.message;
    if (!message) return "No error message";
    if (message.error && typeof message.error.message === "string") return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $b2fa973835d057fa$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = $b2fa973835d057fa$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $9MzNF.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = "error";
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $dvm65.resolvedSyncPromise)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $b2fa973835d057fa$export$5425b53185d13d6c(stackParser, message) {
    var // eslint-disable-next-line deprecation/deprecation
    level = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "info", hint = arguments.length > 3 ? arguments[3] : void 0, attachStacktrace = arguments.length > 4 ? arguments[4] : void 0;
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = $b2fa973835d057fa$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $dvm65.resolvedSyncPromise)(event);
}
/**
 * @hidden
 */ function $b2fa973835d057fa$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    var event;
    if ((0, $fFQTh.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        var errorEvent = exception;
        return $b2fa973835d057fa$export$73fbea5a0a5234af(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $fFQTh.isDOMError)(exception) || (0, $fFQTh.isDOMException)(exception)) {
        var domException = exception;
        if ("stack" in exception) event = $b2fa973835d057fa$export$73fbea5a0a5234af(stackParser, exception);
        else {
            var name = domException.name || ((0, $fFQTh.isDOMError)(domException) ? "DOMError" : "DOMException");
            var message = domException.message ? "".concat(name, ": ").concat(domException.message) : name;
            event = $b2fa973835d057fa$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
            (0, $9MzNF.addExceptionTypeValue)(event, message);
        }
        if ("code" in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = (0, $cxjpp._)((0, $do9pw._)({}, event.tags), {
            "DOMException.code": "".concat(domException.code)
        });
        return event;
    }
    if ((0, $fFQTh.isError)(exception)) // we have a real Error object, do nothing
    return $b2fa973835d057fa$export$73fbea5a0a5234af(stackParser, exception);
    if ((0, $fFQTh.isPlainObject)(exception) || (0, $fFQTh.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        var objectException = exception;
        event = $b2fa973835d057fa$export$a6a5dd73e489caf(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $9MzNF.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $b2fa973835d057fa$export$47d86ae4b3c9994(stackParser, exception, syntheticException, attachStacktrace);
    (0, $9MzNF.addExceptionTypeValue)(event, "".concat(exception), undefined);
    (0, $9MzNF.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
/**
 * @hidden
 */ function $b2fa973835d057fa$export$47d86ae4b3c9994(stackParser, input, syntheticException, attachStacktrace) {
    var event = {
        message: input
    };
    if (attachStacktrace && syntheticException) {
        var frames = $b2fa973835d057fa$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: input,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    return event;
}
function $b2fa973835d057fa$var$getNonErrorObjectExceptionValue(exception, param) {
    var isUnhandledRejection = param.isUnhandledRejection;
    var keys = (0, $9QLqp.extractExceptionKeysForMessage)(exception);
    var captureType = isUnhandledRejection ? "promise rejection" : "exception";
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $fFQTh.isErrorEvent)(exception)) return "Event `ErrorEvent` captured as ".concat(captureType, " with message `").concat(exception.message, "`");
    if ((0, $fFQTh.isEvent)(exception)) {
        var className = $b2fa973835d057fa$var$getObjectClassName(exception);
        return "Event `".concat(className, "` (type=").concat(exception.type, ") captured as ").concat(captureType);
    }
    return "Object captured as ".concat(captureType, " with keys: ").concat(keys);
}
function $b2fa973835d057fa$var$getObjectClassName(obj) {
    try {
        var prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}

});

parcelRegister("1OIkc", function(module, exports) {

$parcel$export(module.exports, "WINDOW", function () { return $152cd7eb18a81ba8$export$56d8a8a25bd48b81; });
$parcel$export(module.exports, "shouldIgnoreOnError", function () { return $152cd7eb18a81ba8$export$b79738ab10c590b2; });
$parcel$export(module.exports, "wrap", function () { return $152cd7eb18a81ba8$export$4997ffc0176396a6; });

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $krMfp = parcelRequire("krMfp");

var $9MzNF = parcelRequire("9MzNF");
var $9QLqp = parcelRequire("9QLqp");
var $3rn7c = parcelRequire("3rn7c");
var $152cd7eb18a81ba8$export$56d8a8a25bd48b81 = (0, $3rn7c.GLOBAL_OBJ);
var $152cd7eb18a81ba8$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $152cd7eb18a81ba8$export$b79738ab10c590b2() {
    return $152cd7eb18a81ba8$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $152cd7eb18a81ba8$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $152cd7eb18a81ba8$var$ignoreOnError++;
    setTimeout(function() {
        $152cd7eb18a81ba8$var$ignoreOnError--;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $152cd7eb18a81ba8$export$4997ffc0176396a6(fn) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, before = arguments.length > 2 ? arguments[2] : void 0;
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (typeof fn !== "function") return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        var wrapper = fn.__sentry_wrapped__;
        if (wrapper) return wrapper;
        // We don't wanna wrap it twice
        if ((0, $9QLqp.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    var sentryWrapped = function sentryWrapped() {
        var args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === "function") before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            var wrappedArguments = args.map(function(arg) {
                return $152cd7eb18a81ba8$export$4997ffc0176396a6(arg, options);
            });
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $152cd7eb18a81ba8$export$1265a142ff5ba165();
            (0, $krMfp.withScope)(function(scope) {
                scope.addEventProcessor(function(event) {
                    if (options.mechanism) {
                        (0, $9MzNF.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $9MzNF.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = (0, $cxjpp._)((0, $do9pw._)({}, event.extra), {
                        arguments: args
                    });
                    return event;
                });
                (0, $krMfp.captureException)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(var property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $9QLqp.markFunctionWrapped)(sentryWrapped, fn);
    (0, $9QLqp.addNonEnumerableProperty)(fn, "__sentry_wrapped__", sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, "name", {
            get: function() {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}

});

parcelRegister("6GiuV", function(module, exports) {

$parcel$export(module.exports, "createUserFeedbackEnvelope", function () { return $4dd5039296ee042b$export$24a4dfcb686ee5bf; });

var $do9pw = parcelRequire("do9pw");

var $gWN4v = parcelRequire("gWN4v");
var $lfm44 = parcelRequire("lfm44");
/**
 * Creates an envelope from a user feedback.
 */ function $4dd5039296ee042b$export$24a4dfcb686ee5bf(feedback, param) {
    var metadata = param.metadata, tunnel = param.tunnel, dsn = param.dsn;
    var headers = (0, $do9pw._)({
        event_id: feedback.event_id,
        sent_at: new Date().toISOString()
    }, metadata && metadata.sdk && {
        sdk: {
            name: metadata.sdk.name,
            version: metadata.sdk.version
        }
    }, !!tunnel && !!dsn && {
        dsn: (0, $lfm44.dsnToString)(dsn)
    });
    var item = $4dd5039296ee042b$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $gWN4v.createEnvelope)(headers, [
        item
    ]);
}
function $4dd5039296ee042b$var$createUserFeedbackEnvelopeItem(feedback) {
    var feedbackHeaders = {
        type: "user_report"
    };
    return [
        feedbackHeaders,
        feedback
    ];
}

});


parcelRegister("3GhmO", function(module, exports) {

$parcel$export(module.exports, "GlobalHandlers", function () { return $2ae2c40cb3edf3ae$export$204155decbc90e5a; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $do9pw = parcelRequire("do9pw");

var $cv9Rk = parcelRequire("cv9Rk");

var $1uvy1 = parcelRequire("1uvy1");

var $9MzNF = parcelRequire("9MzNF");
var $MsrRH = parcelRequire("MsrRH");
var $2Qsdx = parcelRequire("2Qsdx");
var $fFQTh = parcelRequire("fFQTh");
var $fNn7q = parcelRequire("fNn7q");

var $fmHq3 = parcelRequire("fmHq3");

var $1OIkc = parcelRequire("1OIkc");
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /** Global handlers */ var $2ae2c40cb3edf3ae$export$204155decbc90e5a = /*#__PURE__*/ function() {
    "use strict";
    function GlobalHandlers(options) {
        (0, $4GJKx._)(this, GlobalHandlers);
        this.name = GlobalHandlers.id;
        this._options = (0, $do9pw._)({
            onerror: true,
            onunhandledrejection: true
        }, options);
        this._installFunc = {
            onerror: $2ae2c40cb3edf3ae$var$_installGlobalOnErrorHandler,
            onunhandledrejection: $2ae2c40cb3edf3ae$var$_installGlobalOnUnhandledRejectionHandler
        };
    }
    (0, $1wc17._)(GlobalHandlers, [
        {
            /**
   * @inheritDoc
   */ key: "setupOnce",
            value: function setupOnce() {
                Error.stackTraceLimit = 50;
                var options = this._options;
                // We can disable guard-for-in as we construct the options object above + do checks against
                // `this._installFunc` for the property.
                // eslint-disable-next-line guard-for-in
                for(var key in options){
                    var installFunc = this._installFunc[key];
                    if (installFunc && options[key]) {
                        $2ae2c40cb3edf3ae$var$globalHandlerLog(key);
                        installFunc();
                        this._installFunc[key] = undefined;
                    }
                }
            }
        }
    ], [
        {
            key: "__initStatic",
            value: /**
   * @inheritDoc
   */ function __initStatic() {
                this.id = "GlobalHandlers";
            }
        }
    ]);
    return GlobalHandlers;
}();
$2ae2c40cb3edf3ae$export$204155decbc90e5a.__initStatic();
/** JSDoc */ function $2ae2c40cb3edf3ae$var$_installGlobalOnErrorHandler() {
    (0, $MsrRH.addInstrumentationHandler)("error", // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function(data) {
        var _getHubAndOptions = (0, $cv9Rk._)($2ae2c40cb3edf3ae$var$getHubAndOptions(), 3), hub = _getHubAndOptions[0], stackParser = _getHubAndOptions[1], attachStacktrace = _getHubAndOptions[2];
        if (!hub.getIntegration($2ae2c40cb3edf3ae$export$204155decbc90e5a)) return;
        var msg = data.msg, url = data.url, line = data.line, column = data.column, error = data.error;
        if ((0, $1OIkc.shouldIgnoreOnError)() || error && error.__sentry_own_request__) return;
        var event = error === undefined && (0, $fFQTh.isString)(msg) ? $2ae2c40cb3edf3ae$var$_eventFromIncompleteOnError(msg, url, line, column) : $2ae2c40cb3edf3ae$var$_enhanceEventWithInitialFrame((0, $fmHq3.eventFromUnknownInput)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = "error";
        $2ae2c40cb3edf3ae$var$addMechanismAndCapture(hub, error, event, "onerror");
    });
}
/** JSDoc */ function $2ae2c40cb3edf3ae$var$_installGlobalOnUnhandledRejectionHandler() {
    (0, $MsrRH.addInstrumentationHandler)("unhandledrejection", // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function(e) {
        var _getHubAndOptions = (0, $cv9Rk._)($2ae2c40cb3edf3ae$var$getHubAndOptions(), 3), hub = _getHubAndOptions[0], stackParser = _getHubAndOptions[1], attachStacktrace = _getHubAndOptions[2];
        if (!hub.getIntegration($2ae2c40cb3edf3ae$export$204155decbc90e5a)) return;
        var error = e;
        // dig the object of the rejection out of known event types
        try {
            // PromiseRejectionEvents store the object of the rejection under 'reason'
            // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
            if ("reason" in e) error = e.reason;
            else if ("detail" in e && "reason" in e.detail) error = e.detail.reason;
        } catch (_oO) {
        // no-empty
        }
        if ((0, $1OIkc.shouldIgnoreOnError)() || error && error.__sentry_own_request__) return true;
        var event = (0, $fFQTh.isPrimitive)(error) ? $2ae2c40cb3edf3ae$var$_eventFromRejectionWithPrimitive(error) : (0, $fmHq3.eventFromUnknownInput)(stackParser, error, undefined, attachStacktrace, true);
        event.level = "error";
        $2ae2c40cb3edf3ae$var$addMechanismAndCapture(hub, error, event, "onunhandledrejection");
        return;
    });
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $2ae2c40cb3edf3ae$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: "UnhandledRejection",
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: "Non-Error promise rejection captured with value: ".concat(String(reason))
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $2ae2c40cb3edf3ae$var$_eventFromIncompleteOnError(msg, url, line, column) {
    var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    var message = (0, $fFQTh.isErrorEvent)(msg) ? msg.message : msg;
    var name = "Error";
    var groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    var event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $2ae2c40cb3edf3ae$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
/** JSDoc */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $2ae2c40cb3edf3ae$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    var e = event.exception = event.exception || {};
    // event.exception.values
    var ev = e.values = e.values || [];
    // event.exception.values[0]
    var ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    var ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    var ev0sf = ev0s.frames = ev0s.frames || [];
    var colno = isNaN(parseInt(column, 10)) ? undefined : column;
    var lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    var filename = (0, $fFQTh.isString)(url) && url.length > 0 ? url : (0, $2Qsdx.getLocationHref)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: "?",
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $2ae2c40cb3edf3ae$var$globalHandlerLog(type) {
    (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).log("Global Handler attached: ".concat(type));
}
function $2ae2c40cb3edf3ae$var$addMechanismAndCapture(hub, error, event, type) {
    (0, $9MzNF.addExceptionMechanism)(event, {
        handled: false,
        type: type
    });
    hub.captureEvent(event, {
        originalException: error
    });
}
function $2ae2c40cb3edf3ae$var$getHubAndOptions() {
    var hub = (0, $1uvy1.getCurrentHub)();
    var client = hub.getClient();
    var options = client && client.getOptions() || {
        stackParser: function() {
            return [];
        },
        attachStacktrace: false
    };
    return [
        hub,
        options.stackParser,
        options.attachStacktrace
    ];
}

});

parcelRegister("kmUcC", function(module, exports) {

$parcel$export(module.exports, "TryCatch", function () { return $ed41755ee1ada927$export$f1a018517668e6d3; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $do9pw = parcelRequire("do9pw");

var $9QLqp = parcelRequire("9QLqp");
var $5cx56 = parcelRequire("5cx56");

var $1OIkc = parcelRequire("1OIkc");
var $ed41755ee1ada927$var$DEFAULT_EVENT_TARGET = [
    "EventTarget",
    "Window",
    "Node",
    "ApplicationCache",
    "AudioTrackList",
    "BroadcastChannel",
    "ChannelMergerNode",
    "CryptoOperation",
    "EventSource",
    "FileReader",
    "HTMLUnknownElement",
    "IDBDatabase",
    "IDBRequest",
    "IDBTransaction",
    "KeyOperation",
    "MediaController",
    "MessagePort",
    "ModalWindow",
    "Notification",
    "SVGElementInstance",
    "Screen",
    "SharedWorker",
    "TextTrack",
    "TextTrackCue",
    "TextTrackList",
    "WebSocket",
    "WebSocketWorker",
    "Worker",
    "XMLHttpRequest",
    "XMLHttpRequestEventTarget",
    "XMLHttpRequestUpload"
];
/** Wrap timer functions and event targets to catch errors and provide better meta data */ var $ed41755ee1ada927$export$f1a018517668e6d3 = /*#__PURE__*/ function() {
    "use strict";
    function TryCatch(options) {
        (0, $4GJKx._)(this, TryCatch);
        this.name = TryCatch.id;
        this._options = (0, $do9pw._)({
            XMLHttpRequest: true,
            eventTarget: true,
            requestAnimationFrame: true,
            setInterval: true,
            setTimeout: true
        }, options);
    }
    (0, $1wc17._)(TryCatch, [
        {
            /**
   * Wrap timer functions and event targets to catch errors
   * and provide better metadata.
   */ key: "setupOnce",
            value: function setupOnce() {
                if (this._options.setTimeout) (0, $9QLqp.fill)((0, $1OIkc.WINDOW), "setTimeout", $ed41755ee1ada927$var$_wrapTimeFunction);
                if (this._options.setInterval) (0, $9QLqp.fill)((0, $1OIkc.WINDOW), "setInterval", $ed41755ee1ada927$var$_wrapTimeFunction);
                if (this._options.requestAnimationFrame) (0, $9QLqp.fill)((0, $1OIkc.WINDOW), "requestAnimationFrame", $ed41755ee1ada927$var$_wrapRAF);
                if (this._options.XMLHttpRequest && "XMLHttpRequest" in (0, $1OIkc.WINDOW)) (0, $9QLqp.fill)(XMLHttpRequest.prototype, "send", $ed41755ee1ada927$var$_wrapXHR);
                var eventTargetOption = this._options.eventTarget;
                if (eventTargetOption) {
                    var eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $ed41755ee1ada927$var$DEFAULT_EVENT_TARGET;
                    eventTarget.forEach($ed41755ee1ada927$var$_wrapEventTarget);
                }
            }
        }
    ], [
        {
            key: "__initStatic",
            value: /**
   * @inheritDoc
   */ function __initStatic() {
                this.id = "TryCatch";
            }
        }
    ]);
    return TryCatch;
}();
$ed41755ee1ada927$export$f1a018517668e6d3.__initStatic();
/** JSDoc */ function $ed41755ee1ada927$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var originalCallback = args[0];
        args[0] = (0, $1OIkc.wrap)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $5cx56.getFunctionName)(original)
                },
                handled: false,
                type: "instrument"
            }
        });
        return original.apply(this, args);
    };
}
/** JSDoc */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $ed41755ee1ada927$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $1OIkc.wrap)(callback, {
                mechanism: {
                    data: {
                        function: "requestAnimationFrame",
                        handler: (0, $5cx56.getFunctionName)(original)
                    },
                    handled: false,
                    type: "instrument"
                }
            })
        ]);
    };
}
/** JSDoc */ function $ed41755ee1ada927$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var xhr = this;
        var xmlHttpRequestProps = [
            "onload",
            "onerror",
            "onprogress",
            "onreadystatechange"
        ];
        xmlHttpRequestProps.forEach(function(prop) {
            if (prop in xhr && typeof xhr[prop] === "function") // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $9QLqp.fill)(xhr, prop, function(original) {
                var wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $5cx56.getFunctionName)(original)
                        },
                        handled: false,
                        type: "instrument"
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                var originalFunction = (0, $9QLqp.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $5cx56.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, $1OIkc.wrap)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
/** JSDoc */ function $ed41755ee1ada927$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var globalObject = (0, $1OIkc.WINDOW);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    var proto = globalObject[target] && globalObject[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
    (0, $9QLqp.fill)(proto, "addEventListener", function(original) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === "function") // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $1OIkc.wrap)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: "handleEvent",
                            handler: (0, $5cx56.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $1OIkc.wrap)(fn, {
                    mechanism: {
                        data: {
                            function: "addEventListener",
                            handler: (0, $5cx56.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                }),
                options
            ]);
        };
    });
    (0, $9QLqp.fill)(proto, "removeEventListener", function(originalRemoveEventListener) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */ var wrappedEventHandler = fn;
            try {
                var originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}

});

parcelRegister("ggWN2", function(module, exports) {

$parcel$export(module.exports, "Breadcrumbs", function () { return $bd8bbe6a27e2ed90$export$2dc68d50d56fbbd; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $1uvy1 = parcelRequire("1uvy1");

var $MsrRH = parcelRequire("MsrRH");
var $9MzNF = parcelRequire("9MzNF");
var $2Qsdx = parcelRequire("2Qsdx");
var $fNn7q = parcelRequire("fNn7q");
var $16swx = parcelRequire("16swx");
var $11858 = parcelRequire("11858");
var $cX6Q7 = parcelRequire("cX6Q7");

var $1OIkc = parcelRequire("1OIkc");
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ var $bd8bbe6a27e2ed90$var$MAX_ALLOWED_STRING_LENGTH = 1024;
/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */ var $bd8bbe6a27e2ed90$export$2dc68d50d56fbbd = /*#__PURE__*/ function() {
    "use strict";
    function Breadcrumbs(options) {
        (0, $4GJKx._)(this, Breadcrumbs);
        this.name = Breadcrumbs.id;
        this.options = (0, $do9pw._)({
            console: true,
            dom: true,
            fetch: true,
            history: true,
            sentry: true,
            xhr: true
        }, options);
    }
    (0, $1wc17._)(Breadcrumbs, [
        {
            /**
   * Instrument browser built-ins w/ breadcrumb capturing
   *  - Console API
   *  - DOM API (click/typing)
   *  - XMLHttpRequest API
   *  - Fetch API
   *  - History API
   */ key: "setupOnce",
            value: function setupOnce() {
                if (this.options.console) (0, $MsrRH.addInstrumentationHandler)("console", $bd8bbe6a27e2ed90$var$_consoleBreadcrumb);
                if (this.options.dom) (0, $MsrRH.addInstrumentationHandler)("dom", $bd8bbe6a27e2ed90$var$_domBreadcrumb(this.options.dom));
                if (this.options.xhr) (0, $MsrRH.addInstrumentationHandler)("xhr", $bd8bbe6a27e2ed90$var$_xhrBreadcrumb);
                if (this.options.fetch) (0, $MsrRH.addInstrumentationHandler)("fetch", $bd8bbe6a27e2ed90$var$_fetchBreadcrumb);
                if (this.options.history) (0, $MsrRH.addInstrumentationHandler)("history", $bd8bbe6a27e2ed90$var$_historyBreadcrumb);
                if (this.options.sentry) {
                    var client = (0, $1uvy1.getCurrentHub)().getClient();
                    client && client.on && client.on("beforeSendEvent", $bd8bbe6a27e2ed90$var$addSentryBreadcrumb);
                }
            }
        }
    ], [
        {
            key: "__initStatic",
            value: /**
   * @inheritDoc
   */ function __initStatic() {
                this.id = "Breadcrumbs";
            }
        }
    ]);
    return Breadcrumbs;
}();
$bd8bbe6a27e2ed90$export$2dc68d50d56fbbd.__initStatic();
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $bd8bbe6a27e2ed90$var$addSentryBreadcrumb(event) {
    (0, $1uvy1.getCurrentHub)().addBreadcrumb({
        category: "sentry.".concat(event.type === "transaction" ? "transaction" : "event"),
        event_id: event.event_id,
        level: event.level,
        message: (0, $9MzNF.getEventDescription)(event)
    }, {
        event: event
    });
}
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $bd8bbe6a27e2ed90$var$_domBreadcrumb(dom) {
    function _innerDomBreadcrumb(handlerData) {
        var target;
        var keyAttrs = typeof dom === "object" ? dom.serializeAttribute : undefined;
        var maxStringLength = typeof dom === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $bd8bbe6a27e2ed90$var$MAX_ALLOWED_STRING_LENGTH) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).warn("`dom.maxStringLength` cannot exceed ".concat($bd8bbe6a27e2ed90$var$MAX_ALLOWED_STRING_LENGTH, ", but a value of ").concat(maxStringLength, " was configured. Sentry will use ").concat($bd8bbe6a27e2ed90$var$MAX_ALLOWED_STRING_LENGTH, " instead."));
            maxStringLength = $bd8bbe6a27e2ed90$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === "string") keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            var event = handlerData.event;
            target = $bd8bbe6a27e2ed90$var$_isEvent(event) ? (0, $2Qsdx.htmlTreeAsString)(event.target, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            }) : (0, $2Qsdx.htmlTreeAsString)(event, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
        } catch (e) {
            target = "<unknown>";
        }
        if (target.length === 0) return;
        (0, $1uvy1.getCurrentHub)().addBreadcrumb({
            category: "ui.".concat(handlerData.name),
            message: target
        }, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    }
    return _innerDomBreadcrumb;
}
/**
 * Creates breadcrumbs from console API calls
 */ function $bd8bbe6a27e2ed90$var$_consoleBreadcrumb(handlerData) {
    var breadcrumb = {
        category: "console",
        data: {
            arguments: handlerData.args,
            logger: "console"
        },
        level: (0, $cX6Q7.severityLevelFromString)(handlerData.level),
        message: (0, $11858.safeJoin)(handlerData.args, " ")
    };
    if (handlerData.level === "assert") {
        if (handlerData.args[0] === false) {
            breadcrumb.message = "Assertion failed: ".concat((0, $11858.safeJoin)(handlerData.args.slice(1), " ") || "console.assert");
            breadcrumb.data.arguments = handlerData.args.slice(1);
        } else // Don't capture a breadcrumb for passed assertions
        return;
    }
    (0, $1uvy1.getCurrentHub)().addBreadcrumb(breadcrumb, {
        input: handlerData.args,
        level: handlerData.level
    });
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $bd8bbe6a27e2ed90$var$_xhrBreadcrumb(handlerData) {
    var startTimestamp = handlerData.startTimestamp, endTimestamp = handlerData.endTimestamp;
    var sentryXhrData = handlerData.xhr[0, $MsrRH.SENTRY_XHR_DATA_KEY];
    // We only capture complete, non-sentry requests
    if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
    var method = sentryXhrData.method, url = sentryXhrData.url, status_code = sentryXhrData.status_code, body = sentryXhrData.body;
    var data = {
        method: method,
        url: url,
        status_code: status_code
    };
    var hint = {
        xhr: handlerData.xhr,
        input: body,
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp
    };
    (0, $1uvy1.getCurrentHub)().addBreadcrumb({
        category: "xhr",
        data: data,
        type: "http"
    }, hint);
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $bd8bbe6a27e2ed90$var$_fetchBreadcrumb(handlerData) {
    var startTimestamp = handlerData.startTimestamp, endTimestamp = handlerData.endTimestamp;
    // We only capture complete fetch requests
    if (!endTimestamp) return;
    if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
    return;
    if (handlerData.error) {
        var data = handlerData.fetchData;
        var hint = {
            data: handlerData.error,
            input: handlerData.args,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        (0, $1uvy1.getCurrentHub)().addBreadcrumb({
            category: "fetch",
            data: data,
            level: "error",
            type: "http"
        }, hint);
    } else {
        var data1 = (0, $cxjpp._)((0, $do9pw._)({}, handlerData.fetchData), {
            status_code: handlerData.response && handlerData.response.status
        });
        var hint1 = {
            input: handlerData.args,
            response: handlerData.response,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        (0, $1uvy1.getCurrentHub)().addBreadcrumb({
            category: "fetch",
            data: data1,
            type: "http"
        }, hint1);
    }
}
/**
 * Creates breadcrumbs from history API calls
 */ function $bd8bbe6a27e2ed90$var$_historyBreadcrumb(handlerData) {
    var from = handlerData.from;
    var to = handlerData.to;
    var parsedLoc = (0, $16swx.parseUrl)((0, $1OIkc.WINDOW).location.href);
    var parsedFrom = (0, $16swx.parseUrl)(from);
    var parsedTo = (0, $16swx.parseUrl)(to);
    // Initial pushState doesn't provide `from` information
    if (!parsedFrom.path) parsedFrom = parsedLoc;
    // Use only the path component of the URL if the URL matches the current
    // document (almost all the time when using pushState)
    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
    (0, $1uvy1.getCurrentHub)().addBreadcrumb({
        category: "navigation",
        data: {
            from: from,
            to: to
        }
    });
}
function $bd8bbe6a27e2ed90$var$_isEvent(event) {
    return !!event && !!event.target;
}

});
parcelRegister("16swx", function(module, exports) {

$parcel$export(module.exports, "parseUrl", function () { return $0cdc7a3cb1d02105$export$7a5253c0f62e0150; });
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $0cdc7a3cb1d02105$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || "";
    var fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $0cdc7a3cb1d02105$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 */ function $0cdc7a3cb1d02105$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter(function(s) {
        return s.length > 0 && s !== ",";
    }).length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span description
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $0cdc7a3cb1d02105$export$e0ba26c9e23e1fe0(url) {
    var protocol = url.protocol, host = url.host, path = url.path;
    var filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, "[filtered]:[filtered]@")// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    .replace(":80", "").replace(":443", "") || "";
    return "".concat(protocol ? "".concat(protocol, "://") : "").concat(filteredHost).concat(path);
}

});

parcelRegister("cX6Q7", function(module, exports) {

$parcel$export(module.exports, "severityLevelFromString", function () { return $026ef8fba8f2c482$export$d771ef054122c30a; });
// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.
var $026ef8fba8f2c482$export$411d0ffdba845b6c = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
];
/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */ function $026ef8fba8f2c482$export$e01cef29b4327697(level) {
    return $026ef8fba8f2c482$export$d771ef054122c30a(level);
}
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $026ef8fba8f2c482$export$d771ef054122c30a(level) {
    return level === "warn" ? "warning" : $026ef8fba8f2c482$export$411d0ffdba845b6c.includes(level) ? level : "log";
}

});


parcelRegister("aFeNW", function(module, exports) {

$parcel$export(module.exports, "LinkedErrors", function () { return $7c3937968facc6a9$export$8d1e60aaf616fb4f; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $f0Vax = parcelRequire("f0Vax");

var $fmHq3 = parcelRequire("fmHq3");
var $7c3937968facc6a9$var$DEFAULT_KEY = "cause";
var $7c3937968facc6a9$var$DEFAULT_LIMIT = 5;
/** Adds SDK info to an event. */ var $7c3937968facc6a9$export$8d1e60aaf616fb4f = /*#__PURE__*/ function() {
    "use strict";
    function LinkedErrors() {
        var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, $4GJKx._)(this, LinkedErrors);
        this.name = LinkedErrors.id;
        this._key = options.key || $7c3937968facc6a9$var$DEFAULT_KEY;
        this._limit = options.limit || $7c3937968facc6a9$var$DEFAULT_LIMIT;
    }
    (0, $1wc17._)(LinkedErrors, [
        {
            /** @inheritdoc */ key: "setupOnce",
            value: function setupOnce() {
            // noop
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "preprocessEvent",
            value: function preprocessEvent(event, hint, client) {
                var options = client.getOptions();
                (0, $f0Vax.applyAggregateErrorsToEvent)((0, $fmHq3.exceptionFromError), options.stackParser, options.maxValueLength, this._key, this._limit, event, hint);
            }
        }
    ], [
        {
            key: "__initStatic",
            value: /**
   * @inheritDoc
   */ function __initStatic() {
                this.id = "LinkedErrors";
            }
        }
    ]);
    return LinkedErrors;
}();
$7c3937968facc6a9$export$8d1e60aaf616fb4f.__initStatic();

});
parcelRegister("f0Vax", function(module, exports) {

$parcel$export(module.exports, "applyAggregateErrorsToEvent", function () { return $aee333a6063db883$export$b91c38ed7d8ae9b2; });

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $c6Xmf = parcelRequire("c6Xmf");

var $fFQTh = parcelRequire("fFQTh");

var $11858 = parcelRequire("11858");
/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $aee333a6063db883$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser) {
    var maxValueLimit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 250, key = arguments.length > 3 ? arguments[3] : void 0, limit = arguments.length > 4 ? arguments[4] : void 0, event = arguments.length > 5 ? arguments[5] : void 0, hint = arguments.length > 6 ? arguments[6] : void 0;
    if (!event.exception || !event.exception.values || !hint || !(0, $fFQTh.isInstanceOf)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    var originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $aee333a6063db883$var$truncateAggregateExceptions($aee333a6063db883$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
}
function $aee333a6063db883$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    var newExceptions = (0, $c6Xmf._)(prevExceptions);
    if ((0, $fFQTh.isInstanceOf)(error[key], Error)) {
        $aee333a6063db883$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        var newException = exceptionFromErrorImplementation(parser, error[key]);
        var newExceptionId = newExceptions.length;
        $aee333a6063db883$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $aee333a6063db883$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException
        ].concat((0, $c6Xmf._)(newExceptions)), newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach(function(childError, i) {
        if ((0, $fFQTh.isInstanceOf)(childError, Error)) {
            $aee333a6063db883$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            var newException = exceptionFromErrorImplementation(parser, childError);
            var newExceptionId = newExceptions.length;
            $aee333a6063db883$var$applyExceptionGroupFieldsForChildException(newException, "errors[".concat(i, "]"), newExceptionId, exceptionId);
            newExceptions = $aee333a6063db883$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException
            ].concat((0, $c6Xmf._)(newExceptions)), newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $aee333a6063db883$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = (0, $cxjpp._)((0, $do9pw._)({}, exception.mechanism), {
        is_exception_group: true,
        exception_id: exceptionId
    });
}
function $aee333a6063db883$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = (0, $cxjpp._)((0, $do9pw._)({}, exception.mechanism), {
        type: "chained",
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    });
}
/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */ function $aee333a6063db883$var$truncateAggregateExceptions(exceptions, maxValueLength) {
    return exceptions.map(function(exception) {
        if (exception.value) exception.value = (0, $11858.truncate)(exception.value, maxValueLength);
        return exception;
    });
}

});


parcelRegister("gOg06", function(module, exports) {

$parcel$export(module.exports, "HttpContext", function () { return $c3cdba3b081f3cd7$export$5d2ee9a544b09a94; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $1OIkc = parcelRequire("1OIkc");
/** HttpContext integration collects information about HTTP request headers */ var $c3cdba3b081f3cd7$export$5d2ee9a544b09a94 = /*#__PURE__*/ function() {
    "use strict";
    function HttpContext() {
        (0, $4GJKx._)(this, HttpContext);
        this.name = HttpContext.id;
    }
    (0, $1wc17._)(HttpContext, [
        {
            /**
   * @inheritDoc
   */ key: "setupOnce",
            value: function setupOnce() {
            // noop
            }
        },
        {
            /** @inheritDoc */ key: "preprocessEvent",
            value: function preprocessEvent(event) {
                // if none of the information we want exists, don't bother
                if (!(0, $1OIkc.WINDOW).navigator && !(0, $1OIkc.WINDOW).location && !(0, $1OIkc.WINDOW).document) return;
                // grab as much info as exists and add it to the event
                var url = event.request && event.request.url || (0, $1OIkc.WINDOW).location && (0, $1OIkc.WINDOW).location.href;
                var referrer = ((0, $1OIkc.WINDOW).document || {}).referrer;
                var userAgent = ((0, $1OIkc.WINDOW).navigator || {}).userAgent;
                var headers = (0, $do9pw._)({}, event.request && event.request.headers, referrer && {
                    Referer: referrer
                }, userAgent && {
                    "User-Agent": userAgent
                });
                var request = (0, $cxjpp._)((0, $do9pw._)({}, event.request, url && {
                    url: url
                }), {
                    headers: headers
                });
                event.request = request;
            }
        }
    ], [
        {
            key: "__initStatic",
            value: /**
   * @inheritDoc
   */ function __initStatic() {
                this.id = "HttpContext";
            }
        }
    ]);
    return HttpContext;
}();
$c3cdba3b081f3cd7$export$5d2ee9a544b09a94.__initStatic();

});

parcelRegister("8RDo5", function(module, exports) {

$parcel$export(module.exports, "Dedupe", function () { return $6741d382af340f68$export$688d98c249d31ad3; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $fNn7q = parcelRequire("fNn7q");
/** Deduplication filter */ var $6741d382af340f68$export$688d98c249d31ad3 = /*#__PURE__*/ function() {
    "use strict";
    function Dedupe() {
        (0, $4GJKx._)(this, Dedupe);
        this.name = Dedupe.id;
    }
    (0, $1wc17._)(Dedupe, [
        {
            /** @inheritDoc */ key: "setupOnce",
            value: function setupOnce(_addGlobaleventProcessor, _getCurrentHub) {
            // noop
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "processEvent",
            value: function processEvent(currentEvent) {
                // We want to ignore any non-error type events, e.g. transactions or replays
                // These should never be deduped, and also not be compared against as _previousEvent.
                if (currentEvent.type) return currentEvent;
                // Juuust in case something goes wrong
                try {
                    if ($6741d382af340f68$var$_shouldDropEvent(currentEvent, this._previousEvent)) {
                        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).warn("Event dropped due to being a duplicate of previously captured event.");
                        return null;
                    }
                } catch (_oO) {} // eslint-disable-line no-empty
                return this._previousEvent = currentEvent;
            }
        }
    ], [
        {
            key: "__initStatic",
            value: /**
   * @inheritDoc
   */ function __initStatic() {
                this.id = "Dedupe";
            }
        }
    ]);
    return Dedupe;
}();
$6741d382af340f68$export$688d98c249d31ad3.__initStatic();
/** JSDoc */ function $6741d382af340f68$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($6741d382af340f68$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($6741d382af340f68$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
/** JSDoc */ function $6741d382af340f68$var$_isSameMessageEvent(currentEvent, previousEvent) {
    var currentMessage = currentEvent.message;
    var previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$6741d382af340f68$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$6741d382af340f68$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $6741d382af340f68$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    var previousException = $6741d382af340f68$var$_getExceptionFromEvent(previousEvent);
    var currentException = $6741d382af340f68$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$6741d382af340f68$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$6741d382af340f68$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $6741d382af340f68$var$_isSameStacktrace(currentEvent, previousEvent) {
    var currentFrames = $6741d382af340f68$var$_getFramesFromEvent(currentEvent);
    var previousFrames = $6741d382af340f68$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(var i = 0; i < previousFrames.length; i++){
        var frameA = previousFrames[i];
        var frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
/** JSDoc */ function $6741d382af340f68$var$_isSameFingerprint(currentEvent, previousEvent) {
    var currentFingerprint = currentEvent.fingerprint;
    var previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch (_oO) {
        return false;
    }
}
/** JSDoc */ function $6741d382af340f68$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
/** JSDoc */ function $6741d382af340f68$var$_getFramesFromEvent(event) {
    var exception = event.exception;
    if (exception) try {
        // @ts-expect-error Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    return undefined;
}

});

parcelRegister("9H2dV", function(module, exports) {

$parcel$export(module.exports, "defaultStackParser", function () { return $70e9dacb9ca797f0$export$2b2b997d81bf3907; });

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");

var $5cx56 = parcelRequire("5cx56");
// global reference to slice
var $70e9dacb9ca797f0$var$UNKNOWN_FUNCTION = "?";
var $70e9dacb9ca797f0$var$OPERA10_PRIORITY = 10;
var $70e9dacb9ca797f0$var$OPERA11_PRIORITY = 20;
var $70e9dacb9ca797f0$var$CHROME_PRIORITY = 30;
var $70e9dacb9ca797f0$var$WINJS_PRIORITY = 40;
var $70e9dacb9ca797f0$var$GECKO_PRIORITY = 50;
function $70e9dacb9ca797f0$var$createFrame(filename, func, lineno, colno) {
    var frame = {
        filename: filename,
        function: func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
var $70e9dacb9ca797f0$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
var $70e9dacb9ca797f0$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
var $70e9dacb9ca797f0$var$chrome = function(line) {
    var parts = $70e9dacb9ca797f0$var$chromeRegex.exec(line);
    if (parts) {
        var isEval = parts[2] && parts[2].indexOf("eval") === 0; // start of line
        if (isEval) {
            var subMatch = $70e9dacb9ca797f0$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        var _extractSafariExtensionDetails = (0, $cv9Rk._)($70e9dacb9ca797f0$var$extractSafariExtensionDetails(parts[1] || $70e9dacb9ca797f0$var$UNKNOWN_FUNCTION, parts[2]), 2), func = _extractSafariExtensionDetails[0], filename = _extractSafariExtensionDetails[1];
        return $70e9dacb9ca797f0$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
var $70e9dacb9ca797f0$export$263a749fff749872 = [
    $70e9dacb9ca797f0$var$CHROME_PRIORITY,
    $70e9dacb9ca797f0$var$chrome
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
var $70e9dacb9ca797f0$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
var $70e9dacb9ca797f0$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
var $70e9dacb9ca797f0$var$gecko = function(line) {
    var parts = $70e9dacb9ca797f0$var$geckoREgex.exec(line);
    if (parts) {
        var isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
        if (isEval) {
            var subMatch = $70e9dacb9ca797f0$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || "eval";
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ""; // no column when eval
            }
        }
        var filename = parts[3];
        var func = parts[1] || $70e9dacb9ca797f0$var$UNKNOWN_FUNCTION;
        var ref;
        ref = (0, $cv9Rk._)($70e9dacb9ca797f0$var$extractSafariExtensionDetails(func, filename), 2), func = ref[0], filename = ref[1], ref;
        return $70e9dacb9ca797f0$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
var $70e9dacb9ca797f0$export$cdba47a5dd2804d = [
    $70e9dacb9ca797f0$var$GECKO_PRIORITY,
    $70e9dacb9ca797f0$var$gecko
];
var $70e9dacb9ca797f0$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
var $70e9dacb9ca797f0$var$winjs = function(line) {
    var parts = $70e9dacb9ca797f0$var$winjsRegex.exec(line);
    return parts ? $70e9dacb9ca797f0$var$createFrame(parts[2], parts[1] || $70e9dacb9ca797f0$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
var $70e9dacb9ca797f0$export$179460296da408e8 = [
    $70e9dacb9ca797f0$var$WINJS_PRIORITY,
    $70e9dacb9ca797f0$var$winjs
];
var $70e9dacb9ca797f0$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
var $70e9dacb9ca797f0$var$opera10 = function(line) {
    var parts = $70e9dacb9ca797f0$var$opera10Regex.exec(line);
    return parts ? $70e9dacb9ca797f0$var$createFrame(parts[2], parts[3] || $70e9dacb9ca797f0$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
var $70e9dacb9ca797f0$export$f892b52c880ffc7a = [
    $70e9dacb9ca797f0$var$OPERA10_PRIORITY,
    $70e9dacb9ca797f0$var$opera10
];
var $70e9dacb9ca797f0$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
var $70e9dacb9ca797f0$var$opera11 = function(line) {
    var parts = $70e9dacb9ca797f0$var$opera11Regex.exec(line);
    return parts ? $70e9dacb9ca797f0$var$createFrame(parts[5], parts[3] || parts[4] || $70e9dacb9ca797f0$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
var $70e9dacb9ca797f0$export$af11af13f09fb0dc = [
    $70e9dacb9ca797f0$var$OPERA11_PRIORITY,
    $70e9dacb9ca797f0$var$opera11
];
var $70e9dacb9ca797f0$export$7197c0fe6554c079 = [
    $70e9dacb9ca797f0$export$263a749fff749872,
    $70e9dacb9ca797f0$export$cdba47a5dd2804d,
    $70e9dacb9ca797f0$export$179460296da408e8
];
var $70e9dacb9ca797f0$export$2b2b997d81bf3907 = (0, $5cx56.createStackParser).apply(void 0, (0, $c6Xmf._)($70e9dacb9ca797f0$export$7197c0fe6554c079));
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ var $70e9dacb9ca797f0$var$extractSafariExtensionDetails = function(func, filename) {
    var isSafariExtension = func.indexOf("safari-extension") !== -1;
    var isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf("@") !== -1 ? func.split("@")[0] : $70e9dacb9ca797f0$var$UNKNOWN_FUNCTION,
        isSafariExtension ? "safari-extension:".concat(filename) : "safari-web-extension:".concat(filename)
    ] : [
        func,
        filename
    ];
};

});

parcelRegister("gBeZr", function(module, exports) {

$parcel$export(module.exports, "makeFetchTransport", function () { return $c15bbabd10dbb708$export$b2311068c46d7cc8; });

var $do9pw = parcelRequire("do9pw");

var $jKirH = parcelRequire("jKirH");

var $dvm65 = parcelRequire("dvm65");

var $ckaHP = parcelRequire("ckaHP");
/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $c15bbabd10dbb708$export$b2311068c46d7cc8(options) {
    var nativeFetch = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, $ckaHP.getNativeFetchImplementation)();
    var pendingBodySize = 0;
    var pendingCount = 0;
    function makeRequest(request) {
        var requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        var requestOptions = (0, $do9pw._)({
            body: request.body,
            method: "POST",
            referrerPolicy: "origin",
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15
        }, options.fetchOptions);
        try {
            return nativeFetch(options.url, requestOptions).then(function(response) {
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
                        "retry-after": response.headers.get("Retry-After")
                    }
                };
            });
        } catch (e) {
            (0, $ckaHP.clearCachedFetchImplementation)();
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $dvm65.rejectedSyncPromise)(e);
        }
    }
    return (0, $jKirH.createTransport)(options, makeRequest);
}

});
parcelRegister("jKirH", function(module, exports) {

$parcel$export(module.exports, "createTransport", function () { return $e6009f1e677469e0$export$d09f50d9ab7f7b69; });

var $gWN4v = parcelRequire("gWN4v");
var $brOMd = parcelRequire("brOMd");
var $fNn7q = parcelRequire("fNn7q");
var $cJ4Ow = parcelRequire("cJ4Ow");
var $dvm65 = parcelRequire("dvm65");
var $4adLA = parcelRequire("4adLA");
var $e6009f1e677469e0$export$e515cf6dfd2f98b8 = 30;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $e6009f1e677469e0$export$d09f50d9ab7f7b69(options, makeRequest) {
    var buffer = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (0, $cJ4Ow.makePromiseBuffer)(options.bufferSize || $e6009f1e677469e0$export$e515cf6dfd2f98b8);
    var rateLimits = {};
    var flush = function(timeout) {
        return buffer.drain(timeout);
    };
    function send(envelope) {
        var filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $gWN4v.forEachEnvelopeItem)(envelope, function(item, type) {
            var envelopeItemDataCategory = (0, $gWN4v.envelopeItemTypeToDataCategory)(type);
            if ((0, $brOMd.isRateLimited)(rateLimits, envelopeItemDataCategory)) {
                var event = $e6009f1e677469e0$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent("ratelimit_backoff", envelopeItemDataCategory, event);
            } else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $dvm65.resolvedSyncPromise)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var filteredEnvelope = (0, $gWN4v.createEnvelope)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        var recordEnvelopeLoss = function(reason) {
            (0, $gWN4v.forEachEnvelopeItem)(filteredEnvelope, function(item, type) {
                var event = $e6009f1e677469e0$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, (0, $gWN4v.envelopeItemTypeToDataCategory)(type), event);
            });
        };
        var requestTask = function() {
            return makeRequest({
                body: (0, $gWN4v.serializeEnvelope)(filteredEnvelope, options.textEncoder)
            }).then(function(response) {
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).warn("Sentry responded with status code ".concat(response.statusCode, " to sent event."));
                rateLimits = (0, $brOMd.updateRateLimits)(rateLimits, response);
                return response;
            }, function(error) {
                recordEnvelopeLoss("network_error");
                throw error;
            });
        };
        return buffer.add(requestTask).then(function(result) {
            return result;
        }, function(error) {
            if (error instanceof (0, $4adLA.SentryError)) {
                (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).error("Skipped sending event because buffer is full.");
                recordEnvelopeLoss("queue_overflow");
                return (0, $dvm65.resolvedSyncPromise)();
            } else throw error;
        });
    }
    // We use this to identifify if the transport is the base transport
    // TODO (v8): Remove this again as we'll no longer need it
    send.__sentry__baseTransport__ = true;
    return {
        send: send,
        flush: flush
    };
}
function $e6009f1e677469e0$var$getEventForEnvelopeItem(item, type) {
    if (type !== "event" && type !== "transaction") return undefined;
    return Array.isArray(item) ? item[1] : undefined;
}

});
parcelRegister("brOMd", function(module, exports) {

$parcel$export(module.exports, "isRateLimited", function () { return $85599a83c10524f6$export$6c91fec22056810a; });
$parcel$export(module.exports, "updateRateLimits", function () { return $85599a83c10524f6$export$699aff705e0d49d4; });
// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend

var $do9pw = parcelRequire("do9pw");

var $cv9Rk = parcelRequire("cv9Rk");
var $85599a83c10524f6$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $85599a83c10524f6$export$615352e17ed7741(header) {
    var now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now();
    var headerDelay = parseInt("".concat(header), 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    var headerDate = Date.parse("".concat(header));
    if (!isNaN(headerDate)) return headerDate - now;
    return $85599a83c10524f6$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $85599a83c10524f6$export$b89fc7b2e4c799e7(limits, category) {
    return limits[category] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $85599a83c10524f6$export$6c91fec22056810a(limits, category) {
    var now = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Date.now();
    return $85599a83c10524f6$export$b89fc7b2e4c799e7(limits, category) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $85599a83c10524f6$export$699aff705e0d49d4(limits, param) {
    var statusCode = param.statusCode, headers = param.headers, now = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Date.now();
    var updatedRateLimits = (0, $do9pw._)({}, limits);
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    var rateLimitHeader = headers && headers["x-sentry-rate-limits"];
    var retryAfterHeader = headers && headers["retry-after"];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (rateLimitHeader) try {
        /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     */ for(var _iterator = rateLimitHeader.trim().split(",")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var limit = _step.value;
            var _limit_split = (0, $cv9Rk._)(limit.split(":", 2), 2), retryAfter = _limit_split[0], categories = _limit_split[1];
            var headerDelay = parseInt(retryAfter, 10);
            var delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            if (!categories) updatedRateLimits.all = now + delay;
            else try {
                for(var _iterator1 = categories.split(";")[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var category = _step1.value;
                    updatedRateLimits[category] = now + delay;
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $85599a83c10524f6$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}

});

parcelRegister("cJ4Ow", function(module, exports) {

$parcel$export(module.exports, "makePromiseBuffer", function () { return $943d6bea69761626$export$85a4f67f852183e6; });

var $4adLA = parcelRequire("4adLA");

var $dvm65 = parcelRequire("dvm65");
/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $943d6bea69761626$export$85a4f67f852183e6(limit) {
    var buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $dvm65.rejectedSyncPromise)(new (0, $4adLA.SentryError)("Not adding Promise because buffer limit was reached."));
        // start the task and add its promise to the queue
        var task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(function() {
            return remove(task);
        })// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, function() {
            return remove(task).then(null, function() {
            // We have to add another catch here because `remove()` starts a new promise chain.
            });
        });
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $dvm65.SyncPromise)(function(resolve, reject) {
            var counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            var capturedSetTimeout = setTimeout(function() {
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach(function(item) {
                (0, $dvm65.resolvedSyncPromise)(item).then(function() {
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}

});


parcelRegister("ckaHP", function(module, exports) {

$parcel$export(module.exports, "getNativeFetchImplementation", function () { return $8f8fa8442baea0d7$export$8be2119ce08e3379; });
$parcel$export(module.exports, "clearCachedFetchImplementation", function () { return $8f8fa8442baea0d7$export$d499686d2dd738c6; });

var $2D0U7 = parcelRequire("2D0U7");
var $fNn7q = parcelRequire("fNn7q");

var $1OIkc = parcelRequire("1OIkc");
var $8f8fa8442baea0d7$var$cachedFetchImpl = undefined;
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $8f8fa8442baea0d7$export$8be2119ce08e3379() {
    if ($8f8fa8442baea0d7$var$cachedFetchImpl) return $8f8fa8442baea0d7$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $2D0U7.isNativeFetch)((0, $1OIkc.WINDOW).fetch)) return $8f8fa8442baea0d7$var$cachedFetchImpl = (0, $1OIkc.WINDOW).fetch.bind((0, $1OIkc.WINDOW));
    var document = (0, $1OIkc.WINDOW).document;
    var fetchImpl = (0, $1OIkc.WINDOW).fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === "function") try {
        var sandbox = document.createElement("iframe");
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        var contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $fNn7q.logger).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", e);
    }
    return $8f8fa8442baea0d7$var$cachedFetchImpl = fetchImpl.bind((0, $1OIkc.WINDOW));
/* eslint-enable @typescript-eslint/unbound-method */ }
/** Clears cached fetch impl */ function $8f8fa8442baea0d7$export$d499686d2dd738c6() {
    $8f8fa8442baea0d7$var$cachedFetchImpl = undefined;
}

});


parcelRegister("3V7vj", function(module, exports) {

$parcel$export(module.exports, "makeXHRTransport", function () { return $2dac841d86157705$export$5e1441cee30d5a39; });

var $jKirH = parcelRequire("jKirH");

var $dvm65 = parcelRequire("dvm65");
/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ var $2dac841d86157705$var$XHR_READYSTATE_DONE = 4;
/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */ function $2dac841d86157705$export$5e1441cee30d5a39(options) {
    function makeRequest(request) {
        return new (0, $dvm65.SyncPromise)(function(resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.onerror = reject;
            xhr.onreadystatechange = function() {
                if (xhr.readyState === $2dac841d86157705$var$XHR_READYSTATE_DONE) resolve({
                    statusCode: xhr.status,
                    headers: {
                        "x-sentry-rate-limits": xhr.getResponseHeader("X-Sentry-Rate-Limits"),
                        "retry-after": xhr.getResponseHeader("Retry-After")
                    }
                });
            };
            xhr.open("POST", options.url);
            for(var header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $jKirH.createTransport)(options, makeRequest);
}

});



parcelRegister("9wtIr", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $6eee272628963ce8$export$2cd8252107eb640b; });

var $do9pw = parcelRequire("do9pw");

var $jI6fQ = parcelRequire("jI6fQ");
var $987Jv = parcelRequire("987Jv");
/**
 * Inits the React SDK
 */ function $6eee272628963ce8$export$2cd8252107eb640b(options) {
    var opts = (0, $do9pw._)({
        _metadata: {}
    }, options);
    opts._metadata.sdk = opts._metadata.sdk || {
        name: "sentry.javascript.react",
        packages: [
            {
                name: "npm:@sentry/react",
                version: (0, $987Jv.SDK_VERSION)
            }
        ],
        version: (0, $987Jv.SDK_VERSION)
    };
    (0, $jI6fQ.init)(opts);
}

});

parcelRegister("kMa9P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2002b6401f6f348$export$2e2bcd8739ae039; });
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $l29cN = parcelRequire("l29cN");

var $1Mpn7 = parcelRequire("1Mpn7");

var $4P5Sm = parcelRequire("4P5Sm");

var $8xhJC = parcelRequire("8xhJC");

var $bk3D8 = parcelRequire("bk3D8");
var $ehiPA = parcelRequire("ehiPA");
var $hF6zg = parcelRequire("hF6zg");

var $k7OPo = parcelRequire("k7OPo");
function $f2002b6401f6f348$var$processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements
    };
}
function $f2002b6401f6f348$var$assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce(function(acc, k) {
        var v = values[k];
        acc[k] = (0, $k7OPo.isFormatXMLElementFn)(v) ? (0, $8xhJC.assignUniqueKeysToParts)(v) : v;
        return acc;
    }, {});
}
var $f2002b6401f6f348$var$formatMessage = function formatMessage(config, formatters, descriptor, rawValues) {
    var rest = [];
    for(var _i = 4; _i < arguments.length; _i++)rest[_i - 4] = arguments[_i];
    var values = $f2002b6401f6f348$var$assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = (0, $hF6zg.formatMessage).apply(void 0, (0, $l29cN.__spreadArray)([
        config,
        formatters,
        descriptor,
        values
    ], rest, false));
    if (Array.isArray(chunks)) return $1Mpn7.Children.toArray(chunks);
    return chunks;
};
var $f2002b6401f6f348$export$7e4cbedfdd7b4c0d = function createIntl(_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0, $l29cN.__rest)(_a, [
        "defaultRichTextElements"
    ]);
    var defaultRichTextElements = $f2002b6401f6f348$var$assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = (0, $bk3D8.createIntl)((0, $l29cN.__assign)((0, $l29cN.__assign)((0, $l29cN.__assign)({}, (0, $8xhJC.DEFAULT_INTL_CONFIG)), config), {
        defaultRichTextElements: defaultRichTextElements
    }), cache);
    var resolvedConfig = {
        locale: coreIntl.locale,
        timeZone: coreIntl.timeZone,
        fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
        formats: coreIntl.formats,
        defaultLocale: coreIntl.defaultLocale,
        defaultFormats: coreIntl.defaultFormats,
        messages: coreIntl.messages,
        onError: coreIntl.onError,
        defaultRichTextElements: defaultRichTextElements
    };
    return (0, $l29cN.__assign)((0, $l29cN.__assign)({}, coreIntl), {
        // @ts-expect-error fix this
        formatMessage: $f2002b6401f6f348$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters),
        // @ts-expect-error fix this
        $t: $f2002b6401f6f348$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters)
    });
};
var $f2002b6401f6f348$var$IntlProvider = /** @class */ function(_super) {
    (0, $l29cN.__extends)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0, $ehiPA.createIntlCache)();
        _this.state = {
            cache: _this.cache,
            intl: $f2002b6401f6f348$export$7e4cbedfdd7b4c0d($f2002b6401f6f348$var$processIntlConfig(_this.props), _this.cache),
            prevConfig: $f2002b6401f6f348$var$processIntlConfig(_this.props)
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function(props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = $f2002b6401f6f348$var$processIntlConfig(props);
        if (!(0, $8xhJC.shallowEqual)(prevConfig, config)) return {
            intl: $f2002b6401f6f348$export$7e4cbedfdd7b4c0d(config, cache),
            prevConfig: config
        };
        return null;
    };
    IntlProvider.prototype.render = function() {
        (0, $8xhJC.invariantIntlContext)(this.state.intl);
        return $1Mpn7.createElement((0, $4P5Sm.Provider), {
            value: this.state.intl
        }, this.props.children);
    };
    IntlProvider.displayName = "IntlProvider";
    IntlProvider.defaultProps = (0, $8xhJC.DEFAULT_INTL_CONFIG);
    return IntlProvider;
}($1Mpn7.PureComponent);
var $f2002b6401f6f348$export$2e2bcd8739ae039 = $f2002b6401f6f348$var$IntlProvider;

});
parcelRegister("4P5Sm", function(module, exports) {

$parcel$export(module.exports, "Provider", function () { return $38307ba1e3555a1f$export$2881499e37b75b9a; });
$parcel$export(module.exports, "Context", function () { return $38307ba1e3555a1f$export$841858b892ce1f4c; });
$parcel$export(module.exports, "default", function () { return $38307ba1e3555a1f$export$2e2bcd8739ae039; });

var $l29cN = parcelRequire("l29cN");

var $1Mpn7 = parcelRequire("1Mpn7");

var $knVHJ = parcelRequire("knVHJ");

var $8xhJC = parcelRequire("8xhJC");
function $38307ba1e3555a1f$var$getDisplayName(Component) {
    return Component.displayName || Component.name || "Component";
}
// This is primarily dealing with packaging systems where multiple copies of react-intl
// might exist
var $38307ba1e3555a1f$var$IntlContext = typeof window !== "undefined" && !window.__REACT_INTL_BYPASS_GLOBAL_CONTEXT__ ? window.__REACT_INTL_CONTEXT__ || (window.__REACT_INTL_CONTEXT__ = $1Mpn7.createContext(null)) : $1Mpn7.createContext(null);
var $38307ba1e3555a1f$var$IntlConsumer = $38307ba1e3555a1f$var$IntlContext.Consumer, $38307ba1e3555a1f$var$IntlProvider = $38307ba1e3555a1f$var$IntlContext.Provider;
var $38307ba1e3555a1f$export$2881499e37b75b9a = $38307ba1e3555a1f$var$IntlProvider;
var $38307ba1e3555a1f$export$841858b892ce1f4c = $38307ba1e3555a1f$var$IntlContext;
function $38307ba1e3555a1f$export$2e2bcd8739ae039(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? "intl" : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function WithIntl(props) {
        return $1Mpn7.createElement($38307ba1e3555a1f$var$IntlConsumer, null, function(intl) {
            var _a;
            if (enforceContext) (0, $8xhJC.invariantIntlContext)(intl);
            var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
            return $1Mpn7.createElement(WrappedComponent, (0, $l29cN.__assign)({}, props, intlProp, {
                ref: forwardRef ? props.forwardedRef : null
            }));
        });
    };
    WithIntl.displayName = "injectIntl(".concat($38307ba1e3555a1f$var$getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) return (0, (/*@__PURE__*/$parcel$interopDefault($knVHJ)))($1Mpn7.forwardRef(function(props, ref) {
        return $1Mpn7.createElement(WithIntl, (0, $l29cN.__assign)({}, props, {
            forwardedRef: ref
        }));
    }), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($knVHJ)))(WithIntl, WrappedComponent);
}

});
parcelRegister("8xhJC", function(module, exports) {

$parcel$export(module.exports, "invariantIntlContext", function () { return $636f298e4427da85$export$45c4bbf6e55bba1f; });
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", function () { return $636f298e4427da85$export$b52f8d6fc0d47415; });
$parcel$export(module.exports, "assignUniqueKeysToParts", function () { return $636f298e4427da85$export$cfec03d26465fa63; });
$parcel$export(module.exports, "shallowEqual", function () { return $636f298e4427da85$export$d36bdfa510afb180; });

var $l29cN = parcelRequire("l29cN");

var $1Mpn7 = parcelRequire("1Mpn7");

var $8lCTf = parcelRequire("8lCTf");

var $ehiPA = parcelRequire("ehiPA");
function $636f298e4427da85$export$45c4bbf6e55bba1f(intl) {
    (0, $8lCTf.invariant)(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var $636f298e4427da85$export$b52f8d6fc0d47415 = (0, $l29cN.__assign)((0, $l29cN.__assign)({}, (0, $ehiPA.DEFAULT_INTL_CONFIG)), {
    textComponent: $1Mpn7.Fragment
});
function $636f298e4427da85$export$cfec03d26465fa63(formatXMLElementFn) {
    return function(parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn($1Mpn7.Children.toArray(parts));
    };
}
function $636f298e4427da85$export$d36bdfa510afb180(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}

});
parcelRegister("8lCTf", function(module, exports) {

$parcel$export(module.exports, "invariant", function () { return $613e73ab389112d2$export$f5708dca728d7177; });
/**
 * Cannot do Math.log(x) / Math.log(10) bc if IEEE floating point issue
 * @param x number
 */ function $613e73ab389112d2$export$f535bb00660c42db(x) {
    // Cannot count string length via Number.toString because it may use scientific notation
    // for very small or very large numbers.
    return Math.floor(Math.log(x) * Math.LOG10E);
}
function $613e73ab389112d2$export$76d90c956114f2c2(s, times) {
    if (typeof s.repeat === "function") return s.repeat(times);
    var arr = new Array(times);
    for(var i = 0; i < arr.length; i++)arr[i] = s;
    return arr.join("");
}
function $613e73ab389112d2$export$489176b9ebc725cc(map, pl, field, value) {
    if (!map.get(pl)) map.set(pl, Object.create(null));
    var slots = map.get(pl);
    slots[field] = value;
}
function $613e73ab389112d2$export$d21499e79b5c28e2(map, pl, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var k = _a[_i];
        $613e73ab389112d2$export$489176b9ebc725cc(map, pl, k, props[k]);
    }
}
function $613e73ab389112d2$export$3fae2929ed23c202(map, pl, field) {
    return $613e73ab389112d2$export$ca4e2274c058dd9f(map, pl, field)[field];
}
function $613e73ab389112d2$export$ca4e2274c058dd9f(map, pl) {
    var fields = [];
    for(var _i = 2; _i < arguments.length; _i++)fields[_i - 2] = arguments[_i];
    var slots = map.get(pl);
    if (!slots) throw new TypeError("".concat(pl, " InternalSlot has not been initialized"));
    return fields.reduce(function(all, f) {
        all[f] = slots[f];
        return all;
    }, Object.create(null));
}
function $613e73ab389112d2$export$25c75e09b890f24e(patternPart) {
    return patternPart.type === "literal";
}
function $613e73ab389112d2$export$fdab3c20aae16ddf(target, name, _a) {
    var value = _a.value;
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value
    });
}
var $613e73ab389112d2$export$9049a02e759202e4 = /-u(?:-[0-9a-z]{2,8})+/gi;
function $613e73ab389112d2$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}

});

parcelRegister("ehiPA", function(module, exports) {

$parcel$export(module.exports, "filterProps", function () { return $a65142b04820af12$export$d697c39a2985a4c; });
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", function () { return $a65142b04820af12$export$b52f8d6fc0d47415; });
$parcel$export(module.exports, "createIntlCache", function () { return $a65142b04820af12$export$51c4f4e973f2dc00; });
$parcel$export(module.exports, "createFormatters", function () { return $a65142b04820af12$export$c3f4cd5551df13fd; });
$parcel$export(module.exports, "getNamedFormat", function () { return $a65142b04820af12$export$4ee1db8ce44a209b; });

var $l29cN = parcelRequire("l29cN");

var $05hJw = parcelRequire("05hJw");

var $gEYt7 = parcelRequire("gEYt7");

var $9r3qJ = parcelRequire("9r3qJ");
function $a65142b04820af12$export$d697c39a2985a4c(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
var $a65142b04820af12$var$defaultErrorHandler = function defaultErrorHandler(error) {};
var $a65142b04820af12$var$defaultWarnHandler = function defaultWarnHandler(warning) {};
var $a65142b04820af12$export$b52f8d6fc0d47415 = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: "en",
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: $a65142b04820af12$var$defaultErrorHandler,
    onWarn: $a65142b04820af12$var$defaultWarnHandler
};
function $a65142b04820af12$export$51c4f4e973f2dc00() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function $a65142b04820af12$var$createFastMemoizeCache(store) {
    return {
        create: function create() {
            return {
                get: function get(key) {
                    return store[key];
                },
                set: function set(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $a65142b04820af12$export$c3f4cd5551df13fd(cache) {
    if (cache === void 0) cache = $a65142b04820af12$export$51c4f4e973f2dc00();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, $gEYt7.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $l29cN.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $a65142b04820af12$var$createFastMemoizeCache(cache.dateTime),
        strategy: (0, $gEYt7.strategies).variadic
    });
    var getNumberFormat = (0, $gEYt7.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $l29cN.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $a65142b04820af12$var$createFastMemoizeCache(cache.number),
        strategy: (0, $gEYt7.strategies).variadic
    });
    var getPluralRules = (0, $gEYt7.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $l29cN.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $a65142b04820af12$var$createFastMemoizeCache(cache.pluralRules),
        strategy: (0, $gEYt7.strategies).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, $gEYt7.memoize)(function(message, locales, overrideFormats, opts) {
            return new (0, $05hJw.IntlMessageFormat)(message, locales, overrideFormats, (0, $l29cN.__assign)({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: $a65142b04820af12$var$createFastMemoizeCache(cache.message),
            strategy: (0, $gEYt7.strategies).variadic
        }),
        getRelativeTimeFormat: (0, $gEYt7.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0, $l29cN.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $a65142b04820af12$var$createFastMemoizeCache(cache.relativeTime),
            strategy: (0, $gEYt7.strategies).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, $gEYt7.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, (0, $l29cN.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $a65142b04820af12$var$createFastMemoizeCache(cache.list),
            strategy: (0, $gEYt7.strategies).variadic
        }),
        getDisplayNames: (0, $gEYt7.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, (0, $l29cN.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $a65142b04820af12$var$createFastMemoizeCache(cache.displayNames),
            strategy: (0, $gEYt7.strategies).variadic
        })
    };
}
function $a65142b04820af12$export$4ee1db8ce44a209b(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, $9r3qJ.UnsupportedFormatterError)("No ".concat(type, " format named: ").concat(name)));
}

});
parcelRegister("05hJw", function(module, exports) {

$parcel$export(module.exports, "IntlMessageFormat", function () { return $00fe393134d82849$export$d342343268debc40; });
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $l29cN = parcelRequire("l29cN");

var $7Whee = parcelRequire("7Whee");

var $gEYt7 = parcelRequire("gEYt7");

var $k7OPo = parcelRequire("k7OPo");
// -- MessageFormat --------------------------------------------------------
function $00fe393134d82849$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $l29cN.__assign)((0, $l29cN.__assign)((0, $l29cN.__assign)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $l29cN.__assign)((0, $l29cN.__assign)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $00fe393134d82849$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $00fe393134d82849$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $l29cN.__assign)({}, defaultConfig));
}
function $00fe393134d82849$var$createFastMemoizeCache(store) {
    return {
        create: function create() {
            return {
                get: function get(key) {
                    return store[key];
                },
                set: function set(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $00fe393134d82849$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $gEYt7.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $l29cN.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $00fe393134d82849$var$createFastMemoizeCache(cache.number),
            strategy: (0, $gEYt7.strategies).variadic
        }),
        getDateTimeFormat: (0, $gEYt7.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $l29cN.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $00fe393134d82849$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $gEYt7.strategies).variadic
        }),
        getPluralRules: (0, $gEYt7.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $l29cN.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $00fe393134d82849$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $gEYt7.strategies).variadic
        })
    };
}
var $00fe393134d82849$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        var _this = this;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $k7OPo.PART_TYPE).literal || typeof all[all.length - 1] !== "string") all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || "";
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $k7OPo.formatToParts)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            var _a;
            return {
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) || Intl.NumberFormat.supportedLocalesOf(_this.locales)[0]
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === "string") {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError("IntlMessageFormat.__parse must be set to process `message` of type `string`");
            var _a = opts || {}, formatters = _a.formatters, parseOpts = (0, $l29cN.__rest)(_a, [
                "formatters"
            ]);
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, (0, $l29cN.__assign)((0, $l29cN.__assign)({}, parseOpts), {
                locale: this.resolvedLocale
            }));
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError("A message must be provided as a String or AST.");
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $00fe393134d82849$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $00fe393134d82849$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function get() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        if (typeof Intl.Locale === "undefined") return;
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === "string" ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, $7Whee.parse);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: "currency"
            },
            percent: {
                style: "percent"
            }
        },
        date: {
            short: {
                month: "numeric",
                day: "numeric",
                year: "2-digit"
            },
            medium: {
                month: "short",
                day: "numeric",
                year: "numeric"
            },
            long: {
                month: "long",
                day: "numeric",
                year: "numeric"
            },
            full: {
                weekday: "long",
                month: "long",
                day: "numeric",
                year: "numeric"
            }
        },
        time: {
            short: {
                hour: "numeric",
                minute: "numeric"
            },
            medium: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric"
            },
            long: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            },
            full: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            }
        }
    };
    return IntlMessageFormat;
}();

});
parcelRegister("7Whee", function(module, exports) {
$parcel$export(module.exports, "isArgumentElement", function () { return (parcelRequire("eQLAg")).isArgumentElement; });
$parcel$export(module.exports, "isDateElement", function () { return (parcelRequire("eQLAg")).isDateElement; });
$parcel$export(module.exports, "isDateTimeSkeleton", function () { return (parcelRequire("eQLAg")).isDateTimeSkeleton; });
$parcel$export(module.exports, "isLiteralElement", function () { return (parcelRequire("eQLAg")).isLiteralElement; });
$parcel$export(module.exports, "isNumberElement", function () { return (parcelRequire("eQLAg")).isNumberElement; });
$parcel$export(module.exports, "isNumberSkeleton", function () { return (parcelRequire("eQLAg")).isNumberSkeleton; });
$parcel$export(module.exports, "isPluralElement", function () { return (parcelRequire("eQLAg")).isPluralElement; });
$parcel$export(module.exports, "isPoundElement", function () { return (parcelRequire("eQLAg")).isPoundElement; });
$parcel$export(module.exports, "isSelectElement", function () { return (parcelRequire("eQLAg")).isSelectElement; });
$parcel$export(module.exports, "isTagElement", function () { return (parcelRequire("eQLAg")).isTagElement; });
$parcel$export(module.exports, "isTimeElement", function () { return (parcelRequire("eQLAg")).isTimeElement; });
$parcel$export(module.exports, "TYPE", function () { return (parcelRequire("eQLAg")).TYPE; });

$parcel$export(module.exports, "parse", function () { return $5c7b50699a7e8476$export$98e6a39c04603d36; });

var $l29cN = parcelRequire("l29cN");

var $fcjZo = parcelRequire("fcjZo");

var $2zPM7 = parcelRequire("2zPM7");

var $eQLAg = parcelRequire("eQLAg");
function $5c7b50699a7e8476$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $eQLAg.isSelectElement)(el) || (0, $eQLAg.isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            $5c7b50699a7e8476$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $eQLAg.isNumberElement)(el) && (0, $eQLAg.isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, $eQLAg.isDateElement)(el) || (0, $eQLAg.isTimeElement)(el)) && (0, $eQLAg.isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, $eQLAg.isTagElement)(el)) $5c7b50699a7e8476$var$pruneLocation(el.children);
    });
}
function $5c7b50699a7e8476$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $l29cN.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $2zPM7.Parser)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $fcjZo.ErrorKind)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $5c7b50699a7e8476$var$pruneLocation(result.val);
    return result.val;
}
var $5c7b50699a7e8476$export$d3c1bfa0f7d806e9 = (0, $2zPM7.Parser);

});
parcelRegister("fcjZo", function(module, exports) {

$parcel$export(module.exports, "ErrorKind", function () { return $b1077b716a3e1313$export$896afd8541959ee5; });
var $b1077b716a3e1313$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($b1077b716a3e1313$export$896afd8541959ee5 || ($b1077b716a3e1313$export$896afd8541959ee5 = {}));

});

parcelRegister("2zPM7", function(module, exports) {

$parcel$export(module.exports, "Parser", function () { return $1e07031efdf778a8$export$7acfa6ed01010e37; });

var $l29cN = parcelRequire("l29cN");

var $fcjZo = parcelRequire("fcjZo");

var $eQLAg = parcelRequire("eQLAg");

var $i9bgs = parcelRequire("i9bgs");
parcelRequire("gn66P");
var $e0ibg = parcelRequire("e0ibg");
var $3CoNK = parcelRequire("3CoNK");

var $iYRjX = parcelRequire("iYRjX");
var $1e07031efdf778a8$var$_a;
var $1e07031efdf778a8$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $i9bgs.SPACE_SEPARATOR_REGEX).source, "*"));
var $1e07031efdf778a8$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $i9bgs.SPACE_SEPARATOR_REGEX).source, "*$"));
function $1e07031efdf778a8$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $1e07031efdf778a8$var$hasNativeStartsWith = !!String.prototype.startsWith && "_a".startsWith("a", 1);
var $1e07031efdf778a8$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $1e07031efdf778a8$var$hasNativeFromEntries = !!Object.fromEntries;
var $1e07031efdf778a8$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $1e07031efdf778a8$var$hasTrimStart = !!String.prototype.trimStart;
var $1e07031efdf778a8$var$hasTrimEnd = !!String.prototype.trimEnd;
var $1e07031efdf778a8$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $1e07031efdf778a8$var$isSafeInteger = $1e07031efdf778a8$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function isSafeInteger(n) {
    return typeof n === "number" && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $1e07031efdf778a8$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $1e07031efdf778a8$var$re = $1e07031efdf778a8$var$RE("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $1e07031efdf778a8$var$REGEX_SUPPORTS_U_AND_Y = (($1e07031efdf778a8$var$_a = $1e07031efdf778a8$var$re.exec("a")) === null || $1e07031efdf778a8$var$_a === void 0 ? void 0 : $1e07031efdf778a8$var$_a[0]) === "a";
} catch (_) {
    $1e07031efdf778a8$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $1e07031efdf778a8$var$startsWith = $1e07031efdf778a8$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $1e07031efdf778a8$var$fromCodePoint = $1e07031efdf778a8$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = "";
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + " is not a valid code point");
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $1e07031efdf778a8$var$fromEntries = // native
$1e07031efdf778a8$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $1e07031efdf778a8$var$codePointAt = $1e07031efdf778a8$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $1e07031efdf778a8$var$trimStart = $1e07031efdf778a8$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($1e07031efdf778a8$var$SPACE_SEPARATOR_START_REGEX, "");
};
var $1e07031efdf778a8$var$trimEnd = $1e07031efdf778a8$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($1e07031efdf778a8$var$SPACE_SEPARATOR_END_REGEX, "");
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $1e07031efdf778a8$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $1e07031efdf778a8$var$matchIdentifierAtIndex;
if ($1e07031efdf778a8$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $1e07031efdf778a8$var$IDENTIFIER_PREFIX_RE_1 = $1e07031efdf778a8$var$RE("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
    $1e07031efdf778a8$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $1e07031efdf778a8$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $1e07031efdf778a8$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : "";
    };
} else // IE11
$1e07031efdf778a8$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $1e07031efdf778a8$var$codePointAt(s, index);
        if (c === undefined || $1e07031efdf778a8$var$_isWhiteSpace(c) || $1e07031efdf778a8$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $1e07031efdf778a8$var$fromCodePoint.apply(void 0, match);
};
var $1e07031efdf778a8$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error("parser can only be used once");
        return this.parseMessage(0, "", false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === "plural" || parentArgType === "selectordinal")) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $eQLAg.TYPE).pound,
                    location: $1e07031efdf778a8$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $fcjZo.ErrorKind).UNMATCHED_CLOSING_TAG, $1e07031efdf778a8$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $1e07031efdf778a8$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf("/>")) // Self closing tag
        return {
            val: {
                type: (0, $eQLAg.TYPE).literal,
                value: "<".concat(tagName, "/>"),
                location: $1e07031efdf778a8$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf(">")) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf("</")) {
                if (this.isEOF() || !$1e07031efdf778a8$var$_isAlpha(this.char())) return this.error((0, $fcjZo.ErrorKind).INVALID_TAG, $1e07031efdf778a8$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $fcjZo.ErrorKind).UNMATCHED_CLOSING_TAG, $1e07031efdf778a8$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf(">")) return this.error((0, $fcjZo.ErrorKind).INVALID_TAG, $1e07031efdf778a8$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $eQLAg.TYPE).tag,
                        value: tagName,
                        children: children,
                        location: $1e07031efdf778a8$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $fcjZo.ErrorKind).UNCLOSED_TAG, $1e07031efdf778a8$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $fcjZo.ErrorKind).INVALID_TAG, $1e07031efdf778a8$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $1e07031efdf778a8$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = "";
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $1e07031efdf778a8$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $eQLAg.TYPE).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$1e07031efdf778a8$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return "<";
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === "plural" || parentArgType === "selectordinal") break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $1e07031efdf778a8$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === "plural" || parentArgType === "selectordinal") || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $1e07031efdf778a8$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $fcjZo.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $1e07031efdf778a8$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $fcjZo.ErrorKind).EMPTY_ARGUMENT, $1e07031efdf778a8$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $fcjZo.ErrorKind).MALFORMED_ARGUMENT, $1e07031efdf778a8$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $fcjZo.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $1e07031efdf778a8$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $eQLAg.TYPE).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $1e07031efdf778a8$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $fcjZo.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $1e07031efdf778a8$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $fcjZo.ErrorKind).MALFORMED_ARGUMENT, $1e07031efdf778a8$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $1e07031efdf778a8$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $1e07031efdf778a8$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case "":
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $fcjZo.ErrorKind).EXPECT_ARGUMENT_TYPE, $1e07031efdf778a8$var$createLocation(typeStartPosition, typeEndPosition));
            case "number":
            case "date":
            case "time":
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(",")) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $1e07031efdf778a8$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $fcjZo.ErrorKind).EXPECT_ARGUMENT_STYLE, $1e07031efdf778a8$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $1e07031efdf778a8$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $1e07031efdf778a8$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $1e07031efdf778a8$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, "::", 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $1e07031efdf778a8$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === "number") {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $eQLAg.TYPE).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $fcjZo.ErrorKind).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $iYRjX.getBestPattern)(skeleton, this.locale);
                        var style = {
                            type: (0, $eQLAg.SKELETON_TYPE).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $e0ibg.parseDateTimeSkeleton)(dateTimePattern) : {}
                        };
                        var type = argType === "date" ? (0, $eQLAg.TYPE).date : (0, $eQLAg.TYPE).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === "number" ? (0, $eQLAg.TYPE).number : argType === "date" ? (0, $eQLAg.TYPE).date : (0, $eQLAg.TYPE).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case "plural":
            case "selectordinal":
            case "select":
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(",")) return this.error((0, $fcjZo.ErrorKind).EXPECT_SELECT_ARGUMENT_OPTIONS, $1e07031efdf778a8$var$createLocation(typeEndPosition_1, (0, $l29cN.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== "select" && identifierAndLocation.value === "offset") {
                    if (!this.bumpIf(":")) return this.error((0, $fcjZo.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $1e07031efdf778a8$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $fcjZo.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $fcjZo.ErrorKind).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $1e07031efdf778a8$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === "select") return {
                    val: {
                        type: (0, $eQLAg.TYPE).select,
                        value: value,
                        options: $1e07031efdf778a8$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $eQLAg.TYPE).plural,
                        value: value,
                        options: $1e07031efdf778a8$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === "plural" ? "cardinal" : "ordinal",
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $fcjZo.ErrorKind).INVALID_ARGUMENT_TYPE, $1e07031efdf778a8$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $fcjZo.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $1e07031efdf778a8$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $fcjZo.ErrorKind).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $1e07031efdf778a8$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $3CoNK.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error((0, $fcjZo.ErrorKind).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $eQLAg.SKELETON_TYPE).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $3CoNK.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== "select" && this.bumpIf("=")) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $fcjZo.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $fcjZo.ErrorKind).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $1e07031efdf778a8$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === "select" ? (0, $fcjZo.ErrorKind).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $fcjZo.ErrorKind).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === "other") hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf("{")) return this.error(parentArgType === "select" ? (0, $fcjZo.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $fcjZo.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $1e07031efdf778a8$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $1e07031efdf778a8$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === "select" ? (0, $fcjZo.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $fcjZo.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, $1e07031efdf778a8$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $fcjZo.ErrorKind).MISSING_OTHER_CLAUSE, $1e07031efdf778a8$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf("+")) ;
        else if (this.bumpIf("-")) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $1e07031efdf778a8$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$1e07031efdf778a8$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error("out of bound");
        var code = $1e07031efdf778a8$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($1e07031efdf778a8$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $1e07031efdf778a8$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $1e07031efdf778a8$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $1e07031efdf778a8$var$_isAlphaOrSlash(codepoint) {
    return $1e07031efdf778a8$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $1e07031efdf778a8$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $1e07031efdf778a8$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $1e07031efdf778a8$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}

});
parcelRegister("eQLAg", function(module, exports) {

$parcel$export(module.exports, "TYPE", function () { return $acfad52ad3d60366$export$b87f371cbc396fcf; });
$parcel$export(module.exports, "SKELETON_TYPE", function () { return $acfad52ad3d60366$export$906452485466fa53; });
$parcel$export(module.exports, "isLiteralElement", function () { return $acfad52ad3d60366$export$cfa10c5697238752; });
$parcel$export(module.exports, "isArgumentElement", function () { return $acfad52ad3d60366$export$4f55724281bdfaf9; });
$parcel$export(module.exports, "isNumberElement", function () { return $acfad52ad3d60366$export$e11187b219e191e1; });
$parcel$export(module.exports, "isDateElement", function () { return $acfad52ad3d60366$export$32d811605da75f40; });
$parcel$export(module.exports, "isTimeElement", function () { return $acfad52ad3d60366$export$34ec46f596b1702f; });
$parcel$export(module.exports, "isSelectElement", function () { return $acfad52ad3d60366$export$dcfe1c11d168b5a1; });
$parcel$export(module.exports, "isPluralElement", function () { return $acfad52ad3d60366$export$6c796d116f0a4fbc; });
$parcel$export(module.exports, "isPoundElement", function () { return $acfad52ad3d60366$export$c0ece297bdd0c082; });
$parcel$export(module.exports, "isTagElement", function () { return $acfad52ad3d60366$export$5c83de34745812b; });
$parcel$export(module.exports, "isNumberSkeleton", function () { return $acfad52ad3d60366$export$3f9a19cd4152eda3; });
$parcel$export(module.exports, "isDateTimeSkeleton", function () { return $acfad52ad3d60366$export$7680c41f1a55f4cf; });
var $acfad52ad3d60366$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($acfad52ad3d60366$export$b87f371cbc396fcf || ($acfad52ad3d60366$export$b87f371cbc396fcf = {}));
var $acfad52ad3d60366$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($acfad52ad3d60366$export$906452485466fa53 || ($acfad52ad3d60366$export$906452485466fa53 = {}));
function $acfad52ad3d60366$export$cfa10c5697238752(el) {
    return el.type === $acfad52ad3d60366$export$b87f371cbc396fcf.literal;
}
function $acfad52ad3d60366$export$4f55724281bdfaf9(el) {
    return el.type === $acfad52ad3d60366$export$b87f371cbc396fcf.argument;
}
function $acfad52ad3d60366$export$e11187b219e191e1(el) {
    return el.type === $acfad52ad3d60366$export$b87f371cbc396fcf.number;
}
function $acfad52ad3d60366$export$32d811605da75f40(el) {
    return el.type === $acfad52ad3d60366$export$b87f371cbc396fcf.date;
}
function $acfad52ad3d60366$export$34ec46f596b1702f(el) {
    return el.type === $acfad52ad3d60366$export$b87f371cbc396fcf.time;
}
function $acfad52ad3d60366$export$dcfe1c11d168b5a1(el) {
    return el.type === $acfad52ad3d60366$export$b87f371cbc396fcf.select;
}
function $acfad52ad3d60366$export$6c796d116f0a4fbc(el) {
    return el.type === $acfad52ad3d60366$export$b87f371cbc396fcf.plural;
}
function $acfad52ad3d60366$export$c0ece297bdd0c082(el) {
    return el.type === $acfad52ad3d60366$export$b87f371cbc396fcf.pound;
}
function $acfad52ad3d60366$export$5c83de34745812b(el) {
    return el.type === $acfad52ad3d60366$export$b87f371cbc396fcf.tag;
}
function $acfad52ad3d60366$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === "object" && el.type === $acfad52ad3d60366$export$906452485466fa53.number);
}
function $acfad52ad3d60366$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === "object" && el.type === $acfad52ad3d60366$export$906452485466fa53.dateTime);
}
function $acfad52ad3d60366$export$f0ac572c1121c662(value) {
    return {
        type: $acfad52ad3d60366$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $acfad52ad3d60366$export$425e864b0ba114f1(value, style) {
    return {
        type: $acfad52ad3d60366$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}

});

parcelRegister("i9bgs", function(module, exports) {

$parcel$export(module.exports, "SPACE_SEPARATOR_REGEX", function () { return $d361ce28387e5f6e$export$523451f94304dd6c; });
// @generated from regex-gen.ts
var $d361ce28387e5f6e$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $d361ce28387e5f6e$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

});

parcelRegister("gn66P", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", function () { return (parcelRequire("e0ibg")).parseDateTimeSkeleton; });
$parcel$export(module.exports, "parseNumberSkeleton", function () { return (parcelRequire("3CoNK")).parseNumberSkeleton; });
$parcel$export(module.exports, "parseNumberSkeletonFromString", function () { return (parcelRequire("3CoNK")).parseNumberSkeletonFromString; });
parcelRequire("e0ibg");
parcelRequire("3CoNK");

});
parcelRegister("e0ibg", function(module, exports) {

$parcel$export(module.exports, "parseDateTimeSkeleton", function () { return $a31f2b0fe7a22cb6$export$f7b99fb377fe69fa; });
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $a31f2b0fe7a22cb6$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $a31f2b0fe7a22cb6$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($a31f2b0fe7a22cb6$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case "G":
                result.era = len === 4 ? "long" : len === 5 ? "narrow" : "short";
                break;
            // Year
            case "y":
                result.year = len === 2 ? "2-digit" : "numeric";
                break;
            case "Y":
            case "u":
            case "U":
            case "r":
                throw new RangeError("`Y/u/U/r` (year) patterns are not supported, use `y` instead");
            // Quarter
            case "q":
            case "Q":
                throw new RangeError("`q/Q` (quarter) patterns are not supported");
            // Month
            case "M":
            case "L":
                result.month = [
                    "numeric",
                    "2-digit",
                    "short",
                    "long",
                    "narrow"
                ][len - 1];
                break;
            // Week
            case "w":
            case "W":
                throw new RangeError("`w/W` (week) patterns are not supported");
            case "d":
                result.day = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "D":
            case "F":
            case "g":
                throw new RangeError("`D/F/g` (day) patterns are not supported, use `d` instead");
            // Weekday
            case "E":
                result.weekday = len === 4 ? "short" : len === 5 ? "narrow" : "short";
                break;
            case "e":
                if (len < 4) throw new RangeError("`e..eee` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 4];
                break;
            case "c":
                if (len < 4) throw new RangeError("`c..ccc` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 4];
                break;
            // Period
            case "a":
                result.hour12 = true;
                break;
            case "b":
            case "B":
                throw new RangeError("`b/B` (period) patterns are not supported, use `a` instead");
            // Hour
            case "h":
                result.hourCycle = "h12";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "H":
                result.hourCycle = "h23";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "K":
                result.hourCycle = "h11";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "k":
                result.hourCycle = "h24";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "j":
            case "J":
            case "C":
                throw new RangeError("`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead");
            // Minute
            case "m":
                result.minute = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            // Second
            case "s":
                result.second = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "S":
            case "A":
                throw new RangeError("`S/A` (second) patterns are not supported, use `s` instead");
            // Zone
            case "z":
                result.timeZoneName = len < 4 ? "short" : "long";
                break;
            case "Z":
            case "O":
            case "v":
            case "V":
            case "X":
            case "x":
                throw new RangeError("`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead");
        }
        return "";
    });
    return result;
}

});

parcelRegister("3CoNK", function(module, exports) {

$parcel$export(module.exports, "parseNumberSkeletonFromString", function () { return $2a2828b99ea8852e$export$71cee2f16fba2480; });
$parcel$export(module.exports, "parseNumberSkeleton", function () { return $2a2828b99ea8852e$export$47c6f8480bda3e11; });

var $l29cN = parcelRequire("l29cN");

var $bkfvY = parcelRequire("bkfvY");
function $2a2828b99ea8852e$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error("Number skeleton cannot be empty");
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $bkfvY.WHITE_SPACE_REGEX)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split("/");
        if (stemAndOptions.length === 0) throw new Error("Invalid number skeleton");
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error("Invalid number skeleton");
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $2a2828b99ea8852e$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, "");
}
var $2a2828b99ea8852e$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $2a2828b99ea8852e$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $2a2828b99ea8852e$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $2a2828b99ea8852e$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $2a2828b99ea8852e$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === "r") result.roundingPriority = "morePrecision";
    else if (str[str.length - 1] === "s") result.roundingPriority = "lessPrecision";
    str.replace($2a2828b99ea8852e$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== "string") {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === "+") result.minimumSignificantDigits = g1.length;
        else if (g1[0] === "#") result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === "string" ? g2.length : 0);
        }
        return "";
    });
    return result;
}
function $2a2828b99ea8852e$var$parseSign(str) {
    switch(str){
        case "sign-auto":
            return {
                signDisplay: "auto"
            };
        case "sign-accounting":
        case "()":
            return {
                currencySign: "accounting"
            };
        case "sign-always":
        case "+!":
            return {
                signDisplay: "always"
            };
        case "sign-accounting-always":
        case "()!":
            return {
                signDisplay: "always",
                currencySign: "accounting"
            };
        case "sign-except-zero":
        case "+?":
            return {
                signDisplay: "exceptZero"
            };
        case "sign-accounting-except-zero":
        case "()?":
            return {
                signDisplay: "exceptZero",
                currencySign: "accounting"
            };
        case "sign-never":
        case "+_":
            return {
                signDisplay: "never"
            };
    }
}
function $2a2828b99ea8852e$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === "E" && stem[1] === "E") {
        result = {
            notation: "engineering"
        };
        stem = stem.slice(2);
    } else if (stem[0] === "E") {
        result = {
            notation: "scientific"
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === "+!") {
            result.signDisplay = "always";
            stem = stem.slice(2);
        } else if (signDisplay === "+?") {
            result.signDisplay = "exceptZero";
            stem = stem.slice(2);
        }
        if (!$2a2828b99ea8852e$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error("Malformed concise eng/scientific notation");
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $2a2828b99ea8852e$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $2a2828b99ea8852e$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $2a2828b99ea8852e$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case "percent":
            case "%":
                result.style = "percent";
                continue;
            case "%x100":
                result.style = "percent";
                result.scale = 100;
                continue;
            case "currency":
                result.style = "currency";
                result.currency = token.options[0];
                continue;
            case "group-off":
            case ",_":
                result.useGrouping = false;
                continue;
            case "precision-integer":
            case ".":
                result.maximumFractionDigits = 0;
                continue;
            case "measure-unit":
            case "unit":
                result.style = "unit";
                result.unit = $2a2828b99ea8852e$var$icuUnitToEcma(token.options[0]);
                continue;
            case "compact-short":
            case "K":
                result.notation = "compact";
                result.compactDisplay = "short";
                continue;
            case "compact-long":
            case "KK":
                result.notation = "compact";
                result.compactDisplay = "long";
                continue;
            case "scientific":
                result = (0, $l29cN.__assign)((0, $l29cN.__assign)((0, $l29cN.__assign)({}, result), {
                    notation: "scientific"
                }), token.options.reduce(function(all, opt) {
                    return (0, $l29cN.__assign)((0, $l29cN.__assign)({}, all), $2a2828b99ea8852e$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case "engineering":
                result = (0, $l29cN.__assign)((0, $l29cN.__assign)((0, $l29cN.__assign)({}, result), {
                    notation: "engineering"
                }), token.options.reduce(function(all, opt) {
                    return (0, $l29cN.__assign)((0, $l29cN.__assign)({}, all), $2a2828b99ea8852e$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case "notation-simple":
                result.notation = "standard";
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case "unit-width-narrow":
                result.currencyDisplay = "narrowSymbol";
                result.unitDisplay = "narrow";
                continue;
            case "unit-width-short":
                result.currencyDisplay = "code";
                result.unitDisplay = "short";
                continue;
            case "unit-width-full-name":
                result.currencyDisplay = "name";
                result.unitDisplay = "long";
                continue;
            case "unit-width-iso-code":
                result.currencyDisplay = "symbol";
                continue;
            case "scale":
                result.scale = parseFloat(token.options[0]);
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case "integer-width":
                if (token.options.length > 1) throw new RangeError("integer-width stems only accept a single optional option");
                token.options[0].replace($2a2828b99ea8852e$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error("We currently do not support maximum integer digits");
                    else if (g5) throw new Error("We currently do not support exact integer digits");
                    return "";
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($2a2828b99ea8852e$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($2a2828b99ea8852e$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError("Fraction-precision stems only accept a single optional option");
            token.stem.replace($2a2828b99ea8852e$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === "*") result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === "#") result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return "";
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === "w") result = (0, $l29cN.__assign)((0, $l29cN.__assign)({}, result), {
                trailingZeroDisplay: "stripIfInteger"
            });
            else if (opt) result = (0, $l29cN.__assign)((0, $l29cN.__assign)({}, result), $2a2828b99ea8852e$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($2a2828b99ea8852e$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $l29cN.__assign)((0, $l29cN.__assign)({}, result), $2a2828b99ea8852e$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $2a2828b99ea8852e$var$parseSign(token.stem);
        if (signOpts) result = (0, $l29cN.__assign)((0, $l29cN.__assign)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $2a2828b99ea8852e$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $l29cN.__assign)((0, $l29cN.__assign)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}

});
parcelRegister("bkfvY", function(module, exports) {

$parcel$export(module.exports, "WHITE_SPACE_REGEX", function () { return $83ed98e0a4c229f3$export$2b8db14d8bcaece7; });
// @generated from regex-gen.ts
var $83ed98e0a4c229f3$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

});



parcelRegister("iYRjX", function(module, exports) {

$parcel$export(module.exports, "getBestPattern", function () { return $dd173104f688301b$export$29c5368be8904d27; });

var $edrF5 = parcelRequire("edrF5");
function $dd173104f688301b$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = "";
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === "j") {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = "a";
            var hourChar = $dd173104f688301b$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == "H" || hourChar == "k") dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === "J") skeletonCopy += "H";
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $dd173104f688301b$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case "h24":
            return "k";
        case "h23":
            return "H";
        case "h12":
            return "h";
        case "h11":
            return "K";
        default:
            throw new Error("Invalid hourCycle");
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== "root") regionTag = locale.maximize().region;
    var hourCycles = (0, $edrF5.timeData)[regionTag || ""] || (0, $edrF5.timeData)[languageTag || ""] || (0, $edrF5.timeData)["".concat(languageTag, "-001")] || (0, $edrF5.timeData)["001"];
    return hourCycles[0];
}

});
parcelRegister("edrF5", function(module, exports) {

$parcel$export(module.exports, "timeData", function () { return $02abbcd93f2a9d82$export$a8c9209db4084317; });
// @generated from time-data-gen.ts
// prettier-ignore  
var $02abbcd93f2a9d82$export$a8c9209db4084317 = {
    "001": [
        "H",
        "h"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "AS": [
        "h",
        "H"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "AX": [
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BI": [
        "H",
        "h"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "BO": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "BQ": [
        "H"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BT": [
        "h",
        "H"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BY": [
        "H",
        "h"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CL": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CP": [
        "H"
    ],
    "CR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CU": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "CW": [
        "H",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CZ": [
        "H"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "DK": [
        "H"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EC": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "FI": [
        "H"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FO": [
        "H",
        "h"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GH": [
        "h",
        "H"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GL": [
        "H",
        "h"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GT": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HN": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "HU": [
        "H",
        "h"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ID": [
        "H"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IN": [
        "h",
        "H"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "IS": [
        "H"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JP": [
        "H",
        "K",
        "h"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LS": [
        "h",
        "H"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MG": [
        "H",
        "h"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ML": [
        "H"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MT": [
        "H",
        "h"
    ],
    "MU": [
        "H",
        "h"
    ],
    "MV": [
        "H",
        "h"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MX": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NE": [
        "H"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NI": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "NO": [
        "H",
        "h"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PE": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "PL": [
        "H",
        "h"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "PW": [
        "h",
        "H"
    ],
    "PY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "RU": [
        "H"
    ],
    "RW": [
        "H",
        "h"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SE": [
        "H"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "SO": [
        "h",
        "H"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "SV": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TH": [
        "H",
        "h"
    ],
    "TJ": [
        "H",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TM": [
        "H",
        "h"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VN": [
        "H",
        "h"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "WS": [
        "h",
        "H"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZW": [
        "H",
        "h"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "es-BO": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-EC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-PE": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ]
};

});




parcelRegister("gEYt7", function(module, exports) {

$parcel$export(module.exports, "memoize", function () { return $c20f4998f1103d11$export$fc10aeed3a532e2a; });
$parcel$export(module.exports, "strategies", function () { return $c20f4998f1103d11$export$c5491a8691a23b9e; });
//
// Main
//
function $c20f4998f1103d11$export$fc10aeed3a532e2a(fn, options) {
    var cache = options && options.cache ? options.cache : $c20f4998f1103d11$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $c20f4998f1103d11$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $c20f4998f1103d11$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $c20f4998f1103d11$var$isPrimitive(value) {
    return value == null || typeof value === "number" || typeof value === "boolean"; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $c20f4998f1103d11$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $c20f4998f1103d11$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === "undefined") {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $c20f4998f1103d11$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === "undefined") {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $c20f4998f1103d11$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $c20f4998f1103d11$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $c20f4998f1103d11$var$monadic : $c20f4998f1103d11$var$variadic;
    return $c20f4998f1103d11$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $c20f4998f1103d11$var$strategyVariadic(fn, options) {
    return $c20f4998f1103d11$var$assemble(fn, this, $c20f4998f1103d11$var$variadic, options.cache.create(), options.serializer);
}
function $c20f4998f1103d11$var$strategyMonadic(fn, options) {
    return $c20f4998f1103d11$var$assemble(fn, this, $c20f4998f1103d11$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $c20f4998f1103d11$var$serializerDefault = function serializerDefault() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function $c20f4998f1103d11$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$c20f4998f1103d11$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$c20f4998f1103d11$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $c20f4998f1103d11$var$cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new $c20f4998f1103d11$var$ObjectWithoutPrototypeCache();
    }
};
var $c20f4998f1103d11$export$c5491a8691a23b9e = {
    variadic: $c20f4998f1103d11$var$strategyVariadic,
    monadic: $c20f4998f1103d11$var$strategyMonadic
};

});

parcelRegister("k7OPo", function(module, exports) {

$parcel$export(module.exports, "PART_TYPE", function () { return $ea6be3780af344b7$export$49694c2877b44c57; });
$parcel$export(module.exports, "isFormatXMLElementFn", function () { return $ea6be3780af344b7$export$df0c12a2d414a163; });
$parcel$export(module.exports, "formatToParts", function () { return $ea6be3780af344b7$export$275d4a3bb5f66fda; });
parcelRequire("7Whee");
var $eQLAg = parcelRequire("eQLAg");

var $k44HP = parcelRequire("k44HP");
var $ea6be3780af344b7$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($ea6be3780af344b7$export$49694c2877b44c57 || ($ea6be3780af344b7$export$49694c2877b44c57 = {}));
function $ea6be3780af344b7$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $ea6be3780af344b7$export$49694c2877b44c57.literal || part.type !== $ea6be3780af344b7$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $ea6be3780af344b7$export$df0c12a2d414a163(el) {
    return typeof el === "function";
}
function $ea6be3780af344b7$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $eQLAg.isLiteralElement)(els[0])) return [
        {
            type: $ea6be3780af344b7$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $eQLAg.isLiteralElement)(el)) {
            result.push({
                type: $ea6be3780af344b7$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $eQLAg.isPoundElement)(el)) {
            if (typeof currentPluralValue === "number") result.push({
                type: $ea6be3780af344b7$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $k44HP.MissingValueError)(varName, originalMessage);
        var value = values[varName];
        if ((0, $eQLAg.isArgumentElement)(el)) {
            if (!value || typeof value === "string" || typeof value === "number") value = typeof value === "string" || typeof value === "number" ? String(value) : "";
            result.push({
                type: typeof value === "string" ? $ea6be3780af344b7$export$49694c2877b44c57.literal : $ea6be3780af344b7$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $eQLAg.isDateElement)(el)) {
            var style = typeof el.style === "string" ? formats.date[el.style] : (0, $eQLAg.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $ea6be3780af344b7$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $eQLAg.isTimeElement)(el)) {
            var style = typeof el.style === "string" ? formats.time[el.style] : (0, $eQLAg.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $ea6be3780af344b7$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $eQLAg.isNumberElement)(el)) {
            var style = typeof el.style === "string" ? formats.number[el.style] : (0, $eQLAg.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $ea6be3780af344b7$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $eQLAg.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$ea6be3780af344b7$export$df0c12a2d414a163(formatFn)) throw new (0, $k44HP.InvalidValueTypeError)(value_1, "function", originalMessage);
            var parts = $ea6be3780af344b7$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === "string" ? $ea6be3780af344b7$export$49694c2877b44c57.literal : $ea6be3780af344b7$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $eQLAg.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $k44HP.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $ea6be3780af344b7$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $eQLAg.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $k44HP.FormatError)('Intl.PluralRules is not available in this environment.\nTry polyfilling it using "@formatjs/intl-pluralrules"\n', (0, $k44HP.ErrorCode).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $k44HP.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $ea6be3780af344b7$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $ea6be3780af344b7$var$mergeLiteral(result);
}

});
parcelRegister("k44HP", function(module, exports) {

$parcel$export(module.exports, "ErrorCode", function () { return $e9b7d4d846e82f78$export$d4e71bc0b80dc0fb; });
$parcel$export(module.exports, "FormatError", function () { return $e9b7d4d846e82f78$export$7369836851cc1329; });
$parcel$export(module.exports, "InvalidValueError", function () { return $e9b7d4d846e82f78$export$565c3afc07dfa382; });
$parcel$export(module.exports, "InvalidValueTypeError", function () { return $e9b7d4d846e82f78$export$cbc0db47c750f7c9; });
$parcel$export(module.exports, "MissingValueError", function () { return $e9b7d4d846e82f78$export$8bfc137e4d23fdf0; });

var $l29cN = parcelRequire("l29cN");
var $e9b7d4d846e82f78$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($e9b7d4d846e82f78$export$d4e71bc0b80dc0fb || ($e9b7d4d846e82f78$export$d4e71bc0b80dc0fb = {}));
var $e9b7d4d846e82f78$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $l29cN.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $e9b7d4d846e82f78$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $l29cN.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, 'Invalid values for "'.concat(variableId, '": "').concat(value, '". Options are "').concat(Object.keys(options).join('", "'), '"'), $e9b7d4d846e82f78$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($e9b7d4d846e82f78$export$7369836851cc1329);
var $e9b7d4d846e82f78$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $l29cN.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, 'Value for "'.concat(value, '" must be of type ').concat(type), $e9b7d4d846e82f78$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($e9b7d4d846e82f78$export$7369836851cc1329);
var $e9b7d4d846e82f78$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $l29cN.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, 'The intl string context variable "'.concat(variableId, '" was not provided to the string "').concat(originalMessage, '"'), $e9b7d4d846e82f78$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($e9b7d4d846e82f78$export$7369836851cc1329);

});



parcelRegister("9r3qJ", function(module, exports) {

$parcel$export(module.exports, "UnsupportedFormatterError", function () { return $6de94bd67a3ef4a0$export$549f97e137a05c90; });
$parcel$export(module.exports, "InvalidConfigError", function () { return $6de94bd67a3ef4a0$export$3ca04dd7fb305893; });
$parcel$export(module.exports, "MissingDataError", function () { return $6de94bd67a3ef4a0$export$c1eaf877d81384b6; });
$parcel$export(module.exports, "IntlFormatError", function () { return $6de94bd67a3ef4a0$export$e3b7eee1dbc44895; });
$parcel$export(module.exports, "MessageFormatError", function () { return $6de94bd67a3ef4a0$export$74a601a3d3f31621; });
$parcel$export(module.exports, "MissingTranslationError", function () { return $6de94bd67a3ef4a0$export$2ddcb436d0aa3688; });

var $l29cN = parcelRequire("l29cN");
var $6de94bd67a3ef4a0$export$557d6acb76e8a244;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})($6de94bd67a3ef4a0$export$557d6acb76e8a244 || ($6de94bd67a3ef4a0$export$557d6acb76e8a244 = {}));
var $6de94bd67a3ef4a0$export$c016d36112f6ddf8 = /** @class */ function(_super) {
    (0, $l29cN.__extends)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, "\n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : "")) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === "function") // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
var $6de94bd67a3ef4a0$export$549f97e137a05c90 = /** @class */ function(_super) {
    (0, $l29cN.__extends)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, $6de94bd67a3ef4a0$export$557d6acb76e8a244.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}($6de94bd67a3ef4a0$export$c016d36112f6ddf8);
var $6de94bd67a3ef4a0$export$3ca04dd7fb305893 = /** @class */ function(_super) {
    (0, $l29cN.__extends)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, $6de94bd67a3ef4a0$export$557d6acb76e8a244.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}($6de94bd67a3ef4a0$export$c016d36112f6ddf8);
var $6de94bd67a3ef4a0$export$c1eaf877d81384b6 = /** @class */ function(_super) {
    (0, $l29cN.__extends)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, $6de94bd67a3ef4a0$export$557d6acb76e8a244.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}($6de94bd67a3ef4a0$export$c016d36112f6ddf8);
var $6de94bd67a3ef4a0$export$e3b7eee1dbc44895 = /** @class */ function(_super) {
    (0, $l29cN.__extends)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        var _this = _super.call(this, $6de94bd67a3ef4a0$export$557d6acb76e8a244.FORMAT_ERROR, "".concat(message, "\nLocale: ").concat(locale, "\n"), exception) || this;
        _this.locale = locale;
        return _this;
    }
    return IntlFormatError;
}($6de94bd67a3ef4a0$export$c016d36112f6ddf8);
var $6de94bd67a3ef4a0$export$74a601a3d3f31621 = /** @class */ function(_super) {
    (0, $l29cN.__extends)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, "\nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, "\n"), locale, exception) || this;
        _this.descriptor = descriptor;
        _this.locale = locale;
        return _this;
    }
    return MessageFormatError;
}($6de94bd67a3ef4a0$export$e3b7eee1dbc44895);
var $6de94bd67a3ef4a0$export$2ddcb436d0aa3688 = /** @class */ function(_super) {
    (0, $l29cN.__extends)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, $6de94bd67a3ef4a0$export$557d6acb76e8a244.MISSING_TRANSLATION, 'Missing message: "'.concat(descriptor.id, '" for locale "').concat(locale, '", using ').concat(descriptor.defaultMessage ? "default message (".concat(typeof descriptor.defaultMessage === "string" ? descriptor.defaultMessage : descriptor.defaultMessage.map(function(e) {
            var _a;
            return (_a = e.value) !== null && _a !== void 0 ? _a : JSON.stringify(e);
        }).join(), ")") : "id", " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}($6de94bd67a3ef4a0$export$c016d36112f6ddf8);

});




parcelRegister("bk3D8", function(module, exports) {

$parcel$export(module.exports, "createIntl", function () { return $83e460df03e945b0$export$7e4cbedfdd7b4c0d; });

var $l29cN = parcelRequire("l29cN");

var $ehiPA = parcelRequire("ehiPA");

var $9r3qJ = parcelRequire("9r3qJ");

var $bJlGx = parcelRequire("bJlGx");

var $AjdJk = parcelRequire("AjdJk");

var $e9zhZ = parcelRequire("e9zhZ");

var $3KEhk = parcelRequire("3KEhk");

var $hF6zg = parcelRequire("hF6zg");

var $8qdyo = parcelRequire("8qdyo");

var $blzCK = parcelRequire("blzCK");
function $83e460df03e945b0$var$messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === "string";
}
function $83e460df03e945b0$var$verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && $83e460df03e945b0$var$messagesContainString(config.messages || {})) config.onWarn('[@formatjs/intl] "defaultRichTextElements" was specified but "message" was not pre-compiled. \nPlease consider using "@formatjs/cli" to pre-compile your messages for performance.\nFor more details see https://formatjs.io/docs/getting-started/message-distribution');
}
function $83e460df03e945b0$export$7e4cbedfdd7b4c0d(config, cache) {
    var formatters = (0, $ehiPA.createFormatters)(cache);
    var resolvedConfig = (0, $l29cN.__assign)((0, $l29cN.__assign)({}, (0, $ehiPA.DEFAULT_INTL_CONFIG)), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) onError(new (0, $9r3qJ.InvalidConfigError)('"locale" was not configured, using "'.concat(defaultLocale, '" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details')));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || "en";
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $9r3qJ.MissingDataError)('Missing locale data for locale: "'.concat(locale, '" in Intl.NumberFormat. Using default locale: "').concat(defaultLocale, '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details')));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $9r3qJ.MissingDataError)('Missing locale data for locale: "'.concat(locale, '" in Intl.DateTimeFormat. Using default locale: "').concat(defaultLocale, '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details')));
    $83e460df03e945b0$var$verifyConfigMessages(resolvedConfig);
    return (0, $l29cN.__assign)((0, $l29cN.__assign)({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: (0, $bJlGx.formatNumber).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: (0, $bJlGx.formatNumberToParts).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: (0, $AjdJk.formatRelativeTime).bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: (0, $e9zhZ.formatDate).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: (0, $e9zhZ.formatDateToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: (0, $e9zhZ.formatTime).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: (0, $e9zhZ.formatDateTimeRange).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: (0, $e9zhZ.formatTimeToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: (0, $3KEhk.formatPlural).bind(null, resolvedConfig, formatters.getPluralRules),
        // @ts-expect-error TODO: will get to this later
        formatMessage: (0, $hF6zg.formatMessage).bind(null, resolvedConfig, formatters),
        // @ts-expect-error TODO: will get to this later
        $t: (0, $hF6zg.formatMessage).bind(null, resolvedConfig, formatters),
        formatList: (0, $8qdyo.formatList).bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: (0, $8qdyo.formatListToParts).bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: (0, $blzCK.formatDisplayName).bind(null, resolvedConfig, formatters.getDisplayNames)
    });
}

});
parcelRegister("bJlGx", function(module, exports) {

$parcel$export(module.exports, "formatNumber", function () { return $88a4b7e0c5554a72$export$f5dd818bff069720; });
$parcel$export(module.exports, "formatNumberToParts", function () { return $88a4b7e0c5554a72$export$6871080848f10b2f; });

var $ehiPA = parcelRequire("ehiPA");

var $9r3qJ = parcelRequire("9r3qJ");
var $88a4b7e0c5554a72$var$NUMBER_FORMAT_OPTIONS = [
    "style",
    "currency",
    "currencyDisplay",
    "unit",
    "unitDisplay",
    "useGrouping",
    "minimumIntegerDigits",
    "minimumFractionDigits",
    "maximumFractionDigits",
    "minimumSignificantDigits",
    "maximumSignificantDigits",
    // ES2020 NumberFormat
    "compactDisplay",
    "currencyDisplay",
    "currencySign",
    "notation",
    "signDisplay",
    "unit",
    "unitDisplay",
    "numberingSystem"
];
function $88a4b7e0c5554a72$export$a7f9565e3c81cd54(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = format && (0, $ehiPA.getNamedFormat)(formats, "number", format, onError) || {};
    var filteredOptions = (0, $ehiPA.filterProps)(options, $88a4b7e0c5554a72$var$NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function $88a4b7e0c5554a72$export$f5dd818bff069720(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $88a4b7e0c5554a72$export$a7f9565e3c81cd54(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new (0, $9r3qJ.IntlFormatError)("Error formatting number.", config.locale, e));
    }
    return String(value);
}
function $88a4b7e0c5554a72$export$6871080848f10b2f(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $88a4b7e0c5554a72$export$a7f9565e3c81cd54(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new (0, $9r3qJ.IntlFormatError)("Error formatting number.", config.locale, e));
    }
    return [];
}

});

parcelRegister("AjdJk", function(module, exports) {

$parcel$export(module.exports, "formatRelativeTime", function () { return $06d245b07a2a1fce$export$b4ea3b48dcf921f6; });

var $ehiPA = parcelRequire("ehiPA");

var $k44HP = parcelRequire("k44HP");

var $9r3qJ = parcelRequire("9r3qJ");
var $06d245b07a2a1fce$var$RELATIVE_TIME_FORMAT_OPTIONS = [
    "numeric",
    "style"
];
function $06d245b07a2a1fce$var$getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = !!format && (0, $ehiPA.getNamedFormat)(formats, "relative", format, onError) || {};
    var filteredOptions = (0, $ehiPA.filterProps)(options, $06d245b07a2a1fce$var$RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function $06d245b07a2a1fce$export$b4ea3b48dcf921f6(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) options = {};
    if (!unit) unit = "second";
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new (0, $k44HP.FormatError)('Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using "@formatjs/intl-relativetimeformat"\n', (0, $k44HP.ErrorCode).MISSING_INTL_API));
    try {
        return $06d245b07a2a1fce$var$getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new (0, $9r3qJ.IntlFormatError)("Error formatting relative time.", config.locale, e));
    }
    return String(value);
}

});

parcelRegister("e9zhZ", function(module, exports) {

$parcel$export(module.exports, "formatDate", function () { return $a4dd47a700c02d12$export$3ae94a2503e890a1; });
$parcel$export(module.exports, "formatTime", function () { return $a4dd47a700c02d12$export$3203edd9e5edd663; });
$parcel$export(module.exports, "formatDateTimeRange", function () { return $a4dd47a700c02d12$export$a7fc3a91cb2ec376; });
$parcel$export(module.exports, "formatDateToParts", function () { return $a4dd47a700c02d12$export$dc1f059bce486b1; });
$parcel$export(module.exports, "formatTimeToParts", function () { return $a4dd47a700c02d12$export$af6e5d7a5c73edeb; });

var $l29cN = parcelRequire("l29cN");

var $ehiPA = parcelRequire("ehiPA");

var $9r3qJ = parcelRequire("9r3qJ");
var $a4dd47a700c02d12$var$DATE_TIME_FORMAT_OPTIONS = [
    "formatMatcher",
    "timeZone",
    "hour12",
    "weekday",
    "era",
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "timeZoneName",
    "hourCycle",
    "dateStyle",
    "timeStyle",
    "calendar",
    // 'dayPeriod',
    "numberingSystem",
    "fractionalSecondDigits"
];
function $a4dd47a700c02d12$export$a7f9565e3c81cd54(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = (0, $l29cN.__assign)((0, $l29cN.__assign)({}, timeZone && {
        timeZone: timeZone
    }), format && (0, $ehiPA.getNamedFormat)(formats, type, format, onError));
    var filteredOptions = (0, $ehiPA.filterProps)(options, $a4dd47a700c02d12$var$DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === "time" && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = (0, $l29cN.__assign)((0, $l29cN.__assign)({}, filteredOptions), {
        hour: "numeric",
        minute: "numeric"
    });
    return getDateTimeFormat(locale, filteredOptions);
}
function $a4dd47a700c02d12$export$3ae94a2503e890a1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $a4dd47a700c02d12$export$a7f9565e3c81cd54(config, "date", getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $9r3qJ.IntlFormatError)("Error formatting date.", config.locale, e));
    }
    return String(date);
}
function $a4dd47a700c02d12$export$3203edd9e5edd663(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $a4dd47a700c02d12$export$a7f9565e3c81cd54(config, "time", getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $9r3qJ.IntlFormatError)("Error formatting time.", config.locale, e));
    }
    return String(date);
}
function $a4dd47a700c02d12$export$a7fc3a91cb2ec376(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var timeZone = config.timeZone, locale = config.locale, onError = config.onError;
    var filteredOptions = (0, $ehiPA.filterProps)(options, $a4dd47a700c02d12$var$DATE_TIME_FORMAT_OPTIONS, timeZone ? {
        timeZone: timeZone
    } : {});
    try {
        return getDateTimeFormat(locale, filteredOptions).formatRange(from, to);
    } catch (e) {
        onError(new (0, $9r3qJ.IntlFormatError)("Error formatting date time range.", config.locale, e));
    }
    return String(from);
}
function $a4dd47a700c02d12$export$dc1f059bce486b1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $a4dd47a700c02d12$export$a7f9565e3c81cd54(config, "date", getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $9r3qJ.IntlFormatError)("Error formatting date.", config.locale, e));
    }
    return [];
}
function $a4dd47a700c02d12$export$af6e5d7a5c73edeb(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $a4dd47a700c02d12$export$a7f9565e3c81cd54(config, "time", getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $9r3qJ.IntlFormatError)("Error formatting time.", config.locale, e));
    }
    return [];
}

});

parcelRegister("3KEhk", function(module, exports) {

$parcel$export(module.exports, "formatPlural", function () { return $2bb4e977c29709a6$export$bbbd05c900f3568d; });

var $ehiPA = parcelRequire("ehiPA");

var $9r3qJ = parcelRequire("9r3qJ");

var $k44HP = parcelRequire("k44HP");
var $2bb4e977c29709a6$var$PLURAL_FORMAT_OPTIONS = [
    "type"
];
function $2bb4e977c29709a6$export$bbbd05c900f3568d(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    if (!Intl.PluralRules) onError(new (0, $k44HP.FormatError)('Intl.PluralRules is not available in this environment.\nTry polyfilling it using "@formatjs/intl-pluralrules"\n', (0, $k44HP.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $ehiPA.filterProps)(options, $2bb4e977c29709a6$var$PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new (0, $9r3qJ.IntlFormatError)("Error formatting plural.", locale, e));
    }
    return "other";
}

});

parcelRegister("hF6zg", function(module, exports) {

$parcel$export(module.exports, "formatMessage", function () { return $cdbb5c34ef99f23d$export$25868d1e8e76735f; });

var $l29cN = parcelRequire("l29cN");

var $8lCTf = parcelRequire("8lCTf");

var $05hJw = parcelRequire("05hJw");

var $9r3qJ = parcelRequire("9r3qJ");
parcelRequire("7Whee");
var $eQLAg = parcelRequire("eQLAg");
function $cdbb5c34ef99f23d$var$setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function(all, k) {
        all[k] = (0, $l29cN.__assign)({
            timeZone: timeZone
        }, opts[k]);
        return all;
    }, {});
}
function $cdbb5c34ef99f23d$var$deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0, $l29cN.__assign)((0, $l29cN.__assign)({}, opts1), opts2));
    return keys.reduce(function(all, k) {
        all[k] = (0, $l29cN.__assign)((0, $l29cN.__assign)({}, opts1[k] || {}), opts2[k] || {});
        return all;
    }, {});
}
function $cdbb5c34ef99f23d$var$deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    var mfFormats = (0, $05hJw.IntlMessageFormat).formats;
    return (0, $l29cN.__assign)((0, $l29cN.__assign)((0, $l29cN.__assign)({}, mfFormats), f1), {
        date: $cdbb5c34ef99f23d$var$deepMergeOptions($cdbb5c34ef99f23d$var$setTimeZoneInOptions(mfFormats.date, timeZone), $cdbb5c34ef99f23d$var$setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: $cdbb5c34ef99f23d$var$deepMergeOptions($cdbb5c34ef99f23d$var$setTimeZoneInOptions(mfFormats.time, timeZone), $cdbb5c34ef99f23d$var$setTimeZoneInOptions(f1.time || {}, timeZone))
    });
}
var $cdbb5c34ef99f23d$export$25868d1e8e76735f = function formatMessage(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) messageDescriptor = {
        id: ""
    };
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, $8lCTf.invariant)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === (0, $eQLAg.TYPE).literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === "string" && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    values = (0, $l29cN.__assign)((0, $l29cN.__assign)({}, defaultRichTextElements), values || {});
    formats = $cdbb5c34ef99f23d$var$deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = $cdbb5c34ef99f23d$var$deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === "") return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new (0, $9r3qJ.MissingTranslationError)(messageDescriptor, locale));
        if (defaultMessage) try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new (0, $9r3qJ.MessageFormatError)('Error formatting default message for: "'.concat(id, '", rendering default message verbatim'), locale, messageDescriptor, e));
            return typeof defaultMessage === "string" ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0, $l29cN.__assign)({
            formatters: state
        }, opts || {}));
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $9r3qJ.MessageFormatError)('Error formatting message: "'.concat(id, '", using ').concat(defaultMessage ? "default message" : "id", " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $9r3qJ.MessageFormatError)('Error formatting the default message for: "'.concat(id, '", rendering message verbatim'), locale, messageDescriptor, e));
    }
    if (typeof message === "string") return message;
    if (typeof defaultMessage === "string") return defaultMessage;
    return id;
};

});

parcelRegister("8qdyo", function(module, exports) {

$parcel$export(module.exports, "formatList", function () { return $621b43e79156ce10$export$e8b8be48b45905bb; });
$parcel$export(module.exports, "formatListToParts", function () { return $621b43e79156ce10$export$6f284aad1934db69; });

var $l29cN = parcelRequire("l29cN");

var $ehiPA = parcelRequire("ehiPA");

var $k44HP = parcelRequire("k44HP");

var $9r3qJ = parcelRequire("9r3qJ");
var $621b43e79156ce10$var$LIST_FORMAT_OPTIONS = [
    "type",
    "style"
];
var $621b43e79156ce10$var$now = Date.now();
function $621b43e79156ce10$var$generateToken(i) {
    return "".concat($621b43e79156ce10$var$now, "_").concat(i, "_").concat($621b43e79156ce10$var$now);
}
function $621b43e79156ce10$export$e8b8be48b45905bb(opts, getListFormat, values, options) {
    if (options === void 0) options = {};
    var results = $621b43e79156ce10$export$6f284aad1934db69(opts, getListFormat, values, options).reduce(function(all, el) {
        var val = el.value;
        if (typeof val !== "string") all.push(val);
        else if (typeof all[all.length - 1] === "string") all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results.length === 0 ? "" : results;
}
function $621b43e79156ce10$export$6f284aad1934db69(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new (0, $k44HP.FormatError)('Intl.ListFormat is not available in this environment.\nTry polyfilling it using "@formatjs/intl-listformat"\n', (0, $k44HP.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $ehiPA.filterProps)(options, $621b43e79156ce10$var$LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = values.map(function(v, i) {
            if (typeof v === "object") {
                var id = $621b43e79156ce10$var$generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map(function(part) {
            return part.type === "literal" ? part : (0, $l29cN.__assign)((0, $l29cN.__assign)({}, part), {
                value: richValues_1[part.value] || part.value
            });
        });
    } catch (e) {
        onError(new (0, $9r3qJ.IntlFormatError)("Error formatting list.", locale, e));
    }
    // @ts-ignore
    return values;
}

});

parcelRegister("blzCK", function(module, exports) {

$parcel$export(module.exports, "formatDisplayName", function () { return $842d4a1314ec53ea$export$62fe1a4d9e891fa2; });

var $ehiPA = parcelRequire("ehiPA");

var $k44HP = parcelRequire("k44HP");

var $9r3qJ = parcelRequire("9r3qJ");
var $842d4a1314ec53ea$var$DISPLAY_NAMES_OPTONS = [
    "style",
    "type",
    "fallback",
    "languageDisplay"
];
function $842d4a1314ec53ea$export$62fe1a4d9e891fa2(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new (0, $k44HP.FormatError)('Intl.DisplayNames is not available in this environment.\nTry polyfilling it using "@formatjs/intl-displaynames"\n', (0, $k44HP.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $ehiPA.filterProps)(options, $842d4a1314ec53ea$var$DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new (0, $9r3qJ.IntlFormatError)("Error formatting display name.", locale, e));
    }
}

});



parcelRegister("1gvUl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02d018439f4217d6$export$2e2bcd8739ae039; });
//@ts-ignore

var $1rY3h = parcelRequire("1rY3h");

var $1Mpn7 = parcelRequire("1Mpn7");

var $aYygp = parcelRequire("aYygp");

var $Ip8Id = parcelRequire("Ip8Id");
var $02d018439f4217d6$export$fe99df39f319f93e = function(param) {
    var children = param.children;
    (0, $1Mpn7.useEffect)(function() {
        (0, $Ip8Id.initAnalyticsWebClient)();
    }, []);
    return /*#__PURE__*/ (0, $1rY3h.jsx)((0, $aYygp.ContextualAnalyticsData), {
        children: children
    });
};
var $02d018439f4217d6$export$2e2bcd8739ae039 = $02d018439f4217d6$export$fe99df39f319f93e;

});
parcelRegister("aYygp", function(module, exports) {

$parcel$export(module.exports, "ContextualAnalyticsData", function () { return $1f78c8c3bafe83b5$export$198470770171c65; });
/**
 * This library is the only place where you'd use raw AnalyticsContext
 * It provides a typed wrapper around it for better user experience
 */ //@ts-ignore

var $do9pw = parcelRequire("do9pw");

var $dRLPW = parcelRequire("dRLPW");

var $1rY3h = parcelRequire("1rY3h");

var $1Mpn7 = parcelRequire("1Mpn7");

var $7kymc = parcelRequire("7kymc");

var $i7e74 = parcelRequire("i7e74");

var $h9UE0 = parcelRequire("h9UE0");
var $1f78c8c3bafe83b5$export$dc30f43798194b03 = function(props) {
    var children = props.children, sourceName = props.sourceName, sourceType = props.sourceType, rest = (0, $dRLPW._)(props, [
        "children",
        "sourceName",
        "sourceType"
    ]);
    var source = sourceName && sourceType ? "".concat(sourceName).concat(sourceType) : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($i7e74)))((0, $do9pw._)({
        source: source
    }, rest), (0, (/*@__PURE__*/$parcel$interopDefault($7kymc))));
};
var $1f78c8c3bafe83b5$export$198470770171c65 = /*#__PURE__*/ (0, $1Mpn7.memo)(function(props) {
    var data = $1f78c8c3bafe83b5$export$dc30f43798194b03(props);
    return /*#__PURE__*/ (0, $1rY3h.jsx)((0, $h9UE0.default), {
        data: data,
        children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $1rY3h.Fragment), {
            children: props.children
        })
    });
}); /* eslint-enable react/require-default-props */ 

});
parcelRegister("7kymc", function(module, exports) {
/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */ function $55650d41e6bba974$var$isUndefined(value) {
    return value === undefined;
}
module.exports = $55650d41e6bba974$var$isUndefined;

});

parcelRegister("i7e74", function(module, exports) {

var $g4NhP = parcelRequire("g4NhP");

var $7vMWR = parcelRequire("7vMWR");

var $4GpzK = parcelRequire("4GpzK");
/**
 * The opposite of `_.pickBy`; this method creates an object composed of
 * the own and inherited enumerable string keyed properties of `object` that
 * `predicate` doesn't return truthy for. The predicate is invoked with two
 * arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omitBy(object, _.isNumber);
 * // => { 'b': '2' }
 */ function $d303d3fb2e8b0718$var$omitBy(object, predicate) {
    return $4GpzK(object, $7vMWR($g4NhP(predicate)));
}
module.exports = $d303d3fb2e8b0718$var$omitBy;

});
parcelRegister("g4NhP", function(module, exports) {

var $64APv = parcelRequire("64APv");

var $7dQ3L = parcelRequire("7dQ3L");

var $l8JO9 = parcelRequire("l8JO9");

var $imhlU = parcelRequire("imhlU");

var $cuQU6 = parcelRequire("cuQU6");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $bb434056ed253141$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return $l8JO9;
    if (typeof value == "object") return $imhlU(value) ? $7dQ3L(value[0], value[1]) : $64APv(value);
    return $cuQU6(value);
}
module.exports = $bb434056ed253141$var$baseIteratee;

});
parcelRegister("64APv", function(module, exports) {

var $fSFIa = parcelRequire("fSFIa");

var $5Og7O = parcelRequire("5Og7O");

var $hTqPy = parcelRequire("hTqPy");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $46bfaf6d3905daf5$var$baseMatches(source) {
    var matchData = $5Og7O(source);
    if (matchData.length == 1 && matchData[0][2]) return $hTqPy(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $fSFIa(object, source, matchData);
    };
}
module.exports = $46bfaf6d3905daf5$var$baseMatches;

});
parcelRegister("fSFIa", function(module, exports) {

var $bmQRT = parcelRequire("bmQRT");

var $eKVfs = parcelRequire("eKVfs");
/** Used to compose bitmasks for value comparisons. */ var $b8fc412a61a67c67$var$COMPARE_PARTIAL_FLAG = 1, $b8fc412a61a67c67$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $b8fc412a61a67c67$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $bmQRT;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $eKVfs(srcValue, objValue, $b8fc412a61a67c67$var$COMPARE_PARTIAL_FLAG | $b8fc412a61a67c67$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = $b8fc412a61a67c67$var$baseIsMatch;

});
parcelRegister("bmQRT", function(module, exports) {

var $l3q3h = parcelRequire("l3q3h");

var $6vncU = parcelRequire("6vncU");

var $1Hvta = parcelRequire("1Hvta");

var $5Rsv7 = parcelRequire("5Rsv7");

var $MtEvJ = parcelRequire("MtEvJ");

var $2AFRx = parcelRequire("2AFRx");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $846ac256d1b7ff52$var$Stack(entries) {
    var data = this.__data__ = new $l3q3h(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$846ac256d1b7ff52$var$Stack.prototype.clear = $6vncU;
$846ac256d1b7ff52$var$Stack.prototype["delete"] = $1Hvta;
$846ac256d1b7ff52$var$Stack.prototype.get = $5Rsv7;
$846ac256d1b7ff52$var$Stack.prototype.has = $MtEvJ;
$846ac256d1b7ff52$var$Stack.prototype.set = $2AFRx;
module.exports = $846ac256d1b7ff52$var$Stack;

});
parcelRegister("l3q3h", function(module, exports) {

var $j9tBX = parcelRequire("j9tBX");

var $iZj2z = parcelRequire("iZj2z");

var $7t3w1 = parcelRequire("7t3w1");

var $7w4o9 = parcelRequire("7w4o9");

var $2tu85 = parcelRequire("2tu85");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $f53e1623025b90d2$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$f53e1623025b90d2$var$ListCache.prototype.clear = $j9tBX;
$f53e1623025b90d2$var$ListCache.prototype["delete"] = $iZj2z;
$f53e1623025b90d2$var$ListCache.prototype.get = $7t3w1;
$f53e1623025b90d2$var$ListCache.prototype.has = $7w4o9;
$f53e1623025b90d2$var$ListCache.prototype.set = $2tu85;
module.exports = $f53e1623025b90d2$var$ListCache;

});
parcelRegister("j9tBX", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $df15d3c49e33e47f$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $df15d3c49e33e47f$var$listCacheClear;

});

parcelRegister("iZj2z", function(module, exports) {

var $lLz7d = parcelRequire("lLz7d");
/** Used for built-in method references. */ var $dd2cb1840a00f300$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $dd2cb1840a00f300$var$splice = $dd2cb1840a00f300$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $dd2cb1840a00f300$var$listCacheDelete(key) {
    var data = this.__data__, index = $lLz7d(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $dd2cb1840a00f300$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $dd2cb1840a00f300$var$listCacheDelete;

});
parcelRegister("lLz7d", function(module, exports) {

var $OWbEX = parcelRequire("OWbEX");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $fd8939f086ff8050$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($OWbEX(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $fd8939f086ff8050$var$assocIndexOf;

});
parcelRegister("OWbEX", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $0991ce5d419a95a2$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $0991ce5d419a95a2$var$eq;

});



parcelRegister("7t3w1", function(module, exports) {

var $lLz7d = parcelRequire("lLz7d");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $56fdf7eefe78eb1b$var$listCacheGet(key) {
    var data = this.__data__, index = $lLz7d(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $56fdf7eefe78eb1b$var$listCacheGet;

});

parcelRegister("7w4o9", function(module, exports) {

var $lLz7d = parcelRequire("lLz7d");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $578eed0d868f8409$var$listCacheHas(key) {
    return $lLz7d(this.__data__, key) > -1;
}
module.exports = $578eed0d868f8409$var$listCacheHas;

});

parcelRegister("2tu85", function(module, exports) {

var $lLz7d = parcelRequire("lLz7d");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $1cd5a94a97cc2ea0$var$listCacheSet(key, value) {
    var data = this.__data__, index = $lLz7d(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $1cd5a94a97cc2ea0$var$listCacheSet;

});


parcelRegister("6vncU", function(module, exports) {

var $l3q3h = parcelRequire("l3q3h");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $4bc7a3c9d6b1145b$var$stackClear() {
    this.__data__ = new $l3q3h;
    this.size = 0;
}
module.exports = $4bc7a3c9d6b1145b$var$stackClear;

});

parcelRegister("1Hvta", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $13d237c25ab2b113$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
module.exports = $13d237c25ab2b113$var$stackDelete;

});

parcelRegister("5Rsv7", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $444802a9d9344de8$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $444802a9d9344de8$var$stackGet;

});

parcelRegister("MtEvJ", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $091b7c28a83536fa$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $091b7c28a83536fa$var$stackHas;

});

parcelRegister("2AFRx", function(module, exports) {

var $l3q3h = parcelRequire("l3q3h");

var $4ewh5 = parcelRequire("4ewh5");

var $bIXtv = parcelRequire("bIXtv");
/** Used as the size to enable large array optimizations. */ var $1e2f6a8fffa46fb2$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $1e2f6a8fffa46fb2$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $l3q3h) {
        var pairs = data.__data__;
        if (!$4ewh5 || pairs.length < $1e2f6a8fffa46fb2$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $bIXtv(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $1e2f6a8fffa46fb2$var$stackSet;

});
parcelRegister("4ewh5", function(module, exports) {

var $bQvHH = parcelRequire("bQvHH");

var $jtr7n = parcelRequire("jtr7n");
/* Built-in method references that are verified to be native. */ var $31518146962954d8$var$Map = $bQvHH($jtr7n, "Map");
module.exports = $31518146962954d8$var$Map;

});
parcelRegister("bQvHH", function(module, exports) {

var $e83wH = parcelRequire("e83wH");

var $ibj5Y = parcelRequire("ibj5Y");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $89fd24c6db2eef74$var$getNative(object, key) {
    var value = $ibj5Y(object, key);
    return $e83wH(value) ? value : undefined;
}
module.exports = $89fd24c6db2eef74$var$getNative;

});
parcelRegister("e83wH", function(module, exports) {

var $7jT4Y = parcelRequire("7jT4Y");

var $kqYic = parcelRequire("kqYic");

var $gMakP = parcelRequire("gMakP");

var $hWvxM = parcelRequire("hWvxM");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $a4948c563441e4c4$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $a4948c563441e4c4$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $a4948c563441e4c4$var$funcProto = Function.prototype, $a4948c563441e4c4$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $a4948c563441e4c4$var$funcToString = $a4948c563441e4c4$var$funcProto.toString;
/** Used to check objects for own properties. */ var $a4948c563441e4c4$var$hasOwnProperty = $a4948c563441e4c4$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $a4948c563441e4c4$var$reIsNative = RegExp("^" + $a4948c563441e4c4$var$funcToString.call($a4948c563441e4c4$var$hasOwnProperty).replace($a4948c563441e4c4$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $a4948c563441e4c4$var$baseIsNative(value) {
    if (!$gMakP(value) || $kqYic(value)) return false;
    var pattern = $7jT4Y(value) ? $a4948c563441e4c4$var$reIsNative : $a4948c563441e4c4$var$reIsHostCtor;
    return pattern.test($hWvxM(value));
}
module.exports = $a4948c563441e4c4$var$baseIsNative;

});
parcelRegister("7jT4Y", function(module, exports) {

var $55zsO = parcelRequire("55zsO");

var $gMakP = parcelRequire("gMakP");
/** `Object#toString` result references. */ var $5545085a2af6cfca$var$asyncTag = "[object AsyncFunction]", $5545085a2af6cfca$var$funcTag = "[object Function]", $5545085a2af6cfca$var$genTag = "[object GeneratorFunction]", $5545085a2af6cfca$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $5545085a2af6cfca$var$isFunction(value) {
    if (!$gMakP(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $55zsO(value);
    return tag == $5545085a2af6cfca$var$funcTag || tag == $5545085a2af6cfca$var$genTag || tag == $5545085a2af6cfca$var$asyncTag || tag == $5545085a2af6cfca$var$proxyTag;
}
module.exports = $5545085a2af6cfca$var$isFunction;

});
parcelRegister("55zsO", function(module, exports) {

var $eNXax = parcelRequire("eNXax");

var $dh7EZ = parcelRequire("dh7EZ");

var $iIZia = parcelRequire("iIZia");
/** `Object#toString` result references. */ var $3b48edc1b43ece21$var$nullTag = "[object Null]", $3b48edc1b43ece21$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $3b48edc1b43ece21$var$symToStringTag = $eNXax ? $eNXax.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $3b48edc1b43ece21$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $3b48edc1b43ece21$var$undefinedTag : $3b48edc1b43ece21$var$nullTag;
    return $3b48edc1b43ece21$var$symToStringTag && $3b48edc1b43ece21$var$symToStringTag in Object(value) ? $dh7EZ(value) : $iIZia(value);
}
module.exports = $3b48edc1b43ece21$var$baseGetTag;

});
parcelRegister("eNXax", function(module, exports) {

var $jtr7n = parcelRequire("jtr7n");
/** Built-in value references. */ var $ac738a09880b3ee2$var$Symbol = $jtr7n.Symbol;
module.exports = $ac738a09880b3ee2$var$Symbol;

});
parcelRegister("jtr7n", function(module, exports) {

var $c2Uiw = parcelRequire("c2Uiw");
/** Detect free variable `self`. */ var $e2d5c2d6095c52d0$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $e2d5c2d6095c52d0$var$root = $c2Uiw || $e2d5c2d6095c52d0$var$freeSelf || Function("return this")();
module.exports = $e2d5c2d6095c52d0$var$root;

});
parcelRegister("c2Uiw", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $8c51577a8b55dfc9$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $8c51577a8b55dfc9$var$freeGlobal;

});



parcelRegister("dh7EZ", function(module, exports) {

var $eNXax = parcelRequire("eNXax");
/** Used for built-in method references. */ var $9aa2ce0eb921d448$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $9aa2ce0eb921d448$var$hasOwnProperty = $9aa2ce0eb921d448$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $9aa2ce0eb921d448$var$nativeObjectToString = $9aa2ce0eb921d448$var$objectProto.toString;
/** Built-in value references. */ var $9aa2ce0eb921d448$var$symToStringTag = $eNXax ? $eNXax.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $9aa2ce0eb921d448$var$getRawTag(value) {
    var isOwn = $9aa2ce0eb921d448$var$hasOwnProperty.call(value, $9aa2ce0eb921d448$var$symToStringTag), tag = value[$9aa2ce0eb921d448$var$symToStringTag];
    try {
        value[$9aa2ce0eb921d448$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $9aa2ce0eb921d448$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$9aa2ce0eb921d448$var$symToStringTag] = tag;
        else delete value[$9aa2ce0eb921d448$var$symToStringTag];
    }
    return result;
}
module.exports = $9aa2ce0eb921d448$var$getRawTag;

});

parcelRegister("iIZia", function(module, exports) {
/** Used for built-in method references. */ var $da1be163b8b75897$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $da1be163b8b75897$var$nativeObjectToString = $da1be163b8b75897$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $da1be163b8b75897$var$objectToString(value) {
    return $da1be163b8b75897$var$nativeObjectToString.call(value);
}
module.exports = $da1be163b8b75897$var$objectToString;

});


parcelRegister("gMakP", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ 
var $l0HdX = parcelRequire("l0HdX");
function $c369255b5a35656b$var$isObject(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, $l0HdX._)(value);
    return value != null && (type == "object" || type == "function");
}
module.exports = $c369255b5a35656b$var$isObject;

});


parcelRegister("kqYic", function(module, exports) {

var $jmskY = parcelRequire("jmskY");
/** Used to detect methods masquerading as native. */ var $ee0501352ecaba17$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($jmskY && $jmskY.keys && $jmskY.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $ee0501352ecaba17$var$isMasked(func) {
    return !!$ee0501352ecaba17$var$maskSrcKey && $ee0501352ecaba17$var$maskSrcKey in func;
}
module.exports = $ee0501352ecaba17$var$isMasked;

});
parcelRegister("jmskY", function(module, exports) {

var $jtr7n = parcelRequire("jtr7n");
/** Used to detect overreaching core-js shims. */ var $e1860d919b31eed3$var$coreJsData = $jtr7n["__core-js_shared__"];
module.exports = $e1860d919b31eed3$var$coreJsData;

});


parcelRegister("hWvxM", function(module, exports) {
/** Used for built-in method references. */ var $d1005265917b329b$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $d1005265917b329b$var$funcToString = $d1005265917b329b$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $d1005265917b329b$var$toSource(func) {
    if (func != null) {
        try {
            return $d1005265917b329b$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
module.exports = $d1005265917b329b$var$toSource;

});


parcelRegister("ibj5Y", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $d3c81104c7cea640$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $d3c81104c7cea640$var$getValue;

});



parcelRegister("bIXtv", function(module, exports) {

var $83fpY = parcelRequire("83fpY");

var $bcS1J = parcelRequire("bcS1J");

var $axqNn = parcelRequire("axqNn");

var $5Cfcu = parcelRequire("5Cfcu");

var $dWAcy = parcelRequire("dWAcy");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $8891f0394605c508$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$8891f0394605c508$var$MapCache.prototype.clear = $83fpY;
$8891f0394605c508$var$MapCache.prototype["delete"] = $bcS1J;
$8891f0394605c508$var$MapCache.prototype.get = $axqNn;
$8891f0394605c508$var$MapCache.prototype.has = $5Cfcu;
$8891f0394605c508$var$MapCache.prototype.set = $dWAcy;
module.exports = $8891f0394605c508$var$MapCache;

});
parcelRegister("83fpY", function(module, exports) {

var $gsdeA = parcelRequire("gsdeA");

var $l3q3h = parcelRequire("l3q3h");

var $4ewh5 = parcelRequire("4ewh5");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $5dca903ee23580bc$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new $gsdeA,
        "map": new ($4ewh5 || $l3q3h),
        "string": new $gsdeA
    };
}
module.exports = $5dca903ee23580bc$var$mapCacheClear;

});
parcelRegister("gsdeA", function(module, exports) {

var $2nr8H = parcelRequire("2nr8H");

var $eLp7U = parcelRequire("eLp7U");

var $2cpVt = parcelRequire("2cpVt");

var $eH4dY = parcelRequire("eH4dY");

var $kBb30 = parcelRequire("kBb30");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $bfa986f08edeb84e$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$bfa986f08edeb84e$var$Hash.prototype.clear = $2nr8H;
$bfa986f08edeb84e$var$Hash.prototype["delete"] = $eLp7U;
$bfa986f08edeb84e$var$Hash.prototype.get = $2cpVt;
$bfa986f08edeb84e$var$Hash.prototype.has = $eH4dY;
$bfa986f08edeb84e$var$Hash.prototype.set = $kBb30;
module.exports = $bfa986f08edeb84e$var$Hash;

});
parcelRegister("2nr8H", function(module, exports) {

var $9BlOe = parcelRequire("9BlOe");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $1bb2c8087e1aa191$var$hashClear() {
    this.__data__ = $9BlOe ? $9BlOe(null) : {};
    this.size = 0;
}
module.exports = $1bb2c8087e1aa191$var$hashClear;

});
parcelRegister("9BlOe", function(module, exports) {

var $bQvHH = parcelRequire("bQvHH");
/* Built-in method references that are verified to be native. */ var $6fd87c96ecacf27c$var$nativeCreate = $bQvHH(Object, "create");
module.exports = $6fd87c96ecacf27c$var$nativeCreate;

});


parcelRegister("eLp7U", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $abf8f219fcec8a7e$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $abf8f219fcec8a7e$var$hashDelete;

});

parcelRegister("2cpVt", function(module, exports) {

var $9BlOe = parcelRequire("9BlOe");
/** Used to stand-in for `undefined` hash values. */ var $19a0d01cdd97c13b$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $19a0d01cdd97c13b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $19a0d01cdd97c13b$var$hasOwnProperty = $19a0d01cdd97c13b$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $19a0d01cdd97c13b$var$hashGet(key) {
    var data = this.__data__;
    if ($9BlOe) {
        var result = data[key];
        return result === $19a0d01cdd97c13b$var$HASH_UNDEFINED ? undefined : result;
    }
    return $19a0d01cdd97c13b$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $19a0d01cdd97c13b$var$hashGet;

});

parcelRegister("eH4dY", function(module, exports) {

var $9BlOe = parcelRequire("9BlOe");
/** Used for built-in method references. */ var $ab285bb1785f2924$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ab285bb1785f2924$var$hasOwnProperty = $ab285bb1785f2924$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $ab285bb1785f2924$var$hashHas(key) {
    var data = this.__data__;
    return $9BlOe ? data[key] !== undefined : $ab285bb1785f2924$var$hasOwnProperty.call(data, key);
}
module.exports = $ab285bb1785f2924$var$hashHas;

});

parcelRegister("kBb30", function(module, exports) {

var $9BlOe = parcelRequire("9BlOe");
/** Used to stand-in for `undefined` hash values. */ var $efefd529ec3ce2df$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $efefd529ec3ce2df$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $9BlOe && value === undefined ? $efefd529ec3ce2df$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $efefd529ec3ce2df$var$hashSet;

});



parcelRegister("bcS1J", function(module, exports) {

var $jlEnh = parcelRequire("jlEnh");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $828ab94bce67e009$var$mapCacheDelete(key) {
    var result = $jlEnh(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $828ab94bce67e009$var$mapCacheDelete;

});
parcelRegister("jlEnh", function(module, exports) {

var $5jSCe = parcelRequire("5jSCe");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $e15f4c03fd703366$var$getMapData(map, key) {
    var data = map.__data__;
    return $5jSCe(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
module.exports = $e15f4c03fd703366$var$getMapData;

});
parcelRegister("5jSCe", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ 
var $l0HdX = parcelRequire("l0HdX");
function $3df9179f702add90$var$isKeyable(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, $l0HdX._)(value);
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
module.exports = $3df9179f702add90$var$isKeyable;

});



parcelRegister("axqNn", function(module, exports) {

var $jlEnh = parcelRequire("jlEnh");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $7ac1c574ffc04701$var$mapCacheGet(key) {
    return $jlEnh(this, key).get(key);
}
module.exports = $7ac1c574ffc04701$var$mapCacheGet;

});

parcelRegister("5Cfcu", function(module, exports) {

var $jlEnh = parcelRequire("jlEnh");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $416c4ad97b3d9dee$var$mapCacheHas(key) {
    return $jlEnh(this, key).has(key);
}
module.exports = $416c4ad97b3d9dee$var$mapCacheHas;

});

parcelRegister("dWAcy", function(module, exports) {

var $jlEnh = parcelRequire("jlEnh");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $a26cc606734de661$var$mapCacheSet(key, value) {
    var data = $jlEnh(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $a26cc606734de661$var$mapCacheSet;

});




parcelRegister("eKVfs", function(module, exports) {

var $dRmaD = parcelRequire("dRmaD");

var $5UUot = parcelRequire("5UUot");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $abe1c4e07f44939b$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$5UUot(value) && !$5UUot(other)) return value !== value && other !== other;
    return $dRmaD(value, other, bitmask, customizer, $abe1c4e07f44939b$var$baseIsEqual, stack);
}
module.exports = $abe1c4e07f44939b$var$baseIsEqual;

});
parcelRegister("dRmaD", function(module, exports) {

var $bmQRT = parcelRequire("bmQRT");

var $4IPpo = parcelRequire("4IPpo");

var $noHmr = parcelRequire("noHmr");

var $hbx48 = parcelRequire("hbx48");

var $7PSPF = parcelRequire("7PSPF");

var $imhlU = parcelRequire("imhlU");

var $4emcM = parcelRequire("4emcM");

var $cykxW = parcelRequire("cykxW");
/** Used to compose bitmasks for value comparisons. */ var $a1716c368ae82f06$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $a1716c368ae82f06$var$argsTag = "[object Arguments]", $a1716c368ae82f06$var$arrayTag = "[object Array]", $a1716c368ae82f06$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $a1716c368ae82f06$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a1716c368ae82f06$var$hasOwnProperty = $a1716c368ae82f06$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $a1716c368ae82f06$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $imhlU(object), othIsArr = $imhlU(other), objTag = objIsArr ? $a1716c368ae82f06$var$arrayTag : $7PSPF(object), othTag = othIsArr ? $a1716c368ae82f06$var$arrayTag : $7PSPF(other);
    objTag = objTag == $a1716c368ae82f06$var$argsTag ? $a1716c368ae82f06$var$objectTag : objTag;
    othTag = othTag == $a1716c368ae82f06$var$argsTag ? $a1716c368ae82f06$var$objectTag : othTag;
    var objIsObj = objTag == $a1716c368ae82f06$var$objectTag, othIsObj = othTag == $a1716c368ae82f06$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $4emcM(object)) {
        if (!$4emcM(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $bmQRT);
        return objIsArr || $cykxW(object) ? $4IPpo(object, other, bitmask, customizer, equalFunc, stack) : $noHmr(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $a1716c368ae82f06$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $a1716c368ae82f06$var$hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && $a1716c368ae82f06$var$hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $bmQRT);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $bmQRT);
    return $hbx48(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = $a1716c368ae82f06$var$baseIsEqualDeep;

});
parcelRegister("4IPpo", function(module, exports) {

var $b4LIM = parcelRequire("b4LIM");

var $hEdUt = parcelRequire("hEdUt");

var $civ4b = parcelRequire("civ4b");
/** Used to compose bitmasks for value comparisons. */ var $3703262cab8c77bc$var$COMPARE_PARTIAL_FLAG = 1, $3703262cab8c77bc$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $3703262cab8c77bc$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $3703262cab8c77bc$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $3703262cab8c77bc$var$COMPARE_UNORDERED_FLAG ? new $b4LIM : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$hEdUt(other, function(othValue, othIndex) {
                if (!$civ4b(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
module.exports = $3703262cab8c77bc$var$equalArrays;

});
parcelRegister("b4LIM", function(module, exports) {

var $bIXtv = parcelRequire("bIXtv");

var $2seaA = parcelRequire("2seaA");

var $ljuDX = parcelRequire("ljuDX");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $810515dbb37052e5$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $bIXtv;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$810515dbb37052e5$var$SetCache.prototype.add = $810515dbb37052e5$var$SetCache.prototype.push = $2seaA;
$810515dbb37052e5$var$SetCache.prototype.has = $ljuDX;
module.exports = $810515dbb37052e5$var$SetCache;

});
parcelRegister("2seaA", function(module, exports) {
/** Used to stand-in for `undefined` hash values. */ var $1c99301937934d8c$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $1c99301937934d8c$var$setCacheAdd(value) {
    this.__data__.set(value, $1c99301937934d8c$var$HASH_UNDEFINED);
    return this;
}
module.exports = $1c99301937934d8c$var$setCacheAdd;

});

parcelRegister("ljuDX", function(module, exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $f84324750ff5bc84$var$setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = $f84324750ff5bc84$var$setCacheHas;

});


parcelRegister("hEdUt", function(module, exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $cd90f651af9ce75e$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = $cd90f651af9ce75e$var$arraySome;

});

parcelRegister("civ4b", function(module, exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $8f3f43a4136eb51d$var$cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = $8f3f43a4136eb51d$var$cacheHas;

});


parcelRegister("noHmr", function(module, exports) {

var $eNXax = parcelRequire("eNXax");

var $cWV7w = parcelRequire("cWV7w");

var $OWbEX = parcelRequire("OWbEX");

var $4IPpo = parcelRequire("4IPpo");

var $ak312 = parcelRequire("ak312");

var $hHNRO = parcelRequire("hHNRO");
/** Used to compose bitmasks for value comparisons. */ var $04654eadcc6eb961$var$COMPARE_PARTIAL_FLAG = 1, $04654eadcc6eb961$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $04654eadcc6eb961$var$boolTag = "[object Boolean]", $04654eadcc6eb961$var$dateTag = "[object Date]", $04654eadcc6eb961$var$errorTag = "[object Error]", $04654eadcc6eb961$var$mapTag = "[object Map]", $04654eadcc6eb961$var$numberTag = "[object Number]", $04654eadcc6eb961$var$regexpTag = "[object RegExp]", $04654eadcc6eb961$var$setTag = "[object Set]", $04654eadcc6eb961$var$stringTag = "[object String]", $04654eadcc6eb961$var$symbolTag = "[object Symbol]";
var $04654eadcc6eb961$var$arrayBufferTag = "[object ArrayBuffer]", $04654eadcc6eb961$var$dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var $04654eadcc6eb961$var$symbolProto = $eNXax ? $eNXax.prototype : undefined, $04654eadcc6eb961$var$symbolValueOf = $04654eadcc6eb961$var$symbolProto ? $04654eadcc6eb961$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $04654eadcc6eb961$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $04654eadcc6eb961$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $04654eadcc6eb961$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $cWV7w(object), new $cWV7w(other))) return false;
            return true;
        case $04654eadcc6eb961$var$boolTag:
        case $04654eadcc6eb961$var$dateTag:
        case $04654eadcc6eb961$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $OWbEX(+object, +other);
        case $04654eadcc6eb961$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $04654eadcc6eb961$var$regexpTag:
        case $04654eadcc6eb961$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case $04654eadcc6eb961$var$mapTag:
            var convert = $ak312;
        case $04654eadcc6eb961$var$setTag:
            var isPartial = bitmask & $04654eadcc6eb961$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $hHNRO);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $04654eadcc6eb961$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $4IPpo(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case $04654eadcc6eb961$var$symbolTag:
            if ($04654eadcc6eb961$var$symbolValueOf) return $04654eadcc6eb961$var$symbolValueOf.call(object) == $04654eadcc6eb961$var$symbolValueOf.call(other);
    }
    return false;
}
module.exports = $04654eadcc6eb961$var$equalByTag;

});
parcelRegister("cWV7w", function(module, exports) {

var $jtr7n = parcelRequire("jtr7n");
/** Built-in value references. */ var $96d735b7e1333749$var$Uint8Array = $jtr7n.Uint8Array;
module.exports = $96d735b7e1333749$var$Uint8Array;

});

parcelRegister("ak312", function(module, exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $783e1c82f4bfe65e$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = $783e1c82f4bfe65e$var$mapToArray;

});

parcelRegister("hHNRO", function(module, exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $ce3d225bdf82547d$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = $ce3d225bdf82547d$var$setToArray;

});


parcelRegister("hbx48", function(module, exports) {

var $6PVkR = parcelRequire("6PVkR");
/** Used to compose bitmasks for value comparisons. */ var $c82d1ceaa0368b1a$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $c82d1ceaa0368b1a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c82d1ceaa0368b1a$var$hasOwnProperty = $c82d1ceaa0368b1a$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $c82d1ceaa0368b1a$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $c82d1ceaa0368b1a$var$COMPARE_PARTIAL_FLAG, objProps = $6PVkR(object), objLength = objProps.length, othProps = $6PVkR(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $c82d1ceaa0368b1a$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
module.exports = $c82d1ceaa0368b1a$var$equalObjects;

});
parcelRegister("6PVkR", function(module, exports) {

var $eETKI = parcelRequire("eETKI");

var $jjBBe = parcelRequire("jjBBe");

var $4BWID = parcelRequire("4BWID");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $4fa3fb1a5f11a10f$var$getAllKeys(object) {
    return $eETKI(object, $4BWID, $jjBBe);
}
module.exports = $4fa3fb1a5f11a10f$var$getAllKeys;

});
parcelRegister("eETKI", function(module, exports) {

var $4QWyg = parcelRequire("4QWyg");

var $imhlU = parcelRequire("imhlU");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $aac00c673fd6870f$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $imhlU(object) ? result : $4QWyg(result, symbolsFunc(object));
}
module.exports = $aac00c673fd6870f$var$baseGetAllKeys;

});
parcelRegister("4QWyg", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $38896fe398a009b9$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $38896fe398a009b9$var$arrayPush;

});

parcelRegister("imhlU", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $d5d7bde9f08392b1$var$isArray = Array.isArray;
module.exports = $d5d7bde9f08392b1$var$isArray;

});


parcelRegister("jjBBe", function(module, exports) {

var $Xdg0l = parcelRequire("Xdg0l");

var $8yLSk = parcelRequire("8yLSk");
/** Used for built-in method references. */ var $e0fcf520e8c76b84$var$objectProto = Object.prototype;
/** Built-in value references. */ var $e0fcf520e8c76b84$var$propertyIsEnumerable = $e0fcf520e8c76b84$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $e0fcf520e8c76b84$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $e0fcf520e8c76b84$var$getSymbols = !$e0fcf520e8c76b84$var$nativeGetSymbols ? $8yLSk : function getSymbols(object) {
    if (object == null) return [];
    object = Object(object);
    return $Xdg0l($e0fcf520e8c76b84$var$nativeGetSymbols(object), function(symbol) {
        return $e0fcf520e8c76b84$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $e0fcf520e8c76b84$var$getSymbols;

});
parcelRegister("Xdg0l", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $0b1fcb650a557a53$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $0b1fcb650a557a53$var$arrayFilter;

});

parcelRegister("8yLSk", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $63b6a2b65a404543$var$stubArray() {
    return [];
}
module.exports = $63b6a2b65a404543$var$stubArray;

});


parcelRegister("4BWID", function(module, exports) {

var $9R28t = parcelRequire("9R28t");

var $g3M4h = parcelRequire("g3M4h");

var $2ABmT = parcelRequire("2ABmT");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $35b82a806bcd6b76$var$keys(object) {
    return $2ABmT(object) ? $9R28t(object) : $g3M4h(object);
}
module.exports = $35b82a806bcd6b76$var$keys;

});
parcelRegister("9R28t", function(module, exports) {

var $bQbmU = parcelRequire("bQbmU");

var $jakqq = parcelRequire("jakqq");

var $imhlU = parcelRequire("imhlU");

var $4emcM = parcelRequire("4emcM");

var $fgmmd = parcelRequire("fgmmd");

var $cykxW = parcelRequire("cykxW");
/** Used for built-in method references. */ var $72cab86597a32cb2$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $72cab86597a32cb2$var$hasOwnProperty = $72cab86597a32cb2$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $72cab86597a32cb2$var$arrayLikeKeys(value, inherited) {
    var isArr = $imhlU(value), isArg = !isArr && $jakqq(value), isBuff = !isArr && !isArg && $4emcM(value), isType = !isArr && !isArg && !isBuff && $cykxW(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $bQbmU(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $72cab86597a32cb2$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    $fgmmd(key, length)))) result.push(key);
    return result;
}
module.exports = $72cab86597a32cb2$var$arrayLikeKeys;

});
parcelRegister("bQbmU", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $89ed5e9a08bb554e$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $89ed5e9a08bb554e$var$baseTimes;

});

parcelRegister("jakqq", function(module, exports) {

var $hJdTX = parcelRequire("hJdTX");

var $5UUot = parcelRequire("5UUot");
/** Used for built-in method references. */ var $df3ecb832a1e2559$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $df3ecb832a1e2559$var$hasOwnProperty = $df3ecb832a1e2559$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $df3ecb832a1e2559$var$propertyIsEnumerable = $df3ecb832a1e2559$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $df3ecb832a1e2559$var$isArguments = $hJdTX(function() {
    return arguments;
}()) ? $hJdTX : function isArguments(value) {
    return $5UUot(value) && $df3ecb832a1e2559$var$hasOwnProperty.call(value, "callee") && !$df3ecb832a1e2559$var$propertyIsEnumerable.call(value, "callee");
};
module.exports = $df3ecb832a1e2559$var$isArguments;

});
parcelRegister("hJdTX", function(module, exports) {

var $55zsO = parcelRequire("55zsO");

var $5UUot = parcelRequire("5UUot");
/** `Object#toString` result references. */ var $ce816c2fe7604a38$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $ce816c2fe7604a38$var$baseIsArguments(value) {
    return $5UUot(value) && $55zsO(value) == $ce816c2fe7604a38$var$argsTag;
}
module.exports = $ce816c2fe7604a38$var$baseIsArguments;

});
parcelRegister("5UUot", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $44eded5b70311612$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
module.exports = $44eded5b70311612$var$isObjectLike;

});



parcelRegister("4emcM", function(module, exports) {

var $jtr7n = parcelRequire("jtr7n");

var $aElTt = parcelRequire("aElTt");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $jtr7n.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $aElTt;
module.exports = isBuffer;

});
parcelRegister("aElTt", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $7c0e9f7724878a4b$var$stubFalse() {
    return false;
}
module.exports = $7c0e9f7724878a4b$var$stubFalse;

});


parcelRegister("fgmmd", function(module, exports) {
/** Used as references for various `Number` constants. */ 
var $l0HdX = parcelRequire("l0HdX");
var $b1c9b15569191c6f$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $b1c9b15569191c6f$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $b1c9b15569191c6f$var$isIndex(value, length) {
    var type = typeof value === "undefined" ? "undefined" : (0, $l0HdX._)(value);
    length = length == null ? $b1c9b15569191c6f$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $b1c9b15569191c6f$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $b1c9b15569191c6f$var$isIndex;

});

parcelRegister("cykxW", function(module, exports) {

var $76nZq = parcelRequire("76nZq");

var $e1IPi = parcelRequire("e1IPi");

var $68GBo = parcelRequire("68GBo");
/* Node.js helper references. */ var $9238991a0e34b8ab$var$nodeIsTypedArray = $68GBo && $68GBo.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $9238991a0e34b8ab$var$isTypedArray = $9238991a0e34b8ab$var$nodeIsTypedArray ? $e1IPi($9238991a0e34b8ab$var$nodeIsTypedArray) : $76nZq;
module.exports = $9238991a0e34b8ab$var$isTypedArray;

});
parcelRegister("76nZq", function(module, exports) {

var $55zsO = parcelRequire("55zsO");

var $juxNf = parcelRequire("juxNf");

var $5UUot = parcelRequire("5UUot");
/** `Object#toString` result references. */ var $52bbb3c79298be06$var$argsTag = "[object Arguments]", $52bbb3c79298be06$var$arrayTag = "[object Array]", $52bbb3c79298be06$var$boolTag = "[object Boolean]", $52bbb3c79298be06$var$dateTag = "[object Date]", $52bbb3c79298be06$var$errorTag = "[object Error]", $52bbb3c79298be06$var$funcTag = "[object Function]", $52bbb3c79298be06$var$mapTag = "[object Map]", $52bbb3c79298be06$var$numberTag = "[object Number]", $52bbb3c79298be06$var$objectTag = "[object Object]", $52bbb3c79298be06$var$regexpTag = "[object RegExp]", $52bbb3c79298be06$var$setTag = "[object Set]", $52bbb3c79298be06$var$stringTag = "[object String]", $52bbb3c79298be06$var$weakMapTag = "[object WeakMap]";
var $52bbb3c79298be06$var$arrayBufferTag = "[object ArrayBuffer]", $52bbb3c79298be06$var$dataViewTag = "[object DataView]", $52bbb3c79298be06$var$float32Tag = "[object Float32Array]", $52bbb3c79298be06$var$float64Tag = "[object Float64Array]", $52bbb3c79298be06$var$int8Tag = "[object Int8Array]", $52bbb3c79298be06$var$int16Tag = "[object Int16Array]", $52bbb3c79298be06$var$int32Tag = "[object Int32Array]", $52bbb3c79298be06$var$uint8Tag = "[object Uint8Array]", $52bbb3c79298be06$var$uint8ClampedTag = "[object Uint8ClampedArray]", $52bbb3c79298be06$var$uint16Tag = "[object Uint16Array]", $52bbb3c79298be06$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $52bbb3c79298be06$var$typedArrayTags = {};
$52bbb3c79298be06$var$typedArrayTags[$52bbb3c79298be06$var$float32Tag] = $52bbb3c79298be06$var$typedArrayTags[$52bbb3c79298be06$var$float64Tag] = $52bbb3c79298be06$var$typedArrayTags[$52bbb3c79298be06$var$int8Tag] = $52bbb3c79298be06$var$typedArrayTags[$52bbb3c79298be06$var$int16Tag] = $52bbb3c79298be06$var$typedArrayTags[$52bbb3c79298be06$var$int32Tag] = $52bbb3c79298be06$var$typedArrayTags[$52bbb3c79298be06$var$uint8Tag] = $52bbb3c79298be06$var$typedArrayTags[$52bbb3c79298be06$var$uint8ClampedTag] = $52bbb3c79298be06$var$typedArrayTags[$52bbb3c79298be06$var$uint16Tag] = $52bbb3c79298be06$var$typedArrayTags[$52bbb3c79298be06$var$uint32Tag] = true;
$52bbb3c79298be06$var$typedArrayTags[$52bbb3c79298be06$var$argsTag] = $52bbb3c79298be06$var$typedArrayTags[$52bbb3c79298be06$var$arrayTag] = $52bbb3c79298be06$var$typedArrayTags[$52bbb3c79298be06$var$arrayBufferTag] = $52bbb3c79298be06$var$typedArrayTags[$52bbb3c79298be06$var$boolTag] = $52bbb3c79298be06$var$typedArrayTags[$52bbb3c79298be06$var$dataViewTag] = $52bbb3c79298be06$var$typedArrayTags[$52bbb3c79298be06$var$dateTag] = $52bbb3c79298be06$var$typedArrayTags[$52bbb3c79298be06$var$errorTag] = $52bbb3c79298be06$var$typedArrayTags[$52bbb3c79298be06$var$funcTag] = $52bbb3c79298be06$var$typedArrayTags[$52bbb3c79298be06$var$mapTag] = $52bbb3c79298be06$var$typedArrayTags[$52bbb3c79298be06$var$numberTag] = $52bbb3c79298be06$var$typedArrayTags[$52bbb3c79298be06$var$objectTag] = $52bbb3c79298be06$var$typedArrayTags[$52bbb3c79298be06$var$regexpTag] = $52bbb3c79298be06$var$typedArrayTags[$52bbb3c79298be06$var$setTag] = $52bbb3c79298be06$var$typedArrayTags[$52bbb3c79298be06$var$stringTag] = $52bbb3c79298be06$var$typedArrayTags[$52bbb3c79298be06$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $52bbb3c79298be06$var$baseIsTypedArray(value) {
    return $5UUot(value) && $juxNf(value.length) && !!$52bbb3c79298be06$var$typedArrayTags[$55zsO(value)];
}
module.exports = $52bbb3c79298be06$var$baseIsTypedArray;

});
parcelRegister("juxNf", function(module, exports) {
/** Used as references for various `Number` constants. */ var $e30b085592a5dbad$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $e30b085592a5dbad$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $e30b085592a5dbad$var$MAX_SAFE_INTEGER;
}
module.exports = $e30b085592a5dbad$var$isLength;

});


parcelRegister("e1IPi", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $a363ee407f473c16$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $a363ee407f473c16$var$baseUnary;

});

parcelRegister("68GBo", function(module, exports) {

var $c2Uiw = parcelRequire("c2Uiw");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $c2Uiw.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

});



parcelRegister("g3M4h", function(module, exports) {

var $4Pdwh = parcelRequire("4Pdwh");

var $geceX = parcelRequire("geceX");
/** Used for built-in method references. */ var $bb12367ac5e8a252$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $bb12367ac5e8a252$var$hasOwnProperty = $bb12367ac5e8a252$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $bb12367ac5e8a252$var$baseKeys(object) {
    if (!$4Pdwh(object)) return $geceX(object);
    var result = [];
    for(var key in Object(object))if ($bb12367ac5e8a252$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
module.exports = $bb12367ac5e8a252$var$baseKeys;

});
parcelRegister("4Pdwh", function(module, exports) {
/** Used for built-in method references. */ var $3836698bf6c18255$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $3836698bf6c18255$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $3836698bf6c18255$var$objectProto;
    return value === proto;
}
module.exports = $3836698bf6c18255$var$isPrototype;

});

parcelRegister("geceX", function(module, exports) {

var $cto6u = parcelRequire("cto6u");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $bd0772cf4beb4eb9$var$nativeKeys = $cto6u(Object.keys, Object);
module.exports = $bd0772cf4beb4eb9$var$nativeKeys;

});
parcelRegister("cto6u", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $914ae3f0a0d75831$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $914ae3f0a0d75831$var$overArg;

});



parcelRegister("2ABmT", function(module, exports) {

var $7jT4Y = parcelRequire("7jT4Y");

var $juxNf = parcelRequire("juxNf");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $1e2bee17c08616e6$var$isArrayLike(value) {
    return value != null && $juxNf(value.length) && !$7jT4Y(value);
}
module.exports = $1e2bee17c08616e6$var$isArrayLike;

});




parcelRegister("7PSPF", function(module, exports) {

var $i0GnE = parcelRequire("i0GnE");

var $4ewh5 = parcelRequire("4ewh5");

var $kjEWA = parcelRequire("kjEWA");

var $gy3sn = parcelRequire("gy3sn");

var $rn2lT = parcelRequire("rn2lT");

var $55zsO = parcelRequire("55zsO");

var $hWvxM = parcelRequire("hWvxM");
/** `Object#toString` result references. */ var $5b47d460a1bbdcf2$var$mapTag = "[object Map]", $5b47d460a1bbdcf2$var$objectTag = "[object Object]", $5b47d460a1bbdcf2$var$promiseTag = "[object Promise]", $5b47d460a1bbdcf2$var$setTag = "[object Set]", $5b47d460a1bbdcf2$var$weakMapTag = "[object WeakMap]";
var $5b47d460a1bbdcf2$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $5b47d460a1bbdcf2$var$dataViewCtorString = $hWvxM($i0GnE), $5b47d460a1bbdcf2$var$mapCtorString = $hWvxM($4ewh5), $5b47d460a1bbdcf2$var$promiseCtorString = $hWvxM($kjEWA), $5b47d460a1bbdcf2$var$setCtorString = $hWvxM($gy3sn), $5b47d460a1bbdcf2$var$weakMapCtorString = $hWvxM($rn2lT);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $5b47d460a1bbdcf2$var$getTag = $55zsO;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($i0GnE && $5b47d460a1bbdcf2$var$getTag(new $i0GnE(new ArrayBuffer(1))) != $5b47d460a1bbdcf2$var$dataViewTag || $4ewh5 && $5b47d460a1bbdcf2$var$getTag(new $4ewh5) != $5b47d460a1bbdcf2$var$mapTag || $kjEWA && $5b47d460a1bbdcf2$var$getTag($kjEWA.resolve()) != $5b47d460a1bbdcf2$var$promiseTag || $gy3sn && $5b47d460a1bbdcf2$var$getTag(new $gy3sn) != $5b47d460a1bbdcf2$var$setTag || $rn2lT && $5b47d460a1bbdcf2$var$getTag(new $rn2lT) != $5b47d460a1bbdcf2$var$weakMapTag) $5b47d460a1bbdcf2$var$getTag = function getTag(value) {
    var result = $55zsO(value), Ctor = result == $5b47d460a1bbdcf2$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $hWvxM(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $5b47d460a1bbdcf2$var$dataViewCtorString:
            return $5b47d460a1bbdcf2$var$dataViewTag;
        case $5b47d460a1bbdcf2$var$mapCtorString:
            return $5b47d460a1bbdcf2$var$mapTag;
        case $5b47d460a1bbdcf2$var$promiseCtorString:
            return $5b47d460a1bbdcf2$var$promiseTag;
        case $5b47d460a1bbdcf2$var$setCtorString:
            return $5b47d460a1bbdcf2$var$setTag;
        case $5b47d460a1bbdcf2$var$weakMapCtorString:
            return $5b47d460a1bbdcf2$var$weakMapTag;
    }
    return result;
};
module.exports = $5b47d460a1bbdcf2$var$getTag;

});
parcelRegister("i0GnE", function(module, exports) {

var $bQvHH = parcelRequire("bQvHH");

var $jtr7n = parcelRequire("jtr7n");
/* Built-in method references that are verified to be native. */ var $d1c919effe1da9c8$var$DataView = $bQvHH($jtr7n, "DataView");
module.exports = $d1c919effe1da9c8$var$DataView;

});

parcelRegister("kjEWA", function(module, exports) {

var $bQvHH = parcelRequire("bQvHH");

var $jtr7n = parcelRequire("jtr7n");
/* Built-in method references that are verified to be native. */ var $eca5579ed135b85e$var$Promise = $bQvHH($jtr7n, "Promise");
module.exports = $eca5579ed135b85e$var$Promise;

});

parcelRegister("gy3sn", function(module, exports) {

var $bQvHH = parcelRequire("bQvHH");

var $jtr7n = parcelRequire("jtr7n");
/* Built-in method references that are verified to be native. */ var $c0c280c529bbfab7$var$Set = $bQvHH($jtr7n, "Set");
module.exports = $c0c280c529bbfab7$var$Set;

});

parcelRegister("rn2lT", function(module, exports) {

var $bQvHH = parcelRequire("bQvHH");

var $jtr7n = parcelRequire("jtr7n");
/* Built-in method references that are verified to be native. */ var $0524646321862234$var$WeakMap = $bQvHH($jtr7n, "WeakMap");
module.exports = $0524646321862234$var$WeakMap;

});





parcelRegister("5Og7O", function(module, exports) {

var $vKSG1 = parcelRequire("vKSG1");

var $4BWID = parcelRequire("4BWID");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $43ae21605fc222f1$var$getMatchData(object) {
    var result = $4BWID(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $vKSG1(value)
        ];
    }
    return result;
}
module.exports = $43ae21605fc222f1$var$getMatchData;

});
parcelRegister("vKSG1", function(module, exports) {

var $gMakP = parcelRequire("gMakP");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $05f742ee8a503c71$var$isStrictComparable(value) {
    return value === value && !$gMakP(value);
}
module.exports = $05f742ee8a503c71$var$isStrictComparable;

});


parcelRegister("hTqPy", function(module, exports) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $d06c62b55411614d$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = $d06c62b55411614d$var$matchesStrictComparable;

});


parcelRegister("7dQ3L", function(module, exports) {

var $eKVfs = parcelRequire("eKVfs");

var $gnlCg = parcelRequire("gnlCg");

var $hWkFs = parcelRequire("hWkFs");

var $egTPz = parcelRequire("egTPz");

var $vKSG1 = parcelRequire("vKSG1");

var $hTqPy = parcelRequire("hTqPy");

var $cWnmZ = parcelRequire("cWnmZ");
/** Used to compose bitmasks for value comparisons. */ var $5422214aa40c98a8$var$COMPARE_PARTIAL_FLAG = 1, $5422214aa40c98a8$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $5422214aa40c98a8$var$baseMatchesProperty(path, srcValue) {
    if ($egTPz(path) && $vKSG1(srcValue)) return $hTqPy($cWnmZ(path), srcValue);
    return function(object) {
        var objValue = $gnlCg(object, path);
        return objValue === undefined && objValue === srcValue ? $hWkFs(object, path) : $eKVfs(srcValue, objValue, $5422214aa40c98a8$var$COMPARE_PARTIAL_FLAG | $5422214aa40c98a8$var$COMPARE_UNORDERED_FLAG);
    };
}
module.exports = $5422214aa40c98a8$var$baseMatchesProperty;

});
parcelRegister("gnlCg", function(module, exports) {

var $85kxe = parcelRequire("85kxe");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $bebf8fd242258908$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $85kxe(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $bebf8fd242258908$var$get;

});
parcelRegister("85kxe", function(module, exports) {

var $d61lu = parcelRequire("d61lu");

var $cWnmZ = parcelRequire("cWnmZ");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $5e2eb82f052202f2$var$baseGet(object, path) {
    path = $d61lu(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$cWnmZ(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $5e2eb82f052202f2$var$baseGet;

});
parcelRegister("d61lu", function(module, exports) {

var $imhlU = parcelRequire("imhlU");

var $egTPz = parcelRequire("egTPz");

var $bRyTU = parcelRequire("bRyTU");

var $jRfzF = parcelRequire("jRfzF");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $988ce117708232d9$var$castPath(value, object) {
    if ($imhlU(value)) return value;
    return $egTPz(value, object) ? [
        value
    ] : $bRyTU($jRfzF(value));
}
module.exports = $988ce117708232d9$var$castPath;

});
parcelRegister("egTPz", function(module, exports) {

var $l0HdX = parcelRequire("l0HdX");

var $imhlU = parcelRequire("imhlU");

var $8ZLHP = parcelRequire("8ZLHP");
/** Used to match property names within property paths. */ var $a63dde29aa36ef76$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $a63dde29aa36ef76$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $a63dde29aa36ef76$var$isKey(value, object) {
    if ($imhlU(value)) return false;
    var type = typeof value === "undefined" ? "undefined" : (0, $l0HdX._)(value);
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || $8ZLHP(value)) return true;
    return $a63dde29aa36ef76$var$reIsPlainProp.test(value) || !$a63dde29aa36ef76$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = $a63dde29aa36ef76$var$isKey;

});
parcelRegister("8ZLHP", function(module, exports) {

var $l0HdX = parcelRequire("l0HdX");

var $55zsO = parcelRequire("55zsO");

var $5UUot = parcelRequire("5UUot");
/** `Object#toString` result references. */ var $68c9069d0df95f8a$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $68c9069d0df95f8a$var$isSymbol(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $l0HdX._)(value)) == "symbol" || $5UUot(value) && $55zsO(value) == $68c9069d0df95f8a$var$symbolTag;
}
module.exports = $68c9069d0df95f8a$var$isSymbol;

});


parcelRegister("bRyTU", function(module, exports) {

var $inJ6l = parcelRequire("inJ6l");
/** Used to match property names within property paths. */ var $8a2fb7887852bfe2$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $8a2fb7887852bfe2$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $8a2fb7887852bfe2$var$stringToPath = $inJ6l(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($8a2fb7887852bfe2$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($8a2fb7887852bfe2$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
module.exports = $8a2fb7887852bfe2$var$stringToPath;

});
parcelRegister("inJ6l", function(module, exports) {

var $4L14l = parcelRequire("4L14l");
/** Used as the maximum memoize cache size. */ var $037416219f30ebb7$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $037416219f30ebb7$var$memoizeCapped(func) {
    var result = $4L14l(func, function(key) {
        if (cache.size === $037416219f30ebb7$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = $037416219f30ebb7$var$memoizeCapped;

});
parcelRegister("4L14l", function(module, exports) {

var $bIXtv = parcelRequire("bIXtv");
/** Error message constants. */ var $376c6183f17c42af$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $376c6183f17c42af$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($376c6183f17c42af$var$FUNC_ERROR_TEXT);
    var memoized = function memoized1() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($376c6183f17c42af$var$memoize.Cache || $bIXtv);
    return memoized;
}
// Expose `MapCache`.
$376c6183f17c42af$var$memoize.Cache = $bIXtv;
module.exports = $376c6183f17c42af$var$memoize;

});



parcelRegister("jRfzF", function(module, exports) {

var $eFrTa = parcelRequire("eFrTa");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $e74f0c4e53041f07$var$toString(value) {
    return value == null ? "" : $eFrTa(value);
}
module.exports = $e74f0c4e53041f07$var$toString;

});
parcelRegister("eFrTa", function(module, exports) {

var $eNXax = parcelRequire("eNXax");

var $bERaH = parcelRequire("bERaH");

var $imhlU = parcelRequire("imhlU");

var $8ZLHP = parcelRequire("8ZLHP");
/** Used as references for various `Number` constants. */ var $aada8729e4c4e096$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $aada8729e4c4e096$var$symbolProto = $eNXax ? $eNXax.prototype : undefined, $aada8729e4c4e096$var$symbolToString = $aada8729e4c4e096$var$symbolProto ? $aada8729e4c4e096$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $aada8729e4c4e096$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ($imhlU(value)) // Recursively convert values (susceptible to call stack limits).
    return $bERaH(value, $aada8729e4c4e096$var$baseToString) + "";
    if ($8ZLHP(value)) return $aada8729e4c4e096$var$symbolToString ? $aada8729e4c4e096$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$aada8729e4c4e096$var$INFINITY ? "-0" : result;
}
module.exports = $aada8729e4c4e096$var$baseToString;

});
parcelRegister("bERaH", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $87ccaceb5fc7bf23$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $87ccaceb5fc7bf23$var$arrayMap;

});




parcelRegister("cWnmZ", function(module, exports) {

var $8ZLHP = parcelRequire("8ZLHP");
/** Used as references for various `Number` constants. */ var $96bd079164f06073$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $96bd079164f06073$var$toKey(value) {
    if (typeof value == "string" || $8ZLHP(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$96bd079164f06073$var$INFINITY ? "-0" : result;
}
module.exports = $96bd079164f06073$var$toKey;

});



parcelRegister("hWkFs", function(module, exports) {

var $f73HU = parcelRequire("f73HU");

var $3dDlq = parcelRequire("3dDlq");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $d0f7e29aafb8c3bd$var$hasIn(object, path) {
    return object != null && $3dDlq(object, path, $f73HU);
}
module.exports = $d0f7e29aafb8c3bd$var$hasIn;

});
parcelRegister("f73HU", function(module, exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $b00a629cdb7dc313$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = $b00a629cdb7dc313$var$baseHasIn;

});

parcelRegister("3dDlq", function(module, exports) {

var $d61lu = parcelRequire("d61lu");

var $jakqq = parcelRequire("jakqq");

var $imhlU = parcelRequire("imhlU");

var $fgmmd = parcelRequire("fgmmd");

var $juxNf = parcelRequire("juxNf");

var $cWnmZ = parcelRequire("cWnmZ");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $25811b031a5bb6f1$var$hasPath(object, path, hasFunc) {
    path = $d61lu(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $cWnmZ(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $juxNf(length) && $fgmmd(key, length) && ($imhlU(object) || $jakqq(object));
}
module.exports = $25811b031a5bb6f1$var$hasPath;

});



parcelRegister("l8JO9", function(module, exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $f63de0cbce710253$var$identity(value) {
    return value;
}
module.exports = $f63de0cbce710253$var$identity;

});

parcelRegister("cuQU6", function(module, exports) {

var $a2ETW = parcelRequire("a2ETW");

var $g62Tm = parcelRequire("g62Tm");

var $egTPz = parcelRequire("egTPz");

var $cWnmZ = parcelRequire("cWnmZ");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $919152fa8a2ea8c7$var$property(path) {
    return $egTPz(path) ? $a2ETW($cWnmZ(path)) : $g62Tm(path);
}
module.exports = $919152fa8a2ea8c7$var$property;

});
parcelRegister("a2ETW", function(module, exports) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $74f9d16f41b351f1$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $74f9d16f41b351f1$var$baseProperty;

});

parcelRegister("g62Tm", function(module, exports) {

var $85kxe = parcelRequire("85kxe");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $bb7f732c33136c70$var$basePropertyDeep(path) {
    return function(object) {
        return $85kxe(object, path);
    };
}
module.exports = $bb7f732c33136c70$var$basePropertyDeep;

});



parcelRegister("7vMWR", function(module, exports) {
/** Error message constants. */ var $578165c30e0ba139$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that negates the result of the predicate `func`. The
 * `func` predicate is invoked with the `this` binding and arguments of the
 * created function.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} predicate The predicate to negate.
 * @returns {Function} Returns the new negated function.
 * @example
 *
 * function isEven(n) {
 *   return n % 2 == 0;
 * }
 *
 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
 * // => [1, 3, 5]
 */ function $578165c30e0ba139$var$negate(predicate) {
    if (typeof predicate != "function") throw new TypeError($578165c30e0ba139$var$FUNC_ERROR_TEXT);
    return function() {
        var args = arguments;
        switch(args.length){
            case 0:
                return !predicate.call(this);
            case 1:
                return !predicate.call(this, args[0]);
            case 2:
                return !predicate.call(this, args[0], args[1]);
            case 3:
                return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
    };
}
module.exports = $578165c30e0ba139$var$negate;

});

parcelRegister("4GpzK", function(module, exports) {

var $bERaH = parcelRequire("bERaH");

var $g4NhP = parcelRequire("g4NhP");

var $cd1Dz = parcelRequire("cd1Dz");

var $e9Xa8 = parcelRequire("e9Xa8");
/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */ function $368eec6f338e2b81$var$pickBy(object, predicate) {
    if (object == null) return {};
    var props = $bERaH($e9Xa8(object), function(prop) {
        return [
            prop
        ];
    });
    predicate = $g4NhP(predicate);
    return $cd1Dz(object, props, function(value, path) {
        return predicate(value, path[0]);
    });
}
module.exports = $368eec6f338e2b81$var$pickBy;

});
parcelRegister("cd1Dz", function(module, exports) {

var $85kxe = parcelRequire("85kxe");

var $ewhGI = parcelRequire("ewhGI");

var $d61lu = parcelRequire("d61lu");
/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function $8e37f80ebb1ef004$var$basePickBy(object, paths, predicate) {
    var index = -1, length = paths.length, result = {};
    while(++index < length){
        var path = paths[index], value = $85kxe(object, path);
        if (predicate(value, path)) $ewhGI(result, $d61lu(path, object), value);
    }
    return result;
}
module.exports = $8e37f80ebb1ef004$var$basePickBy;

});
parcelRegister("ewhGI", function(module, exports) {

var $2RYJ6 = parcelRequire("2RYJ6");

var $d61lu = parcelRequire("d61lu");

var $fgmmd = parcelRequire("fgmmd");

var $gMakP = parcelRequire("gMakP");

var $cWnmZ = parcelRequire("cWnmZ");
/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $a921c64d57e7f94b$var$baseSet(object, path, value, customizer) {
    if (!$gMakP(object)) return object;
    path = $d61lu(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = $cWnmZ(path[index]), newValue = value;
        if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = $gMakP(objValue) ? objValue : $fgmmd(path[index + 1]) ? [] : {};
        }
        $2RYJ6(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
module.exports = $a921c64d57e7f94b$var$baseSet;

});
parcelRegister("2RYJ6", function(module, exports) {

var $4JDvy = parcelRequire("4JDvy");

var $OWbEX = parcelRequire("OWbEX");
/** Used for built-in method references. */ var $216fa307457ee204$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $216fa307457ee204$var$hasOwnProperty = $216fa307457ee204$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $216fa307457ee204$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($216fa307457ee204$var$hasOwnProperty.call(object, key) && $OWbEX(objValue, value)) || value === undefined && !(key in object)) $4JDvy(object, key, value);
}
module.exports = $216fa307457ee204$var$assignValue;

});
parcelRegister("4JDvy", function(module, exports) {

var $4n307 = parcelRequire("4n307");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $372a02d937c054bc$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && $4n307) $4n307(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
module.exports = $372a02d937c054bc$var$baseAssignValue;

});
parcelRegister("4n307", function(module, exports) {

var $bQvHH = parcelRequire("bQvHH");
var $32eba3522837c710$var$defineProperty = function() {
    try {
        var func = $bQvHH(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
module.exports = $32eba3522837c710$var$defineProperty;

});





parcelRegister("e9Xa8", function(module, exports) {

var $eETKI = parcelRequire("eETKI");

var $fQAkA = parcelRequire("fQAkA");

var $ie2qU = parcelRequire("ie2qU");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $a4efcc6909c6d9c5$var$getAllKeysIn(object) {
    return $eETKI(object, $ie2qU, $fQAkA);
}
module.exports = $a4efcc6909c6d9c5$var$getAllKeysIn;

});
parcelRegister("fQAkA", function(module, exports) {

var $4QWyg = parcelRequire("4QWyg");

var $aHj1K = parcelRequire("aHj1K");

var $jjBBe = parcelRequire("jjBBe");

var $8yLSk = parcelRequire("8yLSk");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $b897e4ede625159c$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $b897e4ede625159c$var$getSymbolsIn = !$b897e4ede625159c$var$nativeGetSymbols ? $8yLSk : function getSymbolsIn(object) {
    var result = [];
    while(object){
        $4QWyg(result, $jjBBe(object));
        object = $aHj1K(object);
    }
    return result;
};
module.exports = $b897e4ede625159c$var$getSymbolsIn;

});
parcelRegister("aHj1K", function(module, exports) {

var $cto6u = parcelRequire("cto6u");
/** Built-in value references. */ var $7c9cadf57c0655ce$var$getPrototype = $cto6u(Object.getPrototypeOf, Object);
module.exports = $7c9cadf57c0655ce$var$getPrototype;

});


parcelRegister("ie2qU", function(module, exports) {

var $9R28t = parcelRequire("9R28t");

var $4jurL = parcelRequire("4jurL");

var $2ABmT = parcelRequire("2ABmT");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $d44b6bf6d8dd9499$var$keysIn(object) {
    return $2ABmT(object) ? $9R28t(object, true) : $4jurL(object);
}
module.exports = $d44b6bf6d8dd9499$var$keysIn;

});
parcelRegister("4jurL", function(module, exports) {

var $gMakP = parcelRequire("gMakP");

var $4Pdwh = parcelRequire("4Pdwh");

var $atMyq = parcelRequire("atMyq");
/** Used for built-in method references. */ var $32408de0d249b99a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $32408de0d249b99a$var$hasOwnProperty = $32408de0d249b99a$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $32408de0d249b99a$var$baseKeysIn(object) {
    if (!$gMakP(object)) return $atMyq(object);
    var isProto = $4Pdwh(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !$32408de0d249b99a$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
module.exports = $32408de0d249b99a$var$baseKeysIn;

});
parcelRegister("atMyq", function(module, exports) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $7a1246ae5b86376d$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
module.exports = $7a1246ae5b86376d$var$nativeKeysIn;

});






parcelRegister("h9UE0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7df3747031decf9$export$2e2bcd8739ae039; });

var $a6f9h = parcelRequire("a6f9h");

var $a0AXg = parcelRequire("a0AXg");

var $3qWgZ = parcelRequire("3qWgZ");
var $c7df3747031decf9$var$_process$env;
var $c7df3747031decf9$var$ExportedAnalyticsContext;
if (typeof $3qWgZ !== "undefined" && $3qWgZ !== null && ($c7df3747031decf9$var$_process$env = {}, true) && $c7df3747031decf9$var$_process$env !== void 0 && $c7df3747031decf9$var$_process$env["ANALYTICS_NEXT_MODERN_CONTEXT"]) $c7df3747031decf9$var$ExportedAnalyticsContext = (0, $a0AXg.default);
else $c7df3747031decf9$var$ExportedAnalyticsContext = (0, $a6f9h.default);
var $c7df3747031decf9$export$2e2bcd8739ae039 = $c7df3747031decf9$var$ExportedAnalyticsContext;

});
parcelRegister("a6f9h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $75a63728423923c4$export$2e2bcd8739ae039; });

var $eetQ9 = parcelRequire("eetQ9");

var $6QU8A = parcelRequire("6QU8A");

var $2Yk1N = parcelRequire("2Yk1N");

var $hgJzq = parcelRequire("hgJzq");

var $eZhUW = parcelRequire("eZhUW");

var $kcuts = parcelRequire("kcuts");

var $6pDhi = parcelRequire("6pDhi");

var $jjExS = parcelRequire("jjExS");

var $1Mpn7 = parcelRequire("1Mpn7");

var $3shKn = parcelRequire("3shKn");

var $3z3zk = parcelRequire("3z3zk");
function $75a63728423923c4$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $75a63728423923c4$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($6pDhi)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($6pDhi)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($kcuts)))(this, result);
    };
}
function $75a63728423923c4$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $75a63728423923c4$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($3shKn))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($3shKn))).func
};
var $75a63728423923c4$var$noop = function noop() {
    return [];
};
// eslint-disable-next-line @repo/internal/react/no-class-components
var $75a63728423923c4$var$AnalyticsContext = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($eZhUW)))(AnalyticsContext, _Component);
    var _super = $75a63728423923c4$var$_createSuper(AnalyticsContext);
    function AnalyticsContext(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($6QU8A)))(this, AnalyticsContext);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))((0, (/*@__PURE__*/$parcel$interopDefault($hgJzq)))(_this), "getChildContext", function() {
            return {
                getAtlaskitAnalyticsContext: _this.getAnalyticsContext
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))((0, (/*@__PURE__*/$parcel$interopDefault($hgJzq)))(_this), "getAnalyticsContext", function() {
            var data = _this.props.data;
            var _this$context$getAtla = _this.context.getAtlaskitAnalyticsContext, getAtlaskitAnalyticsContext = _this$context$getAtla === void 0 ? $75a63728423923c4$var$noop : _this$context$getAtla;
            return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($eetQ9)))(getAtlaskitAnalyticsContext()), [
                data
            ]);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))((0, (/*@__PURE__*/$parcel$interopDefault($hgJzq)))(_this), "getAnalyticsEventHandlers", function() {
            var _this$context$getAtla2 = _this.context.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _this$context$getAtla2 === void 0 ? $75a63728423923c4$var$noop : _this$context$getAtla2;
            return getAtlaskitAnalyticsEventHandlers();
        });
        _this.contextValue = {
            getAtlaskitAnalyticsContext: _this.getAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers
        };
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($2Yk1N)))(AnalyticsContext, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $3z3zk.default).Provider, {
                    value: this.contextValue
                }, children);
            }
        }
    ]);
    return AnalyticsContext;
}((0, $1Mpn7.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))($75a63728423923c4$var$AnalyticsContext, "contextTypes", $75a63728423923c4$var$ContextTypes);
(0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))($75a63728423923c4$var$AnalyticsContext, "childContextTypes", $75a63728423923c4$var$ContextTypes);
var $75a63728423923c4$export$2e2bcd8739ae039 = $75a63728423923c4$var$AnalyticsContext;

});
parcelRegister("eetQ9", function(module, exports) {

var $fjSDx = parcelRequire("fjSDx");

var $emE50 = parcelRequire("emE50");

var $3JoOw = parcelRequire("3JoOw");

var $7t4xL = parcelRequire("7t4xL");
function $a5c9851d9c34881c$var$_toConsumableArray(arr) {
    return $fjSDx(arr) || $emE50(arr) || $3JoOw(arr) || $7t4xL();
}
module.exports = $a5c9851d9c34881c$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("fjSDx", function(module, exports) {

var $1QrN4 = parcelRequire("1QrN4");
function $b2730319597c4527$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $1QrN4(arr);
}
module.exports = $b2730319597c4527$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("1QrN4", function(module, exports) {
function $1580346427754cac$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
module.exports = $1580346427754cac$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("emE50", function(module, exports) {
function $a75235c5a244f8e4$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
module.exports = $a75235c5a244f8e4$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("3JoOw", function(module, exports) {

var $1QrN4 = parcelRequire("1QrN4");
function $2b78d29c482a090c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1QrN4(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1QrN4(o, minLen);
}
module.exports = $2b78d29c482a090c$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("7t4xL", function(module, exports) {
function $56fec417f2d1e494$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $56fec417f2d1e494$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("6QU8A", function(module, exports) {
function $4fd325244885d8ed$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $4fd325244885d8ed$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("2Yk1N", function(module, exports) {

var $53r23 = parcelRequire("53r23");
function $22a0b8864b2a20e1$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $53r23(descriptor.key), descriptor);
    }
}
function $22a0b8864b2a20e1$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $22a0b8864b2a20e1$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $22a0b8864b2a20e1$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
module.exports = $22a0b8864b2a20e1$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("53r23", function(module, exports) {

var $2nffd = parcelRequire("2nffd");
var $3ae2339789af7f0c$var$_typeof = $2nffd.default;

var $a5ZpV = parcelRequire("a5ZpV");
function $3ae2339789af7f0c$var$_toPropertyKey(arg) {
    var key = $a5ZpV(arg, "string");
    return $3ae2339789af7f0c$var$_typeof(key) === "symbol" ? key : String(key);
}
module.exports = $3ae2339789af7f0c$var$_toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("2nffd", function(module, exports) {
function $1ba98e0025765fea$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $1ba98e0025765fea$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $1ba98e0025765fea$var$_typeof(o);
}
module.exports = $1ba98e0025765fea$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("a5ZpV", function(module, exports) {

var $2nffd = parcelRequire("2nffd");
var $759a032db56b9f84$var$_typeof = $2nffd.default;
function $759a032db56b9f84$var$_toPrimitive(input, hint) {
    if ($759a032db56b9f84$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($759a032db56b9f84$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
module.exports = $759a032db56b9f84$var$_toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("hgJzq", function(module, exports) {
function $c92747a1c3295053$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
module.exports = $c92747a1c3295053$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("eZhUW", function(module, exports) {

var $iQaLx = parcelRequire("iQaLx");
function $ae94a93b0ac65ad5$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $iQaLx(subClass, superClass);
}
module.exports = $ae94a93b0ac65ad5$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("iQaLx", function(module, exports) {
function $db756f27e79cc3fb$var$_setPrototypeOf(o, p) {
    module.exports = $db756f27e79cc3fb$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $db756f27e79cc3fb$var$_setPrototypeOf(o, p);
}
module.exports = $db756f27e79cc3fb$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("kcuts", function(module, exports) {

var $2nffd = parcelRequire("2nffd");
var $eb4c912340acb076$var$_typeof = $2nffd.default;

var $hgJzq = parcelRequire("hgJzq");
function $eb4c912340acb076$var$_possibleConstructorReturn(self, call) {
    if (call && ($eb4c912340acb076$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $hgJzq(self);
}
module.exports = $eb4c912340acb076$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("6pDhi", function(module, exports) {
function $4ab38ba4bb7cac66$var$_getPrototypeOf(o) {
    module.exports = $4ab38ba4bb7cac66$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $4ab38ba4bb7cac66$var$_getPrototypeOf(o);
}
module.exports = $4ab38ba4bb7cac66$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("jjExS", function(module, exports) {

var $53r23 = parcelRequire("53r23");
function $e0ff3e210908ac38$var$_defineProperty(obj, key, value) {
    key = $53r23(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
module.exports = $e0ff3e210908ac38$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("3shKn", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2841c0d1fd2d84b2$var$ReactIs, $2841c0d1fd2d84b2$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("lhKOp"))();

});
parcelRegister("lhKOp", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $ft9MD = parcelRequire("ft9MD");
function $f7ef7f6c6a1361b9$var$emptyFunction() {}
function $f7ef7f6c6a1361b9$var$emptyFunctionWithReset() {}
$f7ef7f6c6a1361b9$var$emptyFunctionWithReset.resetWarningCache = $f7ef7f6c6a1361b9$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $ft9MD) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $f7ef7f6c6a1361b9$var$emptyFunctionWithReset,
        resetWarningCache: $f7ef7f6c6a1361b9$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("ft9MD", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $02e804c301ba604b$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $02e804c301ba604b$var$ReactPropTypesSecret;

});



parcelRegister("3z3zk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $298768b09ad29b08$export$2e2bcd8739ae039; });

var $bV06D = parcelRequire("bV06D");
var $298768b09ad29b08$export$2e2bcd8739ae039 = (0, $bV06D.default);

});
parcelRegister("bV06D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ad5199bc83f19f2$export$2e2bcd8739ae039; });

var $1Mpn7 = parcelRequire("1Mpn7");
var $8ad5199bc83f19f2$var$AnalyticsNextContext = (0, $1Mpn7.createContext)({
    getAtlaskitAnalyticsContext: function getAtlaskitAnalyticsContext() {
        return [];
    },
    getAtlaskitAnalyticsEventHandlers: function getAtlaskitAnalyticsEventHandlers() {
        return [];
    }
});
var $8ad5199bc83f19f2$export$2e2bcd8739ae039 = $8ad5199bc83f19f2$var$AnalyticsNextContext;

});



parcelRegister("a0AXg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $749691ec99332b8e$export$2e2bcd8739ae039; });

var $eetQ9 = parcelRequire("eetQ9");

var $1Mpn7 = parcelRequire("1Mpn7");

var $3z3zk = parcelRequire("3z3zk");

var $gVJ1N = parcelRequire("gVJ1N");

var $8JCSe = parcelRequire("8JCSe");
var $749691ec99332b8e$var$AnalyticsContext = function AnalyticsContext(_ref) {
    var data = _ref.data, children = _ref.children;
    var dataRef = (0, $8JCSe.useTrackedRef)(data);
    var analyticsContext = (0, $gVJ1N.useAnalyticsContext)();
    var getAtlaskitAnalyticsContext = (0, $1Mpn7.useCallback)(function() {
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($eetQ9)))(analyticsContext.getAtlaskitAnalyticsContext()), [
            dataRef.current
        ]);
    }, [
        analyticsContext,
        dataRef
    ]);
    var value = (0, $1Mpn7.useMemo)(function() {
        return {
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: analyticsContext.getAtlaskitAnalyticsEventHandlers
        };
    }, [
        analyticsContext,
        getAtlaskitAnalyticsContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $3z3zk.default).Provider, {
        value: value
    }, children);
};
var $749691ec99332b8e$export$2e2bcd8739ae039 = $749691ec99332b8e$var$AnalyticsContext;

});
parcelRegister("gVJ1N", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $c534e5d929f78bff$export$d1f587f82ad51c4; });

var $1Mpn7 = parcelRequire("1Mpn7");

var $3z3zk = parcelRequire("3z3zk");
var $c534e5d929f78bff$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $1Mpn7.useContext)((0, $3z3zk.default));
};

});

parcelRegister("8JCSe", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $65c0ae30ae212827$export$1d27a74659855e44; });

var $1Mpn7 = parcelRequire("1Mpn7");
var $65c0ae30ae212827$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $1Mpn7.useRef)(value);
    (0, $1Mpn7.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
};

});




parcelRegister("Ip8Id", function(module, exports) {

$parcel$export(module.exports, "initAnalyticsWebClient", function () { return $3e9c48b65544ebf2$export$bb0df2ec3a6c8120; });
// import OriginTracing from "@atlassiansox/origin-tracing";

var $5pHLF = parcelRequire("5pHLF");

var $iNfkJ = parcelRequire("iNfkJ");
var $3e9c48b65544ebf2$export$bb0df2ec3a6c8120 = function() {
    var internalClientInitialised;
    if (!window.analyticsWebClient) {
        var _window_analyticsWebClient;
        window.analyticsWebClient = new (0, $iNfkJ.default)();
        internalClientInitialised = (_window_analyticsWebClient = window.analyticsWebClient) === null || _window_analyticsWebClient === void 0 ? void 0 : _window_analyticsWebClient.init();
    } else internalClientInitialised = !!window.analyticsWebClient.getInstance();
    var _window_analyticsWebClient1;
    (0, $5pHLF.resolveAnalyticsWebClientPromise)((_window_analyticsWebClient1 = window.analyticsWebClient) !== null && _window_analyticsWebClient1 !== void 0 ? _window_analyticsWebClient1 : undefined);
    return internalClientInitialised;
};
var $3e9c48b65544ebf2$export$e9ba7ef9458d1a4a = function() {
    return window.analyticsWebClient;
};

});
parcelRegister("5pHLF", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsWebClientPromise", function () { return $e6de15b0901eeb7d$export$799525ac94ca811d; });
$parcel$export(module.exports, "resolveAnalyticsWebClientPromise", function () { return $e6de15b0901eeb7d$export$2b194038750b3976; });
var $e6de15b0901eeb7d$var$markAnalyticsClientAsReady;
var $e6de15b0901eeb7d$var$analyticsClientPromise = new Promise(function(resolve) {
    $e6de15b0901eeb7d$var$markAnalyticsClientAsReady = resolve;
});
var $e6de15b0901eeb7d$export$799525ac94ca811d = function() {
    return $e6de15b0901eeb7d$var$analyticsClientPromise;
};
var $e6de15b0901eeb7d$export$2b194038750b3976 = function(client) {
    return $e6de15b0901eeb7d$var$markAnalyticsClientAsReady(client);
};

});

parcelRegister("iNfkJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f195f099dd0a407$export$2e2bcd8739ae039; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $d4yn6 = parcelRequire("d4yn6");

var $80gKw = parcelRequire("80gKw");

var $ltZfO = parcelRequire("ltZfO");

var $88tu2 = parcelRequire("88tu2");

var $d4mMe = parcelRequire("d4mMe");
var $7wB6S = parcelRequire("7wB6S");
var $22Iz2 = parcelRequire("22Iz2");
var $4f195f099dd0a407$var$getEnvironment = function() {
    return (0, $22Iz2.envType).PROD;
};
var $4f195f099dd0a407$var$shouldUseStargate = function() {
    return true;
};
var $4f195f099dd0a407$var$getAtlassianUserId = function() {
    var userId = (0, $88tu2.Cookie).readCookie("__aid_user_id");
    if (userId) return decodeURIComponent(userId);
    return null;
};
var $4f195f099dd0a407$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function DefaultAnalyticsWebClient() {
        (0, $4GJKx._)(this, DefaultAnalyticsWebClient);
    }
    (0, $1wc17._)(DefaultAnalyticsWebClient, [
        {
            key: "resetBlockingDuration",
            value: function resetBlockingDuration() {
                this.eventCount = 0;
                this.blockingDuration = 0;
            }
        },
        {
            key: "init",
            value: // CHANGED
            function init() {
                var start = performance.now();
                this.analyticsClient = new (0, $7wB6S.default)({
                    env: $4f195f099dd0a407$var$getEnvironment(),
                    product: "marketing",
                    version: "1.0.0",
                    origin: (0, $22Iz2.originType).WEB,
                    locale: "en-us"
                }, {
                    useStargate: $4f195f099dd0a407$var$shouldUseStargate(),
                    delayQueueCompressors: [
                        new (0, $d4mMe.CompressionRule)((0, $d4yn6.canCompress), (0, $d4yn6.buildCompressionFunction)(50))
                    ]
                });
                if (!this.analyticsClient) return false;
                var aaid = $4f195f099dd0a407$var$getAtlassianUserId();
                if (aaid) this.analyticsClient.setUserInfo((0, $22Iz2.userType).ATLASSIAN_ACCOUNT, aaid);
                // Set init time
                this.initTime = performance.now() - start;
                return true;
            }
        },
        {
            key: "sendEvent",
            value: function sendEvent(event) {
                if ((0, $ltZfO.isAnalyticsEvent)(event)) {
                    var type = event.type, payload = event.payload;
                    var start = performance.now();
                    switch(type){
                        case 0, $80gKw.UI_EVENT_TYPE:
                            this.analyticsClient.sendUIEvent(payload);
                            break;
                        case 0, $80gKw.TRACK_EVENT_TYPE:
                            this.analyticsClient.sendTrackEvent(payload);
                            break;
                        case 0, $80gKw.OPERATIONAL_EVENT_TYPE:
                            this.analyticsClient.sendOperationalEvent(payload);
                            break;
                        case 0, $80gKw.SCREEN_EVENT_TYPE:
                            this.analyticsClient.sendScreenEvent(payload);
                            break;
                        default:
                            break;
                    }
                    // Increment the blocking duration
                    this.blockingDuration += performance.now() - start;
                    this.eventCount += 1;
                }
            }
        },
        {
            key: "getInstance",
            value: function getInstance() {
                return this.analyticsClient;
            }
        }
    ]);
    return DefaultAnalyticsWebClient;
}();

});
parcelRegister("d4yn6", function(module, exports) {

$parcel$export(module.exports, "canCompress", function () { return $98464f8fbae57cf2$export$ec3662f84d9f778c; });
$parcel$export(module.exports, "buildCompressionFunction", function () { return $98464f8fbae57cf2$export$20de0576abb0bcc5; });

var $jjExS = parcelRequire("jjExS");
function $98464f8fbae57cf2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $98464f8fbae57cf2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $98464f8fbae57cf2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $98464f8fbae57cf2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $98464f8fbae57cf2$export$ec3662f84d9f778c = function canCompress(event) {
    return event.actionSubject === "feature" && event.action === "exposed" && event.eventType === "operational" && event.attributes && event.tags && event.tags.includes("measurement") && !event.tags.includes("hasCustomAttributes");
};
var $98464f8fbae57cf2$export$ca25d5d7792a4f37 = function compressor(events) {
    var batchSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
    if (!events || events.length <= 0) return [];
    if (batchSize <= 0) throw new Error("Batch size must be greater than 0");
    // Extract evaluations and reduce into a single array
    var flagEvaluations = events.map(function(currentEvent) {
        var _currentEvent$attribu = currentEvent.attributes, flagKey = _currentEvent$attribu.flagKey, value = _currentEvent$attribu.value, reason = _currentEvent$attribu.reason, ruleId = _currentEvent$attribu.ruleId, errorKind = _currentEvent$attribu.errorKind;
        return $98464f8fbae57cf2$var$_objectSpread($98464f8fbae57cf2$var$_objectSpread($98464f8fbae57cf2$var$_objectSpread({
            key: flagKey,
            value: value
        }, reason && {
            reason: reason
        }), ruleId && {
            ruleId: ruleId
        }), errorKind && {
            errorKind: errorKind
        });
    });
    // Batch evaluations into specified batchSize
    return $98464f8fbae57cf2$var$createBatches(flagEvaluations, batchSize);
};
var $98464f8fbae57cf2$var$createBatches = function createBatches(array, batchSize) {
    var compressedEvaluations = [];
    for(var i = 0; i < array.length; i += batchSize){
        var evaluationBatch = array.slice(i, i + batchSize);
        compressedEvaluations.push({
            actionSubject: "features",
            action: "exposed",
            eventType: "operational",
            attributes: {
                evaluations: evaluationBatch
            },
            tags: [
                "measurement"
            ],
            source: "@atlassian/exposure-events-compressor"
        });
    }
    return compressedEvaluations;
};
var $98464f8fbae57cf2$export$20de0576abb0bcc5 = function buildCompressionFunction(batchSize) {
    return function(events) {
        return $98464f8fbae57cf2$export$ca25d5d7792a4f37(events, batchSize);
    };
};

});

parcelRegister("80gKw", function(module, exports) {

$parcel$export(module.exports, "UI_EVENT_TYPE", function () { return $70578b775b00766a$export$a1562d08625f5d7e; });
$parcel$export(module.exports, "TRACK_EVENT_TYPE", function () { return $70578b775b00766a$export$947dac6c72b26f81; });
$parcel$export(module.exports, "SCREEN_EVENT_TYPE", function () { return $70578b775b00766a$export$f1d537d508d2945a; });
$parcel$export(module.exports, "OPERATIONAL_EVENT_TYPE", function () { return $70578b775b00766a$export$12346a674644c156; });
// SCREENS
var $70578b775b00766a$export$f636b5b56f1d624a = "Screen";
var $70578b775b00766a$export$9d2de6eebf7462b5 = "Drawer";
var $70578b775b00766a$export$1171103ea9083ffa = "Modal";
var $70578b775b00766a$export$cae2783c9279926 = "InlineDialog";
var $70578b775b00766a$export$d1123261ca8831d2 = "Dropdown";
var $70578b775b00766a$export$238d30785c4bca84 = "Banner";
var $70578b775b00766a$export$a1562d08625f5d7e = "UI";
var $70578b775b00766a$export$947dac6c72b26f81 = "TRACK";
var $70578b775b00766a$export$f1d537d508d2945a = "SCREEN";
var $70578b775b00766a$export$12346a674644c156 = "OPERATIONAL";

});

parcelRegister("ltZfO", function(module, exports) {

$parcel$export(module.exports, "isAnalyticsEvent", function () { return $c52019e0715c6a7a$export$ad4be5c2ec28cecf; });
var $c52019e0715c6a7a$export$2bace62c90203a60 = [
    "SCREEN",
    "UI",
    "TRACK",
    "OPERATIONAL"
];
var $c52019e0715c6a7a$export$ad4be5c2ec28cecf = function(value) {
    return typeof value === "object" && value !== null && "type" in value && typeof value.type === "string" && $c52019e0715c6a7a$export$2bace62c90203a60.includes(value.type);
};

});

parcelRegister("88tu2", function(module, exports) {

$parcel$export(module.exports, "Cookie", function () { return $03b61151d2fc6d11$export$bd0cf18531183c14; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");
var $03b61151d2fc6d11$export$bd0cf18531183c14 = /*#__PURE__*/ function() {
    "use strict";
    function Cookie() {
        (0, $4GJKx._)(this, Cookie);
    }
    (0, $1wc17._)(Cookie, null, [
        {
            key: "getCookieUrl",
            value: function getCookieUrl(cookieName, defaultUrl) {
                var cookieUrl = Cookie.readCookie(cookieName);
                if (cookieUrl !== null) return cookieUrl;
                return defaultUrl;
            }
        },
        {
            key: "readCookie",
            value: function readCookie(name) {
                try {
                    var nameEQ = name + "=";
                    var ca = document.cookie.split(";");
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = ca[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var c = _step.value;
                            while(c.startsWith(" "))c = c.substring(1, c.length);
                            if (c.startsWith(nameEQ)) return c.substring(nameEQ.length, c.length);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                } catch (e) {
                    // Helpers.sendWrapperLoadError uses this method to get some context
                    // for the reported error, so we don't want to call that here, otherwise
                    // we would get stuck in an infinite loop
                    console.warn("Error reading cookie - ".concat(name), e);
                }
                return null;
            }
        },
        {
            key: "writeCookie",
            value: function writeCookie(name, value, days, topLevelDomain) {
                var seconds = days ? days * 86400 : null;
                Cookie.writeCookieInSeconds(name, value, seconds, topLevelDomain);
            }
        },
        {
            key: "writeCookieInSeconds",
            value: function writeCookieInSeconds(name, value, seconds, topLevelDomain) {
                try {
                    var expires = "";
                    if (seconds) {
                        var date = new Date();
                        date.setTime(date.getTime() + seconds * 1000);
                        expires = "; expires=" + date.toUTCString();
                    }
                    var cookie = name + "=" + value + expires + "; path=/;";
                    var domain = window.location.hostname;
                    if (domain !== "localhost" && topLevelDomain) {
                        var domainTokens = domain.split(".");
                        if (domainTokens.length > 1) {
                            var lastToken = domainTokens[domainTokens.length - 1];
                            var secondLastToken = domainTokens[domainTokens.length - 2];
                            if (isNaN(Number(lastToken)) || isNaN(Number(secondLastToken))) domain = "." + secondLastToken + "." + lastToken;
                        }
                        cookie += " domain=" + domain + ";";
                    }
                    document.cookie = cookie;
                } catch (e) {
                    console.warn("Error writing cookie - ".concat(name), e);
                }
            }
        }
    ]);
    return Cookie;
}();

});

parcelRegister("d4mMe", function(module, exports) {

$parcel$export(module.exports, "CompressionRule", function () { return $983d5121f37adc47$export$89b3253ddfd2e6e8; });

var $4GJKx = parcelRequire("4GJKx");

var $cv9Rk = parcelRequire("cv9Rk");

var $jjExS = parcelRequire("jjExS");

var $hGIZ8 = parcelRequire("hGIZ8");

var $9kC89 = parcelRequire("9kC89");
var $983d5121f37adc47$export$89b3253ddfd2e6e8 = function CompressionRule(predicate, compressFn) {
    "use strict";
    var _this = this;
    (0, $4GJKx._)(this, CompressionRule);
    /**
     * This function returns a flag indicating whether or not this instance is capable of compressing the given event.
     * @param event
     * @returns {boolean}
     */ (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "canCompress", function(event) {
        try {
            return event && (0, $hGIZ8.isActionEventType)(event.eventType) && _this.predicate(event);
        } catch (e) {
            return false;
        }
    });
    /**
     * This function compresses as many events in the given collection as possible.<p>
     * Any events in the given collection that do not match the conditions of {@link canCompress} will be left uncompressed and
     * appended to the end of the resulting array.
     *
     * @param events A collection of analytic events to compress
     * @returns {Array.<Object>} The action fields for the resulting compressed events
     */ (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "compress", function(events) {
        var _partition = (0, $cv9Rk._)((0, $9kC89.partition)(events, function(event) {
            return _this.canCompress(event);
        }), 2), compatibleEvents = _partition[0], incompatibleEvents = _partition[1];
        var compressedEvents = _this.compressFn(compatibleEvents);
        if (!compressedEvents) throw new Error("No events were returned from the compression function");
        compressedEvents.forEach(function(event) {
            (0, $hGIZ8.validateActionEventType)(event.eventType);
            (0, $hGIZ8.validateActionEvent)(event);
        });
        return compressedEvents.concat(incompatibleEvents);
    });
    if (typeof predicate !== "function") throw new Error("Invalid predicate, must be a function that accepts an event and returns a boolean");
    if (typeof compressFn !== "function") throw new Error("Invalid compressFn, must be a function that both accepts and returns an array of events");
    this.predicate = predicate;
    this.compressFn = compressFn;
};

});
parcelRegister("hGIZ8", function(module, exports) {

$parcel$export(module.exports, "validateContainers", function () { return $ce0940fca92b809a$export$e63ea5d8477971d3; });
$parcel$export(module.exports, "isActionEventType", function () { return $ce0940fca92b809a$export$d19cebda16f7579a; });
$parcel$export(module.exports, "validateActionEventType", function () { return $ce0940fca92b809a$export$4a8d7476662aebcc; });
$parcel$export(module.exports, "validateActionEvent", function () { return $ce0940fca92b809a$export$e0c121325c66ed4c; });
$parcel$export(module.exports, "validateScreenEvent", function () { return $ce0940fca92b809a$export$dc993432a592dc27; });
$parcel$export(module.exports, "validateTrackEvent", function () { return $ce0940fca92b809a$export$8c014fd74b0c8b99; });
$parcel$export(module.exports, "validateDwellBaseEvent", function () { return $ce0940fca92b809a$export$39d6334da9a44984; });
$parcel$export(module.exports, "validateUIEvent", function () { return $ce0940fca92b809a$export$e5bac0930c812e90; });
$parcel$export(module.exports, "validateOperationalEvent", function () { return $ce0940fca92b809a$export$1e561554275607ef; });
$parcel$export(module.exports, "validateIdentifyEvent", function () { return $ce0940fca92b809a$export$c16a4e16aa4026c0; });
$parcel$export(module.exports, "validatePlatform", function () { return $ce0940fca92b809a$export$801b46c35394d316; });

var $22Iz2 = parcelRequire("22Iz2");

var $bnlwi = parcelRequire("bnlwi");
var $ce0940fca92b809a$var$actionEventTypes = Object.freeze([
    (0, $22Iz2.eventType).OPERATIONAL,
    (0, $22Iz2.eventType).TRACK,
    (0, $22Iz2.eventType).UI
]);
function $ce0940fca92b809a$export$df8ff30e3c960006(container) {
    if (!(0, $bnlwi.isPlainObject)(container)) throw new Error("properties.containers must be an Object");
    if (!("id" in container)) throw new Error("properties.containers is missing field 'id'");
    if (typeof container.id !== "string") throw new Error("properties.containers.id must be of type String");
    if ("type" in container && typeof container.type !== "string") throw new Error("properties.containers.type must be of type String");
}
function $ce0940fca92b809a$export$e63ea5d8477971d3(containers) {
    if (!containers) return;
    if (containers && containers.constructor !== Object) throw new Error("properties.containers must be an Object");
    Object.values(containers).forEach(function(container) {
        return $ce0940fca92b809a$export$df8ff30e3c960006(container);
    });
}
function $ce0940fca92b809a$export$d19cebda16f7579a(type) {
    switch(type){
        case (0, $22Iz2.eventType).OPERATIONAL:
        case (0, $22Iz2.eventType).TRACK:
        case (0, $22Iz2.eventType).UI:
            return true;
        default:
            return false;
    }
}
function $ce0940fca92b809a$export$4a8d7476662aebcc(type) {
    if (!$ce0940fca92b809a$export$d19cebda16f7579a(type)) throw new Error("Invalid action event type: ".concat(type, ", must be one of: [").concat($ce0940fca92b809a$var$actionEventTypes, "]"));
    return true;
}
function $ce0940fca92b809a$export$e0c121325c66ed4c(event) {
    if (!event) throw new Error("Missing event");
    if (!event.source) throw new Error("Missing event.source");
    if (!event.actionSubject) throw new Error("Missing event.actionSubject");
    if (!event.action) throw new Error("Missing event.action");
    $ce0940fca92b809a$export$e63ea5d8477971d3(event.containers);
}
function $ce0940fca92b809a$export$dc993432a592dc27(name) {
    if (!name) throw new Error("Missing name");
}
function $ce0940fca92b809a$export$8c014fd74b0c8b99(event) {
    $ce0940fca92b809a$export$e0c121325c66ed4c(event);
}
function $ce0940fca92b809a$export$39d6334da9a44984(event) {
    if (!event) throw new Error("Missing event");
    if (!event.source) throw new Error("Missing event.source");
    if (!event.actionSubject) throw new Error("Missing event.actionSubject");
}
function $ce0940fca92b809a$export$e5bac0930c812e90(event) {
    $ce0940fca92b809a$export$e0c121325c66ed4c(event);
}
function $ce0940fca92b809a$export$1e561554275607ef(event) {
    $ce0940fca92b809a$export$e0c121325c66ed4c(event);
}
function $ce0940fca92b809a$export$c16a4e16aa4026c0(userIdType, userId) {
    if (!userIdType) throw new Error("Missing userIdType");
    if (!userId) throw new Error("Missing userId");
    if (!(0, $22Iz2.isType)((0, $22Iz2.userType), userIdType)) throw new Error("Invalid userIdType '".concat(userIdType, "', ") + "must be an userType: [".concat((0, $22Iz2.objectValues)((0, $22Iz2.userType)), "]"));
}
function $ce0940fca92b809a$export$801b46c35394d316(productInfo) {
    if (!(0, $22Iz2.isType)((0, $22Iz2.platformType), productInfo.platform)) throw new Error("Invalid productInfo.platform '".concat(productInfo.platform, "', ") + "must be a platformType: [".concat((0, $22Iz2.objectValues)((0, $22Iz2.platformType)), "]"));
    if (productInfo.origin === (0, $22Iz2.originType).DESKTOP && !(0, $22Iz2.isType)((0, $22Iz2.desktopPlatforms), productInfo.platform)) throw new Error("Invalid productInfo.platform '".concat(productInfo.platform, "', ") + "must be one of [mac, linux, windows]");
    if (productInfo.origin === (0, $22Iz2.originType).WEB && !(0, $22Iz2.isType)((0, $22Iz2.webPlatforms), productInfo.platform)) throw new Error("Invalid productInfo.platform '".concat(productInfo.platform, "', must be one of [web, mobileWeb]"));
}

});
parcelRegister("22Iz2", function(module, exports) {

$parcel$export(module.exports, "envType", function () { return $17ce5634d114eac5$export$56ac8ebc9870b1b9; });
$parcel$export(module.exports, "eventType", function () { return $17ce5634d114eac5$export$4c045e605d532c98; });
$parcel$export(module.exports, "platformType", function () { return $17ce5634d114eac5$export$6b4f396210e539f3; });
$parcel$export(module.exports, "originType", function () { return $17ce5634d114eac5$export$f73e9fcd368bb695; });
$parcel$export(module.exports, "tenantType", function () { return $17ce5634d114eac5$export$496f06ac2a964da2; });
$parcel$export(module.exports, "userType", function () { return $17ce5634d114eac5$export$1827adfd178b4870; });
$parcel$export(module.exports, "apdexType", function () { return $17ce5634d114eac5$export$99b37380a464d794; });
$parcel$export(module.exports, "desktopPlatforms", function () { return $17ce5634d114eac5$export$809831be6c4c6227; });
$parcel$export(module.exports, "webPlatforms", function () { return $17ce5634d114eac5$export$19c579398ad213e7; });
$parcel$export(module.exports, "originTracingType", function () { return $17ce5634d114eac5$export$62a500c02dc63ee; });
$parcel$export(module.exports, "objectValues", function () { return $17ce5634d114eac5$export$ad1854f4a08c15f8; });
$parcel$export(module.exports, "isType", function () { return $17ce5634d114eac5$export$26b9f946b448f23e; });
$parcel$export(module.exports, "perimeterType", function () { return $17ce5634d114eac5$export$bdd41749d2096e4b; });
// These types have been converted from frozen objects to enums.
// We cannot change their name, or even capitalise them without breaking API.
var $17ce5634d114eac5$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["LOCAL"] = "local";
    envType["DEV"] = "dev";
    envType["STAGING"] = "staging";
    envType["PROD"] = "prod";
    return envType;
}({});
var $17ce5634d114eac5$export$4c045e605d532c98 = /*#__PURE__*/ function(eventType) {
    eventType["TRACK"] = "track";
    eventType["UI"] = "ui";
    eventType["OPERATIONAL"] = "operational";
    eventType["SCREEN"] = "screen";
    eventType["IDENTIFY"] = "identify";
    return eventType;
}({});
var $17ce5634d114eac5$export$6b4f396210e539f3 = /*#__PURE__*/ function(platformType) {
    platformType["MAC"] = "mac";
    platformType["LINUX"] = "linux";
    platformType["WINDOWS"] = "windows";
    platformType["DESKTOP"] = "desktop";
    platformType["WEB"] = "web";
    platformType["MOBILE_WEB"] = "mobileWeb";
    return platformType;
}({});
var $17ce5634d114eac5$export$f73e9fcd368bb695 = /*#__PURE__*/ function(originType) {
    originType["DESKTOP"] = "desktop";
    originType["WEB"] = "web";
    return originType;
}({});
var $17ce5634d114eac5$export$496f06ac2a964da2 = /*#__PURE__*/ function(tenantType) {
    tenantType["CLOUD_ID"] = "cloudId";
    tenantType["ORG_ID"] = "orgId";
    tenantType["OPSGENIE_CUSTOMER_ID"] = "opsgenieCustomerId";
    tenantType["HALP_TEAM_ID"] = "halpTeamId";
    tenantType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    tenantType["TRELLO_WORKSPACE_ID"] = "trelloWorkspaceId";
    tenantType["NONE"] = "none";
    return tenantType;
}({});
var $17ce5634d114eac5$export$1827adfd178b4870 = /*#__PURE__*/ function(userType) {
    userType["ATLASSIAN_ACCOUNT"] = "atlassianAccount";
    userType["HASHED_EMAIL"] = "hashedEmail";
    userType["TRELLO"] = "trello";
    userType["OPSGENIE"] = "opsgenie";
    userType["HALP"] = "halp";
    return userType;
}({});
var $17ce5634d114eac5$export$99b37380a464d794 = /*#__PURE__*/ function(apdexType) {
    apdexType["TRANSITION"] = "transition";
    apdexType["INITIAL_LOAD"] = "initialLoad";
    return apdexType;
}({});
var $17ce5634d114eac5$export$809831be6c4c6227 = Object.freeze([
    $17ce5634d114eac5$export$6b4f396210e539f3.DESKTOP,
    $17ce5634d114eac5$export$6b4f396210e539f3.MAC,
    $17ce5634d114eac5$export$6b4f396210e539f3.LINUX,
    $17ce5634d114eac5$export$6b4f396210e539f3.WINDOWS
]);
var $17ce5634d114eac5$export$19c579398ad213e7 = Object.freeze([
    $17ce5634d114eac5$export$6b4f396210e539f3.WEB,
    $17ce5634d114eac5$export$6b4f396210e539f3.MOBILE_WEB
]);
var $17ce5634d114eac5$export$62a500c02dc63ee = /*#__PURE__*/ function(originTracingType) {
    originTracingType["ATL_ORIGIN"] = "atlOrigin";
    return originTracingType;
}({});
function $17ce5634d114eac5$export$ad1854f4a08c15f8(object) {
    return Object.values(object);
}
function $17ce5634d114eac5$export$26b9f946b448f23e(type, value) {
    return Object.values(type).indexOf(value) > -1;
}
var $17ce5634d114eac5$export$bdd41749d2096e4b = /*#__PURE__*/ function(perimeterType) {
    perimeterType["C5"] = "c5";
    perimeterType["COMMERCIAL"] = "commercial";
    perimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    perimeterType["FEDRAMP_HIGH"] = "fedramp-high";
    return perimeterType;
}({});

});

parcelRegister("bnlwi", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $8482891bb802977c$export$53b83ca8eaab0383; });
// Modified from https://github.com/jonschlinkert/is-plain-object/blob/master/index.js
function $8482891bb802977c$var$isObject(val) {
    return val !== null && typeof val === "object" && Array.isArray(val) === false;
}
function $8482891bb802977c$var$isObjectObject(o) {
    return $8482891bb802977c$var$isObject(o) === true && Object.prototype.toString.call(o) === "[object Object]";
}
function $8482891bb802977c$export$53b83ca8eaab0383(o) {
    if ($8482891bb802977c$var$isObjectObject(o) === false) return false;
    // If has modified constructor
    var ctor = o.constructor;
    if (typeof ctor !== "function") return false;
    // If has modified prototype
    var prot = ctor.prototype;
    if ($8482891bb802977c$var$isObjectObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (!("isPrototypeOf" in prot)) return false;
    // Most likely a plain Object
    return true;
}

});


parcelRegister("9kC89", function(module, exports) {

$parcel$export(module.exports, "mapKeys", function () { return $6cb38f41250c2d06$export$781522908e4e76a1; });
$parcel$export(module.exports, "pick", function () { return $6cb38f41250c2d06$export$357523c63a2253b9; });
$parcel$export(module.exports, "omitBy", function () { return $6cb38f41250c2d06$export$d7a617dda645b4e3; });
$parcel$export(module.exports, "pickBy", function () { return $6cb38f41250c2d06$export$b460b275d6c6aa0; });
$parcel$export(module.exports, "omit", function () { return $6cb38f41250c2d06$export$30a06c8d3562193f; });
$parcel$export(module.exports, "equals", function () { return $6cb38f41250c2d06$export$e9bab7fafb253603; });
$parcel$export(module.exports, "partition", function () { return $6cb38f41250c2d06$export$b29f828819edca8d; });
/* eslint-disable no-return-assign, no-sequences */ // https://www.30secondsofcode.org/js/s/map-keys
var $6cb38f41250c2d06$export$781522908e4e76a1 = function(obj, fn) {
    return Object.keys(obj).reduce(function(acc, k) {
        var key = fn(obj[k], k, obj);
        acc[key] = obj[k];
        return acc;
    }, {});
};
// https://www.30secondsofcode.org/js/s/pick
var $6cb38f41250c2d06$export$357523c63a2253b9 = function(obj, arr) {
    return arr.reduce(function(acc, curr) {
        return curr in obj && (acc[curr] = obj[curr]), acc;
    }, {});
};
// https://www.30secondsofcode.org/js/s/omit-by
var $6cb38f41250c2d06$export$d7a617dda645b4e3 = function(obj, fn) {
    return Object.keys(obj).filter(function(k) {
        return !fn(obj[k], k);
    }).reduce(function(acc, key) {
        return acc[key] = obj[key], acc;
    }, {});
};
// https://www.30secondsofcode.org/js/s/pick-by
var $6cb38f41250c2d06$export$b460b275d6c6aa0 = function(obj, fn) {
    return Object.keys(obj).filter(function(k) {
        return fn(obj[k], k);
    }).reduce(function(acc, key) {
        return acc[key] = obj[key], acc;
    }, {});
};
// https://www.30secondsofcode.org/js/s/omit
var $6cb38f41250c2d06$export$30a06c8d3562193f = function(obj, arr) {
    return Object.keys(obj).filter(function(k) {
        return arr.indexOf(k) < 0;
    }).reduce(function(acc, key) {
        return acc[key] = obj[key], acc;
    }, {});
};
// https://www.30secondsofcode.org/js/s/equals
var $6cb38f41250c2d06$export$e9bab7fafb253603 = function(a, b) {
    if (a === b) return true;
    if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
    if (!a || !b || typeof a !== "object" && typeof b !== "object") return a === b;
    if (a.prototype !== b.prototype) return false;
    var keys = Object.keys(a);
    if (keys.length !== Object.keys(b).length) return false;
    return keys.every(function(k) {
        return $6cb38f41250c2d06$export$e9bab7fafb253603(a[k], b[k]);
    });
};
// https://www.30secondsofcode.org/js/s/partition
var $6cb38f41250c2d06$export$b29f828819edca8d = function(arr, fn) {
    return arr.reduce(// eslint-disable-next-line no-shadow
    function(acc, val, i, arr) {
        acc[fn(val, i, arr) ? 0 : 1].push(val);
        return acc;
    }, [
        [],
        []
    ]);
};

});


parcelRegister("7wB6S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57a84ed5054d22d2$export$2e2bcd8739ae039; });

var $4GJKx = parcelRequire("4GJKx");

var $c6Xmf = parcelRequire("c6Xmf");

var $jjExS = parcelRequire("jjExS");

var $ktzPa = parcelRequire("ktzPa");

var $22Iz2 = parcelRequire("22Iz2");

var $ckDXA = parcelRequire("ckDXA");

var $awX4D = parcelRequire("awX4D");

var $fXbpq = parcelRequire("fXbpq");

var $cV8xo = parcelRequire("cV8xo");

var $hGIZ8 = parcelRequire("hGIZ8");

var $lJWVG = parcelRequire("lJWVG");

var $aHFHo = parcelRequire("aHFHo");

var $4ZR7k = parcelRequire("4ZR7k");

var $jzYVM = parcelRequire("jzYVM");

var $kTmBT = parcelRequire("kTmBT");

var $f6Y6c = parcelRequire("f6Y6c");

var $1kGnl = parcelRequire("1kGnl");

var $6f3e8 = parcelRequire("6f3e8");

var $bJ204 = parcelRequire("bJ204");

var $gnvfh = parcelRequire("gnvfh");

var $5LQZZ = parcelRequire("5LQZZ");

var $29bQh = parcelRequire("29bQh");
function $57a84ed5054d22d2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $57a84ed5054d22d2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $57a84ed5054d22d2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $57a84ed5054d22d2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $57a84ed5054d22d2$var$PROD_HOST = "as.atlassian.com/api/v1";
var $57a84ed5054d22d2$var$STARGATE_PROD_HOST = "api-private.atlassian.com/gasv3/api/v1";
var $57a84ed5054d22d2$var$STAGING_HOST = "as.staging.atl-paas.net/api/v1";
var $57a84ed5054d22d2$var$STARGATE_STAGING_HOST = "api-private.stg.atlassian.com/gasv3/api/v1";
var $57a84ed5054d22d2$var$FEDRAMP_SANDBOX_HOST = "as.atlassian-fex.com/api/v1";
var $57a84ed5054d22d2$var$STARGATE_FEDRAMP_SANDBOX_HOST = "api-private.atlassian-fex.com/gasv3/api/v1";
var $57a84ed5054d22d2$export$5df9262e102d0c32 = "/gateway/api/gasv3/api/v1";
var $57a84ed5054d22d2$var$LAST_SCREEN_EVENT_STORAGE_KEY = "last.screen.event";
var $57a84ed5054d22d2$export$2e2bcd8739ae039 = function AnalyticsWebClient(productInfo) {
    "use strict";
    var settings = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _this = this;
    (0, $4GJKx._)(this, AnalyticsWebClient);
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_useStargate", function(useStargate) {
        if (useStargate == null) return true;
        return useStargate;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_selectHost", function(param) {
        var useStargate = param.useStargate, env = param.env, useLegacyUrl = param.useLegacyUrl, perimeter = param.perimeter;
        if (!useStargate) {
            if (perimeter === (0, $22Iz2.perimeterType).FEDRAMP_MODERATE && env === (0, $22Iz2.envType).STAGING) return $57a84ed5054d22d2$var$FEDRAMP_SANDBOX_HOST;
            return env === (0, $22Iz2.envType).PROD ? $57a84ed5054d22d2$var$PROD_HOST : $57a84ed5054d22d2$var$STAGING_HOST;
        }
        if (useLegacyUrl) {
            if (perimeter === (0, $22Iz2.perimeterType).FEDRAMP_MODERATE && env === (0, $22Iz2.envType).STAGING) return $57a84ed5054d22d2$var$STARGATE_FEDRAMP_SANDBOX_HOST;
            return env === (0, $22Iz2.envType).PROD ? $57a84ed5054d22d2$var$STARGATE_PROD_HOST : $57a84ed5054d22d2$var$STARGATE_STAGING_HOST;
        }
        /**
       * Stargate proxy path now needs to be the default to work around browser restrictions with cookies.
       * For more details, see:
       *  - https://experimentation-platform.atlassian.net/browse/MHD-326, and
       *  - https://hello.atlassian.net/wiki/spaces/I/pages/1217206437/api-private+is+broken+is+your+product+impacted
       */ return window.location.host + $57a84ed5054d22d2$export$5df9262e102d0c32;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_endsWith", function(str, suffix) {
        return str.indexOf(suffix, str.length - suffix.length) !== -1;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_changeInternalUserId", function(userId, anonymousId) {
        _this.eventProcessor.getUser().setUserId(userId);
        if (anonymousId && anonymousId !== _this.eventProcessor.getUser().getAnonymousId()) // Setting anonymous id can take a long time. Reading is a lot faster.
        // Only update if it has changed.
        _this.eventProcessor.getUser().setAnonymousId(anonymousId);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_createSubproductGetter", function(subproduct) {
        return (0, $awX4D.default)(subproduct, "Cannot get subproduct from the callback. Proceeding without it.");
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_createEmbeddedProductGetter", function(embeddedProduct) {
        return (0, $awX4D.default)(embeddedProduct, "Cannot get embeddedProduct from the callback. Proceeding without it.");
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_getLastScreenEvent", function() {
        try {
            return JSON.parse(_this._safeSessionStorage.getItem($57a84ed5054d22d2$var$LAST_SCREEN_EVENT_STORAGE_KEY) || "");
        } catch (err) {
            _this._safeSessionStorage.removeItem($57a84ed5054d22d2$var$LAST_SCREEN_EVENT_STORAGE_KEY);
            return null;
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_setLastScreenEvent", function(event) {
        _this._safeSessionStorage.setItem($57a84ed5054d22d2$var$LAST_SCREEN_EVENT_STORAGE_KEY, JSON.stringify({
            name: event.name,
            attributes: event.attributes
        }));
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_shouldEventBeDelayed", function(event) {
        // TODO: this is a temporary restriction for the purposes of the Track All Changes project
        // The delay mechanism has a chance of event loss, which we can only accept for our own data at this point.
        // Once the delay queue implementation has been improved and measured to confirm that it is reliable enough,
        // then we will be able to open it up for other products to use by removing this check.
        if (!event.tags || event.tags.indexOf("measurement") === -1) return false;
        var isEventHighPriority = event.highPriority !== false; // defaults to true if excluded
        return _this.eventDelayQueue.isDelayingLowPriorityEvents() && !isEventHighPriority;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_fireEvent", function(identifier, builtEvent, context, callback) {
        switch(builtEvent.eventType){
            case (0, $22Iz2.eventType).UI:
            case (0, $22Iz2.eventType).OPERATIONAL:
            case (0, $22Iz2.eventType).TRACK:
                return _this.eventProcessor.track(identifier, builtEvent, context, callback);
            case (0, $22Iz2.eventType).SCREEN:
                return _this.eventProcessor.page(identifier, builtEvent, context, callback);
            case (0, $22Iz2.eventType).IDENTIFY:
                return _this.eventProcessor.identify(identifier, builtEvent, context, callback);
            default:
                throw new Error("No handler has been defined for events of type ".concat(builtEvent.eventType));
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_fireDelayedEvent", function(identifier, builtEvent, context, userInfo) {
        try {
            // User information can change while the delay period is active, so we need to restore the values that
            // were active when the event was originally fired.
            _this._changeInternalUserId(userInfo.userId, userInfo.anonymousId);
            builtEvent.tags = (0, $c6Xmf._)(builtEvent.tags || []).concat([
                "sentWithDelay"
            ]);
            // The callbacks for delayed events are fired immediately, so there is nothing to pass through for this argument.
            _this._fireEvent(identifier, builtEvent, context, undefined);
        } finally{
            _this._changeInternalUserId(_this._userInfo.userId, _this._userInfo.anonymousId);
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_delayEvent", function(identifier, builtEvent, context, userInfo, callback) {
        _this.eventDelayQueue.push(identifier, builtEvent, context, userInfo);
        // Fire the callback immediately, as we can consider the event successfully processed at this point
        if (callback) callback();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_processEvent", function(identifier, builtEvent, context, callback) {
        _this._testingCache.saveEvent(builtEvent);
        if (_this._shouldEventBeDelayed(builtEvent)) {
            _this._delayEvent(identifier, builtEvent, context, _this._userInfo, callback);
            return Promise.resolve();
        } else return _this._fireEvent(identifier, builtEvent, context, callback);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "setEmbeddedProduct", function(embeddedProduct) {
        _this._productInfo.embeddedProduct = _this._createEmbeddedProductGetter(embeddedProduct);
        _this.resetUIViewedTimers();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "clearEmbeddedProduct", function() {
        _this._productInfo.embeddedProduct = _this._createEmbeddedProductGetter(null);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "setSubproduct", function(subproduct) {
        _this._productInfo.subproduct = _this._createSubproductGetter(subproduct);
        _this.resetUIViewedTimers();
    });
    /**
     * Calling this function in the intialisation of the client in product
     * captures specified 'origin tracing' URL params and fires a single origin landed event
     * <p>
     * This function expects a mapping between the keys for any URL parameters
     *  that should be captured and removed for origin tracing
     * Multiple parameters may be captured simultaneously if multiple key: handler function pairs are provided
     * Each handler function should return an object with two items
     * a) 'originTracingAttributes' - an object that will be added to the 'origin landed' event's attributes under 'originTracing
     * b) 'taskSessionId' (optional) - an Id string that will be added to the tasksessions for any event that fires from the tab, with the key
     *    matching the URL parameter, for the purpose of attributing subsequent analytics event to the origin land.
     * </p>
     * The general use case for this feature is for allowing attributation of user behaviour to a out of product or cross product link,
     * e.g. from a share or email
     *
     * An example calling this function using an external decoding library, with taskSessionId specified to persist
     * analyticsWebClient.setOriginTracingHandlers({
          atlOrigin: encodedOrigin => {
              const { id, product } = OriginTracing.fromEncoded(encodedOrigin);
              return { originTracingAttributes: {'id': id, 'product': product}, taskSessionId: id };
          },
      });
     *
     * @param  {Object} originParamHandlerMapping a dictionary of mappings between origin url param keys and handler functions
     * @this {AnalyticsWebClient}
     */ (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "setOriginTracingHandlers", function(originParamHandlerMapping) {
        var capturedOriginTraces = _this.originTracing.handleOriginParameters(originParamHandlerMapping, _this._historyReplaceFn);
        Object.keys(capturedOriginTraces).forEach(function(x) {
            if (typeof capturedOriginTraces[x].taskSessionId !== "undefined") _this.task.createTaskSessionWithProvidedId(x, capturedOriginTraces[x].taskSessionId);
        });
        var originAttributes = {};
        Object.keys(capturedOriginTraces).forEach(function(x) {
            if (capturedOriginTraces[x].originTracingAttributes) originAttributes[x] = capturedOriginTraces[x].originTracingAttributes;
            else // eslint-disable-next-line no-console
            console.warn("Handling method for origin parameter ".concat(x, " has not returned any attributes"));
        });
        if (Object.keys(capturedOriginTraces).length > 0) return _this.sendOperationalEvent({
            action: "landed",
            actionSubject: "origin",
            source: "webClient",
            attributes: {
                originTracesLanded: originAttributes
            }
        }, // eslint-disable-next-line @typescript-eslint/no-empty-function
        function() {});
        return Promise.resolve();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "setTenantInfo", function(tenantIdType, tenantId) {
        if (!tenantIdType) throw new Error("Missing tenantIdType");
        if (tenantIdType !== (0, $22Iz2.tenantType).NONE && !tenantId) throw new Error("Missing tenantId");
        if (!(0, $22Iz2.isType)((0, $22Iz2.tenantType), tenantIdType)) throw new Error("Invalid tenantIdType '".concat(tenantIdType, "', ") + "must be an tenantType: [".concat((0, $22Iz2.objectValues)((0, $22Iz2.tenantType)), "]"));
        _this._tenantInfo = {
            tenantIdType: tenantIdType,
            tenantId: tenantId
        };
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "clearTenantInfo", function() {
        _this._tenantInfo = {};
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "setOrgInfo", function(orgId) {
        if (!orgId) throw new Error("Missing orgId");
        _this._orgInfo = {
            orgId: orgId
        };
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "clearOrgInfo", function() {
        _this._orgInfo = {};
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "setWorkspaceInfo", function(workspaceId) {
        if (!workspaceId) throw new Error("Missing workspaceId");
        _this._workspaceInfo = {
            workspaceId: workspaceId
        };
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "clearWorkspaceInfo", function() {
        _this._workspaceInfo = {};
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "setUserInfo", function(userIdType, userId) {
        (0, $hGIZ8.validateIdentifyEvent)(userIdType, userId);
        _this._changeInternalUserId(userId);
        _this._userInfo = {
            userIdType: userIdType,
            userId: userId,
            anonymousId: _this.eventProcessor.getUser().getAnonymousId()
        };
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "clearUserInfo", function() {
        _this._changeInternalUserId(undefined);
        _this._userInfo = {
            anonymousId: _this.eventProcessor.getUser().getAnonymousId()
        };
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "getAnonymousId", function() {
        return _this._userInfo.anonymousId;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "setUIViewedAttributes", function(uiViewedAttributes) {
        if (!uiViewedAttributes) throw new Error("Missing uiViewedAttributes");
        if (typeof uiViewedAttributes !== "object" || Array.isArray(uiViewedAttributes)) throw new Error("Invalid uiViewedAttributes type, should be a non array object");
        _this._uiViewedAttributes = $57a84ed5054d22d2$var$_objectSpread({}, uiViewedAttributes);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "getUIViewedAttributes", function() {
        return _this._uiViewedAttributes;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "clearUIViewedAttributes", function() {
        _this._uiViewedAttributes = {};
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "sendIdentifyEvent", function(userIdType, userId, callback) {
        _this.setUserInfo(userIdType, userId);
        var builtEvent = {
            userIdType: userIdType,
            eventType: (0, $22Iz2.eventType).IDENTIFY
        };
        return _this._processEvent(userId, builtEvent, _this._context, callback);
    });
    /**
     * @deprecated
     * please use {@link sendScreenEvent instead)
     */ (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "sendPageEvent", function(name, callback) {
        return _this.sendScreenEvent(name, callback);
    });
    /**
     * send screen event
     * @param event The event / For retrocompatibility event name is still supported here.
     * @param callback
     * @param attributes. Deprecated, will get ignored if using an event object as first param.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "sendScreenEvent", function(event, callback, attributes) {
        var screenName;
        var screenAttributes;
        var screenContainers;
        var screenTags;
        if (typeof event === "object") {
            /* This is for retrocompatibility */ screenName = event.name;
            screenAttributes = event.attributes;
            screenContainers = event.containers;
            screenTags = event.tags;
        } else {
            screenName = event;
            screenAttributes = attributes;
        }
        (0, $hGIZ8.validateScreenEvent)(screenName);
        (0, $hGIZ8.validateContainers)(screenContainers);
        var builtEvent = (0, $fXbpq.buildScreenEvent)(_this._productInfo, _this._tenantInfo, _this._userInfo, screenAttributes, // TODO: Remove the as any and move into a place where we know event is an object
        event.nonPrivacySafeAttributes, screenTags, _this._tabTracking.getCurrentTabId(), _this._sessionTracking.getCurrentSessionId(), _this.task.getAllTaskSessions(), _this._orgInfo, _this._pageLoadId, _this._workspaceInfo, event, screenContainers);
        var builtEventWithName = $57a84ed5054d22d2$var$_objectSpread({
            name: screenName
        }, builtEvent);
        _this._setLastScreenEvent(builtEventWithName);
        return _this._processEvent(screenName, builtEventWithName, _this._context, (0, $5LQZZ.default)(callback, builtEventWithName));
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "sendTrackEvent", function(event, callback) {
        (0, $hGIZ8.validateTrackEvent)(event);
        var builtEvent = (0, $fXbpq.buildActionEvent)(_this._productInfo, _this._tenantInfo, _this._userInfo, event, (0, $22Iz2.eventType).TRACK, _this._tabTracking.getCurrentTabId(), _this._sessionTracking.getCurrentSessionId(), _this.task.getAllTaskSessions(), _this._orgInfo, _this._pageLoadId, _this._workspaceInfo);
        return _this._processEvent((0, $fXbpq.buildActionName)(event), builtEvent, _this._context, (0, $5LQZZ.default)(callback, builtEvent));
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "sendUIEvent", function(event, callback) {
        (0, $hGIZ8.validateUIEvent)(event);
        var builtEvent = (0, $fXbpq.buildActionEvent)(_this._productInfo, _this._tenantInfo, _this._userInfo, event, (0, $22Iz2.eventType).UI, _this._tabTracking.getCurrentTabId(), _this._sessionTracking.getCurrentSessionId(), _this.task.getAllTaskSessions(), _this._orgInfo, _this._pageLoadId, _this._workspaceInfo);
        return _this._processEvent((0, $fXbpq.buildActionName)(event), builtEvent, _this._context, (0, $5LQZZ.default)(callback, builtEvent));
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "sendOperationalEvent", function(event, callback) {
        (0, $hGIZ8.validateOperationalEvent)(event);
        var builtEvent = (0, $fXbpq.buildActionEvent)(_this._productInfo, _this._tenantInfo, _this._userInfo, event, (0, $22Iz2.eventType).OPERATIONAL, _this._tabTracking.getCurrentTabId(), _this._sessionTracking.getCurrentSessionId(), _this.task.getAllTaskSessions(), _this._orgInfo, _this._pageLoadId, _this._workspaceInfo);
        return _this._processEvent((0, $fXbpq.buildActionName)(event), builtEvent, _this._context, (0, $5LQZZ.default)(callback, builtEvent));
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "startUIViewedEvent", function(callback) {
        _this.stopUIViewedEvent();
        _this._uiViewedEvent = new (0, $bJ204.default)(_this._productInfo, function() {
            return {
                embeddedProduct: _this._productInfo.embeddedProduct(),
                subproduct: _this._productInfo.subproduct(),
                tenantIdType: _this._tenantInfo.tenantIdType,
                tenantId: _this._tenantInfo.tenantId,
                userId: _this._userInfo.userId,
                lastScreenEvent: _this._getLastScreenEvent(),
                attributes: _this._uiViewedAttributes
            };
        }, function(event) {
            return _this.sendUIEvent(event, callback);
        });
        _this._uiViewedEvent.start();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "stopUIViewedEvent", function() {
        if (_this._uiViewedEvent) {
            _this._uiViewedEvent.stop();
            _this._uiViewedEvent = null;
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "resetUIViewedTimers", function() {
        if (_this._uiViewedEvent) _this._uiViewedEvent.resetTimers();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "startApdexEvent", function(apdexEvent) {
        _this._apdexEvent.start(apdexEvent);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "getApdexStart", function(apdexEvent) {
        return _this._apdexEvent.getStart(apdexEvent);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "stopApdexEvent", function(apdexEvent, callback) {
        _this._apdexEvent.stop(apdexEvent, callback);
    });
    // TODO If we ever make another breaking change, merge these two optional args into an `options` object arg.
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "startLowPriorityEventDelay", function(timeout, callback) {
        _this.eventDelayQueue.startLowPriorityEventDelay(timeout, callback);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "stopLowPriorityEventDelay", function() {
        _this.eventDelayQueue.stopLowPriorityEventDelay();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "onEvent", function(analyticsId, analyticsData) {
        if (!analyticsData) throw new Error("Missing analyticsData");
        if (!analyticsData.eventType) throw new Error("Missing analyticsData.eventType");
        if (analyticsData.eventType === (0, $22Iz2.eventType).TRACK) return _this.sendTrackEvent(analyticsData);
        else if (analyticsData.eventType === (0, $22Iz2.eventType).UI) return _this.sendUIEvent(analyticsData);
        else if (analyticsData.eventType === (0, $22Iz2.eventType).OPERATIONAL) return _this.sendOperationalEvent(analyticsData);
        else if (analyticsData.eventType === (0, $22Iz2.eventType).SCREEN) return _this.sendScreenEvent(analyticsData.name, null, analyticsData.attributes);
        else if (analyticsData.eventType === (0, $22Iz2.eventType).IDENTIFY) return _this.sendIdentifyEvent(analyticsData.userIdType, analyticsData.userId);
        throw new Error("Invalid analyticsData.eventType '".concat(analyticsData.eventType, "', ") + "must be an eventType: [".concat((0, $22Iz2.objectValues)((0, $22Iz2.eventType)), "]"));
    });
    if (!productInfo) throw new Error("Missing productInfo");
    if (!productInfo.env) throw new Error("Missing productInfo.env");
    if (!productInfo.product) throw new Error("Missing productInfo.product");
    if (!(0, $22Iz2.isType)((0, $22Iz2.envType), productInfo.env)) throw new Error("Invalid productInfo.env '".concat(productInfo.env, "', ") + "must be an envType: [".concat((0, $22Iz2.objectValues)((0, $22Iz2.envType)), "]"));
    if (productInfo.perimeter && !(0, $22Iz2.isType)((0, $22Iz2.perimeterType), productInfo.perimeter)) throw new Error("Invalid productInfo.perimeter '".concat(productInfo.perimeter, "', ") + "must be an perimeterType: [".concat((0, $22Iz2.objectValues)((0, $22Iz2.perimeterType)), "]"));
    if (!productInfo.origin) productInfo.origin = (0, $22Iz2.originType).WEB;
    else if (!(0, $22Iz2.isType)((0, $22Iz2.originType), productInfo.origin)) throw new Error("Invalid productInfo.origin '".concat(productInfo.origin, "', ") + "must be an originType: [".concat((0, $22Iz2.objectValues)((0, $22Iz2.originType)), "]"));
    if (!productInfo.platform) productInfo.platform = productInfo.origin === (0, $22Iz2.originType).WEB ? (0, $22Iz2.platformType).WEB : (0, $22Iz2.platformType).DESKTOP;
    else (0, $hGIZ8.validatePlatform)(productInfo);
    this.logger = settings.logger || console;
    this._productInfo = $57a84ed5054d22d2$var$_objectSpread($57a84ed5054d22d2$var$_objectSpread({}, productInfo), {}, {
        subproduct: this._createSubproductGetter(productInfo.subproduct),
        embeddedProduct: this._createEmbeddedProductGetter(productInfo.embeddedProduct)
    });
    this._tenantInfo = {};
    this._orgInfo = {};
    this._uiViewedAttributes = {};
    this._context = (0, $fXbpq.buildContext)(this._productInfo);
    this._safeSessionStorage = new (0, $kTmBT.default)();
    var _useStargate = this._useStargate(settings.useStargate);
    var apiHost = settings.apiHost || this._selectHost({
        useStargate: _useStargate,
        env: productInfo.env,
        useLegacyUrl: settings.useLegacyUrl,
        perimeter: productInfo.perimeter
    });
    var apiHostProtocol = settings.apiHostProtocol || "https";
    var minRetryDelay = settings.minRetryDelay || 1000;
    var retryQueueOptions = {
        maxRetryDelay: 60000,
        minRetryDelay: minRetryDelay,
        backoffFactor: 2,
        flushWaitMs: settings.flushWaitInterval,
        flushBeforeUnload: settings.flushBeforeUnload
    };
    var retryQueuePrefix = "awc-".concat(productInfo.env);
    var xidPromiseGetter = function() {
        return (0, $29bQh.XIDPromise)(settings.xidConsent, settings.xidPromiseFn);
    };
    this.eventProcessor = new (0, $lJWVG.default)({
        apiHost: apiHost,
        apiHostProtocol: apiHostProtocol,
        product: productInfo.product,
        retryQueuePrefix: retryQueuePrefix,
        retryQueueOptions: retryQueueOptions,
        xidPromiseGetter: xidPromiseGetter,
        logger: this.logger
    });
    this._userInfo = {
        anonymousId: this.eventProcessor.getUser().getAnonymousId(settings === null || settings === void 0 ? void 0 : settings.customAnonymousIdGenerator)
    };
    this._pageVisibility = new (0, $4ZR7k.default)();
    this._tabTracking = new (0, $f6Y6c.default)();
    this._sessionTracking = new (0, $jzYVM.default)({
        sessionExpiryTime: settings.sessionExpiryTime,
        onNewSessionStarted: settings.onNewSessionStarted
    });
    this.task = new (0, $1kGnl.default)();
    this.originTracing = new (0, $aHFHo.default)();
    // Init Apdex
    this._apdexEvent = new (0, $ckDXA.default)(this.sendOperationalEvent, this._pageVisibility);
    this._historyReplaceFn = typeof settings.historyReplaceFn === "function" ? settings.historyReplaceFn : (0, $gnvfh.defaultHistoryReplaceFn);
    this.eventDelayQueue = new (0, $cV8xo.default)(this._fireDelayedEvent, settings.delayQueueCompressors || []);
    this._testingCache = new (0, $6f3e8.default)();
    this._pageLoadId = (0, (/*@__PURE__*/$parcel$interopDefault($ktzPa)))();
    this._workspaceInfo = {};
};

});
parcelRegister("ktzPa", function(module, exports) {

var $3j01n = parcelRequire("3j01n");

var $5Jjuf = parcelRequire("5Jjuf");
function $ee824e0d0744351f$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == "string") {
        buf = options === "binary" ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $3j01n)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $5Jjuf(rnds);
}
module.exports = $ee824e0d0744351f$var$v4;

});
parcelRegister("3j01n", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $268329a4201658b3$var$getRandomValues = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
if ($268329a4201658b3$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $268329a4201658b3$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $268329a4201658b3$var$getRandomValues($268329a4201658b3$var$rnds8);
        return $268329a4201658b3$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $268329a4201658b3$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $268329a4201658b3$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $268329a4201658b3$var$rnds;
    };
}

});

parcelRegister("5Jjuf", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $42c0456df2db3f06$var$byteToHex = [];
for(var $42c0456df2db3f06$var$i = 0; $42c0456df2db3f06$var$i < 256; ++$42c0456df2db3f06$var$i)$42c0456df2db3f06$var$byteToHex[$42c0456df2db3f06$var$i] = ($42c0456df2db3f06$var$i + 0x100).toString(16).substr(1);
function $42c0456df2db3f06$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $42c0456df2db3f06$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join("");
}
module.exports = $42c0456df2db3f06$var$bytesToUuid;

});


parcelRegister("ckDXA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8fa6598a1a3631a9$export$2e2bcd8739ae039; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $jjExS = parcelRequire("jjExS");

var $22Iz2 = parcelRequire("22Iz2");

var $4ZR7k = parcelRequire("4ZR7k");

var $b7KV0 = parcelRequire("b7KV0");
function $8fa6598a1a3631a9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8fa6598a1a3631a9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8fa6598a1a3631a9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8fa6598a1a3631a9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8fa6598a1a3631a9$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function ApdexEvent(onEvent, pageVisibility) {
        var _this = this;
        (0, $4GJKx._)(this, ApdexEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_getEventKey", function(param) {
            var task = param.task, taskId = param.taskId;
            return taskId ? "".concat(task, ".").concat(taskId) : task;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_getEventTimingByName", function(name) {
            var eventTimings = _this._performance.getEntriesByName(name);
            var eventTiming = eventTimings[eventTimings.length - 1];
            return eventTiming;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_getApdexFields", function(event) {
            var apdexTimings = _this._getApdexTimings(event);
            var apdexScore = _this._calculateApdex({
                duration: apdexTimings.duration,
                threshold: event.threshold
            });
            return $8fa6598a1a3631a9$var$_objectSpread($8fa6598a1a3631a9$var$_objectSpread({}, apdexTimings), {}, {
                apdex: apdexScore
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_getApdexTimings", function(event) {
            var eventKey = _this._getEventKey(event);
            var eventStartName = "".concat(eventKey, "-start");
            var startTime = event.startTime || _this._getStartTime(event, eventStartName);
            var stopTime = event.stopTime || _this._getStopTime();
            // We do some clean up of the marks and started events
            _this._cleanApdexState(eventKey);
            return {
                startTime: startTime,
                stopTime: stopTime,
                duration: stopTime - startTime
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_getStartTime", function(event, eventName) {
            var startTime;
            var timeOrigin = _this._performance.getTimeOrigin();
            if (event.type === (0, $22Iz2.apdexType).INITIAL_LOAD) startTime = timeOrigin;
            else {
                var eventTiming = _this._getEventTimingByName(eventName);
                startTime = timeOrigin + eventTiming.startTime;
            }
            return startTime;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_getStopTime", function() {
            return _this._performance.getTimeOrigin() + _this._performance.now();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_cleanApdexState", function(eventKey) {
            _this._performance.clearMarks("".concat(eventKey, "-start"));
            _this._performance.clearMarks("".concat(eventKey, "-stop"));
            _this._startedEvents.delete(eventKey);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_getVisibilityFields", function(event) {
            var isActiveTab;
            /**
       * For initialLoad type:
       * 1. if tab was not ever hidden (!_wasPreviouslyHidden)
       *
       * For transition type:
       * 1. active status is tracked in active events map (_isActiveEvents)
       *
       * For any type, if startTime or stopTime is specified:
       * 1. If currently active (!_isHidden)
       */ if (event.type === (0, $22Iz2.apdexType).INITIAL_LOAD) isActiveTab = !_this._wasPreviouslyHidden;
            else if (event.type === (0, $22Iz2.apdexType).TRANSITION) {
                var eventKey = _this._getEventKey(event);
                isActiveTab = _this._isActiveEvents.get(eventKey);
            }
            if (event.startTime || event.stopTime) isActiveTab = !_this._pageVisibility.getIsHidden();
            return {
                isActiveTab: isActiveTab
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_calculateApdex", function(param) {
            var duration = param.duration, _param_threshold = param.threshold, threshold = _param_threshold === void 0 ? _this._threshold : _param_threshold;
            var apdex;
            var satisfiedThreshold = threshold;
            var tolerableThreshold = threshold * 4;
            if (duration <= satisfiedThreshold) apdex = 1;
            else if (duration <= tolerableThreshold) apdex = 0.5;
            else apdex = 0;
            return apdex;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_validateStartEvent", function(event) {
            if (!event) throw new Error('Missing "event" in Apdex start event');
            if (!event.task) throw new Error('Missing "task" in Apdex start event');
            if (typeof event.task !== "string") throw new Error('Invalid "task" in Apdex start event');
            if (event.taskId && typeof event.taskId !== "string") throw new Error('Invalid "taskId" in Apdex start event');
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_validateStopEvent", function(event) {
            if (!event) throw new Error('Missing "event" in Apdex stop event');
            if (!event.task) throw new Error('Missing "task" in Apdex stop event');
            if (typeof event.task !== "string") throw new Error('Invalid "task" in Apdex stop event');
            if (event.taskId && typeof event.taskId !== "string") throw new Error('Invalid "taskId" in Apdex stop event');
            if (!event.type) throw new Error('Missing "type" in Apdex stop event');
            if (event.type && !(0, $22Iz2.isType)((0, $22Iz2.apdexType), event.type)) throw new Error('Invalid "type" in Apdex stop event');
            if (event.threshold && typeof event.threshold !== "number") throw new Error('Invalid "threshold" in Apdex stop event');
            /*
       * For a transition, if the startTime was not specified,
       * the start event should have been present.
       */ if (!event.startTime && event.type === (0, $22Iz2.apdexType).TRANSITION) {
                var eventKey = _this._getEventKey(event);
                if (!_this._startedEvents.has(eventKey)) throw new Error('Apdex event transition "'.concat(eventKey, '" was not started'));
            }
            if (event.startTime && !(typeof event.startTime === "number" && event.startTime >= 0)) throw new Error('Invalid "startTime" in Apdex stop event');
            if (event.stopTime && typeof event.stopTime !== "number") throw new Error('Invalid "stopTime" in Apdex stop event');
            if (event.stopTime <= event.startTime) throw new Error('"stopTime" should be greater than "startTime" in Apdex stop event');
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_shouldSendEvent", function(event) {
            if (!event) return false;
            if (typeof event.apdex !== "number") return false;
            return true;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_sendEvent", function(event, callback) {
            if (_this._shouldSendEvent(event)) _this._onEvent({
                source: "ui",
                action: "readyForUser",
                actionSubject: "ui",
                attributes: $8fa6598a1a3631a9$var$_objectSpread($8fa6598a1a3631a9$var$_objectSpread({}, event.additionalAttributes), {}, {
                    task: event.task,
                    taskId: event.taskId,
                    type: event.type,
                    threshold: event.threshold || _this._threshold,
                    apdex: event.apdex,
                    startTime: event.startTime,
                    stopTime: event.stopTime,
                    duration: event.duration,
                    isActiveTab: event.isActiveTab
                })
            }, callback);
        });
        if (!onEvent) throw new Error("Missing onEvent callback");
        if (typeof onEvent !== "function") throw new Error("Invalid onEvent, must be function");
        if (!(pageVisibility instanceof (0, $4ZR7k.default))) throw new Error("Invalid pageVisibility, must be PageVisibility class");
        this._startedEvents = new Map();
        this._performance = new (0, $b7KV0.default)();
        this._onEvent = onEvent;
        this._threshold = 1000;
        this._wasPreviouslyHidden = pageVisibility.getIsHidden();
        this._isActiveEvents = new Map();
        this._pageVisibility = pageVisibility;
        this._pageVisibility.addCallback("apdexEvent", function(isHidden) {
            _this.onVisibilityChange(!isHidden);
        });
    }
    (0, $1wc17._)(ApdexEvent, [
        {
            key: "start",
            value: function start(event) {
                this._validateStartEvent(event);
                if (!this._performance.isAvailable()) return;
                var eventKey = this._getEventKey(event);
                var eventStartName = "".concat(eventKey, "-start");
                this._startedEvents.set(eventKey, true);
                this._isActiveEvents.set(eventKey, !this._pageVisibility.getIsHidden());
                this._performance.clearMarks(eventStartName);
                this._performance.mark(eventStartName);
            }
        },
        {
            key: "getStart",
            value: function getStart(event) {
                this._validateStartEvent(event);
                if (!this._performance.isAvailable()) return undefined;
                var eventKey = this._getEventKey(event);
                var eventStartName = "".concat(eventKey, "-start");
                return this._getEventTimingByName(eventStartName);
            }
        },
        {
            key: "stop",
            value: function stop(event, callback) {
                this._validateStopEvent(event);
                if (!this._performance.isAvailable()) return;
                var apdexFields = this._getApdexFields(event);
                var visibilityFields = this._getVisibilityFields(event);
                this._sendEvent($8fa6598a1a3631a9$var$_objectSpread($8fa6598a1a3631a9$var$_objectSpread($8fa6598a1a3631a9$var$_objectSpread({}, event), apdexFields), visibilityFields), callback);
            }
        },
        {
            key: "onVisibilityChange",
            value: function onVisibilityChange(isActive) {
                var _this = this;
                if (!isActive) {
                    this._wasPreviouslyHidden = true;
                    this._isActiveEvents.forEach(function(value, key) {
                        return _this._isActiveEvents.set(key, false);
                    });
                }
            }
        }
    ]);
    return ApdexEvent;
}();

});
parcelRegister("4ZR7k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a360fea97058cb5$export$2e2bcd8739ae039; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $jjExS = parcelRequire("jjExS");
var $3a360fea97058cb5$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function PageVisibility() {
        var _this = this;
        (0, $4GJKx._)(this, PageVisibility);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_bindEventListeners", function() {
            document.addEventListener(_this._visibilityChange, _this._handleVisibilityChange, false);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_handleVisibilityChange", function() {
            var isHidden = document[_this._hidden];
            _this._isHidden = isHidden;
            _this._callbacks.forEach(function(callbackFn) {
                return callbackFn(isHidden);
            });
        });
        this._isHidden = false;
        this._callbacks = new Map();
        this._hidden = undefined;
        this._visibilityChange = undefined;
        if (typeof document.hidden !== "undefined") {
            // Opera 12.10 and Firefox 18 and later support
            this._isHidden = document.hidden;
            this._hidden = "hidden";
            this._visibilityChange = "visibilitychange";
        } else if (typeof document.msHidden !== "undefined") {
            this._isHidden = document.msHidden;
            this._hidden = "msHidden";
            this._visibilityChange = "msvisibilitychange";
        } else if (typeof document.webkitHidden !== "undefined") {
            this._isHidden = document.webkitHidden;
            this._hidden = "webkitHidden";
            this._visibilityChange = "webkitvisibilitychange";
        }
        if (typeof document.addEventListener !== "undefined" && this._hidden !== undefined) this._bindEventListeners();
    }
    (0, $1wc17._)(PageVisibility, [
        {
            key: "addCallback",
            value: function addCallback(name, fn) {
                if (typeof name !== "string") throw new Error("Invalid name, must be string");
                if (typeof fn !== "function") throw new Error("Invalid callback, must be function");
                this._callbacks.set(name, fn);
            }
        },
        {
            key: "removeCallback",
            value: function removeCallback(name) {
                if (this._callbacks.has(name)) this._callbacks.delete(name);
            }
        },
        {
            key: "getIsHidden",
            value: function getIsHidden() {
                return this._isHidden;
            }
        }
    ]);
    return PageVisibility;
}();

});

parcelRegister("b7KV0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8194be2c1febc0f1$export$2e2bcd8739ae039; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $c6Xmf = parcelRequire("c6Xmf");
var $8194be2c1febc0f1$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function Performance() {
        (0, $4GJKx._)(this, Performance);
        this._performance = window.performance;
    }
    (0, $1wc17._)(Performance, [
        {
            key: "clearMarks",
            value: function clearMarks() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _this__performance;
                if (!this._performance || !this._performance.clearMarks) return;
                (_this__performance = this._performance).clearMarks.apply(_this__performance, (0, $c6Xmf._)(args));
            }
        },
        {
            key: "mark",
            value: function mark() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _this__performance;
                if (!this._performance || !this._performance.mark) return;
                (_this__performance = this._performance).mark.apply(_this__performance, (0, $c6Xmf._)(args));
            }
        },
        {
            key: "getEntriesByName",
            value: function getEntriesByName() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _this__performance;
                if (!this._performance || !this._performance.getEntriesByName) return [];
                return (_this__performance = this._performance).getEntriesByName.apply(_this__performance, (0, $c6Xmf._)(args));
            }
        },
        {
            key: "getTimeOrigin",
            value: function getTimeOrigin() {
                if (!this._performance || !this._performance.timeOrigin && !this._performance.timing) return 0;
                return this._performance.timeOrigin || this._performance.timing.navigationStart;
            }
        },
        {
            key: "now",
            value: function now() {
                if (!this._performance || !this._performance.now) return Date.now ? Date.now() : +new Date();
                return this._performance.now();
            }
        },
        {
            key: "isAvailable",
            value: function isAvailable() {
                return !!this._performance && !!this._performance.clearMarks && !!this._performance.mark && !!this._performance.getEntriesByName && !!this._performance.timing;
            }
        }
    ]);
    return Performance;
}();

});


parcelRegister("awX4D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7aaab75e78d66d31$export$2e2bcd8739ae039; });
/**
 * Wraps {possibleFn} into a error-safe function and handles cases where {possibleFn}
 * is a function or object
 *
 * @param possibleFn - function that returns and object or the object itself
 * @param errorMessage - error message to log if {possibleFn} is a function and
 *                        throws an error when called
 * @returns {Function}
 */ var $7aaab75e78d66d31$var$isFunction = function(possibleFn) {
    return typeof possibleFn === "function";
};
var $7aaab75e78d66d31$export$2e2bcd8739ae039 = function(possibleFn, errorMessage) {
    return function() {
        if ($7aaab75e78d66d31$var$isFunction(possibleFn)) try {
            return possibleFn();
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error("".concat(errorMessage, " - ").concat(e instanceof Error ? e.message : String(e)));
            return undefined;
        }
        return possibleFn;
    };
};

});

parcelRegister("fXbpq", function(module, exports) {

$parcel$export(module.exports, "buildActionFields", function () { return $b9d5374a2b5f2fb7$export$655ecf7241feac42; });
$parcel$export(module.exports, "buildScreenEvent", function () { return $b9d5374a2b5f2fb7$export$c7d9a5f56acc4b19; });
$parcel$export(module.exports, "buildActionName", function () { return $b9d5374a2b5f2fb7$export$9c5623a792efc9b0; });
$parcel$export(module.exports, "buildContext", function () { return $b9d5374a2b5f2fb7$export$3a7fe28f9bf4f3d9; });
$parcel$export(module.exports, "buildActionEvent", function () { return $b9d5374a2b5f2fb7$export$7bf451af4a8e3dd9; });

var $3sHb8 = parcelRequire("3sHb8");

var $jjExS = parcelRequire("jjExS");

var $22Iz2 = parcelRequire("22Iz2");

var $bnlwi = parcelRequire("bnlwi");
function $b9d5374a2b5f2fb7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b9d5374a2b5f2fb7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b9d5374a2b5f2fb7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b9d5374a2b5f2fb7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b9d5374a2b5f2fb7$var$libraryVersion = "4.18.0";
function $b9d5374a2b5f2fb7$var$buildTenantFields(tenantInfo) {
    return {
        tenantIdType: tenantInfo.tenantIdType,
        tenantId: tenantInfo.tenantId
    };
}
function $b9d5374a2b5f2fb7$var$buildUserFields(userInfo) {
    return {
        userIdType: userInfo.userIdType
    };
}
function $b9d5374a2b5f2fb7$var$buildOrgFields(orgInfo) {
    return {
        orgId: orgInfo.orgId
    };
}
function $b9d5374a2b5f2fb7$var$buildWorkspaceFields(workspaceInfo) {
    return {
        workspaceId: workspaceInfo.workspaceId
    };
}
function $b9d5374a2b5f2fb7$var$buildEventOverrides(event) {
    if (event.anonymousId) return {
        anonymousId: event.anonymousId
    };
    return {};
}
function $b9d5374a2b5f2fb7$var$getProductField(field, override) {
    return override === undefined ? field : override;
}
function $b9d5374a2b5f2fb7$var$buildProductFields(productInfo, productOverrides) {
    var overrides = productOverrides || {};
    var env = $b9d5374a2b5f2fb7$var$getProductField(productInfo.env, overrides.env);
    var product = $b9d5374a2b5f2fb7$var$getProductField(productInfo.product, overrides.product);
    var subproduct = $b9d5374a2b5f2fb7$var$getProductField(productInfo.subproduct(), overrides.subproduct);
    var version = $b9d5374a2b5f2fb7$var$getProductField(productInfo.version, overrides.version);
    var origin = $b9d5374a2b5f2fb7$var$getProductField(productInfo.origin, overrides.origin);
    var platform = $b9d5374a2b5f2fb7$var$getProductField(productInfo.platform, overrides.platform);
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform
    };
}
function $b9d5374a2b5f2fb7$var$isNotEmptyObject(obj) {
    return (0, $bnlwi.isPlainObject)(obj) && Object.keys(obj).length > 0;
}
function $b9d5374a2b5f2fb7$var$buildAttributesWithName(name, attrObject) {
    return $b9d5374a2b5f2fb7$var$isNotEmptyObject(attrObject) ? (0, $3sHb8._)({}, name, attrObject) : undefined;
}
function $b9d5374a2b5f2fb7$var$buildAttributes(attributes) {
    return $b9d5374a2b5f2fb7$var$buildAttributesWithName("attributes", attributes);
}
function $b9d5374a2b5f2fb7$export$3f5115a568819c1a(containers) {
    var validContainers = {};
    Object.keys(containers).forEach(function(key) {
        var value = containers[key];
        validContainers[key] = {
            id: value.id,
            type: value.type
        };
    });
    return validContainers;
}
function $b9d5374a2b5f2fb7$export$f045f238d77c002a(containers) {
    if ($b9d5374a2b5f2fb7$var$isNotEmptyObject(containers)) {
        var validContainers = $b9d5374a2b5f2fb7$export$3f5115a568819c1a(containers);
        return $b9d5374a2b5f2fb7$var$buildAttributesWithName("containers", validContainers);
    }
    return undefined;
}
function $b9d5374a2b5f2fb7$export$655ecf7241feac42(event, actionEventType) {
    return $b9d5374a2b5f2fb7$var$_objectSpread({
        containerType: event.containerType,
        containerId: event.containerId,
        source: event.source,
        objectType: event.objectType,
        objectId: event.objectId,
        actionSubject: event.actionSubject,
        action: event.action,
        actionSubjectId: event.actionSubjectId,
        attributes: event.attributes,
        nonPrivacySafeAttributes: event.nonPrivacySafeAttributes,
        tags: event.tags,
        highPriority: event.highPriority,
        eventType: actionEventType
    }, $b9d5374a2b5f2fb7$export$f045f238d77c002a(event.containers));
}
function $b9d5374a2b5f2fb7$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes) {
    return $b9d5374a2b5f2fb7$var$buildAttributesWithName("nonPrivacySafeAttributes", nonPrivacySafeAttributes);
}
function $b9d5374a2b5f2fb7$export$c7d9a5f56acc4b19(productInfo, tenantInfo, userInfo, attributes, nonPrivacySafeAttributes, tags, tabId, sessionId, taskSessions, orgInfo, pageLoadId, workspaceInfo, event, containers) {
    var productFields = $b9d5374a2b5f2fb7$var$buildProductFields(productInfo);
    var tenantFields = $b9d5374a2b5f2fb7$var$buildTenantFields(tenantInfo);
    var userFields = $b9d5374a2b5f2fb7$var$buildUserFields(userInfo);
    var orgFields = $b9d5374a2b5f2fb7$var$buildOrgFields(orgInfo);
    var workspaceFields = $b9d5374a2b5f2fb7$var$buildWorkspaceFields(workspaceInfo);
    var overrides = {
        title: "",
        path: "",
        url: "",
        referrer: "",
        search: "",
        eventType: (0, $22Iz2.eventType).SCREEN
    };
    return $b9d5374a2b5f2fb7$var$_objectSpread($b9d5374a2b5f2fb7$var$_objectSpread($b9d5374a2b5f2fb7$var$_objectSpread($b9d5374a2b5f2fb7$var$_objectSpread($b9d5374a2b5f2fb7$var$_objectSpread($b9d5374a2b5f2fb7$var$_objectSpread($b9d5374a2b5f2fb7$var$_objectSpread($b9d5374a2b5f2fb7$var$_objectSpread($b9d5374a2b5f2fb7$var$_objectSpread($b9d5374a2b5f2fb7$var$_objectSpread({}, productFields), tenantFields), userFields), orgFields), overrides), $b9d5374a2b5f2fb7$var$buildAttributes(attributes)), $b9d5374a2b5f2fb7$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes)), $b9d5374a2b5f2fb7$export$f045f238d77c002a(containers)), $b9d5374a2b5f2fb7$var$buildEventOverrides(event)), {}, {
        tags: tags,
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        pageLoadId: pageLoadId
    }, workspaceFields);
}
function $b9d5374a2b5f2fb7$export$9c5623a792efc9b0(event) {
    return "".concat(event.actionSubject, " ").concat(event.action);
}
function $b9d5374a2b5f2fb7$export$3a7fe28f9bf4f3d9(productInfo) {
    var screen = window.screen || {};
    return {
        context: {
            locale: productInfo.locale,
            screen: {
                width: screen.width,
                height: screen.height,
                density: window.devicePixelRatio
            },
            library: {
                name: "analytics.js",
                version: $b9d5374a2b5f2fb7$var$libraryVersion
            }
        }
    };
}
function $b9d5374a2b5f2fb7$export$e3d99b4bfec06f6e(event) {
    var env = event.env, product = event.product, subproduct = event.subproduct, version = event.version, origin = event.origin, platform = event.platform;
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform
    };
}
function $b9d5374a2b5f2fb7$export$7bf451af4a8e3dd9(productInfo, tenantInfo, userInfo, event, actionEventType, tabId, sessionId, taskSessions, orgInfo, pageLoadId, workspaceInfo) {
    var productFields = $b9d5374a2b5f2fb7$var$buildProductFields(productInfo, $b9d5374a2b5f2fb7$export$e3d99b4bfec06f6e(event));
    var tenantFields = $b9d5374a2b5f2fb7$var$buildTenantFields(tenantInfo);
    var orgFields = $b9d5374a2b5f2fb7$var$buildOrgFields(orgInfo);
    var workspaceFields = $b9d5374a2b5f2fb7$var$buildWorkspaceFields(workspaceInfo);
    var userFields = $b9d5374a2b5f2fb7$var$buildUserFields(userInfo);
    var actionFields = $b9d5374a2b5f2fb7$export$655ecf7241feac42(event, actionEventType);
    return $b9d5374a2b5f2fb7$var$_objectSpread($b9d5374a2b5f2fb7$var$_objectSpread($b9d5374a2b5f2fb7$var$_objectSpread($b9d5374a2b5f2fb7$var$_objectSpread($b9d5374a2b5f2fb7$var$_objectSpread($b9d5374a2b5f2fb7$var$_objectSpread($b9d5374a2b5f2fb7$var$_objectSpread({}, productFields), tenantFields), orgFields), userFields), actionFields), $b9d5374a2b5f2fb7$var$buildEventOverrides(event)), {}, {
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        pageLoadId: pageLoadId
    }, workspaceFields);
}

});

parcelRegister("cV8xo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96816e4b771ed4fa$export$2e2bcd8739ae039; });

var $4GJKx = parcelRequire("4GJKx");

var $jjExS = parcelRequire("jjExS");

var $8ngHp = parcelRequire("8ngHp");

var $l1AWj = parcelRequire("l1AWj");

var $99h0F = parcelRequire("99h0F");
var $96816e4b771ed4fa$export$2e2bcd8739ae039 = function EventDelayCoordinator(fireDelayedEvent, compressors) {
    "use strict";
    var _this = this;
    (0, $4GJKx._)(this, EventDelayCoordinator);
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "push", function(identifier, builtEvent, context, userInfo) {
        _this.delayQueue.push(identifier, builtEvent, context, userInfo);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "startLowPriorityEventDelay", function() {
        var timeout = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $8ngHp.DEFAULT_DELAY_TIMEOUT), callback = arguments.length > 1 ? arguments[1] : void 0;
        if (Number.isNaN(timeout) || timeout <= 0) throw new Error("Invalid timeout period: ".concat(timeout, ", must be a number greater than 0"));
        if (_this.delayTimeout) clearTimeout(_this.delayTimeout);
        var delayTimeoutPeriod = timeout ? Math.min(timeout, (0, $8ngHp.MAX_DELAY_TIMEOUT)) : (0, $8ngHp.MAX_DELAY_TIMEOUT);
        _this.delayCallback = callback;
        _this.delayTimeout = setTimeout(function() {
            return _this.stopLowPriorityEventDelay((0, $99h0F.StopLowPriorityEventDelayReason).TIMEOUT);
        }, delayTimeoutPeriod);
        // If the queue is still flushing from a previous delay period, then we should cancel that flush
        // to stop it from negatively impacting the performance of the new critical section
        _this.delayQueue.cancelFlush();
        _this.isDelaying = true;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "stopLowPriorityEventDelay", function() {
        var reason = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $99h0F.StopLowPriorityEventDelayReason).MANUAL;
        var _this$delayCallback;
        if (_this.delayTimeout) {
            clearTimeout(_this.delayTimeout);
            _this.delayTimeout = undefined;
        }
        _this.delayQueue.startFlush();
        _this.isDelaying = false;
        (_this$delayCallback = _this.delayCallback) === null || _this$delayCallback === void 0 || _this$delayCallback.call(_this, reason);
        _this.delayCallback = undefined;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "isDelayingLowPriorityEvents", function() {
        return _this.isDelaying;
    });
    this.isDelaying = false;
    this.delayQueue = new (0, $l1AWj.default)(fireDelayedEvent, compressors);
};

});
parcelRegister("8ngHp", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_DELAY_TIMEOUT", function () { return $618d6cd454ff9edb$export$cf090d5281b5ae06; });
$parcel$export(module.exports, "MAX_DELAY_TIMEOUT", function () { return $618d6cd454ff9edb$export$8575e30be0feb909; });
var $618d6cd454ff9edb$export$cf090d5281b5ae06 = 10000;
var $618d6cd454ff9edb$export$8575e30be0feb909 = 30000;

});

parcelRegister("l1AWj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4e6585def54a811$export$2e2bcd8739ae039; });

var $4GJKx = parcelRequire("4GJKx");

var $cv9Rk = parcelRequire("cv9Rk");

var $jjExS = parcelRequire("jjExS");

var $fXbpq = parcelRequire("fXbpq");

var $9kC89 = parcelRequire("9kC89");

var $aBIpN = parcelRequire("aBIpN");
// We want to throttle the flush rate so that we don't have a huge upfront performance hit from starting the flush,
// and so that the underlying Segment client has some time to process some events in its queue before more are added.
var $f4e6585def54a811$var$FLUSH_BATCH_SIZE = 7; // aligns with the default batch size of Segment's BatchableQueue
var $f4e6585def54a811$var$FLUSH_BATCH_BACKOFF_PERIOD = 100;
var $f4e6585def54a811$export$2e2bcd8739ae039 = function EventDelayQueue(processFn, compressionRules) {
    "use strict";
    var _this = this;
    (0, $4GJKx._)(this, EventDelayQueue);
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "push", function(identifier, builtEvent, context, userInfo) {
        _this.eventArgs.push({
            identifier: identifier,
            builtEvent: builtEvent,
            context: context,
            userInfo: userInfo
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "size", function() {
        return _this.eventArgs.length;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "startFlush", function() {
        try {
            _this.eventArgs = _this.compressEventArgs(_this.eventArgs);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.warn("Failed to perform compression on the delayed analytics events. " + "Error: ".concat(e.message, ". Sending ").concat(_this.eventArgs.length, " uncompressed events instead"));
        }
        _this.flushNextBatch();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "cancelFlush", function() {
        if (_this.flushBatchTimeout) {
            clearTimeout(_this.flushBatchTimeout);
            _this.flushBatchTimeout = null;
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "flushNextBatch", function() {
        var batch = _this.eventArgs.splice(0, $f4e6585def54a811$var$FLUSH_BATCH_SIZE);
        batch.forEach(function(item) {
            return _this.processFn(item.identifier, item.builtEvent, item.context, item.userInfo);
        });
        if (_this.eventArgs.length > 0) _this.flushBatchTimeout = setTimeout(function() {
            return _this.flushNextBatch();
        }, $f4e6585def54a811$var$FLUSH_BATCH_BACKOFF_PERIOD);
        else _this.flushBatchTimeout = null;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "compressEventArgs", function(eventArgs) {
        var _partition = (0, $cv9Rk._)((0, $9kC89.partition)(eventArgs, function(args) {
            return _this.compressor.canCompress(args.builtEvent);
        }), 2), compressibleEventArgs = _partition[0], incompressibleEventArgs = _partition[1];
        // Events can only be compressed together if they share the same context and user info, since these are top-level
        // fields that need to exist on the fired event and can only be set to a single value.
        // We can achieve this by grouping our events by context prior to passing them to the compressor.
        var contextGroups = compressibleEventArgs.reduce(function(groups, args) {
            var matchingGroup = groups.find(function(group) {
                return (0, $9kC89.equals)(group.userInfo, args.userInfo) && (0, $9kC89.equals)(group.context, args.context);
            });
            if (matchingGroup) matchingGroup.eventArgs.push(args);
            else groups.push({
                userInfo: args.userInfo,
                context: args.context,
                eventArgs: [
                    args
                ]
            });
            return groups;
        }, []);
        // Run the compressor on each group
        var allCompressedEventArgs = contextGroups.reduce(function(acc, group) {
            try {
                var events = group.eventArgs.map(function(args) {
                    return args.builtEvent;
                });
                var compressedEvents = _this.compressor.compress(events);
                var compressedEventArgs = compressedEvents.map(function(compressedEvent) {
                    return {
                        identifier: (0, $fXbpq.buildActionName)(compressedEvent),
                        builtEvent: compressedEvent,
                        userInfo: group.userInfo,
                        context: group.context
                    };
                });
                return acc.concat(compressedEventArgs);
            } catch (e) {
                // If anything goes wrong while compressing this group, then just fall back on the
                // uncompressed events instead. The event compressor already handles errors with invalid
                // generator functions or results, but this is an extra layer of defense to prevent data
                // loss in the event of an unexpected error.
                // eslint-disable-next-line no-console
                console.warn("Failed to compress some analytics events. " + "Error: ".concat(e.message, ". Sending ").concat(group.eventArgs.length, " uncompressed events instead"));
                return group.eventArgs;
            }
        }, []);
        incompressibleEventArgs.forEach(function(args) {
            return allCompressedEventArgs.push(args);
        });
        return allCompressedEventArgs;
    });
    this.processFn = processFn;
    this.flushBatchTimeout = null;
    this.eventArgs = [];
    this.compressor = new (0, $aBIpN.default)(compressionRules);
};

});
parcelRegister("aBIpN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b8fcffac6fdef32$export$2e2bcd8739ae039; });

var $4GJKx = parcelRequire("4GJKx");

var $jjExS = parcelRequire("jjExS");

var $fXbpq = parcelRequire("fXbpq");

var $9kC89 = parcelRequire("9kC89");

var $d4mMe = parcelRequire("d4mMe");
function $7b8fcffac6fdef32$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7b8fcffac6fdef32$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7b8fcffac6fdef32$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7b8fcffac6fdef32$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7b8fcffac6fdef32$export$2e2bcd8739ae039 = function EventCompressor() {
    "use strict";
    var compressionRules = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var _this = this;
    (0, $4GJKx._)(this, EventCompressor);
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "canCompress", function(event) {
        return _this.compressionRules.some(function(compressionRule) {
            return compressionRule.canCompress(event);
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "compress", function(events) {
        var groups = _this.createGroups(events);
        return groups.reduce(function(allCompressedEvents, group) {
            var groupCompressedEvents = _this.compressGroup(group);
            return allCompressedEvents.concat(groupCompressedEvents);
        }, []);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "createGroups", function(events) {
        return(// Group events based on contextual fields. These fields are anything that is added by the client itself,
        // rather than passed in by the caller (eg. product, org. and tenant info)
        events.reduce(function(groups, event) {
            var matchingCompressor = _this.compressionRules.find(function(compressor) {
                return compressor.canCompress(event);
            });
            var contextFields;
            if (matchingCompressor) {
                var actionFields = (0, $fXbpq.buildActionFields)(event, event.eventType);
                contextFields = (0, $9kC89.omit)(event, Object.keys(actionFields));
            }
            var matchingGroup = groups.find(function(group) {
                return matchingCompressor === group.compressor && (0, $9kC89.equals)(contextFields, group.contextFields);
            });
            if (matchingGroup) matchingGroup.events.push(event);
            else groups.push({
                contextFields: contextFields,
                compressor: matchingCompressor,
                events: [
                    event
                ]
            });
            return groups;
        }, []));
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "compressGroup", function(group) {
        // If this group doesn't have any compressor, then the event args are already in their final format
        if (!group.compressor) return group.events;
        try {
            // Run the compressor on the group to generate some new events.
            // The compression function is only expected to return the action fields for each
            // event that it generates, since all other fields are generated by the client.
            var compressedEventActionFields = group.compressor.compress(group.events);
            // Add the context fields to each of the resulting events to inflate them into a full action event
            return compressedEventActionFields.map(function(actionFields) {
                return $7b8fcffac6fdef32$var$_objectSpread($7b8fcffac6fdef32$var$_objectSpread({}, actionFields), group.contextFields);
            });
        } catch (e) {
            // If we fail to compress the events, then just fall back the uncompressed events
            // so that no data is lost. This can happen if the compression function throws an error
            // or returns some invalid event payloads.
            // eslint-disable-next-line no-console
            console.warn("Failed to compress some analytics events. " + "Error: ".concat(e.message, ". Sending ").concat(group.events.length, " uncompressed events instead"));
            return group.events;
        }
    });
    if (!Array.isArray(compressionRules)) throw new Error("Event compressors must be constructed with an array of CompressionRules");
    if (!compressionRules.every(function(rule) {
        return rule instanceof (0, $d4mMe.CompressionRule);
    })) throw new Error("Event compressors can only be constructed with instances of CompressionRule");
    this.compressionRules = compressionRules;
};

});


parcelRegister("99h0F", function(module, exports) {

$parcel$export(module.exports, "StopLowPriorityEventDelayReason", function () { return $01b808df67326e23$export$fa6e3729c21cb8f; });
var $01b808df67326e23$export$fa6e3729c21cb8f = /*#__PURE__*/ function(StopLowPriorityEventDelayReason) {
    StopLowPriorityEventDelayReason["TIMEOUT"] = "timeout";
    StopLowPriorityEventDelayReason["MANUAL"] = "manual";
    return StopLowPriorityEventDelayReason;
}({});

});


parcelRegister("lJWVG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd3b831d8d57614c$export$2e2bcd8739ae039; });

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $l29cN = parcelRequire("l29cN");

var $jjExS = parcelRequire("jjExS");

var $ktzPa = parcelRequire("ktzPa");

var $gXdT6 = parcelRequire("gXdT6");

var $4eyPu = parcelRequire("4eyPu");

var $445Ie = parcelRequire("445Ie");

var $alx1Y = parcelRequire("alx1Y");

var $2p4pW = parcelRequire("2p4pW");

var $7bKoC = parcelRequire("7bKoC");

var $axYp2 = parcelRequire("axYp2");

var $il7rS = parcelRequire("il7rS");
function $fd3b831d8d57614c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fd3b831d8d57614c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fd3b831d8d57614c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fd3b831d8d57614c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $fd3b831d8d57614c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function EventProcessor(options) {
        (0, $4GJKx._)(this, EventProcessor);
        var _this = this;
        // Using anonymous function so it can have the BatchFlushCallback type associated with it
        // And to allow it to not need bind when passing through to ResilieceQueue.
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "sendEvents", function() {
            var _ref = (0, $kSuI9._)(function(items, callback) {
                var httpRetryCount, metricsPayload, metadata, key, eventsWithXID, sentAt, unpackagedEvents, batchBody, response, error;
                return (0, $l29cN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            httpRetryCount = _this.resilienceQueue.getGlobalRetryCount();
                            metricsPayload = _this.metrics.getMetricsPayload();
                            metadata = $fd3b831d8d57614c$var$_objectSpread($fd3b831d8d57614c$var$_objectSpread({}, metricsPayload), {}, {
                                httpRetryCount: httpRetryCount
                            });
                            for(var key in metadata)// @ts-ignore Some keys maybe a string, but these will never equal 0
                            if (metadata[key] === 0) // @ts-ignore Save space in requests by removing metrics with no impact
                            delete metadata[key];
                            return [
                                4,
                                _this.attachXIDs(items)
                            ];
                        case 1:
                            eventsWithXID = _state.sent();
                            // Calculating sentAt after the XID generation as this may take some time.
                            sentAt = new Date().toISOString();
                            unpackagedEvents = eventsWithXID.map(function(item) {
                                item.msg.sentAt = sentAt;
                                return item.msg;
                            });
                            batchBody = {
                                batch: unpackagedEvents,
                                sentAt: sentAt,
                                metadata: metadata
                            };
                            _state.label = 2;
                        case 2:
                            _state.trys.push([
                                2,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4,
                                (0, $2p4pW.sendEvents)({
                                    url: _this.gasv3BatchUrl,
                                    batch: batchBody,
                                    timeout: _this.options.requestTimeout
                                })
                            ];
                        case 3:
                            response = _state.sent();
                            _this.metrics.subtractFromMetrics(metricsPayload);
                            callback(null, response);
                            return [
                                3,
                                5
                            ];
                        case 4:
                            error = _state.sent();
                            callback(error, null);
                            return [
                                3,
                                5
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(items, callback) {
                return _ref.apply(this, arguments);
            };
        }());
        this.user = new (0, $axYp2.default)();
        this.options = $fd3b831d8d57614c$var$_objectSpread($fd3b831d8d57614c$var$_objectSpread({}, options), {}, {
            requestTimeout: options.requestTimeout || (0, $alx1Y.DEFAULT_REQUEST_TIMEOUT),
            retryQueueOptions: options.retryQueueOptions || {},
            logger: options.logger || console
        });
        this.xidPromiseCallback = options.xidPromiseGetter();
        this.gasv3BatchUrl = "".concat(options.apiHostProtocol, "://").concat(options.apiHost, "/batch");
        this.metrics = (0, $4eyPu.default)();
        this.resilienceQueue = (0, $gXdT6.default)(options.retryQueuePrefix, options.product, this.options.retryQueueOptions, this.options.logger);
        this.resilienceQueue.start(this.sendEvents);
    }
    (0, $1wc17._)(EventProcessor, [
        {
            key: "getUser",
            value: function getUser() {
                return this.user;
            }
        },
        {
            key: "track",
            value: function track(eventName, builtEvent, context, callback) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var baseEvent, eventWithoutMessageId, event, packagedEvent;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                baseEvent = _this.buildBaseEvent(context, (0, $7bKoC.SegmentEventTypes).TRACK, builtEvent);
                                eventWithoutMessageId = $fd3b831d8d57614c$var$_objectSpread($fd3b831d8d57614c$var$_objectSpread({}, baseEvent), {}, {
                                    type: (0, $7bKoC.SegmentEventTypes).TRACK,
                                    properties: (0, $il7rS.prepareEventProperties)(builtEvent),
                                    event: eventName
                                });
                                event = $fd3b831d8d57614c$var$_objectSpread($fd3b831d8d57614c$var$_objectSpread({}, eventWithoutMessageId), {}, {
                                    messageId: _this.createMessageId()
                                });
                                packagedEvent = _this.packageEvent(event);
                                return [
                                    4,
                                    _this.resilienceQueue.addItem(packagedEvent)
                                ];
                            case 1:
                                _state.sent();
                                if (callback) callback();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "page",
            value: function page(eventName, builtEvent, context, callback) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var baseEvent, eventWithoutMessageId, event, packagedEvent;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                baseEvent = _this.buildBaseEvent(context, (0, $7bKoC.SegmentEventTypes).PAGE, builtEvent);
                                eventWithoutMessageId = $fd3b831d8d57614c$var$_objectSpread($fd3b831d8d57614c$var$_objectSpread({}, baseEvent), {}, {
                                    type: (0, $7bKoC.SegmentEventTypes).PAGE,
                                    properties: (0, $il7rS.prepareEventProperties)(builtEvent),
                                    name: eventName
                                });
                                event = $fd3b831d8d57614c$var$_objectSpread($fd3b831d8d57614c$var$_objectSpread({}, eventWithoutMessageId), {}, {
                                    messageId: _this.createMessageId()
                                });
                                packagedEvent = _this.packageEvent(event);
                                return [
                                    4,
                                    _this.resilienceQueue.addItem(packagedEvent)
                                ];
                            case 1:
                                _state.sent();
                                if (callback) callback();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "identify",
            value: // Segment uses the identifier to update user id which we have already done in the analyticsWebClient.ts
            function identify(_identifier, builtEvent, context, callback) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var baseEvent, eventWithoutMessageId, event, packagedEvent;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                baseEvent = _this.buildBaseEvent(context, (0, $7bKoC.SegmentEventTypes).IDENTIFY, builtEvent);
                                eventWithoutMessageId = $fd3b831d8d57614c$var$_objectSpread($fd3b831d8d57614c$var$_objectSpread({}, baseEvent), {}, {
                                    type: (0, $7bKoC.SegmentEventTypes).IDENTIFY,
                                    traits: (0, $il7rS.prepareEventProperties)(builtEvent)
                                });
                                event = $fd3b831d8d57614c$var$_objectSpread($fd3b831d8d57614c$var$_objectSpread({}, eventWithoutMessageId), {}, {
                                    messageId: _this.createMessageId()
                                });
                                packagedEvent = _this.packageEvent(event);
                                return [
                                    4,
                                    _this.resilienceQueue.addItem(packagedEvent)
                                ];
                            case 1:
                                _state.sent();
                                if (callback) callback();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "buildBaseEvent",
            value: function buildBaseEvent(context, type, overrides) {
                var clonedContext = (0, $il7rS.prepareEventProperties)(context);
                var segmentContext = (0, $il7rS.buildContext)(clonedContext);
                return {
                    context: segmentContext,
                    timestamp: new Date().toISOString(),
                    type: type,
                    userId: this.user.getUserId(),
                    anonymousId: overrides.anonymousId || this.user.getAnonymousId()
                };
            }
        },
        {
            key: "createMessageId",
            value: function createMessageId() {
                return "ajs-".concat((0, (/*@__PURE__*/$parcel$interopDefault($ktzPa)))());
            }
        },
        {
            key: "packageEvent",
            value: function packageEvent(event) {
                var _this_options = this.options, apiHost = _this_options.apiHost, apiHostProtocol = _this_options.apiHostProtocol;
                return {
                    headers: {
                        "Content-Type": "text/plain"
                    },
                    msg: event,
                    url: "".concat(apiHostProtocol, "://").concat(apiHost, "/").concat(event.type.charAt(0))
                };
            }
        },
        {
            key: "attachXIDs",
            value: function attachXIDs(items) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $l29cN.__generator)(this, function(_state) {
                        if (_this.xidPromiseCallback) return [
                            2,
                            (0, $445Ie.attachXidToMultipleEvents)(items, _this.xidPromiseCallback)
                        ];
                        return [
                            2,
                            Promise.resolve(items)
                        ];
                    });
                })();
            }
        }
    ]);
    return EventProcessor;
}();

});
parcelRegister("gXdT6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c57cedd9d57aefaa$export$2e2bcd8739ae039; });

var $65IGn = parcelRequire("65IGn");

var $c57cedd9d57aefaa$export$2e2bcd8739ae039 = function(retryQueuePrefix, product, options, logger) {
    return new (0, $65IGn.default)(retryQueuePrefix, product, options || {}, logger);
};

});
parcelRegister("65IGn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46f5deb60691457a$export$2e2bcd8739ae039; });

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $l29cN = parcelRequire("l29cN");

var $jjExS = parcelRequire("jjExS");

var $1wZPG = parcelRequire("1wZPG");
var $2LAL4 = parcelRequire("2LAL4");

var $2470d = parcelRequire("2470d");
var $bjrva = parcelRequire("bjrva");
var $fgvDu = parcelRequire("fgvDu");

var $4eyPu = parcelRequire("4eyPu");

var $052TO = parcelRequire("052TO");

var $7cLi3 = parcelRequire("7cLi3");
var $cGib5 = parcelRequire("cGib5");

var $8g8TT = parcelRequire("8g8TT");
function $46f5deb60691457a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $46f5deb60691457a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $46f5deb60691457a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $46f5deb60691457a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $46f5deb60691457a$var$ONE_MINUTE = 60000;
var $46f5deb60691457a$var$LONG_POLLING_OPTIONS = {
    backoffFactor: 0,
    backoffJitterPercentage: 0,
    flushWaitMs: $46f5deb60691457a$var$ONE_MINUTE,
    minRetryDelay: $46f5deb60691457a$var$ONE_MINUTE,
    maxRetryDelay: $46f5deb60691457a$var$ONE_MINUTE
};
var $46f5deb60691457a$export$d219df4fe04c04a7 = {
    backoffFactor: 2,
    backoffJitterPercentage: 0.2,
    batchFlushSize: 7,
    flushBeforeUnload: false,
    flushWaitMs: 500,
    maxAttempts: 10,
    // TODO figure out this number. For indexeddb we are sharing the queue with all tabs
    maxItems: 1000,
    maxRetryDelay: 30000,
    minRetryDelay: 1000
};
var $46f5deb60691457a$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function PullBatchableQueue(queuePrefix, product, options, logger) {
        var _this = this;
        (0, $4GJKx._)(this, PullBatchableQueue);
        this.queuePrefix = queuePrefix;
        // Avoiding using options in ResilienceDB at this stage as
        // the options are optimised for the PushBatchableQueue
        this.resilience = new (0, $bjrva.default)(product, {
            logger: logger,
            maxAttempts: options === null || options === void 0 ? void 0 : options.maxAttempts,
            maxEventLimit: options === null || options === void 0 ? void 0 : options.maxItems
        });
        this.options = this.buildOptions(options);
        this.scheduler = new (0, $7cLi3.default)($46f5deb60691457a$var$_objectSpread($46f5deb60691457a$var$_objectSpread({}, this.options), {}, {
            waitInterval: options !== null && options !== void 0 && options.flushBeforeUnload ? 0 : this.options.flushWaitMs
        }), this.scheduleCallback.bind(this));
        this.longPollingScheduler = new (0, $7cLi3.default)($46f5deb60691457a$var$_objectSpread($46f5deb60691457a$var$_objectSpread({}, $46f5deb60691457a$var$LONG_POLLING_OPTIONS), {}, {
            waitInterval: $46f5deb60691457a$var$LONG_POLLING_OPTIONS.flushWaitMs
        }), this.scheduleLongCallBack.bind(this));
        this.metricsCollector = (0, $4eyPu.default)();
        this.networkStatus = new (0, $052TO.default)(function(status) {
            if (status === (0, $8g8TT.NetworkStatusEnum).OFFLINE) _this.scheduler.stop();
            else _this.checkEventCountAndReschedule();
        });
    }
    (0, $1wc17._)(PullBatchableQueue, [
        {
            key: "start",
            value: function start(flushCallback) {
                this.batchFlushCallback = flushCallback;
                this.longPollingScheduler.schedule();
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.scheduler.stop();
                this.longPollingScheduler.stop();
            }
        },
        {
            key: "addItem",
            value: function addItem(item) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var jsonStringifiedAndParsedItem, numberOfEvictedItems;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // Since Jira and Confluence use `.toJSON` on objects that should be strings
                                // And expect us to use `JSON.stringify` on these objects,
                                // And indexeddb strips these functions from the objects when adding them to the DB,
                                // We must run this silly stringify and parse before passing the event to the resilience meechanism.
                                // Planning on removing this in v4
                                jsonStringifiedAndParsedItem = JSON.parse(JSON.stringify(item));
                                return [
                                    4,
                                    _this.resilience.addItem(jsonStringifiedAndParsedItem, {}, (0, $fgvDu.GuardPolicy).EVICT)
                                ];
                            case 1:
                                numberOfEvictedItems = _state.sent().numberOfEvictedItems;
                                _this.scheduler.schedule();
                                _this.metricsCollector.addToEventCount();
                                if (numberOfEvictedItems > 0) _this.metricsCollector.addToItemsDiscardedByOverflowCounter(numberOfEvictedItems);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getGlobalRetryCount",
            value: function getGlobalRetryCount() {
                return this.scheduler.getFailureCount();
            }
        },
        {
            key: "scheduleCallback",
            value: function scheduleCallback(done) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var result, error;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // Even though we stopped the scheduler, it can be restarted with a call to schedule.
                                // This could be triggered by a new event or the longPollingScheduler
                                if (_this.networkStatus.getNetworkStatus() === (0, $8g8TT.NetworkStatusEnum).OFFLINE) {
                                    done((0, $cGib5.DoneState).NOOP);
                                    return [
                                        2
                                    ];
                                }
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    4,
                                    6
                                ]);
                                return [
                                    4,
                                    _this.resilience.processItems(_this.flush.bind(_this), _this.options.batchFlushSize)
                                ];
                            case 2:
                                result = _state.sent();
                                done(result);
                                return [
                                    3,
                                    6
                                ];
                            case 3:
                                error = _state.sent();
                                if (error.name === (0, $2470d.CallbackProcessingErrorName)) {
                                    done((0, $cGib5.DoneState).ERROR);
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    3,
                                    6
                                ];
                            case 4:
                                return [
                                    4,
                                    _this.checkEventCountAndReschedule()
                                ];
                            case 5:
                                _state.sent();
                                return [
                                    7
                                ];
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "checkEventCountAndReschedule",
            value: function checkEventCountAndReschedule() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var eventWaitingCount;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.resilience.getItemCount()
                                ];
                            case 1:
                                eventWaitingCount = _state.sent();
                                if (eventWaitingCount > 0) _this.scheduler.schedule({
                                    immediate: eventWaitingCount >= _this.options.batchFlushSize
                                });
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "scheduleLongCallBack",
            value: function scheduleLongCallBack(done) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var numberOfQueuesPurged, reclaimMetrics;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // Eventually we will want to send data about how many queues were purged
                                numberOfQueuesPurged = (0, $1wZPG.default)(_this.queuePrefix);
                                _this.metricsCollector.addToPurgedQueuesMetrics(numberOfQueuesPurged);
                                return [
                                    4,
                                    (0, $2LAL4.default)(_this.queuePrefix, function() {
                                        var _ref = (0, $kSuI9._)(function(localStorageItems) {
                                            var itemsToAdd, _ref, addedEvents;
                                            return (0, $l29cN.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        itemsToAdd = localStorageItems.map(function(localStorageItem) {
                                                            return {
                                                                item: localStorageItem.item,
                                                                retryAttempts: localStorageItem.attemptNumber,
                                                                id: localStorageItem.id
                                                            };
                                                        });
                                                        return [
                                                            4,
                                                            _this.resilience.bulkAddItem(itemsToAdd, (0, $fgvDu.GuardPolicy).IGNORE)
                                                        ];
                                                    case 1:
                                                        _ref = _state.sent(), addedEvents = _ref.items;
                                                        if (addedEvents.length === itemsToAdd.length) return [
                                                            2,
                                                            {
                                                                status: "successful"
                                                            }
                                                        ];
                                                        else return [
                                                            2,
                                                            {
                                                                status: "partial",
                                                                acceptedItemIds: addedEvents.map(function(event) {
                                                                    return event.id;
                                                                })
                                                            }
                                                        ];
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                        return function(localStorageItems) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }())
                                ];
                            case 1:
                                reclaimMetrics = _state.sent();
                                _this.metricsCollector.addToReclaimMetrics(reclaimMetrics);
                                // We dont want to flush events from here as there maybe issues with analytics-service
                                // Scheduler has all the context and can schedule the next batch accordingly
                                return [
                                    4,
                                    _this.checkEventCountAndReschedule()
                                ];
                            case 2:
                                _state.sent();
                                done((0, $cGib5.DoneState).SUCCESS);
                                _this.longPollingScheduler.schedule();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "flush",
            value: function flush(wrappedItems, otherMetadata) {
                var _this = this;
                this.metricsCollector.setResilienceMechanism(this.resilience.storeType());
                var batchFlushCallback = this.batchFlushCallback;
                if (!batchFlushCallback) throw new Error("batchFlushCallback has not been set. Call PullBatchableQueue#start first.");
                return new Promise(function(resolve, reject) {
                    if (wrappedItems.length <= 0) {
                        resolve((0, $cGib5.DoneState).NOOP);
                        return;
                    }
                    var items = wrappedItems.map(function(wrappedItem) {
                        var item = wrappedItem.item;
                        if (wrappedItem.retryAttempts > 0 && item.msg) {
                            if (!item.msg._metadata) item.msg._metadata = {};
                            item.msg._metadata.failedAttempts = wrappedItem.retryAttempts;
                        }
                        return item;
                    });
                    batchFlushCallback(items, function(error) {
                        if (error) {
                            if (otherMetadata.numberOfDeletedItems > 0) _this.metricsCollector.addToItemsDiscardedByRetryCounter(otherMetadata.numberOfDeletedItems);
                            reject(error);
                        } else resolve((0, $cGib5.DoneState).SUCCESS);
                    });
                });
            }
        },
        {
            key: "buildOptions",
            value: function buildOptions(options) {
                return {
                    backoffFactor: (options === null || options === void 0 ? void 0 : options.backoffFactor) || $46f5deb60691457a$export$d219df4fe04c04a7.backoffFactor,
                    backoffJitterPercentage: (options === null || options === void 0 ? void 0 : options.backoffJitterPercentage) !== undefined ? options.backoffJitterPercentage : $46f5deb60691457a$export$d219df4fe04c04a7.backoffJitterPercentage,
                    batchFlushSize: (options === null || options === void 0 ? void 0 : options.batchFlushSize) || $46f5deb60691457a$export$d219df4fe04c04a7.batchFlushSize,
                    flushBeforeUnload: (options === null || options === void 0 ? void 0 : options.flushBeforeUnload) || $46f5deb60691457a$export$d219df4fe04c04a7.flushBeforeUnload,
                    flushWaitMs: (options === null || options === void 0 ? void 0 : options.flushWaitMs) || $46f5deb60691457a$export$d219df4fe04c04a7.flushWaitMs,
                    maxItems: (options === null || options === void 0 ? void 0 : options.maxItems) || $46f5deb60691457a$export$d219df4fe04c04a7.maxItems,
                    maxAttempts: (options === null || options === void 0 ? void 0 : options.maxAttempts) || $46f5deb60691457a$export$d219df4fe04c04a7.maxAttempts,
                    maxRetryDelay: (options === null || options === void 0 ? void 0 : options.maxRetryDelay) || $46f5deb60691457a$export$d219df4fe04c04a7.maxRetryDelay,
                    minRetryDelay: (options === null || options === void 0 ? void 0 : options.minRetryDelay) || $46f5deb60691457a$export$d219df4fe04c04a7.minRetryDelay
                };
            }
        }
    ]);
    return PullBatchableQueue;
}();

});
parcelRegister("1wZPG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11d8be3efa29ae45$export$2e2bcd8739ae039; });

var $cv9Rk = parcelRequire("cv9Rk");

var $2uE3S = parcelRequire("2uE3S");

var $kUoMr = parcelRequire("kUoMr");
// For more details on this funciton, see https://hello.atlassian.net/wiki/spaces/MEASURE/pages/585086028/Investigation+Local+storage+full
// TL;DR
// If a queue looses its `ack` key in localstorage, it will never get claimed.
// There is a small chance that this can happen.
// This function is to run through queues and clean any that have been orphaned.
// Keys stolen from https://github.com/segmentio/localstorage-retry/blob/master/lib/index.js#L55
var $11d8be3efa29ae45$var$validSuffixs = Object.values((0, $2uE3S.LocalStorageKeySuffix));
var $11d8be3efa29ae45$export$2e2bcd8739ae039 = function(prefix) {
    if (typeof prefix !== "string" || prefix.length === 0) // We do not want to start deleting everything in localstorage
    return 0;
    try {
        var queueStates = Object.keys(localStorage).filter(function(key) {
            return key && key.startsWith("".concat(prefix, ".")) || false;
        }).map(function(key) {
            return key.split(".");
        }).filter(function(splitKeys) {
            return splitKeys.length === 3 && $11d8be3efa29ae45$var$validSuffixs.includes(splitKeys[2]);
        }).reduce(function(accumulator, currentKeys) {
            var _currentKeys = (0, $cv9Rk._)(currentKeys, 3), id = _currentKeys[1], suffix = _currentKeys[2];
            if (accumulator[id] === undefined) accumulator[id] = {};
            accumulator[id][suffix] = true;
            return accumulator;
        }, {});
        var queuesToPurge = Object.keys(queueStates).filter(function(id) {
            return queueStates[id][(0, $2uE3S.LocalStorageKeySuffix).ACK] !== true;
        });
        queuesToPurge.forEach(function(id) {
            var _createLocalStorageKeys = (0, $kUoMr.createLocalStorageKeys)(prefix, id), queue = _createLocalStorageKeys.queue, inProgress = _createLocalStorageKeys.inProgress, reclaimStart = _createLocalStorageKeys.reclaimStart, reclaimEnd = _createLocalStorageKeys.reclaimEnd;
            localStorage.removeItem(inProgress);
            localStorage.removeItem(queue);
            localStorage.removeItem(reclaimStart);
            localStorage.removeItem(reclaimEnd);
        });
        return queuesToPurge.length;
    } catch (_error) {
    // Ignore errors from localStorage.
    }
    return 0;
};

});
parcelRegister("2uE3S", function(module, exports) {

$parcel$export(module.exports, "LocalStorageKeySuffix", function () { return $1d0d7579c4b0e3c5$export$ecfa71cbc9b28241; });
$parcel$export(module.exports, "Timers", function () { return $1d0d7579c4b0e3c5$export$8bb2c1fb2b1765a9; });
var $1d0d7579c4b0e3c5$export$ecfa71cbc9b28241 = /*#__PURE__*/ function(LocalStorageKeySuffix) {
    LocalStorageKeySuffix["IN_PROGRESS"] = "inProgress";
    LocalStorageKeySuffix["QUEUE"] = "queue";
    LocalStorageKeySuffix["RECLAIM_START"] = "reclaimStart";
    LocalStorageKeySuffix["RECLAIM_END"] = "reclaimEnd";
    LocalStorageKeySuffix["ACK"] = "ack";
    return LocalStorageKeySuffix;
}({});
var $1d0d7579c4b0e3c5$export$8bb2c1fb2b1765a9 = /*#__PURE__*/ function(Timers) {
    Timers[Timers["RECLAIM_TIMEOUT"] = 10000] = "RECLAIM_TIMEOUT";
    Timers[Timers["RECLAIM_WAIT"] = 500] = "RECLAIM_WAIT";
    Timers[Timers["RECLAIM_WAIT_THRESHOLD"] = 2000] = "RECLAIM_WAIT_THRESHOLD";
    return Timers;
}({});

});

parcelRegister("kUoMr", function(module, exports) {

$parcel$export(module.exports, "createLocalStorageKeys", function () { return $f38c427592ca2e81$export$8433d54f767cbec5; });

var $3sHb8 = parcelRequire("3sHb8");

var $2uE3S = parcelRequire("2uE3S");
var $f38c427592ca2e81$export$8433d54f767cbec5 = function(queuePrefix, queueId) {
    var _obj;
    return _obj = {}, (0, $3sHb8._)(_obj, (0, $2uE3S.LocalStorageKeySuffix).ACK, "".concat(queuePrefix, ".").concat(queueId, ".").concat((0, $2uE3S.LocalStorageKeySuffix).ACK)), (0, $3sHb8._)(_obj, (0, $2uE3S.LocalStorageKeySuffix).QUEUE, "".concat(queuePrefix, ".").concat(queueId, ".").concat((0, $2uE3S.LocalStorageKeySuffix).QUEUE)), (0, $3sHb8._)(_obj, (0, $2uE3S.LocalStorageKeySuffix).IN_PROGRESS, "".concat(queuePrefix, ".").concat(queueId, ".").concat((0, $2uE3S.LocalStorageKeySuffix).IN_PROGRESS)), (0, $3sHb8._)(_obj, (0, $2uE3S.LocalStorageKeySuffix).RECLAIM_START, "".concat(queuePrefix, ".").concat(queueId, ".").concat((0, $2uE3S.LocalStorageKeySuffix).RECLAIM_START)), (0, $3sHb8._)(_obj, (0, $2uE3S.LocalStorageKeySuffix).RECLAIM_END, "".concat(queuePrefix, ".").concat(queueId, ".").concat((0, $2uE3S.LocalStorageKeySuffix).RECLAIM_END)), _obj;
};

});


parcelRegister("2LAL4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $203c7bf7b9b4bd05$export$2e2bcd8739ae039; });

var $kSuI9 = parcelRequire("kSuI9");

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");

var $l29cN = parcelRequire("l29cN");

var $jjExS = parcelRequire("jjExS");

var $ktzPa = parcelRequire("ktzPa");

var $2uE3S = parcelRequire("2uE3S");

var $kUoMr = parcelRequire("kUoMr");
function $203c7bf7b9b4bd05$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $203c7bf7b9b4bd05$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $203c7bf7b9b4bd05$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $203c7bf7b9b4bd05$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Code we need to mimic:
// https://github.com/segmentio/localstorage-retry/blob/master/lib/index.js#L262-L357
// Note we do not want to run this library due to the performance, duplication and memory leak issues.
var $203c7bf7b9b4bd05$var$promisedSetTimeout = function(msToWait) {
    return new Promise(function(resolve) {
        setTimeout(resolve, msToWait);
    });
};
var $203c7bf7b9b4bd05$var$findOtherQueues = function(queuePrefix) {
    try {
        return Object.keys(localStorage).filter(function(key) {
            return key.startsWith(queuePrefix);
        }).map(function(key) {
            return key.split(".");
        }).filter(function(split) {
            if (split.length === 3 && split[0] === queuePrefix && split[2] === (0, $2uE3S.LocalStorageKeySuffix).ACK) try {
                var ackTimestamp = localStorage.getItem(split.join("."));
                if (ackTimestamp) {
                    var ackTimestampNumber = parseInt(ackTimestamp);
                    return (0, $2uE3S.Timers).RECLAIM_TIMEOUT + ackTimestampNumber < Date.now();
                }
            } catch (error) {
            // ignore and drop value
            }
            return false;
        }).map(function(split) {
            return split[1];
        });
    } catch (_error) {
    // Ignore errors from accessing localStorage.
    }
    return [];
};
var $203c7bf7b9b4bd05$var$tryReclaim = function() {
    var _ref = (0, $kSuI9._)(function(options, callback) {
        var _options_storageKeys, ack, reclaimStart, reclaimEnd, start;
        return (0, $l29cN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _options_storageKeys = options.storageKeys, ack = _options_storageKeys.ack, reclaimStart = _options_storageKeys.reclaimStart, reclaimEnd = _options_storageKeys.reclaimEnd;
                    start = Date.now();
                    localStorage.setItem(reclaimStart, options.reclaimProcessId);
                    localStorage.setItem(ack, start.toString());
                    return [
                        4,
                        $203c7bf7b9b4bd05$var$promisedSetTimeout((0, $2uE3S.Timers).RECLAIM_WAIT)
                    ];
                case 1:
                    _state.sent();
                    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
                    Date.now() > start + (0, $2uE3S.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
                    localStorage.getItem(reclaimStart) !== options.reclaimProcessId) throw new Error("Took to long to callback, reclaim abandonded. After reclaimStart.");
                    localStorage.setItem(reclaimEnd, options.reclaimProcessId);
                    return [
                        4,
                        $203c7bf7b9b4bd05$var$promisedSetTimeout((0, $2uE3S.Timers).RECLAIM_WAIT)
                    ];
                case 2:
                    _state.sent();
                    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
                    Date.now() > start + (0, $2uE3S.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
                    localStorage.getItem(reclaimStart) !== options.reclaimProcessId || localStorage.getItem(reclaimEnd) !== options.reclaimProcessId) throw new Error("Took to long to callback, reclaim abandonded. After reclaimEnd.");
                    return [
                        2,
                        $203c7bf7b9b4bd05$var$reclaim(options, callback)
                    ];
            }
        });
    });
    return function tryReclaim(options, callback) {
        return _ref.apply(this, arguments);
    };
}();
var $203c7bf7b9b4bd05$var$reclaim = function() {
    var _ref = (0, $kSuI9._)(function(options, callback) {
        var _options_storageKeys, queue, inProgress, eventsInQueue, eventsInProgress, arrayOfEventsInProgress, eventsToProcess, result, leftover;
        return (0, $l29cN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _options_storageKeys = options.storageKeys, queue = _options_storageKeys.queue, inProgress = _options_storageKeys.inProgress;
                    // Queue is an array of events while inProgress is an object with a uuid for key
                    // Either of these queues may legitimately be missing.
                    eventsInQueue = JSON.parse(localStorage.getItem(queue) || "[]");
                    eventsInProgress = JSON.parse(localStorage.getItem(inProgress) || "{}");
                    arrayOfEventsInProgress = Object.entries(eventsInProgress).map(function(param) {
                        var _param = (0, $cv9Rk._)(param, 2), key = _param[0], item = _param[1];
                        var itemWithId = $203c7bf7b9b4bd05$var$_objectSpread($203c7bf7b9b4bd05$var$_objectSpread({}, item), {}, {
                            // LocalStorage-retry would add the attemptCounter after failure, rather than
                            // as it was being processed
                            attemptNumber: item.attemptNumber + 1,
                            id: key
                        });
                        return itemWithId;
                    });
                    eventsToProcess = (0, $c6Xmf._)(eventsInQueue).concat((0, $c6Xmf._)(arrayOfEventsInProgress));
                    if (!(eventsToProcess.length > 0)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        callback(eventsToProcess)
                    ];
                case 1:
                    result = _state.sent();
                    if (result.status === "successful") $203c7bf7b9b4bd05$var$clearLocalStorageKeys(options.storageKeys);
                    else if (result.status === "partial") {
                        // Dont delete all events if we are only able to take some of them.
                        leftover = eventsToProcess.filter(function(event) {
                            return !result.acceptedItemIds.includes(event.id);
                        });
                        // This way around, we can almost ensure that we wont hit memory quota exceeded errors.
                        // However, there is a very small chance that we may lose events if the process exits between these two commands.
                        localStorage.removeItem(inProgress);
                        localStorage.setItem(queue, JSON.stringify(leftover));
                        return [
                            2,
                            {
                                fullReclaim: false
                            }
                        ];
                    }
                    return [
                        3,
                        3
                    ];
                case 2:
                    $203c7bf7b9b4bd05$var$clearLocalStorageKeys(options.storageKeys);
                    _state.label = 3;
                case 3:
                    return [
                        2,
                        {
                            fullReclaim: true
                        }
                    ];
            }
        });
    });
    return function reclaim(options, callback) {
        return _ref.apply(this, arguments);
    };
}();
// Exterminate
var $203c7bf7b9b4bd05$var$clearLocalStorageKeys = function(keys) {
    // Always good to do queue and inprogress first to reduce duplications
    // and to free up more space in localstorage
    localStorage.removeItem(keys.queue);
    localStorage.removeItem(keys.inProgress);
    localStorage.removeItem(keys.reclaimEnd);
    localStorage.removeItem(keys.reclaimStart);
    // This has to be last or we risk leaving things in localStorage that have to be purged
    localStorage.removeItem(keys.ack);
};
var $203c7bf7b9b4bd05$export$2e2bcd8739ae039 = function() {
    var _ref = (0, $kSuI9._)(function(queuePrefix, callback) {
        var reclaimProcessId, queuesToReclaim, claims, settledClaims, failedReclaims, successfulClaims, fullReclaims, partialReclaims;
        return (0, $l29cN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof queuePrefix !== "string" || queuePrefix.length === 0) // We do not want to start deleting everything in localstorage
                    return [
                        2,
                        {
                            fullReclaims: 0,
                            partialReclaims: 0,
                            failedReclaims: 0
                        }
                    ];
                    reclaimProcessId = (0, (/*@__PURE__*/$parcel$interopDefault($ktzPa)))();
                    queuesToReclaim = $203c7bf7b9b4bd05$var$findOtherQueues(queuePrefix);
                    claims = queuesToReclaim.map(function(id) {
                        return $203c7bf7b9b4bd05$var$tryReclaim({
                            queuePrefix: queuePrefix,
                            reclaimProcessId: reclaimProcessId,
                            storageKeys: (0, $kUoMr.createLocalStorageKeys)(queuePrefix, id)
                        }, callback);
                    });
                    return [
                        4,
                        Promise.allSettled(claims)
                    ];
                case 1:
                    settledClaims = _state.sent();
                    failedReclaims = settledClaims.filter(function(claim) {
                        return claim.status === "rejected";
                    });
                    successfulClaims = settledClaims.filter(function(settledValue) {
                        return settledValue.status === "fulfilled";
                    }).map(function(result) {
                        return result.value;
                    });
                    fullReclaims = successfulClaims.filter(function(claim) {
                        return claim.fullReclaim;
                    });
                    partialReclaims = successfulClaims.filter(function(claim) {
                        return !claim.fullReclaim;
                    });
                    return [
                        2,
                        {
                            failedReclaims: failedReclaims.length,
                            partialReclaims: partialReclaims.length,
                            fullReclaims: fullReclaims.length
                        }
                    ];
            }
        });
    });
    return function(queuePrefix, callback) {
        return _ref.apply(this, arguments);
    };
}();

});

parcelRegister("2470d", function(module, exports) {

$parcel$export(module.exports, "CallbackProcessingErrorName", function () { return $1811630393f5d633$export$a409c8de90e11e14; });
$parcel$export(module.exports, "default", function () { return $1811630393f5d633$export$2e2bcd8739ae039; });

var $d3H5E = parcelRequire("d3H5E");

var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $FuVm8 = parcelRequire("FuVm8");

var $ohfOJ = parcelRequire("ohfOJ");
var $1811630393f5d633$export$a409c8de90e11e14 = "CallbackProcessingError";
var $1811630393f5d633$export$2e2bcd8739ae039 = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $dcsZi._)(CallbackProcessingError, Error1);
    var _super = (0, $ohfOJ._)(CallbackProcessingError);
    function CallbackProcessingError(error) {
        (0, $4GJKx._)(this, CallbackProcessingError);
        var _this;
        var messageFromError = error && typeof error === "object" && "toString" in error && typeof error.toString === "function" && error.toString();
        var messageFromString = typeof error === "string" && error;
        var message = messageFromError || messageFromString || "Argument passed to CallbackProcessingError was not an Error or string.";
        _this = _super.call(this, "Error thrown while processing events in callback: ".concat(message));
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf((0, $d3H5E._)(_this), CallbackProcessingError.prototype);
        _this.name = $1811630393f5d633$export$a409c8de90e11e14;
        return _this;
    }
    return CallbackProcessingError;
}((0, $FuVm8._)(Error));

});

parcelRegister("bjrva", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83c6cd57033c1bf6$export$2e2bcd8739ae039; });

var $9K0bJ = parcelRequire("9K0bJ");

var $fgvDu = parcelRequire("fgvDu");

var $2470d = parcelRequire("2470d");
var $83c6cd57033c1bf6$export$2e2bcd8739ae039 = (0, $9K0bJ.default);

});
parcelRegister("9K0bJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $71788e5388026835$export$2e2bcd8739ae039; });

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $l29cN = parcelRequire("l29cN");

var $fgvDu = parcelRequire("fgvDu");

var $767B8 = parcelRequire("767B8");
var $7GpsM = parcelRequire("7GpsM");

var $lNmAq = parcelRequire("lNmAq");

var $aJcKS = parcelRequire("aJcKS");

var $gyA6P = parcelRequire("gyA6P");
var $71788e5388026835$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function DbDelegator(namespace) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $4GJKx._)(this, DbDelegator);
        this.namespace = namespace;
        this.options = (0, $gyA6P.createOptionsWithDefaults)(options);
        if (!namespace || namespace.length === 0 || typeof namespace !== "string") throw new Error("Invalid namespace provided");
        this.resilience = this.getResilienceMechanism(namespace, options);
    }
    (0, $1wc17._)(DbDelegator, [
        {
            key: "getResilienceMechanism",
            value: function getResilienceMechanism(namespace, options) {
                if (!options.useMemory) try {
                    return new (0, $lNmAq.default)(namespace, options);
                } catch (error) {
                    if (!(error instanceof (0, $767B8.default))) {
                        var _options$logger;
                        (_options$logger = options.logger) === null || _options$logger === void 0 || _options$logger.warn("Attempted to create IndexedDbResilience but failed. Using memory instead.");
                    }
                }
                return new (0, $aJcKS.default)(this.namespace, options);
            }
        },
        {
            key: "addItem",
            value: function addItem(item, options) {
                var policy = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (0, $fgvDu.GuardPolicy).ABANDON;
                var _this = this;
                return this.runOrFailOver(function() {
                    return _this.resilience.addItem(item, options, policy);
                });
            }
        },
        {
            key: "bulkAddItem",
            value: function bulkAddItem(itemOptions) {
                var policy = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, $fgvDu.GuardPolicy).ABANDON;
                var _this = this;
                return this.runOrFailOver(function() {
                    return _this.resilience.bulkAddItem(itemOptions, policy);
                });
            }
        },
        {
            key: "getItems",
            value: function getItems(count) {
                var _this = this;
                return this.runOrFailOver(function() {
                    return _this.resilience.getItems(count);
                });
            }
        },
        {
            key: "deleteItems",
            value: function deleteItems(itemIds) {
                var _this = this;
                return this.runOrFailOver(function() {
                    return _this.resilience.deleteItems(itemIds);
                });
            }
        },
        {
            key: "getItemCount",
            value: function getItemCount() {
                var _this = this;
                return this.runOrFailOver(function() {
                    return _this.resilience.getItemCount();
                });
            }
        },
        {
            key: "processItems",
            value: function processItems(processFn, count) {
                var _this = this;
                return this.runOrFailOver(function() {
                    return _this.resilience.processItems(processFn, count);
                });
            }
        },
        {
            key: "storeType",
            value: function storeType() {
                return this.resilience.storeType();
            }
        },
        {
            key: "runOrFailOver",
            value: function runOrFailOver(runnable) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var error;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    6
                                ]);
                                return [
                                    4,
                                    runnable()
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 2:
                                error = _state.sent();
                                if (!(0, $7GpsM.shouldIgnoreResilienceDbError)(error)) return [
                                    3,
                                    3
                                ];
                                throw error;
                            case 3:
                                if (!(_this.resilience.storeType() === (0, $fgvDu.StoreType).INDEXEDDB)) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    _this.failOver()
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                return [
                                    2,
                                    runnable()
                                ];
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "failOver",
            value: function failOver() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var oldResilience, newResilience, items, bulkAddItemsResponse, addedItemIds, error;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // Attempt to get any events we can and put them into memory
                                oldResilience = _this.resilience;
                                newResilience = new (0, $aJcKS.default)(_this.namespace, _this.options);
                                _this.resilience = newResilience;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    ,
                                    7
                                ]);
                                return [
                                    4,
                                    oldResilience.getItems(_this.options.maxEventLimit)
                                ];
                            case 2:
                                items = _state.sent().items;
                                if (!(items.length > 0)) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    newResilience.bulkAddItemWrapperType(items, (0, $fgvDu.GuardPolicy).IGNORE)
                                ];
                            case 3:
                                bulkAddItemsResponse = _state.sent();
                                addedItemIds = bulkAddItemsResponse.items.map(function(item) {
                                    return item.id;
                                });
                                return [
                                    4,
                                    oldResilience.deleteItems(addedItemIds)
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                error = _state.sent();
                                _this.options.logger.warn("Unexpected error from ResilienceDb, switching to MemoryDb");
                                return [
                                    3,
                                    7
                                ];
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return DbDelegator;
}();

});
parcelRegister("fgvDu", function(module, exports) {

$parcel$export(module.exports, "NAMESPACE_AND_TIME_ADDED_INDEX", function () { return $b1d0e3e54be62f41$export$d21fbb25eb37b5bf; });
$parcel$export(module.exports, "RESILIENCE_DB_NAME", function () { return $b1d0e3e54be62f41$export$8cad224051643259; });
$parcel$export(module.exports, "RESILIENCE_STORE_NAME", function () { return $b1d0e3e54be62f41$export$3d8420be07b276ab; });
$parcel$export(module.exports, "TIME_TO_PROCESS_AFTER_INDEX", function () { return $b1d0e3e54be62f41$export$a512a65455fce2a6; });
$parcel$export(module.exports, "TIME_ADDED_INDEX", function () { return $b1d0e3e54be62f41$export$89d9c1ff8ac91862; });
$parcel$export(module.exports, "RETRY_INDEX", function () { return $b1d0e3e54be62f41$export$a37d385bcd713809; });
$parcel$export(module.exports, "INDEXEDDB_TIMEOUT", function () { return $b1d0e3e54be62f41$export$6d8635fed0e4b14d; });
$parcel$export(module.exports, "StoreType", function () { return $b1d0e3e54be62f41$export$39337ab5872e9457; });
$parcel$export(module.exports, "GuardPolicy", function () { return $b1d0e3e54be62f41$export$7710d69e6f450f20; });
var $b1d0e3e54be62f41$export$d21fbb25eb37b5bf = "namespace-timeAdded";
var $b1d0e3e54be62f41$export$8cad224051643259 = "analytics-web-client";
var $b1d0e3e54be62f41$export$3d8420be07b276ab = "analytics-resilience";
var $b1d0e3e54be62f41$export$a512a65455fce2a6 = "timeToBeProcessedAfter";
var $b1d0e3e54be62f41$export$89d9c1ff8ac91862 = "timeAdded";
var $b1d0e3e54be62f41$export$a37d385bcd713809 = "retryAttempts";
var $b1d0e3e54be62f41$export$6d8635fed0e4b14d = 15000;
var $b1d0e3e54be62f41$export$39337ab5872e9457 = /*#__PURE__*/ function(StoreType) {
    StoreType["INDEXEDDB"] = "indexeddb";
    StoreType["MEMORY"] = "memory";
    return StoreType;
}({});
var $b1d0e3e54be62f41$export$7710d69e6f450f20 = /*#__PURE__*/ function(GuardPolicy) {
    GuardPolicy["IGNORE"] = "ignore";
    GuardPolicy["ABANDON"] = "abandon";
    GuardPolicy["EVICT"] = "evict";
    return GuardPolicy;
}({});

});

parcelRegister("767B8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52aefcbee4b0326f$export$2e2bcd8739ae039; });

var $d3H5E = parcelRequire("d3H5E");

var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $FuVm8 = parcelRequire("FuVm8");

var $ohfOJ = parcelRequire("ohfOJ");
var $52aefcbee4b0326f$export$fc14cf6dcea0f8ed = "NoIndexedDbError";
var $52aefcbee4b0326f$export$2e2bcd8739ae039 = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $dcsZi._)(NoIndexedDbError, Error1);
    var _super = (0, $ohfOJ._)(NoIndexedDbError);
    function NoIndexedDbError() {
        (0, $4GJKx._)(this, NoIndexedDbError);
        var _this;
        _this = _super.call(this, "window.indexeddb is undefined.");
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf((0, $d3H5E._)(_this), NoIndexedDbError.prototype);
        _this.name = $52aefcbee4b0326f$export$fc14cf6dcea0f8ed;
        return _this;
    }
    return NoIndexedDbError;
}((0, $FuVm8._)(Error));

});

parcelRegister("7GpsM", function(module, exports) {

$parcel$export(module.exports, "shouldIgnoreResilienceDbError", function () { return $5980351f4567580c$export$74101021e0969375; });

var $1TmaA = parcelRequire("1TmaA");

var $2470d = parcelRequire("2470d");

var $24jTd = parcelRequire("24jTd");
var $5980351f4567580c$export$74101021e0969375 = function(error) {
    if (error && typeof error === "object" && "name" in error) {
        var errorWithName = error;
        return typeof errorWithName.name === "string" && (errorWithName.name === (0, $1TmaA.AbandonWriteErrorName) || errorWithName.name === (0, $2470d.CallbackProcessingErrorName) || errorWithName.name === (0, $24jTd.InvalidPolicyErrorName));
    }
    return false;
};

});
parcelRegister("1TmaA", function(module, exports) {

$parcel$export(module.exports, "AbandonWriteErrorName", function () { return $160c1ff311a597b6$export$ba95206613c96b28; });
$parcel$export(module.exports, "default", function () { return $160c1ff311a597b6$export$2e2bcd8739ae039; });

var $d3H5E = parcelRequire("d3H5E");

var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $FuVm8 = parcelRequire("FuVm8");

var $ohfOJ = parcelRequire("ohfOJ");
var $160c1ff311a597b6$export$ba95206613c96b28 = "AbandonWriteError";
var $160c1ff311a597b6$export$2e2bcd8739ae039 = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $dcsZi._)(AbandonWriteError, Error1);
    var _super = (0, $ohfOJ._)(AbandonWriteError);
    function AbandonWriteError(source) {
        (0, $4GJKx._)(this, AbandonWriteError);
        var _this;
        _this = _super.call(this, "Event Limit reached. Abandoning write to: ".concat(source));
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf((0, $d3H5E._)(_this), AbandonWriteError.prototype);
        _this.name = $160c1ff311a597b6$export$ba95206613c96b28;
        return _this;
    }
    return AbandonWriteError;
}((0, $FuVm8._)(Error));

});

parcelRegister("24jTd", function(module, exports) {

$parcel$export(module.exports, "InvalidPolicyErrorName", function () { return $181b6220a4c3caa7$export$7e7aee9a953465ec; });
$parcel$export(module.exports, "default", function () { return $181b6220a4c3caa7$export$2e2bcd8739ae039; });

var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $FuVm8 = parcelRequire("FuVm8");

var $ohfOJ = parcelRequire("ohfOJ");
var $181b6220a4c3caa7$export$7e7aee9a953465ec = "InvalidPolicyError";
var $181b6220a4c3caa7$export$2e2bcd8739ae039 = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $dcsZi._)(InvalidPolicyError, Error1);
    var _super = (0, $ohfOJ._)(InvalidPolicyError);
    function InvalidPolicyError(policy, method) {
        (0, $4GJKx._)(this, InvalidPolicyError);
        var _this;
        _this = _super.call(this, "Method '".concat(method, "' cannot be called with policy '").concat(policy, "'."));
        _this.name = $181b6220a4c3caa7$export$7e7aee9a953465ec;
        return _this;
    }
    return InvalidPolicyError;
}((0, $FuVm8._)(Error));

});


parcelRegister("lNmAq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fddfb1c932e3c256$export$2e2bcd8739ae039; });

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $l29cN = parcelRequire("l29cN");

var $04Kcc = parcelRequire("04Kcc");

var $jjExS = parcelRequire("jjExS");

var $fgvDu = parcelRequire("fgvDu");

var $1ngTK = parcelRequire("1ngTK");

var $2470d = parcelRequire("2470d");
var $24jTd = parcelRequire("24jTd");
var $767B8 = parcelRequire("767B8");
var $7GpsM = parcelRequire("7GpsM");

var $6FFZb = parcelRequire("6FFZb");

var $gyA6P = parcelRequire("gyA6P");
var $fddfb1c932e3c256$var$_excluded = [
    "item"
], $fddfb1c932e3c256$var$_excluded2 = [
    "items"
];
function $fddfb1c932e3c256$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fddfb1c932e3c256$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fddfb1c932e3c256$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fddfb1c932e3c256$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $fddfb1c932e3c256$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function IndexedDbConnector(_namespace) {
        var _options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $4GJKx._)(this, IndexedDbConnector);
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "startDB", /*#__PURE__*/ (0, $kSuI9._)(function() {
            return (0, $l29cN.__generator)(this, function(_state) {
                return [
                    2,
                    new Promise(function() {
                        var _ref = (0, $kSuI9._)(function(resolve, reject) {
                            var request, error;
                            return (0, $l29cN.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        window.setTimeout(function() {
                                            _this.logger.warn("IndexedDB timed out.");
                                            reject(new (0, $767B8.default)());
                                        }, (0, $fgvDu.INDEXEDDB_TIMEOUT));
                                        /*
         * The database version number can never change.
         * An upgrade transaction is limited to only one connection to the database.
         * Once this is done, we cannot open any connections with older versions of the schema.
         * https://www.w3.org/TR/IndexedDB/#upgrade-transaction-construct
         *
         * Due to the nature of how AWC is used (multiple tabs that are very long lived),
         * we will not be able to run version upgrades via indexeddb.
         *
         * This does not mean we cant change what is stored in the tables,
         * this limitation just prevents us from:
         *   - Creating new ObjectStores in this database connection, and
         *   - Creating new indexes on our ObjectStores
         *
         * Any upgrades we wish to run in the future will have to create a new database,
         * and migrate all the data from older databases.
         *
         * This also means any migrations we make will have to be supported until we have evidence
         * that no events are coming from old versions of the database.
         * This may take a long time.
         */ request = window.indexedDB.open((0, $fgvDu.RESILIENCE_DB_NAME), 1);
                                        request.onupgradeneeded = function(event) {
                                            if (event.oldVersion !== 0) throw new Error("We cannot upgrade the database. Do not do this.");
                                            var db = request.result;
                                            var store = db.createObjectStore((0, $fgvDu.RESILIENCE_STORE_NAME), {
                                                keyPath: "id"
                                            });
                                            store.createIndex((0, $fgvDu.TIME_TO_PROCESS_AFTER_INDEX), (0, $fgvDu.TIME_TO_PROCESS_AFTER_INDEX), {
                                                unique: false
                                            });
                                            store.createIndex((0, $fgvDu.RETRY_INDEX), (0, $fgvDu.RETRY_INDEX), {
                                                unique: false
                                            });
                                            store.createIndex((0, $fgvDu.TIME_ADDED_INDEX), (0, $fgvDu.TIME_ADDED_INDEX), {
                                                unique: false
                                            });
                                            // Compound key index of product - timeAdded.
                                            store.createIndex((0, $fgvDu.NAMESPACE_AND_TIME_ADDED_INDEX), [
                                                "namespace",
                                                "timeAdded"
                                            ], {
                                                unique: false
                                            });
                                        };
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4,
                                            (0, $gyA6P.requestToPromise)(request)
                                        ];
                                    case 2:
                                        _state.sent();
                                        return [
                                            2,
                                            resolve(request.result)
                                        ];
                                    case 3:
                                        error = _state.sent();
                                        _this.logger.warn("IndexedDB failed to initialise.", error);
                                        reject(new (0, $767B8.default)());
                                        return [
                                            3,
                                            4
                                        ];
                                    case 4:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(resolve, reject) {
                            return _ref.apply(this, arguments);
                        };
                    }())
                ];
            });
        }));
        var _this1 = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "addItem", function() {
            var _ref = (0, $kSuI9._)(function(item) {
                var options, policy, logger, namespace, value, objectStore, bulkAddResult, error;
                var _arguments = arguments;
                return (0, $l29cN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {}, policy = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : (0, $fgvDu.GuardPolicy).ABANDON;
                            logger = _this1.logger, namespace = _this1.namespace;
                            value = (0, $gyA6P.convertToItemWrapper)(item, namespace, options);
                            return [
                                4,
                                _this1.getObjectStoreAndTransaction("readwrite")
                            ];
                        case 1:
                            objectStore = _state.sent().objectStore;
                            if (policy === (0, $fgvDu.GuardPolicy).IGNORE) throw new (0, $24jTd.default)(policy, "IndexedDbConnector#addItem");
                            _state.label = 2;
                        case 2:
                            _state.trys.push([
                                2,
                                4,
                                ,
                                5
                            ]);
                            if (!value.namespace || value.namespace.length === 0 || typeof value.namespace !== "string") throw new Error("Namespace not specified");
                            return [
                                4,
                                _this1.globalEventLimitGuard.insertItems(objectStore, [
                                    value
                                ], policy)
                            ];
                        case 3:
                            bulkAddResult = _state.sent();
                            if (bulkAddResult.items.length === 1) return [
                                2,
                                {
                                    item: bulkAddResult.items[0],
                                    numberOfEvictedItems: bulkAddResult.numberOfEvictedItems
                                }
                            ];
                            // Should never happen as the Policy and EventCountGuard should cause another pathway
                            throw new Error("Incorrect number of items added. Expected: 1, got: ".concat(bulkAddResult.items.length));
                        case 4:
                            error = _state.sent();
                            if ((0, $7GpsM.shouldIgnoreResilienceDbError)(error)) throw error;
                            logger.log("Failed to add item to table", error);
                            throw new Error("Request to add item to table failed");
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(item) {
                return _ref.apply(this, arguments);
            };
        }());
        var _this2 = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "bulkAddItem", function() {
            var _ref = (0, $kSuI9._)(function(itemOptions) {
                var policy, logger, namespace, items, objectStore, error;
                var _arguments = arguments;
                return (0, $l29cN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            policy = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : (0, $fgvDu.GuardPolicy).ABANDON;
                            logger = _this2.logger, namespace = _this2.namespace;
                            items = itemOptions.map(function(_ref) {
                                var item = _ref.item, options = (0, (/*@__PURE__*/$parcel$interopDefault($04Kcc)))(_ref, $fddfb1c932e3c256$var$_excluded);
                                return (0, $gyA6P.convertToItemWrapper)(item, namespace, options);
                            });
                            return [
                                4,
                                _this2.getObjectStoreAndTransaction("readwrite")
                            ];
                        case 1:
                            objectStore = _state.sent().objectStore;
                            _state.label = 2;
                        case 2:
                            _state.trys.push([
                                2,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4,
                                _this2.globalEventLimitGuard.insertItems(objectStore, items, policy)
                            ];
                        case 3:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 4:
                            error = _state.sent();
                            if ((0, $7GpsM.shouldIgnoreResilienceDbError)(error)) throw error;
                            logger.log("Failed to add item to table", error);
                            throw new Error("Request to add item to table failed");
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(itemOptions) {
                return _ref.apply(this, arguments);
            };
        }());
        var _this3 = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "getItems", /*#__PURE__*/ (0, $kSuI9._)(function() {
            var count, fixedCount, logger, maxAttempts, _ref, transaction, objectStore, timeIndex, upperBoundOpenKeyRange, request, getResult;
            var _arguments = arguments;
            return (0, $l29cN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        count = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : (0, $1ngTK.GET_ITEM_COUNT);
                        fixedCount = count > 0 ? count : (0, $1ngTK.GET_ITEM_COUNT);
                        logger = _this3.logger;
                        maxAttempts = _this3.options.maxAttempts;
                        return [
                            4,
                            _this3.getObjectStoreAndTransaction("readwrite")
                        ];
                    case 1:
                        _ref = _state.sent(), transaction = _ref.transaction, objectStore = _ref.objectStore;
                        timeIndex = objectStore.index((0, $fgvDu.TIME_TO_PROCESS_AFTER_INDEX));
                        upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
                        request = timeIndex.openCursor(upperBoundOpenKeyRange);
                        return [
                            4,
                            new Promise(function() {
                                var _ref = (0, $kSuI9._)(function(resolve, reject) {
                                    var items, numberOfDeletedItems;
                                    return (0, $l29cN.__generator)(this, function(_state) {
                                        items = [];
                                        numberOfDeletedItems = 0;
                                        request.onerror = function(error) {
                                            logger.error("Failed to open cursor:", error);
                                            reject("Failed to open cursor");
                                        };
                                        // Requests for Cursors call onsuccess multiple times and cannot be converted to promises
                                        request.onsuccess = function(event) {
                                            var cursor = event.target.result;
                                            if (cursor) {
                                                // Prevent mutation of the value we are returning
                                                var value = $fddfb1c932e3c256$var$_objectSpread({}, cursor.value);
                                                items.push(value);
                                                // Mutations seem to be required for testing indexeddb library
                                                var updatedValue = cursor.value;
                                                updatedValue.retryAttempts += 1;
                                                updatedValue.timeToBeProcessedAfter = Date.now() + (0, $1ngTK.VISIBILITY_TIMEOUT);
                                                if (updatedValue.retryAttempts >= maxAttempts) {
                                                    ++numberOfDeletedItems;
                                                    var request = cursor.delete();
                                                    (0, $gyA6P.monitorErrorsOnRequest)(request, logger);
                                                } else {
                                                    var request1 = cursor.update(updatedValue);
                                                    (0, $gyA6P.monitorErrorsOnRequest)(request1, logger);
                                                }
                                                if (items.length < fixedCount) cursor.continue();
                                                else resolve({
                                                    items: items,
                                                    numberOfDeletedItems: numberOfDeletedItems
                                                });
                                            } else resolve({
                                                items: items,
                                                numberOfDeletedItems: numberOfDeletedItems
                                            });
                                        };
                                        return [
                                            2
                                        ];
                                    });
                                });
                                return function(resolve, reject) {
                                    return _ref.apply(this, arguments);
                                };
                            }())
                        ];
                    case 2:
                        getResult = _state.sent();
                        return [
                            4,
                            (0, $gyA6P.commitTransaction)(transaction, _this3.logger)
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2,
                            getResult
                        ];
                }
            });
        }));
        var _this4 = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "deleteItems", function() {
            var _ref = (0, $kSuI9._)(function(itemIds) {
                var _ref, transaction, objectStore, deletePromises, error;
                return (0, $l29cN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this4.getObjectStoreAndTransaction("readwrite")
                            ];
                        case 1:
                            _ref = _state.sent(), transaction = _ref.transaction, objectStore = _ref.objectStore;
                            _state.label = 2;
                        case 2:
                            _state.trys.push([
                                2,
                                5,
                                ,
                                6
                            ]);
                            deletePromises = itemIds.map(function(id) {
                                return _this4.deleteItem(objectStore, id);
                            });
                            return [
                                4,
                                (0, $gyA6P.commitTransaction)(transaction, _this4.logger)
                            ];
                        case 3:
                            _state.sent();
                            return [
                                4,
                                Promise.all(deletePromises)
                            ];
                        case 4:
                            _state.sent();
                            return [
                                3,
                                6
                            ];
                        case 5:
                            error = _state.sent();
                            _this4.logger.warn("Failed to delete items from indexeddb.", error);
                            throw error;
                        case 6:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(itemIds) {
                return _ref.apply(this, arguments);
            };
        }());
        var _this5 = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "getItemCount", /*#__PURE__*/ (0, $kSuI9._)(function() {
            var _ref, transaction, objectStore, timeIndex, upperBoundOpenKeyRange, request, event;
            return (0, $l29cN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this5.getObjectStoreAndTransaction("readonly")
                        ];
                    case 1:
                        _ref = _state.sent(), transaction = _ref.transaction, objectStore = _ref.objectStore;
                        timeIndex = objectStore.index((0, $fgvDu.TIME_TO_PROCESS_AFTER_INDEX));
                        upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
                        request = timeIndex.count(upperBoundOpenKeyRange);
                        return [
                            4,
                            (0, $gyA6P.requestToPromise)(request)
                        ];
                    case 2:
                        event = _state.sent();
                        return [
                            4,
                            (0, $gyA6P.commitTransaction)(transaction, _this5.logger)
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2,
                            event.target.result
                        ];
                }
            });
        }));
        var _this6 = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "processItems", function() {
            var _ref = (0, $kSuI9._)(function(processFn) {
                var count, _await$this$getItems, items, partialResult, result, itemIds, error;
                var _arguments = arguments;
                return (0, $l29cN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            count = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : (0, $1ngTK.GET_ITEM_COUNT);
                            return [
                                4,
                                _this6.getItems(count)
                            ];
                        case 1:
                            _await$this$getItems = _state.sent(), items = _await$this$getItems.items, partialResult = (0, (/*@__PURE__*/$parcel$interopDefault($04Kcc)))(_await$this$getItems, $fddfb1c932e3c256$var$_excluded2);
                            _state.label = 2;
                        case 2:
                            _state.trys.push([
                                2,
                                5,
                                ,
                                6
                            ]);
                            return [
                                4,
                                processFn(items, partialResult)
                            ];
                        case 3:
                            result = _state.sent();
                            itemIds = items.map(function(item) {
                                return item.id;
                            });
                            // We should not await this delete as a rejected promise would get caught by the catch statement
                            return [
                                4,
                                _this6.deleteItems(itemIds)
                            ];
                        case 4:
                            _state.sent();
                            return [
                                2,
                                result
                            ];
                        case 5:
                            error = _state.sent();
                            // Eventually we will need a intermediate class to catch all errors but we should ignore this error
                            // This allows libraries beneath to distinguish between a success or failure in processing to update schedulers or anything else
                            // To provide back off or any other mechanism to allow what ever is cauing the errors to recover
                            throw new (0, $2470d.default)(error);
                        case 6:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(processFn) {
                return _ref.apply(this, arguments);
            };
        }());
        var _this7 = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "deleteItem", function() {
            var _ref = (0, $kSuI9._)(function(objectStore, id) {
                var logger, error;
                return (0, $l29cN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            logger = _this7.logger;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                (0, $gyA6P.requestToPromise)(objectStore.delete(id))
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error = _state.sent();
                            logger.error("Failed to delete item:", id, error);
                            throw error;
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(objectStore, id) {
                return _ref.apply(this, arguments);
            };
        }());
        var _this8 = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "getObjectStoreAndTransaction", function() {
            var _ref = (0, $kSuI9._)(function(mode) {
                var transaction, objectStore;
                return (0, $l29cN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this8.db
                            ];
                        case 1:
                            transaction = _state.sent().transaction((0, $fgvDu.RESILIENCE_STORE_NAME), mode);
                            objectStore = transaction.objectStore((0, $fgvDu.RESILIENCE_STORE_NAME));
                            return [
                                2,
                                {
                                    transaction: transaction,
                                    objectStore: objectStore
                                }
                            ];
                    }
                });
            });
            return function(mode) {
                return _ref.apply(this, arguments);
            };
        }());
        this.options = (0, $gyA6P.createOptionsWithDefaults)(_options);
        this.namespace = _namespace;
        this.logger = this.options.logger;
        if (!window.indexedDB) throw new (0, $767B8.default)();
        this.db = this.startDB();
        // We just swallow any errors as we know that these are intermittent errors
        // when switching from indexeddb -> localStorage
        this.db.catch(function() {});
        /**
     *
     * This class will enforce the number of analytics events we can store in our IndexedDB object store
     * if asked before adding items to the object store.
     */ this.globalEventLimitGuard = new (0, $6FFZb.default)(this.options.maxEventLimit, this.namespace, this.logger, this.deleteItem);
    }
    (0, $1wc17._)(IndexedDbConnector, [
        {
            key: "storeType",
            value: function storeType() {
                return (0, $fgvDu.StoreType).INDEXEDDB;
            }
        }
    ]);
    return IndexedDbConnector;
}();

});
parcelRegister("04Kcc", function(module, exports) {

var $ikTCA = parcelRequire("ikTCA");
function $00e43555e92d38d1$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $ikTCA(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
module.exports = $00e43555e92d38d1$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("ikTCA", function(module, exports) {
function $d5953d7e819ca52f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
module.exports = $d5953d7e819ca52f$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("1ngTK", function(module, exports) {

$parcel$export(module.exports, "GET_ITEM_COUNT", function () { return $10050c124a5fb3e2$export$b6df3d334cec060f; });
$parcel$export(module.exports, "VISIBILITY_TIMEOUT", function () { return $10050c124a5fb3e2$export$14ef152a03a4b6ee; });
$parcel$export(module.exports, "MAX_ATTEMPTS", function () { return $10050c124a5fb3e2$export$da9ab7b2fd5998e8; });
$parcel$export(module.exports, "EVENT_COUNT_LIMIT", function () { return $10050c124a5fb3e2$export$1188664dfff364c8; });
var $10050c124a5fb3e2$export$b6df3d334cec060f = 7;
var $10050c124a5fb3e2$export$14ef152a03a4b6ee = 60000;
var $10050c124a5fb3e2$export$da9ab7b2fd5998e8 = 10;
var $10050c124a5fb3e2$export$1188664dfff364c8 = 5000;

});

parcelRegister("6FFZb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4db723e5e22fa18a$export$2e2bcd8739ae039; });

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $c6Xmf = parcelRequire("c6Xmf");

var $l29cN = parcelRequire("l29cN");

var $jjExS = parcelRequire("jjExS");

var $fgvDu = parcelRequire("fgvDu");

var $1TmaA = parcelRequire("1TmaA");

var $gyA6P = parcelRequire("gyA6P");
var $4db723e5e22fa18a$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function IndexedDbEventCountGuard(eventLimit, namespace, logger, deleteItemHandler) {
        (0, $4GJKx._)(this, IndexedDbEventCountGuard);
        var _this = this;
        /**
     * This query fetches the oldest events currently stored in AWC IndexedDb object store
     * and deletes them sequentially
     */ (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "deleteOldestNEvents", function() {
            var _ref = (0, $kSuI9._)(function(objectStore, count) {
                var _target, productTimeAddedIndex, keyRangeValues, getAllRequest, event, result, deletePromises, error;
                return (0, $l29cN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            productTimeAddedIndex = objectStore.index((0, $fgvDu.NAMESPACE_AND_TIME_ADDED_INDEX));
                            keyRangeValues = IDBKeyRange.bound([
                                _this.namespace,
                                0
                            ], [
                                _this.namespace,
                                Date.now()
                            ]);
                            getAllRequest = productTimeAddedIndex.getAllKeys(keyRangeValues, count);
                            return [
                                4,
                                (0, $gyA6P.requestToPromise)(getAllRequest)
                            ];
                        case 1:
                            event = _state.sent();
                            result = event === null || event === void 0 || (_target = event.target) === null || _target === void 0 ? void 0 : _target.result;
                            if (!(result && Array.isArray(result) && result.length > 0)) return [
                                3,
                                5
                            ];
                            _state.label = 2;
                        case 2:
                            _state.trys.push([
                                2,
                                4,
                                ,
                                5
                            ]);
                            deletePromises = result.map(function(item) {
                                return _this.deleteItemHandler(objectStore, item);
                            });
                            return [
                                4,
                                Promise.all(deletePromises)
                            ];
                        case 3:
                            _state.sent();
                            return [
                                3,
                                5
                            ];
                        case 4:
                            error = _state.sent();
                            _this.logger.warn("Failed to delete items from indexeddb.", error);
                            throw error;
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(objectStore, count) {
                return _ref.apply(this, arguments);
            };
        }());
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error("Event Limit has to be set higher than 1");
        this.namespace = namespace;
        this.logger = logger;
        this.deleteItemHandler = deleteItemHandler;
    }
    (0, $1wc17._)(IndexedDbEventCountGuard, [
        {
            key: "insertItems",
            value: /**
   * This function checks the number of events currently in AWC IndexedDB object store and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * The indexed is treated as effectively: partitioned by product and sorted by timeAdded.
   *
   * This function can be re-used when the bulk add functionality is added in IndexedDbConnector.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ function insertItems(objectStore, items) {
                var policy = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (0, $fgvDu.GuardPolicy).ABANDON;
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var itemsToAdd, numberOfEvictedItems, promises;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                itemsToAdd = (0, $c6Xmf._)(items);
                                numberOfEvictedItems = 0;
                                switch(policy){
                                    case (0, $fgvDu.GuardPolicy).ABANDON:
                                        return [
                                            3,
                                            1
                                        ];
                                    case (0, $fgvDu.GuardPolicy).EVICT:
                                        return [
                                            3,
                                            3
                                        ];
                                    case (0, $fgvDu.GuardPolicy).IGNORE:
                                        return [
                                            3,
                                            5
                                        ];
                                }
                                return [
                                    3,
                                    7
                                ];
                            case 1:
                                return [
                                    4,
                                    _this.throwIfNotEnoughSpace(objectStore, items.length)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    7
                                ];
                            case 3:
                                return [
                                    4,
                                    _this.evictIfNotEnoughSpace(objectStore, items.length)
                                ];
                            case 4:
                                numberOfEvictedItems = _state.sent();
                                return [
                                    3,
                                    7
                                ];
                            case 5:
                                // Removed items from `itemsToAdd` if there is insufficient space
                                return [
                                    4,
                                    _this.calculateHowManyEventsWeCanAdd(objectStore, itemsToAdd)
                                ];
                            case 6:
                                _state.sent();
                                return [
                                    3,
                                    7
                                ];
                            case 7:
                                promises = itemsToAdd.map(function(item) {
                                    return (0, $gyA6P.requestToPromise)(objectStore.add(item));
                                });
                                return [
                                    4,
                                    Promise.all(promises)
                                ];
                            case 8:
                                _state.sent();
                                return [
                                    4,
                                    (0, $gyA6P.commitTransaction)(objectStore.transaction, _this.logger)
                                ];
                            case 9:
                                _state.sent();
                                return [
                                    2,
                                    {
                                        items: itemsToAdd,
                                        numberOfEvictedItems: numberOfEvictedItems
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "throwIfNotEnoughSpace",
            value: function throwIfNotEnoughSpace(objectStore, requiredSpace) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var freeSpace;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.calculateFreeSpace(objectStore)
                                ];
                            case 1:
                                freeSpace = _state.sent();
                                if (freeSpace < requiredSpace) throw new (0, $1TmaA.default)("Not enough space in IndexedDb. Needed ".concat(requiredSpace, " but only had ").concat(freeSpace));
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "evictIfNotEnoughSpace",
            value: function evictIfNotEnoughSpace(objectStore, requiredSpace) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var freeSpace, extraSpace;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.calculateFreeSpace(objectStore)
                                ];
                            case 1:
                                freeSpace = _state.sent();
                                if (!(freeSpace < requiredSpace)) return [
                                    3,
                                    3
                                ];
                                extraSpace = requiredSpace - freeSpace;
                                return [
                                    4,
                                    _this.deleteOldestNEvents(objectStore, extraSpace)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2,
                                    extraSpace
                                ];
                            case 3:
                                return [
                                    2,
                                    0
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "calculateHowManyEventsWeCanAdd",
            value: function calculateHowManyEventsWeCanAdd(objectStore, items) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var freeSpace, numberOfItemsToRemove, start;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.calculateFreeSpace(objectStore)
                                ];
                            case 1:
                                freeSpace = _state.sent();
                                if (freeSpace < items.length) {
                                    numberOfItemsToRemove = items.length - freeSpace;
                                    start = items.length - numberOfItemsToRemove;
                                    items.splice(start, numberOfItemsToRemove);
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "calculateFreeSpace",
            value: function calculateFreeSpace(objectStore) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var numberOfEventsInDb;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getCountofEventsInObjectStore(objectStore)
                                ];
                            case 1:
                                numberOfEventsInDb = _state.sent();
                                return [
                                    2,
                                    _this.eventLimit - numberOfEventsInDb
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getCountofEventsInObjectStore",
            value: /**
   * This query returns the count of items held in AWC IndexedDB object store per product.
   */ function getCountofEventsInObjectStore(objectStore) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var productTimeAddedIndex, keyRangeValues, request, event;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                productTimeAddedIndex = objectStore.index((0, $fgvDu.NAMESPACE_AND_TIME_ADDED_INDEX));
                                keyRangeValues = IDBKeyRange.bound([
                                    _this.namespace,
                                    0
                                ], [
                                    _this.namespace,
                                    Date.now()
                                ]);
                                request = productTimeAddedIndex.count(keyRangeValues);
                                return [
                                    4,
                                    (0, $gyA6P.requestToPromise)(request)
                                ];
                            case 1:
                                event = _state.sent();
                                return [
                                    2,
                                    event.target.result
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return IndexedDbEventCountGuard;
}();

});
parcelRegister("gyA6P", function(module, exports) {

$parcel$export(module.exports, "convertToItemWrapper", function () { return $c0dbd4d55ead6def$export$aec476f33d77be11; });
$parcel$export(module.exports, "createOptionsWithDefaults", function () { return $c0dbd4d55ead6def$export$ddc6718318090f71; });
$parcel$export(module.exports, "requestToPromise", function () { return $c0dbd4d55ead6def$export$85ceed0783e42041; });
$parcel$export(module.exports, "commitTransaction", function () { return $c0dbd4d55ead6def$export$feab8418f018df89; });
$parcel$export(module.exports, "monitorErrorsOnRequest", function () { return $c0dbd4d55ead6def$export$342d941b6f724995; });

var $ktzPa = parcelRequire("ktzPa");

var $1ngTK = parcelRequire("1ngTK");
var $c0dbd4d55ead6def$export$aec476f33d77be11 = function(item, namespace, param) {
    var id = param.id, retryAttempts = param.retryAttempts, timeToProcessOffset = param.timeToProcessOffset;
    return {
        item: item,
        id: id || (0, (/*@__PURE__*/$parcel$interopDefault($ktzPa)))(),
        retryAttempts: retryAttempts || 0,
        timeToBeProcessedAfter: Date.now() + (timeToProcessOffset || 0),
        namespace: namespace,
        timeAdded: Date.now()
    };
};
var $c0dbd4d55ead6def$export$ddc6718318090f71 = function(options) {
    return {
        logger: options.logger || console,
        useMemory: options.useMemory || false,
        maxAttempts: options.maxAttempts || (0, $1ngTK.MAX_ATTEMPTS),
        // This is so that we can customise `maxEventLimit`, primarily for testing.
        maxEventLimit: options.maxEventLimit || (0, $1ngTK.EVENT_COUNT_LIMIT)
    };
};
var $c0dbd4d55ead6def$export$85ceed0783e42041 = function(request) {
    return new Promise(function(resolve, reject) {
        request.onsuccess = function(event) {
            resolve(event);
        };
        request.onerror = function(event) {
            reject(event);
        };
    });
};
var $c0dbd4d55ead6def$export$2a5213bce1720b42 = function(transaction) {
    return new Promise(function(resolve, reject) {
        // We will have to see how much cost there is to waiting for the transaction to complete in the real world.
        // In theory in some cases we could return as soon as the request is complete and
        // just monitor errors on transactions with the logger.
        // This maybe more of an issue in Safari and other older browsers where commit isnt available
        // and we would have to wait for the transaction to complete itself.
        transaction.oncomplete = function() {
            resolve();
        };
        transaction.onerror = function(event) {
            reject(event);
        };
        transaction.onabort = function(event) {
            reject(event);
        };
    });
};
var $c0dbd4d55ead6def$export$feab8418f018df89 = function(transaction, logger) {
    try {
        if (typeof transaction.commit === "function") transaction.commit();
    } catch (error) {
        logger.error("Failed to force commit transaction:", error);
        throw error;
    }
    return $c0dbd4d55ead6def$export$2a5213bce1720b42(transaction);
};
var $c0dbd4d55ead6def$export$342d941b6f724995 = function(request, logger) {
    request.onerror = function(event) {
        logger.warn("Error thrown from request:", event);
    };
};

});



parcelRegister("aJcKS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7cf80040ed2dc1a9$export$2e2bcd8739ae039; });

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $c6Xmf = parcelRequire("c6Xmf");

var $l29cN = parcelRequire("l29cN");

var $jjExS = parcelRequire("jjExS");

var $04Kcc = parcelRequire("04Kcc");

var $fgvDu = parcelRequire("fgvDu");

var $1ngTK = parcelRequire("1ngTK");

var $2470d = parcelRequire("2470d");
var $24jTd = parcelRequire("24jTd");

var $9ubZ8 = parcelRequire("9ubZ8");

var $gyA6P = parcelRequire("gyA6P");
var $7cf80040ed2dc1a9$var$_excluded = [
    "item"
], $7cf80040ed2dc1a9$var$_excluded2 = [
    "items"
];
function $7cf80040ed2dc1a9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7cf80040ed2dc1a9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7cf80040ed2dc1a9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7cf80040ed2dc1a9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7cf80040ed2dc1a9$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function MemoryDb(namespace) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $4GJKx._)(this, MemoryDb);
        this.namespace = namespace;
        this.memoryStore = [];
        this.options = (0, $gyA6P.createOptionsWithDefaults)(options);
        /**
     * This class will enforce the number of analytics events we can store in our MemoryDb
     */ this.globalEventLimitGuard = new (0, $9ubZ8.default)(this.options.maxEventLimit, {
            addItems: this.addItems.bind(this),
            getItemCount: this.getItemCount.bind(this),
            evictEventsIfNeeded: this.evictEventsIfNeeded.bind(this)
        });
    }
    (0, $1wc17._)(MemoryDb, [
        {
            key: "addItem",
            value: /**
   * This method is used mainly to write new events to MemoryDB and uses the MEMORY_DB_GUARD_POLICY.EVICT_OLDEST_IF_LIMIT_EXECEEDED policy
   * to removes oldest events when limit is reached.
   */ function addItem(item) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, policy = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (0, $fgvDu.GuardPolicy).ABANDON;
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var storedValue, bulkAddItemsResult;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (policy === (0, $fgvDu.GuardPolicy).IGNORE) throw new (0, $24jTd.default)(policy, "IndexedDbConnector#addItem");
                                storedValue = (0, $gyA6P.convertToItemWrapper)(item, _this.namespace, options);
                                return [
                                    4,
                                    _this.globalEventLimitGuard.insertItemsToMemoryStore([
                                        storedValue
                                    ], policy)
                                ];
                            case 1:
                                bulkAddItemsResult = _state.sent();
                                return [
                                    2,
                                    Promise.resolve({
                                        item: bulkAddItemsResult.items[0],
                                        numberOfEvictedItems: bulkAddItemsResult.numberOfEvictedItems
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "bulkAddItem",
            value: function bulkAddItem(itemOptions) {
                var policy = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, $fgvDu.GuardPolicy).ABANDON;
                var _this = this;
                var items = itemOptions.map(function(_ref) {
                    var item = _ref.item, addOptions = (0, (/*@__PURE__*/$parcel$interopDefault($04Kcc)))(_ref, $7cf80040ed2dc1a9$var$_excluded);
                    return (0, $gyA6P.convertToItemWrapper)(item, _this.namespace, addOptions);
                });
                return this.bulkAddItemWrapperType(items, policy);
            }
        },
        {
            /**
   * This method is used mainly to write events to MemoryDB when unknown errors are thrown from IndexedDB.
   */ key: "bulkAddItemWrapperType",
            value: function bulkAddItemWrapperType(items) {
                var policy = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, $fgvDu.GuardPolicy).ABANDON;
                return Promise.resolve(this.globalEventLimitGuard.insertItemsToMemoryStore(items, policy));
            }
        },
        {
            key: "getItems",
            value: function getItems() {
                var count = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $1ngTK.GET_ITEM_COUNT);
                return Promise.resolve(this.synchronousGetItems(count));
            }
        },
        {
            key: "synchronousGetItems",
            value: function synchronousGetItems() {
                var count = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $1ngTK.GET_ITEM_COUNT);
                var _this = this;
                var fixedCount = count > 0 ? count : (0, $1ngTK.GET_ITEM_COUNT);
                var now = Date.now();
                var wrappedItems = [];
                var itemsToRemove = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.memoryStore[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var wrappedItem = _step.value;
                        if (wrappedItem.timeToBeProcessedAfter <= now) {
                            wrappedItems.push($7cf80040ed2dc1a9$var$_objectSpread({}, wrappedItem));
                            // Mutates the item in the memoryStore array, but not whats inside of wrappedItems
                            wrappedItem.timeToBeProcessedAfter += (0, $1ngTK.VISIBILITY_TIMEOUT);
                            wrappedItem.retryAttempts += 1;
                            if (wrappedItem.retryAttempts >= this.options.maxAttempts) itemsToRemove.push(wrappedItem);
                        }
                        if (wrappedItems.length >= fixedCount) break;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                itemsToRemove.forEach(function(item) {
                    var index = _this.memoryStore.indexOf(item);
                    _this.memoryStore.splice(index, 1);
                });
                return {
                    items: wrappedItems,
                    numberOfDeletedItems: itemsToRemove.length
                };
            }
        },
        {
            key: "deleteItems",
            value: function deleteItems(itemIds) {
                this.memoryStore = this.memoryStore.filter(function(item) {
                    return !itemIds.includes(item.id);
                });
                return Promise.resolve(void 0);
            }
        },
        {
            key: "getItemCount",
            value: function getItemCount() {
                var now = Date.now();
                var count = this.memoryStore.filter(function(item) {
                    return item.timeToBeProcessedAfter <= now;
                }).length;
                return Promise.resolve(count);
            }
        },
        {
            key: "processItems",
            value: function processItems(processFn, count) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _this$synchronousGetI, items, partialGetResult, itemIds, result, error;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this$synchronousGetI = _this.synchronousGetItems(count), items = _this$synchronousGetI.items, partialGetResult = (0, (/*@__PURE__*/$parcel$interopDefault($04Kcc)))(_this$synchronousGetI, $7cf80040ed2dc1a9$var$_excluded2);
                                itemIds = items.map(function(i) {
                                    return i.id;
                                });
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    processFn(items, partialGetResult)
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    4,
                                    _this.deleteItems(itemIds)
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 4:
                                error = _state.sent();
                                throw new (0, $2470d.default)(error);
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "storeType",
            value: function storeType() {
                return (0, $fgvDu.StoreType).MEMORY;
            }
        },
        {
            /**
   * This function is adding items to the tail of the memoryStore and as it adds new items it keeps the
   * memory store sorted by timeAdded property. This makes evictions easier and adding elements to
   * memoryStore much faster.
   *
   * @param itemsToAdd
   */ key: "addItems",
            value: function addItems(itemsToAdd) {
                var _this_memoryStore;
                (_this_memoryStore = this.memoryStore).push.apply(_this_memoryStore, (0, $c6Xmf._)(itemsToAdd));
                // Sorting everytime, intentionally.
                this.memoryStore.sort(function(a, b) {
                    return a.timeAdded - b.timeAdded;
                });
            }
        },
        {
            /**
   * This function checks the number of events currently in AWC MemoryDb and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ key: "evictEventsIfNeeded",
            value: function evictEventsIfNeeded(eventLimit) {
                var numberOfEventsInDb = this.memoryStore.length;
                // The number of analytics events currently in MemoryDb and
                // the Z events we are proposing to add will exceed our event count limit.
                if (numberOfEventsInDb > eventLimit) {
                    var m = numberOfEventsInDb - eventLimit;
                    // Removing oldest M events
                    this.memoryStore.splice(0, m);
                    return m;
                }
                return 0;
            }
        }
    ]);
    return MemoryDb;
}();

});
parcelRegister("9ubZ8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e80365bbb36cee8$export$2e2bcd8739ae039; });

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $l29cN = parcelRequire("l29cN");

var $jjExS = parcelRequire("jjExS");

var $fgvDu = parcelRequire("fgvDu");

var $1TmaA = parcelRequire("1TmaA");
var $6e80365bbb36cee8$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function MemoryDbEventCountGuard(eventLimit, memoryItemHandlers) {
        var _this = this;
        (0, $4GJKx._)(this, MemoryDbEventCountGuard);
        /**
     * Unlike IndexedDb, we cannot take advantage of any index. So we are,
     * treating the memory store as a sorted set when adding items.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "insertItemsToMemoryStore", function(itemsToAdd, policy) {
            switch(policy){
                case (0, $fgvDu.GuardPolicy).ABANDON:
                    return _this.handleAbandonIfLimitWillExceedPolicy(itemsToAdd);
                case (0, $fgvDu.GuardPolicy).EVICT:
                    return Promise.resolve(_this.handleEvictOldestIfLimitExceededPolicy(itemsToAdd));
                case (0, $fgvDu.GuardPolicy).IGNORE:
                    return _this.handleAddAsManyAsPossible(itemsToAdd);
            }
        });
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error("Event Limit has to be set higher than 1");
        this.memoryItemHandlers = memoryItemHandlers;
    }
    (0, $1wc17._)(MemoryDbEventCountGuard, [
        {
            key: "handleAbandonIfLimitWillExceedPolicy",
            value: function handleAbandonIfLimitWillExceedPolicy(itemsToAdd) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var itemCount;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.memoryItemHandlers.getItemCount()
                                ];
                            case 1:
                                itemCount = _state.sent();
                                if (itemCount + itemsToAdd.length > _this.eventLimit) throw new (0, $1TmaA.default)((0, $fgvDu.StoreType).MEMORY);
                                _this.memoryItemHandlers.addItems(itemsToAdd);
                                return [
                                    2,
                                    {
                                        items: itemsToAdd,
                                        numberOfEvictedItems: 0
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "handleEvictOldestIfLimitExceededPolicy",
            value: function handleEvictOldestIfLimitExceededPolicy(itemsToAdd) {
                this.memoryItemHandlers.addItems(itemsToAdd);
                var numberOfEvictedItems = this.memoryItemHandlers.evictEventsIfNeeded(this.eventLimit);
                return {
                    items: itemsToAdd,
                    numberOfEvictedItems: numberOfEvictedItems
                };
            }
        },
        {
            key: "handleAddAsManyAsPossible",
            value: function handleAddAsManyAsPossible(itemsToAdd) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var freeSpace, _, partialEventsToAdd;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _ = _this.eventLimit;
                                return [
                                    4,
                                    _this.memoryItemHandlers.getItemCount()
                                ];
                            case 1:
                                freeSpace = _ - _state.sent();
                                partialEventsToAdd = freeSpace > itemsToAdd.length ? itemsToAdd : itemsToAdd.slice(0, freeSpace);
                                _this.memoryItemHandlers.addItems(partialEventsToAdd);
                                return [
                                    2,
                                    {
                                        items: partialEventsToAdd,
                                        numberOfEvictedItems: 0
                                    }
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return MemoryDbEventCountGuard;
}();

});




parcelRegister("4eyPu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31537ca9d7c8e25f$export$2e2bcd8739ae039; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $jjExS = parcelRequire("jjExS");

var $8g8TT = parcelRequire("8g8TT");
var $31537ca9d7c8e25f$export$4b62ee5120ab50a8 = /*#__PURE__*/ function() {
    "use strict";
    function MetricsCollector() {
        (0, $4GJKx._)(this, MetricsCollector);
        // Number of events discarded due to exceeding retry limits.
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "itemsDiscardedByRetry", 0);
        // Number of events created by the product in current tab.
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "eventCount", 0);
        // Number of events discarded due to reaching queue max size.
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "itemsDiscardedByOverflow", 0);
        // Will be used in the future when we get more resilience mechanisms
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "resilienceMechanism", (0, $8g8TT.ResilienceMechanism).INDEXEDDB);
        /* --- LocalStorage specific metrics --- */ // Emitted by purgeOrphanedQueues to tell us how many queues we have had to clean up due to
        // https://github.com/segmentio/localstorage-retry/pull/17
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "localstorageNumberOfQueuesPurged", 0);
        // Emitted by reclaimEvents to tell us how many queues were seen in the process of reclaim.
        // We will only emit metrics for queues that are not currently being maintained (i.e. `ack` is not being updated).
        // Queue was found, all events removed and put into resilienceDb.
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "localstorageNumberOfFullReclaims", 0);
        // Queue was found but not all events were able to be put into resilienceDb.
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "localstorageNumberOfPartialReclaims", 0);
        // Reclaim failed for a queue and reclaim was abandonded.
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "localstorageNumberOfFailedReclaims", 0);
    }
    (0, $1wc17._)(MetricsCollector, [
        {
            key: "addToItemsDiscardedByRetryCounter",
            value: function addToItemsDiscardedByRetryCounter() {
                var numberOfDeletedEvents = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
                this.itemsDiscardedByRetry += numberOfDeletedEvents;
            }
        },
        {
            key: "addToEventCount",
            value: function addToEventCount() {
                this.eventCount++;
            }
        },
        {
            key: "addToItemsDiscardedByOverflowCounter",
            value: function addToItemsDiscardedByOverflowCounter() {
                var numberOfDeletedEvents = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
                this.itemsDiscardedByOverflow += numberOfDeletedEvents;
            }
        },
        {
            key: "setResilienceMechanism",
            value: function setResilienceMechanism(mechanism) {
                this.resilienceMechanism = mechanism;
            }
        },
        {
            /* <Localstorage specific> */ key: "addToReclaimMetrics",
            value: function addToReclaimMetrics(reclaimMetrics) {
                this.localstorageNumberOfFullReclaims += reclaimMetrics.fullReclaims;
                this.localstorageNumberOfPartialReclaims += reclaimMetrics.partialReclaims;
                this.localstorageNumberOfFailedReclaims += reclaimMetrics.failedReclaims;
            }
        },
        {
            key: "addToPurgedQueuesMetrics",
            value: function addToPurgedQueuesMetrics(numberOfQueuesPurged) {
                this.localstorageNumberOfQueuesPurged += numberOfQueuesPurged;
            }
        },
        {
            /* </Localstorage specific> */ key: "subtractFromMetrics",
            value: function subtractFromMetrics(sentMetrics) {
                this.itemsDiscardedByRetry = this.subtractFromCount(this.itemsDiscardedByRetry, sentMetrics.itemsDiscardedByRetry);
                this.eventCount = this.subtractFromCount(this.eventCount, sentMetrics.eventCount);
                this.itemsDiscardedByOverflow = this.subtractFromCount(this.itemsDiscardedByOverflow, sentMetrics.itemsDiscardedByOverflow);
                // Localstorage specific
                this.localstorageNumberOfFullReclaims = this.subtractFromCount(this.localstorageNumberOfFullReclaims, sentMetrics.fullReclaims);
                this.localstorageNumberOfPartialReclaims = this.subtractFromCount(this.localstorageNumberOfPartialReclaims, sentMetrics.partialReclaims);
                this.localstorageNumberOfFailedReclaims = this.subtractFromCount(this.localstorageNumberOfFailedReclaims, sentMetrics.failedReclaims);
                this.localstorageNumberOfQueuesPurged = this.subtractFromCount(this.localstorageNumberOfQueuesPurged, sentMetrics.localstorageQueuesPurged);
            }
        },
        {
            key: "subtractFromCount",
            value: function subtractFromCount(count, subtract) {
                return Math.max(count - (subtract || 0), 0);
            }
        },
        {
            key: "getMetricsPayload",
            value: function getMetricsPayload() {
                return {
                    itemsDiscardedByRetry: this.itemsDiscardedByRetry,
                    eventCount: this.eventCount,
                    itemsDiscardedByOverflow: this.itemsDiscardedByOverflow,
                    resilienceMechanism: this.resilienceMechanism,
                    // Localstorage specific
                    localstorageQueuesPurged: this.localstorageNumberOfQueuesPurged,
                    fullReclaims: this.localstorageNumberOfFullReclaims,
                    partialReclaims: this.localstorageNumberOfPartialReclaims,
                    failedReclaims: this.localstorageNumberOfFailedReclaims
                };
            }
        }
    ]);
    return MetricsCollector;
}();
var $31537ca9d7c8e25f$var$cachedMetricsClient = null;
var $31537ca9d7c8e25f$export$2e2bcd8739ae039 = function() {
    if (!$31537ca9d7c8e25f$var$cachedMetricsClient) $31537ca9d7c8e25f$var$cachedMetricsClient = new $31537ca9d7c8e25f$export$4b62ee5120ab50a8();
    return $31537ca9d7c8e25f$var$cachedMetricsClient;
};

});
parcelRegister("8g8TT", function(module, exports) {

$parcel$export(module.exports, "ResilienceMechanism", function () { return $6036b8ce5dc5dfc1$export$c75161629e3ec34e; });
$parcel$export(module.exports, "NetworkStatusEnum", function () { return $6036b8ce5dc5dfc1$export$ee138fa712d11b84; });
var $6036b8ce5dc5dfc1$export$c75161629e3ec34e = /*#__PURE__*/ function(ResilienceMechanism) {
    ResilienceMechanism["INDEXEDDB"] = "indexeddb";
    ResilienceMechanism["MEMORY"] = "memory";
    return ResilienceMechanism;
}({});
var $6036b8ce5dc5dfc1$export$ee138fa712d11b84 = /*#__PURE__*/ function(NetworkStatusEnum) {
    NetworkStatusEnum[NetworkStatusEnum["ONLINE"] = 0] = "ONLINE";
    NetworkStatusEnum[NetworkStatusEnum["OFFLINE"] = 1] = "OFFLINE";
    return NetworkStatusEnum;
}({});

});


parcelRegister("052TO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $00f2b7766482c024$export$2e2bcd8739ae039; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $8g8TT = parcelRequire("8g8TT");
var $00f2b7766482c024$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function NetworkStatus(networkChangeCallback) {
        (0, $4GJKx._)(this, NetworkStatus);
        window.addEventListener("offline", function() {
            return networkChangeCallback((0, $8g8TT.NetworkStatusEnum).OFFLINE);
        });
        window.addEventListener("online", function() {
            return networkChangeCallback((0, $8g8TT.NetworkStatusEnum).ONLINE);
        });
    }
    (0, $1wc17._)(NetworkStatus, [
        {
            key: "getNetworkStatus",
            value: function getNetworkStatus() {
                if (window.navigator.onLine) return (0, $8g8TT.NetworkStatusEnum).ONLINE;
                return (0, $8g8TT.NetworkStatusEnum).OFFLINE;
            }
        }
    ]);
    return NetworkStatus;
}();

});

parcelRegister("7cLi3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53ee56432c43aaeb$export$2e2bcd8739ae039; });

var $4GJKx = parcelRequire("4GJKx");

var $jjExS = parcelRequire("jjExS");

var $lxwYe = parcelRequire("lxwYe");

var $cGib5 = parcelRequire("cGib5");
var $53ee56432c43aaeb$var$SCHEDULER_OPTIONS_DEFAULT = {
    minRetryDelay: 1000,
    maxRetryDelay: 30000,
    backoffFactor: 2,
    backoffJitterPercentage: 0,
    waitInterval: 500,
    callbackTimeoutPeriod: 5000
};
var $53ee56432c43aaeb$export$8bb92baee001fc60 = /*#__PURE__*/ function(QueuedScheduleTypes) {
    QueuedScheduleTypes[QueuedScheduleTypes["NONE"] = 0] = "NONE";
    QueuedScheduleTypes[QueuedScheduleTypes["IMMEDIATE"] = 1] = "IMMEDIATE";
    QueuedScheduleTypes[QueuedScheduleTypes["WAIT"] = 2] = "WAIT";
    return QueuedScheduleTypes;
}({});
var $53ee56432c43aaeb$export$2e2bcd8739ae039 = function Scheduler(retryOptions, callback) {
    "use strict";
    var _this = this;
    (0, $4GJKx._)(this, Scheduler);
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "schedule", function() {
        var immediate = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
            immediate: false
        }).immediate;
        if (_this.operationInFlight) {
            if (immediate) _this.queuedSchedule = $53ee56432c43aaeb$export$8bb92baee001fc60.IMMEDIATE;
            else if (_this.queuedSchedule !== $53ee56432c43aaeb$export$8bb92baee001fc60.IMMEDIATE) _this.queuedSchedule = $53ee56432c43aaeb$export$8bb92baee001fc60.WAIT;
        // Only run immediately if we have no failures
        } else if ((immediate || _this.options.waitInterval <= 0) && _this.failureCount === 0) {
            _this.clearTimeout();
            _this.run();
        // Backoff
        } else if (_this.failureCount > 0 && _this.scheduledTimeout === null) _this.scheduledTimeout = window.setTimeout(_this.run, _this.calculateBackoff());
        else if (_this.scheduledTimeout === null) _this.scheduledTimeout = window.setTimeout(_this.run, _this.options.waitInterval);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "stop", function() {
        _this.clearTimeout();
        _this.queuedSchedule = $53ee56432c43aaeb$export$8bb92baee001fc60.NONE;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "getFailureCount", function() {
        return _this.failureCount;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "getCallbackStatus", function() {
        return _this.callbackTimer.getCallbackStatus();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "clearTimeout", function() {
        if (_this.scheduledTimeout !== null) {
            window.clearTimeout(_this.scheduledTimeout);
            _this.scheduledTimeout = null;
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "run", function() {
        _this.operationInFlight = true;
        _this.clearTimeout();
        try {
            _this.callbackTimer.executeCallbackWithTimeout(// callback to execute
            _this.callback, // when callback completes, call this function
            _this.done, // on timeout, do this instead
            function() {
                return _this.done((0, $cGib5.DoneState).ERROR);
            });
        } catch (err) {
            _this.done(err);
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "done", function(state) {
        _this.operationInFlight = false;
        if (state === (0, $cGib5.DoneState).ERROR || _this.callbackTimer.getCallbackStatus() === (0, $lxwYe.CallbackStatus).TIMED_OUT) {
            _this.failureCount++;
            _this.clearTimeout();
        } else if (state === (0, $cGib5.DoneState).SUCCESS) _this.failureCount = 0;
        _this.processQueuedSchedule();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "processQueuedSchedule", function() {
        if (_this.queuedSchedule !== $53ee56432c43aaeb$export$8bb92baee001fc60.NONE) {
            var immediate = _this.queuedSchedule === $53ee56432c43aaeb$export$8bb92baee001fc60.IMMEDIATE;
            _this.queuedSchedule = $53ee56432c43aaeb$export$8bb92baee001fc60.NONE;
            _this.schedule({
                immediate: immediate
            });
        } else if (_this.failureCount > 0) // This will schedule tasks when this._done was called with a truthy value
        // For example, when this.callback(this._done) was not called within
        // this.callbackTimeoutPeriod
        _this.schedule();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "calculateBackoff", function() {
        var _this_options = _this.options, minRetryDelay = _this_options.minRetryDelay, maxRetryDelay = _this_options.maxRetryDelay, backoffFactor = _this_options.backoffFactor, backoffJitterPercentage = _this_options.backoffJitterPercentage;
        var ms = minRetryDelay * Math.pow(backoffFactor, _this.failureCount);
        if (backoffJitterPercentage) {
            var rand = Math.random();
            var deviation = Math.floor(rand * backoffJitterPercentage * ms);
            if (Math.floor(rand * 10) < 5) ms -= deviation;
            else ms += deviation;
        }
        return Number(Math.min(ms, maxRetryDelay).toPrecision(1));
    });
    this.options = {
        minRetryDelay: retryOptions.minRetryDelay || $53ee56432c43aaeb$var$SCHEDULER_OPTIONS_DEFAULT.minRetryDelay,
        maxRetryDelay: retryOptions.maxRetryDelay || $53ee56432c43aaeb$var$SCHEDULER_OPTIONS_DEFAULT.maxRetryDelay,
        backoffFactor: retryOptions.backoffFactor || $53ee56432c43aaeb$var$SCHEDULER_OPTIONS_DEFAULT.backoffFactor,
        backoffJitterPercentage: retryOptions.backoffJitterPercentage || $53ee56432c43aaeb$var$SCHEDULER_OPTIONS_DEFAULT.backoffJitterPercentage,
        waitInterval: retryOptions.waitInterval !== undefined ? retryOptions.waitInterval : $53ee56432c43aaeb$var$SCHEDULER_OPTIONS_DEFAULT.waitInterval,
        callbackTimeoutPeriod: retryOptions.callbackTimeoutPeriod || $53ee56432c43aaeb$var$SCHEDULER_OPTIONS_DEFAULT.callbackTimeoutPeriod
    };
    this.scheduledTimeout = null;
    this.failureCount = 0;
    this.callback = callback;
    this.operationInFlight = false;
    this.queuedSchedule = $53ee56432c43aaeb$export$8bb92baee001fc60.NONE;
    this.callbackTimer = new (0, $lxwYe.CallbackWithTimeout)(this.options.callbackTimeoutPeriod);
};

});
parcelRegister("lxwYe", function(module, exports) {

$parcel$export(module.exports, "CallbackStatus", function () { return $fae6414b60a8a778$export$ef3353088fca369c; });
$parcel$export(module.exports, "CallbackWithTimeout", function () { return $fae6414b60a8a778$export$590a718599f8f8b3; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $jjExS = parcelRequire("jjExS");
var $fae6414b60a8a778$export$ef3353088fca369c = /*#__PURE__*/ function(CallbackStatus) {
    CallbackStatus["IDLE"] = "idle";
    CallbackStatus["RUNNING"] = "running";
    CallbackStatus["COMPLETED"] = "completed";
    CallbackStatus["TIMED_OUT"] = "timedOut";
    return CallbackStatus;
}({});
var $fae6414b60a8a778$export$def7d978353eaa0 = /*#__PURE__*/ function(CallbackEvent) {
    CallbackEvent["EXECUTE"] = "execute";
    CallbackEvent["COMPLETE"] = "complete";
    CallbackEvent["TIMEOUT"] = "timeout";
    return CallbackEvent;
}({});
var $fae6414b60a8a778$export$590a718599f8f8b3 = /*#__PURE__*/ function() {
    "use strict";
    function CallbackWithTimeout(timeoutPeriod) {
        (0, $4GJKx._)(this, CallbackWithTimeout);
        // Milliseconds to wait
        // Tracks the settimeout; so that we can clear the timeout
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "timeoutHandle", undefined);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "callbackStatus", $fae6414b60a8a778$export$ef3353088fca369c.IDLE);
        if (timeoutPeriod > 0) {
            this.timeoutPeriod = timeoutPeriod;
            return;
        }
        throw new Error("CallbackWithTimeout requires timeout period higher than 0");
    }
    (0, $1wc17._)(CallbackWithTimeout, [
        {
            // This is a state machine to control the flow of execution.
            // IDLE -> RUNNING -> COMPLETED
            // IDLE -> RUNNING -> TIMEDOUT
            key: "transitionCallbackStatus",
            value: function transitionCallbackStatus(currentStatus, event) {
                switch(currentStatus){
                    case $fae6414b60a8a778$export$ef3353088fca369c.IDLE:
                    case $fae6414b60a8a778$export$ef3353088fca369c.TIMED_OUT:
                    case $fae6414b60a8a778$export$ef3353088fca369c.COMPLETED:
                        if (event === $fae6414b60a8a778$export$def7d978353eaa0.EXECUTE) this.callbackStatus = $fae6414b60a8a778$export$ef3353088fca369c.RUNNING;
                        break;
                    case $fae6414b60a8a778$export$ef3353088fca369c.RUNNING:
                        switch(event){
                            case $fae6414b60a8a778$export$def7d978353eaa0.COMPLETE:
                                this.callbackStatus = $fae6414b60a8a778$export$ef3353088fca369c.COMPLETED;
                                break;
                            case $fae6414b60a8a778$export$def7d978353eaa0.TIMEOUT:
                                this.callbackStatus = $fae6414b60a8a778$export$ef3353088fca369c.TIMED_OUT;
                                break;
                        }
                        break;
                    default:
                        this.callbackStatus = currentStatus;
                }
            }
        },
        {
            // Start a timeout. If this.callback(this._done) does not finish
            // by this.options.callbackTimeoutPeriod time period,
            // we will call done with a true value.
            key: "executeCallbackWithTimeout",
            value: function executeCallbackWithTimeout(callback, onDone, onTimeout) {
                var _this = this;
                this.transitionCallbackStatus(this.callbackStatus, $fae6414b60a8a778$export$def7d978353eaa0.EXECUTE);
                // Setting timeout
                this.timeoutHandle = window.setTimeout(function() {
                    _this.transitionCallbackStatus(_this.callbackStatus, $fae6414b60a8a778$export$def7d978353eaa0.TIMEOUT);
                    onTimeout();
                }, this.timeoutPeriod);
                // Executing callback
                callback(function(state) {
                    _this.cancelTimeout();
                    if (_this.getCallbackStatus() !== $fae6414b60a8a778$export$ef3353088fca369c.TIMED_OUT) {
                        _this.transitionCallbackStatus(_this.callbackStatus, $fae6414b60a8a778$export$def7d978353eaa0.COMPLETE);
                        onDone(state);
                    }
                });
            }
        },
        {
            key: "getCallbackStatus",
            value: function getCallbackStatus() {
                return this.callbackStatus;
            }
        },
        {
            // This allows us to cancel the timeout function, for example, if the callback finishes before the timeout period
            // or, if the user wants to manually cancel the timeout
            key: "cancelTimeout",
            value: function cancelTimeout() {
                if (this.timeoutPeriod > 0 && this.timeoutHandle) {
                    window.clearTimeout(this.timeoutHandle);
                    this.timeoutHandle = undefined;
                }
            }
        }
    ]);
    return CallbackWithTimeout;
}();

});

parcelRegister("cGib5", function(module, exports) {

$parcel$export(module.exports, "DoneState", function () { return $93b7820154462d6a$export$f93c40fda808dd0c; });
// Clients can optionally provide the callbackTimeoutPeriod parameter
var $93b7820154462d6a$export$f93c40fda808dd0c = /*#__PURE__*/ function(DoneState) {
    DoneState[DoneState["NOOP"] = 0] = "NOOP";
    DoneState[DoneState["SUCCESS"] = 1] = "SUCCESS";
    DoneState[DoneState["ERROR"] = 2] = "ERROR";
    return DoneState;
}({});

});




parcelRegister("445Ie", function(module, exports) {

$parcel$export(module.exports, "attachXidToMultipleEvents", function () { return $2f5bf78384553587$export$c21270cab66ab290; });

var $kSuI9 = parcelRequire("kSuI9");

var $l29cN = parcelRequire("l29cN");

var $jjExS = parcelRequire("jjExS");

var $7bKoC = parcelRequire("7bKoC");
function $2f5bf78384553587$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2f5bf78384553587$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2f5bf78384553587$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2f5bf78384553587$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2f5bf78384553587$export$c9c3aaf655d6f275(item, xidCallback) {
    if (!(xidCallback && xidCallback instanceof Function)) return item;
    if (item.msg.type === (0, $7bKoC.SegmentEventTypes).PAGE || item.msg.type === (0, $7bKoC.SegmentEventTypes).TRACK) {
        var xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.properties = $2f5bf78384553587$var$_objectSpread($2f5bf78384553587$var$_objectSpread({}, item.msg.properties), {}, {
            xid: xid
        });
    } else if (item.msg.traits && item.msg.type === (0, $7bKoC.SegmentEventTypes).IDENTIFY) {
        var xid1 = xidCallback();
        if (xid1 && Array.isArray(xid1)) item.msg.traits = $2f5bf78384553587$var$_objectSpread($2f5bf78384553587$var$_objectSpread({}, item.msg.traits), {}, {
            xid: xid1
        });
    }
    return item;
}
function $2f5bf78384553587$export$c21270cab66ab290(items, xidItemPromiseCallback) {
    return $2f5bf78384553587$var$_attachXidToMultipleEvents.apply(this, arguments);
}
function $2f5bf78384553587$var$_attachXidToMultipleEvents() {
    $2f5bf78384553587$var$_attachXidToMultipleEvents = (0, $kSuI9._)(function(items, xidItemPromiseCallback) {
        var xidCallback, error;
        return (0, $l29cN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        xidItemPromiseCallback
                    ];
                case 1:
                    xidCallback = _state.sent();
                    return [
                        2,
                        items.map(function(item) {
                            return $2f5bf78384553587$export$c9c3aaf655d6f275(item, xidCallback);
                        })
                    ];
                case 2:
                    error = _state.sent();
                    return [
                        2,
                        items
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return $2f5bf78384553587$var$_attachXidToMultipleEvents.apply(this, arguments);
}

});
parcelRegister("7bKoC", function(module, exports) {

$parcel$export(module.exports, "SegmentEventTypes", function () { return $53bd8cc7f7db7738$export$ddf929981dc6feb3; });
// Segment event types copied from our backend
// https://bitbucket.org/atlassian/analytics-service/src/master/api/src/main/java/com/atlassian/dataservices/analytics/service/api/segment/
var $53bd8cc7f7db7738$export$ddf929981dc6feb3 = /*#__PURE__*/ function(SegmentEventTypes) {
    SegmentEventTypes["IDENTIFY"] = "identify";
    SegmentEventTypes["PAGE"] = "page";
    SegmentEventTypes["TRACK"] = "track";
    return SegmentEventTypes;
}({});
var $53bd8cc7f7db7738$export$8d8db47b9b0efb63 = /*#__PURE__*/ function(CrossDomainIdentifierType) {
    CrossDomainIdentifierType["XC"] = "xc";
    CrossDomainIdentifierType["UID"] = "uid";
    return CrossDomainIdentifierType;
}({});
var $53bd8cc7f7db7738$export$2140495465f9e528 = /*#__PURE__*/ function(CrossDomainIdentifierState) {
    CrossDomainIdentifierState["NEW"] = "NEW";
    CrossDomainIdentifierState["CHANGED"] = "CHANGED";
    CrossDomainIdentifierState["EXISTING"] = "EXISTING";
    CrossDomainIdentifierState["TIMEOUT"] = "TIMEOUT";
    CrossDomainIdentifierState["ERROR"] = "ERROR";
    CrossDomainIdentifierState["UNAVAILABLE"] = "UNAVAILABLE";
    CrossDomainIdentifierState["MALFORMED"] = "MALFORMED";
    CrossDomainIdentifierState["UNKNOWN"] = "UNKNOWN";
    return CrossDomainIdentifierState;
}({});

});


parcelRegister("alx1Y", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_REQUEST_TIMEOUT", function () { return $78857cc9c6a8c085$export$9175ce0e1c95daf2; });
var $78857cc9c6a8c085$export$9175ce0e1c95daf2 = 10000; // 10 seconds

});

parcelRegister("2p4pW", function(module, exports) {

$parcel$export(module.exports, "sendEvents", function () { return $1c0157cb0c7fcf39$export$8e8f0180c1b41fad; });

var $kSuI9 = parcelRequire("kSuI9");

var $l29cN = parcelRequire("l29cN");

var $jjExS = parcelRequire("jjExS");

var $eUBSC = parcelRequire("eUBSC");
function $1c0157cb0c7fcf39$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1c0157cb0c7fcf39$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1c0157cb0c7fcf39$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1c0157cb0c7fcf39$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1c0157cb0c7fcf39$export$8e8f0180c1b41fad = function() {
    var _ref = (0, $kSuI9._)(function(options) {
        var _createOrGetAbortCont, signal, corsOptions, response;
        return (0, $l29cN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    signal = (_createOrGetAbortCont = $1c0157cb0c7fcf39$var$createOrGetAbortController(options)) === null || _createOrGetAbortCont === void 0 ? void 0 : _createOrGetAbortCont.signal;
                    corsOptions = $1c0157cb0c7fcf39$var$getCorsForUrl(options.url);
                    return [
                        4,
                        fetch(options.url, $1c0157cb0c7fcf39$var$_objectSpread({
                            method: "POST",
                            // Content-type has to be text/plain in order to prevent unnecessary `OPTIONS` requests.
                            headers: {
                                "Content-Type": "text/plain"
                            },
                            body: JSON.stringify(options.batch),
                            signal: signal
                        }, corsOptions))
                    ];
                case 1:
                    response = _state.sent();
                    if (response.status === 429 || response.status >= 500 && response.status < 600) throw new Error("HTTP Error ".concat(response.status, " (").concat(response.statusText, ")"));
                    return [
                        2,
                        response
                    ];
            }
        });
    });
    return function sendEvents(options) {
        return _ref.apply(this, arguments);
    };
}();
var $1c0157cb0c7fcf39$var$createOrGetAbortController = function(options) {
    if (options.abortController) return options.abortController;
    else if (options.timeout) {
        var abortController = new AbortController();
        // After a fetch has completed, calling abort is ignored.
        setTimeout(function() {
            abortController.abort();
        }, options.timeout);
        return abortController;
    }
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
var $1c0157cb0c7fcf39$var$getCorsForUrl = (0, $eUBSC.default)(function(url) {
    var origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: "cors",
        credentials: "include"
    };
});

});
parcelRegister("eUBSC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $adb3add65ddbc371$export$2e2bcd8739ae039; });
var $adb3add65ddbc371$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function $adb3add65ddbc371$var$isEqual(first, second) {
    if (first === second) return true;
    if ($adb3add65ddbc371$var$safeIsNaN(first) && $adb3add65ddbc371$var$safeIsNaN(second)) return true;
    return false;
}
function $adb3add65ddbc371$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$adb3add65ddbc371$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $adb3add65ddbc371$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $adb3add65ddbc371$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}

});


parcelRegister("axYp2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7adbd72e532c3654$export$2e2bcd8739ae039; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $6iVV5 = parcelRequire("6iVV5");

var $ktzPa = parcelRequire("ktzPa");

var $l8E1M = parcelRequire("l8E1M");

var $bi0wG = parcelRequire("bi0wG");
var $7adbd72e532c3654$export$c28ab15bb6a6e3e7 = "ajs_anonymous_id";
// Cookie is stale, if anonymousId was generated 7 days ago.
var $7adbd72e532c3654$var$ANONYMOUS_ID_COOKIE_STALE_DAYS = 7;
var $7adbd72e532c3654$var$SAFE = "SAFE";
var $7adbd72e532c3654$var$UNSAFE = "UNSAFE";
var $7adbd72e532c3654$var$NOT_FOUND = "NOT_FOUND";
var $7adbd72e532c3654$var$COOKIE = "COOKIE";
var $7adbd72e532c3654$var$LOCAL_STORAGE = "LOCAL_STORAGE";
var $7adbd72e532c3654$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function User() {
        (0, $4GJKx._)(this, User);
        this.store = new (0, $bi0wG.default)({
            useStoragePrefix: false
        });
        this.cookie = new (0, $l8E1M.default)();
    }
    (0, $1wc17._)(User, [
        {
            key: "getUserId",
            value: function getUserId() {
                return this.userId || null;
            }
        },
        {
            key: "setUserId",
            value: function setUserId(userId) {
                this.userId = userId;
            }
        },
        {
            key: "getAnonymousId",
            value: function getAnonymousId(customAnonymousIdGenerator) {
                /**
     * Prefer localStorage as there cant be duplicate keys, and its faster. Also update cookie, if stale.
     * If not set in localStorage, check cookies. Also set localStorage for future attempts.
     * If not in cookies, generate a new one. Set both cookie and localStorage keys.
     */ return this.getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() || this.getAnonymousIdFromCookieAndUpdateLocalStorage() || this.generateNewAnonymousId(customAnonymousIdGenerator);
            }
        },
        {
            key: "setAnonymousId",
            value: function setAnonymousId(anonymousId) {
                var stringifyAnonymosId = JSON.stringify(anonymousId);
                this.cookie.set($7adbd72e532c3654$export$c28ab15bb6a6e3e7, stringifyAnonymosId);
                this.lastAnonymousIdCookieUpdate = Date.now();
                return this.store.setItem($7adbd72e532c3654$export$c28ab15bb6a6e3e7, stringifyAnonymosId);
            }
        },
        {
            key: "getAnonymousIdFromStorage",
            value: function getAnonymousIdFromStorage(source) {
                var rawStorageAnonidValue = source === $7adbd72e532c3654$var$LOCAL_STORAGE ? this.store.getItem($7adbd72e532c3654$export$c28ab15bb6a6e3e7) : this.cookie.get($7adbd72e532c3654$export$c28ab15bb6a6e3e7);
                if (rawStorageAnonidValue) {
                    var unsafeValue = {
                        type: $7adbd72e532c3654$var$UNSAFE,
                        anonymousId: rawStorageAnonidValue
                    };
                    try {
                        var parsedAnonId = JSON.parse(rawStorageAnonidValue);
                        if (parsedAnonId && typeof parsedAnonId === "string") return {
                            type: $7adbd72e532c3654$var$SAFE,
                            anonymousId: parsedAnonId
                        };
                        return unsafeValue;
                    } catch (err) {
                        /*
         * Segments new Analytics-next client will store strings as strings without stringifing.
         * The legacy Segment client and AWC always stringify and parse cookies and values.
         * If the new Segment analytics-client stores a cookie and local storage value first, it will
         * breaking old clients.
         *
         * Additionally, JSON.parse can cause exceptions to be thrown in some browsers; see AAP-324.
         *
         * Intentionally swalling errors here and returning the original value found in storage to avoid ping-pong.
         */ return unsafeValue;
                    }
                }
                return {
                    type: $7adbd72e532c3654$var$NOT_FOUND
                };
            }
        },
        {
            key: "getAnonymousIdFromLocalStorageAndUpdateCookieIfStale",
            value: function getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() {
                var localStorageValue = this.getAnonymousIdFromStorage($7adbd72e532c3654$var$LOCAL_STORAGE);
                var shouldUpdateCookie = false;
                if (!this.lastAnonymousIdCookieUpdate || (0, $6iVV5.default)(new Date(), new Date(this.lastAnonymousIdCookieUpdate)) >= $7adbd72e532c3654$var$ANONYMOUS_ID_COOKIE_STALE_DAYS) shouldUpdateCookie = true;
                switch(localStorageValue.type){
                    case $7adbd72e532c3654$var$SAFE:
                        if (shouldUpdateCookie) this.setAnonymousId(localStorageValue.anonymousId);
                        return localStorageValue.anonymousId;
                    case $7adbd72e532c3654$var$UNSAFE:
                        return localStorageValue.anonymousId;
                    case $7adbd72e532c3654$var$NOT_FOUND:
                    default:
                        return null;
                }
            }
        },
        {
            key: "getAnonymousIdFromCookieAndUpdateLocalStorage",
            value: function getAnonymousIdFromCookieAndUpdateLocalStorage() {
                var cookieValue = this.getAnonymousIdFromStorage($7adbd72e532c3654$var$COOKIE);
                switch(cookieValue.type){
                    case $7adbd72e532c3654$var$SAFE:
                    case $7adbd72e532c3654$var$UNSAFE:
                        this.store.setItem($7adbd72e532c3654$export$c28ab15bb6a6e3e7, JSON.stringify(cookieValue.anonymousId));
                        return cookieValue.anonymousId;
                    case $7adbd72e532c3654$var$NOT_FOUND:
                    default:
                        return null;
                }
            }
        },
        {
            key: "generateNewAnonymousId",
            value: function generateNewAnonymousId() {
                var customAnonymousIdGenerator = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, (/*@__PURE__*/$parcel$interopDefault($ktzPa)));
                var newAnonId = customAnonymousIdGenerator();
                this.setAnonymousId(newAnonId);
                return newAnonId;
            }
        }
    ]);
    return User;
}();

});
parcelRegister("6iVV5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49715a28c806a5c0$export$2e2bcd8739ae039; });

var $bcxku = parcelRequire("bcxku");

var $9nMbt = parcelRequire("9nMbt");

var $iEgBT = parcelRequire("iEgBT");
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $49715a28c806a5c0$var$compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
function $49715a28c806a5c0$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $iEgBT.default)(2, arguments);
    var dateLeft = (0, $bcxku.default)(dirtyDateLeft);
    var dateRight = (0, $bcxku.default)(dirtyDateRight);
    var sign = $49715a28c806a5c0$var$compareLocalAsc(dateLeft, dateRight);
    var difference = Math.abs((0, $9nMbt.default)(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number($49715a28c806a5c0$var$compareLocalAsc(dateLeft, dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});
parcelRegister("bcxku", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $021ac0b28ca79ad3$export$2e2bcd8739ae039; });

var $iVDBw = parcelRequire("iVDBw");

var $iEgBT = parcelRequire("iEgBT");
function $021ac0b28ca79ad3$export$2e2bcd8739ae039(argument) {
    (0, $iEgBT.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $iVDBw.default)(argument) === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

});
parcelRegister("iVDBw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc7c4573339dd2fe$export$2e2bcd8739ae039; });
function $dc7c4573339dd2fe$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $dc7c4573339dd2fe$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $dc7c4573339dd2fe$export$2e2bcd8739ae039(o);
}

});

parcelRegister("iEgBT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d938d8d82288cd31$export$2e2bcd8739ae039; });
function $d938d8d82288cd31$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}

});


parcelRegister("9nMbt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d4ba368e8923989$export$2e2bcd8739ae039; });

var $5oghF = parcelRequire("5oghF");

var $lU1uQ = parcelRequire("lU1uQ");

var $iEgBT = parcelRequire("iEgBT");
var $6d4ba368e8923989$var$MILLISECONDS_IN_DAY = 86400000;
function $6d4ba368e8923989$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $iEgBT.default)(2, arguments);
    var startOfDayLeft = (0, $lU1uQ.default)(dirtyDateLeft);
    var startOfDayRight = (0, $lU1uQ.default)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $5oghF.default)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $5oghF.default)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $6d4ba368e8923989$var$MILLISECONDS_IN_DAY);
}

});
parcelRegister("5oghF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3ecbd34b7d8761a1$export$2e2bcd8739ae039; });
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $3ecbd34b7d8761a1$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

});

parcelRegister("lU1uQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff1ffd17d0ac1527$export$2e2bcd8739ae039; });

var $bcxku = parcelRequire("bcxku");

var $iEgBT = parcelRequire("iEgBT");
function $ff1ffd17d0ac1527$export$2e2bcd8739ae039(dirtyDate) {
    (0, $iEgBT.default)(1, arguments);
    var date = (0, $bcxku.default)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}

});



parcelRegister("l8E1M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f63964feada7957f$export$2e2bcd8739ae039; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $jjExS = parcelRequire("jjExS");

var $jd4wD = parcelRequire("jd4wD");

var $c1ZG6 = parcelRequire("c1ZG6");

var $6ogBR = parcelRequire("6ogBR");

var $5CyIa = parcelRequire("5CyIa");
function $f63964feada7957f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f63964feada7957f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f63964feada7957f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f63964feada7957f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f63964feada7957f$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function CookieWrapper() {
        (0, $4GJKx._)(this, CookieWrapper);
        this.cookieLike = (0, $5CyIa.canUseCookie)() ? (0, (/*@__PURE__*/$parcel$interopDefault($jd4wD))) : new (0, $6ogBR.default)();
    }
    (0, $1wc17._)(CookieWrapper, [
        {
            key: "set",
            value: function set(name, value, options) {
                return this.cookieLike.set(name, value, $f63964feada7957f$var$_objectSpread($f63964feada7957f$var$_objectSpread({}, (0, $c1ZG6.COOKIE_OPTIONS)), {}, {
                    // Function is memoized so we only calculate this once per page load
                    domain: (0, $5CyIa.getTld)()
                }, options));
            }
        },
        {
            key: "get",
            value: function get(name) {
                return this.cookieLike.get(name);
            }
        },
        {
            key: "remove",
            value: function remove(name, options) {
                this.cookieLike.remove(name, $f63964feada7957f$var$_objectSpread({}, options));
            }
        }
    ]);
    return CookieWrapper;
}();

});
parcelRegister("jd4wD", function(module, exports) {
(function(factory) {
    var registeredInModuleLoader;
    if (typeof define === "function" && define.amd) {
        define(factory);
        registeredInModuleLoader = true;
    }
    module.exports = factory();
    registeredInModuleLoader = true;
    if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function() {
            window.Cookies = OldCookies;
            return api;
        };
    }
})(function() {
    function extend() {
        var i = 0;
        var result = {};
        for(; i < arguments.length; i++){
            var attributes = arguments[i];
            for(var key in attributes)result[key] = attributes[key];
        }
        return result;
    }
    function decode(s) {
        return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function init(converter) {
        function api() {}
        function set(key, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = extend({
                path: "/"
            }, api.defaults, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
            // We're using "expires" because "max-age" is not supported by IE
            attributes.expires = attributes.expires ? attributes.expires.toUTCString() : "";
            try {
                var result = JSON.stringify(value);
                if (/^[\{\[]/.test(result)) value = result;
            } catch (e) {}
            value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
            key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = key + "=" + value + stringifiedAttributes;
        }
        function get(key, json) {
            if (typeof document === "undefined") return;
            var jar = {};
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var i = 0;
            for(; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var cookie = parts.slice(1).join("=");
                if (!json && cookie.charAt(0) === '"') cookie = cookie.slice(1, -1);
                try {
                    var name = decode(parts[0]);
                    cookie = (converter.read || converter)(cookie, name) || decode(cookie);
                    if (json) try {
                        cookie = JSON.parse(cookie);
                    } catch (e) {}
                    jar[name] = cookie;
                    if (key === name) break;
                } catch (e) {}
            }
            return key ? jar[key] : jar;
        }
        api.set = set;
        api.get = function(key) {
            return get(key, false);
        };
        api.getJSON = function(key) {
            return get(key, true);
        };
        api.remove = function(key, attributes) {
            set(key, "", extend(attributes, {
                expires: -1
            }));
        };
        api.defaults = {};
        api.withConverter = init;
        return api;
    }
    return init(function() {});
});

});

parcelRegister("c1ZG6", function(module, exports) {

$parcel$export(module.exports, "COOKIE_OPTIONS", function () { return $8c256bfe3ff9482c$export$5d04dceb9d38c3f8; });
var $8c256bfe3ff9482c$export$5d04dceb9d38c3f8 = {
    // 1 year
    expires: 365,
    secure: window.location.protocol === "https:",
    path: "/"
};

});

parcelRegister("6ogBR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4a71de5103b2d4bd$export$2e2bcd8739ae039; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $bi0wG = parcelRequire("bi0wG");
var $4a71de5103b2d4bd$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function LocalStorageAlt() {
        (0, $4GJKx._)(this, LocalStorageAlt);
        this.safeStorage = new (0, $bi0wG.default)({
            useStoragePrefix: false
        });
    }
    (0, $1wc17._)(LocalStorageAlt, [
        {
            key: "set",
            value: function set(name, value) {
                this.safeStorage.setItem(name, value);
                return value;
            }
        },
        {
            key: "get",
            value: function get(name) {
                var value = this.safeStorage.getItem(name);
                return value || undefined;
            }
        },
        {
            key: "remove",
            value: function remove(name) {
                this.safeStorage.removeItem(name);
            }
        }
    ]);
    return LocalStorageAlt;
}();

});
parcelRegister("bi0wG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8381c89bfb52a32b$export$2e2bcd8739ae039; });

var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $ohfOJ = parcelRequire("ohfOJ");

var $cuRVC = parcelRequire("cuRVC");

var $6fntO = parcelRequire("6fntO");
var $8381c89bfb52a32b$export$2e2bcd8739ae039 = /*#__PURE__*/ function(SafeStorage) {
    "use strict";
    (0, $dcsZi._)(_class, SafeStorage);
    var _super = (0, $ohfOJ._)(_class);
    function _class(options) {
        (0, $4GJKx._)(this, _class);
        var storageToUse;
        try {
            storageToUse = window.localStorage || (0, $cuRVC.default);
        } catch (err) {
            storageToUse = (0, $cuRVC.default);
        }
        return _super.call(this, storageToUse, options);
    }
    return _class;
}((0, $6fntO.default));

});
parcelRegister("cuRVC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91921e66fc9fdc75$export$2e2bcd8739ae039; });

var $4GJKx = parcelRequire("4GJKx");

var $jjExS = parcelRequire("jjExS");
var $91921e66fc9fdc75$export$90e3e001bcac59c7 = function InMemoryStore() {
    "use strict";
    var _this = this;
    (0, $4GJKx._)(this, InMemoryStore);
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_data", {});
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "length", 0);
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "setItem", function(key, value) {
        _this._data[key] = value;
        _this.length = Object.keys(_this._data).length;
        return value;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "getItem", function(key) {
        if (key in _this._data) return _this._data[key];
        return null;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "removeItem", function(key) {
        if (key in _this._data) delete _this._data[key];
        _this.length = Object.keys(_this._data).length;
        return null;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "clear", function() {
        _this._data = {};
        _this.length = 0;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "key", function(index) {
        return Object.keys(_this._data)[index];
    });
};
var $91921e66fc9fdc75$export$2e2bcd8739ae039 = new $91921e66fc9fdc75$export$90e3e001bcac59c7();

});

parcelRegister("6fntO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48c65b6b837fa536$export$2e2bcd8739ae039; });

var $4GJKx = parcelRequire("4GJKx");

var $jjExS = parcelRequire("jjExS");

var $22Iz2 = parcelRequire("22Iz2");

var $cuRVC = parcelRequire("cuRVC");
var $48c65b6b837fa536$export$41c06fdd37b7e9a5 = "awc";
var $48c65b6b837fa536$export$770aa8bc07b3de03 = "awcInMemoryStorageFallback";
function $48c65b6b837fa536$export$48c17662a6902497(store) {
    var TEST_VALUE = "test_value";
    if (!store) return false;
    try {
        var key = "awc.storage.support";
        store.setItem(key, TEST_VALUE);
        var value = store.getItem(key);
        store.removeItem(key);
        // handle localStorage silently failing
        return value === TEST_VALUE;
    } catch (e) {
        // Can throw if localStorage is disabled
        return false;
    }
}
function $48c65b6b837fa536$export$6325979d1c67607f(e) {
    var quotaExceeded = false;
    if (e.code) switch(e.code){
        case 22:
            quotaExceeded = true;
            break;
        case 1014:
            // Firefox
            if (e.name === "NS_ERROR_DOM_QUOTA_REACHED") quotaExceeded = true;
            break;
        default:
            break;
    }
    else if (e.number === -2147024882) // Internet Explorer 8
    quotaExceeded = true;
    return quotaExceeded;
}
var $48c65b6b837fa536$export$2e2bcd8739ae039 = function SafeStorage(storageToUse) {
    "use strict";
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _this = this;
    (0, $4GJKx._)(this, SafeStorage);
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "getStore", function() {
        return _this._store;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "getItem", function(key) {
        return _this._store.getItem(_this.createKey(key));
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "removeItem", function(key) {
        return _this._store.removeItem(_this.createKey(key));
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "setItem", function(key, value) {
        try {
            _this._store.setItem(_this.createKey(key), value);
        } catch (err) {
            if ($48c65b6b837fa536$export$6325979d1c67607f(err)) {
                _this.swapToInMemory();
                _this._store.setItem(_this.createKey(key), value);
            }
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "swapToInMemory", function() {
        if (_this._store === (0, $cuRVC.default)) return;
        var keys = Object.keys(_this._store || {});
        var inMemoryStorage;
        if ($48c65b6b837fa536$export$48c17662a6902497(window[$48c65b6b837fa536$export$770aa8bc07b3de03])) inMemoryStorage = window[$48c65b6b837fa536$export$770aa8bc07b3de03];
        else {
            inMemoryStorage = (0, $cuRVC.default);
            if (!window[$48c65b6b837fa536$export$770aa8bc07b3de03]) // If not already attached to window then attach our instance of InMemoryStorage
            // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
            // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
            window[$48c65b6b837fa536$export$770aa8bc07b3de03] = (0, $cuRVC.default);
        }
        keys.forEach(function(key) {
            if (key.indexOf(_this.getPrefix()) === 0) {
                var value = _this._store.getItem(key);
                if (value) inMemoryStorage.setItem(key, value);
            }
        });
        _this._store = inMemoryStorage;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "clear", function() {
        return _this._store.clear();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "key", function(index) {
        return _this._store.key(index);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "getPrefix", function() {
        return _this._prefix;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "createKey", function(key) {
        if (_this._prefix) return "".concat(_this.getPrefix(), ".").concat(key);
        return key;
    });
    this.options = options;
    var prefixes = [];
    if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push($48c65b6b837fa536$export$41c06fdd37b7e9a5);
    if (options.envPrefix && options.envPrefix !== (0, $22Iz2.envType).PROD) prefixes.push(options.envPrefix);
    this._prefix = prefixes.join("-");
    if ($48c65b6b837fa536$export$48c17662a6902497(storageToUse)) this._store = storageToUse;
    else this.swapToInMemory();
};

});



parcelRegister("5CyIa", function(module, exports) {

$parcel$export(module.exports, "canUseCookie", function () { return $417b6d52a93286f9$export$a9330601ee8f4d95; });
$parcel$export(module.exports, "getTld", function () { return $417b6d52a93286f9$export$de6821eed3d5f32d; });

var $jd4wD = parcelRequire("jd4wD");

var $eUBSC = parcelRequire("eUBSC");
var $417b6d52a93286f9$export$a9330601ee8f4d95 = function() {
    return !(location.protocol === "file:" || location.protocol === "chrome-extension:");
};
var $417b6d52a93286f9$export$eb80e1beaa8dacf8 = "__awc_tld_test__";
var $417b6d52a93286f9$export$19164982d36535d8 = "tld_test";
var $417b6d52a93286f9$export$de6821eed3d5f32d = (0, $eUBSC.default)(function() {
    var hostname = location.hostname;
    var splitHostname = hostname.split(".");
    for(var i = 1; i <= splitHostname.length; i++){
        var domainParts = splitHostname.slice(i * -1);
        var domain = ".".concat(domainParts.join("."));
        (0, (/*@__PURE__*/$parcel$interopDefault($jd4wD))).set($417b6d52a93286f9$export$eb80e1beaa8dacf8, $417b6d52a93286f9$export$19164982d36535d8, {
            domain: domain
        });
        if ((0, (/*@__PURE__*/$parcel$interopDefault($jd4wD))).get($417b6d52a93286f9$export$eb80e1beaa8dacf8) === $417b6d52a93286f9$export$19164982d36535d8) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jd4wD))).remove($417b6d52a93286f9$export$eb80e1beaa8dacf8, {
                domain: domain
            });
            return domain;
        }
    }
    return hostname;
});

});



parcelRegister("il7rS", function(module, exports) {

$parcel$export(module.exports, "buildContext", function () { return $d59ff7483b8b0a90$export$3a7fe28f9bf4f3d9; });
$parcel$export(module.exports, "prepareEventProperties", function () { return $d59ff7483b8b0a90$export$44d22e5fb02cc68e; });

var $jjExS = parcelRequire("jjExS");

var $bs4YN = parcelRequire("bs4YN");
function $d59ff7483b8b0a90$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d59ff7483b8b0a90$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d59ff7483b8b0a90$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d59ff7483b8b0a90$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d59ff7483b8b0a90$export$3a7fe28f9bf4f3d9 = function(context) {
    return $d59ff7483b8b0a90$var$_objectSpread($d59ff7483b8b0a90$var$_objectSpread({}, context.context), {}, {
        userAgent: navigator.userAgent
    });
};
var $d59ff7483b8b0a90$export$44d22e5fb02cc68e = function(properties) {
    var propertiesWithoutUndefined = $d59ff7483b8b0a90$export$2250ccecd1e040fd(properties);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bs4YN)))(propertiesWithoutUndefined);
};
var $d59ff7483b8b0a90$export$2250ccecd1e040fd = function(obj) {
    if (obj === null || typeof obj !== "object") return obj;
    var clone = {};
    Object.keys(obj).forEach(function(key) {
        var value = $d59ff7483b8b0a90$var$getValueOfObject(obj, key);
        if (value !== undefined) {
            if (Array.isArray(value)) clone[key] = value.map(function(i) {
                return $d59ff7483b8b0a90$export$2250ccecd1e040fd(i);
            });
            else if (typeof value === "object" && value !== null) clone[key] = $d59ff7483b8b0a90$export$2250ccecd1e040fd(value);
            else clone[key] = value;
        }
    });
    return clone;
};
// Using ts-ignore everywhere urked me
var $d59ff7483b8b0a90$var$getValueOfObject = function(obj, key) {
    // @ts-ignore This is an object
    return obj[key];
};

});
parcelRegister("bs4YN", function(module, exports) {
"use strict";

var $9p8ZX = parcelRequire("9p8ZX");
/**
 * Expose `traverse`.
 */ module.exports = $85662c19eb832f0d$var$traverse;
/**
 * Recursively traverse an object or array, and convert
 * all ISO date strings parse into Date objects.
 *
 * @param {Object} input - object, array, or string to convert
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $85662c19eb832f0d$var$traverse(input, strict) {
    if (strict === undefined) strict = true;
    if (input && typeof input === "object") return $85662c19eb832f0d$var$traverseObject(input, strict);
    else if (Array.isArray(input)) return $85662c19eb832f0d$var$traverseArray(input, strict);
    else if ($9p8ZX.is(input, strict)) return $9p8ZX.parse(input);
    return input;
}
/**
 * Object traverser helper function.
 *
 * @param {Object} obj - object to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $85662c19eb832f0d$var$traverseObject(obj, strict) {
    Object.keys(obj).forEach(function(key) {
        obj[key] = $85662c19eb832f0d$var$traverse(obj[key], strict);
    });
    return obj;
}
/**
 * Array traverser helper function
 *
 * @param {Array} arr - array to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Array}
 */ function $85662c19eb832f0d$var$traverseArray(arr, strict) {
    arr.forEach(function(value, index) {
        arr[index] = $85662c19eb832f0d$var$traverse(value, strict);
    });
    return arr;
}

});
parcelRegister("9p8ZX", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $6d8d6dbd0767db55$export$98e6a39c04603d36; }, function (v) { return $6d8d6dbd0767db55$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "is", function () { return $6d8d6dbd0767db55$export$226b3eccf92c9ed9; }, function (v) { return $6d8d6dbd0767db55$export$226b3eccf92c9ed9 = v; });
/**
 * Convert an ISO date string to a date. Fallback to native `Date.parse`.
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 *
 * @param {String} iso
 * @return {Date}
 */ var $6d8d6dbd0767db55$export$98e6a39c04603d36;
/**
 * Checks whether a `string` is an ISO date string. `strict` mode requires that
 * the date string at least have a year, month and date.
 *
 * @param {String} string
 * @param {Boolean} strict
 * @return {Boolean}
 */ var $6d8d6dbd0767db55$export$226b3eccf92c9ed9;
"use strict";
/**
 * Matcher, slightly modified from:
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 */ var $6d8d6dbd0767db55$var$matcher = /^(\d{4})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:([ T])(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
$6d8d6dbd0767db55$export$98e6a39c04603d36 = function(iso) {
    var numericKeys = [
        1,
        5,
        6,
        7,
        11,
        12
    ];
    var arr = $6d8d6dbd0767db55$var$matcher.exec(iso);
    var offset = 0;
    // fallback to native parsing
    if (!arr) return new Date(iso);
    /* eslint-disable no-cond-assign */ // remove undefined values
    for(var i = 0, val; val = numericKeys[i]; i++)arr[val] = parseInt(arr[val], 10) || 0;
    /* eslint-enable no-cond-assign */ // allow undefined days and months
    arr[2] = parseInt(arr[2], 10) || 1;
    arr[3] = parseInt(arr[3], 10) || 1;
    // month is 0-11
    arr[2]--;
    // allow abitrary sub-second precision
    arr[8] = arr[8] ? (arr[8] + "00").substring(0, 3) : 0;
    // apply timezone if one exists
    if (arr[4] === " ") offset = new Date().getTimezoneOffset();
    else if (arr[9] !== "Z" && arr[10]) {
        offset = arr[11] * 60 + arr[12];
        if (arr[10] === "+") offset = 0 - offset;
    }
    var millis = Date.UTC(arr[1], arr[2], arr[3], arr[5], arr[6] + offset, arr[7], arr[8]);
    return new Date(millis);
};
$6d8d6dbd0767db55$export$226b3eccf92c9ed9 = function(string, strict) {
    if (typeof string !== "string") return false;
    if (strict && /^\d{4}-\d{2}-\d{2}/.test(string) === false) return false;
    return $6d8d6dbd0767db55$var$matcher.test(string);
};

});




parcelRegister("aHFHo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7cae44120b233abb$export$2e2bcd8739ae039; });

var $4GJKx = parcelRequire("4GJKx");

var $3sHb8 = parcelRequire("3sHb8");

var $jjExS = parcelRequire("jjExS");

var $22Iz2 = parcelRequire("22Iz2");

var $gnvfh = parcelRequire("gnvfh");
var $7cae44120b233abb$export$2e2bcd8739ae039 = function OriginTracing() {
    "use strict";
    (0, $4GJKx._)(this, OriginTracing);
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "handleOriginParameters", function(originParamHandlerMapping, historyReplaceFn) {
        // Collect all the parameter labels to be handled
        var originParamLabelList = Object.keys(originParamHandlerMapping);
        if (!(originParamLabelList.length > 0)) throw new Error("Empty parameter mapping provided");
        // Check if the parameter labels are valid. If any invalid labels are found throw an exception.
        var invalidParams = originParamLabelList.filter(function(x) {
            return Object.values((0, $22Iz2.originTracingType)).indexOf(x) < 0;
        });
        if (invalidParams.length > 0) throw new Error("Invalid Origin Tracing Parameter(s) supplied: ".concat(invalidParams.join(), "!"));
        var isCaptureParam = function(_, key) {
            return originParamLabelList.indexOf(key) >= 0;
        };
        // Capture and remove params from URL
        var capturedURLParams = (0, $gnvfh.default)(isCaptureParam, historyReplaceFn);
        // Apply provided handler function to extract origin trace ID from each URL parameter
        var applyHandlerFunction = function(key) {
            var x = originParamHandlerMapping[key](capturedURLParams[key]);
            return (0, $3sHb8._)({}, key, x);
        };
        var extractedOriginID = Object.keys(capturedURLParams).map(applyHandlerFunction).reduce(function(accumulator, currentValue) {
            return Object.assign(accumulator, currentValue);
        }, {});
        return extractedOriginID;
    });
    this._originStore = {};
};

});
parcelRegister("gnvfh", function(module, exports) {

$parcel$export(module.exports, "defaultHistoryReplaceFn", function () { return $bec707ff6befcba6$export$600dd5bf1b049f11; });
$parcel$export(module.exports, "default", function () { return $bec707ff6befcba6$export$2e2bcd8739ae039; });

var $hlOOc = parcelRequire("hlOOc");

var $9kC89 = parcelRequire("9kC89");
var $bec707ff6befcba6$export$600dd5bf1b049f11 = function(newUrl) {
    return window.history.replaceState({}, "", newUrl);
};
var $bec707ff6befcba6$var$urlParamExtractor = function(isCaptureParam) {
    var historyReplaceFn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $bec707ff6befcba6$export$600dd5bf1b049f11;
    // Extract target parameters and values from URL if present
    var originalUrl = window.location.href;
    var fragmentHash = window.location.hash;
    var removedFragmentURL = fragmentHash !== "" ? originalUrl.replace(fragmentHash, "") : originalUrl;
    var _parseUrl = (0, $hlOOc.parseUrl)(removedFragmentURL), url = _parseUrl.url, query = _parseUrl.query;
    var captureParams = (0, $9kC89.pickBy)(query, isCaptureParam);
    // Do not modify URL if no matches
    if (Object.keys(captureParams).length > 0) {
        var queryWithoutCaptureParams = (0, $9kC89.omitBy)(query, isCaptureParam);
        // Replace the URL minus captured parameters
        if (Object.keys(queryWithoutCaptureParams).length > 0) {
            var newUrl = "".concat(url, "?").concat((0, $hlOOc.stringify)(queryWithoutCaptureParams)).concat(fragmentHash);
            historyReplaceFn(newUrl);
        } else historyReplaceFn("".concat(url).concat(fragmentHash));
    }
    return captureParams;
};
var $bec707ff6befcba6$export$2e2bcd8739ae039 = $bec707ff6befcba6$var$urlParamExtractor;

});
parcelRegister("hlOOc", function(module, exports) {

$parcel$export(module.exports, "extract", function () { return $ca1bcf611781a0b5$export$f9380c9a627682d3; }, function (v) { return $ca1bcf611781a0b5$export$f9380c9a627682d3 = v; });
$parcel$export(module.exports, "parse", function () { return $ca1bcf611781a0b5$export$98e6a39c04603d36; }, function (v) { return $ca1bcf611781a0b5$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "stringify", function () { return $ca1bcf611781a0b5$export$fac44ee5b035f737; }, function (v) { return $ca1bcf611781a0b5$export$fac44ee5b035f737 = v; });
$parcel$export(module.exports, "parseUrl", function () { return $ca1bcf611781a0b5$export$7a5253c0f62e0150; }, function (v) { return $ca1bcf611781a0b5$export$7a5253c0f62e0150 = v; });
$parcel$export(module.exports, "stringifyUrl", function () { return $ca1bcf611781a0b5$export$a8c1621ea79325d3; }, function (v) { return $ca1bcf611781a0b5$export$a8c1621ea79325d3 = v; });
$parcel$export(module.exports, "pick", function () { return $ca1bcf611781a0b5$export$357523c63a2253b9; }, function (v) { return $ca1bcf611781a0b5$export$357523c63a2253b9 = v; });

var $3sHb8 = parcelRequire("3sHb8");

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");
var $ca1bcf611781a0b5$export$f9380c9a627682d3;
var $ca1bcf611781a0b5$export$98e6a39c04603d36;
var $ca1bcf611781a0b5$export$fac44ee5b035f737;
var $ca1bcf611781a0b5$export$7a5253c0f62e0150;
var $ca1bcf611781a0b5$export$a8c1621ea79325d3;
var $ca1bcf611781a0b5$export$357523c63a2253b9;
var $ca1bcf611781a0b5$export$44c361b8ec72ef7f;
"use strict";

var $6pUpV = parcelRequire("6pUpV");

var $zKeTC = parcelRequire("zKeTC");

var $ljZAm = parcelRequire("ljZAm");

var $2Mx4x = parcelRequire("2Mx4x");
var $ca1bcf611781a0b5$var$isNullOrUndefined = function(value) {
    return value === null || value === undefined;
};
var $ca1bcf611781a0b5$var$encodeFragmentIdentifier = Symbol("encodeFragmentIdentifier");
function $ca1bcf611781a0b5$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case "index":
            return function(key) {
                return function(result, value) {
                    var index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return (0, $c6Xmf._)(result).concat([
                        [
                            $ca1bcf611781a0b5$var$encode(key, options),
                            "[",
                            index,
                            "]"
                        ].join("")
                    ]);
                    return (0, $c6Xmf._)(result).concat([
                        [
                            $ca1bcf611781a0b5$var$encode(key, options),
                            "[",
                            $ca1bcf611781a0b5$var$encode(index, options),
                            "]=",
                            $ca1bcf611781a0b5$var$encode(value, options)
                        ].join("")
                    ]);
                };
            };
        case "bracket":
            return function(key) {
                return function(result, value) {
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return (0, $c6Xmf._)(result).concat([
                        [
                            $ca1bcf611781a0b5$var$encode(key, options),
                            "[]"
                        ].join("")
                    ]);
                    return (0, $c6Xmf._)(result).concat([
                        [
                            $ca1bcf611781a0b5$var$encode(key, options),
                            "[]=",
                            $ca1bcf611781a0b5$var$encode(value, options)
                        ].join("")
                    ]);
                };
            };
        case "colon-list-separator":
            return function(key) {
                return function(result, value) {
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return (0, $c6Xmf._)(result).concat([
                        [
                            $ca1bcf611781a0b5$var$encode(key, options),
                            ":list="
                        ].join("")
                    ]);
                    return (0, $c6Xmf._)(result).concat([
                        [
                            $ca1bcf611781a0b5$var$encode(key, options),
                            ":list=",
                            $ca1bcf611781a0b5$var$encode(value, options)
                        ].join("")
                    ]);
                };
            };
        case "comma":
        case "separator":
        case "bracket-separator":
            {
                var keyValueSep = options.arrayFormat === "bracket-separator" ? "[]=" : "=";
                return function(key) {
                    return function(result, value) {
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? "" : value;
                        if (result.length === 0) return [
                            [
                                $ca1bcf611781a0b5$var$encode(key, options),
                                keyValueSep,
                                $ca1bcf611781a0b5$var$encode(value, options)
                            ].join("")
                        ];
                        return [
                            [
                                result,
                                $ca1bcf611781a0b5$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
                };
            }
        default:
            return function(key) {
                return function(result, value) {
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return (0, $c6Xmf._)(result).concat([
                        $ca1bcf611781a0b5$var$encode(key, options)
                    ]);
                    return (0, $c6Xmf._)(result).concat([
                        [
                            $ca1bcf611781a0b5$var$encode(key, options),
                            "=",
                            $ca1bcf611781a0b5$var$encode(value, options)
                        ].join("")
                    ]);
                };
            };
    }
}
function $ca1bcf611781a0b5$var$parserForArrayFormat(options) {
    var result;
    switch(options.arrayFormat){
        case "index":
            return function(key, value, accumulator) {
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case "bracket":
            return function(key, value, accumulator) {
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "colon-list-separator":
            return function(key, value, accumulator) {
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "comma":
        case "separator":
            return function(key, value, accumulator) {
                var isArray = typeof value === "string" && value.includes(options.arrayFormatSeparator);
                var isEncodedArray = typeof value === "string" && !isArray && $ca1bcf611781a0b5$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $ca1bcf611781a0b5$var$decode(value, options) : value;
                var newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map(function(item) {
                    return $ca1bcf611781a0b5$var$decode(item, options);
                }) : value === null ? value : $ca1bcf611781a0b5$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case "bracket-separator":
            return function(key, value, accumulator) {
                var isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, "");
                if (!isArray) {
                    accumulator[key] = value ? $ca1bcf611781a0b5$var$decode(value, options) : value;
                    return;
                }
                var arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map(function(item) {
                    return $ca1bcf611781a0b5$var$decode(item, options);
                });
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return function(key, value, accumulator) {
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $ca1bcf611781a0b5$var$validateArrayFormatSeparator(value) {
    if (typeof value !== "string" || value.length !== 1) throw new TypeError("arrayFormatSeparator must be single character string");
}
function $ca1bcf611781a0b5$var$encode(value, options) {
    if (options.encode) return options.strict ? $6pUpV(value) : encodeURIComponent(value);
    return value;
}
function $ca1bcf611781a0b5$var$decode(value, options) {
    if (options.decode) return $zKeTC(value);
    return value;
}
function $ca1bcf611781a0b5$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === "object") return $ca1bcf611781a0b5$var$keysSorter(Object.keys(input)).sort(function(a, b) {
        return Number(a) - Number(b);
    }).map(function(key) {
        return input[key];
    });
    return input;
}
function $ca1bcf611781a0b5$var$removeHash(input) {
    var hashStart = input.indexOf("#");
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $ca1bcf611781a0b5$var$getHash(url) {
    var hash = "";
    var hashStart = url.indexOf("#");
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $ca1bcf611781a0b5$var$extract(input) {
    input = $ca1bcf611781a0b5$var$removeHash(input);
    var queryStart = input.indexOf("?");
    if (queryStart === -1) return "";
    return input.slice(queryStart + 1);
}
function $ca1bcf611781a0b5$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === "string" && value.trim() !== "") value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) value = value.toLowerCase() === "true";
    return value;
}
function $ca1bcf611781a0b5$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $ca1bcf611781a0b5$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    var formatter = $ca1bcf611781a0b5$var$parserForArrayFormat(options);
    // Create an object with no prototype
    var ret = Object.create(null);
    if (typeof query !== "string") return ret;
    query = query.trim().replace(/^[?#&]/, "");
    if (!query) return ret;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = query.split("&")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var param = _step.value;
            if (param === "") continue;
            var _splitOnFirst = (0, $cv9Rk._)($ljZAm(options.decode ? param.replace(/\+/g, " ") : param, "="), 2), key = _splitOnFirst[0], value = _splitOnFirst[1];
            // Missing `=` should be `null`:
            // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
            value = value === undefined ? null : [
                "comma",
                "separator",
                "bracket-separator"
            ].includes(options.arrayFormat) ? value : $ca1bcf611781a0b5$var$decode(value, options);
            formatter($ca1bcf611781a0b5$var$decode(key, options), value, ret);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = Object.keys(ret)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var key1 = _step1.value;
            var value1 = ret[key1];
            var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
            if (typeof value1 === "object" && value1 !== null) try {
                for(var _iterator2 = Object.keys(value1)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                    var k = _step2.value;
                    value1[k] = $ca1bcf611781a0b5$var$parseValue(value1[k], options);
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                        _iterator2.return();
                    }
                } finally{
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
            else ret[key1] = $ca1bcf611781a0b5$var$parseValue(value1, options);
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce(function(result, key) {
        var value = ret[key];
        if (Boolean(value) && typeof value === "object" && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $ca1bcf611781a0b5$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$ca1bcf611781a0b5$export$f9380c9a627682d3 = $ca1bcf611781a0b5$var$extract;
$ca1bcf611781a0b5$export$98e6a39c04603d36 = $ca1bcf611781a0b5$var$parse;
$ca1bcf611781a0b5$export$fac44ee5b035f737 = function(object, options) {
    if (!object) return "";
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: "none",
        arrayFormatSeparator: ","
    }, options);
    $ca1bcf611781a0b5$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    var shouldFilter = function(key) {
        return options.skipNull && $ca1bcf611781a0b5$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === "";
    };
    var formatter = $ca1bcf611781a0b5$var$encoderForArrayFormat(options);
    var objectCopy = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.keys(object)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (!shouldFilter(key)) objectCopy[key] = object[key];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map(function(key) {
        var value = object[key];
        if (value === undefined) return "";
        if (value === null) return $ca1bcf611781a0b5$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === "bracket-separator") return $ca1bcf611781a0b5$var$encode(key, options) + "[]";
            return value.reduce(formatter(key), []).join("&");
        }
        return $ca1bcf611781a0b5$var$encode(key, options) + "=" + $ca1bcf611781a0b5$var$encode(value, options);
    }).filter(function(x) {
        return x.length > 0;
    }).join("&");
};
$ca1bcf611781a0b5$export$7a5253c0f62e0150 = function(url, options) {
    options = Object.assign({
        decode: true
    }, options);
    var _splitOnFirst = (0, $cv9Rk._)($ljZAm(url, "#"), 2), url_ = _splitOnFirst[0], hash = _splitOnFirst[1];
    return Object.assign({
        url: url_.split("?")[0] || "",
        query: $ca1bcf611781a0b5$var$parse($ca1bcf611781a0b5$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $ca1bcf611781a0b5$var$decode(hash, options)
    } : {});
};
$ca1bcf611781a0b5$export$a8c1621ea79325d3 = function(object, options) {
    options = Object.assign((0, $3sHb8._)({
        encode: true,
        strict: true
    }, $ca1bcf611781a0b5$var$encodeFragmentIdentifier, true), options);
    var url = $ca1bcf611781a0b5$var$removeHash(object.url).split("?")[0] || "";
    var queryFromUrl = $ca1bcf611781a0b5$export$f9380c9a627682d3(object.url);
    var parsedQueryFromUrl = $ca1bcf611781a0b5$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    var query = Object.assign(parsedQueryFromUrl, object.query);
    var queryString = $ca1bcf611781a0b5$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = "?".concat(queryString);
    var hash = $ca1bcf611781a0b5$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = "#".concat(options[$ca1bcf611781a0b5$var$encodeFragmentIdentifier] ? $ca1bcf611781a0b5$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier);
    return "".concat(url).concat(queryString).concat(hash);
};
$ca1bcf611781a0b5$export$357523c63a2253b9 = function(input, filter, options) {
    options = Object.assign((0, $3sHb8._)({
        parseFragmentIdentifier: true
    }, $ca1bcf611781a0b5$var$encodeFragmentIdentifier, false), options);
    var _exports_parseUrl = $ca1bcf611781a0b5$export$7a5253c0f62e0150(input, options), url = _exports_parseUrl.url, query = _exports_parseUrl.query, fragmentIdentifier = _exports_parseUrl.fragmentIdentifier;
    return $ca1bcf611781a0b5$export$a8c1621ea79325d3({
        url: url,
        query: $2Mx4x(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$ca1bcf611781a0b5$export$44c361b8ec72ef7f = function(input, filter, options) {
    var exclusionFilter = Array.isArray(filter) ? function(key) {
        return !filter.includes(key);
    } : function(key, value) {
        return !filter(key, value);
    };
    return $ca1bcf611781a0b5$export$357523c63a2253b9(input, exclusionFilter, options);
};

});
parcelRegister("6pUpV", function(module, exports) {
"use strict";
module.exports = function(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(x) {
        return "%".concat(x.charCodeAt(0).toString(16).toUpperCase());
    });
};

});

parcelRegister("zKeTC", function(module, exports) {

var $l0HdX = parcelRequire("l0HdX");
"use strict";
var $06b723271f58e700$var$token = "%[a-f0-9]{2}";
var $06b723271f58e700$var$singleMatcher = new RegExp("(" + $06b723271f58e700$var$token + ")|([^%]+?)", "gi");
var $06b723271f58e700$var$multiMatcher = new RegExp("(" + $06b723271f58e700$var$token + ")+", "gi");
function $06b723271f58e700$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(""))
        ];
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], $06b723271f58e700$var$decodeComponents(left), $06b723271f58e700$var$decodeComponents(right));
}
function $06b723271f58e700$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match($06b723271f58e700$var$singleMatcher) || [];
        for(var i = 1; i < tokens.length; i++){
            input = $06b723271f58e700$var$decodeComponents(tokens, i).join("");
            tokens = input.match($06b723271f58e700$var$singleMatcher) || [];
        }
        return input;
    }
}
function $06b723271f58e700$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        "%FE%FF": "\uFFFD\uFFFD",
        "%FF%FE": "\uFFFD\uFFFD"
    };
    var match = $06b723271f58e700$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = $06b723271f58e700$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $06b723271f58e700$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap["%C2"] = "\uFFFD";
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, "g"), replaceMap[key]);
    }
    return input;
}
module.exports = function(encodedURI) {
    if (typeof encodedURI !== "string") throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + (typeof encodedURI === "undefined" ? "undefined" : (0, $l0HdX._)(encodedURI)) + "`");
    try {
        encodedURI = encodedURI.replace(/\+/g, " ");
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return $06b723271f58e700$var$customDecodeURIComponent(encodedURI);
    }
};

});

parcelRegister("ljZAm", function(module, exports) {
"use strict";
module.exports = function(string, separator) {
    if (!(typeof string === "string" && typeof separator === "string")) throw new TypeError("Expected the arguments to be of type `string`");
    if (separator === "") return [
        string
    ];
    var separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};

});

parcelRegister("2Mx4x", function(module, exports) {
"use strict";
module.exports = function(obj, predicate) {
    var ret = {};
    var keys = Object.keys(obj);
    var isArr = Array.isArray(predicate);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var val = obj[key];
        if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) ret[key] = val;
    }
    return ret;
};

});




parcelRegister("jzYVM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e4108ccbf8871302$export$2e2bcd8739ae039; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $jjExS = parcelRequire("jjExS");

var $bi0wG = parcelRequire("bi0wG");
var $e4108ccbf8871302$var$SESSION_ID_STORAGE_KEY = "session.id";
var $e4108ccbf8871302$var$SESSION_EXPIRY_STORAGE_KEY = "session.expiry";
var $e4108ccbf8871302$var$ONLY_NUMBERS_REGEX = /^\d+$/;
var $e4108ccbf8871302$export$285f6bddd927a06d = 1800000; // 30 minutes
var $e4108ccbf8871302$export$a92e915d70316eb2 = 5000; // 5 seconds
var $e4108ccbf8871302$export$de43760b2dc10c19 = 0.9; // 90% of expiry
var $e4108ccbf8871302$export$5702a91a6f42969f = function() {};
var $e4108ccbf8871302$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function SessionTracking() {
        var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var _this = this;
        (0, $4GJKx._)(this, SessionTracking);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_generateNewSessionId", function() {
            var newSessionId = Date.now().toString();
            _this._safeLocalStorage.setItem($e4108ccbf8871302$var$SESSION_ID_STORAGE_KEY, newSessionId);
            // COMMENTS-123 - When a new session starts, call the callback if it is given
            _this._onNewSessionStarted && _this._onNewSessionStarted();
            return newSessionId;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_updateSessionExpiry", function() {
            var expiry = Date.now() + _this._sessionExpiryTime;
            _this._safeLocalStorage.setItem($e4108ccbf8871302$var$SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
            return expiry;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_debouncedUpdateSessionExpiry", function(currentExpiry) {
            var _updateSessionExpiry = _this._updateSessionExpiry;
            // If the current expiry is out of date by more than 10% of the expiry, update immediately
            if (currentExpiry < Date.now() + _this._sessionExpiryDebounceThresholdPercentage * _this._sessionExpiryTime) return _updateSessionExpiry();
            else {
                if (_this._sessionExpiryDebounceTimer) clearTimeout(_this._sessionExpiryDebounceTimer);
                // @ts-ignore Something wrong with our types... this is legit
                _this._sessionExpiryDebounceTimer = setTimeout(function() {
                    _updateSessionExpiry();
                }, _this._sessionExpiryDebounce);
            }
        });
        this._sessionExpiryTime = options.sessionExpiryTime || $e4108ccbf8871302$export$285f6bddd927a06d;
        this._sessionExpiryDebounce = options.sessionExpiryDebounce || $e4108ccbf8871302$export$a92e915d70316eb2;
        this._sessionExpiryDebounceThresholdPercentage = options.sessionExpiryDebounceThresholdPercentage || $e4108ccbf8871302$export$de43760b2dc10c19;
        this._onNewSessionStarted = options.onNewSessionStarted ? options.onNewSessionStarted : $e4108ccbf8871302$export$5702a91a6f42969f;
        this._safeLocalStorage = new (0, $bi0wG.default)();
    }
    (0, $1wc17._)(SessionTracking, [
        {
            key: "getCurrentSessionId",
            value: function getCurrentSessionId() {
                var sessionId = this._safeLocalStorage.getItem($e4108ccbf8871302$var$SESSION_ID_STORAGE_KEY);
                var sessionExpiry = parseInt(this._safeLocalStorage.getItem($e4108ccbf8871302$var$SESSION_EXPIRY_STORAGE_KEY) || "0", 10) || 0;
                this._debouncedUpdateSessionExpiry(sessionExpiry);
                if (!sessionId || sessionExpiry <= Date.now() || Number.isNaN(sessionExpiry)) return this._generateNewSessionId();
                // Old versions of sessionId were UUIDs which caused issues for Amplitude which only accepts
                // integers for this field. In these scenarios we want to regenerate the sessionId as an integer
                if (!$e4108ccbf8871302$var$ONLY_NUMBERS_REGEX.test(sessionId)) return this._generateNewSessionId();
                return sessionId;
            }
        }
    ]);
    return SessionTracking;
}();

});

parcelRegister("kTmBT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f35a7b96abdfaa29$export$2e2bcd8739ae039; });

var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $ohfOJ = parcelRequire("ohfOJ");

var $cuRVC = parcelRequire("cuRVC");

var $6fntO = parcelRequire("6fntO");
var $f35a7b96abdfaa29$export$2e2bcd8739ae039 = /*#__PURE__*/ function(SafeStorage) {
    "use strict";
    (0, $dcsZi._)(_class, SafeStorage);
    var _super = (0, $ohfOJ._)(_class);
    function _class(options) {
        (0, $4GJKx._)(this, _class);
        var storageToUse;
        try {
            storageToUse = window.sessionStorage || (0, $cuRVC.default);
        } catch (err) {
            storageToUse = (0, $cuRVC.default);
        }
        return _super.call(this, storageToUse, options);
    }
    return _class;
}((0, $6fntO.default));

});

parcelRegister("f6Y6c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b00608f1176bf709$export$2e2bcd8739ae039; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $jjExS = parcelRequire("jjExS");

var $ktzPa = parcelRequire("ktzPa");

var $kTmBT = parcelRequire("kTmBT");
var $b00608f1176bf709$var$STORAGE_KEY = "tab.id";
var $b00608f1176bf709$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function TabTracking() {
        var _this = this;
        (0, $4GJKx._)(this, TabTracking);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_generateNewTabId", function() {
            var newTabId = (0, (/*@__PURE__*/$parcel$interopDefault($ktzPa)))();
            _this._safeSessionStorage.setItem($b00608f1176bf709$var$STORAGE_KEY, newTabId);
            return newTabId;
        });
        this._safeSessionStorage = new (0, $kTmBT.default)();
    }
    (0, $1wc17._)(TabTracking, [
        {
            key: "getCurrentTabId",
            value: function getCurrentTabId() {
                var tabId = this._safeSessionStorage.getItem($b00608f1176bf709$var$STORAGE_KEY);
                if (!tabId) tabId = this._generateNewTabId();
                return tabId;
            }
        }
    ]);
    return TabTracking;
}();

});

parcelRegister("1kGnl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f888792aac1cc2f$export$2e2bcd8739ae039; });

var $4GJKx = parcelRequire("4GJKx");

var $jjExS = parcelRequire("jjExS");

var $hlOOc = parcelRequire("hlOOc");

var $ktzPa = parcelRequire("ktzPa");

var $22Iz2 = parcelRequire("22Iz2");

var $9kC89 = parcelRequire("9kC89");

var $kTmBT = parcelRequire("kTmBT");

var $gnvfh = parcelRequire("gnvfh");
function $0f888792aac1cc2f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0f888792aac1cc2f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0f888792aac1cc2f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0f888792aac1cc2f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0f888792aac1cc2f$var$STORAGE_KEY = "taskSessions";
var $0f888792aac1cc2f$var$INIT_KEY = "taskSessionsInit";
var $0f888792aac1cc2f$var$AWC_PARAM_PREFIX = "awc.";
var $0f888792aac1cc2f$var$TASK_SESSION_RELOAD_TIME = 3000;
var $0f888792aac1cc2f$export$2e2bcd8739ae039 = function TaskSessionStore() {
    "use strict";
    var _this = this;
    (0, $4GJKx._)(this, TaskSessionStore);
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_taskSessionsNotRecentlyInitialised", function(currentTimestamp) {
        return _this._safeSessionStorage.getItem($0f888792aac1cc2f$var$STORAGE_KEY) === null || _this._safeSessionStorage.getItem($0f888792aac1cc2f$var$INIT_KEY) === null || parseInt(_this._safeSessionStorage.getItem($0f888792aac1cc2f$var$INIT_KEY) || "0", 10) < currentTimestamp - $0f888792aac1cc2f$var$TASK_SESSION_RELOAD_TIME;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_removeTaskSessionPrefix", function(_, taskSessionName) {
        return taskSessionName.split($0f888792aac1cc2f$var$AWC_PARAM_PREFIX)[1];
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_isTaskSessionQueryParam", function(_, taskSessionName) {
        return taskSessionName.startsWith($0f888792aac1cc2f$var$AWC_PARAM_PREFIX);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "getAllTaskSessions", function() {
        try {
            return JSON.parse(_this._safeSessionStorage.getItem($0f888792aac1cc2f$var$STORAGE_KEY) || "");
        } catch (e) {
            return {};
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_writeToSessionStorage", function(taskSessions) {
        try {
            _this._safeSessionStorage.setItem($0f888792aac1cc2f$var$STORAGE_KEY, JSON.stringify(taskSessions));
        // eslint-disable-next-line no-empty
        } catch (e) {}
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_appendTaskSessions", function(newTaskSessions) {
        var currentState = _this.getAllTaskSessions();
        var newState = currentState === null ? newTaskSessions : Object.assign(currentState, newTaskSessions);
        _this._writeToSessionStorage(newState);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_safelyRemoveKey", function(currentState, taskSessionName) {
        if (currentState === null) return {};
        delete currentState[taskSessionName];
        return currentState;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "createTaskSession", function(taskSessionName) {
        var taskSessionId = (0, (/*@__PURE__*/$parcel$interopDefault($ktzPa)))();
        var newTaskSessions = {};
        newTaskSessions[taskSessionName] = taskSessionId;
        _this._appendTaskSessions(newTaskSessions);
        return taskSessionId;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "createTaskSessionWithProvidedId", function(taskSessionName, taskSessionId) {
        if (typeof taskSessionId !== "string") throw new TypeError("invalid taskSessionId, must be string");
        var newTaskSessions = {};
        newTaskSessions[taskSessionName] = taskSessionId;
        _this._appendTaskSessions(newTaskSessions);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "completeTaskSession", function(taskSessionName) {
        var currentState = _this.getAllTaskSessions();
        var updatedState = _this._safelyRemoveKey(currentState, taskSessionName);
        _this._writeToSessionStorage(updatedState);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "formatTaskSessionQueryString", function(param) {
        var uri = param.uri, includedTaskSessions = param.includedTaskSessions;
        var _parseUrl = (0, $hlOOc.parseUrl)(uri), url = _parseUrl.url, query = _parseUrl.query;
        var currentState = _this.getAllTaskSessions();
        // Use specified task sessions, otherwise all tasksessions excluding originTracing sessions
        var filteredTaskSessions = includedTaskSessions ? (0, $9kC89.pick)(currentState, includedTaskSessions) : (0, $9kC89.omit)(currentState, Object.values((0, $22Iz2.originTracingType)));
        if (Object.keys(filteredTaskSessions).length === 0) return uri;
        var queryWithTaskSessions = $0f888792aac1cc2f$var$_objectSpread($0f888792aac1cc2f$var$_objectSpread({}, (0, $9kC89.mapKeys)(filteredTaskSessions, function(_, taskSessionName) {
            return $0f888792aac1cc2f$var$AWC_PARAM_PREFIX + taskSessionName;
        })), query);
        return "".concat(url, "?").concat((0, $hlOOc.stringify)(queryWithTaskSessions));
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "stripQueryParameters", function() {
        var extractedTaskSessions = (0, $9kC89.mapKeys)((0, $gnvfh.default)(_this._isTaskSessionQueryParam), _this._removeTaskSessionPrefix);
        _this._appendTaskSessions(extractedTaskSessions);
    });
    var _currentTimestamp = Date.now();
    this._safeSessionStorage = new (0, $kTmBT.default)();
    // Wrapping all sessionStorage calls in try catch to stop any error propogation, taskSessions should gracefully fail.
    try {
        if (this._taskSessionsNotRecentlyInitialised(_currentTimestamp)) {
            this._writeToSessionStorage({});
            this._safeSessionStorage.setItem($0f888792aac1cc2f$var$INIT_KEY, _currentTimestamp.toString());
        }
    // eslint-disable-next-line no-empty
    } catch (e) {}
};

});

parcelRegister("6f3e8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48b6a59e4cdd697f$export$2e2bcd8739ae039; });

var $4GJKx = parcelRequire("4GJKx");

var $jjExS = parcelRequire("jjExS");

var $jd4wD = parcelRequire("jd4wD");
var $48b6a59e4cdd697f$var$MAX_CACHE_SIZE = 100;
var $48b6a59e4cdd697f$var$COOKIE_NAME = "atlassian_analytics_debug";
var $48b6a59e4cdd697f$var$DEBUG_TAG = "synthetic";
var $48b6a59e4cdd697f$var$getDebugCookie = function() {
    try {
        return JSON.parse((0, (/*@__PURE__*/$parcel$interopDefault($jd4wD))).get($48b6a59e4cdd697f$var$COOKIE_NAME) || "false");
    } catch (error) {
        (0, (/*@__PURE__*/$parcel$interopDefault($jd4wD))).remove($48b6a59e4cdd697f$var$COOKIE_NAME);
    }
    return false;
};
var $48b6a59e4cdd697f$var$TestingCache = function TestingCache() {
    "use strict";
    var _this = this;
    (0, $4GJKx._)(this, TestingCache);
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_bind", function() {
        if (window.testAnalytics) return;
        window.testAnalytics = {
            eventCache: [],
            events: function() {
                return window.testAnalytics.eventCache;
            },
            clear: function() {
                window.testAnalytics.eventCache = [];
                try {
                    localStorage.removeItem("awc.ui.viewed.last.sent");
                    localStorage.removeItem("awc-staging.ui.viewed.last.sent");
                    localStorage.removeItem("awc-dev.ui.viewed.last.sent");
                    localStorage.removeItem("awc-local.ui.viewed.last.sent");
                } catch (_error) {
                // Ignore errors from localStorage.
                }
            }
        };
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_cache", function(event) {
        if (window.testAnalytics.eventCache.length >= $48b6a59e4cdd697f$var$MAX_CACHE_SIZE) window.testAnalytics.eventCache = window.testAnalytics.eventCache.slice(1, window.testAnalytics.eventCache.length);
        window.testAnalytics.eventCache.push(event);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_shouldCacheEvent", function() {
        return _this._isDebugCookieEnabled;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "saveEvent", function(event) {
        if (event && _this._shouldCacheEvent()) {
            if (!window.testAnalytics) _this._bind();
            if (event.tags instanceof Array) event.tags.push($48b6a59e4cdd697f$var$DEBUG_TAG);
            else event.tags = [
                $48b6a59e4cdd697f$var$DEBUG_TAG
            ];
            _this._cache(event);
        }
    });
    this._isDebugCookieEnabled = $48b6a59e4cdd697f$var$getDebugCookie();
    if (this._isDebugCookieEnabled) this._bind();
};
var $48b6a59e4cdd697f$export$2e2bcd8739ae039 = $48b6a59e4cdd697f$var$TestingCache;

});

parcelRegister("bJ204", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $889572dbea124ca2$export$2e2bcd8739ae039; });

var $4GJKx = parcelRequire("4GJKx");

var $04Kcc = parcelRequire("04Kcc");

var $jjExS = parcelRequire("jjExS");

var $22Iz2 = parcelRequire("22Iz2");

var $bi0wG = parcelRequire("bi0wG");
var $889572dbea124ca2$var$_excluded = [
    "embeddedProduct"
];
function $889572dbea124ca2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $889572dbea124ca2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $889572dbea124ca2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $889572dbea124ca2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $889572dbea124ca2$var$DEFAULT_DELAY = 2000; // 2 seconds
var $889572dbea124ca2$var$DEFAULT_THROTTLE = 3600000; // 1 hour
var $889572dbea124ca2$var$DEFAULT_STORAGE_KEY = "ui.viewed.last.sent";
var $889572dbea124ca2$export$2e2bcd8739ae039 = function UIViewedEvent(productInfo, getContext, onEvent) {
    "use strict";
    var settings = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var _this = this;
    (0, $4GJKx._)(this, UIViewedEvent);
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "start", function() {
        _this._startInterval();
        _this._bindEventListeners();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "stop", function() {
        _this._stopInterval();
        _this._unbindEventListeners();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "resetTimers", function() {
        if (_this._intervalId) {
            _this.stop();
            _this.start();
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_bindEventListeners", function() {
        window.addEventListener("focus", _this._focusListener);
        window.addEventListener("blur", _this._blurListener);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_unbindEventListeners", function() {
        window.removeEventListener("focus", _this._focusListener);
        window.removeEventListener("blur", _this._blurListener);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_startInterval", function() {
        clearInterval(_this._intervalId);
        _this._intervalId = setInterval(_this._handleInterval, _this._delay);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_stopInterval", function() {
        if (_this._intervalId) {
            clearInterval(_this._intervalId);
            _this._intervalId = null;
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_getProductKey", function(product, subproduct) {
        var productKey = product;
        if (subproduct) productKey += "-".concat(subproduct);
        return productKey;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_getLastSentTimestamp", function(productKey, tenantId, userId) {
        var json = _this._parseLocalStorageData() || {};
        var u = json[userId] || {};
        var t = u[tenantId] || {};
        var p = t[productKey] || null;
        return p;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_parseLocalStorageData", function() {
        var data = _this._safeLocalStorage.getItem(_this._storageKey);
        try {
            return JSON.parse(data || "");
        } catch (error) {
            _this._safeLocalStorage.removeItem(_this._storageKey);
            return null;
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_setLastSentTimestamp", function(productKey, tenantId, userId) {
        var json = _this._parseLocalStorageData() || {};
        var u = json[userId] || {};
        var t = u[tenantId] || {};
        t[productKey] = Date.now();
        u[tenantId] = t;
        json[userId] = u;
        _this._safeLocalStorage.setItem(_this._storageKey, JSON.stringify(json));
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_shouldSendEvent", function(productKey, tenantIdType, tenantId, userId) {
        if (!document.hasFocus()) return false;
        if (tenantIdType !== (0, $22Iz2.tenantType).NONE && !tenantId || !userId) return false;
        var sinceLastSent = Date.now() - _this._getLastSentTimestamp(productKey, tenantId, userId);
        return sinceLastSent > _this._throttle;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_handleInterval", function() {
        var _this$_getContext = _this._getContext(), embeddedProduct = _this$_getContext.embeddedProduct, context = (0, (/*@__PURE__*/$parcel$interopDefault($04Kcc)))(_this$_getContext, $889572dbea124ca2$var$_excluded);
        _this._sendEvent(_this._product, context);
        if (embeddedProduct) _this._sendEvent(embeddedProduct, context, true);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_sendEvent", function(product, context) {
        var isEmbeddedProduct = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        var subproduct = context.subproduct, tenantIdType = context.tenantIdType, tenantId = context.tenantId, userId = context.userId, lastScreenEvent = context.lastScreenEvent, attributes = context.attributes;
        var productKey = _this._getProductKey(product, subproduct);
        if (_this._shouldSendEvent(productKey, tenantIdType, tenantId, userId)) {
            _this._setLastSentTimestamp(productKey, tenantId, userId);
            var event = _this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes);
            _this._onEvent(event);
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_createEvent", function(product, subproduct, isEmbeddedProduct, lastScreenEvent, extraAttributes) {
        var event = {
            product: product,
            source: "ui",
            action: "viewed",
            actionSubject: "ui",
            attributes: extraAttributes
        };
        if (isEmbeddedProduct) {
            // Clear the subproduct and version as they don't relate to the embedded product
            event.subproduct = null;
            event.version = null;
            event.attributes = $889572dbea124ca2$var$_objectSpread($889572dbea124ca2$var$_objectSpread({}, event.attributes), {}, {
                embeddedInEnv: _this._productInfo.env,
                embeddedInProduct: _this._productInfo.product,
                embeddedInSubproduct: subproduct,
                embeddedInVersion: _this._productInfo.version,
                embeddedInOrigin: _this._productInfo.origin,
                embeddedInPlatform: _this._productInfo.platform
            });
        }
        if (lastScreenEvent) event.attributes = $889572dbea124ca2$var$_objectSpread($889572dbea124ca2$var$_objectSpread({}, event.attributes), {}, {
            lastScreenEvent: {
                name: lastScreenEvent.name,
                attributes: lastScreenEvent.attributes
            }
        });
        return event;
    });
    if (!productInfo) throw new Error("Missing productInfo");
    if (!productInfo.product) throw new Error("Missing productInfo.product");
    if (!getContext) throw new Error("Missing getContext callback");
    if (typeof getContext !== "function") throw new Error("Invalid getContext, must be function");
    if (!onEvent) throw new Error("Missing onEvent callback");
    if (typeof onEvent !== "function") throw new Error("Invalid onEvent, must be function");
    this._productInfo = productInfo;
    this._product = productInfo.product;
    this._getContext = getContext;
    this._onEvent = onEvent;
    this._delay = settings.delay || $889572dbea124ca2$var$DEFAULT_DELAY;
    this._throttle = settings.throttle || $889572dbea124ca2$var$DEFAULT_THROTTLE;
    this._storageKey = settings.storageKey || $889572dbea124ca2$var$DEFAULT_STORAGE_KEY;
    this._safeLocalStorage = new (0, $bi0wG.default)({
        envPrefix: this._productInfo.env
    });
    this._focusListener = function() {
        _this._startInterval();
    };
    this._blurListener = function() {
        _this._stopInterval();
    };
};

});

parcelRegister("5LQZZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $433a7401582f41b5$export$2e2bcd8739ae039; });
function $433a7401582f41b5$export$2e2bcd8739ae039(callback, event) {
    if (!callback || typeof callback !== "function") return null;
    return function() {
        callback(event);
    };
}

});

parcelRegister("29bQh", function(module, exports) {

$parcel$export(module.exports, "XIDPromise", function () { return $19059bae2a00d13f$export$fbe53bbbe682bcdd; });

var $5bFr4 = parcelRequire("5bFr4");
var $19059bae2a00d13f$export$fbe53bbbe682bcdd = function(xidConsent, xidPromiseFn) {
    if (xidConsent && xidPromiseFn && typeof xidPromiseFn === "function") {
        var timeoutPromise = function() {
            return new Promise(function(resolve) {
                setTimeout(function() {
                    return resolve(function() {
                        return (0, $5bFr4.createTimeoutXid)();
                    });
                }, (0, $5bFr4.XID_TIMEOUT));
            });
        };
        var xidPromise = function() {
            return xidPromiseFn().catch(function() {
                return function() {
                    return (0, $5bFr4.createUnknownXid)();
                };
            });
        };
        return Promise.race([
            xidPromise(),
            timeoutPromise()
        ]);
    }
    return undefined;
};

});
parcelRegister("5bFr4", function(module, exports) {

$parcel$export(module.exports, "XID_TIMEOUT", function () { return $3c6e1f12ca380016$export$545bcbd53afabfa3; });
$parcel$export(module.exports, "createTimeoutXid", function () { return $3c6e1f12ca380016$export$af4087e36d63846; });
$parcel$export(module.exports, "createUnknownXid", function () { return $3c6e1f12ca380016$export$fa341d0c750d705b; });

var $8uyVA = parcelRequire("8uyVA");
var $3c6e1f12ca380016$export$545bcbd53afabfa3 = 5000;
var $3c6e1f12ca380016$export$af4087e36d63846 = function() {
    return [
        {
            type: (0, $8uyVA.XIDItemType).XC,
            state: "TIMEOUT"
        },
        {
            type: (0, $8uyVA.XIDItemType).UID,
            state: "TIMEOUT"
        }
    ];
};
var $3c6e1f12ca380016$export$fa341d0c750d705b = function() {
    return [
        {
            type: (0, $8uyVA.XIDItemType).XC,
            state: "UNKNOWN"
        },
        {
            type: (0, $8uyVA.XIDItemType).UID,
            state: "UNKNOWN"
        }
    ];
};

});
parcelRegister("8uyVA", function(module, exports) {

$parcel$export(module.exports, "XIDItemType", function () { return $62ec38028996f397$export$92ca0438bcb0d396; });
var $62ec38028996f397$export$92ca0438bcb0d396 = /*#__PURE__*/ function(XIDItemType) {
    XIDItemType["XC"] = "xc";
    XIDItemType["UID"] = "uid";
    return XIDItemType;
}({});
var $62ec38028996f397$export$c9079017d1f5aab9 = /*#__PURE__*/ function(XIDState) {
    XIDState["NEW"] = "NEW";
    XIDState["CHANGED"] = "CHANGED";
    XIDState["EXISTING"] = "EXISTING";
    XIDState["TIMEOUT"] = "TIMEOUT";
    XIDState["ERROR"] = "ERROR";
    XIDState["UNAVAILABLE"] = "UNAVAILABLE";
    XIDState["MALFORMED"] = "MALFORMED";
    XIDState["UNKNOWN"] = "UNKNOWN";
    return XIDState;
}({});

});







parcelRegister("jNNT0", function(module, exports) {

$parcel$export(module.exports, "InitUFO", function () { return $d9c78567a523d2ac$export$be19e87be63a52cc; });

var $3sHb8 = parcelRequire("3sHb8");

var $1Mpn7 = parcelRequire("1Mpn7");

var $6rNRl = parcelRequire("6rNRl");
var $b1tXY = parcelRequire("b1tXY");
var $7Mc3g = parcelRequire("7Mc3g");

var $5pHLF = parcelRequire("5pHLF");
var $d9c78567a523d2ac$export$be19e87be63a52cc = /*#__PURE__*/ (0, $1Mpn7.memo)(function() {
    (0, $5pHLF.getAnalyticsWebClientPromise)().then(function(client) {
        var _obj;
        (0, $b1tXY.payloadPublisher).setup({
            featureFlagClient: {
                getValue: function() {
                    return true;
                }
            },
            product: "marketing",
            gasv3: client.getInstance(),
            app: {
                version: {
                    web: "1.0.0"
                },
                framework: {
                    name: "react",
                    version: (0, $1Mpn7.version)
                }
            },
            tenantType: (0, $7Mc3g.TenantType).RealUser,
            resourceTimings: {
                mapResources: function(url) {
                    return url;
                },
                sanitiseEndpoints: function(url) {
                    return url;
                }
            },
            performanceConfig: {
                histogram: (_obj = {}, (0, $3sHb8._)(_obj, (0, $6rNRl.ExperiencePerformanceTypes).PageLoad, {
                    initial: {
                        fmp: "1000_2000_3000_4000",
                        tti: "1000_2000_3000_4000"
                    },
                    transition: {
                        fmp: "1000_2000",
                        tti: "1000_2000"
                    }
                }), (0, $3sHb8._)(_obj, (0, $6rNRl.ExperiencePerformanceTypes).PageSegmentLoad, {
                    initial: {
                        fmp: "1000_2000",
                        tti: "1000_2000"
                    },
                    transition: {
                        fmp: "1000_2000",
                        tti: "1000_2000"
                    }
                }), (0, $3sHb8._)(_obj, (0, $6rNRl.ExperiencePerformanceTypes).InlineResult, {
                    result: "1000_2000",
                    response: "1000_2000"
                }), (0, $3sHb8._)(_obj, (0, $6rNRl.ExperiencePerformanceTypes).Custom, {
                    duration: "1000_2000"
                }), _obj)
            }
        });
    });
    return null;
});

});
parcelRegister("6rNRl", function(module, exports) {

$parcel$export(module.exports, "ExperienceTypes", function () { return $4b1bf0bf2623f158$export$994164cf3ae1cc9a; });
$parcel$export(module.exports, "ExperiencePerformanceTypes", function () { return $4b1bf0bf2623f158$export$cc26007c03242fff; });
var $4b1bf0bf2623f158$export$994164cf3ae1cc9a;
(function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
})($4b1bf0bf2623f158$export$994164cf3ae1cc9a || ($4b1bf0bf2623f158$export$994164cf3ae1cc9a = {}));
var $4b1bf0bf2623f158$export$cc26007c03242fff;
(function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
})($4b1bf0bf2623f158$export$cc26007c03242fff || ($4b1bf0bf2623f158$export$cc26007c03242fff = {}));

});

parcelRegister("b1tXY", function(module, exports) {

$parcel$export(module.exports, "payloadPublisher", function () { return $80670869a1028193$export$edb879ae55bb9be3; });

var $e6gyJ = parcelRequire("e6gyJ");

var $2nffd = parcelRequire("2nffd");

var $6QU8A = parcelRequire("6QU8A");

var $2Yk1N = parcelRequire("2Yk1N");

var $jjExS = parcelRequire("jjExS");

var $6rNRl = parcelRequire("6rNRl");
var $caMCf = parcelRequire("caMCf");

var $b8eZI = parcelRequire("b8eZI");

var $iWydU = parcelRequire("iWydU");

var $fc108 = parcelRequire("fc108");

var $1RyTU = parcelRequire("1RyTU");

var $7Mc3g = parcelRequire("7Mc3g");

var $i2xIP = parcelRequire("i2xIP");

var $eCL5B = parcelRequire("eCL5B");

var $lzRGz = parcelRequire("lzRGz");

var $4t1Q2 = parcelRequire("4t1Q2");

var $67kNC = parcelRequire("67kNC");

var $jAELz = parcelRequire("jAELz");

var $kdD4O = parcelRequire("kdD4O");

var $eLBqm = parcelRequire("eLBqm");

var $4mwmu = parcelRequire("4mwmu");

var $bdAw1 = parcelRequire("bdAw1");

var $OrkUx = parcelRequire("OrkUx");

var $64z5l = parcelRequire("64z5l");

var $bVsra = parcelRequire("bVsra");

var $6aU48 = parcelRequire("6aU48");

var $dYjKm = parcelRequire("dYjKm");

var $7rOQc = parcelRequire("7rOQc");
function $80670869a1028193$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $80670869a1028193$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $80670869a1028193$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $80670869a1028193$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $80670869a1028193$var$UNKNOWN_VALUE = "unknown";
var $80670869a1028193$var$DEFAULT_PAYLOAD_DATA = {
    schemaVersion: $80670869a1028193$var$UNKNOWN_VALUE,
    id: $80670869a1028193$var$UNKNOWN_VALUE,
    uuid: $80670869a1028193$var$UNKNOWN_VALUE,
    state: {
        id: $80670869a1028193$var$UNKNOWN_VALUE
    },
    result: {
        startTime: 0,
        duration: 0,
        success: false
    },
    type: (0, $6rNRl.ExperienceTypes).Experience,
    category: $80670869a1028193$var$UNKNOWN_VALUE,
    performanceType: (0, $6rNRl.ExperiencePerformanceTypes).Custom,
    metadata: {},
    explicitTimings: {},
    metrics: {
        startTime: 0,
        endTime: 0,
        marks: []
    },
    platform: null,
    children: [],
    pageVisibleState: (0, $fc108.PageVisibleState).MIXED,
    isSSROutputAsFMP: false,
    timings: [],
    featureFlags: []
};
var $80670869a1028193$var$Publisher = /*#__PURE__*/ function() {
    function Publisher() {
        var _getWindowObject, _getWindowObject$loca, _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($6QU8A)))(this, Publisher);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "gasv3", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "product", "");
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "region", $80670869a1028193$var$UNKNOWN_VALUE);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "hostname", ((_getWindowObject = (0, $7rOQc.getWindowObject)()) === null || _getWindowObject === void 0 ? void 0 : (_getWindowObject$loca = _getWindowObject.location) === null || _getWindowObject$loca === void 0 ? void 0 : _getWindowObject$loca.hostname) || "");
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "tenantType", (0, $7Mc3g.TenantType).RealUser);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "app", {
            version: {
                web: $80670869a1028193$var$UNKNOWN_VALUE
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "performanceConfig", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "buffer", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "featureFlagClient", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "featureFlags", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "ssr", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "resourceTimings", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "bundleEvalTimings", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "route", (0, $6aU48.Route));
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "plugins", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "allowlist", function() {
            return true;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "getPluginsMetrics", function(data) {
            var result = {};
            if (_this.plugins) _this.plugins.forEach(function(plugin) {
                var pluginOutput = plugin($80670869a1028193$var$_objectSpread({}, data));
                if (pluginOutput === null || (0, (/*@__PURE__*/$parcel$interopDefault($2nffd)))(pluginOutput) !== "object") return;
                Object.entries(pluginOutput).forEach(function(_ref) {
                    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($e6gyJ)))(_ref, 2), key = _ref2[0], value = _ref2[1];
                    result["".concat(_this.product, ":").concat(key)] = value;
                });
            });
            return result;
        });
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($2Yk1N)))(Publisher, [
        {
            key: "publish",
            value: function publish(data) {
                var _getPerformanceObject, _getPerformanceObject2;
                var payloadStart = ((_getPerformanceObject = (0, $7rOQc.getPerformanceObject)()) === null || _getPerformanceObject === void 0 ? void 0 : _getPerformanceObject.now()) || 0;
                var experienceKey = this.getExperienceKey(data);
                if (!this.allowlist(experienceKey, data)) {
                    (0, $iWydU.ufowarn)("experience ".concat(experienceKey, " does not meet requirements of allowlist"));
                    return;
                } // it is used to setup default properties on the data to prevent errors
                var supportedData = $80670869a1028193$var$_objectSpread($80670869a1028193$var$_objectSpread({}, $80670869a1028193$var$DEFAULT_PAYLOAD_DATA), data);
                var payload = {
                    actionSubject: "experience",
                    action: "measured",
                    source: "measured",
                    tags: [
                        "observability"
                    ],
                    attributes: {
                        properties: $80670869a1028193$var$_objectSpread($80670869a1028193$var$_objectSpread($80670869a1028193$var$_objectSpread($80670869a1028193$var$_objectSpread($80670869a1028193$var$_objectSpread($80670869a1028193$var$_objectSpread($80670869a1028193$var$_objectSpread($80670869a1028193$var$_objectSpread($80670869a1028193$var$_objectSpread($80670869a1028193$var$_objectSpread($80670869a1028193$var$_objectSpread($80670869a1028193$var$_objectSpread($80670869a1028193$var$_objectSpread($80670869a1028193$var$_objectSpread($80670869a1028193$var$_objectSpread({
                            "event:source": {
                                name: "ufo/web",
                                version: supportedData.schemaVersion
                            },
                            "event:schema": (0, $1RyTU.UFO_BUILD_VERSION) || $80670869a1028193$var$UNKNOWN_VALUE,
                            "event:product": this.product,
                            "event:region": this.region,
                            "event:hostname": this.hostname,
                            "event:route": this.route.getRoute()
                        }, (0, $kdD4O.eventBrowserPlugin)()), (0, $eLBqm.eventCpusPlugin)()), (0, $bdAw1.eventMemoryPlugin)()), (0, $OrkUx.eventNetworkPlugin)()), (0, $67kNC.appFramework)(this.app)), (0, $jAELz.appVersion)(this.app)), {}, {
                            "experience:name": supportedData.id,
                            // platform.fe.page-load|interaction|custom|page-segment.editor
                            "experience:key": experienceKey,
                            "experience:status": supportedData.state.id,
                            "experience:duration": supportedData.result.duration
                        }, supportedData.result.startTime !== null ? {
                            "experience:startTime": supportedData.result.startTime
                        } : null), supportedData.uuid ? {
                            "experience:spanId": supportedData.uuid
                        } : null), this.tenantType !== (0, $7Mc3g.TenantType).RealUser ? {
                            "event:tenantType": this.tenantType
                        } : null), this.mapMetadataToPayload(supportedData.metadata)), this.extractPageLoadData(supportedData)), (0, $lzRGz.pageVisibleState)(supportedData)), (0, $dYjKm.isInitialPageLoad)(supportedData) && (0, $bVsra.ssrSuccess)(this.ssr)), (0, $dYjKm.isInitialPageLoad)(supportedData) && (0, $64z5l.ssrFeatureFlags)(this.ssr)), this.featureFlagClient && (0, $4mwmu.featureFlags)(this.featureFlagClient, this.featureFlags, supportedData)),
                        performance: this.getPerformanceMetrics(supportedData),
                        task: supportedData.id
                    }
                };
                var payloadEnd = ((_getPerformanceObject2 = (0, $7rOQc.getPerformanceObject)()) === null || _getPerformanceObject2 === void 0 ? void 0 : _getPerformanceObject2.now()) || 0;
                payload.attributes.performance.payloadTime = payloadEnd - payloadStart;
                if (this.gasv3) this.gasv3.sendOperationalEvent(payload);
                else this.buffer.push(payload);
                (0, $iWydU.ufolog)("PAYLOAD:", JSON.stringify(payload, null, 2));
            }
        },
        {
            key: "setGlobalEventStream",
            value: function setGlobalEventStream() {
                if (!((0, $b8eZI.getGlobalEventStream)() instanceof (0, $i2xIP.UFOGlobalEventStream))) {
                    var eventStream = new (0, $i2xIP.UFOGlobalEventStream)();
                    eventStream.push({
                        type: (0, $fc108.UFOGlobalEventStreamEventType).SUBSCRIBE,
                        payload: {
                            experienceId: "__SUBSCRIBE_ALL__",
                            callback: this.publish.bind(this)
                        }
                    });
                    (0, $b8eZI.setGlobalEventStream)(eventStream);
                }
            }
        },
        {
            key: "setRoute",
            value: function setRoute(newRoute) {
                this.route.setRoute(newRoute);
            }
        },
        {
            key: "setup",
            value: function setup(config) {
                (0, $caMCf.visibilityChangeObserver).start();
                (0, $4t1Q2.resourceTimingBuffer).start();
                if (!this.product) this.product = config.product || "";
                if (config.allowlist) this.allowlist = config.allowlist;
                if (config.tenantType) this.tenantType = config.tenantType;
                if (config.hostname) this.hostname = config.hostname;
                if (config.region) this.region = config.region;
                if (config.app) this.app = config.app;
                if (config.featureFlagClient) this.featureFlagClient = config.featureFlagClient;
                if (config.featureFlags) this.featureFlags = config.featureFlags;
                if (config.ssr) this.ssr = config.ssr;
                if (config.bundleEvalTimings) this.bundleEvalTimings = config.bundleEvalTimings;
                if (config.resourceTimings) this.resourceTimings = config.resourceTimings;
                if (config.performanceConfig) this.performanceConfig = config.performanceConfig;
                if (config.plugins) this.plugins = config.plugins;
                this.setGlobalEventStream();
                if (!this.gasv3) {
                    this.gasv3 = config.gasv3;
                    this.buffer.forEach(this.gasv3.sendOperationalEvent);
                }
            }
        },
        {
            key: "mapMetadataToPayload",
            value: function mapMetadataToPayload(metadata) {
                var payload = {};
                Object.entries(metadata).forEach(function(_ref3) {
                    var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($e6gyJ)))(_ref3, 2), key = _ref4[0], value = _ref4[1];
                    if (value !== undefined) payload["custom:".concat(key)] = value;
                });
                return payload;
            }
        },
        {
            key: "extractPageLoadData",
            value: function extractPageLoadData(data) {
                if ("initial" in data) return {
                    "experience:pageLoadType": data.initial ? "initial" : "transition"
                };
                return {};
            }
        },
        {
            key: "getPrefix",
            value: function getPrefix(data) {
                if (data.platform !== null) return "platform";
                return this.product;
            }
        },
        {
            key: "getExperienceKey",
            value: function getExperienceKey(data) {
                var keyParts = [
                    this.getPrefix(data),
                    "fe",
                    data.type
                ];
                if (data.platform) keyParts.push(data.platform.component);
                keyParts.push(data.id);
                return keyParts.join(".");
            }
        },
        {
            key: "getExperiencePerformanceKey",
            value: function getExperiencePerformanceKey(data) {
                var keyParts = [
                    this.getPrefix(data),
                    "fe",
                    data.performanceType
                ];
                if (data.platform) keyParts.push(data.platform.component);
                keyParts.push(data.id);
                return keyParts.join(".");
            }
        },
        {
            key: "getExperiencePerformanceType",
            value: function getExperiencePerformanceType(data) {
                return data.performanceType;
            }
        },
        {
            key: "getPerformanceMetrics",
            value: function getPerformanceMetrics(data) {
                return $80670869a1028193$var$_objectSpread($80670869a1028193$var$_objectSpread({
                    "event:key": this.getExperiencePerformanceKey(data),
                    "event:type": this.getExperiencePerformanceType(data)
                }, (0, $eCL5B.getPerformancePayload)(data, this.ssr, this.bundleEvalTimings, this.resourceTimings, this.performanceConfig)), this.getPluginsMetrics(data));
            }
        }
    ]);
    return Publisher;
}();
var $80670869a1028193$export$edb879ae55bb9be3 = new $80670869a1028193$var$Publisher();

});
parcelRegister("e6gyJ", function(module, exports) {

var $49CSN = parcelRequire("49CSN");

var $3L1YK = parcelRequire("3L1YK");

var $3JoOw = parcelRequire("3JoOw");

var $kq0FN = parcelRequire("kq0FN");
function $a43e788f86ca0cfc$var$_slicedToArray(arr, i) {
    return $49CSN(arr) || $3L1YK(arr, i) || $3JoOw(arr, i) || $kq0FN();
}
module.exports = $a43e788f86ca0cfc$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("49CSN", function(module, exports) {
function $30662a0519878d8a$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
module.exports = $30662a0519878d8a$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("3L1YK", function(module, exports) {
function $2bc74bd53b5bb5f6$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $2bc74bd53b5bb5f6$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("kq0FN", function(module, exports) {
function $edd6c200d75f51e1$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $edd6c200d75f51e1$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("caMCf", function(module, exports) {

$parcel$export(module.exports, "visibilityChangeObserver", function () { return $8dcc21522e64c2e9$export$13e680397ec8f3eb; });

var $6QU8A = parcelRequire("6QU8A");

var $2Yk1N = parcelRequire("2Yk1N");

var $jjExS = parcelRequire("jjExS");

var $j2ZFo = parcelRequire("j2ZFo");
var $8dcc21522e64c2e9$var$VisibilityChangeObserver = /*#__PURE__*/ function() {
    function VisibilityChangeObserver() {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($6QU8A)))(this, VisibilityChangeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "started", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "observers", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "broadcast", function() {
            _this.observers.forEach(function(fn) {
                return fn();
            });
            _this.observers = [];
        });
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($2Yk1N)))(VisibilityChangeObserver, [
        {
            key: "start",
            value: function start() {
                if (this.started) return;
                this.started = true;
                document.addEventListener("visibilitychange", this.broadcast);
                /**
       * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
       * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
       * so for that case, you need to also include code to listen for the pagehide event.
       */ if ((0, $j2ZFo.isWindowObjectAvailable)()) window.addEventListener("pagehide", this.broadcast);
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                this.observers.push(callback);
            }
        },
        {
            key: "unsubscribe",
            value: function unsubscribe(callback) {
                this.observers = this.observers.filter(function(fn) {
                    return fn !== callback;
                });
            }
        }
    ]);
    return VisibilityChangeObserver;
}();
var $8dcc21522e64c2e9$export$13e680397ec8f3eb = new $8dcc21522e64c2e9$var$VisibilityChangeObserver();

});
parcelRegister("j2ZFo", function(module, exports) {

$parcel$export(module.exports, "isWindowObjectAvailable", function () { return $ddde09f5595e6267$export$15e172712955e18f; });
var $ddde09f5595e6267$export$15e172712955e18f = function isWindowObjectAvailable() {
    return typeof window !== "undefined";
};

});


parcelRegister("b8eZI", function(module, exports) {

$parcel$export(module.exports, "getGlobalEventStream", function () { return $81ac12aa6a9ef9bc$export$6123a44dc2384540; });
$parcel$export(module.exports, "setGlobalEventStream", function () { return $81ac12aa6a9ef9bc$export$c1522520b417b066; });

var $iWydU = parcelRequire("iWydU");

var $fc108 = parcelRequire("fc108");
var $81ac12aa6a9ef9bc$var$MAX_EARLY_QUEUE_LENGTH = 250;
var $81ac12aa6a9ef9bc$export$6123a44dc2384540 = function getGlobalEventStream() {
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        var earlyStream = function() {
            var stream = [];
            return {
                __buffer_only__: true,
                push: function push(event) {
                    if (stream.length < $81ac12aa6a9ef9bc$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: function getStream() {
                    return stream;
                }
            };
        }();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
var $81ac12aa6a9ef9bc$export$c1522520b417b066 = function setGlobalEventStream(eventStream) {
    var _globalThis$__UFO_GLO, _globalThis$__UFO_GLO2;
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !((_globalThis$__UFO_GLO = globalThis.__UFO_GLOBAL_EVENT_STREAM__) !== null && _globalThis$__UFO_GLO !== void 0 && _globalThis$__UFO_GLO.__buffer_only__)) {
        (0, $iWydU.ufowarn)("Global Event Stream already initialised. Ignoring new event stream setup");
        return;
    }
    if ((_globalThis$__UFO_GLO2 = globalThis.__UFO_GLOBAL_EVENT_STREAM__) !== null && _globalThis$__UFO_GLO2 !== void 0 && _globalThis$__UFO_GLO2.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
var $81ac12aa6a9ef9bc$export$37863216db4b714d = function subscribeEvent(experienceId, callback) {
    return {
        type: (0, $fc108.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
var $81ac12aa6a9ef9bc$export$ee1a7bd1fc9ea85e = function unsubscribeEvent(experienceId, callback) {
    return {
        type: (0, $fc108.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
var $81ac12aa6a9ef9bc$export$7c957416596ca127 = function experiencePayloadEvent(data) {
    return {
        type: (0, $fc108.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("iWydU", function(module, exports) {

$parcel$export(module.exports, "ufologger", function () { return $dca830d59cb2dc6c$export$4ab84f6f04f6566d; });
$parcel$export(module.exports, "ufolog", function () { return $dca830d59cb2dc6c$export$b4958caff08a0960; });
$parcel$export(module.exports, "ufowarn", function () { return $dca830d59cb2dc6c$export$d53d07b6034c4560; });

var $6QU8A = parcelRequire("6QU8A");

var $2Yk1N = parcelRequire("2Yk1N");

var $jjExS = parcelRequire("jjExS");
var $dca830d59cb2dc6c$var$UFOLogger = /*#__PURE__*/ function() {
    function UFOLogger() {
        (0, (/*@__PURE__*/$parcel$interopDefault($6QU8A)))(this, UFOLogger);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "enabled", false);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($2Yk1N)))(UFOLogger, [
        {
            key: "log",
            value: function log() {
                var _console;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                // eslint-disable-next-line no-console
                this.enabled && (_console = console).log.apply(_console, [
                    UFOLogger.UFOprefix
                ].concat(args));
            }
        },
        {
            key: "warn",
            value: function warn() {
                var _console2;
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                // eslint-disable-next-line no-console
                this.enabled && (_console2 = console).warn.apply(_console2, [
                    UFOLogger.UFOprefix
                ].concat(args));
            }
        },
        {
            key: "enable",
            value: function enable() {
                this.enabled = true;
            }
        },
        {
            key: "disable",
            value: function disable() {
                this.enabled = false;
            }
        }
    ]);
    return UFOLogger;
}();
(0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))($dca830d59cb2dc6c$var$UFOLogger, "UFOprefix", "[ufo\uD83D\uDEF8]");
var $dca830d59cb2dc6c$export$4ab84f6f04f6566d = new $dca830d59cb2dc6c$var$UFOLogger();
var $dca830d59cb2dc6c$export$b4958caff08a0960 = function ufolog() {
    $dca830d59cb2dc6c$export$4ab84f6f04f6566d.log.apply($dca830d59cb2dc6c$export$4ab84f6f04f6566d, arguments);
};
var $dca830d59cb2dc6c$export$d53d07b6034c4560 = function ufowarn() {
    $dca830d59cb2dc6c$export$4ab84f6f04f6566d.warn.apply($dca830d59cb2dc6c$export$4ab84f6f04f6566d, arguments);
};

});

parcelRegister("fc108", function(module, exports) {

$parcel$export(module.exports, "UFOGlobalEventStreamEventType", function () { return $b0f8c0d1bbc30308$export$96253c35c37cf96b; });
$parcel$export(module.exports, "PageVisibleState", function () { return $b0f8c0d1bbc30308$export$a12c67b37a306b13; });
$parcel$export(module.exports, "SUBSCRIBE_ALL", function () { return $b0f8c0d1bbc30308$export$79bf131685ad41d7; });
$parcel$export(module.exports, "FMP_MARK", function () { return $b0f8c0d1bbc30308$export$9f2bf58999404c75; });
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", function () { return $b0f8c0d1bbc30308$export$837e0f79a8056912; });

var $b0f8c0d1bbc30308$export$96253c35c37cf96b;
(function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
})($b0f8c0d1bbc30308$export$96253c35c37cf96b || ($b0f8c0d1bbc30308$export$96253c35c37cf96b = {}));
var $b0f8c0d1bbc30308$export$a12c67b37a306b13;
(function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
})($b0f8c0d1bbc30308$export$a12c67b37a306b13 || ($b0f8c0d1bbc30308$export$a12c67b37a306b13 = {}));
var $b0f8c0d1bbc30308$export$66b33c055cbb625e;
(function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
})($b0f8c0d1bbc30308$export$66b33c055cbb625e || ($b0f8c0d1bbc30308$export$66b33c055cbb625e = {}));
var $b0f8c0d1bbc30308$export$3ce489cbe02dc21b;
(function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
})($b0f8c0d1bbc30308$export$3ce489cbe02dc21b || ($b0f8c0d1bbc30308$export$3ce489cbe02dc21b = {}));
var $b0f8c0d1bbc30308$export$341b330828bd3906;
(function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
})($b0f8c0d1bbc30308$export$341b330828bd3906 || ($b0f8c0d1bbc30308$export$341b330828bd3906 = {}));
var $b0f8c0d1bbc30308$export$b9b20160f581e4f8;
(function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
})($b0f8c0d1bbc30308$export$b9b20160f581e4f8 || ($b0f8c0d1bbc30308$export$b9b20160f581e4f8 = {}));
var $b0f8c0d1bbc30308$export$79bf131685ad41d7 = "__SUBSCRIBE_ALL__";
var $b0f8c0d1bbc30308$export$9f2bf58999404c75 = "fmp";
var $b0f8c0d1bbc30308$export$837e0f79a8056912 = "inline-response";

});


parcelRegister("1RyTU", function(module, exports) {

$parcel$export(module.exports, "UFO_BUILD_VERSION", function () { return $15b5d040aaee272a$export$93809551debf385f; });
// temp solution until a proper versioning
var $15b5d040aaee272a$export$93809551debf385f = "0.1.7";

});

parcelRegister("7Mc3g", function(module, exports) {

$parcel$export(module.exports, "TenantType", function () { return $5a965d4956bc3221$export$92a757ac1398962f; });

var $5a965d4956bc3221$export$92a757ac1398962f;
(function(TenantType) {
    TenantType["RealUser"] = "real-user";
    TenantType["Synthetic"] = "synthetic";
})($5a965d4956bc3221$export$92a757ac1398962f || ($5a965d4956bc3221$export$92a757ac1398962f = {}));

});

parcelRegister("i2xIP", function(module, exports) {

$parcel$export(module.exports, "UFOGlobalEventStream", function () { return $d222925fd284c5c7$export$faf4c91b80fc830e; });

var $6QU8A = parcelRequire("6QU8A");

var $2Yk1N = parcelRequire("2Yk1N");

var $jjExS = parcelRequire("jjExS");

var $iWydU = parcelRequire("iWydU");

var $fc108 = parcelRequire("fc108");
var $d222925fd284c5c7$export$faf4c91b80fc830e = /*#__PURE__*/ function() {
    function UFOGlobalEventStream() {
        (0, (/*@__PURE__*/$parcel$interopDefault($6QU8A)))(this, UFOGlobalEventStream);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "__buffer_only__", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "subscribers", {});
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($2Yk1N)))(UFOGlobalEventStream, [
        {
            key: "push",
            value: function push(event) {
                (0, $iWydU.ufolog)("EVENT STREAM push", event.type, event.payload);
                if (event.type === (0, $fc108.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD) this.publish(event.payload);
                if (event.type === (0, $fc108.UFOGlobalEventStreamEventType).SUBSCRIBE) this.subscribe(event.payload.experienceId, event.payload.callback);
                if (event.type === (0, $fc108.UFOGlobalEventStreamEventType).UNSUBSCRIBE) this.unsubscribe(event.payload.experienceId, event.payload.callback);
            }
        },
        {
            key: "publish",
            value: function publish(eventPayload) {
                var _this$subscribers$eve;
                if (this.subscribers[0, $fc108.SUBSCRIBE_ALL]) this.subscribers[0, $fc108.SUBSCRIBE_ALL].forEach(function(fn) {
                    fn(eventPayload);
                });
                (_this$subscribers$eve = this.subscribers[eventPayload.id]) === null || _this$subscribers$eve === void 0 || _this$subscribers$eve.forEach(function(fn) {
                    fn(eventPayload);
                });
            }
        },
        {
            key: "subscribe",
            value: function subscribe(experienceId, fn) {
                (0, $iWydU.ufolog)("EVENT STREAM subscribe", experienceId);
                if (!this.subscribers[experienceId]) this.subscribers[experienceId] = [];
                this.subscribers[experienceId].push(fn);
            }
        },
        {
            key: "unsubscribe",
            value: function unsubscribe(experienceId, fn) {
                var index = this.subscribers[experienceId].findIndex(function(entry) {
                    return entry === fn;
                });
                if (index !== -1) this.subscribers[experienceId].splice(index, 1);
            }
        }
    ]);
    return UFOGlobalEventStream;
}();

});

parcelRegister("eCL5B", function(module, exports) {

$parcel$export(module.exports, "getPerformancePayload", function () { return $aa5924403d775b90$export$738d24377baf6a5e; });

var $jjExS = parcelRequire("jjExS");

var $6rNRl = parcelRequire("6rNRl");

var $fc108 = parcelRequire("fc108");

var $dYjKm = parcelRequire("dYjKm");

var $4ZQ9J = parcelRequire("4ZQ9J");

var $hBGOZ = parcelRequire("hBGOZ");

var $937zu = parcelRequire("937zu");

var $2hPMR = parcelRequire("2hPMR");
function $aa5924403d775b90$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $aa5924403d775b90$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $aa5924403d775b90$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $aa5924403d775b90$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $aa5924403d775b90$var$LoadMetricKeys = {
    tti: "metric:tti",
    fmp: "metric:fmp",
    ttiHistograms: "metric:tti:histogramBuckets",
    fmpHistograms: "metric:fmp:histogramBuckets"
};
var $aa5924403d775b90$var$InlineResultMetricKeys = {
    result: "metric:result",
    response: "metric:response",
    resultHistograms: "metric:result:histogramBuckets",
    responseHistograms: "metric:response:histogramBuckets"
};
var $aa5924403d775b90$var$CustomMetricKeys = {
    duration: "metric:duration",
    durationHistograms: "metric:duration:histogramBuckets"
};
var $aa5924403d775b90$var$getHistogram = function getHistogram(data, performanceConfig, isInitial) {
    var _data$performanceConf, _ref, _ref2;
    var histogram = null;
    if ((_data$performanceConf = data.performanceConfig) !== null && _data$performanceConf !== void 0 && _data$performanceConf.histogram) histogram = data.performanceConfig.histogram;
    else if (performanceConfig !== null && performanceConfig !== void 0 && performanceConfig.histogram) histogram = performanceConfig.histogram;
    if (histogram) {
        var histograms = histogram[data.performanceType];
        switch(data.performanceType){
            case (0, $6rNRl.ExperiencePerformanceTypes).PageLoad:
            case (0, $6rNRl.ExperiencePerformanceTypes).PageSegmentLoad:
                var histogramType = isInitial !== undefined && isInitial === true ? "initial" : "transition";
                return histograms ? (_ref = {}, (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(_ref, $aa5924403d775b90$var$LoadMetricKeys.ttiHistograms, histograms[histogramType].tti), (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(_ref, $aa5924403d775b90$var$LoadMetricKeys.fmpHistograms, histograms[histogramType].fmp), _ref) : {};
            case (0, $6rNRl.ExperiencePerformanceTypes).InlineResult:
                return histograms ? (_ref2 = {}, (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(_ref2, $aa5924403d775b90$var$InlineResultMetricKeys.resultHistograms, histograms.result), (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(_ref2, $aa5924403d775b90$var$InlineResultMetricKeys.responseHistograms, histograms.response), _ref2) : {};
            case (0, $6rNRl.ExperiencePerformanceTypes).Custom:
                return histograms ? (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))({}, $aa5924403d775b90$var$CustomMetricKeys.durationHistograms, histograms.duration) : {};
        }
    }
};
var $aa5924403d775b90$export$bd4e6d81a822ece6 = function getLoadMetrics(data, ssr, performanceConfig) {
    var _data$metrics$marks$f, _objectSpread2;
    if (data.metrics.endTime === null || data.metrics.startTime === null) return null;
    var fmpMark = ((_data$metrics$marks$f = data.metrics.marks.find(function(mark) {
        return mark.name === (0, $fc108.FMP_MARK);
    })) === null || _data$metrics$marks$f === void 0 ? void 0 : _data$metrics$marks$f.time) || (0, $dYjKm.isInitialPageLoad)(data) && (ssr === null || ssr === void 0 ? void 0 : ssr.getDoneMark());
    var tti = data.metrics.endTime - data.metrics.startTime;
    var fmp = typeof fmpMark === "number" ? fmpMark - data.metrics.startTime : tti;
    return $aa5924403d775b90$var$_objectSpread((_objectSpread2 = {}, (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(_objectSpread2, $aa5924403d775b90$var$LoadMetricKeys.tti, Math.round(tti)), (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(_objectSpread2, $aa5924403d775b90$var$LoadMetricKeys.fmp, Math.round(fmp)), _objectSpread2), $aa5924403d775b90$var$getHistogram(data, performanceConfig));
};
var $aa5924403d775b90$export$47f0208fd62dffce = function getInlineResultMetrics(data, performanceConfig) {
    var _objectSpread3;
    if (data.metrics.endTime === null || data.metrics.startTime === null) return null;
    var responseMark = data.metrics.marks.find(function(mark) {
        return mark.name === (0, $fc108.INLINE_RESPONSE_MARK);
    });
    var result = data.metrics.endTime - data.metrics.startTime;
    var response = responseMark ? responseMark.time - data.metrics.startTime : result;
    return $aa5924403d775b90$var$_objectSpread((_objectSpread3 = {}, (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(_objectSpread3, $aa5924403d775b90$var$InlineResultMetricKeys.result, Math.round(result)), (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(_objectSpread3, $aa5924403d775b90$var$InlineResultMetricKeys.response, Math.round(response)), _objectSpread3), $aa5924403d775b90$var$getHistogram(data, performanceConfig));
};
var $aa5924403d775b90$export$c25c1b3ff2ce92cf = function getCustomMetrics(data, performanceConfig) {
    if (data.metrics.endTime === null || data.metrics.startTime === null) return null;
    var duration = data.metrics.endTime - data.metrics.startTime;
    return $aa5924403d775b90$var$_objectSpread((0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))({}, $aa5924403d775b90$var$CustomMetricKeys.duration, Math.round(duration)), $aa5924403d775b90$var$getHistogram(data, performanceConfig));
};
var $aa5924403d775b90$var$getPerformanceMetrics = function getPerformanceMetrics(data, ssr, performanceConfig) {
    switch(data.performanceType){
        case (0, $6rNRl.ExperiencePerformanceTypes).PageLoad:
        case (0, $6rNRl.ExperiencePerformanceTypes).PageSegmentLoad:
            return $aa5924403d775b90$export$bd4e6d81a822ece6(data, ssr, performanceConfig);
        case (0, $6rNRl.ExperiencePerformanceTypes).InlineResult:
            return $aa5924403d775b90$export$47f0208fd62dffce(data, performanceConfig);
        case (0, $6rNRl.ExperiencePerformanceTypes).Custom:
            return $aa5924403d775b90$export$c25c1b3ff2ce92cf(data, performanceConfig);
    }
};
var $aa5924403d775b90$export$738d24377baf6a5e = function getPerformancePayload(data, ssr, bundleEvalConfig, resourceConfig, performanceConfig) {
    return $aa5924403d775b90$var$_objectSpread($aa5924403d775b90$var$_objectSpread($aa5924403d775b90$var$_objectSpread($aa5924403d775b90$var$_objectSpread($aa5924403d775b90$var$_objectSpread({}, $aa5924403d775b90$var$getPerformanceMetrics(data, ssr, performanceConfig)), (0, $2hPMR.resourceTimings)(data, resourceConfig)), (0, $937zu.bundleEvalTimings)(data, bundleEvalConfig)), (0, $hBGOZ.appTimings)(data, ssr)), (0, $dYjKm.isInitialPageLoad)(data) ? (0, $4ZQ9J.navigationMetrics)() : null);
};

});
parcelRegister("dYjKm", function(module, exports) {

$parcel$export(module.exports, "isInitialPageLoad", function () { return $a2c032431e91b3f5$export$7167d96e9881d500; });

var $6rNRl = parcelRequire("6rNRl");
var $a2c032431e91b3f5$export$7167d96e9881d500 = function isInitialPageLoad(data) {
    return data.performanceType === (0, $6rNRl.ExperiencePerformanceTypes).PageLoad && data.initial === true;
};

});

parcelRegister("4ZQ9J", function(module, exports) {

$parcel$export(module.exports, "navigationMetrics", function () { return $3a355107809b5344$export$b88d990436be0f8a; });
var $3a355107809b5344$export$b88d990436be0f8a = function navigationMetrics() {
    var entries = performance.getEntriesByType("navigation");
    if (entries.length === 0) return null;
    var navigation = entries[0];
    var metrics = {
        // From https://www.w3.org/TR/resource-timing/
        redirectStart: Math.round(navigation.redirectStart),
        redirectEnd: Math.round(navigation.redirectEnd),
        fetchStart: Math.round(navigation.fetchStart),
        domainLookupStart: Math.round(navigation.domainLookupStart),
        domainLookupEnd: Math.round(navigation.domainLookupEnd),
        connectStart: Math.round(navigation.connectStart),
        connectEnd: Math.round(navigation.connectEnd),
        secureConnectionStart: Math.round(navigation.secureConnectionStart),
        requestStart: Math.round(navigation.requestStart),
        responseStart: Math.round(navigation.responseStart),
        responseEnd: Math.round(navigation.responseEnd),
        encodedBodySize: Math.round(navigation.encodedBodySize),
        // From https://www.w3.org/TR/navigation-timing-2/
        redirectCount: navigation.redirectCount,
        type: navigation.type,
        unloadEventEnd: Math.round(navigation.unloadEventEnd),
        unloadEventStart: Math.round(navigation.unloadEventStart),
        workerStart: Math.round(navigation.workerStart) // The following properties are ignored because they provided limited value on a modern stack (e.g. the content
    };
    return {
        "metrics:navigation": metrics
    };
};

});

parcelRegister("hBGOZ", function(module, exports) {

$parcel$export(module.exports, "appTimings", function () { return $cd171bd36ba74f6c$export$e952f50a4f2d02da; });

var $jjExS = parcelRequire("jjExS");

var $6rNRl = parcelRequire("6rNRl");

var $dYjKm = parcelRequire("dYjKm");

var $5Elnb = parcelRequire("5Elnb");

var $6WMMP = parcelRequire("6WMMP");
function $cd171bd36ba74f6c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $cd171bd36ba74f6c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $cd171bd36ba74f6c$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $cd171bd36ba74f6c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $cd171bd36ba74f6c$export$e952f50a4f2d02da = function appTimings(data, ssrConfig) {
    var explicitTimings = data.performanceType === (0, $6rNRl.ExperiencePerformanceTypes).PageLoad && data.explicitTimings || null;
    var timings = (0, $5Elnb.customTimings)(data);
    var ssr = (0, $dYjKm.isInitialPageLoad)(data) ? (0, $6WMMP.ssrTimings)(ssrConfig) : null;
    var timingsApp = (explicitTimings || timings || ssr) && $cd171bd36ba74f6c$var$_objectSpread($cd171bd36ba74f6c$var$_objectSpread($cd171bd36ba74f6c$var$_objectSpread({}, explicitTimings), timings), ssr);
    if (!timingsApp || Object.keys(timingsApp).length === 0) return null;
    return {
        "timings:app": timingsApp
    };
};

});
parcelRegister("5Elnb", function(module, exports) {

$parcel$export(module.exports, "customTimings", function () { return $41d14468f340f52f$export$6126f85083a72c6e; });
var $41d14468f340f52f$var$retrieveTimings = function retrieveTimings(data) {
    var configTimings = data.timings || [];
    var timings = configTimings.reduce(function(entries, timing) {
        var startMark = data.metrics.marks.find(function(mark) {
            return mark.name === timing.startMark;
        });
        if (timing.startMark && !startMark) return entries;
        var endMark = data.metrics.marks.find(function(mark) {
            return mark.name === timing.endMark;
        });
        if (timing.endMark && !endMark) return entries;
        if (data.metrics.startTime === null || data.metrics.endTime === null) return null;
        var startTime = Math.round((startMark ? startMark.time : data.metrics.startTime) - data.metrics.startTime);
        var duration = Math.round((endMark ? endMark.time : data.metrics.endTime) - data.metrics.startTime - startTime);
        entries["".concat(timing.key)] = {
            startTime: startTime,
            duration: duration
        };
        return entries;
    }, {});
    return timings;
};
var $41d14468f340f52f$export$6126f85083a72c6e = function customTimings(data) {
    if (!data.timings) return null;
    var timings = $41d14468f340f52f$var$retrieveTimings(data);
    if (Object.keys(timings).length === 0) return null;
    return timings;
};

});

parcelRegister("6WMMP", function(module, exports) {

$parcel$export(module.exports, "ssrTimings", function () { return $50ee00d71e9f375b$export$130f411261a599c5; });

var $2nffd = parcelRequire("2nffd");

var $7jRZm = parcelRequire("7jRZm");
var $50ee00d71e9f375b$var$filterEntry = function filterEntry(entry) {
    return !(!entry || (0, (/*@__PURE__*/$parcel$interopDefault($2nffd)))(entry) !== "object" || entry.startTime < 0 || entry.duration < 0);
};
var $50ee00d71e9f375b$var$mapEntry = function mapEntry(entry) {
    return {
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration)
    };
};
var $50ee00d71e9f375b$var$SSR_PREFIX = "ssr";
var $50ee00d71e9f375b$var$mapKey = function mapKey(key) {
    if (key === "total") return $50ee00d71e9f375b$var$SSR_PREFIX;
    return "".concat($50ee00d71e9f375b$var$SSR_PREFIX).concat((0, $7jRZm.NESTED_METRIC_SEPARATOR)).concat(key);
};
var $50ee00d71e9f375b$export$130f411261a599c5 = function ssrTimings(ssr) {
    if (!(ssr !== null && ssr !== void 0 && ssr.getTimings)) return null;
    var timings = ssr.getTimings();
    if (!timings) return null;
    var ssrTimings = Object.entries(timings).reduce(function(acc, entry) {
        if ($50ee00d71e9f375b$var$filterEntry(entry[1])) acc[$50ee00d71e9f375b$var$mapKey(entry[0])] = $50ee00d71e9f375b$var$mapEntry(entry[1]);
        return acc;
    }, {});
    if (!ssrTimings || Object.keys(ssrTimings).length === 0) return null;
    return ssrTimings;
};

});
parcelRegister("7jRZm", function(module, exports) {

$parcel$export(module.exports, "NESTED_METRIC_SEPARATOR", function () { return $55442fcb9be39d71$export$b98e411ae80c806f; });
var $55442fcb9be39d71$export$b98e411ae80c806f = "/";

});



parcelRegister("937zu", function(module, exports) {

$parcel$export(module.exports, "bundleEvalTimings", function () { return $696a445e7858178c$export$1a2bb347935fc536; });

var $e6gyJ = parcelRequire("e6gyJ");

var $7rOQc = parcelRequire("7rOQc");
var $696a445e7858178c$export$1a2bb347935fc536 = function bundleEvalTimings(data, _bundleEvalTimings) {
    var performance = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $7rOQc.getPerformanceObject)() || undefined;
    if (!_bundleEvalTimings) return null;
    var started = {};
    var timings = {};
    performance === null || performance === void 0 || performance.getEntriesByType("mark").forEach(function(mark) {
        var result = _bundleEvalTimings.mapPerformanceMark(mark.name);
        if (!result || data.result.startTime === null) return;
        var type = result.type, name = result.name;
        if (type === "start" && mark.startTime >= data.result.startTime) {
            started[name] = mark;
            return;
        }
        if (type === "end" && started[name]) {
            timings[name] = {
                startTime: Math.round(started[name].startTime - data.result.startTime),
                duration: Math.round(mark.startTime - started[name].startTime)
            };
            delete started[name];
        }
    });
    if (_bundleEvalTimings !== null && _bundleEvalTimings !== void 0 && _bundleEvalTimings.additionalTimings && data.result.startTime !== null) {
        var result = _bundleEvalTimings.additionalTimings(data.result.startTime);
        if (result) Object.entries(result).forEach(function(_ref) {
            var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($e6gyJ)))(_ref, 2), key = _ref2[0], value = _ref2[1];
            timings[key] = value;
        });
    }
    if (Object.keys(timings).length === 0) return null;
    return {
        "timings:bundleEval": timings
    };
};

});
parcelRegister("7rOQc", function(module, exports) {

$parcel$export(module.exports, "getWindowObject", function () { return $56c27dfad84a1be7$export$9aa44f85591248d9; });
$parcel$export(module.exports, "getPerformanceObject", function () { return $56c27dfad84a1be7$export$8cd0c777b0eb66a0; });
$parcel$export(module.exports, "getPerformanceObserverObject", function () { return $56c27dfad84a1be7$export$74560fd4e61fd440; });
var $56c27dfad84a1be7$export$9aa44f85591248d9 = function getWindowObject() {
    return typeof window !== "undefined" && !!window ? window : undefined;
};
var $56c27dfad84a1be7$export$8cd0c777b0eb66a0 = function getPerformanceObject() {
    var _ref = $56c27dfad84a1be7$export$9aa44f85591248d9() || {}, performance = _ref.performance;
    return performance;
};
var $56c27dfad84a1be7$export$74560fd4e61fd440 = function getPerformanceObserverObject() {
    var _ref2 = $56c27dfad84a1be7$export$9aa44f85591248d9() || {}, PerformanceObserver = _ref2.PerformanceObserver;
    return PerformanceObserver;
};

});


parcelRegister("2hPMR", function(module, exports) {

$parcel$export(module.exports, "resourceTimings", function () { return $1aa5572286a0dcdb$export$81a7d52441a06b50; });

var $jjExS = parcelRequire("jjExS");

var $7rOQc = parcelRequire("7rOQc");

var $4t1Q2 = parcelRequire("4t1Q2");
function $1aa5572286a0dcdb$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1aa5572286a0dcdb$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $1aa5572286a0dcdb$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $1aa5572286a0dcdb$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $1aa5572286a0dcdb$var$cacheableTypes = [
    "script",
    "link"
];
var $1aa5572286a0dcdb$var$resourceTypes = [
    "fetch",
    "xmlhttprequest"
];
var $1aa5572286a0dcdb$var$CACHE_NETWORK = "network";
var $1aa5572286a0dcdb$var$CACHE_MEMORY = "memory";
var $1aa5572286a0dcdb$var$CACHE_DISK = "disk";
var $1aa5572286a0dcdb$var$calculateTransferType = function calculateTransferType(type, duration, size) {
    if (!$1aa5572286a0dcdb$var$cacheableTypes.includes(type)) return $1aa5572286a0dcdb$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $1aa5572286a0dcdb$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $1aa5572286a0dcdb$var$CACHE_DISK;
    if (size === undefined) return null;
    return $1aa5572286a0dcdb$var$CACHE_NETWORK;
};
var $1aa5572286a0dcdb$var$hasAccessToResourceSize = function hasAccessToResourceSize(url, type, entry, hasTimingHeaders) {
    return !$1aa5572286a0dcdb$var$cacheableTypes.includes(type) || url.includes("localhost") || !!(0, $7rOQc.getWindowObject)() && url.includes(window.location.hostname) || hasTimingHeaders(url, entry);
};
var $1aa5572286a0dcdb$var$getReportedInitiatorTypes = function getReportedInitiatorTypes(xhrEnabled) {
    if (xhrEnabled) return [
        "script",
        "link",
        "fetch",
        "xmlhttprequest"
    ];
    return [
        "script",
        "link",
        "fetch"
    ];
};
var $1aa5572286a0dcdb$var$evaluateAccessToResourceTimings = function evaluateAccessToResourceTimings(url, entry) {
    return !(entry.responseStart === 0 && entry.startTime > entry.responseStart);
};
var $1aa5572286a0dcdb$var$getSizeObject = function getSizeObject(size) {
    return size !== undefined ? {
        size: size
    } : null;
};
var $1aa5572286a0dcdb$var$getNetworkData = function getNetworkData(item, eventStart) {
    var hasTimingHeaders = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $1aa5572286a0dcdb$var$evaluateAccessToResourceTimings;
    var name = item.name, duration = item.duration, transferSize = item.transferSize, initiatorType = item.initiatorType, responseStart = item.responseStart;
    var ttfb = Math.round(responseStart - eventStart);
    if (!$1aa5572286a0dcdb$var$hasAccessToResourceSize(name, initiatorType, item, hasTimingHeaders)) return {};
    if ($1aa5572286a0dcdb$var$cacheableTypes.includes(initiatorType)) {
        var transferType = $1aa5572286a0dcdb$var$calculateTransferType(initiatorType, duration, transferSize);
        if (!transferType) return $1aa5572286a0dcdb$var$_objectSpread({
            ttfb: ttfb
        }, $1aa5572286a0dcdb$var$getSizeObject(transferSize));
        if (transferType !== $1aa5572286a0dcdb$var$CACHE_NETWORK) return {
            transferType: transferType
        };
        return $1aa5572286a0dcdb$var$_objectSpread({
            ttfb: ttfb,
            transferType: transferType
        }, $1aa5572286a0dcdb$var$getSizeObject(transferSize));
    }
    return $1aa5572286a0dcdb$var$_objectSpread({
        ttfb: ttfb
    }, $1aa5572286a0dcdb$var$getSizeObject(transferSize));
};
var $1aa5572286a0dcdb$export$81a7d52441a06b50 = function resourceTimings(data, _resourceTimings) {
    var performance = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $7rOQc.getPerformanceObject)() || undefined;
    if (data.result.startTime === null || !_resourceTimings) return null;
    var resources = (0, $4t1Q2.getResourceTimings)(data.result.startTime, performance);
    if (!(resources !== null && resources !== void 0 && resources.length)) return null;
    var resourceTiming = {};
    var xhrFilter = _resourceTimings.xhrFilter;
    var reportedInitiatorTypes = $1aa5572286a0dcdb$var$getReportedInitiatorTypes(!!xhrFilter);
    resources.forEach(function(item) {
        if (!reportedInitiatorTypes.includes(item.initiatorType)) return;
        var name = item.name, startTime = item.startTime, duration = item.duration, workerStart = item.workerStart, fetchStart = item.fetchStart, initiatorType = item.initiatorType;
        if (!name || data.result.startTime === null) return;
        if (initiatorType === "xmlhttprequest" && (xhrFilter === undefined || xhrFilter(name) === false)) return;
        var url = $1aa5572286a0dcdb$var$resourceTypes.includes(initiatorType) ? _resourceTimings.sanitiseEndpoints(name) : _resourceTimings.mapResources(name);
        if (!url || resourceTiming[url]) return;
        resourceTiming[url] = $1aa5572286a0dcdb$var$_objectSpread({
            startTime: Math.round(startTime - data.result.startTime),
            duration: Math.round(duration),
            workerStart: Math.max(Math.round(workerStart - data.result.startTime), 0),
            fetchStart: Math.max(Math.round(fetchStart - data.result.startTime), 0),
            type: initiatorType
        }, $1aa5572286a0dcdb$var$getNetworkData(item, data.result.startTime, _resourceTimings.hasTimingHeaders));
    });
    return {
        "timings:resource": resourceTiming
    };
};

});
parcelRegister("4t1Q2", function(module, exports) {

$parcel$export(module.exports, "resourceTimingBuffer", function () { return $340b4bec2b8fbfcd$export$bea963256235a63e; });
$parcel$export(module.exports, "getResourceTimings", function () { return $340b4bec2b8fbfcd$export$9eebb59359c2e9e5; });

var $eetQ9 = parcelRequire("eetQ9");

var $iWydU = parcelRequire("iWydU");

var $7rOQc = parcelRequire("7rOQc");
var $340b4bec2b8fbfcd$export$bea963256235a63e = {
    timings: [],
    maxSize: 1000,
    observer: null,
    transformResource: function transformResource(entry) {
        return {
            name: entry.name,
            initiatorType: entry.initiatorType,
            transferSize: entry.transferSize,
            startTime: Math.round(entry.startTime),
            duration: Math.round(entry.duration),
            fetchStart: Math.round(entry.fetchStart || 0),
            workerStart: Math.round(entry.workerStart || 0),
            responseStart: Math.round(entry.responseStart || 0)
        };
    },
    start: function start() {
        var performance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $7rOQc.getPerformanceObject)();
        var PerformanceObserver1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $7rOQc.getPerformanceObserverObject)();
        if (!PerformanceObserver1 || !performance || typeof PerformanceObserver1 === "undefined") return;
        if ($340b4bec2b8fbfcd$export$bea963256235a63e.observer) {
            (0, $iWydU.ufologger).warn("Observer is already running");
            return;
        }
        var resources = performance === null || performance === void 0 ? void 0 : performance.getEntriesByType("resource");
        if (resources) $340b4bec2b8fbfcd$export$bea963256235a63e.timings = resources.map(function(resource) {
            return $340b4bec2b8fbfcd$export$bea963256235a63e.transformResource(resource);
        });
        $340b4bec2b8fbfcd$export$bea963256235a63e.observer = new PerformanceObserver1($340b4bec2b8fbfcd$export$bea963256235a63e.addTimings);
        $340b4bec2b8fbfcd$export$bea963256235a63e.observer.observe({
            entryTypes: [
                "resource"
            ]
        });
    },
    stop: function stop() {
        if ($340b4bec2b8fbfcd$export$bea963256235a63e.observer) {
            $340b4bec2b8fbfcd$export$bea963256235a63e.observer.disconnect();
            $340b4bec2b8fbfcd$export$bea963256235a63e.observer = null;
        }
        $340b4bec2b8fbfcd$export$bea963256235a63e.timings = [];
    },
    addTimings: function addTimings(list) {
        var _resourceTimingBuffer;
        var entries = list.getEntries().map(function(entry) {
            return $340b4bec2b8fbfcd$export$bea963256235a63e.transformResource(entry);
        });
        var overflow = $340b4bec2b8fbfcd$export$bea963256235a63e.timings.length + entries.length;
        if (overflow > $340b4bec2b8fbfcd$export$bea963256235a63e.maxSize) {
            var fieldsToRemove = overflow - $340b4bec2b8fbfcd$export$bea963256235a63e.maxSize;
            $340b4bec2b8fbfcd$export$bea963256235a63e.timings.splice(0, fieldsToRemove);
        }
        (_resourceTimingBuffer = $340b4bec2b8fbfcd$export$bea963256235a63e.timings).push.apply(_resourceTimingBuffer, (0, (/*@__PURE__*/$parcel$interopDefault($eetQ9)))(entries));
    }
};
var $340b4bec2b8fbfcd$export$9eebb59359c2e9e5 = function getResourceTimings(startTime) {
    var performance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $7rOQc.getPerformanceObject)();
    if (!PerformanceObserver || !$340b4bec2b8fbfcd$export$bea963256235a63e.observer) {
        var resources = performance === null || performance === void 0 ? void 0 : performance.getEntriesByType("resource");
        if (resources) return resources.filter(function(timing) {
            return timing.startTime >= startTime;
        });
        return null;
    }
    return $340b4bec2b8fbfcd$export$bea963256235a63e.timings.filter(function(timing) {
        return timing.startTime >= startTime;
    });
};

});



parcelRegister("lzRGz", function(module, exports) {

$parcel$export(module.exports, "pageVisibleState", function () { return $fb5682b2f321c6fd$export$723b4c298aca63af; });

var $fc108 = parcelRequire("fc108");
var $fb5682b2f321c6fd$export$723b4c298aca63af = function pageVisibleState(data) {
    var _data$pageVisibleStat;
    return {
        "experience:pageVisible": (_data$pageVisibleStat = data.pageVisibleState) !== null && _data$pageVisibleStat !== void 0 ? _data$pageVisibleStat : document.hidden ? (0, $fc108.PageVisibleState).HIDDEN : (0, $fc108.PageVisibleState).VISIBLE
    };
};

});

parcelRegister("67kNC", function(module, exports) {

$parcel$export(module.exports, "appFramework", function () { return $474387d0b60392a3$export$e34e4529b979f74c; });
var $474387d0b60392a3$export$e34e4529b979f74c = function appFramework(config) {
    if (!config.framework) return null;
    return {
        "app:framework:name": config.framework.name,
        "app:framework:version": config.framework.version
    };
};

});

parcelRegister("jAELz", function(module, exports) {

$parcel$export(module.exports, "appVersion", function () { return $e4310076b2f53bac$export$82ae485178b37419; });
var $e4310076b2f53bac$export$82ae485178b37419 = function appVersion(config) {
    var pluginData = {
        "app:web:version": config.version.web
    };
    if (config.version.ssr) pluginData["app:ssr:version"] = config.version.ssr;
    return pluginData;
};

});

parcelRegister("kdD4O", function(module, exports) {

$parcel$export(module.exports, "eventBrowserPlugin", function () { return $eb83555b52e2ae15$export$f435c2789ca334a7; });

var $hAcNQ = parcelRequire("hAcNQ");

var $eUBSC = parcelRequire("eUBSC");

var $7rOQc = parcelRequire("7rOQc");
var $eb83555b52e2ae15$export$f435c2789ca334a7 = (0, $eUBSC.default)(function() {
    var _getWindowObject, _getWindowObject$navi;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($hAcNQ))).getParser) return null;
    var browser = (0, (/*@__PURE__*/$parcel$interopDefault($hAcNQ))).getParser(((_getWindowObject = (0, $7rOQc.getWindowObject)()) === null || _getWindowObject === void 0 ? void 0 : (_getWindowObject$navi = _getWindowObject.navigator) === null || _getWindowObject$navi === void 0 ? void 0 : _getWindowObject$navi.userAgent) || "");
    return {
        "event:browser:name": browser.getBrowserName(),
        "event:browser:version": browser.getBrowserVersion()
    };
});

});
parcelRegister("hAcNQ", function(module, exports) {
!function(e, r) {
    module.exports = r();
}(module.exports, function() {
    return function(e) {
        var r = {};
        function t(n) {
            if (r[n]) return r[n].exports;
            var i = r[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return e[n].call(i.exports, i, i.exports, t), i.l = !0, i.exports;
        }
        return t.m = e, t.c = r, t.d = function(e, r, n) {
            t.o(e, r) || Object.defineProperty(e, r, {
                enumerable: !0,
                get: n
            });
        }, t.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, t.t = function(e, r) {
            if (1 & r && (e = t(e)), 8 & r) return e;
            if (4 & r && "object" == typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if (t.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: e
            }), 2 & r && "string" != typeof e) for(var i in e)t.d(n, i, (function(r) {
                return e[r];
            }).bind(null, i));
            return n;
        }, t.n = function(e) {
            var r = e && e.__esModule ? function r() {
                return e.default;
            } : function() {
                return e;
            };
            return t.d(r, "a", r), r;
        }, t.o = function(e, r) {
            return Object.prototype.hasOwnProperty.call(e, r);
        }, t.p = "", t(t.s = 0);
    }([
        function(e, r, t) {
            "use strict";
            r.__esModule = !0, r.default = void 0;
            var n, i = (n = t(1)) && n.__esModule ? n : {
                default: n
            };
            /*!
 * Bowser - a browser detector
 * https://github.com/lancedikson/bowser
 * MIT License | (c) Dustin Diaz 2012-2015
 * MIT License | (c) Denis Demchenko 2015-2019
 */ var o = function() {
                function e() {}
                return e.getParser = function(e, r) {
                    if (void 0 === r && (r = !1), "string" != typeof e) throw new Error("UserAgent should be a string");
                    return new i.default(e, r);
                }, e.parse = function(e) {
                    return new i.default(e).getResult();
                }, e;
            }();
            r.default = o, e.exports = r.default;
        },
        function(e, r, t) {
            "use strict";
            r.__esModule = !0, r.default = void 0;
            var n, i = (n = t(2)) && n.__esModule ? n : {
                default: n
            };
            var o = function() {
                function e(e, r) {
                    if (void 0 === r && (r = !1), null == e || "" === e) throw new Error("UserAgent parameter can't be empty");
                    this._ua = e, this.parsedResult = {}, !0 !== r && this.parse();
                }
                var _$r = e.prototype;
                return _$r.getUA = function() {
                    return this._ua;
                }, _$r.test = function(e) {
                    return e.test(this._ua);
                }, _$r.parseBrowser = function() {
                    var _$e = this;
                    this.parsedResult.browser = {};
                    var _$r = i.default.find(function(r) {
                        if ("function" == typeof r.test) return r.test(_$e);
                        if (r.test instanceof Array) return r.test.some(function(r) {
                            return _$e.test(r);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return _$r && (this.parsedResult.browser = _$r.describe(this.getUA())), this.parsedResult.browser;
                }, _$r.isMobile = function() {
                    return this.test(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i);
                }, _$r.getBrowser = function() {
                    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
                }, _$r.getBrowserName = function(e) {
                    return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
                }, _$r.getBrowserVersion = function() {
                    return this.getBrowser().version;
                }, _$r.parse = function() {
                    return this.parseBrowser(), this;
                }, _$r.getResult = function() {
                    return Object.assign({}, this.parsedResult);
                }, e;
            }();
            r.default = o, e.exports = r.default;
        },
        function(e, r, t) {
            "use strict";
            function n(e, r) {
                var t = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                if (t) return (t = t.call(e)).next.bind(t);
                if (Array.isArray(e) || (t = function(e, r) {
                    if (!e) return;
                    if ("string" == typeof e) return i(e, r);
                    var t = Object.prototype.toString.call(e).slice(8, -1);
                    "Object" === t && e.constructor && (t = e.constructor.name);
                    if ("Map" === t || "Set" === t) return Array.from(e);
                    if ("Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return i(e, r);
                }(e)) || r && e && "number" == typeof e.length) {
                    t && (e = t);
                    var n = 0;
                    return function() {
                        return n >= e.length ? {
                            done: !0
                        } : {
                            done: !1,
                            value: e[n++]
                        };
                    };
                }
                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function i(e, r) {
                (null == r || r > e.length) && (r = e.length);
                for(var t = 0, n = new Array(r); t < r; t++)n[t] = e[t];
                return n;
            }
            r.__esModule = !0, r.default = void 0;
            var o = function o(e, r) {
                var t = r.match(e);
                return t && t.length > 0 && t[1] || "";
            }, s = function s(e, r) {
                var t = r.match(e);
                return t && t.length > 1 && t[2] || "";
            }, u = /version\/(\d+(\.?_?\d+)+)/i, a = function a(e, r) {
                void 0 === e && (e = []);
                for(var t, i = n(e); !(t = i()).done;){
                    var s = t.value, u = o(s, r);
                    if (u) return u;
                }
                return null;
            }, d = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function describe(e) {
                        return {
                            name: "Googlebot",
                            version: a([
                                /googlebot\/(\d+(\.\d+))/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /opera/i
                    ],
                    describe: function describe(e) {
                        return {
                            name: "Opera",
                            version: a([
                                u,
                                /(?:opera)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /opr\/|opios/i
                    ],
                    describe: function describe(e) {
                        return {
                            name: "Opera",
                            version: a([
                                /(?:opr|opios)[\s/](\S+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /SamsungBrowser/i
                    ],
                    describe: function describe(e) {
                        return {
                            name: "Samsung Internet for Android",
                            version: a([
                                u,
                                /(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /Whale/i
                    ],
                    describe: function describe(e) {
                        return {
                            name: "NAVER Whale Browser",
                            version: a([
                                u,
                                /(?:whale)[\s/](\d+(?:\.\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /coast/i
                    ],
                    describe: function describe(e) {
                        return {
                            name: "Opera Coast",
                            version: a([
                                u,
                                /(?:coast)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /opt\/\d+(?:.?_?\d+)+/i
                    ],
                    describe: function describe(e) {
                        return {
                            name: "Opera Touch",
                            version: a([
                                /(?:opt)[\s/](\d+(\.?_?\d+)+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /msie|trident/i
                    ],
                    describe: function describe(e) {
                        return {
                            name: "Internet Explorer",
                            version: a([
                                /(?:msie |rv:)(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /\sedg\//i
                    ],
                    describe: function describe(e) {
                        return {
                            name: "Microsoft Edge",
                            version: a([
                                /\sedg\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /edg([ea]|ios)/i
                    ],
                    describe: function describe(e) {
                        return {
                            name: "Microsoft Edge",
                            version: s(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e)
                        };
                    }
                },
                {
                    test: [
                        /vivaldi/i
                    ],
                    describe: function describe(e) {
                        return {
                            name: "Vivaldi",
                            version: a([
                                /vivaldi\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function describe(e) {
                        return {
                            name: "Tizen",
                            version: a([
                                /(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /firefox|iceweasel|fxios/i
                    ],
                    describe: function describe(e) {
                        return {
                            name: "Firefox",
                            version: a([
                                /(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /electron/i
                    ],
                    describe: function describe(e) {
                        return {
                            name: "Electron",
                            version: a([
                                /(?:electron)\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /chromium/i
                    ],
                    describe: function describe(e) {
                        return {
                            name: "Chromium",
                            version: a([
                                /(?:chromium)[\s/](\d+(\.?_?\d+)+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /chrome|crios|crmo/i
                    ],
                    describe: function describe(e) {
                        return {
                            name: "Chrome",
                            version: a([
                                /(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /GSA/i
                    ],
                    describe: function describe(e) {
                        return {
                            name: "Google Search",
                            version: a([
                                /(?:GSA)\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: function test(e) {
                        var _$r = !e.test(/like android/i), t = e.test(/android/i);
                        return _$r && t;
                    },
                    describe: function describe(e) {
                        return {
                            name: "Android Browser",
                            version: a([
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /safari|applewebkit/i
                    ],
                    describe: function describe(e) {
                        return {
                            name: "Safari",
                            version: a([
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /.*/i
                    ],
                    describe: function describe(e) {
                        var _$r = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                        return {
                            name: o(_$r, e),
                            version: s(_$r, e)
                        };
                    }
                }
            ];
            r.default = d, e.exports = r.default;
        }
    ]);
});

});


parcelRegister("eLBqm", function(module, exports) {

$parcel$export(module.exports, "eventCpusPlugin", function () { return $ac027c27498a2321$export$db7649b8854107ad; });

var $eUBSC = parcelRequire("eUBSC");
var $ac027c27498a2321$export$db7649b8854107ad = (0, $eUBSC.default)(function() {
    if (!navigator.hardwareConcurrency) return null;
    return {
        "event:cpus": navigator.hardwareConcurrency
    };
});

});

parcelRegister("4mwmu", function(module, exports) {

$parcel$export(module.exports, "featureFlags", function () { return $32d251d79da4b449$export$e62953d023125748; });

var $eetQ9 = parcelRequire("eetQ9");
var $32d251d79da4b449$export$e62953d023125748 = function featureFlags(featureFlagClient, _featureFlags, data) {
    var allFeatureFlags = [].concat((0, (/*@__PURE__*/$parcel$interopDefault($eetQ9)))(_featureFlags), (0, (/*@__PURE__*/$parcel$interopDefault($eetQ9)))(data.featureFlags || []));
    if (allFeatureFlags.length === 0) return null;
    var initialMemo = [];
    allFeatureFlags.reduce(function(memo, featureFlagKey) {
        var ffVal = featureFlagClient.getValue(featureFlagKey);
        if (ffVal !== undefined && ffVal !== null) memo.push([
            featureFlagKey,
            ffVal
        ]);
        return memo;
    }, initialMemo);
    var mappedFeatureFlags = Object.fromEntries(initialMemo);
    return {
        featureFlags: mappedFeatureFlags
    };
};

});

parcelRegister("bdAw1", function(module, exports) {

$parcel$export(module.exports, "eventMemoryPlugin", function () { return $82ad3bcef2460e6b$export$81efaf8414879a1a; });

var $eUBSC = parcelRequire("eUBSC");
var $82ad3bcef2460e6b$export$81efaf8414879a1a = (0, $eUBSC.default)(function() {
    // @ts-ignore: deviceMemory is exposed in some browsers
    if (!navigator.deviceMemory) return null;
    return {
        // @ts-ignore
        "event:memory": navigator.deviceMemory
    };
});

});

parcelRegister("OrkUx", function(module, exports) {

$parcel$export(module.exports, "eventNetworkPlugin", function () { return $0979e00a6fbfc0fd$export$ce1cf816dce1da56; });
var $0979e00a6fbfc0fd$export$ce1cf816dce1da56 = function eventNetworkPlugin() {
    // @ts-ignore: connection is available in some browsers
    // eslint-disable-next-line compat/compat
    if (!navigator.connection) return null;
    return {
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        "event:network:effectiveType": navigator.connection.effectiveType,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        "event:network:rtt": navigator.connection.rtt,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        "event:network:downlink": navigator.connection.downlink
    };
};

});

parcelRegister("64z5l", function(module, exports) {

$parcel$export(module.exports, "ssrFeatureFlags", function () { return $46be54f7168301af$export$fdbea518c19dfa8; });
var $46be54f7168301af$export$fdbea518c19dfa8 = function ssrFeatureFlags(ssr) {
    if (!(ssr !== null && ssr !== void 0 && ssr.getFeatureFlags)) return null;
    try {
        var featureFlags = ssr.getFeatureFlags();
        if (featureFlags) return {
            "ssr:featureFlags": featureFlags
        };
    } catch (e) {}
    return null;
};

});

parcelRegister("bVsra", function(module, exports) {

$parcel$export(module.exports, "ssrSuccess", function () { return $8aeb139da3874569$export$a3dc8251cf55b2e0; });
var $8aeb139da3874569$export$a3dc8251cf55b2e0 = function ssrSuccess(ssr) {
    if (ssr !== null && ssr !== void 0 && ssr.getDoneMark()) return {
        "ssr:success": true
    };
    return null;
};

});

parcelRegister("6aU48", function(module, exports) {

$parcel$export(module.exports, "Route", function () { return $47ef2ab9081c1dc1$export$e7b0ac011bb776c6; });
var $47ef2ab9081c1dc1$export$e7b0ac011bb776c6 = {
    route: "",
    setRoute: function setRoute(newRoute) {
        this.route = newRoute;
    },
    getRoute: function getRoute() {
        return this.route;
    }
};

});



parcelRegister("haFsC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d5c93f0f8037b0ee$export$2e2bcd8739ae039; });
// import type { Route } from "react-resource-router"; // CHANGED: '@atlassian/jira-router';
// CHANGED
// export default function getUFORouteName(route: Route): string {
function $d5c93f0f8037b0ee$export$2e2bcd8739ae039(route) {
    // REMOVED
    // if (route.ufoName != null) {
    //     return route.ufoName;
    // }
    // return route.name;
    // Remove slashes from route string, since we are not using "react-resource-router"
    // and route names are not available
    return route.replace(/^\//, "").replace(/\//g, "-");
}

});

parcelRegister("jpiYS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $df9ef4c5961a7974$export$2e2bcd8739ae039; });
//@ts-ignore

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $c6Xmf = parcelRequire("c6Xmf");

var $1rY3h = parcelRequire("1rY3h");

var $1Mpn7 = parcelRequire("1Mpn7");

var $3rCRi = parcelRequire("3rCRi");

var $ctqcv = parcelRequire("ctqcv");

var $04zLn = parcelRequire("04zLn");

var $dgbe0 = parcelRequire("dgbe0");

var $ismga = parcelRequire("ismga");

var $9WpMx = parcelRequire("9WpMx");

var $4ve2A = parcelRequire("4ve2A");

var $3Og3K = parcelRequire("3Og3K");
/** A portion of the page we apply measurement to */ var $df9ef4c5961a7974$var$UFOSegment = function(param) {
    var segmentName = param.name, children = param.children;
    var parentContext = (0, $1Mpn7.useContext)((0, $ismga.default));
    var segmentId = (0, $1Mpn7.useMemo)(function() {
        return (0, $04zLn.default)();
    }, []);
    var labelStack = (0, $1Mpn7.useMemo)(function() {
        return (parentContext === null || parentContext === void 0 ? void 0 : parentContext.labelStack) ? (0, $c6Xmf._)(parentContext.labelStack).concat([
            {
                name: segmentName,
                segmentId: segmentId
            }
        ]) : [
            {
                name: segmentName,
                segmentId: segmentId
            }
        ];
    }, [
        parentContext,
        segmentName,
        segmentId
    ]);
    // CHANGED
    var interactionId = (0, $1Mpn7.useContext)((0, $9WpMx.default));
    var interactionContext = (0, $1Mpn7.useMemo)(function() {
        (0, $4ve2A.addSegment)(labelStack);
        var lastCompleteEndTime = 0;
        function complete() {
            var endTime = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : performance.now();
            if (interactionId.current) {
                if (parentContext) parentContext.complete();
                else {
                    var capturedInteractionId = interactionId.current;
                    if (endTime > lastCompleteEndTime) lastCompleteEndTime = endTime;
                    (0, $3rCRi.unstable_scheduleCallback)((0, $3rCRi.unstable_NormalPriority), function() {
                        if (capturedInteractionId === interactionId.current) (0, $4ve2A.tryComplete)(interactionId.current, lastCompleteEndTime);
                    });
                }
            }
        }
        function _internalHold(labelStack, name) {
            if (interactionId.current != null) {
                if (parentContext) return parentContext._internalHold(labelStack, name);
                else {
                    var capturedInteractionId = interactionId.current;
                    var disposeHold = (0, $4ve2A.addHold)(interactionId.current, labelStack, name);
                    return function() {
                        if (capturedInteractionId === interactionId.current) disposeHold();
                    };
                }
            }
        }
        function _internalHoldByID(labelStack, id, name, remove) {
            if (interactionId.current != null) {
                if (parentContext) {
                    parentContext._internalHoldByID(labelStack, name, id, remove);
                    return;
                }
                if (!remove) (0, $4ve2A.addHoldByID)(interactionId.current, labelStack, name, id);
                else (0, $4ve2A.removeHoldByID)(interactionId.current, id);
            }
        }
        if (parentContext) return (0, $cxjpp._)((0, $do9pw._)({}, parentContext), {
            labelStack: labelStack,
            complete: complete
        });
        return {
            labelStack: labelStack,
            hold: function() {
                var name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "unknown";
                // eslint-disable-next-line react/no-this-in-sfc
                return this._internalHold(this.labelStack, name);
            },
            addHoldByID: function(labelStack, id) {
                var name = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "unknown";
                // eslint-disable-next-line react/no-this-in-sfc
                this._internalHoldByID(labelStack, id, name, false);
            },
            removeHoldByID: function(labelStack, id) {
                var name = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "unknown";
                // eslint-disable-next-line react/no-this-in-sfc
                this._internalHoldByID(labelStack, id, name, true);
            },
            tracePress: function() {
                var name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "unknown", timestamp = arguments.length > 1 ? arguments[1] : void 0;
                if (interactionId.current != null) (0, $4ve2A.abortByNewInteraction)(interactionId.current, name);
                var rate = (0, $dgbe0.getInteractionRate)(name, "press");
                if ((0, $ctqcv.default)(rate)) {
                    var startTimestamp = timestamp !== null && timestamp !== void 0 ? timestamp : performance.now();
                    var newId = (0, $04zLn.default)();
                    interactionId.current = newId;
                    (0, $4ve2A.addNewInteraction)(newId, name, "press", startTimestamp, rate, // eslint-disable-next-line react/no-this-in-sfc
                    this.labelStack, (0, $3Og3K.default).current);
                }
            },
            retainQuery: function(info) {
                if (interactionId.current != null) // eslint-disable-next-line react/no-this-in-sfc
                (0, $4ve2A.addRequestInfo)(interactionId.current, this.labelStack, info);
            },
            addPreload: function(moduleId, timestamp) {
                if (interactionId.current != null) (0, $4ve2A.addMark)(interactionId.current, "bundle_preload", moduleId, // eslint-disable-next-line react/no-this-in-sfc
                this.labelStack, timestamp);
            },
            addLoad: function(identifier, start, end) {
                if (interactionId.current != null) {
                    var _this = this, _this_labelStack = _this.labelStack, labelStack = _this_labelStack === void 0 ? [] : _this_labelStack;
                    (0, $4ve2A.addSpan)(interactionId.current, "bundle_load", identifier, labelStack, start, end);
                }
            },
            addMark: function(name, timestamp) {
                if (interactionId.current != null) {
                    var time = timestamp !== null && timestamp !== void 0 ? timestamp : performance.now();
                    // eslint-disable-next-line react/no-this-in-sfc
                    (0, $4ve2A.addMark)(interactionId.current, "custom", name, this.labelStack, time);
                }
            },
            addCustomData: function(customData) {
                if (interactionId.current != null) // eslint-disable-next-line react/no-this-in-sfc
                (0, $4ve2A.addCustomData)(interactionId.current, this.labelStack, customData);
            },
            addCustomTimings: function(customTimings) {
                if (interactionId.current != null) // eslint-disable-next-line react/no-this-in-sfc
                (0, $4ve2A.addCustomTiming)(interactionId.current, this.labelStack, customTimings);
            },
            addApdex: function(apdexInfo) {
                if (interactionId.current != null) {
                    var key = apdexInfo.key, stopTime = apdexInfo.stopTime;
                    // eslint-disable-next-line react/no-this-in-sfc
                    (0, $4ve2A.addApdex)(interactionId.current, {
                        key: key,
                        stopTime: stopTime,
                        labelStack: this.labelStack
                    });
                }
            },
            onRender: function(phase, actualDuration, baseDuration, startTime, commitTime) {
                if (interactionId.current !== null) {
                    (0, $4ve2A.addProfilerTimings)(interactionId.current, // eslint-disable-next-line react/no-this-in-sfc
                    this.labelStack, phase, actualDuration, baseDuration, startTime, commitTime);
                    // eslint-disable-next-line react/no-this-in-sfc
                    this.complete(commitTime);
                }
            },
            _internalHold: _internalHold,
            _internalHoldByID: _internalHoldByID,
            complete: complete
        };
    }, [
        parentContext,
        labelStack,
        interactionId
    ]);
    var onRender = (0, $1Mpn7.useCallback)(function(_id, phase, actualDuration, baseDuration, startTime, commitTime) {
        interactionContext.onRender(phase, actualDuration, baseDuration, startTime, commitTime);
    }, [
        interactionContext
    ]);
    // const relayProfilerContext = useMemo(
    //     () => ({
    //         wrapPrepareQueryResource<T>(cb: () => T): T {
    //             return cb();
    //         },
    //         retainQuery(info: RequestInfo) {
    //             interactionContext.retainQuery(info);
    //         }
    //     }),
    //     [interactionContext]
    // );
    (0, $1Mpn7.useEffect)(function() {
        return function() {
            (0, $4ve2A.removeSegment)(labelStack);
        };
    }, [
        interactionId,
        parentContext,
        interactionContext,
        labelStack
    ]);
    // const reactLooselyLazyContext = useMemo(() => {
    //     const moduleLoadingRequests: {
    //         [key: string]: {
    //             start: number;
    //             timeoutId: ReturnType<typeof setTimeout> | number | undefined;
    //         };
    //     } = {};
    //     return {
    //         current: {
    //             onPreload(moduleId: string, _priority?: number) {
    //                 interactionContext.addPreload(
    //                     extractModuleName(moduleId),
    //                     performance.now()
    //                 );
    //             },
    //             onLoadStart(info: EventInfo): void {
    //                 const timeoutId = setTimeout(() => {
    //                     delete moduleLoadingRequests[info.identifier];
    //                 }, 30000);
    //                 const request = {
    //                     start: performance.now(),
    //                     timeoutId
    //                 };
    //                 moduleLoadingRequests[info.identifier] = request;
    //             },
    //             onLoadComplete(info: EventInfo): void {
    //                 const request = moduleLoadingRequests[info.identifier];
    //                 if (request) {
    //                     clearTimeout(request.timeoutId);
    //                     delete moduleLoadingRequests[info.identifier];
    //                     interactionContext?.addLoad(
    //                         extractModuleName(info.identifier),
    //                         request.start,
    //                         performance.now()
    //                     );
    //                 }
    //             },
    //             placeholderFallBackMounted(
    //                 id: string,
    //                 name?: string,
    //                 lazyWait?: boolean
    //             ): void {
    //                 if (lazyWait) {
    //                     return;
    //                 }
    //                 interactionContext.addHoldByID(labelStack, id, name);
    //             },
    //             placeholderFallBackUnmounted(
    //                 id: string,
    //                 name?: string,
    //                 lazyWait?: boolean
    //             ): void {
    //                 if (lazyWait) {
    //                     return;
    //                 }
    //                 interactionContext.removeHoldByID(labelStack, id, name);
    //             }
    //         }
    //     };
    // }, [interactionContext, labelStack]);
    // CHANGED
    var reactProfilerId = (0, $1Mpn7.useMemo)(function() {
        return labelStack.map(function(l) {
            return l.name;
        }).join("/");
    }, [
        labelStack
    ]);
    return /*#__PURE__*/ (0, $1rY3h.jsx)((0, $ismga.default).Provider, {
        value: interactionContext,
        children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $1Mpn7.Profiler), {
            id: reactProfilerId,
            onRender: onRender,
            children: children
        })
    });
};
var $df9ef4c5961a7974$export$2e2bcd8739ae039 = $df9ef4c5961a7974$var$UFOSegment;

});
parcelRegister("ctqcv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93ce740f71bebe12$export$2e2bcd8739ae039; });

var $7WT0c = parcelRequire("7WT0c");
function $93ce740f71bebe12$export$2e2bcd8739ae039(rate) {
    if (rate === 0) return false;
    else if (rate === 1) return true;
    else return (0, $7WT0c.default)() * rate <= 1;
}

});
parcelRegister("7WT0c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b84d66c905f6faaa$export$2e2bcd8739ae039; });
// code-reaper-ignore-file -- Alternative implementation of random numbers for the browser.
var $b84d66c905f6faaa$var$MAX_UINT32 = 4294967296;
function $b84d66c905f6faaa$export$2e2bcd8739ae039() {
    try {
        var buf = new Uint32Array(1);
        // buf now has a random uint32 value
        window.crypto.getRandomValues(buf);
        // Turn it back into a value in [0,1)
        if (buf[0]) return buf[0] / $b84d66c905f6faaa$var$MAX_UINT32;
        else throw Error("Object  buf[0] is 'undefined'. random()");
    } catch (e) {
        return Math.random();
    }
}

});


parcelRegister("04zLn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e5597cadc4b6d94$export$2e2bcd8739ae039; });
function $5e5597cadc4b6d94$export$2e2bcd8739ae039() {
    var length = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 7;
    var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var result = "";
    for(var i = 0; i < length; i++)result += characters.charAt(Math.floor(Math.random() * characters.length));
    return result;
}

});

parcelRegister("dgbe0", function(module, exports) {

$parcel$export(module.exports, "getInteractionRate", function () { return $75ec7d5dc4b080b4$export$9466a8f085fa7d4e; });
$parcel$export(module.exports, "getCapabilityRate", function () { return $75ec7d5dc4b080b4$export$29b9ffb14861a1d; });
$parcel$export(module.exports, "getAwaitBM3TTIList", function () { return $75ec7d5dc4b080b4$export$2d311b3fd18dcab1; });
$parcel$export(module.exports, "getRemovePageSegmentsUFOPrefixes", function () { return $75ec7d5dc4b080b4$export$e2ea675800536898; });
$parcel$export(module.exports, "getRemoveInteractionsUFOPrefixes", function () { return $75ec7d5dc4b080b4$export$525ba53ca98e9db; });
$parcel$export(module.exports, "getUfoNameOverrides", function () { return $75ec7d5dc4b080b4$export$4f4649ef27b6f5d6; });
// import { getUFOConfig } from './feature-flags';
var $75ec7d5dc4b080b4$var$config = {
    removePageSegmentsUFOPrefixes: false,
    killswitch: [],
    rates: {
    },
    kind: {
        legacy: 1,
        page_load: 1,
        press: 1,
        transition: 1,
        typing: 0
    },
    awaitBM3TTI: [],
    rules: [],
    capability: {
        feature_flag_access: 100,
        react_profiler: 1
    },
    typingMethod: "timeout",
    removeInteractionsUFOPrefixes: true
};
function $75ec7d5dc4b080b4$export$9466a8f085fa7d4e(name, interactionKind) {
    try {
        // REMOVED: const config: Config = getUFOConfig();
        var killswitch = $75ec7d5dc4b080b4$var$config.killswitch, rates = $75ec7d5dc4b080b4$var$config.rates, rules = $75ec7d5dc4b080b4$var$config.rules, kind = $75ec7d5dc4b080b4$var$config.kind;
        if (killswitch != null) {
            // Specifically kill certain events
            if (killswitch.includes(name)) return 0;
        }
        if (rates != null) // Decide the rate explicitly
        {
            if (rates[name] != null) {
                var ratesName = rates[name];
                if (ratesName) return ratesName;
            }
        }
        if (rules != null) // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(var i = 0; i < rules.length; i++){
            var rule = rules[i];
            if (rule) {
                var test = rule.test, rate = rule.rate;
                if (test != null && rate != null) {
                    var regexp = new RegExp(test, "ig");
                    if (regexp.test(name)) return rate;
                }
            }
        }
        if (kind != null) {
            var rate1 = kind[interactionKind];
            if (rate1 != null) return rate1;
        }
        return 0;
    } catch (e) {
        // Fallback
        return 0;
    }
}
function $75ec7d5dc4b080b4$export$29b9ffb14861a1d(capability) {
    try {
        // REMOVED: const config: Config = getUFOConfig();
        var capabilityRate = $75ec7d5dc4b080b4$var$config.capability;
        if (capabilityRate != null) {
            var rate = capabilityRate[capability];
            if (rate != null) return rate;
        }
        return 0;
    } catch (e) {
        return 0;
    }
}
var $75ec7d5dc4b080b4$var$validTypingMethods = [
    "timeout",
    "timeoutNoAlloc",
    "mutationObserver"
];
function $75ec7d5dc4b080b4$export$7e32aae12bf9b50f() {
    var defaultMethod = "timeout";
    try {
        // REMOVED: const config: Config = getUFOConfig();
        var typingMethod = $75ec7d5dc4b080b4$var$config.typingMethod;
        if (typingMethod != null && $75ec7d5dc4b080b4$var$validTypingMethods.find(function(m) {
            return m === typingMethod;
        })) return typingMethod;
        else return defaultMethod;
    } catch (e) {
        return defaultMethod;
    }
}
function $75ec7d5dc4b080b4$export$2d311b3fd18dcab1() {
    try {
        // REMOVED: const config: Config = getUFOConfig();
        var awaitBM3TTI = $75ec7d5dc4b080b4$var$config.awaitBM3TTI;
        if (awaitBM3TTI != null) return awaitBM3TTI;
        else return [];
    } catch (e) {
        return [];
    }
}
function $75ec7d5dc4b080b4$export$e2ea675800536898() {
    try {
        // REMOVED: const config: Config = getUFOConfig();
        var removePageSegmentsUFOPrefixes = $75ec7d5dc4b080b4$var$config.removePageSegmentsUFOPrefixes;
        if (removePageSegmentsUFOPrefixes != null) return removePageSegmentsUFOPrefixes;
        else return false;
    } catch (e) {
        return false;
    }
}
function $75ec7d5dc4b080b4$export$525ba53ca98e9db() {
    try {
        // REMOVED: const config: Config = getUFOConfig();;
        var removeInteractionsUFOPrefixes = $75ec7d5dc4b080b4$var$config.removeInteractionsUFOPrefixes;
        if (removeInteractionsUFOPrefixes != null) return removeInteractionsUFOPrefixes;
        else return false;
    } catch (e) {
        return false;
    }
}
function $75ec7d5dc4b080b4$export$4f4649ef27b6f5d6() {
    try {
        // REMOVED: const config: Config = getUFOConfig();
        var ufoNameOverrides = $75ec7d5dc4b080b4$var$config.ufoNameOverrides;
        if (ufoNameOverrides != null) return ufoNameOverrides;
        return undefined;
    } catch (e) {
        return undefined;
    }
}

});

parcelRegister("ismga", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a4743a4ba07f8e7$export$2e2bcd8739ae039; });

var $1Mpn7 = parcelRequire("1Mpn7");

var $f3uqe = parcelRequire("f3uqe");
var $0a4743a4ba07f8e7$export$2e2bcd8739ae039 = (0, $f3uqe.default);
function $0a4743a4ba07f8e7$export$11bcb6e9af2aca35() {
    return (0, $1Mpn7.useContext)((0, $f3uqe.default));
}

});
parcelRegister("f3uqe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af5ebc0aa324e9c0$export$2e2bcd8739ae039; });

var $1Mpn7 = parcelRequire("1Mpn7");
var $af5ebc0aa324e9c0$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $1Mpn7.createContext)(null);

});


parcelRegister("9WpMx", function(module, exports) {

$parcel$export(module.exports, "DefaultInteractionID", function () { return $9aa37525774ab960$export$3109542b68df9ba1; });
$parcel$export(module.exports, "default", function () { return $9aa37525774ab960$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "getInteractionId", function () { return $9aa37525774ab960$export$37bca3107733ac1e; });

var $1Mpn7 = parcelRequire("1Mpn7");
var $9aa37525774ab960$export$3109542b68df9ba1 = {
    current: null
};
var // We use a context to allow modals to have their own lifecycle
$9aa37525774ab960$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $1Mpn7.createContext)($9aa37525774ab960$export$3109542b68df9ba1);
var $9aa37525774ab960$export$37bca3107733ac1e = function() {
    return $9aa37525774ab960$export$3109542b68df9ba1;
};
var $9aa37525774ab960$export$9f6000531b78127e = function() {
    return $9aa37525774ab960$export$3109542b68df9ba1;
};

});

parcelRegister("4ve2A", function(module, exports) {

$parcel$export(module.exports, "addCustomData", function () { return $4e9a58cf3a4cc422$export$e4380431c2bdabee; });
$parcel$export(module.exports, "addCustomTiming", function () { return $4e9a58cf3a4cc422$export$27cacb7d7f3fe20a; });
$parcel$export(module.exports, "addMark", function () { return $4e9a58cf3a4cc422$export$728e28c22a0fba4; });
$parcel$export(module.exports, "addSpan", function () { return $4e9a58cf3a4cc422$export$2c1d6e17cfa9bbc7; });
$parcel$export(module.exports, "addHold", function () { return $4e9a58cf3a4cc422$export$7606887303596f82; });
$parcel$export(module.exports, "addHoldByID", function () { return $4e9a58cf3a4cc422$export$10582acd678c213; });
$parcel$export(module.exports, "removeHoldByID", function () { return $4e9a58cf3a4cc422$export$4983dfbbb996f7ae; });
$parcel$export(module.exports, "addError", function () { return $4e9a58cf3a4cc422$export$239c33984d9b1367; });
$parcel$export(module.exports, "addErrorToAll", function () { return $4e9a58cf3a4cc422$export$7379c15afd3840fa; });
$parcel$export(module.exports, "addProfilerTimings", function () { return $4e9a58cf3a4cc422$export$53d6f611de951a13; });
$parcel$export(module.exports, "sinkInteractionHandler", function () { return $4e9a58cf3a4cc422$export$9e614a29a1ac213e; });
$parcel$export(module.exports, "tryComplete", function () { return $4e9a58cf3a4cc422$export$673be905888f8839; });
$parcel$export(module.exports, "abort", function () { return $4e9a58cf3a4cc422$export$5def58af4fd46132; });
$parcel$export(module.exports, "abortByNewInteraction", function () { return $4e9a58cf3a4cc422$export$c4a545284f55edf2; });
$parcel$export(module.exports, "addNewInteraction", function () { return $4e9a58cf3a4cc422$export$1a1ed1e1fdb2006b; });
$parcel$export(module.exports, "addApdex", function () { return $4e9a58cf3a4cc422$export$35220fd6cdd1b731; });
$parcel$export(module.exports, "addRequestInfo", function () { return $4e9a58cf3a4cc422$export$57d55b4569823d8f; });
$parcel$export(module.exports, "addSegment", function () { return $4e9a58cf3a4cc422$export$1c43f9ac826b6462; });
$parcel$export(module.exports, "removeSegment", function () { return $4e9a58cf3a4cc422$export$d0365e48b58231c3; });

var $3sHb8 = parcelRequire("3sHb8");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $cZ38z = parcelRequire("cZ38z");

var $ctqcv = parcelRequire("ctqcv");

var $dgbe0 = parcelRequire("dgbe0");

var $ghVTP = parcelRequire("ghVTP");

var $3O6IZ = parcelRequire("3O6IZ");

var $9WpMx = parcelRequire("9WpMx");

var $c24i9 = parcelRequire("c24i9");
var $4e9a58cf3a4cc422$var$PreviousInteractionLog = {
    name: undefined
};
var $4e9a58cf3a4cc422$var$interactionQueue = [];
var $4e9a58cf3a4cc422$var$segmentCache = new Map();
var $4e9a58cf3a4cc422$var$CLEANUP_TIMEOUT = 60000;
var $4e9a58cf3a4cc422$var$CLEANUP_TIMEOUT_AFTER_APDEX = 15000;
var $4e9a58cf3a4cc422$var$segmentObservers = [];
function $4e9a58cf3a4cc422$var$addSegmentObserver(observer) {
    $4e9a58cf3a4cc422$var$segmentObservers.push(observer);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $4e9a58cf3a4cc422$var$segmentCache.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var segmentInfo = _step.value;
            observer.onAdd(segmentInfo);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function $4e9a58cf3a4cc422$var$removeSegmentObserver(observer) {
    var index = $4e9a58cf3a4cc422$var$segmentObservers.findIndex(function(obs) {
        return obs === observer;
    });
    if (index !== -1) $4e9a58cf3a4cc422$var$segmentObservers.splice(index, 1);
}
function $4e9a58cf3a4cc422$export$cd7f480d6b8286c3(interactionId) {
    (0, $c24i9.default).delete(interactionId);
}
function $4e9a58cf3a4cc422$export$12f2b6cb85d59904(interactionId, data) {
    var interaction = (0, $c24i9.default).get(interactionId);
    if (interaction != null) Object.keys(data).forEach(function(key) {
        interaction.metaData[key] = data[key];
    });
}
function $4e9a58cf3a4cc422$export$e4380431c2bdabee(interactionId, labelStack, data) {
    var interaction = (0, $c24i9.default).get(interactionId);
    if (interaction != null) Object.keys(data).forEach(function(i) {
        interaction.customData.push({
            labelStack: labelStack,
            data: (0, $3sHb8._)({}, i, data[i])
        });
    });
}
function $4e9a58cf3a4cc422$export$27cacb7d7f3fe20a(interactionId, labelStack, data) {
    var interaction = (0, $c24i9.default).get(interactionId);
    if (interaction != null) interaction.customTimings.push({
        labelStack: labelStack,
        data: data
    });
}
function $4e9a58cf3a4cc422$export$728e28c22a0fba4(interactionId, type, name, labelStack) {
    var time = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : performance.now();
    var interaction = (0, $c24i9.default).get(interactionId);
    if (interaction != null) interaction.marks.push({
        type: type,
        name: name,
        labelStack: labelStack,
        time: time
    });
}
function $4e9a58cf3a4cc422$export$c4b23cc624bd2fb(type, name, labelStack) {
    var time = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : performance.now();
    (0, $c24i9.default).forEach(function(interaction) {
        interaction.marks.push({
            type: type,
            name: name,
            labelStack: labelStack,
            time: time
        });
    });
}
function $4e9a58cf3a4cc422$export$2c1d6e17cfa9bbc7(interactionId, type, name, labelStack, start) {
    var end = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : performance.now(), size = arguments.length > 6 ? arguments[6] : void 0;
    var interaction = (0, $c24i9.default).get(interactionId);
    if (interaction != null) interaction.spans.push({
        type: type,
        name: name,
        labelStack: labelStack,
        start: start,
        end: end,
        size: size
    });
}
function $4e9a58cf3a4cc422$export$943a8b2b5d6b1809(type, name, labelStack, start) {
    var end = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : performance.now(), size = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0;
    (0, $c24i9.default).forEach(function(interaction) {
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
    });
}
function $4e9a58cf3a4cc422$export$9e04fe1a58571ec(moduleId, timestamp) {
    $4e9a58cf3a4cc422$export$c4b23cc624bd2fb("bundle_preload", moduleId, null, timestamp);
}
function $4e9a58cf3a4cc422$export$6f228d1fdc911d7(identifier, start, end) {
    $4e9a58cf3a4cc422$export$943a8b2b5d6b1809("bundle_load", identifier, null, start, end - start);
}
var $4e9a58cf3a4cc422$var$moduleLoadingRequests = {};
function $4e9a58cf3a4cc422$export$f5a8f10de74904da(input) {
    var result = input !== null && input !== void 0 ? input : "";
    result = result.replace(/^\.\/src\/packages\//, "");
    result = result.replace(/^\.\/node_modules\//, "");
    result = result.replace(/(\/src)?\/(index|main)\.(tsx|ts|js|jsx)$/, "");
    return result;
}
function $4e9a58cf3a4cc422$export$7606887303596f82(interactionId, labelStack, name) {
    var interaction = (0, $c24i9.default).get(interactionId);
    var id = (0, $cZ38z.default)();
    if (interaction != null) {
        var start = performance.now();
        interaction.holdActive.set(id, {
            labelStack: labelStack,
            name: name,
            start: start
        });
        return function() {
            var end = performance.now();
            var currentInteraction = (0, $c24i9.default).get(interactionId);
            var currentHold = interaction.holdActive.get(id);
            if (currentInteraction != null && currentHold != null) {
                currentInteraction.holdInfo.push((0, $cxjpp._)((0, $do9pw._)({}, currentHold), {
                    end: end
                }));
                interaction.holdActive.delete(id);
            }
        };
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    return function() {};
}
function $4e9a58cf3a4cc422$export$10582acd678c213(interactionId, labelStack, name, id, ignoreOnSubmit) {
    var interaction = (0, $c24i9.default).get(interactionId);
    if (interaction != null) {
        var start = performance.now();
        interaction.holdActive.set(id, {
            labelStack: labelStack,
            name: name,
            start: start,
            ignoreOnSubmit: ignoreOnSubmit
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    return function() {};
}
function $4e9a58cf3a4cc422$export$4983dfbbb996f7ae(interactionId, id) {
    var interaction = (0, $c24i9.default).get(interactionId);
    if (interaction != null) {
        var end = performance.now();
        var currentInteraction = (0, $c24i9.default).get(interactionId);
        var currentHold = interaction.holdActive.get(id);
        if (currentInteraction != null && currentHold != null) {
            currentInteraction.holdInfo.push((0, $cxjpp._)((0, $do9pw._)({}, currentHold), {
                end: end
            }));
            interaction.holdActive.delete(id);
        }
    }
}
function $4e9a58cf3a4cc422$export$2df109852219d16e(interactionId) {
    var interaction = (0, $c24i9.default).get(interactionId);
    if (interaction) return interaction.type;
    return null;
}
var $4e9a58cf3a4cc422$export$9591b52b33ccc510 = {
    onPreload: function(moduleId, _priority) {
        $4e9a58cf3a4cc422$export$9e04fe1a58571ec($4e9a58cf3a4cc422$export$f5a8f10de74904da(moduleId), performance.now());
    },
    onLoadStart: function(info) {
        var timeoutId = setTimeout(function() {
            delete $4e9a58cf3a4cc422$var$moduleLoadingRequests[info.identifier];
        }, 30000);
        var request = {
            start: performance.now(),
            timeoutId: timeoutId
        };
        $4e9a58cf3a4cc422$var$moduleLoadingRequests[info.identifier] = request;
    },
    onLoadComplete: function(info) {
        var request = $4e9a58cf3a4cc422$var$moduleLoadingRequests[info.identifier];
        if (request) {
            clearTimeout(request.timeoutId);
            delete $4e9a58cf3a4cc422$var$moduleLoadingRequests[info.identifier];
            $4e9a58cf3a4cc422$export$6f228d1fdc911d7($4e9a58cf3a4cc422$export$f5a8f10de74904da(info.identifier), request.start, performance.now());
        }
    },
    placeholderFallBackMounted: function(id, moduleId) {
        var interactionId = (0, $9WpMx.getInteractionId)();
        var currentInteractionId = interactionId.current;
        if (currentInteractionId) $4e9a58cf3a4cc422$export$10582acd678c213(currentInteractionId, [], moduleId, id);
    },
    placeholderFallBackUnmounted: function(id) {
        var interactionId = (0, $9WpMx.getInteractionId)();
        var currentInteractionId = interactionId.current;
        if (currentInteractionId) $4e9a58cf3a4cc422$export$4983dfbbb996f7ae(currentInteractionId, id);
    }
};
function $4e9a58cf3a4cc422$export$239c33984d9b1367(interactionId, name, labelStack, errorType, errorMessage, errorStack) {
    var interaction = (0, $c24i9.default).get(interactionId);
    if (interaction != null) interaction.errors.push({
        name: name,
        labelStack: labelStack,
        errorType: errorType,
        errorMessage: errorMessage,
        errorStack: errorStack
    });
}
function $4e9a58cf3a4cc422$export$7379c15afd3840fa(name, labelStack, errorType, errorMessage, errorStack) {
    (0, $c24i9.default).forEach(function(interaction) {
        interaction.errors.push({
            name: name,
            labelStack: labelStack,
            errorType: errorType,
            errorMessage: errorMessage,
            errorStack: errorStack
        });
    });
}
var $4e9a58cf3a4cc422$export$53d6f611de951a13 = function(interactionId, labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
    var interaction = (0, $c24i9.default).get(interactionId);
    if (interaction != null) interaction.reactProfilerTimings.push({
        labelStack: labelStack,
        type: type,
        actualDuration: actualDuration,
        baseDuration: baseDuration,
        startTime: startTime,
        commitTime: commitTime
    });
};
var $4e9a58cf3a4cc422$var$pushToQueue = function(id, data) {
    $4e9a58cf3a4cc422$var$interactionQueue.push({
        id: id,
        data: data
    });
};
var $4e9a58cf3a4cc422$var$handleInteraction = $4e9a58cf3a4cc422$var$pushToQueue;
function $4e9a58cf3a4cc422$var$callCleanUpCallbacks(interaction) {
    interaction.cleanupCallbacks.reverse().forEach(function(cleanUpCallback) {
        cleanUpCallback();
    });
}
var $4e9a58cf3a4cc422$var$finishInteraction = function(id, data) {
    var endTime = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : performance.now();
    // eslint-disable-next-line no-param-reassign
    data.end = endTime;
    if (data.featureFlags) // eslint-disable-next-line no-param-reassign
    data.featureFlags.during = Object.fromEntries((0, $3O6IZ.currentFeatureFlagsAccessed));
    (0, $ghVTP.clearActiveTrace)();
    $4e9a58cf3a4cc422$var$callCleanUpCallbacks(data);
    $4e9a58cf3a4cc422$export$cd7f480d6b8286c3(id);
    $4e9a58cf3a4cc422$var$PreviousInteractionLog.name = data.ufoName;
    $4e9a58cf3a4cc422$var$handleInteraction(id, data);
};
var $4e9a58cf3a4cc422$export$9e614a29a1ac213e = function(sinkFn) {
    if ($4e9a58cf3a4cc422$var$handleInteraction === $4e9a58cf3a4cc422$var$pushToQueue) {
        $4e9a58cf3a4cc422$var$handleInteraction = sinkFn;
        $4e9a58cf3a4cc422$var$interactionQueue.forEach(function(interaction) {
            sinkFn(interaction.id, interaction.data);
        });
        $4e9a58cf3a4cc422$var$interactionQueue.length = 0;
    }
};
function $4e9a58cf3a4cc422$export$673be905888f8839(interactionId, endTime) {
    var interaction = (0, $c24i9.default).get(interactionId);
    if (interaction != null) {
        var noMoreHolds = interaction.holdActive.size === 0;
        if (noMoreHolds) $4e9a58cf3a4cc422$var$finishInteraction(interactionId, interaction, endTime);
    }
}
function $4e9a58cf3a4cc422$var$callCancelCallbacks(interaction) {
    interaction.cancelCallbacks.reverse().forEach(function(cancelCallback) {
        cancelCallback();
    });
}
function $4e9a58cf3a4cc422$export$5def58af4fd46132(interactionId, abortReason) {
    var interaction = (0, $c24i9.default).get(interactionId);
    if (interaction != null) {
        $4e9a58cf3a4cc422$var$callCancelCallbacks(interaction);
        interaction.abortReason = abortReason;
        $4e9a58cf3a4cc422$var$finishInteraction(interactionId, interaction);
    }
}
function $4e9a58cf3a4cc422$export$c4a545284f55edf2(interactionId, interactionName) {
    var interaction = (0, $c24i9.default).get(interactionId);
    if (interaction != null) {
        $4e9a58cf3a4cc422$var$callCancelCallbacks(interaction);
        interaction.abortReason = "new_interaction";
        interaction.abortedByInteractionName = interactionName;
        $4e9a58cf3a4cc422$var$finishInteraction(interactionId, interaction);
    }
}
function $4e9a58cf3a4cc422$export$614a7af2affc5dff(abortReason, abortedByInteractionName) {
    (0, $c24i9.default).forEach(function(interaction, interactionId) {
        $4e9a58cf3a4cc422$var$callCancelCallbacks(interaction);
        // eslint-disable-next-line no-param-reassign
        interaction.abortReason = abortReason;
        if (abortedByInteractionName != null) // eslint-disable-next-line no-param-reassign
        interaction.abortedByInteractionName = abortedByInteractionName;
        $4e9a58cf3a4cc422$var$finishInteraction(interactionId, interaction);
    });
}
function $4e9a58cf3a4cc422$export$7b9261a96cfe427b(id, cancelCallback) {
    var interaction = (0, $c24i9.default).get(id);
    interaction === null || interaction === void 0 ? void 0 : interaction.cancelCallbacks.push(cancelCallback);
}
function $4e9a58cf3a4cc422$export$1a1ed1e1fdb2006b(interactionId, ufoName, type, startTime, rate, labelStack, routeName) {
    var trace = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : null;
    var previousTime = startTime;
    var timeoutTime = $4e9a58cf3a4cc422$var$CLEANUP_TIMEOUT;
    var timerID = setTimeout(function() {
        $4e9a58cf3a4cc422$export$5def58af4fd46132(interactionId, "timeout");
    }, $4e9a58cf3a4cc422$var$CLEANUP_TIMEOUT);
    function changeTimeout(newTime) {
        // we compare if the time left is lower than the new time to no
        // extend the timeout beyond the initial waiting time
        var currentTime = performance.now();
        var timeLeft = timeoutTime - (currentTime - previousTime);
        if (timeLeft < newTime) return;
        clearTimeout(this.timerID);
        var newTimerID = setTimeout(function() {
            $4e9a58cf3a4cc422$export$5def58af4fd46132(interactionId, "timeout");
        }, newTime);
        timeoutTime = newTime;
        previousTime = currentTime;
        this.timerID = newTimerID;
    }
    var addFeatureFlagsToInteraction = (0, $ctqcv.default)((0, $dgbe0.getCapabilityRate)("feature_flag_access"));
    var metrics = {
        start: startTime,
        end: 0,
        ufoName: ufoName,
        type: type,
        previousInteractionName: $4e9a58cf3a4cc422$var$PreviousInteractionLog.name,
        marks: [],
        customData: [],
        customTimings: [],
        spans: [],
        requestInfo: [],
        reactProfilerTimings: [],
        holdInfo: [],
        holdActive: new Map(),
        // measure when we execute this code
        // from this we can measure the input delay -
        // how long the browser took to hand execution back to JS)
        measureStart: performance.now(),
        rate: rate,
        cancelCallbacks: [],
        metaData: {},
        errors: [],
        apdex: [],
        labelStack: labelStack,
        routeName: routeName !== null && routeName !== void 0 ? routeName : ufoName,
        featureFlags: addFeatureFlagsToInteraction ? {
            prior: Object.fromEntries((0, $3O6IZ.allFeatureFlagsAccessed)),
            during: {}
        } : undefined,
        knownSegments: [],
        cleanupCallbacks: [],
        awaitReactProfilerCount: 0,
        redirects: [],
        timerID: timerID,
        changeTimeout: changeTimeout,
        trace: trace
    };
    if (addFeatureFlagsToInteraction) (0, $3O6IZ.currentFeatureFlagsAccessed).clear();
    (0, $c24i9.default).set(interactionId, metrics);
    var segmentObserver = {
        onAdd: function(segment) {
            metrics.knownSegments.push(segment);
        },
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onRemove: function() {}
    };
    $4e9a58cf3a4cc422$var$addSegmentObserver(segmentObserver);
    metrics.cleanupCallbacks.push(function() {
        $4e9a58cf3a4cc422$var$removeSegmentObserver(segmentObserver);
    });
    metrics.cleanupCallbacks.push(function() {
        clearTimeout(metrics.timerID);
    });
    var awaitBM3TTIList = (0, $dgbe0.getAwaitBM3TTIList)();
    if (awaitBM3TTIList.includes(ufoName)) $4e9a58cf3a4cc422$export$10582acd678c213(interactionId, [], ufoName, ufoName, true);
}
function $4e9a58cf3a4cc422$export$ad216cc25852d44b(apdex) {
    (0, $c24i9.default).forEach(function(interaction, key) {
        interaction.apdex.push(apdex);
        interaction.changeTimeout($4e9a58cf3a4cc422$var$CLEANUP_TIMEOUT_AFTER_APDEX);
        $4e9a58cf3a4cc422$export$4983dfbbb996f7ae(key, interaction.ufoName);
    });
}
function $4e9a58cf3a4cc422$export$35220fd6cdd1b731(interactionId, apdexInfo) {
    var interaction = (0, $c24i9.default).get(interactionId);
    if (interaction != null) {
        interaction.apdex.push(apdexInfo);
        interaction.changeTimeout($4e9a58cf3a4cc422$var$CLEANUP_TIMEOUT_AFTER_APDEX);
        $4e9a58cf3a4cc422$export$4983dfbbb996f7ae(interactionId, interaction.ufoName);
    }
}
function $4e9a58cf3a4cc422$export$57d55b4569823d8f(interactionId, labelStack, requestInfo) {
    var interaction = (0, $c24i9.default).get(interactionId);
    if (interaction != null) interaction.requestInfo.push((0, $do9pw._)({
        labelStack: labelStack
    }, requestInfo));
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $4e9a58cf3a4cc422$var$isSegmentLabel(obj) {
    return obj && typeof obj.name === "string" && typeof obj.segmentId === "string";
}
function $4e9a58cf3a4cc422$var$getSegmentCacheKey(labelStack) {
    return labelStack.map(function(l) {
        if ($4e9a58cf3a4cc422$var$isSegmentLabel(l)) return "".concat(l.name, "_").concat(l.segmentId);
        return l.name;
    }).join("|");
}
function $4e9a58cf3a4cc422$export$1c43f9ac826b6462(labelStack) {
    var key = $4e9a58cf3a4cc422$var$getSegmentCacheKey(labelStack);
    var existingSegment = $4e9a58cf3a4cc422$var$segmentCache.get(key);
    if (!existingSegment) {
        var segmentInfo = {
            labelStack: labelStack
        };
        $4e9a58cf3a4cc422$var$segmentCache.set(key, segmentInfo);
        $4e9a58cf3a4cc422$var$segmentObservers.forEach(function(observer) {
            observer.onAdd(segmentInfo);
        });
    }
}
function $4e9a58cf3a4cc422$export$d0365e48b58231c3(labelStack) {
    var key = $4e9a58cf3a4cc422$var$getSegmentCacheKey(labelStack);
    var segmentInfo = $4e9a58cf3a4cc422$var$segmentCache.get(key);
    if (segmentInfo) {
        $4e9a58cf3a4cc422$var$segmentCache.delete(JSON.stringify(labelStack));
        $4e9a58cf3a4cc422$var$segmentObservers.forEach(function(observer) {
            observer.onRemove(segmentInfo);
        });
    }
}
function $4e9a58cf3a4cc422$export$bbf14d79614d9818(interactionId, fromUfoName, nextUfoName, nextRouteName, time) {
    var interaction = (0, $c24i9.default).get(interactionId);
    if (interaction != null) {
        interaction.ufoName = nextUfoName;
        interaction.routeName = nextRouteName;
        interaction.redirects.push({
            fromInteractionName: fromUfoName,
            time: time
        });
    }
}

});
parcelRegister("ghVTP", function(module, exports) {

$parcel$export(module.exports, "setActiveTrace", function () { return $5f9c03a29f4898f5$export$a1002be327997103; });
$parcel$export(module.exports, "getActiveTrace", function () { return $5f9c03a29f4898f5$export$b6ac780db3a3cc77; });
$parcel$export(module.exports, "clearActiveTrace", function () { return $5f9c03a29f4898f5$export$17ab21d7be720b; });

var $fbpCQ = parcelRequire("fbpCQ");
var $5f9c03a29f4898f5$var$state = {
    context: null
};
var $5f9c03a29f4898f5$export$a1002be327997103 = function(traceId, sampled, spanId, type) {
    $5f9c03a29f4898f5$var$state.context = {
        traceId: traceId,
        sampled: sampled,
        spanId: spanId,
        type: type
    };
};
var $5f9c03a29f4898f5$export$b6ac780db3a3cc77 = function() {
    return $5f9c03a29f4898f5$var$state.context || undefined;
};
var $5f9c03a29f4898f5$export$17ab21d7be720b = function() {
    $5f9c03a29f4898f5$var$state.context = null;
};
var $5f9c03a29f4898f5$export$6e17cce6446848f9 = function(_url) {
    if ($5f9c03a29f4898f5$var$state.context === null) return null;
    var _state_context = $5f9c03a29f4898f5$var$state.context, traceId = _state_context.traceId, sampled = _state_context.sampled, spanId = _state_context.spanId;
    return (0, $fbpCQ.makeTraceHttpRequestHeaders)(traceId, sampled, spanId);
};

});
parcelRegister("fbpCQ", function(module, exports) {

$parcel$export(module.exports, "makeTraceHttpRequestHeaders", function () { return $84eb63d187fec9b2$export$1115c5277eb10d5e; });
var $84eb63d187fec9b2$export$1115c5277eb10d5e = function(traceId, sampled, spanId) {
    return {
        "X-B3-TraceId": traceId,
        "X-B3-Sampled": sampled,
        "X-B3-SpanId": spanId
    };
};

});


parcelRegister("3O6IZ", function(module, exports) {

$parcel$export(module.exports, "allFeatureFlagsAccessed", function () { return $0dd3707f7fd8aa7a$export$5b78c989c8db2561; });
$parcel$export(module.exports, "currentFeatureFlagsAccessed", function () { return $0dd3707f7fd8aa7a$export$2a5c8df26bb89760; });

var $6HSjh = parcelRequire("6HSjh");
var $0dd3707f7fd8aa7a$export$5b78c989c8db2561 = new Map();
var $0dd3707f7fd8aa7a$export$2a5c8df26bb89760 = new Map();
var $0dd3707f7fd8aa7a$export$47fade9662f71000 = function(featureFlagName, featureFlagValue) {
    var value = (0, $6HSjh.redactValue)(featureFlagValue);
    $0dd3707f7fd8aa7a$export$5b78c989c8db2561.set(featureFlagName, value);
    $0dd3707f7fd8aa7a$export$2a5c8df26bb89760.set(featureFlagName, value);
};

});
parcelRegister("6HSjh", function(module, exports) {

$parcel$export(module.exports, "redactValue", function () { return $bc00105090e9db42$export$fcc03ee4c944962f; });
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $8TqQA = parcelRequire("8TqQA");
var $bc00105090e9db42$var$startsAsObject = function(value) {
    try {
        if (value.charAt(0) === "{") return true;
    } catch (e) {
        return false;
    }
    return false;
};
var $bc00105090e9db42$var$isObject = function(value) {
    return value && typeof value === "object" && value.constructor === Object;
};
var $bc00105090e9db42$var$isString = function(input) {
    var result;
    try {
        result = typeof input === "string" || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
var $bc00105090e9db42$export$7b4abba432e57989 = function(value) {
    return $bc00105090e9db42$var$isString(value) && $bc00105090e9db42$var$startsAsObject(value) || $bc00105090e9db42$var$isObject(value);
};
var $bc00105090e9db42$export$fcc03ee4c944962f = function(featureFlagValue) {
    return $bc00105090e9db42$export$7b4abba432e57989(featureFlagValue) ? (0, $8TqQA.NON_BOOLEAN_VALUE) : featureFlagValue;
};

});
parcelRegister("8TqQA", function(module, exports) {

$parcel$export(module.exports, "NON_BOOLEAN_VALUE", function () { return $ed1cf1e12226bac0$export$42f4885608027d0c; });
var $ed1cf1e12226bac0$export$42f4885608027d0c = "non_boolean";

});



parcelRegister("c24i9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $222771121472b28e$export$2e2bcd8739ae039; });
var $222771121472b28e$var$interactions = new Map();
var $222771121472b28e$export$2e2bcd8739ae039 = $222771121472b28e$var$interactions;

});


parcelRegister("3Og3K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac23a52e67ed1df6$export$2e2bcd8739ae039; });
// The UFORouteName object is a global singleton
var $ac23a52e67ed1df6$var$UFORouteName = {
    current: null
};
var $ac23a52e67ed1df6$export$2e2bcd8739ae039 = $ac23a52e67ed1df6$var$UFORouteName;

});


parcelRegister("2ygkX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ea99719bb95b1d7$export$2e2bcd8739ae039; });

var $cZ38z = parcelRequire("cZ38z");

var $ctqcv = parcelRequire("ctqcv");

var $dgbe0 = parcelRequire("dgbe0");

var $ghVTP = parcelRequire("ghVTP");

var $9WpMx = parcelRequire("9WpMx");

var $4ve2A = parcelRequire("4ve2A");

var $hTn3j = parcelRequire("hTn3j");

var $3Og3K = parcelRequire("3Og3K");
function $8ea99719bb95b1d7$export$2e2bcd8739ae039(ufoName) {
    var routeName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ufoName;
    // REMOVED
    // if (initUFOBeforePageLoadStart()) {
    //     init();
    // }
    (0, $hTn3j.default)();
    if (ufoName != null) {
        (0, $3Og3K.default).current = ufoName;
        var rate = (0, $dgbe0.getInteractionRate)(ufoName, "page_load");
        if ((0, $ctqcv.default)(rate)) {
            var newId = (0, $cZ38z.default)();
            (0, $9WpMx.DefaultInteractionID).current = newId;
            (0, $4ve2A.addNewInteraction)(newId, ufoName, "page_load", 0, rate, null, routeName, (0, $ghVTP.getActiveTrace)());
        }
    }
// REMOVED
// if (!initUFOBeforePageLoadStart()) {
//     init();
// }
}

});
parcelRegister("hTn3j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $abdcb857bf690286$export$2e2bcd8739ae039; });
// import { GlobalReactLooselyLazyProfiler } from "react-loosely-lazy";

var $cv9Rk = parcelRequire("cv9Rk");

var $3rCRi = parcelRequire("3rCRi");

var $iEubr = parcelRequire("iEubr");

var $lwOBK = parcelRequire("lwOBK");

var $15YM2 = parcelRequire("15YM2");

var $lRo6Z = parcelRequire("lRo6Z");

var $cqpBq = parcelRequire("cqpBq");

var $ia6lT = parcelRequire("ia6lT");

var $4ve2A = parcelRequire("4ve2A");

var $5oQFi = parcelRequire("5oQFi");
var $dmn1K = parcelRequire("dmn1K");

var $5e3J5 = parcelRequire("5e3J5");

var $iehXw = parcelRequire("iehXw");
var $abdcb857bf690286$var$initialized = false;


function $abdcb857bf690286$export$2e2bcd8739ae039() {
    if ($abdcb857bf690286$var$initialized) return;
    (0, $lwOBK.retrieveAndSetPageLoadTrace)((0, $iEubr.default));
    (0, $ia6lT.setupHiddenTimingCapture)();
    (0, $15YM2.startLighthouseObserver)();
    (0, $5oQFi.configure)((0, $iehXw.resourceTimingsConfig));
    (0, $dmn1K.startResourceTimingBuffer)();
    (0, $lRo6Z.configure)((0, $5e3J5.bundleEvalTimingsConfig));
    // REMOVED: Jira specifics
    // configureSsrTiming(jiraSsrConfig);
    // REMOVED: Waiting react-loosely-lazy new release
    // GlobalReactLooselyLazyProfiler.current = ModuleLoadingProfiler;
    (0, $cqpBq.sinkErrorHandler)((0, $4ve2A.addErrorToAll));
    $abdcb857bf690286$var$initialized = true;
    Promise.all([
        Promise.resolve((parcelRequire("5pHLF"))),
        (parcelRequire("dmojv"))
    ]).then(function(param) {
        var _param = (0, $cv9Rk._)(param, 2), awc = _param[0], payloadPackage = _param[1];
        awc.getAnalyticsWebClientPromise().then(function(client) {
            var instance = client.getInstance();
            (0, $4ve2A.sinkInteractionHandler)(function(interactionId, interaction) {
                (0, $3rCRi.unstable_scheduleCallback)((0, $3rCRi.unstable_IdlePriority), function() {
                    var payloads = payloadPackage.createPayloads(interactionId, interaction);
                    payloads === null || payloads === void 0 ? void 0 : payloads.forEach(function(payload) {
                        instance.sendOperationalEvent(payload);
                    });
                });
            });
        });
    });
}

});
parcelRegister("iEubr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e5421739706830de$export$2e2bcd8739ae039; });

var $8Ob9p = parcelRequire("8Ob9p");
var $e5421739706830de$export$2e2bcd8739ae039 = (0, $8Ob9p.default);

});
parcelRegister("8Ob9p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $077e9940b2401118$export$2e2bcd8739ae039; });
var $077e9940b2401118$export$c47913ca32a5c6f7 = function(name) {
    var node = typeof document !== "undefined" ? document.querySelector('meta[name="'.concat(name, '"]')) : null;
    var metaValue = node && node.getAttribute("content");
    return metaValue !== undefined ? metaValue : null;
};
var $077e9940b2401118$export$2e2bcd8739ae039 = $077e9940b2401118$export$c47913ca32a5c6f7;

});


parcelRegister("lwOBK", function(module, exports) {

$parcel$export(module.exports, "retrieveAndSetPageLoadTrace", function () { return $bada258926ee9eb0$export$1a71d2bbe236de99; });

var $ghVTP = parcelRequire("ghVTP");
var $bada258926ee9eb0$var$alreadySet = false;
var $bada258926ee9eb0$export$1a71d2bbe236de99 = function(getMeta) {
    // REMOVED: if (__SERVER__ || alreadySet)
    if ($bada258926ee9eb0$var$alreadySet) return;
    var traceId = getMeta("X-B3-TraceId") || "";
    var sampled = getMeta("X-B3-Sampled") || "";
    var spanId = getMeta("X-B3-SpanId") || "";
    $bada258926ee9eb0$var$alreadySet = true;
    (0, $ghVTP.setActiveTrace)(traceId, sampled, spanId, "page_load");
};

});

parcelRegister("15YM2", function(module, exports) {

$parcel$export(module.exports, "startLighthouseObserver", function () { return $838aad903544ff4c$export$5ecf2aafafee3e0; });
$parcel$export(module.exports, "getLighthouseMetrics", function () { return $838aad903544ff4c$export$b46cecdf698e4bb5; });

var $UOPzb = parcelRequire("UOPzb");

var $9tMD2 = parcelRequire("9tMD2");

var $gN3e4 = parcelRequire("gN3e4");

var $2HJ5h = parcelRequire("2HJ5h");

var $7XPb8 = parcelRequire("7XPb8");
function $838aad903544ff4c$export$5ecf2aafafee3e0() {
    (0, $7XPb8.startLSObserver)();
    (0, $7XPb8.startLTObserver)();
}
var $838aad903544ff4c$export$b46cecdf698e4bb5 = function(param) {
    var start = param.start, stop = param.stop;
    var longTask = (0, $2HJ5h.EntriesBuffer)[(0, $9tMD2.PerformanceObserverEntryTypes).LongTask];
    var tbt = longTask ? (0, $gN3e4.getTBT)(start, stop, longTask) : null;
    // no round as CLS is usually 0-1
    var layoutShift = (0, $2HJ5h.EntriesBuffer)[(0, $9tMD2.PerformanceObserverEntryTypes).LayoutShift];
    var cls = layoutShift ? (0, $UOPzb.getCLS)(start, stop, layoutShift) : null;
    return {
        "metric:tbt": tbt ? Math.round(tbt.total) : 0,
        "metric:tbt:observed": tbt ? Math.round(tbt.observed) : 0,
        "metric:cls": cls !== null && cls !== void 0 ? cls : 0
    };
};

});
parcelRegister("UOPzb", function(module, exports) {

$parcel$export(module.exports, "getCLS", function () { return $7ae9ba05c0933591$export$fc6227831ee7c7; });
var $7ae9ba05c0933591$export$fc6227831ee7c7 = function(start, stop, buffer) {
    var layoutShifts = buffer.getAll().filter(function(entry) {
        return entry.startTime >= start && entry.startTime <= stop;
    });
    var sessionWindows = [];
    var currentWindow = null;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // Group layout shifts into session windows
        for(var _iterator = layoutShifts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var shift = _step.value;
            var startTime = shift.startTime;
            var endTime = shift.startTime + shift.duration;
            var score = shift.value;
            if (currentWindow === null || startTime - currentWindow.endTime > 1000 || endTime - currentWindow.startTime > 5000) {
                // Start a new session window
                currentWindow = {
                    startTime: startTime,
                    endTime: endTime,
                    score: score
                };
                sessionWindows.push(currentWindow);
            } else {
                // Add layout shift to current session window
                currentWindow.endTime = endTime;
                currentWindow.score += score;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Find session window with highest cumulative score
    var maxScore = sessionWindows.reduce(function(max, sessionWindow) {
        return sessionWindow.score > max ? sessionWindow.score : max;
    }, 0);
    // Return score of largest burst as CLS metric
    return Math.round(maxScore * 10000) / 10000;
};

});

parcelRegister("9tMD2", function(module, exports) {

$parcel$export(module.exports, "PerformanceObserverEntryTypes", function () { return $3a8195603df2f2b1$export$a4def92db6fc8e17; });
var $3a8195603df2f2b1$export$a4def92db6fc8e17;
(function(PerformanceObserverEntryTypes) {
    PerformanceObserverEntryTypes["LayoutShift"] = "layout-shift";
    PerformanceObserverEntryTypes["LongTask"] = "longtask";
})($3a8195603df2f2b1$export$a4def92db6fc8e17 || ($3a8195603df2f2b1$export$a4def92db6fc8e17 = {}));

});

parcelRegister("gN3e4", function(module, exports) {

$parcel$export(module.exports, "getTBT", function () { return $8c6717e408a4dd44$export$2d6e933b35bd3407; });
var $8c6717e408a4dd44$var$MAX_ACCEPTABLE_TASK_DURATION = 50;
var $8c6717e408a4dd44$export$2d6e933b35bd3407 = function(start, stop, buffer) {
    return buffer.getAll().filter(function(entry) {
        return entry.startTime <= stop && entry.duration > $8c6717e408a4dd44$var$MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop);
    }).reduce(function(tbt, entry) {
        var longTaskStop = entry.startTime + entry.duration;
        var intersectStart = Math.max(entry.startTime + $8c6717e408a4dd44$var$MAX_ACCEPTABLE_TASK_DURATION, start);
        var intersectStop = Math.min(longTaskStop, stop);
        var longTaskIncluded = Math.max(intersectStop - intersectStart, 0);
        // eslint-disable-next-line no-param-reassign
        tbt.observed += entry.duration - $8c6717e408a4dd44$var$MAX_ACCEPTABLE_TASK_DURATION;
        // eslint-disable-next-line no-param-reassign
        tbt.total += longTaskIncluded;
        return tbt;
    }, {
        total: 0,
        observed: 0
    });
};

});

parcelRegister("2HJ5h", function(module, exports) {

$parcel$export(module.exports, "EntriesBuffer", function () { return $48c78ca40c502c4e$export$f7dc16cbd16f7bbe; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $3sHb8 = parcelRequire("3sHb8");

var $9tMD2 = parcelRequire("9tMD2");
var $48c78ca40c502c4e$export$2c6e86519c9e8188 = /*#__PURE__*/ function() {
    "use strict";
    function BufferWithMaxLength() {
        var maxLength = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1000;
        (0, $4GJKx._)(this, BufferWithMaxLength);
        this.buffer = [];
        this.full = false;
        this.maxLength = maxLength;
    }
    (0, $1wc17._)(BufferWithMaxLength, [
        {
            key: "push",
            value: function push(item) {
                if (this.full || this.maxLength === this.buffer.length) {
                    this.full = true;
                    this.buffer.shift();
                }
                this.buffer.push(item);
            }
        },
        {
            key: "getAll",
            value: function getAll() {
                return this.buffer;
            }
        }
    ]);
    return BufferWithMaxLength;
}();
var $48c78ca40c502c4e$var$_obj;
var $48c78ca40c502c4e$export$f7dc16cbd16f7bbe = ($48c78ca40c502c4e$var$_obj = {}, (0, $3sHb8._)($48c78ca40c502c4e$var$_obj, (0, $9tMD2.PerformanceObserverEntryTypes).LongTask, new $48c78ca40c502c4e$export$2c6e86519c9e8188()), (0, $3sHb8._)($48c78ca40c502c4e$var$_obj, (0, $9tMD2.PerformanceObserverEntryTypes).LayoutShift, new $48c78ca40c502c4e$export$2c6e86519c9e8188()), $48c78ca40c502c4e$var$_obj);

});

parcelRegister("7XPb8", function(module, exports) {

$parcel$export(module.exports, "startLSObserver", function () { return $217e329488bcfd1f$export$768ccc3ab7bac3ea; });
$parcel$export(module.exports, "startLTObserver", function () { return $217e329488bcfd1f$export$54fb8b6aaf70ec9c; });

var $9tMD2 = parcelRequire("9tMD2");

var $2HJ5h = parcelRequire("2HJ5h");
var $217e329488bcfd1f$var$pe = null;
var $217e329488bcfd1f$var$getObserver = function() {
    if ($217e329488bcfd1f$var$pe !== null) return $217e329488bcfd1f$var$pe;
    $217e329488bcfd1f$var$pe = new PerformanceObserver(function(list) {
        list.getEntries().forEach(function(entry) {
            var _EntriesBuffer_PerformanceObserverEntryTypes_LayoutShift, _EntriesBuffer_PerformanceObserverEntryTypes_LongTask;
            if (entry.entryType === (0, $9tMD2.PerformanceObserverEntryTypes).LayoutShift) (_EntriesBuffer_PerformanceObserverEntryTypes_LayoutShift = (0, $2HJ5h.EntriesBuffer)[(0, $9tMD2.PerformanceObserverEntryTypes).LayoutShift]) === null || _EntriesBuffer_PerformanceObserverEntryTypes_LayoutShift === void 0 ? void 0 : _EntriesBuffer_PerformanceObserverEntryTypes_LayoutShift.push(entry);
            if (entry.entryType === (0, $9tMD2.PerformanceObserverEntryTypes).LongTask) (_EntriesBuffer_PerformanceObserverEntryTypes_LongTask = (0, $2HJ5h.EntriesBuffer)[(0, $9tMD2.PerformanceObserverEntryTypes).LongTask]) === null || _EntriesBuffer_PerformanceObserverEntryTypes_LongTask === void 0 ? void 0 : _EntriesBuffer_PerformanceObserverEntryTypes_LongTask.push(entry);
        });
    });
    return $217e329488bcfd1f$var$pe;
};
var $217e329488bcfd1f$export$768ccc3ab7bac3ea = function() {
    $217e329488bcfd1f$var$getObserver().observe({
        type: (0, $9tMD2.PerformanceObserverEntryTypes).LayoutShift,
        buffered: true
    });
};
var $217e329488bcfd1f$export$54fb8b6aaf70ec9c = function() {
    $217e329488bcfd1f$var$getObserver().observe({
        type: (0, $9tMD2.PerformanceObserverEntryTypes).LongTask,
        buffered: true
    });
};

});


parcelRegister("lRo6Z", function(module, exports) {

$parcel$export(module.exports, "configure", function () { return $31be16670a239486$export$8d21e34596265fa2; });
$parcel$export(module.exports, "getBundleEvalTimings", function () { return $31be16670a239486$export$2eda1519e91a4386; });

var $jZo3Q = parcelRequire("jZo3Q");
var $31be16670a239486$var$config = null;
function $31be16670a239486$export$8d21e34596265fa2(bundleEvalTimingConfiguration) {
    $31be16670a239486$var$config = bundleEvalTimingConfiguration;
}
var $31be16670a239486$var$getPerformanceObject = function() {
    return (window !== null && window !== void 0 ? window : {}).performance;
};
function $31be16670a239486$export$2eda1519e91a4386(interactionStartTime) {
    if ($31be16670a239486$var$config == null) return {};
    var started = {};
    var timings = {};
    var cachedConfig = $31be16670a239486$var$config;
    var performance = $31be16670a239486$var$getPerformanceObject();
    performance === null || performance === void 0 ? void 0 : performance.getEntriesByType("mark").forEach(function(mark) {
        var result = cachedConfig.mapPerformanceMark(mark.name);
        if (!result) return;
        var type = result.type, name = result.name;
        if (type === "start" && mark.startTime >= interactionStartTime) {
            started[name] = mark;
            return;
        }
        if (type === "end" && started[name]) {
            var _started_name;
            var startTime = (_started_name = started[name]) === null || _started_name === void 0 ? void 0 : _started_name.startTime;
            if (startTime) {
                timings[name] = {
                    startTime: (0, $jZo3Q.roundEpsilon)(startTime - interactionStartTime),
                    duration: (0, $jZo3Q.roundEpsilon)(mark.startTime - startTime)
                };
                delete started[name];
            }
        }
    });
    if (Object.keys(timings).length === 0) return {};
    return timings;
}

});
parcelRegister("jZo3Q", function(module, exports) {

$parcel$export(module.exports, "roundEpsilon", function () { return $6ff7fe755ab21e0e$export$56014375de40214b; });
var $6ff7fe755ab21e0e$export$56014375de40214b = function(num) {
    var places = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 3;
    var factor = Math.pow(10, places);
    return Math.round((num + Number.EPSILON) * factor) / factor;
};

});


parcelRegister("cqpBq", function(module, exports) {

$parcel$export(module.exports, "sinkErrorHandler", function () { return $42afb2f994cec22b$export$ebe081a8c9bf8176; });
var $42afb2f994cec22b$var$shouldInitilizeGlobalErrorHandler = true;
var $42afb2f994cec22b$var$errors = [];
var $42afb2f994cec22b$var$push = function(name, labelStack, errorType, errorMessage, errorStack) {
    $42afb2f994cec22b$var$errors.push({
        name: name,
        labelStack: labelStack,
        errorType: errorType,
        errorMessage: errorMessage,
        errorStack: errorStack
    });
};
var $42afb2f994cec22b$export$ebe081a8c9bf8176 = function(sinkFunc) {
    $42afb2f994cec22b$var$push = sinkFunc;
    $42afb2f994cec22b$var$errors.forEach(function(e) {
        sinkFunc(e.name, e.labelStack, e.errorType, e.errorMessage, e.errorStack);
    });
    $42afb2f994cec22b$var$errors.length = 0;
};
var $42afb2f994cec22b$var$handleError = function(e) {
    var _e_error;
    if (((_e_error = e.error) === null || _e_error === void 0 ? void 0 : _e_error.UFOhasCaught) === undefined) try {
        if (e.error instanceof Error) $42afb2f994cec22b$var$push("GlobalErrorHandler", null, e.error.name, e.error.message, e.error.stack);
        else if (e.error) {
            var hint = JSON.stringify(e.error).slice(0, 50);
            $42afb2f994cec22b$var$push("GlobalErrorHandler", null, "", "Non error object thrown: ".concat(hint), undefined);
        } else if (e.message !== undefined) {
            var hint1 = e.message.slice(0, 50);
            $42afb2f994cec22b$var$push("GlobalErrorHandler", null, "", "Non error object thrown: ".concat(hint1), undefined);
        }
        if (e.error && typeof e.error === "object") e.error.UFOhasCaught = true;
    // eslint-disable-next-line no-empty
    } catch (e) {}
};
var $42afb2f994cec22b$var$handlePromiseRejection = function(e) {
    if (e.reason instanceof Error) $42afb2f994cec22b$var$push("GlobalErrorHandler", null, e.reason.name, e.reason.message, e.reason.stack);
    else if (e.reason) try {
        var hint = JSON.stringify(e.reason).slice(0, 50);
        $42afb2f994cec22b$var$push("GlobalErrorHandler", null, "", "Non error object thrown: ".concat(hint), undefined);
    // eslint-disable-next-line no-empty
    } catch (e) {}
};
var $42afb2f994cec22b$var$setupUFOGlobalErrorHandler = function() {
    if ($42afb2f994cec22b$var$shouldInitilizeGlobalErrorHandler) {
        window.addEventListener("error", $42afb2f994cec22b$var$handleError);
        window.addEventListener("unhandledrejection", $42afb2f994cec22b$var$handlePromiseRejection);
        $42afb2f994cec22b$var$shouldInitilizeGlobalErrorHandler = false;
    }
};
var $42afb2f994cec22b$export$2e2bcd8739ae039 = $42afb2f994cec22b$var$setupUFOGlobalErrorHandler;

});

parcelRegister("ia6lT", function(module, exports) {

$parcel$export(module.exports, "setupHiddenTimingCapture", function () { return $88c9644d372895f6$export$554cefe0f0373da4; });
$parcel$export(module.exports, "getPageVisibilityState", function () { return $88c9644d372895f6$export$768b2008623433e1; });
var $88c9644d372895f6$var$timings = [];
var $88c9644d372895f6$var$wasHiddenFlag;
var $88c9644d372895f6$var$setupFlag = false;
function $88c9644d372895f6$var$isPageHidden() {
    if ("visibilityState" in document) return document.visibilityState === "hidden";
    else // @ts-expect-error - Property 'hidden' does not exist on type 'never'.
    return document.hidden;
}
var $88c9644d372895f6$var$SIZE = 50;
var $88c9644d372895f6$var$insertIndex = 0;
function $88c9644d372895f6$var$pushHidden(isPageHiddenFlag, time) {
    $88c9644d372895f6$var$timings[$88c9644d372895f6$var$insertIndex] = {
        time: time !== null && time !== void 0 ? time : performance.now(),
        hidden: isPageHiddenFlag
    };
    $88c9644d372895f6$var$insertIndex = ($88c9644d372895f6$var$insertIndex + 1) % $88c9644d372895f6$var$SIZE;
    $88c9644d372895f6$var$wasHiddenFlag = isPageHiddenFlag;
}
function $88c9644d372895f6$var$handleChange() {
    var isPageHiddenFlag = $88c9644d372895f6$var$isPageHidden();
    if (isPageHiddenFlag) {
        if (!$88c9644d372895f6$var$wasHiddenFlag) $88c9644d372895f6$var$pushHidden(isPageHiddenFlag);
        $88c9644d372895f6$var$wasHiddenFlag = true;
    } else {
        if ($88c9644d372895f6$var$wasHiddenFlag) $88c9644d372895f6$var$pushHidden(isPageHiddenFlag);
        $88c9644d372895f6$var$wasHiddenFlag = false;
    }
}
function $88c9644d372895f6$var$setup() {
    window.addEventListener("pageshow", $88c9644d372895f6$var$handleChange);
    window.addEventListener("pagehide", $88c9644d372895f6$var$handleChange);
    document.addEventListener("visibilitychange", $88c9644d372895f6$var$handleChange);
}
function $88c9644d372895f6$export$554cefe0f0373da4() {
    if (!$88c9644d372895f6$var$setupFlag) {
        var isPageHiddenFlag = $88c9644d372895f6$var$isPageHidden();
        $88c9644d372895f6$var$pushHidden(isPageHiddenFlag, 0);
        $88c9644d372895f6$var$setup();
        $88c9644d372895f6$var$setupFlag = true;
    }
}
function $88c9644d372895f6$export$768b2008623433e1(start, end) {
    // Desirable default value is visible
    if ($88c9644d372895f6$var$timings.length === 0) return "visible";
    var currentSize = $88c9644d372895f6$var$timings.length;
    var hiddenState = "mixed";
    var startIdx = $88c9644d372895f6$var$insertIndex;
    var endIdx = $88c9644d372895f6$var$insertIndex;
    // currentSize is capped at SIZE.
    for(var i = 0; i < currentSize; i++){
        var _timings_tmpIdx;
        var tmpIdx = ($88c9644d372895f6$var$insertIndex + i) % currentSize;
        var time = (_timings_tmpIdx = $88c9644d372895f6$var$timings[tmpIdx]) === null || _timings_tmpIdx === void 0 ? void 0 : _timings_tmpIdx.time;
        if (time) {
            if (time <= end) {
                endIdx = tmpIdx;
                if (time <= start) startIdx = tmpIdx;
            }
        }
    }
    if (endIdx - startIdx === 0) {
        var _timings_startIdx;
        var hidden = (_timings_startIdx = $88c9644d372895f6$var$timings[startIdx]) === null || _timings_startIdx === void 0 ? void 0 : _timings_startIdx.hidden;
        if (hidden) hiddenState = "hidden";
        else hiddenState = "visible";
    }
    return hiddenState;
}

});

parcelRegister("5oQFi", function(module, exports) {

$parcel$export(module.exports, "configure", function () { return $635f7896507886f8$export$8d21e34596265fa2; });
$parcel$export(module.exports, "getConfig", function () { return $635f7896507886f8$export$44487a86467333c3; });
var $635f7896507886f8$var$config = {
    mapResources: function(url) {
        return url;
    },
    sanitiseEndpoints: function(url) {
        return url;
    }
};
function $635f7896507886f8$export$8d21e34596265fa2(resourceTimingConfig) {
    $635f7896507886f8$var$config = resourceTimingConfig;
}
var $635f7896507886f8$export$44487a86467333c3 = function() {
    return $635f7896507886f8$var$config;
};

});

parcelRegister("dmn1K", function(module, exports) {

$parcel$export(module.exports, "startResourceTimingBuffer", function () { return $1ea795b30ae47b4e$export$a311cb1baa7d2d62; });

var $9Z7SC = parcelRequire("9Z7SC");
function $1ea795b30ae47b4e$export$a311cb1baa7d2d62() {
    (0, $9Z7SC.resourceTimingBuffer).start();
}

});
parcelRegister("9Z7SC", function(module, exports) {

$parcel$export(module.exports, "resourceTimingBuffer", function () { return $f006afa9696d3f6f$export$bea963256235a63e; });
$parcel$export(module.exports, "filterResourceTimings", function () { return $f006afa9696d3f6f$export$4138a729ef1db028; });

var $c6Xmf = parcelRequire("c6Xmf");

var $jZo3Q = parcelRequire("jZo3Q");
var $f006afa9696d3f6f$var$getPerformanceObject = function() {
    return (window !== null && window !== void 0 ? window : {}).performance;
};
var $f006afa9696d3f6f$var$getPerformanceObserverObject = function() {
    return (window !== null && window !== void 0 ? window : {}).PerformanceObserver;
};
var $f006afa9696d3f6f$export$bea963256235a63e = {
    timings: [],
    maxSize: 1000,
    observer: null,
    transformResource: function(entry) {
        var _entry_serverTiming;
        var duration = (0, $jZo3Q.roundEpsilon)(entry.duration);
        var totalBackendTimeEntry = (_entry_serverTiming = entry.serverTiming) === null || _entry_serverTiming === void 0 ? void 0 : _entry_serverTiming.find(// timing name should come from per-product config in the future
        function(timing) {
            return timing.name === "total" || timing.name === "filter-request-papi";
        });
        var serverTime = totalBackendTimeEntry ? (0, $jZo3Q.roundEpsilon)(totalBackendTimeEntry.duration) : undefined;
        var networkTime = serverTime ? duration - serverTime : undefined;
        return {
            name: entry.name,
            initiatorType: entry.initiatorType,
            transferSize: entry.transferSize,
            startTime: (0, $jZo3Q.roundEpsilon)(entry.startTime),
            duration: (0, $jZo3Q.roundEpsilon)(entry.duration),
            fetchStart: (0, $jZo3Q.roundEpsilon)(entry.fetchStart || 0),
            workerStart: (0, $jZo3Q.roundEpsilon)(entry.workerStart || 0),
            responseStart: (0, $jZo3Q.roundEpsilon)(entry.responseStart || 0),
            serverTime: serverTime,
            networkTime: networkTime
        };
    },
    start: function() {
        var _performance_getEntriesByType;
        var performance = $f006afa9696d3f6f$var$getPerformanceObject();
        var PerformanceObserver = $f006afa9696d3f6f$var$getPerformanceObserverObject();
        if (!PerformanceObserver || !performance || typeof PerformanceObserver === "undefined") return;
        if ($f006afa9696d3f6f$export$bea963256235a63e.observer) return;
        var resources = (_performance_getEntriesByType = performance.getEntriesByType) === null || _performance_getEntriesByType === void 0 ? void 0 : _performance_getEntriesByType.call(performance, "resource");
        if (resources) $f006afa9696d3f6f$export$bea963256235a63e.timings = resources.map(function(resource) {
            return $f006afa9696d3f6f$export$bea963256235a63e.transformResource(resource);
        });
        $f006afa9696d3f6f$export$bea963256235a63e.observer = new PerformanceObserver($f006afa9696d3f6f$export$bea963256235a63e.addTimings);
        $f006afa9696d3f6f$export$bea963256235a63e.observer.observe({
            entryTypes: [
                "resource"
            ]
        });
    },
    stop: function() {
        if ($f006afa9696d3f6f$export$bea963256235a63e.observer) {
            $f006afa9696d3f6f$export$bea963256235a63e.observer.disconnect();
            $f006afa9696d3f6f$export$bea963256235a63e.observer = null;
        }
        $f006afa9696d3f6f$export$bea963256235a63e.timings = [];
    },
    addTimings: function(list) {
        var _resourceTimingBuffer_timings;
        var entries = list.getEntries().map(function(entry) {
            return $f006afa9696d3f6f$export$bea963256235a63e.transformResource(entry);
        });
        var overflow = $f006afa9696d3f6f$export$bea963256235a63e.timings.length + entries.length;
        if (overflow > $f006afa9696d3f6f$export$bea963256235a63e.maxSize) {
            var fieldsToRemove = overflow - $f006afa9696d3f6f$export$bea963256235a63e.maxSize;
            $f006afa9696d3f6f$export$bea963256235a63e.timings.splice(0, fieldsToRemove);
        }
        (_resourceTimingBuffer_timings = $f006afa9696d3f6f$export$bea963256235a63e.timings).push.apply(_resourceTimingBuffer_timings, (0, $c6Xmf._)(entries));
    }
};
var $f006afa9696d3f6f$var$isValidTiming = function(timing, startTime, endTime) {
    return timing.startTime >= startTime && timing.startTime + timing.duration <= endTime;
};
var $f006afa9696d3f6f$export$4138a729ef1db028 = function(startTime, endTime) {
    var performance = $f006afa9696d3f6f$var$getPerformanceObject();
    var PerformanceObserver = $f006afa9696d3f6f$var$getPerformanceObserverObject();
    if (!PerformanceObserver || !$f006afa9696d3f6f$export$bea963256235a63e.observer) {
        var resources = performance === null || performance === void 0 ? void 0 : performance.getEntriesByType("resource");
        if (resources) return resources.filter(function(timing) {
            return $f006afa9696d3f6f$var$isValidTiming(timing, startTime, endTime);
        });
        return null;
    }
    return $f006afa9696d3f6f$export$bea963256235a63e.timings.filter(function(timing) {
        return $f006afa9696d3f6f$var$isValidTiming(timing, startTime, endTime);
    });
};

});


parcelRegister("5e3J5", function(module, exports) {

$parcel$export(module.exports, "bundleEvalTimingsConfig", function () { return $fc4ef006810266c1$export$5dbbeefa4e9a0eba; });

var $kmoiZ = parcelRequire("kmoiZ");
var $fc4ef006810266c1$export$5dbbeefa4e9a0eba = {
    mapPerformanceMark: function(mark) {
        if (mark.endsWith((0, $kmoiZ.JS_EVAL_START))) return {
            name: mark.substring(0, mark.indexOf((0, $kmoiZ.JS_EVAL_START))),
            type: "start"
        };
        if (mark.endsWith((0, $kmoiZ.JS_EVAL_STOP))) return {
            name: mark.substring(0, mark.indexOf((0, $kmoiZ.JS_EVAL_STOP))),
            type: "end"
        };
        return null;
    }
};

});
parcelRegister("kmoiZ", function(module, exports) {

$parcel$export(module.exports, "JS_EVAL_START", function () { return $ed28b73bb52ac9e2$export$4719e2a29dbcb33d; }, function (v) { return $ed28b73bb52ac9e2$export$4719e2a29dbcb33d = v; });
$parcel$export(module.exports, "JS_EVAL_STOP", function () { return $ed28b73bb52ac9e2$export$7ee4e0433d720dea; }, function (v) { return $ed28b73bb52ac9e2$export$7ee4e0433d720dea = v; });
/**
 *  IMPORTANT
 *  - this code must be nodejs compatible as it is also used in the webpack.config.js
 */ var $ed28b73bb52ac9e2$export$db6a769879aea97b;
var $ed28b73bb52ac9e2$export$4719e2a29dbcb33d;
var $ed28b73bb52ac9e2$export$7ee4e0433d720dea;
var $ed28b73bb52ac9e2$export$d619b0b88beaed3d;
$ed28b73bb52ac9e2$export$db6a769879aea97b = "ssr.spa.rendered";
/*::
export type JsEvalStart = ':eval-start';
 */ var $ed28b73bb52ac9e2$var$JS_EVAL_START /*:: :JsEvalStart */  = ":eval-start";
$ed28b73bb52ac9e2$export$4719e2a29dbcb33d = $ed28b73bb52ac9e2$var$JS_EVAL_START;
/*::
export type JsEvalStop = ':eval-stop';
 */ var $ed28b73bb52ac9e2$var$JS_EVAL_STOP /*:: :JsEvalStop */  = ":eval-stop";
$ed28b73bb52ac9e2$export$7ee4e0433d720dea = $ed28b73bb52ac9e2$var$JS_EVAL_STOP;
/*::
export type JsEvalApi = '__jsEvalStop';
*/ var $ed28b73bb52ac9e2$var$JS_EVAL_API /*:: :JsEvalApi */  = "__jsEvalStop";
$ed28b73bb52ac9e2$export$d619b0b88beaed3d = $ed28b73bb52ac9e2$var$JS_EVAL_API;

});


parcelRegister("iehXw", function(module, exports) {

$parcel$export(module.exports, "resourceTimingsConfig", function () { return $aa32138df89fc27a$export$5fc9317dcf7889c3; });

var $cv9Rk = parcelRequire("cv9Rk");

var $1CY57 = parcelRequire("1CY57");

var $731ua = parcelRequire("731ua");
var $aa32138df89fc27a$var$isDevelopment = false;
// Web Resource Manager (WRM)
// https://developer.atlassian.com/server/framework/atlassian-sdk/WRM-resource-loading-phases/
var $aa32138df89fc27a$var$isWRMResource = function(url) {
    return url.includes("/batch.js") || url.includes("/batch.css");
};
var $aa32138df89fc27a$var$getWRMAssetName = function(url) {
    var _ref = (0, $cv9Rk._)(/\/([\w.\-,:]*?)(?:,-|\/batch\.)/.exec(url) || [], 2), resources = _ref[1];
    var assetName = (0, $731ua.sanitiseAssetName)($aa32138df89fc27a$var$isDevelopment)(url);
    if (!resources) return assetName;
    return "wrm/".concat(resources, "/").concat(assetName);
};
var $aa32138df89fc27a$var$getFileName = function(url) {
    return $aa32138df89fc27a$var$isWRMResource(url) ? $aa32138df89fc27a$var$getWRMAssetName(url) : (0, $731ua.sanitiseAssetName)($aa32138df89fc27a$var$isDevelopment)(url);
};
// CHANGED
var $aa32138df89fc27a$var$sanitiseEndpoints = function(url) {
    var parsedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($1CY57)))(url, true);
    var fileName = parsedUrl.pathname.replace(/\/\d+$/i, "/<id>");
    return fileName;
};
var $aa32138df89fc27a$export$5fc9317dcf7889c3 = {
    sanitiseEndpoints: $aa32138df89fc27a$var$sanitiseEndpoints,
    mapResources: $aa32138df89fc27a$var$getFileName,
    hasTimingHeaders: function(url) {
        return $aa32138df89fc27a$var$isWRMResource(url);
    },
    xhrFilter: function(url) {
        return url.includes("/rest/greenhopper/");
    }
};

});
parcelRegister("1CY57", function(module, exports) {

var $l0HdX = parcelRequire("l0HdX");
"use strict";

var $lMJj8 = parcelRequire("lMJj8");

var $kgSRu = parcelRequire("kgSRu");
var $12f7f1fc20a28e05$var$controlOrWhitespace = /^[\x00-\x20\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+/, $12f7f1fc20a28e05$var$CRHTLF = /[\n\r\t]/g, $12f7f1fc20a28e05$var$slashes = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//, $12f7f1fc20a28e05$var$port = /:\d+$/, $12f7f1fc20a28e05$var$protocolre = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\\/]+)?([\S\s]*)/i, $12f7f1fc20a28e05$var$windowsDriveLetter = /^[a-zA-Z]:/;
/**
 * Remove control characters and whitespace from the beginning of a string.
 *
 * @param {Object|String} str String to trim.
 * @returns {String} A new string representing `str` stripped of control
 *     characters and whitespace from its beginning.
 * @public
 */ function $12f7f1fc20a28e05$var$trimLeft(str) {
    return (str ? str : "").toString().replace($12f7f1fc20a28e05$var$controlOrWhitespace, "");
}
/**
 * These are the parse rules for the URL parser, it informs the parser
 * about:
 *
 * 0. The char it Needs to parse, if it's a string it should be done using
 *    indexOf, RegExp using exec and NaN means set as current value.
 * 1. The property we should set when parsing this value.
 * 2. Indication if it's backwards or forward parsing, when set as number it's
 *    the value of extra chars that should be split off.
 * 3. Inherit from location if non existing in the parser.
 * 4. `toLowerCase` the resulting value.
 */ var $12f7f1fc20a28e05$var$rules = [
    [
        "#",
        "hash"
    ],
    [
        "?",
        "query"
    ],
    function sanitize(address, url) {
        return $12f7f1fc20a28e05$var$isSpecial(url.protocol) ? address.replace(/\\/g, "/") : address;
    },
    [
        "/",
        "pathname"
    ],
    [
        "@",
        "auth",
        1
    ],
    [
        NaN,
        "host",
        undefined,
        1,
        1
    ],
    [
        /:(\d*)$/,
        "port",
        undefined,
        1
    ],
    [
        NaN,
        "hostname",
        undefined,
        1,
        1
    ] // Set left over.
];
/**
 * These properties should not be copied or inherited from. This is only needed
 * for all non blob URL's as a blob URL does not include a hash, only the
 * origin.
 *
 * @type {Object}
 * @private
 */ var $12f7f1fc20a28e05$var$ignore = {
    hash: 1,
    query: 1
};
/**
 * The location object differs when your code is loaded through a normal page,
 * Worker or through a worker using a blob. And with the blobble begins the
 * trouble as the location object will contain the URL of the blob, not the
 * location of the page where our code is loaded in. The actual origin is
 * encoded in the `pathname` so we can thankfully generate a good "default"
 * location from it so we can generate proper relative URL's again.
 *
 * @param {Object|String} loc Optional default location object.
 * @returns {Object} lolcation object.
 * @public
 */ function $12f7f1fc20a28e05$var$lolcation(loc) {
    var globalVar;
    if (typeof window !== "undefined") globalVar = window;
    else if (typeof $parcel$global !== "undefined") globalVar = $parcel$global;
    else if (typeof self !== "undefined") globalVar = self;
    else globalVar = {};
    var location = globalVar.location || {};
    loc = loc || location;
    var finaldestination = {}, type = typeof loc === "undefined" ? "undefined" : (0, $l0HdX._)(loc), key;
    if ("blob:" === loc.protocol) finaldestination = new $12f7f1fc20a28e05$var$Url(unescape(loc.pathname), {});
    else if ("string" === type) {
        finaldestination = new $12f7f1fc20a28e05$var$Url(loc, {});
        for(key in $12f7f1fc20a28e05$var$ignore)delete finaldestination[key];
    } else if ("object" === type) {
        for(key in loc){
            if (key in $12f7f1fc20a28e05$var$ignore) continue;
            finaldestination[key] = loc[key];
        }
        if (finaldestination.slashes === undefined) finaldestination.slashes = $12f7f1fc20a28e05$var$slashes.test(loc.href);
    }
    return finaldestination;
}
/**
 * Check whether a protocol scheme is special.
 *
 * @param {String} The protocol scheme of the URL
 * @return {Boolean} `true` if the protocol scheme is special, else `false`
 * @private
 */ function $12f7f1fc20a28e05$var$isSpecial(scheme) {
    return scheme === "file:" || scheme === "ftp:" || scheme === "http:" || scheme === "https:" || scheme === "ws:" || scheme === "wss:";
}
/**
 * @typedef ProtocolExtract
 * @type Object
 * @property {String} protocol Protocol matched in the URL, in lowercase.
 * @property {Boolean} slashes `true` if protocol is followed by "//", else `false`.
 * @property {String} rest Rest of the URL that is not part of the protocol.
 */ /**
 * Extract protocol information from a URL with/without double slash ("//").
 *
 * @param {String} address URL we want to extract from.
 * @param {Object} location
 * @return {ProtocolExtract} Extracted information.
 * @private
 */ function $12f7f1fc20a28e05$var$extractProtocol(address, location) {
    address = $12f7f1fc20a28e05$var$trimLeft(address);
    address = address.replace($12f7f1fc20a28e05$var$CRHTLF, "");
    location = location || {};
    var match = $12f7f1fc20a28e05$var$protocolre.exec(address);
    var protocol = match[1] ? match[1].toLowerCase() : "";
    var forwardSlashes = !!match[2];
    var otherSlashes = !!match[3];
    var slashesCount = 0;
    var rest;
    if (forwardSlashes) {
        if (otherSlashes) {
            rest = match[2] + match[3] + match[4];
            slashesCount = match[2].length + match[3].length;
        } else {
            rest = match[2] + match[4];
            slashesCount = match[2].length;
        }
    } else if (otherSlashes) {
        rest = match[3] + match[4];
        slashesCount = match[3].length;
    } else rest = match[4];
    if (protocol === "file:") {
        if (slashesCount >= 2) rest = rest.slice(2);
    } else if ($12f7f1fc20a28e05$var$isSpecial(protocol)) rest = match[4];
    else if (protocol) {
        if (forwardSlashes) rest = rest.slice(2);
    } else if (slashesCount >= 2 && $12f7f1fc20a28e05$var$isSpecial(location.protocol)) rest = match[4];
    return {
        protocol: protocol,
        slashes: forwardSlashes || $12f7f1fc20a28e05$var$isSpecial(protocol),
        slashesCount: slashesCount,
        rest: rest
    };
}
/**
 * Resolve a relative URL pathname against a base URL pathname.
 *
 * @param {String} relative Pathname of the relative URL.
 * @param {String} base Pathname of the base URL.
 * @return {String} Resolved pathname.
 * @private
 */ function $12f7f1fc20a28e05$var$resolve(relative, base) {
    if (relative === "") return base;
    var path = (base || "/").split("/").slice(0, -1).concat(relative.split("/")), i = path.length, last = path[i - 1], unshift = false, up = 0;
    while(i--){
        if (path[i] === ".") path.splice(i, 1);
        else if (path[i] === "..") {
            path.splice(i, 1);
            up++;
        } else if (up) {
            if (i === 0) unshift = true;
            path.splice(i, 1);
            up--;
        }
    }
    if (unshift) path.unshift("");
    if (last === "." || last === "..") path.push("");
    return path.join("/");
}
/**
 * The actual URL instance. Instead of returning an object we've opted-in to
 * create an actual constructor as it's much more memory efficient and
 * faster and it pleases my OCD.
 *
 * It is worth noting that we should not use `URL` as class name to prevent
 * clashes with the global URL instance that got introduced in browsers.
 *
 * @constructor
 * @param {String} address URL we want to parse.
 * @param {Object|String} [location] Location defaults for relative paths.
 * @param {Boolean|Function} [parser] Parser for the query string.
 * @private
 */ function $12f7f1fc20a28e05$var$Url(address, location, parser) {
    address = $12f7f1fc20a28e05$var$trimLeft(address);
    address = address.replace($12f7f1fc20a28e05$var$CRHTLF, "");
    if (!(this instanceof $12f7f1fc20a28e05$var$Url)) return new $12f7f1fc20a28e05$var$Url(address, location, parser);
    var relative, extracted, parse, instruction, index, key, instructions = $12f7f1fc20a28e05$var$rules.slice(), type = typeof location === "undefined" ? "undefined" : (0, $l0HdX._)(location), url = this, i = 0;
    //
    // The following if statements allows this module two have compatibility with
    // 2 different API:
    //
    // 1. Node.js's `url.parse` api which accepts a URL, boolean as arguments
    //    where the boolean indicates that the query string should also be parsed.
    //
    // 2. The `URL` interface of the browser which accepts a URL, object as
    //    arguments. The supplied object will be used as default values / fall-back
    //    for relative paths.
    //
    if ("object" !== type && "string" !== type) {
        parser = location;
        location = null;
    }
    if (parser && "function" !== typeof parser) parser = $kgSRu.parse;
    location = $12f7f1fc20a28e05$var$lolcation(location);
    //
    // Extract protocol information before running the instructions.
    //
    extracted = $12f7f1fc20a28e05$var$extractProtocol(address || "", location);
    relative = !extracted.protocol && !extracted.slashes;
    url.slashes = extracted.slashes || relative && location.slashes;
    url.protocol = extracted.protocol || location.protocol || "";
    address = extracted.rest;
    //
    // When the authority component is absent the URL starts with a path
    // component.
    //
    if (extracted.protocol === "file:" && (extracted.slashesCount !== 2 || $12f7f1fc20a28e05$var$windowsDriveLetter.test(address)) || !extracted.slashes && (extracted.protocol || extracted.slashesCount < 2 || !$12f7f1fc20a28e05$var$isSpecial(url.protocol))) instructions[3] = [
        /(.*)/,
        "pathname"
    ];
    for(; i < instructions.length; i++){
        instruction = instructions[i];
        if (typeof instruction === "function") {
            address = instruction(address, url);
            continue;
        }
        parse = instruction[0];
        key = instruction[1];
        if (parse !== parse) url[key] = address;
        else if ("string" === typeof parse) {
            index = parse === "@" ? address.lastIndexOf(parse) : address.indexOf(parse);
            if (~index) {
                if ("number" === typeof instruction[2]) {
                    url[key] = address.slice(0, index);
                    address = address.slice(index + instruction[2]);
                } else {
                    url[key] = address.slice(index);
                    address = address.slice(0, index);
                }
            }
        } else if (index = parse.exec(address)) {
            url[key] = index[1];
            address = address.slice(0, index.index);
        }
        url[key] = url[key] || (relative && instruction[3] ? location[key] || "" : "");
        //
        // Hostname, host and protocol should be lowercased so they can be used to
        // create a proper `origin`.
        //
        if (instruction[4]) url[key] = url[key].toLowerCase();
    }
    //
    // Also parse the supplied query string in to an object. If we're supplied
    // with a custom parser as function use that instead of the default build-in
    // parser.
    //
    if (parser) url.query = parser(url.query);
    //
    // If the URL is relative, resolve the pathname against the base URL.
    //
    if (relative && location.slashes && url.pathname.charAt(0) !== "/" && (url.pathname !== "" || location.pathname !== "")) url.pathname = $12f7f1fc20a28e05$var$resolve(url.pathname, location.pathname);
    //
    // Default to a / for pathname if none exists. This normalizes the URL
    // to always have a /
    //
    if (url.pathname.charAt(0) !== "/" && $12f7f1fc20a28e05$var$isSpecial(url.protocol)) url.pathname = "/" + url.pathname;
    //
    // We should not add port numbers if they are already the default port number
    // for a given protocol. As the host also contains the port number we're going
    // override it with the hostname which contains no port number.
    //
    if (!$lMJj8(url.port, url.protocol)) {
        url.host = url.hostname;
        url.port = "";
    }
    //
    // Parse down the `auth` for the username and password.
    //
    url.username = url.password = "";
    if (url.auth) {
        index = url.auth.indexOf(":");
        if (~index) {
            url.username = url.auth.slice(0, index);
            url.username = encodeURIComponent(decodeURIComponent(url.username));
            url.password = url.auth.slice(index + 1);
            url.password = encodeURIComponent(decodeURIComponent(url.password));
        } else url.username = encodeURIComponent(decodeURIComponent(url.auth));
        url.auth = url.password ? url.username + ":" + url.password : url.username;
    }
    url.origin = url.protocol !== "file:" && $12f7f1fc20a28e05$var$isSpecial(url.protocol) && url.host ? url.protocol + "//" + url.host : "null";
    //
    // The href is just the compiled result.
    //
    url.href = url.toString();
}
/**
 * This is convenience method for changing properties in the URL instance to
 * insure that they all propagate correctly.
 *
 * @param {String} part          Property we need to adjust.
 * @param {Mixed} value          The newly assigned value.
 * @param {Boolean|Function} fn  When setting the query, it will be the function
 *                               used to parse the query.
 *                               When setting the protocol, double slash will be
 *                               removed from the final url if it is true.
 * @returns {URL} URL instance for chaining.
 * @public
 */ function $12f7f1fc20a28e05$var$set(part, value, fn) {
    var url = this;
    switch(part){
        case "query":
            if ("string" === typeof value && value.length) value = (fn || $kgSRu.parse)(value);
            url[part] = value;
            break;
        case "port":
            url[part] = value;
            if (!$lMJj8(value, url.protocol)) {
                url.host = url.hostname;
                url[part] = "";
            } else if (value) url.host = url.hostname + ":" + value;
            break;
        case "hostname":
            url[part] = value;
            if (url.port) value += ":" + url.port;
            url.host = value;
            break;
        case "host":
            url[part] = value;
            if ($12f7f1fc20a28e05$var$port.test(value)) {
                value = value.split(":");
                url.port = value.pop();
                url.hostname = value.join(":");
            } else {
                url.hostname = value;
                url.port = "";
            }
            break;
        case "protocol":
            url.protocol = value.toLowerCase();
            url.slashes = !fn;
            break;
        case "pathname":
        case "hash":
            if (value) {
                var char = part === "pathname" ? "/" : "#";
                url[part] = value.charAt(0) !== char ? char + value : value;
            } else url[part] = value;
            break;
        case "username":
        case "password":
            url[part] = encodeURIComponent(value);
            break;
        case "auth":
            var index = value.indexOf(":");
            if (~index) {
                url.username = value.slice(0, index);
                url.username = encodeURIComponent(decodeURIComponent(url.username));
                url.password = value.slice(index + 1);
                url.password = encodeURIComponent(decodeURIComponent(url.password));
            } else url.username = encodeURIComponent(decodeURIComponent(value));
    }
    for(var i = 0; i < $12f7f1fc20a28e05$var$rules.length; i++){
        var ins = $12f7f1fc20a28e05$var$rules[i];
        if (ins[4]) url[ins[1]] = url[ins[1]].toLowerCase();
    }
    url.auth = url.password ? url.username + ":" + url.password : url.username;
    url.origin = url.protocol !== "file:" && $12f7f1fc20a28e05$var$isSpecial(url.protocol) && url.host ? url.protocol + "//" + url.host : "null";
    url.href = url.toString();
    return url;
}
/**
 * Transform the properties back in to a valid and full URL string.
 *
 * @param {Function} stringify Optional query stringify function.
 * @returns {String} Compiled version of the URL.
 * @public
 */ function $12f7f1fc20a28e05$var$toString(stringify) {
    if (!stringify || "function" !== typeof stringify) stringify = $kgSRu.stringify;
    var query, url = this, host = url.host, protocol = url.protocol;
    if (protocol && protocol.charAt(protocol.length - 1) !== ":") protocol += ":";
    var result = protocol + (url.protocol && url.slashes || $12f7f1fc20a28e05$var$isSpecial(url.protocol) ? "//" : "");
    if (url.username) {
        result += url.username;
        if (url.password) result += ":" + url.password;
        result += "@";
    } else if (url.password) {
        result += ":" + url.password;
        result += "@";
    } else if (url.protocol !== "file:" && $12f7f1fc20a28e05$var$isSpecial(url.protocol) && !host && url.pathname !== "/") //
    // Add back the empty userinfo, otherwise the original invalid URL
    // might be transformed into a valid one with `url.pathname` as host.
    //
    result += "@";
    //
    // Trailing colon is removed from `url.host` when it is parsed. If it still
    // ends with a colon, then add back the trailing colon that was removed. This
    // prevents an invalid URL from being transformed into a valid one.
    //
    if (host[host.length - 1] === ":" || $12f7f1fc20a28e05$var$port.test(url.hostname) && !url.port) host += ":";
    result += host + url.pathname;
    query = "object" === typeof url.query ? stringify(url.query) : url.query;
    if (query) result += "?" !== query.charAt(0) ? "?" + query : query;
    if (url.hash) result += url.hash;
    return result;
}
$12f7f1fc20a28e05$var$Url.prototype = {
    set: $12f7f1fc20a28e05$var$set,
    toString: $12f7f1fc20a28e05$var$toString
};
//
// Expose the URL parser and some additional properties that might be useful for
// others or testing.
//
$12f7f1fc20a28e05$var$Url.extractProtocol = $12f7f1fc20a28e05$var$extractProtocol;
$12f7f1fc20a28e05$var$Url.location = $12f7f1fc20a28e05$var$lolcation;
$12f7f1fc20a28e05$var$Url.trimLeft = $12f7f1fc20a28e05$var$trimLeft;
$12f7f1fc20a28e05$var$Url.qs = $kgSRu;
module.exports = $12f7f1fc20a28e05$var$Url;

});
parcelRegister("lMJj8", function(module, exports) {
"use strict";
/**
 * Check if we're required to add a port number.
 *
 * @see https://url.spec.whatwg.org/#default-port
 * @param {Number|String} port Port number we need to check
 * @param {String} protocol Protocol we need to check against.
 * @returns {Boolean} Is it a default port for the given protocol
 * @api private
 */ module.exports = function required(port, protocol) {
    protocol = protocol.split(":")[0];
    port = +port;
    if (!port) return false;
    switch(protocol){
        case "http":
        case "ws":
            return port !== 80;
        case "https":
        case "wss":
            return port !== 443;
        case "ftp":
            return port !== 21;
        case "gopher":
            return port !== 70;
        case "file":
            return false;
    }
    return port !== 0;
};

});

parcelRegister("kgSRu", function(module, exports) {

$parcel$export(module.exports, "stringify", function () { return $ec1fdba703a1d67e$export$fac44ee5b035f737; }, function (v) { return $ec1fdba703a1d67e$export$fac44ee5b035f737 = v; });
$parcel$export(module.exports, "parse", function () { return $ec1fdba703a1d67e$export$98e6a39c04603d36; }, function (v) { return $ec1fdba703a1d67e$export$98e6a39c04603d36 = v; });
//
// Expose the module.
//
var $ec1fdba703a1d67e$export$fac44ee5b035f737;
var $ec1fdba703a1d67e$export$98e6a39c04603d36;
"use strict";
var $ec1fdba703a1d67e$var$has = Object.prototype.hasOwnProperty, $ec1fdba703a1d67e$var$undef;
/**
 * Decode a URI encoded string.
 *
 * @param {String} input The URI encoded string.
 * @returns {String|Null} The decoded string.
 * @api private
 */ function $ec1fdba703a1d67e$var$decode(input) {
    try {
        return decodeURIComponent(input.replace(/\+/g, " "));
    } catch (e) {
        return null;
    }
}
/**
 * Attempts to encode a given input.
 *
 * @param {String} input The string that needs to be encoded.
 * @returns {String|Null} The encoded string.
 * @api private
 */ function $ec1fdba703a1d67e$var$encode(input) {
    try {
        return encodeURIComponent(input);
    } catch (e) {
        return null;
    }
}
/**
 * Simple query string parser.
 *
 * @param {String} query The query string that needs to be parsed.
 * @returns {Object}
 * @api public
 */ function $ec1fdba703a1d67e$var$querystring(query) {
    var parser = /([^=?#&]+)=?([^&]*)/g, result = {}, part;
    while(part = parser.exec(query)){
        var key = $ec1fdba703a1d67e$var$decode(part[1]), value = $ec1fdba703a1d67e$var$decode(part[2]);
        //
        // Prevent overriding of existing properties. This ensures that build-in
        // methods like `toString` or __proto__ are not overriden by malicious
        // querystrings.
        //
        // In the case if failed decoding, we want to omit the key/value pairs
        // from the result.
        //
        if (key === null || value === null || key in result) continue;
        result[key] = value;
    }
    return result;
}
/**
 * Transform a query string to an object.
 *
 * @param {Object} obj Object that should be transformed.
 * @param {String} prefix Optional prefix.
 * @returns {String}
 * @api public
 */ function $ec1fdba703a1d67e$var$querystringify(obj, prefix) {
    prefix = prefix || "";
    var pairs = [], value, key;
    //
    // Optionally prefix with a '?' if needed
    //
    if ("string" !== typeof prefix) prefix = "?";
    for(key in obj)if ($ec1fdba703a1d67e$var$has.call(obj, key)) {
        value = obj[key];
        //
        // Edge cases where we actually want to encode the value to an empty
        // string instead of the stringified value.
        //
        if (!value && (value === null || value === $ec1fdba703a1d67e$var$undef || isNaN(value))) value = "";
        key = $ec1fdba703a1d67e$var$encode(key);
        value = $ec1fdba703a1d67e$var$encode(value);
        //
        // If we failed to encode the strings, we should bail out as we don't
        // want to add invalid strings to the query.
        //
        if (key === null || value === null) continue;
        pairs.push(key + "=" + value);
    }
    return pairs.length ? prefix + pairs.join("&") : "";
}
$ec1fdba703a1d67e$export$fac44ee5b035f737 = $ec1fdba703a1d67e$var$querystringify;
$ec1fdba703a1d67e$export$98e6a39c04603d36 = $ec1fdba703a1d67e$var$querystring;

});


parcelRegister("731ua", function(module, exports) {
var $5219f7333ecb0b74$var$getBaseName = function(assetPathOrURL /*:: :string */ ) {
    return assetPathOrURL.split("#")[0].split("?")[0].split("/").pop();
};
/**
 * Given an asset path or URL isolate the basename and remove the chunk hash and cache-bust integer.
 *
 * IMPORTANT
 *  - this algorithm must exactly match the webpack output filename format in webpack.config.js
 *  - this code must be nodejs compatible as it is also used in the webpack.config.js
 */ var $5219f7333ecb0b74$var$sanitiseAssetName = function(isDevelopment /*:: :boolean */ ) {
    return function(assetPathOrURL /*:: :string */ ) {
        var baseName = $5219f7333ecb0b74$var$getBaseName(assetPathOrURL);
        // we desire "[name.with.dots].[ext]"
        // in debug we expect "[name.with.dots].[ext]"
        // in production we expect "[name.with.dots].[hash].[cache-bust].[ext]"
        var split = baseName.split(".");
        // CHANGED: Need to add to process.env.BUNDLER
        var BUNDLER = "parcel";
        if (BUNDLER === "parcel") {
            if (split.length === 1) // Inline bundles are only an id
            return split[0];
            // return the first part and extension - this should always be valid for Parcel bundles.
            // In the case of shared bundles (e.g. shared.hash.js) this will return 'shared.js'.
            // This will cause only the first shared bundle loaded to be tracked.
            // In the short term this is desired to prevent too much noise.
            return [
                split[0],
                split[split.length - 1]
            ].join(".");
        }
        if (isDevelopment || split.length < 2) return baseName;
        // CHANGED
        var file = split.slice(0, 1);
        var extension = split.slice(-1);
        return "".concat(file, ".").concat(extension);
    };
};
module.exports = {
    sanitiseAssetName: $5219f7333ecb0b74$var$sanitiseAssetName
};

});


parcelRegister("dmojv", function(module, exports) {


module.exports = (parcelRequire("eg86f"))((parcelRequire("bRvn3")).resolve("kkiwx")).then(function() {
    return parcelRequire("5QVPE");
});

});
parcelRegister("eg86f", function(module, exports) {
"use strict";

var $31a2I = parcelRequire("31a2I");
module.exports = $31a2I(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("31a2I", function(module, exports) {
"use strict";
var $23294162c634ba05$var$cachedBundles = {};
var $23294162c634ba05$var$cachedPreloads = {};
var $23294162c634ba05$var$cachedPrefetches = {};
function $23294162c634ba05$var$getCache(type) {
    switch(type){
        case "preload":
            return $23294162c634ba05$var$cachedPreloads;
        case "prefetch":
            return $23294162c634ba05$var$cachedPrefetches;
        default:
            return $23294162c634ba05$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $23294162c634ba05$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});





parcelRegister("1HWyq", function(module, exports) {

$parcel$export(module.exports, "InitializeAutoAtlAnalytics", function () { return (parcelRequire("ifIti")).InitializeAutoAtlAnalytics; });

var $ifIti = parcelRequire("ifIti");

});
parcelRegister("ifIti", function(module, exports) {

$parcel$export(module.exports, "InitializeAutoAtlAnalytics", function () { return $b764d41293575372$export$81535e9b19050d04; });

var $cv9Rk = parcelRequire("cv9Rk");

var $1Mpn7 = parcelRequire("1Mpn7");

var $g1gbh = parcelRequire("g1gbh");

var $2NtzU = parcelRequire("2NtzU");

var $2Pnqs = parcelRequire("2Pnqs");
var $b764d41293575372$var$deepClone = function(obj) {
    return JSON.parse(JSON.stringify(obj));
};
var $b764d41293575372$var$InitializeAutoAtlAnalyticsImpl = function(param) {
    var _param_pageViewProperties = param.pageViewProperties, pageViewProperties = _param_pageViewProperties === void 0 ? {} : _param_pageViewProperties, createAnalyticsEvent = param.createAnalyticsEvent;
    var analyticsClient = (0, $2NtzU.useAnalyticsClient)();
    var _useAnalyticsOptOut = (0, $cv9Rk._)((0, $2NtzU.useAnalyticsOptOut)(), 1), analyticsOptOut = _useAnalyticsOptOut[0];
    var ANALYTICS_WRITE_KEY = "kiv6wyh2nw";
    (0, $1Mpn7.useEffect)(function() {
        if (!analyticsClient || analyticsOptOut) return;
        (0, $2Pnqs.Initializer).initWithPageAnalytics(ANALYTICS_WRITE_KEY, $b764d41293575372$var$deepClone(pageViewProperties), {}, Date.now(), analyticsClient.getAnonymousId(), createAnalyticsEvent || null);
    }, [
        analyticsClient
    ]);
    return null;
};
var $b764d41293575372$export$81535e9b19050d04 = (0, $g1gbh.default)()($b764d41293575372$var$InitializeAutoAtlAnalyticsImpl);

});
parcelRegister("g1gbh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba994a8d4225d0de$export$2e2bcd8739ae039; });

var $fjkYW = parcelRequire("fjkYW");

var $1Mpn7 = parcelRequire("1Mpn7");

var $145N3 = parcelRequire("145N3");

var $2aTkC = parcelRequire("2aTkC");
var $ba994a8d4225d0de$var$withAnalyticsEvents = function withAnalyticsEvents() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function(WrappedComponent) {
        var WithAnalyticsEvents = /*#__PURE__*/ (0, $1Mpn7.forwardRef)(function(props, ref) {
            var _usePatchedProps = (0, $2aTkC.usePatchedProps)(createEventMap, props), patchedEventProps = _usePatchedProps.patchedEventProps;
            var _useAnalyticsEvents = (0, $145N3.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($fjkYW)))({}, props, patchedEventProps, {
                createAnalyticsEvent: createAnalyticsEvent,
                ref: ref
            }));
        });
        // @ts-ignore
        WithAnalyticsEvents.displayName = "WithAnalyticsEvents(".concat(// @ts-ignore disneyName doesn't exist on type
        WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsEvents;
    };
};
var $ba994a8d4225d0de$export$2e2bcd8739ae039 = $ba994a8d4225d0de$var$withAnalyticsEvents;

});
parcelRegister("145N3", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $0c6aa7f664b3b7b6$export$5bf35293e545f20c; });

var $8tMco = parcelRequire("8tMco");

var $jVSPy = parcelRequire("jVSPy");

var $gVJ1N = parcelRequire("gVJ1N");
function $0c6aa7f664b3b7b6$export$5bf35293e545f20c() {
    var analyticsContext = (0, $gVJ1N.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $8tMco.useCallbackOne)(function(payload) {
        return new (0, $jVSPy.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("8tMco", function(module, exports) {

$parcel$export(module.exports, "useCallbackOne", function () { return $62c66b72ba757ae4$export$33752cf3ee811995; });

var $1Mpn7 = parcelRequire("1Mpn7");
function $62c66b72ba757ae4$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function $62c66b72ba757ae4$export$b6feb8998cd9b342(getResult, inputs) {
    var initial = (0, $1Mpn7.useState)(function() {
        return {
            inputs: inputs,
            result: getResult()
        };
    })[0];
    var isFirstRun = (0, $1Mpn7.useRef)(true);
    var committed = (0, $1Mpn7.useRef)(initial);
    var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && $62c66b72ba757ae4$var$areInputsEqual(inputs, committed.current.inputs));
    var cache = useCache ? committed.current : {
        inputs: inputs,
        result: getResult()
    };
    (0, $1Mpn7.useEffect)(function() {
        isFirstRun.current = false;
        committed.current = cache;
    }, [
        cache
    ]);
    return cache.result;
}
function $62c66b72ba757ae4$export$33752cf3ee811995(callback, inputs) {
    return $62c66b72ba757ae4$export$b6feb8998cd9b342(function() {
        return callback;
    }, inputs);
}
var $62c66b72ba757ae4$export$1538c33de8887b59 = $62c66b72ba757ae4$export$b6feb8998cd9b342;
var $62c66b72ba757ae4$export$35808ee640e87ca7 = $62c66b72ba757ae4$export$33752cf3ee811995;

});

parcelRegister("jVSPy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e82ddf5e3cea1fbe$export$2e2bcd8739ae039; });

var $eetQ9 = parcelRequire("eetQ9");

var $6QU8A = parcelRequire("6QU8A");

var $2Yk1N = parcelRequire("2Yk1N");

var $hgJzq = parcelRequire("hgJzq");

var $gzkFF = parcelRequire("gzkFF");

var $eZhUW = parcelRequire("eZhUW");

var $kcuts = parcelRequire("kcuts");

var $6pDhi = parcelRequire("6pDhi");

var $jjExS = parcelRequire("jjExS");

var $4afLk = parcelRequire("4afLk");
function $e82ddf5e3cea1fbe$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $e82ddf5e3cea1fbe$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($6pDhi)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($6pDhi)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($kcuts)))(this, result);
    };
}
function $e82ddf5e3cea1fbe$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $e82ddf5e3cea1fbe$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $e82ddf5e3cea1fbe$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 ? void 0 : (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $e82ddf5e3cea1fbe$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($eZhUW)))(UIAnalyticsEvent, _AnalyticsEvent);
    var _super = $e82ddf5e3cea1fbe$var$_createSuper(UIAnalyticsEvent);
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($6QU8A)))(this, UIAnalyticsEvent);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))((0, (/*@__PURE__*/$parcel$interopDefault($hgJzq)))(_this), "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))((0, (/*@__PURE__*/$parcel$interopDefault($hgJzq)))(_this), "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($eetQ9)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($eetQ9)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))((0, (/*@__PURE__*/$parcel$interopDefault($hgJzq)))(_this), "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler((0, (/*@__PURE__*/$parcel$interopDefault($hgJzq)))(_this), channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($2Yk1N)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return (0, (/*@__PURE__*/$parcel$interopDefault($gzkFF)))((0, (/*@__PURE__*/$parcel$interopDefault($6pDhi)))(UIAnalyticsEvent.prototype), "update", this).call(this, updater);
            }
        }
    ]);
    return UIAnalyticsEvent;
}((0, $4afLk.default));

});
parcelRegister("gzkFF", function(module, exports) {

var $6FxMH = parcelRequire("6FxMH");
function $c0fff3100d1f8c41$var$_get() {
    if (typeof Reflect !== "undefined" && Reflect.get) module.exports = $c0fff3100d1f8c41$var$_get = Reflect.get.bind(), module.exports.__esModule = true, module.exports["default"] = module.exports;
    else module.exports = $c0fff3100d1f8c41$var$_get = function _get(target, property, receiver) {
        var base = $6FxMH(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(arguments.length < 3 ? target : receiver);
        return desc.value;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $c0fff3100d1f8c41$var$_get.apply(this, arguments);
}
module.exports = $c0fff3100d1f8c41$var$_get, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("6FxMH", function(module, exports) {

var $6pDhi = parcelRequire("6pDhi");
function $4db0c74991f22394$var$_superPropBase(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = $6pDhi(object);
        if (object === null) break;
    }
    return object;
}
module.exports = $4db0c74991f22394$var$_superPropBase, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("4afLk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $308452b0c1d6b0b8$export$2e2bcd8739ae039; });

var $2nffd = parcelRequire("2nffd");

var $6QU8A = parcelRequire("6QU8A");

var $2Yk1N = parcelRequire("2Yk1N");

var $jjExS = parcelRequire("jjExS");
function $308452b0c1d6b0b8$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $308452b0c1d6b0b8$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $308452b0c1d6b0b8$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $308452b0c1d6b0b8$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $308452b0c1d6b0b8$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $308452b0c1d6b0b8$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 ? void 0 : (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $308452b0c1d6b0b8$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($6QU8A)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $308452b0c1d6b0b8$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($2Yk1N)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($2nffd)))(updater) === "object") this.payload = $308452b0c1d6b0b8$var$_objectSpread($308452b0c1d6b0b8$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
    return AnalyticsEvent;
}();

});



parcelRegister("2aTkC", function(module, exports) {

$parcel$export(module.exports, "usePatchedProps", function () { return $19576fa1494950f6$export$9ebb5a84d17e5d18; });

var $jjExS = parcelRequire("jjExS");

var $2nffd = parcelRequire("2nffd");

var $1Mpn7 = parcelRequire("1Mpn7");

var $145N3 = parcelRequire("145N3");
function $19576fa1494950f6$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $19576fa1494950f6$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $19576fa1494950f6$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $19576fa1494950f6$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $19576fa1494950f6$export$9ebb5a84d17e5d18() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var wrappedComponentProps = arguments.length > 1 ? arguments[1] : undefined;
    var _useAnalyticsEvents = (0, $145N3.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var handlerCache = (0, $1Mpn7.useRef)({});
    var patchedProps = (0, $1Mpn7.useMemo)(function() {
        var cache = handlerCache.current;
        // Clean up no longer used handlers in cache
        Object.keys(cache).filter(function(key) {
            return !(key in createEventMap);
        }).forEach(function(key) {
            return delete cache[key];
        });
        return Object.keys(createEventMap).reduce(function(p, k) {
            var eventCreator = createEventMap[k];
            if (![
                "object",
                "function"
            ].includes((0, (/*@__PURE__*/$parcel$interopDefault($2nffd)))(eventCreator))) return p;
            var propValue = wrappedComponentProps[k];
            if (k in cache && cache[k].eventCreator === eventCreator && cache[k].propValue === propValue) return $19576fa1494950f6$var$_objectSpread($19576fa1494950f6$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))({}, k, cache[k].wrappedCallback));
            var wrappedCallback = function wrappedCallback() {
                var analyticsEvent = typeof eventCreator === "function" ? eventCreator(createAnalyticsEvent, wrappedComponentProps) : createAnalyticsEvent(eventCreator);
                if (propValue && typeof propValue === "function") {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    propValue.apply(void 0, args.concat([
                        analyticsEvent
                    ]));
                }
            };
            cache[k] = {
                eventCreator: eventCreator,
                wrappedCallback: wrappedCallback,
                propValue: propValue
            };
            return $19576fa1494950f6$var$_objectSpread($19576fa1494950f6$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))({}, k, wrappedCallback));
        }, {});
    }, [
        createEventMap,
        wrappedComponentProps,
        createAnalyticsEvent,
        handlerCache
    ]);
    return {
        patchedEventProps: patchedProps
    };
}

});


parcelRegister("2NtzU", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsOptOut", function () { return $773d0a25975cf5b4$export$a0fc6e748d26e0d0; });
$parcel$export(module.exports, "WacAnalyticsListener", function () { return $773d0a25975cf5b4$export$cc11fd4b7198f590; });
$parcel$export(module.exports, "useAnalyticsClient", function () { return $773d0a25975cf5b4$export$923054f18cb06572; });
$parcel$export(module.exports, "WacAnalyticsClientProvider", function () { return $773d0a25975cf5b4$export$f84a51d6dd0d7383; });
// @ts-ignore

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");

var $1rY3h = parcelRequire("1rY3h");

var $1Mpn7 = parcelRequire("1Mpn7");

var $4itqO = parcelRequire("4itqO");

var $9dPw1 = parcelRequire("9dPw1");

var $7Y96P = parcelRequire("7Y96P");

var $6E1VX = parcelRequire("6E1VX");
var $773d0a25975cf5b4$var$getGASv3Environment = function(envTypes) {
    return envTypes.PROD;
};
var $773d0a25975cf5b4$var$getXidEnvironment = function() {
    return (0, $9dPw1.Environment).PROD;
};
var $773d0a25975cf5b4$var$shouldUseStargate = function() {
    return true;
};
var $773d0a25975cf5b4$var$getAtlassianUserId = function() {
    var userId = (0, $7Y96P.Cookie).readCookie("__aid_user_id");
    if (userId) return decodeURIComponent(userId);
    return null;
};
var $773d0a25975cf5b4$export$a0fc6e748d26e0d0 = function() {
    var _useState = (0, $cv9Rk._)((0, $1Mpn7.useState)(true), 2), analyticsOptOut = _useState[0], setAnalyticsOptOut = _useState[1];
    (0, $1Mpn7.useEffect)(function() {
        var _exec;
        var OptanonConsentValue = (_exec = new RegExp("OptanonConsent=([^;]+)").exec(document.cookie)) === null || _exec === void 0 ? void 0 : _exec[1];
        var currentAnalyticsOptOut = OptanonConsentValue ? decodeURIComponent(OptanonConsentValue).includes(",2:0") : false;
        if (analyticsOptOut !== currentAnalyticsOptOut) setAnalyticsOptOut(currentAnalyticsOptOut);
    }, [
        analyticsOptOut
    ]);
    return [
        analyticsOptOut
    ];
};
var $773d0a25975cf5b4$var$getAnonIdUsedByFeatureGatesClientInSSR = function() {
    return window.featureGateBootstrapValues.identifiers.analyticsAnonymousId;
};
var $773d0a25975cf5b4$var$AnalyticsWebClientContext = /*#__PURE__*/ (0, $1Mpn7.createContext)({
    analyticsWebClientInstance: null
});
var $773d0a25975cf5b4$export$cc11fd4b7198f590 = function(param) {
    var children = param.children;
    var analyticsClient = $773d0a25975cf5b4$export$923054f18cb06572();
    var _useAnalyticsOptOut = (0, $cv9Rk._)($773d0a25975cf5b4$export$a0fc6e748d26e0d0(), 1), analyticsOptOut = _useAnalyticsOptOut[0];
    var _useState = (0, $cv9Rk._)((0, $1Mpn7.useState)("false"), 2), loginUserDetected = _useState[0], setLoginUserDetected = _useState[1];
    (0, $1Mpn7.useEffect)(function() {
        var cookieValue = (0, $7Y96P.Cookie).readCookie("login_user_detected");
        if (cookieValue) setLoginUserDetected(cookieValue);
    }, []);
    var onEvent = (0, $1Mpn7.useCallback)(function(event, channel) {
        var _window;
        if (!analyticsClient || analyticsOptOut) return;
        if (channel === "signup") {
            var analyticsDataList = (0, $c6Xmf._)(event.context).concat([
                event.payload
            ]);
            var analyticsEventMagnolia = analyticsDataList.reduce(function(mergedAnalyticsEvent, currentAnalyicsEvent) {
                return (0, $do9pw._)({}, mergedAnalyticsEvent, currentAnalyicsEvent);
            }, {});
            (0, $6E1VX.Tracking).trackEvent(analyticsEventMagnolia["eventName"], analyticsEventMagnolia);
            return;
        }
        // TODO - in the future add any default context
        var processedEventPayload = (0, $cxjpp._)((0, $do9pw._)({
            actionSubject: "component",
            eventType: "ui",
            source: "default"
        }, event.payload), {
            attributes: (0, $cxjpp._)((0, $do9pw._)({}, event.payload["attributes"] || {}), {
                loginUserDetected: loginUserDetected
            })
        });
        if (!!((_window = window) === null || _window === void 0 ? void 0 : _window.cmsPageVariant)) processedEventPayload["attributes"].cmsPageVariant = window.cmsPageVariant;
        var ANALYTICS_TYPE = "gasv3";
        if (ANALYTICS_TYPE === "console") {
            console.log({
                event: processedEventPayload
            });
            analyticsClient.onEvent(null, processedEventPayload);
        } else analyticsClient.onEvent(null, processedEventPayload);
    }, [
        analyticsClient,
        analyticsOptOut,
        loginUserDetected
    ]);
    return(/**
     * Current channels are:
     * - atl-global: For all auto-generated events from InitializeAutoAtlAnalytics
     * - marketing: For events generated via the React components themselves
     *
     * TODO - can add in the FabricEventsListeners to catch atlasKit and fabric components etc.
     */ /*#__PURE__*/ (0, $1rY3h.jsx)((0, $4itqO.default), {
        channel: "*",
        onEvent: onEvent,
        children: children
    }));
};

var $773d0a25975cf5b4$export$f84a51d6dd0d7383 = function(param) {
    var children = param.children;
    var _useState = (0, $cv9Rk._)((0, $1Mpn7.useState)(null), 2), analyticsWebClientInstance = _useState[0], setAnalyticsWebClientInstance = _useState[1];
    (0, $1Mpn7.useEffect)(function() {
        if (typeof window !== "undefined") (parcelRequire("e63qO")).then(function(Module) {
            var AnalyticsWebClientLib = Module.default;
            var envTypes = Module.envType;
            var userTypes = Module.userType;
            var client = new AnalyticsWebClientLib({
                env: $773d0a25975cf5b4$var$getGASv3Environment(envTypes),
                product: "marketing",
                version: "1.0.0",
                locale: "en-us"
            }, {
                useStargate: $773d0a25975cf5b4$var$shouldUseStargate(),
                xidConsent: true,
                xidPromiseFn: function() {
                    return new (0, $9dPw1.XID)($773d0a25975cf5b4$var$getXidEnvironment()).getXidCallbackForPromise();
                },
                // If SSR wasn't given an anonymous ID cookie, then it will generate one and pass it down.
                // This function will ensure the analytics client uses the same one instead of generating another.
                customAnonymousIdGenerator: $773d0a25975cf5b4$var$getAnonIdUsedByFeatureGatesClientInSSR
            });
            var aaid = $773d0a25975cf5b4$var$getAtlassianUserId();
            if (aaid) client.setUserInfo(userTypes.ATLASSIAN_ACCOUNT, aaid);
            // If the FeatureGates and analytics clients are using different identifiers,
            // it means that the client already had an anonymousId in localStorage and/or cookies,
            // but SSR was unable to use it, either because the client had blocked sending cookies,
            // or because there was some issue extracting it.
            // An identifier mismatch means we won't be able to include this session in the experiment metrics.
            // We capture an operational event here as a way to tell how much data we've lost in our experiment results.
            var featureGatesAnonId = $773d0a25975cf5b4$var$getAnonIdUsedByFeatureGatesClientInSSR();
            if ($773d0a25975cf5b4$var$getAnonIdUsedByFeatureGatesClientInSSR() !== client.getAnonymousId()) client.sendOperationalEvent({
                action: "mismatched",
                actionSubject: "anonymousId",
                source: "awcInitialization",
                attributes: {
                    featureGatesAnonId: featureGatesAnonId
                }
            });
            setAnalyticsWebClientInstance(client);
        });
    }, []);
    return /*#__PURE__*/ (0, $1rY3h.jsx)($773d0a25975cf5b4$var$AnalyticsWebClientContext.Provider, {
        value: {
            analyticsWebClientInstance: analyticsWebClientInstance
        },
        children: children
    });
};
var $773d0a25975cf5b4$export$923054f18cb06572 = function() {
    var context = (0, $1Mpn7.useContext)($773d0a25975cf5b4$var$AnalyticsWebClientContext);
    if (!context) throw new Error("calls to useAnalyticsClient must be wrapped in <WacAnalyticsClientProvider>!");
    return context.analyticsWebClientInstance;
};

});
parcelRegister("4itqO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $320fac5114db9cac$export$2e2bcd8739ae039; });

var $lLoAw = parcelRequire("lLoAw");

var $awZ87 = parcelRequire("awZ87");

var $3qWgZ = parcelRequire("3qWgZ");
var $320fac5114db9cac$var$_process$env;
var $320fac5114db9cac$var$ExportedAnalyticsListener;
if (typeof $3qWgZ !== "undefined" && $3qWgZ !== null && ($320fac5114db9cac$var$_process$env = {}, true) && $320fac5114db9cac$var$_process$env !== void 0 && $320fac5114db9cac$var$_process$env["ANALYTICS_NEXT_MODERN_CONTEXT"]) $320fac5114db9cac$var$ExportedAnalyticsListener = (0, $awZ87.default);
else $320fac5114db9cac$var$ExportedAnalyticsListener = (0, $lLoAw.default);
var $320fac5114db9cac$export$2e2bcd8739ae039 = $320fac5114db9cac$var$ExportedAnalyticsListener;

});
parcelRegister("lLoAw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd810f70c6bc5f4e$export$2e2bcd8739ae039; });

var $eetQ9 = parcelRequire("eetQ9");

var $6QU8A = parcelRequire("6QU8A");

var $2Yk1N = parcelRequire("2Yk1N");

var $hgJzq = parcelRequire("hgJzq");

var $eZhUW = parcelRequire("eZhUW");

var $kcuts = parcelRequire("kcuts");

var $6pDhi = parcelRequire("6pDhi");

var $jjExS = parcelRequire("jjExS");

var $1Mpn7 = parcelRequire("1Mpn7");

var $3shKn = parcelRequire("3shKn");

var $3z3zk = parcelRequire("3z3zk");
function $fd810f70c6bc5f4e$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $fd810f70c6bc5f4e$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($6pDhi)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($6pDhi)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($kcuts)))(this, result);
    };
}
function $fd810f70c6bc5f4e$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $fd810f70c6bc5f4e$var$ContextTypes = {
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($3shKn))).func,
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($3shKn))).func
};
var $fd810f70c6bc5f4e$var$noop = function noop() {
    return [];
};
// eslint-disable-next-line @repo/internal/react/no-class-components
var $fd810f70c6bc5f4e$var$AnalyticsListener = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($eZhUW)))(AnalyticsListener, _Component);
    var _super = $fd810f70c6bc5f4e$var$_createSuper(AnalyticsListener);
    function AnalyticsListener(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($6QU8A)))(this, AnalyticsListener);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))((0, (/*@__PURE__*/$parcel$interopDefault($hgJzq)))(_this), "getChildContext", function() {
            return {
                getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers,
                getAtlaskitAnalyticsContext: _this.getAtlaskitAnalyticsContext
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))((0, (/*@__PURE__*/$parcel$interopDefault($hgJzq)))(_this), "getAnalyticsEventHandlers", function() {
            var _this$props = _this.props, channel = _this$props.channel, onEvent = _this$props.onEvent;
            var _this$context$getAtla = _this.context.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _this$context$getAtla === void 0 ? $fd810f70c6bc5f4e$var$noop : _this$context$getAtla;
            var handler = function handler(event, eventChannel) {
                if (channel === "*" || channel === eventChannel) onEvent(event, eventChannel);
            };
            return [
                handler
            ].concat((0, (/*@__PURE__*/$parcel$interopDefault($eetQ9)))(getAtlaskitAnalyticsEventHandlers()));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))((0, (/*@__PURE__*/$parcel$interopDefault($hgJzq)))(_this), "getAtlaskitAnalyticsContext", function() {
            var _this$context$getAtla2 = _this.context.getAtlaskitAnalyticsContext, getAtlaskitAnalyticsContext = _this$context$getAtla2 === void 0 ? $fd810f70c6bc5f4e$var$noop : _this$context$getAtla2;
            return getAtlaskitAnalyticsContext();
        });
        _this.contextValue = {
            getAtlaskitAnalyticsContext: _this.getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers
        };
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($2Yk1N)))(AnalyticsListener, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $3z3zk.default).Provider, {
                    value: this.contextValue
                }, children);
            }
        }
    ]);
    return AnalyticsListener;
}((0, $1Mpn7.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))($fd810f70c6bc5f4e$var$AnalyticsListener, "contextTypes", $fd810f70c6bc5f4e$var$ContextTypes);
(0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))($fd810f70c6bc5f4e$var$AnalyticsListener, "childContextTypes", $fd810f70c6bc5f4e$var$ContextTypes);
var $fd810f70c6bc5f4e$export$2e2bcd8739ae039 = $fd810f70c6bc5f4e$var$AnalyticsListener;

});

parcelRegister("awZ87", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7aac4fab657361ba$export$2e2bcd8739ae039; });

var $eetQ9 = parcelRequire("eetQ9");

var $1Mpn7 = parcelRequire("1Mpn7");

var $3z3zk = parcelRequire("3z3zk");

var $gVJ1N = parcelRequire("gVJ1N");

var $8JCSe = parcelRequire("8JCSe");
var $7aac4fab657361ba$var$AnalyticsListener = function AnalyticsListener(_ref) {
    var children = _ref.children, channel = _ref.channel, onEvent = _ref.onEvent;
    var analyticsContext = (0, $gVJ1N.useAnalyticsContext)();
    var onEventRef = (0, $8JCSe.useTrackedRef)(onEvent);
    var channelRef = (0, $8JCSe.useTrackedRef)(channel);
    var getAtlaskitAnalyticsEventHandlers = (0, $1Mpn7.useCallback)(function() {
        var thisHandler = function thisHandler(event, eventChannel) {
            if (channelRef.current === "*" || channelRef.current === eventChannel) onEventRef.current(event, eventChannel);
        };
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($eetQ9)))(analyticsContext.getAtlaskitAnalyticsEventHandlers()), [
            thisHandler
        ]);
    }, [
        analyticsContext,
        channelRef,
        onEventRef
    ]);
    var value = (0, $1Mpn7.useMemo)(function() {
        return {
            getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers,
            getAtlaskitAnalyticsContext: analyticsContext.getAtlaskitAnalyticsContext
        };
    }, [
        analyticsContext,
        getAtlaskitAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $3z3zk.default).Provider, {
        value: value
    }, children);
};
var $7aac4fab657361ba$export$2e2bcd8739ae039 = $7aac4fab657361ba$var$AnalyticsListener;

});


parcelRegister("9dPw1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l29cN = parcelRequire("l29cN");

$l29cN.__exportStar((parcelRequire("d815O")), module.exports);

var $dMiFw = parcelRequire("dMiFw");
module.exports.XID = $dMiFw.XID;

});
parcelRegister("d815O", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $98ecdeb3acf356d1$var$Environment;
(function(Environment) {
    Environment["TEST"] = "test";
    Environment["LOCAL"] = "local";
    Environment["DEV"] = "dev";
    Environment["STAGE"] = "stage";
    Environment["PROD"] = "prod";
})($98ecdeb3acf356d1$var$Environment = module.exports.Environment || (module.exports.Environment = {}));
var $98ecdeb3acf356d1$var$XIDItemType;
(function(XIDItemType) {
    XIDItemType["XC"] = "xc";
    XIDItemType["UID"] = "uid";
})($98ecdeb3acf356d1$var$XIDItemType = module.exports.XIDItemType || (module.exports.XIDItemType = {}));
var $98ecdeb3acf356d1$var$XIDState;
(function(XIDState) {
    XIDState["NEW"] = "NEW";
    XIDState["CHANGED"] = "CHANGED";
    XIDState["EXISTING"] = "EXISTING";
    XIDState["TIMEOUT"] = "TIMEOUT";
    XIDState["ERROR"] = "ERROR";
    XIDState["UNAVAILABLE"] = "UNAVAILABLE";
    XIDState["MALFORMED"] = "MALFORMED";
    XIDState["UNKNOWN"] = "UNKNOWN";
})($98ecdeb3acf356d1$var$XIDState = module.exports.XIDState || (module.exports.XIDState = {}));
var $98ecdeb3acf356d1$var$XIDGenerateMode;
(function(XIDGenerateMode) {
    XIDGenerateMode["XC_ONLY"] = "XC_ONLY";
    XIDGenerateMode["UID_ONLY"] = "UID_ONLY";
    XIDGenerateMode["CACHE_ONLY"] = "CACHE_ONLY";
    XIDGenerateMode["XC_UID"] = "XC_UID";
    XIDGenerateMode["CACHE_XC_UID"] = "CACHE_XC_UID";
})($98ecdeb3acf356d1$var$XIDGenerateMode = module.exports.XIDGenerateMode || (module.exports.XIDGenerateMode = {}));

});

parcelRegister("dMiFw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l29cN = parcelRequire("l29cN");

var $a07e3d46b3d117a5$var$promise_polyfill_1 = $l29cN.__importDefault((parcelRequire("5acao")));

var $8v5Y9 = parcelRequire("8v5Y9");

var $4f9Cx = parcelRequire("4f9Cx");

var $6Xh0s = parcelRequire("6Xh0s");

var $iaGC2 = parcelRequire("iaGC2");

var $d815O = parcelRequire("d815O");
module.exports.defaultTimeout = 5000;
var $a07e3d46b3d117a5$var$delayUidGenerate = 1e3;
var $a07e3d46b3d117a5$var$nonProdMaxTimeout = 30000;
var $a07e3d46b3d117a5$var$prodMaxTimeout = 10000;
var $a07e3d46b3d117a5$var$minTimeout = 2000;
var $a07e3d46b3d117a5$var$XID = function() {
    function XID(env, timeout) {
        if (env === void 0) env = $d815O.Environment.LOCAL;
        if (timeout === void 0) timeout = module.exports.defaultTimeout;
        this.storageEnabled = true;
        this.timeoutUid = {
            type: $d815O.XIDItemType.UID,
            state: $d815O.XIDState.TIMEOUT
        };
        if (!env) throw new Error("Missing env configuration");
        this.env = env;
        var maxTimeout = this.env === $d815O.Environment.PROD ? $a07e3d46b3d117a5$var$prodMaxTimeout : $a07e3d46b3d117a5$var$nonProdMaxTimeout;
        if (timeout >= $a07e3d46b3d117a5$var$minTimeout && timeout <= maxTimeout) this.timeout = timeout;
        else {
            if (this.env !== $d815O.Environment.PROD) console.log("timeout configuration must be in the range of [" + $a07e3d46b3d117a5$var$minTimeout + ", " + maxTimeout + "] seconds");
            this.timeout = module.exports.defaultTimeout;
        }
    }
    XID.prototype.getTimeoutPromise = function(timeoutXid) {
        var _this = this;
        return new $a07e3d46b3d117a5$var$promise_polyfill_1.default(function(resolve) {
            setTimeout(function() {
                resolve([
                    timeoutXid
                ]);
            }, (_this.timeout - $a07e3d46b3d117a5$var$delayUidGenerate) / 2);
        });
    };
    XID.prototype.getXcPromiseAndSave = function() {
        var _this = this;
        return new $a07e3d46b3d117a5$var$promise_polyfill_1.default(function(resolve) {
            _this.getXc().then(function(xc) {
                if (_this.storageEnabled) $8v5Y9.Storage.saveXid([
                    xc
                ]);
                resolve([
                    xc
                ]);
            });
        });
    };
    XID.prototype.getUidPromiseAndSave = function() {
        var _this = this;
        return new $a07e3d46b3d117a5$var$promise_polyfill_1.default(function(resolve) {
            var handleUid = function handleUid() {
                var cachedUids = [];
                if (_this.storageEnabled) cachedUids = $8v5Y9.Storage.getUids();
                var uids = $4f9Cx.UIDGenerator.getValue(cachedUids);
                if (_this.storageEnabled) {
                    $8v5Y9.Storage.saveUids(uids);
                    $8v5Y9.Storage.saveXid(uids);
                }
                resolve(uids);
            };
            var requestIdleCallback = window.requestIdleCallback;
            requestIdleCallback ? requestIdleCallback(handleUid) : setTimeout(handleUid, $a07e3d46b3d117a5$var$delayUidGenerate);
        });
    };
    XID.prototype.getXidPromiseInXcUidOnly = function() {
        var _this = this;
        return this.getXcPromiseAndSave().then(function(xc) {
            if (xc && xc.length > 0 && xc[0].createdAt && xc[0].value) return xc;
            else return _this.getTimeoutPromise(_this.timeoutUid), _this.getUidPromiseAndSave().then(function(uid) {
                return $l29cN.__spreadArrays(uid, xc);
            });
        });
    };
    XID.prototype.getXidCallbackForPromise = function(mode, storageEnabled) {
        if (mode === void 0) mode = $d815O.XIDGenerateMode.CACHE_XC_UID;
        if (storageEnabled === void 0) storageEnabled = true;
        var transformedXids;
        var transform = function transform(xids) {
            if (transformedXids) return transformedXids;
            transformedXids = xids.map(function(xid) {
                if (xid.state === $d815O.XIDState.NEW || xid.state === $d815O.XIDState.CHANGED) return {
                    state: $d815O.XIDState.EXISTING,
                    type: xid.type,
                    createdAt: xid.createdAt,
                    value: xid.value
                };
                return xid;
            });
            return xids;
        };
        return this.getXidPromise(mode, storageEnabled).then(function(xid) {
            return function() {
                return transform(xid);
            };
        });
    };
    XID.prototype.getXidPromise = function(mode, storageEnabled) {
        var _this = this;
        if (mode === void 0) mode = $d815O.XIDGenerateMode.CACHE_XC_UID;
        if (storageEnabled === void 0) storageEnabled = true;
        this.storageEnabled = storageEnabled;
        var cachedXidValue = mode === $d815O.XIDGenerateMode.CACHE_ONLY || mode === $d815O.XIDGenerateMode.CACHE_XC_UID ? $8v5Y9.Storage.getCachedXID() : [];
        switch(mode){
            case $d815O.XIDGenerateMode.XC_ONLY:
                return $iaGC2.promiseWithTimer(function() {
                    return _this.getXcPromiseAndSave();
                });
            case $d815O.XIDGenerateMode.UID_ONLY:
                return $iaGC2.promiseWithTimer(function() {
                    return $a07e3d46b3d117a5$var$promise_polyfill_1.default.race([
                        _this.getTimeoutPromise(_this.timeoutUid),
                        _this.getUidPromiseAndSave()
                    ]);
                });
            case $d815O.XIDGenerateMode.XC_UID:
                return $iaGC2.promiseWithTimer(function() {
                    return _this.getXidPromiseInXcUidOnly();
                });
            case $d815O.XIDGenerateMode.CACHE_ONLY:
                return $a07e3d46b3d117a5$var$promise_polyfill_1.default.resolve(cachedXidValue);
            case $d815O.XIDGenerateMode.CACHE_XC_UID:
            default:
                return cachedXidValue.length > 0 ? $a07e3d46b3d117a5$var$promise_polyfill_1.default.resolve(cachedXidValue) : $iaGC2.promiseWithTimer(function() {
                    return _this.getXidPromiseInXcUidOnly();
                });
        }
    };
    XID.prototype.getXc = function() {
        return $6Xh0s.XCGenerator.getValue(this.env, (this.timeout - $a07e3d46b3d117a5$var$delayUidGenerate) / 2, this.storageEnabled);
    };
    XID.prototype.getUidDetails = function() {
        return $4f9Cx.UIDGenerator.getDetails();
    };
    return XID;
}();
module.exports.XID = $a07e3d46b3d117a5$var$XID;

});
parcelRegister("5acao", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $3c2752f53104d850$export$2e2bcd8739ae039; });

var $bvrPw = parcelRequire("bvrPw");

var $i0Q6k = parcelRequire("i0Q6k");

var $kPP3G = parcelRequire("kPP3G");
// Store setTimeout reference so promise-polyfill will be unaffected by
// other code modifying setTimeout (like sinon.useFakeTimers())
var $3c2752f53104d850$var$setTimeoutFunc = setTimeout;
function $3c2752f53104d850$var$isArray(x) {
    return Boolean(x && typeof x.length !== "undefined");
}
function $3c2752f53104d850$var$noop() {}
// Polyfill for Function.prototype.bind
function $3c2752f53104d850$var$bind(fn, thisArg) {
    return function() {
        fn.apply(thisArg, arguments);
    };
}
/**
 * @constructor
 * @param {Function} fn
 */ function $3c2752f53104d850$var$Promise(fn) {
    if (!(this instanceof $3c2752f53104d850$var$Promise)) throw new TypeError("Promises must be constructed via new");
    if (typeof fn !== "function") throw new TypeError("not a function");
    /** @type {!number} */ this._state = 0;
    /** @type {!boolean} */ this._handled = false;
    /** @type {Promise|undefined} */ this._value = undefined;
    /** @type {!Array<!Function>} */ this._deferreds = [];
    $3c2752f53104d850$var$doResolve(fn, this);
}
function $3c2752f53104d850$var$handle(self, deferred) {
    while(self._state === 3)self = self._value;
    if (self._state === 0) {
        self._deferreds.push(deferred);
        return;
    }
    self._handled = true;
    $3c2752f53104d850$var$Promise._immediateFn(function() {
        var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
        if (cb === null) {
            (self._state === 1 ? $3c2752f53104d850$var$resolve : $3c2752f53104d850$var$reject)(deferred.promise, self._value);
            return;
        }
        var ret;
        try {
            ret = cb(self._value);
        } catch (e) {
            $3c2752f53104d850$var$reject(deferred.promise, e);
            return;
        }
        $3c2752f53104d850$var$resolve(deferred.promise, ret);
    });
}
function $3c2752f53104d850$var$resolve(self, newValue) {
    try {
        // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
        if (newValue === self) throw new TypeError("A promise cannot be resolved with itself.");
        if (newValue && (typeof newValue === "object" || typeof newValue === "function")) {
            var then = newValue.then;
            if (newValue instanceof $3c2752f53104d850$var$Promise) {
                self._state = 3;
                self._value = newValue;
                $3c2752f53104d850$var$finale(self);
                return;
            } else if (typeof then === "function") {
                $3c2752f53104d850$var$doResolve($3c2752f53104d850$var$bind(then, newValue), self);
                return;
            }
        }
        self._state = 1;
        self._value = newValue;
        $3c2752f53104d850$var$finale(self);
    } catch (e) {
        $3c2752f53104d850$var$reject(self, e);
    }
}
function $3c2752f53104d850$var$reject(self, newValue) {
    self._state = 2;
    self._value = newValue;
    $3c2752f53104d850$var$finale(self);
}
function $3c2752f53104d850$var$finale(self) {
    if (self._state === 2 && self._deferreds.length === 0) $3c2752f53104d850$var$Promise._immediateFn(function() {
        if (!self._handled) $3c2752f53104d850$var$Promise._unhandledRejectionFn(self._value);
    });
    for(var i = 0, len = self._deferreds.length; i < len; i++)$3c2752f53104d850$var$handle(self, self._deferreds[i]);
    self._deferreds = null;
}
/**
 * @constructor
 */ function $3c2752f53104d850$var$Handler(onFulfilled, onRejected, promise) {
    this.onFulfilled = typeof onFulfilled === "function" ? onFulfilled : null;
    this.onRejected = typeof onRejected === "function" ? onRejected : null;
    this.promise = promise;
}
/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */ function $3c2752f53104d850$var$doResolve(fn, self) {
    var done = false;
    try {
        fn(function(value) {
            if (done) return;
            done = true;
            $3c2752f53104d850$var$resolve(self, value);
        }, function(reason) {
            if (done) return;
            done = true;
            $3c2752f53104d850$var$reject(self, reason);
        });
    } catch (ex) {
        if (done) return;
        done = true;
        $3c2752f53104d850$var$reject(self, ex);
    }
}
$3c2752f53104d850$var$Promise.prototype["catch"] = function(onRejected) {
    return this.then(null, onRejected);
};
$3c2752f53104d850$var$Promise.prototype.then = function(onFulfilled, onRejected) {
    // @ts-ignore
    var prom = new this.constructor($3c2752f53104d850$var$noop);
    $3c2752f53104d850$var$handle(this, new $3c2752f53104d850$var$Handler(onFulfilled, onRejected, prom));
    return prom;
};
$3c2752f53104d850$var$Promise.prototype["finally"] = (0, $bvrPw.default);
$3c2752f53104d850$var$Promise.all = function(arr) {
    return new $3c2752f53104d850$var$Promise(function(resolve, reject) {
        if (!$3c2752f53104d850$var$isArray(arr)) return reject(new TypeError("Promise.all accepts an array"));
        var args = Array.prototype.slice.call(arr);
        if (args.length === 0) return resolve([]);
        var remaining = args.length;
        function res(i, val) {
            try {
                if (val && (typeof val === "object" || typeof val === "function")) {
                    var then = val.then;
                    if (typeof then === "function") {
                        then.call(val, function(val) {
                            res(i, val);
                        }, reject);
                        return;
                    }
                }
                args[i] = val;
                if (--remaining === 0) resolve(args);
            } catch (ex) {
                reject(ex);
            }
        }
        for(var i = 0; i < args.length; i++)res(i, args[i]);
    });
};
$3c2752f53104d850$var$Promise.any = (0, $kPP3G.default);
$3c2752f53104d850$var$Promise.allSettled = (0, $i0Q6k.default);
$3c2752f53104d850$var$Promise.resolve = function(value) {
    if (value && typeof value === "object" && value.constructor === $3c2752f53104d850$var$Promise) return value;
    return new $3c2752f53104d850$var$Promise(function(resolve) {
        resolve(value);
    });
};
$3c2752f53104d850$var$Promise.reject = function(value) {
    return new $3c2752f53104d850$var$Promise(function(resolve, reject) {
        reject(value);
    });
};
$3c2752f53104d850$var$Promise.race = function(arr) {
    return new $3c2752f53104d850$var$Promise(function(resolve, reject) {
        if (!$3c2752f53104d850$var$isArray(arr)) return reject(new TypeError("Promise.race accepts an array"));
        for(var i = 0, len = arr.length; i < len; i++)$3c2752f53104d850$var$Promise.resolve(arr[i]).then(resolve, reject);
    });
};
// Use polyfill for setImmediate for performance gains
$3c2752f53104d850$var$Promise._immediateFn = // @ts-ignore
typeof setImmediate === "function" && function(fn) {
    // @ts-ignore
    setImmediate(fn);
} || function(fn) {
    $3c2752f53104d850$var$setTimeoutFunc(fn, 0);
};
$3c2752f53104d850$var$Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
    if (typeof console !== "undefined" && console) console.warn("Possible Unhandled Promise Rejection:", err); // eslint-disable-line no-console
};
var $3c2752f53104d850$export$2e2bcd8739ae039 = $3c2752f53104d850$var$Promise;

});
parcelRegister("bvrPw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $86082d715f686e6e$export$2e2bcd8739ae039; });
/**
 * @this {Promise}
 */ function $86082d715f686e6e$var$finallyConstructor(callback) {
    var constructor = this.constructor;
    return this.then(function(value) {
        // @ts-ignore
        return constructor.resolve(callback()).then(function() {
            return value;
        });
    }, function(reason) {
        // @ts-ignore
        return constructor.resolve(callback()).then(function() {
            // @ts-ignore
            return constructor.reject(reason);
        });
    });
}
var $86082d715f686e6e$export$2e2bcd8739ae039 = $86082d715f686e6e$var$finallyConstructor;

});

parcelRegister("i0Q6k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1d0a4424b78f71e$export$2e2bcd8739ae039; });

var $l0HdX = parcelRequire("l0HdX");
function $d1d0a4424b78f71e$var$allSettled(arr) {
    var P = this;
    return new P(function(resolve, reject) {
        if (!(arr && typeof arr.length !== "undefined")) return reject(new TypeError((typeof arr === "undefined" ? "undefined" : (0, $l0HdX._)(arr)) + " " + arr + " is not iterable(cannot read property Symbol(Symbol.iterator))"));
        var args = Array.prototype.slice.call(arr);
        if (args.length === 0) return resolve([]);
        var remaining = args.length;
        function res(i, val) {
            if (val && (typeof val === "object" || typeof val === "function")) {
                var then = val.then;
                if (typeof then === "function") {
                    then.call(val, function(val) {
                        res(i, val);
                    }, function(e) {
                        args[i] = {
                            status: "rejected",
                            reason: e
                        };
                        if (--remaining === 0) resolve(args);
                    });
                    return;
                }
            }
            args[i] = {
                status: "fulfilled",
                value: val
            };
            if (--remaining === 0) resolve(args);
        }
        for(var i = 0; i < args.length; i++)res(i, args[i]);
    });
}
var $d1d0a4424b78f71e$export$2e2bcd8739ae039 = $d1d0a4424b78f71e$var$allSettled;

});

parcelRegister("kPP3G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2b02d35a519d64c$export$2e2bcd8739ae039; });
/**
 * @constructor
 */ function $f2b02d35a519d64c$var$AggregateError(errors, message) {
    this.name = "AggregateError", this.errors = errors;
    this.message = message || "";
}
$f2b02d35a519d64c$var$AggregateError.prototype = Error.prototype;
function $f2b02d35a519d64c$var$any(arr) {
    var P = this;
    return new P(function(resolve, reject) {
        if (!(arr && typeof arr.length !== "undefined")) return reject(new TypeError("Promise.any accepts an array"));
        var args = Array.prototype.slice.call(arr);
        if (args.length === 0) return reject();
        var rejectionReasons = [];
        for(var i = 0; i < args.length; i++)try {
            P.resolve(args[i]).then(resolve).catch(function(error) {
                rejectionReasons.push(error);
                if (rejectionReasons.length === args.length) reject(new $f2b02d35a519d64c$var$AggregateError(rejectionReasons, "All promises were rejected"));
            });
        } catch (ex) {
            reject(ex);
        }
    });
}
var $f2b02d35a519d64c$export$2e2bcd8739ae039 = $f2b02d35a519d64c$var$any;

});


parcelRegister("8v5Y9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l29cN = parcelRequire("l29cN");

var $hGC2G = parcelRequire("hGC2G");

var $d815O = parcelRequire("d815O");

var $kmE2G = parcelRequire("kmE2G");

var $iOAnx = parcelRequire("iOAnx");

var $8ks9k = parcelRequire("8ks9k");
var $6305d954258574b4$var$UID_REFRESH_PERIOD = 604800000;
var $6305d954258574b4$var$XC_REFRESH_PERIOD = 2592000000;
module.exports.XC_CURRENT = "atl_xid.xc";
var $6305d954258574b4$var$XID_REFRESHED_AT = "atl_xid.ts";
var $6305d954258574b4$var$XID_CURRENT = "atl_xid.current";
var $6305d954258574b4$var$UIDS_ALL = "atl_xid.uid";
var $6305d954258574b4$var$UIDS_STORE_LIMIT = 20;
var $6305d954258574b4$var$Storage = function() {
    function Storage() {}
    Storage.getCachedXID = function() {
        try {
            var currentXID = $kmE2G.getXidItemFromCache($6305d954258574b4$var$XID_CURRENT);
            var refreshedAt = $kmE2G.getCache($6305d954258574b4$var$XID_REFRESHED_AT);
            var isFresh = false;
            if (currentXID.length > 0 && currentXID[0].type === $d815O.XIDItemType.UID) isFresh = parseInt(refreshedAt || "", 10) >= new Date().getTime() - $6305d954258574b4$var$UID_REFRESH_PERIOD;
            else if (currentXID.length > 0 && currentXID[0].type === $d815O.XIDItemType.XC) isFresh = parseInt(refreshedAt || "", 10) >= new Date().getTime() - $6305d954258574b4$var$XC_REFRESH_PERIOD;
            if (isFresh) {
                for(var _i = 0, currentXID_1 = currentXID; _i < currentXID_1.length; _i++){
                    var entry = currentXID_1[_i];
                    entry.state = $d815O.XIDState.EXISTING;
                }
                return currentXID;
            } else return [];
        } catch (err) {
            return [];
        }
    };
    Storage.saveXid = function(xid) {
        try {
            $hGC2G.setCookie($6305d954258574b4$var$XID_REFRESHED_AT, new Date().getTime());
            $kmE2G.setLocalstorage($6305d954258574b4$var$XID_REFRESHED_AT, new Date().getTime().toString());
            var xidCache = [];
            for(var _i = 0, xid_1 = xid; _i < xid_1.length; _i++){
                var entry = xid_1[_i];
                if (entry.value && entry.createdAt) {
                    xidCache.push({
                        type: entry.type,
                        value: entry.value,
                        createdAt: entry.createdAt
                    });
                    break;
                }
            }
            $hGC2G.setCookie($6305d954258574b4$var$XID_CURRENT, JSON.stringify(xidCache));
            $kmE2G.setLocalstorage($6305d954258574b4$var$XID_CURRENT, JSON.stringify(xidCache));
        } catch (err) {
            console.error("Error setting xid cookie.");
        }
    };
    Storage.updateXc = function(env, xc) {
        try {
            if (env === $d815O.Environment.PROD && $iOAnx.isAtlassianComDomain()) return Storage.processAtlassianComDomainXc(xc);
            else Storage.saveXcLocalstorage(xc);
        } catch (err) {
            console.error("Error setting xc cookie.");
        }
        return xc;
    };
    Storage.getUids = function() {
        var uid = $kmE2G.getXidItemFromCache($6305d954258574b4$var$UIDS_ALL) || [];
        for(var _i = 0, uid_1 = uid; _i < uid_1.length; _i++){
            var entry = uid_1[_i];
            entry.state = $d815O.XIDState.EXISTING;
        }
        return uid;
    };
    Storage.saveUids = function(uid) {
        try {
            var uidCache = [];
            for(var _i = 0, uid_2 = uid; _i < uid_2.length; _i++){
                var entry = uid_2[_i];
                if (entry.value && entry.createdAt) uidCache.push({
                    type: entry.type,
                    value: entry.value,
                    createdAt: entry.createdAt
                });
            }
            uidCache.slice(0, $6305d954258574b4$var$UIDS_STORE_LIMIT);
            $kmE2G.setLocalstorage($6305d954258574b4$var$UIDS_ALL, JSON.stringify(uidCache));
        } catch (err) {
            console.error("Error setting uid cookie.");
        }
    };
    Storage.saveXcLocalstorage = function(xc) {
        if (xc.value && xc.createdAt) {
            var currentXcCache = $kmE2G.getXidFromLocalStorage(module.exports.XC_CURRENT);
            if (currentXcCache && currentXcCache.value === xc.value) return;
            else if (currentXcCache && currentXcCache.value !== xc.value) xc.state = $d815O.XIDState.CHANGED;
            var xidCache = {
                type: xc.type,
                value: xc.value,
                createdAt: xc.createdAt
            };
            $kmE2G.setLocalstorage(module.exports.XC_CURRENT, JSON.stringify(xidCache));
        }
    };
    Storage.processAtlassianComDomainXc = function(xc) {
        if (xc.value && xc.createdAt) {
            var currentXcCache = $kmE2G.getXidFromCookie(module.exports.XC_CURRENT);
            if (currentXcCache) {
                $hGC2G.setCookie(module.exports.XC_CURRENT, JSON.stringify(currentXcCache), $hGC2G.getCrossDomainCookieOption());
                var currentXc = $l29cN.__assign({
                    state: $d815O.XIDState.EXISTING
                }, currentXcCache);
                Storage.saveXcLocalstorage(currentXc);
                return currentXc;
            } else {
                var newXcCache = {
                    value: $8ks9k.uuidv4(),
                    createdAt: new Date().toISOString(),
                    type: $d815O.XIDItemType.XC
                };
                $hGC2G.setCookie(module.exports.XC_CURRENT, JSON.stringify(newXcCache), $hGC2G.getCrossDomainCookieOption());
                var newXc = $l29cN.__assign({
                    state: $d815O.XIDState.NEW
                }, newXcCache);
                Storage.saveXcLocalstorage(newXc);
                return newXc;
            }
        } else return xc;
    };
    return Storage;
}();
module.exports.Storage = $6305d954258574b4$var$Storage;

});
parcelRegister("hGC2G", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l29cN = parcelRequire("l29cN");
var $ce03de4dab1a8892$var$set = function set(name, value, options) {
    var str = $ce03de4dab1a8892$var$encode(name) + "=" + $ce03de4dab1a8892$var$encode((value || "").toString());
    if (value == null) options.maxage = -1;
    var expiry;
    if (options.maxage) expiry = new Date(+new Date() + options.maxage);
    if (options.path) str += "; path=" + options.path;
    if (options.domain) str += "; domain=" + options.domain;
    if (expiry) str += "; expires=" + expiry.toUTCString();
    if (options.secure) str += "; secure";
    if (options.sameSite) str += "; samesite=" + options.sameSite;
    document.cookie = str;
    return str;
};
var $ce03de4dab1a8892$var$all = function all() {
    try {
        return $ce03de4dab1a8892$var$parse(document.cookie);
    } catch (err) {
        if (typeof console !== "undefined" && typeof console.error === "function") console.error(err.stack || err);
        return {};
    }
};
function $ce03de4dab1a8892$var$get(name) {
    return $ce03de4dab1a8892$var$all()[name];
}
function $ce03de4dab1a8892$var$parse(str) {
    var obj = {};
    var pairs = str.split(/ *; */);
    if (pairs[0] === "") return obj;
    pairs.forEach(function(item) {
        var pair = item.split("=");
        var key = $ce03de4dab1a8892$var$decode(pair[0]);
        var value = $ce03de4dab1a8892$var$decode(pair[1]);
        if (key && value) obj[key] = value;
    });
    return obj;
}
function $ce03de4dab1a8892$var$encode(value) {
    try {
        return encodeURIComponent(value);
    } catch (e) {
        console.log("error `encode(%o)` - %o", value, e);
        return "";
    }
}
function $ce03de4dab1a8892$var$decode(value) {
    try {
        return decodeURIComponent(value);
    } catch (e) {
        console.log("error `decode(%o)` - %o", value, e);
        return "";
    }
}
function $ce03de4dab1a8892$var$getCookie(name) {
    return $ce03de4dab1a8892$var$get(name);
}
module.exports.getCookie = $ce03de4dab1a8892$var$getCookie;
function $ce03de4dab1a8892$var$getAllCookies() {
    return $ce03de4dab1a8892$var$all();
}
module.exports.getAllCookies = $ce03de4dab1a8892$var$getAllCookies;
function $ce03de4dab1a8892$var$setCookie(name, value, options) {
    var finalOption = $l29cN.__assign({
        maxage: 31536000000,
        secure: true,
        path: "/",
        expires: null,
        domain: null,
        sameSite: "lax"
    }, options);
    return $ce03de4dab1a8892$var$set(name, value, finalOption);
}
module.exports.setCookie = $ce03de4dab1a8892$var$setCookie;
function $ce03de4dab1a8892$var$getCrossDomainCookieOption() {
    var domain = window.location.hostname.split(".").slice(-2).join(".");
    return {
        sameSite: "None",
        domain: domain
    };
}
module.exports.getCrossDomainCookieOption = $ce03de4dab1a8892$var$getCrossDomainCookieOption;

});

parcelRegister("kmE2G", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hGC2G = parcelRequire("hGC2G");

var $Mi8nP = parcelRequire("Mi8nP");
var $ed34ec45d4e44a07$var$parseCachedXidItem = function parseCachedXidItem(value) {
    try {
        var xid = JSON.parse(value);
        if (xid instanceof Array) {
            var valid = true;
            for(var _i = 0, xid_1 = xid; _i < xid_1.length; _i++){
                var entry = xid_1[_i];
                valid = valid && $Mi8nP.checkXidValid(entry);
            }
            return valid ? xid : undefined;
        } else return $Mi8nP.checkXidValid(xid) ? xid : undefined;
    } catch (err) {
        return;
    }
};
function $ed34ec45d4e44a07$var$getFromLocalStorage(name) {
    try {
        return localStorage.getItem(name) || "";
    } catch (err) {}
}
function $ed34ec45d4e44a07$var$getXidFromCookie(name) {
    var cookieValue = $hGC2G.getCookie(name);
    return $ed34ec45d4e44a07$var$parseCachedXidItem(cookieValue);
}
module.exports.getXidFromCookie = $ed34ec45d4e44a07$var$getXidFromCookie;
function $ed34ec45d4e44a07$var$getXidFromLocalStorage(name) {
    var lsValue = "";
    try {
        lsValue = localStorage.getItem(name) || "";
    } catch (err) {}
    return $ed34ec45d4e44a07$var$parseCachedXidItem(lsValue);
}
module.exports.getXidFromLocalStorage = $ed34ec45d4e44a07$var$getXidFromLocalStorage;
function $ed34ec45d4e44a07$var$setLocalstorage(name, value) {
    try {
        localStorage.setItem(name, value);
    } catch (err) {}
}
module.exports.setLocalstorage = $ed34ec45d4e44a07$var$setLocalstorage;
function $ed34ec45d4e44a07$var$getCache(name) {
    return $hGC2G.getCookie(name) || $ed34ec45d4e44a07$var$getFromLocalStorage(name);
}
module.exports.getCache = $ed34ec45d4e44a07$var$getCache;
function $ed34ec45d4e44a07$var$getXidItemFromCache(name) {
    return $ed34ec45d4e44a07$var$getXidFromCookie(name) || $ed34ec45d4e44a07$var$getXidFromLocalStorage(name);
}
module.exports.getXidItemFromCache = $ed34ec45d4e44a07$var$getXidItemFromCache;

});
parcelRegister("Mi8nP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $d815O = parcelRequire("d815O");
module.exports.checkXidValid = function(xid) {
    return (xid.type === $d815O.XIDItemType.UID || xid.type === $d815O.XIDItemType.XC) && !!xid.value && !!Date.parse(xid.createdAt);
};

});


parcelRegister("iOAnx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hGC2G = parcelRequire("hGC2G");

var $kya0M = parcelRequire("kya0M");
var $db291d8e9a72cfcc$var$getLevels = function getLevels(url) {
    var host = $kya0M.parse(url).hostname;
    var parts = host.split(".");
    var last = parts[parts.length - 1];
    var levels = [];
    if (parts.length === 4 && !isNaN(parseInt(last, 10))) return levels;
    if (parts.length <= 1) return levels;
    for(var i = parts.length - 2; i >= 0; --i)levels.push(parts.slice(i).join("."));
    return levels;
};
module.exports.domain = function(url) {
    var domainLevels = $db291d8e9a72cfcc$var$getLevels(url);
    for(var _i = 0, domainLevels_1 = domainLevels; _i < domainLevels_1.length; _i++){
        var domainLevel = domainLevels_1[_i];
        var cname = "__tld__";
        var opts = {
            domain: "." + domainLevel
        };
        $hGC2G.setCookie(cname, 1, opts);
        if ($hGC2G.getCookie(cname)) {
            $hGC2G.setCookie(cname, null, opts);
            return domainLevel;
        }
    }
    return "";
};
module.exports.inIframe = function() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
};
module.exports.isAtlassianComDomain = function() {
    return /atlassian\.com$/.test(window.location.hostname);
};

});
parcelRegister("kya0M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parse = function(url) {
    var a = document.createElement("a");
    a.href = url;
    return {
        href: a.href,
        host: a.host || location.host,
        port: "0" === a.port || "" === a.port ? module.exports.port(a.protocol) : a.port,
        hash: a.hash,
        hostname: a.hostname || location.hostname,
        pathname: a.pathname.charAt(0) !== "/" ? "/" + a.pathname : a.pathname,
        protocol: !a.protocol || ":" === a.protocol ? location.protocol : a.protocol,
        search: a.search,
        query: a.search.slice(1)
    };
};
module.exports.isAbsolute = function(url) {
    return 0 === url.indexOf("//") || !!~url.indexOf("://");
};
module.exports.isRelative = function(url) {
    return !module.exports.isAbsolute(url);
};
module.exports.isCrossDomain = function(url) {
    var finalUrl = module.exports.parse(url);
    var location1 = module.exports.parse(window.location.href);
    return finalUrl.hostname !== location1.hostname || finalUrl.port !== location1.port || finalUrl.protocol !== location1.protocol;
};
module.exports.port = function(protocol) {
    switch(protocol){
        case "http:":
            return 80;
        case "https:":
            return 443;
        default:
            return location.port;
    }
};
module.exports.getParam = function(name) {
    var b = window.location.href.match("[?&]" + name + "=([^&#]+)");
    return b ? b.pop() : "";
};

});


parcelRegister("8ks9k", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.uuidv4 = function() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(char) {
        var random = Math.random() * 16 | 0;
        var uuid = char === "x" ? random : random & 0x3 | 0x8;
        return uuid.toString(16);
    });
};

});


parcelRegister("4f9Cx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l29cN = parcelRequire("l29cN");

var $7kAbl = parcelRequire("7kAbl");

var $iywSH = parcelRequire("iywSH");

var $e1GQz = parcelRequire("e1GQz");

var $k6YJW = parcelRequire("k6YJW");

var $4HjwG = parcelRequire("4HjwG");

var $9dPw1 = parcelRequire("9dPw1");

var $hqDKS = parcelRequire("hqDKS");
var $31700693d497675c$var$UIDGenerator = function() {
    function UIDGenerator() {}
    UIDGenerator.getDetails = function() {
        try {
            return {
                browser: {
                    browserDefaultEvalLength: $7kAbl.browserDefaultEvalLength(),
                    canWriteCookie: $7kAbl.canWriteCookie(),
                    getBrowserVendor: $7kAbl.getBrowserVendor(),
                    getHardwareConcurrency: $7kAbl.getHardwareConcurrency(),
                    getLanguage: $7kAbl.getLanguage(),
                    getPlatform: $7kAbl.getPlatform(),
                    getPlugins: $7kAbl.getPlugins(),
                    getProductSub: $7kAbl.getProductSub(),
                    getTimeZone: $7kAbl.getTimeZone(),
                    getTimeZoneOffset: $7kAbl.getTimeZoneOffset(),
                    getUserAgent: $7kAbl.getUserAgent(),
                    isIndexedDBAvailable: $7kAbl.isIndexedDBAvailable(),
                    isLocalStorageAvailable: $7kAbl.isLocalStorageAvailable(),
                    isSessionStorageAvailable: $7kAbl.isSessionStorageAvailable(),
                    isTestingBot: $7kAbl.isTestingBot(),
                    isWebDriver: $7kAbl.isWebDriver()
                },
                canvas: {
                    studyPrint: $iywSH.studyPrint()
                },
                font: {
                    jsFonts: new $k6YJW.DetectFonts().detect()
                },
                webGL: {
                    getWebGL: $4HjwG.getWebGL()
                }
            };
        } catch (err) {
            return $e1GQz.ERROR;
        }
    };
    UIDGenerator.getValue = function(cachedUids) {
        try {
            var values = [
                $7kAbl.browserDefaultEvalLength(),
                $7kAbl.canWriteCookie(),
                $7kAbl.getBrowserVendor(),
                $7kAbl.getHardwareConcurrency(),
                $7kAbl.getLanguage(),
                $7kAbl.getPlatform(),
                $7kAbl.getPlugins(),
                $7kAbl.getProductSub(),
                $7kAbl.getTimeZone(),
                $7kAbl.getTimeZoneOffset(),
                $7kAbl.getUserAgent(),
                $7kAbl.isIndexedDBAvailable(),
                $7kAbl.isLocalStorageAvailable(),
                $7kAbl.isSessionStorageAvailable(),
                $7kAbl.isTestingBot(),
                $7kAbl.isWebDriver(),
                $iywSH.studyPrint(),
                new $k6YJW.DetectFonts().result(),
                $4HjwG.getWebGL()
            ];
            var value = $hqDKS.x64hash128(values.join("|"), 64);
            var state = void 0;
            if (!cachedUids.length) state = $9dPw1.XIDState.NEW;
            else if (cachedUids[0].value === value) state = $9dPw1.XIDState.EXISTING;
            else state = $9dPw1.XIDState.CHANGED;
            return state === $9dPw1.XIDState.EXISTING ? cachedUids : $l29cN.__spreadArrays([
                {
                    type: $9dPw1.XIDItemType.UID,
                    createdAt: new Date().toISOString(),
                    state: state,
                    value: value
                }
            ], cachedUids);
        } catch (err) {
            return [
                {
                    type: $9dPw1.XIDItemType.UID,
                    state: $9dPw1.XIDState.ERROR
                }
            ];
        }
    };
    return UIDGenerator;
}();
module.exports.UIDGenerator = $31700693d497675c$var$UIDGenerator;

});
parcelRegister("7kAbl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $ihEHq = parcelRequire("ihEHq");
module.exports.browserDefaultEvalLength = $ihEHq.browserDefaultEvalLength;

var $8ZKSp = parcelRequire("8ZKSp");
module.exports.canWriteCookie = $8ZKSp.canWriteCookie;

var $4RcCr = parcelRequire("4RcCr");
module.exports.getBrowserVendor = $4RcCr.getBrowserVendor;

var $bB8QQ = parcelRequire("bB8QQ");
module.exports.getHardwareConcurrency = $bB8QQ.getHardwareConcurrency;

var $6KMK3 = parcelRequire("6KMK3");
module.exports.getLanguage = $6KMK3.getLanguage;

var $atcWD = parcelRequire("atcWD");
module.exports.getPlatform = $atcWD.getPlatform;

var $i96PD = parcelRequire("i96PD");
module.exports.getPlugins = $i96PD.getPlugins;

var $5ce7o = parcelRequire("5ce7o");
module.exports.getProductSub = $5ce7o.getProductSub;

var $6lz4M = parcelRequire("6lz4M");
module.exports.getTimeZone = $6lz4M.getTimeZone;

var $kseDq = parcelRequire("kseDq");
module.exports.getTimeZoneOffset = $kseDq.getTimeZoneOffset;

var $dAhjR = parcelRequire("dAhjR");
module.exports.getUserAgent = $dAhjR.getUserAgent;

var $hqOkz = parcelRequire("hqOkz");
module.exports.isIndexedDBAvailable = $hqOkz.isIndexedDBAvailable;

var $3vymj = parcelRequire("3vymj");
module.exports.isLocalStorageAvailable = $3vymj.isLocalStorageAvailable;

var $5CK86 = parcelRequire("5CK86");
module.exports.isSessionStorageAvailable = $5CK86.isSessionStorageAvailable;

var $9t9Sl = parcelRequire("9t9Sl");
module.exports.isTestingBot = $9t9Sl.isTestingBot;

var $a7ifF = parcelRequire("a7ifF");
module.exports.isWebDriver = $a7ifF.isWebDriver;

});
parcelRegister("ihEHq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $e1GQz = parcelRequire("e1GQz");
function $d4f9629ace37139b$var$browserDefaultEvalLength() {
    try {
        return eval.toString().length || 0;
    } catch (err) {
        return $e1GQz.ERROR;
    }
}
module.exports.browserDefaultEvalLength = $d4f9629ace37139b$var$browserDefaultEvalLength;

});
parcelRegister("e1GQz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UNAVAILABLE = "UNAVAILABLE";
module.exports.ERROR = "ERROR";
module.exports.YES = "YES";
module.exports.NO = "NO";

});


parcelRegister("8ZKSp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $e1GQz = parcelRequire("e1GQz");
function $68c861f3a2b6d96d$var$canWriteCookie() {
    try {
        document.cookie = "cookietest=1";
        if (document.cookie.indexOf("cookietest=") !== -1) {
            document.cookie = "cookietest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT";
            return $e1GQz.YES;
        }
        return $e1GQz.NO;
    } catch (t) {
        return $e1GQz.ERROR;
    }
}
module.exports.canWriteCookie = $68c861f3a2b6d96d$var$canWriteCookie;

});

parcelRegister("4RcCr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $e1GQz = parcelRequire("e1GQz");
function $3895e68497d3eff9$var$getBrowserVendor() {
    try {
        return navigator.vendor || $e1GQz.UNAVAILABLE;
    } catch (error) {
        return $e1GQz.ERROR;
    }
}
module.exports.getBrowserVendor = $3895e68497d3eff9$var$getBrowserVendor;

});

parcelRegister("bB8QQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $871a041b62f236c6$var$getHardwareConcurrency() {
    try {
        var result = parseInt(navigator.hardwareConcurrency.toString(), 10);
        return isNaN(result) ? 1 : result;
    } catch (t) {
        return 1;
    }
}
module.exports.getHardwareConcurrency = $871a041b62f236c6$var$getHardwareConcurrency;

});

parcelRegister("6KMK3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $e1GQz = parcelRequire("e1GQz");
function $4eacd9163656a988$var$getLanguage() {
    try {
        return navigator.language || $e1GQz.UNAVAILABLE;
    } catch (error) {
        return $e1GQz.ERROR;
    }
}
module.exports.getLanguage = $4eacd9163656a988$var$getLanguage;

});

parcelRegister("atcWD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $e1GQz = parcelRequire("e1GQz");
function $79f6a7620b87497b$var$getPlatform() {
    try {
        return navigator.platform || $e1GQz.UNAVAILABLE;
    } catch (error) {
        return $e1GQz.ERROR;
    }
}
module.exports.getPlatform = $79f6a7620b87497b$var$getPlatform;

});

parcelRegister("i96PD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $e1GQz = parcelRequire("e1GQz");
function $d35e5dea1344d988$var$getPlugins() {
    try {
        var MSIE = "Microsoft Internet Explorer";
        var NETSCAPE = "Netscape";
        var isIE = navigator.appName === MSIE;
        var isNetscape = navigator.appName === NETSCAPE;
        var isTrident = /Trident/.test(navigator.userAgent);
        if (isIE || isNetscape && isTrident) return $e1GQz.UNAVAILABLE;
        var navigatorPlugins = navigator.plugins;
        var s = "";
        for(var i = 0; i < navigatorPlugins.length; i++){
            var plugin = navigator.plugins[i];
            var name_1 = plugin.name;
            var fileName = plugin.filename;
            var pluginMimeTypes = plugin.length;
            for(var j = 0; j < pluginMimeTypes; j++){
                var o = plugin[j];
                if (o) s = s + name_1 + "," + fileName + "," + o.type + "|";
            }
        }
        return s;
    } catch (error) {
        return $e1GQz.ERROR;
    }
}
module.exports.getPlugins = $d35e5dea1344d988$var$getPlugins;

});

parcelRegister("5ce7o", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $e1GQz = parcelRequire("e1GQz");
function $3c89064daac91651$var$getProductSub() {
    try {
        return navigator.productSub || $e1GQz.UNAVAILABLE;
    } catch (error) {
        return $e1GQz.ERROR;
    }
}
module.exports.getProductSub = $3c89064daac91651$var$getProductSub;

});

parcelRegister("6lz4M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $e1GQz = parcelRequire("e1GQz");
function $49efe99b85944c34$var$getTimeZone() {
    try {
        if (window.Intl && window.Intl.DateTimeFormat) return new window.Intl.DateTimeFormat().resolvedOptions().timeZone;
        return $e1GQz.UNAVAILABLE;
    } catch (error) {
        return $e1GQz.ERROR;
    }
}
module.exports.getTimeZone = $49efe99b85944c34$var$getTimeZone;

});

parcelRegister("kseDq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $e1GQz = parcelRequire("e1GQz");
function $ee41c65656c961e6$var$getTimeZoneOffset() {
    try {
        return new Date().getTimezoneOffset() || $e1GQz.UNAVAILABLE;
    } catch (error) {
        return $e1GQz.ERROR;
    }
}
module.exports.getTimeZoneOffset = $ee41c65656c961e6$var$getTimeZoneOffset;

});

parcelRegister("dAhjR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $e1GQz = parcelRequire("e1GQz");
function $9e3c1265cf298cac$var$getUserAgent() {
    try {
        return navigator.userAgent || $e1GQz.UNAVAILABLE;
    } catch (d) {
        return $e1GQz.ERROR;
    }
}
module.exports.getUserAgent = $9e3c1265cf298cac$var$getUserAgent;

});

parcelRegister("hqOkz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $e1GQz = parcelRequire("e1GQz");
function $cb0be801e2f0e071$var$isIndexedDBAvailable() {
    try {
        return window.indexedDB ? $e1GQz.YES : $e1GQz.NO;
    } catch (e) {
        return $e1GQz.ERROR;
    }
}
module.exports.isIndexedDBAvailable = $cb0be801e2f0e071$var$isIndexedDBAvailable;

});

parcelRegister("3vymj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $e1GQz = parcelRequire("e1GQz");
function $28deeb4a5b7ea870$var$isLocalStorageAvailable() {
    try {
        return window.localStorage ? $e1GQz.YES : $e1GQz.NO;
    } catch (e) {
        return $e1GQz.ERROR;
    }
}
module.exports.isLocalStorageAvailable = $28deeb4a5b7ea870$var$isLocalStorageAvailable;

});

parcelRegister("5CK86", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $e1GQz = parcelRequire("e1GQz");
function $418448c394ae780c$var$isSessionStorageAvailable() {
    try {
        return window.sessionStorage ? $e1GQz.YES : $e1GQz.NO;
    } catch (e) {
        return $e1GQz.ERROR;
    }
}
module.exports.isSessionStorageAvailable = $418448c394ae780c$var$isSessionStorageAvailable;

});

parcelRegister("9t9Sl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $e1GQz = parcelRequire("e1GQz");
function $6e4e7b8fe4c83365$var$isTestingBot() {
    try {
        var t = [
            "webdriver" in window,
            "_Selenium_IDE_Recorder" in window,
            "callSelenium" in window,
            "_selenium" in window,
            "__webdriver_script_fn" in document,
            "__driver_evaluate" in document,
            "__webdriver_evaluate" in document,
            "__selenium_evaluate" in document,
            "__fxdriver_evaluate" in document,
            "__driver_unwrapped" in document,
            "__webdriver_unwrapped" in document,
            "__selenium_unwrapped" in document,
            "__fxdriver_unwrapped" in document,
            "__webdriver_script_func" in document,
            null !== document.documentElement.getAttribute("selenium"),
            null !== document.documentElement.getAttribute("webdriver"),
            null !== document.documentElement.getAttribute("driver")
        ];
        return t.some(function(e) {
            return e === true;
        }) ? $e1GQz.YES : $e1GQz.NO;
    } catch (error) {
        return $e1GQz.ERROR;
    }
}
module.exports.isTestingBot = $6e4e7b8fe4c83365$var$isTestingBot;

});

parcelRegister("a7ifF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $e1GQz = parcelRequire("e1GQz");
function $75d8b737f9b7922e$var$isWebDriver() {
    try {
        return navigator.webdriver ? $e1GQz.YES : $e1GQz.NO;
    } catch (error) {
        return $e1GQz.ERROR;
    }
}
module.exports.isWebDriver = $75d8b737f9b7922e$var$isWebDriver;

});


parcelRegister("iywSH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9PuPC = parcelRequire("9PuPC");
module.exports.studyPrint = $9PuPC.studyPrint;

});
parcelRegister("9PuPC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $e1GQz = parcelRequire("e1GQz");
function $7280cb009b6d0b4b$var$studyPrint() {
    try {
        var canvasElement = document.createElement("canvas");
        canvasElement.width = 240;
        canvasElement.height = 140;
        canvasElement.style.display = "inline";
        var canvasContext = canvasElement.getContext("2d");
        if (canvasContext) {
            canvasContext.rect(0, 0, 10, 10);
            canvasContext.rect(2, 2, 6, 6);
            canvasContext.isPointInPath(5, 5, "evenodd");
            canvasContext.textBaseline = "alphabetic";
            canvasContext.fillStyle = "#f60";
            canvasContext.fillRect(125, 1, 62, 20);
            canvasContext.fillStyle = "#069";
            canvasContext.font = "11pt no-real-font-123";
            canvasContext.fillText("Cwm fjordbank \uD83D\uDE03 gly", 2, 15);
            canvasContext.fillStyle = "rgba(102, 204, 0, 0.2)";
            canvasContext.font = "18pt Arial";
            canvasContext.fillText("Cwm fjordbank \uD83D\uDE03 gly", 4, 45);
            canvasContext.globalCompositeOperation = "multiply";
            canvasContext.fillStyle = "rgb(255,0,255)";
            canvasContext.beginPath();
            canvasContext.arc(50, 50, 50, 0, 2 * Math.PI, !0);
            canvasContext.closePath();
            canvasContext.fill();
            canvasContext.fillStyle = "rgb(0,255,255)";
            canvasContext.beginPath();
            canvasContext.arc(100, 50, 50, 0, 2 * Math.PI, !0);
            canvasContext.closePath();
            canvasContext.fill();
            canvasContext.fillStyle = "rgb(255,255,0)";
            canvasContext.beginPath();
            canvasContext.arc(75, 100, 50, 0, 2 * Math.PI, !0);
            canvasContext.closePath();
            canvasContext.fill();
            canvasContext.fillStyle = "rgb(255,0,255)";
            canvasContext.arc(75, 75, 75, 0, 2 * Math.PI, !0);
            canvasContext.arc(75, 75, 25, 0, 2 * Math.PI, !0);
            canvasContext.fill("evenodd");
            return canvasElement.toDataURL();
        }
        return $e1GQz.UNAVAILABLE;
    } catch (error) {
        return $e1GQz.ERROR;
    }
}
module.exports.studyPrint = $7280cb009b6d0b4b$var$studyPrint;

});


parcelRegister("k6YJW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $cihJ3 = parcelRequire("cihJ3");
module.exports.DetectFonts = $cihJ3.DetectFonts;

});
parcelRegister("cihJ3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $e1GQz = parcelRequire("e1GQz");

var $dqBMy = parcelRequire("dqBMy");
var $8f34ea678775eadd$var$DetectFonts = function() {
    function DetectFonts() {
        var _this = this;
        this.baseFonts = [
            "monospace",
            "sans-serif",
            "serif"
        ];
        this.testString = "mmmmmmmmmmlli";
        this.testSize = "72px";
        this.defaultWidth = {};
        this.defaultHeight = {};
        this.createSpan = function() {
            var s = document.createElement("span");
            s.style.position = "absolute";
            s.style.left = "-9999px";
            s.style.fontSize = _this.testSize;
            s.style.fontStyle = "normal";
            s.style.fontWeight = "normal";
            s.style.letterSpacing = "normal";
            s.style.lineBreak = "auto";
            s.style.lineHeight = "normal";
            s.style.textTransform = "none";
            s.style.textAlign = "left";
            s.style.textDecoration = "none";
            s.style.textShadow = "none";
            s.style.whiteSpace = "normal";
            s.style.wordBreak = "normal";
            s.style.wordSpacing = "normal";
            s.innerHTML = _this.testString;
            return s;
        };
        this.createSpanWithFonts = function(fontToDetect, baseFont) {
            var s = _this.createSpan();
            s.style.fontFamily = "'" + fontToDetect + "'," + baseFont;
            return s;
        };
        this.initializeBaseFontsSpans = function() {
            var spans = [];
            for(var _i = 0, _a = _this.baseFonts; _i < _a.length; _i++){
                var font = _a[_i];
                var s = _this.createSpan();
                s.style.fontFamily = font;
                _this.baseFontsDiv.appendChild(s);
                spans.push(s);
            }
            return spans;
        };
        this.initializeFontsSpans = function() {
            var spans = {};
            for(var _i = 0, fontsToCheck_2 = $dqBMy.fontsToCheck; _i < fontsToCheck_2.length; _i++){
                var fontToDetect = fontsToCheck_2[_i];
                var fontSpans = [];
                for(var _a = 0, _b = _this.baseFonts; _a < _b.length; _a++){
                    var baseFont = _b[_a];
                    var s = _this.createSpanWithFonts(fontToDetect, baseFont);
                    _this.fontsDiv.appendChild(s);
                    fontSpans.push(s);
                }
                var key = fontToDetect;
                spans[key] = fontSpans;
            }
            return spans;
        };
        this.isFontAvailable = function(fontSpans) {
            var detected = false;
            for(var i = 0; i < _this.baseFonts.length; i++){
                var fontWidth = fontSpans[i].offsetWidth;
                var fontDefaultWidth = _this.defaultWidth[_this.baseFonts[i]];
                var fontHeight = fontSpans[i].offsetHeight;
                var fontDefaultHeight = _this.defaultHeight[_this.baseFonts[i]];
                detected = fontWidth !== fontDefaultWidth || fontHeight !== fontDefaultHeight;
                if (detected) return detected;
            }
            return detected;
        };
        this.bodyElement = document.getElementsByTagName("body")[0];
        this.baseFontsDiv = document.createElement("div");
        this.fontsDiv = document.createElement("div");
    }
    DetectFonts.prototype.detect = function() {
        var baseFontsSpans = this.initializeBaseFontsSpans();
        this.bodyElement.appendChild(this.baseFontsDiv);
        for(var index = 0; index < this.baseFonts.length; index++){
            this.defaultWidth[this.baseFonts[index]] = baseFontsSpans[index].offsetWidth;
            this.defaultHeight[this.baseFonts[index]] = baseFontsSpans[index].offsetHeight;
        }
        var fontsSpans = this.initializeFontsSpans();
        this.bodyElement.appendChild(this.fontsDiv);
        var available = [];
        for(var _i = 0, fontsToCheck_3 = $dqBMy.fontsToCheck; _i < fontsToCheck_3.length; _i++){
            var fontToCheck = fontsToCheck_3[_i];
            var result = 0;
            if (this.isFontAvailable(fontsSpans[fontToCheck])) result = 1;
            available.push(result);
        }
        this.bodyElement.removeChild(this.fontsDiv);
        this.bodyElement.removeChild(this.baseFontsDiv);
        return available.join("|");
    };
    DetectFonts.prototype.result = function() {
        try {
            return this.detect();
        } catch (error) {
            return $e1GQz.ERROR;
        }
    };
    return DetectFonts;
}();
module.exports.DetectFonts = $8f34ea678775eadd$var$DetectFonts;

});
parcelRegister("dqBMy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fontsToCheck = [
    "Adobe Garamond",
    "Adobe Hebrew",
    "Agency FB",
    "Airstream",
    "Andale Mono",
    "Aparajita",
    "Arial",
    "BN Manson Nights",
    "Baskerville",
    "BlackChancery",
    "Book Antiqua",
    "Bookman Old Style",
    "CG Times",
    "Calibri",
    "Cambria",
    "Cambria Math",
    "Century",
    "Century Gothic",
    "Century Schoolbook",
    "Chalkboard",
    "Comic Sans",
    "Comic Sans MS",
    "Consolas",
    "Cooper Black",
    "Corbel",
    "Courier",
    "Courier New",
    "Curlz MT",
    "DS Sans Serif",
    "Degrassi",
    "Didot",
    "Ebrima",
    "GOST Common",
    "Geneva",
    "Georgia",
    "Gulim",
    "Heiti TC",
    "Helvetica",
    "Helvetica Neue",
    "Hoefler Text",
    "Impact",
    "Kalinga",
    "Letter Gothic",
    "Lithos Pro",
    "Lucida Bright",
    "Lucida Calligraphy",
    "Lucida Console",
    "Lucida Fax",
    "Lucida Handwriting",
    "Lucida Sans",
    "MS Gothic",
    "MS Outlook",
    "MS PGothic",
    "MYRIAD",
    "Malgun Gothic",
    "Mangal",
    "MapInfo Miscellaneous",
    "Meiryo UI",
    "Monaco",
    "Monotype Corsiva",
    "NSimSun",
    "OSAKA",
    "Palatino",
    "Pickwick",
    "Playbill",
    "Pristina",
    "Segoe Print",
    "Segoe Script",
    "Segoe UI",
    "Shonar Bangla",
    "Snell Roundhand",
    "Styllo",
    "Tahoma",
    "Times",
    "Times New Roman",
    "Trebuchet MS",
    "Verdana",
    "Wingdings"
];

});



parcelRegister("4HjwG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $heGBC = parcelRequire("heGBC");
module.exports.getWebGL = $heGBC.getWebGL;

});
parcelRegister("heGBC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $e1GQz = parcelRequire("e1GQz");

var $f8BSb = parcelRequire("f8BSb");
function $c8c4cb1bc9c5db6a$var$getWebGL() {
    try {
        var gl = $f8BSb.getContext();
        if (typeof gl === "undefined") return $e1GQz.UNAVAILABLE;
        if (gl && typeof gl === "object" && gl.context) {
            var glContext = gl.context;
            var rendererInfo = glContext.getExtension("WEBGL_debug_renderer_info");
            if (rendererInfo !== null) return [
                glContext.getParameter(rendererInfo.UNMASKED_RENDERER_WEBGL),
                glContext.getParameter(glContext.MAX_COMBINED_TEXTURE_IMAGE_UNITS),
                glContext.getParameter(glContext.MAX_CUBE_MAP_TEXTURE_SIZE)
            ].join("|");
            return $e1GQz.UNAVAILABLE;
        }
    } catch (p) {
        return $e1GQz.ERROR;
    }
}
module.exports.getWebGL = $c8c4cb1bc9c5db6a$var$getWebGL;

});
parcelRegister("f8BSb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $e1GQz = parcelRequire("e1GQz");
function $b054fb2455152685$var$getContext() {
    if (window.WebGLRenderingContext) {
        var canvasElement = document.createElement("canvas");
        var webGLcontexts = [
            "webgl",
            "experimental-webgl",
            "moz-webgl",
            "webkit-3d"
        ];
        for(var _i = 0, webGLcontexts_1 = webGLcontexts; _i < webGLcontexts_1.length; _i++){
            var contextName = webGLcontexts_1[_i];
            try {
                var canvasRenderingContext = canvasElement.getContext(contextName);
                if (canvasRenderingContext && canvasRenderingContext instanceof WebGLRenderingContext && typeof canvasRenderingContext.getParameter === "function") return {
                    name: contextName,
                    context: canvasRenderingContext
                };
            } catch (p) {
                return $e1GQz.ERROR;
            }
        }
    }
    return $e1GQz.UNAVAILABLE;
}
module.exports.getContext = $b054fb2455152685$var$getContext;

});



parcelRegister("hqDKS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $cb03b3e9decfb2bb$var$x64Add = function x64Add(m, n) {
    m = [
        m[0] >>> 16,
        m[0] & 0xffff,
        m[1] >>> 16,
        m[1] & 0xffff
    ];
    n = [
        n[0] >>> 16,
        n[0] & 0xffff,
        n[1] >>> 16,
        n[1] & 0xffff
    ];
    var o = [
        0,
        0,
        0,
        0
    ];
    o[3] += m[3] + n[3];
    o[2] += o[3] >>> 16;
    o[3] &= 0xffff;
    o[2] += m[2] + n[2];
    o[1] += o[2] >>> 16;
    o[2] &= 0xffff;
    o[1] += m[1] + n[1];
    o[0] += o[1] >>> 16;
    o[1] &= 0xffff;
    o[0] += m[0] + n[0];
    o[0] &= 0xffff;
    return [
        o[0] << 16 | o[1],
        o[2] << 16 | o[3]
    ];
};
var $cb03b3e9decfb2bb$var$x64Multiply = function x64Multiply(m, n) {
    m = [
        m[0] >>> 16,
        m[0] & 0xffff,
        m[1] >>> 16,
        m[1] & 0xffff
    ];
    n = [
        n[0] >>> 16,
        n[0] & 0xffff,
        n[1] >>> 16,
        n[1] & 0xffff
    ];
    var o = [
        0,
        0,
        0,
        0
    ];
    o[3] += m[3] * n[3];
    o[2] += o[3] >>> 16;
    o[3] &= 0xffff;
    o[2] += m[2] * n[3];
    o[1] += o[2] >>> 16;
    o[2] &= 0xffff;
    o[2] += m[3] * n[2];
    o[1] += o[2] >>> 16;
    o[2] &= 0xffff;
    o[1] += m[1] * n[3];
    o[0] += o[1] >>> 16;
    o[1] &= 0xffff;
    o[1] += m[2] * n[2];
    o[0] += o[1] >>> 16;
    o[1] &= 0xffff;
    o[1] += m[3] * n[1];
    o[0] += o[1] >>> 16;
    o[1] &= 0xffff;
    o[0] += m[0] * n[3] + m[1] * n[2] + m[2] * n[1] + m[3] * n[0];
    o[0] &= 0xffff;
    return [
        o[0] << 16 | o[1],
        o[2] << 16 | o[3]
    ];
};
var $cb03b3e9decfb2bb$var$x64Rotl = function x64Rotl(m, n) {
    n %= 64;
    if (n === 32) return [
        m[1],
        m[0]
    ];
    else if (n < 32) return [
        m[0] << n | m[1] >>> 32 - n,
        m[1] << n | m[0] >>> 32 - n
    ];
    else {
        n -= 32;
        return [
            m[1] << n | m[0] >>> 32 - n,
            m[0] << n | m[1] >>> 32 - n
        ];
    }
};
var $cb03b3e9decfb2bb$var$x64LeftShift = function x64LeftShift(m, n) {
    n %= 64;
    if (n === 0) return m;
    else if (n < 32) return [
        m[0] << n | m[1] >>> 32 - n,
        m[1] << n
    ];
    else return [
        m[1] << n - 32,
        0
    ];
};
var $cb03b3e9decfb2bb$var$x64Xor = function x64Xor(m, n) {
    return [
        m[0] ^ n[0],
        m[1] ^ n[1]
    ];
};
var $cb03b3e9decfb2bb$var$x64Fmix = function x64Fmix(h) {
    h = $cb03b3e9decfb2bb$var$x64Xor(h, [
        0,
        h[0] >>> 1
    ]);
    h = $cb03b3e9decfb2bb$var$x64Multiply(h, [
        0xff51afd7,
        0xed558ccd
    ]);
    h = $cb03b3e9decfb2bb$var$x64Xor(h, [
        0,
        h[0] >>> 1
    ]);
    h = $cb03b3e9decfb2bb$var$x64Multiply(h, [
        0xc4ceb9fe,
        0x1a85ec53
    ]);
    h = $cb03b3e9decfb2bb$var$x64Xor(h, [
        0,
        h[0] >>> 1
    ]);
    return h;
};
module.exports.x64hash128 = function(key, seed) {
    key = key || "";
    seed = seed || 0;
    var remainder = key.length % 16;
    var bytes = key.length - remainder;
    var h1 = [
        0,
        seed
    ];
    var h2 = [
        0,
        seed
    ];
    var k1 = [
        0,
        0
    ];
    var k2 = [
        0,
        0
    ];
    var c1 = [
        0x87c37b91,
        0x114253d5
    ];
    var c2 = [
        0x4cf5ad43,
        0x2745937f
    ];
    for(var i = 0; i < bytes; i = i + 16){
        k1 = [
            key.charCodeAt(i + 4) & 0xff | (key.charCodeAt(i + 5) & 0xff) << 8 | (key.charCodeAt(i + 6) & 0xff) << 16 | (key.charCodeAt(i + 7) & 0xff) << 24,
            key.charCodeAt(i) & 0xff | (key.charCodeAt(i + 1) & 0xff) << 8 | (key.charCodeAt(i + 2) & 0xff) << 16 | (key.charCodeAt(i + 3) & 0xff) << 24
        ];
        k2 = [
            key.charCodeAt(i + 12) & 0xff | (key.charCodeAt(i + 13) & 0xff) << 8 | (key.charCodeAt(i + 14) & 0xff) << 16 | (key.charCodeAt(i + 15) & 0xff) << 24,
            key.charCodeAt(i + 8) & 0xff | (key.charCodeAt(i + 9) & 0xff) << 8 | (key.charCodeAt(i + 10) & 0xff) << 16 | (key.charCodeAt(i + 11) & 0xff) << 24
        ];
        k1 = $cb03b3e9decfb2bb$var$x64Multiply(k1, c1);
        k1 = $cb03b3e9decfb2bb$var$x64Rotl(k1, 31);
        k1 = $cb03b3e9decfb2bb$var$x64Multiply(k1, c2);
        h1 = $cb03b3e9decfb2bb$var$x64Xor(h1, k1);
        h1 = $cb03b3e9decfb2bb$var$x64Rotl(h1, 27);
        h1 = $cb03b3e9decfb2bb$var$x64Add(h1, h2);
        h1 = $cb03b3e9decfb2bb$var$x64Add($cb03b3e9decfb2bb$var$x64Multiply(h1, [
            0,
            5
        ]), [
            0,
            0x52dce729
        ]);
        k2 = $cb03b3e9decfb2bb$var$x64Multiply(k2, c2);
        k2 = $cb03b3e9decfb2bb$var$x64Rotl(k2, 33);
        k2 = $cb03b3e9decfb2bb$var$x64Multiply(k2, c1);
        h2 = $cb03b3e9decfb2bb$var$x64Xor(h2, k2);
        h2 = $cb03b3e9decfb2bb$var$x64Rotl(h2, 31);
        h2 = $cb03b3e9decfb2bb$var$x64Add(h2, h1);
        h2 = $cb03b3e9decfb2bb$var$x64Add($cb03b3e9decfb2bb$var$x64Multiply(h2, [
            0,
            5
        ]), [
            0,
            0x38495ab5
        ]);
    }
    k1 = [
        0,
        0
    ];
    k2 = [
        0,
        0
    ];
    var iX = bytes;
    switch(remainder){
        case 15:
            k2 = $cb03b3e9decfb2bb$var$x64Xor(k2, $cb03b3e9decfb2bb$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 14)
            ], 48));
        case 14:
            k2 = $cb03b3e9decfb2bb$var$x64Xor(k2, $cb03b3e9decfb2bb$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 13)
            ], 40));
        case 13:
            k2 = $cb03b3e9decfb2bb$var$x64Xor(k2, $cb03b3e9decfb2bb$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 12)
            ], 32));
        case 12:
            k2 = $cb03b3e9decfb2bb$var$x64Xor(k2, $cb03b3e9decfb2bb$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 11)
            ], 24));
        case 11:
            k2 = $cb03b3e9decfb2bb$var$x64Xor(k2, $cb03b3e9decfb2bb$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 10)
            ], 16));
        case 10:
            k2 = $cb03b3e9decfb2bb$var$x64Xor(k2, $cb03b3e9decfb2bb$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 9)
            ], 8));
        case 9:
            k2 = $cb03b3e9decfb2bb$var$x64Xor(k2, [
                0,
                key.charCodeAt(iX + 8)
            ]);
            k2 = $cb03b3e9decfb2bb$var$x64Multiply(k2, c2);
            k2 = $cb03b3e9decfb2bb$var$x64Rotl(k2, 33);
            k2 = $cb03b3e9decfb2bb$var$x64Multiply(k2, c1);
            h2 = $cb03b3e9decfb2bb$var$x64Xor(h2, k2);
        case 8:
            k1 = $cb03b3e9decfb2bb$var$x64Xor(k1, $cb03b3e9decfb2bb$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 7)
            ], 56));
        case 7:
            k1 = $cb03b3e9decfb2bb$var$x64Xor(k1, $cb03b3e9decfb2bb$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 6)
            ], 48));
        case 6:
            k1 = $cb03b3e9decfb2bb$var$x64Xor(k1, $cb03b3e9decfb2bb$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 5)
            ], 40));
        case 5:
            k1 = $cb03b3e9decfb2bb$var$x64Xor(k1, $cb03b3e9decfb2bb$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 4)
            ], 32));
        case 4:
            k1 = $cb03b3e9decfb2bb$var$x64Xor(k1, $cb03b3e9decfb2bb$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 3)
            ], 24));
        case 3:
            k1 = $cb03b3e9decfb2bb$var$x64Xor(k1, $cb03b3e9decfb2bb$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 2)
            ], 16));
        case 2:
            k1 = $cb03b3e9decfb2bb$var$x64Xor(k1, $cb03b3e9decfb2bb$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 1)
            ], 8));
        case 1:
            k1 = $cb03b3e9decfb2bb$var$x64Xor(k1, [
                0,
                key.charCodeAt(iX)
            ]);
            k1 = $cb03b3e9decfb2bb$var$x64Multiply(k1, c1);
            k1 = $cb03b3e9decfb2bb$var$x64Rotl(k1, 31);
            k1 = $cb03b3e9decfb2bb$var$x64Multiply(k1, c2);
            h1 = $cb03b3e9decfb2bb$var$x64Xor(h1, k1);
    }
    h1 = $cb03b3e9decfb2bb$var$x64Xor(h1, [
        0,
        key.length
    ]);
    h2 = $cb03b3e9decfb2bb$var$x64Xor(h2, [
        0,
        key.length
    ]);
    h1 = $cb03b3e9decfb2bb$var$x64Add(h1, h2);
    h2 = $cb03b3e9decfb2bb$var$x64Add(h2, h1);
    h1 = $cb03b3e9decfb2bb$var$x64Fmix(h1);
    h2 = $cb03b3e9decfb2bb$var$x64Fmix(h2);
    h1 = $cb03b3e9decfb2bb$var$x64Add(h1, h2);
    h2 = $cb03b3e9decfb2bb$var$x64Add(h2, h1);
    return ("00000000" + (h1[0] >>> 0).toString(16)).slice(-8) + ("00000000" + (h1[1] >>> 0).toString(16)).slice(-8) + ("00000000" + (h2[0] >>> 0).toString(16)).slice(-8) + ("00000000" + (h2[1] >>> 0).toString(16)).slice(-8);
};

});


parcelRegister("6Xh0s", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l29cN = parcelRequire("l29cN");

var $510571e20fa49de5$var$promise_polyfill_1 = $l29cN.__importDefault((parcelRequire("5acao")));

var $iOAnx = parcelRequire("iOAnx");

var $8v5Y9 = parcelRequire("8v5Y9");

var $9dPw1 = parcelRequire("9dPw1");
var $510571e20fa49de5$var$TEST_HOST = "";
var $510571e20fa49de5$var$DEV_HOST = "xxid.dev.atl-paas.net";
var $510571e20fa49de5$var$STG_HOST = "xxid.staging.atl-paas.net";
var $510571e20fa49de5$var$PROD_FALLBACK_HOST = "xxid.atl-paas.net";
var $510571e20fa49de5$var$PROD_HOST = "xxid.atlassian.com";
var $510571e20fa49de5$var$defaultTimeout = 3000;
var $510571e20fa49de5$var$XCGenerator = function() {
    function XCGenerator() {}
    XCGenerator.getValue = function(env, timeout, isStorageEnabled) {
        if (timeout === void 0) timeout = $510571e20fa49de5$var$defaultTimeout;
        if (isStorageEnabled === void 0) isStorageEnabled = true;
        var xxidHost = XCGenerator.getHost(env);
        var xxidOrigin = xxidHost ? "https://" + xxidHost : "";
        var iframeUrl = xxidOrigin ? xxidOrigin + "?t=" + new Date().getTime() : "";
        var frame = XCGenerator.addFrame(iframeUrl);
        return new $510571e20fa49de5$var$promise_polyfill_1.default(function(resolve) {
            var listen = function listen1(event) {
                if (event.data.type === "xcReady" && event.origin === xxidOrigin) {
                    var xc = XCGenerator.messageToXc(event);
                    if (isStorageEnabled) xc = $8v5Y9.Storage.updateXc(env, xc);
                    resolve(xc);
                    XCGenerator.removeFrame(frame, listen);
                }
            };
            window.addEventListener("message", listen);
            setTimeout(function() {
                resolve({
                    type: $9dPw1.XIDItemType.XC,
                    state: $9dPw1.XIDState.TIMEOUT
                });
                XCGenerator.removeFrame(frame, listen);
            }, timeout);
        });
    };
    XCGenerator.messageToXc = function(event) {
        var _a = event.data, xc = _a.xc, ts = _a.ts, state = _a.state;
        if (xc && !!Date.parse(ts) && state) return {
            type: $9dPw1.XIDItemType.XC,
            value: xc,
            createdAt: ts,
            state: state
        };
        else return {
            type: $9dPw1.XIDItemType.XC,
            state: state ? state : $9dPw1.XIDState.MALFORMED
        };
    };
    XCGenerator.addFrame = function(url) {
        var frame = document.createElement("iframe");
        frame.id = "xc-" + new Date().getTime();
        frame.src = url;
        frame.style.display = "none";
        frame.style.position = "fixed";
        document.body.appendChild(frame);
        return frame;
    };
    XCGenerator.removeFrame = function(frame, listen) {
        if (document.body.contains(frame)) {
            document.body.removeChild(frame);
            window.removeEventListener("message", listen);
        }
    };
    XCGenerator.getHost = function(env) {
        switch(env){
            case $9dPw1.Environment.STAGE:
                return $510571e20fa49de5$var$STG_HOST;
            case $9dPw1.Environment.PROD:
                return $iOAnx.isAtlassianComDomain() ? $510571e20fa49de5$var$PROD_FALLBACK_HOST : $510571e20fa49de5$var$PROD_HOST;
            case $9dPw1.Environment.TEST:
                return $510571e20fa49de5$var$TEST_HOST;
            case $9dPw1.Environment.LOCAL:
            case $9dPw1.Environment.DEV:
            default:
                return $510571e20fa49de5$var$DEV_HOST;
        }
    };
    return XCGenerator;
}();
module.exports.XCGenerator = $510571e20fa49de5$var$XCGenerator;

});

parcelRegister("iaGC2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $d815O = parcelRequire("d815O");
var $d3aa371f789a7cb9$var$maptoNewXidCandidate = function maptoNewXidCandidate(item, promiseStartTime) {
    var state = item.state, type = item.type, value = item.value, createdAt = item.createdAt;
    if (item && state && type && value && createdAt && (state === $d815O.XIDState.NEW || state === $d815O.XIDState.CHANGED)) return {
        state: state,
        type: type,
        value: value,
        createdAt: createdAt,
        timeTaken: $d3aa371f789a7cb9$var$getCurrentTime() - promiseStartTime
    };
    return null;
};
var $d3aa371f789a7cb9$var$maptoExistingXid = function maptoExistingXid(item) {
    var state = item.state, type = item.type, value = item.value, createdAt = item.createdAt;
    if (item && state && type && value && createdAt && state === $d815O.XIDState.EXISTING) return {
        state: state,
        type: type,
        value: value,
        createdAt: createdAt
    };
    return null;
};
var $d3aa371f789a7cb9$var$mapToAmbiguousXid = function mapToAmbiguousXid(item) {
    var state = item.state, type = item.type;
    if (item && state && type) switch(state){
        case $d815O.XIDState.TIMEOUT:
        case $d815O.XIDState.ERROR:
        case $d815O.XIDState.UNAVAILABLE:
        case $d815O.XIDState.UNKNOWN:
        case $d815O.XIDState.MALFORMED:
            return {
                type: type,
                state: state
            };
    }
    return null;
};
var $d3aa371f789a7cb9$var$mapToMalformedXid = function mapToMalformedXid(item) {
    var type = item.type;
    if (item && type) return {
        type: type,
        state: $d815O.XIDState.MALFORMED
    };
    return null;
};
function $d3aa371f789a7cb9$var$promiseWithTimer(fn) {
    var addTimeTaken = function addTimeTaken(item) {
        var fallbackXid = {
            type: $d815O.XIDItemType.UID,
            state: $d815O.XIDState.MALFORMED
        };
        return $d3aa371f789a7cb9$var$maptoNewXidCandidate(item, start) || $d3aa371f789a7cb9$var$maptoExistingXid(item) || $d3aa371f789a7cb9$var$mapToAmbiguousXid(item) || $d3aa371f789a7cb9$var$mapToMalformedXid(item) || fallbackXid;
    };
    var onPromiseDone = function onPromiseDone(data) {
        return data.map(function(item) {
            return addTimeTaken(item);
        });
    };
    var start = $d3aa371f789a7cb9$var$getCurrentTime();
    return fn().then(onPromiseDone);
}
module.exports.promiseWithTimer = $d3aa371f789a7cb9$var$promiseWithTimer;
var $d3aa371f789a7cb9$var$getCurrentTime = function getCurrentTime() {
    if (performance && performance.now) return performance.now();
    return new Date().getTime();
};

});



parcelRegister("7Y96P", function(module, exports) {

$parcel$export(module.exports, "Cookie", function () { return $bf80f1dd72db8734$export$bd0cf18531183c14; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");
var $bf80f1dd72db8734$export$bd0cf18531183c14 = /*#__PURE__*/ function() {
    "use strict";
    function Cookie() {
        (0, $4GJKx._)(this, Cookie);
    }
    (0, $1wc17._)(Cookie, null, [
        {
            key: "getCookieUrl",
            value: function getCookieUrl(cookieName, defaultUrl) {
                var cookieUrl = Cookie.readCookie(cookieName);
                if (cookieUrl !== null) return cookieUrl;
                return defaultUrl;
            }
        },
        {
            key: "readCookie",
            value: function readCookie(name) {
                try {
                    var nameEQ = name + "=";
                    var ca = document.cookie.split(";");
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = ca[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var c = _step.value;
                            while(c.startsWith(" "))c = c.substring(1, c.length);
                            if (c.startsWith(nameEQ)) return c.substring(nameEQ.length, c.length);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                } catch (e) {
                    // Helpers.sendWrapperLoadError uses this method to get some context
                    // for the reported error, so we don't want to call that here, otherwise
                    // we would get stuck in an infinite loop
                    // Missing login_user_detected cookie is expected for logged out users, so no need to log it.
                    if (name !== "login_user_detected") console.warn("Error reading cookie - ".concat(name), e);
                }
                return null;
            }
        },
        {
            key: "writeCookie",
            value: function writeCookie(name, value, days, topLevelDomain) {
                var seconds = days ? days * 86400 : null;
                Cookie.writeCookieInSeconds(name, value, seconds, topLevelDomain);
            }
        },
        {
            key: "writeCookieInSeconds",
            value: function writeCookieInSeconds(name, value, seconds, topLevelDomain) {
                try {
                    var expires = "";
                    if (seconds) {
                        var date = new Date();
                        date.setTime(date.getTime() + seconds * 1000);
                        expires = "; expires=" + date.toUTCString();
                    }
                    var cookie = name + "=" + value + expires + "; path=/;";
                    var domain = window.location.hostname;
                    if (domain !== "localhost" && topLevelDomain) {
                        var domainTokens = domain.split(".");
                        if (domainTokens.length > 1) {
                            var lastToken = domainTokens[domainTokens.length - 1];
                            var secondLastToken = domainTokens[domainTokens.length - 2];
                            if (isNaN(Number(lastToken)) || isNaN(Number(secondLastToken))) domain = "." + secondLastToken + "." + lastToken;
                        }
                        cookie += " domain=" + domain + ";";
                    }
                    document.cookie = cookie;
                } catch (e) {
                    console.warn("Error writing cookie - ".concat(name), e);
                }
            }
        }
    ]);
    return Cookie;
}();

});

parcelRegister("6E1VX", function(module, exports) {

$parcel$export(module.exports, "Tracking", function () { return $612566eddec26fad$export$3672a9a17fd672c4; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $7Y96P = parcelRequire("7Y96P");

var $e0MtP = parcelRequire("e0MtP");

var $6lrSF = parcelRequire("6lrSF");

var $kVM1Y = parcelRequire("kVM1Y");

var $gIHCW = parcelRequire("gIHCW");

var $eJGhX = parcelRequire("eJGhX");

var $2LAwh = parcelRequire("2LAwh");

var $joVrF = parcelRequire("joVrF");
var $612566eddec26fad$export$3672a9a17fd672c4 = /*#__PURE__*/ function() {
    "use strict";
    function Tracking() {
        (0, $4GJKx._)(this, Tracking);
    }
    (0, $1wc17._)(Tracking, null, [
        {
            key: "_getEventDomain",
            value: function _getEventDomain() {
                return location && location.href ? new URL(location.href).hostname : "";
            }
        },
        {
            key: "_browserSupportsPromises",
            value: function _browserSupportsPromises() {
                return typeof Promise === "function";
            }
        },
        {
            key: "_userOptedOutOfTrackingCookies",
            value: function _userOptedOutOfTrackingCookies() {
                return window.OnetrustActiveGroups && !/,4,/.exec(window.OnetrustActiveGroups);
            }
        },
        {
            key: "_shouldUsePromise",
            value: function _shouldUsePromise() {
                return Tracking._browserSupportsPromises() && !Tracking._userOptedOutOfTrackingCookies();
            }
        },
        {
            key: "trackEvent",
            value: /**
   * Send a track/UI event
   * @method trackEvent
   * @param {string} event the name of the event
   * @param {object} data the properties to be sent with the event
   */ function trackEvent(event, data) {
                if (Tracking._shouldUsePromise()) Tracking.enrichEventDataPromise(data).then(function(enrichedData) {
                    return Tracking._trackEvent(event, enrichedData);
                });
                else {
                    data = Tracking.enrichEventData(data);
                    Tracking._trackEvent(event, data);
                }
            }
        },
        {
            key: "_trackEvent",
            value: function _trackEvent(event, enrichedData) {
                (0, $kVM1Y.GASv3).sendUIEvent(event, enrichedData);
                (0, $gIHCW.Gtm).track(enrichedData, event);
            }
        },
        {
            key: "pageView",
            value: /**
   * send a page/screen event
   * @function pageView
   * @param {object} pageViewProperties - optional, dictionary of properties of the page (see: https://segment.com/docs/libraries/analytics.js/#page)
   * @param {object} pageViewOptions - optional, dictionary options to enable or disable specific integrations for the call (see: https://segment.com/docs/libraries/analytics.js/#page)
   * */ function pageView(pageViewProperties) {
                if (Tracking._shouldUsePromise()) Tracking.enrichEventDataPromise(pageViewProperties).then(function(enrichedPageViewProperties) {
                    Tracking._pageView(enrichedPageViewProperties);
                });
                else {
                    pageViewProperties = Tracking.enrichEventData(pageViewProperties);
                    Tracking._pageView(pageViewProperties);
                }
            }
        },
        {
            key: "_pageView",
            value: function _pageView(enrichedPageViewProperties) {
                enrichedPageViewProperties.wrapperName = "atl-global";
                enrichedPageViewProperties.destinationFlag = "gasv3";
                if (!!window.cmsPageVariant) enrichedPageViewProperties.cmsPageVariant = window.cmsPageVariant;
                (0, $gIHCW.Gtm).page(null, null, enrichedPageViewProperties);
                (0, $kVM1Y.GASv3).sendScreenEvent(null, enrichedPageViewProperties);
            }
        },
        {
            key: "getPageViewId",
            value: /**
   * Gets the pageViewId. Creates one if it doesn't exist
   * @function getPageViewId()
   */ function getPageViewId() {
                if (!Tracking.pageViewId) Tracking.pageViewId = (0, $eJGhX.Guid).guid();
                return Tracking.pageViewId;
            }
        },
        {
            key: "enrichEventDataPromise",
            value: /**
   * adds common data attributes to all track/UI and page/screen events
   * @function enrichEventData
   * @param {object} data the data to enrich
   */ function enrichEventDataPromise(data) {
                // If the data contains a href, then we have clicked a link and are navigating away
                // to a different page, so we don't have time to wait for the retry logic.
                var enableRetryForMarketoId = !(data === null || data === void 0 ? void 0 : data.href) && !(data === null || data === void 0 ? void 0 : data.form);
                return new Promise(function(resolve) {
                    (0, $joVrF.Identity).getMarketoIdPromise(enableRetryForMarketoId).then(function(marketoId) {
                        resolve(Tracking._enrichEventData(data, marketoId));
                    });
                });
            }
        },
        {
            key: "enrichEventData",
            value: /**
   * adds common data attributes to all track/UI and page/screen events
   * @function enrichEventData
   * @param {object} data the data to enrich
   */ function enrichEventData(data) {
                return Tracking._enrichEventData(data, (0, $joVrF.Identity).getMarketoId());
            }
        },
        {
            key: "_enrichEventData",
            value: function _enrichEventData(inputData, marketoId) {
                var data = {};
                if (typeof inputData !== "object" || inputData === null) {
                    var dataValue = inputData;
                    if (typeof dataValue !== "undefined") data["data"] = dataValue;
                } else data = inputData;
                // if not already done, read the request Id cookie set by bxp-gateway
                if (!Tracking.bxpGatewayRequestId) Tracking.bxpGatewayRequestId = (0, $7Y96P.Cookie).readCookie("bxp_gateway_request_id");
                // Only set the property if the cookie was there and readCookie didn't return null
                if (Tracking.bxpGatewayRequestId) data["bxpGatewayRequestId"] = Tracking.bxpGatewayRequestId;
                data["pageViewId"] = Tracking.getPageViewId();
                // add identity data, if not present
                data["atlEventId"] = (0, $eJGhX.Guid).guid();
                data["atlJSVersion"] = (0, $e0MtP.AnalyticsState).version || "1.0.0";
                data["browserLanguages"] = navigator.languages;
                // add category, if not present
                data["category"] = data["category"] || (document.title !== "undefined" ? document.title.trim().replace(/\W+/g, "_") : "");
                // add the cohort to the object
                data[0, $6lrSF.ATL_COHORT] = (0, $6lrSF.Cohort).readWriteAtlCohort();
                var utms = (0, $e0MtP.AnalyticsState).utms;
                if (!!utms) data["campaign"] = {
                    name: utms["utm_campaign"],
                    medium: utms["utm_medium"],
                    source: utms["utm_source"],
                    content: utms["utm_content"],
                    term: utms["utm_term"]
                };
                data["clientSessionId"] = Tracking.readWriteSessionCookie();
                if (Tracking.xid) data["atlXid"] = Tracking.xid;
                data["marketoId"] = marketoId ? marketoId : "";
                return data;
            }
        },
        {
            key: "buildTrackEventProperties",
            value: /**
   * @function buildTrackEventProperties
   * @param {HTMLElement} el target element
   * @param {object} dataset takes data set from event.target.dataset
   * @param {string} label
   * @param {string} href
   * @returns {object} trackEventProperties
   */ function buildTrackEventProperties(el, dataset, label, href) {
                if (!dataset) return;
                var trackEventProperties = {
                    label: label,
                    href: href
                };
                if (el && el.nodeName === "BUTTON") {
                    var form = el.getAttribute("form");
                    if (form) trackEventProperties.form = form;
                }
                var expectedProperties = [
                    "actionSubjectId",
                    "eventContainer",
                    "eventColumn",
                    "eventComponent",
                    "uuid",
                    "event",
                    "inputValue",
                    "parentLabel",
                    "label",
                    "labelEnglish",
                    "productKey",
                    "productVersion",
                    "productEdition",
                    "productPlatform",
                    "schemaVersion",
                    "name"
                ];
                var isExpectedProperty = function(value) {
                    return expectedProperties.includes(value);
                };
                var dataSetEntries = [];
                for(var dataProperty in dataset)if (dataProperty !== "track-event" && dataset.hasOwnProperty(dataProperty)) {
                    var dataPropertyValue = dataset[dataProperty];
                    if (dataPropertyValue) {
                        if (isExpectedProperty(dataProperty)) trackEventProperties[dataProperty] = dataPropertyValue;
                        else {
                            var dataEntry = {};
                            dataEntry[dataProperty] = dataPropertyValue;
                            dataSetEntries.push(dataEntry);
                        }
                    }
                }
                trackEventProperties.dataSet = dataSetEntries;
                return trackEventProperties;
            }
        },
        {
            key: "_autoTrackClickEvent",
            value: /**
   * callback for auto track click events
   * @function _autoTrackClickEvent
   * @ignore
   */ // eslint-disable-next-line complexity
            function _autoTrackClickEvent(event) {
                try {
                    var _targetElem_parentNode;
                    var currentTargetElem = event.currentTarget;
                    var targetElem = event.target;
                    var rawText = targetElem.textContent;
                    var isInput = function(elem) {
                        return elem.tagName === "INPUT";
                    };
                    var isAnchor = function(elem) {
                        return elem.hasAttribute("href");
                    };
                    var isSelect = function(elem) {
                        return elem.tagName === "SELECT";
                    };
                    // handle form buttons differently
                    if (isInput(targetElem)) rawText = targetElem.value !== "" ? targetElem.value : targetElem.textContent;
                    else if (isSelect(targetElem)) {
                        targetElem = targetElem.options[targetElem.selectedIndex] || targetElem;
                        rawText = targetElem.getAttribute("data-label") || targetElem.textContent || targetElem.ariaLabel || targetElem.className;
                    } else if (rawText === "") rawText = ((_targetElem_parentNode = targetElem.parentNode) === null || _targetElem_parentNode === void 0 ? void 0 : _targetElem_parentNode.textContent) || targetElem.title || targetElem.ariaLabel || targetElem.className;
                    var href = isAnchor(targetElem) ? targetElem.href : isAnchor(currentTargetElem) ? currentTargetElem.href : "";
                    var trackEventName = targetElem.getAttribute("data-track-event") || currentTargetElem.getAttribute("data-track-event") || "Clicked-Auto-CTA";
                    var eventLabel = rawText ? rawText.toLowerCase().trim().replace(/ /g, "-") : "";
                    var trackEventProperties = Tracking.buildTrackEventProperties(currentTargetElem, currentTargetElem.dataset, eventLabel, href);
                    //@ts-ignore
                    Tracking.trackEvent(trackEventName, trackEventProperties);
                } catch (err) {
                    (0, $2LAwh.Helpers).sendWrapperLoadError("Error auto-tracking click event");
                }
            }
        },
        {
            key: "autoTrackSelects",
            value: /**
   * queries the document for all selects and adds a change handler to them for tracking
   * @function autoTrackSelects
   */ function autoTrackSelects() {
                try {
                    var selects = Array.from(document.querySelectorAll("select"));
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = selects[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var select = _step.value;
                            if (!Tracking.isAutoTrackingDisabled(select)) {
                                select.removeEventListener("change", Tracking._autoTrackClickEvent);
                                select.addEventListener("change", Tracking._autoTrackClickEvent);
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                } catch (e) {
                    (0, $2LAwh.Helpers).sendWrapperLoadError("Error auto-tracking select event");
                }
            }
        },
        {
            key: "autoTrackButtons",
            value: /**
   * queries the document for all submit buttons and adds a click handler to them for tracking
   * @function autoTrackButtons
   * @param {boolean} trackAll Indicates whether to use WAC's extended auto-tracking
   */ function autoTrackButtons(trackAll) {
                try {
                    var selector = trackAll ? "button, input[type='submit'], input[type='button']" : "button, input[type='submit']";
                    var btns = Array.from(document.querySelectorAll(selector));
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = btns[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var btn = _step.value;
                            if (!Tracking.isAutoTrackingDisabled(btn)) {
                                // remove existing event listener (to prevent redundant listeners from useEffect hooks)
                                btn.removeEventListener("click", Tracking._autoTrackClickEvent);
                                // add an event listener
                                btn.addEventListener("click", Tracking._autoTrackClickEvent);
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                } catch (e) {
                    (0, $2LAwh.Helpers).sendWrapperLoadError("Error auto-tracking button event");
                }
            }
        },
        {
            key: "autoTrackLinks",
            value: /**
   * queries the document for all links with a class of 'button', 'btn', 'cta' and 'external-link' and adds click handler for tracking
   * @function autoTrackLinks
   * @param {boolean} trackAll Indicates whether to use WAC's extended auto-tracking
   */ function autoTrackLinks(trackAll) {
                try {
                    var links = [], selector = trackAll ? "a, .external-link" : "a[class*='button'], a[class*='btn'], .external-link", btnyLinks = Array.from(document.querySelectorAll(selector));
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = btnyLinks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var el = _step.value;
                            var htmlEl = el;
                            if (trackAll || htmlEl.offsetWidth >= 50 || el.className.includes("cta") || el.className.includes("external-link")) links.push(el);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = links[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var link = _step1.value;
                            if (!Tracking.isAutoTrackingDisabled(link)) {
                                link.removeEventListener("click", Tracking._autoTrackClickEvent);
                                link.addEventListener("click", Tracking._autoTrackClickEvent);
                            }
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                } catch (e) {
                    (0, $2LAwh.Helpers).sendWrapperLoadError("Error auto-tracking link event");
                }
            }
        },
        {
            key: "_autoTrackVideoEvent",
            value: /**
   * callback for auto track video events
   * @function _autoTrackVideoEvent
   * @ignore
   */ function _autoTrackVideoEvent(element, eventName) {
                try {
                    var _element_parentElement;
                    var className = typeof element.className !== "undefined" ? element.className : (_element_parentElement = element.parentElement) === null || _element_parentElement === void 0 ? void 0 : _element_parentElement.className, eventLabel = typeof element.textContent !== "undefined" ? element.textContent : "", eventCategory = typeof document.title !== "undefined" ? document.title.replace(/\W+/g, "_").trim() : "";
                    Tracking.trackEvent(eventName, {
                        className: className,
                        category: eventCategory,
                        label: eventLabel,
                        _sio: (0, $7Y96P.Cookie).readCookie("_sio") || "",
                        _atl_path: (0, $7Y96P.Cookie).readCookie("__atl_path") || ""
                    });
                } catch (e) {
                    (0, $2LAwh.Helpers).sendWrapperLoadError("Error auto-tracking video event");
                }
            }
        },
        {
            key: "autoTrackVideos",
            value: /**
   * queries the document for all divs with video open and close links and adds a click handler for tracking
   * @function autoTrackVideos
   */ function autoTrackVideos() {
                try {
                    var videoOpenLinks = Array.from(document.querySelectorAll("div[class*='videoPlayButton'], .video-link, .video_link, .customer-story-video-link"));
                    var videoCloseLinks = Array.from(document.querySelectorAll("div[class='overlay'], .modal.video .close"));
                    var trackVideoOpenEvent = function trackVideoOpenEvent(ev) {
                        var currentTargetElem = ev.currentTarget;
                        Tracking._autoTrackVideoEvent(currentTargetElem, "Opened Video");
                    };
                    var trackVideoCloseEvent = function trackVideoCloseEvent(ev) {
                        var currentTargetElem = ev.currentTarget;
                        Tracking._autoTrackVideoEvent(currentTargetElem, "Closed Video");
                    };
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = videoOpenLinks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var videoOpenLink = _step.value;
                            videoOpenLink.removeEventListener("click", trackVideoOpenEvent);
                            videoOpenLink.addEventListener("click", trackVideoOpenEvent);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = videoCloseLinks[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var videoCloseLink = _step1.value;
                            videoCloseLink.removeEventListener("click", trackVideoCloseEvent);
                            videoCloseLink.addEventListener("click", trackVideoCloseEvent);
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                } catch (e) {
                    (0, $2LAwh.Helpers).sendWrapperLoadError("Error auto-tracking video event");
                }
            }
        },
        {
            key: "isAutoTrackingDisabled",
            value: /**
   * check to see if the element in question contains class 'doNotAutoTrack'
   * @function isAutoTrackingDisabled
   * @param element
   */ function isAutoTrackingDisabled(element) {
                return element.classList.contains("doNotAutoTrack");
            }
        },
        {
            key: "readWriteSessionCookie",
            value: /**
   * return an existing session cookie
   * @function readWriteSessionCookie
   * @returns {string}
   */ function readWriteSessionCookie() {
                var cookie = (0, $7Y96P.Cookie).readCookie("atl_session");
                var name = "atl_session";
                var value = cookie || (0, $eJGhX.Guid).guid();
                var seconds = 1800;
                if ((0, $7Y96P.Cookie).writeCookieInSeconds) (0, $7Y96P.Cookie).writeCookieInSeconds(name, value, seconds);
                return value;
            }
        }
    ]);
    return Tracking;
}();

});
parcelRegister("e0MtP", function(module, exports) {

$parcel$export(module.exports, "AnalyticsState", function () { return $0e4e264b3f2f74b4$export$4a20ceb938e79e70; });

var $4GJKx = parcelRequire("4GJKx");
var $0e4e264b3f2f74b4$export$4a20ceb938e79e70 = function AnalyticsState() {
    "use strict";
    (0, $4GJKx._)(this, AnalyticsState);
};

});

parcelRegister("6lrSF", function(module, exports) {

$parcel$export(module.exports, "ATL_COHORT", function () { return $24f1fb1c674a2a68$export$69c4df819eb57a1b; });
$parcel$export(module.exports, "Cohort", function () { return $24f1fb1c674a2a68$export$b76685d1b5a37732; });
/**
 * @typedef {object} Cohort
 * @property {string} ATL_COHORT The cookie name
 * @property {object | null} readWriteAtlCohort The cohort object or null
 * @property {object | null} readAtlCohort The cohort object or null
 */ 
var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $7Y96P = parcelRequire("7Y96P");

var $eJGhX = parcelRequire("eJGhX");

var $2LAwh = parcelRequire("2LAwh");
var $24f1fb1c674a2a68$export$69c4df819eb57a1b = "atlCohort";
var $24f1fb1c674a2a68$export$d2bea30496ddbdeb = "2";
var $24f1fb1c674a2a68$export$d28e176424fc1872 = [
    "index",
    "bucketedAtUTC",
    "version",
    "bucketId"
];
var $24f1fb1c674a2a68$var$cohortBuckets = {
    bucketAll: {
        bucketId: 0
    }
};
var $24f1fb1c674a2a68$export$b76685d1b5a37732 = /*#__PURE__*/ function() {
    "use strict";
    function Cohort() {
        (0, $4GJKx._)(this, Cohort);
    }
    (0, $1wc17._)(Cohort, null, [
        {
            key: "readAtlCohort",
            value: /*
   Hypothetical way to add other buckets (adding their name to the types above):
       if (isMobileDevice()) {
          cohortBuckets.bucket_mobile = {
              bucketId: 1
          };
      }
       if (isEnglishSpeaking()) {
          cohortBuckets.bucket_english = {};
      }
       function isMobileDevice() {
          // some logic here...
          return true;
      }
  
      function isEnglishSpeaking() {
          // some logic here...
          return false;
      }
  */ /**
   * Tries to read the ATL_COHORT cookie and return it
   * @function readAtlCohort
   * @return {object | null} the cohort object or null
   */ function readAtlCohort() {
                var atlCohort;
                var atlCohortCookie = (0, $7Y96P.Cookie).readCookie($24f1fb1c674a2a68$export$69c4df819eb57a1b);
                try {
                    atlCohort = atlCohortCookie ? JSON.parse(atlCohortCookie) : null;
                    return (0, $2LAwh.Helpers).isObject(atlCohort) ? atlCohort : null;
                } catch (e) {
                    (0, $2LAwh.Helpers).sendWrapperLoadError("Error reading ALT_COHORT Cookie");
                    return null;
                }
            }
        },
        {
            key: "writeAtlCohort",
            value: /**
   * Writes the stringified `atlCohort` object to the `ATL_COHORT` cookie
   * @function writeAtlCohort
   * @ignore
   * @param {object} atlCohort the cohort object
   */ function writeAtlCohort(atlCohort) {
                if ((0, $2LAwh.Helpers).isObject(atlCohort)) (0, $7Y96P.Cookie).writeCookie($24f1fb1c674a2a68$export$69c4df819eb57a1b, JSON.stringify(atlCohort), 3650, true);
            }
        },
        {
            key: "bucketExists",
            value: /**
   * Checks to see if a bucket is in the `atlCohort` object and returns `true` if it does and `false` if it does not
   * @function bucketExists
   * @ignore
   * @param  {BucketName} key a bucket key
   * @param  {Partial<AtlCohort>} atlCohort the cohort object
   * @return {boolean} whether or not a bucket is in the cohort object
   */ function bucketExists(key, atlCohort) {
                if ((0, $2LAwh.Helpers).isObject(atlCohort)) {
                    var bucket = atlCohort[key];
                    if (bucket && (0, $2LAwh.Helpers).isObject(bucket)) return $24f1fb1c674a2a68$export$d28e176424fc1872.every(function(bucketAttribute) {
                        return typeof bucket[bucketAttribute] !== "undefined";
                    });
                }
                return false;
            }
        },
        {
            key: "createBucket",
            value: /**
   * Takes a `bucketKey` and returns and object with `index` and `bucketedAtUTC` properties and optional attribute properties
   * @function createBucket
   * @ignore
   * @param  {string} bucketKey
   * @return {object} a bucket object
   */ function createBucket(bucketKey) {
                var bucketAttributes = $24f1fb1c674a2a68$var$cohortBuckets[bucketKey];
                var anonymousId = (0, $7Y96P.Cookie).readCookie("ajs_anonymous_id");
                var bucket = {
                    bucketedAtUTC: new Date().toISOString(),
                    version: $24f1fb1c674a2a68$export$d2bea30496ddbdeb,
                    index: anonymousId ? (0, $eJGhX.Guid).guidHashCode((0, $eJGhX.Guid).addNumberToGUID(anonymousId, bucketAttributes.bucketId)) % 100 : Math.ceil(Math.random() * 100),
                    bucketId: bucketAttributes.bucketId
                };
                return bucket;
            }
        },
        {
            key: "readWriteAtlCohort",
            value: /**
   * Reads `ATL_COHORT` cookie and if there are any missing buckets, it adds them and writes them to the cookie. Returns the `atlCohort` object
   * @function readWriteAtlCohort
   * @param {boolean} writeOverride when present, trigger a cohort rewrite
   * @return {object | null} the cohort object or null
   */ function readWriteAtlCohort(writeOverride) {
                // if overriding the cohort, do not read the existing cohort; set to empty to force a write
                var atlCohort = writeOverride ? {} : Cohort.readAtlCohort() || {};
                var missingBuckets = Object.keys($24f1fb1c674a2a68$var$cohortBuckets).filter(function(bucket) {
                    return !Cohort.bucketExists(bucket, atlCohort);
                });
                if (missingBuckets.length) {
                    missingBuckets.forEach(function(missingBucket) {
                        return atlCohort[missingBucket] = Cohort.createBucket(missingBucket);
                    });
                    Cohort.writeAtlCohort(atlCohort);
                }
                return atlCohort;
            }
        }
    ]);
    return Cohort;
}();

});
parcelRegister("eJGhX", function(module, exports) {

$parcel$export(module.exports, "Guid", function () { return $10b9ca9063a879be$export$f6d5d4774149a3bf; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $cZ38z = parcelRequire("cZ38z");

var $2LAwh = parcelRequire("2LAwh");

var $7Y3dk = parcelRequire("7Y3dk");
var $10b9ca9063a879be$export$f6d5d4774149a3bf = /*#__PURE__*/ function() {
    "use strict";
    function Guid() {
        (0, $4GJKx._)(this, Guid);
    }
    (0, $1wc17._)(Guid, null, [
        {
            key: "guid",
            value: function guid() {
                try {
                    return (0, $cZ38z.default)();
                } catch (e) {
                    (0, $2LAwh.Helpers).sendWrapperLoadError("Error getting uuidV4");
                    return (0, $7Y3dk.mathGuid)();
                }
            }
        },
        {
            key: "guidNoDashes",
            value: function guidNoDashes() {
                return (0, $cZ38z.default)().replace(/-/g, "");
            }
        },
        {
            key: "addNumberToGUID",
            value: /**
   * Convert a GUID deterministically based on the passed in number
   * @param guid - guid to convert
   * @param number - a number to modify the guid by
   * @returns the modified guid or the original in case of failure
   */ function addNumberToGUID(guid, number) {
                // take the last 4 digits and convert to a hex string representation
                var hex = guid.slice(-4);
                var value = parseInt(hex, 16);
                if (isNaN(value)) return guid;
                var valLength = value.toString(16).length;
                value += number;
                // clamp to 2 bytes
                if (value > 65535) value -= 65536;
                else if (value < 0) value += 65536;
                // convert back to hex and make sure its as long as many digits as the initial value
                // This is needed for subtraction
                hex = value.toString(16);
                if (hex.length < valLength) hex = ("00000" + hex).slice(-valLength);
                // replace the last 4 digits of the guid with the last 4 digits of the converted value
                return guid.slice(0, guid.length - hex.length) + hex;
            }
        },
        {
            key: "guidHashCode",
            value: // guidHashCode takes in a String and returns a Number
            // e.g. "51c96b99-f1b0-4727-9802-a40c096929ae" => 411024693
            function guidHashCode(guid) {
                var hash = 0;
                for(var i = 0; i < guid.length; i++){
                    hash += Math.pow(guid.charCodeAt(i) * 31, guid.length - i);
                    hash = hash & hash; // Convert to 32bit integer
                }
                return Math.abs(hash);
            }
        }
    ]);
    return Guid;
}();

});
parcelRegister("2LAwh", function(module, exports) {

$parcel$export(module.exports, "Helpers", function () { return $7f71ae639b0d5d8a$export$4dc2b60021baefca; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $cv9Rk = parcelRequire("cv9Rk");

var $hDCWT = parcelRequire("hDCWT");

var $7Y96P = parcelRequire("7Y96P");

var $e0MtP = parcelRequire("e0MtP");
// This regex is the simplified RFC 5322 expression from http://www.regular-expressions.info/email.html
var $7f71ae639b0d5d8a$var$EMAIL_REGEX = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/i;
var $7f71ae639b0d5d8a$var$PATH_OVERRIDE = "/path-contained-email-address";
var $7f71ae639b0d5d8a$export$4dc2b60021baefca = /*#__PURE__*/ function() {
    "use strict";
    function Helpers() {
        (0, $4GJKx._)(this, Helpers);
    }
    (0, $1wc17._)(Helpers, null, [
        {
            key: "makeRestRequest",
            value: /**
   * Attempts to send an HTTP request.
   * @function makeRestRequest
   * @param {string} method the request method
   * @param {string} url the request URL
   * @param {Object[]} headers an array of headers to set in the request
   * @param {string} body the body of the request
   * @param {boolean} credentials whether to send request with credentials; defaults to false
   * @param {callback} callback optional callback function
   * @param {object} mockReq used in testing so we don't actually send a request
   */ function makeRestRequest(method, url, headers, body, credentials, callback, mockReq) {
                var xhr = mockReq || new XMLHttpRequest();
                xhr.open(method, url);
                xhr.withCredentials = credentials ? credentials : false;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (!!headers) try {
                    // set headers
                    for(var _iterator = headers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var item = _step.value;
                        xhr.setRequestHeader(item.header, item.value);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (!body) body = null;
                xhr.onreadystatechange = function() {
                    if (xhr.readyState === XMLHttpRequest.DONE) {
                        if (xhr.status >= 200 && xhr.status < 300) {
                            if (callback) callback(xhr.responseText);
                        } else if (callback) callback("error");
                    }
                };
                xhr.send(body);
            }
        },
        {
            key: "sendWrapperLoadError",
            value: function sendWrapperLoadError(message, data) {
                var anonymousId = (0, $7Y96P.Cookie).readCookie("ajs_anonymous_id");
                var decodedAnonymousId;
                if (anonymousId) // the cookie value is URI encoded with quotes on the outside, so decode and remove them
                decodedAnonymousId = decodeURIComponent(anonymousId).replace(/['"]+/g, "");
                var userId = (0, $7Y96P.Cookie).readCookie("__aid_user_id");
                var decodedUserId;
                if (userId) decodedUserId = decodeURIComponent(userId);
                var xid = (0, $7Y96P.Cookie).readCookie("seg_xid");
                var body = {
                    anonymousId: decodedAnonymousId || null,
                    userId: decodedUserId || null,
                    xid: xid || null,
                    message: message || null,
                    version: (0, $e0MtP.AnalyticsState).version,
                    additionalData: data || null
                };
                var env = "production";
                var url = env === "production" ? "https://www.atlassian.com/endpoint/atlglobalload" : "https://wac.stg.internal.atlassian.com/endpoint/atlglobalload";
                var headers = [
                    {
                        header: "Content-type",
                        value: "application/json"
                    },
                    {
                        header: "accept",
                        value: "*/*"
                    }
                ];
                Helpers.makeRestRequest("POST", url, headers, JSON.stringify(body), false);
            }
        },
        {
            key: "getParameterByName",
            value: function getParameterByName(name) {
                name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
                var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
                var results = regex.exec(window.location.search);
                var value = results && results.length >= 2 ? results[1] : null;
                return !value ? "" : decodeURIComponent(value.replace(/\+/g, " "));
            }
        },
        {
            key: "getUtms",
            value: function getUtms(utms) {
                if (window.location.search.includes("utm_")) {
                    for(var utmKey in utms)if (utms.hasOwnProperty(utmKey)) utms[utmKey] = Helpers.getParameterByName(utmKey);
                    return utms;
                }
                return null;
            }
        },
        {
            key: "canonical",
            value: // taken from https://github.com/segmentio/canonical/blob/master/lib/index.js
            function canonical() {
                var tags = Array.from(document.getElementsByTagName("link"));
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = tags[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var tag = _step.value;
                        if (tag && tag.getAttribute("rel") === "canonical") return tag.getAttribute("href");
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return null;
            }
        },
        {
            key: "getCanonicalUrl",
            value: // taken from https://github.com/segmentio/analytics.js-core/blob/master/lib/pageDefaults.js
            function getCanonicalUrl() {
                var canon = Helpers.canonical();
                if (canon) return canon;
                var url = window.location.href;
                var i = url.indexOf("#");
                return i === -1 ? url : url.slice(0, i);
            }
        },
        {
            key: "addActualUrl",
            value: function addActualUrl(obj) {
                if (window.location.href !== Helpers.getCanonicalUrl()) {
                    // respect cleaned url
                    if (obj["url"]) obj["actualUrl"] = obj["url"];
                    else obj["actualUrl"] = window.location.href;
                }
            }
        },
        {
            key: "isObject",
            value: function isObject(o) {
                return o !== null && typeof o === "object" && Array.isArray(o) === false;
            }
        },
        {
            key: "urlContainsEmail",
            value: function urlContainsEmail(url) {
                return Boolean($7f71ae639b0d5d8a$var$EMAIL_REGEX.exec(decodeURIComponent(url)));
            }
        },
        {
            key: "dropEmailQueryParams",
            value: // dropping attributes containing email
            function dropEmailQueryParams(obj) {
                var sanitizedObj = {};
                Object.entries(obj).forEach(function(param) {
                    var _param = (0, $cv9Rk._)(param, 2), key = _param[0], value = _param[1];
                    if (!Helpers.urlContainsEmail(value)) sanitizedObj[key] = value;
                });
                return sanitizedObj;
            }
        },
        {
            key: "dropEmailFromPath",
            value: // dropping email from the url path
            function dropEmailFromPath(path) {
                var newPath = "";
                if (Helpers.urlContainsEmail(path)) {
                    var pathArray = path.split("/");
                    pathArray.forEach(function(value) {
                        if (value !== "" && !Helpers.urlContainsEmail(value)) newPath = newPath + "/" + value;
                    });
                }
                return newPath === "" ? path : newPath;
            }
        },
        {
            key: "convertQueryObjToString",
            value: // convert query params object to query params string
            function convertQueryObjToString(obj) {
                var queryString = new URLSearchParams(obj).toString();
                if (queryString !== "") queryString = "?" + queryString;
                return queryString;
            }
        },
        {
            key: "emailAddressIsDetected",
            value: function emailAddressIsDetected() {
                return Helpers.urlContainsEmail(window.location.href) || Helpers.urlContainsEmail(document.referrer);
            }
        },
        {
            key: "hostnameFromUrl",
            value: function hostnameFromUrl(url) {
                return url.replace(/http(s|):\/\//g, "").split(/(\/|:)/g)[0];
            }
        },
        {
            key: "addCleanedUrlAndPaths",
            value: function addCleanedUrlAndPaths(obj) {
                obj["url"] = window.location.origin + $7f71ae639b0d5d8a$var$PATH_OVERRIDE;
                obj["path"] = $7f71ae639b0d5d8a$var$PATH_OVERRIDE;
                obj["search"] = "";
                return obj;
            }
        },
        {
            key: "addCleanedReferrer",
            value: function addCleanedReferrer(obj) {
                obj["referrer"] = Helpers.urlWithoutPath(document.referrer) + $7f71ae639b0d5d8a$var$PATH_OVERRIDE;
                return obj;
            }
        },
        {
            key: "urlWithoutPath",
            value: function urlWithoutPath(url) {
                var fakeTag = document.createElement("a");
                fakeTag.href = url;
                return fakeTag.protocol + "//" + fakeTag.host;
            }
        },
        {
            key: "maskURL",
            value: // mask query params of an string/url if it has email
            function maskURL(input) {
                if (input === "" || input === undefined) return input;
                var url = new URL(input);
                var obj = (0, (/*@__PURE__*/$parcel$interopDefault($hDCWT))).parse(url.search);
                obj = Helpers.dropEmailQueryParams(obj);
                return url.origin + Helpers.dropEmailFromPath(url.pathname) + Helpers.convertQueryObjToString(obj);
            }
        }
    ]);
    return Helpers;
}();

});
parcelRegister("hDCWT", function(module, exports) {

$parcel$export(module.exports, "extract", function () { return $cd744a9a319cc687$export$f9380c9a627682d3; }, function (v) { return $cd744a9a319cc687$export$f9380c9a627682d3 = v; });
$parcel$export(module.exports, "parse", function () { return $cd744a9a319cc687$export$98e6a39c04603d36; }, function (v) { return $cd744a9a319cc687$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "stringify", function () { return $cd744a9a319cc687$export$fac44ee5b035f737; }, function (v) { return $cd744a9a319cc687$export$fac44ee5b035f737 = v; });
$parcel$export(module.exports, "parseUrl", function () { return $cd744a9a319cc687$export$7a5253c0f62e0150; }, function (v) { return $cd744a9a319cc687$export$7a5253c0f62e0150 = v; });
$parcel$export(module.exports, "stringifyUrl", function () { return $cd744a9a319cc687$export$a8c1621ea79325d3; }, function (v) { return $cd744a9a319cc687$export$a8c1621ea79325d3 = v; });
$parcel$export(module.exports, "pick", function () { return $cd744a9a319cc687$export$357523c63a2253b9; }, function (v) { return $cd744a9a319cc687$export$357523c63a2253b9 = v; });
$parcel$export(module.exports, "exclude", function () { return $cd744a9a319cc687$export$44c361b8ec72ef7f; }, function (v) { return $cd744a9a319cc687$export$44c361b8ec72ef7f = v; });

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");
var $cd744a9a319cc687$export$f9380c9a627682d3;
var $cd744a9a319cc687$export$98e6a39c04603d36;
var $cd744a9a319cc687$export$fac44ee5b035f737;
var $cd744a9a319cc687$export$7a5253c0f62e0150;
var $cd744a9a319cc687$export$a8c1621ea79325d3;
var $cd744a9a319cc687$export$357523c63a2253b9;
var $cd744a9a319cc687$export$44c361b8ec72ef7f;
"use strict";

var $6pUpV = parcelRequire("6pUpV");

var $zKeTC = parcelRequire("zKeTC");

var $ljZAm = parcelRequire("ljZAm");

var $2Mx4x = parcelRequire("2Mx4x");
var $cd744a9a319cc687$var$isNullOrUndefined = function(value) {
    return value === null || value === undefined;
};
function $cd744a9a319cc687$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case "index":
            return function(key) {
                return function(result, value) {
                    var index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return (0, $c6Xmf._)(result).concat([
                        [
                            $cd744a9a319cc687$var$encode(key, options),
                            "[",
                            index,
                            "]"
                        ].join("")
                    ]);
                    return (0, $c6Xmf._)(result).concat([
                        [
                            $cd744a9a319cc687$var$encode(key, options),
                            "[",
                            $cd744a9a319cc687$var$encode(index, options),
                            "]=",
                            $cd744a9a319cc687$var$encode(value, options)
                        ].join("")
                    ]);
                };
            };
        case "bracket":
            return function(key) {
                return function(result, value) {
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return (0, $c6Xmf._)(result).concat([
                        [
                            $cd744a9a319cc687$var$encode(key, options),
                            "[]"
                        ].join("")
                    ]);
                    return (0, $c6Xmf._)(result).concat([
                        [
                            $cd744a9a319cc687$var$encode(key, options),
                            "[]=",
                            $cd744a9a319cc687$var$encode(value, options)
                        ].join("")
                    ]);
                };
            };
        case "comma":
        case "separator":
            return function(key) {
                return function(result, value) {
                    if (value === null || value === undefined || value.length === 0) return result;
                    if (result.length === 0) return [
                        [
                            $cd744a9a319cc687$var$encode(key, options),
                            "=",
                            $cd744a9a319cc687$var$encode(value, options)
                        ].join("")
                    ];
                    return [
                        [
                            result,
                            $cd744a9a319cc687$var$encode(value, options)
                        ].join(options.arrayFormatSeparator)
                    ];
                };
            };
        default:
            return function(key) {
                return function(result, value) {
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return (0, $c6Xmf._)(result).concat([
                        $cd744a9a319cc687$var$encode(key, options)
                    ]);
                    return (0, $c6Xmf._)(result).concat([
                        [
                            $cd744a9a319cc687$var$encode(key, options),
                            "=",
                            $cd744a9a319cc687$var$encode(value, options)
                        ].join("")
                    ]);
                };
            };
    }
}
function $cd744a9a319cc687$var$parserForArrayFormat(options) {
    var result;
    switch(options.arrayFormat){
        case "index":
            return function(key, value, accumulator) {
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case "bracket":
            return function(key, value, accumulator) {
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "comma":
        case "separator":
            return function(key, value, accumulator) {
                var isArray = typeof value === "string" && value.includes(options.arrayFormatSeparator);
                var isEncodedArray = typeof value === "string" && !isArray && $cd744a9a319cc687$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $cd744a9a319cc687$var$decode(value, options) : value;
                var newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map(function(item) {
                    return $cd744a9a319cc687$var$decode(item, options);
                }) : value === null ? value : $cd744a9a319cc687$var$decode(value, options);
                accumulator[key] = newValue;
            };
        default:
            return function(key, value, accumulator) {
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $cd744a9a319cc687$var$validateArrayFormatSeparator(value) {
    if (typeof value !== "string" || value.length !== 1) throw new TypeError("arrayFormatSeparator must be single character string");
}
function $cd744a9a319cc687$var$encode(value, options) {
    if (options.encode) return options.strict ? $6pUpV(value) : encodeURIComponent(value);
    return value;
}
function $cd744a9a319cc687$var$decode(value, options) {
    if (options.decode) return $zKeTC(value);
    return value;
}
function $cd744a9a319cc687$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === "object") return $cd744a9a319cc687$var$keysSorter(Object.keys(input)).sort(function(a, b) {
        return Number(a) - Number(b);
    }).map(function(key) {
        return input[key];
    });
    return input;
}
function $cd744a9a319cc687$var$removeHash(input) {
    var hashStart = input.indexOf("#");
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $cd744a9a319cc687$var$getHash(url) {
    var hash = "";
    var hashStart = url.indexOf("#");
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $cd744a9a319cc687$var$extract(input) {
    input = $cd744a9a319cc687$var$removeHash(input);
    var queryStart = input.indexOf("?");
    if (queryStart === -1) return "";
    return input.slice(queryStart + 1);
}
function $cd744a9a319cc687$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === "string" && value.trim() !== "") value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) value = value.toLowerCase() === "true";
    return value;
}
function $cd744a9a319cc687$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $cd744a9a319cc687$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    var formatter = $cd744a9a319cc687$var$parserForArrayFormat(options);
    // Create an object with no prototype
    var ret = Object.create(null);
    if (typeof query !== "string") return ret;
    query = query.trim().replace(/^[?#&]/, "");
    if (!query) return ret;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = query.split("&")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var param = _step.value;
            if (param === "") continue;
            var _splitOnFirst = (0, $cv9Rk._)($ljZAm(options.decode ? param.replace(/\+/g, " ") : param, "="), 2), key = _splitOnFirst[0], value = _splitOnFirst[1];
            // Missing `=` should be `null`:
            // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
            value = value === undefined ? null : [
                "comma",
                "separator"
            ].includes(options.arrayFormat) ? value : $cd744a9a319cc687$var$decode(value, options);
            formatter($cd744a9a319cc687$var$decode(key, options), value, ret);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = Object.keys(ret)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var key1 = _step1.value;
            var value1 = ret[key1];
            var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
            if (typeof value1 === "object" && value1 !== null) try {
                for(var _iterator2 = Object.keys(value1)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                    var k = _step2.value;
                    value1[k] = $cd744a9a319cc687$var$parseValue(value1[k], options);
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                        _iterator2.return();
                    }
                } finally{
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
            else ret[key1] = $cd744a9a319cc687$var$parseValue(value1, options);
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce(function(result, key) {
        var value = ret[key];
        if (Boolean(value) && typeof value === "object" && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $cd744a9a319cc687$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$cd744a9a319cc687$export$f9380c9a627682d3 = $cd744a9a319cc687$var$extract;
$cd744a9a319cc687$export$98e6a39c04603d36 = $cd744a9a319cc687$var$parse;
$cd744a9a319cc687$export$fac44ee5b035f737 = function(object, options) {
    if (!object) return "";
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: "none",
        arrayFormatSeparator: ","
    }, options);
    $cd744a9a319cc687$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    var shouldFilter = function(key) {
        return options.skipNull && $cd744a9a319cc687$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === "";
    };
    var formatter = $cd744a9a319cc687$var$encoderForArrayFormat(options);
    var objectCopy = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.keys(object)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (!shouldFilter(key)) objectCopy[key] = object[key];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map(function(key) {
        var value = object[key];
        if (value === undefined) return "";
        if (value === null) return $cd744a9a319cc687$var$encode(key, options);
        if (Array.isArray(value)) return value.reduce(formatter(key), []).join("&");
        return $cd744a9a319cc687$var$encode(key, options) + "=" + $cd744a9a319cc687$var$encode(value, options);
    }).filter(function(x) {
        return x.length > 0;
    }).join("&");
};
$cd744a9a319cc687$export$7a5253c0f62e0150 = function(url, options) {
    options = Object.assign({
        decode: true
    }, options);
    var _splitOnFirst = (0, $cv9Rk._)($ljZAm(url, "#"), 2), url_ = _splitOnFirst[0], hash = _splitOnFirst[1];
    return Object.assign({
        url: url_.split("?")[0] || "",
        query: $cd744a9a319cc687$var$parse($cd744a9a319cc687$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $cd744a9a319cc687$var$decode(hash, options)
    } : {});
};
$cd744a9a319cc687$export$a8c1621ea79325d3 = function(object, options) {
    options = Object.assign({
        encode: true,
        strict: true
    }, options);
    var url = $cd744a9a319cc687$var$removeHash(object.url).split("?")[0] || "";
    var queryFromUrl = $cd744a9a319cc687$export$f9380c9a627682d3(object.url);
    var parsedQueryFromUrl = $cd744a9a319cc687$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    var query = Object.assign(parsedQueryFromUrl, object.query);
    var queryString = $cd744a9a319cc687$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = "?".concat(queryString);
    var hash = $cd744a9a319cc687$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = "#".concat($cd744a9a319cc687$var$encode(object.fragmentIdentifier, options));
    return "".concat(url).concat(queryString).concat(hash);
};
$cd744a9a319cc687$export$357523c63a2253b9 = function(input, filter, options) {
    options = Object.assign({
        parseFragmentIdentifier: true
    }, options);
    var _exports_parseUrl = $cd744a9a319cc687$export$7a5253c0f62e0150(input, options), url = _exports_parseUrl.url, query = _exports_parseUrl.query, fragmentIdentifier = _exports_parseUrl.fragmentIdentifier;
    return $cd744a9a319cc687$export$a8c1621ea79325d3({
        url: url,
        query: $2Mx4x(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$cd744a9a319cc687$export$44c361b8ec72ef7f = function(input, filter, options) {
    var exclusionFilter = Array.isArray(filter) ? function(key) {
        return !filter.includes(key);
    } : function(key, value) {
        return !filter(key, value);
    };
    return $cd744a9a319cc687$export$357523c63a2253b9(input, exclusionFilter, options);
};

});


parcelRegister("7Y3dk", function(module, exports) {

$parcel$export(module.exports, "mathGuid", function () { return $741b93b55269349f$export$dba5740cd1e5d9ea; });
/**
 * See:
 *  - http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/24891600#24891600
 * for more context around the issue of psuedo-randomness used by browsers and the solution used below.
 *
 * and:
 *  - http://web.archive.org/web/20120503063359/http://baagoe.com/en/RandomMusings/javascript/
 * for info regarding the Alea code used below.
 */ var $741b93b55269349f$var$trueRandom = function() {
    function Mash() {
        var n = 0xefc8249d;
        var mash = function mash(data) {
            for(var i = 0; i < data.length; i++){
                n += data.charCodeAt(i);
                var h = 0.02519603282416938 * n;
                n = h >>> 0;
                h -= n;
                h *= n;
                n = h >>> 0;
                h -= n;
                n += h * 0x100000000; // 2^32
            }
            return (n >>> 0) * 2.3283064365386963e-10; // 2^-32
        };
        return mash;
    }
    function Alea() {
        return function(args) {
            // Johannes BaagÃ¸e <baagoe@baagoe.com>, 2010
            var s0 = 0;
            var s1 = 0;
            var s2 = 0;
            var c = 1;
            if (args.length == 0) args = [
                +new Date()
            ];
            var mash = Mash();
            s0 = mash(" ");
            s1 = mash(" ");
            s2 = mash(" ");
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = args[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var item = _step.value;
                    s0 -= mash(item);
                    if (s0 < 0) s0 += 1;
                    s1 -= mash(item);
                    if (s1 < 0) s1 += 1;
                    s2 -= mash(item);
                    if (s2 < 0) s2 += 1;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            var random = function random() {
                var t = 2091639 * s0 + c * 2.3283064365386963e-10; // 2^-32
                s0 = s1;
                s1 = s2;
                return s2 = t - (c = t | 0);
            };
            random.uint32 = function() {
                return random() * 0x100000000; // 2^32
            };
            random.fract53 = function() {
                return random() + (random() * 0x200000 | 0) * 1.1102230246251565e-16; // 2^-53
            };
            random.version = "Alea 0.9";
            random.args = args;
            return random;
        }(Array.prototype.slice.call(arguments));
    }
    return Alea();
}();
var $741b93b55269349f$export$dba5740cd1e5d9ea = function mathGuid() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        var r = $741b93b55269349f$var$trueRandom() * 16 | 0, v = c == "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
};

});



parcelRegister("kVM1Y", function(module, exports) {

$parcel$export(module.exports, "GASv3", function () { return $ffe227100cdaae90$export$d3e9576dd68d5e11; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $4j9Ig = parcelRequire("4j9Ig");

var $7Y96P = parcelRequire("7Y96P");

var $e0MtP = parcelRequire("e0MtP");

var $eJGhX = parcelRequire("eJGhX");

var $2LAwh = parcelRequire("2LAwh");

var $joVrF = parcelRequire("joVrF");

var $6E1VX = parcelRequire("6E1VX");

var $9YAD1 = parcelRequire("9YAD1");

var $hDCWT = parcelRequire("hDCWT");
var $ffe227100cdaae90$var$attributeWhiteList = [
    "atlCohort",
    "featureFlags"
];
var $ffe227100cdaae90$var$ATL_USER_HASH = "atlUserHash";
var $ffe227100cdaae90$export$d3e9576dd68d5e11 = /*#__PURE__*/ function() {
    "use strict";
    function GASv3() {
        (0, $4GJKx._)(this, GASv3);
    }
    (0, $1wc17._)(GASv3, null, [
        {
            key: "sendUIEvent",
            value: /**
   * Sends a UI event to GASv3
   * @function sendUIEvent
   * @param {string} name
   * @param {object} data
   * @param {object} skipEnrichment - whether to add additional data
   */ function sendUIEvent(name, data, skipEnrichment) {
                if (!skipEnrichment) data = GASv3.enrichEventData(data);
                data["trackEventName"] = name;
                var source = GASv3.setSource(data);
                var uiEvent = {
                    // this will likely change
                    action: data["event"] || "clicked",
                    actionSubject: data["eventComponent"] || "component",
                    actionSubjectId: data["actionSubjectId"] || undefined,
                    source: source,
                    attributes: data
                };
                this._createAndFireEvent("ui", uiEvent);
            }
        },
        {
            key: "_createAndFireEvent",
            value: function _createAndFireEvent(eventType, payload) {
                if (!(0, $e0MtP.AnalyticsState).createAnalyticsEvent) return;
                (0, $4j9Ig.default)("atl-global")((0, $cxjpp._)((0, $do9pw._)({}, payload), {
                    eventType: eventType
                }))((0, $e0MtP.AnalyticsState).createAnalyticsEvent);
            }
        },
        {
            key: "sendScreenEvent",
            value: /**
   * Sends a Screen event to GASv3
   * @function sendScreenEvent
   * @param {string} name
   * @param {object} data - GASv3 screen event attributes
   *                 data.screenNameOverride - special data attribute that overrides the screen name for the event, instead of the default 'page'.
   *                                           If used, this attribute will be stripped from the data before sending to GASv3.
   * @param {object} skipEnrichment - whether to add additional data
   */ function sendScreenEvent(name, data, skipEnrichment) {
                if (!skipEnrichment) data = GASv3.enrichEventData(data);
                data["name"] = name;
                var screenName = typeof data !== "undefined" && data["screenNameOverride"] || "page";
                if (typeof data === "object") delete data["screenNameOverride"];
                this._createAndFireEvent("screen", {
                    name: screenName,
                    attributes: data
                });
                GASv3.sendIdentityEvent();
            }
        },
        {
            key: "sendIdentityEvent",
            value: /**
   *
   * @function sendIdentityEvent
   */ function sendIdentityEvent() {
                // load the identity hash cookie
                var atlUserHash = (0, $7Y96P.Cookie).readCookie($ffe227100cdaae90$var$ATL_USER_HASH);
                // get the user identifiers
                var identifiers = GASv3.getUserIdentifiers();
                // calculate the data hash of the known identifiers
                var calculatedHash = (0, $eJGhX.Guid).guidHashCode(JSON.stringify(identifiers)).toString();
                if (!atlUserHash || atlUserHash !== calculatedHash) {
                    // save new hash and send UI event
                    (0, $7Y96P.Cookie).writeCookie($ffe227100cdaae90$var$ATL_USER_HASH, calculatedHash, 3650, true);
                    var data = {
                        event: "identified",
                        eventComponent: "user",
                        identifiers: identifiers,
                        writeKey: (0, $e0MtP.AnalyticsState).writeKey
                    };
                    GASv3.sendUIEvent("", data, true);
                }
            }
        },
        {
            key: "getUserIdentifiers",
            value: function getUserIdentifiers() {
                return {
                    anonymousId: (0, $e0MtP.AnalyticsState).anonymousId,
                    atlassianAccountId: (0, $joVrF.Identity).getAtlassianUserId(),
                    crossDomainId: (0, $6E1VX.Tracking).xid,
                    optimizelyEndUserId: null,
                    trelloUserId: (0, $joVrF.Identity).getTrelloUserId()
                };
            }
        },
        {
            key: "setSource",
            value: function setSource(data) {
                var set = false;
                var source = "";
                if (data["eventContainer"]) {
                    source += data["eventContainer"].split(" ")[0];
                    set = true;
                }
                if (data["eventColumn"]) {
                    source += data["eventColumn"].split(" ")[0];
                    set = true;
                }
                if (!set) source = "none";
                return source;
            }
        },
        {
            key: "getReferrerURL",
            value: // fix for hot-99118
            function getReferrerURL(ref) {
                if ((0, $joVrF.Identity).isReferrerTrello()) {
                    var referrer = new URL(ref);
                    return referrer.hostname + (0, $9YAD1.TrelloUrlScrubber).scrubUrl(referrer.pathname, "");
                }
                return ref;
            }
        },
        {
            key: "enrichEventData",
            value: /**
   * This function is to specifically add data needed in Socrates but not provided by default in GASv3 like it is for Segment
   * @function enrichEventData
   * @param {object} inputData  // a dictionary of data to enrich
   */ // eslint-disable-next-line complexity
            function enrichEventData(inputData) {
                var data = {};
                if (typeof inputData !== "object" || inputData === null) {
                    var dataValue = inputData;
                    if (typeof dataValue !== "undefined") data.data = dataValue;
                } else data = inputData;
                var newData = JSON.parse(JSON.stringify(data));
                newData.writeKey = (0, $e0MtP.AnalyticsState).writeKey;
                newData.isMarketingEvent = GASv3.isMarketingEvent;
                var page;
                var ref;
                var page_canonical_url;
                try {
                    // convert all passed in values to string if they are currently objects
                    Object.keys(newData).forEach(function(inputKey) {
                        var key = inputKey;
                        if (newData[key] && typeof newData[key] === "object" && !Array.isArray(newData[key]) && !$ffe227100cdaae90$var$attributeWhiteList.includes(key)) // @ts-ignore
                        newData[key] = JSON.stringify(newData[key]);
                    });
                    var href = GASv3.getLocation();
                    page = href ? new URL((0, $2LAwh.Helpers).maskURL(href)) : null;
                    ref = document.referrer ? new URL((0, $2LAwh.Helpers).maskURL(document.referrer)) : null;
                    page_canonical_url = (0, $2LAwh.Helpers).maskURL((0, $2LAwh.Helpers).getCanonicalUrl());
                    newData.page_title = newData.page_title || document.title || "";
                    newData.page_domain = page ? page.hostname || "" : "";
                    newData.page_subdomain = page ? page.hostname || "" : "";
                    // referrer attributes
                    newData.page_referrer_domain = ref ? ref.hostname || "" : "";
                    newData.page_referrer_subdomain = ref ? ref.hostname || "" : "";
                    if ((0, $joVrF.Identity).isReferrerTrello()) {
                        // fix for hot-99118
                        newData.page_canonical_url = page ? (0, $9YAD1.TrelloUrlScrubber).scrubUrl(page.href, page.origin) || "" : "";
                        newData.page_url = page ? (0, $9YAD1.TrelloUrlScrubber).scrubUrl(page.href, page.origin) || "" : "";
                        newData.page_path = page ? (0, $9YAD1.TrelloUrlScrubber).scrubUrl(page.pathname, new URL(page.href).pathname) || "" : "";
                        newData.page_url_parameters = page ? (0, $9YAD1.TrelloUrlScrubber).scrubUrl(page.search, "") : "";
                        newData.page_url_params_json = page ? JSON.stringify($hDCWT.parse((0, $9YAD1.TrelloUrlScrubber).scrubUrl(page.search, new URL(page.origin).pathname))) : "";
                        newData.page_referrer_url_params_json = ref ? JSON.stringify($hDCWT.parse((0, $9YAD1.TrelloUrlScrubber).scrubUrl(ref.search, new URL(ref.origin).pathname))) : "";
                        newData.page_referrer_path = ref ? (0, $9YAD1.TrelloUrlScrubber).scrubUrl(ref.pathname, new URL(ref.origin).pathname) || "" : "";
                        newData.page_referrer_url = ref ? ref.origin + (0, $9YAD1.TrelloUrlScrubber).scrubUrl(ref.pathname, new URL(ref.origin).pathname) || "" : "";
                    } else {
                        newData.page_canonical_url = page_canonical_url;
                        newData.page_url = page ? page.href || "" : "";
                        newData.page_path = page ? page.pathname || "" : "";
                        newData.page_url_parameters = page ? page.search || "" : "";
                        newData.page_url_params_json = page ? JSON.stringify($hDCWT.parse(page.search)) : "";
                        newData.page_referrer_url_params_json = ref ? JSON.stringify($hDCWT.parse(ref.search)) : "";
                        newData.page_referrer_path = ref ? ref.pathname || "" : "";
                        newData.page_referrer_url = ref ? ref.href || "" : "";
                    }
                    newData.cookiesEnabled = window.navigator ? window.navigator.cookieEnabled : "unknown";
                    newData.activeGroups = window.OnetrustActiveGroups ? window.OnetrustActiveGroups : "";
                } catch (e) {
                    // fix for hot-99118
                    var additionalData = {
                        error: e instanceof Error ? e.message : JSON.stringify(e),
                        href: location ? location.href : "no location",
                        referrer: document ? document.referrer ? GASv3.getReferrerURL(document.referrer) : "no referrer" : "no document"
                    };
                    (0, $2LAwh.Helpers).sendWrapperLoadError("GASv3 enrichEventData error", JSON.stringify(additionalData));
                }
                return newData;
            }
        },
        {
            key: "getLocation",
            value: function getLocation() {
                return location.href;
            }
        }
    ]);
    return GASv3;
}();

});
parcelRegister("4j9Ig", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3230788d4c4fa821$export$2e2bcd8739ae039; });
var $3230788d4c4fa821$export$2e2bcd8739ae039 = function(channel) {
    return function(payload) {
        return function(createAnalyticsEvent) {
            var consumerEvent = createAnalyticsEvent(payload);
            var clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };
    };
};

});

parcelRegister("joVrF", function(module, exports) {

$parcel$export(module.exports, "Identity", function () { return $663e0097a082f7a4$export$544bf02140fa9a77; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $7Y96P = parcelRequire("7Y96P");

var $e0MtP = parcelRequire("e0MtP");

var $6lrSF = parcelRequire("6lrSF");

var $2LAwh = parcelRequire("2LAwh");

var $6E1VX = parcelRequire("6E1VX");
var $663e0097a082f7a4$var$TRELLO_USER_ID = "token";
var $663e0097a082f7a4$var$XID = "seg_xid";
var $663e0097a082f7a4$var$pageViewProperties = {};
var $663e0097a082f7a4$var$MARKETO_ID = "_mkto_trk";
var $663e0097a082f7a4$var$REFERRER_TRELLO_DOMAINS = [
    "trello.com",
    "trellis.coffee"
];
var $663e0097a082f7a4$export$544bf02140fa9a77 = /*#__PURE__*/ function() {
    "use strict";
    function Identity() {
        (0, $4GJKx._)(this, Identity);
    }
    (0, $1wc17._)(Identity, null, [
        {
            key: "identify",
            value: /**
   * Sends a track event with known identifiers
   * @function identify
   * @param {string} userId - required
   * @param {object} traits - optional, dictionary of custom traits to send
   */ function identify(userId, traits) {
                traits = !!traits && typeof traits === "object" ? traits : {};
                var data = traits;
                data["atlassian_id"] = userId;
                data["atlJSVersion"] = (0, $e0MtP.AnalyticsState).version || "1.0.0";
                try {
                    data["ga_clientid"] = (0, $7Y96P.Cookie).readCookie("_ga");
                } catch (e) {
                    (0, $2LAwh.Helpers).sendWrapperLoadError("Error reading _ga cookie");
                }
                (0, $6E1VX.Tracking).trackEvent("known_identifiers", data);
            }
        },
        {
            key: "autoIdentify",
            value: /**
   * used internally to gather all known ids and call identify
   * @function autoIdentify
   */ function autoIdentify() {
                var emailDetected = (0, $2LAwh.Helpers).emailAddressIsDetected();
                var userId = Identity.getAtlassianUserId();
                var xid = (0, $7Y96P.Cookie).readCookie($663e0097a082f7a4$var$XID);
                if (emailDetected) {
                    var integrations = {
                        "All": false,
                        "Google Analytics": true
                    };
                    if (!(0, $e0MtP.AnalyticsState).pageViewOptions) (0, $e0MtP.AnalyticsState).pageViewOptions = {
                        integrations: integrations
                    };
                    else (0, $e0MtP.AnalyticsState).pageViewOptions["integrations"] = integrations;
                    if ((0, $2LAwh.Helpers).urlContainsEmail(window.location.href)) (0, $2LAwh.Helpers).addCleanedUrlAndPaths($663e0097a082f7a4$var$pageViewProperties);
                    if ((0, $2LAwh.Helpers).urlContainsEmail(document.referrer)) (0, $2LAwh.Helpers).addCleanedReferrer($663e0097a082f7a4$var$pageViewProperties);
                }
                try {
                    $663e0097a082f7a4$var$pageViewProperties["anonymous_id"] = (0, $e0MtP.AnalyticsState).anonymousId;
                } catch (e) {
                    (0, $2LAwh.Helpers).sendWrapperLoadError("Error reading segment anonymousId");
                }
                try {
                    $663e0097a082f7a4$var$pageViewProperties[0, $6lrSF.ATL_COHORT] = (0, $6lrSF.Cohort).readWriteAtlCohort();
                } catch (e) {
                    (0, $2LAwh.Helpers).sendWrapperLoadError("Error read / writing atlCohort cookie");
                }
                if (userId || xid) Identity.identify(userId, $663e0097a082f7a4$var$pageViewProperties);
            }
        },
        {
            key: "getAtlassianUserId",
            value: function getAtlassianUserId() {
                var userId = (0, $7Y96P.Cookie).readCookie("__aid_user_id");
                if (userId) return decodeURIComponent(userId);
                return null;
            }
        },
        {
            key: "getTrelloUserId",
            value: function getTrelloUserId() {
                try {
                    var page = location.href ? new URL(location.href) : null;
                    // since the trello cookie is such a common name. check to make sure we're actually on a trello page
                    if (page && (page.hostname.includes("trello.com") || page.hostname.includes("trellis.coffee"))) {
                        var token = (0, $7Y96P.Cookie).readCookie($663e0097a082f7a4$var$TRELLO_USER_ID);
                        if (token) return decodeURIComponent(token).split("/")[0];
                    }
                } catch (e) {
                    (0, $2LAwh.Helpers).sendWrapperLoadError("Error reading Trello userId");
                }
                return null;
            }
        },
        {
            key: "getMarketoId",
            value: function getMarketoId() {
                var marketoId = (0, $7Y96P.Cookie).readCookie($663e0097a082f7a4$var$MARKETO_ID);
                if (marketoId) return decodeURIComponent(marketoId);
                return null;
            }
        },
        {
            key: "getMarketoIdPromise",
            value: function getMarketoIdPromise() {
                var enableRetry = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                var waitCount = 0;
                var maxWait = enableRetry ? 5000 : 0;
                return new Promise(function(resolve) {
                    Identity._internalMarketoPromise(waitCount, maxWait, resolve);
                });
            }
        },
        {
            key: "_internalMarketoPromise",
            value: function _internalMarketoPromise(waitCount, maxWait, resolve) {
                var delay = 500;
                var marketoId = (0, $7Y96P.Cookie).readCookie($663e0097a082f7a4$var$MARKETO_ID);
                // wait for up to 5 seconds for the marketo cookie to show up
                if (marketoId) resolve(decodeURIComponent(marketoId));
                else {
                    waitCount += delay;
                    if (waitCount >= maxWait) {
                        (0, $2LAwh.Helpers).sendWrapperLoadError("getMarketoIdPromise error");
                        resolve("");
                    } else setTimeout(function() {
                        Identity._internalMarketoPromise(waitCount, maxWait, resolve);
                    }, delay);
                }
            }
        },
        {
            key: "isReferrerTrello",
            value: function isReferrerTrello() {
                if (!document.referrer) return false;
                var ref = new URL(document.referrer);
                return $663e0097a082f7a4$var$REFERRER_TRELLO_DOMAINS.includes(ref.hostname);
            }
        }
    ]);
    return Identity;
}();

});

parcelRegister("9YAD1", function(module, exports) {

$parcel$export(module.exports, "TrelloUrlScrubber", function () { return $b55d4e26dec7c927$export$6177d4ea0363b1de; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");
var $b55d4e26dec7c927$var$routeTypes = {
    BOARD: "board",
    BOARD_BUTLER: "board-butler",
    BOARD_BUTLER_PAGE: "board-butler-page",
    BOARD_RECOMMEND: "board-recommend",
    CARD: "card",
    ENTERPRISE_ADMIN: "enterprise-admin",
    ENTERPRISE_ADMIN_TAB: "enterprise-admin-tab",
    ENTERPRISE_ADMIN_TAB_SUBSECTION: "enterprise-admin-tab-subsection",
    HOME: "home",
    TEMPLATES: "templates",
    TEMPLATES_CATEGORIES: "templates-categories",
    TEMPLATES_STORY: "templates-story",
    TEMPLATES_RECOMMEND: "templates-recommend",
    TEMPLATES_SUBMIT: "templates-submit",
    TEMPLATE: "template",
    USER: "user",
    USER_TABS: "user-tabs",
    USER_CARDS_WORKSPACE: "user-cards-workspace",
    VIEW: "view",
    WORKSPACE: "workspace",
    WORKSPACE_SECTION: "workspace-section",
    WORKSPACE_MEMBERS_SUBSECTION: "workspace-members-subsection",
    WORKSPACE_VIEWS_SUBSECTION: "workspace-views-subsection",
    POWER_UPS_HOME: "power-ups-home",
    POWER_UPS_ALL: "power-ups-all",
    POWER_UPS_TRELLO: "power-ups-trello",
    POWER_UPS_CATEGORIES: "power-ups-categories",
    UPGRADE_TEAM: "select-team-to-upgrade",
    SHORTCUTS: "shortcuts"
};
// Trello indices of non UGC/PII in the pathname depending on their route type
var $b55d4e26dec7c927$var$ALLOWLIST_INDICES = {
    ROUTE_IDENTIFIER: 0,
    ROUTE_SHORTLINK: 1,
    B_ROUTE_BUTLER: 3,
    B_ROUTE_BUTLER_PAGE: 4,
    B_ROUTE_RECOMMEND: 4,
    E_ROUTE_ADMIN: 2,
    E_ROUTE_ADMIN_TAB_NAME: 3,
    E_ROUTE_ADMIN_TAB_SUBSECTION_NAME: 4,
    POWER_UPS_ROUTE_PAGE: 1,
    POWER_UPS_ROUTE_CATEGORY: 1,
    POWER_UPS_ROUTE_CATEGORY_NAME: 2,
    TEMPLATES_ROUTE_PAGE: 1,
    TEMPLATES_ROUTE_CATEGORY: 1,
    TEMPLATES_ROUTE_TEMPLATE_NAME: 2,
    TEMPLATES_ROUTE_RECOMMEND: 4,
    U_ROUTE_TAB_NAME: 2,
    W_ROUTE_PAGE: 2,
    W_ROUTE_PAGE_SUBSECTION: 3
};
var $b55d4e26dec7c927$var$routePatternMap = new Map([
    [
        $b55d4e26dec7c927$var$routeTypes.BOARD_RECOMMEND,
        {
            id: $b55d4e26dec7c927$var$routeTypes.BOARD_RECOMMEND,
            regExp: new RegExp("^/b/([^/]+)/([^/]+)/([^/]+)/recommend$"),
            allowlist: [
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.ROUTE_SHORTLINK,
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.B_ROUTE_RECOMMEND
            ]
        }
    ],
    [
        $b55d4e26dec7c927$var$routeTypes.BOARD_BUTLER_PAGE,
        {
            id: $b55d4e26dec7c927$var$routeTypes.BOARD_BUTLER_PAGE,
            regExp: new RegExp("^/b/([^/]+)/([^/]+)/butler/(rules|card-buttons|board-buttons|schedule|on-dates|connected-apps)$"),
            allowlist: [
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.ROUTE_SHORTLINK,
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.B_ROUTE_BUTLER,
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.B_ROUTE_BUTLER_PAGE
            ]
        }
    ],
    [
        $b55d4e26dec7c927$var$routeTypes.BOARD_BUTLER,
        {
            id: $b55d4e26dec7c927$var$routeTypes.BOARD_BUTLER,
            regExp: new RegExp("^/b/([^/]+)/([^/]+)/butler/$"),
            allowlist: [
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.ROUTE_SHORTLINK,
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.B_ROUTE_BUTLER
            ]
        }
    ],
    [
        $b55d4e26dec7c927$var$routeTypes.BOARD,
        {
            id: $b55d4e26dec7c927$var$routeTypes.BOARD,
            regExp: new RegExp("^/b/([^/]+)(?:/(.*?))?$"),
            allowlist: [
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.ROUTE_SHORTLINK
            ]
        }
    ],
    [
        $b55d4e26dec7c927$var$routeTypes.CARD,
        {
            id: $b55d4e26dec7c927$var$routeTypes.CARD,
            regExp: new RegExp("^/c/"),
            allowlist: [
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.ROUTE_SHORTLINK
            ]
        }
    ],
    [
        $b55d4e26dec7c927$var$routeTypes.ENTERPRISE_ADMIN_TAB_SUBSECTION,
        {
            id: $b55d4e26dec7c927$var$routeTypes.ENTERPRISE_ADMIN_TAB_SUBSECTION,
            regExp: new RegExp("^/e/([^/]+)/admin/(members|workspaces|boards)/(managed|boardguests|deactivated|non-enterprise|pending|public)$"),
            allowlist: [
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.E_ROUTE_ADMIN,
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.E_ROUTE_ADMIN_TAB_NAME,
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.E_ROUTE_ADMIN_TAB_SUBSECTION_NAME
            ]
        }
    ],
    [
        $b55d4e26dec7c927$var$routeTypes.ENTERPRISE_ADMIN_TAB,
        {
            id: $b55d4e26dec7c927$var$routeTypes.ENTERPRISE_ADMIN_TAB,
            regExp: new RegExp("^/e/([^/]+)/admin/(members|workspaces|settings|attachment-restrictions|boards|power-ups|auditlog|account-administration|sso|api-tokens)$"),
            allowlist: [
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.E_ROUTE_ADMIN,
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.E_ROUTE_ADMIN_TAB_NAME
            ]
        }
    ],
    [
        $b55d4e26dec7c927$var$routeTypes.ENTERPRISE_ADMIN,
        {
            id: $b55d4e26dec7c927$var$routeTypes.ENTERPRISE_ADMIN,
            regExp: new RegExp("^/e/([^/]+)/admin$"),
            allowlist: [
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.E_ROUTE_ADMIN
            ]
        }
    ],
    [
        $b55d4e26dec7c927$var$routeTypes.POWER_UPS_HOME,
        {
            id: $b55d4e26dec7c927$var$routeTypes.POWER_UPS_HOME,
            regExp: new RegExp("^/power-ups$"),
            allowlist: [
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER
            ]
        }
    ],
    [
        $b55d4e26dec7c927$var$routeTypes.POWER_UPS_ALL,
        {
            id: $b55d4e26dec7c927$var$routeTypes.POWER_UPS_ALL,
            regExp: new RegExp("^/power-ups/all$"),
            allowlist: [
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.POWER_UPS_ROUTE_PAGE
            ]
        }
    ],
    [
        $b55d4e26dec7c927$var$routeTypes.POWER_UPS_TRELLO,
        {
            id: $b55d4e26dec7c927$var$routeTypes.POWER_UPS_TRELLO,
            regExp: new RegExp("^/power-ups/made-by-trello$"),
            allowlist: [
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.POWER_UPS_ROUTE_PAGE
            ]
        }
    ],
    [
        $b55d4e26dec7c927$var$routeTypes.POWER_UPS_CATEGORIES,
        {
            id: $b55d4e26dec7c927$var$routeTypes.POWER_UPS_CATEGORIES,
            regExp: new RegExp("^/power-ups/category/(automation|analytics-reporting|board-utilities|communication-collaboration|developer-tools|file-management|hr-operations|it-project-management|marketing-social-media|product-design|sales-support)$"),
            allowlist: [
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.POWER_UPS_ROUTE_CATEGORY,
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.POWER_UPS_ROUTE_CATEGORY_NAME
            ]
        }
    ],
    [
        $b55d4e26dec7c927$var$routeTypes.HOME,
        {
            id: $b55d4e26dec7c927$var$routeTypes.HOME,
            regExp: new RegExp("^/$"),
            allowlist: [
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER
            ]
        }
    ],
    [
        $b55d4e26dec7c927$var$routeTypes.UPGRADE_TEAM,
        {
            id: $b55d4e26dec7c927$var$routeTypes.UPGRADE_TEAM,
            regExp: new RegExp("^/select-team-to-upgrade$"),
            allowlist: [
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER
            ]
        }
    ],
    [
        $b55d4e26dec7c927$var$routeTypes.SHORTCUTS,
        {
            id: $b55d4e26dec7c927$var$routeTypes.SHORTCUTS,
            regExp: new RegExp("^/shortcuts$"),
            allowlist: [
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER
            ]
        }
    ],
    [
        $b55d4e26dec7c927$var$routeTypes.TEMPLATES_SUBMIT,
        {
            id: $b55d4e26dec7c927$var$routeTypes.TEMPLATES_SUBMIT,
            regExp: new RegExp("^/templates/submit$"),
            allowlist: [
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.TEMPLATES_ROUTE_PAGE
            ]
        }
    ],
    [
        $b55d4e26dec7c927$var$routeTypes.TEMPLATES_RECOMMEND,
        {
            id: $b55d4e26dec7c927$var$routeTypes.TEMPLATES_RECOMMEND,
            regExp: new RegExp("^/templates/([^/]+)/([^/]+)/([^/]+)/recommend$"),
            allowlist: [
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.TEMPLATES_ROUTE_CATEGORY,
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.TEMPLATES_ROUTE_TEMPLATE_NAME,
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.TEMPLATES_ROUTE_RECOMMEND
            ]
        }
    ],
    [
        $b55d4e26dec7c927$var$routeTypes.TEMPLATES_CATEGORIES,
        {
            id: $b55d4e26dec7c927$var$routeTypes.TEMPLATES_CATEGORIES,
            regExp: new RegExp("^/templates/(business|design|education|engineering|marketing|operations-hr|personal|productivity|product-management|project-management|remote-work|sales|support|team-management)$"),
            allowlist: [
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.TEMPLATES_ROUTE_CATEGORY
            ]
        }
    ],
    [
        $b55d4e26dec7c927$var$routeTypes.TEMPLATES_STORY,
        {
            id: $b55d4e26dec7c927$var$routeTypes.TEMPLATES_STORY,
            regExp: new RegExp("^/templates/([^/]+)/([^/]+)$"),
            allowlist: [
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.TEMPLATES_ROUTE_CATEGORY,
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.TEMPLATES_ROUTE_TEMPLATE_NAME
            ]
        }
    ],
    [
        $b55d4e26dec7c927$var$routeTypes.TEMPLATES,
        {
            id: $b55d4e26dec7c927$var$routeTypes.TEMPLATES,
            regExp: new RegExp("^/templates$"),
            allowlist: [
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER
            ]
        }
    ],
    [
        $b55d4e26dec7c927$var$routeTypes.USER_CARDS_WORKSPACE,
        {
            id: $b55d4e26dec7c927$var$routeTypes.USER_CARDS_WORKSPACE,
            regExp: new RegExp("^/u/([^/]+)/cards/([^/]+)$"),
            allowlist: [
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.U_ROUTE_TAB_NAME
            ]
        }
    ],
    [
        $b55d4e26dec7c927$var$routeTypes.USER_TABS,
        {
            id: $b55d4e26dec7c927$var$routeTypes.USER_TABS,
            regExp: new RegExp("^/u/([^/]+)/(profile|activity|boards|cards|labs|tasks)$"),
            allowlist: [
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.U_ROUTE_TAB_NAME
            ]
        }
    ],
    [
        $b55d4e26dec7c927$var$routeTypes.USER,
        {
            id: $b55d4e26dec7c927$var$routeTypes.USER,
            regExp: new RegExp("^/u/"),
            allowlist: [
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER
            ]
        }
    ],
    [
        $b55d4e26dec7c927$var$routeTypes.VIEW,
        {
            id: $b55d4e26dec7c927$var$routeTypes.VIEW,
            regExp: new RegExp("^/v/"),
            allowlist: [
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.ROUTE_SHORTLINK
            ]
        }
    ],
    [
        $b55d4e26dec7c927$var$routeTypes.WORKSPACE_SECTION,
        {
            id: $b55d4e26dec7c927$var$routeTypes.WORKSPACE_SECTION,
            regExp: new RegExp("^/w/([^/]+)/(account|billing|home|export|free-trial|members|tables|getting-started|highlights|reports)$"),
            allowlist: [
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.W_ROUTE_PAGE
            ]
        }
    ],
    [
        $b55d4e26dec7c927$var$routeTypes.WORKSPACE_MEMBERS_SUBSECTION,
        {
            id: $b55d4e26dec7c927$var$routeTypes.WORKSPACE_MEMBERS_SUBSECTION,
            regExp: new RegExp("^/w/([^/]+)/members/(guests|requests)$"),
            allowlist: [
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.W_ROUTE_PAGE,
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.W_ROUTE_PAGE_SUBSECTION
            ]
        }
    ],
    [
        $b55d4e26dec7c927$var$routeTypes.WORKSPACE_VIEWS_SUBSECTION,
        {
            id: $b55d4e26dec7c927$var$routeTypes.WORKSPACE_VIEWS_SUBSECTION,
            regExp: new RegExp("^/w/([^/]+)/views/(table|calendar|)$"),
            allowlist: [
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.W_ROUTE_PAGE,
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.W_ROUTE_PAGE_SUBSECTION
            ]
        }
    ],
    [
        $b55d4e26dec7c927$var$routeTypes.WORKSPACE,
        {
            id: $b55d4e26dec7c927$var$routeTypes.WORKSPACE,
            regExp: new RegExp("^/w/"),
            allowlist: [
                $b55d4e26dec7c927$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER
            ]
        }
    ]
]);
var $b55d4e26dec7c927$export$6177d4ea0363b1de = /*#__PURE__*/ function() {
    "use strict";
    function TrelloUrlScrubber() {
        (0, $4GJKx._)(this, TrelloUrlScrubber);
    }
    (0, $1wc17._)(TrelloUrlScrubber, null, [
        {
            key: "_determineRoute",
            value: function _determineRoute(urlPathname) {
                var routePatternArray = Array.from($b55d4e26dec7c927$var$routePatternMap.values());
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = routePatternArray[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var routeDefinition = _step.value;
                        if (routeDefinition.regExp.exec(urlPathname)) return routeDefinition;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return null;
            }
        },
        {
            key: "_reconstructPathname",
            value: // reconstructs the pathname to include sections that do NOT include UGC/PII
            function _reconstructPathname(pathnameSections, sectionsToKeep) {
                var reconstructedUrl = "";
                for(var i = 0; i < pathnameSections.length; i++)if (sectionsToKeep.includes(i)) reconstructedUrl += "/" + pathnameSections[i];
                return reconstructedUrl;
            }
        },
        {
            key: "scrubUrl",
            value: // finds the matching route for the pathname we want to include in our marketing
            // analytics and then sanitizes it of UGC/PII
            function scrubUrl(urlPathname, defaultPathname) {
                var matchingRoute = TrelloUrlScrubber._determineRoute(urlPathname);
                // remove starting slash to allow matchers to use ^ properly
                var partialUrl = urlPathname.substring(1, urlPathname.length);
                var pathnameSections = partialUrl.split("/");
                // to avoid UGC/PII related HOTs, we should be extra cautious & return a
                // generic path for URLs that don't follow a known pattern
                return matchingRoute ? TrelloUrlScrubber._reconstructPathname(pathnameSections, matchingRoute.allowlist) : defaultPathname;
            }
        }
    ]);
    return TrelloUrlScrubber;
}();

});


parcelRegister("gIHCW", function(module, exports) {

$parcel$export(module.exports, "Gtm", function () { return $4294c9496bd83b60$export$9ab4d56492766a00; });
/**
 * Internal module for initializing Snowplow and making Snowplow-specific event calls. Public init functions can be found in Initializer module
 * @module Gtm
 */ 
var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $e0MtP = parcelRequire("e0MtP");
var $4294c9496bd83b60$export$9ab4d56492766a00 = /*#__PURE__*/ function() {
    "use strict";
    function Gtm() {
        (0, $4GJKx._)(this, Gtm);
    }
    (0, $1wc17._)(Gtm, null, [
        {
            key: "initialize",
            value: /**
   * Initializes Google Tag Manager
   * @function initialize
   */ function initialize(writeKey) {
                var containerId = Gtm.getContainerId(writeKey);
                if (containerId) {
                    var _firstScript_parentNode;
                    window["dataLayer"] = window["dataLayer"] || [];
                    window["dataLayer"].push({
                        "gtm.start": new Date().getTime(),
                        "event": "gtm.js"
                    });
                    var firstScript = document.getElementsByTagName("script")[0];
                    var gtmScript = document.createElement("script");
                    gtmScript.async = true;
                    gtmScript.src = "https://www.googletagmanager.com/gtm.js?id=" + containerId;
                    firstScript === null || firstScript === void 0 ? void 0 : (_firstScript_parentNode = firstScript.parentNode) === null || _firstScript_parentNode === void 0 ? void 0 : _firstScript_parentNode.insertBefore(gtmScript, firstScript);
                }
            }
        },
        {
            key: "page",
            value: /**
   * Sends a gtm page call
   * @function page
   */ function page(name, category, data) {
                var event = "Loaded a Page";
                Gtm.track(data, event);
                if (category) {
                    event = "Viewed " + name + " " + category + " Page";
                    Gtm.track(data, event);
                }
                if (name) {
                    event = "Viewed " + name + " Page";
                    Gtm.track(data, event);
                }
            }
        },
        {
            key: "track",
            value: function track(data, event) {
                var props = typeof data !== "undefined" ? JSON.parse(JSON.stringify(data)) : {};
                var anonId = (0, $e0MtP.AnalyticsState).anonymousId;
                if (anonId) props.gasv3AnonymousId = anonId;
                if (event) props.event = event;
                var dataLayer = "dataLayer";
                window[dataLayer] = window[dataLayer] || [];
                window[dataLayer].push(props);
            }
        },
        {
            key: "getContainerId",
            value: function getContainerId(writeKey) {
                var containerIds = Gtm.getContainerIdMapping();
                return containerIds[writeKey];
            }
        },
        {
            key: "getContainerIdMapping",
            value: function getContainerIdMapping() {
                return {
                    // Production
                    "ycih1ygfsk": "GTM-MR6PJQR",
                    // support.atlassian.com
                    "9nfqb81km3": "GTM-TSGXFNC",
                    // confluence.atlassian.com
                    "kFTUHPhH9Q": "GTM-TRS3MV",
                    // bitbucket
                    "u7y09b0olq": "GTM-5VS67RK",
                    // developer.atlassian.com
                    "eNVsl3NOQquS5E0YXjD4prfiNVqVP3mr": "GTM-KZLJPX4",
                    // opsgenie
                    "bvsetm1g1y": "GTM-5RJSBR",
                    // atlassian.com-cart
                    "kiv6wyh2nw": "GTM-5RJSBR",
                    // atlassian.com
                    "r4n974s99s": "GTM-5RJSBR",
                    // blogs.atlassian.com
                    "swoogo": "GTM-5RJSBR",
                    // events.atlassian.com
                    "8oi64no": "GTM-K7MDT22",
                    // statuspage.io
                    "xjtlog1hqa": "GTM-KQ6R2C3",
                    // marketplace.atlassian.com
                    "bNSPpYAL9OiAkamBRvfRJoRu9YANW14I": "GTM-MGV77B",
                    // docs.atlassian.com-aui
                    "TNnhg0QuQfHEpBTzp27kJXNWZoMqSvkw": "GTM-TQZMFCL",
                    // community.atlassian.com
                    "trello": "GTM-PJ8M5SK",
                    // trello
                    // Test
                    "4J6H7c3XTcpm1dbenkOILSyOachvf9It": "GTM-TQZMFCL",
                    // community.stg.atlassian.com
                    "SBLZG3ZYcSBcUMeLKLalrtyW8w1Caold": "GTM-TQZMFCL",
                    // community.dev1.dev.atlassian.com
                    "QVFu18jjHlCNaBXizZ3mtiqlBXVRkg1M": "GTM-TQZMFCL",
                    // community.dev2.dev.atlassian.com
                    "QmWM6iw7auEJw5gDQi6910Xk1wqyZ6bE": "GTM-TQZMFCL",
                    // community.dev3.dev.atlassian.com
                    "hWTszOAQMuItRdv8J30A3mNpCWd891bx": "GTM-TQZMFCL",
                    // community.dev4.dev.atlassian.com
                    "EWfeqJKJ0rPNOe3fcXrh2dg7bVXZNi2I": "GTM-5RJSBR",
                    // qa-wac.internal.atlassian.com
                    "Z2S07IGcRYkPJ7XHy3OIXcjpYoy9E6bs": "GTM-5RJSBR" // CXP Local Dev
                };
            }
        }
    ]);
    return Gtm;
}();

});


parcelRegister("e63qO", function(module, exports) {


module.exports = (parcelRequire("eg86f"))((parcelRequire("bRvn3")).resolve("4F7y4")).then(function() {
    return parcelRequire("7C6Ys");
});

});


parcelRegister("2Pnqs", function(module, exports) {

$parcel$export(module.exports, "Initializer", function () { return $e7d0026c36c0fc5a$export$9e14a7677ef1423c; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $e0MtP = parcelRequire("e0MtP");

var $kVM1Y = parcelRequire("kVM1Y");

var $gIHCW = parcelRequire("gIHCW");

var $2LAwh = parcelRequire("2LAwh");

var $6FvqL = parcelRequire("6FvqL");

var $6E1VX = parcelRequire("6E1VX");
var $e7d0026c36c0fc5a$export$9e14a7677ef1423c = /*#__PURE__*/ function() {
    "use strict";
    function Initializer() {
        (0, $4GJKx._)(this, Initializer);
    }
    (0, $1wc17._)(Initializer, null, [
        {
            key: "initWithPageAnalytics",
            value: /**
   * Loads and initializes segment.io.
   * @function initWithPageAnalytics
   * @param {string} writeKey - required, Segment.io key
   * @param {object} pageViewProperties - optional, dictionary of properties of the page (see: https://segment.com/docs/libraries/analytics.js/#page)
   * @param {object} loadOptions - optional, object with a dictionary of which integrations to load (see: https://segment.com/docs/sources/website/analytics.js/#load-options)
   * @param {number} loadTimestamp - optional, the timestamp at which the initializing site loaded this script
   * @param {string} anonymousId - GASv3 analytics client anonymous id
   * @param {function} createAnalyticsEvent - analytics next CreateUIAnalyticsEvent
   */ function initWithPageAnalytics(writeKey, pageViewProperties, loadOptions, loadTimestamp, anonymousId, createAnalyticsEvent) {
                (0, $e0MtP.AnalyticsState).anonymousId = anonymousId;
                (0, $e0MtP.AnalyticsState).createAnalyticsEvent = createAnalyticsEvent;
                // set load timestamp for calculating metrics
                (0, $6FvqL.Metrics).setLoadTimestamp(loadTimestamp);
                // TODO: Switch these params to dynamically config based on writeKey
                (0, $gIHCW.Gtm).initialize(writeKey);
                Initializer.captureUTMs();
                // set unpopulated params to empty objects
                if (typeof loadOptions !== "object" || loadOptions === null) loadOptions = {};
                if (typeof pageViewProperties !== "object" || pageViewProperties === null) pageViewProperties = {};
                // adding marketing boolean if current product comes under marketing domain
                Initializer.setIsMarketingEvent(pageViewProperties);
                // store params for later reporting if necessary.
                (0, $e0MtP.AnalyticsState).writeKey = writeKey;
                // TODO: pageViewOptions used to be passed in, but doesn't appear to be used outside of Segment.
                // Can we just delete this completely?
                (0, $e0MtP.AnalyticsState).pageViewOptions = {};
                // auto-fire page view
                (0, $2LAwh.Helpers).addActualUrl(pageViewProperties);
                (0, $6E1VX.Tracking).pageView(pageViewProperties);
                // add auto tracking and configure google analytics integration
                Initializer.autoTrack();
                Initializer.gaIntegration();
                Initializer.globalCallReady();
            }
        },
        {
            key: "globalCallReady",
            value: /**
   * Calls window functions that are awaiting a wrapper ready state
   * @function globalCallReady
   */ function globalCallReady() {
                if (typeof window.analyticsPageReady === "function") window.analyticsPageReady();
                (0, $6FvqL.Metrics).logMetric((0, $6FvqL.MetricKey).TIME_TO_READY);
                (0, $6FvqL.Metrics).sendMetrics();
            }
        },
        {
            key: "captureUTMs",
            value: function captureUTMs() {
                var utmKeys = {
                    utm_campaign: "",
                    utm_medium: "",
                    utm_source: "",
                    utm_content: "",
                    utm_term: ""
                };
                (0, $e0MtP.AnalyticsState).utms = (0, $2LAwh.Helpers).getUtms(utmKeys);
            }
        },
        {
            key: "autoTrack",
            value: /**
   * Applies auto-tracking for select domains
   * @function autoTrack
   */ function autoTrack() {
                (0, $6E1VX.Tracking).autoTrackButtons(true);
                (0, $6E1VX.Tracking).autoTrackLinks(true);
                (0, $6E1VX.Tracking).autoTrackVideos();
                (0, $6E1VX.Tracking).autoTrackSelects();
            }
        },
        {
            key: "gaIntegration",
            value: /**
   * Completes path overrides for Google Analytics
   * @function gaIntegration
   */ function gaIntegration() {
                var emailDetected = (0, $2LAwh.Helpers).emailAddressIsDetected();
                var pathOverride = "/path-contained-email-address";
                if (typeof window.ga !== "undefined") {
                    window.ga("require", "linker");
                    window.ga("linker:autoLink", [
                        "atlassian.com",
                        "bitbucket.org",
                        "hipchat.com",
                        "attendease.com",
                        "get.atlassian.com",
                        "eegeventsite.secure.force.com",
                        "atlassian.swoogo.com"
                    ]);
                    if (emailDetected) {
                        // only override what is needed
                        if ((0, $2LAwh.Helpers).urlContainsEmail(window.location.href)) {
                            window.ga("set", "location", window.location.origin + pathOverride);
                            window.ga("set", "path", pathOverride);
                        }
                        if ((0, $2LAwh.Helpers).urlContainsEmail(document.referrer)) window.ga("set", "referrer", (0, $2LAwh.Helpers).hostnameFromUrl(document.referrer) + pathOverride);
                    }
                }
            }
        },
        {
            key: "setIsMarketingEvent",
            value: function setIsMarketingEvent(pageViewProperties) {
                if (typeof pageViewProperties["isMarketingEvent"] !== "boolean") (0, $kVM1Y.GASv3).isMarketingEvent = true;
                else (0, $kVM1Y.GASv3).isMarketingEvent = pageViewProperties["isMarketingEvent"];
            }
        },
        {
            key: "setXID",
            value: function setXID(xid) {
                (0, $6E1VX.Tracking).xid = xid;
            }
        }
    ]);
    return Initializer;
}();

});
parcelRegister("6FvqL", function(module, exports) {

$parcel$export(module.exports, "MetricKey", function () { return $730548a3f4ef95ea$export$4657ae8822aeedd; });
$parcel$export(module.exports, "Metrics", function () { return $730548a3f4ef95ea$export$ed9166ec0f465b5e; });
/**
 * Module for segment metrics tracking events.
 * @module Metrics
 */ 
var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $cv9Rk = parcelRequire("cv9Rk");

var $e0MtP = parcelRequire("e0MtP");

var $6lrSF = parcelRequire("6lrSF");

var $kVM1Y = parcelRequire("kVM1Y");

var $6E1VX = parcelRequire("6E1VX");
var $730548a3f4ef95ea$export$4657ae8822aeedd;
(function(MetricKey) {
    MetricKey["TIME_TO_LOAD"] = "timeToLoad";
    MetricKey["TIME_TO_SEGMENT_LOAD"] = "timeToSegmentLoad";
    MetricKey["TIME_TO_AVAILABLE"] = "timeToAvailable";
    MetricKey["TIME_TO_READY"] = "timeToReady";
    MetricKey["TIME_TO_START_LOAD_XID"] = "timeToStartLoadXID";
    MetricKey["TIME_TO_START_GET_XID"] = "timeToStartGetXID";
    MetricKey["TIME_TO_LOAD_XID"] = "timeToLoadXID";
})($730548a3f4ef95ea$export$4657ae8822aeedd || ($730548a3f4ef95ea$export$4657ae8822aeedd = {}));
var $730548a3f4ef95ea$export$ed9166ec0f465b5e = /*#__PURE__*/ function() {
    "use strict";
    function Metrics() {
        (0, $4GJKx._)(this, Metrics);
    }
    (0, $1wc17._)(Metrics, null, [
        {
            key: "logMetric",
            value: /**
   * Store the value of a single performance metric
   * @function logMetrics
   * @param {MetricKey} metricKey - the metric to log
   * @param {number} mockDate - a mock timestamp
   */ function logMetric(metricKey, mockDate) {
                Metrics.metricsData[metricKey] = mockDate || Date.now();
            }
        },
        {
            key: "setLoadTimestamp",
            value: function setLoadTimestamp(loadTimestamp) {
                Metrics.loadTimestamp = loadTimestamp;
            }
        },
        {
            key: "sendMetrics",
            value: /**
   * Logs an performance metrics track call to segment via the HTTP API
   * @function sendMetrics
   * @param {object} mockReq used in testing so we don't actually send anything to Segment
   */ function sendMetrics(mockReq) {
                var loadTimestamp = Metrics.loadTimestamp;
                if (!loadTimestamp) return;
                // calculate all of the times
                Object.entries(Metrics.metricsData).forEach(function(param) {
                    var _param = (0, $cv9Rk._)(param, 2), key = _param[0], value = _param[1];
                    if (value > 0) // Todo .. should this be > loadTimestamp ??
                    Metrics.metricsData[key] = value - loadTimestamp;
                });
                var cohort = (0, $6lrSF.Cohort).readAtlCohort();
                var properties = {
                    event: "metrics",
                    eventComponent: "atlGlobal",
                    metrics: Metrics.metricsData,
                    atlJSVersion: (0, $e0MtP.AnalyticsState).version,
                    cohort: cohort ? cohort.bucketAll.index : null,
                    host: mockReq ? mockReq.hostFake : window.location.host,
                    path: mockReq ? mockReq.pathFake : window.location.pathname,
                    pageViewId: (0, $6E1VX.Tracking).getPageViewId() // used to tie to other events
                };
                (0, $kVM1Y.GASv3).sendUIEvent("", properties, true);
                Metrics.resetMetrics();
            }
        },
        {
            key: "resetMetrics",
            value: // testing only
            function resetMetrics() {
                Metrics.metricsData = {};
            }
        }
    ]);
    return Metrics;
}();
$730548a3f4ef95ea$export$ed9166ec0f465b5e.metricsData = {};

});




parcelRegister("8l3nP", function(module, exports) {

$parcel$export(module.exports, "WacAnalyticsListener", function () { return (parcelRequire("2NtzU")).WacAnalyticsListener; });
$parcel$export(module.exports, "WacAnalyticsClientProvider", function () { return (parcelRequire("2NtzU")).WacAnalyticsClientProvider; });

var $2NtzU = parcelRequire("2NtzU");

});

parcelRegister("eb65f", function(module, exports) {
$parcel$export(module.exports, "BxpWebStargateClient", function () { return (parcelRequire("8JWVu")).BxpWebStargateClient; });
$parcel$export(module.exports, "BxpWebStargateClientProvider", function () { return (parcelRequire("8JWVu")).BxpWebStargateClientProvider; });
$parcel$export(module.exports, "GetUserPermissionsIsPermittedRequestPermissionId", function () { return (parcelRequire("5F3nZ")).GetUserPermissionsIsPermittedRequestPermissionId; });
$parcel$export(module.exports, "useBxpWebStargateClient", function () { return (parcelRequire("8JWVu")).useBxpWebStargateClient; });
parcelRequire("6I3hM");
parcelRequire("9IuIN");

});
parcelRegister("6I3hM", function(module, exports) {
$parcel$export(module.exports, "BxpWebStargateClient", function () { return (parcelRequire("8JWVu")).BxpWebStargateClient; });
$parcel$export(module.exports, "BxpWebStargateClientProvider", function () { return (parcelRequire("8JWVu")).BxpWebStargateClientProvider; });
$parcel$export(module.exports, "useBxpWebStargateClient", function () { return (parcelRequire("8JWVu")).useBxpWebStargateClient; });
$parcel$export(module.exports, "GetUserPermissionsIsPermittedRequestPermissionId", function () { return (parcelRequire("5F3nZ")).GetUserPermissionsIsPermittedRequestPermissionId; });
parcelRequire("8JWVu");
parcelRequire("5F3nZ");

});
parcelRegister("8JWVu", function(module, exports) {

$parcel$export(module.exports, "BxpWebStargateClient", function () { return $051b74e2ead10a5e$export$963f114b487aad6d; });
$parcel$export(module.exports, "useBxpWebStargateClient", function () { return $051b74e2ead10a5e$export$ac42303986bb641e; });
$parcel$export(module.exports, "BxpWebStargateClientProvider", function () { return $051b74e2ead10a5e$export$dc976c529d501f0c; });

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $do9pw = parcelRequire("do9pw");

var $l29cN = parcelRequire("l29cN");

var $1rY3h = parcelRequire("1rY3h");

var $1Mpn7 = parcelRequire("1Mpn7");

var $lFPa6 = parcelRequire("lFPa6");
parcelRequire("9IuIN");
var $lfRvA = parcelRequire("lfRvA");
var $eOuSG = parcelRequire("eOuSG");
var $lKUe1 = parcelRequire("lKUe1");
var $fRjmR = parcelRequire("fRjmR");
var $9bEvq = parcelRequire("9bEvq");
var $eBzId = parcelRequire("eBzId");
var $3PVc1 = parcelRequire("3PVc1");
var $051b74e2ead10a5e$var$BASE_URL = "https://www.atlassian.com/gateway/api";
var $051b74e2ead10a5e$export$963f114b487aad6d = /*#__PURE__*/ function() {
    "use strict";
    function BxpWebStargateClient(param) {
        var baseUrl = param.baseUrl;
        (0, $4GJKx._)(this, BxpWebStargateClient);
        this.baseUrl = baseUrl;
    }
    (0, $1wc17._)(BxpWebStargateClient, [
        {
            key: "fetch",
            value: function fetch1(urlPath, init) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $l29cN.__generator)(this, function(_state) {
                        return [
                            2,
                            fetch(_this.baseUrl + urlPath, init)
                        ];
                    });
                })();
            }
        },
        {
            key: "me",
            value: function me(param) {
                var cloudSessionTokenCookie = param.cloudSessionTokenCookie;
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var response;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.fetch("/me", {
                                        headers: (0, $lfRvA.mapCookieToHeaders)(cloudSessionTokenCookie),
                                        credentials: "include"
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                if (!response.ok) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    response.json()
                                ];
                            case 2:
                                return [
                                    2,
                                    (0, $eOuSG.mapMeResponseToUserProfile).apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                            case 3:
                                throw new (0, $lKUe1.UnsuccessfulFetchError)({
                                    response: response
                                });
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getSignupServerXsrfToken",
            value: function getSignupServerXsrfToken() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.fetch("/bxp/signup/auth/xsrf", {
                                        method: "GET",
                                        credentials: "include",
                                        headers: {
                                            accept: "text/plain"
                                        }
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    (0, $fRjmR.mapResponseToText).apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "checkAuthenticationMethodsAvailable",
            value: /**
   * Get the authentication methods available to a given user.
   *
   * @see https://bxp-signup-server.us-west-2.prod.atl-paas.net/swagger/#/Identity/post_authentication_methods_available
   */ function checkAuthenticationMethodsAvailable(param) {
                var email = param.email, _param_application = param.application, application = _param_application === void 0 ? "wac" : _param_application, successRedirect = param.successRedirect;
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var xsrfToken, atlCohortId;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getSignupServerXsrfToken()
                                ];
                            case 1:
                                xsrfToken = _state.sent();
                                atlCohortId = (0, $9bEvq.getAtlCohortIdFromCookie)();
                                return [
                                    4,
                                    _this.fetch("/bxp/signup/authentication/methods-available", {
                                        method: "POST",
                                        headers: {
                                            "Content-Type": "application/json",
                                            "xsrf-token": xsrfToken,
                                            "X-Atl-Cohort-Id": atlCohortId
                                        },
                                        credentials: "include",
                                        body: JSON.stringify({
                                            email: email,
                                            application: application,
                                            continue: successRedirect
                                        })
                                    })
                                ];
                            case 2:
                                return [
                                    2,
                                    (0, $fRjmR.mapResponseToJson).apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "availableProducts",
            value: function availableProducts(param) {
                var cloudSessionTokenCookie = param.cloudSessionTokenCookie, removeNonAdminSites = param.removeNonAdminSites, includeInvalidSites = param.includeInvalidSites, includeInvalidBitbucketSite = param.includeInvalidBitbucketSite;
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var response, result, sites;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.fetch("/ais/available-products", {
                                        headers: (0, $lfRvA.mapCookieToHeaders)(cloudSessionTokenCookie),
                                        credentials: "include"
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                if (!response.ok) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    response.json()
                                ];
                            case 2:
                                result = _state.sent();
                                sites = result && result.sites || [];
                                if (removeNonAdminSites) sites = sites.filter(function(site) {
                                    return site.adminAccess;
                                });
                                if (!includeInvalidSites) sites = sites.filter(function(site) {
                                    return (0, $eBzId.isValidSite)({
                                        site: site,
                                        includeInvalidBitbucketSite: includeInvalidBitbucketSite
                                    });
                                });
                                return [
                                    2,
                                    Promise.resolve({
                                        sites: sites,
                                        isNewUser: !!(result && result.isNewUser)
                                    })
                                ];
                            case 3:
                                // throw new UnsuccessfulFetchError({
                                //     response
                                // });
                                return [
                                    2,
                                    Promise.resolve({
                                        sites: [],
                                        isNewUser: false
                                    })
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "availableProductsLegacy",
            value: /**
   * The legacy get availableProducts call from IdentityClient
   */ function availableProductsLegacy(param) {
                var cloudSessionTokenCookie = param.cloudSessionTokenCookie, includeInvalidSites = param.includeInvalidSites, includeInvalidBitbucketSite = param.includeInvalidBitbucketSite;
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var reqUrl, response, result, sites;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                reqUrl = "".concat(_this.baseUrl, "/available-products/api/available-products");
                                return [
                                    4,
                                    fetch(reqUrl, {
                                        headers: (0, $lfRvA.mapCookieToHeaders)(cloudSessionTokenCookie),
                                        credentials: "include"
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                if (!response.ok) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    response.json()
                                ];
                            case 2:
                                result = _state.sent();
                                sites = result && result.sites || [];
                                sites = (0, (/*@__PURE__*/$parcel$interopDefault($lFPa6))).remove((0, (/*@__PURE__*/$parcel$interopDefault($lFPa6))).map(sites, function(site) {
                                    var products = (0, (/*@__PURE__*/$parcel$interopDefault($lFPa6))).map(site.availableProducts, function(product) {
                                        return (0, $3PVc1.PRODUCT_KEY_MAP)[product.productType];
                                    }).filter(function(product) {
                                        return product !== undefined;
                                    });
                                    if (!(0, (/*@__PURE__*/$parcel$interopDefault($lFPa6))).isEmpty(products)) return {
                                        adminAccess: site.adminAccess,
                                        cloudId: site.cloudId,
                                        displayName: site.displayName,
                                        url: site.url,
                                        products: products
                                    };
                                    else return null;
                                }), function(site) {
                                    return site !== undefined && site !== null;
                                });
                                if (!includeInvalidSites) sites = sites.filter(function(site) {
                                    return (0, $eBzId.isValidSite)({
                                        site: site,
                                        includeInvalidBitbucketSite: includeInvalidBitbucketSite
                                    });
                                });
                                return [
                                    2,
                                    Promise.resolve(sites)
                                ];
                            case 3:
                                throw new (0, $lKUe1.UnsuccessfulFetchError)({
                                    response: response
                                });
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "activateProduct",
            value: function activateProduct(request) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var xsrfToken, atlCohortId, headers, upstreamResponse;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getSignupServerXsrfToken()
                                ];
                            case 1:
                                xsrfToken = _state.sent();
                                atlCohortId = (0, $9bEvq.getAtlCohortIdFromCookie)();
                                headers = (0, $lfRvA.mapCookieToHeaders)(request.cloudSessionTokenCookie);
                                Object.assign(headers, {
                                    "Content-Type": "application/json",
                                    "xsrf-token": xsrfToken,
                                    "X-Atl-Cohort-Id": atlCohortId
                                });
                                return [
                                    4,
                                    _this.fetch("/bxp/signup/activate-product", {
                                        method: "POST",
                                        headers: headers,
                                        credentials: "include",
                                        body: JSON.stringify(request)
                                    })
                                ];
                            case 2:
                                return [
                                    4,
                                    (0, $fRjmR.mapResponseToJson).apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                            case 3:
                                upstreamResponse = _state.sent();
                                return [
                                    2,
                                    upstreamResponse
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "siteActivateDirect",
            value: /**
   * Isolated version of /activate-product for skip site name experiment BXPSU-2556
   */ function siteActivateDirect(request) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var xsrfToken, atlCohortId, headers, upstreamResponse;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getSignupServerXsrfToken()
                                ];
                            case 1:
                                xsrfToken = _state.sent();
                                atlCohortId = (0, $9bEvq.getAtlCohortIdFromCookie)();
                                headers = (0, $lfRvA.mapCookieToHeaders)(request.cloudSessionTokenCookie);
                                Object.assign(headers, {
                                    "Content-Type": "application/json",
                                    "xsrf-token": xsrfToken,
                                    "X-Atl-Cohort-Id": atlCohortId
                                });
                                return [
                                    4,
                                    _this.fetch("/bxp/signup/site/activate/direct", {
                                        method: "POST",
                                        headers: headers,
                                        credentials: "include",
                                        body: JSON.stringify(request)
                                    })
                                ];
                            case 2:
                                return [
                                    4,
                                    (0, $fRjmR.mapResponseToJson).apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                            case 3:
                                upstreamResponse = _state.sent();
                                return [
                                    2,
                                    upstreamResponse
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "bitbucketWorkspaces",
            value: /**
   * Get a list of Bitbucket workspaces
   * @param nextUrl - override the request URL for pagination
   * bitbucket/user/permissions/workspaces?sort=workspace.slug
   */ function bitbucketWorkspaces(param) {
                var nextUrl = param.nextUrl, cloudSessionTokenCookie = param.cloudSessionTokenCookie, urlQuery = param.urlQuery;
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var reqUrl, response, _;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                reqUrl = "".concat(_this.baseUrl, "/bitbucket/user/permissions/workspaces");
                                if (nextUrl) reqUrl = nextUrl;
                                if (urlQuery) reqUrl = "".concat(reqUrl, "?").concat(urlQuery);
                                return [
                                    4,
                                    fetch(reqUrl, {
                                        headers: (0, $lfRvA.mapCookieToHeaders)(cloudSessionTokenCookie),
                                        credentials: "include"
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                if (!response.ok) return [
                                    3,
                                    3
                                ];
                                _ = Promise.resolve;
                                return [
                                    4,
                                    response.json()
                                ];
                            case 2:
                                return [
                                    2,
                                    _.apply(Promise, [
                                        _state.sent()
                                    ])
                                ];
                            case 3:
                                throw new (0, $lKUe1.UnsuccessfulFetchError)({
                                    response: response
                                });
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "checkCloudNameAvailability",
            value: function checkCloudNameAvailability(param) {
                var cloudName = param.cloudName, cloudSessionTokenCookie = param.cloudSessionTokenCookie;
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var headers;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                headers = (0, $lfRvA.mapCookieToHeaders)(cloudSessionTokenCookie);
                                Object.assign(headers, {
                                    "Accept": "application/json",
                                    "Content-Type": "application/json"
                                });
                                return [
                                    4,
                                    _this.fetch("/hostname/cloud/availability/check", {
                                        method: "post",
                                        body: JSON.stringify({
                                            cloudName: cloudName
                                        }),
                                        headers: headers,
                                        credentials: "include"
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    (0, $fRjmR.mapResponseToJson).apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getAvailableSites",
            value: function getAvailableSites(request) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var orderId, transactionAccount;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                orderId = request.orderId, transactionAccount = request.transactionAccount;
                                return [
                                    4,
                                    fetch("".concat(_this.baseUrl, "/bxp/signup/v1/order/").concat(orderId, "/available-sites"), {
                                        method: "GET",
                                        headers: {
                                            "Content-Type": "application/json",
                                            "X-Transaction-Account": transactionAccount
                                        },
                                        credentials: "include"
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    (0, $fRjmR.mapResponseToJson).apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getRecommendedSiteName",
            value: function getRecommendedSiteName(request) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var xsrfToken, atlCohortId, headers, response;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getSignupServerXsrfToken()
                                ];
                            case 1:
                                xsrfToken = _state.sent();
                                atlCohortId = (0, $9bEvq.getAtlCohortIdFromCookie)();
                                headers = (0, $lfRvA.mapCookieToHeaders)(request.cloudSessionTokenCookie);
                                Object.assign(headers, {
                                    "Content-Type": "application/json",
                                    "xsrf-token": xsrfToken,
                                    "X-Atl-Cohort-Id": atlCohortId
                                });
                                return [
                                    4,
                                    _this.fetch("/bxp/signup/site/recommended-name", {
                                        method: "POST",
                                        headers: headers,
                                        credentials: "include",
                                        body: JSON.stringify(request)
                                    })
                                ];
                            case 2:
                                return [
                                    4,
                                    (0, $fRjmR.mapResponseToJson).apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                            case 3:
                                response = _state.sent();
                                return [
                                    2,
                                    response
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getCloudStatus",
            value: function getCloudStatus(param) {
                var cloudId = param.cloudId, requestId = param.requestId;
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.fetch("/cofs/".concat(cloudId, "/status/").concat(requestId), {
                                        headers: {
                                            "Content-Type": "application/json"
                                        },
                                        credentials: "include"
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    (0, $fRjmR.mapResponseToJson).apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getProductActivationStatus",
            value: function getProductActivationStatus(request) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var xsrfToken;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getSignupServerXsrfToken()
                                ];
                            case 1:
                                xsrfToken = _state.sent();
                                return [
                                    4,
                                    _this.fetch("/bxp/signup/activate/status/".concat(request.provisioningRequestId), {
                                        method: "GET",
                                        headers: {
                                            "Content-Type": "application/json",
                                            "xsrf-token": xsrfToken
                                        },
                                        credentials: "include"
                                    })
                                ];
                            case 2:
                                return [
                                    2,
                                    (0, $fRjmR.mapResponseToJson).apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getUserPermissionsIsPermitted",
            value: function getUserPermissionsIsPermitted(param) {
                var permissionId = param.permissionId, resourceId = param.resourceId, dontRequirePrincipalInSite = param.dontRequirePrincipalInSite;
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.fetch("/permissions/permitted", {
                                        credentials: "include",
                                        method: "POST",
                                        headers: {
                                            "Content-Type": "application/json"
                                        },
                                        body: JSON.stringify({
                                            permissionId: permissionId,
                                            resourceId: resourceId,
                                            dontRequirePrincipalInSite: dontRequirePrincipalInSite
                                        })
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    (0, $fRjmR.mapResponseToJson).apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "postExpandFreeValidation",
            value: function postExpandFreeValidation(request) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var cloudId, productKeys;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                cloudId = request.cloudId, productKeys = request.productKeys;
                                return [
                                    4,
                                    _this.fetch("/cloud/expand-free-validation", {
                                        method: "POST",
                                        headers: {
                                            "Content-Type": "application/json"
                                        },
                                        credentials: "include",
                                        body: JSON.stringify({
                                            cloudId: cloudId,
                                            productKeys: productKeys
                                        })
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    (0, $fRjmR.mapResponseToJson).apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getProductEdition",
            value: function getProductEdition(request) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var cloudId, productKey;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                cloudId = request.cloudId, productKey = request.productKey;
                                return [
                                    4,
                                    _this.fetch("/cloud/edition/".concat(cloudId, "/").concat(productKey), {
                                        method: "GET",
                                        headers: {
                                            "Content-Type": "application/json"
                                        },
                                        credentials: "include"
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    (0, $fRjmR.mapResponseToJson).apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getActivationAuthorization",
            value: function getActivationAuthorization(request) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var productKeys, productEdition, cloudId, siteName, atlCohortId;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                productKeys = request.productKeys, productEdition = request.productEdition, cloudId = request.cloudId, siteName = request.siteName;
                                atlCohortId = (0, $9bEvq.getAtlCohortIdFromCookie)();
                                return [
                                    4,
                                    _this.fetch("/bxp/signup/activation-authorization?".concat(new URLSearchParams({
                                        productKeys: productKeys.join(","),
                                        productEdition: productEdition,
                                        cloudId: cloudId !== null && cloudId !== void 0 ? cloudId : "",
                                        siteName: siteName
                                    })), {
                                        method: "GET",
                                        headers: {
                                            "Content-Type": "application/json",
                                            "X-Atl-Cohort-Id": atlCohortId
                                        },
                                        credentials: "include"
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    (0, $fRjmR.mapResponseToJson).apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getCcpHamsStatus",
            value: function getCcpHamsStatus(request) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var cloudId, offeringKeys;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                cloudId = request.cloudId, offeringKeys = request.offeringKeys;
                                return [
                                    4,
                                    _this.fetch("/bag/rollout/service?cloudId=".concat(cloudId, "&offeringKeys=").concat(offeringKeys), {
                                        method: "GET",
                                        headers: {
                                            "Content-Type": "application/json"
                                        },
                                        credentials: "include"
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    (0, $fRjmR.mapResponseToJson).apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getLicenceInformationStatus",
            value: function getLicenceInformationStatus(request) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var xsrfToken;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getSignupServerXsrfToken()
                                ];
                            case 1:
                                xsrfToken = _state.sent();
                                return [
                                    4,
                                    _this.fetch("/bxp/signup/cloud/".concat(request.cloudId, "/license-information"), {
                                        method: "GET",
                                        headers: {
                                            "Content-Type": "application/json",
                                            "xsrf-token": xsrfToken
                                        },
                                        credentials: "include"
                                    })
                                ];
                            case 2:
                                return [
                                    2,
                                    (0, $fRjmR.mapResponseToJson).apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "postProductActivate",
            value: function postProductActivate(request) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var xsrfToken;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getSignupServerXsrfToken()
                                ];
                            case 1:
                                xsrfToken = _state.sent();
                                return [
                                    4,
                                    _this.fetch("/bxp/signup/product/activate", {
                                        method: "POST",
                                        headers: {
                                            "Content-Type": "application/json",
                                            "xsrf-token": xsrfToken
                                        },
                                        credentials: "include",
                                        body: JSON.stringify(request)
                                    })
                                ];
                            case 2:
                                return [
                                    2,
                                    (0, $fRjmR.mapResponseToJson).apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "postCloudSignUp",
            value: function postCloudSignUp(param) {
                var payload = param.payload;
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.fetch("/cloud/signup", {
                                        method: "POST",
                                        headers: {
                                            "Content-Type": "application/json"
                                        },
                                        body: JSON.stringify(payload),
                                        credentials: "include"
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    (0, $fRjmR.mapResponseToJson).apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "postCOFSProductActivate",
            value: /**
   * For attaching a product to an existing site using COFS, xflow worked on the endpoint
   */ function postCOFSProductActivate(request) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var xsrfToken, cloudId;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getSignupServerXsrfToken()
                                ];
                            case 1:
                                xsrfToken = _state.sent();
                                cloudId = request.cloudId;
                                return [
                                    4,
                                    fetch("".concat(_this.baseUrl, "/xflow/").concat(cloudId, "/activate"), {
                                        method: "POST",
                                        headers: {
                                            "Content-Type": "application/json",
                                            "xsrf-token": xsrfToken
                                        },
                                        credentials: "include",
                                        body: JSON.stringify(request)
                                    })
                                ];
                            case 2:
                                return [
                                    2,
                                    (0, $fRjmR.mapResponseToJson).apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "userSignup",
            value: function userSignup(request) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var xsrfToken, atlCohortId;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getSignupServerXsrfToken()
                                ];
                            case 1:
                                xsrfToken = _state.sent();
                                atlCohortId = (0, $9bEvq.getAtlCohortIdFromCookie)();
                                return [
                                    4,
                                    _this.fetch("/bxp/signup/identity/user-signup", {
                                        method: "POST",
                                        headers: {
                                            "Content-Type": "application/json",
                                            "xsrf-token": xsrfToken,
                                            "X-Atl-Cohort-Id": atlCohortId
                                        },
                                        credentials: "include",
                                        body: JSON.stringify((0, $do9pw._)({}, request))
                                    })
                                ];
                            case 2:
                                return [
                                    2,
                                    (0, $fRjmR.mapResponseToJson).apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getConsentConfig",
            value: function getConsentConfig() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var xsrfToken;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getSignupServerXsrfToken()
                                ];
                            case 1:
                                xsrfToken = _state.sent();
                                return [
                                    4,
                                    _this.fetch("/preferencesV2/consent-config", {
                                        method: "POST",
                                        headers: {
                                            "Content-Type": "application/json",
                                            "xsrf-token": xsrfToken
                                        },
                                        credentials: "include"
                                    })
                                ];
                            case 2:
                                return [
                                    2,
                                    (0, $fRjmR.mapResponseToJson).apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updateConsentPreferences",
            value: function updateConsentPreferences(postData) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var xsrfToken, preferencesV2Update;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getSignupServerXsrfToken()
                                ];
                            case 1:
                                xsrfToken = _state.sent();
                                return [
                                    4,
                                    _this.fetch("/preferencesV2/update", {
                                        method: "POST",
                                        headers: {
                                            "Content-Type": "application/json",
                                            "xsrf-token": xsrfToken
                                        },
                                        credentials: "include",
                                        body: JSON.stringify(postData)
                                    })
                                ];
                            case 2:
                                preferencesV2Update = _state.sent();
                                return [
                                    2,
                                    preferencesV2Update.status
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getInviteLink",
            value: function getInviteLink(postData) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $l29cN.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.fetch("/bxp/signup/experimental/confluence/product/onboarding/invitation_url", {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json"
                                },
                                credentials: "include",
                                body: JSON.stringify(postData)
                            }).then(function(response) {
                                return response.json();
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "submitConfluenceOnboardingSelections",
            value: function submitConfluenceOnboardingSelections(postData) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $l29cN.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.fetch("/bxp/signup/experimental/confluence/product/onboarding", {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json"
                                },
                                credentials: "include",
                                body: JSON.stringify(postData)
                            }).then(function(response) {
                                return response.json();
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "getSignupUserTraits",
            value: function getSignupUserTraits(param) {
                var cloudSessionTokenCookie = param.cloudSessionTokenCookie;
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var response, result;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.fetch("/bxp/signup/experimental/signup/user/traits", {
                                        headers: (0, $lfRvA.mapCookieToHeaders)(cloudSessionTokenCookie),
                                        credentials: "include"
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                if (!response.ok) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    response.json()
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                return [
                                    2,
                                    {
                                        success: false
                                    }
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return BxpWebStargateClient;
}();
var $051b74e2ead10a5e$var$BxpWebStargateClientContext = /*#__PURE__*/ (0, $1Mpn7.createContext)(new $051b74e2ead10a5e$export$963f114b487aad6d({
    baseUrl: $051b74e2ead10a5e$var$BASE_URL
}));
function $051b74e2ead10a5e$export$ac42303986bb641e() {
    return (0, $1Mpn7.useContext)($051b74e2ead10a5e$var$BxpWebStargateClientContext);
}
var $051b74e2ead10a5e$export$dc976c529d501f0c = function(props) {
    var children = props.children;
    if ($051b74e2ead10a5e$var$isBaseUrlStargateClientProviderProps(props)) return /*#__PURE__*/ (0, $1rY3h.jsx)($051b74e2ead10a5e$var$BxpWebStargateClientContext.Provider, {
        value: new $051b74e2ead10a5e$export$963f114b487aad6d({
            baseUrl: props.baseUrl
        }),
        children: children
    });
    else return /*#__PURE__*/ (0, $1rY3h.jsx)($051b74e2ead10a5e$var$BxpWebStargateClientContext.Provider, {
        value: props.client,
        children: children
    });
};
function $051b74e2ead10a5e$var$isBaseUrlStargateClientProviderProps(props) {
    return !!(props === null || props === void 0 ? void 0 : props.baseUrl);
}

});
parcelRegister("lFPa6", function(module, exports) {

var $l0HdX = parcelRequire("l0HdX");
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined1;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined1 : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined1 : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined1) result = result === undefined1 ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined1 : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, _$Function = context.Function, Math = context.Math, _$Object = context.Object, _$RegExp = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = _$Function.prototype, objectProto = _$Object.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(_$Object);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = _$RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined1, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined1, getPrototype = overArg(_$Object.getPrototypeOf, _$Object), objectCreate = _$Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined1, symIterator = Symbol ? Symbol.iterator : undefined1, symToStringTag = Symbol ? Symbol.toStringTag : undefined1;
        var defineProperty = function() {
            try {
                var func = getNative(_$Object, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = _$Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined1, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(_$Object.keys, _$Object), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(_$Object, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined1, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined1, symbolToString = symbolProto ? symbolProto.toString : undefined1;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var _$result = new object;
                object.prototype = undefined1;
                return _$result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined1;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var _$result = new LazyWrapper(this.__wrapped__);
            _$result.__actions__ = copyArray(this.__actions__);
            _$result.__dir__ = this.__dir__;
            _$result.__filtered__ = this.__filtered__;
            _$result.__iteratees__ = copyArray(this.__iteratees__);
            _$result.__takeCount__ = this.__takeCount__;
            _$result.__views__ = copyArray(this.__views__);
            return _$result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var _$result = new LazyWrapper(this);
                _$result.__dir__ = -1;
                _$result.__filtered__ = true;
            } else {
                _$result = this.clone();
                _$result.__dir__ *= -1;
            }
            return _$result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var _$result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], _$iteratee = data.iteratee, type = data.type, computed = _$iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                _$result[resIndex++] = value;
            }
            return _$result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var _$result = this.has(key) && delete this.__data__[key];
            this.size -= _$result ? 1 : 0;
            return _$result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var _$result = data[key];
                return _$result === HASH_UNDEFINED ? undefined1 : _$result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined1;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined1 : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined1 ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined1 : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var _$result = getMapData(this, key)["delete"](key);
            this.size -= _$result ? 1 : 0;
            return _$result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), _$size = data.size;
            data.set(key, value);
            this.size += data.size == _$size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, _$result = data["delete"](key);
            this.size = data.size;
            return _$result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, _$result = skipIndexes ? baseTimes(value.length, String) : [], length = _$result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) _$result.push(key);
            return _$result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined1;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined1 && !eq(object[key], value) || value === undefined1 && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined1 && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, _$result = Array1(length), skip = object == null;
            while(++index < length)_$result[index] = skip ? undefined1 : get(object, paths[index]);
            return _$result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined1) number = number <= upper ? number : upper;
                if (lower !== undefined1) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var _$result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) _$result = object ? customizer(value, key, object, stack) : customizer(value);
            if (_$result !== undefined1) return _$result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                _$result = initCloneArray(value);
                if (!isDeep) return copyArray(value, _$result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    _$result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(_$result, value)) : copySymbols(value, baseAssign(_$result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    _$result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, _$result);
            if (isSet(value)) value.forEach(function(subValue) {
                _$result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                _$result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined1 : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(_$result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return _$result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = _$Object(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined1 && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined1, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, _$includes = arrayIncludes, isCommon = true, length = array.length, _$result = [], valuesLength = values.length;
            if (!length) return _$result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                _$includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                _$includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    _$result.push(value);
                } else if (!_$includes(values, computed, comparator)) _$result.push(value);
            }
            return _$result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var _$result = true;
            baseEach(collection, function(value, index, collection) {
                _$result = !!predicate(value, index, collection);
                return _$result;
            });
            return _$result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined1 ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, _$result = value;
            }
            return _$result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined1 || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var _$result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) _$result.push(value);
            });
            return _$result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined1;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var _$result = keysFunc(object);
            return isArray(object) ? _$result : arrayPush(_$result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined1 ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in _$Object(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in _$Object(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var _$includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, _$result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined1;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && _$result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : _$includes(_$result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : _$includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    _$result.push(value);
                }
            }
            return _$result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined1 : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = _$Object(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined1 && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var _$result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(_$result === undefined1 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : _$result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var _$result = [];
            for(var key in _$Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") _$result.push(key);
            return _$result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), _$result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) _$result.push(key);
            return _$result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, _$result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                _$result[++index] = iteratee(value, key, collection);
            });
            return _$result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined1 && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined1;
                    if (newValue === undefined1) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined1;
            var isCommon = newValue === undefined1;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined1;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var _$result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(_$result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, _$result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(_$result, castPath(path, object), value);
            }
            return _$result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var _$indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = _$indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), _$result = Array1(length);
            while(length--){
                _$result[fromRight ? length : ++index] = start;
                start += step;
            }
            return _$result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var _$result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return _$result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) _$result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return _$result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined1;
                    if (newValue === undefined1) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function baseSetData(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function baseSetToString(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var _$result = Array1(length);
            while(++index < length)_$result[index] = array[index + start];
            return _$result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var _$result;
            baseEach(collection, function(value, index, collection) {
                _$result = predicate(value, index, collection);
                return !_$result;
            });
            return !!_$result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined1;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined1, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, _$result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    _$result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return _$result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var _$result = value + "";
            return _$result == "0" && 1 / value == -INFINITY ? "-0" : _$result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, _$includes = arrayIncludes, length = array.length, isCommon = true, _$result = [], seen = _$result;
            if (comparator) {
                isCommon = false;
                _$includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var _$set = iteratee ? null : createSet(array);
                if (_$set) return setToArray(_$set);
                isCommon = false;
                _$includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : _$result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    _$result.push(value);
                } else if (!_$includes(seen, computed, comparator)) {
                    if (seen !== _$result) seen.push(computed);
                    _$result.push(value);
                }
            }
            return _$result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var _$result = value;
            if (_$result instanceof LazyWrapper) _$result = _$result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, _$result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, _$result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) _$result[index] = baseDifference(_$result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(_$result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, _$result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined1;
                assignFunc(_$result, props[index], value);
            }
            return _$result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined1 ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, _$result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(_$result);
            return _$result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var _$result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(_$result).set(new Uint8Array(arrayBuffer));
            return _$result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var _$result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            _$result.lastIndex = regexp.lastIndex;
            return _$result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? _$Object(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined1, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined1, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var _$result = compareAscending(objCriteria[index], othCriteria[index]);
                if (_$result) {
                    if (index >= ordersLength) return _$result;
                    var order = orders[index];
                    return _$result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), _$result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)_$result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) _$result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)_$result[leftIndex++] = args[argsIndex++];
            return _$result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), _$result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)_$result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)_$result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) _$result[offset + holders[holdersIndex]] = args[argsIndex++];
            return _$result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined1;
                if (newValue === undefined1) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined1, guard = length > 2 ? sources[2] : undefined1;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined1;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined1 : customizer;
                    length = 1;
                }
                object = _$Object(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = _$Object(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = _$Object(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined1;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), _$result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(_$result) ? _$result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined1, args, holders, undefined1, undefined1, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = _$Object(collection);
                if (!isArrayLike(collection)) {
                    var _$iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function predicate(key) {
                        return _$iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[_$iteratee ? collection[index] : index] : undefined1;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined1;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, _$result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)_$result = funcs[index].call(this, _$result);
                    return _$result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined1 : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var _$result;
                if (value === undefined1 && other === undefined1) return defaultValue;
                if (value !== undefined1) _$result = value;
                if (other !== undefined1) {
                    if (_$result === undefined1) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    _$result = operator(value, other);
                }
                return _$result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined1 ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var _$result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(_$result), 0, length).join("") : _$result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined1;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined1) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined1 ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined1, newHoldersRight = isCurry ? undefined1 : holders, newPartials = isCurry ? partials : undefined1, newPartialsRight = isCurry ? undefined1 : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var _$result = wrapFunc.apply(undefined1, newData);
            if (isLaziable(func)) setData(_$result, newData);
            _$result.placeholder = placeholder;
            return setWrapToString(_$result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function createSet(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined1;
            }
            ary = ary === undefined1 ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined1 ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined1;
            }
            var data = isBindKey ? undefined1 : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined1 ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var _$result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) _$result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) _$result = createPartial(func, bitmask, thisArg, partials);
            else _$result = createHybrid.apply(undefined1, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(_$result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined1 || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined1, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined1 : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, _$result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined1;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined1) {
                    if (compared) continue;
                    _$result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        _$result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    _$result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return _$result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var _$result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return _$result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var _$result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined1 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    _$result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (_$result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) _$result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return _$result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined1, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function getData(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var _$result = func.name + "", array = realNames[_$result], length = hasOwnProperty.call(realNames, _$result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return _$result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var _$result = lodash.iteratee || iteratee;
            _$result = _$result === iteratee ? baseIteratee : _$result;
            return arguments.length ? _$result(arguments[0], arguments[1]) : _$result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var _$result = keys(object), length = _$result.length;
            while(length--){
                var key = _$result[length], value = object[key];
                _$result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return _$result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined1;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined1;
                var unmasked = true;
            } catch (e) {}
            var _$result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return _$result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function getSymbols(object) {
            if (object == null) return [];
            object = _$Object(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function getSymbolsIn(object) {
            var _$result = [];
            while(object){
                arrayPush(_$result, getSymbols(object));
                object = getPrototype(object);
            }
            return _$result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function getTag(value) {
            var _$result = baseGetTag(value), Ctor = _$result == objectTag ? value.constructor : undefined1, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return _$result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], _$size = data.size;
                switch(data.type){
                    case "drop":
                        start += _$size;
                        break;
                    case "dropRight":
                        end -= _$size;
                        break;
                    case "take":
                        end = nativeMin(end, start + _$size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - _$size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, _$result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(_$result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (_$result || ++index != length) return _$result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, _$result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                _$result.index = array.index;
                _$result.input = array.input;
            }
            return _$result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value === "undefined" ? "undefined" : (0, $l0HdX._)(value);
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index === "undefined" ? "undefined" : (0, $l0HdX._)(index);
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value === "undefined" ? "undefined" : (0, $l0HdX._)(value);
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in _$Object(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value === "undefined" ? "undefined" : (0, $l0HdX._)(value);
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined1 || key in _$Object(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var _$result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = _$result.cache;
            return _$result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var _$result = [];
            if (object != null) for(var key in _$Object(object))_$result.push(key);
            return _$result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined1 ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined1;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined1, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined1 ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var _$result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) _$result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                _$result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return _$result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var _$result = value + "";
            return _$result == "0" && 1 / value == -INFINITY ? "-0" : _$result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var _$result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            _$result.__actions__ = copyArray(wrapper.__actions__);
            _$result.__index__ = wrapper.__index__;
            _$result.__values__ = wrapper.__values__;
            return _$result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined1) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, _$result = Array1(nativeCeil(length / size));
            while(index < length)_$result[resIndex++] = baseSlice(array, index, index += size);
            return _$result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, _$result = [];
            while(++index < length){
                var value = array[index];
                if (value) _$result[resIndex++] = value;
            }
            return _$result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var _$iteratee = last(values);
            if (isArrayLikeObject(_$iteratee)) _$iteratee = undefined1;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(_$iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined1;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined1, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined1 ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined1 ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined1) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined1 ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, _$result = {};
            while(++index < length){
                var pair = pairs[index];
                _$result[pair[0]] = pair[1];
            }
            return _$result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined1;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var _$iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (_$iteratee === last(mapped)) _$iteratee = undefined1;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(_$iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined1;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined1, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined1;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined1) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined1;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined1, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, _$result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return _$result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var _$result = [];
            if (!(array && array.length)) return _$result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    _$result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return _$result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined1 ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined1 ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined1 ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var _$iteratee = last(arrays);
            if (isArrayLikeObject(_$iteratee)) _$iteratee = undefined1;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(_$iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined1;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined1, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined1;
            return array && array.length ? baseUniq(array, undefined1, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var _$result = unzip(array);
            if (iteratee == null) return _$result;
            return arrayMap(_$result, function(group) {
                return apply(iteratee, undefined1, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var _$iteratee = last(arrays);
            if (isArrayLikeObject(_$iteratee)) _$iteratee = undefined1;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(_$iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined1;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined1, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, _$iteratee = length > 1 ? arrays[length - 1] : undefined1;
            _$iteratee = typeof _$iteratee == "function" ? (arrays.pop(), _$iteratee) : undefined1;
            return unzipWith(arrays, _$iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var _$result = lodash(value);
            _$result.__chain__ = true;
            return _$result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function interceptor(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined1
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined1);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined1) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined1 : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var _$result, parent = this;
            while(parent instanceof baseLodash){
                var _$clone = wrapperClone(parent);
                _$clone.__index__ = 0;
                _$clone.__values__ = undefined1;
                if (_$result) previous.__wrapped__ = _$clone;
                else _$result = _$clone;
                var previous = _$clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return _$result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined1
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined1;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined1 ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", _$result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                _$result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return _$result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined1 : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined1) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined1;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined1 : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined1, undefined1, undefined1, undefined1, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var _$result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) _$result = func.apply(this, arguments);
                if (n <= 1) func = undefined1;
                return _$result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined1 : arity;
            var _$result = createWrap(func, WRAP_CURRY_FLAG, undefined1, undefined1, undefined1, undefined1, undefined1, arity);
            _$result.placeholder = curry.placeholder;
            return _$result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined1 : arity;
            var _$result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined1, undefined1, undefined1, undefined1, undefined1, arity);
            _$result.placeholder = curryRight.placeholder;
            return _$result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, _$result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined1;
                lastInvokeTime = time;
                _$result = func.apply(thisArg, args);
                return _$result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : _$result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined1 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined1;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined1;
                return _$result;
            }
            function cancel() {
                if (timerId !== undefined1) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined1;
            }
            function flush() {
                return timerId === undefined1 ? _$result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined1) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined1) timerId = setTimeout(timerExpired, wait);
                return _$result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function memoized1() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var _$result = func.apply(this, args);
                memoized.cache = cache.set(key, _$result) || cache;
                return _$result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined1, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined1, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined1, undefined1, undefined1, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined1 ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined1;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined1;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function isArguments(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined1;
            var _$result = customizer ? customizer(value, other) : undefined1;
            return _$result === undefined1 ? baseIsEqual(value, other, undefined1, customizer) : !!_$result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value === "undefined" ? "undefined" : (0, $l0HdX._)(value);
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined1;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return (typeof value === "undefined" ? "undefined" : (0, $l0HdX._)(value)) == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined1;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var _$result = toFinite(value), remainder = _$result % 1;
            return _$result === _$result ? remainder ? _$result - remainder : _$result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var _$result = baseCreate(prototype);
            return properties == null ? _$result : baseAssign(_$result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = _$Object(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined1;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined1 || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined1, customDefaultsMerge);
            return apply(mergeWith, undefined1, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var _$result = object == null ? undefined1 : baseGet(object, path);
            return _$result === undefined1 ? defaultValue : _$result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var _$result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(_$result, iteratee(value, key, object), value);
            });
            return _$result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var _$result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(_$result, key, iteratee(value, key, object));
            });
            return _$result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var _$result = {};
            if (object == null) return _$result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), _$result);
            if (isDeep) _$result = baseClone(_$result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(_$result, paths[length]);
            return _$result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined1;
            }
            while(++index < length){
                var value = object == null ? undefined1 : object[toKey(path[index])];
                if (value === undefined1) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined1;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined1;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined1) {
                upper = lower;
                lower = undefined1;
            }
            if (upper !== undefined1) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined1) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined1) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined1;
            if (floating === undefined1) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined1;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined1;
                }
            }
            if (lower === undefined1 && upper === undefined1) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined1) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined1 ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined1) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined1;
            limit = limit === undefined1 ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined1;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = _$RegExp((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var _$result = attempt(function() {
                return _$Function(importsKeys, sourceURL + "return " + source).apply(undefined1, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            _$result.source = source;
            if (isError(_$result)) throw _$result;
            return _$result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined1)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined1)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined1)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var _$result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined1) return _$result + omission;
            if (strSymbols) end += _$result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = _$result;
                    if (!separator.global) separator = _$RegExp(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    _$result = _$result.slice(0, newEnd === undefined1 ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = _$result.lastIndexOf(separator);
                if (index > -1) _$result = _$result.slice(0, index);
            }
            return _$result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined1 : pattern;
            if (pattern === undefined1) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined1, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var _$chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (_$chain || chainAll) {
                        var _$result = object(this.__wrapped__), actions = _$result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        _$result.__chain__ = chainAll;
                        return _$result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined1 : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var _$result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return _$result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined1;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined1;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined1;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined1;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined1 ? 1 : nativeMax(toInteger(n), 0);
                var _$result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (_$result.__filtered__) _$result.__takeCount__ = nativeMin(n, _$result.__takeCount__);
                else _$result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (_$result.__dir__ < 0 ? "Right" : "")
                });
                return _$result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var _$result = this.clone();
                _$result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                _$result.__filtered__ = _$result.__filtered__ || isFilter;
                return _$result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var _$result = this;
            if (_$result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(_$result);
            if (start < 0) _$result = _$result.takeRight(-start);
            else if (start) _$result = _$result.drop(start);
            if (end !== undefined1) {
                end = toInteger(end);
                _$result = end < 0 ? _$result.dropRight(-end) : _$result.take(end - start);
            }
            return _$result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, _$iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function interceptor(value) {
                    var _$result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? _$result[0] : _$result;
                };
                if (useLazy && checkIteratee && typeof _$iteratee == "function" && _$iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var _$result = func.apply(value, args);
                    _$result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined1
                    });
                    return new LodashWrapper(_$result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                _$result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? _$result.value()[0] : _$result.value() : _$result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined1, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined1
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(undefined);

});

parcelRegister("9IuIN", function(module, exports) {
$parcel$export(module.exports, "mapCookieToHeaders", function () { return (parcelRequire("lfRvA")).mapCookieToHeaders; });
$parcel$export(module.exports, "mapMeResponseToUserProfile", function () { return (parcelRequire("eOuSG")).mapMeResponseToUserProfile; });
$parcel$export(module.exports, "UnsuccessfulFetchError", function () { return (parcelRequire("lKUe1")).UnsuccessfulFetchError; });
$parcel$export(module.exports, "isValidSite", function () { return (parcelRequire("eBzId")).isValidSite; });
$parcel$export(module.exports, "mapResponseToJson", function () { return (parcelRequire("fRjmR")).mapResponseToJson; });
$parcel$export(module.exports, "mapResponseToText", function () { return (parcelRequire("fRjmR")).mapResponseToText; });
$parcel$export(module.exports, "getAtlCohortIdFromCookie", function () { return (parcelRequire("9bEvq")).getAtlCohortIdFromCookie; });
$parcel$export(module.exports, "PRODUCT_KEY_MAP", function () { return (parcelRequire("3PVc1")).PRODUCT_KEY_MAP; });
parcelRequire("lfRvA");
parcelRequire("eOuSG");
parcelRequire("lKUe1");
parcelRequire("eBzId");
parcelRequire("fRjmR");
parcelRequire("9bEvq");
parcelRequire("247ii");
parcelRequire("3PVc1");

});
parcelRegister("lfRvA", function(module, exports) {

$parcel$export(module.exports, "mapCookieToHeaders", function () { return $44902f515c896689$export$2caf3886cd1c5ca7; });

var $1q4lt = parcelRequire("1q4lt");
function $44902f515c896689$export$659f3e5265115438(param) {
    var name = param.name, value = param.value;
    return (0, $1q4lt.serialize)(name, value);
}
function $44902f515c896689$export$2caf3886cd1c5ca7(cookie) {
    if (cookie) return {
        cookie: $44902f515c896689$export$659f3e5265115438(cookie)
    };
    else return {};
}

});
parcelRegister("1q4lt", function(module, exports) {

$parcel$export(module.exports, "serialize", function () { return $108b9710a590aa4b$export$dfdc1655ccc5b9cb; }, function (v) { return $108b9710a590aa4b$export$dfdc1655ccc5b9cb = v; });
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */ /**
 * Module exports.
 * @public
 */ var $108b9710a590aa4b$export$98e6a39c04603d36;
var $108b9710a590aa4b$export$dfdc1655ccc5b9cb;
"use strict";
$108b9710a590aa4b$export$98e6a39c04603d36 = $108b9710a590aa4b$var$parse;
$108b9710a590aa4b$export$dfdc1655ccc5b9cb = $108b9710a590aa4b$var$serialize;
/**
 * Module variables.
 * @private
 */ var $108b9710a590aa4b$var$__toString = Object.prototype.toString;
/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */ var $108b9710a590aa4b$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */ function $108b9710a590aa4b$var$parse(str, options) {
    if (typeof str !== "string") throw new TypeError("argument str must be a string");
    var obj = {};
    var opt = options || {};
    var dec = opt.decode || $108b9710a590aa4b$var$decode;
    var index = 0;
    while(index < str.length){
        var eqIdx = str.indexOf("=", index);
        // no more cookie pairs
        if (eqIdx === -1) break;
        var endIdx = str.indexOf(";", index);
        if (endIdx === -1) endIdx = str.length;
        else if (endIdx < eqIdx) {
            // backtrack on prior semicolon
            index = str.lastIndexOf(";", eqIdx - 1) + 1;
            continue;
        }
        var key = str.slice(index, eqIdx).trim();
        // only assign once
        if (undefined === obj[key]) {
            var val = str.slice(eqIdx + 1, endIdx).trim();
            // quoted values
            if (val.charCodeAt(0) === 0x22) val = val.slice(1, -1);
            obj[key] = $108b9710a590aa4b$var$tryDecode(val, dec);
        }
        index = endIdx + 1;
    }
    return obj;
}
/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */ function $108b9710a590aa4b$var$serialize(name, val, options) {
    var opt = options || {};
    var enc = opt.encode || $108b9710a590aa4b$var$encode;
    if (typeof enc !== "function") throw new TypeError("option encode is invalid");
    if (!$108b9710a590aa4b$var$fieldContentRegExp.test(name)) throw new TypeError("argument name is invalid");
    var value = enc(val);
    if (value && !$108b9710a590aa4b$var$fieldContentRegExp.test(value)) throw new TypeError("argument val is invalid");
    var str = name + "=" + value;
    if (null != opt.maxAge) {
        var maxAge = opt.maxAge - 0;
        if (isNaN(maxAge) || !isFinite(maxAge)) throw new TypeError("option maxAge is invalid");
        str += "; Max-Age=" + Math.floor(maxAge);
    }
    if (opt.domain) {
        if (!$108b9710a590aa4b$var$fieldContentRegExp.test(opt.domain)) throw new TypeError("option domain is invalid");
        str += "; Domain=" + opt.domain;
    }
    if (opt.path) {
        if (!$108b9710a590aa4b$var$fieldContentRegExp.test(opt.path)) throw new TypeError("option path is invalid");
        str += "; Path=" + opt.path;
    }
    if (opt.expires) {
        var expires = opt.expires;
        if (!$108b9710a590aa4b$var$isDate(expires) || isNaN(expires.valueOf())) throw new TypeError("option expires is invalid");
        str += "; Expires=" + expires.toUTCString();
    }
    if (opt.httpOnly) str += "; HttpOnly";
    if (opt.secure) str += "; Secure";
    if (opt.priority) {
        var priority = typeof opt.priority === "string" ? opt.priority.toLowerCase() : opt.priority;
        switch(priority){
            case "low":
                str += "; Priority=Low";
                break;
            case "medium":
                str += "; Priority=Medium";
                break;
            case "high":
                str += "; Priority=High";
                break;
            default:
                throw new TypeError("option priority is invalid");
        }
    }
    if (opt.sameSite) {
        var sameSite = typeof opt.sameSite === "string" ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += "; SameSite=Strict";
                break;
            case "lax":
                str += "; SameSite=Lax";
                break;
            case "strict":
                str += "; SameSite=Strict";
                break;
            case "none":
                str += "; SameSite=None";
                break;
            default:
                throw new TypeError("option sameSite is invalid");
        }
    }
    return str;
}
/**
 * URL-decode string value. Optimized to skip native call when no %.
 *
 * @param {string} str
 * @returns {string}
 */ function $108b9710a590aa4b$var$decode(str) {
    return str.indexOf("%") !== -1 ? decodeURIComponent(str) : str;
}
/**
 * URL-encode value.
 *
 * @param {string} str
 * @returns {string}
 */ function $108b9710a590aa4b$var$encode(val) {
    return encodeURIComponent(val);
}
/**
 * Determine if value is a Date.
 *
 * @param {*} val
 * @private
 */ function $108b9710a590aa4b$var$isDate(val) {
    return $108b9710a590aa4b$var$__toString.call(val) === "[object Date]" || val instanceof Date;
}
/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */ function $108b9710a590aa4b$var$tryDecode(str, decode) {
    try {
        return decode(str);
    } catch (e) {
        return str;
    }
}

});


parcelRegister("eOuSG", function(module, exports) {

$parcel$export(module.exports, "mapMeResponseToUserProfile", function () { return $ca02b44aafe305c1$export$76c6404ebb3f2fbe; });

var $do9pw = parcelRequire("do9pw");

var $dRLPW = parcelRequire("dRLPW");
function $ca02b44aafe305c1$export$76c6404ebb3f2fbe(_param) {
    var account_id = _param.account_id, others = (0, $dRLPW._)(_param, [
        "account_id"
    ]);
    return (0, $do9pw._)({
        accountId: account_id
    }, others);
}

});

parcelRegister("lKUe1", function(module, exports) {

$parcel$export(module.exports, "UnsuccessfulFetchError", function () { return $be29fa839c7ee92f$export$da6dec65957b7041; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $FuVm8 = parcelRequire("FuVm8");

var $ohfOJ = parcelRequire("ohfOJ");
var $be29fa839c7ee92f$export$da6dec65957b7041 = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $dcsZi._)(UnsuccessfulFetchError, Error1);
    var _super = (0, $ohfOJ._)(UnsuccessfulFetchError);
    function UnsuccessfulFetchError(param) {
        var message = param.message, response = param.response;
        (0, $4GJKx._)(this, UnsuccessfulFetchError);
        var _this;
        _this = _super.call(this, message !== null && message !== void 0 ? message : response.statusText);
        _this.name = UnsuccessfulFetchError.name;
        _this.response = response;
        return _this;
    }
    (0, $1wc17._)(UnsuccessfulFetchError, [
        {
            key: "url",
            get: function get() {
                return this.response.url;
            }
        },
        {
            key: "status",
            get: function get() {
                return this.response.status;
            }
        }
    ]);
    return UnsuccessfulFetchError;
}((0, $FuVm8._)(Error));
function $be29fa839c7ee92f$export$24a0e392ef274e28(value) {
    return value.name === $be29fa839c7ee92f$export$da6dec65957b7041.name;
}

});

parcelRegister("eBzId", function(module, exports) {

$parcel$export(module.exports, "isValidSite", function () { return $9dc76ff9e7479c49$export$c7346ed3533fb878; });
var $9dc76ff9e7479c49$export$c7346ed3533fb878 = function(param) {
    var site = param.site, includeInvalidBitbucketSite = param.includeInvalidBitbucketSite;
    var ignoreSiteNames = [
        "servicedog",
        "ecosystem",
        "atlassiantraining",
        "Atlassian Stride",
        "volunteerhub",
        "atlassiantraining",
        "hello-staging",
        "ecosystem",
        "riskmanagement",
        "hello-staging3",
        "hello-staging6",
        "hello-staging9",
        "jdog",
        "sre-ehlo",
        "trello",
        "Trello"
    ];
    if (!includeInvalidBitbucketSite) ignoreSiteNames.push("bitbucket", "Bitbucket");
    if (ignoreSiteNames.includes(site.displayName)) return false;
    if (site.cloudId.startsWith("DUMMY")) return false;
    return true;
};

});

parcelRegister("fRjmR", function(module, exports) {

$parcel$export(module.exports, "mapResponseToText", function () { return $e7cf203b9a11c5ff$export$779c89bcd6b62ed; });
$parcel$export(module.exports, "mapResponseToJson", function () { return $e7cf203b9a11c5ff$export$a1968f52311c9c2e; });

var $kSuI9 = parcelRequire("kSuI9");

var $l29cN = parcelRequire("l29cN");

var $lKUe1 = parcelRequire("lKUe1");
function $e7cf203b9a11c5ff$export$779c89bcd6b62ed(response) {
    return $e7cf203b9a11c5ff$var$_mapResponseToText.apply(this, arguments);
}
function $e7cf203b9a11c5ff$var$_mapResponseToText() {
    $e7cf203b9a11c5ff$var$_mapResponseToText = (0, $kSuI9._)(function(response) {
        var _, _tmp;
        return (0, $l29cN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!response.ok) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        response.text()
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
                case 2:
                    _ = (0, $lKUe1.UnsuccessfulFetchError).bind;
                    _tmp = {};
                    return [
                        4,
                        $e7cf203b9a11c5ff$var$mapResponseToMessage(response)
                    ];
                case 3:
                    throw new (_.apply((0, $lKUe1.UnsuccessfulFetchError), [
                        void 0,
                        (_tmp.message = _state.sent(), _tmp.response = response, _tmp)
                    ]));
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $e7cf203b9a11c5ff$var$_mapResponseToText.apply(this, arguments);
}
function $e7cf203b9a11c5ff$export$a1968f52311c9c2e(response) {
    return $e7cf203b9a11c5ff$var$_mapResponseToJson.apply(this, arguments);
}
function $e7cf203b9a11c5ff$var$_mapResponseToJson() {
    $e7cf203b9a11c5ff$var$_mapResponseToJson = (0, $kSuI9._)(function(response) {
        var _, _tmp;
        return (0, $l29cN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!response.ok) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        response.json()
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
                case 2:
                    _ = (0, $lKUe1.UnsuccessfulFetchError).bind;
                    _tmp = {};
                    return [
                        4,
                        $e7cf203b9a11c5ff$var$mapResponseToMessage(response)
                    ];
                case 3:
                    throw new (_.apply((0, $lKUe1.UnsuccessfulFetchError), [
                        void 0,
                        (_tmp.message = _state.sent(), _tmp.response = response, _tmp)
                    ]));
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $e7cf203b9a11c5ff$var$_mapResponseToJson.apply(this, arguments);
}
function $e7cf203b9a11c5ff$var$mapResponseToMessage(response) {
    return $e7cf203b9a11c5ff$var$_mapResponseToMessage.apply(this, arguments);
}
function $e7cf203b9a11c5ff$var$_mapResponseToMessage() {
    $e7cf203b9a11c5ff$var$_mapResponseToMessage = (0, $kSuI9._)(function(response) {
        var statusText, message;
        return (0, $l29cN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    statusText = response.statusText;
                    return [
                        4,
                        response.text()
                    ];
                case 1:
                    message = _state.sent();
                    if (message.length > 0) return [
                        2,
                        "".concat(statusText, " ").concat(message)
                    ];
                    else return [
                        2,
                        statusText
                    ];
                    return [
                        2
                    ];
            }
        });
    });
    return $e7cf203b9a11c5ff$var$_mapResponseToMessage.apply(this, arguments);
}

});

parcelRegister("9bEvq", function(module, exports) {

$parcel$export(module.exports, "getAtlCohortIdFromCookie", function () { return $66b79841a5d0868f$export$a284fd3cd35fac52; });

var $5vvNu = parcelRequire("5vvNu");
function $66b79841a5d0868f$export$a284fd3cd35fac52() {
    var atlCohortId;
    try {
        var cookie = JSON.parse((0, (/*@__PURE__*/$parcel$interopDefault($5vvNu))).get("atlCohort") || "");
        atlCohortId = cookie["bucketAll"].index;
    } catch (e) {
        atlCohortId = "";
        console.warn("Cannot parse atlCohort cookie", e);
    }
    return atlCohortId;
}

});
parcelRegister("5vvNu", function(module, exports) {
(function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    /* eslint-disable no-var */ function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)target[key] = source[key];
        }
        return target;
    }
    /* eslint-enable no-var */ /* eslint-disable no-var */ var defaultConverter = {
        read: function read(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function write(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    /* eslint-enable no-var */ /* eslint-disable no-var */ function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = name + "=" + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === "undefined" || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var value = parts.slice(1).join("=");
                try {
                    var found = decodeURIComponent(parts[0]);
                    jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (e) {}
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function remove(name, attributes) {
                set(name, "", assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function withAttributes(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function withConverter(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: "/"
    });
    /* eslint-enable no-var */ return api;
});

});


parcelRegister("247ii", function(module, exports) {

});

parcelRegister("3PVc1", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_KEY_MAP", function () { return $556078c707394981$export$49ebef81048c4e68; });
var $556078c707394981$export$92fa52c125cc0e5 = "identity-platform";
var $556078c707394981$export$49ebef81048c4e68 = {
    CONFLUENCE: "confluence.ondemand",
    JIRA_CORE: "jira-core.ondemand",
    JIRA_BUSINESS: "jira-core.ondemand",
    JIRA_SOFTWARE: "jira-software.ondemand",
    JIRA_SERVICE_DESK: "jira-servicedesk.ondemand",
    BITBUCKET: "com.atlassian.bitbucket",
    OPSGENIE: "opsgenie",
    STATUSPAGE: "statuspage",
    TRELLO: "trello"
};

});



parcelRegister("5F3nZ", function(module, exports) {

$parcel$export(module.exports, "GetUserPermissionsIsPermittedRequestPermissionId", function () { return $107a2d90b735501a$export$13699c771a86789f; });
var $107a2d90b735501a$export$5699ee30bc277ff0;
(function(AuthenticationMethodsType) {
    AuthenticationMethodsType["PASSWORD"] = "password";
    AuthenticationMethodsType["GOOGLE"] = "google";
    AuthenticationMethodsType["SAML"] = "saml";
    AuthenticationMethodsType["MICROSOFT"] = "microsoft";
    AuthenticationMethodsType["APPLE"] = "apple";
    AuthenticationMethodsType["SLACK"] = "slack";
})($107a2d90b735501a$export$5699ee30bc277ff0 || ($107a2d90b735501a$export$5699ee30bc277ff0 = {}));
var $107a2d90b735501a$export$13699c771a86789f;
(function(GetUserPermissionsIsPermittedRequestPermissionId) {
    GetUserPermissionsIsPermittedRequestPermissionId["ADD_PRODUCTS"] = "add-products";
    GetUserPermissionsIsPermittedRequestPermissionId["INVITE_USERS"] = "invite-users";
    GetUserPermissionsIsPermittedRequestPermissionId["MANAGE"] = "manage";
    GetUserPermissionsIsPermittedRequestPermissionId["WRITE"] = "write";
    /**
   * @deprecated ADD_PRODUCT is a legacy permissionId, use ADD_PRODUCTS instead.
   */ GetUserPermissionsIsPermittedRequestPermissionId["ADD_PRODUCT"] = "addProduct";
})($107a2d90b735501a$export$13699c771a86789f || ($107a2d90b735501a$export$13699c771a86789f = {}));

});



parcelRegister("iw4d3", function(module, exports) {

$parcel$export(module.exports, "PageWrapper", function () { return $7de2c62ff3704cb4$export$3a31c848ced7e406; });
// @ts-ignore

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $1rY3h = parcelRequire("1rY3h");

var $1Mpn7 = parcelRequire("1Mpn7");

var $8pPrt = parcelRequire("8pPrt");

var $jqImJ = parcelRequire("jqImJ");
var $bHTvw = parcelRequire("bHTvw");
var $dXylA = parcelRequire("dXylA");

var $a0rbC = parcelRequire("a0rbC");
var $7de2c62ff3704cb4$var$SUPPORTED_LOCALES = [
    {
        hrefLang: "ja",
        langRoute: "ja"
    },
    {
        hrefLang: "fr",
        langRoute: "fr"
    },
    {
        hrefLang: "de",
        langRoute: "de"
    },
    {
        hrefLang: "es",
        langRoute: "es"
    },
    {
        hrefLang: "pt-BR",
        langRoute: "br"
    },
    {
        hrefLang: "zh-Hans",
        langRoute: "zh"
    },
    {
        hrefLang: "ko",
        langRoute: "ko"
    },
    {
        hrefLang: "ru",
        langRoute: "ru"
    },
    {
        hrefLang: "pl",
        langRoute: "pl"
    },
    {
        hrefLang: "it",
        langRoute: "it"
    },
    {
        hrefLang: "nl",
        langRoute: "nl"
    },
    {
        hrefLang: "hu",
        langRoute: "hu"
    }
];
var $7de2c62ff3704cb4$var$UNSUPPORTED_SEARCH_ENGINE_ROUTES = [
    "/ondemand/signup/checkemail",
    "/ondemand/signup/confirmation"
];
var $7de2c62ff3704cb4$export$3a31c848ced7e406 = function(props) {
    var baseUrl = props.baseUrl, route = props.route, variant = props.variant, inlineCss = props.inlineCss, themeStyles = props.themeStyles, children = props.children;
    var intl = (0, $8pPrt.default)();
    var localePrefix = intl.locale === "en" ? "" : "/".concat(intl.locale);
    var themePrefs = {
        colorMode: "light"
    };
    var themeAttrs = (0, $bHTvw.default)(themePrefs);
    var ssrAutoScript = (0, $jqImJ.default)(themePrefs.colorMode);
    (0, $1Mpn7.useEffect)(function() {
        // Theme config for client-only rendering
        (0, $dXylA.default)(themePrefs);
    }, [
        themePrefs
    ]);
    var title, description;
    switch(route){
        case "/software/jira":
            title = intl.formatMessage({
                id: "JiraSoftwarePage.title",
                defaultMessage: "Jira | Issue & Project Tracking Software | Atlassian"
            });
            if (variant === null || variant === void 0 ? void 0 : variant.length) description = intl.formatMessage({
                id: "JiraSoftwarePage.paid.description",
                defaultMessage: "Plan, track, and manage your agile and software development projects in Jira. Customize your workflow, collaborate, and release great software."
            });
            else description = intl.formatMessage({
                id: "JiraSoftwarePage.description",
                defaultMessage: "Make the impossible, possible in Jira. Plan, track, and release world-class software with the number one project management tool for agile teams."
            });
            break;
        case "/software/jira/product-discovery":
            title = intl.formatMessage({
                id: "JiraProductDiscoveryPage.title",
                defaultMessage: "Jira Product Discovery | prioritization and roadmapping tool"
            });
            description = intl.formatMessage({
                id: "JiraProductDiscoveryPage.description",
                defaultMessage: "Organize and prioritize customer insights and product ideas, create custom and shareable roadmaps, and build products that make an impact - all in Jira."
            });
            break;
        case "/software/jira/pricing":
            title = intl.formatMessage({
                id: "JiraSoftwarePricingPage.title",
                defaultMessage: " Jira Pricing - Monthly and Annual Subscription Cost per User"
            });
            description = intl.formatMessage({
                id: "JiraSoftwarePricingPage.description",
                defaultMessage: "The #1 software development tool used by agile teams. Try it free or buy now. Available for cloud or server. Built for teams of all sizes."
            });
            break;
        case "/software/jira/service-management":
            title = intl.formatMessage({
                id: "JiraServiceManagementPage.title",
                defaultMessage: "Jira Service Management | A new take on ITSM software"
            });
            if (!variant || (variant === null || variant === void 0 ? void 0 : variant.startsWith("anchor-lp-jsm")) || variant === "paid-lp-jsm-incidentchangemgmt" || variant === "paid-lp-jsm-itsm") description = intl.formatMessage({
                id: "JiraServiceManagementPage.description",
                defaultMessage: "Make the impossible, possible with Jira Service Management. ITSM collaboration software that unlocks teams."
            });
            else description = intl.formatMessage({
                id: "JiraServiceManagementPage.paid.description",
                defaultMessage: "Jira Service Desk is now Jira Service Management. Jira Service Management is ITSM software that unlocks teams."
            });
            break;
        case "/software/jira/service-management/pricing":
            title = intl.formatMessage({
                id: "JiraServiceManagementSoftwarePricingPage.title",
                defaultMessage: "Pricing - Jira Service Management | Atlassian"
            });
            description = intl.formatMessage({
                id: "JiraServiceManagementSoftwarePricingPage.description",
                defaultMessage: "Jira Service Management brings you a collaborative IT service desk with a powerful ticketing system, a self-service knowledge base and real-time reporting"
            });
            break;
        case "/software/confluence":
            title = intl.formatMessage({
                id: "ConfluencePage.title",
                defaultMessage: "Confluence | Your Remote-Friendly Team Workspace | Atlassian"
            });
            if (variant === null || variant === void 0 ? void 0 : variant.length) description = intl.formatMessage({
                id: "ConfluencePage.paid.description",
                defaultMessage: "Confluence is where you create, organize and discuss work with your team."
            });
            else description = intl.formatMessage({
                id: "ConfluencePage.description",
                defaultMessage: "Make the impossible, possible with Confluence Cloud. Your team workspace trusted for documentation, project collaboration, Jira integrations, and more!"
            });
            break;
        case "/software/confluence/templates/search":
            title = intl.formatMessage({
                id: "ConfluenceTemplatesSearchPage.title",
                defaultMessage: "Search Results | Atlassian"
            });
            break;
        case "/software/confluence/pricing":
            title = intl.formatMessage({
                id: "ConfluencePricingPage.title",
                defaultMessage: "Confluence Pricing: Free and Paid Plans | Atlassian"
            });
            description = intl.formatMessage({
                id: "ConfluencePricingPage.paid.description",
                defaultMessage: "Compare pricing for Confluence across our Standard, Premium, and Enterprise plans or get started for free today."
            });
            break;
        case "/jira":
            title = intl.formatMessage({
                id: "JiraLandingPage.title",
                defaultMessage: "Jira Products: Accomplish Great Work as a Team | Atlassian"
            });
            description = intl.formatMessage({
                id: "JiraLandingPage.description",
                defaultMessage: "Jira products are a family of project planning & work management solutions that empower all teams to work with agility and do their best - together."
            });
            break;
        case "/ondemand/signup/confirmation":
            title = intl.formatMessage({
                id: "ConfirmationPage.title",
                defaultMessage: "Confirmation | Atlassian"
            });
            description = undefined;
            break;
        case "/ondemand/signup/checkemail":
            title = intl.formatMessage({
                id: "CheckemailPage.title",
                defaultMessage: "Check Email | Atlassian"
            });
            description = intl.formatMessage({
                id: "CheckemailPage.description",
                defaultMessage: "Millions of users globally rely on Atlassian products every day for improving software development, project management, collaboration, and code quality."
            });
            break;
        case "/try/cloud/signup":
            title = intl.formatMessage({
                id: "SignupPage.title",
                defaultMessage: "Sign up - Try Atlassian Cloud | Atlassian"
            });
            description = intl.formatMessage({
                id: "SignupPage.description",
                defaultMessage: "Try our products in the Cloud, free for 7 days"
            });
            break;
        case "/software/jira/features":
            title = intl.formatMessage({
                id: "JiraSoftwareFeaturesPage.title",
                defaultMessage: "Jira Software - Features | Atlassian"
            });
            description = intl.formatMessage({
                id: "JiraSoftwareFeaturesPage.description",
                defaultMessage: "Jira Software is equipped with features that support every stage of your software development process to help you plan, track and report."
            });
            break;
        case "/try":
            title = intl.formatMessage({
                id: "TryPage.title",
                defaultMessage: "Try Atlassian Products for Free | Atlassian"
            });
            description = intl.formatMessage({
                id: "TryPage.description",
                defaultMessage: "Try Atlassian software development tools for free. See how Jira, Confluence, and our other tools can help your team track projects and collaborate"
            });
            break;
        case "/software/jira/free":
            title = intl.formatMessage({
                id: "JiraSoftwareFreePage.title",
                defaultMessage: "Jira Free: Get Jira Software for Free | Atlassian"
            });
            description = intl.formatMessage({
                id: "JiraSoftwareFreePage.description",
                defaultMessage: "Get Jira for free. The #1 software development tool used by agile teams is free for up to 10 users - get started today."
            });
            break;
        default:
            title = intl.formatMessage({
                id: "HomePage.title",
                defaultMessage: "Collaboration software for software, IT and business teams"
            });
            description = intl.formatMessage({
                id: "HomePage.description",
                defaultMessage: "Atlassian's team collaboration software like Jira, Confluence and Trello help teams organize, discuss, and complete shared work."
            });
            if (route.startsWith("/software/confluence/templates")) {
                title = intl.formatMessage({
                    id: "ConfluenceTemplatesPage.title",
                    defaultMessage: "Confluence Templates | Atlassian"
                });
                description = intl.formatMessage({
                    id: "ConfluenceTemplatesPage.description",
                    defaultMessage: "Confluence templates help teams create, organize, and discuss work. Get started with our template library."
                });
                // get the metadata from the template data
                var templatePageMeta = (0, $a0rbC.getTemplateMetadata)({
                    route: route,
                    templates: props.templates,
                    collections: props.collections
                });
                if (templatePageMeta === null || templatePageMeta === void 0 ? void 0 : templatePageMeta.title) {
                    title = templatePageMeta.title;
                    switch(templatePageMeta.titleSuffix){
                        case "template":
                            title += " " + intl.formatMessage({
                                id: "ConfluenceTemplatesDetailPage.title-suffix",
                                defaultMessage: "Template | Atlassian"
                            });
                            break;
                        case "collection":
                            title += " " + intl.formatMessage({
                                id: "ConfluenceTemplatesCollectionDetailPage.title-suffix",
                                defaultMessage: "Collection | Atlassian"
                            });
                            break;
                        default:
                            title += " | Atlassian";
                    }
                }
                if (templatePageMeta === null || templatePageMeta === void 0 ? void 0 : templatePageMeta.description) description = templatePageMeta.description;
            }
            break;
    }
    if (props.pureClientMode) return /*#__PURE__*/ (0, $1rY3h.jsxs)((0, $1rY3h.Fragment), {
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsx)("style", {
                suppressHydrationWarning: true,
                dangerouslySetInnerHTML: {
                    __html: inlineCss || ""
                }
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("link", {
                rel: "canonical",
                href: "".concat(baseUrl).concat(route)
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("link", {
                rel: "alternate",
                href: "".concat(baseUrl).concat(route),
                hrefLang: "x-default"
            }),
            $7de2c62ff3704cb4$var$SUPPORTED_LOCALES.map(function(param) {
                var hrefLang = param.hrefLang, langRoute = param.langRoute;
                return /*#__PURE__*/ (0, $1rY3h.jsx)("link", {
                    rel: "alternate",
                    href: "".concat(baseUrl, "/").concat(langRoute).concat(route),
                    hrefLang: hrefLang
                }, hrefLang);
            }),
            children
        ]
    });
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("html", (0, $cxjpp._)((0, $do9pw._)({
        lang: intl.locale
    }, themeAttrs), {
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsxs)("head", {
                children: [
                    /*#__PURE__*/ (0, $1rY3h.jsx)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("title", {
                        children: title
                    }),
                    description && /*#__PURE__*/ (0, $1rY3h.jsx)("meta", {
                        name: "description",
                        content: description
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1"
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("meta", {
                        httpEquiv: "X-UA-Compatible",
                        content: "IE=edge, chrome=1"
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("meta", {
                        name: "author",
                        content: "Atlassian"
                    }),
                    $7de2c62ff3704cb4$var$UNSUPPORTED_SEARCH_ENGINE_ROUTES.includes(route) && /*#__PURE__*/ (0, $1rY3h.jsx)("meta", {
                        name: "robots",
                        content: "noindex,nofollow"
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("style", {
                        suppressHydrationWarning: true,
                        dangerouslySetInnerHTML: {
                            __html: inlineCss || ""
                        },
                        id: "ssr_style"
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("link", {
                        rel: "canonical",
                        href: "".concat(baseUrl).concat(localePrefix).concat(route)
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("link", {
                        rel: "alternate",
                        href: "".concat(baseUrl).concat(route),
                        hrefLang: "x-default"
                    }),
                    $7de2c62ff3704cb4$var$SUPPORTED_LOCALES.map(function(param) {
                        var hrefLang = param.hrefLang, langRoute = param.langRoute;
                        return /*#__PURE__*/ (0, $1rY3h.jsx)("link", {
                            rel: "alternate",
                            href: "".concat(baseUrl, "/").concat(langRoute).concat(route),
                            hrefLang: hrefLang
                        }, hrefLang);
                    }),
                    (themeStyles || []).map(function(theme) {
                        return /*#__PURE__*/ (0, $1rY3h.jsx)("link", (0, $cxjpp._)((0, $do9pw._)({
                            rel: "stylesheet"
                        }, theme.attrs), {
                            href: "https://wac-web.prod-east.frontend.public.atl-paas.net/assets/atlaskit-tokens_".concat(theme.id, ".css")
                        }), theme.id);
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("script", {
                        id: "onetrust",
                        type: "text/javascript",
                        src: "https://atl-onetrust-wrapper.atlassian.com/assets/atl-onetrust-wrapper.min.js",
                        "data-domain": "ed42d30f-c9f0-408c-b65a-cd77205ecdf5",
                        "data-test": "false",
                        "data-geofence": "false",
                        "data-sync": "true"
                    }),
                    ssrAutoScript ? /*#__PURE__*/ (0, $1rY3h.jsx)("script", {
                        dangerouslySetInnerHTML: {
                            __html: ssrAutoScript
                        }
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("body", {
                children: children
            })
        ]
    }));
};

});
parcelRegister("8pPrt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $62088fdcdb48b1a0$export$2e2bcd8739ae039; });

var $1Mpn7 = parcelRequire("1Mpn7");

var $4P5Sm = parcelRequire("4P5Sm");

var $8xhJC = parcelRequire("8xhJC");
function $62088fdcdb48b1a0$export$2e2bcd8739ae039() {
    var intl = $1Mpn7.useContext((0, $4P5Sm.Context));
    (0, $8xhJC.invariantIntlContext)(intl);
    return intl;
}

});

parcelRegister("jqImJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e252dc19556b6745$export$2e2bcd8739ae039; });

var $cWK60 = parcelRequire("cWK60");

var $c8ZjH = parcelRequire("c8ZjH");

var $ivGXZ = parcelRequire("ivGXZ");
/**
 * Provides a script that, when executed before paint, sets the `data-color-mode` attribute based on the current system theme,
 * to enable SSR support for automatic theme switching, avoid a flash of un-themed content on first paint.
 *
 * @param {string} colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 *
 * @returns {string} A string to be added to the innerHTML of a script tag in the document head
 */ var $e252dc19556b6745$var$getSSRAutoScript = function getSSRAutoScript(colorMode, contrastMode) {
    if (colorMode !== "auto" && contrastMode !== "auto") return undefined;
    var setColorMode = colorMode === "auto" ? "\n  try {\n    const darkModeMql = window.matchMedia('".concat((0, $ivGXZ.darkModeMediaQuery), "');\n    const colorMode = darkModeMql.matches ? 'dark' : 'light';\n    document.documentElement.setAttribute('").concat((0, $c8ZjH.COLOR_MODE_ATTRIBUTE), "', colorMode);\n  } catch (e) {}") : "";
    var setContrastMode = (0, $cWK60.getBooleanFF)("platform.design-system-team.increased-contrast-themes") && contrastMode === "auto" ? "\n  try {\n    const contrastModeMql = window.matchMedia('".concat((0, $ivGXZ.moreContrastMediaQuery), "');\n    const contrastMode = contrastModeMql.matches ? 'more' : 'no-preference';\n    document.documentElement.setAttribute('").concat((0, $c8ZjH.CONTRAST_MODE_ATTRIBUTE), "', contrastMode);\n  } catch (e) {}") : "";
    return "(() => {".concat(setColorMode).concat(setContrastMode, "})()");
};
var $e252dc19556b6745$export$2e2bcd8739ae039 = $e252dc19556b6745$var$getSSRAutoScript;

});
parcelRegister("cWK60", function(module, exports) {

$parcel$export(module.exports, "getBooleanFF", function () { return $96cea8842f4b82ee$export$470e5c2be1411c89; });

var $amBLu = parcelRequire("amBLu");
function $96cea8842f4b82ee$export$ba05d765b8392e5e(flagResolver) {
    (0, $amBLu.setBooleanResolver)(flagResolver);
}
function $96cea8842f4b82ee$export$470e5c2be1411c89(name) {
    return (0, $amBLu.resolveBooleanFlag)(name);
}

});
parcelRegister("amBLu", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $78b940c90cbabb20$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $78b940c90cbabb20$export$6333b6aff9fc6275; });

var $2sqnn = parcelRequire("2sqnn");

var $3qWgZ = parcelRequire("3qWgZ");
var $78b940c90cbabb20$var$pkgName = "@atlaskit/platform-feature-flags";
var $78b940c90cbabb20$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $78b940c90cbabb20$var$hasProcessEnv = typeof $3qWgZ !== "undefined" && typeof $3qWgZ.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $78b940c90cbabb20$var$ENV_ENABLE_PLATFORM_FF = $78b940c90cbabb20$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $78b940c90cbabb20$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $78b940c90cbabb20$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $78b940c90cbabb20$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $78b940c90cbabb20$var$ENV_ENABLE_PLATFORM_FF || $78b940c90cbabb20$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $78b940c90cbabb20$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $78b940c90cbabb20$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$78b940c90cbabb20$var$globalVar[$78b940c90cbabb20$export$7e41b1b2bdee3f98] = $78b940c90cbabb20$var$globalVar[$78b940c90cbabb20$export$7e41b1b2bdee3f98] || $78b940c90cbabb20$var$DEFAULT_PFF_GLOBAL;
function $78b940c90cbabb20$export$f2b591175b3e424c(resolver) {
    $78b940c90cbabb20$var$globalVar[$78b940c90cbabb20$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2;
}
function $78b940c90cbabb20$export$6333b6aff9fc6275(flagKey) {
    if ($78b940c90cbabb20$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $2sqnn.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $78b940c90cbabb20$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL3;
        var result = (_globalVar$PFF_GLOBAL3 = $78b940c90cbabb20$var$globalVar[$78b940c90cbabb20$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("2sqnn", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $1ca2a806c6ace114$export$1c9f709888824e05; });
var $1ca2a806c6ace114$var$_ref, $1ca2a806c6ace114$var$_globalThis$process, $1ca2a806c6ace114$var$_globalThis$process$e, $1ca2a806c6ace114$var$_globalThis$process2, $1ca2a806c6ace114$var$_globalThis$process2$;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $1ca2a806c6ace114$var$TESTS_MODE = ($1ca2a806c6ace114$var$_ref = (globalThis === null || globalThis === void 0 ? void 0 : ($1ca2a806c6ace114$var$_globalThis$process = globalThis.process) === null || $1ca2a806c6ace114$var$_globalThis$process === void 0 ? void 0 : ($1ca2a806c6ace114$var$_globalThis$process$e = $1ca2a806c6ace114$var$_globalThis$process.env) === null || $1ca2a806c6ace114$var$_globalThis$process$e === void 0 ? void 0 : $1ca2a806c6ace114$var$_globalThis$process$e.JEST_WORKER_ID) !== undefined, $1ca2a806c6ace114$var$_ref !== void 0) ? $1ca2a806c6ace114$var$_ref : false;
var $1ca2a806c6ace114$var$DEBUG_MODE = !$1ca2a806c6ace114$var$TESTS_MODE && (globalThis === null || globalThis === void 0 ? void 0 : ($1ca2a806c6ace114$var$_globalThis$process2 = globalThis.process) === null || $1ca2a806c6ace114$var$_globalThis$process2 === void 0 ? void 0 : ($1ca2a806c6ace114$var$_globalThis$process2$ = $1ca2a806c6ace114$var$_globalThis$process2.env) === null || $1ca2a806c6ace114$var$_globalThis$process2$ === void 0 ? void 0 : $1ca2a806c6ace114$var$_globalThis$process2$.NODE_ENV) !== "production";
var $1ca2a806c6ace114$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$1ca2a806c6ace114$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("c8ZjH", function(module, exports) {

$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", function () { return $8d75cb9ba93bb527$export$4ef52930e33717cd; });
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", function () { return $8d75cb9ba93bb527$export$a00eac3f8684bcd0; });
$parcel$export(module.exports, "CONTRAST_MODE_ATTRIBUTE", function () { return $8d75cb9ba93bb527$export$2112803007239c61; });
$parcel$export(module.exports, "CUSTOM_THEME_ATTRIBUTE", function () { return $8d75cb9ba93bb527$export$352e418ed5b6193a; });
$parcel$export(module.exports, "TOKEN_NOT_FOUND_CSS_VAR", function () { return $8d75cb9ba93bb527$export$dddac1532e822863; });
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", function () { return $8d75cb9ba93bb527$export$9d7b58831ae93caa; });
var $8d75cb9ba93bb527$export$4ef52930e33717cd = "data-theme";
var $8d75cb9ba93bb527$export$a00eac3f8684bcd0 = "data-color-mode";
var $8d75cb9ba93bb527$export$2112803007239c61 = "data-contrast-mode";
var $8d75cb9ba93bb527$export$352e418ed5b6193a = "data-custom-theme";
var $8d75cb9ba93bb527$export$2faeed762aac6741 = "light";
var $8d75cb9ba93bb527$export$6f0c6fb8c80fcc92 = "ds";
var $8d75cb9ba93bb527$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $8d75cb9ba93bb527$export$dddac1532e822863 = "--".concat($8d75cb9ba93bb527$export$6f0c6fb8c80fcc92, "-token-not-found");
var $8d75cb9ba93bb527$export$9d7b58831ae93caa = "--".concat($8d75cb9ba93bb527$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRegister("ivGXZ", function(module, exports) {

$parcel$export(module.exports, "loadAndAppendThemeCss", function () { return $d79c7385fd211d03$export$26cd7ae85c7144e5; });
$parcel$export(module.exports, "darkModeMediaQuery", function () { return $d79c7385fd211d03$export$bb1e815119d30f8b; });
$parcel$export(module.exports, "moreContrastMediaQuery", function () { return $d79c7385fd211d03$export$8662df6937d86fcb; });

var $e8dor = parcelRequire("e8dor");

var $fGIeY = parcelRequire("fGIeY");

var $8ZYml = parcelRequire("8ZYml");

var $c8ZjH = parcelRequire("c8ZjH");
var $d79c7385fd211d03$export$26cd7ae85c7144e5 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($e8dor)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).mark(function _callee(themeId) {
        var themeCss, style;
        return (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!document.head.querySelector("style[".concat((0, $c8ZjH.THEME_DATA_ATTRIBUTE), '="').concat(themeId, '"]:not([').concat((0, $c8ZjH.CUSTOM_THEME_ATTRIBUTE), "])"))) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return");
                case 2:
                    _context.next = 4;
                    return $d79c7385fd211d03$export$8a48286ed7df6720(themeId);
                case 4:
                    themeCss = _context.sent;
                    style = document.createElement("style");
                    style.textContent = themeCss;
                    style.dataset.theme = themeId;
                    document.head.appendChild(style);
                case 9:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadAndAppendThemeCss(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $d79c7385fd211d03$export$8a48286ed7df6720 = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($e8dor)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).mark(function _callee2(themeId) {
        var _yield$themeImportMap, themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    _context2.next = 2;
                    return (0, $8ZYml.default)[themeId]();
                case 2:
                    _yield$themeImportMap = _context2.sent;
                    themeCss = _yield$themeImportMap.default;
                    return _context2.abrupt("return", themeCss);
                case 5:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function loadThemeCss(_x2) {
        return _ref2.apply(this, arguments);
    };
}();
var $d79c7385fd211d03$export$bb1e815119d30f8b = "(prefers-color-scheme: dark)";
var $d79c7385fd211d03$export$8662df6937d86fcb = "(prefers-contrast: more)";

});
parcelRegister("e8dor", function(module, exports) {
function $a49c33a30d1b08d0$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $a49c33a30d1b08d0$var$_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $a49c33a30d1b08d0$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $a49c33a30d1b08d0$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
module.exports = $a49c33a30d1b08d0$var$_asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("fGIeY", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $b6bd1881a7dca5aa$var$runtime = (parcelRequire("1fygo"))();
module.exports = $b6bd1881a7dca5aa$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $b6bd1881a7dca5aa$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $b6bd1881a7dca5aa$var$runtime;
    else Function("r", "regeneratorRuntime = r")($b6bd1881a7dca5aa$var$runtime);
}

});
parcelRegister("1fygo", function(module, exports) {

var $2nffd = parcelRequire("2nffd");
var $0e91c528b562c561$var$_typeof = $2nffd.default;
function $0e91c528b562c561$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    module.exports = $0e91c528b562c561$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $0e91c528b562c561$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw new Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($0e91c528b562c561$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var _$t = r.pop();
                if (_$t in e) return next.value = _$t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw new Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
module.exports = $0e91c528b562c561$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("8ZYml", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68d2d75d0777d2ab$export$2e2bcd8739ae039; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This file contains a dynamic import for each theme this package exports.
 * Themes are loaded asynchronously at runtime to minimise the amount of CSS we send to the client.
 * This allows users to compose their themes and only use the tokens that are requested.
 * When a new theme is created, the import should automatically be added to the map
 *
 * @codegen <<SignedSource::a21941d8f8cea58425b92ce9b8bfcd4e>>
 * @codegenCommand yarn build tokens
 */ 












var $68d2d75d0777d2ab$var$themeImportsMap = {
    "light": function light() {
        return (parcelRequire("bZ02M"));
    },
    "light-increased-contrast": function lightIncreasedContrast() {
        return (parcelRequire("8Br6E"));
    },
    "dark": function dark() {
        return (parcelRequire("hWoqs"));
    },
    "dark-increased-contrast": function darkIncreasedContrast() {
        return (parcelRequire("cOG18"));
    },
    "legacy-light": function legacyLight() {
        return (parcelRequire("gijeQ"));
    },
    "legacy-dark": function legacyDark() {
        return (parcelRequire("bl5IH"));
    },
    "spacing": function spacing() {
        return (parcelRequire("3L7os"));
    },
    "typography-adg3": function typographyAdg3() {
        return (parcelRequire("cHNu9"));
    },
    "shape": function shape() {
        return (parcelRequire("9BLt4"));
    },
    "light-new-input-border": function lightNewInputBorder() {
        return (parcelRequire("hCeCF"));
    },
    "dark-new-input-border": function darkNewInputBorder() {
        return (parcelRequire("ceXlA"));
    },
    "typography": function typography() {
        return (parcelRequire("jMlgb"));
    },
    "typography-minor3": function typographyMinor3() {
        return (parcelRequire("ZuzJb"));
    }
};
var $68d2d75d0777d2ab$export$2e2bcd8739ae039 = $68d2d75d0777d2ab$var$themeImportsMap;

});
parcelRegister("bZ02M", function(module, exports) {


module.exports = (parcelRequire("eg86f"))((parcelRequire("bRvn3")).resolve("6j3nX")).then(function() {
    return parcelRequire("di4AN");
});

});

parcelRegister("8Br6E", function(module, exports) {


module.exports = (parcelRequire("eg86f"))((parcelRequire("bRvn3")).resolve("cWPTZ")).then(function() {
    return parcelRequire("3QT9i");
});

});

parcelRegister("hWoqs", function(module, exports) {


module.exports = (parcelRequire("eg86f"))((parcelRequire("bRvn3")).resolve("b5bLO")).then(function() {
    return parcelRequire("1l2jM");
});

});

parcelRegister("cOG18", function(module, exports) {


module.exports = (parcelRequire("eg86f"))((parcelRequire("bRvn3")).resolve("3dF3X")).then(function() {
    return parcelRequire("la0p6");
});

});

parcelRegister("gijeQ", function(module, exports) {


module.exports = (parcelRequire("eg86f"))((parcelRequire("bRvn3")).resolve("1MP1e")).then(function() {
    return parcelRequire("8yec2");
});

});

parcelRegister("bl5IH", function(module, exports) {


module.exports = (parcelRequire("eg86f"))((parcelRequire("bRvn3")).resolve("iPSug")).then(function() {
    return parcelRequire("8kPU5");
});

});

parcelRegister("3L7os", function(module, exports) {


module.exports = (parcelRequire("eg86f"))((parcelRequire("bRvn3")).resolve("7xQL9")).then(function() {
    return parcelRequire("lr70G");
});

});

parcelRegister("cHNu9", function(module, exports) {


module.exports = (parcelRequire("eg86f"))((parcelRequire("bRvn3")).resolve("betUP")).then(function() {
    return parcelRequire("fofdF");
});

});

parcelRegister("9BLt4", function(module, exports) {


module.exports = (parcelRequire("eg86f"))((parcelRequire("bRvn3")).resolve("3dWtk")).then(function() {
    return parcelRequire("2Iur2");
});

});

parcelRegister("hCeCF", function(module, exports) {


module.exports = (parcelRequire("eg86f"))((parcelRequire("bRvn3")).resolve("bu8X5")).then(function() {
    return parcelRequire("cVk5p");
});

});

parcelRegister("ceXlA", function(module, exports) {


module.exports = (parcelRequire("eg86f"))((parcelRequire("bRvn3")).resolve("6JKFD")).then(function() {
    return parcelRequire("7mKuN");
});

});

parcelRegister("jMlgb", function(module, exports) {


module.exports = (parcelRequire("eg86f"))((parcelRequire("bRvn3")).resolve("jqcFX")).then(function() {
    return parcelRequire("buBiQ");
});

});

parcelRegister("ZuzJb", function(module, exports) {


module.exports = (parcelRequire("eg86f"))((parcelRequire("bRvn3")).resolve("OV2GL")).then(function() {
    return parcelRequire("lDvP0");
});

});




parcelRegister("bHTvw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $885ec47dbbf6f635$export$2e2bcd8739ae039; });

var $jjExS = parcelRequire("jjExS");

var $cWK60 = parcelRequire("cWK60");

var $c8ZjH = parcelRequire("c8ZjH");

var $g4m7u = parcelRequire("g4m7u");

var $90ANA = parcelRequire("90ANA");

var $6dkEh = parcelRequire("6dkEh");

var $j0aa8 = parcelRequire("j0aa8");
function $885ec47dbbf6f635$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $885ec47dbbf6f635$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $885ec47dbbf6f635$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $885ec47dbbf6f635$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $885ec47dbbf6f635$var$defaultColorMode = "light";
var $885ec47dbbf6f635$var$defaultContrastMode = "no-preference";
/**
 * Server-side rendering utility. Generates the valid HTML attributes for a given theme.
 * Note: this utility does not handle automatic theme switching.
 *
 * @param {Object<string, string>} themeOptions - Theme options object
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 *
 * @returns {Object} Object of HTML attributes to be applied to the document root
 */ var $885ec47dbbf6f635$var$getThemeHtmlAttrs = function getThemeHtmlAttrs() {
    var _result;
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$colorMode = _ref.colorMode, colorMode = _ref$colorMode === void 0 ? (0, $g4m7u.themeStateDefaults)["colorMode"] : _ref$colorMode, _ref$dark = _ref.dark, dark = _ref$dark === void 0 ? (0, $g4m7u.themeStateDefaults)["dark"] : _ref$dark, _ref$light = _ref.light, light = _ref$light === void 0 ? (0, $g4m7u.themeStateDefaults)["light"] : _ref$light, _ref$contrastMode = _ref.contrastMode, contrastMode = _ref$contrastMode === void 0 ? (0, $g4m7u.themeStateDefaults)["contrastMode"] : _ref$contrastMode, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? (0, $g4m7u.themeStateDefaults)["shape"] : _ref$shape, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? (0, $g4m7u.themeStateDefaults)["spacing"] : _ref$spacing, _ref$typography = _ref.typography, typography = _ref$typography === void 0 ? (0, $g4m7u.themeStateDefaults)["typography"] : _ref$typography, _ref$UNSAFE_themeOpti = _ref.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref$UNSAFE_themeOpti === void 0 ? (0, $g4m7u.themeStateDefaults)["UNSAFE_themeOptions"] : _ref$UNSAFE_themeOpti;
    var themeAttribute = (0, $90ANA.themeObjectToString)({
        dark: dark,
        light: light,
        shape: shape,
        spacing: spacing,
        typography: typography
    });
    var result = (_result = {}, (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(_result, (0, $c8ZjH.THEME_DATA_ATTRIBUTE), themeAttribute), (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(_result, (0, $c8ZjH.COLOR_MODE_ATTRIBUTE), colorMode === "auto" ? $885ec47dbbf6f635$var$defaultColorMode : colorMode), _result);
    if ((0, $cWK60.getBooleanFF)("platform.design-system-team.increased-contrast-themes")) result = $885ec47dbbf6f635$var$_objectSpread($885ec47dbbf6f635$var$_objectSpread({}, result), {}, (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))({}, (0, $c8ZjH.CONTRAST_MODE_ATTRIBUTE), contrastMode === "auto" ? $885ec47dbbf6f635$var$defaultContrastMode : contrastMode));
    if (UNSAFE_themeOptions && (0, $6dkEh.isValidBrandHex)(UNSAFE_themeOptions.brandColor)) {
        var optionString = JSON.stringify(UNSAFE_themeOptions);
        var uniqueId = (0, $j0aa8.hash)(optionString);
        result[0, $c8ZjH.CUSTOM_THEME_ATTRIBUTE] = uniqueId;
    }
    return result;
};
var $885ec47dbbf6f635$export$2e2bcd8739ae039 = $885ec47dbbf6f635$var$getThemeHtmlAttrs;

});
parcelRegister("g4m7u", function(module, exports) {

$parcel$export(module.exports, "themeIds", function () { return $bb2e2d92462f7729$export$7d43e72a58e3283f; });
$parcel$export(module.exports, "themeStateDefaults", function () { return $bb2e2d92462f7729$export$9aedcfa7336a207; });
$parcel$export(module.exports, "default", function () { return $bb2e2d92462f7729$export$2e2bcd8739ae039; });
/**
 * This file contains the source of truth for themes and all associated meta data.
 */ /**
 * Themes: The internal identifier of a theme.
 * These ids are what the actual theme files/folders are called.
 * style-dictionary will attempt to locate these in the file-system.
 */ /**
 * ThemeOverrides: The internal identifier of a theme override. Which are themes that contain
 * a subset of tokens intended to override an existing theme. These ids are what the actual
 * theme files/folders are called. style-dictionary will attempt to locate these in the file-system.
 * Theme overrides are temporary and there may not be any defined at times.
 */ /**
 * Theme kinds: The type of theme.
 * Some themes are entirely focused on Color, whilst others are purely focused on spacing.
 * In the future other types may be introduced such as typography.
 */ /**
 * Theme modes: The general purpose of a theme.
 * This attr is used to apply the appropriate system-preference option
 * It may also be used as a selector for mode-specific overrides such as light/dark images.
 * The idea is there may exist many color themes, but every theme must either fit into light or dark.
 */ var $bb2e2d92462f7729$export$83993de8eb66733 = [
    "light",
    "dark",
    "auto"
];
var $bb2e2d92462f7729$export$8ce7e340c74e86c5 = [
    "more",
    "no-preference",
    "auto"
];
var $bb2e2d92462f7729$export$7d43e72a58e3283f = [
    "light-increased-contrast",
    "light",
    "dark",
    "dark-increased-contrast",
    "legacy-light",
    "legacy-dark",
    "spacing",
    "typography",
    "shape",
    "typography-adg3",
    "typography-minor3"
];
var $bb2e2d92462f7729$export$ba8a43b83ecc69f8 = [
    "light-new-input-border",
    "dark-new-input-border"
];
var $bb2e2d92462f7729$export$92ba366331403db2 = [].concat($bb2e2d92462f7729$export$7d43e72a58e3283f, $bb2e2d92462f7729$export$ba8a43b83ecc69f8);
/**
 * Theme to use a base. This will create the theme as
 * an extension with all token values marked as optional
 * to allow tokens to be overridden as required.
 */ /**
 * Palettes: The set of base tokens a given theme may be populated with.
 * For example: legacy light & dark themes use the "legacyPalette" containing colors from our
 * previous color set.
 */ /**
 * ThemeConfig: the source of truth for all theme meta-data.
 * This object should be used whenever interfacing with themes.
 */ var $bb2e2d92462f7729$var$themeConfig = {
    "atlassian-light": {
        id: "light",
        displayName: "Light Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "light"
        }
    },
    "atlassian-light-increased-contrast": {
        id: "light-increased-contrast",
        displayName: "Light Theme (increased contrast)",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "light"
        },
        extends: "light",
        increasesContrastFor: "light"
    },
    "atlassian-dark": {
        id: "dark",
        displayName: "Dark Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "dark"
        }
    },
    "atlassian-dark-increased-contrast": {
        id: "dark-increased-contrast",
        displayName: "Dark Theme (increased contrast)",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "dark"
        },
        extends: "dark",
        increasesContrastFor: "dark"
    },
    "atlassian-legacy-light": {
        id: "legacy-light",
        displayName: "Light Theme (legacy)",
        palette: "legacyPalette",
        attributes: {
            type: "color",
            mode: "light"
        }
    },
    "atlassian-legacy-dark": {
        id: "legacy-dark",
        displayName: "Dark Theme (legacy)",
        palette: "legacyPalette",
        attributes: {
            type: "color",
            mode: "dark"
        }
    },
    "atlassian-spacing": {
        id: "spacing",
        displayName: "Atlassian Spacing",
        palette: "spacingScale",
        attributes: {
            type: "spacing"
        }
    },
    "atlassian-typography-adg3": {
        id: "typography-adg3",
        displayName: "ADG3 Typography",
        palette: "typographyPalette",
        attributes: {
            type: "typography"
        }
    },
    "atlassian-shape": {
        id: "shape",
        displayName: "Atlassian Shape",
        palette: "shapePalette",
        attributes: {
            type: "shape"
        }
    },
    "atlassian-light-new-input-border": {
        id: "light-new-input-border",
        displayName: "Light Theme New Input Border",
        palette: "defaultPalette",
        override: "light",
        attributes: {
            type: "color",
            mode: "light"
        }
    },
    "atlassian-dark-new-input-border": {
        id: "dark-new-input-border",
        displayName: "Dark Theme New Input Border",
        palette: "defaultPalette",
        override: "dark",
        attributes: {
            type: "color",
            mode: "dark"
        }
    },
    "atlassian-typography": {
        id: "typography",
        displayName: "Atlassian Typography (Minor Second)",
        palette: "typographyPalette",
        attributes: {
            type: "typography"
        }
    },
    "atlassian-typography-minor3": {
        id: "typography-minor3",
        displayName: "Atlassian Typography (Minor Third)",
        palette: "typographyPalette",
        attributes: {
            type: "typography"
        }
    }
};
var $bb2e2d92462f7729$export$9aedcfa7336a207 = {
    colorMode: "auto",
    contrastMode: "auto",
    dark: "dark",
    light: "light",
    shape: undefined,
    spacing: "spacing",
    typography: undefined,
    UNSAFE_themeOptions: undefined
};
var /**
 * Represents theme state once mounted to the page
 * (the page doesn't have an "auto" color mode, it's either light or dark)
 */ $bb2e2d92462f7729$export$2e2bcd8739ae039 = $bb2e2d92462f7729$var$themeConfig;

});

parcelRegister("90ANA", function(module, exports) {

$parcel$export(module.exports, "themeObjectToString", function () { return $68f0a89a0c7fa960$export$62c37ab81302621a; });

var $2nffd = parcelRequire("2nffd");

var $e6gyJ = parcelRequire("e6gyJ");

var $g4m7u = parcelRequire("g4m7u");
var $68f0a89a0c7fa960$var$themeKinds = [
    "light",
    "dark",
    "spacing",
    "typography",
    "shape"
];
var $68f0a89a0c7fa960$var$customThemeOptions = "UNSAFE_themeOptions";
var $68f0a89a0c7fa960$var$isThemeKind = function isThemeKind(themeKind) {
    return $68f0a89a0c7fa960$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};
var $68f0a89a0c7fa960$var$isThemeIds = function isThemeIds(themeId) {
    return (0, $g4m7u.themeIds).find(function(id) {
        return id === themeId;
    }) !== undefined;
};
var $68f0a89a0c7fa960$var$isColorMode = function isColorMode(modeId) {
    return [
        "light",
        "dark",
        "auto"
    ].includes(modeId);
};
var $68f0a89a0c7fa960$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(" ").map(function(theme) {
        return theme.split(/:([\s\S]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($e6gyJ)))(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === "colorMode" && $68f0a89a0c7fa960$var$isColorMode(id)) themeObject[kind] = id;
        if ($68f0a89a0c7fa960$var$isThemeKind(kind) && $68f0a89a0c7fa960$var$isThemeIds(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $68f0a89a0c7fa960$var$customThemeOptions) try {
            themeObject[$68f0a89a0c7fa960$var$customThemeOptions] = JSON.parse(id);
        } catch (e) {
            new Error("Invalid custom theme string");
        }
        return themeObject;
    }, {});
};
var $68f0a89a0c7fa960$export$62c37ab81302621a = function themeObjectToString(themeState) {
    return Object.entries(themeState).reduce(function(themeString, _ref3) {
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($e6gyJ)))(_ref3, 2), kind = _ref4[0], id = _ref4[1];
        if (// colorMode theme state
        kind === "colorMode" && typeof id === "string" && $68f0a89a0c7fa960$var$isColorMode(id) || // custom theme state
        kind === $68f0a89a0c7fa960$var$customThemeOptions && (0, (/*@__PURE__*/$parcel$interopDefault($2nffd)))(id) === "object" || // other theme states
        $68f0a89a0c7fa960$var$isThemeKind(kind) && typeof id === "string" && $68f0a89a0c7fa960$var$isThemeIds(id)) return themeString + "".concat(themeString ? " " : "") + "".concat(kind, ":").concat((0, (/*@__PURE__*/$parcel$interopDefault($2nffd)))(id) === "object" ? JSON.stringify(id) : id);
        return themeString;
    }, "");
};

});

parcelRegister("6dkEh", function(module, exports) {

$parcel$export(module.exports, "isValidBrandHex", function () { return $4863f95f1bc9e294$export$53031ac1ecb71f44; });
$parcel$export(module.exports, "rgbToHex", function () { return $4863f95f1bc9e294$export$34d09c4a771c46ef; });
$parcel$export(module.exports, "hexToRgbA", function () { return $4863f95f1bc9e294$export$b36dbdb4f463f05c; });
$parcel$export(module.exports, "hexToRgb", function () { return $4863f95f1bc9e294$export$5a544e13ad4e1fa5; });
$parcel$export(module.exports, "hexToHSL", function () { return $4863f95f1bc9e294$export$47ea145a83f50dc0; });
$parcel$export(module.exports, "HSLToRGB", function () { return $4863f95f1bc9e294$export$1ff93e992dd58bec; });
$parcel$export(module.exports, "relativeLuminanceW3C", function () { return $4863f95f1bc9e294$export$e770b01b744f3745; });
$parcel$export(module.exports, "getContrastRatio", function () { return $4863f95f1bc9e294$export$d061e26956a60b0a; });
$parcel$export(module.exports, "deltaE", function () { return $4863f95f1bc9e294$export$e8ddad763b4bebf9; });
// valid hex color with 6 digits
var $4863f95f1bc9e294$export$53031ac1ecb71f44 = function isValidBrandHex(hex) {
    return /^#[0-9A-F]{6}$/i.test(hex);
};
// valid hex color with 4, 6 or 8 digits
var $4863f95f1bc9e294$var$isValidHex = function isValidHex(hex) {
    return /^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex);
};
function $4863f95f1bc9e294$export$34d09c4a771c46ef(r, g, b) {
    return "#" + (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
}
function $4863f95f1bc9e294$export$1212645cf40ebf71(hex) {
    if (hex.length === 9) {
        var int = parseInt(hex.slice(7, 9), 16) / 255;
        return Number(parseFloat(int.toString()).toFixed(2));
    }
    return 1;
}
function $4863f95f1bc9e294$export$b36dbdb4f463f05c(hex) {
    if (!$4863f95f1bc9e294$var$isValidHex(hex)) throw new Error("Invalid HEX");
    var c;
    c = hex.substring(1).split("");
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = "0x" + c.join("");
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255,
        $4863f95f1bc9e294$export$1212645cf40ebf71(hex)
    ];
}
function $4863f95f1bc9e294$export$5a544e13ad4e1fa5(hex) {
    if (!$4863f95f1bc9e294$var$isValidHex(hex)) throw new Error("Invalid HEX");
    var c;
    c = hex.substring(1).split("");
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = "0x" + c.join("");
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255
    ];
}
function $4863f95f1bc9e294$export$47ea145a83f50dc0(hex) {
    if (!$4863f95f1bc9e294$var$isValidHex(hex)) throw new Error("Invalid HEX");
    var r = 0, g = 0, b = 0;
    if (hex.length === 4) {
        r = "0x" + hex[1] + hex[1];
        g = "0x" + hex[2] + hex[2];
        b = "0x" + hex[3] + hex[3];
    } else if (hex.length === 7) {
        r = "0x" + hex[1] + hex[2];
        g = "0x" + hex[3] + hex[4];
        b = "0x" + hex[5] + hex[6];
    }
    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    var cmin = Math.min(r, g, b), cmax = Math.max(r, g, b), delta = cmax - cmin, h = 0, s = 0, l = 0;
    if (delta === 0) h = 0;
    else if (cmax === r) h = (g - b) / delta % 6;
    else if (cmax === g) h = (b - r) / delta + 2;
    else h = (r - g) / delta + 4;
    h = Math.round(h * 60);
    if (h < 0) h += 360;
    l = (cmax + cmin) / 2;
    s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);
    return [
        h,
        s,
        l
    ];
}
function $4863f95f1bc9e294$export$1ff93e992dd58bec(h, s, l) {
    s /= 100;
    l /= 100;
    var k = function k(n) {
        return (n + h / 30) % 12;
    };
    var a = s * Math.min(l, 1 - l);
    var f = function f(n) {
        return l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
    };
    return [
        255 * f(0),
        255 * f(8),
        255 * f(4)
    ];
}
function $4863f95f1bc9e294$export$e770b01b744f3745(r, g, b) {
    var RsRGB = r / 255;
    var GsRGB = g / 255;
    var BsRGB = b / 255;
    var R = RsRGB <= 0.03928 ? RsRGB / 12.92 : Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    var G = GsRGB <= 0.03928 ? GsRGB / 12.92 : Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    var B = BsRGB <= 0.03928 ? BsRGB / 12.92 : Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    // For the sRGB colorspace, the relative luminance of a color is defined as:
    var L = 0.2126 * R + 0.7152 * G + 0.0722 * B;
    return L;
}
function $4863f95f1bc9e294$export$d061e26956a60b0a(foreground, background) {
    if (!$4863f95f1bc9e294$var$isValidHex(foreground) || !$4863f95f1bc9e294$var$isValidHex(background)) throw new Error("Invalid HEX");
    var foregroundRgb = $4863f95f1bc9e294$export$5a544e13ad4e1fa5(foreground);
    var backgroundRgb = $4863f95f1bc9e294$export$5a544e13ad4e1fa5(background);
    var foregroundLuminance = $4863f95f1bc9e294$export$e770b01b744f3745(foregroundRgb[0], foregroundRgb[1], foregroundRgb[2]);
    var backgroundLuminance = $4863f95f1bc9e294$export$e770b01b744f3745(backgroundRgb[0], backgroundRgb[1], backgroundRgb[2]);
    // calculate the color contrast ratio
    var brightest = Math.max(foregroundLuminance, backgroundLuminance);
    var darkest = Math.min(foregroundLuminance, backgroundLuminance);
    return (brightest + 0.05) / (darkest + 0.05);
}
function $4863f95f1bc9e294$export$e8ddad763b4bebf9(rgbA, rgbB) {
    var labA = $4863f95f1bc9e294$var$rgbToLab(rgbA);
    var labB = $4863f95f1bc9e294$var$rgbToLab(rgbB);
    var deltaL = labA[0] - labB[0];
    var deltaA = labA[1] - labB[1];
    var deltaB = labA[2] - labB[2];
    var c1 = Math.sqrt(labA[1] * labA[1] + labA[2] * labA[2]);
    var c2 = Math.sqrt(labB[1] * labB[1] + labB[2] * labB[2]);
    var deltaC = c1 - c2;
    var deltaH = deltaA * deltaA + deltaB * deltaB - deltaC * deltaC;
    deltaH = deltaH < 0 ? 0 : Math.sqrt(deltaH);
    var sc = 1.0 + 0.045 * c1;
    var sh = 1.0 + 0.015 * c1;
    var deltaLKlsl = deltaL / 1.0;
    var deltaCkcsc = deltaC / sc;
    var deltaHkhsh = deltaH / sh;
    var i = deltaLKlsl * deltaLKlsl + deltaCkcsc * deltaCkcsc + deltaHkhsh * deltaHkhsh;
    return i < 0 ? 0 : Math.sqrt(i);
}
function $4863f95f1bc9e294$var$rgbToLab(rgb) {
    var r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255, x, y, z;
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
    y = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 1.0;
    z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    return [
        116 * y - 16,
        500 * (x - y),
        200 * (y - z)
    ];
}

});

parcelRegister("j0aa8", function(module, exports) {

$parcel$export(module.exports, "hash", function () { return $dd55e670c2d0a442$export$d6af199866bfb566; });
var $dd55e670c2d0a442$export$d6af199866bfb566 = function hash(str) {
    var hash = 0;
    for(var i = 0; i < str.length; i++){
        var char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};

});


parcelRegister("dXylA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a29b6daa7875076e$export$2e2bcd8739ae039; });

var $e8dor = parcelRequire("e8dor");

var $fGIeY = parcelRequire("fGIeY");

var $cWK60 = parcelRequire("cWK60");

var $g4m7u = parcelRequire("g4m7u");

var $6dkEh = parcelRequire("6dkEh");

var $3y1ue = parcelRequire("3y1ue");

var $9K0jg = parcelRequire("9K0jg");

var $jJqEb = parcelRequire("jJqEb");

var $ivGXZ = parcelRequire("ivGXZ");
function $a29b6daa7875076e$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $a29b6daa7875076e$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $a29b6daa7875076e$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a29b6daa7875076e$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a29b6daa7875076e$var$_arrayLikeToArray(o, minLen);
}
function $a29b6daa7875076e$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

/**
 * Sets the theme globally at runtime. This updates the `data-theme` and `data-color-mode` attributes on your page's <html> tag.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.contrastMode The contrast mode theme to be applied. If set to `auto`, the theme applied will be determined by the OS setting.set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 * @param {function} themeLoader Callback function used to override the default theme loading functionality.
 *
 * @returns A Promise of an unbind function, that can be used to stop listening for changes to system theme.
 *
 * @example
 * ```
 * setGlobalTheme({colorMode: 'auto', light: 'light', dark: 'dark', spacing: 'spacing'});
 * ```
 */ var $a29b6daa7875076e$var$setGlobalTheme = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($e8dor)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).mark(function _callee3() {
        var _ref2, _ref2$colorMode, colorMode, _ref2$contrastMode, contrastMode, _ref2$dark, dark, _ref2$light, light, _ref2$shape, shape, _ref2$spacing, spacing, _ref2$typography, typography, _ref2$UNSAFE_themeOpt, UNSAFE_themeOptions, themeLoader, themeState, themePreferences, loadingStrategy, loadingTasks, mode, attrOfMissingCustomStyles, themeOverridePreferences, _iterator, _step, themeId, autoUnbind, _args3 = arguments;
        return (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    _ref2 = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {}, _ref2$colorMode = _ref2.colorMode, colorMode = _ref2$colorMode === void 0 ? (0, $g4m7u.themeStateDefaults)["colorMode"] : _ref2$colorMode, _ref2$contrastMode = _ref2.contrastMode, contrastMode = _ref2$contrastMode === void 0 ? (0, $g4m7u.themeStateDefaults)["contrastMode"] : _ref2$contrastMode, _ref2$dark = _ref2.dark, dark = _ref2$dark === void 0 ? (0, $g4m7u.themeStateDefaults)["dark"] : _ref2$dark, _ref2$light = _ref2.light, light = _ref2$light === void 0 ? (0, $g4m7u.themeStateDefaults)["light"] : _ref2$light, _ref2$shape = _ref2.shape, shape = _ref2$shape === void 0 ? (0, $g4m7u.themeStateDefaults)["shape"] : _ref2$shape, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? (0, $g4m7u.themeStateDefaults)["spacing"] : _ref2$spacing, _ref2$typography = _ref2.typography, typography = _ref2$typography === void 0 ? (0, $g4m7u.themeStateDefaults)["typography"] : _ref2$typography, _ref2$UNSAFE_themeOpt = _ref2.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref2$UNSAFE_themeOpt === void 0 ? (0, $g4m7u.themeStateDefaults)["UNSAFE_themeOptions"] : _ref2$UNSAFE_themeOpt;
                    themeLoader = _args3.length > 1 ? _args3[1] : undefined;
                    // CLEANUP: Remove. This blocks application of increased contrast themes
                    // without the feature flag enabled.
                    if (!(0, $cWK60.getBooleanFF)("platform.design-system-team.increased-contrast-themes")) {
                        if (light === "light-increased-contrast") light = "light";
                        if (dark === "dark-increased-contrast") dark = "dark";
                    }
                    themeState = {
                        colorMode: colorMode,
                        contrastMode: contrastMode,
                        dark: dark,
                        light: light,
                        shape: shape,
                        spacing: spacing,
                        typography: typography,
                        UNSAFE_themeOptions: themeLoader ? undefined : UNSAFE_themeOptions
                    }; // Determine what to load and loading strategy
                    themePreferences = (0, $jJqEb.getThemePreferences)(themeState);
                    loadingStrategy = themeLoader ? themeLoader : (0, $ivGXZ.loadAndAppendThemeCss); // Load standard themes
                    loadingTasks = themePreferences.map(/*#__PURE__*/ function() {
                        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($e8dor)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).mark(function _callee(themeId) {
                            return (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).wrap(function _callee$(_context) {
                                while(true)switch(_context.prev = _context.next){
                                    case 0:
                                        _context.next = 2;
                                        return loadingStrategy(themeId);
                                    case 2:
                                        return _context.abrupt("return", _context.sent);
                                    case 3:
                                    case "end":
                                        return _context.stop();
                                }
                            }, _callee);
                        }));
                        return function(_x) {
                            return _ref3.apply(this, arguments);
                        };
                    }()); // Load custom themes if needed
                    if (!themeLoader && UNSAFE_themeOptions && (0, $6dkEh.isValidBrandHex)(UNSAFE_themeOptions === null || UNSAFE_themeOptions === void 0 ? void 0 : UNSAFE_themeOptions.brandColor)) {
                        mode = colorMode || (0, $g4m7u.themeStateDefaults)["colorMode"];
                        attrOfMissingCustomStyles = (0, $9K0jg.findMissingCustomStyleElements)(UNSAFE_themeOptions, mode);
                        if (attrOfMissingCustomStyles.length > 0) // Load custom theme styles
                        loadingTasks.push((0, (/*@__PURE__*/$parcel$interopDefault($e8dor)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).mark(function _callee2() {
                            var _yield$import, loadAndAppendCustomThemeCss;
                            return (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).wrap(function _callee2$(_context2) {
                                while(true)switch(_context2.prev = _context2.next){
                                    case 0:
                                        _context2.next = 2;
                                        return (parcelRequire("kRuFa"));
                                    case 2:
                                        _yield$import = _context2.sent;
                                        loadAndAppendCustomThemeCss = _yield$import.loadAndAppendCustomThemeCss;
                                        loadAndAppendCustomThemeCss({
                                            colorMode: attrOfMissingCustomStyles.length === 2 ? "auto" : // only load the missing custom theme styles
                                            attrOfMissingCustomStyles[0],
                                            UNSAFE_themeOptions: UNSAFE_themeOptions
                                        });
                                    case 5:
                                    case "end":
                                        return _context2.stop();
                                }
                            }, _callee2);
                        }))());
                    }
                    _context3.next = 10;
                    return Promise.all(loadingTasks);
                case 10:
                    // Load override themes after standard themes
                    themeOverridePreferences = (0, $jJqEb.getThemeOverridePreferences)(themeState);
                    _iterator = $a29b6daa7875076e$var$_createForOfIteratorHelper(themeOverridePreferences);
                    _context3.prev = 12;
                    _iterator.s();
                case 14:
                    if ((_step = _iterator.n()).done) {
                        _context3.next = 20;
                        break;
                    }
                    themeId = _step.value;
                    _context3.next = 18;
                    return loadingStrategy(themeId);
                case 18:
                    _context3.next = 14;
                    break;
                case 20:
                    _context3.next = 25;
                    break;
                case 22:
                    _context3.prev = 22;
                    _context3.t0 = _context3["catch"](12);
                    _iterator.e(_context3.t0);
                case 25:
                    _context3.prev = 25;
                    _iterator.f();
                    return _context3.finish(25);
                case 28:
                    autoUnbind = (0, $3y1ue.default)(themeState);
                    return _context3.abrupt("return", autoUnbind);
                case 30:
                case "end":
                    return _context3.stop();
            }
        }, _callee3, null, [
            [
                12,
                22,
                25,
                28
            ]
        ]);
    }));
    return function setGlobalTheme() {
        return _ref.apply(this, arguments);
    };
}();
var $a29b6daa7875076e$export$2e2bcd8739ae039 = $a29b6daa7875076e$var$setGlobalTheme;

});
parcelRegister("3y1ue", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2955b34689ca2fe6$export$2e2bcd8739ae039; });

var $e6gyJ = parcelRequire("e6gyJ");

var $cWK60 = parcelRequire("cWK60");

var $bHTvw = parcelRequire("bHTvw");

var $hyW0M = parcelRequire("hyW0M");

var $bPWJC = parcelRequire("bPWJC");
function $2955b34689ca2fe6$export$2e2bcd8739ae039(themeState) {
    if (themeState.colorMode === "auto") {
        // Set colorMode based on the user preference
        themeState.colorMode = (0, $hyW0M.default).getColorMode();
        // Bind a listener (if one doesn't already exist) to keep colorMode updated
        (0, $hyW0M.default).bind();
    } else (0, $hyW0M.default).unbind();
    if ((0, $cWK60.getBooleanFF)("platform.design-system-team.increased-contrast-themes")) {
        if (themeState.contrastMode === "auto") {
            // Set contrastMode based on the user preference
            themeState.contrastMode = (0, $bPWJC.default).getContrastMode();
            // Bind a listener (if one doesn't already exist) to keep contrastMode updated
            (0, $bPWJC.default).bind();
        } else (0, $bPWJC.default).unbind();
    }
    var themeAttributes = (0, $bHTvw.default)(themeState);
    Object.entries(themeAttributes).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($e6gyJ)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        document.documentElement.setAttribute(key, value);
    });
    return function() {
        (0, $hyW0M.default).unbind();
        if ((0, $cWK60.getBooleanFF)("platform.design-system-team.increased-contrast-themes")) (0, $bPWJC.default).unbind();
    };
}

});
parcelRegister("hyW0M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc929c8cfc896a84$export$2e2bcd8739ae039; });

var $6QU8A = parcelRequire("6QU8A");

var $2Yk1N = parcelRequire("2Yk1N");

var $jjExS = parcelRequire("jjExS");

var $12aDa = parcelRequire("12aDa");

var $c8ZjH = parcelRequire("c8ZjH");

var $ivGXZ = parcelRequire("ivGXZ");
var $cc929c8cfc896a84$var$isMatchMediaAvailable = typeof window !== "undefined" && "matchMedia" in window;
/**
 * Updates the current theme when the system theme changes. Should be bound
 * to an event listener listening on the '(prefers-color-scheme: dark)' query
 * @param e The event representing a change in system theme.
 */ function $cc929c8cfc896a84$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $c8ZjH.COLOR_MODE_ATTRIBUTE), e.matches ? "dark" : "light");
}
var $cc929c8cfc896a84$var$darkModeMql = $cc929c8cfc896a84$var$isMatchMediaAvailable && window.matchMedia((0, $ivGXZ.darkModeMediaQuery));
var $cc929c8cfc896a84$var$ColorModeObserver = /*#__PURE__*/ function() {
    function ColorModeObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($6QU8A)))(this, ColorModeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "unbindThemeChangeListener", null);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($2Yk1N)))(ColorModeObserver, [
        {
            key: "getColorMode",
            value: function getColorMode() {
                if (!$cc929c8cfc896a84$var$darkModeMql) return "light";
                return $cc929c8cfc896a84$var$darkModeMql !== null && $cc929c8cfc896a84$var$darkModeMql !== void 0 && $cc929c8cfc896a84$var$darkModeMql.matches ? "dark" : "light";
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($cc929c8cfc896a84$var$darkModeMql && this.unbindThemeChangeListener === null) this.unbindThemeChangeListener = (0, $12aDa.bind)($cc929c8cfc896a84$var$darkModeMql, {
                    type: "change",
                    listener: $cc929c8cfc896a84$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindThemeChangeListener) {
                    this.unbindThemeChangeListener();
                    this.unbindThemeChangeListener = null;
                }
            }
        }
    ]);
    return ColorModeObserver;
}();
/**
 * A singleton color mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $cc929c8cfc896a84$var$SingletonColorModeObserver = new $cc929c8cfc896a84$var$ColorModeObserver();
var $cc929c8cfc896a84$export$2e2bcd8739ae039 = $cc929c8cfc896a84$var$SingletonColorModeObserver;

});
parcelRegister("12aDa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = module.exports.bind = void 0;

var $6q0HD = parcelRequire("6q0HD");
Object.defineProperty(module.exports, "bind", {
    enumerable: true,
    get: function get() {
        return $6q0HD.bind;
    }
});

var $c9OiB = parcelRequire("c9OiB");
Object.defineProperty(module.exports, "bindAll", {
    enumerable: true,
    get: function get() {
        return $c9OiB.bindAll;
    }
});

});
parcelRegister("6q0HD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bind = void 0;
function $4ac5b7532fe5e421$var$bind(target, _a) {
    var type = _a.type, listener = _a.listener, options = _a.options;
    target.addEventListener(type, listener, options);
    return function unbind() {
        target.removeEventListener(type, listener, options);
    };
}
module.exports.bind = $4ac5b7532fe5e421$var$bind;

});

parcelRegister("c9OiB", function(module, exports) {
"use strict";
var $8d9d579db574bfff$var$__assign = module.exports && module.exports.__assign || function() {
    $8d9d579db574bfff$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8d9d579db574bfff$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = void 0;

var $6q0HD = parcelRequire("6q0HD");
function $8d9d579db574bfff$var$toOptions(value) {
    if (typeof value === "undefined") return undefined;
    if (typeof value === "boolean") return {
        capture: value
    };
    return value;
}
function $8d9d579db574bfff$var$getBinding(original, sharedOptions) {
    if (sharedOptions == null) return original;
    var binding = $8d9d579db574bfff$var$__assign($8d9d579db574bfff$var$__assign({}, original), {
        options: $8d9d579db574bfff$var$__assign($8d9d579db574bfff$var$__assign({}, $8d9d579db574bfff$var$toOptions(sharedOptions)), $8d9d579db574bfff$var$toOptions(original.options))
    });
    return binding;
}
function $8d9d579db574bfff$var$bindAll(target, bindings, sharedOptions) {
    var unbinds = bindings.map(function(original) {
        var binding = $8d9d579db574bfff$var$getBinding(original, sharedOptions);
        return (0, $6q0HD.bind)(target, binding);
    });
    return function unbindAll() {
        unbinds.forEach(function(unbind) {
            return unbind();
        });
    };
}
module.exports.bindAll = $8d9d579db574bfff$var$bindAll;

});



parcelRegister("bPWJC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89e2049f119ffcad$export$2e2bcd8739ae039; });

var $6QU8A = parcelRequire("6QU8A");

var $2Yk1N = parcelRequire("2Yk1N");

var $jjExS = parcelRequire("jjExS");

var $12aDa = parcelRequire("12aDa");

var $c8ZjH = parcelRequire("c8ZjH");

var $ivGXZ = parcelRequire("ivGXZ");
var $89e2049f119ffcad$var$isMatchMediaAvailable = typeof window !== "undefined" && "matchMedia" in window;
/**
 * Updates the current theme when the system contrast preference changes. Should be bound
 * to an event listener listening on the '(prefers-contrast: more)' query
 * @param e The event representing a change in system theme.
 */ function $89e2049f119ffcad$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $c8ZjH.CONTRAST_MODE_ATTRIBUTE), e.matches ? "more" : "no-preference");
}
var $89e2049f119ffcad$var$contrastModeMql = $89e2049f119ffcad$var$isMatchMediaAvailable && window.matchMedia((0, $ivGXZ.moreContrastMediaQuery));
var $89e2049f119ffcad$var$ContrastModeObserver = /*#__PURE__*/ function() {
    function ContrastModeObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($6QU8A)))(this, ContrastModeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "unbindContrastChangeListener", null);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($2Yk1N)))(ContrastModeObserver, [
        {
            key: "getContrastMode",
            value: function getContrastMode() {
                if (!$89e2049f119ffcad$var$contrastModeMql) return "no-preference";
                return $89e2049f119ffcad$var$contrastModeMql !== null && $89e2049f119ffcad$var$contrastModeMql !== void 0 && $89e2049f119ffcad$var$contrastModeMql.matches ? "more" : "no-preference";
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($89e2049f119ffcad$var$contrastModeMql && this.unbindContrastChangeListener === null) this.unbindContrastChangeListener = (0, $12aDa.bind)($89e2049f119ffcad$var$contrastModeMql, {
                    type: "change",
                    listener: $89e2049f119ffcad$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindContrastChangeListener) {
                    this.unbindContrastChangeListener();
                    this.unbindContrastChangeListener = null;
                }
            }
        }
    ]);
    return ContrastModeObserver;
}();
/**
 * A singleton contrast mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $89e2049f119ffcad$var$SingletonContrastModeObserver = new $89e2049f119ffcad$var$ContrastModeObserver();
var $89e2049f119ffcad$export$2e2bcd8739ae039 = $89e2049f119ffcad$var$SingletonContrastModeObserver;

});


parcelRegister("9K0jg", function(module, exports) {

$parcel$export(module.exports, "findMissingCustomStyleElements", function () { return $7178a66c7c095090$export$bd1ac9300b0e885a; });
$parcel$export(module.exports, "limitSizeOfCustomStyleElements", function () { return $7178a66c7c095090$export$e7ae172320e03461; });
$parcel$export(module.exports, "reduceTokenMap", function () { return $7178a66c7c095090$export$e673f367da2ff23e; });

var $e6gyJ = parcelRequire("e6gyJ");

var $eetQ9 = parcelRequire("eetQ9");

var $kpSv8 = parcelRequire("kpSv8");

var $c8ZjH = parcelRequire("c8ZjH");

var $j0aa8 = parcelRequire("j0aa8");
function $7178a66c7c095090$export$bd1ac9300b0e885a(UNSAFE_themeOptions, mode) {
    var optionString = JSON.stringify(UNSAFE_themeOptions);
    var uniqueId = (0, $j0aa8.hash)(optionString);
    var attrOfMissingCustomStyles = [];
    (mode === "auto" ? [
        "light",
        "dark"
    ] : [
        mode
    ]).forEach(function(themeId) {
        var element = document.head.querySelector("style[".concat((0, $c8ZjH.CUSTOM_THEME_ATTRIBUTE), '="').concat(uniqueId, '"][').concat((0, $c8ZjH.THEME_DATA_ATTRIBUTE), '="').concat(themeId, '"]'));
        if (element) // Append the existing custom styles to take precedence over others
        document.head.appendChild(element);
        else attrOfMissingCustomStyles.push(themeId);
    });
    return attrOfMissingCustomStyles;
}
function $7178a66c7c095090$export$e7ae172320e03461(sizeThreshold) {
    var styleTags = (0, (/*@__PURE__*/$parcel$interopDefault($eetQ9)))(Array.from(document.head.querySelectorAll("style[".concat((0, $c8ZjH.CUSTOM_THEME_ATTRIBUTE), "][").concat((0, $c8ZjH.THEME_DATA_ATTRIBUTE), "]"))));
    if (styleTags.length < sizeThreshold) return;
    styleTags.slice(0, styleTags.length - (sizeThreshold - 1)).forEach(function(element) {
        return element.remove();
    });
}
function $7178a66c7c095090$export$e673f367da2ff23e(tokenMap, themeRamp) {
    return Object.entries(tokenMap).reduce(function(acc, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($e6gyJ)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        var cssVar = (0, $kpSv8.default)[key];
        return cssVar ? "".concat(acc, "\n  ").concat(cssVar, ": ").concat(typeof value === "string" ? value : themeRamp[value], ";") : acc;
    }, "");
}

});
parcelRegister("kpSv8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $edd06b3c8c8396c5$export$2e2bcd8739ae039; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b8507162c70d82c2e8040cc31a142fdb>>
 * @codegenCommand yarn build tokens
 */ var $edd06b3c8c8396c5$var$tokens = {
    "color.text": "--ds-text",
    "color.text.accent.lime": "--ds-text-accent-lime",
    "color.text.accent.lime.bolder": "--ds-text-accent-lime-bolder",
    "color.text.accent.red": "--ds-text-accent-red",
    "color.text.accent.red.bolder": "--ds-text-accent-red-bolder",
    "color.text.accent.orange": "--ds-text-accent-orange",
    "color.text.accent.orange.bolder": "--ds-text-accent-orange-bolder",
    "color.text.accent.yellow": "--ds-text-accent-yellow",
    "color.text.accent.yellow.bolder": "--ds-text-accent-yellow-bolder",
    "color.text.accent.green": "--ds-text-accent-green",
    "color.text.accent.green.bolder": "--ds-text-accent-green-bolder",
    "color.text.accent.teal": "--ds-text-accent-teal",
    "color.text.accent.teal.bolder": "--ds-text-accent-teal-bolder",
    "color.text.accent.blue": "--ds-text-accent-blue",
    "color.text.accent.blue.bolder": "--ds-text-accent-blue-bolder",
    "color.text.accent.purple": "--ds-text-accent-purple",
    "color.text.accent.purple.bolder": "--ds-text-accent-purple-bolder",
    "color.text.accent.magenta": "--ds-text-accent-magenta",
    "color.text.accent.magenta.bolder": "--ds-text-accent-magenta-bolder",
    "color.text.accent.gray": "--ds-text-accent-gray",
    "color.text.accent.gray.bolder": "--ds-text-accent-gray-bolder",
    "color.text.disabled": "--ds-text-disabled",
    "color.text.inverse": "--ds-text-inverse",
    "color.text.selected": "--ds-text-selected",
    "color.text.brand": "--ds-text-brand",
    "color.text.danger": "--ds-text-danger",
    "color.text.warning": "--ds-text-warning",
    "color.text.warning.inverse": "--ds-text-warning-inverse",
    "color.text.success": "--ds-text-success",
    "color.text.discovery": "--ds-text-discovery",
    "color.text.information": "--ds-text-information",
    "color.text.subtlest": "--ds-text-subtlest",
    "color.text.subtle": "--ds-text-subtle",
    "color.link": "--ds-link",
    "color.link.pressed": "--ds-link-pressed",
    "color.link.visited": "--ds-link-visited",
    "color.icon": "--ds-icon",
    "color.icon.accent.lime": "--ds-icon-accent-lime",
    "color.icon.accent.red": "--ds-icon-accent-red",
    "color.icon.accent.orange": "--ds-icon-accent-orange",
    "color.icon.accent.yellow": "--ds-icon-accent-yellow",
    "color.icon.accent.green": "--ds-icon-accent-green",
    "color.icon.accent.teal": "--ds-icon-accent-teal",
    "color.icon.accent.blue": "--ds-icon-accent-blue",
    "color.icon.accent.purple": "--ds-icon-accent-purple",
    "color.icon.accent.magenta": "--ds-icon-accent-magenta",
    "color.icon.accent.gray": "--ds-icon-accent-gray",
    "color.icon.disabled": "--ds-icon-disabled",
    "color.icon.inverse": "--ds-icon-inverse",
    "color.icon.selected": "--ds-icon-selected",
    "color.icon.brand": "--ds-icon-brand",
    "color.icon.danger": "--ds-icon-danger",
    "color.icon.warning": "--ds-icon-warning",
    "color.icon.warning.inverse": "--ds-icon-warning-inverse",
    "color.icon.success": "--ds-icon-success",
    "color.icon.discovery": "--ds-icon-discovery",
    "color.icon.information": "--ds-icon-information",
    "color.icon.subtle": "--ds-icon-subtle",
    "color.border": "--ds-border",
    "color.border.accent.lime": "--ds-border-accent-lime",
    "color.border.accent.red": "--ds-border-accent-red",
    "color.border.accent.orange": "--ds-border-accent-orange",
    "color.border.accent.yellow": "--ds-border-accent-yellow",
    "color.border.accent.green": "--ds-border-accent-green",
    "color.border.accent.teal": "--ds-border-accent-teal",
    "color.border.accent.blue": "--ds-border-accent-blue",
    "color.border.accent.purple": "--ds-border-accent-purple",
    "color.border.accent.magenta": "--ds-border-accent-magenta",
    "color.border.accent.gray": "--ds-border-accent-gray",
    "color.border.disabled": "--ds-border-disabled",
    "color.border.focused": "--ds-border-focused",
    "color.border.input": "--ds-border-input",
    "color.border.inverse": "--ds-border-inverse",
    "color.border.selected": "--ds-border-selected",
    "color.border.brand": "--ds-border-brand",
    "color.border.danger": "--ds-border-danger",
    "color.border.warning": "--ds-border-warning",
    "color.border.success": "--ds-border-success",
    "color.border.discovery": "--ds-border-discovery",
    "color.border.information": "--ds-border-information",
    "color.border.bold": "--ds-border-bold",
    "color.background.accent.lime.subtlest": "--ds-background-accent-lime-subtlest",
    "color.background.accent.lime.subtlest.hovered": "--ds-background-accent-lime-subtlest-hovered",
    "color.background.accent.lime.subtlest.pressed": "--ds-background-accent-lime-subtlest-pressed",
    "color.background.accent.lime.subtler": "--ds-background-accent-lime-subtler",
    "color.background.accent.lime.subtler.hovered": "--ds-background-accent-lime-subtler-hovered",
    "color.background.accent.lime.subtler.pressed": "--ds-background-accent-lime-subtler-pressed",
    "color.background.accent.lime.subtle": "--ds-background-accent-lime-subtle",
    "color.background.accent.lime.subtle.hovered": "--ds-background-accent-lime-subtle-hovered",
    "color.background.accent.lime.subtle.pressed": "--ds-background-accent-lime-subtle-pressed",
    "color.background.accent.lime.bolder": "--ds-background-accent-lime-bolder",
    "color.background.accent.lime.bolder.hovered": "--ds-background-accent-lime-bolder-hovered",
    "color.background.accent.lime.bolder.pressed": "--ds-background-accent-lime-bolder-pressed",
    "color.background.accent.red.subtlest": "--ds-background-accent-red-subtlest",
    "color.background.accent.red.subtlest.hovered": "--ds-background-accent-red-subtlest-hovered",
    "color.background.accent.red.subtlest.pressed": "--ds-background-accent-red-subtlest-pressed",
    "color.background.accent.red.subtler": "--ds-background-accent-red-subtler",
    "color.background.accent.red.subtler.hovered": "--ds-background-accent-red-subtler-hovered",
    "color.background.accent.red.subtler.pressed": "--ds-background-accent-red-subtler-pressed",
    "color.background.accent.red.subtle": "--ds-background-accent-red-subtle",
    "color.background.accent.red.subtle.hovered": "--ds-background-accent-red-subtle-hovered",
    "color.background.accent.red.subtle.pressed": "--ds-background-accent-red-subtle-pressed",
    "color.background.accent.red.bolder": "--ds-background-accent-red-bolder",
    "color.background.accent.red.bolder.hovered": "--ds-background-accent-red-bolder-hovered",
    "color.background.accent.red.bolder.pressed": "--ds-background-accent-red-bolder-pressed",
    "color.background.accent.orange.subtlest": "--ds-background-accent-orange-subtlest",
    "color.background.accent.orange.subtlest.hovered": "--ds-background-accent-orange-subtlest-hovered",
    "color.background.accent.orange.subtlest.pressed": "--ds-background-accent-orange-subtlest-pressed",
    "color.background.accent.orange.subtler": "--ds-background-accent-orange-subtler",
    "color.background.accent.orange.subtler.hovered": "--ds-background-accent-orange-subtler-hovered",
    "color.background.accent.orange.subtler.pressed": "--ds-background-accent-orange-subtler-pressed",
    "color.background.accent.orange.subtle": "--ds-background-accent-orange-subtle",
    "color.background.accent.orange.subtle.hovered": "--ds-background-accent-orange-subtle-hovered",
    "color.background.accent.orange.subtle.pressed": "--ds-background-accent-orange-subtle-pressed",
    "color.background.accent.orange.bolder": "--ds-background-accent-orange-bolder",
    "color.background.accent.orange.bolder.hovered": "--ds-background-accent-orange-bolder-hovered",
    "color.background.accent.orange.bolder.pressed": "--ds-background-accent-orange-bolder-pressed",
    "color.background.accent.yellow.subtlest": "--ds-background-accent-yellow-subtlest",
    "color.background.accent.yellow.subtlest.hovered": "--ds-background-accent-yellow-subtlest-hovered",
    "color.background.accent.yellow.subtlest.pressed": "--ds-background-accent-yellow-subtlest-pressed",
    "color.background.accent.yellow.subtler": "--ds-background-accent-yellow-subtler",
    "color.background.accent.yellow.subtler.hovered": "--ds-background-accent-yellow-subtler-hovered",
    "color.background.accent.yellow.subtler.pressed": "--ds-background-accent-yellow-subtler-pressed",
    "color.background.accent.yellow.subtle": "--ds-background-accent-yellow-subtle",
    "color.background.accent.yellow.subtle.hovered": "--ds-background-accent-yellow-subtle-hovered",
    "color.background.accent.yellow.subtle.pressed": "--ds-background-accent-yellow-subtle-pressed",
    "color.background.accent.yellow.bolder": "--ds-background-accent-yellow-bolder",
    "color.background.accent.yellow.bolder.hovered": "--ds-background-accent-yellow-bolder-hovered",
    "color.background.accent.yellow.bolder.pressed": "--ds-background-accent-yellow-bolder-pressed",
    "color.background.accent.green.subtlest": "--ds-background-accent-green-subtlest",
    "color.background.accent.green.subtlest.hovered": "--ds-background-accent-green-subtlest-hovered",
    "color.background.accent.green.subtlest.pressed": "--ds-background-accent-green-subtlest-pressed",
    "color.background.accent.green.subtler": "--ds-background-accent-green-subtler",
    "color.background.accent.green.subtler.hovered": "--ds-background-accent-green-subtler-hovered",
    "color.background.accent.green.subtler.pressed": "--ds-background-accent-green-subtler-pressed",
    "color.background.accent.green.subtle": "--ds-background-accent-green-subtle",
    "color.background.accent.green.subtle.hovered": "--ds-background-accent-green-subtle-hovered",
    "color.background.accent.green.subtle.pressed": "--ds-background-accent-green-subtle-pressed",
    "color.background.accent.green.bolder": "--ds-background-accent-green-bolder",
    "color.background.accent.green.bolder.hovered": "--ds-background-accent-green-bolder-hovered",
    "color.background.accent.green.bolder.pressed": "--ds-background-accent-green-bolder-pressed",
    "color.background.accent.teal.subtlest": "--ds-background-accent-teal-subtlest",
    "color.background.accent.teal.subtlest.hovered": "--ds-background-accent-teal-subtlest-hovered",
    "color.background.accent.teal.subtlest.pressed": "--ds-background-accent-teal-subtlest-pressed",
    "color.background.accent.teal.subtler": "--ds-background-accent-teal-subtler",
    "color.background.accent.teal.subtler.hovered": "--ds-background-accent-teal-subtler-hovered",
    "color.background.accent.teal.subtler.pressed": "--ds-background-accent-teal-subtler-pressed",
    "color.background.accent.teal.subtle": "--ds-background-accent-teal-subtle",
    "color.background.accent.teal.subtle.hovered": "--ds-background-accent-teal-subtle-hovered",
    "color.background.accent.teal.subtle.pressed": "--ds-background-accent-teal-subtle-pressed",
    "color.background.accent.teal.bolder": "--ds-background-accent-teal-bolder",
    "color.background.accent.teal.bolder.hovered": "--ds-background-accent-teal-bolder-hovered",
    "color.background.accent.teal.bolder.pressed": "--ds-background-accent-teal-bolder-pressed",
    "color.background.accent.blue.subtlest": "--ds-background-accent-blue-subtlest",
    "color.background.accent.blue.subtlest.hovered": "--ds-background-accent-blue-subtlest-hovered",
    "color.background.accent.blue.subtlest.pressed": "--ds-background-accent-blue-subtlest-pressed",
    "color.background.accent.blue.subtler": "--ds-background-accent-blue-subtler",
    "color.background.accent.blue.subtler.hovered": "--ds-background-accent-blue-subtler-hovered",
    "color.background.accent.blue.subtler.pressed": "--ds-background-accent-blue-subtler-pressed",
    "color.background.accent.blue.subtle": "--ds-background-accent-blue-subtle",
    "color.background.accent.blue.subtle.hovered": "--ds-background-accent-blue-subtle-hovered",
    "color.background.accent.blue.subtle.pressed": "--ds-background-accent-blue-subtle-pressed",
    "color.background.accent.blue.bolder": "--ds-background-accent-blue-bolder",
    "color.background.accent.blue.bolder.hovered": "--ds-background-accent-blue-bolder-hovered",
    "color.background.accent.blue.bolder.pressed": "--ds-background-accent-blue-bolder-pressed",
    "color.background.accent.purple.subtlest": "--ds-background-accent-purple-subtlest",
    "color.background.accent.purple.subtlest.hovered": "--ds-background-accent-purple-subtlest-hovered",
    "color.background.accent.purple.subtlest.pressed": "--ds-background-accent-purple-subtlest-pressed",
    "color.background.accent.purple.subtler": "--ds-background-accent-purple-subtler",
    "color.background.accent.purple.subtler.hovered": "--ds-background-accent-purple-subtler-hovered",
    "color.background.accent.purple.subtler.pressed": "--ds-background-accent-purple-subtler-pressed",
    "color.background.accent.purple.subtle": "--ds-background-accent-purple-subtle",
    "color.background.accent.purple.subtle.hovered": "--ds-background-accent-purple-subtle-hovered",
    "color.background.accent.purple.subtle.pressed": "--ds-background-accent-purple-subtle-pressed",
    "color.background.accent.purple.bolder": "--ds-background-accent-purple-bolder",
    "color.background.accent.purple.bolder.hovered": "--ds-background-accent-purple-bolder-hovered",
    "color.background.accent.purple.bolder.pressed": "--ds-background-accent-purple-bolder-pressed",
    "color.background.accent.magenta.subtlest": "--ds-background-accent-magenta-subtlest",
    "color.background.accent.magenta.subtlest.hovered": "--ds-background-accent-magenta-subtlest-hovered",
    "color.background.accent.magenta.subtlest.pressed": "--ds-background-accent-magenta-subtlest-pressed",
    "color.background.accent.magenta.subtler": "--ds-background-accent-magenta-subtler",
    "color.background.accent.magenta.subtler.hovered": "--ds-background-accent-magenta-subtler-hovered",
    "color.background.accent.magenta.subtler.pressed": "--ds-background-accent-magenta-subtler-pressed",
    "color.background.accent.magenta.subtle": "--ds-background-accent-magenta-subtle",
    "color.background.accent.magenta.subtle.hovered": "--ds-background-accent-magenta-subtle-hovered",
    "color.background.accent.magenta.subtle.pressed": "--ds-background-accent-magenta-subtle-pressed",
    "color.background.accent.magenta.bolder": "--ds-background-accent-magenta-bolder",
    "color.background.accent.magenta.bolder.hovered": "--ds-background-accent-magenta-bolder-hovered",
    "color.background.accent.magenta.bolder.pressed": "--ds-background-accent-magenta-bolder-pressed",
    "color.background.accent.gray.subtlest": "--ds-background-accent-gray-subtlest",
    "color.background.accent.gray.subtlest.hovered": "--ds-background-accent-gray-subtlest-hovered",
    "color.background.accent.gray.subtlest.pressed": "--ds-background-accent-gray-subtlest-pressed",
    "color.background.accent.gray.subtler": "--ds-background-accent-gray-subtler",
    "color.background.accent.gray.subtler.hovered": "--ds-background-accent-gray-subtler-hovered",
    "color.background.accent.gray.subtler.pressed": "--ds-background-accent-gray-subtler-pressed",
    "color.background.accent.gray.subtle": "--ds-background-accent-gray-subtle",
    "color.background.accent.gray.subtle.hovered": "--ds-background-accent-gray-subtle-hovered",
    "color.background.accent.gray.subtle.pressed": "--ds-background-accent-gray-subtle-pressed",
    "color.background.accent.gray.bolder": "--ds-background-accent-gray-bolder",
    "color.background.accent.gray.bolder.hovered": "--ds-background-accent-gray-bolder-hovered",
    "color.background.accent.gray.bolder.pressed": "--ds-background-accent-gray-bolder-pressed",
    "color.background.disabled": "--ds-background-disabled",
    "color.background.input": "--ds-background-input",
    "color.background.input.hovered": "--ds-background-input-hovered",
    "color.background.input.pressed": "--ds-background-input-pressed",
    "color.background.inverse.subtle": "--ds-background-inverse-subtle",
    "color.background.inverse.subtle.hovered": "--ds-background-inverse-subtle-hovered",
    "color.background.inverse.subtle.pressed": "--ds-background-inverse-subtle-pressed",
    "color.background.neutral": "--ds-background-neutral",
    "color.background.neutral.hovered": "--ds-background-neutral-hovered",
    "color.background.neutral.pressed": "--ds-background-neutral-pressed",
    "color.background.neutral.subtle": "--ds-background-neutral-subtle",
    "color.background.neutral.subtle.hovered": "--ds-background-neutral-subtle-hovered",
    "color.background.neutral.subtle.pressed": "--ds-background-neutral-subtle-pressed",
    "color.background.neutral.bold": "--ds-background-neutral-bold",
    "color.background.neutral.bold.hovered": "--ds-background-neutral-bold-hovered",
    "color.background.neutral.bold.pressed": "--ds-background-neutral-bold-pressed",
    "color.background.selected": "--ds-background-selected",
    "color.background.selected.hovered": "--ds-background-selected-hovered",
    "color.background.selected.pressed": "--ds-background-selected-pressed",
    "color.background.selected.bold": "--ds-background-selected-bold",
    "color.background.selected.bold.hovered": "--ds-background-selected-bold-hovered",
    "color.background.selected.bold.pressed": "--ds-background-selected-bold-pressed",
    "color.background.brand.subtlest": "--ds-background-brand-subtlest",
    "color.background.brand.subtlest.hovered": "--ds-background-brand-subtlest-hovered",
    "color.background.brand.subtlest.pressed": "--ds-background-brand-subtlest-pressed",
    "color.background.brand.bold": "--ds-background-brand-bold",
    "color.background.brand.bold.hovered": "--ds-background-brand-bold-hovered",
    "color.background.brand.bold.pressed": "--ds-background-brand-bold-pressed",
    "color.background.brand.boldest": "--ds-background-brand-boldest",
    "color.background.brand.boldest.hovered": "--ds-background-brand-boldest-hovered",
    "color.background.brand.boldest.pressed": "--ds-background-brand-boldest-pressed",
    "color.background.danger": "--ds-background-danger",
    "color.background.danger.hovered": "--ds-background-danger-hovered",
    "color.background.danger.pressed": "--ds-background-danger-pressed",
    "color.background.danger.bold": "--ds-background-danger-bold",
    "color.background.danger.bold.hovered": "--ds-background-danger-bold-hovered",
    "color.background.danger.bold.pressed": "--ds-background-danger-bold-pressed",
    "color.background.warning": "--ds-background-warning",
    "color.background.warning.hovered": "--ds-background-warning-hovered",
    "color.background.warning.pressed": "--ds-background-warning-pressed",
    "color.background.warning.bold": "--ds-background-warning-bold",
    "color.background.warning.bold.hovered": "--ds-background-warning-bold-hovered",
    "color.background.warning.bold.pressed": "--ds-background-warning-bold-pressed",
    "color.background.success": "--ds-background-success",
    "color.background.success.hovered": "--ds-background-success-hovered",
    "color.background.success.pressed": "--ds-background-success-pressed",
    "color.background.success.bold": "--ds-background-success-bold",
    "color.background.success.bold.hovered": "--ds-background-success-bold-hovered",
    "color.background.success.bold.pressed": "--ds-background-success-bold-pressed",
    "color.background.discovery": "--ds-background-discovery",
    "color.background.discovery.hovered": "--ds-background-discovery-hovered",
    "color.background.discovery.pressed": "--ds-background-discovery-pressed",
    "color.background.discovery.bold": "--ds-background-discovery-bold",
    "color.background.discovery.bold.hovered": "--ds-background-discovery-bold-hovered",
    "color.background.discovery.bold.pressed": "--ds-background-discovery-bold-pressed",
    "color.background.information": "--ds-background-information",
    "color.background.information.hovered": "--ds-background-information-hovered",
    "color.background.information.pressed": "--ds-background-information-pressed",
    "color.background.information.bold": "--ds-background-information-bold",
    "color.background.information.bold.hovered": "--ds-background-information-bold-hovered",
    "color.background.information.bold.pressed": "--ds-background-information-bold-pressed",
    "color.blanket": "--ds-blanket",
    "color.blanket.selected": "--ds-blanket-selected",
    "color.blanket.danger": "--ds-blanket-danger",
    "color.interaction.hovered": "--ds-interaction-hovered",
    "color.interaction.pressed": "--ds-interaction-pressed",
    "color.skeleton": "--ds-skeleton",
    "color.skeleton.subtle": "--ds-skeleton-subtle",
    "color.chart.categorical.1": "--ds-chart-categorical-1",
    "color.chart.categorical.1.hovered": "--ds-chart-categorical-1-hovered",
    "color.chart.categorical.2": "--ds-chart-categorical-2",
    "color.chart.categorical.2.hovered": "--ds-chart-categorical-2-hovered",
    "color.chart.categorical.3": "--ds-chart-categorical-3",
    "color.chart.categorical.3.hovered": "--ds-chart-categorical-3-hovered",
    "color.chart.categorical.4": "--ds-chart-categorical-4",
    "color.chart.categorical.4.hovered": "--ds-chart-categorical-4-hovered",
    "color.chart.categorical.5": "--ds-chart-categorical-5",
    "color.chart.categorical.5.hovered": "--ds-chart-categorical-5-hovered",
    "color.chart.categorical.6": "--ds-chart-categorical-6",
    "color.chart.categorical.6.hovered": "--ds-chart-categorical-6-hovered",
    "color.chart.categorical.7": "--ds-chart-categorical-7",
    "color.chart.categorical.7.hovered": "--ds-chart-categorical-7-hovered",
    "color.chart.categorical.8": "--ds-chart-categorical-8",
    "color.chart.categorical.8.hovered": "--ds-chart-categorical-8-hovered",
    "color.chart.lime.bold": "--ds-chart-lime-bold",
    "color.chart.lime.bold.hovered": "--ds-chart-lime-bold-hovered",
    "color.chart.lime.bolder": "--ds-chart-lime-bolder",
    "color.chart.lime.bolder.hovered": "--ds-chart-lime-bolder-hovered",
    "color.chart.lime.boldest": "--ds-chart-lime-boldest",
    "color.chart.lime.boldest.hovered": "--ds-chart-lime-boldest-hovered",
    "color.chart.neutral": "--ds-chart-neutral",
    "color.chart.neutral.hovered": "--ds-chart-neutral-hovered",
    "color.chart.red.bold": "--ds-chart-red-bold",
    "color.chart.red.bold.hovered": "--ds-chart-red-bold-hovered",
    "color.chart.red.bolder": "--ds-chart-red-bolder",
    "color.chart.red.bolder.hovered": "--ds-chart-red-bolder-hovered",
    "color.chart.red.boldest": "--ds-chart-red-boldest",
    "color.chart.red.boldest.hovered": "--ds-chart-red-boldest-hovered",
    "color.chart.orange.bold": "--ds-chart-orange-bold",
    "color.chart.orange.bold.hovered": "--ds-chart-orange-bold-hovered",
    "color.chart.orange.bolder": "--ds-chart-orange-bolder",
    "color.chart.orange.bolder.hovered": "--ds-chart-orange-bolder-hovered",
    "color.chart.orange.boldest": "--ds-chart-orange-boldest",
    "color.chart.orange.boldest.hovered": "--ds-chart-orange-boldest-hovered",
    "color.chart.yellow.bold": "--ds-chart-yellow-bold",
    "color.chart.yellow.bold.hovered": "--ds-chart-yellow-bold-hovered",
    "color.chart.yellow.bolder": "--ds-chart-yellow-bolder",
    "color.chart.yellow.bolder.hovered": "--ds-chart-yellow-bolder-hovered",
    "color.chart.yellow.boldest": "--ds-chart-yellow-boldest",
    "color.chart.yellow.boldest.hovered": "--ds-chart-yellow-boldest-hovered",
    "color.chart.green.bold": "--ds-chart-green-bold",
    "color.chart.green.bold.hovered": "--ds-chart-green-bold-hovered",
    "color.chart.green.bolder": "--ds-chart-green-bolder",
    "color.chart.green.bolder.hovered": "--ds-chart-green-bolder-hovered",
    "color.chart.green.boldest": "--ds-chart-green-boldest",
    "color.chart.green.boldest.hovered": "--ds-chart-green-boldest-hovered",
    "color.chart.teal.bold": "--ds-chart-teal-bold",
    "color.chart.teal.bold.hovered": "--ds-chart-teal-bold-hovered",
    "color.chart.teal.bolder": "--ds-chart-teal-bolder",
    "color.chart.teal.bolder.hovered": "--ds-chart-teal-bolder-hovered",
    "color.chart.teal.boldest": "--ds-chart-teal-boldest",
    "color.chart.teal.boldest.hovered": "--ds-chart-teal-boldest-hovered",
    "color.chart.blue.bold": "--ds-chart-blue-bold",
    "color.chart.blue.bold.hovered": "--ds-chart-blue-bold-hovered",
    "color.chart.blue.bolder": "--ds-chart-blue-bolder",
    "color.chart.blue.bolder.hovered": "--ds-chart-blue-bolder-hovered",
    "color.chart.blue.boldest": "--ds-chart-blue-boldest",
    "color.chart.blue.boldest.hovered": "--ds-chart-blue-boldest-hovered",
    "color.chart.purple.bold": "--ds-chart-purple-bold",
    "color.chart.purple.bold.hovered": "--ds-chart-purple-bold-hovered",
    "color.chart.purple.bolder": "--ds-chart-purple-bolder",
    "color.chart.purple.bolder.hovered": "--ds-chart-purple-bolder-hovered",
    "color.chart.purple.boldest": "--ds-chart-purple-boldest",
    "color.chart.purple.boldest.hovered": "--ds-chart-purple-boldest-hovered",
    "color.chart.magenta.bold": "--ds-chart-magenta-bold",
    "color.chart.magenta.bold.hovered": "--ds-chart-magenta-bold-hovered",
    "color.chart.magenta.bolder": "--ds-chart-magenta-bolder",
    "color.chart.magenta.bolder.hovered": "--ds-chart-magenta-bolder-hovered",
    "color.chart.magenta.boldest": "--ds-chart-magenta-boldest",
    "color.chart.magenta.boldest.hovered": "--ds-chart-magenta-boldest-hovered",
    "color.chart.gray.bold": "--ds-chart-gray-bold",
    "color.chart.gray.bold.hovered": "--ds-chart-gray-bold-hovered",
    "color.chart.gray.bolder": "--ds-chart-gray-bolder",
    "color.chart.gray.bolder.hovered": "--ds-chart-gray-bolder-hovered",
    "color.chart.gray.boldest": "--ds-chart-gray-boldest",
    "color.chart.gray.boldest.hovered": "--ds-chart-gray-boldest-hovered",
    "color.chart.brand": "--ds-chart-brand",
    "color.chart.brand.hovered": "--ds-chart-brand-hovered",
    "color.chart.danger": "--ds-chart-danger",
    "color.chart.danger.hovered": "--ds-chart-danger-hovered",
    "color.chart.danger.bold": "--ds-chart-danger-bold",
    "color.chart.danger.bold.hovered": "--ds-chart-danger-bold-hovered",
    "color.chart.warning": "--ds-chart-warning",
    "color.chart.warning.hovered": "--ds-chart-warning-hovered",
    "color.chart.warning.bold": "--ds-chart-warning-bold",
    "color.chart.warning.bold.hovered": "--ds-chart-warning-bold-hovered",
    "color.chart.success": "--ds-chart-success",
    "color.chart.success.hovered": "--ds-chart-success-hovered",
    "color.chart.success.bold": "--ds-chart-success-bold",
    "color.chart.success.bold.hovered": "--ds-chart-success-bold-hovered",
    "color.chart.discovery": "--ds-chart-discovery",
    "color.chart.discovery.hovered": "--ds-chart-discovery-hovered",
    "color.chart.discovery.bold": "--ds-chart-discovery-bold",
    "color.chart.discovery.bold.hovered": "--ds-chart-discovery-bold-hovered",
    "color.chart.information": "--ds-chart-information",
    "color.chart.information.hovered": "--ds-chart-information-hovered",
    "color.chart.information.bold": "--ds-chart-information-bold",
    "color.chart.information.bold.hovered": "--ds-chart-information-bold-hovered",
    "elevation.surface": "--ds-surface",
    "elevation.surface.hovered": "--ds-surface-hovered",
    "elevation.surface.pressed": "--ds-surface-pressed",
    "elevation.surface.overlay": "--ds-surface-overlay",
    "elevation.surface.overlay.hovered": "--ds-surface-overlay-hovered",
    "elevation.surface.overlay.pressed": "--ds-surface-overlay-pressed",
    "elevation.surface.raised": "--ds-surface-raised",
    "elevation.surface.raised.hovered": "--ds-surface-raised-hovered",
    "elevation.surface.raised.pressed": "--ds-surface-raised-pressed",
    "elevation.surface.sunken": "--ds-surface-sunken",
    "elevation.shadow.overflow": "--ds-shadow-overflow",
    "elevation.shadow.overflow.perimeter": "--ds-shadow-overflow-perimeter",
    "elevation.shadow.overflow.spread": "--ds-shadow-overflow-spread",
    "elevation.shadow.overlay": "--ds-shadow-overlay",
    "elevation.shadow.raised": "--ds-shadow-raised",
    "opacity.disabled": "--ds-opacity-disabled",
    "opacity.loading": "--ds-opacity-loading",
    "utility.UNSAFE.textTransformUppercase": "--ds-UNSAFE-textTransformUppercase",
    "utility.UNSAFE.transparent": "--ds-UNSAFE-transparent",
    "utility.elevation.surface.current": "--ds-elevation-surface-current",
    "border.radius.050": "--ds-border-radius-050",
    "border.radius": "--ds-border-radius",
    "border.radius.100": "--ds-border-radius-100",
    "border.radius.200": "--ds-border-radius-200",
    "border.radius.300": "--ds-border-radius-300",
    "border.radius.400": "--ds-border-radius-400",
    "border.radius.circle": "--ds-border-radius-circle",
    "border.width": "--ds-border-width",
    "border.width.0": "--ds-border-width-0",
    "border.width.indicator": "--ds-border-width-indicator",
    "border.width.outline": "--ds-border-width-outline",
    "space.0": "--ds-space-0",
    "space.025": "--ds-space-025",
    "space.050": "--ds-space-050",
    "space.075": "--ds-space-075",
    "space.100": "--ds-space-100",
    "space.150": "--ds-space-150",
    "space.200": "--ds-space-200",
    "space.250": "--ds-space-250",
    "space.300": "--ds-space-300",
    "space.400": "--ds-space-400",
    "space.500": "--ds-space-500",
    "space.600": "--ds-space-600",
    "space.800": "--ds-space-800",
    "space.1000": "--ds-space-1000",
    "space.negative.025": "--ds-space-negative-025",
    "space.negative.050": "--ds-space-negative-050",
    "space.negative.075": "--ds-space-negative-075",
    "space.negative.100": "--ds-space-negative-100",
    "space.negative.150": "--ds-space-negative-150",
    "space.negative.200": "--ds-space-negative-200",
    "space.negative.250": "--ds-space-negative-250",
    "space.negative.300": "--ds-space-negative-300",
    "space.negative.400": "--ds-space-negative-400",
    "font.body": "--ds-font-body",
    "font.body.large": "--ds-font-body-large",
    "font.body.small": "--ds-font-body-small",
    "font.code": "--ds-font-code",
    "font.heading.large": "--ds-font-heading-large",
    "font.heading.medium": "--ds-font-heading-medium",
    "font.heading.small": "--ds-font-heading-small",
    "font.heading.xlarge": "--ds-font-heading-xlarge",
    "font.heading.xsmall": "--ds-font-heading-xsmall",
    "font.heading.xxlarge": "--ds-font-heading-xxlarge",
    "font.heading.xxsmall": "--ds-font-heading-xxsmall",
    "font.letterSpacing.0": "--ds-font-letterSpacing-0",
    "font.letterSpacing.100": "--ds-font-letterSpacing-100",
    "font.letterSpacing.200": "--ds-font-letterSpacing-200",
    "font.letterSpacing.300": "--ds-font-letterSpacing-300",
    "font.letterSpacing.400": "--ds-font-letterSpacing-400",
    "font.ui": "--ds-font-ui",
    "font.ui.small": "--ds-font-ui-small",
    "font.family.body": "--ds-font-family-body",
    "font.family.code": "--ds-font-family-code",
    "font.family.heading": "--ds-font-family-heading",
    "font.family.monospace": "--ds-font-family-monospace",
    "font.family.sans": "--ds-font-family-sans",
    "font.family.brand": "--ds-font-family-brand",
    "font.size.050": "--ds-font-size-050",
    "font.size.075": "--ds-font-size-075",
    "font.size.100": "--ds-font-size-100",
    "font.size.200": "--ds-font-size-200",
    "font.size.300": "--ds-font-size-300",
    "font.size.400": "--ds-font-size-400",
    "font.size.500": "--ds-font-size-500",
    "font.size.600": "--ds-font-size-600",
    "font.weight.bold": "--ds-font-weight-bold",
    "font.weight.medium": "--ds-font-weight-medium",
    "font.weight.regular": "--ds-font-weight-regular",
    "font.weight.semibold": "--ds-font-weight-semibold",
    "font.lineHeight.1": "--ds-font-lineHeight-1",
    "font.lineHeight.100": "--ds-font-lineHeight-100",
    "font.lineHeight.200": "--ds-font-lineHeight-200",
    "font.lineHeight.300": "--ds-font-lineHeight-300",
    "font.lineHeight.400": "--ds-font-lineHeight-400",
    "font.lineHeight.500": "--ds-font-lineHeight-500",
    "font.lineHeight.600": "--ds-font-lineHeight-600"
};
var $edd06b3c8c8396c5$export$2e2bcd8739ae039 = $edd06b3c8c8396c5$var$tokens;

});


parcelRegister("jJqEb", function(module, exports) {

$parcel$export(module.exports, "getThemePreferences", function () { return $e5d6e3d9d2d8f271$export$dd6aeb7c823fc03d; });
$parcel$export(module.exports, "getThemeOverridePreferences", function () { return $e5d6e3d9d2d8f271$export$5d76d7014f4a5d08; });

var $eetQ9 = parcelRequire("eetQ9");

var $cWK60 = parcelRequire("cWK60");

var $llMdQ = parcelRequire("llMdQ");
var $e5d6e3d9d2d8f271$export$dd6aeb7c823fc03d = function getThemePreferences(themeState) {
    var colorMode = themeState.colorMode, contrastMode = themeState.contrastMode, dark = themeState.dark, light = themeState.light, shape = themeState.shape, spacing = themeState.spacing, typography = themeState.typography;
    var autoColorModeThemes = [
        light,
        dark
    ];
    var themePreferences = [];
    if (colorMode === "auto") {
        if (contrastMode !== "no-preference" && (0, $cWK60.getBooleanFF)("platform.design-system-team.increased-contrast-themes")) autoColorModeThemes.forEach(function(normalTheme) {
            var increasedContrastTheme = (0, $llMdQ.default)(normalTheme);
            if (increasedContrastTheme) autoColorModeThemes.push(increasedContrastTheme);
        });
        themePreferences.push.apply(themePreferences, autoColorModeThemes);
    } else {
        themePreferences.push(themeState[colorMode]);
        if (contrastMode !== "no-preference" && (0, $cWK60.getBooleanFF)("platform.design-system-team.increased-contrast-themes")) {
            var increasedContrastTheme = (0, $llMdQ.default)(themeState[colorMode]);
            if (increasedContrastTheme) themePreferences.push(increasedContrastTheme);
        }
    }
    [
        shape,
        spacing,
        typography
    ].forEach(function(themeId) {
        if (themeId) themePreferences.push(themeId);
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eetQ9)))(new Set(themePreferences));
};
var $e5d6e3d9d2d8f271$export$5d76d7014f4a5d08 = function getThemeOverridePreferences(themeState) {
    var colorMode = themeState.colorMode, dark = themeState.dark, light = themeState.light;
    var themeOverridePreferences = [];
    var themePreferences = colorMode === "auto" ? [
        light,
        dark
    ] : [
        themeState[colorMode]
    ];
    if ((0, $cWK60.getBooleanFF)("platform.design-system-team.border-checkbox_nyoiu")) {
        themePreferences.includes("light") && themeOverridePreferences.push("light-new-input-border");
        themePreferences.includes("dark") && themeOverridePreferences.push("dark-new-input-border");
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($eetQ9)))(new Set(themeOverridePreferences));
};

});
parcelRegister("llMdQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f8b0f7164f2271cf$export$2e2bcd8739ae039; });

var $e6gyJ = parcelRequire("e6gyJ");

var $g4m7u = parcelRequire("g4m7u");
function $f8b0f7164f2271cf$export$2e2bcd8739ae039(themeId) {
    var _Object$entries$find;
    return (_Object$entries$find = Object.entries((0, $g4m7u.default)).find(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($e6gyJ)))(_ref, 2), increasesContrastFor = _ref2[1].increasesContrastFor;
        return increasesContrastFor === themeId;
    })) === null || _Object$entries$find === void 0 ? void 0 : _Object$entries$find[1].id;
}

});


parcelRegister("kRuFa", function(module, exports) {


module.exports = (parcelRequire("eg86f"))((parcelRequire("bRvn3")).resolve("fEfqe")).then(function() {
    return parcelRequire("4oYjC");
});

});


parcelRegister("a0rbC", function(module, exports) {

$parcel$export(module.exports, "getTemplateMetadata", function () { return $6e169f25f7e7eb0d$export$606b2644585d411e; });
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $bKkDu = parcelRequire("bKkDu");
var $6e169f25f7e7eb0d$export$606b2644585d411e = function(param) {
    var route = param.route, templates = param.templates, collections = param.collections;
    var matcher = Object.values((0, $bKkDu.LoaderMatchers)).find(function(loader) {
        return loader.match.test(route);
    });
    if (!matcher) throw new Error("No metadata loader matcher found for route ".concat(route));
    var matchGroup = matcher.match.exec(route);
    var urlSlug = "";
    if (matchGroup && matchGroup.groups) urlSlug = matchGroup.groups["urlSlug"];
    if (matcher.getPageMetadata) return matcher.getPageMetadata({
        templates: templates,
        collections: collections,
        urlSlug: urlSlug
    });
    return;
};

});
parcelRegister("bKkDu", function(module, exports) {

$parcel$export(module.exports, "LoaderMatchers", function () { return $45a587ad9e0f0fe8$export$6a8ace3b32415e83; });

var $3mjl2 = parcelRequire("3mjl2");
var $45a587ad9e0f0fe8$export$6a8ace3b32415e83 = [
    {
        match: /templates$/,
        name: "confluence-templates-page"
    },
    {
        match: /templates\/search$/,
        name: "confluence-template-search-page"
    },
    {
        match: RegExp("templates\\/(?<urlSlug>[a-z0-9-]+)$"),
        name: "confluence-template-details-page",
        getPageMetadata: function(param) {
            var templates = param.templates, urlSlug = param.urlSlug;
            var template = templates === null || templates === void 0 ? void 0 : templates.find(function(template) {
                return template.urlSlug === urlSlug;
            });
            return template ? {
                title: template === null || template === void 0 ? void 0 : template.name,
                description: template === null || template === void 0 ? void 0 : template.oneLinerHeadline,
                titleSuffix: "template"
            } : undefined;
        }
    },
    {
        match: RegExp("templates\\/collections\\/(?<urlSlug>[a-z0-9-]+)$"),
        name: "confluence-template-collection-details-page",
        getPageMetadata: function(param) {
            var collections = param.collections, urlSlug = param.urlSlug;
            var collection = collections === null || collections === void 0 ? void 0 : collections.find(function(collection) {
                return collection.urlSlug === urlSlug;
            });
            return collection ? {
                title: collection === null || collection === void 0 ? void 0 : collection.name,
                description: collection === null || collection === void 0 ? void 0 : collection.oneLinerHeadline,
                titleSuffix: "collection"
            } : undefined;
        }
    },
    {
        match: RegExp("templates\\/categories\\/(?<urlSlug>[a-z0-9-]+)$"),
        name: "confluence-template-category-page",
        getPageMetadata: function(param) {
            var urlSlug = param.urlSlug;
            // use testCategoriesData for now
            var category = (0, $3mjl2.testCategoriesData).find(function(category) {
                return category.urlSlug === urlSlug;
            });
            return category ? {
                title: category === null || category === void 0 ? void 0 : category.pageTitle,
                description: category === null || category === void 0 ? void 0 : category.shortDescriptionOneLiner
            } : undefined;
        }
    }
];

});
parcelRegister("3mjl2", function(module, exports) {

$parcel$export(module.exports, "testCategoriesData", function () { return $df811296183fbbc0$export$2b52c791239006bd; });
$parcel$export(module.exports, "testPartnerTemplatesData", function () { return $df811296183fbbc0$export$88e216f6036b695f; });
var $df811296183fbbc0$export$2b52c791239006bd = [
    {
        id: "7ckISKU5UGRFKMEQyFfmH1",
        name: "Featured",
        urlSlug: "featured",
        shortDescriptionOneLiner: "Check out the latest and greatest templates from Confluence Cloud.",
        pageTitle: "Featured Confluence Templates",
        description: null
    },
    {
        id: "7ckISKU5UGRFKMEQyFfmH2",
        name: "Partners",
        urlSlug: "partners",
        shortDescriptionOneLiner: "Learn how the pros do it with templates from our partners.",
        pageTitle: "Partner Templates",
        description: null
    },
    {
        id: "3L5l3wY9ZWRYMqVpAewmcG",
        name: "Business Strategy",
        urlSlug: "business-strategy",
        shortDescriptionOneLiner: "Identify goals, assess risks, and implement business tactics with these business strategy templates.",
        pageTitle: "Business Strategy Templates",
        description: null
    },
    {
        id: "3L5l3wY9ZWRYMqVpAewmcr",
        name: "Design",
        urlSlug: "design",
        shortDescriptionOneLiner: "Use Confluence\u2019s collection of design templates to create design systems, brainstorm ideas, and run design sprints like an expert.",
        pageTitle: "Design Templates",
        description: null
    },
    {
        id: "3L5l3wY9ZWRYMqVpAewmc1",
        name: "Docs & Reports",
        urlSlug: "docs-and-reports",
        shortDescriptionOneLiner: "Improve documentation and create great reports to share with your team and other stakeholders.",
        pageTitle: "Docs & Reports Templates",
        description: null
    },
    {
        id: "3L5l3wY9ZWRYMqVpAewmc2",
        name: "Human Resources",
        urlSlug: "human-resources",
        shortDescriptionOneLiner: "Simplify recruiting and employee development with these Confluence templates for HR pros.",
        pageTitle: "Human Resources Templates",
        description: null
    },
    {
        id: "3L5l3wY9ZWRYMqVpAewmc3",
        name: "Marketing & Sales",
        urlSlug: "marketing-and-sales",
        shortDescriptionOneLiner: "Write a creative brief, craft user personas, coordinate campaigns, and a whole lot more. Check out our top marketing and sales templates here.",
        pageTitle: "Marketing & Sales Templates",
        description: null
    },
    {
        id: "3L5l3wY9ZWRYMqVpAewmc4",
        name: "Personal",
        urlSlug: "personal",
        shortDescriptionOneLiner: "Jot down notes, organize your work, and much more in the safe space of Confluence.",
        pageTitle: "Personal Templates",
        description: null
    },
    {
        id: "5K1kNHZzKqwQBpU3XThCQW",
        name: "Product Management",
        urlSlug: "product-management",
        shortDescriptionOneLiner: "Master the product management lifecycle from brainstorming to launch with templates tailor-made for PMs.",
        pageTitle: "Product Management Templates",
        description: null
    },
    {
        id: "5K1kNHZzKqwQBpU3XThCQ1",
        name: "Productivity",
        urlSlug: "productivity",
        shortDescriptionOneLiner: "Keep track of where you're going and what you need to accomplish with our productivity templates, including to-do lists, meeting notes and more.",
        pageTitle: "Productivity Templates",
        description: null
    },
    {
        id: "5K1kNHZzKqwQBpU3XThCQ2",
        name: "Project Planning",
        urlSlug: "project-planning",
        shortDescriptionOneLiner: "Oversee projects, report progress, and prepare for project deadlines and launches.",
        pageTitle: "Project Planning Templates",
        description: null
    },
    {
        id: "5K1kNHZzKqwQBpU3XThCQ3",
        name: "Software Development / IT",
        urlSlug: "software-development",
        shortDescriptionOneLiner: "Support your engineering team and develop products faster with our software and IT templates.",
        pageTitle: "Software Development / IT Templates",
        description: null
    },
    {
        id: "5lnoDFfbaQh3DA2Ajm9WSH",
        name: "Startup",
        urlSlug: "startup",
        shortDescriptionOneLiner: "Get started with resources for early-stage companies to help your team scale.",
        pageTitle: "Startup Templates",
        description: null
    },
    {
        id: "5lnoDFfbaQh3DA2Ajm9WS1",
        name: "Teamwork",
        urlSlug: "teamwork",
        shortDescriptionOneLiner: "Monitor the health of your teams and organize meeting minutes and notes.",
        pageTitle: "Teamwork Templates",
        description: null
    }
];
var $df811296183fbbc0$export$88e216f6036b695f = [
    {
        templateId: "tXbjwEb4mL6WURJ4cq411",
        name: "Team homepage",
        urlSlug: "team-homepage",
        partnerDescription: "Invite your organization at large to get to know your team.",
        contributor: {
            name: "Atlassian",
            logo: [
                {
                    name: "atlassian-logo",
                    size: 4833,
                    url: "https://wac-cdn.atlassian.com/dam/jcr:97f4fdbe-96d6-4c84-9ad3-e6f597d9ba37/logos-Atlassian-horizontal-blue-onecolor-rgb.svg?cdnVersion=1392",
                    height: 109,
                    width: 460
                }
            ]
        },
        previewBlurb: "Invite your organization at large to get to know your team.",
        templateIcon: {
            name: "hubspot logo",
            size: 4833,
            url: "https://wac-cdn.atlassian.com/dam/jcr:291bfa36-a57d-4f00-8bc1-502fccdf1cca/hubspot-logo-full.png?cdnVersion=1426",
            height: 64,
            width: 64
        },
        partnerImage: {
            name: "hubspot",
            size: 1137,
            url: "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/templates/partner-hubspot-media-kit.webp",
            height: 64,
            width: 64
        }
    },
    {
        templateId: "2WbcCVrA7SH6ZVuXCsyDtu",
        name: "Job description",
        urlSlug: "job-description",
        partnerDescription: "Finding the right talent starts here.",
        contributor: {
            name: "Indeed",
            logo: [
                {
                    name: "indeed-logo-full",
                    size: 74906,
                    url: "//images.ctfassets.net/xjcz23wx147q/49VpFL28CtHeNkuSH2F9lP/30d40c925537d3953199ca05ec30a9af/indeed-logo-full.svg",
                    height: 201,
                    width: 731
                }
            ]
        },
        previewBlurb: "Use this template to build job descriptions that will attract the highest quality candidates.",
        templateIcon: {
            name: "hiring-process",
            size: 6317,
            url: "https://wac-cdn.atlassian.com/dam/jcr:641d5550-46de-4938-8028-eb39e9c48f82/indeed-logo-full.svg?cdnVersion=1426",
            height: 64,
            width: 64
        },
        partnerImage: {
            name: "indeed",
            size: 1137,
            url: "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/templates/partner-indeed-unsplash.webp",
            height: 64,
            width: 64
        }
    },
    {
        templateId: "tXbjwEb4mL6WURJ4cq41D",
        name: "Experiment plan and results",
        urlSlug: "experiment-plan-and-results",
        partnerDescription: "Streamline your process and improve your business.",
        contributor: {
            name: "Optimizely",
            logo: [
                {
                    name: "optimizely-logo",
                    size: 4833,
                    url: "//images.ctfassets.net/xjcz23wx147q/6UgZ8U62VhRebuxWTC6fx3/31d9d8888ef58eb6d73cfdb6c3e66570/optimizely-logo.png",
                    height: 109,
                    width: 460
                }
            ]
        },
        previewBlurb: "Document the details of your experiment including your hypothesis, variations, and results.",
        templateIcon: {
            name: "Optimizely logo",
            size: 420871,
            url: "https://wac-cdn.atlassian.com/dam/jcr:e2ed4cbc-94fd-494f-a04b-9646b797ef25/optimizely-logo-full.png?cdnVersion=1426",
            height: 64,
            width: 64
        },
        partnerImage: {
            name: "optimizely",
            size: 1137,
            url: "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/templates/partner-optimizely-unsplash.webp",
            height: 64,
            width: 64
        }
    },
    {
        templateId: "tXbjwEb4mL6WURJ4cq413",
        name: "Design sprint ",
        urlSlug: "design-sprint",
        partnerDescription: "Run a well-planned print, understand design problems and brainstorm solutions. ",
        contributor: {
            name: "Figma",
            logo: [
                {
                    name: "figma-logo",
                    size: 4833,
                    url: "https://wac-cdn.atlassian.com/dam/jcr:3a696f17-0629-4a92-895b-cdaf3fdd3d08/figma-logo-full.svg?cdnVersion=1392",
                    height: 109,
                    width: 460
                }
            ]
        },
        previewBlurb: "Run a well-planned print, understand design problems and brainstorm solutions. ",
        templateIcon: {
            name: "figma logo",
            size: 420871,
            url: "https://wac-cdn.atlassian.com/dam/jcr:3a696f17-0629-4a92-895b-cdaf3fdd3d08/figma-logo-full.svg?cdnVersion=1392",
            height: 64,
            width: 64
        },
        partnerImage: {
            name: "figma",
            size: 1137,
            url: "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/templates/partner-figma-unsplash.webp",
            height: 64,
            width: 64
        }
    },
    {
        templateId: "38qTifwO0eMcG6r8Idr2c1",
        name: " Customer impact assessment",
        urlSlug: "customer-impact-assessment",
        partnerDescription: "Make a change with zero pain with the right process. ",
        contributor: {
            name: "ZENDESK",
            logo: [
                {
                    name: "zendesk-logo",
                    size: 34708,
                    url: "https://wac-cdn.atlassian.com/dam/jcr:6c868fb8-1f02-467b-b5a5-799502e17d82/zendesk-logo-full.png?cdnVersion=1418"
                }
            ]
        },
        previewBlurb: "Make a change with zero pain with the right process. ",
        templateIcon: {
            name: "Brainstorming icon",
            size: 9247,
            url: "https://wac-cdn.atlassian.com/dam/jcr:6c868fb8-1f02-467b-b5a5-799502e17d82/zendesk-logo-full.png?cdnVersion=1418",
            height: 236,
            width: 248
        },
        partnerImage: {
            name: "zendesk",
            size: 1137,
            url: "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/templates/partner-zendesk-unsplash.webp",
            height: 64,
            width: 64
        }
    },
    {
        templateId: "3iLfGIDUjhn3vSBpnpzcNM",
        name: "Project status",
        urlSlug: "project-status",
        partnerDescription: "Easily update your teams on project status using Confluence and Jira data.",
        contributor: {
            name: "Arizona State University",
            logo: [
                {
                    name: "arizona-state-university-logo",
                    size: 11030,
                    url: "//images.ctfassets.net/xjcz23wx147q/5JVzU07vgxDAgmfK1PQLS6/5ff1f25fd7df230329bc97219c35da6e/arizona-state-university-asu.svg",
                    height: 595,
                    width: 1813
                }
            ]
        },
        previewBlurb: "Easily report progress on your projects to stakeholders using Confluence and Jira together.",
        templateIcon: {
            name: "project-status-icon",
            size: 12929,
            url: "https://wac-cdn.atlassian.com/dam/jcr:73018d7a-83da-4c25-8be3-aa078e37a560/asu-logo-full.png?cdnVersion=1426",
            height: 64,
            width: 64
        },
        partnerImage: {
            name: "arizonastateuniversity",
            size: 1137,
            url: "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/templates/partner-asu-media-kit.webp",
            height: 64,
            width: 64
        }
    },
    {
        templateId: "38qTifwO0eMcG6r8Idr2cH",
        name: "Brainstorming",
        urlSlug: "brainstorming",
        partnerDescription: " Lead a super productive brainstorming session.",
        contributor: {
            name: "MURAL",
            logo: [
                {
                    name: "mural-logo",
                    size: 34708,
                    url: "//images.ctfassets.net/xjcz23wx147q/6HaL8jfJ8lZV0pPTuFarDS/12db840ecd288b695bf4601c2102c5e2/mural-139x26.svg"
                }
            ]
        },
        previewBlurb: "Lead a super productive brainstorming session",
        templateIcon: {
            name: "Brainstorming icon",
            size: 9247,
            url: "https://wac-cdn.atlassian.com/dam/jcr:642ced63-c988-4f5f-9ec4-34e0757d7d61/mural-logo-full.svg?cdnVersion=1426",
            height: 236,
            width: 248
        },
        partnerImage: {
            name: "Brainstorming",
            size: 1137,
            url: "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/templates/partner-mural-media-kit.webp",
            height: 64,
            width: 64
        }
    },
    {
        templateId: "01p85VZkOsDbJaRMrZjqzW",
        name: "Business plan one-pager",
        urlSlug: "business-plan-one-pager",
        partnerDescription: "Set your strategy (and stick to it) with a short and simple plan.",
        contributor: {
            name: "Isos Technology",
            logo: [
                {
                    name: "isos-logo",
                    size: 7862,
                    url: "//images.ctfassets.net/xjcz23wx147q/6sRPBfEdDyxaNiPh5scG7K/d92019fc67cabc1327bd18c5d0a247b5/isos-logo-full.png",
                    height: 225,
                    width: 800
                }
            ]
        },
        previewBlurb: "Set your strategy (and stick to it) with a short and simple plan",
        templateIcon: {
            name: "Isos logo",
            size: 8506,
            url: "https://wac-cdn.atlassian.com/dam/jcr:f0618907-7568-4e07-8485-400262b22783/isos-logo-full.png?cdnVersion=1426",
            height: 250,
            width: 212
        },
        partnerImage: {
            name: "isostech",
            size: 1137,
            url: "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/templates/partner-isos-unsplash.webp",
            height: 64,
            width: 64
        }
    },
    {
        templateId: "Aen4GRrwytCXzfh3VGboA",
        name: "AWS architecture diagram",
        urlSlug: "aws-architecture-diagram",
        partnerDescription: "Visualize your AWS network with this guide from Lucidchart\u2019s.",
        contributor: {
            name: "Lucidchart",
            logo: [
                {
                    name: "lucidchart-logo-full",
                    size: 8025,
                    url: "//images.ctfassets.net/xjcz23wx147q/2FoqenBRbSpjDs8tG0842m/aa85152afba56f04c3b2e70e9d1f6022/lucidchart-logo-full.png",
                    height: 150,
                    width: 600
                },
                {
                    name: "lucidchat-pictorial-logo",
                    size: 2841,
                    url: "//images.ctfassets.net/xjcz23wx147q/48Wzj474xufBid0gFLHItY/e8175b3a56c0b6a56063c17e8def0558/aws-architecture-diagram.svg",
                    height: 64,
                    width: 64
                }
            ]
        },
        previewBlurb: "Visualize your AWS network with this guide from Lucidchart",
        templateIcon: {
            name: "lucidchat-pictorial-logo",
            size: 2841,
            url: "https://wac-cdn.atlassian.com/dam/jcr:69741a41-0dcf-4e4e-ad1b-94ac8720bb0e/lucidchart-logo-full.png?cdnVersion=1426",
            height: 64,
            width: 64
        },
        partnerImage: {
            name: "lucidchart",
            size: 1137,
            url: "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/templates/partner-lucidchart-unsplash.webp",
            height: 64,
            width: 64
        }
    },
    {
        templateId: "2lGZVe8PSvCrXFIjT4w4tC",
        name: "Risk assessment matrix",
        urlSlug: "risk-assessment",
        partnerDescription: "Identify, prioritize, plan for (and avoid) worst-case scenarios.",
        contributor: {
            name: "Stiltsoft",
            logo: [
                {
                    name: "stiltsoft-logo-full",
                    size: 3822,
                    url: "//images.ctfassets.net/xjcz23wx147q/5q6RcuZ7KD8K0DT8OQs2w4/b249a1d8810e85d6f8378464b92d2333/stiltsoft-logo-full.svg",
                    height: 63,
                    width: 474
                }
            ]
        },
        previewBlurb: "Identify and prioritize risks, then define what further actions you need to take to control.",
        templateIcon: {
            name: "risk-assessment-icon",
            size: 11682,
            url: "https://wac-cdn.atlassian.com/dam/jcr:05d75cb9-faf0-4ebe-8b11-707adc1dbf58/stiltsoft-logo-full.svg?cdnVersion=1426",
            height: 64,
            width: 64
        },
        partnerImage: {
            name: "Stiltsoft",
            size: 1137,
            url: "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/templates/partner-stiltsoft-unsplash.webp",
            height: 64,
            width: 64
        }
    },
    {
        templateId: "tXbjwEb4mL6WURJ4cq412",
        name: "Team poster",
        urlSlug: "team-poster",
        partnerDescription: "Invite your organization at large to get to know your team.",
        contributor: {
            name: "Atlassian",
            logo: [
                {
                    name: "atlassian-logo",
                    size: 4833,
                    url: "https://wac-cdn.atlassian.com/dam/jcr:97f4fdbe-96d6-4c84-9ad3-e6f597d9ba37/logos-Atlassian-horizontal-blue-onecolor-rgb.svg?cdnVersion=1392",
                    height: 109,
                    width: 460
                }
            ]
        },
        previewBlurb: "Invite your organization at large to get to know your team.",
        templateIcon: {
            name: "Atlassian logo",
            size: 420871,
            url: "https://wac-cdn.atlassian.com/dam/jcr:97f4fdbe-96d6-4c84-9ad3-e6f597d9ba37/logos-Atlassian-horizontal-blue-onecolor-rgb.svg?cdnVersion=1426",
            height: 64,
            width: 64
        },
        partnerImage: {
            name: "atlassian",
            size: 1137,
            url: "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/templates/partner-hubspot-thumbnail.webp",
            height: 64,
            width: 64
        }
    }
];

});




parcelRegister("af5n8", function(module, exports) {

$parcel$export(module.exports, "useLoggedInUser", function () { return $e5a668784bc2c9e9$export$aae23f3a65fbe750; });
$parcel$export(module.exports, "LoggedInUserProvider", function () { return $e5a668784bc2c9e9$export$164e91ee1eedc9fa; });

var $kSuI9 = parcelRequire("kSuI9");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $cv9Rk = parcelRequire("cv9Rk");

var $l29cN = parcelRequire("l29cN");

var $1rY3h = parcelRequire("1rY3h");

var $1Mpn7 = parcelRequire("1Mpn7");
parcelRequire("eb65f");
var $8JWVu = parcelRequire("8JWVu");

var $7Y96P = parcelRequire("7Y96P");
var $e5a668784bc2c9e9$var$DEFAULT_USER_STATE = {
    isUserLoggedIn: false,
    requestInProgress: true
};
var $e5a668784bc2c9e9$var$LoggedInUserContext = /*#__PURE__*/ (0, $1Mpn7.createContext)((0, $do9pw._)({}, $e5a668784bc2c9e9$var$DEFAULT_USER_STATE));
var $e5a668784bc2c9e9$export$aae23f3a65fbe750 = function() {
    var context = (0, $1Mpn7.useContext)($e5a668784bc2c9e9$var$LoggedInUserContext);
    if (!context) throw new Error("calls to useLoggedInUser must be wrapped in <LoggedInUserProvider>");
    return context;
};
var $e5a668784bc2c9e9$export$164e91ee1eedc9fa = function(param) {
    var children = param.children;
    var stargateClient = (0, $8JWVu.useBxpWebStargateClient)();
    var _useState = (0, $cv9Rk._)((0, $1Mpn7.useState)((0, $do9pw._)({}, $e5a668784bc2c9e9$var$DEFAULT_USER_STATE)), 2), loggedInUserInstance = _useState[0], setLoggedInUserInstance = _useState[1];
    (0, $1Mpn7.useEffect)(function() {
        (0, $1Mpn7.startTransition)(function() {
            if ((0, $7Y96P.Cookie).readCookie("login_user_detected") !== "true") {
                // If logged in user cookie isn't present, then we don't need to make a call to stargate.
                // This cookie is set by bxp-gateway to determine if the user is logged in or not.
                setLoggedInUserInstance((0, $cxjpp._)((0, $do9pw._)({}, $e5a668784bc2c9e9$var$DEFAULT_USER_STATE), {
                    requestInProgress: false
                }));
                return;
            }
            var getUserProfile = function() {
                var _ref = (0, $kSuI9._)(function() {
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    stargateClient.me({})
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                });
                return function getUserProfile() {
                    return _ref.apply(this, arguments);
                };
            }();
            getUserProfile().then(function(userProfile) {
                setLoggedInUserInstance((0, $do9pw._)({
                    requestInProgress: false,
                    isUserLoggedIn: true
                }, userProfile));
            }).catch(function(e) {
                console.warn("Error getting user profile: ", e);
                setLoggedInUserInstance((0, $cxjpp._)((0, $do9pw._)({}, $e5a668784bc2c9e9$var$DEFAULT_USER_STATE), {
                    requestInProgress: false
                }));
            });
        });
    }, [
        stargateClient
    ]);
    return /*#__PURE__*/ (0, $1rY3h.jsx)($e5a668784bc2c9e9$var$LoggedInUserContext.Provider, {
        value: loggedInUserInstance,
        children: children
    });
};

});

parcelRegister("idnzS", function(module, exports) {

$parcel$export(module.exports, "getFeatureFlagValues", function () { return $728cc0bafe37e080$export$e65c18714c4363a3; });
$parcel$export(module.exports, "parseRoute", function () { return $728cc0bafe37e080$export$9bf1c8c94a38f6fb; });

var $cv9Rk = parcelRequire("cv9Rk");
parcelRequire("k24nj");
var $5FngR = parcelRequire("5FngR");

var $aTcOY = parcelRequire("aTcOY");
var $728cc0bafe37e080$export$e65c18714c4363a3 = function(params) {
    // set defaults for feature flags
    var featureFlags = {
        enableBundlesAfterSignup: false,
        enableCutSignUpStepsInHalf: false,
        enableConfirmationPageOverlay: (0, $5FngR.ConfirmationPageOverlayVariants).UNENROLLED,
        provisionSecondPartyApps: false
    };
    params[0] && (params[0] = params[0].replace(/^\?(.+)/, "$1"));
    params.forEach(function(param) {
        var _param_split = (0, $cv9Rk._)(param.split("="), 2), key = _param_split[0], value = _param_split[1];
        switch(key){
            case "provisionSecondPartyApps":
                if (value === "enableProvisionSecondPartyApps") featureFlags.provisionSecondPartyApps = true;
                break;
            case "bundles_treatment":
                if (value === "bundles_after_signup") featureFlags.enableBundlesAfterSignup = true;
                break;
            case "enable_cut_sign_up_flow_in_half_variant":
                if (value === "expcen_2603_enable_cut_sign_up_flow_in_half_variant") featureFlags.enableCutSignUpStepsInHalf = true;
                break;
            case "bundles_post_signup_variation_conf":
                if (value === "bundles_post_signup_conf") featureFlags.enableConfirmationPageOverlay = (0, $5FngR.ConfirmationPageOverlayVariants).BUNDLES_MODAL;
                break;
            case "video_overlay_post_signup_variation_conf":
                if (value === "video_overlay_post_signup_conf") featureFlags.enableConfirmationPageOverlay = (0, $5FngR.ConfirmationPageOverlayVariants).VIDEO_OVERLAY;
                break;
            case "bundles_post_signup_control_conf":
                if (value === "bundles_post_signup_control_conf") featureFlags.enableConfirmationPageOverlay = (0, $5FngR.ConfirmationPageOverlayVariants).CONTROL;
                break;
        }
    });
    return featureFlags;
};
var $728cc0bafe37e080$export$9bf1c8c94a38f6fb = function(location) {
    var _params_filter_;
    // remove all leading slashes (server had 2 leading slashes, client has 1)
    var noSlashPrefixPath = location.pathname.replace(/^\/+/, "");
    if (noSlashPrefixPath === "index.html") // case for the unlocalized home page
    return {
        locale: "en",
        path: "",
        variant: undefined,
        search: "",
        featureFlags: {}
    };
    // check if the route has a locale prefix
    var potentialLocale = noSlashPrefixPath.split("/")[0] || "";
    var localeIsValid = (0, $aTcOY.isValidLocale)(potentialLocale);
    // if there is a locale prefix, set the locale variable and remove the prefix from the path
    // otherwise, set the locale to the default (en) and leave the path as is
    var locale = localeIsValid ? potentialLocale : "en";
    var cleanedPath = localeIsValid ? noSlashPrefixPath.slice(locale.length + 1) : noSlashPrefixPath;
    var params = location.search.split("&");
    var cmsVariantValue = (_params_filter_ = params.filter(function(param) {
        return param.includes("cmsVariant");
    })[0]) === null || _params_filter_ === void 0 ? void 0 : _params_filter_.split("=")[1];
    var featureFlags = $728cc0bafe37e080$export$e65c18714c4363a3(params);
    return {
        path: cleanedPath,
        variant: cmsVariantValue,
        locale: locale,
        search: location.search,
        featureFlags: featureFlags
    };
};

});
parcelRegister("k24nj", function(module, exports) {
$parcel$export(module.exports, "CloudStatusProvider", function () { return (parcelRequire("5FngR")).CloudStatusProvider; });
$parcel$export(module.exports, "ConfirmationPageOverlayVariants", function () { return (parcelRequire("5FngR")).ConfirmationPageOverlayVariants; });
$parcel$export(module.exports, "useCloudStatus", function () { return (parcelRequire("5FngR")).useCloudStatus; });
$parcel$export(module.exports, "useConfirmationPageOverlayModal", function () { return (parcelRequire("5FngR")).useConfirmationPageOverlayModal; });
$parcel$export(module.exports, "PageOverlayModalProvider", function () { return (parcelRequire("gGKHl")).PageOverlayModalProvider; });
$parcel$export(module.exports, "usePageOverlayModal", function () { return (parcelRequire("gGKHl")).usePageOverlayModal; });
$parcel$export(module.exports, "useFetchUserSegmentData", function () { return (parcelRequire("2DsRs")).useFetchUserSegmentData; });
$parcel$export(module.exports, "FreeBundlesStatusProvider", function () { return (parcelRequire("iTEfn")).FreeBundlesStatusProvider; });
$parcel$export(module.exports, "useFreeBundlesStatus", function () { return (parcelRequire("iTEfn")).useFreeBundlesStatus; });
$parcel$export(module.exports, "useFreeBundles", function () { return (parcelRequire("JxlmM")).useFreeBundles; });
$parcel$export(module.exports, "JiraTemplateChoiceProvider", function () { return (parcelRequire("9bye2")).JiraTemplateChoiceProvider; });
$parcel$export(module.exports, "useJiraTemplateChoice", function () { return (parcelRequire("9bye2")).useJiraTemplateChoice; });
$parcel$export(module.exports, "useSearchParameters", function () { return (parcelRequire("cqkTt")).useSearchParameters; });
$parcel$export(module.exports, "useUserSegmentationStatus", function () { return (parcelRequire("aVmvD")).useUserSegmentationStatus; });
$parcel$export(module.exports, "useTipsViewType", function () { return (parcelRequire("ksfH5")).useTipsViewType; });
$parcel$export(module.exports, "useProductKeys", function () { return (parcelRequire("6911k")).useProductKeys; });

$parcel$export(module.exports, "useConfirmationPageType", function () { return (parcelRequire("7fxFq")).default; });
parcelRequire("5FngR");
parcelRequire("gGKHl");
parcelRequire("2DsRs");
parcelRequire("iTEfn");
parcelRequire("JxlmM");
parcelRequire("9bye2");
parcelRequire("cqkTt");
parcelRequire("aVmvD");

var $7fxFq = parcelRequire("7fxFq");
parcelRequire("ksfH5");
parcelRequire("6911k");

});
parcelRegister("5FngR", function(module, exports) {

$parcel$export(module.exports, "ConfirmationPageOverlayVariants", function () { return $5e8b75e987a7e230$export$b4cb79dd3839e78d; });
$parcel$export(module.exports, "useCloudStatus", function () { return $5e8b75e987a7e230$export$5ef42433186f4316; });
$parcel$export(module.exports, "CloudStatusProvider", function () { return $5e8b75e987a7e230$export$9a4cb48cb61f091b; });
$parcel$export(module.exports, "useConfirmationPageOverlayModal", function () { return $5e8b75e987a7e230$export$48e0416fa20ddf0c; });

var $kSuI9 = parcelRequire("kSuI9");

var $cv9Rk = parcelRequire("cv9Rk");

var $l29cN = parcelRequire("l29cN");

var $1rY3h = parcelRequire("1rY3h");

var $1Mpn7 = parcelRequire("1Mpn7");

var $145N3 = parcelRequire("145N3");
parcelRequire("eb65f");
var $8JWVu = parcelRequire("8JWVu");
parcelRequire("3nMqF");
var $1PgDH = parcelRequire("1PgDH");
var $bp6Uh = parcelRequire("bp6Uh");
parcelRequire("k24nj");
var $cqkTt = parcelRequire("cqkTt");
var $iTEfn = parcelRequire("iTEfn");
var $aVmvD = parcelRequire("aVmvD");
var $7fxFq = parcelRequire("7fxFq");
var $9bye2 = parcelRequire("9bye2");
var $5e8b75e987a7e230$export$7bd623b29ec8e1eb = 600000;
var $5e8b75e987a7e230$export$107dbe6386f6c087 = 5000;
var $5e8b75e987a7e230$export$bf10a6f24dd9d3e2 = "pending";
var $5e8b75e987a7e230$export$b4cb79dd3839e78d;
(function(ConfirmationPageOverlayVariants) {
    ConfirmationPageOverlayVariants["BUNDLES_MODAL"] = "bundles_modal";
    ConfirmationPageOverlayVariants["VIDEO_OVERLAY"] = "video_overlay";
    ConfirmationPageOverlayVariants["CONTROL"] = "control";
    ConfirmationPageOverlayVariants["UNENROLLED"] = "unenrolled";
})($5e8b75e987a7e230$export$b4cb79dd3839e78d || ($5e8b75e987a7e230$export$b4cb79dd3839e78d = {}));
function $5e8b75e987a7e230$export$5ef42433186f4316() {
    return (0, $1Mpn7.useContext)($5e8b75e987a7e230$var$CloudStatusContext);
}
var $5e8b75e987a7e230$var$CloudStatusContext = /*#__PURE__*/ (0, $1Mpn7.createContext)({
    isReferredFromVerifyEmail: false,
    createCloudStatus: $5e8b75e987a7e230$export$bf10a6f24dd9d3e2,
    progress: 0,
    featureFlags: {
        provisionSecondPartyApps: false,
        enableBundlesAfterSignup: false
    },
    deferRedirect: false,
    redirectUrl: ""
});
function $5e8b75e987a7e230$var$getProgressbarStatus(param) {
    var startTime = param.startTime, pivotPercentage = param.pivotPercentage, progressBarPivotPoint = param.progressBarPivotPoint, slowProgressIncrement = param.slowProgressIncrement, slowProgress = param.slowProgress, interval = param.interval;
    var currentTime = Date.now();
    var elapsedTime = currentTime - startTime;
    if (elapsedTime >= $5e8b75e987a7e230$export$7bd623b29ec8e1eb) {
        // @ts-ignore
        clearInterval(interval);
        return 1;
    } else if (elapsedTime <= progressBarPivotPoint) {
        var rapidProgress = pivotPercentage / progressBarPivotPoint * elapsedTime;
        return rapidProgress;
    } else {
        slowProgress = slowProgress == 0 ? pivotPercentage : slowProgress + slowProgressIncrement;
        return slowProgress;
    }
}
var $5e8b75e987a7e230$export$9a4cb48cb61f091b = function(param) {
    var _param_retryInterval = param.retryInterval, retryInterval = _param_retryInterval === void 0 ? $5e8b75e987a7e230$export$107dbe6386f6c087 : _param_retryInterval, _param_timeout = param.timeout, timeout = _param_timeout === void 0 ? $5e8b75e987a7e230$export$7bd623b29ec8e1eb : _param_timeout, _param_isProduction = param.isProduction, isProduction = _param_isProduction === void 0 ? false : _param_isProduction, children = param.children, featureFlags = param.featureFlags, provisioningRequestId = param.provisioningRequestId, onDemandUrl = param.onDemandUrl, cloudIdProp = param.cloudId, platform = param.platform, requestId = param.requestId;
    var cofsClient = (0, $1PgDH.useCofsClient)();
    var stargateClient = (0, $8JWVu.useBxpWebStargateClient)();
    var createAnalyticsEvent = (0, $145N3.useAnalyticsEvents)().createAnalyticsEvent;
    var _useSearchParameters = (0, $cqkTt.useSearchParameters)(), referrer = _useSearchParameters.referrer, products = _useSearchParameters.products, siteRenameRequestId = _useSearchParameters.siteRenameRequestId, dataRegion = _useSearchParameters.dataRegion, admin = _useSearchParameters.admin, isFoundingAdmin = _useSearchParameters.isFoundingAdmin, signupSource = _useSearchParameters.signupSource, provisionApp = _useSearchParameters.provisionApp, appKey = _useSearchParameters.appKey;
    var isProductJsw = products.length === 1 && products.includes("jira-software.ondemand");
    var isProductConfluence = products.length === 1 && products.includes("confluence.ondemand");
    var isFreeBundlesEnabled = (featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.enableBundlesAfterSignup) && isProductJsw;
    var is15secondProvisioningEnabled = isProductJsw || isProductConfluence;
    var isPageOverlayModalEnabled = $5e8b75e987a7e230$export$48e0416fa20ddf0c(featureFlags);
    var _useFreeBundlesStatus = (0, $iTEfn.useFreeBundlesStatus)(), bundleProvisioningStatus = _useFreeBundlesStatus.bundleProvisioningStatus, setBundleProvisioningStatus = _useFreeBundlesStatus.setBundleProvisioningStatus;
    var _useState = (0, $cv9Rk._)((0, $1Mpn7.useState)(timeout > 0 ? "pending" : "timeout"), 2), createCloudStatus = _useState[0], setCreateCloudStatus = _useState[1];
    var _useState1 = (0, $cv9Rk._)((0, $1Mpn7.useState)(cloudIdProp), 2), cloudId = _useState1[0], setCloudId = _useState1[1];
    var hasRequiredParameters = !!onDemandUrl && !!products.length;
    var _useState2 = (0, $cv9Rk._)((0, $1Mpn7.useState)(0), 2), progress = _useState2[0], setProgress = _useState2[1];
    var isReferredFromVerifyEmail = referrer === "verify_email";
    var shouldShowUserSegmentationPage = (0, $aVmvD.useUserSegmentationStatus)(products).shouldShowUserSegmentationPage;
    var _useState3 = (0, $cv9Rk._)((0, $1Mpn7.useState)(false), 2), deferRedirect = _useState3[0], setDeferRedirect = _useState3[1];
    var _useState4 = (0, $cv9Rk._)((0, $1Mpn7.useState)(""), 2), redirectUrl = _useState4[0], setRedirectUrl = _useState4[1];
    var currentScreen = (0, $7fxFq.default)(createCloudStatus, deferRedirect);
    var finalProvisioningScreens = (0, $1Mpn7.useMemo)(function() {
        return [
            "robots",
            "jira-animated-provisioning-screen",
            "redirect"
        ];
    }, []);
    var templateChoice = (0, $9bye2.useJiraTemplateChoice)().templateChoice;
    var createRedirectUrl = (0, $1Mpn7.useCallback)(function() {
        var url = new URL($5e8b75e987a7e230$var$createBaseUrl(isProduction, onDemandUrl, products, dataRegion, cloudId, admin, createAnalyticsEvent));
        // This causes browser to retry for 30 seconds if site isn't ready
        url.searchParams.set("src", "signup");
        if (templateChoice) {
            url.pathname = url.pathname + "welcome/software";
            url.searchParams.set("jsw_acp", "true");
            url.searchParams.set("template_choice", templateChoice);
        }
        if (siteRenameRequestId) url.searchParams.set("rename", "true");
        if (signupSource === "bbbundle" && isFoundingAdmin === "true") {
            url.searchParams.set("signupSource", signupSource);
            url.searchParams.set("isFoundingAdmin", isFoundingAdmin);
        }
        return url.toString();
    }, [
        admin,
        cloudId,
        products,
        dataRegion,
        onDemandUrl,
        signupSource,
        isProduction,
        templateChoice,
        isFoundingAdmin,
        siteRenameRequestId,
        createAnalyticsEvent
    ]);
    var _useState5 = (0, $cv9Rk._)((0, $1Mpn7.useState)(undefined), 2), getCloudStatus = _useState5[0], setCloudStatus = _useState5[1];
    (0, $1Mpn7.useEffect)(function() {
        if (platform === "ccp") setCloudStatus(function() {
            return /*#__PURE__*/ (0, $kSuI9._)(function() {
                var requestIdsResp, requestIds, detectedCloudId, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, resource, _resource_resourcePackages_;
                return (0, $l29cN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!provisioningRequestId) return [
                                2,
                                Promise.resolve(false)
                            ];
                            requestIdsResp = function() {
                                var _ref = (0, $kSuI9._)(function(product) {
                                    return (0, $l29cN.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    stargateClient.getProductActivationStatus({
                                                        provisioningRequestId: product
                                                    })
                                                ];
                                            case 1:
                                                return [
                                                    2,
                                                    _state.sent()
                                                ];
                                        }
                                    });
                                });
                                return function requestIdsResp(product) {
                                    return _ref.apply(this, arguments);
                                };
                            }();
                            return [
                                4,
                                Promise.all(provisioningRequestId.split(",").map(function() {
                                    var _ref = (0, $kSuI9._)(function(product) {
                                        var e;
                                        return (0, $l29cN.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    _state.trys.push([
                                                        0,
                                                        2,
                                                        ,
                                                        4
                                                    ]);
                                                    console.info("Requesting Ids ".concat(JSON.stringify(product)));
                                                    return [
                                                        4,
                                                        requestIdsResp(product)
                                                    ];
                                                case 1:
                                                    return [
                                                        2,
                                                        _state.sent()
                                                    ];
                                                case 2:
                                                    e = _state.sent();
                                                    // retry if the first call fails
                                                    console.info("Retry Requesting Ids ".concat(JSON.stringify(product)));
                                                    return [
                                                        4,
                                                        requestIdsResp(product)
                                                    ];
                                                case 3:
                                                    return [
                                                        2,
                                                        _state.sent()
                                                    ];
                                                case 4:
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    });
                                    return function(product) {
                                        return _ref.apply(this, arguments);
                                    };
                                }()))
                            ];
                        case 1:
                            requestIds = _state.sent();
                            // check for cloudId in the status response
                            if (!cloudId) {
                                detectedCloudId = $5e8b75e987a7e230$var$getCloudIdFromProductActivationStatuses(requestIds);
                                if (detectedCloudId) setCloudId(detectedCloudId);
                            }
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(_iterator = requestIds[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    resource = _step.value;
                                    ;
                                    if (resource.resourcePackages.find(function(item) {
                                        return item.action.status === "IN_PROGRESS";
                                    })) return [
                                        2,
                                        Promise.resolve(false)
                                    ];
                                    if (resource.resourcePackages.find(function(item) {
                                        return item.action.status === "PROVISIONING_FAILURE";
                                    })) return [
                                        2,
                                        Promise.reject(new Error("Provisioning Failure CCP with cloudId ".concat(cloudId, ": ").concat(JSON.stringify((_resource_resourcePackages_ = resource.resourcePackages[0]) === null || _resource_resourcePackages_ === void 0 ? void 0 : _resource_resourcePackages_.action.errorDetails))))
                                    ];
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            return [
                                2,
                                Promise.resolve(true)
                            ];
                    }
                });
            });
        });
        else setCloudStatus(function() {
            return /*#__PURE__*/ (0, $kSuI9._)(function() {
                var cloudStatusResp, e;
                return (0, $l29cN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!cloudId || !requestId) return [
                                2,
                                Promise.resolve(false)
                            ];
                            cloudStatusResp = function() {
                                var _ref = (0, $kSuI9._)(function() {
                                    var _ref, completed, successful;
                                    return (0, $l29cN.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    cofsClient.getCloudStatus({
                                                        cloudId: cloudId,
                                                        requestId: requestId
                                                    })
                                                ];
                                            case 1:
                                                _ref = _state.sent(), completed = _ref.completed, successful = _ref.successful;
                                                return [
                                                    2,
                                                    Promise.resolve(completed && successful)
                                                ];
                                        }
                                    });
                                });
                                return function cloudStatusResp() {
                                    return _ref.apply(this, arguments);
                                };
                            }();
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                5
                            ]);
                            return [
                                4,
                                cloudStatusResp()
                            ];
                        case 2:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 3:
                            e = _state.sent();
                            return [
                                4,
                                cloudStatusResp()
                            ];
                        case 4:
                            // retry if the first call fails
                            return [
                                2,
                                _state.sent()
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
        });
    }, [
        platform,
        requestId
    ]);
    (0, $1Mpn7.useEffect)(function() {
        if (!hasRequiredParameters) {
            if (createCloudStatus !== "error") {
                createAnalyticsEvent({
                    event: "errored",
                    eventName: "missingRequiredParameters"
                }).fire("signup");
                setCreateCloudStatus("error");
            }
            return;
        }
        getCloudStatus && $5e8b75e987a7e230$var$pollCloudStatusWithFeatureFlag({
            getCloudStatus: getCloudStatus,
            startTime: Date.now(),
            retryInterval: retryInterval,
            timeout: timeout,
            onSuccess: function(startTime, endTime, elapsedTime) {
                if (is15secondProvisioningEnabled) createAnalyticsEvent({
                    eventType: "operational",
                    action: "succeeded",
                    actionSubject: "provisioning-loading-screen-with-improved-polling",
                    source: "bxpkit-wac-confirmation-page",
                    attributes: {
                        totalElapsedTime: endTime - startTime,
                        timeDiffFromPrev5secondPoll: (endTime - startTime) % 5000,
                        timeDiffFromNext5secondPoll: 5000 - (endTime - startTime) % 5000
                    }
                }).fire("signup");
                createAnalyticsEvent({
                    eventType: "operational",
                    eventName: "createCloudSucceeded",
                    startTime: startTime,
                    endTime: endTime,
                    elapsedTime: elapsedTime
                }).fire("signup");
                setProgress(1); // Progress bar to 100% before redirecting user to product
                setCreateCloudStatus("success");
                if (!shouldShowUserSegmentationPage && featureFlags.provisionSecondPartyApps && provisionApp && platform !== "ccp" && !!appKey && !!onDemandUrl) {
                    // eslint-disable-next-line react-hooks/rules-of-hooks
                    var bxpExpressClient = (0, $bp6Uh.useBXPExpressClient)();
                    bxpExpressClient.getXsrfToken().then(function(xsrfToken) {
                        bxpExpressClient.marketplaceAppInstall({
                            siteName: onDemandUrl,
                            appKey: appKey,
                            xsrfToken: xsrfToken
                        }).catch(function(err) {
                            return err;
                        });
                    });
                }
            },
            onError: function(startTime, endTime, elapsedTime, error) {
                createAnalyticsEvent({
                    event: "errored",
                    eventName: "createCloudErrored",
                    startTime: startTime,
                    endTime: endTime,
                    elapsedTime: elapsedTime,
                    error: error
                }).fire("signup");
                setCreateCloudStatus("error");
            },
            onTimeout: function(startTime, endTime, elapsedTime) {
                createAnalyticsEvent({
                    event: "timedOut",
                    eventName: "createCloudTimedOut",
                    startTime: startTime,
                    endTime: endTime,
                    elapsedTime: elapsedTime
                }).fire("signup");
                setCreateCloudStatus("timeout");
            }
        }, is15secondProvisioningEnabled);
    }, [
        hasRequiredParameters,
        getCloudStatus
    ]);
    // Handles the progress bar update
    // https://hello.atlassian.net/wiki/spaces/BXP/pages/2602964460/USC-898+Fixing+the+dilemma+of+the+progress+bar+by+implementing+a+piecewise+function
    (0, $1Mpn7.useEffect)(function() {
        var startTime = Date.now();
        var pivotPercentage = 0.8; // The progress bar will fill up to 80% by the pivot time
        var progressBarPivotPoint = is15secondProvisioningEnabled ? 30000 : 60000; // the pivot point after which the progress bar will slow down
        var slowProgressIncrement = (1 - pivotPercentage) / (($5e8b75e987a7e230$export$7bd623b29ec8e1eb - progressBarPivotPoint) / 100);
        var slowProgress = 0;
        var interval = setInterval(function() {
            setProgress($5e8b75e987a7e230$var$getProgressbarStatus({
                startTime: startTime,
                pivotPercentage: pivotPercentage,
                progressBarPivotPoint: progressBarPivotPoint,
                slowProgressIncrement: slowProgressIncrement,
                slowProgress: slowProgress,
                interval: interval
            }));
        }, 100); // Update progress every 0.1 second
        return function() {
            setProgress(0);
            clearInterval(interval);
        };
    }, [
        is15secondProvisioningEnabled
    ]);
    (0, $1Mpn7.useEffect)(function() {
        if (createCloudStatus !== "success") return;
        if (// verify user has made it to a final screen (i.e. robots, jira-animated-provisioning-screen, redirect).
        finalProvisioningScreens.includes(currentScreen) && (isFreeBundlesEnabled || isPageOverlayModalEnabled)) switch(bundleProvisioningStatus){
            case "payload-ready":
            case "no-payload":
                // initial site is provisioned, now let Bundles UI know
                // it can provision secondary products
                setBundleProvisioningStatus("provisioning");
                return;
            case "success":
                if (deferRedirect) {
                    setRedirectUrl(createRedirectUrl());
                    return;
                }
                // Bundles UI has completed provisioning secondary products
                window.location.assign(createRedirectUrl());
                return;
            case "waiting":
                // Bundles modal should alert the user that product is ready
                if (isPageOverlayModalEnabled) setBundleProvisioningStatus("provisioning");
                return;
            default:
                return;
        }
        // verify user has made it to a final screen (i.e. robots, jira-animated-provisioning-screen, redirect).
        if (finalProvisioningScreens.includes(currentScreen)) {
            if (deferRedirect) {
                setRedirectUrl(createRedirectUrl());
                return;
            }
            window.location.assign(createRedirectUrl());
        }
    }, [
        currentScreen,
        createCloudStatus,
        bundleProvisioningStatus
    ]);
    return /*#__PURE__*/ (0, $1rY3h.jsx)($5e8b75e987a7e230$var$CloudStatusContext.Provider, {
        value: {
            isReferredFromVerifyEmail: isReferredFromVerifyEmail,
            createCloudStatus: createCloudStatus,
            progress: progress,
            featureFlags: featureFlags,
            deferRedirect: deferRedirect,
            setDeferRedirect: setDeferRedirect,
            redirectUrl: redirectUrl
        },
        children: children
    });
};
var $5e8b75e987a7e230$export$59840c81aaf7fd49 = function(products) {
    if (products.length > 0 && products[0] !== "") return products[0];
    else return undefined;
};
var $5e8b75e987a7e230$var$getTopLevelDomain = function(isProduction) {
    if (isProduction) return ".atlassian.net";
    else return ".jira-dev.com";
};
var $5e8b75e987a7e230$var$isValidOnDemandUrl = function(siteName) {
    var isUrl = siteName.includes(".");
    return !isUrl;
};
var $5e8b75e987a7e230$var$createBaseUrl = function(isProduction, onDemandUrl, products, dataRegion, cloudId, admin, createAnalyticsEvent) {
    if (!$5e8b75e987a7e230$var$isValidOnDemandUrl(onDemandUrl || "")) {
        createAnalyticsEvent({
            actionSubject: "invalidUrlOnRedirect",
            eventComponent: "confirmationPage",
            event: "event",
            eventType: "ui"
        }).fire("signup");
        window.history.back();
    }
    var instanceUrl = "https://" + encodeURIComponent(String(onDemandUrl)) + $5e8b75e987a7e230$var$getTopLevelDomain(isProduction);
    var primaryProduct = $5e8b75e987a7e230$export$59840c81aaf7fd49(products);
    if (admin) return $5e8b75e987a7e230$var$getAdminhubRedirectUrl(isProduction, cloudId);
    if (typeof primaryProduct !== "string") return instanceUrl;
    if (primaryProduct === "opsgenie") return $5e8b75e987a7e230$var$getOpsgenieRedirectUrl(isProduction, onDemandUrl, dataRegion);
    if (primaryProduct === "statuspage") return $5e8b75e987a7e230$var$getStatuspageRedirectUrl(isProduction, cloudId);
    if (primaryProduct === "com.atlassian.bitbucket") return $5e8b75e987a7e230$var$getBitbucketRedirectUrl(isProduction);
    if (primaryProduct === "confluence.ondemand") return $5e8b75e987a7e230$var$getConfluenceJiraRedirectUrl(instanceUrl);
    return instanceUrl;
};
var $5e8b75e987a7e230$var$getConfluenceJiraRedirectUrl = function getConfluenceJiraRedirectUrl(instanceUrl) {
    return instanceUrl + "/wiki";
};
var $5e8b75e987a7e230$var$getBitbucketRedirectUrl = function getBitbucketRedirectUrl(isProduction) {
    if (!isProduction) return "https://integration.bb-inf.net/dashboard/overview";
    return "https://bitbucket.org/dashboard/overview";
};
var $5e8b75e987a7e230$var$getOpsgenieRedirectUrl = function getOpsgenieRedirectUrl(isProduction, onDemandUrl, dataRegion) {
    if (!isProduction) return "https://".concat(onDemandUrl, ".atlassian-app.opsgeni.us");
    if (dataRegion === "europe") return "https://".concat(onDemandUrl, ".atlassian-app.eu.opsgenie.com");
    return "https://".concat(onDemandUrl, ".atlassian-app.opsgenie.com");
};
var $5e8b75e987a7e230$var$getStatuspageRedirectUrl = function getStatuspageRedirectUrl(isProduction, cloudId) {
    if (!isProduction) return "https://manage.statuspagestaging.com/cloud/" + cloudId;
    return "https://manage.statuspage.io/cloud/" + cloudId;
};
var $5e8b75e987a7e230$var$getAdminhubRedirectUrl = function(isProduction, cloudId) {
    if (!isProduction) return "https://admin.stg.atlassian.com/s/" + cloudId + "/setup";
    return "https://admin.atlassian.com/s/" + cloudId + "/setup";
};
var $5e8b75e987a7e230$var$getCloudIdFromProductActivationStatuses = function(ccpResponses) {
    return ccpResponses.map(function(param) {
        var resourcePackages = param.resourcePackages;
        return resourcePackages.map(function(param) {
            var resourceAris = param.resourceAris;
            var _resourceAris_find;
            return (_resourceAris_find = resourceAris.find(function(resourceAri) {
                return resourceAri.startsWith("ari:cloud:platform::site/");
            })) === null || _resourceAris_find === void 0 ? void 0 : _resourceAris_find.split("/")[1];
        }).find(function(e) {
            return e;
        });
    }).find(function(e) {
        return e;
    });
};
function $5e8b75e987a7e230$var$pollCloudStatusWithFeatureFlag(options, is15secondProvisioningEnabled) {
    if (is15secondProvisioningEnabled) return $5e8b75e987a7e230$export$ab1a43b145253280(options);
    return $5e8b75e987a7e230$var$pollCloudStatus(options);
}
function $5e8b75e987a7e230$var$pollCloudStatus(options) {
    var getCloudStatus = options.getCloudStatus, startTime = options.startTime, retryInterval = options.retryInterval, timeout = options.timeout, onSuccess = options.onSuccess, onError = options.onError, onTimeout = options.onTimeout;
    var endTime = Date.now();
    var elapsedTime = endTime - startTime;
    // onResponse(elapsedTime);
    if (elapsedTime < timeout) getCloudStatus().then(function(ready) {
        if (ready) onSuccess(startTime, endTime, elapsedTime);
        else setTimeout(function() {
            return $5e8b75e987a7e230$var$pollCloudStatus(options);
        }, retryInterval);
    }).catch(function(error) {
        return onError(startTime, endTime, elapsedTime, error);
    });
    else onTimeout(startTime, endTime, elapsedTime);
}
function $5e8b75e987a7e230$export$ab1a43b145253280(options) {
    var run = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    var getCloudStatus = options.getCloudStatus, startTime = options.startTime, timeout = options.timeout, onSuccess = options.onSuccess, onError = options.onError, onTimeout = options.onTimeout;
    function poll() {
        var endTime = Date.now();
        var elapsedTime = endTime - startTime;
        if (elapsedTime > timeout) {
            onTimeout(startTime, endTime, elapsedTime);
            return;
        }
        getCloudStatus().then(function(ready) {
            if (ready) onSuccess(startTime, endTime, elapsedTime);
            else $5e8b75e987a7e230$export$ab1a43b145253280(options, run + 1);
        }).catch(function(error) {
            return onError(startTime, endTime, elapsedTime, error);
        });
    }
    // initial run, check immediately to avoid rate limiting issues
    if (run === 0) {
        poll();
        return;
    }
    // we expect the majority of requests to be completed in the 15-30 second range, wait until 15 seconds to begin fast polling
    if (run === 1) {
        setTimeout(function() {
            return poll();
        }, 15000);
        return;
    }
    // in the 15-30 seconds range, fast poll every 2 seconds
    if (run > 1 && run < 10) {
        setTimeout(function() {
            return poll();
        }, 2000);
        return;
    }
    // if provisioning is delayed, slow poll every 10 seconds until the timeout if necessary
    setTimeout(function() {
        return poll();
    }, 10000);
}
function $5e8b75e987a7e230$export$48e0416fa20ddf0c(featureFlags) {
    var _useSearchParameters = (0, $cqkTt.useSearchParameters)(), products = _useSearchParameters.products, cloudId = _useSearchParameters.cloudId;
    return !!(featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.enableConfirmationPageOverlay) && (featureFlags.enableConfirmationPageOverlay === "bundles_modal" || featureFlags.enableConfirmationPageOverlay === "video_overlay") && products.length === 1 && cloudId !== "" && products.includes("confluence.ondemand");
}

});
parcelRegister("3nMqF", function(module, exports) {
$parcel$export(module.exports, "AppKey", function () { return (parcelRequire("fN6oO")).AppKey; });
$parcel$export(module.exports, "ENV_DEV", function () { return (parcelRequire("fN6oO")).ENV_DEV; });
$parcel$export(module.exports, "ENV_PRODUCTION", function () { return (parcelRequire("fN6oO")).ENV_PRODUCTION; });
$parcel$export(module.exports, "ENV_STAGING", function () { return (parcelRequire("fN6oO")).ENV_STAGING; });
$parcel$export(module.exports, "ProductKey", function () { return (parcelRequire("fN6oO")).ProductKey; });
$parcel$export(module.exports, "RECAPTCHA_KEY", function () { return (parcelRequire("fN6oO")).RECAPTCHA_KEY; });
$parcel$export(module.exports, "SanitizedHtml", function () { return (parcelRequire("iyjDo")).SanitizedHtml; });
$parcel$export(module.exports, "defineMessagesSimple", function () { return (parcelRequire("7HUGN")).defineMessagesSimple; });
$parcel$export(module.exports, "Environment", function () { return (parcelRequire("39wmd")).Environment; });
$parcel$export(module.exports, "getFirstName", function () { return (parcelRequire("2DKGq")).getFirstName; });
$parcel$export(module.exports, "getIsBundleBbJsw", function () { return (parcelRequire("cq0Ay")).getIsBundleBbJsw; });
$parcel$export(module.exports, "getIsBundleDevops", function () { return (parcelRequire("cq0Ay")).getIsBundleDevops; });
$parcel$export(module.exports, "getLastName", function () { return (parcelRequire("2DKGq")).getLastName; });
$parcel$export(module.exports, "OfferingCatalog", function () { return (parcelRequire("9ap2n")).OfferingCatalog; });
$parcel$export(module.exports, "Storage", function () { return (parcelRequire("iPDfU")).Storage; });
$parcel$export(module.exports, "Url", function () { return (parcelRequire("4vhRZ")).Url; });

var $ddvKW = parcelRequire("ddvKW");

var $ddYYi = parcelRequire("ddYYi");
parcelRequire("fN6oO");
parcelRequire("30nFL");
parcelRequire("3hvGO");
parcelRequire("bsIlm");
$parcel$exportWildcard(module.exports, $ddvKW);
$parcel$exportWildcard(module.exports, $ddYYi);

});
parcelRegister("ddvKW", function(module, exports) {
$parcel$export(module.exports, "HamletClientContext", function () { return (parcelRequire("6es2I")).HamletClientContext; });
$parcel$export(module.exports, "hashEmail", function () { return (parcelRequire("5hKwB")).hashEmail; });
$parcel$export(module.exports, "MarieSchemaAnalytics", function () { return (parcelRequire("5hKwB")).MarieSchemaAnalytics; });
parcelRequire("6es2I");

var $h77aJ = parcelRequire("h77aJ");
parcelRequire("5hKwB");
$parcel$exportWildcard(module.exports, $h77aJ);

});
parcelRegister("6es2I", function(module, exports) {

$parcel$export(module.exports, "HamletClientContext", function () { return $54c428b5bb83b077$export$ea0be683fdf7ef3d; });

var $1Mpn7 = parcelRequire("1Mpn7");
parcelRequire("4rAus");
var $zyOx3 = parcelRequire("zyOx3");
var $54c428b5bb83b077$export$ea0be683fdf7ef3d = (0, $1Mpn7.createContext)(new (0, $zyOx3.HamletClient)());

});
parcelRegister("4rAus", function(module, exports) {
$parcel$export(module.exports, "HamletClient", function () { return (parcelRequire("zyOx3")).HamletClient; });
parcelRequire("bC3ur");
parcelRequire("zyOx3");
parcelRequire("dCFAP");

});
parcelRegister("bC3ur", function(module, exports) {
parcelRequire("4AKt4");
parcelRequire("9Bd1W");
parcelRequire("jVqr7");
parcelRequire("dKqDi");
parcelRequire("jyr8U");

});
parcelRegister("4AKt4", function(module, exports) {

});

parcelRegister("9Bd1W", function(module, exports) {

});

parcelRegister("jVqr7", function(module, exports) {

});

parcelRegister("dKqDi", function(module, exports) {

});

parcelRegister("jyr8U", function(module, exports) {

});


parcelRegister("zyOx3", function(module, exports) {

$parcel$export(module.exports, "HamletClient", function () { return $06ae4657446f1e96$export$d5dedf6025fd6da0; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $l29cN = parcelRequire("l29cN");
parcelRequire("8pXts");
var $k3aYB = parcelRequire("k3aYB");
var $jyXh7 = parcelRequire("jyXh7");
var $cNDwR = parcelRequire("cNDwR");

var $hTD6v = parcelRequire("hTD6v");
var $06ae4657446f1e96$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $06ae4657446f1e96$export$6554e0e4e82f1b3a = "https://hamlet.atlassian.com";
var $06ae4657446f1e96$export$d5dedf6025fd6da0 = /*#__PURE__*/ function() {
    "use strict";
    function HamletClient() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_baseUrl = _ref.baseUrl, baseUrl = _ref_baseUrl === void 0 ? $06ae4657446f1e96$export$6554e0e4e82f1b3a : _ref_baseUrl;
        (0, $4GJKx._)(this, HamletClient);
        this.baseUrl = baseUrl;
    }
    (0, $1wc17._)(HamletClient, [
        {
            key: "getXsrfToken",
            value: function getXsrfToken(param) {
                var cloudSessionTokenCookie = param.cloudSessionTokenCookie;
                return $06ae4657446f1e96$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $hTD6v.fetch)("".concat(this.baseUrl, "/1.0/auth/xsrf/plain"), {
                                        headers: {
                                            cookie: (0, $k3aYB.serializeCookie)(cloudSessionTokenCookie)
                                        }
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    (0, $jyXh7.mapResponseToText).apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getEmailExists",
            value: function getEmailExists(param) {
                var email = param.email;
                return $06ae4657446f1e96$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $hTD6v.fetch)("".concat(this.baseUrl, "/1.0/public/aid/exists/").concat(email), {
                                        method: "POST"
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    (0, $jyXh7.mapResponseToJson).apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getCart",
            value: function getCart(param) {
                var cartId = param.cartId;
                return $06ae4657446f1e96$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $hTD6v.fetch)("".concat(this.baseUrl, "/1.0/public/order/cart/").concat(cartId))
                                ];
                            case 1:
                                return [
                                    2,
                                    (0, $jyXh7.mapResponseToJson).apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "patchUser",
            value: function patchUser(param) {
                var cloudSessionTokenCookie = param.cloudSessionTokenCookie, firstName = param.firstName, lastName = param.lastName;
                return $06ae4657446f1e96$var$__awaiter(this, void 0, void 0, function() {
                    var _tmp, _tmp1, _tmp2, _;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = [
                                    "".concat(this.baseUrl, "/1.0/public/contact/currentUser/patch")
                                ];
                                _tmp1 = {
                                    method: "PATCH"
                                };
                                _tmp2 = {
                                    "Accept": "application/json",
                                    "Content-Type": "application/json"
                                };
                                _ = "ATL-XSRF-Token";
                                return [
                                    4,
                                    this.getXsrfToken({
                                        cloudSessionTokenCookie: cloudSessionTokenCookie
                                    })
                                ];
                            case 1:
                                return [
                                    4,
                                    (0, $hTD6v.fetch).apply(void 0, _tmp.concat([
                                        (_tmp1.headers = (_tmp2[_] = _state.sent(), _tmp2["Cookie"] = (0, $k3aYB.serializeCookie)(cloudSessionTokenCookie), _tmp2), _tmp1.body = JSON.stringify([
                                            {
                                                op: "replace",
                                                path: "/contactDetails/firstName",
                                                value: firstName
                                            },
                                            {
                                                op: "replace",
                                                path: "/contactDetails/lastName",
                                                value: lastName
                                            }
                                        ]), _tmp1)
                                    ]))
                                ];
                            case 2:
                                return [
                                    2,
                                    (0, $jyXh7.mapResponseToJson).apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getProductPricing",
            value: function getProductPricing(param) {
                var productKeys = param.productKeys, _param_licenseType = param.licenseType, licenseType = _param_licenseType === void 0 ? "evaluation" : _param_licenseType, _param_requestingApplication = param.requestingApplication, requestingApplication = _param_requestingApplication === void 0 ? "WAC" : _param_requestingApplication, _param_monthsValid = param.monthsValid, monthsValid = _param_monthsValid === void 0 ? "1" : _param_monthsValid;
                return $06ae4657446f1e96$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $hTD6v.fetch)((0, $cNDwR.createUrl)({
                                        baseUrl: this.baseUrl,
                                        path: "/1.0/public/pricing/query",
                                        query: {
                                            licenseType: licenseType,
                                            productKey: productKeys,
                                            requestingApplication: requestingApplication,
                                            monthsValid: monthsValid,
                                            cacheBuster: Date.now()
                                        }
                                    }))
                                ];
                            case 1:
                                return [
                                    2,
                                    (0, $jyXh7.mapResponseToJson).apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                });
            }
        }
    ]);
    return HamletClient;
}();

});
parcelRegister("8pXts", function(module, exports) {
$parcel$export(module.exports, "UnsucessfulFetchError", function () { return (parcelRequire("210XJ")).UnsucessfulFetchError; });
$parcel$export(module.exports, "createHeaders", function () { return (parcelRequire("bwbcq")).createHeaders; });
$parcel$export(module.exports, "createUrl", function () { return (parcelRequire("cNDwR")).createUrl; });
$parcel$export(module.exports, "mapCookieToHeaders", function () { return (parcelRequire("k3aYB")).mapCookieToHeaders; });
$parcel$export(module.exports, "mapResponseToJson", function () { return (parcelRequire("jyXh7")).mapResponseToJson; });
$parcel$export(module.exports, "mapResponseToText", function () { return (parcelRequire("jyXh7")).mapResponseToText; });
$parcel$export(module.exports, "serializeCookie", function () { return (parcelRequire("k3aYB")).serializeCookie; });
parcelRequire("fRibA");
parcelRequire("ef41K");
parcelRequire("iF0dh");

});
parcelRegister("fRibA", function(module, exports) {
$parcel$export(module.exports, "UnsucessfulFetchError", function () { return (parcelRequire("210XJ")).UnsucessfulFetchError; });
parcelRequire("210XJ");

});
parcelRegister("210XJ", function(module, exports) {

$parcel$export(module.exports, "UnsucessfulFetchError", function () { return $177c6be44383df64$export$cb3dedb538046409; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $FuVm8 = parcelRequire("FuVm8");

var $ohfOJ = parcelRequire("ohfOJ");
var $177c6be44383df64$export$cb3dedb538046409 = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $dcsZi._)(UnsucessfulFetchError, Error1);
    var _super = (0, $ohfOJ._)(UnsucessfulFetchError);
    function UnsucessfulFetchError(param) {
        var message = param.message, response = param.response;
        (0, $4GJKx._)(this, UnsucessfulFetchError);
        var _this;
        _this = _super.call(this, message !== null && message !== void 0 ? message : response.statusText);
        _this.name = UnsucessfulFetchError.name;
        _this.response = response;
        return _this;
    }
    (0, $1wc17._)(UnsucessfulFetchError, [
        {
            key: "url",
            get: function get() {
                return this.response.url;
            }
        },
        {
            key: "status",
            get: function get() {
                return this.response.status;
            }
        }
    ]);
    return UnsucessfulFetchError;
}((0, $FuVm8._)(Error));
function $177c6be44383df64$export$86741fdf20922685(value) {
    return value.name === $177c6be44383df64$export$cb3dedb538046409.name;
}

});


parcelRegister("ef41K", function(module, exports) {
parcelRequire("8yhYR");

});
parcelRegister("8yhYR", function(module, exports) {

});


parcelRegister("iF0dh", function(module, exports) {
$parcel$export(module.exports, "mapCookieToHeaders", function () { return (parcelRequire("k3aYB")).mapCookieToHeaders; });
$parcel$export(module.exports, "serializeCookie", function () { return (parcelRequire("k3aYB")).serializeCookie; });
$parcel$export(module.exports, "createHeaders", function () { return (parcelRequire("bwbcq")).createHeaders; });
$parcel$export(module.exports, "mapResponseToJson", function () { return (parcelRequire("jyXh7")).mapResponseToJson; });
$parcel$export(module.exports, "mapResponseToText", function () { return (parcelRequire("jyXh7")).mapResponseToText; });
$parcel$export(module.exports, "createUrl", function () { return (parcelRequire("cNDwR")).createUrl; });
parcelRequire("k3aYB");
parcelRequire("bwbcq");
parcelRequire("jyXh7");
parcelRequire("cNDwR");

});
parcelRegister("k3aYB", function(module, exports) {

$parcel$export(module.exports, "serializeCookie", function () { return $e98c9a2698831191$export$659f3e5265115438; });
$parcel$export(module.exports, "mapCookieToHeaders", function () { return $e98c9a2698831191$export$2caf3886cd1c5ca7; });

var $j7dq3 = parcelRequire("j7dq3");
function $e98c9a2698831191$export$659f3e5265115438(param) {
    var name = param.name, value = param.value;
    return (0, $j7dq3.serialize)(name, value);
}
function $e98c9a2698831191$export$2caf3886cd1c5ca7(cookie) {
    if (cookie) return {
        cookie: $e98c9a2698831191$export$659f3e5265115438(cookie)
    };
    else return {};
}

});
parcelRegister("j7dq3", function(module, exports) {

$parcel$export(module.exports, "serialize", function () { return $dea9148acf0a7005$export$dfdc1655ccc5b9cb; }, function (v) { return $dea9148acf0a7005$export$dfdc1655ccc5b9cb = v; });
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */ /**
 * Module exports.
 * @public
 */ var $dea9148acf0a7005$export$98e6a39c04603d36;
var $dea9148acf0a7005$export$dfdc1655ccc5b9cb;
"use strict";
$dea9148acf0a7005$export$98e6a39c04603d36 = $dea9148acf0a7005$var$parse;
$dea9148acf0a7005$export$dfdc1655ccc5b9cb = $dea9148acf0a7005$var$serialize;
/**
 * Module variables.
 * @private
 */ var $dea9148acf0a7005$var$decode = decodeURIComponent;
var $dea9148acf0a7005$var$encode = encodeURIComponent;
/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */ var $dea9148acf0a7005$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */ function $dea9148acf0a7005$var$parse(str, options) {
    if (typeof str !== "string") throw new TypeError("argument str must be a string");
    var obj = {};
    var opt = options || {};
    var pairs = str.split(";");
    var dec = opt.decode || $dea9148acf0a7005$var$decode;
    for(var i = 0; i < pairs.length; i++){
        var pair = pairs[i];
        var index = pair.indexOf("=");
        // skip things that don't look like key=value
        if (index < 0) continue;
        var key = pair.substring(0, index).trim();
        // only assign once
        if (undefined == obj[key]) {
            var val = pair.substring(index + 1, pair.length).trim();
            // quoted values
            if (val[0] === '"') val = val.slice(1, -1);
            obj[key] = $dea9148acf0a7005$var$tryDecode(val, dec);
        }
    }
    return obj;
}
/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */ function $dea9148acf0a7005$var$serialize(name, val, options) {
    var opt = options || {};
    var enc = opt.encode || $dea9148acf0a7005$var$encode;
    if (typeof enc !== "function") throw new TypeError("option encode is invalid");
    if (!$dea9148acf0a7005$var$fieldContentRegExp.test(name)) throw new TypeError("argument name is invalid");
    var value = enc(val);
    if (value && !$dea9148acf0a7005$var$fieldContentRegExp.test(value)) throw new TypeError("argument val is invalid");
    var str = name + "=" + value;
    if (null != opt.maxAge) {
        var maxAge = opt.maxAge - 0;
        if (isNaN(maxAge) || !isFinite(maxAge)) throw new TypeError("option maxAge is invalid");
        str += "; Max-Age=" + Math.floor(maxAge);
    }
    if (opt.domain) {
        if (!$dea9148acf0a7005$var$fieldContentRegExp.test(opt.domain)) throw new TypeError("option domain is invalid");
        str += "; Domain=" + opt.domain;
    }
    if (opt.path) {
        if (!$dea9148acf0a7005$var$fieldContentRegExp.test(opt.path)) throw new TypeError("option path is invalid");
        str += "; Path=" + opt.path;
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== "function") throw new TypeError("option expires is invalid");
        str += "; Expires=" + opt.expires.toUTCString();
    }
    if (opt.httpOnly) str += "; HttpOnly";
    if (opt.secure) str += "; Secure";
    if (opt.sameSite) {
        var sameSite = typeof opt.sameSite === "string" ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += "; SameSite=Strict";
                break;
            case "lax":
                str += "; SameSite=Lax";
                break;
            case "strict":
                str += "; SameSite=Strict";
                break;
            case "none":
                str += "; SameSite=None";
                break;
            default:
                throw new TypeError("option sameSite is invalid");
        }
    }
    return str;
}
/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */ function $dea9148acf0a7005$var$tryDecode(str, decode) {
    try {
        return decode(str);
    } catch (e) {
        return str;
    }
}

});


parcelRegister("bwbcq", function(module, exports) {

$parcel$export(module.exports, "createHeaders", function () { return $862b5ed8877d79a0$export$197579c449ddabf4; });

var $3sHb8 = parcelRequire("3sHb8");
parcelRequire("8swxV");
var $fQcXQ = parcelRequire("fQcXQ");
function $862b5ed8877d79a0$export$197579c449ddabf4(headers) {
    return Object.keys(headers).reduce(function(result, name) {
        var value = headers[name];
        if (!(0, $fQcXQ.isUndefined)(value)) return Object.assign(Object.assign({}, result), (0, $3sHb8._)({}, name, value.toString()));
        else return result;
    }, {});
}

});
parcelRegister("8swxV", function(module, exports) {
$parcel$export(module.exports, "isObject", function () { return (parcelRequire("bo20b")).isObject; });
$parcel$export(module.exports, "getRecordKeys", function () { return (parcelRequire("hqPFZ")).getRecordKeys; });
$parcel$export(module.exports, "isNotUndefined", function () { return (parcelRequire("fQcXQ")).isNotUndefined; });
$parcel$export(module.exports, "isUndefined", function () { return (parcelRequire("fQcXQ")).isUndefined; });
parcelRequire("9Ib4K");
parcelRequire("b2F61");
parcelRequire("cDj4Y");
parcelRequire("bo20b");
parcelRequire("gXPt7");
parcelRequire("hqPFZ");
parcelRequire("ff2h9");
parcelRequire("fQcXQ");

});
parcelRegister("9Ib4K", function(module, exports) {

$parcel$export(module.exports, "isArray", function () { return $7120d07ff51f2b35$export$43bee75e5e14138e; });
function $7120d07ff51f2b35$export$43bee75e5e14138e(value) {
    return Array.isArray(value);
}
function $7120d07ff51f2b35$export$3c63dcefc1d74c49(value) {
    if (!$7120d07ff51f2b35$export$43bee75e5e14138e(value)) throw new TypeError("Value is not of type array.");
}

});

parcelRegister("b2F61", function(module, exports) {
function $809fc26fdf8f16ac$export$630801d484da15df(value) {
    return value === null;
}
function $809fc26fdf8f16ac$export$31947e1aefef4655(value) {
    if ($809fc26fdf8f16ac$export$7909a8efff3699c9(value)) throw new TypeError("Value is not null.");
}
function $809fc26fdf8f16ac$export$7909a8efff3699c9(value) {
    return value !== null;
}
function $809fc26fdf8f16ac$export$9c14e1a1fcf1d102(value) {
    if ($809fc26fdf8f16ac$export$630801d484da15df(value)) throw new TypeError("Value is null.");
}

});

parcelRegister("cDj4Y", function(module, exports) {
function $9327ed47c9c7cba4$export$7e4aa119212bc614(value) {
    return typeof value === "number";
}
function $9327ed47c9c7cba4$export$98639c528a8f7f90(value) {
    if (!$9327ed47c9c7cba4$export$7e4aa119212bc614(value)) throw new TypeError("Value is not of type number.");
}
function $9327ed47c9c7cba4$export$9240adf59a14d18b(value) {
    return value;
}

});

parcelRegister("bo20b", function(module, exports) {

$parcel$export(module.exports, "isObject", function () { return $84a37d219e3441dd$export$a6cdc56e425d0d0a; });
/* eslint-disable @typescript-eslint/ban-types */ function $84a37d219e3441dd$export$a6cdc56e425d0d0a(value) {
    return value !== null && typeof value === "object";
}
function $84a37d219e3441dd$export$28450c73da0c0cec(value) {
    if (!$84a37d219e3441dd$export$a6cdc56e425d0d0a(value)) throw new TypeError("Value is not of type object.");
}

});

parcelRegister("gXPt7", function(module, exports) {
function $c59a149b8dccd55c$export$6003a5f097c73977(predicate) {
    return function(value) {
        return !predicate(value);
    };
}

});

parcelRegister("hqPFZ", function(module, exports) {

$parcel$export(module.exports, "getRecordKeys", function () { return $cb0cf335bb69df77$export$5bf60f6fb0235abd; });

var $9Ib4K = parcelRequire("9Ib4K");

var $bo20b = parcelRequire("bo20b");
function $cb0cf335bb69df77$export$6ba840931da50680(value) {
    return (0, $bo20b.isObject)(value) && !(0, $9Ib4K.isArray)(value);
}
function $cb0cf335bb69df77$export$3372e6121710b67c(value) {
    if (!$cb0cf335bb69df77$export$6ba840931da50680(value)) throw TypeError("Value is not of type Record<string | number | symbol, unknown>");
}
function $cb0cf335bb69df77$export$5bf60f6fb0235abd(record) {
    return Object.keys(record);
}

});

parcelRegister("ff2h9", function(module, exports) {
function $b18a059e41ed0021$export$844ec244b1367d54(value) {
    return typeof value === "string";
}
function $b18a059e41ed0021$export$7ff2c3a8f780f104(value) {
    if (!$b18a059e41ed0021$export$844ec244b1367d54(value)) throw new TypeError("Value is not of type string.");
}
function $b18a059e41ed0021$export$25e58f6be9d2ebe5(value) {
    return value;
}

});

parcelRegister("fQcXQ", function(module, exports) {

$parcel$export(module.exports, "isUndefined", function () { return $b885c4c35e01f00b$export$fce6876652108ab; });
$parcel$export(module.exports, "isNotUndefined", function () { return $b885c4c35e01f00b$export$e7321bf46d18757f; });
function $b885c4c35e01f00b$export$fce6876652108ab(value) {
    return value === undefined;
}
function $b885c4c35e01f00b$export$53402e64a64c3f87(value) {
    if (!$b885c4c35e01f00b$export$fce6876652108ab(value)) throw new TypeError("Value is not undefined.");
}
function $b885c4c35e01f00b$export$e7321bf46d18757f(value) {
    return value !== undefined;
}
function $b885c4c35e01f00b$export$f232a18cc1f66d93(value) {
    if (!$b885c4c35e01f00b$export$e7321bf46d18757f(value)) throw new TypeError("Value is undefined.");
}

});



parcelRegister("jyXh7", function(module, exports) {

$parcel$export(module.exports, "mapResponseToText", function () { return $e3df2c16dd0a58b3$export$779c89bcd6b62ed; });
$parcel$export(module.exports, "mapResponseToJson", function () { return $e3df2c16dd0a58b3$export$a1968f52311c9c2e; });

var $l29cN = parcelRequire("l29cN");
parcelRequire("fRibA");
var $210XJ = parcelRequire("210XJ");
var $e3df2c16dd0a58b3$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $e3df2c16dd0a58b3$export$779c89bcd6b62ed(response) {
    return $e3df2c16dd0a58b3$var$__awaiter(this, void 0, void 0, function() {
        var _, _tmp;
        return (0, $l29cN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!response.ok) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        response.text()
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
                case 2:
                    _ = (0, $210XJ.UnsucessfulFetchError).bind;
                    _tmp = {};
                    return [
                        4,
                        $e3df2c16dd0a58b3$var$mapResponseToMessage(response)
                    ];
                case 3:
                    throw new (_.apply((0, $210XJ.UnsucessfulFetchError), [
                        void 0,
                        (_tmp.message = _state.sent(), _tmp.response = response, _tmp)
                    ]));
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
}
function $e3df2c16dd0a58b3$export$a1968f52311c9c2e(response) {
    return $e3df2c16dd0a58b3$var$__awaiter(this, void 0, void 0, function() {
        var _, _tmp;
        return (0, $l29cN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!response.ok) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        response.json()
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
                case 2:
                    _ = (0, $210XJ.UnsucessfulFetchError).bind;
                    _tmp = {};
                    return [
                        4,
                        $e3df2c16dd0a58b3$var$mapResponseToMessage(response)
                    ];
                case 3:
                    throw new (_.apply((0, $210XJ.UnsucessfulFetchError), [
                        void 0,
                        (_tmp.message = _state.sent(), _tmp.response = response, _tmp)
                    ]));
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
}
function $e3df2c16dd0a58b3$var$mapResponseToMessage(response) {
    return $e3df2c16dd0a58b3$var$__awaiter(this, void 0, void 0, function() {
        var statusText, message;
        return (0, $l29cN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    statusText = response.statusText;
                    return [
                        4,
                        response.text()
                    ];
                case 1:
                    message = _state.sent();
                    if (message.length > 0) return [
                        2,
                        "".concat(statusText, " ").concat(message)
                    ];
                    else return [
                        2,
                        statusText
                    ];
                    return [
                        2
                    ];
            }
        });
    });
}

});

parcelRegister("cNDwR", function(module, exports) {

$parcel$export(module.exports, "createUrl", function () { return $9518b94936dbcbf8$export$7138c24907de3954; });

var $3sHb8 = parcelRequire("3sHb8");

var $c6Xmf = parcelRequire("c6Xmf");
parcelRequire("8swxV");
var $fQcXQ = parcelRequire("fQcXQ");
function $9518b94936dbcbf8$export$7138c24907de3954() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_baseUrl = _ref.baseUrl, baseUrl = _ref_baseUrl === void 0 ? "" : _ref_baseUrl, _ref_path = _ref.path, path = _ref_path === void 0 ? "" : _ref_path, query = _ref.query;
    var queryString = $9518b94936dbcbf8$var$mapQueryToQueryString(query);
    if (queryString) return "".concat(baseUrl).concat(path, "?").concat(queryString);
    else return "".concat(baseUrl).concat(path);
}
function $9518b94936dbcbf8$var$mapQueryToQueryString() {
    var query = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var queryString = Object.keys(query).reduce(function(pairs, name) {
        var value = query[name];
        if ((0, $fQcXQ.isUndefined)(value)) return pairs;
        else if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") return (0, $c6Xmf._)(pairs).concat([
            "".concat(encodeURIComponent(name), "=").concat(encodeURIComponent(value))
        ]);
        else return (0, $c6Xmf._)(pairs).concat([
            value.map(function(item) {
                return $9518b94936dbcbf8$var$mapQueryToQueryString((0, $3sHb8._)({}, name, item));
            }).join("&")
        ]);
    }, []).join("&");
    if (queryString.length > 0) return queryString;
    else return null;
}

});



parcelRegister("hTD6v", function(module, exports) {
// Save global object in a variable
var __global__ = typeof globalThis !== "undefined" && globalThis || typeof self !== "undefined" && self || typeof $parcel$global !== "undefined" && $parcel$global;
// Create an object that extends from __global__ without the fetch function
var __globalThis__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = __global__.DOMException;
    }
    F.prototype = __global__; // Needed for feature detection on whatwg-fetch's code
    return new F();
}();
// Wraps whatwg-fetch with a function scope to hijack the global object
// "globalThis" that's going to be patched
(function(globalThis1) {
    var irrelevant = function(exports1) {
        var _$global = typeof globalThis1 !== "undefined" && globalThis1 || typeof self !== "undefined" && self || typeof _$global !== "undefined" && _$global;
        var support = {
            searchParams: "URLSearchParams" in _$global,
            iterable: "Symbol" in _$global && "iterator" in Symbol,
            blob: "FileReader" in _$global && "Blob" in _$global && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: "FormData" in _$global,
            arrayBuffer: "ArrayBuffer" in _$global
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                "[object Int8Array]",
                "[object Uint8Array]",
                "[object Uint8ClampedArray]",
                "[object Int16Array]",
                "[object Uint16Array]",
                "[object Int32Array]",
                "[object Uint32Array]",
                "[object Float32Array]",
                "[object Float64Array]"
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== "string") name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === "") throw new TypeError('Invalid character in header field name: "' + name + '"');
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== "string") value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function next() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ", " + value : value;
        };
        Headers.prototype["delete"] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body.bodyUsed) return Promise.reject(new TypeError("Already read"));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsText(blob);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join("");
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                /*
        fetch-mock wraps the Response object in an ES6 Proxy to
        provide useful test harness features such as flush. However, on
        ES5 browsers without fetch or Proxy support pollyfills must be used;
        the proxy-pollyfill is unable to proxy an attribute unless it exists
        on the object before the Proxy is created. This change ensures
        Response.bodyUsed exists on the instance, while maintaining the
        semantic of setting Request.bodyUsed in the constructor before
        _initBody is called.
      */ this.bodyUsed = this.bodyUsed;
                this._bodyInit = body;
                if (!body) this._bodyText = "";
                else if (typeof body === "string") this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get("content-type")) {
                    if (typeof body === "string") this.headers.set("content-type", "text/plain;charset=UTF-8");
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set("content-type", this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
                }
            };
            if (support.blob) {
                this.blob = function() {
                    var rejected = consumed(this);
                    if (rejected) return rejected;
                    if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                    else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                        this._bodyArrayBuffer
                    ]));
                    else if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                    else return Promise.resolve(new Blob([
                        this._bodyText
                    ]));
                };
                this.arrayBuffer = function() {
                    if (this._bodyArrayBuffer) {
                        var isConsumed = consumed(this);
                        if (isConsumed) return isConsumed;
                        if (ArrayBuffer.isView(this._bodyArrayBuffer)) return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
                        else return Promise.resolve(this._bodyArrayBuffer);
                    } else return this.blob().then(readBlobAsArrayBuffer);
                };
            }
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error("could not read FormData body as text");
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            "DELETE",
            "GET",
            "HEAD",
            "OPTIONS",
            "POST",
            "PUT"
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            if (!(this instanceof Request)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError("Already read");
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || "same-origin";
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || "GET");
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal;
            this.referrer = null;
            if ((this.method === "GET" || this.method === "HEAD") && body) throw new TypeError("Body not allowed for GET or HEAD requests");
            this._initBody(body);
            if (this.method === "GET" || this.method === "HEAD") {
                if (options.cache === "no-store" || options.cache === "no-cache") {
                    // Search for a '_' parameter in the query string
                    var reParamSearch = /([?&])_=[^&]*/;
                    if (reParamSearch.test(this.url)) // If it already exists then set the value with the current time
                    this.url = this.url.replace(reParamSearch, "$1_=" + new Date().getTime());
                    else {
                        // Otherwise add a new '_' parameter to the end with the current time
                        var reQueryString = /\?/;
                        this.url += (reQueryString.test(this.url) ? "&" : "?") + "_=" + new Date().getTime();
                    }
                }
            }
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split("&").forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split("=");
                    var name = split.shift().replace(/\+/g, " ");
                    var value = split.join("=").replace(/\+/g, " ");
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
            // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
            // https://github.com/github/fetch/issues/748
            // https://github.com/zloirock/core-js/issues/751
            preProcessedHeaders.split("\r").map(function(header) {
                return header.indexOf("\n") === 0 ? header.substr(1, header.length) : header;
            }).forEach(function(line) {
                var parts = line.split(":");
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(":").trim();
                    headers.append(key, value);
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!(this instanceof Response)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            if (!options) options = {};
            this.type = "default";
            this.status = options.status === undefined ? 200 : options.status;
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = options.statusText === undefined ? "" : "" + options.statusText;
            this.headers = new Headers(options.headers);
            this.url = options.url || "";
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 0,
                statusText: ""
            });
            response.type = "error";
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError("Invalid status code");
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = _$global.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException("Aborted", "AbortError"));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        status: xhr.status,
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || "")
                    };
                    options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
                    var body = "response" in xhr ? xhr.response : xhr.responseText;
                    setTimeout(function() {
                        resolve(new Response(body, options));
                    }, 0);
                };
                xhr.onerror = function() {
                    setTimeout(function() {
                        reject(new TypeError("Network request failed"));
                    }, 0);
                };
                xhr.ontimeout = function() {
                    setTimeout(function() {
                        reject(new TypeError("Network request failed"));
                    }, 0);
                };
                xhr.onabort = function() {
                    setTimeout(function() {
                        reject(new exports1.DOMException("Aborted", "AbortError"));
                    }, 0);
                };
                function fixUrl(url) {
                    try {
                        return url === "" && _$global.location.href ? _$global.location.href : url;
                    } catch (e) {
                        return url;
                    }
                }
                xhr.open(request.method, fixUrl(request.url), true);
                if (request.credentials === "include") xhr.withCredentials = true;
                else if (request.credentials === "omit") xhr.withCredentials = false;
                if ("responseType" in xhr) {
                    if (support.blob) xhr.responseType = "blob";
                    else if (support.arrayBuffer && request.headers.get("Content-Type") && request.headers.get("Content-Type").indexOf("application/octet-stream") !== -1) xhr.responseType = "arraybuffer";
                }
                if (init && typeof init.headers === "object" && !(init.headers instanceof Headers)) Object.getOwnPropertyNames(init.headers).forEach(function(name) {
                    xhr.setRequestHeader(name, normalizeValue(init.headers[name]));
                });
                else request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener("abort", abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener("abort", abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === "undefined" ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!_$global.fetch) {
            _$global.fetch = fetch;
            _$global.Headers = Headers;
            _$global.Request = Request;
            _$global.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        return exports1;
    }({});
})(__globalThis__);
// This is a ponyfill, so...
__globalThis__.fetch.ponyfill = true;
delete __globalThis__.fetch.polyfill;
// Choose between native implementation (__global__) or custom implementation (__globalThis__)
var ctx = __global__.fetch ? __global__ : __globalThis__;
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
;
exports.default = ctx.fetch // For TypeScript consumers without esModuleInterop.
;
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
;
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

});


parcelRegister("dCFAP", function(module, exports) {

});



parcelRegister("h77aJ", function(module, exports) {
// import { PricingCalculator } from '@atlassian/bxp-product-pricing';
// import { useMemo } from 'react';
//
// import { useProductPricingStore } from '@atlassiansox/bxpkit-product-pricing-store';
//
// export function usePricingCalculator() {
//   const productPricingStore = useProductPricingStore();
//   return useMemo(
//     () => new PricingCalculator({ productPricingStore }),
//     [productPricingStore]
//   );
// }

});

parcelRegister("5hKwB", function(module, exports) {

$parcel$export(module.exports, "hashEmail", function () { return $03ee34d95c7e3617$export$2cb26a492a43576c; });
$parcel$export(module.exports, "MarieSchemaAnalytics", function () { return $03ee34d95c7e3617$export$f855b9e595a3bfdc; });

var $kSuI9 = parcelRequire("kSuI9");

var $cv9Rk = parcelRequire("cv9Rk");

var $l29cN = parcelRequire("l29cN");

var $1Mpn7 = parcelRequire("1Mpn7");

var $4LVJL = parcelRequire("4LVJL");
var $03ee34d95c7e3617$export$2cb26a492a43576c = function() {
    var _ref = (0, $kSuI9._)(function(email) {
        var salt, _email_toLowerCase_split, tmp, username, tmp1, domain, sanitizedUsername, cleanEmail, hashResult;
        return (0, $l29cN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    salt = "$2b$11$wgr1TJNVKwiK/dQBd3HKm.";
                    if (!email || typeof email === "number") return [
                        2,
                        Promise.resolve("")
                    ];
                    // set email to lowercase, split username & domain
                    // tslint:disable-next-line: prefer-const
                    _email_toLowerCase_split = (0, $cv9Rk._)(email.toLowerCase().split("@"), 2), tmp = _email_toLowerCase_split[0], username = tmp === void 0 ? "" : tmp, tmp1 = _email_toLowerCase_split[1], domain = tmp1 === void 0 ? "" : tmp1;
                    // strip fullstops
                    sanitizedUsername = username.replace(/\./g, "");
                    // ignore anything after '+' char
                    if (sanitizedUsername.includes("+")) sanitizedUsername = sanitizedUsername.split("+")[0] || "";
                    // rejoin the email
                    cleanEmail = sanitizedUsername + "@" + domain;
                    return [
                        4,
                        (0, $4LVJL.hash)(cleanEmail, salt).catch(function() {
                            return "";
                        })
                    ];
                case 1:
                    hashResult = _state.sent();
                    return [
                        2,
                        Promise.resolve(hashResult)
                    ];
            }
        });
    });
    return function hashEmail(email) {
        return _ref.apply(this, arguments);
    };
}();
var $03ee34d95c7e3617$var$MarieSchema = {
    eventContainer: "",
    productKey: [],
    productEdition: "",
    productPlatform: "",
    schemaVersion: 1,
    loginUserDetected: 0,
    suiteName: "",
    // tslint:disable-next-line:no-empty
    setSuiteName: function() {
        return undefined;
    },
    userEmail: "",
    // tslint:disable-next-line:no-empty
    setUserEmail: function() {
        return undefined;
    },
    productsOffered: []
};
var $03ee34d95c7e3617$export$f855b9e595a3bfdc = /*#__PURE__*/ (0, $1Mpn7.createContext)($03ee34d95c7e3617$var$MarieSchema);

});
parcelRegister("4LVJL", function(module, exports) {

var $l0HdX = parcelRequire("l0HdX");

var $3qWgZ = parcelRequire("3qWgZ");

/*
 Copyright (c) 2012 Nevins Bartolomeo <nevins.bartolomeo@gmail.com>
 Copyright (c) 2012 Shane Girish <shaneGirish@gmail.com>
 Copyright (c) 2014 Daniel Wirtz <dcode@dcode.io>

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions
 are met:
 1. Redistributions of source code must retain the above copyright
 notice, this list of conditions and the following disclaimer.
 2. Redistributions in binary form must reproduce the above copyright
 notice, this list of conditions and the following disclaimer in the
 documentation and/or other materials provided with the distribution.
 3. The name of the author may not be used to endorse or promote products
 derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED BY THE AUTHOR ``AS IS'' AND ANY EXPRESS OR
 IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES
 OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY DIRECT, INDIRECT,
 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
 THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
 THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ /**
 * @license bcrypt.js (c) 2013 Daniel Wirtz <dcode@dcode.io>
 * Released under the Apache License, Version 2.0
 * see: https://github.com/dcodeIO/bcrypt.js for details
 */ (function(global, factory) {
    /* AMD */ if (typeof define === "function" && define["amd"]) define([], factory);
    else if (module && module["exports"]) module["exports"] = factory();
    else (global["dcodeIO"] = global["dcodeIO"] || {})["bcrypt"] = factory();
})(undefined, function() {
    "use strict";
    /**
     * bcrypt namespace.
     * @type {Object.<string,*>}
     */ var bcrypt = {};
    /**
     * The random implementation to use as a fallback.
     * @type {?function(number):!Array.<number>}
     * @inner
     */ var randomFallback = null;
    /**
     * Generates cryptographically secure random bytes.
     * @function
     * @param {number} len Bytes length
     * @returns {!Array.<number>} Random bytes
     * @throws {Error} If no random implementation is available
     * @inner
     */ function random(len) {
        /* node */ if (module && module["exports"]) try {
            return (parcelRequire("f3yl3")).randomBytes(len);
        } catch (e) {}
        /* WCA */ try {
            var a;
            (self["crypto"] || self["msCrypto"])["getRandomValues"](a = new Uint32Array(len));
            return Array.prototype.slice.call(a);
        } catch (e) {}
        /* fallback */ if (!randomFallback) throw Error("Neither WebCryptoAPI nor a crypto module is available. Use bcrypt.setRandomFallback to set an alternative");
        return randomFallback(len);
    }
    // Test if any secure randomness source is available
    var randomAvailable = false;
    try {
        random(1);
        randomAvailable = true;
    } catch (e) {}
    // Default fallback, if any
    randomFallback = null;
    /**
     * Sets the pseudo random number generator to use as a fallback if neither node's `crypto` module nor the Web Crypto
     *  API is available. Please note: It is highly important that the PRNG used is cryptographically secure and that it
     *  is seeded properly!
     * @param {?function(number):!Array.<number>} random Function taking the number of bytes to generate as its
     *  sole argument, returning the corresponding array of cryptographically secure random byte values.
     * @see http://nodejs.org/api/crypto.html
     * @see http://www.w3.org/TR/WebCryptoAPI/
     */ bcrypt.setRandomFallback = function(random) {
        randomFallback = random;
    };
    /**
     * Synchronously generates a salt.
     * @param {number=} rounds Number of rounds to use, defaults to 10 if omitted
     * @param {number=} seed_length Not supported.
     * @returns {string} Resulting salt
     * @throws {Error} If a random fallback is required but not set
     * @expose
     */ bcrypt.genSaltSync = function(rounds, seed_length) {
        rounds = rounds || GENSALT_DEFAULT_LOG2_ROUNDS;
        if (typeof rounds !== "number") throw Error("Illegal arguments: " + (typeof rounds === "undefined" ? "undefined" : (0, $l0HdX._)(rounds)) + ", " + (typeof seed_length === "undefined" ? "undefined" : (0, $l0HdX._)(seed_length)));
        if (rounds < 4) rounds = 4;
        else if (rounds > 31) rounds = 31;
        var salt = [];
        salt.push("$2a$");
        if (rounds < 10) salt.push("0");
        salt.push(rounds.toString());
        salt.push("$");
        salt.push(base64_encode(random(BCRYPT_SALT_LEN), BCRYPT_SALT_LEN)); // May throw
        return salt.join("");
    };
    /**
     * Asynchronously generates a salt.
     * @param {(number|function(Error, string=))=} rounds Number of rounds to use, defaults to 10 if omitted
     * @param {(number|function(Error, string=))=} seed_length Not supported.
     * @param {function(Error, string=)=} callback Callback receiving the error, if any, and the resulting salt
     * @returns {!Promise} If `callback` has been omitted
     * @throws {Error} If `callback` is present but not a function
     * @expose
     */ bcrypt.genSalt = function(rounds, seed_length, callback) {
        if (typeof seed_length === "function") callback = seed_length, seed_length = undefined; // Not supported.
        if (typeof rounds === "function") callback = rounds, rounds = undefined;
        if (typeof rounds === "undefined") rounds = GENSALT_DEFAULT_LOG2_ROUNDS;
        else if (typeof rounds !== "number") throw Error("illegal arguments: " + (typeof rounds === "undefined" ? "undefined" : (0, $l0HdX._)(rounds)));
        function _async(callback) {
            nextTick(function() {
                try {
                    callback(null, bcrypt.genSaltSync(rounds));
                } catch (err) {
                    callback(err);
                }
            });
        }
        if (callback) {
            if (typeof callback !== "function") throw Error("Illegal callback: " + (typeof callback === "undefined" ? "undefined" : (0, $l0HdX._)(callback)));
            _async(callback);
        } else return new Promise(function(resolve, reject) {
            _async(function(err, res) {
                if (err) {
                    reject(err);
                    return;
                }
                resolve(res);
            });
        });
    };
    /**
     * Synchronously generates a hash for the given string.
     * @param {string} s String to hash
     * @param {(number|string)=} salt Salt length to generate or salt to use, default to 10
     * @returns {string} Resulting hash
     * @expose
     */ bcrypt.hashSync = function(s, salt) {
        if (typeof salt === "undefined") salt = GENSALT_DEFAULT_LOG2_ROUNDS;
        if (typeof salt === "number") salt = bcrypt.genSaltSync(salt);
        if (typeof s !== "string" || typeof salt !== "string") throw Error("Illegal arguments: " + (typeof s === "undefined" ? "undefined" : (0, $l0HdX._)(s)) + ", " + (typeof salt === "undefined" ? "undefined" : (0, $l0HdX._)(salt)));
        return _hash(s, salt);
    };
    /**
     * Asynchronously generates a hash for the given string.
     * @param {string} s String to hash
     * @param {number|string} salt Salt length to generate or salt to use
     * @param {function(Error, string=)=} callback Callback receiving the error, if any, and the resulting hash
     * @param {function(number)=} progressCallback Callback successively called with the percentage of rounds completed
     *  (0.0 - 1.0), maximally once per `MAX_EXECUTION_TIME = 100` ms.
     * @returns {!Promise} If `callback` has been omitted
     * @throws {Error} If `callback` is present but not a function
     * @expose
     */ bcrypt.hash = function(s, salt, callback, progressCallback) {
        function _async(callback) {
            if (typeof s === "string" && typeof salt === "number") bcrypt.genSalt(salt, function(err, salt) {
                _hash(s, salt, callback, progressCallback);
            });
            else if (typeof s === "string" && typeof salt === "string") _hash(s, salt, callback, progressCallback);
            else nextTick(callback.bind(this, Error("Illegal arguments: " + (typeof s === "undefined" ? "undefined" : (0, $l0HdX._)(s)) + ", " + (typeof salt === "undefined" ? "undefined" : (0, $l0HdX._)(salt)))));
        }
        if (callback) {
            if (typeof callback !== "function") throw Error("Illegal callback: " + (typeof callback === "undefined" ? "undefined" : (0, $l0HdX._)(callback)));
            _async(callback);
        } else return new Promise(function(resolve, reject) {
            _async(function(err, res) {
                if (err) {
                    reject(err);
                    return;
                }
                resolve(res);
            });
        });
    };
    /**
     * Compares two strings of the same length in constant time.
     * @param {string} known Must be of the correct length
     * @param {string} unknown Must be the same length as `known`
     * @returns {boolean}
     * @inner
     */ function safeStringCompare(known, unknown) {
        var right = 0, wrong = 0;
        for(var i = 0, k = known.length; i < k; ++i)if (known.charCodeAt(i) === unknown.charCodeAt(i)) ++right;
        else ++wrong;
        // Prevent removal of unused variables (never true, actually)
        if (right < 0) return false;
        return wrong === 0;
    }
    /**
     * Synchronously tests a string against a hash.
     * @param {string} s String to compare
     * @param {string} hash Hash to test against
     * @returns {boolean} true if matching, otherwise false
     * @throws {Error} If an argument is illegal
     * @expose
     */ bcrypt.compareSync = function(s, hash) {
        if (typeof s !== "string" || typeof hash !== "string") throw Error("Illegal arguments: " + (typeof s === "undefined" ? "undefined" : (0, $l0HdX._)(s)) + ", " + (typeof hash === "undefined" ? "undefined" : (0, $l0HdX._)(hash)));
        if (hash.length !== 60) return false;
        return safeStringCompare(bcrypt.hashSync(s, hash.substr(0, hash.length - 31)), hash);
    };
    /**
     * Asynchronously compares the given data against the given hash.
     * @param {string} s Data to compare
     * @param {string} hash Data to be compared to
     * @param {function(Error, boolean)=} callback Callback receiving the error, if any, otherwise the result
     * @param {function(number)=} progressCallback Callback successively called with the percentage of rounds completed
     *  (0.0 - 1.0), maximally once per `MAX_EXECUTION_TIME = 100` ms.
     * @returns {!Promise} If `callback` has been omitted
     * @throws {Error} If `callback` is present but not a function
     * @expose
     */ bcrypt.compare = function(s, hash, callback, progressCallback) {
        function _async(callback) {
            if (typeof s !== "string" || typeof hash !== "string") {
                nextTick(callback.bind(this, Error("Illegal arguments: " + (typeof s === "undefined" ? "undefined" : (0, $l0HdX._)(s)) + ", " + (typeof hash === "undefined" ? "undefined" : (0, $l0HdX._)(hash)))));
                return;
            }
            if (hash.length !== 60) {
                nextTick(callback.bind(this, null, false));
                return;
            }
            bcrypt.hash(s, hash.substr(0, 29), function(err, comp) {
                if (err) callback(err);
                else callback(null, safeStringCompare(comp, hash));
            }, progressCallback);
        }
        if (callback) {
            if (typeof callback !== "function") throw Error("Illegal callback: " + (typeof callback === "undefined" ? "undefined" : (0, $l0HdX._)(callback)));
            _async(callback);
        } else return new Promise(function(resolve, reject) {
            _async(function(err, res) {
                if (err) {
                    reject(err);
                    return;
                }
                resolve(res);
            });
        });
    };
    /**
     * Gets the number of rounds used to encrypt the specified hash.
     * @param {string} hash Hash to extract the used number of rounds from
     * @returns {number} Number of rounds used
     * @throws {Error} If `hash` is not a string
     * @expose
     */ bcrypt.getRounds = function(hash) {
        if (typeof hash !== "string") throw Error("Illegal arguments: " + (typeof hash === "undefined" ? "undefined" : (0, $l0HdX._)(hash)));
        return parseInt(hash.split("$")[2], 10);
    };
    /**
     * Gets the salt portion from a hash. Does not validate the hash.
     * @param {string} hash Hash to extract the salt from
     * @returns {string} Extracted salt part
     * @throws {Error} If `hash` is not a string or otherwise invalid
     * @expose
     */ bcrypt.getSalt = function(hash) {
        if (typeof hash !== "string") throw Error("Illegal arguments: " + (typeof hash === "undefined" ? "undefined" : (0, $l0HdX._)(hash)));
        if (hash.length !== 60) throw Error("Illegal hash length: " + hash.length + " != 60");
        return hash.substring(0, 29);
    };
    /**
     * Continues with the callback on the next tick.
     * @function
     * @param {function(...[*])} callback Callback to execute
     * @inner
     */ var nextTick = typeof $3qWgZ !== "undefined" && $3qWgZ && typeof $3qWgZ.nextTick === "function" ? typeof setImmediate === "function" ? setImmediate : $3qWgZ.nextTick : setTimeout;
    /**
     * Converts a JavaScript string to UTF8 bytes.
     * @param {string} str String
     * @returns {!Array.<number>} UTF8 bytes
     * @inner
     */ function stringToBytes(str) {
        var out = [], i = 0;
        utfx.encodeUTF16toUTF8(function() {
            if (i >= str.length) return null;
            return str.charCodeAt(i++);
        }, function(b) {
            out.push(b);
        });
        return out;
    }
    // A base64 implementation for the bcrypt algorithm. This is partly non-standard.
    /**
     * bcrypt's own non-standard base64 dictionary.
     * @type {!Array.<string>}
     * @const
     * @inner
     **/ var BASE64_CODE = "./ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split("");
    /**
     * @type {!Array.<number>}
     * @const
     * @inner
     **/ var BASE64_INDEX = [
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        0,
        1,
        54,
        55,
        56,
        57,
        58,
        59,
        60,
        61,
        62,
        63,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        28,
        29,
        30,
        31,
        32,
        33,
        34,
        35,
        36,
        37,
        38,
        39,
        40,
        41,
        42,
        43,
        44,
        45,
        46,
        47,
        48,
        49,
        50,
        51,
        52,
        53,
        -1,
        -1,
        -1,
        -1,
        -1
    ];
    /**
     * @type {!function(...number):string}
     * @inner
     */ var stringFromCharCode = String.fromCharCode;
    /**
     * Encodes a byte array to base64 with up to len bytes of input.
     * @param {!Array.<number>} b Byte array
     * @param {number} len Maximum input length
     * @returns {string}
     * @inner
     */ function base64_encode(b, len) {
        var off = 0, rs = [], c1, c2;
        if (len <= 0 || len > b.length) throw Error("Illegal len: " + len);
        while(off < len){
            c1 = b[off++] & 0xff;
            rs.push(BASE64_CODE[c1 >> 2 & 0x3f]);
            c1 = (c1 & 0x03) << 4;
            if (off >= len) {
                rs.push(BASE64_CODE[c1 & 0x3f]);
                break;
            }
            c2 = b[off++] & 0xff;
            c1 |= c2 >> 4 & 0x0f;
            rs.push(BASE64_CODE[c1 & 0x3f]);
            c1 = (c2 & 0x0f) << 2;
            if (off >= len) {
                rs.push(BASE64_CODE[c1 & 0x3f]);
                break;
            }
            c2 = b[off++] & 0xff;
            c1 |= c2 >> 6 & 0x03;
            rs.push(BASE64_CODE[c1 & 0x3f]);
            rs.push(BASE64_CODE[c2 & 0x3f]);
        }
        return rs.join("");
    }
    /**
     * Decodes a base64 encoded string to up to len bytes of output.
     * @param {string} s String to decode
     * @param {number} len Maximum output length
     * @returns {!Array.<number>}
     * @inner
     */ function base64_decode(s, len) {
        var off = 0, slen = s.length, olen = 0, rs = [], c1, c2, c3, c4, o, code;
        if (len <= 0) throw Error("Illegal len: " + len);
        while(off < slen - 1 && olen < len){
            code = s.charCodeAt(off++);
            c1 = code < BASE64_INDEX.length ? BASE64_INDEX[code] : -1;
            code = s.charCodeAt(off++);
            c2 = code < BASE64_INDEX.length ? BASE64_INDEX[code] : -1;
            if (c1 == -1 || c2 == -1) break;
            o = c1 << 2 >>> 0;
            o |= (c2 & 0x30) >> 4;
            rs.push(stringFromCharCode(o));
            if (++olen >= len || off >= slen) break;
            code = s.charCodeAt(off++);
            c3 = code < BASE64_INDEX.length ? BASE64_INDEX[code] : -1;
            if (c3 == -1) break;
            o = (c2 & 0x0f) << 4 >>> 0;
            o |= (c3 & 0x3c) >> 2;
            rs.push(stringFromCharCode(o));
            if (++olen >= len || off >= slen) break;
            code = s.charCodeAt(off++);
            c4 = code < BASE64_INDEX.length ? BASE64_INDEX[code] : -1;
            o = (c3 & 0x03) << 6 >>> 0;
            o |= c4;
            rs.push(stringFromCharCode(o));
            ++olen;
        }
        var res = [];
        for(off = 0; off < olen; off++)res.push(rs[off].charCodeAt(0));
        return res;
    }
    /**
     * utfx-embeddable (c) 2014 Daniel Wirtz <dcode@dcode.io>
     * Released under the Apache License, Version 2.0
     * see: https://github.com/dcodeIO/utfx for details
     */ var utfx = function() {
        "use strict";
        /**
         * utfx namespace.
         * @inner
         * @type {!Object.<string,*>}
         */ var utfx = {};
        /**
         * Maximum valid code point.
         * @type {number}
         * @const
         */ utfx.MAX_CODEPOINT = 0x10FFFF;
        /**
         * Encodes UTF8 code points to UTF8 bytes.
         * @param {(!function():number|null) | number} src Code points source, either as a function returning the next code point
         *  respectively `null` if there are no more code points left or a single numeric code point.
         * @param {!function(number)} dst Bytes destination as a function successively called with the next byte
         */ utfx.encodeUTF8 = function(src, dst) {
            var cp = null;
            if (typeof src === "number") cp = src, src = function src() {
                return null;
            };
            while(cp !== null || (cp = src()) !== null){
                if (cp < 0x80) dst(cp & 0x7F);
                else if (cp < 0x800) dst(cp >> 6 & 0x1F | 0xC0), dst(cp & 0x3F | 0x80);
                else if (cp < 0x10000) dst(cp >> 12 & 0x0F | 0xE0), dst(cp >> 6 & 0x3F | 0x80), dst(cp & 0x3F | 0x80);
                else dst(cp >> 18 & 0x07 | 0xF0), dst(cp >> 12 & 0x3F | 0x80), dst(cp >> 6 & 0x3F | 0x80), dst(cp & 0x3F | 0x80);
                cp = null;
            }
        };
        /**
         * Decodes UTF8 bytes to UTF8 code points.
         * @param {!function():number|null} src Bytes source as a function returning the next byte respectively `null` if there
         *  are no more bytes left.
         * @param {!function(number)} dst Code points destination as a function successively called with each decoded code point.
         * @throws {RangeError} If a starting byte is invalid in UTF8
         * @throws {Error} If the last sequence is truncated. Has an array property `bytes` holding the
         *  remaining bytes.
         */ utfx.decodeUTF8 = function(src, dst) {
            var a, b, c, d, fail = function fail(b) {
                b = b.slice(0, b.indexOf(null));
                var err = Error(b.toString());
                err.name = "TruncatedError";
                err["bytes"] = b;
                throw err;
            };
            while((a = src()) !== null){
                if ((a & 0x80) === 0) dst(a);
                else if ((a & 0xE0) === 0xC0) (b = src()) === null && fail([
                    a,
                    b
                ]), dst((a & 0x1F) << 6 | b & 0x3F);
                else if ((a & 0xF0) === 0xE0) ((b = src()) === null || (c = src()) === null) && fail([
                    a,
                    b,
                    c
                ]), dst((a & 0x0F) << 12 | (b & 0x3F) << 6 | c & 0x3F);
                else if ((a & 0xF8) === 0xF0) ((b = src()) === null || (c = src()) === null || (d = src()) === null) && fail([
                    a,
                    b,
                    c,
                    d
                ]), dst((a & 0x07) << 18 | (b & 0x3F) << 12 | (c & 0x3F) << 6 | d & 0x3F);
                else throw RangeError("Illegal starting byte: " + a);
            }
        };
        /**
         * Converts UTF16 characters to UTF8 code points.
         * @param {!function():number|null} src Characters source as a function returning the next char code respectively
         *  `null` if there are no more characters left.
         * @param {!function(number)} dst Code points destination as a function successively called with each converted code
         *  point.
         */ utfx.UTF16toUTF8 = function(src, dst) {
            var c1, c2 = null;
            while(true){
                if ((c1 = c2 !== null ? c2 : src()) === null) break;
                if (c1 >= 0xD800 && c1 <= 0xDFFF) {
                    if ((c2 = src()) !== null) {
                        if (c2 >= 0xDC00 && c2 <= 0xDFFF) {
                            dst((c1 - 0xD800) * 0x400 + c2 - 0xDC00 + 0x10000);
                            c2 = null;
                            continue;
                        }
                    }
                }
                dst(c1);
            }
            if (c2 !== null) dst(c2);
        };
        /**
         * Converts UTF8 code points to UTF16 characters.
         * @param {(!function():number|null) | number} src Code points source, either as a function returning the next code point
         *  respectively `null` if there are no more code points left or a single numeric code point.
         * @param {!function(number)} dst Characters destination as a function successively called with each converted char code.
         * @throws {RangeError} If a code point is out of range
         */ utfx.UTF8toUTF16 = function(src, dst) {
            var cp = null;
            if (typeof src === "number") cp = src, src = function src() {
                return null;
            };
            while(cp !== null || (cp = src()) !== null){
                if (cp <= 0xFFFF) dst(cp);
                else cp -= 0x10000, dst((cp >> 10) + 0xD800), dst(cp % 0x400 + 0xDC00);
                cp = null;
            }
        };
        /**
         * Converts and encodes UTF16 characters to UTF8 bytes.
         * @param {!function():number|null} src Characters source as a function returning the next char code respectively `null`
         *  if there are no more characters left.
         * @param {!function(number)} dst Bytes destination as a function successively called with the next byte.
         */ utfx.encodeUTF16toUTF8 = function(src, dst) {
            utfx.UTF16toUTF8(src, function(cp) {
                utfx.encodeUTF8(cp, dst);
            });
        };
        /**
         * Decodes and converts UTF8 bytes to UTF16 characters.
         * @param {!function():number|null} src Bytes source as a function returning the next byte respectively `null` if there
         *  are no more bytes left.
         * @param {!function(number)} dst Characters destination as a function successively called with each converted char code.
         * @throws {RangeError} If a starting byte is invalid in UTF8
         * @throws {Error} If the last sequence is truncated. Has an array property `bytes` holding the remaining bytes.
         */ utfx.decodeUTF8toUTF16 = function(src, dst) {
            utfx.decodeUTF8(src, function(cp) {
                utfx.UTF8toUTF16(cp, dst);
            });
        };
        /**
         * Calculates the byte length of an UTF8 code point.
         * @param {number} cp UTF8 code point
         * @returns {number} Byte length
         */ utfx.calculateCodePoint = function(cp) {
            return cp < 0x80 ? 1 : cp < 0x800 ? 2 : cp < 0x10000 ? 3 : 4;
        };
        /**
         * Calculates the number of UTF8 bytes required to store UTF8 code points.
         * @param {(!function():number|null)} src Code points source as a function returning the next code point respectively
         *  `null` if there are no more code points left.
         * @returns {number} The number of UTF8 bytes required
         */ utfx.calculateUTF8 = function(src) {
            var cp, l = 0;
            while((cp = src()) !== null)l += utfx.calculateCodePoint(cp);
            return l;
        };
        /**
         * Calculates the number of UTF8 code points respectively UTF8 bytes required to store UTF16 char codes.
         * @param {(!function():number|null)} src Characters source as a function returning the next char code respectively
         *  `null` if there are no more characters left.
         * @returns {!Array.<number>} The number of UTF8 code points at index 0 and the number of UTF8 bytes required at index 1.
         */ utfx.calculateUTF16asUTF8 = function(src) {
            var n = 0, l = 0;
            utfx.UTF16toUTF8(src, function(cp) {
                ++n;
                l += utfx.calculateCodePoint(cp);
            });
            return [
                n,
                l
            ];
        };
        return utfx;
    }();
    Date.now = Date.now || function() {
        return +new Date;
    };
    /**
     * @type {number}
     * @const
     * @inner
     */ var BCRYPT_SALT_LEN = 16;
    /**
     * @type {number}
     * @const
     * @inner
     */ var GENSALT_DEFAULT_LOG2_ROUNDS = 10;
    /**
     * @type {number}
     * @const
     * @inner
     */ var BLOWFISH_NUM_ROUNDS = 16;
    /**
     * @type {number}
     * @const
     * @inner
     */ var MAX_EXECUTION_TIME = 100;
    /**
     * @type {Array.<number>}
     * @const
     * @inner
     */ var P_ORIG = [
        0x243f6a88,
        0x85a308d3,
        0x13198a2e,
        0x03707344,
        0xa4093822,
        0x299f31d0,
        0x082efa98,
        0xec4e6c89,
        0x452821e6,
        0x38d01377,
        0xbe5466cf,
        0x34e90c6c,
        0xc0ac29b7,
        0xc97c50dd,
        0x3f84d5b5,
        0xb5470917,
        0x9216d5d9,
        0x8979fb1b
    ];
    /**
     * @type {Array.<number>}
     * @const
     * @inner
     */ var S_ORIG = [
        0xd1310ba6,
        0x98dfb5ac,
        0x2ffd72db,
        0xd01adfb7,
        0xb8e1afed,
        0x6a267e96,
        0xba7c9045,
        0xf12c7f99,
        0x24a19947,
        0xb3916cf7,
        0x0801f2e2,
        0x858efc16,
        0x636920d8,
        0x71574e69,
        0xa458fea3,
        0xf4933d7e,
        0x0d95748f,
        0x728eb658,
        0x718bcd58,
        0x82154aee,
        0x7b54a41d,
        0xc25a59b5,
        0x9c30d539,
        0x2af26013,
        0xc5d1b023,
        0x286085f0,
        0xca417918,
        0xb8db38ef,
        0x8e79dcb0,
        0x603a180e,
        0x6c9e0e8b,
        0xb01e8a3e,
        0xd71577c1,
        0xbd314b27,
        0x78af2fda,
        0x55605c60,
        0xe65525f3,
        0xaa55ab94,
        0x57489862,
        0x63e81440,
        0x55ca396a,
        0x2aab10b6,
        0xb4cc5c34,
        0x1141e8ce,
        0xa15486af,
        0x7c72e993,
        0xb3ee1411,
        0x636fbc2a,
        0x2ba9c55d,
        0x741831f6,
        0xce5c3e16,
        0x9b87931e,
        0xafd6ba33,
        0x6c24cf5c,
        0x7a325381,
        0x28958677,
        0x3b8f4898,
        0x6b4bb9af,
        0xc4bfe81b,
        0x66282193,
        0x61d809cc,
        0xfb21a991,
        0x487cac60,
        0x5dec8032,
        0xef845d5d,
        0xe98575b1,
        0xdc262302,
        0xeb651b88,
        0x23893e81,
        0xd396acc5,
        0x0f6d6ff3,
        0x83f44239,
        0x2e0b4482,
        0xa4842004,
        0x69c8f04a,
        0x9e1f9b5e,
        0x21c66842,
        0xf6e96c9a,
        0x670c9c61,
        0xabd388f0,
        0x6a51a0d2,
        0xd8542f68,
        0x960fa728,
        0xab5133a3,
        0x6eef0b6c,
        0x137a3be4,
        0xba3bf050,
        0x7efb2a98,
        0xa1f1651d,
        0x39af0176,
        0x66ca593e,
        0x82430e88,
        0x8cee8619,
        0x456f9fb4,
        0x7d84a5c3,
        0x3b8b5ebe,
        0xe06f75d8,
        0x85c12073,
        0x401a449f,
        0x56c16aa6,
        0x4ed3aa62,
        0x363f7706,
        0x1bfedf72,
        0x429b023d,
        0x37d0d724,
        0xd00a1248,
        0xdb0fead3,
        0x49f1c09b,
        0x075372c9,
        0x80991b7b,
        0x25d479d8,
        0xf6e8def7,
        0xe3fe501a,
        0xb6794c3b,
        0x976ce0bd,
        0x04c006ba,
        0xc1a94fb6,
        0x409f60c4,
        0x5e5c9ec2,
        0x196a2463,
        0x68fb6faf,
        0x3e6c53b5,
        0x1339b2eb,
        0x3b52ec6f,
        0x6dfc511f,
        0x9b30952c,
        0xcc814544,
        0xaf5ebd09,
        0xbee3d004,
        0xde334afd,
        0x660f2807,
        0x192e4bb3,
        0xc0cba857,
        0x45c8740f,
        0xd20b5f39,
        0xb9d3fbdb,
        0x5579c0bd,
        0x1a60320a,
        0xd6a100c6,
        0x402c7279,
        0x679f25fe,
        0xfb1fa3cc,
        0x8ea5e9f8,
        0xdb3222f8,
        0x3c7516df,
        0xfd616b15,
        0x2f501ec8,
        0xad0552ab,
        0x323db5fa,
        0xfd238760,
        0x53317b48,
        0x3e00df82,
        0x9e5c57bb,
        0xca6f8ca0,
        0x1a87562e,
        0xdf1769db,
        0xd542a8f6,
        0x287effc3,
        0xac6732c6,
        0x8c4f5573,
        0x695b27b0,
        0xbbca58c8,
        0xe1ffa35d,
        0xb8f011a0,
        0x10fa3d98,
        0xfd2183b8,
        0x4afcb56c,
        0x2dd1d35b,
        0x9a53e479,
        0xb6f84565,
        0xd28e49bc,
        0x4bfb9790,
        0xe1ddf2da,
        0xa4cb7e33,
        0x62fb1341,
        0xcee4c6e8,
        0xef20cada,
        0x36774c01,
        0xd07e9efe,
        0x2bf11fb4,
        0x95dbda4d,
        0xae909198,
        0xeaad8e71,
        0x6b93d5a0,
        0xd08ed1d0,
        0xafc725e0,
        0x8e3c5b2f,
        0x8e7594b7,
        0x8ff6e2fb,
        0xf2122b64,
        0x8888b812,
        0x900df01c,
        0x4fad5ea0,
        0x688fc31c,
        0xd1cff191,
        0xb3a8c1ad,
        0x2f2f2218,
        0xbe0e1777,
        0xea752dfe,
        0x8b021fa1,
        0xe5a0cc0f,
        0xb56f74e8,
        0x18acf3d6,
        0xce89e299,
        0xb4a84fe0,
        0xfd13e0b7,
        0x7cc43b81,
        0xd2ada8d9,
        0x165fa266,
        0x80957705,
        0x93cc7314,
        0x211a1477,
        0xe6ad2065,
        0x77b5fa86,
        0xc75442f5,
        0xfb9d35cf,
        0xebcdaf0c,
        0x7b3e89a0,
        0xd6411bd3,
        0xae1e7e49,
        0x00250e2d,
        0x2071b35e,
        0x226800bb,
        0x57b8e0af,
        0x2464369b,
        0xf009b91e,
        0x5563911d,
        0x59dfa6aa,
        0x78c14389,
        0xd95a537f,
        0x207d5ba2,
        0x02e5b9c5,
        0x83260376,
        0x6295cfa9,
        0x11c81968,
        0x4e734a41,
        0xb3472dca,
        0x7b14a94a,
        0x1b510052,
        0x9a532915,
        0xd60f573f,
        0xbc9bc6e4,
        0x2b60a476,
        0x81e67400,
        0x08ba6fb5,
        0x571be91f,
        0xf296ec6b,
        0x2a0dd915,
        0xb6636521,
        0xe7b9f9b6,
        0xff34052e,
        0xc5855664,
        0x53b02d5d,
        0xa99f8fa1,
        0x08ba4799,
        0x6e85076a,
        0x4b7a70e9,
        0xb5b32944,
        0xdb75092e,
        0xc4192623,
        0xad6ea6b0,
        0x49a7df7d,
        0x9cee60b8,
        0x8fedb266,
        0xecaa8c71,
        0x699a17ff,
        0x5664526c,
        0xc2b19ee1,
        0x193602a5,
        0x75094c29,
        0xa0591340,
        0xe4183a3e,
        0x3f54989a,
        0x5b429d65,
        0x6b8fe4d6,
        0x99f73fd6,
        0xa1d29c07,
        0xefe830f5,
        0x4d2d38e6,
        0xf0255dc1,
        0x4cdd2086,
        0x8470eb26,
        0x6382e9c6,
        0x021ecc5e,
        0x09686b3f,
        0x3ebaefc9,
        0x3c971814,
        0x6b6a70a1,
        0x687f3584,
        0x52a0e286,
        0xb79c5305,
        0xaa500737,
        0x3e07841c,
        0x7fdeae5c,
        0x8e7d44ec,
        0x5716f2b8,
        0xb03ada37,
        0xf0500c0d,
        0xf01c1f04,
        0x0200b3ff,
        0xae0cf51a,
        0x3cb574b2,
        0x25837a58,
        0xdc0921bd,
        0xd19113f9,
        0x7ca92ff6,
        0x94324773,
        0x22f54701,
        0x3ae5e581,
        0x37c2dadc,
        0xc8b57634,
        0x9af3dda7,
        0xa9446146,
        0x0fd0030e,
        0xecc8c73e,
        0xa4751e41,
        0xe238cd99,
        0x3bea0e2f,
        0x3280bba1,
        0x183eb331,
        0x4e548b38,
        0x4f6db908,
        0x6f420d03,
        0xf60a04bf,
        0x2cb81290,
        0x24977c79,
        0x5679b072,
        0xbcaf89af,
        0xde9a771f,
        0xd9930810,
        0xb38bae12,
        0xdccf3f2e,
        0x5512721f,
        0x2e6b7124,
        0x501adde6,
        0x9f84cd87,
        0x7a584718,
        0x7408da17,
        0xbc9f9abc,
        0xe94b7d8c,
        0xec7aec3a,
        0xdb851dfa,
        0x63094366,
        0xc464c3d2,
        0xef1c1847,
        0x3215d908,
        0xdd433b37,
        0x24c2ba16,
        0x12a14d43,
        0x2a65c451,
        0x50940002,
        0x133ae4dd,
        0x71dff89e,
        0x10314e55,
        0x81ac77d6,
        0x5f11199b,
        0x043556f1,
        0xd7a3c76b,
        0x3c11183b,
        0x5924a509,
        0xf28fe6ed,
        0x97f1fbfa,
        0x9ebabf2c,
        0x1e153c6e,
        0x86e34570,
        0xeae96fb1,
        0x860e5e0a,
        0x5a3e2ab3,
        0x771fe71c,
        0x4e3d06fa,
        0x2965dcb9,
        0x99e71d0f,
        0x803e89d6,
        0x5266c825,
        0x2e4cc978,
        0x9c10b36a,
        0xc6150eba,
        0x94e2ea78,
        0xa5fc3c53,
        0x1e0a2df4,
        0xf2f74ea7,
        0x361d2b3d,
        0x1939260f,
        0x19c27960,
        0x5223a708,
        0xf71312b6,
        0xebadfe6e,
        0xeac31f66,
        0xe3bc4595,
        0xa67bc883,
        0xb17f37d1,
        0x018cff28,
        0xc332ddef,
        0xbe6c5aa5,
        0x65582185,
        0x68ab9802,
        0xeecea50f,
        0xdb2f953b,
        0x2aef7dad,
        0x5b6e2f84,
        0x1521b628,
        0x29076170,
        0xecdd4775,
        0x619f1510,
        0x13cca830,
        0xeb61bd96,
        0x0334fe1e,
        0xaa0363cf,
        0xb5735c90,
        0x4c70a239,
        0xd59e9e0b,
        0xcbaade14,
        0xeecc86bc,
        0x60622ca7,
        0x9cab5cab,
        0xb2f3846e,
        0x648b1eaf,
        0x19bdf0ca,
        0xa02369b9,
        0x655abb50,
        0x40685a32,
        0x3c2ab4b3,
        0x319ee9d5,
        0xc021b8f7,
        0x9b540b19,
        0x875fa099,
        0x95f7997e,
        0x623d7da8,
        0xf837889a,
        0x97e32d77,
        0x11ed935f,
        0x16681281,
        0x0e358829,
        0xc7e61fd6,
        0x96dedfa1,
        0x7858ba99,
        0x57f584a5,
        0x1b227263,
        0x9b83c3ff,
        0x1ac24696,
        0xcdb30aeb,
        0x532e3054,
        0x8fd948e4,
        0x6dbc3128,
        0x58ebf2ef,
        0x34c6ffea,
        0xfe28ed61,
        0xee7c3c73,
        0x5d4a14d9,
        0xe864b7e3,
        0x42105d14,
        0x203e13e0,
        0x45eee2b6,
        0xa3aaabea,
        0xdb6c4f15,
        0xfacb4fd0,
        0xc742f442,
        0xef6abbb5,
        0x654f3b1d,
        0x41cd2105,
        0xd81e799e,
        0x86854dc7,
        0xe44b476a,
        0x3d816250,
        0xcf62a1f2,
        0x5b8d2646,
        0xfc8883a0,
        0xc1c7b6a3,
        0x7f1524c3,
        0x69cb7492,
        0x47848a0b,
        0x5692b285,
        0x095bbf00,
        0xad19489d,
        0x1462b174,
        0x23820e00,
        0x58428d2a,
        0x0c55f5ea,
        0x1dadf43e,
        0x233f7061,
        0x3372f092,
        0x8d937e41,
        0xd65fecf1,
        0x6c223bdb,
        0x7cde3759,
        0xcbee7460,
        0x4085f2a7,
        0xce77326e,
        0xa6078084,
        0x19f8509e,
        0xe8efd855,
        0x61d99735,
        0xa969a7aa,
        0xc50c06c2,
        0x5a04abfc,
        0x800bcadc,
        0x9e447a2e,
        0xc3453484,
        0xfdd56705,
        0x0e1e9ec9,
        0xdb73dbd3,
        0x105588cd,
        0x675fda79,
        0xe3674340,
        0xc5c43465,
        0x713e38d8,
        0x3d28f89e,
        0xf16dff20,
        0x153e21e7,
        0x8fb03d4a,
        0xe6e39f2b,
        0xdb83adf7,
        0xe93d5a68,
        0x948140f7,
        0xf64c261c,
        0x94692934,
        0x411520f7,
        0x7602d4f7,
        0xbcf46b2e,
        0xd4a20068,
        0xd4082471,
        0x3320f46a,
        0x43b7d4b7,
        0x500061af,
        0x1e39f62e,
        0x97244546,
        0x14214f74,
        0xbf8b8840,
        0x4d95fc1d,
        0x96b591af,
        0x70f4ddd3,
        0x66a02f45,
        0xbfbc09ec,
        0x03bd9785,
        0x7fac6dd0,
        0x31cb8504,
        0x96eb27b3,
        0x55fd3941,
        0xda2547e6,
        0xabca0a9a,
        0x28507825,
        0x530429f4,
        0x0a2c86da,
        0xe9b66dfb,
        0x68dc1462,
        0xd7486900,
        0x680ec0a4,
        0x27a18dee,
        0x4f3ffea2,
        0xe887ad8c,
        0xb58ce006,
        0x7af4d6b6,
        0xaace1e7c,
        0xd3375fec,
        0xce78a399,
        0x406b2a42,
        0x20fe9e35,
        0xd9f385b9,
        0xee39d7ab,
        0x3b124e8b,
        0x1dc9faf7,
        0x4b6d1856,
        0x26a36631,
        0xeae397b2,
        0x3a6efa74,
        0xdd5b4332,
        0x6841e7f7,
        0xca7820fb,
        0xfb0af54e,
        0xd8feb397,
        0x454056ac,
        0xba489527,
        0x55533a3a,
        0x20838d87,
        0xfe6ba9b7,
        0xd096954b,
        0x55a867bc,
        0xa1159a58,
        0xcca92963,
        0x99e1db33,
        0xa62a4a56,
        0x3f3125f9,
        0x5ef47e1c,
        0x9029317c,
        0xfdf8e802,
        0x04272f70,
        0x80bb155c,
        0x05282ce3,
        0x95c11548,
        0xe4c66d22,
        0x48c1133f,
        0xc70f86dc,
        0x07f9c9ee,
        0x41041f0f,
        0x404779a4,
        0x5d886e17,
        0x325f51eb,
        0xd59bc0d1,
        0xf2bcc18f,
        0x41113564,
        0x257b7834,
        0x602a9c60,
        0xdff8e8a3,
        0x1f636c1b,
        0x0e12b4c2,
        0x02e1329e,
        0xaf664fd1,
        0xcad18115,
        0x6b2395e0,
        0x333e92e1,
        0x3b240b62,
        0xeebeb922,
        0x85b2a20e,
        0xe6ba0d99,
        0xde720c8c,
        0x2da2f728,
        0xd0127845,
        0x95b794fd,
        0x647d0862,
        0xe7ccf5f0,
        0x5449a36f,
        0x877d48fa,
        0xc39dfd27,
        0xf33e8d1e,
        0x0a476341,
        0x992eff74,
        0x3a6f6eab,
        0xf4f8fd37,
        0xa812dc60,
        0xa1ebddf8,
        0x991be14c,
        0xdb6e6b0d,
        0xc67b5510,
        0x6d672c37,
        0x2765d43b,
        0xdcd0e804,
        0xf1290dc7,
        0xcc00ffa3,
        0xb5390f92,
        0x690fed0b,
        0x667b9ffb,
        0xcedb7d9c,
        0xa091cf0b,
        0xd9155ea3,
        0xbb132f88,
        0x515bad24,
        0x7b9479bf,
        0x763bd6eb,
        0x37392eb3,
        0xcc115979,
        0x8026e297,
        0xf42e312d,
        0x6842ada7,
        0xc66a2b3b,
        0x12754ccc,
        0x782ef11c,
        0x6a124237,
        0xb79251e7,
        0x06a1bbe6,
        0x4bfb6350,
        0x1a6b1018,
        0x11caedfa,
        0x3d25bdd8,
        0xe2e1c3c9,
        0x44421659,
        0x0a121386,
        0xd90cec6e,
        0xd5abea2a,
        0x64af674e,
        0xda86a85f,
        0xbebfe988,
        0x64e4c3fe,
        0x9dbc8057,
        0xf0f7c086,
        0x60787bf8,
        0x6003604d,
        0xd1fd8346,
        0xf6381fb0,
        0x7745ae04,
        0xd736fccc,
        0x83426b33,
        0xf01eab71,
        0xb0804187,
        0x3c005e5f,
        0x77a057be,
        0xbde8ae24,
        0x55464299,
        0xbf582e61,
        0x4e58f48f,
        0xf2ddfda2,
        0xf474ef38,
        0x8789bdc2,
        0x5366f9c3,
        0xc8b38e74,
        0xb475f255,
        0x46fcd9b9,
        0x7aeb2661,
        0x8b1ddf84,
        0x846a0e79,
        0x915f95e2,
        0x466e598e,
        0x20b45770,
        0x8cd55591,
        0xc902de4c,
        0xb90bace1,
        0xbb8205d0,
        0x11a86248,
        0x7574a99e,
        0xb77f19b6,
        0xe0a9dc09,
        0x662d09a1,
        0xc4324633,
        0xe85a1f02,
        0x09f0be8c,
        0x4a99a025,
        0x1d6efe10,
        0x1ab93d1d,
        0x0ba5a4df,
        0xa186f20f,
        0x2868f169,
        0xdcb7da83,
        0x573906fe,
        0xa1e2ce9b,
        0x4fcd7f52,
        0x50115e01,
        0xa70683fa,
        0xa002b5c4,
        0x0de6d027,
        0x9af88c27,
        0x773f8641,
        0xc3604c06,
        0x61a806b5,
        0xf0177a28,
        0xc0f586e0,
        0x006058aa,
        0x30dc7d62,
        0x11e69ed7,
        0x2338ea63,
        0x53c2dd94,
        0xc2c21634,
        0xbbcbee56,
        0x90bcb6de,
        0xebfc7da1,
        0xce591d76,
        0x6f05e409,
        0x4b7c0188,
        0x39720a3d,
        0x7c927c24,
        0x86e3725f,
        0x724d9db9,
        0x1ac15bb4,
        0xd39eb8fc,
        0xed545578,
        0x08fca5b5,
        0xd83d7cd3,
        0x4dad0fc4,
        0x1e50ef5e,
        0xb161e6f8,
        0xa28514d9,
        0x6c51133c,
        0x6fd5c7e7,
        0x56e14ec4,
        0x362abfce,
        0xddc6c837,
        0xd79a3234,
        0x92638212,
        0x670efa8e,
        0x406000e0,
        0x3a39ce37,
        0xd3faf5cf,
        0xabc27737,
        0x5ac52d1b,
        0x5cb0679e,
        0x4fa33742,
        0xd3822740,
        0x99bc9bbe,
        0xd5118e9d,
        0xbf0f7315,
        0xd62d1c7e,
        0xc700c47b,
        0xb78c1b6b,
        0x21a19045,
        0xb26eb1be,
        0x6a366eb4,
        0x5748ab2f,
        0xbc946e79,
        0xc6a376d2,
        0x6549c2c8,
        0x530ff8ee,
        0x468dde7d,
        0xd5730a1d,
        0x4cd04dc6,
        0x2939bbdb,
        0xa9ba4650,
        0xac9526e8,
        0xbe5ee304,
        0xa1fad5f0,
        0x6a2d519a,
        0x63ef8ce2,
        0x9a86ee22,
        0xc089c2b8,
        0x43242ef6,
        0xa51e03aa,
        0x9cf2d0a4,
        0x83c061ba,
        0x9be96a4d,
        0x8fe51550,
        0xba645bd6,
        0x2826a2f9,
        0xa73a3ae1,
        0x4ba99586,
        0xef5562e9,
        0xc72fefd3,
        0xf752f7da,
        0x3f046f69,
        0x77fa0a59,
        0x80e4a915,
        0x87b08601,
        0x9b09e6ad,
        0x3b3ee593,
        0xe990fd5a,
        0x9e34d797,
        0x2cf0b7d9,
        0x022b8b51,
        0x96d5ac3a,
        0x017da67d,
        0xd1cf3ed6,
        0x7c7d2d28,
        0x1f9f25cf,
        0xadf2b89b,
        0x5ad6b472,
        0x5a88f54c,
        0xe029ac71,
        0xe019a5e6,
        0x47b0acfd,
        0xed93fa9b,
        0xe8d3c48d,
        0x283b57cc,
        0xf8d56629,
        0x79132e28,
        0x785f0191,
        0xed756055,
        0xf7960e44,
        0xe3d35e8c,
        0x15056dd4,
        0x88f46dba,
        0x03a16125,
        0x0564f0bd,
        0xc3eb9e15,
        0x3c9057a2,
        0x97271aec,
        0xa93a072a,
        0x1b3f6d9b,
        0x1e6321f5,
        0xf59c66fb,
        0x26dcf319,
        0x7533d928,
        0xb155fdf5,
        0x03563482,
        0x8aba3cbb,
        0x28517711,
        0xc20ad9f8,
        0xabcc5167,
        0xccad925f,
        0x4de81751,
        0x3830dc8e,
        0x379d5862,
        0x9320f991,
        0xea7a90c2,
        0xfb3e7bce,
        0x5121ce64,
        0x774fbe32,
        0xa8b6e37e,
        0xc3293d46,
        0x48de5369,
        0x6413e680,
        0xa2ae0810,
        0xdd6db224,
        0x69852dfd,
        0x09072166,
        0xb39a460a,
        0x6445c0dd,
        0x586cdecf,
        0x1c20c8ae,
        0x5bbef7dd,
        0x1b588d40,
        0xccd2017f,
        0x6bb4e3bb,
        0xdda26a7e,
        0x3a59ff45,
        0x3e350a44,
        0xbcb4cdd5,
        0x72eacea8,
        0xfa6484bb,
        0x8d6612ae,
        0xbf3c6f47,
        0xd29be463,
        0x542f5d9e,
        0xaec2771b,
        0xf64e6370,
        0x740e0d8d,
        0xe75b1357,
        0xf8721671,
        0xaf537d5d,
        0x4040cb08,
        0x4eb4e2cc,
        0x34d2466a,
        0x0115af84,
        0xe1b00428,
        0x95983a1d,
        0x06b89fb4,
        0xce6ea048,
        0x6f3f3b82,
        0x3520ab82,
        0x011a1d4b,
        0x277227f8,
        0x611560b1,
        0xe7933fdc,
        0xbb3a792b,
        0x344525bd,
        0xa08839e1,
        0x51ce794b,
        0x2f32c9b7,
        0xa01fbac9,
        0xe01cc87e,
        0xbcc7d1f6,
        0xcf0111c3,
        0xa1e8aac7,
        0x1a908749,
        0xd44fbd9a,
        0xd0dadecb,
        0xd50ada38,
        0x0339c32a,
        0xc6913667,
        0x8df9317c,
        0xe0b12b4f,
        0xf79e59b7,
        0x43f5bb3a,
        0xf2d519ff,
        0x27d9459c,
        0xbf97222c,
        0x15e6fc2a,
        0x0f91fc71,
        0x9b941525,
        0xfae59361,
        0xceb69ceb,
        0xc2a86459,
        0x12baa8d1,
        0xb6c1075e,
        0xe3056a0c,
        0x10d25065,
        0xcb03a442,
        0xe0ec6e0e,
        0x1698db3b,
        0x4c98a0be,
        0x3278e964,
        0x9f1f9532,
        0xe0d392df,
        0xd3a0342b,
        0x8971f21e,
        0x1b0a7441,
        0x4ba3348c,
        0xc5be7120,
        0xc37632d8,
        0xdf359f8d,
        0x9b992f2e,
        0xe60b6f47,
        0x0fe3f11d,
        0xe54cda54,
        0x1edad891,
        0xce6279cf,
        0xcd3e7e6f,
        0x1618b166,
        0xfd2c1d05,
        0x848fd2c5,
        0xf6fb2299,
        0xf523f357,
        0xa6327623,
        0x93a83531,
        0x56cccd02,
        0xacf08162,
        0x5a75ebb5,
        0x6e163697,
        0x88d273cc,
        0xde966292,
        0x81b949d0,
        0x4c50901b,
        0x71c65614,
        0xe6c6c7bd,
        0x327a140a,
        0x45e1d006,
        0xc3f27b9a,
        0xc9aa53fd,
        0x62a80f00,
        0xbb25bfe2,
        0x35bdd2f6,
        0x71126905,
        0xb2040222,
        0xb6cbcf7c,
        0xcd769c2b,
        0x53113ec0,
        0x1640e3d3,
        0x38abbd60,
        0x2547adf0,
        0xba38209c,
        0xf746ce76,
        0x77afa1c5,
        0x20756060,
        0x85cbfe4e,
        0x8ae88dd8,
        0x7aaaf9b0,
        0x4cf9aa7e,
        0x1948c25c,
        0x02fb8a8c,
        0x01c36ae4,
        0xd6ebe1f9,
        0x90d4f869,
        0xa65cdea0,
        0x3f09252d,
        0xc208e69f,
        0xb74e6132,
        0xce77e25b,
        0x578fdfe3,
        0x3ac372e6
    ];
    /**
     * @type {Array.<number>}
     * @const
     * @inner
     */ var C_ORIG = [
        0x4f727068,
        0x65616e42,
        0x65686f6c,
        0x64657253,
        0x63727944,
        0x6f756274
    ];
    /**
     * @param {Array.<number>} lr
     * @param {number} off
     * @param {Array.<number>} P
     * @param {Array.<number>} S
     * @returns {Array.<number>}
     * @inner
     */ function _encipher(lr, off, P, S) {
        var n, l = lr[off], r = lr[off + 1];
        l ^= P[0];
        /*
        for (var i=0, k=BLOWFISH_NUM_ROUNDS-2; i<=k;)
            // Feistel substitution on left word
            n  = S[l >>> 24],
            n += S[0x100 | ((l >> 16) & 0xff)],
            n ^= S[0x200 | ((l >> 8) & 0xff)],
            n += S[0x300 | (l & 0xff)],
            r ^= n ^ P[++i],
            // Feistel substitution on right word
            n  = S[r >>> 24],
            n += S[0x100 | ((r >> 16) & 0xff)],
            n ^= S[0x200 | ((r >> 8) & 0xff)],
            n += S[0x300 | (r & 0xff)],
            l ^= n ^ P[++i];
        */ //The following is an unrolled version of the above loop.
        //Iteration 0
        n = S[l >>> 24];
        n += S[0x100 | l >> 16 & 0xff];
        n ^= S[0x200 | l >> 8 & 0xff];
        n += S[0x300 | l & 0xff];
        r ^= n ^ P[1];
        n = S[r >>> 24];
        n += S[0x100 | r >> 16 & 0xff];
        n ^= S[0x200 | r >> 8 & 0xff];
        n += S[0x300 | r & 0xff];
        l ^= n ^ P[2];
        //Iteration 1
        n = S[l >>> 24];
        n += S[0x100 | l >> 16 & 0xff];
        n ^= S[0x200 | l >> 8 & 0xff];
        n += S[0x300 | l & 0xff];
        r ^= n ^ P[3];
        n = S[r >>> 24];
        n += S[0x100 | r >> 16 & 0xff];
        n ^= S[0x200 | r >> 8 & 0xff];
        n += S[0x300 | r & 0xff];
        l ^= n ^ P[4];
        //Iteration 2
        n = S[l >>> 24];
        n += S[0x100 | l >> 16 & 0xff];
        n ^= S[0x200 | l >> 8 & 0xff];
        n += S[0x300 | l & 0xff];
        r ^= n ^ P[5];
        n = S[r >>> 24];
        n += S[0x100 | r >> 16 & 0xff];
        n ^= S[0x200 | r >> 8 & 0xff];
        n += S[0x300 | r & 0xff];
        l ^= n ^ P[6];
        //Iteration 3
        n = S[l >>> 24];
        n += S[0x100 | l >> 16 & 0xff];
        n ^= S[0x200 | l >> 8 & 0xff];
        n += S[0x300 | l & 0xff];
        r ^= n ^ P[7];
        n = S[r >>> 24];
        n += S[0x100 | r >> 16 & 0xff];
        n ^= S[0x200 | r >> 8 & 0xff];
        n += S[0x300 | r & 0xff];
        l ^= n ^ P[8];
        //Iteration 4
        n = S[l >>> 24];
        n += S[0x100 | l >> 16 & 0xff];
        n ^= S[0x200 | l >> 8 & 0xff];
        n += S[0x300 | l & 0xff];
        r ^= n ^ P[9];
        n = S[r >>> 24];
        n += S[0x100 | r >> 16 & 0xff];
        n ^= S[0x200 | r >> 8 & 0xff];
        n += S[0x300 | r & 0xff];
        l ^= n ^ P[10];
        //Iteration 5
        n = S[l >>> 24];
        n += S[0x100 | l >> 16 & 0xff];
        n ^= S[0x200 | l >> 8 & 0xff];
        n += S[0x300 | l & 0xff];
        r ^= n ^ P[11];
        n = S[r >>> 24];
        n += S[0x100 | r >> 16 & 0xff];
        n ^= S[0x200 | r >> 8 & 0xff];
        n += S[0x300 | r & 0xff];
        l ^= n ^ P[12];
        //Iteration 6
        n = S[l >>> 24];
        n += S[0x100 | l >> 16 & 0xff];
        n ^= S[0x200 | l >> 8 & 0xff];
        n += S[0x300 | l & 0xff];
        r ^= n ^ P[13];
        n = S[r >>> 24];
        n += S[0x100 | r >> 16 & 0xff];
        n ^= S[0x200 | r >> 8 & 0xff];
        n += S[0x300 | r & 0xff];
        l ^= n ^ P[14];
        //Iteration 7
        n = S[l >>> 24];
        n += S[0x100 | l >> 16 & 0xff];
        n ^= S[0x200 | l >> 8 & 0xff];
        n += S[0x300 | l & 0xff];
        r ^= n ^ P[15];
        n = S[r >>> 24];
        n += S[0x100 | r >> 16 & 0xff];
        n ^= S[0x200 | r >> 8 & 0xff];
        n += S[0x300 | r & 0xff];
        l ^= n ^ P[16];
        lr[off] = r ^ P[BLOWFISH_NUM_ROUNDS + 1];
        lr[off + 1] = l;
        return lr;
    }
    /**
     * @param {Array.<number>} data
     * @param {number} offp
     * @returns {{key: number, offp: number}}
     * @inner
     */ function _streamtoword(data, offp) {
        for(var i = 0, word = 0; i < 4; ++i)word = word << 8 | data[offp] & 0xff, offp = (offp + 1) % data.length;
        return {
            key: word,
            offp: offp
        };
    }
    /**
     * @param {Array.<number>} key
     * @param {Array.<number>} P
     * @param {Array.<number>} S
     * @inner
     */ function _key(key, P, S) {
        var offset = 0, lr = [
            0,
            0
        ], plen = P.length, slen = S.length, sw;
        for(var i = 0; i < plen; i++)sw = _streamtoword(key, offset), offset = sw.offp, P[i] = P[i] ^ sw.key;
        for(i = 0; i < plen; i += 2)lr = _encipher(lr, 0, P, S), P[i] = lr[0], P[i + 1] = lr[1];
        for(i = 0; i < slen; i += 2)lr = _encipher(lr, 0, P, S), S[i] = lr[0], S[i + 1] = lr[1];
    }
    /**
     * Expensive key schedule Blowfish.
     * @param {Array.<number>} data
     * @param {Array.<number>} key
     * @param {Array.<number>} P
     * @param {Array.<number>} S
     * @inner
     */ function _ekskey(data, key, P, S) {
        var offp = 0, lr = [
            0,
            0
        ], plen = P.length, slen = S.length, sw;
        for(var i = 0; i < plen; i++)sw = _streamtoword(key, offp), offp = sw.offp, P[i] = P[i] ^ sw.key;
        offp = 0;
        for(i = 0; i < plen; i += 2)sw = _streamtoword(data, offp), offp = sw.offp, lr[0] ^= sw.key, sw = _streamtoword(data, offp), offp = sw.offp, lr[1] ^= sw.key, lr = _encipher(lr, 0, P, S), P[i] = lr[0], P[i + 1] = lr[1];
        for(i = 0; i < slen; i += 2)sw = _streamtoword(data, offp), offp = sw.offp, lr[0] ^= sw.key, sw = _streamtoword(data, offp), offp = sw.offp, lr[1] ^= sw.key, lr = _encipher(lr, 0, P, S), S[i] = lr[0], S[i + 1] = lr[1];
    }
    /**
     * Internaly crypts a string.
     * @param {Array.<number>} b Bytes to crypt
     * @param {Array.<number>} salt Salt bytes to use
     * @param {number} rounds Number of rounds
     * @param {function(Error, Array.<number>=)=} callback Callback receiving the error, if any, and the resulting bytes. If
     *  omitted, the operation will be performed synchronously.
     *  @param {function(number)=} progressCallback Callback called with the current progress
     * @returns {!Array.<number>|undefined} Resulting bytes if callback has been omitted, otherwise `undefined`
     * @inner
     */ function _crypt(b, salt, rounds, callback, progressCallback) {
        var cdata = C_ORIG.slice(), clen = cdata.length, err;
        // Validate
        if (rounds < 4 || rounds > 31) {
            err = Error("Illegal number of rounds (4-31): " + rounds);
            if (callback) {
                nextTick(callback.bind(this, err));
                return;
            } else throw err;
        }
        if (salt.length !== BCRYPT_SALT_LEN) {
            err = Error("Illegal salt length: " + salt.length + " != " + BCRYPT_SALT_LEN);
            if (callback) {
                nextTick(callback.bind(this, err));
                return;
            } else throw err;
        }
        rounds = 1 << rounds >>> 0;
        var P, S, i = 0, j;
        //Use typed arrays when available - huge speedup!
        if (Int32Array) {
            P = new Int32Array(P_ORIG);
            S = new Int32Array(S_ORIG);
        } else {
            P = P_ORIG.slice();
            S = S_ORIG.slice();
        }
        _ekskey(salt, b, P, S);
        /**
         * Calcualtes the next round.
         * @returns {Array.<number>|undefined} Resulting array if callback has been omitted, otherwise `undefined`
         * @inner
         */ function next() {
            if (progressCallback) progressCallback(i / rounds);
            if (i < rounds) {
                var start = Date.now();
                for(; i < rounds;){
                    i = i + 1;
                    _key(b, P, S);
                    _key(salt, P, S);
                    if (Date.now() - start > MAX_EXECUTION_TIME) break;
                }
            } else {
                for(i = 0; i < 64; i++)for(j = 0; j < clen >> 1; j++)_encipher(cdata, j << 1, P, S);
                var ret = [];
                for(i = 0; i < clen; i++)ret.push((cdata[i] >> 24 & 0xff) >>> 0), ret.push((cdata[i] >> 16 & 0xff) >>> 0), ret.push((cdata[i] >> 8 & 0xff) >>> 0), ret.push((cdata[i] & 0xff) >>> 0);
                if (callback) {
                    callback(null, ret);
                    return;
                } else return ret;
            }
            if (callback) nextTick(next);
        }
        // Async
        if (typeof callback !== "undefined") next();
        else {
            var res;
            while(true)if (typeof (res = next()) !== "undefined") return res || [];
        }
    }
    /**
     * Internally hashes a string.
     * @param {string} s String to hash
     * @param {?string} salt Salt to use, actually never null
     * @param {function(Error, string=)=} callback Callback receiving the error, if any, and the resulting hash. If omitted,
     *  hashing is perormed synchronously.
     *  @param {function(number)=} progressCallback Callback called with the current progress
     * @returns {string|undefined} Resulting hash if callback has been omitted, otherwise `undefined`
     * @inner
     */ function _hash(s, salt, callback, progressCallback) {
        var err;
        if (typeof s !== "string" || typeof salt !== "string") {
            err = Error("Invalid string / salt: Not a string");
            if (callback) {
                nextTick(callback.bind(this, err));
                return;
            } else throw err;
        }
        // Validate the salt
        var minor, offset;
        if (salt.charAt(0) !== "$" || salt.charAt(1) !== "2") {
            err = Error("Invalid salt version: " + salt.substring(0, 2));
            if (callback) {
                nextTick(callback.bind(this, err));
                return;
            } else throw err;
        }
        if (salt.charAt(2) === "$") minor = String.fromCharCode(0), offset = 3;
        else {
            minor = salt.charAt(2);
            if (minor !== "a" && minor !== "b" && minor !== "y" || salt.charAt(3) !== "$") {
                err = Error("Invalid salt revision: " + salt.substring(2, 4));
                if (callback) {
                    nextTick(callback.bind(this, err));
                    return;
                } else throw err;
            }
            offset = 4;
        }
        // Extract number of rounds
        if (salt.charAt(offset + 2) > "$") {
            err = Error("Missing salt rounds");
            if (callback) {
                nextTick(callback.bind(this, err));
                return;
            } else throw err;
        }
        var r1 = parseInt(salt.substring(offset, offset + 1), 10) * 10, r2 = parseInt(salt.substring(offset + 1, offset + 2), 10), rounds = r1 + r2, real_salt = salt.substring(offset + 3, offset + 25);
        s += minor >= "a" ? "\x00" : "";
        var passwordb = stringToBytes(s), saltb = base64_decode(real_salt, BCRYPT_SALT_LEN);
        /**
         * Finishes hashing.
         * @param {Array.<number>} bytes Byte array
         * @returns {string}
         * @inner
         */ function finish(bytes) {
            var res = [];
            res.push("$2");
            if (minor >= "a") res.push(minor);
            res.push("$");
            if (rounds < 10) res.push("0");
            res.push(rounds.toString());
            res.push("$");
            res.push(base64_encode(saltb, saltb.length));
            res.push(base64_encode(bytes, C_ORIG.length * 4 - 1));
            return res.join("");
        }
        // Sync
        if (typeof callback == "undefined") return finish(_crypt(passwordb, saltb, rounds));
        else _crypt(passwordb, saltb, rounds, function(err, bytes) {
            if (err) callback(err, null);
            else callback(null, finish(bytes));
        }, progressCallback);
    }
    /**
     * Encodes a byte array to base64 with up to len bytes of input, using the custom bcrypt alphabet.
     * @function
     * @param {!Array.<number>} b Byte array
     * @param {number} len Maximum input length
     * @returns {string}
     * @expose
     */ bcrypt.encodeBase64 = base64_encode;
    /**
     * Decodes a base64 encoded string to up to len bytes of output, using the custom bcrypt alphabet.
     * @function
     * @param {string} s String to decode
     * @param {number} len Maximum output length
     * @returns {!Array.<number>}
     * @expose
     */ bcrypt.decodeBase64 = base64_decode;
    return bcrypt;
});

});
parcelRegister("f3yl3", function(module, exports) {

$parcel$export(module.exports, "randomBytes", function () { return $af61c5c5e4a140e6$export$5f828d93ff035aa8; }, function (v) { return $af61c5c5e4a140e6$export$5f828d93ff035aa8 = v; });
$parcel$export(module.exports, "createHmac", function () { return $af61c5c5e4a140e6$export$da39cf97e1eb7c91; }, function (v) { return $af61c5c5e4a140e6$export$da39cf97e1eb7c91 = v; });
$parcel$export(module.exports, "createSign", function () { return $af61c5c5e4a140e6$export$45df7cae684751af; }, function (v) { return $af61c5c5e4a140e6$export$45df7cae684751af = v; });
$parcel$export(module.exports, "createVerify", function () { return $af61c5c5e4a140e6$export$6f65485f87568e37; }, function (v) { return $af61c5c5e4a140e6$export$6f65485f87568e37 = v; });
$parcel$export(module.exports, "constants", function () { return $af61c5c5e4a140e6$export$1a988e7317c65621; }, function (v) { return $af61c5c5e4a140e6$export$1a988e7317c65621 = v; });
var $af61c5c5e4a140e6$export$5f828d93ff035aa8;
var $af61c5c5e4a140e6$export$cd94982b18c6332c;
var $af61c5c5e4a140e6$export$1d518568e4f529b0;
var $af61c5c5e4a140e6$export$5285b6d41c912b41;
var $af61c5c5e4a140e6$export$2fb37efbf6ae0c0e;
var $af61c5c5e4a140e6$export$ab85ecd77ce6a5cd;
var $af61c5c5e4a140e6$export$da39cf97e1eb7c91;
var $af61c5c5e4a140e6$export$52a9039d7177394f;
var $af61c5c5e4a140e6$export$f7201db400317331;
var $af61c5c5e4a140e6$export$448fa22aedc9dbca;
var $af61c5c5e4a140e6$export$b80c7ba289c8fa56;
var $af61c5c5e4a140e6$export$26e5786e8ac8e530;
var $af61c5c5e4a140e6$export$bdd223f16383713e;
var $af61c5c5e4a140e6$export$20533d26f07f1ee0;
var $af61c5c5e4a140e6$export$2f64596b8cbf08b4;
var $af61c5c5e4a140e6$export$2ce6d8d0e8b04e1a;
var $af61c5c5e4a140e6$export$12ada9414fbc594c;
var $af61c5c5e4a140e6$export$f5e7e39d57cd9700;
var $af61c5c5e4a140e6$export$36b6d6ef312eab39;
var $af61c5c5e4a140e6$export$58a258485f1e49f6;
var $af61c5c5e4a140e6$export$dedd8dc3dc62b370;
var $af61c5c5e4a140e6$export$971862a2fcb1bb40;
var $af61c5c5e4a140e6$export$c6ff6a88acbeaf40;
var $af61c5c5e4a140e6$export$fdc27893e98845cc;
var $af61c5c5e4a140e6$export$6671fb9a1323bed;
var $af61c5c5e4a140e6$export$d74daf141a551db;
var $af61c5c5e4a140e6$export$45df7cae684751af;
var $af61c5c5e4a140e6$export$1db683ad541682f6;
var $af61c5c5e4a140e6$export$6f65485f87568e37;
var $af61c5c5e4a140e6$export$91a8e56769aeb334;
var $af61c5c5e4a140e6$export$2d4117e99c2179e4;
var $af61c5c5e4a140e6$export$512823e338ddb1b7;
var $af61c5c5e4a140e6$export$9d0e0c0c4a8d30f3;
var $af61c5c5e4a140e6$export$b9d55ff329113abd;
var $af61c5c5e4a140e6$export$7efb24e2fddf99b9;
var $af61c5c5e4a140e6$export$bb1abf2ce84fc7e8;
var $af61c5c5e4a140e6$export$2f7171e78e524d5e;
var $af61c5c5e4a140e6$export$e1d879b482f37d98;
var $af61c5c5e4a140e6$export$1a988e7317c65621;
"use strict";

$af61c5c5e4a140e6$export$5f828d93ff035aa8 = $af61c5c5e4a140e6$export$cd94982b18c6332c = $af61c5c5e4a140e6$export$1d518568e4f529b0 = $af61c5c5e4a140e6$export$5285b6d41c912b41 = (parcelRequire("3JQ6x"));

$af61c5c5e4a140e6$export$2fb37efbf6ae0c0e = $af61c5c5e4a140e6$export$ab85ecd77ce6a5cd = (parcelRequire("iX9BE"));

$af61c5c5e4a140e6$export$da39cf97e1eb7c91 = $af61c5c5e4a140e6$export$52a9039d7177394f = (parcelRequire("gEN8J"));

var $1u3pS = parcelRequire("1u3pS");
var $af61c5c5e4a140e6$var$algoKeys = Object.keys($1u3pS);
var $af61c5c5e4a140e6$var$hashes = [
    "sha1",
    "sha224",
    "sha256",
    "sha384",
    "sha512",
    "md5",
    "rmd160"
].concat($af61c5c5e4a140e6$var$algoKeys);
$af61c5c5e4a140e6$export$f7201db400317331 = function() {
    return $af61c5c5e4a140e6$var$hashes;
};

var $deQJE = parcelRequire("deQJE");
$af61c5c5e4a140e6$export$448fa22aedc9dbca = $deQJE.pbkdf2;
$af61c5c5e4a140e6$export$b80c7ba289c8fa56 = $deQJE.pbkdf2Sync;

var $iTle6 = parcelRequire("iTle6");
$af61c5c5e4a140e6$export$26e5786e8ac8e530 = $iTle6.Cipher;
$af61c5c5e4a140e6$export$bdd223f16383713e = $iTle6.createCipher;
$af61c5c5e4a140e6$export$20533d26f07f1ee0 = $iTle6.Cipheriv;
$af61c5c5e4a140e6$export$2f64596b8cbf08b4 = $iTle6.createCipheriv;
$af61c5c5e4a140e6$export$2ce6d8d0e8b04e1a = $iTle6.Decipher;
$af61c5c5e4a140e6$export$12ada9414fbc594c = $iTle6.createDecipher;
$af61c5c5e4a140e6$export$f5e7e39d57cd9700 = $iTle6.Decipheriv;
$af61c5c5e4a140e6$export$36b6d6ef312eab39 = $iTle6.createDecipheriv;
$af61c5c5e4a140e6$export$58a258485f1e49f6 = $iTle6.getCiphers;
$af61c5c5e4a140e6$export$dedd8dc3dc62b370 = $iTle6.listCiphers;

var $fHxKF = parcelRequire("fHxKF");
$af61c5c5e4a140e6$export$971862a2fcb1bb40 = $fHxKF.DiffieHellmanGroup;
$af61c5c5e4a140e6$export$c6ff6a88acbeaf40 = $fHxKF.createDiffieHellmanGroup;
$af61c5c5e4a140e6$export$fdc27893e98845cc = $fHxKF.getDiffieHellman;
$af61c5c5e4a140e6$export$6671fb9a1323bed = $fHxKF.createDiffieHellman;
$af61c5c5e4a140e6$export$d74daf141a551db = $fHxKF.DiffieHellman;

var $entsh = parcelRequire("entsh");
$af61c5c5e4a140e6$export$45df7cae684751af = $entsh.createSign;
$af61c5c5e4a140e6$export$1db683ad541682f6 = $entsh.Sign;
$af61c5c5e4a140e6$export$6f65485f87568e37 = $entsh.createVerify;
$af61c5c5e4a140e6$export$91a8e56769aeb334 = $entsh.Verify;

$af61c5c5e4a140e6$export$2d4117e99c2179e4 = (parcelRequire("b7rlI"));

var $e3PEx = parcelRequire("e3PEx");
$af61c5c5e4a140e6$export$512823e338ddb1b7 = $e3PEx.publicEncrypt;
$af61c5c5e4a140e6$export$9d0e0c0c4a8d30f3 = $e3PEx.privateEncrypt;
$af61c5c5e4a140e6$export$b9d55ff329113abd = $e3PEx.publicDecrypt;
$af61c5c5e4a140e6$export$7efb24e2fddf99b9 = $e3PEx.privateDecrypt;

var $2R97P = parcelRequire("2R97P");
$af61c5c5e4a140e6$export$bb1abf2ce84fc7e8 = $2R97P.randomFill;
$af61c5c5e4a140e6$export$2f7171e78e524d5e = $2R97P.randomFillSync;
$af61c5c5e4a140e6$export$e1d879b482f37d98 = function() {
    throw new Error([
        "sorry, createCredentials is not implemented yet",
        "we accept pull requests",
        "https://github.com/crypto-browserify/crypto-browserify"
    ].join("\n"));
};
$af61c5c5e4a140e6$export$1a988e7317c65621 = {
    "DH_CHECK_P_NOT_SAFE_PRIME": 2,
    "DH_CHECK_P_NOT_PRIME": 1,
    "DH_UNABLE_TO_CHECK_GENERATOR": 4,
    "DH_NOT_SUITABLE_GENERATOR": 8,
    "NPN_ENABLED": 1,
    "ALPN_ENABLED": 1,
    "RSA_PKCS1_PADDING": 1,
    "RSA_SSLV23_PADDING": 2,
    "RSA_NO_PADDING": 3,
    "RSA_PKCS1_OAEP_PADDING": 4,
    "RSA_X931_PADDING": 5,
    "RSA_PKCS1_PSS_PADDING": 6,
    "POINT_CONVERSION_COMPRESSED": 2,
    "POINT_CONVERSION_UNCOMPRESSED": 4,
    "POINT_CONVERSION_HYBRID": 6
};

});
parcelRegister("3JQ6x", function(module, exports) {

var $3qWgZ = parcelRequire("3qWgZ");
"use strict";
// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var $2b8dfdf2f6875c99$var$MAX_BYTES = 65536;
// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var $2b8dfdf2f6875c99$var$MAX_UINT32 = 4294967295;
function $2b8dfdf2f6875c99$var$oldBrowser() {
    throw new Error("Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11");
}

var $f6JDE = parcelRequire("f6JDE");
var $2b8dfdf2f6875c99$require$Buffer = $f6JDE.Buffer;
var $2b8dfdf2f6875c99$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
if ($2b8dfdf2f6875c99$var$crypto && $2b8dfdf2f6875c99$var$crypto.getRandomValues) module.exports = $2b8dfdf2f6875c99$var$randomBytes;
else module.exports = $2b8dfdf2f6875c99$var$oldBrowser;
function $2b8dfdf2f6875c99$var$randomBytes(size, cb) {
    // phantomjs needs to throw
    if (size > $2b8dfdf2f6875c99$var$MAX_UINT32) throw new RangeError("requested too many random bytes");
    var bytes = $2b8dfdf2f6875c99$require$Buffer.allocUnsafe(size);
    if (size > 0) {
        if (size > $2b8dfdf2f6875c99$var$MAX_BYTES) // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
        for(var generated = 0; generated < size; generated += $2b8dfdf2f6875c99$var$MAX_BYTES)// buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        $2b8dfdf2f6875c99$var$crypto.getRandomValues(bytes.slice(generated, generated + $2b8dfdf2f6875c99$var$MAX_BYTES));
        else $2b8dfdf2f6875c99$var$crypto.getRandomValues(bytes);
    }
    if (typeof cb === "function") return $3qWgZ.nextTick(function() {
        cb(null, bytes);
    });
    return bytes;
}

});
parcelRegister("f6JDE", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $8dlmd = parcelRequire("8dlmd");
var $affad16faad56d13$var$Buffer = $8dlmd.Buffer;
// alternative to using Object.keys for old browsers
function $affad16faad56d13$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($affad16faad56d13$var$Buffer.from && $affad16faad56d13$var$Buffer.alloc && $affad16faad56d13$var$Buffer.allocUnsafe && $affad16faad56d13$var$Buffer.allocUnsafeSlow) module.exports = $8dlmd;
else {
    // Copy properties from require('buffer')
    $affad16faad56d13$var$copyProps($8dlmd, module.exports);
    module.exports.Buffer = $affad16faad56d13$var$SafeBuffer;
}
function $affad16faad56d13$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $affad16faad56d13$var$Buffer(arg, encodingOrOffset, length);
}
$affad16faad56d13$var$SafeBuffer.prototype = Object.create($affad16faad56d13$var$Buffer.prototype);
// Copy static methods from Buffer
$affad16faad56d13$var$copyProps($affad16faad56d13$var$Buffer, $affad16faad56d13$var$SafeBuffer);
$affad16faad56d13$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return $affad16faad56d13$var$Buffer(arg, encodingOrOffset, length);
};
$affad16faad56d13$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = $affad16faad56d13$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$affad16faad56d13$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $affad16faad56d13$var$Buffer(size);
};
$affad16faad56d13$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $8dlmd.SlowBuffer(size);
};

});
parcelRegister("8dlmd", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $5fb01ac0df210ca2$export$a143d493d941bafc; }, function (v) { return $5fb01ac0df210ca2$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "SlowBuffer", function () { return $5fb01ac0df210ca2$export$e4cf37d7f6fb9e0a; }, function (v) { return $5fb01ac0df210ca2$export$e4cf37d7f6fb9e0a = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $5fb01ac0df210ca2$export$f99ded8fe4b79145; }, function (v) { return $5fb01ac0df210ca2$export$f99ded8fe4b79145 = v; });
$parcel$export(module.exports, "kMaxLength", function () { return $5fb01ac0df210ca2$export$599f31c3813fae4d; }, function (v) { return $5fb01ac0df210ca2$export$599f31c3813fae4d = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 
var $d3H5E = parcelRequire("d3H5E");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $l0HdX = parcelRequire("l0HdX");

var $ohfOJ = parcelRequire("ohfOJ");
var $5fb01ac0df210ca2$export$a143d493d941bafc;
var $5fb01ac0df210ca2$export$e4cf37d7f6fb9e0a;
var $5fb01ac0df210ca2$export$f99ded8fe4b79145;
var $5fb01ac0df210ca2$export$599f31c3813fae4d;
"use strict";

var $iB1U9 = parcelRequire("iB1U9");

var $7ls3U = parcelRequire("7ls3U");
var $5fb01ac0df210ca2$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$5fb01ac0df210ca2$export$a143d493d941bafc = $5fb01ac0df210ca2$var$Buffer;
$5fb01ac0df210ca2$export$e4cf37d7f6fb9e0a = $5fb01ac0df210ca2$var$SlowBuffer;
$5fb01ac0df210ca2$export$f99ded8fe4b79145 = 50;
var $5fb01ac0df210ca2$var$K_MAX_LENGTH = 0x7fffffff;
$5fb01ac0df210ca2$export$599f31c3813fae4d = $5fb01ac0df210ca2$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $5fb01ac0df210ca2$var$Buffer.TYPED_ARRAY_SUPPORT = $5fb01ac0df210ca2$var$typedArraySupport();
if (!$5fb01ac0df210ca2$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $5fb01ac0df210ca2$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function foo() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($5fb01ac0df210ca2$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function get() {
        if (!$5fb01ac0df210ca2$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($5fb01ac0df210ca2$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function get() {
        if (!$5fb01ac0df210ca2$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $5fb01ac0df210ca2$var$createBuffer(length) {
    if (length > $5fb01ac0df210ca2$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $5fb01ac0df210ca2$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $5fb01ac0df210ca2$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $5fb01ac0df210ca2$var$allocUnsafe(arg);
    }
    return $5fb01ac0df210ca2$var$from(arg, encodingOrOffset, length);
}
$5fb01ac0df210ca2$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $5fb01ac0df210ca2$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $5fb01ac0df210ca2$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $5fb01ac0df210ca2$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $l0HdX._)(value)));
    if ($5fb01ac0df210ca2$var$isInstance(value, ArrayBuffer) || value && $5fb01ac0df210ca2$var$isInstance(value.buffer, ArrayBuffer)) return $5fb01ac0df210ca2$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($5fb01ac0df210ca2$var$isInstance(value, SharedArrayBuffer) || value && $5fb01ac0df210ca2$var$isInstance(value.buffer, SharedArrayBuffer))) return $5fb01ac0df210ca2$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $5fb01ac0df210ca2$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $5fb01ac0df210ca2$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $5fb01ac0df210ca2$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $l0HdX._)(value)));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $5fb01ac0df210ca2$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $5fb01ac0df210ca2$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($5fb01ac0df210ca2$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($5fb01ac0df210ca2$var$Buffer, Uint8Array);
function $5fb01ac0df210ca2$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $5fb01ac0df210ca2$var$alloc(size, fill, encoding) {
    $5fb01ac0df210ca2$var$assertSize(size);
    if (size <= 0) return $5fb01ac0df210ca2$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $5fb01ac0df210ca2$var$createBuffer(size).fill(fill, encoding) : $5fb01ac0df210ca2$var$createBuffer(size).fill(fill);
    return $5fb01ac0df210ca2$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $5fb01ac0df210ca2$var$Buffer.alloc = function(size, fill, encoding) {
    return $5fb01ac0df210ca2$var$alloc(size, fill, encoding);
};
function $5fb01ac0df210ca2$var$allocUnsafe(size) {
    $5fb01ac0df210ca2$var$assertSize(size);
    return $5fb01ac0df210ca2$var$createBuffer(size < 0 ? 0 : $5fb01ac0df210ca2$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $5fb01ac0df210ca2$var$Buffer.allocUnsafe = function(size) {
    return $5fb01ac0df210ca2$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $5fb01ac0df210ca2$var$Buffer.allocUnsafeSlow = function(size) {
    return $5fb01ac0df210ca2$var$allocUnsafe(size);
};
function $5fb01ac0df210ca2$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$5fb01ac0df210ca2$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $5fb01ac0df210ca2$var$byteLength(string, encoding) | 0;
    var buf = $5fb01ac0df210ca2$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $5fb01ac0df210ca2$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $5fb01ac0df210ca2$var$checked(array.length) | 0;
    var buf = $5fb01ac0df210ca2$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $5fb01ac0df210ca2$var$fromArrayView(arrayView) {
    if ($5fb01ac0df210ca2$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $5fb01ac0df210ca2$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $5fb01ac0df210ca2$var$fromArrayLike(arrayView);
}
function $5fb01ac0df210ca2$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $5fb01ac0df210ca2$var$Buffer.prototype);
    return buf;
}
function $5fb01ac0df210ca2$var$fromObject(obj) {
    if ($5fb01ac0df210ca2$var$Buffer.isBuffer(obj)) {
        var len = $5fb01ac0df210ca2$var$checked(obj.length) | 0;
        var buf = $5fb01ac0df210ca2$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $5fb01ac0df210ca2$var$numberIsNaN(obj.length)) return $5fb01ac0df210ca2$var$createBuffer(0);
        return $5fb01ac0df210ca2$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $5fb01ac0df210ca2$var$fromArrayLike(obj.data);
}
function $5fb01ac0df210ca2$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $5fb01ac0df210ca2$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $5fb01ac0df210ca2$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $5fb01ac0df210ca2$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $5fb01ac0df210ca2$var$Buffer.alloc(+length);
}
$5fb01ac0df210ca2$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $5fb01ac0df210ca2$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$5fb01ac0df210ca2$var$Buffer.compare = function compare(a, b) {
    if ($5fb01ac0df210ca2$var$isInstance(a, Uint8Array)) a = $5fb01ac0df210ca2$var$Buffer.from(a, a.offset, a.byteLength);
    if ($5fb01ac0df210ca2$var$isInstance(b, Uint8Array)) b = $5fb01ac0df210ca2$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$5fb01ac0df210ca2$var$Buffer.isBuffer(a) || !$5fb01ac0df210ca2$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$5fb01ac0df210ca2$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$5fb01ac0df210ca2$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $5fb01ac0df210ca2$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $5fb01ac0df210ca2$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($5fb01ac0df210ca2$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$5fb01ac0df210ca2$var$Buffer.isBuffer(buf)) buf = $5fb01ac0df210ca2$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$5fb01ac0df210ca2$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $5fb01ac0df210ca2$var$byteLength(string, encoding) {
    if ($5fb01ac0df210ca2$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $5fb01ac0df210ca2$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, $l0HdX._)(string)));
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $5fb01ac0df210ca2$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $5fb01ac0df210ca2$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $5fb01ac0df210ca2$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$5fb01ac0df210ca2$var$Buffer.byteLength = $5fb01ac0df210ca2$var$byteLength;
function $5fb01ac0df210ca2$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $5fb01ac0df210ca2$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $5fb01ac0df210ca2$var$utf8Slice(this, start, end);
        case "ascii":
            return $5fb01ac0df210ca2$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $5fb01ac0df210ca2$var$latin1Slice(this, start, end);
        case "base64":
            return $5fb01ac0df210ca2$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $5fb01ac0df210ca2$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$5fb01ac0df210ca2$var$Buffer.prototype._isBuffer = true;
function $5fb01ac0df210ca2$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$5fb01ac0df210ca2$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$5fb01ac0df210ca2$var$swap(this, i, i + 1);
    return this;
};
$5fb01ac0df210ca2$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $5fb01ac0df210ca2$var$swap(this, i, i + 3);
        $5fb01ac0df210ca2$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$5fb01ac0df210ca2$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $5fb01ac0df210ca2$var$swap(this, i, i + 7);
        $5fb01ac0df210ca2$var$swap(this, i + 1, i + 6);
        $5fb01ac0df210ca2$var$swap(this, i + 2, i + 5);
        $5fb01ac0df210ca2$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$5fb01ac0df210ca2$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $5fb01ac0df210ca2$var$utf8Slice(this, 0, length);
    return $5fb01ac0df210ca2$var$slowToString.apply(this, arguments);
};
$5fb01ac0df210ca2$var$Buffer.prototype.toLocaleString = $5fb01ac0df210ca2$var$Buffer.prototype.toString;
$5fb01ac0df210ca2$var$Buffer.prototype.equals = function equals(b) {
    if (!$5fb01ac0df210ca2$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $5fb01ac0df210ca2$var$Buffer.compare(this, b) === 0;
};
$5fb01ac0df210ca2$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $5fb01ac0df210ca2$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($5fb01ac0df210ca2$var$customInspectSymbol) $5fb01ac0df210ca2$var$Buffer.prototype[$5fb01ac0df210ca2$var$customInspectSymbol] = $5fb01ac0df210ca2$var$Buffer.prototype.inspect;
$5fb01ac0df210ca2$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($5fb01ac0df210ca2$var$isInstance(target, Uint8Array)) target = $5fb01ac0df210ca2$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$5fb01ac0df210ca2$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, $l0HdX._)(target)));
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $5fb01ac0df210ca2$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($5fb01ac0df210ca2$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $5fb01ac0df210ca2$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($5fb01ac0df210ca2$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $5fb01ac0df210ca2$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $5fb01ac0df210ca2$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $5fb01ac0df210ca2$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$5fb01ac0df210ca2$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$5fb01ac0df210ca2$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $5fb01ac0df210ca2$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$5fb01ac0df210ca2$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $5fb01ac0df210ca2$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $5fb01ac0df210ca2$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    var i;
    for(i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($5fb01ac0df210ca2$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $5fb01ac0df210ca2$var$utf8Write(buf, string, offset, length) {
    return $5fb01ac0df210ca2$var$blitBuffer($5fb01ac0df210ca2$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $5fb01ac0df210ca2$var$asciiWrite(buf, string, offset, length) {
    return $5fb01ac0df210ca2$var$blitBuffer($5fb01ac0df210ca2$var$asciiToBytes(string), buf, offset, length);
}
function $5fb01ac0df210ca2$var$base64Write(buf, string, offset, length) {
    return $5fb01ac0df210ca2$var$blitBuffer($5fb01ac0df210ca2$var$base64ToBytes(string), buf, offset, length);
}
function $5fb01ac0df210ca2$var$ucs2Write(buf, string, offset, length) {
    return $5fb01ac0df210ca2$var$blitBuffer($5fb01ac0df210ca2$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$5fb01ac0df210ca2$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $5fb01ac0df210ca2$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $5fb01ac0df210ca2$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $5fb01ac0df210ca2$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $5fb01ac0df210ca2$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $5fb01ac0df210ca2$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$5fb01ac0df210ca2$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $5fb01ac0df210ca2$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $iB1U9.fromByteArray(buf);
    else return $iB1U9.fromByteArray(buf.slice(start, end));
}
function $5fb01ac0df210ca2$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte = void 0, thirdByte = void 0, fourthByte = void 0, tempCodePoint = void 0;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $5fb01ac0df210ca2$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $5fb01ac0df210ca2$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $5fb01ac0df210ca2$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $5fb01ac0df210ca2$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $5fb01ac0df210ca2$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $5fb01ac0df210ca2$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $5fb01ac0df210ca2$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $5fb01ac0df210ca2$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $5fb01ac0df210ca2$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $5fb01ac0df210ca2$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$5fb01ac0df210ca2$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $5fb01ac0df210ca2$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $5fb01ac0df210ca2$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$5fb01ac0df210ca2$var$Buffer.prototype.readUintLE = $5fb01ac0df210ca2$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$5fb01ac0df210ca2$var$Buffer.prototype.readUintBE = $5fb01ac0df210ca2$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$5fb01ac0df210ca2$var$Buffer.prototype.readUint8 = $5fb01ac0df210ca2$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$5fb01ac0df210ca2$var$Buffer.prototype.readUint16LE = $5fb01ac0df210ca2$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$5fb01ac0df210ca2$var$Buffer.prototype.readUint16BE = $5fb01ac0df210ca2$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$5fb01ac0df210ca2$var$Buffer.prototype.readUint32LE = $5fb01ac0df210ca2$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$5fb01ac0df210ca2$var$Buffer.prototype.readUint32BE = $5fb01ac0df210ca2$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$5fb01ac0df210ca2$var$Buffer.prototype.readBigUInt64LE = $5fb01ac0df210ca2$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $5fb01ac0df210ca2$var$validateNumber(offset, "offset");
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $5fb01ac0df210ca2$var$boundsError(offset, this.length - 8);
    var lo = first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
    var hi = this[++offset] + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$5fb01ac0df210ca2$var$Buffer.prototype.readBigUInt64BE = $5fb01ac0df210ca2$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $5fb01ac0df210ca2$var$validateNumber(offset, "offset");
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $5fb01ac0df210ca2$var$boundsError(offset, this.length - 8);
    var hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    var lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$5fb01ac0df210ca2$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$5fb01ac0df210ca2$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$5fb01ac0df210ca2$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$5fb01ac0df210ca2$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$5fb01ac0df210ca2$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$5fb01ac0df210ca2$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$5fb01ac0df210ca2$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$5fb01ac0df210ca2$var$Buffer.prototype.readBigInt64LE = $5fb01ac0df210ca2$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $5fb01ac0df210ca2$var$validateNumber(offset, "offset");
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $5fb01ac0df210ca2$var$boundsError(offset, this.length - 8);
    var val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * Math.pow(2, 16) + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
});
$5fb01ac0df210ca2$var$Buffer.prototype.readBigInt64BE = $5fb01ac0df210ca2$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $5fb01ac0df210ca2$var$validateNumber(offset, "offset");
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $5fb01ac0df210ca2$var$boundsError(offset, this.length - 8);
    var val = (first << 24) + // Overflow
    this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last);
});
$5fb01ac0df210ca2$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkOffset(offset, 4, this.length);
    return $7ls3U.read(this, offset, true, 23, 4);
};
$5fb01ac0df210ca2$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkOffset(offset, 4, this.length);
    return $7ls3U.read(this, offset, false, 23, 4);
};
$5fb01ac0df210ca2$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkOffset(offset, 8, this.length);
    return $7ls3U.read(this, offset, true, 52, 8);
};
$5fb01ac0df210ca2$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkOffset(offset, 8, this.length);
    return $7ls3U.read(this, offset, false, 52, 8);
};
function $5fb01ac0df210ca2$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$5fb01ac0df210ca2$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$5fb01ac0df210ca2$var$Buffer.prototype.writeUintLE = $5fb01ac0df210ca2$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $5fb01ac0df210ca2$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$5fb01ac0df210ca2$var$Buffer.prototype.writeUintBE = $5fb01ac0df210ca2$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $5fb01ac0df210ca2$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$5fb01ac0df210ca2$var$Buffer.prototype.writeUint8 = $5fb01ac0df210ca2$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$5fb01ac0df210ca2$var$Buffer.prototype.writeUint16LE = $5fb01ac0df210ca2$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$5fb01ac0df210ca2$var$Buffer.prototype.writeUint16BE = $5fb01ac0df210ca2$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$5fb01ac0df210ca2$var$Buffer.prototype.writeUint32LE = $5fb01ac0df210ca2$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$5fb01ac0df210ca2$var$Buffer.prototype.writeUint32BE = $5fb01ac0df210ca2$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $5fb01ac0df210ca2$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $5fb01ac0df210ca2$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $5fb01ac0df210ca2$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $5fb01ac0df210ca2$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$5fb01ac0df210ca2$var$Buffer.prototype.writeBigUInt64LE = $5fb01ac0df210ca2$var$defineBigIntMethod(function writeBigUInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $5fb01ac0df210ca2$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$5fb01ac0df210ca2$var$Buffer.prototype.writeBigUInt64BE = $5fb01ac0df210ca2$var$defineBigIntMethod(function writeBigUInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $5fb01ac0df210ca2$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$5fb01ac0df210ca2$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $5fb01ac0df210ca2$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$5fb01ac0df210ca2$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $5fb01ac0df210ca2$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$5fb01ac0df210ca2$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$5fb01ac0df210ca2$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$5fb01ac0df210ca2$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$5fb01ac0df210ca2$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$5fb01ac0df210ca2$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$5fb01ac0df210ca2$var$Buffer.prototype.writeBigInt64LE = $5fb01ac0df210ca2$var$defineBigIntMethod(function writeBigInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $5fb01ac0df210ca2$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$5fb01ac0df210ca2$var$Buffer.prototype.writeBigInt64BE = $5fb01ac0df210ca2$var$defineBigIntMethod(function writeBigInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $5fb01ac0df210ca2$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $5fb01ac0df210ca2$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $5fb01ac0df210ca2$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7ls3U.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$5fb01ac0df210ca2$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $5fb01ac0df210ca2$var$writeFloat(this, value, offset, true, noAssert);
};
$5fb01ac0df210ca2$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $5fb01ac0df210ca2$var$writeFloat(this, value, offset, false, noAssert);
};
function $5fb01ac0df210ca2$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7ls3U.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$5fb01ac0df210ca2$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $5fb01ac0df210ca2$var$writeDouble(this, value, offset, true, noAssert);
};
$5fb01ac0df210ca2$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $5fb01ac0df210ca2$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$5fb01ac0df210ca2$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$5fb01ac0df210ca2$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$5fb01ac0df210ca2$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$5fb01ac0df210ca2$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $5fb01ac0df210ca2$var$Buffer.isBuffer(val) ? val : $5fb01ac0df210ca2$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
var $5fb01ac0df210ca2$var$errors = {};
function $5fb01ac0df210ca2$var$E(sym, getMessage, Base) {
    $5fb01ac0df210ca2$var$errors[sym] = /*#__PURE__*/ function(Base) {
        (0, $dcsZi._)(NodeError, Base);
        var _super = (0, $ohfOJ._)(NodeError);
        function NodeError() {
            (0, $4GJKx._)(this, NodeError);
            var _this;
            _this = _super.call(this);
            Object.defineProperty((0, $d3H5E._)(_this), "message", {
                value: getMessage.apply((0, $d3H5E._)(_this), arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            _this.name = "".concat(_this.name, " [").concat(sym, "]");
            // Access the stack to generate the error message including the error code
            // from the name.
            _this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete _this.name;
            return _this;
        }
        (0, $1wc17._)(NodeError, [
            {
                key: "code",
                get: function get() {
                    return sym;
                },
                set: function set(value) {
                    Object.defineProperty(this, "code", {
                        configurable: true,
                        enumerable: true,
                        value: value,
                        writable: true
                    });
                }
            },
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(sym, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
}
$5fb01ac0df210ca2$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return "".concat(name, " is outside of buffer bounds");
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$5fb01ac0df210ca2$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return 'The "'.concat(name, '" argument must be of type number. Received type ').concat(typeof actual === "undefined" ? "undefined" : (0, $l0HdX._)(actual));
}, TypeError);
$5fb01ac0df210ca2$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    var msg = 'The value of "'.concat(str, '" is out of range.');
    var received = input;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $5fb01ac0df210ca2$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $l0HdX._)(input)) === "bigint") {
        received = String(input);
        if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) received = $5fb01ac0df210ca2$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += " It must be ".concat(range, ". Received ").concat(received);
    return msg;
}, RangeError);
function $5fb01ac0df210ca2$var$addNumericalSeparator(val) {
    var res = "";
    var i = val.length;
    var start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
// CHECK FUNCTIONS
// ===============
function $5fb01ac0df210ca2$var$checkBounds(buf, offset, byteLength) {
    $5fb01ac0df210ca2$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $5fb01ac0df210ca2$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $5fb01ac0df210ca2$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        var n = (typeof min === "undefined" ? "undefined" : (0, $l0HdX._)(min)) === "bigint" ? "n" : "";
        var range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = ">= 0".concat(n, " and < 2").concat(n, " ** ").concat((byteLength + 1) * 8).concat(n);
            else range = ">= -(2".concat(n, " ** ").concat((byteLength + 1) * 8 - 1).concat(n, ") and < 2 ** ") + "".concat((byteLength + 1) * 8 - 1).concat(n);
        } else range = ">= ".concat(min).concat(n, " and <= ").concat(max).concat(n);
        throw new $5fb01ac0df210ca2$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $5fb01ac0df210ca2$var$checkBounds(buf, offset, byteLength);
}
function $5fb01ac0df210ca2$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $5fb01ac0df210ca2$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $5fb01ac0df210ca2$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $5fb01ac0df210ca2$var$validateNumber(value, type);
        throw new $5fb01ac0df210ca2$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $5fb01ac0df210ca2$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $5fb01ac0df210ca2$var$errors.ERR_OUT_OF_RANGE(type || "offset", ">= ".concat(type ? 1 : 0, " and <= ").concat(length), value);
}
// HELPER FUNCTIONS
// ================
var $5fb01ac0df210ca2$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $5fb01ac0df210ca2$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($5fb01ac0df210ca2$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $5fb01ac0df210ca2$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $5fb01ac0df210ca2$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $5fb01ac0df210ca2$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $5fb01ac0df210ca2$var$base64ToBytes(str) {
    return $iB1U9.toByteArray($5fb01ac0df210ca2$var$base64clean(str));
}
function $5fb01ac0df210ca2$var$blitBuffer(src, dst, offset, length) {
    var i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $5fb01ac0df210ca2$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $5fb01ac0df210ca2$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $5fb01ac0df210ca2$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $5fb01ac0df210ca2$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $5fb01ac0df210ca2$var$BufferBigIntNotDefined : fn;
}
function $5fb01ac0df210ca2$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("iB1U9", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $d89d28ee65638e83$export$d622b2ad8d90c771; }, function (v) { return $d89d28ee65638e83$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $d89d28ee65638e83$export$6100ba28696e12de; }, function (v) { return $d89d28ee65638e83$export$6100ba28696e12de = v; });
var $d89d28ee65638e83$export$a48f0734ac7c2329;
var $d89d28ee65638e83$export$d622b2ad8d90c771;
var $d89d28ee65638e83$export$6100ba28696e12de;
"use strict";
$d89d28ee65638e83$export$a48f0734ac7c2329 = $d89d28ee65638e83$var$byteLength;
$d89d28ee65638e83$export$d622b2ad8d90c771 = $d89d28ee65638e83$var$toByteArray;
$d89d28ee65638e83$export$6100ba28696e12de = $d89d28ee65638e83$var$fromByteArray;
var $d89d28ee65638e83$var$lookup = [];
var $d89d28ee65638e83$var$revLookup = [];
var $d89d28ee65638e83$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $d89d28ee65638e83$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $d89d28ee65638e83$var$i = 0, $d89d28ee65638e83$var$len = $d89d28ee65638e83$var$code.length; $d89d28ee65638e83$var$i < $d89d28ee65638e83$var$len; ++$d89d28ee65638e83$var$i){
    $d89d28ee65638e83$var$lookup[$d89d28ee65638e83$var$i] = $d89d28ee65638e83$var$code[$d89d28ee65638e83$var$i];
    $d89d28ee65638e83$var$revLookup[$d89d28ee65638e83$var$code.charCodeAt($d89d28ee65638e83$var$i)] = $d89d28ee65638e83$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$d89d28ee65638e83$var$revLookup["-".charCodeAt(0)] = 62;
$d89d28ee65638e83$var$revLookup["_".charCodeAt(0)] = 63;
function $d89d28ee65638e83$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $d89d28ee65638e83$var$byteLength(b64) {
    var lens = $d89d28ee65638e83$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $d89d28ee65638e83$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $d89d28ee65638e83$var$toByteArray(b64) {
    var tmp;
    var lens = $d89d28ee65638e83$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $d89d28ee65638e83$var$Arr($d89d28ee65638e83$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $d89d28ee65638e83$var$revLookup[b64.charCodeAt(i)] << 18 | $d89d28ee65638e83$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $d89d28ee65638e83$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $d89d28ee65638e83$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $d89d28ee65638e83$var$revLookup[b64.charCodeAt(i)] << 2 | $d89d28ee65638e83$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $d89d28ee65638e83$var$revLookup[b64.charCodeAt(i)] << 10 | $d89d28ee65638e83$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $d89d28ee65638e83$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $d89d28ee65638e83$var$tripletToBase64(num) {
    return $d89d28ee65638e83$var$lookup[num >> 18 & 0x3F] + $d89d28ee65638e83$var$lookup[num >> 12 & 0x3F] + $d89d28ee65638e83$var$lookup[num >> 6 & 0x3F] + $d89d28ee65638e83$var$lookup[num & 0x3F];
}
function $d89d28ee65638e83$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($d89d28ee65638e83$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $d89d28ee65638e83$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($d89d28ee65638e83$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($d89d28ee65638e83$var$lookup[tmp >> 2] + $d89d28ee65638e83$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($d89d28ee65638e83$var$lookup[tmp >> 10] + $d89d28ee65638e83$var$lookup[tmp >> 4 & 0x3F] + $d89d28ee65638e83$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("7ls3U", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $5590431cd58e8b92$export$aafa59e2e03f2942; }, function (v) { return $5590431cd58e8b92$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $5590431cd58e8b92$export$68d8715fc104d294; }, function (v) { return $5590431cd58e8b92$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $5590431cd58e8b92$export$aafa59e2e03f2942;
var $5590431cd58e8b92$export$68d8715fc104d294;
$5590431cd58e8b92$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$5590431cd58e8b92$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});




parcelRegister("iX9BE", function(module, exports) {
"use strict";

var $hwgCU = parcelRequire("hwgCU");

var $d6CkU = parcelRequire("d6CkU");

var $hEcOA = parcelRequire("hEcOA");

var $2K8vW = parcelRequire("2K8vW");

var $3iWnY = parcelRequire("3iWnY");
function $dcc53049d4569c01$var$Hash(hash) {
    $3iWnY.call(this, "digest");
    this._hash = hash;
}
$hwgCU($dcc53049d4569c01$var$Hash, $3iWnY);
$dcc53049d4569c01$var$Hash.prototype._update = function(data) {
    this._hash.update(data);
};
$dcc53049d4569c01$var$Hash.prototype._final = function() {
    return this._hash.digest();
};
module.exports = function createHash(alg) {
    alg = alg.toLowerCase();
    if (alg === "md5") return new $d6CkU();
    if (alg === "rmd160" || alg === "ripemd160") return new $hEcOA();
    return new $dcc53049d4569c01$var$Hash($2K8vW(alg));
};

});
parcelRegister("hwgCU", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function TempCtor() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("d6CkU", function(module, exports) {
"use strict";

var $hwgCU = parcelRequire("hwgCU");

var $2CWxM = parcelRequire("2CWxM");

var $f6JDE = parcelRequire("f6JDE");
var $98a992aa2242396d$require$Buffer = $f6JDE.Buffer;
var $98a992aa2242396d$var$ARRAY16 = new Array(16);
function $98a992aa2242396d$var$MD5() {
    $2CWxM.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
}
$hwgCU($98a992aa2242396d$var$MD5, $2CWxM);
$98a992aa2242396d$var$MD5.prototype._update = function() {
    var M = $98a992aa2242396d$var$ARRAY16;
    for(var i = 0; i < 16; ++i)M[i] = this._block.readInt32LE(i * 4);
    var a = this._a;
    var b = this._b;
    var c = this._c;
    var d = this._d;
    a = $98a992aa2242396d$var$fnF(a, b, c, d, M[0], 0xd76aa478, 7);
    d = $98a992aa2242396d$var$fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
    c = $98a992aa2242396d$var$fnF(c, d, a, b, M[2], 0x242070db, 17);
    b = $98a992aa2242396d$var$fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
    a = $98a992aa2242396d$var$fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
    d = $98a992aa2242396d$var$fnF(d, a, b, c, M[5], 0x4787c62a, 12);
    c = $98a992aa2242396d$var$fnF(c, d, a, b, M[6], 0xa8304613, 17);
    b = $98a992aa2242396d$var$fnF(b, c, d, a, M[7], 0xfd469501, 22);
    a = $98a992aa2242396d$var$fnF(a, b, c, d, M[8], 0x698098d8, 7);
    d = $98a992aa2242396d$var$fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
    c = $98a992aa2242396d$var$fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
    b = $98a992aa2242396d$var$fnF(b, c, d, a, M[11], 0x895cd7be, 22);
    a = $98a992aa2242396d$var$fnF(a, b, c, d, M[12], 0x6b901122, 7);
    d = $98a992aa2242396d$var$fnF(d, a, b, c, M[13], 0xfd987193, 12);
    c = $98a992aa2242396d$var$fnF(c, d, a, b, M[14], 0xa679438e, 17);
    b = $98a992aa2242396d$var$fnF(b, c, d, a, M[15], 0x49b40821, 22);
    a = $98a992aa2242396d$var$fnG(a, b, c, d, M[1], 0xf61e2562, 5);
    d = $98a992aa2242396d$var$fnG(d, a, b, c, M[6], 0xc040b340, 9);
    c = $98a992aa2242396d$var$fnG(c, d, a, b, M[11], 0x265e5a51, 14);
    b = $98a992aa2242396d$var$fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
    a = $98a992aa2242396d$var$fnG(a, b, c, d, M[5], 0xd62f105d, 5);
    d = $98a992aa2242396d$var$fnG(d, a, b, c, M[10], 0x02441453, 9);
    c = $98a992aa2242396d$var$fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
    b = $98a992aa2242396d$var$fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
    a = $98a992aa2242396d$var$fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
    d = $98a992aa2242396d$var$fnG(d, a, b, c, M[14], 0xc33707d6, 9);
    c = $98a992aa2242396d$var$fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
    b = $98a992aa2242396d$var$fnG(b, c, d, a, M[8], 0x455a14ed, 20);
    a = $98a992aa2242396d$var$fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
    d = $98a992aa2242396d$var$fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
    c = $98a992aa2242396d$var$fnG(c, d, a, b, M[7], 0x676f02d9, 14);
    b = $98a992aa2242396d$var$fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
    a = $98a992aa2242396d$var$fnH(a, b, c, d, M[5], 0xfffa3942, 4);
    d = $98a992aa2242396d$var$fnH(d, a, b, c, M[8], 0x8771f681, 11);
    c = $98a992aa2242396d$var$fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
    b = $98a992aa2242396d$var$fnH(b, c, d, a, M[14], 0xfde5380c, 23);
    a = $98a992aa2242396d$var$fnH(a, b, c, d, M[1], 0xa4beea44, 4);
    d = $98a992aa2242396d$var$fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
    c = $98a992aa2242396d$var$fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
    b = $98a992aa2242396d$var$fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
    a = $98a992aa2242396d$var$fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
    d = $98a992aa2242396d$var$fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
    c = $98a992aa2242396d$var$fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
    b = $98a992aa2242396d$var$fnH(b, c, d, a, M[6], 0x04881d05, 23);
    a = $98a992aa2242396d$var$fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
    d = $98a992aa2242396d$var$fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
    c = $98a992aa2242396d$var$fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
    b = $98a992aa2242396d$var$fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
    a = $98a992aa2242396d$var$fnI(a, b, c, d, M[0], 0xf4292244, 6);
    d = $98a992aa2242396d$var$fnI(d, a, b, c, M[7], 0x432aff97, 10);
    c = $98a992aa2242396d$var$fnI(c, d, a, b, M[14], 0xab9423a7, 15);
    b = $98a992aa2242396d$var$fnI(b, c, d, a, M[5], 0xfc93a039, 21);
    a = $98a992aa2242396d$var$fnI(a, b, c, d, M[12], 0x655b59c3, 6);
    d = $98a992aa2242396d$var$fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
    c = $98a992aa2242396d$var$fnI(c, d, a, b, M[10], 0xffeff47d, 15);
    b = $98a992aa2242396d$var$fnI(b, c, d, a, M[1], 0x85845dd1, 21);
    a = $98a992aa2242396d$var$fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
    d = $98a992aa2242396d$var$fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
    c = $98a992aa2242396d$var$fnI(c, d, a, b, M[6], 0xa3014314, 15);
    b = $98a992aa2242396d$var$fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
    a = $98a992aa2242396d$var$fnI(a, b, c, d, M[4], 0xf7537e82, 6);
    d = $98a992aa2242396d$var$fnI(d, a, b, c, M[11], 0xbd3af235, 10);
    c = $98a992aa2242396d$var$fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
    b = $98a992aa2242396d$var$fnI(b, c, d, a, M[9], 0xeb86d391, 21);
    this._a = this._a + a | 0;
    this._b = this._b + b | 0;
    this._c = this._c + c | 0;
    this._d = this._d + d | 0;
};
$98a992aa2242396d$var$MD5.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $98a992aa2242396d$require$Buffer.allocUnsafe(16);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    return buffer;
};
function $98a992aa2242396d$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $98a992aa2242396d$var$fnF(a, b, c, d, m, k, s) {
    return $98a992aa2242396d$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
}
function $98a992aa2242396d$var$fnG(a, b, c, d, m, k, s) {
    return $98a992aa2242396d$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
}
function $98a992aa2242396d$var$fnH(a, b, c, d, m, k, s) {
    return $98a992aa2242396d$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
}
function $98a992aa2242396d$var$fnI(a, b, c, d, m, k, s) {
    return $98a992aa2242396d$var$rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
}
module.exports = $98a992aa2242396d$var$MD5;

});
parcelRegister("2CWxM", function(module, exports) {
"use strict";

var $f6JDE = parcelRequire("f6JDE");
var $1e9c8af926768e88$require$Buffer = $f6JDE.Buffer;

var $9zh20 = parcelRequire("9zh20");
var $1e9c8af926768e88$require$Transform = $9zh20.Transform;

var $hwgCU = parcelRequire("hwgCU");
function $1e9c8af926768e88$var$throwIfNotStringOrBuffer(val, prefix) {
    if (!$1e9c8af926768e88$require$Buffer.isBuffer(val) && typeof val !== "string") throw new TypeError(prefix + " must be a string or a buffer");
}
function $1e9c8af926768e88$var$HashBase(blockSize) {
    $1e9c8af926768e88$require$Transform.call(this);
    this._block = $1e9c8af926768e88$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$hwgCU($1e9c8af926768e88$var$HashBase, $1e9c8af926768e88$require$Transform);
$1e9c8af926768e88$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$1e9c8af926768e88$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
$1e9c8af926768e88$var$HashBase.prototype.update = function(data, encoding) {
    $1e9c8af926768e88$var$throwIfNotStringOrBuffer(data, "Data");
    if (this._finalized) throw new Error("Digest already called");
    if (!$1e9c8af926768e88$require$Buffer.isBuffer(data)) data = $1e9c8af926768e88$require$Buffer.from(data, encoding);
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + data.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;)block[i++] = data[offset++];
        this._update();
        this._blockOffset = 0;
    }
    while(offset < data.length)block[this._blockOffset++] = data[offset++];
    // update length
    for(var j = 0, carry = data.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$1e9c8af926768e88$var$HashBase.prototype._update = function() {
    throw new Error("_update is not implemented");
};
$1e9c8af926768e88$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error("Digest already called");
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$1e9c8af926768e88$var$HashBase.prototype._digest = function() {
    throw new Error("_digest is not implemented");
};
module.exports = $1e9c8af926768e88$var$HashBase;

});
parcelRegister("9zh20", function(module, exports) {

exports = module.exports = (parcelRequire("kNQv4"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("giiCg"));

exports.Duplex = (parcelRequire("kPQvy"));

exports.Transform = (parcelRequire("43NjS"));

exports.PassThrough = (parcelRequire("c04gS"));

exports.finished = (parcelRequire("9YDMx"));

exports.pipeline = (parcelRequire("bmpl8"));

});
parcelRegister("kNQv4", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $3qWgZ = parcelRequire("3qWgZ");
"use strict";
module.exports = $f2511bb04321984c$var$Readable;
/*<replacement>*/ var $f2511bb04321984c$var$Duplex;
/*</replacement>*/ $f2511bb04321984c$var$Readable.ReadableState = $f2511bb04321984c$var$ReadableState;

var $cyxGb = parcelRequire("cyxGb");
var $f2511bb04321984c$require$EE = $cyxGb.EventEmitter;
var $f2511bb04321984c$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $4GfFr = parcelRequire("4GfFr");

var $8dlmd = parcelRequire("8dlmd");
var $f2511bb04321984c$require$Buffer = $8dlmd.Buffer;
var $f2511bb04321984c$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $f2511bb04321984c$var$_uint8ArrayToBuffer(chunk) {
    return $f2511bb04321984c$require$Buffer.from(chunk);
}
function $f2511bb04321984c$var$_isUint8Array(obj) {
    return $f2511bb04321984c$require$Buffer.isBuffer(obj) || obj instanceof $f2511bb04321984c$var$OurUint8Array;
}

var $9dH9K = parcelRequire("9dH9K");
var $f2511bb04321984c$var$debug;
if ($9dH9K && $9dH9K.debuglog) $f2511bb04321984c$var$debug = $9dH9K.debuglog("stream");
else $f2511bb04321984c$var$debug = function debug() {};

var $9KJLc = parcelRequire("9KJLc");

var $37y91 = parcelRequire("37y91");

var $7s2Xd = parcelRequire("7s2Xd");
var $f2511bb04321984c$var$getHighWaterMark = $7s2Xd.getHighWaterMark;

var $1PYlf = parcelRequire("1PYlf");
var $f2511bb04321984c$require$_require$codes = $1PYlf.codes;
var $f2511bb04321984c$var$ERR_INVALID_ARG_TYPE = $f2511bb04321984c$require$_require$codes.ERR_INVALID_ARG_TYPE, $f2511bb04321984c$var$ERR_STREAM_PUSH_AFTER_EOF = $f2511bb04321984c$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $f2511bb04321984c$var$ERR_METHOD_NOT_IMPLEMENTED = $f2511bb04321984c$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $f2511bb04321984c$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $f2511bb04321984c$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $f2511bb04321984c$var$StringDecoder;
var $f2511bb04321984c$var$createReadableStreamAsyncIterator;
var $f2511bb04321984c$var$from;

(parcelRequire("hwgCU"))($f2511bb04321984c$var$Readable, $4GfFr);
var $f2511bb04321984c$var$errorOrDestroy = $37y91.errorOrDestroy;
var $f2511bb04321984c$var$kProxyEvents = [
    "error",
    "close",
    "destroy",
    "pause",
    "resume"
];
function $f2511bb04321984c$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $f2511bb04321984c$var$ReadableState(options, stream, isDuplex) {
    $f2511bb04321984c$var$Duplex = $f2511bb04321984c$var$Duplex || (parcelRequire("kPQvy"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $f2511bb04321984c$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $f2511bb04321984c$var$getHighWaterMark(this, options, "readableHighWaterMark", isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $9KJLc();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$f2511bb04321984c$var$StringDecoder) $f2511bb04321984c$var$StringDecoder = (parcelRequire("3q4dM")).StringDecoder;
        this.decoder = new $f2511bb04321984c$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $f2511bb04321984c$var$Readable(options) {
    $f2511bb04321984c$var$Duplex = $f2511bb04321984c$var$Duplex || (parcelRequire("kPQvy"));
    if (!(this instanceof $f2511bb04321984c$var$Readable)) return new $f2511bb04321984c$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $f2511bb04321984c$var$Duplex;
    this._readableState = new $f2511bb04321984c$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
    }
    $4GfFr.call(this);
}
Object.defineProperty($f2511bb04321984c$var$Readable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$f2511bb04321984c$var$Readable.prototype.destroy = $37y91.destroy;
$f2511bb04321984c$var$Readable.prototype._undestroy = $37y91.undestroy;
$f2511bb04321984c$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$f2511bb04321984c$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $f2511bb04321984c$require$Buffer.from(chunk, encoding);
                encoding = "";
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $f2511bb04321984c$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$f2511bb04321984c$var$Readable.prototype.unshift = function(chunk) {
    return $f2511bb04321984c$var$readableAddChunk(this, chunk, null, true, false);
};
function $f2511bb04321984c$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $f2511bb04321984c$var$debug("readableAddChunk", chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $f2511bb04321984c$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $f2511bb04321984c$var$chunkInvalid(state, chunk);
        if (er) $f2511bb04321984c$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== $f2511bb04321984c$require$Buffer.prototype) chunk = $f2511bb04321984c$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $f2511bb04321984c$var$errorOrDestroy(stream, new $f2511bb04321984c$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $f2511bb04321984c$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $f2511bb04321984c$var$errorOrDestroy(stream, new $f2511bb04321984c$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $f2511bb04321984c$var$addChunk(stream, state, chunk, false);
                    else $f2511bb04321984c$var$maybeReadMore(stream, state);
                } else $f2511bb04321984c$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $f2511bb04321984c$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $f2511bb04321984c$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit("data", chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $f2511bb04321984c$var$emitReadable(stream);
    }
    $f2511bb04321984c$var$maybeReadMore(stream, state);
}
function $f2511bb04321984c$var$chunkInvalid(state, chunk) {
    var er;
    if (!$f2511bb04321984c$var$_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new $f2511bb04321984c$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer",
        "Uint8Array"
    ], chunk);
    return er;
}
$f2511bb04321984c$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$f2511bb04321984c$var$Readable.prototype.setEncoding = function(enc) {
    if (!$f2511bb04321984c$var$StringDecoder) $f2511bb04321984c$var$StringDecoder = (parcelRequire("3q4dM")).StringDecoder;
    var decoder = new $f2511bb04321984c$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = "";
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== "") this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $f2511bb04321984c$var$MAX_HWM = 0x40000000;
function $f2511bb04321984c$var$computeNewHighWaterMark(n) {
    if (n >= $f2511bb04321984c$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $f2511bb04321984c$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $f2511bb04321984c$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $f2511bb04321984c$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$f2511bb04321984c$var$Readable.prototype.read = function(n) {
    $f2511bb04321984c$var$debug("read", n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $f2511bb04321984c$var$debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) $f2511bb04321984c$var$endReadable(this);
        else $f2511bb04321984c$var$emitReadable(this);
        return null;
    }
    n = $f2511bb04321984c$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $f2511bb04321984c$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $f2511bb04321984c$var$debug("need readable", doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $f2511bb04321984c$var$debug("length less than watermark", doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $f2511bb04321984c$var$debug("reading or ended", doRead);
    } else if (doRead) {
        $f2511bb04321984c$var$debug("do read");
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $f2511bb04321984c$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $f2511bb04321984c$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $f2511bb04321984c$var$endReadable(this);
    }
    if (ret !== null) this.emit("data", ret);
    return ret;
};
function $f2511bb04321984c$var$onEofChunk(stream, state) {
    $f2511bb04321984c$var$debug("onEofChunk");
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $f2511bb04321984c$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $f2511bb04321984c$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $f2511bb04321984c$var$emitReadable(stream) {
    var state = stream._readableState;
    $f2511bb04321984c$var$debug("emitReadable", state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $f2511bb04321984c$var$debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        $3qWgZ.nextTick($f2511bb04321984c$var$emitReadable_, stream);
    }
}
function $f2511bb04321984c$var$emitReadable_(stream) {
    var state = stream._readableState;
    $f2511bb04321984c$var$debug("emitReadable_", state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit("readable");
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $f2511bb04321984c$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $f2511bb04321984c$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $3qWgZ.nextTick($f2511bb04321984c$var$maybeReadMore_, stream, state);
    }
}
function $f2511bb04321984c$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $f2511bb04321984c$var$debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$f2511bb04321984c$var$Readable.prototype._read = function(n) {
    $f2511bb04321984c$var$errorOrDestroy(this, new $f2511bb04321984c$var$ERR_METHOD_NOT_IMPLEMENTED("_read()"));
};
$f2511bb04321984c$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $f2511bb04321984c$var$debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $3qWgZ.stdout && dest !== $3qWgZ.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $3qWgZ.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $f2511bb04321984c$var$debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $f2511bb04321984c$var$debug("onend");
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $f2511bb04321984c$var$pipeOnDrain(src);
    dest.on("drain", ondrain);
    var cleanedUp = false;
    function cleanup() {
        $f2511bb04321984c$var$debug("cleanup");
        // cleanup event handlers once the pipe is broken
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on("data", ondata);
    function ondata(chunk) {
        $f2511bb04321984c$var$debug("ondata");
        var ret = dest.write(chunk);
        $f2511bb04321984c$var$debug("dest.write", ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $f2511bb04321984c$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $f2511bb04321984c$var$debug("false write response, pause", state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $f2511bb04321984c$var$debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if ($f2511bb04321984c$var$EElistenerCount(dest, "error") === 0) $f2511bb04321984c$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $f2511bb04321984c$var$prependListener(dest, "error", onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        $f2511bb04321984c$var$debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        $f2511bb04321984c$var$debug("unpipe");
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit("pipe", src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $f2511bb04321984c$var$debug("pipe resume");
        src.resume();
    }
    return dest;
};
function $f2511bb04321984c$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $f2511bb04321984c$var$debug("pipeOnDrain", state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $f2511bb04321984c$var$EElistenerCount(src, "data")) {
            state.flowing = true;
            $f2511bb04321984c$var$flow(src);
        }
    };
}
$f2511bb04321984c$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit("unpipe", this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $f2511bb04321984c$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit("unpipe", this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$f2511bb04321984c$var$Readable.prototype.on = function(ev, fn) {
    var res = $4GfFr.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === "data") {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount("readable") > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === "readable") {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $f2511bb04321984c$var$debug("on readable", state.length, state.reading);
            if (state.length) $f2511bb04321984c$var$emitReadable(this);
            else if (!state.reading) $3qWgZ.nextTick($f2511bb04321984c$var$nReadingNextTick, this);
        }
    }
    return res;
};
$f2511bb04321984c$var$Readable.prototype.addListener = $f2511bb04321984c$var$Readable.prototype.on;
$f2511bb04321984c$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $4GfFr.prototype.removeListener.call(this, ev, fn);
    if (ev === "readable") // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $3qWgZ.nextTick($f2511bb04321984c$var$updateReadableListening, this);
    return res;
};
$f2511bb04321984c$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $4GfFr.prototype.removeAllListeners.apply(this, arguments);
    if (ev === "readable" || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $3qWgZ.nextTick($f2511bb04321984c$var$updateReadableListening, this);
    return res;
};
function $f2511bb04321984c$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount("readable") > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount("data") > 0) self1.resume();
}
function $f2511bb04321984c$var$nReadingNextTick(self1) {
    $f2511bb04321984c$var$debug("readable nexttick read 0");
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$f2511bb04321984c$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $f2511bb04321984c$var$debug("resume");
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $f2511bb04321984c$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $f2511bb04321984c$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $3qWgZ.nextTick($f2511bb04321984c$var$resume_, stream, state);
    }
}
function $f2511bb04321984c$var$resume_(stream, state) {
    $f2511bb04321984c$var$debug("resume", state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit("resume");
    $f2511bb04321984c$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$f2511bb04321984c$var$Readable.prototype.pause = function() {
    $f2511bb04321984c$var$debug("call pause flowing=%j", this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $f2511bb04321984c$var$debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    this._readableState.paused = true;
    return this;
};
function $f2511bb04321984c$var$flow(stream) {
    var state = stream._readableState;
    $f2511bb04321984c$var$debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$f2511bb04321984c$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on("end", function() {
        $f2511bb04321984c$var$debug("wrapped end");
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on("data", function(chunk) {
        $f2511bb04321984c$var$debug("wrapped data");
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $f2511bb04321984c$var$kProxyEvents.length; n++)stream.on($f2511bb04321984c$var$kProxyEvents[n], this.emit.bind(this, $f2511bb04321984c$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $f2511bb04321984c$var$debug("wrapped _read", n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === "function") $f2511bb04321984c$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($f2511bb04321984c$var$createReadableStreamAsyncIterator === undefined) $f2511bb04321984c$var$createReadableStreamAsyncIterator = (parcelRequire("hjam0"));
    return $f2511bb04321984c$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($f2511bb04321984c$var$Readable.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($f2511bb04321984c$var$Readable.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($f2511bb04321984c$var$Readable.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$f2511bb04321984c$var$Readable._fromList = $f2511bb04321984c$var$fromList;
Object.defineProperty($f2511bb04321984c$var$Readable.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $f2511bb04321984c$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $f2511bb04321984c$var$endReadable(stream) {
    var state = stream._readableState;
    $f2511bb04321984c$var$debug("endReadable", state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $3qWgZ.nextTick($f2511bb04321984c$var$endReadableNT, state, stream);
    }
}
function $f2511bb04321984c$var$endReadableNT(state, stream) {
    $f2511bb04321984c$var$debug("endReadableNT", state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit("end");
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === "function") $f2511bb04321984c$var$Readable.from = function(iterable, opts) {
    if ($f2511bb04321984c$var$from === undefined) $f2511bb04321984c$var$from = (parcelRequire("9K1uD"));
    return $f2511bb04321984c$var$from($f2511bb04321984c$var$Readable, iterable, opts);
};
function $f2511bb04321984c$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("cyxGb", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $l0HdX = parcelRequire("l0HdX");
"use strict";
var $9242c90cd2aa67c8$var$R = typeof Reflect === "object" ? Reflect : null;
var $9242c90cd2aa67c8$var$ReflectApply = $9242c90cd2aa67c8$var$R && typeof $9242c90cd2aa67c8$var$R.apply === "function" ? $9242c90cd2aa67c8$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $9242c90cd2aa67c8$var$ReflectOwnKeys;
if ($9242c90cd2aa67c8$var$R && typeof $9242c90cd2aa67c8$var$R.ownKeys === "function") $9242c90cd2aa67c8$var$ReflectOwnKeys = $9242c90cd2aa67c8$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $9242c90cd2aa67c8$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $9242c90cd2aa67c8$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $9242c90cd2aa67c8$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $9242c90cd2aa67c8$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $9242c90cd2aa67c8$var$EventEmitter() {
    $9242c90cd2aa67c8$var$EventEmitter.init.call(this);
}
module.exports = $9242c90cd2aa67c8$var$EventEmitter;
module.exports.once = $9242c90cd2aa67c8$var$once;
// Backwards-compat with node 0.10.x
$9242c90cd2aa67c8$var$EventEmitter.EventEmitter = $9242c90cd2aa67c8$var$EventEmitter;
$9242c90cd2aa67c8$var$EventEmitter.prototype._events = undefined;
$9242c90cd2aa67c8$var$EventEmitter.prototype._eventsCount = 0;
$9242c90cd2aa67c8$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $9242c90cd2aa67c8$var$defaultMaxListeners = 10;
function $9242c90cd2aa67c8$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + (typeof listener === "undefined" ? "undefined" : (0, $l0HdX._)(listener)));
}
Object.defineProperty($9242c90cd2aa67c8$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function get() {
        return $9242c90cd2aa67c8$var$defaultMaxListeners;
    },
    set: function set(arg) {
        if (typeof arg !== "number" || arg < 0 || $9242c90cd2aa67c8$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $9242c90cd2aa67c8$var$defaultMaxListeners = arg;
    }
});
$9242c90cd2aa67c8$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$9242c90cd2aa67c8$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $9242c90cd2aa67c8$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $9242c90cd2aa67c8$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $9242c90cd2aa67c8$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$9242c90cd2aa67c8$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $9242c90cd2aa67c8$var$_getMaxListeners(this);
};
$9242c90cd2aa67c8$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $9242c90cd2aa67c8$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $9242c90cd2aa67c8$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$9242c90cd2aa67c8$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $9242c90cd2aa67c8$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $9242c90cd2aa67c8$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $9242c90cd2aa67c8$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $9242c90cd2aa67c8$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$9242c90cd2aa67c8$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $9242c90cd2aa67c8$var$_addListener(this, type, listener, false);
};
$9242c90cd2aa67c8$var$EventEmitter.prototype.on = $9242c90cd2aa67c8$var$EventEmitter.prototype.addListener;
$9242c90cd2aa67c8$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $9242c90cd2aa67c8$var$_addListener(this, type, listener, true);
};
function $9242c90cd2aa67c8$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $9242c90cd2aa67c8$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $9242c90cd2aa67c8$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$9242c90cd2aa67c8$var$EventEmitter.prototype.once = function once(type, listener) {
    $9242c90cd2aa67c8$var$checkListener(listener);
    this.on(type, $9242c90cd2aa67c8$var$_onceWrap(this, type, listener));
    return this;
};
$9242c90cd2aa67c8$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $9242c90cd2aa67c8$var$checkListener(listener);
    this.prependListener(type, $9242c90cd2aa67c8$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$9242c90cd2aa67c8$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $9242c90cd2aa67c8$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $9242c90cd2aa67c8$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$9242c90cd2aa67c8$var$EventEmitter.prototype.off = $9242c90cd2aa67c8$var$EventEmitter.prototype.removeListener;
$9242c90cd2aa67c8$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $9242c90cd2aa67c8$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $9242c90cd2aa67c8$var$unwrapListeners(evlistener) : $9242c90cd2aa67c8$var$arrayClone(evlistener, evlistener.length);
}
$9242c90cd2aa67c8$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $9242c90cd2aa67c8$var$_listeners(this, type, true);
};
$9242c90cd2aa67c8$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $9242c90cd2aa67c8$var$_listeners(this, type, false);
};
$9242c90cd2aa67c8$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $9242c90cd2aa67c8$var$listenerCount.call(emitter, type);
};
$9242c90cd2aa67c8$var$EventEmitter.prototype.listenerCount = $9242c90cd2aa67c8$var$listenerCount;
function $9242c90cd2aa67c8$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$9242c90cd2aa67c8$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $9242c90cd2aa67c8$var$ReflectOwnKeys(this._events) : [];
};
function $9242c90cd2aa67c8$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $9242c90cd2aa67c8$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $9242c90cd2aa67c8$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $9242c90cd2aa67c8$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $9242c90cd2aa67c8$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $9242c90cd2aa67c8$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $9242c90cd2aa67c8$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $9242c90cd2aa67c8$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $9242c90cd2aa67c8$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + (typeof emitter === "undefined" ? "undefined" : (0, $l0HdX._)(emitter)));
}

});

parcelRegister("4GfFr", function(module, exports) {

module.exports = (parcelRequire("cyxGb")).EventEmitter;

});

parcelRegister("9dH9K", function(module, exports) {
"use strict";

});

parcelRegister("9KJLc", function(module, exports) {

var $l0HdX = parcelRequire("l0HdX");
"use strict";
function $719be7f50de264a8$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $719be7f50de264a8$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $719be7f50de264a8$var$ownKeys(Object(source), !0).forEach(function(key) {
            $719be7f50de264a8$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $719be7f50de264a8$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $719be7f50de264a8$var$_defineProperty(obj, key, value) {
    key = $719be7f50de264a8$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $719be7f50de264a8$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $719be7f50de264a8$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $719be7f50de264a8$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $719be7f50de264a8$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $719be7f50de264a8$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $719be7f50de264a8$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $719be7f50de264a8$var$_toPropertyKey(arg) {
    var key = $719be7f50de264a8$var$_toPrimitive(arg, "string");
    return (typeof key === "undefined" ? "undefined" : (0, $l0HdX._)(key)) === "symbol" ? key : String(key);
}
function $719be7f50de264a8$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $8dlmd = parcelRequire("8dlmd");
var $719be7f50de264a8$var$Buffer = $8dlmd.Buffer;

var $9dH9K = parcelRequire("9dH9K");
var $719be7f50de264a8$var$inspect = $9dH9K.inspect;
var $719be7f50de264a8$var$custom = $719be7f50de264a8$var$inspect && $719be7f50de264a8$var$inspect.custom || "inspect";
function $719be7f50de264a8$var$copyBuffer(src, target, offset) {
    $719be7f50de264a8$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $719be7f50de264a8$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $719be7f50de264a8$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return "";
                var p = this.head;
                var ret = "" + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $719be7f50de264a8$var$Buffer.alloc(0);
                var ret = $719be7f50de264a8$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $719be7f50de264a8$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $719be7f50de264a8$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $719be7f50de264a8$var$custom,
            value: function value(_, options) {
                return $719be7f50de264a8$var$inspect(this, $719be7f50de264a8$var$_objectSpread($719be7f50de264a8$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("37y91", function(module, exports) {

var $3qWgZ = parcelRequire("3qWgZ");
"use strict";
// undocumented cb() API, needed for core, not for public API
function $245c82ec672f1a1c$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $3qWgZ.nextTick($245c82ec672f1a1c$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $3qWgZ.nextTick($245c82ec672f1a1c$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $3qWgZ.nextTick($245c82ec672f1a1c$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $3qWgZ.nextTick($245c82ec672f1a1c$var$emitErrorAndCloseNT, _this, err);
            } else $3qWgZ.nextTick($245c82ec672f1a1c$var$emitCloseNT, _this);
        } else if (cb) {
            $3qWgZ.nextTick($245c82ec672f1a1c$var$emitCloseNT, _this);
            cb(err);
        } else $3qWgZ.nextTick($245c82ec672f1a1c$var$emitCloseNT, _this);
    });
    return this;
}
function $245c82ec672f1a1c$var$emitErrorAndCloseNT(self, err) {
    $245c82ec672f1a1c$var$emitErrorNT(self, err);
    $245c82ec672f1a1c$var$emitCloseNT(self);
}
function $245c82ec672f1a1c$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit("close");
}
function $245c82ec672f1a1c$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $245c82ec672f1a1c$var$emitErrorNT(self, err) {
    self.emit("error", err);
}
function $245c82ec672f1a1c$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit("error", err);
}
module.exports = {
    destroy: $245c82ec672f1a1c$var$destroy,
    undestroy: $245c82ec672f1a1c$var$undestroy,
    errorOrDestroy: $245c82ec672f1a1c$var$errorOrDestroy
};

});

parcelRegister("7s2Xd", function(module, exports) {
"use strict";

var $56cd708b65d4851d$var$ERR_INVALID_OPT_VALUE = (parcelRequire("1PYlf")).codes.ERR_INVALID_OPT_VALUE;
function $56cd708b65d4851d$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $56cd708b65d4851d$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $56cd708b65d4851d$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : "highWaterMark";
            throw new $56cd708b65d4851d$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $56cd708b65d4851d$var$getHighWaterMark
};

});
parcelRegister("1PYlf", function(module, exports) {

$parcel$export(module.exports, "codes", function () { return $15695c7f314426b2$export$e45cb6485273080e; }, function (v) { return $15695c7f314426b2$export$e45cb6485273080e = v; });

var $l0HdX = parcelRequire("l0HdX");
var $15695c7f314426b2$export$e45cb6485273080e;
"use strict";
function $15695c7f314426b2$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $15695c7f314426b2$var$codes = {};
function $15695c7f314426b2$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $15695c7f314426b2$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $15695c7f314426b2$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $15695c7f314426b2$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $15695c7f314426b2$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $15695c7f314426b2$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $15695c7f314426b2$var$includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$15695c7f314426b2$var$createErrorType("ERR_INVALID_OPT_VALUE", function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$15695c7f314426b2$var$createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && $15695c7f314426b2$var$startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if ($15695c7f314426b2$var$endsWith(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($15695c7f314426b2$var$oneOf(expected, "type"));
    else {
        var type = $15695c7f314426b2$var$includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat($15695c7f314426b2$var$oneOf(expected, "type"));
    }
    msg += ". Received type ".concat(typeof actual === "undefined" ? "undefined" : (0, $l0HdX._)(actual));
    return msg;
}, TypeError);
$15695c7f314426b2$var$createErrorType("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
$15695c7f314426b2$var$createErrorType("ERR_METHOD_NOT_IMPLEMENTED", function(name) {
    return "The " + name + " method is not implemented";
});
$15695c7f314426b2$var$createErrorType("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
$15695c7f314426b2$var$createErrorType("ERR_STREAM_DESTROYED", function(name) {
    return "Cannot call " + name + " after a stream was destroyed";
});
$15695c7f314426b2$var$createErrorType("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
$15695c7f314426b2$var$createErrorType("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
$15695c7f314426b2$var$createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end");
$15695c7f314426b2$var$createErrorType("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
$15695c7f314426b2$var$createErrorType("ERR_UNKNOWN_ENCODING", function(arg) {
    return "Unknown encoding: " + arg;
}, TypeError);
$15695c7f314426b2$var$createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
$15695c7f314426b2$export$e45cb6485273080e = $15695c7f314426b2$var$codes;

});


parcelRegister("kPQvy", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $3qWgZ = parcelRequire("3qWgZ");
"use strict";
/*<replacement>*/ var $f2b14d0e3571bc09$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $f2b14d0e3571bc09$var$Duplex;

var $kNQv4 = parcelRequire("kNQv4");

var $giiCg = parcelRequire("giiCg");

(parcelRequire("hwgCU"))($f2b14d0e3571bc09$var$Duplex, $kNQv4);
// Allow the keys array to be GC'ed.
var $f2b14d0e3571bc09$var$keys = $f2b14d0e3571bc09$var$objectKeys($giiCg.prototype);
for(var $f2b14d0e3571bc09$var$v = 0; $f2b14d0e3571bc09$var$v < $f2b14d0e3571bc09$var$keys.length; $f2b14d0e3571bc09$var$v++){
    var $f2b14d0e3571bc09$var$method = $f2b14d0e3571bc09$var$keys[$f2b14d0e3571bc09$var$v];
    if (!$f2b14d0e3571bc09$var$Duplex.prototype[$f2b14d0e3571bc09$var$method]) $f2b14d0e3571bc09$var$Duplex.prototype[$f2b14d0e3571bc09$var$method] = $giiCg.prototype[$f2b14d0e3571bc09$var$method];
}
function $f2b14d0e3571bc09$var$Duplex(options) {
    if (!(this instanceof $f2b14d0e3571bc09$var$Duplex)) return new $f2b14d0e3571bc09$var$Duplex(options);
    $kNQv4.call(this, options);
    $giiCg.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once("end", $f2b14d0e3571bc09$var$onend);
        }
    }
}
Object.defineProperty($f2b14d0e3571bc09$var$Duplex.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($f2b14d0e3571bc09$var$Duplex.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($f2b14d0e3571bc09$var$Duplex.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $f2b14d0e3571bc09$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $3qWgZ.nextTick($f2b14d0e3571bc09$var$onEndNT, this);
}
function $f2b14d0e3571bc09$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($f2b14d0e3571bc09$var$Duplex.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("giiCg", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $3qWgZ = parcelRequire("3qWgZ");
"use strict";
module.exports = $bdccc4952fb75ddd$var$Writable;
/* <replacement> */ function $bdccc4952fb75ddd$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $bdccc4952fb75ddd$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $bdccc4952fb75ddd$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $bdccc4952fb75ddd$var$Duplex;
/*</replacement>*/ $bdccc4952fb75ddd$var$Writable.WritableState = $bdccc4952fb75ddd$var$WritableState;

/*<replacement>*/ var $bdccc4952fb75ddd$var$internalUtil = {
    deprecate: (parcelRequire("9Y66y"))
};

var $4GfFr = parcelRequire("4GfFr");

var $8dlmd = parcelRequire("8dlmd");
var $bdccc4952fb75ddd$require$Buffer = $8dlmd.Buffer;
var $bdccc4952fb75ddd$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $bdccc4952fb75ddd$var$_uint8ArrayToBuffer(chunk) {
    return $bdccc4952fb75ddd$require$Buffer.from(chunk);
}
function $bdccc4952fb75ddd$var$_isUint8Array(obj) {
    return $bdccc4952fb75ddd$require$Buffer.isBuffer(obj) || obj instanceof $bdccc4952fb75ddd$var$OurUint8Array;
}

var $37y91 = parcelRequire("37y91");

var $7s2Xd = parcelRequire("7s2Xd");
var $bdccc4952fb75ddd$var$getHighWaterMark = $7s2Xd.getHighWaterMark;

var $1PYlf = parcelRequire("1PYlf");
var $bdccc4952fb75ddd$require$_require$codes = $1PYlf.codes;
var $bdccc4952fb75ddd$var$ERR_INVALID_ARG_TYPE = $bdccc4952fb75ddd$require$_require$codes.ERR_INVALID_ARG_TYPE, $bdccc4952fb75ddd$var$ERR_METHOD_NOT_IMPLEMENTED = $bdccc4952fb75ddd$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $bdccc4952fb75ddd$var$ERR_MULTIPLE_CALLBACK = $bdccc4952fb75ddd$require$_require$codes.ERR_MULTIPLE_CALLBACK, $bdccc4952fb75ddd$var$ERR_STREAM_CANNOT_PIPE = $bdccc4952fb75ddd$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $bdccc4952fb75ddd$var$ERR_STREAM_DESTROYED = $bdccc4952fb75ddd$require$_require$codes.ERR_STREAM_DESTROYED, $bdccc4952fb75ddd$var$ERR_STREAM_NULL_VALUES = $bdccc4952fb75ddd$require$_require$codes.ERR_STREAM_NULL_VALUES, $bdccc4952fb75ddd$var$ERR_STREAM_WRITE_AFTER_END = $bdccc4952fb75ddd$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $bdccc4952fb75ddd$var$ERR_UNKNOWN_ENCODING = $bdccc4952fb75ddd$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $bdccc4952fb75ddd$var$errorOrDestroy = $37y91.errorOrDestroy;

(parcelRequire("hwgCU"))($bdccc4952fb75ddd$var$Writable, $4GfFr);
function $bdccc4952fb75ddd$var$nop() {}

function $bdccc4952fb75ddd$var$WritableState(options, stream, isDuplex) {
    $bdccc4952fb75ddd$var$Duplex = $bdccc4952fb75ddd$var$Duplex || (parcelRequire("kPQvy"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $bdccc4952fb75ddd$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $bdccc4952fb75ddd$var$getHighWaterMark(this, options, "writableHighWaterMark", isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $bdccc4952fb75ddd$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $bdccc4952fb75ddd$var$CorkedRequest(this);
}
$bdccc4952fb75ddd$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($bdccc4952fb75ddd$var$WritableState.prototype, "buffer", {
            get: $bdccc4952fb75ddd$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $bdccc4952fb75ddd$var$realHasInstance;
if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
    $bdccc4952fb75ddd$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($bdccc4952fb75ddd$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($bdccc4952fb75ddd$var$realHasInstance.call(this, object)) return true;
            if (this !== $bdccc4952fb75ddd$var$Writable) return false;
            return object && object._writableState instanceof $bdccc4952fb75ddd$var$WritableState;
        }
    });
} else $bdccc4952fb75ddd$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $bdccc4952fb75ddd$var$Writable(options) {
    $bdccc4952fb75ddd$var$Duplex = $bdccc4952fb75ddd$var$Duplex || (parcelRequire("kPQvy"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $bdccc4952fb75ddd$var$Duplex;
    if (!isDuplex && !$bdccc4952fb75ddd$var$realHasInstance.call($bdccc4952fb75ddd$var$Writable, this)) return new $bdccc4952fb75ddd$var$Writable(options);
    this._writableState = new $bdccc4952fb75ddd$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
    }
    $4GfFr.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$bdccc4952fb75ddd$var$Writable.prototype.pipe = function() {
    $bdccc4952fb75ddd$var$errorOrDestroy(this, new $bdccc4952fb75ddd$var$ERR_STREAM_CANNOT_PIPE());
};
function $bdccc4952fb75ddd$var$writeAfterEnd(stream, cb) {
    var er = new $bdccc4952fb75ddd$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $bdccc4952fb75ddd$var$errorOrDestroy(stream, er);
    $3qWgZ.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $bdccc4952fb75ddd$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $bdccc4952fb75ddd$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== "string" && !state.objectMode) er = new $bdccc4952fb75ddd$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer"
    ], chunk);
    if (er) {
        $bdccc4952fb75ddd$var$errorOrDestroy(stream, er);
        $3qWgZ.nextTick(cb, er);
        return false;
    }
    return true;
}
$bdccc4952fb75ddd$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $bdccc4952fb75ddd$var$_isUint8Array(chunk);
    if (isBuf && !$bdccc4952fb75ddd$require$Buffer.isBuffer(chunk)) chunk = $bdccc4952fb75ddd$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = "buffer";
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== "function") cb = $bdccc4952fb75ddd$var$nop;
    if (state.ending) $bdccc4952fb75ddd$var$writeAfterEnd(this, cb);
    else if (isBuf || $bdccc4952fb75ddd$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $bdccc4952fb75ddd$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$bdccc4952fb75ddd$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$bdccc4952fb75ddd$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $bdccc4952fb75ddd$var$clearBuffer(this, state);
    }
};
$bdccc4952fb75ddd$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = encoding.toLowerCase();
    if (!([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new $bdccc4952fb75ddd$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($bdccc4952fb75ddd$var$Writable.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $bdccc4952fb75ddd$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = $bdccc4952fb75ddd$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($bdccc4952fb75ddd$var$Writable.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $bdccc4952fb75ddd$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $bdccc4952fb75ddd$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = "buffer";
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $bdccc4952fb75ddd$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $bdccc4952fb75ddd$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $bdccc4952fb75ddd$var$ERR_STREAM_DESTROYED("write"));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $bdccc4952fb75ddd$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $3qWgZ.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $3qWgZ.nextTick($bdccc4952fb75ddd$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $bdccc4952fb75ddd$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $bdccc4952fb75ddd$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $bdccc4952fb75ddd$var$finishMaybe(stream, state);
    }
}
function $bdccc4952fb75ddd$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $bdccc4952fb75ddd$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== "function") throw new $bdccc4952fb75ddd$var$ERR_MULTIPLE_CALLBACK();
    $bdccc4952fb75ddd$var$onwriteStateUpdate(state);
    if (er) $bdccc4952fb75ddd$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $bdccc4952fb75ddd$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $bdccc4952fb75ddd$var$clearBuffer(stream, state);
        if (sync) $3qWgZ.nextTick($bdccc4952fb75ddd$var$afterWrite, stream, state, finished, cb);
        else $bdccc4952fb75ddd$var$afterWrite(stream, state, finished, cb);
    }
}
function $bdccc4952fb75ddd$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $bdccc4952fb75ddd$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $bdccc4952fb75ddd$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $bdccc4952fb75ddd$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
}
// if there's something in the buffer waiting, then process it
function $bdccc4952fb75ddd$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $bdccc4952fb75ddd$var$doWrite(stream, state, true, state.length, buffer, "", holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $bdccc4952fb75ddd$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $bdccc4952fb75ddd$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$bdccc4952fb75ddd$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $bdccc4952fb75ddd$var$ERR_METHOD_NOT_IMPLEMENTED("_write()"));
};
$bdccc4952fb75ddd$var$Writable.prototype._writev = null;
$bdccc4952fb75ddd$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $bdccc4952fb75ddd$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($bdccc4952fb75ddd$var$Writable.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $bdccc4952fb75ddd$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $bdccc4952fb75ddd$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $bdccc4952fb75ddd$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit("prefinish");
        $bdccc4952fb75ddd$var$finishMaybe(stream, state);
    });
}
function $bdccc4952fb75ddd$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function" && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $3qWgZ.nextTick($bdccc4952fb75ddd$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function $bdccc4952fb75ddd$var$finishMaybe(stream, state) {
    var need = $bdccc4952fb75ddd$var$needFinish(state);
    if (need) {
        $bdccc4952fb75ddd$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit("finish");
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $bdccc4952fb75ddd$var$endWritable(stream, state, cb) {
    state.ending = true;
    $bdccc4952fb75ddd$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $3qWgZ.nextTick(cb);
        else stream.once("finish", cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $bdccc4952fb75ddd$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($bdccc4952fb75ddd$var$Writable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$bdccc4952fb75ddd$var$Writable.prototype.destroy = $37y91.destroy;
$bdccc4952fb75ddd$var$Writable.prototype._undestroy = $37y91.undestroy;
$bdccc4952fb75ddd$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRegister("9Y66y", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $741e73f226a4b72a$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $741e73f226a4b72a$var$deprecate(fn, msg) {
    if ($741e73f226a4b72a$var$config("noDeprecation")) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($741e73f226a4b72a$var$config("throwDeprecation")) throw new Error(msg);
            else if ($741e73f226a4b72a$var$config("traceDeprecation")) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $741e73f226a4b72a$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === "true";
}

});



parcelRegister("3q4dM", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", function () { return $27d713100e959eaa$export$63a7aa211a91ed69; }, function (v) { return $27d713100e959eaa$export$63a7aa211a91ed69 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $27d713100e959eaa$export$63a7aa211a91ed69;
"use strict";

var $f6JDE = parcelRequire("f6JDE");
var $27d713100e959eaa$require$Buffer = $f6JDE.Buffer;
/*</replacement>*/ var $27d713100e959eaa$var$isEncoding = $27d713100e959eaa$require$Buffer.isEncoding || function(encoding) {
    encoding = "" + encoding;
    switch(encoding && encoding.toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
            return true;
        default:
            return false;
    }
};
function $27d713100e959eaa$var$_normalizeEncoding(enc) {
    if (!enc) return "utf8";
    var retried;
    while(true)switch(enc){
        case "utf8":
        case "utf-8":
            return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return "utf16le";
        case "latin1":
        case "binary":
            return "latin1";
        case "base64":
        case "ascii":
        case "hex":
            return enc;
        default:
            if (retried) return; // undefined
            enc = ("" + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $27d713100e959eaa$var$normalizeEncoding(enc) {
    var nenc = $27d713100e959eaa$var$_normalizeEncoding(enc);
    if (typeof nenc !== "string" && ($27d713100e959eaa$require$Buffer.isEncoding === $27d713100e959eaa$var$isEncoding || !$27d713100e959eaa$var$isEncoding(enc))) throw new Error("Unknown encoding: " + enc);
    return nenc || enc;
}
$27d713100e959eaa$export$63a7aa211a91ed69 = $27d713100e959eaa$var$StringDecoder;
function $27d713100e959eaa$var$StringDecoder(encoding) {
    this.encoding = $27d713100e959eaa$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case "utf16le":
            this.text = $27d713100e959eaa$var$utf16Text;
            this.end = $27d713100e959eaa$var$utf16End;
            nb = 4;
            break;
        case "utf8":
            this.fillLast = $27d713100e959eaa$var$utf8FillLast;
            nb = 4;
            break;
        case "base64":
            this.text = $27d713100e959eaa$var$base64Text;
            this.end = $27d713100e959eaa$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $27d713100e959eaa$var$simpleWrite;
            this.end = $27d713100e959eaa$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $27d713100e959eaa$require$Buffer.allocUnsafe(nb);
}
$27d713100e959eaa$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return "";
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return "";
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || "";
};
$27d713100e959eaa$var$StringDecoder.prototype.end = $27d713100e959eaa$var$utf8End;
// Returns only complete characters in a Buffer
$27d713100e959eaa$var$StringDecoder.prototype.text = $27d713100e959eaa$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$27d713100e959eaa$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $27d713100e959eaa$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $27d713100e959eaa$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $27d713100e959eaa$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $27d713100e959eaa$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $27d713100e959eaa$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $27d713100e959eaa$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return "\uFFFD";
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return "\uFFFD";
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return "\uFFFD";
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $27d713100e959eaa$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $27d713100e959eaa$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $27d713100e959eaa$var$utf8Text(buf, i) {
    var total = $27d713100e959eaa$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString("utf8", i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString("utf8", i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $27d713100e959eaa$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + "\uFFFD";
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $27d713100e959eaa$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString("utf16le", i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString("utf16le", i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $27d713100e959eaa$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString("utf16le", 0, end);
    }
    return r;
}
function $27d713100e959eaa$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString("base64", i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString("base64", i, buf.length - n);
}
function $27d713100e959eaa$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $27d713100e959eaa$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $27d713100e959eaa$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : "";
}

});

parcelRegister("hjam0", function(module, exports) {

var $l0HdX = parcelRequire("l0HdX");

var $3qWgZ = parcelRequire("3qWgZ");
"use strict";
var $0340749d561400a2$var$_Object$setPrototypeO;
function $0340749d561400a2$var$_defineProperty(obj, key, value) {
    key = $0340749d561400a2$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0340749d561400a2$var$_toPropertyKey(arg) {
    var key = $0340749d561400a2$var$_toPrimitive(arg, "string");
    return (typeof key === "undefined" ? "undefined" : (0, $l0HdX._)(key)) === "symbol" ? key : String(key);
}
function $0340749d561400a2$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $9YDMx = parcelRequire("9YDMx");
var $0340749d561400a2$var$kLastResolve = Symbol("lastResolve");
var $0340749d561400a2$var$kLastReject = Symbol("lastReject");
var $0340749d561400a2$var$kError = Symbol("error");
var $0340749d561400a2$var$kEnded = Symbol("ended");
var $0340749d561400a2$var$kLastPromise = Symbol("lastPromise");
var $0340749d561400a2$var$kHandlePromise = Symbol("handlePromise");
var $0340749d561400a2$var$kStream = Symbol("stream");
function $0340749d561400a2$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $0340749d561400a2$var$readAndResolve(iter) {
    var resolve = iter[$0340749d561400a2$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$0340749d561400a2$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$0340749d561400a2$var$kLastPromise] = null;
            iter[$0340749d561400a2$var$kLastResolve] = null;
            iter[$0340749d561400a2$var$kLastReject] = null;
            resolve($0340749d561400a2$var$createIterResult(data, false));
        }
    }
}
function $0340749d561400a2$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $3qWgZ.nextTick($0340749d561400a2$var$readAndResolve, iter);
}
function $0340749d561400a2$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$0340749d561400a2$var$kEnded]) {
                resolve($0340749d561400a2$var$createIterResult(undefined, true));
                return;
            }
            iter[$0340749d561400a2$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $0340749d561400a2$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $0340749d561400a2$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($0340749d561400a2$var$_Object$setPrototypeO = {
    get stream () {
        return this[$0340749d561400a2$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$0340749d561400a2$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$0340749d561400a2$var$kEnded]) return Promise.resolve($0340749d561400a2$var$createIterResult(undefined, true));
        if (this[$0340749d561400a2$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $3qWgZ.nextTick(function() {
                if (_this[$0340749d561400a2$var$kError]) reject(_this[$0340749d561400a2$var$kError]);
                else resolve($0340749d561400a2$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$0340749d561400a2$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($0340749d561400a2$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$0340749d561400a2$var$kStream].read();
            if (data !== null) return Promise.resolve($0340749d561400a2$var$createIterResult(data, false));
            promise = new Promise(this[$0340749d561400a2$var$kHandlePromise]);
        }
        this[$0340749d561400a2$var$kLastPromise] = promise;
        return promise;
    }
}, $0340749d561400a2$var$_defineProperty($0340749d561400a2$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $0340749d561400a2$var$_defineProperty($0340749d561400a2$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$0340749d561400a2$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($0340749d561400a2$var$createIterResult(undefined, true));
        });
    });
}), $0340749d561400a2$var$_Object$setPrototypeO), $0340749d561400a2$var$AsyncIteratorPrototype);
var $0340749d561400a2$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($0340749d561400a2$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $0340749d561400a2$var$_defineProperty(_Object$create, $0340749d561400a2$var$kStream, {
        value: stream,
        writable: true
    }), $0340749d561400a2$var$_defineProperty(_Object$create, $0340749d561400a2$var$kLastResolve, {
        value: null,
        writable: true
    }), $0340749d561400a2$var$_defineProperty(_Object$create, $0340749d561400a2$var$kLastReject, {
        value: null,
        writable: true
    }), $0340749d561400a2$var$_defineProperty(_Object$create, $0340749d561400a2$var$kError, {
        value: null,
        writable: true
    }), $0340749d561400a2$var$_defineProperty(_Object$create, $0340749d561400a2$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $0340749d561400a2$var$_defineProperty(_Object$create, $0340749d561400a2$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$0340749d561400a2$var$kStream].read();
            if (data) {
                iterator[$0340749d561400a2$var$kLastPromise] = null;
                iterator[$0340749d561400a2$var$kLastResolve] = null;
                iterator[$0340749d561400a2$var$kLastReject] = null;
                resolve($0340749d561400a2$var$createIterResult(data, false));
            } else {
                iterator[$0340749d561400a2$var$kLastResolve] = resolve;
                iterator[$0340749d561400a2$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$0340749d561400a2$var$kLastPromise] = null;
    $9YDMx(stream, function(err) {
        if (err && err.code !== "ERR_STREAM_PREMATURE_CLOSE") {
            var reject = iterator[$0340749d561400a2$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$0340749d561400a2$var$kLastPromise] = null;
                iterator[$0340749d561400a2$var$kLastResolve] = null;
                iterator[$0340749d561400a2$var$kLastReject] = null;
                reject(err);
            }
            iterator[$0340749d561400a2$var$kError] = err;
            return;
        }
        var resolve = iterator[$0340749d561400a2$var$kLastResolve];
        if (resolve !== null) {
            iterator[$0340749d561400a2$var$kLastPromise] = null;
            iterator[$0340749d561400a2$var$kLastResolve] = null;
            iterator[$0340749d561400a2$var$kLastReject] = null;
            resolve($0340749d561400a2$var$createIterResult(undefined, true));
        }
        iterator[$0340749d561400a2$var$kEnded] = true;
    });
    stream.on("readable", $0340749d561400a2$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $0340749d561400a2$var$createReadableStreamAsyncIterator;

});
parcelRegister("9YDMx", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";

var $7438937dc6fa57e6$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("1PYlf")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $7438937dc6fa57e6$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $7438937dc6fa57e6$var$noop() {}
function $7438937dc6fa57e6$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}
function $7438937dc6fa57e6$var$eos(stream, opts, callback) {
    if (typeof opts === "function") return $7438937dc6fa57e6$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $7438937dc6fa57e6$var$once(callback || $7438937dc6fa57e6$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $7438937dc6fa57e6$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $7438937dc6fa57e6$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on("finish", onfinish);
    };
    if ($7438937dc6fa57e6$var$isRequest(stream)) {
        stream.on("complete", onfinish);
        stream.on("abort", onclose);
        if (stream.req) onrequest();
        else stream.on("request", onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on("end", onlegacyfinish);
        stream.on("close", onlegacyfinish);
    }
    stream.on("end", onend);
    stream.on("finish", onfinish);
    if (opts.error !== false) stream.on("error", onerror);
    stream.on("close", onclose);
    return function() {
        stream.removeListener("complete", onfinish);
        stream.removeListener("abort", onclose);
        stream.removeListener("request", onrequest);
        if (stream.req) stream.req.removeListener("finish", onfinish);
        stream.removeListener("end", onlegacyfinish);
        stream.removeListener("close", onlegacyfinish);
        stream.removeListener("finish", onfinish);
        stream.removeListener("end", onend);
        stream.removeListener("error", onerror);
        stream.removeListener("close", onclose);
    };
}
module.exports = $7438937dc6fa57e6$var$eos;

});


parcelRegister("9K1uD", function(module, exports) {
module.exports = function() {
    throw new Error("Readable.from is not available in the browser");
};

});


parcelRegister("43NjS", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
"use strict";
module.exports = $2f4db314d1eab571$var$Transform;

var $1PYlf = parcelRequire("1PYlf");
var $2f4db314d1eab571$require$_require$codes = $1PYlf.codes;
var $2f4db314d1eab571$var$ERR_METHOD_NOT_IMPLEMENTED = $2f4db314d1eab571$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $2f4db314d1eab571$var$ERR_MULTIPLE_CALLBACK = $2f4db314d1eab571$require$_require$codes.ERR_MULTIPLE_CALLBACK, $2f4db314d1eab571$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $2f4db314d1eab571$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $2f4db314d1eab571$var$ERR_TRANSFORM_WITH_LENGTH_0 = $2f4db314d1eab571$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $kPQvy = parcelRequire("kPQvy");

(parcelRequire("hwgCU"))($2f4db314d1eab571$var$Transform, $kPQvy);
function $2f4db314d1eab571$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit("error", new $2f4db314d1eab571$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $2f4db314d1eab571$var$Transform(options) {
    if (!(this instanceof $2f4db314d1eab571$var$Transform)) return new $2f4db314d1eab571$var$Transform(options);
    $kPQvy.call(this, options);
    this._transformState = {
        afterTransform: $2f4db314d1eab571$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on("prefinish", $2f4db314d1eab571$var$prefinish);
}
function $2f4db314d1eab571$var$prefinish() {
    var _this = this;
    if (typeof this._flush === "function" && !this._readableState.destroyed) this._flush(function(er, data) {
        $2f4db314d1eab571$var$done(_this, er, data);
    });
    else $2f4db314d1eab571$var$done(this, null, null);
}
$2f4db314d1eab571$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $kPQvy.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$2f4db314d1eab571$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $2f4db314d1eab571$var$ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
};
$2f4db314d1eab571$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$2f4db314d1eab571$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$2f4db314d1eab571$var$Transform.prototype._destroy = function(err, cb) {
    $kPQvy.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $2f4db314d1eab571$var$done(stream, er, data) {
    if (er) return stream.emit("error", er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $2f4db314d1eab571$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $2f4db314d1eab571$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("c04gS", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
"use strict";
module.exports = $8bc8cc4ee2a723dc$var$PassThrough;

var $43NjS = parcelRequire("43NjS");

(parcelRequire("hwgCU"))($8bc8cc4ee2a723dc$var$PassThrough, $43NjS);
function $8bc8cc4ee2a723dc$var$PassThrough(options) {
    if (!(this instanceof $8bc8cc4ee2a723dc$var$PassThrough)) return new $8bc8cc4ee2a723dc$var$PassThrough(options);
    $43NjS.call(this, options);
}
$8bc8cc4ee2a723dc$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("bmpl8", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";
var $845567c455b72948$var$eos;
function $845567c455b72948$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $1PYlf = parcelRequire("1PYlf");
var $845567c455b72948$require$_require$codes = $1PYlf.codes;
var $845567c455b72948$var$ERR_MISSING_ARGS = $845567c455b72948$require$_require$codes.ERR_MISSING_ARGS, $845567c455b72948$var$ERR_STREAM_DESTROYED = $845567c455b72948$require$_require$codes.ERR_STREAM_DESTROYED;
function $845567c455b72948$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $845567c455b72948$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}

function $845567c455b72948$var$destroyer(stream, reading, writing, callback) {
    callback = $845567c455b72948$var$once(callback);
    var closed = false;
    stream.on("close", function() {
        closed = true;
    });
    if ($845567c455b72948$var$eos === undefined) $845567c455b72948$var$eos = (parcelRequire("9YDMx"));
    $845567c455b72948$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($845567c455b72948$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === "function") return stream.destroy();
        callback(err || new $845567c455b72948$var$ERR_STREAM_DESTROYED("pipe"));
    };
}
function $845567c455b72948$var$call(fn) {
    fn();
}
function $845567c455b72948$var$pipe(from, to) {
    return from.pipe(to);
}
function $845567c455b72948$var$popCallback(streams) {
    if (!streams.length) return $845567c455b72948$var$noop;
    if (typeof streams[streams.length - 1] !== "function") return $845567c455b72948$var$noop;
    return streams.pop();
}
function $845567c455b72948$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $845567c455b72948$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $845567c455b72948$var$ERR_MISSING_ARGS("streams");
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $845567c455b72948$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($845567c455b72948$var$call);
            if (reading) return;
            destroys.forEach($845567c455b72948$var$call);
            callback(error);
        });
    });
    return streams.reduce($845567c455b72948$var$pipe);
}
module.exports = $845567c455b72948$var$pipeline;

});




parcelRegister("hEcOA", function(module, exports) {
"use strict";

var $8dlmd = parcelRequire("8dlmd");
var $cd901ce4ece51bae$require$Buffer = $8dlmd.Buffer;

var $hwgCU = parcelRequire("hwgCU");

var $2CWxM = parcelRequire("2CWxM");
var $cd901ce4ece51bae$var$ARRAY16 = new Array(16);
var $cd901ce4ece51bae$var$zl = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $cd901ce4ece51bae$var$zr = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $cd901ce4ece51bae$var$sl = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $cd901ce4ece51bae$var$sr = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];
var $cd901ce4ece51bae$var$hl = [
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
];
var $cd901ce4ece51bae$var$hr = [
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
];
function $cd901ce4ece51bae$var$RIPEMD160() {
    $2CWxM.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
$hwgCU($cd901ce4ece51bae$var$RIPEMD160, $2CWxM);
$cd901ce4ece51bae$var$RIPEMD160.prototype._update = function() {
    var words = $cd901ce4ece51bae$var$ARRAY16;
    for(var j = 0; j < 16; ++j)words[j] = this._block.readInt32LE(j * 4);
    var al = this._a | 0;
    var bl = this._b | 0;
    var cl = this._c | 0;
    var dl = this._d | 0;
    var el = this._e | 0;
    var ar = this._a | 0;
    var br = this._b | 0;
    var cr = this._c | 0;
    var dr = this._d | 0;
    var er = this._e | 0;
    // computation
    for(var i = 0; i < 80; i += 1){
        var tl;
        var tr;
        if (i < 16) {
            tl = $cd901ce4ece51bae$var$fn1(al, bl, cl, dl, el, words[$cd901ce4ece51bae$var$zl[i]], $cd901ce4ece51bae$var$hl[0], $cd901ce4ece51bae$var$sl[i]);
            tr = $cd901ce4ece51bae$var$fn5(ar, br, cr, dr, er, words[$cd901ce4ece51bae$var$zr[i]], $cd901ce4ece51bae$var$hr[0], $cd901ce4ece51bae$var$sr[i]);
        } else if (i < 32) {
            tl = $cd901ce4ece51bae$var$fn2(al, bl, cl, dl, el, words[$cd901ce4ece51bae$var$zl[i]], $cd901ce4ece51bae$var$hl[1], $cd901ce4ece51bae$var$sl[i]);
            tr = $cd901ce4ece51bae$var$fn4(ar, br, cr, dr, er, words[$cd901ce4ece51bae$var$zr[i]], $cd901ce4ece51bae$var$hr[1], $cd901ce4ece51bae$var$sr[i]);
        } else if (i < 48) {
            tl = $cd901ce4ece51bae$var$fn3(al, bl, cl, dl, el, words[$cd901ce4ece51bae$var$zl[i]], $cd901ce4ece51bae$var$hl[2], $cd901ce4ece51bae$var$sl[i]);
            tr = $cd901ce4ece51bae$var$fn3(ar, br, cr, dr, er, words[$cd901ce4ece51bae$var$zr[i]], $cd901ce4ece51bae$var$hr[2], $cd901ce4ece51bae$var$sr[i]);
        } else if (i < 64) {
            tl = $cd901ce4ece51bae$var$fn4(al, bl, cl, dl, el, words[$cd901ce4ece51bae$var$zl[i]], $cd901ce4ece51bae$var$hl[3], $cd901ce4ece51bae$var$sl[i]);
            tr = $cd901ce4ece51bae$var$fn2(ar, br, cr, dr, er, words[$cd901ce4ece51bae$var$zr[i]], $cd901ce4ece51bae$var$hr[3], $cd901ce4ece51bae$var$sr[i]);
        } else {
            tl = $cd901ce4ece51bae$var$fn5(al, bl, cl, dl, el, words[$cd901ce4ece51bae$var$zl[i]], $cd901ce4ece51bae$var$hl[4], $cd901ce4ece51bae$var$sl[i]);
            tr = $cd901ce4ece51bae$var$fn1(ar, br, cr, dr, er, words[$cd901ce4ece51bae$var$zr[i]], $cd901ce4ece51bae$var$hr[4], $cd901ce4ece51bae$var$sr[i]);
        }
        al = el;
        el = dl;
        dl = $cd901ce4ece51bae$var$rotl(cl, 10);
        cl = bl;
        bl = tl;
        ar = er;
        er = dr;
        dr = $cd901ce4ece51bae$var$rotl(cr, 10);
        cr = br;
        br = tr;
    }
    // update state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
$cd901ce4ece51bae$var$RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $cd901ce4ece51bae$require$Buffer.alloc ? $cd901ce4ece51bae$require$Buffer.alloc(20) : new $cd901ce4ece51bae$require$Buffer(20);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
function $cd901ce4ece51bae$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $cd901ce4ece51bae$var$fn1(a, b, c, d, e, m, k, s) {
    return $cd901ce4ece51bae$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function $cd901ce4ece51bae$var$fn2(a, b, c, d, e, m, k, s) {
    return $cd901ce4ece51bae$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function $cd901ce4ece51bae$var$fn3(a, b, c, d, e, m, k, s) {
    return $cd901ce4ece51bae$var$rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function $cd901ce4ece51bae$var$fn4(a, b, c, d, e, m, k, s) {
    return $cd901ce4ece51bae$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function $cd901ce4ece51bae$var$fn5(a, b, c, d, e, m, k, s) {
    return $cd901ce4ece51bae$var$rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
module.exports = $cd901ce4ece51bae$var$RIPEMD160;

});

parcelRegister("2K8vW", function(module, exports) {
var $1ff67b64544499f5$var$exports = module.exports = function SHA(algorithm) {
    algorithm = algorithm.toLowerCase();
    var Algorithm = $1ff67b64544499f5$var$exports[algorithm];
    if (!Algorithm) throw new Error(algorithm + " is not supported (we accept pull requests)");
    return new Algorithm();
};

$1ff67b64544499f5$var$exports.sha = (parcelRequire("5dn1l"));

$1ff67b64544499f5$var$exports.sha1 = (parcelRequire("7MIHN"));

$1ff67b64544499f5$var$exports.sha224 = (parcelRequire("7ndu3"));

$1ff67b64544499f5$var$exports.sha256 = (parcelRequire("3cndD"));

$1ff67b64544499f5$var$exports.sha384 = (parcelRequire("56LDo"));

$1ff67b64544499f5$var$exports.sha512 = (parcelRequire("j1Oyd"));

});
parcelRegister("5dn1l", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */ 
var $hwgCU = parcelRequire("hwgCU");

var $5MBZl = parcelRequire("5MBZl");

var $f6JDE = parcelRequire("f6JDE");
var $3cc006166bea5d4d$require$Buffer = $f6JDE.Buffer;
var $3cc006166bea5d4d$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $3cc006166bea5d4d$var$W = new Array(80);
function $3cc006166bea5d4d$var$Sha() {
    this.init();
    this._w = $3cc006166bea5d4d$var$W;
    $5MBZl.call(this, 64, 56);
}
$hwgCU($3cc006166bea5d4d$var$Sha, $5MBZl);
$3cc006166bea5d4d$var$Sha.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $3cc006166bea5d4d$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $3cc006166bea5d4d$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $3cc006166bea5d4d$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$3cc006166bea5d4d$var$Sha.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $3cc006166bea5d4d$var$rotl5(a) + $3cc006166bea5d4d$var$ft(s, b, c, d) + e + W[j] + $3cc006166bea5d4d$var$K[s] | 0;
        e = d;
        d = c;
        c = $3cc006166bea5d4d$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$3cc006166bea5d4d$var$Sha.prototype._hash = function() {
    var H = $3cc006166bea5d4d$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $3cc006166bea5d4d$var$Sha;

});
parcelRegister("5MBZl", function(module, exports) {

var $f6JDE = parcelRequire("f6JDE");
var $435ee72272142fa8$require$Buffer = $f6JDE.Buffer;
// prototype class for hash functions
function $435ee72272142fa8$var$Hash(blockSize, finalSize) {
    this._block = $435ee72272142fa8$require$Buffer.alloc(blockSize);
    this._finalSize = finalSize;
    this._blockSize = blockSize;
    this._len = 0;
}
$435ee72272142fa8$var$Hash.prototype.update = function(data, enc) {
    if (typeof data === "string") {
        enc = enc || "utf8";
        data = $435ee72272142fa8$require$Buffer.from(data, enc);
    }
    var block = this._block;
    var blockSize = this._blockSize;
    var length = data.length;
    var accum = this._len;
    for(var offset = 0; offset < length;){
        var assigned = accum % blockSize;
        var remainder = Math.min(length - offset, blockSize - assigned);
        for(var i = 0; i < remainder; i++)block[assigned + i] = data[offset + i];
        accum += remainder;
        offset += remainder;
        if (accum % blockSize === 0) this._update(block);
    }
    this._len += length;
    return this;
};
$435ee72272142fa8$var$Hash.prototype.digest = function(enc) {
    var rem = this._len % this._blockSize;
    this._block[rem] = 0x80;
    // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
    // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
    this._block.fill(0, rem + 1);
    if (rem >= this._finalSize) {
        this._update(this._block);
        this._block.fill(0);
    }
    var bits = this._len * 8;
    // uint32
    if (bits <= 0xffffffff) this._block.writeUInt32BE(bits, this._blockSize - 4);
    else {
        var lowBits = (bits & 0xffffffff) >>> 0;
        var highBits = (bits - lowBits) / 0x100000000;
        this._block.writeUInt32BE(highBits, this._blockSize - 8);
        this._block.writeUInt32BE(lowBits, this._blockSize - 4);
    }
    this._update(this._block);
    var hash = this._hash();
    return enc ? hash.toString(enc) : hash;
};
$435ee72272142fa8$var$Hash.prototype._update = function() {
    throw new Error("_update must be implemented by subclass");
};
module.exports = $435ee72272142fa8$var$Hash;

});


parcelRegister("7MIHN", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */ 
var $hwgCU = parcelRequire("hwgCU");

var $5MBZl = parcelRequire("5MBZl");

var $f6JDE = parcelRequire("f6JDE");
var $5aafb1a7746401b9$require$Buffer = $f6JDE.Buffer;
var $5aafb1a7746401b9$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $5aafb1a7746401b9$var$W = new Array(80);
function $5aafb1a7746401b9$var$Sha1() {
    this.init();
    this._w = $5aafb1a7746401b9$var$W;
    $5MBZl.call(this, 64, 56);
}
$hwgCU($5aafb1a7746401b9$var$Sha1, $5MBZl);
$5aafb1a7746401b9$var$Sha1.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $5aafb1a7746401b9$var$rotl1(num) {
    return num << 1 | num >>> 31;
}
function $5aafb1a7746401b9$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $5aafb1a7746401b9$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $5aafb1a7746401b9$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$5aafb1a7746401b9$var$Sha1.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = $5aafb1a7746401b9$var$rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]);
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $5aafb1a7746401b9$var$rotl5(a) + $5aafb1a7746401b9$var$ft(s, b, c, d) + e + W[j] + $5aafb1a7746401b9$var$K[s] | 0;
        e = d;
        d = c;
        c = $5aafb1a7746401b9$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$5aafb1a7746401b9$var$Sha1.prototype._hash = function() {
    var H = $5aafb1a7746401b9$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $5aafb1a7746401b9$var$Sha1;

});

parcelRegister("7ndu3", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $hwgCU = parcelRequire("hwgCU");

var $3cndD = parcelRequire("3cndD");

var $5MBZl = parcelRequire("5MBZl");

var $f6JDE = parcelRequire("f6JDE");
var $55e523f5b86214af$require$Buffer = $f6JDE.Buffer;
var $55e523f5b86214af$var$W = new Array(64);
function $55e523f5b86214af$var$Sha224() {
    this.init();
    this._w = $55e523f5b86214af$var$W // new Array(64)
    ;
    $5MBZl.call(this, 64, 56);
}
$hwgCU($55e523f5b86214af$var$Sha224, $3cndD);
$55e523f5b86214af$var$Sha224.prototype.init = function() {
    this._a = 0xc1059ed8;
    this._b = 0x367cd507;
    this._c = 0x3070dd17;
    this._d = 0xf70e5939;
    this._e = 0xffc00b31;
    this._f = 0x68581511;
    this._g = 0x64f98fa7;
    this._h = 0xbefa4fa4;
    return this;
};
$55e523f5b86214af$var$Sha224.prototype._hash = function() {
    var H = $55e523f5b86214af$require$Buffer.allocUnsafe(28);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    return H;
};
module.exports = $55e523f5b86214af$var$Sha224;

});
parcelRegister("3cndD", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $hwgCU = parcelRequire("hwgCU");

var $5MBZl = parcelRequire("5MBZl");

var $f6JDE = parcelRequire("f6JDE");
var $254480e1a267a658$require$Buffer = $f6JDE.Buffer;
var $254480e1a267a658$var$K = [
    0x428A2F98,
    0x71374491,
    0xB5C0FBCF,
    0xE9B5DBA5,
    0x3956C25B,
    0x59F111F1,
    0x923F82A4,
    0xAB1C5ED5,
    0xD807AA98,
    0x12835B01,
    0x243185BE,
    0x550C7DC3,
    0x72BE5D74,
    0x80DEB1FE,
    0x9BDC06A7,
    0xC19BF174,
    0xE49B69C1,
    0xEFBE4786,
    0x0FC19DC6,
    0x240CA1CC,
    0x2DE92C6F,
    0x4A7484AA,
    0x5CB0A9DC,
    0x76F988DA,
    0x983E5152,
    0xA831C66D,
    0xB00327C8,
    0xBF597FC7,
    0xC6E00BF3,
    0xD5A79147,
    0x06CA6351,
    0x14292967,
    0x27B70A85,
    0x2E1B2138,
    0x4D2C6DFC,
    0x53380D13,
    0x650A7354,
    0x766A0ABB,
    0x81C2C92E,
    0x92722C85,
    0xA2BFE8A1,
    0xA81A664B,
    0xC24B8B70,
    0xC76C51A3,
    0xD192E819,
    0xD6990624,
    0xF40E3585,
    0x106AA070,
    0x19A4C116,
    0x1E376C08,
    0x2748774C,
    0x34B0BCB5,
    0x391C0CB3,
    0x4ED8AA4A,
    0x5B9CCA4F,
    0x682E6FF3,
    0x748F82EE,
    0x78A5636F,
    0x84C87814,
    0x8CC70208,
    0x90BEFFFA,
    0xA4506CEB,
    0xBEF9A3F7,
    0xC67178F2
];
var $254480e1a267a658$var$W = new Array(64);
function $254480e1a267a658$var$Sha256() {
    this.init();
    this._w = $254480e1a267a658$var$W // new Array(64)
    ;
    $5MBZl.call(this, 64, 56);
}
$hwgCU($254480e1a267a658$var$Sha256, $5MBZl);
$254480e1a267a658$var$Sha256.prototype.init = function() {
    this._a = 0x6a09e667;
    this._b = 0xbb67ae85;
    this._c = 0x3c6ef372;
    this._d = 0xa54ff53a;
    this._e = 0x510e527f;
    this._f = 0x9b05688c;
    this._g = 0x1f83d9ab;
    this._h = 0x5be0cd19;
    return this;
};
function $254480e1a267a658$var$ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $254480e1a267a658$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $254480e1a267a658$var$sigma0(x) {
    return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
}
function $254480e1a267a658$var$sigma1(x) {
    return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
}
function $254480e1a267a658$var$gamma0(x) {
    return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
}
function $254480e1a267a658$var$gamma1(x) {
    return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
}
$254480e1a267a658$var$Sha256.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    var f = this._f | 0;
    var g = this._g | 0;
    var h = this._h | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 64; ++i)W[i] = $254480e1a267a658$var$gamma1(W[i - 2]) + W[i - 7] + $254480e1a267a658$var$gamma0(W[i - 15]) + W[i - 16] | 0;
    for(var j = 0; j < 64; ++j){
        var T1 = h + $254480e1a267a658$var$sigma1(e) + $254480e1a267a658$var$ch(e, f, g) + $254480e1a267a658$var$K[j] + W[j] | 0;
        var T2 = $254480e1a267a658$var$sigma0(a) + $254480e1a267a658$var$maj(a, b, c) | 0;
        h = g;
        g = f;
        f = e;
        e = d + T1 | 0;
        d = c;
        c = b;
        b = a;
        a = T1 + T2 | 0;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
    this._f = f + this._f | 0;
    this._g = g + this._g | 0;
    this._h = h + this._h | 0;
};
$254480e1a267a658$var$Sha256.prototype._hash = function() {
    var H = $254480e1a267a658$require$Buffer.allocUnsafe(32);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    H.writeInt32BE(this._h, 28);
    return H;
};
module.exports = $254480e1a267a658$var$Sha256;

});


parcelRegister("56LDo", function(module, exports) {

var $hwgCU = parcelRequire("hwgCU");

var $j1Oyd = parcelRequire("j1Oyd");

var $5MBZl = parcelRequire("5MBZl");

var $f6JDE = parcelRequire("f6JDE");
var $3b82767865680f4e$require$Buffer = $f6JDE.Buffer;
var $3b82767865680f4e$var$W = new Array(160);
function $3b82767865680f4e$var$Sha384() {
    this.init();
    this._w = $3b82767865680f4e$var$W;
    $5MBZl.call(this, 128, 112);
}
$hwgCU($3b82767865680f4e$var$Sha384, $j1Oyd);
$3b82767865680f4e$var$Sha384.prototype.init = function() {
    this._ah = 0xcbbb9d5d;
    this._bh = 0x629a292a;
    this._ch = 0x9159015a;
    this._dh = 0x152fecd8;
    this._eh = 0x67332667;
    this._fh = 0x8eb44a87;
    this._gh = 0xdb0c2e0d;
    this._hh = 0x47b5481d;
    this._al = 0xc1059ed8;
    this._bl = 0x367cd507;
    this._cl = 0x3070dd17;
    this._dl = 0xf70e5939;
    this._el = 0xffc00b31;
    this._fl = 0x68581511;
    this._gl = 0x64f98fa7;
    this._hl = 0xbefa4fa4;
    return this;
};
$3b82767865680f4e$var$Sha384.prototype._hash = function() {
    var H = $3b82767865680f4e$require$Buffer.allocUnsafe(48);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    return H;
};
module.exports = $3b82767865680f4e$var$Sha384;

});
parcelRegister("j1Oyd", function(module, exports) {

var $hwgCU = parcelRequire("hwgCU");

var $5MBZl = parcelRequire("5MBZl");

var $f6JDE = parcelRequire("f6JDE");
var $dda552a6cacb7ba0$require$Buffer = $f6JDE.Buffer;
var $dda552a6cacb7ba0$var$K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
var $dda552a6cacb7ba0$var$W = new Array(160);
function $dda552a6cacb7ba0$var$Sha512() {
    this.init();
    this._w = $dda552a6cacb7ba0$var$W;
    $5MBZl.call(this, 128, 112);
}
$hwgCU($dda552a6cacb7ba0$var$Sha512, $5MBZl);
$dda552a6cacb7ba0$var$Sha512.prototype.init = function() {
    this._ah = 0x6a09e667;
    this._bh = 0xbb67ae85;
    this._ch = 0x3c6ef372;
    this._dh = 0xa54ff53a;
    this._eh = 0x510e527f;
    this._fh = 0x9b05688c;
    this._gh = 0x1f83d9ab;
    this._hh = 0x5be0cd19;
    this._al = 0xf3bcc908;
    this._bl = 0x84caa73b;
    this._cl = 0xfe94f82b;
    this._dl = 0x5f1d36f1;
    this._el = 0xade682d1;
    this._fl = 0x2b3e6c1f;
    this._gl = 0xfb41bd6b;
    this._hl = 0x137e2179;
    return this;
};
function $dda552a6cacb7ba0$var$Ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $dda552a6cacb7ba0$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $dda552a6cacb7ba0$var$sigma0(x, xl) {
    return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
}
function $dda552a6cacb7ba0$var$sigma1(x, xl) {
    return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
}
function $dda552a6cacb7ba0$var$Gamma0(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
}
function $dda552a6cacb7ba0$var$Gamma0l(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
}
function $dda552a6cacb7ba0$var$Gamma1(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
}
function $dda552a6cacb7ba0$var$Gamma1l(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
}
function $dda552a6cacb7ba0$var$getCarry(a, b) {
    return a >>> 0 < b >>> 0 ? 1 : 0;
}
$dda552a6cacb7ba0$var$Sha512.prototype._update = function(M) {
    var W = this._w;
    var ah = this._ah | 0;
    var bh = this._bh | 0;
    var ch = this._ch | 0;
    var dh = this._dh | 0;
    var eh = this._eh | 0;
    var fh = this._fh | 0;
    var gh = this._gh | 0;
    var hh = this._hh | 0;
    var al = this._al | 0;
    var bl = this._bl | 0;
    var cl = this._cl | 0;
    var dl = this._dl | 0;
    var el = this._el | 0;
    var fl = this._fl | 0;
    var gl = this._gl | 0;
    var hl = this._hl | 0;
    for(var i = 0; i < 32; i += 2){
        W[i] = M.readInt32BE(i * 4);
        W[i + 1] = M.readInt32BE(i * 4 + 4);
    }
    for(; i < 160; i += 2){
        var xh = W[i - 30];
        var xl = W[i - 30 + 1];
        var gamma0 = $dda552a6cacb7ba0$var$Gamma0(xh, xl);
        var gamma0l = $dda552a6cacb7ba0$var$Gamma0l(xl, xh);
        xh = W[i - 4];
        xl = W[i - 4 + 1];
        var gamma1 = $dda552a6cacb7ba0$var$Gamma1(xh, xl);
        var gamma1l = $dda552a6cacb7ba0$var$Gamma1l(xl, xh);
        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
        var Wi7h = W[i - 14];
        var Wi7l = W[i - 14 + 1];
        var Wi16h = W[i - 32];
        var Wi16l = W[i - 32 + 1];
        var Wil = gamma0l + Wi7l | 0;
        var Wih = gamma0 + Wi7h + $dda552a6cacb7ba0$var$getCarry(Wil, gamma0l) | 0;
        Wil = Wil + gamma1l | 0;
        Wih = Wih + gamma1 + $dda552a6cacb7ba0$var$getCarry(Wil, gamma1l) | 0;
        Wil = Wil + Wi16l | 0;
        Wih = Wih + Wi16h + $dda552a6cacb7ba0$var$getCarry(Wil, Wi16l) | 0;
        W[i] = Wih;
        W[i + 1] = Wil;
    }
    for(var j = 0; j < 160; j += 2){
        Wih = W[j];
        Wil = W[j + 1];
        var majh = $dda552a6cacb7ba0$var$maj(ah, bh, ch);
        var majl = $dda552a6cacb7ba0$var$maj(al, bl, cl);
        var sigma0h = $dda552a6cacb7ba0$var$sigma0(ah, al);
        var sigma0l = $dda552a6cacb7ba0$var$sigma0(al, ah);
        var sigma1h = $dda552a6cacb7ba0$var$sigma1(eh, el);
        var sigma1l = $dda552a6cacb7ba0$var$sigma1(el, eh);
        // t1 = h + sigma1 + ch + K[j] + W[j]
        var Kih = $dda552a6cacb7ba0$var$K[j];
        var Kil = $dda552a6cacb7ba0$var$K[j + 1];
        var chh = $dda552a6cacb7ba0$var$Ch(eh, fh, gh);
        var chl = $dda552a6cacb7ba0$var$Ch(el, fl, gl);
        var t1l = hl + sigma1l | 0;
        var t1h = hh + sigma1h + $dda552a6cacb7ba0$var$getCarry(t1l, hl) | 0;
        t1l = t1l + chl | 0;
        t1h = t1h + chh + $dda552a6cacb7ba0$var$getCarry(t1l, chl) | 0;
        t1l = t1l + Kil | 0;
        t1h = t1h + Kih + $dda552a6cacb7ba0$var$getCarry(t1l, Kil) | 0;
        t1l = t1l + Wil | 0;
        t1h = t1h + Wih + $dda552a6cacb7ba0$var$getCarry(t1l, Wil) | 0;
        // t2 = sigma0 + maj
        var t2l = sigma0l + majl | 0;
        var t2h = sigma0h + majh + $dda552a6cacb7ba0$var$getCarry(t2l, sigma0l) | 0;
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        el = dl + t1l | 0;
        eh = dh + t1h + $dda552a6cacb7ba0$var$getCarry(el, dl) | 0;
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        al = t1l + t2l | 0;
        ah = t1h + t2h + $dda552a6cacb7ba0$var$getCarry(al, t1l) | 0;
    }
    this._al = this._al + al | 0;
    this._bl = this._bl + bl | 0;
    this._cl = this._cl + cl | 0;
    this._dl = this._dl + dl | 0;
    this._el = this._el + el | 0;
    this._fl = this._fl + fl | 0;
    this._gl = this._gl + gl | 0;
    this._hl = this._hl + hl | 0;
    this._ah = this._ah + ah + $dda552a6cacb7ba0$var$getCarry(this._al, al) | 0;
    this._bh = this._bh + bh + $dda552a6cacb7ba0$var$getCarry(this._bl, bl) | 0;
    this._ch = this._ch + ch + $dda552a6cacb7ba0$var$getCarry(this._cl, cl) | 0;
    this._dh = this._dh + dh + $dda552a6cacb7ba0$var$getCarry(this._dl, dl) | 0;
    this._eh = this._eh + eh + $dda552a6cacb7ba0$var$getCarry(this._el, el) | 0;
    this._fh = this._fh + fh + $dda552a6cacb7ba0$var$getCarry(this._fl, fl) | 0;
    this._gh = this._gh + gh + $dda552a6cacb7ba0$var$getCarry(this._gl, gl) | 0;
    this._hh = this._hh + hh + $dda552a6cacb7ba0$var$getCarry(this._hl, hl) | 0;
};
$dda552a6cacb7ba0$var$Sha512.prototype._hash = function() {
    var H = $dda552a6cacb7ba0$require$Buffer.allocUnsafe(64);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    writeInt64BE(this._gh, this._gl, 48);
    writeInt64BE(this._hh, this._hl, 56);
    return H;
};
module.exports = $dda552a6cacb7ba0$var$Sha512;

});



parcelRegister("3iWnY", function(module, exports) {

var $f6JDE = parcelRequire("f6JDE");
var $268057b78fc10758$require$Buffer = $f6JDE.Buffer;

var $l0FDA = parcelRequire("l0FDA");
var $268057b78fc10758$require$Transform = $l0FDA.Transform;

var $3q4dM = parcelRequire("3q4dM");
var $268057b78fc10758$require$StringDecoder = $3q4dM.StringDecoder;

var $hwgCU = parcelRequire("hwgCU");
function $268057b78fc10758$var$CipherBase(hashMode) {
    $268057b78fc10758$require$Transform.call(this);
    this.hashMode = typeof hashMode === "string";
    if (this.hashMode) this[hashMode] = this._finalOrDigest;
    else this.final = this._finalOrDigest;
    if (this._final) {
        this.__final = this._final;
        this._final = null;
    }
    this._decoder = null;
    this._encoding = null;
}
$hwgCU($268057b78fc10758$var$CipherBase, $268057b78fc10758$require$Transform);
$268057b78fc10758$var$CipherBase.prototype.update = function(data, inputEnc, outputEnc) {
    if (typeof data === "string") data = $268057b78fc10758$require$Buffer.from(data, inputEnc);
    var outData = this._update(data);
    if (this.hashMode) return this;
    if (outputEnc) outData = this._toString(outData, outputEnc);
    return outData;
};
$268057b78fc10758$var$CipherBase.prototype.setAutoPadding = function() {};
$268057b78fc10758$var$CipherBase.prototype.getAuthTag = function() {
    throw new Error("trying to get auth tag in unsupported state");
};
$268057b78fc10758$var$CipherBase.prototype.setAuthTag = function() {
    throw new Error("trying to set auth tag in unsupported state");
};
$268057b78fc10758$var$CipherBase.prototype.setAAD = function() {
    throw new Error("trying to set aad in unsupported state");
};
$268057b78fc10758$var$CipherBase.prototype._transform = function(data, _, next) {
    var err;
    try {
        if (this.hashMode) this._update(data);
        else this.push(this._update(data));
    } catch (e) {
        err = e;
    } finally{
        next(err);
    }
};
$268057b78fc10758$var$CipherBase.prototype._flush = function(done) {
    var err;
    try {
        this.push(this.__final());
    } catch (e) {
        err = e;
    }
    done(err);
};
$268057b78fc10758$var$CipherBase.prototype._finalOrDigest = function(outputEnc) {
    var outData = this.__final() || $268057b78fc10758$require$Buffer.alloc(0);
    if (outputEnc) outData = this._toString(outData, outputEnc, true);
    return outData;
};
$268057b78fc10758$var$CipherBase.prototype._toString = function(value, enc, fin) {
    if (!this._decoder) {
        this._decoder = new $268057b78fc10758$require$StringDecoder(enc);
        this._encoding = enc;
    }
    if (this._encoding !== enc) throw new Error("can't switch encodings");
    var out = this._decoder.write(value);
    if (fin) out += this._decoder.end();
    return out;
};
module.exports = $268057b78fc10758$var$CipherBase;

});
parcelRegister("l0FDA", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $f4b9e56ad38471b9$var$Stream;

var $cyxGb = parcelRequire("cyxGb");
var $f4b9e56ad38471b9$require$EE = $cyxGb.EventEmitter;

var $hwgCU = parcelRequire("hwgCU");
$hwgCU($f4b9e56ad38471b9$var$Stream, $f4b9e56ad38471b9$require$EE);

$f4b9e56ad38471b9$var$Stream.Readable = (parcelRequire("kNQv4"));

$f4b9e56ad38471b9$var$Stream.Writable = (parcelRequire("giiCg"));

$f4b9e56ad38471b9$var$Stream.Duplex = (parcelRequire("kPQvy"));

$f4b9e56ad38471b9$var$Stream.Transform = (parcelRequire("43NjS"));

$f4b9e56ad38471b9$var$Stream.PassThrough = (parcelRequire("c04gS"));

$f4b9e56ad38471b9$var$Stream.finished = (parcelRequire("9YDMx"));

$f4b9e56ad38471b9$var$Stream.pipeline = (parcelRequire("bmpl8"));
// Backwards-compat with node 0.4.x
$f4b9e56ad38471b9$var$Stream.Stream = $f4b9e56ad38471b9$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $f4b9e56ad38471b9$var$Stream() {
    $f4b9e56ad38471b9$require$EE.call(this);
}
$f4b9e56ad38471b9$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on("data", ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on("drain", ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on("end", onend);
        source.on("close", onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === "function") dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($f4b9e56ad38471b9$require$EE.listenerCount(this, "error") === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on("error", onerror);
    dest.on("error", onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener("data", ondata);
        dest.removeListener("drain", ondrain);
        source.removeListener("end", onend);
        source.removeListener("close", onclose);
        source.removeListener("error", onerror);
        dest.removeListener("error", onerror);
        source.removeListener("end", cleanup);
        source.removeListener("close", cleanup);
        dest.removeListener("close", cleanup);
    }
    source.on("end", cleanup);
    source.on("close", cleanup);
    dest.on("close", cleanup);
    dest.emit("pipe", source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});



parcelRegister("gEN8J", function(module, exports) {
"use strict";

var $hwgCU = parcelRequire("hwgCU");

var $l8aZe = parcelRequire("l8aZe");

var $3iWnY = parcelRequire("3iWnY");

var $f6JDE = parcelRequire("f6JDE");
var $c2067ff0b37c64c9$require$Buffer = $f6JDE.Buffer;

var $kv7tj = parcelRequire("kv7tj");

var $hEcOA = parcelRequire("hEcOA");

var $2K8vW = parcelRequire("2K8vW");
var $c2067ff0b37c64c9$var$ZEROS = $c2067ff0b37c64c9$require$Buffer.alloc(128);
function $c2067ff0b37c64c9$var$Hmac(alg, key) {
    $3iWnY.call(this, "digest");
    if (typeof key === "string") key = $c2067ff0b37c64c9$require$Buffer.from(key);
    var blocksize = alg === "sha512" || alg === "sha384" ? 128 : 64;
    this._alg = alg;
    this._key = key;
    if (key.length > blocksize) {
        var hash = alg === "rmd160" ? new $hEcOA() : $2K8vW(alg);
        key = hash.update(key).digest();
    } else if (key.length < blocksize) key = $c2067ff0b37c64c9$require$Buffer.concat([
        key,
        $c2067ff0b37c64c9$var$ZEROS
    ], blocksize);
    var ipad = this._ipad = $c2067ff0b37c64c9$require$Buffer.allocUnsafe(blocksize);
    var opad = this._opad = $c2067ff0b37c64c9$require$Buffer.allocUnsafe(blocksize);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = alg === "rmd160" ? new $hEcOA() : $2K8vW(alg);
    this._hash.update(ipad);
}
$hwgCU($c2067ff0b37c64c9$var$Hmac, $3iWnY);
$c2067ff0b37c64c9$var$Hmac.prototype._update = function(data) {
    this._hash.update(data);
};
$c2067ff0b37c64c9$var$Hmac.prototype._final = function() {
    var h = this._hash.digest();
    var hash = this._alg === "rmd160" ? new $hEcOA() : $2K8vW(this._alg);
    return hash.update(this._opad).update(h).digest();
};
module.exports = function createHmac(alg, key) {
    alg = alg.toLowerCase();
    if (alg === "rmd160" || alg === "ripemd160") return new $c2067ff0b37c64c9$var$Hmac("rmd160", key);
    if (alg === "md5") return new $l8aZe($kv7tj, key);
    return new $c2067ff0b37c64c9$var$Hmac(alg, key);
};

});
parcelRegister("l8aZe", function(module, exports) {
"use strict";

var $hwgCU = parcelRequire("hwgCU");

var $f6JDE = parcelRequire("f6JDE");
var $f622de0c484e5b2e$require$Buffer = $f6JDE.Buffer;

var $3iWnY = parcelRequire("3iWnY");
var $f622de0c484e5b2e$var$ZEROS = $f622de0c484e5b2e$require$Buffer.alloc(128);
var $f622de0c484e5b2e$var$blocksize = 64;
function $f622de0c484e5b2e$var$Hmac(alg, key) {
    $3iWnY.call(this, "digest");
    if (typeof key === "string") key = $f622de0c484e5b2e$require$Buffer.from(key);
    this._alg = alg;
    this._key = key;
    if (key.length > $f622de0c484e5b2e$var$blocksize) key = alg(key);
    else if (key.length < $f622de0c484e5b2e$var$blocksize) key = $f622de0c484e5b2e$require$Buffer.concat([
        key,
        $f622de0c484e5b2e$var$ZEROS
    ], $f622de0c484e5b2e$var$blocksize);
    var ipad = this._ipad = $f622de0c484e5b2e$require$Buffer.allocUnsafe($f622de0c484e5b2e$var$blocksize);
    var opad = this._opad = $f622de0c484e5b2e$require$Buffer.allocUnsafe($f622de0c484e5b2e$var$blocksize);
    for(var i = 0; i < $f622de0c484e5b2e$var$blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = [
        ipad
    ];
}
$hwgCU($f622de0c484e5b2e$var$Hmac, $3iWnY);
$f622de0c484e5b2e$var$Hmac.prototype._update = function(data) {
    this._hash.push(data);
};
$f622de0c484e5b2e$var$Hmac.prototype._final = function() {
    var h = this._alg($f622de0c484e5b2e$require$Buffer.concat(this._hash));
    return this._alg($f622de0c484e5b2e$require$Buffer.concat([
        this._opad,
        h
    ]));
};
module.exports = $f622de0c484e5b2e$var$Hmac;

});

parcelRegister("kv7tj", function(module, exports) {

var $d6CkU = parcelRequire("d6CkU");
module.exports = function(buffer) {
    return new $d6CkU().update(buffer).digest();
};

});


parcelRegister("1u3pS", function(module, exports) {

module.exports = (parcelRequire("1Dipf"));

});
parcelRegister("1Dipf", function(module, exports) {
module.exports = JSON.parse('{"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}');

});


parcelRegister("deQJE", function(module, exports) {

$parcel$export(module.exports, "pbkdf2", function () { return $9a357d4bb166bcc0$export$448fa22aedc9dbca; }, function (v) { return $9a357d4bb166bcc0$export$448fa22aedc9dbca = v; });
$parcel$export(module.exports, "pbkdf2Sync", function () { return $9a357d4bb166bcc0$export$b80c7ba289c8fa56; }, function (v) { return $9a357d4bb166bcc0$export$b80c7ba289c8fa56 = v; });
var $9a357d4bb166bcc0$export$448fa22aedc9dbca;
var $9a357d4bb166bcc0$export$b80c7ba289c8fa56;

$9a357d4bb166bcc0$export$448fa22aedc9dbca = (parcelRequire("eUjyU"));

$9a357d4bb166bcc0$export$b80c7ba289c8fa56 = (parcelRequire("5lPwq"));

});
parcelRegister("eUjyU", function(module, exports) {

var $f6JDE = parcelRequire("f6JDE");
var $ada5783fc8caf58d$require$Buffer = $f6JDE.Buffer;

var $10Q1Y = parcelRequire("10Q1Y");

var $5a8Ot = parcelRequire("5a8Ot");

var $5lPwq = parcelRequire("5lPwq");

var $54x9q = parcelRequire("54x9q");
var $ada5783fc8caf58d$var$ZERO_BUF;
var $ada5783fc8caf58d$var$subtle = $parcel$global.crypto && $parcel$global.crypto.subtle;
var $ada5783fc8caf58d$var$toBrowser = {
    sha: "SHA-1",
    "sha-1": "SHA-1",
    sha1: "SHA-1",
    sha256: "SHA-256",
    "sha-256": "SHA-256",
    sha384: "SHA-384",
    "sha-384": "SHA-384",
    "sha-512": "SHA-512",
    sha512: "SHA-512"
};
var $ada5783fc8caf58d$var$checks = [];
function $ada5783fc8caf58d$var$checkNative(algo) {
    if ($parcel$global.process && !$parcel$global.process.browser) return Promise.resolve(false);
    if (!$ada5783fc8caf58d$var$subtle || !$ada5783fc8caf58d$var$subtle.importKey || !$ada5783fc8caf58d$var$subtle.deriveBits) return Promise.resolve(false);
    if ($ada5783fc8caf58d$var$checks[algo] !== undefined) return $ada5783fc8caf58d$var$checks[algo];
    $ada5783fc8caf58d$var$ZERO_BUF = $ada5783fc8caf58d$var$ZERO_BUF || $ada5783fc8caf58d$require$Buffer.alloc(8);
    var prom = $ada5783fc8caf58d$var$browserPbkdf2($ada5783fc8caf58d$var$ZERO_BUF, $ada5783fc8caf58d$var$ZERO_BUF, 10, 128, algo).then(function() {
        return true;
    }).catch(function() {
        return false;
    });
    $ada5783fc8caf58d$var$checks[algo] = prom;
    return prom;
}
var $ada5783fc8caf58d$var$nextTick;
function $ada5783fc8caf58d$var$getNextTick() {
    if ($ada5783fc8caf58d$var$nextTick) return $ada5783fc8caf58d$var$nextTick;
    if ($parcel$global.process && $parcel$global.process.nextTick) $ada5783fc8caf58d$var$nextTick = $parcel$global.process.nextTick;
    else if ($parcel$global.queueMicrotask) $ada5783fc8caf58d$var$nextTick = $parcel$global.queueMicrotask;
    else if ($parcel$global.setImmediate) $ada5783fc8caf58d$var$nextTick = $parcel$global.setImmediate;
    else $ada5783fc8caf58d$var$nextTick = $parcel$global.setTimeout;
    return $ada5783fc8caf58d$var$nextTick;
}
function $ada5783fc8caf58d$var$browserPbkdf2(password, salt, iterations, length, algo) {
    return $ada5783fc8caf58d$var$subtle.importKey("raw", password, {
        name: "PBKDF2"
    }, false, [
        "deriveBits"
    ]).then(function(key) {
        return $ada5783fc8caf58d$var$subtle.deriveBits({
            name: "PBKDF2",
            salt: salt,
            iterations: iterations,
            hash: {
                name: algo
            }
        }, key, length << 3);
    }).then(function(res) {
        return $ada5783fc8caf58d$require$Buffer.from(res);
    });
}
function $ada5783fc8caf58d$var$resolvePromise(promise, callback) {
    promise.then(function(out) {
        $ada5783fc8caf58d$var$getNextTick()(function() {
            callback(null, out);
        });
    }, function(e) {
        $ada5783fc8caf58d$var$getNextTick()(function() {
            callback(e);
        });
    });
}
module.exports = function(password, salt, iterations, keylen, digest, callback) {
    if (typeof digest === "function") {
        callback = digest;
        digest = undefined;
    }
    digest = digest || "sha1";
    var algo = $ada5783fc8caf58d$var$toBrowser[digest.toLowerCase()];
    if (!algo || typeof $parcel$global.Promise !== "function") {
        $ada5783fc8caf58d$var$getNextTick()(function() {
            var out;
            try {
                out = $5lPwq(password, salt, iterations, keylen, digest);
            } catch (e) {
                return callback(e);
            }
            callback(null, out);
        });
        return;
    }
    $10Q1Y(iterations, keylen);
    password = $54x9q(password, $5a8Ot, "Password");
    salt = $54x9q(salt, $5a8Ot, "Salt");
    if (typeof callback !== "function") throw new Error("No callback provided to pbkdf2");
    $ada5783fc8caf58d$var$resolvePromise($ada5783fc8caf58d$var$checkNative(algo).then(function(resp) {
        if (resp) return $ada5783fc8caf58d$var$browserPbkdf2(password, salt, iterations, keylen, algo);
        return $5lPwq(password, salt, iterations, keylen, digest);
    }), callback);
};

});
parcelRegister("10Q1Y", function(module, exports) {
var $0bce26c0776970c7$var$MAX_ALLOC = Math.pow(2, 30) - 1 // default in iojs
;
module.exports = function(iterations, keylen) {
    if (typeof iterations !== "number") throw new TypeError("Iterations not a number");
    if (iterations < 0) throw new TypeError("Bad iterations");
    if (typeof keylen !== "number") throw new TypeError("Key length not a number");
    if (keylen < 0 || keylen > $0bce26c0776970c7$var$MAX_ALLOC || keylen !== keylen) throw new TypeError("Bad key length");
};

});

parcelRegister("5a8Ot", function(module, exports) {

var $3qWgZ = parcelRequire("3qWgZ");
var $3c24b90238f4ff39$var$defaultEncoding;
/* istanbul ignore next */ if ($parcel$global.process && $parcel$global.process.browser) $3c24b90238f4ff39$var$defaultEncoding = "utf-8";
else if ($parcel$global.process && $parcel$global.process.version) {
    var $3c24b90238f4ff39$var$pVersionMajor = parseInt($3qWgZ.version.split(".")[0].slice(1), 10);
    $3c24b90238f4ff39$var$defaultEncoding = $3c24b90238f4ff39$var$pVersionMajor >= 6 ? "utf-8" : "binary";
} else $3c24b90238f4ff39$var$defaultEncoding = "utf-8";
module.exports = $3c24b90238f4ff39$var$defaultEncoding;

});

parcelRegister("5lPwq", function(module, exports) {

var $kv7tj = parcelRequire("kv7tj");

var $hEcOA = parcelRequire("hEcOA");

var $2K8vW = parcelRequire("2K8vW");

var $f6JDE = parcelRequire("f6JDE");
var $3e56e11c2a47f393$require$Buffer = $f6JDE.Buffer;

var $10Q1Y = parcelRequire("10Q1Y");

var $5a8Ot = parcelRequire("5a8Ot");

var $54x9q = parcelRequire("54x9q");
var $3e56e11c2a47f393$var$ZEROS = $3e56e11c2a47f393$require$Buffer.alloc(128);
var $3e56e11c2a47f393$var$sizes = {
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    rmd160: 20,
    ripemd160: 20
};
function $3e56e11c2a47f393$var$Hmac(alg, key, saltLen) {
    var hash = $3e56e11c2a47f393$var$getDigest(alg);
    var blocksize = alg === "sha512" || alg === "sha384" ? 128 : 64;
    if (key.length > blocksize) key = hash(key);
    else if (key.length < blocksize) key = $3e56e11c2a47f393$require$Buffer.concat([
        key,
        $3e56e11c2a47f393$var$ZEROS
    ], blocksize);
    var ipad = $3e56e11c2a47f393$require$Buffer.allocUnsafe(blocksize + $3e56e11c2a47f393$var$sizes[alg]);
    var opad = $3e56e11c2a47f393$require$Buffer.allocUnsafe(blocksize + $3e56e11c2a47f393$var$sizes[alg]);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    var ipad1 = $3e56e11c2a47f393$require$Buffer.allocUnsafe(blocksize + saltLen + 4);
    ipad.copy(ipad1, 0, 0, blocksize);
    this.ipad1 = ipad1;
    this.ipad2 = ipad;
    this.opad = opad;
    this.alg = alg;
    this.blocksize = blocksize;
    this.hash = hash;
    this.size = $3e56e11c2a47f393$var$sizes[alg];
}
$3e56e11c2a47f393$var$Hmac.prototype.run = function(data, ipad) {
    data.copy(ipad, this.blocksize);
    var h = this.hash(ipad);
    h.copy(this.opad, this.blocksize);
    return this.hash(this.opad);
};
function $3e56e11c2a47f393$var$getDigest(alg) {
    function shaFunc(data) {
        return $2K8vW(alg).update(data).digest();
    }
    function rmd160Func(data) {
        return new $hEcOA().update(data).digest();
    }
    if (alg === "rmd160" || alg === "ripemd160") return rmd160Func;
    if (alg === "md5") return $kv7tj;
    return shaFunc;
}
function $3e56e11c2a47f393$var$pbkdf2(password, salt, iterations, keylen, digest) {
    $10Q1Y(iterations, keylen);
    password = $54x9q(password, $5a8Ot, "Password");
    salt = $54x9q(salt, $5a8Ot, "Salt");
    digest = digest || "sha1";
    var hmac = new $3e56e11c2a47f393$var$Hmac(digest, password, salt.length);
    var DK = $3e56e11c2a47f393$require$Buffer.allocUnsafe(keylen);
    var block1 = $3e56e11c2a47f393$require$Buffer.allocUnsafe(salt.length + 4);
    salt.copy(block1, 0, 0, salt.length);
    var destPos = 0;
    var hLen = $3e56e11c2a47f393$var$sizes[digest];
    var l = Math.ceil(keylen / hLen);
    for(var i = 1; i <= l; i++){
        block1.writeUInt32BE(i, salt.length);
        var T = hmac.run(block1, hmac.ipad1);
        var U = T;
        for(var j = 1; j < iterations; j++){
            U = hmac.run(U, hmac.ipad2);
            for(var k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        T.copy(DK, destPos);
        destPos += hLen;
    }
    return DK;
}
module.exports = $3e56e11c2a47f393$var$pbkdf2;

});
parcelRegister("54x9q", function(module, exports) {

var $f6JDE = parcelRequire("f6JDE");
var $3b170a9040eece19$require$Buffer = $f6JDE.Buffer;
module.exports = function(thing, encoding, name) {
    if ($3b170a9040eece19$require$Buffer.isBuffer(thing)) return thing;
    else if (typeof thing === "string") return $3b170a9040eece19$require$Buffer.from(thing, encoding);
    else if (ArrayBuffer.isView(thing)) return $3b170a9040eece19$require$Buffer.from(thing.buffer);
    else throw new TypeError(name + " must be a string, a Buffer, a typed array or a DataView");
};

});




parcelRegister("iTle6", function(module, exports) {

$parcel$export(module.exports, "createCipher", function () { return $dc0dd42dcd0826c3$export$bdd223f16383713e; }, function (v) { return $dc0dd42dcd0826c3$export$bdd223f16383713e = v; });
$parcel$export(module.exports, "Cipher", function () { return $dc0dd42dcd0826c3$export$26e5786e8ac8e530; }, function (v) { return $dc0dd42dcd0826c3$export$26e5786e8ac8e530 = v; });
$parcel$export(module.exports, "createCipheriv", function () { return $dc0dd42dcd0826c3$export$2f64596b8cbf08b4; }, function (v) { return $dc0dd42dcd0826c3$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "Cipheriv", function () { return $dc0dd42dcd0826c3$export$20533d26f07f1ee0; }, function (v) { return $dc0dd42dcd0826c3$export$20533d26f07f1ee0 = v; });
$parcel$export(module.exports, "createDecipher", function () { return $dc0dd42dcd0826c3$export$12ada9414fbc594c; }, function (v) { return $dc0dd42dcd0826c3$export$12ada9414fbc594c = v; });
$parcel$export(module.exports, "Decipher", function () { return $dc0dd42dcd0826c3$export$2ce6d8d0e8b04e1a; }, function (v) { return $dc0dd42dcd0826c3$export$2ce6d8d0e8b04e1a = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $dc0dd42dcd0826c3$export$36b6d6ef312eab39; }, function (v) { return $dc0dd42dcd0826c3$export$36b6d6ef312eab39 = v; });
$parcel$export(module.exports, "Decipheriv", function () { return $dc0dd42dcd0826c3$export$f5e7e39d57cd9700; }, function (v) { return $dc0dd42dcd0826c3$export$f5e7e39d57cd9700 = v; });
$parcel$export(module.exports, "listCiphers", function () { return $dc0dd42dcd0826c3$export$dedd8dc3dc62b370; }, function (v) { return $dc0dd42dcd0826c3$export$dedd8dc3dc62b370 = v; });
$parcel$export(module.exports, "getCiphers", function () { return $dc0dd42dcd0826c3$export$58a258485f1e49f6; }, function (v) { return $dc0dd42dcd0826c3$export$58a258485f1e49f6 = v; });
var $dc0dd42dcd0826c3$export$bdd223f16383713e;
var $dc0dd42dcd0826c3$export$26e5786e8ac8e530;
var $dc0dd42dcd0826c3$export$2f64596b8cbf08b4;
var $dc0dd42dcd0826c3$export$20533d26f07f1ee0;
var $dc0dd42dcd0826c3$export$12ada9414fbc594c;
var $dc0dd42dcd0826c3$export$2ce6d8d0e8b04e1a;
var $dc0dd42dcd0826c3$export$36b6d6ef312eab39;
var $dc0dd42dcd0826c3$export$f5e7e39d57cd9700;
var $dc0dd42dcd0826c3$export$dedd8dc3dc62b370;
var $dc0dd42dcd0826c3$export$58a258485f1e49f6;

var $eq2g5 = parcelRequire("eq2g5");

var $aRQ6l = parcelRequire("aRQ6l");

var $6dfWh = parcelRequire("6dfWh");

var $cIuhm = parcelRequire("cIuhm");

var $31WmI = parcelRequire("31WmI");
function $dc0dd42dcd0826c3$var$createCipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($6dfWh[suite]) {
        keyLen = $6dfWh[suite].key;
        ivLen = $6dfWh[suite].iv;
    } else if ($cIuhm[suite]) {
        keyLen = $cIuhm[suite].key * 8;
        ivLen = $cIuhm[suite].iv;
    } else throw new TypeError("invalid suite type");
    var keys = $31WmI(password, false, keyLen, ivLen);
    return $dc0dd42dcd0826c3$var$createCipheriv(suite, keys.key, keys.iv);
}
function $dc0dd42dcd0826c3$var$createDecipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($6dfWh[suite]) {
        keyLen = $6dfWh[suite].key;
        ivLen = $6dfWh[suite].iv;
    } else if ($cIuhm[suite]) {
        keyLen = $cIuhm[suite].key * 8;
        ivLen = $cIuhm[suite].iv;
    } else throw new TypeError("invalid suite type");
    var keys = $31WmI(password, false, keyLen, ivLen);
    return $dc0dd42dcd0826c3$var$createDecipheriv(suite, keys.key, keys.iv);
}
function $dc0dd42dcd0826c3$var$createCipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($6dfWh[suite]) return $aRQ6l.createCipheriv(suite, key, iv);
    if ($cIuhm[suite]) return new $eq2g5({
        key: key,
        iv: iv,
        mode: suite
    });
    throw new TypeError("invalid suite type");
}
function $dc0dd42dcd0826c3$var$createDecipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($6dfWh[suite]) return $aRQ6l.createDecipheriv(suite, key, iv);
    if ($cIuhm[suite]) return new $eq2g5({
        key: key,
        iv: iv,
        mode: suite,
        decrypt: true
    });
    throw new TypeError("invalid suite type");
}
function $dc0dd42dcd0826c3$var$getCiphers() {
    return Object.keys($cIuhm).concat($aRQ6l.getCiphers());
}
$dc0dd42dcd0826c3$export$bdd223f16383713e = $dc0dd42dcd0826c3$export$26e5786e8ac8e530 = $dc0dd42dcd0826c3$var$createCipher;
$dc0dd42dcd0826c3$export$2f64596b8cbf08b4 = $dc0dd42dcd0826c3$export$20533d26f07f1ee0 = $dc0dd42dcd0826c3$var$createCipheriv;
$dc0dd42dcd0826c3$export$12ada9414fbc594c = $dc0dd42dcd0826c3$export$2ce6d8d0e8b04e1a = $dc0dd42dcd0826c3$var$createDecipher;
$dc0dd42dcd0826c3$export$36b6d6ef312eab39 = $dc0dd42dcd0826c3$export$f5e7e39d57cd9700 = $dc0dd42dcd0826c3$var$createDecipheriv;
$dc0dd42dcd0826c3$export$dedd8dc3dc62b370 = $dc0dd42dcd0826c3$export$58a258485f1e49f6 = $dc0dd42dcd0826c3$var$getCiphers;

});
parcelRegister("eq2g5", function(module, exports) {

var $3iWnY = parcelRequire("3iWnY");

var $4x2Hb = parcelRequire("4x2Hb");

var $hwgCU = parcelRequire("hwgCU");

var $f6JDE = parcelRequire("f6JDE");
var $a7f53ee23cca8e16$require$Buffer = $f6JDE.Buffer;
var $a7f53ee23cca8e16$var$modes = {
    "des-ede3-cbc": $4x2Hb.CBC.instantiate($4x2Hb.EDE),
    "des-ede3": $4x2Hb.EDE,
    "des-ede-cbc": $4x2Hb.CBC.instantiate($4x2Hb.EDE),
    "des-ede": $4x2Hb.EDE,
    "des-cbc": $4x2Hb.CBC.instantiate($4x2Hb.DES),
    "des-ecb": $4x2Hb.DES
};
$a7f53ee23cca8e16$var$modes.des = $a7f53ee23cca8e16$var$modes["des-cbc"];
$a7f53ee23cca8e16$var$modes.des3 = $a7f53ee23cca8e16$var$modes["des-ede3-cbc"];
module.exports = $a7f53ee23cca8e16$var$DES;
$hwgCU($a7f53ee23cca8e16$var$DES, $3iWnY);
function $a7f53ee23cca8e16$var$DES(opts) {
    $3iWnY.call(this);
    var modeName = opts.mode.toLowerCase();
    var mode = $a7f53ee23cca8e16$var$modes[modeName];
    var type;
    if (opts.decrypt) type = "decrypt";
    else type = "encrypt";
    var key = opts.key;
    if (!$a7f53ee23cca8e16$require$Buffer.isBuffer(key)) key = $a7f53ee23cca8e16$require$Buffer.from(key);
    if (modeName === "des-ede" || modeName === "des-ede-cbc") key = $a7f53ee23cca8e16$require$Buffer.concat([
        key,
        key.slice(0, 8)
    ]);
    var iv = opts.iv;
    if (!$a7f53ee23cca8e16$require$Buffer.isBuffer(iv)) iv = $a7f53ee23cca8e16$require$Buffer.from(iv);
    this._des = mode.create({
        key: key,
        iv: iv,
        type: type
    });
}
$a7f53ee23cca8e16$var$DES.prototype._update = function(data) {
    return $a7f53ee23cca8e16$require$Buffer.from(this._des.update(data));
};
$a7f53ee23cca8e16$var$DES.prototype._final = function() {
    return $a7f53ee23cca8e16$require$Buffer.from(this._des.final());
};

});
parcelRegister("4x2Hb", function(module, exports) {

$parcel$export(module.exports, "DES", function () { return $34cc55c637d8a80b$export$cc8859615686b300; }, function (v) { return $34cc55c637d8a80b$export$cc8859615686b300 = v; });
$parcel$export(module.exports, "CBC", function () { return $34cc55c637d8a80b$export$8ad3f227af08fcc5; }, function (v) { return $34cc55c637d8a80b$export$8ad3f227af08fcc5 = v; });
$parcel$export(module.exports, "EDE", function () { return $34cc55c637d8a80b$export$947646e34766044f; }, function (v) { return $34cc55c637d8a80b$export$947646e34766044f = v; });
var $34cc55c637d8a80b$export$eab97d15b1788b8d;
var $34cc55c637d8a80b$export$26e5786e8ac8e530;
var $34cc55c637d8a80b$export$cc8859615686b300;
var $34cc55c637d8a80b$export$8ad3f227af08fcc5;
var $34cc55c637d8a80b$export$947646e34766044f;
"use strict";

$34cc55c637d8a80b$export$eab97d15b1788b8d = (parcelRequire("6bLgN"));

$34cc55c637d8a80b$export$26e5786e8ac8e530 = (parcelRequire("juQQV"));

$34cc55c637d8a80b$export$cc8859615686b300 = (parcelRequire("dNPGF"));

$34cc55c637d8a80b$export$8ad3f227af08fcc5 = (parcelRequire("b8O1s"));

$34cc55c637d8a80b$export$947646e34766044f = (parcelRequire("5wR3a"));

});
parcelRegister("6bLgN", function(module, exports) {

$parcel$export(module.exports, "readUInt32BE", function () { return $48186ffb13ebb8e8$export$cfaef8ed399428b0; }, function (v) { return $48186ffb13ebb8e8$export$cfaef8ed399428b0 = v; });
$parcel$export(module.exports, "writeUInt32BE", function () { return $48186ffb13ebb8e8$export$a80c7deaea7cbd80; }, function (v) { return $48186ffb13ebb8e8$export$a80c7deaea7cbd80 = v; });
$parcel$export(module.exports, "ip", function () { return $48186ffb13ebb8e8$export$ed7577ae6e1cd0ef; }, function (v) { return $48186ffb13ebb8e8$export$ed7577ae6e1cd0ef = v; });
$parcel$export(module.exports, "rip", function () { return $48186ffb13ebb8e8$export$5dcbef3aa594f567; }, function (v) { return $48186ffb13ebb8e8$export$5dcbef3aa594f567 = v; });
$parcel$export(module.exports, "pc1", function () { return $48186ffb13ebb8e8$export$5bc8001ca71ed9c5; }, function (v) { return $48186ffb13ebb8e8$export$5bc8001ca71ed9c5 = v; });
$parcel$export(module.exports, "r28shl", function () { return $48186ffb13ebb8e8$export$3e714e2c5d5d8cb2; }, function (v) { return $48186ffb13ebb8e8$export$3e714e2c5d5d8cb2 = v; });
$parcel$export(module.exports, "pc2", function () { return $48186ffb13ebb8e8$export$94c3e544fd062b7f; }, function (v) { return $48186ffb13ebb8e8$export$94c3e544fd062b7f = v; });
$parcel$export(module.exports, "expand", function () { return $48186ffb13ebb8e8$export$9f77e0932fb78f72; }, function (v) { return $48186ffb13ebb8e8$export$9f77e0932fb78f72 = v; });
$parcel$export(module.exports, "substitute", function () { return $48186ffb13ebb8e8$export$d865ce2836f5927f; }, function (v) { return $48186ffb13ebb8e8$export$d865ce2836f5927f = v; });
$parcel$export(module.exports, "permute", function () { return $48186ffb13ebb8e8$export$95e62ad65da8b7d2; }, function (v) { return $48186ffb13ebb8e8$export$95e62ad65da8b7d2 = v; });
$parcel$export(module.exports, "padSplit", function () { return $48186ffb13ebb8e8$export$209139ff098c441a; }, function (v) { return $48186ffb13ebb8e8$export$209139ff098c441a = v; });
var $48186ffb13ebb8e8$export$cfaef8ed399428b0;
var $48186ffb13ebb8e8$export$a80c7deaea7cbd80;
var $48186ffb13ebb8e8$export$ed7577ae6e1cd0ef;
var $48186ffb13ebb8e8$export$5dcbef3aa594f567;
var $48186ffb13ebb8e8$export$5bc8001ca71ed9c5;
var $48186ffb13ebb8e8$export$3e714e2c5d5d8cb2;
var $48186ffb13ebb8e8$export$94c3e544fd062b7f;
var $48186ffb13ebb8e8$export$9f77e0932fb78f72;
var $48186ffb13ebb8e8$export$d865ce2836f5927f;
var $48186ffb13ebb8e8$export$95e62ad65da8b7d2;
var $48186ffb13ebb8e8$export$209139ff098c441a;
"use strict";
$48186ffb13ebb8e8$export$cfaef8ed399428b0 = function readUInt32BE(bytes, off) {
    var res = bytes[0 + off] << 24 | bytes[1 + off] << 16 | bytes[2 + off] << 8 | bytes[3 + off];
    return res >>> 0;
};
$48186ffb13ebb8e8$export$a80c7deaea7cbd80 = function writeUInt32BE(bytes, value, off) {
    bytes[0 + off] = value >>> 24;
    bytes[1 + off] = value >>> 16 & 0xff;
    bytes[2 + off] = value >>> 8 & 0xff;
    bytes[3 + off] = value & 0xff;
};
$48186ffb13ebb8e8$export$ed7577ae6e1cd0ef = function ip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >>> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >>> j + i & 1;
        }
    }
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inR >>> j + i & 1;
        }
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inL >>> j + i & 1;
        }
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$48186ffb13ebb8e8$export$5dcbef3aa594f567 = function rip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 0; i < 4; i++)for(var j = 24; j >= 0; j -= 8){
        outL <<= 1;
        outL |= inR >>> j + i & 1;
        outL <<= 1;
        outL |= inL >>> j + i & 1;
    }
    for(var i = 4; i < 8; i++)for(var j = 24; j >= 0; j -= 8){
        outR <<= 1;
        outR |= inR >>> j + i & 1;
        outR <<= 1;
        outR |= inL >>> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$48186ffb13ebb8e8$export$5bc8001ca71ed9c5 = function pc1(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    // 7, 15, 23, 31, 39, 47, 55, 63
    // 6, 14, 22, 30, 39, 47, 55, 63
    // 5, 13, 21, 29, 39, 47, 55, 63
    // 4, 12, 20, 28
    for(var i = 7; i >= 5; i--){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outL <<= 1;
        outL |= inR >> j + i & 1;
    }
    // 1, 9, 17, 25, 33, 41, 49, 57
    // 2, 10, 18, 26, 34, 42, 50, 58
    // 3, 11, 19, 27, 35, 43, 51, 59
    // 36, 44, 52, 60
    for(var i = 1; i <= 3; i++){
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outR <<= 1;
        outR |= inL >> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$48186ffb13ebb8e8$export$3e714e2c5d5d8cb2 = function r28shl(num, shift) {
    return num << shift & 0xfffffff | num >>> 28 - shift;
};
var $48186ffb13ebb8e8$var$pc2table = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
];
$48186ffb13ebb8e8$export$94c3e544fd062b7f = function pc2(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    var len = $48186ffb13ebb8e8$var$pc2table.length >>> 1;
    for(var i = 0; i < len; i++){
        outL <<= 1;
        outL |= inL >>> $48186ffb13ebb8e8$var$pc2table[i] & 0x1;
    }
    for(var i = len; i < $48186ffb13ebb8e8$var$pc2table.length; i++){
        outR <<= 1;
        outR |= inR >>> $48186ffb13ebb8e8$var$pc2table[i] & 0x1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$48186ffb13ebb8e8$export$9f77e0932fb78f72 = function expand(r, out, off) {
    var outL = 0;
    var outR = 0;
    outL = (r & 1) << 5 | r >>> 27;
    for(var i = 23; i >= 15; i -= 4){
        outL <<= 6;
        outL |= r >>> i & 0x3f;
    }
    for(var i = 11; i >= 3; i -= 4){
        outR |= r >>> i & 0x3f;
        outR <<= 6;
    }
    outR |= (r & 0x1f) << 1 | r >>> 31;
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
var $48186ffb13ebb8e8$var$sTable = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
];
$48186ffb13ebb8e8$export$d865ce2836f5927f = function substitute(inL, inR) {
    var out = 0;
    for(var i = 0; i < 4; i++){
        var b = inL >>> 18 - i * 6 & 0x3f;
        var sb = $48186ffb13ebb8e8$var$sTable[i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    for(var i = 0; i < 4; i++){
        var b = inR >>> 18 - i * 6 & 0x3f;
        var sb = $48186ffb13ebb8e8$var$sTable[256 + i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    return out >>> 0;
};
var $48186ffb13ebb8e8$var$permuteTable = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
];
$48186ffb13ebb8e8$export$95e62ad65da8b7d2 = function permute(num) {
    var out = 0;
    for(var i = 0; i < $48186ffb13ebb8e8$var$permuteTable.length; i++){
        out <<= 1;
        out |= num >>> $48186ffb13ebb8e8$var$permuteTable[i] & 0x1;
    }
    return out >>> 0;
};
$48186ffb13ebb8e8$export$209139ff098c441a = function padSplit(num, size, group) {
    var str = num.toString(2);
    while(str.length < size)str = "0" + str;
    var out = [];
    for(var i = 0; i < size; i += group)out.push(str.slice(i, i + group));
    return out.join(" ");
};

});

parcelRegister("juQQV", function(module, exports) {
"use strict";

var $7WVV2 = parcelRequire("7WVV2");
function $e319d11e93dea4cc$var$Cipher(options) {
    this.options = options;
    this.type = this.options.type;
    this.blockSize = 8;
    this._init();
    this.buffer = new Array(this.blockSize);
    this.bufferOff = 0;
    this.padding = options.padding !== false;
}
module.exports = $e319d11e93dea4cc$var$Cipher;
$e319d11e93dea4cc$var$Cipher.prototype._init = function _init() {
// Might be overrided
};
$e319d11e93dea4cc$var$Cipher.prototype.update = function update(data) {
    if (data.length === 0) return [];
    if (this.type === "decrypt") return this._updateDecrypt(data);
    else return this._updateEncrypt(data);
};
$e319d11e93dea4cc$var$Cipher.prototype._buffer = function _buffer(data, off) {
    // Append data to buffer
    var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
    for(var i = 0; i < min; i++)this.buffer[this.bufferOff + i] = data[off + i];
    this.bufferOff += min;
    // Shift next
    return min;
};
$e319d11e93dea4cc$var$Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
    this._update(this.buffer, 0, out, off);
    this.bufferOff = 0;
    return this.blockSize;
};
$e319d11e93dea4cc$var$Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = (this.bufferOff + data.length) / this.blockSize | 0;
    var out = new Array(count * this.blockSize);
    if (this.bufferOff !== 0) {
        inputOff += this._buffer(data, inputOff);
        if (this.bufferOff === this.buffer.length) outputOff += this._flushBuffer(out, outputOff);
    }
    // Write blocks
    var max = data.length - (data.length - inputOff) % this.blockSize;
    for(; inputOff < max; inputOff += this.blockSize){
        this._update(data, inputOff, out, outputOff);
        outputOff += this.blockSize;
    }
    // Queue rest
    for(; inputOff < data.length; inputOff++, this.bufferOff++)this.buffer[this.bufferOff] = data[inputOff];
    return out;
};
$e319d11e93dea4cc$var$Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
    var out = new Array(count * this.blockSize);
    // TODO(indutny): optimize it, this is far from optimal
    for(; count > 0; count--){
        inputOff += this._buffer(data, inputOff);
        outputOff += this._flushBuffer(out, outputOff);
    }
    // Buffer rest of the input
    inputOff += this._buffer(data, inputOff);
    return out;
};
$e319d11e93dea4cc$var$Cipher.prototype.final = function final(buffer) {
    var first;
    if (buffer) first = this.update(buffer);
    var last;
    if (this.type === "encrypt") last = this._finalEncrypt();
    else last = this._finalDecrypt();
    if (first) return first.concat(last);
    else return last;
};
$e319d11e93dea4cc$var$Cipher.prototype._pad = function _pad(buffer, off) {
    if (off === 0) return false;
    while(off < buffer.length)buffer[off++] = 0;
    return true;
};
$e319d11e93dea4cc$var$Cipher.prototype._finalEncrypt = function _finalEncrypt() {
    if (!this._pad(this.buffer, this.bufferOff)) return [];
    var out = new Array(this.blockSize);
    this._update(this.buffer, 0, out, 0);
    return out;
};
$e319d11e93dea4cc$var$Cipher.prototype._unpad = function _unpad(buffer) {
    return buffer;
};
$e319d11e93dea4cc$var$Cipher.prototype._finalDecrypt = function _finalDecrypt() {
    $7WVV2.equal(this.bufferOff, this.blockSize, "Not enough data to decrypt");
    var out = new Array(this.blockSize);
    this._flushBuffer(out, 0);
    return this._unpad(out);
};

});
parcelRegister("7WVV2", function(module, exports) {
module.exports = $5c9ae0b2a4247da8$var$assert;
function $5c9ae0b2a4247da8$var$assert(val, msg) {
    if (!val) throw new Error(msg || "Assertion failed");
}
$5c9ae0b2a4247da8$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || "Assertion failed: " + l + " != " + r);
};

});


parcelRegister("dNPGF", function(module, exports) {
"use strict";

var $7WVV2 = parcelRequire("7WVV2");

var $hwgCU = parcelRequire("hwgCU");

var $6bLgN = parcelRequire("6bLgN");

var $juQQV = parcelRequire("juQQV");
function $a0c7f1fcf61949cd$var$DESState() {
    this.tmp = new Array(2);
    this.keys = null;
}
function $a0c7f1fcf61949cd$var$DES(options) {
    $juQQV.call(this, options);
    var state = new $a0c7f1fcf61949cd$var$DESState();
    this._desState = state;
    this.deriveKeys(state, options.key);
}
$hwgCU($a0c7f1fcf61949cd$var$DES, $juQQV);
module.exports = $a0c7f1fcf61949cd$var$DES;
$a0c7f1fcf61949cd$var$DES.create = function create(options) {
    return new $a0c7f1fcf61949cd$var$DES(options);
};
var $a0c7f1fcf61949cd$var$shiftTable = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
];
$a0c7f1fcf61949cd$var$DES.prototype.deriveKeys = function deriveKeys(state, key) {
    state.keys = new Array(32);
    $7WVV2.equal(key.length, this.blockSize, "Invalid key length");
    var kL = $6bLgN.readUInt32BE(key, 0);
    var kR = $6bLgN.readUInt32BE(key, 4);
    $6bLgN.pc1(kL, kR, state.tmp, 0);
    kL = state.tmp[0];
    kR = state.tmp[1];
    for(var i = 0; i < state.keys.length; i += 2){
        var shift = $a0c7f1fcf61949cd$var$shiftTable[i >>> 1];
        kL = $6bLgN.r28shl(kL, shift);
        kR = $6bLgN.r28shl(kR, shift);
        $6bLgN.pc2(kL, kR, state.keys, i);
    }
};
$a0c7f1fcf61949cd$var$DES.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._desState;
    var l = $6bLgN.readUInt32BE(inp, inOff);
    var r = $6bLgN.readUInt32BE(inp, inOff + 4);
    // Initial Permutation
    $6bLgN.ip(l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    if (this.type === "encrypt") this._encrypt(state, l, r, state.tmp, 0);
    else this._decrypt(state, l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    $6bLgN.writeUInt32BE(out, l, outOff);
    $6bLgN.writeUInt32BE(out, r, outOff + 4);
};
$a0c7f1fcf61949cd$var$DES.prototype._pad = function _pad(buffer, off) {
    if (this.padding === false) return false;
    var value = buffer.length - off;
    for(var i = off; i < buffer.length; i++)buffer[i] = value;
    return true;
};
$a0c7f1fcf61949cd$var$DES.prototype._unpad = function _unpad(buffer) {
    if (this.padding === false) return buffer;
    var pad = buffer[buffer.length - 1];
    for(var i = buffer.length - pad; i < buffer.length; i++)$7WVV2.equal(buffer[i], pad);
    return buffer.slice(0, buffer.length - pad);
};
$a0c7f1fcf61949cd$var$DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
    var l = lStart;
    var r = rStart;
    // Apply f() x16 times
    for(var i = 0; i < state.keys.length; i += 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $6bLgN.expand(r, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $6bLgN.substitute(keyL, keyR);
        var f = $6bLgN.permute(s);
        var t = r;
        r = (l ^ f) >>> 0;
        l = t;
    }
    // Reverse Initial Permutation
    $6bLgN.rip(r, l, out, off);
};
$a0c7f1fcf61949cd$var$DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
    var l = rStart;
    var r = lStart;
    // Apply f() x16 times
    for(var i = state.keys.length - 2; i >= 0; i -= 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $6bLgN.expand(l, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $6bLgN.substitute(keyL, keyR);
        var f = $6bLgN.permute(s);
        var t = l;
        l = (r ^ f) >>> 0;
        r = t;
    }
    // Reverse Initial Permutation
    $6bLgN.rip(l, r, out, off);
};

});

parcelRegister("b8O1s", function(module, exports) {

$parcel$export(module.exports, "instantiate", function () { return $81c73e7a3a2c953d$export$f9bb8d20ccc7477a; }, function (v) { return $81c73e7a3a2c953d$export$f9bb8d20ccc7477a = v; });
var $81c73e7a3a2c953d$export$f9bb8d20ccc7477a;
"use strict";

var $7WVV2 = parcelRequire("7WVV2");

var $hwgCU = parcelRequire("hwgCU");
var $81c73e7a3a2c953d$var$proto = {};
function $81c73e7a3a2c953d$var$CBCState(iv) {
    $7WVV2.equal(iv.length, 8, "Invalid IV length");
    this.iv = new Array(8);
    for(var i = 0; i < this.iv.length; i++)this.iv[i] = iv[i];
}
function $81c73e7a3a2c953d$var$instantiate(Base) {
    function CBC(options) {
        Base.call(this, options);
        this._cbcInit();
    }
    $hwgCU(CBC, Base);
    var keys = Object.keys($81c73e7a3a2c953d$var$proto);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        CBC.prototype[key] = $81c73e7a3a2c953d$var$proto[key];
    }
    CBC.create = function create(options) {
        return new CBC(options);
    };
    return CBC;
}
$81c73e7a3a2c953d$export$f9bb8d20ccc7477a = $81c73e7a3a2c953d$var$instantiate;
$81c73e7a3a2c953d$var$proto._cbcInit = function _cbcInit() {
    var state = new $81c73e7a3a2c953d$var$CBCState(this.options.iv);
    this._cbcState = state;
};
$81c73e7a3a2c953d$var$proto._update = function _update(inp, inOff, out, outOff) {
    var state = this._cbcState;
    var superProto = this.constructor.super_.prototype;
    var iv = state.iv;
    if (this.type === "encrypt") {
        for(var i = 0; i < this.blockSize; i++)iv[i] ^= inp[inOff + i];
        superProto._update.call(this, iv, 0, out, outOff);
        for(var i = 0; i < this.blockSize; i++)iv[i] = out[outOff + i];
    } else {
        superProto._update.call(this, inp, inOff, out, outOff);
        for(var i = 0; i < this.blockSize; i++)out[outOff + i] ^= iv[i];
        for(var i = 0; i < this.blockSize; i++)iv[i] = inp[inOff + i];
    }
};

});

parcelRegister("5wR3a", function(module, exports) {
"use strict";

var $7WVV2 = parcelRequire("7WVV2");

var $hwgCU = parcelRequire("hwgCU");

var $juQQV = parcelRequire("juQQV");

var $dNPGF = parcelRequire("dNPGF");
function $4069178717548761$var$EDEState(type, key) {
    $7WVV2.equal(key.length, 24, "Invalid key length");
    var k1 = key.slice(0, 8);
    var k2 = key.slice(8, 16);
    var k3 = key.slice(16, 24);
    if (type === "encrypt") this.ciphers = [
        $dNPGF.create({
            type: "encrypt",
            key: k1
        }),
        $dNPGF.create({
            type: "decrypt",
            key: k2
        }),
        $dNPGF.create({
            type: "encrypt",
            key: k3
        })
    ];
    else this.ciphers = [
        $dNPGF.create({
            type: "decrypt",
            key: k3
        }),
        $dNPGF.create({
            type: "encrypt",
            key: k2
        }),
        $dNPGF.create({
            type: "decrypt",
            key: k1
        })
    ];
}
function $4069178717548761$var$EDE(options) {
    $juQQV.call(this, options);
    var state = new $4069178717548761$var$EDEState(this.type, this.options.key);
    this._edeState = state;
}
$hwgCU($4069178717548761$var$EDE, $juQQV);
module.exports = $4069178717548761$var$EDE;
$4069178717548761$var$EDE.create = function create(options) {
    return new $4069178717548761$var$EDE(options);
};
$4069178717548761$var$EDE.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._edeState;
    state.ciphers[0]._update(inp, inOff, out, outOff);
    state.ciphers[1]._update(out, outOff, out, outOff);
    state.ciphers[2]._update(out, outOff, out, outOff);
};
$4069178717548761$var$EDE.prototype._pad = $dNPGF.prototype._pad;
$4069178717548761$var$EDE.prototype._unpad = $dNPGF.prototype._unpad;

});



parcelRegister("aRQ6l", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", function () { return $7e9744d741c642a6$export$2f64596b8cbf08b4; }, function (v) { return $7e9744d741c642a6$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $7e9744d741c642a6$export$36b6d6ef312eab39; }, function (v) { return $7e9744d741c642a6$export$36b6d6ef312eab39 = v; });
$parcel$export(module.exports, "getCiphers", function () { return $7e9744d741c642a6$export$58a258485f1e49f6; }, function (v) { return $7e9744d741c642a6$export$58a258485f1e49f6 = v; });
var $7e9744d741c642a6$export$bdd223f16383713e;
var $7e9744d741c642a6$export$26e5786e8ac8e530;
var $7e9744d741c642a6$export$2f64596b8cbf08b4;
var $7e9744d741c642a6$export$20533d26f07f1ee0;
var $7e9744d741c642a6$export$12ada9414fbc594c;
var $7e9744d741c642a6$export$2ce6d8d0e8b04e1a;
var $7e9744d741c642a6$export$36b6d6ef312eab39;
var $7e9744d741c642a6$export$f5e7e39d57cd9700;
var $7e9744d741c642a6$export$dedd8dc3dc62b370;
var $7e9744d741c642a6$export$58a258485f1e49f6;

var $bD7KD = parcelRequire("bD7KD");

var $kBMSR = parcelRequire("kBMSR");

var $6ubVF = parcelRequire("6ubVF");
function $7e9744d741c642a6$var$getCiphers() {
    return Object.keys($6ubVF);
}
$7e9744d741c642a6$export$bdd223f16383713e = $7e9744d741c642a6$export$26e5786e8ac8e530 = $bD7KD.createCipher;
$7e9744d741c642a6$export$2f64596b8cbf08b4 = $7e9744d741c642a6$export$20533d26f07f1ee0 = $bD7KD.createCipheriv;
$7e9744d741c642a6$export$12ada9414fbc594c = $7e9744d741c642a6$export$2ce6d8d0e8b04e1a = $kBMSR.createDecipher;
$7e9744d741c642a6$export$36b6d6ef312eab39 = $7e9744d741c642a6$export$f5e7e39d57cd9700 = $kBMSR.createDecipheriv;
$7e9744d741c642a6$export$dedd8dc3dc62b370 = $7e9744d741c642a6$export$58a258485f1e49f6 = $7e9744d741c642a6$var$getCiphers;

});
parcelRegister("bD7KD", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", function () { return $8779597974504634$export$2f64596b8cbf08b4; }, function (v) { return $8779597974504634$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "createCipher", function () { return $8779597974504634$export$bdd223f16383713e; }, function (v) { return $8779597974504634$export$bdd223f16383713e = v; });
var $8779597974504634$export$2f64596b8cbf08b4;
var $8779597974504634$export$bdd223f16383713e;

var $6dfWh = parcelRequire("6dfWh");

var $eokB6 = parcelRequire("eokB6");

var $f6JDE = parcelRequire("f6JDE");
var $8779597974504634$require$Buffer = $f6JDE.Buffer;

var $kOVIY = parcelRequire("kOVIY");

var $3iWnY = parcelRequire("3iWnY");

var $i9Fg2 = parcelRequire("i9Fg2");

var $31WmI = parcelRequire("31WmI");

var $hwgCU = parcelRequire("hwgCU");
function $8779597974504634$var$Cipher(mode, key, iv) {
    $3iWnY.call(this);
    this._cache = new $8779597974504634$var$Splitter();
    this._cipher = new $i9Fg2.AES(key);
    this._prev = $8779597974504634$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$hwgCU($8779597974504634$var$Cipher, $3iWnY);
$8779597974504634$var$Cipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get()){
        thing = this._mode.encrypt(this, chunk);
        out.push(thing);
    }
    return $8779597974504634$require$Buffer.concat(out);
};
var $8779597974504634$var$PADDING = $8779597974504634$require$Buffer.alloc(16, 0x10);
$8779597974504634$var$Cipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) {
        chunk = this._mode.encrypt(this, chunk);
        this._cipher.scrub();
        return chunk;
    }
    if (!chunk.equals($8779597974504634$var$PADDING)) {
        this._cipher.scrub();
        throw new Error("data not multiple of block length");
    }
};
$8779597974504634$var$Cipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $8779597974504634$var$Splitter() {
    this.cache = $8779597974504634$require$Buffer.allocUnsafe(0);
}
$8779597974504634$var$Splitter.prototype.add = function(data) {
    this.cache = $8779597974504634$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$8779597974504634$var$Splitter.prototype.get = function() {
    if (this.cache.length > 15) {
        var out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$8779597974504634$var$Splitter.prototype.flush = function() {
    var len = 16 - this.cache.length;
    var padBuff = $8779597974504634$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)padBuff.writeUInt8(len, i);
    return $8779597974504634$require$Buffer.concat([
        this.cache,
        padBuff
    ]);
};
function $8779597974504634$var$createCipheriv(suite, password, iv) {
    var config = $6dfWh[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    if (typeof password === "string") password = $8779597974504634$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError("invalid key length " + password.length);
    if (typeof iv === "string") iv = $8779597974504634$require$Buffer.from(iv);
    if (config.mode !== "GCM" && iv.length !== config.iv) throw new TypeError("invalid iv length " + iv.length);
    if (config.type === "stream") return new $kOVIY(config.module, password, iv);
    else if (config.type === "auth") return new $eokB6(config.module, password, iv);
    return new $8779597974504634$var$Cipher(config.module, password, iv);
}
function $8779597974504634$var$createCipher(suite, password) {
    var config = $6dfWh[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    var keys = $31WmI(password, false, config.key, config.iv);
    return $8779597974504634$var$createCipheriv(suite, keys.key, keys.iv);
}
$8779597974504634$export$2f64596b8cbf08b4 = $8779597974504634$var$createCipheriv;
$8779597974504634$export$bdd223f16383713e = $8779597974504634$var$createCipher;

});
parcelRegister("6dfWh", function(module, exports) {








var $4860521d965d293f$var$modeModules = {
    ECB: (parcelRequire("ftHGP")),
    CBC: (parcelRequire("5ObuI")),
    CFB: (parcelRequire("oyF32")),
    CFB8: (parcelRequire("iQkgX")),
    CFB1: (parcelRequire("3FLMo")),
    OFB: (parcelRequire("bRl7C")),
    CTR: (parcelRequire("8cWkk")),
    GCM: (parcelRequire("8cWkk"))
};

var $6ubVF = parcelRequire("6ubVF");
for(var $4860521d965d293f$var$key in $6ubVF)$6ubVF[$4860521d965d293f$var$key].module = $4860521d965d293f$var$modeModules[$6ubVF[$4860521d965d293f$var$key].mode];
module.exports = $6ubVF;

});
parcelRegister("ftHGP", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $b44b7452698721c4$export$5b0f6292f11d1d18; }, function (v) { return $b44b7452698721c4$export$5b0f6292f11d1d18 = v; });
$parcel$export(module.exports, "decrypt", function () { return $b44b7452698721c4$export$e85a0c9a1067c5d3; }, function (v) { return $b44b7452698721c4$export$e85a0c9a1067c5d3 = v; });
var $b44b7452698721c4$export$5b0f6292f11d1d18;
var $b44b7452698721c4$export$e85a0c9a1067c5d3;
$b44b7452698721c4$export$5b0f6292f11d1d18 = function(self, block) {
    return self._cipher.encryptBlock(block);
};
$b44b7452698721c4$export$e85a0c9a1067c5d3 = function(self, block) {
    return self._cipher.decryptBlock(block);
};

});

parcelRegister("5ObuI", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $43aa89cdaa95f0fc$export$5b0f6292f11d1d18; }, function (v) { return $43aa89cdaa95f0fc$export$5b0f6292f11d1d18 = v; });
$parcel$export(module.exports, "decrypt", function () { return $43aa89cdaa95f0fc$export$e85a0c9a1067c5d3; }, function (v) { return $43aa89cdaa95f0fc$export$e85a0c9a1067c5d3 = v; });
var $43aa89cdaa95f0fc$export$5b0f6292f11d1d18;
var $43aa89cdaa95f0fc$export$e85a0c9a1067c5d3;

var $dXVYi = parcelRequire("dXVYi");
$43aa89cdaa95f0fc$export$5b0f6292f11d1d18 = function(self, block) {
    var data = $dXVYi(block, self._prev);
    self._prev = self._cipher.encryptBlock(data);
    return self._prev;
};
$43aa89cdaa95f0fc$export$e85a0c9a1067c5d3 = function(self, block) {
    var pad = self._prev;
    self._prev = block;
    var out = self._cipher.decryptBlock(block);
    return $dXVYi(out, pad);
};

});
parcelRegister("dXVYi", function(module, exports) {

var $8dlmd = parcelRequire("8dlmd");
var $a2adc0f95f922690$require$Buffer = $8dlmd.Buffer;
module.exports = function xor(a, b) {
    var length = Math.min(a.length, b.length);
    var buffer = new $a2adc0f95f922690$require$Buffer(length);
    for(var i = 0; i < length; ++i)buffer[i] = a[i] ^ b[i];
    return buffer;
};

});


parcelRegister("oyF32", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $049d20f883445e46$export$5b0f6292f11d1d18; }, function (v) { return $049d20f883445e46$export$5b0f6292f11d1d18 = v; });
var $049d20f883445e46$export$5b0f6292f11d1d18;

var $f6JDE = parcelRequire("f6JDE");
var $049d20f883445e46$require$Buffer = $f6JDE.Buffer;

var $dXVYi = parcelRequire("dXVYi");
function $049d20f883445e46$var$encryptStart(self, data, decrypt) {
    var len = data.length;
    var out = $dXVYi(data, self._cache);
    self._cache = self._cache.slice(len);
    self._prev = $049d20f883445e46$require$Buffer.concat([
        self._prev,
        decrypt ? data : out
    ]);
    return out;
}
$049d20f883445e46$export$5b0f6292f11d1d18 = function(self, data, decrypt) {
    var out = $049d20f883445e46$require$Buffer.allocUnsafe(0);
    var len;
    while(data.length){
        if (self._cache.length === 0) {
            self._cache = self._cipher.encryptBlock(self._prev);
            self._prev = $049d20f883445e46$require$Buffer.allocUnsafe(0);
        }
        if (self._cache.length <= data.length) {
            len = self._cache.length;
            out = $049d20f883445e46$require$Buffer.concat([
                out,
                $049d20f883445e46$var$encryptStart(self, data.slice(0, len), decrypt)
            ]);
            data = data.slice(len);
        } else {
            out = $049d20f883445e46$require$Buffer.concat([
                out,
                $049d20f883445e46$var$encryptStart(self, data, decrypt)
            ]);
            break;
        }
    }
    return out;
};

});

parcelRegister("iQkgX", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $db7ccf0b8e84af35$export$5b0f6292f11d1d18; }, function (v) { return $db7ccf0b8e84af35$export$5b0f6292f11d1d18 = v; });
var $db7ccf0b8e84af35$export$5b0f6292f11d1d18;

var $f6JDE = parcelRequire("f6JDE");
var $db7ccf0b8e84af35$require$Buffer = $f6JDE.Buffer;
function $db7ccf0b8e84af35$var$encryptByte(self, byteParam, decrypt) {
    var pad = self._cipher.encryptBlock(self._prev);
    var out = pad[0] ^ byteParam;
    self._prev = $db7ccf0b8e84af35$require$Buffer.concat([
        self._prev.slice(1),
        $db7ccf0b8e84af35$require$Buffer.from([
            decrypt ? byteParam : out
        ])
    ]);
    return out;
}
$db7ccf0b8e84af35$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $db7ccf0b8e84af35$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $db7ccf0b8e84af35$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("3FLMo", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $2aca4377a7f8174a$export$5b0f6292f11d1d18; }, function (v) { return $2aca4377a7f8174a$export$5b0f6292f11d1d18 = v; });
var $2aca4377a7f8174a$export$5b0f6292f11d1d18;

var $f6JDE = parcelRequire("f6JDE");
var $2aca4377a7f8174a$require$Buffer = $f6JDE.Buffer;
function $2aca4377a7f8174a$var$encryptByte(self, byteParam, decrypt) {
    var pad;
    var i = -1;
    var len = 8;
    var out = 0;
    var bit, value;
    while(++i < len){
        pad = self._cipher.encryptBlock(self._prev);
        bit = byteParam & 1 << 7 - i ? 0x80 : 0;
        value = pad[0] ^ bit;
        out += (value & 0x80) >> i % 8;
        self._prev = $2aca4377a7f8174a$var$shiftIn(self._prev, decrypt ? bit : value);
    }
    return out;
}
function $2aca4377a7f8174a$var$shiftIn(buffer, value) {
    var len = buffer.length;
    var i = -1;
    var out = $2aca4377a7f8174a$require$Buffer.allocUnsafe(buffer.length);
    buffer = $2aca4377a7f8174a$require$Buffer.concat([
        buffer,
        $2aca4377a7f8174a$require$Buffer.from([
            value
        ])
    ]);
    while(++i < len)out[i] = buffer[i] << 1 | buffer[i + 1] >> 7;
    return out;
}
$2aca4377a7f8174a$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $2aca4377a7f8174a$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $2aca4377a7f8174a$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("bRl7C", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $8a250750c65788ce$export$5b0f6292f11d1d18; }, function (v) { return $8a250750c65788ce$export$5b0f6292f11d1d18 = v; });
var $8a250750c65788ce$export$5b0f6292f11d1d18;

var $8dlmd = parcelRequire("8dlmd");
var $8a250750c65788ce$require$Buffer = $8dlmd.Buffer;

var $dXVYi = parcelRequire("dXVYi");
function $8a250750c65788ce$var$getBlock(self) {
    self._prev = self._cipher.encryptBlock(self._prev);
    return self._prev;
}
$8a250750c65788ce$export$5b0f6292f11d1d18 = function(self, chunk) {
    while(self._cache.length < chunk.length)self._cache = $8a250750c65788ce$require$Buffer.concat([
        self._cache,
        $8a250750c65788ce$var$getBlock(self)
    ]);
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $dXVYi(chunk, pad);
};

});

parcelRegister("8cWkk", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $5f9cb03e5e5c45e2$export$5b0f6292f11d1d18; }, function (v) { return $5f9cb03e5e5c45e2$export$5b0f6292f11d1d18 = v; });
var $5f9cb03e5e5c45e2$export$5b0f6292f11d1d18;

var $dXVYi = parcelRequire("dXVYi");

var $f6JDE = parcelRequire("f6JDE");
var $5f9cb03e5e5c45e2$require$Buffer = $f6JDE.Buffer;

var $bOxjL = parcelRequire("bOxjL");
function $5f9cb03e5e5c45e2$var$getBlock(self) {
    var out = self._cipher.encryptBlockRaw(self._prev);
    $bOxjL(self._prev);
    return out;
}
var $5f9cb03e5e5c45e2$var$blockSize = 16;
$5f9cb03e5e5c45e2$export$5b0f6292f11d1d18 = function(self, chunk) {
    var chunkNum = Math.ceil(chunk.length / $5f9cb03e5e5c45e2$var$blockSize);
    var start = self._cache.length;
    self._cache = $5f9cb03e5e5c45e2$require$Buffer.concat([
        self._cache,
        $5f9cb03e5e5c45e2$require$Buffer.allocUnsafe(chunkNum * $5f9cb03e5e5c45e2$var$blockSize)
    ]);
    for(var i = 0; i < chunkNum; i++){
        var out = $5f9cb03e5e5c45e2$var$getBlock(self);
        var offset = start + i * $5f9cb03e5e5c45e2$var$blockSize;
        self._cache.writeUInt32BE(out[0], offset + 0);
        self._cache.writeUInt32BE(out[1], offset + 4);
        self._cache.writeUInt32BE(out[2], offset + 8);
        self._cache.writeUInt32BE(out[3], offset + 12);
    }
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $dXVYi(chunk, pad);
};

});
parcelRegister("bOxjL", function(module, exports) {
function $899e3574d5653873$var$incr32(iv) {
    var len = iv.length;
    var item;
    while(len--){
        item = iv.readUInt8(len);
        if (item === 255) iv.writeUInt8(0, len);
        else {
            item++;
            iv.writeUInt8(item, len);
            break;
        }
    }
}
module.exports = $899e3574d5653873$var$incr32;

});


parcelRegister("6ubVF", function(module, exports) {
module.exports = JSON.parse('{"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}');

});


parcelRegister("eokB6", function(module, exports) {

var $i9Fg2 = parcelRequire("i9Fg2");

var $f6JDE = parcelRequire("f6JDE");
var $a7a348cfaae5a7f4$require$Buffer = $f6JDE.Buffer;

var $3iWnY = parcelRequire("3iWnY");

var $hwgCU = parcelRequire("hwgCU");

var $bgRuK = parcelRequire("bgRuK");

var $dXVYi = parcelRequire("dXVYi");

var $bOxjL = parcelRequire("bOxjL");
function $a7a348cfaae5a7f4$var$xorTest(a, b) {
    var out = 0;
    if (a.length !== b.length) out++;
    var len = Math.min(a.length, b.length);
    for(var i = 0; i < len; ++i)out += a[i] ^ b[i];
    return out;
}
function $a7a348cfaae5a7f4$var$calcIv(self, iv, ck) {
    if (iv.length === 12) {
        self._finID = $a7a348cfaae5a7f4$require$Buffer.concat([
            iv,
            $a7a348cfaae5a7f4$require$Buffer.from([
                0,
                0,
                0,
                1
            ])
        ]);
        return $a7a348cfaae5a7f4$require$Buffer.concat([
            iv,
            $a7a348cfaae5a7f4$require$Buffer.from([
                0,
                0,
                0,
                2
            ])
        ]);
    }
    var ghash = new $bgRuK(ck);
    var len = iv.length;
    var toPad = len % 16;
    ghash.update(iv);
    if (toPad) {
        toPad = 16 - toPad;
        ghash.update($a7a348cfaae5a7f4$require$Buffer.alloc(toPad, 0));
    }
    ghash.update($a7a348cfaae5a7f4$require$Buffer.alloc(8, 0));
    var ivBits = len * 8;
    var tail = $a7a348cfaae5a7f4$require$Buffer.alloc(8);
    tail.writeUIntBE(ivBits, 0, 8);
    ghash.update(tail);
    self._finID = ghash.state;
    var out = $a7a348cfaae5a7f4$require$Buffer.from(self._finID);
    $bOxjL(out);
    return out;
}
function $a7a348cfaae5a7f4$var$StreamCipher(mode, key, iv, decrypt) {
    $3iWnY.call(this);
    var h = $a7a348cfaae5a7f4$require$Buffer.alloc(4, 0);
    this._cipher = new $i9Fg2.AES(key);
    var ck = this._cipher.encryptBlock(h);
    this._ghash = new $bgRuK(ck);
    iv = $a7a348cfaae5a7f4$var$calcIv(this, iv, ck);
    this._prev = $a7a348cfaae5a7f4$require$Buffer.from(iv);
    this._cache = $a7a348cfaae5a7f4$require$Buffer.allocUnsafe(0);
    this._secCache = $a7a348cfaae5a7f4$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._alen = 0;
    this._len = 0;
    this._mode = mode;
    this._authTag = null;
    this._called = false;
}
$hwgCU($a7a348cfaae5a7f4$var$StreamCipher, $3iWnY);
$a7a348cfaae5a7f4$var$StreamCipher.prototype._update = function(chunk) {
    if (!this._called && this._alen) {
        var rump = 16 - this._alen % 16;
        if (rump < 16) {
            rump = $a7a348cfaae5a7f4$require$Buffer.alloc(rump, 0);
            this._ghash.update(rump);
        }
    }
    this._called = true;
    var out = this._mode.encrypt(this, chunk);
    if (this._decrypt) this._ghash.update(chunk);
    else this._ghash.update(out);
    this._len += chunk.length;
    return out;
};
$a7a348cfaae5a7f4$var$StreamCipher.prototype._final = function() {
    if (this._decrypt && !this._authTag) throw new Error("Unsupported state or unable to authenticate data");
    var tag = $dXVYi(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && $a7a348cfaae5a7f4$var$xorTest(tag, this._authTag)) throw new Error("Unsupported state or unable to authenticate data");
    this._authTag = tag;
    this._cipher.scrub();
};
$a7a348cfaae5a7f4$var$StreamCipher.prototype.getAuthTag = function getAuthTag() {
    if (this._decrypt || !$a7a348cfaae5a7f4$require$Buffer.isBuffer(this._authTag)) throw new Error("Attempting to get auth tag in unsupported state");
    return this._authTag;
};
$a7a348cfaae5a7f4$var$StreamCipher.prototype.setAuthTag = function setAuthTag(tag) {
    if (!this._decrypt) throw new Error("Attempting to set auth tag in unsupported state");
    this._authTag = tag;
};
$a7a348cfaae5a7f4$var$StreamCipher.prototype.setAAD = function setAAD(buf) {
    if (this._called) throw new Error("Attempting to set AAD in unsupported state");
    this._ghash.update(buf);
    this._alen += buf.length;
};
module.exports = $a7a348cfaae5a7f4$var$StreamCipher;

});
parcelRegister("i9Fg2", function(module, exports) {

$parcel$export(module.exports, "AES", function () { return $d379122c64699d99$export$b80fbe1c3a2b92b5; }, function (v) { return $d379122c64699d99$export$b80fbe1c3a2b92b5 = v; });
// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/
var $d379122c64699d99$export$b80fbe1c3a2b92b5;

var $f6JDE = parcelRequire("f6JDE");
var $d379122c64699d99$require$Buffer = $f6JDE.Buffer;
function $d379122c64699d99$var$asUInt32Array(buf) {
    if (!$d379122c64699d99$require$Buffer.isBuffer(buf)) buf = $d379122c64699d99$require$Buffer.from(buf);
    var len = buf.length / 4 | 0;
    var out = new Array(len);
    for(var i = 0; i < len; i++)out[i] = buf.readUInt32BE(i * 4);
    return out;
}
function $d379122c64699d99$var$scrubVec(v) {
    for(var i = 0; i < v.length; v++)v[i] = 0;
}
function $d379122c64699d99$var$cryptBlock(M, keySchedule, SUB_MIX, SBOX, nRounds) {
    var SUB_MIX0 = SUB_MIX[0];
    var SUB_MIX1 = SUB_MIX[1];
    var SUB_MIX2 = SUB_MIX[2];
    var SUB_MIX3 = SUB_MIX[3];
    var s0 = M[0] ^ keySchedule[0];
    var s1 = M[1] ^ keySchedule[1];
    var s2 = M[2] ^ keySchedule[2];
    var s3 = M[3] ^ keySchedule[3];
    var t0, t1, t2, t3;
    var ksRow = 4;
    for(var round = 1; round < nRounds; round++){
        t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[s1 >>> 16 & 0xff] ^ SUB_MIX2[s2 >>> 8 & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++];
        t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[s2 >>> 16 & 0xff] ^ SUB_MIX2[s3 >>> 8 & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++];
        t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[s3 >>> 16 & 0xff] ^ SUB_MIX2[s0 >>> 8 & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++];
        t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[s0 >>> 16 & 0xff] ^ SUB_MIX2[s1 >>> 8 & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++];
        s0 = t0;
        s1 = t1;
        s2 = t2;
        s3 = t3;
    }
    t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
    t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
    t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
    t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
    t0 = t0 >>> 0;
    t1 = t1 >>> 0;
    t2 = t2 >>> 0;
    t3 = t3 >>> 0;
    return [
        t0,
        t1,
        t2,
        t3
    ];
}
// AES constants
var $d379122c64699d99$var$RCON = [
    0x00,
    0x01,
    0x02,
    0x04,
    0x08,
    0x10,
    0x20,
    0x40,
    0x80,
    0x1b,
    0x36
];
var $d379122c64699d99$var$G = function() {
    // Compute double table
    var d = new Array(256);
    for(var j = 0; j < 256; j++)if (j < 128) d[j] = j << 1;
    else d[j] = j << 1 ^ 0x11b;
    var SBOX = [];
    var INV_SBOX = [];
    var SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    var INV_SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    // Walk GF(2^8)
    var x = 0;
    var xi = 0;
    for(var i = 0; i < 256; ++i){
        // Compute sbox
        var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
        sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
        SBOX[x] = sx;
        INV_SBOX[sx] = x;
        // Compute multiplication
        var x2 = d[x];
        var x4 = d[x2];
        var x8 = d[x4];
        // Compute sub bytes, mix columns tables
        var t = d[sx] * 0x101 ^ sx * 0x1010100;
        SUB_MIX[0][x] = t << 24 | t >>> 8;
        SUB_MIX[1][x] = t << 16 | t >>> 16;
        SUB_MIX[2][x] = t << 8 | t >>> 24;
        SUB_MIX[3][x] = t;
        // Compute inv sub bytes, inv mix columns tables
        t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
        INV_SUB_MIX[0][sx] = t << 24 | t >>> 8;
        INV_SUB_MIX[1][sx] = t << 16 | t >>> 16;
        INV_SUB_MIX[2][sx] = t << 8 | t >>> 24;
        INV_SUB_MIX[3][sx] = t;
        if (x === 0) x = xi = 1;
        else {
            x = x2 ^ d[d[d[x8 ^ x2]]];
            xi ^= d[d[xi]];
        }
    }
    return {
        SBOX: SBOX,
        INV_SBOX: INV_SBOX,
        SUB_MIX: SUB_MIX,
        INV_SUB_MIX: INV_SUB_MIX
    };
}();
function $d379122c64699d99$var$AES(key) {
    this._key = $d379122c64699d99$var$asUInt32Array(key);
    this._reset();
}
$d379122c64699d99$var$AES.blockSize = 16;
$d379122c64699d99$var$AES.keySize = 32;
$d379122c64699d99$var$AES.prototype.blockSize = $d379122c64699d99$var$AES.blockSize;
$d379122c64699d99$var$AES.prototype.keySize = $d379122c64699d99$var$AES.keySize;
$d379122c64699d99$var$AES.prototype._reset = function() {
    var keyWords = this._key;
    var keySize = keyWords.length;
    var nRounds = keySize + 6;
    var ksRows = (nRounds + 1) * 4;
    var keySchedule = [];
    for(var k = 0; k < keySize; k++)keySchedule[k] = keyWords[k];
    for(k = keySize; k < ksRows; k++){
        var t = keySchedule[k - 1];
        if (k % keySize === 0) {
            t = t << 8 | t >>> 24;
            t = $d379122c64699d99$var$G.SBOX[t >>> 24] << 24 | $d379122c64699d99$var$G.SBOX[t >>> 16 & 0xff] << 16 | $d379122c64699d99$var$G.SBOX[t >>> 8 & 0xff] << 8 | $d379122c64699d99$var$G.SBOX[t & 0xff];
            t ^= $d379122c64699d99$var$RCON[k / keySize | 0] << 24;
        } else if (keySize > 6 && k % keySize === 4) t = $d379122c64699d99$var$G.SBOX[t >>> 24] << 24 | $d379122c64699d99$var$G.SBOX[t >>> 16 & 0xff] << 16 | $d379122c64699d99$var$G.SBOX[t >>> 8 & 0xff] << 8 | $d379122c64699d99$var$G.SBOX[t & 0xff];
        keySchedule[k] = keySchedule[k - keySize] ^ t;
    }
    var invKeySchedule = [];
    for(var ik = 0; ik < ksRows; ik++){
        var ksR = ksRows - ik;
        var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)];
        if (ik < 4 || ksR <= 4) invKeySchedule[ik] = tt;
        else invKeySchedule[ik] = $d379122c64699d99$var$G.INV_SUB_MIX[0][$d379122c64699d99$var$G.SBOX[tt >>> 24]] ^ $d379122c64699d99$var$G.INV_SUB_MIX[1][$d379122c64699d99$var$G.SBOX[tt >>> 16 & 0xff]] ^ $d379122c64699d99$var$G.INV_SUB_MIX[2][$d379122c64699d99$var$G.SBOX[tt >>> 8 & 0xff]] ^ $d379122c64699d99$var$G.INV_SUB_MIX[3][$d379122c64699d99$var$G.SBOX[tt & 0xff]];
    }
    this._nRounds = nRounds;
    this._keySchedule = keySchedule;
    this._invKeySchedule = invKeySchedule;
};
$d379122c64699d99$var$AES.prototype.encryptBlockRaw = function(M) {
    M = $d379122c64699d99$var$asUInt32Array(M);
    return $d379122c64699d99$var$cryptBlock(M, this._keySchedule, $d379122c64699d99$var$G.SUB_MIX, $d379122c64699d99$var$G.SBOX, this._nRounds);
};
$d379122c64699d99$var$AES.prototype.encryptBlock = function(M) {
    var out = this.encryptBlockRaw(M);
    var buf = $d379122c64699d99$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[1], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[3], 12);
    return buf;
};
$d379122c64699d99$var$AES.prototype.decryptBlock = function(M) {
    M = $d379122c64699d99$var$asUInt32Array(M);
    // swap
    var m1 = M[1];
    M[1] = M[3];
    M[3] = m1;
    var out = $d379122c64699d99$var$cryptBlock(M, this._invKeySchedule, $d379122c64699d99$var$G.INV_SUB_MIX, $d379122c64699d99$var$G.INV_SBOX, this._nRounds);
    var buf = $d379122c64699d99$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[3], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[1], 12);
    return buf;
};
$d379122c64699d99$var$AES.prototype.scrub = function() {
    $d379122c64699d99$var$scrubVec(this._keySchedule);
    $d379122c64699d99$var$scrubVec(this._invKeySchedule);
    $d379122c64699d99$var$scrubVec(this._key);
};
$d379122c64699d99$export$b80fbe1c3a2b92b5 = $d379122c64699d99$var$AES;

});

parcelRegister("bgRuK", function(module, exports) {

var $f6JDE = parcelRequire("f6JDE");
var $834aaf522be4bf6d$require$Buffer = $f6JDE.Buffer;
var $834aaf522be4bf6d$var$ZEROES = $834aaf522be4bf6d$require$Buffer.alloc(16, 0);
function $834aaf522be4bf6d$var$toArray(buf) {
    return [
        buf.readUInt32BE(0),
        buf.readUInt32BE(4),
        buf.readUInt32BE(8),
        buf.readUInt32BE(12)
    ];
}
function $834aaf522be4bf6d$var$fromArray(out) {
    var buf = $834aaf522be4bf6d$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0] >>> 0, 0);
    buf.writeUInt32BE(out[1] >>> 0, 4);
    buf.writeUInt32BE(out[2] >>> 0, 8);
    buf.writeUInt32BE(out[3] >>> 0, 12);
    return buf;
}
function $834aaf522be4bf6d$var$GHASH(key) {
    this.h = key;
    this.state = $834aaf522be4bf6d$require$Buffer.alloc(16, 0);
    this.cache = $834aaf522be4bf6d$require$Buffer.allocUnsafe(0);
}
// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
$834aaf522be4bf6d$var$GHASH.prototype.ghash = function(block) {
    var i = -1;
    while(++i < block.length)this.state[i] ^= block[i];
    this._multiply();
};
$834aaf522be4bf6d$var$GHASH.prototype._multiply = function() {
    var Vi = $834aaf522be4bf6d$var$toArray(this.h);
    var Zi = [
        0,
        0,
        0,
        0
    ];
    var j, xi, lsbVi;
    var i = -1;
    while(++i < 128){
        xi = (this.state[~~(i / 8)] & 1 << 7 - i % 8) !== 0;
        if (xi) {
            // Z_i+1 = Z_i ^ V_i
            Zi[0] ^= Vi[0];
            Zi[1] ^= Vi[1];
            Zi[2] ^= Vi[2];
            Zi[3] ^= Vi[3];
        }
        // Store the value of LSB(V_i)
        lsbVi = (Vi[3] & 1) !== 0;
        // V_i+1 = V_i >> 1
        for(j = 3; j > 0; j--)Vi[j] = Vi[j] >>> 1 | (Vi[j - 1] & 1) << 31;
        Vi[0] = Vi[0] >>> 1;
        // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
        if (lsbVi) Vi[0] = Vi[0] ^ -520093696;
    }
    this.state = $834aaf522be4bf6d$var$fromArray(Zi);
};
$834aaf522be4bf6d$var$GHASH.prototype.update = function(buf) {
    this.cache = $834aaf522be4bf6d$require$Buffer.concat([
        this.cache,
        buf
    ]);
    var chunk;
    while(this.cache.length >= 16){
        chunk = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        this.ghash(chunk);
    }
};
$834aaf522be4bf6d$var$GHASH.prototype.final = function(abl, bl) {
    if (this.cache.length) this.ghash($834aaf522be4bf6d$require$Buffer.concat([
        this.cache,
        $834aaf522be4bf6d$var$ZEROES
    ], 16));
    this.ghash($834aaf522be4bf6d$var$fromArray([
        0,
        abl,
        0,
        bl
    ]));
    return this.state;
};
module.exports = $834aaf522be4bf6d$var$GHASH;

});


parcelRegister("kOVIY", function(module, exports) {

var $i9Fg2 = parcelRequire("i9Fg2");

var $f6JDE = parcelRequire("f6JDE");
var $f285410a711af4a7$require$Buffer = $f6JDE.Buffer;

var $3iWnY = parcelRequire("3iWnY");

var $hwgCU = parcelRequire("hwgCU");
function $f285410a711af4a7$var$StreamCipher(mode, key, iv, decrypt) {
    $3iWnY.call(this);
    this._cipher = new $i9Fg2.AES(key);
    this._prev = $f285410a711af4a7$require$Buffer.from(iv);
    this._cache = $f285410a711af4a7$require$Buffer.allocUnsafe(0);
    this._secCache = $f285410a711af4a7$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._mode = mode;
}
$hwgCU($f285410a711af4a7$var$StreamCipher, $3iWnY);
$f285410a711af4a7$var$StreamCipher.prototype._update = function(chunk) {
    return this._mode.encrypt(this, chunk, this._decrypt);
};
$f285410a711af4a7$var$StreamCipher.prototype._final = function() {
    this._cipher.scrub();
};
module.exports = $f285410a711af4a7$var$StreamCipher;

});

parcelRegister("31WmI", function(module, exports) {

var $f6JDE = parcelRequire("f6JDE");
var $234ebd4239d2b3c9$require$Buffer = $f6JDE.Buffer;

var $d6CkU = parcelRequire("d6CkU");
/* eslint-disable camelcase */ function $234ebd4239d2b3c9$var$EVP_BytesToKey(password, salt, keyBits, ivLen) {
    if (!$234ebd4239d2b3c9$require$Buffer.isBuffer(password)) password = $234ebd4239d2b3c9$require$Buffer.from(password, "binary");
    if (salt) {
        if (!$234ebd4239d2b3c9$require$Buffer.isBuffer(salt)) salt = $234ebd4239d2b3c9$require$Buffer.from(salt, "binary");
        if (salt.length !== 8) throw new RangeError("salt should be Buffer with 8 byte length");
    }
    var keyLen = keyBits / 8;
    var key = $234ebd4239d2b3c9$require$Buffer.alloc(keyLen);
    var iv = $234ebd4239d2b3c9$require$Buffer.alloc(ivLen || 0);
    var tmp = $234ebd4239d2b3c9$require$Buffer.alloc(0);
    while(keyLen > 0 || ivLen > 0){
        var hash = new $d6CkU();
        hash.update(tmp);
        hash.update(password);
        if (salt) hash.update(salt);
        tmp = hash.digest();
        var used = 0;
        if (keyLen > 0) {
            var keyStart = key.length - keyLen;
            used = Math.min(keyLen, tmp.length);
            tmp.copy(key, keyStart, 0, used);
            keyLen -= used;
        }
        if (used < tmp.length && ivLen > 0) {
            var ivStart = iv.length - ivLen;
            var length = Math.min(ivLen, tmp.length - used);
            tmp.copy(iv, ivStart, used, used + length);
            ivLen -= length;
        }
    }
    tmp.fill(0);
    return {
        key: key,
        iv: iv
    };
}
module.exports = $234ebd4239d2b3c9$var$EVP_BytesToKey;

});


parcelRegister("kBMSR", function(module, exports) {

$parcel$export(module.exports, "createDecipher", function () { return $f00d2eacbbd88b87$export$12ada9414fbc594c; }, function (v) { return $f00d2eacbbd88b87$export$12ada9414fbc594c = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $f00d2eacbbd88b87$export$36b6d6ef312eab39; }, function (v) { return $f00d2eacbbd88b87$export$36b6d6ef312eab39 = v; });
var $f00d2eacbbd88b87$export$12ada9414fbc594c;
var $f00d2eacbbd88b87$export$36b6d6ef312eab39;

var $eokB6 = parcelRequire("eokB6");

var $f6JDE = parcelRequire("f6JDE");
var $f00d2eacbbd88b87$require$Buffer = $f6JDE.Buffer;

var $6dfWh = parcelRequire("6dfWh");

var $kOVIY = parcelRequire("kOVIY");

var $3iWnY = parcelRequire("3iWnY");

var $i9Fg2 = parcelRequire("i9Fg2");

var $31WmI = parcelRequire("31WmI");

var $hwgCU = parcelRequire("hwgCU");
function $f00d2eacbbd88b87$var$Decipher(mode, key, iv) {
    $3iWnY.call(this);
    this._cache = new $f00d2eacbbd88b87$var$Splitter();
    this._last = void 0;
    this._cipher = new $i9Fg2.AES(key);
    this._prev = $f00d2eacbbd88b87$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$hwgCU($f00d2eacbbd88b87$var$Decipher, $3iWnY);
$f00d2eacbbd88b87$var$Decipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get(this._autopadding)){
        thing = this._mode.decrypt(this, chunk);
        out.push(thing);
    }
    return $f00d2eacbbd88b87$require$Buffer.concat(out);
};
$f00d2eacbbd88b87$var$Decipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) return $f00d2eacbbd88b87$var$unpad(this._mode.decrypt(this, chunk));
    else if (chunk) throw new Error("data not multiple of block length");
};
$f00d2eacbbd88b87$var$Decipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $f00d2eacbbd88b87$var$Splitter() {
    this.cache = $f00d2eacbbd88b87$require$Buffer.allocUnsafe(0);
}
$f00d2eacbbd88b87$var$Splitter.prototype.add = function(data) {
    this.cache = $f00d2eacbbd88b87$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$f00d2eacbbd88b87$var$Splitter.prototype.get = function(autoPadding) {
    var out;
    if (autoPadding) {
        if (this.cache.length > 16) {
            out = this.cache.slice(0, 16);
            this.cache = this.cache.slice(16);
            return out;
        }
    } else if (this.cache.length >= 16) {
        out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$f00d2eacbbd88b87$var$Splitter.prototype.flush = function() {
    if (this.cache.length) return this.cache;
};
function $f00d2eacbbd88b87$var$unpad(last) {
    var padded = last[15];
    if (padded < 1 || padded > 16) throw new Error("unable to decrypt data");
    var i = -1;
    while(++i < padded){
        if (last[i + (16 - padded)] !== padded) throw new Error("unable to decrypt data");
    }
    if (padded === 16) return;
    return last.slice(0, 16 - padded);
}
function $f00d2eacbbd88b87$var$createDecipheriv(suite, password, iv) {
    var config = $6dfWh[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    if (typeof iv === "string") iv = $f00d2eacbbd88b87$require$Buffer.from(iv);
    if (config.mode !== "GCM" && iv.length !== config.iv) throw new TypeError("invalid iv length " + iv.length);
    if (typeof password === "string") password = $f00d2eacbbd88b87$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError("invalid key length " + password.length);
    if (config.type === "stream") return new $kOVIY(config.module, password, iv, true);
    else if (config.type === "auth") return new $eokB6(config.module, password, iv, true);
    return new $f00d2eacbbd88b87$var$Decipher(config.module, password, iv);
}
function $f00d2eacbbd88b87$var$createDecipher(suite, password) {
    var config = $6dfWh[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    var keys = $31WmI(password, false, config.key, config.iv);
    return $f00d2eacbbd88b87$var$createDecipheriv(suite, keys.key, keys.iv);
}
$f00d2eacbbd88b87$export$12ada9414fbc594c = $f00d2eacbbd88b87$var$createDecipher;
$f00d2eacbbd88b87$export$36b6d6ef312eab39 = $f00d2eacbbd88b87$var$createDecipheriv;

});


parcelRegister("cIuhm", function(module, exports) {

$parcel$export(module.exports, "des-ecb", function () { return $942114dac3b79528$export$116f8a5cee447347; }, function (v) { return $942114dac3b79528$export$116f8a5cee447347 = v; });
$parcel$export(module.exports, "des-cbc", function () { return $942114dac3b79528$export$7483c4066bfb7ae9; }, function (v) { return $942114dac3b79528$export$7483c4066bfb7ae9 = v; });
$parcel$export(module.exports, "des", function () { return $942114dac3b79528$export$e7a565d2e588bb06; }, function (v) { return $942114dac3b79528$export$e7a565d2e588bb06 = v; });
$parcel$export(module.exports, "des-ede3-cbc", function () { return $942114dac3b79528$export$aaa2f54a426f3eb8; }, function (v) { return $942114dac3b79528$export$aaa2f54a426f3eb8 = v; });
$parcel$export(module.exports, "des3", function () { return $942114dac3b79528$export$eba20568dde4ada; }, function (v) { return $942114dac3b79528$export$eba20568dde4ada = v; });
$parcel$export(module.exports, "des-ede3", function () { return $942114dac3b79528$export$d3b5e5996938f5ae; }, function (v) { return $942114dac3b79528$export$d3b5e5996938f5ae = v; });
$parcel$export(module.exports, "des-ede-cbc", function () { return $942114dac3b79528$export$57c08356130bc99b; }, function (v) { return $942114dac3b79528$export$57c08356130bc99b = v; });
$parcel$export(module.exports, "des-ede", function () { return $942114dac3b79528$export$c7169791d5c1e65d; }, function (v) { return $942114dac3b79528$export$c7169791d5c1e65d = v; });
var $942114dac3b79528$export$116f8a5cee447347;
var $942114dac3b79528$export$7483c4066bfb7ae9;
var $942114dac3b79528$export$e7a565d2e588bb06;
var $942114dac3b79528$export$aaa2f54a426f3eb8;
var $942114dac3b79528$export$eba20568dde4ada;
var $942114dac3b79528$export$d3b5e5996938f5ae;
var $942114dac3b79528$export$57c08356130bc99b;
var $942114dac3b79528$export$c7169791d5c1e65d;
$942114dac3b79528$export$116f8a5cee447347 = {
    key: 8,
    iv: 0
};
$942114dac3b79528$export$7483c4066bfb7ae9 = $942114dac3b79528$export$e7a565d2e588bb06 = {
    key: 8,
    iv: 8
};
$942114dac3b79528$export$aaa2f54a426f3eb8 = $942114dac3b79528$export$eba20568dde4ada = {
    key: 24,
    iv: 8
};
$942114dac3b79528$export$d3b5e5996938f5ae = {
    key: 24,
    iv: 0
};
$942114dac3b79528$export$57c08356130bc99b = {
    key: 16,
    iv: 8
};
$942114dac3b79528$export$c7169791d5c1e65d = {
    key: 16,
    iv: 0
};

});


parcelRegister("fHxKF", function(module, exports) {

$parcel$export(module.exports, "DiffieHellmanGroup", function () { return $b6e50d8c59b9877d$export$971862a2fcb1bb40; }, function (v) { return $b6e50d8c59b9877d$export$971862a2fcb1bb40 = v; });
$parcel$export(module.exports, "createDiffieHellmanGroup", function () { return $b6e50d8c59b9877d$export$c6ff6a88acbeaf40; }, function (v) { return $b6e50d8c59b9877d$export$c6ff6a88acbeaf40 = v; });
$parcel$export(module.exports, "getDiffieHellman", function () { return $b6e50d8c59b9877d$export$fdc27893e98845cc; }, function (v) { return $b6e50d8c59b9877d$export$fdc27893e98845cc = v; });
$parcel$export(module.exports, "createDiffieHellman", function () { return $b6e50d8c59b9877d$export$6671fb9a1323bed; }, function (v) { return $b6e50d8c59b9877d$export$6671fb9a1323bed = v; });
$parcel$export(module.exports, "DiffieHellman", function () { return $b6e50d8c59b9877d$export$d74daf141a551db; }, function (v) { return $b6e50d8c59b9877d$export$d74daf141a551db = v; });
var $b6e50d8c59b9877d$export$971862a2fcb1bb40;
var $b6e50d8c59b9877d$export$c6ff6a88acbeaf40;
var $b6e50d8c59b9877d$export$fdc27893e98845cc;
var $b6e50d8c59b9877d$export$6671fb9a1323bed;
var $b6e50d8c59b9877d$export$d74daf141a551db;

var $8dlmd = parcelRequire("8dlmd");
var $b6e50d8c59b9877d$require$Buffer = $8dlmd.Buffer;

var $6YQeC = parcelRequire("6YQeC");

var $5EZQO = parcelRequire("5EZQO");

var $6CsWk = parcelRequire("6CsWk");
function $b6e50d8c59b9877d$var$getDiffieHellman(mod) {
    var prime = new $b6e50d8c59b9877d$require$Buffer($5EZQO[mod].prime, "hex");
    var gen = new $b6e50d8c59b9877d$require$Buffer($5EZQO[mod].gen, "hex");
    return new $6CsWk(prime, gen);
}
var $b6e50d8c59b9877d$var$ENCODINGS = {
    "binary": true,
    "hex": true,
    "base64": true
};
function $b6e50d8c59b9877d$var$createDiffieHellman(prime, enc, generator, genc) {
    if ($b6e50d8c59b9877d$require$Buffer.isBuffer(enc) || $b6e50d8c59b9877d$var$ENCODINGS[enc] === undefined) return $b6e50d8c59b9877d$var$createDiffieHellman(prime, "binary", enc, generator);
    enc = enc || "binary";
    genc = genc || "binary";
    generator = generator || new $b6e50d8c59b9877d$require$Buffer([
        2
    ]);
    if (!$b6e50d8c59b9877d$require$Buffer.isBuffer(generator)) generator = new $b6e50d8c59b9877d$require$Buffer(generator, genc);
    if (typeof prime === "number") return new $6CsWk($6YQeC(prime, generator), generator, true);
    if (!$b6e50d8c59b9877d$require$Buffer.isBuffer(prime)) prime = new $b6e50d8c59b9877d$require$Buffer(prime, enc);
    return new $6CsWk(prime, generator, true);
}
$b6e50d8c59b9877d$export$971862a2fcb1bb40 = $b6e50d8c59b9877d$export$c6ff6a88acbeaf40 = $b6e50d8c59b9877d$export$fdc27893e98845cc = $b6e50d8c59b9877d$var$getDiffieHellman;
$b6e50d8c59b9877d$export$6671fb9a1323bed = $b6e50d8c59b9877d$export$d74daf141a551db = $b6e50d8c59b9877d$var$createDiffieHellman;

});
parcelRegister("6YQeC", function(module, exports) {

var $3JQ6x = parcelRequire("3JQ6x");
module.exports = $5150dd63c4ab198c$var$findPrime;
$5150dd63c4ab198c$var$findPrime.simpleSieve = $5150dd63c4ab198c$var$simpleSieve;
$5150dd63c4ab198c$var$findPrime.fermatTest = $5150dd63c4ab198c$var$fermatTest;

var $blRDm = parcelRequire("blRDm");
var $5150dd63c4ab198c$var$TWENTYFOUR = new $blRDm(24);

var $anlhi = parcelRequire("anlhi");
var $5150dd63c4ab198c$var$millerRabin = new $anlhi();
var $5150dd63c4ab198c$var$ONE = new $blRDm(1);
var $5150dd63c4ab198c$var$TWO = new $blRDm(2);
var $5150dd63c4ab198c$var$FIVE = new $blRDm(5);
var $5150dd63c4ab198c$var$SIXTEEN = new $blRDm(16);
var $5150dd63c4ab198c$var$EIGHT = new $blRDm(8);
var $5150dd63c4ab198c$var$TEN = new $blRDm(10);
var $5150dd63c4ab198c$var$THREE = new $blRDm(3);
var $5150dd63c4ab198c$var$SEVEN = new $blRDm(7);
var $5150dd63c4ab198c$var$ELEVEN = new $blRDm(11);
var $5150dd63c4ab198c$var$FOUR = new $blRDm(4);
var $5150dd63c4ab198c$var$TWELVE = new $blRDm(12);
var $5150dd63c4ab198c$var$primes = null;
function $5150dd63c4ab198c$var$_getPrimes() {
    if ($5150dd63c4ab198c$var$primes !== null) return $5150dd63c4ab198c$var$primes;
    var limit = 0x100000;
    var res = [];
    res[0] = 2;
    for(var i = 1, k = 3; k < limit; k += 2){
        var sqrt = Math.ceil(Math.sqrt(k));
        for(var j = 0; j < i && res[j] <= sqrt; j++)if (k % res[j] === 0) break;
        if (i !== j && res[j] <= sqrt) continue;
        res[i++] = k;
    }
    $5150dd63c4ab198c$var$primes = res;
    return res;
}
function $5150dd63c4ab198c$var$simpleSieve(p) {
    var primes = $5150dd63c4ab198c$var$_getPrimes();
    for(var i = 0; i < primes.length; i++)if (p.modn(primes[i]) === 0) {
        if (p.cmpn(primes[i]) === 0) return true;
        else return false;
    }
    return true;
}
function $5150dd63c4ab198c$var$fermatTest(p) {
    var red = $blRDm.mont(p);
    return $5150dd63c4ab198c$var$TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}
function $5150dd63c4ab198c$var$findPrime(bits, gen) {
    if (bits < 16) {
        // this is what openssl does
        if (gen === 2 || gen === 5) return new $blRDm([
            0x8c,
            0x7b
        ]);
        else return new $blRDm([
            0x8c,
            0x27
        ]);
    }
    gen = new $blRDm(gen);
    var num, n2;
    while(true){
        num = new $blRDm($3JQ6x(Math.ceil(bits / 8)));
        while(num.bitLength() > bits)num.ishrn(1);
        if (num.isEven()) num.iadd($5150dd63c4ab198c$var$ONE);
        if (!num.testn(1)) num.iadd($5150dd63c4ab198c$var$TWO);
        if (!gen.cmp($5150dd63c4ab198c$var$TWO)) while(num.mod($5150dd63c4ab198c$var$TWENTYFOUR).cmp($5150dd63c4ab198c$var$ELEVEN))num.iadd($5150dd63c4ab198c$var$FOUR);
        else if (!gen.cmp($5150dd63c4ab198c$var$FIVE)) while(num.mod($5150dd63c4ab198c$var$TEN).cmp($5150dd63c4ab198c$var$THREE))num.iadd($5150dd63c4ab198c$var$FOUR);
        n2 = num.shrn(1);
        if ($5150dd63c4ab198c$var$simpleSieve(n2) && $5150dd63c4ab198c$var$simpleSieve(num) && $5150dd63c4ab198c$var$fermatTest(n2) && $5150dd63c4ab198c$var$fermatTest(num) && $5150dd63c4ab198c$var$millerRabin.test(n2) && $5150dd63c4ab198c$var$millerRabin.test(num)) return num;
    }
}

});
parcelRegister("blRDm", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function TempCtor() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("9dH9K")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("anlhi", function(module, exports) {

var $blRDm = parcelRequire("blRDm");

var $iuHvy = parcelRequire("iuHvy");
function $78dc8eba17b831d5$var$MillerRabin(rand) {
    this.rand = rand || new $iuHvy.Rand();
}
module.exports = $78dc8eba17b831d5$var$MillerRabin;
$78dc8eba17b831d5$var$MillerRabin.create = function create(rand) {
    return new $78dc8eba17b831d5$var$MillerRabin(rand);
};
$78dc8eba17b831d5$var$MillerRabin.prototype._randbelow = function _randbelow(n) {
    var len = n.bitLength();
    var min_bytes = Math.ceil(len / 8);
    // Generage random bytes until a number less than n is found.
    // This ensures that 0..n-1 have an equal probability of being selected.
    do var a = new $blRDm(this.rand.generate(min_bytes));
    while (a.cmp(n) >= 0);
    return a;
};
$78dc8eba17b831d5$var$MillerRabin.prototype._randrange = function _randrange(start, stop) {
    // Generate a random number greater than or equal to start and less than stop.
    var size = stop.sub(start);
    return start.add(this._randbelow(size));
};
$78dc8eba17b831d5$var$MillerRabin.prototype.test = function test(n, k, cb) {
    var len = n.bitLength();
    var red = $blRDm.mont(n);
    var rone = new $blRDm(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    var prime = true;
    for(; k > 0; k--){
        var a = this._randrange(new $blRDm(2), n1);
        if (cb) cb(a);
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return false;
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) return false;
    }
    return prime;
};
$78dc8eba17b831d5$var$MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
    var len = n.bitLength();
    var red = $blRDm.mont(n);
    var rone = new $blRDm(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    for(; k > 0; k--){
        var a = this._randrange(new $blRDm(2), n1);
        var g = n.gcd(a);
        if (g.cmpn(1) !== 0) return g;
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return x.fromRed().subn(1).gcd(n);
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) {
            x = x.redSqr();
            return x.fromRed().subn(1).gcd(n);
        }
    }
    return false;
};

});
parcelRegister("iuHvy", function(module, exports) {
var $d76cc71a17f3c5e7$var$r;
module.exports = function rand(len) {
    if (!$d76cc71a17f3c5e7$var$r) $d76cc71a17f3c5e7$var$r = new $d76cc71a17f3c5e7$var$Rand(null);
    return $d76cc71a17f3c5e7$var$r.generate(len);
};
function $d76cc71a17f3c5e7$var$Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = $d76cc71a17f3c5e7$var$Rand;
$d76cc71a17f3c5e7$var$Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
$d76cc71a17f3c5e7$var$Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};

if (typeof self === "object") {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    $d76cc71a17f3c5e7$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    $d76cc71a17f3c5e7$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === "object") // Old junk
    $d76cc71a17f3c5e7$var$Rand.prototype._rand = function() {
        throw new Error("Not implemented yet");
    };
} else // Node.js or Web worker with no crypto support
try {
    var $d76cc71a17f3c5e7$var$crypto = (parcelRequire("9dH9K"));
    if (typeof $d76cc71a17f3c5e7$var$crypto.randomBytes !== "function") throw new Error("Not supported");
    $d76cc71a17f3c5e7$var$Rand.prototype._rand = function _rand(n) {
        return $d76cc71a17f3c5e7$var$crypto.randomBytes(n);
    };
} catch (e) {}

});



parcelRegister("5EZQO", function(module, exports) {
module.exports = JSON.parse('{"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}');

});

parcelRegister("6CsWk", function(module, exports) {

var $8dlmd = parcelRequire("8dlmd");
var $4d1cbd89abc293e9$require$Buffer = $8dlmd.Buffer;

var $blRDm = parcelRequire("blRDm");

var $anlhi = parcelRequire("anlhi");
var $4d1cbd89abc293e9$var$millerRabin = new $anlhi();
var $4d1cbd89abc293e9$var$TWENTYFOUR = new $blRDm(24);
var $4d1cbd89abc293e9$var$ELEVEN = new $blRDm(11);
var $4d1cbd89abc293e9$var$TEN = new $blRDm(10);
var $4d1cbd89abc293e9$var$THREE = new $blRDm(3);
var $4d1cbd89abc293e9$var$SEVEN = new $blRDm(7);

var $6YQeC = parcelRequire("6YQeC");

var $3JQ6x = parcelRequire("3JQ6x");
module.exports = $4d1cbd89abc293e9$var$DH;
function $4d1cbd89abc293e9$var$setPublicKey(pub, enc) {
    enc = enc || "utf8";
    if (!$4d1cbd89abc293e9$require$Buffer.isBuffer(pub)) pub = new $4d1cbd89abc293e9$require$Buffer(pub, enc);
    this._pub = new $blRDm(pub);
    return this;
}
function $4d1cbd89abc293e9$var$setPrivateKey(priv, enc) {
    enc = enc || "utf8";
    if (!$4d1cbd89abc293e9$require$Buffer.isBuffer(priv)) priv = new $4d1cbd89abc293e9$require$Buffer(priv, enc);
    this._priv = new $blRDm(priv);
    return this;
}
var $4d1cbd89abc293e9$var$primeCache = {};
function $4d1cbd89abc293e9$var$checkPrime(prime, generator) {
    var gen = generator.toString("hex");
    var hex = [
        gen,
        prime.toString(16)
    ].join("_");
    if (hex in $4d1cbd89abc293e9$var$primeCache) return $4d1cbd89abc293e9$var$primeCache[hex];
    var error = 0;
    if (prime.isEven() || !$6YQeC.simpleSieve || !$6YQeC.fermatTest(prime) || !$4d1cbd89abc293e9$var$millerRabin.test(prime)) {
        //not a prime so +1
        error += 1;
        if (gen === "02" || gen === "05") // we'd be able to check the generator
        // it would fail so +8
        error += 8;
        else //we wouldn't be able to test the generator
        // so +4
        error += 4;
        $4d1cbd89abc293e9$var$primeCache[hex] = error;
        return error;
    }
    if (!$4d1cbd89abc293e9$var$millerRabin.test(prime.shrn(1))) //not a safe prime
    error += 2;
    var rem;
    switch(gen){
        case "02":
            if (prime.mod($4d1cbd89abc293e9$var$TWENTYFOUR).cmp($4d1cbd89abc293e9$var$ELEVEN)) // unsuidable generator
            error += 8;
            break;
        case "05":
            rem = prime.mod($4d1cbd89abc293e9$var$TEN);
            if (rem.cmp($4d1cbd89abc293e9$var$THREE) && rem.cmp($4d1cbd89abc293e9$var$SEVEN)) // prime mod 10 needs to equal 3 or 7
            error += 8;
            break;
        default:
            error += 4;
    }
    $4d1cbd89abc293e9$var$primeCache[hex] = error;
    return error;
}
function $4d1cbd89abc293e9$var$DH(prime, generator, malleable) {
    this.setGenerator(generator);
    this.__prime = new $blRDm(prime);
    this._prime = $blRDm.mont(this.__prime);
    this._primeLen = prime.length;
    this._pub = undefined;
    this._priv = undefined;
    this._primeCode = undefined;
    if (malleable) {
        this.setPublicKey = $4d1cbd89abc293e9$var$setPublicKey;
        this.setPrivateKey = $4d1cbd89abc293e9$var$setPrivateKey;
    } else this._primeCode = 8;
}
Object.defineProperty($4d1cbd89abc293e9$var$DH.prototype, "verifyError", {
    enumerable: true,
    get: function get() {
        if (typeof this._primeCode !== "number") this._primeCode = $4d1cbd89abc293e9$var$checkPrime(this.__prime, this.__gen);
        return this._primeCode;
    }
});
$4d1cbd89abc293e9$var$DH.prototype.generateKeys = function() {
    if (!this._priv) this._priv = new $blRDm($3JQ6x(this._primeLen));
    this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
    return this.getPublicKey();
};
$4d1cbd89abc293e9$var$DH.prototype.computeSecret = function(other) {
    other = new $blRDm(other);
    other = other.toRed(this._prime);
    var secret = other.redPow(this._priv).fromRed();
    var out = new $4d1cbd89abc293e9$require$Buffer(secret.toArray());
    var prime = this.getPrime();
    if (out.length < prime.length) {
        var front = new $4d1cbd89abc293e9$require$Buffer(prime.length - out.length);
        front.fill(0);
        out = $4d1cbd89abc293e9$require$Buffer.concat([
            front,
            out
        ]);
    }
    return out;
};
$4d1cbd89abc293e9$var$DH.prototype.getPublicKey = function getPublicKey(enc) {
    return $4d1cbd89abc293e9$var$formatReturnValue(this._pub, enc);
};
$4d1cbd89abc293e9$var$DH.prototype.getPrivateKey = function getPrivateKey(enc) {
    return $4d1cbd89abc293e9$var$formatReturnValue(this._priv, enc);
};
$4d1cbd89abc293e9$var$DH.prototype.getPrime = function(enc) {
    return $4d1cbd89abc293e9$var$formatReturnValue(this.__prime, enc);
};
$4d1cbd89abc293e9$var$DH.prototype.getGenerator = function(enc) {
    return $4d1cbd89abc293e9$var$formatReturnValue(this._gen, enc);
};
$4d1cbd89abc293e9$var$DH.prototype.setGenerator = function(gen, enc) {
    enc = enc || "utf8";
    if (!$4d1cbd89abc293e9$require$Buffer.isBuffer(gen)) gen = new $4d1cbd89abc293e9$require$Buffer(gen, enc);
    this.__gen = gen;
    this._gen = new $blRDm(gen);
    return this;
};
function $4d1cbd89abc293e9$var$formatReturnValue(bn, enc) {
    var buf = new $4d1cbd89abc293e9$require$Buffer(bn.toArray());
    if (!enc) return buf;
    else return buf.toString(enc);
}

});


parcelRegister("entsh", function(module, exports) {

var $f6JDE = parcelRequire("f6JDE");
var $a77a0fd4684dfd4a$require$Buffer = $f6JDE.Buffer;

var $iX9BE = parcelRequire("iX9BE");

var $9zh20 = parcelRequire("9zh20");

var $hwgCU = parcelRequire("hwgCU");

var $8gBOy = parcelRequire("8gBOy");

var $9yqcM = parcelRequire("9yqcM");

var $1Dipf = parcelRequire("1Dipf");
Object.keys($1Dipf).forEach(function(key) {
    $1Dipf[key].id = $a77a0fd4684dfd4a$require$Buffer.from($1Dipf[key].id, "hex");
    $1Dipf[key.toLowerCase()] = $1Dipf[key];
});
function $a77a0fd4684dfd4a$var$Sign(algorithm) {
    $9zh20.Writable.call(this);
    var data = $1Dipf[algorithm];
    if (!data) throw new Error("Unknown message digest");
    this._hashType = data.hash;
    this._hash = $iX9BE(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$hwgCU($a77a0fd4684dfd4a$var$Sign, $9zh20.Writable);
$a77a0fd4684dfd4a$var$Sign.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$a77a0fd4684dfd4a$var$Sign.prototype.update = function update(data, enc) {
    if (typeof data === "string") data = $a77a0fd4684dfd4a$require$Buffer.from(data, enc);
    this._hash.update(data);
    return this;
};
$a77a0fd4684dfd4a$var$Sign.prototype.sign = function signMethod(key, enc) {
    this.end();
    var hash = this._hash.digest();
    var sig = $8gBOy(hash, key, this._hashType, this._signType, this._tag);
    return enc ? sig.toString(enc) : sig;
};
function $a77a0fd4684dfd4a$var$Verify(algorithm) {
    $9zh20.Writable.call(this);
    var data = $1Dipf[algorithm];
    if (!data) throw new Error("Unknown message digest");
    this._hash = $iX9BE(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$hwgCU($a77a0fd4684dfd4a$var$Verify, $9zh20.Writable);
$a77a0fd4684dfd4a$var$Verify.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$a77a0fd4684dfd4a$var$Verify.prototype.update = function update(data, enc) {
    if (typeof data === "string") data = $a77a0fd4684dfd4a$require$Buffer.from(data, enc);
    this._hash.update(data);
    return this;
};
$a77a0fd4684dfd4a$var$Verify.prototype.verify = function verifyMethod(key, sig, enc) {
    if (typeof sig === "string") sig = $a77a0fd4684dfd4a$require$Buffer.from(sig, enc);
    this.end();
    var hash = this._hash.digest();
    return $9yqcM(sig, hash, key, this._signType, this._tag);
};
function $a77a0fd4684dfd4a$var$createSign(algorithm) {
    return new $a77a0fd4684dfd4a$var$Sign(algorithm);
}
function $a77a0fd4684dfd4a$var$createVerify(algorithm) {
    return new $a77a0fd4684dfd4a$var$Verify(algorithm);
}
module.exports = {
    Sign: $a77a0fd4684dfd4a$var$createSign,
    Verify: $a77a0fd4684dfd4a$var$createVerify,
    createSign: $a77a0fd4684dfd4a$var$createSign,
    createVerify: $a77a0fd4684dfd4a$var$createVerify
};

});
parcelRegister("8gBOy", function(module, exports) {
// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js

var $f6JDE = parcelRequire("f6JDE");
var $604d267ca33bac64$require$Buffer = $f6JDE.Buffer;

var $gEN8J = parcelRequire("gEN8J");

var $ckQX1 = parcelRequire("ckQX1");

var $4z21a = parcelRequire("4z21a");
var $604d267ca33bac64$require$EC = $4z21a.ec;

var $7qixM = parcelRequire("7qixM");

var $gBWPR = parcelRequire("gBWPR");

var $a05id = parcelRequire("a05id");
function $604d267ca33bac64$var$sign(hash, key, hashType, signType, tag) {
    var priv = $gBWPR(key);
    if (priv.curve) {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== "ecdsa" && signType !== "ecdsa/rsa") throw new Error("wrong private key type");
        return $604d267ca33bac64$var$ecSign(hash, priv);
    } else if (priv.type === "dsa") {
        if (signType !== "dsa") throw new Error("wrong private key type");
        return $604d267ca33bac64$var$dsaSign(hash, priv, hashType);
    } else {
        if (signType !== "rsa" && signType !== "ecdsa/rsa") throw new Error("wrong private key type");
    }
    hash = $604d267ca33bac64$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = priv.modulus.byteLength();
    var pad = [
        0,
        1
    ];
    while(hash.length + pad.length + 1 < len)pad.push(0xff);
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    var out = $ckQX1(pad, priv);
    return out;
}
function $604d267ca33bac64$var$ecSign(hash, priv) {
    var curveId = $a05id[priv.curve.join(".")];
    if (!curveId) throw new Error("unknown curve " + priv.curve.join("."));
    var curve = new $604d267ca33bac64$require$EC(curveId);
    var key = curve.keyFromPrivate(priv.privateKey);
    var out = key.sign(hash);
    return $604d267ca33bac64$require$Buffer.from(out.toDER());
}
function $604d267ca33bac64$var$dsaSign(hash, priv, algo) {
    var x = priv.params.priv_key;
    var p = priv.params.p;
    var q = priv.params.q;
    var g = priv.params.g;
    var r = new $7qixM(0);
    var k;
    var H = $604d267ca33bac64$var$bits2int(hash, q).mod(q);
    var s = false;
    var kv = $604d267ca33bac64$var$getKey(x, q, hash, algo);
    while(s === false){
        k = $604d267ca33bac64$var$makeKey(q, kv, algo);
        r = $604d267ca33bac64$var$makeR(g, k, p, q);
        s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
        if (s.cmpn(0) === 0) {
            s = false;
            r = new $7qixM(0);
        }
    }
    return $604d267ca33bac64$var$toDER(r, s);
}
function $604d267ca33bac64$var$toDER(r, s) {
    r = r.toArray();
    s = s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    var total = r.length + s.length + 4;
    var res = [
        0x30,
        total,
        0x02,
        r.length
    ];
    res = res.concat(r, [
        0x02,
        s.length
    ], s);
    return $604d267ca33bac64$require$Buffer.from(res);
}
function $604d267ca33bac64$var$getKey(x, q, hash, algo) {
    x = $604d267ca33bac64$require$Buffer.from(x.toArray());
    if (x.length < q.byteLength()) {
        var zeros = $604d267ca33bac64$require$Buffer.alloc(q.byteLength() - x.length);
        x = $604d267ca33bac64$require$Buffer.concat([
            zeros,
            x
        ]);
    }
    var hlen = hash.length;
    var hbits = $604d267ca33bac64$var$bits2octets(hash, q);
    var v = $604d267ca33bac64$require$Buffer.alloc(hlen);
    v.fill(1);
    var k = $604d267ca33bac64$require$Buffer.alloc(hlen);
    k = $gEN8J(algo, k).update(v).update($604d267ca33bac64$require$Buffer.from([
        0
    ])).update(x).update(hbits).digest();
    v = $gEN8J(algo, k).update(v).digest();
    k = $gEN8J(algo, k).update(v).update($604d267ca33bac64$require$Buffer.from([
        1
    ])).update(x).update(hbits).digest();
    v = $gEN8J(algo, k).update(v).digest();
    return {
        k: k,
        v: v
    };
}
function $604d267ca33bac64$var$bits2int(obits, q) {
    var bits = new $7qixM(obits);
    var shift = (obits.length << 3) - q.bitLength();
    if (shift > 0) bits.ishrn(shift);
    return bits;
}
function $604d267ca33bac64$var$bits2octets(bits, q) {
    bits = $604d267ca33bac64$var$bits2int(bits, q);
    bits = bits.mod(q);
    var out = $604d267ca33bac64$require$Buffer.from(bits.toArray());
    if (out.length < q.byteLength()) {
        var zeros = $604d267ca33bac64$require$Buffer.alloc(q.byteLength() - out.length);
        out = $604d267ca33bac64$require$Buffer.concat([
            zeros,
            out
        ]);
    }
    return out;
}
function $604d267ca33bac64$var$makeKey(q, kv, algo) {
    var t;
    var k;
    do {
        t = $604d267ca33bac64$require$Buffer.alloc(0);
        while(t.length * 8 < q.bitLength()){
            kv.v = $gEN8J(algo, kv.k).update(kv.v).digest();
            t = $604d267ca33bac64$require$Buffer.concat([
                t,
                kv.v
            ]);
        }
        k = $604d267ca33bac64$var$bits2int(t, q);
        kv.k = $gEN8J(algo, kv.k).update(kv.v).update($604d267ca33bac64$require$Buffer.from([
            0
        ])).digest();
        kv.v = $gEN8J(algo, kv.k).update(kv.v).digest();
    }while (k.cmp(q) !== -1);
    return k;
}
function $604d267ca33bac64$var$makeR(g, k, p, q) {
    return g.toRed($7qixM.mont(p)).redPow(k).fromRed().mod(q);
}
module.exports = $604d267ca33bac64$var$sign;
module.exports.getKey = $604d267ca33bac64$var$getKey;
module.exports.makeKey = $604d267ca33bac64$var$makeKey;

});
parcelRegister("ckQX1", function(module, exports) {

var $8dlmd = parcelRequire("8dlmd");
var $8fb06d3b2dcaa6bd$require$Buffer = $8dlmd.Buffer;

var $6VLK2 = parcelRequire("6VLK2");

var $3JQ6x = parcelRequire("3JQ6x");
function $8fb06d3b2dcaa6bd$var$blind(priv) {
    var r = $8fb06d3b2dcaa6bd$var$getr(priv);
    var blinder = r.toRed($6VLK2.mont(priv.modulus)).redPow(new $6VLK2(priv.publicExponent)).fromRed();
    return {
        blinder: blinder,
        unblinder: r.invm(priv.modulus)
    };
}
function $8fb06d3b2dcaa6bd$var$getr(priv) {
    var len = priv.modulus.byteLength();
    var r;
    do r = new $6VLK2($3JQ6x(len));
    while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2));
    return r;
}
function $8fb06d3b2dcaa6bd$var$crt(msg, priv) {
    var blinds = $8fb06d3b2dcaa6bd$var$blind(priv);
    var len = priv.modulus.byteLength();
    var blinded = new $6VLK2(msg).mul(blinds.blinder).umod(priv.modulus);
    var c1 = blinded.toRed($6VLK2.mont(priv.prime1));
    var c2 = blinded.toRed($6VLK2.mont(priv.prime2));
    var qinv = priv.coefficient;
    var p = priv.prime1;
    var q = priv.prime2;
    var m1 = c1.redPow(priv.exponent1).fromRed();
    var m2 = c2.redPow(priv.exponent2).fromRed();
    var h = m1.isub(m2).imul(qinv).umod(p).imul(q);
    return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike($8fb06d3b2dcaa6bd$require$Buffer, "be", len);
}
$8fb06d3b2dcaa6bd$var$crt.getr = $8fb06d3b2dcaa6bd$var$getr;
module.exports = $8fb06d3b2dcaa6bd$var$crt;

});
parcelRegister("6VLK2", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function TempCtor() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("9dH9K")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});


parcelRegister("4z21a", function(module, exports) {
"use strict";
var $352bff07aa0da42d$var$elliptic = module.exports;

$352bff07aa0da42d$var$elliptic.version = (parcelRequire("auhIW")).version;

$352bff07aa0da42d$var$elliptic.utils = (parcelRequire("4OvZ4"));

$352bff07aa0da42d$var$elliptic.rand = (parcelRequire("iuHvy"));

$352bff07aa0da42d$var$elliptic.curve = (parcelRequire("f1dYm"));

$352bff07aa0da42d$var$elliptic.curves = (parcelRequire("dG5bA"));

// Protocols
$352bff07aa0da42d$var$elliptic.ec = (parcelRequire("fGaGJ"));

$352bff07aa0da42d$var$elliptic.eddsa = (parcelRequire("h9ZEV"));

});
parcelRegister("auhIW", function(module, exports) {
module.exports = JSON.parse('{"name":"elliptic","version":"6.5.4","description":"EC cryptography","main":"lib/elliptic.js","files":["lib"],"scripts":{"lint":"eslint lib test","lint:fix":"npm run lint -- --fix","unit":"istanbul test _mocha --reporter=spec test/index.js","test":"npm run lint && npm run unit","version":"grunt dist && git add dist/"},"repository":{"type":"git","url":"git@github.com:indutny/elliptic"},"keywords":["EC","Elliptic","curve","Cryptography"],"author":"Fedor Indutny <fedor@indutny.com>","license":"MIT","bugs":{"url":"https://github.com/indutny/elliptic/issues"},"homepage":"https://github.com/indutny/elliptic","devDependencies":{"brfs":"^2.0.2","coveralls":"^3.1.0","eslint":"^7.6.0","grunt":"^1.2.1","grunt-browserify":"^5.3.0","grunt-cli":"^1.3.2","grunt-contrib-connect":"^3.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^5.0.0","grunt-mocha-istanbul":"^5.0.2","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.5","mocha":"^8.0.1"},"dependencies":{"bn.js":"^4.11.9","brorand":"^1.1.0","hash.js":"^1.0.0","hmac-drbg":"^1.0.1","inherits":"^2.0.4","minimalistic-assert":"^1.0.1","minimalistic-crypto-utils":"^1.0.1"}}');

});

parcelRegister("4OvZ4", function(module, exports) {
"use strict";
var $3814a44bf186da78$var$utils = module.exports;

var $blRDm = parcelRequire("blRDm");

var $7WVV2 = parcelRequire("7WVV2");

var $dAFlY = parcelRequire("dAFlY");
$3814a44bf186da78$var$utils.assert = $7WVV2;
$3814a44bf186da78$var$utils.toArray = $dAFlY.toArray;
$3814a44bf186da78$var$utils.zero2 = $dAFlY.zero2;
$3814a44bf186da78$var$utils.toHex = $dAFlY.toHex;
$3814a44bf186da78$var$utils.encode = $dAFlY.encode;
// Represent num in a w-NAF form
function $3814a44bf186da78$var$getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    naf.fill(0);
    var ws = 1 << w + 1;
    var k = num.clone();
    for(var i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
$3814a44bf186da78$var$utils.getNAF = $3814a44bf186da78$var$getNAF;
// Represent k1, k2 in a Joint Sparse Form
function $3814a44bf186da78$var$getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
$3814a44bf186da78$var$utils.getJSF = $3814a44bf186da78$var$getJSF;
function $3814a44bf186da78$var$cachedProperty(obj, name, computer) {
    var key = "_" + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
$3814a44bf186da78$var$utils.cachedProperty = $3814a44bf186da78$var$cachedProperty;
function $3814a44bf186da78$var$parseBytes(bytes) {
    return typeof bytes === "string" ? $3814a44bf186da78$var$utils.toArray(bytes, "hex") : bytes;
}
$3814a44bf186da78$var$utils.parseBytes = $3814a44bf186da78$var$parseBytes;
function $3814a44bf186da78$var$intFromLE(bytes) {
    return new $blRDm(bytes, "hex", "le");
}
$3814a44bf186da78$var$utils.intFromLE = $3814a44bf186da78$var$intFromLE;

});
parcelRegister("dAFlY", function(module, exports) {
"use strict";
var $9e4eb71150b048f8$var$utils = module.exports;
function $9e4eb71150b048f8$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== "string") {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === "hex") {
        msg = msg.replace(/[^a-z0-9]+/ig, "");
        if (msg.length % 2 !== 0) msg = "0" + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
$9e4eb71150b048f8$var$utils.toArray = $9e4eb71150b048f8$var$toArray;
function $9e4eb71150b048f8$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$9e4eb71150b048f8$var$utils.zero2 = $9e4eb71150b048f8$var$zero2;
function $9e4eb71150b048f8$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $9e4eb71150b048f8$var$zero2(msg[i].toString(16));
    return res;
}
$9e4eb71150b048f8$var$utils.toHex = $9e4eb71150b048f8$var$toHex;
$9e4eb71150b048f8$var$utils.encode = function encode(arr, enc) {
    if (enc === "hex") return $9e4eb71150b048f8$var$toHex(arr);
    else return arr;
};

});


parcelRegister("f1dYm", function(module, exports) {
"use strict";
var $aef1c9ad0dd0a9eb$var$curve = module.exports;

$aef1c9ad0dd0a9eb$var$curve.base = (parcelRequire("25gFn"));

$aef1c9ad0dd0a9eb$var$curve.short = (parcelRequire("hbKRh"));

$aef1c9ad0dd0a9eb$var$curve.mont = (parcelRequire("eyqzN"));

$aef1c9ad0dd0a9eb$var$curve.edwards = (parcelRequire("jDxcC"));

});
parcelRegister("25gFn", function(module, exports) {
"use strict";

var $blRDm = parcelRequire("blRDm");

var $4OvZ4 = parcelRequire("4OvZ4");
var $1848f9f836a1b9c7$var$getNAF = $4OvZ4.getNAF;
var $1848f9f836a1b9c7$var$getJSF = $4OvZ4.getJSF;
var $1848f9f836a1b9c7$var$assert = $4OvZ4.assert;
function $1848f9f836a1b9c7$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new $blRDm(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? $blRDm.red(conf.prime) : $blRDm.mont(this.p);
    // Useful for many curves
    this.zero = new $blRDm(0).toRed(this.red);
    this.one = new $blRDm(1).toRed(this.red);
    this.two = new $blRDm(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new $blRDm(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = $1848f9f836a1b9c7$var$BaseCurve;
$1848f9f836a1b9c7$var$BaseCurve.prototype.point = function point() {
    throw new Error("Not implemented");
};
$1848f9f836a1b9c7$var$BaseCurve.prototype.validate = function validate() {
    throw new Error("Not implemented");
};
$1848f9f836a1b9c7$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $1848f9f836a1b9c7$var$assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $1848f9f836a1b9c7$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$1848f9f836a1b9c7$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $1848f9f836a1b9c7$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $1848f9f836a1b9c7$var$assert(z !== 0);
        if (p.type === "affine") {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === "affine" ? acc.toP() : acc;
};
$1848f9f836a1b9c7$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $1848f9f836a1b9c7$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $1848f9f836a1b9c7$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $1848f9f836a1b9c7$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === "affine") acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $1848f9f836a1b9c7$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$1848f9f836a1b9c7$var$BaseCurve.BasePoint = $1848f9f836a1b9c7$var$BasePoint;
$1848f9f836a1b9c7$var$BasePoint.prototype.eq = function eq() {
    throw new Error("Not implemented");
};
$1848f9f836a1b9c7$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$1848f9f836a1b9c7$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $4OvZ4.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $1848f9f836a1b9c7$var$assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $1848f9f836a1b9c7$var$assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error("Unknown point format");
};
$1848f9f836a1b9c7$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$1848f9f836a1b9c7$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray("be", len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray("be", len));
};
$1848f9f836a1b9c7$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $4OvZ4.encode(this._encode(compact), enc);
};
$1848f9f836a1b9c7$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$1848f9f836a1b9c7$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$1848f9f836a1b9c7$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$1848f9f836a1b9c7$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$1848f9f836a1b9c7$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$1848f9f836a1b9c7$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

});

parcelRegister("hbKRh", function(module, exports) {
"use strict";

var $4OvZ4 = parcelRequire("4OvZ4");

var $blRDm = parcelRequire("blRDm");

var $hwgCU = parcelRequire("hwgCU");

var $25gFn = parcelRequire("25gFn");
var $c837cfdbc6a3038e$var$assert = $4OvZ4.assert;
function $c837cfdbc6a3038e$var$ShortCurve(conf) {
    $25gFn.call(this, "short", conf);
    this.a = new $blRDm(conf.a, 16).toRed(this.red);
    this.b = new $blRDm(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$hwgCU($c837cfdbc6a3038e$var$ShortCurve, $25gFn);
module.exports = $c837cfdbc6a3038e$var$ShortCurve;
$c837cfdbc6a3038e$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new $blRDm(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new $blRDm(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $c837cfdbc6a3038e$var$assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new $blRDm(vec.a, 16),
            b: new $blRDm(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$c837cfdbc6a3038e$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : $blRDm.mont(num);
    var tinv = new $blRDm(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new $blRDm(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$c837cfdbc6a3038e$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new $blRDm(1);
    var y1 = new $blRDm(0);
    var x2 = new $blRDm(0);
    var y2 = new $blRDm(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$c837cfdbc6a3038e$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$c837cfdbc6a3038e$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $blRDm(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$c837cfdbc6a3038e$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$c837cfdbc6a3038e$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $c837cfdbc6a3038e$var$Point(curve, x, y, isRed) {
    $25gFn.BasePoint.call(this, curve, "affine");
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new $blRDm(x, 16);
        this.y = new $blRDm(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$hwgCU($c837cfdbc6a3038e$var$Point, $25gFn.BasePoint);
$c837cfdbc6a3038e$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $c837cfdbc6a3038e$var$Point(this, x, y, isRed);
};
$c837cfdbc6a3038e$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $c837cfdbc6a3038e$var$Point.fromJSON(this, obj, red);
};
$c837cfdbc6a3038e$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function endoMul(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$c837cfdbc6a3038e$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$c837cfdbc6a3038e$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === "string") obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$c837cfdbc6a3038e$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
$c837cfdbc6a3038e$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$c837cfdbc6a3038e$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$c837cfdbc6a3038e$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$c837cfdbc6a3038e$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$c837cfdbc6a3038e$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$c837cfdbc6a3038e$var$Point.prototype.mul = function mul(k) {
    k = new $blRDm(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$c837cfdbc6a3038e$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$c837cfdbc6a3038e$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$c837cfdbc6a3038e$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$c837cfdbc6a3038e$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function negate(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$c837cfdbc6a3038e$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $c837cfdbc6a3038e$var$JPoint(curve, x, y, z) {
    $25gFn.BasePoint.call(this, curve, "jacobian");
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new $blRDm(0);
    } else {
        this.x = new $blRDm(x, 16);
        this.y = new $blRDm(y, 16);
        this.z = new $blRDm(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$hwgCU($c837cfdbc6a3038e$var$JPoint, $25gFn.BasePoint);
$c837cfdbc6a3038e$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $c837cfdbc6a3038e$var$JPoint(this, x, y, z);
};
$c837cfdbc6a3038e$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$c837cfdbc6a3038e$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$c837cfdbc6a3038e$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$c837cfdbc6a3038e$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$c837cfdbc6a3038e$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$c837cfdbc6a3038e$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$c837cfdbc6a3038e$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$c837cfdbc6a3038e$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$c837cfdbc6a3038e$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$c837cfdbc6a3038e$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$c837cfdbc6a3038e$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new $blRDm(k, kbase);
    return this.curve._wnafMul(this, k);
};
$c837cfdbc6a3038e$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === "affine") return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$c837cfdbc6a3038e$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$c837cfdbc6a3038e$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC JPoint Infinity>";
    return "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
$c837cfdbc6a3038e$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

});

parcelRegister("eyqzN", function(module, exports) {
"use strict";

var $blRDm = parcelRequire("blRDm");

var $hwgCU = parcelRequire("hwgCU");

var $25gFn = parcelRequire("25gFn");

var $4OvZ4 = parcelRequire("4OvZ4");
function $a988db3387543c7d$var$MontCurve(conf) {
    $25gFn.call(this, "mont", conf);
    this.a = new $blRDm(conf.a, 16).toRed(this.red);
    this.b = new $blRDm(conf.b, 16).toRed(this.red);
    this.i4 = new $blRDm(4).toRed(this.red).redInvm();
    this.two = new $blRDm(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
$hwgCU($a988db3387543c7d$var$MontCurve, $25gFn);
module.exports = $a988db3387543c7d$var$MontCurve;
$a988db3387543c7d$var$MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function $a988db3387543c7d$var$Point(curve, x, z) {
    $25gFn.BasePoint.call(this, curve, "projective");
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new $blRDm(x, 16);
        this.z = new $blRDm(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
$hwgCU($a988db3387543c7d$var$Point, $25gFn.BasePoint);
$a988db3387543c7d$var$MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point($4OvZ4.toArray(bytes, enc), 1);
};
$a988db3387543c7d$var$MontCurve.prototype.point = function point(x, z) {
    return new $a988db3387543c7d$var$Point(this, x, z);
};
$a988db3387543c7d$var$MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $a988db3387543c7d$var$Point.fromJSON(this, obj);
};
$a988db3387543c7d$var$Point.prototype.precompute = function precompute() {
// No-op
};
$a988db3387543c7d$var$Point.prototype._encode = function _encode() {
    return this.getX().toArray("be", this.curve.p.byteLength());
};
$a988db3387543c7d$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $a988db3387543c7d$var$Point(curve, obj[0], obj[1] || curve.one);
};
$a988db3387543c7d$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
$a988db3387543c7d$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
$a988db3387543c7d$var$Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
$a988db3387543c7d$var$Point.prototype.add = function add() {
    throw new Error("Not supported on Montgomery curve");
};
$a988db3387543c7d$var$Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
$a988db3387543c7d$var$Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
$a988db3387543c7d$var$Point.prototype.mulAdd = function mulAdd() {
    throw new Error("Not supported on Montgomery curve");
};
$a988db3387543c7d$var$Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error("Not supported on Montgomery curve");
};
$a988db3387543c7d$var$Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
$a988db3387543c7d$var$Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
$a988db3387543c7d$var$Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

});

parcelRegister("jDxcC", function(module, exports) {
"use strict";

var $4OvZ4 = parcelRequire("4OvZ4");

var $blRDm = parcelRequire("blRDm");

var $hwgCU = parcelRequire("hwgCU");

var $25gFn = parcelRequire("25gFn");
var $e4bb6a30ae189fa2$var$assert = $4OvZ4.assert;
function $e4bb6a30ae189fa2$var$EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    $25gFn.call(this, "edwards", conf);
    this.a = new $blRDm(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new $blRDm(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new $blRDm(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    $e4bb6a30ae189fa2$var$assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
$hwgCU($e4bb6a30ae189fa2$var$EdwardsCurve, $25gFn);
module.exports = $e4bb6a30ae189fa2$var$EdwardsCurve;
$e4bb6a30ae189fa2$var$EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
$e4bb6a30ae189fa2$var$EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
$e4bb6a30ae189fa2$var$EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
$e4bb6a30ae189fa2$var$EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $blRDm(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$e4bb6a30ae189fa2$var$EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new $blRDm(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error("invalid point");
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error("invalid point");
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
$e4bb6a30ae189fa2$var$EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function $e4bb6a30ae189fa2$var$Point(curve, x, y, z, t) {
    $25gFn.BasePoint.call(this, curve, "projective");
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new $blRDm(x, 16);
        this.y = new $blRDm(y, 16);
        this.z = z ? new $blRDm(z, 16) : this.curve.one;
        this.t = t && new $blRDm(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
$hwgCU($e4bb6a30ae189fa2$var$Point, $25gFn.BasePoint);
$e4bb6a30ae189fa2$var$EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $e4bb6a30ae189fa2$var$Point.fromJSON(this, obj);
};
$e4bb6a30ae189fa2$var$EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new $e4bb6a30ae189fa2$var$Point(this, x, y, z, t);
};
$e4bb6a30ae189fa2$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $e4bb6a30ae189fa2$var$Point(curve, obj[0], obj[1], obj[2]);
};
$e4bb6a30ae189fa2$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
$e4bb6a30ae189fa2$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
$e4bb6a30ae189fa2$var$Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$e4bb6a30ae189fa2$var$Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
$e4bb6a30ae189fa2$var$Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
$e4bb6a30ae189fa2$var$Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$e4bb6a30ae189fa2$var$Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
$e4bb6a30ae189fa2$var$Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
$e4bb6a30ae189fa2$var$Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
$e4bb6a30ae189fa2$var$Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
$e4bb6a30ae189fa2$var$Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
$e4bb6a30ae189fa2$var$Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
$e4bb6a30ae189fa2$var$Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
$e4bb6a30ae189fa2$var$Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
$e4bb6a30ae189fa2$var$Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
$e4bb6a30ae189fa2$var$Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
$e4bb6a30ae189fa2$var$Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
$e4bb6a30ae189fa2$var$Point.prototype.toP = $e4bb6a30ae189fa2$var$Point.prototype.normalize;
$e4bb6a30ae189fa2$var$Point.prototype.mixedAdd = $e4bb6a30ae189fa2$var$Point.prototype.add;

});


parcelRegister("dG5bA", function(module, exports) {
"use strict";
var $9f533866ab76b6b4$var$curves = module.exports;

var $2eq8E = parcelRequire("2eq8E");

var $f1dYm = parcelRequire("f1dYm");

var $4OvZ4 = parcelRequire("4OvZ4");
var $9f533866ab76b6b4$var$assert = $4OvZ4.assert;
function $9f533866ab76b6b4$var$PresetCurve(options) {
    if (options.type === "short") this.curve = new $f1dYm.short(options);
    else if (options.type === "edwards") this.curve = new $f1dYm.edwards(options);
    else this.curve = new $f1dYm.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    $9f533866ab76b6b4$var$assert(this.g.validate(), "Invalid curve");
    $9f533866ab76b6b4$var$assert(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
}
$9f533866ab76b6b4$var$curves.PresetCurve = $9f533866ab76b6b4$var$PresetCurve;
function $9f533866ab76b6b4$var$defineCurve(name, options) {
    Object.defineProperty($9f533866ab76b6b4$var$curves, name, {
        configurable: true,
        enumerable: true,
        get: function get() {
            var curve = new $9f533866ab76b6b4$var$PresetCurve(options);
            Object.defineProperty($9f533866ab76b6b4$var$curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
$9f533866ab76b6b4$var$defineCurve("p192", {
    type: "short",
    prime: "p192",
    p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
    b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
    n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
    hash: $2eq8E.sha256,
    gRed: false,
    g: [
        "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
        "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
    ]
});
$9f533866ab76b6b4$var$defineCurve("p224", {
    type: "short",
    prime: "p224",
    p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
    b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
    n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
    hash: $2eq8E.sha256,
    gRed: false,
    g: [
        "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
        "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
    ]
});
$9f533866ab76b6b4$var$defineCurve("p256", {
    type: "short",
    prime: null,
    p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
    a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
    b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
    n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
    hash: $2eq8E.sha256,
    gRed: false,
    g: [
        "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
        "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
    ]
});
$9f533866ab76b6b4$var$defineCurve("p384", {
    type: "short",
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: $2eq8E.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
$9f533866ab76b6b4$var$defineCurve("p521", {
    type: "short",
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: $2eq8E.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
$9f533866ab76b6b4$var$defineCurve("curve25519", {
    type: "mont",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "76d06",
    b: "1",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: $2eq8E.sha256,
    gRed: false,
    g: [
        "9"
    ]
});
$9f533866ab76b6b4$var$defineCurve("ed25519", {
    type: "edwards",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "-1",
    c: "1",
    // -121665 * (121666^(-1)) (mod P)
    d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: $2eq8E.sha256,
    gRed: false,
    g: [
        "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
        // 4/5
        "6666666666666666666666666666666666666666666666666666666666666658"
    ]
});
var $9f533866ab76b6b4$var$pre;

try {
    $9f533866ab76b6b4$var$pre = (parcelRequire("9TncA"));
} catch (e) {
    $9f533866ab76b6b4$var$pre = undefined;
}
$9f533866ab76b6b4$var$defineCurve("secp256k1", {
    type: "short",
    prime: "k256",
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
    a: "0",
    b: "7",
    n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
    h: "1",
    hash: $2eq8E.sha256,
    // Precomputed endomorphism
    beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
    lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
    basis: [
        {
            a: "3086d221a7d46bcde86c90e49284eb15",
            b: "-e4437ed6010e88286f547fa90abfe4c3"
        },
        {
            a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
            b: "3086d221a7d46bcde86c90e49284eb15"
        }
    ],
    gRed: false,
    g: [
        "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
        "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
        $9f533866ab76b6b4$var$pre
    ]
});

});
parcelRegister("2eq8E", function(module, exports) {
var $1a012a2ae54af2fe$var$hash = module.exports;

$1a012a2ae54af2fe$var$hash.utils = (parcelRequire("bxKYQ"));

$1a012a2ae54af2fe$var$hash.common = (parcelRequire("hImYp"));

$1a012a2ae54af2fe$var$hash.sha = (parcelRequire("03XPf"));

$1a012a2ae54af2fe$var$hash.ripemd = (parcelRequire("6xyjW"));

$1a012a2ae54af2fe$var$hash.hmac = (parcelRequire("cMrGk"));
// Proxy hash functions to the main object
$1a012a2ae54af2fe$var$hash.sha1 = $1a012a2ae54af2fe$var$hash.sha.sha1;
$1a012a2ae54af2fe$var$hash.sha256 = $1a012a2ae54af2fe$var$hash.sha.sha256;
$1a012a2ae54af2fe$var$hash.sha224 = $1a012a2ae54af2fe$var$hash.sha.sha224;
$1a012a2ae54af2fe$var$hash.sha384 = $1a012a2ae54af2fe$var$hash.sha.sha384;
$1a012a2ae54af2fe$var$hash.sha512 = $1a012a2ae54af2fe$var$hash.sha.sha512;
$1a012a2ae54af2fe$var$hash.ripemd160 = $1a012a2ae54af2fe$var$hash.ripemd.ripemd160;

});
parcelRegister("bxKYQ", function(module, exports) {

$parcel$export(module.exports, "inherits", function () { return $8677381611f24b78$export$69f1b2dcda23c5f8; }, function (v) { return $8677381611f24b78$export$69f1b2dcda23c5f8 = v; });
$parcel$export(module.exports, "toArray", function () { return $8677381611f24b78$export$45b10814cc054894; }, function (v) { return $8677381611f24b78$export$45b10814cc054894 = v; });
$parcel$export(module.exports, "toHex", function () { return $8677381611f24b78$export$7ea66e3774a60b67; }, function (v) { return $8677381611f24b78$export$7ea66e3774a60b67 = v; });
$parcel$export(module.exports, "htonl", function () { return $8677381611f24b78$export$34a52f00f601f6f1; }, function (v) { return $8677381611f24b78$export$34a52f00f601f6f1 = v; });
$parcel$export(module.exports, "toHex32", function () { return $8677381611f24b78$export$812b0cbd5e8a72ab; }, function (v) { return $8677381611f24b78$export$812b0cbd5e8a72ab = v; });
$parcel$export(module.exports, "zero2", function () { return $8677381611f24b78$export$f24f9e11d63bb314; }, function (v) { return $8677381611f24b78$export$f24f9e11d63bb314 = v; });
$parcel$export(module.exports, "zero8", function () { return $8677381611f24b78$export$b71357c7e07ca1f1; }, function (v) { return $8677381611f24b78$export$b71357c7e07ca1f1 = v; });
$parcel$export(module.exports, "join32", function () { return $8677381611f24b78$export$2e58a4b541fdcbe8; }, function (v) { return $8677381611f24b78$export$2e58a4b541fdcbe8 = v; });
$parcel$export(module.exports, "split32", function () { return $8677381611f24b78$export$183b950bde9faab8; }, function (v) { return $8677381611f24b78$export$183b950bde9faab8 = v; });
$parcel$export(module.exports, "rotr32", function () { return $8677381611f24b78$export$4785c77169fea59e; }, function (v) { return $8677381611f24b78$export$4785c77169fea59e = v; });
$parcel$export(module.exports, "rotl32", function () { return $8677381611f24b78$export$242a185dfcffac5b; }, function (v) { return $8677381611f24b78$export$242a185dfcffac5b = v; });
$parcel$export(module.exports, "sum32", function () { return $8677381611f24b78$export$58c04ae0ae31877d; }, function (v) { return $8677381611f24b78$export$58c04ae0ae31877d = v; });
$parcel$export(module.exports, "sum32_3", function () { return $8677381611f24b78$export$d058ca695f8c6f11; }, function (v) { return $8677381611f24b78$export$d058ca695f8c6f11 = v; });
$parcel$export(module.exports, "sum32_4", function () { return $8677381611f24b78$export$a1efd7fc3e986367; }, function (v) { return $8677381611f24b78$export$a1efd7fc3e986367 = v; });
$parcel$export(module.exports, "sum32_5", function () { return $8677381611f24b78$export$bbfea4a2b5abaab4; }, function (v) { return $8677381611f24b78$export$bbfea4a2b5abaab4 = v; });
$parcel$export(module.exports, "sum64", function () { return $8677381611f24b78$export$97ad4afc7de86152; }, function (v) { return $8677381611f24b78$export$97ad4afc7de86152 = v; });
$parcel$export(module.exports, "sum64_hi", function () { return $8677381611f24b78$export$ce4673d9a79f6a4b; }, function (v) { return $8677381611f24b78$export$ce4673d9a79f6a4b = v; });
$parcel$export(module.exports, "sum64_lo", function () { return $8677381611f24b78$export$786cc99fc6eedc0b; }, function (v) { return $8677381611f24b78$export$786cc99fc6eedc0b = v; });
$parcel$export(module.exports, "sum64_4_hi", function () { return $8677381611f24b78$export$45c59b9a1848dd0; }, function (v) { return $8677381611f24b78$export$45c59b9a1848dd0 = v; });
$parcel$export(module.exports, "sum64_4_lo", function () { return $8677381611f24b78$export$50d8f613e76d3034; }, function (v) { return $8677381611f24b78$export$50d8f613e76d3034 = v; });
$parcel$export(module.exports, "sum64_5_hi", function () { return $8677381611f24b78$export$b8e83683c60ee162; }, function (v) { return $8677381611f24b78$export$b8e83683c60ee162 = v; });
$parcel$export(module.exports, "sum64_5_lo", function () { return $8677381611f24b78$export$aeeb51790d1bcc4a; }, function (v) { return $8677381611f24b78$export$aeeb51790d1bcc4a = v; });
$parcel$export(module.exports, "rotr64_hi", function () { return $8677381611f24b78$export$bb7c616f719ad9c; }, function (v) { return $8677381611f24b78$export$bb7c616f719ad9c = v; });
$parcel$export(module.exports, "rotr64_lo", function () { return $8677381611f24b78$export$4d63290824f9d7df; }, function (v) { return $8677381611f24b78$export$4d63290824f9d7df = v; });
$parcel$export(module.exports, "shr64_hi", function () { return $8677381611f24b78$export$2f64ceb90ef28ea1; }, function (v) { return $8677381611f24b78$export$2f64ceb90ef28ea1 = v; });
$parcel$export(module.exports, "shr64_lo", function () { return $8677381611f24b78$export$8d2089d465f6d10d; }, function (v) { return $8677381611f24b78$export$8d2089d465f6d10d = v; });
var $8677381611f24b78$export$69f1b2dcda23c5f8;
var $8677381611f24b78$export$45b10814cc054894;
var $8677381611f24b78$export$7ea66e3774a60b67;
var $8677381611f24b78$export$34a52f00f601f6f1;
var $8677381611f24b78$export$812b0cbd5e8a72ab;
var $8677381611f24b78$export$f24f9e11d63bb314;
var $8677381611f24b78$export$b71357c7e07ca1f1;
var $8677381611f24b78$export$2e58a4b541fdcbe8;
var $8677381611f24b78$export$183b950bde9faab8;
var $8677381611f24b78$export$4785c77169fea59e;
var $8677381611f24b78$export$242a185dfcffac5b;
var $8677381611f24b78$export$58c04ae0ae31877d;
var $8677381611f24b78$export$d058ca695f8c6f11;
var $8677381611f24b78$export$a1efd7fc3e986367;
var $8677381611f24b78$export$bbfea4a2b5abaab4;
var $8677381611f24b78$export$97ad4afc7de86152;
var $8677381611f24b78$export$ce4673d9a79f6a4b;
var $8677381611f24b78$export$786cc99fc6eedc0b;
var $8677381611f24b78$export$45c59b9a1848dd0;
var $8677381611f24b78$export$50d8f613e76d3034;
var $8677381611f24b78$export$b8e83683c60ee162;
var $8677381611f24b78$export$aeeb51790d1bcc4a;
var $8677381611f24b78$export$bb7c616f719ad9c;
var $8677381611f24b78$export$4d63290824f9d7df;
var $8677381611f24b78$export$2f64ceb90ef28ea1;
var $8677381611f24b78$export$8d2089d465f6d10d;
"use strict";

var $7WVV2 = parcelRequire("7WVV2");

var $hwgCU = parcelRequire("hwgCU");
$8677381611f24b78$export$69f1b2dcda23c5f8 = $hwgCU;
function $8677381611f24b78$var$isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function $8677381611f24b78$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === "string") {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if ($8677381611f24b78$var$isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === "hex") {
            msg = msg.replace(/[^a-z0-9]+/ig, "");
            if (msg.length % 2 !== 0) msg = "0" + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$8677381611f24b78$export$45b10814cc054894 = $8677381611f24b78$var$toArray;
function $8677381611f24b78$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $8677381611f24b78$var$zero2(msg[i].toString(16));
    return res;
}
$8677381611f24b78$export$7ea66e3774a60b67 = $8677381611f24b78$var$toHex;
function $8677381611f24b78$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$8677381611f24b78$export$34a52f00f601f6f1 = $8677381611f24b78$var$htonl;
function $8677381611f24b78$var$toHex32(msg, endian) {
    var res = "";
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === "little") w = $8677381611f24b78$var$htonl(w);
        res += $8677381611f24b78$var$zero8(w.toString(16));
    }
    return res;
}
$8677381611f24b78$export$812b0cbd5e8a72ab = $8677381611f24b78$var$toHex32;
function $8677381611f24b78$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$8677381611f24b78$export$f24f9e11d63bb314 = $8677381611f24b78$var$zero2;
function $8677381611f24b78$var$zero8(word) {
    if (word.length === 7) return "0" + word;
    else if (word.length === 6) return "00" + word;
    else if (word.length === 5) return "000" + word;
    else if (word.length === 4) return "0000" + word;
    else if (word.length === 3) return "00000" + word;
    else if (word.length === 2) return "000000" + word;
    else if (word.length === 1) return "0000000" + word;
    else return word;
}
$8677381611f24b78$export$b71357c7e07ca1f1 = $8677381611f24b78$var$zero8;
function $8677381611f24b78$var$join32(msg, start, end, endian) {
    var len = end - start;
    $7WVV2(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === "big") w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$8677381611f24b78$export$2e58a4b541fdcbe8 = $8677381611f24b78$var$join32;
function $8677381611f24b78$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === "big") {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$8677381611f24b78$export$183b950bde9faab8 = $8677381611f24b78$var$split32;
function $8677381611f24b78$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$8677381611f24b78$export$4785c77169fea59e = $8677381611f24b78$var$rotr32;
function $8677381611f24b78$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$8677381611f24b78$export$242a185dfcffac5b = $8677381611f24b78$var$rotl32;
function $8677381611f24b78$var$sum32(a, b) {
    return a + b >>> 0;
}
$8677381611f24b78$export$58c04ae0ae31877d = $8677381611f24b78$var$sum32;
function $8677381611f24b78$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$8677381611f24b78$export$d058ca695f8c6f11 = $8677381611f24b78$var$sum32_3;
function $8677381611f24b78$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$8677381611f24b78$export$a1efd7fc3e986367 = $8677381611f24b78$var$sum32_4;
function $8677381611f24b78$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$8677381611f24b78$export$bbfea4a2b5abaab4 = $8677381611f24b78$var$sum32_5;
function $8677381611f24b78$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$8677381611f24b78$export$97ad4afc7de86152 = $8677381611f24b78$var$sum64;
function $8677381611f24b78$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$8677381611f24b78$export$ce4673d9a79f6a4b = $8677381611f24b78$var$sum64_hi;
function $8677381611f24b78$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$8677381611f24b78$export$786cc99fc6eedc0b = $8677381611f24b78$var$sum64_lo;
function $8677381611f24b78$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$8677381611f24b78$export$45c59b9a1848dd0 = $8677381611f24b78$var$sum64_4_hi;
function $8677381611f24b78$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$8677381611f24b78$export$50d8f613e76d3034 = $8677381611f24b78$var$sum64_4_lo;
function $8677381611f24b78$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$8677381611f24b78$export$b8e83683c60ee162 = $8677381611f24b78$var$sum64_5_hi;
function $8677381611f24b78$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$8677381611f24b78$export$aeeb51790d1bcc4a = $8677381611f24b78$var$sum64_5_lo;
function $8677381611f24b78$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$8677381611f24b78$export$bb7c616f719ad9c = $8677381611f24b78$var$rotr64_hi;
function $8677381611f24b78$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$8677381611f24b78$export$4d63290824f9d7df = $8677381611f24b78$var$rotr64_lo;
function $8677381611f24b78$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$8677381611f24b78$export$2f64ceb90ef28ea1 = $8677381611f24b78$var$shr64_hi;
function $8677381611f24b78$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$8677381611f24b78$export$8d2089d465f6d10d = $8677381611f24b78$var$shr64_lo;

});

parcelRegister("hImYp", function(module, exports) {

$parcel$export(module.exports, "BlockHash", function () { return $ce585dc167d45d11$export$8687658379b577e6; }, function (v) { return $ce585dc167d45d11$export$8687658379b577e6 = v; });
var $ce585dc167d45d11$export$8687658379b577e6;
"use strict";

var $bxKYQ = parcelRequire("bxKYQ");

var $7WVV2 = parcelRequire("7WVV2");
function $ce585dc167d45d11$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = "big";
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$ce585dc167d45d11$export$8687658379b577e6 = $ce585dc167d45d11$var$BlockHash;
$ce585dc167d45d11$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $bxKYQ.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $bxKYQ.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$ce585dc167d45d11$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $7WVV2(this.pending === null);
    return this._digest(enc);
};
$ce585dc167d45d11$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === "big") {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRegister("03XPf", function(module, exports) {

$parcel$export(module.exports, "sha1", function () { return $00beb00d0afa2168$export$5091bdda49ba90f5; }, function (v) { return $00beb00d0afa2168$export$5091bdda49ba90f5 = v; });
$parcel$export(module.exports, "sha224", function () { return $00beb00d0afa2168$export$97b70509d4e397ea; }, function (v) { return $00beb00d0afa2168$export$97b70509d4e397ea = v; });
$parcel$export(module.exports, "sha256", function () { return $00beb00d0afa2168$export$bced8d2aada2d1c9; }, function (v) { return $00beb00d0afa2168$export$bced8d2aada2d1c9 = v; });
$parcel$export(module.exports, "sha384", function () { return $00beb00d0afa2168$export$612d47d55dedde45; }, function (v) { return $00beb00d0afa2168$export$612d47d55dedde45 = v; });
$parcel$export(module.exports, "sha512", function () { return $00beb00d0afa2168$export$a888d2532e6dc7bb; }, function (v) { return $00beb00d0afa2168$export$a888d2532e6dc7bb = v; });
var $00beb00d0afa2168$export$5091bdda49ba90f5;
var $00beb00d0afa2168$export$97b70509d4e397ea;
var $00beb00d0afa2168$export$bced8d2aada2d1c9;
var $00beb00d0afa2168$export$612d47d55dedde45;
var $00beb00d0afa2168$export$a888d2532e6dc7bb;
"use strict";

$00beb00d0afa2168$export$5091bdda49ba90f5 = (parcelRequire("i4U9Z"));

$00beb00d0afa2168$export$97b70509d4e397ea = (parcelRequire("e6IrM"));

$00beb00d0afa2168$export$bced8d2aada2d1c9 = (parcelRequire("6tIqG"));

$00beb00d0afa2168$export$612d47d55dedde45 = (parcelRequire("kmwi1"));

$00beb00d0afa2168$export$a888d2532e6dc7bb = (parcelRequire("bVmxl"));

});
parcelRegister("i4U9Z", function(module, exports) {
"use strict";

var $bxKYQ = parcelRequire("bxKYQ");

var $hImYp = parcelRequire("hImYp");

var $clh35 = parcelRequire("clh35");
var $d29429f1c0a951ac$var$rotl32 = $bxKYQ.rotl32;
var $d29429f1c0a951ac$var$sum32 = $bxKYQ.sum32;
var $d29429f1c0a951ac$var$sum32_5 = $bxKYQ.sum32_5;
var $d29429f1c0a951ac$var$ft_1 = $clh35.ft_1;
var $d29429f1c0a951ac$var$BlockHash = $hImYp.BlockHash;
var $d29429f1c0a951ac$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $d29429f1c0a951ac$var$SHA1() {
    if (!(this instanceof $d29429f1c0a951ac$var$SHA1)) return new $d29429f1c0a951ac$var$SHA1();
    $d29429f1c0a951ac$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$bxKYQ.inherits($d29429f1c0a951ac$var$SHA1, $d29429f1c0a951ac$var$BlockHash);
module.exports = $d29429f1c0a951ac$var$SHA1;
$d29429f1c0a951ac$var$SHA1.blockSize = 512;
$d29429f1c0a951ac$var$SHA1.outSize = 160;
$d29429f1c0a951ac$var$SHA1.hmacStrength = 80;
$d29429f1c0a951ac$var$SHA1.padLength = 64;
$d29429f1c0a951ac$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $d29429f1c0a951ac$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $d29429f1c0a951ac$var$sum32_5($d29429f1c0a951ac$var$rotl32(a, 5), $d29429f1c0a951ac$var$ft_1(s, b, c, d), e, W[i], $d29429f1c0a951ac$var$sha1_K[s]);
        e = d;
        d = c;
        c = $d29429f1c0a951ac$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $d29429f1c0a951ac$var$sum32(this.h[0], a);
    this.h[1] = $d29429f1c0a951ac$var$sum32(this.h[1], b);
    this.h[2] = $d29429f1c0a951ac$var$sum32(this.h[2], c);
    this.h[3] = $d29429f1c0a951ac$var$sum32(this.h[3], d);
    this.h[4] = $d29429f1c0a951ac$var$sum32(this.h[4], e);
};
$d29429f1c0a951ac$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === "hex") return $bxKYQ.toHex32(this.h, "big");
    else return $bxKYQ.split32(this.h, "big");
};

});
parcelRegister("clh35", function(module, exports) {

$parcel$export(module.exports, "ft_1", function () { return $8fc4abc25197f241$export$5a92649d7ddb9f63; }, function (v) { return $8fc4abc25197f241$export$5a92649d7ddb9f63 = v; });
$parcel$export(module.exports, "ch32", function () { return $8fc4abc25197f241$export$c6d0d020c3a6269; }, function (v) { return $8fc4abc25197f241$export$c6d0d020c3a6269 = v; });
$parcel$export(module.exports, "maj32", function () { return $8fc4abc25197f241$export$eb90c27fca05f956; }, function (v) { return $8fc4abc25197f241$export$eb90c27fca05f956 = v; });
$parcel$export(module.exports, "s0_256", function () { return $8fc4abc25197f241$export$14a4a98e063b1999; }, function (v) { return $8fc4abc25197f241$export$14a4a98e063b1999 = v; });
$parcel$export(module.exports, "s1_256", function () { return $8fc4abc25197f241$export$d20cecfa1564c686; }, function (v) { return $8fc4abc25197f241$export$d20cecfa1564c686 = v; });
$parcel$export(module.exports, "g0_256", function () { return $8fc4abc25197f241$export$44fd472a12fc6db; }, function (v) { return $8fc4abc25197f241$export$44fd472a12fc6db = v; });
$parcel$export(module.exports, "g1_256", function () { return $8fc4abc25197f241$export$1ed238bb6ea1dd47; }, function (v) { return $8fc4abc25197f241$export$1ed238bb6ea1dd47 = v; });
var $8fc4abc25197f241$export$5a92649d7ddb9f63;
var $8fc4abc25197f241$export$c6d0d020c3a6269;
var $8fc4abc25197f241$export$eb90c27fca05f956;
var $8fc4abc25197f241$export$cc992891a14496a1;
var $8fc4abc25197f241$export$14a4a98e063b1999;
var $8fc4abc25197f241$export$d20cecfa1564c686;
var $8fc4abc25197f241$export$44fd472a12fc6db;
var $8fc4abc25197f241$export$1ed238bb6ea1dd47;
"use strict";

var $bxKYQ = parcelRequire("bxKYQ");
var $8fc4abc25197f241$var$rotr32 = $bxKYQ.rotr32;
function $8fc4abc25197f241$var$ft_1(s, x, y, z) {
    if (s === 0) return $8fc4abc25197f241$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $8fc4abc25197f241$var$p32(x, y, z);
    if (s === 2) return $8fc4abc25197f241$var$maj32(x, y, z);
}
$8fc4abc25197f241$export$5a92649d7ddb9f63 = $8fc4abc25197f241$var$ft_1;
function $8fc4abc25197f241$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$8fc4abc25197f241$export$c6d0d020c3a6269 = $8fc4abc25197f241$var$ch32;
function $8fc4abc25197f241$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$8fc4abc25197f241$export$eb90c27fca05f956 = $8fc4abc25197f241$var$maj32;
function $8fc4abc25197f241$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$8fc4abc25197f241$export$cc992891a14496a1 = $8fc4abc25197f241$var$p32;
function $8fc4abc25197f241$var$s0_256(x) {
    return $8fc4abc25197f241$var$rotr32(x, 2) ^ $8fc4abc25197f241$var$rotr32(x, 13) ^ $8fc4abc25197f241$var$rotr32(x, 22);
}
$8fc4abc25197f241$export$14a4a98e063b1999 = $8fc4abc25197f241$var$s0_256;
function $8fc4abc25197f241$var$s1_256(x) {
    return $8fc4abc25197f241$var$rotr32(x, 6) ^ $8fc4abc25197f241$var$rotr32(x, 11) ^ $8fc4abc25197f241$var$rotr32(x, 25);
}
$8fc4abc25197f241$export$d20cecfa1564c686 = $8fc4abc25197f241$var$s1_256;
function $8fc4abc25197f241$var$g0_256(x) {
    return $8fc4abc25197f241$var$rotr32(x, 7) ^ $8fc4abc25197f241$var$rotr32(x, 18) ^ x >>> 3;
}
$8fc4abc25197f241$export$44fd472a12fc6db = $8fc4abc25197f241$var$g0_256;
function $8fc4abc25197f241$var$g1_256(x) {
    return $8fc4abc25197f241$var$rotr32(x, 17) ^ $8fc4abc25197f241$var$rotr32(x, 19) ^ x >>> 10;
}
$8fc4abc25197f241$export$1ed238bb6ea1dd47 = $8fc4abc25197f241$var$g1_256;

});


parcelRegister("e6IrM", function(module, exports) {
"use strict";

var $bxKYQ = parcelRequire("bxKYQ");

var $6tIqG = parcelRequire("6tIqG");
function $a4541a7e4b763d42$var$SHA224() {
    if (!(this instanceof $a4541a7e4b763d42$var$SHA224)) return new $a4541a7e4b763d42$var$SHA224();
    $6tIqG.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$bxKYQ.inherits($a4541a7e4b763d42$var$SHA224, $6tIqG);
module.exports = $a4541a7e4b763d42$var$SHA224;
$a4541a7e4b763d42$var$SHA224.blockSize = 512;
$a4541a7e4b763d42$var$SHA224.outSize = 224;
$a4541a7e4b763d42$var$SHA224.hmacStrength = 192;
$a4541a7e4b763d42$var$SHA224.padLength = 64;
$a4541a7e4b763d42$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === "hex") return $bxKYQ.toHex32(this.h.slice(0, 7), "big");
    else return $bxKYQ.split32(this.h.slice(0, 7), "big");
};

});
parcelRegister("6tIqG", function(module, exports) {
"use strict";

var $bxKYQ = parcelRequire("bxKYQ");

var $hImYp = parcelRequire("hImYp");

var $clh35 = parcelRequire("clh35");

var $7WVV2 = parcelRequire("7WVV2");
var $4b77ea42209547a5$var$sum32 = $bxKYQ.sum32;
var $4b77ea42209547a5$var$sum32_4 = $bxKYQ.sum32_4;
var $4b77ea42209547a5$var$sum32_5 = $bxKYQ.sum32_5;
var $4b77ea42209547a5$var$ch32 = $clh35.ch32;
var $4b77ea42209547a5$var$maj32 = $clh35.maj32;
var $4b77ea42209547a5$var$s0_256 = $clh35.s0_256;
var $4b77ea42209547a5$var$s1_256 = $clh35.s1_256;
var $4b77ea42209547a5$var$g0_256 = $clh35.g0_256;
var $4b77ea42209547a5$var$g1_256 = $clh35.g1_256;
var $4b77ea42209547a5$var$BlockHash = $hImYp.BlockHash;
var $4b77ea42209547a5$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $4b77ea42209547a5$var$SHA256() {
    if (!(this instanceof $4b77ea42209547a5$var$SHA256)) return new $4b77ea42209547a5$var$SHA256();
    $4b77ea42209547a5$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $4b77ea42209547a5$var$sha256_K;
    this.W = new Array(64);
}
$bxKYQ.inherits($4b77ea42209547a5$var$SHA256, $4b77ea42209547a5$var$BlockHash);
module.exports = $4b77ea42209547a5$var$SHA256;
$4b77ea42209547a5$var$SHA256.blockSize = 512;
$4b77ea42209547a5$var$SHA256.outSize = 256;
$4b77ea42209547a5$var$SHA256.hmacStrength = 192;
$4b77ea42209547a5$var$SHA256.padLength = 64;
$4b77ea42209547a5$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $4b77ea42209547a5$var$sum32_4($4b77ea42209547a5$var$g1_256(W[i - 2]), W[i - 7], $4b77ea42209547a5$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $7WVV2(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $4b77ea42209547a5$var$sum32_5(h, $4b77ea42209547a5$var$s1_256(e), $4b77ea42209547a5$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $4b77ea42209547a5$var$sum32($4b77ea42209547a5$var$s0_256(a), $4b77ea42209547a5$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $4b77ea42209547a5$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $4b77ea42209547a5$var$sum32(T1, T2);
    }
    this.h[0] = $4b77ea42209547a5$var$sum32(this.h[0], a);
    this.h[1] = $4b77ea42209547a5$var$sum32(this.h[1], b);
    this.h[2] = $4b77ea42209547a5$var$sum32(this.h[2], c);
    this.h[3] = $4b77ea42209547a5$var$sum32(this.h[3], d);
    this.h[4] = $4b77ea42209547a5$var$sum32(this.h[4], e);
    this.h[5] = $4b77ea42209547a5$var$sum32(this.h[5], f);
    this.h[6] = $4b77ea42209547a5$var$sum32(this.h[6], g);
    this.h[7] = $4b77ea42209547a5$var$sum32(this.h[7], h);
};
$4b77ea42209547a5$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === "hex") return $bxKYQ.toHex32(this.h, "big");
    else return $bxKYQ.split32(this.h, "big");
};

});


parcelRegister("kmwi1", function(module, exports) {
"use strict";

var $bxKYQ = parcelRequire("bxKYQ");

var $bVmxl = parcelRequire("bVmxl");
function $ed2ee8cb8518db64$var$SHA384() {
    if (!(this instanceof $ed2ee8cb8518db64$var$SHA384)) return new $ed2ee8cb8518db64$var$SHA384();
    $bVmxl.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$bxKYQ.inherits($ed2ee8cb8518db64$var$SHA384, $bVmxl);
module.exports = $ed2ee8cb8518db64$var$SHA384;
$ed2ee8cb8518db64$var$SHA384.blockSize = 1024;
$ed2ee8cb8518db64$var$SHA384.outSize = 384;
$ed2ee8cb8518db64$var$SHA384.hmacStrength = 192;
$ed2ee8cb8518db64$var$SHA384.padLength = 128;
$ed2ee8cb8518db64$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === "hex") return $bxKYQ.toHex32(this.h.slice(0, 12), "big");
    else return $bxKYQ.split32(this.h.slice(0, 12), "big");
};

});
parcelRegister("bVmxl", function(module, exports) {
"use strict";

var $bxKYQ = parcelRequire("bxKYQ");

var $hImYp = parcelRequire("hImYp");

var $7WVV2 = parcelRequire("7WVV2");
var $8ae67ff153ff2587$var$rotr64_hi = $bxKYQ.rotr64_hi;
var $8ae67ff153ff2587$var$rotr64_lo = $bxKYQ.rotr64_lo;
var $8ae67ff153ff2587$var$shr64_hi = $bxKYQ.shr64_hi;
var $8ae67ff153ff2587$var$shr64_lo = $bxKYQ.shr64_lo;
var $8ae67ff153ff2587$var$sum64 = $bxKYQ.sum64;
var $8ae67ff153ff2587$var$sum64_hi = $bxKYQ.sum64_hi;
var $8ae67ff153ff2587$var$sum64_lo = $bxKYQ.sum64_lo;
var $8ae67ff153ff2587$var$sum64_4_hi = $bxKYQ.sum64_4_hi;
var $8ae67ff153ff2587$var$sum64_4_lo = $bxKYQ.sum64_4_lo;
var $8ae67ff153ff2587$var$sum64_5_hi = $bxKYQ.sum64_5_hi;
var $8ae67ff153ff2587$var$sum64_5_lo = $bxKYQ.sum64_5_lo;
var $8ae67ff153ff2587$var$BlockHash = $hImYp.BlockHash;
var $8ae67ff153ff2587$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $8ae67ff153ff2587$var$SHA512() {
    if (!(this instanceof $8ae67ff153ff2587$var$SHA512)) return new $8ae67ff153ff2587$var$SHA512();
    $8ae67ff153ff2587$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $8ae67ff153ff2587$var$sha512_K;
    this.W = new Array(160);
}
$bxKYQ.inherits($8ae67ff153ff2587$var$SHA512, $8ae67ff153ff2587$var$BlockHash);
module.exports = $8ae67ff153ff2587$var$SHA512;
$8ae67ff153ff2587$var$SHA512.blockSize = 1024;
$8ae67ff153ff2587$var$SHA512.outSize = 512;
$8ae67ff153ff2587$var$SHA512.hmacStrength = 192;
$8ae67ff153ff2587$var$SHA512.padLength = 128;
$8ae67ff153ff2587$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $8ae67ff153ff2587$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $8ae67ff153ff2587$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $8ae67ff153ff2587$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $8ae67ff153ff2587$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $8ae67ff153ff2587$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $8ae67ff153ff2587$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$8ae67ff153ff2587$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $7WVV2(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $8ae67ff153ff2587$var$s1_512_hi(eh, el);
        var c1_lo = $8ae67ff153ff2587$var$s1_512_lo(eh, el);
        var c2_hi = $8ae67ff153ff2587$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $8ae67ff153ff2587$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $8ae67ff153ff2587$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $8ae67ff153ff2587$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $8ae67ff153ff2587$var$s0_512_hi(ah, al);
        c0_lo = $8ae67ff153ff2587$var$s0_512_lo(ah, al);
        c1_hi = $8ae67ff153ff2587$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $8ae67ff153ff2587$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $8ae67ff153ff2587$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $8ae67ff153ff2587$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $8ae67ff153ff2587$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $8ae67ff153ff2587$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $8ae67ff153ff2587$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $8ae67ff153ff2587$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $8ae67ff153ff2587$var$sum64(this.h, 0, ah, al);
    $8ae67ff153ff2587$var$sum64(this.h, 2, bh, bl);
    $8ae67ff153ff2587$var$sum64(this.h, 4, ch, cl);
    $8ae67ff153ff2587$var$sum64(this.h, 6, dh, dl);
    $8ae67ff153ff2587$var$sum64(this.h, 8, eh, el);
    $8ae67ff153ff2587$var$sum64(this.h, 10, fh, fl);
    $8ae67ff153ff2587$var$sum64(this.h, 12, gh, gl);
    $8ae67ff153ff2587$var$sum64(this.h, 14, hh, hl);
};
$8ae67ff153ff2587$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === "hex") return $bxKYQ.toHex32(this.h, "big");
    else return $bxKYQ.split32(this.h, "big");
};
function $8ae67ff153ff2587$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $8ae67ff153ff2587$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $8ae67ff153ff2587$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $8ae67ff153ff2587$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $8ae67ff153ff2587$var$s0_512_hi(xh, xl) {
    var c0_hi = $8ae67ff153ff2587$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $8ae67ff153ff2587$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $8ae67ff153ff2587$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $8ae67ff153ff2587$var$s0_512_lo(xh, xl) {
    var c0_lo = $8ae67ff153ff2587$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $8ae67ff153ff2587$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $8ae67ff153ff2587$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $8ae67ff153ff2587$var$s1_512_hi(xh, xl) {
    var c0_hi = $8ae67ff153ff2587$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $8ae67ff153ff2587$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $8ae67ff153ff2587$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $8ae67ff153ff2587$var$s1_512_lo(xh, xl) {
    var c0_lo = $8ae67ff153ff2587$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $8ae67ff153ff2587$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $8ae67ff153ff2587$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $8ae67ff153ff2587$var$g0_512_hi(xh, xl) {
    var c0_hi = $8ae67ff153ff2587$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $8ae67ff153ff2587$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $8ae67ff153ff2587$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $8ae67ff153ff2587$var$g0_512_lo(xh, xl) {
    var c0_lo = $8ae67ff153ff2587$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $8ae67ff153ff2587$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $8ae67ff153ff2587$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $8ae67ff153ff2587$var$g1_512_hi(xh, xl) {
    var c0_hi = $8ae67ff153ff2587$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $8ae67ff153ff2587$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $8ae67ff153ff2587$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $8ae67ff153ff2587$var$g1_512_lo(xh, xl) {
    var c0_lo = $8ae67ff153ff2587$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $8ae67ff153ff2587$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $8ae67ff153ff2587$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRegister("6xyjW", function(module, exports) {

$parcel$export(module.exports, "ripemd160", function () { return $4c3072866331e23e$export$d1cea0ee4e3f0d3e; }, function (v) { return $4c3072866331e23e$export$d1cea0ee4e3f0d3e = v; });
var $4c3072866331e23e$export$d1cea0ee4e3f0d3e;
"use strict";

var $bxKYQ = parcelRequire("bxKYQ");

var $hImYp = parcelRequire("hImYp");
var $4c3072866331e23e$var$rotl32 = $bxKYQ.rotl32;
var $4c3072866331e23e$var$sum32 = $bxKYQ.sum32;
var $4c3072866331e23e$var$sum32_3 = $bxKYQ.sum32_3;
var $4c3072866331e23e$var$sum32_4 = $bxKYQ.sum32_4;
var $4c3072866331e23e$var$BlockHash = $hImYp.BlockHash;
function $4c3072866331e23e$var$RIPEMD160() {
    if (!(this instanceof $4c3072866331e23e$var$RIPEMD160)) return new $4c3072866331e23e$var$RIPEMD160();
    $4c3072866331e23e$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = "little";
}
$bxKYQ.inherits($4c3072866331e23e$var$RIPEMD160, $4c3072866331e23e$var$BlockHash);
$4c3072866331e23e$export$d1cea0ee4e3f0d3e = $4c3072866331e23e$var$RIPEMD160;
$4c3072866331e23e$var$RIPEMD160.blockSize = 512;
$4c3072866331e23e$var$RIPEMD160.outSize = 160;
$4c3072866331e23e$var$RIPEMD160.hmacStrength = 192;
$4c3072866331e23e$var$RIPEMD160.padLength = 64;
$4c3072866331e23e$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $4c3072866331e23e$var$sum32($4c3072866331e23e$var$rotl32($4c3072866331e23e$var$sum32_4(A, $4c3072866331e23e$var$f(j, B, C, D), msg[$4c3072866331e23e$var$r[j] + start], $4c3072866331e23e$var$K(j)), $4c3072866331e23e$var$s[j]), E);
        A = E;
        E = D;
        D = $4c3072866331e23e$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $4c3072866331e23e$var$sum32($4c3072866331e23e$var$rotl32($4c3072866331e23e$var$sum32_4(Ah, $4c3072866331e23e$var$f(79 - j, Bh, Ch, Dh), msg[$4c3072866331e23e$var$rh[j] + start], $4c3072866331e23e$var$Kh(j)), $4c3072866331e23e$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $4c3072866331e23e$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $4c3072866331e23e$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $4c3072866331e23e$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $4c3072866331e23e$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $4c3072866331e23e$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $4c3072866331e23e$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$4c3072866331e23e$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === "hex") return $bxKYQ.toHex32(this.h, "little");
    else return $bxKYQ.split32(this.h, "little");
};
function $4c3072866331e23e$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $4c3072866331e23e$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $4c3072866331e23e$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $4c3072866331e23e$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $4c3072866331e23e$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $4c3072866331e23e$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $4c3072866331e23e$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRegister("cMrGk", function(module, exports) {
"use strict";

var $bxKYQ = parcelRequire("bxKYQ");

var $7WVV2 = parcelRequire("7WVV2");
function $94df70b96f2baa06$var$Hmac(hash, key, enc) {
    if (!(this instanceof $94df70b96f2baa06$var$Hmac)) return new $94df70b96f2baa06$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($bxKYQ.toArray(key, enc));
}
module.exports = $94df70b96f2baa06$var$Hmac;
$94df70b96f2baa06$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $7WVV2(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$94df70b96f2baa06$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$94df70b96f2baa06$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});


parcelRegister("9TncA", function(module, exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
                "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
            ],
            [
                "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
                "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
            ],
            [
                "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
                "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
            ],
            [
                "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
                "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
            ],
            [
                "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
                "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
            ],
            [
                "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
                "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
            ],
            [
                "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
                "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
            ],
            [
                "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
                "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
            ],
            [
                "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
                "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
            ],
            [
                "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
                "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
            ],
            [
                "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
                "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
            ],
            [
                "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
                "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
            ],
            [
                "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
                "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
            ],
            [
                "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
                "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
            ],
            [
                "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
                "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
            ],
            [
                "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
                "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
            ],
            [
                "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
                "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
            ],
            [
                "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
                "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
            ],
            [
                "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
                "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
            ],
            [
                "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
                "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
            ],
            [
                "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
                "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
            ],
            [
                "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
                "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
            ],
            [
                "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
                "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
            ],
            [
                "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
                "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
            ],
            [
                "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
                "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
            ],
            [
                "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
                "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
            ],
            [
                "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
                "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
            ],
            [
                "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
                "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
            ],
            [
                "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
                "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
            ],
            [
                "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
                "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
            ],
            [
                "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
                "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
            ],
            [
                "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
                "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
            ],
            [
                "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
                "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
            ],
            [
                "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
                "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
            ],
            [
                "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
                "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
            ],
            [
                "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
                "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
            ],
            [
                "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
                "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
            ],
            [
                "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
                "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
            ],
            [
                "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
                "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
            ],
            [
                "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
                "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
            ],
            [
                "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
                "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
            ],
            [
                "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
                "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
            ],
            [
                "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
                "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
            ],
            [
                "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
                "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
            ],
            [
                "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
                "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
            ],
            [
                "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
                "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
            ],
            [
                "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
                "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
            ],
            [
                "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
                "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
            ],
            [
                "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
                "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
            ],
            [
                "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
                "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
            ],
            [
                "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
                "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
            ],
            [
                "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
                "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
            ],
            [
                "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
                "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
            ],
            [
                "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
                "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
            ],
            [
                "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
                "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
            ],
            [
                "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
                "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
            ],
            [
                "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
                "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
            ],
            [
                "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
                "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
            ],
            [
                "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
                "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
            ],
            [
                "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
                "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
            ],
            [
                "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
                "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
            ],
            [
                "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
                "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
            ],
            [
                "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
                "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
            ],
            [
                "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
                "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
            ],
            [
                "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
                "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
                "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
            ],
            [
                "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
                "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
            ],
            [
                "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
                "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
            ],
            [
                "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
                "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
            ],
            [
                "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
                "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
            ],
            [
                "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
                "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
            ],
            [
                "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
                "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
            ],
            [
                "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
                "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
            ],
            [
                "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
                "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
            ],
            [
                "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
                "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
            ],
            [
                "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
                "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
            ],
            [
                "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
                "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
            ],
            [
                "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
                "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
            ],
            [
                "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
                "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
            ],
            [
                "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
                "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
            ],
            [
                "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
                "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
            ],
            [
                "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
                "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
            ],
            [
                "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
                "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
            ],
            [
                "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
                "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
            ],
            [
                "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
                "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
            ],
            [
                "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
                "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
            ],
            [
                "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
                "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
            ],
            [
                "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
                "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
            ],
            [
                "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
                "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
            ],
            [
                "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
                "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
            ],
            [
                "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
                "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
            ],
            [
                "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
                "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
            ],
            [
                "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
                "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
            ],
            [
                "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
                "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
            ],
            [
                "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
                "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
            ],
            [
                "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
                "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
            ],
            [
                "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
                "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
            ],
            [
                "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
                "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
            ],
            [
                "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
                "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
            ],
            [
                "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
                "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
            ],
            [
                "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
                "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
            ],
            [
                "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
                "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
            ],
            [
                "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
                "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
            ],
            [
                "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
                "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
            ],
            [
                "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
                "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
            ],
            [
                "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
                "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
            ],
            [
                "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
                "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
            ],
            [
                "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
                "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
            ],
            [
                "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
                "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
            ],
            [
                "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
                "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
            ],
            [
                "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
                "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
            ],
            [
                "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
                "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
            ],
            [
                "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
                "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
            ],
            [
                "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
                "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
            ],
            [
                "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
                "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
            ],
            [
                "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
                "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
            ],
            [
                "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
                "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
            ],
            [
                "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
                "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
            ],
            [
                "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
                "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
            ],
            [
                "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
                "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
            ],
            [
                "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
                "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
            ],
            [
                "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
                "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
            ],
            [
                "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
                "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
            ],
            [
                "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
                "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
            ],
            [
                "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
                "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
            ],
            [
                "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
                "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
            ],
            [
                "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
                "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
            ],
            [
                "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
                "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
            ],
            [
                "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
                "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
            ],
            [
                "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
                "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
            ],
            [
                "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
                "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
            ],
            [
                "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
                "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
            ],
            [
                "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
                "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
            ],
            [
                "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
                "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
            ],
            [
                "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
                "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
            ],
            [
                "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
                "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
            ],
            [
                "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
                "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
            ],
            [
                "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
                "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
            ],
            [
                "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
                "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
            ],
            [
                "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
                "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
            ],
            [
                "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
                "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
            ],
            [
                "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
                "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
            ],
            [
                "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
                "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
            ],
            [
                "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
                "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
            ],
            [
                "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
                "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
            ],
            [
                "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
                "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
            ],
            [
                "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
                "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
            ],
            [
                "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
                "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
            ],
            [
                "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
                "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
            ],
            [
                "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
                "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
            ],
            [
                "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
                "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
            ],
            [
                "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
                "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
            ],
            [
                "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
                "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
            ],
            [
                "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
                "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
            ],
            [
                "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
                "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
            ],
            [
                "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
                "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
            ],
            [
                "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
                "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
            ],
            [
                "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
                "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
            ],
            [
                "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
                "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
            ],
            [
                "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
                "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
            ],
            [
                "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
                "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
            ],
            [
                "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
                "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
            ],
            [
                "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
                "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
            ],
            [
                "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
                "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
            ],
            [
                "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
                "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
            ],
            [
                "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
                "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
            ],
            [
                "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
                "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
            ],
            [
                "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
                "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
            ],
            [
                "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
                "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
            ],
            [
                "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
                "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
            ],
            [
                "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
                "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
            ],
            [
                "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
                "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
            ],
            [
                "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
                "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
            ],
            [
                "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
                "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
            ],
            [
                "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
                "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
            ],
            [
                "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
                "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
            ],
            [
                "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
                "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
            ],
            [
                "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
                "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
            ],
            [
                "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
                "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
            ],
            [
                "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
                "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
            ],
            [
                "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
                "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
            ],
            [
                "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
                "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
            ],
            [
                "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
                "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
            ],
            [
                "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
                "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
            ],
            [
                "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
                "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
            ],
            [
                "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
                "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
            ],
            [
                "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
                "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
            ],
            [
                "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
                "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
            ],
            [
                "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
                "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
            ],
            [
                "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
                "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
            ],
            [
                "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
                "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
            ],
            [
                "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
                "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
            ]
        ]
    }
};

});


parcelRegister("fGaGJ", function(module, exports) {
"use strict";

var $blRDm = parcelRequire("blRDm");

var $4ICjl = parcelRequire("4ICjl");

var $4OvZ4 = parcelRequire("4OvZ4");

var $dG5bA = parcelRequire("dG5bA");

var $iuHvy = parcelRequire("iuHvy");
var $b6a311b8d0e8cc20$var$assert = $4OvZ4.assert;

var $c6vd1 = parcelRequire("c6vd1");

var $kJete = parcelRequire("kJete");
function $b6a311b8d0e8cc20$var$EC(options) {
    if (!(this instanceof $b6a311b8d0e8cc20$var$EC)) return new $b6a311b8d0e8cc20$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === "string") {
        $b6a311b8d0e8cc20$var$assert(Object.prototype.hasOwnProperty.call($dG5bA, options), "Unknown curve " + options);
        options = $dG5bA[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $dG5bA.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = $b6a311b8d0e8cc20$var$EC;
$b6a311b8d0e8cc20$var$EC.prototype.keyPair = function keyPair(options) {
    return new $c6vd1(this, options);
};
$b6a311b8d0e8cc20$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $c6vd1.fromPrivate(this, priv, enc);
};
$b6a311b8d0e8cc20$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $c6vd1.fromPublic(this, pub, enc);
};
$b6a311b8d0e8cc20$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $4ICjl({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || "utf8",
        entropy: options.entropy || $iuHvy(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || "utf8",
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new $blRDm(2));
    for(;;){
        var priv = new $blRDm(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$b6a311b8d0e8cc20$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
    var delta = msg.byteLength() * 8 - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$b6a311b8d0e8cc20$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === "object") {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(new $blRDm(msg, 16));
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray("be", bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray("be", bytes);
    // Instantiate Hmac_DRBG
    var drbg = new $4ICjl({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || "utf8"
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new $blRDm(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new $blRDm(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $kJete({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$b6a311b8d0e8cc20$var$EC.prototype.verify = function verify(msg, signature, key, enc) {
    msg = this._truncateToN(new $blRDm(msg, 16));
    key = this.keyFromPublic(key, enc);
    signature = new $kJete(signature, "hex");
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$b6a311b8d0e8cc20$var$EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    $b6a311b8d0e8cc20$var$assert((3 & j) === j, "The recovery param is more than two bits");
    signature = new $kJete(signature, enc);
    var n = this.n;
    var e = new $blRDm(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error("Unable to find sencond key candinate");
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$b6a311b8d0e8cc20$var$EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new $kJete(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error("Unable to find valid recovery factor");
};

});
parcelRegister("4ICjl", function(module, exports) {
"use strict";

var $2eq8E = parcelRequire("2eq8E");

var $dAFlY = parcelRequire("dAFlY");

var $7WVV2 = parcelRequire("7WVV2");
function $36f8fd3aefd3d562$var$HmacDRBG(options) {
    if (!(this instanceof $36f8fd3aefd3d562$var$HmacDRBG)) return new $36f8fd3aefd3d562$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $dAFlY.toArray(options.entropy, options.entropyEnc || "hex");
    var nonce = $dAFlY.toArray(options.nonce, options.nonceEnc || "hex");
    var pers = $dAFlY.toArray(options.pers, options.persEnc || "hex");
    $7WVV2(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._init(entropy, nonce, pers);
}
module.exports = $36f8fd3aefd3d562$var$HmacDRBG;
$36f8fd3aefd3d562$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$36f8fd3aefd3d562$var$HmacDRBG.prototype._hmac = function hmac() {
    return new $2eq8E.hmac(this.hash, this.K);
};
$36f8fd3aefd3d562$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$36f8fd3aefd3d562$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== "string") {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $dAFlY.toArray(entropy, entropyEnc);
    add = $dAFlY.toArray(add, addEnc);
    $7WVV2(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$36f8fd3aefd3d562$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
    // Optional encoding
    if (typeof enc !== "string") {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $dAFlY.toArray(add, addEnc || "hex");
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $dAFlY.encode(res, enc);
};

});

parcelRegister("c6vd1", function(module, exports) {
"use strict";

var $blRDm = parcelRequire("blRDm");

var $4OvZ4 = parcelRequire("4OvZ4");
var $8cfe410d5ce89c9a$var$assert = $4OvZ4.assert;
function $8cfe410d5ce89c9a$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = $8cfe410d5ce89c9a$var$KeyPair;
$8cfe410d5ce89c9a$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $8cfe410d5ce89c9a$var$KeyPair) return pub;
    return new $8cfe410d5ce89c9a$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$8cfe410d5ce89c9a$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $8cfe410d5ce89c9a$var$KeyPair) return priv;
    return new $8cfe410d5ce89c9a$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$8cfe410d5ce89c9a$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: "Invalid public key"
    };
    if (!pub.validate()) return {
        result: false,
        reason: "Public key is not a point"
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: "Public key * N != O"
    };
    return {
        result: true,
        reason: null
    };
};
$8cfe410d5ce89c9a$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === "string") {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$8cfe410d5ce89c9a$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === "hex") return this.priv.toString(16, 2);
    else return this.priv;
};
$8cfe410d5ce89c9a$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new $blRDm(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$8cfe410d5ce89c9a$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === "mont") $8cfe410d5ce89c9a$var$assert(key.x, "Need x coordinate");
        else if (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") $8cfe410d5ce89c9a$var$assert(key.x && key.y, "Need both x and y coordinate");
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$8cfe410d5ce89c9a$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $8cfe410d5ce89c9a$var$assert(pub.validate(), "public point not validated");
    return pub.mul(this.priv).getX();
};
// ECDSA
$8cfe410d5ce89c9a$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$8cfe410d5ce89c9a$var$KeyPair.prototype.verify = function verify(msg, signature) {
    return this.ec.verify(msg, signature, this);
};
$8cfe410d5ce89c9a$var$KeyPair.prototype.inspect = function inspect() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};

});

parcelRegister("kJete", function(module, exports) {
"use strict";

var $blRDm = parcelRequire("blRDm");

var $4OvZ4 = parcelRequire("4OvZ4");
var $f1733c287b88a42d$var$assert = $4OvZ4.assert;
function $f1733c287b88a42d$var$Signature(options, enc) {
    if (options instanceof $f1733c287b88a42d$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $f1733c287b88a42d$var$assert(options.r && options.s, "Signature without r or s");
    this.r = new $blRDm(options.r, 16);
    this.s = new $blRDm(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = $f1733c287b88a42d$var$Signature;
function $f1733c287b88a42d$var$Position() {
    this.place = 0;
}
function $f1733c287b88a42d$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $f1733c287b88a42d$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$f1733c287b88a42d$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $4OvZ4.toArray(data, enc);
    var p = new $f1733c287b88a42d$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $f1733c287b88a42d$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $f1733c287b88a42d$var$getLength(data, p);
    if (rlen === false) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $f1733c287b88a42d$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new $blRDm(r);
    this.s = new $blRDm(s);
    this.recoveryParam = null;
    return true;
};
function $f1733c287b88a42d$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$f1733c287b88a42d$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $f1733c287b88a42d$var$rmPadding(r);
    s = $f1733c287b88a42d$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $f1733c287b88a42d$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $f1733c287b88a42d$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $f1733c287b88a42d$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $4OvZ4.encode(res, enc);
};

});


parcelRegister("h9ZEV", function(module, exports) {
"use strict";

var $2eq8E = parcelRequire("2eq8E");

var $dG5bA = parcelRequire("dG5bA");

var $4OvZ4 = parcelRequire("4OvZ4");
var $c7e31b1f62dd2632$var$assert = $4OvZ4.assert;
var $c7e31b1f62dd2632$var$parseBytes = $4OvZ4.parseBytes;

var $4Y9Yr = parcelRequire("4Y9Yr");

var $9muLt = parcelRequire("9muLt");
function $c7e31b1f62dd2632$var$EDDSA(curve) {
    $c7e31b1f62dd2632$var$assert(curve === "ed25519", "only tested with ed25519 so far");
    if (!(this instanceof $c7e31b1f62dd2632$var$EDDSA)) return new $c7e31b1f62dd2632$var$EDDSA(curve);
    curve = $dG5bA[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = $2eq8E.sha512;
}
module.exports = $c7e31b1f62dd2632$var$EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ $c7e31b1f62dd2632$var$EDDSA.prototype.sign = function sign(message, secret) {
    message = $c7e31b1f62dd2632$var$parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ $c7e31b1f62dd2632$var$EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = $c7e31b1f62dd2632$var$parseBytes(message);
    sig = this.makeSignature(sig);
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
$c7e31b1f62dd2632$var$EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return $4OvZ4.intFromLE(hash.digest()).umod(this.curve.n);
};
$c7e31b1f62dd2632$var$EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return $4Y9Yr.fromPublic(this, pub);
};
$c7e31b1f62dd2632$var$EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return $4Y9Yr.fromSecret(this, secret);
};
$c7e31b1f62dd2632$var$EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof $9muLt) return sig;
    return new $9muLt(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ $c7e31b1f62dd2632$var$EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray("le", this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
$c7e31b1f62dd2632$var$EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = $4OvZ4.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = $4OvZ4.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
$c7e31b1f62dd2632$var$EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray("le", this.encodingLength);
};
$c7e31b1f62dd2632$var$EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return $4OvZ4.intFromLE(bytes);
};
$c7e31b1f62dd2632$var$EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

});
parcelRegister("4Y9Yr", function(module, exports) {
"use strict";

var $4OvZ4 = parcelRequire("4OvZ4");
var $39e480a1bf1698dd$var$assert = $4OvZ4.assert;
var $39e480a1bf1698dd$var$parseBytes = $4OvZ4.parseBytes;
var $39e480a1bf1698dd$var$cachedProperty = $4OvZ4.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function $39e480a1bf1698dd$var$KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = $39e480a1bf1698dd$var$parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = $39e480a1bf1698dd$var$parseBytes(params.pub);
}
$39e480a1bf1698dd$var$KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof $39e480a1bf1698dd$var$KeyPair) return pub;
    return new $39e480a1bf1698dd$var$KeyPair(eddsa, {
        pub: pub
    });
};
$39e480a1bf1698dd$var$KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof $39e480a1bf1698dd$var$KeyPair) return secret;
    return new $39e480a1bf1698dd$var$KeyPair(eddsa, {
        secret: secret
    });
};
$39e480a1bf1698dd$var$KeyPair.prototype.secret = function secret() {
    return this._secret;
};
$39e480a1bf1698dd$var$cachedProperty($39e480a1bf1698dd$var$KeyPair, "pubBytes", function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
$39e480a1bf1698dd$var$cachedProperty($39e480a1bf1698dd$var$KeyPair, "pub", function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
$39e480a1bf1698dd$var$cachedProperty($39e480a1bf1698dd$var$KeyPair, "privBytes", function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
$39e480a1bf1698dd$var$cachedProperty($39e480a1bf1698dd$var$KeyPair, "priv", function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
$39e480a1bf1698dd$var$cachedProperty($39e480a1bf1698dd$var$KeyPair, "hash", function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
$39e480a1bf1698dd$var$cachedProperty($39e480a1bf1698dd$var$KeyPair, "messagePrefix", function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
$39e480a1bf1698dd$var$KeyPair.prototype.sign = function sign(message) {
    $39e480a1bf1698dd$var$assert(this._secret, "KeyPair can only verify");
    return this.eddsa.sign(message, this);
};
$39e480a1bf1698dd$var$KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
$39e480a1bf1698dd$var$KeyPair.prototype.getSecret = function getSecret(enc) {
    $39e480a1bf1698dd$var$assert(this._secret, "KeyPair is public only");
    return $4OvZ4.encode(this.secret(), enc);
};
$39e480a1bf1698dd$var$KeyPair.prototype.getPublic = function getPublic(enc) {
    return $4OvZ4.encode(this.pubBytes(), enc);
};
module.exports = $39e480a1bf1698dd$var$KeyPair;

});

parcelRegister("9muLt", function(module, exports) {
"use strict";

var $blRDm = parcelRequire("blRDm");

var $4OvZ4 = parcelRequire("4OvZ4");
var $6d0e08567e95a27b$var$assert = $4OvZ4.assert;
var $6d0e08567e95a27b$var$cachedProperty = $4OvZ4.cachedProperty;
var $6d0e08567e95a27b$var$parseBytes = $4OvZ4.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function $6d0e08567e95a27b$var$Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== "object") sig = $6d0e08567e95a27b$var$parseBytes(sig);
    if (Array.isArray(sig)) sig = {
        R: sig.slice(0, eddsa.encodingLength),
        S: sig.slice(eddsa.encodingLength)
    };
    $6d0e08567e95a27b$var$assert(sig.R && sig.S, "Signature without R or S");
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof $blRDm) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
$6d0e08567e95a27b$var$cachedProperty($6d0e08567e95a27b$var$Signature, "S", function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
$6d0e08567e95a27b$var$cachedProperty($6d0e08567e95a27b$var$Signature, "R", function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
$6d0e08567e95a27b$var$cachedProperty($6d0e08567e95a27b$var$Signature, "Rencoded", function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
$6d0e08567e95a27b$var$cachedProperty($6d0e08567e95a27b$var$Signature, "Sencoded", function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
$6d0e08567e95a27b$var$Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
$6d0e08567e95a27b$var$Signature.prototype.toHex = function toHex() {
    return $4OvZ4.encode(this.toBytes(), "hex").toUpperCase();
};
module.exports = $6d0e08567e95a27b$var$Signature;

});



parcelRegister("7qixM", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function TempCtor() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("9dH9K")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("gBWPR", function(module, exports) {

var $gCOZA = parcelRequire("gCOZA");

var $5ALlJ = parcelRequire("5ALlJ");

var $dhIis = parcelRequire("dhIis");

var $aRQ6l = parcelRequire("aRQ6l");

var $deQJE = parcelRequire("deQJE");

var $f6JDE = parcelRequire("f6JDE");
var $c17dbd8f59a0a3b0$require$Buffer = $f6JDE.Buffer;
module.exports = $c17dbd8f59a0a3b0$var$parseKeys;
function $c17dbd8f59a0a3b0$var$parseKeys(buffer) {
    var password;
    if (typeof buffer === "object" && !$c17dbd8f59a0a3b0$require$Buffer.isBuffer(buffer)) {
        password = buffer.passphrase;
        buffer = buffer.key;
    }
    if (typeof buffer === "string") buffer = $c17dbd8f59a0a3b0$require$Buffer.from(buffer);
    var stripped = $dhIis(buffer, password);
    var type = stripped.tag;
    var data = stripped.data;
    var subtype, ndata;
    switch(type){
        case "CERTIFICATE":
            ndata = $gCOZA.certificate.decode(data, "der").tbsCertificate.subjectPublicKeyInfo;
        // falls through
        case "PUBLIC KEY":
            if (!ndata) ndata = $gCOZA.PublicKey.decode(data, "der");
            subtype = ndata.algorithm.algorithm.join(".");
            switch(subtype){
                case "1.2.840.113549.1.1.1":
                    return $gCOZA.RSAPublicKey.decode(ndata.subjectPublicKey.data, "der");
                case "1.2.840.10045.2.1":
                    ndata.subjectPrivateKey = ndata.subjectPublicKey;
                    return {
                        type: "ec",
                        data: ndata
                    };
                case "1.2.840.10040.4.1":
                    ndata.algorithm.params.pub_key = $gCOZA.DSAparam.decode(ndata.subjectPublicKey.data, "der");
                    return {
                        type: "dsa",
                        data: ndata.algorithm.params
                    };
                default:
                    throw new Error("unknown key id " + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case "ENCRYPTED PRIVATE KEY":
            data = $gCOZA.EncryptedPrivateKey.decode(data, "der");
            data = $c17dbd8f59a0a3b0$var$decrypt(data, password);
        // falls through
        case "PRIVATE KEY":
            ndata = $gCOZA.PrivateKey.decode(data, "der");
            subtype = ndata.algorithm.algorithm.join(".");
            switch(subtype){
                case "1.2.840.113549.1.1.1":
                    return $gCOZA.RSAPrivateKey.decode(ndata.subjectPrivateKey, "der");
                case "1.2.840.10045.2.1":
                    return {
                        curve: ndata.algorithm.curve,
                        privateKey: $gCOZA.ECPrivateKey.decode(ndata.subjectPrivateKey, "der").privateKey
                    };
                case "1.2.840.10040.4.1":
                    ndata.algorithm.params.priv_key = $gCOZA.DSAparam.decode(ndata.subjectPrivateKey, "der");
                    return {
                        type: "dsa",
                        params: ndata.algorithm.params
                    };
                default:
                    throw new Error("unknown key id " + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case "RSA PUBLIC KEY":
            return $gCOZA.RSAPublicKey.decode(data, "der");
        case "RSA PRIVATE KEY":
            return $gCOZA.RSAPrivateKey.decode(data, "der");
        case "DSA PRIVATE KEY":
            return {
                type: "dsa",
                params: $gCOZA.DSAPrivateKey.decode(data, "der")
            };
        case "EC PRIVATE KEY":
            data = $gCOZA.ECPrivateKey.decode(data, "der");
            return {
                curve: data.parameters.value,
                privateKey: data.privateKey
            };
        default:
            throw new Error("unknown key type " + type);
    }
}
$c17dbd8f59a0a3b0$var$parseKeys.signature = $gCOZA.signature;
function $c17dbd8f59a0a3b0$var$decrypt(data, password) {
    var salt = data.algorithm.decrypt.kde.kdeparams.salt;
    var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
    var algo = $5ALlJ[data.algorithm.decrypt.cipher.algo.join(".")];
    var iv = data.algorithm.decrypt.cipher.iv;
    var cipherText = data.subjectPrivateKey;
    var keylen = parseInt(algo.split("-")[1], 10) / 8;
    var key = $deQJE.pbkdf2Sync(password, salt, iters, keylen, "sha1");
    var cipher = $aRQ6l.createDecipheriv(algo, key, iv);
    var out = [];
    out.push(cipher.update(cipherText));
    out.push(cipher.final());
    return $c17dbd8f59a0a3b0$require$Buffer.concat(out);
}

});
parcelRegister("gCOZA", function(module, exports) {

$parcel$export(module.exports, "certificate", function () { return $c1a7bff4ff62642f$export$c98397a6eb8d0678; }, function (v) { return $c1a7bff4ff62642f$export$c98397a6eb8d0678 = v; });
$parcel$export(module.exports, "RSAPrivateKey", function () { return $c1a7bff4ff62642f$export$f4aab6816f64fa6b; }, function (v) { return $c1a7bff4ff62642f$export$f4aab6816f64fa6b = v; });
$parcel$export(module.exports, "RSAPublicKey", function () { return $c1a7bff4ff62642f$export$4471f5c65d097c11; }, function (v) { return $c1a7bff4ff62642f$export$4471f5c65d097c11 = v; });
$parcel$export(module.exports, "PublicKey", function () { return $c1a7bff4ff62642f$export$ca8b6604d6ce14de; }, function (v) { return $c1a7bff4ff62642f$export$ca8b6604d6ce14de = v; });
$parcel$export(module.exports, "PrivateKey", function () { return $c1a7bff4ff62642f$export$8f54525b330fd87b; }, function (v) { return $c1a7bff4ff62642f$export$8f54525b330fd87b = v; });
$parcel$export(module.exports, "EncryptedPrivateKey", function () { return $c1a7bff4ff62642f$export$23cd2842b44ca3e7; }, function (v) { return $c1a7bff4ff62642f$export$23cd2842b44ca3e7 = v; });
$parcel$export(module.exports, "DSAPrivateKey", function () { return $c1a7bff4ff62642f$export$245c9aaa9f5ce4ce; }, function (v) { return $c1a7bff4ff62642f$export$245c9aaa9f5ce4ce = v; });
$parcel$export(module.exports, "DSAparam", function () { return $c1a7bff4ff62642f$export$8ad762e3e6399afe; }, function (v) { return $c1a7bff4ff62642f$export$8ad762e3e6399afe = v; });
$parcel$export(module.exports, "ECPrivateKey", function () { return $c1a7bff4ff62642f$export$32ef6f92e22c6ab0; }, function (v) { return $c1a7bff4ff62642f$export$32ef6f92e22c6ab0 = v; });
$parcel$export(module.exports, "signature", function () { return $c1a7bff4ff62642f$export$c9cd164b539ebb63; }, function (v) { return $c1a7bff4ff62642f$export$c9cd164b539ebb63 = v; });
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.
var $c1a7bff4ff62642f$export$c98397a6eb8d0678;
var $c1a7bff4ff62642f$export$f4aab6816f64fa6b;
var $c1a7bff4ff62642f$export$4471f5c65d097c11;
var $c1a7bff4ff62642f$export$ca8b6604d6ce14de;
var $c1a7bff4ff62642f$export$8f54525b330fd87b;
var $c1a7bff4ff62642f$export$23cd2842b44ca3e7;
var $c1a7bff4ff62642f$export$245c9aaa9f5ce4ce;
var $c1a7bff4ff62642f$export$8ad762e3e6399afe;
var $c1a7bff4ff62642f$export$32ef6f92e22c6ab0;
var $c1a7bff4ff62642f$export$c9cd164b539ebb63;
"use strict";

var $gUmgU = parcelRequire("gUmgU");

$c1a7bff4ff62642f$export$c98397a6eb8d0678 = (parcelRequire("ffLik"));
var $c1a7bff4ff62642f$var$RSAPrivateKey = $gUmgU.define("RSAPrivateKey", function() {
    this.seq().obj(this.key("version").int(), this.key("modulus").int(), this.key("publicExponent").int(), this.key("privateExponent").int(), this.key("prime1").int(), this.key("prime2").int(), this.key("exponent1").int(), this.key("exponent2").int(), this.key("coefficient").int());
});
$c1a7bff4ff62642f$export$f4aab6816f64fa6b = $c1a7bff4ff62642f$var$RSAPrivateKey;
var $c1a7bff4ff62642f$var$RSAPublicKey = $gUmgU.define("RSAPublicKey", function() {
    this.seq().obj(this.key("modulus").int(), this.key("publicExponent").int());
});
$c1a7bff4ff62642f$export$4471f5c65d097c11 = $c1a7bff4ff62642f$var$RSAPublicKey;
var $c1a7bff4ff62642f$var$PublicKey = $gUmgU.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(this.key("algorithm").use($c1a7bff4ff62642f$var$AlgorithmIdentifier), this.key("subjectPublicKey").bitstr());
});
$c1a7bff4ff62642f$export$ca8b6604d6ce14de = $c1a7bff4ff62642f$var$PublicKey;
var $c1a7bff4ff62642f$var$AlgorithmIdentifier = $gUmgU.define("AlgorithmIdentifier", function() {
    this.seq().obj(this.key("algorithm").objid(), this.key("none").null_().optional(), this.key("curve").objid().optional(), this.key("params").seq().obj(this.key("p").int(), this.key("q").int(), this.key("g").int()).optional());
});
var $c1a7bff4ff62642f$var$PrivateKeyInfo = $gUmgU.define("PrivateKeyInfo", function() {
    this.seq().obj(this.key("version").int(), this.key("algorithm").use($c1a7bff4ff62642f$var$AlgorithmIdentifier), this.key("subjectPrivateKey").octstr());
});
$c1a7bff4ff62642f$export$8f54525b330fd87b = $c1a7bff4ff62642f$var$PrivateKeyInfo;
var $c1a7bff4ff62642f$var$EncryptedPrivateKeyInfo = $gUmgU.define("EncryptedPrivateKeyInfo", function() {
    this.seq().obj(this.key("algorithm").seq().obj(this.key("id").objid(), this.key("decrypt").seq().obj(this.key("kde").seq().obj(this.key("id").objid(), this.key("kdeparams").seq().obj(this.key("salt").octstr(), this.key("iters").int())), this.key("cipher").seq().obj(this.key("algo").objid(), this.key("iv").octstr()))), this.key("subjectPrivateKey").octstr());
});
$c1a7bff4ff62642f$export$23cd2842b44ca3e7 = $c1a7bff4ff62642f$var$EncryptedPrivateKeyInfo;
var $c1a7bff4ff62642f$var$DSAPrivateKey = $gUmgU.define("DSAPrivateKey", function() {
    this.seq().obj(this.key("version").int(), this.key("p").int(), this.key("q").int(), this.key("g").int(), this.key("pub_key").int(), this.key("priv_key").int());
});
$c1a7bff4ff62642f$export$245c9aaa9f5ce4ce = $c1a7bff4ff62642f$var$DSAPrivateKey;
$c1a7bff4ff62642f$export$8ad762e3e6399afe = $gUmgU.define("DSAparam", function() {
    this.int();
});
var $c1a7bff4ff62642f$var$ECPrivateKey = $gUmgU.define("ECPrivateKey", function() {
    this.seq().obj(this.key("version").int(), this.key("privateKey").octstr(), this.key("parameters").optional().explicit(0).use($c1a7bff4ff62642f$var$ECParameters), this.key("publicKey").optional().explicit(1).bitstr());
});
$c1a7bff4ff62642f$export$32ef6f92e22c6ab0 = $c1a7bff4ff62642f$var$ECPrivateKey;
var $c1a7bff4ff62642f$var$ECParameters = $gUmgU.define("ECParameters", function() {
    this.choice({
        namedCurve: this.objid()
    });
});
$c1a7bff4ff62642f$export$c9cd164b539ebb63 = $gUmgU.define("signature", function() {
    this.seq().obj(this.key("r").int(), this.key("s").int());
});

});
parcelRegister("gUmgU", function(module, exports) {
"use strict";
var $c4f3270138095275$var$asn1 = module.exports;

$c4f3270138095275$var$asn1.bignum = (parcelRequire("blRDm"));

$c4f3270138095275$var$asn1.define = (parcelRequire("lydQD")).define;

$c4f3270138095275$var$asn1.base = (parcelRequire("bGIA7"));

$c4f3270138095275$var$asn1.constants = (parcelRequire("lSXPm"));

$c4f3270138095275$var$asn1.decoders = (parcelRequire("9XR9M"));

$c4f3270138095275$var$asn1.encoders = (parcelRequire("AkVFl"));

});
parcelRegister("lydQD", function(module, exports) {
"use strict";

var $AkVFl = parcelRequire("AkVFl");

var $9XR9M = parcelRequire("9XR9M");

var $hwgCU = parcelRequire("hwgCU");
var $fb0783da6b844faa$var$api = module.exports;
$fb0783da6b844faa$var$api.define = function define(name, body) {
    return new $fb0783da6b844faa$var$Entity(name, body);
};
function $fb0783da6b844faa$var$Entity(name, body) {
    this.name = name;
    this.body = body;
    this.decoders = {};
    this.encoders = {};
}
$fb0783da6b844faa$var$Entity.prototype._createNamed = function createNamed(Base) {
    var name = this.name;
    function Generated(entity) {
        this._initNamed(entity, name);
    }
    $hwgCU(Generated, Base);
    Generated.prototype._initNamed = function _initNamed(entity, name) {
        Base.call(this, entity, name);
    };
    return new Generated(this);
};
$fb0783da6b844faa$var$Entity.prototype._getDecoder = function _getDecoder(enc) {
    enc = enc || "der";
    // Lazily create decoder
    if (!this.decoders.hasOwnProperty(enc)) this.decoders[enc] = this._createNamed($9XR9M[enc]);
    return this.decoders[enc];
};
$fb0783da6b844faa$var$Entity.prototype.decode = function decode(data, enc, options) {
    return this._getDecoder(enc).decode(data, options);
};
$fb0783da6b844faa$var$Entity.prototype._getEncoder = function _getEncoder(enc) {
    enc = enc || "der";
    // Lazily create encoder
    if (!this.encoders.hasOwnProperty(enc)) this.encoders[enc] = this._createNamed($AkVFl[enc]);
    return this.encoders[enc];
};
$fb0783da6b844faa$var$Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
    return this._getEncoder(enc).encode(data, reporter);
};

});
parcelRegister("AkVFl", function(module, exports) {
"use strict";
var $06d398fd48d75df1$var$encoders = module.exports;

$06d398fd48d75df1$var$encoders.der = (parcelRequire("cno1D"));

$06d398fd48d75df1$var$encoders.pem = (parcelRequire("ac8XI"));

});
parcelRegister("cno1D", function(module, exports) {
"use strict";

var $hwgCU = parcelRequire("hwgCU");

var $lwNfX = parcelRequire("lwNfX");
var $902a44ef9d4a2e48$require$Buffer = $lwNfX.Buffer;

var $gF4FC = parcelRequire("gF4FC");

var $9CP3j = parcelRequire("9CP3j");
function $902a44ef9d4a2e48$var$DEREncoder(entity) {
    this.enc = "der";
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $902a44ef9d4a2e48$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $902a44ef9d4a2e48$var$DEREncoder;
$902a44ef9d4a2e48$var$DEREncoder.prototype.encode = function encode(data, reporter) {
    return this.tree._encode(data, reporter).join();
};
// Tree methods
function $902a44ef9d4a2e48$var$DERNode(parent) {
    $gF4FC.call(this, "der", parent);
}
$hwgCU($902a44ef9d4a2e48$var$DERNode, $gF4FC);
$902a44ef9d4a2e48$var$DERNode.prototype._encodeComposite = function encodeComposite(tag, primitive, cls, content) {
    var encodedTag = $902a44ef9d4a2e48$var$encodeTag(tag, primitive, cls, this.reporter);
    // Short form
    if (content.length < 0x80) {
        var header = $902a44ef9d4a2e48$require$Buffer.alloc(2);
        header[0] = encodedTag;
        header[1] = content.length;
        return this._createEncoderBuffer([
            header,
            content
        ]);
    }
    // Long form
    // Count octets required to store length
    var lenOctets = 1;
    for(var i = content.length; i >= 0x100; i >>= 8)lenOctets++;
    var header1 = $902a44ef9d4a2e48$require$Buffer.alloc(2 + lenOctets);
    header1[0] = encodedTag;
    header1[1] = 0x80 | lenOctets;
    for(var i1 = 1 + lenOctets, j = content.length; j > 0; i1--, j >>= 8)header1[i1] = j & 0xff;
    return this._createEncoderBuffer([
        header1,
        content
    ]);
};
$902a44ef9d4a2e48$var$DERNode.prototype._encodeStr = function encodeStr(str, tag) {
    if (tag === "bitstr") return this._createEncoderBuffer([
        str.unused | 0,
        str.data
    ]);
    else if (tag === "bmpstr") {
        var buf = $902a44ef9d4a2e48$require$Buffer.alloc(str.length * 2);
        for(var i = 0; i < str.length; i++)buf.writeUInt16BE(str.charCodeAt(i), i * 2);
        return this._createEncoderBuffer(buf);
    } else if (tag === "numstr") {
        if (!this._isNumstr(str)) return this.reporter.error("Encoding of string type: numstr supports only digits and space");
        return this._createEncoderBuffer(str);
    } else if (tag === "printstr") {
        if (!this._isPrintstr(str)) return this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark");
        return this._createEncoderBuffer(str);
    } else if (/str$/.test(tag)) return this._createEncoderBuffer(str);
    else if (tag === "objDesc") return this._createEncoderBuffer(str);
    else return this.reporter.error("Encoding of string type: " + tag + " unsupported");
};
$902a44ef9d4a2e48$var$DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
    if (typeof id === "string") {
        if (!values) return this.reporter.error("string objid given, but no values map found");
        if (!values.hasOwnProperty(id)) return this.reporter.error("objid not found in values map");
        id = values[id].split(/[\s.]+/g);
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    } else if (Array.isArray(id)) {
        id = id.slice();
        for(var i1 = 0; i1 < id.length; i1++)id[i1] |= 0;
    }
    if (!Array.isArray(id)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(id));
    if (!relative) {
        if (id[1] >= 40) return this.reporter.error("Second objid identifier OOB");
        id.splice(0, 2, id[0] * 40 + id[1]);
    }
    // Count number of octets
    var size = 0;
    for(var i2 = 0; i2 < id.length; i2++){
        var ident = id[i2];
        for(size++; ident >= 0x80; ident >>= 7)size++;
    }
    var objid = $902a44ef9d4a2e48$require$Buffer.alloc(size);
    var offset = objid.length - 1;
    for(var i3 = id.length - 1; i3 >= 0; i3--){
        var ident1 = id[i3];
        objid[offset--] = ident1 & 0x7f;
        while((ident1 >>= 7) > 0)objid[offset--] = 0x80 | ident1 & 0x7f;
    }
    return this._createEncoderBuffer(objid);
};
function $902a44ef9d4a2e48$var$two(num) {
    if (num < 10) return "0" + num;
    else return num;
}
$902a44ef9d4a2e48$var$DERNode.prototype._encodeTime = function encodeTime(time, tag) {
    var str;
    var date = new Date(time);
    if (tag === "gentime") str = [
        $902a44ef9d4a2e48$var$two(date.getUTCFullYear()),
        $902a44ef9d4a2e48$var$two(date.getUTCMonth() + 1),
        $902a44ef9d4a2e48$var$two(date.getUTCDate()),
        $902a44ef9d4a2e48$var$two(date.getUTCHours()),
        $902a44ef9d4a2e48$var$two(date.getUTCMinutes()),
        $902a44ef9d4a2e48$var$two(date.getUTCSeconds()),
        "Z"
    ].join("");
    else if (tag === "utctime") str = [
        $902a44ef9d4a2e48$var$two(date.getUTCFullYear() % 100),
        $902a44ef9d4a2e48$var$two(date.getUTCMonth() + 1),
        $902a44ef9d4a2e48$var$two(date.getUTCDate()),
        $902a44ef9d4a2e48$var$two(date.getUTCHours()),
        $902a44ef9d4a2e48$var$two(date.getUTCMinutes()),
        $902a44ef9d4a2e48$var$two(date.getUTCSeconds()),
        "Z"
    ].join("");
    else this.reporter.error("Encoding " + tag + " time is not supported yet");
    return this._encodeStr(str, "octstr");
};
$902a44ef9d4a2e48$var$DERNode.prototype._encodeNull = function encodeNull() {
    return this._createEncoderBuffer("");
};
$902a44ef9d4a2e48$var$DERNode.prototype._encodeInt = function encodeInt(num, values) {
    if (typeof num === "string") {
        if (!values) return this.reporter.error("String int or enum given, but no values map");
        if (!values.hasOwnProperty(num)) return this.reporter.error("Values map doesn't contain: " + JSON.stringify(num));
        num = values[num];
    }
    // Bignum, assume big endian
    if (typeof num !== "number" && !$902a44ef9d4a2e48$require$Buffer.isBuffer(num)) {
        var numArray = num.toArray();
        if (!num.sign && numArray[0] & 0x80) numArray.unshift(0);
        num = $902a44ef9d4a2e48$require$Buffer.from(numArray);
    }
    if ($902a44ef9d4a2e48$require$Buffer.isBuffer(num)) {
        var size = num.length;
        if (num.length === 0) size++;
        var out = $902a44ef9d4a2e48$require$Buffer.alloc(size);
        num.copy(out);
        if (num.length === 0) out[0] = 0;
        return this._createEncoderBuffer(out);
    }
    if (num < 0x80) return this._createEncoderBuffer(num);
    if (num < 0x100) return this._createEncoderBuffer([
        0,
        num
    ]);
    var size1 = 1;
    for(var i = num; i >= 0x100; i >>= 8)size1++;
    var out1 = new Array(size1);
    for(var i1 = out1.length - 1; i1 >= 0; i1--){
        out1[i1] = num & 0xff;
        num >>= 8;
    }
    if (out1[0] & 0x80) out1.unshift(0);
    return this._createEncoderBuffer($902a44ef9d4a2e48$require$Buffer.from(out1));
};
$902a44ef9d4a2e48$var$DERNode.prototype._encodeBool = function encodeBool(value) {
    return this._createEncoderBuffer(value ? 0xff : 0);
};
$902a44ef9d4a2e48$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === "function") entity = entity(obj);
    return entity._getEncoder("der").tree;
};
$902a44ef9d4a2e48$var$DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
    var state = this._baseState;
    var i;
    if (state["default"] === null) return false;
    var data = dataBuffer.join();
    if (state.defaultBuffer === undefined) state.defaultBuffer = this._encodeValue(state["default"], reporter, parent).join();
    if (data.length !== state.defaultBuffer.length) return false;
    for(i = 0; i < data.length; i++)if (data[i] !== state.defaultBuffer[i]) return false;
    return true;
};
// Utility methods
function $902a44ef9d4a2e48$var$encodeTag(tag, primitive, cls, reporter) {
    var res;
    if (tag === "seqof") tag = "seq";
    else if (tag === "setof") tag = "set";
    if ($9CP3j.tagByName.hasOwnProperty(tag)) res = $9CP3j.tagByName[tag];
    else if (typeof tag === "number" && (tag | 0) === tag) res = tag;
    else return reporter.error("Unknown tag: " + tag);
    if (res >= 0x1f) return reporter.error("Multi-octet tag encoding unsupported");
    if (!primitive) res |= 0x20;
    res |= $9CP3j.tagClassByName[cls || "universal"] << 6;
    return res;
}

});
parcelRegister("lwNfX", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $l0HdX = parcelRequire("l0HdX");

var $3qWgZ = parcelRequire("3qWgZ");
"use strict";

var $8dlmd = parcelRequire("8dlmd");
var $fac2cb684eb4e076$var$Buffer = $8dlmd.Buffer;
var $fac2cb684eb4e076$var$safer = {};
var $fac2cb684eb4e076$var$key;
for($fac2cb684eb4e076$var$key in $8dlmd){
    if (!$8dlmd.hasOwnProperty($fac2cb684eb4e076$var$key)) continue;
    if ($fac2cb684eb4e076$var$key === "SlowBuffer" || $fac2cb684eb4e076$var$key === "Buffer") continue;
    $fac2cb684eb4e076$var$safer[$fac2cb684eb4e076$var$key] = $8dlmd[$fac2cb684eb4e076$var$key];
}
var $fac2cb684eb4e076$var$Safer = $fac2cb684eb4e076$var$safer.Buffer = {};
for($fac2cb684eb4e076$var$key in $fac2cb684eb4e076$var$Buffer){
    if (!$fac2cb684eb4e076$var$Buffer.hasOwnProperty($fac2cb684eb4e076$var$key)) continue;
    if ($fac2cb684eb4e076$var$key === "allocUnsafe" || $fac2cb684eb4e076$var$key === "allocUnsafeSlow") continue;
    $fac2cb684eb4e076$var$Safer[$fac2cb684eb4e076$var$key] = $fac2cb684eb4e076$var$Buffer[$fac2cb684eb4e076$var$key];
}
$fac2cb684eb4e076$var$safer.Buffer.prototype = $fac2cb684eb4e076$var$Buffer.prototype;
if (!$fac2cb684eb4e076$var$Safer.from || $fac2cb684eb4e076$var$Safer.from === Uint8Array.from) $fac2cb684eb4e076$var$Safer.from = function(value, encodingOrOffset, length) {
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type ' + (typeof value === "undefined" ? "undefined" : (0, $l0HdX._)(value)));
    if (value && typeof value.length === "undefined") throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $l0HdX._)(value)));
    return $fac2cb684eb4e076$var$Buffer(value, encodingOrOffset, length);
};
if (!$fac2cb684eb4e076$var$Safer.alloc) $fac2cb684eb4e076$var$Safer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError('The "size" argument must be of type number. Received type ' + (typeof size === "undefined" ? "undefined" : (0, $l0HdX._)(size)));
    if (size < 0 || size >= 2 * 1073741824) throw new RangeError('The value "' + size + '" is invalid for option "size"');
    var buf = $fac2cb684eb4e076$var$Buffer(size);
    if (!fill || fill.length === 0) buf.fill(0);
    else if (typeof encoding === "string") buf.fill(fill, encoding);
    else buf.fill(fill);
    return buf;
};
if (!$fac2cb684eb4e076$var$safer.kStringMaxLength) try {
    $fac2cb684eb4e076$var$safer.kStringMaxLength = $3qWgZ.binding("buffer").kStringMaxLength;
} catch (e) {
// we can't determine kStringMaxLength in environments where process.binding
// is unsupported, so let's not set it
}
if (!$fac2cb684eb4e076$var$safer.constants) {
    $fac2cb684eb4e076$var$safer.constants = {
        MAX_LENGTH: $fac2cb684eb4e076$var$safer.kMaxLength
    };
    if ($fac2cb684eb4e076$var$safer.kStringMaxLength) $fac2cb684eb4e076$var$safer.constants.MAX_STRING_LENGTH = $fac2cb684eb4e076$var$safer.kStringMaxLength;
}
module.exports = $fac2cb684eb4e076$var$safer;

});

parcelRegister("gF4FC", function(module, exports) {
"use strict";

var $eRMR9 = parcelRequire("eRMR9");
var $c214191e131302c2$require$Reporter = $eRMR9.Reporter;

var $dx1y7 = parcelRequire("dx1y7");
var $c214191e131302c2$require$EncoderBuffer = $dx1y7.EncoderBuffer;

var $dx1y7 = parcelRequire("dx1y7");
var $c214191e131302c2$require$DecoderBuffer = $dx1y7.DecoderBuffer;

var $7WVV2 = parcelRequire("7WVV2");
// Supported tags
var $c214191e131302c2$var$tags = [
    "seq",
    "seqof",
    "set",
    "setof",
    "objid",
    "bool",
    "gentime",
    "utctime",
    "null_",
    "enum",
    "int",
    "objDesc",
    "bitstr",
    "bmpstr",
    "charstr",
    "genstr",
    "graphstr",
    "ia5str",
    "iso646str",
    "numstr",
    "octstr",
    "printstr",
    "t61str",
    "unistr",
    "utf8str",
    "videostr"
];
// Public methods list
var $c214191e131302c2$var$methods = [
    "key",
    "obj",
    "use",
    "optional",
    "explicit",
    "implicit",
    "def",
    "choice",
    "any",
    "contains"
].concat($c214191e131302c2$var$tags);
// Overrided methods list
var $c214191e131302c2$var$overrided = [
    "_peekTag",
    "_decodeTag",
    "_use",
    "_decodeStr",
    "_decodeObjid",
    "_decodeTime",
    "_decodeNull",
    "_decodeInt",
    "_decodeBool",
    "_decodeList",
    "_encodeComposite",
    "_encodeStr",
    "_encodeObjid",
    "_encodeTime",
    "_encodeNull",
    "_encodeInt",
    "_encodeBool"
];
function $c214191e131302c2$var$Node(enc, parent, name) {
    var state = {};
    this._baseState = state;
    state.name = name;
    state.enc = enc;
    state.parent = parent || null;
    state.children = null;
    // State
    state.tag = null;
    state.args = null;
    state.reverseArgs = null;
    state.choice = null;
    state.optional = false;
    state.any = false;
    state.obj = false;
    state.use = null;
    state.useDecoder = null;
    state.key = null;
    state["default"] = null;
    state.explicit = null;
    state.implicit = null;
    state.contains = null;
    // Should create new instance on each method
    if (!state.parent) {
        state.children = [];
        this._wrap();
    }
}
module.exports = $c214191e131302c2$var$Node;
var $c214191e131302c2$var$stateProps = [
    "enc",
    "parent",
    "children",
    "tag",
    "args",
    "reverseArgs",
    "choice",
    "optional",
    "any",
    "obj",
    "use",
    "alteredUse",
    "key",
    "default",
    "explicit",
    "implicit",
    "contains"
];
$c214191e131302c2$var$Node.prototype.clone = function clone() {
    var state = this._baseState;
    var cstate = {};
    $c214191e131302c2$var$stateProps.forEach(function(prop) {
        cstate[prop] = state[prop];
    });
    var res = new this.constructor(cstate.parent);
    res._baseState = cstate;
    return res;
};
$c214191e131302c2$var$Node.prototype._wrap = function wrap() {
    var state = this._baseState;
    $c214191e131302c2$var$methods.forEach(function(method) {
        this[method] = function _wrappedMethod() {
            var clone = new this.constructor(this);
            state.children.push(clone);
            return clone[method].apply(clone, arguments);
        };
    }, this);
};
$c214191e131302c2$var$Node.prototype._init = function init(body) {
    var state = this._baseState;
    $7WVV2(state.parent === null);
    body.call(this);
    // Filter children
    state.children = state.children.filter(function(child) {
        return child._baseState.parent === this;
    }, this);
    $7WVV2.equal(state.children.length, 1, "Root node can have only one child");
};
$c214191e131302c2$var$Node.prototype._useArgs = function useArgs(args) {
    var state = this._baseState;
    // Filter children and args
    var children = args.filter(function(arg) {
        return arg instanceof this.constructor;
    }, this);
    args = args.filter(function(arg) {
        return !(arg instanceof this.constructor);
    }, this);
    if (children.length !== 0) {
        $7WVV2(state.children === null);
        state.children = children;
        // Replace parent to maintain backward link
        children.forEach(function(child) {
            child._baseState.parent = this;
        }, this);
    }
    if (args.length !== 0) {
        $7WVV2(state.args === null);
        state.args = args;
        state.reverseArgs = args.map(function(arg) {
            if (typeof arg !== "object" || arg.constructor !== Object) return arg;
            var res = {};
            Object.keys(arg).forEach(function(key) {
                if (key == (key | 0)) key |= 0;
                var value = arg[key];
                res[value] = key;
            });
            return res;
        });
    }
};
//
// Overrided methods
//
$c214191e131302c2$var$overrided.forEach(function(method) {
    $c214191e131302c2$var$Node.prototype[method] = function _overrided() {
        var state = this._baseState;
        throw new Error(method + " not implemented for encoding: " + state.enc);
    };
});
//
// Public methods
//
$c214191e131302c2$var$tags.forEach(function(tag) {
    $c214191e131302c2$var$Node.prototype[tag] = function _tagMethod() {
        var state = this._baseState;
        var args = Array.prototype.slice.call(arguments);
        $7WVV2(state.tag === null);
        state.tag = tag;
        this._useArgs(args);
        return this;
    };
});
$c214191e131302c2$var$Node.prototype.use = function use(item) {
    $7WVV2(item);
    var state = this._baseState;
    $7WVV2(state.use === null);
    state.use = item;
    return this;
};
$c214191e131302c2$var$Node.prototype.optional = function optional() {
    var state = this._baseState;
    state.optional = true;
    return this;
};
$c214191e131302c2$var$Node.prototype.def = function def(val) {
    var state = this._baseState;
    $7WVV2(state["default"] === null);
    state["default"] = val;
    state.optional = true;
    return this;
};
$c214191e131302c2$var$Node.prototype.explicit = function explicit(num) {
    var state = this._baseState;
    $7WVV2(state.explicit === null && state.implicit === null);
    state.explicit = num;
    return this;
};
$c214191e131302c2$var$Node.prototype.implicit = function implicit(num) {
    var state = this._baseState;
    $7WVV2(state.explicit === null && state.implicit === null);
    state.implicit = num;
    return this;
};
$c214191e131302c2$var$Node.prototype.obj = function obj() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);
    state.obj = true;
    if (args.length !== 0) this._useArgs(args);
    return this;
};
$c214191e131302c2$var$Node.prototype.key = function key(newKey) {
    var state = this._baseState;
    $7WVV2(state.key === null);
    state.key = newKey;
    return this;
};
$c214191e131302c2$var$Node.prototype.any = function any() {
    var state = this._baseState;
    state.any = true;
    return this;
};
$c214191e131302c2$var$Node.prototype.choice = function choice(obj) {
    var state = this._baseState;
    $7WVV2(state.choice === null);
    state.choice = obj;
    this._useArgs(Object.keys(obj).map(function(key) {
        return obj[key];
    }));
    return this;
};
$c214191e131302c2$var$Node.prototype.contains = function contains(item) {
    var state = this._baseState;
    $7WVV2(state.use === null);
    state.contains = item;
    return this;
};
//
// Decoding
//
$c214191e131302c2$var$Node.prototype._decode = function decode(input, options) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return input.wrapResult(state.children[0]._decode(input, options));
    var result = state["default"];
    var present = true;
    var prevKey = null;
    if (state.key !== null) prevKey = input.enterKey(state.key);
    // Check if tag is there
    if (state.optional) {
        var tag = null;
        if (state.explicit !== null) tag = state.explicit;
        else if (state.implicit !== null) tag = state.implicit;
        else if (state.tag !== null) tag = state.tag;
        if (tag === null && !state.any) {
            // Trial and Error
            var save = input.save();
            try {
                if (state.choice === null) this._decodeGeneric(state.tag, input, options);
                else this._decodeChoice(input, options);
                present = true;
            } catch (e) {
                present = false;
            }
            input.restore(save);
        } else {
            present = this._peekTag(input, tag, state.any);
            if (input.isError(present)) return present;
        }
    }
    // Push object on stack
    var prevObj;
    if (state.obj && present) prevObj = input.enterObject();
    if (present) {
        // Unwrap explicit values
        if (state.explicit !== null) {
            var explicit = this._decodeTag(input, state.explicit);
            if (input.isError(explicit)) return explicit;
            input = explicit;
        }
        var start = input.offset;
        // Unwrap implicit and normal values
        if (state.use === null && state.choice === null) {
            var save1;
            if (state.any) save1 = input.save();
            var body = this._decodeTag(input, state.implicit !== null ? state.implicit : state.tag, state.any);
            if (input.isError(body)) return body;
            if (state.any) result = input.raw(save1);
            else input = body;
        }
        if (options && options.track && state.tag !== null) options.track(input.path(), start, input.length, "tagged");
        if (options && options.track && state.tag !== null) options.track(input.path(), input.offset, input.length, "content");
        // Select proper method for tag
        if (state.any) ;
        else if (state.choice === null) result = this._decodeGeneric(state.tag, input, options);
        else result = this._decodeChoice(input, options);
        if (input.isError(result)) return result;
        // Decode children
        if (!state.any && state.choice === null && state.children !== null) state.children.forEach(function decodeChildren(child) {
            // NOTE: We are ignoring errors here, to let parser continue with other
            // parts of encoded data
            child._decode(input, options);
        });
        // Decode contained/encoded by schema, only in bit or octet strings
        if (state.contains && (state.tag === "octstr" || state.tag === "bitstr")) {
            var data = new $c214191e131302c2$require$DecoderBuffer(result);
            result = this._getUse(state.contains, input._reporterState.obj)._decode(data, options);
        }
    }
    // Pop object
    if (state.obj && present) result = input.leaveObject(prevObj);
    // Set key
    if (state.key !== null && (result !== null || present === true)) input.leaveKey(prevKey, state.key, result);
    else if (prevKey !== null) input.exitKey(prevKey);
    return result;
};
$c214191e131302c2$var$Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
    var state = this._baseState;
    if (tag === "seq" || tag === "set") return null;
    if (tag === "seqof" || tag === "setof") return this._decodeList(input, tag, state.args[0], options);
    else if (/str$/.test(tag)) return this._decodeStr(input, tag, options);
    else if (tag === "objid" && state.args) return this._decodeObjid(input, state.args[0], state.args[1], options);
    else if (tag === "objid") return this._decodeObjid(input, null, null, options);
    else if (tag === "gentime" || tag === "utctime") return this._decodeTime(input, tag, options);
    else if (tag === "null_") return this._decodeNull(input, options);
    else if (tag === "bool") return this._decodeBool(input, options);
    else if (tag === "objDesc") return this._decodeStr(input, tag, options);
    else if (tag === "int" || tag === "enum") return this._decodeInt(input, state.args && state.args[0], options);
    if (state.use !== null) return this._getUse(state.use, input._reporterState.obj)._decode(input, options);
    else return input.error("unknown tag: " + tag);
};
$c214191e131302c2$var$Node.prototype._getUse = function _getUse(entity, obj) {
    var state = this._baseState;
    // Create altered use decoder if implicit is set
    state.useDecoder = this._use(entity, obj);
    $7WVV2(state.useDecoder._baseState.parent === null);
    state.useDecoder = state.useDecoder._baseState.children[0];
    if (state.implicit !== state.useDecoder._baseState.implicit) {
        state.useDecoder = state.useDecoder.clone();
        state.useDecoder._baseState.implicit = state.implicit;
    }
    return state.useDecoder;
};
$c214191e131302c2$var$Node.prototype._decodeChoice = function decodeChoice(input, options) {
    var state = this._baseState;
    var result = null;
    var match = false;
    Object.keys(state.choice).some(function(key) {
        var save = input.save();
        var node = state.choice[key];
        try {
            var value = node._decode(input, options);
            if (input.isError(value)) return false;
            result = {
                type: key,
                value: value
            };
            match = true;
        } catch (e) {
            input.restore(save);
            return false;
        }
        return true;
    }, this);
    if (!match) return input.error("Choice not matched");
    return result;
};
//
// Encoding
//
$c214191e131302c2$var$Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
    return new $c214191e131302c2$require$EncoderBuffer(data, this.reporter);
};
$c214191e131302c2$var$Node.prototype._encode = function encode(data, reporter, parent) {
    var state = this._baseState;
    if (state["default"] !== null && state["default"] === data) return;
    var result = this._encodeValue(data, reporter, parent);
    if (result === undefined) return;
    if (this._skipDefault(result, reporter, parent)) return;
    return result;
};
$c214191e131302c2$var$Node.prototype._encodeValue = function encode(data, reporter, parent) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return state.children[0]._encode(data, reporter || new $c214191e131302c2$require$Reporter());
    var result = null;
    // Set reporter to share it with a child class
    this.reporter = reporter;
    // Check if data is there
    if (state.optional && data === undefined) {
        if (state["default"] !== null) data = state["default"];
        else return;
    }
    // Encode children first
    var content = null;
    var primitive = false;
    if (state.any) // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
    else if (state.choice) result = this._encodeChoice(data, reporter);
    else if (state.contains) {
        content = this._getUse(state.contains, parent)._encode(data, reporter);
        primitive = true;
    } else if (state.children) {
        content = state.children.map(function(child) {
            if (child._baseState.tag === "null_") return child._encode(null, reporter, data);
            if (child._baseState.key === null) return reporter.error("Child should have a key");
            var prevKey = reporter.enterKey(child._baseState.key);
            if (typeof data !== "object") return reporter.error("Child expected, but input is not object");
            var res = child._encode(data[child._baseState.key], reporter, data);
            reporter.leaveKey(prevKey);
            return res;
        }, this).filter(function(child) {
            return child;
        });
        content = this._createEncoderBuffer(content);
    } else {
        if (state.tag === "seqof" || state.tag === "setof") {
            // TODO(indutny): this should be thrown on DSL level
            if (!(state.args && state.args.length === 1)) return reporter.error("Too many args for : " + state.tag);
            if (!Array.isArray(data)) return reporter.error("seqof/setof, but data is not Array");
            var child = this.clone();
            child._baseState.implicit = null;
            content = this._createEncoderBuffer(data.map(function(item) {
                var state = this._baseState;
                return this._getUse(state.args[0], data)._encode(item, reporter);
            }, child));
        } else if (state.use !== null) result = this._getUse(state.use, parent)._encode(data, reporter);
        else {
            content = this._encodePrimitive(state.tag, data);
            primitive = true;
        }
    }
    // Encode data itself
    if (!state.any && state.choice === null) {
        var tag = state.implicit !== null ? state.implicit : state.tag;
        var cls = state.implicit === null ? "universal" : "context";
        if (tag === null) {
            if (state.use === null) reporter.error("Tag could be omitted only for .use()");
        } else if (state.use === null) result = this._encodeComposite(tag, primitive, cls, content);
    }
    // Wrap in explicit
    if (state.explicit !== null) result = this._encodeComposite(state.explicit, false, "context", result);
    return result;
};
$c214191e131302c2$var$Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
    var state = this._baseState;
    var node = state.choice[data.type];
    if (!node) $7WVV2(false, data.type + " not found in " + JSON.stringify(Object.keys(state.choice)));
    return node._encode(data.value, reporter);
};
$c214191e131302c2$var$Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
    var state = this._baseState;
    if (/str$/.test(tag)) return this._encodeStr(data, tag);
    else if (tag === "objid" && state.args) return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
    else if (tag === "objid") return this._encodeObjid(data, null, null);
    else if (tag === "gentime" || tag === "utctime") return this._encodeTime(data, tag);
    else if (tag === "null_") return this._encodeNull();
    else if (tag === "int" || tag === "enum") return this._encodeInt(data, state.args && state.reverseArgs[0]);
    else if (tag === "bool") return this._encodeBool(data);
    else if (tag === "objDesc") return this._encodeStr(data, tag);
    else throw new Error("Unsupported tag: " + tag);
};
$c214191e131302c2$var$Node.prototype._isNumstr = function isNumstr(str) {
    return /^[0-9 ]*$/.test(str);
};
$c214191e131302c2$var$Node.prototype._isPrintstr = function isPrintstr(str) {
    return /^[A-Za-z0-9 '()+,-./:=?]*$/.test(str);
};

});
parcelRegister("eRMR9", function(module, exports) {

$parcel$export(module.exports, "Reporter", function () { return $ad2be9c1b4131355$export$957313a2f485e5ed; }, function (v) { return $ad2be9c1b4131355$export$957313a2f485e5ed = v; });
var $ad2be9c1b4131355$export$957313a2f485e5ed;
"use strict";

var $hwgCU = parcelRequire("hwgCU");
function $ad2be9c1b4131355$var$Reporter(options) {
    this._reporterState = {
        obj: null,
        path: [],
        options: options || {},
        errors: []
    };
}
$ad2be9c1b4131355$export$957313a2f485e5ed = $ad2be9c1b4131355$var$Reporter;
$ad2be9c1b4131355$var$Reporter.prototype.isError = function isError(obj) {
    return obj instanceof $ad2be9c1b4131355$var$ReporterError;
};
$ad2be9c1b4131355$var$Reporter.prototype.save = function save() {
    var state = this._reporterState;
    return {
        obj: state.obj,
        pathLen: state.path.length
    };
};
$ad2be9c1b4131355$var$Reporter.prototype.restore = function restore(data) {
    var state = this._reporterState;
    state.obj = data.obj;
    state.path = state.path.slice(0, data.pathLen);
};
$ad2be9c1b4131355$var$Reporter.prototype.enterKey = function enterKey(key) {
    return this._reporterState.path.push(key);
};
$ad2be9c1b4131355$var$Reporter.prototype.exitKey = function exitKey(index) {
    var state = this._reporterState;
    state.path = state.path.slice(0, index - 1);
};
$ad2be9c1b4131355$var$Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
    var state = this._reporterState;
    this.exitKey(index);
    if (state.obj !== null) state.obj[key] = value;
};
$ad2be9c1b4131355$var$Reporter.prototype.path = function path() {
    return this._reporterState.path.join("/");
};
$ad2be9c1b4131355$var$Reporter.prototype.enterObject = function enterObject() {
    var state = this._reporterState;
    var prev = state.obj;
    state.obj = {};
    return prev;
};
$ad2be9c1b4131355$var$Reporter.prototype.leaveObject = function leaveObject(prev) {
    var state = this._reporterState;
    var now = state.obj;
    state.obj = prev;
    return now;
};
$ad2be9c1b4131355$var$Reporter.prototype.error = function error(msg) {
    var err;
    var state = this._reporterState;
    var inherited = msg instanceof $ad2be9c1b4131355$var$ReporterError;
    if (inherited) err = msg;
    else err = new $ad2be9c1b4131355$var$ReporterError(state.path.map(function(elem) {
        return "[" + JSON.stringify(elem) + "]";
    }).join(""), msg.message || msg, msg.stack);
    if (!state.options.partial) throw err;
    if (!inherited) state.errors.push(err);
    return err;
};
$ad2be9c1b4131355$var$Reporter.prototype.wrapResult = function wrapResult(result) {
    var state = this._reporterState;
    if (!state.options.partial) return result;
    return {
        result: this.isError(result) ? null : result,
        errors: state.errors
    };
};
function $ad2be9c1b4131355$var$ReporterError(path, msg) {
    this.path = path;
    this.rethrow(msg);
}
$hwgCU($ad2be9c1b4131355$var$ReporterError, Error);
$ad2be9c1b4131355$var$ReporterError.prototype.rethrow = function rethrow(msg) {
    this.message = msg + " at: " + (this.path || "(shallow)");
    if (Error.captureStackTrace) Error.captureStackTrace(this, $ad2be9c1b4131355$var$ReporterError);
    if (!this.stack) try {
        // IE only adds stack when thrown
        throw new Error(this.message);
    } catch (e) {
        this.stack = e.stack;
    }
    return this;
};

});

parcelRegister("dx1y7", function(module, exports) {

$parcel$export(module.exports, "DecoderBuffer", function () { return $9d9f8f119934b711$export$bf9f79cdc4a49163; }, function (v) { return $9d9f8f119934b711$export$bf9f79cdc4a49163 = v; });
$parcel$export(module.exports, "EncoderBuffer", function () { return $9d9f8f119934b711$export$8ff24f7760c7a78e; }, function (v) { return $9d9f8f119934b711$export$8ff24f7760c7a78e = v; });

var $l0HdX = parcelRequire("l0HdX");
var $9d9f8f119934b711$export$bf9f79cdc4a49163;
var $9d9f8f119934b711$export$8ff24f7760c7a78e;
"use strict";

var $hwgCU = parcelRequire("hwgCU");

var $eRMR9 = parcelRequire("eRMR9");
var $9d9f8f119934b711$require$Reporter = $eRMR9.Reporter;

var $lwNfX = parcelRequire("lwNfX");
var $9d9f8f119934b711$require$Buffer = $lwNfX.Buffer;
function $9d9f8f119934b711$var$DecoderBuffer(base, options) {
    $9d9f8f119934b711$require$Reporter.call(this, options);
    if (!$9d9f8f119934b711$require$Buffer.isBuffer(base)) {
        this.error("Input not Buffer");
        return;
    }
    this.base = base;
    this.offset = 0;
    this.length = base.length;
}
$hwgCU($9d9f8f119934b711$var$DecoderBuffer, $9d9f8f119934b711$require$Reporter);
$9d9f8f119934b711$export$bf9f79cdc4a49163 = $9d9f8f119934b711$var$DecoderBuffer;
$9d9f8f119934b711$var$DecoderBuffer.isDecoderBuffer = function isDecoderBuffer(data) {
    if (data instanceof $9d9f8f119934b711$var$DecoderBuffer) return true;
    // Or accept compatible API
    var isCompatible = typeof data === "object" && $9d9f8f119934b711$require$Buffer.isBuffer(data.base) && data.constructor.name === "DecoderBuffer" && typeof data.offset === "number" && typeof data.length === "number" && typeof data.save === "function" && typeof data.restore === "function" && typeof data.isEmpty === "function" && typeof data.readUInt8 === "function" && typeof data.skip === "function" && typeof data.raw === "function";
    return isCompatible;
};
$9d9f8f119934b711$var$DecoderBuffer.prototype.save = function save() {
    return {
        offset: this.offset,
        reporter: $9d9f8f119934b711$require$Reporter.prototype.save.call(this)
    };
};
$9d9f8f119934b711$var$DecoderBuffer.prototype.restore = function restore(save) {
    // Return skipped data
    var res = new $9d9f8f119934b711$var$DecoderBuffer(this.base);
    res.offset = save.offset;
    res.length = this.offset;
    this.offset = save.offset;
    $9d9f8f119934b711$require$Reporter.prototype.restore.call(this, save.reporter);
    return res;
};
$9d9f8f119934b711$var$DecoderBuffer.prototype.isEmpty = function isEmpty() {
    return this.offset === this.length;
};
$9d9f8f119934b711$var$DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
    if (this.offset + 1 <= this.length) return this.base.readUInt8(this.offset++, true);
    else return this.error(fail || "DecoderBuffer overrun");
};
$9d9f8f119934b711$var$DecoderBuffer.prototype.skip = function skip(bytes, fail) {
    if (!(this.offset + bytes <= this.length)) return this.error(fail || "DecoderBuffer overrun");
    var res = new $9d9f8f119934b711$var$DecoderBuffer(this.base);
    // Share reporter state
    res._reporterState = this._reporterState;
    res.offset = this.offset;
    res.length = this.offset + bytes;
    this.offset += bytes;
    return res;
};
$9d9f8f119934b711$var$DecoderBuffer.prototype.raw = function raw(save) {
    return this.base.slice(save ? save.offset : this.offset, this.length);
};
function $9d9f8f119934b711$var$EncoderBuffer(value, reporter) {
    if (Array.isArray(value)) {
        this.length = 0;
        this.value = value.map(function(item) {
            if (!$9d9f8f119934b711$var$EncoderBuffer.isEncoderBuffer(item)) item = new $9d9f8f119934b711$var$EncoderBuffer(item, reporter);
            this.length += item.length;
            return item;
        }, this);
    } else if (typeof value === "number") {
        if (!(0 <= value && value <= 0xff)) return reporter.error("non-byte EncoderBuffer value");
        this.value = value;
        this.length = 1;
    } else if (typeof value === "string") {
        this.value = value;
        this.length = $9d9f8f119934b711$require$Buffer.byteLength(value);
    } else if ($9d9f8f119934b711$require$Buffer.isBuffer(value)) {
        this.value = value;
        this.length = value.length;
    } else return reporter.error("Unsupported type: " + (typeof value === "undefined" ? "undefined" : (0, $l0HdX._)(value)));
}
$9d9f8f119934b711$export$8ff24f7760c7a78e = $9d9f8f119934b711$var$EncoderBuffer;
$9d9f8f119934b711$var$EncoderBuffer.isEncoderBuffer = function isEncoderBuffer(data) {
    if (data instanceof $9d9f8f119934b711$var$EncoderBuffer) return true;
    // Or accept compatible API
    var isCompatible = typeof data === "object" && data.constructor.name === "EncoderBuffer" && typeof data.length === "number" && typeof data.join === "function";
    return isCompatible;
};
$9d9f8f119934b711$var$EncoderBuffer.prototype.join = function join(out, offset) {
    if (!out) out = $9d9f8f119934b711$require$Buffer.alloc(this.length);
    if (!offset) offset = 0;
    if (this.length === 0) return out;
    if (Array.isArray(this.value)) this.value.forEach(function(item) {
        item.join(out, offset);
        offset += item.length;
    });
    else {
        if (typeof this.value === "number") out[offset] = this.value;
        else if (typeof this.value === "string") out.write(this.value, offset);
        else if ($9d9f8f119934b711$require$Buffer.isBuffer(this.value)) this.value.copy(out, offset);
        offset += this.length;
    }
    return out;
};

});


parcelRegister("9CP3j", function(module, exports) {

$parcel$export(module.exports, "tagClass", function () { return $701f43a0a4c88343$export$3584c46ed60baee8; }, function (v) { return $701f43a0a4c88343$export$3584c46ed60baee8 = v; });
$parcel$export(module.exports, "tagClassByName", function () { return $701f43a0a4c88343$export$f18596ef8d632e49; }, function (v) { return $701f43a0a4c88343$export$f18596ef8d632e49 = v; });
$parcel$export(module.exports, "tag", function () { return $701f43a0a4c88343$export$2b067c6666111485; }, function (v) { return $701f43a0a4c88343$export$2b067c6666111485 = v; });
$parcel$export(module.exports, "tagByName", function () { return $701f43a0a4c88343$export$f17df38a421ab9e3; }, function (v) { return $701f43a0a4c88343$export$f17df38a421ab9e3 = v; });
var $701f43a0a4c88343$export$3584c46ed60baee8;
var $701f43a0a4c88343$export$f18596ef8d632e49;
var $701f43a0a4c88343$export$2b067c6666111485;
var $701f43a0a4c88343$export$f17df38a421ab9e3;
"use strict";
// Helper
function $701f43a0a4c88343$var$reverse(map) {
    var res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        var value = map[key];
        res[value] = key;
    });
    return res;
}
$701f43a0a4c88343$export$3584c46ed60baee8 = {
    0: "universal",
    1: "application",
    2: "context",
    3: "private"
};
$701f43a0a4c88343$export$f18596ef8d632e49 = $701f43a0a4c88343$var$reverse($701f43a0a4c88343$export$3584c46ed60baee8);
$701f43a0a4c88343$export$2b067c6666111485 = {
    0x00: "end",
    0x01: "bool",
    0x02: "int",
    0x03: "bitstr",
    0x04: "octstr",
    0x05: "null_",
    0x06: "objid",
    0x07: "objDesc",
    0x08: "external",
    0x09: "real",
    0x0a: "enum",
    0x0b: "embed",
    0x0c: "utf8str",
    0x0d: "relativeOid",
    0x10: "seq",
    0x11: "set",
    0x12: "numstr",
    0x13: "printstr",
    0x14: "t61str",
    0x15: "videostr",
    0x16: "ia5str",
    0x17: "utctime",
    0x18: "gentime",
    0x19: "graphstr",
    0x1a: "iso646str",
    0x1b: "genstr",
    0x1c: "unistr",
    0x1d: "charstr",
    0x1e: "bmpstr"
};
$701f43a0a4c88343$export$f17df38a421ab9e3 = $701f43a0a4c88343$var$reverse($701f43a0a4c88343$export$2b067c6666111485);

});


parcelRegister("ac8XI", function(module, exports) {
"use strict";

var $hwgCU = parcelRequire("hwgCU");

var $cno1D = parcelRequire("cno1D");
function $76c1fa141ff0d983$var$PEMEncoder(entity) {
    $cno1D.call(this, entity);
    this.enc = "pem";
}
$hwgCU($76c1fa141ff0d983$var$PEMEncoder, $cno1D);
module.exports = $76c1fa141ff0d983$var$PEMEncoder;
$76c1fa141ff0d983$var$PEMEncoder.prototype.encode = function encode(data, options) {
    var buf = $cno1D.prototype.encode.call(this, data);
    var p = buf.toString("base64");
    var out = [
        "-----BEGIN " + options.label + "-----"
    ];
    for(var i = 0; i < p.length; i += 64)out.push(p.slice(i, i + 64));
    out.push("-----END " + options.label + "-----");
    return out.join("\n");
};

});


parcelRegister("9XR9M", function(module, exports) {
"use strict";
var $7412db8bf5d75d5e$var$decoders = module.exports;

$7412db8bf5d75d5e$var$decoders.der = (parcelRequire("02In3"));

$7412db8bf5d75d5e$var$decoders.pem = (parcelRequire("8rMOX"));

});
parcelRegister("02In3", function(module, exports) {
"use strict";

var $hwgCU = parcelRequire("hwgCU");

var $blRDm = parcelRequire("blRDm");

var $dx1y7 = parcelRequire("dx1y7");
var $00829b27548afa16$require$DecoderBuffer = $dx1y7.DecoderBuffer;

var $gF4FC = parcelRequire("gF4FC");

var $9CP3j = parcelRequire("9CP3j");
function $00829b27548afa16$var$DERDecoder(entity) {
    this.enc = "der";
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $00829b27548afa16$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $00829b27548afa16$var$DERDecoder;
$00829b27548afa16$var$DERDecoder.prototype.decode = function decode(data, options) {
    if (!$00829b27548afa16$require$DecoderBuffer.isDecoderBuffer(data)) data = new $00829b27548afa16$require$DecoderBuffer(data, options);
    return this.tree._decode(data, options);
};
// Tree methods
function $00829b27548afa16$var$DERNode(parent) {
    $gF4FC.call(this, "der", parent);
}
$hwgCU($00829b27548afa16$var$DERNode, $gF4FC);
$00829b27548afa16$var$DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
    if (buffer.isEmpty()) return false;
    var state = buffer.save();
    var decodedTag = $00829b27548afa16$var$derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    buffer.restore(state);
    return decodedTag.tag === tag || decodedTag.tagStr === tag || decodedTag.tagStr + "of" === tag || any;
};
$00829b27548afa16$var$DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
    var decodedTag = $00829b27548afa16$var$derDecodeTag(buffer, 'Failed to decode tag of "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    var len = $00829b27548afa16$var$derDecodeLen(buffer, decodedTag.primitive, 'Failed to get length of "' + tag + '"');
    // Failure
    if (buffer.isError(len)) return len;
    if (!any && decodedTag.tag !== tag && decodedTag.tagStr !== tag && decodedTag.tagStr + "of" !== tag) return buffer.error('Failed to match tag: "' + tag + '"');
    if (decodedTag.primitive || len !== null) return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
    // Indefinite length... find END tag
    var state = buffer.save();
    var res = this._skipUntilEnd(buffer, 'Failed to skip indefinite length body: "' + this.tag + '"');
    if (buffer.isError(res)) return res;
    len = buffer.offset - state.offset;
    buffer.restore(state);
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};
$00829b27548afa16$var$DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
    for(;;){
        var tag = $00829b27548afa16$var$derDecodeTag(buffer, fail);
        if (buffer.isError(tag)) return tag;
        var len = $00829b27548afa16$var$derDecodeLen(buffer, tag.primitive, fail);
        if (buffer.isError(len)) return len;
        var res = void 0;
        if (tag.primitive || len !== null) res = buffer.skip(len);
        else res = this._skipUntilEnd(buffer, fail);
        // Failure
        if (buffer.isError(res)) return res;
        if (tag.tagStr === "end") break;
    }
};
$00829b27548afa16$var$DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder, options) {
    var result = [];
    while(!buffer.isEmpty()){
        var possibleEnd = this._peekTag(buffer, "end");
        if (buffer.isError(possibleEnd)) return possibleEnd;
        var res = decoder.decode(buffer, "der", options);
        if (buffer.isError(res) && possibleEnd) break;
        result.push(res);
    }
    return result;
};
$00829b27548afa16$var$DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
    if (tag === "bitstr") {
        var unused = buffer.readUInt8();
        if (buffer.isError(unused)) return unused;
        return {
            unused: unused,
            data: buffer.raw()
        };
    } else if (tag === "bmpstr") {
        var raw = buffer.raw();
        if (raw.length % 2 === 1) return buffer.error("Decoding of string type: bmpstr length mismatch");
        var str = "";
        for(var i = 0; i < raw.length / 2; i++)str += String.fromCharCode(raw.readUInt16BE(i * 2));
        return str;
    } else if (tag === "numstr") {
        var numstr = buffer.raw().toString("ascii");
        if (!this._isNumstr(numstr)) return buffer.error("Decoding of string type: numstr unsupported characters");
        return numstr;
    } else if (tag === "octstr") return buffer.raw();
    else if (tag === "objDesc") return buffer.raw();
    else if (tag === "printstr") {
        var printstr = buffer.raw().toString("ascii");
        if (!this._isPrintstr(printstr)) return buffer.error("Decoding of string type: printstr unsupported characters");
        return printstr;
    } else if (/str$/.test(tag)) return buffer.raw().toString();
    else return buffer.error("Decoding of string type: " + tag + " unsupported");
};
$00829b27548afa16$var$DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
    var result;
    var identifiers = [];
    var ident = 0;
    var subident = 0;
    while(!buffer.isEmpty()){
        subident = buffer.readUInt8();
        ident <<= 7;
        ident |= subident & 0x7f;
        if ((subident & 0x80) === 0) {
            identifiers.push(ident);
            ident = 0;
        }
    }
    if (subident & 0x80) identifiers.push(ident);
    var first = identifiers[0] / 40 | 0;
    var second = identifiers[0] % 40;
    if (relative) result = identifiers;
    else result = [
        first,
        second
    ].concat(identifiers.slice(1));
    if (values) {
        var tmp = values[result.join(" ")];
        if (tmp === undefined) tmp = values[result.join(".")];
        if (tmp !== undefined) result = tmp;
    }
    return result;
};
$00829b27548afa16$var$DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
    var str = buffer.raw().toString();
    var year;
    var mon;
    var day;
    var hour;
    var min;
    var sec;
    if (tag === "gentime") {
        year = str.slice(0, 4) | 0;
        mon = str.slice(4, 6) | 0;
        day = str.slice(6, 8) | 0;
        hour = str.slice(8, 10) | 0;
        min = str.slice(10, 12) | 0;
        sec = str.slice(12, 14) | 0;
    } else if (tag === "utctime") {
        year = str.slice(0, 2) | 0;
        mon = str.slice(2, 4) | 0;
        day = str.slice(4, 6) | 0;
        hour = str.slice(6, 8) | 0;
        min = str.slice(8, 10) | 0;
        sec = str.slice(10, 12) | 0;
        if (year < 70) year = 2000 + year;
        else year = 1900 + year;
    } else return buffer.error("Decoding " + tag + " time is not supported yet");
    return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};
$00829b27548afa16$var$DERNode.prototype._decodeNull = function decodeNull() {
    return null;
};
$00829b27548afa16$var$DERNode.prototype._decodeBool = function decodeBool(buffer) {
    var res = buffer.readUInt8();
    if (buffer.isError(res)) return res;
    else return res !== 0;
};
$00829b27548afa16$var$DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
    // Bigint, return as it is (assume big endian)
    var raw = buffer.raw();
    var res = new $blRDm(raw);
    if (values) res = values[res.toString(10)] || res;
    return res;
};
$00829b27548afa16$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === "function") entity = entity(obj);
    return entity._getDecoder("der").tree;
};
// Utility methods
function $00829b27548afa16$var$derDecodeTag(buf, fail) {
    var tag = buf.readUInt8(fail);
    if (buf.isError(tag)) return tag;
    var cls = $9CP3j.tagClass[tag >> 6];
    var primitive = (tag & 0x20) === 0;
    // Multi-octet tag - load
    if ((tag & 0x1f) === 0x1f) {
        var oct = tag;
        tag = 0;
        while((oct & 0x80) === 0x80){
            oct = buf.readUInt8(fail);
            if (buf.isError(oct)) return oct;
            tag <<= 7;
            tag |= oct & 0x7f;
        }
    } else tag &= 0x1f;
    var tagStr = $9CP3j.tag[tag];
    return {
        cls: cls,
        primitive: primitive,
        tag: tag,
        tagStr: tagStr
    };
}
function $00829b27548afa16$var$derDecodeLen(buf, primitive, fail) {
    var len = buf.readUInt8(fail);
    if (buf.isError(len)) return len;
    // Indefinite form
    if (!primitive && len === 0x80) return null;
    // Definite form
    if ((len & 0x80) === 0) // Short form
    return len;
    // Long form
    var num = len & 0x7f;
    if (num > 4) return buf.error("length octect is too long");
    len = 0;
    for(var i = 0; i < num; i++){
        len <<= 8;
        var j = buf.readUInt8(fail);
        if (buf.isError(j)) return j;
        len |= j;
    }
    return len;
}

});

parcelRegister("8rMOX", function(module, exports) {
"use strict";

var $hwgCU = parcelRequire("hwgCU");

var $lwNfX = parcelRequire("lwNfX");
var $6266b722304a237f$require$Buffer = $lwNfX.Buffer;

var $02In3 = parcelRequire("02In3");
function $6266b722304a237f$var$PEMDecoder(entity) {
    $02In3.call(this, entity);
    this.enc = "pem";
}
$hwgCU($6266b722304a237f$var$PEMDecoder, $02In3);
module.exports = $6266b722304a237f$var$PEMDecoder;
$6266b722304a237f$var$PEMDecoder.prototype.decode = function decode(data, options) {
    var lines = data.toString().split(/[\r\n]+/g);
    var label = options.label.toUpperCase();
    var re = /^-----(BEGIN|END) ([^-]+)-----$/;
    var start = -1;
    var end = -1;
    for(var i = 0; i < lines.length; i++){
        var match = lines[i].match(re);
        if (match === null) continue;
        if (match[2] !== label) continue;
        if (start === -1) {
            if (match[1] !== "BEGIN") break;
            start = i;
        } else {
            if (match[1] !== "END") break;
            end = i;
            break;
        }
    }
    if (start === -1 || end === -1) throw new Error("PEM section not found for: " + label);
    var base64 = lines.slice(start + 1, end).join("");
    // Remove excessive symbols
    base64.replace(/[^a-z0-9+/=]+/gi, "");
    var input = $6266b722304a237f$require$Buffer.from(base64, "base64");
    return $02In3.prototype.decode.call(this, input, options);
};

});



parcelRegister("bGIA7", function(module, exports) {
"use strict";
var $882632eb34b48c07$var$base = module.exports;

$882632eb34b48c07$var$base.Reporter = (parcelRequire("eRMR9")).Reporter;

$882632eb34b48c07$var$base.DecoderBuffer = (parcelRequire("dx1y7")).DecoderBuffer;

$882632eb34b48c07$var$base.EncoderBuffer = (parcelRequire("dx1y7")).EncoderBuffer;

$882632eb34b48c07$var$base.Node = (parcelRequire("gF4FC"));

});

parcelRegister("lSXPm", function(module, exports) {
"use strict";
var $feed0c9653b2ab71$var$constants = module.exports;
// Helper
$feed0c9653b2ab71$var$constants._reverse = function reverse(map) {
    var res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        var value = map[key];
        res[value] = key;
    });
    return res;
};

$feed0c9653b2ab71$var$constants.der = (parcelRequire("9CP3j"));

});


parcelRegister("ffLik", function(module, exports) {
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen
"use strict";

var $gUmgU = parcelRequire("gUmgU");
var $b1acf17930accb12$var$Time = $gUmgU.define("Time", function() {
    this.choice({
        utcTime: this.utctime(),
        generalTime: this.gentime()
    });
});
var $b1acf17930accb12$var$AttributeTypeValue = $gUmgU.define("AttributeTypeValue", function() {
    this.seq().obj(this.key("type").objid(), this.key("value").any());
});
var $b1acf17930accb12$var$AlgorithmIdentifier = $gUmgU.define("AlgorithmIdentifier", function() {
    this.seq().obj(this.key("algorithm").objid(), this.key("parameters").optional(), this.key("curve").objid().optional());
});
var $b1acf17930accb12$var$SubjectPublicKeyInfo = $gUmgU.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(this.key("algorithm").use($b1acf17930accb12$var$AlgorithmIdentifier), this.key("subjectPublicKey").bitstr());
});
var $b1acf17930accb12$var$RelativeDistinguishedName = $gUmgU.define("RelativeDistinguishedName", function() {
    this.setof($b1acf17930accb12$var$AttributeTypeValue);
});
var $b1acf17930accb12$var$RDNSequence = $gUmgU.define("RDNSequence", function() {
    this.seqof($b1acf17930accb12$var$RelativeDistinguishedName);
});
var $b1acf17930accb12$var$Name = $gUmgU.define("Name", function() {
    this.choice({
        rdnSequence: this.use($b1acf17930accb12$var$RDNSequence)
    });
});
var $b1acf17930accb12$var$Validity = $gUmgU.define("Validity", function() {
    this.seq().obj(this.key("notBefore").use($b1acf17930accb12$var$Time), this.key("notAfter").use($b1acf17930accb12$var$Time));
});
var $b1acf17930accb12$var$Extension = $gUmgU.define("Extension", function() {
    this.seq().obj(this.key("extnID").objid(), this.key("critical").bool().def(false), this.key("extnValue").octstr());
});
var $b1acf17930accb12$var$TBSCertificate = $gUmgU.define("TBSCertificate", function() {
    this.seq().obj(this.key("version").explicit(0).int().optional(), this.key("serialNumber").int(), this.key("signature").use($b1acf17930accb12$var$AlgorithmIdentifier), this.key("issuer").use($b1acf17930accb12$var$Name), this.key("validity").use($b1acf17930accb12$var$Validity), this.key("subject").use($b1acf17930accb12$var$Name), this.key("subjectPublicKeyInfo").use($b1acf17930accb12$var$SubjectPublicKeyInfo), this.key("issuerUniqueID").implicit(1).bitstr().optional(), this.key("subjectUniqueID").implicit(2).bitstr().optional(), this.key("extensions").explicit(3).seqof($b1acf17930accb12$var$Extension).optional());
});
var $b1acf17930accb12$var$X509Certificate = $gUmgU.define("X509Certificate", function() {
    this.seq().obj(this.key("tbsCertificate").use($b1acf17930accb12$var$TBSCertificate), this.key("signatureAlgorithm").use($b1acf17930accb12$var$AlgorithmIdentifier), this.key("signatureValue").bitstr());
});
module.exports = $b1acf17930accb12$var$X509Certificate;

});


parcelRegister("5ALlJ", function(module, exports) {
module.exports = JSON.parse('{"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}');

});

parcelRegister("dhIis", function(module, exports) {
// adapted from https://github.com/apatil/pemstrip
var $9abf39518c1b7fe8$var$findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m;
var $9abf39518c1b7fe8$var$startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;
var $9abf39518c1b7fe8$var$fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m;

var $31WmI = parcelRequire("31WmI");

var $aRQ6l = parcelRequire("aRQ6l");

var $f6JDE = parcelRequire("f6JDE");
var $9abf39518c1b7fe8$require$Buffer = $f6JDE.Buffer;
module.exports = function(okey, password) {
    var key = okey.toString();
    var match = key.match($9abf39518c1b7fe8$var$findProc);
    var decrypted;
    if (!match) {
        var match2 = key.match($9abf39518c1b7fe8$var$fullRegex);
        decrypted = $9abf39518c1b7fe8$require$Buffer.from(match2[2].replace(/[\r\n]/g, ""), "base64");
    } else {
        var suite = "aes" + match[1];
        var iv = $9abf39518c1b7fe8$require$Buffer.from(match[2], "hex");
        var cipherText = $9abf39518c1b7fe8$require$Buffer.from(match[3].replace(/[\r\n]/g, ""), "base64");
        var cipherKey = $31WmI(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
        var out = [];
        var cipher = $aRQ6l.createDecipheriv(suite, cipherKey, iv);
        out.push(cipher.update(cipherText));
        out.push(cipher.final());
        decrypted = $9abf39518c1b7fe8$require$Buffer.concat(out);
    }
    var tag = key.match($9abf39518c1b7fe8$var$startRegex)[1];
    return {
        tag: tag,
        data: decrypted
    };
};

});


parcelRegister("a05id", function(module, exports) {
module.exports = JSON.parse('{"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}');

});


parcelRegister("9yqcM", function(module, exports) {
// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js

var $f6JDE = parcelRequire("f6JDE");
var $6f4b9dd39bf9ffee$require$Buffer = $f6JDE.Buffer;

var $7qixM = parcelRequire("7qixM");

var $4z21a = parcelRequire("4z21a");
var $6f4b9dd39bf9ffee$require$EC = $4z21a.ec;

var $gBWPR = parcelRequire("gBWPR");

var $a05id = parcelRequire("a05id");
function $6f4b9dd39bf9ffee$var$verify(sig, hash, key, signType, tag) {
    var pub = $gBWPR(key);
    if (pub.type === "ec") {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== "ecdsa" && signType !== "ecdsa/rsa") throw new Error("wrong public key type");
        return $6f4b9dd39bf9ffee$var$ecVerify(sig, hash, pub);
    } else if (pub.type === "dsa") {
        if (signType !== "dsa") throw new Error("wrong public key type");
        return $6f4b9dd39bf9ffee$var$dsaVerify(sig, hash, pub);
    } else {
        if (signType !== "rsa" && signType !== "ecdsa/rsa") throw new Error("wrong public key type");
    }
    hash = $6f4b9dd39bf9ffee$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = pub.modulus.byteLength();
    var pad = [
        1
    ];
    var padNum = 0;
    while(hash.length + pad.length + 2 < len){
        pad.push(0xff);
        padNum++;
    }
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    pad = $6f4b9dd39bf9ffee$require$Buffer.from(pad);
    var red = $7qixM.mont(pub.modulus);
    sig = new $7qixM(sig).toRed(red);
    sig = sig.redPow(new $7qixM(pub.publicExponent));
    sig = $6f4b9dd39bf9ffee$require$Buffer.from(sig.fromRed().toArray());
    var out = padNum < 8 ? 1 : 0;
    len = Math.min(sig.length, pad.length);
    if (sig.length !== pad.length) out = 1;
    i = -1;
    while(++i < len)out |= sig[i] ^ pad[i];
    return out === 0;
}
function $6f4b9dd39bf9ffee$var$ecVerify(sig, hash, pub) {
    var curveId = $a05id[pub.data.algorithm.curve.join(".")];
    if (!curveId) throw new Error("unknown curve " + pub.data.algorithm.curve.join("."));
    var curve = new $6f4b9dd39bf9ffee$require$EC(curveId);
    var pubkey = pub.data.subjectPrivateKey.data;
    return curve.verify(hash, sig, pubkey);
}
function $6f4b9dd39bf9ffee$var$dsaVerify(sig, hash, pub) {
    var p = pub.data.p;
    var q = pub.data.q;
    var g = pub.data.g;
    var y = pub.data.pub_key;
    var unpacked = $gBWPR.signature.decode(sig, "der");
    var s = unpacked.s;
    var r = unpacked.r;
    $6f4b9dd39bf9ffee$var$checkValue(s, q);
    $6f4b9dd39bf9ffee$var$checkValue(r, q);
    var montp = $7qixM.mont(p);
    var w = s.invm(q);
    var v = g.toRed(montp).redPow(new $7qixM(hash).mul(w).mod(q)).fromRed().mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed()).mod(p).mod(q);
    return v.cmp(r) === 0;
}
function $6f4b9dd39bf9ffee$var$checkValue(b, q) {
    if (b.cmpn(0) <= 0) throw new Error("invalid sig");
    if (b.cmp(q) >= q) throw new Error("invalid sig");
}
module.exports = $6f4b9dd39bf9ffee$var$verify;

});


parcelRegister("b7rlI", function(module, exports) {

var $8dlmd = parcelRequire("8dlmd");
var $8185902b2e97f0ee$require$Buffer = $8dlmd.Buffer;

var $4z21a = parcelRequire("4z21a");

var $blRDm = parcelRequire("blRDm");
module.exports = function createECDH(curve) {
    return new $8185902b2e97f0ee$var$ECDH(curve);
};
var $8185902b2e97f0ee$var$aliases = {
    secp256k1: {
        name: "secp256k1",
        byteLength: 32
    },
    secp224r1: {
        name: "p224",
        byteLength: 28
    },
    prime256v1: {
        name: "p256",
        byteLength: 32
    },
    prime192v1: {
        name: "p192",
        byteLength: 24
    },
    ed25519: {
        name: "ed25519",
        byteLength: 32
    },
    secp384r1: {
        name: "p384",
        byteLength: 48
    },
    secp521r1: {
        name: "p521",
        byteLength: 66
    }
};
$8185902b2e97f0ee$var$aliases.p224 = $8185902b2e97f0ee$var$aliases.secp224r1;
$8185902b2e97f0ee$var$aliases.p256 = $8185902b2e97f0ee$var$aliases.secp256r1 = $8185902b2e97f0ee$var$aliases.prime256v1;
$8185902b2e97f0ee$var$aliases.p192 = $8185902b2e97f0ee$var$aliases.secp192r1 = $8185902b2e97f0ee$var$aliases.prime192v1;
$8185902b2e97f0ee$var$aliases.p384 = $8185902b2e97f0ee$var$aliases.secp384r1;
$8185902b2e97f0ee$var$aliases.p521 = $8185902b2e97f0ee$var$aliases.secp521r1;
function $8185902b2e97f0ee$var$ECDH(curve) {
    this.curveType = $8185902b2e97f0ee$var$aliases[curve];
    if (!this.curveType) this.curveType = {
        name: curve
    };
    this.curve = new $4z21a.ec(this.curveType.name) // eslint-disable-line new-cap
    ;
    this.keys = void 0;
}
$8185902b2e97f0ee$var$ECDH.prototype.generateKeys = function(enc, format) {
    this.keys = this.curve.genKeyPair();
    return this.getPublicKey(enc, format);
};
$8185902b2e97f0ee$var$ECDH.prototype.computeSecret = function(other, inenc, enc) {
    inenc = inenc || "utf8";
    if (!$8185902b2e97f0ee$require$Buffer.isBuffer(other)) other = new $8185902b2e97f0ee$require$Buffer(other, inenc);
    var otherPub = this.curve.keyFromPublic(other).getPublic();
    var out = otherPub.mul(this.keys.getPrivate()).getX();
    return $8185902b2e97f0ee$var$formatReturnValue(out, enc, this.curveType.byteLength);
};
$8185902b2e97f0ee$var$ECDH.prototype.getPublicKey = function(enc, format) {
    var key = this.keys.getPublic(format === "compressed", true);
    if (format === "hybrid") {
        if (key[key.length - 1] % 2) key[0] = 7;
        else key[0] = 6;
    }
    return $8185902b2e97f0ee$var$formatReturnValue(key, enc);
};
$8185902b2e97f0ee$var$ECDH.prototype.getPrivateKey = function(enc) {
    return $8185902b2e97f0ee$var$formatReturnValue(this.keys.getPrivate(), enc);
};
$8185902b2e97f0ee$var$ECDH.prototype.setPublicKey = function(pub, enc) {
    enc = enc || "utf8";
    if (!$8185902b2e97f0ee$require$Buffer.isBuffer(pub)) pub = new $8185902b2e97f0ee$require$Buffer(pub, enc);
    this.keys._importPublic(pub);
    return this;
};
$8185902b2e97f0ee$var$ECDH.prototype.setPrivateKey = function(priv, enc) {
    enc = enc || "utf8";
    if (!$8185902b2e97f0ee$require$Buffer.isBuffer(priv)) priv = new $8185902b2e97f0ee$require$Buffer(priv, enc);
    var _priv = new $blRDm(priv);
    _priv = _priv.toString(16);
    this.keys = this.curve.genKeyPair();
    this.keys._importPrivate(_priv);
    return this;
};
function $8185902b2e97f0ee$var$formatReturnValue(bn, enc, len) {
    if (!Array.isArray(bn)) bn = bn.toArray();
    var buf = new $8185902b2e97f0ee$require$Buffer(bn);
    if (len && buf.length < len) {
        var zeros = new $8185902b2e97f0ee$require$Buffer(len - buf.length);
        zeros.fill(0);
        buf = $8185902b2e97f0ee$require$Buffer.concat([
            zeros,
            buf
        ]);
    }
    if (!enc) return buf;
    else return buf.toString(enc);
}

});

parcelRegister("e3PEx", function(module, exports) {

$parcel$export(module.exports, "publicEncrypt", function () { return $a3c969a86af48f93$export$512823e338ddb1b7; }, function (v) { return $a3c969a86af48f93$export$512823e338ddb1b7 = v; });
$parcel$export(module.exports, "privateDecrypt", function () { return $a3c969a86af48f93$export$7efb24e2fddf99b9; }, function (v) { return $a3c969a86af48f93$export$7efb24e2fddf99b9 = v; });
$parcel$export(module.exports, "privateEncrypt", function () { return $a3c969a86af48f93$export$9d0e0c0c4a8d30f3; }, function (v) { return $a3c969a86af48f93$export$9d0e0c0c4a8d30f3 = v; });
$parcel$export(module.exports, "publicDecrypt", function () { return $a3c969a86af48f93$export$b9d55ff329113abd; }, function (v) { return $a3c969a86af48f93$export$b9d55ff329113abd = v; });
var $a3c969a86af48f93$export$512823e338ddb1b7;
var $a3c969a86af48f93$export$7efb24e2fddf99b9;
var $a3c969a86af48f93$export$9d0e0c0c4a8d30f3;
var $a3c969a86af48f93$export$b9d55ff329113abd;

$a3c969a86af48f93$export$512823e338ddb1b7 = (parcelRequire("eWpx7"));

$a3c969a86af48f93$export$7efb24e2fddf99b9 = (parcelRequire("ePg1G"));
$a3c969a86af48f93$export$9d0e0c0c4a8d30f3 = function privateEncrypt(key, buf) {
    return $a3c969a86af48f93$export$512823e338ddb1b7(key, buf, true);
};
$a3c969a86af48f93$export$b9d55ff329113abd = function publicDecrypt(key, buf) {
    return $a3c969a86af48f93$export$7efb24e2fddf99b9(key, buf, true);
};

});
parcelRegister("eWpx7", function(module, exports) {

var $gBWPR = parcelRequire("gBWPR");

var $3JQ6x = parcelRequire("3JQ6x");

var $iX9BE = parcelRequire("iX9BE");

var $cJJlZ = parcelRequire("cJJlZ");

var $i7xPa = parcelRequire("i7xPa");

var $blRDm = parcelRequire("blRDm");

var $58Kta = parcelRequire("58Kta");

var $ckQX1 = parcelRequire("ckQX1");

var $f6JDE = parcelRequire("f6JDE");
var $ae0a49cdf46338ac$require$Buffer = $f6JDE.Buffer;
module.exports = function publicEncrypt(publicKey, msg, reverse) {
    var padding;
    if (publicKey.padding) padding = publicKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $gBWPR(publicKey);
    var paddedMsg;
    if (padding === 4) paddedMsg = $ae0a49cdf46338ac$var$oaep(key, msg);
    else if (padding === 1) paddedMsg = $ae0a49cdf46338ac$var$pkcs1(key, msg, reverse);
    else if (padding === 3) {
        paddedMsg = new $blRDm(msg);
        if (paddedMsg.cmp(key.modulus) >= 0) throw new Error("data too long for modulus");
    } else throw new Error("unknown padding");
    if (reverse) return $ckQX1(paddedMsg, key);
    else return $58Kta(paddedMsg, key);
};
function $ae0a49cdf46338ac$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var mLen = msg.length;
    var iHash = $iX9BE("sha1").update($ae0a49cdf46338ac$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    var hLen2 = 2 * hLen;
    if (mLen > k - hLen2 - 2) throw new Error("message too long");
    var ps = $ae0a49cdf46338ac$require$Buffer.alloc(k - mLen - hLen2 - 2);
    var dblen = k - hLen - 1;
    var seed = $3JQ6x(hLen);
    var maskedDb = $i7xPa($ae0a49cdf46338ac$require$Buffer.concat([
        iHash,
        ps,
        $ae0a49cdf46338ac$require$Buffer.alloc(1, 1),
        msg
    ], dblen), $cJJlZ(seed, dblen));
    var maskedSeed = $i7xPa(seed, $cJJlZ(maskedDb, hLen));
    return new $blRDm($ae0a49cdf46338ac$require$Buffer.concat([
        $ae0a49cdf46338ac$require$Buffer.alloc(1),
        maskedSeed,
        maskedDb
    ], k));
}
function $ae0a49cdf46338ac$var$pkcs1(key, msg, reverse) {
    var mLen = msg.length;
    var k = key.modulus.byteLength();
    if (mLen > k - 11) throw new Error("message too long");
    var ps;
    if (reverse) ps = $ae0a49cdf46338ac$require$Buffer.alloc(k - mLen - 3, 0xff);
    else ps = $ae0a49cdf46338ac$var$nonZero(k - mLen - 3);
    return new $blRDm($ae0a49cdf46338ac$require$Buffer.concat([
        $ae0a49cdf46338ac$require$Buffer.from([
            0,
            reverse ? 1 : 2
        ]),
        ps,
        $ae0a49cdf46338ac$require$Buffer.alloc(1),
        msg
    ], k));
}
function $ae0a49cdf46338ac$var$nonZero(len) {
    var out = $ae0a49cdf46338ac$require$Buffer.allocUnsafe(len);
    var i = 0;
    var cache = $3JQ6x(len * 2);
    var cur = 0;
    var num;
    while(i < len){
        if (cur === cache.length) {
            cache = $3JQ6x(len * 2);
            cur = 0;
        }
        num = cache[cur++];
        if (num) out[i++] = num;
    }
    return out;
}

});
parcelRegister("cJJlZ", function(module, exports) {

var $iX9BE = parcelRequire("iX9BE");

var $f6JDE = parcelRequire("f6JDE");
var $945cde4fd521e368$require$Buffer = $f6JDE.Buffer;
module.exports = function(seed, len) {
    var t = $945cde4fd521e368$require$Buffer.alloc(0);
    var i = 0;
    var c;
    while(t.length < len){
        c = $945cde4fd521e368$var$i2ops(i++);
        t = $945cde4fd521e368$require$Buffer.concat([
            t,
            $iX9BE("sha1").update(seed).update(c).digest()
        ]);
    }
    return t.slice(0, len);
};
function $945cde4fd521e368$var$i2ops(c) {
    var out = $945cde4fd521e368$require$Buffer.allocUnsafe(4);
    out.writeUInt32BE(c, 0);
    return out;
}

});

parcelRegister("i7xPa", function(module, exports) {
module.exports = function xor(a, b) {
    var len = a.length;
    var i = -1;
    while(++i < len)a[i] ^= b[i];
    return a;
};

});

parcelRegister("58Kta", function(module, exports) {

var $blRDm = parcelRequire("blRDm");

var $f6JDE = parcelRequire("f6JDE");
var $3be1befd59ecab7e$require$Buffer = $f6JDE.Buffer;
function $3be1befd59ecab7e$var$withPublic(paddedMsg, key) {
    return $3be1befd59ecab7e$require$Buffer.from(paddedMsg.toRed($blRDm.mont(key.modulus)).redPow(new $blRDm(key.publicExponent)).fromRed().toArray());
}
module.exports = $3be1befd59ecab7e$var$withPublic;

});


parcelRegister("ePg1G", function(module, exports) {

var $gBWPR = parcelRequire("gBWPR");

var $cJJlZ = parcelRequire("cJJlZ");

var $i7xPa = parcelRequire("i7xPa");

var $blRDm = parcelRequire("blRDm");

var $ckQX1 = parcelRequire("ckQX1");

var $iX9BE = parcelRequire("iX9BE");

var $58Kta = parcelRequire("58Kta");

var $f6JDE = parcelRequire("f6JDE");
var $acb24294048a9576$require$Buffer = $f6JDE.Buffer;
module.exports = function privateDecrypt(privateKey, enc, reverse) {
    var padding;
    if (privateKey.padding) padding = privateKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $gBWPR(privateKey);
    var k = key.modulus.byteLength();
    if (enc.length > k || new $blRDm(enc).cmp(key.modulus) >= 0) throw new Error("decryption error");
    var msg;
    if (reverse) msg = $58Kta(new $blRDm(enc), key);
    else msg = $ckQX1(enc, key);
    var zBuffer = $acb24294048a9576$require$Buffer.alloc(k - msg.length);
    msg = $acb24294048a9576$require$Buffer.concat([
        zBuffer,
        msg
    ], k);
    if (padding === 4) return $acb24294048a9576$var$oaep(key, msg);
    else if (padding === 1) return $acb24294048a9576$var$pkcs1(key, msg, reverse);
    else if (padding === 3) return msg;
    else throw new Error("unknown padding");
};
function $acb24294048a9576$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var iHash = $iX9BE("sha1").update($acb24294048a9576$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    if (msg[0] !== 0) throw new Error("decryption error");
    var maskedSeed = msg.slice(1, hLen + 1);
    var maskedDb = msg.slice(hLen + 1);
    var seed = $i7xPa(maskedSeed, $cJJlZ(maskedDb, hLen));
    var db = $i7xPa(maskedDb, $cJJlZ(seed, k - hLen - 1));
    if ($acb24294048a9576$var$compare(iHash, db.slice(0, hLen))) throw new Error("decryption error");
    var i = hLen;
    while(db[i] === 0)i++;
    if (db[i++] !== 1) throw new Error("decryption error");
    return db.slice(i);
}
function $acb24294048a9576$var$pkcs1(key, msg, reverse) {
    var p1 = msg.slice(0, 2);
    var i = 2;
    var status = 0;
    while(msg[i++] !== 0)if (i >= msg.length) {
        status++;
        break;
    }
    var ps = msg.slice(2, i - 1);
    if (p1.toString("hex") !== "0002" && !reverse || p1.toString("hex") !== "0001" && reverse) status++;
    if (ps.length < 8) status++;
    if (status) throw new Error("decryption error");
    return msg.slice(i);
}
function $acb24294048a9576$var$compare(a, b) {
    a = $acb24294048a9576$require$Buffer.from(a);
    b = $acb24294048a9576$require$Buffer.from(b);
    var dif = 0;
    var len = a.length;
    if (a.length !== b.length) {
        dif++;
        len = Math.min(a.length, b.length);
    }
    var i = -1;
    while(++i < len)dif += a[i] ^ b[i];
    return dif;
}

});


parcelRegister("2R97P", function(module, exports) {

$parcel$export(module.exports, "randomFill", function () { return $21479c18642af883$export$bb1abf2ce84fc7e8; }, function (v) { return $21479c18642af883$export$bb1abf2ce84fc7e8 = v; });
$parcel$export(module.exports, "randomFillSync", function () { return $21479c18642af883$export$2f7171e78e524d5e; }, function (v) { return $21479c18642af883$export$2f7171e78e524d5e = v; });
var $21479c18642af883$export$bb1abf2ce84fc7e8;
var $21479c18642af883$export$2f7171e78e524d5e;

var $3qWgZ = parcelRequire("3qWgZ");
"use strict";
function $21479c18642af883$var$oldBrowser() {
    throw new Error("secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11");
}

var $f6JDE = parcelRequire("f6JDE");

var $3JQ6x = parcelRequire("3JQ6x");
var $21479c18642af883$var$Buffer = $f6JDE.Buffer;
var $21479c18642af883$var$kBufferMaxLength = $f6JDE.kMaxLength;
var $21479c18642af883$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
var $21479c18642af883$var$kMaxUint32 = Math.pow(2, 32) - 1;
function $21479c18642af883$var$assertOffset(offset, length) {
    if (typeof offset !== "number" || offset !== offset) throw new TypeError("offset must be a number");
    if (offset > $21479c18642af883$var$kMaxUint32 || offset < 0) throw new TypeError("offset must be a uint32");
    if (offset > $21479c18642af883$var$kBufferMaxLength || offset > length) throw new RangeError("offset out of range");
}
function $21479c18642af883$var$assertSize(size, offset, length) {
    if (typeof size !== "number" || size !== size) throw new TypeError("size must be a number");
    if (size > $21479c18642af883$var$kMaxUint32 || size < 0) throw new TypeError("size must be a uint32");
    if (size + offset > length || size > $21479c18642af883$var$kBufferMaxLength) throw new RangeError("buffer too small");
}
if ($21479c18642af883$var$crypto && $21479c18642af883$var$crypto.getRandomValues || false) {
    $21479c18642af883$export$bb1abf2ce84fc7e8 = $21479c18642af883$var$randomFill;
    $21479c18642af883$export$2f7171e78e524d5e = $21479c18642af883$var$randomFillSync;
} else {
    $21479c18642af883$export$bb1abf2ce84fc7e8 = $21479c18642af883$var$oldBrowser;
    $21479c18642af883$export$2f7171e78e524d5e = $21479c18642af883$var$oldBrowser;
}
function $21479c18642af883$var$randomFill(buf, offset, size, cb) {
    if (!$21479c18642af883$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof offset === "function") {
        cb = offset;
        offset = 0;
        size = buf.length;
    } else if (typeof size === "function") {
        cb = size;
        size = buf.length - offset;
    } else if (typeof cb !== "function") throw new TypeError('"cb" argument must be a function');
    $21479c18642af883$var$assertOffset(offset, buf.length);
    $21479c18642af883$var$assertSize(size, offset, buf.length);
    return $21479c18642af883$var$actualFill(buf, offset, size, cb);
}
function $21479c18642af883$var$actualFill(buf, offset, size, cb) {
    var ourBuf = buf.buffer;
    var uint = new Uint8Array(ourBuf, offset, size);
    $21479c18642af883$var$crypto.getRandomValues(uint);
    if (cb) {
        $3qWgZ.nextTick(function() {
            cb(null, buf);
        });
        return;
    }
    return buf;
    if (cb) {
        $3JQ6x(size, function(err, bytes) {
            if (err) return cb(err);
            bytes.copy(buf, offset);
            cb(null, buf);
        });
        return;
    }
    var bytes = $3JQ6x(size);
    bytes.copy(buf, offset);
    return buf;
}
function $21479c18642af883$var$randomFillSync(buf, offset, size) {
    if (typeof offset === "undefined") offset = 0;
    if (!$21479c18642af883$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    $21479c18642af883$var$assertOffset(offset, buf.length);
    if (size === undefined) size = buf.length - offset;
    $21479c18642af883$var$assertSize(size, offset, buf.length);
    return $21479c18642af883$var$actualFill(buf, offset, size);
}

});





parcelRegister("ddYYi", function(module, exports) {
$parcel$export(module.exports, "AsyncResult", function () { return (parcelRequire("HSGiS")).AsyncResult; });
$parcel$export(module.exports, "useAISAvailableProducts", function () { return (parcelRequire("cjq8z")).useAISAvailableProducts; });
$parcel$export(module.exports, "useBXPExpressClient", function () { return (parcelRequire("bp6Uh")).useBXPExpressClient; });
$parcel$export(module.exports, "useCofsClient", function () { return (parcelRequire("1PgDH")).useCofsClient; });
parcelRequire("HSGiS");
parcelRequire("cjq8z");
parcelRequire("8FrtF");
parcelRequire("bp6Uh");
parcelRequire("8IMyc");

var $7heDW = parcelRequire("7heDW");
parcelRequire("fbkIc");
parcelRequire("f4Ki3");
parcelRequire("1PgDH");
parcelRequire("5p5UA");
parcelRequire("8d7jm");

var $gDtmg = parcelRequire("gDtmg");

var $1uofz = parcelRequire("1uofz");

var $7UnWs = parcelRequire("7UnWs");
parcelRequire("3pymB");
parcelRequire("lRxFc");
parcelRequire("g7fcJ");
parcelRequire("gqYfG");
$parcel$exportWildcard(module.exports, $7heDW);
$parcel$exportWildcard(module.exports, $gDtmg);
$parcel$exportWildcard(module.exports, $1uofz);
$parcel$exportWildcard(module.exports, $7UnWs);

});
parcelRegister("HSGiS", function(module, exports) {

$parcel$export(module.exports, "useAsync", function () { return $63eb0ce72cea7e86$export$cdf1dc76b55502e3; });
$parcel$export(module.exports, "AsyncResult", function () { return $63eb0ce72cea7e86$export$3b98ae54dec9c881; });
/* eslint-disable @typescript-eslint/explicit-member-accessibility */ 
var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $cv9Rk = parcelRequire("cv9Rk");

var $FuVm8 = parcelRequire("FuVm8");

var $ohfOJ = parcelRequire("ohfOJ");

var $1Mpn7 = parcelRequire("1Mpn7");
function $63eb0ce72cea7e86$export$cdf1dc76b55502e3(task, dependencies) {
    var _useState = (0, $cv9Rk._)((0, $1Mpn7.useState)($63eb0ce72cea7e86$export$3b98ae54dec9c881.pending()), 2), result = _useState[0], setResult = _useState[1];
    (0, $1Mpn7.useEffect)(function() {
        var inEffect = true;
        task().then(function(value) {
            if (inEffect) setResult($63eb0ce72cea7e86$export$3b98ae54dec9c881.complete(value));
        }).catch(function(error) {
            if (inEffect) setResult($63eb0ce72cea7e86$export$3b98ae54dec9c881.error(error));
        });
        return function() {
            inEffect = false;
        };
    }, dependencies);
    return result;
}
var $63eb0ce72cea7e86$export$3b98ae54dec9c881 = /*#__PURE__*/ function() {
    "use strict";
    function AsyncResult(isPending) {
        (0, $4GJKx._)(this, AsyncResult);
        this.isPending = isPending;
    }
    (0, $1wc17._)(AsyncResult, null, [
        {
            key: "pending",
            value: function pending() {
                return new $63eb0ce72cea7e86$var$PendingAsyncResult();
            }
        },
        {
            key: "complete",
            value: function complete(value) {
                return new $63eb0ce72cea7e86$var$CompleteAsyncResult(value);
            }
        },
        {
            key: "error",
            value: function error(error) {
                return new $63eb0ce72cea7e86$var$ErrorAsyncResult(error);
            }
        },
        {
            key: "isPending",
            value: function isPending(result) {
                return result.isPending === true;
            }
        },
        {
            key: "isComplete",
            value: function isComplete(result) {
                return result.isPending === false && result.error === undefined;
            }
        },
        {
            key: "isError",
            value: function isError(result) {
                return result.isPending === false && result.error !== undefined;
            }
        }
    ]);
    return AsyncResult;
}();
var $63eb0ce72cea7e86$var$PendingAsyncResult = /*#__PURE__*/ function(AsyncResult) {
    "use strict";
    (0, $dcsZi._)(PendingAsyncResult, AsyncResult);
    var _super = (0, $ohfOJ._)(PendingAsyncResult);
    function PendingAsyncResult() {
        (0, $4GJKx._)(this, PendingAsyncResult);
        return _super.call(this, true);
    }
    (0, $1wc17._)(PendingAsyncResult, [
        {
            key: "map",
            value: function map() {
                return new PendingAsyncResult();
            }
        },
        {
            key: "catch",
            value: function _catch() {
                return this;
            }
        },
        {
            key: "value",
            get: function get() {
                throw new Error("AsyncResult is pending...");
            }
        }
    ]);
    return PendingAsyncResult;
}($63eb0ce72cea7e86$export$3b98ae54dec9c881);
var $63eb0ce72cea7e86$var$CompleteAsyncResult = /*#__PURE__*/ function(AsyncResult) {
    "use strict";
    (0, $dcsZi._)(CompleteAsyncResult, AsyncResult);
    var _super = (0, $ohfOJ._)(CompleteAsyncResult);
    function CompleteAsyncResult(value) {
        (0, $4GJKx._)(this, CompleteAsyncResult);
        var _this;
        _this = _super.call(this, false);
        _this.value = value;
        return _this;
    }
    (0, $1wc17._)(CompleteAsyncResult, [
        {
            key: "map",
            value: function map(mapper) {
                return new CompleteAsyncResult(mapper(this.value));
            }
        },
        {
            key: "catch",
            value: function _catch() {
                return this;
            }
        }
    ]);
    return CompleteAsyncResult;
}($63eb0ce72cea7e86$export$3b98ae54dec9c881);
var $63eb0ce72cea7e86$var$ErrorAsyncResult = /*#__PURE__*/ function(AsyncResult) {
    "use strict";
    (0, $dcsZi._)(ErrorAsyncResult, AsyncResult);
    var _super = (0, $ohfOJ._)(ErrorAsyncResult);
    function ErrorAsyncResult(error) {
        (0, $4GJKx._)(this, ErrorAsyncResult);
        var _this;
        _this = _super.call(this, false);
        _this.error = error;
        return _this;
    }
    (0, $1wc17._)(ErrorAsyncResult, [
        {
            key: "map",
            value: function map() {
                return new ErrorAsyncResult(this.error);
            }
        },
        {
            key: "catch",
            value: function _catch(catcher) {
                return new $63eb0ce72cea7e86$var$CompleteAsyncResult(catcher(this.error));
            }
        },
        {
            key: "value",
            get: function get() {
                throw new $63eb0ce72cea7e86$export$36212ba89a98b1ce(this.error);
            }
        }
    ]);
    return ErrorAsyncResult;
}($63eb0ce72cea7e86$export$3b98ae54dec9c881);
var $63eb0ce72cea7e86$export$36212ba89a98b1ce = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $dcsZi._)(AsyncResultError, Error1);
    var _super = (0, $ohfOJ._)(AsyncResultError);
    function AsyncResultError(cause) {
        (0, $4GJKx._)(this, AsyncResultError);
        var _this;
        _this = _super.call(this, cause.message);
        _this.cause = cause;
        _this.name = AsyncResultError.name;
        return _this;
    }
    return AsyncResultError;
}((0, $FuVm8._)(Error));

});

parcelRegister("cjq8z", function(module, exports) {

$parcel$export(module.exports, "useAISAvailableProducts", function () { return $80ed9f267d84bba0$export$3691a5908e1c8031; });
parcelRequire("eb65f");
var $8JWVu = parcelRequire("8JWVu");

var $HSGiS = parcelRequire("HSGiS");
function $80ed9f267d84bba0$export$5afbfe6edea8e998(param) {
    var includeInvalidSites = param.includeInvalidSites, includeInvalidBitbucketSite = param.includeInvalidBitbucketSite;
    var stargateClient = (0, $8JWVu.useBxpWebStargateClient)();
    return (0, $HSGiS.useAsync)(function() {
        return stargateClient.availableProductsLegacy({
            includeInvalidSites: includeInvalidSites,
            includeInvalidBitbucketSite: includeInvalidBitbucketSite
        });
    }, []);
}
function $80ed9f267d84bba0$export$3691a5908e1c8031(param) {
    var includeInvalidSites = param.includeInvalidSites, includeInvalidBitbucketSite = param.includeInvalidBitbucketSite, removeNonAdminSites = param.removeNonAdminSites;
    var stargateClient = (0, $8JWVu.useBxpWebStargateClient)();
    return (0, $HSGiS.useAsync)(function() {
        return stargateClient.availableProducts({
            includeInvalidSites: includeInvalidSites,
            includeInvalidBitbucketSite: includeInvalidBitbucketSite,
            removeNonAdminSites: removeNonAdminSites
        });
    }, []);
}

});

parcelRegister("8FrtF", function(module, exports) {
parcelRequire("eb65f");
var $8JWVu = parcelRequire("8JWVu");

var $HSGiS = parcelRequire("HSGiS");
function $7d368791e04fb522$export$8bf857d5a9c0ddbd(param) {
    var nextUrl = param.nextUrl, urlQuery = param.urlQuery, makeRequest = param.makeRequest;
    var stargateClient = (0, $8JWVu.useBxpWebStargateClient)();
    return (0, $HSGiS.useAsync)(function() {
        return makeRequest ? stargateClient.bitbucketWorkspaces({
            nextUrl: nextUrl,
            urlQuery: urlQuery
        }) : Promise.resolve(null);
    }, [
        makeRequest
    ]);
}

});

parcelRegister("bp6Uh", function(module, exports) {

$parcel$export(module.exports, "useBXPExpressClient", function () { return $553edeb5694687ce$export$c81a5c96f3f6ff; });

var $1rY3h = parcelRequire("1rY3h");

var $1Mpn7 = parcelRequire("1Mpn7");
parcelRequire("aQFSh");
var $kLYFI = parcelRequire("kLYFI");
var $553edeb5694687ce$var$BXPExpressClientContext = /*#__PURE__*/ (0, $1Mpn7.createContext)(new (0, $kLYFI.BXPExpressClient)());
function $553edeb5694687ce$export$c81a5c96f3f6ff() {
    return (0, $1Mpn7.useContext)($553edeb5694687ce$var$BXPExpressClientContext);
}
var $553edeb5694687ce$export$ea18f77333ecadff = function(param) {
    var client = param.client, children = param.children;
    return /*#__PURE__*/ (0, $1rY3h.jsx)($553edeb5694687ce$var$BXPExpressClientContext.Provider, {
        value: client,
        children: children
    });
};

});
parcelRegister("aQFSh", function(module, exports) {
$parcel$export(module.exports, "BXPExpressClient", function () { return (parcelRequire("kLYFI")).BXPExpressClient; });
parcelRequire("kLYFI");
parcelRequire("6NWU9");
parcelRequire("iZbsj");

});
parcelRegister("kLYFI", function(module, exports) {

$parcel$export(module.exports, "BXPExpressClient", function () { return $f1f74293f8c23ea9$export$61e0b35357cdbae1; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $l29cN = parcelRequire("l29cN");
parcelRequire("8pXts");
var $jyXh7 = parcelRequire("jyXh7");

var $hTD6v = parcelRequire("hTD6v");
var $f1f74293f8c23ea9$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $f1f74293f8c23ea9$export$61e0b35357cdbae1 = /*#__PURE__*/ function() {
    "use strict";
    function BXPExpressClient() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_baseUrl = _ref.baseUrl, baseUrl = _ref_baseUrl === void 0 ? BXPExpressClient.DEFAULT_BASE_URL : _ref_baseUrl;
        (0, $4GJKx._)(this, BXPExpressClient);
        this.baseUrl = baseUrl;
    }
    (0, $1wc17._)(BXPExpressClient, [
        {
            key: "getXsrfToken",
            value: function getXsrfToken() {
                return $f1f74293f8c23ea9$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $hTD6v.fetch)("".concat(this.baseUrl, "/auth/xsrf"), {
                                        method: "GET",
                                        credentials: "include",
                                        headers: {
                                            accept: "text/plain"
                                        }
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    (0, $jyXh7.mapResponseToText).apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "cloudSignupAnonymous",
            value: function cloudSignupAnonymous(param) {
                var payload = param.payload, cookies = param.cookies;
                return $f1f74293f8c23ea9$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $hTD6v.fetch)("".concat(this.baseUrl, "/cloud/signupAnon"), {
                                        method: "POST",
                                        headers: {
                                            "Content-Type": "application/json",
                                            "ATL-Cookies": JSON.stringify(cookies)
                                        },
                                        body: JSON.stringify(payload),
                                        credentials: "include"
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    (0, $jyXh7.mapResponseToJson).apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "marketplaceAppInstall",
            value: function marketplaceAppInstall(param) {
                var siteName = param.siteName, appKey = param.appKey, xsrfToken = param.xsrfToken;
                return $f1f74293f8c23ea9$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $hTD6v.fetch)("".concat(this.baseUrl, "/marketplace/app/install"), {
                                        method: "POST",
                                        headers: {
                                            "Content-Type": "application/json",
                                            "xsrf-token": xsrfToken
                                        },
                                        body: JSON.stringify({
                                            siteName: siteName,
                                            appKey: appKey
                                        }),
                                        credentials: "include"
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    (0, $jyXh7.mapResponseToJson).apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "cloudExpandFreeValidation",
            value: function cloudExpandFreeValidation(param) {
                var cloudId = param.cloudId, productKeys = param.productKeys, edition = param.edition;
                return $f1f74293f8c23ea9$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $hTD6v.fetch)("".concat(this.baseUrl, "/cloud/expand-free-validation"), {
                                        method: "POST",
                                        headers: {
                                            "Content-Type": "application/json"
                                        },
                                        body: JSON.stringify({
                                            cloudId: cloudId,
                                            productKeys: productKeys,
                                            edition: edition
                                        })
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    (0, $jyXh7.mapResponseToJson).apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "postBreachStatus",
            value: function postBreachStatus(param) {
                var payload = param.payload;
                return $f1f74293f8c23ea9$var$__awaiter(this, void 0, void 0, function() {
                    var options;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                options = {
                                    headers: {
                                        "content-type": "application/json"
                                    },
                                    method: "POST",
                                    body: JSON.stringify(payload)
                                };
                                return [
                                    4,
                                    (0, $hTD6v.fetch)("".concat(this.baseUrl, "/cloud/expand-free-validation"), options)
                                ];
                            case 1:
                                return [
                                    2,
                                    (0, $jyXh7.mapResponseToJson).apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "productEditionByCloudId",
            value: function productEditionByCloudId(param) {
                var cloudId = param.cloudId, productKey = param.productKey;
                return $f1f74293f8c23ea9$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $hTD6v.fetch)("".concat(this.baseUrl, "/cloud/edition/").concat(cloudId, "/").concat(productKey), {
                                        method: "GET",
                                        headers: {
                                            "Content-Type": "application/json"
                                        },
                                        credentials: "include"
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    (0, $jyXh7.mapResponseToJson).apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                });
            }
        }
    ]);
    return BXPExpressClient;
}();
$f1f74293f8c23ea9$export$61e0b35357cdbae1.DEFAULT_BASE_URL = "https://wac.stg.internal.atlassian.com/endpoint";

});

parcelRegister("6NWU9", function(module, exports) {

});

parcelRegister("iZbsj", function(module, exports) {

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $l29cN = parcelRequire("l29cN");
parcelRequire("8pXts");
var $bwbcq = parcelRequire("bwbcq");
var $jyXh7 = parcelRequire("jyXh7");

var $hTD6v = parcelRequire("hTD6v");
var $dd26cf5628a761b7$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $dd26cf5628a761b7$export$1ceed0deea1336a8 = /*#__PURE__*/ function() {
    "use strict";
    function BXPExpressStargateClient() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_baseUrl = _ref.baseUrl, baseUrl = _ref_baseUrl === void 0 ? BXPExpressStargateClient.DEFAULT_BASE_URL : _ref_baseUrl;
        (0, $4GJKx._)(this, BXPExpressStargateClient);
        this.baseUrl = baseUrl;
    }
    (0, $1wc17._)(BXPExpressStargateClient, [
        {
            key: "cloudSignup",
            value: function cloudSignup(param) {
                var payload = param.payload, cookies = param.cookies;
                return $dd26cf5628a761b7$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $hTD6v.fetch)("".concat(this.baseUrl, "/cloud/signup"), {
                                        method: "POST",
                                        headers: (0, $bwbcq.createHeaders)({
                                            "Content-Type": "application/json",
                                            "ATL-Cookies": JSON.stringify(cookies)
                                        }),
                                        body: JSON.stringify(payload),
                                        credentials: "include"
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    (0, $jyXh7.mapResponseToJson).apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                });
            }
        }
    ]);
    return BXPExpressStargateClient;
}();
$dd26cf5628a761b7$export$1ceed0deea1336a8.DEFAULT_BASE_URL = "https://wac.stg.internal.atlassian.com/gateway/api";

});



parcelRegister("8IMyc", function(module, exports) {

var $1rY3h = parcelRequire("1rY3h");

var $1Mpn7 = parcelRequire("1Mpn7");
parcelRequire("4rAus");
var $zyOx3 = parcelRequire("zyOx3");
var $219ef182e5e9b06b$var$HamletClientContext = /*#__PURE__*/ (0, $1Mpn7.createContext)(new (0, $zyOx3.HamletClient)());
function $219ef182e5e9b06b$export$94d042ccee1051af() {
    return (0, $1Mpn7.useContext)($219ef182e5e9b06b$var$HamletClientContext);
}
var $219ef182e5e9b06b$export$f53b47fb37a12ee6 = function(param) {
    var client = param.client, children = param.children;
    return /*#__PURE__*/ (0, $1rY3h.jsx)($219ef182e5e9b06b$var$HamletClientContext.Provider, {
        value: client,
        children: children
    });
};

});

parcelRegister("7heDW", function(module, exports) {
// import { PricingCalculation } from '@atlassian/bxp-product-pricing';
// import { PricingPlan } from '@atlassian/bxp-product-pricing/dist/types/src/utils';
// import { usePricingCalculator } from '../contexts';
// import { AsyncResult, useAsync } from './use-async';
//
// export function useCalculation(
//   units: number,
//   pricingPlan: PricingPlan,
//   currencyIsoCode: string
// ): AsyncResult<PricingCalculation> {
//   const calculator = usePricingCalculator();
//   return useAsync(
//     () =>
//       calculator.calculatePriceWithPricingPlan({
//         units,
//         currencyIsoCode,
//         pricingPlan
//       }),
//     [units, pricingPlan, currencyIsoCode]
//   );
// }

});

parcelRegister("fbkIc", function(module, exports) {

var $1Mpn7 = parcelRequire("1Mpn7");
parcelRequire("ddvKW");
var $6es2I = parcelRequire("6es2I");

var $HSGiS = parcelRequire("HSGiS");
function $8fdda9c7d5cebb00$export$7e0ba394830a1349(cartId) {
    var hamletClient = (0, $1Mpn7.useContext)((0, $6es2I.HamletClientContext));
    return (0, $HSGiS.useAsync)(function() {
        return hamletClient.getCart({
            cartId: cartId
        });
    }, [
        cartId
    ]);
}

});

parcelRegister("f4Ki3", function(module, exports) {

var $1rY3h = parcelRequire("1rY3h");

var $1Mpn7 = parcelRequire("1Mpn7");
parcelRequire("Dz6PC");
var $9umL4 = parcelRequire("9umL4");
var $29e536b7b6e174e6$var$CnasClientContext = /*#__PURE__*/ (0, $1Mpn7.createContext)(new (0, $9umL4.CnasClient)());
function $29e536b7b6e174e6$export$7165ec39bb560eb0() {
    return (0, $1Mpn7.useContext)($29e536b7b6e174e6$var$CnasClientContext);
}
var $29e536b7b6e174e6$export$836c6aa381828af4 = function(param) {
    var client = param.client, children = param.children;
    return /*#__PURE__*/ (0, $1rY3h.jsx)($29e536b7b6e174e6$var$CnasClientContext.Provider, {
        value: client,
        children: children
    });
};

});
parcelRegister("Dz6PC", function(module, exports) {
$parcel$export(module.exports, "CnasClient", function () { return (parcelRequire("9umL4")).CnasClient; });
parcelRequire("9umL4");

});
parcelRegister("9umL4", function(module, exports) {

$parcel$export(module.exports, "CnasClient", function () { return $6e8891b7e884e97d$export$c8a7d4119cf45f9f; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $l29cN = parcelRequire("l29cN");
parcelRequire("8FQM6");
var $dmUnl = parcelRequire("dmUnl");
parcelRequire("8pXts");
var $jyXh7 = parcelRequire("jyXh7");

var $hTD6v = parcelRequire("hTD6v");
var $6e8891b7e884e97d$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $6e8891b7e884e97d$export$942ba04389b0d5a2 = "https://wac.stg.internal.atlassian.com/apis/stg/cnas";
var $6e8891b7e884e97d$export$690b5b24bd8551b7 = "https://www.atlassian.com/apis/prod/cnas";
var $6e8891b7e884e97d$export$92fa52c125cc0e5 = "cloud-name-availability";
var $6e8891b7e884e97d$export$c8a7d4119cf45f9f = /*#__PURE__*/ function() {
    "use strict";
    function CnasClient() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_baseUrl = _ref.baseUrl, baseUrl = _ref_baseUrl === void 0 ? $6e8891b7e884e97d$export$942ba04389b0d5a2 : _ref_baseUrl;
        (0, $4GJKx._)(this, CnasClient);
        this.baseUrl = baseUrl;
    }
    (0, $1wc17._)(CnasClient, [
        {
            key: "getNameAvailability",
            value: function getNameAvailability(param) {
                var cloudName = param.cloudName;
                return $6e8891b7e884e97d$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $hTD6v.fetch)("".concat(this.baseUrl, "/shopping-cart/name-availability/queries"), {
                                        method: "POST",
                                        headers: {
                                            "Content-Type": "application/json"
                                        },
                                        body: JSON.stringify({
                                            cloudName: cloudName
                                        })
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    (0, $jyXh7.mapResponseToJson).apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "cloudNameAvailabilityCheck",
            value: function cloudNameAvailabilityCheck(param) {
                var cloudName = param.cloudName, auth = param.auth;
                return $6e8891b7e884e97d$var$__awaiter(this, void 0, void 0, function() {
                    var headers;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                headers = new (0, $hTD6v.Headers)();
                                headers.append("Content-Type", "application/json");
                                headers.append("Authorization", (0, $dmUnl.generateAsapHeader)(Object.assign(Object.assign({}, auth.asap), {
                                    audience: $6e8891b7e884e97d$export$92fa52c125cc0e5
                                })));
                                return [
                                    4,
                                    (0, $hTD6v.fetch)("".concat(this.baseUrl, "/name-availability/check"), {
                                        method: "POST",
                                        headers: {
                                            "Content-Type": "application/json"
                                        },
                                        body: JSON.stringify({
                                            cloudName: cloudName
                                        })
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    (0, $jyXh7.mapResponseToJson).apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                });
            }
        }
    ]);
    return CnasClient;
}();

});
parcelRegister("8FQM6", function(module, exports) {
$parcel$export(module.exports, "generateAsapHeader", function () { return (parcelRequire("dmUnl")).generateAsapHeader; });
parcelRequire("bOhPV");
parcelRequire("31hKK");
parcelRequire("eDmKf");
parcelRequire("dmUnl");

});
parcelRegister("bOhPV", function(module, exports) {

});

parcelRegister("31hKK", function(module, exports) {

var $f3yl3 = parcelRequire("f3yl3");

var $29L6x = parcelRequire("29L6x");
var $232f3c7e34c776bf$export$b1b8b1f1ee84ab88 = 60;
function $232f3c7e34c776bf$export$cd2c2b98b16ce7fc(param) {
    var _param_payload = param.payload, payload = _param_payload === void 0 ? {} : _param_payload, privateKey = param.privateKey, keyId = param.keyId, _param_expiresIn = param.expiresIn, expiresIn = _param_expiresIn === void 0 ? $232f3c7e34c776bf$export$b1b8b1f1ee84ab88 : _param_expiresIn, audience = param.audience, issuer = param.issuer, _param_subject = param.subject, subject = _param_subject === void 0 ? issuer : _param_subject;
    return (0, $29L6x.sign)(payload, privateKey, {
        algorithm: "RS256",
        keyid: keyId,
        expiresIn: expiresIn,
        audience: audience,
        issuer: issuer,
        subject: subject,
        jwtid: (0, $f3yl3.randomBytes)(20).toString("hex")
    });
}

});
parcelRegister("29L6x", function(module, exports) {






module.exports = {
    decode: (parcelRequire("aJ2Ww")),
    verify: (parcelRequire("2Z5j7")),
    sign: (parcelRequire("26TDN")),
    JsonWebTokenError: (parcelRequire("1Rs0b")),
    NotBeforeError: (parcelRequire("f0TUW")),
    TokenExpiredError: (parcelRequire("cstwt"))
};

});
parcelRegister("aJ2Ww", function(module, exports) {

var $k6iCM = parcelRequire("k6iCM");
module.exports = function(jwt, options) {
    options = options || {};
    var decoded = $k6iCM.decode(jwt, options);
    if (!decoded) return null;
    var payload = decoded.payload;
    //try parse the payload
    if (typeof payload === "string") try {
        var obj = JSON.parse(payload);
        if (obj !== null && typeof obj === "object") payload = obj;
    } catch (e) {}
    //return header if `complete` option is enabled.  header includes claims
    //such as `kid` and `alg` used to select the key within a JWKS needed to
    //verify the signature
    if (options.complete === true) return {
        header: decoded.header,
        payload: payload,
        signature: decoded.signature
    };
    return payload;
};

});
parcelRegister("k6iCM", function(module, exports) {

$parcel$export(module.exports, "sign", function () { return $ea22d09db846874f$export$c5552dfdbc7cec71; }, function (v) { return $ea22d09db846874f$export$c5552dfdbc7cec71 = v; });
$parcel$export(module.exports, "verify", function () { return $ea22d09db846874f$export$532244b5b8b0b4b6; }, function (v) { return $ea22d09db846874f$export$532244b5b8b0b4b6 = v; });
$parcel$export(module.exports, "decode", function () { return $ea22d09db846874f$export$2f872c0f2117be69; }, function (v) { return $ea22d09db846874f$export$2f872c0f2117be69 = v; });
$parcel$export(module.exports, "createSign", function () { return $ea22d09db846874f$export$45df7cae684751af; }, function (v) { return $ea22d09db846874f$export$45df7cae684751af = v; });
/*global exports*/ var $ea22d09db846874f$export$6f6fa4628974a579;
var $ea22d09db846874f$export$c5552dfdbc7cec71;
var $ea22d09db846874f$export$532244b5b8b0b4b6;
var $ea22d09db846874f$export$2f872c0f2117be69;
var $ea22d09db846874f$export$1ea939691cdc45b8;
var $ea22d09db846874f$export$45df7cae684751af;
var $ea22d09db846874f$export$6f65485f87568e37;

var $dD7mS = parcelRequire("dD7mS");

var $Td10G = parcelRequire("Td10G");
var $ea22d09db846874f$var$ALGORITHMS = [
    "HS256",
    "HS384",
    "HS512",
    "RS256",
    "RS384",
    "RS512",
    "PS256",
    "PS384",
    "PS512",
    "ES256",
    "ES384",
    "ES512"
];
$ea22d09db846874f$export$6f6fa4628974a579 = $ea22d09db846874f$var$ALGORITHMS;
$ea22d09db846874f$export$c5552dfdbc7cec71 = $dD7mS.sign;
$ea22d09db846874f$export$532244b5b8b0b4b6 = $Td10G.verify;
$ea22d09db846874f$export$2f872c0f2117be69 = $Td10G.decode;
$ea22d09db846874f$export$1ea939691cdc45b8 = $Td10G.isValid;
$ea22d09db846874f$export$45df7cae684751af = function createSign(opts) {
    return new $dD7mS(opts);
};
$ea22d09db846874f$export$6f65485f87568e37 = function createVerify(opts) {
    return new $Td10G(opts);
};

});
parcelRegister("dD7mS", function(module, exports) {
/*global module*/ 
var $f6JDE = parcelRequire("f6JDE");
var $9ec4a207f28e5c46$require$Buffer = $f6JDE.Buffer;

var $141kN = parcelRequire("141kN");

var $gfoCJ = parcelRequire("gfoCJ");

var $l0FDA = parcelRequire("l0FDA");

var $iWbL3 = parcelRequire("iWbL3");

var $9h4Bq = parcelRequire("9h4Bq");
function $9ec4a207f28e5c46$var$base64url(string, encoding) {
    return $9ec4a207f28e5c46$require$Buffer.from(string, encoding).toString("base64").replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}
function $9ec4a207f28e5c46$var$jwsSecuredInput(header, payload, encoding) {
    encoding = encoding || "utf8";
    var encodedHeader = $9ec4a207f28e5c46$var$base64url($iWbL3(header), "binary");
    var encodedPayload = $9ec4a207f28e5c46$var$base64url($iWbL3(payload), encoding);
    return $9h4Bq.format("%s.%s", encodedHeader, encodedPayload);
}
function $9ec4a207f28e5c46$var$jwsSign(opts) {
    var header = opts.header;
    var payload = opts.payload;
    var secretOrKey = opts.secret || opts.privateKey;
    var encoding = opts.encoding;
    var algo = $gfoCJ(header.alg);
    var securedInput = $9ec4a207f28e5c46$var$jwsSecuredInput(header, payload, encoding);
    var signature = algo.sign(securedInput, secretOrKey);
    return $9h4Bq.format("%s.%s", securedInput, signature);
}
function $9ec4a207f28e5c46$var$SignStream(opts) {
    var secret = opts.secret || opts.privateKey || opts.key;
    var secretStream = new $141kN(secret);
    this.readable = true;
    this.header = opts.header;
    this.encoding = opts.encoding;
    this.secret = this.privateKey = this.key = secretStream;
    this.payload = new $141kN(opts.payload);
    this.secret.once("close", (function() {
        if (!this.payload.writable && this.readable) this.sign();
    }).bind(this));
    this.payload.once("close", (function() {
        if (!this.secret.writable && this.readable) this.sign();
    }).bind(this));
}
$9h4Bq.inherits($9ec4a207f28e5c46$var$SignStream, $l0FDA);
$9ec4a207f28e5c46$var$SignStream.prototype.sign = function sign() {
    try {
        var signature = $9ec4a207f28e5c46$var$jwsSign({
            header: this.header,
            payload: this.payload.buffer,
            secret: this.secret.buffer,
            encoding: this.encoding
        });
        this.emit("done", signature);
        this.emit("data", signature);
        this.emit("end");
        this.readable = false;
        return signature;
    } catch (e) {
        this.readable = false;
        this.emit("error", e);
        this.emit("close");
    }
};
$9ec4a207f28e5c46$var$SignStream.sign = $9ec4a207f28e5c46$var$jwsSign;
module.exports = $9ec4a207f28e5c46$var$SignStream;

});
parcelRegister("141kN", function(module, exports) {
/*global module, process*/ 
var $l0HdX = parcelRequire("l0HdX");

var $3qWgZ = parcelRequire("3qWgZ");

var $f6JDE = parcelRequire("f6JDE");
var $0c673326e9de3484$require$Buffer = $f6JDE.Buffer;

var $l0FDA = parcelRequire("l0FDA");

var $9h4Bq = parcelRequire("9h4Bq");
function $0c673326e9de3484$var$DataStream(data) {
    this.buffer = null;
    this.writable = true;
    this.readable = true;
    // No input
    if (!data) {
        this.buffer = $0c673326e9de3484$require$Buffer.alloc(0);
        return this;
    }
    // Stream
    if (typeof data.pipe === "function") {
        this.buffer = $0c673326e9de3484$require$Buffer.alloc(0);
        data.pipe(this);
        return this;
    }
    // Buffer or String
    // or Object (assumedly a passworded key)
    if (data.length || typeof data === "object") {
        this.buffer = data;
        this.writable = false;
        $3qWgZ.nextTick((function() {
            this.emit("end", data);
            this.readable = false;
            this.emit("close");
        }).bind(this));
        return this;
    }
    throw new TypeError("Unexpected data type (" + (typeof data === "undefined" ? "undefined" : (0, $l0HdX._)(data)) + ")");
}
$9h4Bq.inherits($0c673326e9de3484$var$DataStream, $l0FDA);
$0c673326e9de3484$var$DataStream.prototype.write = function write(data) {
    this.buffer = $0c673326e9de3484$require$Buffer.concat([
        this.buffer,
        $0c673326e9de3484$require$Buffer.from(data)
    ]);
    this.emit("data", data);
};
$0c673326e9de3484$var$DataStream.prototype.end = function end(data) {
    if (data) this.write(data);
    this.emit("end", data);
    this.emit("close");
    this.writable = false;
    this.readable = false;
};
module.exports = $0c673326e9de3484$var$DataStream;

});
parcelRegister("9h4Bq", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $l0HdX = parcelRequire("l0HdX");

var $3qWgZ = parcelRequire("3qWgZ");
var $6c094591c72a5da5$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $6c094591c72a5da5$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$6c094591c72a5da5$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($6c094591c72a5da5$var$inspect(arguments[i]));
        return objects.join(" ");
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($6c094591c72a5da5$var$formatRegExp, function(x) {
        if (x === "%%") return "%";
        if (i >= len) return x;
        switch(x){
            case "%s":
                return String(args[i++]);
            case "%d":
                return Number(args[i++]);
            case "%j":
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return "[Circular]";
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($6c094591c72a5da5$var$isNull(x) || !$6c094591c72a5da5$var$isObject(x)) str += " " + x;
    else str += " " + $6c094591c72a5da5$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    if (typeof $3qWgZ !== "undefined" && $3qWgZ.noDeprecation === true) return fn;
    // Allow for deprecating things in the process of starting up.
    if (typeof $3qWgZ === "undefined") return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($3qWgZ.throwDeprecation) throw new Error(msg);
            else if ($3qWgZ.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
};
var $6c094591c72a5da5$var$debugs = {};
var $6c094591c72a5da5$var$debugEnvRegex = /^$/;
var $6c094591c72a5da5$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$6c094591c72a5da5$var$debugs[set]) {
        if ($6c094591c72a5da5$var$debugEnvRegex.test(set)) {
            var pid = $3qWgZ.pid;
            $6c094591c72a5da5$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error("%s %d: %s", set, pid, msg);
            };
        } else $6c094591c72a5da5$var$debugs[set] = function() {};
    }
    return $6c094591c72a5da5$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $6c094591c72a5da5$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $6c094591c72a5da5$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($6c094591c72a5da5$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($6c094591c72a5da5$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($6c094591c72a5da5$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($6c094591c72a5da5$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($6c094591c72a5da5$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $6c094591c72a5da5$var$stylizeWithColor;
    return $6c094591c72a5da5$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $6c094591c72a5da5$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$6c094591c72a5da5$var$inspect.colors = {
    "bold": [
        1,
        22
    ],
    "italic": [
        3,
        23
    ],
    "underline": [
        4,
        24
    ],
    "inverse": [
        7,
        27
    ],
    "white": [
        37,
        39
    ],
    "grey": [
        90,
        39
    ],
    "black": [
        30,
        39
    ],
    "blue": [
        34,
        39
    ],
    "cyan": [
        36,
        39
    ],
    "green": [
        32,
        39
    ],
    "magenta": [
        35,
        39
    ],
    "red": [
        31,
        39
    ],
    "yellow": [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$6c094591c72a5da5$var$inspect.styles = {
    "special": "cyan",
    "number": "yellow",
    "boolean": "yellow",
    "undefined": "grey",
    "null": "bold",
    "string": "green",
    "date": "magenta",
    // "name": intentionally not styling
    "regexp": "red"
};
function $6c094591c72a5da5$var$stylizeWithColor(str, styleType) {
    var style = $6c094591c72a5da5$var$inspect.styles[styleType];
    if (style) return "\x1b[" + $6c094591c72a5da5$var$inspect.colors[style][0] + "m" + str + "\x1b[" + $6c094591c72a5da5$var$inspect.colors[style][1] + "m";
    else return str;
}
function $6c094591c72a5da5$var$stylizeNoColor(str, styleType) {
    return str;
}
function $6c094591c72a5da5$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $6c094591c72a5da5$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $6c094591c72a5da5$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$6c094591c72a5da5$var$isString(ret)) ret = $6c094591c72a5da5$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $6c094591c72a5da5$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $6c094591c72a5da5$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($6c094591c72a5da5$var$isError(value) && (keys.indexOf("message") >= 0 || keys.indexOf("description") >= 0)) return $6c094591c72a5da5$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($6c094591c72a5da5$var$isFunction(value)) {
            var name = value.name ? ": " + value.name : "";
            return ctx.stylize("[Function" + name + "]", "special");
        }
        if ($6c094591c72a5da5$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        if ($6c094591c72a5da5$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), "date");
        if ($6c094591c72a5da5$var$isError(value)) return $6c094591c72a5da5$var$formatError(value);
    }
    var base = "", array = false, braces = [
        "{",
        "}"
    ];
    // Make Array say that they are Array
    if ($6c094591c72a5da5$var$isArray(value)) {
        array = true;
        braces = [
            "[",
            "]"
        ];
    }
    // Make functions say that they are functions
    if ($6c094591c72a5da5$var$isFunction(value)) {
        var n = value.name ? ": " + value.name : "";
        base = " [Function" + n + "]";
    }
    // Make RegExps say that they are RegExps
    if ($6c094591c72a5da5$var$isRegExp(value)) base = " " + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($6c094591c72a5da5$var$isDate(value)) base = " " + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($6c094591c72a5da5$var$isError(value)) base = " " + $6c094591c72a5da5$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($6c094591c72a5da5$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        else return ctx.stylize("[Object]", "special");
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $6c094591c72a5da5$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $6c094591c72a5da5$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $6c094591c72a5da5$var$reduceToSingleString(output, base, braces);
}
function $6c094591c72a5da5$var$formatPrimitive(ctx, value) {
    if ($6c094591c72a5da5$var$isUndefined(value)) return ctx.stylize("undefined", "undefined");
    if ($6c094591c72a5da5$var$isString(value)) {
        var simple = "'" + JSON.stringify(value).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
        return ctx.stylize(simple, "string");
    }
    if ($6c094591c72a5da5$var$isNumber(value)) return ctx.stylize("" + value, "number");
    if ($6c094591c72a5da5$var$isBoolean(value)) return ctx.stylize("" + value, "boolean");
    // For some reason typeof null is "object", so special case here.
    if ($6c094591c72a5da5$var$isNull(value)) return ctx.stylize("null", "null");
}
function $6c094591c72a5da5$var$formatError(value) {
    return "[" + Error.prototype.toString.call(value) + "]";
}
function $6c094591c72a5da5$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($6c094591c72a5da5$var$hasOwnProperty(value, String(i))) output.push($6c094591c72a5da5$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push("");
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($6c094591c72a5da5$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $6c094591c72a5da5$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize("[Getter/Setter]", "special");
        else str = ctx.stylize("[Getter]", "special");
    } else if (desc.set) str = ctx.stylize("[Setter]", "special");
    if (!$6c094591c72a5da5$var$hasOwnProperty(visibleKeys, key)) name = "[" + key + "]";
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($6c094591c72a5da5$var$isNull(recurseTimes)) str = $6c094591c72a5da5$var$formatValue(ctx, desc.value, null);
            else str = $6c094591c72a5da5$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf("\n") > -1) {
                if (array) str = str.split("\n").map(function(line) {
                    return "  " + line;
                }).join("\n").slice(2);
                else str = "\n" + str.split("\n").map(function(line) {
                    return "   " + line;
                }).join("\n");
            }
        } else str = ctx.stylize("[Circular]", "special");
    }
    if ($6c094591c72a5da5$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify("" + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, "name");
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, "string");
        }
    }
    return name + ": " + str;
}
function $6c094591c72a5da5$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf("\n") >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, "").length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === "" ? "" : base + "\n ") + " " + output.join(",\n  ") + " " + braces[1];
    return braces[0] + base + " " + output.join(", ") + " " + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("hMGSV"));
function $6c094591c72a5da5$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $6c094591c72a5da5$var$isArray;
function $6c094591c72a5da5$var$isBoolean(arg) {
    return typeof arg === "boolean";
}
module.exports.isBoolean = $6c094591c72a5da5$var$isBoolean;
function $6c094591c72a5da5$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $6c094591c72a5da5$var$isNull;
function $6c094591c72a5da5$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $6c094591c72a5da5$var$isNullOrUndefined;
function $6c094591c72a5da5$var$isNumber(arg) {
    return typeof arg === "number";
}
module.exports.isNumber = $6c094591c72a5da5$var$isNumber;
function $6c094591c72a5da5$var$isString(arg) {
    return typeof arg === "string";
}
module.exports.isString = $6c094591c72a5da5$var$isString;
function $6c094591c72a5da5$var$isSymbol(arg) {
    return (typeof arg === "undefined" ? "undefined" : (0, $l0HdX._)(arg)) === "symbol";
}
module.exports.isSymbol = $6c094591c72a5da5$var$isSymbol;
function $6c094591c72a5da5$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $6c094591c72a5da5$var$isUndefined;
function $6c094591c72a5da5$var$isRegExp(re) {
    return $6c094591c72a5da5$var$isObject(re) && $6c094591c72a5da5$var$objectToString(re) === "[object RegExp]";
}
module.exports.isRegExp = $6c094591c72a5da5$var$isRegExp;
module.exports.types.isRegExp = $6c094591c72a5da5$var$isRegExp;
function $6c094591c72a5da5$var$isObject(arg) {
    return typeof arg === "object" && arg !== null;
}
module.exports.isObject = $6c094591c72a5da5$var$isObject;
function $6c094591c72a5da5$var$isDate(d) {
    return $6c094591c72a5da5$var$isObject(d) && $6c094591c72a5da5$var$objectToString(d) === "[object Date]";
}
module.exports.isDate = $6c094591c72a5da5$var$isDate;
module.exports.types.isDate = $6c094591c72a5da5$var$isDate;
function $6c094591c72a5da5$var$isError(e) {
    return $6c094591c72a5da5$var$isObject(e) && ($6c094591c72a5da5$var$objectToString(e) === "[object Error]" || e instanceof Error);
}
module.exports.isError = $6c094591c72a5da5$var$isError;
module.exports.types.isNativeError = $6c094591c72a5da5$var$isError;
function $6c094591c72a5da5$var$isFunction(arg) {
    return typeof arg === "function";
}
module.exports.isFunction = $6c094591c72a5da5$var$isFunction;
function $6c094591c72a5da5$var$isPrimitive(arg) {
    return arg === null || typeof arg === "boolean" || typeof arg === "number" || typeof arg === "string" || (typeof arg === "undefined" ? "undefined" : (0, $l0HdX._)(arg)) === "symbol" || // ES6 symbol
    typeof arg === "undefined";
}
module.exports.isPrimitive = $6c094591c72a5da5$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("j1W0B"));
function $6c094591c72a5da5$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $6c094591c72a5da5$var$pad(n) {
    return n < 10 ? "0" + n.toString(10) : n.toString(10);
}
var $6c094591c72a5da5$var$months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
// 26 Feb 16:19:34
function $6c094591c72a5da5$var$timestamp() {
    var d = new Date();
    var time = [
        $6c094591c72a5da5$var$pad(d.getHours()),
        $6c094591c72a5da5$var$pad(d.getMinutes()),
        $6c094591c72a5da5$var$pad(d.getSeconds())
    ].join(":");
    return [
        d.getDate(),
        $6c094591c72a5da5$var$months[d.getMonth()],
        time
    ].join(" ");
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log("%s - %s", $6c094591c72a5da5$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("hwgCU"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$6c094591c72a5da5$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $6c094591c72a5da5$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $6c094591c72a5da5$var$kCustomPromisifiedSymbol = typeof Symbol !== "undefined" ? Symbol("util.promisify.custom") : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
    if ($6c094591c72a5da5$var$kCustomPromisifiedSymbol && original[$6c094591c72a5da5$var$kCustomPromisifiedSymbol]) {
        var fn = original[$6c094591c72a5da5$var$kCustomPromisifiedSymbol];
        if (typeof fn !== "function") throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $6c094591c72a5da5$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($6c094591c72a5da5$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $6c094591c72a5da5$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $6c094591c72a5da5$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $6c094591c72a5da5$var$kCustomPromisifiedSymbol;
function $6c094591c72a5da5$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error("Promise was rejected with a falsy value");
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $6c094591c72a5da5$var$callbackify(original) {
    if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== "function") throw new TypeError("The last argument must be of type Function");
        var self = this;
        var cb = function cb() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $3qWgZ.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $3qWgZ.nextTick($6c094591c72a5da5$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $6c094591c72a5da5$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $6c094591c72a5da5$var$callbackify;

});
parcelRegister("hMGSV", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
"use strict";

var $j0N7T = parcelRequire("j0N7T");

var $bcv4e = parcelRequire("bcv4e");

var $lL7gm = parcelRequire("lL7gm");

var $bewCu = parcelRequire("bewCu");
function $cf282f690758f580$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $cf282f690758f580$var$BigIntSupported = typeof BigInt !== "undefined";
var $cf282f690758f580$var$SymbolSupported = typeof Symbol !== "undefined";
var $cf282f690758f580$var$ObjectToString = $cf282f690758f580$var$uncurryThis(Object.prototype.toString);
var $cf282f690758f580$var$numberValue = $cf282f690758f580$var$uncurryThis(Number.prototype.valueOf);
var $cf282f690758f580$var$stringValue = $cf282f690758f580$var$uncurryThis(String.prototype.valueOf);
var $cf282f690758f580$var$booleanValue = $cf282f690758f580$var$uncurryThis(Boolean.prototype.valueOf);
if ($cf282f690758f580$var$BigIntSupported) var $cf282f690758f580$var$bigIntValue = $cf282f690758f580$var$uncurryThis(BigInt.prototype.valueOf);
if ($cf282f690758f580$var$SymbolSupported) var $cf282f690758f580$var$symbolValue = $cf282f690758f580$var$uncurryThis(Symbol.prototype.valueOf);
function $cf282f690758f580$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== "object") return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $j0N7T;
module.exports.isGeneratorFunction = $bcv4e;
module.exports.isTypedArray = $bewCu;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $cf282f690758f580$var$isPromise(input) {
    return typeof Promise !== "undefined" && input instanceof Promise || input !== null && typeof input === "object" && typeof input.then === "function" && typeof input.catch === "function";
}
module.exports.isPromise = $cf282f690758f580$var$isPromise;
function $cf282f690758f580$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $bewCu(value) || $cf282f690758f580$var$isDataView(value);
}
module.exports.isArrayBufferView = $cf282f690758f580$var$isArrayBufferView;
function $cf282f690758f580$var$isUint8Array(value) {
    return $lL7gm(value) === "Uint8Array";
}
module.exports.isUint8Array = $cf282f690758f580$var$isUint8Array;
function $cf282f690758f580$var$isUint8ClampedArray(value) {
    return $lL7gm(value) === "Uint8ClampedArray";
}
module.exports.isUint8ClampedArray = $cf282f690758f580$var$isUint8ClampedArray;
function $cf282f690758f580$var$isUint16Array(value) {
    return $lL7gm(value) === "Uint16Array";
}
module.exports.isUint16Array = $cf282f690758f580$var$isUint16Array;
function $cf282f690758f580$var$isUint32Array(value) {
    return $lL7gm(value) === "Uint32Array";
}
module.exports.isUint32Array = $cf282f690758f580$var$isUint32Array;
function $cf282f690758f580$var$isInt8Array(value) {
    return $lL7gm(value) === "Int8Array";
}
module.exports.isInt8Array = $cf282f690758f580$var$isInt8Array;
function $cf282f690758f580$var$isInt16Array(value) {
    return $lL7gm(value) === "Int16Array";
}
module.exports.isInt16Array = $cf282f690758f580$var$isInt16Array;
function $cf282f690758f580$var$isInt32Array(value) {
    return $lL7gm(value) === "Int32Array";
}
module.exports.isInt32Array = $cf282f690758f580$var$isInt32Array;
function $cf282f690758f580$var$isFloat32Array(value) {
    return $lL7gm(value) === "Float32Array";
}
module.exports.isFloat32Array = $cf282f690758f580$var$isFloat32Array;
function $cf282f690758f580$var$isFloat64Array(value) {
    return $lL7gm(value) === "Float64Array";
}
module.exports.isFloat64Array = $cf282f690758f580$var$isFloat64Array;
function $cf282f690758f580$var$isBigInt64Array(value) {
    return $lL7gm(value) === "BigInt64Array";
}
module.exports.isBigInt64Array = $cf282f690758f580$var$isBigInt64Array;
function $cf282f690758f580$var$isBigUint64Array(value) {
    return $lL7gm(value) === "BigUint64Array";
}
module.exports.isBigUint64Array = $cf282f690758f580$var$isBigUint64Array;
function $cf282f690758f580$var$isMapToString(value) {
    return $cf282f690758f580$var$ObjectToString(value) === "[object Map]";
}
$cf282f690758f580$var$isMapToString.working = typeof Map !== "undefined" && $cf282f690758f580$var$isMapToString(new Map());
function $cf282f690758f580$var$isMap(value) {
    if (typeof Map === "undefined") return false;
    return $cf282f690758f580$var$isMapToString.working ? $cf282f690758f580$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $cf282f690758f580$var$isMap;
function $cf282f690758f580$var$isSetToString(value) {
    return $cf282f690758f580$var$ObjectToString(value) === "[object Set]";
}
$cf282f690758f580$var$isSetToString.working = typeof Set !== "undefined" && $cf282f690758f580$var$isSetToString(new Set());
function $cf282f690758f580$var$isSet(value) {
    if (typeof Set === "undefined") return false;
    return $cf282f690758f580$var$isSetToString.working ? $cf282f690758f580$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $cf282f690758f580$var$isSet;
function $cf282f690758f580$var$isWeakMapToString(value) {
    return $cf282f690758f580$var$ObjectToString(value) === "[object WeakMap]";
}
$cf282f690758f580$var$isWeakMapToString.working = typeof WeakMap !== "undefined" && $cf282f690758f580$var$isWeakMapToString(new WeakMap());
function $cf282f690758f580$var$isWeakMap(value) {
    if (typeof WeakMap === "undefined") return false;
    return $cf282f690758f580$var$isWeakMapToString.working ? $cf282f690758f580$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $cf282f690758f580$var$isWeakMap;
function $cf282f690758f580$var$isWeakSetToString(value) {
    return $cf282f690758f580$var$ObjectToString(value) === "[object WeakSet]";
}
$cf282f690758f580$var$isWeakSetToString.working = typeof WeakSet !== "undefined" && $cf282f690758f580$var$isWeakSetToString(new WeakSet());
function $cf282f690758f580$var$isWeakSet(value) {
    return $cf282f690758f580$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $cf282f690758f580$var$isWeakSet;
function $cf282f690758f580$var$isArrayBufferToString(value) {
    return $cf282f690758f580$var$ObjectToString(value) === "[object ArrayBuffer]";
}
$cf282f690758f580$var$isArrayBufferToString.working = typeof ArrayBuffer !== "undefined" && $cf282f690758f580$var$isArrayBufferToString(new ArrayBuffer());
function $cf282f690758f580$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === "undefined") return false;
    return $cf282f690758f580$var$isArrayBufferToString.working ? $cf282f690758f580$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $cf282f690758f580$var$isArrayBuffer;
function $cf282f690758f580$var$isDataViewToString(value) {
    return $cf282f690758f580$var$ObjectToString(value) === "[object DataView]";
}
$cf282f690758f580$var$isDataViewToString.working = typeof ArrayBuffer !== "undefined" && typeof DataView !== "undefined" && $cf282f690758f580$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $cf282f690758f580$var$isDataView(value) {
    if (typeof DataView === "undefined") return false;
    return $cf282f690758f580$var$isDataViewToString.working ? $cf282f690758f580$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $cf282f690758f580$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $cf282f690758f580$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== "undefined" ? SharedArrayBuffer : undefined;
function $cf282f690758f580$var$isSharedArrayBufferToString(value) {
    return $cf282f690758f580$var$ObjectToString(value) === "[object SharedArrayBuffer]";
}
function $cf282f690758f580$var$isSharedArrayBuffer(value) {
    if (typeof $cf282f690758f580$var$SharedArrayBufferCopy === "undefined") return false;
    if (typeof $cf282f690758f580$var$isSharedArrayBufferToString.working === "undefined") $cf282f690758f580$var$isSharedArrayBufferToString.working = $cf282f690758f580$var$isSharedArrayBufferToString(new $cf282f690758f580$var$SharedArrayBufferCopy());
    return $cf282f690758f580$var$isSharedArrayBufferToString.working ? $cf282f690758f580$var$isSharedArrayBufferToString(value) : value instanceof $cf282f690758f580$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $cf282f690758f580$var$isSharedArrayBuffer;
function $cf282f690758f580$var$isAsyncFunction(value) {
    return $cf282f690758f580$var$ObjectToString(value) === "[object AsyncFunction]";
}
module.exports.isAsyncFunction = $cf282f690758f580$var$isAsyncFunction;
function $cf282f690758f580$var$isMapIterator(value) {
    return $cf282f690758f580$var$ObjectToString(value) === "[object Map Iterator]";
}
module.exports.isMapIterator = $cf282f690758f580$var$isMapIterator;
function $cf282f690758f580$var$isSetIterator(value) {
    return $cf282f690758f580$var$ObjectToString(value) === "[object Set Iterator]";
}
module.exports.isSetIterator = $cf282f690758f580$var$isSetIterator;
function $cf282f690758f580$var$isGeneratorObject(value) {
    return $cf282f690758f580$var$ObjectToString(value) === "[object Generator]";
}
module.exports.isGeneratorObject = $cf282f690758f580$var$isGeneratorObject;
function $cf282f690758f580$var$isWebAssemblyCompiledModule(value) {
    return $cf282f690758f580$var$ObjectToString(value) === "[object WebAssembly.Module]";
}
module.exports.isWebAssemblyCompiledModule = $cf282f690758f580$var$isWebAssemblyCompiledModule;
function $cf282f690758f580$var$isNumberObject(value) {
    return $cf282f690758f580$var$checkBoxedPrimitive(value, $cf282f690758f580$var$numberValue);
}
module.exports.isNumberObject = $cf282f690758f580$var$isNumberObject;
function $cf282f690758f580$var$isStringObject(value) {
    return $cf282f690758f580$var$checkBoxedPrimitive(value, $cf282f690758f580$var$stringValue);
}
module.exports.isStringObject = $cf282f690758f580$var$isStringObject;
function $cf282f690758f580$var$isBooleanObject(value) {
    return $cf282f690758f580$var$checkBoxedPrimitive(value, $cf282f690758f580$var$booleanValue);
}
module.exports.isBooleanObject = $cf282f690758f580$var$isBooleanObject;
function $cf282f690758f580$var$isBigIntObject(value) {
    return $cf282f690758f580$var$BigIntSupported && $cf282f690758f580$var$checkBoxedPrimitive(value, $cf282f690758f580$var$bigIntValue);
}
module.exports.isBigIntObject = $cf282f690758f580$var$isBigIntObject;
function $cf282f690758f580$var$isSymbolObject(value) {
    return $cf282f690758f580$var$SymbolSupported && $cf282f690758f580$var$checkBoxedPrimitive(value, $cf282f690758f580$var$symbolValue);
}
module.exports.isSymbolObject = $cf282f690758f580$var$isSymbolObject;
function $cf282f690758f580$var$isBoxedPrimitive(value) {
    return $cf282f690758f580$var$isNumberObject(value) || $cf282f690758f580$var$isStringObject(value) || $cf282f690758f580$var$isBooleanObject(value) || $cf282f690758f580$var$isBigIntObject(value) || $cf282f690758f580$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $cf282f690758f580$var$isBoxedPrimitive;
function $cf282f690758f580$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== "undefined" && ($cf282f690758f580$var$isArrayBuffer(value) || $cf282f690758f580$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $cf282f690758f580$var$isAnyArrayBuffer;
[
    "isProxy",
    "isExternal",
    "isModuleNamespaceObject"
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function value() {
            throw new Error(method + " is not supported in userland");
        }
    });
});

});
parcelRegister("j0N7T", function(module, exports) {
"use strict";

var $dd741fdcca18722d$var$hasToStringTag = (parcelRequire("fwPQg"))();

var $7SltU = parcelRequire("7SltU");
var $dd741fdcca18722d$var$$toString = $7SltU("Object.prototype.toString");
var $dd741fdcca18722d$var$isStandardArguments = function isArguments(value) {
    if ($dd741fdcca18722d$var$hasToStringTag && value && typeof value === "object" && Symbol.toStringTag in value) return false;
    return $dd741fdcca18722d$var$$toString(value) === "[object Arguments]";
};
var $dd741fdcca18722d$var$isLegacyArguments = function isArguments(value) {
    if ($dd741fdcca18722d$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $dd741fdcca18722d$var$$toString(value) !== "[object Array]" && $dd741fdcca18722d$var$$toString(value.callee) === "[object Function]";
};
var $dd741fdcca18722d$var$supportsStandardArguments = function() {
    return $dd741fdcca18722d$var$isStandardArguments(arguments);
}();
$dd741fdcca18722d$var$isStandardArguments.isLegacyArguments = $dd741fdcca18722d$var$isLegacyArguments; // for tests
module.exports = $dd741fdcca18722d$var$supportsStandardArguments ? $dd741fdcca18722d$var$isStandardArguments : $dd741fdcca18722d$var$isLegacyArguments;

});
parcelRegister("fwPQg", function(module, exports) {
"use strict";

var $6Yg3A = parcelRequire("6Yg3A");
module.exports = function hasToStringTagShams() {
    return $6Yg3A() && !!Symbol.toStringTag;
};

});
parcelRegister("6Yg3A", function(module, exports) {

var $l0HdX = parcelRequire("l0HdX");
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if ((0, $l0HdX._)(Symbol.iterator) === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("7SltU", function(module, exports) {
"use strict";

var $i8ZMJ = parcelRequire("i8ZMJ");

var $fhZhY = parcelRequire("fhZhY");
var $5bbe3d48dff191e5$var$$indexOf = $fhZhY($i8ZMJ("String.prototype.indexOf"));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $i8ZMJ(name, !!allowMissing);
    if (typeof intrinsic === "function" && $5bbe3d48dff191e5$var$$indexOf(name, ".prototype.") > -1) return $fhZhY(intrinsic);
    return intrinsic;
};

});
parcelRegister("i8ZMJ", function(module, exports) {
"use strict";
var $d358e68f95a6c524$var$_$undefined;
var $d358e68f95a6c524$var$$SyntaxError = SyntaxError;
var $d358e68f95a6c524$var$$Function = Function;
var $d358e68f95a6c524$var$$TypeError = TypeError;
// eslint-disable-next-line consistent-return
var $d358e68f95a6c524$var$getEvalledConstructor = function getEvalledConstructor(expressionSyntax) {
    try {
        return $d358e68f95a6c524$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $d358e68f95a6c524$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($d358e68f95a6c524$var$$gOPD) try {
    $d358e68f95a6c524$var$$gOPD({}, "");
} catch (e) {
    $d358e68f95a6c524$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $d358e68f95a6c524$var$throwTypeError = function throwTypeError() {
    throw new $d358e68f95a6c524$var$$TypeError();
};
var $d358e68f95a6c524$var$ThrowTypeError = $d358e68f95a6c524$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $d358e68f95a6c524$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $d358e68f95a6c524$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $d358e68f95a6c524$var$throwTypeError;
        }
    }
}() : $d358e68f95a6c524$var$throwTypeError;

var $d358e68f95a6c524$var$hasSymbols = (parcelRequire("jlnB1"))();

var $d358e68f95a6c524$var$hasProto = (parcelRequire("a4DJV"))();
var $d358e68f95a6c524$var$getProto = Object.getPrototypeOf || ($d358e68f95a6c524$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $d358e68f95a6c524$var$needsEval = {};
var $d358e68f95a6c524$var$TypedArray = typeof Uint8Array === "undefined" || !$d358e68f95a6c524$var$getProto ? undefined : $d358e68f95a6c524$var$getProto(Uint8Array);
var $d358e68f95a6c524$var$INTRINSICS = {
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $d358e68f95a6c524$var$hasSymbols && $d358e68f95a6c524$var$getProto ? $d358e68f95a6c524$var$getProto([][Symbol.iterator]()) : undefined,
    "%AsyncFromSyncIteratorPrototype%": undefined,
    "%AsyncFunction%": $d358e68f95a6c524$var$needsEval,
    "%AsyncGenerator%": $d358e68f95a6c524$var$needsEval,
    "%AsyncGeneratorFunction%": $d358e68f95a6c524$var$needsEval,
    "%AsyncIteratorPrototype%": $d358e68f95a6c524$var$needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": Error,
    "%eval%": eval,
    "%EvalError%": EvalError,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry,
    "%Function%": $d358e68f95a6c524$var$$Function,
    "%GeneratorFunction%": $d358e68f95a6c524$var$needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $d358e68f95a6c524$var$hasSymbols && $d358e68f95a6c524$var$getProto ? $d358e68f95a6c524$var$getProto($d358e68f95a6c524$var$getProto([][Symbol.iterator]())) : undefined,
    "%JSON%": typeof JSON === "object" ? JSON : undefined,
    "%Map%": typeof Map === "undefined" ? undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$d358e68f95a6c524$var$hasSymbols || !$d358e68f95a6c524$var$getProto ? undefined : $d358e68f95a6c524$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
    "%RangeError%": RangeError,
    "%ReferenceError%": ReferenceError,
    "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$d358e68f95a6c524$var$hasSymbols || !$d358e68f95a6c524$var$getProto ? undefined : $d358e68f95a6c524$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $d358e68f95a6c524$var$hasSymbols && $d358e68f95a6c524$var$getProto ? $d358e68f95a6c524$var$getProto(""[Symbol.iterator]()) : undefined,
    "%Symbol%": $d358e68f95a6c524$var$hasSymbols ? Symbol : undefined,
    "%SyntaxError%": $d358e68f95a6c524$var$$SyntaxError,
    "%ThrowTypeError%": $d358e68f95a6c524$var$ThrowTypeError,
    "%TypedArray%": $d358e68f95a6c524$var$TypedArray,
    "%TypeError%": $d358e68f95a6c524$var$$TypeError,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
    "%URIError%": URIError,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet
};
if ($d358e68f95a6c524$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $d358e68f95a6c524$var$errorProto = $d358e68f95a6c524$var$getProto($d358e68f95a6c524$var$getProto(e));
    $d358e68f95a6c524$var$INTRINSICS["%Error.prototype%"] = $d358e68f95a6c524$var$errorProto;
}
var $d358e68f95a6c524$var$doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = $d358e68f95a6c524$var$getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = $d358e68f95a6c524$var$getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = $d358e68f95a6c524$var$getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && $d358e68f95a6c524$var$getProto) value = $d358e68f95a6c524$var$getProto(gen.prototype);
    }
    $d358e68f95a6c524$var$INTRINSICS[name] = value;
    return value;
};
var $d358e68f95a6c524$var$LEGACY_ALIASES = {
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};

var $i0Se7 = parcelRequire("i0Se7");

var $2rd5A = parcelRequire("2rd5A");
var $d358e68f95a6c524$var$$concat = $i0Se7.call(Function.call, Array.prototype.concat);
var $d358e68f95a6c524$var$$spliceApply = $i0Se7.call(Function.apply, Array.prototype.splice);
var $d358e68f95a6c524$var$$replace = $i0Se7.call(Function.call, String.prototype.replace);
var $d358e68f95a6c524$var$$strSlice = $i0Se7.call(Function.call, String.prototype.slice);
var $d358e68f95a6c524$var$$exec = $i0Se7.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $d358e68f95a6c524$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $d358e68f95a6c524$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $d358e68f95a6c524$var$stringToPath = function stringToPath(string) {
    var first = $d358e68f95a6c524$var$$strSlice(string, 0, 1);
    var last = $d358e68f95a6c524$var$$strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $d358e68f95a6c524$var$$SyntaxError("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $d358e68f95a6c524$var$$SyntaxError("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $d358e68f95a6c524$var$$replace(string, $d358e68f95a6c524$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $d358e68f95a6c524$var$$replace(subString, $d358e68f95a6c524$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $d358e68f95a6c524$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($2rd5A($d358e68f95a6c524$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $d358e68f95a6c524$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($2rd5A($d358e68f95a6c524$var$INTRINSICS, intrinsicName)) {
        var value = $d358e68f95a6c524$var$INTRINSICS[intrinsicName];
        if (value === $d358e68f95a6c524$var$needsEval) value = $d358e68f95a6c524$var$doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $d358e68f95a6c524$var$$TypeError("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $d358e68f95a6c524$var$$SyntaxError("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $d358e68f95a6c524$var$$TypeError("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $d358e68f95a6c524$var$$TypeError('"allowMissing" argument must be a boolean');
    if ($d358e68f95a6c524$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $d358e68f95a6c524$var$$SyntaxError("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = $d358e68f95a6c524$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $d358e68f95a6c524$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $d358e68f95a6c524$var$$spliceApply(parts, $d358e68f95a6c524$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $d358e68f95a6c524$var$$strSlice(part, 0, 1);
        var last = $d358e68f95a6c524$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $d358e68f95a6c524$var$$SyntaxError("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($2rd5A($d358e68f95a6c524$var$INTRINSICS, intrinsicRealName)) value = $d358e68f95a6c524$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $d358e68f95a6c524$var$$TypeError("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($d358e68f95a6c524$var$$gOPD && i + 1 >= parts.length) {
                var desc = $d358e68f95a6c524$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $2rd5A(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $d358e68f95a6c524$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("jlnB1", function(module, exports) {

var $l0HdX = parcelRequire("l0HdX");
"use strict";
var $e152482bba694be4$var$origSymbol = typeof Symbol !== "undefined" && Symbol;

var $6Yg3A = parcelRequire("6Yg3A");
module.exports = function hasNativeSymbols() {
    if (typeof $e152482bba694be4$var$origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if ((0, $l0HdX._)($e152482bba694be4$var$origSymbol("foo")) !== "symbol") return false;
    if ((0, $l0HdX._)(Symbol("bar")) !== "symbol") return false;
    return $6Yg3A();
};

});

parcelRegister("a4DJV", function(module, exports) {
"use strict";
var $75591a95a8f98f86$var$test = {
    foo: {}
};
var $75591a95a8f98f86$var$$Object = Object;
module.exports = function hasProto() {
    return ({
        __proto__: $75591a95a8f98f86$var$test
    }).foo === $75591a95a8f98f86$var$test.foo && !(({
        __proto__: null
    }) instanceof $75591a95a8f98f86$var$$Object);
};

});

parcelRegister("i0Se7", function(module, exports) {
"use strict";

var $i8DFG = parcelRequire("i8DFG");
module.exports = Function.prototype.bind || $i8DFG;

});
parcelRegister("i8DFG", function(module, exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var $d347bf40622b172c$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $d347bf40622b172c$var$toStr = Object.prototype.toString;
var $d347bf40622b172c$var$max = Math.max;
var $d347bf40622b172c$var$funcType = "[object Function]";
var $d347bf40622b172c$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $d347bf40622b172c$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $d347bf40622b172c$var$joiny = function joiny(arr, joiner) {
    var str = "";
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $d347bf40622b172c$var$toStr.apply(target) !== $d347bf40622b172c$var$funcType) throw new TypeError($d347bf40622b172c$var$ERROR_MESSAGE + target);
    var args = $d347bf40622b172c$var$slicy(arguments, 1);
    var bound;
    var binder = function binder() {
        if (this instanceof bound) {
            var result = target.apply(this, $d347bf40622b172c$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $d347bf40622b172c$var$concatty(args, arguments));
    };
    var boundLength = $d347bf40622b172c$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = "$" + i;
    bound = Function("binder", "return function (" + $d347bf40622b172c$var$joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("2rd5A", function(module, exports) {
"use strict";
var $1c68419f703464e2$var$hasOwnProperty = {}.hasOwnProperty;
var $1c68419f703464e2$var$call = Function.prototype.call;
module.exports = $1c68419f703464e2$var$call.bind ? $1c68419f703464e2$var$call.bind($1c68419f703464e2$var$hasOwnProperty) : function(O, P) {
    return $1c68419f703464e2$var$call.call($1c68419f703464e2$var$hasOwnProperty, O, P);
};

});


parcelRegister("fhZhY", function(module, exports) {
"use strict";

var $i0Se7 = parcelRequire("i0Se7");

var $i8ZMJ = parcelRequire("i8ZMJ");
var $b217fc3ec86ba4af$var$$apply = $i8ZMJ("%Function.prototype.apply%");
var $b217fc3ec86ba4af$var$$call = $i8ZMJ("%Function.prototype.call%");
var $b217fc3ec86ba4af$var$$reflectApply = $i8ZMJ("%Reflect.apply%", true) || $i0Se7.call($b217fc3ec86ba4af$var$$call, $b217fc3ec86ba4af$var$$apply);
var $b217fc3ec86ba4af$var$$gOPD = $i8ZMJ("%Object.getOwnPropertyDescriptor%", true);
var $b217fc3ec86ba4af$var$$defineProperty = $i8ZMJ("%Object.defineProperty%", true);
var $b217fc3ec86ba4af$var$$max = $i8ZMJ("%Math.max%");
if ($b217fc3ec86ba4af$var$$defineProperty) try {
    $b217fc3ec86ba4af$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $b217fc3ec86ba4af$var$$defineProperty = null;
}
module.exports = function callBind(originalFunction) {
    var func = $b217fc3ec86ba4af$var$$reflectApply($i0Se7, $b217fc3ec86ba4af$var$$call, arguments);
    if ($b217fc3ec86ba4af$var$$gOPD && $b217fc3ec86ba4af$var$$defineProperty) {
        var desc = $b217fc3ec86ba4af$var$$gOPD(func, "length");
        if (desc.configurable) // original length, plus the receiver, minus any additional arguments (after the receiver)
        $b217fc3ec86ba4af$var$$defineProperty(func, "length", {
            value: 1 + $b217fc3ec86ba4af$var$$max(0, originalFunction.length - (arguments.length - 1))
        });
    }
    return func;
};
var $b217fc3ec86ba4af$var$applyBind = function applyBind() {
    return $b217fc3ec86ba4af$var$$reflectApply($i0Se7, $b217fc3ec86ba4af$var$$apply, arguments);
};
if ($b217fc3ec86ba4af$var$$defineProperty) $b217fc3ec86ba4af$var$$defineProperty(module.exports, "apply", {
    value: $b217fc3ec86ba4af$var$applyBind
});
else module.exports.apply = $b217fc3ec86ba4af$var$applyBind;

});



parcelRegister("bcv4e", function(module, exports) {
"use strict";
var $8278ea0857f27bef$var$toStr = Object.prototype.toString;
var $8278ea0857f27bef$var$fnToStr = Function.prototype.toString;
var $8278ea0857f27bef$var$isFnRegex = /^\s*(?:function)?\*/;

var $8278ea0857f27bef$var$hasToStringTag = (parcelRequire("fwPQg"))();
var $8278ea0857f27bef$var$getProto = Object.getPrototypeOf;
var $8278ea0857f27bef$var$getGeneratorFunc = function getGeneratorFunc() {
    if (!$8278ea0857f27bef$var$hasToStringTag) return false;
    try {
        return Function("return function*() {}")();
    } catch (e) {}
};
var $8278ea0857f27bef$var$GeneratorFunction;
module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== "function") return false;
    if ($8278ea0857f27bef$var$isFnRegex.test($8278ea0857f27bef$var$fnToStr.call(fn))) return true;
    if (!$8278ea0857f27bef$var$hasToStringTag) {
        var str = $8278ea0857f27bef$var$toStr.call(fn);
        return str === "[object GeneratorFunction]";
    }
    if (!$8278ea0857f27bef$var$getProto) return false;
    if (typeof $8278ea0857f27bef$var$GeneratorFunction === "undefined") {
        var generatorFunc = $8278ea0857f27bef$var$getGeneratorFunc();
        $8278ea0857f27bef$var$GeneratorFunction = generatorFunc ? $8278ea0857f27bef$var$getProto(generatorFunc) : false;
    }
    return $8278ea0857f27bef$var$getProto(fn) === $8278ea0857f27bef$var$GeneratorFunction;
};

});

parcelRegister("lL7gm", function(module, exports) {
"use strict";

var $loi3l = parcelRequire("loi3l");

var $gGZLR = parcelRequire("gGZLR");

var $fhZhY = parcelRequire("fhZhY");

var $7SltU = parcelRequire("7SltU");

var $lulvK = parcelRequire("lulvK");
var $fd739f0a4dcad96d$var$$toString = $7SltU("Object.prototype.toString");

var $fd739f0a4dcad96d$var$hasToStringTag = (parcelRequire("fwPQg"))();
var $fd739f0a4dcad96d$var$g = typeof globalThis === "undefined" ? $parcel$global : globalThis;
var $fd739f0a4dcad96d$var$typedArrays = $gGZLR();
var $fd739f0a4dcad96d$var$$slice = $7SltU("String.prototype.slice");
var $fd739f0a4dcad96d$var$getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
var $fd739f0a4dcad96d$var$$indexOf = $7SltU("Array.prototype.indexOf", true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
var $fd739f0a4dcad96d$var$cache = {
    __proto__: null
};
if ($fd739f0a4dcad96d$var$hasToStringTag && $lulvK && $fd739f0a4dcad96d$var$getPrototypeOf) $loi3l($fd739f0a4dcad96d$var$typedArrays, function(typedArray) {
    var arr = new $fd739f0a4dcad96d$var$g[typedArray]();
    if (Symbol.toStringTag in arr) {
        var proto = $fd739f0a4dcad96d$var$getPrototypeOf(arr);
        var descriptor = $lulvK(proto, Symbol.toStringTag);
        if (!descriptor) {
            var superProto = $fd739f0a4dcad96d$var$getPrototypeOf(proto);
            descriptor = $lulvK(superProto, Symbol.toStringTag);
        }
        $fd739f0a4dcad96d$var$cache["$" + typedArray] = $fhZhY(descriptor.get);
    }
});
else $loi3l($fd739f0a4dcad96d$var$typedArrays, function(typedArray) {
    var arr = new $fd739f0a4dcad96d$var$g[typedArray]();
    $fd739f0a4dcad96d$var$cache["$" + typedArray] = $fhZhY(arr.slice);
});
var $fd739f0a4dcad96d$var$tryTypedArrays = function tryAllTypedArrays(value) {
    var found = false;
    $loi3l($fd739f0a4dcad96d$var$cache, function(getter, typedArray) {
        if (!found) try {
            if ("$" + getter(value) === typedArray) found = $fd739f0a4dcad96d$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
var $fd739f0a4dcad96d$var$trySlices = function tryAllSlices(value) {
    var found = false;
    $loi3l($fd739f0a4dcad96d$var$cache, function(getter, name) {
        if (!found) try {
            getter(value);
            found = $fd739f0a4dcad96d$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
};
module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== "object") return false;
    if (!$fd739f0a4dcad96d$var$hasToStringTag) {
        var tag = $fd739f0a4dcad96d$var$$slice($fd739f0a4dcad96d$var$$toString(value), 8, -1);
        if ($fd739f0a4dcad96d$var$$indexOf($fd739f0a4dcad96d$var$typedArrays, tag) > -1) return tag;
        if (tag !== "Object") return false;
        // node < 0.6 hits here on real Typed Arrays
        return $fd739f0a4dcad96d$var$trySlices(value);
    }
    if (!$lulvK) return null;
     // unknown engine
    return $fd739f0a4dcad96d$var$tryTypedArrays(value);
};

});
parcelRegister("loi3l", function(module, exports) {
"use strict";

var $mf7eV = parcelRequire("mf7eV");
var $f929d7d2e2ddd2cb$var$toStr = Object.prototype.toString;
var $f929d7d2e2ddd2cb$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $f929d7d2e2ddd2cb$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($f929d7d2e2ddd2cb$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
var $f929d7d2e2ddd2cb$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
var $f929d7d2e2ddd2cb$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($f929d7d2e2ddd2cb$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
var $f929d7d2e2ddd2cb$var$forEach = function forEach(list, iterator, thisArg) {
    if (!$mf7eV(iterator)) throw new TypeError("iterator must be a function");
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($f929d7d2e2ddd2cb$var$toStr.call(list) === "[object Array]") $f929d7d2e2ddd2cb$var$forEachArray(list, iterator, receiver);
    else if (typeof list === "string") $f929d7d2e2ddd2cb$var$forEachString(list, iterator, receiver);
    else $f929d7d2e2ddd2cb$var$forEachObject(list, iterator, receiver);
};
module.exports = $f929d7d2e2ddd2cb$var$forEach;

});
parcelRegister("mf7eV", function(module, exports) {
"use strict";
var $042dc7dd85f34ff9$var$fnToStr = Function.prototype.toString;
var $042dc7dd85f34ff9$var$reflectApply = typeof Reflect === "object" && Reflect !== null && Reflect.apply;
var $042dc7dd85f34ff9$var$badArrayLike;
var $042dc7dd85f34ff9$var$isCallableMarker;
if (typeof $042dc7dd85f34ff9$var$reflectApply === "function" && typeof Object.defineProperty === "function") try {
    $042dc7dd85f34ff9$var$badArrayLike = Object.defineProperty({}, "length", {
        get: function get() {
            throw $042dc7dd85f34ff9$var$isCallableMarker;
        }
    });
    $042dc7dd85f34ff9$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $042dc7dd85f34ff9$var$reflectApply(function() {
        throw 42;
    }, null, $042dc7dd85f34ff9$var$badArrayLike);
} catch (_) {
    if (_ !== $042dc7dd85f34ff9$var$isCallableMarker) $042dc7dd85f34ff9$var$reflectApply = null;
}
else $042dc7dd85f34ff9$var$reflectApply = null;
var $042dc7dd85f34ff9$var$constructorRegex = /^\s*class\b/;
var $042dc7dd85f34ff9$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $042dc7dd85f34ff9$var$fnToStr.call(value);
        return $042dc7dd85f34ff9$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $042dc7dd85f34ff9$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($042dc7dd85f34ff9$var$isES6ClassFn(value)) return false;
        $042dc7dd85f34ff9$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $042dc7dd85f34ff9$var$toStr = Object.prototype.toString;
var $042dc7dd85f34ff9$var$objectClass = "[object Object]";
var $042dc7dd85f34ff9$var$fnClass = "[object Function]";
var $042dc7dd85f34ff9$var$genClass = "[object GeneratorFunction]";
var $042dc7dd85f34ff9$var$ddaClass = "[object HTMLAllCollection]"; // IE 11
var $042dc7dd85f34ff9$var$ddaClass2 = "[object HTML document.all class]";
var $042dc7dd85f34ff9$var$ddaClass3 = "[object HTMLCollection]"; // IE 9-10
var $042dc7dd85f34ff9$var$hasToStringTag = typeof Symbol === "function" && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $042dc7dd85f34ff9$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $042dc7dd85f34ff9$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === "object") {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $042dc7dd85f34ff9$var$all = document.all;
    if ($042dc7dd85f34ff9$var$toStr.call($042dc7dd85f34ff9$var$all) === $042dc7dd85f34ff9$var$toStr.call(document.all)) $042dc7dd85f34ff9$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($042dc7dd85f34ff9$var$isIE68 || !value) && (typeof value === "undefined" || typeof value === "object")) try {
            var str = $042dc7dd85f34ff9$var$toStr.call(value);
            return (str === $042dc7dd85f34ff9$var$ddaClass || str === $042dc7dd85f34ff9$var$ddaClass2 || str === $042dc7dd85f34ff9$var$ddaClass3 // opera 12.16
             || str === $042dc7dd85f34ff9$var$objectClass // IE 6-8
            ) && value("") == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $042dc7dd85f34ff9$var$reflectApply ? function isCallable(value) {
    if ($042dc7dd85f34ff9$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== "function" && typeof value !== "object") return false;
    try {
        $042dc7dd85f34ff9$var$reflectApply(value, null, $042dc7dd85f34ff9$var$badArrayLike);
    } catch (e) {
        if (e !== $042dc7dd85f34ff9$var$isCallableMarker) return false;
    }
    return !$042dc7dd85f34ff9$var$isES6ClassFn(value) && $042dc7dd85f34ff9$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($042dc7dd85f34ff9$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== "function" && typeof value !== "object") return false;
    if ($042dc7dd85f34ff9$var$hasToStringTag) return $042dc7dd85f34ff9$var$tryFunctionObject(value);
    if ($042dc7dd85f34ff9$var$isES6ClassFn(value)) return false;
    var strClass = $042dc7dd85f34ff9$var$toStr.call(value);
    if (strClass !== $042dc7dd85f34ff9$var$fnClass && strClass !== $042dc7dd85f34ff9$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $042dc7dd85f34ff9$var$tryFunctionObject(value);
};

});


parcelRegister("gGZLR", function(module, exports) {
"use strict";
var $c2707c06914e978b$var$possibleNames = [
    "BigInt64Array",
    "BigUint64Array",
    "Float32Array",
    "Float64Array",
    "Int16Array",
    "Int32Array",
    "Int8Array",
    "Uint16Array",
    "Uint32Array",
    "Uint8Array",
    "Uint8ClampedArray"
];
var $c2707c06914e978b$var$g = typeof globalThis === "undefined" ? $parcel$global : globalThis;
module.exports = function availableTypedArrays() {
    var out = [];
    for(var i = 0; i < $c2707c06914e978b$var$possibleNames.length; i++)if (typeof $c2707c06914e978b$var$g[$c2707c06914e978b$var$possibleNames[i]] === "function") out[out.length] = $c2707c06914e978b$var$possibleNames[i];
    return out;
};

});

parcelRegister("lulvK", function(module, exports) {
"use strict";

var $i8ZMJ = parcelRequire("i8ZMJ");
var $fa4d15f50e3afe0b$var$$gOPD = $i8ZMJ("%Object.getOwnPropertyDescriptor%", true);
if ($fa4d15f50e3afe0b$var$$gOPD) try {
    $fa4d15f50e3afe0b$var$$gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $fa4d15f50e3afe0b$var$$gOPD = null;
}
module.exports = $fa4d15f50e3afe0b$var$$gOPD;

});


parcelRegister("bewCu", function(module, exports) {
"use strict";

var $lL7gm = parcelRequire("lL7gm");
module.exports = function isTypedArray(value) {
    return !!$lL7gm(value);
};

});


parcelRegister("j1W0B", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === "object" && typeof arg.copy === "function" && typeof arg.fill === "function" && typeof arg.readUInt8 === "function";
};

});



parcelRegister("gfoCJ", function(module, exports) {

var $lEoaA = parcelRequire("lEoaA");

var $f6JDE = parcelRequire("f6JDE");
var $bd4125ccc0a3feb8$require$Buffer = $f6JDE.Buffer;

var $f3yl3 = parcelRequire("f3yl3");

var $9GTGd = parcelRequire("9GTGd");

var $9h4Bq = parcelRequire("9h4Bq");
var $bd4125ccc0a3feb8$var$MSG_INVALID_ALGORITHM = '"%s" is not a valid algorithm.\n  Supported algorithms are:\n  "HS256", "HS384", "HS512", "RS256", "RS384", "RS512", "PS256", "PS384", "PS512", "ES256", "ES384", "ES512" and "none".';
var $bd4125ccc0a3feb8$var$MSG_INVALID_SECRET = "secret must be a string or buffer";
var $bd4125ccc0a3feb8$var$MSG_INVALID_VERIFIER_KEY = "key must be a string or a buffer";
var $bd4125ccc0a3feb8$var$MSG_INVALID_SIGNER_KEY = "key must be a string, a buffer or an object";
var $bd4125ccc0a3feb8$var$supportsKeyObjects = typeof $f3yl3.createPublicKey === "function";
if ($bd4125ccc0a3feb8$var$supportsKeyObjects) {
    $bd4125ccc0a3feb8$var$MSG_INVALID_VERIFIER_KEY += " or a KeyObject";
    $bd4125ccc0a3feb8$var$MSG_INVALID_SECRET += "or a KeyObject";
}
function $bd4125ccc0a3feb8$var$checkIsPublicKey(key) {
    if ($bd4125ccc0a3feb8$require$Buffer.isBuffer(key)) return;
    if (typeof key === "string") return;
    if (!$bd4125ccc0a3feb8$var$supportsKeyObjects) throw $bd4125ccc0a3feb8$var$typeError($bd4125ccc0a3feb8$var$MSG_INVALID_VERIFIER_KEY);
    if (typeof key !== "object") throw $bd4125ccc0a3feb8$var$typeError($bd4125ccc0a3feb8$var$MSG_INVALID_VERIFIER_KEY);
    if (typeof key.type !== "string") throw $bd4125ccc0a3feb8$var$typeError($bd4125ccc0a3feb8$var$MSG_INVALID_VERIFIER_KEY);
    if (typeof key.asymmetricKeyType !== "string") throw $bd4125ccc0a3feb8$var$typeError($bd4125ccc0a3feb8$var$MSG_INVALID_VERIFIER_KEY);
    if (typeof key.export !== "function") throw $bd4125ccc0a3feb8$var$typeError($bd4125ccc0a3feb8$var$MSG_INVALID_VERIFIER_KEY);
}
function $bd4125ccc0a3feb8$var$checkIsPrivateKey(key) {
    if ($bd4125ccc0a3feb8$require$Buffer.isBuffer(key)) return;
    if (typeof key === "string") return;
    if (typeof key === "object") return;
    throw $bd4125ccc0a3feb8$var$typeError($bd4125ccc0a3feb8$var$MSG_INVALID_SIGNER_KEY);
}
function $bd4125ccc0a3feb8$var$checkIsSecretKey(key) {
    if ($bd4125ccc0a3feb8$require$Buffer.isBuffer(key)) return;
    if (typeof key === "string") return key;
    if (!$bd4125ccc0a3feb8$var$supportsKeyObjects) throw $bd4125ccc0a3feb8$var$typeError($bd4125ccc0a3feb8$var$MSG_INVALID_SECRET);
    if (typeof key !== "object") throw $bd4125ccc0a3feb8$var$typeError($bd4125ccc0a3feb8$var$MSG_INVALID_SECRET);
    if (key.type !== "secret") throw $bd4125ccc0a3feb8$var$typeError($bd4125ccc0a3feb8$var$MSG_INVALID_SECRET);
    if (typeof key.export !== "function") throw $bd4125ccc0a3feb8$var$typeError($bd4125ccc0a3feb8$var$MSG_INVALID_SECRET);
}
function $bd4125ccc0a3feb8$var$fromBase64(base64) {
    return base64.replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}
function $bd4125ccc0a3feb8$var$toBase64(base64url) {
    base64url = base64url.toString();
    var padding = 4 - base64url.length % 4;
    if (padding !== 4) for(var i = 0; i < padding; ++i)base64url += "=";
    return base64url.replace(/\-/g, "+").replace(/_/g, "/");
}
function $bd4125ccc0a3feb8$var$typeError(template) {
    var args = [].slice.call(arguments, 1);
    var errMsg = $9h4Bq.format.bind($9h4Bq, template).apply(null, args);
    return new TypeError(errMsg);
}
function $bd4125ccc0a3feb8$var$bufferOrString(obj) {
    return $bd4125ccc0a3feb8$require$Buffer.isBuffer(obj) || typeof obj === "string";
}
function $bd4125ccc0a3feb8$var$normalizeInput(thing) {
    if (!$bd4125ccc0a3feb8$var$bufferOrString(thing)) thing = JSON.stringify(thing);
    return thing;
}
function $bd4125ccc0a3feb8$var$createHmacSigner(bits) {
    return function sign(thing, secret) {
        $bd4125ccc0a3feb8$var$checkIsSecretKey(secret);
        thing = $bd4125ccc0a3feb8$var$normalizeInput(thing);
        var hmac = $f3yl3.createHmac("sha" + bits, secret);
        var sig = (hmac.update(thing), hmac.digest("base64"));
        return $bd4125ccc0a3feb8$var$fromBase64(sig);
    };
}
function $bd4125ccc0a3feb8$var$createHmacVerifier(bits) {
    return function verify(thing, signature, secret) {
        var computedSig = $bd4125ccc0a3feb8$var$createHmacSigner(bits)(thing, secret);
        return $lEoaA($bd4125ccc0a3feb8$require$Buffer.from(signature), $bd4125ccc0a3feb8$require$Buffer.from(computedSig));
    };
}
function $bd4125ccc0a3feb8$var$createKeySigner(bits) {
    return function sign(thing, privateKey) {
        $bd4125ccc0a3feb8$var$checkIsPrivateKey(privateKey);
        thing = $bd4125ccc0a3feb8$var$normalizeInput(thing);
        // Even though we are specifying "RSA" here, this works with ECDSA
        // keys as well.
        var signer = $f3yl3.createSign("RSA-SHA" + bits);
        var sig = (signer.update(thing), signer.sign(privateKey, "base64"));
        return $bd4125ccc0a3feb8$var$fromBase64(sig);
    };
}
function $bd4125ccc0a3feb8$var$createKeyVerifier(bits) {
    return function verify(thing, signature, publicKey) {
        $bd4125ccc0a3feb8$var$checkIsPublicKey(publicKey);
        thing = $bd4125ccc0a3feb8$var$normalizeInput(thing);
        signature = $bd4125ccc0a3feb8$var$toBase64(signature);
        var verifier = $f3yl3.createVerify("RSA-SHA" + bits);
        verifier.update(thing);
        return verifier.verify(publicKey, signature, "base64");
    };
}
function $bd4125ccc0a3feb8$var$createPSSKeySigner(bits) {
    return function sign(thing, privateKey) {
        $bd4125ccc0a3feb8$var$checkIsPrivateKey(privateKey);
        thing = $bd4125ccc0a3feb8$var$normalizeInput(thing);
        var signer = $f3yl3.createSign("RSA-SHA" + bits);
        var sig = (signer.update(thing), signer.sign({
            key: privateKey,
            padding: $f3yl3.constants.RSA_PKCS1_PSS_PADDING,
            saltLength: $f3yl3.constants.RSA_PSS_SALTLEN_DIGEST
        }, "base64"));
        return $bd4125ccc0a3feb8$var$fromBase64(sig);
    };
}
function $bd4125ccc0a3feb8$var$createPSSKeyVerifier(bits) {
    return function verify(thing, signature, publicKey) {
        $bd4125ccc0a3feb8$var$checkIsPublicKey(publicKey);
        thing = $bd4125ccc0a3feb8$var$normalizeInput(thing);
        signature = $bd4125ccc0a3feb8$var$toBase64(signature);
        var verifier = $f3yl3.createVerify("RSA-SHA" + bits);
        verifier.update(thing);
        return verifier.verify({
            key: publicKey,
            padding: $f3yl3.constants.RSA_PKCS1_PSS_PADDING,
            saltLength: $f3yl3.constants.RSA_PSS_SALTLEN_DIGEST
        }, signature, "base64");
    };
}
function $bd4125ccc0a3feb8$var$createECDSASigner(bits) {
    var inner = $bd4125ccc0a3feb8$var$createKeySigner(bits);
    return function sign() {
        var signature = inner.apply(null, arguments);
        signature = $9GTGd.derToJose(signature, "ES" + bits);
        return signature;
    };
}
function $bd4125ccc0a3feb8$var$createECDSAVerifer(bits) {
    var inner = $bd4125ccc0a3feb8$var$createKeyVerifier(bits);
    return function verify(thing, signature, publicKey) {
        signature = $9GTGd.joseToDer(signature, "ES" + bits).toString("base64");
        var result = inner(thing, signature, publicKey);
        return result;
    };
}
function $bd4125ccc0a3feb8$var$createNoneSigner() {
    return function sign() {
        return "";
    };
}
function $bd4125ccc0a3feb8$var$createNoneVerifier() {
    return function verify(thing, signature) {
        return signature === "";
    };
}
module.exports = function jwa(algorithm) {
    var signerFactories = {
        hs: $bd4125ccc0a3feb8$var$createHmacSigner,
        rs: $bd4125ccc0a3feb8$var$createKeySigner,
        ps: $bd4125ccc0a3feb8$var$createPSSKeySigner,
        es: $bd4125ccc0a3feb8$var$createECDSASigner,
        none: $bd4125ccc0a3feb8$var$createNoneSigner
    };
    var verifierFactories = {
        hs: $bd4125ccc0a3feb8$var$createHmacVerifier,
        rs: $bd4125ccc0a3feb8$var$createKeyVerifier,
        ps: $bd4125ccc0a3feb8$var$createPSSKeyVerifier,
        es: $bd4125ccc0a3feb8$var$createECDSAVerifer,
        none: $bd4125ccc0a3feb8$var$createNoneVerifier
    };
    var match = algorithm.match(/^(RS|PS|ES|HS)(256|384|512)$|^(none)$/i);
    if (!match) throw $bd4125ccc0a3feb8$var$typeError($bd4125ccc0a3feb8$var$MSG_INVALID_ALGORITHM, algorithm);
    var algo = (match[1] || match[3]).toLowerCase();
    var bits = match[2];
    return {
        sign: signerFactories[algo](bits),
        verify: verifierFactories[algo](bits)
    };
};

});
parcelRegister("lEoaA", function(module, exports) {
/*jshint node:true */ "use strict";

var $8dlmd = parcelRequire("8dlmd");
var $fc30150675b65188$require$Buffer = $8dlmd.Buffer;

var $8dlmd = parcelRequire("8dlmd");
var $fc30150675b65188$require$SlowBuffer = $8dlmd.SlowBuffer;
module.exports = $fc30150675b65188$var$bufferEq;
function $fc30150675b65188$var$bufferEq(a, b) {
    // shortcutting on type is necessary for correctness
    if (!$fc30150675b65188$require$Buffer.isBuffer(a) || !$fc30150675b65188$require$Buffer.isBuffer(b)) return false;
    // buffer sizes should be well-known information, so despite this
    // shortcutting, it doesn't leak any information about the *contents* of the
    // buffers.
    if (a.length !== b.length) return false;
    var c = 0;
    for(var i = 0; i < a.length; i++)/*jshint bitwise:false */ c |= a[i] ^ b[i]; // XOR
    return c === 0;
}
$fc30150675b65188$var$bufferEq.install = function() {
    $fc30150675b65188$require$Buffer.prototype.equal = $fc30150675b65188$require$SlowBuffer.prototype.equal = function equal(that) {
        return $fc30150675b65188$var$bufferEq(this, that);
    };
};
var $fc30150675b65188$var$origBufEqual = $fc30150675b65188$require$Buffer.prototype.equal;
var $fc30150675b65188$var$origSlowBufEqual = $fc30150675b65188$require$SlowBuffer.prototype.equal;
$fc30150675b65188$var$bufferEq.restore = function() {
    $fc30150675b65188$require$Buffer.prototype.equal = $fc30150675b65188$var$origBufEqual;
    $fc30150675b65188$require$SlowBuffer.prototype.equal = $fc30150675b65188$var$origSlowBufEqual;
};

});

parcelRegister("9GTGd", function(module, exports) {
"use strict";

var $f6JDE = parcelRequire("f6JDE");
var $70e33a2d55aa1a83$require$Buffer = $f6JDE.Buffer;

var $75qVp = parcelRequire("75qVp");
var $70e33a2d55aa1a83$var$MAX_OCTET = 0x80, $70e33a2d55aa1a83$var$CLASS_UNIVERSAL = 0, $70e33a2d55aa1a83$var$PRIMITIVE_BIT = 0x20, $70e33a2d55aa1a83$var$TAG_SEQ = 0x10, $70e33a2d55aa1a83$var$TAG_INT = 0x02, $70e33a2d55aa1a83$var$ENCODED_TAG_SEQ = $70e33a2d55aa1a83$var$TAG_SEQ | $70e33a2d55aa1a83$var$PRIMITIVE_BIT | $70e33a2d55aa1a83$var$CLASS_UNIVERSAL << 6, $70e33a2d55aa1a83$var$ENCODED_TAG_INT = $70e33a2d55aa1a83$var$TAG_INT | $70e33a2d55aa1a83$var$CLASS_UNIVERSAL << 6;
function $70e33a2d55aa1a83$var$base64Url(base64) {
    return base64.replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}
function $70e33a2d55aa1a83$var$signatureAsBuffer(signature) {
    if ($70e33a2d55aa1a83$require$Buffer.isBuffer(signature)) return signature;
    else if ("string" === typeof signature) return $70e33a2d55aa1a83$require$Buffer.from(signature, "base64");
    throw new TypeError("ECDSA signature must be a Base64 string or a Buffer");
}
function $70e33a2d55aa1a83$var$derToJose(signature, alg) {
    signature = $70e33a2d55aa1a83$var$signatureAsBuffer(signature);
    var paramBytes = $75qVp(alg);
    // the DER encoded param should at most be the param size, plus a padding
    // zero, since due to being a signed integer
    var maxEncodedParamLength = paramBytes + 1;
    var inputLength = signature.length;
    var offset = 0;
    if (signature[offset++] !== $70e33a2d55aa1a83$var$ENCODED_TAG_SEQ) throw new Error('Could not find expected "seq"');
    var seqLength = signature[offset++];
    if (seqLength === ($70e33a2d55aa1a83$var$MAX_OCTET | 1)) seqLength = signature[offset++];
    if (inputLength - offset < seqLength) throw new Error('"seq" specified length of "' + seqLength + '", only "' + (inputLength - offset) + '" remaining');
    if (signature[offset++] !== $70e33a2d55aa1a83$var$ENCODED_TAG_INT) throw new Error('Could not find expected "int" for "r"');
    var rLength = signature[offset++];
    if (inputLength - offset - 2 < rLength) throw new Error('"r" specified length of "' + rLength + '", only "' + (inputLength - offset - 2) + '" available');
    if (maxEncodedParamLength < rLength) throw new Error('"r" specified length of "' + rLength + '", max of "' + maxEncodedParamLength + '" is acceptable');
    var rOffset = offset;
    offset += rLength;
    if (signature[offset++] !== $70e33a2d55aa1a83$var$ENCODED_TAG_INT) throw new Error('Could not find expected "int" for "s"');
    var sLength = signature[offset++];
    if (inputLength - offset !== sLength) throw new Error('"s" specified length of "' + sLength + '", expected "' + (inputLength - offset) + '"');
    if (maxEncodedParamLength < sLength) throw new Error('"s" specified length of "' + sLength + '", max of "' + maxEncodedParamLength + '" is acceptable');
    var sOffset = offset;
    offset += sLength;
    if (offset !== inputLength) throw new Error('Expected to consume entire buffer, but "' + (inputLength - offset) + '" bytes remain');
    var rPadding = paramBytes - rLength, sPadding = paramBytes - sLength;
    var dst = $70e33a2d55aa1a83$require$Buffer.allocUnsafe(rPadding + rLength + sPadding + sLength);
    for(offset = 0; offset < rPadding; ++offset)dst[offset] = 0;
    signature.copy(dst, offset, rOffset + Math.max(-rPadding, 0), rOffset + rLength);
    offset = paramBytes;
    for(var o = offset; offset < o + sPadding; ++offset)dst[offset] = 0;
    signature.copy(dst, offset, sOffset + Math.max(-sPadding, 0), sOffset + sLength);
    dst = dst.toString("base64");
    dst = $70e33a2d55aa1a83$var$base64Url(dst);
    return dst;
}
function $70e33a2d55aa1a83$var$countPadding(buf, start, stop) {
    var padding = 0;
    while(start + padding < stop && buf[start + padding] === 0)++padding;
    var needsSign = buf[start + padding] >= $70e33a2d55aa1a83$var$MAX_OCTET;
    if (needsSign) --padding;
    return padding;
}
function $70e33a2d55aa1a83$var$joseToDer(signature, alg) {
    signature = $70e33a2d55aa1a83$var$signatureAsBuffer(signature);
    var paramBytes = $75qVp(alg);
    var signatureBytes = signature.length;
    if (signatureBytes !== paramBytes * 2) throw new TypeError('"' + alg + '" signatures must be "' + paramBytes * 2 + '" bytes, saw "' + signatureBytes + '"');
    var rPadding = $70e33a2d55aa1a83$var$countPadding(signature, 0, paramBytes);
    var sPadding = $70e33a2d55aa1a83$var$countPadding(signature, paramBytes, signature.length);
    var rLength = paramBytes - rPadding;
    var sLength = paramBytes - sPadding;
    var rsBytes = 2 + rLength + 1 + 1 + sLength;
    var shortLength = rsBytes < $70e33a2d55aa1a83$var$MAX_OCTET;
    var dst = $70e33a2d55aa1a83$require$Buffer.allocUnsafe((shortLength ? 2 : 3) + rsBytes);
    var offset = 0;
    dst[offset++] = $70e33a2d55aa1a83$var$ENCODED_TAG_SEQ;
    if (shortLength) // Bit 8 has value "0"
    // bits 7-1 give the length.
    dst[offset++] = rsBytes;
    else {
        // Bit 8 of first octet has value "1"
        // bits 7-1 give the number of additional length octets.
        dst[offset++] = $70e33a2d55aa1a83$var$MAX_OCTET | 1;
        // length, base 256
        dst[offset++] = rsBytes & 0xff;
    }
    dst[offset++] = $70e33a2d55aa1a83$var$ENCODED_TAG_INT;
    dst[offset++] = rLength;
    if (rPadding < 0) {
        dst[offset++] = 0;
        offset += signature.copy(dst, offset, 0, paramBytes);
    } else offset += signature.copy(dst, offset, rPadding, paramBytes);
    dst[offset++] = $70e33a2d55aa1a83$var$ENCODED_TAG_INT;
    dst[offset++] = sLength;
    if (sPadding < 0) {
        dst[offset++] = 0;
        signature.copy(dst, offset, paramBytes);
    } else signature.copy(dst, offset, paramBytes + sPadding);
    return dst;
}
module.exports = {
    derToJose: $70e33a2d55aa1a83$var$derToJose,
    joseToDer: $70e33a2d55aa1a83$var$joseToDer
};

});
parcelRegister("75qVp", function(module, exports) {
"use strict";
function $528de2c700a9db5f$var$getParamSize(keySize) {
    var result = (keySize / 8 | 0) + (keySize % 8 === 0 ? 0 : 1);
    return result;
}
var $528de2c700a9db5f$var$paramBytesForAlg = {
    ES256: $528de2c700a9db5f$var$getParamSize(256),
    ES384: $528de2c700a9db5f$var$getParamSize(384),
    ES512: $528de2c700a9db5f$var$getParamSize(521)
};
function $528de2c700a9db5f$var$getParamBytesForAlg(alg) {
    var paramBytes = $528de2c700a9db5f$var$paramBytesForAlg[alg];
    if (paramBytes) return paramBytes;
    throw new Error('Unknown algorithm "' + alg + '"');
}
module.exports = $528de2c700a9db5f$var$getParamBytesForAlg;

});



parcelRegister("iWbL3", function(module, exports) {
/*global module*/ 
var $8dlmd = parcelRequire("8dlmd");
var $dc96c3a6cafd78e4$require$Buffer = $8dlmd.Buffer;
module.exports = function toString(obj) {
    if (typeof obj === "string") return obj;
    if (typeof obj === "number" || $dc96c3a6cafd78e4$require$Buffer.isBuffer(obj)) return obj.toString();
    return JSON.stringify(obj);
};

});


parcelRegister("Td10G", function(module, exports) {
/*global module*/ 
var $f6JDE = parcelRequire("f6JDE");
var $0a5f3bbc01bfbfba$require$Buffer = $f6JDE.Buffer;

var $141kN = parcelRequire("141kN");

var $gfoCJ = parcelRequire("gfoCJ");

var $l0FDA = parcelRequire("l0FDA");

var $iWbL3 = parcelRequire("iWbL3");

var $9h4Bq = parcelRequire("9h4Bq");
var $0a5f3bbc01bfbfba$var$JWS_REGEX = /^[a-zA-Z0-9\-_]+?\.[a-zA-Z0-9\-_]+?\.([a-zA-Z0-9\-_]+)?$/;
function $0a5f3bbc01bfbfba$var$isObject(thing) {
    return Object.prototype.toString.call(thing) === "[object Object]";
}
function $0a5f3bbc01bfbfba$var$safeJsonParse(thing) {
    if ($0a5f3bbc01bfbfba$var$isObject(thing)) return thing;
    try {
        return JSON.parse(thing);
    } catch (e) {
        return undefined;
    }
}
function $0a5f3bbc01bfbfba$var$headerFromJWS(jwsSig) {
    var encodedHeader = jwsSig.split(".", 1)[0];
    return $0a5f3bbc01bfbfba$var$safeJsonParse($0a5f3bbc01bfbfba$require$Buffer.from(encodedHeader, "base64").toString("binary"));
}
function $0a5f3bbc01bfbfba$var$securedInputFromJWS(jwsSig) {
    return jwsSig.split(".", 2).join(".");
}
function $0a5f3bbc01bfbfba$var$signatureFromJWS(jwsSig) {
    return jwsSig.split(".")[2];
}
function $0a5f3bbc01bfbfba$var$payloadFromJWS(jwsSig, encoding) {
    encoding = encoding || "utf8";
    var payload = jwsSig.split(".")[1];
    return $0a5f3bbc01bfbfba$require$Buffer.from(payload, "base64").toString(encoding);
}
function $0a5f3bbc01bfbfba$var$isValidJws(string) {
    return $0a5f3bbc01bfbfba$var$JWS_REGEX.test(string) && !!$0a5f3bbc01bfbfba$var$headerFromJWS(string);
}
function $0a5f3bbc01bfbfba$var$jwsVerify(jwsSig, algorithm, secretOrKey) {
    if (!algorithm) {
        var err = new Error("Missing algorithm parameter for jws.verify");
        err.code = "MISSING_ALGORITHM";
        throw err;
    }
    jwsSig = $iWbL3(jwsSig);
    var signature = $0a5f3bbc01bfbfba$var$signatureFromJWS(jwsSig);
    var securedInput = $0a5f3bbc01bfbfba$var$securedInputFromJWS(jwsSig);
    var algo = $gfoCJ(algorithm);
    return algo.verify(securedInput, signature, secretOrKey);
}
function $0a5f3bbc01bfbfba$var$jwsDecode(jwsSig, opts) {
    opts = opts || {};
    jwsSig = $iWbL3(jwsSig);
    if (!$0a5f3bbc01bfbfba$var$isValidJws(jwsSig)) return null;
    var header = $0a5f3bbc01bfbfba$var$headerFromJWS(jwsSig);
    if (!header) return null;
    var payload = $0a5f3bbc01bfbfba$var$payloadFromJWS(jwsSig);
    if (header.typ === "JWT" || opts.json) payload = JSON.parse(payload, opts.encoding);
    return {
        header: header,
        payload: payload,
        signature: $0a5f3bbc01bfbfba$var$signatureFromJWS(jwsSig)
    };
}
function $0a5f3bbc01bfbfba$var$VerifyStream(opts) {
    opts = opts || {};
    var secretOrKey = opts.secret || opts.publicKey || opts.key;
    var secretStream = new $141kN(secretOrKey);
    this.readable = true;
    this.algorithm = opts.algorithm;
    this.encoding = opts.encoding;
    this.secret = this.publicKey = this.key = secretStream;
    this.signature = new $141kN(opts.signature);
    this.secret.once("close", (function() {
        if (!this.signature.writable && this.readable) this.verify();
    }).bind(this));
    this.signature.once("close", (function() {
        if (!this.secret.writable && this.readable) this.verify();
    }).bind(this));
}
$9h4Bq.inherits($0a5f3bbc01bfbfba$var$VerifyStream, $l0FDA);
$0a5f3bbc01bfbfba$var$VerifyStream.prototype.verify = function verify() {
    try {
        var valid = $0a5f3bbc01bfbfba$var$jwsVerify(this.signature.buffer, this.algorithm, this.key.buffer);
        var obj = $0a5f3bbc01bfbfba$var$jwsDecode(this.signature.buffer, this.encoding);
        this.emit("done", valid, obj);
        this.emit("data", valid);
        this.emit("end");
        this.readable = false;
        return valid;
    } catch (e) {
        this.readable = false;
        this.emit("error", e);
        this.emit("close");
    }
};
$0a5f3bbc01bfbfba$var$VerifyStream.decode = $0a5f3bbc01bfbfba$var$jwsDecode;
$0a5f3bbc01bfbfba$var$VerifyStream.isValid = $0a5f3bbc01bfbfba$var$isValidJws;
$0a5f3bbc01bfbfba$var$VerifyStream.verify = $0a5f3bbc01bfbfba$var$jwsVerify;
module.exports = $0a5f3bbc01bfbfba$var$VerifyStream;

});



parcelRegister("2Z5j7", function(module, exports) {

var $1Rs0b = parcelRequire("1Rs0b");

var $f0TUW = parcelRequire("f0TUW");

var $cstwt = parcelRequire("cstwt");

var $aJ2Ww = parcelRequire("aJ2Ww");

var $3v2vH = parcelRequire("3v2vH");

var $4Q3pU = parcelRequire("4Q3pU");

var $k6iCM = parcelRequire("k6iCM");
var $22c56532b29aec86$var$PUB_KEY_ALGS = [
    "RS256",
    "RS384",
    "RS512",
    "ES256",
    "ES384",
    "ES512"
];
var $22c56532b29aec86$var$RSA_KEY_ALGS = [
    "RS256",
    "RS384",
    "RS512"
];
var $22c56532b29aec86$var$HS_ALGS = [
    "HS256",
    "HS384",
    "HS512"
];
if ($4Q3pU) {
    $22c56532b29aec86$var$PUB_KEY_ALGS.splice(3, 0, "PS256", "PS384", "PS512");
    $22c56532b29aec86$var$RSA_KEY_ALGS.splice(3, 0, "PS256", "PS384", "PS512");
}
module.exports = function(jwtString, secretOrPublicKey, options, callback) {
    if (typeof options === "function" && !callback) {
        callback = options;
        options = {};
    }
    if (!options) options = {};
    //clone this object since we are going to mutate it.
    options = Object.assign({}, options);
    var done;
    if (callback) done = callback;
    else done = function done(err, data) {
        if (err) throw err;
        return data;
    };
    if (options.clockTimestamp && typeof options.clockTimestamp !== "number") return done(new $1Rs0b("clockTimestamp must be a number"));
    if (options.nonce !== undefined && (typeof options.nonce !== "string" || options.nonce.trim() === "")) return done(new $1Rs0b("nonce must be a non-empty string"));
    var clockTimestamp = options.clockTimestamp || Math.floor(Date.now() / 1000);
    if (!jwtString) return done(new $1Rs0b("jwt must be provided"));
    if (typeof jwtString !== "string") return done(new $1Rs0b("jwt must be a string"));
    var parts = jwtString.split(".");
    if (parts.length !== 3) return done(new $1Rs0b("jwt malformed"));
    var decodedToken;
    try {
        decodedToken = $aJ2Ww(jwtString, {
            complete: true
        });
    } catch (err) {
        return done(err);
    }
    if (!decodedToken) return done(new $1Rs0b("invalid token"));
    var header = decodedToken.header;
    var getSecret;
    if (typeof secretOrPublicKey === "function") {
        if (!callback) return done(new $1Rs0b("verify must be called asynchronous if secret or public key is provided as a callback"));
        getSecret = secretOrPublicKey;
    } else getSecret = function getSecret(header, secretCallback) {
        return secretCallback(null, secretOrPublicKey);
    };
    return getSecret(header, function(err, secretOrPublicKey) {
        if (err) return done(new $1Rs0b("error in secret or public key callback: " + err.message));
        var hasSignature = parts[2].trim() !== "";
        if (!hasSignature && secretOrPublicKey) return done(new $1Rs0b("jwt signature is required"));
        if (hasSignature && !secretOrPublicKey) return done(new $1Rs0b("secret or public key must be provided"));
        if (!hasSignature && !options.algorithms) options.algorithms = [
            "none"
        ];
        if (!options.algorithms) options.algorithms = ~secretOrPublicKey.toString().indexOf("BEGIN CERTIFICATE") || ~secretOrPublicKey.toString().indexOf("BEGIN PUBLIC KEY") ? $22c56532b29aec86$var$PUB_KEY_ALGS : ~secretOrPublicKey.toString().indexOf("BEGIN RSA PUBLIC KEY") ? $22c56532b29aec86$var$RSA_KEY_ALGS : $22c56532b29aec86$var$HS_ALGS;
        if (!~options.algorithms.indexOf(decodedToken.header.alg)) return done(new $1Rs0b("invalid algorithm"));
        var valid;
        try {
            valid = $k6iCM.verify(jwtString, decodedToken.header.alg, secretOrPublicKey);
        } catch (e) {
            return done(e);
        }
        if (!valid) return done(new $1Rs0b("invalid signature"));
        var payload = decodedToken.payload;
        if (typeof payload.nbf !== "undefined" && !options.ignoreNotBefore) {
            if (typeof payload.nbf !== "number") return done(new $1Rs0b("invalid nbf value"));
            if (payload.nbf > clockTimestamp + (options.clockTolerance || 0)) return done(new $f0TUW("jwt not active", new Date(payload.nbf * 1000)));
        }
        if (typeof payload.exp !== "undefined" && !options.ignoreExpiration) {
            if (typeof payload.exp !== "number") return done(new $1Rs0b("invalid exp value"));
            if (clockTimestamp >= payload.exp + (options.clockTolerance || 0)) return done(new $cstwt("jwt expired", new Date(payload.exp * 1000)));
        }
        if (options.audience) {
            var audiences = Array.isArray(options.audience) ? options.audience : [
                options.audience
            ];
            var target = Array.isArray(payload.aud) ? payload.aud : [
                payload.aud
            ];
            var match = target.some(function(targetAudience) {
                return audiences.some(function(audience) {
                    return audience instanceof RegExp ? audience.test(targetAudience) : audience === targetAudience;
                });
            });
            if (!match) return done(new $1Rs0b("jwt audience invalid. expected: " + audiences.join(" or ")));
        }
        if (options.issuer) {
            var invalid_issuer = typeof options.issuer === "string" && payload.iss !== options.issuer || Array.isArray(options.issuer) && options.issuer.indexOf(payload.iss) === -1;
            if (invalid_issuer) return done(new $1Rs0b("jwt issuer invalid. expected: " + options.issuer));
        }
        if (options.subject) {
            if (payload.sub !== options.subject) return done(new $1Rs0b("jwt subject invalid. expected: " + options.subject));
        }
        if (options.jwtid) {
            if (payload.jti !== options.jwtid) return done(new $1Rs0b("jwt jwtid invalid. expected: " + options.jwtid));
        }
        if (options.nonce) {
            if (payload.nonce !== options.nonce) return done(new $1Rs0b("jwt nonce invalid. expected: " + options.nonce));
        }
        if (options.maxAge) {
            if (typeof payload.iat !== "number") return done(new $1Rs0b("iat required when maxAge is specified"));
            var maxAgeTimestamp = $3v2vH(options.maxAge, payload.iat);
            if (typeof maxAgeTimestamp === "undefined") return done(new $1Rs0b('"maxAge" should be a number of seconds or string representing a timespan eg: "1d", "20h", 60'));
            if (clockTimestamp >= maxAgeTimestamp + (options.clockTolerance || 0)) return done(new $cstwt("maxAge exceeded", new Date(maxAgeTimestamp * 1000)));
        }
        if (options.complete === true) {
            var signature = decodedToken.signature;
            return done(null, {
                header: header,
                payload: payload,
                signature: signature
            });
        }
        return done(null, payload);
    });
};

});
parcelRegister("1Rs0b", function(module, exports) {
var $15b07643dd533cb9$var$JsonWebTokenError = function JsonWebTokenError(message, error) {
    Error.call(this, message);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    this.name = "JsonWebTokenError";
    this.message = message;
    if (error) this.inner = error;
};
$15b07643dd533cb9$var$JsonWebTokenError.prototype = Object.create(Error.prototype);
$15b07643dd533cb9$var$JsonWebTokenError.prototype.constructor = $15b07643dd533cb9$var$JsonWebTokenError;
module.exports = $15b07643dd533cb9$var$JsonWebTokenError;

});

parcelRegister("f0TUW", function(module, exports) {

var $1Rs0b = parcelRequire("1Rs0b");
var $aee23b24d4e1140e$var$NotBeforeError = function NotBeforeError(message, date) {
    $1Rs0b.call(this, message);
    this.name = "NotBeforeError";
    this.date = date;
};
$aee23b24d4e1140e$var$NotBeforeError.prototype = Object.create($1Rs0b.prototype);
$aee23b24d4e1140e$var$NotBeforeError.prototype.constructor = $aee23b24d4e1140e$var$NotBeforeError;
module.exports = $aee23b24d4e1140e$var$NotBeforeError;

});

parcelRegister("cstwt", function(module, exports) {

var $1Rs0b = parcelRequire("1Rs0b");
var $911f002d19ffd667$var$TokenExpiredError = function TokenExpiredError(message, expiredAt) {
    $1Rs0b.call(this, message);
    this.name = "TokenExpiredError";
    this.expiredAt = expiredAt;
};
$911f002d19ffd667$var$TokenExpiredError.prototype = Object.create($1Rs0b.prototype);
$911f002d19ffd667$var$TokenExpiredError.prototype.constructor = $911f002d19ffd667$var$TokenExpiredError;
module.exports = $911f002d19ffd667$var$TokenExpiredError;

});

parcelRegister("3v2vH", function(module, exports) {

var $dcJ77 = parcelRequire("dcJ77");
module.exports = function(time, iat) {
    var timestamp = iat || Math.floor(Date.now() / 1000);
    if (typeof time === "string") {
        var milliseconds = $dcJ77(time);
        if (typeof milliseconds === "undefined") return;
        return Math.floor(timestamp + milliseconds / 1000);
    } else if (typeof time === "number") return timestamp + time;
    else return;
};

});
parcelRegister("dcJ77", function(module, exports) {
/**
 * Helpers.
 */ 
var $l0HdX = parcelRequire("l0HdX");
var $99cf6408a0003c8f$var$s = 1000;
var $99cf6408a0003c8f$var$m = $99cf6408a0003c8f$var$s * 60;
var $99cf6408a0003c8f$var$h = $99cf6408a0003c8f$var$m * 60;
var $99cf6408a0003c8f$var$d = $99cf6408a0003c8f$var$h * 24;
var $99cf6408a0003c8f$var$w = $99cf6408a0003c8f$var$d * 7;
var $99cf6408a0003c8f$var$y = $99cf6408a0003c8f$var$d * 365.25;
/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */ module.exports = function(val, options) {
    options = options || {};
    var type = typeof val === "undefined" ? "undefined" : (0, $l0HdX._)(val);
    if (type === "string" && val.length > 0) return $99cf6408a0003c8f$var$parse(val);
    else if (type === "number" && isFinite(val)) return options.long ? $99cf6408a0003c8f$var$fmtLong(val) : $99cf6408a0003c8f$var$fmtShort(val);
    throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(val));
};
/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */ function $99cf6408a0003c8f$var$parse(str) {
    str = String(str);
    if (str.length > 100) return;
    var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(str);
    if (!match) return;
    var n = parseFloat(match[1]);
    var type = (match[2] || "ms").toLowerCase();
    switch(type){
        case "years":
        case "year":
        case "yrs":
        case "yr":
        case "y":
            return n * $99cf6408a0003c8f$var$y;
        case "weeks":
        case "week":
        case "w":
            return n * $99cf6408a0003c8f$var$w;
        case "days":
        case "day":
        case "d":
            return n * $99cf6408a0003c8f$var$d;
        case "hours":
        case "hour":
        case "hrs":
        case "hr":
        case "h":
            return n * $99cf6408a0003c8f$var$h;
        case "minutes":
        case "minute":
        case "mins":
        case "min":
        case "m":
            return n * $99cf6408a0003c8f$var$m;
        case "seconds":
        case "second":
        case "secs":
        case "sec":
        case "s":
            return n * $99cf6408a0003c8f$var$s;
        case "milliseconds":
        case "millisecond":
        case "msecs":
        case "msec":
        case "ms":
            return n;
        default:
            return undefined;
    }
}
/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $99cf6408a0003c8f$var$fmtShort(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= $99cf6408a0003c8f$var$d) return Math.round(ms / $99cf6408a0003c8f$var$d) + "d";
    if (msAbs >= $99cf6408a0003c8f$var$h) return Math.round(ms / $99cf6408a0003c8f$var$h) + "h";
    if (msAbs >= $99cf6408a0003c8f$var$m) return Math.round(ms / $99cf6408a0003c8f$var$m) + "m";
    if (msAbs >= $99cf6408a0003c8f$var$s) return Math.round(ms / $99cf6408a0003c8f$var$s) + "s";
    return ms + "ms";
}
/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $99cf6408a0003c8f$var$fmtLong(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= $99cf6408a0003c8f$var$d) return $99cf6408a0003c8f$var$plural(ms, msAbs, $99cf6408a0003c8f$var$d, "day");
    if (msAbs >= $99cf6408a0003c8f$var$h) return $99cf6408a0003c8f$var$plural(ms, msAbs, $99cf6408a0003c8f$var$h, "hour");
    if (msAbs >= $99cf6408a0003c8f$var$m) return $99cf6408a0003c8f$var$plural(ms, msAbs, $99cf6408a0003c8f$var$m, "minute");
    if (msAbs >= $99cf6408a0003c8f$var$s) return $99cf6408a0003c8f$var$plural(ms, msAbs, $99cf6408a0003c8f$var$s, "second");
    return ms + " ms";
}
/**
 * Pluralization helper.
 */ function $99cf6408a0003c8f$var$plural(ms, msAbs, n, name) {
    var isPlural = msAbs >= n * 1.5;
    return Math.round(ms / n) + " " + name + (isPlural ? "s" : "");
}

});


parcelRegister("4Q3pU", function(module, exports) {

var $3qWgZ = parcelRequire("3qWgZ");

var $1axIs = parcelRequire("1axIs");
module.exports = $1axIs.satisfies($3qWgZ.version, "^6.12.0 || >=8.0.0");

});
parcelRegister("1axIs", function(module, exports) {

var $3qWgZ = parcelRequire("3qWgZ");
exports = module.exports = SemVer;
var debug;
/* istanbul ignore next */ typeof $3qWgZ === "object" && $3qWgZ.env && undefined;
debug = function debug() {};
// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
exports.SEMVER_SPEC_VERSION = "2.0.0";
var MAX_LENGTH = 256;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */ 9007199254740991;
// Max safe segment length for coercion.
var MAX_SAFE_COMPONENT_LENGTH = 16;
var MAX_SAFE_BUILD_LENGTH = MAX_LENGTH - 6;
// The actual regexps go on exports.re
var re = exports.re = [];
var safeRe = exports.safeRe = [];
var src = exports.src = [];
var R = 0;
var LETTERDASHNUMBER = "[a-zA-Z0-9-]";
// Replace some greedy regex tokens to prevent regex dos issues. These regex are
// used internally via the safeRe object since all inputs in this library get
// normalized first to trim and collapse all extra whitespace. The original
// regexes are exported for userland consumption and lower level usage. A
// future breaking change could export the safer regex only with a note that
// all input should have extra whitespace removed.
var safeRegexReplacements = [
    [
        "\\s",
        1
    ],
    [
        "\\d",
        MAX_LENGTH
    ],
    [
        LETTERDASHNUMBER,
        MAX_SAFE_BUILD_LENGTH
    ]
];
function makeSafeRe(value) {
    for(var i = 0; i < safeRegexReplacements.length; i++){
        var token = safeRegexReplacements[i][0];
        var max = safeRegexReplacements[i][1];
        value = value.split(token + "*").join(token + "{0," + max + "}").split(token + "+").join(token + "{1," + max + "}");
    }
    return value;
}
// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.
// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.
var NUMERICIDENTIFIER = R++;
src[NUMERICIDENTIFIER] = "0|[1-9]\\d*";
var NUMERICIDENTIFIERLOOSE = R++;
src[NUMERICIDENTIFIERLOOSE] = "\\d+";
// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.
var NONNUMERICIDENTIFIER = R++;
src[NONNUMERICIDENTIFIER] = "\\d*[a-zA-Z-]" + LETTERDASHNUMBER + "*";
// ## Main Version
// Three dot-separated numeric identifiers.
var MAINVERSION = R++;
src[MAINVERSION] = "(" + src[NUMERICIDENTIFIER] + ")\\." + "(" + src[NUMERICIDENTIFIER] + ")\\." + "(" + src[NUMERICIDENTIFIER] + ")";
var MAINVERSIONLOOSE = R++;
src[MAINVERSIONLOOSE] = "(" + src[NUMERICIDENTIFIERLOOSE] + ")\\." + "(" + src[NUMERICIDENTIFIERLOOSE] + ")\\." + "(" + src[NUMERICIDENTIFIERLOOSE] + ")";
// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.
var PRERELEASEIDENTIFIER = R++;
src[PRERELEASEIDENTIFIER] = "(?:" + src[NUMERICIDENTIFIER] + "|" + src[NONNUMERICIDENTIFIER] + ")";
var PRERELEASEIDENTIFIERLOOSE = R++;
src[PRERELEASEIDENTIFIERLOOSE] = "(?:" + src[NUMERICIDENTIFIERLOOSE] + "|" + src[NONNUMERICIDENTIFIER] + ")";
// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.
var PRERELEASE = R++;
src[PRERELEASE] = "(?:-(" + src[PRERELEASEIDENTIFIER] + "(?:\\." + src[PRERELEASEIDENTIFIER] + ")*))";
var PRERELEASELOOSE = R++;
src[PRERELEASELOOSE] = "(?:-?(" + src[PRERELEASEIDENTIFIERLOOSE] + "(?:\\." + src[PRERELEASEIDENTIFIERLOOSE] + ")*))";
// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.
var BUILDIDENTIFIER = R++;
src[BUILDIDENTIFIER] = LETTERDASHNUMBER + "+";
// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.
var BUILD = R++;
src[BUILD] = "(?:\\+(" + src[BUILDIDENTIFIER] + "(?:\\." + src[BUILDIDENTIFIER] + ")*))";
// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.
// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.
var FULL = R++;
var FULLPLAIN = "v?" + src[MAINVERSION] + src[PRERELEASE] + "?" + src[BUILD] + "?";
src[FULL] = "^" + FULLPLAIN + "$";
// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
var LOOSEPLAIN = "[v=\\s]*" + src[MAINVERSIONLOOSE] + src[PRERELEASELOOSE] + "?" + src[BUILD] + "?";
var LOOSE = R++;
src[LOOSE] = "^" + LOOSEPLAIN + "$";
var GTLT = R++;
src[GTLT] = "((?:<|>)?=?)";
// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
var XRANGEIDENTIFIERLOOSE = R++;
src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + "|x|X|\\*";
var XRANGEIDENTIFIER = R++;
src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + "|x|X|\\*";
var XRANGEPLAIN = R++;
src[XRANGEPLAIN] = "[v=\\s]*(" + src[XRANGEIDENTIFIER] + ")" + "(?:\\.(" + src[XRANGEIDENTIFIER] + ")" + "(?:\\.(" + src[XRANGEIDENTIFIER] + ")" + "(?:" + src[PRERELEASE] + ")?" + src[BUILD] + "?" + ")?)?";
var XRANGEPLAINLOOSE = R++;
src[XRANGEPLAINLOOSE] = "[v=\\s]*(" + src[XRANGEIDENTIFIERLOOSE] + ")" + "(?:\\.(" + src[XRANGEIDENTIFIERLOOSE] + ")" + "(?:\\.(" + src[XRANGEIDENTIFIERLOOSE] + ")" + "(?:" + src[PRERELEASELOOSE] + ")?" + src[BUILD] + "?" + ")?)?";
var XRANGE = R++;
src[XRANGE] = "^" + src[GTLT] + "\\s*" + src[XRANGEPLAIN] + "$";
var XRANGELOOSE = R++;
src[XRANGELOOSE] = "^" + src[GTLT] + "\\s*" + src[XRANGEPLAINLOOSE] + "$";
// Coercion.
// Extract anything that could conceivably be a part of a valid semver
var COERCE = R++;
src[COERCE] = "(?:^|[^\\d])(\\d{1," + MAX_SAFE_COMPONENT_LENGTH + "})" + "(?:\\.(\\d{1," + MAX_SAFE_COMPONENT_LENGTH + "}))?" + "(?:\\.(\\d{1," + MAX_SAFE_COMPONENT_LENGTH + "}))?" + "(?:$|[^\\d])";
// Tilde ranges.
// Meaning is "reasonably at or greater than"
var LONETILDE = R++;
src[LONETILDE] = "(?:~>?)";
var TILDETRIM = R++;
src[TILDETRIM] = "(\\s*)" + src[LONETILDE] + "\\s+";
re[TILDETRIM] = new RegExp(src[TILDETRIM], "g");
safeRe[TILDETRIM] = new RegExp(makeSafeRe(src[TILDETRIM]), "g");
var tildeTrimReplace = "$1~";
var TILDE = R++;
src[TILDE] = "^" + src[LONETILDE] + src[XRANGEPLAIN] + "$";
var TILDELOOSE = R++;
src[TILDELOOSE] = "^" + src[LONETILDE] + src[XRANGEPLAINLOOSE] + "$";
// Caret ranges.
// Meaning is "at least and backwards compatible with"
var LONECARET = R++;
src[LONECARET] = "(?:\\^)";
var CARETTRIM = R++;
src[CARETTRIM] = "(\\s*)" + src[LONECARET] + "\\s+";
re[CARETTRIM] = new RegExp(src[CARETTRIM], "g");
safeRe[CARETTRIM] = new RegExp(makeSafeRe(src[CARETTRIM]), "g");
var caretTrimReplace = "$1^";
var CARET = R++;
src[CARET] = "^" + src[LONECARET] + src[XRANGEPLAIN] + "$";
var CARETLOOSE = R++;
src[CARETLOOSE] = "^" + src[LONECARET] + src[XRANGEPLAINLOOSE] + "$";
// A simple gt/lt/eq thing, or just "" to indicate "any version"
var COMPARATORLOOSE = R++;
src[COMPARATORLOOSE] = "^" + src[GTLT] + "\\s*(" + LOOSEPLAIN + ")$|^$";
var COMPARATOR = R++;
src[COMPARATOR] = "^" + src[GTLT] + "\\s*(" + FULLPLAIN + ")$|^$";
// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
var COMPARATORTRIM = R++;
src[COMPARATORTRIM] = "(\\s*)" + src[GTLT] + "\\s*(" + LOOSEPLAIN + "|" + src[XRANGEPLAIN] + ")";
// this one has to use the /g flag
re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], "g");
safeRe[COMPARATORTRIM] = new RegExp(makeSafeRe(src[COMPARATORTRIM]), "g");
var comparatorTrimReplace = "$1$2$3";
// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
var HYPHENRANGE = R++;
src[HYPHENRANGE] = "^\\s*(" + src[XRANGEPLAIN] + ")" + "\\s+-\\s+" + "(" + src[XRANGEPLAIN] + ")" + "\\s*$";
var HYPHENRANGELOOSE = R++;
src[HYPHENRANGELOOSE] = "^\\s*(" + src[XRANGEPLAINLOOSE] + ")" + "\\s+-\\s+" + "(" + src[XRANGEPLAINLOOSE] + ")" + "\\s*$";
// Star ranges basically just allow anything at all.
var STAR = R++;
src[STAR] = "(<|>)?=?\\s*\\*";
// Compile to actual regexp objects.
// All are flag-free, unless they were created above with a flag.
for(var i = 0; i < R; i++){
    debug(i, src[i]);
    if (!re[i]) {
        re[i] = new RegExp(src[i]);
        // Replace all greedy whitespace to prevent regex dos issues. These regex are
        // used internally via the safeRe object since all inputs in this library get
        // normalized first to trim and collapse all extra whitespace. The original
        // regexes are exported for userland consumption and lower level usage. A
        // future breaking change could export the safer regex only with a note that
        // all input should have extra whitespace removed.
        safeRe[i] = new RegExp(makeSafeRe(src[i]));
    }
}
exports.parse = parse;
function parse(version, options) {
    if (!options || typeof options !== "object") options = {
        loose: !!options,
        includePrerelease: false
    };
    if (version instanceof SemVer) return version;
    if (typeof version !== "string") return null;
    if (version.length > MAX_LENGTH) return null;
    var r = options.loose ? safeRe[LOOSE] : safeRe[FULL];
    if (!r.test(version)) return null;
    try {
        return new SemVer(version, options);
    } catch (er) {
        return null;
    }
}
exports.valid = valid;
function valid(version, options) {
    var v = parse(version, options);
    return v ? v.version : null;
}
exports.clean = clean;
function clean(version, options) {
    var s = parse(version.trim().replace(/^[=v]+/, ""), options);
    return s ? s.version : null;
}
exports.SemVer = SemVer;
function SemVer(version, options) {
    if (!options || typeof options !== "object") options = {
        loose: !!options,
        includePrerelease: false
    };
    if (version instanceof SemVer) {
        if (version.loose === options.loose) return version;
        else version = version.version;
    } else if (typeof version !== "string") throw new TypeError("Invalid Version: " + version);
    if (version.length > MAX_LENGTH) throw new TypeError("version is longer than " + MAX_LENGTH + " characters");
    if (!(this instanceof SemVer)) return new SemVer(version, options);
    debug("SemVer", version, options);
    this.options = options;
    this.loose = !!options.loose;
    var m = version.trim().match(options.loose ? safeRe[LOOSE] : safeRe[FULL]);
    if (!m) throw new TypeError("Invalid Version: " + version);
    this.raw = version;
    // these are actually numbers
    this.major = +m[1];
    this.minor = +m[2];
    this.patch = +m[3];
    if (this.major > MAX_SAFE_INTEGER || this.major < 0) throw new TypeError("Invalid major version");
    if (this.minor > MAX_SAFE_INTEGER || this.minor < 0) throw new TypeError("Invalid minor version");
    if (this.patch > MAX_SAFE_INTEGER || this.patch < 0) throw new TypeError("Invalid patch version");
    // numberify any prerelease numeric ids
    if (!m[4]) this.prerelease = [];
    else this.prerelease = m[4].split(".").map(function(id) {
        if (/^[0-9]+$/.test(id)) {
            var num = +id;
            if (num >= 0 && num < MAX_SAFE_INTEGER) return num;
        }
        return id;
    });
    this.build = m[5] ? m[5].split(".") : [];
    this.format();
}
SemVer.prototype.format = function() {
    this.version = this.major + "." + this.minor + "." + this.patch;
    if (this.prerelease.length) this.version += "-" + this.prerelease.join(".");
    return this.version;
};
SemVer.prototype.toString = function() {
    return this.version;
};
SemVer.prototype.compare = function(other) {
    debug("SemVer.compare", this.version, this.options, other);
    if (!(other instanceof SemVer)) other = new SemVer(other, this.options);
    return this.compareMain(other) || this.comparePre(other);
};
SemVer.prototype.compareMain = function(other) {
    if (!(other instanceof SemVer)) other = new SemVer(other, this.options);
    return compareIdentifiers(this.major, other.major) || compareIdentifiers(this.minor, other.minor) || compareIdentifiers(this.patch, other.patch);
};
SemVer.prototype.comparePre = function(other) {
    if (!(other instanceof SemVer)) other = new SemVer(other, this.options);
    // NOT having a prerelease is > having one
    if (this.prerelease.length && !other.prerelease.length) return -1;
    else if (!this.prerelease.length && other.prerelease.length) return 1;
    else if (!this.prerelease.length && !other.prerelease.length) return 0;
    var i = 0;
    do {
        var a = this.prerelease[i];
        var b = other.prerelease[i];
        debug("prerelease compare", i, a, b);
        if (a === undefined && b === undefined) return 0;
        else if (b === undefined) return 1;
        else if (a === undefined) return -1;
        else if (a === b) continue;
        else return compareIdentifiers(a, b);
    }while (++i);
};
// preminor will bump the version up to the next minor release, and immediately
// down to pre-release. premajor and prepatch work the same way.
SemVer.prototype.inc = function(release, identifier) {
    switch(release){
        case "premajor":
            this.prerelease.length = 0;
            this.patch = 0;
            this.minor = 0;
            this.major++;
            this.inc("pre", identifier);
            break;
        case "preminor":
            this.prerelease.length = 0;
            this.patch = 0;
            this.minor++;
            this.inc("pre", identifier);
            break;
        case "prepatch":
            // If this is already a prerelease, it will bump to the next version
            // drop any prereleases that might already exist, since they are not
            // relevant at this point.
            this.prerelease.length = 0;
            this.inc("patch", identifier);
            this.inc("pre", identifier);
            break;
        // If the input is a non-prerelease version, this acts the same as
        // prepatch.
        case "prerelease":
            if (this.prerelease.length === 0) this.inc("patch", identifier);
            this.inc("pre", identifier);
            break;
        case "major":
            // If this is a pre-major version, bump up to the same major version.
            // Otherwise increment major.
            // 1.0.0-5 bumps to 1.0.0
            // 1.1.0 bumps to 2.0.0
            if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) this.major++;
            this.minor = 0;
            this.patch = 0;
            this.prerelease = [];
            break;
        case "minor":
            // If this is a pre-minor version, bump up to the same minor version.
            // Otherwise increment minor.
            // 1.2.0-5 bumps to 1.2.0
            // 1.2.1 bumps to 1.3.0
            if (this.patch !== 0 || this.prerelease.length === 0) this.minor++;
            this.patch = 0;
            this.prerelease = [];
            break;
        case "patch":
            // If this is not a pre-release version, it will increment the patch.
            // If it is a pre-release it will bump up to the same patch version.
            // 1.2.0-5 patches to 1.2.0
            // 1.2.0 patches to 1.2.1
            if (this.prerelease.length === 0) this.patch++;
            this.prerelease = [];
            break;
        // This probably shouldn't be used publicly.
        // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
        case "pre":
            if (this.prerelease.length === 0) this.prerelease = [
                0
            ];
            else {
                var i = this.prerelease.length;
                while(--i >= 0)if (typeof this.prerelease[i] === "number") {
                    this.prerelease[i]++;
                    i = -2;
                }
                if (i === -1) // didn't increment anything
                this.prerelease.push(0);
            }
            if (identifier) {
                // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
                // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
                if (this.prerelease[0] === identifier) {
                    if (isNaN(this.prerelease[1])) this.prerelease = [
                        identifier,
                        0
                    ];
                } else this.prerelease = [
                    identifier,
                    0
                ];
            }
            break;
        default:
            throw new Error("invalid increment argument: " + release);
    }
    this.format();
    this.raw = this.version;
    return this;
};
exports.inc = inc;
function inc(version, release, loose, identifier) {
    if (typeof loose === "string") {
        identifier = loose;
        loose = undefined;
    }
    try {
        return new SemVer(version, loose).inc(release, identifier).version;
    } catch (er) {
        return null;
    }
}
exports.diff = diff;
function diff(version1, version2) {
    if (eq(version1, version2)) return null;
    else {
        var v1 = parse(version1);
        var v2 = parse(version2);
        var prefix = "";
        if (v1.prerelease.length || v2.prerelease.length) {
            prefix = "pre";
            var defaultResult = "prerelease";
        }
        for(var key in v1)if (key === "major" || key === "minor" || key === "patch") {
            if (v1[key] !== v2[key]) return prefix + key;
        }
        return defaultResult // may be undefined
        ;
    }
}
exports.compareIdentifiers = compareIdentifiers;
var numeric = /^[0-9]+$/;
function compareIdentifiers(a, b) {
    var anum = numeric.test(a);
    var bnum = numeric.test(b);
    if (anum && bnum) {
        a = +a;
        b = +b;
    }
    return a === b ? 0 : anum && !bnum ? -1 : bnum && !anum ? 1 : a < b ? -1 : 1;
}
exports.rcompareIdentifiers = rcompareIdentifiers;
function rcompareIdentifiers(a, b) {
    return compareIdentifiers(b, a);
}
exports.major = major;
function major(a, loose) {
    return new SemVer(a, loose).major;
}
exports.minor = minor;
function minor(a, loose) {
    return new SemVer(a, loose).minor;
}
exports.patch = patch;
function patch(a, loose) {
    return new SemVer(a, loose).patch;
}
exports.compare = compare;
function compare(a, b, loose) {
    return new SemVer(a, loose).compare(new SemVer(b, loose));
}
exports.compareLoose = compareLoose;
function compareLoose(a, b) {
    return compare(a, b, true);
}
exports.rcompare = rcompare;
function rcompare(a, b, loose) {
    return compare(b, a, loose);
}
exports.sort = sort;
function sort(list, loose) {
    return list.sort(function(a, b) {
        return exports.compare(a, b, loose);
    });
}
exports.rsort = rsort;
function rsort(list, loose) {
    return list.sort(function(a, b) {
        return exports.rcompare(a, b, loose);
    });
}
exports.gt = gt;
function gt(a, b, loose) {
    return compare(a, b, loose) > 0;
}
exports.lt = lt;
function lt(a, b, loose) {
    return compare(a, b, loose) < 0;
}
exports.eq = eq;
function eq(a, b, loose) {
    return compare(a, b, loose) === 0;
}
exports.neq = neq;
function neq(a, b, loose) {
    return compare(a, b, loose) !== 0;
}
exports.gte = gte;
function gte(a, b, loose) {
    return compare(a, b, loose) >= 0;
}
exports.lte = lte;
function lte(a, b, loose) {
    return compare(a, b, loose) <= 0;
}
exports.cmp = cmp;
function cmp(a, op, b, loose) {
    switch(op){
        case "===":
            if (typeof a === "object") a = a.version;
            if (typeof b === "object") b = b.version;
            return a === b;
        case "!==":
            if (typeof a === "object") a = a.version;
            if (typeof b === "object") b = b.version;
            return a !== b;
        case "":
        case "=":
        case "==":
            return eq(a, b, loose);
        case "!=":
            return neq(a, b, loose);
        case ">":
            return gt(a, b, loose);
        case ">=":
            return gte(a, b, loose);
        case "<":
            return lt(a, b, loose);
        case "<=":
            return lte(a, b, loose);
        default:
            throw new TypeError("Invalid operator: " + op);
    }
}
exports.Comparator = Comparator;
function Comparator(comp, options) {
    if (!options || typeof options !== "object") options = {
        loose: !!options,
        includePrerelease: false
    };
    if (comp instanceof Comparator) {
        if (comp.loose === !!options.loose) return comp;
        else comp = comp.value;
    }
    if (!(this instanceof Comparator)) return new Comparator(comp, options);
    comp = comp.trim().split(/\s+/).join(" ");
    debug("comparator", comp, options);
    this.options = options;
    this.loose = !!options.loose;
    this.parse(comp);
    if (this.semver === ANY) this.value = "";
    else this.value = this.operator + this.semver.version;
    debug("comp", this);
}
var ANY = {};
Comparator.prototype.parse = function(comp) {
    var r = this.options.loose ? safeRe[COMPARATORLOOSE] : safeRe[COMPARATOR];
    var m = comp.match(r);
    if (!m) throw new TypeError("Invalid comparator: " + comp);
    this.operator = m[1];
    if (this.operator === "=") this.operator = "";
    // if it literally is just '>' or '' then allow anything.
    if (!m[2]) this.semver = ANY;
    else this.semver = new SemVer(m[2], this.options.loose);
};
Comparator.prototype.toString = function() {
    return this.value;
};
Comparator.prototype.test = function(version) {
    debug("Comparator.test", version, this.options.loose);
    if (this.semver === ANY) return true;
    if (typeof version === "string") version = new SemVer(version, this.options);
    return cmp(version, this.operator, this.semver, this.options);
};
Comparator.prototype.intersects = function(comp, options) {
    if (!(comp instanceof Comparator)) throw new TypeError("a Comparator is required");
    if (!options || typeof options !== "object") options = {
        loose: !!options,
        includePrerelease: false
    };
    var rangeTmp;
    if (this.operator === "") {
        rangeTmp = new Range(comp.value, options);
        return satisfies(this.value, rangeTmp, options);
    } else if (comp.operator === "") {
        rangeTmp = new Range(this.value, options);
        return satisfies(comp.semver, rangeTmp, options);
    }
    var sameDirectionIncreasing = (this.operator === ">=" || this.operator === ">") && (comp.operator === ">=" || comp.operator === ">");
    var sameDirectionDecreasing = (this.operator === "<=" || this.operator === "<") && (comp.operator === "<=" || comp.operator === "<");
    var sameSemVer = this.semver.version === comp.semver.version;
    var differentDirectionsInclusive = (this.operator === ">=" || this.operator === "<=") && (comp.operator === ">=" || comp.operator === "<=");
    var oppositeDirectionsLessThan = cmp(this.semver, "<", comp.semver, options) && (this.operator === ">=" || this.operator === ">") && (comp.operator === "<=" || comp.operator === "<");
    var oppositeDirectionsGreaterThan = cmp(this.semver, ">", comp.semver, options) && (this.operator === "<=" || this.operator === "<") && (comp.operator === ">=" || comp.operator === ">");
    return sameDirectionIncreasing || sameDirectionDecreasing || sameSemVer && differentDirectionsInclusive || oppositeDirectionsLessThan || oppositeDirectionsGreaterThan;
};
exports.Range = Range;
function Range(range, options) {
    if (!options || typeof options !== "object") options = {
        loose: !!options,
        includePrerelease: false
    };
    if (range instanceof Range) {
        if (range.loose === !!options.loose && range.includePrerelease === !!options.includePrerelease) return range;
        else return new Range(range.raw, options);
    }
    if (range instanceof Comparator) return new Range(range.value, options);
    if (!(this instanceof Range)) return new Range(range, options);
    this.options = options;
    this.loose = !!options.loose;
    this.includePrerelease = !!options.includePrerelease;
    // First reduce all whitespace as much as possible so we do not have to rely
    // on potentially slow regexes like \s*. This is then stored and used for
    // future error messages as well.
    this.raw = range.trim().split(/\s+/).join(" ");
    // First, split based on boolean or ||
    this.set = this.raw.split("||").map(function(range) {
        return this.parseRange(range.trim());
    }, this).filter(function(c) {
        // throw out any that are not relevant for whatever reason
        return c.length;
    });
    if (!this.set.length) throw new TypeError("Invalid SemVer Range: " + this.raw);
    this.format();
}
Range.prototype.format = function() {
    this.range = this.set.map(function(comps) {
        return comps.join(" ").trim();
    }).join("||").trim();
    return this.range;
};
Range.prototype.toString = function() {
    return this.range;
};
Range.prototype.parseRange = function(range) {
    var loose = this.options.loose;
    // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
    var hr = loose ? safeRe[HYPHENRANGELOOSE] : safeRe[HYPHENRANGE];
    range = range.replace(hr, hyphenReplace);
    debug("hyphen replace", range);
    // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
    range = range.replace(safeRe[COMPARATORTRIM], comparatorTrimReplace);
    debug("comparator trim", range, safeRe[COMPARATORTRIM]);
    // `~ 1.2.3` => `~1.2.3`
    range = range.replace(safeRe[TILDETRIM], tildeTrimReplace);
    // `^ 1.2.3` => `^1.2.3`
    range = range.replace(safeRe[CARETTRIM], caretTrimReplace);
    // At this point, the range is completely trimmed and
    // ready to be split into comparators.
    var compRe = loose ? safeRe[COMPARATORLOOSE] : safeRe[COMPARATOR];
    var set = range.split(" ").map(function(comp) {
        return parseComparator(comp, this.options);
    }, this).join(" ").split(/\s+/);
    if (this.options.loose) // in loose mode, throw out any that are not valid comparators
    set = set.filter(function(comp) {
        return !!comp.match(compRe);
    });
    set = set.map(function(comp) {
        return new Comparator(comp, this.options);
    }, this);
    return set;
};
Range.prototype.intersects = function(range, options) {
    if (!(range instanceof Range)) throw new TypeError("a Range is required");
    return this.set.some(function(thisComparators) {
        return thisComparators.every(function(thisComparator) {
            return range.set.some(function(rangeComparators) {
                return rangeComparators.every(function(rangeComparator) {
                    return thisComparator.intersects(rangeComparator, options);
                });
            });
        });
    });
};
// Mostly just for testing and legacy API reasons
exports.toComparators = toComparators;
function toComparators(range, options) {
    return new Range(range, options).set.map(function(comp) {
        return comp.map(function(c) {
            return c.value;
        }).join(" ").trim().split(" ");
    });
}
// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
function parseComparator(comp, options) {
    debug("comp", comp, options);
    comp = replaceCarets(comp, options);
    debug("caret", comp);
    comp = replaceTildes(comp, options);
    debug("tildes", comp);
    comp = replaceXRanges(comp, options);
    debug("xrange", comp);
    comp = replaceStars(comp, options);
    debug("stars", comp);
    return comp;
}
function isX(id) {
    return !id || id.toLowerCase() === "x" || id === "*";
}
// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
function replaceTildes(comp, options) {
    return comp.trim().split(/\s+/).map(function(comp) {
        return replaceTilde(comp, options);
    }).join(" ");
}
function replaceTilde(comp, options) {
    var r = options.loose ? safeRe[TILDELOOSE] : safeRe[TILDE];
    return comp.replace(r, function(_, M, m, p, pr) {
        debug("tilde", comp, _, M, m, p, pr);
        var ret;
        if (isX(M)) ret = "";
        else if (isX(m)) ret = ">=" + M + ".0.0 <" + (+M + 1) + ".0.0";
        else if (isX(p)) // ~1.2 == >=1.2.0 <1.3.0
        ret = ">=" + M + "." + m + ".0 <" + M + "." + (+m + 1) + ".0";
        else if (pr) {
            debug("replaceTilde pr", pr);
            ret = ">=" + M + "." + m + "." + p + "-" + pr + " <" + M + "." + (+m + 1) + ".0";
        } else // ~1.2.3 == >=1.2.3 <1.3.0
        ret = ">=" + M + "." + m + "." + p + " <" + M + "." + (+m + 1) + ".0";
        debug("tilde return", ret);
        return ret;
    });
}
// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
// ^1.2.3 --> >=1.2.3 <2.0.0
// ^1.2.0 --> >=1.2.0 <2.0.0
function replaceCarets(comp, options) {
    return comp.trim().split(/\s+/).map(function(comp) {
        return replaceCaret(comp, options);
    }).join(" ");
}
function replaceCaret(comp, options) {
    debug("caret", comp, options);
    var r = options.loose ? safeRe[CARETLOOSE] : safeRe[CARET];
    return comp.replace(r, function(_, M, m, p, pr) {
        debug("caret", comp, _, M, m, p, pr);
        var ret;
        if (isX(M)) ret = "";
        else if (isX(m)) ret = ">=" + M + ".0.0 <" + (+M + 1) + ".0.0";
        else if (isX(p)) {
            if (M === "0") ret = ">=" + M + "." + m + ".0 <" + M + "." + (+m + 1) + ".0";
            else ret = ">=" + M + "." + m + ".0 <" + (+M + 1) + ".0.0";
        } else if (pr) {
            debug("replaceCaret pr", pr);
            if (M === "0") {
                if (m === "0") ret = ">=" + M + "." + m + "." + p + "-" + pr + " <" + M + "." + m + "." + (+p + 1);
                else ret = ">=" + M + "." + m + "." + p + "-" + pr + " <" + M + "." + (+m + 1) + ".0";
            } else ret = ">=" + M + "." + m + "." + p + "-" + pr + " <" + (+M + 1) + ".0.0";
        } else {
            debug("no pr");
            if (M === "0") {
                if (m === "0") ret = ">=" + M + "." + m + "." + p + " <" + M + "." + m + "." + (+p + 1);
                else ret = ">=" + M + "." + m + "." + p + " <" + M + "." + (+m + 1) + ".0";
            } else ret = ">=" + M + "." + m + "." + p + " <" + (+M + 1) + ".0.0";
        }
        debug("caret return", ret);
        return ret;
    });
}
function replaceXRanges(comp, options) {
    debug("replaceXRanges", comp, options);
    return comp.split(/\s+/).map(function(comp) {
        return replaceXRange(comp, options);
    }).join(" ");
}
function replaceXRange(comp, options) {
    comp = comp.trim();
    var r = options.loose ? safeRe[XRANGELOOSE] : safeRe[XRANGE];
    return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
        debug("xRange", comp, ret, gtlt, M, m, p, pr);
        var xM = isX(M);
        var xm = xM || isX(m);
        var xp = xm || isX(p);
        var anyX = xp;
        if (gtlt === "=" && anyX) gtlt = "";
        if (xM) {
            if (gtlt === ">" || gtlt === "<") // nothing is allowed
            ret = "<0.0.0";
            else // nothing is forbidden
            ret = "*";
        } else if (gtlt && anyX) {
            // we know patch is an x, because we have any x at all.
            // replace X with 0
            if (xm) m = 0;
            p = 0;
            if (gtlt === ">") {
                // >1 => >=2.0.0
                // >1.2 => >=1.3.0
                // >1.2.3 => >= 1.2.4
                gtlt = ">=";
                if (xm) {
                    M = +M + 1;
                    m = 0;
                    p = 0;
                } else {
                    m = +m + 1;
                    p = 0;
                }
            } else if (gtlt === "<=") {
                // <=0.7.x is actually <0.8.0, since any 0.7.x should
                // pass.  Similarly, <=7.x is actually <8.0.0, etc.
                gtlt = "<";
                if (xm) M = +M + 1;
                else m = +m + 1;
            }
            ret = gtlt + M + "." + m + "." + p;
        } else if (xm) ret = ">=" + M + ".0.0 <" + (+M + 1) + ".0.0";
        else if (xp) ret = ">=" + M + "." + m + ".0 <" + M + "." + (+m + 1) + ".0";
        debug("xRange return", ret);
        return ret;
    });
}
// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
function replaceStars(comp, options) {
    debug("replaceStars", comp, options);
    // Looseness is ignored here.  star is always as loose as it gets!
    return comp.trim().replace(safeRe[STAR], "");
}
// This function is passed to string.replace(safeRe[HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0
function hyphenReplace($0, from, fM, fm, fp, fpr, fb, to, tM, tm, tp, tpr, tb) {
    if (isX(fM)) from = "";
    else if (isX(fm)) from = ">=" + fM + ".0.0";
    else if (isX(fp)) from = ">=" + fM + "." + fm + ".0";
    else from = ">=" + from;
    if (isX(tM)) to = "";
    else if (isX(tm)) to = "<" + (+tM + 1) + ".0.0";
    else if (isX(tp)) to = "<" + tM + "." + (+tm + 1) + ".0";
    else if (tpr) to = "<=" + tM + "." + tm + "." + tp + "-" + tpr;
    else to = "<=" + to;
    return (from + " " + to).trim();
}
// if ANY of the sets match ALL of its comparators, then pass
Range.prototype.test = function(version) {
    if (!version) return false;
    if (typeof version === "string") version = new SemVer(version, this.options);
    for(var i = 0; i < this.set.length; i++){
        if (testSet(this.set[i], version, this.options)) return true;
    }
    return false;
};
function testSet(set, version, options) {
    for(var i = 0; i < set.length; i++){
        if (!set[i].test(version)) return false;
    }
    if (version.prerelease.length && !options.includePrerelease) {
        // Find the set of versions that are allowed to have prereleases
        // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
        // That should allow `1.2.3-pr.2` to pass.
        // However, `1.2.4-alpha.notready` should NOT be allowed,
        // even though it's within the range set by the comparators.
        for(i = 0; i < set.length; i++){
            debug(set[i].semver);
            if (set[i].semver === ANY) continue;
            if (set[i].semver.prerelease.length > 0) {
                var allowed = set[i].semver;
                if (allowed.major === version.major && allowed.minor === version.minor && allowed.patch === version.patch) return true;
            }
        }
        // Version has a -pre, but it's not one of the ones we like.
        return false;
    }
    return true;
}
exports.satisfies = satisfies;
function satisfies(version, range, options) {
    try {
        range = new Range(range, options);
    } catch (er) {
        return false;
    }
    return range.test(version);
}
exports.maxSatisfying = maxSatisfying;
function maxSatisfying(versions, range, options) {
    var max = null;
    var maxSV = null;
    try {
        var rangeObj = new Range(range, options);
    } catch (er) {
        return null;
    }
    versions.forEach(function(v) {
        if (rangeObj.test(v)) // satisfies(v, range, options)
        {
            if (!max || maxSV.compare(v) === -1) {
                // compare(max, v, true)
                max = v;
                maxSV = new SemVer(max, options);
            }
        }
    });
    return max;
}
exports.minSatisfying = minSatisfying;
function minSatisfying(versions, range, options) {
    var min = null;
    var minSV = null;
    try {
        var rangeObj = new Range(range, options);
    } catch (er) {
        return null;
    }
    versions.forEach(function(v) {
        if (rangeObj.test(v)) // satisfies(v, range, options)
        {
            if (!min || minSV.compare(v) === 1) {
                // compare(min, v, true)
                min = v;
                minSV = new SemVer(min, options);
            }
        }
    });
    return min;
}
exports.minVersion = minVersion;
function minVersion(range, loose) {
    range = new Range(range, loose);
    var minver = new SemVer("0.0.0");
    if (range.test(minver)) return minver;
    minver = new SemVer("0.0.0-0");
    if (range.test(minver)) return minver;
    minver = null;
    for(var i = 0; i < range.set.length; ++i){
        var comparators = range.set[i];
        comparators.forEach(function(comparator) {
            // Clone to avoid manipulating the comparator's semver object.
            var compver = new SemVer(comparator.semver.version);
            switch(comparator.operator){
                case ">":
                    if (compver.prerelease.length === 0) compver.patch++;
                    else compver.prerelease.push(0);
                    compver.raw = compver.format();
                /* fallthrough */ case "":
                case ">=":
                    if (!minver || gt(minver, compver)) minver = compver;
                    break;
                case "<":
                case "<=":
                    break;
                /* istanbul ignore next */ default:
                    throw new Error("Unexpected operation: " + comparator.operator);
            }
        });
    }
    if (minver && range.test(minver)) return minver;
    return null;
}
exports.validRange = validRange;
function validRange(range, options) {
    try {
        // Return '*' instead of '' so that truthiness works.
        // This will throw if it's invalid anyway
        return new Range(range, options).range || "*";
    } catch (er) {
        return null;
    }
}
// Determine if version is less than all the versions possible in the range
exports.ltr = ltr;
function ltr(version, range, options) {
    return outside(version, range, "<", options);
}
// Determine if version is greater than all the versions possible in the range.
exports.gtr = gtr;
function gtr(version, range, options) {
    return outside(version, range, ">", options);
}
exports.outside = outside;
function outside(version, range, hilo, options) {
    version = new SemVer(version, options);
    range = new Range(range, options);
    var gtfn, ltefn, ltfn, comp, ecomp;
    switch(hilo){
        case ">":
            gtfn = gt;
            ltefn = lte;
            ltfn = lt;
            comp = ">";
            ecomp = ">=";
            break;
        case "<":
            gtfn = lt;
            ltefn = gte;
            ltfn = gt;
            comp = "<";
            ecomp = "<=";
            break;
        default:
            throw new TypeError('Must provide a hilo val of "<" or ">"');
    }
    // If it satisifes the range it is not outside
    if (satisfies(version, range, options)) return false;
    // From now on, variable terms are as if we're in "gtr" mode.
    // but note that everything is flipped for the "ltr" function.
    for(var i = 0; i < range.set.length; ++i){
        var comparators = range.set[i];
        var high = null;
        var low = null;
        comparators.forEach(function(comparator) {
            if (comparator.semver === ANY) comparator = new Comparator(">=0.0.0");
            high = high || comparator;
            low = low || comparator;
            if (gtfn(comparator.semver, high.semver, options)) high = comparator;
            else if (ltfn(comparator.semver, low.semver, options)) low = comparator;
        });
        // If the edge version comparator has a operator then our version
        // isn't outside it
        if (high.operator === comp || high.operator === ecomp) return false;
        // If the lowest version comparator has an operator and our version
        // is less than it then it isn't higher than the range
        if ((!low.operator || low.operator === comp) && ltefn(version, low.semver)) return false;
        else if (low.operator === ecomp && ltfn(version, low.semver)) return false;
    }
    return true;
}
exports.prerelease = prerelease;
function prerelease(version, options) {
    var parsed = parse(version, options);
    return parsed && parsed.prerelease.length ? parsed.prerelease : null;
}
exports.intersects = intersects;
function intersects(r1, r2, options) {
    r1 = new Range(r1, options);
    r2 = new Range(r2, options);
    return r1.intersects(r2);
}
exports.coerce = coerce;
function coerce(version) {
    if (version instanceof SemVer) return version;
    if (typeof version !== "string") return null;
    var match = version.match(safeRe[COERCE]);
    if (match == null) return null;
    return parse(match[1] + "." + (match[2] || "0") + "." + (match[3] || "0"));
}

});



parcelRegister("26TDN", function(module, exports) {

var $l0HdX = parcelRequire("l0HdX");

var $8dlmd = parcelRequire("8dlmd");
var $18974d725f28197e$require$Buffer = $8dlmd.Buffer;

var $3v2vH = parcelRequire("3v2vH");

var $4Q3pU = parcelRequire("4Q3pU");

var $k6iCM = parcelRequire("k6iCM");

var $95ofo = parcelRequire("95ofo");

var $ankif = parcelRequire("ankif");

var $jEVyY = parcelRequire("jEVyY");

var $88CoJ = parcelRequire("88CoJ");

var $fBIYc = parcelRequire("fBIYc");

var $ZIHWX = parcelRequire("ZIHWX");

var $l8UoO = parcelRequire("l8UoO");
var $18974d725f28197e$var$SUPPORTED_ALGS = [
    "RS256",
    "RS384",
    "RS512",
    "ES256",
    "ES384",
    "ES512",
    "HS256",
    "HS384",
    "HS512",
    "none"
];
if ($4Q3pU) $18974d725f28197e$var$SUPPORTED_ALGS.splice(3, 0, "PS256", "PS384", "PS512");
var $18974d725f28197e$var$sign_options_schema = {
    expiresIn: {
        isValid: function isValid(value) {
            return $jEVyY(value) || $ZIHWX(value) && value;
        },
        message: '"expiresIn" should be a number of seconds or string representing a timespan'
    },
    notBefore: {
        isValid: function isValid(value) {
            return $jEVyY(value) || $ZIHWX(value) && value;
        },
        message: '"notBefore" should be a number of seconds or string representing a timespan'
    },
    audience: {
        isValid: function isValid(value) {
            return $ZIHWX(value) || Array.isArray(value);
        },
        message: '"audience" must be a string or array'
    },
    algorithm: {
        isValid: $95ofo.bind(null, $18974d725f28197e$var$SUPPORTED_ALGS),
        message: '"algorithm" must be a valid string enum value'
    },
    header: {
        isValid: $fBIYc,
        message: '"header" must be an object'
    },
    encoding: {
        isValid: $ZIHWX,
        message: '"encoding" must be a string'
    },
    issuer: {
        isValid: $ZIHWX,
        message: '"issuer" must be a string'
    },
    subject: {
        isValid: $ZIHWX,
        message: '"subject" must be a string'
    },
    jwtid: {
        isValid: $ZIHWX,
        message: '"jwtid" must be a string'
    },
    noTimestamp: {
        isValid: $ankif,
        message: '"noTimestamp" must be a boolean'
    },
    keyid: {
        isValid: $ZIHWX,
        message: '"keyid" must be a string'
    },
    mutatePayload: {
        isValid: $ankif,
        message: '"mutatePayload" must be a boolean'
    }
};
var $18974d725f28197e$var$registered_claims_schema = {
    iat: {
        isValid: $88CoJ,
        message: '"iat" should be a number of seconds'
    },
    exp: {
        isValid: $88CoJ,
        message: '"exp" should be a number of seconds'
    },
    nbf: {
        isValid: $88CoJ,
        message: '"nbf" should be a number of seconds'
    }
};
function $18974d725f28197e$var$validate(schema, allowUnknown, object, parameterName) {
    if (!$fBIYc(object)) throw new Error('Expected "' + parameterName + '" to be a plain object.');
    Object.keys(object).forEach(function(key) {
        var validator = schema[key];
        if (!validator) {
            if (!allowUnknown) throw new Error('"' + key + '" is not allowed in "' + parameterName + '"');
            return;
        }
        if (!validator.isValid(object[key])) throw new Error(validator.message);
    });
}
function $18974d725f28197e$var$validateOptions(options) {
    return $18974d725f28197e$var$validate($18974d725f28197e$var$sign_options_schema, false, options, "options");
}
function $18974d725f28197e$var$validatePayload(payload) {
    return $18974d725f28197e$var$validate($18974d725f28197e$var$registered_claims_schema, true, payload, "payload");
}
var $18974d725f28197e$var$options_to_payload = {
    "audience": "aud",
    "issuer": "iss",
    "subject": "sub",
    "jwtid": "jti"
};
var $18974d725f28197e$var$options_for_objects = [
    "expiresIn",
    "notBefore",
    "noTimestamp",
    "audience",
    "issuer",
    "subject",
    "jwtid"
];
module.exports = function(payload, secretOrPrivateKey, options, callback) {
    if (typeof options === "function") {
        callback = options;
        options = {};
    } else options = options || {};
    var isObjectPayload = typeof payload === "object" && !$18974d725f28197e$require$Buffer.isBuffer(payload);
    var header = Object.assign({
        alg: options.algorithm || "HS256",
        typ: isObjectPayload ? "JWT" : undefined,
        kid: options.keyid
    }, options.header);
    function failure(err) {
        if (callback) return callback(err);
        throw err;
    }
    if (!secretOrPrivateKey && options.algorithm !== "none") return failure(new Error("secretOrPrivateKey must have a value"));
    if (typeof payload === "undefined") return failure(new Error("payload is required"));
    else if (isObjectPayload) {
        try {
            $18974d725f28197e$var$validatePayload(payload);
        } catch (error) {
            return failure(error);
        }
        if (!options.mutatePayload) payload = Object.assign({}, payload);
    } else {
        var invalid_options = $18974d725f28197e$var$options_for_objects.filter(function(opt) {
            return typeof options[opt] !== "undefined";
        });
        if (invalid_options.length > 0) return failure(new Error("invalid " + invalid_options.join(",") + " option for " + (typeof payload === "undefined" ? "undefined" : (0, $l0HdX._)(payload)) + " payload"));
    }
    if (typeof payload.exp !== "undefined" && typeof options.expiresIn !== "undefined") return failure(new Error('Bad "options.expiresIn" option the payload already has an "exp" property.'));
    if (typeof payload.nbf !== "undefined" && typeof options.notBefore !== "undefined") return failure(new Error('Bad "options.notBefore" option the payload already has an "nbf" property.'));
    try {
        $18974d725f28197e$var$validateOptions(options);
    } catch (error) {
        return failure(error);
    }
    var timestamp = payload.iat || Math.floor(Date.now() / 1000);
    if (options.noTimestamp) delete payload.iat;
    else if (isObjectPayload) payload.iat = timestamp;
    if (typeof options.notBefore !== "undefined") {
        try {
            payload.nbf = $3v2vH(options.notBefore, timestamp);
        } catch (err) {
            return failure(err);
        }
        if (typeof payload.nbf === "undefined") return failure(new Error('"notBefore" should be a number of seconds or string representing a timespan eg: "1d", "20h", 60'));
    }
    if (typeof options.expiresIn !== "undefined" && typeof payload === "object") {
        try {
            payload.exp = $3v2vH(options.expiresIn, timestamp);
        } catch (err) {
            return failure(err);
        }
        if (typeof payload.exp === "undefined") return failure(new Error('"expiresIn" should be a number of seconds or string representing a timespan eg: "1d", "20h", 60'));
    }
    Object.keys($18974d725f28197e$var$options_to_payload).forEach(function(key) {
        var claim = $18974d725f28197e$var$options_to_payload[key];
        if (typeof options[key] !== "undefined") {
            if (typeof payload[claim] !== "undefined") return failure(new Error('Bad "options.' + key + '" option. The payload already has an "' + claim + '" property.'));
            payload[claim] = options[key];
        }
    });
    var encoding = options.encoding || "utf8";
    if (typeof callback === "function") {
        callback = callback && $l8UoO(callback);
        $k6iCM.createSign({
            header: header,
            privateKey: secretOrPrivateKey,
            payload: payload,
            encoding: encoding
        }).once("error", callback).once("done", function(signature) {
            callback(null, signature);
        });
    } else return $k6iCM.sign({
        header: header,
        payload: payload,
        secret: secretOrPrivateKey,
        encoding: encoding
    });
};

});
parcelRegister("95ofo", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as references for various `Number` constants. */ 
var $l0HdX = parcelRequire("l0HdX");
var $69d763ad88f3bade$var$INFINITY = 1 / 0, $69d763ad88f3bade$var$MAX_SAFE_INTEGER = 9007199254740991, $69d763ad88f3bade$var$MAX_INTEGER = 1.7976931348623157e+308, $69d763ad88f3bade$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $69d763ad88f3bade$var$argsTag = "[object Arguments]", $69d763ad88f3bade$var$funcTag = "[object Function]", $69d763ad88f3bade$var$genTag = "[object GeneratorFunction]", $69d763ad88f3bade$var$stringTag = "[object String]", $69d763ad88f3bade$var$symbolTag = "[object Symbol]";
/** Used to match leading and trailing whitespace. */ var $69d763ad88f3bade$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $69d763ad88f3bade$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $69d763ad88f3bade$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $69d763ad88f3bade$var$reIsOctal = /^0o[0-7]+$/i;
/** Used to detect unsigned integer values. */ var $69d763ad88f3bade$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/** Built-in method references without a dependency on `root`. */ var $69d763ad88f3bade$var$freeParseInt = parseInt;
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $69d763ad88f3bade$var$arrayMap(array, iteratee) {
    var index = -1, length = array ? array.length : 0, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $69d763ad88f3bade$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $69d763ad88f3bade$var$baseIndexOf(array, value, fromIndex) {
    if (value !== value) return $69d763ad88f3bade$var$baseFindIndex(array, $69d763ad88f3bade$var$baseIsNaN, fromIndex);
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $69d763ad88f3bade$var$baseIsNaN(value) {
    return value !== value;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $69d763ad88f3bade$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */ function $69d763ad88f3bade$var$baseValues(object, props) {
    return $69d763ad88f3bade$var$arrayMap(props, function(key) {
        return object[key];
    });
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $69d763ad88f3bade$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/** Used for built-in method references. */ var $69d763ad88f3bade$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $69d763ad88f3bade$var$hasOwnProperty = $69d763ad88f3bade$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $69d763ad88f3bade$var$objectToString = $69d763ad88f3bade$var$objectProto.toString;
/** Built-in value references. */ var $69d763ad88f3bade$var$propertyIsEnumerable = $69d763ad88f3bade$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $69d763ad88f3bade$var$nativeKeys = $69d763ad88f3bade$var$overArg(Object.keys, Object), $69d763ad88f3bade$var$nativeMax = Math.max;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $69d763ad88f3bade$var$arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = $69d763ad88f3bade$var$isArray(value) || $69d763ad88f3bade$var$isArguments(value) ? $69d763ad88f3bade$var$baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || $69d763ad88f3bade$var$hasOwnProperty.call(value, key)) && !(skipIndexes && (key == "length" || $69d763ad88f3bade$var$isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $69d763ad88f3bade$var$baseKeys(object) {
    if (!$69d763ad88f3bade$var$isPrototype(object)) return $69d763ad88f3bade$var$nativeKeys(object);
    var result = [];
    for(var key in Object(object))if ($69d763ad88f3bade$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $69d763ad88f3bade$var$isIndex(value, length) {
    length = length == null ? $69d763ad88f3bade$var$MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == "number" || $69d763ad88f3bade$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $69d763ad88f3bade$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $69d763ad88f3bade$var$objectProto;
    return value === proto;
}
/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */ function $69d763ad88f3bade$var$includes(collection, value, fromIndex, guard) {
    collection = $69d763ad88f3bade$var$isArrayLike(collection) ? collection : $69d763ad88f3bade$var$values(collection);
    fromIndex = fromIndex && !guard ? $69d763ad88f3bade$var$toInteger(fromIndex) : 0;
    var length = collection.length;
    if (fromIndex < 0) fromIndex = $69d763ad88f3bade$var$nativeMax(length + fromIndex, 0);
    return $69d763ad88f3bade$var$isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && $69d763ad88f3bade$var$baseIndexOf(collection, value, fromIndex) > -1;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function $69d763ad88f3bade$var$isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return $69d763ad88f3bade$var$isArrayLikeObject(value) && $69d763ad88f3bade$var$hasOwnProperty.call(value, "callee") && (!$69d763ad88f3bade$var$propertyIsEnumerable.call(value, "callee") || $69d763ad88f3bade$var$objectToString.call(value) == $69d763ad88f3bade$var$argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $69d763ad88f3bade$var$isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $69d763ad88f3bade$var$isArrayLike(value) {
    return value != null && $69d763ad88f3bade$var$isLength(value.length) && !$69d763ad88f3bade$var$isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $69d763ad88f3bade$var$isArrayLikeObject(value) {
    return $69d763ad88f3bade$var$isObjectLike(value) && $69d763ad88f3bade$var$isArrayLike(value);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $69d763ad88f3bade$var$isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = $69d763ad88f3bade$var$isObject(value) ? $69d763ad88f3bade$var$objectToString.call(value) : "";
    return tag == $69d763ad88f3bade$var$funcTag || tag == $69d763ad88f3bade$var$genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $69d763ad88f3bade$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $69d763ad88f3bade$var$MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $69d763ad88f3bade$var$isObject(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, $l0HdX._)(value);
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $69d763ad88f3bade$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $69d763ad88f3bade$var$isString(value) {
    return typeof value == "string" || !$69d763ad88f3bade$var$isArray(value) && $69d763ad88f3bade$var$isObjectLike(value) && $69d763ad88f3bade$var$objectToString.call(value) == $69d763ad88f3bade$var$stringTag;
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $69d763ad88f3bade$var$isSymbol(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $l0HdX._)(value)) == "symbol" || $69d763ad88f3bade$var$isObjectLike(value) && $69d763ad88f3bade$var$objectToString.call(value) == $69d763ad88f3bade$var$symbolTag;
}
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $69d763ad88f3bade$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $69d763ad88f3bade$var$toNumber(value);
    if (value === $69d763ad88f3bade$var$INFINITY || value === -$69d763ad88f3bade$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $69d763ad88f3bade$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $69d763ad88f3bade$var$toInteger(value) {
    var result = $69d763ad88f3bade$var$toFinite(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $69d763ad88f3bade$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($69d763ad88f3bade$var$isSymbol(value)) return $69d763ad88f3bade$var$NAN;
    if ($69d763ad88f3bade$var$isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $69d763ad88f3bade$var$isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace($69d763ad88f3bade$var$reTrim, "");
    var isBinary = $69d763ad88f3bade$var$reIsBinary.test(value);
    return isBinary || $69d763ad88f3bade$var$reIsOctal.test(value) ? $69d763ad88f3bade$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $69d763ad88f3bade$var$reIsBadHex.test(value) ? $69d763ad88f3bade$var$NAN : +value;
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $69d763ad88f3bade$var$keys(object) {
    return $69d763ad88f3bade$var$isArrayLike(object) ? $69d763ad88f3bade$var$arrayLikeKeys(object) : $69d763ad88f3bade$var$baseKeys(object);
}
/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */ function $69d763ad88f3bade$var$values(object) {
    return object ? $69d763ad88f3bade$var$baseValues(object, $69d763ad88f3bade$var$keys(object)) : [];
}
module.exports = $69d763ad88f3bade$var$includes;

});

parcelRegister("ankif", function(module, exports) {
/**
 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /** `Object#toString` result references. */ var $78dbcb35bce8beb8$var$boolTag = "[object Boolean]";
/** Used for built-in method references. */ var $78dbcb35bce8beb8$var$objectProto = Object.prototype;
/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */ var $78dbcb35bce8beb8$var$objectToString = $78dbcb35bce8beb8$var$objectProto.toString;
/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */ function $78dbcb35bce8beb8$var$isBoolean(value) {
    return value === true || value === false || $78dbcb35bce8beb8$var$isObjectLike(value) && $78dbcb35bce8beb8$var$objectToString.call(value) == $78dbcb35bce8beb8$var$boolTag;
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $78dbcb35bce8beb8$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
module.exports = $78dbcb35bce8beb8$var$isBoolean;

});

parcelRegister("jEVyY", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as references for various `Number` constants. */ 
var $l0HdX = parcelRequire("l0HdX");
var $e4fe6798af501d19$var$INFINITY = 1 / 0, $e4fe6798af501d19$var$MAX_INTEGER = 1.7976931348623157e+308, $e4fe6798af501d19$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $e4fe6798af501d19$var$symbolTag = "[object Symbol]";
/** Used to match leading and trailing whitespace. */ var $e4fe6798af501d19$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $e4fe6798af501d19$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $e4fe6798af501d19$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $e4fe6798af501d19$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $e4fe6798af501d19$var$freeParseInt = parseInt;
/** Used for built-in method references. */ var $e4fe6798af501d19$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $e4fe6798af501d19$var$objectToString = $e4fe6798af501d19$var$objectProto.toString;
/**
 * Checks if `value` is an integer.
 *
 * **Note:** This method is based on
 * [`Number.isInteger`](https://mdn.io/Number/isInteger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
 * @example
 *
 * _.isInteger(3);
 * // => true
 *
 * _.isInteger(Number.MIN_VALUE);
 * // => false
 *
 * _.isInteger(Infinity);
 * // => false
 *
 * _.isInteger('3');
 * // => false
 */ function $e4fe6798af501d19$var$isInteger(value) {
    return typeof value == "number" && value == $e4fe6798af501d19$var$toInteger(value);
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $e4fe6798af501d19$var$isObject(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, $l0HdX._)(value);
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $e4fe6798af501d19$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $e4fe6798af501d19$var$isSymbol(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $l0HdX._)(value)) == "symbol" || $e4fe6798af501d19$var$isObjectLike(value) && $e4fe6798af501d19$var$objectToString.call(value) == $e4fe6798af501d19$var$symbolTag;
}
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $e4fe6798af501d19$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $e4fe6798af501d19$var$toNumber(value);
    if (value === $e4fe6798af501d19$var$INFINITY || value === -$e4fe6798af501d19$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $e4fe6798af501d19$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $e4fe6798af501d19$var$toInteger(value) {
    var result = $e4fe6798af501d19$var$toFinite(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $e4fe6798af501d19$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($e4fe6798af501d19$var$isSymbol(value)) return $e4fe6798af501d19$var$NAN;
    if ($e4fe6798af501d19$var$isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $e4fe6798af501d19$var$isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace($e4fe6798af501d19$var$reTrim, "");
    var isBinary = $e4fe6798af501d19$var$reIsBinary.test(value);
    return isBinary || $e4fe6798af501d19$var$reIsOctal.test(value) ? $e4fe6798af501d19$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $e4fe6798af501d19$var$reIsBadHex.test(value) ? $e4fe6798af501d19$var$NAN : +value;
}
module.exports = $e4fe6798af501d19$var$isInteger;

});

parcelRegister("88CoJ", function(module, exports) {
/**
 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /** `Object#toString` result references. */ var $5eccdb1e25305d56$var$numberTag = "[object Number]";
/** Used for built-in method references. */ var $5eccdb1e25305d56$var$objectProto = Object.prototype;
/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */ var $5eccdb1e25305d56$var$objectToString = $5eccdb1e25305d56$var$objectProto.toString;
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $5eccdb1e25305d56$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
 * as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $5eccdb1e25305d56$var$isNumber(value) {
    return typeof value == "number" || $5eccdb1e25305d56$var$isObjectLike(value) && $5eccdb1e25305d56$var$objectToString.call(value) == $5eccdb1e25305d56$var$numberTag;
}
module.exports = $5eccdb1e25305d56$var$isNumber;

});

parcelRegister("fBIYc", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** `Object#toString` result references. */ var $b5cd31d414c2856b$var$objectTag = "[object Object]";
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function $b5cd31d414c2856b$var$isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != "function") try {
        result = !!(value + "");
    } catch (e) {}
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $b5cd31d414c2856b$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/** Used for built-in method references. */ var $b5cd31d414c2856b$var$funcProto = Function.prototype, $b5cd31d414c2856b$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $b5cd31d414c2856b$var$funcToString = $b5cd31d414c2856b$var$funcProto.toString;
/** Used to check objects for own properties. */ var $b5cd31d414c2856b$var$hasOwnProperty = $b5cd31d414c2856b$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $b5cd31d414c2856b$var$objectCtorString = $b5cd31d414c2856b$var$funcToString.call(Object);
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $b5cd31d414c2856b$var$objectToString = $b5cd31d414c2856b$var$objectProto.toString;
/** Built-in value references. */ var $b5cd31d414c2856b$var$getPrototype = $b5cd31d414c2856b$var$overArg(Object.getPrototypeOf, Object);
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $b5cd31d414c2856b$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $b5cd31d414c2856b$var$isPlainObject(value) {
    if (!$b5cd31d414c2856b$var$isObjectLike(value) || $b5cd31d414c2856b$var$objectToString.call(value) != $b5cd31d414c2856b$var$objectTag || $b5cd31d414c2856b$var$isHostObject(value)) return false;
    var proto = $b5cd31d414c2856b$var$getPrototype(value);
    if (proto === null) return true;
    var Ctor = $b5cd31d414c2856b$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $b5cd31d414c2856b$var$funcToString.call(Ctor) == $b5cd31d414c2856b$var$objectCtorString;
}
module.exports = $b5cd31d414c2856b$var$isPlainObject;

});

parcelRegister("ZIHWX", function(module, exports) {
/**
 * lodash 4.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /** `Object#toString` result references. */ var $0b9860abf6e3480f$var$stringTag = "[object String]";
/** Used for built-in method references. */ var $0b9860abf6e3480f$var$objectProto = Object.prototype;
/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */ var $0b9860abf6e3480f$var$objectToString = $0b9860abf6e3480f$var$objectProto.toString;
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @type Function
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $0b9860abf6e3480f$var$isArray = Array.isArray;
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $0b9860abf6e3480f$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $0b9860abf6e3480f$var$isString(value) {
    return typeof value == "string" || !$0b9860abf6e3480f$var$isArray(value) && $0b9860abf6e3480f$var$isObjectLike(value) && $0b9860abf6e3480f$var$objectToString.call(value) == $0b9860abf6e3480f$var$stringTag;
}
module.exports = $0b9860abf6e3480f$var$isString;

});

parcelRegister("l8UoO", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ 
var $l0HdX = parcelRequire("l0HdX");
var $f646180a1894899a$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used as references for various `Number` constants. */ var $f646180a1894899a$var$INFINITY = 1 / 0, $f646180a1894899a$var$MAX_INTEGER = 1.7976931348623157e+308, $f646180a1894899a$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $f646180a1894899a$var$symbolTag = "[object Symbol]";
/** Used to match leading and trailing whitespace. */ var $f646180a1894899a$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $f646180a1894899a$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $f646180a1894899a$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $f646180a1894899a$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $f646180a1894899a$var$freeParseInt = parseInt;
/** Used for built-in method references. */ var $f646180a1894899a$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $f646180a1894899a$var$objectToString = $f646180a1894899a$var$objectProto.toString;
/**
 * Creates a function that invokes `func`, with the `this` binding and arguments
 * of the created function, while it's called less than `n` times. Subsequent
 * calls to the created function return the result of the last `func` invocation.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {number} n The number of calls at which `func` is no longer invoked.
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * jQuery(element).on('click', _.before(5, addContactToList));
 * // => Allows adding up to 4 contacts to the list.
 */ function $f646180a1894899a$var$before(n, func) {
    var result;
    if (typeof func != "function") throw new TypeError($f646180a1894899a$var$FUNC_ERROR_TEXT);
    n = $f646180a1894899a$var$toInteger(n);
    return function() {
        if (--n > 0) result = func.apply(this, arguments);
        if (n <= 1) func = undefined;
        return result;
    };
}
/**
 * Creates a function that is restricted to invoking `func` once. Repeat calls
 * to the function return the value of the first invocation. The `func` is
 * invoked with the `this` binding and arguments of the created function.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * var initialize = _.once(createApplication);
 * initialize();
 * initialize();
 * // => `createApplication` is invoked once
 */ function $f646180a1894899a$var$once(func) {
    return $f646180a1894899a$var$before(2, func);
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $f646180a1894899a$var$isObject(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, $l0HdX._)(value);
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $f646180a1894899a$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $f646180a1894899a$var$isSymbol(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $l0HdX._)(value)) == "symbol" || $f646180a1894899a$var$isObjectLike(value) && $f646180a1894899a$var$objectToString.call(value) == $f646180a1894899a$var$symbolTag;
}
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $f646180a1894899a$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $f646180a1894899a$var$toNumber(value);
    if (value === $f646180a1894899a$var$INFINITY || value === -$f646180a1894899a$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $f646180a1894899a$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $f646180a1894899a$var$toInteger(value) {
    var result = $f646180a1894899a$var$toFinite(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $f646180a1894899a$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($f646180a1894899a$var$isSymbol(value)) return $f646180a1894899a$var$NAN;
    if ($f646180a1894899a$var$isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $f646180a1894899a$var$isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace($f646180a1894899a$var$reTrim, "");
    var isBinary = $f646180a1894899a$var$reIsBinary.test(value);
    return isBinary || $f646180a1894899a$var$reIsOctal.test(value) ? $f646180a1894899a$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $f646180a1894899a$var$reIsBadHex.test(value) ? $f646180a1894899a$var$NAN : +value;
}
module.exports = $f646180a1894899a$var$once;

});




parcelRegister("eDmKf", function(module, exports) {

$parcel$export(module.exports, "decodeAsapPrivateKeyDataUri", function () { return $aa7659de586a5e6b$export$b704b405606abbca; });
parcelRequire("8swxV");
var $bo20b = parcelRequire("bo20b");

var $29L6x = parcelRequire("29L6x");

var $ej1jw = parcelRequire("ej1jw");
var $aa7659de586a5e6b$var$DATA_URI_PATTERN = /^data:application\/pkcs8;kid=([\w.\-+/]+);base64,([a-zA-Z0-9+/=]+)$/;
function $aa7659de586a5e6b$var$decodePrivateKeyBase64(base64) {
    var der = (0, $ej1jw.util).decode64(base64);
    var privateKey = (0, $ej1jw.pki).privateKeyFromAsn1((0, $ej1jw.asn1).fromDer(der));
    return (0, $ej1jw.pki).privateKeyToPem(privateKey);
}
function $aa7659de586a5e6b$export$b704b405606abbca(dataUri) {
    var match = $aa7659de586a5e6b$var$DATA_URI_PATTERN.exec(decodeURIComponent(dataUri));
    if (match) return {
        keyId: match[1],
        privateKey: $aa7659de586a5e6b$var$decodePrivateKeyBase64(match[2]).replace(/\\n/g, "\n").replace(/"/g, "").trim()
    };
    else throw new Error("Data URI does not match ASAP_PRIVATE_KEY format.");
}
function $aa7659de586a5e6b$export$6b06a513d2b998c1(token) {
    var decodedToken = (0, $29L6x.decode)(token);
    if ((0, $bo20b.isObject)(decodedToken)) return decodedToken;
    else return {};
}

});
parcelRegister("ej1jw", function(module, exports) {
/**
 * Node.js module for Forge.
 *
 * @author Dave Longley
 *
 * Copyright 2011-2016 Digital Bazaar, Inc.
 */ 
module.exports = (parcelRequire("fz7FM"));
parcelRequire("60qK1");
parcelRequire("1Kjlm");
parcelRequire("d4EnE");
parcelRequire("4Bsm2");
parcelRequire("bhqHY");
parcelRequire("Z0bIW");
parcelRequire("9YZGj");
parcelRequire("lejEO");
parcelRequire("8Mfmm");
parcelRequire("6c6HA");
parcelRequire("lQ4Ml");
parcelRequire("jkn5W");
parcelRequire("8061v");
parcelRequire("2hbS7");
parcelRequire("fv3Sg");
parcelRequire("dOZFj");
parcelRequire("c6KQm");
parcelRequire("lNcH9");
parcelRequire("aQ9s6");
parcelRequire("1VUmF");
parcelRequire("a65r1");
parcelRequire("3231S");
parcelRequire("kRrm7");
parcelRequire("935ik");
parcelRequire("gao36");

});
parcelRegister("fz7FM", function(module, exports) {
/**
 * Node.js module for Forge.
 *
 * @author Dave Longley
 *
 * Copyright 2011-2016 Digital Bazaar, Inc.
 */ module.exports = {
    // default options
    options: {
        usePureJavaScript: false
    }
};

});

parcelRegister("60qK1", function(module, exports) {
/**
 * Advanced Encryption Standard (AES) implementation.
 *
 * This implementation is based on the public domain library 'jscrypto' which
 * was written by:
 *
 * Emily Stark (estark@stanford.edu)
 * Mike Hamburg (mhamburg@stanford.edu)
 * Dan Boneh (dabo@cs.stanford.edu)
 *
 * Parts of this code are based on the OpenSSL implementation of AES:
 * http://www.openssl.org
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2014 Digital Bazaar, Inc.
 */ 
var $fz7FM = parcelRequire("fz7FM");
parcelRequire("4Bsm2");
parcelRequire("2hAcz");
parcelRequire("gao36");
/* AES API */ module.exports = $fz7FM.aes = $fz7FM.aes || {};
/**
 * Deprecated. Instead, use:
 *
 * var cipher = forge.cipher.createCipher('AES-<mode>', key);
 * cipher.start({iv: iv});
 *
 * Creates an AES cipher object to encrypt data using the given symmetric key.
 * The output will be stored in the 'output' member of the returned cipher.
 *
 * The key and iv may be given as a string of bytes, an array of bytes,
 * a byte buffer, or an array of 32-bit words.
 *
 * @param key the symmetric key to use.
 * @param iv the initialization vector to use.
 * @param output the buffer to write to, null to create one.
 * @param mode the cipher mode to use (default: 'CBC').
 *
 * @return the cipher.
 */ $fz7FM.aes.startEncrypting = function(key, iv, output, mode) {
    var cipher = $45f77c72b66ff073$var$_createCipher({
        key: key,
        output: output,
        decrypt: false,
        mode: mode
    });
    cipher.start(iv);
    return cipher;
};
/**
 * Deprecated. Instead, use:
 *
 * var cipher = forge.cipher.createCipher('AES-<mode>', key);
 *
 * Creates an AES cipher object to encrypt data using the given symmetric key.
 *
 * The key may be given as a string of bytes, an array of bytes, a
 * byte buffer, or an array of 32-bit words.
 *
 * @param key the symmetric key to use.
 * @param mode the cipher mode to use (default: 'CBC').
 *
 * @return the cipher.
 */ $fz7FM.aes.createEncryptionCipher = function(key, mode) {
    return $45f77c72b66ff073$var$_createCipher({
        key: key,
        output: null,
        decrypt: false,
        mode: mode
    });
};
/**
 * Deprecated. Instead, use:
 *
 * var decipher = forge.cipher.createDecipher('AES-<mode>', key);
 * decipher.start({iv: iv});
 *
 * Creates an AES cipher object to decrypt data using the given symmetric key.
 * The output will be stored in the 'output' member of the returned cipher.
 *
 * The key and iv may be given as a string of bytes, an array of bytes,
 * a byte buffer, or an array of 32-bit words.
 *
 * @param key the symmetric key to use.
 * @param iv the initialization vector to use.
 * @param output the buffer to write to, null to create one.
 * @param mode the cipher mode to use (default: 'CBC').
 *
 * @return the cipher.
 */ $fz7FM.aes.startDecrypting = function(key, iv, output, mode) {
    var cipher = $45f77c72b66ff073$var$_createCipher({
        key: key,
        output: output,
        decrypt: true,
        mode: mode
    });
    cipher.start(iv);
    return cipher;
};
/**
 * Deprecated. Instead, use:
 *
 * var decipher = forge.cipher.createDecipher('AES-<mode>', key);
 *
 * Creates an AES cipher object to decrypt data using the given symmetric key.
 *
 * The key may be given as a string of bytes, an array of bytes, a
 * byte buffer, or an array of 32-bit words.
 *
 * @param key the symmetric key to use.
 * @param mode the cipher mode to use (default: 'CBC').
 *
 * @return the cipher.
 */ $fz7FM.aes.createDecryptionCipher = function(key, mode) {
    return $45f77c72b66ff073$var$_createCipher({
        key: key,
        output: null,
        decrypt: true,
        mode: mode
    });
};
/**
 * Creates a new AES cipher algorithm object.
 *
 * @param name the name of the algorithm.
 * @param mode the mode factory function.
 *
 * @return the AES algorithm object.
 */ $fz7FM.aes.Algorithm = function(name, mode) {
    if (!$45f77c72b66ff073$var$init) $45f77c72b66ff073$var$initialize();
    var self = this;
    self.name = name;
    self.mode = new mode({
        blockSize: 16,
        cipher: {
            encrypt: function encrypt(inBlock, outBlock) {
                return $45f77c72b66ff073$var$_updateBlock(self._w, inBlock, outBlock, false);
            },
            decrypt: function decrypt(inBlock, outBlock) {
                return $45f77c72b66ff073$var$_updateBlock(self._w, inBlock, outBlock, true);
            }
        }
    });
    self._init = false;
};
/**
 * Initializes this AES algorithm by expanding its key.
 *
 * @param options the options to use.
 *          key the key to use with this algorithm.
 *          decrypt true if the algorithm should be initialized for decryption,
 *            false for encryption.
 */ $fz7FM.aes.Algorithm.prototype.initialize = function(options) {
    if (this._init) return;
    var key = options.key;
    var tmp;
    /* Note: The key may be a string of bytes, an array of bytes, a byte
    buffer, or an array of 32-bit integers. If the key is in bytes, then
    it must be 16, 24, or 32 bytes in length. If it is in 32-bit
    integers, it must be 4, 6, or 8 integers long. */ if (typeof key === "string" && (key.length === 16 || key.length === 24 || key.length === 32)) // convert key string into byte buffer
    key = $fz7FM.util.createBuffer(key);
    else if ($fz7FM.util.isArray(key) && (key.length === 16 || key.length === 24 || key.length === 32)) {
        // convert key integer array into byte buffer
        tmp = key;
        key = $fz7FM.util.createBuffer();
        for(var i = 0; i < tmp.length; ++i)key.putByte(tmp[i]);
    }
    // convert key byte buffer into 32-bit integer array
    if (!$fz7FM.util.isArray(key)) {
        tmp = key;
        key = [];
        // key lengths of 16, 24, 32 bytes allowed
        var len = tmp.length();
        if (len === 16 || len === 24 || len === 32) {
            len = len >>> 2;
            for(var i = 0; i < len; ++i)key.push(tmp.getInt32());
        }
    }
    // key must be an array of 32-bit integers by now
    if (!$fz7FM.util.isArray(key) || !(key.length === 4 || key.length === 6 || key.length === 8)) throw new Error("Invalid key parameter.");
    // encryption operation is always used for these modes
    var mode = this.mode.name;
    var encryptOp = [
        "CFB",
        "OFB",
        "CTR",
        "GCM"
    ].indexOf(mode) !== -1;
    // do key expansion
    this._w = $45f77c72b66ff073$var$_expandKey(key, options.decrypt && !encryptOp);
    this._init = true;
};
/**
 * Expands a key. Typically only used for testing.
 *
 * @param key the symmetric key to expand, as an array of 32-bit words.
 * @param decrypt true to expand for decryption, false for encryption.
 *
 * @return the expanded key.
 */ $fz7FM.aes._expandKey = function(key, decrypt) {
    if (!$45f77c72b66ff073$var$init) $45f77c72b66ff073$var$initialize();
    return $45f77c72b66ff073$var$_expandKey(key, decrypt);
};
/**
 * Updates a single block. Typically only used for testing.
 *
 * @param w the expanded key to use.
 * @param input an array of block-size 32-bit words.
 * @param output an array of block-size 32-bit words.
 * @param decrypt true to decrypt, false to encrypt.
 */ $fz7FM.aes._updateBlock = $45f77c72b66ff073$var$_updateBlock;
/** Register AES algorithms **/ $45f77c72b66ff073$var$registerAlgorithm("AES-ECB", $fz7FM.cipher.modes.ecb);
$45f77c72b66ff073$var$registerAlgorithm("AES-CBC", $fz7FM.cipher.modes.cbc);
$45f77c72b66ff073$var$registerAlgorithm("AES-CFB", $fz7FM.cipher.modes.cfb);
$45f77c72b66ff073$var$registerAlgorithm("AES-OFB", $fz7FM.cipher.modes.ofb);
$45f77c72b66ff073$var$registerAlgorithm("AES-CTR", $fz7FM.cipher.modes.ctr);
$45f77c72b66ff073$var$registerAlgorithm("AES-GCM", $fz7FM.cipher.modes.gcm);
function $45f77c72b66ff073$var$registerAlgorithm(name, mode) {
    var factory = function factory() {
        return new $fz7FM.aes.Algorithm(name, mode);
    };
    $fz7FM.cipher.registerAlgorithm(name, factory);
}
/** AES implementation **/ var $45f77c72b66ff073$var$init = false; // not yet initialized
var $45f77c72b66ff073$var$Nb = 4; // number of words comprising the state (AES = 4)
var $45f77c72b66ff073$var$sbox; // non-linear substitution table used in key expansion
var $45f77c72b66ff073$var$isbox; // inversion of sbox
var $45f77c72b66ff073$var$rcon; // round constant word array
var $45f77c72b66ff073$var$mix; // mix-columns table
var $45f77c72b66ff073$var$imix; // inverse mix-columns table
/**
 * Performs initialization, ie: precomputes tables to optimize for speed.
 *
 * One way to understand how AES works is to imagine that 'addition' and
 * 'multiplication' are interfaces that require certain mathematical
 * properties to hold true (ie: they are associative) but they might have
 * different implementations and produce different kinds of results ...
 * provided that their mathematical properties remain true. AES defines
 * its own methods of addition and multiplication but keeps some important
 * properties the same, ie: associativity and distributivity. The
 * explanation below tries to shed some light on how AES defines addition
 * and multiplication of bytes and 32-bit words in order to perform its
 * encryption and decryption algorithms.
 *
 * The basics:
 *
 * The AES algorithm views bytes as binary representations of polynomials
 * that have either 1 or 0 as the coefficients. It defines the addition
 * or subtraction of two bytes as the XOR operation. It also defines the
 * multiplication of two bytes as a finite field referred to as GF(2^8)
 * (Note: 'GF' means "Galois Field" which is a field that contains a finite
 * number of elements so GF(2^8) has 256 elements).
 *
 * This means that any two bytes can be represented as binary polynomials;
 * when they multiplied together and modularly reduced by an irreducible
 * polynomial of the 8th degree, the results are the field GF(2^8). The
 * specific irreducible polynomial that AES uses in hexadecimal is 0x11b.
 * This multiplication is associative with 0x01 as the identity:
 *
 * (b * 0x01 = GF(b, 0x01) = b).
 *
 * The operation GF(b, 0x02) can be performed at the byte level by left
 * shifting b once and then XOR'ing it (to perform the modular reduction)
 * with 0x11b if b is >= 128. Repeated application of the multiplication
 * of 0x02 can be used to implement the multiplication of any two bytes.
 *
 * For instance, multiplying 0x57 and 0x13, denoted as GF(0x57, 0x13), can
 * be performed by factoring 0x13 into 0x01, 0x02, and 0x10. Then these
 * factors can each be multiplied by 0x57 and then added together. To do
 * the multiplication, values for 0x57 multiplied by each of these 3 factors
 * can be precomputed and stored in a table. To add them, the values from
 * the table are XOR'd together.
 *
 * AES also defines addition and multiplication of words, that is 4-byte
 * numbers represented as polynomials of 3 degrees where the coefficients
 * are the values of the bytes.
 *
 * The word [a0, a1, a2, a3] is a polynomial a3x^3 + a2x^2 + a1x + a0.
 *
 * Addition is performed by XOR'ing like powers of x. Multiplication
 * is performed in two steps, the first is an algebriac expansion as
 * you would do normally (where addition is XOR). But the result is
 * a polynomial larger than 3 degrees and thus it cannot fit in a word. So
 * next the result is modularly reduced by an AES-specific polynomial of
 * degree 4 which will always produce a polynomial of less than 4 degrees
 * such that it will fit in a word. In AES, this polynomial is x^4 + 1.
 *
 * The modular product of two polynomials 'a' and 'b' is thus:
 *
 * d(x) = d3x^3 + d2x^2 + d1x + d0
 * with
 * d0 = GF(a0, b0) ^ GF(a3, b1) ^ GF(a2, b2) ^ GF(a1, b3)
 * d1 = GF(a1, b0) ^ GF(a0, b1) ^ GF(a3, b2) ^ GF(a2, b3)
 * d2 = GF(a2, b0) ^ GF(a1, b1) ^ GF(a0, b2) ^ GF(a3, b3)
 * d3 = GF(a3, b0) ^ GF(a2, b1) ^ GF(a1, b2) ^ GF(a0, b3)
 *
 * As a matrix:
 *
 * [d0] = [a0 a3 a2 a1][b0]
 * [d1]   [a1 a0 a3 a2][b1]
 * [d2]   [a2 a1 a0 a3][b2]
 * [d3]   [a3 a2 a1 a0][b3]
 *
 * Special polynomials defined by AES (0x02 == {02}):
 * a(x)    = {03}x^3 + {01}x^2 + {01}x + {02}
 * a^-1(x) = {0b}x^3 + {0d}x^2 + {09}x + {0e}.
 *
 * These polynomials are used in the MixColumns() and InverseMixColumns()
 * operations, respectively, to cause each element in the state to affect
 * the output (referred to as diffusing).
 *
 * RotWord() uses: a0 = a1 = a2 = {00} and a3 = {01}, which is the
 * polynomial x3.
 *
 * The ShiftRows() method modifies the last 3 rows in the state (where
 * the state is 4 words with 4 bytes per word) by shifting bytes cyclically.
 * The 1st byte in the second row is moved to the end of the row. The 1st
 * and 2nd bytes in the third row are moved to the end of the row. The 1st,
 * 2nd, and 3rd bytes are moved in the fourth row.
 *
 * More details on how AES arithmetic works:
 *
 * In the polynomial representation of binary numbers, XOR performs addition
 * and subtraction and multiplication in GF(2^8) denoted as GF(a, b)
 * corresponds with the multiplication of polynomials modulo an irreducible
 * polynomial of degree 8. In other words, for AES, GF(a, b) will multiply
 * polynomial 'a' with polynomial 'b' and then do a modular reduction by
 * an AES-specific irreducible polynomial of degree 8.
 *
 * A polynomial is irreducible if its only divisors are one and itself. For
 * the AES algorithm, this irreducible polynomial is:
 *
 * m(x) = x^8 + x^4 + x^3 + x + 1,
 *
 * or {01}{1b} in hexadecimal notation, where each coefficient is a bit:
 * 100011011 = 283 = 0x11b.
 *
 * For example, GF(0x57, 0x83) = 0xc1 because
 *
 * 0x57 = 87  = 01010111 = x^6 + x^4 + x^2 + x + 1
 * 0x85 = 131 = 10000101 = x^7 + x + 1
 *
 * (x^6 + x^4 + x^2 + x + 1) * (x^7 + x + 1)
 * =  x^13 + x^11 + x^9 + x^8 + x^7 +
 *    x^7 + x^5 + x^3 + x^2 + x +
 *    x^6 + x^4 + x^2 + x + 1
 * =  x^13 + x^11 + x^9 + x^8 + x^6 + x^5 + x^4 + x^3 + 1 = y
 *    y modulo (x^8 + x^4 + x^3 + x + 1)
 * =  x^7 + x^6 + 1.
 *
 * The modular reduction by m(x) guarantees the result will be a binary
 * polynomial of less than degree 8, so that it can fit in a byte.
 *
 * The operation to multiply a binary polynomial b with x (the polynomial
 * x in binary representation is 00000010) is:
 *
 * b_7x^8 + b_6x^7 + b_5x^6 + b_4x^5 + b_3x^4 + b_2x^3 + b_1x^2 + b_0x^1
 *
 * To get GF(b, x) we must reduce that by m(x). If b_7 is 0 (that is the
 * most significant bit is 0 in b) then the result is already reduced. If
 * it is 1, then we can reduce it by subtracting m(x) via an XOR.
 *
 * It follows that multiplication by x (00000010 or 0x02) can be implemented
 * by performing a left shift followed by a conditional bitwise XOR with
 * 0x1b. This operation on bytes is denoted by xtime(). Multiplication by
 * higher powers of x can be implemented by repeated application of xtime().
 *
 * By adding intermediate results, multiplication by any constant can be
 * implemented. For instance:
 *
 * GF(0x57, 0x13) = 0xfe because:
 *
 * xtime(b) = (b & 128) ? (b << 1 ^ 0x11b) : (b << 1)
 *
 * Note: We XOR with 0x11b instead of 0x1b because in javascript our
 * datatype for b can be larger than 1 byte, so a left shift will not
 * automatically eliminate bits that overflow a byte ... by XOR'ing the
 * overflow bit with 1 (the extra one from 0x11b) we zero it out.
 *
 * GF(0x57, 0x02) = xtime(0x57) = 0xae
 * GF(0x57, 0x04) = xtime(0xae) = 0x47
 * GF(0x57, 0x08) = xtime(0x47) = 0x8e
 * GF(0x57, 0x10) = xtime(0x8e) = 0x07
 *
 * GF(0x57, 0x13) = GF(0x57, (0x01 ^ 0x02 ^ 0x10))
 *
 * And by the distributive property (since XOR is addition and GF() is
 * multiplication):
 *
 * = GF(0x57, 0x01) ^ GF(0x57, 0x02) ^ GF(0x57, 0x10)
 * = 0x57 ^ 0xae ^ 0x07
 * = 0xfe.
 */ function $45f77c72b66ff073$var$initialize() {
    $45f77c72b66ff073$var$init = true;
    /* Populate the Rcon table. These are the values given by
    [x^(i-1),{00},{00},{00}] where x^(i-1) are powers of x (and x = 0x02)
    in the field of GF(2^8), where i starts at 1.

    rcon[0] = [0x00, 0x00, 0x00, 0x00]
    rcon[1] = [0x01, 0x00, 0x00, 0x00] 2^(1-1) = 2^0 = 1
    rcon[2] = [0x02, 0x00, 0x00, 0x00] 2^(2-1) = 2^1 = 2
    ...
    rcon[9]  = [0x1B, 0x00, 0x00, 0x00] 2^(9-1)  = 2^8 = 0x1B
    rcon[10] = [0x36, 0x00, 0x00, 0x00] 2^(10-1) = 2^9 = 0x36

    We only store the first byte because it is the only one used.
  */ $45f77c72b66ff073$var$rcon = [
        0x00,
        0x01,
        0x02,
        0x04,
        0x08,
        0x10,
        0x20,
        0x40,
        0x80,
        0x1B,
        0x36
    ];
    // compute xtime table which maps i onto GF(i, 0x02)
    var xtime = new Array(256);
    for(var i = 0; i < 128; ++i){
        xtime[i] = i << 1;
        xtime[i + 128] = i + 128 << 1 ^ 0x11B;
    }
    // compute all other tables
    $45f77c72b66ff073$var$sbox = new Array(256);
    $45f77c72b66ff073$var$isbox = new Array(256);
    $45f77c72b66ff073$var$mix = new Array(4);
    $45f77c72b66ff073$var$imix = new Array(4);
    for(var i = 0; i < 4; ++i){
        $45f77c72b66ff073$var$mix[i] = new Array(256);
        $45f77c72b66ff073$var$imix[i] = new Array(256);
    }
    var e = 0, ei = 0, e2, e4, e8, sx, sx2, me, ime;
    for(var i = 0; i < 256; ++i){
        /* We need to generate the SubBytes() sbox and isbox tables so that
      we can perform byte substitutions. This requires us to traverse
      all of the elements in GF, find their multiplicative inverses,
      and apply to each the following affine transformation:

      bi' = bi ^ b(i + 4) mod 8 ^ b(i + 5) mod 8 ^ b(i + 6) mod 8 ^
            b(i + 7) mod 8 ^ ci
      for 0 <= i < 8, where bi is the ith bit of the byte, and ci is the
      ith bit of a byte c with the value {63} or {01100011}.

      It is possible to traverse every possible value in a Galois field
      using what is referred to as a 'generator'. There are many
      generators (128 out of 256): 3,5,6,9,11,82 to name a few. To fully
      traverse GF we iterate 255 times, multiplying by our generator
      each time.

      On each iteration we can determine the multiplicative inverse for
      the current element.

      Suppose there is an element in GF 'e'. For a given generator 'g',
      e = g^x. The multiplicative inverse of e is g^(255 - x). It turns
      out that if use the inverse of a generator as another generator
      it will produce all of the corresponding multiplicative inverses
      at the same time. For this reason, we choose 5 as our inverse
      generator because it only requires 2 multiplies and 1 add and its
      inverse, 82, requires relatively few operations as well.

      In order to apply the affine transformation, the multiplicative
      inverse 'ei' of 'e' can be repeatedly XOR'd (4 times) with a
      bit-cycling of 'ei'. To do this 'ei' is first stored in 's' and
      'x'. Then 's' is left shifted and the high bit of 's' is made the
      low bit. The resulting value is stored in 's'. Then 'x' is XOR'd
      with 's' and stored in 'x'. On each subsequent iteration the same
      operation is performed. When 4 iterations are complete, 'x' is
      XOR'd with 'c' (0x63) and the transformed value is stored in 'x'.
      For example:

      s = 01000001
      x = 01000001

      iteration 1: s = 10000010, x ^= s
      iteration 2: s = 00000101, x ^= s
      iteration 3: s = 00001010, x ^= s
      iteration 4: s = 00010100, x ^= s
      x ^= 0x63

      This can be done with a loop where s = (s << 1) | (s >> 7). However,
      it can also be done by using a single 16-bit (in this case 32-bit)
      number 'sx'. Since XOR is an associative operation, we can set 'sx'
      to 'ei' and then XOR it with 'sx' left-shifted 1,2,3, and 4 times.
      The most significant bits will flow into the high 8 bit positions
      and be correctly XOR'd with one another. All that remains will be
      to cycle the high 8 bits by XOR'ing them all with the lower 8 bits
      afterwards.

      At the same time we're populating sbox and isbox we can precompute
      the multiplication we'll need to do to do MixColumns() later.
    */ // apply affine transformation
        sx = ei ^ ei << 1 ^ ei << 2 ^ ei << 3 ^ ei << 4;
        sx = sx >> 8 ^ sx & 255 ^ 0x63;
        // update tables
        $45f77c72b66ff073$var$sbox[e] = sx;
        $45f77c72b66ff073$var$isbox[sx] = e;
        /* Mixing columns is done using matrix multiplication. The columns
      that are to be mixed are each a single word in the current state.
      The state has Nb columns (4 columns). Therefore each column is a
      4 byte word. So to mix the columns in a single column 'c' where
      its rows are r0, r1, r2, and r3, we use the following matrix
      multiplication:

      [2 3 1 1]*[r0,c]=[r'0,c]
      [1 2 3 1] [r1,c] [r'1,c]
      [1 1 2 3] [r2,c] [r'2,c]
      [3 1 1 2] [r3,c] [r'3,c]

      r0, r1, r2, and r3 are each 1 byte of one of the words in the
      state (a column). To do matrix multiplication for each mixed
      column c' we multiply the corresponding row from the left matrix
      with the corresponding column from the right matrix. In total, we
      get 4 equations:

      r0,c' = 2*r0,c + 3*r1,c + 1*r2,c + 1*r3,c
      r1,c' = 1*r0,c + 2*r1,c + 3*r2,c + 1*r3,c
      r2,c' = 1*r0,c + 1*r1,c + 2*r2,c + 3*r3,c
      r3,c' = 3*r0,c + 1*r1,c + 1*r2,c + 2*r3,c

      As usual, the multiplication is as previously defined and the
      addition is XOR. In order to optimize mixing columns we can store
      the multiplication results in tables. If you think of the whole
      column as a word (it might help to visualize by mentally rotating
      the equations above by counterclockwise 90 degrees) then you can
      see that it would be useful to map the multiplications performed on
      each byte (r0, r1, r2, r3) onto a word as well. For instance, we
      could map 2*r0,1*r0,1*r0,3*r0 onto a word by storing 2*r0 in the
      highest 8 bits and 3*r0 in the lowest 8 bits (with the other two
      respectively in the middle). This means that a table can be
      constructed that uses r0 as an index to the word. We can do the
      same with r1, r2, and r3, creating a total of 4 tables.

      To construct a full c', we can just look up each byte of c in
      their respective tables and XOR the results together.

      Also, to build each table we only have to calculate the word
      for 2,1,1,3 for every byte ... which we can do on each iteration
      of this loop since we will iterate over every byte. After we have
      calculated 2,1,1,3 we can get the results for the other tables
      by cycling the byte at the end to the beginning. For instance
      we can take the result of table 2,1,1,3 and produce table 3,2,1,1
      by moving the right most byte to the left most position just like
      how you can imagine the 3 moved out of 2,1,1,3 and to the front
      to produce 3,2,1,1.

      There is another optimization in that the same multiples of
      the current element we need in order to advance our generator
      to the next iteration can be reused in performing the 2,1,1,3
      calculation. We also calculate the inverse mix column tables,
      with e,9,d,b being the inverse of 2,1,1,3.

      When we're done, and we need to actually mix columns, the first
      byte of each state word should be put through mix[0] (2,1,1,3),
      the second through mix[1] (3,2,1,1) and so forth. Then they should
      be XOR'd together to produce the fully mixed column.
    */ // calculate mix and imix table values
        sx2 = xtime[sx];
        e2 = xtime[e];
        e4 = xtime[e2];
        e8 = xtime[e4];
        me = sx2 << 24 ^ // 2
        sx << 16 ^ // 1
        sx << 8 ^ // 1
        (sx ^ sx2); // 3
        ime = (e2 ^ e4 ^ e8) << 24 ^ // E (14)
        (e ^ e8) << 16 ^ // 9
        (e ^ e4 ^ e8) << 8 ^ // D (13)
        (e ^ e2 ^ e8); // B (11)
        // produce each of the mix tables by rotating the 2,1,1,3 value
        for(var n = 0; n < 4; ++n){
            $45f77c72b66ff073$var$mix[n][e] = me;
            $45f77c72b66ff073$var$imix[n][sx] = ime;
            // cycle the right most byte to the left most position
            // ie: 2,1,1,3 becomes 3,2,1,1
            me = me << 24 | me >>> 8;
            ime = ime << 24 | ime >>> 8;
        }
        // get next element and inverse
        if (e === 0) // 1 is the inverse of 1
        e = ei = 1;
        else {
            // e = 2e + 2*2*2*(10e)) = multiply e by 82 (chosen generator)
            // ei = ei + 2*2*ei = multiply ei by 5 (inverse generator)
            e = e2 ^ xtime[xtime[xtime[e2 ^ e8]]];
            ei ^= xtime[xtime[ei]];
        }
    }
}
/**
 * Generates a key schedule using the AES key expansion algorithm.
 *
 * The AES algorithm takes the Cipher Key, K, and performs a Key Expansion
 * routine to generate a key schedule. The Key Expansion generates a total
 * of Nb*(Nr + 1) words: the algorithm requires an initial set of Nb words,
 * and each of the Nr rounds requires Nb words of key data. The resulting
 * key schedule consists of a linear array of 4-byte words, denoted [wi ],
 * with i in the range 0 <= i < Nb(Nr + 1).
 *
 * KeyExpansion(byte key[4*Nk], word w[Nb*(Nr+1)], Nk)
 * AES-128 (Nb=4, Nk=4, Nr=10)
 * AES-192 (Nb=4, Nk=6, Nr=12)
 * AES-256 (Nb=4, Nk=8, Nr=14)
 * Note: Nr=Nk+6.
 *
 * Nb is the number of columns (32-bit words) comprising the State (or
 * number of bytes in a block). For AES, Nb=4.
 *
 * @param key the key to schedule (as an array of 32-bit words).
 * @param decrypt true to modify the key schedule to decrypt, false not to.
 *
 * @return the generated key schedule.
 */ function $45f77c72b66ff073$var$_expandKey(key, decrypt) {
    // copy the key's words to initialize the key schedule
    var w = key.slice(0);
    /* RotWord() will rotate a word, moving the first byte to the last
    byte's position (shifting the other bytes left).

    We will be getting the value of Rcon at i / Nk. 'i' will iterate
    from Nk to (Nb * Nr+1). Nk = 4 (4 byte key), Nb = 4 (4 words in
    a block), Nr = Nk + 6 (10). Therefore 'i' will iterate from
    4 to 44 (exclusive). Each time we iterate 4 times, i / Nk will
    increase by 1. We use a counter iNk to keep track of this.
   */ // go through the rounds expanding the key
    var temp, iNk = 1;
    var Nk = w.length;
    var Nr1 = Nk + 6 + 1;
    var end = $45f77c72b66ff073$var$Nb * Nr1;
    for(var i = Nk; i < end; ++i){
        temp = w[i - 1];
        if (i % Nk === 0) {
            // temp = SubWord(RotWord(temp)) ^ Rcon[i / Nk]
            temp = $45f77c72b66ff073$var$sbox[temp >>> 16 & 255] << 24 ^ $45f77c72b66ff073$var$sbox[temp >>> 8 & 255] << 16 ^ $45f77c72b66ff073$var$sbox[temp & 255] << 8 ^ $45f77c72b66ff073$var$sbox[temp >>> 24] ^ $45f77c72b66ff073$var$rcon[iNk] << 24;
            iNk++;
        } else if (Nk > 6 && i % Nk === 4) // temp = SubWord(temp)
        temp = $45f77c72b66ff073$var$sbox[temp >>> 24] << 24 ^ $45f77c72b66ff073$var$sbox[temp >>> 16 & 255] << 16 ^ $45f77c72b66ff073$var$sbox[temp >>> 8 & 255] << 8 ^ $45f77c72b66ff073$var$sbox[temp & 255];
        w[i] = w[i - Nk] ^ temp;
    }
    /* When we are updating a cipher block we always use the code path for
     encryption whether we are decrypting or not (to shorten code and
     simplify the generation of look up tables). However, because there
     are differences in the decryption algorithm, other than just swapping
     in different look up tables, we must transform our key schedule to
     account for these changes:

     1. The decryption algorithm gets its key rounds in reverse order.
     2. The decryption algorithm adds the round key before mixing columns
       instead of afterwards.

     We don't need to modify our key schedule to handle the first case,
     we can just traverse the key schedule in reverse order when decrypting.

     The second case requires a little work.

     The tables we built for performing rounds will take an input and then
     perform SubBytes() and MixColumns() or, for the decrypt version,
     InvSubBytes() and InvMixColumns(). But the decrypt algorithm requires
     us to AddRoundKey() before InvMixColumns(). This means we'll need to
     apply some transformations to the round key to inverse-mix its columns
     so they'll be correct for moving AddRoundKey() to after the state has
     had its columns inverse-mixed.

     To inverse-mix the columns of the state when we're decrypting we use a
     lookup table that will apply InvSubBytes() and InvMixColumns() at the
     same time. However, the round key's bytes are not inverse-substituted
     in the decryption algorithm. To get around this problem, we can first
     substitute the bytes in the round key so that when we apply the
     transformation via the InvSubBytes()+InvMixColumns() table, it will
     undo our substitution leaving us with the original value that we
     want -- and then inverse-mix that value.

     This change will correctly alter our key schedule so that we can XOR
     each round key with our already transformed decryption state. This
     allows us to use the same code path as the encryption algorithm.

     We make one more change to the decryption key. Since the decryption
     algorithm runs in reverse from the encryption algorithm, we reverse
     the order of the round keys to avoid having to iterate over the key
     schedule backwards when running the encryption algorithm later in
     decryption mode. In addition to reversing the order of the round keys,
     we also swap each round key's 2nd and 4th rows. See the comments
     section where rounds are performed for more details about why this is
     done. These changes are done inline with the other substitution
     described above.
  */ if (decrypt) {
        var tmp;
        var m0 = $45f77c72b66ff073$var$imix[0];
        var m1 = $45f77c72b66ff073$var$imix[1];
        var m2 = $45f77c72b66ff073$var$imix[2];
        var m3 = $45f77c72b66ff073$var$imix[3];
        var wnew = w.slice(0);
        end = w.length;
        for(var i = 0, wi = end - $45f77c72b66ff073$var$Nb; i < end; i += $45f77c72b66ff073$var$Nb, wi -= $45f77c72b66ff073$var$Nb){
            // do not sub the first or last round key (round keys are Nb
            // words) as no column mixing is performed before they are added,
            // but do change the key order
            if (i === 0 || i === end - $45f77c72b66ff073$var$Nb) {
                wnew[i] = w[wi];
                wnew[i + 1] = w[wi + 3];
                wnew[i + 2] = w[wi + 2];
                wnew[i + 3] = w[wi + 1];
            } else // substitute each round key byte because the inverse-mix
            // table will inverse-substitute it (effectively cancel the
            // substitution because round key bytes aren't sub'd in
            // decryption mode) and swap indexes 3 and 1
            for(var n = 0; n < $45f77c72b66ff073$var$Nb; ++n){
                tmp = w[wi + n];
                wnew[i + (3 & -n)] = m0[$45f77c72b66ff073$var$sbox[tmp >>> 24]] ^ m1[$45f77c72b66ff073$var$sbox[tmp >>> 16 & 255]] ^ m2[$45f77c72b66ff073$var$sbox[tmp >>> 8 & 255]] ^ m3[$45f77c72b66ff073$var$sbox[tmp & 255]];
            }
        }
        w = wnew;
    }
    return w;
}
/**
 * Updates a single block (16 bytes) using AES. The update will either
 * encrypt or decrypt the block.
 *
 * @param w the key schedule.
 * @param input the input block (an array of 32-bit words).
 * @param output the updated output block.
 * @param decrypt true to decrypt the block, false to encrypt it.
 */ function $45f77c72b66ff073$var$_updateBlock(w, input, output, decrypt) {
    /*
  Cipher(byte in[4*Nb], byte out[4*Nb], word w[Nb*(Nr+1)])
  begin
    byte state[4,Nb]
    state = in
    AddRoundKey(state, w[0, Nb-1])
    for round = 1 step 1 to Nr-1
      SubBytes(state)
      ShiftRows(state)
      MixColumns(state)
      AddRoundKey(state, w[round*Nb, (round+1)*Nb-1])
    end for
    SubBytes(state)
    ShiftRows(state)
    AddRoundKey(state, w[Nr*Nb, (Nr+1)*Nb-1])
    out = state
  end

  InvCipher(byte in[4*Nb], byte out[4*Nb], word w[Nb*(Nr+1)])
  begin
    byte state[4,Nb]
    state = in
    AddRoundKey(state, w[Nr*Nb, (Nr+1)*Nb-1])
    for round = Nr-1 step -1 downto 1
      InvShiftRows(state)
      InvSubBytes(state)
      AddRoundKey(state, w[round*Nb, (round+1)*Nb-1])
      InvMixColumns(state)
    end for
    InvShiftRows(state)
    InvSubBytes(state)
    AddRoundKey(state, w[0, Nb-1])
    out = state
  end
  */ // Encrypt: AddRoundKey(state, w[0, Nb-1])
    // Decrypt: AddRoundKey(state, w[Nr*Nb, (Nr+1)*Nb-1])
    var Nr = w.length / 4 - 1;
    var m0, m1, m2, m3, sub;
    if (decrypt) {
        m0 = $45f77c72b66ff073$var$imix[0];
        m1 = $45f77c72b66ff073$var$imix[1];
        m2 = $45f77c72b66ff073$var$imix[2];
        m3 = $45f77c72b66ff073$var$imix[3];
        sub = $45f77c72b66ff073$var$isbox;
    } else {
        m0 = $45f77c72b66ff073$var$mix[0];
        m1 = $45f77c72b66ff073$var$mix[1];
        m2 = $45f77c72b66ff073$var$mix[2];
        m3 = $45f77c72b66ff073$var$mix[3];
        sub = $45f77c72b66ff073$var$sbox;
    }
    var a, b, c, d, a2, b2, c2;
    a = input[0] ^ w[0];
    b = input[decrypt ? 3 : 1] ^ w[1];
    c = input[2] ^ w[2];
    d = input[decrypt ? 1 : 3] ^ w[3];
    var i = 3;
    /* In order to share code we follow the encryption algorithm when both
    encrypting and decrypting. To account for the changes required in the
    decryption algorithm, we use different lookup tables when decrypting
    and use a modified key schedule to account for the difference in the
    order of transformations applied when performing rounds. We also get
    key rounds in reverse order (relative to encryption). */ for(var round = 1; round < Nr; ++round){
        /* As described above, we'll be using table lookups to perform the
      column mixing. Each column is stored as a word in the state (the
      array 'input' has one column as a word at each index). In order to
      mix a column, we perform these transformations on each row in c,
      which is 1 byte in each word. The new column for c0 is c'0:

               m0      m1      m2      m3
      r0,c'0 = 2*r0,c0 + 3*r1,c0 + 1*r2,c0 + 1*r3,c0
      r1,c'0 = 1*r0,c0 + 2*r1,c0 + 3*r2,c0 + 1*r3,c0
      r2,c'0 = 1*r0,c0 + 1*r1,c0 + 2*r2,c0 + 3*r3,c0
      r3,c'0 = 3*r0,c0 + 1*r1,c0 + 1*r2,c0 + 2*r3,c0

      So using mix tables where c0 is a word with r0 being its upper
      8 bits and r3 being its lower 8 bits:

      m0[c0 >> 24] will yield this word: [2*r0,1*r0,1*r0,3*r0]
      ...
      m3[c0 & 255] will yield this word: [1*r3,1*r3,3*r3,2*r3]

      Therefore to mix the columns in each word in the state we
      do the following (& 255 omitted for brevity):
      c'0,r0 = m0[c0 >> 24] ^ m1[c1 >> 16] ^ m2[c2 >> 8] ^ m3[c3]
      c'0,r1 = m0[c0 >> 24] ^ m1[c1 >> 16] ^ m2[c2 >> 8] ^ m3[c3]
      c'0,r2 = m0[c0 >> 24] ^ m1[c1 >> 16] ^ m2[c2 >> 8] ^ m3[c3]
      c'0,r3 = m0[c0 >> 24] ^ m1[c1 >> 16] ^ m2[c2 >> 8] ^ m3[c3]

      However, before mixing, the algorithm requires us to perform
      ShiftRows(). The ShiftRows() transformation cyclically shifts the
      last 3 rows of the state over different offsets. The first row
      (r = 0) is not shifted.

      s'_r,c = s_r,(c + shift(r, Nb) mod Nb
      for 0 < r < 4 and 0 <= c < Nb and
      shift(1, 4) = 1
      shift(2, 4) = 2
      shift(3, 4) = 3.

      This causes the first byte in r = 1 to be moved to the end of
      the row, the first 2 bytes in r = 2 to be moved to the end of
      the row, the first 3 bytes in r = 3 to be moved to the end of
      the row:

      r1: [c0 c1 c2 c3] => [c1 c2 c3 c0]
      r2: [c0 c1 c2 c3]    [c2 c3 c0 c1]
      r3: [c0 c1 c2 c3]    [c3 c0 c1 c2]

      We can make these substitutions inline with our column mixing to
      generate an updated set of equations to produce each word in the
      state (note the columns have changed positions):

      c0 c1 c2 c3 => c0 c1 c2 c3
      c0 c1 c2 c3    c1 c2 c3 c0  (cycled 1 byte)
      c0 c1 c2 c3    c2 c3 c0 c1  (cycled 2 bytes)
      c0 c1 c2 c3    c3 c0 c1 c2  (cycled 3 bytes)

      Therefore:

      c'0 = 2*r0,c0 + 3*r1,c1 + 1*r2,c2 + 1*r3,c3
      c'0 = 1*r0,c0 + 2*r1,c1 + 3*r2,c2 + 1*r3,c3
      c'0 = 1*r0,c0 + 1*r1,c1 + 2*r2,c2 + 3*r3,c3
      c'0 = 3*r0,c0 + 1*r1,c1 + 1*r2,c2 + 2*r3,c3

      c'1 = 2*r0,c1 + 3*r1,c2 + 1*r2,c3 + 1*r3,c0
      c'1 = 1*r0,c1 + 2*r1,c2 + 3*r2,c3 + 1*r3,c0
      c'1 = 1*r0,c1 + 1*r1,c2 + 2*r2,c3 + 3*r3,c0
      c'1 = 3*r0,c1 + 1*r1,c2 + 1*r2,c3 + 2*r3,c0

      ... and so forth for c'2 and c'3. The important distinction is
      that the columns are cycling, with c0 being used with the m0
      map when calculating c0, but c1 being used with the m0 map when
      calculating c1 ... and so forth.

      When performing the inverse we transform the mirror image and
      skip the bottom row, instead of the top one, and move upwards:

      c3 c2 c1 c0 => c0 c3 c2 c1  (cycled 3 bytes) *same as encryption
      c3 c2 c1 c0    c1 c0 c3 c2  (cycled 2 bytes)
      c3 c2 c1 c0    c2 c1 c0 c3  (cycled 1 byte)  *same as encryption
      c3 c2 c1 c0    c3 c2 c1 c0

      If you compare the resulting matrices for ShiftRows()+MixColumns()
      and for InvShiftRows()+InvMixColumns() the 2nd and 4th columns are
      different (in encrypt mode vs. decrypt mode). So in order to use
      the same code to handle both encryption and decryption, we will
      need to do some mapping.

      If in encryption mode we let a=c0, b=c1, c=c2, d=c3, and r<N> be
      a row number in the state, then the resulting matrix in encryption
      mode for applying the above transformations would be:

      r1: a b c d
      r2: b c d a
      r3: c d a b
      r4: d a b c

      If we did the same in decryption mode we would get:

      r1: a d c b
      r2: b a d c
      r3: c b a d
      r4: d c b a

      If instead we swap d and b (set b=c3 and d=c1), then we get:

      r1: a b c d
      r2: d a b c
      r3: c d a b
      r4: b c d a

      Now the 1st and 3rd rows are the same as the encryption matrix. All
      we need to do then to make the mapping exactly the same is to swap
      the 2nd and 4th rows when in decryption mode. To do this without
      having to do it on each iteration, we swapped the 2nd and 4th rows
      in the decryption key schedule. We also have to do the swap above
      when we first pull in the input and when we set the final output. */ a2 = m0[a >>> 24] ^ m1[b >>> 16 & 255] ^ m2[c >>> 8 & 255] ^ m3[d & 255] ^ w[++i];
        b2 = m0[b >>> 24] ^ m1[c >>> 16 & 255] ^ m2[d >>> 8 & 255] ^ m3[a & 255] ^ w[++i];
        c2 = m0[c >>> 24] ^ m1[d >>> 16 & 255] ^ m2[a >>> 8 & 255] ^ m3[b & 255] ^ w[++i];
        d = m0[d >>> 24] ^ m1[a >>> 16 & 255] ^ m2[b >>> 8 & 255] ^ m3[c & 255] ^ w[++i];
        a = a2;
        b = b2;
        c = c2;
    }
    /*
    Encrypt:
    SubBytes(state)
    ShiftRows(state)
    AddRoundKey(state, w[Nr*Nb, (Nr+1)*Nb-1])

    Decrypt:
    InvShiftRows(state)
    InvSubBytes(state)
    AddRoundKey(state, w[0, Nb-1])
   */ // Note: rows are shifted inline
    output[0] = sub[a >>> 24] << 24 ^ sub[b >>> 16 & 255] << 16 ^ sub[c >>> 8 & 255] << 8 ^ sub[d & 255] ^ w[++i];
    output[decrypt ? 3 : 1] = sub[b >>> 24] << 24 ^ sub[c >>> 16 & 255] << 16 ^ sub[d >>> 8 & 255] << 8 ^ sub[a & 255] ^ w[++i];
    output[2] = sub[c >>> 24] << 24 ^ sub[d >>> 16 & 255] << 16 ^ sub[a >>> 8 & 255] << 8 ^ sub[b & 255] ^ w[++i];
    output[decrypt ? 1 : 3] = sub[d >>> 24] << 24 ^ sub[a >>> 16 & 255] << 16 ^ sub[b >>> 8 & 255] << 8 ^ sub[c & 255] ^ w[++i];
}
/**
 * Deprecated. Instead, use:
 *
 * forge.cipher.createCipher('AES-<mode>', key);
 * forge.cipher.createDecipher('AES-<mode>', key);
 *
 * Creates a deprecated AES cipher object. This object's mode will default to
 * CBC (cipher-block-chaining).
 *
 * The key and iv may be given as a string of bytes, an array of bytes, a
 * byte buffer, or an array of 32-bit words.
 *
 * @param options the options to use.
 *          key the symmetric key to use.
 *          output the buffer to write to.
 *          decrypt true for decryption, false for encryption.
 *          mode the cipher mode to use (default: 'CBC').
 *
 * @return the cipher.
 */ function $45f77c72b66ff073$var$_createCipher(options) {
    options = options || {};
    var mode = (options.mode || "CBC").toUpperCase();
    var algorithm = "AES-" + mode;
    var cipher;
    if (options.decrypt) cipher = $fz7FM.cipher.createDecipher(algorithm, options.key);
    else cipher = $fz7FM.cipher.createCipher(algorithm, options.key);
    // backwards compatible start API
    var start = cipher.start;
    cipher.start = function(iv, options) {
        // backwards compatibility: support second arg as output buffer
        var output = null;
        if (options instanceof $fz7FM.util.ByteBuffer) {
            output = options;
            options = {};
        }
        options = options || {};
        options.output = output;
        options.iv = iv;
        start.call(cipher, options);
    };
    return cipher;
}

});
parcelRegister("4Bsm2", function(module, exports) {
/**
 * Cipher base API.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2014 Digital Bazaar, Inc.
 */ 
var $fz7FM = parcelRequire("fz7FM");
parcelRequire("gao36");
module.exports = $fz7FM.cipher = $fz7FM.cipher || {};
// registered algorithms
$fz7FM.cipher.algorithms = $fz7FM.cipher.algorithms || {};
/**
 * Creates a cipher object that can be used to encrypt data using the given
 * algorithm and key. The algorithm may be provided as a string value for a
 * previously registered algorithm or it may be given as a cipher algorithm
 * API object.
 *
 * @param algorithm the algorithm to use, either a string or an algorithm API
 *          object.
 * @param key the key to use, as a binary-encoded string of bytes or a
 *          byte buffer.
 *
 * @return the cipher.
 */ $fz7FM.cipher.createCipher = function(algorithm, key) {
    var api = algorithm;
    if (typeof api === "string") {
        api = $fz7FM.cipher.getAlgorithm(api);
        if (api) api = api();
    }
    if (!api) throw new Error("Unsupported algorithm: " + algorithm);
    // assume block cipher
    return new $fz7FM.cipher.BlockCipher({
        algorithm: api,
        key: key,
        decrypt: false
    });
};
/**
 * Creates a decipher object that can be used to decrypt data using the given
 * algorithm and key. The algorithm may be provided as a string value for a
 * previously registered algorithm or it may be given as a cipher algorithm
 * API object.
 *
 * @param algorithm the algorithm to use, either a string or an algorithm API
 *          object.
 * @param key the key to use, as a binary-encoded string of bytes or a
 *          byte buffer.
 *
 * @return the cipher.
 */ $fz7FM.cipher.createDecipher = function(algorithm, key) {
    var api = algorithm;
    if (typeof api === "string") {
        api = $fz7FM.cipher.getAlgorithm(api);
        if (api) api = api();
    }
    if (!api) throw new Error("Unsupported algorithm: " + algorithm);
    // assume block cipher
    return new $fz7FM.cipher.BlockCipher({
        algorithm: api,
        key: key,
        decrypt: true
    });
};
/**
 * Registers an algorithm by name. If the name was already registered, the
 * algorithm API object will be overwritten.
 *
 * @param name the name of the algorithm.
 * @param algorithm the algorithm API object.
 */ $fz7FM.cipher.registerAlgorithm = function(name, algorithm) {
    name = name.toUpperCase();
    $fz7FM.cipher.algorithms[name] = algorithm;
};
/**
 * Gets a registered algorithm by name.
 *
 * @param name the name of the algorithm.
 *
 * @return the algorithm, if found, null if not.
 */ $fz7FM.cipher.getAlgorithm = function(name) {
    name = name.toUpperCase();
    if (name in $fz7FM.cipher.algorithms) return $fz7FM.cipher.algorithms[name];
    return null;
};
var $35a09cbc3a7f7fb3$var$BlockCipher = $fz7FM.cipher.BlockCipher = function BlockCipher(options) {
    this.algorithm = options.algorithm;
    this.mode = this.algorithm.mode;
    this.blockSize = this.mode.blockSize;
    this._finish = false;
    this._input = null;
    this.output = null;
    this._op = options.decrypt ? this.mode.decrypt : this.mode.encrypt;
    this._decrypt = options.decrypt;
    this.algorithm.initialize(options);
};
/**
 * Starts or restarts the encryption or decryption process, whichever
 * was previously configured.
 *
 * For non-GCM mode, the IV may be a binary-encoded string of bytes, an array
 * of bytes, a byte buffer, or an array of 32-bit integers. If the IV is in
 * bytes, then it must be Nb (16) bytes in length. If the IV is given in as
 * 32-bit integers, then it must be 4 integers long.
 *
 * Note: an IV is not required or used in ECB mode.
 *
 * For GCM-mode, the IV must be given as a binary-encoded string of bytes or
 * a byte buffer. The number of bytes should be 12 (96 bits) as recommended
 * by NIST SP-800-38D but another length may be given.
 *
 * @param options the options to use:
 *          iv the initialization vector to use as a binary-encoded string of
 *            bytes, null to reuse the last ciphered block from a previous
 *            update() (this "residue" method is for legacy support only).
 *          additionalData additional authentication data as a binary-encoded
 *            string of bytes, for 'GCM' mode, (default: none).
 *          tagLength desired length of authentication tag, in bits, for
 *            'GCM' mode (0-128, default: 128).
 *          tag the authentication tag to check if decrypting, as a
 *             binary-encoded string of bytes.
 *          output the output the buffer to write to, null to create one.
 */ $35a09cbc3a7f7fb3$var$BlockCipher.prototype.start = function(options) {
    options = options || {};
    var opts = {};
    for(var key in options)opts[key] = options[key];
    opts.decrypt = this._decrypt;
    this._finish = false;
    this._input = $fz7FM.util.createBuffer();
    this.output = options.output || $fz7FM.util.createBuffer();
    this.mode.start(opts);
};
/**
 * Updates the next block according to the cipher mode.
 *
 * @param input the buffer to read from.
 */ $35a09cbc3a7f7fb3$var$BlockCipher.prototype.update = function(input) {
    if (input) // input given, so empty it into the input buffer
    this._input.putBuffer(input);
    // do cipher operation until it needs more input and not finished
    while(!this._op.call(this.mode, this._input, this.output, this._finish) && !this._finish);
    // free consumed memory from input buffer
    this._input.compact();
};
/**
 * Finishes encrypting or decrypting.
 *
 * @param pad a padding function to use in CBC mode, null for default,
 *          signature(blockSize, buffer, decrypt).
 *
 * @return true if successful, false on error.
 */ $35a09cbc3a7f7fb3$var$BlockCipher.prototype.finish = function(pad) {
    // backwards-compatibility w/deprecated padding API
    // Note: will overwrite padding functions even after another start() call
    if (pad && (this.mode.name === "ECB" || this.mode.name === "CBC")) {
        this.mode.pad = function(input) {
            return pad(this.blockSize, input, false);
        };
        this.mode.unpad = function(output) {
            return pad(this.blockSize, output, true);
        };
    }
    // build options for padding and afterFinish functions
    var options = {};
    options.decrypt = this._decrypt;
    // get # of bytes that won't fill a block
    options.overflow = this._input.length() % this.blockSize;
    if (!this._decrypt && this.mode.pad) {
        if (!this.mode.pad(this._input, options)) return false;
    }
    // do final update
    this._finish = true;
    this.update();
    if (this._decrypt && this.mode.unpad) {
        if (!this.mode.unpad(this.output, options)) return false;
    }
    if (this.mode.afterFinish) {
        if (!this.mode.afterFinish(this.output, options)) return false;
    }
    return true;
};

});
parcelRegister("gao36", function(module, exports) {
/**
 * Utility functions for web applications.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2018 Digital Bazaar, Inc.
 */ 
var $9dH9K = parcelRequire("9dH9K");

var $9dH9K = parcelRequire("9dH9K");
var $bc503c2c69c21e12$require$Buffer = $9dH9K.Buffer;

var $fz7FM = parcelRequire("fz7FM");

var $fu0iC = parcelRequire("fu0iC");
/* Utilities API */ var $bc503c2c69c21e12$var$util = module.exports = $fz7FM.util = $fz7FM.util || {};
// define setImmediate and nextTick
(function() {
    // use native nextTick (unless we're in webpack)
    // webpack (or better node-libs-browser polyfill) sets process.browser.
    // this way we can detect webpack properly
    typeof $9dH9K !== "undefined" && $9dH9K.nextTick;
    // polyfill nextTick with native setImmediate
    if (typeof setImmediate === "function") {
        $bc503c2c69c21e12$var$util.setImmediate = function() {
            return setImmediate.apply(undefined, arguments);
        };
        $bc503c2c69c21e12$var$util.nextTick = function(callback) {
            return setImmediate(callback);
        };
        return;
    }
    /* Note: A polyfill upgrade pattern is used here to allow combining
  polyfills. For example, MutationObserver is fast, but blocks UI updates,
  so it needs to allow UI updates periodically, so it falls back on
  postMessage or setTimeout. */ // polyfill with setTimeout
    $bc503c2c69c21e12$var$util.setImmediate = function(callback) {
        setTimeout(callback, 0);
    };
    // upgrade polyfill to use postMessage
    if (typeof window !== "undefined" && typeof window.postMessage === "function") {
        var msg = "forge.setImmediate";
        var callbacks = [];
        $bc503c2c69c21e12$var$util.setImmediate = function(callback) {
            callbacks.push(callback);
            // only send message when one hasn't been sent in
            // the current turn of the event loop
            if (callbacks.length === 1) window.postMessage(msg, "*");
        };
        function handler(event) {
            if (event.source === window && event.data === msg) {
                event.stopPropagation();
                var copy = callbacks.slice();
                callbacks.length = 0;
                copy.forEach(function(callback) {
                    callback();
                });
            }
        }
        window.addEventListener("message", handler, true);
    }
    // upgrade polyfill to use MutationObserver
    if (typeof MutationObserver !== "undefined") {
        // polyfill with MutationObserver
        var now = Date.now();
        var attr = true;
        var div = document.createElement("div");
        var callbacks = [];
        new MutationObserver(function() {
            var copy = callbacks.slice();
            callbacks.length = 0;
            copy.forEach(function(callback) {
                callback();
            });
        }).observe(div, {
            attributes: true
        });
        var oldSetImmediate = $bc503c2c69c21e12$var$util.setImmediate;
        $bc503c2c69c21e12$var$util.setImmediate = function(callback) {
            if (Date.now() - now > 15) {
                now = Date.now();
                oldSetImmediate(callback);
            } else {
                callbacks.push(callback);
                // only trigger observer when it hasn't been triggered in
                // the current turn of the event loop
                if (callbacks.length === 1) div.setAttribute("a", attr = !attr);
            }
        };
    }
    $bc503c2c69c21e12$var$util.nextTick = $bc503c2c69c21e12$var$util.setImmediate;
})();
// check if running under Node.js
$bc503c2c69c21e12$var$util.isNodejs = typeof $9dH9K !== "undefined" && $9dH9K.versions && $9dH9K.versions.node;
// 'self' will also work in Web Workers (instance of WorkerGlobalScope) while
// it will point to `window` in the main thread.
// To remain compatible with older browsers, we fall back to 'window' if 'self'
// is not available.
$bc503c2c69c21e12$var$util.globalScope = function() {
    if ($bc503c2c69c21e12$var$util.isNodejs) return $parcel$global;
    return typeof self === "undefined" ? window : self;
}();
// define isArray
$bc503c2c69c21e12$var$util.isArray = Array.isArray || function(x) {
    return Object.prototype.toString.call(x) === "[object Array]";
};
// define isArrayBuffer
$bc503c2c69c21e12$var$util.isArrayBuffer = function(x) {
    return typeof ArrayBuffer !== "undefined" && x instanceof ArrayBuffer;
};
// define isArrayBufferView
$bc503c2c69c21e12$var$util.isArrayBufferView = function(x) {
    return x && $bc503c2c69c21e12$var$util.isArrayBuffer(x.buffer) && x.byteLength !== undefined;
};
/**
 * Ensure a bits param is 8, 16, 24, or 32. Used to validate input for
 * algorithms where bit manipulation, JavaScript limitations, and/or algorithm
 * design only allow for byte operations of a limited size.
 *
 * @param n number of bits.
 *
 * Throw Error if n invalid.
 */ function $bc503c2c69c21e12$var$_checkBitsParam(n) {
    if (!(n === 8 || n === 16 || n === 24 || n === 32)) throw new Error("Only 8, 16, 24, or 32 bits supported: " + n);
}
// TODO: set ByteBuffer to best available backing
$bc503c2c69c21e12$var$util.ByteBuffer = $bc503c2c69c21e12$var$ByteStringBuffer;
/** Buffer w/BinaryString backing */ /**
 * Constructor for a binary string backed byte buffer.
 *
 * @param [b] the bytes to wrap (either encoded as string, one byte per
 *          character, or as an ArrayBuffer or Typed Array).
 */ function $bc503c2c69c21e12$var$ByteStringBuffer(b) {
    // TODO: update to match DataBuffer API
    // the data in this buffer
    this.data = "";
    // the pointer for reading from this buffer
    this.read = 0;
    if (typeof b === "string") this.data = b;
    else if ($bc503c2c69c21e12$var$util.isArrayBuffer(b) || $bc503c2c69c21e12$var$util.isArrayBufferView(b)) {
        if (typeof $bc503c2c69c21e12$require$Buffer !== "undefined" && b instanceof $bc503c2c69c21e12$require$Buffer) this.data = b.toString("binary");
        else {
            // convert native buffer to forge buffer
            // FIXME: support native buffers internally instead
            var arr = new Uint8Array(b);
            try {
                this.data = String.fromCharCode.apply(null, arr);
            } catch (e) {
                for(var i = 0; i < arr.length; ++i)this.putByte(arr[i]);
            }
        }
    } else if (b instanceof $bc503c2c69c21e12$var$ByteStringBuffer || typeof b === "object" && typeof b.data === "string" && typeof b.read === "number") {
        // copy existing buffer
        this.data = b.data;
        this.read = b.read;
    }
    // used for v8 optimization
    this._constructedStringLength = 0;
}
$bc503c2c69c21e12$var$util.ByteStringBuffer = $bc503c2c69c21e12$var$ByteStringBuffer;
/* Note: This is an optimization for V8-based browsers. When V8 concatenates
  a string, the strings are only joined logically using a "cons string" or
  "constructed/concatenated string". These containers keep references to one
  another and can result in very large memory usage. For example, if a 2MB
  string is constructed by concatenating 4 bytes together at a time, the
  memory usage will be ~44MB; so ~22x increase. The strings are only joined
  together when an operation requiring their joining takes place, such as
  substr(). This function is called when adding data to this buffer to ensure
  these types of strings are periodically joined to reduce the memory
  footprint. */ var $bc503c2c69c21e12$var$_MAX_CONSTRUCTED_STRING_LENGTH = 4096;
$bc503c2c69c21e12$var$util.ByteStringBuffer.prototype._optimizeConstructedString = function(x) {
    this._constructedStringLength += x;
    if (this._constructedStringLength > $bc503c2c69c21e12$var$_MAX_CONSTRUCTED_STRING_LENGTH) {
        // this substr() should cause the constructed string to join
        this.data.substr(0, 1);
        this._constructedStringLength = 0;
    }
};
/**
 * Gets the number of bytes in this buffer.
 *
 * @return the number of bytes in this buffer.
 */ $bc503c2c69c21e12$var$util.ByteStringBuffer.prototype.length = function() {
    return this.data.length - this.read;
};
/**
 * Gets whether or not this buffer is empty.
 *
 * @return true if this buffer is empty, false if not.
 */ $bc503c2c69c21e12$var$util.ByteStringBuffer.prototype.isEmpty = function() {
    return this.length() <= 0;
};
/**
 * Puts a byte in this buffer.
 *
 * @param b the byte to put.
 *
 * @return this buffer.
 */ $bc503c2c69c21e12$var$util.ByteStringBuffer.prototype.putByte = function(b) {
    return this.putBytes(String.fromCharCode(b));
};
/**
 * Puts a byte in this buffer N times.
 *
 * @param b the byte to put.
 * @param n the number of bytes of value b to put.
 *
 * @return this buffer.
 */ $bc503c2c69c21e12$var$util.ByteStringBuffer.prototype.fillWithByte = function(b, n) {
    b = String.fromCharCode(b);
    var d = this.data;
    while(n > 0){
        if (n & 1) d += b;
        n >>>= 1;
        if (n > 0) b += b;
    }
    this.data = d;
    this._optimizeConstructedString(n);
    return this;
};
/**
 * Puts bytes in this buffer.
 *
 * @param bytes the bytes (as a binary encoded string) to put.
 *
 * @return this buffer.
 */ $bc503c2c69c21e12$var$util.ByteStringBuffer.prototype.putBytes = function(bytes) {
    this.data += bytes;
    this._optimizeConstructedString(bytes.length);
    return this;
};
/**
 * Puts a UTF-16 encoded string into this buffer.
 *
 * @param str the string to put.
 *
 * @return this buffer.
 */ $bc503c2c69c21e12$var$util.ByteStringBuffer.prototype.putString = function(str) {
    return this.putBytes($bc503c2c69c21e12$var$util.encodeUtf8(str));
};
/**
 * Puts a 16-bit integer in this buffer in big-endian order.
 *
 * @param i the 16-bit integer.
 *
 * @return this buffer.
 */ $bc503c2c69c21e12$var$util.ByteStringBuffer.prototype.putInt16 = function(i) {
    return this.putBytes(String.fromCharCode(i >> 8 & 0xFF) + String.fromCharCode(i & 0xFF));
};
/**
 * Puts a 24-bit integer in this buffer in big-endian order.
 *
 * @param i the 24-bit integer.
 *
 * @return this buffer.
 */ $bc503c2c69c21e12$var$util.ByteStringBuffer.prototype.putInt24 = function(i) {
    return this.putBytes(String.fromCharCode(i >> 16 & 0xFF) + String.fromCharCode(i >> 8 & 0xFF) + String.fromCharCode(i & 0xFF));
};
/**
 * Puts a 32-bit integer in this buffer in big-endian order.
 *
 * @param i the 32-bit integer.
 *
 * @return this buffer.
 */ $bc503c2c69c21e12$var$util.ByteStringBuffer.prototype.putInt32 = function(i) {
    return this.putBytes(String.fromCharCode(i >> 24 & 0xFF) + String.fromCharCode(i >> 16 & 0xFF) + String.fromCharCode(i >> 8 & 0xFF) + String.fromCharCode(i & 0xFF));
};
/**
 * Puts a 16-bit integer in this buffer in little-endian order.
 *
 * @param i the 16-bit integer.
 *
 * @return this buffer.
 */ $bc503c2c69c21e12$var$util.ByteStringBuffer.prototype.putInt16Le = function(i) {
    return this.putBytes(String.fromCharCode(i & 0xFF) + String.fromCharCode(i >> 8 & 0xFF));
};
/**
 * Puts a 24-bit integer in this buffer in little-endian order.
 *
 * @param i the 24-bit integer.
 *
 * @return this buffer.
 */ $bc503c2c69c21e12$var$util.ByteStringBuffer.prototype.putInt24Le = function(i) {
    return this.putBytes(String.fromCharCode(i & 0xFF) + String.fromCharCode(i >> 8 & 0xFF) + String.fromCharCode(i >> 16 & 0xFF));
};
/**
 * Puts a 32-bit integer in this buffer in little-endian order.
 *
 * @param i the 32-bit integer.
 *
 * @return this buffer.
 */ $bc503c2c69c21e12$var$util.ByteStringBuffer.prototype.putInt32Le = function(i) {
    return this.putBytes(String.fromCharCode(i & 0xFF) + String.fromCharCode(i >> 8 & 0xFF) + String.fromCharCode(i >> 16 & 0xFF) + String.fromCharCode(i >> 24 & 0xFF));
};
/**
 * Puts an n-bit integer in this buffer in big-endian order.
 *
 * @param i the n-bit integer.
 * @param n the number of bits in the integer (8, 16, 24, or 32).
 *
 * @return this buffer.
 */ $bc503c2c69c21e12$var$util.ByteStringBuffer.prototype.putInt = function(i, n) {
    $bc503c2c69c21e12$var$_checkBitsParam(n);
    var bytes = "";
    do {
        n -= 8;
        bytes += String.fromCharCode(i >> n & 0xFF);
    }while (n > 0);
    return this.putBytes(bytes);
};
/**
 * Puts a signed n-bit integer in this buffer in big-endian order. Two's
 * complement representation is used.
 *
 * @param i the n-bit integer.
 * @param n the number of bits in the integer (8, 16, 24, or 32).
 *
 * @return this buffer.
 */ $bc503c2c69c21e12$var$util.ByteStringBuffer.prototype.putSignedInt = function(i, n) {
    // putInt checks n
    if (i < 0) i += 2 << n - 1;
    return this.putInt(i, n);
};
/**
 * Puts the given buffer into this buffer.
 *
 * @param buffer the buffer to put into this one.
 *
 * @return this buffer.
 */ $bc503c2c69c21e12$var$util.ByteStringBuffer.prototype.putBuffer = function(buffer) {
    return this.putBytes(buffer.getBytes());
};
/**
 * Gets a byte from this buffer and advances the read pointer by 1.
 *
 * @return the byte.
 */ $bc503c2c69c21e12$var$util.ByteStringBuffer.prototype.getByte = function() {
    return this.data.charCodeAt(this.read++);
};
/**
 * Gets a uint16 from this buffer in big-endian order and advances the read
 * pointer by 2.
 *
 * @return the uint16.
 */ $bc503c2c69c21e12$var$util.ByteStringBuffer.prototype.getInt16 = function() {
    var rval = this.data.charCodeAt(this.read) << 8 ^ this.data.charCodeAt(this.read + 1);
    this.read += 2;
    return rval;
};
/**
 * Gets a uint24 from this buffer in big-endian order and advances the read
 * pointer by 3.
 *
 * @return the uint24.
 */ $bc503c2c69c21e12$var$util.ByteStringBuffer.prototype.getInt24 = function() {
    var rval = this.data.charCodeAt(this.read) << 16 ^ this.data.charCodeAt(this.read + 1) << 8 ^ this.data.charCodeAt(this.read + 2);
    this.read += 3;
    return rval;
};
/**
 * Gets a uint32 from this buffer in big-endian order and advances the read
 * pointer by 4.
 *
 * @return the word.
 */ $bc503c2c69c21e12$var$util.ByteStringBuffer.prototype.getInt32 = function() {
    var rval = this.data.charCodeAt(this.read) << 24 ^ this.data.charCodeAt(this.read + 1) << 16 ^ this.data.charCodeAt(this.read + 2) << 8 ^ this.data.charCodeAt(this.read + 3);
    this.read += 4;
    return rval;
};
/**
 * Gets a uint16 from this buffer in little-endian order and advances the read
 * pointer by 2.
 *
 * @return the uint16.
 */ $bc503c2c69c21e12$var$util.ByteStringBuffer.prototype.getInt16Le = function() {
    var rval = this.data.charCodeAt(this.read) ^ this.data.charCodeAt(this.read + 1) << 8;
    this.read += 2;
    return rval;
};
/**
 * Gets a uint24 from this buffer in little-endian order and advances the read
 * pointer by 3.
 *
 * @return the uint24.
 */ $bc503c2c69c21e12$var$util.ByteStringBuffer.prototype.getInt24Le = function() {
    var rval = this.data.charCodeAt(this.read) ^ this.data.charCodeAt(this.read + 1) << 8 ^ this.data.charCodeAt(this.read + 2) << 16;
    this.read += 3;
    return rval;
};
/**
 * Gets a uint32 from this buffer in little-endian order and advances the read
 * pointer by 4.
 *
 * @return the word.
 */ $bc503c2c69c21e12$var$util.ByteStringBuffer.prototype.getInt32Le = function() {
    var rval = this.data.charCodeAt(this.read) ^ this.data.charCodeAt(this.read + 1) << 8 ^ this.data.charCodeAt(this.read + 2) << 16 ^ this.data.charCodeAt(this.read + 3) << 24;
    this.read += 4;
    return rval;
};
/**
 * Gets an n-bit integer from this buffer in big-endian order and advances the
 * read pointer by ceil(n/8).
 *
 * @param n the number of bits in the integer (8, 16, 24, or 32).
 *
 * @return the integer.
 */ $bc503c2c69c21e12$var$util.ByteStringBuffer.prototype.getInt = function(n) {
    $bc503c2c69c21e12$var$_checkBitsParam(n);
    var rval = 0;
    do {
        // TODO: Use (rval * 0x100) if adding support for 33 to 53 bits.
        rval = (rval << 8) + this.data.charCodeAt(this.read++);
        n -= 8;
    }while (n > 0);
    return rval;
};
/**
 * Gets a signed n-bit integer from this buffer in big-endian order, using
 * two's complement, and advances the read pointer by n/8.
 *
 * @param n the number of bits in the integer (8, 16, 24, or 32).
 *
 * @return the integer.
 */ $bc503c2c69c21e12$var$util.ByteStringBuffer.prototype.getSignedInt = function(n) {
    // getInt checks n
    var x = this.getInt(n);
    var max = 2 << n - 2;
    if (x >= max) x -= max << 1;
    return x;
};
/**
 * Reads bytes out as a binary encoded string and clears them from the
 * buffer. Note that the resulting string is binary encoded (in node.js this
 * encoding is referred to as `binary`, it is *not* `utf8`).
 *
 * @param count the number of bytes to read, undefined or null for all.
 *
 * @return a binary encoded string of bytes.
 */ $bc503c2c69c21e12$var$util.ByteStringBuffer.prototype.getBytes = function(count) {
    var rval;
    if (count) {
        // read count bytes
        count = Math.min(this.length(), count);
        rval = this.data.slice(this.read, this.read + count);
        this.read += count;
    } else if (count === 0) rval = "";
    else {
        // read all bytes, optimize to only copy when needed
        rval = this.read === 0 ? this.data : this.data.slice(this.read);
        this.clear();
    }
    return rval;
};
/**
 * Gets a binary encoded string of the bytes from this buffer without
 * modifying the read pointer.
 *
 * @param count the number of bytes to get, omit to get all.
 *
 * @return a string full of binary encoded characters.
 */ $bc503c2c69c21e12$var$util.ByteStringBuffer.prototype.bytes = function(count) {
    return typeof count === "undefined" ? this.data.slice(this.read) : this.data.slice(this.read, this.read + count);
};
/**
 * Gets a byte at the given index without modifying the read pointer.
 *
 * @param i the byte index.
 *
 * @return the byte.
 */ $bc503c2c69c21e12$var$util.ByteStringBuffer.prototype.at = function(i) {
    return this.data.charCodeAt(this.read + i);
};
/**
 * Puts a byte at the given index without modifying the read pointer.
 *
 * @param i the byte index.
 * @param b the byte to put.
 *
 * @return this buffer.
 */ $bc503c2c69c21e12$var$util.ByteStringBuffer.prototype.setAt = function(i, b) {
    this.data = this.data.substr(0, this.read + i) + String.fromCharCode(b) + this.data.substr(this.read + i + 1);
    return this;
};
/**
 * Gets the last byte without modifying the read pointer.
 *
 * @return the last byte.
 */ $bc503c2c69c21e12$var$util.ByteStringBuffer.prototype.last = function() {
    return this.data.charCodeAt(this.data.length - 1);
};
/**
 * Creates a copy of this buffer.
 *
 * @return the copy.
 */ $bc503c2c69c21e12$var$util.ByteStringBuffer.prototype.copy = function() {
    var c = $bc503c2c69c21e12$var$util.createBuffer(this.data);
    c.read = this.read;
    return c;
};
/**
 * Compacts this buffer.
 *
 * @return this buffer.
 */ $bc503c2c69c21e12$var$util.ByteStringBuffer.prototype.compact = function() {
    if (this.read > 0) {
        this.data = this.data.slice(this.read);
        this.read = 0;
    }
    return this;
};
/**
 * Clears this buffer.
 *
 * @return this buffer.
 */ $bc503c2c69c21e12$var$util.ByteStringBuffer.prototype.clear = function() {
    this.data = "";
    this.read = 0;
    return this;
};
/**
 * Shortens this buffer by triming bytes off of the end of this buffer.
 *
 * @param count the number of bytes to trim off.
 *
 * @return this buffer.
 */ $bc503c2c69c21e12$var$util.ByteStringBuffer.prototype.truncate = function(count) {
    var len = Math.max(0, this.length() - count);
    this.data = this.data.substr(this.read, len);
    this.read = 0;
    return this;
};
/**
 * Converts this buffer to a hexadecimal string.
 *
 * @return a hexadecimal string.
 */ $bc503c2c69c21e12$var$util.ByteStringBuffer.prototype.toHex = function() {
    var rval = "";
    for(var i = this.read; i < this.data.length; ++i){
        var b = this.data.charCodeAt(i);
        if (b < 16) rval += "0";
        rval += b.toString(16);
    }
    return rval;
};
/**
 * Converts this buffer to a UTF-16 string (standard JavaScript string).
 *
 * @return a UTF-16 string.
 */ $bc503c2c69c21e12$var$util.ByteStringBuffer.prototype.toString = function() {
    return $bc503c2c69c21e12$var$util.decodeUtf8(this.bytes());
};
/** End Buffer w/BinaryString backing */ /** Buffer w/UInt8Array backing */ /**
 * FIXME: Experimental. Do not use yet.
 *
 * Constructor for an ArrayBuffer-backed byte buffer.
 *
 * The buffer may be constructed from a string, an ArrayBuffer, DataView, or a
 * TypedArray.
 *
 * If a string is given, its encoding should be provided as an option,
 * otherwise it will default to 'binary'. A 'binary' string is encoded such
 * that each character is one byte in length and size.
 *
 * If an ArrayBuffer, DataView, or TypedArray is given, it will be used
 * *directly* without any copying. Note that, if a write to the buffer requires
 * more space, the buffer will allocate a new backing ArrayBuffer to
 * accommodate. The starting read and write offsets for the buffer may be
 * given as options.
 *
 * @param [b] the initial bytes for this buffer.
 * @param options the options to use:
 *          [readOffset] the starting read offset to use (default: 0).
 *          [writeOffset] the starting write offset to use (default: the
 *            length of the first parameter).
 *          [growSize] the minimum amount, in bytes, to grow the buffer by to
 *            accommodate writes (default: 1024).
 *          [encoding] the encoding ('binary', 'utf8', 'utf16', 'hex') for the
 *            first parameter, if it is a string (default: 'binary').
 */ function $bc503c2c69c21e12$var$DataBuffer(b, options) {
    // default options
    options = options || {};
    // pointers for read from/write to buffer
    this.read = options.readOffset || 0;
    this.growSize = options.growSize || 1024;
    var isArrayBuffer = $bc503c2c69c21e12$var$util.isArrayBuffer(b);
    var isArrayBufferView = $bc503c2c69c21e12$var$util.isArrayBufferView(b);
    if (isArrayBuffer || isArrayBufferView) {
        // use ArrayBuffer directly
        if (isArrayBuffer) this.data = new DataView(b);
        else // TODO: adjust read/write offset based on the type of view
        // or specify that this must be done in the options ... that the
        // offsets are byte-based
        this.data = new DataView(b.buffer, b.byteOffset, b.byteLength);
        this.write = "writeOffset" in options ? options.writeOffset : this.data.byteLength;
        return;
    }
    // initialize to empty array buffer and add any given bytes using putBytes
    this.data = new DataView(new ArrayBuffer(0));
    this.write = 0;
    if (b !== null && b !== undefined) this.putBytes(b);
    if ("writeOffset" in options) this.write = options.writeOffset;
}
$bc503c2c69c21e12$var$util.DataBuffer = $bc503c2c69c21e12$var$DataBuffer;
/**
 * Gets the number of bytes in this buffer.
 *
 * @return the number of bytes in this buffer.
 */ $bc503c2c69c21e12$var$util.DataBuffer.prototype.length = function() {
    return this.write - this.read;
};
/**
 * Gets whether or not this buffer is empty.
 *
 * @return true if this buffer is empty, false if not.
 */ $bc503c2c69c21e12$var$util.DataBuffer.prototype.isEmpty = function() {
    return this.length() <= 0;
};
/**
 * Ensures this buffer has enough empty space to accommodate the given number
 * of bytes. An optional parameter may be given that indicates a minimum
 * amount to grow the buffer if necessary. If the parameter is not given,
 * the buffer will be grown by some previously-specified default amount
 * or heuristic.
 *
 * @param amount the number of bytes to accommodate.
 * @param [growSize] the minimum amount, in bytes, to grow the buffer by if
 *          necessary.
 */ $bc503c2c69c21e12$var$util.DataBuffer.prototype.accommodate = function(amount, growSize) {
    if (this.length() >= amount) return this;
    growSize = Math.max(growSize || this.growSize, amount);
    // grow buffer
    var src = new Uint8Array(this.data.buffer, this.data.byteOffset, this.data.byteLength);
    var dst = new Uint8Array(this.length() + growSize);
    dst.set(src);
    this.data = new DataView(dst.buffer);
    return this;
};
/**
 * Puts a byte in this buffer.
 *
 * @param b the byte to put.
 *
 * @return this buffer.
 */ $bc503c2c69c21e12$var$util.DataBuffer.prototype.putByte = function(b) {
    this.accommodate(1);
    this.data.setUint8(this.write++, b);
    return this;
};
/**
 * Puts a byte in this buffer N times.
 *
 * @param b the byte to put.
 * @param n the number of bytes of value b to put.
 *
 * @return this buffer.
 */ $bc503c2c69c21e12$var$util.DataBuffer.prototype.fillWithByte = function(b, n) {
    this.accommodate(n);
    for(var i = 0; i < n; ++i)this.data.setUint8(b);
    return this;
};
/**
 * Puts bytes in this buffer. The bytes may be given as a string, an
 * ArrayBuffer, a DataView, or a TypedArray.
 *
 * @param bytes the bytes to put.
 * @param [encoding] the encoding for the first parameter ('binary', 'utf8',
 *          'utf16', 'hex'), if it is a string (default: 'binary').
 *
 * @return this buffer.
 */ $bc503c2c69c21e12$var$util.DataBuffer.prototype.putBytes = function(bytes, encoding) {
    if ($bc503c2c69c21e12$var$util.isArrayBufferView(bytes)) {
        var src = new Uint8Array(bytes.buffer, bytes.byteOffset, bytes.byteLength);
        var len = src.byteLength - src.byteOffset;
        this.accommodate(len);
        var dst = new Uint8Array(this.data.buffer, this.write);
        dst.set(src);
        this.write += len;
        return this;
    }
    if ($bc503c2c69c21e12$var$util.isArrayBuffer(bytes)) {
        var src = new Uint8Array(bytes);
        this.accommodate(src.byteLength);
        var dst = new Uint8Array(this.data.buffer);
        dst.set(src, this.write);
        this.write += src.byteLength;
        return this;
    }
    // bytes is a util.DataBuffer or equivalent
    if (bytes instanceof $bc503c2c69c21e12$var$util.DataBuffer || typeof bytes === "object" && typeof bytes.read === "number" && typeof bytes.write === "number" && $bc503c2c69c21e12$var$util.isArrayBufferView(bytes.data)) {
        var src = new Uint8Array(bytes.data.byteLength, bytes.read, bytes.length());
        this.accommodate(src.byteLength);
        var dst = new Uint8Array(bytes.data.byteLength, this.write);
        dst.set(src);
        this.write += src.byteLength;
        return this;
    }
    if (bytes instanceof $bc503c2c69c21e12$var$util.ByteStringBuffer) {
        // copy binary string and process as the same as a string parameter below
        bytes = bytes.data;
        encoding = "binary";
    }
    // string conversion
    encoding = encoding || "binary";
    if (typeof bytes === "string") {
        var view;
        // decode from string
        if (encoding === "hex") {
            this.accommodate(Math.ceil(bytes.length / 2));
            view = new Uint8Array(this.data.buffer, this.write);
            this.write += $bc503c2c69c21e12$var$util.binary.hex.decode(bytes, view, this.write);
            return this;
        }
        if (encoding === "base64") {
            this.accommodate(Math.ceil(bytes.length / 4) * 3);
            view = new Uint8Array(this.data.buffer, this.write);
            this.write += $bc503c2c69c21e12$var$util.binary.base64.decode(bytes, view, this.write);
            return this;
        }
        // encode text as UTF-8 bytes
        if (encoding === "utf8") {
            // encode as UTF-8 then decode string as raw binary
            bytes = $bc503c2c69c21e12$var$util.encodeUtf8(bytes);
            encoding = "binary";
        }
        // decode string as raw binary
        if (encoding === "binary" || encoding === "raw") {
            // one byte per character
            this.accommodate(bytes.length);
            view = new Uint8Array(this.data.buffer, this.write);
            this.write += $bc503c2c69c21e12$var$util.binary.raw.decode(view);
            return this;
        }
        // encode text as UTF-16 bytes
        if (encoding === "utf16") {
            // two bytes per character
            this.accommodate(bytes.length * 2);
            view = new Uint16Array(this.data.buffer, this.write);
            this.write += $bc503c2c69c21e12$var$util.text.utf16.encode(view);
            return this;
        }
        throw new Error("Invalid encoding: " + encoding);
    }
    throw Error("Invalid parameter: " + bytes);
};
/**
 * Puts the given buffer into this buffer.
 *
 * @param buffer the buffer to put into this one.
 *
 * @return this buffer.
 */ $bc503c2c69c21e12$var$util.DataBuffer.prototype.putBuffer = function(buffer) {
    this.putBytes(buffer);
    buffer.clear();
    return this;
};
/**
 * Puts a string into this buffer.
 *
 * @param str the string to put.
 * @param [encoding] the encoding for the string (default: 'utf16').
 *
 * @return this buffer.
 */ $bc503c2c69c21e12$var$util.DataBuffer.prototype.putString = function(str) {
    return this.putBytes(str, "utf16");
};
/**
 * Puts a 16-bit integer in this buffer in big-endian order.
 *
 * @param i the 16-bit integer.
 *
 * @return this buffer.
 */ $bc503c2c69c21e12$var$util.DataBuffer.prototype.putInt16 = function(i) {
    this.accommodate(2);
    this.data.setInt16(this.write, i);
    this.write += 2;
    return this;
};
/**
 * Puts a 24-bit integer in this buffer in big-endian order.
 *
 * @param i the 24-bit integer.
 *
 * @return this buffer.
 */ $bc503c2c69c21e12$var$util.DataBuffer.prototype.putInt24 = function(i) {
    this.accommodate(3);
    this.data.setInt16(this.write, i >> 8 & 0xFFFF);
    this.data.setInt8(this.write, i >> 16 & 0xFF);
    this.write += 3;
    return this;
};
/**
 * Puts a 32-bit integer in this buffer in big-endian order.
 *
 * @param i the 32-bit integer.
 *
 * @return this buffer.
 */ $bc503c2c69c21e12$var$util.DataBuffer.prototype.putInt32 = function(i) {
    this.accommodate(4);
    this.data.setInt32(this.write, i);
    this.write += 4;
    return this;
};
/**
 * Puts a 16-bit integer in this buffer in little-endian order.
 *
 * @param i the 16-bit integer.
 *
 * @return this buffer.
 */ $bc503c2c69c21e12$var$util.DataBuffer.prototype.putInt16Le = function(i) {
    this.accommodate(2);
    this.data.setInt16(this.write, i, true);
    this.write += 2;
    return this;
};
/**
 * Puts a 24-bit integer in this buffer in little-endian order.
 *
 * @param i the 24-bit integer.
 *
 * @return this buffer.
 */ $bc503c2c69c21e12$var$util.DataBuffer.prototype.putInt24Le = function(i) {
    this.accommodate(3);
    this.data.setInt8(this.write, i >> 16 & 0xFF);
    this.data.setInt16(this.write, i >> 8 & 0xFFFF, true);
    this.write += 3;
    return this;
};
/**
 * Puts a 32-bit integer in this buffer in little-endian order.
 *
 * @param i the 32-bit integer.
 *
 * @return this buffer.
 */ $bc503c2c69c21e12$var$util.DataBuffer.prototype.putInt32Le = function(i) {
    this.accommodate(4);
    this.data.setInt32(this.write, i, true);
    this.write += 4;
    return this;
};
/**
 * Puts an n-bit integer in this buffer in big-endian order.
 *
 * @param i the n-bit integer.
 * @param n the number of bits in the integer (8, 16, 24, or 32).
 *
 * @return this buffer.
 */ $bc503c2c69c21e12$var$util.DataBuffer.prototype.putInt = function(i, n) {
    $bc503c2c69c21e12$var$_checkBitsParam(n);
    this.accommodate(n / 8);
    do {
        n -= 8;
        this.data.setInt8(this.write++, i >> n & 0xFF);
    }while (n > 0);
    return this;
};
/**
 * Puts a signed n-bit integer in this buffer in big-endian order. Two's
 * complement representation is used.
 *
 * @param i the n-bit integer.
 * @param n the number of bits in the integer.
 *
 * @return this buffer.
 */ $bc503c2c69c21e12$var$util.DataBuffer.prototype.putSignedInt = function(i, n) {
    $bc503c2c69c21e12$var$_checkBitsParam(n);
    this.accommodate(n / 8);
    if (i < 0) i += 2 << n - 1;
    return this.putInt(i, n);
};
/**
 * Gets a byte from this buffer and advances the read pointer by 1.
 *
 * @return the byte.
 */ $bc503c2c69c21e12$var$util.DataBuffer.prototype.getByte = function() {
    return this.data.getInt8(this.read++);
};
/**
 * Gets a uint16 from this buffer in big-endian order and advances the read
 * pointer by 2.
 *
 * @return the uint16.
 */ $bc503c2c69c21e12$var$util.DataBuffer.prototype.getInt16 = function() {
    var rval = this.data.getInt16(this.read);
    this.read += 2;
    return rval;
};
/**
 * Gets a uint24 from this buffer in big-endian order and advances the read
 * pointer by 3.
 *
 * @return the uint24.
 */ $bc503c2c69c21e12$var$util.DataBuffer.prototype.getInt24 = function() {
    var rval = this.data.getInt16(this.read) << 8 ^ this.data.getInt8(this.read + 2);
    this.read += 3;
    return rval;
};
/**
 * Gets a uint32 from this buffer in big-endian order and advances the read
 * pointer by 4.
 *
 * @return the word.
 */ $bc503c2c69c21e12$var$util.DataBuffer.prototype.getInt32 = function() {
    var rval = this.data.getInt32(this.read);
    this.read += 4;
    return rval;
};
/**
 * Gets a uint16 from this buffer in little-endian order and advances the read
 * pointer by 2.
 *
 * @return the uint16.
 */ $bc503c2c69c21e12$var$util.DataBuffer.prototype.getInt16Le = function() {
    var rval = this.data.getInt16(this.read, true);
    this.read += 2;
    return rval;
};
/**
 * Gets a uint24 from this buffer in little-endian order and advances the read
 * pointer by 3.
 *
 * @return the uint24.
 */ $bc503c2c69c21e12$var$util.DataBuffer.prototype.getInt24Le = function() {
    var rval = this.data.getInt8(this.read) ^ this.data.getInt16(this.read + 1, true) << 8;
    this.read += 3;
    return rval;
};
/**
 * Gets a uint32 from this buffer in little-endian order and advances the read
 * pointer by 4.
 *
 * @return the word.
 */ $bc503c2c69c21e12$var$util.DataBuffer.prototype.getInt32Le = function() {
    var rval = this.data.getInt32(this.read, true);
    this.read += 4;
    return rval;
};
/**
 * Gets an n-bit integer from this buffer in big-endian order and advances the
 * read pointer by n/8.
 *
 * @param n the number of bits in the integer (8, 16, 24, or 32).
 *
 * @return the integer.
 */ $bc503c2c69c21e12$var$util.DataBuffer.prototype.getInt = function(n) {
    $bc503c2c69c21e12$var$_checkBitsParam(n);
    var rval = 0;
    do {
        // TODO: Use (rval * 0x100) if adding support for 33 to 53 bits.
        rval = (rval << 8) + this.data.getInt8(this.read++);
        n -= 8;
    }while (n > 0);
    return rval;
};
/**
 * Gets a signed n-bit integer from this buffer in big-endian order, using
 * two's complement, and advances the read pointer by n/8.
 *
 * @param n the number of bits in the integer (8, 16, 24, or 32).
 *
 * @return the integer.
 */ $bc503c2c69c21e12$var$util.DataBuffer.prototype.getSignedInt = function(n) {
    // getInt checks n
    var x = this.getInt(n);
    var max = 2 << n - 2;
    if (x >= max) x -= max << 1;
    return x;
};
/**
 * Reads bytes out as a binary encoded string and clears them from the
 * buffer.
 *
 * @param count the number of bytes to read, undefined or null for all.
 *
 * @return a binary encoded string of bytes.
 */ $bc503c2c69c21e12$var$util.DataBuffer.prototype.getBytes = function(count) {
    // TODO: deprecate this method, it is poorly named and
    // this.toString('binary') replaces it
    // add a toTypedArray()/toArrayBuffer() function
    var rval;
    if (count) {
        // read count bytes
        count = Math.min(this.length(), count);
        rval = this.data.slice(this.read, this.read + count);
        this.read += count;
    } else if (count === 0) rval = "";
    else {
        // read all bytes, optimize to only copy when needed
        rval = this.read === 0 ? this.data : this.data.slice(this.read);
        this.clear();
    }
    return rval;
};
/**
 * Gets a binary encoded string of the bytes from this buffer without
 * modifying the read pointer.
 *
 * @param count the number of bytes to get, omit to get all.
 *
 * @return a string full of binary encoded characters.
 */ $bc503c2c69c21e12$var$util.DataBuffer.prototype.bytes = function(count) {
    // TODO: deprecate this method, it is poorly named, add "getString()"
    return typeof count === "undefined" ? this.data.slice(this.read) : this.data.slice(this.read, this.read + count);
};
/**
 * Gets a byte at the given index without modifying the read pointer.
 *
 * @param i the byte index.
 *
 * @return the byte.
 */ $bc503c2c69c21e12$var$util.DataBuffer.prototype.at = function(i) {
    return this.data.getUint8(this.read + i);
};
/**
 * Puts a byte at the given index without modifying the read pointer.
 *
 * @param i the byte index.
 * @param b the byte to put.
 *
 * @return this buffer.
 */ $bc503c2c69c21e12$var$util.DataBuffer.prototype.setAt = function(i, b) {
    this.data.setUint8(i, b);
    return this;
};
/**
 * Gets the last byte without modifying the read pointer.
 *
 * @return the last byte.
 */ $bc503c2c69c21e12$var$util.DataBuffer.prototype.last = function() {
    return this.data.getUint8(this.write - 1);
};
/**
 * Creates a copy of this buffer.
 *
 * @return the copy.
 */ $bc503c2c69c21e12$var$util.DataBuffer.prototype.copy = function() {
    return new $bc503c2c69c21e12$var$util.DataBuffer(this);
};
/**
 * Compacts this buffer.
 *
 * @return this buffer.
 */ $bc503c2c69c21e12$var$util.DataBuffer.prototype.compact = function() {
    if (this.read > 0) {
        var src = new Uint8Array(this.data.buffer, this.read);
        var dst = new Uint8Array(src.byteLength);
        dst.set(src);
        this.data = new DataView(dst);
        this.write -= this.read;
        this.read = 0;
    }
    return this;
};
/**
 * Clears this buffer.
 *
 * @return this buffer.
 */ $bc503c2c69c21e12$var$util.DataBuffer.prototype.clear = function() {
    this.data = new DataView(new ArrayBuffer(0));
    this.read = this.write = 0;
    return this;
};
/**
 * Shortens this buffer by triming bytes off of the end of this buffer.
 *
 * @param count the number of bytes to trim off.
 *
 * @return this buffer.
 */ $bc503c2c69c21e12$var$util.DataBuffer.prototype.truncate = function(count) {
    this.write = Math.max(0, this.length() - count);
    this.read = Math.min(this.read, this.write);
    return this;
};
/**
 * Converts this buffer to a hexadecimal string.
 *
 * @return a hexadecimal string.
 */ $bc503c2c69c21e12$var$util.DataBuffer.prototype.toHex = function() {
    var rval = "";
    for(var i = this.read; i < this.data.byteLength; ++i){
        var b = this.data.getUint8(i);
        if (b < 16) rval += "0";
        rval += b.toString(16);
    }
    return rval;
};
/**
 * Converts this buffer to a string, using the given encoding. If no
 * encoding is given, 'utf8' (UTF-8) is used.
 *
 * @param [encoding] the encoding to use: 'binary', 'utf8', 'utf16', 'hex',
 *          'base64' (default: 'utf8').
 *
 * @return a string representation of the bytes in this buffer.
 */ $bc503c2c69c21e12$var$util.DataBuffer.prototype.toString = function(encoding) {
    var view = new Uint8Array(this.data, this.read, this.length());
    encoding = encoding || "utf8";
    // encode to string
    if (encoding === "binary" || encoding === "raw") return $bc503c2c69c21e12$var$util.binary.raw.encode(view);
    if (encoding === "hex") return $bc503c2c69c21e12$var$util.binary.hex.encode(view);
    if (encoding === "base64") return $bc503c2c69c21e12$var$util.binary.base64.encode(view);
    // decode to text
    if (encoding === "utf8") return $bc503c2c69c21e12$var$util.text.utf8.decode(view);
    if (encoding === "utf16") return $bc503c2c69c21e12$var$util.text.utf16.decode(view);
    throw new Error("Invalid encoding: " + encoding);
};
/** End Buffer w/UInt8Array backing */ /**
 * Creates a buffer that stores bytes. A value may be given to populate the
 * buffer with data. This value can either be string of encoded bytes or a
 * regular string of characters. When passing a string of binary encoded
 * bytes, the encoding `raw` should be given. This is also the default. When
 * passing a string of characters, the encoding `utf8` should be given.
 *
 * @param [input] a string with encoded bytes to store in the buffer.
 * @param [encoding] (default: 'raw', other: 'utf8').
 */ $bc503c2c69c21e12$var$util.createBuffer = function(input, encoding) {
    // TODO: deprecate, use new ByteBuffer() instead
    encoding = encoding || "raw";
    if (input !== undefined && encoding === "utf8") input = $bc503c2c69c21e12$var$util.encodeUtf8(input);
    return new $bc503c2c69c21e12$var$util.ByteBuffer(input);
};
/**
 * Fills a string with a particular value. If you want the string to be a byte
 * string, pass in String.fromCharCode(theByte).
 *
 * @param c the character to fill the string with, use String.fromCharCode
 *          to fill the string with a byte value.
 * @param n the number of characters of value c to fill with.
 *
 * @return the filled string.
 */ $bc503c2c69c21e12$var$util.fillString = function(c, n) {
    var s = "";
    while(n > 0){
        if (n & 1) s += c;
        n >>>= 1;
        if (n > 0) c += c;
    }
    return s;
};
/**
 * Performs a per byte XOR between two byte strings and returns the result as a
 * string of bytes.
 *
 * @param s1 first string of bytes.
 * @param s2 second string of bytes.
 * @param n the number of bytes to XOR.
 *
 * @return the XOR'd result.
 */ $bc503c2c69c21e12$var$util.xorBytes = function(s1, s2, n) {
    var s3 = "";
    var b = "";
    var t = "";
    var i = 0;
    var c = 0;
    for(; n > 0; --n, ++i){
        b = s1.charCodeAt(i) ^ s2.charCodeAt(i);
        if (c >= 10) {
            s3 += t;
            t = "";
            c = 0;
        }
        t += String.fromCharCode(b);
        ++c;
    }
    s3 += t;
    return s3;
};
/**
 * Converts a hex string into a 'binary' encoded string of bytes.
 *
 * @param hex the hexadecimal string to convert.
 *
 * @return the binary-encoded string of bytes.
 */ $bc503c2c69c21e12$var$util.hexToBytes = function(hex) {
    // TODO: deprecate: "Deprecated. Use util.binary.hex.decode instead."
    var rval = "";
    var i = 0;
    if (hex.length & true) {
        // odd number of characters, convert first character alone
        i = 1;
        rval += String.fromCharCode(parseInt(hex[0], 16));
    }
    // convert 2 characters (1 byte) at a time
    for(; i < hex.length; i += 2)rval += String.fromCharCode(parseInt(hex.substr(i, 2), 16));
    return rval;
};
/**
 * Converts a 'binary' encoded string of bytes to hex.
 *
 * @param bytes the byte string to convert.
 *
 * @return the string of hexadecimal characters.
 */ $bc503c2c69c21e12$var$util.bytesToHex = function(bytes) {
    // TODO: deprecate: "Deprecated. Use util.binary.hex.encode instead."
    return $bc503c2c69c21e12$var$util.createBuffer(bytes).toHex();
};
/**
 * Converts an 32-bit integer to 4-big-endian byte string.
 *
 * @param i the integer.
 *
 * @return the byte string.
 */ $bc503c2c69c21e12$var$util.int32ToBytes = function(i) {
    return String.fromCharCode(i >> 24 & 0xFF) + String.fromCharCode(i >> 16 & 0xFF) + String.fromCharCode(i >> 8 & 0xFF) + String.fromCharCode(i & 0xFF);
};
// base64 characters, reverse mapping
var $bc503c2c69c21e12$var$_base64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
var $bc503c2c69c21e12$var$_base64Idx = [
    /*43 -43 = 0*/ /*'+',  1,  2,  3,'/' */ 62,
    -1,
    -1,
    -1,
    63,
    /*'0','1','2','3','4','5','6','7','8','9' */ 52,
    53,
    54,
    55,
    56,
    57,
    58,
    59,
    60,
    61,
    /*15, 16, 17,'=', 19, 20, 21 */ -1,
    -1,
    -1,
    64,
    -1,
    -1,
    -1,
    /*65 - 43 = 22*/ /*'A','B','C','D','E','F','G','H','I','J','K','L','M', */ 0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    /*'N','O','P','Q','R','S','T','U','V','W','X','Y','Z' */ 13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    /*91 - 43 = 48 */ /*48, 49, 50, 51, 52, 53 */ -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    /*97 - 43 = 54*/ /*'a','b','c','d','e','f','g','h','i','j','k','l','m' */ 26,
    27,
    28,
    29,
    30,
    31,
    32,
    33,
    34,
    35,
    36,
    37,
    38,
    /*'n','o','p','q','r','s','t','u','v','w','x','y','z' */ 39,
    40,
    41,
    42,
    43,
    44,
    45,
    46,
    47,
    48,
    49,
    50,
    51
];
// base58 characters (Bitcoin alphabet)
var $bc503c2c69c21e12$var$_base58 = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
/**
 * Base64 encodes a 'binary' encoded string of bytes.
 *
 * @param input the binary encoded string of bytes to base64-encode.
 * @param maxline the maximum number of encoded characters per line to use,
 *          defaults to none.
 *
 * @return the base64-encoded output.
 */ $bc503c2c69c21e12$var$util.encode64 = function(input, maxline) {
    // TODO: deprecate: "Deprecated. Use util.binary.base64.encode instead."
    var line = "";
    var output = "";
    var chr1, chr2, chr3;
    var i = 0;
    while(i < input.length){
        chr1 = input.charCodeAt(i++);
        chr2 = input.charCodeAt(i++);
        chr3 = input.charCodeAt(i++);
        // encode 4 character group
        line += $bc503c2c69c21e12$var$_base64.charAt(chr1 >> 2);
        line += $bc503c2c69c21e12$var$_base64.charAt((chr1 & 3) << 4 | chr2 >> 4);
        if (isNaN(chr2)) line += "==";
        else {
            line += $bc503c2c69c21e12$var$_base64.charAt((chr2 & 15) << 2 | chr3 >> 6);
            line += isNaN(chr3) ? "=" : $bc503c2c69c21e12$var$_base64.charAt(chr3 & 63);
        }
        if (maxline && line.length > maxline) {
            output += line.substr(0, maxline) + "\r\n";
            line = line.substr(maxline);
        }
    }
    output += line;
    return output;
};
/**
 * Base64 decodes a string into a 'binary' encoded string of bytes.
 *
 * @param input the base64-encoded input.
 *
 * @return the binary encoded string.
 */ $bc503c2c69c21e12$var$util.decode64 = function(input) {
    // TODO: deprecate: "Deprecated. Use util.binary.base64.decode instead."
    // remove all non-base64 characters
    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
    var output = "";
    var enc1, enc2, enc3, enc4;
    var i = 0;
    while(i < input.length){
        enc1 = $bc503c2c69c21e12$var$_base64Idx[input.charCodeAt(i++) - 43];
        enc2 = $bc503c2c69c21e12$var$_base64Idx[input.charCodeAt(i++) - 43];
        enc3 = $bc503c2c69c21e12$var$_base64Idx[input.charCodeAt(i++) - 43];
        enc4 = $bc503c2c69c21e12$var$_base64Idx[input.charCodeAt(i++) - 43];
        output += String.fromCharCode(enc1 << 2 | enc2 >> 4);
        if (enc3 !== 64) {
            // decoded at least 2 bytes
            output += String.fromCharCode((enc2 & 15) << 4 | enc3 >> 2);
            if (enc4 !== 64) // decoded 3 bytes
            output += String.fromCharCode((enc3 & 3) << 6 | enc4);
        }
    }
    return output;
};
/**
 * Encodes the given string of characters (a standard JavaScript
 * string) as a binary encoded string where the bytes represent
 * a UTF-8 encoded string of characters. Non-ASCII characters will be
 * encoded as multiple bytes according to UTF-8.
 *
 * @param str a standard string of characters to encode.
 *
 * @return the binary encoded string.
 */ $bc503c2c69c21e12$var$util.encodeUtf8 = function(str) {
    return unescape(encodeURIComponent(str));
};
/**
 * Decodes a binary encoded string that contains bytes that
 * represent a UTF-8 encoded string of characters -- into a
 * string of characters (a standard JavaScript string).
 *
 * @param str the binary encoded string to decode.
 *
 * @return the resulting standard string of characters.
 */ $bc503c2c69c21e12$var$util.decodeUtf8 = function(str) {
    return decodeURIComponent(escape(str));
};
// binary encoding/decoding tools
// FIXME: Experimental. Do not use yet.
$bc503c2c69c21e12$var$util.binary = {
    raw: {},
    hex: {},
    base64: {},
    base58: {},
    baseN: {
        encode: $fu0iC.encode,
        decode: $fu0iC.decode
    }
};
/**
 * Encodes a Uint8Array as a binary-encoded string. This encoding uses
 * a value between 0 and 255 for each character.
 *
 * @param bytes the Uint8Array to encode.
 *
 * @return the binary-encoded string.
 */ $bc503c2c69c21e12$var$util.binary.raw.encode = function(bytes) {
    return String.fromCharCode.apply(null, bytes);
};
/**
 * Decodes a binary-encoded string to a Uint8Array. This encoding uses
 * a value between 0 and 255 for each character.
 *
 * @param str the binary-encoded string to decode.
 * @param [output] an optional Uint8Array to write the output to; if it
 *          is too small, an exception will be thrown.
 * @param [offset] the start offset for writing to the output (default: 0).
 *
 * @return the Uint8Array or the number of bytes written if output was given.
 */ $bc503c2c69c21e12$var$util.binary.raw.decode = function(str, output, offset) {
    var out = output;
    if (!out) out = new Uint8Array(str.length);
    offset = offset || 0;
    var j = offset;
    for(var i = 0; i < str.length; ++i)out[j++] = str.charCodeAt(i);
    return output ? j - offset : out;
};
/**
 * Encodes a 'binary' string, ArrayBuffer, DataView, TypedArray, or
 * ByteBuffer as a string of hexadecimal characters.
 *
 * @param bytes the bytes to convert.
 *
 * @return the string of hexadecimal characters.
 */ $bc503c2c69c21e12$var$util.binary.hex.encode = $bc503c2c69c21e12$var$util.bytesToHex;
/**
 * Decodes a hex-encoded string to a Uint8Array.
 *
 * @param hex the hexadecimal string to convert.
 * @param [output] an optional Uint8Array to write the output to; if it
 *          is too small, an exception will be thrown.
 * @param [offset] the start offset for writing to the output (default: 0).
 *
 * @return the Uint8Array or the number of bytes written if output was given.
 */ $bc503c2c69c21e12$var$util.binary.hex.decode = function(hex, output, offset) {
    var out = output;
    if (!out) out = new Uint8Array(Math.ceil(hex.length / 2));
    offset = offset || 0;
    var i = 0, j = offset;
    if (hex.length & 1) {
        // odd number of characters, convert first character alone
        i = 1;
        out[j++] = parseInt(hex[0], 16);
    }
    // convert 2 characters (1 byte) at a time
    for(; i < hex.length; i += 2)out[j++] = parseInt(hex.substr(i, 2), 16);
    return output ? j - offset : out;
};
/**
 * Base64-encodes a Uint8Array.
 *
 * @param input the Uint8Array to encode.
 * @param maxline the maximum number of encoded characters per line to use,
 *          defaults to none.
 *
 * @return the base64-encoded output string.
 */ $bc503c2c69c21e12$var$util.binary.base64.encode = function(input, maxline) {
    var line = "";
    var output = "";
    var chr1, chr2, chr3;
    var i = 0;
    while(i < input.byteLength){
        chr1 = input[i++];
        chr2 = input[i++];
        chr3 = input[i++];
        // encode 4 character group
        line += $bc503c2c69c21e12$var$_base64.charAt(chr1 >> 2);
        line += $bc503c2c69c21e12$var$_base64.charAt((chr1 & 3) << 4 | chr2 >> 4);
        if (isNaN(chr2)) line += "==";
        else {
            line += $bc503c2c69c21e12$var$_base64.charAt((chr2 & 15) << 2 | chr3 >> 6);
            line += isNaN(chr3) ? "=" : $bc503c2c69c21e12$var$_base64.charAt(chr3 & 63);
        }
        if (maxline && line.length > maxline) {
            output += line.substr(0, maxline) + "\r\n";
            line = line.substr(maxline);
        }
    }
    output += line;
    return output;
};
/**
 * Decodes a base64-encoded string to a Uint8Array.
 *
 * @param input the base64-encoded input string.
 * @param [output] an optional Uint8Array to write the output to; if it
 *          is too small, an exception will be thrown.
 * @param [offset] the start offset for writing to the output (default: 0).
 *
 * @return the Uint8Array or the number of bytes written if output was given.
 */ $bc503c2c69c21e12$var$util.binary.base64.decode = function(input, output, offset) {
    var out = output;
    if (!out) out = new Uint8Array(Math.ceil(input.length / 4) * 3);
    // remove all non-base64 characters
    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
    offset = offset || 0;
    var enc1, enc2, enc3, enc4;
    var i = 0, j = offset;
    while(i < input.length){
        enc1 = $bc503c2c69c21e12$var$_base64Idx[input.charCodeAt(i++) - 43];
        enc2 = $bc503c2c69c21e12$var$_base64Idx[input.charCodeAt(i++) - 43];
        enc3 = $bc503c2c69c21e12$var$_base64Idx[input.charCodeAt(i++) - 43];
        enc4 = $bc503c2c69c21e12$var$_base64Idx[input.charCodeAt(i++) - 43];
        out[j++] = enc1 << 2 | enc2 >> 4;
        if (enc3 !== 64) {
            // decoded at least 2 bytes
            out[j++] = (enc2 & 15) << 4 | enc3 >> 2;
            if (enc4 !== 64) // decoded 3 bytes
            out[j++] = (enc3 & 3) << 6 | enc4;
        }
    }
    // make sure result is the exact decoded length
    return output ? j - offset : out.subarray(0, j);
};
// add support for base58 encoding/decoding with Bitcoin alphabet
$bc503c2c69c21e12$var$util.binary.base58.encode = function(input, maxline) {
    return $bc503c2c69c21e12$var$util.binary.baseN.encode(input, $bc503c2c69c21e12$var$_base58, maxline);
};
$bc503c2c69c21e12$var$util.binary.base58.decode = function(input, maxline) {
    return $bc503c2c69c21e12$var$util.binary.baseN.decode(input, $bc503c2c69c21e12$var$_base58, maxline);
};
// text encoding/decoding tools
// FIXME: Experimental. Do not use yet.
$bc503c2c69c21e12$var$util.text = {
    utf8: {},
    utf16: {}
};
/**
 * Encodes the given string as UTF-8 in a Uint8Array.
 *
 * @param str the string to encode.
 * @param [output] an optional Uint8Array to write the output to; if it
 *          is too small, an exception will be thrown.
 * @param [offset] the start offset for writing to the output (default: 0).
 *
 * @return the Uint8Array or the number of bytes written if output was given.
 */ $bc503c2c69c21e12$var$util.text.utf8.encode = function(str, output, offset) {
    str = $bc503c2c69c21e12$var$util.encodeUtf8(str);
    var out = output;
    if (!out) out = new Uint8Array(str.length);
    offset = offset || 0;
    var j = offset;
    for(var i = 0; i < str.length; ++i)out[j++] = str.charCodeAt(i);
    return output ? j - offset : out;
};
/**
 * Decodes the UTF-8 contents from a Uint8Array.
 *
 * @param bytes the Uint8Array to decode.
 *
 * @return the resulting string.
 */ $bc503c2c69c21e12$var$util.text.utf8.decode = function(bytes) {
    return $bc503c2c69c21e12$var$util.decodeUtf8(String.fromCharCode.apply(null, bytes));
};
/**
 * Encodes the given string as UTF-16 in a Uint8Array.
 *
 * @param str the string to encode.
 * @param [output] an optional Uint8Array to write the output to; if it
 *          is too small, an exception will be thrown.
 * @param [offset] the start offset for writing to the output (default: 0).
 *
 * @return the Uint8Array or the number of bytes written if output was given.
 */ $bc503c2c69c21e12$var$util.text.utf16.encode = function(str, output, offset) {
    var out = output;
    if (!out) out = new Uint8Array(str.length * 2);
    var view = new Uint16Array(out.buffer);
    offset = offset || 0;
    var j = offset;
    var k = offset;
    for(var i = 0; i < str.length; ++i){
        view[k++] = str.charCodeAt(i);
        j += 2;
    }
    return output ? j - offset : out;
};
/**
 * Decodes the UTF-16 contents from a Uint8Array.
 *
 * @param bytes the Uint8Array to decode.
 *
 * @return the resulting string.
 */ $bc503c2c69c21e12$var$util.text.utf16.decode = function(bytes) {
    return String.fromCharCode.apply(null, new Uint16Array(bytes.buffer));
};
/**
 * Deflates the given data using a flash interface.
 *
 * @param api the flash interface.
 * @param bytes the data.
 * @param raw true to return only raw deflate data, false to include zlib
 *          header and trailer.
 *
 * @return the deflated data as a string.
 */ $bc503c2c69c21e12$var$util.deflate = function(api, bytes, raw) {
    bytes = $bc503c2c69c21e12$var$util.decode64(api.deflate($bc503c2c69c21e12$var$util.encode64(bytes)).rval);
    // strip zlib header and trailer if necessary
    if (raw) {
        // zlib header is 2 bytes (CMF,FLG) where FLG indicates that
        // there is a 4-byte DICT (alder-32) block before the data if
        // its 5th bit is set
        var start = 2;
        var flg = bytes.charCodeAt(1);
        if (flg & 0x20) start = 6;
        // zlib trailer is 4 bytes of adler-32
        bytes = bytes.substring(start, bytes.length - 4);
    }
    return bytes;
};
/**
 * Inflates the given data using a flash interface.
 *
 * @param api the flash interface.
 * @param bytes the data.
 * @param raw true if the incoming data has no zlib header or trailer and is
 *          raw DEFLATE data.
 *
 * @return the inflated data as a string, null on error.
 */ $bc503c2c69c21e12$var$util.inflate = function(api, bytes, raw) {
    // TODO: add zlib header and trailer if necessary/possible
    var rval = api.inflate($bc503c2c69c21e12$var$util.encode64(bytes)).rval;
    return rval === null ? null : $bc503c2c69c21e12$var$util.decode64(rval);
};
/**
 * Sets a storage object.
 *
 * @param api the storage interface.
 * @param id the storage ID to use.
 * @param obj the storage object, null to remove.
 */ var $bc503c2c69c21e12$var$_setStorageObject = function _setStorageObject(api, id, obj) {
    if (!api) throw new Error("WebStorage not available.");
    var rval;
    if (obj === null) rval = api.removeItem(id);
    else {
        // json-encode and base64-encode object
        obj = $bc503c2c69c21e12$var$util.encode64(JSON.stringify(obj));
        rval = api.setItem(id, obj);
    }
    // handle potential flash error
    if (typeof rval !== "undefined" && rval.rval !== true) {
        var error = new Error(rval.error.message);
        error.id = rval.error.id;
        error.name = rval.error.name;
        throw error;
    }
};
/**
 * Gets a storage object.
 *
 * @param api the storage interface.
 * @param id the storage ID to use.
 *
 * @return the storage object entry or null if none exists.
 */ var $bc503c2c69c21e12$var$_getStorageObject = function _getStorageObject(api, id) {
    if (!api) throw new Error("WebStorage not available.");
    // get the existing entry
    var rval = api.getItem(id);
    /* Note: We check api.init because we can't do (api == localStorage)
    on IE because of "Class doesn't support Automation" exception. Only
    the flash api has an init method so this works too, but we need a
    better solution in the future. */ // flash returns item wrapped in an object, handle special case
    if (api.init) {
        if (rval.rval === null) {
            if (rval.error) {
                var error = new Error(rval.error.message);
                error.id = rval.error.id;
                error.name = rval.error.name;
                throw error;
            }
            // no error, but also no item
            rval = null;
        } else rval = rval.rval;
    }
    // handle decoding
    if (rval !== null) // base64-decode and json-decode data
    rval = JSON.parse($bc503c2c69c21e12$var$util.decode64(rval));
    return rval;
};
/**
 * Stores an item in local storage.
 *
 * @param api the storage interface.
 * @param id the storage ID to use.
 * @param key the key for the item.
 * @param data the data for the item (any javascript object/primitive).
 */ var $bc503c2c69c21e12$var$_setItem = function _setItem(api, id, key, data) {
    // get storage object
    var obj = $bc503c2c69c21e12$var$_getStorageObject(api, id);
    if (obj === null) // create a new storage object
    obj = {};
    // update key
    obj[key] = data;
    // set storage object
    $bc503c2c69c21e12$var$_setStorageObject(api, id, obj);
};
/**
 * Gets an item from local storage.
 *
 * @param api the storage interface.
 * @param id the storage ID to use.
 * @param key the key for the item.
 *
 * @return the item.
 */ var $bc503c2c69c21e12$var$_getItem = function _getItem(api, id, key) {
    // get storage object
    var rval = $bc503c2c69c21e12$var$_getStorageObject(api, id);
    if (rval !== null) // return data at key
    rval = key in rval ? rval[key] : null;
    return rval;
};
/**
 * Removes an item from local storage.
 *
 * @param api the storage interface.
 * @param id the storage ID to use.
 * @param key the key for the item.
 */ var $bc503c2c69c21e12$var$_removeItem = function _removeItem(api, id, key) {
    // get storage object
    var obj = $bc503c2c69c21e12$var$_getStorageObject(api, id);
    if (obj !== null && key in obj) {
        // remove key
        delete obj[key];
        // see if entry has no keys remaining
        var empty = true;
        for(var prop in obj){
            empty = false;
            break;
        }
        if (empty) // remove entry entirely if no keys are left
        obj = null;
        // set storage object
        $bc503c2c69c21e12$var$_setStorageObject(api, id, obj);
    }
};
/**
 * Clears the local disk storage identified by the given ID.
 *
 * @param api the storage interface.
 * @param id the storage ID to use.
 */ var $bc503c2c69c21e12$var$_clearItems = function _clearItems(api, id) {
    $bc503c2c69c21e12$var$_setStorageObject(api, id, null);
};
/**
 * Calls a storage function.
 *
 * @param func the function to call.
 * @param args the arguments for the function.
 * @param location the location argument.
 *
 * @return the return value from the function.
 */ var $bc503c2c69c21e12$var$_callStorageFunction = function _callStorageFunction(func, args, location) {
    var rval = null;
    // default storage types
    if (typeof location === "undefined") location = [
        "web",
        "flash"
    ];
    // apply storage types in order of preference
    var type;
    var done = false;
    var exception = null;
    for(var idx in location){
        type = location[idx];
        try {
            if (type === "flash" || type === "both") {
                if (args[0] === null) throw new Error("Flash local storage not available.");
                rval = func.apply(this, args);
                done = type === "flash";
            }
            if (type === "web" || type === "both") {
                args[0] = localStorage;
                rval = func.apply(this, args);
                done = true;
            }
        } catch (ex) {
            exception = ex;
        }
        if (done) break;
    }
    if (!done) throw exception;
    return rval;
};
/**
 * Stores an item on local disk.
 *
 * The available types of local storage include 'flash', 'web', and 'both'.
 *
 * The type 'flash' refers to flash local storage (SharedObject). In order
 * to use flash local storage, the 'api' parameter must be valid. The type
 * 'web' refers to WebStorage, if supported by the browser. The type 'both'
 * refers to storing using both 'flash' and 'web', not just one or the
 * other.
 *
 * The location array should list the storage types to use in order of
 * preference:
 *
 * ['flash']: flash only storage
 * ['web']: web only storage
 * ['both']: try to store in both
 * ['flash','web']: store in flash first, but if not available, 'web'
 * ['web','flash']: store in web first, but if not available, 'flash'
 *
 * The location array defaults to: ['web', 'flash']
 *
 * @param api the flash interface, null to use only WebStorage.
 * @param id the storage ID to use.
 * @param key the key for the item.
 * @param data the data for the item (any javascript object/primitive).
 * @param location an array with the preferred types of storage to use.
 */ $bc503c2c69c21e12$var$util.setItem = function(api, id, key, data, location) {
    $bc503c2c69c21e12$var$_callStorageFunction($bc503c2c69c21e12$var$_setItem, arguments, location);
};
/**
 * Gets an item on local disk.
 *
 * Set setItem() for details on storage types.
 *
 * @param api the flash interface, null to use only WebStorage.
 * @param id the storage ID to use.
 * @param key the key for the item.
 * @param location an array with the preferred types of storage to use.
 *
 * @return the item.
 */ $bc503c2c69c21e12$var$util.getItem = function(api, id, key, location) {
    return $bc503c2c69c21e12$var$_callStorageFunction($bc503c2c69c21e12$var$_getItem, arguments, location);
};
/**
 * Removes an item on local disk.
 *
 * Set setItem() for details on storage types.
 *
 * @param api the flash interface.
 * @param id the storage ID to use.
 * @param key the key for the item.
 * @param location an array with the preferred types of storage to use.
 */ $bc503c2c69c21e12$var$util.removeItem = function(api, id, key, location) {
    $bc503c2c69c21e12$var$_callStorageFunction($bc503c2c69c21e12$var$_removeItem, arguments, location);
};
/**
 * Clears the local disk storage identified by the given ID.
 *
 * Set setItem() for details on storage types.
 *
 * @param api the flash interface if flash is available.
 * @param id the storage ID to use.
 * @param location an array with the preferred types of storage to use.
 */ $bc503c2c69c21e12$var$util.clearItems = function(api, id, location) {
    $bc503c2c69c21e12$var$_callStorageFunction($bc503c2c69c21e12$var$_clearItems, arguments, location);
};
/**
 * Check if an object is empty.
 *
 * Taken from:
 * http://stackoverflow.com/questions/679915/how-do-i-test-for-an-empty-javascript-object-from-json/679937#679937
 *
 * @param object the object to check.
 */ $bc503c2c69c21e12$var$util.isEmpty = function(obj) {
    for(var prop in obj){
        if (obj.hasOwnProperty(prop)) return false;
    }
    return true;
};
/**
 * Format with simple printf-style interpolation.
 *
 * %%: literal '%'
 * %s,%o: convert next argument into a string.
 *
 * @param format the string to format.
 * @param ... arguments to interpolate into the format string.
 */ $bc503c2c69c21e12$var$util.format = function(format) {
    var re = /%./g;
    // current match
    var match;
    // current part
    var part;
    // current arg index
    var argi = 0;
    // collected parts to recombine later
    var parts = [];
    // last index found
    var last = 0;
    // loop while matches remain
    while(match = re.exec(format)){
        part = format.substring(last, re.lastIndex - 2);
        // don't add empty strings (ie, parts between %s%s)
        if (part.length > 0) parts.push(part);
        last = re.lastIndex;
        // switch on % code
        var code = match[0][1];
        switch(code){
            case "s":
            case "o":
                // check if enough arguments were given
                if (argi < arguments.length) parts.push(arguments[argi++ + 1]);
                else parts.push("<?>");
                break;
            // FIXME: do proper formating for numbers, etc
            //case 'f':
            //case 'd':
            case "%":
                parts.push("%");
                break;
            default:
                parts.push("<%" + code + "?>");
        }
    }
    // add trailing part of format string
    parts.push(format.substring(last));
    return parts.join("");
};
/**
 * Formats a number.
 *
 * http://snipplr.com/view/5945/javascript-numberformat--ported-from-php/
 */ $bc503c2c69c21e12$var$util.formatNumber = function(number, decimals, dec_point, thousands_sep) {
    // http://kevin.vanzonneveld.net
    // +   original by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
    // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // +     bugfix by: Michael White (http://crestidg.com)
    // +     bugfix by: Benjamin Lupton
    // +     bugfix by: Allan Jensen (http://www.winternet.no)
    // +    revised by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
    // *     example 1: number_format(1234.5678, 2, '.', '');
    // *     returns 1: 1234.57
    var n = number, c = isNaN(decimals = Math.abs(decimals)) ? 2 : decimals;
    var d = dec_point === undefined ? "," : dec_point;
    var t = thousands_sep === undefined ? "." : thousands_sep, s = n < 0 ? "-" : "";
    var i = parseInt(n = Math.abs(+n || 0).toFixed(c), 10) + "";
    var j = i.length > 3 ? i.length % 3 : 0;
    return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
};
/**
 * Formats a byte size.
 *
 * http://snipplr.com/view/5949/format-humanize-file-byte-size-presentation-in-javascript/
 */ $bc503c2c69c21e12$var$util.formatSize = function(size) {
    if (size >= 1073741824) size = $bc503c2c69c21e12$var$util.formatNumber(size / 1073741824, 2, ".", "") + " GiB";
    else if (size >= 1048576) size = $bc503c2c69c21e12$var$util.formatNumber(size / 1048576, 2, ".", "") + " MiB";
    else if (size >= 1024) size = $bc503c2c69c21e12$var$util.formatNumber(size / 1024, 0) + " KiB";
    else size = $bc503c2c69c21e12$var$util.formatNumber(size, 0) + " bytes";
    return size;
};
/**
 * Converts an IPv4 or IPv6 string representation into bytes (in network order).
 *
 * @param ip the IPv4 or IPv6 address to convert.
 *
 * @return the 4-byte IPv6 or 16-byte IPv6 address or null if the address can't
 *         be parsed.
 */ $bc503c2c69c21e12$var$util.bytesFromIP = function(ip) {
    if (ip.indexOf(".") !== -1) return $bc503c2c69c21e12$var$util.bytesFromIPv4(ip);
    if (ip.indexOf(":") !== -1) return $bc503c2c69c21e12$var$util.bytesFromIPv6(ip);
    return null;
};
/**
 * Converts an IPv4 string representation into bytes (in network order).
 *
 * @param ip the IPv4 address to convert.
 *
 * @return the 4-byte address or null if the address can't be parsed.
 */ $bc503c2c69c21e12$var$util.bytesFromIPv4 = function(ip) {
    ip = ip.split(".");
    if (ip.length !== 4) return null;
    var b = $bc503c2c69c21e12$var$util.createBuffer();
    for(var i = 0; i < ip.length; ++i){
        var num = parseInt(ip[i], 10);
        if (isNaN(num)) return null;
        b.putByte(num);
    }
    return b.getBytes();
};
/**
 * Converts an IPv6 string representation into bytes (in network order).
 *
 * @param ip the IPv6 address to convert.
 *
 * @return the 16-byte address or null if the address can't be parsed.
 */ $bc503c2c69c21e12$var$util.bytesFromIPv6 = function(ip) {
    var blanks = 0;
    ip = ip.split(":").filter(function(e) {
        if (e.length === 0) ++blanks;
        return true;
    });
    var zeros = (8 - ip.length + blanks) * 2;
    var b = $bc503c2c69c21e12$var$util.createBuffer();
    for(var i = 0; i < 8; ++i){
        if (!ip[i] || ip[i].length === 0) {
            b.fillWithByte(0, zeros);
            zeros = 0;
            continue;
        }
        var bytes = $bc503c2c69c21e12$var$util.hexToBytes(ip[i]);
        if (bytes.length < 2) b.putByte(0);
        b.putBytes(bytes);
    }
    return b.getBytes();
};
/**
 * Converts 4-bytes into an IPv4 string representation or 16-bytes into
 * an IPv6 string representation. The bytes must be in network order.
 *
 * @param bytes the bytes to convert.
 *
 * @return the IPv4 or IPv6 string representation if 4 or 16 bytes,
 *         respectively, are given, otherwise null.
 */ $bc503c2c69c21e12$var$util.bytesToIP = function(bytes) {
    if (bytes.length === 4) return $bc503c2c69c21e12$var$util.bytesToIPv4(bytes);
    if (bytes.length === 16) return $bc503c2c69c21e12$var$util.bytesToIPv6(bytes);
    return null;
};
/**
 * Converts 4-bytes into an IPv4 string representation. The bytes must be
 * in network order.
 *
 * @param bytes the bytes to convert.
 *
 * @return the IPv4 string representation or null for an invalid # of bytes.
 */ $bc503c2c69c21e12$var$util.bytesToIPv4 = function(bytes) {
    if (bytes.length !== 4) return null;
    var ip = [];
    for(var i = 0; i < bytes.length; ++i)ip.push(bytes.charCodeAt(i));
    return ip.join(".");
};
/**
 * Converts 16-bytes into an IPv16 string representation. The bytes must be
 * in network order.
 *
 * @param bytes the bytes to convert.
 *
 * @return the IPv16 string representation or null for an invalid # of bytes.
 */ $bc503c2c69c21e12$var$util.bytesToIPv6 = function(bytes) {
    if (bytes.length !== 16) return null;
    var ip = [];
    var zeroGroups = [];
    var zeroMaxGroup = 0;
    for(var i = 0; i < bytes.length; i += 2){
        var hex = $bc503c2c69c21e12$var$util.bytesToHex(bytes[i] + bytes[i + 1]);
        // canonicalize zero representation
        while(hex[0] === "0" && hex !== "0")hex = hex.substr(1);
        if (hex === "0") {
            var last = zeroGroups[zeroGroups.length - 1];
            var idx = ip.length;
            if (!last || idx !== last.end + 1) zeroGroups.push({
                start: idx,
                end: idx
            });
            else {
                last.end = idx;
                if (last.end - last.start > zeroGroups[zeroMaxGroup].end - zeroGroups[zeroMaxGroup].start) zeroMaxGroup = zeroGroups.length - 1;
            }
        }
        ip.push(hex);
    }
    if (zeroGroups.length > 0) {
        var group = zeroGroups[zeroMaxGroup];
        // only shorten group of length > 0
        if (group.end - group.start > 0) {
            ip.splice(group.start, group.end - group.start + 1, "");
            if (group.start === 0) ip.unshift("");
            if (group.end === 7) ip.push("");
        }
    }
    return ip.join(":");
};
/**
 * Estimates the number of processes that can be run concurrently. If
 * creating Web Workers, keep in mind that the main JavaScript process needs
 * its own core.
 *
 * @param options the options to use:
 *          update true to force an update (not use the cached value).
 * @param callback(err, max) called once the operation completes.
 */ $bc503c2c69c21e12$var$util.estimateCores = function(options, callback) {
    if (typeof options === "function") {
        callback = options;
        options = {};
    }
    options = options || {};
    if ("cores" in $bc503c2c69c21e12$var$util && !options.update) return callback(null, $bc503c2c69c21e12$var$util.cores);
    if (typeof navigator !== "undefined" && "hardwareConcurrency" in navigator && navigator.hardwareConcurrency > 0) {
        $bc503c2c69c21e12$var$util.cores = navigator.hardwareConcurrency;
        return callback(null, $bc503c2c69c21e12$var$util.cores);
    }
    if (typeof Worker === "undefined") {
        // workers not available
        $bc503c2c69c21e12$var$util.cores = 1;
        return callback(null, $bc503c2c69c21e12$var$util.cores);
    }
    if (typeof Blob === "undefined") {
        // can't estimate, default to 2
        $bc503c2c69c21e12$var$util.cores = 2;
        return callback(null, $bc503c2c69c21e12$var$util.cores);
    }
    // create worker concurrency estimation code as blob
    var blobUrl = URL.createObjectURL(new Blob([
        "(",
        (function() {
            self.addEventListener("message", function(e) {
                // run worker for 4 ms
                var st = Date.now();
                var et = st + 4;
                while(Date.now() < et);
                self.postMessage({
                    st: st,
                    et: et
                });
            });
        }).toString(),
        ")()"
    ], {
        type: "application/javascript"
    }));
    // take 5 samples using 16 workers
    sample([], 5, 16);
    function sample(max, samples, numWorkers) {
        if (samples === 0) {
            // get overlap average
            var avg = Math.floor(max.reduce(function(avg, x) {
                return avg + x;
            }, 0) / max.length);
            $bc503c2c69c21e12$var$util.cores = Math.max(1, avg);
            URL.revokeObjectURL(blobUrl);
            return callback(null, $bc503c2c69c21e12$var$util.cores);
        }
        map(numWorkers, function(err, results) {
            max.push(reduce(numWorkers, results));
            sample(max, samples - 1, numWorkers);
        });
    }
    function map(numWorkers, callback) {
        var workers = [];
        var results = [];
        for(var i = 0; i < numWorkers; ++i){
            var worker = new Worker(blobUrl);
            worker.addEventListener("message", function(e) {
                results.push(e.data);
                if (results.length === numWorkers) {
                    for(var i = 0; i < numWorkers; ++i)workers[i].terminate();
                    callback(null, results);
                }
            });
            workers.push(worker);
        }
        for(var i = 0; i < numWorkers; ++i)workers[i].postMessage(i);
    }
    function reduce(numWorkers, results) {
        // find overlapping time windows
        var overlaps = [];
        for(var n = 0; n < numWorkers; ++n){
            var r1 = results[n];
            var overlap = overlaps[n] = [];
            for(var i = 0; i < numWorkers; ++i){
                if (n === i) continue;
                var r2 = results[i];
                if (r1.st > r2.st && r1.st < r2.et || r2.st > r1.st && r2.st < r1.et) overlap.push(i);
            }
        }
        // get maximum overlaps ... don't include overlapping worker itself
        // as the main JS process was also being scheduled during the work and
        // would have to be subtracted from the estimate anyway
        return overlaps.reduce(function(max, overlap) {
            return Math.max(max, overlap.length);
        }, 0);
    }
};

});
parcelRegister("fu0iC", function(module, exports) {
/**
 * Base-N/Base-X encoding/decoding functions.
 *
 * Original implementation from base-x:
 * https://github.com/cryptocoinjs/base-x
 *
 * Which is MIT licensed:
 *
 * The MIT License (MIT)
 *
 * Copyright base-x contributors (c) 2016
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
 * DEALINGS IN THE SOFTWARE.
 */ 
var $9dH9K = parcelRequire("9dH9K");
var $b459e3cec52ce7aa$require$Buffer = $9dH9K.Buffer;
var $b459e3cec52ce7aa$var$api = {};
module.exports = $b459e3cec52ce7aa$var$api;
// baseN alphabet indexes
var $b459e3cec52ce7aa$var$_reverseAlphabets = {};
/**
 * BaseN-encodes a Uint8Array using the given alphabet.
 *
 * @param input the Uint8Array to encode.
 * @param maxline the maximum number of encoded characters per line to use,
 *          defaults to none.
 *
 * @return the baseN-encoded output string.
 */ $b459e3cec52ce7aa$var$api.encode = function(input, alphabet, maxline) {
    if (typeof alphabet !== "string") throw new TypeError('"alphabet" must be a string.');
    if (maxline !== undefined && typeof maxline !== "number") throw new TypeError('"maxline" must be a number.');
    var output = "";
    if (!(input instanceof Uint8Array)) // assume forge byte buffer
    output = $b459e3cec52ce7aa$var$_encodeWithByteBuffer(input, alphabet);
    else {
        var i = 0;
        var base = alphabet.length;
        var first = alphabet.charAt(0);
        var digits = [
            0
        ];
        for(i = 0; i < input.length; ++i){
            for(var j = 0, carry = input[i]; j < digits.length; ++j){
                carry += digits[j] << 8;
                digits[j] = carry % base;
                carry = carry / base | 0;
            }
            while(carry > 0){
                digits.push(carry % base);
                carry = carry / base | 0;
            }
        }
        // deal with leading zeros
        for(i = 0; input[i] === 0 && i < input.length - 1; ++i)output += first;
        // convert digits to a string
        for(i = digits.length - 1; i >= 0; --i)output += alphabet[digits[i]];
    }
    if (maxline) {
        var regex = new RegExp(".{1," + maxline + "}", "g");
        output = output.match(regex).join("\r\n");
    }
    return output;
};
/**
 * Decodes a baseN-encoded (using the given alphabet) string to a
 * Uint8Array.
 *
 * @param input the baseN-encoded input string.
 *
 * @return the Uint8Array.
 */ $b459e3cec52ce7aa$var$api.decode = function(input, alphabet) {
    if (typeof input !== "string") throw new TypeError('"input" must be a string.');
    if (typeof alphabet !== "string") throw new TypeError('"alphabet" must be a string.');
    var table = $b459e3cec52ce7aa$var$_reverseAlphabets[alphabet];
    if (!table) {
        // compute reverse alphabet
        table = $b459e3cec52ce7aa$var$_reverseAlphabets[alphabet] = [];
        for(var i = 0; i < alphabet.length; ++i)table[alphabet.charCodeAt(i)] = i;
    }
    // remove whitespace characters
    input = input.replace(/\s/g, "");
    var base = alphabet.length;
    var first = alphabet.charAt(0);
    var bytes = [
        0
    ];
    for(var i = 0; i < input.length; i++){
        var value = table[input.charCodeAt(i)];
        if (value === undefined) return;
        for(var j = 0, carry = value; j < bytes.length; ++j){
            carry += bytes[j] * base;
            bytes[j] = carry & 0xff;
            carry >>= 8;
        }
        while(carry > 0){
            bytes.push(carry & 0xff);
            carry >>= 8;
        }
    }
    // deal with leading zeros
    for(var k = 0; input[k] === first && k < input.length - 1; ++k)bytes.push(0);
    if (typeof $b459e3cec52ce7aa$require$Buffer !== "undefined") return $b459e3cec52ce7aa$require$Buffer.from(bytes.reverse());
    return new Uint8Array(bytes.reverse());
};
function $b459e3cec52ce7aa$var$_encodeWithByteBuffer(input, alphabet) {
    var i = 0;
    var base = alphabet.length;
    var first = alphabet.charAt(0);
    var digits = [
        0
    ];
    for(i = 0; i < input.length(); ++i){
        for(var j = 0, carry = input.at(i); j < digits.length; ++j){
            carry += digits[j] << 8;
            digits[j] = carry % base;
            carry = carry / base | 0;
        }
        while(carry > 0){
            digits.push(carry % base);
            carry = carry / base | 0;
        }
    }
    var output = "";
    // deal with leading zeros
    for(i = 0; input.at(i) === 0 && i < input.length() - 1; ++i)output += first;
    // convert digits to a string
    for(i = digits.length - 1; i >= 0; --i)output += alphabet[digits[i]];
    return output;
}

});



parcelRegister("2hAcz", function(module, exports) {
/**
 * Supported cipher modes.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2014 Digital Bazaar, Inc.
 */ 
var $fz7FM = parcelRequire("fz7FM");
parcelRequire("gao36");
$fz7FM.cipher = $fz7FM.cipher || {};
// supported cipher modes
var $1a99403691088acd$var$modes = module.exports = $fz7FM.cipher.modes = $fz7FM.cipher.modes || {};
/** Electronic codebook (ECB) (Don't use this; it's not secure) **/ $1a99403691088acd$var$modes.ecb = function(options) {
    options = options || {};
    this.name = "ECB";
    this.cipher = options.cipher;
    this.blockSize = options.blockSize || 16;
    this._ints = this.blockSize / 4;
    this._inBlock = new Array(this._ints);
    this._outBlock = new Array(this._ints);
};
$1a99403691088acd$var$modes.ecb.prototype.start = function(options) {};
$1a99403691088acd$var$modes.ecb.prototype.encrypt = function(input, output, finish) {
    // not enough input to encrypt
    if (input.length() < this.blockSize && !(finish && input.length() > 0)) return true;
    // get next block
    for(var i = 0; i < this._ints; ++i)this._inBlock[i] = input.getInt32();
    // encrypt block
    this.cipher.encrypt(this._inBlock, this._outBlock);
    // write output
    for(var i = 0; i < this._ints; ++i)output.putInt32(this._outBlock[i]);
};
$1a99403691088acd$var$modes.ecb.prototype.decrypt = function(input, output, finish) {
    // not enough input to decrypt
    if (input.length() < this.blockSize && !(finish && input.length() > 0)) return true;
    // get next block
    for(var i = 0; i < this._ints; ++i)this._inBlock[i] = input.getInt32();
    // decrypt block
    this.cipher.decrypt(this._inBlock, this._outBlock);
    // write output
    for(var i = 0; i < this._ints; ++i)output.putInt32(this._outBlock[i]);
};
$1a99403691088acd$var$modes.ecb.prototype.pad = function(input, options) {
    // add PKCS#7 padding to block (each pad byte is the
    // value of the number of pad bytes)
    var padding = input.length() === this.blockSize ? this.blockSize : this.blockSize - input.length();
    input.fillWithByte(padding, padding);
    return true;
};
$1a99403691088acd$var$modes.ecb.prototype.unpad = function(output, options) {
    // check for error: input data not a multiple of blockSize
    if (options.overflow > 0) return false;
    // ensure padding byte count is valid
    var len = output.length();
    var count = output.at(len - 1);
    if (count > this.blockSize << 2) return false;
    // trim off padding bytes
    output.truncate(count);
    return true;
};
/** Cipher-block Chaining (CBC) **/ $1a99403691088acd$var$modes.cbc = function(options) {
    options = options || {};
    this.name = "CBC";
    this.cipher = options.cipher;
    this.blockSize = options.blockSize || 16;
    this._ints = this.blockSize / 4;
    this._inBlock = new Array(this._ints);
    this._outBlock = new Array(this._ints);
};
$1a99403691088acd$var$modes.cbc.prototype.start = function(options) {
    // Note: legacy support for using IV residue (has security flaws)
    // if IV is null, reuse block from previous processing
    if (options.iv === null) {
        // must have a previous block
        if (!this._prev) throw new Error("Invalid IV parameter.");
        this._iv = this._prev.slice(0);
    } else if (!("iv" in options)) throw new Error("Invalid IV parameter.");
    else {
        // save IV as "previous" block
        this._iv = $1a99403691088acd$var$transformIV(options.iv, this.blockSize);
        this._prev = this._iv.slice(0);
    }
};
$1a99403691088acd$var$modes.cbc.prototype.encrypt = function(input, output, finish) {
    // not enough input to encrypt
    if (input.length() < this.blockSize && !(finish && input.length() > 0)) return true;
    // get next block
    // CBC XOR's IV (or previous block) with plaintext
    for(var i = 0; i < this._ints; ++i)this._inBlock[i] = this._prev[i] ^ input.getInt32();
    // encrypt block
    this.cipher.encrypt(this._inBlock, this._outBlock);
    // write output, save previous block
    for(var i = 0; i < this._ints; ++i)output.putInt32(this._outBlock[i]);
    this._prev = this._outBlock;
};
$1a99403691088acd$var$modes.cbc.prototype.decrypt = function(input, output, finish) {
    // not enough input to decrypt
    if (input.length() < this.blockSize && !(finish && input.length() > 0)) return true;
    // get next block
    for(var i = 0; i < this._ints; ++i)this._inBlock[i] = input.getInt32();
    // decrypt block
    this.cipher.decrypt(this._inBlock, this._outBlock);
    // write output, save previous ciphered block
    // CBC XOR's IV (or previous block) with ciphertext
    for(var i = 0; i < this._ints; ++i)output.putInt32(this._prev[i] ^ this._outBlock[i]);
    this._prev = this._inBlock.slice(0);
};
$1a99403691088acd$var$modes.cbc.prototype.pad = function(input, options) {
    // add PKCS#7 padding to block (each pad byte is the
    // value of the number of pad bytes)
    var padding = input.length() === this.blockSize ? this.blockSize : this.blockSize - input.length();
    input.fillWithByte(padding, padding);
    return true;
};
$1a99403691088acd$var$modes.cbc.prototype.unpad = function(output, options) {
    // check for error: input data not a multiple of blockSize
    if (options.overflow > 0) return false;
    // ensure padding byte count is valid
    var len = output.length();
    var count = output.at(len - 1);
    if (count > this.blockSize << 2) return false;
    // trim off padding bytes
    output.truncate(count);
    return true;
};
/** Cipher feedback (CFB) **/ $1a99403691088acd$var$modes.cfb = function(options) {
    options = options || {};
    this.name = "CFB";
    this.cipher = options.cipher;
    this.blockSize = options.blockSize || 16;
    this._ints = this.blockSize / 4;
    this._inBlock = null;
    this._outBlock = new Array(this._ints);
    this._partialBlock = new Array(this._ints);
    this._partialOutput = $fz7FM.util.createBuffer();
    this._partialBytes = 0;
};
$1a99403691088acd$var$modes.cfb.prototype.start = function(options) {
    if (!("iv" in options)) throw new Error("Invalid IV parameter.");
    // use IV as first input
    this._iv = $1a99403691088acd$var$transformIV(options.iv, this.blockSize);
    this._inBlock = this._iv.slice(0);
    this._partialBytes = 0;
};
$1a99403691088acd$var$modes.cfb.prototype.encrypt = function(input, output, finish) {
    // not enough input to encrypt
    var inputLength = input.length();
    if (inputLength === 0) return true;
    // encrypt block
    this.cipher.encrypt(this._inBlock, this._outBlock);
    // handle full block
    if (this._partialBytes === 0 && inputLength >= this.blockSize) {
        // XOR input with output, write input as output
        for(var i = 0; i < this._ints; ++i){
            this._inBlock[i] = input.getInt32() ^ this._outBlock[i];
            output.putInt32(this._inBlock[i]);
        }
        return;
    }
    // handle partial block
    var partialBytes = (this.blockSize - inputLength) % this.blockSize;
    if (partialBytes > 0) partialBytes = this.blockSize - partialBytes;
    // XOR input with output, write input as partial output
    this._partialOutput.clear();
    for(var i = 0; i < this._ints; ++i){
        this._partialBlock[i] = input.getInt32() ^ this._outBlock[i];
        this._partialOutput.putInt32(this._partialBlock[i]);
    }
    if (partialBytes > 0) // block still incomplete, restore input buffer
    input.read -= this.blockSize;
    else // block complete, update input block
    for(var i = 0; i < this._ints; ++i)this._inBlock[i] = this._partialBlock[i];
    // skip any previous partial bytes
    if (this._partialBytes > 0) this._partialOutput.getBytes(this._partialBytes);
    if (partialBytes > 0 && !finish) {
        output.putBytes(this._partialOutput.getBytes(partialBytes - this._partialBytes));
        this._partialBytes = partialBytes;
        return true;
    }
    output.putBytes(this._partialOutput.getBytes(inputLength - this._partialBytes));
    this._partialBytes = 0;
};
$1a99403691088acd$var$modes.cfb.prototype.decrypt = function(input, output, finish) {
    // not enough input to decrypt
    var inputLength = input.length();
    if (inputLength === 0) return true;
    // encrypt block (CFB always uses encryption mode)
    this.cipher.encrypt(this._inBlock, this._outBlock);
    // handle full block
    if (this._partialBytes === 0 && inputLength >= this.blockSize) {
        // XOR input with output, write input as output
        for(var i = 0; i < this._ints; ++i){
            this._inBlock[i] = input.getInt32();
            output.putInt32(this._inBlock[i] ^ this._outBlock[i]);
        }
        return;
    }
    // handle partial block
    var partialBytes = (this.blockSize - inputLength) % this.blockSize;
    if (partialBytes > 0) partialBytes = this.blockSize - partialBytes;
    // XOR input with output, write input as partial output
    this._partialOutput.clear();
    for(var i = 0; i < this._ints; ++i){
        this._partialBlock[i] = input.getInt32();
        this._partialOutput.putInt32(this._partialBlock[i] ^ this._outBlock[i]);
    }
    if (partialBytes > 0) // block still incomplete, restore input buffer
    input.read -= this.blockSize;
    else // block complete, update input block
    for(var i = 0; i < this._ints; ++i)this._inBlock[i] = this._partialBlock[i];
    // skip any previous partial bytes
    if (this._partialBytes > 0) this._partialOutput.getBytes(this._partialBytes);
    if (partialBytes > 0 && !finish) {
        output.putBytes(this._partialOutput.getBytes(partialBytes - this._partialBytes));
        this._partialBytes = partialBytes;
        return true;
    }
    output.putBytes(this._partialOutput.getBytes(inputLength - this._partialBytes));
    this._partialBytes = 0;
};
/** Output feedback (OFB) **/ $1a99403691088acd$var$modes.ofb = function(options) {
    options = options || {};
    this.name = "OFB";
    this.cipher = options.cipher;
    this.blockSize = options.blockSize || 16;
    this._ints = this.blockSize / 4;
    this._inBlock = null;
    this._outBlock = new Array(this._ints);
    this._partialOutput = $fz7FM.util.createBuffer();
    this._partialBytes = 0;
};
$1a99403691088acd$var$modes.ofb.prototype.start = function(options) {
    if (!("iv" in options)) throw new Error("Invalid IV parameter.");
    // use IV as first input
    this._iv = $1a99403691088acd$var$transformIV(options.iv, this.blockSize);
    this._inBlock = this._iv.slice(0);
    this._partialBytes = 0;
};
$1a99403691088acd$var$modes.ofb.prototype.encrypt = function(input, output, finish) {
    // not enough input to encrypt
    var inputLength = input.length();
    if (input.length() === 0) return true;
    // encrypt block (OFB always uses encryption mode)
    this.cipher.encrypt(this._inBlock, this._outBlock);
    // handle full block
    if (this._partialBytes === 0 && inputLength >= this.blockSize) {
        // XOR input with output and update next input
        for(var i = 0; i < this._ints; ++i){
            output.putInt32(input.getInt32() ^ this._outBlock[i]);
            this._inBlock[i] = this._outBlock[i];
        }
        return;
    }
    // handle partial block
    var partialBytes = (this.blockSize - inputLength) % this.blockSize;
    if (partialBytes > 0) partialBytes = this.blockSize - partialBytes;
    // XOR input with output
    this._partialOutput.clear();
    for(var i = 0; i < this._ints; ++i)this._partialOutput.putInt32(input.getInt32() ^ this._outBlock[i]);
    if (partialBytes > 0) // block still incomplete, restore input buffer
    input.read -= this.blockSize;
    else // block complete, update input block
    for(var i = 0; i < this._ints; ++i)this._inBlock[i] = this._outBlock[i];
    // skip any previous partial bytes
    if (this._partialBytes > 0) this._partialOutput.getBytes(this._partialBytes);
    if (partialBytes > 0 && !finish) {
        output.putBytes(this._partialOutput.getBytes(partialBytes - this._partialBytes));
        this._partialBytes = partialBytes;
        return true;
    }
    output.putBytes(this._partialOutput.getBytes(inputLength - this._partialBytes));
    this._partialBytes = 0;
};
$1a99403691088acd$var$modes.ofb.prototype.decrypt = $1a99403691088acd$var$modes.ofb.prototype.encrypt;
/** Counter (CTR) **/ $1a99403691088acd$var$modes.ctr = function(options) {
    options = options || {};
    this.name = "CTR";
    this.cipher = options.cipher;
    this.blockSize = options.blockSize || 16;
    this._ints = this.blockSize / 4;
    this._inBlock = null;
    this._outBlock = new Array(this._ints);
    this._partialOutput = $fz7FM.util.createBuffer();
    this._partialBytes = 0;
};
$1a99403691088acd$var$modes.ctr.prototype.start = function(options) {
    if (!("iv" in options)) throw new Error("Invalid IV parameter.");
    // use IV as first input
    this._iv = $1a99403691088acd$var$transformIV(options.iv, this.blockSize);
    this._inBlock = this._iv.slice(0);
    this._partialBytes = 0;
};
$1a99403691088acd$var$modes.ctr.prototype.encrypt = function(input, output, finish) {
    // not enough input to encrypt
    var inputLength = input.length();
    if (inputLength === 0) return true;
    // encrypt block (CTR always uses encryption mode)
    this.cipher.encrypt(this._inBlock, this._outBlock);
    // handle full block
    if (this._partialBytes === 0 && inputLength >= this.blockSize) // XOR input with output
    for(var i = 0; i < this._ints; ++i)output.putInt32(input.getInt32() ^ this._outBlock[i]);
    else {
        // handle partial block
        var partialBytes = (this.blockSize - inputLength) % this.blockSize;
        if (partialBytes > 0) partialBytes = this.blockSize - partialBytes;
        // XOR input with output
        this._partialOutput.clear();
        for(var i = 0; i < this._ints; ++i)this._partialOutput.putInt32(input.getInt32() ^ this._outBlock[i]);
        if (partialBytes > 0) // block still incomplete, restore input buffer
        input.read -= this.blockSize;
        // skip any previous partial bytes
        if (this._partialBytes > 0) this._partialOutput.getBytes(this._partialBytes);
        if (partialBytes > 0 && !finish) {
            output.putBytes(this._partialOutput.getBytes(partialBytes - this._partialBytes));
            this._partialBytes = partialBytes;
            return true;
        }
        output.putBytes(this._partialOutput.getBytes(inputLength - this._partialBytes));
        this._partialBytes = 0;
    }
    // block complete, increment counter (input block)
    $1a99403691088acd$var$inc32(this._inBlock);
};
$1a99403691088acd$var$modes.ctr.prototype.decrypt = $1a99403691088acd$var$modes.ctr.prototype.encrypt;
/** Galois/Counter Mode (GCM) **/ $1a99403691088acd$var$modes.gcm = function(options) {
    options = options || {};
    this.name = "GCM";
    this.cipher = options.cipher;
    this.blockSize = options.blockSize || 16;
    this._ints = this.blockSize / 4;
    this._inBlock = new Array(this._ints);
    this._outBlock = new Array(this._ints);
    this._partialOutput = $fz7FM.util.createBuffer();
    this._partialBytes = 0;
    // R is actually this value concatenated with 120 more zero bits, but
    // we only XOR against R so the other zeros have no effect -- we just
    // apply this value to the first integer in a block
    this._R = 0xE1000000;
};
$1a99403691088acd$var$modes.gcm.prototype.start = function(options) {
    if (!("iv" in options)) throw new Error("Invalid IV parameter.");
    // ensure IV is a byte buffer
    var iv = $fz7FM.util.createBuffer(options.iv);
    // no ciphered data processed yet
    this._cipherLength = 0;
    // default additional data is none
    var additionalData;
    if ("additionalData" in options) additionalData = $fz7FM.util.createBuffer(options.additionalData);
    else additionalData = $fz7FM.util.createBuffer();
    // default tag length is 128 bits
    if ("tagLength" in options) this._tagLength = options.tagLength;
    else this._tagLength = 128;
    // if tag is given, ensure tag matches tag length
    this._tag = null;
    if (options.decrypt) {
        // save tag to check later
        this._tag = $fz7FM.util.createBuffer(options.tag).getBytes();
        if (this._tag.length !== this._tagLength / 8) throw new Error("Authentication tag does not match tag length.");
    }
    // create tmp storage for hash calculation
    this._hashBlock = new Array(this._ints);
    // no tag generated yet
    this.tag = null;
    // generate hash subkey
    // (apply block cipher to "zero" block)
    this._hashSubkey = new Array(this._ints);
    this.cipher.encrypt([
        0,
        0,
        0,
        0
    ], this._hashSubkey);
    // generate table M
    // use 4-bit tables (32 component decomposition of a 16 byte value)
    // 8-bit tables take more space and are known to have security
    // vulnerabilities (in native implementations)
    this.componentBits = 4;
    this._m = this.generateHashTable(this._hashSubkey, this.componentBits);
    // Note: support IV length different from 96 bits? (only supporting
    // 96 bits is recommended by NIST SP-800-38D)
    // generate J_0
    var ivLength = iv.length();
    if (ivLength === 12) // 96-bit IV
    this._j0 = [
        iv.getInt32(),
        iv.getInt32(),
        iv.getInt32(),
        1
    ];
    else {
        // IV is NOT 96-bits
        this._j0 = [
            0,
            0,
            0,
            0
        ];
        while(iv.length() > 0)this._j0 = this.ghash(this._hashSubkey, this._j0, [
            iv.getInt32(),
            iv.getInt32(),
            iv.getInt32(),
            iv.getInt32()
        ]);
        this._j0 = this.ghash(this._hashSubkey, this._j0, [
            0,
            0
        ].concat($1a99403691088acd$var$from64To32(ivLength * 8)));
    }
    // generate ICB (initial counter block)
    this._inBlock = this._j0.slice(0);
    $1a99403691088acd$var$inc32(this._inBlock);
    this._partialBytes = 0;
    // consume authentication data
    additionalData = $fz7FM.util.createBuffer(additionalData);
    // save additional data length as a BE 64-bit number
    this._aDataLength = $1a99403691088acd$var$from64To32(additionalData.length() * 8);
    // pad additional data to 128 bit (16 byte) block size
    var overflow = additionalData.length() % this.blockSize;
    if (overflow) additionalData.fillWithByte(0, this.blockSize - overflow);
    this._s = [
        0,
        0,
        0,
        0
    ];
    while(additionalData.length() > 0)this._s = this.ghash(this._hashSubkey, this._s, [
        additionalData.getInt32(),
        additionalData.getInt32(),
        additionalData.getInt32(),
        additionalData.getInt32()
    ]);
};
$1a99403691088acd$var$modes.gcm.prototype.encrypt = function(input, output, finish) {
    // not enough input to encrypt
    var inputLength = input.length();
    if (inputLength === 0) return true;
    // encrypt block
    this.cipher.encrypt(this._inBlock, this._outBlock);
    // handle full block
    if (this._partialBytes === 0 && inputLength >= this.blockSize) {
        // XOR input with output
        for(var i = 0; i < this._ints; ++i)output.putInt32(this._outBlock[i] ^= input.getInt32());
        this._cipherLength += this.blockSize;
    } else {
        // handle partial block
        var partialBytes = (this.blockSize - inputLength) % this.blockSize;
        if (partialBytes > 0) partialBytes = this.blockSize - partialBytes;
        // XOR input with output
        this._partialOutput.clear();
        for(var i = 0; i < this._ints; ++i)this._partialOutput.putInt32(input.getInt32() ^ this._outBlock[i]);
        if (partialBytes <= 0 || finish) {
            // handle overflow prior to hashing
            if (finish) {
                // get block overflow
                var overflow = inputLength % this.blockSize;
                this._cipherLength += overflow;
                // truncate for hash function
                this._partialOutput.truncate(this.blockSize - overflow);
            } else this._cipherLength += this.blockSize;
            // get output block for hashing
            for(var i = 0; i < this._ints; ++i)this._outBlock[i] = this._partialOutput.getInt32();
            this._partialOutput.read -= this.blockSize;
        }
        // skip any previous partial bytes
        if (this._partialBytes > 0) this._partialOutput.getBytes(this._partialBytes);
        if (partialBytes > 0 && !finish) {
            // block still incomplete, restore input buffer, get partial output,
            // and return early
            input.read -= this.blockSize;
            output.putBytes(this._partialOutput.getBytes(partialBytes - this._partialBytes));
            this._partialBytes = partialBytes;
            return true;
        }
        output.putBytes(this._partialOutput.getBytes(inputLength - this._partialBytes));
        this._partialBytes = 0;
    }
    // update hash block S
    this._s = this.ghash(this._hashSubkey, this._s, this._outBlock);
    // increment counter (input block)
    $1a99403691088acd$var$inc32(this._inBlock);
};
$1a99403691088acd$var$modes.gcm.prototype.decrypt = function(input, output, finish) {
    // not enough input to decrypt
    var inputLength = input.length();
    if (inputLength < this.blockSize && !(finish && inputLength > 0)) return true;
    // encrypt block (GCM always uses encryption mode)
    this.cipher.encrypt(this._inBlock, this._outBlock);
    // increment counter (input block)
    $1a99403691088acd$var$inc32(this._inBlock);
    // update hash block S
    this._hashBlock[0] = input.getInt32();
    this._hashBlock[1] = input.getInt32();
    this._hashBlock[2] = input.getInt32();
    this._hashBlock[3] = input.getInt32();
    this._s = this.ghash(this._hashSubkey, this._s, this._hashBlock);
    // XOR hash input with output
    for(var i = 0; i < this._ints; ++i)output.putInt32(this._outBlock[i] ^ this._hashBlock[i]);
    // increment cipher data length
    if (inputLength < this.blockSize) this._cipherLength += inputLength % this.blockSize;
    else this._cipherLength += this.blockSize;
};
$1a99403691088acd$var$modes.gcm.prototype.afterFinish = function(output, options) {
    var rval = true;
    // handle overflow
    if (options.decrypt && options.overflow) output.truncate(this.blockSize - options.overflow);
    // handle authentication tag
    this.tag = $fz7FM.util.createBuffer();
    // concatenate additional data length with cipher length
    var lengths = this._aDataLength.concat($1a99403691088acd$var$from64To32(this._cipherLength * 8));
    // include lengths in hash
    this._s = this.ghash(this._hashSubkey, this._s, lengths);
    // do GCTR(J_0, S)
    var tag = [];
    this.cipher.encrypt(this._j0, tag);
    for(var i = 0; i < this._ints; ++i)this.tag.putInt32(this._s[i] ^ tag[i]);
    // trim tag to length
    this.tag.truncate(this.tag.length() % (this._tagLength / 8));
    // check authentication tag
    if (options.decrypt && this.tag.bytes() !== this._tag) rval = false;
    return rval;
};
/**
 * See NIST SP-800-38D 6.3 (Algorithm 1). This function performs Galois
 * field multiplication. The field, GF(2^128), is defined by the polynomial:
 *
 * x^128 + x^7 + x^2 + x + 1
 *
 * Which is represented in little-endian binary form as: 11100001 (0xe1). When
 * the value of a coefficient is 1, a bit is set. The value R, is the
 * concatenation of this value and 120 zero bits, yielding a 128-bit value
 * which matches the block size.
 *
 * This function will multiply two elements (vectors of bytes), X and Y, in
 * the field GF(2^128). The result is initialized to zero. For each bit of
 * X (out of 128), x_i, if x_i is set, then the result is multiplied (XOR'd)
 * by the current value of Y. For each bit, the value of Y will be raised by
 * a power of x (multiplied by the polynomial x). This can be achieved by
 * shifting Y once to the right. If the current value of Y, prior to being
 * multiplied by x, has 0 as its LSB, then it is a 127th degree polynomial.
 * Otherwise, we must divide by R after shifting to find the remainder.
 *
 * @param x the first block to multiply by the second.
 * @param y the second block to multiply by the first.
 *
 * @return the block result of the multiplication.
 */ $1a99403691088acd$var$modes.gcm.prototype.multiply = function(x, y) {
    var z_i = [
        0,
        0,
        0,
        0
    ];
    var v_i = y.slice(0);
    // calculate Z_128 (block has 128 bits)
    for(var i = 0; i < 128; ++i){
        // if x_i is 0, Z_{i+1} = Z_i (unchanged)
        // else Z_{i+1} = Z_i ^ V_i
        // get x_i by finding 32-bit int position, then left shift 1 by remainder
        var x_i = x[i / 32 | 0] & 1 << 31 - i % 32;
        if (x_i) {
            z_i[0] ^= v_i[0];
            z_i[1] ^= v_i[1];
            z_i[2] ^= v_i[2];
            z_i[3] ^= v_i[3];
        }
        // if LSB(V_i) is 1, V_i = V_i >> 1
        // else V_i = (V_i >> 1) ^ R
        this.pow(v_i, v_i);
    }
    return z_i;
};
$1a99403691088acd$var$modes.gcm.prototype.pow = function(x, out) {
    // if LSB(x) is 1, x = x >>> 1
    // else x = (x >>> 1) ^ R
    var lsb = x[3] & 1;
    // always do x >>> 1:
    // starting with the rightmost integer, shift each integer to the right
    // one bit, pulling in the bit from the integer to the left as its top
    // most bit (do this for the last 3 integers)
    for(var i = 3; i > 0; --i)out[i] = x[i] >>> 1 | (x[i - 1] & 1) << 31;
    // shift the first integer normally
    out[0] = x[0] >>> 1;
    // if lsb was not set, then polynomial had a degree of 127 and doesn't
    // need to divided; otherwise, XOR with R to find the remainder; we only
    // need to XOR the first integer since R technically ends w/120 zero bits
    if (lsb) out[0] ^= this._R;
};
$1a99403691088acd$var$modes.gcm.prototype.tableMultiply = function(x) {
    // assumes 4-bit tables are used
    var z = [
        0,
        0,
        0,
        0
    ];
    for(var i = 0; i < 32; ++i){
        var idx = i / 8 | 0;
        var x_i = x[idx] >>> (7 - i % 8) * 4 & 0xF;
        var ah = this._m[i][x_i];
        z[0] ^= ah[0];
        z[1] ^= ah[1];
        z[2] ^= ah[2];
        z[3] ^= ah[3];
    }
    return z;
};
/**
 * A continuing version of the GHASH algorithm that operates on a single
 * block. The hash block, last hash value (Ym) and the new block to hash
 * are given.
 *
 * @param h the hash block.
 * @param y the previous value for Ym, use [0, 0, 0, 0] for a new hash.
 * @param x the block to hash.
 *
 * @return the hashed value (Ym).
 */ $1a99403691088acd$var$modes.gcm.prototype.ghash = function(h, y, x) {
    y[0] ^= x[0];
    y[1] ^= x[1];
    y[2] ^= x[2];
    y[3] ^= x[3];
    return this.tableMultiply(y);
//return this.multiply(y, h);
};
/**
 * Precomputes a table for multiplying against the hash subkey. This
 * mechanism provides a substantial speed increase over multiplication
 * performed without a table. The table-based multiplication this table is
 * for solves X * H by multiplying each component of X by H and then
 * composing the results together using XOR.
 *
 * This function can be used to generate tables with different bit sizes
 * for the components, however, this implementation assumes there are
 * 32 components of X (which is a 16 byte vector), therefore each component
 * takes 4-bits (so the table is constructed with bits=4).
 *
 * @param h the hash subkey.
 * @param bits the bit size for a component.
 */ $1a99403691088acd$var$modes.gcm.prototype.generateHashTable = function(h, bits) {
    // TODO: There are further optimizations that would use only the
    // first table M_0 (or some variant) along with a remainder table;
    // this can be explored in the future
    var multiplier = 8 / bits;
    var perInt = 4 * multiplier;
    var size = 16 * multiplier;
    var m = new Array(size);
    for(var i = 0; i < size; ++i){
        var tmp = [
            0,
            0,
            0,
            0
        ];
        var idx = i / perInt | 0;
        var shft = (perInt - 1 - i % perInt) * bits;
        tmp[idx] = 1 << bits - 1 << shft;
        m[i] = this.generateSubHashTable(this.multiply(tmp, h), bits);
    }
    return m;
};
/**
 * Generates a table for multiplying against the hash subkey for one
 * particular component (out of all possible component values).
 *
 * @param mid the pre-multiplied value for the middle key of the table.
 * @param bits the bit size for a component.
 */ $1a99403691088acd$var$modes.gcm.prototype.generateSubHashTable = function(mid, bits) {
    // compute the table quickly by minimizing the number of
    // POW operations -- they only need to be performed for powers of 2,
    // all other entries can be composed from those powers using XOR
    var size = 1 << bits;
    var half = size >>> 1;
    var m = new Array(size);
    m[half] = mid.slice(0);
    var i = half >>> 1;
    while(i > 0){
        // raise m0[2 * i] and store in m0[i]
        this.pow(m[2 * i], m[i] = []);
        i >>= 1;
    }
    i = 2;
    while(i < half){
        for(var j = 1; j < i; ++j){
            var m_i = m[i];
            var m_j = m[j];
            m[i + j] = [
                m_i[0] ^ m_j[0],
                m_i[1] ^ m_j[1],
                m_i[2] ^ m_j[2],
                m_i[3] ^ m_j[3]
            ];
        }
        i *= 2;
    }
    m[0] = [
        0,
        0,
        0,
        0
    ];
    /* Note: We could avoid storing these by doing composition during multiply
  calculate top half using composition by speed is preferred. */ for(i = half + 1; i < size; ++i){
        var c = m[i ^ half];
        m[i] = [
            mid[0] ^ c[0],
            mid[1] ^ c[1],
            mid[2] ^ c[2],
            mid[3] ^ c[3]
        ];
    }
    return m;
};
/** Utility functions */ function $1a99403691088acd$var$transformIV(iv, blockSize) {
    if (typeof iv === "string") // convert iv string into byte buffer
    iv = $fz7FM.util.createBuffer(iv);
    if ($fz7FM.util.isArray(iv) && iv.length > 4) {
        // convert iv byte array into byte buffer
        var tmp = iv;
        iv = $fz7FM.util.createBuffer();
        for(var i = 0; i < tmp.length; ++i)iv.putByte(tmp[i]);
    }
    if (iv.length() < blockSize) throw new Error("Invalid IV length; got " + iv.length() + " bytes and expected " + blockSize + " bytes.");
    if (!$fz7FM.util.isArray(iv)) {
        // convert iv byte buffer into 32-bit integer array
        var ints = [];
        var blocks = blockSize / 4;
        for(var i = 0; i < blocks; ++i)ints.push(iv.getInt32());
        iv = ints;
    }
    return iv;
}
function $1a99403691088acd$var$inc32(block) {
    // increment last 32 bits of block only
    block[block.length - 1] = block[block.length - 1] + 1 & 0xFFFFFFFF;
}
function $1a99403691088acd$var$from64To32(num) {
    // convert 64-bit number to two BE Int32s
    return [
        num / 0x100000000 | 0,
        num & 0xFFFFFFFF
    ];
}

});


parcelRegister("1Kjlm", function(module, exports) {
/**
 * A Javascript implementation of AES Cipher Suites for TLS.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2009-2015 Digital Bazaar, Inc.
 *
 */ 
var $fz7FM = parcelRequire("fz7FM");
parcelRequire("60qK1");
parcelRequire("935ik");
var $1459178dd577db68$var$tls = module.exports = $fz7FM.tls;
/**
 * Supported cipher suites.
 */ $1459178dd577db68$var$tls.CipherSuites["TLS_RSA_WITH_AES_128_CBC_SHA"] = {
    id: [
        0x00,
        0x2f
    ],
    name: "TLS_RSA_WITH_AES_128_CBC_SHA",
    initSecurityParameters: function initSecurityParameters(sp) {
        sp.bulk_cipher_algorithm = $1459178dd577db68$var$tls.BulkCipherAlgorithm.aes;
        sp.cipher_type = $1459178dd577db68$var$tls.CipherType.block;
        sp.enc_key_length = 16;
        sp.block_length = 16;
        sp.fixed_iv_length = 16;
        sp.record_iv_length = 16;
        sp.mac_algorithm = $1459178dd577db68$var$tls.MACAlgorithm.hmac_sha1;
        sp.mac_length = 20;
        sp.mac_key_length = 20;
    },
    initConnectionState: $1459178dd577db68$var$initConnectionState
};
$1459178dd577db68$var$tls.CipherSuites["TLS_RSA_WITH_AES_256_CBC_SHA"] = {
    id: [
        0x00,
        0x35
    ],
    name: "TLS_RSA_WITH_AES_256_CBC_SHA",
    initSecurityParameters: function initSecurityParameters(sp) {
        sp.bulk_cipher_algorithm = $1459178dd577db68$var$tls.BulkCipherAlgorithm.aes;
        sp.cipher_type = $1459178dd577db68$var$tls.CipherType.block;
        sp.enc_key_length = 32;
        sp.block_length = 16;
        sp.fixed_iv_length = 16;
        sp.record_iv_length = 16;
        sp.mac_algorithm = $1459178dd577db68$var$tls.MACAlgorithm.hmac_sha1;
        sp.mac_length = 20;
        sp.mac_key_length = 20;
    },
    initConnectionState: $1459178dd577db68$var$initConnectionState
};
function $1459178dd577db68$var$initConnectionState(state, c, sp) {
    var client = c.entity === $fz7FM.tls.ConnectionEnd.client;
    // cipher setup
    state.read.cipherState = {
        init: false,
        cipher: $fz7FM.cipher.createDecipher("AES-CBC", client ? sp.keys.server_write_key : sp.keys.client_write_key),
        iv: client ? sp.keys.server_write_IV : sp.keys.client_write_IV
    };
    state.write.cipherState = {
        init: false,
        cipher: $fz7FM.cipher.createCipher("AES-CBC", client ? sp.keys.client_write_key : sp.keys.server_write_key),
        iv: client ? sp.keys.client_write_IV : sp.keys.server_write_IV
    };
    state.read.cipherFunction = $1459178dd577db68$var$decrypt_aes_cbc_sha1;
    state.write.cipherFunction = $1459178dd577db68$var$encrypt_aes_cbc_sha1;
    // MAC setup
    state.read.macLength = state.write.macLength = sp.mac_length;
    state.read.macFunction = state.write.macFunction = $1459178dd577db68$var$tls.hmac_sha1;
}
/**
 * Encrypts the TLSCompressed record into a TLSCipherText record using AES
 * in CBC mode.
 *
 * @param record the TLSCompressed record to encrypt.
 * @param s the ConnectionState to use.
 *
 * @return true on success, false on failure.
 */ function $1459178dd577db68$var$encrypt_aes_cbc_sha1(record, s) {
    var rval = false;
    // append MAC to fragment, update sequence number
    var mac = s.macFunction(s.macKey, s.sequenceNumber, record);
    record.fragment.putBytes(mac);
    s.updateSequenceNumber();
    // TLS 1.1+ use an explicit IV every time to protect against CBC attacks
    var iv;
    if (record.version.minor === $1459178dd577db68$var$tls.Versions.TLS_1_0.minor) // use the pre-generated IV when initializing for TLS 1.0, otherwise use
    // the residue from the previous encryption
    iv = s.cipherState.init ? null : s.cipherState.iv;
    else iv = $fz7FM.random.getBytesSync(16);
    s.cipherState.init = true;
    // start cipher
    var cipher = s.cipherState.cipher;
    cipher.start({
        iv: iv
    });
    // TLS 1.1+ write IV into output
    if (record.version.minor >= $1459178dd577db68$var$tls.Versions.TLS_1_1.minor) cipher.output.putBytes(iv);
    // do encryption (default padding is appropriate)
    cipher.update(record.fragment);
    if (cipher.finish($1459178dd577db68$var$encrypt_aes_cbc_sha1_padding)) {
        // set record fragment to encrypted output
        record.fragment = cipher.output;
        record.length = record.fragment.length();
        rval = true;
    }
    return rval;
}
/**
 * Handles padding for aes_cbc_sha1 in encrypt mode.
 *
 * @param blockSize the block size.
 * @param input the input buffer.
 * @param decrypt true in decrypt mode, false in encrypt mode.
 *
 * @return true on success, false on failure.
 */ function $1459178dd577db68$var$encrypt_aes_cbc_sha1_padding(blockSize, input, decrypt) {
    /* The encrypted data length (TLSCiphertext.length) is one more than the sum
   of SecurityParameters.block_length, TLSCompressed.length,
   SecurityParameters.mac_length, and padding_length.

   The padding may be any length up to 255 bytes long, as long as it results in
   the TLSCiphertext.length being an integral multiple of the block length.
   Lengths longer than necessary might be desirable to frustrate attacks on a
   protocol based on analysis of the lengths of exchanged messages. Each uint8
   in the padding data vector must be filled with the padding length value.

   The padding length should be such that the total size of the
   GenericBlockCipher structure is a multiple of the cipher's block length.
   Legal values range from zero to 255, inclusive. This length specifies the
   length of the padding field exclusive of the padding_length field itself.

   This is slightly different from PKCS#7 because the padding value is 1
   less than the actual number of padding bytes if you include the
   padding_length uint8 itself as a padding byte. */ if (!decrypt) {
        // get the number of padding bytes required to reach the blockSize and
        // subtract 1 for the padding value (to make room for the padding_length
        // uint8)
        var padding = blockSize - input.length() % blockSize;
        input.fillWithByte(padding - 1, padding);
    }
    return true;
}
/**
 * Handles padding for aes_cbc_sha1 in decrypt mode.
 *
 * @param blockSize the block size.
 * @param output the output buffer.
 * @param decrypt true in decrypt mode, false in encrypt mode.
 *
 * @return true on success, false on failure.
 */ function $1459178dd577db68$var$decrypt_aes_cbc_sha1_padding(blockSize, output, decrypt) {
    var rval = true;
    if (decrypt) {
        /* The last byte in the output specifies the number of padding bytes not
      including itself. Each of the padding bytes has the same value as that
      last byte (known as the padding_length). Here we check all padding
      bytes to ensure they have the value of padding_length even if one of
      them is bad in order to ward-off timing attacks. */ var len = output.length();
        var paddingLength = output.last();
        for(var i = len - 1 - paddingLength; i < len - 1; ++i)rval = rval && output.at(i) == paddingLength;
        if (rval) // trim off padding bytes and last padding length byte
        output.truncate(paddingLength + 1);
    }
    return rval;
}
/**
 * Decrypts a TLSCipherText record into a TLSCompressed record using
 * AES in CBC mode.
 *
 * @param record the TLSCipherText record to decrypt.
 * @param s the ConnectionState to use.
 *
 * @return true on success, false on failure.
 */ function $1459178dd577db68$var$decrypt_aes_cbc_sha1(record, s) {
    var rval = false;
    var iv;
    if (record.version.minor === $1459178dd577db68$var$tls.Versions.TLS_1_0.minor) // use pre-generated IV when initializing for TLS 1.0, otherwise use the
    // residue from the previous decryption
    iv = s.cipherState.init ? null : s.cipherState.iv;
    else // TLS 1.1+ use an explicit IV every time to protect against CBC attacks
    // that is appended to the record fragment
    iv = record.fragment.getBytes(16);
    s.cipherState.init = true;
    // start cipher
    var cipher = s.cipherState.cipher;
    cipher.start({
        iv: iv
    });
    // do decryption
    cipher.update(record.fragment);
    rval = cipher.finish($1459178dd577db68$var$decrypt_aes_cbc_sha1_padding);
    // even if decryption fails, keep going to minimize timing attacks
    // decrypted data:
    // first (len - 20) bytes = application data
    // last 20 bytes          = MAC
    var macLen = s.macLength;
    // create a random MAC to check against should the mac length check fail
    // Note: do this regardless of the failure to keep timing consistent
    var mac = $fz7FM.random.getBytesSync(macLen);
    // get fragment and mac
    var len = cipher.output.length();
    if (len >= macLen) {
        record.fragment = cipher.output.getBytes(len - macLen);
        mac = cipher.output.getBytes(macLen);
    } else // bad data, but get bytes anyway to try to keep timing consistent
    record.fragment = cipher.output.getBytes();
    record.fragment = $fz7FM.util.createBuffer(record.fragment);
    record.length = record.fragment.length();
    // see if data integrity checks out, update sequence number
    var mac2 = s.macFunction(s.macKey, s.sequenceNumber, record);
    s.updateSequenceNumber();
    rval = $1459178dd577db68$var$compareMacs(s.macKey, mac, mac2) && rval;
    return rval;
}
/**
 * Safely compare two MACs. This function will compare two MACs in a way
 * that protects against timing attacks.
 *
 * TODO: Expose elsewhere as a utility API.
 *
 * See: https://www.nccgroup.trust/us/about-us/newsroom-and-events/blog/2011/february/double-hmac-verification/
 *
 * @param key the MAC key to use.
 * @param mac1 as a binary-encoded string of bytes.
 * @param mac2 as a binary-encoded string of bytes.
 *
 * @return true if the MACs are the same, false if not.
 */ function $1459178dd577db68$var$compareMacs(key, mac1, mac2) {
    var hmac = $fz7FM.hmac.create();
    hmac.start("SHA1", key);
    hmac.update(mac1);
    mac1 = hmac.digest().getBytes();
    hmac.start(null, null);
    hmac.update(mac2);
    mac2 = hmac.digest().getBytes();
    return mac1 === mac2;
}

});
parcelRegister("935ik", function(module, exports) {
/**
 * A Javascript implementation of Transport Layer Security (TLS).
 *
 * @author Dave Longley
 *
 * Copyright (c) 2009-2014 Digital Bazaar, Inc.
 *
 * The TLS Handshake Protocol involves the following steps:
 *
 * - Exchange hello messages to agree on algorithms, exchange random values,
 * and check for session resumption.
 *
 * - Exchange the necessary cryptographic parameters to allow the client and
 * server to agree on a premaster secret.
 *
 * - Exchange certificates and cryptographic information to allow the client
 * and server to authenticate themselves.
 *
 * - Generate a master secret from the premaster secret and exchanged random
 * values.
 *
 * - Provide security parameters to the record layer.
 *
 * - Allow the client and server to verify that their peer has calculated the
 * same security parameters and that the handshake occurred without tampering
 * by an attacker.
 *
 * Up to 4 different messages may be sent during a key exchange. The server
 * certificate, the server key exchange, the client certificate, and the
 * client key exchange.
 *
 * A typical handshake (from the client's perspective).
 *
 * 1. Client sends ClientHello.
 * 2. Client receives ServerHello.
 * 3. Client receives optional Certificate.
 * 4. Client receives optional ServerKeyExchange.
 * 5. Client receives ServerHelloDone.
 * 6. Client sends optional Certificate.
 * 7. Client sends ClientKeyExchange.
 * 8. Client sends optional CertificateVerify.
 * 9. Client sends ChangeCipherSpec.
 * 10. Client sends Finished.
 * 11. Client receives ChangeCipherSpec.
 * 12. Client receives Finished.
 * 13. Client sends/receives application data.
 *
 * To reuse an existing session:
 *
 * 1. Client sends ClientHello with session ID for reuse.
 * 2. Client receives ServerHello with same session ID if reusing.
 * 3. Client receives ChangeCipherSpec message if reusing.
 * 4. Client receives Finished.
 * 5. Client sends ChangeCipherSpec.
 * 6. Client sends Finished.
 *
 * Note: Client ignores HelloRequest if in the middle of a handshake.
 *
 * Record Layer:
 *
 * The record layer fragments information blocks into TLSPlaintext records
 * carrying data in chunks of 2^14 bytes or less. Client message boundaries are
 * not preserved in the record layer (i.e., multiple client messages of the
 * same ContentType MAY be coalesced into a single TLSPlaintext record, or a
 * single message MAY be fragmented across several records).
 *
 * struct {
 *   uint8 major;
 *   uint8 minor;
 * } ProtocolVersion;
 *
 * struct {
 *   ContentType type;
 *   ProtocolVersion version;
 *   uint16 length;
 *   opaque fragment[TLSPlaintext.length];
 * } TLSPlaintext;
 *
 * type:
 *   The higher-level protocol used to process the enclosed fragment.
 *
 * version:
 *   The version of the protocol being employed. TLS Version 1.2 uses version
 *   {3, 3}. TLS Version 1.0 uses version {3, 1}. Note that a client that
 *   supports multiple versions of TLS may not know what version will be
 *   employed before it receives the ServerHello.
 *
 * length:
 *   The length (in bytes) of the following TLSPlaintext.fragment. The length
 *   MUST NOT exceed 2^14 = 16384 bytes.
 *
 * fragment:
 *   The application data. This data is transparent and treated as an
 *   independent block to be dealt with by the higher-level protocol specified
 *   by the type field.
 *
 * Implementations MUST NOT send zero-length fragments of Handshake, Alert, or
 * ChangeCipherSpec content types. Zero-length fragments of Application data
 * MAY be sent as they are potentially useful as a traffic analysis
 * countermeasure.
 *
 * Note: Data of different TLS record layer content types MAY be interleaved.
 * Application data is generally of lower precedence for transmission than
 * other content types. However, records MUST be delivered to the network in
 * the same order as they are protected by the record layer. Recipients MUST
 * receive and process interleaved application layer traffic during handshakes
 * subsequent to the first one on a connection.
 *
 * struct {
 *   ContentType type;       // same as TLSPlaintext.type
 *   ProtocolVersion version;// same as TLSPlaintext.version
 *   uint16 length;
 *   opaque fragment[TLSCompressed.length];
 * } TLSCompressed;
 *
 * length:
 *   The length (in bytes) of the following TLSCompressed.fragment.
 *   The length MUST NOT exceed 2^14 + 1024.
 *
 * fragment:
 *   The compressed form of TLSPlaintext.fragment.
 *
 * Note: A CompressionMethod.null operation is an identity operation; no fields
 * are altered. In this implementation, since no compression is supported,
 * uncompressed records are always the same as compressed records.
 *
 * Encryption Information:
 *
 * The encryption and MAC functions translate a TLSCompressed structure into a
 * TLSCiphertext. The decryption functions reverse the process. The MAC of the
 * record also includes a sequence number so that missing, extra, or repeated
 * messages are detectable.
 *
 * struct {
 *   ContentType type;
 *   ProtocolVersion version;
 *   uint16 length;
 *   select (SecurityParameters.cipher_type) {
 *     case stream: GenericStreamCipher;
 *     case block:  GenericBlockCipher;
 *     case aead:   GenericAEADCipher;
 *   } fragment;
 * } TLSCiphertext;
 *
 * type:
 *   The type field is identical to TLSCompressed.type.
 *
 * version:
 *   The version field is identical to TLSCompressed.version.
 *
 * length:
 *   The length (in bytes) of the following TLSCiphertext.fragment.
 *   The length MUST NOT exceed 2^14 + 2048.
 *
 * fragment:
 *   The encrypted form of TLSCompressed.fragment, with the MAC.
 *
 * Note: Only CBC Block Ciphers are supported by this implementation.
 *
 * The TLSCompressed.fragment structures are converted to/from block
 * TLSCiphertext.fragment structures.
 *
 * struct {
 *   opaque IV[SecurityParameters.record_iv_length];
 *   block-ciphered struct {
 *     opaque content[TLSCompressed.length];
 *     opaque MAC[SecurityParameters.mac_length];
 *     uint8 padding[GenericBlockCipher.padding_length];
 *     uint8 padding_length;
 *   };
 * } GenericBlockCipher;
 *
 * The MAC is generated as described in Section 6.2.3.1.
 *
 * IV:
 *   The Initialization Vector (IV) SHOULD be chosen at random, and MUST be
 *   unpredictable. Note that in versions of TLS prior to 1.1, there was no
 *   IV field, and the last ciphertext block of the previous record (the "CBC
 *   residue") was used as the IV. This was changed to prevent the attacks
 *   described in [CBCATT]. For block ciphers, the IV length is of length
 *   SecurityParameters.record_iv_length, which is equal to the
 *   SecurityParameters.block_size.
 *
 * padding:
 *   Padding that is added to force the length of the plaintext to be an
 *   integral multiple of the block cipher's block length. The padding MAY be
 *   any length up to 255 bytes, as long as it results in the
 *   TLSCiphertext.length being an integral multiple of the block length.
 *   Lengths longer than necessary might be desirable to frustrate attacks on
 *   a protocol that are based on analysis of the lengths of exchanged
 *   messages. Each uint8 in the padding data vector MUST be filled with the
 *   padding length value. The receiver MUST check this padding and MUST use
 *   the bad_record_mac alert to indicate padding errors.
 *
 * padding_length:
 *   The padding length MUST be such that the total size of the
 *   GenericBlockCipher structure is a multiple of the cipher's block length.
 *   Legal values range from zero to 255, inclusive. This length specifies the
 *   length of the padding field exclusive of the padding_length field itself.
 *
 * The encrypted data length (TLSCiphertext.length) is one more than the sum of
 * SecurityParameters.block_length, TLSCompressed.length,
 * SecurityParameters.mac_length, and padding_length.
 *
 * Example: If the block length is 8 bytes, the content length
 * (TLSCompressed.length) is 61 bytes, and the MAC length is 20 bytes, then the
 * length before padding is 82 bytes (this does not include the IV. Thus, the
 * padding length modulo 8 must be equal to 6 in order to make the total length
 * an even multiple of 8 bytes (the block length). The padding length can be
 * 6, 14, 22, and so on, through 254. If the padding length were the minimum
 * necessary, 6, the padding would be 6 bytes, each containing the value 6.
 * Thus, the last 8 octets of the GenericBlockCipher before block encryption
 * would be xx 06 06 06 06 06 06 06, where xx is the last octet of the MAC.
 *
 * Note: With block ciphers in CBC mode (Cipher Block Chaining), it is critical
 * that the entire plaintext of the record be known before any ciphertext is
 * transmitted. Otherwise, it is possible for the attacker to mount the attack
 * described in [CBCATT].
 *
 * Implementation note: Canvel et al. [CBCTIME] have demonstrated a timing
 * attack on CBC padding based on the time required to compute the MAC. In
 * order to defend against this attack, implementations MUST ensure that
 * record processing time is essentially the same whether or not the padding
 * is correct. In general, the best way to do this is to compute the MAC even
 * if the padding is incorrect, and only then reject the packet. For instance,
 * if the pad appears to be incorrect, the implementation might assume a
 * zero-length pad and then compute the MAC. This leaves a small timing
 * channel, since MAC performance depends, to some extent, on the size of the
 * data fragment, but it is not believed to be large enough to be exploitable,
 * due to the large block size of existing MACs and the small size of the
 * timing signal.
 */ 
var $fz7FM = parcelRequire("fz7FM");
parcelRequire("d4EnE");
parcelRequire("9YZGj");
parcelRequire("bPSAM");
parcelRequire("8061v");
parcelRequire("c6KQm");
parcelRequire("a65r1");
parcelRequire("1DNOR");
parcelRequire("gao36");
/**
 * Generates pseudo random bytes by mixing the result of two hash functions,
 * MD5 and SHA-1.
 *
 * prf_TLS1(secret, label, seed) =
 *   P_MD5(S1, label + seed) XOR P_SHA-1(S2, label + seed);
 *
 * Each P_hash function functions as follows:
 *
 * P_hash(secret, seed) = HMAC_hash(secret, A(1) + seed) +
 *                        HMAC_hash(secret, A(2) + seed) +
 *                        HMAC_hash(secret, A(3) + seed) + ...
 * A() is defined as:
 *   A(0) = seed
 *   A(i) = HMAC_hash(secret, A(i-1))
 *
 * The '+' operator denotes concatenation.
 *
 * As many iterations A(N) as are needed are performed to generate enough
 * pseudo random byte output. If an iteration creates more data than is
 * necessary, then it is truncated.
 *
 * Therefore:
 * A(1) = HMAC_hash(secret, A(0))
 *      = HMAC_hash(secret, seed)
 * A(2) = HMAC_hash(secret, A(1))
 *      = HMAC_hash(secret, HMAC_hash(secret, seed))
 *
 * Therefore:
 * P_hash(secret, seed) =
 *   HMAC_hash(secret, HMAC_hash(secret, A(0)) + seed) +
 *   HMAC_hash(secret, HMAC_hash(secret, A(1)) + seed) +
 *   ...
 *
 * Therefore:
 * P_hash(secret, seed) =
 *   HMAC_hash(secret, HMAC_hash(secret, seed) + seed) +
 *   HMAC_hash(secret, HMAC_hash(secret, HMAC_hash(secret, seed)) + seed) +
 *   ...
 *
 * @param secret the secret to use.
 * @param label the label to use.
 * @param seed the seed value to use.
 * @param length the number of bytes to generate.
 *
 * @return the pseudo random bytes in a byte buffer.
 */ var $69688044bad9a4b6$var$prf_TLS1 = function prf_TLS1(secret, label, seed, length) {
    var rval = $fz7FM.util.createBuffer();
    /* For TLS 1.0, the secret is split in half, into two secrets of equal
    length. If the secret has an odd length then the last byte of the first
    half will be the same as the first byte of the second. The length of the
    two secrets is half of the secret rounded up. */ var idx = secret.length >> 1;
    var slen = idx + (secret.length & 1);
    var s1 = secret.substr(0, slen);
    var s2 = secret.substr(idx, slen);
    var ai = $fz7FM.util.createBuffer();
    var hmac = $fz7FM.hmac.create();
    seed = label + seed;
    // determine the number of iterations that must be performed to generate
    // enough output bytes, md5 creates 16 byte hashes, sha1 creates 20
    var md5itr = Math.ceil(length / 16);
    var sha1itr = Math.ceil(length / 20);
    // do md5 iterations
    hmac.start("MD5", s1);
    var md5bytes = $fz7FM.util.createBuffer();
    ai.putBytes(seed);
    for(var i = 0; i < md5itr; ++i){
        // HMAC_hash(secret, A(i-1))
        hmac.start(null, null);
        hmac.update(ai.getBytes());
        ai.putBuffer(hmac.digest());
        // HMAC_hash(secret, A(i) + seed)
        hmac.start(null, null);
        hmac.update(ai.bytes() + seed);
        md5bytes.putBuffer(hmac.digest());
    }
    // do sha1 iterations
    hmac.start("SHA1", s2);
    var sha1bytes = $fz7FM.util.createBuffer();
    ai.clear();
    ai.putBytes(seed);
    for(var i = 0; i < sha1itr; ++i){
        // HMAC_hash(secret, A(i-1))
        hmac.start(null, null);
        hmac.update(ai.getBytes());
        ai.putBuffer(hmac.digest());
        // HMAC_hash(secret, A(i) + seed)
        hmac.start(null, null);
        hmac.update(ai.bytes() + seed);
        sha1bytes.putBuffer(hmac.digest());
    }
    // XOR the md5 bytes with the sha1 bytes
    rval.putBytes($fz7FM.util.xorBytes(md5bytes.getBytes(), sha1bytes.getBytes(), length));
    return rval;
};
/**
 * Generates pseudo random bytes using a SHA256 algorithm. For TLS 1.2.
 *
 * @param secret the secret to use.
 * @param label the label to use.
 * @param seed the seed value to use.
 * @param length the number of bytes to generate.
 *
 * @return the pseudo random bytes in a byte buffer.
 */ var $69688044bad9a4b6$var$prf_sha256 = function prf_sha256(secret, label, seed, length) {
// FIXME: implement me for TLS 1.2
};
/**
 * Gets a MAC for a record using the SHA-1 hash algorithm.
 *
 * @param key the mac key.
 * @param state the sequence number (array of two 32-bit integers).
 * @param record the record.
 *
 * @return the sha-1 hash (20 bytes) for the given record.
 */ var $69688044bad9a4b6$var$hmac_sha1 = function hmac_sha1(key, seqNum, record) {
    /* MAC is computed like so:
  HMAC_hash(
    key, seqNum +
      TLSCompressed.type +
      TLSCompressed.version +
      TLSCompressed.length +
      TLSCompressed.fragment)
  */ var hmac = $fz7FM.hmac.create();
    hmac.start("SHA1", key);
    var b = $fz7FM.util.createBuffer();
    b.putInt32(seqNum[0]);
    b.putInt32(seqNum[1]);
    b.putByte(record.type);
    b.putByte(record.version.major);
    b.putByte(record.version.minor);
    b.putInt16(record.length);
    b.putBytes(record.fragment.bytes());
    hmac.update(b.getBytes());
    return hmac.digest().getBytes();
};
/**
 * Compresses the TLSPlaintext record into a TLSCompressed record using the
 * deflate algorithm.
 *
 * @param c the TLS connection.
 * @param record the TLSPlaintext record to compress.
 * @param s the ConnectionState to use.
 *
 * @return true on success, false on failure.
 */ var $69688044bad9a4b6$var$deflate = function deflate(c, record, s) {
    var rval = false;
    try {
        var bytes = c.deflate(record.fragment.getBytes());
        record.fragment = $fz7FM.util.createBuffer(bytes);
        record.length = bytes.length;
        rval = true;
    } catch (ex) {
    // deflate error, fail out
    }
    return rval;
};
/**
 * Decompresses the TLSCompressed record into a TLSPlaintext record using the
 * deflate algorithm.
 *
 * @param c the TLS connection.
 * @param record the TLSCompressed record to decompress.
 * @param s the ConnectionState to use.
 *
 * @return true on success, false on failure.
 */ var $69688044bad9a4b6$var$inflate = function inflate(c, record, s) {
    var rval = false;
    try {
        var bytes = c.inflate(record.fragment.getBytes());
        record.fragment = $fz7FM.util.createBuffer(bytes);
        record.length = bytes.length;
        rval = true;
    } catch (ex) {
    // inflate error, fail out
    }
    return rval;
};
/**
 * Reads a TLS variable-length vector from a byte buffer.
 *
 * Variable-length vectors are defined by specifying a subrange of legal
 * lengths, inclusively, using the notation <floor..ceiling>. When these are
 * encoded, the actual length precedes the vector's contents in the byte
 * stream. The length will be in the form of a number consuming as many bytes
 * as required to hold the vector's specified maximum (ceiling) length. A
 * variable-length vector with an actual length field of zero is referred to
 * as an empty vector.
 *
 * @param b the byte buffer.
 * @param lenBytes the number of bytes required to store the length.
 *
 * @return the resulting byte buffer.
 */ var $69688044bad9a4b6$var$readVector = function readVector(b, lenBytes) {
    var len = 0;
    switch(lenBytes){
        case 1:
            len = b.getByte();
            break;
        case 2:
            len = b.getInt16();
            break;
        case 3:
            len = b.getInt24();
            break;
        case 4:
            len = b.getInt32();
            break;
    }
    // read vector bytes into a new buffer
    return $fz7FM.util.createBuffer(b.getBytes(len));
};
/**
 * Writes a TLS variable-length vector to a byte buffer.
 *
 * @param b the byte buffer.
 * @param lenBytes the number of bytes required to store the length.
 * @param v the byte buffer vector.
 */ var $69688044bad9a4b6$var$writeVector = function writeVector(b, lenBytes, v) {
    // encode length at the start of the vector, where the number of bytes for
    // the length is the maximum number of bytes it would take to encode the
    // vector's ceiling
    b.putInt(v.length(), lenBytes << 3);
    b.putBuffer(v);
};
/**
 * The tls implementation.
 */ var $69688044bad9a4b6$var$tls = {};
/**
 * Version: TLS 1.2 = 3.3, TLS 1.1 = 3.2, TLS 1.0 = 3.1. Both TLS 1.1 and
 * TLS 1.2 were still too new (ie: openSSL didn't implement them) at the time
 * of this implementation so TLS 1.0 was implemented instead.
 */ $69688044bad9a4b6$var$tls.Versions = {
    TLS_1_0: {
        major: 3,
        minor: 1
    },
    TLS_1_1: {
        major: 3,
        minor: 2
    },
    TLS_1_2: {
        major: 3,
        minor: 3
    }
};
$69688044bad9a4b6$var$tls.SupportedVersions = [
    $69688044bad9a4b6$var$tls.Versions.TLS_1_1,
    $69688044bad9a4b6$var$tls.Versions.TLS_1_0
];
$69688044bad9a4b6$var$tls.Version = $69688044bad9a4b6$var$tls.SupportedVersions[0];
/**
 * Maximum fragment size. True maximum is 16384, but we fragment before that
 * to allow for unusual small increases during compression.
 */ $69688044bad9a4b6$var$tls.MaxFragment = 15360;
/**
 * Whether this entity is considered the "client" or "server".
 * enum { server, client } ConnectionEnd;
 */ $69688044bad9a4b6$var$tls.ConnectionEnd = {
    server: 0,
    client: 1
};
/**
 * Pseudo-random function algorithm used to generate keys from the master
 * secret.
 * enum { tls_prf_sha256 } PRFAlgorithm;
 */ $69688044bad9a4b6$var$tls.PRFAlgorithm = {
    tls_prf_sha256: 0
};
/**
 * Bulk encryption algorithms.
 * enum { null, rc4, des3, aes } BulkCipherAlgorithm;
 */ $69688044bad9a4b6$var$tls.BulkCipherAlgorithm = {
    none: null,
    rc4: 0,
    des3: 1,
    aes: 2
};
/**
 * Cipher types.
 * enum { stream, block, aead } CipherType;
 */ $69688044bad9a4b6$var$tls.CipherType = {
    stream: 0,
    block: 1,
    aead: 2
};
/**
 * MAC (Message Authentication Code) algorithms.
 * enum { null, hmac_md5, hmac_sha1, hmac_sha256,
 *   hmac_sha384, hmac_sha512} MACAlgorithm;
 */ $69688044bad9a4b6$var$tls.MACAlgorithm = {
    none: null,
    hmac_md5: 0,
    hmac_sha1: 1,
    hmac_sha256: 2,
    hmac_sha384: 3,
    hmac_sha512: 4
};
/**
 * Compression algorithms.
 * enum { null(0), deflate(1), (255) } CompressionMethod;
 */ $69688044bad9a4b6$var$tls.CompressionMethod = {
    none: 0,
    deflate: 1
};
/**
 * TLS record content types.
 * enum {
 *   change_cipher_spec(20), alert(21), handshake(22),
 *   application_data(23), (255)
 * } ContentType;
 */ $69688044bad9a4b6$var$tls.ContentType = {
    change_cipher_spec: 20,
    alert: 21,
    handshake: 22,
    application_data: 23,
    heartbeat: 24
};
/**
 * TLS handshake types.
 * enum {
 *   hello_request(0), client_hello(1), server_hello(2),
 *   certificate(11), server_key_exchange (12),
 *   certificate_request(13), server_hello_done(14),
 *   certificate_verify(15), client_key_exchange(16),
 *   finished(20), (255)
 * } HandshakeType;
 */ $69688044bad9a4b6$var$tls.HandshakeType = {
    hello_request: 0,
    client_hello: 1,
    server_hello: 2,
    certificate: 11,
    server_key_exchange: 12,
    certificate_request: 13,
    server_hello_done: 14,
    certificate_verify: 15,
    client_key_exchange: 16,
    finished: 20
};
/**
 * TLS Alert Protocol.
 *
 * enum { warning(1), fatal(2), (255) } AlertLevel;
 *
 * enum {
 *   close_notify(0),
 *   unexpected_message(10),
 *   bad_record_mac(20),
 *   decryption_failed(21),
 *   record_overflow(22),
 *   decompression_failure(30),
 *   handshake_failure(40),
 *   bad_certificate(42),
 *   unsupported_certificate(43),
 *   certificate_revoked(44),
 *   certificate_expired(45),
 *   certificate_unknown(46),
 *   illegal_parameter(47),
 *   unknown_ca(48),
 *   access_denied(49),
 *   decode_error(50),
 *   decrypt_error(51),
 *   export_restriction(60),
 *   protocol_version(70),
 *   insufficient_security(71),
 *   internal_error(80),
 *   user_canceled(90),
 *   no_renegotiation(100),
 *   (255)
 * } AlertDescription;
 *
 * struct {
 *   AlertLevel level;
 *   AlertDescription description;
 * } Alert;
 */ $69688044bad9a4b6$var$tls.Alert = {};
$69688044bad9a4b6$var$tls.Alert.Level = {
    warning: 1,
    fatal: 2
};
$69688044bad9a4b6$var$tls.Alert.Description = {
    close_notify: 0,
    unexpected_message: 10,
    bad_record_mac: 20,
    decryption_failed: 21,
    record_overflow: 22,
    decompression_failure: 30,
    handshake_failure: 40,
    bad_certificate: 42,
    unsupported_certificate: 43,
    certificate_revoked: 44,
    certificate_expired: 45,
    certificate_unknown: 46,
    illegal_parameter: 47,
    unknown_ca: 48,
    access_denied: 49,
    decode_error: 50,
    decrypt_error: 51,
    export_restriction: 60,
    protocol_version: 70,
    insufficient_security: 71,
    internal_error: 80,
    user_canceled: 90,
    no_renegotiation: 100
};
/**
 * TLS Heartbeat Message types.
 * enum {
 *   heartbeat_request(1),
 *   heartbeat_response(2),
 *   (255)
 * } HeartbeatMessageType;
 */ $69688044bad9a4b6$var$tls.HeartbeatMessageType = {
    heartbeat_request: 1,
    heartbeat_response: 2
};
/**
 * Supported cipher suites.
 */ $69688044bad9a4b6$var$tls.CipherSuites = {};
/**
 * Gets a supported cipher suite from its 2 byte ID.
 *
 * @param twoBytes two bytes in a string.
 *
 * @return the matching supported cipher suite or null.
 */ $69688044bad9a4b6$var$tls.getCipherSuite = function(twoBytes) {
    var rval = null;
    for(var key in $69688044bad9a4b6$var$tls.CipherSuites){
        var cs = $69688044bad9a4b6$var$tls.CipherSuites[key];
        if (cs.id[0] === twoBytes.charCodeAt(0) && cs.id[1] === twoBytes.charCodeAt(1)) {
            rval = cs;
            break;
        }
    }
    return rval;
};
/**
 * Called when an unexpected record is encountered.
 *
 * @param c the connection.
 * @param record the record.
 */ $69688044bad9a4b6$var$tls.handleUnexpected = function(c, record) {
    // if connection is client and closed, ignore unexpected messages
    var ignore = !c.open && c.entity === $69688044bad9a4b6$var$tls.ConnectionEnd.client;
    if (!ignore) c.error(c, {
        message: "Unexpected message. Received TLS record out of order.",
        send: true,
        alert: {
            level: $69688044bad9a4b6$var$tls.Alert.Level.fatal,
            description: $69688044bad9a4b6$var$tls.Alert.Description.unexpected_message
        }
    });
};
/**
 * Called when a client receives a HelloRequest record.
 *
 * @param c the connection.
 * @param record the record.
 * @param length the length of the handshake message.
 */ $69688044bad9a4b6$var$tls.handleHelloRequest = function(c, record, length) {
    // ignore renegotiation requests from the server during a handshake, but
    // if handshaking, send a warning alert that renegotation is denied
    if (!c.handshaking && c.handshakes > 0) {
        // send alert warning
        $69688044bad9a4b6$var$tls.queue(c, $69688044bad9a4b6$var$tls.createAlert(c, {
            level: $69688044bad9a4b6$var$tls.Alert.Level.warning,
            description: $69688044bad9a4b6$var$tls.Alert.Description.no_renegotiation
        }));
        $69688044bad9a4b6$var$tls.flush(c);
    }
    // continue
    c.process();
};
/**
 * Parses a hello message from a ClientHello or ServerHello record.
 *
 * @param record the record to parse.
 *
 * @return the parsed message.
 */ $69688044bad9a4b6$var$tls.parseHelloMessage = function(c, record, length) {
    var msg = null;
    var client = c.entity === $69688044bad9a4b6$var$tls.ConnectionEnd.client;
    // minimum of 38 bytes in message
    if (length < 38) c.error(c, {
        message: client ? "Invalid ServerHello message. Message too short." : "Invalid ClientHello message. Message too short.",
        send: true,
        alert: {
            level: $69688044bad9a4b6$var$tls.Alert.Level.fatal,
            description: $69688044bad9a4b6$var$tls.Alert.Description.illegal_parameter
        }
    });
    else {
        // use 'remaining' to calculate # of remaining bytes in the message
        var b = record.fragment;
        var remaining = b.length();
        msg = {
            version: {
                major: b.getByte(),
                minor: b.getByte()
            },
            random: $fz7FM.util.createBuffer(b.getBytes(32)),
            session_id: $69688044bad9a4b6$var$readVector(b, 1),
            extensions: []
        };
        if (client) {
            msg.cipher_suite = b.getBytes(2);
            msg.compression_method = b.getByte();
        } else {
            msg.cipher_suites = $69688044bad9a4b6$var$readVector(b, 2);
            msg.compression_methods = $69688044bad9a4b6$var$readVector(b, 1);
        }
        // read extensions if there are any bytes left in the message
        remaining = length - (remaining - b.length());
        if (remaining > 0) {
            // parse extensions
            var exts = $69688044bad9a4b6$var$readVector(b, 2);
            while(exts.length() > 0)msg.extensions.push({
                type: [
                    exts.getByte(),
                    exts.getByte()
                ],
                data: $69688044bad9a4b6$var$readVector(exts, 2)
            });
            // TODO: make extension support modular
            if (!client) for(var i = 0; i < msg.extensions.length; ++i){
                var ext = msg.extensions[i];
                // support SNI extension
                if (ext.type[0] === 0x00 && ext.type[1] === 0x00) {
                    // get server name list
                    var snl = $69688044bad9a4b6$var$readVector(ext.data, 2);
                    while(snl.length() > 0){
                        // read server name type
                        var snType = snl.getByte();
                        // only HostName type (0x00) is known, break out if
                        // another type is detected
                        if (snType !== 0x00) break;
                        // add host name to server name list
                        c.session.extensions.server_name.serverNameList.push($69688044bad9a4b6$var$readVector(snl, 2).getBytes());
                    }
                }
            }
        }
        // version already set, do not allow version change
        if (c.session.version) {
            if (msg.version.major !== c.session.version.major || msg.version.minor !== c.session.version.minor) return c.error(c, {
                message: "TLS version change is disallowed during renegotiation.",
                send: true,
                alert: {
                    level: $69688044bad9a4b6$var$tls.Alert.Level.fatal,
                    description: $69688044bad9a4b6$var$tls.Alert.Description.protocol_version
                }
            });
        }
        // get the chosen (ServerHello) cipher suite
        if (client) // FIXME: should be checking configured acceptable cipher suites
        c.session.cipherSuite = $69688044bad9a4b6$var$tls.getCipherSuite(msg.cipher_suite);
        else {
            // get a supported preferred (ClientHello) cipher suite
            // choose the first supported cipher suite
            var tmp = $fz7FM.util.createBuffer(msg.cipher_suites.bytes());
            while(tmp.length() > 0){
                // FIXME: should be checking configured acceptable suites
                // cipher suites take up 2 bytes
                c.session.cipherSuite = $69688044bad9a4b6$var$tls.getCipherSuite(tmp.getBytes(2));
                if (c.session.cipherSuite !== null) break;
            }
        }
        // cipher suite not supported
        if (c.session.cipherSuite === null) return c.error(c, {
            message: "No cipher suites in common.",
            send: true,
            alert: {
                level: $69688044bad9a4b6$var$tls.Alert.Level.fatal,
                description: $69688044bad9a4b6$var$tls.Alert.Description.handshake_failure
            },
            cipherSuite: $fz7FM.util.bytesToHex(msg.cipher_suite)
        });
        // TODO: handle compression methods
        if (client) c.session.compressionMethod = msg.compression_method;
        else // no compression
        c.session.compressionMethod = $69688044bad9a4b6$var$tls.CompressionMethod.none;
    }
    return msg;
};
/**
 * Creates security parameters for the given connection based on the given
 * hello message.
 *
 * @param c the TLS connection.
 * @param msg the hello message.
 */ $69688044bad9a4b6$var$tls.createSecurityParameters = function(c, msg) {
    /* Note: security params are from TLS 1.2, some values like prf_algorithm
  are ignored for TLS 1.0/1.1 and the builtin as specified in the spec is
  used. */ // TODO: handle other options from server when more supported
    // get client and server randoms
    var client = c.entity === $69688044bad9a4b6$var$tls.ConnectionEnd.client;
    var msgRandom = msg.random.bytes();
    var cRandom = client ? c.session.sp.client_random : msgRandom;
    var sRandom = client ? msgRandom : $69688044bad9a4b6$var$tls.createRandom().getBytes();
    // create new security parameters
    c.session.sp = {
        entity: c.entity,
        prf_algorithm: $69688044bad9a4b6$var$tls.PRFAlgorithm.tls_prf_sha256,
        bulk_cipher_algorithm: null,
        cipher_type: null,
        enc_key_length: null,
        block_length: null,
        fixed_iv_length: null,
        record_iv_length: null,
        mac_algorithm: null,
        mac_length: null,
        mac_key_length: null,
        compression_algorithm: c.session.compressionMethod,
        pre_master_secret: null,
        master_secret: null,
        client_random: cRandom,
        server_random: sRandom
    };
};
/**
 * Called when a client receives a ServerHello record.
 *
 * When a ServerHello message will be sent:
 *   The server will send this message in response to a client hello message
 *   when it was able to find an acceptable set of algorithms. If it cannot
 *   find such a match, it will respond with a handshake failure alert.
 *
 * uint24 length;
 * struct {
 *   ProtocolVersion server_version;
 *   Random random;
 *   SessionID session_id;
 *   CipherSuite cipher_suite;
 *   CompressionMethod compression_method;
 *   select(extensions_present) {
 *     case false:
 *       struct {};
 *     case true:
 *       Extension extensions<0..2^16-1>;
 *   };
 * } ServerHello;
 *
 * @param c the connection.
 * @param record the record.
 * @param length the length of the handshake message.
 */ $69688044bad9a4b6$var$tls.handleServerHello = function(c, record, length) {
    var msg = $69688044bad9a4b6$var$tls.parseHelloMessage(c, record, length);
    if (c.fail) return;
    // ensure server version is compatible
    if (msg.version.minor <= c.version.minor) c.version.minor = msg.version.minor;
    else return c.error(c, {
        message: "Incompatible TLS version.",
        send: true,
        alert: {
            level: $69688044bad9a4b6$var$tls.Alert.Level.fatal,
            description: $69688044bad9a4b6$var$tls.Alert.Description.protocol_version
        }
    });
    // indicate session version has been set
    c.session.version = c.version;
    // get the session ID from the message
    var sessionId = msg.session_id.bytes();
    // if the session ID is not blank and matches the cached one, resume
    // the session
    if (sessionId.length > 0 && sessionId === c.session.id) {
        // resuming session, expect a ChangeCipherSpec next
        c.expect = $69688044bad9a4b6$var$SCC;
        c.session.resuming = true;
        // get new server random
        c.session.sp.server_random = msg.random.bytes();
    } else {
        // not resuming, expect a server Certificate message next
        c.expect = $69688044bad9a4b6$var$SCE;
        c.session.resuming = false;
        // create new security parameters
        $69688044bad9a4b6$var$tls.createSecurityParameters(c, msg);
    }
    // set new session ID
    c.session.id = sessionId;
    // continue
    c.process();
};
/**
 * Called when a server receives a ClientHello record.
 *
 * When a ClientHello message will be sent:
 *   When a client first connects to a server it is required to send the
 *   client hello as its first message. The client can also send a client
 *   hello in response to a hello request or on its own initiative in order
 *   to renegotiate the security parameters in an existing connection.
 *
 * @param c the connection.
 * @param record the record.
 * @param length the length of the handshake message.
 */ $69688044bad9a4b6$var$tls.handleClientHello = function(c, record, length) {
    var msg = $69688044bad9a4b6$var$tls.parseHelloMessage(c, record, length);
    if (c.fail) return;
    // get the session ID from the message
    var sessionId = msg.session_id.bytes();
    // see if the given session ID is in the cache
    var session = null;
    if (c.sessionCache) {
        session = c.sessionCache.getSession(sessionId);
        if (session === null) // session ID not found
        sessionId = "";
        else if (session.version.major !== msg.version.major || session.version.minor > msg.version.minor) {
            // if session version is incompatible with client version, do not resume
            session = null;
            sessionId = "";
        }
    }
    // no session found to resume, generate a new session ID
    if (sessionId.length === 0) sessionId = $fz7FM.random.getBytes(32);
    // update session
    c.session.id = sessionId;
    c.session.clientHelloVersion = msg.version;
    c.session.sp = {};
    if (session) {
        // use version and security parameters from resumed session
        c.version = c.session.version = session.version;
        c.session.sp = session.sp;
    } else {
        // use highest compatible minor version
        var version;
        for(var i = 1; i < $69688044bad9a4b6$var$tls.SupportedVersions.length; ++i){
            version = $69688044bad9a4b6$var$tls.SupportedVersions[i];
            if (version.minor <= msg.version.minor) break;
        }
        c.version = {
            major: version.major,
            minor: version.minor
        };
        c.session.version = c.version;
    }
    // if a session is set, resume it
    if (session !== null) {
        // resuming session, expect a ChangeCipherSpec next
        c.expect = $69688044bad9a4b6$var$CCC;
        c.session.resuming = true;
        // get new client random
        c.session.sp.client_random = msg.random.bytes();
    } else {
        // not resuming, expect a Certificate or ClientKeyExchange
        c.expect = c.verifyClient !== false ? $69688044bad9a4b6$var$CCE : $69688044bad9a4b6$var$CKE;
        c.session.resuming = false;
        // create new security parameters
        $69688044bad9a4b6$var$tls.createSecurityParameters(c, msg);
    }
    // connection now open
    c.open = true;
    // queue server hello
    $69688044bad9a4b6$var$tls.queue(c, $69688044bad9a4b6$var$tls.createRecord(c, {
        type: $69688044bad9a4b6$var$tls.ContentType.handshake,
        data: $69688044bad9a4b6$var$tls.createServerHello(c)
    }));
    if (c.session.resuming) {
        // queue change cipher spec message
        $69688044bad9a4b6$var$tls.queue(c, $69688044bad9a4b6$var$tls.createRecord(c, {
            type: $69688044bad9a4b6$var$tls.ContentType.change_cipher_spec,
            data: $69688044bad9a4b6$var$tls.createChangeCipherSpec()
        }));
        // create pending state
        c.state.pending = $69688044bad9a4b6$var$tls.createConnectionState(c);
        // change current write state to pending write state
        c.state.current.write = c.state.pending.write;
        // queue finished
        $69688044bad9a4b6$var$tls.queue(c, $69688044bad9a4b6$var$tls.createRecord(c, {
            type: $69688044bad9a4b6$var$tls.ContentType.handshake,
            data: $69688044bad9a4b6$var$tls.createFinished(c)
        }));
    } else {
        // queue server certificate
        $69688044bad9a4b6$var$tls.queue(c, $69688044bad9a4b6$var$tls.createRecord(c, {
            type: $69688044bad9a4b6$var$tls.ContentType.handshake,
            data: $69688044bad9a4b6$var$tls.createCertificate(c)
        }));
        if (!c.fail) {
            // queue server key exchange
            $69688044bad9a4b6$var$tls.queue(c, $69688044bad9a4b6$var$tls.createRecord(c, {
                type: $69688044bad9a4b6$var$tls.ContentType.handshake,
                data: $69688044bad9a4b6$var$tls.createServerKeyExchange(c)
            }));
            // request client certificate if set
            if (c.verifyClient !== false) // queue certificate request
            $69688044bad9a4b6$var$tls.queue(c, $69688044bad9a4b6$var$tls.createRecord(c, {
                type: $69688044bad9a4b6$var$tls.ContentType.handshake,
                data: $69688044bad9a4b6$var$tls.createCertificateRequest(c)
            }));
            // queue server hello done
            $69688044bad9a4b6$var$tls.queue(c, $69688044bad9a4b6$var$tls.createRecord(c, {
                type: $69688044bad9a4b6$var$tls.ContentType.handshake,
                data: $69688044bad9a4b6$var$tls.createServerHelloDone(c)
            }));
        }
    }
    // send records
    $69688044bad9a4b6$var$tls.flush(c);
    // continue
    c.process();
};
/**
 * Called when a client receives a Certificate record.
 *
 * When this message will be sent:
 *   The server must send a certificate whenever the agreed-upon key exchange
 *   method is not an anonymous one. This message will always immediately
 *   follow the server hello message.
 *
 * Meaning of this message:
 *   The certificate type must be appropriate for the selected cipher suite's
 *   key exchange algorithm, and is generally an X.509v3 certificate. It must
 *   contain a key which matches the key exchange method, as follows. Unless
 *   otherwise specified, the signing algorithm for the certificate must be
 *   the same as the algorithm for the certificate key. Unless otherwise
 *   specified, the public key may be of any length.
 *
 * opaque ASN.1Cert<1..2^24-1>;
 * struct {
 *   ASN.1Cert certificate_list<1..2^24-1>;
 * } Certificate;
 *
 * @param c the connection.
 * @param record the record.
 * @param length the length of the handshake message.
 */ $69688044bad9a4b6$var$tls.handleCertificate = function(c, record, length) {
    // minimum of 3 bytes in message
    if (length < 3) return c.error(c, {
        message: "Invalid Certificate message. Message too short.",
        send: true,
        alert: {
            level: $69688044bad9a4b6$var$tls.Alert.Level.fatal,
            description: $69688044bad9a4b6$var$tls.Alert.Description.illegal_parameter
        }
    });
    var b = record.fragment;
    var msg = {
        certificate_list: $69688044bad9a4b6$var$readVector(b, 3)
    };
    /* The sender's certificate will be first in the list (chain), each
    subsequent one that follows will certify the previous one, but root
    certificates (self-signed) that specify the certificate authority may
    be omitted under the assumption that clients must already possess it. */ var cert, asn1;
    var certs = [];
    try {
        while(msg.certificate_list.length() > 0){
            // each entry in msg.certificate_list is a vector with 3 len bytes
            cert = $69688044bad9a4b6$var$readVector(msg.certificate_list, 3);
            asn1 = $fz7FM.asn1.fromDer(cert);
            cert = $fz7FM.pki.certificateFromAsn1(asn1, true);
            certs.push(cert);
        }
    } catch (ex) {
        return c.error(c, {
            message: "Could not parse certificate list.",
            cause: ex,
            send: true,
            alert: {
                level: $69688044bad9a4b6$var$tls.Alert.Level.fatal,
                description: $69688044bad9a4b6$var$tls.Alert.Description.bad_certificate
            }
        });
    }
    // ensure at least 1 certificate was provided if in client-mode
    // or if verifyClient was set to true to require a certificate
    // (as opposed to 'optional')
    var client = c.entity === $69688044bad9a4b6$var$tls.ConnectionEnd.client;
    if ((client || c.verifyClient === true) && certs.length === 0) // error, no certificate
    c.error(c, {
        message: client ? "No server certificate provided." : "No client certificate provided.",
        send: true,
        alert: {
            level: $69688044bad9a4b6$var$tls.Alert.Level.fatal,
            description: $69688044bad9a4b6$var$tls.Alert.Description.illegal_parameter
        }
    });
    else if (certs.length === 0) // no certs to verify
    // expect a ServerKeyExchange or ClientKeyExchange message next
    c.expect = client ? $69688044bad9a4b6$var$SKE : $69688044bad9a4b6$var$CKE;
    else {
        // save certificate in session
        if (client) c.session.serverCertificate = certs[0];
        else c.session.clientCertificate = certs[0];
        if ($69688044bad9a4b6$var$tls.verifyCertificateChain(c, certs)) // expect a ServerKeyExchange or ClientKeyExchange message next
        c.expect = client ? $69688044bad9a4b6$var$SKE : $69688044bad9a4b6$var$CKE;
    }
    // continue
    c.process();
};
/**
 * Called when a client receives a ServerKeyExchange record.
 *
 * When this message will be sent:
 *   This message will be sent immediately after the server certificate
 *   message (or the server hello message, if this is an anonymous
 *   negotiation).
 *
 *   The server key exchange message is sent by the server only when the
 *   server certificate message (if sent) does not contain enough data to
 *   allow the client to exchange a premaster secret.
 *
 * Meaning of this message:
 *   This message conveys cryptographic information to allow the client to
 *   communicate the premaster secret: either an RSA public key to encrypt
 *   the premaster secret with, or a Diffie-Hellman public key with which the
 *   client can complete a key exchange (with the result being the premaster
 *   secret.)
 *
 * enum {
 *   dhe_dss, dhe_rsa, dh_anon, rsa, dh_dss, dh_rsa
 * } KeyExchangeAlgorithm;
 *
 * struct {
 *   opaque dh_p<1..2^16-1>;
 *   opaque dh_g<1..2^16-1>;
 *   opaque dh_Ys<1..2^16-1>;
 * } ServerDHParams;
 *
 * struct {
 *   select(KeyExchangeAlgorithm) {
 *     case dh_anon:
 *       ServerDHParams params;
 *     case dhe_dss:
 *     case dhe_rsa:
 *       ServerDHParams params;
 *       digitally-signed struct {
 *         opaque client_random[32];
 *         opaque server_random[32];
 *         ServerDHParams params;
 *       } signed_params;
 *     case rsa:
 *     case dh_dss:
 *     case dh_rsa:
 *       struct {};
 *   };
 * } ServerKeyExchange;
 *
 * @param c the connection.
 * @param record the record.
 * @param length the length of the handshake message.
 */ $69688044bad9a4b6$var$tls.handleServerKeyExchange = function(c, record, length) {
    // this implementation only supports RSA, no Diffie-Hellman support
    // so any length > 0 is invalid
    if (length > 0) return c.error(c, {
        message: "Invalid key parameters. Only RSA is supported.",
        send: true,
        alert: {
            level: $69688044bad9a4b6$var$tls.Alert.Level.fatal,
            description: $69688044bad9a4b6$var$tls.Alert.Description.unsupported_certificate
        }
    });
    // expect an optional CertificateRequest message next
    c.expect = $69688044bad9a4b6$var$SCR;
    // continue
    c.process();
};
/**
 * Called when a client receives a ClientKeyExchange record.
 *
 * @param c the connection.
 * @param record the record.
 * @param length the length of the handshake message.
 */ $69688044bad9a4b6$var$tls.handleClientKeyExchange = function(c, record, length) {
    // this implementation only supports RSA, no Diffie-Hellman support
    // so any length < 48 is invalid
    if (length < 48) return c.error(c, {
        message: "Invalid key parameters. Only RSA is supported.",
        send: true,
        alert: {
            level: $69688044bad9a4b6$var$tls.Alert.Level.fatal,
            description: $69688044bad9a4b6$var$tls.Alert.Description.unsupported_certificate
        }
    });
    var b = record.fragment;
    var msg = {
        enc_pre_master_secret: $69688044bad9a4b6$var$readVector(b, 2).getBytes()
    };
    // do rsa decryption
    var privateKey = null;
    if (c.getPrivateKey) try {
        privateKey = c.getPrivateKey(c, c.session.serverCertificate);
        privateKey = $fz7FM.pki.privateKeyFromPem(privateKey);
    } catch (ex) {
        c.error(c, {
            message: "Could not get private key.",
            cause: ex,
            send: true,
            alert: {
                level: $69688044bad9a4b6$var$tls.Alert.Level.fatal,
                description: $69688044bad9a4b6$var$tls.Alert.Description.internal_error
            }
        });
    }
    if (privateKey === null) return c.error(c, {
        message: "No private key set.",
        send: true,
        alert: {
            level: $69688044bad9a4b6$var$tls.Alert.Level.fatal,
            description: $69688044bad9a4b6$var$tls.Alert.Description.internal_error
        }
    });
    try {
        // decrypt 48-byte pre-master secret
        var sp = c.session.sp;
        sp.pre_master_secret = privateKey.decrypt(msg.enc_pre_master_secret);
        // ensure client hello version matches first 2 bytes
        var version = c.session.clientHelloVersion;
        if (version.major !== sp.pre_master_secret.charCodeAt(0) || version.minor !== sp.pre_master_secret.charCodeAt(1)) // error, do not send alert (see BLEI attack below)
        throw new Error("TLS version rollback attack detected.");
    } catch (ex) {
        /* Note: Daniel Bleichenbacher [BLEI] can be used to attack a
      TLS server which is using PKCS#1 encoded RSA, so instead of
      failing here, we generate 48 random bytes and use that as
      the pre-master secret. */ sp.pre_master_secret = $fz7FM.random.getBytes(48);
    }
    // expect a CertificateVerify message if a Certificate was received that
    // does not have fixed Diffie-Hellman params, otherwise expect
    // ChangeCipherSpec
    c.expect = $69688044bad9a4b6$var$CCC;
    if (c.session.clientCertificate !== null) // only RSA support, so expect CertificateVerify
    // TODO: support Diffie-Hellman
    c.expect = $69688044bad9a4b6$var$CCV;
    // continue
    c.process();
};
/**
 * Called when a client receives a CertificateRequest record.
 *
 * When this message will be sent:
 *   A non-anonymous server can optionally request a certificate from the
 *   client, if appropriate for the selected cipher suite. This message, if
 *   sent, will immediately follow the Server Key Exchange message (if it is
 *   sent; otherwise, the Server Certificate message).
 *
 * enum {
 *   rsa_sign(1), dss_sign(2), rsa_fixed_dh(3), dss_fixed_dh(4),
 *   rsa_ephemeral_dh_RESERVED(5), dss_ephemeral_dh_RESERVED(6),
 *   fortezza_dms_RESERVED(20), (255)
 * } ClientCertificateType;
 *
 * opaque DistinguishedName<1..2^16-1>;
 *
 * struct {
 *   ClientCertificateType certificate_types<1..2^8-1>;
 *   SignatureAndHashAlgorithm supported_signature_algorithms<2^16-1>;
 *   DistinguishedName certificate_authorities<0..2^16-1>;
 * } CertificateRequest;
 *
 * @param c the connection.
 * @param record the record.
 * @param length the length of the handshake message.
 */ $69688044bad9a4b6$var$tls.handleCertificateRequest = function(c, record, length) {
    // minimum of 3 bytes in message
    if (length < 3) return c.error(c, {
        message: "Invalid CertificateRequest. Message too short.",
        send: true,
        alert: {
            level: $69688044bad9a4b6$var$tls.Alert.Level.fatal,
            description: $69688044bad9a4b6$var$tls.Alert.Description.illegal_parameter
        }
    });
    // TODO: TLS 1.2+ has different format including
    // SignatureAndHashAlgorithm after cert types
    var b = record.fragment;
    var msg = {
        certificate_types: $69688044bad9a4b6$var$readVector(b, 1),
        certificate_authorities: $69688044bad9a4b6$var$readVector(b, 2)
    };
    // save certificate request in session
    c.session.certificateRequest = msg;
    // expect a ServerHelloDone message next
    c.expect = $69688044bad9a4b6$var$SHD;
    // continue
    c.process();
};
/**
 * Called when a server receives a CertificateVerify record.
 *
 * @param c the connection.
 * @param record the record.
 * @param length the length of the handshake message.
 */ $69688044bad9a4b6$var$tls.handleCertificateVerify = function(c, record, length) {
    if (length < 2) return c.error(c, {
        message: "Invalid CertificateVerify. Message too short.",
        send: true,
        alert: {
            level: $69688044bad9a4b6$var$tls.Alert.Level.fatal,
            description: $69688044bad9a4b6$var$tls.Alert.Description.illegal_parameter
        }
    });
    // rewind to get full bytes for message so it can be manually
    // digested below (special case for CertificateVerify messages because
    // they must be digested *after* handling as opposed to all others)
    var b = record.fragment;
    b.read -= 4;
    var msgBytes = b.bytes();
    b.read += 4;
    var msg = {
        signature: $69688044bad9a4b6$var$readVector(b, 2).getBytes()
    };
    // TODO: add support for DSA
    // generate data to verify
    var verify = $fz7FM.util.createBuffer();
    verify.putBuffer(c.session.md5.digest());
    verify.putBuffer(c.session.sha1.digest());
    verify = verify.getBytes();
    try {
        var cert = c.session.clientCertificate;
        /*b = forge.pki.rsa.decrypt(
      msg.signature, cert.publicKey, true, verify.length);
    if(b !== verify) {*/ if (!cert.publicKey.verify(verify, msg.signature, "NONE")) throw new Error("CertificateVerify signature does not match.");
        // digest message now that it has been handled
        c.session.md5.update(msgBytes);
        c.session.sha1.update(msgBytes);
    } catch (ex) {
        return c.error(c, {
            message: "Bad signature in CertificateVerify.",
            send: true,
            alert: {
                level: $69688044bad9a4b6$var$tls.Alert.Level.fatal,
                description: $69688044bad9a4b6$var$tls.Alert.Description.handshake_failure
            }
        });
    }
    // expect ChangeCipherSpec
    c.expect = $69688044bad9a4b6$var$CCC;
    // continue
    c.process();
};
/**
 * Called when a client receives a ServerHelloDone record.
 *
 * When this message will be sent:
 *   The server hello done message is sent by the server to indicate the end
 *   of the server hello and associated messages. After sending this message
 *   the server will wait for a client response.
 *
 * Meaning of this message:
 *   This message means that the server is done sending messages to support
 *   the key exchange, and the client can proceed with its phase of the key
 *   exchange.
 *
 *   Upon receipt of the server hello done message the client should verify
 *   that the server provided a valid certificate if required and check that
 *   the server hello parameters are acceptable.
 *
 * struct {} ServerHelloDone;
 *
 * @param c the connection.
 * @param record the record.
 * @param length the length of the handshake message.
 */ $69688044bad9a4b6$var$tls.handleServerHelloDone = function(c, record, length) {
    // len must be 0 bytes
    if (length > 0) return c.error(c, {
        message: "Invalid ServerHelloDone message. Invalid length.",
        send: true,
        alert: {
            level: $69688044bad9a4b6$var$tls.Alert.Level.fatal,
            description: $69688044bad9a4b6$var$tls.Alert.Description.record_overflow
        }
    });
    if (c.serverCertificate === null) {
        // no server certificate was provided
        var error = {
            message: "No server certificate provided. Not enough security.",
            send: true,
            alert: {
                level: $69688044bad9a4b6$var$tls.Alert.Level.fatal,
                description: $69688044bad9a4b6$var$tls.Alert.Description.insufficient_security
            }
        };
        // call application callback
        var depth = 0;
        var ret = c.verify(c, error.alert.description, depth, []);
        if (ret !== true) {
            // check for custom alert info
            if (ret || ret === 0) {
                // set custom message and alert description
                if (typeof ret === "object" && !$fz7FM.util.isArray(ret)) {
                    if (ret.message) error.message = ret.message;
                    if (ret.alert) error.alert.description = ret.alert;
                } else if (typeof ret === "number") // set custom alert description
                error.alert.description = ret;
            }
            // send error
            return c.error(c, error);
        }
    }
    // create client certificate message if requested
    if (c.session.certificateRequest !== null) {
        record = $69688044bad9a4b6$var$tls.createRecord(c, {
            type: $69688044bad9a4b6$var$tls.ContentType.handshake,
            data: $69688044bad9a4b6$var$tls.createCertificate(c)
        });
        $69688044bad9a4b6$var$tls.queue(c, record);
    }
    // create client key exchange message
    record = $69688044bad9a4b6$var$tls.createRecord(c, {
        type: $69688044bad9a4b6$var$tls.ContentType.handshake,
        data: $69688044bad9a4b6$var$tls.createClientKeyExchange(c)
    });
    $69688044bad9a4b6$var$tls.queue(c, record);
    // expect no messages until the following callback has been called
    c.expect = $69688044bad9a4b6$var$SER;
    // create callback to handle client signature (for client-certs)
    var callback = function callback(c, signature) {
        if (c.session.certificateRequest !== null && c.session.clientCertificate !== null) // create certificate verify message
        $69688044bad9a4b6$var$tls.queue(c, $69688044bad9a4b6$var$tls.createRecord(c, {
            type: $69688044bad9a4b6$var$tls.ContentType.handshake,
            data: $69688044bad9a4b6$var$tls.createCertificateVerify(c, signature)
        }));
        // create change cipher spec message
        $69688044bad9a4b6$var$tls.queue(c, $69688044bad9a4b6$var$tls.createRecord(c, {
            type: $69688044bad9a4b6$var$tls.ContentType.change_cipher_spec,
            data: $69688044bad9a4b6$var$tls.createChangeCipherSpec()
        }));
        // create pending state
        c.state.pending = $69688044bad9a4b6$var$tls.createConnectionState(c);
        // change current write state to pending write state
        c.state.current.write = c.state.pending.write;
        // create finished message
        $69688044bad9a4b6$var$tls.queue(c, $69688044bad9a4b6$var$tls.createRecord(c, {
            type: $69688044bad9a4b6$var$tls.ContentType.handshake,
            data: $69688044bad9a4b6$var$tls.createFinished(c)
        }));
        // expect a server ChangeCipherSpec message next
        c.expect = $69688044bad9a4b6$var$SCC;
        // send records
        $69688044bad9a4b6$var$tls.flush(c);
        // continue
        c.process();
    };
    // if there is no certificate request or no client certificate, do
    // callback immediately
    if (c.session.certificateRequest === null || c.session.clientCertificate === null) return callback(c, null);
    // otherwise get the client signature
    $69688044bad9a4b6$var$tls.getClientSignature(c, callback);
};
/**
 * Called when a ChangeCipherSpec record is received.
 *
 * @param c the connection.
 * @param record the record.
 */ $69688044bad9a4b6$var$tls.handleChangeCipherSpec = function(c, record) {
    if (record.fragment.getByte() !== 0x01) return c.error(c, {
        message: "Invalid ChangeCipherSpec message received.",
        send: true,
        alert: {
            level: $69688044bad9a4b6$var$tls.Alert.Level.fatal,
            description: $69688044bad9a4b6$var$tls.Alert.Description.illegal_parameter
        }
    });
    // create pending state if:
    // 1. Resuming session in client mode OR
    // 2. NOT resuming session in server mode
    var client = c.entity === $69688044bad9a4b6$var$tls.ConnectionEnd.client;
    if (c.session.resuming && client || !c.session.resuming && !client) c.state.pending = $69688044bad9a4b6$var$tls.createConnectionState(c);
    // change current read state to pending read state
    c.state.current.read = c.state.pending.read;
    // clear pending state if:
    // 1. NOT resuming session in client mode OR
    // 2. resuming a session in server mode
    if (!c.session.resuming && client || c.session.resuming && !client) c.state.pending = null;
    // expect a Finished record next
    c.expect = client ? $69688044bad9a4b6$var$SFI : $69688044bad9a4b6$var$CFI;
    // continue
    c.process();
};
/**
 * Called when a Finished record is received.
 *
 * When this message will be sent:
 *   A finished message is always sent immediately after a change
 *   cipher spec message to verify that the key exchange and
 *   authentication processes were successful. It is essential that a
 *   change cipher spec message be received between the other
 *   handshake messages and the Finished message.
 *
 * Meaning of this message:
 *   The finished message is the first protected with the just-
 *   negotiated algorithms, keys, and secrets. Recipients of finished
 *   messages must verify that the contents are correct.  Once a side
 *   has sent its Finished message and received and validated the
 *   Finished message from its peer, it may begin to send and receive
 *   application data over the connection.
 *
 * struct {
 *   opaque verify_data[verify_data_length];
 * } Finished;
 *
 * verify_data
 *   PRF(master_secret, finished_label, Hash(handshake_messages))
 *     [0..verify_data_length-1];
 *
 * finished_label
 *   For Finished messages sent by the client, the string
 *   "client finished". For Finished messages sent by the server, the
 *   string "server finished".
 *
 * verify_data_length depends on the cipher suite. If it is not specified
 * by the cipher suite, then it is 12. Versions of TLS < 1.2 always used
 * 12 bytes.
 *
 * @param c the connection.
 * @param record the record.
 * @param length the length of the handshake message.
 */ $69688044bad9a4b6$var$tls.handleFinished = function(c, record, length) {
    // rewind to get full bytes for message so it can be manually
    // digested below (special case for Finished messages because they
    // must be digested *after* handling as opposed to all others)
    var b = record.fragment;
    b.read -= 4;
    var msgBytes = b.bytes();
    b.read += 4;
    // message contains only verify_data
    var vd = record.fragment.getBytes();
    // ensure verify data is correct
    b = $fz7FM.util.createBuffer();
    b.putBuffer(c.session.md5.digest());
    b.putBuffer(c.session.sha1.digest());
    // set label based on entity type
    var client = c.entity === $69688044bad9a4b6$var$tls.ConnectionEnd.client;
    var label = client ? "server finished" : "client finished";
    // TODO: determine prf function and verify length for TLS 1.2
    var sp = c.session.sp;
    var vdl = 12;
    var prf = $69688044bad9a4b6$var$prf_TLS1;
    b = prf(sp.master_secret, label, b.getBytes(), vdl);
    if (b.getBytes() !== vd) return c.error(c, {
        message: "Invalid verify_data in Finished message.",
        send: true,
        alert: {
            level: $69688044bad9a4b6$var$tls.Alert.Level.fatal,
            description: $69688044bad9a4b6$var$tls.Alert.Description.decrypt_error
        }
    });
    // digest finished message now that it has been handled
    c.session.md5.update(msgBytes);
    c.session.sha1.update(msgBytes);
    // resuming session as client or NOT resuming session as server
    if (c.session.resuming && client || !c.session.resuming && !client) {
        // create change cipher spec message
        $69688044bad9a4b6$var$tls.queue(c, $69688044bad9a4b6$var$tls.createRecord(c, {
            type: $69688044bad9a4b6$var$tls.ContentType.change_cipher_spec,
            data: $69688044bad9a4b6$var$tls.createChangeCipherSpec()
        }));
        // change current write state to pending write state, clear pending
        c.state.current.write = c.state.pending.write;
        c.state.pending = null;
        // create finished message
        $69688044bad9a4b6$var$tls.queue(c, $69688044bad9a4b6$var$tls.createRecord(c, {
            type: $69688044bad9a4b6$var$tls.ContentType.handshake,
            data: $69688044bad9a4b6$var$tls.createFinished(c)
        }));
    }
    // expect application data next
    c.expect = client ? $69688044bad9a4b6$var$SAD : $69688044bad9a4b6$var$CAD;
    // handshake complete
    c.handshaking = false;
    ++c.handshakes;
    // save access to peer certificate
    c.peerCertificate = client ? c.session.serverCertificate : c.session.clientCertificate;
    // send records
    $69688044bad9a4b6$var$tls.flush(c);
    // now connected
    c.isConnected = true;
    c.connected(c);
    // continue
    c.process();
};
/**
 * Called when an Alert record is received.
 *
 * @param c the connection.
 * @param record the record.
 */ $69688044bad9a4b6$var$tls.handleAlert = function(c, record) {
    // read alert
    var b = record.fragment;
    var alert = {
        level: b.getByte(),
        description: b.getByte()
    };
    // TODO: consider using a table?
    // get appropriate message
    var msg;
    switch(alert.description){
        case $69688044bad9a4b6$var$tls.Alert.Description.close_notify:
            msg = "Connection closed.";
            break;
        case $69688044bad9a4b6$var$tls.Alert.Description.unexpected_message:
            msg = "Unexpected message.";
            break;
        case $69688044bad9a4b6$var$tls.Alert.Description.bad_record_mac:
            msg = "Bad record MAC.";
            break;
        case $69688044bad9a4b6$var$tls.Alert.Description.decryption_failed:
            msg = "Decryption failed.";
            break;
        case $69688044bad9a4b6$var$tls.Alert.Description.record_overflow:
            msg = "Record overflow.";
            break;
        case $69688044bad9a4b6$var$tls.Alert.Description.decompression_failure:
            msg = "Decompression failed.";
            break;
        case $69688044bad9a4b6$var$tls.Alert.Description.handshake_failure:
            msg = "Handshake failure.";
            break;
        case $69688044bad9a4b6$var$tls.Alert.Description.bad_certificate:
            msg = "Bad certificate.";
            break;
        case $69688044bad9a4b6$var$tls.Alert.Description.unsupported_certificate:
            msg = "Unsupported certificate.";
            break;
        case $69688044bad9a4b6$var$tls.Alert.Description.certificate_revoked:
            msg = "Certificate revoked.";
            break;
        case $69688044bad9a4b6$var$tls.Alert.Description.certificate_expired:
            msg = "Certificate expired.";
            break;
        case $69688044bad9a4b6$var$tls.Alert.Description.certificate_unknown:
            msg = "Certificate unknown.";
            break;
        case $69688044bad9a4b6$var$tls.Alert.Description.illegal_parameter:
            msg = "Illegal parameter.";
            break;
        case $69688044bad9a4b6$var$tls.Alert.Description.unknown_ca:
            msg = "Unknown certificate authority.";
            break;
        case $69688044bad9a4b6$var$tls.Alert.Description.access_denied:
            msg = "Access denied.";
            break;
        case $69688044bad9a4b6$var$tls.Alert.Description.decode_error:
            msg = "Decode error.";
            break;
        case $69688044bad9a4b6$var$tls.Alert.Description.decrypt_error:
            msg = "Decrypt error.";
            break;
        case $69688044bad9a4b6$var$tls.Alert.Description.export_restriction:
            msg = "Export restriction.";
            break;
        case $69688044bad9a4b6$var$tls.Alert.Description.protocol_version:
            msg = "Unsupported protocol version.";
            break;
        case $69688044bad9a4b6$var$tls.Alert.Description.insufficient_security:
            msg = "Insufficient security.";
            break;
        case $69688044bad9a4b6$var$tls.Alert.Description.internal_error:
            msg = "Internal error.";
            break;
        case $69688044bad9a4b6$var$tls.Alert.Description.user_canceled:
            msg = "User canceled.";
            break;
        case $69688044bad9a4b6$var$tls.Alert.Description.no_renegotiation:
            msg = "Renegotiation not supported.";
            break;
        default:
            msg = "Unknown error.";
            break;
    }
    // close connection on close_notify, not an error
    if (alert.description === $69688044bad9a4b6$var$tls.Alert.Description.close_notify) return c.close();
    // call error handler
    c.error(c, {
        message: msg,
        send: false,
        // origin is the opposite end
        origin: c.entity === $69688044bad9a4b6$var$tls.ConnectionEnd.client ? "server" : "client",
        alert: alert
    });
    // continue
    c.process();
};
/**
 * Called when a Handshake record is received.
 *
 * @param c the connection.
 * @param record the record.
 */ $69688044bad9a4b6$var$tls.handleHandshake = function(c, record) {
    // get the handshake type and message length
    var b = record.fragment;
    var type = b.getByte();
    var length = b.getInt24();
    // see if the record fragment doesn't yet contain the full message
    if (length > b.length()) {
        // cache the record, clear its fragment, and reset the buffer read
        // pointer before the type and length were read
        c.fragmented = record;
        record.fragment = $fz7FM.util.createBuffer();
        b.read -= 4;
        // continue
        return c.process();
    }
    // full message now available, clear cache, reset read pointer to
    // before type and length
    c.fragmented = null;
    b.read -= 4;
    // save the handshake bytes for digestion after handler is found
    // (include type and length of handshake msg)
    var bytes = b.bytes(length + 4);
    // restore read pointer
    b.read += 4;
    // handle expected message
    if (type in $69688044bad9a4b6$var$hsTable[c.entity][c.expect]) {
        // initialize server session
        if (c.entity === $69688044bad9a4b6$var$tls.ConnectionEnd.server && !c.open && !c.fail) {
            c.handshaking = true;
            c.session = {
                version: null,
                extensions: {
                    server_name: {
                        serverNameList: []
                    }
                },
                cipherSuite: null,
                compressionMethod: null,
                serverCertificate: null,
                clientCertificate: null,
                md5: $fz7FM.md.md5.create(),
                sha1: $fz7FM.md.sha1.create()
            };
        }
        /* Update handshake messages digest. Finished and CertificateVerify
      messages are not digested here. They can't be digested as part of
      the verify_data that they contain. These messages are manually
      digested in their handlers. HelloRequest messages are simply never
      included in the handshake message digest according to spec. */ if (type !== $69688044bad9a4b6$var$tls.HandshakeType.hello_request && type !== $69688044bad9a4b6$var$tls.HandshakeType.certificate_verify && type !== $69688044bad9a4b6$var$tls.HandshakeType.finished) {
            c.session.md5.update(bytes);
            c.session.sha1.update(bytes);
        }
        // handle specific handshake type record
        $69688044bad9a4b6$var$hsTable[c.entity][c.expect][type](c, record, length);
    } else // unexpected record
    $69688044bad9a4b6$var$tls.handleUnexpected(c, record);
};
/**
 * Called when an ApplicationData record is received.
 *
 * @param c the connection.
 * @param record the record.
 */ $69688044bad9a4b6$var$tls.handleApplicationData = function(c, record) {
    // buffer data, notify that its ready
    c.data.putBuffer(record.fragment);
    c.dataReady(c);
    // continue
    c.process();
};
/**
 * Called when a Heartbeat record is received.
 *
 * @param c the connection.
 * @param record the record.
 */ $69688044bad9a4b6$var$tls.handleHeartbeat = function(c, record) {
    // get the heartbeat type and payload
    var b = record.fragment;
    var type = b.getByte();
    var length = b.getInt16();
    var payload = b.getBytes(length);
    if (type === $69688044bad9a4b6$var$tls.HeartbeatMessageType.heartbeat_request) {
        // discard request during handshake or if length is too large
        if (c.handshaking || length > payload.length) // continue
        return c.process();
        // retransmit payload
        $69688044bad9a4b6$var$tls.queue(c, $69688044bad9a4b6$var$tls.createRecord(c, {
            type: $69688044bad9a4b6$var$tls.ContentType.heartbeat,
            data: $69688044bad9a4b6$var$tls.createHeartbeat($69688044bad9a4b6$var$tls.HeartbeatMessageType.heartbeat_response, payload)
        }));
        $69688044bad9a4b6$var$tls.flush(c);
    } else if (type === $69688044bad9a4b6$var$tls.HeartbeatMessageType.heartbeat_response) {
        // check payload against expected payload, discard heartbeat if no match
        if (payload !== c.expectedHeartbeatPayload) // continue
        return c.process();
        // notify that a valid heartbeat was received
        if (c.heartbeatReceived) c.heartbeatReceived(c, $fz7FM.util.createBuffer(payload));
    }
    // continue
    c.process();
};
/**
 * The transistional state tables for receiving TLS records. It maps the
 * current TLS engine state and a received record to a function to handle the
 * record and update the state.
 *
 * For instance, if the current state is SHE, then the TLS engine is expecting
 * a ServerHello record. Once a record is received, the handler function is
 * looked up using the state SHE and the record's content type.
 *
 * The resulting function will either be an error handler or a record handler.
 * The function will take whatever action is appropriate and update the state
 * for the next record.
 *
 * The states are all based on possible server record types. Note that the
 * client will never specifically expect to receive a HelloRequest or an alert
 * from the server so there is no state that reflects this. These messages may
 * occur at any time.
 *
 * There are two tables for mapping states because there is a second tier of
 * types for handshake messages. Once a record with a content type of handshake
 * is received, the handshake record handler will look up the handshake type in
 * the secondary map to get its appropriate handler.
 *
 * Valid message orders are as follows:
 *
 * =======================FULL HANDSHAKE======================
 * Client                                               Server
 *
 * ClientHello                  -------->
 *                                                 ServerHello
 *                                                Certificate*
 *                                          ServerKeyExchange*
 *                                         CertificateRequest*
 *                              <--------      ServerHelloDone
 * Certificate*
 * ClientKeyExchange
 * CertificateVerify*
 * [ChangeCipherSpec]
 * Finished                     -------->
 *                                          [ChangeCipherSpec]
 *                              <--------             Finished
 * Application Data             <------->     Application Data
 *
 * =====================SESSION RESUMPTION=====================
 * Client                                                Server
 *
 * ClientHello                   -------->
 *                                                  ServerHello
 *                                           [ChangeCipherSpec]
 *                               <--------             Finished
 * [ChangeCipherSpec]
 * Finished                      -------->
 * Application Data              <------->     Application Data
 */ // client expect states (indicate which records are expected to be received)
var $69688044bad9a4b6$var$SHE = 0; // rcv server hello
var $69688044bad9a4b6$var$SCE = 1; // rcv server certificate
var $69688044bad9a4b6$var$SKE = 2; // rcv server key exchange
var $69688044bad9a4b6$var$SCR = 3; // rcv certificate request
var $69688044bad9a4b6$var$SHD = 4; // rcv server hello done
var $69688044bad9a4b6$var$SCC = 5; // rcv change cipher spec
var $69688044bad9a4b6$var$SFI = 6; // rcv finished
var $69688044bad9a4b6$var$SAD = 7; // rcv application data
var $69688044bad9a4b6$var$SER = 8; // not expecting any messages at this point
// server expect states
var $69688044bad9a4b6$var$CHE = 0; // rcv client hello
var $69688044bad9a4b6$var$CCE = 1; // rcv client certificate
var $69688044bad9a4b6$var$CKE = 2; // rcv client key exchange
var $69688044bad9a4b6$var$CCV = 3; // rcv certificate verify
var $69688044bad9a4b6$var$CCC = 4; // rcv change cipher spec
var $69688044bad9a4b6$var$CFI = 5; // rcv finished
var $69688044bad9a4b6$var$CAD = 6; // rcv application data
var $69688044bad9a4b6$var$CER = 7; // not expecting any messages at this point
// map client current expect state and content type to function
var $69688044bad9a4b6$var$__ = $69688044bad9a4b6$var$tls.handleUnexpected;
var $69688044bad9a4b6$var$R0 = $69688044bad9a4b6$var$tls.handleChangeCipherSpec;
var $69688044bad9a4b6$var$R1 = $69688044bad9a4b6$var$tls.handleAlert;
var $69688044bad9a4b6$var$R2 = $69688044bad9a4b6$var$tls.handleHandshake;
var $69688044bad9a4b6$var$R3 = $69688044bad9a4b6$var$tls.handleApplicationData;
var $69688044bad9a4b6$var$R4 = $69688044bad9a4b6$var$tls.handleHeartbeat;
var $69688044bad9a4b6$var$ctTable = [];
$69688044bad9a4b6$var$ctTable[$69688044bad9a4b6$var$tls.ConnectionEnd.client] = [
    //      CC,AL,HS,AD,HB
    /*SHE*/ [
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$R1,
        $69688044bad9a4b6$var$R2,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$R4
    ],
    /*SCE*/ [
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$R1,
        $69688044bad9a4b6$var$R2,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$R4
    ],
    /*SKE*/ [
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$R1,
        $69688044bad9a4b6$var$R2,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$R4
    ],
    /*SCR*/ [
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$R1,
        $69688044bad9a4b6$var$R2,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$R4
    ],
    /*SHD*/ [
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$R1,
        $69688044bad9a4b6$var$R2,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$R4
    ],
    /*SCC*/ [
        $69688044bad9a4b6$var$R0,
        $69688044bad9a4b6$var$R1,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$R4
    ],
    /*SFI*/ [
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$R1,
        $69688044bad9a4b6$var$R2,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$R4
    ],
    /*SAD*/ [
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$R1,
        $69688044bad9a4b6$var$R2,
        $69688044bad9a4b6$var$R3,
        $69688044bad9a4b6$var$R4
    ],
    /*SER*/ [
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$R1,
        $69688044bad9a4b6$var$R2,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$R4
    ]
];
// map server current expect state and content type to function
$69688044bad9a4b6$var$ctTable[$69688044bad9a4b6$var$tls.ConnectionEnd.server] = [
    //      CC,AL,HS,AD
    /*CHE*/ [
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$R1,
        $69688044bad9a4b6$var$R2,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$R4
    ],
    /*CCE*/ [
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$R1,
        $69688044bad9a4b6$var$R2,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$R4
    ],
    /*CKE*/ [
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$R1,
        $69688044bad9a4b6$var$R2,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$R4
    ],
    /*CCV*/ [
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$R1,
        $69688044bad9a4b6$var$R2,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$R4
    ],
    /*CCC*/ [
        $69688044bad9a4b6$var$R0,
        $69688044bad9a4b6$var$R1,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$R4
    ],
    /*CFI*/ [
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$R1,
        $69688044bad9a4b6$var$R2,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$R4
    ],
    /*CAD*/ [
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$R1,
        $69688044bad9a4b6$var$R2,
        $69688044bad9a4b6$var$R3,
        $69688044bad9a4b6$var$R4
    ],
    /*CER*/ [
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$R1,
        $69688044bad9a4b6$var$R2,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$R4
    ]
];
// map client current expect state and handshake type to function
var $69688044bad9a4b6$var$H0 = $69688044bad9a4b6$var$tls.handleHelloRequest;
var $69688044bad9a4b6$var$H1 = $69688044bad9a4b6$var$tls.handleServerHello;
var $69688044bad9a4b6$var$H2 = $69688044bad9a4b6$var$tls.handleCertificate;
var $69688044bad9a4b6$var$H3 = $69688044bad9a4b6$var$tls.handleServerKeyExchange;
var $69688044bad9a4b6$var$H4 = $69688044bad9a4b6$var$tls.handleCertificateRequest;
var $69688044bad9a4b6$var$H5 = $69688044bad9a4b6$var$tls.handleServerHelloDone;
var $69688044bad9a4b6$var$H6 = $69688044bad9a4b6$var$tls.handleFinished;
var $69688044bad9a4b6$var$hsTable = [];
$69688044bad9a4b6$var$hsTable[$69688044bad9a4b6$var$tls.ConnectionEnd.client] = [
    //      HR,01,SH,03,04,05,06,07,08,09,10,SC,SK,CR,HD,15,CK,17,18,19,FI
    /*SHE*/ [
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$H1,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__
    ],
    /*SCE*/ [
        $69688044bad9a4b6$var$H0,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$H2,
        $69688044bad9a4b6$var$H3,
        $69688044bad9a4b6$var$H4,
        $69688044bad9a4b6$var$H5,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__
    ],
    /*SKE*/ [
        $69688044bad9a4b6$var$H0,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$H3,
        $69688044bad9a4b6$var$H4,
        $69688044bad9a4b6$var$H5,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__
    ],
    /*SCR*/ [
        $69688044bad9a4b6$var$H0,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$H4,
        $69688044bad9a4b6$var$H5,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__
    ],
    /*SHD*/ [
        $69688044bad9a4b6$var$H0,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$H5,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__
    ],
    /*SCC*/ [
        $69688044bad9a4b6$var$H0,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__
    ],
    /*SFI*/ [
        $69688044bad9a4b6$var$H0,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$H6
    ],
    /*SAD*/ [
        $69688044bad9a4b6$var$H0,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__
    ],
    /*SER*/ [
        $69688044bad9a4b6$var$H0,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__
    ]
];
// map server current expect state and handshake type to function
// Note: CAD[CH] does not map to FB because renegotation is prohibited
var $69688044bad9a4b6$var$H7 = $69688044bad9a4b6$var$tls.handleClientHello;
var $69688044bad9a4b6$var$H8 = $69688044bad9a4b6$var$tls.handleClientKeyExchange;
var $69688044bad9a4b6$var$H9 = $69688044bad9a4b6$var$tls.handleCertificateVerify;
$69688044bad9a4b6$var$hsTable[$69688044bad9a4b6$var$tls.ConnectionEnd.server] = [
    //      01,CH,02,03,04,05,06,07,08,09,10,CC,12,13,14,CV,CK,17,18,19,FI
    /*CHE*/ [
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$H7,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__
    ],
    /*CCE*/ [
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$H2,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__
    ],
    /*CKE*/ [
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$H8,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__
    ],
    /*CCV*/ [
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$H9,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__
    ],
    /*CCC*/ [
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__
    ],
    /*CFI*/ [
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$H6
    ],
    /*CAD*/ [
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__
    ],
    /*CER*/ [
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__,
        $69688044bad9a4b6$var$__
    ]
];
/**
 * Generates the master_secret and keys using the given security parameters.
 *
 * The security parameters for a TLS connection state are defined as such:
 *
 * struct {
 *   ConnectionEnd          entity;
 *   PRFAlgorithm           prf_algorithm;
 *   BulkCipherAlgorithm    bulk_cipher_algorithm;
 *   CipherType             cipher_type;
 *   uint8                  enc_key_length;
 *   uint8                  block_length;
 *   uint8                  fixed_iv_length;
 *   uint8                  record_iv_length;
 *   MACAlgorithm           mac_algorithm;
 *   uint8                  mac_length;
 *   uint8                  mac_key_length;
 *   CompressionMethod      compression_algorithm;
 *   opaque                 master_secret[48];
 *   opaque                 client_random[32];
 *   opaque                 server_random[32];
 * } SecurityParameters;
 *
 * Note that this definition is from TLS 1.2. In TLS 1.0 some of these
 * parameters are ignored because, for instance, the PRFAlgorithm is a
 * builtin-fixed algorithm combining iterations of MD5 and SHA-1 in TLS 1.0.
 *
 * The Record Protocol requires an algorithm to generate keys required by the
 * current connection state.
 *
 * The master secret is expanded into a sequence of secure bytes, which is then
 * split to a client write MAC key, a server write MAC key, a client write
 * encryption key, and a server write encryption key. In TLS 1.0 a client write
 * IV and server write IV are also generated. Each of these is generated from
 * the byte sequence in that order. Unused values are empty. In TLS 1.2, some
 * AEAD ciphers may additionally require a client write IV and a server write
 * IV (see Section 6.2.3.3).
 *
 * When keys, MAC keys, and IVs are generated, the master secret is used as an
 * entropy source.
 *
 * To generate the key material, compute:
 *
 * master_secret = PRF(pre_master_secret, "master secret",
 *                     ClientHello.random + ServerHello.random)
 *
 * key_block = PRF(SecurityParameters.master_secret,
 *                 "key expansion",
 *                 SecurityParameters.server_random +
 *                 SecurityParameters.client_random);
 *
 * until enough output has been generated. Then, the key_block is
 * partitioned as follows:
 *
 * client_write_MAC_key[SecurityParameters.mac_key_length]
 * server_write_MAC_key[SecurityParameters.mac_key_length]
 * client_write_key[SecurityParameters.enc_key_length]
 * server_write_key[SecurityParameters.enc_key_length]
 * client_write_IV[SecurityParameters.fixed_iv_length]
 * server_write_IV[SecurityParameters.fixed_iv_length]
 *
 * In TLS 1.2, the client_write_IV and server_write_IV are only generated for
 * implicit nonce techniques as described in Section 3.2.1 of [AEAD]. This
 * implementation uses TLS 1.0 so IVs are generated.
 *
 * Implementation note: The currently defined cipher suite which requires the
 * most material is AES_256_CBC_SHA256. It requires 2 x 32 byte keys and 2 x 32
 * byte MAC keys, for a total 128 bytes of key material. In TLS 1.0 it also
 * requires 2 x 16 byte IVs, so it actually takes 160 bytes of key material.
 *
 * @param c the connection.
 * @param sp the security parameters to use.
 *
 * @return the security keys.
 */ $69688044bad9a4b6$var$tls.generateKeys = function(c, sp) {
    // TLS_RSA_WITH_AES_128_CBC_SHA (required to be compliant with TLS 1.2) &
    // TLS_RSA_WITH_AES_256_CBC_SHA are the only cipher suites implemented
    // at present
    // TLS_DHE_DSS_WITH_3DES_EDE_CBC_SHA is required to be compliant with
    // TLS 1.0 but we don't care right now because AES is better and we have
    // an implementation for it
    // TODO: TLS 1.2 implementation
    /*
  // determine the PRF
  var prf;
  switch(sp.prf_algorithm) {
  case tls.PRFAlgorithm.tls_prf_sha256:
    prf = prf_sha256;
    break;
  default:
    // should never happen
    throw new Error('Invalid PRF');
  }
  */ // TLS 1.0/1.1 implementation
    var prf = $69688044bad9a4b6$var$prf_TLS1;
    // concatenate server and client random
    var random = sp.client_random + sp.server_random;
    // only create master secret if session is new
    if (!c.session.resuming) {
        // create master secret, clean up pre-master secret
        sp.master_secret = prf(sp.pre_master_secret, "master secret", random, 48).bytes();
        sp.pre_master_secret = null;
    }
    // generate the amount of key material needed
    random = sp.server_random + sp.client_random;
    var length = 2 * sp.mac_key_length + 2 * sp.enc_key_length;
    // include IV for TLS/1.0
    var tls10 = c.version.major === $69688044bad9a4b6$var$tls.Versions.TLS_1_0.major && c.version.minor === $69688044bad9a4b6$var$tls.Versions.TLS_1_0.minor;
    if (tls10) length += 2 * sp.fixed_iv_length;
    var km = prf(sp.master_secret, "key expansion", random, length);
    // split the key material into the MAC and encryption keys
    var rval = {
        client_write_MAC_key: km.getBytes(sp.mac_key_length),
        server_write_MAC_key: km.getBytes(sp.mac_key_length),
        client_write_key: km.getBytes(sp.enc_key_length),
        server_write_key: km.getBytes(sp.enc_key_length)
    };
    // include TLS 1.0 IVs
    if (tls10) {
        rval.client_write_IV = km.getBytes(sp.fixed_iv_length);
        rval.server_write_IV = km.getBytes(sp.fixed_iv_length);
    }
    return rval;
};
/**
 * Creates a new initialized TLS connection state. A connection state has
 * a read mode and a write mode.
 *
 * compression state:
 *   The current state of the compression algorithm.
 *
 * cipher state:
 *   The current state of the encryption algorithm. This will consist of the
 *   scheduled key for that connection. For stream ciphers, this will also
 *   contain whatever state information is necessary to allow the stream to
 *   continue to encrypt or decrypt data.
 *
 * MAC key:
 *   The MAC key for the connection.
 *
 * sequence number:
 *   Each connection state contains a sequence number, which is maintained
 *   separately for read and write states. The sequence number MUST be set to
 *   zero whenever a connection state is made the active state. Sequence
 *   numbers are of type uint64 and may not exceed 2^64-1. Sequence numbers do
 *   not wrap. If a TLS implementation would need to wrap a sequence number,
 *   it must renegotiate instead. A sequence number is incremented after each
 *   record: specifically, the first record transmitted under a particular
 *   connection state MUST use sequence number 0.
 *
 * @param c the connection.
 *
 * @return the new initialized TLS connection state.
 */ $69688044bad9a4b6$var$tls.createConnectionState = function(c) {
    var client = c.entity === $69688044bad9a4b6$var$tls.ConnectionEnd.client;
    var createMode = function createMode() {
        var mode = {
            // two 32-bit numbers, first is most significant
            sequenceNumber: [
                0,
                0
            ],
            macKey: null,
            macLength: 0,
            macFunction: null,
            cipherState: null,
            cipherFunction: function cipherFunction(record) {
                return true;
            },
            compressionState: null,
            compressFunction: function compressFunction(record) {
                return true;
            },
            updateSequenceNumber: function updateSequenceNumber() {
                if (mode.sequenceNumber[1] === 0xFFFFFFFF) {
                    mode.sequenceNumber[1] = 0;
                    ++mode.sequenceNumber[0];
                } else ++mode.sequenceNumber[1];
            }
        };
        return mode;
    };
    var state = {
        read: createMode(),
        write: createMode()
    };
    // update function in read mode will decrypt then decompress a record
    state.read.update = function(c, record) {
        if (!state.read.cipherFunction(record, state.read)) c.error(c, {
            message: "Could not decrypt record or bad MAC.",
            send: true,
            alert: {
                level: $69688044bad9a4b6$var$tls.Alert.Level.fatal,
                // doesn't matter if decryption failed or MAC was
                // invalid, return the same error so as not to reveal
                // which one occurred
                description: $69688044bad9a4b6$var$tls.Alert.Description.bad_record_mac
            }
        });
        else if (!state.read.compressFunction(c, record, state.read)) c.error(c, {
            message: "Could not decompress record.",
            send: true,
            alert: {
                level: $69688044bad9a4b6$var$tls.Alert.Level.fatal,
                description: $69688044bad9a4b6$var$tls.Alert.Description.decompression_failure
            }
        });
        return !c.fail;
    };
    // update function in write mode will compress then encrypt a record
    state.write.update = function(c, record) {
        if (!state.write.compressFunction(c, record, state.write)) // error, but do not send alert since it would require
        // compression as well
        c.error(c, {
            message: "Could not compress record.",
            send: false,
            alert: {
                level: $69688044bad9a4b6$var$tls.Alert.Level.fatal,
                description: $69688044bad9a4b6$var$tls.Alert.Description.internal_error
            }
        });
        else if (!state.write.cipherFunction(record, state.write)) // error, but do not send alert since it would require
        // encryption as well
        c.error(c, {
            message: "Could not encrypt record.",
            send: false,
            alert: {
                level: $69688044bad9a4b6$var$tls.Alert.Level.fatal,
                description: $69688044bad9a4b6$var$tls.Alert.Description.internal_error
            }
        });
        return !c.fail;
    };
    // handle security parameters
    if (c.session) {
        var sp = c.session.sp;
        c.session.cipherSuite.initSecurityParameters(sp);
        // generate keys
        sp.keys = $69688044bad9a4b6$var$tls.generateKeys(c, sp);
        state.read.macKey = client ? sp.keys.server_write_MAC_key : sp.keys.client_write_MAC_key;
        state.write.macKey = client ? sp.keys.client_write_MAC_key : sp.keys.server_write_MAC_key;
        // cipher suite setup
        c.session.cipherSuite.initConnectionState(state, c, sp);
        // compression setup
        switch(sp.compression_algorithm){
            case $69688044bad9a4b6$var$tls.CompressionMethod.none:
                break;
            case $69688044bad9a4b6$var$tls.CompressionMethod.deflate:
                state.read.compressFunction = $69688044bad9a4b6$var$inflate;
                state.write.compressFunction = $69688044bad9a4b6$var$deflate;
                break;
            default:
                throw new Error("Unsupported compression algorithm.");
        }
    }
    return state;
};
/**
 * Creates a Random structure.
 *
 * struct {
 *   uint32 gmt_unix_time;
 *   opaque random_bytes[28];
 * } Random;
 *
 * gmt_unix_time:
 *   The current time and date in standard UNIX 32-bit format (seconds since
 *   the midnight starting Jan 1, 1970, UTC, ignoring leap seconds) according
 *   to the sender's internal clock. Clocks are not required to be set
 *   correctly by the basic TLS protocol; higher-level or application
 *   protocols may define additional requirements. Note that, for historical
 *   reasons, the data element is named using GMT, the predecessor of the
 *   current worldwide time base, UTC.
 * random_bytes:
 *   28 bytes generated by a secure random number generator.
 *
 * @return the Random structure as a byte array.
 */ $69688044bad9a4b6$var$tls.createRandom = function() {
    // get UTC milliseconds
    var d = new Date();
    var utc = +d + d.getTimezoneOffset() * 60000;
    var rval = $fz7FM.util.createBuffer();
    rval.putInt32(utc);
    rval.putBytes($fz7FM.random.getBytes(28));
    return rval;
};
/**
 * Creates a TLS record with the given type and data.
 *
 * @param c the connection.
 * @param options:
 *   type: the record type.
 *   data: the plain text data in a byte buffer.
 *
 * @return the created record.
 */ $69688044bad9a4b6$var$tls.createRecord = function(c, options) {
    if (!options.data) return null;
    var record = {
        type: options.type,
        version: {
            major: c.version.major,
            minor: c.version.minor
        },
        length: options.data.length(),
        fragment: options.data
    };
    return record;
};
/**
 * Creates a TLS alert record.
 *
 * @param c the connection.
 * @param alert:
 *   level: the TLS alert level.
 *   description: the TLS alert description.
 *
 * @return the created alert record.
 */ $69688044bad9a4b6$var$tls.createAlert = function(c, alert) {
    var b = $fz7FM.util.createBuffer();
    b.putByte(alert.level);
    b.putByte(alert.description);
    return $69688044bad9a4b6$var$tls.createRecord(c, {
        type: $69688044bad9a4b6$var$tls.ContentType.alert,
        data: b
    });
};
/* The structure of a TLS handshake message.
 *
 * struct {
 *    HandshakeType msg_type;    // handshake type
 *    uint24 length;             // bytes in message
 *    select(HandshakeType) {
 *       case hello_request:       HelloRequest;
 *       case client_hello:        ClientHello;
 *       case server_hello:        ServerHello;
 *       case certificate:         Certificate;
 *       case server_key_exchange: ServerKeyExchange;
 *       case certificate_request: CertificateRequest;
 *       case server_hello_done:   ServerHelloDone;
 *       case certificate_verify:  CertificateVerify;
 *       case client_key_exchange: ClientKeyExchange;
 *       case finished:            Finished;
 *    } body;
 * } Handshake;
 */ /**
 * Creates a ClientHello message.
 *
 * opaque SessionID<0..32>;
 * enum { null(0), deflate(1), (255) } CompressionMethod;
 * uint8 CipherSuite[2];
 *
 * struct {
 *   ProtocolVersion client_version;
 *   Random random;
 *   SessionID session_id;
 *   CipherSuite cipher_suites<2..2^16-2>;
 *   CompressionMethod compression_methods<1..2^8-1>;
 *   select(extensions_present) {
 *     case false:
 *       struct {};
 *     case true:
 *       Extension extensions<0..2^16-1>;
 *   };
 * } ClientHello;
 *
 * The extension format for extended client hellos and server hellos is:
 *
 * struct {
 *   ExtensionType extension_type;
 *   opaque extension_data<0..2^16-1>;
 * } Extension;
 *
 * Here:
 *
 * - "extension_type" identifies the particular extension type.
 * - "extension_data" contains information specific to the particular
 * extension type.
 *
 * The extension types defined in this document are:
 *
 * enum {
 *   server_name(0), max_fragment_length(1),
 *   client_certificate_url(2), trusted_ca_keys(3),
 *   truncated_hmac(4), status_request(5), (65535)
 * } ExtensionType;
 *
 * @param c the connection.
 *
 * @return the ClientHello byte buffer.
 */ $69688044bad9a4b6$var$tls.createClientHello = function(c) {
    // save hello version
    c.session.clientHelloVersion = {
        major: c.version.major,
        minor: c.version.minor
    };
    // create supported cipher suites
    var cipherSuites = $fz7FM.util.createBuffer();
    for(var i = 0; i < c.cipherSuites.length; ++i){
        var cs = c.cipherSuites[i];
        cipherSuites.putByte(cs.id[0]);
        cipherSuites.putByte(cs.id[1]);
    }
    var cSuites = cipherSuites.length();
    // create supported compression methods, null always supported, but
    // also support deflate if connection has inflate and deflate methods
    var compressionMethods = $fz7FM.util.createBuffer();
    compressionMethods.putByte($69688044bad9a4b6$var$tls.CompressionMethod.none);
    // FIXME: deflate support disabled until issues with raw deflate data
    // without zlib headers are resolved
    /*
  if(c.inflate !== null && c.deflate !== null) {
    compressionMethods.putByte(tls.CompressionMethod.deflate);
  }
  */ var cMethods = compressionMethods.length();
    // create TLS SNI (server name indication) extension if virtual host
    // has been specified, see RFC 3546
    var extensions = $fz7FM.util.createBuffer();
    if (c.virtualHost) {
        // create extension struct
        var ext = $fz7FM.util.createBuffer();
        ext.putByte(0x00); // type server_name (ExtensionType is 2 bytes)
        ext.putByte(0x00);
        /* In order to provide the server name, clients MAY include an
     * extension of type "server_name" in the (extended) client hello.
     * The "extension_data" field of this extension SHALL contain
     * "ServerNameList" where:
     *
     * struct {
     *   NameType name_type;
     *   select(name_type) {
     *     case host_name: HostName;
     *   } name;
     * } ServerName;
     *
     * enum {
     *   host_name(0), (255)
     * } NameType;
     *
     * opaque HostName<1..2^16-1>;
     *
     * struct {
     *   ServerName server_name_list<1..2^16-1>
     * } ServerNameList;
     */ var serverName = $fz7FM.util.createBuffer();
        serverName.putByte(0x00); // type host_name
        $69688044bad9a4b6$var$writeVector(serverName, 2, $fz7FM.util.createBuffer(c.virtualHost));
        // ServerNameList is in extension_data
        var snList = $fz7FM.util.createBuffer();
        $69688044bad9a4b6$var$writeVector(snList, 2, serverName);
        $69688044bad9a4b6$var$writeVector(ext, 2, snList);
        extensions.putBuffer(ext);
    }
    var extLength = extensions.length();
    if (extLength > 0) // add extension vector length
    extLength += 2;
    // determine length of the handshake message
    // cipher suites and compression methods size will need to be
    // updated if more get added to the list
    var sessionId = c.session.id;
    var length = sessionId.length + 1 + // session ID vector
    2 + // version (major + minor)
    4 + 28 + // random time and random bytes
    2 + cSuites + // cipher suites vector
    1 + cMethods + // compression methods vector
    extLength; // extensions vector
    // build record fragment
    var rval = $fz7FM.util.createBuffer();
    rval.putByte($69688044bad9a4b6$var$tls.HandshakeType.client_hello);
    rval.putInt24(length); // handshake length
    rval.putByte(c.version.major); // major version
    rval.putByte(c.version.minor); // minor version
    rval.putBytes(c.session.sp.client_random); // random time + bytes
    $69688044bad9a4b6$var$writeVector(rval, 1, $fz7FM.util.createBuffer(sessionId));
    $69688044bad9a4b6$var$writeVector(rval, 2, cipherSuites);
    $69688044bad9a4b6$var$writeVector(rval, 1, compressionMethods);
    if (extLength > 0) $69688044bad9a4b6$var$writeVector(rval, 2, extensions);
    return rval;
};
/**
 * Creates a ServerHello message.
 *
 * @param c the connection.
 *
 * @return the ServerHello byte buffer.
 */ $69688044bad9a4b6$var$tls.createServerHello = function(c) {
    // determine length of the handshake message
    var sessionId = c.session.id;
    var length = sessionId.length + 1 + // session ID vector
    2 + // version (major + minor)
    4 + 28 + // random time and random bytes
    2 + // chosen cipher suite
    1; // chosen compression method
    // build record fragment
    var rval = $fz7FM.util.createBuffer();
    rval.putByte($69688044bad9a4b6$var$tls.HandshakeType.server_hello);
    rval.putInt24(length); // handshake length
    rval.putByte(c.version.major); // major version
    rval.putByte(c.version.minor); // minor version
    rval.putBytes(c.session.sp.server_random); // random time + bytes
    $69688044bad9a4b6$var$writeVector(rval, 1, $fz7FM.util.createBuffer(sessionId));
    rval.putByte(c.session.cipherSuite.id[0]);
    rval.putByte(c.session.cipherSuite.id[1]);
    rval.putByte(c.session.compressionMethod);
    return rval;
};
/**
 * Creates a Certificate message.
 *
 * When this message will be sent:
 *   This is the first message the client can send after receiving a server
 *   hello done message and the first message the server can send after
 *   sending a ServerHello. This client message is only sent if the server
 *   requests a certificate. If no suitable certificate is available, the
 *   client should send a certificate message containing no certificates. If
 *   client authentication is required by the server for the handshake to
 *   continue, it may respond with a fatal handshake failure alert.
 *
 * opaque ASN.1Cert<1..2^24-1>;
 *
 * struct {
 *   ASN.1Cert certificate_list<0..2^24-1>;
 * } Certificate;
 *
 * @param c the connection.
 *
 * @return the Certificate byte buffer.
 */ $69688044bad9a4b6$var$tls.createCertificate = function(c) {
    // TODO: check certificate request to ensure types are supported
    // get a certificate (a certificate as a PEM string)
    var client = c.entity === $69688044bad9a4b6$var$tls.ConnectionEnd.client;
    var cert = null;
    if (c.getCertificate) {
        var hint;
        if (client) hint = c.session.certificateRequest;
        else hint = c.session.extensions.server_name.serverNameList;
        cert = c.getCertificate(c, hint);
    }
    // buffer to hold certificate list
    var certList = $fz7FM.util.createBuffer();
    if (cert !== null) try {
        // normalize cert to a chain of certificates
        if (!$fz7FM.util.isArray(cert)) cert = [
            cert
        ];
        var asn1 = null;
        for(var i = 0; i < cert.length; ++i){
            var msg = $fz7FM.pem.decode(cert[i])[0];
            if (msg.type !== "CERTIFICATE" && msg.type !== "X509 CERTIFICATE" && msg.type !== "TRUSTED CERTIFICATE") {
                var error = new Error('Could not convert certificate from PEM; PEM header type is not "CERTIFICATE", "X509 CERTIFICATE", or "TRUSTED CERTIFICATE".');
                error.headerType = msg.type;
                throw error;
            }
            if (msg.procType && msg.procType.type === "ENCRYPTED") throw new Error("Could not convert certificate from PEM; PEM is encrypted.");
            var der = $fz7FM.util.createBuffer(msg.body);
            if (asn1 === null) asn1 = $fz7FM.asn1.fromDer(der.bytes(), false);
            // certificate entry is itself a vector with 3 length bytes
            var certBuffer = $fz7FM.util.createBuffer();
            $69688044bad9a4b6$var$writeVector(certBuffer, 3, der);
            // add cert vector to cert list vector
            certList.putBuffer(certBuffer);
        }
        // save certificate
        cert = $fz7FM.pki.certificateFromAsn1(asn1);
        if (client) c.session.clientCertificate = cert;
        else c.session.serverCertificate = cert;
    } catch (ex) {
        return c.error(c, {
            message: "Could not send certificate list.",
            cause: ex,
            send: true,
            alert: {
                level: $69688044bad9a4b6$var$tls.Alert.Level.fatal,
                description: $69688044bad9a4b6$var$tls.Alert.Description.bad_certificate
            }
        });
    }
    // determine length of the handshake message
    var length = 3 + certList.length(); // cert list vector
    // build record fragment
    var rval = $fz7FM.util.createBuffer();
    rval.putByte($69688044bad9a4b6$var$tls.HandshakeType.certificate);
    rval.putInt24(length);
    $69688044bad9a4b6$var$writeVector(rval, 3, certList);
    return rval;
};
/**
 * Creates a ClientKeyExchange message.
 *
 * When this message will be sent:
 *   This message is always sent by the client. It will immediately follow the
 *   client certificate message, if it is sent. Otherwise it will be the first
 *   message sent by the client after it receives the server hello done
 *   message.
 *
 * Meaning of this message:
 *   With this message, the premaster secret is set, either though direct
 *   transmission of the RSA-encrypted secret, or by the transmission of
 *   Diffie-Hellman parameters which will allow each side to agree upon the
 *   same premaster secret. When the key exchange method is DH_RSA or DH_DSS,
 *   client certification has been requested, and the client was able to
 *   respond with a certificate which contained a Diffie-Hellman public key
 *   whose parameters (group and generator) matched those specified by the
 *   server in its certificate, this message will not contain any data.
 *
 * Meaning of this message:
 *   If RSA is being used for key agreement and authentication, the client
 *   generates a 48-byte premaster secret, encrypts it using the public key
 *   from the server's certificate or the temporary RSA key provided in a
 *   server key exchange message, and sends the result in an encrypted
 *   premaster secret message. This structure is a variant of the client
 *   key exchange message, not a message in itself.
 *
 * struct {
 *   select(KeyExchangeAlgorithm) {
 *     case rsa: EncryptedPreMasterSecret;
 *     case diffie_hellman: ClientDiffieHellmanPublic;
 *   } exchange_keys;
 * } ClientKeyExchange;
 *
 * struct {
 *   ProtocolVersion client_version;
 *   opaque random[46];
 * } PreMasterSecret;
 *
 * struct {
 *   public-key-encrypted PreMasterSecret pre_master_secret;
 * } EncryptedPreMasterSecret;
 *
 * A public-key-encrypted element is encoded as a vector <0..2^16-1>.
 *
 * @param c the connection.
 *
 * @return the ClientKeyExchange byte buffer.
 */ $69688044bad9a4b6$var$tls.createClientKeyExchange = function(c) {
    // create buffer to encrypt
    var b = $fz7FM.util.createBuffer();
    // add highest client-supported protocol to help server avoid version
    // rollback attacks
    b.putByte(c.session.clientHelloVersion.major);
    b.putByte(c.session.clientHelloVersion.minor);
    // generate and add 46 random bytes
    b.putBytes($fz7FM.random.getBytes(46));
    // save pre-master secret
    var sp = c.session.sp;
    sp.pre_master_secret = b.getBytes();
    // RSA-encrypt the pre-master secret
    var key = c.session.serverCertificate.publicKey;
    b = key.encrypt(sp.pre_master_secret);
    /* Note: The encrypted pre-master secret will be stored in a
    public-key-encrypted opaque vector that has the length prefixed using
    2 bytes, so include those 2 bytes in the handshake message length. This
    is done as a minor optimization instead of calling writeVector(). */ // determine length of the handshake message
    var length = b.length + 2;
    // build record fragment
    var rval = $fz7FM.util.createBuffer();
    rval.putByte($69688044bad9a4b6$var$tls.HandshakeType.client_key_exchange);
    rval.putInt24(length);
    // add vector length bytes
    rval.putInt16(b.length);
    rval.putBytes(b);
    return rval;
};
/**
 * Creates a ServerKeyExchange message.
 *
 * @param c the connection.
 *
 * @return the ServerKeyExchange byte buffer.
 */ $69688044bad9a4b6$var$tls.createServerKeyExchange = function(c) {
    // this implementation only supports RSA, no Diffie-Hellman support,
    // so this record is empty
    // determine length of the handshake message
    var length = 0;
    // build record fragment
    var rval = $fz7FM.util.createBuffer();
    if (length > 0) {
        rval.putByte($69688044bad9a4b6$var$tls.HandshakeType.server_key_exchange);
        rval.putInt24(length);
    }
    return rval;
};
/**
 * Gets the signed data used to verify a client-side certificate. See
 * tls.createCertificateVerify() for details.
 *
 * @param c the connection.
 * @param callback the callback to call once the signed data is ready.
 */ $69688044bad9a4b6$var$tls.getClientSignature = function(c, callback) {
    // generate data to RSA encrypt
    var b = $fz7FM.util.createBuffer();
    b.putBuffer(c.session.md5.digest());
    b.putBuffer(c.session.sha1.digest());
    b = b.getBytes();
    // create default signing function as necessary
    c.getSignature = c.getSignature || function(c, b, callback) {
        // do rsa encryption, call callback
        var privateKey = null;
        if (c.getPrivateKey) try {
            privateKey = c.getPrivateKey(c, c.session.clientCertificate);
            privateKey = $fz7FM.pki.privateKeyFromPem(privateKey);
        } catch (ex) {
            c.error(c, {
                message: "Could not get private key.",
                cause: ex,
                send: true,
                alert: {
                    level: $69688044bad9a4b6$var$tls.Alert.Level.fatal,
                    description: $69688044bad9a4b6$var$tls.Alert.Description.internal_error
                }
            });
        }
        if (privateKey === null) c.error(c, {
            message: "No private key set.",
            send: true,
            alert: {
                level: $69688044bad9a4b6$var$tls.Alert.Level.fatal,
                description: $69688044bad9a4b6$var$tls.Alert.Description.internal_error
            }
        });
        else b = privateKey.sign(b, null);
        callback(c, b);
    };
    // get client signature
    c.getSignature(c, b, callback);
};
/**
 * Creates a CertificateVerify message.
 *
 * Meaning of this message:
 *   This structure conveys the client's Diffie-Hellman public value
 *   (Yc) if it was not already included in the client's certificate.
 *   The encoding used for Yc is determined by the enumerated
 *   PublicValueEncoding. This structure is a variant of the client
 *   key exchange message, not a message in itself.
 *
 * When this message will be sent:
 *   This message is used to provide explicit verification of a client
 *   certificate. This message is only sent following a client
 *   certificate that has signing capability (i.e. all certificates
 *   except those containing fixed Diffie-Hellman parameters). When
 *   sent, it will immediately follow the client key exchange message.
 *
 * struct {
 *   Signature signature;
 * } CertificateVerify;
 *
 * CertificateVerify.signature.md5_hash
 *   MD5(handshake_messages);
 *
 * Certificate.signature.sha_hash
 *   SHA(handshake_messages);
 *
 * Here handshake_messages refers to all handshake messages sent or
 * received starting at client hello up to but not including this
 * message, including the type and length fields of the handshake
 * messages.
 *
 * select(SignatureAlgorithm) {
 *   case anonymous: struct { };
 *   case rsa:
 *     digitally-signed struct {
 *       opaque md5_hash[16];
 *       opaque sha_hash[20];
 *     };
 *   case dsa:
 *     digitally-signed struct {
 *       opaque sha_hash[20];
 *     };
 * } Signature;
 *
 * In digital signing, one-way hash functions are used as input for a
 * signing algorithm. A digitally-signed element is encoded as an opaque
 * vector <0..2^16-1>, where the length is specified by the signing
 * algorithm and key.
 *
 * In RSA signing, a 36-byte structure of two hashes (one SHA and one
 * MD5) is signed (encrypted with the private key). It is encoded with
 * PKCS #1 block type 0 or type 1 as described in [PKCS1].
 *
 * In DSS, the 20 bytes of the SHA hash are run directly through the
 * Digital Signing Algorithm with no additional hashing.
 *
 * @param c the connection.
 * @param signature the signature to include in the message.
 *
 * @return the CertificateVerify byte buffer.
 */ $69688044bad9a4b6$var$tls.createCertificateVerify = function(c, signature) {
    /* Note: The signature will be stored in a "digitally-signed" opaque
    vector that has the length prefixed using 2 bytes, so include those
    2 bytes in the handshake message length. This is done as a minor
    optimization instead of calling writeVector(). */ // determine length of the handshake message
    var length = signature.length + 2;
    // build record fragment
    var rval = $fz7FM.util.createBuffer();
    rval.putByte($69688044bad9a4b6$var$tls.HandshakeType.certificate_verify);
    rval.putInt24(length);
    // add vector length bytes
    rval.putInt16(signature.length);
    rval.putBytes(signature);
    return rval;
};
/**
 * Creates a CertificateRequest message.
 *
 * @param c the connection.
 *
 * @return the CertificateRequest byte buffer.
 */ $69688044bad9a4b6$var$tls.createCertificateRequest = function(c) {
    // TODO: support other certificate types
    var certTypes = $fz7FM.util.createBuffer();
    // common RSA certificate type
    certTypes.putByte(0x01);
    // add distinguished names from CA store
    var cAs = $fz7FM.util.createBuffer();
    for(var key in c.caStore.certs){
        var cert = c.caStore.certs[key];
        var dn = $fz7FM.pki.distinguishedNameToAsn1(cert.subject);
        var byteBuffer = $fz7FM.asn1.toDer(dn);
        cAs.putInt16(byteBuffer.length());
        cAs.putBuffer(byteBuffer);
    }
    // TODO: TLS 1.2+ has a different format
    // determine length of the handshake message
    var length = 1 + certTypes.length() + 2 + cAs.length();
    // build record fragment
    var rval = $fz7FM.util.createBuffer();
    rval.putByte($69688044bad9a4b6$var$tls.HandshakeType.certificate_request);
    rval.putInt24(length);
    $69688044bad9a4b6$var$writeVector(rval, 1, certTypes);
    $69688044bad9a4b6$var$writeVector(rval, 2, cAs);
    return rval;
};
/**
 * Creates a ServerHelloDone message.
 *
 * @param c the connection.
 *
 * @return the ServerHelloDone byte buffer.
 */ $69688044bad9a4b6$var$tls.createServerHelloDone = function(c) {
    // build record fragment
    var rval = $fz7FM.util.createBuffer();
    rval.putByte($69688044bad9a4b6$var$tls.HandshakeType.server_hello_done);
    rval.putInt24(0);
    return rval;
};
/**
 * Creates a ChangeCipherSpec message.
 *
 * The change cipher spec protocol exists to signal transitions in
 * ciphering strategies. The protocol consists of a single message,
 * which is encrypted and compressed under the current (not the pending)
 * connection state. The message consists of a single byte of value 1.
 *
 * struct {
 *   enum { change_cipher_spec(1), (255) } type;
 * } ChangeCipherSpec;
 *
 * @return the ChangeCipherSpec byte buffer.
 */ $69688044bad9a4b6$var$tls.createChangeCipherSpec = function() {
    var rval = $fz7FM.util.createBuffer();
    rval.putByte(0x01);
    return rval;
};
/**
 * Creates a Finished message.
 *
 * struct {
 *   opaque verify_data[12];
 * } Finished;
 *
 * verify_data
 *   PRF(master_secret, finished_label, MD5(handshake_messages) +
 *   SHA-1(handshake_messages)) [0..11];
 *
 * finished_label
 *   For Finished messages sent by the client, the string "client
 *   finished". For Finished messages sent by the server, the
 *   string "server finished".
 *
 * handshake_messages
 *   All of the data from all handshake messages up to but not
 *   including this message. This is only data visible at the
 *   handshake layer and does not include record layer headers.
 *   This is the concatenation of all the Handshake structures as
 *   defined in 7.4 exchanged thus far.
 *
 * @param c the connection.
 *
 * @return the Finished byte buffer.
 */ $69688044bad9a4b6$var$tls.createFinished = function(c) {
    // generate verify_data
    var b = $fz7FM.util.createBuffer();
    b.putBuffer(c.session.md5.digest());
    b.putBuffer(c.session.sha1.digest());
    // TODO: determine prf function and verify length for TLS 1.2
    var client = c.entity === $69688044bad9a4b6$var$tls.ConnectionEnd.client;
    var sp = c.session.sp;
    var vdl = 12;
    var prf = $69688044bad9a4b6$var$prf_TLS1;
    var label = client ? "client finished" : "server finished";
    b = prf(sp.master_secret, label, b.getBytes(), vdl);
    // build record fragment
    var rval = $fz7FM.util.createBuffer();
    rval.putByte($69688044bad9a4b6$var$tls.HandshakeType.finished);
    rval.putInt24(b.length());
    rval.putBuffer(b);
    return rval;
};
/**
 * Creates a HeartbeatMessage (See RFC 6520).
 *
 * struct {
 *   HeartbeatMessageType type;
 *   uint16 payload_length;
 *   opaque payload[HeartbeatMessage.payload_length];
 *   opaque padding[padding_length];
 * } HeartbeatMessage;
 *
 * The total length of a HeartbeatMessage MUST NOT exceed 2^14 or
 * max_fragment_length when negotiated as defined in [RFC6066].
 *
 * type: The message type, either heartbeat_request or heartbeat_response.
 *
 * payload_length: The length of the payload.
 *
 * payload: The payload consists of arbitrary content.
 *
 * padding: The padding is random content that MUST be ignored by the
 *   receiver. The length of a HeartbeatMessage is TLSPlaintext.length
 *   for TLS and DTLSPlaintext.length for DTLS. Furthermore, the
 *   length of the type field is 1 byte, and the length of the
 *   payload_length is 2. Therefore, the padding_length is
 *   TLSPlaintext.length - payload_length - 3 for TLS and
 *   DTLSPlaintext.length - payload_length - 3 for DTLS. The
 *   padding_length MUST be at least 16.
 *
 * The sender of a HeartbeatMessage MUST use a random padding of at
 * least 16 bytes. The padding of a received HeartbeatMessage message
 * MUST be ignored.
 *
 * If the payload_length of a received HeartbeatMessage is too large,
 * the received HeartbeatMessage MUST be discarded silently.
 *
 * @param c the connection.
 * @param type the tls.HeartbeatMessageType.
 * @param payload the heartbeat data to send as the payload.
 * @param [payloadLength] the payload length to use, defaults to the
 *          actual payload length.
 *
 * @return the HeartbeatRequest byte buffer.
 */ $69688044bad9a4b6$var$tls.createHeartbeat = function(type, payload, payloadLength) {
    if (typeof payloadLength === "undefined") payloadLength = payload.length;
    // build record fragment
    var rval = $fz7FM.util.createBuffer();
    rval.putByte(type); // heartbeat message type
    rval.putInt16(payloadLength); // payload length
    rval.putBytes(payload); // payload
    // padding
    var plaintextLength = rval.length();
    var paddingLength = Math.max(16, plaintextLength - payloadLength - 3);
    rval.putBytes($fz7FM.random.getBytes(paddingLength));
    return rval;
};
/**
 * Fragments, compresses, encrypts, and queues a record for delivery.
 *
 * @param c the connection.
 * @param record the record to queue.
 */ $69688044bad9a4b6$var$tls.queue = function(c, record) {
    // error during record creation
    if (!record) return;
    if (record.fragment.length() === 0) {
        if (record.type === $69688044bad9a4b6$var$tls.ContentType.handshake || record.type === $69688044bad9a4b6$var$tls.ContentType.alert || record.type === $69688044bad9a4b6$var$tls.ContentType.change_cipher_spec) // Empty handshake, alert of change cipher spec messages are not allowed per the TLS specification and should not be sent.
        return;
    }
    // if the record is a handshake record, update handshake hashes
    if (record.type === $69688044bad9a4b6$var$tls.ContentType.handshake) {
        var bytes = record.fragment.bytes();
        c.session.md5.update(bytes);
        c.session.sha1.update(bytes);
        bytes = null;
    }
    // handle record fragmentation
    var records;
    if (record.fragment.length() <= $69688044bad9a4b6$var$tls.MaxFragment) records = [
        record
    ];
    else {
        // fragment data as long as it is too long
        records = [];
        var data = record.fragment.bytes();
        while(data.length > $69688044bad9a4b6$var$tls.MaxFragment){
            records.push($69688044bad9a4b6$var$tls.createRecord(c, {
                type: record.type,
                data: $fz7FM.util.createBuffer(data.slice(0, $69688044bad9a4b6$var$tls.MaxFragment))
            }));
            data = data.slice($69688044bad9a4b6$var$tls.MaxFragment);
        }
        // add last record
        if (data.length > 0) records.push($69688044bad9a4b6$var$tls.createRecord(c, {
            type: record.type,
            data: $fz7FM.util.createBuffer(data)
        }));
    }
    // compress and encrypt all fragmented records
    for(var i = 0; i < records.length && !c.fail; ++i){
        // update the record using current write state
        var rec = records[i];
        var s = c.state.current.write;
        if (s.update(c, rec)) // store record
        c.records.push(rec);
    }
};
/**
 * Flushes all queued records to the output buffer and calls the
 * tlsDataReady() handler on the given connection.
 *
 * @param c the connection.
 *
 * @return true on success, false on failure.
 */ $69688044bad9a4b6$var$tls.flush = function(c) {
    for(var i = 0; i < c.records.length; ++i){
        var record = c.records[i];
        // add record header and fragment
        c.tlsData.putByte(record.type);
        c.tlsData.putByte(record.version.major);
        c.tlsData.putByte(record.version.minor);
        c.tlsData.putInt16(record.fragment.length());
        c.tlsData.putBuffer(c.records[i].fragment);
    }
    c.records = [];
    return c.tlsDataReady(c);
};
/**
 * Maps a pki.certificateError to a tls.Alert.Description.
 *
 * @param error the error to map.
 *
 * @return the alert description.
 */ var $69688044bad9a4b6$var$_certErrorToAlertDesc = function _certErrorToAlertDesc(error) {
    switch(error){
        case true:
            return true;
        case $fz7FM.pki.certificateError.bad_certificate:
            return $69688044bad9a4b6$var$tls.Alert.Description.bad_certificate;
        case $fz7FM.pki.certificateError.unsupported_certificate:
            return $69688044bad9a4b6$var$tls.Alert.Description.unsupported_certificate;
        case $fz7FM.pki.certificateError.certificate_revoked:
            return $69688044bad9a4b6$var$tls.Alert.Description.certificate_revoked;
        case $fz7FM.pki.certificateError.certificate_expired:
            return $69688044bad9a4b6$var$tls.Alert.Description.certificate_expired;
        case $fz7FM.pki.certificateError.certificate_unknown:
            return $69688044bad9a4b6$var$tls.Alert.Description.certificate_unknown;
        case $fz7FM.pki.certificateError.unknown_ca:
            return $69688044bad9a4b6$var$tls.Alert.Description.unknown_ca;
        default:
            return $69688044bad9a4b6$var$tls.Alert.Description.bad_certificate;
    }
};
/**
 * Maps a tls.Alert.Description to a pki.certificateError.
 *
 * @param desc the alert description.
 *
 * @return the certificate error.
 */ var $69688044bad9a4b6$var$_alertDescToCertError = function _alertDescToCertError(desc) {
    switch(desc){
        case true:
            return true;
        case $69688044bad9a4b6$var$tls.Alert.Description.bad_certificate:
            return $fz7FM.pki.certificateError.bad_certificate;
        case $69688044bad9a4b6$var$tls.Alert.Description.unsupported_certificate:
            return $fz7FM.pki.certificateError.unsupported_certificate;
        case $69688044bad9a4b6$var$tls.Alert.Description.certificate_revoked:
            return $fz7FM.pki.certificateError.certificate_revoked;
        case $69688044bad9a4b6$var$tls.Alert.Description.certificate_expired:
            return $fz7FM.pki.certificateError.certificate_expired;
        case $69688044bad9a4b6$var$tls.Alert.Description.certificate_unknown:
            return $fz7FM.pki.certificateError.certificate_unknown;
        case $69688044bad9a4b6$var$tls.Alert.Description.unknown_ca:
            return $fz7FM.pki.certificateError.unknown_ca;
        default:
            return $fz7FM.pki.certificateError.bad_certificate;
    }
};
/**
 * Verifies a certificate chain against the given connection's
 * Certificate Authority store.
 *
 * @param c the TLS connection.
 * @param chain the certificate chain to verify, with the root or highest
 *          authority at the end.
 *
 * @return true if successful, false if not.
 */ $69688044bad9a4b6$var$tls.verifyCertificateChain = function(c, chain) {
    try {
        // Make a copy of c.verifyOptions so that we can modify options.verify
        // without modifying c.verifyOptions.
        var options = {};
        for(var key in c.verifyOptions)options[key] = c.verifyOptions[key];
        options.verify = function(vfd, depth, chain) {
            // convert pki.certificateError to tls alert description
            var desc = $69688044bad9a4b6$var$_certErrorToAlertDesc(vfd);
            // call application callback
            var ret = c.verify(c, vfd, depth, chain);
            if (ret !== true) {
                if (typeof ret === "object" && !$fz7FM.util.isArray(ret)) {
                    // throw custom error
                    var error = new Error("The application rejected the certificate.");
                    error.send = true;
                    error.alert = {
                        level: $69688044bad9a4b6$var$tls.Alert.Level.fatal,
                        description: $69688044bad9a4b6$var$tls.Alert.Description.bad_certificate
                    };
                    if (ret.message) error.message = ret.message;
                    if (ret.alert) error.alert.description = ret.alert;
                    throw error;
                }
                // convert tls alert description to pki.certificateError
                if (ret !== vfd) ret = $69688044bad9a4b6$var$_alertDescToCertError(ret);
            }
            return ret;
        };
        // verify chain
        $fz7FM.pki.verifyCertificateChain(c.caStore, chain, options);
    } catch (ex) {
        // build tls error if not already customized
        var err = ex;
        if (typeof err !== "object" || $fz7FM.util.isArray(err)) err = {
            send: true,
            alert: {
                level: $69688044bad9a4b6$var$tls.Alert.Level.fatal,
                description: $69688044bad9a4b6$var$_certErrorToAlertDesc(ex)
            }
        };
        if (!("send" in err)) err.send = true;
        if (!("alert" in err)) err.alert = {
            level: $69688044bad9a4b6$var$tls.Alert.Level.fatal,
            description: $69688044bad9a4b6$var$_certErrorToAlertDesc(err.error)
        };
        // send error
        c.error(c, err);
    }
    return !c.fail;
};
/**
 * Creates a new TLS session cache.
 *
 * @param cache optional map of session ID to cached session.
 * @param capacity the maximum size for the cache (default: 100).
 *
 * @return the new TLS session cache.
 */ $69688044bad9a4b6$var$tls.createSessionCache = function(cache, capacity) {
    var rval = null;
    // assume input is already a session cache object
    if (cache && cache.getSession && cache.setSession && cache.order) rval = cache;
    else {
        // create cache
        rval = {};
        rval.cache = cache || {};
        rval.capacity = Math.max(capacity || 100, 1);
        rval.order = [];
        // store order for sessions, delete session overflow
        for(var key in cache)if (rval.order.length <= capacity) rval.order.push(key);
        else delete cache[key];
        // get a session from a session ID (or get any session)
        rval.getSession = function(sessionId) {
            var session = null;
            var key = null;
            // if session ID provided, use it
            if (sessionId) key = $fz7FM.util.bytesToHex(sessionId);
            else if (rval.order.length > 0) // get first session from cache
            key = rval.order[0];
            if (key !== null && key in rval.cache) {
                // get cached session and remove from cache
                session = rval.cache[key];
                delete rval.cache[key];
                for(var i in rval.order)if (rval.order[i] === key) {
                    rval.order.splice(i, 1);
                    break;
                }
            }
            return session;
        };
        // set a session in the cache
        rval.setSession = function(sessionId, session) {
            // remove session from cache if at capacity
            if (rval.order.length === rval.capacity) {
                var key = rval.order.shift();
                delete rval.cache[key];
            }
            // add session to cache
            var key = $fz7FM.util.bytesToHex(sessionId);
            rval.order.push(key);
            rval.cache[key] = session;
        };
    }
    return rval;
};
/**
 * Creates a new TLS connection.
 *
 * See public createConnection() docs for more details.
 *
 * @param options the options for this connection.
 *
 * @return the new TLS connection.
 */ $69688044bad9a4b6$var$tls.createConnection = function(options) {
    var caStore = null;
    if (options.caStore) {
        // if CA store is an array, convert it to a CA store object
        if ($fz7FM.util.isArray(options.caStore)) caStore = $fz7FM.pki.createCaStore(options.caStore);
        else caStore = options.caStore;
    } else // create empty CA store
    caStore = $fz7FM.pki.createCaStore();
    // setup default cipher suites
    var cipherSuites = options.cipherSuites || null;
    if (cipherSuites === null) {
        cipherSuites = [];
        for(var key in $69688044bad9a4b6$var$tls.CipherSuites)cipherSuites.push($69688044bad9a4b6$var$tls.CipherSuites[key]);
    }
    // set default entity
    var entity = options.server || false ? $69688044bad9a4b6$var$tls.ConnectionEnd.server : $69688044bad9a4b6$var$tls.ConnectionEnd.client;
    // create session cache if requested
    var sessionCache = options.sessionCache ? $69688044bad9a4b6$var$tls.createSessionCache(options.sessionCache) : null;
    // create TLS connection
    var c = {
        version: {
            major: $69688044bad9a4b6$var$tls.Version.major,
            minor: $69688044bad9a4b6$var$tls.Version.minor
        },
        entity: entity,
        sessionId: options.sessionId,
        caStore: caStore,
        sessionCache: sessionCache,
        cipherSuites: cipherSuites,
        connected: options.connected,
        virtualHost: options.virtualHost || null,
        verifyClient: options.verifyClient || false,
        verify: options.verify || function(cn, vfd, dpth, cts) {
            return vfd;
        },
        verifyOptions: options.verifyOptions || {},
        getCertificate: options.getCertificate || null,
        getPrivateKey: options.getPrivateKey || null,
        getSignature: options.getSignature || null,
        input: $fz7FM.util.createBuffer(),
        tlsData: $fz7FM.util.createBuffer(),
        data: $fz7FM.util.createBuffer(),
        tlsDataReady: options.tlsDataReady,
        dataReady: options.dataReady,
        heartbeatReceived: options.heartbeatReceived,
        closed: options.closed,
        error: function error(c, ex) {
            // set origin if not set
            ex.origin = ex.origin || (c.entity === $69688044bad9a4b6$var$tls.ConnectionEnd.client ? "client" : "server");
            // send TLS alert
            if (ex.send) {
                $69688044bad9a4b6$var$tls.queue(c, $69688044bad9a4b6$var$tls.createAlert(c, ex.alert));
                $69688044bad9a4b6$var$tls.flush(c);
            }
            // error is fatal by default
            var fatal = ex.fatal !== false;
            if (fatal) // set fail flag
            c.fail = true;
            // call error handler first
            options.error(c, ex);
            if (fatal) // fatal error, close connection, do not clear fail
            c.close(false);
        },
        deflate: options.deflate || null,
        inflate: options.inflate || null
    };
    /**
   * Resets a closed TLS connection for reuse. Called in c.close().
   *
   * @param clearFail true to clear the fail flag (default: true).
   */ c.reset = function(clearFail) {
        c.version = {
            major: $69688044bad9a4b6$var$tls.Version.major,
            minor: $69688044bad9a4b6$var$tls.Version.minor
        };
        c.record = null;
        c.session = null;
        c.peerCertificate = null;
        c.state = {
            pending: null,
            current: null
        };
        c.expect = c.entity === $69688044bad9a4b6$var$tls.ConnectionEnd.client ? $69688044bad9a4b6$var$SHE : $69688044bad9a4b6$var$CHE;
        c.fragmented = null;
        c.records = [];
        c.open = false;
        c.handshakes = 0;
        c.handshaking = false;
        c.isConnected = false;
        c.fail = !(clearFail || typeof clearFail === "undefined");
        c.input.clear();
        c.tlsData.clear();
        c.data.clear();
        c.state.current = $69688044bad9a4b6$var$tls.createConnectionState(c);
    };
    // do initial reset of connection
    c.reset();
    /**
   * Updates the current TLS engine state based on the given record.
   *
   * @param c the TLS connection.
   * @param record the TLS record to act on.
   */ var _update = function _update(c, record) {
        // get record handler (align type in table by subtracting lowest)
        var aligned = record.type - $69688044bad9a4b6$var$tls.ContentType.change_cipher_spec;
        var handlers = $69688044bad9a4b6$var$ctTable[c.entity][c.expect];
        if (aligned in handlers) handlers[aligned](c, record);
        else // unexpected record
        $69688044bad9a4b6$var$tls.handleUnexpected(c, record);
    };
    /**
   * Reads the record header and initializes the next record on the given
   * connection.
   *
   * @param c the TLS connection with the next record.
   *
   * @return 0 if the input data could be processed, otherwise the
   *         number of bytes required for data to be processed.
   */ var _readRecordHeader = function _readRecordHeader(c) {
        var rval = 0;
        // get input buffer and its length
        var b = c.input;
        var len = b.length();
        // need at least 5 bytes to initialize a record
        if (len < 5) rval = 5 - len;
        else {
            // enough bytes for header
            // initialize record
            c.record = {
                type: b.getByte(),
                version: {
                    major: b.getByte(),
                    minor: b.getByte()
                },
                length: b.getInt16(),
                fragment: $fz7FM.util.createBuffer(),
                ready: false
            };
            // check record version
            var compatibleVersion = c.record.version.major === c.version.major;
            if (compatibleVersion && c.session && c.session.version) // session version already set, require same minor version
            compatibleVersion = c.record.version.minor === c.version.minor;
            if (!compatibleVersion) c.error(c, {
                message: "Incompatible TLS version.",
                send: true,
                alert: {
                    level: $69688044bad9a4b6$var$tls.Alert.Level.fatal,
                    description: $69688044bad9a4b6$var$tls.Alert.Description.protocol_version
                }
            });
        }
        return rval;
    };
    /**
   * Reads the next record's contents and appends its message to any
   * previously fragmented message.
   *
   * @param c the TLS connection with the next record.
   *
   * @return 0 if the input data could be processed, otherwise the
   *         number of bytes required for data to be processed.
   */ var _readRecord = function _readRecord(c) {
        var rval = 0;
        // ensure there is enough input data to get the entire record
        var b = c.input;
        var len = b.length();
        if (len < c.record.length) // not enough data yet, return how much is required
        rval = c.record.length - len;
        else {
            // there is enough data to parse the pending record
            // fill record fragment and compact input buffer
            c.record.fragment.putBytes(b.getBytes(c.record.length));
            b.compact();
            // update record using current read state
            var s = c.state.current.read;
            if (s.update(c, c.record)) {
                // see if there is a previously fragmented message that the
                // new record's message fragment should be appended to
                if (c.fragmented !== null) {
                    // if the record type matches a previously fragmented
                    // record, append the record fragment to it
                    if (c.fragmented.type === c.record.type) {
                        // concatenate record fragments
                        c.fragmented.fragment.putBuffer(c.record.fragment);
                        c.record = c.fragmented;
                    } else // error, invalid fragmented record
                    c.error(c, {
                        message: "Invalid fragmented record.",
                        send: true,
                        alert: {
                            level: $69688044bad9a4b6$var$tls.Alert.Level.fatal,
                            description: $69688044bad9a4b6$var$tls.Alert.Description.unexpected_message
                        }
                    });
                }
                // record is now ready
                c.record.ready = true;
            }
        }
        return rval;
    };
    /**
   * Performs a handshake using the TLS Handshake Protocol, as a client.
   *
   * This method should only be called if the connection is in client mode.
   *
   * @param sessionId the session ID to use, null to start a new one.
   */ c.handshake = function(sessionId) {
        // error to call this in non-client mode
        if (c.entity !== $69688044bad9a4b6$var$tls.ConnectionEnd.client) // not fatal error
        c.error(c, {
            message: "Cannot initiate handshake as a server.",
            fatal: false
        });
        else if (c.handshaking) // handshake is already in progress, fail but not fatal error
        c.error(c, {
            message: "Handshake already in progress.",
            fatal: false
        });
        else {
            // clear fail flag on reuse
            if (c.fail && !c.open && c.handshakes === 0) c.fail = false;
            // now handshaking
            c.handshaking = true;
            // default to blank (new session)
            sessionId = sessionId || "";
            // if a session ID was specified, try to find it in the cache
            var session = null;
            if (sessionId.length > 0) {
                if (c.sessionCache) session = c.sessionCache.getSession(sessionId);
                // matching session not found in cache, clear session ID
                if (session === null) sessionId = "";
            }
            // no session given, grab a session from the cache, if available
            if (sessionId.length === 0 && c.sessionCache) {
                session = c.sessionCache.getSession();
                if (session !== null) sessionId = session.id;
            }
            // set up session
            c.session = {
                id: sessionId,
                version: null,
                cipherSuite: null,
                compressionMethod: null,
                serverCertificate: null,
                certificateRequest: null,
                clientCertificate: null,
                sp: {},
                md5: $fz7FM.md.md5.create(),
                sha1: $fz7FM.md.sha1.create()
            };
            // use existing session information
            if (session) {
                // only update version on connection, session version not yet set
                c.version = session.version;
                c.session.sp = session.sp;
            }
            // generate new client random
            c.session.sp.client_random = $69688044bad9a4b6$var$tls.createRandom().getBytes();
            // connection now open
            c.open = true;
            // send hello
            $69688044bad9a4b6$var$tls.queue(c, $69688044bad9a4b6$var$tls.createRecord(c, {
                type: $69688044bad9a4b6$var$tls.ContentType.handshake,
                data: $69688044bad9a4b6$var$tls.createClientHello(c)
            }));
            $69688044bad9a4b6$var$tls.flush(c);
        }
    };
    /**
   * Called when TLS protocol data has been received from somewhere and should
   * be processed by the TLS engine.
   *
   * @param data the TLS protocol data, as a string, to process.
   *
   * @return 0 if the data could be processed, otherwise the number of bytes
   *         required for data to be processed.
   */ c.process = function(data) {
        var rval = 0;
        // buffer input data
        if (data) c.input.putBytes(data);
        // process next record if no failure, process will be called after
        // each record is handled (since handling can be asynchronous)
        if (!c.fail) {
            // reset record if ready and now empty
            if (c.record !== null && c.record.ready && c.record.fragment.isEmpty()) c.record = null;
            // if there is no pending record, try to read record header
            if (c.record === null) rval = _readRecordHeader(c);
            // read the next record (if record not yet ready)
            if (!c.fail && c.record !== null && !c.record.ready) rval = _readRecord(c);
            // record ready to be handled, update engine state
            if (!c.fail && c.record !== null && c.record.ready) _update(c, c.record);
        }
        return rval;
    };
    /**
   * Requests that application data be packaged into a TLS record. The
   * tlsDataReady handler will be called when the TLS record(s) have been
   * prepared.
   *
   * @param data the application data, as a raw 'binary' encoded string, to
   *          be sent; to send utf-16/utf-8 string data, use the return value
   *          of util.encodeUtf8(str).
   *
   * @return true on success, false on failure.
   */ c.prepare = function(data) {
        $69688044bad9a4b6$var$tls.queue(c, $69688044bad9a4b6$var$tls.createRecord(c, {
            type: $69688044bad9a4b6$var$tls.ContentType.application_data,
            data: $fz7FM.util.createBuffer(data)
        }));
        return $69688044bad9a4b6$var$tls.flush(c);
    };
    /**
   * Requests that a heartbeat request be packaged into a TLS record for
   * transmission. The tlsDataReady handler will be called when TLS record(s)
   * have been prepared.
   *
   * When a heartbeat response has been received, the heartbeatReceived
   * handler will be called with the matching payload. This handler can
   * be used to clear a retransmission timer, etc.
   *
   * @param payload the heartbeat data to send as the payload in the message.
   * @param [payloadLength] the payload length to use, defaults to the
   *          actual payload length.
   *
   * @return true on success, false on failure.
   */ c.prepareHeartbeatRequest = function(payload, payloadLength) {
        if (payload instanceof $fz7FM.util.ByteBuffer) payload = payload.bytes();
        if (typeof payloadLength === "undefined") payloadLength = payload.length;
        c.expectedHeartbeatPayload = payload;
        $69688044bad9a4b6$var$tls.queue(c, $69688044bad9a4b6$var$tls.createRecord(c, {
            type: $69688044bad9a4b6$var$tls.ContentType.heartbeat,
            data: $69688044bad9a4b6$var$tls.createHeartbeat($69688044bad9a4b6$var$tls.HeartbeatMessageType.heartbeat_request, payload, payloadLength)
        }));
        return $69688044bad9a4b6$var$tls.flush(c);
    };
    /**
   * Closes the connection (sends a close_notify alert).
   *
   * @param clearFail true to clear the fail flag (default: true).
   */ c.close = function(clearFail) {
        // save session if connection didn't fail
        if (!c.fail && c.sessionCache && c.session) {
            // only need to preserve session ID, version, and security params
            var session = {
                id: c.session.id,
                version: c.session.version,
                sp: c.session.sp
            };
            session.sp.keys = null;
            c.sessionCache.setSession(session.id, session);
        }
        if (c.open) {
            // connection no longer open, clear input
            c.open = false;
            c.input.clear();
            // if connected or handshaking, send an alert
            if (c.isConnected || c.handshaking) {
                c.isConnected = c.handshaking = false;
                // send close_notify alert
                $69688044bad9a4b6$var$tls.queue(c, $69688044bad9a4b6$var$tls.createAlert(c, {
                    level: $69688044bad9a4b6$var$tls.Alert.Level.warning,
                    description: $69688044bad9a4b6$var$tls.Alert.Description.close_notify
                }));
                $69688044bad9a4b6$var$tls.flush(c);
            }
            // call handler
            c.closed(c);
        }
        // reset TLS connection, do not clear fail flag
        c.reset(clearFail);
    };
    return c;
};
/* TLS API */ module.exports = $fz7FM.tls = $fz7FM.tls || {};
// expose non-functions
for(var $69688044bad9a4b6$var$key in $69688044bad9a4b6$var$tls)if (typeof $69688044bad9a4b6$var$tls[$69688044bad9a4b6$var$key] !== "function") $fz7FM.tls[$69688044bad9a4b6$var$key] = $69688044bad9a4b6$var$tls[$69688044bad9a4b6$var$key];
// expose prf_tls1 for testing
$fz7FM.tls.prf_tls1 = $69688044bad9a4b6$var$prf_TLS1;
// expose sha1 hmac method
$fz7FM.tls.hmac_sha1 = $69688044bad9a4b6$var$hmac_sha1;
// expose session cache creation
$fz7FM.tls.createSessionCache = $69688044bad9a4b6$var$tls.createSessionCache;
/**
 * Creates a new TLS connection. This does not make any assumptions about the
 * transport layer that TLS is working on top of, ie: it does not assume there
 * is a TCP/IP connection or establish one. A TLS connection is totally
 * abstracted away from the layer is runs on top of, it merely establishes a
 * secure channel between a client" and a "server".
 *
 * A TLS connection contains 4 connection states: pending read and write, and
 * current read and write.
 *
 * At initialization, the current read and write states will be null. Only once
 * the security parameters have been set and the keys have been generated can
 * the pending states be converted into current states. Current states will be
 * updated for each record processed.
 *
 * A custom certificate verify callback may be provided to check information
 * like the common name on the server's certificate. It will be called for
 * every certificate in the chain. It has the following signature:
 *
 * variable func(c, certs, index, preVerify)
 * Where:
 * c         The TLS connection
 * verified  Set to true if certificate was verified, otherwise the alert
 *           tls.Alert.Description for why the certificate failed.
 * depth     The current index in the chain, where 0 is the server's cert.
 * certs     The certificate chain, *NOTE* if the server was anonymous then
 *           the chain will be empty.
 *
 * The function returns true on success and on failure either the appropriate
 * tls.Alert.Description or an object with 'alert' set to the appropriate
 * tls.Alert.Description and 'message' set to a custom error message. If true
 * is not returned then the connection will abort using, in order of
 * availability, first the returned alert description, second the preVerify
 * alert description, and lastly the default 'bad_certificate'.
 *
 * There are three callbacks that can be used to make use of client-side
 * certificates where each takes the TLS connection as the first parameter:
 *
 * getCertificate(conn, hint)
 *   The second parameter is a hint as to which certificate should be
 *   returned. If the connection entity is a client, then the hint will be
 *   the CertificateRequest message from the server that is part of the
 *   TLS protocol. If the connection entity is a server, then it will be
 *   the servername list provided via an SNI extension the ClientHello, if
 *   one was provided (empty array if not). The hint can be examined to
 *   determine which certificate to use (advanced). Most implementations
 *   will just return a certificate. The return value must be a
 *   PEM-formatted certificate or an array of PEM-formatted certificates
 *   that constitute a certificate chain, with the first in the array/chain
 *   being the client's certificate.
 * getPrivateKey(conn, certificate)
 *   The second parameter is an forge.pki X.509 certificate object that
 *   is associated with the requested private key. The return value must
 *   be a PEM-formatted private key.
 * getSignature(conn, bytes, callback)
 *   This callback can be used instead of getPrivateKey if the private key
 *   is not directly accessible in javascript or should not be. For
 *   instance, a secure external web service could provide the signature
 *   in exchange for appropriate credentials. The second parameter is a
 *   string of bytes to be signed that are part of the TLS protocol. These
 *   bytes are used to verify that the private key for the previously
 *   provided client-side certificate is accessible to the client. The
 *   callback is a function that takes 2 parameters, the TLS connection
 *   and the RSA encrypted (signed) bytes as a string. This callback must
 *   be called once the signature is ready.
 *
 * @param options the options for this connection:
 *   server: true if the connection is server-side, false for client.
 *   sessionId: a session ID to reuse, null for a new connection.
 *   caStore: an array of certificates to trust.
 *   sessionCache: a session cache to use.
 *   cipherSuites: an optional array of cipher suites to use,
 *     see tls.CipherSuites.
 *   connected: function(conn) called when the first handshake completes.
 *   virtualHost: the virtual server name to use in a TLS SNI extension.
 *   verifyClient: true to require a client certificate in server mode,
 *     'optional' to request one, false not to (default: false).
 *   verify: a handler used to custom verify certificates in the chain.
 *   verifyOptions: an object with options for the certificate chain validation.
 *     See documentation of pki.verifyCertificateChain for possible options.
 *     verifyOptions.verify is ignored. If you wish to specify a verify handler
 *     use the verify key.
 *   getCertificate: an optional callback used to get a certificate or
 *     a chain of certificates (as an array).
 *   getPrivateKey: an optional callback used to get a private key.
 *   getSignature: an optional callback used to get a signature.
 *   tlsDataReady: function(conn) called when TLS protocol data has been
 *     prepared and is ready to be used (typically sent over a socket
 *     connection to its destination), read from conn.tlsData buffer.
 *   dataReady: function(conn) called when application data has
 *     been parsed from a TLS record and should be consumed by the
 *     application, read from conn.data buffer.
 *   closed: function(conn) called when the connection has been closed.
 *   error: function(conn, error) called when there was an error.
 *   deflate: function(inBytes) if provided, will deflate TLS records using
 *     the deflate algorithm if the server supports it.
 *   inflate: function(inBytes) if provided, will inflate TLS records using
 *     the deflate algorithm if the server supports it.
 *
 * @return the new TLS connection.
 */ $fz7FM.tls.createConnection = $69688044bad9a4b6$var$tls.createConnection;

});
parcelRegister("d4EnE", function(module, exports) {
/**
 * Javascript implementation of Abstract Syntax Notation Number One.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2015 Digital Bazaar, Inc.
 *
 * An API for storing data using the Abstract Syntax Notation Number One
 * format using DER (Distinguished Encoding Rules) encoding. This encoding is
 * commonly used to store data for PKI, i.e. X.509 Certificates, and this
 * implementation exists for that purpose.
 *
 * Abstract Syntax Notation Number One (ASN.1) is used to define the abstract
 * syntax of information without restricting the way the information is encoded
 * for transmission. It provides a standard that allows for open systems
 * communication. ASN.1 defines the syntax of information data and a number of
 * simple data types as well as a notation for describing them and specifying
 * values for them.
 *
 * The RSA algorithm creates public and private keys that are often stored in
 * X.509 or PKCS#X formats -- which use ASN.1 (encoded in DER format). This
 * class provides the most basic functionality required to store and load DSA
 * keys that are encoded according to ASN.1.
 *
 * The most common binary encodings for ASN.1 are BER (Basic Encoding Rules)
 * and DER (Distinguished Encoding Rules). DER is just a subset of BER that
 * has stricter requirements for how data must be encoded.
 *
 * Each ASN.1 structure has a tag (a byte identifying the ASN.1 structure type)
 * and a byte array for the value of this ASN1 structure which may be data or a
 * list of ASN.1 structures.
 *
 * Each ASN.1 structure using BER is (Tag-Length-Value):
 *
 * | byte 0 | bytes X | bytes Y |
 * |--------|---------|----------
 * |  tag   | length  |  value  |
 *
 * ASN.1 allows for tags to be of "High-tag-number form" which allows a tag to
 * be two or more octets, but that is not supported by this class. A tag is
 * only 1 byte. Bits 1-5 give the tag number (ie the data type within a
 * particular 'class'), 6 indicates whether or not the ASN.1 value is
 * constructed from other ASN.1 values, and bits 7 and 8 give the 'class'. If
 * bits 7 and 8 are both zero, the class is UNIVERSAL. If only bit 7 is set,
 * then the class is APPLICATION. If only bit 8 is set, then the class is
 * CONTEXT_SPECIFIC. If both bits 7 and 8 are set, then the class is PRIVATE.
 * The tag numbers for the data types for the class UNIVERSAL are listed below:
 *
 * UNIVERSAL 0 Reserved for use by the encoding rules
 * UNIVERSAL 1 Boolean type
 * UNIVERSAL 2 Integer type
 * UNIVERSAL 3 Bitstring type
 * UNIVERSAL 4 Octetstring type
 * UNIVERSAL 5 Null type
 * UNIVERSAL 6 Object identifier type
 * UNIVERSAL 7 Object descriptor type
 * UNIVERSAL 8 External type and Instance-of type
 * UNIVERSAL 9 Real type
 * UNIVERSAL 10 Enumerated type
 * UNIVERSAL 11 Embedded-pdv type
 * UNIVERSAL 12 UTF8String type
 * UNIVERSAL 13 Relative object identifier type
 * UNIVERSAL 14-15 Reserved for future editions
 * UNIVERSAL 16 Sequence and Sequence-of types
 * UNIVERSAL 17 Set and Set-of types
 * UNIVERSAL 18-22, 25-30 Character string types
 * UNIVERSAL 23-24 Time types
 *
 * The length of an ASN.1 structure is specified after the tag identifier.
 * There is a definite form and an indefinite form. The indefinite form may
 * be used if the encoding is constructed and not all immediately available.
 * The indefinite form is encoded using a length byte with only the 8th bit
 * set. The end of the constructed object is marked using end-of-contents
 * octets (two zero bytes).
 *
 * The definite form looks like this:
 *
 * The length may take up 1 or more bytes, it depends on the length of the
 * value of the ASN.1 structure. DER encoding requires that if the ASN.1
 * structure has a value that has a length greater than 127, more than 1 byte
 * will be used to store its length, otherwise just one byte will be used.
 * This is strict.
 *
 * In the case that the length of the ASN.1 value is less than 127, 1 octet
 * (byte) is used to store the "short form" length. The 8th bit has a value of
 * 0 indicating the length is "short form" and not "long form" and bits 7-1
 * give the length of the data. (The 8th bit is the left-most, most significant
 * bit: also known as big endian or network format).
 *
 * In the case that the length of the ASN.1 value is greater than 127, 2 to
 * 127 octets (bytes) are used to store the "long form" length. The first
 * byte's 8th bit is set to 1 to indicate the length is "long form." Bits 7-1
 * give the number of additional octets. All following octets are in base 256
 * with the most significant digit first (typical big-endian binary unsigned
 * integer storage). So, for instance, if the length of a value was 257, the
 * first byte would be set to:
 *
 * 10000010 = 130 = 0x82.
 *
 * This indicates there are 2 octets (base 256) for the length. The second and
 * third bytes (the octets just mentioned) would store the length in base 256:
 *
 * octet 2: 00000001 = 1 * 256^1 = 256
 * octet 3: 00000001 = 1 * 256^0 = 1
 * total = 257
 *
 * The algorithm for converting a js integer value of 257 to base-256 is:
 *
 * var value = 257;
 * var bytes = [];
 * bytes[0] = (value >>> 8) & 0xFF; // most significant byte first
 * bytes[1] = value & 0xFF;        // least significant byte last
 *
 * On the ASN.1 UNIVERSAL Object Identifier (OID) type:
 *
 * An OID can be written like: "value1.value2.value3...valueN"
 *
 * The DER encoding rules:
 *
 * The first byte has the value 40 * value1 + value2.
 * The following bytes, if any, encode the remaining values. Each value is
 * encoded in base 128, most significant digit first (big endian), with as
 * few digits as possible, and the most significant bit of each byte set
 * to 1 except the last in each value's encoding. For example: Given the
 * OID "1.2.840.113549", its DER encoding is (remember each byte except the
 * last one in each encoding is OR'd with 0x80):
 *
 * byte 1: 40 * 1 + 2 = 42 = 0x2A.
 * bytes 2-3: 128 * 6 + 72 = 840 = 6 72 = 6 72 = 0x0648 = 0x8648
 * bytes 4-6: 16384 * 6 + 128 * 119 + 13 = 6 119 13 = 0x06770D = 0x86F70D
 *
 * The final value is: 0x2A864886F70D.
 * The full OID (including ASN.1 tag and length of 6 bytes) is:
 * 0x06062A864886F70D
 */ 
var $l0HdX = parcelRequire("l0HdX");

var $fz7FM = parcelRequire("fz7FM");
parcelRequire("gao36");
parcelRequire("dm89c");
/* ASN.1 API */ var $984af8c9ec0fa78a$var$asn1 = module.exports = $fz7FM.asn1 = $fz7FM.asn1 || {};
/**
 * ASN.1 classes.
 */ $984af8c9ec0fa78a$var$asn1.Class = {
    UNIVERSAL: 0x00,
    APPLICATION: 0x40,
    CONTEXT_SPECIFIC: 0x80,
    PRIVATE: 0xC0
};
/**
 * ASN.1 types. Not all types are supported by this implementation, only
 * those necessary to implement a simple PKI are implemented.
 */ $984af8c9ec0fa78a$var$asn1.Type = {
    NONE: 0,
    BOOLEAN: 1,
    INTEGER: 2,
    BITSTRING: 3,
    OCTETSTRING: 4,
    NULL: 5,
    OID: 6,
    ODESC: 7,
    EXTERNAL: 8,
    REAL: 9,
    ENUMERATED: 10,
    EMBEDDED: 11,
    UTF8: 12,
    ROID: 13,
    SEQUENCE: 16,
    SET: 17,
    PRINTABLESTRING: 19,
    IA5STRING: 22,
    UTCTIME: 23,
    GENERALIZEDTIME: 24,
    BMPSTRING: 30
};
/**
 * Creates a new asn1 object.
 *
 * @param tagClass the tag class for the object.
 * @param type the data type (tag number) for the object.
 * @param constructed true if the asn1 object is in constructed form.
 * @param value the value for the object, if it is not constructed.
 * @param [options] the options to use:
 *          [bitStringContents] the plain BIT STRING content including padding
 *            byte.
 *
 * @return the asn1 object.
 */ $984af8c9ec0fa78a$var$asn1.create = function(tagClass, type, constructed, value, options) {
    /* An asn1 object has a tagClass, a type, a constructed flag, and a
    value. The value's type depends on the constructed flag. If
    constructed, it will contain a list of other asn1 objects. If not,
    it will contain the ASN.1 value as an array of bytes formatted
    according to the ASN.1 data type. */ // remove undefined values
    if ($fz7FM.util.isArray(value)) {
        var tmp = [];
        for(var i = 0; i < value.length; ++i)if (value[i] !== undefined) tmp.push(value[i]);
        value = tmp;
    }
    var obj = {
        tagClass: tagClass,
        type: type,
        constructed: constructed,
        composed: constructed || $fz7FM.util.isArray(value),
        value: value
    };
    if (options && "bitStringContents" in options) {
        // TODO: copy byte buffer if it's a buffer not a string
        obj.bitStringContents = options.bitStringContents;
        // TODO: add readonly flag to avoid this overhead
        // save copy to detect changes
        obj.original = $984af8c9ec0fa78a$var$asn1.copy(obj);
    }
    return obj;
};
/**
 * Copies an asn1 object.
 *
 * @param obj the asn1 object.
 * @param [options] copy options:
 *          [excludeBitStringContents] true to not copy bitStringContents
 *
 * @return the a copy of the asn1 object.
 */ $984af8c9ec0fa78a$var$asn1.copy = function(obj, options) {
    var copy;
    if ($fz7FM.util.isArray(obj)) {
        copy = [];
        for(var i = 0; i < obj.length; ++i)copy.push($984af8c9ec0fa78a$var$asn1.copy(obj[i], options));
        return copy;
    }
    if (typeof obj === "string") // TODO: copy byte buffer if it's a buffer not a string
    return obj;
    copy = {
        tagClass: obj.tagClass,
        type: obj.type,
        constructed: obj.constructed,
        composed: obj.composed,
        value: $984af8c9ec0fa78a$var$asn1.copy(obj.value, options)
    };
    if (options && !options.excludeBitStringContents) // TODO: copy byte buffer if it's a buffer not a string
    copy.bitStringContents = obj.bitStringContents;
    return copy;
};
/**
 * Compares asn1 objects for equality.
 *
 * Note this function does not run in constant time.
 *
 * @param obj1 the first asn1 object.
 * @param obj2 the second asn1 object.
 * @param [options] compare options:
 *          [includeBitStringContents] true to compare bitStringContents
 *
 * @return true if the asn1 objects are equal.
 */ $984af8c9ec0fa78a$var$asn1.equals = function(obj1, obj2, options) {
    if ($fz7FM.util.isArray(obj1)) {
        if (!$fz7FM.util.isArray(obj2)) return false;
        if (obj1.length !== obj2.length) return false;
        for(var i = 0; i < obj1.length; ++i){
            if (!$984af8c9ec0fa78a$var$asn1.equals(obj1[i], obj2[i])) return false;
        }
        return true;
    }
    if ((typeof obj1 === "undefined" ? "undefined" : (0, $l0HdX._)(obj1)) !== (typeof obj2 === "undefined" ? "undefined" : (0, $l0HdX._)(obj2))) return false;
    if (typeof obj1 === "string") return obj1 === obj2;
    var equal = obj1.tagClass === obj2.tagClass && obj1.type === obj2.type && obj1.constructed === obj2.constructed && obj1.composed === obj2.composed && $984af8c9ec0fa78a$var$asn1.equals(obj1.value, obj2.value);
    if (options && options.includeBitStringContents) equal = equal && obj1.bitStringContents === obj2.bitStringContents;
    return equal;
};
/**
 * Gets the length of a BER-encoded ASN.1 value.
 *
 * In case the length is not specified, undefined is returned.
 *
 * @param b the BER-encoded ASN.1 byte buffer, starting with the first
 *          length byte.
 *
 * @return the length of the BER-encoded ASN.1 value or undefined.
 */ $984af8c9ec0fa78a$var$asn1.getBerValueLength = function(b) {
    // TODO: move this function and related DER/BER functions to a der.js
    // file; better abstract ASN.1 away from der/ber.
    var b2 = b.getByte();
    if (b2 === 0x80) return undefined;
    // see if the length is "short form" or "long form" (bit 8 set)
    var length;
    var longForm = b2 & 0x80;
    if (!longForm) // length is just the first byte
    length = b2;
    else // the number of bytes the length is specified in bits 7 through 1
    // and each length byte is in big-endian base-256
    length = b.getInt((b2 & 0x7F) << 3);
    return length;
};
/**
 * Check if the byte buffer has enough bytes. Throws an Error if not.
 *
 * @param bytes the byte buffer to parse from.
 * @param remaining the bytes remaining in the current parsing state.
 * @param n the number of bytes the buffer must have.
 */ function $984af8c9ec0fa78a$var$_checkBufferLength(bytes, remaining, n) {
    if (n > remaining) {
        var error = new Error("Too few bytes to parse DER.");
        error.available = bytes.length();
        error.remaining = remaining;
        error.requested = n;
        throw error;
    }
}
/**
 * Gets the length of a BER-encoded ASN.1 value.
 *
 * In case the length is not specified, undefined is returned.
 *
 * @param bytes the byte buffer to parse from.
 * @param remaining the bytes remaining in the current parsing state.
 *
 * @return the length of the BER-encoded ASN.1 value or undefined.
 */ var $984af8c9ec0fa78a$var$_getValueLength = function _getValueLength(bytes, remaining) {
    // TODO: move this function and related DER/BER functions to a der.js
    // file; better abstract ASN.1 away from der/ber.
    // fromDer already checked that this byte exists
    var b2 = bytes.getByte();
    remaining--;
    if (b2 === 0x80) return undefined;
    // see if the length is "short form" or "long form" (bit 8 set)
    var length;
    var longForm = b2 & 0x80;
    if (!longForm) // length is just the first byte
    length = b2;
    else {
        // the number of bytes the length is specified in bits 7 through 1
        // and each length byte is in big-endian base-256
        var longFormBytes = b2 & 0x7F;
        $984af8c9ec0fa78a$var$_checkBufferLength(bytes, remaining, longFormBytes);
        length = bytes.getInt(longFormBytes << 3);
    }
    // FIXME: this will only happen for 32 bit getInt with high bit set
    if (length < 0) throw new Error("Negative length: " + length);
    return length;
};
/**
 * Parses an asn1 object from a byte buffer in DER format.
 *
 * @param bytes the byte buffer to parse from.
 * @param [strict] true to be strict when checking value lengths, false to
 *          allow truncated values (default: true).
 * @param [options] object with options or boolean strict flag
 *          [strict] true to be strict when checking value lengths, false to
 *            allow truncated values (default: true).
 *          [parseAllBytes] true to ensure all bytes are parsed
 *            (default: true)
 *          [decodeBitStrings] true to attempt to decode the content of
 *            BIT STRINGs (not OCTET STRINGs) using strict mode. Note that
 *            without schema support to understand the data context this can
 *            erroneously decode values that happen to be valid ASN.1. This
 *            flag will be deprecated or removed as soon as schema support is
 *            available. (default: true)
 *
 * @throws Will throw an error for various malformed input conditions.
 *
 * @return the parsed asn1 object.
 */ $984af8c9ec0fa78a$var$asn1.fromDer = function(bytes, options) {
    if (options === undefined) options = {
        strict: true,
        parseAllBytes: true,
        decodeBitStrings: true
    };
    if (typeof options === "boolean") options = {
        strict: options,
        parseAllBytes: true,
        decodeBitStrings: true
    };
    if (!("strict" in options)) options.strict = true;
    if (!("parseAllBytes" in options)) options.parseAllBytes = true;
    if (!("decodeBitStrings" in options)) options.decodeBitStrings = true;
    // wrap in buffer if needed
    if (typeof bytes === "string") bytes = $fz7FM.util.createBuffer(bytes);
    var byteCount = bytes.length();
    var value = $984af8c9ec0fa78a$var$_fromDer(bytes, bytes.length(), 0, options);
    if (options.parseAllBytes && bytes.length() !== 0) {
        var error = new Error("Unparsed DER bytes remain after ASN.1 parsing.");
        error.byteCount = byteCount;
        error.remaining = bytes.length();
        throw error;
    }
    return value;
};
/**
 * Internal function to parse an asn1 object from a byte buffer in DER format.
 *
 * @param bytes the byte buffer to parse from.
 * @param remaining the number of bytes remaining for this chunk.
 * @param depth the current parsing depth.
 * @param options object with same options as fromDer().
 *
 * @return the parsed asn1 object.
 */ function $984af8c9ec0fa78a$var$_fromDer(bytes, remaining, depth, options) {
    // temporary storage for consumption calculations
    var start;
    // minimum length for ASN.1 DER structure is 2
    $984af8c9ec0fa78a$var$_checkBufferLength(bytes, remaining, 2);
    // get the first byte
    var b1 = bytes.getByte();
    // consumed one byte
    remaining--;
    // get the tag class
    var tagClass = b1 & 0xC0;
    // get the type (bits 1-5)
    var type = b1 & 0x1F;
    // get the variable value length and adjust remaining bytes
    start = bytes.length();
    var length = $984af8c9ec0fa78a$var$_getValueLength(bytes, remaining);
    remaining -= start - bytes.length();
    // ensure there are enough bytes to get the value
    if (length !== undefined && length > remaining) {
        if (options.strict) {
            var error = new Error("Too few bytes to read ASN.1 value.");
            error.available = bytes.length();
            error.remaining = remaining;
            error.requested = length;
            throw error;
        }
        // Note: be lenient with truncated values and use remaining state bytes
        length = remaining;
    }
    // value storage
    var value;
    // possible BIT STRING contents storage
    var bitStringContents;
    // constructed flag is bit 6 (32 = 0x20) of the first byte
    var constructed = (b1 & 0x20) === 0x20;
    if (constructed) {
        // parse child asn1 objects from the value
        value = [];
        if (length === undefined) // asn1 object of indefinite length, read until end tag
        for(;;){
            $984af8c9ec0fa78a$var$_checkBufferLength(bytes, remaining, 2);
            if (bytes.bytes(2) === String.fromCharCode(0, 0)) {
                bytes.getBytes(2);
                remaining -= 2;
                break;
            }
            start = bytes.length();
            value.push($984af8c9ec0fa78a$var$_fromDer(bytes, remaining, depth + 1, options));
            remaining -= start - bytes.length();
        }
        else // parsing asn1 object of definite length
        while(length > 0){
            start = bytes.length();
            value.push($984af8c9ec0fa78a$var$_fromDer(bytes, length, depth + 1, options));
            remaining -= start - bytes.length();
            length -= start - bytes.length();
        }
    }
    // if a BIT STRING, save the contents including padding
    if (value === undefined && tagClass === $984af8c9ec0fa78a$var$asn1.Class.UNIVERSAL && type === $984af8c9ec0fa78a$var$asn1.Type.BITSTRING) bitStringContents = bytes.bytes(length);
    // determine if a non-constructed value should be decoded as a composed
    // value that contains other ASN.1 objects. BIT STRINGs (and OCTET STRINGs)
    // can be used this way.
    if (value === undefined && options.decodeBitStrings && tagClass === $984af8c9ec0fa78a$var$asn1.Class.UNIVERSAL && // FIXME: OCTET STRINGs not yet supported here
    // .. other parts of forge expect to decode OCTET STRINGs manually
    type === $984af8c9ec0fa78a$var$asn1.Type.BITSTRING /*|| type === asn1.Type.OCTETSTRING*/  && length > 1) {
        // save read position
        var savedRead = bytes.read;
        var savedRemaining = remaining;
        var unused = 0;
        if (type === $984af8c9ec0fa78a$var$asn1.Type.BITSTRING) {
            /* The first octet gives the number of bits by which the length of the
        bit string is less than the next multiple of eight (this is called
        the "number of unused bits").

        The second and following octets give the value of the bit string
        converted to an octet string. */ $984af8c9ec0fa78a$var$_checkBufferLength(bytes, remaining, 1);
            unused = bytes.getByte();
            remaining--;
        }
        // if all bits are used, maybe the BIT/OCTET STRING holds ASN.1 objs
        if (unused === 0) try {
            // attempt to parse child asn1 object from the value
            // (stored in array to signal composed value)
            start = bytes.length();
            var subOptions = {
                // enforce strict mode to avoid parsing ASN.1 from plain data
                strict: true,
                decodeBitStrings: true
            };
            var composed = $984af8c9ec0fa78a$var$_fromDer(bytes, remaining, depth + 1, subOptions);
            var used = start - bytes.length();
            remaining -= used;
            if (type == $984af8c9ec0fa78a$var$asn1.Type.BITSTRING) used++;
            // if the data all decoded and the class indicates UNIVERSAL or
            // CONTEXT_SPECIFIC then assume we've got an encapsulated ASN.1 object
            var tc = composed.tagClass;
            if (used === length && (tc === $984af8c9ec0fa78a$var$asn1.Class.UNIVERSAL || tc === $984af8c9ec0fa78a$var$asn1.Class.CONTEXT_SPECIFIC)) value = [
                composed
            ];
        } catch (ex) {}
        if (value === undefined) {
            // restore read position
            bytes.read = savedRead;
            remaining = savedRemaining;
        }
    }
    if (value === undefined) {
        // asn1 not constructed or composed, get raw value
        // TODO: do DER to OID conversion and vice-versa in .toDer?
        if (length === undefined) {
            if (options.strict) throw new Error("Non-constructed ASN.1 object of indefinite length.");
            // be lenient and use remaining state bytes
            length = remaining;
        }
        if (type === $984af8c9ec0fa78a$var$asn1.Type.BMPSTRING) {
            value = "";
            for(; length > 0; length -= 2){
                $984af8c9ec0fa78a$var$_checkBufferLength(bytes, remaining, 2);
                value += String.fromCharCode(bytes.getInt16());
                remaining -= 2;
            }
        } else {
            value = bytes.getBytes(length);
            remaining -= length;
        }
    }
    // add BIT STRING contents if available
    var asn1Options = bitStringContents === undefined ? null : {
        bitStringContents: bitStringContents
    };
    // create and return asn1 object
    return $984af8c9ec0fa78a$var$asn1.create(tagClass, type, constructed, value, asn1Options);
}
/**
 * Converts the given asn1 object to a buffer of bytes in DER format.
 *
 * @param asn1 the asn1 object to convert to bytes.
 *
 * @return the buffer of bytes.
 */ $984af8c9ec0fa78a$var$asn1.toDer = function(obj) {
    var bytes = $fz7FM.util.createBuffer();
    // build the first byte
    var b1 = obj.tagClass | obj.type;
    // for storing the ASN.1 value
    var value = $fz7FM.util.createBuffer();
    // use BIT STRING contents if available and data not changed
    var useBitStringContents = false;
    if ("bitStringContents" in obj) {
        useBitStringContents = true;
        if (obj.original) useBitStringContents = $984af8c9ec0fa78a$var$asn1.equals(obj, obj.original);
    }
    if (useBitStringContents) value.putBytes(obj.bitStringContents);
    else if (obj.composed) {
        // if composed, use each child asn1 object's DER bytes as value
        // turn on 6th bit (0x20 = 32) to indicate asn1 is constructed
        // from other asn1 objects
        if (obj.constructed) b1 |= 0x20;
        else // type is a bit string, add unused bits of 0x00
        value.putByte(0x00);
        // add all of the child DER bytes together
        for(var i = 0; i < obj.value.length; ++i)if (obj.value[i] !== undefined) value.putBuffer($984af8c9ec0fa78a$var$asn1.toDer(obj.value[i]));
    } else {
        // use asn1.value directly
        if (obj.type === $984af8c9ec0fa78a$var$asn1.Type.BMPSTRING) for(var i = 0; i < obj.value.length; ++i)value.putInt16(obj.value.charCodeAt(i));
        else // ensure integer is minimally-encoded
        // TODO: should all leading bytes be stripped vs just one?
        // .. ex '00 00 01' => '01'?
        if (obj.type === $984af8c9ec0fa78a$var$asn1.Type.INTEGER && obj.value.length > 1 && // leading 0x00 for positive integer
        (obj.value.charCodeAt(0) === 0 && (obj.value.charCodeAt(1) & 0x80) === 0 || // leading 0xFF for negative integer
        obj.value.charCodeAt(0) === 0xFF && (obj.value.charCodeAt(1) & 0x80) === 0x80)) value.putBytes(obj.value.substr(1));
        else value.putBytes(obj.value);
    }
    // add tag byte
    bytes.putByte(b1);
    // use "short form" encoding
    if (value.length() <= 127) // one byte describes the length
    // bit 8 = 0 and bits 7-1 = length
    bytes.putByte(value.length() & 0x7F);
    else {
        // use "long form" encoding
        // 2 to 127 bytes describe the length
        // first byte: bit 8 = 1 and bits 7-1 = # of additional bytes
        // other bytes: length in base 256, big-endian
        var len = value.length();
        var lenBytes = "";
        do {
            lenBytes += String.fromCharCode(len & 0xFF);
            len = len >>> 8;
        }while (len > 0);
        // set first byte to # bytes used to store the length and turn on
        // bit 8 to indicate long-form length is used
        bytes.putByte(lenBytes.length | 0x80);
        // concatenate length bytes in reverse since they were generated
        // little endian and we need big endian
        for(var i = lenBytes.length - 1; i >= 0; --i)bytes.putByte(lenBytes.charCodeAt(i));
    }
    // concatenate value bytes
    bytes.putBuffer(value);
    return bytes;
};
/**
 * Converts an OID dot-separated string to a byte buffer. The byte buffer
 * contains only the DER-encoded value, not any tag or length bytes.
 *
 * @param oid the OID dot-separated string.
 *
 * @return the byte buffer.
 */ $984af8c9ec0fa78a$var$asn1.oidToDer = function(oid) {
    // split OID into individual values
    var values = oid.split(".");
    var bytes = $fz7FM.util.createBuffer();
    // first byte is 40 * value1 + value2
    bytes.putByte(40 * parseInt(values[0], 10) + parseInt(values[1], 10));
    // other bytes are each value in base 128 with 8th bit set except for
    // the last byte for each value
    var last, valueBytes, value, b;
    for(var i = 2; i < values.length; ++i){
        // produce value bytes in reverse because we don't know how many
        // bytes it will take to store the value
        last = true;
        valueBytes = [];
        value = parseInt(values[i], 10);
        do {
            b = value & 0x7F;
            value = value >>> 7;
            // if value is not last, then turn on 8th bit
            if (!last) b |= 0x80;
            valueBytes.push(b);
            last = false;
        }while (value > 0);
        // add value bytes in reverse (needs to be in big endian)
        for(var n = valueBytes.length - 1; n >= 0; --n)bytes.putByte(valueBytes[n]);
    }
    return bytes;
};
/**
 * Converts a DER-encoded byte buffer to an OID dot-separated string. The
 * byte buffer should contain only the DER-encoded value, not any tag or
 * length bytes.
 *
 * @param bytes the byte buffer.
 *
 * @return the OID dot-separated string.
 */ $984af8c9ec0fa78a$var$asn1.derToOid = function(bytes) {
    var oid;
    // wrap in buffer if needed
    if (typeof bytes === "string") bytes = $fz7FM.util.createBuffer(bytes);
    // first byte is 40 * value1 + value2
    var b = bytes.getByte();
    oid = Math.floor(b / 40) + "." + b % 40;
    // other bytes are each value in base 128 with 8th bit set except for
    // the last byte for each value
    var value = 0;
    while(bytes.length() > 0){
        b = bytes.getByte();
        value = value << 7;
        // not the last byte for the value
        if (b & 0x80) value += b & 0x7F;
        else {
            // last byte
            oid += "." + (value + b);
            value = 0;
        }
    }
    return oid;
};
/**
 * Converts a UTCTime value to a date.
 *
 * Note: GeneralizedTime has 4 digits for the year and is used for X.509
 * dates past 2049. Parsing that structure hasn't been implemented yet.
 *
 * @param utc the UTCTime value to convert.
 *
 * @return the date.
 */ $984af8c9ec0fa78a$var$asn1.utcTimeToDate = function(utc) {
    /* The following formats can be used:

    YYMMDDhhmmZ
    YYMMDDhhmm+hh'mm'
    YYMMDDhhmm-hh'mm'
    YYMMDDhhmmssZ
    YYMMDDhhmmss+hh'mm'
    YYMMDDhhmmss-hh'mm'

    Where:

    YY is the least significant two digits of the year
    MM is the month (01 to 12)
    DD is the day (01 to 31)
    hh is the hour (00 to 23)
    mm are the minutes (00 to 59)
    ss are the seconds (00 to 59)
    Z indicates that local time is GMT, + indicates that local time is
    later than GMT, and - indicates that local time is earlier than GMT
    hh' is the absolute value of the offset from GMT in hours
    mm' is the absolute value of the offset from GMT in minutes */ var date = new Date();
    // if YY >= 50 use 19xx, if YY < 50 use 20xx
    var year = parseInt(utc.substr(0, 2), 10);
    year = year >= 50 ? 1900 + year : 2000 + year;
    var MM = parseInt(utc.substr(2, 2), 10) - 1; // use 0-11 for month
    var DD = parseInt(utc.substr(4, 2), 10);
    var hh = parseInt(utc.substr(6, 2), 10);
    var mm = parseInt(utc.substr(8, 2), 10);
    var ss = 0;
    // not just YYMMDDhhmmZ
    if (utc.length > 11) {
        // get character after minutes
        var c = utc.charAt(10);
        var end = 10;
        // see if seconds are present
        if (c !== "+" && c !== "-") {
            // get seconds
            ss = parseInt(utc.substr(10, 2), 10);
            end += 2;
        }
    }
    // update date
    date.setUTCFullYear(year, MM, DD);
    date.setUTCHours(hh, mm, ss, 0);
    if (end) {
        // get +/- after end of time
        c = utc.charAt(end);
        if (c === "+" || c === "-") {
            // get hours+minutes offset
            var hhoffset = parseInt(utc.substr(end + 1, 2), 10);
            var mmoffset = parseInt(utc.substr(end + 4, 2), 10);
            // calculate offset in milliseconds
            var offset = hhoffset * 60 + mmoffset;
            offset *= 60000;
            // apply offset
            if (c === "+") date.setTime(+date - offset);
            else date.setTime(+date + offset);
        }
    }
    return date;
};
/**
 * Converts a GeneralizedTime value to a date.
 *
 * @param gentime the GeneralizedTime value to convert.
 *
 * @return the date.
 */ $984af8c9ec0fa78a$var$asn1.generalizedTimeToDate = function(gentime) {
    /* The following formats can be used:

    YYYYMMDDHHMMSS
    YYYYMMDDHHMMSS.fff
    YYYYMMDDHHMMSSZ
    YYYYMMDDHHMMSS.fffZ
    YYYYMMDDHHMMSS+hh'mm'
    YYYYMMDDHHMMSS.fff+hh'mm'
    YYYYMMDDHHMMSS-hh'mm'
    YYYYMMDDHHMMSS.fff-hh'mm'

    Where:

    YYYY is the year
    MM is the month (01 to 12)
    DD is the day (01 to 31)
    hh is the hour (00 to 23)
    mm are the minutes (00 to 59)
    ss are the seconds (00 to 59)
    .fff is the second fraction, accurate to three decimal places
    Z indicates that local time is GMT, + indicates that local time is
    later than GMT, and - indicates that local time is earlier than GMT
    hh' is the absolute value of the offset from GMT in hours
    mm' is the absolute value of the offset from GMT in minutes */ var date = new Date();
    var YYYY = parseInt(gentime.substr(0, 4), 10);
    var MM = parseInt(gentime.substr(4, 2), 10) - 1; // use 0-11 for month
    var DD = parseInt(gentime.substr(6, 2), 10);
    var hh = parseInt(gentime.substr(8, 2), 10);
    var mm = parseInt(gentime.substr(10, 2), 10);
    var ss = parseInt(gentime.substr(12, 2), 10);
    var fff = 0;
    var offset = 0;
    var isUTC = false;
    if (gentime.charAt(gentime.length - 1) === "Z") isUTC = true;
    var end = gentime.length - 5, c = gentime.charAt(end);
    if (c === "+" || c === "-") {
        // get hours+minutes offset
        var hhoffset = parseInt(gentime.substr(end + 1, 2), 10);
        var mmoffset = parseInt(gentime.substr(end + 4, 2), 10);
        // calculate offset in milliseconds
        offset = hhoffset * 60 + mmoffset;
        offset *= 60000;
        // apply offset
        if (c === "+") offset *= -1;
        isUTC = true;
    }
    // check for second fraction
    if (gentime.charAt(14) === ".") fff = parseFloat(gentime.substr(14), 10) * 1000;
    if (isUTC) {
        date.setUTCFullYear(YYYY, MM, DD);
        date.setUTCHours(hh, mm, ss, fff);
        // apply offset
        date.setTime(+date + offset);
    } else {
        date.setFullYear(YYYY, MM, DD);
        date.setHours(hh, mm, ss, fff);
    }
    return date;
};
/**
 * Converts a date to a UTCTime value.
 *
 * Note: GeneralizedTime has 4 digits for the year and is used for X.509
 * dates past 2049. Converting to a GeneralizedTime hasn't been
 * implemented yet.
 *
 * @param date the date to convert.
 *
 * @return the UTCTime value.
 */ $984af8c9ec0fa78a$var$asn1.dateToUtcTime = function(date) {
    // TODO: validate; currently assumes proper format
    if (typeof date === "string") return date;
    var rval = "";
    // create format YYMMDDhhmmssZ
    var format = [];
    format.push(("" + date.getUTCFullYear()).substr(2));
    format.push("" + (date.getUTCMonth() + 1));
    format.push("" + date.getUTCDate());
    format.push("" + date.getUTCHours());
    format.push("" + date.getUTCMinutes());
    format.push("" + date.getUTCSeconds());
    // ensure 2 digits are used for each format entry
    for(var i = 0; i < format.length; ++i){
        if (format[i].length < 2) rval += "0";
        rval += format[i];
    }
    rval += "Z";
    return rval;
};
/**
 * Converts a date to a GeneralizedTime value.
 *
 * @param date the date to convert.
 *
 * @return the GeneralizedTime value as a string.
 */ $984af8c9ec0fa78a$var$asn1.dateToGeneralizedTime = function(date) {
    // TODO: validate; currently assumes proper format
    if (typeof date === "string") return date;
    var rval = "";
    // create format YYYYMMDDHHMMSSZ
    var format = [];
    format.push("" + date.getUTCFullYear());
    format.push("" + (date.getUTCMonth() + 1));
    format.push("" + date.getUTCDate());
    format.push("" + date.getUTCHours());
    format.push("" + date.getUTCMinutes());
    format.push("" + date.getUTCSeconds());
    // ensure 2 digits are used for each format entry
    for(var i = 0; i < format.length; ++i){
        if (format[i].length < 2) rval += "0";
        rval += format[i];
    }
    rval += "Z";
    return rval;
};
/**
 * Converts a javascript integer to a DER-encoded byte buffer to be used
 * as the value for an INTEGER type.
 *
 * @param x the integer.
 *
 * @return the byte buffer.
 */ $984af8c9ec0fa78a$var$asn1.integerToDer = function(x) {
    var rval = $fz7FM.util.createBuffer();
    if (x >= -128 && x < 0x80) return rval.putSignedInt(x, 8);
    if (x >= -32768 && x < 0x8000) return rval.putSignedInt(x, 16);
    if (x >= -8388608 && x < 0x800000) return rval.putSignedInt(x, 24);
    if (x >= -2147483648 && x < 0x80000000) return rval.putSignedInt(x, 32);
    var error = new Error("Integer too large; max is 32-bits.");
    error.integer = x;
    throw error;
};
/**
 * Converts a DER-encoded byte buffer to a javascript integer. This is
 * typically used to decode the value of an INTEGER type.
 *
 * @param bytes the byte buffer.
 *
 * @return the integer.
 */ $984af8c9ec0fa78a$var$asn1.derToInteger = function(bytes) {
    // wrap in buffer if needed
    if (typeof bytes === "string") bytes = $fz7FM.util.createBuffer(bytes);
    var n = bytes.length() * 8;
    if (n > 32) throw new Error("Integer too large; max is 32-bits.");
    return bytes.getSignedInt(n);
};
/**
 * Validates that the given ASN.1 object is at least a super set of the
 * given ASN.1 structure. Only tag classes and types are checked. An
 * optional map may also be provided to capture ASN.1 values while the
 * structure is checked.
 *
 * To capture an ASN.1 value, set an object in the validator's 'capture'
 * parameter to the key to use in the capture map. To capture the full
 * ASN.1 object, specify 'captureAsn1'. To capture BIT STRING bytes, including
 * the leading unused bits counter byte, specify 'captureBitStringContents'.
 * To capture BIT STRING bytes, without the leading unused bits counter byte,
 * specify 'captureBitStringValue'.
 *
 * Objects in the validator may set a field 'optional' to true to indicate
 * that it isn't necessary to pass validation.
 *
 * @param obj the ASN.1 object to validate.
 * @param v the ASN.1 structure validator.
 * @param capture an optional map to capture values in.
 * @param errors an optional array for storing validation errors.
 *
 * @return true on success, false on failure.
 */ $984af8c9ec0fa78a$var$asn1.validate = function(obj, v, capture, errors) {
    var rval = false;
    // ensure tag class and type are the same if specified
    if ((obj.tagClass === v.tagClass || typeof v.tagClass === "undefined") && (obj.type === v.type || typeof v.type === "undefined")) {
        // ensure constructed flag is the same if specified
        if (obj.constructed === v.constructed || typeof v.constructed === "undefined") {
            rval = true;
            // handle sub values
            if (v.value && $fz7FM.util.isArray(v.value)) {
                var j = 0;
                for(var i = 0; rval && i < v.value.length; ++i){
                    rval = v.value[i].optional || false;
                    if (obj.value[j]) {
                        rval = $984af8c9ec0fa78a$var$asn1.validate(obj.value[j], v.value[i], capture, errors);
                        if (rval) ++j;
                        else if (v.value[i].optional) rval = true;
                    }
                    if (!rval && errors) errors.push("[" + v.name + "] " + 'Tag class "' + v.tagClass + '", type "' + v.type + '" expected value length "' + v.value.length + '", got "' + obj.value.length + '"');
                }
            }
            if (rval && capture) {
                if (v.capture) capture[v.capture] = obj.value;
                if (v.captureAsn1) capture[v.captureAsn1] = obj;
                if (v.captureBitStringContents && "bitStringContents" in obj) capture[v.captureBitStringContents] = obj.bitStringContents;
                if (v.captureBitStringValue && "bitStringContents" in obj) {
                    var value;
                    if (obj.bitStringContents.length < 2) capture[v.captureBitStringValue] = "";
                    else {
                        // FIXME: support unused bits with data shifting
                        var unused = obj.bitStringContents.charCodeAt(0);
                        if (unused !== 0) throw new Error("captureBitStringValue only supported for zero unused bits");
                        capture[v.captureBitStringValue] = obj.bitStringContents.slice(1);
                    }
                }
            }
        } else if (errors) errors.push("[" + v.name + "] " + 'Expected constructed "' + v.constructed + '", got "' + obj.constructed + '"');
    } else if (errors) {
        if (obj.tagClass !== v.tagClass) errors.push("[" + v.name + "] " + 'Expected tag class "' + v.tagClass + '", got "' + obj.tagClass + '"');
        if (obj.type !== v.type) errors.push("[" + v.name + "] " + 'Expected type "' + v.type + '", got "' + obj.type + '"');
    }
    return rval;
};
// regex for testing for non-latin characters
var $984af8c9ec0fa78a$var$_nonLatinRegex = /[^\\u0000-\\u00ff]/;
/**
 * Pretty prints an ASN.1 object to a string.
 *
 * @param obj the object to write out.
 * @param level the level in the tree.
 * @param indentation the indentation to use.
 *
 * @return the string.
 */ $984af8c9ec0fa78a$var$asn1.prettyPrint = function(obj, level, indentation) {
    var rval = "";
    // set default level and indentation
    level = level || 0;
    indentation = indentation || 2;
    // start new line for deep levels
    if (level > 0) rval += "\n";
    // create indent
    var indent = "";
    for(var i = 0; i < level * indentation; ++i)indent += " ";
    // print class:type
    rval += indent + "Tag: ";
    switch(obj.tagClass){
        case $984af8c9ec0fa78a$var$asn1.Class.UNIVERSAL:
            rval += "Universal:";
            break;
        case $984af8c9ec0fa78a$var$asn1.Class.APPLICATION:
            rval += "Application:";
            break;
        case $984af8c9ec0fa78a$var$asn1.Class.CONTEXT_SPECIFIC:
            rval += "Context-Specific:";
            break;
        case $984af8c9ec0fa78a$var$asn1.Class.PRIVATE:
            rval += "Private:";
            break;
    }
    if (obj.tagClass === $984af8c9ec0fa78a$var$asn1.Class.UNIVERSAL) {
        rval += obj.type;
        // known types
        switch(obj.type){
            case $984af8c9ec0fa78a$var$asn1.Type.NONE:
                rval += " (None)";
                break;
            case $984af8c9ec0fa78a$var$asn1.Type.BOOLEAN:
                rval += " (Boolean)";
                break;
            case $984af8c9ec0fa78a$var$asn1.Type.INTEGER:
                rval += " (Integer)";
                break;
            case $984af8c9ec0fa78a$var$asn1.Type.BITSTRING:
                rval += " (Bit string)";
                break;
            case $984af8c9ec0fa78a$var$asn1.Type.OCTETSTRING:
                rval += " (Octet string)";
                break;
            case $984af8c9ec0fa78a$var$asn1.Type.NULL:
                rval += " (Null)";
                break;
            case $984af8c9ec0fa78a$var$asn1.Type.OID:
                rval += " (Object Identifier)";
                break;
            case $984af8c9ec0fa78a$var$asn1.Type.ODESC:
                rval += " (Object Descriptor)";
                break;
            case $984af8c9ec0fa78a$var$asn1.Type.EXTERNAL:
                rval += " (External or Instance of)";
                break;
            case $984af8c9ec0fa78a$var$asn1.Type.REAL:
                rval += " (Real)";
                break;
            case $984af8c9ec0fa78a$var$asn1.Type.ENUMERATED:
                rval += " (Enumerated)";
                break;
            case $984af8c9ec0fa78a$var$asn1.Type.EMBEDDED:
                rval += " (Embedded PDV)";
                break;
            case $984af8c9ec0fa78a$var$asn1.Type.UTF8:
                rval += " (UTF8)";
                break;
            case $984af8c9ec0fa78a$var$asn1.Type.ROID:
                rval += " (Relative Object Identifier)";
                break;
            case $984af8c9ec0fa78a$var$asn1.Type.SEQUENCE:
                rval += " (Sequence)";
                break;
            case $984af8c9ec0fa78a$var$asn1.Type.SET:
                rval += " (Set)";
                break;
            case $984af8c9ec0fa78a$var$asn1.Type.PRINTABLESTRING:
                rval += " (Printable String)";
                break;
            case $984af8c9ec0fa78a$var$asn1.Type.IA5String:
                rval += " (IA5String (ASCII))";
                break;
            case $984af8c9ec0fa78a$var$asn1.Type.UTCTIME:
                rval += " (UTC time)";
                break;
            case $984af8c9ec0fa78a$var$asn1.Type.GENERALIZEDTIME:
                rval += " (Generalized time)";
                break;
            case $984af8c9ec0fa78a$var$asn1.Type.BMPSTRING:
                rval += " (BMP String)";
                break;
        }
    } else rval += obj.type;
    rval += "\n";
    rval += indent + "Constructed: " + obj.constructed + "\n";
    if (obj.composed) {
        var subvalues = 0;
        var sub = "";
        for(var i = 0; i < obj.value.length; ++i)if (obj.value[i] !== undefined) {
            subvalues += 1;
            sub += $984af8c9ec0fa78a$var$asn1.prettyPrint(obj.value[i], level + 1, indentation);
            if (i + 1 < obj.value.length) sub += ",";
        }
        rval += indent + "Sub values: " + subvalues + sub;
    } else {
        rval += indent + "Value: ";
        if (obj.type === $984af8c9ec0fa78a$var$asn1.Type.OID) {
            var oid = $984af8c9ec0fa78a$var$asn1.derToOid(obj.value);
            rval += oid;
            if ($fz7FM.pki && $fz7FM.pki.oids) {
                if (oid in $fz7FM.pki.oids) rval += " (" + $fz7FM.pki.oids[oid] + ") ";
            }
        }
        if (obj.type === $984af8c9ec0fa78a$var$asn1.Type.INTEGER) try {
            rval += $984af8c9ec0fa78a$var$asn1.derToInteger(obj.value);
        } catch (ex) {
            rval += "0x" + $fz7FM.util.bytesToHex(obj.value);
        }
        else if (obj.type === $984af8c9ec0fa78a$var$asn1.Type.BITSTRING) {
            // TODO: shift bits as needed to display without padding
            if (obj.value.length > 1) // remove unused bits field
            rval += "0x" + $fz7FM.util.bytesToHex(obj.value.slice(1));
            else rval += "(none)";
            // show unused bit count
            if (obj.value.length > 0) {
                var unused = obj.value.charCodeAt(0);
                if (unused == 1) rval += " (1 unused bit shown)";
                else if (unused > 1) rval += " (" + unused + " unused bits shown)";
            }
        } else if (obj.type === $984af8c9ec0fa78a$var$asn1.Type.OCTETSTRING) {
            if (!$984af8c9ec0fa78a$var$_nonLatinRegex.test(obj.value)) rval += "(" + obj.value + ") ";
            rval += "0x" + $fz7FM.util.bytesToHex(obj.value);
        } else if (obj.type === $984af8c9ec0fa78a$var$asn1.Type.UTF8) try {
            rval += $fz7FM.util.decodeUtf8(obj.value);
        } catch (e) {
            if (e.message === "URI malformed") rval += "0x" + $fz7FM.util.bytesToHex(obj.value) + " (malformed UTF8)";
            else throw e;
        }
        else if (obj.type === $984af8c9ec0fa78a$var$asn1.Type.PRINTABLESTRING || obj.type === $984af8c9ec0fa78a$var$asn1.Type.IA5String) rval += obj.value;
        else if ($984af8c9ec0fa78a$var$_nonLatinRegex.test(obj.value)) rval += "0x" + $fz7FM.util.bytesToHex(obj.value);
        else if (obj.value.length === 0) rval += "[null]";
        else rval += obj.value;
    }
    return rval;
};

});
parcelRegister("dm89c", function(module, exports) {
/**
 * Object IDs for ASN.1.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2013 Digital Bazaar, Inc.
 */ 
var $fz7FM = parcelRequire("fz7FM");
$fz7FM.pki = $fz7FM.pki || {};
var $9b93a65bec9dc6fe$var$oids = module.exports = $fz7FM.pki.oids = $fz7FM.oids = $fz7FM.oids || {};
// set id to name mapping and name to id mapping
function $9b93a65bec9dc6fe$var$_IN(id, name) {
    $9b93a65bec9dc6fe$var$oids[id] = name;
    $9b93a65bec9dc6fe$var$oids[name] = id;
}
// set id to name mapping only
function $9b93a65bec9dc6fe$var$_I_(id, name) {
    $9b93a65bec9dc6fe$var$oids[id] = name;
}
// algorithm OIDs
$9b93a65bec9dc6fe$var$_IN("1.2.840.113549.1.1.1", "rsaEncryption");
// Note: md2 & md4 not implemented
//_IN('1.2.840.113549.1.1.2', 'md2WithRSAEncryption');
//_IN('1.2.840.113549.1.1.3', 'md4WithRSAEncryption');
$9b93a65bec9dc6fe$var$_IN("1.2.840.113549.1.1.4", "md5WithRSAEncryption");
$9b93a65bec9dc6fe$var$_IN("1.2.840.113549.1.1.5", "sha1WithRSAEncryption");
$9b93a65bec9dc6fe$var$_IN("1.2.840.113549.1.1.7", "RSAES-OAEP");
$9b93a65bec9dc6fe$var$_IN("1.2.840.113549.1.1.8", "mgf1");
$9b93a65bec9dc6fe$var$_IN("1.2.840.113549.1.1.9", "pSpecified");
$9b93a65bec9dc6fe$var$_IN("1.2.840.113549.1.1.10", "RSASSA-PSS");
$9b93a65bec9dc6fe$var$_IN("1.2.840.113549.1.1.11", "sha256WithRSAEncryption");
$9b93a65bec9dc6fe$var$_IN("1.2.840.113549.1.1.12", "sha384WithRSAEncryption");
$9b93a65bec9dc6fe$var$_IN("1.2.840.113549.1.1.13", "sha512WithRSAEncryption");
// Edwards-curve Digital Signature Algorithm (EdDSA) Ed25519
$9b93a65bec9dc6fe$var$_IN("1.3.101.112", "EdDSA25519");
$9b93a65bec9dc6fe$var$_IN("1.2.840.10040.4.3", "dsa-with-sha1");
$9b93a65bec9dc6fe$var$_IN("1.3.14.3.2.7", "desCBC");
$9b93a65bec9dc6fe$var$_IN("1.3.14.3.2.26", "sha1");
// Deprecated equivalent of sha1WithRSAEncryption
$9b93a65bec9dc6fe$var$_IN("1.3.14.3.2.29", "sha1WithRSASignature");
$9b93a65bec9dc6fe$var$_IN("2.16.840.1.101.3.4.2.1", "sha256");
$9b93a65bec9dc6fe$var$_IN("2.16.840.1.101.3.4.2.2", "sha384");
$9b93a65bec9dc6fe$var$_IN("2.16.840.1.101.3.4.2.3", "sha512");
$9b93a65bec9dc6fe$var$_IN("2.16.840.1.101.3.4.2.4", "sha224");
$9b93a65bec9dc6fe$var$_IN("2.16.840.1.101.3.4.2.5", "sha512-224");
$9b93a65bec9dc6fe$var$_IN("2.16.840.1.101.3.4.2.6", "sha512-256");
$9b93a65bec9dc6fe$var$_IN("1.2.840.113549.2.2", "md2");
$9b93a65bec9dc6fe$var$_IN("1.2.840.113549.2.5", "md5");
// pkcs#7 content types
$9b93a65bec9dc6fe$var$_IN("1.2.840.113549.1.7.1", "data");
$9b93a65bec9dc6fe$var$_IN("1.2.840.113549.1.7.2", "signedData");
$9b93a65bec9dc6fe$var$_IN("1.2.840.113549.1.7.3", "envelopedData");
$9b93a65bec9dc6fe$var$_IN("1.2.840.113549.1.7.4", "signedAndEnvelopedData");
$9b93a65bec9dc6fe$var$_IN("1.2.840.113549.1.7.5", "digestedData");
$9b93a65bec9dc6fe$var$_IN("1.2.840.113549.1.7.6", "encryptedData");
// pkcs#9 oids
$9b93a65bec9dc6fe$var$_IN("1.2.840.113549.1.9.1", "emailAddress");
$9b93a65bec9dc6fe$var$_IN("1.2.840.113549.1.9.2", "unstructuredName");
$9b93a65bec9dc6fe$var$_IN("1.2.840.113549.1.9.3", "contentType");
$9b93a65bec9dc6fe$var$_IN("1.2.840.113549.1.9.4", "messageDigest");
$9b93a65bec9dc6fe$var$_IN("1.2.840.113549.1.9.5", "signingTime");
$9b93a65bec9dc6fe$var$_IN("1.2.840.113549.1.9.6", "counterSignature");
$9b93a65bec9dc6fe$var$_IN("1.2.840.113549.1.9.7", "challengePassword");
$9b93a65bec9dc6fe$var$_IN("1.2.840.113549.1.9.8", "unstructuredAddress");
$9b93a65bec9dc6fe$var$_IN("1.2.840.113549.1.9.14", "extensionRequest");
$9b93a65bec9dc6fe$var$_IN("1.2.840.113549.1.9.20", "friendlyName");
$9b93a65bec9dc6fe$var$_IN("1.2.840.113549.1.9.21", "localKeyId");
$9b93a65bec9dc6fe$var$_IN("1.2.840.113549.1.9.22.1", "x509Certificate");
// pkcs#12 safe bags
$9b93a65bec9dc6fe$var$_IN("1.2.840.113549.1.12.10.1.1", "keyBag");
$9b93a65bec9dc6fe$var$_IN("1.2.840.113549.1.12.10.1.2", "pkcs8ShroudedKeyBag");
$9b93a65bec9dc6fe$var$_IN("1.2.840.113549.1.12.10.1.3", "certBag");
$9b93a65bec9dc6fe$var$_IN("1.2.840.113549.1.12.10.1.4", "crlBag");
$9b93a65bec9dc6fe$var$_IN("1.2.840.113549.1.12.10.1.5", "secretBag");
$9b93a65bec9dc6fe$var$_IN("1.2.840.113549.1.12.10.1.6", "safeContentsBag");
// password-based-encryption for pkcs#12
$9b93a65bec9dc6fe$var$_IN("1.2.840.113549.1.5.13", "pkcs5PBES2");
$9b93a65bec9dc6fe$var$_IN("1.2.840.113549.1.5.12", "pkcs5PBKDF2");
$9b93a65bec9dc6fe$var$_IN("1.2.840.113549.1.12.1.1", "pbeWithSHAAnd128BitRC4");
$9b93a65bec9dc6fe$var$_IN("1.2.840.113549.1.12.1.2", "pbeWithSHAAnd40BitRC4");
$9b93a65bec9dc6fe$var$_IN("1.2.840.113549.1.12.1.3", "pbeWithSHAAnd3-KeyTripleDES-CBC");
$9b93a65bec9dc6fe$var$_IN("1.2.840.113549.1.12.1.4", "pbeWithSHAAnd2-KeyTripleDES-CBC");
$9b93a65bec9dc6fe$var$_IN("1.2.840.113549.1.12.1.5", "pbeWithSHAAnd128BitRC2-CBC");
$9b93a65bec9dc6fe$var$_IN("1.2.840.113549.1.12.1.6", "pbewithSHAAnd40BitRC2-CBC");
// hmac OIDs
$9b93a65bec9dc6fe$var$_IN("1.2.840.113549.2.7", "hmacWithSHA1");
$9b93a65bec9dc6fe$var$_IN("1.2.840.113549.2.8", "hmacWithSHA224");
$9b93a65bec9dc6fe$var$_IN("1.2.840.113549.2.9", "hmacWithSHA256");
$9b93a65bec9dc6fe$var$_IN("1.2.840.113549.2.10", "hmacWithSHA384");
$9b93a65bec9dc6fe$var$_IN("1.2.840.113549.2.11", "hmacWithSHA512");
// symmetric key algorithm oids
$9b93a65bec9dc6fe$var$_IN("1.2.840.113549.3.7", "des-EDE3-CBC");
$9b93a65bec9dc6fe$var$_IN("2.16.840.1.101.3.4.1.2", "aes128-CBC");
$9b93a65bec9dc6fe$var$_IN("2.16.840.1.101.3.4.1.22", "aes192-CBC");
$9b93a65bec9dc6fe$var$_IN("2.16.840.1.101.3.4.1.42", "aes256-CBC");
// certificate issuer/subject OIDs
$9b93a65bec9dc6fe$var$_IN("2.5.4.3", "commonName");
$9b93a65bec9dc6fe$var$_IN("2.5.4.4", "surname");
$9b93a65bec9dc6fe$var$_IN("2.5.4.5", "serialNumber");
$9b93a65bec9dc6fe$var$_IN("2.5.4.6", "countryName");
$9b93a65bec9dc6fe$var$_IN("2.5.4.7", "localityName");
$9b93a65bec9dc6fe$var$_IN("2.5.4.8", "stateOrProvinceName");
$9b93a65bec9dc6fe$var$_IN("2.5.4.9", "streetAddress");
$9b93a65bec9dc6fe$var$_IN("2.5.4.10", "organizationName");
$9b93a65bec9dc6fe$var$_IN("2.5.4.11", "organizationalUnitName");
$9b93a65bec9dc6fe$var$_IN("2.5.4.12", "title");
$9b93a65bec9dc6fe$var$_IN("2.5.4.13", "description");
$9b93a65bec9dc6fe$var$_IN("2.5.4.15", "businessCategory");
$9b93a65bec9dc6fe$var$_IN("2.5.4.17", "postalCode");
$9b93a65bec9dc6fe$var$_IN("2.5.4.42", "givenName");
$9b93a65bec9dc6fe$var$_IN("1.3.6.1.4.1.311.60.2.1.2", "jurisdictionOfIncorporationStateOrProvinceName");
$9b93a65bec9dc6fe$var$_IN("1.3.6.1.4.1.311.60.2.1.3", "jurisdictionOfIncorporationCountryName");
// X.509 extension OIDs
$9b93a65bec9dc6fe$var$_IN("2.16.840.1.113730.1.1", "nsCertType");
$9b93a65bec9dc6fe$var$_IN("2.16.840.1.113730.1.13", "nsComment"); // deprecated in theory; still widely used
$9b93a65bec9dc6fe$var$_I_("2.5.29.1", "authorityKeyIdentifier"); // deprecated, use .35
$9b93a65bec9dc6fe$var$_I_("2.5.29.2", "keyAttributes"); // obsolete use .37 or .15
$9b93a65bec9dc6fe$var$_I_("2.5.29.3", "certificatePolicies"); // deprecated, use .32
$9b93a65bec9dc6fe$var$_I_("2.5.29.4", "keyUsageRestriction"); // obsolete use .37 or .15
$9b93a65bec9dc6fe$var$_I_("2.5.29.5", "policyMapping"); // deprecated use .33
$9b93a65bec9dc6fe$var$_I_("2.5.29.6", "subtreesConstraint"); // obsolete use .30
$9b93a65bec9dc6fe$var$_I_("2.5.29.7", "subjectAltName"); // deprecated use .17
$9b93a65bec9dc6fe$var$_I_("2.5.29.8", "issuerAltName"); // deprecated use .18
$9b93a65bec9dc6fe$var$_I_("2.5.29.9", "subjectDirectoryAttributes");
$9b93a65bec9dc6fe$var$_I_("2.5.29.10", "basicConstraints"); // deprecated use .19
$9b93a65bec9dc6fe$var$_I_("2.5.29.11", "nameConstraints"); // deprecated use .30
$9b93a65bec9dc6fe$var$_I_("2.5.29.12", "policyConstraints"); // deprecated use .36
$9b93a65bec9dc6fe$var$_I_("2.5.29.13", "basicConstraints"); // deprecated use .19
$9b93a65bec9dc6fe$var$_IN("2.5.29.14", "subjectKeyIdentifier");
$9b93a65bec9dc6fe$var$_IN("2.5.29.15", "keyUsage");
$9b93a65bec9dc6fe$var$_I_("2.5.29.16", "privateKeyUsagePeriod");
$9b93a65bec9dc6fe$var$_IN("2.5.29.17", "subjectAltName");
$9b93a65bec9dc6fe$var$_IN("2.5.29.18", "issuerAltName");
$9b93a65bec9dc6fe$var$_IN("2.5.29.19", "basicConstraints");
$9b93a65bec9dc6fe$var$_I_("2.5.29.20", "cRLNumber");
$9b93a65bec9dc6fe$var$_I_("2.5.29.21", "cRLReason");
$9b93a65bec9dc6fe$var$_I_("2.5.29.22", "expirationDate");
$9b93a65bec9dc6fe$var$_I_("2.5.29.23", "instructionCode");
$9b93a65bec9dc6fe$var$_I_("2.5.29.24", "invalidityDate");
$9b93a65bec9dc6fe$var$_I_("2.5.29.25", "cRLDistributionPoints"); // deprecated use .31
$9b93a65bec9dc6fe$var$_I_("2.5.29.26", "issuingDistributionPoint"); // deprecated use .28
$9b93a65bec9dc6fe$var$_I_("2.5.29.27", "deltaCRLIndicator");
$9b93a65bec9dc6fe$var$_I_("2.5.29.28", "issuingDistributionPoint");
$9b93a65bec9dc6fe$var$_I_("2.5.29.29", "certificateIssuer");
$9b93a65bec9dc6fe$var$_I_("2.5.29.30", "nameConstraints");
$9b93a65bec9dc6fe$var$_IN("2.5.29.31", "cRLDistributionPoints");
$9b93a65bec9dc6fe$var$_IN("2.5.29.32", "certificatePolicies");
$9b93a65bec9dc6fe$var$_I_("2.5.29.33", "policyMappings");
$9b93a65bec9dc6fe$var$_I_("2.5.29.34", "policyConstraints"); // deprecated use .36
$9b93a65bec9dc6fe$var$_IN("2.5.29.35", "authorityKeyIdentifier");
$9b93a65bec9dc6fe$var$_I_("2.5.29.36", "policyConstraints");
$9b93a65bec9dc6fe$var$_IN("2.5.29.37", "extKeyUsage");
$9b93a65bec9dc6fe$var$_I_("2.5.29.46", "freshestCRL");
$9b93a65bec9dc6fe$var$_I_("2.5.29.54", "inhibitAnyPolicy");
// extKeyUsage purposes
$9b93a65bec9dc6fe$var$_IN("1.3.6.1.4.1.11129.2.4.2", "timestampList");
$9b93a65bec9dc6fe$var$_IN("1.3.6.1.5.5.7.1.1", "authorityInfoAccess");
$9b93a65bec9dc6fe$var$_IN("1.3.6.1.5.5.7.3.1", "serverAuth");
$9b93a65bec9dc6fe$var$_IN("1.3.6.1.5.5.7.3.2", "clientAuth");
$9b93a65bec9dc6fe$var$_IN("1.3.6.1.5.5.7.3.3", "codeSigning");
$9b93a65bec9dc6fe$var$_IN("1.3.6.1.5.5.7.3.4", "emailProtection");
$9b93a65bec9dc6fe$var$_IN("1.3.6.1.5.5.7.3.8", "timeStamping");

});


parcelRegister("9YZGj", function(module, exports) {
/**
 * Hash-based Message Authentication Code implementation. Requires a message
 * digest object that can be obtained, for example, from forge.md.sha1 or
 * forge.md.md5.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2012 Digital Bazaar, Inc. All rights reserved.
 */ 
var $fz7FM = parcelRequire("fz7FM");
parcelRequire("6NNT4");
parcelRequire("gao36");
/* HMAC API */ var $74499050f6390a4f$var$hmac = module.exports = $fz7FM.hmac = $fz7FM.hmac || {};
/**
 * Creates an HMAC object that uses the given message digest object.
 *
 * @return an HMAC object.
 */ $74499050f6390a4f$var$hmac.create = function() {
    // the hmac key to use
    var _key = null;
    // the message digest to use
    var _md = null;
    // the inner padding
    var _ipadding = null;
    // the outer padding
    var _opadding = null;
    // hmac context
    var ctx = {};
    /**
   * Starts or restarts the HMAC with the given key and message digest.
   *
   * @param md the message digest to use, null to reuse the previous one,
   *           a string to use builtin 'sha1', 'md5', 'sha256'.
   * @param key the key to use as a string, array of bytes, byte buffer,
   *           or null to reuse the previous key.
   */ ctx.start = function(md, key) {
        if (md !== null) {
            if (typeof md === "string") {
                // create builtin message digest
                md = md.toLowerCase();
                if (md in $fz7FM.md.algorithms) _md = $fz7FM.md.algorithms[md].create();
                else throw new Error('Unknown hash algorithm "' + md + '"');
            } else // store message digest
            _md = md;
        }
        if (key === null) // reuse previous key
        key = _key;
        else {
            if (typeof key === "string") // convert string into byte buffer
            key = $fz7FM.util.createBuffer(key);
            else if ($fz7FM.util.isArray(key)) {
                // convert byte array into byte buffer
                var tmp = key;
                key = $fz7FM.util.createBuffer();
                for(var i = 0; i < tmp.length; ++i)key.putByte(tmp[i]);
            }
            // if key is longer than blocksize, hash it
            var keylen = key.length();
            if (keylen > _md.blockLength) {
                _md.start();
                _md.update(key.bytes());
                key = _md.digest();
            }
            // mix key into inner and outer padding
            // ipadding = [0x36 * blocksize] ^ key
            // opadding = [0x5C * blocksize] ^ key
            _ipadding = $fz7FM.util.createBuffer();
            _opadding = $fz7FM.util.createBuffer();
            keylen = key.length();
            for(var i = 0; i < keylen; ++i){
                var tmp = key.at(i);
                _ipadding.putByte(0x36 ^ tmp);
                _opadding.putByte(0x5C ^ tmp);
            }
            // if key is shorter than blocksize, add additional padding
            if (keylen < _md.blockLength) {
                var tmp = _md.blockLength - keylen;
                for(var i = 0; i < tmp; ++i){
                    _ipadding.putByte(0x36);
                    _opadding.putByte(0x5C);
                }
            }
            _key = key;
            _ipadding = _ipadding.bytes();
            _opadding = _opadding.bytes();
        }
        // digest is done like so: hash(opadding | hash(ipadding | message))
        // prepare to do inner hash
        // hash(ipadding | message)
        _md.start();
        _md.update(_ipadding);
    };
    /**
   * Updates the HMAC with the given message bytes.
   *
   * @param bytes the bytes to update with.
   */ ctx.update = function(bytes) {
        _md.update(bytes);
    };
    /**
   * Produces the Message Authentication Code (MAC).
   *
   * @return a byte buffer containing the digest value.
   */ ctx.getMac = function() {
        // digest is done like so: hash(opadding | hash(ipadding | message))
        // here we do the outer hashing
        var inner = _md.digest().bytes();
        _md.start();
        _md.update(_opadding);
        _md.update(inner);
        return _md.digest();
    };
    // alias for getMac
    ctx.digest = ctx.getMac;
    return ctx;
};

});
parcelRegister("6NNT4", function(module, exports) {
/**
 * Node.js module for Forge message digests.
 *
 * @author Dave Longley
 *
 * Copyright 2011-2017 Digital Bazaar, Inc.
 */ 
var $fz7FM = parcelRequire("fz7FM");
module.exports = $fz7FM.md = $fz7FM.md || {};
$fz7FM.md.algorithms = $fz7FM.md.algorithms || {};

});


parcelRegister("bPSAM", function(module, exports) {
/**
 * Message Digest Algorithm 5 with 128-bit digest (MD5) implementation.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2014 Digital Bazaar, Inc.
 */ 
var $fz7FM = parcelRequire("fz7FM");
parcelRequire("6NNT4");
parcelRequire("gao36");
var $89decdfe6fa3d2de$var$md5 = module.exports = $fz7FM.md5 = $fz7FM.md5 || {};
$fz7FM.md.md5 = $fz7FM.md.algorithms.md5 = $89decdfe6fa3d2de$var$md5;
/**
 * Creates an MD5 message digest object.
 *
 * @return a message digest object.
 */ $89decdfe6fa3d2de$var$md5.create = function() {
    // do initialization as necessary
    if (!$89decdfe6fa3d2de$var$_initialized) $89decdfe6fa3d2de$var$_init();
    // MD5 state contains four 32-bit integers
    var _state = null;
    // input buffer
    var _input = $fz7FM.util.createBuffer();
    // used for word storage
    var _w = new Array(16);
    // message digest object
    var md = {
        algorithm: "md5",
        blockLength: 64,
        digestLength: 16,
        // 56-bit length of message so far (does not including padding)
        messageLength: 0,
        // true message length
        fullMessageLength: null,
        // size of message length in bytes
        messageLengthSize: 8
    };
    /**
   * Starts the digest.
   *
   * @return this digest object.
   */ md.start = function() {
        // up to 56-bit message length for convenience
        md.messageLength = 0;
        // full message length (set md.messageLength64 for backwards-compatibility)
        md.fullMessageLength = md.messageLength64 = [];
        var int32s = md.messageLengthSize / 4;
        for(var i = 0; i < int32s; ++i)md.fullMessageLength.push(0);
        _input = $fz7FM.util.createBuffer();
        _state = {
            h0: 0x67452301,
            h1: 0xEFCDAB89,
            h2: 0x98BADCFE,
            h3: 0x10325476
        };
        return md;
    };
    // start digest automatically for first time
    md.start();
    /**
   * Updates the digest with the given message input. The given input can
   * treated as raw input (no encoding will be applied) or an encoding of
   * 'utf8' maybe given to encode the input using UTF-8.
   *
   * @param msg the message input to update with.
   * @param encoding the encoding to use (default: 'raw', other: 'utf8').
   *
   * @return this digest object.
   */ md.update = function(msg, encoding) {
        if (encoding === "utf8") msg = $fz7FM.util.encodeUtf8(msg);
        // update message length
        var len = msg.length;
        md.messageLength += len;
        len = [
            len / 0x100000000 >>> 0,
            len >>> 0
        ];
        for(var i = md.fullMessageLength.length - 1; i >= 0; --i){
            md.fullMessageLength[i] += len[1];
            len[1] = len[0] + (md.fullMessageLength[i] / 0x100000000 >>> 0);
            md.fullMessageLength[i] = md.fullMessageLength[i] >>> 0;
            len[0] = len[1] / 0x100000000 >>> 0;
        }
        // add bytes to input buffer
        _input.putBytes(msg);
        // process bytes
        $89decdfe6fa3d2de$var$_update(_state, _w, _input);
        // compact input buffer every 2K or if empty
        if (_input.read > 2048 || _input.length() === 0) _input.compact();
        return md;
    };
    /**
   * Produces the digest.
   *
   * @return a byte buffer containing the digest value.
   */ md.digest = function() {
        /* Note: Here we copy the remaining bytes in the input buffer and
    add the appropriate MD5 padding. Then we do the final update
    on a copy of the state so that if the user wants to get
    intermediate digests they can do so. */ /* Determine the number of bytes that must be added to the message
    to ensure its length is congruent to 448 mod 512. In other words,
    the data to be digested must be a multiple of 512 bits (or 128 bytes).
    This data includes the message, some padding, and the length of the
    message. Since the length of the message will be encoded as 8 bytes (64
    bits), that means that the last segment of the data must have 56 bytes
    (448 bits) of message and padding. Therefore, the length of the message
    plus the padding must be congruent to 448 mod 512 because
    512 - 128 = 448.

    In order to fill up the message length it must be filled with
    padding that begins with 1 bit followed by all 0 bits. Padding
    must *always* be present, so if the message length is already
    congruent to 448 mod 512, then 512 padding bits must be added. */ var finalBlock = $fz7FM.util.createBuffer();
        finalBlock.putBytes(_input.bytes());
        // compute remaining size to be digested (include message length size)
        var remaining = md.fullMessageLength[md.fullMessageLength.length - 1] + md.messageLengthSize;
        // add padding for overflow blockSize - overflow
        // _padding starts with 1 byte with first bit is set (byte value 128), then
        // there may be up to (blockSize - 1) other pad bytes
        var overflow = remaining & md.blockLength - 1;
        finalBlock.putBytes($89decdfe6fa3d2de$var$_padding.substr(0, md.blockLength - overflow));
        // serialize message length in bits in little-endian order; since length
        // is stored in bytes we multiply by 8 and add carry
        var bits, carry = 0;
        for(var i = md.fullMessageLength.length - 1; i >= 0; --i){
            bits = md.fullMessageLength[i] * 8 + carry;
            carry = bits / 0x100000000 >>> 0;
            finalBlock.putInt32Le(bits >>> 0);
        }
        var s2 = {
            h0: _state.h0,
            h1: _state.h1,
            h2: _state.h2,
            h3: _state.h3
        };
        $89decdfe6fa3d2de$var$_update(s2, _w, finalBlock);
        var rval = $fz7FM.util.createBuffer();
        rval.putInt32Le(s2.h0);
        rval.putInt32Le(s2.h1);
        rval.putInt32Le(s2.h2);
        rval.putInt32Le(s2.h3);
        return rval;
    };
    return md;
};
// padding, constant tables for calculating md5
var $89decdfe6fa3d2de$var$_padding = null;
var $89decdfe6fa3d2de$var$_g = null;
var $89decdfe6fa3d2de$var$_r = null;
var $89decdfe6fa3d2de$var$_k = null;
var $89decdfe6fa3d2de$var$_initialized = false;
/**
 * Initializes the constant tables.
 */ function $89decdfe6fa3d2de$var$_init() {
    // create padding
    $89decdfe6fa3d2de$var$_padding = String.fromCharCode(128);
    $89decdfe6fa3d2de$var$_padding += $fz7FM.util.fillString(String.fromCharCode(0x00), 64);
    // g values
    $89decdfe6fa3d2de$var$_g = [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        1,
        6,
        11,
        0,
        5,
        10,
        15,
        4,
        9,
        14,
        3,
        8,
        13,
        2,
        7,
        12,
        5,
        8,
        11,
        14,
        1,
        4,
        7,
        10,
        13,
        0,
        3,
        6,
        9,
        12,
        15,
        2,
        0,
        7,
        14,
        5,
        12,
        3,
        10,
        1,
        8,
        15,
        6,
        13,
        4,
        11,
        2,
        9
    ];
    // rounds table
    $89decdfe6fa3d2de$var$_r = [
        7,
        12,
        17,
        22,
        7,
        12,
        17,
        22,
        7,
        12,
        17,
        22,
        7,
        12,
        17,
        22,
        5,
        9,
        14,
        20,
        5,
        9,
        14,
        20,
        5,
        9,
        14,
        20,
        5,
        9,
        14,
        20,
        4,
        11,
        16,
        23,
        4,
        11,
        16,
        23,
        4,
        11,
        16,
        23,
        4,
        11,
        16,
        23,
        6,
        10,
        15,
        21,
        6,
        10,
        15,
        21,
        6,
        10,
        15,
        21,
        6,
        10,
        15,
        21
    ];
    // get the result of abs(sin(i + 1)) as a 32-bit integer
    $89decdfe6fa3d2de$var$_k = new Array(64);
    for(var i = 0; i < 64; ++i)$89decdfe6fa3d2de$var$_k[i] = Math.floor(Math.abs(Math.sin(i + 1)) * 0x100000000);
    // now initialized
    $89decdfe6fa3d2de$var$_initialized = true;
}
/**
 * Updates an MD5 state with the given byte buffer.
 *
 * @param s the MD5 state to update.
 * @param w the array to use to store words.
 * @param bytes the byte buffer to update with.
 */ function $89decdfe6fa3d2de$var$_update(s, w, bytes) {
    // consume 512 bit (64 byte) chunks
    var t, a, b, c, d, f, r, i;
    var len = bytes.length();
    while(len >= 64){
        // initialize hash value for this chunk
        a = s.h0;
        b = s.h1;
        c = s.h2;
        d = s.h3;
        // round 1
        for(i = 0; i < 16; ++i){
            w[i] = bytes.getInt32Le();
            f = d ^ b & (c ^ d);
            t = a + f + $89decdfe6fa3d2de$var$_k[i] + w[i];
            r = $89decdfe6fa3d2de$var$_r[i];
            a = d;
            d = c;
            c = b;
            b += t << r | t >>> 32 - r;
        }
        // round 2
        for(; i < 32; ++i){
            f = c ^ d & (b ^ c);
            t = a + f + $89decdfe6fa3d2de$var$_k[i] + w[$89decdfe6fa3d2de$var$_g[i]];
            r = $89decdfe6fa3d2de$var$_r[i];
            a = d;
            d = c;
            c = b;
            b += t << r | t >>> 32 - r;
        }
        // round 3
        for(; i < 48; ++i){
            f = b ^ c ^ d;
            t = a + f + $89decdfe6fa3d2de$var$_k[i] + w[$89decdfe6fa3d2de$var$_g[i]];
            r = $89decdfe6fa3d2de$var$_r[i];
            a = d;
            d = c;
            c = b;
            b += t << r | t >>> 32 - r;
        }
        // round 4
        for(; i < 64; ++i){
            f = c ^ (b | ~d);
            t = a + f + $89decdfe6fa3d2de$var$_k[i] + w[$89decdfe6fa3d2de$var$_g[i]];
            r = $89decdfe6fa3d2de$var$_r[i];
            a = d;
            d = c;
            c = b;
            b += t << r | t >>> 32 - r;
        }
        // update hash state
        s.h0 = s.h0 + a | 0;
        s.h1 = s.h1 + b | 0;
        s.h2 = s.h2 + c | 0;
        s.h3 = s.h3 + d | 0;
        len -= 64;
    }
}

});

parcelRegister("8061v", function(module, exports) {
/**
 * Javascript implementation of basic PEM (Privacy Enhanced Mail) algorithms.
 *
 * See: RFC 1421.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2013-2014 Digital Bazaar, Inc.
 *
 * A Forge PEM object has the following fields:
 *
 * type: identifies the type of message (eg: "RSA PRIVATE KEY").
 *
 * procType: identifies the type of processing performed on the message,
 *   it has two subfields: version and type, eg: 4,ENCRYPTED.
 *
 * contentDomain: identifies the type of content in the message, typically
 *   only uses the value: "RFC822".
 *
 * dekInfo: identifies the message encryption algorithm and mode and includes
 *   any parameters for the algorithm, it has two subfields: algorithm and
 *   parameters, eg: DES-CBC,F8143EDE5960C597.
 *
 * headers: contains all other PEM encapsulated headers -- where order is
 *   significant (for pairing data like recipient ID + key info).
 *
 * body: the binary-encoded body.
 */ 
var $fz7FM = parcelRequire("fz7FM");
parcelRequire("gao36");
// shortcut for pem API
var $5d32fee697438bc2$var$pem = module.exports = $fz7FM.pem = $fz7FM.pem || {};
/**
 * Encodes (serializes) the given PEM object.
 *
 * @param msg the PEM message object to encode.
 * @param options the options to use:
 *          maxline the maximum characters per line for the body, (default: 64).
 *
 * @return the PEM-formatted string.
 */ $5d32fee697438bc2$var$pem.encode = function(msg, options) {
    options = options || {};
    var rval = "-----BEGIN " + msg.type + "-----\r\n";
    // encode special headers
    var header;
    if (msg.procType) {
        header = {
            name: "Proc-Type",
            values: [
                String(msg.procType.version),
                msg.procType.type
            ]
        };
        rval += $5d32fee697438bc2$var$foldHeader(header);
    }
    if (msg.contentDomain) {
        header = {
            name: "Content-Domain",
            values: [
                msg.contentDomain
            ]
        };
        rval += $5d32fee697438bc2$var$foldHeader(header);
    }
    if (msg.dekInfo) {
        header = {
            name: "DEK-Info",
            values: [
                msg.dekInfo.algorithm
            ]
        };
        if (msg.dekInfo.parameters) header.values.push(msg.dekInfo.parameters);
        rval += $5d32fee697438bc2$var$foldHeader(header);
    }
    if (msg.headers) // encode all other headers
    for(var i = 0; i < msg.headers.length; ++i)rval += $5d32fee697438bc2$var$foldHeader(msg.headers[i]);
    // terminate header
    if (msg.procType) rval += "\r\n";
    // add body
    rval += $fz7FM.util.encode64(msg.body, options.maxline || 64) + "\r\n";
    rval += "-----END " + msg.type + "-----\r\n";
    return rval;
};
/**
 * Decodes (deserializes) all PEM messages found in the given string.
 *
 * @param str the PEM-formatted string to decode.
 *
 * @return the PEM message objects in an array.
 */ $5d32fee697438bc2$var$pem.decode = function(str) {
    var rval = [];
    // split string into PEM messages (be lenient w/EOF on BEGIN line)
    var rMessage = /\s*-----BEGIN ([A-Z0-9- ]+)-----\r?\n?([\x21-\x7e\s]+?(?:\r?\n\r?\n))?([:A-Za-z0-9+\/=\s]+?)-----END \1-----/g;
    var rHeader = /([\x21-\x7e]+):\s*([\x21-\x7e\s^:]+)/;
    var rCRLF = /\r?\n/;
    var match;
    while(true){
        match = rMessage.exec(str);
        if (!match) break;
        // accept "NEW CERTIFICATE REQUEST" as "CERTIFICATE REQUEST"
        // https://datatracker.ietf.org/doc/html/rfc7468#section-7
        var type = match[1];
        if (type === "NEW CERTIFICATE REQUEST") type = "CERTIFICATE REQUEST";
        var msg = {
            type: type,
            procType: null,
            contentDomain: null,
            dekInfo: null,
            headers: [],
            body: $fz7FM.util.decode64(match[3])
        };
        rval.push(msg);
        // no headers
        if (!match[2]) continue;
        // parse headers
        var lines = match[2].split(rCRLF);
        var li = 0;
        while(match && li < lines.length){
            // get line, trim any rhs whitespace
            var line = lines[li].replace(/\s+$/, "");
            // RFC2822 unfold any following folded lines
            for(var nl = li + 1; nl < lines.length; ++nl){
                var next = lines[nl];
                if (!/\s/.test(next[0])) break;
                line += next;
                li = nl;
            }
            // parse header
            match = line.match(rHeader);
            if (match) {
                var header = {
                    name: match[1],
                    values: []
                };
                var values = match[2].split(",");
                for(var vi = 0; vi < values.length; ++vi)header.values.push($5d32fee697438bc2$var$ltrim(values[vi]));
                // Proc-Type must be the first header
                if (!msg.procType) {
                    if (header.name !== "Proc-Type") throw new Error('Invalid PEM formatted message. The first encapsulated header must be "Proc-Type".');
                    else if (header.values.length !== 2) throw new Error('Invalid PEM formatted message. The "Proc-Type" header must have two subfields.');
                    msg.procType = {
                        version: values[0],
                        type: values[1]
                    };
                } else if (!msg.contentDomain && header.name === "Content-Domain") // special-case Content-Domain
                msg.contentDomain = values[0] || "";
                else if (!msg.dekInfo && header.name === "DEK-Info") {
                    // special-case DEK-Info
                    if (header.values.length === 0) throw new Error('Invalid PEM formatted message. The "DEK-Info" header must have at least one subfield.');
                    msg.dekInfo = {
                        algorithm: values[0],
                        parameters: values[1] || null
                    };
                } else msg.headers.push(header);
            }
            ++li;
        }
        if (msg.procType === "ENCRYPTED" && !msg.dekInfo) throw new Error('Invalid PEM formatted message. The "DEK-Info" header must be present if "Proc-Type" is "ENCRYPTED".');
    }
    if (rval.length === 0) throw new Error("Invalid PEM formatted message.");
    return rval;
};
function $5d32fee697438bc2$var$foldHeader(header) {
    var rval = header.name + ": ";
    // ensure values with CRLF are folded
    var values = [];
    var insertSpace = function insertSpace(match, $1) {
        return " " + $1;
    };
    for(var i = 0; i < header.values.length; ++i)values.push(header.values[i].replace(/^(\S+\r\n)/, insertSpace));
    rval += values.join(",") + "\r\n";
    // do folding
    var length = 0;
    var candidate = -1;
    for(var i = 0; i < rval.length; ++i, ++length){
        if (length > 65 && candidate !== -1) {
            var insert = rval[candidate];
            if (insert === ",") {
                ++candidate;
                rval = rval.substr(0, candidate) + "\r\n " + rval.substr(candidate);
            } else rval = rval.substr(0, candidate) + "\r\n" + insert + rval.substr(candidate + 1);
            length = i - candidate - 1;
            candidate = -1;
            ++i;
        } else if (rval[i] === " " || rval[i] === "	" || rval[i] === ",") candidate = i;
    }
    return rval;
}
function $5d32fee697438bc2$var$ltrim(str) {
    return str.replace(/^\s+/, "");
}

});

parcelRegister("c6KQm", function(module, exports) {
/**
 * Javascript implementation of a basic Public Key Infrastructure, including
 * support for RSA public and private keys.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2013 Digital Bazaar, Inc.
 */ 
var $fz7FM = parcelRequire("fz7FM");
parcelRequire("d4EnE");
parcelRequire("dm89c");
parcelRequire("58Y8U");
parcelRequire("8061v");
parcelRequire("jkn5W");
parcelRequire("fv3Sg");
parcelRequire("1VUmF");
parcelRequire("eRNaT");
parcelRequire("gao36");
parcelRequire("3c4BG");
// shortcut for asn.1 API
var $8d0a61b6acd70574$var$asn1 = $fz7FM.asn1;
/* Public Key Infrastructure (PKI) implementation. */ var $8d0a61b6acd70574$var$pki = module.exports = $fz7FM.pki = $fz7FM.pki || {};
/**
 * NOTE: THIS METHOD IS DEPRECATED. Use pem.decode() instead.
 *
 * Converts PEM-formatted data to DER.
 *
 * @param pem the PEM-formatted data.
 *
 * @return the DER-formatted data.
 */ $8d0a61b6acd70574$var$pki.pemToDer = function(pem) {
    var msg = $fz7FM.pem.decode(pem)[0];
    if (msg.procType && msg.procType.type === "ENCRYPTED") throw new Error("Could not convert PEM to DER; PEM is encrypted.");
    return $fz7FM.util.createBuffer(msg.body);
};
/**
 * Converts an RSA private key from PEM format.
 *
 * @param pem the PEM-formatted private key.
 *
 * @return the private key.
 */ $8d0a61b6acd70574$var$pki.privateKeyFromPem = function(pem) {
    var msg = $fz7FM.pem.decode(pem)[0];
    if (msg.type !== "PRIVATE KEY" && msg.type !== "RSA PRIVATE KEY") {
        var error = new Error('Could not convert private key from PEM; PEM header type is not "PRIVATE KEY" or "RSA PRIVATE KEY".');
        error.headerType = msg.type;
        throw error;
    }
    if (msg.procType && msg.procType.type === "ENCRYPTED") throw new Error("Could not convert private key from PEM; PEM is encrypted.");
    // convert DER to ASN.1 object
    var obj = $8d0a61b6acd70574$var$asn1.fromDer(msg.body);
    return $8d0a61b6acd70574$var$pki.privateKeyFromAsn1(obj);
};
/**
 * Converts an RSA private key to PEM format.
 *
 * @param key the private key.
 * @param maxline the maximum characters per line, defaults to 64.
 *
 * @return the PEM-formatted private key.
 */ $8d0a61b6acd70574$var$pki.privateKeyToPem = function(key, maxline) {
    // convert to ASN.1, then DER, then PEM-encode
    var msg = {
        type: "RSA PRIVATE KEY",
        body: $8d0a61b6acd70574$var$asn1.toDer($8d0a61b6acd70574$var$pki.privateKeyToAsn1(key)).getBytes()
    };
    return $fz7FM.pem.encode(msg, {
        maxline: maxline
    });
};
/**
 * Converts a PrivateKeyInfo to PEM format.
 *
 * @param pki the PrivateKeyInfo.
 * @param maxline the maximum characters per line, defaults to 64.
 *
 * @return the PEM-formatted private key.
 */ $8d0a61b6acd70574$var$pki.privateKeyInfoToPem = function(pki, maxline) {
    // convert to DER, then PEM-encode
    var msg = {
        type: "PRIVATE KEY",
        body: $8d0a61b6acd70574$var$asn1.toDer(pki).getBytes()
    };
    return $fz7FM.pem.encode(msg, {
        maxline: maxline
    });
};

});
parcelRegister("58Y8U", function(module, exports) {
/**
 * Password-based encryption functions.
 *
 * @author Dave Longley
 * @author Stefan Siegl <stesie@brokenpipe.de>
 *
 * Copyright (c) 2010-2013 Digital Bazaar, Inc.
 * Copyright (c) 2012 Stefan Siegl <stesie@brokenpipe.de>
 *
 * An EncryptedPrivateKeyInfo:
 *
 * EncryptedPrivateKeyInfo ::= SEQUENCE {
 *   encryptionAlgorithm  EncryptionAlgorithmIdentifier,
 *   encryptedData        EncryptedData }
 *
 * EncryptionAlgorithmIdentifier ::= AlgorithmIdentifier
 *
 * EncryptedData ::= OCTET STRING
 */ 
var $fz7FM = parcelRequire("fz7FM");
parcelRequire("60qK1");
parcelRequire("d4EnE");
parcelRequire("bhqHY");
parcelRequire("6NNT4");
parcelRequire("dm89c");
parcelRequire("jkn5W");
parcelRequire("8061v");
parcelRequire("a65r1");
parcelRequire("3231S");
parcelRequire("eRNaT");
parcelRequire("gao36");
if (typeof $3bec5a2dafafc956$var$BigInteger === "undefined") var $3bec5a2dafafc956$var$BigInteger = $fz7FM.jsbn.BigInteger;
// shortcut for asn.1 API
var $3bec5a2dafafc956$var$asn1 = $fz7FM.asn1;
/* Password-based encryption implementation. */ var $3bec5a2dafafc956$var$pki = $fz7FM.pki = $fz7FM.pki || {};
module.exports = $3bec5a2dafafc956$var$pki.pbe = $fz7FM.pbe = $fz7FM.pbe || {};
var $3bec5a2dafafc956$var$oids = $3bec5a2dafafc956$var$pki.oids;
// validator for an EncryptedPrivateKeyInfo structure
// Note: Currently only works w/algorithm params
var $3bec5a2dafafc956$var$encryptedPrivateKeyValidator = {
    name: "EncryptedPrivateKeyInfo",
    tagClass: $3bec5a2dafafc956$var$asn1.Class.UNIVERSAL,
    type: $3bec5a2dafafc956$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: "EncryptedPrivateKeyInfo.encryptionAlgorithm",
            tagClass: $3bec5a2dafafc956$var$asn1.Class.UNIVERSAL,
            type: $3bec5a2dafafc956$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    name: "AlgorithmIdentifier.algorithm",
                    tagClass: $3bec5a2dafafc956$var$asn1.Class.UNIVERSAL,
                    type: $3bec5a2dafafc956$var$asn1.Type.OID,
                    constructed: false,
                    capture: "encryptionOid"
                },
                {
                    name: "AlgorithmIdentifier.parameters",
                    tagClass: $3bec5a2dafafc956$var$asn1.Class.UNIVERSAL,
                    type: $3bec5a2dafafc956$var$asn1.Type.SEQUENCE,
                    constructed: true,
                    captureAsn1: "encryptionParams"
                }
            ]
        },
        {
            // encryptedData
            name: "EncryptedPrivateKeyInfo.encryptedData",
            tagClass: $3bec5a2dafafc956$var$asn1.Class.UNIVERSAL,
            type: $3bec5a2dafafc956$var$asn1.Type.OCTETSTRING,
            constructed: false,
            capture: "encryptedData"
        }
    ]
};
// validator for a PBES2Algorithms structure
// Note: Currently only works w/PBKDF2 + AES encryption schemes
var $3bec5a2dafafc956$var$PBES2AlgorithmsValidator = {
    name: "PBES2Algorithms",
    tagClass: $3bec5a2dafafc956$var$asn1.Class.UNIVERSAL,
    type: $3bec5a2dafafc956$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: "PBES2Algorithms.keyDerivationFunc",
            tagClass: $3bec5a2dafafc956$var$asn1.Class.UNIVERSAL,
            type: $3bec5a2dafafc956$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    name: "PBES2Algorithms.keyDerivationFunc.oid",
                    tagClass: $3bec5a2dafafc956$var$asn1.Class.UNIVERSAL,
                    type: $3bec5a2dafafc956$var$asn1.Type.OID,
                    constructed: false,
                    capture: "kdfOid"
                },
                {
                    name: "PBES2Algorithms.params",
                    tagClass: $3bec5a2dafafc956$var$asn1.Class.UNIVERSAL,
                    type: $3bec5a2dafafc956$var$asn1.Type.SEQUENCE,
                    constructed: true,
                    value: [
                        {
                            name: "PBES2Algorithms.params.salt",
                            tagClass: $3bec5a2dafafc956$var$asn1.Class.UNIVERSAL,
                            type: $3bec5a2dafafc956$var$asn1.Type.OCTETSTRING,
                            constructed: false,
                            capture: "kdfSalt"
                        },
                        {
                            name: "PBES2Algorithms.params.iterationCount",
                            tagClass: $3bec5a2dafafc956$var$asn1.Class.UNIVERSAL,
                            type: $3bec5a2dafafc956$var$asn1.Type.INTEGER,
                            constructed: false,
                            capture: "kdfIterationCount"
                        },
                        {
                            name: "PBES2Algorithms.params.keyLength",
                            tagClass: $3bec5a2dafafc956$var$asn1.Class.UNIVERSAL,
                            type: $3bec5a2dafafc956$var$asn1.Type.INTEGER,
                            constructed: false,
                            optional: true,
                            capture: "keyLength"
                        },
                        {
                            // prf
                            name: "PBES2Algorithms.params.prf",
                            tagClass: $3bec5a2dafafc956$var$asn1.Class.UNIVERSAL,
                            type: $3bec5a2dafafc956$var$asn1.Type.SEQUENCE,
                            constructed: true,
                            optional: true,
                            value: [
                                {
                                    name: "PBES2Algorithms.params.prf.algorithm",
                                    tagClass: $3bec5a2dafafc956$var$asn1.Class.UNIVERSAL,
                                    type: $3bec5a2dafafc956$var$asn1.Type.OID,
                                    constructed: false,
                                    capture: "prfOid"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            name: "PBES2Algorithms.encryptionScheme",
            tagClass: $3bec5a2dafafc956$var$asn1.Class.UNIVERSAL,
            type: $3bec5a2dafafc956$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    name: "PBES2Algorithms.encryptionScheme.oid",
                    tagClass: $3bec5a2dafafc956$var$asn1.Class.UNIVERSAL,
                    type: $3bec5a2dafafc956$var$asn1.Type.OID,
                    constructed: false,
                    capture: "encOid"
                },
                {
                    name: "PBES2Algorithms.encryptionScheme.iv",
                    tagClass: $3bec5a2dafafc956$var$asn1.Class.UNIVERSAL,
                    type: $3bec5a2dafafc956$var$asn1.Type.OCTETSTRING,
                    constructed: false,
                    capture: "encIv"
                }
            ]
        }
    ]
};
var $3bec5a2dafafc956$var$pkcs12PbeParamsValidator = {
    name: "pkcs-12PbeParams",
    tagClass: $3bec5a2dafafc956$var$asn1.Class.UNIVERSAL,
    type: $3bec5a2dafafc956$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: "pkcs-12PbeParams.salt",
            tagClass: $3bec5a2dafafc956$var$asn1.Class.UNIVERSAL,
            type: $3bec5a2dafafc956$var$asn1.Type.OCTETSTRING,
            constructed: false,
            capture: "salt"
        },
        {
            name: "pkcs-12PbeParams.iterations",
            tagClass: $3bec5a2dafafc956$var$asn1.Class.UNIVERSAL,
            type: $3bec5a2dafafc956$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "iterations"
        }
    ]
};
/**
 * Encrypts a ASN.1 PrivateKeyInfo object, producing an EncryptedPrivateKeyInfo.
 *
 * PBES2Algorithms ALGORITHM-IDENTIFIER ::=
 *   { {PBES2-params IDENTIFIED BY id-PBES2}, ...}
 *
 * id-PBES2 OBJECT IDENTIFIER ::= {pkcs-5 13}
 *
 * PBES2-params ::= SEQUENCE {
 *   keyDerivationFunc AlgorithmIdentifier {{PBES2-KDFs}},
 *   encryptionScheme AlgorithmIdentifier {{PBES2-Encs}}
 * }
 *
 * PBES2-KDFs ALGORITHM-IDENTIFIER ::=
 *   { {PBKDF2-params IDENTIFIED BY id-PBKDF2}, ... }
 *
 * PBES2-Encs ALGORITHM-IDENTIFIER ::= { ... }
 *
 * PBKDF2-params ::= SEQUENCE {
 *   salt CHOICE {
 *     specified OCTET STRING,
 *     otherSource AlgorithmIdentifier {{PBKDF2-SaltSources}}
 *   },
 *   iterationCount INTEGER (1..MAX),
 *   keyLength INTEGER (1..MAX) OPTIONAL,
 *   prf AlgorithmIdentifier {{PBKDF2-PRFs}} DEFAULT algid-hmacWithSHA1
 * }
 *
 * @param obj the ASN.1 PrivateKeyInfo object.
 * @param password the password to encrypt with.
 * @param options:
 *          algorithm the encryption algorithm to use
 *            ('aes128', 'aes192', 'aes256', '3des'), defaults to 'aes128'.
 *          count the iteration count to use.
 *          saltSize the salt size to use.
 *          prfAlgorithm the PRF message digest algorithm to use
 *            ('sha1', 'sha224', 'sha256', 'sha384', 'sha512')
 *
 * @return the ASN.1 EncryptedPrivateKeyInfo.
 */ $3bec5a2dafafc956$var$pki.encryptPrivateKeyInfo = function(obj, password, options) {
    // set default options
    options = options || {};
    options.saltSize = options.saltSize || 8;
    options.count = options.count || 2048;
    options.algorithm = options.algorithm || "aes128";
    options.prfAlgorithm = options.prfAlgorithm || "sha1";
    // generate PBE params
    var salt = $fz7FM.random.getBytesSync(options.saltSize);
    var count = options.count;
    var countBytes = $3bec5a2dafafc956$var$asn1.integerToDer(count);
    var dkLen;
    var encryptionAlgorithm;
    var encryptedData;
    if (options.algorithm.indexOf("aes") === 0 || options.algorithm === "des") {
        // do PBES2
        var ivLen, encOid, cipherFn;
        switch(options.algorithm){
            case "aes128":
                dkLen = 16;
                ivLen = 16;
                encOid = $3bec5a2dafafc956$var$oids["aes128-CBC"];
                cipherFn = $fz7FM.aes.createEncryptionCipher;
                break;
            case "aes192":
                dkLen = 24;
                ivLen = 16;
                encOid = $3bec5a2dafafc956$var$oids["aes192-CBC"];
                cipherFn = $fz7FM.aes.createEncryptionCipher;
                break;
            case "aes256":
                dkLen = 32;
                ivLen = 16;
                encOid = $3bec5a2dafafc956$var$oids["aes256-CBC"];
                cipherFn = $fz7FM.aes.createEncryptionCipher;
                break;
            case "des":
                dkLen = 8;
                ivLen = 8;
                encOid = $3bec5a2dafafc956$var$oids["desCBC"];
                cipherFn = $fz7FM.des.createEncryptionCipher;
                break;
            default:
                var error = new Error("Cannot encrypt private key. Unknown encryption algorithm.");
                error.algorithm = options.algorithm;
                throw error;
        }
        // get PRF message digest
        var prfAlgorithm = "hmacWith" + options.prfAlgorithm.toUpperCase();
        var md = $3bec5a2dafafc956$var$prfAlgorithmToMessageDigest(prfAlgorithm);
        // encrypt private key using pbe SHA-1 and AES/DES
        var dk = $fz7FM.pkcs5.pbkdf2(password, salt, count, dkLen, md);
        var iv = $fz7FM.random.getBytesSync(ivLen);
        var cipher = cipherFn(dk);
        cipher.start(iv);
        cipher.update($3bec5a2dafafc956$var$asn1.toDer(obj));
        cipher.finish();
        encryptedData = cipher.output.getBytes();
        // get PBKDF2-params
        var params = $3bec5a2dafafc956$var$createPbkdf2Params(salt, countBytes, dkLen, prfAlgorithm);
        encryptionAlgorithm = $3bec5a2dafafc956$var$asn1.create($3bec5a2dafafc956$var$asn1.Class.UNIVERSAL, $3bec5a2dafafc956$var$asn1.Type.SEQUENCE, true, [
            $3bec5a2dafafc956$var$asn1.create($3bec5a2dafafc956$var$asn1.Class.UNIVERSAL, $3bec5a2dafafc956$var$asn1.Type.OID, false, $3bec5a2dafafc956$var$asn1.oidToDer($3bec5a2dafafc956$var$oids["pkcs5PBES2"]).getBytes()),
            $3bec5a2dafafc956$var$asn1.create($3bec5a2dafafc956$var$asn1.Class.UNIVERSAL, $3bec5a2dafafc956$var$asn1.Type.SEQUENCE, true, [
                // keyDerivationFunc
                $3bec5a2dafafc956$var$asn1.create($3bec5a2dafafc956$var$asn1.Class.UNIVERSAL, $3bec5a2dafafc956$var$asn1.Type.SEQUENCE, true, [
                    $3bec5a2dafafc956$var$asn1.create($3bec5a2dafafc956$var$asn1.Class.UNIVERSAL, $3bec5a2dafafc956$var$asn1.Type.OID, false, $3bec5a2dafafc956$var$asn1.oidToDer($3bec5a2dafafc956$var$oids["pkcs5PBKDF2"]).getBytes()),
                    // PBKDF2-params
                    params
                ]),
                // encryptionScheme
                $3bec5a2dafafc956$var$asn1.create($3bec5a2dafafc956$var$asn1.Class.UNIVERSAL, $3bec5a2dafafc956$var$asn1.Type.SEQUENCE, true, [
                    $3bec5a2dafafc956$var$asn1.create($3bec5a2dafafc956$var$asn1.Class.UNIVERSAL, $3bec5a2dafafc956$var$asn1.Type.OID, false, $3bec5a2dafafc956$var$asn1.oidToDer(encOid).getBytes()),
                    // iv
                    $3bec5a2dafafc956$var$asn1.create($3bec5a2dafafc956$var$asn1.Class.UNIVERSAL, $3bec5a2dafafc956$var$asn1.Type.OCTETSTRING, false, iv)
                ])
            ])
        ]);
    } else if (options.algorithm === "3des") {
        // Do PKCS12 PBE
        dkLen = 24;
        var saltBytes = new $fz7FM.util.ByteBuffer(salt);
        var dk = $3bec5a2dafafc956$var$pki.pbe.generatePkcs12Key(password, saltBytes, 1, count, dkLen);
        var iv = $3bec5a2dafafc956$var$pki.pbe.generatePkcs12Key(password, saltBytes, 2, count, dkLen);
        var cipher = $fz7FM.des.createEncryptionCipher(dk);
        cipher.start(iv);
        cipher.update($3bec5a2dafafc956$var$asn1.toDer(obj));
        cipher.finish();
        encryptedData = cipher.output.getBytes();
        encryptionAlgorithm = $3bec5a2dafafc956$var$asn1.create($3bec5a2dafafc956$var$asn1.Class.UNIVERSAL, $3bec5a2dafafc956$var$asn1.Type.SEQUENCE, true, [
            $3bec5a2dafafc956$var$asn1.create($3bec5a2dafafc956$var$asn1.Class.UNIVERSAL, $3bec5a2dafafc956$var$asn1.Type.OID, false, $3bec5a2dafafc956$var$asn1.oidToDer($3bec5a2dafafc956$var$oids["pbeWithSHAAnd3-KeyTripleDES-CBC"]).getBytes()),
            // pkcs-12PbeParams
            $3bec5a2dafafc956$var$asn1.create($3bec5a2dafafc956$var$asn1.Class.UNIVERSAL, $3bec5a2dafafc956$var$asn1.Type.SEQUENCE, true, [
                // salt
                $3bec5a2dafafc956$var$asn1.create($3bec5a2dafafc956$var$asn1.Class.UNIVERSAL, $3bec5a2dafafc956$var$asn1.Type.OCTETSTRING, false, salt),
                // iteration count
                $3bec5a2dafafc956$var$asn1.create($3bec5a2dafafc956$var$asn1.Class.UNIVERSAL, $3bec5a2dafafc956$var$asn1.Type.INTEGER, false, countBytes.getBytes())
            ])
        ]);
    } else {
        var error = new Error("Cannot encrypt private key. Unknown encryption algorithm.");
        error.algorithm = options.algorithm;
        throw error;
    }
    // EncryptedPrivateKeyInfo
    var rval = $3bec5a2dafafc956$var$asn1.create($3bec5a2dafafc956$var$asn1.Class.UNIVERSAL, $3bec5a2dafafc956$var$asn1.Type.SEQUENCE, true, [
        // encryptionAlgorithm
        encryptionAlgorithm,
        // encryptedData
        $3bec5a2dafafc956$var$asn1.create($3bec5a2dafafc956$var$asn1.Class.UNIVERSAL, $3bec5a2dafafc956$var$asn1.Type.OCTETSTRING, false, encryptedData)
    ]);
    return rval;
};
/**
 * Decrypts a ASN.1 PrivateKeyInfo object.
 *
 * @param obj the ASN.1 EncryptedPrivateKeyInfo object.
 * @param password the password to decrypt with.
 *
 * @return the ASN.1 PrivateKeyInfo on success, null on failure.
 */ $3bec5a2dafafc956$var$pki.decryptPrivateKeyInfo = function(obj, password) {
    var rval = null;
    // get PBE params
    var capture = {};
    var errors = [];
    if (!$3bec5a2dafafc956$var$asn1.validate(obj, $3bec5a2dafafc956$var$encryptedPrivateKeyValidator, capture, errors)) {
        var error = new Error("Cannot read encrypted private key. ASN.1 object is not a supported EncryptedPrivateKeyInfo.");
        error.errors = errors;
        throw error;
    }
    // get cipher
    var oid = $3bec5a2dafafc956$var$asn1.derToOid(capture.encryptionOid);
    var cipher = $3bec5a2dafafc956$var$pki.pbe.getCipher(oid, capture.encryptionParams, password);
    // get encrypted data
    var encrypted = $fz7FM.util.createBuffer(capture.encryptedData);
    cipher.update(encrypted);
    if (cipher.finish()) rval = $3bec5a2dafafc956$var$asn1.fromDer(cipher.output);
    return rval;
};
/**
 * Converts a EncryptedPrivateKeyInfo to PEM format.
 *
 * @param epki the EncryptedPrivateKeyInfo.
 * @param maxline the maximum characters per line, defaults to 64.
 *
 * @return the PEM-formatted encrypted private key.
 */ $3bec5a2dafafc956$var$pki.encryptedPrivateKeyToPem = function(epki, maxline) {
    // convert to DER, then PEM-encode
    var msg = {
        type: "ENCRYPTED PRIVATE KEY",
        body: $3bec5a2dafafc956$var$asn1.toDer(epki).getBytes()
    };
    return $fz7FM.pem.encode(msg, {
        maxline: maxline
    });
};
/**
 * Converts a PEM-encoded EncryptedPrivateKeyInfo to ASN.1 format. Decryption
 * is not performed.
 *
 * @param pem the EncryptedPrivateKeyInfo in PEM-format.
 *
 * @return the ASN.1 EncryptedPrivateKeyInfo.
 */ $3bec5a2dafafc956$var$pki.encryptedPrivateKeyFromPem = function(pem) {
    var msg = $fz7FM.pem.decode(pem)[0];
    if (msg.type !== "ENCRYPTED PRIVATE KEY") {
        var error = new Error('Could not convert encrypted private key from PEM; PEM header type is "ENCRYPTED PRIVATE KEY".');
        error.headerType = msg.type;
        throw error;
    }
    if (msg.procType && msg.procType.type === "ENCRYPTED") throw new Error("Could not convert encrypted private key from PEM; PEM is encrypted.");
    // convert DER to ASN.1 object
    return $3bec5a2dafafc956$var$asn1.fromDer(msg.body);
};
/**
 * Encrypts an RSA private key. By default, the key will be wrapped in
 * a PrivateKeyInfo and encrypted to produce a PKCS#8 EncryptedPrivateKeyInfo.
 * This is the standard, preferred way to encrypt a private key.
 *
 * To produce a non-standard PEM-encrypted private key that uses encapsulated
 * headers to indicate the encryption algorithm (old-style non-PKCS#8 OpenSSL
 * private key encryption), set the 'legacy' option to true. Note: Using this
 * option will cause the iteration count to be forced to 1.
 *
 * Note: The 'des' algorithm is supported, but it is not considered to be
 * secure because it only uses a single 56-bit key. If possible, it is highly
 * recommended that a different algorithm be used.
 *
 * @param rsaKey the RSA key to encrypt.
 * @param password the password to use.
 * @param options:
 *          algorithm: the encryption algorithm to use
 *            ('aes128', 'aes192', 'aes256', '3des', 'des').
 *          count: the iteration count to use.
 *          saltSize: the salt size to use.
 *          legacy: output an old non-PKCS#8 PEM-encrypted+encapsulated
 *            headers (DEK-Info) private key.
 *
 * @return the PEM-encoded ASN.1 EncryptedPrivateKeyInfo.
 */ $3bec5a2dafafc956$var$pki.encryptRsaPrivateKey = function(rsaKey, password, options) {
    // standard PKCS#8
    options = options || {};
    if (!options.legacy) {
        // encrypt PrivateKeyInfo
        var rval = $3bec5a2dafafc956$var$pki.wrapRsaPrivateKey($3bec5a2dafafc956$var$pki.privateKeyToAsn1(rsaKey));
        rval = $3bec5a2dafafc956$var$pki.encryptPrivateKeyInfo(rval, password, options);
        return $3bec5a2dafafc956$var$pki.encryptedPrivateKeyToPem(rval);
    }
    // legacy non-PKCS#8
    var algorithm;
    var iv;
    var dkLen;
    var cipherFn;
    switch(options.algorithm){
        case "aes128":
            algorithm = "AES-128-CBC";
            dkLen = 16;
            iv = $fz7FM.random.getBytesSync(16);
            cipherFn = $fz7FM.aes.createEncryptionCipher;
            break;
        case "aes192":
            algorithm = "AES-192-CBC";
            dkLen = 24;
            iv = $fz7FM.random.getBytesSync(16);
            cipherFn = $fz7FM.aes.createEncryptionCipher;
            break;
        case "aes256":
            algorithm = "AES-256-CBC";
            dkLen = 32;
            iv = $fz7FM.random.getBytesSync(16);
            cipherFn = $fz7FM.aes.createEncryptionCipher;
            break;
        case "3des":
            algorithm = "DES-EDE3-CBC";
            dkLen = 24;
            iv = $fz7FM.random.getBytesSync(8);
            cipherFn = $fz7FM.des.createEncryptionCipher;
            break;
        case "des":
            algorithm = "DES-CBC";
            dkLen = 8;
            iv = $fz7FM.random.getBytesSync(8);
            cipherFn = $fz7FM.des.createEncryptionCipher;
            break;
        default:
            var error = new Error('Could not encrypt RSA private key; unsupported encryption algorithm "' + options.algorithm + '".');
            error.algorithm = options.algorithm;
            throw error;
    }
    // encrypt private key using OpenSSL legacy key derivation
    var dk = $fz7FM.pbe.opensslDeriveBytes(password, iv.substr(0, 8), dkLen);
    var cipher = cipherFn(dk);
    cipher.start(iv);
    cipher.update($3bec5a2dafafc956$var$asn1.toDer($3bec5a2dafafc956$var$pki.privateKeyToAsn1(rsaKey)));
    cipher.finish();
    var msg = {
        type: "RSA PRIVATE KEY",
        procType: {
            version: "4",
            type: "ENCRYPTED"
        },
        dekInfo: {
            algorithm: algorithm,
            parameters: $fz7FM.util.bytesToHex(iv).toUpperCase()
        },
        body: cipher.output.getBytes()
    };
    return $fz7FM.pem.encode(msg);
};
/**
 * Decrypts an RSA private key.
 *
 * @param pem the PEM-formatted EncryptedPrivateKeyInfo to decrypt.
 * @param password the password to use.
 *
 * @return the RSA key on success, null on failure.
 */ $3bec5a2dafafc956$var$pki.decryptRsaPrivateKey = function(pem, password) {
    var rval = null;
    var msg = $fz7FM.pem.decode(pem)[0];
    if (msg.type !== "ENCRYPTED PRIVATE KEY" && msg.type !== "PRIVATE KEY" && msg.type !== "RSA PRIVATE KEY") {
        var error = new Error('Could not convert private key from PEM; PEM header type is not "ENCRYPTED PRIVATE KEY", "PRIVATE KEY", or "RSA PRIVATE KEY".');
        error.headerType = error;
        throw error;
    }
    if (msg.procType && msg.procType.type === "ENCRYPTED") {
        var dkLen;
        var cipherFn;
        switch(msg.dekInfo.algorithm){
            case "DES-CBC":
                dkLen = 8;
                cipherFn = $fz7FM.des.createDecryptionCipher;
                break;
            case "DES-EDE3-CBC":
                dkLen = 24;
                cipherFn = $fz7FM.des.createDecryptionCipher;
                break;
            case "AES-128-CBC":
                dkLen = 16;
                cipherFn = $fz7FM.aes.createDecryptionCipher;
                break;
            case "AES-192-CBC":
                dkLen = 24;
                cipherFn = $fz7FM.aes.createDecryptionCipher;
                break;
            case "AES-256-CBC":
                dkLen = 32;
                cipherFn = $fz7FM.aes.createDecryptionCipher;
                break;
            case "RC2-40-CBC":
                dkLen = 5;
                cipherFn = function cipherFn(key) {
                    return $fz7FM.rc2.createDecryptionCipher(key, 40);
                };
                break;
            case "RC2-64-CBC":
                dkLen = 8;
                cipherFn = function cipherFn(key) {
                    return $fz7FM.rc2.createDecryptionCipher(key, 64);
                };
                break;
            case "RC2-128-CBC":
                dkLen = 16;
                cipherFn = function cipherFn(key) {
                    return $fz7FM.rc2.createDecryptionCipher(key, 128);
                };
                break;
            default:
                var error = new Error('Could not decrypt private key; unsupported encryption algorithm "' + msg.dekInfo.algorithm + '".');
                error.algorithm = msg.dekInfo.algorithm;
                throw error;
        }
        // use OpenSSL legacy key derivation
        var iv = $fz7FM.util.hexToBytes(msg.dekInfo.parameters);
        var dk = $fz7FM.pbe.opensslDeriveBytes(password, iv.substr(0, 8), dkLen);
        var cipher = cipherFn(dk);
        cipher.start(iv);
        cipher.update($fz7FM.util.createBuffer(msg.body));
        if (cipher.finish()) rval = cipher.output.getBytes();
        else return rval;
    } else rval = msg.body;
    if (msg.type === "ENCRYPTED PRIVATE KEY") rval = $3bec5a2dafafc956$var$pki.decryptPrivateKeyInfo($3bec5a2dafafc956$var$asn1.fromDer(rval), password);
    else // decryption already performed above
    rval = $3bec5a2dafafc956$var$asn1.fromDer(rval);
    if (rval !== null) rval = $3bec5a2dafafc956$var$pki.privateKeyFromAsn1(rval);
    return rval;
};
/**
 * Derives a PKCS#12 key.
 *
 * @param password the password to derive the key material from, null or
 *          undefined for none.
 * @param salt the salt, as a ByteBuffer, to use.
 * @param id the PKCS#12 ID byte (1 = key material, 2 = IV, 3 = MAC).
 * @param iter the iteration count.
 * @param n the number of bytes to derive from the password.
 * @param md the message digest to use, defaults to SHA-1.
 *
 * @return a ByteBuffer with the bytes derived from the password.
 */ $3bec5a2dafafc956$var$pki.pbe.generatePkcs12Key = function(password, salt, id, iter, n, md) {
    var j, l;
    if (typeof md === "undefined" || md === null) {
        if (!("sha1" in $fz7FM.md)) throw new Error('"sha1" hash algorithm unavailable.');
        md = $fz7FM.md.sha1.create();
    }
    var u = md.digestLength;
    var v = md.blockLength;
    var result = new $fz7FM.util.ByteBuffer();
    /* Convert password to Unicode byte buffer + trailing 0-byte. */ var passBuf = new $fz7FM.util.ByteBuffer();
    if (password !== null && password !== undefined) {
        for(l = 0; l < password.length; l++)passBuf.putInt16(password.charCodeAt(l));
        passBuf.putInt16(0);
    }
    /* Length of salt and password in BYTES. */ var p = passBuf.length();
    var s = salt.length();
    /* 1. Construct a string, D (the "diversifier"), by concatenating
        v copies of ID. */ var D = new $fz7FM.util.ByteBuffer();
    D.fillWithByte(id, v);
    /* 2. Concatenate copies of the salt together to create a string S of length
        v * ceil(s / v) bytes (the final copy of the salt may be trunacted
        to create S).
        Note that if the salt is the empty string, then so is S. */ var Slen = v * Math.ceil(s / v);
    var S = new $fz7FM.util.ByteBuffer();
    for(l = 0; l < Slen; l++)S.putByte(salt.at(l % s));
    /* 3. Concatenate copies of the password together to create a string P of
        length v * ceil(p / v) bytes (the final copy of the password may be
        truncated to create P).
        Note that if the password is the empty string, then so is P. */ var Plen = v * Math.ceil(p / v);
    var P = new $fz7FM.util.ByteBuffer();
    for(l = 0; l < Plen; l++)P.putByte(passBuf.at(l % p));
    /* 4. Set I=S||P to be the concatenation of S and P. */ var I = S;
    I.putBuffer(P);
    /* 5. Set c=ceil(n / u). */ var c = Math.ceil(n / u);
    /* 6. For i=1, 2, ..., c, do the following: */ for(var i = 1; i <= c; i++){
        /* a) Set Ai=H^r(D||I). (l.e. the rth hash of D||I, H(H(H(...H(D||I)))) */ var buf = new $fz7FM.util.ByteBuffer();
        buf.putBytes(D.bytes());
        buf.putBytes(I.bytes());
        for(var round = 0; round < iter; round++){
            md.start();
            md.update(buf.getBytes());
            buf = md.digest();
        }
        /* b) Concatenate copies of Ai to create a string B of length v bytes (the
          final copy of Ai may be truncated to create B). */ var B = new $fz7FM.util.ByteBuffer();
        for(l = 0; l < v; l++)B.putByte(buf.at(l % u));
        /* c) Treating I as a concatenation I0, I1, ..., Ik-1 of v-byte blocks,
          where k=ceil(s / v) + ceil(p / v), modify I by setting
          Ij=(Ij+B+1) mod 2v for each j.  */ var k = Math.ceil(s / v) + Math.ceil(p / v);
        var Inew = new $fz7FM.util.ByteBuffer();
        for(j = 0; j < k; j++){
            var chunk = new $fz7FM.util.ByteBuffer(I.getBytes(v));
            var x = 0x1ff;
            for(l = B.length() - 1; l >= 0; l--){
                x = x >> 8;
                x += B.at(l) + chunk.at(l);
                chunk.setAt(l, x & 0xff);
            }
            Inew.putBuffer(chunk);
        }
        I = Inew;
        /* Add Ai to A. */ result.putBuffer(buf);
    }
    result.truncate(result.length() - n);
    return result;
};
/**
 * Get new Forge cipher object instance.
 *
 * @param oid the OID (in string notation).
 * @param params the ASN.1 params object.
 * @param password the password to decrypt with.
 *
 * @return new cipher object instance.
 */ $3bec5a2dafafc956$var$pki.pbe.getCipher = function(oid, params, password) {
    switch(oid){
        case $3bec5a2dafafc956$var$pki.oids["pkcs5PBES2"]:
            return $3bec5a2dafafc956$var$pki.pbe.getCipherForPBES2(oid, params, password);
        case $3bec5a2dafafc956$var$pki.oids["pbeWithSHAAnd3-KeyTripleDES-CBC"]:
        case $3bec5a2dafafc956$var$pki.oids["pbewithSHAAnd40BitRC2-CBC"]:
            return $3bec5a2dafafc956$var$pki.pbe.getCipherForPKCS12PBE(oid, params, password);
        default:
            var error = new Error("Cannot read encrypted PBE data block. Unsupported OID.");
            error.oid = oid;
            error.supportedOids = [
                "pkcs5PBES2",
                "pbeWithSHAAnd3-KeyTripleDES-CBC",
                "pbewithSHAAnd40BitRC2-CBC"
            ];
            throw error;
    }
};
/**
 * Get new Forge cipher object instance according to PBES2 params block.
 *
 * The returned cipher instance is already started using the IV
 * from PBES2 parameter block.
 *
 * @param oid the PKCS#5 PBKDF2 OID (in string notation).
 * @param params the ASN.1 PBES2-params object.
 * @param password the password to decrypt with.
 *
 * @return new cipher object instance.
 */ $3bec5a2dafafc956$var$pki.pbe.getCipherForPBES2 = function(oid, params, password) {
    // get PBE params
    var capture = {};
    var errors = [];
    if (!$3bec5a2dafafc956$var$asn1.validate(params, $3bec5a2dafafc956$var$PBES2AlgorithmsValidator, capture, errors)) {
        var error = new Error("Cannot read password-based-encryption algorithm parameters. ASN.1 object is not a supported EncryptedPrivateKeyInfo.");
        error.errors = errors;
        throw error;
    }
    // check oids
    oid = $3bec5a2dafafc956$var$asn1.derToOid(capture.kdfOid);
    if (oid !== $3bec5a2dafafc956$var$pki.oids["pkcs5PBKDF2"]) {
        var error = new Error("Cannot read encrypted private key. Unsupported key derivation function OID.");
        error.oid = oid;
        error.supportedOids = [
            "pkcs5PBKDF2"
        ];
        throw error;
    }
    oid = $3bec5a2dafafc956$var$asn1.derToOid(capture.encOid);
    if (oid !== $3bec5a2dafafc956$var$pki.oids["aes128-CBC"] && oid !== $3bec5a2dafafc956$var$pki.oids["aes192-CBC"] && oid !== $3bec5a2dafafc956$var$pki.oids["aes256-CBC"] && oid !== $3bec5a2dafafc956$var$pki.oids["des-EDE3-CBC"] && oid !== $3bec5a2dafafc956$var$pki.oids["desCBC"]) {
        var error = new Error("Cannot read encrypted private key. Unsupported encryption scheme OID.");
        error.oid = oid;
        error.supportedOids = [
            "aes128-CBC",
            "aes192-CBC",
            "aes256-CBC",
            "des-EDE3-CBC",
            "desCBC"
        ];
        throw error;
    }
    // set PBE params
    var salt = capture.kdfSalt;
    var count = $fz7FM.util.createBuffer(capture.kdfIterationCount);
    count = count.getInt(count.length() << 3);
    var dkLen;
    var cipherFn;
    switch($3bec5a2dafafc956$var$pki.oids[oid]){
        case "aes128-CBC":
            dkLen = 16;
            cipherFn = $fz7FM.aes.createDecryptionCipher;
            break;
        case "aes192-CBC":
            dkLen = 24;
            cipherFn = $fz7FM.aes.createDecryptionCipher;
            break;
        case "aes256-CBC":
            dkLen = 32;
            cipherFn = $fz7FM.aes.createDecryptionCipher;
            break;
        case "des-EDE3-CBC":
            dkLen = 24;
            cipherFn = $fz7FM.des.createDecryptionCipher;
            break;
        case "desCBC":
            dkLen = 8;
            cipherFn = $fz7FM.des.createDecryptionCipher;
            break;
    }
    // get PRF message digest
    var md = $3bec5a2dafafc956$var$prfOidToMessageDigest(capture.prfOid);
    // decrypt private key using pbe with chosen PRF and AES/DES
    var dk = $fz7FM.pkcs5.pbkdf2(password, salt, count, dkLen, md);
    var iv = capture.encIv;
    var cipher = cipherFn(dk);
    cipher.start(iv);
    return cipher;
};
/**
 * Get new Forge cipher object instance for PKCS#12 PBE.
 *
 * The returned cipher instance is already started using the key & IV
 * derived from the provided password and PKCS#12 PBE salt.
 *
 * @param oid The PKCS#12 PBE OID (in string notation).
 * @param params The ASN.1 PKCS#12 PBE-params object.
 * @param password The password to decrypt with.
 *
 * @return the new cipher object instance.
 */ $3bec5a2dafafc956$var$pki.pbe.getCipherForPKCS12PBE = function(oid, params, password) {
    // get PBE params
    var capture = {};
    var errors = [];
    if (!$3bec5a2dafafc956$var$asn1.validate(params, $3bec5a2dafafc956$var$pkcs12PbeParamsValidator, capture, errors)) {
        var error = new Error("Cannot read password-based-encryption algorithm parameters. ASN.1 object is not a supported EncryptedPrivateKeyInfo.");
        error.errors = errors;
        throw error;
    }
    var salt = $fz7FM.util.createBuffer(capture.salt);
    var count = $fz7FM.util.createBuffer(capture.iterations);
    count = count.getInt(count.length() << 3);
    var dkLen, dIvLen, cipherFn;
    switch(oid){
        case $3bec5a2dafafc956$var$pki.oids["pbeWithSHAAnd3-KeyTripleDES-CBC"]:
            dkLen = 24;
            dIvLen = 8;
            cipherFn = $fz7FM.des.startDecrypting;
            break;
        case $3bec5a2dafafc956$var$pki.oids["pbewithSHAAnd40BitRC2-CBC"]:
            dkLen = 5;
            dIvLen = 8;
            cipherFn = function cipherFn(key, iv) {
                var cipher = $fz7FM.rc2.createDecryptionCipher(key, 40);
                cipher.start(iv, null);
                return cipher;
            };
            break;
        default:
            var error = new Error("Cannot read PKCS #12 PBE data block. Unsupported OID.");
            error.oid = oid;
            throw error;
    }
    // get PRF message digest
    var md = $3bec5a2dafafc956$var$prfOidToMessageDigest(capture.prfOid);
    var key = $3bec5a2dafafc956$var$pki.pbe.generatePkcs12Key(password, salt, 1, count, dkLen, md);
    md.start();
    var iv = $3bec5a2dafafc956$var$pki.pbe.generatePkcs12Key(password, salt, 2, count, dIvLen, md);
    return cipherFn(key, iv);
};
/**
 * OpenSSL's legacy key derivation function.
 *
 * See: http://www.openssl.org/docs/crypto/EVP_BytesToKey.html
 *
 * @param password the password to derive the key from.
 * @param salt the salt to use, null for none.
 * @param dkLen the number of bytes needed for the derived key.
 * @param [options] the options to use:
 *          [md] an optional message digest object to use.
 */ $3bec5a2dafafc956$var$pki.pbe.opensslDeriveBytes = function(password, salt, dkLen, md) {
    if (typeof md === "undefined" || md === null) {
        if (!("md5" in $fz7FM.md)) throw new Error('"md5" hash algorithm unavailable.');
        md = $fz7FM.md.md5.create();
    }
    if (salt === null) salt = "";
    var digests = [
        $3bec5a2dafafc956$var$hash(md, password + salt)
    ];
    for(var length = 16, i = 1; length < dkLen; ++i, length += 16)digests.push($3bec5a2dafafc956$var$hash(md, digests[i - 1] + password + salt));
    return digests.join("").substr(0, dkLen);
};
function $3bec5a2dafafc956$var$hash(md, bytes) {
    return md.start().update(bytes).digest().getBytes();
}
function $3bec5a2dafafc956$var$prfOidToMessageDigest(prfOid) {
    // get PRF algorithm, default to SHA-1
    var prfAlgorithm;
    if (!prfOid) prfAlgorithm = "hmacWithSHA1";
    else {
        prfAlgorithm = $3bec5a2dafafc956$var$pki.oids[$3bec5a2dafafc956$var$asn1.derToOid(prfOid)];
        if (!prfAlgorithm) {
            var error = new Error("Unsupported PRF OID.");
            error.oid = prfOid;
            error.supported = [
                "hmacWithSHA1",
                "hmacWithSHA224",
                "hmacWithSHA256",
                "hmacWithSHA384",
                "hmacWithSHA512"
            ];
            throw error;
        }
    }
    return $3bec5a2dafafc956$var$prfAlgorithmToMessageDigest(prfAlgorithm);
}
function $3bec5a2dafafc956$var$prfAlgorithmToMessageDigest(prfAlgorithm) {
    var factory = $fz7FM.md;
    switch(prfAlgorithm){
        case "hmacWithSHA224":
            factory = $fz7FM.md.sha512;
        case "hmacWithSHA1":
        case "hmacWithSHA256":
        case "hmacWithSHA384":
        case "hmacWithSHA512":
            prfAlgorithm = prfAlgorithm.substr(8).toLowerCase();
            break;
        default:
            var error = new Error("Unsupported PRF algorithm.");
            error.algorithm = prfAlgorithm;
            error.supported = [
                "hmacWithSHA1",
                "hmacWithSHA224",
                "hmacWithSHA256",
                "hmacWithSHA384",
                "hmacWithSHA512"
            ];
            throw error;
    }
    if (!factory || !(prfAlgorithm in factory)) throw new Error("Unknown hash algorithm: " + prfAlgorithm);
    return factory[prfAlgorithm].create();
}
function $3bec5a2dafafc956$var$createPbkdf2Params(salt, countBytes, dkLen, prfAlgorithm) {
    var params = $3bec5a2dafafc956$var$asn1.create($3bec5a2dafafc956$var$asn1.Class.UNIVERSAL, $3bec5a2dafafc956$var$asn1.Type.SEQUENCE, true, [
        // salt
        $3bec5a2dafafc956$var$asn1.create($3bec5a2dafafc956$var$asn1.Class.UNIVERSAL, $3bec5a2dafafc956$var$asn1.Type.OCTETSTRING, false, salt),
        // iteration count
        $3bec5a2dafafc956$var$asn1.create($3bec5a2dafafc956$var$asn1.Class.UNIVERSAL, $3bec5a2dafafc956$var$asn1.Type.INTEGER, false, countBytes.getBytes())
    ]);
    // when PRF algorithm is not SHA-1 default, add key length and PRF algorithm
    if (prfAlgorithm !== "hmacWithSHA1") params.value.push(// key length
    $3bec5a2dafafc956$var$asn1.create($3bec5a2dafafc956$var$asn1.Class.UNIVERSAL, $3bec5a2dafafc956$var$asn1.Type.INTEGER, false, $fz7FM.util.hexToBytes(dkLen.toString(16))), // AlgorithmIdentifier
    $3bec5a2dafafc956$var$asn1.create($3bec5a2dafafc956$var$asn1.Class.UNIVERSAL, $3bec5a2dafafc956$var$asn1.Type.SEQUENCE, true, [
        // algorithm
        $3bec5a2dafafc956$var$asn1.create($3bec5a2dafafc956$var$asn1.Class.UNIVERSAL, $3bec5a2dafafc956$var$asn1.Type.OID, false, $3bec5a2dafafc956$var$asn1.oidToDer($3bec5a2dafafc956$var$pki.oids[prfAlgorithm]).getBytes()),
        // parameters (null)
        $3bec5a2dafafc956$var$asn1.create($3bec5a2dafafc956$var$asn1.Class.UNIVERSAL, $3bec5a2dafafc956$var$asn1.Type.NULL, false, "")
    ]));
    return params;
}

});
parcelRegister("bhqHY", function(module, exports) {
/**
 * DES (Data Encryption Standard) implementation.
 *
 * This implementation supports DES as well as 3DES-EDE in ECB and CBC mode.
 * It is based on the BSD-licensed implementation by Paul Tero:
 *
 * Paul Tero, July 2001
 * http://www.tero.co.uk/des/
 *
 * Optimised for performance with large blocks by
 * Michael Hayworth, November 2001
 * http://www.netdealing.com
 *
 * THIS SOFTWARE IS PROVIDED "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
 * ARE DISCLAIMED.  IN NO EVENT SHALL THE AUTHOR OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS
 * OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION)
 * HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
 * OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF
 * SUCH DAMAGE.
 *
 * @author Stefan Siegl
 * @author Dave Longley
 *
 * Copyright (c) 2012 Stefan Siegl <stesie@brokenpipe.de>
 * Copyright (c) 2012-2014 Digital Bazaar, Inc.
 */ 
var $fz7FM = parcelRequire("fz7FM");
parcelRequire("4Bsm2");
parcelRequire("2hAcz");
parcelRequire("gao36");
/* DES API */ module.exports = $fz7FM.des = $fz7FM.des || {};
/**
 * Deprecated. Instead, use:
 *
 * var cipher = forge.cipher.createCipher('DES-<mode>', key);
 * cipher.start({iv: iv});
 *
 * Creates an DES cipher object to encrypt data using the given symmetric key.
 * The output will be stored in the 'output' member of the returned cipher.
 *
 * The key and iv may be given as binary-encoded strings of bytes or
 * byte buffers.
 *
 * @param key the symmetric key to use (64 or 192 bits).
 * @param iv the initialization vector to use.
 * @param output the buffer to write to, null to create one.
 * @param mode the cipher mode to use (default: 'CBC' if IV is
 *          given, 'ECB' if null).
 *
 * @return the cipher.
 */ $fz7FM.des.startEncrypting = function(key, iv, output, mode) {
    var cipher = $8365fff5c67f01d8$var$_createCipher({
        key: key,
        output: output,
        decrypt: false,
        mode: mode || (iv === null ? "ECB" : "CBC")
    });
    cipher.start(iv);
    return cipher;
};
/**
 * Deprecated. Instead, use:
 *
 * var cipher = forge.cipher.createCipher('DES-<mode>', key);
 *
 * Creates an DES cipher object to encrypt data using the given symmetric key.
 *
 * The key may be given as a binary-encoded string of bytes or a byte buffer.
 *
 * @param key the symmetric key to use (64 or 192 bits).
 * @param mode the cipher mode to use (default: 'CBC').
 *
 * @return the cipher.
 */ $fz7FM.des.createEncryptionCipher = function(key, mode) {
    return $8365fff5c67f01d8$var$_createCipher({
        key: key,
        output: null,
        decrypt: false,
        mode: mode
    });
};
/**
 * Deprecated. Instead, use:
 *
 * var decipher = forge.cipher.createDecipher('DES-<mode>', key);
 * decipher.start({iv: iv});
 *
 * Creates an DES cipher object to decrypt data using the given symmetric key.
 * The output will be stored in the 'output' member of the returned cipher.
 *
 * The key and iv may be given as binary-encoded strings of bytes or
 * byte buffers.
 *
 * @param key the symmetric key to use (64 or 192 bits).
 * @param iv the initialization vector to use.
 * @param output the buffer to write to, null to create one.
 * @param mode the cipher mode to use (default: 'CBC' if IV is
 *          given, 'ECB' if null).
 *
 * @return the cipher.
 */ $fz7FM.des.startDecrypting = function(key, iv, output, mode) {
    var cipher = $8365fff5c67f01d8$var$_createCipher({
        key: key,
        output: output,
        decrypt: true,
        mode: mode || (iv === null ? "ECB" : "CBC")
    });
    cipher.start(iv);
    return cipher;
};
/**
 * Deprecated. Instead, use:
 *
 * var decipher = forge.cipher.createDecipher('DES-<mode>', key);
 *
 * Creates an DES cipher object to decrypt data using the given symmetric key.
 *
 * The key may be given as a binary-encoded string of bytes or a byte buffer.
 *
 * @param key the symmetric key to use (64 or 192 bits).
 * @param mode the cipher mode to use (default: 'CBC').
 *
 * @return the cipher.
 */ $fz7FM.des.createDecryptionCipher = function(key, mode) {
    return $8365fff5c67f01d8$var$_createCipher({
        key: key,
        output: null,
        decrypt: true,
        mode: mode
    });
};
/**
 * Creates a new DES cipher algorithm object.
 *
 * @param name the name of the algorithm.
 * @param mode the mode factory function.
 *
 * @return the DES algorithm object.
 */ $fz7FM.des.Algorithm = function(name, mode) {
    var self = this;
    self.name = name;
    self.mode = new mode({
        blockSize: 8,
        cipher: {
            encrypt: function encrypt(inBlock, outBlock) {
                return $8365fff5c67f01d8$var$_updateBlock(self._keys, inBlock, outBlock, false);
            },
            decrypt: function decrypt(inBlock, outBlock) {
                return $8365fff5c67f01d8$var$_updateBlock(self._keys, inBlock, outBlock, true);
            }
        }
    });
    self._init = false;
};
/**
 * Initializes this DES algorithm by expanding its key.
 *
 * @param options the options to use.
 *          key the key to use with this algorithm.
 *          decrypt true if the algorithm should be initialized for decryption,
 *            false for encryption.
 */ $fz7FM.des.Algorithm.prototype.initialize = function(options) {
    if (this._init) return;
    var key = $fz7FM.util.createBuffer(options.key);
    if (this.name.indexOf("3DES") === 0) {
        if (key.length() !== 24) throw new Error("Invalid Triple-DES key size: " + key.length() * 8);
    }
    // do key expansion to 16 or 48 subkeys (single or triple DES)
    this._keys = $8365fff5c67f01d8$var$_createKeys(key);
    this._init = true;
};
/** Register DES algorithms **/ $8365fff5c67f01d8$var$registerAlgorithm("DES-ECB", $fz7FM.cipher.modes.ecb);
$8365fff5c67f01d8$var$registerAlgorithm("DES-CBC", $fz7FM.cipher.modes.cbc);
$8365fff5c67f01d8$var$registerAlgorithm("DES-CFB", $fz7FM.cipher.modes.cfb);
$8365fff5c67f01d8$var$registerAlgorithm("DES-OFB", $fz7FM.cipher.modes.ofb);
$8365fff5c67f01d8$var$registerAlgorithm("DES-CTR", $fz7FM.cipher.modes.ctr);
$8365fff5c67f01d8$var$registerAlgorithm("3DES-ECB", $fz7FM.cipher.modes.ecb);
$8365fff5c67f01d8$var$registerAlgorithm("3DES-CBC", $fz7FM.cipher.modes.cbc);
$8365fff5c67f01d8$var$registerAlgorithm("3DES-CFB", $fz7FM.cipher.modes.cfb);
$8365fff5c67f01d8$var$registerAlgorithm("3DES-OFB", $fz7FM.cipher.modes.ofb);
$8365fff5c67f01d8$var$registerAlgorithm("3DES-CTR", $fz7FM.cipher.modes.ctr);
function $8365fff5c67f01d8$var$registerAlgorithm(name, mode) {
    var factory = function factory() {
        return new $fz7FM.des.Algorithm(name, mode);
    };
    $fz7FM.cipher.registerAlgorithm(name, factory);
}
/** DES implementation **/ var $8365fff5c67f01d8$var$spfunction1 = [
    0x1010400,
    0,
    0x10000,
    0x1010404,
    0x1010004,
    0x10404,
    0x4,
    0x10000,
    0x400,
    0x1010400,
    0x1010404,
    0x400,
    0x1000404,
    0x1010004,
    0x1000000,
    0x4,
    0x404,
    0x1000400,
    0x1000400,
    0x10400,
    0x10400,
    0x1010000,
    0x1010000,
    0x1000404,
    0x10004,
    0x1000004,
    0x1000004,
    0x10004,
    0,
    0x404,
    0x10404,
    0x1000000,
    0x10000,
    0x1010404,
    0x4,
    0x1010000,
    0x1010400,
    0x1000000,
    0x1000000,
    0x400,
    0x1010004,
    0x10000,
    0x10400,
    0x1000004,
    0x400,
    0x4,
    0x1000404,
    0x10404,
    0x1010404,
    0x10004,
    0x1010000,
    0x1000404,
    0x1000004,
    0x404,
    0x10404,
    0x1010400,
    0x404,
    0x1000400,
    0x1000400,
    0,
    0x10004,
    0x10400,
    0,
    0x1010004
];
var $8365fff5c67f01d8$var$spfunction2 = [
    -2146402272,
    -2147450880,
    0x8000,
    0x108020,
    0x100000,
    0x20,
    -2146435040,
    -2147450848,
    -2147483616,
    -2146402272,
    -2146402304,
    -2147483648,
    -2147450880,
    0x100000,
    0x20,
    -2146435040,
    0x108000,
    0x100020,
    -2147450848,
    0,
    -2147483648,
    0x8000,
    0x108020,
    -2146435072,
    0x100020,
    -2147483616,
    0,
    0x108000,
    0x8020,
    -2146402304,
    -2146435072,
    0x8020,
    0,
    0x108020,
    -2146435040,
    0x100000,
    -2147450848,
    -2146435072,
    -2146402304,
    0x8000,
    -2146435072,
    -2147450880,
    0x20,
    -2146402272,
    0x108020,
    0x20,
    0x8000,
    -2147483648,
    0x8020,
    -2146402304,
    0x100000,
    -2147483616,
    0x100020,
    -2147450848,
    -2147483616,
    0x100020,
    0x108000,
    0,
    -2147450880,
    0x8020,
    -2147483648,
    -2146435040,
    -2146402272,
    0x108000
];
var $8365fff5c67f01d8$var$spfunction3 = [
    0x208,
    0x8020200,
    0,
    0x8020008,
    0x8000200,
    0,
    0x20208,
    0x8000200,
    0x20008,
    0x8000008,
    0x8000008,
    0x20000,
    0x8020208,
    0x20008,
    0x8020000,
    0x208,
    0x8000000,
    0x8,
    0x8020200,
    0x200,
    0x20200,
    0x8020000,
    0x8020008,
    0x20208,
    0x8000208,
    0x20200,
    0x20000,
    0x8000208,
    0x8,
    0x8020208,
    0x200,
    0x8000000,
    0x8020200,
    0x8000000,
    0x20008,
    0x208,
    0x20000,
    0x8020200,
    0x8000200,
    0,
    0x200,
    0x20008,
    0x8020208,
    0x8000200,
    0x8000008,
    0x200,
    0,
    0x8020008,
    0x8000208,
    0x20000,
    0x8000000,
    0x8020208,
    0x8,
    0x20208,
    0x20200,
    0x8000008,
    0x8020000,
    0x8000208,
    0x208,
    0x8020000,
    0x20208,
    0x8,
    0x8020008,
    0x20200
];
var $8365fff5c67f01d8$var$spfunction4 = [
    0x802001,
    0x2081,
    0x2081,
    0x80,
    0x802080,
    0x800081,
    0x800001,
    0x2001,
    0,
    0x802000,
    0x802000,
    0x802081,
    0x81,
    0,
    0x800080,
    0x800001,
    0x1,
    0x2000,
    0x800000,
    0x802001,
    0x80,
    0x800000,
    0x2001,
    0x2080,
    0x800081,
    0x1,
    0x2080,
    0x800080,
    0x2000,
    0x802080,
    0x802081,
    0x81,
    0x800080,
    0x800001,
    0x802000,
    0x802081,
    0x81,
    0,
    0,
    0x802000,
    0x2080,
    0x800080,
    0x800081,
    0x1,
    0x802001,
    0x2081,
    0x2081,
    0x80,
    0x802081,
    0x81,
    0x1,
    0x2000,
    0x800001,
    0x2001,
    0x802080,
    0x800081,
    0x2001,
    0x2080,
    0x800000,
    0x802001,
    0x80,
    0x800000,
    0x2000,
    0x802080
];
var $8365fff5c67f01d8$var$spfunction5 = [
    0x100,
    0x2080100,
    0x2080000,
    0x42000100,
    0x80000,
    0x100,
    0x40000000,
    0x2080000,
    0x40080100,
    0x80000,
    0x2000100,
    0x40080100,
    0x42000100,
    0x42080000,
    0x80100,
    0x40000000,
    0x2000000,
    0x40080000,
    0x40080000,
    0,
    0x40000100,
    0x42080100,
    0x42080100,
    0x2000100,
    0x42080000,
    0x40000100,
    0,
    0x42000000,
    0x2080100,
    0x2000000,
    0x42000000,
    0x80100,
    0x80000,
    0x42000100,
    0x100,
    0x2000000,
    0x40000000,
    0x2080000,
    0x42000100,
    0x40080100,
    0x2000100,
    0x40000000,
    0x42080000,
    0x2080100,
    0x40080100,
    0x100,
    0x2000000,
    0x42080000,
    0x42080100,
    0x80100,
    0x42000000,
    0x42080100,
    0x2080000,
    0,
    0x40080000,
    0x42000000,
    0x80100,
    0x2000100,
    0x40000100,
    0x80000,
    0,
    0x40080000,
    0x2080100,
    0x40000100
];
var $8365fff5c67f01d8$var$spfunction6 = [
    0x20000010,
    0x20400000,
    0x4000,
    0x20404010,
    0x20400000,
    0x10,
    0x20404010,
    0x400000,
    0x20004000,
    0x404010,
    0x400000,
    0x20000010,
    0x400010,
    0x20004000,
    0x20000000,
    0x4010,
    0,
    0x400010,
    0x20004010,
    0x4000,
    0x404000,
    0x20004010,
    0x10,
    0x20400010,
    0x20400010,
    0,
    0x404010,
    0x20404000,
    0x4010,
    0x404000,
    0x20404000,
    0x20000000,
    0x20004000,
    0x10,
    0x20400010,
    0x404000,
    0x20404010,
    0x400000,
    0x4010,
    0x20000010,
    0x400000,
    0x20004000,
    0x20000000,
    0x4010,
    0x20000010,
    0x20404010,
    0x404000,
    0x20400000,
    0x404010,
    0x20404000,
    0,
    0x20400010,
    0x10,
    0x4000,
    0x20400000,
    0x404010,
    0x4000,
    0x400010,
    0x20004010,
    0,
    0x20404000,
    0x20000000,
    0x400010,
    0x20004010
];
var $8365fff5c67f01d8$var$spfunction7 = [
    0x200000,
    0x4200002,
    0x4000802,
    0,
    0x800,
    0x4000802,
    0x200802,
    0x4200800,
    0x4200802,
    0x200000,
    0,
    0x4000002,
    0x2,
    0x4000000,
    0x4200002,
    0x802,
    0x4000800,
    0x200802,
    0x200002,
    0x4000800,
    0x4000002,
    0x4200000,
    0x4200800,
    0x200002,
    0x4200000,
    0x800,
    0x802,
    0x4200802,
    0x200800,
    0x2,
    0x4000000,
    0x200800,
    0x4000000,
    0x200800,
    0x200000,
    0x4000802,
    0x4000802,
    0x4200002,
    0x4200002,
    0x2,
    0x200002,
    0x4000000,
    0x4000800,
    0x200000,
    0x4200800,
    0x802,
    0x200802,
    0x4200800,
    0x802,
    0x4000002,
    0x4200802,
    0x4200000,
    0x200800,
    0,
    0x2,
    0x4200802,
    0,
    0x200802,
    0x4200000,
    0x800,
    0x4000002,
    0x4000800,
    0x800,
    0x200002
];
var $8365fff5c67f01d8$var$spfunction8 = [
    0x10001040,
    0x1000,
    0x40000,
    0x10041040,
    0x10000000,
    0x10001040,
    0x40,
    0x10000000,
    0x40040,
    0x10040000,
    0x10041040,
    0x41000,
    0x10041000,
    0x41040,
    0x1000,
    0x40,
    0x10040000,
    0x10000040,
    0x10001000,
    0x1040,
    0x41000,
    0x40040,
    0x10040040,
    0x10041000,
    0x1040,
    0,
    0,
    0x10040040,
    0x10000040,
    0x10001000,
    0x41040,
    0x40000,
    0x41040,
    0x40000,
    0x10041000,
    0x1000,
    0x40,
    0x10040040,
    0x1000,
    0x41040,
    0x10001000,
    0x40,
    0x10000040,
    0x10040000,
    0x10040040,
    0x10000000,
    0x40000,
    0x10001040,
    0,
    0x10041040,
    0x40040,
    0x10000040,
    0x10040000,
    0x10001000,
    0x10001040,
    0,
    0x10041040,
    0x41000,
    0x41000,
    0x1040,
    0x1040,
    0x40040,
    0x10000000,
    0x10041000
];
/**
 * Create necessary sub keys.
 *
 * @param key the 64-bit or 192-bit key.
 *
 * @return the expanded keys.
 */ function $8365fff5c67f01d8$var$_createKeys(key) {
    var pc2bytes0 = [
        0,
        0x4,
        0x20000000,
        0x20000004,
        0x10000,
        0x10004,
        0x20010000,
        0x20010004,
        0x200,
        0x204,
        0x20000200,
        0x20000204,
        0x10200,
        0x10204,
        0x20010200,
        0x20010204
    ], pc2bytes1 = [
        0,
        0x1,
        0x100000,
        0x100001,
        0x4000000,
        0x4000001,
        0x4100000,
        0x4100001,
        0x100,
        0x101,
        0x100100,
        0x100101,
        0x4000100,
        0x4000101,
        0x4100100,
        0x4100101
    ], pc2bytes2 = [
        0,
        0x8,
        0x800,
        0x808,
        0x1000000,
        0x1000008,
        0x1000800,
        0x1000808,
        0,
        0x8,
        0x800,
        0x808,
        0x1000000,
        0x1000008,
        0x1000800,
        0x1000808
    ], pc2bytes3 = [
        0,
        0x200000,
        0x8000000,
        0x8200000,
        0x2000,
        0x202000,
        0x8002000,
        0x8202000,
        0x20000,
        0x220000,
        0x8020000,
        0x8220000,
        0x22000,
        0x222000,
        0x8022000,
        0x8222000
    ], pc2bytes4 = [
        0,
        0x40000,
        0x10,
        0x40010,
        0,
        0x40000,
        0x10,
        0x40010,
        0x1000,
        0x41000,
        0x1010,
        0x41010,
        0x1000,
        0x41000,
        0x1010,
        0x41010
    ], pc2bytes5 = [
        0,
        0x400,
        0x20,
        0x420,
        0,
        0x400,
        0x20,
        0x420,
        0x2000000,
        0x2000400,
        0x2000020,
        0x2000420,
        0x2000000,
        0x2000400,
        0x2000020,
        0x2000420
    ], pc2bytes6 = [
        0,
        0x10000000,
        0x80000,
        0x10080000,
        0x2,
        0x10000002,
        0x80002,
        0x10080002,
        0,
        0x10000000,
        0x80000,
        0x10080000,
        0x2,
        0x10000002,
        0x80002,
        0x10080002
    ], pc2bytes7 = [
        0,
        0x10000,
        0x800,
        0x10800,
        0x20000000,
        0x20010000,
        0x20000800,
        0x20010800,
        0x20000,
        0x30000,
        0x20800,
        0x30800,
        0x20020000,
        0x20030000,
        0x20020800,
        0x20030800
    ], pc2bytes8 = [
        0,
        0x40000,
        0,
        0x40000,
        0x2,
        0x40002,
        0x2,
        0x40002,
        0x2000000,
        0x2040000,
        0x2000000,
        0x2040000,
        0x2000002,
        0x2040002,
        0x2000002,
        0x2040002
    ], pc2bytes9 = [
        0,
        0x10000000,
        0x8,
        0x10000008,
        0,
        0x10000000,
        0x8,
        0x10000008,
        0x400,
        0x10000400,
        0x408,
        0x10000408,
        0x400,
        0x10000400,
        0x408,
        0x10000408
    ], pc2bytes10 = [
        0,
        0x20,
        0,
        0x20,
        0x100000,
        0x100020,
        0x100000,
        0x100020,
        0x2000,
        0x2020,
        0x2000,
        0x2020,
        0x102000,
        0x102020,
        0x102000,
        0x102020
    ], pc2bytes11 = [
        0,
        0x1000000,
        0x200,
        0x1000200,
        0x200000,
        0x1200000,
        0x200200,
        0x1200200,
        0x4000000,
        0x5000000,
        0x4000200,
        0x5000200,
        0x4200000,
        0x5200000,
        0x4200200,
        0x5200200
    ], pc2bytes12 = [
        0,
        0x1000,
        0x8000000,
        0x8001000,
        0x80000,
        0x81000,
        0x8080000,
        0x8081000,
        0x10,
        0x1010,
        0x8000010,
        0x8001010,
        0x80010,
        0x81010,
        0x8080010,
        0x8081010
    ], pc2bytes13 = [
        0,
        0x4,
        0x100,
        0x104,
        0,
        0x4,
        0x100,
        0x104,
        0x1,
        0x5,
        0x101,
        0x105,
        0x1,
        0x5,
        0x101,
        0x105
    ];
    // how many iterations (1 for des, 3 for triple des)
    // changed by Paul 16/6/2007 to use Triple DES for 9+ byte keys
    var iterations = key.length() > 8 ? 3 : 1;
    // stores the return keys
    var keys = [];
    // now define the left shifts which need to be done
    var shifts = [
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0
    ];
    var n = 0, tmp;
    for(var j = 0; j < iterations; j++){
        var left = key.getInt32();
        var right = key.getInt32();
        tmp = (left >>> 4 ^ right) & 0x0f0f0f0f;
        right ^= tmp;
        left ^= tmp << 4;
        tmp = (right >>> -16 ^ left) & 0x0000ffff;
        left ^= tmp;
        right ^= tmp << -16;
        tmp = (left >>> 2 ^ right) & 0x33333333;
        right ^= tmp;
        left ^= tmp << 2;
        tmp = (right >>> -16 ^ left) & 0x0000ffff;
        left ^= tmp;
        right ^= tmp << -16;
        tmp = (left >>> 1 ^ right) & 0x55555555;
        right ^= tmp;
        left ^= tmp << 1;
        tmp = (right >>> 8 ^ left) & 0x00ff00ff;
        left ^= tmp;
        right ^= tmp << 8;
        tmp = (left >>> 1 ^ right) & 0x55555555;
        right ^= tmp;
        left ^= tmp << 1;
        // right needs to be shifted and OR'd with last four bits of left
        tmp = left << 8 | right >>> 20 & 0x000000f0;
        // left needs to be put upside down
        left = right << 24 | right << 8 & 0xff0000 | right >>> 8 & 0xff00 | right >>> 24 & 0xf0;
        right = tmp;
        // now go through and perform these shifts on the left and right keys
        for(var i = 0; i < shifts.length; ++i){
            //shift the keys either one or two bits to the left
            if (shifts[i]) {
                left = left << 2 | left >>> 26;
                right = right << 2 | right >>> 26;
            } else {
                left = left << 1 | left >>> 27;
                right = right << 1 | right >>> 27;
            }
            left &= -15;
            right &= -15;
            // now apply PC-2, in such a way that E is easier when encrypting or
            // decrypting this conversion will look like PC-2 except only the last 6
            // bits of each byte are used rather than 48 consecutive bits and the
            // order of lines will be according to how the S selection functions will
            // be applied: S2, S4, S6, S8, S1, S3, S5, S7
            var lefttmp = pc2bytes0[left >>> 28] | pc2bytes1[left >>> 24 & 0xf] | pc2bytes2[left >>> 20 & 0xf] | pc2bytes3[left >>> 16 & 0xf] | pc2bytes4[left >>> 12 & 0xf] | pc2bytes5[left >>> 8 & 0xf] | pc2bytes6[left >>> 4 & 0xf];
            var righttmp = pc2bytes7[right >>> 28] | pc2bytes8[right >>> 24 & 0xf] | pc2bytes9[right >>> 20 & 0xf] | pc2bytes10[right >>> 16 & 0xf] | pc2bytes11[right >>> 12 & 0xf] | pc2bytes12[right >>> 8 & 0xf] | pc2bytes13[right >>> 4 & 0xf];
            tmp = (righttmp >>> 16 ^ lefttmp) & 0x0000ffff;
            keys[n++] = lefttmp ^ tmp;
            keys[n++] = righttmp ^ tmp << 16;
        }
    }
    return keys;
}
/**
 * Updates a single block (1 byte) using DES. The update will either
 * encrypt or decrypt the block.
 *
 * @param keys the expanded keys.
 * @param input the input block (an array of 32-bit words).
 * @param output the updated output block.
 * @param decrypt true to decrypt the block, false to encrypt it.
 */ function $8365fff5c67f01d8$var$_updateBlock(keys, input, output, decrypt) {
    // set up loops for single or triple DES
    var iterations = keys.length === 32 ? 3 : 9;
    var looping;
    if (iterations === 3) looping = decrypt ? [
        30,
        -2,
        -2
    ] : [
        0,
        32,
        2
    ];
    else looping = decrypt ? [
        94,
        62,
        -2,
        32,
        64,
        2,
        30,
        -2,
        -2
    ] : [
        0,
        32,
        2,
        62,
        30,
        -2,
        64,
        96,
        2
    ];
    var tmp;
    var left = input[0];
    var right = input[1];
    // first each 64 bit chunk of the message must be permuted according to IP
    tmp = (left >>> 4 ^ right) & 0x0f0f0f0f;
    right ^= tmp;
    left ^= tmp << 4;
    tmp = (left >>> 16 ^ right) & 0x0000ffff;
    right ^= tmp;
    left ^= tmp << 16;
    tmp = (right >>> 2 ^ left) & 0x33333333;
    left ^= tmp;
    right ^= tmp << 2;
    tmp = (right >>> 8 ^ left) & 0x00ff00ff;
    left ^= tmp;
    right ^= tmp << 8;
    tmp = (left >>> 1 ^ right) & 0x55555555;
    right ^= tmp;
    left ^= tmp << 1;
    // rotate left 1 bit
    left = left << 1 | left >>> 31;
    right = right << 1 | right >>> 31;
    for(var j = 0; j < iterations; j += 3){
        var endloop = looping[j + 1];
        var loopinc = looping[j + 2];
        // now go through and perform the encryption or decryption
        for(var i = looping[j]; i != endloop; i += loopinc){
            var right1 = right ^ keys[i];
            var right2 = (right >>> 4 | right << 28) ^ keys[i + 1];
            // passing these bytes through the S selection functions
            tmp = left;
            left = right;
            right = tmp ^ ($8365fff5c67f01d8$var$spfunction2[right1 >>> 24 & 0x3f] | $8365fff5c67f01d8$var$spfunction4[right1 >>> 16 & 0x3f] | $8365fff5c67f01d8$var$spfunction6[right1 >>> 8 & 0x3f] | $8365fff5c67f01d8$var$spfunction8[right1 & 0x3f] | $8365fff5c67f01d8$var$spfunction1[right2 >>> 24 & 0x3f] | $8365fff5c67f01d8$var$spfunction3[right2 >>> 16 & 0x3f] | $8365fff5c67f01d8$var$spfunction5[right2 >>> 8 & 0x3f] | $8365fff5c67f01d8$var$spfunction7[right2 & 0x3f]);
        }
        // unreverse left and right
        tmp = left;
        left = right;
        right = tmp;
    }
    // rotate right 1 bit
    left = left >>> 1 | left << 31;
    right = right >>> 1 | right << 31;
    // now perform IP-1, which is IP in the opposite direction
    tmp = (left >>> 1 ^ right) & 0x55555555;
    right ^= tmp;
    left ^= tmp << 1;
    tmp = (right >>> 8 ^ left) & 0x00ff00ff;
    left ^= tmp;
    right ^= tmp << 8;
    tmp = (right >>> 2 ^ left) & 0x33333333;
    left ^= tmp;
    right ^= tmp << 2;
    tmp = (left >>> 16 ^ right) & 0x0000ffff;
    right ^= tmp;
    left ^= tmp << 16;
    tmp = (left >>> 4 ^ right) & 0x0f0f0f0f;
    right ^= tmp;
    left ^= tmp << 4;
    output[0] = left;
    output[1] = right;
}
/**
 * Deprecated. Instead, use:
 *
 * forge.cipher.createCipher('DES-<mode>', key);
 * forge.cipher.createDecipher('DES-<mode>', key);
 *
 * Creates a deprecated DES cipher object. This object's mode will default to
 * CBC (cipher-block-chaining).
 *
 * The key may be given as a binary-encoded string of bytes or a byte buffer.
 *
 * @param options the options to use.
 *          key the symmetric key to use (64 or 192 bits).
 *          output the buffer to write to.
 *          decrypt true for decryption, false for encryption.
 *          mode the cipher mode to use (default: 'CBC').
 *
 * @return the cipher.
 */ function $8365fff5c67f01d8$var$_createCipher(options) {
    options = options || {};
    var mode = (options.mode || "CBC").toUpperCase();
    var algorithm = "DES-" + mode;
    var cipher;
    if (options.decrypt) cipher = $fz7FM.cipher.createDecipher(algorithm, options.key);
    else cipher = $fz7FM.cipher.createCipher(algorithm, options.key);
    // backwards compatible start API
    var start = cipher.start;
    cipher.start = function(iv, options) {
        // backwards compatibility: support second arg as output buffer
        var output = null;
        if (options instanceof $fz7FM.util.ByteBuffer) {
            output = options;
            options = {};
        }
        options = options || {};
        options.output = output;
        options.iv = iv;
        start.call(cipher, options);
    };
    return cipher;
}

});

parcelRegister("jkn5W", function(module, exports) {
/**
 * Password-Based Key-Derivation Function #2 implementation.
 *
 * See RFC 2898 for details.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2013 Digital Bazaar, Inc.
 */ 
var $9dH9K = parcelRequire("9dH9K");
var $e121ccb8eb02e348$require$Buffer = $9dH9K.Buffer;

var $fz7FM = parcelRequire("fz7FM");
parcelRequire("9YZGj");
parcelRequire("6NNT4");
parcelRequire("gao36");
var $e121ccb8eb02e348$var$pkcs5 = $fz7FM.pkcs5 = $fz7FM.pkcs5 || {};
var $e121ccb8eb02e348$var$crypto;

if ($fz7FM.util.isNodejs && !$fz7FM.options.usePureJavaScript) $e121ccb8eb02e348$var$crypto = (parcelRequire("9dH9K"));
/**
 * Derives a key from a password.
 *
 * @param p the password as a binary-encoded string of bytes.
 * @param s the salt as a binary-encoded string of bytes.
 * @param c the iteration count, a positive integer.
 * @param dkLen the intended length, in bytes, of the derived key,
 *          (max: 2^32 - 1) * hash length of the PRF.
 * @param [md] the message digest (or algorithm identifier as a string) to use
 *          in the PRF, defaults to SHA-1.
 * @param [callback(err, key)] presence triggers asynchronous version, called
 *          once the operation completes.
 *
 * @return the derived key, as a binary-encoded string of bytes, for the
 *           synchronous version (if no callback is specified).
 */ module.exports = $fz7FM.pbkdf2 = $e121ccb8eb02e348$var$pkcs5.pbkdf2 = function(p, s, c, dkLen, md, callback) {
    if (typeof md === "function") {
        callback = md;
        md = null;
    }
    // use native implementation if possible and not disabled, note that
    // some node versions only support SHA-1, others allow digest to be changed
    if ($fz7FM.util.isNodejs && !$fz7FM.options.usePureJavaScript && $e121ccb8eb02e348$var$crypto.pbkdf2 && (md === null || typeof md !== "object") && ($e121ccb8eb02e348$var$crypto.pbkdf2Sync.length > 4 || !md || md === "sha1")) {
        if (typeof md !== "string") // default prf to SHA-1
        md = "sha1";
        p = $e121ccb8eb02e348$require$Buffer.from(p, "binary");
        s = $e121ccb8eb02e348$require$Buffer.from(s, "binary");
        if (!callback) {
            if ($e121ccb8eb02e348$var$crypto.pbkdf2Sync.length === 4) return $e121ccb8eb02e348$var$crypto.pbkdf2Sync(p, s, c, dkLen).toString("binary");
            return $e121ccb8eb02e348$var$crypto.pbkdf2Sync(p, s, c, dkLen, md).toString("binary");
        }
        if ($e121ccb8eb02e348$var$crypto.pbkdf2Sync.length === 4) return $e121ccb8eb02e348$var$crypto.pbkdf2(p, s, c, dkLen, function(err, key) {
            if (err) return callback(err);
            callback(null, key.toString("binary"));
        });
        return $e121ccb8eb02e348$var$crypto.pbkdf2(p, s, c, dkLen, md, function(err, key) {
            if (err) return callback(err);
            callback(null, key.toString("binary"));
        });
    }
    if (typeof md === "undefined" || md === null) // default prf to SHA-1
    md = "sha1";
    if (typeof md === "string") {
        if (!(md in $fz7FM.md.algorithms)) throw new Error("Unknown hash algorithm: " + md);
        md = $fz7FM.md[md].create();
    }
    var hLen = md.digestLength;
    /* 1. If dkLen > (2^32 - 1) * hLen, output "derived key too long" and
    stop. */ if (dkLen > 0xFFFFFFFF * hLen) {
        var err = new Error("Derived key is too long.");
        if (callback) return callback(err);
        throw err;
    }
    /* 2. Let len be the number of hLen-octet blocks in the derived key,
    rounding up, and let r be the number of octets in the last
    block:

    len = CEIL(dkLen / hLen),
    r = dkLen - (len - 1) * hLen. */ var len = Math.ceil(dkLen / hLen);
    var r = dkLen - (len - 1) * hLen;
    /* 3. For each block of the derived key apply the function F defined
    below to the password P, the salt S, the iteration count c, and
    the block index to compute the block:

    T_1 = F(P, S, c, 1),
    T_2 = F(P, S, c, 2),
    ...
    T_len = F(P, S, c, len),

    where the function F is defined as the exclusive-or sum of the
    first c iterates of the underlying pseudorandom function PRF
    applied to the password P and the concatenation of the salt S
    and the block index i:

    F(P, S, c, i) = u_1 XOR u_2 XOR ... XOR u_c

    where

    u_1 = PRF(P, S || INT(i)),
    u_2 = PRF(P, u_1),
    ...
    u_c = PRF(P, u_{c-1}).

    Here, INT(i) is a four-octet encoding of the integer i, most
    significant octet first. */ var prf = $fz7FM.hmac.create();
    prf.start(md, p);
    var dk = "";
    var xor, u_c, u_c1;
    // sync version
    if (!callback) {
        for(var i = 1; i <= len; ++i){
            // PRF(P, S || INT(i)) (first iteration)
            prf.start(null, null);
            prf.update(s);
            prf.update($fz7FM.util.int32ToBytes(i));
            xor = u_c1 = prf.digest().getBytes();
            // PRF(P, u_{c-1}) (other iterations)
            for(var j = 2; j <= c; ++j){
                prf.start(null, null);
                prf.update(u_c1);
                u_c = prf.digest().getBytes();
                // F(p, s, c, i)
                xor = $fz7FM.util.xorBytes(xor, u_c, hLen);
                u_c1 = u_c;
            }
            /* 4. Concatenate the blocks and extract the first dkLen octets to
        produce a derived key DK:

        DK = T_1 || T_2 ||  ...  || T_len<0..r-1> */ dk += i < len ? xor : xor.substr(0, r);
        }
        /* 5. Output the derived key DK. */ return dk;
    }
    // async version
    var i = 1, j;
    function outer() {
        if (i > len) // done
        return callback(null, dk);
        // PRF(P, S || INT(i)) (first iteration)
        prf.start(null, null);
        prf.update(s);
        prf.update($fz7FM.util.int32ToBytes(i));
        xor = u_c1 = prf.digest().getBytes();
        // PRF(P, u_{c-1}) (other iterations)
        j = 2;
        inner();
    }
    function inner() {
        if (j <= c) {
            prf.start(null, null);
            prf.update(u_c1);
            u_c = prf.digest().getBytes();
            // F(p, s, c, i)
            xor = $fz7FM.util.xorBytes(xor, u_c, hLen);
            u_c1 = u_c;
            ++j;
            return $fz7FM.util.setImmediate(inner);
        }
        /* 4. Concatenate the blocks and extract the first dkLen octets to
      produce a derived key DK:

      DK = T_1 || T_2 ||  ...  || T_len<0..r-1> */ dk += i < len ? xor : xor.substr(0, r);
        ++i;
        outer();
    }
    outer();
};

});

parcelRegister("a65r1", function(module, exports) {
/**
 * An API for getting cryptographically-secure random bytes. The bytes are
 * generated using the Fortuna algorithm devised by Bruce Schneier and
 * Niels Ferguson.
 *
 * Getting strong random bytes is not yet easy to do in javascript. The only
 * truish random entropy that can be collected is from the mouse, keyboard, or
 * from timing with respect to page loads, etc. This generator makes a poor
 * attempt at providing random bytes when those sources haven't yet provided
 * enough entropy to initially seed or to reseed the PRNG.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2009-2014 Digital Bazaar, Inc.
 */ 
var $fz7FM = parcelRequire("fz7FM");
parcelRequire("60qK1");
parcelRequire("go2xp");
parcelRequire("aQ9s6");
parcelRequire("gao36");
(function() {
    // forge.random already defined
    if ($fz7FM.random && $fz7FM.random.getBytes) {
        module.exports = $fz7FM.random;
        return;
    }
    (function(jQuery1) {
        // the default prng plugin, uses AES-128
        var prng_aes = {};
        var _prng_aes_output = new Array(4);
        var _prng_aes_buffer = $fz7FM.util.createBuffer();
        prng_aes.formatKey = function(key) {
            // convert the key into 32-bit integers
            var tmp = $fz7FM.util.createBuffer(key);
            key = new Array(4);
            key[0] = tmp.getInt32();
            key[1] = tmp.getInt32();
            key[2] = tmp.getInt32();
            key[3] = tmp.getInt32();
            // return the expanded key
            return $fz7FM.aes._expandKey(key, false);
        };
        prng_aes.formatSeed = function(seed) {
            // convert seed into 32-bit integers
            var tmp = $fz7FM.util.createBuffer(seed);
            seed = new Array(4);
            seed[0] = tmp.getInt32();
            seed[1] = tmp.getInt32();
            seed[2] = tmp.getInt32();
            seed[3] = tmp.getInt32();
            return seed;
        };
        prng_aes.cipher = function(key, seed) {
            $fz7FM.aes._updateBlock(key, seed, _prng_aes_output, false);
            _prng_aes_buffer.putInt32(_prng_aes_output[0]);
            _prng_aes_buffer.putInt32(_prng_aes_output[1]);
            _prng_aes_buffer.putInt32(_prng_aes_output[2]);
            _prng_aes_buffer.putInt32(_prng_aes_output[3]);
            return _prng_aes_buffer.getBytes();
        };
        prng_aes.increment = function(seed) {
            // FIXME: do we care about carry or signed issues?
            ++seed[3];
            return seed;
        };
        prng_aes.md = $fz7FM.md.sha256;
        /**
 * Creates a new PRNG.
 */ function spawnPrng() {
            var ctx = $fz7FM.prng.create(prng_aes);
            /**
   * Gets random bytes. If a native secure crypto API is unavailable, this
   * method tries to make the bytes more unpredictable by drawing from data that
   * can be collected from the user of the browser, eg: mouse movement.
   *
   * If a callback is given, this method will be called asynchronously.
   *
   * @param count the number of random bytes to get.
   * @param [callback(err, bytes)] called once the operation completes.
   *
   * @return the random bytes in a string.
   */ ctx.getBytes = function(count, callback) {
                return ctx.generate(count, callback);
            };
            /**
   * Gets random bytes asynchronously. If a native secure crypto API is
   * unavailable, this method tries to make the bytes more unpredictable by
   * drawing from data that can be collected from the user of the browser,
   * eg: mouse movement.
   *
   * @param count the number of random bytes to get.
   *
   * @return the random bytes in a string.
   */ ctx.getBytesSync = function(count) {
                return ctx.generate(count);
            };
            return ctx;
        }
        // create default prng context
        var _ctx = spawnPrng();
        // add other sources of entropy only if window.crypto.getRandomValues is not
        // available -- otherwise this source will be automatically used by the prng
        var getRandomValues = null;
        var globalScope = $fz7FM.util.globalScope;
        var _crypto = globalScope.crypto || globalScope.msCrypto;
        if (_crypto && _crypto.getRandomValues) getRandomValues = function getRandomValues(arr) {
            return _crypto.getRandomValues(arr);
        };
        if ($fz7FM.options.usePureJavaScript || !$fz7FM.util.isNodejs && !getRandomValues) {
            // if this is a web worker, do not use weak entropy, instead register to
            // receive strong entropy asynchronously from the main thread
            typeof window === "undefined" || window.document;
            // get load time entropy
            _ctx.collectInt(+new Date(), 32);
            // add some entropy from navigator object
            if (typeof navigator !== "undefined") {
                var _navBytes = "";
                for(var key in navigator)try {
                    if (typeof navigator[key] == "string") _navBytes += navigator[key];
                } catch (e) {
                /* Some navigator keys might not be accessible, e.g. the geolocation
          attribute throws an exception if touched in Mozilla chrome://
          context.

          Silently ignore this and just don't use this as a source of
          entropy. */ }
                _ctx.collect(_navBytes);
                _navBytes = null;
            }
            // add mouse and keyboard collectors if jquery is available
            if (jQuery1) {
                // set up mouse entropy capture
                jQuery1().mousemove(function(e) {
                    // add mouse coords
                    _ctx.collectInt(e.clientX, 16);
                    _ctx.collectInt(e.clientY, 16);
                });
                // set up keyboard entropy capture
                jQuery1().keypress(function(e) {
                    _ctx.collectInt(e.charCode, 8);
                });
            }
        }
        /* Random API */ if (!$fz7FM.random) $fz7FM.random = _ctx;
        else // extend forge.random with _ctx
        for(var key in _ctx)$fz7FM.random[key] = _ctx[key];
        // expose spawn PRNG
        $fz7FM.random.createInstance = spawnPrng;
        module.exports = $fz7FM.random;
    })(typeof jQuery !== "undefined" ? jQuery : null);
})();

});
parcelRegister("go2xp", function(module, exports) {
/**
 * Secure Hash Algorithm with 256-bit digest (SHA-256) implementation.
 *
 * See FIPS 180-2 for details.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2015 Digital Bazaar, Inc.
 */ 
var $fz7FM = parcelRequire("fz7FM");
parcelRequire("6NNT4");
parcelRequire("gao36");
var $bee0db2e9e1b7221$var$sha256 = module.exports = $fz7FM.sha256 = $fz7FM.sha256 || {};
$fz7FM.md.sha256 = $fz7FM.md.algorithms.sha256 = $bee0db2e9e1b7221$var$sha256;
/**
 * Creates a SHA-256 message digest object.
 *
 * @return a message digest object.
 */ $bee0db2e9e1b7221$var$sha256.create = function() {
    // do initialization as necessary
    if (!$bee0db2e9e1b7221$var$_initialized) $bee0db2e9e1b7221$var$_init();
    // SHA-256 state contains eight 32-bit integers
    var _state = null;
    // input buffer
    var _input = $fz7FM.util.createBuffer();
    // used for word storage
    var _w = new Array(64);
    // message digest object
    var md = {
        algorithm: "sha256",
        blockLength: 64,
        digestLength: 32,
        // 56-bit length of message so far (does not including padding)
        messageLength: 0,
        // true message length
        fullMessageLength: null,
        // size of message length in bytes
        messageLengthSize: 8
    };
    /**
   * Starts the digest.
   *
   * @return this digest object.
   */ md.start = function() {
        // up to 56-bit message length for convenience
        md.messageLength = 0;
        // full message length (set md.messageLength64 for backwards-compatibility)
        md.fullMessageLength = md.messageLength64 = [];
        var int32s = md.messageLengthSize / 4;
        for(var i = 0; i < int32s; ++i)md.fullMessageLength.push(0);
        _input = $fz7FM.util.createBuffer();
        _state = {
            h0: 0x6A09E667,
            h1: 0xBB67AE85,
            h2: 0x3C6EF372,
            h3: 0xA54FF53A,
            h4: 0x510E527F,
            h5: 0x9B05688C,
            h6: 0x1F83D9AB,
            h7: 0x5BE0CD19
        };
        return md;
    };
    // start digest automatically for first time
    md.start();
    /**
   * Updates the digest with the given message input. The given input can
   * treated as raw input (no encoding will be applied) or an encoding of
   * 'utf8' maybe given to encode the input using UTF-8.
   *
   * @param msg the message input to update with.
   * @param encoding the encoding to use (default: 'raw', other: 'utf8').
   *
   * @return this digest object.
   */ md.update = function(msg, encoding) {
        if (encoding === "utf8") msg = $fz7FM.util.encodeUtf8(msg);
        // update message length
        var len = msg.length;
        md.messageLength += len;
        len = [
            len / 0x100000000 >>> 0,
            len >>> 0
        ];
        for(var i = md.fullMessageLength.length - 1; i >= 0; --i){
            md.fullMessageLength[i] += len[1];
            len[1] = len[0] + (md.fullMessageLength[i] / 0x100000000 >>> 0);
            md.fullMessageLength[i] = md.fullMessageLength[i] >>> 0;
            len[0] = len[1] / 0x100000000 >>> 0;
        }
        // add bytes to input buffer
        _input.putBytes(msg);
        // process bytes
        $bee0db2e9e1b7221$var$_update(_state, _w, _input);
        // compact input buffer every 2K or if empty
        if (_input.read > 2048 || _input.length() === 0) _input.compact();
        return md;
    };
    /**
   * Produces the digest.
   *
   * @return a byte buffer containing the digest value.
   */ md.digest = function() {
        /* Note: Here we copy the remaining bytes in the input buffer and
    add the appropriate SHA-256 padding. Then we do the final update
    on a copy of the state so that if the user wants to get
    intermediate digests they can do so. */ /* Determine the number of bytes that must be added to the message
    to ensure its length is congruent to 448 mod 512. In other words,
    the data to be digested must be a multiple of 512 bits (or 128 bytes).
    This data includes the message, some padding, and the length of the
    message. Since the length of the message will be encoded as 8 bytes (64
    bits), that means that the last segment of the data must have 56 bytes
    (448 bits) of message and padding. Therefore, the length of the message
    plus the padding must be congruent to 448 mod 512 because
    512 - 128 = 448.

    In order to fill up the message length it must be filled with
    padding that begins with 1 bit followed by all 0 bits. Padding
    must *always* be present, so if the message length is already
    congruent to 448 mod 512, then 512 padding bits must be added. */ var finalBlock = $fz7FM.util.createBuffer();
        finalBlock.putBytes(_input.bytes());
        // compute remaining size to be digested (include message length size)
        var remaining = md.fullMessageLength[md.fullMessageLength.length - 1] + md.messageLengthSize;
        // add padding for overflow blockSize - overflow
        // _padding starts with 1 byte with first bit is set (byte value 128), then
        // there may be up to (blockSize - 1) other pad bytes
        var overflow = remaining & md.blockLength - 1;
        finalBlock.putBytes($bee0db2e9e1b7221$var$_padding.substr(0, md.blockLength - overflow));
        // serialize message length in bits in big-endian order; since length
        // is stored in bytes we multiply by 8 and add carry from next int
        var next, carry;
        var bits = md.fullMessageLength[0] * 8;
        for(var i = 0; i < md.fullMessageLength.length - 1; ++i){
            next = md.fullMessageLength[i + 1] * 8;
            carry = next / 0x100000000 >>> 0;
            bits += carry;
            finalBlock.putInt32(bits >>> 0);
            bits = next >>> 0;
        }
        finalBlock.putInt32(bits);
        var s2 = {
            h0: _state.h0,
            h1: _state.h1,
            h2: _state.h2,
            h3: _state.h3,
            h4: _state.h4,
            h5: _state.h5,
            h6: _state.h6,
            h7: _state.h7
        };
        $bee0db2e9e1b7221$var$_update(s2, _w, finalBlock);
        var rval = $fz7FM.util.createBuffer();
        rval.putInt32(s2.h0);
        rval.putInt32(s2.h1);
        rval.putInt32(s2.h2);
        rval.putInt32(s2.h3);
        rval.putInt32(s2.h4);
        rval.putInt32(s2.h5);
        rval.putInt32(s2.h6);
        rval.putInt32(s2.h7);
        return rval;
    };
    return md;
};
// sha-256 padding bytes not initialized yet
var $bee0db2e9e1b7221$var$_padding = null;
var $bee0db2e9e1b7221$var$_initialized = false;
// table of constants
var $bee0db2e9e1b7221$var$_k = null;
/**
 * Initializes the constant tables.
 */ function $bee0db2e9e1b7221$var$_init() {
    // create padding
    $bee0db2e9e1b7221$var$_padding = String.fromCharCode(128);
    $bee0db2e9e1b7221$var$_padding += $fz7FM.util.fillString(String.fromCharCode(0x00), 64);
    // create K table for SHA-256
    $bee0db2e9e1b7221$var$_k = [
        0x428a2f98,
        0x71374491,
        0xb5c0fbcf,
        0xe9b5dba5,
        0x3956c25b,
        0x59f111f1,
        0x923f82a4,
        0xab1c5ed5,
        0xd807aa98,
        0x12835b01,
        0x243185be,
        0x550c7dc3,
        0x72be5d74,
        0x80deb1fe,
        0x9bdc06a7,
        0xc19bf174,
        0xe49b69c1,
        0xefbe4786,
        0x0fc19dc6,
        0x240ca1cc,
        0x2de92c6f,
        0x4a7484aa,
        0x5cb0a9dc,
        0x76f988da,
        0x983e5152,
        0xa831c66d,
        0xb00327c8,
        0xbf597fc7,
        0xc6e00bf3,
        0xd5a79147,
        0x06ca6351,
        0x14292967,
        0x27b70a85,
        0x2e1b2138,
        0x4d2c6dfc,
        0x53380d13,
        0x650a7354,
        0x766a0abb,
        0x81c2c92e,
        0x92722c85,
        0xa2bfe8a1,
        0xa81a664b,
        0xc24b8b70,
        0xc76c51a3,
        0xd192e819,
        0xd6990624,
        0xf40e3585,
        0x106aa070,
        0x19a4c116,
        0x1e376c08,
        0x2748774c,
        0x34b0bcb5,
        0x391c0cb3,
        0x4ed8aa4a,
        0x5b9cca4f,
        0x682e6ff3,
        0x748f82ee,
        0x78a5636f,
        0x84c87814,
        0x8cc70208,
        0x90befffa,
        0xa4506ceb,
        0xbef9a3f7,
        0xc67178f2
    ];
    // now initialized
    $bee0db2e9e1b7221$var$_initialized = true;
}
/**
 * Updates a SHA-256 state with the given byte buffer.
 *
 * @param s the SHA-256 state to update.
 * @param w the array to use to store words.
 * @param bytes the byte buffer to update with.
 */ function $bee0db2e9e1b7221$var$_update(s, w, bytes) {
    // consume 512 bit (64 byte) chunks
    var t1, t2, s0, s1, ch, maj, i, a, b, c, d, e, f, g, h;
    var len = bytes.length();
    while(len >= 64){
        // the w array will be populated with sixteen 32-bit big-endian words
        // and then extended into 64 32-bit words according to SHA-256
        for(i = 0; i < 16; ++i)w[i] = bytes.getInt32();
        for(; i < 64; ++i){
            // XOR word 2 words ago rot right 17, rot right 19, shft right 10
            t1 = w[i - 2];
            t1 = (t1 >>> 17 | t1 << 15) ^ (t1 >>> 19 | t1 << 13) ^ t1 >>> 10;
            // XOR word 15 words ago rot right 7, rot right 18, shft right 3
            t2 = w[i - 15];
            t2 = (t2 >>> 7 | t2 << 25) ^ (t2 >>> 18 | t2 << 14) ^ t2 >>> 3;
            // sum(t1, word 7 ago, t2, word 16 ago) modulo 2^32
            w[i] = t1 + w[i - 7] + t2 + w[i - 16] | 0;
        }
        // initialize hash value for this chunk
        a = s.h0;
        b = s.h1;
        c = s.h2;
        d = s.h3;
        e = s.h4;
        f = s.h5;
        g = s.h6;
        h = s.h7;
        // round function
        for(i = 0; i < 64; ++i){
            // Sum1(e)
            s1 = (e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7);
            // Ch(e, f, g) (optimized the same way as SHA-1)
            ch = g ^ e & (f ^ g);
            // Sum0(a)
            s0 = (a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10);
            // Maj(a, b, c) (optimized the same way as SHA-1)
            maj = a & b | c & (a ^ b);
            // main algorithm
            t1 = h + s1 + ch + $bee0db2e9e1b7221$var$_k[i] + w[i];
            t2 = s0 + maj;
            h = g;
            g = f;
            f = e;
            // `>>> 0` necessary to avoid iOS/Safari 10 optimization bug
            // can't truncate with `| 0`
            e = d + t1 >>> 0;
            d = c;
            c = b;
            b = a;
            // `>>> 0` necessary to avoid iOS/Safari 10 optimization bug
            // can't truncate with `| 0`
            a = t1 + t2 >>> 0;
        }
        // update hash state
        s.h0 = s.h0 + a | 0;
        s.h1 = s.h1 + b | 0;
        s.h2 = s.h2 + c | 0;
        s.h3 = s.h3 + d | 0;
        s.h4 = s.h4 + e | 0;
        s.h5 = s.h5 + f | 0;
        s.h6 = s.h6 + g | 0;
        s.h7 = s.h7 + h | 0;
        len -= 64;
    }
}

});

parcelRegister("aQ9s6", function(module, exports) {
/**
 * A javascript implementation of a cryptographically-secure
 * Pseudo Random Number Generator (PRNG). The Fortuna algorithm is followed
 * here though the use of SHA-256 is not enforced; when generating an
 * a PRNG context, the hashing algorithm and block cipher used for
 * the generator are specified via a plugin.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2014 Digital Bazaar, Inc.
 */ 
var $9dH9K = parcelRequire("9dH9K");

var $fz7FM = parcelRequire("fz7FM");
parcelRequire("gao36");
var $7e4617bf95899448$var$_crypto = null;

if ($fz7FM.util.isNodejs && !$fz7FM.options.usePureJavaScript && !$9dH9K.versions["node-webkit"]) $7e4617bf95899448$var$_crypto = (parcelRequire("9dH9K"));
/* PRNG API */ var $7e4617bf95899448$var$prng = module.exports = $fz7FM.prng = $fz7FM.prng || {};
/**
 * Creates a new PRNG context.
 *
 * A PRNG plugin must be passed in that will provide:
 *
 * 1. A function that initializes the key and seed of a PRNG context. It
 *   will be given a 16 byte key and a 16 byte seed. Any key expansion
 *   or transformation of the seed from a byte string into an array of
 *   integers (or similar) should be performed.
 * 2. The cryptographic function used by the generator. It takes a key and
 *   a seed.
 * 3. A seed increment function. It takes the seed and returns seed + 1.
 * 4. An api to create a message digest.
 *
 * For an example, see random.js.
 *
 * @param plugin the PRNG plugin to use.
 */ $7e4617bf95899448$var$prng.create = function(plugin) {
    var ctx = {
        plugin: plugin,
        key: null,
        seed: null,
        time: null,
        // number of reseeds so far
        reseeds: 0,
        // amount of data generated so far
        generated: 0,
        // no initial key bytes
        keyBytes: ""
    };
    // create 32 entropy pools (each is a message digest)
    var md = plugin.md;
    var pools = new Array(32);
    for(var i = 0; i < 32; ++i)pools[i] = md.create();
    ctx.pools = pools;
    // entropy pools are written to cyclically, starting at index 0
    ctx.pool = 0;
    /**
   * Generates random bytes. The bytes may be generated synchronously or
   * asynchronously. Web workers must use the asynchronous interface or
   * else the behavior is undefined.
   *
   * @param count the number of random bytes to generate.
   * @param [callback(err, bytes)] called once the operation completes.
   *
   * @return count random bytes as a string.
   */ ctx.generate = function(count, callback) {
        // do synchronously
        if (!callback) return ctx.generateSync(count);
        // simple generator using counter-based CBC
        var cipher = ctx.plugin.cipher;
        var increment = ctx.plugin.increment;
        var formatKey = ctx.plugin.formatKey;
        var formatSeed = ctx.plugin.formatSeed;
        var b = $fz7FM.util.createBuffer();
        // paranoid deviation from Fortuna:
        // reset key for every request to protect previously
        // generated random bytes should the key be discovered;
        // there is no 100ms based reseeding because of this
        // forced reseed for every `generate` call
        ctx.key = null;
        generate();
        function generate(err) {
            if (err) return callback(err);
            // sufficient bytes generated
            if (b.length() >= count) return callback(null, b.getBytes(count));
            // if amount of data generated is greater than 1 MiB, trigger reseed
            if (ctx.generated > 0xfffff) ctx.key = null;
            if (ctx.key === null) // prevent stack overflow
            return $fz7FM.util.nextTick(function() {
                _reseed(generate);
            });
            // generate the random bytes
            var bytes = cipher(ctx.key, ctx.seed);
            ctx.generated += bytes.length;
            b.putBytes(bytes);
            // generate bytes for a new key and seed
            ctx.key = formatKey(cipher(ctx.key, increment(ctx.seed)));
            ctx.seed = formatSeed(cipher(ctx.key, ctx.seed));
            $fz7FM.util.setImmediate(generate);
        }
    };
    /**
   * Generates random bytes synchronously.
   *
   * @param count the number of random bytes to generate.
   *
   * @return count random bytes as a string.
   */ ctx.generateSync = function(count) {
        // simple generator using counter-based CBC
        var cipher = ctx.plugin.cipher;
        var increment = ctx.plugin.increment;
        var formatKey = ctx.plugin.formatKey;
        var formatSeed = ctx.plugin.formatSeed;
        // paranoid deviation from Fortuna:
        // reset key for every request to protect previously
        // generated random bytes should the key be discovered;
        // there is no 100ms based reseeding because of this
        // forced reseed for every `generateSync` call
        ctx.key = null;
        var b = $fz7FM.util.createBuffer();
        while(b.length() < count){
            // if amount of data generated is greater than 1 MiB, trigger reseed
            if (ctx.generated > 0xfffff) ctx.key = null;
            if (ctx.key === null) _reseedSync();
            // generate the random bytes
            var bytes = cipher(ctx.key, ctx.seed);
            ctx.generated += bytes.length;
            b.putBytes(bytes);
            // generate bytes for a new key and seed
            ctx.key = formatKey(cipher(ctx.key, increment(ctx.seed)));
            ctx.seed = formatSeed(cipher(ctx.key, ctx.seed));
        }
        return b.getBytes(count);
    };
    /**
   * Private function that asynchronously reseeds a generator.
   *
   * @param callback(err) called once the operation completes.
   */ function _reseed(callback) {
        if (ctx.pools[0].messageLength >= 32) {
            _seed();
            return callback();
        }
        // not enough seed data...
        var needed = 32 - ctx.pools[0].messageLength << 5;
        ctx.seedFile(needed, function(err, bytes) {
            if (err) return callback(err);
            ctx.collect(bytes);
            _seed();
            callback();
        });
    }
    /**
   * Private function that synchronously reseeds a generator.
   */ function _reseedSync() {
        if (ctx.pools[0].messageLength >= 32) return _seed();
        // not enough seed data...
        var needed = 32 - ctx.pools[0].messageLength << 5;
        ctx.collect(ctx.seedFileSync(needed));
        _seed();
    }
    /**
   * Private function that seeds a generator once enough bytes are available.
   */ function _seed() {
        // update reseed count
        ctx.reseeds = ctx.reseeds === 0xffffffff ? 0 : ctx.reseeds + 1;
        // goal is to update `key` via:
        // key = hash(key + s)
        //   where 's' is all collected entropy from selected pools, then...
        // create a plugin-based message digest
        var md = ctx.plugin.md.create();
        // consume current key bytes
        md.update(ctx.keyBytes);
        // digest the entropy of pools whose index k meet the
        // condition 'n mod 2^k == 0' where n is the number of reseeds
        var _2powK = 1;
        for(var k = 0; k < 32; ++k){
            if (ctx.reseeds % _2powK === 0) {
                md.update(ctx.pools[k].digest().getBytes());
                ctx.pools[k].start();
            }
            _2powK = _2powK << 1;
        }
        // get digest for key bytes
        ctx.keyBytes = md.digest().getBytes();
        // paranoid deviation from Fortuna:
        // update `seed` via `seed = hash(key)`
        // instead of initializing to zero once and only
        // ever incrementing it
        md.start();
        md.update(ctx.keyBytes);
        var seedBytes = md.digest().getBytes();
        // update state
        ctx.key = ctx.plugin.formatKey(ctx.keyBytes);
        ctx.seed = ctx.plugin.formatSeed(seedBytes);
        ctx.generated = 0;
    }
    /**
   * The built-in default seedFile. This seedFile is used when entropy
   * is needed immediately.
   *
   * @param needed the number of bytes that are needed.
   *
   * @return the random bytes.
   */ function defaultSeedFile(needed) {
        // use window.crypto.getRandomValues strong source of entropy if available
        var getRandomValues = null;
        var globalScope = $fz7FM.util.globalScope;
        var _crypto = globalScope.crypto || globalScope.msCrypto;
        if (_crypto && _crypto.getRandomValues) getRandomValues = function getRandomValues(arr) {
            return _crypto.getRandomValues(arr);
        };
        var b = $fz7FM.util.createBuffer();
        if (getRandomValues) while(b.length() < needed){
            // max byte length is 65536 before QuotaExceededError is thrown
            // http://www.w3.org/TR/WebCryptoAPI/#RandomSource-method-getRandomValues
            var count = Math.max(1, Math.min(needed - b.length(), 65536) / 4);
            var entropy = new Uint32Array(Math.floor(count));
            try {
                getRandomValues(entropy);
                for(var i = 0; i < entropy.length; ++i)b.putInt32(entropy[i]);
            } catch (e) {
                /* only ignore QuotaExceededError */ if (!(typeof QuotaExceededError !== "undefined" && e instanceof QuotaExceededError)) throw e;
            }
        }
        // be sad and add some weak random data
        if (b.length() < needed) {
            /* Draws from Park-Miller "minimal standard" 31 bit PRNG,
      implemented with David G. Carta's optimization: with 32 bit math
      and without division (Public Domain). */ var hi, lo, next;
            var seed = Math.floor(Math.random() * 0x010000);
            while(b.length() < needed){
                lo = 16807 * (seed & 0xFFFF);
                hi = 16807 * (seed >> 16);
                lo += (hi & 0x7FFF) << 16;
                lo += hi >> 15;
                lo = (lo & 0x7FFFFFFF) + (lo >> 31);
                seed = lo & 0xFFFFFFFF;
                // consume lower 3 bytes of seed
                for(var i = 0; i < 3; ++i){
                    // throw in more pseudo random
                    next = seed >>> (i << 3);
                    next ^= Math.floor(Math.random() * 0x0100);
                    b.putByte(next & 0xFF);
                }
            }
        }
        return b.getBytes(needed);
    }
    // initialize seed file APIs
    if ($7e4617bf95899448$var$_crypto) {
        // use nodejs async API
        ctx.seedFile = function(needed, callback) {
            $7e4617bf95899448$var$_crypto.randomBytes(needed, function(err, bytes) {
                if (err) return callback(err);
                callback(null, bytes.toString());
            });
        };
        // use nodejs sync API
        ctx.seedFileSync = function(needed) {
            return $7e4617bf95899448$var$_crypto.randomBytes(needed).toString();
        };
    } else {
        ctx.seedFile = function(needed, callback) {
            try {
                callback(null, defaultSeedFile(needed));
            } catch (e) {
                callback(e);
            }
        };
        ctx.seedFileSync = defaultSeedFile;
    }
    /**
   * Adds entropy to a prng ctx's accumulator.
   *
   * @param bytes the bytes of entropy as a string.
   */ ctx.collect = function(bytes) {
        // iterate over pools distributing entropy cyclically
        var count = bytes.length;
        for(var i = 0; i < count; ++i){
            ctx.pools[ctx.pool].update(bytes.substr(i, 1));
            ctx.pool = ctx.pool === 31 ? 0 : ctx.pool + 1;
        }
    };
    /**
   * Collects an integer of n bits.
   *
   * @param i the integer entropy.
   * @param n the number of bits in the integer.
   */ ctx.collectInt = function(i, n) {
        var bytes = "";
        for(var x = 0; x < n; x += 8)bytes += String.fromCharCode(i >> x & 0xFF);
        ctx.collect(bytes);
    };
    /**
   * Registers a Web Worker to receive immediate entropy from the main thread.
   * This method is required until Web Workers can access the native crypto
   * API. This method should be called twice for each created worker, once in
   * the main thread, and once in the worker itself.
   *
   * @param worker the worker to register.
   */ ctx.registerWorker = function(worker) {
        // worker receives random bytes
        if (worker === self) ctx.seedFile = function(needed, callback) {
            function listener(e) {
                var data = e.data;
                if (data.forge && data.forge.prng) {
                    self.removeEventListener("message", listener);
                    callback(data.forge.prng.err, data.forge.prng.bytes);
                }
            }
            self.addEventListener("message", listener);
            self.postMessage({
                forge: {
                    prng: {
                        needed: needed
                    }
                }
            });
        };
        else {
            // main thread sends random bytes upon request
            var listener = function listener(e) {
                var data = e.data;
                if (data.forge && data.forge.prng) ctx.seedFile(data.forge.prng.needed, function(err, bytes) {
                    worker.postMessage({
                        forge: {
                            prng: {
                                err: err,
                                bytes: bytes
                            }
                        }
                    });
                });
            };
            // TODO: do we need to remove the event listener when the worker dies?
            worker.addEventListener("message", listener);
        }
    };
    return ctx;
};

});


parcelRegister("3231S", function(module, exports) {
/**
 * RC2 implementation.
 *
 * @author Stefan Siegl
 *
 * Copyright (c) 2012 Stefan Siegl <stesie@brokenpipe.de>
 *
 * Information on the RC2 cipher is available from RFC #2268,
 * http://www.ietf.org/rfc/rfc2268.txt
 */ 
var $fz7FM = parcelRequire("fz7FM");
parcelRequire("gao36");
var $2353e88eb6b56834$var$piTable = [
    0xd9,
    0x78,
    0xf9,
    0xc4,
    0x19,
    0xdd,
    0xb5,
    0xed,
    0x28,
    0xe9,
    0xfd,
    0x79,
    0x4a,
    0xa0,
    0xd8,
    0x9d,
    0xc6,
    0x7e,
    0x37,
    0x83,
    0x2b,
    0x76,
    0x53,
    0x8e,
    0x62,
    0x4c,
    0x64,
    0x88,
    0x44,
    0x8b,
    0xfb,
    0xa2,
    0x17,
    0x9a,
    0x59,
    0xf5,
    0x87,
    0xb3,
    0x4f,
    0x13,
    0x61,
    0x45,
    0x6d,
    0x8d,
    0x09,
    0x81,
    0x7d,
    0x32,
    0xbd,
    0x8f,
    0x40,
    0xeb,
    0x86,
    0xb7,
    0x7b,
    0x0b,
    0xf0,
    0x95,
    0x21,
    0x22,
    0x5c,
    0x6b,
    0x4e,
    0x82,
    0x54,
    0xd6,
    0x65,
    0x93,
    0xce,
    0x60,
    0xb2,
    0x1c,
    0x73,
    0x56,
    0xc0,
    0x14,
    0xa7,
    0x8c,
    0xf1,
    0xdc,
    0x12,
    0x75,
    0xca,
    0x1f,
    0x3b,
    0xbe,
    0xe4,
    0xd1,
    0x42,
    0x3d,
    0xd4,
    0x30,
    0xa3,
    0x3c,
    0xb6,
    0x26,
    0x6f,
    0xbf,
    0x0e,
    0xda,
    0x46,
    0x69,
    0x07,
    0x57,
    0x27,
    0xf2,
    0x1d,
    0x9b,
    0xbc,
    0x94,
    0x43,
    0x03,
    0xf8,
    0x11,
    0xc7,
    0xf6,
    0x90,
    0xef,
    0x3e,
    0xe7,
    0x06,
    0xc3,
    0xd5,
    0x2f,
    0xc8,
    0x66,
    0x1e,
    0xd7,
    0x08,
    0xe8,
    0xea,
    0xde,
    0x80,
    0x52,
    0xee,
    0xf7,
    0x84,
    0xaa,
    0x72,
    0xac,
    0x35,
    0x4d,
    0x6a,
    0x2a,
    0x96,
    0x1a,
    0xd2,
    0x71,
    0x5a,
    0x15,
    0x49,
    0x74,
    0x4b,
    0x9f,
    0xd0,
    0x5e,
    0x04,
    0x18,
    0xa4,
    0xec,
    0xc2,
    0xe0,
    0x41,
    0x6e,
    0x0f,
    0x51,
    0xcb,
    0xcc,
    0x24,
    0x91,
    0xaf,
    0x50,
    0xa1,
    0xf4,
    0x70,
    0x39,
    0x99,
    0x7c,
    0x3a,
    0x85,
    0x23,
    0xb8,
    0xb4,
    0x7a,
    0xfc,
    0x02,
    0x36,
    0x5b,
    0x25,
    0x55,
    0x97,
    0x31,
    0x2d,
    0x5d,
    0xfa,
    0x98,
    0xe3,
    0x8a,
    0x92,
    0xae,
    0x05,
    0xdf,
    0x29,
    0x10,
    0x67,
    0x6c,
    0xba,
    0xc9,
    0xd3,
    0x00,
    0xe6,
    0xcf,
    0xe1,
    0x9e,
    0xa8,
    0x2c,
    0x63,
    0x16,
    0x01,
    0x3f,
    0x58,
    0xe2,
    0x89,
    0xa9,
    0x0d,
    0x38,
    0x34,
    0x1b,
    0xab,
    0x33,
    0xff,
    0xb0,
    0xbb,
    0x48,
    0x0c,
    0x5f,
    0xb9,
    0xb1,
    0xcd,
    0x2e,
    0xc5,
    0xf3,
    0xdb,
    0x47,
    0xe5,
    0xa5,
    0x9c,
    0x77,
    0x0a,
    0xa6,
    0x20,
    0x68,
    0xfe,
    0x7f,
    0xc1,
    0xad
];
var $2353e88eb6b56834$var$s = [
    1,
    2,
    3,
    5
];
/**
 * Rotate a word left by given number of bits.
 *
 * Bits that are shifted out on the left are put back in on the right
 * hand side.
 *
 * @param word The word to shift left.
 * @param bits The number of bits to shift by.
 * @return The rotated word.
 */ var $2353e88eb6b56834$var$rol = function rol(word, bits) {
    return word << bits & 0xffff | (word & 0xffff) >> 16 - bits;
};
/**
 * Rotate a word right by given number of bits.
 *
 * Bits that are shifted out on the right are put back in on the left
 * hand side.
 *
 * @param word The word to shift right.
 * @param bits The number of bits to shift by.
 * @return The rotated word.
 */ var $2353e88eb6b56834$var$ror = function ror(word, bits) {
    return (word & 0xffff) >> bits | word << 16 - bits & 0xffff;
};
/* RC2 API */ module.exports = $fz7FM.rc2 = $fz7FM.rc2 || {};
/**
 * Perform RC2 key expansion as per RFC #2268, section 2.
 *
 * @param key variable-length user key (between 1 and 128 bytes)
 * @param effKeyBits number of effective key bits (default: 128)
 * @return the expanded RC2 key (ByteBuffer of 128 bytes)
 */ $fz7FM.rc2.expandKey = function(key, effKeyBits) {
    if (typeof key === "string") key = $fz7FM.util.createBuffer(key);
    effKeyBits = effKeyBits || 128;
    /* introduce variables that match the names used in RFC #2268 */ var L = key;
    var T = key.length();
    var T1 = effKeyBits;
    var T8 = Math.ceil(T1 / 8);
    var TM = 0xff >> (T1 & 0x07);
    var i;
    for(i = T; i < 128; i++)L.putByte($2353e88eb6b56834$var$piTable[L.at(i - 1) + L.at(i - T) & 0xff]);
    L.setAt(128 - T8, $2353e88eb6b56834$var$piTable[L.at(128 - T8) & TM]);
    for(i = 127 - T8; i >= 0; i--)L.setAt(i, $2353e88eb6b56834$var$piTable[L.at(i + 1) ^ L.at(i + T8)]);
    return L;
};
/**
 * Creates a RC2 cipher object.
 *
 * @param key the symmetric key to use (as base for key generation).
 * @param bits the number of effective key bits.
 * @param encrypt false for decryption, true for encryption.
 *
 * @return the cipher.
 */ var $2353e88eb6b56834$var$createCipher = function createCipher(key, bits, encrypt) {
    var _finish = false, _input = null, _output = null, _iv = null;
    var mixRound, mashRound;
    var i, j, K = [];
    /* Expand key and fill into K[] Array */ key = $fz7FM.rc2.expandKey(key, bits);
    for(i = 0; i < 64; i++)K.push(key.getInt16Le());
    if (encrypt) {
        /**
     * Perform one mixing round "in place".
     *
     * @param R Array of four words to perform mixing on.
     */ mixRound = function mixRound(R) {
            for(i = 0; i < 4; i++){
                R[i] += K[j] + (R[(i + 3) % 4] & R[(i + 2) % 4]) + (~R[(i + 3) % 4] & R[(i + 1) % 4]);
                R[i] = $2353e88eb6b56834$var$rol(R[i], $2353e88eb6b56834$var$s[i]);
                j++;
            }
        };
        /**
     * Perform one mashing round "in place".
     *
     * @param R Array of four words to perform mashing on.
     */ mashRound = function mashRound(R) {
            for(i = 0; i < 4; i++)R[i] += K[R[(i + 3) % 4] & 63];
        };
    } else {
        /**
     * Perform one r-mixing round "in place".
     *
     * @param R Array of four words to perform mixing on.
     */ mixRound = function mixRound(R) {
            for(i = 3; i >= 0; i--){
                R[i] = $2353e88eb6b56834$var$ror(R[i], $2353e88eb6b56834$var$s[i]);
                R[i] -= K[j] + (R[(i + 3) % 4] & R[(i + 2) % 4]) + (~R[(i + 3) % 4] & R[(i + 1) % 4]);
                j--;
            }
        };
        /**
     * Perform one r-mashing round "in place".
     *
     * @param R Array of four words to perform mashing on.
     */ mashRound = function mashRound(R) {
            for(i = 3; i >= 0; i--)R[i] -= K[R[(i + 3) % 4] & 63];
        };
    }
    /**
   * Run the specified cipher execution plan.
   *
   * This function takes four words from the input buffer, applies the IV on
   * it (if requested) and runs the provided execution plan.
   *
   * The plan must be put together in form of a array of arrays.  Where the
   * outer one is simply a list of steps to perform and the inner one needs
   * to have two elements: the first one telling how many rounds to perform,
   * the second one telling what to do (i.e. the function to call).
   *
   * @param {Array} plan The plan to execute.
   */ var runPlan = function runPlan(plan) {
        var R = [];
        /* Get data from input buffer and fill the four words into R */ for(i = 0; i < 4; i++){
            var val = _input.getInt16Le();
            if (_iv !== null) {
                if (encrypt) /* We're encrypting, apply the IV first. */ val ^= _iv.getInt16Le();
                else /* We're decryption, keep cipher text for next block. */ _iv.putInt16Le(val);
            }
            R.push(val & 0xffff);
        }
        /* Reset global "j" variable as per spec. */ j = encrypt ? 0 : 63;
        /* Run execution plan. */ for(var ptr = 0; ptr < plan.length; ptr++)for(var ctr = 0; ctr < plan[ptr][0]; ctr++)plan[ptr][1](R);
        /* Write back result to output buffer. */ for(i = 0; i < 4; i++){
            if (_iv !== null) {
                if (encrypt) /* We're encrypting in CBC-mode, feed back encrypted bytes into
             IV buffer to carry it forward to next block. */ _iv.putInt16Le(R[i]);
                else R[i] ^= _iv.getInt16Le();
            }
            _output.putInt16Le(R[i]);
        }
    };
    /* Create cipher object */ var cipher = null;
    cipher = {
        /**
     * Starts or restarts the encryption or decryption process, whichever
     * was previously configured.
     *
     * To use the cipher in CBC mode, iv may be given either as a string
     * of bytes, or as a byte buffer.  For ECB mode, give null as iv.
     *
     * @param iv the initialization vector to use, null for ECB mode.
     * @param output the output the buffer to write to, null to create one.
     */ start: function start(iv, output) {
            if (iv) /* CBC mode */ {
                if (typeof iv === "string") iv = $fz7FM.util.createBuffer(iv);
            }
            _finish = false;
            _input = $fz7FM.util.createBuffer();
            _output = output || new $fz7FM.util.createBuffer();
            _iv = iv;
            cipher.output = _output;
        },
        /**
     * Updates the next block.
     *
     * @param input the buffer to read from.
     */ update: function update(input) {
            if (!_finish) // not finishing, so fill the input buffer with more input
            _input.putBuffer(input);
            while(_input.length() >= 8)runPlan([
                [
                    5,
                    mixRound
                ],
                [
                    1,
                    mashRound
                ],
                [
                    6,
                    mixRound
                ],
                [
                    1,
                    mashRound
                ],
                [
                    5,
                    mixRound
                ]
            ]);
        },
        /**
     * Finishes encrypting or decrypting.
     *
     * @param pad a padding function to use, null for PKCS#7 padding,
     *           signature(blockSize, buffer, decrypt).
     *
     * @return true if successful, false on error.
     */ finish: function finish(pad) {
            var rval = true;
            if (encrypt) {
                if (pad) rval = pad(8, _input, !encrypt);
                else {
                    // add PKCS#7 padding to block (each pad byte is the
                    // value of the number of pad bytes)
                    var padding = _input.length() === 8 ? 8 : 8 - _input.length();
                    _input.fillWithByte(padding, padding);
                }
            }
            if (rval) {
                // do final update
                _finish = true;
                cipher.update();
            }
            if (!encrypt) {
                // check for error: input data not a multiple of block size
                rval = _input.length() === 0;
                if (rval) {
                    if (pad) rval = pad(8, _output, !encrypt);
                    else {
                        // ensure padding byte count is valid
                        var len = _output.length();
                        var count = _output.at(len - 1);
                        if (count > len) rval = false;
                        else // trim off padding bytes
                        _output.truncate(count);
                    }
                }
            }
            return rval;
        }
    };
    return cipher;
};
/**
 * Creates an RC2 cipher object to encrypt data in ECB or CBC mode using the
 * given symmetric key. The output will be stored in the 'output' member
 * of the returned cipher.
 *
 * The key and iv may be given as a string of bytes or a byte buffer.
 * The cipher is initialized to use 128 effective key bits.
 *
 * @param key the symmetric key to use.
 * @param iv the initialization vector to use.
 * @param output the buffer to write to, null to create one.
 *
 * @return the cipher.
 */ $fz7FM.rc2.startEncrypting = function(key, iv, output) {
    var cipher = $fz7FM.rc2.createEncryptionCipher(key, 128);
    cipher.start(iv, output);
    return cipher;
};
/**
 * Creates an RC2 cipher object to encrypt data in ECB or CBC mode using the
 * given symmetric key.
 *
 * The key may be given as a string of bytes or a byte buffer.
 *
 * To start encrypting call start() on the cipher with an iv and optional
 * output buffer.
 *
 * @param key the symmetric key to use.
 *
 * @return the cipher.
 */ $fz7FM.rc2.createEncryptionCipher = function(key, bits) {
    return $2353e88eb6b56834$var$createCipher(key, bits, true);
};
/**
 * Creates an RC2 cipher object to decrypt data in ECB or CBC mode using the
 * given symmetric key. The output will be stored in the 'output' member
 * of the returned cipher.
 *
 * The key and iv may be given as a string of bytes or a byte buffer.
 * The cipher is initialized to use 128 effective key bits.
 *
 * @param key the symmetric key to use.
 * @param iv the initialization vector to use.
 * @param output the buffer to write to, null to create one.
 *
 * @return the cipher.
 */ $fz7FM.rc2.startDecrypting = function(key, iv, output) {
    var cipher = $fz7FM.rc2.createDecryptionCipher(key, 128);
    cipher.start(iv, output);
    return cipher;
};
/**
 * Creates an RC2 cipher object to decrypt data in ECB or CBC mode using the
 * given symmetric key.
 *
 * The key may be given as a string of bytes or a byte buffer.
 *
 * To start decrypting call start() on the cipher with an iv and optional
 * output buffer.
 *
 * @param key the symmetric key to use.
 *
 * @return the cipher.
 */ $fz7FM.rc2.createDecryptionCipher = function(key, bits) {
    return $2353e88eb6b56834$var$createCipher(key, bits, false);
};

});

parcelRegister("eRNaT", function(module, exports) {
/**
 * Javascript implementation of basic RSA algorithms.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2014 Digital Bazaar, Inc.
 *
 * The only algorithm currently supported for PKI is RSA.
 *
 * An RSA key is often stored in ASN.1 DER format. The SubjectPublicKeyInfo
 * ASN.1 structure is composed of an algorithm of type AlgorithmIdentifier
 * and a subjectPublicKey of type bit string.
 *
 * The AlgorithmIdentifier contains an Object Identifier (OID) and parameters
 * for the algorithm, if any. In the case of RSA, there aren't any.
 *
 * SubjectPublicKeyInfo ::= SEQUENCE {
 *   algorithm AlgorithmIdentifier,
 *   subjectPublicKey BIT STRING
 * }
 *
 * AlgorithmIdentifer ::= SEQUENCE {
 *   algorithm OBJECT IDENTIFIER,
 *   parameters ANY DEFINED BY algorithm OPTIONAL
 * }
 *
 * For an RSA public key, the subjectPublicKey is:
 *
 * RSAPublicKey ::= SEQUENCE {
 *   modulus            INTEGER,    -- n
 *   publicExponent     INTEGER     -- e
 * }
 *
 * PrivateKeyInfo ::= SEQUENCE {
 *   version                   Version,
 *   privateKeyAlgorithm       PrivateKeyAlgorithmIdentifier,
 *   privateKey                PrivateKey,
 *   attributes           [0]  IMPLICIT Attributes OPTIONAL
 * }
 *
 * Version ::= INTEGER
 * PrivateKeyAlgorithmIdentifier ::= AlgorithmIdentifier
 * PrivateKey ::= OCTET STRING
 * Attributes ::= SET OF Attribute
 *
 * An RSA private key as the following structure:
 *
 * RSAPrivateKey ::= SEQUENCE {
 *   version Version,
 *   modulus INTEGER, -- n
 *   publicExponent INTEGER, -- e
 *   privateExponent INTEGER, -- d
 *   prime1 INTEGER, -- p
 *   prime2 INTEGER, -- q
 *   exponent1 INTEGER, -- d mod (p-1)
 *   exponent2 INTEGER, -- d mod (q-1)
 *   coefficient INTEGER -- (inverse of q) mod p
 * }
 *
 * Version ::= INTEGER
 *
 * The OID for the RSA key algorithm is: 1.2.840.113549.1.1.1
 */ 
var $fz7FM = parcelRequire("fz7FM");
parcelRequire("d4EnE");
parcelRequire("dFOUo");
parcelRequire("dm89c");
parcelRequire("2hbS7");
parcelRequire("lNcH9");
parcelRequire("a65r1");
parcelRequire("gao36");
if (typeof $ad2c28fbd9c82f00$var$BigInteger === "undefined") var $ad2c28fbd9c82f00$var$BigInteger = $fz7FM.jsbn.BigInteger;

var $ad2c28fbd9c82f00$var$_crypto = $fz7FM.util.isNodejs ? (parcelRequire("9dH9K")) : null;
// shortcut for asn.1 API
var $ad2c28fbd9c82f00$var$asn1 = $fz7FM.asn1;
// shortcut for util API
var $ad2c28fbd9c82f00$var$util = $fz7FM.util;
/*
 * RSA encryption and decryption, see RFC 2313.
 */ $fz7FM.pki = $fz7FM.pki || {};
module.exports = $fz7FM.pki.rsa = $fz7FM.rsa = $fz7FM.rsa || {};
var $ad2c28fbd9c82f00$var$pki = $fz7FM.pki;
// for finding primes, which are 30k+i for i = 1, 7, 11, 13, 17, 19, 23, 29
var $ad2c28fbd9c82f00$var$GCD_30_DELTA = [
    6,
    4,
    2,
    4,
    2,
    4,
    6,
    2
];
// validator for a PrivateKeyInfo structure
var $ad2c28fbd9c82f00$var$privateKeyValidator = {
    // PrivateKeyInfo
    name: "PrivateKeyInfo",
    tagClass: $ad2c28fbd9c82f00$var$asn1.Class.UNIVERSAL,
    type: $ad2c28fbd9c82f00$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            // Version (INTEGER)
            name: "PrivateKeyInfo.version",
            tagClass: $ad2c28fbd9c82f00$var$asn1.Class.UNIVERSAL,
            type: $ad2c28fbd9c82f00$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "privateKeyVersion"
        },
        {
            // privateKeyAlgorithm
            name: "PrivateKeyInfo.privateKeyAlgorithm",
            tagClass: $ad2c28fbd9c82f00$var$asn1.Class.UNIVERSAL,
            type: $ad2c28fbd9c82f00$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    name: "AlgorithmIdentifier.algorithm",
                    tagClass: $ad2c28fbd9c82f00$var$asn1.Class.UNIVERSAL,
                    type: $ad2c28fbd9c82f00$var$asn1.Type.OID,
                    constructed: false,
                    capture: "privateKeyOid"
                }
            ]
        },
        {
            // PrivateKey
            name: "PrivateKeyInfo",
            tagClass: $ad2c28fbd9c82f00$var$asn1.Class.UNIVERSAL,
            type: $ad2c28fbd9c82f00$var$asn1.Type.OCTETSTRING,
            constructed: false,
            capture: "privateKey"
        }
    ]
};
// validator for an RSA private key
var $ad2c28fbd9c82f00$var$rsaPrivateKeyValidator = {
    // RSAPrivateKey
    name: "RSAPrivateKey",
    tagClass: $ad2c28fbd9c82f00$var$asn1.Class.UNIVERSAL,
    type: $ad2c28fbd9c82f00$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            // Version (INTEGER)
            name: "RSAPrivateKey.version",
            tagClass: $ad2c28fbd9c82f00$var$asn1.Class.UNIVERSAL,
            type: $ad2c28fbd9c82f00$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "privateKeyVersion"
        },
        {
            // modulus (n)
            name: "RSAPrivateKey.modulus",
            tagClass: $ad2c28fbd9c82f00$var$asn1.Class.UNIVERSAL,
            type: $ad2c28fbd9c82f00$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "privateKeyModulus"
        },
        {
            // publicExponent (e)
            name: "RSAPrivateKey.publicExponent",
            tagClass: $ad2c28fbd9c82f00$var$asn1.Class.UNIVERSAL,
            type: $ad2c28fbd9c82f00$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "privateKeyPublicExponent"
        },
        {
            // privateExponent (d)
            name: "RSAPrivateKey.privateExponent",
            tagClass: $ad2c28fbd9c82f00$var$asn1.Class.UNIVERSAL,
            type: $ad2c28fbd9c82f00$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "privateKeyPrivateExponent"
        },
        {
            // prime1 (p)
            name: "RSAPrivateKey.prime1",
            tagClass: $ad2c28fbd9c82f00$var$asn1.Class.UNIVERSAL,
            type: $ad2c28fbd9c82f00$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "privateKeyPrime1"
        },
        {
            // prime2 (q)
            name: "RSAPrivateKey.prime2",
            tagClass: $ad2c28fbd9c82f00$var$asn1.Class.UNIVERSAL,
            type: $ad2c28fbd9c82f00$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "privateKeyPrime2"
        },
        {
            // exponent1 (d mod (p-1))
            name: "RSAPrivateKey.exponent1",
            tagClass: $ad2c28fbd9c82f00$var$asn1.Class.UNIVERSAL,
            type: $ad2c28fbd9c82f00$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "privateKeyExponent1"
        },
        {
            // exponent2 (d mod (q-1))
            name: "RSAPrivateKey.exponent2",
            tagClass: $ad2c28fbd9c82f00$var$asn1.Class.UNIVERSAL,
            type: $ad2c28fbd9c82f00$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "privateKeyExponent2"
        },
        {
            // coefficient ((inverse of q) mod p)
            name: "RSAPrivateKey.coefficient",
            tagClass: $ad2c28fbd9c82f00$var$asn1.Class.UNIVERSAL,
            type: $ad2c28fbd9c82f00$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "privateKeyCoefficient"
        }
    ]
};
// validator for an RSA public key
var $ad2c28fbd9c82f00$var$rsaPublicKeyValidator = {
    // RSAPublicKey
    name: "RSAPublicKey",
    tagClass: $ad2c28fbd9c82f00$var$asn1.Class.UNIVERSAL,
    type: $ad2c28fbd9c82f00$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            // modulus (n)
            name: "RSAPublicKey.modulus",
            tagClass: $ad2c28fbd9c82f00$var$asn1.Class.UNIVERSAL,
            type: $ad2c28fbd9c82f00$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "publicKeyModulus"
        },
        {
            // publicExponent (e)
            name: "RSAPublicKey.exponent",
            tagClass: $ad2c28fbd9c82f00$var$asn1.Class.UNIVERSAL,
            type: $ad2c28fbd9c82f00$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "publicKeyExponent"
        }
    ]
};
// validator for an SubjectPublicKeyInfo structure
// Note: Currently only works with an RSA public key
var $ad2c28fbd9c82f00$var$publicKeyValidator = $fz7FM.pki.rsa.publicKeyValidator = {
    name: "SubjectPublicKeyInfo",
    tagClass: $ad2c28fbd9c82f00$var$asn1.Class.UNIVERSAL,
    type: $ad2c28fbd9c82f00$var$asn1.Type.SEQUENCE,
    constructed: true,
    captureAsn1: "subjectPublicKeyInfo",
    value: [
        {
            name: "SubjectPublicKeyInfo.AlgorithmIdentifier",
            tagClass: $ad2c28fbd9c82f00$var$asn1.Class.UNIVERSAL,
            type: $ad2c28fbd9c82f00$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    name: "AlgorithmIdentifier.algorithm",
                    tagClass: $ad2c28fbd9c82f00$var$asn1.Class.UNIVERSAL,
                    type: $ad2c28fbd9c82f00$var$asn1.Type.OID,
                    constructed: false,
                    capture: "publicKeyOid"
                }
            ]
        },
        {
            // subjectPublicKey
            name: "SubjectPublicKeyInfo.subjectPublicKey",
            tagClass: $ad2c28fbd9c82f00$var$asn1.Class.UNIVERSAL,
            type: $ad2c28fbd9c82f00$var$asn1.Type.BITSTRING,
            constructed: false,
            value: [
                {
                    // RSAPublicKey
                    name: "SubjectPublicKeyInfo.subjectPublicKey.RSAPublicKey",
                    tagClass: $ad2c28fbd9c82f00$var$asn1.Class.UNIVERSAL,
                    type: $ad2c28fbd9c82f00$var$asn1.Type.SEQUENCE,
                    constructed: true,
                    optional: true,
                    captureAsn1: "rsaPublicKey"
                }
            ]
        }
    ]
};
// validator for a DigestInfo structure
var $ad2c28fbd9c82f00$var$digestInfoValidator = {
    name: "DigestInfo",
    tagClass: $ad2c28fbd9c82f00$var$asn1.Class.UNIVERSAL,
    type: $ad2c28fbd9c82f00$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: "DigestInfo.DigestAlgorithm",
            tagClass: $ad2c28fbd9c82f00$var$asn1.Class.UNIVERSAL,
            type: $ad2c28fbd9c82f00$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    name: "DigestInfo.DigestAlgorithm.algorithmIdentifier",
                    tagClass: $ad2c28fbd9c82f00$var$asn1.Class.UNIVERSAL,
                    type: $ad2c28fbd9c82f00$var$asn1.Type.OID,
                    constructed: false,
                    capture: "algorithmIdentifier"
                },
                {
                    // NULL paramters
                    name: "DigestInfo.DigestAlgorithm.parameters",
                    tagClass: $ad2c28fbd9c82f00$var$asn1.Class.UNIVERSAL,
                    type: $ad2c28fbd9c82f00$var$asn1.Type.NULL,
                    // captured only to check existence for md2 and md5
                    capture: "parameters",
                    optional: true,
                    constructed: false
                }
            ]
        },
        {
            // digest
            name: "DigestInfo.digest",
            tagClass: $ad2c28fbd9c82f00$var$asn1.Class.UNIVERSAL,
            type: $ad2c28fbd9c82f00$var$asn1.Type.OCTETSTRING,
            constructed: false,
            capture: "digest"
        }
    ]
};
/**
 * Wrap digest in DigestInfo object.
 *
 * This function implements EMSA-PKCS1-v1_5-ENCODE as per RFC 3447.
 *
 * DigestInfo ::= SEQUENCE {
 *   digestAlgorithm DigestAlgorithmIdentifier,
 *   digest Digest
 * }
 *
 * DigestAlgorithmIdentifier ::= AlgorithmIdentifier
 * Digest ::= OCTET STRING
 *
 * @param md the message digest object with the hash to sign.
 *
 * @return the encoded message (ready for RSA encrytion)
 */ var $ad2c28fbd9c82f00$var$emsaPkcs1v15encode = function emsaPkcs1v15encode(md) {
    // get the oid for the algorithm
    var oid;
    if (md.algorithm in $ad2c28fbd9c82f00$var$pki.oids) oid = $ad2c28fbd9c82f00$var$pki.oids[md.algorithm];
    else {
        var error = new Error("Unknown message digest algorithm.");
        error.algorithm = md.algorithm;
        throw error;
    }
    var oidBytes = $ad2c28fbd9c82f00$var$asn1.oidToDer(oid).getBytes();
    // create the digest info
    var digestInfo = $ad2c28fbd9c82f00$var$asn1.create($ad2c28fbd9c82f00$var$asn1.Class.UNIVERSAL, $ad2c28fbd9c82f00$var$asn1.Type.SEQUENCE, true, []);
    var digestAlgorithm = $ad2c28fbd9c82f00$var$asn1.create($ad2c28fbd9c82f00$var$asn1.Class.UNIVERSAL, $ad2c28fbd9c82f00$var$asn1.Type.SEQUENCE, true, []);
    digestAlgorithm.value.push($ad2c28fbd9c82f00$var$asn1.create($ad2c28fbd9c82f00$var$asn1.Class.UNIVERSAL, $ad2c28fbd9c82f00$var$asn1.Type.OID, false, oidBytes));
    digestAlgorithm.value.push($ad2c28fbd9c82f00$var$asn1.create($ad2c28fbd9c82f00$var$asn1.Class.UNIVERSAL, $ad2c28fbd9c82f00$var$asn1.Type.NULL, false, ""));
    var digest = $ad2c28fbd9c82f00$var$asn1.create($ad2c28fbd9c82f00$var$asn1.Class.UNIVERSAL, $ad2c28fbd9c82f00$var$asn1.Type.OCTETSTRING, false, md.digest().getBytes());
    digestInfo.value.push(digestAlgorithm);
    digestInfo.value.push(digest);
    // encode digest info
    return $ad2c28fbd9c82f00$var$asn1.toDer(digestInfo).getBytes();
};
/**
 * Performs x^c mod n (RSA encryption or decryption operation).
 *
 * @param x the number to raise and mod.
 * @param key the key to use.
 * @param pub true if the key is public, false if private.
 *
 * @return the result of x^c mod n.
 */ var $ad2c28fbd9c82f00$var$_modPow = function _modPow(x, key, pub) {
    if (pub) return x.modPow(key.e, key.n);
    if (!key.p || !key.q) // allow calculation without CRT params (slow)
    return x.modPow(key.d, key.n);
    // pre-compute dP, dQ, and qInv if necessary
    if (!key.dP) key.dP = key.d.mod(key.p.subtract($ad2c28fbd9c82f00$var$BigInteger.ONE));
    if (!key.dQ) key.dQ = key.d.mod(key.q.subtract($ad2c28fbd9c82f00$var$BigInteger.ONE));
    if (!key.qInv) key.qInv = key.q.modInverse(key.p);
    /* Chinese remainder theorem (CRT) states:

    Suppose n1, n2, ..., nk are positive integers which are pairwise
    coprime (n1 and n2 have no common factors other than 1). For any
    integers x1, x2, ..., xk there exists an integer x solving the
    system of simultaneous congruences (where ~= means modularly
    congruent so a ~= b mod n means a mod n = b mod n):

    x ~= x1 mod n1
    x ~= x2 mod n2
    ...
    x ~= xk mod nk

    This system of congruences has a single simultaneous solution x
    between 0 and n - 1. Furthermore, each xk solution and x itself
    is congruent modulo the product n = n1*n2*...*nk.
    So x1 mod n = x2 mod n = xk mod n = x mod n.

    The single simultaneous solution x can be solved with the following
    equation:

    x = sum(xi*ri*si) mod n where ri = n/ni and si = ri^-1 mod ni.

    Where x is less than n, xi = x mod ni.

    For RSA we are only concerned with k = 2. The modulus n = pq, where
    p and q are coprime. The RSA decryption algorithm is:

    y = x^d mod n

    Given the above:

    x1 = x^d mod p
    r1 = n/p = q
    s1 = q^-1 mod p
    x2 = x^d mod q
    r2 = n/q = p
    s2 = p^-1 mod q

    So y = (x1r1s1 + x2r2s2) mod n
         = ((x^d mod p)q(q^-1 mod p) + (x^d mod q)p(p^-1 mod q)) mod n

    According to Fermat's Little Theorem, if the modulus P is prime,
    for any integer A not evenly divisible by P, A^(P-1) ~= 1 mod P.
    Since A is not divisible by P it follows that if:
    N ~= M mod (P - 1), then A^N mod P = A^M mod P. Therefore:

    A^N mod P = A^(M mod (P - 1)) mod P. (The latter takes less effort
    to calculate). In order to calculate x^d mod p more quickly the
    exponent d mod (p - 1) is stored in the RSA private key (the same
    is done for x^d mod q). These values are referred to as dP and dQ
    respectively. Therefore we now have:

    y = ((x^dP mod p)q(q^-1 mod p) + (x^dQ mod q)p(p^-1 mod q)) mod n

    Since we'll be reducing x^dP by modulo p (same for q) we can also
    reduce x by p (and q respectively) before hand. Therefore, let

    xp = ((x mod p)^dP mod p), and
    xq = ((x mod q)^dQ mod q), yielding:

    y = (xp*q*(q^-1 mod p) + xq*p*(p^-1 mod q)) mod n

    This can be further reduced to a simple algorithm that only
    requires 1 inverse (the q inverse is used) to be used and stored.
    The algorithm is called Garner's algorithm. If qInv is the
    inverse of q, we simply calculate:

    y = (qInv*(xp - xq) mod p) * q + xq

    However, there are two further complications. First, we need to
    ensure that xp > xq to prevent signed BigIntegers from being used
    so we add p until this is true (since we will be mod'ing with
    p anyway). Then, there is a known timing attack on algorithms
    using the CRT. To mitigate this risk, "cryptographic blinding"
    should be used. This requires simply generating a random number r
    between 0 and n-1 and its inverse and multiplying x by r^e before
    calculating y and then multiplying y by r^-1 afterwards. Note that
    r must be coprime with n (gcd(r, n) === 1) in order to have an
    inverse.
  */ // cryptographic blinding
    var r;
    do r = new $ad2c28fbd9c82f00$var$BigInteger($fz7FM.util.bytesToHex($fz7FM.random.getBytes(key.n.bitLength() / 8)), 16);
    while (r.compareTo(key.n) >= 0 || !r.gcd(key.n).equals($ad2c28fbd9c82f00$var$BigInteger.ONE));
    x = x.multiply(r.modPow(key.e, key.n)).mod(key.n);
    // calculate xp and xq
    var xp = x.mod(key.p).modPow(key.dP, key.p);
    var xq = x.mod(key.q).modPow(key.dQ, key.q);
    // xp must be larger than xq to avoid signed bit usage
    while(xp.compareTo(xq) < 0)xp = xp.add(key.p);
    // do last step
    var y = xp.subtract(xq).multiply(key.qInv).mod(key.p).multiply(key.q).add(xq);
    // remove effect of random for cryptographic blinding
    y = y.multiply(r.modInverse(key.n)).mod(key.n);
    return y;
};
/**
 * NOTE: THIS METHOD IS DEPRECATED, use 'sign' on a private key object or
 * 'encrypt' on a public key object instead.
 *
 * Performs RSA encryption.
 *
 * The parameter bt controls whether to put padding bytes before the
 * message passed in. Set bt to either true or false to disable padding
 * completely (in order to handle e.g. EMSA-PSS encoding seperately before),
 * signaling whether the encryption operation is a public key operation
 * (i.e. encrypting data) or not, i.e. private key operation (data signing).
 *
 * For PKCS#1 v1.5 padding pass in the block type to use, i.e. either 0x01
 * (for signing) or 0x02 (for encryption). The key operation mode (private
 * or public) is derived from this flag in that case).
 *
 * @param m the message to encrypt as a byte string.
 * @param key the RSA key to use.
 * @param bt for PKCS#1 v1.5 padding, the block type to use
 *   (0x01 for private key, 0x02 for public),
 *   to disable padding: true = public key, false = private key.
 *
 * @return the encrypted bytes as a string.
 */ $ad2c28fbd9c82f00$var$pki.rsa.encrypt = function(m, key, bt) {
    var pub = bt;
    var eb;
    // get the length of the modulus in bytes
    var k = Math.ceil(key.n.bitLength() / 8);
    if (bt !== false && bt !== true) {
        // legacy, default to PKCS#1 v1.5 padding
        pub = bt === 0x02;
        eb = $ad2c28fbd9c82f00$var$_encodePkcs1_v1_5(m, key, bt);
    } else {
        eb = $fz7FM.util.createBuffer();
        eb.putBytes(m);
    }
    // load encryption block as big integer 'x'
    // FIXME: hex conversion inefficient, get BigInteger w/byte strings
    var x = new $ad2c28fbd9c82f00$var$BigInteger(eb.toHex(), 16);
    // do RSA encryption
    var y = $ad2c28fbd9c82f00$var$_modPow(x, key, pub);
    // convert y into the encrypted data byte string, if y is shorter in
    // bytes than k, then prepend zero bytes to fill up ed
    // FIXME: hex conversion inefficient, get BigInteger w/byte strings
    var yhex = y.toString(16);
    var ed = $fz7FM.util.createBuffer();
    var zeros = k - Math.ceil(yhex.length / 2);
    while(zeros > 0){
        ed.putByte(0x00);
        --zeros;
    }
    ed.putBytes($fz7FM.util.hexToBytes(yhex));
    return ed.getBytes();
};
/**
 * NOTE: THIS METHOD IS DEPRECATED, use 'decrypt' on a private key object or
 * 'verify' on a public key object instead.
 *
 * Performs RSA decryption.
 *
 * The parameter ml controls whether to apply PKCS#1 v1.5 padding
 * or not.  Set ml = false to disable padding removal completely
 * (in order to handle e.g. EMSA-PSS later on) and simply pass back
 * the RSA encryption block.
 *
 * @param ed the encrypted data to decrypt in as a byte string.
 * @param key the RSA key to use.
 * @param pub true for a public key operation, false for private.
 * @param ml the message length, if known, false to disable padding.
 *
 * @return the decrypted message as a byte string.
 */ $ad2c28fbd9c82f00$var$pki.rsa.decrypt = function(ed, key, pub, ml) {
    // get the length of the modulus in bytes
    var k = Math.ceil(key.n.bitLength() / 8);
    // error if the length of the encrypted data ED is not k
    if (ed.length !== k) {
        var error = new Error("Encrypted message length is invalid.");
        error.length = ed.length;
        error.expected = k;
        throw error;
    }
    // convert encrypted data into a big integer
    // FIXME: hex conversion inefficient, get BigInteger w/byte strings
    var y = new $ad2c28fbd9c82f00$var$BigInteger($fz7FM.util.createBuffer(ed).toHex(), 16);
    // y must be less than the modulus or it wasn't the result of
    // a previous mod operation (encryption) using that modulus
    if (y.compareTo(key.n) >= 0) throw new Error("Encrypted message is invalid.");
    // do RSA decryption
    var x = $ad2c28fbd9c82f00$var$_modPow(y, key, pub);
    // create the encryption block, if x is shorter in bytes than k, then
    // prepend zero bytes to fill up eb
    // FIXME: hex conversion inefficient, get BigInteger w/byte strings
    var xhex = x.toString(16);
    var eb = $fz7FM.util.createBuffer();
    var zeros = k - Math.ceil(xhex.length / 2);
    while(zeros > 0){
        eb.putByte(0x00);
        --zeros;
    }
    eb.putBytes($fz7FM.util.hexToBytes(xhex));
    if (ml !== false) // legacy, default to PKCS#1 v1.5 padding
    return $ad2c28fbd9c82f00$var$_decodePkcs1_v1_5(eb.getBytes(), key, pub);
    // return message
    return eb.getBytes();
};
/**
 * Creates an RSA key-pair generation state object. It is used to allow
 * key-generation to be performed in steps. It also allows for a UI to
 * display progress updates.
 *
 * @param bits the size for the private key in bits, defaults to 2048.
 * @param e the public exponent to use, defaults to 65537 (0x10001).
 * @param [options] the options to use.
 *          prng a custom crypto-secure pseudo-random number generator to use,
 *            that must define "getBytesSync".
 *          algorithm the algorithm to use (default: 'PRIMEINC').
 *
 * @return the state object to use to generate the key-pair.
 */ $ad2c28fbd9c82f00$var$pki.rsa.createKeyPairGenerationState = function(bits, e, options) {
    // TODO: migrate step-based prime generation code to forge.prime
    // set default bits
    if (typeof bits === "string") bits = parseInt(bits, 10);
    bits = bits || 2048;
    // create prng with api that matches BigInteger secure random
    options = options || {};
    var prng = options.prng || $fz7FM.random;
    var rng = {
        // x is an array to fill with bytes
        nextBytes: function nextBytes(x) {
            var b = prng.getBytesSync(x.length);
            for(var i = 0; i < x.length; ++i)x[i] = b.charCodeAt(i);
        }
    };
    var algorithm = options.algorithm || "PRIMEINC";
    // create PRIMEINC algorithm state
    var rval;
    if (algorithm === "PRIMEINC") {
        rval = {
            algorithm: algorithm,
            state: 0,
            bits: bits,
            rng: rng,
            eInt: e || 65537,
            e: new $ad2c28fbd9c82f00$var$BigInteger(null),
            p: null,
            q: null,
            qBits: bits >> 1,
            pBits: bits - (bits >> 1),
            pqState: 0,
            num: null,
            keys: null
        };
        rval.e.fromInt(rval.eInt);
    } else throw new Error("Invalid key generation algorithm: " + algorithm);
    return rval;
};
/**
 * Attempts to runs the key-generation algorithm for at most n seconds
 * (approximately) using the given state. When key-generation has completed,
 * the keys will be stored in state.keys.
 *
 * To use this function to update a UI while generating a key or to prevent
 * causing browser lockups/warnings, set "n" to a value other than 0. A
 * simple pattern for generating a key and showing a progress indicator is:
 *
 * var state = pki.rsa.createKeyPairGenerationState(2048);
 * var step = function() {
 *   // step key-generation, run algorithm for 100 ms, repeat
 *   if(!forge.pki.rsa.stepKeyPairGenerationState(state, 100)) {
 *     setTimeout(step, 1);
 *   } else {
 *     // key-generation complete
 *     // TODO: turn off progress indicator here
 *     // TODO: use the generated key-pair in "state.keys"
 *   }
 * };
 * // TODO: turn on progress indicator here
 * setTimeout(step, 0);
 *
 * @param state the state to use.
 * @param n the maximum number of milliseconds to run the algorithm for, 0
 *          to run the algorithm to completion.
 *
 * @return true if the key-generation completed, false if not.
 */ $ad2c28fbd9c82f00$var$pki.rsa.stepKeyPairGenerationState = function(state, n) {
    // set default algorithm if not set
    if (!("algorithm" in state)) state.algorithm = "PRIMEINC";
    // TODO: migrate step-based prime generation code to forge.prime
    // TODO: abstract as PRIMEINC algorithm
    // do key generation (based on Tom Wu's rsa.js, see jsbn.js license)
    // with some minor optimizations and designed to run in steps
    // local state vars
    var THIRTY = new $ad2c28fbd9c82f00$var$BigInteger(null);
    THIRTY.fromInt(30);
    var deltaIdx = 0;
    var op_or = function op_or(x, y) {
        return x | y;
    };
    // keep stepping until time limit is reached or done
    var t1 = +new Date();
    var t2;
    var total = 0;
    while(state.keys === null && (n <= 0 || total < n)){
        // generate p or q
        if (state.state === 0) {
            /* Note: All primes are of the form:

        30k+i, for i < 30 and gcd(30, i)=1, where there are 8 values for i

        When we generate a random number, we always align it at 30k + 1. Each
        time the number is determined not to be prime we add to get to the
        next 'i', eg: if the number was at 30k + 1 we add 6. */ var bits = state.p === null ? state.pBits : state.qBits;
            var bits1 = bits - 1;
            // get a random number
            if (state.pqState === 0) {
                state.num = new $ad2c28fbd9c82f00$var$BigInteger(bits, state.rng);
                // force MSB set
                if (!state.num.testBit(bits1)) state.num.bitwiseTo($ad2c28fbd9c82f00$var$BigInteger.ONE.shiftLeft(bits1), op_or, state.num);
                // align number on 30k+1 boundary
                state.num.dAddOffset(31 - state.num.mod(THIRTY).byteValue(), 0);
                deltaIdx = 0;
                ++state.pqState;
            } else if (state.pqState === 1) {
                // try to make the number a prime
                if (state.num.bitLength() > bits) // overflow, try again
                state.pqState = 0;
                else if (state.num.isProbablePrime($ad2c28fbd9c82f00$var$_getMillerRabinTests(state.num.bitLength()))) ++state.pqState;
                else // get next potential prime
                state.num.dAddOffset($ad2c28fbd9c82f00$var$GCD_30_DELTA[deltaIdx++ % 8], 0);
            } else if (state.pqState === 2) // ensure number is coprime with e
            state.pqState = state.num.subtract($ad2c28fbd9c82f00$var$BigInteger.ONE).gcd(state.e).compareTo($ad2c28fbd9c82f00$var$BigInteger.ONE) === 0 ? 3 : 0;
            else if (state.pqState === 3) {
                // store p or q
                state.pqState = 0;
                if (state.p === null) state.p = state.num;
                else state.q = state.num;
                // advance state if both p and q are ready
                if (state.p !== null && state.q !== null) ++state.state;
                state.num = null;
            }
        } else if (state.state === 1) {
            // ensure p is larger than q (swap them if not)
            if (state.p.compareTo(state.q) < 0) {
                state.num = state.p;
                state.p = state.q;
                state.q = state.num;
            }
            ++state.state;
        } else if (state.state === 2) {
            // compute phi: (p - 1)(q - 1) (Euler's totient function)
            state.p1 = state.p.subtract($ad2c28fbd9c82f00$var$BigInteger.ONE);
            state.q1 = state.q.subtract($ad2c28fbd9c82f00$var$BigInteger.ONE);
            state.phi = state.p1.multiply(state.q1);
            ++state.state;
        } else if (state.state === 3) {
            // ensure e and phi are coprime
            if (state.phi.gcd(state.e).compareTo($ad2c28fbd9c82f00$var$BigInteger.ONE) === 0) // phi and e are coprime, advance
            ++state.state;
            else {
                // phi and e aren't coprime, so generate a new p and q
                state.p = null;
                state.q = null;
                state.state = 0;
            }
        } else if (state.state === 4) {
            // create n, ensure n is has the right number of bits
            state.n = state.p.multiply(state.q);
            // ensure n is right number of bits
            if (state.n.bitLength() === state.bits) // success, advance
            ++state.state;
            else {
                // failed, get new q
                state.q = null;
                state.state = 0;
            }
        } else if (state.state === 5) {
            // set keys
            var d = state.e.modInverse(state.phi);
            state.keys = {
                privateKey: $ad2c28fbd9c82f00$var$pki.rsa.setPrivateKey(state.n, state.e, d, state.p, state.q, d.mod(state.p1), d.mod(state.q1), state.q.modInverse(state.p)),
                publicKey: $ad2c28fbd9c82f00$var$pki.rsa.setPublicKey(state.n, state.e)
            };
        }
        // update timing
        t2 = +new Date();
        total += t2 - t1;
        t1 = t2;
    }
    return state.keys !== null;
};
/**
 * Generates an RSA public-private key pair in a single call.
 *
 * To generate a key-pair in steps (to allow for progress updates and to
 * prevent blocking or warnings in slow browsers) then use the key-pair
 * generation state functions.
 *
 * To generate a key-pair asynchronously (either through web-workers, if
 * available, or by breaking up the work on the main thread), pass a
 * callback function.
 *
 * @param [bits] the size for the private key in bits, defaults to 2048.
 * @param [e] the public exponent to use, defaults to 65537.
 * @param [options] options for key-pair generation, if given then 'bits'
 *            and 'e' must *not* be given:
 *          bits the size for the private key in bits, (default: 2048).
 *          e the public exponent to use, (default: 65537 (0x10001)).
 *          workerScript the worker script URL.
 *          workers the number of web workers (if supported) to use,
 *            (default: 2).
 *          workLoad the size of the work load, ie: number of possible prime
 *            numbers for each web worker to check per work assignment,
 *            (default: 100).
 *          prng a custom crypto-secure pseudo-random number generator to use,
 *            that must define "getBytesSync". Disables use of native APIs.
 *          algorithm the algorithm to use (default: 'PRIMEINC').
 * @param [callback(err, keypair)] called once the operation completes.
 *
 * @return an object with privateKey and publicKey properties.
 */ $ad2c28fbd9c82f00$var$pki.rsa.generateKeyPair = function(bits, e, options, callback) {
    // (bits), (options), (callback)
    if (arguments.length === 1) {
        if (typeof bits === "object") {
            options = bits;
            bits = undefined;
        } else if (typeof bits === "function") {
            callback = bits;
            bits = undefined;
        }
    } else if (arguments.length === 2) {
        // (bits, e), (bits, options), (bits, callback), (options, callback)
        if (typeof bits === "number") {
            if (typeof e === "function") {
                callback = e;
                e = undefined;
            } else if (typeof e !== "number") {
                options = e;
                e = undefined;
            }
        } else {
            options = bits;
            callback = e;
            bits = undefined;
            e = undefined;
        }
    } else if (arguments.length === 3) {
        // (bits, e, options), (bits, e, callback), (bits, options, callback)
        if (typeof e === "number") {
            if (typeof options === "function") {
                callback = options;
                options = undefined;
            }
        } else {
            callback = options;
            options = e;
            e = undefined;
        }
    }
    options = options || {};
    if (bits === undefined) bits = options.bits || 2048;
    if (e === undefined) e = options.e || 0x10001;
    // use native code if permitted, available, and parameters are acceptable
    if (!$fz7FM.options.usePureJavaScript && !options.prng && bits >= 256 && bits <= 16384 && (e === 0x10001 || e === 3)) {
        if (callback) {
            // try native async
            if ($ad2c28fbd9c82f00$var$_detectNodeCrypto("generateKeyPair")) return $ad2c28fbd9c82f00$var$_crypto.generateKeyPair("rsa", {
                modulusLength: bits,
                publicExponent: e,
                publicKeyEncoding: {
                    type: "spki",
                    format: "pem"
                },
                privateKeyEncoding: {
                    type: "pkcs8",
                    format: "pem"
                }
            }, function(err, pub, priv) {
                if (err) return callback(err);
                callback(null, {
                    privateKey: $ad2c28fbd9c82f00$var$pki.privateKeyFromPem(priv),
                    publicKey: $ad2c28fbd9c82f00$var$pki.publicKeyFromPem(pub)
                });
            });
            if ($ad2c28fbd9c82f00$var$_detectSubtleCrypto("generateKey") && $ad2c28fbd9c82f00$var$_detectSubtleCrypto("exportKey")) // use standard native generateKey
            return $ad2c28fbd9c82f00$var$util.globalScope.crypto.subtle.generateKey({
                name: "RSASSA-PKCS1-v1_5",
                modulusLength: bits,
                publicExponent: $ad2c28fbd9c82f00$var$_intToUint8Array(e),
                hash: {
                    name: "SHA-256"
                }
            }, true, [
                "sign",
                "verify"
            ]).then(function(pair) {
                return $ad2c28fbd9c82f00$var$util.globalScope.crypto.subtle.exportKey("pkcs8", pair.privateKey);
            // avoiding catch(function(err) {...}) to support IE <= 8
            }).then(undefined, function(err) {
                callback(err);
            }).then(function(pkcs8) {
                if (pkcs8) {
                    var privateKey = $ad2c28fbd9c82f00$var$pki.privateKeyFromAsn1($ad2c28fbd9c82f00$var$asn1.fromDer($fz7FM.util.createBuffer(pkcs8)));
                    callback(null, {
                        privateKey: privateKey,
                        publicKey: $ad2c28fbd9c82f00$var$pki.setRsaPublicKey(privateKey.n, privateKey.e)
                    });
                }
            });
            if ($ad2c28fbd9c82f00$var$_detectSubtleMsCrypto("generateKey") && $ad2c28fbd9c82f00$var$_detectSubtleMsCrypto("exportKey")) {
                var genOp = $ad2c28fbd9c82f00$var$util.globalScope.msCrypto.subtle.generateKey({
                    name: "RSASSA-PKCS1-v1_5",
                    modulusLength: bits,
                    publicExponent: $ad2c28fbd9c82f00$var$_intToUint8Array(e),
                    hash: {
                        name: "SHA-256"
                    }
                }, true, [
                    "sign",
                    "verify"
                ]);
                genOp.oncomplete = function(e) {
                    var pair = e.target.result;
                    var exportOp = $ad2c28fbd9c82f00$var$util.globalScope.msCrypto.subtle.exportKey("pkcs8", pair.privateKey);
                    exportOp.oncomplete = function(e) {
                        var pkcs8 = e.target.result;
                        var privateKey = $ad2c28fbd9c82f00$var$pki.privateKeyFromAsn1($ad2c28fbd9c82f00$var$asn1.fromDer($fz7FM.util.createBuffer(pkcs8)));
                        callback(null, {
                            privateKey: privateKey,
                            publicKey: $ad2c28fbd9c82f00$var$pki.setRsaPublicKey(privateKey.n, privateKey.e)
                        });
                    };
                    exportOp.onerror = function(err) {
                        callback(err);
                    };
                };
                genOp.onerror = function(err) {
                    callback(err);
                };
                return;
            }
        } else // try native sync
        if ($ad2c28fbd9c82f00$var$_detectNodeCrypto("generateKeyPairSync")) {
            var keypair = $ad2c28fbd9c82f00$var$_crypto.generateKeyPairSync("rsa", {
                modulusLength: bits,
                publicExponent: e,
                publicKeyEncoding: {
                    type: "spki",
                    format: "pem"
                },
                privateKeyEncoding: {
                    type: "pkcs8",
                    format: "pem"
                }
            });
            return {
                privateKey: $ad2c28fbd9c82f00$var$pki.privateKeyFromPem(keypair.privateKey),
                publicKey: $ad2c28fbd9c82f00$var$pki.publicKeyFromPem(keypair.publicKey)
            };
        }
    }
    // use JavaScript implementation
    var state = $ad2c28fbd9c82f00$var$pki.rsa.createKeyPairGenerationState(bits, e, options);
    if (!callback) {
        $ad2c28fbd9c82f00$var$pki.rsa.stepKeyPairGenerationState(state, 0);
        return state.keys;
    }
    $ad2c28fbd9c82f00$var$_generateKeyPair(state, options, callback);
};
/**
 * Sets an RSA public key from BigIntegers modulus and exponent.
 *
 * @param n the modulus.
 * @param e the exponent.
 *
 * @return the public key.
 */ $ad2c28fbd9c82f00$var$pki.setRsaPublicKey = $ad2c28fbd9c82f00$var$pki.rsa.setPublicKey = function(n, e) {
    var key = {
        n: n,
        e: e
    };
    /**
   * Encrypts the given data with this public key. Newer applications
   * should use the 'RSA-OAEP' decryption scheme, 'RSAES-PKCS1-V1_5' is for
   * legacy applications.
   *
   * @param data the byte string to encrypt.
   * @param scheme the encryption scheme to use:
   *          'RSAES-PKCS1-V1_5' (default),
   *          'RSA-OAEP',
   *          'RAW', 'NONE', or null to perform raw RSA encryption,
   *          an object with an 'encode' property set to a function
   *          with the signature 'function(data, key)' that returns
   *          a binary-encoded string representing the encoded data.
   * @param schemeOptions any scheme-specific options.
   *
   * @return the encrypted byte string.
   */ key.encrypt = function(data, scheme, schemeOptions) {
        if (typeof scheme === "string") scheme = scheme.toUpperCase();
        else if (scheme === undefined) scheme = "RSAES-PKCS1-V1_5";
        if (scheme === "RSAES-PKCS1-V1_5") scheme = {
            encode: function encode(m, key, pub) {
                return $ad2c28fbd9c82f00$var$_encodePkcs1_v1_5(m, key, 0x02).getBytes();
            }
        };
        else if (scheme === "RSA-OAEP" || scheme === "RSAES-OAEP") scheme = {
            encode: function encode(m, key) {
                return $fz7FM.pkcs1.encode_rsa_oaep(key, m, schemeOptions);
            }
        };
        else if ([
            "RAW",
            "NONE",
            "NULL",
            null
        ].indexOf(scheme) !== -1) scheme = {
            encode: function encode(e) {
                return e;
            }
        };
        else if (typeof scheme === "string") throw new Error('Unsupported encryption scheme: "' + scheme + '".');
        // do scheme-based encoding then rsa encryption
        var _$e = scheme.encode(data, key, true);
        return $ad2c28fbd9c82f00$var$pki.rsa.encrypt(_$e, key, true);
    };
    /**
   * Verifies the given signature against the given digest.
   *
   * PKCS#1 supports multiple (currently two) signature schemes:
   * RSASSA-PKCS1-V1_5 and RSASSA-PSS.
   *
   * By default this implementation uses the "old scheme", i.e.
   * RSASSA-PKCS1-V1_5, in which case once RSA-decrypted, the
   * signature is an OCTET STRING that holds a DigestInfo.
   *
   * DigestInfo ::= SEQUENCE {
   *   digestAlgorithm DigestAlgorithmIdentifier,
   *   digest Digest
   * }
   * DigestAlgorithmIdentifier ::= AlgorithmIdentifier
   * Digest ::= OCTET STRING
   *
   * To perform PSS signature verification, provide an instance
   * of Forge PSS object as the scheme parameter.
   *
   * @param digest the message digest hash to compare against the signature,
   *          as a binary-encoded string.
   * @param signature the signature to verify, as a binary-encoded string.
   * @param scheme signature verification scheme to use:
   *          'RSASSA-PKCS1-V1_5' or undefined for RSASSA PKCS#1 v1.5,
   *          a Forge PSS object for RSASSA-PSS,
   *          'NONE' or null for none, DigestInfo will not be expected, but
   *            PKCS#1 v1.5 padding will still be used.
   * @param options optional verify options
   *          _parseAllDigestBytes testing flag to control parsing of all
   *            digest bytes. Unsupported and not for general usage.
   *            (default: true)
   *
   * @return true if the signature was verified, false if not.
   */ key.verify = function(digest, signature, scheme, options) {
        if (typeof scheme === "string") scheme = scheme.toUpperCase();
        else if (scheme === undefined) scheme = "RSASSA-PKCS1-V1_5";
        if (options === undefined) options = {
            _parseAllDigestBytes: true
        };
        if (!("_parseAllDigestBytes" in options)) options._parseAllDigestBytes = true;
        if (scheme === "RSASSA-PKCS1-V1_5") scheme = {
            verify: function verify(digest, d) {
                // remove padding
                d = $ad2c28fbd9c82f00$var$_decodePkcs1_v1_5(d, key, true);
                // d is ASN.1 BER-encoded DigestInfo
                var obj = $ad2c28fbd9c82f00$var$asn1.fromDer(d, {
                    parseAllBytes: options._parseAllDigestBytes
                });
                // validate DigestInfo
                var capture = {};
                var errors = [];
                if (!$ad2c28fbd9c82f00$var$asn1.validate(obj, $ad2c28fbd9c82f00$var$digestInfoValidator, capture, errors)) {
                    var error = new Error("ASN.1 object does not contain a valid RSASSA-PKCS1-v1_5 DigestInfo value.");
                    error.errors = errors;
                    throw error;
                }
                // check hash algorithm identifier
                // see PKCS1-v1-5DigestAlgorithms in RFC 8017
                // FIXME: add support to vaidator for strict value choices
                var oid = $ad2c28fbd9c82f00$var$asn1.derToOid(capture.algorithmIdentifier);
                if (!(oid === $fz7FM.oids.md2 || oid === $fz7FM.oids.md5 || oid === $fz7FM.oids.sha1 || oid === $fz7FM.oids.sha224 || oid === $fz7FM.oids.sha256 || oid === $fz7FM.oids.sha384 || oid === $fz7FM.oids.sha512 || oid === $fz7FM.oids["sha512-224"] || oid === $fz7FM.oids["sha512-256"])) {
                    var error = new Error("Unknown RSASSA-PKCS1-v1_5 DigestAlgorithm identifier.");
                    error.oid = oid;
                    throw error;
                }
                // special check for md2 and md5 that NULL parameters exist
                if (oid === $fz7FM.oids.md2 || oid === $fz7FM.oids.md5) {
                    if (!("parameters" in capture)) throw new Error("ASN.1 object does not contain a valid RSASSA-PKCS1-v1_5 DigestInfo value. Missing algorithm identifer NULL parameters.");
                }
                // compare the given digest to the decrypted one
                return digest === capture.digest;
            }
        };
        else if (scheme === "NONE" || scheme === "NULL" || scheme === null) scheme = {
            verify: function verify(digest, d) {
                // remove padding
                d = $ad2c28fbd9c82f00$var$_decodePkcs1_v1_5(d, key, true);
                return digest === d;
            }
        };
        // do rsa decryption w/o any decoding, then verify -- which does decoding
        var d = $ad2c28fbd9c82f00$var$pki.rsa.decrypt(signature, key, true, false);
        return scheme.verify(digest, d, key.n.bitLength());
    };
    return key;
};
/**
 * Sets an RSA private key from BigIntegers modulus, exponent, primes,
 * prime exponents, and modular multiplicative inverse.
 *
 * @param n the modulus.
 * @param e the public exponent.
 * @param d the private exponent ((inverse of e) mod n).
 * @param p the first prime.
 * @param q the second prime.
 * @param dP exponent1 (d mod (p-1)).
 * @param dQ exponent2 (d mod (q-1)).
 * @param qInv ((inverse of q) mod p)
 *
 * @return the private key.
 */ $ad2c28fbd9c82f00$var$pki.setRsaPrivateKey = $ad2c28fbd9c82f00$var$pki.rsa.setPrivateKey = function(n, e, d, p, q, dP, dQ, qInv) {
    var key = {
        n: n,
        e: e,
        d: d,
        p: p,
        q: q,
        dP: dP,
        dQ: dQ,
        qInv: qInv
    };
    /**
   * Decrypts the given data with this private key. The decryption scheme
   * must match the one used to encrypt the data.
   *
   * @param data the byte string to decrypt.
   * @param scheme the decryption scheme to use:
   *          'RSAES-PKCS1-V1_5' (default),
   *          'RSA-OAEP',
   *          'RAW', 'NONE', or null to perform raw RSA decryption.
   * @param schemeOptions any scheme-specific options.
   *
   * @return the decrypted byte string.
   */ key.decrypt = function(data, scheme, schemeOptions) {
        if (typeof scheme === "string") scheme = scheme.toUpperCase();
        else if (scheme === undefined) scheme = "RSAES-PKCS1-V1_5";
        // do rsa decryption w/o any decoding
        var _$d = $ad2c28fbd9c82f00$var$pki.rsa.decrypt(data, key, false, false);
        if (scheme === "RSAES-PKCS1-V1_5") scheme = {
            decode: $ad2c28fbd9c82f00$var$_decodePkcs1_v1_5
        };
        else if (scheme === "RSA-OAEP" || scheme === "RSAES-OAEP") scheme = {
            decode: function decode(d, key) {
                return $fz7FM.pkcs1.decode_rsa_oaep(key, d, schemeOptions);
            }
        };
        else if ([
            "RAW",
            "NONE",
            "NULL",
            null
        ].indexOf(scheme) !== -1) scheme = {
            decode: function decode(d) {
                return d;
            }
        };
        else throw new Error('Unsupported encryption scheme: "' + scheme + '".');
        // decode according to scheme
        return scheme.decode(_$d, key, false);
    };
    /**
   * Signs the given digest, producing a signature.
   *
   * PKCS#1 supports multiple (currently two) signature schemes:
   * RSASSA-PKCS1-V1_5 and RSASSA-PSS.
   *
   * By default this implementation uses the "old scheme", i.e.
   * RSASSA-PKCS1-V1_5. In order to generate a PSS signature, provide
   * an instance of Forge PSS object as the scheme parameter.
   *
   * @param md the message digest object with the hash to sign.
   * @param scheme the signature scheme to use:
   *          'RSASSA-PKCS1-V1_5' or undefined for RSASSA PKCS#1 v1.5,
   *          a Forge PSS object for RSASSA-PSS,
   *          'NONE' or null for none, DigestInfo will not be used but
   *            PKCS#1 v1.5 padding will still be used.
   *
   * @return the signature as a byte string.
   */ key.sign = function(md, scheme) {
        /* Note: The internal implementation of RSA operations is being
      transitioned away from a PKCS#1 v1.5 hard-coded scheme. Some legacy
      code like the use of an encoding block identifier 'bt' will eventually
      be removed. */ // private key operation
        var bt = false;
        if (typeof scheme === "string") scheme = scheme.toUpperCase();
        if (scheme === undefined || scheme === "RSASSA-PKCS1-V1_5") {
            scheme = {
                encode: $ad2c28fbd9c82f00$var$emsaPkcs1v15encode
            };
            bt = 0x01;
        } else if (scheme === "NONE" || scheme === "NULL" || scheme === null) {
            scheme = {
                encode: function encode() {
                    return md;
                }
            };
            bt = 0x01;
        }
        // encode and then encrypt
        var _$d = scheme.encode(md, key.n.bitLength());
        return $ad2c28fbd9c82f00$var$pki.rsa.encrypt(_$d, key, bt);
    };
    return key;
};
/**
 * Wraps an RSAPrivateKey ASN.1 object in an ASN.1 PrivateKeyInfo object.
 *
 * @param rsaKey the ASN.1 RSAPrivateKey.
 *
 * @return the ASN.1 PrivateKeyInfo.
 */ $ad2c28fbd9c82f00$var$pki.wrapRsaPrivateKey = function(rsaKey) {
    // PrivateKeyInfo
    return $ad2c28fbd9c82f00$var$asn1.create($ad2c28fbd9c82f00$var$asn1.Class.UNIVERSAL, $ad2c28fbd9c82f00$var$asn1.Type.SEQUENCE, true, [
        // version (0)
        $ad2c28fbd9c82f00$var$asn1.create($ad2c28fbd9c82f00$var$asn1.Class.UNIVERSAL, $ad2c28fbd9c82f00$var$asn1.Type.INTEGER, false, $ad2c28fbd9c82f00$var$asn1.integerToDer(0).getBytes()),
        // privateKeyAlgorithm
        $ad2c28fbd9c82f00$var$asn1.create($ad2c28fbd9c82f00$var$asn1.Class.UNIVERSAL, $ad2c28fbd9c82f00$var$asn1.Type.SEQUENCE, true, [
            $ad2c28fbd9c82f00$var$asn1.create($ad2c28fbd9c82f00$var$asn1.Class.UNIVERSAL, $ad2c28fbd9c82f00$var$asn1.Type.OID, false, $ad2c28fbd9c82f00$var$asn1.oidToDer($ad2c28fbd9c82f00$var$pki.oids.rsaEncryption).getBytes()),
            $ad2c28fbd9c82f00$var$asn1.create($ad2c28fbd9c82f00$var$asn1.Class.UNIVERSAL, $ad2c28fbd9c82f00$var$asn1.Type.NULL, false, "")
        ]),
        // PrivateKey
        $ad2c28fbd9c82f00$var$asn1.create($ad2c28fbd9c82f00$var$asn1.Class.UNIVERSAL, $ad2c28fbd9c82f00$var$asn1.Type.OCTETSTRING, false, $ad2c28fbd9c82f00$var$asn1.toDer(rsaKey).getBytes())
    ]);
};
/**
 * Converts a private key from an ASN.1 object.
 *
 * @param obj the ASN.1 representation of a PrivateKeyInfo containing an
 *          RSAPrivateKey or an RSAPrivateKey.
 *
 * @return the private key.
 */ $ad2c28fbd9c82f00$var$pki.privateKeyFromAsn1 = function(obj) {
    // get PrivateKeyInfo
    var capture = {};
    var errors = [];
    if ($ad2c28fbd9c82f00$var$asn1.validate(obj, $ad2c28fbd9c82f00$var$privateKeyValidator, capture, errors)) obj = $ad2c28fbd9c82f00$var$asn1.fromDer($fz7FM.util.createBuffer(capture.privateKey));
    // get RSAPrivateKey
    capture = {};
    errors = [];
    if (!$ad2c28fbd9c82f00$var$asn1.validate(obj, $ad2c28fbd9c82f00$var$rsaPrivateKeyValidator, capture, errors)) {
        var error = new Error("Cannot read private key. ASN.1 object does not contain an RSAPrivateKey.");
        error.errors = errors;
        throw error;
    }
    // Note: Version is currently ignored.
    // capture.privateKeyVersion
    // FIXME: inefficient, get a BigInteger that uses byte strings
    var n, e, d, p, q, dP, dQ, qInv;
    n = $fz7FM.util.createBuffer(capture.privateKeyModulus).toHex();
    e = $fz7FM.util.createBuffer(capture.privateKeyPublicExponent).toHex();
    d = $fz7FM.util.createBuffer(capture.privateKeyPrivateExponent).toHex();
    p = $fz7FM.util.createBuffer(capture.privateKeyPrime1).toHex();
    q = $fz7FM.util.createBuffer(capture.privateKeyPrime2).toHex();
    dP = $fz7FM.util.createBuffer(capture.privateKeyExponent1).toHex();
    dQ = $fz7FM.util.createBuffer(capture.privateKeyExponent2).toHex();
    qInv = $fz7FM.util.createBuffer(capture.privateKeyCoefficient).toHex();
    // set private key
    return $ad2c28fbd9c82f00$var$pki.setRsaPrivateKey(new $ad2c28fbd9c82f00$var$BigInteger(n, 16), new $ad2c28fbd9c82f00$var$BigInteger(e, 16), new $ad2c28fbd9c82f00$var$BigInteger(d, 16), new $ad2c28fbd9c82f00$var$BigInteger(p, 16), new $ad2c28fbd9c82f00$var$BigInteger(q, 16), new $ad2c28fbd9c82f00$var$BigInteger(dP, 16), new $ad2c28fbd9c82f00$var$BigInteger(dQ, 16), new $ad2c28fbd9c82f00$var$BigInteger(qInv, 16));
};
/**
 * Converts a private key to an ASN.1 RSAPrivateKey.
 *
 * @param key the private key.
 *
 * @return the ASN.1 representation of an RSAPrivateKey.
 */ $ad2c28fbd9c82f00$var$pki.privateKeyToAsn1 = $ad2c28fbd9c82f00$var$pki.privateKeyToRSAPrivateKey = function(key) {
    // RSAPrivateKey
    return $ad2c28fbd9c82f00$var$asn1.create($ad2c28fbd9c82f00$var$asn1.Class.UNIVERSAL, $ad2c28fbd9c82f00$var$asn1.Type.SEQUENCE, true, [
        // version (0 = only 2 primes, 1 multiple primes)
        $ad2c28fbd9c82f00$var$asn1.create($ad2c28fbd9c82f00$var$asn1.Class.UNIVERSAL, $ad2c28fbd9c82f00$var$asn1.Type.INTEGER, false, $ad2c28fbd9c82f00$var$asn1.integerToDer(0).getBytes()),
        // modulus (n)
        $ad2c28fbd9c82f00$var$asn1.create($ad2c28fbd9c82f00$var$asn1.Class.UNIVERSAL, $ad2c28fbd9c82f00$var$asn1.Type.INTEGER, false, $ad2c28fbd9c82f00$var$_bnToBytes(key.n)),
        // publicExponent (e)
        $ad2c28fbd9c82f00$var$asn1.create($ad2c28fbd9c82f00$var$asn1.Class.UNIVERSAL, $ad2c28fbd9c82f00$var$asn1.Type.INTEGER, false, $ad2c28fbd9c82f00$var$_bnToBytes(key.e)),
        // privateExponent (d)
        $ad2c28fbd9c82f00$var$asn1.create($ad2c28fbd9c82f00$var$asn1.Class.UNIVERSAL, $ad2c28fbd9c82f00$var$asn1.Type.INTEGER, false, $ad2c28fbd9c82f00$var$_bnToBytes(key.d)),
        // privateKeyPrime1 (p)
        $ad2c28fbd9c82f00$var$asn1.create($ad2c28fbd9c82f00$var$asn1.Class.UNIVERSAL, $ad2c28fbd9c82f00$var$asn1.Type.INTEGER, false, $ad2c28fbd9c82f00$var$_bnToBytes(key.p)),
        // privateKeyPrime2 (q)
        $ad2c28fbd9c82f00$var$asn1.create($ad2c28fbd9c82f00$var$asn1.Class.UNIVERSAL, $ad2c28fbd9c82f00$var$asn1.Type.INTEGER, false, $ad2c28fbd9c82f00$var$_bnToBytes(key.q)),
        // privateKeyExponent1 (dP)
        $ad2c28fbd9c82f00$var$asn1.create($ad2c28fbd9c82f00$var$asn1.Class.UNIVERSAL, $ad2c28fbd9c82f00$var$asn1.Type.INTEGER, false, $ad2c28fbd9c82f00$var$_bnToBytes(key.dP)),
        // privateKeyExponent2 (dQ)
        $ad2c28fbd9c82f00$var$asn1.create($ad2c28fbd9c82f00$var$asn1.Class.UNIVERSAL, $ad2c28fbd9c82f00$var$asn1.Type.INTEGER, false, $ad2c28fbd9c82f00$var$_bnToBytes(key.dQ)),
        // coefficient (qInv)
        $ad2c28fbd9c82f00$var$asn1.create($ad2c28fbd9c82f00$var$asn1.Class.UNIVERSAL, $ad2c28fbd9c82f00$var$asn1.Type.INTEGER, false, $ad2c28fbd9c82f00$var$_bnToBytes(key.qInv))
    ]);
};
/**
 * Converts a public key from an ASN.1 SubjectPublicKeyInfo or RSAPublicKey.
 *
 * @param obj the asn1 representation of a SubjectPublicKeyInfo or RSAPublicKey.
 *
 * @return the public key.
 */ $ad2c28fbd9c82f00$var$pki.publicKeyFromAsn1 = function(obj) {
    // get SubjectPublicKeyInfo
    var capture = {};
    var errors = [];
    if ($ad2c28fbd9c82f00$var$asn1.validate(obj, $ad2c28fbd9c82f00$var$publicKeyValidator, capture, errors)) {
        // get oid
        var oid = $ad2c28fbd9c82f00$var$asn1.derToOid(capture.publicKeyOid);
        if (oid !== $ad2c28fbd9c82f00$var$pki.oids.rsaEncryption) {
            var error = new Error("Cannot read public key. Unknown OID.");
            error.oid = oid;
            throw error;
        }
        obj = capture.rsaPublicKey;
    }
    // get RSA params
    errors = [];
    if (!$ad2c28fbd9c82f00$var$asn1.validate(obj, $ad2c28fbd9c82f00$var$rsaPublicKeyValidator, capture, errors)) {
        var error = new Error("Cannot read public key. ASN.1 object does not contain an RSAPublicKey.");
        error.errors = errors;
        throw error;
    }
    // FIXME: inefficient, get a BigInteger that uses byte strings
    var n = $fz7FM.util.createBuffer(capture.publicKeyModulus).toHex();
    var e = $fz7FM.util.createBuffer(capture.publicKeyExponent).toHex();
    // set public key
    return $ad2c28fbd9c82f00$var$pki.setRsaPublicKey(new $ad2c28fbd9c82f00$var$BigInteger(n, 16), new $ad2c28fbd9c82f00$var$BigInteger(e, 16));
};
/**
 * Converts a public key to an ASN.1 SubjectPublicKeyInfo.
 *
 * @param key the public key.
 *
 * @return the asn1 representation of a SubjectPublicKeyInfo.
 */ $ad2c28fbd9c82f00$var$pki.publicKeyToAsn1 = $ad2c28fbd9c82f00$var$pki.publicKeyToSubjectPublicKeyInfo = function(key) {
    // SubjectPublicKeyInfo
    return $ad2c28fbd9c82f00$var$asn1.create($ad2c28fbd9c82f00$var$asn1.Class.UNIVERSAL, $ad2c28fbd9c82f00$var$asn1.Type.SEQUENCE, true, [
        // AlgorithmIdentifier
        $ad2c28fbd9c82f00$var$asn1.create($ad2c28fbd9c82f00$var$asn1.Class.UNIVERSAL, $ad2c28fbd9c82f00$var$asn1.Type.SEQUENCE, true, [
            // algorithm
            $ad2c28fbd9c82f00$var$asn1.create($ad2c28fbd9c82f00$var$asn1.Class.UNIVERSAL, $ad2c28fbd9c82f00$var$asn1.Type.OID, false, $ad2c28fbd9c82f00$var$asn1.oidToDer($ad2c28fbd9c82f00$var$pki.oids.rsaEncryption).getBytes()),
            // parameters (null)
            $ad2c28fbd9c82f00$var$asn1.create($ad2c28fbd9c82f00$var$asn1.Class.UNIVERSAL, $ad2c28fbd9c82f00$var$asn1.Type.NULL, false, "")
        ]),
        // subjectPublicKey
        $ad2c28fbd9c82f00$var$asn1.create($ad2c28fbd9c82f00$var$asn1.Class.UNIVERSAL, $ad2c28fbd9c82f00$var$asn1.Type.BITSTRING, false, [
            $ad2c28fbd9c82f00$var$pki.publicKeyToRSAPublicKey(key)
        ])
    ]);
};
/**
 * Converts a public key to an ASN.1 RSAPublicKey.
 *
 * @param key the public key.
 *
 * @return the asn1 representation of a RSAPublicKey.
 */ $ad2c28fbd9c82f00$var$pki.publicKeyToRSAPublicKey = function(key) {
    // RSAPublicKey
    return $ad2c28fbd9c82f00$var$asn1.create($ad2c28fbd9c82f00$var$asn1.Class.UNIVERSAL, $ad2c28fbd9c82f00$var$asn1.Type.SEQUENCE, true, [
        // modulus (n)
        $ad2c28fbd9c82f00$var$asn1.create($ad2c28fbd9c82f00$var$asn1.Class.UNIVERSAL, $ad2c28fbd9c82f00$var$asn1.Type.INTEGER, false, $ad2c28fbd9c82f00$var$_bnToBytes(key.n)),
        // publicExponent (e)
        $ad2c28fbd9c82f00$var$asn1.create($ad2c28fbd9c82f00$var$asn1.Class.UNIVERSAL, $ad2c28fbd9c82f00$var$asn1.Type.INTEGER, false, $ad2c28fbd9c82f00$var$_bnToBytes(key.e))
    ]);
};
/**
 * Encodes a message using PKCS#1 v1.5 padding.
 *
 * @param m the message to encode.
 * @param key the RSA key to use.
 * @param bt the block type to use, i.e. either 0x01 (for signing) or 0x02
 *          (for encryption).
 *
 * @return the padded byte buffer.
 */ function $ad2c28fbd9c82f00$var$_encodePkcs1_v1_5(m, key, bt) {
    var eb = $fz7FM.util.createBuffer();
    // get the length of the modulus in bytes
    var k = Math.ceil(key.n.bitLength() / 8);
    /* use PKCS#1 v1.5 padding */ if (m.length > k - 11) {
        var error = new Error("Message is too long for PKCS#1 v1.5 padding.");
        error.length = m.length;
        error.max = k - 11;
        throw error;
    }
    /* A block type BT, a padding string PS, and the data D shall be
    formatted into an octet string EB, the encryption block:

    EB = 00 || BT || PS || 00 || D

    The block type BT shall be a single octet indicating the structure of
    the encryption block. For this version of the document it shall have
    value 00, 01, or 02. For a private-key operation, the block type
    shall be 00 or 01. For a public-key operation, it shall be 02.

    The padding string PS shall consist of k-3-||D|| octets. For block
    type 00, the octets shall have value 00; for block type 01, they
    shall have value FF; and for block type 02, they shall be
    pseudorandomly generated and nonzero. This makes the length of the
    encryption block EB equal to k. */ // build the encryption block
    eb.putByte(0x00);
    eb.putByte(bt);
    // create the padding
    var padNum = k - 3 - m.length;
    var padByte;
    // private key op
    if (bt === 0x00 || bt === 0x01) {
        padByte = bt === 0x00 ? 0x00 : 0xFF;
        for(var i = 0; i < padNum; ++i)eb.putByte(padByte);
    } else // public key op
    // pad with random non-zero values
    while(padNum > 0){
        var numZeros = 0;
        var padBytes = $fz7FM.random.getBytes(padNum);
        for(var i = 0; i < padNum; ++i){
            padByte = padBytes.charCodeAt(i);
            if (padByte === 0) ++numZeros;
            else eb.putByte(padByte);
        }
        padNum = numZeros;
    }
    // zero followed by message
    eb.putByte(0x00);
    eb.putBytes(m);
    return eb;
}
/**
 * Decodes a message using PKCS#1 v1.5 padding.
 *
 * @param em the message to decode.
 * @param key the RSA key to use.
 * @param pub true if the key is a public key, false if it is private.
 * @param ml the message length, if specified.
 *
 * @return the decoded bytes.
 */ function $ad2c28fbd9c82f00$var$_decodePkcs1_v1_5(em, key, pub, ml) {
    // get the length of the modulus in bytes
    var k = Math.ceil(key.n.bitLength() / 8);
    /* It is an error if any of the following conditions occurs:

    1. The encryption block EB cannot be parsed unambiguously.
    2. The padding string PS consists of fewer than eight octets
      or is inconsisent with the block type BT.
    3. The decryption process is a public-key operation and the block
      type BT is not 00 or 01, or the decryption process is a
      private-key operation and the block type is not 02.
   */ // parse the encryption block
    var eb = $fz7FM.util.createBuffer(em);
    var first = eb.getByte();
    var bt = eb.getByte();
    if (first !== 0x00 || pub && bt !== 0x00 && bt !== 0x01 || !pub && bt != 0x02 || pub && bt === 0x00 && typeof ml === "undefined") throw new Error("Encryption block is invalid.");
    var padNum = 0;
    if (bt === 0x00) {
        // check all padding bytes for 0x00
        padNum = k - 3 - ml;
        for(var i = 0; i < padNum; ++i){
            if (eb.getByte() !== 0x00) throw new Error("Encryption block is invalid.");
        }
    } else if (bt === 0x01) {
        // find the first byte that isn't 0xFF, should be after all padding
        padNum = 0;
        while(eb.length() > 1){
            if (eb.getByte() !== 0xFF) {
                --eb.read;
                break;
            }
            ++padNum;
        }
    } else if (bt === 0x02) {
        // look for 0x00 byte
        padNum = 0;
        while(eb.length() > 1){
            if (eb.getByte() === 0x00) {
                --eb.read;
                break;
            }
            ++padNum;
        }
    }
    // zero must be 0x00 and padNum must be (k - 3 - message length)
    var zero = eb.getByte();
    if (zero !== 0x00 || padNum !== k - 3 - eb.length()) throw new Error("Encryption block is invalid.");
    return eb.getBytes();
}
/**
 * Runs the key-generation algorithm asynchronously, either in the background
 * via Web Workers, or using the main thread and setImmediate.
 *
 * @param state the key-pair generation state.
 * @param [options] options for key-pair generation:
 *          workerScript the worker script URL.
 *          workers the number of web workers (if supported) to use,
 *            (default: 2, -1 to use estimated cores minus one).
 *          workLoad the size of the work load, ie: number of possible prime
 *            numbers for each web worker to check per work assignment,
 *            (default: 100).
 * @param callback(err, keypair) called once the operation completes.
 */ function $ad2c28fbd9c82f00$var$_generateKeyPair(state, options, callback) {
    if (typeof options === "function") {
        callback = options;
        options = {};
    }
    options = options || {};
    var opts = {
        algorithm: {
            name: options.algorithm || "PRIMEINC",
            options: {
                workers: options.workers || 2,
                workLoad: options.workLoad || 100,
                workerScript: options.workerScript
            }
        }
    };
    if ("prng" in options) opts.prng = options.prng;
    generate();
    function generate() {
        // find p and then q (done in series to simplify)
        getPrime(state.pBits, function(err, num) {
            if (err) return callback(err);
            state.p = num;
            if (state.q !== null) return finish(err, state.q);
            getPrime(state.qBits, finish);
        });
    }
    function getPrime(bits, callback) {
        $fz7FM.prime.generateProbablePrime(bits, opts, callback);
    }
    function finish(err, num) {
        if (err) return callback(err);
        // set q
        state.q = num;
        // ensure p is larger than q (swap them if not)
        if (state.p.compareTo(state.q) < 0) {
            var tmp = state.p;
            state.p = state.q;
            state.q = tmp;
        }
        // ensure p is coprime with e
        if (state.p.subtract($ad2c28fbd9c82f00$var$BigInteger.ONE).gcd(state.e).compareTo($ad2c28fbd9c82f00$var$BigInteger.ONE) !== 0) {
            state.p = null;
            generate();
            return;
        }
        // ensure q is coprime with e
        if (state.q.subtract($ad2c28fbd9c82f00$var$BigInteger.ONE).gcd(state.e).compareTo($ad2c28fbd9c82f00$var$BigInteger.ONE) !== 0) {
            state.q = null;
            getPrime(state.qBits, finish);
            return;
        }
        // compute phi: (p - 1)(q - 1) (Euler's totient function)
        state.p1 = state.p.subtract($ad2c28fbd9c82f00$var$BigInteger.ONE);
        state.q1 = state.q.subtract($ad2c28fbd9c82f00$var$BigInteger.ONE);
        state.phi = state.p1.multiply(state.q1);
        // ensure e and phi are coprime
        if (state.phi.gcd(state.e).compareTo($ad2c28fbd9c82f00$var$BigInteger.ONE) !== 0) {
            // phi and e aren't coprime, so generate a new p and q
            state.p = state.q = null;
            generate();
            return;
        }
        // create n, ensure n is has the right number of bits
        state.n = state.p.multiply(state.q);
        if (state.n.bitLength() !== state.bits) {
            // failed, get new q
            state.q = null;
            getPrime(state.qBits, finish);
            return;
        }
        // set keys
        var d = state.e.modInverse(state.phi);
        state.keys = {
            privateKey: $ad2c28fbd9c82f00$var$pki.rsa.setPrivateKey(state.n, state.e, d, state.p, state.q, d.mod(state.p1), d.mod(state.q1), state.q.modInverse(state.p)),
            publicKey: $ad2c28fbd9c82f00$var$pki.rsa.setPublicKey(state.n, state.e)
        };
        callback(null, state.keys);
    }
}
/**
 * Converts a positive BigInteger into 2's-complement big-endian bytes.
 *
 * @param b the big integer to convert.
 *
 * @return the bytes.
 */ function $ad2c28fbd9c82f00$var$_bnToBytes(b) {
    // prepend 0x00 if first byte >= 0x80
    var hex = b.toString(16);
    if (hex[0] >= "8") hex = "00" + hex;
    var bytes = $fz7FM.util.hexToBytes(hex);
    // ensure integer is minimally-encoded
    if (bytes.length > 1 && // leading 0x00 for positive integer
    (bytes.charCodeAt(0) === 0 && (bytes.charCodeAt(1) & 0x80) === 0 || // leading 0xFF for negative integer
    bytes.charCodeAt(0) === 0xFF && (bytes.charCodeAt(1) & 0x80) === 0x80)) return bytes.substr(1);
    return bytes;
}
/**
 * Returns the required number of Miller-Rabin tests to generate a
 * prime with an error probability of (1/2)^80.
 *
 * See Handbook of Applied Cryptography Chapter 4, Table 4.4.
 *
 * @param bits the bit size.
 *
 * @return the required number of iterations.
 */ function $ad2c28fbd9c82f00$var$_getMillerRabinTests(bits) {
    if (bits <= 100) return 27;
    if (bits <= 150) return 18;
    if (bits <= 200) return 15;
    if (bits <= 250) return 12;
    if (bits <= 300) return 9;
    if (bits <= 350) return 8;
    if (bits <= 400) return 7;
    if (bits <= 500) return 6;
    if (bits <= 600) return 5;
    if (bits <= 800) return 4;
    if (bits <= 1250) return 3;
    return 2;
}
/**
 * Performs feature detection on the Node crypto interface.
 *
 * @param fn the feature (function) to detect.
 *
 * @return true if detected, false if not.
 */ function $ad2c28fbd9c82f00$var$_detectNodeCrypto(fn) {
    return $fz7FM.util.isNodejs && typeof $ad2c28fbd9c82f00$var$_crypto[fn] === "function";
}
/**
 * Performs feature detection on the SubtleCrypto interface.
 *
 * @param fn the feature (function) to detect.
 *
 * @return true if detected, false if not.
 */ function $ad2c28fbd9c82f00$var$_detectSubtleCrypto(fn) {
    return typeof $ad2c28fbd9c82f00$var$util.globalScope !== "undefined" && typeof $ad2c28fbd9c82f00$var$util.globalScope.crypto === "object" && typeof $ad2c28fbd9c82f00$var$util.globalScope.crypto.subtle === "object" && typeof $ad2c28fbd9c82f00$var$util.globalScope.crypto.subtle[fn] === "function";
}
/**
 * Performs feature detection on the deprecated Microsoft Internet Explorer
 * outdated SubtleCrypto interface. This function should only be used after
 * checking for the modern, standard SubtleCrypto interface.
 *
 * @param fn the feature (function) to detect.
 *
 * @return true if detected, false if not.
 */ function $ad2c28fbd9c82f00$var$_detectSubtleMsCrypto(fn) {
    return typeof $ad2c28fbd9c82f00$var$util.globalScope !== "undefined" && typeof $ad2c28fbd9c82f00$var$util.globalScope.msCrypto === "object" && typeof $ad2c28fbd9c82f00$var$util.globalScope.msCrypto.subtle === "object" && typeof $ad2c28fbd9c82f00$var$util.globalScope.msCrypto.subtle[fn] === "function";
}
function $ad2c28fbd9c82f00$var$_intToUint8Array(x) {
    var bytes = $fz7FM.util.hexToBytes(x.toString(16));
    var buffer = new Uint8Array(bytes.length);
    for(var i = 0; i < bytes.length; ++i)buffer[i] = bytes.charCodeAt(i);
    return buffer;
}
function $ad2c28fbd9c82f00$var$_privateKeyFromJwk(jwk) {
    if (jwk.kty !== "RSA") throw new Error('Unsupported key algorithm "' + jwk.kty + '"; algorithm must be "RSA".');
    return $ad2c28fbd9c82f00$var$pki.setRsaPrivateKey($ad2c28fbd9c82f00$var$_base64ToBigInt(jwk.n), $ad2c28fbd9c82f00$var$_base64ToBigInt(jwk.e), $ad2c28fbd9c82f00$var$_base64ToBigInt(jwk.d), $ad2c28fbd9c82f00$var$_base64ToBigInt(jwk.p), $ad2c28fbd9c82f00$var$_base64ToBigInt(jwk.q), $ad2c28fbd9c82f00$var$_base64ToBigInt(jwk.dp), $ad2c28fbd9c82f00$var$_base64ToBigInt(jwk.dq), $ad2c28fbd9c82f00$var$_base64ToBigInt(jwk.qi));
}
function $ad2c28fbd9c82f00$var$_publicKeyFromJwk(jwk) {
    if (jwk.kty !== "RSA") throw new Error('Key algorithm must be "RSA".');
    return $ad2c28fbd9c82f00$var$pki.setRsaPublicKey($ad2c28fbd9c82f00$var$_base64ToBigInt(jwk.n), $ad2c28fbd9c82f00$var$_base64ToBigInt(jwk.e));
}
function $ad2c28fbd9c82f00$var$_base64ToBigInt(b64) {
    return new $ad2c28fbd9c82f00$var$BigInteger($fz7FM.util.bytesToHex($fz7FM.util.decode64(b64)), 16);
}

});
parcelRegister("dFOUo", function(module, exports) {
// Copyright (c) 2005  Tom Wu
// All Rights Reserved.
// See "LICENSE" for details.
// Basic JavaScript BN library - subset useful for RSA encryption.
/*
Licensing (LICENSE)
-------------------

This software is covered under the following copyright:
*/ /*
 * Copyright (c) 2003-2005  Tom Wu
 * All Rights Reserved.
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS-IS" AND WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS, IMPLIED OR OTHERWISE, INCLUDING WITHOUT LIMITATION, ANY
 * WARRANTY OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.
 *
 * IN NO EVENT SHALL TOM WU BE LIABLE FOR ANY SPECIAL, INCIDENTAL,
 * INDIRECT OR CONSEQUENTIAL DAMAGES OF ANY KIND, OR ANY DAMAGES WHATSOEVER
 * RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER OR NOT ADVISED OF
 * THE POSSIBILITY OF DAMAGE, AND ON ANY THEORY OF LIABILITY, ARISING OUT
 * OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 *
 * In addition, the following condition applies:
 *
 * All redistributions must retain an intact copy of this copyright notice
 * and disclaimer.
 */ /*
Address all questions regarding this license to:

  Tom Wu
  tjw@cs.Stanford.EDU
*/ 
var $fz7FM = parcelRequire("fz7FM");
module.exports = $fz7FM.jsbn = $fz7FM.jsbn || {};
// Bits per digit
var $9f4698123987813e$var$dbits;
// JavaScript engine analysis
var $9f4698123987813e$var$canary = 0xdeadbeefcafe;
var $9f4698123987813e$var$j_lm = ($9f4698123987813e$var$canary & 0xffffff) == 0xefcafe;
// (public) Constructor
function $9f4698123987813e$var$BigInteger(a, b, c) {
    this.data = [];
    if (a != null) {
        if ("number" == typeof a) this.fromNumber(a, b, c);
        else if (b == null && "string" != typeof a) this.fromString(a, 256);
        else this.fromString(a, b);
    }
}
$fz7FM.jsbn.BigInteger = $9f4698123987813e$var$BigInteger;
// return new, unset BigInteger
function $9f4698123987813e$var$nbi() {
    return new $9f4698123987813e$var$BigInteger(null);
}
// am: Compute w_j += (x*this_i), propagate carries,
// c is initial carry, returns final carry.
// c < 3*dvalue, x < 2*dvalue, this_i < dvalue
// We need to select the fastest one that works in this environment.
// am1: use a single mult and divide to get the high bits,
// max digit bits should be 26 because
// max internal value = 2*dvalue^2-2*dvalue (< 2^53)
function $9f4698123987813e$var$am1(i, x, w, j, c, n) {
    while(--n >= 0){
        var v = x * this.data[i++] + w.data[j] + c;
        c = Math.floor(v / 0x4000000);
        w.data[j++] = v & 0x3ffffff;
    }
    return c;
}
// am2 avoids a big mult-and-extract completely.
// Max digit bits should be <= 30 because we do bitwise ops
// on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
function $9f4698123987813e$var$am2(i, x, w, j, c, n) {
    var xl = x & 0x7fff, xh = x >> 15;
    while(--n >= 0){
        var l = this.data[i] & 0x7fff;
        var h = this.data[i++] >> 15;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x7fff) << 15) + w.data[j] + (c & 0x3fffffff);
        c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
        w.data[j++] = l & 0x3fffffff;
    }
    return c;
}
// Alternately, set max digit bits to 28 since some
// browsers slow down when dealing with 32-bit numbers.
function $9f4698123987813e$var$am3(i, x, w, j, c, n) {
    var xl = x & 0x3fff, xh = x >> 14;
    while(--n >= 0){
        var l = this.data[i] & 0x3fff;
        var h = this.data[i++] >> 14;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x3fff) << 14) + w.data[j] + c;
        c = (l >> 28) + (m >> 14) + xh * h;
        w.data[j++] = l & 0xfffffff;
    }
    return c;
}
// node.js (no browser)
if (typeof navigator === "undefined") {
    $9f4698123987813e$var$BigInteger.prototype.am = $9f4698123987813e$var$am3;
    $9f4698123987813e$var$dbits = 28;
} else if ($9f4698123987813e$var$j_lm && navigator.appName == "Microsoft Internet Explorer") {
    $9f4698123987813e$var$BigInteger.prototype.am = $9f4698123987813e$var$am2;
    $9f4698123987813e$var$dbits = 30;
} else if ($9f4698123987813e$var$j_lm && navigator.appName != "Netscape") {
    $9f4698123987813e$var$BigInteger.prototype.am = $9f4698123987813e$var$am1;
    $9f4698123987813e$var$dbits = 26;
} else {
    $9f4698123987813e$var$BigInteger.prototype.am = $9f4698123987813e$var$am3;
    $9f4698123987813e$var$dbits = 28;
}
$9f4698123987813e$var$BigInteger.prototype.DB = $9f4698123987813e$var$dbits;
$9f4698123987813e$var$BigInteger.prototype.DM = (1 << $9f4698123987813e$var$dbits) - 1;
$9f4698123987813e$var$BigInteger.prototype.DV = 1 << $9f4698123987813e$var$dbits;
var $9f4698123987813e$var$BI_FP = 52;
$9f4698123987813e$var$BigInteger.prototype.FV = Math.pow(2, $9f4698123987813e$var$BI_FP);
$9f4698123987813e$var$BigInteger.prototype.F1 = $9f4698123987813e$var$BI_FP - $9f4698123987813e$var$dbits;
$9f4698123987813e$var$BigInteger.prototype.F2 = 2 * $9f4698123987813e$var$dbits - $9f4698123987813e$var$BI_FP;
// Digit conversions
var $9f4698123987813e$var$BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
var $9f4698123987813e$var$BI_RC = new Array();
var $9f4698123987813e$var$rr, $9f4698123987813e$var$vv;
$9f4698123987813e$var$rr = "0".charCodeAt(0);
for($9f4698123987813e$var$vv = 0; $9f4698123987813e$var$vv <= 9; ++$9f4698123987813e$var$vv)$9f4698123987813e$var$BI_RC[$9f4698123987813e$var$rr++] = $9f4698123987813e$var$vv;
$9f4698123987813e$var$rr = "a".charCodeAt(0);
for($9f4698123987813e$var$vv = 10; $9f4698123987813e$var$vv < 36; ++$9f4698123987813e$var$vv)$9f4698123987813e$var$BI_RC[$9f4698123987813e$var$rr++] = $9f4698123987813e$var$vv;
$9f4698123987813e$var$rr = "A".charCodeAt(0);
for($9f4698123987813e$var$vv = 10; $9f4698123987813e$var$vv < 36; ++$9f4698123987813e$var$vv)$9f4698123987813e$var$BI_RC[$9f4698123987813e$var$rr++] = $9f4698123987813e$var$vv;
function $9f4698123987813e$var$int2char(n) {
    return $9f4698123987813e$var$BI_RM.charAt(n);
}
function $9f4698123987813e$var$intAt(s, i) {
    var c = $9f4698123987813e$var$BI_RC[s.charCodeAt(i)];
    return c == null ? -1 : c;
}
// (protected) copy this to r
function $9f4698123987813e$var$bnpCopyTo(r) {
    for(var i = this.t - 1; i >= 0; --i)r.data[i] = this.data[i];
    r.t = this.t;
    r.s = this.s;
}
// (protected) set from integer value x, -DV <= x < DV
function $9f4698123987813e$var$bnpFromInt(x) {
    this.t = 1;
    this.s = x < 0 ? -1 : 0;
    if (x > 0) this.data[0] = x;
    else if (x < -1) this.data[0] = x + this.DV;
    else this.t = 0;
}
// return bigint initialized to value
function $9f4698123987813e$var$nbv(i) {
    var r = $9f4698123987813e$var$nbi();
    r.fromInt(i);
    return r;
}
// (protected) set from string and radix
function $9f4698123987813e$var$bnpFromString(s, b) {
    var k;
    if (b == 16) k = 4;
    else if (b == 8) k = 3;
    else if (b == 256) k = 8; // byte array
    else if (b == 2) k = 1;
    else if (b == 32) k = 5;
    else if (b == 4) k = 2;
    else {
        this.fromRadix(s, b);
        return;
    }
    this.t = 0;
    this.s = 0;
    var i = s.length, mi = false, sh = 0;
    while(--i >= 0){
        var x = k == 8 ? s[i] & 0xff : $9f4698123987813e$var$intAt(s, i);
        if (x < 0) {
            if (s.charAt(i) == "-") mi = true;
            continue;
        }
        mi = false;
        if (sh == 0) this.data[this.t++] = x;
        else if (sh + k > this.DB) {
            this.data[this.t - 1] |= (x & (1 << this.DB - sh) - 1) << sh;
            this.data[this.t++] = x >> this.DB - sh;
        } else this.data[this.t - 1] |= x << sh;
        sh += k;
        if (sh >= this.DB) sh -= this.DB;
    }
    if (k == 8 && (s[0] & 0x80) != 0) {
        this.s = -1;
        if (sh > 0) this.data[this.t - 1] |= (1 << this.DB - sh) - 1 << sh;
    }
    this.clamp();
    if (mi) $9f4698123987813e$var$BigInteger.ZERO.subTo(this, this);
}
// (protected) clamp off excess high words
function $9f4698123987813e$var$bnpClamp() {
    var c = this.s & this.DM;
    while(this.t > 0 && this.data[this.t - 1] == c)--this.t;
}
// (public) return string representation in given radix
function $9f4698123987813e$var$bnToString(b) {
    if (this.s < 0) return "-" + this.negate().toString(b);
    var k;
    if (b == 16) k = 4;
    else if (b == 8) k = 3;
    else if (b == 2) k = 1;
    else if (b == 32) k = 5;
    else if (b == 4) k = 2;
    else return this.toRadix(b);
    var km = (1 << k) - 1, d, m = false, r = "", i = this.t;
    var p = this.DB - i * this.DB % k;
    if (i-- > 0) {
        if (p < this.DB && (d = this.data[i] >> p) > 0) {
            m = true;
            r = $9f4698123987813e$var$int2char(d);
        }
        while(i >= 0){
            if (p < k) {
                d = (this.data[i] & (1 << p) - 1) << k - p;
                d |= this.data[--i] >> (p += this.DB - k);
            } else {
                d = this.data[i] >> (p -= k) & km;
                if (p <= 0) {
                    p += this.DB;
                    --i;
                }
            }
            if (d > 0) m = true;
            if (m) r += $9f4698123987813e$var$int2char(d);
        }
    }
    return m ? r : "0";
}
// (public) -this
function $9f4698123987813e$var$bnNegate() {
    var r = $9f4698123987813e$var$nbi();
    $9f4698123987813e$var$BigInteger.ZERO.subTo(this, r);
    return r;
}
// (public) |this|
function $9f4698123987813e$var$bnAbs() {
    return this.s < 0 ? this.negate() : this;
}
// (public) return + if this > a, - if this < a, 0 if equal
function $9f4698123987813e$var$bnCompareTo(a) {
    var r = this.s - a.s;
    if (r != 0) return r;
    var i = this.t;
    r = i - a.t;
    if (r != 0) return this.s < 0 ? -r : r;
    while(--i >= 0)if ((r = this.data[i] - a.data[i]) != 0) return r;
    return 0;
}
// returns bit length of the integer x
function $9f4698123987813e$var$nbits(x) {
    var r = 1, t;
    if ((t = x >>> 16) != 0) {
        x = t;
        r += 16;
    }
    if ((t = x >> 8) != 0) {
        x = t;
        r += 8;
    }
    if ((t = x >> 4) != 0) {
        x = t;
        r += 4;
    }
    if ((t = x >> 2) != 0) {
        x = t;
        r += 2;
    }
    if ((t = x >> 1) != 0) {
        x = t;
        r += 1;
    }
    return r;
}
// (public) return the number of bits in "this"
function $9f4698123987813e$var$bnBitLength() {
    if (this.t <= 0) return 0;
    return this.DB * (this.t - 1) + $9f4698123987813e$var$nbits(this.data[this.t - 1] ^ this.s & this.DM);
}
// (protected) r = this << n*DB
function $9f4698123987813e$var$bnpDLShiftTo(n, r) {
    var i;
    for(i = this.t - 1; i >= 0; --i)r.data[i + n] = this.data[i];
    for(i = n - 1; i >= 0; --i)r.data[i] = 0;
    r.t = this.t + n;
    r.s = this.s;
}
// (protected) r = this >> n*DB
function $9f4698123987813e$var$bnpDRShiftTo(n, r) {
    for(var i = n; i < this.t; ++i)r.data[i - n] = this.data[i];
    r.t = Math.max(this.t - n, 0);
    r.s = this.s;
}
// (protected) r = this << n
function $9f4698123987813e$var$bnpLShiftTo(n, r) {
    var bs = n % this.DB;
    var cbs = this.DB - bs;
    var bm = (1 << cbs) - 1;
    var ds = Math.floor(n / this.DB), c = this.s << bs & this.DM, i;
    for(i = this.t - 1; i >= 0; --i){
        r.data[i + ds + 1] = this.data[i] >> cbs | c;
        c = (this.data[i] & bm) << bs;
    }
    for(i = ds - 1; i >= 0; --i)r.data[i] = 0;
    r.data[ds] = c;
    r.t = this.t + ds + 1;
    r.s = this.s;
    r.clamp();
}
// (protected) r = this >> n
function $9f4698123987813e$var$bnpRShiftTo(n, r) {
    r.s = this.s;
    var ds = Math.floor(n / this.DB);
    if (ds >= this.t) {
        r.t = 0;
        return;
    }
    var bs = n % this.DB;
    var cbs = this.DB - bs;
    var bm = (1 << bs) - 1;
    r.data[0] = this.data[ds] >> bs;
    for(var i = ds + 1; i < this.t; ++i){
        r.data[i - ds - 1] |= (this.data[i] & bm) << cbs;
        r.data[i - ds] = this.data[i] >> bs;
    }
    if (bs > 0) r.data[this.t - ds - 1] |= (this.s & bm) << cbs;
    r.t = this.t - ds;
    r.clamp();
}
// (protected) r = this - a
function $9f4698123987813e$var$bnpSubTo(a, r) {
    var i = 0, c = 0, m = Math.min(a.t, this.t);
    while(i < m){
        c += this.data[i] - a.data[i];
        r.data[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c -= a.s;
        while(i < this.t){
            c += this.data[i];
            r.data[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c -= a.data[i];
            r.data[i++] = c & this.DM;
            c >>= this.DB;
        }
        c -= a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c < -1) r.data[i++] = this.DV + c;
    else if (c > 0) r.data[i++] = c;
    r.t = i;
    r.clamp();
}
// (protected) r = this * a, r != this,a (HAC 14.12)
// "this" should be the larger one if appropriate.
function $9f4698123987813e$var$bnpMultiplyTo(a, r) {
    var x = this.abs(), y = a.abs();
    var i = x.t;
    r.t = i + y.t;
    while(--i >= 0)r.data[i] = 0;
    for(i = 0; i < y.t; ++i)r.data[i + x.t] = x.am(0, y.data[i], r, i, 0, x.t);
    r.s = 0;
    r.clamp();
    if (this.s != a.s) $9f4698123987813e$var$BigInteger.ZERO.subTo(r, r);
}
// (protected) r = this^2, r != this (HAC 14.16)
function $9f4698123987813e$var$bnpSquareTo(r) {
    var x = this.abs();
    var i = r.t = 2 * x.t;
    while(--i >= 0)r.data[i] = 0;
    for(i = 0; i < x.t - 1; ++i){
        var c = x.am(i, x.data[i], r, 2 * i, 0, 1);
        if ((r.data[i + x.t] += x.am(i + 1, 2 * x.data[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
            r.data[i + x.t] -= x.DV;
            r.data[i + x.t + 1] = 1;
        }
    }
    if (r.t > 0) r.data[r.t - 1] += x.am(i, x.data[i], r, 2 * i, 0, 1);
    r.s = 0;
    r.clamp();
}
// (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
// r != q, this != m.  q or r may be null.
function $9f4698123987813e$var$bnpDivRemTo(m, q, r) {
    var pm = m.abs();
    if (pm.t <= 0) return;
    var pt = this.abs();
    if (pt.t < pm.t) {
        if (q != null) q.fromInt(0);
        if (r != null) this.copyTo(r);
        return;
    }
    if (r == null) r = $9f4698123987813e$var$nbi();
    var y = $9f4698123987813e$var$nbi(), ts = this.s, ms = m.s;
    var nsh = this.DB - $9f4698123987813e$var$nbits(pm.data[pm.t - 1]); // normalize modulus
    if (nsh > 0) {
        pm.lShiftTo(nsh, y);
        pt.lShiftTo(nsh, r);
    } else {
        pm.copyTo(y);
        pt.copyTo(r);
    }
    var ys = y.t;
    var y0 = y.data[ys - 1];
    if (y0 == 0) return;
    var yt = y0 * (1 << this.F1) + (ys > 1 ? y.data[ys - 2] >> this.F2 : 0);
    var d1 = this.FV / yt, d2 = (1 << this.F1) / yt, e = 1 << this.F2;
    var i = r.t, j = i - ys, t = q == null ? $9f4698123987813e$var$nbi() : q;
    y.dlShiftTo(j, t);
    if (r.compareTo(t) >= 0) {
        r.data[r.t++] = 1;
        r.subTo(t, r);
    }
    $9f4698123987813e$var$BigInteger.ONE.dlShiftTo(ys, t);
    t.subTo(y, y); // "negative" y so we can replace sub with am later
    while(y.t < ys)y.data[y.t++] = 0;
    while(--j >= 0){
        // Estimate quotient digit
        var qd = r.data[--i] == y0 ? this.DM : Math.floor(r.data[i] * d1 + (r.data[i - 1] + e) * d2);
        if ((r.data[i] += y.am(0, qd, r, j, 0, ys)) < qd) {
            y.dlShiftTo(j, t);
            r.subTo(t, r);
            while(r.data[i] < --qd)r.subTo(t, r);
        }
    }
    if (q != null) {
        r.drShiftTo(ys, q);
        if (ts != ms) $9f4698123987813e$var$BigInteger.ZERO.subTo(q, q);
    }
    r.t = ys;
    r.clamp();
    if (nsh > 0) r.rShiftTo(nsh, r); // Denormalize remainder
    if (ts < 0) $9f4698123987813e$var$BigInteger.ZERO.subTo(r, r);
}
// (public) this mod a
function $9f4698123987813e$var$bnMod(a) {
    var r = $9f4698123987813e$var$nbi();
    this.abs().divRemTo(a, null, r);
    if (this.s < 0 && r.compareTo($9f4698123987813e$var$BigInteger.ZERO) > 0) a.subTo(r, r);
    return r;
}
// Modular reduction using "classic" algorithm
function $9f4698123987813e$var$Classic(m) {
    this.m = m;
}
function $9f4698123987813e$var$cConvert(x) {
    if (x.s < 0 || x.compareTo(this.m) >= 0) return x.mod(this.m);
    else return x;
}
function $9f4698123987813e$var$cRevert(x) {
    return x;
}
function $9f4698123987813e$var$cReduce(x) {
    x.divRemTo(this.m, null, x);
}
function $9f4698123987813e$var$cMulTo(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
}
function $9f4698123987813e$var$cSqrTo(x, r) {
    x.squareTo(r);
    this.reduce(r);
}
$9f4698123987813e$var$Classic.prototype.convert = $9f4698123987813e$var$cConvert;
$9f4698123987813e$var$Classic.prototype.revert = $9f4698123987813e$var$cRevert;
$9f4698123987813e$var$Classic.prototype.reduce = $9f4698123987813e$var$cReduce;
$9f4698123987813e$var$Classic.prototype.mulTo = $9f4698123987813e$var$cMulTo;
$9f4698123987813e$var$Classic.prototype.sqrTo = $9f4698123987813e$var$cSqrTo;
// (protected) return "-1/this % 2^DB"; useful for Mont. reduction
// justification:
//         xy == 1 (mod m)
//         xy =  1+km
//   xy(2-xy) = (1+km)(1-km)
// x[y(2-xy)] = 1-k^2m^2
// x[y(2-xy)] == 1 (mod m^2)
// if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
// should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
// JS multiply "overflows" differently from C/C++, so care is needed here.
function $9f4698123987813e$var$bnpInvDigit() {
    if (this.t < 1) return 0;
    var x = this.data[0];
    if ((x & 1) == 0) return 0;
    var y = x & 3; // y == 1/x mod 2^2
    y = y * (2 - (x & 0xf) * y) & 0xf; // y == 1/x mod 2^4
    y = y * (2 - (x & 0xff) * y) & 0xff; // y == 1/x mod 2^8
    y = y * (2 - ((x & 0xffff) * y & 0xffff)) & 0xffff; // y == 1/x mod 2^16
    // last step - calculate inverse mod DV directly;
    // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
    y = y * (2 - x * y % this.DV) % this.DV; // y == 1/x mod 2^dbits
    // we really want the negative inverse, and -DV < y < DV
    return y > 0 ? this.DV - y : -y;
}
// Montgomery reduction
function $9f4698123987813e$var$Montgomery(m) {
    this.m = m;
    this.mp = m.invDigit();
    this.mpl = this.mp & 0x7fff;
    this.mph = this.mp >> 15;
    this.um = (1 << m.DB - 15) - 1;
    this.mt2 = 2 * m.t;
}
// xR mod m
function $9f4698123987813e$var$montConvert(x) {
    var r = $9f4698123987813e$var$nbi();
    x.abs().dlShiftTo(this.m.t, r);
    r.divRemTo(this.m, null, r);
    if (x.s < 0 && r.compareTo($9f4698123987813e$var$BigInteger.ZERO) > 0) this.m.subTo(r, r);
    return r;
}
// x/R mod m
function $9f4698123987813e$var$montRevert(x) {
    var r = $9f4698123987813e$var$nbi();
    x.copyTo(r);
    this.reduce(r);
    return r;
}
// x = x/R mod m (HAC 14.32)
function $9f4698123987813e$var$montReduce(x) {
    while(x.t <= this.mt2)x.data[x.t++] = 0;
    for(var i = 0; i < this.m.t; ++i){
        // faster way of calculating u0 = x.data[i]*mp mod DV
        var j = x.data[i] & 0x7fff;
        var u0 = j * this.mpl + ((j * this.mph + (x.data[i] >> 15) * this.mpl & this.um) << 15) & x.DM;
        // use am to combine the multiply-shift-add into one call
        j = i + this.m.t;
        x.data[j] += this.m.am(0, u0, x, i, 0, this.m.t);
        // propagate carry
        while(x.data[j] >= x.DV){
            x.data[j] -= x.DV;
            x.data[++j]++;
        }
    }
    x.clamp();
    x.drShiftTo(this.m.t, x);
    if (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
}
// r = "x^2/R mod m"; x != r
function $9f4698123987813e$var$montSqrTo(x, r) {
    x.squareTo(r);
    this.reduce(r);
}
// r = "xy/R mod m"; x,y != r
function $9f4698123987813e$var$montMulTo(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
}
$9f4698123987813e$var$Montgomery.prototype.convert = $9f4698123987813e$var$montConvert;
$9f4698123987813e$var$Montgomery.prototype.revert = $9f4698123987813e$var$montRevert;
$9f4698123987813e$var$Montgomery.prototype.reduce = $9f4698123987813e$var$montReduce;
$9f4698123987813e$var$Montgomery.prototype.mulTo = $9f4698123987813e$var$montMulTo;
$9f4698123987813e$var$Montgomery.prototype.sqrTo = $9f4698123987813e$var$montSqrTo;
// (protected) true iff this is even
function $9f4698123987813e$var$bnpIsEven() {
    return (this.t > 0 ? this.data[0] & 1 : this.s) == 0;
}
// (protected) this^e, e < 2^32, doing sqr and mul with "r" (HAC 14.79)
function $9f4698123987813e$var$bnpExp(e, z) {
    if (e > 0xffffffff || e < 1) return $9f4698123987813e$var$BigInteger.ONE;
    var r = $9f4698123987813e$var$nbi(), r2 = $9f4698123987813e$var$nbi(), g = z.convert(this), i = $9f4698123987813e$var$nbits(e) - 1;
    g.copyTo(r);
    while(--i >= 0){
        z.sqrTo(r, r2);
        if ((e & 1 << i) > 0) z.mulTo(r2, g, r);
        else {
            var t = r;
            r = r2;
            r2 = t;
        }
    }
    return z.revert(r);
}
// (public) this^e % m, 0 <= e < 2^32
function $9f4698123987813e$var$bnModPowInt(e, m) {
    var z;
    if (e < 256 || m.isEven()) z = new $9f4698123987813e$var$Classic(m);
    else z = new $9f4698123987813e$var$Montgomery(m);
    return this.exp(e, z);
}
// protected
$9f4698123987813e$var$BigInteger.prototype.copyTo = $9f4698123987813e$var$bnpCopyTo;
$9f4698123987813e$var$BigInteger.prototype.fromInt = $9f4698123987813e$var$bnpFromInt;
$9f4698123987813e$var$BigInteger.prototype.fromString = $9f4698123987813e$var$bnpFromString;
$9f4698123987813e$var$BigInteger.prototype.clamp = $9f4698123987813e$var$bnpClamp;
$9f4698123987813e$var$BigInteger.prototype.dlShiftTo = $9f4698123987813e$var$bnpDLShiftTo;
$9f4698123987813e$var$BigInteger.prototype.drShiftTo = $9f4698123987813e$var$bnpDRShiftTo;
$9f4698123987813e$var$BigInteger.prototype.lShiftTo = $9f4698123987813e$var$bnpLShiftTo;
$9f4698123987813e$var$BigInteger.prototype.rShiftTo = $9f4698123987813e$var$bnpRShiftTo;
$9f4698123987813e$var$BigInteger.prototype.subTo = $9f4698123987813e$var$bnpSubTo;
$9f4698123987813e$var$BigInteger.prototype.multiplyTo = $9f4698123987813e$var$bnpMultiplyTo;
$9f4698123987813e$var$BigInteger.prototype.squareTo = $9f4698123987813e$var$bnpSquareTo;
$9f4698123987813e$var$BigInteger.prototype.divRemTo = $9f4698123987813e$var$bnpDivRemTo;
$9f4698123987813e$var$BigInteger.prototype.invDigit = $9f4698123987813e$var$bnpInvDigit;
$9f4698123987813e$var$BigInteger.prototype.isEven = $9f4698123987813e$var$bnpIsEven;
$9f4698123987813e$var$BigInteger.prototype.exp = $9f4698123987813e$var$bnpExp;
// public
$9f4698123987813e$var$BigInteger.prototype.toString = $9f4698123987813e$var$bnToString;
$9f4698123987813e$var$BigInteger.prototype.negate = $9f4698123987813e$var$bnNegate;
$9f4698123987813e$var$BigInteger.prototype.abs = $9f4698123987813e$var$bnAbs;
$9f4698123987813e$var$BigInteger.prototype.compareTo = $9f4698123987813e$var$bnCompareTo;
$9f4698123987813e$var$BigInteger.prototype.bitLength = $9f4698123987813e$var$bnBitLength;
$9f4698123987813e$var$BigInteger.prototype.mod = $9f4698123987813e$var$bnMod;
$9f4698123987813e$var$BigInteger.prototype.modPowInt = $9f4698123987813e$var$bnModPowInt;
// "constants"
$9f4698123987813e$var$BigInteger.ZERO = $9f4698123987813e$var$nbv(0);
$9f4698123987813e$var$BigInteger.ONE = $9f4698123987813e$var$nbv(1);
// jsbn2 lib
//Copyright (c) 2005-2009  Tom Wu
//All Rights Reserved.
//See "LICENSE" for details (See jsbn.js for LICENSE).
//Extended JavaScript BN functions, required for RSA private ops.
//Version 1.1: new BigInteger("0", 10) returns "proper" zero
//(public)
function $9f4698123987813e$var$bnClone() {
    var r = $9f4698123987813e$var$nbi();
    this.copyTo(r);
    return r;
}
//(public) return value as integer
function $9f4698123987813e$var$bnIntValue() {
    if (this.s < 0) {
        if (this.t == 1) return this.data[0] - this.DV;
        else if (this.t == 0) return -1;
    } else if (this.t == 1) return this.data[0];
    else if (this.t == 0) return 0;
    // assumes 16 < DB < 32
    return (this.data[1] & (1 << 32 - this.DB) - 1) << this.DB | this.data[0];
}
//(public) return value as byte
function $9f4698123987813e$var$bnByteValue() {
    return this.t == 0 ? this.s : this.data[0] << 24 >> 24;
}
//(public) return value as short (assumes DB>=16)
function $9f4698123987813e$var$bnShortValue() {
    return this.t == 0 ? this.s : this.data[0] << 16 >> 16;
}
//(protected) return x s.t. r^x < DV
function $9f4698123987813e$var$bnpChunkSize(r) {
    return Math.floor(Math.LN2 * this.DB / Math.log(r));
}
//(public) 0 if this == 0, 1 if this > 0
function $9f4698123987813e$var$bnSigNum() {
    if (this.s < 0) return -1;
    else if (this.t <= 0 || this.t == 1 && this.data[0] <= 0) return 0;
    else return 1;
}
//(protected) convert to radix string
function $9f4698123987813e$var$bnpToRadix(b) {
    if (b == null) b = 10;
    if (this.signum() == 0 || b < 2 || b > 36) return "0";
    var cs = this.chunkSize(b);
    var a = Math.pow(b, cs);
    var d = $9f4698123987813e$var$nbv(a), y = $9f4698123987813e$var$nbi(), z = $9f4698123987813e$var$nbi(), r = "";
    this.divRemTo(d, y, z);
    while(y.signum() > 0){
        r = (a + z.intValue()).toString(b).substr(1) + r;
        y.divRemTo(d, y, z);
    }
    return z.intValue().toString(b) + r;
}
//(protected) convert from radix string
function $9f4698123987813e$var$bnpFromRadix(s, b) {
    this.fromInt(0);
    if (b == null) b = 10;
    var cs = this.chunkSize(b);
    var d = Math.pow(b, cs), mi = false, j = 0, w = 0;
    for(var i = 0; i < s.length; ++i){
        var x = $9f4698123987813e$var$intAt(s, i);
        if (x < 0) {
            if (s.charAt(i) == "-" && this.signum() == 0) mi = true;
            continue;
        }
        w = b * w + x;
        if (++j >= cs) {
            this.dMultiply(d);
            this.dAddOffset(w, 0);
            j = 0;
            w = 0;
        }
    }
    if (j > 0) {
        this.dMultiply(Math.pow(b, j));
        this.dAddOffset(w, 0);
    }
    if (mi) $9f4698123987813e$var$BigInteger.ZERO.subTo(this, this);
}
//(protected) alternate constructor
function $9f4698123987813e$var$bnpFromNumber(a, b, c) {
    if ("number" == typeof b) {
        // new BigInteger(int,int,RNG)
        if (a < 2) this.fromInt(1);
        else {
            this.fromNumber(a, c);
            if (!this.testBit(a - 1)) this.bitwiseTo($9f4698123987813e$var$BigInteger.ONE.shiftLeft(a - 1), $9f4698123987813e$var$op_or, this);
            if (this.isEven()) this.dAddOffset(1, 0); // force odd
            while(!this.isProbablePrime(b)){
                this.dAddOffset(2, 0);
                if (this.bitLength() > a) this.subTo($9f4698123987813e$var$BigInteger.ONE.shiftLeft(a - 1), this);
            }
        }
    } else {
        // new BigInteger(int,RNG)
        var x = new Array(), t = a & 7;
        x.length = (a >> 3) + 1;
        b.nextBytes(x);
        if (t > 0) x[0] &= (1 << t) - 1;
        else x[0] = 0;
        this.fromString(x, 256);
    }
}
//(public) convert to bigendian byte array
function $9f4698123987813e$var$bnToByteArray() {
    var i = this.t, r = new Array();
    r[0] = this.s;
    var p = this.DB - i * this.DB % 8, d, k = 0;
    if (i-- > 0) {
        if (p < this.DB && (d = this.data[i] >> p) != (this.s & this.DM) >> p) r[k++] = d | this.s << this.DB - p;
        while(i >= 0){
            if (p < 8) {
                d = (this.data[i] & (1 << p) - 1) << 8 - p;
                d |= this.data[--i] >> (p += this.DB - 8);
            } else {
                d = this.data[i] >> (p -= 8) & 0xff;
                if (p <= 0) {
                    p += this.DB;
                    --i;
                }
            }
            if ((d & 0x80) != 0) d |= -256;
            if (k == 0 && (this.s & 0x80) != (d & 0x80)) ++k;
            if (k > 0 || d != this.s) r[k++] = d;
        }
    }
    return r;
}
function $9f4698123987813e$var$bnEquals(a) {
    return this.compareTo(a) == 0;
}
function $9f4698123987813e$var$bnMin(a) {
    return this.compareTo(a) < 0 ? this : a;
}
function $9f4698123987813e$var$bnMax(a) {
    return this.compareTo(a) > 0 ? this : a;
}
//(protected) r = this op a (bitwise)
function $9f4698123987813e$var$bnpBitwiseTo(a, op, r) {
    var i, f, m = Math.min(a.t, this.t);
    for(i = 0; i < m; ++i)r.data[i] = op(this.data[i], a.data[i]);
    if (a.t < this.t) {
        f = a.s & this.DM;
        for(i = m; i < this.t; ++i)r.data[i] = op(this.data[i], f);
        r.t = this.t;
    } else {
        f = this.s & this.DM;
        for(i = m; i < a.t; ++i)r.data[i] = op(f, a.data[i]);
        r.t = a.t;
    }
    r.s = op(this.s, a.s);
    r.clamp();
}
//(public) this & a
function $9f4698123987813e$var$op_and(x, y) {
    return x & y;
}
function $9f4698123987813e$var$bnAnd(a) {
    var r = $9f4698123987813e$var$nbi();
    this.bitwiseTo(a, $9f4698123987813e$var$op_and, r);
    return r;
}
//(public) this | a
function $9f4698123987813e$var$op_or(x, y) {
    return x | y;
}
function $9f4698123987813e$var$bnOr(a) {
    var r = $9f4698123987813e$var$nbi();
    this.bitwiseTo(a, $9f4698123987813e$var$op_or, r);
    return r;
}
//(public) this ^ a
function $9f4698123987813e$var$op_xor(x, y) {
    return x ^ y;
}
function $9f4698123987813e$var$bnXor(a) {
    var r = $9f4698123987813e$var$nbi();
    this.bitwiseTo(a, $9f4698123987813e$var$op_xor, r);
    return r;
}
//(public) this & ~a
function $9f4698123987813e$var$op_andnot(x, y) {
    return x & ~y;
}
function $9f4698123987813e$var$bnAndNot(a) {
    var r = $9f4698123987813e$var$nbi();
    this.bitwiseTo(a, $9f4698123987813e$var$op_andnot, r);
    return r;
}
//(public) ~this
function $9f4698123987813e$var$bnNot() {
    var r = $9f4698123987813e$var$nbi();
    for(var i = 0; i < this.t; ++i)r.data[i] = this.DM & ~this.data[i];
    r.t = this.t;
    r.s = ~this.s;
    return r;
}
//(public) this << n
function $9f4698123987813e$var$bnShiftLeft(n) {
    var r = $9f4698123987813e$var$nbi();
    if (n < 0) this.rShiftTo(-n, r);
    else this.lShiftTo(n, r);
    return r;
}
//(public) this >> n
function $9f4698123987813e$var$bnShiftRight(n) {
    var r = $9f4698123987813e$var$nbi();
    if (n < 0) this.lShiftTo(-n, r);
    else this.rShiftTo(n, r);
    return r;
}
//return index of lowest 1-bit in x, x < 2^31
function $9f4698123987813e$var$lbit(x) {
    if (x == 0) return -1;
    var r = 0;
    if ((x & 0xffff) == 0) {
        x >>= 16;
        r += 16;
    }
    if ((x & 0xff) == 0) {
        x >>= 8;
        r += 8;
    }
    if ((x & 0xf) == 0) {
        x >>= 4;
        r += 4;
    }
    if ((x & 3) == 0) {
        x >>= 2;
        r += 2;
    }
    if ((x & 1) == 0) ++r;
    return r;
}
//(public) returns index of lowest 1-bit (or -1 if none)
function $9f4698123987813e$var$bnGetLowestSetBit() {
    for(var i = 0; i < this.t; ++i)if (this.data[i] != 0) return i * this.DB + $9f4698123987813e$var$lbit(this.data[i]);
    if (this.s < 0) return this.t * this.DB;
    return -1;
}
//return number of 1 bits in x
function $9f4698123987813e$var$cbit(x) {
    var r = 0;
    while(x != 0){
        x &= x - 1;
        ++r;
    }
    return r;
}
//(public) return number of set bits
function $9f4698123987813e$var$bnBitCount() {
    var r = 0, x = this.s & this.DM;
    for(var i = 0; i < this.t; ++i)r += $9f4698123987813e$var$cbit(this.data[i] ^ x);
    return r;
}
//(public) true iff nth bit is set
function $9f4698123987813e$var$bnTestBit(n) {
    var j = Math.floor(n / this.DB);
    if (j >= this.t) return this.s != 0;
    return (this.data[j] & 1 << n % this.DB) != 0;
}
//(protected) this op (1<<n)
function $9f4698123987813e$var$bnpChangeBit(n, op) {
    var r = $9f4698123987813e$var$BigInteger.ONE.shiftLeft(n);
    this.bitwiseTo(r, op, r);
    return r;
}
//(public) this | (1<<n)
function $9f4698123987813e$var$bnSetBit(n) {
    return this.changeBit(n, $9f4698123987813e$var$op_or);
}
//(public) this & ~(1<<n)
function $9f4698123987813e$var$bnClearBit(n) {
    return this.changeBit(n, $9f4698123987813e$var$op_andnot);
}
//(public) this ^ (1<<n)
function $9f4698123987813e$var$bnFlipBit(n) {
    return this.changeBit(n, $9f4698123987813e$var$op_xor);
}
//(protected) r = this + a
function $9f4698123987813e$var$bnpAddTo(a, r) {
    var i = 0, c = 0, m = Math.min(a.t, this.t);
    while(i < m){
        c += this.data[i] + a.data[i];
        r.data[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c += a.s;
        while(i < this.t){
            c += this.data[i];
            r.data[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c += a.data[i];
            r.data[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c > 0) r.data[i++] = c;
    else if (c < -1) r.data[i++] = this.DV + c;
    r.t = i;
    r.clamp();
}
//(public) this + a
function $9f4698123987813e$var$bnAdd(a) {
    var r = $9f4698123987813e$var$nbi();
    this.addTo(a, r);
    return r;
}
//(public) this - a
function $9f4698123987813e$var$bnSubtract(a) {
    var r = $9f4698123987813e$var$nbi();
    this.subTo(a, r);
    return r;
}
//(public) this * a
function $9f4698123987813e$var$bnMultiply(a) {
    var r = $9f4698123987813e$var$nbi();
    this.multiplyTo(a, r);
    return r;
}
//(public) this / a
function $9f4698123987813e$var$bnDivide(a) {
    var r = $9f4698123987813e$var$nbi();
    this.divRemTo(a, r, null);
    return r;
}
//(public) this % a
function $9f4698123987813e$var$bnRemainder(a) {
    var r = $9f4698123987813e$var$nbi();
    this.divRemTo(a, null, r);
    return r;
}
//(public) [this/a,this%a]
function $9f4698123987813e$var$bnDivideAndRemainder(a) {
    var q = $9f4698123987813e$var$nbi(), r = $9f4698123987813e$var$nbi();
    this.divRemTo(a, q, r);
    return new Array(q, r);
}
//(protected) this *= n, this >= 0, 1 < n < DV
function $9f4698123987813e$var$bnpDMultiply(n) {
    this.data[this.t] = this.am(0, n - 1, this, 0, 0, this.t);
    ++this.t;
    this.clamp();
}
//(protected) this += n << w words, this >= 0
function $9f4698123987813e$var$bnpDAddOffset(n, w) {
    if (n == 0) return;
    while(this.t <= w)this.data[this.t++] = 0;
    this.data[w] += n;
    while(this.data[w] >= this.DV){
        this.data[w] -= this.DV;
        if (++w >= this.t) this.data[this.t++] = 0;
        ++this.data[w];
    }
}
//A "null" reducer
function $9f4698123987813e$var$NullExp() {}
function $9f4698123987813e$var$nNop(x) {
    return x;
}
function $9f4698123987813e$var$nMulTo(x, y, r) {
    x.multiplyTo(y, r);
}
function $9f4698123987813e$var$nSqrTo(x, r) {
    x.squareTo(r);
}
$9f4698123987813e$var$NullExp.prototype.convert = $9f4698123987813e$var$nNop;
$9f4698123987813e$var$NullExp.prototype.revert = $9f4698123987813e$var$nNop;
$9f4698123987813e$var$NullExp.prototype.mulTo = $9f4698123987813e$var$nMulTo;
$9f4698123987813e$var$NullExp.prototype.sqrTo = $9f4698123987813e$var$nSqrTo;
//(public) this^e
function $9f4698123987813e$var$bnPow(e) {
    return this.exp(e, new $9f4698123987813e$var$NullExp());
}
//(protected) r = lower n words of "this * a", a.t <= n
//"this" should be the larger one if appropriate.
function $9f4698123987813e$var$bnpMultiplyLowerTo(a, n, r) {
    var i = Math.min(this.t + a.t, n);
    r.s = 0; // assumes a,this >= 0
    r.t = i;
    while(i > 0)r.data[--i] = 0;
    var j;
    for(j = r.t - this.t; i < j; ++i)r.data[i + this.t] = this.am(0, a.data[i], r, i, 0, this.t);
    for(j = Math.min(a.t, n); i < j; ++i)this.am(0, a.data[i], r, i, 0, n - i);
    r.clamp();
}
//(protected) r = "this * a" without lower n words, n > 0
//"this" should be the larger one if appropriate.
function $9f4698123987813e$var$bnpMultiplyUpperTo(a, n, r) {
    --n;
    var i = r.t = this.t + a.t - n;
    r.s = 0; // assumes a,this >= 0
    while(--i >= 0)r.data[i] = 0;
    for(i = Math.max(n - this.t, 0); i < a.t; ++i)r.data[this.t + i - n] = this.am(n - i, a.data[i], r, 0, 0, this.t + i - n);
    r.clamp();
    r.drShiftTo(1, r);
}
//Barrett modular reduction
function $9f4698123987813e$var$Barrett(m) {
    // setup Barrett
    this.r2 = $9f4698123987813e$var$nbi();
    this.q3 = $9f4698123987813e$var$nbi();
    $9f4698123987813e$var$BigInteger.ONE.dlShiftTo(2 * m.t, this.r2);
    this.mu = this.r2.divide(m);
    this.m = m;
}
function $9f4698123987813e$var$barrettConvert(x) {
    if (x.s < 0 || x.t > 2 * this.m.t) return x.mod(this.m);
    else if (x.compareTo(this.m) < 0) return x;
    else {
        var r = $9f4698123987813e$var$nbi();
        x.copyTo(r);
        this.reduce(r);
        return r;
    }
}
function $9f4698123987813e$var$barrettRevert(x) {
    return x;
}
//x = x mod m (HAC 14.42)
function $9f4698123987813e$var$barrettReduce(x) {
    x.drShiftTo(this.m.t - 1, this.r2);
    if (x.t > this.m.t + 1) {
        x.t = this.m.t + 1;
        x.clamp();
    }
    this.mu.multiplyUpperTo(this.r2, this.m.t + 1, this.q3);
    this.m.multiplyLowerTo(this.q3, this.m.t + 1, this.r2);
    while(x.compareTo(this.r2) < 0)x.dAddOffset(1, this.m.t + 1);
    x.subTo(this.r2, x);
    while(x.compareTo(this.m) >= 0)x.subTo(this.m, x);
}
//r = x^2 mod m; x != r
function $9f4698123987813e$var$barrettSqrTo(x, r) {
    x.squareTo(r);
    this.reduce(r);
}
//r = x*y mod m; x,y != r
function $9f4698123987813e$var$barrettMulTo(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
}
$9f4698123987813e$var$Barrett.prototype.convert = $9f4698123987813e$var$barrettConvert;
$9f4698123987813e$var$Barrett.prototype.revert = $9f4698123987813e$var$barrettRevert;
$9f4698123987813e$var$Barrett.prototype.reduce = $9f4698123987813e$var$barrettReduce;
$9f4698123987813e$var$Barrett.prototype.mulTo = $9f4698123987813e$var$barrettMulTo;
$9f4698123987813e$var$Barrett.prototype.sqrTo = $9f4698123987813e$var$barrettSqrTo;
//(public) this^e % m (HAC 14.85)
function $9f4698123987813e$var$bnModPow(e, m) {
    var i = e.bitLength(), k, r = $9f4698123987813e$var$nbv(1), z;
    if (i <= 0) return r;
    else if (i < 18) k = 1;
    else if (i < 48) k = 3;
    else if (i < 144) k = 4;
    else if (i < 768) k = 5;
    else k = 6;
    if (i < 8) z = new $9f4698123987813e$var$Classic(m);
    else if (m.isEven()) z = new $9f4698123987813e$var$Barrett(m);
    else z = new $9f4698123987813e$var$Montgomery(m);
    // precomputation
    var g = new Array(), n = 3, k1 = k - 1, km = (1 << k) - 1;
    g[1] = z.convert(this);
    if (k > 1) {
        var g2 = $9f4698123987813e$var$nbi();
        z.sqrTo(g[1], g2);
        while(n <= km){
            g[n] = $9f4698123987813e$var$nbi();
            z.mulTo(g2, g[n - 2], g[n]);
            n += 2;
        }
    }
    var j = e.t - 1, w, is1 = true, r2 = $9f4698123987813e$var$nbi(), t;
    i = $9f4698123987813e$var$nbits(e.data[j]) - 1;
    while(j >= 0){
        if (i >= k1) w = e.data[j] >> i - k1 & km;
        else {
            w = (e.data[j] & (1 << i + 1) - 1) << k1 - i;
            if (j > 0) w |= e.data[j - 1] >> this.DB + i - k1;
        }
        n = k;
        while((w & 1) == 0){
            w >>= 1;
            --n;
        }
        if ((i -= n) < 0) {
            i += this.DB;
            --j;
        }
        if (is1) {
            g[w].copyTo(r);
            is1 = false;
        } else {
            while(n > 1){
                z.sqrTo(r, r2);
                z.sqrTo(r2, r);
                n -= 2;
            }
            if (n > 0) z.sqrTo(r, r2);
            else {
                t = r;
                r = r2;
                r2 = t;
            }
            z.mulTo(r2, g[w], r);
        }
        while(j >= 0 && (e.data[j] & 1 << i) == 0){
            z.sqrTo(r, r2);
            t = r;
            r = r2;
            r2 = t;
            if (--i < 0) {
                i = this.DB - 1;
                --j;
            }
        }
    }
    return z.revert(r);
}
//(public) gcd(this,a) (HAC 14.54)
function $9f4698123987813e$var$bnGCD(a) {
    var x = this.s < 0 ? this.negate() : this.clone();
    var y = a.s < 0 ? a.negate() : a.clone();
    if (x.compareTo(y) < 0) {
        var t = x;
        x = y;
        y = t;
    }
    var i = x.getLowestSetBit(), g = y.getLowestSetBit();
    if (g < 0) return x;
    if (i < g) g = i;
    if (g > 0) {
        x.rShiftTo(g, x);
        y.rShiftTo(g, y);
    }
    while(x.signum() > 0){
        if ((i = x.getLowestSetBit()) > 0) x.rShiftTo(i, x);
        if ((i = y.getLowestSetBit()) > 0) y.rShiftTo(i, y);
        if (x.compareTo(y) >= 0) {
            x.subTo(y, x);
            x.rShiftTo(1, x);
        } else {
            y.subTo(x, y);
            y.rShiftTo(1, y);
        }
    }
    if (g > 0) y.lShiftTo(g, y);
    return y;
}
//(protected) this % n, n < 2^26
function $9f4698123987813e$var$bnpModInt(n) {
    if (n <= 0) return 0;
    var d = this.DV % n, r = this.s < 0 ? n - 1 : 0;
    if (this.t > 0) {
        if (d == 0) r = this.data[0] % n;
        else for(var i = this.t - 1; i >= 0; --i)r = (d * r + this.data[i]) % n;
    }
    return r;
}
//(public) 1/this % m (HAC 14.61)
function $9f4698123987813e$var$bnModInverse(m) {
    var ac = m.isEven();
    if (this.isEven() && ac || m.signum() == 0) return $9f4698123987813e$var$BigInteger.ZERO;
    var u = m.clone(), v = this.clone();
    var a = $9f4698123987813e$var$nbv(1), b = $9f4698123987813e$var$nbv(0), c = $9f4698123987813e$var$nbv(0), d = $9f4698123987813e$var$nbv(1);
    while(u.signum() != 0){
        while(u.isEven()){
            u.rShiftTo(1, u);
            if (ac) {
                if (!a.isEven() || !b.isEven()) {
                    a.addTo(this, a);
                    b.subTo(m, b);
                }
                a.rShiftTo(1, a);
            } else if (!b.isEven()) b.subTo(m, b);
            b.rShiftTo(1, b);
        }
        while(v.isEven()){
            v.rShiftTo(1, v);
            if (ac) {
                if (!c.isEven() || !d.isEven()) {
                    c.addTo(this, c);
                    d.subTo(m, d);
                }
                c.rShiftTo(1, c);
            } else if (!d.isEven()) d.subTo(m, d);
            d.rShiftTo(1, d);
        }
        if (u.compareTo(v) >= 0) {
            u.subTo(v, u);
            if (ac) a.subTo(c, a);
            b.subTo(d, b);
        } else {
            v.subTo(u, v);
            if (ac) c.subTo(a, c);
            d.subTo(b, d);
        }
    }
    if (v.compareTo($9f4698123987813e$var$BigInteger.ONE) != 0) return $9f4698123987813e$var$BigInteger.ZERO;
    if (d.compareTo(m) >= 0) return d.subtract(m);
    if (d.signum() < 0) d.addTo(m, d);
    else return d;
    if (d.signum() < 0) return d.add(m);
    else return d;
}
var $9f4698123987813e$var$lowprimes = [
    2,
    3,
    5,
    7,
    11,
    13,
    17,
    19,
    23,
    29,
    31,
    37,
    41,
    43,
    47,
    53,
    59,
    61,
    67,
    71,
    73,
    79,
    83,
    89,
    97,
    101,
    103,
    107,
    109,
    113,
    127,
    131,
    137,
    139,
    149,
    151,
    157,
    163,
    167,
    173,
    179,
    181,
    191,
    193,
    197,
    199,
    211,
    223,
    227,
    229,
    233,
    239,
    241,
    251,
    257,
    263,
    269,
    271,
    277,
    281,
    283,
    293,
    307,
    311,
    313,
    317,
    331,
    337,
    347,
    349,
    353,
    359,
    367,
    373,
    379,
    383,
    389,
    397,
    401,
    409,
    419,
    421,
    431,
    433,
    439,
    443,
    449,
    457,
    461,
    463,
    467,
    479,
    487,
    491,
    499,
    503,
    509
];
var $9f4698123987813e$var$lplim = 67108864 / $9f4698123987813e$var$lowprimes[$9f4698123987813e$var$lowprimes.length - 1];
//(public) test primality with certainty >= 1-.5^t
function $9f4698123987813e$var$bnIsProbablePrime(t) {
    var i, x = this.abs();
    if (x.t == 1 && x.data[0] <= $9f4698123987813e$var$lowprimes[$9f4698123987813e$var$lowprimes.length - 1]) {
        for(i = 0; i < $9f4698123987813e$var$lowprimes.length; ++i)if (x.data[0] == $9f4698123987813e$var$lowprimes[i]) return true;
        return false;
    }
    if (x.isEven()) return false;
    i = 1;
    while(i < $9f4698123987813e$var$lowprimes.length){
        var m = $9f4698123987813e$var$lowprimes[i], j = i + 1;
        while(j < $9f4698123987813e$var$lowprimes.length && m < $9f4698123987813e$var$lplim)m *= $9f4698123987813e$var$lowprimes[j++];
        m = x.modInt(m);
        while(i < j)if (m % $9f4698123987813e$var$lowprimes[i++] == 0) return false;
    }
    return x.millerRabin(t);
}
//(protected) true if probably prime (HAC 4.24, Miller-Rabin)
function $9f4698123987813e$var$bnpMillerRabin(t) {
    var n1 = this.subtract($9f4698123987813e$var$BigInteger.ONE);
    var k = n1.getLowestSetBit();
    if (k <= 0) return false;
    var r = n1.shiftRight(k);
    var prng = $9f4698123987813e$var$bnGetPrng();
    var a;
    for(var i = 0; i < t; ++i){
        // select witness 'a' at random from between 1 and n1
        do a = new $9f4698123987813e$var$BigInteger(this.bitLength(), prng);
        while (a.compareTo($9f4698123987813e$var$BigInteger.ONE) <= 0 || a.compareTo(n1) >= 0);
        var y = a.modPow(r, this);
        if (y.compareTo($9f4698123987813e$var$BigInteger.ONE) != 0 && y.compareTo(n1) != 0) {
            var j = 1;
            while(j++ < k && y.compareTo(n1) != 0){
                y = y.modPowInt(2, this);
                if (y.compareTo($9f4698123987813e$var$BigInteger.ONE) == 0) return false;
            }
            if (y.compareTo(n1) != 0) return false;
        }
    }
    return true;
}
// get pseudo random number generator
function $9f4698123987813e$var$bnGetPrng() {
    // create prng with api that matches BigInteger secure random
    return {
        // x is an array to fill with bytes
        nextBytes: function nextBytes(x) {
            for(var i = 0; i < x.length; ++i)x[i] = Math.floor(Math.random() * 0x0100);
        }
    };
}
//protected
$9f4698123987813e$var$BigInteger.prototype.chunkSize = $9f4698123987813e$var$bnpChunkSize;
$9f4698123987813e$var$BigInteger.prototype.toRadix = $9f4698123987813e$var$bnpToRadix;
$9f4698123987813e$var$BigInteger.prototype.fromRadix = $9f4698123987813e$var$bnpFromRadix;
$9f4698123987813e$var$BigInteger.prototype.fromNumber = $9f4698123987813e$var$bnpFromNumber;
$9f4698123987813e$var$BigInteger.prototype.bitwiseTo = $9f4698123987813e$var$bnpBitwiseTo;
$9f4698123987813e$var$BigInteger.prototype.changeBit = $9f4698123987813e$var$bnpChangeBit;
$9f4698123987813e$var$BigInteger.prototype.addTo = $9f4698123987813e$var$bnpAddTo;
$9f4698123987813e$var$BigInteger.prototype.dMultiply = $9f4698123987813e$var$bnpDMultiply;
$9f4698123987813e$var$BigInteger.prototype.dAddOffset = $9f4698123987813e$var$bnpDAddOffset;
$9f4698123987813e$var$BigInteger.prototype.multiplyLowerTo = $9f4698123987813e$var$bnpMultiplyLowerTo;
$9f4698123987813e$var$BigInteger.prototype.multiplyUpperTo = $9f4698123987813e$var$bnpMultiplyUpperTo;
$9f4698123987813e$var$BigInteger.prototype.modInt = $9f4698123987813e$var$bnpModInt;
$9f4698123987813e$var$BigInteger.prototype.millerRabin = $9f4698123987813e$var$bnpMillerRabin;
//public
$9f4698123987813e$var$BigInteger.prototype.clone = $9f4698123987813e$var$bnClone;
$9f4698123987813e$var$BigInteger.prototype.intValue = $9f4698123987813e$var$bnIntValue;
$9f4698123987813e$var$BigInteger.prototype.byteValue = $9f4698123987813e$var$bnByteValue;
$9f4698123987813e$var$BigInteger.prototype.shortValue = $9f4698123987813e$var$bnShortValue;
$9f4698123987813e$var$BigInteger.prototype.signum = $9f4698123987813e$var$bnSigNum;
$9f4698123987813e$var$BigInteger.prototype.toByteArray = $9f4698123987813e$var$bnToByteArray;
$9f4698123987813e$var$BigInteger.prototype.equals = $9f4698123987813e$var$bnEquals;
$9f4698123987813e$var$BigInteger.prototype.min = $9f4698123987813e$var$bnMin;
$9f4698123987813e$var$BigInteger.prototype.max = $9f4698123987813e$var$bnMax;
$9f4698123987813e$var$BigInteger.prototype.and = $9f4698123987813e$var$bnAnd;
$9f4698123987813e$var$BigInteger.prototype.or = $9f4698123987813e$var$bnOr;
$9f4698123987813e$var$BigInteger.prototype.xor = $9f4698123987813e$var$bnXor;
$9f4698123987813e$var$BigInteger.prototype.andNot = $9f4698123987813e$var$bnAndNot;
$9f4698123987813e$var$BigInteger.prototype.not = $9f4698123987813e$var$bnNot;
$9f4698123987813e$var$BigInteger.prototype.shiftLeft = $9f4698123987813e$var$bnShiftLeft;
$9f4698123987813e$var$BigInteger.prototype.shiftRight = $9f4698123987813e$var$bnShiftRight;
$9f4698123987813e$var$BigInteger.prototype.getLowestSetBit = $9f4698123987813e$var$bnGetLowestSetBit;
$9f4698123987813e$var$BigInteger.prototype.bitCount = $9f4698123987813e$var$bnBitCount;
$9f4698123987813e$var$BigInteger.prototype.testBit = $9f4698123987813e$var$bnTestBit;
$9f4698123987813e$var$BigInteger.prototype.setBit = $9f4698123987813e$var$bnSetBit;
$9f4698123987813e$var$BigInteger.prototype.clearBit = $9f4698123987813e$var$bnClearBit;
$9f4698123987813e$var$BigInteger.prototype.flipBit = $9f4698123987813e$var$bnFlipBit;
$9f4698123987813e$var$BigInteger.prototype.add = $9f4698123987813e$var$bnAdd;
$9f4698123987813e$var$BigInteger.prototype.subtract = $9f4698123987813e$var$bnSubtract;
$9f4698123987813e$var$BigInteger.prototype.multiply = $9f4698123987813e$var$bnMultiply;
$9f4698123987813e$var$BigInteger.prototype.divide = $9f4698123987813e$var$bnDivide;
$9f4698123987813e$var$BigInteger.prototype.remainder = $9f4698123987813e$var$bnRemainder;
$9f4698123987813e$var$BigInteger.prototype.divideAndRemainder = $9f4698123987813e$var$bnDivideAndRemainder;
$9f4698123987813e$var$BigInteger.prototype.modPow = $9f4698123987813e$var$bnModPow;
$9f4698123987813e$var$BigInteger.prototype.modInverse = $9f4698123987813e$var$bnModInverse;
$9f4698123987813e$var$BigInteger.prototype.pow = $9f4698123987813e$var$bnPow;
$9f4698123987813e$var$BigInteger.prototype.gcd = $9f4698123987813e$var$bnGCD;
$9f4698123987813e$var$BigInteger.prototype.isProbablePrime = $9f4698123987813e$var$bnIsProbablePrime; //BigInteger interfaces not implemented in jsbn:
 //BigInteger(int signum, byte[] magnitude)
 //double doubleValue()
 //float floatValue()
 //int hashCode()
 //long longValue()
 //static BigInteger valueOf(long val)

});

parcelRegister("2hbS7", function(module, exports) {
/**
 * Partial implementation of PKCS#1 v2.2: RSA-OEAP
 *
 * Modified but based on the following MIT and BSD licensed code:
 *
 * https://github.com/kjur/jsjws/blob/master/rsa.js:
 *
 * The 'jsjws'(JSON Web Signature JavaScript Library) License
 *
 * Copyright (c) 2012 Kenji Urushima
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *
 * http://webrsa.cvs.sourceforge.net/viewvc/webrsa/Client/RSAES-OAEP.js?content-type=text%2Fplain:
 *
 * RSAES-OAEP.js
 * $Id: RSAES-OAEP.js,v 1.1.1.1 2003/03/19 15:37:20 ellispritchard Exp $
 * JavaScript Implementation of PKCS #1 v2.1 RSA CRYPTOGRAPHY STANDARD (RSA Laboratories, June 14, 2002)
 * Copyright (C) Ellis Pritchard, Guardian Unlimited 2003.
 * Contact: ellis@nukinetics.com
 * Distributed under the BSD License.
 *
 * Official documentation: http://www.rsa.com/rsalabs/node.asp?id=2125
 *
 * @author Evan Jones (http://evanjones.ca/)
 * @author Dave Longley
 *
 * Copyright (c) 2013-2014 Digital Bazaar, Inc.
 */ 
var $fz7FM = parcelRequire("fz7FM");
parcelRequire("gao36");
parcelRequire("a65r1");
parcelRequire("1DNOR");
// shortcut for PKCS#1 API
var $1a8660ce827b1c02$var$pkcs1 = module.exports = $fz7FM.pkcs1 = $fz7FM.pkcs1 || {};
/**
 * Encode the given RSAES-OAEP message (M) using key, with optional label (L)
 * and seed.
 *
 * This method does not perform RSA encryption, it only encodes the message
 * using RSAES-OAEP.
 *
 * @param key the RSA key to use.
 * @param message the message to encode.
 * @param options the options to use:
 *          label an optional label to use.
 *          seed the seed to use.
 *          md the message digest object to use, undefined for SHA-1.
 *          mgf1 optional mgf1 parameters:
 *            md the message digest object to use for MGF1.
 *
 * @return the encoded message bytes.
 */ $1a8660ce827b1c02$var$pkcs1.encode_rsa_oaep = function(key, message, options) {
    // parse arguments
    var label;
    var seed;
    var md;
    var mgf1Md;
    // legacy args (label, seed, md)
    if (typeof options === "string") {
        label = options;
        seed = arguments[3] || undefined;
        md = arguments[4] || undefined;
    } else if (options) {
        label = options.label || undefined;
        seed = options.seed || undefined;
        md = options.md || undefined;
        if (options.mgf1 && options.mgf1.md) mgf1Md = options.mgf1.md;
    }
    // default OAEP to SHA-1 message digest
    if (!md) md = $fz7FM.md.sha1.create();
    else md.start();
    // default MGF-1 to same as OAEP
    if (!mgf1Md) mgf1Md = md;
    // compute length in bytes and check output
    var keyLength = Math.ceil(key.n.bitLength() / 8);
    var maxLength = keyLength - 2 * md.digestLength - 2;
    if (message.length > maxLength) {
        var error = new Error("RSAES-OAEP input message length is too long.");
        error.length = message.length;
        error.maxLength = maxLength;
        throw error;
    }
    if (!label) label = "";
    md.update(label, "raw");
    var lHash = md.digest();
    var PS = "";
    var PS_length = maxLength - message.length;
    for(var i = 0; i < PS_length; i++)PS += "\x00";
    var DB = lHash.getBytes() + PS + "\x01" + message;
    if (!seed) seed = $fz7FM.random.getBytes(md.digestLength);
    else if (seed.length !== md.digestLength) {
        var error = new Error("Invalid RSAES-OAEP seed. The seed length must match the digest length.");
        error.seedLength = seed.length;
        error.digestLength = md.digestLength;
        throw error;
    }
    var dbMask = $1a8660ce827b1c02$var$rsa_mgf1(seed, keyLength - md.digestLength - 1, mgf1Md);
    var maskedDB = $fz7FM.util.xorBytes(DB, dbMask, DB.length);
    var seedMask = $1a8660ce827b1c02$var$rsa_mgf1(maskedDB, md.digestLength, mgf1Md);
    var maskedSeed = $fz7FM.util.xorBytes(seed, seedMask, seed.length);
    // return encoded message
    return "\x00" + maskedSeed + maskedDB;
};
/**
 * Decode the given RSAES-OAEP encoded message (EM) using key, with optional
 * label (L).
 *
 * This method does not perform RSA decryption, it only decodes the message
 * using RSAES-OAEP.
 *
 * @param key the RSA key to use.
 * @param em the encoded message to decode.
 * @param options the options to use:
 *          label an optional label to use.
 *          md the message digest object to use for OAEP, undefined for SHA-1.
 *          mgf1 optional mgf1 parameters:
 *            md the message digest object to use for MGF1.
 *
 * @return the decoded message bytes.
 */ $1a8660ce827b1c02$var$pkcs1.decode_rsa_oaep = function(key, em, options) {
    // parse args
    var label;
    var md;
    var mgf1Md;
    // legacy args
    if (typeof options === "string") {
        label = options;
        md = arguments[3] || undefined;
    } else if (options) {
        label = options.label || undefined;
        md = options.md || undefined;
        if (options.mgf1 && options.mgf1.md) mgf1Md = options.mgf1.md;
    }
    // compute length in bytes
    var keyLength = Math.ceil(key.n.bitLength() / 8);
    if (em.length !== keyLength) {
        var error = new Error("RSAES-OAEP encoded message length is invalid.");
        error.length = em.length;
        error.expectedLength = keyLength;
        throw error;
    }
    // default OAEP to SHA-1 message digest
    if (md === undefined) md = $fz7FM.md.sha1.create();
    else md.start();
    // default MGF-1 to same as OAEP
    if (!mgf1Md) mgf1Md = md;
    if (keyLength < 2 * md.digestLength + 2) throw new Error("RSAES-OAEP key is too short for the hash function.");
    if (!label) label = "";
    md.update(label, "raw");
    var lHash = md.digest().getBytes();
    // split the message into its parts
    var y = em.charAt(0);
    var maskedSeed = em.substring(1, md.digestLength + 1);
    var maskedDB = em.substring(1 + md.digestLength);
    var seedMask = $1a8660ce827b1c02$var$rsa_mgf1(maskedDB, md.digestLength, mgf1Md);
    var seed = $fz7FM.util.xorBytes(maskedSeed, seedMask, maskedSeed.length);
    var dbMask = $1a8660ce827b1c02$var$rsa_mgf1(seed, keyLength - md.digestLength - 1, mgf1Md);
    var db = $fz7FM.util.xorBytes(maskedDB, dbMask, maskedDB.length);
    var lHashPrime = db.substring(0, md.digestLength);
    // constant time check that all values match what is expected
    var error = y !== "\x00";
    // constant time check lHash vs lHashPrime
    for(var i = 0; i < md.digestLength; ++i)error |= lHash.charAt(i) !== lHashPrime.charAt(i);
    // "constant time" find the 0x1 byte separating the padding (zeros) from the
    // message
    // TODO: It must be possible to do this in a better/smarter way?
    var in_ps = 1;
    var index = md.digestLength;
    for(var j = md.digestLength; j < db.length; j++){
        var code = db.charCodeAt(j);
        var is_0 = code & 0x1 ^ 0x1;
        // non-zero if not 0 or 1 in the ps section
        var error_mask = in_ps ? 0xfffe : 0x0000;
        error |= code & error_mask;
        // latch in_ps to zero after we find 0x1
        in_ps = in_ps & is_0;
        index += in_ps;
    }
    if (error || db.charCodeAt(index) !== 0x1) throw new Error("Invalid RSAES-OAEP padding.");
    return db.substring(index + 1);
};
function $1a8660ce827b1c02$var$rsa_mgf1(seed, maskLength, hash) {
    // default to SHA-1 message digest
    if (!hash) hash = $fz7FM.md.sha1.create();
    var t = "";
    var count = Math.ceil(maskLength / hash.digestLength);
    for(var i = 0; i < count; ++i){
        var c = String.fromCharCode(i >> 24 & 0xFF, i >> 16 & 0xFF, i >> 8 & 0xFF, i & 0xFF);
        hash.start();
        hash.update(seed + c);
        t += hash.digest().getBytes();
    }
    return t.substring(0, maskLength);
}

});
parcelRegister("1DNOR", function(module, exports) {
/**
 * Secure Hash Algorithm with 160-bit digest (SHA-1) implementation.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2015 Digital Bazaar, Inc.
 */ 
var $fz7FM = parcelRequire("fz7FM");
parcelRequire("6NNT4");
parcelRequire("gao36");
var $1320140d69c3e55a$var$sha1 = module.exports = $fz7FM.sha1 = $fz7FM.sha1 || {};
$fz7FM.md.sha1 = $fz7FM.md.algorithms.sha1 = $1320140d69c3e55a$var$sha1;
/**
 * Creates a SHA-1 message digest object.
 *
 * @return a message digest object.
 */ $1320140d69c3e55a$var$sha1.create = function() {
    // do initialization as necessary
    if (!$1320140d69c3e55a$var$_initialized) $1320140d69c3e55a$var$_init();
    // SHA-1 state contains five 32-bit integers
    var _state = null;
    // input buffer
    var _input = $fz7FM.util.createBuffer();
    // used for word storage
    var _w = new Array(80);
    // message digest object
    var md = {
        algorithm: "sha1",
        blockLength: 64,
        digestLength: 20,
        // 56-bit length of message so far (does not including padding)
        messageLength: 0,
        // true message length
        fullMessageLength: null,
        // size of message length in bytes
        messageLengthSize: 8
    };
    /**
   * Starts the digest.
   *
   * @return this digest object.
   */ md.start = function() {
        // up to 56-bit message length for convenience
        md.messageLength = 0;
        // full message length (set md.messageLength64 for backwards-compatibility)
        md.fullMessageLength = md.messageLength64 = [];
        var int32s = md.messageLengthSize / 4;
        for(var i = 0; i < int32s; ++i)md.fullMessageLength.push(0);
        _input = $fz7FM.util.createBuffer();
        _state = {
            h0: 0x67452301,
            h1: 0xEFCDAB89,
            h2: 0x98BADCFE,
            h3: 0x10325476,
            h4: 0xC3D2E1F0
        };
        return md;
    };
    // start digest automatically for first time
    md.start();
    /**
   * Updates the digest with the given message input. The given input can
   * treated as raw input (no encoding will be applied) or an encoding of
   * 'utf8' maybe given to encode the input using UTF-8.
   *
   * @param msg the message input to update with.
   * @param encoding the encoding to use (default: 'raw', other: 'utf8').
   *
   * @return this digest object.
   */ md.update = function(msg, encoding) {
        if (encoding === "utf8") msg = $fz7FM.util.encodeUtf8(msg);
        // update message length
        var len = msg.length;
        md.messageLength += len;
        len = [
            len / 0x100000000 >>> 0,
            len >>> 0
        ];
        for(var i = md.fullMessageLength.length - 1; i >= 0; --i){
            md.fullMessageLength[i] += len[1];
            len[1] = len[0] + (md.fullMessageLength[i] / 0x100000000 >>> 0);
            md.fullMessageLength[i] = md.fullMessageLength[i] >>> 0;
            len[0] = len[1] / 0x100000000 >>> 0;
        }
        // add bytes to input buffer
        _input.putBytes(msg);
        // process bytes
        $1320140d69c3e55a$var$_update(_state, _w, _input);
        // compact input buffer every 2K or if empty
        if (_input.read > 2048 || _input.length() === 0) _input.compact();
        return md;
    };
    /**
   * Produces the digest.
   *
   * @return a byte buffer containing the digest value.
   */ md.digest = function() {
        /* Note: Here we copy the remaining bytes in the input buffer and
    add the appropriate SHA-1 padding. Then we do the final update
    on a copy of the state so that if the user wants to get
    intermediate digests they can do so. */ /* Determine the number of bytes that must be added to the message
    to ensure its length is congruent to 448 mod 512. In other words,
    the data to be digested must be a multiple of 512 bits (or 128 bytes).
    This data includes the message, some padding, and the length of the
    message. Since the length of the message will be encoded as 8 bytes (64
    bits), that means that the last segment of the data must have 56 bytes
    (448 bits) of message and padding. Therefore, the length of the message
    plus the padding must be congruent to 448 mod 512 because
    512 - 128 = 448.

    In order to fill up the message length it must be filled with
    padding that begins with 1 bit followed by all 0 bits. Padding
    must *always* be present, so if the message length is already
    congruent to 448 mod 512, then 512 padding bits must be added. */ var finalBlock = $fz7FM.util.createBuffer();
        finalBlock.putBytes(_input.bytes());
        // compute remaining size to be digested (include message length size)
        var remaining = md.fullMessageLength[md.fullMessageLength.length - 1] + md.messageLengthSize;
        // add padding for overflow blockSize - overflow
        // _padding starts with 1 byte with first bit is set (byte value 128), then
        // there may be up to (blockSize - 1) other pad bytes
        var overflow = remaining & md.blockLength - 1;
        finalBlock.putBytes($1320140d69c3e55a$var$_padding.substr(0, md.blockLength - overflow));
        // serialize message length in bits in big-endian order; since length
        // is stored in bytes we multiply by 8 and add carry from next int
        var next, carry;
        var bits = md.fullMessageLength[0] * 8;
        for(var i = 0; i < md.fullMessageLength.length - 1; ++i){
            next = md.fullMessageLength[i + 1] * 8;
            carry = next / 0x100000000 >>> 0;
            bits += carry;
            finalBlock.putInt32(bits >>> 0);
            bits = next >>> 0;
        }
        finalBlock.putInt32(bits);
        var s2 = {
            h0: _state.h0,
            h1: _state.h1,
            h2: _state.h2,
            h3: _state.h3,
            h4: _state.h4
        };
        $1320140d69c3e55a$var$_update(s2, _w, finalBlock);
        var rval = $fz7FM.util.createBuffer();
        rval.putInt32(s2.h0);
        rval.putInt32(s2.h1);
        rval.putInt32(s2.h2);
        rval.putInt32(s2.h3);
        rval.putInt32(s2.h4);
        return rval;
    };
    return md;
};
// sha-1 padding bytes not initialized yet
var $1320140d69c3e55a$var$_padding = null;
var $1320140d69c3e55a$var$_initialized = false;
/**
 * Initializes the constant tables.
 */ function $1320140d69c3e55a$var$_init() {
    // create padding
    $1320140d69c3e55a$var$_padding = String.fromCharCode(128);
    $1320140d69c3e55a$var$_padding += $fz7FM.util.fillString(String.fromCharCode(0x00), 64);
    // now initialized
    $1320140d69c3e55a$var$_initialized = true;
}
/**
 * Updates a SHA-1 state with the given byte buffer.
 *
 * @param s the SHA-1 state to update.
 * @param w the array to use to store words.
 * @param bytes the byte buffer to update with.
 */ function $1320140d69c3e55a$var$_update(s, w, bytes) {
    // consume 512 bit (64 byte) chunks
    var t, a, b, c, d, e, f, i;
    var len = bytes.length();
    while(len >= 64){
        // the w array will be populated with sixteen 32-bit big-endian words
        // and then extended into 80 32-bit words according to SHA-1 algorithm
        // and for 32-79 using Max Locktyukhin's optimization
        // initialize hash value for this chunk
        a = s.h0;
        b = s.h1;
        c = s.h2;
        d = s.h3;
        e = s.h4;
        // round 1
        for(i = 0; i < 16; ++i){
            t = bytes.getInt32();
            w[i] = t;
            f = d ^ b & (c ^ d);
            t = (a << 5 | a >>> 27) + f + e + 0x5A827999 + t;
            e = d;
            d = c;
            // `>>> 0` necessary to avoid iOS/Safari 10 optimization bug
            c = (b << 30 | b >>> 2) >>> 0;
            b = a;
            a = t;
        }
        for(; i < 20; ++i){
            t = w[i - 3] ^ w[i - 8] ^ w[i - 14] ^ w[i - 16];
            t = t << 1 | t >>> 31;
            w[i] = t;
            f = d ^ b & (c ^ d);
            t = (a << 5 | a >>> 27) + f + e + 0x5A827999 + t;
            e = d;
            d = c;
            // `>>> 0` necessary to avoid iOS/Safari 10 optimization bug
            c = (b << 30 | b >>> 2) >>> 0;
            b = a;
            a = t;
        }
        // round 2
        for(; i < 32; ++i){
            t = w[i - 3] ^ w[i - 8] ^ w[i - 14] ^ w[i - 16];
            t = t << 1 | t >>> 31;
            w[i] = t;
            f = b ^ c ^ d;
            t = (a << 5 | a >>> 27) + f + e + 0x6ED9EBA1 + t;
            e = d;
            d = c;
            // `>>> 0` necessary to avoid iOS/Safari 10 optimization bug
            c = (b << 30 | b >>> 2) >>> 0;
            b = a;
            a = t;
        }
        for(; i < 40; ++i){
            t = w[i - 6] ^ w[i - 16] ^ w[i - 28] ^ w[i - 32];
            t = t << 2 | t >>> 30;
            w[i] = t;
            f = b ^ c ^ d;
            t = (a << 5 | a >>> 27) + f + e + 0x6ED9EBA1 + t;
            e = d;
            d = c;
            // `>>> 0` necessary to avoid iOS/Safari 10 optimization bug
            c = (b << 30 | b >>> 2) >>> 0;
            b = a;
            a = t;
        }
        // round 3
        for(; i < 60; ++i){
            t = w[i - 6] ^ w[i - 16] ^ w[i - 28] ^ w[i - 32];
            t = t << 2 | t >>> 30;
            w[i] = t;
            f = b & c | d & (b ^ c);
            t = (a << 5 | a >>> 27) + f + e + 0x8F1BBCDC + t;
            e = d;
            d = c;
            // `>>> 0` necessary to avoid iOS/Safari 10 optimization bug
            c = (b << 30 | b >>> 2) >>> 0;
            b = a;
            a = t;
        }
        // round 4
        for(; i < 80; ++i){
            t = w[i - 6] ^ w[i - 16] ^ w[i - 28] ^ w[i - 32];
            t = t << 2 | t >>> 30;
            w[i] = t;
            f = b ^ c ^ d;
            t = (a << 5 | a >>> 27) + f + e + 0xCA62C1D6 + t;
            e = d;
            d = c;
            // `>>> 0` necessary to avoid iOS/Safari 10 optimization bug
            c = (b << 30 | b >>> 2) >>> 0;
            b = a;
            a = t;
        }
        // update hash state
        s.h0 = s.h0 + a | 0;
        s.h1 = s.h1 + b | 0;
        s.h2 = s.h2 + c | 0;
        s.h3 = s.h3 + d | 0;
        s.h4 = s.h4 + e | 0;
        len -= 64;
    }
}

});


parcelRegister("lNcH9", function(module, exports) {
/**
 * Prime number generation API.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2014 Digital Bazaar, Inc.
 */ 
var $fz7FM = parcelRequire("fz7FM");
parcelRequire("gao36");
parcelRequire("dFOUo");
parcelRequire("a65r1");
(function() {
    // forge.prime already defined
    if ($fz7FM.prime) {
        module.exports = $fz7FM.prime;
        return;
    }
    /* PRIME API */ var prime = module.exports = $fz7FM.prime = $fz7FM.prime || {};
    var BigInteger = $fz7FM.jsbn.BigInteger;
    // primes are 30k+i for i = 1, 7, 11, 13, 17, 19, 23, 29
    var GCD_30_DELTA = [
        6,
        4,
        2,
        4,
        2,
        4,
        6,
        2
    ];
    var THIRTY = new BigInteger(null);
    THIRTY.fromInt(30);
    var op_or = function op_or(x, y) {
        return x | y;
    };
    /**
 * Generates a random probable prime with the given number of bits.
 *
 * Alternative algorithms can be specified by name as a string or as an
 * object with custom options like so:
 *
 * {
 *   name: 'PRIMEINC',
 *   options: {
 *     maxBlockTime: <the maximum amount of time to block the main
 *       thread before allowing I/O other JS to run>,
 *     millerRabinTests: <the number of miller-rabin tests to run>,
 *     workerScript: <the worker script URL>,
 *     workers: <the number of web workers (if supported) to use,
 *       -1 to use estimated cores minus one>.
 *     workLoad: the size of the work load, ie: number of possible prime
 *       numbers for each web worker to check per work assignment,
 *       (default: 100).
 *   }
 * }
 *
 * @param bits the number of bits for the prime number.
 * @param options the options to use.
 *          [algorithm] the algorithm to use (default: 'PRIMEINC').
 *          [prng] a custom crypto-secure pseudo-random number generator to use,
 *            that must define "getBytesSync".
 *
 * @return callback(err, num) called once the operation completes.
 */ prime.generateProbablePrime = function(bits, options, callback) {
        if (typeof options === "function") {
            callback = options;
            options = {};
        }
        options = options || {};
        // default to PRIMEINC algorithm
        var algorithm = options.algorithm || "PRIMEINC";
        if (typeof algorithm === "string") algorithm = {
            name: algorithm
        };
        algorithm.options = algorithm.options || {};
        // create prng with api that matches BigInteger secure random
        var prng = options.prng || $fz7FM.random;
        var rng = {
            // x is an array to fill with bytes
            nextBytes: function nextBytes(x) {
                var b = prng.getBytesSync(x.length);
                for(var i = 0; i < x.length; ++i)x[i] = b.charCodeAt(i);
            }
        };
        if (algorithm.name === "PRIMEINC") return primeincFindPrime(bits, rng, algorithm.options, callback);
        throw new Error("Invalid prime generation algorithm: " + algorithm.name);
    };
    function primeincFindPrime(bits, rng, options, callback) {
        if ("workers" in options) return primeincFindPrimeWithWorkers(bits, rng, options, callback);
        return primeincFindPrimeWithoutWorkers(bits, rng, options, callback);
    }
    function primeincFindPrimeWithoutWorkers(bits, rng, options, callback) {
        // initialize random number
        var num = generateRandom(bits, rng);
        /* Note: All primes are of the form 30k+i for i < 30 and gcd(30, i)=1. The
  number we are given is always aligned at 30k + 1. Each time the number is
  determined not to be prime we add to get to the next 'i', eg: if the number
  was at 30k + 1 we add 6. */ var deltaIdx = 0;
        // get required number of MR tests
        var mrTests = getMillerRabinTests(num.bitLength());
        if ("millerRabinTests" in options) mrTests = options.millerRabinTests;
        // find prime nearest to 'num' for maxBlockTime ms
        // 10 ms gives 5ms of leeway for other calculations before dropping
        // below 60fps (1000/60 == 16.67), but in reality, the number will
        // likely be higher due to an 'atomic' big int modPow
        var maxBlockTime = 10;
        if ("maxBlockTime" in options) maxBlockTime = options.maxBlockTime;
        _primeinc(num, bits, rng, deltaIdx, mrTests, maxBlockTime, callback);
    }
    function _primeinc(num, bits, rng, deltaIdx, mrTests, maxBlockTime, callback) {
        var start = +new Date();
        do {
            // overflow, regenerate random number
            if (num.bitLength() > bits) num = generateRandom(bits, rng);
            // do primality test
            if (num.isProbablePrime(mrTests)) return callback(null, num);
            // get next potential prime
            num.dAddOffset(GCD_30_DELTA[deltaIdx++ % 8], 0);
        }while (maxBlockTime < 0 || +new Date() - start < maxBlockTime);
        // keep trying later
        $fz7FM.util.setImmediate(function() {
            _primeinc(num, bits, rng, deltaIdx, mrTests, maxBlockTime, callback);
        });
    }
    // NOTE: This algorithm is indeterminate in nature because workers
    // run in parallel looking at different segments of numbers. Even if this
    // algorithm is run twice with the same input from a predictable RNG, it
    // may produce different outputs.
    function primeincFindPrimeWithWorkers(bits, rng, options, callback) {
        // web workers unavailable
        if (typeof Worker === "undefined") return primeincFindPrimeWithoutWorkers(bits, rng, options, callback);
        // initialize random number
        var num = generateRandom(bits, rng);
        // use web workers to generate keys
        var numWorkers = options.workers;
        var workLoad = options.workLoad || 100;
        var range = workLoad * 30 / 8;
        var workerScript = options.workerScript || "forge/prime.worker.js";
        if (numWorkers === -1) return $fz7FM.util.estimateCores(function(err, cores) {
            if (err) // default to 2
            cores = 2;
            numWorkers = cores - 1;
            generate();
        });
        generate();
        function generate() {
            // require at least 1 worker
            numWorkers = Math.max(1, numWorkers);
            // TODO: consider optimizing by starting workers outside getPrime() ...
            // note that in order to clean up they will have to be made internally
            // asynchronous which may actually be slower
            // start workers immediately
            var workers = [];
            for(var i = 0; i < numWorkers; ++i)// FIXME: fix path or use blob URLs
            workers[i] = new Worker(workerScript);
            var running = numWorkers;
            // listen for requests from workers and assign ranges to find prime
            for(var i = 0; i < numWorkers; ++i)workers[i].addEventListener("message", workerMessage);
            /* Note: The distribution of random numbers is unknown. Therefore, each
    web worker is continuously allocated a range of numbers to check for a
    random number until one is found.

    Every 30 numbers will be checked just 8 times, because prime numbers
    have the form:

    30k+i, for i < 30 and gcd(30, i)=1 (there are 8 values of i for this)

    Therefore, if we want a web worker to run N checks before asking for
    a new range of numbers, each range must contain N*30/8 numbers.

    For 100 checks (workLoad), this is a range of 375. */ var found = false;
            function workerMessage(e) {
                // ignore message, prime already found
                if (found) return;
                --running;
                var data = e.data;
                if (data.found) {
                    // terminate all workers
                    for(var i = 0; i < workers.length; ++i)workers[i].terminate();
                    found = true;
                    return callback(null, new BigInteger(data.prime, 16));
                }
                // overflow, regenerate random number
                if (num.bitLength() > bits) num = generateRandom(bits, rng);
                // assign new range to check
                var hex = num.toString(16);
                // start prime search
                e.target.postMessage({
                    hex: hex,
                    workLoad: workLoad
                });
                num.dAddOffset(range, 0);
            }
        }
    }
    /**
 * Generates a random number using the given number of bits and RNG.
 *
 * @param bits the number of bits for the number.
 * @param rng the random number generator to use.
 *
 * @return the random number.
 */ function generateRandom(bits, rng) {
        var num = new BigInteger(bits, rng);
        // force MSB set
        var bits1 = bits - 1;
        if (!num.testBit(bits1)) num.bitwiseTo(BigInteger.ONE.shiftLeft(bits1), op_or, num);
        // align number on 30k+1 boundary
        num.dAddOffset(31 - num.mod(THIRTY).byteValue(), 0);
        return num;
    }
    /**
 * Returns the required number of Miller-Rabin tests to generate a
 * prime with an error probability of (1/2)^80.
 *
 * See Handbook of Applied Cryptography Chapter 4, Table 4.4.
 *
 * @param bits the bit size.
 *
 * @return the required number of iterations.
 */ function getMillerRabinTests(bits) {
        if (bits <= 100) return 27;
        if (bits <= 150) return 18;
        if (bits <= 200) return 15;
        if (bits <= 250) return 12;
        if (bits <= 300) return 9;
        if (bits <= 350) return 8;
        if (bits <= 400) return 7;
        if (bits <= 500) return 6;
        if (bits <= 600) return 5;
        if (bits <= 800) return 4;
        if (bits <= 1250) return 3;
        return 2;
    }
})();

});



parcelRegister("fv3Sg", function(module, exports) {
/**
 * Javascript implementation of PKCS#12.
 *
 * @author Dave Longley
 * @author Stefan Siegl <stesie@brokenpipe.de>
 *
 * Copyright (c) 2010-2014 Digital Bazaar, Inc.
 * Copyright (c) 2012 Stefan Siegl <stesie@brokenpipe.de>
 *
 * The ASN.1 representation of PKCS#12 is as follows
 * (see ftp://ftp.rsasecurity.com/pub/pkcs/pkcs-12/pkcs-12-tc1.pdf for details)
 *
 * PFX ::= SEQUENCE {
 *   version  INTEGER {v3(3)}(v3,...),
 *   authSafe ContentInfo,
 *   macData  MacData OPTIONAL
 * }
 *
 * MacData ::= SEQUENCE {
 *   mac DigestInfo,
 *   macSalt OCTET STRING,
 *   iterations INTEGER DEFAULT 1
 * }
 * Note: The iterations default is for historical reasons and its use is
 * deprecated. A higher value, like 1024, is recommended.
 *
 * DigestInfo is defined in PKCS#7 as follows:
 *
 * DigestInfo ::= SEQUENCE {
 *   digestAlgorithm DigestAlgorithmIdentifier,
 *   digest Digest
 * }
 *
 * DigestAlgorithmIdentifier ::= AlgorithmIdentifier
 *
 * The AlgorithmIdentifier contains an Object Identifier (OID) and parameters
 * for the algorithm, if any. In the case of SHA1 there is none.
 *
 * AlgorithmIdentifer ::= SEQUENCE {
 *    algorithm OBJECT IDENTIFIER,
 *    parameters ANY DEFINED BY algorithm OPTIONAL
 * }
 *
 * Digest ::= OCTET STRING
 *
 *
 * ContentInfo ::= SEQUENCE {
 *   contentType ContentType,
 *   content     [0] EXPLICIT ANY DEFINED BY contentType OPTIONAL
 * }
 *
 * ContentType ::= OBJECT IDENTIFIER
 *
 * AuthenticatedSafe ::= SEQUENCE OF ContentInfo
 * -- Data if unencrypted
 * -- EncryptedData if password-encrypted
 * -- EnvelopedData if public key-encrypted
 *
 *
 * SafeContents ::= SEQUENCE OF SafeBag
 *
 * SafeBag ::= SEQUENCE {
 *   bagId     BAG-TYPE.&id ({PKCS12BagSet})
 *   bagValue  [0] EXPLICIT BAG-TYPE.&Type({PKCS12BagSet}{@bagId}),
 *   bagAttributes SET OF PKCS12Attribute OPTIONAL
 * }
 *
 * PKCS12Attribute ::= SEQUENCE {
 *   attrId ATTRIBUTE.&id ({PKCS12AttrSet}),
 *   attrValues SET OF ATTRIBUTE.&Type ({PKCS12AttrSet}{@attrId})
 * } -- This type is compatible with the X.500 type 'Attribute'
 *
 * PKCS12AttrSet ATTRIBUTE ::= {
 *   friendlyName | -- from PKCS #9
 *   localKeyId, -- from PKCS #9
 *   ... -- Other attributes are allowed
 * }
 *
 * CertBag ::= SEQUENCE {
 *   certId    BAG-TYPE.&id   ({CertTypes}),
 *   certValue [0] EXPLICIT BAG-TYPE.&Type ({CertTypes}{@certId})
 * }
 *
 * x509Certificate BAG-TYPE ::= {OCTET STRING IDENTIFIED BY {certTypes 1}}
 *   -- DER-encoded X.509 certificate stored in OCTET STRING
 *
 * sdsiCertificate BAG-TYPE ::= {IA5String IDENTIFIED BY {certTypes 2}}
 * -- Base64-encoded SDSI certificate stored in IA5String
 *
 * CertTypes BAG-TYPE ::= {
 *   x509Certificate |
 *   sdsiCertificate,
 *   ... -- For future extensions
 * }
 */ 
var $fz7FM = parcelRequire("fz7FM");
parcelRequire("d4EnE");
parcelRequire("9YZGj");
parcelRequire("dm89c");
parcelRequire("2RJQB");
parcelRequire("58Y8U");
parcelRequire("a65r1");
parcelRequire("eRNaT");
parcelRequire("1DNOR");
parcelRequire("gao36");
parcelRequire("3c4BG");
// shortcut for asn.1 & PKI API
var $b48cc194cf10beb3$var$asn1 = $fz7FM.asn1;
var $b48cc194cf10beb3$var$pki = $fz7FM.pki;
// shortcut for PKCS#12 API
var $b48cc194cf10beb3$var$p12 = module.exports = $fz7FM.pkcs12 = $fz7FM.pkcs12 || {};
var $b48cc194cf10beb3$var$contentInfoValidator = {
    name: "ContentInfo",
    tagClass: $b48cc194cf10beb3$var$asn1.Class.UNIVERSAL,
    type: $b48cc194cf10beb3$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: "ContentInfo.contentType",
            tagClass: $b48cc194cf10beb3$var$asn1.Class.UNIVERSAL,
            type: $b48cc194cf10beb3$var$asn1.Type.OID,
            constructed: false,
            capture: "contentType"
        },
        {
            name: "ContentInfo.content",
            tagClass: $b48cc194cf10beb3$var$asn1.Class.CONTEXT_SPECIFIC,
            constructed: true,
            captureAsn1: "content"
        }
    ]
};
var $b48cc194cf10beb3$var$pfxValidator = {
    name: "PFX",
    tagClass: $b48cc194cf10beb3$var$asn1.Class.UNIVERSAL,
    type: $b48cc194cf10beb3$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: "PFX.version",
            tagClass: $b48cc194cf10beb3$var$asn1.Class.UNIVERSAL,
            type: $b48cc194cf10beb3$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "version"
        },
        $b48cc194cf10beb3$var$contentInfoValidator,
        {
            name: "PFX.macData",
            tagClass: $b48cc194cf10beb3$var$asn1.Class.UNIVERSAL,
            type: $b48cc194cf10beb3$var$asn1.Type.SEQUENCE,
            constructed: true,
            optional: true,
            captureAsn1: "mac",
            value: [
                {
                    name: "PFX.macData.mac",
                    tagClass: $b48cc194cf10beb3$var$asn1.Class.UNIVERSAL,
                    type: $b48cc194cf10beb3$var$asn1.Type.SEQUENCE,
                    constructed: true,
                    value: [
                        {
                            name: "PFX.macData.mac.digestAlgorithm",
                            tagClass: $b48cc194cf10beb3$var$asn1.Class.UNIVERSAL,
                            type: $b48cc194cf10beb3$var$asn1.Type.SEQUENCE,
                            constructed: true,
                            value: [
                                {
                                    name: "PFX.macData.mac.digestAlgorithm.algorithm",
                                    tagClass: $b48cc194cf10beb3$var$asn1.Class.UNIVERSAL,
                                    type: $b48cc194cf10beb3$var$asn1.Type.OID,
                                    constructed: false,
                                    capture: "macAlgorithm"
                                },
                                {
                                    name: "PFX.macData.mac.digestAlgorithm.parameters",
                                    tagClass: $b48cc194cf10beb3$var$asn1.Class.UNIVERSAL,
                                    captureAsn1: "macAlgorithmParameters"
                                }
                            ]
                        },
                        {
                            name: "PFX.macData.mac.digest",
                            tagClass: $b48cc194cf10beb3$var$asn1.Class.UNIVERSAL,
                            type: $b48cc194cf10beb3$var$asn1.Type.OCTETSTRING,
                            constructed: false,
                            capture: "macDigest"
                        }
                    ]
                },
                {
                    name: "PFX.macData.macSalt",
                    tagClass: $b48cc194cf10beb3$var$asn1.Class.UNIVERSAL,
                    type: $b48cc194cf10beb3$var$asn1.Type.OCTETSTRING,
                    constructed: false,
                    capture: "macSalt"
                },
                {
                    name: "PFX.macData.iterations",
                    tagClass: $b48cc194cf10beb3$var$asn1.Class.UNIVERSAL,
                    type: $b48cc194cf10beb3$var$asn1.Type.INTEGER,
                    constructed: false,
                    optional: true,
                    capture: "macIterations"
                }
            ]
        }
    ]
};
var $b48cc194cf10beb3$var$safeBagValidator = {
    name: "SafeBag",
    tagClass: $b48cc194cf10beb3$var$asn1.Class.UNIVERSAL,
    type: $b48cc194cf10beb3$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: "SafeBag.bagId",
            tagClass: $b48cc194cf10beb3$var$asn1.Class.UNIVERSAL,
            type: $b48cc194cf10beb3$var$asn1.Type.OID,
            constructed: false,
            capture: "bagId"
        },
        {
            name: "SafeBag.bagValue",
            tagClass: $b48cc194cf10beb3$var$asn1.Class.CONTEXT_SPECIFIC,
            constructed: true,
            captureAsn1: "bagValue"
        },
        {
            name: "SafeBag.bagAttributes",
            tagClass: $b48cc194cf10beb3$var$asn1.Class.UNIVERSAL,
            type: $b48cc194cf10beb3$var$asn1.Type.SET,
            constructed: true,
            optional: true,
            capture: "bagAttributes"
        }
    ]
};
var $b48cc194cf10beb3$var$attributeValidator = {
    name: "Attribute",
    tagClass: $b48cc194cf10beb3$var$asn1.Class.UNIVERSAL,
    type: $b48cc194cf10beb3$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: "Attribute.attrId",
            tagClass: $b48cc194cf10beb3$var$asn1.Class.UNIVERSAL,
            type: $b48cc194cf10beb3$var$asn1.Type.OID,
            constructed: false,
            capture: "oid"
        },
        {
            name: "Attribute.attrValues",
            tagClass: $b48cc194cf10beb3$var$asn1.Class.UNIVERSAL,
            type: $b48cc194cf10beb3$var$asn1.Type.SET,
            constructed: true,
            capture: "values"
        }
    ]
};
var $b48cc194cf10beb3$var$certBagValidator = {
    name: "CertBag",
    tagClass: $b48cc194cf10beb3$var$asn1.Class.UNIVERSAL,
    type: $b48cc194cf10beb3$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: "CertBag.certId",
            tagClass: $b48cc194cf10beb3$var$asn1.Class.UNIVERSAL,
            type: $b48cc194cf10beb3$var$asn1.Type.OID,
            constructed: false,
            capture: "certId"
        },
        {
            name: "CertBag.certValue",
            tagClass: $b48cc194cf10beb3$var$asn1.Class.CONTEXT_SPECIFIC,
            constructed: true,
            /* So far we only support X.509 certificates (which are wrapped in
       an OCTET STRING, hence hard code that here). */ value: [
                {
                    name: "CertBag.certValue[0]",
                    tagClass: $b48cc194cf10beb3$var$asn1.Class.UNIVERSAL,
                    type: $b48cc194cf10beb3$var$asn1.Class.OCTETSTRING,
                    constructed: false,
                    capture: "cert"
                }
            ]
        }
    ]
};
/**
 * Search SafeContents structure for bags with matching attributes.
 *
 * The search can optionally be narrowed by a certain bag type.
 *
 * @param safeContents the SafeContents structure to search in.
 * @param attrName the name of the attribute to compare against.
 * @param attrValue the attribute value to search for.
 * @param [bagType] bag type to narrow search by.
 *
 * @return an array of matching bags.
 */ function $b48cc194cf10beb3$var$_getBagsByAttribute(safeContents, attrName, attrValue, bagType) {
    var result = [];
    for(var i = 0; i < safeContents.length; i++)for(var j = 0; j < safeContents[i].safeBags.length; j++){
        var bag = safeContents[i].safeBags[j];
        if (bagType !== undefined && bag.type !== bagType) continue;
        // only filter by bag type, no attribute specified
        if (attrName === null) {
            result.push(bag);
            continue;
        }
        if (bag.attributes[attrName] !== undefined && bag.attributes[attrName].indexOf(attrValue) >= 0) result.push(bag);
    }
    return result;
}
/**
 * Converts a PKCS#12 PFX in ASN.1 notation into a PFX object.
 *
 * @param obj The PKCS#12 PFX in ASN.1 notation.
 * @param strict true to use strict DER decoding, false not to (default: true).
 * @param {String} password Password to decrypt with (optional).
 *
 * @return PKCS#12 PFX object.
 */ $b48cc194cf10beb3$var$p12.pkcs12FromAsn1 = function(obj, strict, password) {
    // handle args
    if (typeof strict === "string") {
        password = strict;
        strict = true;
    } else if (strict === undefined) strict = true;
    // validate PFX and capture data
    var capture = {};
    var errors = [];
    if (!$b48cc194cf10beb3$var$asn1.validate(obj, $b48cc194cf10beb3$var$pfxValidator, capture, errors)) {
        var error = new Error("Cannot read PKCS#12 PFX. ASN.1 object is not an PKCS#12 PFX.");
        error.errors = error;
        throw error;
    }
    var pfx = {
        version: capture.version.charCodeAt(0),
        safeContents: [],
        /**
     * Gets bags with matching attributes.
     *
     * @param filter the attributes to filter by:
     *          [localKeyId] the localKeyId to search for.
     *          [localKeyIdHex] the localKeyId in hex to search for.
     *          [friendlyName] the friendly name to search for.
     *          [bagType] bag type to narrow each attribute search by.
     *
     * @return a map of attribute type to an array of matching bags or, if no
     *           attribute was given but a bag type, the map key will be the
     *           bag type.
     */ getBags: function getBags(filter) {
            var rval = {};
            var localKeyId;
            if ("localKeyId" in filter) localKeyId = filter.localKeyId;
            else if ("localKeyIdHex" in filter) localKeyId = $fz7FM.util.hexToBytes(filter.localKeyIdHex);
            // filter on bagType only
            if (localKeyId === undefined && !("friendlyName" in filter) && "bagType" in filter) rval[filter.bagType] = $b48cc194cf10beb3$var$_getBagsByAttribute(pfx.safeContents, null, null, filter.bagType);
            if (localKeyId !== undefined) rval.localKeyId = $b48cc194cf10beb3$var$_getBagsByAttribute(pfx.safeContents, "localKeyId", localKeyId, filter.bagType);
            if ("friendlyName" in filter) rval.friendlyName = $b48cc194cf10beb3$var$_getBagsByAttribute(pfx.safeContents, "friendlyName", filter.friendlyName, filter.bagType);
            return rval;
        },
        /**
     * DEPRECATED: use getBags() instead.
     *
     * Get bags with matching friendlyName attribute.
     *
     * @param friendlyName the friendly name to search for.
     * @param [bagType] bag type to narrow search by.
     *
     * @return an array of bags with matching friendlyName attribute.
     */ getBagsByFriendlyName: function getBagsByFriendlyName(friendlyName, bagType) {
            return $b48cc194cf10beb3$var$_getBagsByAttribute(pfx.safeContents, "friendlyName", friendlyName, bagType);
        },
        /**
     * DEPRECATED: use getBags() instead.
     *
     * Get bags with matching localKeyId attribute.
     *
     * @param localKeyId the localKeyId to search for.
     * @param [bagType] bag type to narrow search by.
     *
     * @return an array of bags with matching localKeyId attribute.
     */ getBagsByLocalKeyId: function getBagsByLocalKeyId(localKeyId, bagType) {
            return $b48cc194cf10beb3$var$_getBagsByAttribute(pfx.safeContents, "localKeyId", localKeyId, bagType);
        }
    };
    if (capture.version.charCodeAt(0) !== 3) {
        var error = new Error("PKCS#12 PFX of version other than 3 not supported.");
        error.version = capture.version.charCodeAt(0);
        throw error;
    }
    if ($b48cc194cf10beb3$var$asn1.derToOid(capture.contentType) !== $b48cc194cf10beb3$var$pki.oids.data) {
        var error = new Error("Only PKCS#12 PFX in password integrity mode supported.");
        error.oid = $b48cc194cf10beb3$var$asn1.derToOid(capture.contentType);
        throw error;
    }
    var data = capture.content.value[0];
    if (data.tagClass !== $b48cc194cf10beb3$var$asn1.Class.UNIVERSAL || data.type !== $b48cc194cf10beb3$var$asn1.Type.OCTETSTRING) throw new Error("PKCS#12 authSafe content data is not an OCTET STRING.");
    data = $b48cc194cf10beb3$var$_decodePkcs7Data(data);
    // check for MAC
    if (capture.mac) {
        var md = null;
        var macKeyBytes = 0;
        var macAlgorithm = $b48cc194cf10beb3$var$asn1.derToOid(capture.macAlgorithm);
        switch(macAlgorithm){
            case $b48cc194cf10beb3$var$pki.oids.sha1:
                md = $fz7FM.md.sha1.create();
                macKeyBytes = 20;
                break;
            case $b48cc194cf10beb3$var$pki.oids.sha256:
                md = $fz7FM.md.sha256.create();
                macKeyBytes = 32;
                break;
            case $b48cc194cf10beb3$var$pki.oids.sha384:
                md = $fz7FM.md.sha384.create();
                macKeyBytes = 48;
                break;
            case $b48cc194cf10beb3$var$pki.oids.sha512:
                md = $fz7FM.md.sha512.create();
                macKeyBytes = 64;
                break;
            case $b48cc194cf10beb3$var$pki.oids.md5:
                md = $fz7FM.md.md5.create();
                macKeyBytes = 16;
                break;
        }
        if (md === null) throw new Error("PKCS#12 uses unsupported MAC algorithm: " + macAlgorithm);
        // verify MAC (iterations default to 1)
        var macSalt = new $fz7FM.util.ByteBuffer(capture.macSalt);
        var macIterations = "macIterations" in capture ? parseInt($fz7FM.util.bytesToHex(capture.macIterations), 16) : 1;
        var macKey = $b48cc194cf10beb3$var$p12.generateKey(password, macSalt, 3, macIterations, macKeyBytes, md);
        var mac = $fz7FM.hmac.create();
        mac.start(md, macKey);
        mac.update(data.value);
        var macValue = mac.getMac();
        if (macValue.getBytes() !== capture.macDigest) throw new Error("PKCS#12 MAC could not be verified. Invalid password?");
    }
    $b48cc194cf10beb3$var$_decodeAuthenticatedSafe(pfx, data.value, strict, password);
    return pfx;
};
/**
 * Decodes PKCS#7 Data. PKCS#7 (RFC 2315) defines "Data" as an OCTET STRING,
 * but it is sometimes an OCTET STRING that is composed/constructed of chunks,
 * each its own OCTET STRING. This is BER-encoding vs. DER-encoding. This
 * function transforms this corner-case into the usual simple,
 * non-composed/constructed OCTET STRING.
 *
 * This function may be moved to ASN.1 at some point to better deal with
 * more BER-encoding issues, should they arise.
 *
 * @param data the ASN.1 Data object to transform.
 */ function $b48cc194cf10beb3$var$_decodePkcs7Data(data) {
    // handle special case of "chunked" data content: an octet string composed
    // of other octet strings
    if (data.composed || data.constructed) {
        var value = $fz7FM.util.createBuffer();
        for(var i = 0; i < data.value.length; ++i)value.putBytes(data.value[i].value);
        data.composed = data.constructed = false;
        data.value = value.getBytes();
    }
    return data;
}
/**
 * Decode PKCS#12 AuthenticatedSafe (BER encoded) into PFX object.
 *
 * The AuthenticatedSafe is a BER-encoded SEQUENCE OF ContentInfo.
 *
 * @param pfx The PKCS#12 PFX object to fill.
 * @param {String} authSafe BER-encoded AuthenticatedSafe.
 * @param strict true to use strict DER decoding, false not to.
 * @param {String} password Password to decrypt with (optional).
 */ function $b48cc194cf10beb3$var$_decodeAuthenticatedSafe(pfx, authSafe, strict, password) {
    authSafe = $b48cc194cf10beb3$var$asn1.fromDer(authSafe, strict); /* actually it's BER encoded */ 
    if (authSafe.tagClass !== $b48cc194cf10beb3$var$asn1.Class.UNIVERSAL || authSafe.type !== $b48cc194cf10beb3$var$asn1.Type.SEQUENCE || authSafe.constructed !== true) throw new Error("PKCS#12 AuthenticatedSafe expected to be a SEQUENCE OF ContentInfo");
    for(var i = 0; i < authSafe.value.length; i++){
        var contentInfo = authSafe.value[i];
        // validate contentInfo and capture data
        var capture = {};
        var errors = [];
        if (!$b48cc194cf10beb3$var$asn1.validate(contentInfo, $b48cc194cf10beb3$var$contentInfoValidator, capture, errors)) {
            var error = new Error("Cannot read ContentInfo.");
            error.errors = errors;
            throw error;
        }
        var obj = {
            encrypted: false
        };
        var safeContents = null;
        var data = capture.content.value[0];
        switch($b48cc194cf10beb3$var$asn1.derToOid(capture.contentType)){
            case $b48cc194cf10beb3$var$pki.oids.data:
                if (data.tagClass !== $b48cc194cf10beb3$var$asn1.Class.UNIVERSAL || data.type !== $b48cc194cf10beb3$var$asn1.Type.OCTETSTRING) throw new Error("PKCS#12 SafeContents Data is not an OCTET STRING.");
                safeContents = $b48cc194cf10beb3$var$_decodePkcs7Data(data).value;
                break;
            case $b48cc194cf10beb3$var$pki.oids.encryptedData:
                safeContents = $b48cc194cf10beb3$var$_decryptSafeContents(data, password);
                obj.encrypted = true;
                break;
            default:
                var error = new Error("Unsupported PKCS#12 contentType.");
                error.contentType = $b48cc194cf10beb3$var$asn1.derToOid(capture.contentType);
                throw error;
        }
        obj.safeBags = $b48cc194cf10beb3$var$_decodeSafeContents(safeContents, strict, password);
        pfx.safeContents.push(obj);
    }
}
/**
 * Decrypt PKCS#7 EncryptedData structure.
 *
 * @param data ASN.1 encoded EncryptedContentInfo object.
 * @param password The user-provided password.
 *
 * @return The decrypted SafeContents (ASN.1 object).
 */ function $b48cc194cf10beb3$var$_decryptSafeContents(data, password) {
    var capture = {};
    var errors = [];
    if (!$b48cc194cf10beb3$var$asn1.validate(data, $fz7FM.pkcs7.asn1.encryptedDataValidator, capture, errors)) {
        var error = new Error("Cannot read EncryptedContentInfo.");
        error.errors = errors;
        throw error;
    }
    var oid = $b48cc194cf10beb3$var$asn1.derToOid(capture.contentType);
    if (oid !== $b48cc194cf10beb3$var$pki.oids.data) {
        var error = new Error("PKCS#12 EncryptedContentInfo ContentType is not Data.");
        error.oid = oid;
        throw error;
    }
    // get cipher
    oid = $b48cc194cf10beb3$var$asn1.derToOid(capture.encAlgorithm);
    var cipher = $b48cc194cf10beb3$var$pki.pbe.getCipher(oid, capture.encParameter, password);
    // get encrypted data
    var encryptedContentAsn1 = $b48cc194cf10beb3$var$_decodePkcs7Data(capture.encryptedContentAsn1);
    var encrypted = $fz7FM.util.createBuffer(encryptedContentAsn1.value);
    cipher.update(encrypted);
    if (!cipher.finish()) throw new Error("Failed to decrypt PKCS#12 SafeContents.");
    return cipher.output.getBytes();
}
/**
 * Decode PKCS#12 SafeContents (BER-encoded) into array of Bag objects.
 *
 * The safeContents is a BER-encoded SEQUENCE OF SafeBag.
 *
 * @param {String} safeContents BER-encoded safeContents.
 * @param strict true to use strict DER decoding, false not to.
 * @param {String} password Password to decrypt with (optional).
 *
 * @return {Array} Array of Bag objects.
 */ function $b48cc194cf10beb3$var$_decodeSafeContents(safeContents, strict, password) {
    // if strict and no safe contents, return empty safes
    if (!strict && safeContents.length === 0) return [];
    // actually it's BER-encoded
    safeContents = $b48cc194cf10beb3$var$asn1.fromDer(safeContents, strict);
    if (safeContents.tagClass !== $b48cc194cf10beb3$var$asn1.Class.UNIVERSAL || safeContents.type !== $b48cc194cf10beb3$var$asn1.Type.SEQUENCE || safeContents.constructed !== true) throw new Error("PKCS#12 SafeContents expected to be a SEQUENCE OF SafeBag.");
    var res = [];
    for(var i = 0; i < safeContents.value.length; i++){
        var safeBag = safeContents.value[i];
        // validate SafeBag and capture data
        var capture = {};
        var errors = [];
        if (!$b48cc194cf10beb3$var$asn1.validate(safeBag, $b48cc194cf10beb3$var$safeBagValidator, capture, errors)) {
            var error = new Error("Cannot read SafeBag.");
            error.errors = errors;
            throw error;
        }
        /* Create bag object and push to result array. */ var bag = {
            type: $b48cc194cf10beb3$var$asn1.derToOid(capture.bagId),
            attributes: $b48cc194cf10beb3$var$_decodeBagAttributes(capture.bagAttributes)
        };
        res.push(bag);
        var validator, decoder;
        var bagAsn1 = capture.bagValue.value[0];
        switch(bag.type){
            case $b48cc194cf10beb3$var$pki.oids.pkcs8ShroudedKeyBag:
                /* bagAsn1 has a EncryptedPrivateKeyInfo, which we need to decrypt.
           Afterwards we can handle it like a keyBag,
           which is a PrivateKeyInfo. */ bagAsn1 = $b48cc194cf10beb3$var$pki.decryptPrivateKeyInfo(bagAsn1, password);
                if (bagAsn1 === null) throw new Error("Unable to decrypt PKCS#8 ShroudedKeyBag, wrong password?");
            /* fall through */ case $b48cc194cf10beb3$var$pki.oids.keyBag:
                /* A PKCS#12 keyBag is a simple PrivateKeyInfo as understood by our
           PKI module, hence we don't have to do validation/capturing here,
           just pass what we already got. */ try {
                    bag.key = $b48cc194cf10beb3$var$pki.privateKeyFromAsn1(bagAsn1);
                } catch (e) {
                    // ignore unknown key type, pass asn1 value
                    bag.key = null;
                    bag.asn1 = bagAsn1;
                }
                continue; /* Nothing more to do. */ 
            case $b48cc194cf10beb3$var$pki.oids.certBag:
                /* A PKCS#12 certBag can wrap both X.509 and sdsi certificates.
           Therefore put the SafeBag content through another validator to
           capture the fields.  Afterwards check & store the results. */ validator = $b48cc194cf10beb3$var$certBagValidator;
                decoder = function decoder() {
                    if ($b48cc194cf10beb3$var$asn1.derToOid(capture.certId) !== $b48cc194cf10beb3$var$pki.oids.x509Certificate) {
                        var error = new Error("Unsupported certificate type, only X.509 supported.");
                        error.oid = $b48cc194cf10beb3$var$asn1.derToOid(capture.certId);
                        throw error;
                    }
                    // true=produce cert hash
                    var certAsn1 = $b48cc194cf10beb3$var$asn1.fromDer(capture.cert, strict);
                    try {
                        bag.cert = $b48cc194cf10beb3$var$pki.certificateFromAsn1(certAsn1, true);
                    } catch (e) {
                        // ignore unknown cert type, pass asn1 value
                        bag.cert = null;
                        bag.asn1 = certAsn1;
                    }
                };
                break;
            default:
                var error = new Error("Unsupported PKCS#12 SafeBag type.");
                error.oid = bag.type;
                throw error;
        }
        /* Validate SafeBag value (i.e. CertBag, etc.) and capture data if needed. */ if (validator !== undefined && !$b48cc194cf10beb3$var$asn1.validate(bagAsn1, validator, capture, errors)) {
            var error = new Error("Cannot read PKCS#12 " + validator.name);
            error.errors = errors;
            throw error;
        }
        /* Call decoder function from above to store the results. */ decoder();
    }
    return res;
}
/**
 * Decode PKCS#12 SET OF PKCS12Attribute into JavaScript object.
 *
 * @param attributes SET OF PKCS12Attribute (ASN.1 object).
 *
 * @return the decoded attributes.
 */ function $b48cc194cf10beb3$var$_decodeBagAttributes(attributes) {
    var decodedAttrs = {};
    if (attributes !== undefined) for(var i = 0; i < attributes.length; ++i){
        var capture = {};
        var errors = [];
        if (!$b48cc194cf10beb3$var$asn1.validate(attributes[i], $b48cc194cf10beb3$var$attributeValidator, capture, errors)) {
            var error = new Error("Cannot read PKCS#12 BagAttribute.");
            error.errors = errors;
            throw error;
        }
        var oid = $b48cc194cf10beb3$var$asn1.derToOid(capture.oid);
        if ($b48cc194cf10beb3$var$pki.oids[oid] === undefined) continue;
        decodedAttrs[$b48cc194cf10beb3$var$pki.oids[oid]] = [];
        for(var j = 0; j < capture.values.length; ++j)decodedAttrs[$b48cc194cf10beb3$var$pki.oids[oid]].push(capture.values[j].value);
    }
    return decodedAttrs;
}
/**
 * Wraps a private key and certificate in a PKCS#12 PFX wrapper. If a
 * password is provided then the private key will be encrypted.
 *
 * An entire certificate chain may also be included. To do this, pass
 * an array for the "cert" parameter where the first certificate is
 * the one that is paired with the private key and each subsequent one
 * verifies the previous one. The certificates may be in PEM format or
 * have been already parsed by Forge.
 *
 * @todo implement password-based-encryption for the whole package
 *
 * @param key the private key.
 * @param cert the certificate (may be an array of certificates in order
 *          to specify a certificate chain).
 * @param password the password to use, null for none.
 * @param options:
 *          algorithm the encryption algorithm to use
 *            ('aes128', 'aes192', 'aes256', '3des'), defaults to 'aes128'.
 *          count the iteration count to use.
 *          saltSize the salt size to use.
 *          useMac true to include a MAC, false not to, defaults to true.
 *          localKeyId the local key ID to use, in hex.
 *          friendlyName the friendly name to use.
 *          generateLocalKeyId true to generate a random local key ID,
 *            false not to, defaults to true.
 *
 * @return the PKCS#12 PFX ASN.1 object.
 */ $b48cc194cf10beb3$var$p12.toPkcs12Asn1 = function(key, cert, password, options) {
    // set default options
    options = options || {};
    options.saltSize = options.saltSize || 8;
    options.count = options.count || 2048;
    options.algorithm = options.algorithm || options.encAlgorithm || "aes128";
    if (!("useMac" in options)) options.useMac = true;
    if (!("localKeyId" in options)) options.localKeyId = null;
    if (!("generateLocalKeyId" in options)) options.generateLocalKeyId = true;
    var localKeyId = options.localKeyId;
    var bagAttrs;
    if (localKeyId !== null) localKeyId = $fz7FM.util.hexToBytes(localKeyId);
    else if (options.generateLocalKeyId) {
        // use SHA-1 of paired cert, if available
        if (cert) {
            var pairedCert = $fz7FM.util.isArray(cert) ? cert[0] : cert;
            if (typeof pairedCert === "string") pairedCert = $b48cc194cf10beb3$var$pki.certificateFromPem(pairedCert);
            var sha1 = $fz7FM.md.sha1.create();
            sha1.update($b48cc194cf10beb3$var$asn1.toDer($b48cc194cf10beb3$var$pki.certificateToAsn1(pairedCert)).getBytes());
            localKeyId = sha1.digest().getBytes();
        } else // FIXME: consider using SHA-1 of public key (which can be generated
        // from private key components), see: cert.generateSubjectKeyIdentifier
        // generate random bytes
        localKeyId = $fz7FM.random.getBytes(20);
    }
    var attrs = [];
    if (localKeyId !== null) attrs.push(// localKeyID
    $b48cc194cf10beb3$var$asn1.create($b48cc194cf10beb3$var$asn1.Class.UNIVERSAL, $b48cc194cf10beb3$var$asn1.Type.SEQUENCE, true, [
        // attrId
        $b48cc194cf10beb3$var$asn1.create($b48cc194cf10beb3$var$asn1.Class.UNIVERSAL, $b48cc194cf10beb3$var$asn1.Type.OID, false, $b48cc194cf10beb3$var$asn1.oidToDer($b48cc194cf10beb3$var$pki.oids.localKeyId).getBytes()),
        // attrValues
        $b48cc194cf10beb3$var$asn1.create($b48cc194cf10beb3$var$asn1.Class.UNIVERSAL, $b48cc194cf10beb3$var$asn1.Type.SET, true, [
            $b48cc194cf10beb3$var$asn1.create($b48cc194cf10beb3$var$asn1.Class.UNIVERSAL, $b48cc194cf10beb3$var$asn1.Type.OCTETSTRING, false, localKeyId)
        ])
    ]));
    if ("friendlyName" in options) attrs.push(// friendlyName
    $b48cc194cf10beb3$var$asn1.create($b48cc194cf10beb3$var$asn1.Class.UNIVERSAL, $b48cc194cf10beb3$var$asn1.Type.SEQUENCE, true, [
        // attrId
        $b48cc194cf10beb3$var$asn1.create($b48cc194cf10beb3$var$asn1.Class.UNIVERSAL, $b48cc194cf10beb3$var$asn1.Type.OID, false, $b48cc194cf10beb3$var$asn1.oidToDer($b48cc194cf10beb3$var$pki.oids.friendlyName).getBytes()),
        // attrValues
        $b48cc194cf10beb3$var$asn1.create($b48cc194cf10beb3$var$asn1.Class.UNIVERSAL, $b48cc194cf10beb3$var$asn1.Type.SET, true, [
            $b48cc194cf10beb3$var$asn1.create($b48cc194cf10beb3$var$asn1.Class.UNIVERSAL, $b48cc194cf10beb3$var$asn1.Type.BMPSTRING, false, options.friendlyName)
        ])
    ]));
    if (attrs.length > 0) bagAttrs = $b48cc194cf10beb3$var$asn1.create($b48cc194cf10beb3$var$asn1.Class.UNIVERSAL, $b48cc194cf10beb3$var$asn1.Type.SET, true, attrs);
    // collect contents for AuthenticatedSafe
    var contents = [];
    // create safe bag(s) for certificate chain
    var chain = [];
    if (cert !== null) {
        if ($fz7FM.util.isArray(cert)) chain = cert;
        else chain = [
            cert
        ];
    }
    var certSafeBags = [];
    for(var i = 0; i < chain.length; ++i){
        // convert cert from PEM as necessary
        cert = chain[i];
        if (typeof cert === "string") cert = $b48cc194cf10beb3$var$pki.certificateFromPem(cert);
        // SafeBag
        var certBagAttrs = i === 0 ? bagAttrs : undefined;
        var certAsn1 = $b48cc194cf10beb3$var$pki.certificateToAsn1(cert);
        var certSafeBag = $b48cc194cf10beb3$var$asn1.create($b48cc194cf10beb3$var$asn1.Class.UNIVERSAL, $b48cc194cf10beb3$var$asn1.Type.SEQUENCE, true, [
            // bagId
            $b48cc194cf10beb3$var$asn1.create($b48cc194cf10beb3$var$asn1.Class.UNIVERSAL, $b48cc194cf10beb3$var$asn1.Type.OID, false, $b48cc194cf10beb3$var$asn1.oidToDer($b48cc194cf10beb3$var$pki.oids.certBag).getBytes()),
            // bagValue
            $b48cc194cf10beb3$var$asn1.create($b48cc194cf10beb3$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, [
                // CertBag
                $b48cc194cf10beb3$var$asn1.create($b48cc194cf10beb3$var$asn1.Class.UNIVERSAL, $b48cc194cf10beb3$var$asn1.Type.SEQUENCE, true, [
                    // certId
                    $b48cc194cf10beb3$var$asn1.create($b48cc194cf10beb3$var$asn1.Class.UNIVERSAL, $b48cc194cf10beb3$var$asn1.Type.OID, false, $b48cc194cf10beb3$var$asn1.oidToDer($b48cc194cf10beb3$var$pki.oids.x509Certificate).getBytes()),
                    // certValue (x509Certificate)
                    $b48cc194cf10beb3$var$asn1.create($b48cc194cf10beb3$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, [
                        $b48cc194cf10beb3$var$asn1.create($b48cc194cf10beb3$var$asn1.Class.UNIVERSAL, $b48cc194cf10beb3$var$asn1.Type.OCTETSTRING, false, $b48cc194cf10beb3$var$asn1.toDer(certAsn1).getBytes())
                    ])
                ])
            ]),
            // bagAttributes (OPTIONAL)
            certBagAttrs
        ]);
        certSafeBags.push(certSafeBag);
    }
    if (certSafeBags.length > 0) {
        // SafeContents
        var certSafeContents = $b48cc194cf10beb3$var$asn1.create($b48cc194cf10beb3$var$asn1.Class.UNIVERSAL, $b48cc194cf10beb3$var$asn1.Type.SEQUENCE, true, certSafeBags);
        // ContentInfo
        var certCI = // PKCS#7 ContentInfo
        $b48cc194cf10beb3$var$asn1.create($b48cc194cf10beb3$var$asn1.Class.UNIVERSAL, $b48cc194cf10beb3$var$asn1.Type.SEQUENCE, true, [
            // contentType
            $b48cc194cf10beb3$var$asn1.create($b48cc194cf10beb3$var$asn1.Class.UNIVERSAL, $b48cc194cf10beb3$var$asn1.Type.OID, false, // OID for the content type is 'data'
            $b48cc194cf10beb3$var$asn1.oidToDer($b48cc194cf10beb3$var$pki.oids.data).getBytes()),
            // content
            $b48cc194cf10beb3$var$asn1.create($b48cc194cf10beb3$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, [
                $b48cc194cf10beb3$var$asn1.create($b48cc194cf10beb3$var$asn1.Class.UNIVERSAL, $b48cc194cf10beb3$var$asn1.Type.OCTETSTRING, false, $b48cc194cf10beb3$var$asn1.toDer(certSafeContents).getBytes())
            ])
        ]);
        contents.push(certCI);
    }
    // create safe contents for private key
    var keyBag = null;
    if (key !== null) {
        // SafeBag
        var pkAsn1 = $b48cc194cf10beb3$var$pki.wrapRsaPrivateKey($b48cc194cf10beb3$var$pki.privateKeyToAsn1(key));
        if (password === null) // no encryption
        keyBag = $b48cc194cf10beb3$var$asn1.create($b48cc194cf10beb3$var$asn1.Class.UNIVERSAL, $b48cc194cf10beb3$var$asn1.Type.SEQUENCE, true, [
            // bagId
            $b48cc194cf10beb3$var$asn1.create($b48cc194cf10beb3$var$asn1.Class.UNIVERSAL, $b48cc194cf10beb3$var$asn1.Type.OID, false, $b48cc194cf10beb3$var$asn1.oidToDer($b48cc194cf10beb3$var$pki.oids.keyBag).getBytes()),
            // bagValue
            $b48cc194cf10beb3$var$asn1.create($b48cc194cf10beb3$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, [
                // PrivateKeyInfo
                pkAsn1
            ]),
            // bagAttributes (OPTIONAL)
            bagAttrs
        ]);
        else // encrypted PrivateKeyInfo
        keyBag = $b48cc194cf10beb3$var$asn1.create($b48cc194cf10beb3$var$asn1.Class.UNIVERSAL, $b48cc194cf10beb3$var$asn1.Type.SEQUENCE, true, [
            // bagId
            $b48cc194cf10beb3$var$asn1.create($b48cc194cf10beb3$var$asn1.Class.UNIVERSAL, $b48cc194cf10beb3$var$asn1.Type.OID, false, $b48cc194cf10beb3$var$asn1.oidToDer($b48cc194cf10beb3$var$pki.oids.pkcs8ShroudedKeyBag).getBytes()),
            // bagValue
            $b48cc194cf10beb3$var$asn1.create($b48cc194cf10beb3$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, [
                // EncryptedPrivateKeyInfo
                $b48cc194cf10beb3$var$pki.encryptPrivateKeyInfo(pkAsn1, password, options)
            ]),
            // bagAttributes (OPTIONAL)
            bagAttrs
        ]);
        // SafeContents
        var keySafeContents = $b48cc194cf10beb3$var$asn1.create($b48cc194cf10beb3$var$asn1.Class.UNIVERSAL, $b48cc194cf10beb3$var$asn1.Type.SEQUENCE, true, [
            keyBag
        ]);
        // ContentInfo
        var keyCI = // PKCS#7 ContentInfo
        $b48cc194cf10beb3$var$asn1.create($b48cc194cf10beb3$var$asn1.Class.UNIVERSAL, $b48cc194cf10beb3$var$asn1.Type.SEQUENCE, true, [
            // contentType
            $b48cc194cf10beb3$var$asn1.create($b48cc194cf10beb3$var$asn1.Class.UNIVERSAL, $b48cc194cf10beb3$var$asn1.Type.OID, false, // OID for the content type is 'data'
            $b48cc194cf10beb3$var$asn1.oidToDer($b48cc194cf10beb3$var$pki.oids.data).getBytes()),
            // content
            $b48cc194cf10beb3$var$asn1.create($b48cc194cf10beb3$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, [
                $b48cc194cf10beb3$var$asn1.create($b48cc194cf10beb3$var$asn1.Class.UNIVERSAL, $b48cc194cf10beb3$var$asn1.Type.OCTETSTRING, false, $b48cc194cf10beb3$var$asn1.toDer(keySafeContents).getBytes())
            ])
        ]);
        contents.push(keyCI);
    }
    // create AuthenticatedSafe by stringing together the contents
    var safe = $b48cc194cf10beb3$var$asn1.create($b48cc194cf10beb3$var$asn1.Class.UNIVERSAL, $b48cc194cf10beb3$var$asn1.Type.SEQUENCE, true, contents);
    var macData;
    if (options.useMac) {
        // MacData
        var sha1 = $fz7FM.md.sha1.create();
        var macSalt = new $fz7FM.util.ByteBuffer($fz7FM.random.getBytes(options.saltSize));
        var count = options.count;
        // 160-bit key
        var key = $b48cc194cf10beb3$var$p12.generateKey(password, macSalt, 3, count, 20);
        var mac = $fz7FM.hmac.create();
        mac.start(sha1, key);
        mac.update($b48cc194cf10beb3$var$asn1.toDer(safe).getBytes());
        var macValue = mac.getMac();
        macData = $b48cc194cf10beb3$var$asn1.create($b48cc194cf10beb3$var$asn1.Class.UNIVERSAL, $b48cc194cf10beb3$var$asn1.Type.SEQUENCE, true, [
            // mac DigestInfo
            $b48cc194cf10beb3$var$asn1.create($b48cc194cf10beb3$var$asn1.Class.UNIVERSAL, $b48cc194cf10beb3$var$asn1.Type.SEQUENCE, true, [
                // digestAlgorithm
                $b48cc194cf10beb3$var$asn1.create($b48cc194cf10beb3$var$asn1.Class.UNIVERSAL, $b48cc194cf10beb3$var$asn1.Type.SEQUENCE, true, [
                    // algorithm = SHA-1
                    $b48cc194cf10beb3$var$asn1.create($b48cc194cf10beb3$var$asn1.Class.UNIVERSAL, $b48cc194cf10beb3$var$asn1.Type.OID, false, $b48cc194cf10beb3$var$asn1.oidToDer($b48cc194cf10beb3$var$pki.oids.sha1).getBytes()),
                    // parameters = Null
                    $b48cc194cf10beb3$var$asn1.create($b48cc194cf10beb3$var$asn1.Class.UNIVERSAL, $b48cc194cf10beb3$var$asn1.Type.NULL, false, "")
                ]),
                // digest
                $b48cc194cf10beb3$var$asn1.create($b48cc194cf10beb3$var$asn1.Class.UNIVERSAL, $b48cc194cf10beb3$var$asn1.Type.OCTETSTRING, false, macValue.getBytes())
            ]),
            // macSalt OCTET STRING
            $b48cc194cf10beb3$var$asn1.create($b48cc194cf10beb3$var$asn1.Class.UNIVERSAL, $b48cc194cf10beb3$var$asn1.Type.OCTETSTRING, false, macSalt.getBytes()),
            // iterations INTEGER (XXX: Only support count < 65536)
            $b48cc194cf10beb3$var$asn1.create($b48cc194cf10beb3$var$asn1.Class.UNIVERSAL, $b48cc194cf10beb3$var$asn1.Type.INTEGER, false, $b48cc194cf10beb3$var$asn1.integerToDer(count).getBytes())
        ]);
    }
    // PFX
    return $b48cc194cf10beb3$var$asn1.create($b48cc194cf10beb3$var$asn1.Class.UNIVERSAL, $b48cc194cf10beb3$var$asn1.Type.SEQUENCE, true, [
        // version (3)
        $b48cc194cf10beb3$var$asn1.create($b48cc194cf10beb3$var$asn1.Class.UNIVERSAL, $b48cc194cf10beb3$var$asn1.Type.INTEGER, false, $b48cc194cf10beb3$var$asn1.integerToDer(3).getBytes()),
        // PKCS#7 ContentInfo
        $b48cc194cf10beb3$var$asn1.create($b48cc194cf10beb3$var$asn1.Class.UNIVERSAL, $b48cc194cf10beb3$var$asn1.Type.SEQUENCE, true, [
            // contentType
            $b48cc194cf10beb3$var$asn1.create($b48cc194cf10beb3$var$asn1.Class.UNIVERSAL, $b48cc194cf10beb3$var$asn1.Type.OID, false, // OID for the content type is 'data'
            $b48cc194cf10beb3$var$asn1.oidToDer($b48cc194cf10beb3$var$pki.oids.data).getBytes()),
            // content
            $b48cc194cf10beb3$var$asn1.create($b48cc194cf10beb3$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, [
                $b48cc194cf10beb3$var$asn1.create($b48cc194cf10beb3$var$asn1.Class.UNIVERSAL, $b48cc194cf10beb3$var$asn1.Type.OCTETSTRING, false, $b48cc194cf10beb3$var$asn1.toDer(safe).getBytes())
            ])
        ]),
        macData
    ]);
};
/**
 * Derives a PKCS#12 key.
 *
 * @param password the password to derive the key material from, null or
 *          undefined for none.
 * @param salt the salt, as a ByteBuffer, to use.
 * @param id the PKCS#12 ID byte (1 = key material, 2 = IV, 3 = MAC).
 * @param iter the iteration count.
 * @param n the number of bytes to derive from the password.
 * @param md the message digest to use, defaults to SHA-1.
 *
 * @return a ByteBuffer with the bytes derived from the password.
 */ $b48cc194cf10beb3$var$p12.generateKey = $fz7FM.pbe.generatePkcs12Key;

});
parcelRegister("2RJQB", function(module, exports) {
/**
 * Javascript implementation of ASN.1 validators for PKCS#7 v1.5.
 *
 * @author Dave Longley
 * @author Stefan Siegl
 *
 * Copyright (c) 2012-2015 Digital Bazaar, Inc.
 * Copyright (c) 2012 Stefan Siegl <stesie@brokenpipe.de>
 *
 * The ASN.1 representation of PKCS#7 is as follows
 * (see RFC #2315 for details, http://www.ietf.org/rfc/rfc2315.txt):
 *
 * A PKCS#7 message consists of a ContentInfo on root level, which may
 * contain any number of further ContentInfo nested into it.
 *
 * ContentInfo ::= SEQUENCE {
 *   contentType                ContentType,
 *   content               [0]  EXPLICIT ANY DEFINED BY contentType OPTIONAL
 * }
 *
 * ContentType ::= OBJECT IDENTIFIER
 *
 * EnvelopedData ::= SEQUENCE {
 *   version                    Version,
 *   recipientInfos             RecipientInfos,
 *   encryptedContentInfo       EncryptedContentInfo
 * }
 *
 * EncryptedData ::= SEQUENCE {
 *   version                    Version,
 *   encryptedContentInfo       EncryptedContentInfo
 * }
 *
 * id-signedData OBJECT IDENTIFIER ::= { iso(1) member-body(2)
 *   us(840) rsadsi(113549) pkcs(1) pkcs7(7) 2 }
 *
 * SignedData ::= SEQUENCE {
 *   version           INTEGER,
 *   digestAlgorithms  DigestAlgorithmIdentifiers,
 *   contentInfo       ContentInfo,
 *   certificates      [0] IMPLICIT Certificates OPTIONAL,
 *   crls              [1] IMPLICIT CertificateRevocationLists OPTIONAL,
 *   signerInfos       SignerInfos
 * }
 *
 * SignerInfos ::= SET OF SignerInfo
 *
 * SignerInfo ::= SEQUENCE {
 *   version                    Version,
 *   issuerAndSerialNumber      IssuerAndSerialNumber,
 *   digestAlgorithm            DigestAlgorithmIdentifier,
 *   authenticatedAttributes    [0] IMPLICIT Attributes OPTIONAL,
 *   digestEncryptionAlgorithm  DigestEncryptionAlgorithmIdentifier,
 *   encryptedDigest            EncryptedDigest,
 *   unauthenticatedAttributes  [1] IMPLICIT Attributes OPTIONAL
 * }
 *
 * EncryptedDigest ::= OCTET STRING
 *
 * Attributes ::= SET OF Attribute
 *
 * Attribute ::= SEQUENCE {
 *   attrType    OBJECT IDENTIFIER,
 *   attrValues  SET OF AttributeValue
 * }
 *
 * AttributeValue ::= ANY
 *
 * Version ::= INTEGER
 *
 * RecipientInfos ::= SET OF RecipientInfo
 *
 * EncryptedContentInfo ::= SEQUENCE {
 *   contentType                 ContentType,
 *   contentEncryptionAlgorithm  ContentEncryptionAlgorithmIdentifier,
 *   encryptedContent       [0]  IMPLICIT EncryptedContent OPTIONAL
 * }
 *
 * ContentEncryptionAlgorithmIdentifier ::= AlgorithmIdentifier
 *
 * The AlgorithmIdentifier contains an Object Identifier (OID) and parameters
 * for the algorithm, if any. In the case of AES and DES3, there is only one,
 * the IV.
 *
 * AlgorithmIdentifer ::= SEQUENCE {
 *    algorithm OBJECT IDENTIFIER,
 *    parameters ANY DEFINED BY algorithm OPTIONAL
 * }
 *
 * EncryptedContent ::= OCTET STRING
 *
 * RecipientInfo ::= SEQUENCE {
 *   version                     Version,
 *   issuerAndSerialNumber       IssuerAndSerialNumber,
 *   keyEncryptionAlgorithm      KeyEncryptionAlgorithmIdentifier,
 *   encryptedKey                EncryptedKey
 * }
 *
 * IssuerAndSerialNumber ::= SEQUENCE {
 *   issuer                      Name,
 *   serialNumber                CertificateSerialNumber
 * }
 *
 * CertificateSerialNumber ::= INTEGER
 *
 * KeyEncryptionAlgorithmIdentifier ::= AlgorithmIdentifier
 *
 * EncryptedKey ::= OCTET STRING
 */ 
var $fz7FM = parcelRequire("fz7FM");
parcelRequire("d4EnE");
parcelRequire("gao36");
// shortcut for ASN.1 API
var $21641856222544cb$var$asn1 = $fz7FM.asn1;
// shortcut for PKCS#7 API
var $21641856222544cb$var$p7v = module.exports = $fz7FM.pkcs7asn1 = $fz7FM.pkcs7asn1 || {};
$fz7FM.pkcs7 = $fz7FM.pkcs7 || {};
$fz7FM.pkcs7.asn1 = $21641856222544cb$var$p7v;
var $21641856222544cb$var$contentInfoValidator = {
    name: "ContentInfo",
    tagClass: $21641856222544cb$var$asn1.Class.UNIVERSAL,
    type: $21641856222544cb$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: "ContentInfo.ContentType",
            tagClass: $21641856222544cb$var$asn1.Class.UNIVERSAL,
            type: $21641856222544cb$var$asn1.Type.OID,
            constructed: false,
            capture: "contentType"
        },
        {
            name: "ContentInfo.content",
            tagClass: $21641856222544cb$var$asn1.Class.CONTEXT_SPECIFIC,
            type: 0,
            constructed: true,
            optional: true,
            captureAsn1: "content"
        }
    ]
};
$21641856222544cb$var$p7v.contentInfoValidator = $21641856222544cb$var$contentInfoValidator;
var $21641856222544cb$var$encryptedContentInfoValidator = {
    name: "EncryptedContentInfo",
    tagClass: $21641856222544cb$var$asn1.Class.UNIVERSAL,
    type: $21641856222544cb$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: "EncryptedContentInfo.contentType",
            tagClass: $21641856222544cb$var$asn1.Class.UNIVERSAL,
            type: $21641856222544cb$var$asn1.Type.OID,
            constructed: false,
            capture: "contentType"
        },
        {
            name: "EncryptedContentInfo.contentEncryptionAlgorithm",
            tagClass: $21641856222544cb$var$asn1.Class.UNIVERSAL,
            type: $21641856222544cb$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    name: "EncryptedContentInfo.contentEncryptionAlgorithm.algorithm",
                    tagClass: $21641856222544cb$var$asn1.Class.UNIVERSAL,
                    type: $21641856222544cb$var$asn1.Type.OID,
                    constructed: false,
                    capture: "encAlgorithm"
                },
                {
                    name: "EncryptedContentInfo.contentEncryptionAlgorithm.parameter",
                    tagClass: $21641856222544cb$var$asn1.Class.UNIVERSAL,
                    captureAsn1: "encParameter"
                }
            ]
        },
        {
            name: "EncryptedContentInfo.encryptedContent",
            tagClass: $21641856222544cb$var$asn1.Class.CONTEXT_SPECIFIC,
            type: 0,
            /* The PKCS#7 structure output by OpenSSL somewhat differs from what
     * other implementations do generate.
     *
     * OpenSSL generates a structure like this:
     * SEQUENCE {
     *    ...
     *    [0]
     *       26 DA 67 D2 17 9C 45 3C B1 2A A8 59 2F 29 33 38
     *       C3 C3 DF 86 71 74 7A 19 9F 40 D0 29 BE 85 90 45
     *       ...
     * }
     *
     * Whereas other implementations (and this PKCS#7 module) generate:
     * SEQUENCE {
     *    ...
     *    [0] {
     *       OCTET STRING
     *          26 DA 67 D2 17 9C 45 3C B1 2A A8 59 2F 29 33 38
     *          C3 C3 DF 86 71 74 7A 19 9F 40 D0 29 BE 85 90 45
     *          ...
     *    }
     * }
     *
     * In order to support both, we just capture the context specific
     * field here.  The OCTET STRING bit is removed below.
     */ capture: "encryptedContent",
            captureAsn1: "encryptedContentAsn1"
        }
    ]
};
$21641856222544cb$var$p7v.envelopedDataValidator = {
    name: "EnvelopedData",
    tagClass: $21641856222544cb$var$asn1.Class.UNIVERSAL,
    type: $21641856222544cb$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: "EnvelopedData.Version",
            tagClass: $21641856222544cb$var$asn1.Class.UNIVERSAL,
            type: $21641856222544cb$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "version"
        },
        {
            name: "EnvelopedData.RecipientInfos",
            tagClass: $21641856222544cb$var$asn1.Class.UNIVERSAL,
            type: $21641856222544cb$var$asn1.Type.SET,
            constructed: true,
            captureAsn1: "recipientInfos"
        }
    ].concat($21641856222544cb$var$encryptedContentInfoValidator)
};
$21641856222544cb$var$p7v.encryptedDataValidator = {
    name: "EncryptedData",
    tagClass: $21641856222544cb$var$asn1.Class.UNIVERSAL,
    type: $21641856222544cb$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: "EncryptedData.Version",
            tagClass: $21641856222544cb$var$asn1.Class.UNIVERSAL,
            type: $21641856222544cb$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "version"
        }
    ].concat($21641856222544cb$var$encryptedContentInfoValidator)
};
var $21641856222544cb$var$signerValidator = {
    name: "SignerInfo",
    tagClass: $21641856222544cb$var$asn1.Class.UNIVERSAL,
    type: $21641856222544cb$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: "SignerInfo.version",
            tagClass: $21641856222544cb$var$asn1.Class.UNIVERSAL,
            type: $21641856222544cb$var$asn1.Type.INTEGER,
            constructed: false
        },
        {
            name: "SignerInfo.issuerAndSerialNumber",
            tagClass: $21641856222544cb$var$asn1.Class.UNIVERSAL,
            type: $21641856222544cb$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    name: "SignerInfo.issuerAndSerialNumber.issuer",
                    tagClass: $21641856222544cb$var$asn1.Class.UNIVERSAL,
                    type: $21641856222544cb$var$asn1.Type.SEQUENCE,
                    constructed: true,
                    captureAsn1: "issuer"
                },
                {
                    name: "SignerInfo.issuerAndSerialNumber.serialNumber",
                    tagClass: $21641856222544cb$var$asn1.Class.UNIVERSAL,
                    type: $21641856222544cb$var$asn1.Type.INTEGER,
                    constructed: false,
                    capture: "serial"
                }
            ]
        },
        {
            name: "SignerInfo.digestAlgorithm",
            tagClass: $21641856222544cb$var$asn1.Class.UNIVERSAL,
            type: $21641856222544cb$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    name: "SignerInfo.digestAlgorithm.algorithm",
                    tagClass: $21641856222544cb$var$asn1.Class.UNIVERSAL,
                    type: $21641856222544cb$var$asn1.Type.OID,
                    constructed: false,
                    capture: "digestAlgorithm"
                },
                {
                    name: "SignerInfo.digestAlgorithm.parameter",
                    tagClass: $21641856222544cb$var$asn1.Class.UNIVERSAL,
                    constructed: false,
                    captureAsn1: "digestParameter",
                    optional: true
                }
            ]
        },
        {
            name: "SignerInfo.authenticatedAttributes",
            tagClass: $21641856222544cb$var$asn1.Class.CONTEXT_SPECIFIC,
            type: 0,
            constructed: true,
            optional: true,
            capture: "authenticatedAttributes"
        },
        {
            name: "SignerInfo.digestEncryptionAlgorithm",
            tagClass: $21641856222544cb$var$asn1.Class.UNIVERSAL,
            type: $21641856222544cb$var$asn1.Type.SEQUENCE,
            constructed: true,
            capture: "signatureAlgorithm"
        },
        {
            name: "SignerInfo.encryptedDigest",
            tagClass: $21641856222544cb$var$asn1.Class.UNIVERSAL,
            type: $21641856222544cb$var$asn1.Type.OCTETSTRING,
            constructed: false,
            capture: "signature"
        },
        {
            name: "SignerInfo.unauthenticatedAttributes",
            tagClass: $21641856222544cb$var$asn1.Class.CONTEXT_SPECIFIC,
            type: 1,
            constructed: true,
            optional: true,
            capture: "unauthenticatedAttributes"
        }
    ]
};
$21641856222544cb$var$p7v.signedDataValidator = {
    name: "SignedData",
    tagClass: $21641856222544cb$var$asn1.Class.UNIVERSAL,
    type: $21641856222544cb$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: "SignedData.Version",
            tagClass: $21641856222544cb$var$asn1.Class.UNIVERSAL,
            type: $21641856222544cb$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "version"
        },
        {
            name: "SignedData.DigestAlgorithms",
            tagClass: $21641856222544cb$var$asn1.Class.UNIVERSAL,
            type: $21641856222544cb$var$asn1.Type.SET,
            constructed: true,
            captureAsn1: "digestAlgorithms"
        },
        $21641856222544cb$var$contentInfoValidator,
        {
            name: "SignedData.Certificates",
            tagClass: $21641856222544cb$var$asn1.Class.CONTEXT_SPECIFIC,
            type: 0,
            optional: true,
            captureAsn1: "certificates"
        },
        {
            name: "SignedData.CertificateRevocationLists",
            tagClass: $21641856222544cb$var$asn1.Class.CONTEXT_SPECIFIC,
            type: 1,
            optional: true,
            captureAsn1: "crls"
        },
        {
            name: "SignedData.SignerInfos",
            tagClass: $21641856222544cb$var$asn1.Class.UNIVERSAL,
            type: $21641856222544cb$var$asn1.Type.SET,
            capture: "signerInfos",
            optional: true,
            value: [
                $21641856222544cb$var$signerValidator
            ]
        }
    ]
};
$21641856222544cb$var$p7v.recipientInfoValidator = {
    name: "RecipientInfo",
    tagClass: $21641856222544cb$var$asn1.Class.UNIVERSAL,
    type: $21641856222544cb$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: "RecipientInfo.version",
            tagClass: $21641856222544cb$var$asn1.Class.UNIVERSAL,
            type: $21641856222544cb$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "version"
        },
        {
            name: "RecipientInfo.issuerAndSerial",
            tagClass: $21641856222544cb$var$asn1.Class.UNIVERSAL,
            type: $21641856222544cb$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    name: "RecipientInfo.issuerAndSerial.issuer",
                    tagClass: $21641856222544cb$var$asn1.Class.UNIVERSAL,
                    type: $21641856222544cb$var$asn1.Type.SEQUENCE,
                    constructed: true,
                    captureAsn1: "issuer"
                },
                {
                    name: "RecipientInfo.issuerAndSerial.serialNumber",
                    tagClass: $21641856222544cb$var$asn1.Class.UNIVERSAL,
                    type: $21641856222544cb$var$asn1.Type.INTEGER,
                    constructed: false,
                    capture: "serial"
                }
            ]
        },
        {
            name: "RecipientInfo.keyEncryptionAlgorithm",
            tagClass: $21641856222544cb$var$asn1.Class.UNIVERSAL,
            type: $21641856222544cb$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    name: "RecipientInfo.keyEncryptionAlgorithm.algorithm",
                    tagClass: $21641856222544cb$var$asn1.Class.UNIVERSAL,
                    type: $21641856222544cb$var$asn1.Type.OID,
                    constructed: false,
                    capture: "encAlgorithm"
                },
                {
                    name: "RecipientInfo.keyEncryptionAlgorithm.parameter",
                    tagClass: $21641856222544cb$var$asn1.Class.UNIVERSAL,
                    constructed: false,
                    captureAsn1: "encParameter",
                    optional: true
                }
            ]
        },
        {
            name: "RecipientInfo.encryptedKey",
            tagClass: $21641856222544cb$var$asn1.Class.UNIVERSAL,
            type: $21641856222544cb$var$asn1.Type.OCTETSTRING,
            constructed: false,
            capture: "encKey"
        }
    ]
};

});

parcelRegister("3c4BG", function(module, exports) {
/**
 * Javascript implementation of X.509 and related components (such as
 * Certification Signing Requests) of a Public Key Infrastructure.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2014 Digital Bazaar, Inc.
 *
 * The ASN.1 representation of an X.509v3 certificate is as follows
 * (see RFC 2459):
 *
 * Certificate ::= SEQUENCE {
 *   tbsCertificate       TBSCertificate,
 *   signatureAlgorithm   AlgorithmIdentifier,
 *   signatureValue       BIT STRING
 * }
 *
 * TBSCertificate ::= SEQUENCE {
 *   version         [0]  EXPLICIT Version DEFAULT v1,
 *   serialNumber         CertificateSerialNumber,
 *   signature            AlgorithmIdentifier,
 *   issuer               Name,
 *   validity             Validity,
 *   subject              Name,
 *   subjectPublicKeyInfo SubjectPublicKeyInfo,
 *   issuerUniqueID  [1]  IMPLICIT UniqueIdentifier OPTIONAL,
 *                        -- If present, version shall be v2 or v3
 *   subjectUniqueID [2]  IMPLICIT UniqueIdentifier OPTIONAL,
 *                        -- If present, version shall be v2 or v3
 *   extensions      [3]  EXPLICIT Extensions OPTIONAL
 *                        -- If present, version shall be v3
 * }
 *
 * Version ::= INTEGER  { v1(0), v2(1), v3(2) }
 *
 * CertificateSerialNumber ::= INTEGER
 *
 * Name ::= CHOICE {
 *   // only one possible choice for now
 *   RDNSequence
 * }
 *
 * RDNSequence ::= SEQUENCE OF RelativeDistinguishedName
 *
 * RelativeDistinguishedName ::= SET OF AttributeTypeAndValue
 *
 * AttributeTypeAndValue ::= SEQUENCE {
 *   type     AttributeType,
 *   value    AttributeValue
 * }
 * AttributeType ::= OBJECT IDENTIFIER
 * AttributeValue ::= ANY DEFINED BY AttributeType
 *
 * Validity ::= SEQUENCE {
 *   notBefore      Time,
 *   notAfter       Time
 * }
 *
 * Time ::= CHOICE {
 *   utcTime        UTCTime,
 *   generalTime    GeneralizedTime
 * }
 *
 * UniqueIdentifier ::= BIT STRING
 *
 * SubjectPublicKeyInfo ::= SEQUENCE {
 *   algorithm            AlgorithmIdentifier,
 *   subjectPublicKey     BIT STRING
 * }
 *
 * Extensions ::= SEQUENCE SIZE (1..MAX) OF Extension
 *
 * Extension ::= SEQUENCE {
 *   extnID      OBJECT IDENTIFIER,
 *   critical    BOOLEAN DEFAULT FALSE,
 *   extnValue   OCTET STRING
 * }
 *
 * The only key algorithm currently supported for PKI is RSA.
 *
 * RSASSA-PSS signatures are described in RFC 3447 and RFC 4055.
 *
 * PKCS#10 v1.7 describes certificate signing requests:
 *
 * CertificationRequestInfo:
 *
 * CertificationRequestInfo ::= SEQUENCE {
 *   version       INTEGER { v1(0) } (v1,...),
 *   subject       Name,
 *   subjectPKInfo SubjectPublicKeyInfo{{ PKInfoAlgorithms }},
 *   attributes    [0] Attributes{{ CRIAttributes }}
 * }
 *
 * Attributes { ATTRIBUTE:IOSet } ::= SET OF Attribute{{ IOSet }}
 *
 * CRIAttributes  ATTRIBUTE  ::= {
 *   ... -- add any locally defined attributes here -- }
 *
 * Attribute { ATTRIBUTE:IOSet } ::= SEQUENCE {
 *   type   ATTRIBUTE.&id({IOSet}),
 *   values SET SIZE(1..MAX) OF ATTRIBUTE.&Type({IOSet}{@type})
 * }
 *
 * CertificationRequest ::= SEQUENCE {
 *   certificationRequestInfo CertificationRequestInfo,
 *   signatureAlgorithm AlgorithmIdentifier{{ SignatureAlgorithms }},
 *   signature          BIT STRING
 * }
 */ 
var $fz7FM = parcelRequire("fz7FM");
parcelRequire("60qK1");
parcelRequire("d4EnE");
parcelRequire("bhqHY");
parcelRequire("6NNT4");
parcelRequire("clzK4");
parcelRequire("dm89c");
parcelRequire("8061v");
parcelRequire("1VUmF");
parcelRequire("eRNaT");
parcelRequire("gao36");
// shortcut for asn.1 API
var $253610e522d269d8$var$asn1 = $fz7FM.asn1;
/* Public Key Infrastructure (PKI) implementation. */ var $253610e522d269d8$var$pki = module.exports = $fz7FM.pki = $fz7FM.pki || {};
var $253610e522d269d8$var$oids = $253610e522d269d8$var$pki.oids;
// short name OID mappings
var $253610e522d269d8$var$_shortNames = {};
$253610e522d269d8$var$_shortNames["CN"] = $253610e522d269d8$var$oids["commonName"];
$253610e522d269d8$var$_shortNames["commonName"] = "CN";
$253610e522d269d8$var$_shortNames["C"] = $253610e522d269d8$var$oids["countryName"];
$253610e522d269d8$var$_shortNames["countryName"] = "C";
$253610e522d269d8$var$_shortNames["L"] = $253610e522d269d8$var$oids["localityName"];
$253610e522d269d8$var$_shortNames["localityName"] = "L";
$253610e522d269d8$var$_shortNames["ST"] = $253610e522d269d8$var$oids["stateOrProvinceName"];
$253610e522d269d8$var$_shortNames["stateOrProvinceName"] = "ST";
$253610e522d269d8$var$_shortNames["O"] = $253610e522d269d8$var$oids["organizationName"];
$253610e522d269d8$var$_shortNames["organizationName"] = "O";
$253610e522d269d8$var$_shortNames["OU"] = $253610e522d269d8$var$oids["organizationalUnitName"];
$253610e522d269d8$var$_shortNames["organizationalUnitName"] = "OU";
$253610e522d269d8$var$_shortNames["E"] = $253610e522d269d8$var$oids["emailAddress"];
$253610e522d269d8$var$_shortNames["emailAddress"] = "E";
// validator for an SubjectPublicKeyInfo structure
// Note: Currently only works with an RSA public key
var $253610e522d269d8$var$publicKeyValidator = $fz7FM.pki.rsa.publicKeyValidator;
// validator for an X.509v3 certificate
var $253610e522d269d8$var$x509CertificateValidator = {
    name: "Certificate",
    tagClass: $253610e522d269d8$var$asn1.Class.UNIVERSAL,
    type: $253610e522d269d8$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: "Certificate.TBSCertificate",
            tagClass: $253610e522d269d8$var$asn1.Class.UNIVERSAL,
            type: $253610e522d269d8$var$asn1.Type.SEQUENCE,
            constructed: true,
            captureAsn1: "tbsCertificate",
            value: [
                {
                    name: "Certificate.TBSCertificate.version",
                    tagClass: $253610e522d269d8$var$asn1.Class.CONTEXT_SPECIFIC,
                    type: 0,
                    constructed: true,
                    optional: true,
                    value: [
                        {
                            name: "Certificate.TBSCertificate.version.integer",
                            tagClass: $253610e522d269d8$var$asn1.Class.UNIVERSAL,
                            type: $253610e522d269d8$var$asn1.Type.INTEGER,
                            constructed: false,
                            capture: "certVersion"
                        }
                    ]
                },
                {
                    name: "Certificate.TBSCertificate.serialNumber",
                    tagClass: $253610e522d269d8$var$asn1.Class.UNIVERSAL,
                    type: $253610e522d269d8$var$asn1.Type.INTEGER,
                    constructed: false,
                    capture: "certSerialNumber"
                },
                {
                    name: "Certificate.TBSCertificate.signature",
                    tagClass: $253610e522d269d8$var$asn1.Class.UNIVERSAL,
                    type: $253610e522d269d8$var$asn1.Type.SEQUENCE,
                    constructed: true,
                    value: [
                        {
                            name: "Certificate.TBSCertificate.signature.algorithm",
                            tagClass: $253610e522d269d8$var$asn1.Class.UNIVERSAL,
                            type: $253610e522d269d8$var$asn1.Type.OID,
                            constructed: false,
                            capture: "certinfoSignatureOid"
                        },
                        {
                            name: "Certificate.TBSCertificate.signature.parameters",
                            tagClass: $253610e522d269d8$var$asn1.Class.UNIVERSAL,
                            optional: true,
                            captureAsn1: "certinfoSignatureParams"
                        }
                    ]
                },
                {
                    name: "Certificate.TBSCertificate.issuer",
                    tagClass: $253610e522d269d8$var$asn1.Class.UNIVERSAL,
                    type: $253610e522d269d8$var$asn1.Type.SEQUENCE,
                    constructed: true,
                    captureAsn1: "certIssuer"
                },
                {
                    name: "Certificate.TBSCertificate.validity",
                    tagClass: $253610e522d269d8$var$asn1.Class.UNIVERSAL,
                    type: $253610e522d269d8$var$asn1.Type.SEQUENCE,
                    constructed: true,
                    // Note: UTC and generalized times may both appear so the capture
                    // names are based on their detected order, the names used below
                    // are only for the common case, which validity time really means
                    // "notBefore" and which means "notAfter" will be determined by order
                    value: [
                        {
                            // notBefore (Time) (UTC time case)
                            name: "Certificate.TBSCertificate.validity.notBefore (utc)",
                            tagClass: $253610e522d269d8$var$asn1.Class.UNIVERSAL,
                            type: $253610e522d269d8$var$asn1.Type.UTCTIME,
                            constructed: false,
                            optional: true,
                            capture: "certValidity1UTCTime"
                        },
                        {
                            // notBefore (Time) (generalized time case)
                            name: "Certificate.TBSCertificate.validity.notBefore (generalized)",
                            tagClass: $253610e522d269d8$var$asn1.Class.UNIVERSAL,
                            type: $253610e522d269d8$var$asn1.Type.GENERALIZEDTIME,
                            constructed: false,
                            optional: true,
                            capture: "certValidity2GeneralizedTime"
                        },
                        {
                            // notAfter (Time) (only UTC time is supported)
                            name: "Certificate.TBSCertificate.validity.notAfter (utc)",
                            tagClass: $253610e522d269d8$var$asn1.Class.UNIVERSAL,
                            type: $253610e522d269d8$var$asn1.Type.UTCTIME,
                            constructed: false,
                            optional: true,
                            capture: "certValidity3UTCTime"
                        },
                        {
                            // notAfter (Time) (only UTC time is supported)
                            name: "Certificate.TBSCertificate.validity.notAfter (generalized)",
                            tagClass: $253610e522d269d8$var$asn1.Class.UNIVERSAL,
                            type: $253610e522d269d8$var$asn1.Type.GENERALIZEDTIME,
                            constructed: false,
                            optional: true,
                            capture: "certValidity4GeneralizedTime"
                        }
                    ]
                },
                {
                    // Name (subject) (RDNSequence)
                    name: "Certificate.TBSCertificate.subject",
                    tagClass: $253610e522d269d8$var$asn1.Class.UNIVERSAL,
                    type: $253610e522d269d8$var$asn1.Type.SEQUENCE,
                    constructed: true,
                    captureAsn1: "certSubject"
                },
                // SubjectPublicKeyInfo
                $253610e522d269d8$var$publicKeyValidator,
                {
                    // issuerUniqueID (optional)
                    name: "Certificate.TBSCertificate.issuerUniqueID",
                    tagClass: $253610e522d269d8$var$asn1.Class.CONTEXT_SPECIFIC,
                    type: 1,
                    constructed: true,
                    optional: true,
                    value: [
                        {
                            name: "Certificate.TBSCertificate.issuerUniqueID.id",
                            tagClass: $253610e522d269d8$var$asn1.Class.UNIVERSAL,
                            type: $253610e522d269d8$var$asn1.Type.BITSTRING,
                            constructed: false,
                            // TODO: support arbitrary bit length ids
                            captureBitStringValue: "certIssuerUniqueId"
                        }
                    ]
                },
                {
                    // subjectUniqueID (optional)
                    name: "Certificate.TBSCertificate.subjectUniqueID",
                    tagClass: $253610e522d269d8$var$asn1.Class.CONTEXT_SPECIFIC,
                    type: 2,
                    constructed: true,
                    optional: true,
                    value: [
                        {
                            name: "Certificate.TBSCertificate.subjectUniqueID.id",
                            tagClass: $253610e522d269d8$var$asn1.Class.UNIVERSAL,
                            type: $253610e522d269d8$var$asn1.Type.BITSTRING,
                            constructed: false,
                            // TODO: support arbitrary bit length ids
                            captureBitStringValue: "certSubjectUniqueId"
                        }
                    ]
                },
                {
                    // Extensions (optional)
                    name: "Certificate.TBSCertificate.extensions",
                    tagClass: $253610e522d269d8$var$asn1.Class.CONTEXT_SPECIFIC,
                    type: 3,
                    constructed: true,
                    captureAsn1: "certExtensions",
                    optional: true
                }
            ]
        },
        {
            // AlgorithmIdentifier (signature algorithm)
            name: "Certificate.signatureAlgorithm",
            tagClass: $253610e522d269d8$var$asn1.Class.UNIVERSAL,
            type: $253610e522d269d8$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    // algorithm
                    name: "Certificate.signatureAlgorithm.algorithm",
                    tagClass: $253610e522d269d8$var$asn1.Class.UNIVERSAL,
                    type: $253610e522d269d8$var$asn1.Type.OID,
                    constructed: false,
                    capture: "certSignatureOid"
                },
                {
                    name: "Certificate.TBSCertificate.signature.parameters",
                    tagClass: $253610e522d269d8$var$asn1.Class.UNIVERSAL,
                    optional: true,
                    captureAsn1: "certSignatureParams"
                }
            ]
        },
        {
            // SignatureValue
            name: "Certificate.signatureValue",
            tagClass: $253610e522d269d8$var$asn1.Class.UNIVERSAL,
            type: $253610e522d269d8$var$asn1.Type.BITSTRING,
            constructed: false,
            captureBitStringValue: "certSignature"
        }
    ]
};
var $253610e522d269d8$var$rsassaPssParameterValidator = {
    name: "rsapss",
    tagClass: $253610e522d269d8$var$asn1.Class.UNIVERSAL,
    type: $253610e522d269d8$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: "rsapss.hashAlgorithm",
            tagClass: $253610e522d269d8$var$asn1.Class.CONTEXT_SPECIFIC,
            type: 0,
            constructed: true,
            value: [
                {
                    name: "rsapss.hashAlgorithm.AlgorithmIdentifier",
                    tagClass: $253610e522d269d8$var$asn1.Class.UNIVERSAL,
                    type: $253610e522d269d8$var$asn1.Class.SEQUENCE,
                    constructed: true,
                    optional: true,
                    value: [
                        {
                            name: "rsapss.hashAlgorithm.AlgorithmIdentifier.algorithm",
                            tagClass: $253610e522d269d8$var$asn1.Class.UNIVERSAL,
                            type: $253610e522d269d8$var$asn1.Type.OID,
                            constructed: false,
                            capture: "hashOid"
                        }
                    ]
                }
            ]
        },
        {
            name: "rsapss.maskGenAlgorithm",
            tagClass: $253610e522d269d8$var$asn1.Class.CONTEXT_SPECIFIC,
            type: 1,
            constructed: true,
            value: [
                {
                    name: "rsapss.maskGenAlgorithm.AlgorithmIdentifier",
                    tagClass: $253610e522d269d8$var$asn1.Class.UNIVERSAL,
                    type: $253610e522d269d8$var$asn1.Class.SEQUENCE,
                    constructed: true,
                    optional: true,
                    value: [
                        {
                            name: "rsapss.maskGenAlgorithm.AlgorithmIdentifier.algorithm",
                            tagClass: $253610e522d269d8$var$asn1.Class.UNIVERSAL,
                            type: $253610e522d269d8$var$asn1.Type.OID,
                            constructed: false,
                            capture: "maskGenOid"
                        },
                        {
                            name: "rsapss.maskGenAlgorithm.AlgorithmIdentifier.params",
                            tagClass: $253610e522d269d8$var$asn1.Class.UNIVERSAL,
                            type: $253610e522d269d8$var$asn1.Type.SEQUENCE,
                            constructed: true,
                            value: [
                                {
                                    name: "rsapss.maskGenAlgorithm.AlgorithmIdentifier.params.algorithm",
                                    tagClass: $253610e522d269d8$var$asn1.Class.UNIVERSAL,
                                    type: $253610e522d269d8$var$asn1.Type.OID,
                                    constructed: false,
                                    capture: "maskGenHashOid"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            name: "rsapss.saltLength",
            tagClass: $253610e522d269d8$var$asn1.Class.CONTEXT_SPECIFIC,
            type: 2,
            optional: true,
            value: [
                {
                    name: "rsapss.saltLength.saltLength",
                    tagClass: $253610e522d269d8$var$asn1.Class.UNIVERSAL,
                    type: $253610e522d269d8$var$asn1.Class.INTEGER,
                    constructed: false,
                    capture: "saltLength"
                }
            ]
        },
        {
            name: "rsapss.trailerField",
            tagClass: $253610e522d269d8$var$asn1.Class.CONTEXT_SPECIFIC,
            type: 3,
            optional: true,
            value: [
                {
                    name: "rsapss.trailer.trailer",
                    tagClass: $253610e522d269d8$var$asn1.Class.UNIVERSAL,
                    type: $253610e522d269d8$var$asn1.Class.INTEGER,
                    constructed: false,
                    capture: "trailer"
                }
            ]
        }
    ]
};
// validator for a CertificationRequestInfo structure
var $253610e522d269d8$var$certificationRequestInfoValidator = {
    name: "CertificationRequestInfo",
    tagClass: $253610e522d269d8$var$asn1.Class.UNIVERSAL,
    type: $253610e522d269d8$var$asn1.Type.SEQUENCE,
    constructed: true,
    captureAsn1: "certificationRequestInfo",
    value: [
        {
            name: "CertificationRequestInfo.integer",
            tagClass: $253610e522d269d8$var$asn1.Class.UNIVERSAL,
            type: $253610e522d269d8$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "certificationRequestInfoVersion"
        },
        {
            // Name (subject) (RDNSequence)
            name: "CertificationRequestInfo.subject",
            tagClass: $253610e522d269d8$var$asn1.Class.UNIVERSAL,
            type: $253610e522d269d8$var$asn1.Type.SEQUENCE,
            constructed: true,
            captureAsn1: "certificationRequestInfoSubject"
        },
        // SubjectPublicKeyInfo
        $253610e522d269d8$var$publicKeyValidator,
        {
            name: "CertificationRequestInfo.attributes",
            tagClass: $253610e522d269d8$var$asn1.Class.CONTEXT_SPECIFIC,
            type: 0,
            constructed: true,
            optional: true,
            capture: "certificationRequestInfoAttributes",
            value: [
                {
                    name: "CertificationRequestInfo.attributes",
                    tagClass: $253610e522d269d8$var$asn1.Class.UNIVERSAL,
                    type: $253610e522d269d8$var$asn1.Type.SEQUENCE,
                    constructed: true,
                    value: [
                        {
                            name: "CertificationRequestInfo.attributes.type",
                            tagClass: $253610e522d269d8$var$asn1.Class.UNIVERSAL,
                            type: $253610e522d269d8$var$asn1.Type.OID,
                            constructed: false
                        },
                        {
                            name: "CertificationRequestInfo.attributes.value",
                            tagClass: $253610e522d269d8$var$asn1.Class.UNIVERSAL,
                            type: $253610e522d269d8$var$asn1.Type.SET,
                            constructed: true
                        }
                    ]
                }
            ]
        }
    ]
};
// validator for a CertificationRequest structure
var $253610e522d269d8$var$certificationRequestValidator = {
    name: "CertificationRequest",
    tagClass: $253610e522d269d8$var$asn1.Class.UNIVERSAL,
    type: $253610e522d269d8$var$asn1.Type.SEQUENCE,
    constructed: true,
    captureAsn1: "csr",
    value: [
        $253610e522d269d8$var$certificationRequestInfoValidator,
        {
            // AlgorithmIdentifier (signature algorithm)
            name: "CertificationRequest.signatureAlgorithm",
            tagClass: $253610e522d269d8$var$asn1.Class.UNIVERSAL,
            type: $253610e522d269d8$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    // algorithm
                    name: "CertificationRequest.signatureAlgorithm.algorithm",
                    tagClass: $253610e522d269d8$var$asn1.Class.UNIVERSAL,
                    type: $253610e522d269d8$var$asn1.Type.OID,
                    constructed: false,
                    capture: "csrSignatureOid"
                },
                {
                    name: "CertificationRequest.signatureAlgorithm.parameters",
                    tagClass: $253610e522d269d8$var$asn1.Class.UNIVERSAL,
                    optional: true,
                    captureAsn1: "csrSignatureParams"
                }
            ]
        },
        {
            // signature
            name: "CertificationRequest.signature",
            tagClass: $253610e522d269d8$var$asn1.Class.UNIVERSAL,
            type: $253610e522d269d8$var$asn1.Type.BITSTRING,
            constructed: false,
            captureBitStringValue: "csrSignature"
        }
    ]
};
/**
 * Converts an RDNSequence of ASN.1 DER-encoded RelativeDistinguishedName
 * sets into an array with objects that have type and value properties.
 *
 * @param rdn the RDNSequence to convert.
 * @param md a message digest to append type and value to if provided.
 */ $253610e522d269d8$var$pki.RDNAttributesAsArray = function(rdn, md) {
    var rval = [];
    // each value in 'rdn' in is a SET of RelativeDistinguishedName
    var set, attr, obj;
    for(var si = 0; si < rdn.value.length; ++si){
        // get the RelativeDistinguishedName set
        set = rdn.value[si];
        // each value in the SET is an AttributeTypeAndValue sequence
        // containing first a type (an OID) and second a value (defined by
        // the OID)
        for(var i = 0; i < set.value.length; ++i){
            obj = {};
            attr = set.value[i];
            obj.type = $253610e522d269d8$var$asn1.derToOid(attr.value[0].value);
            obj.value = attr.value[1].value;
            obj.valueTagClass = attr.value[1].type;
            // if the OID is known, get its name and short name
            if (obj.type in $253610e522d269d8$var$oids) {
                obj.name = $253610e522d269d8$var$oids[obj.type];
                if (obj.name in $253610e522d269d8$var$_shortNames) obj.shortName = $253610e522d269d8$var$_shortNames[obj.name];
            }
            if (md) {
                md.update(obj.type);
                md.update(obj.value);
            }
            rval.push(obj);
        }
    }
    return rval;
};
/**
 * Converts ASN.1 CRIAttributes into an array with objects that have type and
 * value properties.
 *
 * @param attributes the CRIAttributes to convert.
 */ $253610e522d269d8$var$pki.CRIAttributesAsArray = function(attributes) {
    var rval = [];
    // each value in 'attributes' in is a SEQUENCE with an OID and a SET
    for(var si = 0; si < attributes.length; ++si){
        // get the attribute sequence
        var seq = attributes[si];
        // each value in the SEQUENCE containing first a type (an OID) and
        // second a set of values (defined by the OID)
        var type = $253610e522d269d8$var$asn1.derToOid(seq.value[0].value);
        var values = seq.value[1].value;
        for(var vi = 0; vi < values.length; ++vi){
            var obj = {};
            obj.type = type;
            obj.value = values[vi].value;
            obj.valueTagClass = values[vi].type;
            // if the OID is known, get its name and short name
            if (obj.type in $253610e522d269d8$var$oids) {
                obj.name = $253610e522d269d8$var$oids[obj.type];
                if (obj.name in $253610e522d269d8$var$_shortNames) obj.shortName = $253610e522d269d8$var$_shortNames[obj.name];
            }
            // parse extensions
            if (obj.type === $253610e522d269d8$var$oids.extensionRequest) {
                obj.extensions = [];
                for(var ei = 0; ei < obj.value.length; ++ei)obj.extensions.push($253610e522d269d8$var$pki.certificateExtensionFromAsn1(obj.value[ei]));
            }
            rval.push(obj);
        }
    }
    return rval;
};
/**
 * Gets an issuer or subject attribute from its name, type, or short name.
 *
 * @param obj the issuer or subject object.
 * @param options a short name string or an object with:
 *          shortName the short name for the attribute.
 *          name the name for the attribute.
 *          type the type for the attribute.
 *
 * @return the attribute.
 */ function $253610e522d269d8$var$_getAttribute(obj, options) {
    if (typeof options === "string") options = {
        shortName: options
    };
    var rval = null;
    var attr;
    for(var i = 0; rval === null && i < obj.attributes.length; ++i){
        attr = obj.attributes[i];
        if (options.type && options.type === attr.type) rval = attr;
        else if (options.name && options.name === attr.name) rval = attr;
        else if (options.shortName && options.shortName === attr.shortName) rval = attr;
    }
    return rval;
}
/**
 * Converts signature parameters from ASN.1 structure.
 *
 * Currently only RSASSA-PSS supported.  The PKCS#1 v1.5 signature scheme had
 * no parameters.
 *
 * RSASSA-PSS-params  ::=  SEQUENCE  {
 *   hashAlgorithm      [0] HashAlgorithm DEFAULT
 *                             sha1Identifier,
 *   maskGenAlgorithm   [1] MaskGenAlgorithm DEFAULT
 *                             mgf1SHA1Identifier,
 *   saltLength         [2] INTEGER DEFAULT 20,
 *   trailerField       [3] INTEGER DEFAULT 1
 * }
 *
 * HashAlgorithm  ::=  AlgorithmIdentifier
 *
 * MaskGenAlgorithm  ::=  AlgorithmIdentifier
 *
 * AlgorithmIdentifer ::= SEQUENCE {
 *   algorithm OBJECT IDENTIFIER,
 *   parameters ANY DEFINED BY algorithm OPTIONAL
 * }
 *
 * @param oid The OID specifying the signature algorithm
 * @param obj The ASN.1 structure holding the parameters
 * @param fillDefaults Whether to use return default values where omitted
 * @return signature parameter object
 */ var $253610e522d269d8$var$_readSignatureParameters = function _readSignatureParameters(oid, obj, fillDefaults) {
    var params = {};
    if (oid !== $253610e522d269d8$var$oids["RSASSA-PSS"]) return params;
    if (fillDefaults) params = {
        hash: {
            algorithmOid: $253610e522d269d8$var$oids["sha1"]
        },
        mgf: {
            algorithmOid: $253610e522d269d8$var$oids["mgf1"],
            hash: {
                algorithmOid: $253610e522d269d8$var$oids["sha1"]
            }
        },
        saltLength: 20
    };
    var capture = {};
    var errors = [];
    if (!$253610e522d269d8$var$asn1.validate(obj, $253610e522d269d8$var$rsassaPssParameterValidator, capture, errors)) {
        var error = new Error("Cannot read RSASSA-PSS parameter block.");
        error.errors = errors;
        throw error;
    }
    if (capture.hashOid !== undefined) {
        params.hash = params.hash || {};
        params.hash.algorithmOid = $253610e522d269d8$var$asn1.derToOid(capture.hashOid);
    }
    if (capture.maskGenOid !== undefined) {
        params.mgf = params.mgf || {};
        params.mgf.algorithmOid = $253610e522d269d8$var$asn1.derToOid(capture.maskGenOid);
        params.mgf.hash = params.mgf.hash || {};
        params.mgf.hash.algorithmOid = $253610e522d269d8$var$asn1.derToOid(capture.maskGenHashOid);
    }
    if (capture.saltLength !== undefined) params.saltLength = capture.saltLength.charCodeAt(0);
    return params;
};
/**
 * Create signature digest for OID.
 *
 * @param options
 *   signatureOid: the OID specifying the signature algorithm.
 *   type: a human readable type for error messages
 * @return a created md instance. throws if unknown oid.
 */ var $253610e522d269d8$var$_createSignatureDigest = function _createSignatureDigest(options) {
    switch($253610e522d269d8$var$oids[options.signatureOid]){
        case "sha1WithRSAEncryption":
        // deprecated alias
        case "sha1WithRSASignature":
            return $fz7FM.md.sha1.create();
        case "md5WithRSAEncryption":
            return $fz7FM.md.md5.create();
        case "sha256WithRSAEncryption":
            return $fz7FM.md.sha256.create();
        case "sha384WithRSAEncryption":
            return $fz7FM.md.sha384.create();
        case "sha512WithRSAEncryption":
            return $fz7FM.md.sha512.create();
        case "RSASSA-PSS":
            return $fz7FM.md.sha256.create();
        default:
            var error = new Error("Could not compute " + options.type + " digest. " + "Unknown signature OID.");
            error.signatureOid = options.signatureOid;
            throw error;
    }
};
/**
 * Verify signature on certificate or CSR.
 *
 * @param options:
 *   certificate the certificate or CSR to verify.
 *   md the signature digest.
 *   signature the signature
 * @return a created md instance. throws if unknown oid.
 */ var $253610e522d269d8$var$_verifySignature = function _verifySignature(options) {
    var cert = options.certificate;
    var scheme;
    switch(cert.signatureOid){
        case $253610e522d269d8$var$oids.sha1WithRSAEncryption:
        // deprecated alias
        case $253610e522d269d8$var$oids.sha1WithRSASignature:
            break;
        case $253610e522d269d8$var$oids["RSASSA-PSS"]:
            var hash, mgf;
            /* initialize mgf */ hash = $253610e522d269d8$var$oids[cert.signatureParameters.mgf.hash.algorithmOid];
            if (hash === undefined || $fz7FM.md[hash] === undefined) {
                var error = new Error("Unsupported MGF hash function.");
                error.oid = cert.signatureParameters.mgf.hash.algorithmOid;
                error.name = hash;
                throw error;
            }
            mgf = $253610e522d269d8$var$oids[cert.signatureParameters.mgf.algorithmOid];
            if (mgf === undefined || $fz7FM.mgf[mgf] === undefined) {
                var error = new Error("Unsupported MGF function.");
                error.oid = cert.signatureParameters.mgf.algorithmOid;
                error.name = mgf;
                throw error;
            }
            mgf = $fz7FM.mgf[mgf].create($fz7FM.md[hash].create());
            /* initialize hash function */ hash = $253610e522d269d8$var$oids[cert.signatureParameters.hash.algorithmOid];
            if (hash === undefined || $fz7FM.md[hash] === undefined) {
                var error = new Error("Unsupported RSASSA-PSS hash function.");
                error.oid = cert.signatureParameters.hash.algorithmOid;
                error.name = hash;
                throw error;
            }
            scheme = $fz7FM.pss.create($fz7FM.md[hash].create(), mgf, cert.signatureParameters.saltLength);
            break;
    }
    // verify signature on cert using public key
    return cert.publicKey.verify(options.md.digest().getBytes(), options.signature, scheme);
};
/**
 * Converts an X.509 certificate from PEM format.
 *
 * Note: If the certificate is to be verified then compute hash should
 * be set to true. This will scan the TBSCertificate part of the ASN.1
 * object while it is converted so it doesn't need to be converted back
 * to ASN.1-DER-encoding later.
 *
 * @param pem the PEM-formatted certificate.
 * @param computeHash true to compute the hash for verification.
 * @param strict true to be strict when checking ASN.1 value lengths, false to
 *          allow truncated values (default: true).
 *
 * @return the certificate.
 */ $253610e522d269d8$var$pki.certificateFromPem = function(pem, computeHash, strict) {
    var msg = $fz7FM.pem.decode(pem)[0];
    if (msg.type !== "CERTIFICATE" && msg.type !== "X509 CERTIFICATE" && msg.type !== "TRUSTED CERTIFICATE") {
        var error = new Error('Could not convert certificate from PEM; PEM header type is not "CERTIFICATE", "X509 CERTIFICATE", or "TRUSTED CERTIFICATE".');
        error.headerType = msg.type;
        throw error;
    }
    if (msg.procType && msg.procType.type === "ENCRYPTED") throw new Error("Could not convert certificate from PEM; PEM is encrypted.");
    // convert DER to ASN.1 object
    var obj = $253610e522d269d8$var$asn1.fromDer(msg.body, strict);
    return $253610e522d269d8$var$pki.certificateFromAsn1(obj, computeHash);
};
/**
 * Converts an X.509 certificate to PEM format.
 *
 * @param cert the certificate.
 * @param maxline the maximum characters per line, defaults to 64.
 *
 * @return the PEM-formatted certificate.
 */ $253610e522d269d8$var$pki.certificateToPem = function(cert, maxline) {
    // convert to ASN.1, then DER, then PEM-encode
    var msg = {
        type: "CERTIFICATE",
        body: $253610e522d269d8$var$asn1.toDer($253610e522d269d8$var$pki.certificateToAsn1(cert)).getBytes()
    };
    return $fz7FM.pem.encode(msg, {
        maxline: maxline
    });
};
/**
 * Converts an RSA public key from PEM format.
 *
 * @param pem the PEM-formatted public key.
 *
 * @return the public key.
 */ $253610e522d269d8$var$pki.publicKeyFromPem = function(pem) {
    var msg = $fz7FM.pem.decode(pem)[0];
    if (msg.type !== "PUBLIC KEY" && msg.type !== "RSA PUBLIC KEY") {
        var error = new Error('Could not convert public key from PEM; PEM header type is not "PUBLIC KEY" or "RSA PUBLIC KEY".');
        error.headerType = msg.type;
        throw error;
    }
    if (msg.procType && msg.procType.type === "ENCRYPTED") throw new Error("Could not convert public key from PEM; PEM is encrypted.");
    // convert DER to ASN.1 object
    var obj = $253610e522d269d8$var$asn1.fromDer(msg.body);
    return $253610e522d269d8$var$pki.publicKeyFromAsn1(obj);
};
/**
 * Converts an RSA public key to PEM format (using a SubjectPublicKeyInfo).
 *
 * @param key the public key.
 * @param maxline the maximum characters per line, defaults to 64.
 *
 * @return the PEM-formatted public key.
 */ $253610e522d269d8$var$pki.publicKeyToPem = function(key, maxline) {
    // convert to ASN.1, then DER, then PEM-encode
    var msg = {
        type: "PUBLIC KEY",
        body: $253610e522d269d8$var$asn1.toDer($253610e522d269d8$var$pki.publicKeyToAsn1(key)).getBytes()
    };
    return $fz7FM.pem.encode(msg, {
        maxline: maxline
    });
};
/**
 * Converts an RSA public key to PEM format (using an RSAPublicKey).
 *
 * @param key the public key.
 * @param maxline the maximum characters per line, defaults to 64.
 *
 * @return the PEM-formatted public key.
 */ $253610e522d269d8$var$pki.publicKeyToRSAPublicKeyPem = function(key, maxline) {
    // convert to ASN.1, then DER, then PEM-encode
    var msg = {
        type: "RSA PUBLIC KEY",
        body: $253610e522d269d8$var$asn1.toDer($253610e522d269d8$var$pki.publicKeyToRSAPublicKey(key)).getBytes()
    };
    return $fz7FM.pem.encode(msg, {
        maxline: maxline
    });
};
/**
 * Gets a fingerprint for the given public key.
 *
 * @param options the options to use.
 *          [md] the message digest object to use (defaults to forge.md.sha1).
 *          [type] the type of fingerprint, such as 'RSAPublicKey',
 *            'SubjectPublicKeyInfo' (defaults to 'RSAPublicKey').
 *          [encoding] an alternative output encoding, such as 'hex'
 *            (defaults to none, outputs a byte buffer).
 *          [delimiter] the delimiter to use between bytes for 'hex' encoded
 *            output, eg: ':' (defaults to none).
 *
 * @return the fingerprint as a byte buffer or other encoding based on options.
 */ $253610e522d269d8$var$pki.getPublicKeyFingerprint = function(key, options) {
    options = options || {};
    var md = options.md || $fz7FM.md.sha1.create();
    var type = options.type || "RSAPublicKey";
    var bytes;
    switch(type){
        case "RSAPublicKey":
            bytes = $253610e522d269d8$var$asn1.toDer($253610e522d269d8$var$pki.publicKeyToRSAPublicKey(key)).getBytes();
            break;
        case "SubjectPublicKeyInfo":
            bytes = $253610e522d269d8$var$asn1.toDer($253610e522d269d8$var$pki.publicKeyToAsn1(key)).getBytes();
            break;
        default:
            throw new Error('Unknown fingerprint type "' + options.type + '".');
    }
    // hash public key bytes
    md.start();
    md.update(bytes);
    var digest = md.digest();
    if (options.encoding === "hex") {
        var hex = digest.toHex();
        if (options.delimiter) return hex.match(/.{2}/g).join(options.delimiter);
        return hex;
    } else if (options.encoding === "binary") return digest.getBytes();
    else if (options.encoding) throw new Error('Unknown encoding "' + options.encoding + '".');
    return digest;
};
/**
 * Converts a PKCS#10 certification request (CSR) from PEM format.
 *
 * Note: If the certification request is to be verified then compute hash
 * should be set to true. This will scan the CertificationRequestInfo part of
 * the ASN.1 object while it is converted so it doesn't need to be converted
 * back to ASN.1-DER-encoding later.
 *
 * @param pem the PEM-formatted certificate.
 * @param computeHash true to compute the hash for verification.
 * @param strict true to be strict when checking ASN.1 value lengths, false to
 *          allow truncated values (default: true).
 *
 * @return the certification request (CSR).
 */ $253610e522d269d8$var$pki.certificationRequestFromPem = function(pem, computeHash, strict) {
    var msg = $fz7FM.pem.decode(pem)[0];
    if (msg.type !== "CERTIFICATE REQUEST") {
        var error = new Error('Could not convert certification request from PEM; PEM header type is not "CERTIFICATE REQUEST".');
        error.headerType = msg.type;
        throw error;
    }
    if (msg.procType && msg.procType.type === "ENCRYPTED") throw new Error("Could not convert certification request from PEM; PEM is encrypted.");
    // convert DER to ASN.1 object
    var obj = $253610e522d269d8$var$asn1.fromDer(msg.body, strict);
    return $253610e522d269d8$var$pki.certificationRequestFromAsn1(obj, computeHash);
};
/**
 * Converts a PKCS#10 certification request (CSR) to PEM format.
 *
 * @param csr the certification request.
 * @param maxline the maximum characters per line, defaults to 64.
 *
 * @return the PEM-formatted certification request.
 */ $253610e522d269d8$var$pki.certificationRequestToPem = function(csr, maxline) {
    // convert to ASN.1, then DER, then PEM-encode
    var msg = {
        type: "CERTIFICATE REQUEST",
        body: $253610e522d269d8$var$asn1.toDer($253610e522d269d8$var$pki.certificationRequestToAsn1(csr)).getBytes()
    };
    return $fz7FM.pem.encode(msg, {
        maxline: maxline
    });
};
/**
 * Creates an empty X.509v3 RSA certificate.
 *
 * @return the certificate.
 */ $253610e522d269d8$var$pki.createCertificate = function() {
    var cert = {};
    cert.version = 0x02;
    cert.serialNumber = "00";
    cert.signatureOid = null;
    cert.signature = null;
    cert.siginfo = {};
    cert.siginfo.algorithmOid = null;
    cert.validity = {};
    cert.validity.notBefore = new Date();
    cert.validity.notAfter = new Date();
    cert.issuer = {};
    cert.issuer.getField = function(sn) {
        return $253610e522d269d8$var$_getAttribute(cert.issuer, sn);
    };
    cert.issuer.addField = function(attr) {
        $253610e522d269d8$var$_fillMissingFields([
            attr
        ]);
        cert.issuer.attributes.push(attr);
    };
    cert.issuer.attributes = [];
    cert.issuer.hash = null;
    cert.subject = {};
    cert.subject.getField = function(sn) {
        return $253610e522d269d8$var$_getAttribute(cert.subject, sn);
    };
    cert.subject.addField = function(attr) {
        $253610e522d269d8$var$_fillMissingFields([
            attr
        ]);
        cert.subject.attributes.push(attr);
    };
    cert.subject.attributes = [];
    cert.subject.hash = null;
    cert.extensions = [];
    cert.publicKey = null;
    cert.md = null;
    /**
   * Sets the subject of this certificate.
   *
   * @param attrs the array of subject attributes to use.
   * @param uniqueId an optional a unique ID to use.
   */ cert.setSubject = function(attrs, uniqueId) {
        // set new attributes, clear hash
        $253610e522d269d8$var$_fillMissingFields(attrs);
        cert.subject.attributes = attrs;
        delete cert.subject.uniqueId;
        if (uniqueId) // TODO: support arbitrary bit length ids
        cert.subject.uniqueId = uniqueId;
        cert.subject.hash = null;
    };
    /**
   * Sets the issuer of this certificate.
   *
   * @param attrs the array of issuer attributes to use.
   * @param uniqueId an optional a unique ID to use.
   */ cert.setIssuer = function(attrs, uniqueId) {
        // set new attributes, clear hash
        $253610e522d269d8$var$_fillMissingFields(attrs);
        cert.issuer.attributes = attrs;
        delete cert.issuer.uniqueId;
        if (uniqueId) // TODO: support arbitrary bit length ids
        cert.issuer.uniqueId = uniqueId;
        cert.issuer.hash = null;
    };
    /**
   * Sets the extensions of this certificate.
   *
   * @param exts the array of extensions to use.
   */ cert.setExtensions = function(exts) {
        for(var i = 0; i < exts.length; ++i)$253610e522d269d8$var$_fillMissingExtensionFields(exts[i], {
            cert: cert
        });
        // set new extensions
        cert.extensions = exts;
    };
    /**
   * Gets an extension by its name or id.
   *
   * @param options the name to use or an object with:
   *          name the name to use.
   *          id the id to use.
   *
   * @return the extension or null if not found.
   */ cert.getExtension = function(options) {
        if (typeof options === "string") options = {
            name: options
        };
        var rval = null;
        var ext;
        for(var i = 0; rval === null && i < cert.extensions.length; ++i){
            ext = cert.extensions[i];
            if (options.id && ext.id === options.id) rval = ext;
            else if (options.name && ext.name === options.name) rval = ext;
        }
        return rval;
    };
    /**
   * Signs this certificate using the given private key.
   *
   * @param key the private key to sign with.
   * @param md the message digest object to use (defaults to forge.md.sha1).
   */ cert.sign = function(key, md) {
        // TODO: get signature OID from private key
        cert.md = md || $fz7FM.md.sha1.create();
        var algorithmOid = $253610e522d269d8$var$oids[cert.md.algorithm + "WithRSAEncryption"];
        if (!algorithmOid) {
            var error = new Error("Could not compute certificate digest. Unknown message digest algorithm OID.");
            error.algorithm = cert.md.algorithm;
            throw error;
        }
        cert.signatureOid = cert.siginfo.algorithmOid = algorithmOid;
        // get TBSCertificate, convert to DER
        cert.tbsCertificate = $253610e522d269d8$var$pki.getTBSCertificate(cert);
        var bytes = $253610e522d269d8$var$asn1.toDer(cert.tbsCertificate);
        // digest and sign
        cert.md.update(bytes.getBytes());
        cert.signature = key.sign(cert.md);
    };
    /**
   * Attempts verify the signature on the passed certificate using this
   * certificate's public key.
   *
   * @param child the certificate to verify.
   *
   * @return true if verified, false if not.
   */ cert.verify = function(child) {
        var rval = false;
        if (!cert.issued(child)) {
            var issuer = child.issuer;
            var subject = cert.subject;
            var error = new Error("The parent certificate did not issue the given child certificate; the child certificate's issuer does not match the parent's subject.");
            error.expectedIssuer = subject.attributes;
            error.actualIssuer = issuer.attributes;
            throw error;
        }
        var md = child.md;
        if (md === null) {
            // create digest for OID signature types
            md = $253610e522d269d8$var$_createSignatureDigest({
                signatureOid: child.signatureOid,
                type: "certificate"
            });
            // produce DER formatted TBSCertificate and digest it
            var tbsCertificate = child.tbsCertificate || $253610e522d269d8$var$pki.getTBSCertificate(child);
            var bytes = $253610e522d269d8$var$asn1.toDer(tbsCertificate);
            md.update(bytes.getBytes());
        }
        if (md !== null) rval = $253610e522d269d8$var$_verifySignature({
            certificate: cert,
            md: md,
            signature: child.signature
        });
        return rval;
    };
    /**
   * Returns true if this certificate's issuer matches the passed
   * certificate's subject. Note that no signature check is performed.
   *
   * @param parent the certificate to check.
   *
   * @return true if this certificate's issuer matches the passed certificate's
   *         subject.
   */ cert.isIssuer = function(parent) {
        var rval = false;
        var i = cert.issuer;
        var s = parent.subject;
        // compare hashes if present
        if (i.hash && s.hash) rval = i.hash === s.hash;
        else if (i.attributes.length === s.attributes.length) {
            // all attributes are the same so issuer matches subject
            rval = true;
            var iattr, sattr;
            for(var n = 0; rval && n < i.attributes.length; ++n){
                iattr = i.attributes[n];
                sattr = s.attributes[n];
                if (iattr.type !== sattr.type || iattr.value !== sattr.value) // attribute mismatch
                rval = false;
            }
        }
        return rval;
    };
    /**
   * Returns true if this certificate's subject matches the issuer of the
   * given certificate). Note that not signature check is performed.
   *
   * @param child the certificate to check.
   *
   * @return true if this certificate's subject matches the passed
   *         certificate's issuer.
   */ cert.issued = function(child) {
        return child.isIssuer(cert);
    };
    /**
   * Generates the subjectKeyIdentifier for this certificate as byte buffer.
   *
   * @return the subjectKeyIdentifier for this certificate as byte buffer.
   */ cert.generateSubjectKeyIdentifier = function() {
        /* See: 4.2.1.2 section of the the RFC3280, keyIdentifier is either:

      (1) The keyIdentifier is composed of the 160-bit SHA-1 hash of the
        value of the BIT STRING subjectPublicKey (excluding the tag,
        length, and number of unused bits).

      (2) The keyIdentifier is composed of a four bit type field with
        the value 0100 followed by the least significant 60 bits of the
        SHA-1 hash of the value of the BIT STRING subjectPublicKey
        (excluding the tag, length, and number of unused bit string bits).
    */ // skipping the tag, length, and number of unused bits is the same
        // as just using the RSAPublicKey (for RSA keys, which are the
        // only ones supported)
        return $253610e522d269d8$var$pki.getPublicKeyFingerprint(cert.publicKey, {
            type: "RSAPublicKey"
        });
    };
    /**
   * Verifies the subjectKeyIdentifier extension value for this certificate
   * against its public key. If no extension is found, false will be
   * returned.
   *
   * @return true if verified, false if not.
   */ cert.verifySubjectKeyIdentifier = function() {
        var oid = $253610e522d269d8$var$oids["subjectKeyIdentifier"];
        for(var i = 0; i < cert.extensions.length; ++i){
            var ext = cert.extensions[i];
            if (ext.id === oid) {
                var ski = cert.generateSubjectKeyIdentifier().getBytes();
                return $fz7FM.util.hexToBytes(ext.subjectKeyIdentifier) === ski;
            }
        }
        return false;
    };
    return cert;
};
/**
 * Converts an X.509v3 RSA certificate from an ASN.1 object.
 *
 * Note: If the certificate is to be verified then compute hash should
 * be set to true. There is currently no implementation for converting
 * a certificate back to ASN.1 so the TBSCertificate part of the ASN.1
 * object needs to be scanned before the cert object is created.
 *
 * @param obj the asn1 representation of an X.509v3 RSA certificate.
 * @param computeHash true to compute the hash for verification.
 *
 * @return the certificate.
 */ $253610e522d269d8$var$pki.certificateFromAsn1 = function(obj, computeHash) {
    // validate certificate and capture data
    var capture = {};
    var errors = [];
    if (!$253610e522d269d8$var$asn1.validate(obj, $253610e522d269d8$var$x509CertificateValidator, capture, errors)) {
        var error = new Error("Cannot read X.509 certificate. ASN.1 object is not an X509v3 Certificate.");
        error.errors = errors;
        throw error;
    }
    // get oid
    var oid = $253610e522d269d8$var$asn1.derToOid(capture.publicKeyOid);
    if (oid !== $253610e522d269d8$var$pki.oids.rsaEncryption) throw new Error("Cannot read public key. OID is not RSA.");
    // create certificate
    var cert = $253610e522d269d8$var$pki.createCertificate();
    cert.version = capture.certVersion ? capture.certVersion.charCodeAt(0) : 0;
    var serial = $fz7FM.util.createBuffer(capture.certSerialNumber);
    cert.serialNumber = serial.toHex();
    cert.signatureOid = $fz7FM.asn1.derToOid(capture.certSignatureOid);
    cert.signatureParameters = $253610e522d269d8$var$_readSignatureParameters(cert.signatureOid, capture.certSignatureParams, true);
    cert.siginfo.algorithmOid = $fz7FM.asn1.derToOid(capture.certinfoSignatureOid);
    cert.siginfo.parameters = $253610e522d269d8$var$_readSignatureParameters(cert.siginfo.algorithmOid, capture.certinfoSignatureParams, false);
    cert.signature = capture.certSignature;
    var validity = [];
    if (capture.certValidity1UTCTime !== undefined) validity.push($253610e522d269d8$var$asn1.utcTimeToDate(capture.certValidity1UTCTime));
    if (capture.certValidity2GeneralizedTime !== undefined) validity.push($253610e522d269d8$var$asn1.generalizedTimeToDate(capture.certValidity2GeneralizedTime));
    if (capture.certValidity3UTCTime !== undefined) validity.push($253610e522d269d8$var$asn1.utcTimeToDate(capture.certValidity3UTCTime));
    if (capture.certValidity4GeneralizedTime !== undefined) validity.push($253610e522d269d8$var$asn1.generalizedTimeToDate(capture.certValidity4GeneralizedTime));
    if (validity.length > 2) throw new Error("Cannot read notBefore/notAfter validity times; more than two times were provided in the certificate.");
    if (validity.length < 2) throw new Error("Cannot read notBefore/notAfter validity times; they were not provided as either UTCTime or GeneralizedTime.");
    cert.validity.notBefore = validity[0];
    cert.validity.notAfter = validity[1];
    // keep TBSCertificate to preserve signature when exporting
    cert.tbsCertificate = capture.tbsCertificate;
    if (computeHash) {
        // create digest for OID signature type
        cert.md = $253610e522d269d8$var$_createSignatureDigest({
            signatureOid: cert.signatureOid,
            type: "certificate"
        });
        // produce DER formatted TBSCertificate and digest it
        var bytes = $253610e522d269d8$var$asn1.toDer(cert.tbsCertificate);
        cert.md.update(bytes.getBytes());
    }
    // handle issuer, build issuer message digest
    var imd = $fz7FM.md.sha1.create();
    var ibytes = $253610e522d269d8$var$asn1.toDer(capture.certIssuer);
    imd.update(ibytes.getBytes());
    cert.issuer.getField = function(sn) {
        return $253610e522d269d8$var$_getAttribute(cert.issuer, sn);
    };
    cert.issuer.addField = function(attr) {
        $253610e522d269d8$var$_fillMissingFields([
            attr
        ]);
        cert.issuer.attributes.push(attr);
    };
    cert.issuer.attributes = $253610e522d269d8$var$pki.RDNAttributesAsArray(capture.certIssuer);
    if (capture.certIssuerUniqueId) cert.issuer.uniqueId = capture.certIssuerUniqueId;
    cert.issuer.hash = imd.digest().toHex();
    // handle subject, build subject message digest
    var smd = $fz7FM.md.sha1.create();
    var sbytes = $253610e522d269d8$var$asn1.toDer(capture.certSubject);
    smd.update(sbytes.getBytes());
    cert.subject.getField = function(sn) {
        return $253610e522d269d8$var$_getAttribute(cert.subject, sn);
    };
    cert.subject.addField = function(attr) {
        $253610e522d269d8$var$_fillMissingFields([
            attr
        ]);
        cert.subject.attributes.push(attr);
    };
    cert.subject.attributes = $253610e522d269d8$var$pki.RDNAttributesAsArray(capture.certSubject);
    if (capture.certSubjectUniqueId) cert.subject.uniqueId = capture.certSubjectUniqueId;
    cert.subject.hash = smd.digest().toHex();
    // handle extensions
    if (capture.certExtensions) cert.extensions = $253610e522d269d8$var$pki.certificateExtensionsFromAsn1(capture.certExtensions);
    else cert.extensions = [];
    // convert RSA public key from ASN.1
    cert.publicKey = $253610e522d269d8$var$pki.publicKeyFromAsn1(capture.subjectPublicKeyInfo);
    return cert;
};
/**
 * Converts an ASN.1 extensions object (with extension sequences as its
 * values) into an array of extension objects with types and values.
 *
 * Supported extensions:
 *
 * id-ce-keyUsage OBJECT IDENTIFIER ::=  { id-ce 15 }
 * KeyUsage ::= BIT STRING {
 *   digitalSignature        (0),
 *   nonRepudiation          (1),
 *   keyEncipherment         (2),
 *   dataEncipherment        (3),
 *   keyAgreement            (4),
 *   keyCertSign             (5),
 *   cRLSign                 (6),
 *   encipherOnly            (7),
 *   decipherOnly            (8)
 * }
 *
 * id-ce-basicConstraints OBJECT IDENTIFIER ::=  { id-ce 19 }
 * BasicConstraints ::= SEQUENCE {
 *   cA                      BOOLEAN DEFAULT FALSE,
 *   pathLenConstraint       INTEGER (0..MAX) OPTIONAL
 * }
 *
 * subjectAltName EXTENSION ::= {
 *   SYNTAX GeneralNames
 *   IDENTIFIED BY id-ce-subjectAltName
 * }
 *
 * GeneralNames ::= SEQUENCE SIZE (1..MAX) OF GeneralName
 *
 * GeneralName ::= CHOICE {
 *   otherName      [0] INSTANCE OF OTHER-NAME,
 *   rfc822Name     [1] IA5String,
 *   dNSName        [2] IA5String,
 *   x400Address    [3] ORAddress,
 *   directoryName  [4] Name,
 *   ediPartyName   [5] EDIPartyName,
 *   uniformResourceIdentifier [6] IA5String,
 *   IPAddress      [7] OCTET STRING,
 *   registeredID   [8] OBJECT IDENTIFIER
 * }
 *
 * OTHER-NAME ::= TYPE-IDENTIFIER
 *
 * EDIPartyName ::= SEQUENCE {
 *   nameAssigner [0] DirectoryString {ub-name} OPTIONAL,
 *   partyName    [1] DirectoryString {ub-name}
 * }
 *
 * @param exts the extensions ASN.1 with extension sequences to parse.
 *
 * @return the array.
 */ $253610e522d269d8$var$pki.certificateExtensionsFromAsn1 = function(exts) {
    var rval = [];
    for(var i = 0; i < exts.value.length; ++i){
        // get extension sequence
        var extseq = exts.value[i];
        for(var ei = 0; ei < extseq.value.length; ++ei)rval.push($253610e522d269d8$var$pki.certificateExtensionFromAsn1(extseq.value[ei]));
    }
    return rval;
};
/**
 * Parses a single certificate extension from ASN.1.
 *
 * @param ext the extension in ASN.1 format.
 *
 * @return the parsed extension as an object.
 */ $253610e522d269d8$var$pki.certificateExtensionFromAsn1 = function(ext) {
    // an extension has:
    // [0] extnID      OBJECT IDENTIFIER
    // [1] critical    BOOLEAN DEFAULT FALSE
    // [2] extnValue   OCTET STRING
    var e = {};
    e.id = $253610e522d269d8$var$asn1.derToOid(ext.value[0].value);
    e.critical = false;
    if (ext.value[1].type === $253610e522d269d8$var$asn1.Type.BOOLEAN) {
        e.critical = ext.value[1].value.charCodeAt(0) !== 0x00;
        e.value = ext.value[2].value;
    } else e.value = ext.value[1].value;
    // if the oid is known, get its name
    if (e.id in $253610e522d269d8$var$oids) {
        e.name = $253610e522d269d8$var$oids[e.id];
        // handle key usage
        if (e.name === "keyUsage") {
            // get value as BIT STRING
            var ev = $253610e522d269d8$var$asn1.fromDer(e.value);
            var b2 = 0x00;
            var b3 = 0x00;
            if (ev.value.length > 1) {
                // skip first byte, just indicates unused bits which
                // will be padded with 0s anyway
                // get bytes with flag bits
                b2 = ev.value.charCodeAt(1);
                b3 = ev.value.length > 2 ? ev.value.charCodeAt(2) : 0;
            }
            // set flags
            e.digitalSignature = (b2 & 0x80) === 0x80;
            e.nonRepudiation = (b2 & 0x40) === 0x40;
            e.keyEncipherment = (b2 & 0x20) === 0x20;
            e.dataEncipherment = (b2 & 0x10) === 0x10;
            e.keyAgreement = (b2 & 0x08) === 0x08;
            e.keyCertSign = (b2 & 0x04) === 0x04;
            e.cRLSign = (b2 & 0x02) === 0x02;
            e.encipherOnly = (b2 & 0x01) === 0x01;
            e.decipherOnly = (b3 & 0x80) === 0x80;
        } else if (e.name === "basicConstraints") {
            // handle basic constraints
            // get value as SEQUENCE
            var ev = $253610e522d269d8$var$asn1.fromDer(e.value);
            // get cA BOOLEAN flag (defaults to false)
            if (ev.value.length > 0 && ev.value[0].type === $253610e522d269d8$var$asn1.Type.BOOLEAN) e.cA = ev.value[0].value.charCodeAt(0) !== 0x00;
            else e.cA = false;
            // get path length constraint
            var value = null;
            if (ev.value.length > 0 && ev.value[0].type === $253610e522d269d8$var$asn1.Type.INTEGER) value = ev.value[0].value;
            else if (ev.value.length > 1) value = ev.value[1].value;
            if (value !== null) e.pathLenConstraint = $253610e522d269d8$var$asn1.derToInteger(value);
        } else if (e.name === "extKeyUsage") {
            // handle extKeyUsage
            // value is a SEQUENCE of OIDs
            var ev = $253610e522d269d8$var$asn1.fromDer(e.value);
            for(var vi = 0; vi < ev.value.length; ++vi){
                var oid = $253610e522d269d8$var$asn1.derToOid(ev.value[vi].value);
                if (oid in $253610e522d269d8$var$oids) e[$253610e522d269d8$var$oids[oid]] = true;
                else e[oid] = true;
            }
        } else if (e.name === "nsCertType") {
            // handle nsCertType
            // get value as BIT STRING
            var ev = $253610e522d269d8$var$asn1.fromDer(e.value);
            var b2 = 0x00;
            if (ev.value.length > 1) // skip first byte, just indicates unused bits which
            // will be padded with 0s anyway
            // get bytes with flag bits
            b2 = ev.value.charCodeAt(1);
            // set flags
            e.client = (b2 & 0x80) === 0x80;
            e.server = (b2 & 0x40) === 0x40;
            e.email = (b2 & 0x20) === 0x20;
            e.objsign = (b2 & 0x10) === 0x10;
            e.reserved = (b2 & 0x08) === 0x08;
            e.sslCA = (b2 & 0x04) === 0x04;
            e.emailCA = (b2 & 0x02) === 0x02;
            e.objCA = (b2 & 0x01) === 0x01;
        } else if (e.name === "subjectAltName" || e.name === "issuerAltName") {
            // handle subjectAltName/issuerAltName
            e.altNames = [];
            // ev is a SYNTAX SEQUENCE
            var gn;
            var ev = $253610e522d269d8$var$asn1.fromDer(e.value);
            for(var n = 0; n < ev.value.length; ++n){
                // get GeneralName
                gn = ev.value[n];
                var altName = {
                    type: gn.type,
                    value: gn.value
                };
                e.altNames.push(altName);
                // Note: Support for types 1,2,6,7,8
                switch(gn.type){
                    // rfc822Name
                    case 1:
                    // dNSName
                    case 2:
                    // uniformResourceIdentifier (URI)
                    case 6:
                        break;
                    // IPAddress
                    case 7:
                        // convert to IPv4/IPv6 string representation
                        altName.ip = $fz7FM.util.bytesToIP(gn.value);
                        break;
                    // registeredID
                    case 8:
                        altName.oid = $253610e522d269d8$var$asn1.derToOid(gn.value);
                        break;
                    default:
                }
            }
        } else if (e.name === "subjectKeyIdentifier") {
            // value is an OCTETSTRING w/the hash of the key-type specific
            // public key structure (eg: RSAPublicKey)
            var ev = $253610e522d269d8$var$asn1.fromDer(e.value);
            e.subjectKeyIdentifier = $fz7FM.util.bytesToHex(ev.value);
        }
    }
    return e;
};
/**
 * Converts a PKCS#10 certification request (CSR) from an ASN.1 object.
 *
 * Note: If the certification request is to be verified then compute hash
 * should be set to true. There is currently no implementation for converting
 * a certificate back to ASN.1 so the CertificationRequestInfo part of the
 * ASN.1 object needs to be scanned before the csr object is created.
 *
 * @param obj the asn1 representation of a PKCS#10 certification request (CSR).
 * @param computeHash true to compute the hash for verification.
 *
 * @return the certification request (CSR).
 */ $253610e522d269d8$var$pki.certificationRequestFromAsn1 = function(obj, computeHash) {
    // validate certification request and capture data
    var capture = {};
    var errors = [];
    if (!$253610e522d269d8$var$asn1.validate(obj, $253610e522d269d8$var$certificationRequestValidator, capture, errors)) {
        var error = new Error("Cannot read PKCS#10 certificate request. ASN.1 object is not a PKCS#10 CertificationRequest.");
        error.errors = errors;
        throw error;
    }
    // get oid
    var oid = $253610e522d269d8$var$asn1.derToOid(capture.publicKeyOid);
    if (oid !== $253610e522d269d8$var$pki.oids.rsaEncryption) throw new Error("Cannot read public key. OID is not RSA.");
    // create certification request
    var csr = $253610e522d269d8$var$pki.createCertificationRequest();
    csr.version = capture.csrVersion ? capture.csrVersion.charCodeAt(0) : 0;
    csr.signatureOid = $fz7FM.asn1.derToOid(capture.csrSignatureOid);
    csr.signatureParameters = $253610e522d269d8$var$_readSignatureParameters(csr.signatureOid, capture.csrSignatureParams, true);
    csr.siginfo.algorithmOid = $fz7FM.asn1.derToOid(capture.csrSignatureOid);
    csr.siginfo.parameters = $253610e522d269d8$var$_readSignatureParameters(csr.siginfo.algorithmOid, capture.csrSignatureParams, false);
    csr.signature = capture.csrSignature;
    // keep CertificationRequestInfo to preserve signature when exporting
    csr.certificationRequestInfo = capture.certificationRequestInfo;
    if (computeHash) {
        // create digest for OID signature type
        csr.md = $253610e522d269d8$var$_createSignatureDigest({
            signatureOid: csr.signatureOid,
            type: "certification request"
        });
        // produce DER formatted CertificationRequestInfo and digest it
        var bytes = $253610e522d269d8$var$asn1.toDer(csr.certificationRequestInfo);
        csr.md.update(bytes.getBytes());
    }
    // handle subject, build subject message digest
    var smd = $fz7FM.md.sha1.create();
    csr.subject.getField = function(sn) {
        return $253610e522d269d8$var$_getAttribute(csr.subject, sn);
    };
    csr.subject.addField = function(attr) {
        $253610e522d269d8$var$_fillMissingFields([
            attr
        ]);
        csr.subject.attributes.push(attr);
    };
    csr.subject.attributes = $253610e522d269d8$var$pki.RDNAttributesAsArray(capture.certificationRequestInfoSubject, smd);
    csr.subject.hash = smd.digest().toHex();
    // convert RSA public key from ASN.1
    csr.publicKey = $253610e522d269d8$var$pki.publicKeyFromAsn1(capture.subjectPublicKeyInfo);
    // convert attributes from ASN.1
    csr.getAttribute = function(sn) {
        return $253610e522d269d8$var$_getAttribute(csr, sn);
    };
    csr.addAttribute = function(attr) {
        $253610e522d269d8$var$_fillMissingFields([
            attr
        ]);
        csr.attributes.push(attr);
    };
    csr.attributes = $253610e522d269d8$var$pki.CRIAttributesAsArray(capture.certificationRequestInfoAttributes || []);
    return csr;
};
/**
 * Creates an empty certification request (a CSR or certificate signing
 * request). Once created, its public key and attributes can be set and then
 * it can be signed.
 *
 * @return the empty certification request.
 */ $253610e522d269d8$var$pki.createCertificationRequest = function() {
    var csr = {};
    csr.version = 0x00;
    csr.signatureOid = null;
    csr.signature = null;
    csr.siginfo = {};
    csr.siginfo.algorithmOid = null;
    csr.subject = {};
    csr.subject.getField = function(sn) {
        return $253610e522d269d8$var$_getAttribute(csr.subject, sn);
    };
    csr.subject.addField = function(attr) {
        $253610e522d269d8$var$_fillMissingFields([
            attr
        ]);
        csr.subject.attributes.push(attr);
    };
    csr.subject.attributes = [];
    csr.subject.hash = null;
    csr.publicKey = null;
    csr.attributes = [];
    csr.getAttribute = function(sn) {
        return $253610e522d269d8$var$_getAttribute(csr, sn);
    };
    csr.addAttribute = function(attr) {
        $253610e522d269d8$var$_fillMissingFields([
            attr
        ]);
        csr.attributes.push(attr);
    };
    csr.md = null;
    /**
   * Sets the subject of this certification request.
   *
   * @param attrs the array of subject attributes to use.
   */ csr.setSubject = function(attrs) {
        // set new attributes
        $253610e522d269d8$var$_fillMissingFields(attrs);
        csr.subject.attributes = attrs;
        csr.subject.hash = null;
    };
    /**
   * Sets the attributes of this certification request.
   *
   * @param attrs the array of attributes to use.
   */ csr.setAttributes = function(attrs) {
        // set new attributes
        $253610e522d269d8$var$_fillMissingFields(attrs);
        csr.attributes = attrs;
    };
    /**
   * Signs this certification request using the given private key.
   *
   * @param key the private key to sign with.
   * @param md the message digest object to use (defaults to forge.md.sha1).
   */ csr.sign = function(key, md) {
        // TODO: get signature OID from private key
        csr.md = md || $fz7FM.md.sha1.create();
        var algorithmOid = $253610e522d269d8$var$oids[csr.md.algorithm + "WithRSAEncryption"];
        if (!algorithmOid) {
            var error = new Error("Could not compute certification request digest. Unknown message digest algorithm OID.");
            error.algorithm = csr.md.algorithm;
            throw error;
        }
        csr.signatureOid = csr.siginfo.algorithmOid = algorithmOid;
        // get CertificationRequestInfo, convert to DER
        csr.certificationRequestInfo = $253610e522d269d8$var$pki.getCertificationRequestInfo(csr);
        var bytes = $253610e522d269d8$var$asn1.toDer(csr.certificationRequestInfo);
        // digest and sign
        csr.md.update(bytes.getBytes());
        csr.signature = key.sign(csr.md);
    };
    /**
   * Attempts verify the signature on the passed certification request using
   * its public key.
   *
   * A CSR that has been exported to a file in PEM format can be verified using
   * OpenSSL using this command:
   *
   * openssl req -in <the-csr-pem-file> -verify -noout -text
   *
   * @return true if verified, false if not.
   */ csr.verify = function() {
        var rval = false;
        var md = csr.md;
        if (md === null) {
            md = $253610e522d269d8$var$_createSignatureDigest({
                signatureOid: csr.signatureOid,
                type: "certification request"
            });
            // produce DER formatted CertificationRequestInfo and digest it
            var cri = csr.certificationRequestInfo || $253610e522d269d8$var$pki.getCertificationRequestInfo(csr);
            var bytes = $253610e522d269d8$var$asn1.toDer(cri);
            md.update(bytes.getBytes());
        }
        if (md !== null) rval = $253610e522d269d8$var$_verifySignature({
            certificate: csr,
            md: md,
            signature: csr.signature
        });
        return rval;
    };
    return csr;
};
/**
 * Converts an X.509 subject or issuer to an ASN.1 RDNSequence.
 *
 * @param obj the subject or issuer (distinguished name).
 *
 * @return the ASN.1 RDNSequence.
 */ function $253610e522d269d8$var$_dnToAsn1(obj) {
    // create an empty RDNSequence
    var rval = $253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, $253610e522d269d8$var$asn1.Type.SEQUENCE, true, []);
    // iterate over attributes
    var attr, set;
    var attrs = obj.attributes;
    for(var i = 0; i < attrs.length; ++i){
        attr = attrs[i];
        var value = attr.value;
        // reuse tag class for attribute value if available
        var valueTagClass = $253610e522d269d8$var$asn1.Type.PRINTABLESTRING;
        if ("valueTagClass" in attr) {
            valueTagClass = attr.valueTagClass;
            if (valueTagClass === $253610e522d269d8$var$asn1.Type.UTF8) value = $fz7FM.util.encodeUtf8(value);
        // FIXME: handle more encodings
        }
        // create a RelativeDistinguishedName set
        // each value in the set is an AttributeTypeAndValue first
        // containing the type (an OID) and second the value
        set = $253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, $253610e522d269d8$var$asn1.Type.SET, true, [
            $253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, $253610e522d269d8$var$asn1.Type.SEQUENCE, true, [
                // AttributeType
                $253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, $253610e522d269d8$var$asn1.Type.OID, false, $253610e522d269d8$var$asn1.oidToDer(attr.type).getBytes()),
                // AttributeValue
                $253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, valueTagClass, false, value)
            ])
        ]);
        rval.value.push(set);
    }
    return rval;
}
/**
 * Gets all printable attributes (typically of an issuer or subject) in a
 * simplified JSON format for display.
 *
 * @param attrs the attributes.
 *
 * @return the JSON for display.
 */ function $253610e522d269d8$var$_getAttributesAsJson(attrs) {
    var rval = {};
    for(var i = 0; i < attrs.length; ++i){
        var attr = attrs[i];
        if (attr.shortName && (attr.valueTagClass === $253610e522d269d8$var$asn1.Type.UTF8 || attr.valueTagClass === $253610e522d269d8$var$asn1.Type.PRINTABLESTRING || attr.valueTagClass === $253610e522d269d8$var$asn1.Type.IA5STRING)) {
            var value = attr.value;
            if (attr.valueTagClass === $253610e522d269d8$var$asn1.Type.UTF8) value = $fz7FM.util.encodeUtf8(attr.value);
            if (!(attr.shortName in rval)) rval[attr.shortName] = value;
            else if ($fz7FM.util.isArray(rval[attr.shortName])) rval[attr.shortName].push(value);
            else rval[attr.shortName] = [
                rval[attr.shortName],
                value
            ];
        }
    }
    return rval;
}
/**
 * Fills in missing fields in attributes.
 *
 * @param attrs the attributes to fill missing fields in.
 */ function $253610e522d269d8$var$_fillMissingFields(attrs) {
    var attr;
    for(var i = 0; i < attrs.length; ++i){
        attr = attrs[i];
        // populate missing name
        if (typeof attr.name === "undefined") {
            if (attr.type && attr.type in $253610e522d269d8$var$pki.oids) attr.name = $253610e522d269d8$var$pki.oids[attr.type];
            else if (attr.shortName && attr.shortName in $253610e522d269d8$var$_shortNames) attr.name = $253610e522d269d8$var$pki.oids[$253610e522d269d8$var$_shortNames[attr.shortName]];
        }
        // populate missing type (OID)
        if (typeof attr.type === "undefined") {
            if (attr.name && attr.name in $253610e522d269d8$var$pki.oids) attr.type = $253610e522d269d8$var$pki.oids[attr.name];
            else {
                var error = new Error("Attribute type not specified.");
                error.attribute = attr;
                throw error;
            }
        }
        // populate missing shortname
        if (typeof attr.shortName === "undefined") {
            if (attr.name && attr.name in $253610e522d269d8$var$_shortNames) attr.shortName = $253610e522d269d8$var$_shortNames[attr.name];
        }
        // convert extensions to value
        if (attr.type === $253610e522d269d8$var$oids.extensionRequest) {
            attr.valueConstructed = true;
            attr.valueTagClass = $253610e522d269d8$var$asn1.Type.SEQUENCE;
            if (!attr.value && attr.extensions) {
                attr.value = [];
                for(var ei = 0; ei < attr.extensions.length; ++ei)attr.value.push($253610e522d269d8$var$pki.certificateExtensionToAsn1($253610e522d269d8$var$_fillMissingExtensionFields(attr.extensions[ei])));
            }
        }
        if (typeof attr.value === "undefined") {
            var error = new Error("Attribute value not specified.");
            error.attribute = attr;
            throw error;
        }
    }
}
/**
 * Fills in missing fields in certificate extensions.
 *
 * @param e the extension.
 * @param [options] the options to use.
 *          [cert] the certificate the extensions are for.
 *
 * @return the extension.
 */ function $253610e522d269d8$var$_fillMissingExtensionFields(e, options) {
    options = options || {};
    // populate missing name
    if (typeof e.name === "undefined") {
        if (e.id && e.id in $253610e522d269d8$var$pki.oids) e.name = $253610e522d269d8$var$pki.oids[e.id];
    }
    // populate missing id
    if (typeof e.id === "undefined") {
        if (e.name && e.name in $253610e522d269d8$var$pki.oids) e.id = $253610e522d269d8$var$pki.oids[e.name];
        else {
            var error = new Error("Extension ID not specified.");
            error.extension = e;
            throw error;
        }
    }
    if (typeof e.value !== "undefined") return e;
    // handle missing value:
    // value is a BIT STRING
    if (e.name === "keyUsage") {
        // build flags
        var unused = 0;
        var b2 = 0x00;
        var b3 = 0x00;
        if (e.digitalSignature) {
            b2 |= 0x80;
            unused = 7;
        }
        if (e.nonRepudiation) {
            b2 |= 0x40;
            unused = 6;
        }
        if (e.keyEncipherment) {
            b2 |= 0x20;
            unused = 5;
        }
        if (e.dataEncipherment) {
            b2 |= 0x10;
            unused = 4;
        }
        if (e.keyAgreement) {
            b2 |= 0x08;
            unused = 3;
        }
        if (e.keyCertSign) {
            b2 |= 0x04;
            unused = 2;
        }
        if (e.cRLSign) {
            b2 |= 0x02;
            unused = 1;
        }
        if (e.encipherOnly) {
            b2 |= 0x01;
            unused = 0;
        }
        if (e.decipherOnly) {
            b3 |= 0x80;
            unused = 7;
        }
        // create bit string
        var value = String.fromCharCode(unused);
        if (b3 !== 0) value += String.fromCharCode(b2) + String.fromCharCode(b3);
        else if (b2 !== 0) value += String.fromCharCode(b2);
        e.value = $253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, $253610e522d269d8$var$asn1.Type.BITSTRING, false, value);
    } else if (e.name === "basicConstraints") {
        // basicConstraints is a SEQUENCE
        e.value = $253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, $253610e522d269d8$var$asn1.Type.SEQUENCE, true, []);
        // cA BOOLEAN flag defaults to false
        if (e.cA) e.value.value.push($253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, $253610e522d269d8$var$asn1.Type.BOOLEAN, false, String.fromCharCode(0xFF)));
        if ("pathLenConstraint" in e) e.value.value.push($253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, $253610e522d269d8$var$asn1.Type.INTEGER, false, $253610e522d269d8$var$asn1.integerToDer(e.pathLenConstraint).getBytes()));
    } else if (e.name === "extKeyUsage") {
        // extKeyUsage is a SEQUENCE of OIDs
        e.value = $253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, $253610e522d269d8$var$asn1.Type.SEQUENCE, true, []);
        var seq = e.value.value;
        for(var key in e){
            if (e[key] !== true) continue;
            // key is name in OID map
            if (key in $253610e522d269d8$var$oids) seq.push($253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, $253610e522d269d8$var$asn1.Type.OID, false, $253610e522d269d8$var$asn1.oidToDer($253610e522d269d8$var$oids[key]).getBytes()));
            else if (key.indexOf(".") !== -1) // assume key is an OID
            seq.push($253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, $253610e522d269d8$var$asn1.Type.OID, false, $253610e522d269d8$var$asn1.oidToDer(key).getBytes()));
        }
    } else if (e.name === "nsCertType") {
        // nsCertType is a BIT STRING
        // build flags
        var unused = 0;
        var b2 = 0x00;
        if (e.client) {
            b2 |= 0x80;
            unused = 7;
        }
        if (e.server) {
            b2 |= 0x40;
            unused = 6;
        }
        if (e.email) {
            b2 |= 0x20;
            unused = 5;
        }
        if (e.objsign) {
            b2 |= 0x10;
            unused = 4;
        }
        if (e.reserved) {
            b2 |= 0x08;
            unused = 3;
        }
        if (e.sslCA) {
            b2 |= 0x04;
            unused = 2;
        }
        if (e.emailCA) {
            b2 |= 0x02;
            unused = 1;
        }
        if (e.objCA) {
            b2 |= 0x01;
            unused = 0;
        }
        // create bit string
        var value = String.fromCharCode(unused);
        if (b2 !== 0) value += String.fromCharCode(b2);
        e.value = $253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, $253610e522d269d8$var$asn1.Type.BITSTRING, false, value);
    } else if (e.name === "subjectAltName" || e.name === "issuerAltName") {
        // SYNTAX SEQUENCE
        e.value = $253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, $253610e522d269d8$var$asn1.Type.SEQUENCE, true, []);
        var altName;
        for(var n = 0; n < e.altNames.length; ++n){
            altName = e.altNames[n];
            var value = altName.value;
            // handle IP
            if (altName.type === 7 && altName.ip) {
                value = $fz7FM.util.bytesFromIP(altName.ip);
                if (value === null) {
                    var error = new Error('Extension "ip" value is not a valid IPv4 or IPv6 address.');
                    error.extension = e;
                    throw error;
                }
            } else if (altName.type === 8) {
                // handle OID
                if (altName.oid) value = $253610e522d269d8$var$asn1.oidToDer($253610e522d269d8$var$asn1.oidToDer(altName.oid));
                else // deprecated ... convert value to OID
                value = $253610e522d269d8$var$asn1.oidToDer(value);
            }
            e.value.value.push($253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.CONTEXT_SPECIFIC, altName.type, false, value));
        }
    } else if (e.name === "nsComment" && options.cert) {
        // sanity check value is ASCII (req'd) and not too big
        if (!/^[\x00-\x7F]*$/.test(e.comment) || e.comment.length < 1 || e.comment.length > 128) throw new Error('Invalid "nsComment" content.');
        // IA5STRING opaque comment
        e.value = $253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, $253610e522d269d8$var$asn1.Type.IA5STRING, false, e.comment);
    } else if (e.name === "subjectKeyIdentifier" && options.cert) {
        var ski = options.cert.generateSubjectKeyIdentifier();
        e.subjectKeyIdentifier = ski.toHex();
        // OCTETSTRING w/digest
        e.value = $253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, $253610e522d269d8$var$asn1.Type.OCTETSTRING, false, ski.getBytes());
    } else if (e.name === "authorityKeyIdentifier" && options.cert) {
        // SYNTAX SEQUENCE
        e.value = $253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, $253610e522d269d8$var$asn1.Type.SEQUENCE, true, []);
        var seq = e.value.value;
        if (e.keyIdentifier) {
            var keyIdentifier = e.keyIdentifier === true ? options.cert.generateSubjectKeyIdentifier().getBytes() : e.keyIdentifier;
            seq.push($253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.CONTEXT_SPECIFIC, 0, false, keyIdentifier));
        }
        if (e.authorityCertIssuer) {
            var authorityCertIssuer = [
                $253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.CONTEXT_SPECIFIC, 4, true, [
                    $253610e522d269d8$var$_dnToAsn1(e.authorityCertIssuer === true ? options.cert.issuer : e.authorityCertIssuer)
                ])
            ];
            seq.push($253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.CONTEXT_SPECIFIC, 1, true, authorityCertIssuer));
        }
        if (e.serialNumber) {
            var serialNumber = $fz7FM.util.hexToBytes(e.serialNumber === true ? options.cert.serialNumber : e.serialNumber);
            seq.push($253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.CONTEXT_SPECIFIC, 2, false, serialNumber));
        }
    } else if (e.name === "cRLDistributionPoints") {
        e.value = $253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, $253610e522d269d8$var$asn1.Type.SEQUENCE, true, []);
        var seq = e.value.value;
        // Create sub SEQUENCE of DistributionPointName
        var subSeq = $253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, $253610e522d269d8$var$asn1.Type.SEQUENCE, true, []);
        // Create fullName CHOICE
        var fullNameGeneralNames = $253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, []);
        var altName;
        for(var n = 0; n < e.altNames.length; ++n){
            altName = e.altNames[n];
            var value = altName.value;
            // handle IP
            if (altName.type === 7 && altName.ip) {
                value = $fz7FM.util.bytesFromIP(altName.ip);
                if (value === null) {
                    var error = new Error('Extension "ip" value is not a valid IPv4 or IPv6 address.');
                    error.extension = e;
                    throw error;
                }
            } else if (altName.type === 8) {
                // handle OID
                if (altName.oid) value = $253610e522d269d8$var$asn1.oidToDer($253610e522d269d8$var$asn1.oidToDer(altName.oid));
                else // deprecated ... convert value to OID
                value = $253610e522d269d8$var$asn1.oidToDer(value);
            }
            fullNameGeneralNames.value.push($253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.CONTEXT_SPECIFIC, altName.type, false, value));
        }
        // Add to the parent SEQUENCE
        subSeq.value.push($253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, [
            fullNameGeneralNames
        ]));
        seq.push(subSeq);
    }
    // ensure value has been defined by now
    if (typeof e.value === "undefined") {
        var error = new Error("Extension value not specified.");
        error.extension = e;
        throw error;
    }
    return e;
}
/**
 * Convert signature parameters object to ASN.1
 *
 * @param {String} oid Signature algorithm OID
 * @param params The signature parametrs object
 * @return ASN.1 object representing signature parameters
 */ function $253610e522d269d8$var$_signatureParametersToAsn1(oid, params) {
    switch(oid){
        case $253610e522d269d8$var$oids["RSASSA-PSS"]:
            var parts = [];
            if (params.hash.algorithmOid !== undefined) parts.push($253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, [
                $253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, $253610e522d269d8$var$asn1.Type.SEQUENCE, true, [
                    $253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, $253610e522d269d8$var$asn1.Type.OID, false, $253610e522d269d8$var$asn1.oidToDer(params.hash.algorithmOid).getBytes()),
                    $253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, $253610e522d269d8$var$asn1.Type.NULL, false, "")
                ])
            ]));
            if (params.mgf.algorithmOid !== undefined) parts.push($253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.CONTEXT_SPECIFIC, 1, true, [
                $253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, $253610e522d269d8$var$asn1.Type.SEQUENCE, true, [
                    $253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, $253610e522d269d8$var$asn1.Type.OID, false, $253610e522d269d8$var$asn1.oidToDer(params.mgf.algorithmOid).getBytes()),
                    $253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, $253610e522d269d8$var$asn1.Type.SEQUENCE, true, [
                        $253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, $253610e522d269d8$var$asn1.Type.OID, false, $253610e522d269d8$var$asn1.oidToDer(params.mgf.hash.algorithmOid).getBytes()),
                        $253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, $253610e522d269d8$var$asn1.Type.NULL, false, "")
                    ])
                ])
            ]));
            if (params.saltLength !== undefined) parts.push($253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.CONTEXT_SPECIFIC, 2, true, [
                $253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, $253610e522d269d8$var$asn1.Type.INTEGER, false, $253610e522d269d8$var$asn1.integerToDer(params.saltLength).getBytes())
            ]));
            return $253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, $253610e522d269d8$var$asn1.Type.SEQUENCE, true, parts);
        default:
            return $253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, $253610e522d269d8$var$asn1.Type.NULL, false, "");
    }
}
/**
 * Converts a certification request's attributes to an ASN.1 set of
 * CRIAttributes.
 *
 * @param csr certification request.
 *
 * @return the ASN.1 set of CRIAttributes.
 */ function $253610e522d269d8$var$_CRIAttributesToAsn1(csr) {
    // create an empty context-specific container
    var rval = $253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, []);
    // no attributes, return empty container
    if (csr.attributes.length === 0) return rval;
    // each attribute has a sequence with a type and a set of values
    var attrs = csr.attributes;
    for(var i = 0; i < attrs.length; ++i){
        var attr = attrs[i];
        var value = attr.value;
        // reuse tag class for attribute value if available
        var valueTagClass = $253610e522d269d8$var$asn1.Type.UTF8;
        if ("valueTagClass" in attr) valueTagClass = attr.valueTagClass;
        if (valueTagClass === $253610e522d269d8$var$asn1.Type.UTF8) value = $fz7FM.util.encodeUtf8(value);
        var valueConstructed = false;
        if ("valueConstructed" in attr) valueConstructed = attr.valueConstructed;
        // FIXME: handle more encodings
        // create a RelativeDistinguishedName set
        // each value in the set is an AttributeTypeAndValue first
        // containing the type (an OID) and second the value
        var seq = $253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, $253610e522d269d8$var$asn1.Type.SEQUENCE, true, [
            // AttributeType
            $253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, $253610e522d269d8$var$asn1.Type.OID, false, $253610e522d269d8$var$asn1.oidToDer(attr.type).getBytes()),
            $253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, $253610e522d269d8$var$asn1.Type.SET, true, [
                // AttributeValue
                $253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, valueTagClass, valueConstructed, value)
            ])
        ]);
        rval.value.push(seq);
    }
    return rval;
}
var $253610e522d269d8$var$jan_1_1950 = new Date("1950-01-01T00:00:00Z");
var $253610e522d269d8$var$jan_1_2050 = new Date("2050-01-01T00:00:00Z");
/**
 * Converts a Date object to ASN.1
 * Handles the different format before and after 1st January 2050
 *
 * @param date date object.
 *
 * @return the ASN.1 object representing the date.
 */ function $253610e522d269d8$var$_dateToAsn1(date) {
    if (date >= $253610e522d269d8$var$jan_1_1950 && date < $253610e522d269d8$var$jan_1_2050) return $253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, $253610e522d269d8$var$asn1.Type.UTCTIME, false, $253610e522d269d8$var$asn1.dateToUtcTime(date));
    else return $253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, $253610e522d269d8$var$asn1.Type.GENERALIZEDTIME, false, $253610e522d269d8$var$asn1.dateToGeneralizedTime(date));
}
/**
 * Gets the ASN.1 TBSCertificate part of an X.509v3 certificate.
 *
 * @param cert the certificate.
 *
 * @return the asn1 TBSCertificate.
 */ $253610e522d269d8$var$pki.getTBSCertificate = function(cert) {
    // TBSCertificate
    var notBefore = $253610e522d269d8$var$_dateToAsn1(cert.validity.notBefore);
    var notAfter = $253610e522d269d8$var$_dateToAsn1(cert.validity.notAfter);
    var tbs = $253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, $253610e522d269d8$var$asn1.Type.SEQUENCE, true, [
        // version
        $253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, [
            // integer
            $253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, $253610e522d269d8$var$asn1.Type.INTEGER, false, $253610e522d269d8$var$asn1.integerToDer(cert.version).getBytes())
        ]),
        // serialNumber
        $253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, $253610e522d269d8$var$asn1.Type.INTEGER, false, $fz7FM.util.hexToBytes(cert.serialNumber)),
        // signature
        $253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, $253610e522d269d8$var$asn1.Type.SEQUENCE, true, [
            // algorithm
            $253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, $253610e522d269d8$var$asn1.Type.OID, false, $253610e522d269d8$var$asn1.oidToDer(cert.siginfo.algorithmOid).getBytes()),
            // parameters
            $253610e522d269d8$var$_signatureParametersToAsn1(cert.siginfo.algorithmOid, cert.siginfo.parameters)
        ]),
        // issuer
        $253610e522d269d8$var$_dnToAsn1(cert.issuer),
        // validity
        $253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, $253610e522d269d8$var$asn1.Type.SEQUENCE, true, [
            notBefore,
            notAfter
        ]),
        // subject
        $253610e522d269d8$var$_dnToAsn1(cert.subject),
        // SubjectPublicKeyInfo
        $253610e522d269d8$var$pki.publicKeyToAsn1(cert.publicKey)
    ]);
    if (cert.issuer.uniqueId) // issuerUniqueID (optional)
    tbs.value.push($253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.CONTEXT_SPECIFIC, 1, true, [
        $253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, $253610e522d269d8$var$asn1.Type.BITSTRING, false, // TODO: support arbitrary bit length ids
        String.fromCharCode(0x00) + cert.issuer.uniqueId)
    ]));
    if (cert.subject.uniqueId) // subjectUniqueID (optional)
    tbs.value.push($253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.CONTEXT_SPECIFIC, 2, true, [
        $253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, $253610e522d269d8$var$asn1.Type.BITSTRING, false, // TODO: support arbitrary bit length ids
        String.fromCharCode(0x00) + cert.subject.uniqueId)
    ]));
    if (cert.extensions.length > 0) // extensions (optional)
    tbs.value.push($253610e522d269d8$var$pki.certificateExtensionsToAsn1(cert.extensions));
    return tbs;
};
/**
 * Gets the ASN.1 CertificationRequestInfo part of a
 * PKCS#10 CertificationRequest.
 *
 * @param csr the certification request.
 *
 * @return the asn1 CertificationRequestInfo.
 */ $253610e522d269d8$var$pki.getCertificationRequestInfo = function(csr) {
    // CertificationRequestInfo
    var cri = $253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, $253610e522d269d8$var$asn1.Type.SEQUENCE, true, [
        // version
        $253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, $253610e522d269d8$var$asn1.Type.INTEGER, false, $253610e522d269d8$var$asn1.integerToDer(csr.version).getBytes()),
        // subject
        $253610e522d269d8$var$_dnToAsn1(csr.subject),
        // SubjectPublicKeyInfo
        $253610e522d269d8$var$pki.publicKeyToAsn1(csr.publicKey),
        // attributes
        $253610e522d269d8$var$_CRIAttributesToAsn1(csr)
    ]);
    return cri;
};
/**
 * Converts a DistinguishedName (subject or issuer) to an ASN.1 object.
 *
 * @param dn the DistinguishedName.
 *
 * @return the asn1 representation of a DistinguishedName.
 */ $253610e522d269d8$var$pki.distinguishedNameToAsn1 = function(dn) {
    return $253610e522d269d8$var$_dnToAsn1(dn);
};
/**
 * Converts an X.509v3 RSA certificate to an ASN.1 object.
 *
 * @param cert the certificate.
 *
 * @return the asn1 representation of an X.509v3 RSA certificate.
 */ $253610e522d269d8$var$pki.certificateToAsn1 = function(cert) {
    // prefer cached TBSCertificate over generating one
    var tbsCertificate = cert.tbsCertificate || $253610e522d269d8$var$pki.getTBSCertificate(cert);
    // Certificate
    return $253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, $253610e522d269d8$var$asn1.Type.SEQUENCE, true, [
        // TBSCertificate
        tbsCertificate,
        // AlgorithmIdentifier (signature algorithm)
        $253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, $253610e522d269d8$var$asn1.Type.SEQUENCE, true, [
            // algorithm
            $253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, $253610e522d269d8$var$asn1.Type.OID, false, $253610e522d269d8$var$asn1.oidToDer(cert.signatureOid).getBytes()),
            // parameters
            $253610e522d269d8$var$_signatureParametersToAsn1(cert.signatureOid, cert.signatureParameters)
        ]),
        // SignatureValue
        $253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, $253610e522d269d8$var$asn1.Type.BITSTRING, false, String.fromCharCode(0x00) + cert.signature)
    ]);
};
/**
 * Converts X.509v3 certificate extensions to ASN.1.
 *
 * @param exts the extensions to convert.
 *
 * @return the extensions in ASN.1 format.
 */ $253610e522d269d8$var$pki.certificateExtensionsToAsn1 = function(exts) {
    // create top-level extension container
    var rval = $253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.CONTEXT_SPECIFIC, 3, true, []);
    // create extension sequence (stores a sequence for each extension)
    var seq = $253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, $253610e522d269d8$var$asn1.Type.SEQUENCE, true, []);
    rval.value.push(seq);
    for(var i = 0; i < exts.length; ++i)seq.value.push($253610e522d269d8$var$pki.certificateExtensionToAsn1(exts[i]));
    return rval;
};
/**
 * Converts a single certificate extension to ASN.1.
 *
 * @param ext the extension to convert.
 *
 * @return the extension in ASN.1 format.
 */ $253610e522d269d8$var$pki.certificateExtensionToAsn1 = function(ext) {
    // create a sequence for each extension
    var extseq = $253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, $253610e522d269d8$var$asn1.Type.SEQUENCE, true, []);
    // extnID (OID)
    extseq.value.push($253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, $253610e522d269d8$var$asn1.Type.OID, false, $253610e522d269d8$var$asn1.oidToDer(ext.id).getBytes()));
    // critical defaults to false
    if (ext.critical) // critical BOOLEAN DEFAULT FALSE
    extseq.value.push($253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, $253610e522d269d8$var$asn1.Type.BOOLEAN, false, String.fromCharCode(0xFF)));
    var value = ext.value;
    if (typeof ext.value !== "string") // value is asn.1
    value = $253610e522d269d8$var$asn1.toDer(value).getBytes();
    // extnValue (OCTET STRING)
    extseq.value.push($253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, $253610e522d269d8$var$asn1.Type.OCTETSTRING, false, value));
    return extseq;
};
/**
 * Converts a PKCS#10 certification request to an ASN.1 object.
 *
 * @param csr the certification request.
 *
 * @return the asn1 representation of a certification request.
 */ $253610e522d269d8$var$pki.certificationRequestToAsn1 = function(csr) {
    // prefer cached CertificationRequestInfo over generating one
    var cri = csr.certificationRequestInfo || $253610e522d269d8$var$pki.getCertificationRequestInfo(csr);
    // Certificate
    return $253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, $253610e522d269d8$var$asn1.Type.SEQUENCE, true, [
        // CertificationRequestInfo
        cri,
        // AlgorithmIdentifier (signature algorithm)
        $253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, $253610e522d269d8$var$asn1.Type.SEQUENCE, true, [
            // algorithm
            $253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, $253610e522d269d8$var$asn1.Type.OID, false, $253610e522d269d8$var$asn1.oidToDer(csr.signatureOid).getBytes()),
            // parameters
            $253610e522d269d8$var$_signatureParametersToAsn1(csr.signatureOid, csr.signatureParameters)
        ]),
        // signature
        $253610e522d269d8$var$asn1.create($253610e522d269d8$var$asn1.Class.UNIVERSAL, $253610e522d269d8$var$asn1.Type.BITSTRING, false, String.fromCharCode(0x00) + csr.signature)
    ]);
};
/**
 * Creates a CA store.
 *
 * @param certs an optional array of certificate objects or PEM-formatted
 *          certificate strings to add to the CA store.
 *
 * @return the CA store.
 */ $253610e522d269d8$var$pki.createCaStore = function(certs) {
    // create CA store
    var caStore = {
        // stored certificates
        certs: {}
    };
    /**
   * Gets the certificate that issued the passed certificate or its
   * 'parent'.
   *
   * @param cert the certificate to get the parent for.
   *
   * @return the parent certificate or null if none was found.
   */ caStore.getIssuer = function(cert) {
        var rval = getBySubject(cert.issuer);
        // see if there are multiple matches
        /*if(forge.util.isArray(rval)) {
      // TODO: resolve multiple matches by checking
      // authorityKey/subjectKey/issuerUniqueID/other identifiers, etc.
      // FIXME: or alternatively do authority key mapping
      // if possible (X.509v1 certs can't work?)
      throw new Error('Resolving multiple issuer matches not implemented yet.');
    }*/ return rval;
    };
    /**
   * Adds a trusted certificate to the store.
   *
   * @param cert the certificate to add as a trusted certificate (either a
   *          pki.certificate object or a PEM-formatted certificate).
   */ caStore.addCertificate = function(cert) {
        // convert from pem if necessary
        if (typeof cert === "string") cert = $fz7FM.pki.certificateFromPem(cert);
        ensureSubjectHasHash(cert.subject);
        if (!caStore.hasCertificate(cert)) {
            if (cert.subject.hash in caStore.certs) {
                // subject hash already exists, append to array
                var tmp = caStore.certs[cert.subject.hash];
                if (!$fz7FM.util.isArray(tmp)) tmp = [
                    tmp
                ];
                tmp.push(cert);
                caStore.certs[cert.subject.hash] = tmp;
            } else caStore.certs[cert.subject.hash] = cert;
        }
    };
    /**
   * Checks to see if the given certificate is in the store.
   *
   * @param cert the certificate to check (either a pki.certificate or a
   *          PEM-formatted certificate).
   *
   * @return true if the certificate is in the store, false if not.
   */ caStore.hasCertificate = function(cert) {
        // convert from pem if necessary
        if (typeof cert === "string") cert = $fz7FM.pki.certificateFromPem(cert);
        var match = getBySubject(cert.subject);
        if (!match) return false;
        if (!$fz7FM.util.isArray(match)) match = [
            match
        ];
        // compare DER-encoding of certificates
        var der1 = $253610e522d269d8$var$asn1.toDer($253610e522d269d8$var$pki.certificateToAsn1(cert)).getBytes();
        for(var i = 0; i < match.length; ++i){
            var der2 = $253610e522d269d8$var$asn1.toDer($253610e522d269d8$var$pki.certificateToAsn1(match[i])).getBytes();
            if (der1 === der2) return true;
        }
        return false;
    };
    /**
   * Lists all of the certificates kept in the store.
   *
   * @return an array of all of the pki.certificate objects in the store.
   */ caStore.listAllCertificates = function() {
        var certList = [];
        for(var hash in caStore.certs)if (caStore.certs.hasOwnProperty(hash)) {
            var value = caStore.certs[hash];
            if (!$fz7FM.util.isArray(value)) certList.push(value);
            else for(var i = 0; i < value.length; ++i)certList.push(value[i]);
        }
        return certList;
    };
    /**
   * Removes a certificate from the store.
   *
   * @param cert the certificate to remove (either a pki.certificate or a
   *          PEM-formatted certificate).
   *
   * @return the certificate that was removed or null if the certificate
   *           wasn't in store.
   */ caStore.removeCertificate = function(cert) {
        var result;
        // convert from pem if necessary
        if (typeof cert === "string") cert = $fz7FM.pki.certificateFromPem(cert);
        ensureSubjectHasHash(cert.subject);
        if (!caStore.hasCertificate(cert)) return null;
        var match = getBySubject(cert.subject);
        if (!$fz7FM.util.isArray(match)) {
            result = caStore.certs[cert.subject.hash];
            delete caStore.certs[cert.subject.hash];
            return result;
        }
        // compare DER-encoding of certificates
        var der1 = $253610e522d269d8$var$asn1.toDer($253610e522d269d8$var$pki.certificateToAsn1(cert)).getBytes();
        for(var i = 0; i < match.length; ++i){
            var der2 = $253610e522d269d8$var$asn1.toDer($253610e522d269d8$var$pki.certificateToAsn1(match[i])).getBytes();
            if (der1 === der2) {
                result = match[i];
                match.splice(i, 1);
            }
        }
        if (match.length === 0) delete caStore.certs[cert.subject.hash];
        return result;
    };
    function getBySubject(subject) {
        ensureSubjectHasHash(subject);
        return caStore.certs[subject.hash] || null;
    }
    function ensureSubjectHasHash(subject) {
        // produce subject hash if it doesn't exist
        if (!subject.hash) {
            var md = $fz7FM.md.sha1.create();
            subject.attributes = $253610e522d269d8$var$pki.RDNAttributesAsArray($253610e522d269d8$var$_dnToAsn1(subject), md);
            subject.hash = md.digest().toHex();
        }
    }
    // auto-add passed in certs
    if (certs) // parse PEM-formatted certificates as necessary
    for(var i = 0; i < certs.length; ++i){
        var cert = certs[i];
        caStore.addCertificate(cert);
    }
    return caStore;
};
/**
 * Certificate verification errors, based on TLS.
 */ $253610e522d269d8$var$pki.certificateError = {
    bad_certificate: "forge.pki.BadCertificate",
    unsupported_certificate: "forge.pki.UnsupportedCertificate",
    certificate_revoked: "forge.pki.CertificateRevoked",
    certificate_expired: "forge.pki.CertificateExpired",
    certificate_unknown: "forge.pki.CertificateUnknown",
    unknown_ca: "forge.pki.UnknownCertificateAuthority"
};
/**
 * Verifies a certificate chain against the given Certificate Authority store
 * with an optional custom verify callback.
 *
 * @param caStore a certificate store to verify against.
 * @param chain the certificate chain to verify, with the root or highest
 *          authority at the end (an array of certificates).
 * @param options a callback to be called for every certificate in the chain or
 *                  an object with:
 *                  verify a callback to be called for every certificate in the
 *                    chain
 *                  validityCheckDate the date against which the certificate
 *                    validity period should be checked. Pass null to not check
 *                    the validity period. By default, the current date is used.
 *
 * The verify callback has the following signature:
 *
 * verified - Set to true if certificate was verified, otherwise the
 *   pki.certificateError for why the certificate failed.
 * depth - The current index in the chain, where 0 is the end point's cert.
 * certs - The certificate chain, *NOTE* an empty chain indicates an anonymous
 *   end point.
 *
 * The function returns true on success and on failure either the appropriate
 * pki.certificateError or an object with 'error' set to the appropriate
 * pki.certificateError and 'message' set to a custom error message.
 *
 * @return true if successful, error thrown if not.
 */ $253610e522d269d8$var$pki.verifyCertificateChain = function(caStore, chain, options) {
    /* From: RFC3280 - Internet X.509 Public Key Infrastructure Certificate
    Section 6: Certification Path Validation
    See inline parentheticals related to this particular implementation.

    The primary goal of path validation is to verify the binding between
    a subject distinguished name or a subject alternative name and subject
    public key, as represented in the end entity certificate, based on the
    public key of the trust anchor. This requires obtaining a sequence of
    certificates that support that binding. That sequence should be provided
    in the passed 'chain'. The trust anchor should be in the given CA
    store. The 'end entity' certificate is the certificate provided by the
    end point (typically a server) and is the first in the chain.

    To meet this goal, the path validation process verifies, among other
    things, that a prospective certification path (a sequence of n
    certificates or a 'chain') satisfies the following conditions:

    (a) for all x in {1, ..., n-1}, the subject of certificate x is
          the issuer of certificate x+1;

    (b) certificate 1 is issued by the trust anchor;

    (c) certificate n is the certificate to be validated; and

    (d) for all x in {1, ..., n}, the certificate was valid at the
          time in question.

    Note that here 'n' is index 0 in the chain and 1 is the last certificate
    in the chain and it must be signed by a certificate in the connection's
    CA store.

    The path validation process also determines the set of certificate
    policies that are valid for this path, based on the certificate policies
    extension, policy mapping extension, policy constraints extension, and
    inhibit any-policy extension.

    Note: Policy mapping extension not supported (Not Required).

    Note: If the certificate has an unsupported critical extension, then it
    must be rejected.

    Note: A certificate is self-issued if the DNs that appear in the subject
    and issuer fields are identical and are not empty.

    The path validation algorithm assumes the following seven inputs are
    provided to the path processing logic. What this specific implementation
    will use is provided parenthetically:

    (a) a prospective certification path of length n (the 'chain')
    (b) the current date/time: ('now').
    (c) user-initial-policy-set: A set of certificate policy identifiers
          naming the policies that are acceptable to the certificate user.
          The user-initial-policy-set contains the special value any-policy
          if the user is not concerned about certificate policy
          (Not implemented. Any policy is accepted).
    (d) trust anchor information, describing a CA that serves as a trust
          anchor for the certification path. The trust anchor information
          includes:

      (1)  the trusted issuer name,
      (2)  the trusted public key algorithm,
      (3)  the trusted public key, and
      (4)  optionally, the trusted public key parameters associated
             with the public key.

      (Trust anchors are provided via certificates in the CA store).

      The trust anchor information may be provided to the path processing
      procedure in the form of a self-signed certificate. The trusted anchor
      information is trusted because it was delivered to the path processing
      procedure by some trustworthy out-of-band procedure. If the trusted
      public key algorithm requires parameters, then the parameters are
      provided along with the trusted public key (No parameters used in this
      implementation).

    (e) initial-policy-mapping-inhibit, which indicates if policy mapping is
          allowed in the certification path.
          (Not implemented, no policy checking)

    (f) initial-explicit-policy, which indicates if the path must be valid
          for at least one of the certificate policies in the user-initial-
          policy-set.
          (Not implemented, no policy checking)

    (g) initial-any-policy-inhibit, which indicates whether the
          anyPolicy OID should be processed if it is included in a
          certificate.
          (Not implemented, so any policy is valid provided that it is
          not marked as critical) */ /* Basic Path Processing:

    For each certificate in the 'chain', the following is checked:

    1. The certificate validity period includes the current time.
    2. The certificate was signed by its parent (where the parent is either
       the next in the chain or from the CA store). Allow processing to
       continue to the next step if no parent is found but the certificate is
       in the CA store.
    3. TODO: The certificate has not been revoked.
    4. The certificate issuer name matches the parent's subject name.
    5. TODO: If the certificate is self-issued and not the final certificate
       in the chain, skip this step, otherwise verify that the subject name
       is within one of the permitted subtrees of X.500 distinguished names
       and that each of the alternative names in the subjectAltName extension
       (critical or non-critical) is within one of the permitted subtrees for
       that name type.
    6. TODO: If the certificate is self-issued and not the final certificate
       in the chain, skip this step, otherwise verify that the subject name
       is not within one of the excluded subtrees for X.500 distinguished
       names and none of the subjectAltName extension names are excluded for
       that name type.
    7. The other steps in the algorithm for basic path processing involve
       handling the policy extension which is not presently supported in this
       implementation. Instead, if a critical policy extension is found, the
       certificate is rejected as not supported.
    8. If the certificate is not the first or if its the only certificate in
       the chain (having no parent from the CA store or is self-signed) and it
       has a critical key usage extension, verify that the keyCertSign bit is
       set. If the key usage extension exists, verify that the basic
       constraints extension exists. If the basic constraints extension exists,
       verify that the cA flag is set. If pathLenConstraint is set, ensure that
       the number of certificates that precede in the chain (come earlier
       in the chain as implemented below), excluding the very first in the
       chain (typically the end-entity one), isn't greater than the
       pathLenConstraint. This constraint limits the number of intermediate
       CAs that may appear below a CA before only end-entity certificates
       may be issued. */ // if a verify callback is passed as the third parameter, package it within
    // the options object. This is to support a legacy function signature that
    // expected the verify callback as the third parameter.
    if (typeof options === "function") options = {
        verify: options
    };
    options = options || {};
    // copy cert chain references to another array to protect against changes
    // in verify callback
    chain = chain.slice(0);
    var certs = chain.slice(0);
    var validityCheckDate = options.validityCheckDate;
    // if no validityCheckDate is specified, default to the current date. Make
    // sure to maintain the value null because it indicates that the validity
    // period should not be checked.
    if (typeof validityCheckDate === "undefined") validityCheckDate = new Date();
    // verify each cert in the chain using its parent, where the parent
    // is either the next in the chain or from the CA store
    var first = true;
    var error = null;
    var depth = 0;
    do {
        var cert = chain.shift();
        var parent = null;
        var selfSigned = false;
        if (validityCheckDate) // 1. check valid time
        {
            if (validityCheckDate < cert.validity.notBefore || validityCheckDate > cert.validity.notAfter) error = {
                message: "Certificate is not valid yet or has expired.",
                error: $253610e522d269d8$var$pki.certificateError.certificate_expired,
                notBefore: cert.validity.notBefore,
                notAfter: cert.validity.notAfter,
                // TODO: we might want to reconsider renaming 'now' to
                // 'validityCheckDate' should this API be changed in the future.
                now: validityCheckDate
            };
        }
        // 2. verify with parent from chain or CA store
        if (error === null) {
            parent = chain[0] || caStore.getIssuer(cert);
            if (parent === null) // check for self-signed cert
            {
                if (cert.isIssuer(cert)) {
                    selfSigned = true;
                    parent = cert;
                }
            }
            if (parent) {
                // FIXME: current CA store implementation might have multiple
                // certificates where the issuer can't be determined from the
                // certificate (happens rarely with, eg: old certificates) so normalize
                // by always putting parents into an array
                // TODO: there's may be an extreme degenerate case currently uncovered
                // where an old intermediate certificate seems to have a matching parent
                // but none of the parents actually verify ... but the intermediate
                // is in the CA and it should pass this check; needs investigation
                var parents = parent;
                if (!$fz7FM.util.isArray(parents)) parents = [
                    parents
                ];
                // try to verify with each possible parent (typically only one)
                var verified = false;
                while(!verified && parents.length > 0){
                    parent = parents.shift();
                    try {
                        verified = parent.verify(cert);
                    } catch (ex) {
                    // failure to verify, don't care why, try next one
                    }
                }
                if (!verified) error = {
                    message: "Certificate signature is invalid.",
                    error: $253610e522d269d8$var$pki.certificateError.bad_certificate
                };
            }
            if (error === null && (!parent || selfSigned) && !caStore.hasCertificate(cert)) // no parent issuer and certificate itself is not trusted
            error = {
                message: "Certificate is not trusted.",
                error: $253610e522d269d8$var$pki.certificateError.unknown_ca
            };
        }
        // TODO: 3. check revoked
        // 4. check for matching issuer/subject
        if (error === null && parent && !cert.isIssuer(parent)) // parent is not issuer
        error = {
            message: "Certificate issuer is invalid.",
            error: $253610e522d269d8$var$pki.certificateError.bad_certificate
        };
        // 5. TODO: check names with permitted names tree
        // 6. TODO: check names against excluded names tree
        // 7. check for unsupported critical extensions
        if (error === null) {
            // supported extensions
            var se = {
                keyUsage: true,
                basicConstraints: true
            };
            for(var i = 0; error === null && i < cert.extensions.length; ++i){
                var ext = cert.extensions[i];
                if (ext.critical && !(ext.name in se)) error = {
                    message: "Certificate has an unsupported critical extension.",
                    error: $253610e522d269d8$var$pki.certificateError.unsupported_certificate
                };
            }
        }
        // 8. check for CA if cert is not first or is the only certificate
        // remaining in chain with no parent or is self-signed
        if (error === null && (!first || chain.length === 0 && (!parent || selfSigned))) {
            // first check keyUsage extension and then basic constraints
            var bcExt = cert.getExtension("basicConstraints");
            var keyUsageExt = cert.getExtension("keyUsage");
            if (keyUsageExt !== null) // keyCertSign must be true and there must be a basic
            // constraints extension
            {
                if (!keyUsageExt.keyCertSign || bcExt === null) // bad certificate
                error = {
                    message: "Certificate keyUsage or basicConstraints conflict or indicate that the certificate is not a CA. If the certificate is the only one in the chain or isn't the first then the certificate must be a valid CA.",
                    error: $253610e522d269d8$var$pki.certificateError.bad_certificate
                };
            }
            // basic constraints cA flag must be set
            if (error === null && bcExt !== null && !bcExt.cA) // bad certificate
            error = {
                message: "Certificate basicConstraints indicates the certificate is not a CA.",
                error: $253610e522d269d8$var$pki.certificateError.bad_certificate
            };
            // if error is not null and keyUsage is available, then we know it
            // has keyCertSign and there is a basic constraints extension too,
            // which means we can check pathLenConstraint (if it exists)
            if (error === null && keyUsageExt !== null && "pathLenConstraint" in bcExt) {
                // pathLen is the maximum # of intermediate CA certs that can be
                // found between the current certificate and the end-entity (depth 0)
                // certificate; this number does not include the end-entity (depth 0,
                // last in the chain) even if it happens to be a CA certificate itself
                var pathLen = depth - 1;
                if (pathLen > bcExt.pathLenConstraint) // pathLenConstraint violated, bad certificate
                error = {
                    message: "Certificate basicConstraints pathLenConstraint violated.",
                    error: $253610e522d269d8$var$pki.certificateError.bad_certificate
                };
            }
        }
        // call application callback
        var vfd = error === null ? true : error.error;
        var ret = options.verify ? options.verify(vfd, depth, certs) : vfd;
        if (ret === true) // clear any set error
        error = null;
        else {
            // if passed basic tests, set default message and alert
            if (vfd === true) error = {
                message: "The application rejected the certificate.",
                error: $253610e522d269d8$var$pki.certificateError.bad_certificate
            };
            // check for custom error info
            if (ret || ret === 0) {
                // set custom message and error
                if (typeof ret === "object" && !$fz7FM.util.isArray(ret)) {
                    if (ret.message) error.message = ret.message;
                    if (ret.error) error.error = ret.error;
                } else if (typeof ret === "string") // set custom error
                error.error = ret;
            }
            // throw error
            throw error;
        }
        // no longer first cert in chain
        first = false;
        ++depth;
    }while (chain.length > 0);
    return true;
};

});
parcelRegister("clzK4", function(module, exports) {
/**
 * Node.js module for Forge mask generation functions.
 *
 * @author Stefan Siegl
 *
 * Copyright 2012 Stefan Siegl <stesie@brokenpipe.de>
 */ 
var $fz7FM = parcelRequire("fz7FM");
parcelRequire("lQ4Ml");
module.exports = $fz7FM.mgf = $fz7FM.mgf || {};
$fz7FM.mgf.mgf1 = $fz7FM.mgf1;

});
parcelRegister("lQ4Ml", function(module, exports) {
/**
 * Javascript implementation of mask generation function MGF1.
 *
 * @author Stefan Siegl
 * @author Dave Longley
 *
 * Copyright (c) 2012 Stefan Siegl <stesie@brokenpipe.de>
 * Copyright (c) 2014 Digital Bazaar, Inc.
 */ 
var $fz7FM = parcelRequire("fz7FM");
parcelRequire("gao36");
$fz7FM.mgf = $fz7FM.mgf || {};
var $fe622943204c7246$var$mgf1 = module.exports = $fz7FM.mgf.mgf1 = $fz7FM.mgf1 = $fz7FM.mgf1 || {};
/**
 * Creates a MGF1 mask generation function object.
 *
 * @param md the message digest API to use (eg: forge.md.sha1.create()).
 *
 * @return a mask generation function object.
 */ $fe622943204c7246$var$mgf1.create = function(md) {
    var mgf = {
        /**
     * Generate mask of specified length.
     *
     * @param {String} seed The seed for mask generation.
     * @param maskLen Number of bytes to generate.
     * @return {String} The generated mask.
     */ generate: function generate(seed, maskLen) {
            /* 2. Let T be the empty octet string. */ var t = new $fz7FM.util.ByteBuffer();
            /* 3. For counter from 0 to ceil(maskLen / hLen), do the following: */ var len = Math.ceil(maskLen / md.digestLength);
            for(var i = 0; i < len; i++){
                /* a. Convert counter to an octet string C of length 4 octets */ var c = new $fz7FM.util.ByteBuffer();
                c.putInt32(i);
                /* b. Concatenate the hash of the seed mgfSeed and C to the octet
         * string T: */ md.start();
                md.update(seed + c.getBytes());
                t.putBuffer(md.digest());
            }
            /* Output the leading maskLen octets of T as the octet string mask. */ t.truncate(t.length() - maskLen);
            return t.getBytes();
        }
    };
    return mgf;
};

});


parcelRegister("1VUmF", function(module, exports) {
/**
 * Javascript implementation of PKCS#1 PSS signature padding.
 *
 * @author Stefan Siegl
 *
 * Copyright (c) 2012 Stefan Siegl <stesie@brokenpipe.de>
 */ 
var $fz7FM = parcelRequire("fz7FM");
parcelRequire("a65r1");
parcelRequire("gao36");
// shortcut for PSS API
var $1686d62adcecc29c$var$pss = module.exports = $fz7FM.pss = $fz7FM.pss || {};
/**
 * Creates a PSS signature scheme object.
 *
 * There are several ways to provide a salt for encoding:
 *
 * 1. Specify the saltLength only and the built-in PRNG will generate it.
 * 2. Specify the saltLength and a custom PRNG with 'getBytesSync' defined that
 *   will be used.
 * 3. Specify the salt itself as a forge.util.ByteBuffer.
 *
 * @param options the options to use:
 *          md the message digest object to use, a forge md instance.
 *          mgf the mask generation function to use, a forge mgf instance.
 *          [saltLength] the length of the salt in octets.
 *          [prng] the pseudo-random number generator to use to produce a salt.
 *          [salt] the salt to use when encoding.
 *
 * @return a signature scheme object.
 */ $1686d62adcecc29c$var$pss.create = function(options) {
    // backwards compatibility w/legacy args: hash, mgf, sLen
    if (arguments.length === 3) options = {
        md: arguments[0],
        mgf: arguments[1],
        saltLength: arguments[2]
    };
    var hash = options.md;
    var mgf = options.mgf;
    var hLen = hash.digestLength;
    var salt_ = options.salt || null;
    if (typeof salt_ === "string") // assume binary-encoded string
    salt_ = $fz7FM.util.createBuffer(salt_);
    var sLen;
    if ("saltLength" in options) sLen = options.saltLength;
    else if (salt_ !== null) sLen = salt_.length();
    else throw new Error("Salt length not specified or specific salt not given.");
    if (salt_ !== null && salt_.length() !== sLen) throw new Error("Given salt length does not match length of given salt.");
    var prng = options.prng || $fz7FM.random;
    var pssobj = {};
    /**
   * Encodes a PSS signature.
   *
   * This function implements EMSA-PSS-ENCODE as per RFC 3447, section 9.1.1.
   *
   * @param md the message digest object with the hash to sign.
   * @param modsBits the length of the RSA modulus in bits.
   *
   * @return the encoded message as a binary-encoded string of length
   *           ceil((modBits - 1) / 8).
   */ pssobj.encode = function(md, modBits) {
        var i;
        var emBits = modBits - 1;
        var emLen = Math.ceil(emBits / 8);
        /* 2. Let mHash = Hash(M), an octet string of length hLen. */ var mHash = md.digest().getBytes();
        /* 3. If emLen < hLen + sLen + 2, output "encoding error" and stop. */ if (emLen < hLen + sLen + 2) throw new Error("Message is too long to encrypt.");
        /* 4. Generate a random octet string salt of length sLen; if sLen = 0,
     *    then salt is the empty string. */ var salt;
        if (salt_ === null) salt = prng.getBytesSync(sLen);
        else salt = salt_.bytes();
        /* 5. Let M' = (0x)00 00 00 00 00 00 00 00 || mHash || salt; */ var m_ = new $fz7FM.util.ByteBuffer();
        m_.fillWithByte(0, 8);
        m_.putBytes(mHash);
        m_.putBytes(salt);
        /* 6. Let H = Hash(M'), an octet string of length hLen. */ hash.start();
        hash.update(m_.getBytes());
        var h = hash.digest().getBytes();
        /* 7. Generate an octet string PS consisting of emLen - sLen - hLen - 2
     *    zero octets.  The length of PS may be 0. */ var ps = new $fz7FM.util.ByteBuffer();
        ps.fillWithByte(0, emLen - sLen - hLen - 2);
        /* 8. Let DB = PS || 0x01 || salt; DB is an octet string of length
     *    emLen - hLen - 1. */ ps.putByte(0x01);
        ps.putBytes(salt);
        var db = ps.getBytes();
        /* 9. Let dbMask = MGF(H, emLen - hLen - 1). */ var maskLen = emLen - hLen - 1;
        var dbMask = mgf.generate(h, maskLen);
        /* 10. Let maskedDB = DB \xor dbMask. */ var maskedDB = "";
        for(i = 0; i < maskLen; i++)maskedDB += String.fromCharCode(db.charCodeAt(i) ^ dbMask.charCodeAt(i));
        /* 11. Set the leftmost 8emLen - emBits bits of the leftmost octet in
     *     maskedDB to zero. */ var mask = 0xFF00 >> 8 * emLen - emBits & 0xFF;
        maskedDB = String.fromCharCode(maskedDB.charCodeAt(0) & ~mask) + maskedDB.substr(1);
        /* 12. Let EM = maskedDB || H || 0xbc.
     * 13. Output EM. */ return maskedDB + h + String.fromCharCode(0xbc);
    };
    /**
   * Verifies a PSS signature.
   *
   * This function implements EMSA-PSS-VERIFY as per RFC 3447, section 9.1.2.
   *
   * @param mHash the message digest hash, as a binary-encoded string, to
   *         compare against the signature.
   * @param em the encoded message, as a binary-encoded string
   *          (RSA decryption result).
   * @param modsBits the length of the RSA modulus in bits.
   *
   * @return true if the signature was verified, false if not.
   */ pssobj.verify = function(mHash, em, modBits) {
        var i;
        var emBits = modBits - 1;
        var emLen = Math.ceil(emBits / 8);
        /* c. Convert the message representative m to an encoded message EM
     *    of length emLen = ceil((modBits - 1) / 8) octets, where modBits
     *    is the length in bits of the RSA modulus n */ em = em.substr(-emLen);
        /* 3. If emLen < hLen + sLen + 2, output "inconsistent" and stop. */ if (emLen < hLen + sLen + 2) throw new Error("Inconsistent parameters to PSS signature verification.");
        /* 4. If the rightmost octet of EM does not have hexadecimal value
     *    0xbc, output "inconsistent" and stop. */ if (em.charCodeAt(emLen - 1) !== 0xbc) throw new Error("Encoded message does not end in 0xBC.");
        /* 5. Let maskedDB be the leftmost emLen - hLen - 1 octets of EM, and
     *    let H be the next hLen octets. */ var maskLen = emLen - hLen - 1;
        var maskedDB = em.substr(0, maskLen);
        var h = em.substr(maskLen, hLen);
        /* 6. If the leftmost 8emLen - emBits bits of the leftmost octet in
     *    maskedDB are not all equal to zero, output "inconsistent" and stop. */ var mask = 0xFF00 >> 8 * emLen - emBits & 0xFF;
        if ((maskedDB.charCodeAt(0) & mask) !== 0) throw new Error("Bits beyond keysize not zero as expected.");
        /* 7. Let dbMask = MGF(H, emLen - hLen - 1). */ var dbMask = mgf.generate(h, maskLen);
        /* 8. Let DB = maskedDB \xor dbMask. */ var db = "";
        for(i = 0; i < maskLen; i++)db += String.fromCharCode(maskedDB.charCodeAt(i) ^ dbMask.charCodeAt(i));
        /* 9. Set the leftmost 8emLen - emBits bits of the leftmost octet
     * in DB to zero. */ db = String.fromCharCode(db.charCodeAt(0) & ~mask) + db.substr(1);
        /* 10. If the emLen - hLen - sLen - 2 leftmost octets of DB are not zero
     * or if the octet at position emLen - hLen - sLen - 1 (the leftmost
     * position is "position 1") does not have hexadecimal value 0x01,
     * output "inconsistent" and stop. */ var checkLen = emLen - hLen - sLen - 2;
        for(i = 0; i < checkLen; i++){
            if (db.charCodeAt(i) !== 0x00) throw new Error("Leftmost octets not zero as expected");
        }
        if (db.charCodeAt(checkLen) !== 0x01) throw new Error("Inconsistent PSS signature, 0x01 marker not found");
        /* 11. Let salt be the last sLen octets of DB. */ var salt = db.substr(-sLen);
        /* 12.  Let M' = (0x)00 00 00 00 00 00 00 00 || mHash || salt */ var m_ = new $fz7FM.util.ByteBuffer();
        m_.fillWithByte(0, 8);
        m_.putBytes(mHash);
        m_.putBytes(salt);
        /* 13. Let H' = Hash(M'), an octet string of length hLen. */ hash.start();
        hash.update(m_.getBytes());
        var h_ = hash.digest().getBytes();
        /* 14. If H = H', output "consistent." Otherwise, output "inconsistent." */ return h === h_;
    };
    return pssobj;
};

});






parcelRegister("Z0bIW", function(module, exports) {
/**
 * JavaScript implementation of Ed25519.
 *
 * Copyright (c) 2017-2019 Digital Bazaar, Inc.
 *
 * This implementation is based on the most excellent TweetNaCl which is
 * in the public domain. Many thanks to its contributors:
 *
 * https://github.com/dchest/tweetnacl-js
 */ 
var $9dH9K = parcelRequire("9dH9K");
var $0b75d7f8c06f4d7f$require$Buffer = $9dH9K.Buffer;

var $fz7FM = parcelRequire("fz7FM");
parcelRequire("dFOUo");
parcelRequire("a65r1");
parcelRequire("k95pK");
parcelRequire("gao36");

var $jhDDh = parcelRequire("jhDDh");
var $0b75d7f8c06f4d7f$var$publicKeyValidator = $jhDDh.publicKeyValidator;
var $0b75d7f8c06f4d7f$var$privateKeyValidator = $jhDDh.privateKeyValidator;
if (typeof $0b75d7f8c06f4d7f$var$BigInteger === "undefined") var $0b75d7f8c06f4d7f$var$BigInteger = $fz7FM.jsbn.BigInteger;
var $0b75d7f8c06f4d7f$var$ByteBuffer = $fz7FM.util.ByteBuffer;
var $0b75d7f8c06f4d7f$var$NativeBuffer = typeof $0b75d7f8c06f4d7f$require$Buffer === "undefined" ? Uint8Array : $0b75d7f8c06f4d7f$require$Buffer;
/*
 * Ed25519 algorithms, see RFC 8032:
 * https://tools.ietf.org/html/rfc8032
 */ $fz7FM.pki = $fz7FM.pki || {};
module.exports = $fz7FM.pki.ed25519 = $fz7FM.ed25519 = $fz7FM.ed25519 || {};
var $0b75d7f8c06f4d7f$var$ed25519 = $fz7FM.ed25519;
$0b75d7f8c06f4d7f$var$ed25519.constants = {};
$0b75d7f8c06f4d7f$var$ed25519.constants.PUBLIC_KEY_BYTE_LENGTH = 32;
$0b75d7f8c06f4d7f$var$ed25519.constants.PRIVATE_KEY_BYTE_LENGTH = 64;
$0b75d7f8c06f4d7f$var$ed25519.constants.SEED_BYTE_LENGTH = 32;
$0b75d7f8c06f4d7f$var$ed25519.constants.SIGN_BYTE_LENGTH = 64;
$0b75d7f8c06f4d7f$var$ed25519.constants.HASH_BYTE_LENGTH = 64;
$0b75d7f8c06f4d7f$var$ed25519.generateKeyPair = function(options) {
    options = options || {};
    var seed = options.seed;
    if (seed === undefined) // generate seed
    seed = $fz7FM.random.getBytesSync($0b75d7f8c06f4d7f$var$ed25519.constants.SEED_BYTE_LENGTH);
    else if (typeof seed === "string") {
        if (seed.length !== $0b75d7f8c06f4d7f$var$ed25519.constants.SEED_BYTE_LENGTH) throw new TypeError('"seed" must be ' + $0b75d7f8c06f4d7f$var$ed25519.constants.SEED_BYTE_LENGTH + " bytes in length.");
    } else if (!(seed instanceof Uint8Array)) throw new TypeError('"seed" must be a node.js Buffer, Uint8Array, or a binary string.');
    seed = $0b75d7f8c06f4d7f$var$messageToNativeBuffer({
        message: seed,
        encoding: "binary"
    });
    var pk = new $0b75d7f8c06f4d7f$var$NativeBuffer($0b75d7f8c06f4d7f$var$ed25519.constants.PUBLIC_KEY_BYTE_LENGTH);
    var sk = new $0b75d7f8c06f4d7f$var$NativeBuffer($0b75d7f8c06f4d7f$var$ed25519.constants.PRIVATE_KEY_BYTE_LENGTH);
    for(var i = 0; i < 32; ++i)sk[i] = seed[i];
    $0b75d7f8c06f4d7f$var$crypto_sign_keypair(pk, sk);
    return {
        publicKey: pk,
        privateKey: sk
    };
};
/**
 * Converts a private key from a RFC8410 ASN.1 encoding.
 *
 * @param obj - The asn1 representation of a private key.
 *
 * @returns {Object} keyInfo - The key information.
 * @returns {Buffer|Uint8Array} keyInfo.privateKeyBytes - 32 private key bytes.
 */ $0b75d7f8c06f4d7f$var$ed25519.privateKeyFromAsn1 = function(obj) {
    var capture = {};
    var errors = [];
    var valid = $fz7FM.asn1.validate(obj, $0b75d7f8c06f4d7f$var$privateKeyValidator, capture, errors);
    if (!valid) {
        var error = new Error("Invalid Key.");
        error.errors = errors;
        throw error;
    }
    var oid = $fz7FM.asn1.derToOid(capture.privateKeyOid);
    var ed25519Oid = $fz7FM.oids.EdDSA25519;
    if (oid !== ed25519Oid) throw new Error('Invalid OID "' + oid + '"; OID must be "' + ed25519Oid + '".');
    var privateKey = capture.privateKey;
    // manually extract the private key bytes from nested octet string, see FIXME:
    // https://github.com/digitalbazaar/forge/blob/master/lib/asn1.js#L542
    var privateKeyBytes = $0b75d7f8c06f4d7f$var$messageToNativeBuffer({
        message: $fz7FM.asn1.fromDer(privateKey).value,
        encoding: "binary"
    });
    // TODO: RFC8410 specifies a format for encoding the public key bytes along
    // with the private key bytes. `publicKeyBytes` can be returned in the
    // future. https://tools.ietf.org/html/rfc8410#section-10.3
    return {
        privateKeyBytes: privateKeyBytes
    };
};
/**
 * Converts a public key from a RFC8410 ASN.1 encoding.
 *
 * @param obj - The asn1 representation of a public key.
 *
 * @return {Buffer|Uint8Array} - 32 public key bytes.
 */ $0b75d7f8c06f4d7f$var$ed25519.publicKeyFromAsn1 = function(obj) {
    // get SubjectPublicKeyInfo
    var capture = {};
    var errors = [];
    var valid = $fz7FM.asn1.validate(obj, $0b75d7f8c06f4d7f$var$publicKeyValidator, capture, errors);
    if (!valid) {
        var error = new Error("Invalid Key.");
        error.errors = errors;
        throw error;
    }
    var oid = $fz7FM.asn1.derToOid(capture.publicKeyOid);
    var ed25519Oid = $fz7FM.oids.EdDSA25519;
    if (oid !== ed25519Oid) throw new Error('Invalid OID "' + oid + '"; OID must be "' + ed25519Oid + '".');
    var publicKeyBytes = capture.ed25519PublicKey;
    if (publicKeyBytes.length !== $0b75d7f8c06f4d7f$var$ed25519.constants.PUBLIC_KEY_BYTE_LENGTH) throw new Error("Key length is invalid.");
    return $0b75d7f8c06f4d7f$var$messageToNativeBuffer({
        message: publicKeyBytes,
        encoding: "binary"
    });
};
$0b75d7f8c06f4d7f$var$ed25519.publicKeyFromPrivateKey = function(options) {
    options = options || {};
    var privateKey = $0b75d7f8c06f4d7f$var$messageToNativeBuffer({
        message: options.privateKey,
        encoding: "binary"
    });
    if (privateKey.length !== $0b75d7f8c06f4d7f$var$ed25519.constants.PRIVATE_KEY_BYTE_LENGTH) throw new TypeError('"options.privateKey" must have a byte length of ' + $0b75d7f8c06f4d7f$var$ed25519.constants.PRIVATE_KEY_BYTE_LENGTH);
    var pk = new $0b75d7f8c06f4d7f$var$NativeBuffer($0b75d7f8c06f4d7f$var$ed25519.constants.PUBLIC_KEY_BYTE_LENGTH);
    for(var i = 0; i < pk.length; ++i)pk[i] = privateKey[32 + i];
    return pk;
};
$0b75d7f8c06f4d7f$var$ed25519.sign = function(options) {
    options = options || {};
    var msg = $0b75d7f8c06f4d7f$var$messageToNativeBuffer(options);
    var privateKey = $0b75d7f8c06f4d7f$var$messageToNativeBuffer({
        message: options.privateKey,
        encoding: "binary"
    });
    if (privateKey.length === $0b75d7f8c06f4d7f$var$ed25519.constants.SEED_BYTE_LENGTH) {
        var keyPair = $0b75d7f8c06f4d7f$var$ed25519.generateKeyPair({
            seed: privateKey
        });
        privateKey = keyPair.privateKey;
    } else if (privateKey.length !== $0b75d7f8c06f4d7f$var$ed25519.constants.PRIVATE_KEY_BYTE_LENGTH) throw new TypeError('"options.privateKey" must have a byte length of ' + $0b75d7f8c06f4d7f$var$ed25519.constants.SEED_BYTE_LENGTH + " or " + $0b75d7f8c06f4d7f$var$ed25519.constants.PRIVATE_KEY_BYTE_LENGTH);
    var signedMsg = new $0b75d7f8c06f4d7f$var$NativeBuffer($0b75d7f8c06f4d7f$var$ed25519.constants.SIGN_BYTE_LENGTH + msg.length);
    $0b75d7f8c06f4d7f$var$crypto_sign(signedMsg, msg, msg.length, privateKey);
    var sig = new $0b75d7f8c06f4d7f$var$NativeBuffer($0b75d7f8c06f4d7f$var$ed25519.constants.SIGN_BYTE_LENGTH);
    for(var i = 0; i < sig.length; ++i)sig[i] = signedMsg[i];
    return sig;
};
$0b75d7f8c06f4d7f$var$ed25519.verify = function(options) {
    options = options || {};
    var msg = $0b75d7f8c06f4d7f$var$messageToNativeBuffer(options);
    if (options.signature === undefined) throw new TypeError('"options.signature" must be a node.js Buffer, a Uint8Array, a forge ByteBuffer, or a binary string.');
    var sig = $0b75d7f8c06f4d7f$var$messageToNativeBuffer({
        message: options.signature,
        encoding: "binary"
    });
    if (sig.length !== $0b75d7f8c06f4d7f$var$ed25519.constants.SIGN_BYTE_LENGTH) throw new TypeError('"options.signature" must have a byte length of ' + $0b75d7f8c06f4d7f$var$ed25519.constants.SIGN_BYTE_LENGTH);
    var publicKey = $0b75d7f8c06f4d7f$var$messageToNativeBuffer({
        message: options.publicKey,
        encoding: "binary"
    });
    if (publicKey.length !== $0b75d7f8c06f4d7f$var$ed25519.constants.PUBLIC_KEY_BYTE_LENGTH) throw new TypeError('"options.publicKey" must have a byte length of ' + $0b75d7f8c06f4d7f$var$ed25519.constants.PUBLIC_KEY_BYTE_LENGTH);
    var sm = new $0b75d7f8c06f4d7f$var$NativeBuffer($0b75d7f8c06f4d7f$var$ed25519.constants.SIGN_BYTE_LENGTH + msg.length);
    var m = new $0b75d7f8c06f4d7f$var$NativeBuffer($0b75d7f8c06f4d7f$var$ed25519.constants.SIGN_BYTE_LENGTH + msg.length);
    var i;
    for(i = 0; i < $0b75d7f8c06f4d7f$var$ed25519.constants.SIGN_BYTE_LENGTH; ++i)sm[i] = sig[i];
    for(i = 0; i < msg.length; ++i)sm[i + $0b75d7f8c06f4d7f$var$ed25519.constants.SIGN_BYTE_LENGTH] = msg[i];
    return $0b75d7f8c06f4d7f$var$crypto_sign_open(m, sm, sm.length, publicKey) >= 0;
};
function $0b75d7f8c06f4d7f$var$messageToNativeBuffer(options) {
    var message = options.message;
    if (message instanceof Uint8Array || message instanceof $0b75d7f8c06f4d7f$var$NativeBuffer) return message;
    var encoding = options.encoding;
    if (message === undefined) {
        if (options.md) {
            // TODO: more rigorous validation that `md` is a MessageDigest
            message = options.md.digest().getBytes();
            encoding = "binary";
        } else throw new TypeError('"options.message" or "options.md" not specified.');
    }
    if (typeof message === "string" && !encoding) throw new TypeError('"options.encoding" must be "binary" or "utf8".');
    if (typeof message === "string") {
        if (typeof $0b75d7f8c06f4d7f$require$Buffer !== "undefined") return $0b75d7f8c06f4d7f$require$Buffer.from(message, encoding);
        message = new $0b75d7f8c06f4d7f$var$ByteBuffer(message, encoding);
    } else if (!(message instanceof $0b75d7f8c06f4d7f$var$ByteBuffer)) throw new TypeError('"options.message" must be a node.js Buffer, a Uint8Array, a forge ByteBuffer, or a string with "options.encoding" specifying its encoding.');
    // convert to native buffer
    var buffer = new $0b75d7f8c06f4d7f$var$NativeBuffer(message.length());
    for(var i = 0; i < buffer.length; ++i)buffer[i] = message.at(i);
    return buffer;
}
var $0b75d7f8c06f4d7f$var$gf0 = $0b75d7f8c06f4d7f$var$gf();
var $0b75d7f8c06f4d7f$var$gf1 = $0b75d7f8c06f4d7f$var$gf([
    1
]);
var $0b75d7f8c06f4d7f$var$D = $0b75d7f8c06f4d7f$var$gf([
    0x78a3,
    0x1359,
    0x4dca,
    0x75eb,
    0xd8ab,
    0x4141,
    0x0a4d,
    0x0070,
    0xe898,
    0x7779,
    0x4079,
    0x8cc7,
    0xfe73,
    0x2b6f,
    0x6cee,
    0x5203
]);
var $0b75d7f8c06f4d7f$var$D2 = $0b75d7f8c06f4d7f$var$gf([
    0xf159,
    0x26b2,
    0x9b94,
    0xebd6,
    0xb156,
    0x8283,
    0x149a,
    0x00e0,
    0xd130,
    0xeef3,
    0x80f2,
    0x198e,
    0xfce7,
    0x56df,
    0xd9dc,
    0x2406
]);
var $0b75d7f8c06f4d7f$var$X = $0b75d7f8c06f4d7f$var$gf([
    0xd51a,
    0x8f25,
    0x2d60,
    0xc956,
    0xa7b2,
    0x9525,
    0xc760,
    0x692c,
    0xdc5c,
    0xfdd6,
    0xe231,
    0xc0a4,
    0x53fe,
    0xcd6e,
    0x36d3,
    0x2169
]);
var $0b75d7f8c06f4d7f$var$Y = $0b75d7f8c06f4d7f$var$gf([
    0x6658,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666
]);
var $0b75d7f8c06f4d7f$var$L = new Float64Array([
    0xed,
    0xd3,
    0xf5,
    0x5c,
    0x1a,
    0x63,
    0x12,
    0x58,
    0xd6,
    0x9c,
    0xf7,
    0xa2,
    0xde,
    0xf9,
    0xde,
    0x14,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0x10
]);
var $0b75d7f8c06f4d7f$var$I = $0b75d7f8c06f4d7f$var$gf([
    0xa0b0,
    0x4a0e,
    0x1b27,
    0xc4ee,
    0xe478,
    0xad2f,
    0x1806,
    0x2f43,
    0xd7a7,
    0x3dfb,
    0x0099,
    0x2b4d,
    0xdf0b,
    0x4fc1,
    0x2480,
    0x2b83
]);
// TODO: update forge buffer implementation to use `Buffer` or `Uint8Array`,
// whichever is available, to improve performance
function $0b75d7f8c06f4d7f$var$sha512(msg, msgLen) {
    // Note: `out` and `msg` are NativeBuffer
    var md = $fz7FM.md.sha512.create();
    var buffer = new $0b75d7f8c06f4d7f$var$ByteBuffer(msg);
    md.update(buffer.getBytes(msgLen), "binary");
    var hash = md.digest().getBytes();
    if (typeof $0b75d7f8c06f4d7f$require$Buffer !== "undefined") return $0b75d7f8c06f4d7f$require$Buffer.from(hash, "binary");
    var out = new $0b75d7f8c06f4d7f$var$NativeBuffer($0b75d7f8c06f4d7f$var$ed25519.constants.HASH_BYTE_LENGTH);
    for(var i = 0; i < 64; ++i)out[i] = hash.charCodeAt(i);
    return out;
}
function $0b75d7f8c06f4d7f$var$crypto_sign_keypair(pk, sk) {
    var p = [
        $0b75d7f8c06f4d7f$var$gf(),
        $0b75d7f8c06f4d7f$var$gf(),
        $0b75d7f8c06f4d7f$var$gf(),
        $0b75d7f8c06f4d7f$var$gf()
    ];
    var i;
    var d = $0b75d7f8c06f4d7f$var$sha512(sk, 32);
    d[0] &= 248;
    d[31] &= 127;
    d[31] |= 64;
    $0b75d7f8c06f4d7f$var$scalarbase(p, d);
    $0b75d7f8c06f4d7f$var$pack(pk, p);
    for(i = 0; i < 32; ++i)sk[i + 32] = pk[i];
    return 0;
}
// Note: difference from C - smlen returned, not passed as argument.
function $0b75d7f8c06f4d7f$var$crypto_sign(sm, m, n, sk) {
    var i, j, x = new Float64Array(64);
    var p = [
        $0b75d7f8c06f4d7f$var$gf(),
        $0b75d7f8c06f4d7f$var$gf(),
        $0b75d7f8c06f4d7f$var$gf(),
        $0b75d7f8c06f4d7f$var$gf()
    ];
    var d = $0b75d7f8c06f4d7f$var$sha512(sk, 32);
    d[0] &= 248;
    d[31] &= 127;
    d[31] |= 64;
    var smlen = n + 64;
    for(i = 0; i < n; ++i)sm[64 + i] = m[i];
    for(i = 0; i < 32; ++i)sm[32 + i] = d[32 + i];
    var r = $0b75d7f8c06f4d7f$var$sha512(sm.subarray(32), n + 32);
    $0b75d7f8c06f4d7f$var$reduce(r);
    $0b75d7f8c06f4d7f$var$scalarbase(p, r);
    $0b75d7f8c06f4d7f$var$pack(sm, p);
    for(i = 32; i < 64; ++i)sm[i] = sk[i];
    var h = $0b75d7f8c06f4d7f$var$sha512(sm, n + 64);
    $0b75d7f8c06f4d7f$var$reduce(h);
    for(i = 32; i < 64; ++i)x[i] = 0;
    for(i = 0; i < 32; ++i)x[i] = r[i];
    for(i = 0; i < 32; ++i)for(j = 0; j < 32; j++)x[i + j] += h[i] * d[j];
    $0b75d7f8c06f4d7f$var$modL(sm.subarray(32), x);
    return smlen;
}
function $0b75d7f8c06f4d7f$var$crypto_sign_open(m, sm, n, pk) {
    var i, mlen;
    var t = new $0b75d7f8c06f4d7f$var$NativeBuffer(32);
    var p = [
        $0b75d7f8c06f4d7f$var$gf(),
        $0b75d7f8c06f4d7f$var$gf(),
        $0b75d7f8c06f4d7f$var$gf(),
        $0b75d7f8c06f4d7f$var$gf()
    ], q = [
        $0b75d7f8c06f4d7f$var$gf(),
        $0b75d7f8c06f4d7f$var$gf(),
        $0b75d7f8c06f4d7f$var$gf(),
        $0b75d7f8c06f4d7f$var$gf()
    ];
    mlen = -1;
    if (n < 64) return -1;
    if ($0b75d7f8c06f4d7f$var$unpackneg(q, pk)) return -1;
    for(i = 0; i < n; ++i)m[i] = sm[i];
    for(i = 0; i < 32; ++i)m[i + 32] = pk[i];
    var h = $0b75d7f8c06f4d7f$var$sha512(m, n);
    $0b75d7f8c06f4d7f$var$reduce(h);
    $0b75d7f8c06f4d7f$var$scalarmult(p, q, h);
    $0b75d7f8c06f4d7f$var$scalarbase(q, sm.subarray(32));
    $0b75d7f8c06f4d7f$var$add(p, q);
    $0b75d7f8c06f4d7f$var$pack(t, p);
    n -= 64;
    if ($0b75d7f8c06f4d7f$var$crypto_verify_32(sm, 0, t, 0)) {
        for(i = 0; i < n; ++i)m[i] = 0;
        return -1;
    }
    for(i = 0; i < n; ++i)m[i] = sm[i + 64];
    mlen = n;
    return mlen;
}
function $0b75d7f8c06f4d7f$var$modL(r, x) {
    var carry, i, j, k;
    for(i = 63; i >= 32; --i){
        carry = 0;
        for(j = i - 32, k = i - 12; j < k; ++j){
            x[j] += carry - 16 * x[i] * $0b75d7f8c06f4d7f$var$L[j - (i - 32)];
            carry = x[j] + 128 >> 8;
            x[j] -= carry * 256;
        }
        x[j] += carry;
        x[i] = 0;
    }
    carry = 0;
    for(j = 0; j < 32; ++j){
        x[j] += carry - (x[31] >> 4) * $0b75d7f8c06f4d7f$var$L[j];
        carry = x[j] >> 8;
        x[j] &= 255;
    }
    for(j = 0; j < 32; ++j)x[j] -= carry * $0b75d7f8c06f4d7f$var$L[j];
    for(i = 0; i < 32; ++i){
        x[i + 1] += x[i] >> 8;
        r[i] = x[i] & 255;
    }
}
function $0b75d7f8c06f4d7f$var$reduce(r) {
    var x = new Float64Array(64);
    for(var i = 0; i < 64; ++i){
        x[i] = r[i];
        r[i] = 0;
    }
    $0b75d7f8c06f4d7f$var$modL(r, x);
}
function $0b75d7f8c06f4d7f$var$add(p, q) {
    var a = $0b75d7f8c06f4d7f$var$gf(), b = $0b75d7f8c06f4d7f$var$gf(), c = $0b75d7f8c06f4d7f$var$gf(), d = $0b75d7f8c06f4d7f$var$gf(), e = $0b75d7f8c06f4d7f$var$gf(), f = $0b75d7f8c06f4d7f$var$gf(), g = $0b75d7f8c06f4d7f$var$gf(), h = $0b75d7f8c06f4d7f$var$gf(), t = $0b75d7f8c06f4d7f$var$gf();
    $0b75d7f8c06f4d7f$var$Z(a, p[1], p[0]);
    $0b75d7f8c06f4d7f$var$Z(t, q[1], q[0]);
    $0b75d7f8c06f4d7f$var$M(a, a, t);
    $0b75d7f8c06f4d7f$var$A(b, p[0], p[1]);
    $0b75d7f8c06f4d7f$var$A(t, q[0], q[1]);
    $0b75d7f8c06f4d7f$var$M(b, b, t);
    $0b75d7f8c06f4d7f$var$M(c, p[3], q[3]);
    $0b75d7f8c06f4d7f$var$M(c, c, $0b75d7f8c06f4d7f$var$D2);
    $0b75d7f8c06f4d7f$var$M(d, p[2], q[2]);
    $0b75d7f8c06f4d7f$var$A(d, d, d);
    $0b75d7f8c06f4d7f$var$Z(e, b, a);
    $0b75d7f8c06f4d7f$var$Z(f, d, c);
    $0b75d7f8c06f4d7f$var$A(g, d, c);
    $0b75d7f8c06f4d7f$var$A(h, b, a);
    $0b75d7f8c06f4d7f$var$M(p[0], e, f);
    $0b75d7f8c06f4d7f$var$M(p[1], h, g);
    $0b75d7f8c06f4d7f$var$M(p[2], g, f);
    $0b75d7f8c06f4d7f$var$M(p[3], e, h);
}
function $0b75d7f8c06f4d7f$var$cswap(p, q, b) {
    for(var i = 0; i < 4; ++i)$0b75d7f8c06f4d7f$var$sel25519(p[i], q[i], b);
}
function $0b75d7f8c06f4d7f$var$pack(r, p) {
    var tx = $0b75d7f8c06f4d7f$var$gf(), ty = $0b75d7f8c06f4d7f$var$gf(), zi = $0b75d7f8c06f4d7f$var$gf();
    $0b75d7f8c06f4d7f$var$inv25519(zi, p[2]);
    $0b75d7f8c06f4d7f$var$M(tx, p[0], zi);
    $0b75d7f8c06f4d7f$var$M(ty, p[1], zi);
    $0b75d7f8c06f4d7f$var$pack25519(r, ty);
    r[31] ^= $0b75d7f8c06f4d7f$var$par25519(tx) << 7;
}
function $0b75d7f8c06f4d7f$var$pack25519(o, n) {
    var i, j, b;
    var m = $0b75d7f8c06f4d7f$var$gf(), t = $0b75d7f8c06f4d7f$var$gf();
    for(i = 0; i < 16; ++i)t[i] = n[i];
    $0b75d7f8c06f4d7f$var$car25519(t);
    $0b75d7f8c06f4d7f$var$car25519(t);
    $0b75d7f8c06f4d7f$var$car25519(t);
    for(j = 0; j < 2; ++j){
        m[0] = t[0] - 0xffed;
        for(i = 1; i < 15; ++i){
            m[i] = t[i] - 0xffff - (m[i - 1] >> 16 & 1);
            m[i - 1] &= 0xffff;
        }
        m[15] = t[15] - 0x7fff - (m[14] >> 16 & 1);
        b = m[15] >> 16 & 1;
        m[14] &= 0xffff;
        $0b75d7f8c06f4d7f$var$sel25519(t, m, 1 - b);
    }
    for(i = 0; i < 16; i++){
        o[2 * i] = t[i] & 0xff;
        o[2 * i + 1] = t[i] >> 8;
    }
}
function $0b75d7f8c06f4d7f$var$unpackneg(r, p) {
    var t = $0b75d7f8c06f4d7f$var$gf(), chk = $0b75d7f8c06f4d7f$var$gf(), num = $0b75d7f8c06f4d7f$var$gf(), den = $0b75d7f8c06f4d7f$var$gf(), den2 = $0b75d7f8c06f4d7f$var$gf(), den4 = $0b75d7f8c06f4d7f$var$gf(), den6 = $0b75d7f8c06f4d7f$var$gf();
    $0b75d7f8c06f4d7f$var$set25519(r[2], $0b75d7f8c06f4d7f$var$gf1);
    $0b75d7f8c06f4d7f$var$unpack25519(r[1], p);
    $0b75d7f8c06f4d7f$var$S(num, r[1]);
    $0b75d7f8c06f4d7f$var$M(den, num, $0b75d7f8c06f4d7f$var$D);
    $0b75d7f8c06f4d7f$var$Z(num, num, r[2]);
    $0b75d7f8c06f4d7f$var$A(den, r[2], den);
    $0b75d7f8c06f4d7f$var$S(den2, den);
    $0b75d7f8c06f4d7f$var$S(den4, den2);
    $0b75d7f8c06f4d7f$var$M(den6, den4, den2);
    $0b75d7f8c06f4d7f$var$M(t, den6, num);
    $0b75d7f8c06f4d7f$var$M(t, t, den);
    $0b75d7f8c06f4d7f$var$pow2523(t, t);
    $0b75d7f8c06f4d7f$var$M(t, t, num);
    $0b75d7f8c06f4d7f$var$M(t, t, den);
    $0b75d7f8c06f4d7f$var$M(t, t, den);
    $0b75d7f8c06f4d7f$var$M(r[0], t, den);
    $0b75d7f8c06f4d7f$var$S(chk, r[0]);
    $0b75d7f8c06f4d7f$var$M(chk, chk, den);
    if ($0b75d7f8c06f4d7f$var$neq25519(chk, num)) $0b75d7f8c06f4d7f$var$M(r[0], r[0], $0b75d7f8c06f4d7f$var$I);
    $0b75d7f8c06f4d7f$var$S(chk, r[0]);
    $0b75d7f8c06f4d7f$var$M(chk, chk, den);
    if ($0b75d7f8c06f4d7f$var$neq25519(chk, num)) return -1;
    if ($0b75d7f8c06f4d7f$var$par25519(r[0]) === p[31] >> 7) $0b75d7f8c06f4d7f$var$Z(r[0], $0b75d7f8c06f4d7f$var$gf0, r[0]);
    $0b75d7f8c06f4d7f$var$M(r[3], r[0], r[1]);
    return 0;
}
function $0b75d7f8c06f4d7f$var$unpack25519(o, n) {
    var i;
    for(i = 0; i < 16; ++i)o[i] = n[2 * i] + (n[2 * i + 1] << 8);
    o[15] &= 0x7fff;
}
function $0b75d7f8c06f4d7f$var$pow2523(o, i) {
    var c = $0b75d7f8c06f4d7f$var$gf();
    var a;
    for(a = 0; a < 16; ++a)c[a] = i[a];
    for(a = 250; a >= 0; --a){
        $0b75d7f8c06f4d7f$var$S(c, c);
        if (a !== 1) $0b75d7f8c06f4d7f$var$M(c, c, i);
    }
    for(a = 0; a < 16; ++a)o[a] = c[a];
}
function $0b75d7f8c06f4d7f$var$neq25519(a, b) {
    var c = new $0b75d7f8c06f4d7f$var$NativeBuffer(32);
    var d = new $0b75d7f8c06f4d7f$var$NativeBuffer(32);
    $0b75d7f8c06f4d7f$var$pack25519(c, a);
    $0b75d7f8c06f4d7f$var$pack25519(d, b);
    return $0b75d7f8c06f4d7f$var$crypto_verify_32(c, 0, d, 0);
}
function $0b75d7f8c06f4d7f$var$crypto_verify_32(x, xi, y, yi) {
    return $0b75d7f8c06f4d7f$var$vn(x, xi, y, yi, 32);
}
function $0b75d7f8c06f4d7f$var$vn(x, xi, y, yi, n) {
    var i, d = 0;
    for(i = 0; i < n; ++i)d |= x[xi + i] ^ y[yi + i];
    return (1 & d - 1 >>> 8) - 1;
}
function $0b75d7f8c06f4d7f$var$par25519(a) {
    var d = new $0b75d7f8c06f4d7f$var$NativeBuffer(32);
    $0b75d7f8c06f4d7f$var$pack25519(d, a);
    return d[0] & 1;
}
function $0b75d7f8c06f4d7f$var$scalarmult(p, q, s) {
    var b, i;
    $0b75d7f8c06f4d7f$var$set25519(p[0], $0b75d7f8c06f4d7f$var$gf0);
    $0b75d7f8c06f4d7f$var$set25519(p[1], $0b75d7f8c06f4d7f$var$gf1);
    $0b75d7f8c06f4d7f$var$set25519(p[2], $0b75d7f8c06f4d7f$var$gf1);
    $0b75d7f8c06f4d7f$var$set25519(p[3], $0b75d7f8c06f4d7f$var$gf0);
    for(i = 255; i >= 0; --i){
        b = s[i / 8 | 0] >> (i & 7) & 1;
        $0b75d7f8c06f4d7f$var$cswap(p, q, b);
        $0b75d7f8c06f4d7f$var$add(q, p);
        $0b75d7f8c06f4d7f$var$add(p, p);
        $0b75d7f8c06f4d7f$var$cswap(p, q, b);
    }
}
function $0b75d7f8c06f4d7f$var$scalarbase(p, s) {
    var q = [
        $0b75d7f8c06f4d7f$var$gf(),
        $0b75d7f8c06f4d7f$var$gf(),
        $0b75d7f8c06f4d7f$var$gf(),
        $0b75d7f8c06f4d7f$var$gf()
    ];
    $0b75d7f8c06f4d7f$var$set25519(q[0], $0b75d7f8c06f4d7f$var$X);
    $0b75d7f8c06f4d7f$var$set25519(q[1], $0b75d7f8c06f4d7f$var$Y);
    $0b75d7f8c06f4d7f$var$set25519(q[2], $0b75d7f8c06f4d7f$var$gf1);
    $0b75d7f8c06f4d7f$var$M(q[3], $0b75d7f8c06f4d7f$var$X, $0b75d7f8c06f4d7f$var$Y);
    $0b75d7f8c06f4d7f$var$scalarmult(p, q, s);
}
function $0b75d7f8c06f4d7f$var$set25519(r, a) {
    var i;
    for(i = 0; i < 16; i++)r[i] = a[i] | 0;
}
function $0b75d7f8c06f4d7f$var$inv25519(o, i) {
    var c = $0b75d7f8c06f4d7f$var$gf();
    var a;
    for(a = 0; a < 16; ++a)c[a] = i[a];
    for(a = 253; a >= 0; --a){
        $0b75d7f8c06f4d7f$var$S(c, c);
        if (a !== 2 && a !== 4) $0b75d7f8c06f4d7f$var$M(c, c, i);
    }
    for(a = 0; a < 16; ++a)o[a] = c[a];
}
function $0b75d7f8c06f4d7f$var$car25519(o) {
    var i, v, c = 1;
    for(i = 0; i < 16; ++i){
        v = o[i] + c + 65535;
        c = Math.floor(v / 65536);
        o[i] = v - c * 65536;
    }
    o[0] += c - 1 + 37 * (c - 1);
}
function $0b75d7f8c06f4d7f$var$sel25519(p, q, b) {
    var t, c = ~(b - 1);
    for(var i = 0; i < 16; ++i){
        t = c & (p[i] ^ q[i]);
        p[i] ^= t;
        q[i] ^= t;
    }
}
function $0b75d7f8c06f4d7f$var$gf(init) {
    var i, r = new Float64Array(16);
    if (init) for(i = 0; i < init.length; ++i)r[i] = init[i];
    return r;
}
function $0b75d7f8c06f4d7f$var$A(o, a, b) {
    for(var i = 0; i < 16; ++i)o[i] = a[i] + b[i];
}
function $0b75d7f8c06f4d7f$var$Z(o, a, b) {
    for(var i = 0; i < 16; ++i)o[i] = a[i] - b[i];
}
function $0b75d7f8c06f4d7f$var$S(o, a) {
    $0b75d7f8c06f4d7f$var$M(o, a, a);
}
function $0b75d7f8c06f4d7f$var$M(o, a, b) {
    var v, c, t0 = 0, t1 = 0, t2 = 0, t3 = 0, t4 = 0, t5 = 0, t6 = 0, t7 = 0, t8 = 0, t9 = 0, t10 = 0, t11 = 0, t12 = 0, t13 = 0, t14 = 0, t15 = 0, t16 = 0, t17 = 0, t18 = 0, t19 = 0, t20 = 0, t21 = 0, t22 = 0, t23 = 0, t24 = 0, t25 = 0, t26 = 0, t27 = 0, t28 = 0, t29 = 0, t30 = 0, b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11], b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
    v = a[0];
    t0 += v * b0;
    t1 += v * b1;
    t2 += v * b2;
    t3 += v * b3;
    t4 += v * b4;
    t5 += v * b5;
    t6 += v * b6;
    t7 += v * b7;
    t8 += v * b8;
    t9 += v * b9;
    t10 += v * b10;
    t11 += v * b11;
    t12 += v * b12;
    t13 += v * b13;
    t14 += v * b14;
    t15 += v * b15;
    v = a[1];
    t1 += v * b0;
    t2 += v * b1;
    t3 += v * b2;
    t4 += v * b3;
    t5 += v * b4;
    t6 += v * b5;
    t7 += v * b6;
    t8 += v * b7;
    t9 += v * b8;
    t10 += v * b9;
    t11 += v * b10;
    t12 += v * b11;
    t13 += v * b12;
    t14 += v * b13;
    t15 += v * b14;
    t16 += v * b15;
    v = a[2];
    t2 += v * b0;
    t3 += v * b1;
    t4 += v * b2;
    t5 += v * b3;
    t6 += v * b4;
    t7 += v * b5;
    t8 += v * b6;
    t9 += v * b7;
    t10 += v * b8;
    t11 += v * b9;
    t12 += v * b10;
    t13 += v * b11;
    t14 += v * b12;
    t15 += v * b13;
    t16 += v * b14;
    t17 += v * b15;
    v = a[3];
    t3 += v * b0;
    t4 += v * b1;
    t5 += v * b2;
    t6 += v * b3;
    t7 += v * b4;
    t8 += v * b5;
    t9 += v * b6;
    t10 += v * b7;
    t11 += v * b8;
    t12 += v * b9;
    t13 += v * b10;
    t14 += v * b11;
    t15 += v * b12;
    t16 += v * b13;
    t17 += v * b14;
    t18 += v * b15;
    v = a[4];
    t4 += v * b0;
    t5 += v * b1;
    t6 += v * b2;
    t7 += v * b3;
    t8 += v * b4;
    t9 += v * b5;
    t10 += v * b6;
    t11 += v * b7;
    t12 += v * b8;
    t13 += v * b9;
    t14 += v * b10;
    t15 += v * b11;
    t16 += v * b12;
    t17 += v * b13;
    t18 += v * b14;
    t19 += v * b15;
    v = a[5];
    t5 += v * b0;
    t6 += v * b1;
    t7 += v * b2;
    t8 += v * b3;
    t9 += v * b4;
    t10 += v * b5;
    t11 += v * b6;
    t12 += v * b7;
    t13 += v * b8;
    t14 += v * b9;
    t15 += v * b10;
    t16 += v * b11;
    t17 += v * b12;
    t18 += v * b13;
    t19 += v * b14;
    t20 += v * b15;
    v = a[6];
    t6 += v * b0;
    t7 += v * b1;
    t8 += v * b2;
    t9 += v * b3;
    t10 += v * b4;
    t11 += v * b5;
    t12 += v * b6;
    t13 += v * b7;
    t14 += v * b8;
    t15 += v * b9;
    t16 += v * b10;
    t17 += v * b11;
    t18 += v * b12;
    t19 += v * b13;
    t20 += v * b14;
    t21 += v * b15;
    v = a[7];
    t7 += v * b0;
    t8 += v * b1;
    t9 += v * b2;
    t10 += v * b3;
    t11 += v * b4;
    t12 += v * b5;
    t13 += v * b6;
    t14 += v * b7;
    t15 += v * b8;
    t16 += v * b9;
    t17 += v * b10;
    t18 += v * b11;
    t19 += v * b12;
    t20 += v * b13;
    t21 += v * b14;
    t22 += v * b15;
    v = a[8];
    t8 += v * b0;
    t9 += v * b1;
    t10 += v * b2;
    t11 += v * b3;
    t12 += v * b4;
    t13 += v * b5;
    t14 += v * b6;
    t15 += v * b7;
    t16 += v * b8;
    t17 += v * b9;
    t18 += v * b10;
    t19 += v * b11;
    t20 += v * b12;
    t21 += v * b13;
    t22 += v * b14;
    t23 += v * b15;
    v = a[9];
    t9 += v * b0;
    t10 += v * b1;
    t11 += v * b2;
    t12 += v * b3;
    t13 += v * b4;
    t14 += v * b5;
    t15 += v * b6;
    t16 += v * b7;
    t17 += v * b8;
    t18 += v * b9;
    t19 += v * b10;
    t20 += v * b11;
    t21 += v * b12;
    t22 += v * b13;
    t23 += v * b14;
    t24 += v * b15;
    v = a[10];
    t10 += v * b0;
    t11 += v * b1;
    t12 += v * b2;
    t13 += v * b3;
    t14 += v * b4;
    t15 += v * b5;
    t16 += v * b6;
    t17 += v * b7;
    t18 += v * b8;
    t19 += v * b9;
    t20 += v * b10;
    t21 += v * b11;
    t22 += v * b12;
    t23 += v * b13;
    t24 += v * b14;
    t25 += v * b15;
    v = a[11];
    t11 += v * b0;
    t12 += v * b1;
    t13 += v * b2;
    t14 += v * b3;
    t15 += v * b4;
    t16 += v * b5;
    t17 += v * b6;
    t18 += v * b7;
    t19 += v * b8;
    t20 += v * b9;
    t21 += v * b10;
    t22 += v * b11;
    t23 += v * b12;
    t24 += v * b13;
    t25 += v * b14;
    t26 += v * b15;
    v = a[12];
    t12 += v * b0;
    t13 += v * b1;
    t14 += v * b2;
    t15 += v * b3;
    t16 += v * b4;
    t17 += v * b5;
    t18 += v * b6;
    t19 += v * b7;
    t20 += v * b8;
    t21 += v * b9;
    t22 += v * b10;
    t23 += v * b11;
    t24 += v * b12;
    t25 += v * b13;
    t26 += v * b14;
    t27 += v * b15;
    v = a[13];
    t13 += v * b0;
    t14 += v * b1;
    t15 += v * b2;
    t16 += v * b3;
    t17 += v * b4;
    t18 += v * b5;
    t19 += v * b6;
    t20 += v * b7;
    t21 += v * b8;
    t22 += v * b9;
    t23 += v * b10;
    t24 += v * b11;
    t25 += v * b12;
    t26 += v * b13;
    t27 += v * b14;
    t28 += v * b15;
    v = a[14];
    t14 += v * b0;
    t15 += v * b1;
    t16 += v * b2;
    t17 += v * b3;
    t18 += v * b4;
    t19 += v * b5;
    t20 += v * b6;
    t21 += v * b7;
    t22 += v * b8;
    t23 += v * b9;
    t24 += v * b10;
    t25 += v * b11;
    t26 += v * b12;
    t27 += v * b13;
    t28 += v * b14;
    t29 += v * b15;
    v = a[15];
    t15 += v * b0;
    t16 += v * b1;
    t17 += v * b2;
    t18 += v * b3;
    t19 += v * b4;
    t20 += v * b5;
    t21 += v * b6;
    t22 += v * b7;
    t23 += v * b8;
    t24 += v * b9;
    t25 += v * b10;
    t26 += v * b11;
    t27 += v * b12;
    t28 += v * b13;
    t29 += v * b14;
    t30 += v * b15;
    t0 += 38 * t16;
    t1 += 38 * t17;
    t2 += 38 * t18;
    t3 += 38 * t19;
    t4 += 38 * t20;
    t5 += 38 * t21;
    t6 += 38 * t22;
    t7 += 38 * t23;
    t8 += 38 * t24;
    t9 += 38 * t25;
    t10 += 38 * t26;
    t11 += 38 * t27;
    t12 += 38 * t28;
    t13 += 38 * t29;
    t14 += 38 * t30;
    // t15 left as is
    // first car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    // second car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    o[0] = t0;
    o[1] = t1;
    o[2] = t2;
    o[3] = t3;
    o[4] = t4;
    o[5] = t5;
    o[6] = t6;
    o[7] = t7;
    o[8] = t8;
    o[9] = t9;
    o[10] = t10;
    o[11] = t11;
    o[12] = t12;
    o[13] = t13;
    o[14] = t14;
    o[15] = t15;
}

});
parcelRegister("k95pK", function(module, exports) {
/**
 * Secure Hash Algorithm with a 1024-bit block size implementation.
 *
 * This includes: SHA-512, SHA-384, SHA-512/224, and SHA-512/256. For
 * SHA-256 (block size 512 bits), see sha256.js.
 *
 * See FIPS 180-4 for details.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2014-2015 Digital Bazaar, Inc.
 */ 
var $fz7FM = parcelRequire("fz7FM");
parcelRequire("6NNT4");
parcelRequire("gao36");
var $eaa8d9141b3f9711$var$sha512 = module.exports = $fz7FM.sha512 = $fz7FM.sha512 || {};
// SHA-512
$fz7FM.md.sha512 = $fz7FM.md.algorithms.sha512 = $eaa8d9141b3f9711$var$sha512;
// SHA-384
var $eaa8d9141b3f9711$var$sha384 = $fz7FM.sha384 = $fz7FM.sha512.sha384 = $fz7FM.sha512.sha384 || {};
$eaa8d9141b3f9711$var$sha384.create = function() {
    return $eaa8d9141b3f9711$var$sha512.create("SHA-384");
};
$fz7FM.md.sha384 = $fz7FM.md.algorithms.sha384 = $eaa8d9141b3f9711$var$sha384;
// SHA-512/256
$fz7FM.sha512.sha256 = $fz7FM.sha512.sha256 || {
    create: function create() {
        return $eaa8d9141b3f9711$var$sha512.create("SHA-512/256");
    }
};
$fz7FM.md["sha512/256"] = $fz7FM.md.algorithms["sha512/256"] = $fz7FM.sha512.sha256;
// SHA-512/224
$fz7FM.sha512.sha224 = $fz7FM.sha512.sha224 || {
    create: function create() {
        return $eaa8d9141b3f9711$var$sha512.create("SHA-512/224");
    }
};
$fz7FM.md["sha512/224"] = $fz7FM.md.algorithms["sha512/224"] = $fz7FM.sha512.sha224;
/**
 * Creates a SHA-2 message digest object.
 *
 * @param algorithm the algorithm to use (SHA-512, SHA-384, SHA-512/224,
 *          SHA-512/256).
 *
 * @return a message digest object.
 */ $eaa8d9141b3f9711$var$sha512.create = function(algorithm) {
    // do initialization as necessary
    if (!$eaa8d9141b3f9711$var$_initialized) $eaa8d9141b3f9711$var$_init();
    if (typeof algorithm === "undefined") algorithm = "SHA-512";
    if (!(algorithm in $eaa8d9141b3f9711$var$_states)) throw new Error("Invalid SHA-512 algorithm: " + algorithm);
    // SHA-512 state contains eight 64-bit integers (each as two 32-bit ints)
    var _state = $eaa8d9141b3f9711$var$_states[algorithm];
    var _h = null;
    // input buffer
    var _input = $fz7FM.util.createBuffer();
    // used for 64-bit word storage
    var _w = new Array(80);
    for(var wi = 0; wi < 80; ++wi)_w[wi] = new Array(2);
    // determine digest length by algorithm name (default)
    var digestLength = 64;
    switch(algorithm){
        case "SHA-384":
            digestLength = 48;
            break;
        case "SHA-512/256":
            digestLength = 32;
            break;
        case "SHA-512/224":
            digestLength = 28;
            break;
    }
    // message digest object
    var md = {
        // SHA-512 => sha512
        algorithm: algorithm.replace("-", "").toLowerCase(),
        blockLength: 128,
        digestLength: digestLength,
        // 56-bit length of message so far (does not including padding)
        messageLength: 0,
        // true message length
        fullMessageLength: null,
        // size of message length in bytes
        messageLengthSize: 16
    };
    /**
   * Starts the digest.
   *
   * @return this digest object.
   */ md.start = function() {
        // up to 56-bit message length for convenience
        md.messageLength = 0;
        // full message length (set md.messageLength128 for backwards-compatibility)
        md.fullMessageLength = md.messageLength128 = [];
        var int32s = md.messageLengthSize / 4;
        for(var i = 0; i < int32s; ++i)md.fullMessageLength.push(0);
        _input = $fz7FM.util.createBuffer();
        _h = new Array(_state.length);
        for(var i = 0; i < _state.length; ++i)_h[i] = _state[i].slice(0);
        return md;
    };
    // start digest automatically for first time
    md.start();
    /**
   * Updates the digest with the given message input. The given input can
   * treated as raw input (no encoding will be applied) or an encoding of
   * 'utf8' maybe given to encode the input using UTF-8.
   *
   * @param msg the message input to update with.
   * @param encoding the encoding to use (default: 'raw', other: 'utf8').
   *
   * @return this digest object.
   */ md.update = function(msg, encoding) {
        if (encoding === "utf8") msg = $fz7FM.util.encodeUtf8(msg);
        // update message length
        var len = msg.length;
        md.messageLength += len;
        len = [
            len / 0x100000000 >>> 0,
            len >>> 0
        ];
        for(var i = md.fullMessageLength.length - 1; i >= 0; --i){
            md.fullMessageLength[i] += len[1];
            len[1] = len[0] + (md.fullMessageLength[i] / 0x100000000 >>> 0);
            md.fullMessageLength[i] = md.fullMessageLength[i] >>> 0;
            len[0] = len[1] / 0x100000000 >>> 0;
        }
        // add bytes to input buffer
        _input.putBytes(msg);
        // process bytes
        $eaa8d9141b3f9711$var$_update(_h, _w, _input);
        // compact input buffer every 2K or if empty
        if (_input.read > 2048 || _input.length() === 0) _input.compact();
        return md;
    };
    /**
   * Produces the digest.
   *
   * @return a byte buffer containing the digest value.
   */ md.digest = function() {
        /* Note: Here we copy the remaining bytes in the input buffer and
    add the appropriate SHA-512 padding. Then we do the final update
    on a copy of the state so that if the user wants to get
    intermediate digests they can do so. */ /* Determine the number of bytes that must be added to the message
    to ensure its length is congruent to 896 mod 1024. In other words,
    the data to be digested must be a multiple of 1024 bits (or 128 bytes).
    This data includes the message, some padding, and the length of the
    message. Since the length of the message will be encoded as 16 bytes (128
    bits), that means that the last segment of the data must have 112 bytes
    (896 bits) of message and padding. Therefore, the length of the message
    plus the padding must be congruent to 896 mod 1024 because
    1024 - 128 = 896.

    In order to fill up the message length it must be filled with
    padding that begins with 1 bit followed by all 0 bits. Padding
    must *always* be present, so if the message length is already
    congruent to 896 mod 1024, then 1024 padding bits must be added. */ var finalBlock = $fz7FM.util.createBuffer();
        finalBlock.putBytes(_input.bytes());
        // compute remaining size to be digested (include message length size)
        var remaining = md.fullMessageLength[md.fullMessageLength.length - 1] + md.messageLengthSize;
        // add padding for overflow blockSize - overflow
        // _padding starts with 1 byte with first bit is set (byte value 128), then
        // there may be up to (blockSize - 1) other pad bytes
        var overflow = remaining & md.blockLength - 1;
        finalBlock.putBytes($eaa8d9141b3f9711$var$_padding.substr(0, md.blockLength - overflow));
        // serialize message length in bits in big-endian order; since length
        // is stored in bytes we multiply by 8 and add carry from next int
        var next, carry;
        var bits = md.fullMessageLength[0] * 8;
        for(var i = 0; i < md.fullMessageLength.length - 1; ++i){
            next = md.fullMessageLength[i + 1] * 8;
            carry = next / 0x100000000 >>> 0;
            bits += carry;
            finalBlock.putInt32(bits >>> 0);
            bits = next >>> 0;
        }
        finalBlock.putInt32(bits);
        var h = new Array(_h.length);
        for(var i = 0; i < _h.length; ++i)h[i] = _h[i].slice(0);
        $eaa8d9141b3f9711$var$_update(h, _w, finalBlock);
        var rval = $fz7FM.util.createBuffer();
        var hlen;
        if (algorithm === "SHA-512") hlen = h.length;
        else if (algorithm === "SHA-384") hlen = h.length - 2;
        else hlen = h.length - 4;
        for(var i = 0; i < hlen; ++i){
            rval.putInt32(h[i][0]);
            if (i !== hlen - 1 || algorithm !== "SHA-512/224") rval.putInt32(h[i][1]);
        }
        return rval;
    };
    return md;
};
// sha-512 padding bytes not initialized yet
var $eaa8d9141b3f9711$var$_padding = null;
var $eaa8d9141b3f9711$var$_initialized = false;
// table of constants
var $eaa8d9141b3f9711$var$_k = null;
// initial hash states
var $eaa8d9141b3f9711$var$_states = null;
/**
 * Initializes the constant tables.
 */ function $eaa8d9141b3f9711$var$_init() {
    // create padding
    $eaa8d9141b3f9711$var$_padding = String.fromCharCode(128);
    $eaa8d9141b3f9711$var$_padding += $fz7FM.util.fillString(String.fromCharCode(0x00), 128);
    // create K table for SHA-512
    $eaa8d9141b3f9711$var$_k = [
        [
            0x428a2f98,
            0xd728ae22
        ],
        [
            0x71374491,
            0x23ef65cd
        ],
        [
            0xb5c0fbcf,
            0xec4d3b2f
        ],
        [
            0xe9b5dba5,
            0x8189dbbc
        ],
        [
            0x3956c25b,
            0xf348b538
        ],
        [
            0x59f111f1,
            0xb605d019
        ],
        [
            0x923f82a4,
            0xaf194f9b
        ],
        [
            0xab1c5ed5,
            0xda6d8118
        ],
        [
            0xd807aa98,
            0xa3030242
        ],
        [
            0x12835b01,
            0x45706fbe
        ],
        [
            0x243185be,
            0x4ee4b28c
        ],
        [
            0x550c7dc3,
            0xd5ffb4e2
        ],
        [
            0x72be5d74,
            0xf27b896f
        ],
        [
            0x80deb1fe,
            0x3b1696b1
        ],
        [
            0x9bdc06a7,
            0x25c71235
        ],
        [
            0xc19bf174,
            0xcf692694
        ],
        [
            0xe49b69c1,
            0x9ef14ad2
        ],
        [
            0xefbe4786,
            0x384f25e3
        ],
        [
            0x0fc19dc6,
            0x8b8cd5b5
        ],
        [
            0x240ca1cc,
            0x77ac9c65
        ],
        [
            0x2de92c6f,
            0x592b0275
        ],
        [
            0x4a7484aa,
            0x6ea6e483
        ],
        [
            0x5cb0a9dc,
            0xbd41fbd4
        ],
        [
            0x76f988da,
            0x831153b5
        ],
        [
            0x983e5152,
            0xee66dfab
        ],
        [
            0xa831c66d,
            0x2db43210
        ],
        [
            0xb00327c8,
            0x98fb213f
        ],
        [
            0xbf597fc7,
            0xbeef0ee4
        ],
        [
            0xc6e00bf3,
            0x3da88fc2
        ],
        [
            0xd5a79147,
            0x930aa725
        ],
        [
            0x06ca6351,
            0xe003826f
        ],
        [
            0x14292967,
            0x0a0e6e70
        ],
        [
            0x27b70a85,
            0x46d22ffc
        ],
        [
            0x2e1b2138,
            0x5c26c926
        ],
        [
            0x4d2c6dfc,
            0x5ac42aed
        ],
        [
            0x53380d13,
            0x9d95b3df
        ],
        [
            0x650a7354,
            0x8baf63de
        ],
        [
            0x766a0abb,
            0x3c77b2a8
        ],
        [
            0x81c2c92e,
            0x47edaee6
        ],
        [
            0x92722c85,
            0x1482353b
        ],
        [
            0xa2bfe8a1,
            0x4cf10364
        ],
        [
            0xa81a664b,
            0xbc423001
        ],
        [
            0xc24b8b70,
            0xd0f89791
        ],
        [
            0xc76c51a3,
            0x0654be30
        ],
        [
            0xd192e819,
            0xd6ef5218
        ],
        [
            0xd6990624,
            0x5565a910
        ],
        [
            0xf40e3585,
            0x5771202a
        ],
        [
            0x106aa070,
            0x32bbd1b8
        ],
        [
            0x19a4c116,
            0xb8d2d0c8
        ],
        [
            0x1e376c08,
            0x5141ab53
        ],
        [
            0x2748774c,
            0xdf8eeb99
        ],
        [
            0x34b0bcb5,
            0xe19b48a8
        ],
        [
            0x391c0cb3,
            0xc5c95a63
        ],
        [
            0x4ed8aa4a,
            0xe3418acb
        ],
        [
            0x5b9cca4f,
            0x7763e373
        ],
        [
            0x682e6ff3,
            0xd6b2b8a3
        ],
        [
            0x748f82ee,
            0x5defb2fc
        ],
        [
            0x78a5636f,
            0x43172f60
        ],
        [
            0x84c87814,
            0xa1f0ab72
        ],
        [
            0x8cc70208,
            0x1a6439ec
        ],
        [
            0x90befffa,
            0x23631e28
        ],
        [
            0xa4506ceb,
            0xde82bde9
        ],
        [
            0xbef9a3f7,
            0xb2c67915
        ],
        [
            0xc67178f2,
            0xe372532b
        ],
        [
            0xca273ece,
            0xea26619c
        ],
        [
            0xd186b8c7,
            0x21c0c207
        ],
        [
            0xeada7dd6,
            0xcde0eb1e
        ],
        [
            0xf57d4f7f,
            0xee6ed178
        ],
        [
            0x06f067aa,
            0x72176fba
        ],
        [
            0x0a637dc5,
            0xa2c898a6
        ],
        [
            0x113f9804,
            0xbef90dae
        ],
        [
            0x1b710b35,
            0x131c471b
        ],
        [
            0x28db77f5,
            0x23047d84
        ],
        [
            0x32caab7b,
            0x40c72493
        ],
        [
            0x3c9ebe0a,
            0x15c9bebc
        ],
        [
            0x431d67c4,
            0x9c100d4c
        ],
        [
            0x4cc5d4be,
            0xcb3e42b6
        ],
        [
            0x597f299c,
            0xfc657e2a
        ],
        [
            0x5fcb6fab,
            0x3ad6faec
        ],
        [
            0x6c44198c,
            0x4a475817
        ]
    ];
    // initial hash states
    $eaa8d9141b3f9711$var$_states = {};
    $eaa8d9141b3f9711$var$_states["SHA-512"] = [
        [
            0x6a09e667,
            0xf3bcc908
        ],
        [
            0xbb67ae85,
            0x84caa73b
        ],
        [
            0x3c6ef372,
            0xfe94f82b
        ],
        [
            0xa54ff53a,
            0x5f1d36f1
        ],
        [
            0x510e527f,
            0xade682d1
        ],
        [
            0x9b05688c,
            0x2b3e6c1f
        ],
        [
            0x1f83d9ab,
            0xfb41bd6b
        ],
        [
            0x5be0cd19,
            0x137e2179
        ]
    ];
    $eaa8d9141b3f9711$var$_states["SHA-384"] = [
        [
            0xcbbb9d5d,
            0xc1059ed8
        ],
        [
            0x629a292a,
            0x367cd507
        ],
        [
            0x9159015a,
            0x3070dd17
        ],
        [
            0x152fecd8,
            0xf70e5939
        ],
        [
            0x67332667,
            0xffc00b31
        ],
        [
            0x8eb44a87,
            0x68581511
        ],
        [
            0xdb0c2e0d,
            0x64f98fa7
        ],
        [
            0x47b5481d,
            0xbefa4fa4
        ]
    ];
    $eaa8d9141b3f9711$var$_states["SHA-512/256"] = [
        [
            0x22312194,
            0xFC2BF72C
        ],
        [
            0x9F555FA3,
            0xC84C64C2
        ],
        [
            0x2393B86B,
            0x6F53B151
        ],
        [
            0x96387719,
            0x5940EABD
        ],
        [
            0x96283EE2,
            0xA88EFFE3
        ],
        [
            0xBE5E1E25,
            0x53863992
        ],
        [
            0x2B0199FC,
            0x2C85B8AA
        ],
        [
            0x0EB72DDC,
            0x81C52CA2
        ]
    ];
    $eaa8d9141b3f9711$var$_states["SHA-512/224"] = [
        [
            0x8C3D37C8,
            0x19544DA2
        ],
        [
            0x73E19966,
            0x89DCD4D6
        ],
        [
            0x1DFAB7AE,
            0x32FF9C82
        ],
        [
            0x679DD514,
            0x582F9FCF
        ],
        [
            0x0F6D2B69,
            0x7BD44DA8
        ],
        [
            0x77E36F73,
            0x04C48942
        ],
        [
            0x3F9D85A8,
            0x6A1D36C8
        ],
        [
            0x1112E6AD,
            0x91D692A1
        ]
    ];
    // now initialized
    $eaa8d9141b3f9711$var$_initialized = true;
}
/**
 * Updates a SHA-512 state with the given byte buffer.
 *
 * @param s the SHA-512 state to update.
 * @param w the array to use to store words.
 * @param bytes the byte buffer to update with.
 */ function $eaa8d9141b3f9711$var$_update(s, w, bytes) {
    // consume 512 bit (128 byte) chunks
    var t1_hi, t1_lo;
    var t2_hi, t2_lo;
    var s0_hi, s0_lo;
    var s1_hi, s1_lo;
    var ch_hi, ch_lo;
    var maj_hi, maj_lo;
    var a_hi, a_lo;
    var b_hi, b_lo;
    var c_hi, c_lo;
    var d_hi, d_lo;
    var e_hi, e_lo;
    var f_hi, f_lo;
    var g_hi, g_lo;
    var h_hi, h_lo;
    var i, hi, lo, w2, w7, w15, w16;
    var len = bytes.length();
    while(len >= 128){
        // the w array will be populated with sixteen 64-bit big-endian words
        // and then extended into 64 64-bit words according to SHA-512
        for(i = 0; i < 16; ++i){
            w[i][0] = bytes.getInt32() >>> 0;
            w[i][1] = bytes.getInt32() >>> 0;
        }
        for(; i < 80; ++i){
            // for word 2 words ago: ROTR 19(x) ^ ROTR 61(x) ^ SHR 6(x)
            w2 = w[i - 2];
            hi = w2[0];
            lo = w2[1];
            // high bits
            t1_hi = ((hi >>> 19 | lo << 13) ^ // ROTR 19
            (lo >>> 29 | hi << 3) ^ // ROTR 61/(swap + ROTR 29)
            hi >>> 6) >>> 0; // SHR 6
            // low bits
            t1_lo = ((hi << 13 | lo >>> 19) ^ // ROTR 19
            (lo << 3 | hi >>> 29) ^ // ROTR 61/(swap + ROTR 29)
            (hi << 26 | lo >>> 6)) >>> 0; // SHR 6
            // for word 15 words ago: ROTR 1(x) ^ ROTR 8(x) ^ SHR 7(x)
            w15 = w[i - 15];
            hi = w15[0];
            lo = w15[1];
            // high bits
            t2_hi = ((hi >>> 1 | lo << 31) ^ // ROTR 1
            (hi >>> 8 | lo << 24) ^ // ROTR 8
            hi >>> 7) >>> 0; // SHR 7
            // low bits
            t2_lo = ((hi << 31 | lo >>> 1) ^ // ROTR 1
            (hi << 24 | lo >>> 8) ^ // ROTR 8
            (hi << 25 | lo >>> 7)) >>> 0; // SHR 7
            // sum(t1, word 7 ago, t2, word 16 ago) modulo 2^64 (carry lo overflow)
            w7 = w[i - 7];
            w16 = w[i - 16];
            lo = t1_lo + w7[1] + t2_lo + w16[1];
            w[i][0] = t1_hi + w7[0] + t2_hi + w16[0] + (lo / 0x100000000 >>> 0) >>> 0;
            w[i][1] = lo >>> 0;
        }
        // initialize hash value for this chunk
        a_hi = s[0][0];
        a_lo = s[0][1];
        b_hi = s[1][0];
        b_lo = s[1][1];
        c_hi = s[2][0];
        c_lo = s[2][1];
        d_hi = s[3][0];
        d_lo = s[3][1];
        e_hi = s[4][0];
        e_lo = s[4][1];
        f_hi = s[5][0];
        f_lo = s[5][1];
        g_hi = s[6][0];
        g_lo = s[6][1];
        h_hi = s[7][0];
        h_lo = s[7][1];
        // round function
        for(i = 0; i < 80; ++i){
            // Sum1(e) = ROTR 14(e) ^ ROTR 18(e) ^ ROTR 41(e)
            s1_hi = ((e_hi >>> 14 | e_lo << 18) ^ // ROTR 14
            (e_hi >>> 18 | e_lo << 14) ^ // ROTR 18
            (e_lo >>> 9 | e_hi << 23)) >>> 0; // ROTR 41/(swap + ROTR 9)
            s1_lo = ((e_hi << 18 | e_lo >>> 14) ^ // ROTR 14
            (e_hi << 14 | e_lo >>> 18) ^ // ROTR 18
            (e_lo << 23 | e_hi >>> 9)) >>> 0; // ROTR 41/(swap + ROTR 9)
            // Ch(e, f, g) (optimized the same way as SHA-1)
            ch_hi = (g_hi ^ e_hi & (f_hi ^ g_hi)) >>> 0;
            ch_lo = (g_lo ^ e_lo & (f_lo ^ g_lo)) >>> 0;
            // Sum0(a) = ROTR 28(a) ^ ROTR 34(a) ^ ROTR 39(a)
            s0_hi = ((a_hi >>> 28 | a_lo << 4) ^ // ROTR 28
            (a_lo >>> 2 | a_hi << 30) ^ // ROTR 34/(swap + ROTR 2)
            (a_lo >>> 7 | a_hi << 25)) >>> 0; // ROTR 39/(swap + ROTR 7)
            s0_lo = ((a_hi << 4 | a_lo >>> 28) ^ // ROTR 28
            (a_lo << 30 | a_hi >>> 2) ^ // ROTR 34/(swap + ROTR 2)
            (a_lo << 25 | a_hi >>> 7)) >>> 0; // ROTR 39/(swap + ROTR 7)
            // Maj(a, b, c) (optimized the same way as SHA-1)
            maj_hi = (a_hi & b_hi | c_hi & (a_hi ^ b_hi)) >>> 0;
            maj_lo = (a_lo & b_lo | c_lo & (a_lo ^ b_lo)) >>> 0;
            // main algorithm
            // t1 = (h + s1 + ch + _k[i] + _w[i]) modulo 2^64 (carry lo overflow)
            lo = h_lo + s1_lo + ch_lo + $eaa8d9141b3f9711$var$_k[i][1] + w[i][1];
            t1_hi = h_hi + s1_hi + ch_hi + $eaa8d9141b3f9711$var$_k[i][0] + w[i][0] + (lo / 0x100000000 >>> 0) >>> 0;
            t1_lo = lo >>> 0;
            // t2 = s0 + maj modulo 2^64 (carry lo overflow)
            lo = s0_lo + maj_lo;
            t2_hi = s0_hi + maj_hi + (lo / 0x100000000 >>> 0) >>> 0;
            t2_lo = lo >>> 0;
            h_hi = g_hi;
            h_lo = g_lo;
            g_hi = f_hi;
            g_lo = f_lo;
            f_hi = e_hi;
            f_lo = e_lo;
            // e = (d + t1) modulo 2^64 (carry lo overflow)
            lo = d_lo + t1_lo;
            e_hi = d_hi + t1_hi + (lo / 0x100000000 >>> 0) >>> 0;
            e_lo = lo >>> 0;
            d_hi = c_hi;
            d_lo = c_lo;
            c_hi = b_hi;
            c_lo = b_lo;
            b_hi = a_hi;
            b_lo = a_lo;
            // a = (t1 + t2) modulo 2^64 (carry lo overflow)
            lo = t1_lo + t2_lo;
            a_hi = t1_hi + t2_hi + (lo / 0x100000000 >>> 0) >>> 0;
            a_lo = lo >>> 0;
        }
        // update hash state (additional modulo 2^64)
        lo = s[0][1] + a_lo;
        s[0][0] = s[0][0] + a_hi + (lo / 0x100000000 >>> 0) >>> 0;
        s[0][1] = lo >>> 0;
        lo = s[1][1] + b_lo;
        s[1][0] = s[1][0] + b_hi + (lo / 0x100000000 >>> 0) >>> 0;
        s[1][1] = lo >>> 0;
        lo = s[2][1] + c_lo;
        s[2][0] = s[2][0] + c_hi + (lo / 0x100000000 >>> 0) >>> 0;
        s[2][1] = lo >>> 0;
        lo = s[3][1] + d_lo;
        s[3][0] = s[3][0] + d_hi + (lo / 0x100000000 >>> 0) >>> 0;
        s[3][1] = lo >>> 0;
        lo = s[4][1] + e_lo;
        s[4][0] = s[4][0] + e_hi + (lo / 0x100000000 >>> 0) >>> 0;
        s[4][1] = lo >>> 0;
        lo = s[5][1] + f_lo;
        s[5][0] = s[5][0] + f_hi + (lo / 0x100000000 >>> 0) >>> 0;
        s[5][1] = lo >>> 0;
        lo = s[6][1] + g_lo;
        s[6][0] = s[6][0] + g_hi + (lo / 0x100000000 >>> 0) >>> 0;
        s[6][1] = lo >>> 0;
        lo = s[7][1] + h_lo;
        s[7][0] = s[7][0] + h_hi + (lo / 0x100000000 >>> 0) >>> 0;
        s[7][1] = lo >>> 0;
        len -= 128;
    }
}

});

parcelRegister("jhDDh", function(module, exports) {

$parcel$export(module.exports, "privateKeyValidator", function () { return $e09e590f23634c3b$export$fed72f95cdc10258; }, function (v) { return $e09e590f23634c3b$export$fed72f95cdc10258 = v; });
$parcel$export(module.exports, "publicKeyValidator", function () { return $e09e590f23634c3b$export$16f1063872153885; }, function (v) { return $e09e590f23634c3b$export$16f1063872153885 = v; });
/**
 * Copyright (c) 2019 Digital Bazaar, Inc.
 */ var $e09e590f23634c3b$export$fed72f95cdc10258;
var $e09e590f23634c3b$export$16f1063872153885;

var $fz7FM = parcelRequire("fz7FM");
parcelRequire("d4EnE");
var $e09e590f23634c3b$var$asn1 = $fz7FM.asn1;
$e09e590f23634c3b$export$fed72f95cdc10258 = {
    // PrivateKeyInfo
    name: "PrivateKeyInfo",
    tagClass: $e09e590f23634c3b$var$asn1.Class.UNIVERSAL,
    type: $e09e590f23634c3b$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            // Version (INTEGER)
            name: "PrivateKeyInfo.version",
            tagClass: $e09e590f23634c3b$var$asn1.Class.UNIVERSAL,
            type: $e09e590f23634c3b$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "privateKeyVersion"
        },
        {
            // privateKeyAlgorithm
            name: "PrivateKeyInfo.privateKeyAlgorithm",
            tagClass: $e09e590f23634c3b$var$asn1.Class.UNIVERSAL,
            type: $e09e590f23634c3b$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    name: "AlgorithmIdentifier.algorithm",
                    tagClass: $e09e590f23634c3b$var$asn1.Class.UNIVERSAL,
                    type: $e09e590f23634c3b$var$asn1.Type.OID,
                    constructed: false,
                    capture: "privateKeyOid"
                }
            ]
        },
        {
            // PrivateKey
            name: "PrivateKeyInfo",
            tagClass: $e09e590f23634c3b$var$asn1.Class.UNIVERSAL,
            type: $e09e590f23634c3b$var$asn1.Type.OCTETSTRING,
            constructed: false,
            capture: "privateKey"
        }
    ]
};
$e09e590f23634c3b$export$16f1063872153885 = {
    name: "SubjectPublicKeyInfo",
    tagClass: $e09e590f23634c3b$var$asn1.Class.UNIVERSAL,
    type: $e09e590f23634c3b$var$asn1.Type.SEQUENCE,
    constructed: true,
    captureAsn1: "subjectPublicKeyInfo",
    value: [
        {
            name: "SubjectPublicKeyInfo.AlgorithmIdentifier",
            tagClass: $e09e590f23634c3b$var$asn1.Class.UNIVERSAL,
            type: $e09e590f23634c3b$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    name: "AlgorithmIdentifier.algorithm",
                    tagClass: $e09e590f23634c3b$var$asn1.Class.UNIVERSAL,
                    type: $e09e590f23634c3b$var$asn1.Type.OID,
                    constructed: false,
                    capture: "publicKeyOid"
                }
            ]
        },
        // capture group for ed25519PublicKey
        {
            tagClass: $e09e590f23634c3b$var$asn1.Class.UNIVERSAL,
            type: $e09e590f23634c3b$var$asn1.Type.BITSTRING,
            constructed: false,
            composed: true,
            captureBitStringValue: "ed25519PublicKey"
        }
    ]
};

});


parcelRegister("lejEO", function(module, exports) {
/**
 * Javascript implementation of RSA-KEM.
 *
 * @author Lautaro Cozzani Rodriguez
 * @author Dave Longley
 *
 * Copyright (c) 2014 Lautaro Cozzani <lautaro.cozzani@scytl.com>
 * Copyright (c) 2014 Digital Bazaar, Inc.
 */ 
var $fz7FM = parcelRequire("fz7FM");
parcelRequire("gao36");
parcelRequire("a65r1");
parcelRequire("dFOUo");
module.exports = $fz7FM.kem = $fz7FM.kem || {};
var $f74a2752d481465d$var$BigInteger = $fz7FM.jsbn.BigInteger;
/**
 * The API for the RSA Key Encapsulation Mechanism (RSA-KEM) from ISO 18033-2.
 */ $fz7FM.kem.rsa = {};
/**
 * Creates an RSA KEM API object for generating a secret asymmetric key.
 *
 * The symmetric key may be generated via a call to 'encrypt', which will
 * produce a ciphertext to be transmitted to the recipient and a key to be
 * kept secret. The ciphertext is a parameter to be passed to 'decrypt' which
 * will produce the same secret key for the recipient to use to decrypt a
 * message that was encrypted with the secret key.
 *
 * @param kdf the KDF API to use (eg: new forge.kem.kdf1()).
 * @param options the options to use.
 *          [prng] a custom crypto-secure pseudo-random number generator to use,
 *            that must define "getBytesSync".
 */ $fz7FM.kem.rsa.create = function(kdf, options) {
    options = options || {};
    var prng = options.prng || $fz7FM.random;
    var kem = {};
    /**
   * Generates a secret key and its encapsulation.
   *
   * @param publicKey the RSA public key to encrypt with.
   * @param keyLength the length, in bytes, of the secret key to generate.
   *
   * @return an object with:
   *   encapsulation: the ciphertext for generating the secret key, as a
   *     binary-encoded string of bytes.
   *   key: the secret key to use for encrypting a message.
   */ kem.encrypt = function(publicKey, keyLength) {
        // generate a random r where 1 < r < n
        var byteLength = Math.ceil(publicKey.n.bitLength() / 8);
        var r;
        do r = new $f74a2752d481465d$var$BigInteger($fz7FM.util.bytesToHex(prng.getBytesSync(byteLength)), 16).mod(publicKey.n);
        while (r.compareTo($f74a2752d481465d$var$BigInteger.ONE) <= 0);
        // prepend r with zeros
        r = $fz7FM.util.hexToBytes(r.toString(16));
        var zeros = byteLength - r.length;
        if (zeros > 0) r = $fz7FM.util.fillString(String.fromCharCode(0), zeros) + r;
        // encrypt the random
        var encapsulation = publicKey.encrypt(r, "NONE");
        // generate the secret key
        var key = kdf.generate(r, keyLength);
        return {
            encapsulation: encapsulation,
            key: key
        };
    };
    /**
   * Decrypts an encapsulated secret key.
   *
   * @param privateKey the RSA private key to decrypt with.
   * @param encapsulation the ciphertext for generating the secret key, as
   *          a binary-encoded string of bytes.
   * @param keyLength the length, in bytes, of the secret key to generate.
   *
   * @return the secret key as a binary-encoded string of bytes.
   */ kem.decrypt = function(privateKey, encapsulation, keyLength) {
        // decrypt the encapsulation and generate the secret key
        var r = privateKey.decrypt(encapsulation, "NONE");
        return kdf.generate(r, keyLength);
    };
    return kem;
};
// TODO: add forge.kem.kdf.create('KDF1', {md: ..., ...}) API?
/**
 * Creates a key derivation API object that implements KDF1 per ISO 18033-2.
 *
 * @param md the hash API to use.
 * @param [digestLength] an optional digest length that must be positive and
 *          less than or equal to md.digestLength.
 *
 * @return a KDF1 API object.
 */ $fz7FM.kem.kdf1 = function(md, digestLength) {
    $f74a2752d481465d$var$_createKDF(this, md, 0, digestLength || md.digestLength);
};
/**
 * Creates a key derivation API object that implements KDF2 per ISO 18033-2.
 *
 * @param md the hash API to use.
 * @param [digestLength] an optional digest length that must be positive and
 *          less than or equal to md.digestLength.
 *
 * @return a KDF2 API object.
 */ $fz7FM.kem.kdf2 = function(md, digestLength) {
    $f74a2752d481465d$var$_createKDF(this, md, 1, digestLength || md.digestLength);
};
/**
 * Creates a KDF1 or KDF2 API object.
 *
 * @param md the hash API to use.
 * @param counterStart the starting index for the counter.
 * @param digestLength the digest length to use.
 *
 * @return the KDF API object.
 */ function $f74a2752d481465d$var$_createKDF(kdf, md, counterStart, digestLength) {
    /**
   * Generate a key of the specified length.
   *
   * @param x the binary-encoded byte string to generate a key from.
   * @param length the number of bytes to generate (the size of the key).
   *
   * @return the key as a binary-encoded string.
   */ kdf.generate = function(x, length) {
        var key = new $fz7FM.util.ByteBuffer();
        // run counter from counterStart to ceil(length / Hash.len)
        var k = Math.ceil(length / digestLength) + counterStart;
        var c = new $fz7FM.util.ByteBuffer();
        for(var i = counterStart; i < k; ++i){
            // I2OSP(i, 4): convert counter to an octet string of 4 octets
            c.putInt32(i);
            // digest 'x' and the counter and add the result to the key
            md.start();
            md.update(x + c.getBytes());
            var hash = md.digest();
            key.putBytes(hash.getBytes(digestLength));
        }
        // truncate to the correct key length
        key.truncate(key.length() - length);
        return key.getBytes();
    };
}

});

parcelRegister("8Mfmm", function(module, exports) {
/**
 * Cross-browser support for logging in a web application.
 *
 * @author David I. Lehn <dlehn@digitalbazaar.com>
 *
 * Copyright (c) 2008-2013 Digital Bazaar, Inc.
 */ 
var $fz7FM = parcelRequire("fz7FM");
parcelRequire("gao36");
/* LOG API */ module.exports = $fz7FM.log = $fz7FM.log || {};
/**
 * Application logging system.
 *
 * Each logger level available as it's own function of the form:
 *   forge.log.level(category, args...)
 * The category is an arbitrary string, and the args are the same as
 * Firebug's console.log API. By default the call will be output as:
 *   'LEVEL [category] <args[0]>, args[1], ...'
 * This enables proper % formatting via the first argument.
 * Each category is enabled by default but can be enabled or disabled with
 * the setCategoryEnabled() function.
 */ // list of known levels
$fz7FM.log.levels = [
    "none",
    "error",
    "warning",
    "info",
    "debug",
    "verbose",
    "max"
];
// info on the levels indexed by name:
//   index: level index
//   name: uppercased display name
var $663eb88ade25ff00$var$sLevelInfo = {};
// list of loggers
var $663eb88ade25ff00$var$sLoggers = [];
/**
 * Standard console logger. If no console support is enabled this will
 * remain null. Check before using.
 */ var $663eb88ade25ff00$var$sConsoleLogger = null;
// logger flags
/**
 * Lock the level at the current value. Used in cases where user config may
 * set the level such that only critical messages are seen but more verbose
 * messages are needed for debugging or other purposes.
 */ $fz7FM.log.LEVEL_LOCKED = 2;
/**
 * Always call log function. By default, the logging system will check the
 * message level against logger.level before calling the log function. This
 * flag allows the function to do its own check.
 */ $fz7FM.log.NO_LEVEL_CHECK = 4;
/**
 * Perform message interpolation with the passed arguments. "%" style
 * fields in log messages will be replaced by arguments as needed. Some
 * loggers, such as Firebug, may do this automatically. The original log
 * message will be available as 'message' and the interpolated version will
 * be available as 'fullMessage'.
 */ $fz7FM.log.INTERPOLATE = 8;
// setup each log level
for(var $663eb88ade25ff00$var$i = 0; $663eb88ade25ff00$var$i < $fz7FM.log.levels.length; ++$663eb88ade25ff00$var$i){
    var $663eb88ade25ff00$var$level = $fz7FM.log.levels[$663eb88ade25ff00$var$i];
    $663eb88ade25ff00$var$sLevelInfo[$663eb88ade25ff00$var$level] = {
        index: $663eb88ade25ff00$var$i,
        name: $663eb88ade25ff00$var$level.toUpperCase()
    };
}
/**
 * Message logger. Will dispatch a message to registered loggers as needed.
 *
 * @param message message object
 */ $fz7FM.log.logMessage = function(message) {
    var messageLevelIndex = $663eb88ade25ff00$var$sLevelInfo[message.level].index;
    for(var i = 0; i < $663eb88ade25ff00$var$sLoggers.length; ++i){
        var logger = $663eb88ade25ff00$var$sLoggers[i];
        if (logger.flags & $fz7FM.log.NO_LEVEL_CHECK) logger.f(message);
        else {
            // get logger level
            var loggerLevelIndex = $663eb88ade25ff00$var$sLevelInfo[logger.level].index;
            // check level
            if (messageLevelIndex <= loggerLevelIndex) // message critical enough, call logger
            logger.f(logger, message);
        }
    }
};
/**
 * Sets the 'standard' key on a message object to:
 * "LEVEL [category] " + message
 *
 * @param message a message log object
 */ $fz7FM.log.prepareStandard = function(message) {
    if (!("standard" in message)) message.standard = $663eb88ade25ff00$var$sLevelInfo[message.level].name + //' ' + +message.timestamp +
    " [" + message.category + "] " + message.message;
};
/**
 * Sets the 'full' key on a message object to the original message
 * interpolated via % formatting with the message arguments.
 *
 * @param message a message log object.
 */ $fz7FM.log.prepareFull = function(message) {
    if (!("full" in message)) {
        // copy args and insert message at the front
        var args = [
            message.message
        ];
        args = args.concat([]);
        // format the message
        message.full = $fz7FM.util.format.apply(this, args);
    }
};
/**
 * Applies both preparseStandard() and prepareFull() to a message object and
 * store result in 'standardFull'.
 *
 * @param message a message log object.
 */ $fz7FM.log.prepareStandardFull = function(message) {
    if (!("standardFull" in message)) {
        // FIXME implement 'standardFull' logging
        $fz7FM.log.prepareStandard(message);
        message.standardFull = message.standard;
    }
};
// levels for which we want functions
var $663eb88ade25ff00$var$levels = [
    "error",
    "warning",
    "info",
    "debug",
    "verbose"
];
for(var $663eb88ade25ff00$var$i = 0; $663eb88ade25ff00$var$i < $663eb88ade25ff00$var$levels.length; ++$663eb88ade25ff00$var$i)// wrap in a function to ensure proper level var is passed
(function(level) {
    // create function for this level
    $fz7FM.log[level] = function(category, message /*, args...*/ ) {
        // convert arguments to real array, remove category and message
        var args = Array.prototype.slice.call(arguments).slice(2);
        // create message object
        // Note: interpolation and standard formatting is done lazily
        var msg = {
            timestamp: new Date(),
            level: level,
            category: category,
            message: message,
            "arguments": args
        };
        // process this message
        $fz7FM.log.logMessage(msg);
    };
})($663eb88ade25ff00$var$levels[$663eb88ade25ff00$var$i]);
/**
 * Creates a new logger with specified custom logging function.
 *
 * The logging function has a signature of:
 *   function(logger, message)
 * logger: current logger
 * message: object:
 *   level: level id
 *   category: category
 *   message: string message
 *   arguments: Array of extra arguments
 *   fullMessage: interpolated message and arguments if INTERPOLATE flag set
 *
 * @param logFunction a logging function which takes a log message object
 *          as a parameter.
 *
 * @return a logger object.
 */ $fz7FM.log.makeLogger = function(logFunction) {
    var logger = {
        flags: 0,
        f: logFunction
    };
    $fz7FM.log.setLevel(logger, "none");
    return logger;
};
/**
 * Sets the current log level on a logger.
 *
 * @param logger the target logger.
 * @param level the new maximum log level as a string.
 *
 * @return true if set, false if not.
 */ $fz7FM.log.setLevel = function(logger, level) {
    var rval = false;
    if (logger && !(logger.flags & $fz7FM.log.LEVEL_LOCKED)) for(var i = 0; i < $fz7FM.log.levels.length; ++i){
        var aValidLevel = $fz7FM.log.levels[i];
        if (level == aValidLevel) {
            // set level
            logger.level = level;
            rval = true;
            break;
        }
    }
    return rval;
};
/**
 * Locks the log level at its current value.
 *
 * @param logger the target logger.
 * @param lock boolean lock value, default to true.
 */ $fz7FM.log.lock = function(logger, lock) {
    if (typeof lock === "undefined" || lock) logger.flags |= $fz7FM.log.LEVEL_LOCKED;
    else logger.flags &= ~$fz7FM.log.LEVEL_LOCKED;
};
/**
 * Adds a logger.
 *
 * @param logger the logger object.
 */ $fz7FM.log.addLogger = function(logger) {
    $663eb88ade25ff00$var$sLoggers.push(logger);
};
// setup the console logger if possible, else create fake console.log
if (typeof console !== "undefined" && "log" in console) {
    var $663eb88ade25ff00$var$logger;
    if (console.error && console.warn && console.info && console.debug) {
        // looks like Firebug-style logging is available
        // level handlers map
        var $663eb88ade25ff00$var$levelHandlers = {
            error: console.error,
            warning: console.warn,
            info: console.info,
            debug: console.debug,
            verbose: console.debug
        };
        var $663eb88ade25ff00$var$f = function f(logger, message) {
            $fz7FM.log.prepareStandard(message);
            var handler = $663eb88ade25ff00$var$levelHandlers[message.level];
            // prepend standard message and concat args
            var args = [
                message.standard
            ];
            args = args.concat(message["arguments"].slice());
            // apply to low-level console function
            handler.apply(console, args);
        };
        $663eb88ade25ff00$var$logger = $fz7FM.log.makeLogger($663eb88ade25ff00$var$f);
    } else {
        // only appear to have basic console.log
        var $663eb88ade25ff00$var$f = function f(logger, message) {
            $fz7FM.log.prepareStandardFull(message);
            console.log(message.standardFull);
        };
        $663eb88ade25ff00$var$logger = $fz7FM.log.makeLogger($663eb88ade25ff00$var$f);
    }
    $fz7FM.log.setLevel($663eb88ade25ff00$var$logger, "debug");
    $fz7FM.log.addLogger($663eb88ade25ff00$var$logger);
    $663eb88ade25ff00$var$sConsoleLogger = $663eb88ade25ff00$var$logger;
} else // define fake console.log to avoid potential script errors on
// browsers that do not have console logging
console = {
    log: function log() {}
};
/*
 * Check for logging control query vars in current URL.
 *
 * console.level=<level-name>
 * Set's the console log level by name.  Useful to override defaults and
 * allow more verbose logging before a user config is loaded.
 *
 * console.lock=<true|false>
 * Lock the console log level at whatever level it is set at.  This is run
 * after console.level is processed.  Useful to force a level of verbosity
 * that could otherwise be limited by a user config.
 */ if ($663eb88ade25ff00$var$sConsoleLogger !== null && typeof window !== "undefined" && window.location) {
    var $663eb88ade25ff00$var$query = new URL(window.location.href).searchParams;
    if ($663eb88ade25ff00$var$query.has("console.level")) // set with last value
    $fz7FM.log.setLevel($663eb88ade25ff00$var$sConsoleLogger, $663eb88ade25ff00$var$query.get("console.level").slice(-1)[0]);
    if ($663eb88ade25ff00$var$query.has("console.lock")) {
        // set with last value
        var $663eb88ade25ff00$var$lock = $663eb88ade25ff00$var$query.get("console.lock").slice(-1)[0];
        if ($663eb88ade25ff00$var$lock == "true") $fz7FM.log.lock($663eb88ade25ff00$var$sConsoleLogger);
    }
}
// provide public access to console logger
$fz7FM.log.consoleLogger = $663eb88ade25ff00$var$sConsoleLogger;

});

parcelRegister("6c6HA", function(module, exports) {
/**
 * Node.js module for all known Forge message digests.
 *
 * @author Dave Longley
 *
 * Copyright 2011-2017 Digital Bazaar, Inc.
 */ 
module.exports = (parcelRequire("6NNT4"));
parcelRequire("bPSAM");
parcelRequire("1DNOR");
parcelRequire("go2xp");
parcelRequire("k95pK");

});

parcelRegister("dOZFj", function(module, exports) {
/**
 * Javascript implementation of PKCS#7 v1.5.
 *
 * @author Stefan Siegl
 * @author Dave Longley
 *
 * Copyright (c) 2012 Stefan Siegl <stesie@brokenpipe.de>
 * Copyright (c) 2012-2015 Digital Bazaar, Inc.
 *
 * Currently this implementation only supports ContentType of EnvelopedData,
 * EncryptedData, or SignedData at the root level. The top level elements may
 * contain only a ContentInfo of ContentType Data, i.e. plain data. Further
 * nesting is not (yet) supported.
 *
 * The Forge validators for PKCS #7's ASN.1 structures are available from
 * a separate file pkcs7asn1.js, since those are referenced from other
 * PKCS standards like PKCS #12.
 */ 
var $fz7FM = parcelRequire("fz7FM");
parcelRequire("60qK1");
parcelRequire("d4EnE");
parcelRequire("bhqHY");
parcelRequire("dm89c");
parcelRequire("8061v");
parcelRequire("2RJQB");
parcelRequire("a65r1");
parcelRequire("gao36");
parcelRequire("3c4BG");
// shortcut for ASN.1 API
var $a0ffc74c94d05282$var$asn1 = $fz7FM.asn1;
// shortcut for PKCS#7 API
var $a0ffc74c94d05282$var$p7 = module.exports = $fz7FM.pkcs7 = $fz7FM.pkcs7 || {};
/**
 * Converts a PKCS#7 message from PEM format.
 *
 * @param pem the PEM-formatted PKCS#7 message.
 *
 * @return the PKCS#7 message.
 */ $a0ffc74c94d05282$var$p7.messageFromPem = function(pem) {
    var msg = $fz7FM.pem.decode(pem)[0];
    if (msg.type !== "PKCS7") {
        var error = new Error('Could not convert PKCS#7 message from PEM; PEM header type is not "PKCS#7".');
        error.headerType = msg.type;
        throw error;
    }
    if (msg.procType && msg.procType.type === "ENCRYPTED") throw new Error("Could not convert PKCS#7 message from PEM; PEM is encrypted.");
    // convert DER to ASN.1 object
    var obj = $a0ffc74c94d05282$var$asn1.fromDer(msg.body);
    return $a0ffc74c94d05282$var$p7.messageFromAsn1(obj);
};
/**
 * Converts a PKCS#7 message to PEM format.
 *
 * @param msg The PKCS#7 message object
 * @param maxline The maximum characters per line, defaults to 64.
 *
 * @return The PEM-formatted PKCS#7 message.
 */ $a0ffc74c94d05282$var$p7.messageToPem = function(msg, maxline) {
    // convert to ASN.1, then DER, then PEM-encode
    var pemObj = {
        type: "PKCS7",
        body: $a0ffc74c94d05282$var$asn1.toDer(msg.toAsn1()).getBytes()
    };
    return $fz7FM.pem.encode(pemObj, {
        maxline: maxline
    });
};
/**
 * Converts a PKCS#7 message from an ASN.1 object.
 *
 * @param obj the ASN.1 representation of a ContentInfo.
 *
 * @return the PKCS#7 message.
 */ $a0ffc74c94d05282$var$p7.messageFromAsn1 = function(obj) {
    // validate root level ContentInfo and capture data
    var capture = {};
    var errors = [];
    if (!$a0ffc74c94d05282$var$asn1.validate(obj, $a0ffc74c94d05282$var$p7.asn1.contentInfoValidator, capture, errors)) {
        var error = new Error("Cannot read PKCS#7 message. ASN.1 object is not an PKCS#7 ContentInfo.");
        error.errors = errors;
        throw error;
    }
    var contentType = $a0ffc74c94d05282$var$asn1.derToOid(capture.contentType);
    var msg;
    switch(contentType){
        case $fz7FM.pki.oids.envelopedData:
            msg = $a0ffc74c94d05282$var$p7.createEnvelopedData();
            break;
        case $fz7FM.pki.oids.encryptedData:
            msg = $a0ffc74c94d05282$var$p7.createEncryptedData();
            break;
        case $fz7FM.pki.oids.signedData:
            msg = $a0ffc74c94d05282$var$p7.createSignedData();
            break;
        default:
            throw new Error("Cannot read PKCS#7 message. ContentType with OID " + contentType + " is not (yet) supported.");
    }
    msg.fromAsn1(capture.content.value[0]);
    return msg;
};
$a0ffc74c94d05282$var$p7.createSignedData = function() {
    var msg = null;
    msg = {
        type: $fz7FM.pki.oids.signedData,
        version: 1,
        certificates: [],
        crls: [],
        // TODO: add json-formatted signer stuff here?
        signers: [],
        // populated during sign()
        digestAlgorithmIdentifiers: [],
        contentInfo: null,
        signerInfos: [],
        fromAsn1: function fromAsn1(obj) {
            // validate SignedData content block and capture data.
            $a0ffc74c94d05282$var$_fromAsn1(msg, obj, $a0ffc74c94d05282$var$p7.asn1.signedDataValidator);
            msg.certificates = [];
            msg.crls = [];
            msg.digestAlgorithmIdentifiers = [];
            msg.contentInfo = null;
            msg.signerInfos = [];
            if (msg.rawCapture.certificates) {
                var certs = msg.rawCapture.certificates.value;
                for(var i = 0; i < certs.length; ++i)msg.certificates.push($fz7FM.pki.certificateFromAsn1(certs[i]));
            }
        // TODO: parse crls
        },
        toAsn1: function toAsn1() {
            // degenerate case with no content
            if (!msg.contentInfo) msg.sign();
            var certs = [];
            for(var i = 0; i < msg.certificates.length; ++i)certs.push($fz7FM.pki.certificateToAsn1(msg.certificates[i]));
            var crls = [];
            // TODO: implement CRLs
            // [0] SignedData
            var signedData = $a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, [
                $a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.UNIVERSAL, $a0ffc74c94d05282$var$asn1.Type.SEQUENCE, true, [
                    // Version
                    $a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.UNIVERSAL, $a0ffc74c94d05282$var$asn1.Type.INTEGER, false, $a0ffc74c94d05282$var$asn1.integerToDer(msg.version).getBytes()),
                    // DigestAlgorithmIdentifiers
                    $a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.UNIVERSAL, $a0ffc74c94d05282$var$asn1.Type.SET, true, msg.digestAlgorithmIdentifiers),
                    // ContentInfo
                    msg.contentInfo
                ])
            ]);
            if (certs.length > 0) // [0] IMPLICIT ExtendedCertificatesAndCertificates OPTIONAL
            signedData.value[0].value.push($a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, certs));
            if (crls.length > 0) // [1] IMPLICIT CertificateRevocationLists OPTIONAL
            signedData.value[0].value.push($a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.CONTEXT_SPECIFIC, 1, true, crls));
            // SignerInfos
            signedData.value[0].value.push($a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.UNIVERSAL, $a0ffc74c94d05282$var$asn1.Type.SET, true, msg.signerInfos));
            // ContentInfo
            return $a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.UNIVERSAL, $a0ffc74c94d05282$var$asn1.Type.SEQUENCE, true, [
                // ContentType
                $a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.UNIVERSAL, $a0ffc74c94d05282$var$asn1.Type.OID, false, $a0ffc74c94d05282$var$asn1.oidToDer(msg.type).getBytes()),
                // [0] SignedData
                signedData
            ]);
        },
        /**
     * Add (another) entity to list of signers.
     *
     * Note: If authenticatedAttributes are provided, then, per RFC 2315,
     * they must include at least two attributes: content type and
     * message digest. The message digest attribute value will be
     * auto-calculated during signing and will be ignored if provided.
     *
     * Here's an example of providing these two attributes:
     *
     * forge.pkcs7.createSignedData();
     * p7.addSigner({
     *   issuer: cert.issuer.attributes,
     *   serialNumber: cert.serialNumber,
     *   key: privateKey,
     *   digestAlgorithm: forge.pki.oids.sha1,
     *   authenticatedAttributes: [{
     *     type: forge.pki.oids.contentType,
     *     value: forge.pki.oids.data
     *   }, {
     *     type: forge.pki.oids.messageDigest
     *   }]
     * });
     *
     * TODO: Support [subjectKeyIdentifier] as signer's ID.
     *
     * @param signer the signer information:
     *          key the signer's private key.
     *          [certificate] a certificate containing the public key
     *            associated with the signer's private key; use this option as
     *            an alternative to specifying signer.issuer and
     *            signer.serialNumber.
     *          [issuer] the issuer attributes (eg: cert.issuer.attributes).
     *          [serialNumber] the signer's certificate's serial number in
     *           hexadecimal (eg: cert.serialNumber).
     *          [digestAlgorithm] the message digest OID, as a string, to use
     *            (eg: forge.pki.oids.sha1).
     *          [authenticatedAttributes] an optional array of attributes
     *            to also sign along with the content.
     */ addSigner: function addSigner(signer) {
            var issuer = signer.issuer;
            var serialNumber = signer.serialNumber;
            if (signer.certificate) {
                var cert = signer.certificate;
                if (typeof cert === "string") cert = $fz7FM.pki.certificateFromPem(cert);
                issuer = cert.issuer.attributes;
                serialNumber = cert.serialNumber;
            }
            var key = signer.key;
            if (!key) throw new Error("Could not add PKCS#7 signer; no private key specified.");
            if (typeof key === "string") key = $fz7FM.pki.privateKeyFromPem(key);
            // ensure OID known for digest algorithm
            var digestAlgorithm = signer.digestAlgorithm || $fz7FM.pki.oids.sha1;
            switch(digestAlgorithm){
                case $fz7FM.pki.oids.sha1:
                case $fz7FM.pki.oids.sha256:
                case $fz7FM.pki.oids.sha384:
                case $fz7FM.pki.oids.sha512:
                case $fz7FM.pki.oids.md5:
                    break;
                default:
                    throw new Error("Could not add PKCS#7 signer; unknown message digest algorithm: " + digestAlgorithm);
            }
            // if authenticatedAttributes is present, then the attributes
            // must contain at least PKCS #9 content-type and message-digest
            var authenticatedAttributes = signer.authenticatedAttributes || [];
            if (authenticatedAttributes.length > 0) {
                var contentType = false;
                var messageDigest = false;
                for(var i = 0; i < authenticatedAttributes.length; ++i){
                    var attr = authenticatedAttributes[i];
                    if (!contentType && attr.type === $fz7FM.pki.oids.contentType) {
                        contentType = true;
                        if (messageDigest) break;
                        continue;
                    }
                    if (!messageDigest && attr.type === $fz7FM.pki.oids.messageDigest) {
                        messageDigest = true;
                        if (contentType) break;
                        continue;
                    }
                }
                if (!contentType || !messageDigest) throw new Error("Invalid signer.authenticatedAttributes. If signer.authenticatedAttributes is specified, then it must contain at least two attributes, PKCS #9 content-type and PKCS #9 message-digest.");
            }
            msg.signers.push({
                key: key,
                version: 1,
                issuer: issuer,
                serialNumber: serialNumber,
                digestAlgorithm: digestAlgorithm,
                signatureAlgorithm: $fz7FM.pki.oids.rsaEncryption,
                signature: null,
                authenticatedAttributes: authenticatedAttributes,
                unauthenticatedAttributes: []
            });
        },
        /**
     * Signs the content.
     * @param options Options to apply when signing:
     *    [detached] boolean. If signing should be done in detached mode. Defaults to false.
     */ sign: function sign(options) {
            options = options || {};
            // auto-generate content info
            if (typeof msg.content !== "object" || msg.contentInfo === null) {
                // use Data ContentInfo
                msg.contentInfo = $a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.UNIVERSAL, $a0ffc74c94d05282$var$asn1.Type.SEQUENCE, true, [
                    // ContentType
                    $a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.UNIVERSAL, $a0ffc74c94d05282$var$asn1.Type.OID, false, $a0ffc74c94d05282$var$asn1.oidToDer($fz7FM.pki.oids.data).getBytes())
                ]);
                // add actual content, if present
                if ("content" in msg) {
                    var content;
                    if (msg.content instanceof $fz7FM.util.ByteBuffer) content = msg.content.bytes();
                    else if (typeof msg.content === "string") content = $fz7FM.util.encodeUtf8(msg.content);
                    if (options.detached) msg.detachedContent = $a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.UNIVERSAL, $a0ffc74c94d05282$var$asn1.Type.OCTETSTRING, false, content);
                    else msg.contentInfo.value.push(// [0] EXPLICIT content
                    $a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, [
                        $a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.UNIVERSAL, $a0ffc74c94d05282$var$asn1.Type.OCTETSTRING, false, content)
                    ]));
                }
            }
            // no signers, return early (degenerate case for certificate container)
            if (msg.signers.length === 0) return;
            // generate digest algorithm identifiers
            var mds = addDigestAlgorithmIds();
            // generate signerInfos
            addSignerInfos(mds);
        },
        verify: function verify() {
            throw new Error("PKCS#7 signature verification not yet implemented.");
        },
        /**
     * Add a certificate.
     *
     * @param cert the certificate to add.
     */ addCertificate: function addCertificate(cert) {
            // convert from PEM
            if (typeof cert === "string") cert = $fz7FM.pki.certificateFromPem(cert);
            msg.certificates.push(cert);
        },
        /**
     * Add a certificate revokation list.
     *
     * @param crl the certificate revokation list to add.
     */ addCertificateRevokationList: function addCertificateRevokationList(crl) {
            throw new Error("PKCS#7 CRL support not yet implemented.");
        }
    };
    return msg;
    function addDigestAlgorithmIds() {
        var mds = {};
        for(var i = 0; i < msg.signers.length; ++i){
            var signer = msg.signers[i];
            var oid = signer.digestAlgorithm;
            if (!(oid in mds)) // content digest
            mds[oid] = $fz7FM.md[$fz7FM.pki.oids[oid]].create();
            if (signer.authenticatedAttributes.length === 0) // no custom attributes to digest; use content message digest
            signer.md = mds[oid];
            else // custom attributes to be digested; use own message digest
            // TODO: optimize to just copy message digest state if that
            // feature is ever supported with message digests
            signer.md = $fz7FM.md[$fz7FM.pki.oids[oid]].create();
        }
        // add unique digest algorithm identifiers
        msg.digestAlgorithmIdentifiers = [];
        for(var oid in mds)msg.digestAlgorithmIdentifiers.push(// AlgorithmIdentifier
        $a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.UNIVERSAL, $a0ffc74c94d05282$var$asn1.Type.SEQUENCE, true, [
            // algorithm
            $a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.UNIVERSAL, $a0ffc74c94d05282$var$asn1.Type.OID, false, $a0ffc74c94d05282$var$asn1.oidToDer(oid).getBytes()),
            // parameters (null)
            $a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.UNIVERSAL, $a0ffc74c94d05282$var$asn1.Type.NULL, false, "")
        ]));
        return mds;
    }
    function addSignerInfos(mds) {
        var content;
        if (msg.detachedContent) // Signature has been made in detached mode.
        content = msg.detachedContent;
        else {
            // Note: ContentInfo is a SEQUENCE with 2 values, second value is
            // the content field and is optional for a ContentInfo but required here
            // since signers are present
            // get ContentInfo content
            content = msg.contentInfo.value[1];
            // skip [0] EXPLICIT content wrapper
            content = content.value[0];
        }
        if (!content) throw new Error("Could not sign PKCS#7 message; there is no content to sign.");
        // get ContentInfo content type
        var contentType = $a0ffc74c94d05282$var$asn1.derToOid(msg.contentInfo.value[0].value);
        // serialize content
        var bytes = $a0ffc74c94d05282$var$asn1.toDer(content);
        // skip identifier and length per RFC 2315 9.3
        // skip identifier (1 byte)
        bytes.getByte();
        // read and discard length bytes
        $a0ffc74c94d05282$var$asn1.getBerValueLength(bytes);
        bytes = bytes.getBytes();
        // digest content DER value bytes
        for(var oid in mds)mds[oid].start().update(bytes);
        // sign content
        var signingTime = new Date();
        for(var i = 0; i < msg.signers.length; ++i){
            var signer = msg.signers[i];
            if (signer.authenticatedAttributes.length === 0) {
                // if ContentInfo content type is not "Data", then
                // authenticatedAttributes must be present per RFC 2315
                if (contentType !== $fz7FM.pki.oids.data) throw new Error("Invalid signer; authenticatedAttributes must be present when the ContentInfo content type is not PKCS#7 Data.");
            } else {
                // process authenticated attributes
                // [0] IMPLICIT
                signer.authenticatedAttributesAsn1 = $a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, []);
                // per RFC 2315, attributes are to be digested using a SET container
                // not the above [0] IMPLICIT container
                var attrsAsn1 = $a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.UNIVERSAL, $a0ffc74c94d05282$var$asn1.Type.SET, true, []);
                for(var ai = 0; ai < signer.authenticatedAttributes.length; ++ai){
                    var attr = signer.authenticatedAttributes[ai];
                    if (attr.type === $fz7FM.pki.oids.messageDigest) // use content message digest as value
                    attr.value = mds[signer.digestAlgorithm].digest();
                    else if (attr.type === $fz7FM.pki.oids.signingTime) // auto-populate signing time if not already set
                    {
                        if (!attr.value) attr.value = signingTime;
                    }
                    // convert to ASN.1 and push onto Attributes SET (for signing) and
                    // onto authenticatedAttributesAsn1 to complete SignedData ASN.1
                    // TODO: optimize away duplication
                    attrsAsn1.value.push($a0ffc74c94d05282$var$_attributeToAsn1(attr));
                    signer.authenticatedAttributesAsn1.value.push($a0ffc74c94d05282$var$_attributeToAsn1(attr));
                }
                // DER-serialize and digest SET OF attributes only
                bytes = $a0ffc74c94d05282$var$asn1.toDer(attrsAsn1).getBytes();
                signer.md.start().update(bytes);
            }
            // sign digest
            signer.signature = signer.key.sign(signer.md, "RSASSA-PKCS1-V1_5");
        }
        // add signer info
        msg.signerInfos = $a0ffc74c94d05282$var$_signersToAsn1(msg.signers);
    }
};
/**
 * Creates an empty PKCS#7 message of type EncryptedData.
 *
 * @return the message.
 */ $a0ffc74c94d05282$var$p7.createEncryptedData = function() {
    var msg = null;
    msg = {
        type: $fz7FM.pki.oids.encryptedData,
        version: 0,
        encryptedContent: {
            algorithm: $fz7FM.pki.oids["aes256-CBC"]
        },
        /**
     * Reads an EncryptedData content block (in ASN.1 format)
     *
     * @param obj The ASN.1 representation of the EncryptedData content block
     */ fromAsn1: function fromAsn1(obj) {
            // Validate EncryptedData content block and capture data.
            $a0ffc74c94d05282$var$_fromAsn1(msg, obj, $a0ffc74c94d05282$var$p7.asn1.encryptedDataValidator);
        },
        /**
     * Decrypt encrypted content
     *
     * @param key The (symmetric) key as a byte buffer
     */ decrypt: function decrypt(key) {
            if (key !== undefined) msg.encryptedContent.key = key;
            $a0ffc74c94d05282$var$_decryptContent(msg);
        }
    };
    return msg;
};
/**
 * Creates an empty PKCS#7 message of type EnvelopedData.
 *
 * @return the message.
 */ $a0ffc74c94d05282$var$p7.createEnvelopedData = function() {
    var msg = null;
    msg = {
        type: $fz7FM.pki.oids.envelopedData,
        version: 0,
        recipients: [],
        encryptedContent: {
            algorithm: $fz7FM.pki.oids["aes256-CBC"]
        },
        /**
     * Reads an EnvelopedData content block (in ASN.1 format)
     *
     * @param obj the ASN.1 representation of the EnvelopedData content block.
     */ fromAsn1: function fromAsn1(obj) {
            // validate EnvelopedData content block and capture data
            var capture = $a0ffc74c94d05282$var$_fromAsn1(msg, obj, $a0ffc74c94d05282$var$p7.asn1.envelopedDataValidator);
            msg.recipients = $a0ffc74c94d05282$var$_recipientsFromAsn1(capture.recipientInfos.value);
        },
        toAsn1: function toAsn1() {
            // ContentInfo
            return $a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.UNIVERSAL, $a0ffc74c94d05282$var$asn1.Type.SEQUENCE, true, [
                // ContentType
                $a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.UNIVERSAL, $a0ffc74c94d05282$var$asn1.Type.OID, false, $a0ffc74c94d05282$var$asn1.oidToDer(msg.type).getBytes()),
                // [0] EnvelopedData
                $a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, [
                    $a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.UNIVERSAL, $a0ffc74c94d05282$var$asn1.Type.SEQUENCE, true, [
                        // Version
                        $a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.UNIVERSAL, $a0ffc74c94d05282$var$asn1.Type.INTEGER, false, $a0ffc74c94d05282$var$asn1.integerToDer(msg.version).getBytes()),
                        // RecipientInfos
                        $a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.UNIVERSAL, $a0ffc74c94d05282$var$asn1.Type.SET, true, $a0ffc74c94d05282$var$_recipientsToAsn1(msg.recipients)),
                        // EncryptedContentInfo
                        $a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.UNIVERSAL, $a0ffc74c94d05282$var$asn1.Type.SEQUENCE, true, $a0ffc74c94d05282$var$_encryptedContentToAsn1(msg.encryptedContent))
                    ])
                ])
            ]);
        },
        /**
     * Find recipient by X.509 certificate's issuer.
     *
     * @param cert the certificate with the issuer to look for.
     *
     * @return the recipient object.
     */ findRecipient: function findRecipient(cert) {
            var sAttr = cert.issuer.attributes;
            for(var i = 0; i < msg.recipients.length; ++i){
                var r = msg.recipients[i];
                var rAttr = r.issuer;
                if (r.serialNumber !== cert.serialNumber) continue;
                if (rAttr.length !== sAttr.length) continue;
                var match = true;
                for(var j = 0; j < sAttr.length; ++j)if (rAttr[j].type !== sAttr[j].type || rAttr[j].value !== sAttr[j].value) {
                    match = false;
                    break;
                }
                if (match) return r;
            }
            return null;
        },
        /**
     * Decrypt enveloped content
     *
     * @param recipient The recipient object related to the private key
     * @param privKey The (RSA) private key object
     */ decrypt: function decrypt(recipient, privKey) {
            if (msg.encryptedContent.key === undefined && recipient !== undefined && privKey !== undefined) switch(recipient.encryptedContent.algorithm){
                case $fz7FM.pki.oids.rsaEncryption:
                case $fz7FM.pki.oids.desCBC:
                    var key = privKey.decrypt(recipient.encryptedContent.content);
                    msg.encryptedContent.key = $fz7FM.util.createBuffer(key);
                    break;
                default:
                    throw new Error("Unsupported asymmetric cipher, OID " + recipient.encryptedContent.algorithm);
            }
            $a0ffc74c94d05282$var$_decryptContent(msg);
        },
        /**
     * Add (another) entity to list of recipients.
     *
     * @param cert The certificate of the entity to add.
     */ addRecipient: function addRecipient(cert) {
            msg.recipients.push({
                version: 0,
                issuer: cert.issuer.attributes,
                serialNumber: cert.serialNumber,
                encryptedContent: {
                    // We simply assume rsaEncryption here, since forge.pki only
                    // supports RSA so far.  If the PKI module supports other
                    // ciphers one day, we need to modify this one as well.
                    algorithm: $fz7FM.pki.oids.rsaEncryption,
                    key: cert.publicKey
                }
            });
        },
        /**
     * Encrypt enveloped content.
     *
     * This function supports two optional arguments, cipher and key, which
     * can be used to influence symmetric encryption.  Unless cipher is
     * provided, the cipher specified in encryptedContent.algorithm is used
     * (defaults to AES-256-CBC).  If no key is provided, encryptedContent.key
     * is (re-)used.  If that one's not set, a random key will be generated
     * automatically.
     *
     * @param [key] The key to be used for symmetric encryption.
     * @param [cipher] The OID of the symmetric cipher to use.
     */ encrypt: function encrypt(key, cipher) {
            // Part 1: Symmetric encryption
            if (msg.encryptedContent.content === undefined) {
                cipher = cipher || msg.encryptedContent.algorithm;
                key = key || msg.encryptedContent.key;
                var keyLen, ivLen, ciphFn;
                switch(cipher){
                    case $fz7FM.pki.oids["aes128-CBC"]:
                        keyLen = 16;
                        ivLen = 16;
                        ciphFn = $fz7FM.aes.createEncryptionCipher;
                        break;
                    case $fz7FM.pki.oids["aes192-CBC"]:
                        keyLen = 24;
                        ivLen = 16;
                        ciphFn = $fz7FM.aes.createEncryptionCipher;
                        break;
                    case $fz7FM.pki.oids["aes256-CBC"]:
                        keyLen = 32;
                        ivLen = 16;
                        ciphFn = $fz7FM.aes.createEncryptionCipher;
                        break;
                    case $fz7FM.pki.oids["des-EDE3-CBC"]:
                        keyLen = 24;
                        ivLen = 8;
                        ciphFn = $fz7FM.des.createEncryptionCipher;
                        break;
                    default:
                        throw new Error("Unsupported symmetric cipher, OID " + cipher);
                }
                if (key === undefined) key = $fz7FM.util.createBuffer($fz7FM.random.getBytes(keyLen));
                else if (key.length() != keyLen) throw new Error("Symmetric key has wrong length; got " + key.length() + " bytes, expected " + keyLen + ".");
                // Keep a copy of the key & IV in the object, so the caller can
                // use it for whatever reason.
                msg.encryptedContent.algorithm = cipher;
                msg.encryptedContent.key = key;
                msg.encryptedContent.parameter = $fz7FM.util.createBuffer($fz7FM.random.getBytes(ivLen));
                var ciph = ciphFn(key);
                ciph.start(msg.encryptedContent.parameter.copy());
                ciph.update(msg.content);
                // The finish function does PKCS#7 padding by default, therefore
                // no action required by us.
                if (!ciph.finish()) throw new Error("Symmetric encryption failed.");
                msg.encryptedContent.content = ciph.output;
            }
            // Part 2: asymmetric encryption for each recipient
            for(var i = 0; i < msg.recipients.length; ++i){
                var recipient = msg.recipients[i];
                // Nothing to do, encryption already done.
                if (recipient.encryptedContent.content !== undefined) continue;
                switch(recipient.encryptedContent.algorithm){
                    case $fz7FM.pki.oids.rsaEncryption:
                        recipient.encryptedContent.content = recipient.encryptedContent.key.encrypt(msg.encryptedContent.key.data);
                        break;
                    default:
                        throw new Error("Unsupported asymmetric cipher, OID " + recipient.encryptedContent.algorithm);
                }
            }
        }
    };
    return msg;
};
/**
 * Converts a single recipient from an ASN.1 object.
 *
 * @param obj the ASN.1 RecipientInfo.
 *
 * @return the recipient object.
 */ function $a0ffc74c94d05282$var$_recipientFromAsn1(obj) {
    // validate EnvelopedData content block and capture data
    var capture = {};
    var errors = [];
    if (!$a0ffc74c94d05282$var$asn1.validate(obj, $a0ffc74c94d05282$var$p7.asn1.recipientInfoValidator, capture, errors)) {
        var error = new Error("Cannot read PKCS#7 RecipientInfo. ASN.1 object is not an PKCS#7 RecipientInfo.");
        error.errors = errors;
        throw error;
    }
    return {
        version: capture.version.charCodeAt(0),
        issuer: $fz7FM.pki.RDNAttributesAsArray(capture.issuer),
        serialNumber: $fz7FM.util.createBuffer(capture.serial).toHex(),
        encryptedContent: {
            algorithm: $a0ffc74c94d05282$var$asn1.derToOid(capture.encAlgorithm),
            parameter: capture.encParameter ? capture.encParameter.value : undefined,
            content: capture.encKey
        }
    };
}
/**
 * Converts a single recipient object to an ASN.1 object.
 *
 * @param obj the recipient object.
 *
 * @return the ASN.1 RecipientInfo.
 */ function $a0ffc74c94d05282$var$_recipientToAsn1(obj) {
    return $a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.UNIVERSAL, $a0ffc74c94d05282$var$asn1.Type.SEQUENCE, true, [
        // Version
        $a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.UNIVERSAL, $a0ffc74c94d05282$var$asn1.Type.INTEGER, false, $a0ffc74c94d05282$var$asn1.integerToDer(obj.version).getBytes()),
        // IssuerAndSerialNumber
        $a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.UNIVERSAL, $a0ffc74c94d05282$var$asn1.Type.SEQUENCE, true, [
            // Name
            $fz7FM.pki.distinguishedNameToAsn1({
                attributes: obj.issuer
            }),
            // Serial
            $a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.UNIVERSAL, $a0ffc74c94d05282$var$asn1.Type.INTEGER, false, $fz7FM.util.hexToBytes(obj.serialNumber))
        ]),
        // KeyEncryptionAlgorithmIdentifier
        $a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.UNIVERSAL, $a0ffc74c94d05282$var$asn1.Type.SEQUENCE, true, [
            // Algorithm
            $a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.UNIVERSAL, $a0ffc74c94d05282$var$asn1.Type.OID, false, $a0ffc74c94d05282$var$asn1.oidToDer(obj.encryptedContent.algorithm).getBytes()),
            // Parameter, force NULL, only RSA supported for now.
            $a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.UNIVERSAL, $a0ffc74c94d05282$var$asn1.Type.NULL, false, "")
        ]),
        // EncryptedKey
        $a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.UNIVERSAL, $a0ffc74c94d05282$var$asn1.Type.OCTETSTRING, false, obj.encryptedContent.content)
    ]);
}
/**
 * Map a set of RecipientInfo ASN.1 objects to recipient objects.
 *
 * @param infos an array of ASN.1 representations RecipientInfo (i.e. SET OF).
 *
 * @return an array of recipient objects.
 */ function $a0ffc74c94d05282$var$_recipientsFromAsn1(infos) {
    var ret = [];
    for(var i = 0; i < infos.length; ++i)ret.push($a0ffc74c94d05282$var$_recipientFromAsn1(infos[i]));
    return ret;
}
/**
 * Map an array of recipient objects to ASN.1 RecipientInfo objects.
 *
 * @param recipients an array of recipientInfo objects.
 *
 * @return an array of ASN.1 RecipientInfos.
 */ function $a0ffc74c94d05282$var$_recipientsToAsn1(recipients) {
    var ret = [];
    for(var i = 0; i < recipients.length; ++i)ret.push($a0ffc74c94d05282$var$_recipientToAsn1(recipients[i]));
    return ret;
}
/**
 * Converts a single signer from an ASN.1 object.
 *
 * @param obj the ASN.1 representation of a SignerInfo.
 *
 * @return the signer object.
 */ function $a0ffc74c94d05282$var$_signerFromAsn1(obj) {
    // validate EnvelopedData content block and capture data
    var capture = {};
    var errors = [];
    if (!$a0ffc74c94d05282$var$asn1.validate(obj, $a0ffc74c94d05282$var$p7.asn1.signerInfoValidator, capture, errors)) {
        var error = new Error("Cannot read PKCS#7 SignerInfo. ASN.1 object is not an PKCS#7 SignerInfo.");
        error.errors = errors;
        throw error;
    }
    var rval = {
        version: capture.version.charCodeAt(0),
        issuer: $fz7FM.pki.RDNAttributesAsArray(capture.issuer),
        serialNumber: $fz7FM.util.createBuffer(capture.serial).toHex(),
        digestAlgorithm: $a0ffc74c94d05282$var$asn1.derToOid(capture.digestAlgorithm),
        signatureAlgorithm: $a0ffc74c94d05282$var$asn1.derToOid(capture.signatureAlgorithm),
        signature: capture.signature,
        authenticatedAttributes: [],
        unauthenticatedAttributes: []
    };
    // TODO: convert attributes
    var authenticatedAttributes = capture.authenticatedAttributes || [];
    var unauthenticatedAttributes = capture.unauthenticatedAttributes || [];
    return rval;
}
/**
 * Converts a single signerInfo object to an ASN.1 object.
 *
 * @param obj the signerInfo object.
 *
 * @return the ASN.1 representation of a SignerInfo.
 */ function $a0ffc74c94d05282$var$_signerToAsn1(obj) {
    // SignerInfo
    var rval = $a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.UNIVERSAL, $a0ffc74c94d05282$var$asn1.Type.SEQUENCE, true, [
        // version
        $a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.UNIVERSAL, $a0ffc74c94d05282$var$asn1.Type.INTEGER, false, $a0ffc74c94d05282$var$asn1.integerToDer(obj.version).getBytes()),
        // issuerAndSerialNumber
        $a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.UNIVERSAL, $a0ffc74c94d05282$var$asn1.Type.SEQUENCE, true, [
            // name
            $fz7FM.pki.distinguishedNameToAsn1({
                attributes: obj.issuer
            }),
            // serial
            $a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.UNIVERSAL, $a0ffc74c94d05282$var$asn1.Type.INTEGER, false, $fz7FM.util.hexToBytes(obj.serialNumber))
        ]),
        // digestAlgorithm
        $a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.UNIVERSAL, $a0ffc74c94d05282$var$asn1.Type.SEQUENCE, true, [
            // algorithm
            $a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.UNIVERSAL, $a0ffc74c94d05282$var$asn1.Type.OID, false, $a0ffc74c94d05282$var$asn1.oidToDer(obj.digestAlgorithm).getBytes()),
            // parameters (null)
            $a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.UNIVERSAL, $a0ffc74c94d05282$var$asn1.Type.NULL, false, "")
        ])
    ]);
    // authenticatedAttributes (OPTIONAL)
    if (obj.authenticatedAttributesAsn1) // add ASN.1 previously generated during signing
    rval.value.push(obj.authenticatedAttributesAsn1);
    // digestEncryptionAlgorithm
    rval.value.push($a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.UNIVERSAL, $a0ffc74c94d05282$var$asn1.Type.SEQUENCE, true, [
        // algorithm
        $a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.UNIVERSAL, $a0ffc74c94d05282$var$asn1.Type.OID, false, $a0ffc74c94d05282$var$asn1.oidToDer(obj.signatureAlgorithm).getBytes()),
        // parameters (null)
        $a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.UNIVERSAL, $a0ffc74c94d05282$var$asn1.Type.NULL, false, "")
    ]));
    // encryptedDigest
    rval.value.push($a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.UNIVERSAL, $a0ffc74c94d05282$var$asn1.Type.OCTETSTRING, false, obj.signature));
    // unauthenticatedAttributes (OPTIONAL)
    if (obj.unauthenticatedAttributes.length > 0) {
        // [1] IMPLICIT
        var attrsAsn1 = $a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.CONTEXT_SPECIFIC, 1, true, []);
        for(var i = 0; i < obj.unauthenticatedAttributes.length; ++i){
            var attr = obj.unauthenticatedAttributes[i];
            attrsAsn1.values.push($a0ffc74c94d05282$var$_attributeToAsn1(attr));
        }
        rval.value.push(attrsAsn1);
    }
    return rval;
}
/**
 * Map a set of SignerInfo ASN.1 objects to an array of signer objects.
 *
 * @param signerInfoAsn1s an array of ASN.1 SignerInfos (i.e. SET OF).
 *
 * @return an array of signers objects.
 */ function $a0ffc74c94d05282$var$_signersFromAsn1(signerInfoAsn1s) {
    var ret = [];
    for(var i = 0; i < signerInfoAsn1s.length; ++i)ret.push($a0ffc74c94d05282$var$_signerFromAsn1(signerInfoAsn1s[i]));
    return ret;
}
/**
 * Map an array of signer objects to ASN.1 objects.
 *
 * @param signers an array of signer objects.
 *
 * @return an array of ASN.1 SignerInfos.
 */ function $a0ffc74c94d05282$var$_signersToAsn1(signers) {
    var ret = [];
    for(var i = 0; i < signers.length; ++i)ret.push($a0ffc74c94d05282$var$_signerToAsn1(signers[i]));
    return ret;
}
/**
 * Convert an attribute object to an ASN.1 Attribute.
 *
 * @param attr the attribute object.
 *
 * @return the ASN.1 Attribute.
 */ function $a0ffc74c94d05282$var$_attributeToAsn1(attr) {
    var value;
    // TODO: generalize to support more attributes
    if (attr.type === $fz7FM.pki.oids.contentType) value = $a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.UNIVERSAL, $a0ffc74c94d05282$var$asn1.Type.OID, false, $a0ffc74c94d05282$var$asn1.oidToDer(attr.value).getBytes());
    else if (attr.type === $fz7FM.pki.oids.messageDigest) value = $a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.UNIVERSAL, $a0ffc74c94d05282$var$asn1.Type.OCTETSTRING, false, attr.value.bytes());
    else if (attr.type === $fz7FM.pki.oids.signingTime) {
        /* Note per RFC 2985: Dates between 1 January 1950 and 31 December 2049
      (inclusive) MUST be encoded as UTCTime. Any dates with year values
      before 1950 or after 2049 MUST be encoded as GeneralizedTime. [Further,]
      UTCTime values MUST be expressed in Greenwich Mean Time (Zulu) and MUST
      include seconds (i.e., times are YYMMDDHHMMSSZ), even where the
      number of seconds is zero.  Midnight (GMT) must be represented as
      "YYMMDD000000Z". */ // TODO: make these module-level constants
        var jan_1_1950 = new Date("1950-01-01T00:00:00Z");
        var jan_1_2050 = new Date("2050-01-01T00:00:00Z");
        var date = attr.value;
        if (typeof date === "string") {
            // try to parse date
            var timestamp = Date.parse(date);
            if (!isNaN(timestamp)) date = new Date(timestamp);
            else if (date.length === 13) // YYMMDDHHMMSSZ (13 chars for UTCTime)
            date = $a0ffc74c94d05282$var$asn1.utcTimeToDate(date);
            else // assume generalized time
            date = $a0ffc74c94d05282$var$asn1.generalizedTimeToDate(date);
        }
        if (date >= jan_1_1950 && date < jan_1_2050) value = $a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.UNIVERSAL, $a0ffc74c94d05282$var$asn1.Type.UTCTIME, false, $a0ffc74c94d05282$var$asn1.dateToUtcTime(date));
        else value = $a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.UNIVERSAL, $a0ffc74c94d05282$var$asn1.Type.GENERALIZEDTIME, false, $a0ffc74c94d05282$var$asn1.dateToGeneralizedTime(date));
    }
    // TODO: expose as common API call
    // create a RelativeDistinguishedName set
    // each value in the set is an AttributeTypeAndValue first
    // containing the type (an OID) and second the value
    return $a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.UNIVERSAL, $a0ffc74c94d05282$var$asn1.Type.SEQUENCE, true, [
        // AttributeType
        $a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.UNIVERSAL, $a0ffc74c94d05282$var$asn1.Type.OID, false, $a0ffc74c94d05282$var$asn1.oidToDer(attr.type).getBytes()),
        $a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.UNIVERSAL, $a0ffc74c94d05282$var$asn1.Type.SET, true, [
            // AttributeValue
            value
        ])
    ]);
}
/**
 * Map messages encrypted content to ASN.1 objects.
 *
 * @param ec The encryptedContent object of the message.
 *
 * @return ASN.1 representation of the encryptedContent object (SEQUENCE).
 */ function $a0ffc74c94d05282$var$_encryptedContentToAsn1(ec) {
    return [
        // ContentType, always Data for the moment
        $a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.UNIVERSAL, $a0ffc74c94d05282$var$asn1.Type.OID, false, $a0ffc74c94d05282$var$asn1.oidToDer($fz7FM.pki.oids.data).getBytes()),
        // ContentEncryptionAlgorithmIdentifier
        $a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.UNIVERSAL, $a0ffc74c94d05282$var$asn1.Type.SEQUENCE, true, [
            // Algorithm
            $a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.UNIVERSAL, $a0ffc74c94d05282$var$asn1.Type.OID, false, $a0ffc74c94d05282$var$asn1.oidToDer(ec.algorithm).getBytes()),
            // Parameters (IV)
            !ec.parameter ? undefined : $a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.UNIVERSAL, $a0ffc74c94d05282$var$asn1.Type.OCTETSTRING, false, ec.parameter.getBytes())
        ]),
        // [0] EncryptedContent
        $a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, [
            $a0ffc74c94d05282$var$asn1.create($a0ffc74c94d05282$var$asn1.Class.UNIVERSAL, $a0ffc74c94d05282$var$asn1.Type.OCTETSTRING, false, ec.content.getBytes())
        ])
    ];
}
/**
 * Reads the "common part" of an PKCS#7 content block (in ASN.1 format)
 *
 * This function reads the "common part" of the PKCS#7 content blocks
 * EncryptedData and EnvelopedData, i.e. version number and symmetrically
 * encrypted content block.
 *
 * The result of the ASN.1 validate and capture process is returned
 * to allow the caller to extract further data, e.g. the list of recipients
 * in case of a EnvelopedData object.
 *
 * @param msg the PKCS#7 object to read the data to.
 * @param obj the ASN.1 representation of the content block.
 * @param validator the ASN.1 structure validator object to use.
 *
 * @return the value map captured by validator object.
 */ function $a0ffc74c94d05282$var$_fromAsn1(msg, obj, validator) {
    var capture = {};
    var errors = [];
    if (!$a0ffc74c94d05282$var$asn1.validate(obj, validator, capture, errors)) {
        var error = new Error("Cannot read PKCS#7 message. ASN.1 object is not a supported PKCS#7 message.");
        error.errors = error;
        throw error;
    }
    // Check contentType, so far we only support (raw) Data.
    var contentType = $a0ffc74c94d05282$var$asn1.derToOid(capture.contentType);
    if (contentType !== $fz7FM.pki.oids.data) throw new Error("Unsupported PKCS#7 message. Only wrapped ContentType Data supported.");
    if (capture.encryptedContent) {
        var content = "";
        if ($fz7FM.util.isArray(capture.encryptedContent)) for(var i = 0; i < capture.encryptedContent.length; ++i){
            if (capture.encryptedContent[i].type !== $a0ffc74c94d05282$var$asn1.Type.OCTETSTRING) throw new Error("Malformed PKCS#7 message, expecting encrypted content constructed of only OCTET STRING objects.");
            content += capture.encryptedContent[i].value;
        }
        else content = capture.encryptedContent;
        msg.encryptedContent = {
            algorithm: $a0ffc74c94d05282$var$asn1.derToOid(capture.encAlgorithm),
            parameter: $fz7FM.util.createBuffer(capture.encParameter.value),
            content: $fz7FM.util.createBuffer(content)
        };
    }
    if (capture.content) {
        var content = "";
        if ($fz7FM.util.isArray(capture.content)) for(var i = 0; i < capture.content.length; ++i){
            if (capture.content[i].type !== $a0ffc74c94d05282$var$asn1.Type.OCTETSTRING) throw new Error("Malformed PKCS#7 message, expecting content constructed of only OCTET STRING objects.");
            content += capture.content[i].value;
        }
        else content = capture.content;
        msg.content = $fz7FM.util.createBuffer(content);
    }
    msg.version = capture.version.charCodeAt(0);
    msg.rawCapture = capture;
    return capture;
}
/**
 * Decrypt the symmetrically encrypted content block of the PKCS#7 message.
 *
 * Decryption is skipped in case the PKCS#7 message object already has a
 * (decrypted) content attribute.  The algorithm, key and cipher parameters
 * (probably the iv) are taken from the encryptedContent attribute of the
 * message object.
 *
 * @param The PKCS#7 message object.
 */ function $a0ffc74c94d05282$var$_decryptContent(msg) {
    if (msg.encryptedContent.key === undefined) throw new Error("Symmetric key not available.");
    if (msg.content === undefined) {
        var ciph;
        switch(msg.encryptedContent.algorithm){
            case $fz7FM.pki.oids["aes128-CBC"]:
            case $fz7FM.pki.oids["aes192-CBC"]:
            case $fz7FM.pki.oids["aes256-CBC"]:
                ciph = $fz7FM.aes.createDecryptionCipher(msg.encryptedContent.key);
                break;
            case $fz7FM.pki.oids["desCBC"]:
            case $fz7FM.pki.oids["des-EDE3-CBC"]:
                ciph = $fz7FM.des.createDecryptionCipher(msg.encryptedContent.key);
                break;
            default:
                throw new Error("Unsupported symmetric cipher, OID " + msg.encryptedContent.algorithm);
        }
        ciph.start(msg.encryptedContent.parameter);
        ciph.update(msg.encryptedContent.content);
        if (!ciph.finish()) throw new Error("Symmetric decryption failed.");
        msg.content = ciph.output;
    }
}

});

parcelRegister("kRrm7", function(module, exports) {
/**
 * Functions to output keys in SSH-friendly formats.
 *
 * This is part of the Forge project which may be used under the terms of
 * either the BSD License or the GNU General Public License (GPL) Version 2.
 *
 * See: https://github.com/digitalbazaar/forge/blob/cbebca3780658703d925b61b2caffb1d263a6c1d/LICENSE
 *
 * @author https://github.com/shellac
 */ 
var $fz7FM = parcelRequire("fz7FM");
parcelRequire("60qK1");
parcelRequire("9YZGj");
parcelRequire("bPSAM");
parcelRequire("1DNOR");
parcelRequire("gao36");
var $f2fdfa27bc823f53$var$ssh = module.exports = $fz7FM.ssh = $fz7FM.ssh || {};
/**
 * Encodes (and optionally encrypts) a private RSA key as a Putty PPK file.
 *
 * @param privateKey the key.
 * @param passphrase a passphrase to protect the key (falsy for no encryption).
 * @param comment a comment to include in the key file.
 *
 * @return the PPK file as a string.
 */ $f2fdfa27bc823f53$var$ssh.privateKeyToPutty = function(privateKey, passphrase, comment) {
    comment = comment || "";
    passphrase = passphrase || "";
    var algorithm = "ssh-rsa";
    var encryptionAlgorithm = passphrase === "" ? "none" : "aes256-cbc";
    var ppk = "PuTTY-User-Key-File-2: " + algorithm + "\r\n";
    ppk += "Encryption: " + encryptionAlgorithm + "\r\n";
    ppk += "Comment: " + comment + "\r\n";
    // public key into buffer for ppk
    var pubbuffer = $fz7FM.util.createBuffer();
    $f2fdfa27bc823f53$var$_addStringToBuffer(pubbuffer, algorithm);
    $f2fdfa27bc823f53$var$_addBigIntegerToBuffer(pubbuffer, privateKey.e);
    $f2fdfa27bc823f53$var$_addBigIntegerToBuffer(pubbuffer, privateKey.n);
    // write public key
    var pub = $fz7FM.util.encode64(pubbuffer.bytes(), 64);
    var length = Math.floor(pub.length / 66) + 1; // 66 = 64 + \r\n
    ppk += "Public-Lines: " + length + "\r\n";
    ppk += pub;
    // private key into a buffer
    var privbuffer = $fz7FM.util.createBuffer();
    $f2fdfa27bc823f53$var$_addBigIntegerToBuffer(privbuffer, privateKey.d);
    $f2fdfa27bc823f53$var$_addBigIntegerToBuffer(privbuffer, privateKey.p);
    $f2fdfa27bc823f53$var$_addBigIntegerToBuffer(privbuffer, privateKey.q);
    $f2fdfa27bc823f53$var$_addBigIntegerToBuffer(privbuffer, privateKey.qInv);
    // optionally encrypt the private key
    var priv;
    if (!passphrase) // use the unencrypted buffer
    priv = $fz7FM.util.encode64(privbuffer.bytes(), 64);
    else {
        // encrypt RSA key using passphrase
        var encLen = privbuffer.length() + 16 - 1;
        encLen -= encLen % 16;
        // pad private key with sha1-d data -- needs to be a multiple of 16
        var padding = $f2fdfa27bc823f53$var$_sha1(privbuffer.bytes());
        padding.truncate(padding.length() - encLen + privbuffer.length());
        privbuffer.putBuffer(padding);
        var aeskey = $fz7FM.util.createBuffer();
        aeskey.putBuffer($f2fdfa27bc823f53$var$_sha1("\x00\x00\x00\x00", passphrase));
        aeskey.putBuffer($f2fdfa27bc823f53$var$_sha1("\x00\x00\x00\x01", passphrase));
        // encrypt some bytes using CBC mode
        // key is 40 bytes, so truncate *by* 8 bytes
        var cipher = $fz7FM.aes.createEncryptionCipher(aeskey.truncate(8), "CBC");
        cipher.start($fz7FM.util.createBuffer().fillWithByte(0, 16));
        cipher.update(privbuffer.copy());
        cipher.finish();
        var encrypted = cipher.output;
        // Note: this appears to differ from Putty -- is forge wrong, or putty?
        // due to padding we finish as an exact multiple of 16
        encrypted.truncate(16); // all padding
        priv = $fz7FM.util.encode64(encrypted.bytes(), 64);
    }
    // output private key
    length = Math.floor(priv.length / 66) + 1; // 64 + \r\n
    ppk += "\r\nPrivate-Lines: " + length + "\r\n";
    ppk += priv;
    // MAC
    var mackey = $f2fdfa27bc823f53$var$_sha1("putty-private-key-file-mac-key", passphrase);
    var macbuffer = $fz7FM.util.createBuffer();
    $f2fdfa27bc823f53$var$_addStringToBuffer(macbuffer, algorithm);
    $f2fdfa27bc823f53$var$_addStringToBuffer(macbuffer, encryptionAlgorithm);
    $f2fdfa27bc823f53$var$_addStringToBuffer(macbuffer, comment);
    macbuffer.putInt32(pubbuffer.length());
    macbuffer.putBuffer(pubbuffer);
    macbuffer.putInt32(privbuffer.length());
    macbuffer.putBuffer(privbuffer);
    var hmac = $fz7FM.hmac.create();
    hmac.start("sha1", mackey);
    hmac.update(macbuffer.bytes());
    ppk += "\r\nPrivate-MAC: " + hmac.digest().toHex() + "\r\n";
    return ppk;
};
/**
 * Encodes a public RSA key as an OpenSSH file.
 *
 * @param key the key.
 * @param comment a comment.
 *
 * @return the public key in OpenSSH format.
 */ $f2fdfa27bc823f53$var$ssh.publicKeyToOpenSSH = function(key, comment) {
    var type = "ssh-rsa";
    comment = comment || "";
    var buffer = $fz7FM.util.createBuffer();
    $f2fdfa27bc823f53$var$_addStringToBuffer(buffer, type);
    $f2fdfa27bc823f53$var$_addBigIntegerToBuffer(buffer, key.e);
    $f2fdfa27bc823f53$var$_addBigIntegerToBuffer(buffer, key.n);
    return type + " " + $fz7FM.util.encode64(buffer.bytes()) + " " + comment;
};
/**
 * Encodes a private RSA key as an OpenSSH file.
 *
 * @param key the key.
 * @param passphrase a passphrase to protect the key (falsy for no encryption).
 *
 * @return the public key in OpenSSH format.
 */ $f2fdfa27bc823f53$var$ssh.privateKeyToOpenSSH = function(privateKey, passphrase) {
    if (!passphrase) return $fz7FM.pki.privateKeyToPem(privateKey);
    // OpenSSH private key is just a legacy format, it seems
    return $fz7FM.pki.encryptRsaPrivateKey(privateKey, passphrase, {
        legacy: true,
        algorithm: "aes128"
    });
};
/**
 * Gets the SSH fingerprint for the given public key.
 *
 * @param options the options to use.
 *          [md] the message digest object to use (defaults to forge.md.md5).
 *          [encoding] an alternative output encoding, such as 'hex'
 *            (defaults to none, outputs a byte buffer).
 *          [delimiter] the delimiter to use between bytes for 'hex' encoded
 *            output, eg: ':' (defaults to none).
 *
 * @return the fingerprint as a byte buffer or other encoding based on options.
 */ $f2fdfa27bc823f53$var$ssh.getPublicKeyFingerprint = function(key, options) {
    options = options || {};
    var md = options.md || $fz7FM.md.md5.create();
    var type = "ssh-rsa";
    var buffer = $fz7FM.util.createBuffer();
    $f2fdfa27bc823f53$var$_addStringToBuffer(buffer, type);
    $f2fdfa27bc823f53$var$_addBigIntegerToBuffer(buffer, key.e);
    $f2fdfa27bc823f53$var$_addBigIntegerToBuffer(buffer, key.n);
    // hash public key bytes
    md.start();
    md.update(buffer.getBytes());
    var digest = md.digest();
    if (options.encoding === "hex") {
        var hex = digest.toHex();
        if (options.delimiter) return hex.match(/.{2}/g).join(options.delimiter);
        return hex;
    } else if (options.encoding === "binary") return digest.getBytes();
    else if (options.encoding) throw new Error('Unknown encoding "' + options.encoding + '".');
    return digest;
};
/**
 * Adds len(val) then val to a buffer.
 *
 * @param buffer the buffer to add to.
 * @param val a big integer.
 */ function $f2fdfa27bc823f53$var$_addBigIntegerToBuffer(buffer, val) {
    var hexVal = val.toString(16);
    // ensure 2s complement +ve
    if (hexVal[0] >= "8") hexVal = "00" + hexVal;
    var bytes = $fz7FM.util.hexToBytes(hexVal);
    buffer.putInt32(bytes.length);
    buffer.putBytes(bytes);
}
/**
 * Adds len(val) then val to a buffer.
 *
 * @param buffer the buffer to add to.
 * @param val a string.
 */ function $f2fdfa27bc823f53$var$_addStringToBuffer(buffer, val) {
    buffer.putInt32(val.length);
    buffer.putString(val);
}
/**
 * Hashes the arguments into one value using SHA-1.
 *
 * @return the sha1 hash of the provided arguments.
 */ function $f2fdfa27bc823f53$var$_sha1() {
    var sha = $fz7FM.md.sha1.create();
    var num = arguments.length;
    for(var i = 0; i < num; ++i)sha.update(arguments[i]);
    return sha.digest();
}

});



parcelRegister("dmUnl", function(module, exports) {

$parcel$export(module.exports, "generateAsapHeader", function () { return $9bb90f75d9d39be1$export$722274807142456; });

var $2tqtW = parcelRequire("2tqtW");

var $eDmKf = parcelRequire("eDmKf");
function $9bb90f75d9d39be1$export$722274807142456(param) {
    var issuer = param.issuer, audience = param.audience, keyId = param.keyId, privateKey = param.privateKey, subject = param.subject;
    if (privateKey.includes("data:application/pkcs8")) {
        var _decodeAsapPrivateKeyDataUri = (0, $eDmKf.decodeAsapPrivateKeyDataUri)(privateKey), uriKeyId = _decodeAsapPrivateKeyDataUri.keyId, uriPrivateKey = _decodeAsapPrivateKeyDataUri.privateKey;
        keyId = uriKeyId;
        privateKey = uriPrivateKey;
    }
    var jwtConfig = {
        privateKey: privateKey,
        issuer: issuer,
        keyId: keyId,
        audience: audience,
        subject: subject
    };
    var authHeaderGenerator = $2tqtW.createAuthHeaderGenerator(jwtConfig);
    return authHeaderGenerator();
}

});
parcelRegister("2tqtW", function(module, exports) {
"use strict";



module.exports = {
    createJwtAuthFilter: (parcelRequire("9tRil")),
    createAuthHeaderGenerator: (parcelRequire("esIA0")),
    parseDataUri: (parcelRequire("9OuTD"))
};

});
parcelRegister("9tRil", function(module, exports) {
"use strict";

var $esIA0 = parcelRequire("esIA0");
function $6e7029bbcbd7b8b4$var$createJwtAuthFilter(jwtConfig) {
    var getOrGenerateAuthHeader = $esIA0(jwtConfig);
    return function addJwtAuthHeader(requestConfig, next) {
        requestConfig.httpOptions.headers["authorization"] = getOrGenerateAuthHeader();
        return next(requestConfig);
    };
}
module.exports = $6e7029bbcbd7b8b4$var$createJwtAuthFilter;

});
parcelRegister("esIA0", function(module, exports) {
"use strict";

var $f3yl3 = parcelRequire("f3yl3");

var $29L6x = parcelRequire("29L6x");
function $a87642d293368a3f$var$assertDefined(value, message) {
    if (value === undefined || value === null || value === "") throw new Error(message);
}
function $a87642d293368a3f$var$createAuthHeaderGenerator(jwtConfig) {
    $a87642d293368a3f$var$assertDefined(jwtConfig.privateKey, "jwtConfig.privateKey must be set");
    $a87642d293368a3f$var$assertDefined(jwtConfig.keyId, "jwtConfig.keyId must be set");
    $a87642d293368a3f$var$assertDefined(jwtConfig.issuer, "jwtConfig.issuer must be set");
    $a87642d293368a3f$var$assertDefined(jwtConfig.audience, "jwtConfig.audience must be set");
    var privateKey = jwtConfig.privateKey.replace(/\\n/g, "\n").replace(/"/g, "");
    // The max age is less than the expiry so that we don't ever reuse a nearly expired token
    var tokenExpiryMs = jwtConfig.tokenExpiryMs || 600000;
    var tokenMaxAgeMs = jwtConfig.tokenMaxAgeMs || 540000;
    var additionalClaims = jwtConfig.additionalClaims || {};
    var lastUpdated = 0;
    var authHeader;
    function isExpired(now) {
        var tokenAge = now - lastUpdated;
        return tokenAge > tokenMaxAgeMs;
    }
    function generateStandardClaims(now) {
        return {
            aud: jwtConfig.audience,
            iss: jwtConfig.issuer,
            sub: jwtConfig.subject || jwtConfig.issuer,
            iat: Math.floor(now / 1000),
            nbf: Math.floor(now / 1000),
            exp: Math.floor((now + tokenExpiryMs) / 1000),
            jti: $f3yl3.randomBytes(20).toString("hex")
        };
    }
    function getOrGenerateAuthHeader() {
        var now = Date.now();
        if (!isExpired(now)) return authHeader;
        var claims = Object.assign({}, generateStandardClaims(now), additionalClaims);
        var options = {
            algorithm: "RS256",
            header: {
                kid: jwtConfig.keyId
            }
        };
        authHeader = "Bearer " + $29L6x.sign(claims, privateKey, options);
        lastUpdated = now;
        return authHeader;
    }
    // Fail if we cannot generate an auth header
    getOrGenerateAuthHeader();
    return getOrGenerateAuthHeader;
}
module.exports = $a87642d293368a3f$var$createAuthHeaderGenerator;

});


parcelRegister("9OuTD", function(module, exports) {

var $8dlmd = parcelRequire("8dlmd");
var $7250bff1c1040a08$require$Buffer = $8dlmd.Buffer;
"use strict";

var $f3yl3 = parcelRequire("f3yl3");
var $7250bff1c1040a08$var$nodeForge;

try {
    $7250bff1c1040a08$var$nodeForge = (parcelRequire("ej1jw"));
} catch (err) {
    // istanbul ignore if: impossible to test with proxyquire
    if (err.code !== "MODULE_NOT_FOUND") throw err;
}
var $7250bff1c1040a08$var$DATA_URI_PATTERN = /^data:application\/pkcs8;kid=([\w.\-+/]+);base64,([a-zA-Z0-9+/=]+)$/;
function $7250bff1c1040a08$var$parsePrivateKeyWithNodeForge(privateKeyDerBase64) {
    var privateKeyDerBuffer = $7250bff1c1040a08$var$nodeForge.util.decode64(privateKeyDerBase64);
    var privateKeyAsn1 = $7250bff1c1040a08$var$nodeForge.asn1.fromDer(privateKeyDerBuffer);
    var privateKeyObj = $7250bff1c1040a08$var$nodeForge.pki.privateKeyFromAsn1(privateKeyAsn1);
    var privateKeyPem = $7250bff1c1040a08$var$nodeForge.pki.privateKeyToPem(privateKeyObj);
    return privateKeyPem.toString("base64");
}
// Note: This can't be tested on node<11, so in CI we don't enforce full coverage on node<11 because of this.
function $7250bff1c1040a08$var$parsePrivateKeyWithCrypto(privateKeyDerBase64) {
    var privateKeyDerBuffer = $7250bff1c1040a08$require$Buffer.from(privateKeyDerBase64, "base64");
    var privateKeyObj = $f3yl3.createPrivateKey({
        key: privateKeyDerBuffer,
        type: "pkcs8",
        format: "der"
    });
    var privateKeyPemBuffer = privateKeyObj.export({
        type: "pkcs8",
        format: "pem"
    });
    return privateKeyPemBuffer.toString("base64");
}
function $7250bff1c1040a08$var$parsePrivateKey(privateKeyDerBase64) {
    if ($f3yl3.createPrivateKey) return $7250bff1c1040a08$var$parsePrivateKeyWithCrypto(privateKeyDerBase64);
    else if ($7250bff1c1040a08$var$nodeForge) return $7250bff1c1040a08$var$parsePrivateKeyWithNodeForge(privateKeyDerBase64);
    else throw new Error("node-forge must be installed for Node.js versions older than v11.6.0. Please install node-forge (npm install --save node-forge) or upgrade to a newer version of Node.js.");
}
function $7250bff1c1040a08$var$parseDataUri(dataUri) {
    var match = $7250bff1c1040a08$var$DATA_URI_PATTERN.exec(decodeURIComponent(dataUri));
    if (!match) throw new Error("Data URI does not match required format!");
    var keyId = match[1];
    var privateKey = $7250bff1c1040a08$var$parsePrivateKey(match[2]);
    return {
        keyId: keyId,
        privateKey: privateKey
    };
}
module.exports = $7250bff1c1040a08$var$parseDataUri;

});







parcelRegister("1PgDH", function(module, exports) {

$parcel$export(module.exports, "useCofsClient", function () { return $4dfcd96e573b9cd5$export$1af72b6e15f91c2b; });

var $1rY3h = parcelRequire("1rY3h");

var $1Mpn7 = parcelRequire("1Mpn7");
parcelRequire("6o8iU");
var $jT5mg = parcelRequire("jT5mg");
var $4dfcd96e573b9cd5$var$CofsClientContext = /*#__PURE__*/ (0, $1Mpn7.createContext)(new (0, $jT5mg.CofsClient)());
function $4dfcd96e573b9cd5$export$1af72b6e15f91c2b() {
    return (0, $1Mpn7.useContext)($4dfcd96e573b9cd5$var$CofsClientContext);
}
var $4dfcd96e573b9cd5$export$b70bae26f9205f30 = function(param) {
    var client = param.client, children = param.children;
    return /*#__PURE__*/ (0, $1rY3h.jsx)($4dfcd96e573b9cd5$var$CofsClientContext.Provider, {
        value: client,
        children: children
    });
};

});
parcelRegister("6o8iU", function(module, exports) {
$parcel$export(module.exports, "AGGClient", function () { return (parcelRequire("7Xz35")).AGGClient; });
$parcel$export(module.exports, "CofsClient", function () { return (parcelRequire("jT5mg")).CofsClient; });
$parcel$export(module.exports, "UnsuccessfulFetchError", function () { return (parcelRequire("4toNk")).UnsuccessfulFetchError; });
parcelRequire("jwUJR");
parcelRequire("f3iSa");
parcelRequire("bhzmC");

});
parcelRegister("jwUJR", function(module, exports) {
$parcel$export(module.exports, "AGGClient", function () { return (parcelRequire("7Xz35")).AGGClient; });
parcelRequire("7Xz35");
parcelRequire("7seFM");

});
parcelRegister("7Xz35", function(module, exports) {

$parcel$export(module.exports, "AGGClient", function () { return $604216d6c8da1f42$export$b44e5dafe13af7b3; });
//@ts-nocheck

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $c6Xmf = parcelRequire("c6Xmf");

var $l29cN = parcelRequire("l29cN");
parcelRequire("bhzmC");
var $4toNk = parcelRequire("4toNk");
var $604216d6c8da1f42$var$GATEWAY_URL = "/gateway/api/graphql";
var $604216d6c8da1f42$var$DEFAULT_OPTIONS = {
    gatewayUrl: $604216d6c8da1f42$var$GATEWAY_URL
};
var $604216d6c8da1f42$var$GET_TEMPLATES_QUERY = "#graphql\n    query getTemplates($first: Int = 50, $after: String) {\n        templates(search: {queries: {first: $first, after: $after}}) {\n            pageInfo {\n                hasNextPage\n                endCursor\n            }\n            edges {\n                node {\n                    templateId\n                    name\n                    contributor {\n                        __typename\n                        ... on ContentPlatformOrganization {\n                            ...contentPlatformOrganization\n                        }\n                        ... on ContentPlatformAuthor {\n                            name\n                            jobTitle\n                            shortBiography\n                            authorPicture {\n                                ...contentPlatformImageAsset\n                            }\n                            organization {\n                                ...contentPlatformOrganization\n                            }\n                        }\n                    }\n                    previewBlurb\n                    templateIcon {\n                        ...contentPlatformImageAsset\n                    }\n                    templatePreview {\n                        ...contentPlatformImageAsset\n                    }\n                    oneLinerHeadline\n                    aboutThisTemplate\n                    howToUseThisTemplate {\n                        name\n                        steps {\n                            name\n                            description\n                            asset {\n                                ...contentPlatformImageAsset\n                            }\n                        }\n                    }\n                    category {\n                        id\n                        name\n                        urlSlug\n                        shortDescriptionOneLiner\n                        description\n                    }\n                    relatedTemplates {\n                        templateId\n                    }\n                    targetAudience {\n                        userRoleId\n                        roleDescription\n                        userRole\n                    }\n                    targetOrganizationSize {\n                        shortDescription\n                        name\n                    }\n                }\n            }\n        }\n    }\n\n    fragment contentPlatformImageAsset on ContentPlatformTemplateImageAsset {\n        description\n        title\n        url\n        details\n        fileName\n        contentType\n    }\n\n    fragment contentPlatformOrganization on ContentPlatformOrganization {\n        name\n        tagline\n        shortDescription\n        logo {\n            ...contentPlatformImageAsset\n        }\n        industry {\n            name\n            shortDescription\n        }\n    }\n    ";
function $604216d6c8da1f42$var$imageFromContentPlatformImage(node) {
    var _details_image, _details_image1;
    // TODO: Assert the shape of this JSON blob?
    var details = node.details;
    return {
        name: node.title,
        size: details.size,
        height: (_details_image = details.image) === null || _details_image === void 0 ? void 0 : _details_image.height,
        width: (_details_image1 = details.image) === null || _details_image1 === void 0 ? void 0 : _details_image1.width,
        url: node.url
    };
}
function $604216d6c8da1f42$var$contributorFromContentPlatformContributor(node) {
    var _node_logo, _node_industry;
    if ((node === null || node === void 0 ? void 0 : node.__typename) === "ContentPlatformOrganization") return {
        name: node.name,
        tagline: node.tagline,
        shortDescription: node.shortDescription,
        logo: (_node_logo = node.logo) === null || _node_logo === void 0 ? void 0 : _node_logo.map($604216d6c8da1f42$var$imageFromContentPlatformImage),
        industry: (_node_industry = node.industry) === null || _node_industry === void 0 ? void 0 : _node_industry.map(function(industry) {
            return {
                name: industry.name,
                shortDescription: industry.shortDescription
            };
        })
    };
    else if ((node === null || node === void 0 ? void 0 : node.__typename) === "ContentPlatformAuthor") return {
        name: node.name,
        jobTitle: node.jobTitle,
        shortBiography: node.shortBiography,
        authorPicture: node.authorPicture ? $604216d6c8da1f42$var$imageFromContentPlatformImage(node.authorPicture) : null,
        organization: $604216d6c8da1f42$var$contributorFromContentPlatformContributor(node.organization)
    };
    return null;
}
function $604216d6c8da1f42$var$templateFromContentPlatformTemplate(node) {
    var _node_templatePreview, _node_howToUseThisTemplate, _node_category, _node_relatedTemplates, _node_targetOrganizationSize;
    return {
        templateId: node.templateId,
        name: node.name,
        contributor: $604216d6c8da1f42$var$contributorFromContentPlatformContributor(node.contributor),
        previewBlurb: node.previewBlurb,
        templateIcon: node.templateIcon ? $604216d6c8da1f42$var$imageFromContentPlatformImage(node.templateIcon) : null,
        templatePreview: (_node_templatePreview = node.templatePreview) === null || _node_templatePreview === void 0 ? void 0 : _node_templatePreview.map($604216d6c8da1f42$var$imageFromContentPlatformImage),
        oneLinerHeadline: node.oneLinerHeadline,
        aboutThisTemplate: node.aboutThisTemplate,
        howToUseThisTemplate: (_node_howToUseThisTemplate = node.howToUseThisTemplate) === null || _node_howToUseThisTemplate === void 0 ? void 0 : _node_howToUseThisTemplate.map(function(guide) {
            var _guide_steps;
            var _guide_steps_map;
            return {
                name: guide.name,
                steps: (_guide_steps_map = (_guide_steps = guide.steps) === null || _guide_steps === void 0 ? void 0 : _guide_steps.map(function(step) {
                    return {
                        name: step.name,
                        description: step.description,
                        asset: step.asset ? $604216d6c8da1f42$var$imageFromContentPlatformImage(step.asset) : null
                    };
                })) !== null && _guide_steps_map !== void 0 ? _guide_steps_map : []
            };
        }),
        category: (_node_category = node.category) === null || _node_category === void 0 ? void 0 : _node_category.map(function(category) {
            return {
                id: category.id,
                name: category.name,
                urlSlug: category.urlSlug,
                shortDescriptionOneLiner: category.shortDescriptionOneLiner,
                description: category.description
            };
        }),
        relatedTemplates: (_node_relatedTemplates = node.relatedTemplates) === null || _node_relatedTemplates === void 0 ? void 0 : _node_relatedTemplates.map($604216d6c8da1f42$var$templateFromContentPlatformTemplate),
        targetAudience: node.targetAudience,
        targetOrganizationSize: (_node_targetOrganizationSize = node.targetOrganizationSize) === null || _node_targetOrganizationSize === void 0 ? void 0 : _node_targetOrganizationSize.map(function(size) {
            return {
                name: size.name,
                shortDescription: size.shortDescription
            };
        })
    };
}
var $604216d6c8da1f42$export$b44e5dafe13af7b3 = /*#__PURE__*/ function() {
    "use strict";
    function AGGClient() {
        var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $604216d6c8da1f42$var$DEFAULT_OPTIONS;
        (0, $4GJKx._)(this, AGGClient);
        this.opts = opts;
    }
    (0, $1wc17._)(AGGClient, [
        {
            key: "query",
            value: function query(query, variables) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _this_opts, _this_opts_gatewayUrl, response;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetch((_this_opts_gatewayUrl = (_this_opts = _this.opts) === null || _this_opts === void 0 ? void 0 : _this_opts.gatewayUrl) !== null && _this_opts_gatewayUrl !== void 0 ? _this_opts_gatewayUrl : $604216d6c8da1f42$var$GATEWAY_URL, {
                                        method: "POST",
                                        headers: {
                                            "Content-Type": "application/json"
                                        },
                                        credentials: "include",
                                        body: JSON.stringify({
                                            query: query,
                                            variables: variables
                                        })
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                if (response.ok) return [
                                    2,
                                    response.json()
                                ];
                                throw new (0, $4toNk.UnsuccessfulFetchError)({
                                    response: response
                                });
                        }
                    });
                })();
            }
        },
        {
            key: "getTemplates",
            value: function getTemplates() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var templates, pageInfo, _templates, data;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                templates = [];
                                _state.label = 1;
                            case 1:
                                return [
                                    4,
                                    _this.query($604216d6c8da1f42$var$GET_TEMPLATES_QUERY, {
                                        after: pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.endCursor
                                    })
                                ];
                            case 2:
                                data = _state.sent().data;
                                pageInfo = data.templates.pageInfo;
                                (_templates = templates).push.apply(_templates, (0, $c6Xmf._)(data.templates.edges.map(function(param) {
                                    var node = param.node;
                                    return $604216d6c8da1f42$var$templateFromContentPlatformTemplate(node);
                                })));
                                _state.label = 3;
                            case 3:
                                if (pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.hasNextPage) return [
                                    3,
                                    1
                                ];
                                _state.label = 4;
                            case 4:
                                return [
                                    2,
                                    templates
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return AGGClient;
}();

});
parcelRegister("bhzmC", function(module, exports) {
$parcel$export(module.exports, "UnsuccessfulFetchError", function () { return (parcelRequire("4toNk")).UnsuccessfulFetchError; });
parcelRequire("4MfmO");
parcelRequire("4toNk");
parcelRequire("gT7nL");
parcelRequire("14Y7k");

});
parcelRegister("4MfmO", function(module, exports) {

$parcel$export(module.exports, "serializeCookie", function () { return $d0560c3a072a7581$export$659f3e5265115438; });

var $1q4lt = parcelRequire("1q4lt");
function $d0560c3a072a7581$export$659f3e5265115438(param) {
    var name = param.name, value = param.value;
    return (0, $1q4lt.serialize)(name, value);
}
function $d0560c3a072a7581$export$2caf3886cd1c5ca7(cookie) {
    if (cookie) return {
        cookie: $d0560c3a072a7581$export$659f3e5265115438(cookie)
    };
    else return {};
}

});

parcelRegister("4toNk", function(module, exports) {

$parcel$export(module.exports, "UnsuccessfulFetchError", function () { return $3994137f8e29c5f0$export$da6dec65957b7041; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $FuVm8 = parcelRequire("FuVm8");

var $ohfOJ = parcelRequire("ohfOJ");
var $3994137f8e29c5f0$export$da6dec65957b7041 = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $dcsZi._)(UnsuccessfulFetchError, Error1);
    var _super = (0, $ohfOJ._)(UnsuccessfulFetchError);
    function UnsuccessfulFetchError(param) {
        var message = param.message, response = param.response;
        (0, $4GJKx._)(this, UnsuccessfulFetchError);
        var _this;
        _this = _super.call(this, message !== null && message !== void 0 ? message : response.statusText);
        _this.name = UnsuccessfulFetchError.name;
        _this.response = response;
        return _this;
    }
    (0, $1wc17._)(UnsuccessfulFetchError, [
        {
            key: "url",
            get: function get() {
                return this.response.url;
            }
        },
        {
            key: "status",
            get: function get() {
                return this.response.status;
            }
        }
    ]);
    return UnsuccessfulFetchError;
}((0, $FuVm8._)(Error));
function $3994137f8e29c5f0$export$24a0e392ef274e28(value) {
    return value.name === $3994137f8e29c5f0$export$da6dec65957b7041.name;
}

});

parcelRegister("gT7nL", function(module, exports) {

$parcel$export(module.exports, "mapResponseToText", function () { return $b718842b9b866daf$export$779c89bcd6b62ed; });
$parcel$export(module.exports, "mapResponseToJson", function () { return $b718842b9b866daf$export$a1968f52311c9c2e; });

var $kSuI9 = parcelRequire("kSuI9");

var $l29cN = parcelRequire("l29cN");

var $4toNk = parcelRequire("4toNk");
function $b718842b9b866daf$export$779c89bcd6b62ed(response) {
    return $b718842b9b866daf$var$_mapResponseToText.apply(this, arguments);
}
function $b718842b9b866daf$var$_mapResponseToText() {
    $b718842b9b866daf$var$_mapResponseToText = (0, $kSuI9._)(function(response) {
        var _, _tmp;
        return (0, $l29cN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!response.ok) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        response.text()
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
                case 2:
                    _ = (0, $4toNk.UnsuccessfulFetchError).bind;
                    _tmp = {};
                    return [
                        4,
                        $b718842b9b866daf$var$mapResponseToMessage(response)
                    ];
                case 3:
                    throw new (_.apply((0, $4toNk.UnsuccessfulFetchError), [
                        void 0,
                        (_tmp.message = _state.sent(), _tmp.response = response, _tmp)
                    ]));
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $b718842b9b866daf$var$_mapResponseToText.apply(this, arguments);
}
function $b718842b9b866daf$export$a1968f52311c9c2e(response) {
    return $b718842b9b866daf$var$_mapResponseToJson.apply(this, arguments);
}
function $b718842b9b866daf$var$_mapResponseToJson() {
    $b718842b9b866daf$var$_mapResponseToJson = (0, $kSuI9._)(function(response) {
        var _, _tmp;
        return (0, $l29cN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!response.ok) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        response.json()
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
                case 2:
                    _ = (0, $4toNk.UnsuccessfulFetchError).bind;
                    _tmp = {};
                    return [
                        4,
                        $b718842b9b866daf$var$mapResponseToMessage(response)
                    ];
                case 3:
                    throw new (_.apply((0, $4toNk.UnsuccessfulFetchError), [
                        void 0,
                        (_tmp.message = _state.sent(), _tmp.response = response, _tmp)
                    ]));
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $b718842b9b866daf$var$_mapResponseToJson.apply(this, arguments);
}
function $b718842b9b866daf$var$mapResponseToMessage(response) {
    return $b718842b9b866daf$var$_mapResponseToMessage.apply(this, arguments);
}
function $b718842b9b866daf$var$_mapResponseToMessage() {
    $b718842b9b866daf$var$_mapResponseToMessage = (0, $kSuI9._)(function(response) {
        var statusText, message;
        return (0, $l29cN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    statusText = response.statusText;
                    return [
                        4,
                        response.text()
                    ];
                case 1:
                    message = _state.sent();
                    if (message.length > 0) return [
                        2,
                        "".concat(statusText, " ").concat(message)
                    ];
                    else return [
                        2,
                        statusText
                    ];
                    return [
                        2
                    ];
            }
        });
    });
    return $b718842b9b866daf$var$_mapResponseToMessage.apply(this, arguments);
}

});

parcelRegister("14Y7k", function(module, exports) {

$parcel$export(module.exports, "isAtlassianIdAuth", function () { return $e2d388632d91a2c1$export$453c84352b0f02ea; });
function $e2d388632d91a2c1$export$453c84352b0f02ea(value) {
    var auth = value;
    return !!(auth === null || auth === void 0 ? void 0 : auth.xsrfToken) && !!auth.cloudSessionTokenCookie;
}

});



parcelRegister("7seFM", function(module, exports) {

});


parcelRegister("f3iSa", function(module, exports) {
$parcel$export(module.exports, "CofsClient", function () { return (parcelRequire("jT5mg")).CofsClient; });
parcelRequire("jT5mg");
parcelRequire("6rMz0");

});
parcelRegister("jT5mg", function(module, exports) {

$parcel$export(module.exports, "CofsClient", function () { return $ab6963818dec6c72$export$3746584432e1d900; });

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $l29cN = parcelRequire("l29cN");

var $4MfmO = parcelRequire("4MfmO");

var $gT7nL = parcelRequire("gT7nL");

var $14Y7k = parcelRequire("14Y7k");
var $ab6963818dec6c72$export$942ba04389b0d5a2 = "https://cofs.staging.public.atl-paas.net";
var $ab6963818dec6c72$var$_httpswwwatlassiancomapisprodcofs;
var $ab6963818dec6c72$export$3746584432e1d900 = /*#__PURE__*/ function() {
    "use strict";
    function CofsClient() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_baseUrl = _ref.baseUrl, baseUrl = _ref_baseUrl === void 0 ? ($ab6963818dec6c72$var$_httpswwwatlassiancomapisprodcofs = "https://www.atlassian.com/apis/prod/cofs") !== null && $ab6963818dec6c72$var$_httpswwwatlassiancomapisprodcofs !== void 0 ? $ab6963818dec6c72$var$_httpswwwatlassiancomapisprodcofs : $ab6963818dec6c72$export$942ba04389b0d5a2 : _ref_baseUrl;
        (0, $4GJKx._)(this, CofsClient);
        this.baseUrl = baseUrl;
    }
    (0, $1wc17._)(CofsClient, [
        {
            key: "activateProducts",
            value: function activateProducts(request) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var headers, cloudId, body, auth, analyticsData, userContextToken, cookiesList;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                headers = new Headers({
                                    "Accept": "application/json",
                                    "Content-Type": "application/json"
                                });
                                cloudId = request.cloudId, body = request.body, auth = request.auth, analyticsData = request.analyticsData, userContextToken = request.userContextToken;
                                cookiesList = [];
                                if (analyticsData) cookiesList = analyticsData;
                                if ((0, $14Y7k.isAtlassianIdAuth)(auth)) {
                                    headers.append("ATL-XSRF-Token", auth.xsrfToken);
                                    cookiesList.push(auth.cloudSessionTokenCookie);
                                } else {
                                    headers.append("X-Slauth-Egress", "true");
                                    headers.append("X-Slauth-Audience", "cofs");
                                    if (userContextToken) headers.append("User-Context", userContextToken);
                                }
                                if (cookiesList.length) headers.append("Cookie", cookiesList.map(function(cookieItem) {
                                    return (0, $4MfmO.serializeCookie)(cookieItem);
                                }).join("; "));
                                return [
                                    4,
                                    fetch("".concat(_this.baseUrl, "/cloud/").concat(cloudId, "/activateProducts"), {
                                        method: "POST",
                                        headers: headers,
                                        body: JSON.stringify(body)
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    (0, $gT7nL.mapResponseToJson).apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "createCloud",
            value: function createCloud(originalRequest) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var request, headers, body, auth, userContextToken, source, clientIp, analyticsData, cookiesList;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                request = originalRequest;
                                headers = new Headers({
                                    "Accept": "application/json",
                                    "Content-Type": "application/json"
                                });
                                body = request.body, auth = request.auth, userContextToken = request.userContextToken, source = request.source, clientIp = request.clientIp, analyticsData = request.analyticsData;
                                if (source) headers.append("X-ATL-Source", source);
                                cookiesList = [];
                                if (analyticsData) cookiesList = analyticsData;
                                if ((0, $14Y7k.isAtlassianIdAuth)(auth)) {
                                    headers.append("ATL-XSRF-Token", auth.xsrfToken);
                                    cookiesList.push(auth.cloudSessionTokenCookie);
                                } else {
                                    headers.append("X-Slauth-Egress", "true");
                                    headers.append("X-Slauth-Audience", "cofs");
                                    if (userContextToken) headers.append("User-Context", userContextToken);
                                }
                                if (cookiesList.length) headers.append("Cookie", cookiesList.map(function(cookieItem) {
                                    return (0, $4MfmO.serializeCookie)(cookieItem);
                                }).join("; "));
                                if (clientIp) headers.append("X-Forwarded-For", clientIp);
                                return [
                                    4,
                                    fetch("".concat(_this.baseUrl, "/cloud"), {
                                        method: "POST",
                                        headers: headers,
                                        body: JSON.stringify(body)
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    (0, $gT7nL.mapResponseToJson).apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getNameAvailability",
            value: function getNameAvailability(param) {
                var name = param.name;
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var success;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetch("".concat(_this.baseUrl, "/nameAvailability"), {
                                        method: "POST",
                                        headers: {
                                            "Content-Type": "application/json"
                                        },
                                        body: JSON.stringify({
                                            name: name
                                        })
                                    })
                                ];
                            case 1:
                                return [
                                    4,
                                    (0, $gT7nL.mapResponseToJson).apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                            case 2:
                                success = _state.sent().success;
                                return [
                                    2,
                                    success
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "reserveName",
            value: function reserveName(param) {
                var cloudName = param.cloudName;
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var headers;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                headers = new Headers({
                                    "Accept": "application/json",
                                    "Content-Type": "application/json",
                                    "X-Slauth-Egress": "true",
                                    "X-Slauth-Audience": "cofs"
                                });
                                return [
                                    4,
                                    fetch("".concat(_this.baseUrl, "/cloudname/availability/reserve"), {
                                        method: "POST",
                                        headers: headers,
                                        body: JSON.stringify({
                                            cloudName: cloudName
                                        })
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    (0, $gT7nL.mapResponseToJson).apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "resourcePackagesCheck",
            value: function resourcePackagesCheck(param) {
                var entitlements = param.entitlements;
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var headers, packageUris;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                headers = new Headers({
                                    "Accept": "application/json",
                                    "Content-Type": "application/json",
                                    "X-Slauth-Egress": "true",
                                    "X-Slauth-Audience": "cofs"
                                });
                                packageUris = entitlements.map(function(entitlement) {
                                    return "ari:cloud:platform::lifecycle-resource-package/".concat(entitlement);
                                });
                                return [
                                    4,
                                    fetch("".concat(_this.baseUrl, "/resource-packages/info"), {
                                        method: "POST",
                                        headers: headers,
                                        body: JSON.stringify({
                                            "package-uris": packageUris
                                        })
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    (0, $gT7nL.mapResponseToJson).apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "renameSite",
            value: function renameSite(param) {
                var cloudId = param.cloudId, newSiteName = param.newSiteName;
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var progressUri;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetch("".concat(_this.baseUrl, "/").concat(cloudId, "/rename"), {
                                        method: "PUT",
                                        headers: {
                                            "Content-Type": "application/json"
                                        },
                                        body: JSON.stringify({
                                            cloudName: newSiteName
                                        })
                                    })
                                ];
                            case 1:
                                return [
                                    4,
                                    (0, $gT7nL.mapResponseToJson).apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                            case 2:
                                progressUri = _state.sent().progressUri;
                                return [
                                    2,
                                    progressUri
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getCloudStatus",
            value: function getCloudStatus(param) {
                var cloudId = param.cloudId, requestId = param.requestId;
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetch("".concat(_this.baseUrl, "/cloud/").concat(cloudId, "/status/").concat(requestId), {
                                        headers: {
                                            "Content-Type": "application/json"
                                        }
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    (0, $gT7nL.mapResponseToJson).apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "pollProgress",
            value: function pollProgress(param) {
                var progressUri = param.progressUri;
                return (0, $kSuI9._)(function() {
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetch(progressUri, {
                                        method: "GET",
                                        headers: {
                                            "Content-Type": "application/json"
                                        }
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    (0, $gT7nL.mapResponseToJson).apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getHealthCheck",
            value: function getHealthCheck() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetch("".concat(_this.baseUrl, "/healthcheck"), {
                                        method: "GET",
                                        headers: {
                                            "Content-Type": "application/json"
                                        }
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    (0, $gT7nL.mapResponseToText).apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return CofsClient;
}();

});

parcelRegister("6rMz0", function(module, exports) {

});




parcelRegister("5p5UA", function(module, exports) {

var $1rY3h = parcelRequire("1rY3h");

var $1Mpn7 = parcelRequire("1Mpn7");
var $e865dc76e3886fac$var$LocaleContext = /*#__PURE__*/ (0, $1Mpn7.createContext)("en");
function $e865dc76e3886fac$export$43bb16f9c6d9e3f7() {
    return (0, $1Mpn7.useContext)($e865dc76e3886fac$var$LocaleContext);
}
var $e865dc76e3886fac$export$d07e18ad7fac0edc = function(param) {
    var locale = param.locale, children = param.children;
    return /*#__PURE__*/ (0, $1rY3h.jsx)($e865dc76e3886fac$var$LocaleContext.Provider, {
        value: locale,
        children: children
    });
};

});

parcelRegister("8d7jm", function(module, exports) {
parcelRequire("eb65f");
var $8JWVu = parcelRequire("8JWVu");

var $HSGiS = parcelRequire("HSGiS");
function $85e4d628f18e3027$export$f637e1cf42d15a62() {
    var stargateClient = (0, $8JWVu.useBxpWebStargateClient)();
    return (0, $HSGiS.useAsync)(function() {
        return stargateClient.me({});
    }, []);
}

});

parcelRegister("gDtmg", function(module, exports) {
// import { ProductKey } from '@atlassiansox/asc-product-catalog';
// import {
//   PricingCalculation,
//   PricingPeriod
// } from '@atlassian/bxp-product-pricing';
//
// import { usePricingCalculator } from '../contexts';
// import { AsyncResult, useAsync } from './use-async';
//
// export type PricingEditionResult = PricingCalculation[] & {
//   readonly units: number;
//   readonly period: PricingPeriod;
// };
//
// export function usePricingEdition(
//   productKeys: ProductKey[],
//   units: number,
//   period: PricingPeriod,
//   currencyIsoCode: string
// ): AsyncResult<PricingEditionResult> {
//   const calculator = usePricingCalculator();
//
//   return useAsync(async () => {
//     const pricing = await Promise.all(
//       productKeys.map((productKey) => {
//         return calculator.calculatePrice({
//           productKey,
//           units,
//           period,
//           currencyIsoCode
//         });
//       })
//     );
//
//     return {
//       ...pricing,
//       units,
//       period
//     };
//   }, [units, period, currencyIsoCode]);
// }

});

parcelRegister("1uofz", function(module, exports) {
// import { ProductKey } from '@atlassiansox/asc-product-catalog';
// import {
//   PricingCalculation,
//   PricingPeriod
// } from '@atlassian/bxp-product-pricing';
//
// import { usePricingCalculator } from '../contexts';
// import { AsyncResult, useAsync } from './use-async';
//
// export type PricingResult = PricingCalculation & {
//   readonly units: number;
//   readonly period: PricingPeriod;
// };
//
// export function usePricing(
//   productKey: ProductKey,
//   units: number,
//   period: PricingPeriod,
//   currencyIsoCode: string
// ): AsyncResult<PricingResult> {
//   const calculator = usePricingCalculator();
//   return useAsync(async () => {
//     const pricing = await calculator.calculatePrice({
//       productKey,
//       units,
//       period,
//       currencyIsoCode
//     });
//     return {
//       ...pricing,
//       units,
//       period
//     };
//   }, [productKey, units, period, currencyIsoCode]);
// }

});

parcelRegister("7UnWs", function(module, exports) {
// import {
//   PricingCalculation,
//   PricingPeriod,
//   PricingPlan
// } from '@atlassian/bxp-product-pricing';
// import { usePricingCalculator } from '../contexts';
// import { AsyncResult, useAsync } from './use-async';
//
// type MinimalProductState = { key: string; units: number };
//
// const reduceCalcs = (calcs: PricingCalculation[]) =>
//   calcs.reduce((total, calc) => calc.total + total, 0);
//
// export function useTotal(
//   products: MinimalProductState[],
//   addons: Array<{ pricingPlan: PricingPlan; units: number }>,
//   currencyIsoCode: string,
//   period: PricingPeriod
// ): AsyncResult<number> {
//   const calculator = usePricingCalculator();
//   return useAsync(async () => {
//     const productsTotal = await Promise.all(
//       products.map((product) =>
//         calculator.calculatePrice({
//           productKey: product.key,
//           units: product.units,
//           period,
//           currencyIsoCode
//         })
//       )
//     ).then(reduceCalcs);
//
//     const addonsTotal = await Promise.all(
//       addons.map(async (addon) => {
//         try {
//           return await calculator.calculatePriceWithPricingPlan({
//             units: addon.units,
//             currencyIsoCode,
//             pricingPlan: addon.pricingPlan
//           });
//         } catch (e) {
//           // https://hello.atlassian.net/browse/WCF-1173
//           // temp fix for apps with tier limits below 5000
//           return {
//             currencyIsoCode,
//             total: 0,
//             breakdown: [],
//             pricingPlan: []
//           };
//         }
//       })
//     ).then(reduceCalcs);
//
//     return productsTotal + (addonsTotal || 0);
//   }, [products, addons, currencyIsoCode, period]);
// }

});

parcelRegister("3pymB", function(module, exports) {

var $1rY3h = parcelRequire("1rY3h");

var $1Mpn7 = parcelRequire("1Mpn7");
parcelRequire("bXbpN");
var $4uH9s = parcelRequire("4uH9s");
parcelRequire("3hvGO");
var $39wmd = parcelRequire("39wmd");
var $6b11c44dfba5aac9$export$dcc1b9ccaa325625 = /*#__PURE__*/ (0, $1Mpn7.createContext)(new (0, $4uH9s.IdentityClient)({
    baseUrlStargate: (0, $39wmd.Environment).getApiPrivateUrl(),
    baseUrlIdentity: (0, $39wmd.Environment).getIdentityBaseUrl()
}));
function $6b11c44dfba5aac9$export$2a51658674d3faff() {
    return (0, $1Mpn7.useContext)($6b11c44dfba5aac9$export$dcc1b9ccaa325625);
}
var $6b11c44dfba5aac9$export$af6e86bf511b4067 = function(param) {
    var client = param.client, children = param.children;
    return /*#__PURE__*/ (0, $1rY3h.jsx)($6b11c44dfba5aac9$export$dcc1b9ccaa325625.Provider, {
        value: client,
        children: children
    });
};

});
parcelRegister("bXbpN", function(module, exports) {
$parcel$export(module.exports, "IdentityClient", function () { return (parcelRequire("4uH9s")).IdentityClient; });
parcelRequire("iJ0nj");
parcelRequire("4uH9s");
parcelRequire("jDutY");

});
parcelRegister("iJ0nj", function(module, exports) {
parcelRequire("8gpfr");

});
parcelRegister("8gpfr", function(module, exports) {

});


parcelRegister("4uH9s", function(module, exports) {

$parcel$export(module.exports, "IdentityClient", function () { return $345b6fbce7aab4f7$export$f9c003efee04f318; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $l29cN = parcelRequire("l29cN");

var $lFPa6 = parcelRequire("lFPa6");
parcelRequire("8pXts");
var $jyXh7 = parcelRequire("jyXh7");
var $210XJ = parcelRequire("210XJ");
parcelRequire("8FQM6");
var $dmUnl = parcelRequire("dmUnl");

var $hTD6v = parcelRequire("hTD6v");

var $jDutY = parcelRequire("jDutY");
var $345b6fbce7aab4f7$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $345b6fbce7aab4f7$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $345b6fbce7aab4f7$export$c039d0ad0b34bf5 = "https://id.staging.atl-paas.net";
var $345b6fbce7aab4f7$var$ASAP_AUDIENCE = "identity-platform";
var $345b6fbce7aab4f7$export$f9c003efee04f318 = /*#__PURE__*/ function() {
    "use strict";
    function IdentityClient() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_baseUrlIdentity = _ref.baseUrlIdentity, baseUrlIdentity = _ref_baseUrlIdentity === void 0 ? $345b6fbce7aab4f7$export$c039d0ad0b34bf5 : _ref_baseUrlIdentity;
        (0, $4GJKx._)(this, IdentityClient);
        this.baseUrlIdentity = baseUrlIdentity;
    }
    (0, $1wc17._)(IdentityClient, [
        {
            key: "permissionsPermitted",
            value: function permissionsPermitted(request) {
                return $345b6fbce7aab4f7$var$__awaiter(this, void 0, void 0, function() {
                    var auth, permissionId, principalId, resourceId, dontRequirePrincipalInSite, url, params, headers;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                auth = request.auth, permissionId = request.permissionId, principalId = request.principalId, resourceId = request.resourceId, dontRequirePrincipalInSite = request.dontRequirePrincipalInSite;
                                // URL is defined globally for node versions >= 10.0.0 and globally in browsers,
                                // so I'm assuming this should work cross platform
                                url = new URL("".concat(this.baseUrlIdentity, "/v1/permissions/permitted"));
                                params = {
                                    permissionId: permissionId,
                                    principalId: principalId,
                                    resourceId: resourceId,
                                    dontRequirePrincipalInSite: dontRequirePrincipalInSite
                                };
                                (0, (/*@__PURE__*/$parcel$interopDefault($lFPa6))).map(params, function(val, key) {
                                    url.searchParams.append(key, val.toString());
                                });
                                headers = new (0, $hTD6v.Headers)();
                                if ((0, $jDutY.isAsapAuth)(auth)) headers.append("Authorization", (0, $dmUnl.generateAsapHeader)(Object.assign(Object.assign({}, auth.asap), {
                                    audience: $345b6fbce7aab4f7$var$ASAP_AUDIENCE
                                })));
                                return [
                                    4,
                                    (0, $hTD6v.fetch)("".concat(url), {
                                        method: "GET",
                                        headers: headers
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    (0, $jyXh7.mapResponseToText).apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "permissionsBulkPermitted",
            value: function permissionsBulkPermitted(request) {
                return $345b6fbce7aab4f7$var$__awaiter(this, void 0, void 0, function() {
                    var auth, query, url, headers;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                auth = request.auth, query = request.query;
                                url = new URL("".concat(this.baseUrlIdentity, "/v3/permissions/bulk/permitted"));
                                headers = new (0, $hTD6v.Headers)();
                                if ((0, $jDutY.isAsapAuth)(auth)) headers.append("Authorization", (0, $dmUnl.generateAsapHeader)(Object.assign(Object.assign({}, auth.asap), {
                                    audience: $345b6fbce7aab4f7$var$ASAP_AUDIENCE
                                })));
                                headers.append("Accept", "application/json");
                                headers.append("Content-Type", "application/json");
                                return [
                                    4,
                                    (0, $hTD6v.fetch)("".concat(url), {
                                        method: "POST",
                                        headers: headers,
                                        body: JSON.stringify(query)
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    (0, $jyXh7.mapResponseToText).apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "checkAddProductCapabilities",
            value: function checkAddProductCapabilities(request) {
                return $345b6fbce7aab4f7$var$__awaiter(this, void 0, void 0, function() {
                    var auth, cloudId, product, licenceLimit, url, requestData, headers, response;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                auth = request.auth, cloudId = request.cloudId, product = request.product, licenceLimit = request.licenceLimit;
                                url = new URL("".concat(this.baseUrlIdentity, "/v2/licences/capabilities"));
                                requestData = [
                                    {
                                        action: (0, $jDutY.CHECK_ADD_PROJECT_ACTION),
                                        owner: "".concat((0, $jDutY.CHECK_ADD_PROJECT_ARI_PREFIX)).concat(cloudId),
                                        product: product,
                                        licenceLimit: licenceLimit
                                    }
                                ];
                                headers = new (0, $hTD6v.Headers)();
                                headers.append("Content-Type", "application/json");
                                if ((0, $jDutY.isAsapAuth)(auth)) headers.append("Authorization", (0, $dmUnl.generateAsapHeader)(Object.assign(Object.assign({}, auth.asap), {
                                    audience: $345b6fbce7aab4f7$var$ASAP_AUDIENCE
                                })));
                                return [
                                    4,
                                    (0, $hTD6v.fetch)("".concat(url), {
                                        method: "post",
                                        headers: headers,
                                        body: JSON.stringify(requestData)
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                if (response.ok) return [
                                    2,
                                    response.json()
                                ];
                                else throw new (0, $210XJ.UnsucessfulFetchError)({
                                    response: response
                                });
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "checkAuthenticationMethodsAvailable",
            value: function checkAuthenticationMethodsAvailable(options) {
                return $345b6fbce7aab4f7$var$__awaiter(this, void 0, void 0, function() {
                    var email, redirect_to, application, auth;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                email = options.email, redirect_to = options.redirect_to, application = options.application, auth = options.auth;
                                return [
                                    4,
                                    (0, $hTD6v.fetch)("".concat(this.baseUrlIdentity, "/v2/authentication/methods-available"), {
                                        method: "POST",
                                        headers: {
                                            "Authorization": (0, $dmUnl.generateAsapHeader)(Object.assign(Object.assign({}, auth.asap), {
                                                audience: $345b6fbce7aab4f7$var$ASAP_AUDIENCE
                                            })),
                                            "Content-Type": "application/json"
                                        },
                                        body: JSON.stringify({
                                            email: email,
                                            redirect_to: redirect_to,
                                            application: application
                                        })
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    (0, $jyXh7.mapResponseToJson).apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getUser",
            value: function getUser(accountId) {
                return $345b6fbce7aab4f7$var$__awaiter(this, void 0, void 0, function() {
                    var result, _;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $hTD6v.fetch)("".concat(this.baseUrlIdentity, "/v2/users/").concat(accountId))
                                ];
                            case 1:
                                result = _state.sent();
                                if (result.status === 404) return [
                                    2,
                                    undefined
                                ];
                                if (!!result.ok) return [
                                    3,
                                    3
                                ];
                                _ = Error.bind;
                                return [
                                    4,
                                    result.text()
                                ];
                            case 2:
                                throw new (_.apply(Error, [
                                    void 0,
                                    _state.sent()
                                ]));
                            case 3:
                                return [
                                    4,
                                    result.json()
                                ];
                            case 4:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getUserName",
            value: function getUserName(accountId) {
                return $345b6fbce7aab4f7$var$__awaiter(this, void 0, void 0, function() {
                    var user;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getUser(accountId)
                                ];
                            case 1:
                                user = _state.sent();
                                if (!user) return [
                                    2,
                                    undefined
                                ];
                                return [
                                    2,
                                    user.name
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getHealthCheck",
            value: function getHealthCheck() {
                return $345b6fbce7aab4f7$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $hTD6v.fetch)("".concat(this.baseUrlIdentity, "/healthcheck"))
                                ];
                            case 1:
                                return [
                                    2,
                                    (0, $jyXh7.mapResponseToText).apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "userSignup",
            value: function userSignup(request, options) {
                return $345b6fbce7aab4f7$var$__awaiter(this, void 0, void 0, function() {
                    var application, displayName, email, locale, recaptchaScore, redirectTo, suppressEmail, userAgent, anonymousId, headers, context, body;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                application = request.application, displayName = request.displayName, email = request.email, locale = request.locale, recaptchaScore = request.recaptchaScore, redirectTo = request.redirectTo, suppressEmail = request.suppressEmail, userAgent = request.userAgent, anonymousId = request.anonymousId;
                                headers = new (0, $hTD6v.Headers)({
                                    "Authorization": (0, $dmUnl.generateAsapHeader)(Object.assign(Object.assign({}, options.auth.asap), {
                                        audience: $345b6fbce7aab4f7$var$ASAP_AUDIENCE
                                    })),
                                    "Content-Type": "application/json"
                                });
                                if (anonymousId) headers.append("X-Atl-Anonymous-Id", anonymousId);
                                context = Object.assign(Object.assign({}, userAgent && {
                                    deviceInfo: {
                                        userAgent: userAgent
                                    }
                                }), recaptchaScore && {
                                    riskScore: {
                                        type: "reCAPTCHA",
                                        value: recaptchaScore
                                    }
                                });
                                body = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
                                    application: application
                                }, displayName && {
                                    displayName: displayName
                                }), {
                                    email: email
                                }), locale && {
                                    locale: locale
                                }), suppressEmail !== undefined && {
                                    suppressEmail: suppressEmail
                                }), redirectTo && {
                                    redirect_to: redirectTo
                                }), Object.keys(context).length && {
                                    context: context
                                });
                                return [
                                    4,
                                    (0, $hTD6v.fetch)("".concat(this.baseUrlIdentity, "/v2/users/signup"), {
                                        method: "POST",
                                        headers: headers,
                                        body: JSON.stringify(Object.assign(Object.assign({}, body), {
                                            redirect_to: redirectTo
                                        }))
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    (0, $jyXh7.mapResponseToJson).apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getUsersByCloudId",
            value: function getUsersByCloudId(request) {
                return $345b6fbce7aab4f7$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $hTD6v.fetch)("".concat(this.baseUrlIdentity, "/v1/site/").concat(request.cloudId, "/Users"), {
                                        method: "GET",
                                        headers: {
                                            "Authorization": (0, $dmUnl.generateAsapHeader)(Object.assign(Object.assign({}, request.auth.asap), {
                                                audience: $345b6fbce7aab4f7$var$ASAP_AUDIENCE
                                            })),
                                            "Content-Type": "application/json"
                                        }
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    (0, $jyXh7.mapResponseToJson).apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getUserByCloudAndAaId",
            value: function getUserByCloudAndAaId(request) {
                return $345b6fbce7aab4f7$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $hTD6v.fetch)("".concat(this.baseUrlIdentity, "/v1/site/").concat(request.cloudId, "/Users/").concat(request.atlassianAccountId), {
                                        method: "GET",
                                        headers: {
                                            "Authorization": (0, $dmUnl.generateAsapHeader)(Object.assign(Object.assign({}, request.auth.asap), {
                                                audience: $345b6fbce7aab4f7$var$ASAP_AUDIENCE
                                            })),
                                            "Content-Type": "application/json"
                                        }
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    (0, $jyXh7.mapResponseToJson).apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getPrincipalsByResource",
            value: function getPrincipalsByResource(request) {
                return $345b6fbce7aab4f7$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $hTD6v.fetch)("".concat(this.baseUrlIdentity, "/v3/permissions/principalsByResource"), {
                                        method: "POST",
                                        headers: {
                                            "Authorization": (0, $dmUnl.generateAsapHeader)(Object.assign(Object.assign({}, request.auth.asap), {
                                                audience: $345b6fbce7aab4f7$var$ASAP_AUDIENCE
                                            })),
                                            "Content-Type": "application/json"
                                        },
                                        body: JSON.stringify({
                                            principalFilter: request.principalFilter,
                                            resourceId: request.resourceId,
                                            permissionId: request.permissionId
                                        })
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    (0, $jyXh7.mapResponseToJson).apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "inviteUser",
            value: function inviteUser(request) {
                return $345b6fbce7aab4f7$var$__awaiter(this, void 0, void 0, function() {
                    var auth, requestPayload, response, _, _tmp, _1, _2, invitationUrl;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                auth = request.auth, requestPayload = $345b6fbce7aab4f7$var$__rest(request, [
                                    "auth"
                                ]);
                                return [
                                    4,
                                    (0, $hTD6v.fetch)("".concat(this.baseUrlIdentity, "/v1/Users/invite"), {
                                        method: "Post",
                                        headers: {
                                            "Authorization": (0, $dmUnl.generateAsapHeader)(Object.assign(Object.assign({}, auth.asap), {
                                                audience: $345b6fbce7aab4f7$var$ASAP_AUDIENCE
                                            })),
                                            "Content-Type": "application/json"
                                        },
                                        body: JSON.stringify(requestPayload)
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                if (!!response.ok) return [
                                    3,
                                    3
                                ];
                                _ = (0, $210XJ.UnsucessfulFetchError).bind;
                                _tmp = {};
                                _2 = (_1 = "".concat(response.statusText, " ")).concat;
                                return [
                                    4,
                                    response.text()
                                ];
                            case 2:
                                throw new (_.apply((0, $210XJ.UnsucessfulFetchError), [
                                    void 0,
                                    (_tmp.message = _2.apply(_1, [
                                        _state.sent()
                                    ]), _tmp.response = response, _tmp)
                                ]));
                            case 3:
                                invitationUrl = response.headers.get("location");
                                if (!invitationUrl) throw new Error("invitation request succeeded but no location header was returned");
                                return [
                                    2,
                                    {
                                        invitationUrl: invitationUrl
                                    }
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getUserIdsByEmailAddresses",
            value: function getUserIdsByEmailAddresses(request) {
                return $345b6fbce7aab4f7$var$__awaiter(this, void 0, void 0, function() {
                    var response, _, _1, _2;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $hTD6v.fetch)("".concat(this.baseUrlIdentity, "/v2/users/fetch/by-email"), {
                                        method: "POST",
                                        headers: {
                                            "Authorization": (0, $dmUnl.generateAsapHeader)(Object.assign(Object.assign({}, request.auth.asap), {
                                                audience: $345b6fbce7aab4f7$var$ASAP_AUDIENCE
                                            })),
                                            "Content-Type": "application/json"
                                        },
                                        body: JSON.stringify({
                                            emails: request.emailAddresses
                                        })
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                if (!!response.ok) return [
                                    3,
                                    3
                                ];
                                _ = Error.bind;
                                _2 = (_1 = "".concat(response.statusText, " ")).concat;
                                return [
                                    4,
                                    response.text()
                                ];
                            case 2:
                                throw new (_.apply(Error, [
                                    void 0,
                                    _2.apply(_1, [
                                        _state.sent()
                                    ])
                                ]));
                            case 3:
                                return [
                                    2,
                                    response.json()
                                ];
                        }
                    });
                });
            }
        }
    ]);
    return IdentityClient;
}();

});
parcelRegister("jDutY", function(module, exports) {

$parcel$export(module.exports, "isAsapAuth", function () { return $e4b94e05f6748de9$export$bdffa12efde3d762; });
$parcel$export(module.exports, "CHECK_ADD_PROJECT_ACTION", function () { return $e4b94e05f6748de9$export$1be8a60ec08708d6; });
$parcel$export(module.exports, "CHECK_ADD_PROJECT_ARI_PREFIX", function () { return $e4b94e05f6748de9$export$3561addd98c2dde4; });
function $e4b94e05f6748de9$export$bdffa12efde3d762(auth) {
    return !!auth.asap.issuer && !!auth.asap.keyId && !!auth.asap.privateKey;
}
var $e4b94e05f6748de9$export$1be8a60ec08708d6 = "addProduct";
var $e4b94e05f6748de9$export$3561addd98c2dde4 = "ari:cloud:platform::site/";

});



parcelRegister("3hvGO", function(module, exports) {
$parcel$export(module.exports, "Environment", function () { return (parcelRequire("39wmd")).Environment; });
$parcel$export(module.exports, "Url", function () { return (parcelRequire("4vhRZ")).Url; });
$parcel$export(module.exports, "getFirstName", function () { return (parcelRequire("2DKGq")).getFirstName; });
$parcel$export(module.exports, "getLastName", function () { return (parcelRequire("2DKGq")).getLastName; });
$parcel$export(module.exports, "Storage", function () { return (parcelRequire("iPDfU")).Storage; });
$parcel$export(module.exports, "getIsBundleBbJsw", function () { return (parcelRequire("cq0Ay")).getIsBundleBbJsw; });
$parcel$export(module.exports, "getIsBundleDevops", function () { return (parcelRequire("cq0Ay")).getIsBundleDevops; });
$parcel$export(module.exports, "defineMessagesSimple", function () { return (parcelRequire("7HUGN")).defineMessagesSimple; });
$parcel$export(module.exports, "OfferingCatalog", function () { return (parcelRequire("9ap2n")).OfferingCatalog; });
/**
 * Widely-Used utility functions that are not async
 */ parcelRequire("39wmd");
parcelRequire("4vhRZ");
parcelRequire("2DKGq");
parcelRequire("iPDfU");
parcelRequire("cq0Ay");
parcelRequire("7HUGN");
parcelRequire("9ap2n");

});
parcelRegister("39wmd", function(module, exports) {

$parcel$export(module.exports, "Environment", function () { return $fbf827fc14e8dad8$export$7dc6752a22ab011a; });

var $fN6oO = parcelRequire("fN6oO");

var $4vhRZ = parcelRequire("4vhRZ");
var $fbf827fc14e8dad8$export$7dc6752a22ab011a;
(function(Environment) {
    var VALID_LOCALES = [
        "cn",
        "cs",
        "de",
        "es",
        "fr",
        "it",
        "ko",
        "hu",
        "nl",
        "ja",
        "pl",
        "br",
        "ro",
        "fi",
        "ru",
        "zh"
    ];
    var BXP_TO_GROWTH_LOCALE_MAP = {
        de: "de",
        es: "es",
        fr: "fr",
        it: "it",
        ko: "ko",
        hu: "hu",
        nl: "nl",
        ja: "ja",
        pl: "pl",
        br: "pt-BR",
        ru: "ru",
        zh: "zh"
    };
    function getSubdomain() {
        var urlParts = (0, $4vhRZ.Url).getLocation().hostname.split(".");
        if (urlParts[1] === "dev") return "localhost";
        return urlParts[0];
    }
    Environment.getSubdomain = getSubdomain;
    function getEnvironment() {
        switch(getSubdomain()){
            case "wac":
            case "qa-wac":
            case "author":
            case "proof":
            case "statlas":
            case "truth":
                return 0, $fN6oO.ENV_STAGING;
            case "localhost":
            case "local":
                return 0, $fN6oO.ENV_DEV;
            case "www":
            case "atlassian":
            case "bitbucket":
            case "sourcetreeapp":
            case "agile":
            case "git":
            case "software":
                return 0, $fN6oO.ENV_PRODUCTION;
            default:
                /* for omlet instances */ return 0, $fN6oO.ENV_STAGING;
        }
    }
    // eslint-disable-next-line complexity
    Environment.getEnvironment = getEnvironment;
    function isProduction() {
        return getEnvironment() === (0, $fN6oO.ENV_PRODUCTION);
    }
    Environment.isProduction = isProduction;
    function isDev() {
        return getEnvironment() === (0, $fN6oO.ENV_DEV);
    }
    Environment.isDev = isDev;
    function isStaging() {
        return getEnvironment() === (0, $fN6oO.ENV_STAGING);
    }
    Environment.isStaging = isStaging;
    function getIdentityBaseUrl() {
        if (!isProduction()) return 0, $fN6oO.URL_STAGING_IDENTITY;
        else return 0, $fN6oO.URL_PRODUCTION_IDENTITY;
    }
    Environment.getIdentityBaseUrl = getIdentityBaseUrl;
    function getWacIntegrationUrl() {
        if (!isProduction()) {
            var useQaWAC = window.location.hostname.includes("qa-wac") || window.location.hostname.includes("author");
            return useQaWAC ? (0, $fN6oO.URL_STAGING_WAC_DEPRECATED) : (0, $fN6oO.URL_STAGING_WAC);
        } else return 0, $fN6oO.URL_PRODUCTION_WAC;
    }
    Environment.getWacIntegrationUrl = getWacIntegrationUrl;
    function getApiPrivateUrl() {
        if (!isProduction()) return 0, $fN6oO.URL_STAGING_API_PRIVATE;
        else return 0, $fN6oO.URL_PRODUCTION_API_PRIVATE;
    }
    Environment.getApiPrivateUrl = getApiPrivateUrl;
    function getHamletUrl() {
        if (!isProduction()) return "".concat(getWacIntegrationUrl(), "/apis/stg/hamlet");
        else return "".concat(getWacIntegrationUrl(), "/hamlet");
    }
    Environment.getHamletUrl = getHamletUrl;
    function getInternationalSubdomain() {
        var hostnameSubdomain = getSubdomain() || "";
        if (!VALID_LOCALES.includes(hostnameSubdomain)) return false;
        return hostnameSubdomain;
    }
    Environment.getInternationalSubdomain = getInternationalSubdomain;
    function getPathLocale() {
        var pathParts = window.location.pathname.split("/");
        // check for https://author.marketing.internal.atlassian.com/wac/ja
        var localeIndex = pathParts.length > 2 && pathParts[1] === "wac" ? 2 : 1;
        return pathParts.length > 1 && VALID_LOCALES.includes(pathParts[localeIndex] || "") ? "/".concat(pathParts[localeIndex]) : "";
    }
    Environment.getPathLocale = getPathLocale;
    function getGrowthKitLocale() {
        var currentLocale = getPathLocale().substring(1);
        var growthKitLocale = BXP_TO_GROWTH_LOCALE_MAP[currentLocale];
        if (growthKitLocale !== undefined) return growthKitLocale;
        return "";
    }
    // Return a locale that is compatible with growth-kit
    // https://bitbucket.org/atlassian/growth-kit/src/master/packages/components/up-flow/_locales/
    Environment.getGrowthKitLocale = getGrowthKitLocale;
    function getCurrentSearchParam(param) {
        var bundle = param.bundle, product = param.product, edition = param.edition, templateId = param.templateId, migrationSourceUuid = param.migrationSourceUuid, developer = param.developer, src = param.src;
        var location1 = (0, $4vhRZ.Url).getLocation();
        var internationalSubdomain = getInternationalSubdomain();
        var params = new URLSearchParams(location1.search.slice(1));
        if (internationalSubdomain) params.set("lang", internationalSubdomain);
        if (bundle) params.set("bundle", bundle);
        if (product) params.set("product", product);
        if (edition) params.set("edition", edition);
        if (templateId) params.set("templateId", templateId);
        if (migrationSourceUuid) params.set("migrationSourceUuid", migrationSourceUuid);
        if (developer) params.set("developer", developer);
        if (src) params.set("src", src);
        return "?" + params.toString();
    }
    Environment.getCurrentSearchParam = getCurrentSearchParam;
    function getParam(param) {
        var params = new URLSearchParams(location.search.slice(1));
        return params.get(param);
    }
    Environment.getParam = getParam;
    function getSocialSignUpUrl(param) {
        var loginGoogleOrigin = param.loginGoogleOrigin, socialContinueUrl = param.socialContinueUrl, bundle = param.bundle, product = param.product, edition = param.edition, templateId = param.templateId, migrationSourceUuid = param.migrationSourceUuid, developer = param.developer, src = param.src, continueUrlOverride = param.continueUrlOverride;
        var splitPath = socialContinueUrl.split("/");
        // @ts-ignore
        if (splitPath.length >= 2 && splitPath[1].includes("wac")) {
            // remove contextual path if applicable
            splitPath.splice(0, 2);
            socialContinueUrl = "/".concat(splitPath.join("/"));
        }
        socialContinueUrl = "".concat(getWacIntegrationUrl()).concat(socialContinueUrl);
        var signupSocialUrl = "".concat(socialContinueUrl).concat(getCurrentSearchParam({
            bundle: bundle,
            product: product,
            edition: edition,
            templateId: templateId,
            migrationSourceUuid: migrationSourceUuid,
            developer: developer,
            src: src
        }));
        var cobranding = "application=wac";
        var socialSignup = "&social-signup-login=true";
        var atlOrigin = "&atlOrigin=".concat(encodeURIComponent(loginGoogleOrigin));
        var continueUrl = "&continue=".concat(encodeURIComponent("".concat(signupSocialUrl).concat(socialSignup)));
        var accountPrompt = "&prompt=select_account";
        if (templateId && continueUrlOverride) continueUrl = "&continue=".concat(encodeURIComponent(continueUrlOverride));
        return "".concat(getIdentityBaseUrl(), "/login/initiate/google?").concat(cobranding).concat(atlOrigin).concat(continueUrl).concat(accountPrompt);
    }
    Environment.getSocialSignUpUrl = getSocialSignUpUrl;
    function getIdSigninUrl(atlOriginId, skipEncoding, continueUrlOverride) {
        var currentUrl = skipEncoding ? (0, $4vhRZ.Url).getUrl() : encodeURIComponent((0, $4vhRZ.Url).getUrl());
        if (continueUrlOverride) currentUrl = skipEncoding ? continueUrlOverride : encodeURIComponent(continueUrlOverride);
        var returnUrl = atlOriginId ? "".concat(getIdentityBaseUrl(), "/login?atlOrigin=").concat(atlOriginId, "&continue=").concat(currentUrl) : "".concat(getIdentityBaseUrl(), "/login?continue=").concat(currentUrl);
        return returnUrl;
    }
    Environment.getIdSigninUrl = getIdSigninUrl;
    function getIdSwitchUserUrl(atlOriginId) {
        var idSigninUrl = new URL(getIdSigninUrl(atlOriginId, false));
        idSigninUrl.searchParams.set("application", "wac");
        idSigninUrl.searchParams.set("prompt", "select_account");
        return idSigninUrl.toString();
    }
    Environment.getIdSwitchUserUrl = getIdSwitchUserUrl;
    Environment.reCaptchaKey = isProduction() ? (0, $fN6oO.RECAPTCHA_KEY) : (0, $fN6oO.RECAPTCHA_KEY_TEST);
})($fbf827fc14e8dad8$export$7dc6752a22ab011a || ($fbf827fc14e8dad8$export$7dc6752a22ab011a = {}));

});
parcelRegister("fN6oO", function(module, exports) {

$parcel$export(module.exports, "ENV_DEV", function () { return $c5a070dddf12c967$export$395710bce26e0bbe; });
$parcel$export(module.exports, "ENV_STAGING", function () { return $c5a070dddf12c967$export$c0ff33dc19b9700c; });
$parcel$export(module.exports, "ENV_PRODUCTION", function () { return $c5a070dddf12c967$export$4342d8832354880f; });
$parcel$export(module.exports, "URL_STAGING_IDENTITY", function () { return $c5a070dddf12c967$export$5e856692c0a3368e; });
$parcel$export(module.exports, "URL_PRODUCTION_IDENTITY", function () { return $c5a070dddf12c967$export$b74fe7f72ce73c14; });
$parcel$export(module.exports, "URL_STAGING_WAC_DEPRECATED", function () { return $c5a070dddf12c967$export$3b3310a1a582f0c6; });
$parcel$export(module.exports, "URL_STAGING_WAC", function () { return $c5a070dddf12c967$export$209563a60562fbdb; });
$parcel$export(module.exports, "URL_PRODUCTION_WAC", function () { return $c5a070dddf12c967$export$80425ef5138cf2f0; });
$parcel$export(module.exports, "URL_STAGING_API_PRIVATE", function () { return $c5a070dddf12c967$export$2fd2486655328842; });
$parcel$export(module.exports, "URL_PRODUCTION_API_PRIVATE", function () { return $c5a070dddf12c967$export$89e6da4dd8bae962; });
$parcel$export(module.exports, "RECAPTCHA_KEY", function () { return $c5a070dddf12c967$export$3c733ac79bd72e45; });
$parcel$export(module.exports, "RECAPTCHA_KEY_TEST", function () { return $c5a070dddf12c967$export$f8fc2e45c8a667fe; });
$parcel$export(module.exports, "ProductKey", function () { return $c5a070dddf12c967$export$f3a53bd43617a593; });
$parcel$export(module.exports, "AppKey", function () { return $c5a070dddf12c967$export$e50fec5b87d6cd71; });
/**
 * Commonly-used constants, enums/mappings
 */ var $c5a070dddf12c967$export$b1f75679747bdf24 = "US";
var $c5a070dddf12c967$export$427ae666c2c86a64 = "USD";
var $c5a070dddf12c967$export$395710bce26e0bbe = "dev";
var $c5a070dddf12c967$export$c0ff33dc19b9700c = "staging";
var $c5a070dddf12c967$export$4342d8832354880f = "production";
var $c5a070dddf12c967$export$5e856692c0a3368e = "https://id.stg.internal.atlassian.com";
var $c5a070dddf12c967$export$b74fe7f72ce73c14 = "https://id.atlassian.com";
var $c5a070dddf12c967$export$3b3310a1a582f0c6 = "https://qa-wac.internal.atlassian.com";
var $c5a070dddf12c967$export$209563a60562fbdb = "https://wac.stg.internal.atlassian.com";
var $c5a070dddf12c967$export$80425ef5138cf2f0 = "https://www.atlassian.com";
var $c5a070dddf12c967$export$2fd2486655328842 = "https://wac.stg.internal.atlassian.com/gateway/api";
var $c5a070dddf12c967$export$89e6da4dd8bae962 = "https://www.atlassian.com/gateway/api";
var $c5a070dddf12c967$export$3c733ac79bd72e45 = "6LeTa5ocAAAAAJefQaFL-1ENlPNY3Wq2j-GhcZ6n";
var $c5a070dddf12c967$export$f8fc2e45c8a667fe = "6Lf0JekdAAAAAAWT2kBc89gFVKhxkwTPxa-e9tvx";
var $c5a070dddf12c967$export$f3a53bd43617a593;
(function(ProductKey) {
    ProductKey["JIRA_SOFTWARE"] = "jira-software.ondemand";
    ProductKey["BITBUCKET"] = "com.atlassian.bitbucket";
    ProductKey["CONFLUENCE"] = "confluence.ondemand";
    ProductKey["OPSGENIE"] = "opsgenie";
    ProductKey["JIRA_SERVICE_DESK"] = "jira-servicedesk.ondemand";
    ProductKey["JIRA_SERVICE_MANAGEMENT"] = "jira-servicedesk.ondemand";
    ProductKey["JIRA_CORE"] = "jira-core.ondemand";
    ProductKey["JIRA_WORK_MANAGEMENT"] = "jira-core.ondemand";
    ProductKey["ACCESS"] = "com.atlassian.identity-manager";
    ProductKey["STATUSPAGE"] = "statuspage";
    ProductKey["CONFLUENCE_PLUGIN_QUESTIONS"] = "com.atlassian.confluence.plugins.confluence-questions.ondemand";
    ProductKey["CONFLUENCE_TEAM_CALENDARS"] = "team.calendars.confluence.ondemand";
    ProductKey["JIRA_ROADMAPS"] = "com.radiantminds.roadmaps-jira.ondemand";
    ProductKey["JIRA_BONFIRE"] = "bonfire.jira.ondemand";
    ProductKey["JIRA_REFAPP"] = "refapp";
    ProductKey["TEAM_CENTRAL"] = "townsquare";
    ProductKey["JIRA_PRODUCT_DISCOVERY"] = "jira-product-discovery";
    ProductKey["COMPASS"] = "compass";
    ProductKey["ATLAS"] = "townsquare";
    ProductKey["FABRIC"] = "atlassian-whiteboard";
    ProductKey["BEACON"] = "beacon";
})($c5a070dddf12c967$export$f3a53bd43617a593 || ($c5a070dddf12c967$export$f3a53bd43617a593 = {}));
var $c5a070dddf12c967$export$e50fec5b87d6cd71;
(function(AppKey) {
    AppKey["TEMPO"] = "is.origo.jira.tempo-plugin";
    AppKey["ZEPHYR"] = "com.thed.zephyr.je";
    AppKey["BIGPICTURE"] = "eu.softwareplant.bigpicture";
})($c5a070dddf12c967$export$e50fec5b87d6cd71 || ($c5a070dddf12c967$export$e50fec5b87d6cd71 = {}));

});

parcelRegister("4vhRZ", function(module, exports) {

$parcel$export(module.exports, "Url", function () { return $a08576f5782c4f78$export$59d795186a5d3f58; });
var $a08576f5782c4f78$export$59d795186a5d3f58;
(function(Url) {
    function getLocation() {
        return window.location;
    }
    Url.getLocation = getLocation;
    function getUrl() {
        return getLocation().href;
    }
    Url.getUrl = getUrl;
    function getUnhashedUrl() {
        var url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : getUrl();
        url = url || window.location.href;
        var hashIndex = url.indexOf("#");
        return url.substring(0, hashIndex > -1 ? hashIndex : url.length);
    }
    Url.getUnhashedUrl = getUnhashedUrl;
    function htmlEscape(str) {
        return String(str).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    }
    Url.htmlEscape = htmlEscape;
    function getParameterByName(name) {
        var url = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : getUrl();
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
        var results = regex.exec(url);
        if (!results || !results[2]) return "";
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }
    Url.getParameterByName = getParameterByName;
    function getQueryString() {
        var url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : getUrl();
        var _window_location_search, _window_location;
        var questionIndex;
        var r = (_window_location = window.location) === null || _window_location === void 0 ? void 0 : (_window_location_search = _window_location.search) === null || _window_location_search === void 0 ? void 0 : _window_location_search.substring(1, window.location.search.length);
        if (url) {
            url = getUnhashedUrl(url);
            questionIndex = url.indexOf("?");
            r = questionIndex > -1 ? url.substring(questionIndex + 1) : "";
        }
        return r;
    }
    Url.getQueryString = getQueryString;
    function getUrlParams() {
        var url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : getUrl();
        var qs = getQueryString(url);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var r = null;
        var paramPairs;
        var keyValuePair;
        if (qs) {
            paramPairs = decodeURIComponent(qs).split("&");
            for(var i = 0, iLen = paramPairs.length; i < iLen; i++){
                if (!r) r = {};
                // @ts-ignore
                keyValuePair = paramPairs[i].split("=");
                if (keyValuePair.length > 2) // @ts-ignore
                keyValuePair[1] = paramPairs[i].split("=").slice(1).join("=");
                // @ts-ignore
                r[keyValuePair[0]] = keyValuePair.length > 1 ? // @ts-ignore
                decodeURIComponent(keyValuePair[1]) : null;
            }
        }
        return r;
    }
    Url.getUrlParams = getUrlParams;
})($a08576f5782c4f78$export$59d795186a5d3f58 || ($a08576f5782c4f78$export$59d795186a5d3f58 = {}));

});


parcelRegister("2DKGq", function(module, exports) {

$parcel$export(module.exports, "getFirstName", function () { return $c1a7bc03bdf7938f$export$cf3a9fa4cebe2986; });
$parcel$export(module.exports, "getLastName", function () { return $c1a7bc03bdf7938f$export$7e754b0f7b365efd; });
parcelRequire("eb65f");
var $8JWVu = parcelRequire("8JWVu");
parcelRequire("3nMqF");
var $39wmd = parcelRequire("39wmd");
function $c1a7bc03bdf7938f$export$d60f4fada65a69be() {
    var stargateClient = new (0, $8JWVu.BxpWebStargateClient)({
        baseUrl: (0, $39wmd.Environment).getApiPrivateUrl()
    });
    return stargateClient.me({});
}
var $c1a7bc03bdf7938f$export$cf3a9fa4cebe2986 = function() {
    var fullName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return fullName.trim().split(" ")[0] || "";
};
var $c1a7bc03bdf7938f$export$7e754b0f7b365efd = function() {
    var fullName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var lastName = "";
    var names = fullName.trim().split(" ");
    if (names.length > 1) {
        names.shift();
        lastName = names.join(" ");
    }
    return lastName || ".";
};

});

parcelRegister("iPDfU", function(module, exports) {

$parcel$export(module.exports, "Storage", function () { return $7f592f34e87b2627$export$bf2a15d34f3c441c; });
/**
 * sessionStorage, localStorage, cookie storage, etc.
 */ var $7f592f34e87b2627$export$bf2a15d34f3c441c;
(function(Storage) {
    function hasStorage() {
        return localStorage && sessionStorage && typeof localStorage.getItem === "function" && typeof sessionStorage.getItem === "function";
    }
    Storage.hasStorage = hasStorage;
    function getLocalStorage(key) {
        if (!hasStorage) return getCookie(key);
        return localStorage.getItem(key);
    }
    /**
   * Localstorage (w/ fallback to cookies)
   */ Storage.getLocalStorage = getLocalStorage;
    function setLocalStorage(key, value) {
        if (!hasStorage) setCookie(key, value);
        try {
            localStorage.setItem(key, value);
        } catch (e) {
            // Don't store for private browsing
            // tslint:disable-next-line:no-console
            console.log("Local Storage failed, check if browsing in Safari private window.");
        }
    }
    Storage.setLocalStorage = setLocalStorage;
    function removeLocalStorage(key) {
        if (!hasStorage) removeCookie(key);
        try {
            localStorage.removeItem(key);
        } catch (e) {
            // Don't remove for private browsing
            // tslint:disable-next-line:no-console
            console.log("Local Storage failed, check if browsing in Safari private window.");
        }
    }
    Storage.removeLocalStorage = removeLocalStorage;
    function getSessionStorage(key) {
        if (!hasStorage) return getCookie(key);
        return sessionStorage.getItem(key);
    }
    /**
   * Sessionstorage (w/ fallback to cookies)
   */ Storage.getSessionStorage = getSessionStorage;
    function setSessionStorage(key, value) {
        if (!hasStorage) setCookie(key, value);
        try {
            sessionStorage.setItem(key, value);
        } catch (e) {
            // Don't store for private browsing
            // tslint:disable-next-line:no-console
            console.log("Session Storage failed, check if browsing in Safari private window.");
        }
    }
    Storage.setSessionStorage = setSessionStorage;
    function removeSessionStorage(key) {
        if (!hasStorage) removeCookie(key);
        try {
            sessionStorage.removeItem(key);
        } catch (e) {
            // Don't remove for private browsing
            // tslint:disable-next-line:no-console
            console.log("Session Storage failed, check if browsing in Safari private window.");
        }
    }
    Storage.removeSessionStorage = removeSessionStorage;
    function getCookie(key) {
        var encodedName = encodeURIComponent(key).replace(/[\-\.\+\*]/g, "\\$&");
        var regex = new RegExp("(?:(?:^|.*;)\\s*" + encodedName + "\\s*\\=\\s*([^;]*).*$)|^.*$");
        return decodeURIComponent(document.cookie.replace(regex, "$1")) || null;
    }
    /**
   * Cookie
   */ Storage.getCookie = getCookie;
    function setCookie(key, value, days, sameSite) {
        var expires = "";
        var sameSiteString = sameSite ? "; SameSite=".concat(sameSite && sameSite === "Strict" || sameSite === "Lax" ? sameSite : "None") : "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + days * 86400000);
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = key + "=" + value + expires + sameSiteString + "; path=/";
    }
    Storage.setCookie = setCookie;
    function removeCookie(key) {
        setCookie(key, "", -1);
    }
    Storage.removeCookie = removeCookie;
})($7f592f34e87b2627$export$bf2a15d34f3c441c || ($7f592f34e87b2627$export$bf2a15d34f3c441c = {}));

});

parcelRegister("cq0Ay", function(module, exports) {

$parcel$export(module.exports, "getIsBundleBbJsw", function () { return $0aca870a0727f111$export$967b7c98eb3e396d; });
$parcel$export(module.exports, "getIsBundleDevops", function () { return $0aca870a0727f111$export$8e42e76b67f3c20; });

var $lFPa6 = parcelRequire("lFPa6");
parcelRequire("3nMqF");
var $fN6oO = parcelRequire("fN6oO");
var $0aca870a0727f111$export$967b7c98eb3e396d = function(products) {
    return products.length === 2 && (0, (/*@__PURE__*/$parcel$interopDefault($lFPa6))).includes((0, (/*@__PURE__*/$parcel$interopDefault($lFPa6))).map(products, function(val) {
        return val.product === (0, $fN6oO.ProductKey).JIRA_SOFTWARE;
    }), true) && (0, (/*@__PURE__*/$parcel$interopDefault($lFPa6))).includes((0, (/*@__PURE__*/$parcel$interopDefault($lFPa6))).map(products, function(val) {
        return val.product === (0, $fN6oO.ProductKey).BITBUCKET;
    }), true);
};
var $0aca870a0727f111$export$8e42e76b67f3c20 = function(products) {
    return products.length === 4 && (0, (/*@__PURE__*/$parcel$interopDefault($lFPa6))).includes((0, (/*@__PURE__*/$parcel$interopDefault($lFPa6))).map(products, function(val) {
        return val.product === (0, $fN6oO.ProductKey).JIRA_SOFTWARE;
    }), true) && (0, (/*@__PURE__*/$parcel$interopDefault($lFPa6))).includes((0, (/*@__PURE__*/$parcel$interopDefault($lFPa6))).map(products, function(val) {
        return val.product === (0, $fN6oO.ProductKey).CONFLUENCE;
    }), true) && (0, (/*@__PURE__*/$parcel$interopDefault($lFPa6))).includes((0, (/*@__PURE__*/$parcel$interopDefault($lFPa6))).map(products, function(val) {
        return val.product === (0, $fN6oO.ProductKey).BITBUCKET;
    }), true) && (0, (/*@__PURE__*/$parcel$interopDefault($lFPa6))).includes((0, (/*@__PURE__*/$parcel$interopDefault($lFPa6))).map(products, function(val) {
        return val.product === (0, $fN6oO.ProductKey).OPSGENIE;
    }), true);
};

});

parcelRegister("7HUGN", function(module, exports) {

$parcel$export(module.exports, "defineMessagesSimple", function () { return $2ab30fc21d6d81df$export$8e588bcdedc394ea; });

var $cv9Rk = parcelRequire("cv9Rk");

var $6gDD1 = parcelRequire("6gDD1");
function $2ab30fc21d6d81df$export$8e588bcdedc394ea(prefix, messages) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var tranformedMessages = {};
    Object.entries(messages).map(function(param) {
        var _param = (0, $cv9Rk._)(param, 2), key = _param[0], value = _param[1];
        tranformedMessages[key] = {
            id: "".concat(prefix, ".").concat(key),
            defaultMessage: value
        };
    });
    return (0, $6gDD1.defineMessages)(tranformedMessages);
}

});
parcelRegister("6gDD1", function(module, exports) {

$parcel$export(module.exports, "defineMessages", function () { return $4902fa0eb2ea37a6$export$1adfeb024f5185b; });

var $g3Rk8 = parcelRequire("g3Rk8");

var $4P5Sm = parcelRequire("4P5Sm");

var $8pPrt = parcelRequire("8pPrt");

var $kMa9P = parcelRequire("kMa9P");



var $dFwuF = parcelRequire("dFwuF");


function $4902fa0eb2ea37a6$export$1adfeb024f5185b(msgs) {
    return msgs;
}
function $4902fa0eb2ea37a6$export$747d244ee58120dd(msg) {
    return msg;
}
var $4902fa0eb2ea37a6$export$40ae3194919d16b = (0, $g3Rk8.createFormattedComponent)("formatDate");
var $4902fa0eb2ea37a6$export$5b390a54f8a846f7 = (0, $g3Rk8.createFormattedComponent)("formatTime");
var $4902fa0eb2ea37a6$export$db80edc1e6b2f63d = (0, $g3Rk8.createFormattedComponent)("formatNumber");
var $4902fa0eb2ea37a6$export$f52b44e459e6e71d = (0, $g3Rk8.createFormattedComponent)("formatList");
var $4902fa0eb2ea37a6$export$c2336ea5aaab92fa = (0, $g3Rk8.createFormattedComponent)("formatDisplayName");
var $4902fa0eb2ea37a6$export$7fdc7d2c91ce149b = (0, $g3Rk8.createFormattedDateTimePartsComponent)("formatDate");
var $4902fa0eb2ea37a6$export$ec35873761676c2a = (0, $g3Rk8.createFormattedDateTimePartsComponent)("formatTime");

});
parcelRegister("g3Rk8", function(module, exports) {

$parcel$export(module.exports, "createFormattedDateTimePartsComponent", function () { return $bb164a200d4d4d2d$export$7448277f6036d2ab; });
$parcel$export(module.exports, "createFormattedComponent", function () { return $bb164a200d4d4d2d$export$b37e14176d001dec; });

var $l29cN = parcelRequire("l29cN");

var $1Mpn7 = parcelRequire("1Mpn7");

var $8pPrt = parcelRequire("8pPrt");
var $bb164a200d4d4d2d$var$DisplayName;
(function(DisplayName) {
    DisplayName["formatDate"] = "FormattedDate";
    DisplayName["formatTime"] = "FormattedTime";
    DisplayName["formatNumber"] = "FormattedNumber";
    DisplayName["formatList"] = "FormattedList";
    // Note that this DisplayName is the locale display name, not to be confused with
    // the name of the enum, which is for React component display name in dev tools.
    DisplayName["formatDisplayName"] = "FormattedDisplayName";
})($bb164a200d4d4d2d$var$DisplayName || ($bb164a200d4d4d2d$var$DisplayName = {}));
var $bb164a200d4d4d2d$var$DisplayNameParts;
(function(DisplayNameParts) {
    DisplayNameParts["formatDate"] = "FormattedDateParts";
    DisplayNameParts["formatTime"] = "FormattedTimeParts";
    DisplayNameParts["formatNumber"] = "FormattedNumberParts";
    DisplayNameParts["formatList"] = "FormattedListParts";
})($bb164a200d4d4d2d$var$DisplayNameParts || ($bb164a200d4d4d2d$var$DisplayNameParts = {}));
var $bb164a200d4d4d2d$export$54d4989ed3eea1ea = function FormattedNumberParts(props) {
    var intl = (0, $8pPrt.default)();
    var value = props.value, children = props.children, formatProps = (0, $l29cN.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatNumberToParts(value, formatProps));
};
$bb164a200d4d4d2d$export$54d4989ed3eea1ea.displayName = "FormattedNumberParts";
var $bb164a200d4d4d2d$export$5ac259c7da6d2188 = function FormattedListParts(props) {
    var intl = (0, $8pPrt.default)();
    var value = props.value, children = props.children, formatProps = (0, $l29cN.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatListToParts(value, formatProps));
};
$bb164a200d4d4d2d$export$54d4989ed3eea1ea.displayName = "FormattedNumberParts";
function $bb164a200d4d4d2d$export$7448277f6036d2ab(name) {
    var ComponentParts = function ComponentParts(props) {
        var intl = (0, $8pPrt.default)();
        var value = props.value, children = props.children, formatProps = (0, $l29cN.__rest)(props, [
            "value",
            "children"
        ]);
        var date = typeof value === "string" ? new Date(value || 0) : value;
        var formattedParts = name === "formatDate" ? intl.formatDateToParts(date, formatProps) : intl.formatTimeToParts(date, formatProps);
        return children(formattedParts);
    };
    ComponentParts.displayName = $bb164a200d4d4d2d$var$DisplayNameParts[name];
    return ComponentParts;
}
function $bb164a200d4d4d2d$export$b37e14176d001dec(name) {
    var Component = function Component(props) {
        var intl = (0, $8pPrt.default)();
        var value = props.value, children = props.children, formatProps = (0, $l29cN.__rest)(props, [
            "value",
            "children"
        ]);
        // TODO: fix TS type definition for localeMatcher upstream
        var formattedValue = intl[name](value, formatProps);
        if (typeof children === "function") return children(formattedValue);
        var Text = intl.textComponent || $1Mpn7.Fragment;
        return $1Mpn7.createElement(Text, null, formattedValue);
    };
    Component.displayName = $bb164a200d4d4d2d$var$DisplayName[name];
    return Component;
}

});

parcelRegister("dFwuF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f384f3ec5e110bf$export$2e2bcd8739ae039; });
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $l29cN = parcelRequire("l29cN");

var $1Mpn7 = parcelRequire("1Mpn7");

var $8pPrt = parcelRequire("8pPrt");

var $8xhJC = parcelRequire("8xhJC");
function $9f384f3ec5e110bf$var$areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0, $l29cN.__rest)(prevProps, [
        "values"
    ]);
    var nextValues = nextProps.values, nextOtherProps = (0, $l29cN.__rest)(nextProps, [
        "values"
    ]);
    return (0, $8xhJC.shallowEqual)(nextValues, values) && (0, $8xhJC.shallowEqual)(otherProps, nextOtherProps);
}
function $9f384f3ec5e110bf$var$FormattedMessage(props) {
    var intl = (0, $8pPrt.default)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? $1Mpn7.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = {
        id: id,
        description: description,
        defaultMessage: defaultMessage
    };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag
    });
    if (typeof children === "function") return children(Array.isArray(nodes) ? nodes : [
        nodes
    ]);
    if (Component) return $1Mpn7.createElement(Component, null, $1Mpn7.Children.toArray(nodes));
    return $1Mpn7.createElement($1Mpn7.Fragment, null, nodes);
}
$9f384f3ec5e110bf$var$FormattedMessage.displayName = "FormattedMessage";
var $9f384f3ec5e110bf$var$MemoizedFormattedMessage = $1Mpn7.memo($9f384f3ec5e110bf$var$FormattedMessage, $9f384f3ec5e110bf$var$areEqual);
$9f384f3ec5e110bf$var$MemoizedFormattedMessage.displayName = "MemoizedFormattedMessage";
var $9f384f3ec5e110bf$export$2e2bcd8739ae039 = $9f384f3ec5e110bf$var$MemoizedFormattedMessage;

});



parcelRegister("9ap2n", function(module, exports) {

$parcel$export(module.exports, "OfferingCatalog", function () { return $2d4add6ec9f93b38$export$82e88cf9c9975cf0; });
// Here is the ticket, where we pulled the offering ID's
// https://hello.atlassian.net/browse/BXPSU-421

var $4GJKx = parcelRequire("4GJKx");

var $3sHb8 = parcelRequire("3sHb8");

var $fN6oO = parcelRequire("fN6oO");
var $2d4add6ec9f93b38$var$PricingType;
(function(PricingType) {
    PricingType["FREE"] = "FREE";
    PricingType["PAID"] = "PAID";
    PricingType["LIMITED_FREE"] = "LIMITED_FREE";
})($2d4add6ec9f93b38$var$PricingType || ($2d4add6ec9f93b38$var$PricingType = {}));
var $2d4add6ec9f93b38$var$_obj, $2d4add6ec9f93b38$var$_obj1, $2d4add6ec9f93b38$var$_obj2;
var $2d4add6ec9f93b38$var$OFFERING_IDS = {
    dev: ($2d4add6ec9f93b38$var$_obj = {}, (0, $3sHb8._)($2d4add6ec9f93b38$var$_obj, (0, $fN6oO.ProductKey).JIRA_SOFTWARE, {
        free: {
            offeringId: "de2887c9-8a55-41d5-b5cf-ad6a5589ebed",
            productKey: (0, $fN6oO.ProductKey).JIRA_SOFTWARE,
            pricingType: "FREE",
            edition: "free",
            chargeElement: "user"
        },
        standard: {
            offeringId: "a70b5cbb-1ae1-4003-8f4a-9001a4a50526",
            productKey: (0, $fN6oO.ProductKey).JIRA_SOFTWARE,
            pricingType: "PAID",
            edition: "standard",
            chargeElement: "user"
        },
        premium: {
            offeringId: "6dd805b4-da75-4374-a7a7-cf0b12f7ea07",
            productKey: (0, $fN6oO.ProductKey).JIRA_SOFTWARE,
            pricingType: "PAID",
            edition: "premium",
            chargeElement: "user"
        }
    }), (0, $3sHb8._)($2d4add6ec9f93b38$var$_obj, (0, $fN6oO.ProductKey).CONFLUENCE, {
        free: {
            offeringId: "7547cfd6-a804-4e42-8bed-e656d49ea09e",
            productKey: (0, $fN6oO.ProductKey).CONFLUENCE,
            pricingType: "FREE",
            edition: "free",
            chargeElement: "user"
        },
        standard: {
            offeringId: "2eda1119-fab4-4699-ab37-ff8f12052cde",
            productKey: (0, $fN6oO.ProductKey).CONFLUENCE,
            pricingType: "PAID",
            edition: "standard",
            chargeElement: "user"
        },
        premium: {
            offeringId: "06ef245c-5fa3-473b-8822-5e6fe072ae4b",
            productKey: (0, $fN6oO.ProductKey).CONFLUENCE,
            pricingType: "PAID",
            edition: "premium",
            chargeElement: "user"
        }
    }), (0, $3sHb8._)($2d4add6ec9f93b38$var$_obj, (0, $fN6oO.ProductKey).JIRA_SERVICE_MANAGEMENT, {
        free: {
            offeringId: "2bad3c2f-d740-44a9-b08d-849202f11830",
            productKey: (0, $fN6oO.ProductKey).JIRA_SERVICE_MANAGEMENT,
            pricingType: "FREE",
            edition: "free",
            chargeElement: "agent"
        },
        standard: {
            offeringId: "396efb16-749b-41fa-9cd1-ad10cfefa1d0",
            productKey: (0, $fN6oO.ProductKey).JIRA_SERVICE_MANAGEMENT,
            pricingType: "PAID",
            edition: "standard",
            chargeElement: "agent"
        },
        premium: {
            offeringId: "0c6683b4-4633-4673-beca-690d171de6a5",
            productKey: (0, $fN6oO.ProductKey).JIRA_SERVICE_MANAGEMENT,
            pricingType: "PAID",
            edition: "premium",
            chargeElement: "agent"
        },
        halp: {
            offeringId: "396efb16-749b-41fa-9cd1-ad10cfefa1d0",
            // https://workbench.staging.atl-paas.net/offerings/396efb16-749b-41fa-9cd1-ad10cfefa1d0
            pricingPlanId: "7701f274-6c84-45cd-bdb0-493a67355e61",
            // https://workbench.staging.atl-paas.net/products/jira-servicedesk.ondemand/plans/7701f274-6c84-45cd-bdb0-493a67355e61
            pricingType: "PAID",
            // pricing type for CCP
            productKey: (0, $fN6oO.ProductKey).JIRA_SERVICE_MANAGEMENT,
            edition: "standard",
            chargeElement: "agent"
        }
    }), (0, $3sHb8._)($2d4add6ec9f93b38$var$_obj, (0, $fN6oO.ProductKey).JIRA_WORK_MANAGEMENT, {
        free: {
            offeringId: "769055e8-05f5-4b1a-ba1a-a1afc874ee6d",
            productKey: (0, $fN6oO.ProductKey).JIRA_WORK_MANAGEMENT,
            pricingType: "FREE",
            edition: "free",
            chargeElement: "user"
        },
        standard: {
            offeringId: "5ab35ef5-e441-493a-b6e0-ba2d21a72ac6",
            productKey: (0, $fN6oO.ProductKey).JIRA_WORK_MANAGEMENT,
            pricingType: "PAID",
            edition: "standard",
            chargeElement: "user"
        },
        premium: {
            offeringId: "d8e9a61a-c83b-4e40-a757-997d5bae2bb2",
            productKey: (0, $fN6oO.ProductKey).JIRA_WORK_MANAGEMENT,
            pricingType: "PAID",
            edition: "premium",
            chargeElement: "user"
        }
    }), (0, $3sHb8._)($2d4add6ec9f93b38$var$_obj, (0, $fN6oO.ProductKey).JIRA_PRODUCT_DISCOVERY, {
        free: {
            offeringId: "d843dd9e-23c5-4d27-af44-5009d568cb6e",
            productKey: (0, $fN6oO.ProductKey).JIRA_PRODUCT_DISCOVERY,
            pricingType: "FREE",
            edition: "free",
            chargeElement: "user"
        },
        standard: {
            offeringId: "35b9268e-66e2-45fb-81d3-dacd1e31831a",
            productKey: (0, $fN6oO.ProductKey).JIRA_PRODUCT_DISCOVERY,
            pricingType: "PAID",
            edition: "standard",
            chargeElement: "user"
        }
    }), (0, $3sHb8._)($2d4add6ec9f93b38$var$_obj, (0, $fN6oO.ProductKey).COMPASS, {
        beta: {
            offeringId: "7af07cb3-d4e5-473e-87b3-3ae3bc9248a6",
            productKey: (0, $fN6oO.ProductKey).COMPASS,
            edition: "beta",
            chargeElement: "user"
        },
        free: {
            offeringId: "1d1951e5-881c-4f75-b0cd-3c6859dd5759",
            productKey: (0, $fN6oO.ProductKey).COMPASS,
            pricingType: "FREE",
            edition: "free",
            chargeElement: "user"
        },
        standard: {
            offeringId: "575abf20-6cac-4bbc-9666-1791fae8d822",
            productKey: (0, $fN6oO.ProductKey).COMPASS,
            pricingType: "PAID",
            edition: "standard",
            chargeElement: "user"
        }
    }), (0, $3sHb8._)($2d4add6ec9f93b38$var$_obj, (0, $fN6oO.ProductKey).ATLAS, {
        free: {
            offeringId: "88064fa1-b573-4358-a9de-ec350aac1ddc",
            productKey: (0, $fN6oO.ProductKey).ATLAS,
            pricingType: "FREE",
            edition: "free",
            chargeElement: "user"
        },
        standard: {
            offeringId: "01c8ddad-8ea4-4da9-8127-71d6ff6de1c9",
            productKey: (0, $fN6oO.ProductKey).ATLAS,
            pricingType: "PAID",
            edition: "standard",
            chargeElement: "user"
        },
        premium: {
            offeringId: "f7866043-d6e4-4d54-9c6a-4f82c6a1ebe5",
            productKey: (0, $fN6oO.ProductKey).ATLAS,
            pricingType: "PAID",
            edition: "premium",
            chargeElement: "user"
        }
    }), (0, $3sHb8._)($2d4add6ec9f93b38$var$_obj, (0, $fN6oO.ProductKey).OPSGENIE, {
        free: {
            offeringId: "d0c6ab1d-d8ea-49f8-8893-eafca2e05158",
            productKey: (0, $fN6oO.ProductKey).OPSGENIE,
            pricingType: "FREE",
            edition: "essentials",
            chargeElement: "user"
        }
    }), (0, $3sHb8._)($2d4add6ec9f93b38$var$_obj, (0, $fN6oO.ProductKey).FABRIC, {
        free: {
            offeringId: "b0c7b413-b264-4c01-8b67-c61aa2c3e455",
            productKey: (0, $fN6oO.ProductKey).FABRIC,
            pricingType: "FREE",
            edition: "free",
            chargeElement: "user"
        }
    }), (0, $3sHb8._)($2d4add6ec9f93b38$var$_obj, (0, $fN6oO.ProductKey).STATUSPAGE, {
        free: {
            offeringId: "cff16c60-539b-11ea-8d77-2e728ce88125",
            productKey: (0, $fN6oO.ProductKey).STATUSPAGE,
            pricingType: "FREE",
            edition: "free",
            chargeElement: "user"
        }
    }), (0, $3sHb8._)($2d4add6ec9f93b38$var$_obj, (0, $fN6oO.ProductKey).BITBUCKET, {
        free: {
            offeringId: "00000000-0000-0000-0000-000000000000",
            productKey: (0, $fN6oO.ProductKey).BITBUCKET,
            pricingType: "FREE",
            edition: "free",
            chargeElement: "user"
        },
        standard: {
            offeringId: "00000000-0000-0000-0000-000000000000",
            productKey: (0, $fN6oO.ProductKey).BITBUCKET,
            pricingType: "PAID",
            edition: "standard",
            chargeElement: "user"
        },
        premium: {
            offeringId: "00000000-0000-0000-0000-000000000000",
            productKey: (0, $fN6oO.ProductKey).BITBUCKET,
            pricingType: "PAID",
            edition: "premium",
            chargeElement: "user"
        }
    }), $2d4add6ec9f93b38$var$_obj),
    staging: ($2d4add6ec9f93b38$var$_obj1 = {}, (0, $3sHb8._)($2d4add6ec9f93b38$var$_obj1, (0, $fN6oO.ProductKey).JIRA_SOFTWARE, {
        free: {
            offeringId: "de2887c9-8a55-41d5-b5cf-ad6a5589ebed",
            productKey: (0, $fN6oO.ProductKey).JIRA_SOFTWARE,
            pricingType: "FREE",
            edition: "free",
            chargeElement: "user",
            jiraFamilyOfferingId: "009f8789-c10c-4366-9420-f712d02a6499"
        },
        standard: {
            offeringId: "a70b5cbb-1ae1-4003-8f4a-9001a4a50526",
            productKey: (0, $fN6oO.ProductKey).JIRA_SOFTWARE,
            pricingType: "PAID",
            edition: "standard",
            chargeElement: "user",
            jiraFamilyOfferingId: "009f8789-c10c-4366-9420-f712d02a6499"
        },
        premium: {
            offeringId: "6dd805b4-da75-4374-a7a7-cf0b12f7ea07",
            productKey: (0, $fN6oO.ProductKey).JIRA_SOFTWARE,
            pricingType: "PAID",
            edition: "premium",
            chargeElement: "user",
            jiraFamilyOfferingId: "009f8789-c10c-4366-9420-f712d02a6499"
        }
    }), (0, $3sHb8._)($2d4add6ec9f93b38$var$_obj1, (0, $fN6oO.ProductKey).CONFLUENCE, {
        free: {
            offeringId: "7547cfd6-a804-4e42-8bed-e656d49ea09e",
            productKey: (0, $fN6oO.ProductKey).CONFLUENCE,
            pricingType: "FREE",
            edition: "free",
            chargeElement: "user"
        },
        standard: {
            offeringId: "2eda1119-fab4-4699-ab37-ff8f12052cde",
            productKey: (0, $fN6oO.ProductKey).CONFLUENCE,
            pricingType: "PAID",
            edition: "standard",
            chargeElement: "user"
        },
        premium: {
            offeringId: "06ef245c-5fa3-473b-8822-5e6fe072ae4b",
            productKey: (0, $fN6oO.ProductKey).CONFLUENCE,
            pricingType: "PAID",
            edition: "premium",
            chargeElement: "user"
        }
    }), (0, $3sHb8._)($2d4add6ec9f93b38$var$_obj1, (0, $fN6oO.ProductKey).JIRA_SERVICE_MANAGEMENT, {
        free: {
            offeringId: "2bad3c2f-d740-44a9-b08d-849202f11830",
            productKey: (0, $fN6oO.ProductKey).JIRA_SERVICE_MANAGEMENT,
            pricingType: "FREE",
            edition: "free",
            chargeElement: "agent",
            jiraFamilyOfferingId: "009f8789-c10c-4366-9420-f712d02a6499"
        },
        standard: {
            offeringId: "396efb16-749b-41fa-9cd1-ad10cfefa1d0",
            productKey: (0, $fN6oO.ProductKey).JIRA_SERVICE_MANAGEMENT,
            pricingType: "PAID",
            edition: "standard",
            chargeElement: "agent",
            jiraFamilyOfferingId: "009f8789-c10c-4366-9420-f712d02a6499"
        },
        premium: {
            offeringId: "0c6683b4-4633-4673-beca-690d171de6a5",
            productKey: (0, $fN6oO.ProductKey).JIRA_SERVICE_MANAGEMENT,
            pricingType: "PAID",
            edition: "premium",
            chargeElement: "agent",
            jiraFamilyOfferingId: "009f8789-c10c-4366-9420-f712d02a6499"
        },
        halp: {
            offeringId: "396efb16-749b-41fa-9cd1-ad10cfefa1d0",
            // https://workbench.staging.atl-paas.net/offerings/396efb16-749b-41fa-9cd1-ad10cfefa1d0
            pricingPlanId: "7701f274-6c84-45cd-bdb0-493a67355e61",
            // https://workbench.staging.atl-paas.net/products/jira-servicedesk.ondemand/plans/7701f274-6c84-45cd-bdb0-493a67355e61
            pricingType: "PAID",
            // pricing type for CCP
            productKey: (0, $fN6oO.ProductKey).JIRA_SERVICE_MANAGEMENT,
            edition: "standard",
            chargeElement: "agent"
        }
    }), (0, $3sHb8._)($2d4add6ec9f93b38$var$_obj1, (0, $fN6oO.ProductKey).JIRA_WORK_MANAGEMENT, {
        free: {
            offeringId: "769055e8-05f5-4b1a-ba1a-a1afc874ee6d",
            productKey: (0, $fN6oO.ProductKey).JIRA_WORK_MANAGEMENT,
            pricingType: "FREE",
            edition: "free",
            chargeElement: "user",
            jiraFamilyOfferingId: "009f8789-c10c-4366-9420-f712d02a6499"
        },
        standard: {
            offeringId: "5ab35ef5-e441-493a-b6e0-ba2d21a72ac6",
            productKey: (0, $fN6oO.ProductKey).JIRA_WORK_MANAGEMENT,
            pricingType: "PAID",
            edition: "standard",
            chargeElement: "user",
            jiraFamilyOfferingId: "009f8789-c10c-4366-9420-f712d02a6499"
        },
        premium: {
            offeringId: "d8e9a61a-c83b-4e40-a757-997d5bae2bb2",
            productKey: (0, $fN6oO.ProductKey).JIRA_WORK_MANAGEMENT,
            pricingType: "PAID",
            edition: "premium",
            chargeElement: "user"
        }
    }), (0, $3sHb8._)($2d4add6ec9f93b38$var$_obj1, (0, $fN6oO.ProductKey).JIRA_PRODUCT_DISCOVERY, {
        free: {
            offeringId: "d843dd9e-23c5-4d27-af44-5009d568cb6e",
            productKey: (0, $fN6oO.ProductKey).JIRA_PRODUCT_DISCOVERY,
            pricingType: "FREE",
            edition: "free",
            chargeElement: "user"
        },
        standard: {
            offeringId: "35b9268e-66e2-45fb-81d3-dacd1e31831a",
            productKey: (0, $fN6oO.ProductKey).JIRA_PRODUCT_DISCOVERY,
            pricingType: "PAID",
            edition: "standard",
            chargeElement: "user"
        }
    }), (0, $3sHb8._)($2d4add6ec9f93b38$var$_obj1, (0, $fN6oO.ProductKey).COMPASS, {
        beta: {
            offeringId: "7af07cb3-d4e5-473e-87b3-3ae3bc9248a6",
            productKey: (0, $fN6oO.ProductKey).COMPASS,
            edition: "beta",
            chargeElement: "user"
        },
        free: {
            offeringId: "1d1951e5-881c-4f75-b0cd-3c6859dd5759",
            productKey: (0, $fN6oO.ProductKey).COMPASS,
            pricingType: "FREE",
            edition: "free",
            chargeElement: "user"
        },
        standard: {
            offeringId: "575abf20-6cac-4bbc-9666-1791fae8d822",
            productKey: (0, $fN6oO.ProductKey).COMPASS,
            pricingType: "PAID",
            edition: "standard",
            chargeElement: "user"
        }
    }), (0, $3sHb8._)($2d4add6ec9f93b38$var$_obj1, (0, $fN6oO.ProductKey).ATLAS, {
        free: {
            offeringId: "88064fa1-b573-4358-a9de-ec350aac1ddc",
            productKey: (0, $fN6oO.ProductKey).ATLAS,
            pricingType: "FREE",
            edition: "free",
            chargeElement: "user"
        },
        standard: {
            offeringId: "01c8ddad-8ea4-4da9-8127-71d6ff6de1c9",
            productKey: (0, $fN6oO.ProductKey).ATLAS,
            pricingType: "PAID",
            edition: "standard",
            chargeElement: "user"
        },
        premium: {
            offeringId: "f7866043-d6e4-4d54-9c6a-4f82c6a1ebe5",
            productKey: (0, $fN6oO.ProductKey).ATLAS,
            pricingType: "PAID",
            edition: "premium",
            chargeElement: "user"
        }
    }), (0, $3sHb8._)($2d4add6ec9f93b38$var$_obj1, (0, $fN6oO.ProductKey).OPSGENIE, {
        free: {
            offeringId: "d0c6ab1d-d8ea-49f8-8893-eafca2e05158",
            productKey: (0, $fN6oO.ProductKey).OPSGENIE,
            pricingType: "FREE",
            edition: "essentials",
            chargeElement: "user"
        }
    }), (0, $3sHb8._)($2d4add6ec9f93b38$var$_obj1, (0, $fN6oO.ProductKey).FABRIC, {
        free: {
            offeringId: "b0c7b413-b264-4c01-8b67-c61aa2c3e455",
            productKey: (0, $fN6oO.ProductKey).FABRIC,
            pricingType: "FREE",
            edition: "free",
            chargeElement: "user"
        }
    }), (0, $3sHb8._)($2d4add6ec9f93b38$var$_obj1, (0, $fN6oO.ProductKey).STATUSPAGE, {
        free: {
            offeringId: "cff16c60-539b-11ea-8d77-2e728ce88125",
            productKey: (0, $fN6oO.ProductKey).STATUSPAGE,
            pricingType: "FREE",
            edition: "free",
            chargeElement: "user"
        }
    }), (0, $3sHb8._)($2d4add6ec9f93b38$var$_obj1, (0, $fN6oO.ProductKey).BITBUCKET, {
        free: {
            offeringId: "00000000-0000-0000-0000-000000000000",
            productKey: (0, $fN6oO.ProductKey).BITBUCKET,
            pricingType: "FREE",
            edition: "free",
            chargeElement: "user"
        },
        standard: {
            offeringId: "00000000-0000-0000-0000-000000000000",
            productKey: (0, $fN6oO.ProductKey).BITBUCKET,
            pricingType: "PAID",
            edition: "standard",
            chargeElement: "user"
        },
        premium: {
            offeringId: "00000000-0000-0000-0000-000000000000",
            productKey: (0, $fN6oO.ProductKey).BITBUCKET,
            pricingType: "PAID",
            edition: "premium",
            chargeElement: "user"
        }
    }), $2d4add6ec9f93b38$var$_obj1),
    production: ($2d4add6ec9f93b38$var$_obj2 = {}, (0, $3sHb8._)($2d4add6ec9f93b38$var$_obj2, (0, $fN6oO.ProductKey).JIRA_SOFTWARE, {
        free: {
            offeringId: "de2887c9-8a55-41d5-b5cf-ad6a5589ebed",
            productKey: (0, $fN6oO.ProductKey).JIRA_SOFTWARE,
            pricingType: "FREE",
            edition: "free",
            chargeElement: "user"
        },
        standard: {
            offeringId: "a70b5cbb-1ae1-4003-8f4a-9001a4a50526",
            productKey: (0, $fN6oO.ProductKey).JIRA_SOFTWARE,
            pricingType: "PAID",
            edition: "standard",
            chargeElement: "user"
        },
        premium: {
            offeringId: "6dd805b4-da75-4374-a7a7-cf0b12f7ea07",
            productKey: (0, $fN6oO.ProductKey).JIRA_SOFTWARE,
            pricingType: "PAID",
            edition: "premium",
            chargeElement: "user"
        }
    }), (0, $3sHb8._)($2d4add6ec9f93b38$var$_obj2, (0, $fN6oO.ProductKey).CONFLUENCE, {
        free: {
            offeringId: "7547cfd6-a804-4e42-8bed-e656d49ea09e",
            productKey: (0, $fN6oO.ProductKey).CONFLUENCE,
            pricingType: "FREE",
            edition: "free",
            chargeElement: "user"
        },
        standard: {
            offeringId: "2eda1119-fab4-4699-ab37-ff8f12052cde",
            productKey: (0, $fN6oO.ProductKey).CONFLUENCE,
            pricingType: "PAID",
            edition: "standard",
            chargeElement: "user"
        },
        premium: {
            offeringId: "06ef245c-5fa3-473b-8822-5e6fe072ae4b",
            productKey: (0, $fN6oO.ProductKey).CONFLUENCE,
            pricingType: "PAID",
            edition: "premium",
            chargeElement: "user"
        }
    }), (0, $3sHb8._)($2d4add6ec9f93b38$var$_obj2, (0, $fN6oO.ProductKey).JIRA_SERVICE_MANAGEMENT, {
        free: {
            offeringId: "2bad3c2f-d740-44a9-b08d-849202f11830",
            productKey: (0, $fN6oO.ProductKey).JIRA_SERVICE_MANAGEMENT,
            pricingType: "FREE",
            edition: "free",
            chargeElement: "agent"
        },
        standard: {
            offeringId: "396efb16-749b-41fa-9cd1-ad10cfefa1d0",
            productKey: (0, $fN6oO.ProductKey).JIRA_SERVICE_MANAGEMENT,
            pricingType: "PAID",
            edition: "standard",
            chargeElement: "agent"
        },
        premium: {
            offeringId: "0c6683b4-4633-4673-beca-690d171de6a5",
            productKey: (0, $fN6oO.ProductKey).JIRA_SERVICE_MANAGEMENT,
            pricingType: "PAID",
            edition: "premium",
            chargeElement: "agent"
        },
        halp: {
            offeringId: "396efb16-749b-41fa-9cd1-ad10cfefa1d0",
            pricingPlanId: "200b2088-934b-4669-b7c5-7ae6961c9368",
            // https://workbench.prod.atl-paas.net/products/jira-servicedesk.ondemand/plans/200b2088-934b-4669-b7c5-7ae6961c9368
            pricingType: "PAID",
            // pricing type for CCP
            productKey: (0, $fN6oO.ProductKey).JIRA_SERVICE_MANAGEMENT,
            edition: "standard",
            chargeElement: "agent"
        }
    }), (0, $3sHb8._)($2d4add6ec9f93b38$var$_obj2, (0, $fN6oO.ProductKey).JIRA_WORK_MANAGEMENT, {
        free: {
            offeringId: "769055e8-05f5-4b1a-ba1a-a1afc874ee6d",
            productKey: (0, $fN6oO.ProductKey).JIRA_WORK_MANAGEMENT,
            pricingType: "FREE",
            edition: "free",
            chargeElement: "user"
        },
        standard: {
            offeringId: "5ab35ef5-e441-493a-b6e0-ba2d21a72ac6",
            productKey: (0, $fN6oO.ProductKey).JIRA_WORK_MANAGEMENT,
            pricingType: "PAID",
            edition: "standard",
            chargeElement: "user"
        },
        premium: {
            offeringId: "d8e9a61a-c83b-4e40-a757-997d5bae2bb2",
            productKey: (0, $fN6oO.ProductKey).JIRA_WORK_MANAGEMENT,
            pricingType: "PAID",
            edition: "premium",
            chargeElement: "user"
        }
    }), (0, $3sHb8._)($2d4add6ec9f93b38$var$_obj2, (0, $fN6oO.ProductKey).JIRA_PRODUCT_DISCOVERY, {
        free: {
            offeringId: "d843dd9e-23c5-4d27-af44-5009d568cb6e",
            productKey: (0, $fN6oO.ProductKey).JIRA_PRODUCT_DISCOVERY,
            pricingType: "FREE",
            edition: "free",
            chargeElement: "user"
        },
        standard: {
            offeringId: "35b9268e-66e2-45fb-81d3-dacd1e31831a",
            productKey: (0, $fN6oO.ProductKey).JIRA_PRODUCT_DISCOVERY,
            pricingType: "PAID",
            edition: "standard",
            chargeElement: "user"
        }
    }), (0, $3sHb8._)($2d4add6ec9f93b38$var$_obj2, (0, $fN6oO.ProductKey).COMPASS, {
        beta: {
            offeringId: "7af07cb3-d4e5-473e-87b3-3ae3bc9248a6",
            productKey: "compass",
            edition: "beta",
            chargeElement: "user"
        },
        free: {
            offeringId: "1d1951e5-881c-4f75-b0cd-3c6859dd5759",
            productKey: (0, $fN6oO.ProductKey).COMPASS,
            pricingType: "FREE",
            edition: "free",
            chargeElement: "user"
        },
        standard: {
            offeringId: "575abf20-6cac-4bbc-9666-1791fae8d822",
            productKey: (0, $fN6oO.ProductKey).COMPASS,
            pricingType: "PAID",
            edition: "standard",
            chargeElement: "user"
        }
    }), (0, $3sHb8._)($2d4add6ec9f93b38$var$_obj2, (0, $fN6oO.ProductKey).ATLAS, {
        free: {
            offeringId: "88064fa1-b573-4358-a9de-ec350aac1ddc",
            productKey: (0, $fN6oO.ProductKey).ATLAS,
            pricingType: "FREE",
            edition: "free",
            chargeElement: "user"
        },
        standard: {
            offeringId: "01c8ddad-8ea4-4da9-8127-71d6ff6de1c9",
            productKey: (0, $fN6oO.ProductKey).ATLAS,
            pricingType: "PAID",
            edition: "standard",
            chargeElement: "user"
        },
        premium: {
            offeringId: "f7866043-d6e4-4d54-9c6a-4f82c6a1ebe5",
            productKey: (0, $fN6oO.ProductKey).ATLAS,
            pricingType: "PAID",
            edition: "premium",
            chargeElement: "user"
        }
    }), (0, $3sHb8._)($2d4add6ec9f93b38$var$_obj2, (0, $fN6oO.ProductKey).OPSGENIE, {
        free: {
            offeringId: "d0c6ab1d-d8ea-49f8-8893-eafca2e05158",
            productKey: (0, $fN6oO.ProductKey).OPSGENIE,
            pricingType: "FREE",
            edition: "essentials",
            chargeElement: "user"
        }
    }), (0, $3sHb8._)($2d4add6ec9f93b38$var$_obj2, (0, $fN6oO.ProductKey).FABRIC, {
        free: {
            offeringId: "b0c7b413-b264-4c01-8b67-c61aa2c3e455",
            productKey: (0, $fN6oO.ProductKey).FABRIC,
            pricingType: "FREE",
            edition: "free",
            chargeElement: "user"
        }
    }), (0, $3sHb8._)($2d4add6ec9f93b38$var$_obj2, (0, $fN6oO.ProductKey).STATUSPAGE, {
        free: {
            offeringId: "cff16c60-539b-11ea-8d77-2e728ce88125",
            productKey: (0, $fN6oO.ProductKey).STATUSPAGE,
            pricingType: "FREE",
            edition: "free",
            chargeElement: "user"
        }
    }), (0, $3sHb8._)($2d4add6ec9f93b38$var$_obj2, (0, $fN6oO.ProductKey).BITBUCKET, {
        free: {
            offeringId: "00000000-0000-0000-0000-000000000000",
            productKey: (0, $fN6oO.ProductKey).BITBUCKET,
            pricingType: "FREE",
            edition: "free",
            chargeElement: "user"
        },
        standard: {
            offeringId: "00000000-0000-0000-0000-000000000000",
            productKey: (0, $fN6oO.ProductKey).BITBUCKET,
            pricingType: "PAID",
            edition: "standard",
            chargeElement: "user"
        },
        premium: {
            offeringId: "00000000-0000-0000-0000-000000000000",
            productKey: (0, $fN6oO.ProductKey).BITBUCKET,
            pricingType: "PAID",
            edition: "premium",
            chargeElement: "user"
        }
    }), $2d4add6ec9f93b38$var$_obj2)
};
var $2d4add6ec9f93b38$export$82e88cf9c9975cf0 = function OfferingCatalog(environmentType) {
    "use strict";
    var _this = this;
    (0, $4GJKx._)(this, OfferingCatalog);
    this.mapProductKeyAndEditionToCcpProduct = function(param) {
        var productKey = param.productKey, edition = param.edition;
        var products = $2d4add6ec9f93b38$var$OFFERING_IDS[_this.environmentType];
        var editions = $2d4add6ec9f93b38$var$OFFERING_IDS[_this.environmentType][productKey];
        return products[productKey][edition];
    };
    this.environmentType = environmentType;
};

});



parcelRegister("lRxFc", function(module, exports) {
parcelRequire("eb65f");
var $8JWVu = parcelRequire("8JWVu");

var $HSGiS = parcelRequire("HSGiS");
function $a861d22ff03d6bd7$export$b7929e1ac52d58da(param) {
    var cloudId = param.cloudId;
    var stargateClient = (0, $8JWVu.useBxpWebStargateClient)();
    return (0, $HSGiS.useAsync)(function() {
        return stargateClient.getLicenceInformationStatus({
            cloudId: cloudId
        });
    }, []);
}

});

parcelRegister("g7fcJ", function(module, exports) {
parcelRequire("eb65f");
var $8JWVu = parcelRequire("8JWVu");

var $HSGiS = parcelRequire("HSGiS");
function $4951a7863f2dd8e4$export$3d267f848a49f99e(param) {
    var cloudId = param.cloudId, offeringKeys = param.offeringKeys;
    var stargateClient = (0, $8JWVu.useBxpWebStargateClient)();
    return (0, $HSGiS.useAsync)(function() {
        return stargateClient.getCcpHamsStatus({
            cloudId: cloudId,
            offeringKeys: offeringKeys
        });
    }, []);
}

});

parcelRegister("gqYfG", function(module, exports) {
parcelRequire("eb65f");
var $8JWVu = parcelRequire("8JWVu");

var $HSGiS = parcelRequire("HSGiS");
function $9198568390ac41d8$export$3738ff0cbe469211(param) {
    var orderId = param.orderId, transactionAccount = param.transactionAccount;
    var stargateClient = (0, $8JWVu.useBxpWebStargateClient)();
    return (0, $HSGiS.useAsync)(function() {
        return stargateClient.getAvailableSites({
            orderId: orderId,
            transactionAccount: transactionAccount
        });
    }, []);
}

});


parcelRegister("30nFL", function(module, exports) {
$parcel$export(module.exports, "SanitizedHtml", function () { return (parcelRequire("iyjDo")).SanitizedHtml; });
parcelRequire("hQHw2");
parcelRequire("iyjDo");

});
parcelRegister("hQHw2", function(module, exports) {

$parcel$export(module.exports, "SanitizedFormattedHtmlMessage", function () { return $6b87136b23ae52c4$export$1f6024696f089bb4; });
//@ts-nocheck

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $dRLPW = parcelRequire("dRLPW");

var $1rY3h = parcelRequire("1rY3h");

var $5cpvS = parcelRequire("5cpvS");

var $dFwuF = parcelRequire("dFwuF");

var $iyjDo = parcelRequire("iyjDo");
var $6b87136b23ae52c4$export$1f6024696f089bb4 = function(_param) {
    var tagName = _param.tagName, values = _param.values, messageDescriptor = (0, $dRLPW._)(_param, [
        "tagName",
        "values"
    ]);
    return /*#__PURE__*/ (0, $1rY3h.jsx)((0, $dFwuF.default), (0, $cxjpp._)((0, $do9pw._)({
        tagName: tagName,
        values: $6b87136b23ae52c4$var$escapeValues(values)
    }, messageDescriptor), {
        children: function(html) {
            return /*#__PURE__*/ (0, $1rY3h.jsx)((0, $iyjDo.SanitizedHtml), {
                innerHTML: html,
                tagName: tagName
            });
        }
    }));
};
function $6b87136b23ae52c4$var$escapeValues() {
    var messageValues = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Object.keys(messageValues).forEach(function(keyName) {
        var messageValue = messageValues[keyName];
        messageValues[keyName] = typeof messageValue === "string" ? (0, $5cpvS.escape)(messageValue) : messageValue;
    });
    return messageValues;
}

});
parcelRegister("5cpvS", function(module, exports) {
(function(root) {
    // Detect free variables `exports`.
    var freeExports = exports;
    // Detect free variable `module`.
    var freeModule = module && module.exports == freeExports && module;
    // Detect free variable `global`, from Node.js or Browserified code,
    // and use it as `root`.
    var freeGlobal = typeof $parcel$global == "object" && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) root = freeGlobal;
    /*--------------------------------------------------------------------------*/ // All astral symbols.
    var regexAstralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
    // All ASCII symbols (not just printable ASCII) except those listed in the
    // first column of the overrides table.
    // https://html.spec.whatwg.org/multipage/syntax.html#table-charref-overrides
    var regexAsciiWhitelist = /[\x01-\x7F]/g;
    // All BMP symbols that are not ASCII newlines, printable ASCII symbols, or
    // code points listed in the first column of the overrides table on
    // https://html.spec.whatwg.org/multipage/syntax.html#table-charref-overrides.
    var regexBmpWhitelist = /[\x01-\t\x0B\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g;
    var regexEncodeNonAscii = /<\u20D2|=\u20E5|>\u20D2|\u205F\u200A|\u219D\u0338|\u2202\u0338|\u2220\u20D2|\u2229\uFE00|\u222A\uFE00|\u223C\u20D2|\u223D\u0331|\u223E\u0333|\u2242\u0338|\u224B\u0338|\u224D\u20D2|\u224E\u0338|\u224F\u0338|\u2250\u0338|\u2261\u20E5|\u2264\u20D2|\u2265\u20D2|\u2266\u0338|\u2267\u0338|\u2268\uFE00|\u2269\uFE00|\u226A\u0338|\u226A\u20D2|\u226B\u0338|\u226B\u20D2|\u227F\u0338|\u2282\u20D2|\u2283\u20D2|\u228A\uFE00|\u228B\uFE00|\u228F\u0338|\u2290\u0338|\u2293\uFE00|\u2294\uFE00|\u22B4\u20D2|\u22B5\u20D2|\u22D8\u0338|\u22D9\u0338|\u22DA\uFE00|\u22DB\uFE00|\u22F5\u0338|\u22F9\u0338|\u2933\u0338|\u29CF\u0338|\u29D0\u0338|\u2A6D\u0338|\u2A70\u0338|\u2A7D\u0338|\u2A7E\u0338|\u2AA1\u0338|\u2AA2\u0338|\u2AAC\uFE00|\u2AAD\uFE00|\u2AAF\u0338|\u2AB0\u0338|\u2AC5\u0338|\u2AC6\u0338|\u2ACB\uFE00|\u2ACC\uFE00|\u2AFD\u20E5|[\xA0-\u0113\u0116-\u0122\u0124-\u012B\u012E-\u014D\u0150-\u017E\u0192\u01B5\u01F5\u0237\u02C6\u02C7\u02D8-\u02DD\u0311\u0391-\u03A1\u03A3-\u03A9\u03B1-\u03C9\u03D1\u03D2\u03D5\u03D6\u03DC\u03DD\u03F0\u03F1\u03F5\u03F6\u0401-\u040C\u040E-\u044F\u0451-\u045C\u045E\u045F\u2002-\u2005\u2007-\u2010\u2013-\u2016\u2018-\u201A\u201C-\u201E\u2020-\u2022\u2025\u2026\u2030-\u2035\u2039\u203A\u203E\u2041\u2043\u2044\u204F\u2057\u205F-\u2063\u20AC\u20DB\u20DC\u2102\u2105\u210A-\u2113\u2115-\u211E\u2122\u2124\u2127-\u2129\u212C\u212D\u212F-\u2131\u2133-\u2138\u2145-\u2148\u2153-\u215E\u2190-\u219B\u219D-\u21A7\u21A9-\u21AE\u21B0-\u21B3\u21B5-\u21B7\u21BA-\u21DB\u21DD\u21E4\u21E5\u21F5\u21FD-\u2205\u2207-\u2209\u220B\u220C\u220F-\u2214\u2216-\u2218\u221A\u221D-\u2238\u223A-\u2257\u2259\u225A\u225C\u225F-\u2262\u2264-\u228B\u228D-\u229B\u229D-\u22A5\u22A7-\u22B0\u22B2-\u22BB\u22BD-\u22DB\u22DE-\u22E3\u22E6-\u22F7\u22F9-\u22FE\u2305\u2306\u2308-\u2310\u2312\u2313\u2315\u2316\u231C-\u231F\u2322\u2323\u232D\u232E\u2336\u233D\u233F\u237C\u23B0\u23B1\u23B4-\u23B6\u23DC-\u23DF\u23E2\u23E7\u2423\u24C8\u2500\u2502\u250C\u2510\u2514\u2518\u251C\u2524\u252C\u2534\u253C\u2550-\u256C\u2580\u2584\u2588\u2591-\u2593\u25A1\u25AA\u25AB\u25AD\u25AE\u25B1\u25B3-\u25B5\u25B8\u25B9\u25BD-\u25BF\u25C2\u25C3\u25CA\u25CB\u25EC\u25EF\u25F8-\u25FC\u2605\u2606\u260E\u2640\u2642\u2660\u2663\u2665\u2666\u266A\u266D-\u266F\u2713\u2717\u2720\u2736\u2758\u2772\u2773\u27C8\u27C9\u27E6-\u27ED\u27F5-\u27FA\u27FC\u27FF\u2902-\u2905\u290C-\u2913\u2916\u2919-\u2920\u2923-\u292A\u2933\u2935-\u2939\u293C\u293D\u2945\u2948-\u294B\u294E-\u2976\u2978\u2979\u297B-\u297F\u2985\u2986\u298B-\u2996\u299A\u299C\u299D\u29A4-\u29B7\u29B9\u29BB\u29BC\u29BE-\u29C5\u29C9\u29CD-\u29D0\u29DC-\u29DE\u29E3-\u29E5\u29EB\u29F4\u29F6\u2A00-\u2A02\u2A04\u2A06\u2A0C\u2A0D\u2A10-\u2A17\u2A22-\u2A27\u2A29\u2A2A\u2A2D-\u2A31\u2A33-\u2A3C\u2A3F\u2A40\u2A42-\u2A4D\u2A50\u2A53-\u2A58\u2A5A-\u2A5D\u2A5F\u2A66\u2A6A\u2A6D-\u2A75\u2A77-\u2A9A\u2A9D-\u2AA2\u2AA4-\u2AB0\u2AB3-\u2AC8\u2ACB\u2ACC\u2ACF-\u2ADB\u2AE4\u2AE6-\u2AE9\u2AEB-\u2AF3\u2AFD\uFB00-\uFB04]|\uD835[\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDCCF\uDD04\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDD6B]/g;
    var encodeMap = {
        "\xad": "shy",
        "\u200C": "zwnj",
        "\u200D": "zwj",
        "\u200E": "lrm",
        "\u2063": "ic",
        "\u2062": "it",
        "\u2061": "af",
        "\u200F": "rlm",
        "\u200B": "ZeroWidthSpace",
        "\u2060": "NoBreak",
        "\u0311": "DownBreve",
        "\u20DB": "tdot",
        "\u20DC": "DotDot",
        "	": "Tab",
        "\n": "NewLine",
        "\u2008": "puncsp",
        "\u205F": "MediumSpace",
        "\u2009": "thinsp",
        "\u200A": "hairsp",
        "\u2004": "emsp13",
        "\u2002": "ensp",
        "\u2005": "emsp14",
        "\u2003": "emsp",
        "\u2007": "numsp",
        "\xa0": "nbsp",
        "\u205F\u200A": "ThickSpace",
        "\u203E": "oline",
        "_": "lowbar",
        "\u2010": "dash",
        "\u2013": "ndash",
        "\u2014": "mdash",
        "\u2015": "horbar",
        ",": "comma",
        ";": "semi",
        "\u204F": "bsemi",
        ":": "colon",
        "\u2A74": "Colone",
        "!": "excl",
        "\xa1": "iexcl",
        "?": "quest",
        "\xbf": "iquest",
        ".": "period",
        "\u2025": "nldr",
        "\u2026": "mldr",
        "\xb7": "middot",
        "'": "apos",
        "\u2018": "lsquo",
        "\u2019": "rsquo",
        "\u201A": "sbquo",
        "\u2039": "lsaquo",
        "\u203A": "rsaquo",
        '"': "quot",
        "\u201C": "ldquo",
        "\u201D": "rdquo",
        "\u201E": "bdquo",
        "\xab": "laquo",
        "\xbb": "raquo",
        "(": "lpar",
        ")": "rpar",
        "[": "lsqb",
        "]": "rsqb",
        "{": "lcub",
        "}": "rcub",
        "\u2308": "lceil",
        "\u2309": "rceil",
        "\u230A": "lfloor",
        "\u230B": "rfloor",
        "\u2985": "lopar",
        "\u2986": "ropar",
        "\u298B": "lbrke",
        "\u298C": "rbrke",
        "\u298D": "lbrkslu",
        "\u298E": "rbrksld",
        "\u298F": "lbrksld",
        "\u2990": "rbrkslu",
        "\u2991": "langd",
        "\u2992": "rangd",
        "\u2993": "lparlt",
        "\u2994": "rpargt",
        "\u2995": "gtlPar",
        "\u2996": "ltrPar",
        "\u27E6": "lobrk",
        "\u27E7": "robrk",
        "\u27E8": "lang",
        "\u27E9": "rang",
        "\u27EA": "Lang",
        "\u27EB": "Rang",
        "\u27EC": "loang",
        "\u27ED": "roang",
        "\u2772": "lbbrk",
        "\u2773": "rbbrk",
        "\u2016": "Vert",
        "\xa7": "sect",
        "\xb6": "para",
        "@": "commat",
        "*": "ast",
        "/": "sol",
        "undefined": null,
        "&": "amp",
        "#": "num",
        "%": "percnt",
        "\u2030": "permil",
        "\u2031": "pertenk",
        "\u2020": "dagger",
        "\u2021": "Dagger",
        "\u2022": "bull",
        "\u2043": "hybull",
        "\u2032": "prime",
        "\u2033": "Prime",
        "\u2034": "tprime",
        "\u2057": "qprime",
        "\u2035": "bprime",
        "\u2041": "caret",
        "`": "grave",
        "\xb4": "acute",
        "\u02DC": "tilde",
        "^": "Hat",
        "\xaf": "macr",
        "\u02D8": "breve",
        "\u02D9": "dot",
        "\xa8": "die",
        "\u02DA": "ring",
        "\u02DD": "dblac",
        "\xb8": "cedil",
        "\u02DB": "ogon",
        "\u02C6": "circ",
        "\u02C7": "caron",
        "\xb0": "deg",
        "\xa9": "copy",
        "\xae": "reg",
        "\u2117": "copysr",
        "\u2118": "wp",
        "\u211E": "rx",
        "\u2127": "mho",
        "\u2129": "iiota",
        "\u2190": "larr",
        "\u219A": "nlarr",
        "\u2192": "rarr",
        "\u219B": "nrarr",
        "\u2191": "uarr",
        "\u2193": "darr",
        "\u2194": "harr",
        "\u21AE": "nharr",
        "\u2195": "varr",
        "\u2196": "nwarr",
        "\u2197": "nearr",
        "\u2198": "searr",
        "\u2199": "swarr",
        "\u219D": "rarrw",
        "\u219D\u0338": "nrarrw",
        "\u219E": "Larr",
        "\u219F": "Uarr",
        "\u21A0": "Rarr",
        "\u21A1": "Darr",
        "\u21A2": "larrtl",
        "\u21A3": "rarrtl",
        "\u21A4": "mapstoleft",
        "\u21A5": "mapstoup",
        "\u21A6": "map",
        "\u21A7": "mapstodown",
        "\u21A9": "larrhk",
        "\u21AA": "rarrhk",
        "\u21AB": "larrlp",
        "\u21AC": "rarrlp",
        "\u21AD": "harrw",
        "\u21B0": "lsh",
        "\u21B1": "rsh",
        "\u21B2": "ldsh",
        "\u21B3": "rdsh",
        "\u21B5": "crarr",
        "\u21B6": "cularr",
        "\u21B7": "curarr",
        "\u21BA": "olarr",
        "\u21BB": "orarr",
        "\u21BC": "lharu",
        "\u21BD": "lhard",
        "\u21BE": "uharr",
        "\u21BF": "uharl",
        "\u21C0": "rharu",
        "\u21C1": "rhard",
        "\u21C2": "dharr",
        "\u21C3": "dharl",
        "\u21C4": "rlarr",
        "\u21C5": "udarr",
        "\u21C6": "lrarr",
        "\u21C7": "llarr",
        "\u21C8": "uuarr",
        "\u21C9": "rrarr",
        "\u21CA": "ddarr",
        "\u21CB": "lrhar",
        "\u21CC": "rlhar",
        "\u21D0": "lArr",
        "\u21CD": "nlArr",
        "\u21D1": "uArr",
        "\u21D2": "rArr",
        "\u21CF": "nrArr",
        "\u21D3": "dArr",
        "\u21D4": "iff",
        "\u21CE": "nhArr",
        "\u21D5": "vArr",
        "\u21D6": "nwArr",
        "\u21D7": "neArr",
        "\u21D8": "seArr",
        "\u21D9": "swArr",
        "\u21DA": "lAarr",
        "\u21DB": "rAarr",
        "\u21DD": "zigrarr",
        "\u21E4": "larrb",
        "\u21E5": "rarrb",
        "\u21F5": "duarr",
        "\u21FD": "loarr",
        "\u21FE": "roarr",
        "\u21FF": "hoarr",
        "\u2200": "forall",
        "\u2201": "comp",
        "\u2202": "part",
        "\u2202\u0338": "npart",
        "\u2203": "exist",
        "\u2204": "nexist",
        "\u2205": "empty",
        "\u2207": "Del",
        "\u2208": "in",
        "\u2209": "notin",
        "\u220B": "ni",
        "\u220C": "notni",
        "\u03F6": "bepsi",
        "\u220F": "prod",
        "\u2210": "coprod",
        "\u2211": "sum",
        "+": "plus",
        "\xb1": "pm",
        "\xf7": "div",
        "\xd7": "times",
        "<": "lt",
        "\u226E": "nlt",
        "<\u20D2": "nvlt",
        "=": "equals",
        "\u2260": "ne",
        "=\u20E5": "bne",
        "\u2A75": "Equal",
        ">": "gt",
        "\u226F": "ngt",
        ">\u20D2": "nvgt",
        "\xac": "not",
        "|": "vert",
        "\xa6": "brvbar",
        "\u2212": "minus",
        "\u2213": "mp",
        "\u2214": "plusdo",
        "\u2044": "frasl",
        "\u2216": "setmn",
        "\u2217": "lowast",
        "\u2218": "compfn",
        "\u221A": "Sqrt",
        "\u221D": "prop",
        "\u221E": "infin",
        "\u221F": "angrt",
        "\u2220": "ang",
        "\u2220\u20D2": "nang",
        "\u2221": "angmsd",
        "\u2222": "angsph",
        "\u2223": "mid",
        "\u2224": "nmid",
        "\u2225": "par",
        "\u2226": "npar",
        "\u2227": "and",
        "\u2228": "or",
        "\u2229": "cap",
        "\u2229\uFE00": "caps",
        "\u222A": "cup",
        "\u222A\uFE00": "cups",
        "\u222B": "int",
        "\u222C": "Int",
        "\u222D": "tint",
        "\u2A0C": "qint",
        "\u222E": "oint",
        "\u222F": "Conint",
        "\u2230": "Cconint",
        "\u2231": "cwint",
        "\u2232": "cwconint",
        "\u2233": "awconint",
        "\u2234": "there4",
        "\u2235": "becaus",
        "\u2236": "ratio",
        "\u2237": "Colon",
        "\u2238": "minusd",
        "\u223A": "mDDot",
        "\u223B": "homtht",
        "\u223C": "sim",
        "\u2241": "nsim",
        "\u223C\u20D2": "nvsim",
        "\u223D": "bsim",
        "\u223D\u0331": "race",
        "\u223E": "ac",
        "\u223E\u0333": "acE",
        "\u223F": "acd",
        "\u2240": "wr",
        "\u2242": "esim",
        "\u2242\u0338": "nesim",
        "\u2243": "sime",
        "\u2244": "nsime",
        "\u2245": "cong",
        "\u2247": "ncong",
        "\u2246": "simne",
        "\u2248": "ap",
        "\u2249": "nap",
        "\u224A": "ape",
        "\u224B": "apid",
        "\u224B\u0338": "napid",
        "\u224C": "bcong",
        "\u224D": "CupCap",
        "\u226D": "NotCupCap",
        "\u224D\u20D2": "nvap",
        "\u224E": "bump",
        "\u224E\u0338": "nbump",
        "\u224F": "bumpe",
        "\u224F\u0338": "nbumpe",
        "\u2250": "doteq",
        "\u2250\u0338": "nedot",
        "\u2251": "eDot",
        "\u2252": "efDot",
        "\u2253": "erDot",
        "\u2254": "colone",
        "\u2255": "ecolon",
        "\u2256": "ecir",
        "\u2257": "cire",
        "\u2259": "wedgeq",
        "\u225A": "veeeq",
        "\u225C": "trie",
        "\u225F": "equest",
        "\u2261": "equiv",
        "\u2262": "nequiv",
        "\u2261\u20E5": "bnequiv",
        "\u2264": "le",
        "\u2270": "nle",
        "\u2264\u20D2": "nvle",
        "\u2265": "ge",
        "\u2271": "nge",
        "\u2265\u20D2": "nvge",
        "\u2266": "lE",
        "\u2266\u0338": "nlE",
        "\u2267": "gE",
        "\u2267\u0338": "ngE",
        "\u2268\uFE00": "lvnE",
        "\u2268": "lnE",
        "\u2269": "gnE",
        "\u2269\uFE00": "gvnE",
        "\u226A": "ll",
        "\u226A\u0338": "nLtv",
        "\u226A\u20D2": "nLt",
        "\u226B": "gg",
        "\u226B\u0338": "nGtv",
        "\u226B\u20D2": "nGt",
        "\u226C": "twixt",
        "\u2272": "lsim",
        "\u2274": "nlsim",
        "\u2273": "gsim",
        "\u2275": "ngsim",
        "\u2276": "lg",
        "\u2278": "ntlg",
        "\u2277": "gl",
        "\u2279": "ntgl",
        "\u227A": "pr",
        "\u2280": "npr",
        "\u227B": "sc",
        "\u2281": "nsc",
        "\u227C": "prcue",
        "\u22E0": "nprcue",
        "\u227D": "sccue",
        "\u22E1": "nsccue",
        "\u227E": "prsim",
        "\u227F": "scsim",
        "\u227F\u0338": "NotSucceedsTilde",
        "\u2282": "sub",
        "\u2284": "nsub",
        "\u2282\u20D2": "vnsub",
        "\u2283": "sup",
        "\u2285": "nsup",
        "\u2283\u20D2": "vnsup",
        "\u2286": "sube",
        "\u2288": "nsube",
        "\u2287": "supe",
        "\u2289": "nsupe",
        "\u228A\uFE00": "vsubne",
        "\u228A": "subne",
        "\u228B\uFE00": "vsupne",
        "\u228B": "supne",
        "\u228D": "cupdot",
        "\u228E": "uplus",
        "\u228F": "sqsub",
        "\u228F\u0338": "NotSquareSubset",
        "\u2290": "sqsup",
        "\u2290\u0338": "NotSquareSuperset",
        "\u2291": "sqsube",
        "\u22E2": "nsqsube",
        "\u2292": "sqsupe",
        "\u22E3": "nsqsupe",
        "\u2293": "sqcap",
        "\u2293\uFE00": "sqcaps",
        "\u2294": "sqcup",
        "\u2294\uFE00": "sqcups",
        "\u2295": "oplus",
        "\u2296": "ominus",
        "\u2297": "otimes",
        "\u2298": "osol",
        "\u2299": "odot",
        "\u229A": "ocir",
        "\u229B": "oast",
        "\u229D": "odash",
        "\u229E": "plusb",
        "\u229F": "minusb",
        "\u22A0": "timesb",
        "\u22A1": "sdotb",
        "\u22A2": "vdash",
        "\u22AC": "nvdash",
        "\u22A3": "dashv",
        "\u22A4": "top",
        "\u22A5": "bot",
        "\u22A7": "models",
        "\u22A8": "vDash",
        "\u22AD": "nvDash",
        "\u22A9": "Vdash",
        "\u22AE": "nVdash",
        "\u22AA": "Vvdash",
        "\u22AB": "VDash",
        "\u22AF": "nVDash",
        "\u22B0": "prurel",
        "\u22B2": "vltri",
        "\u22EA": "nltri",
        "\u22B3": "vrtri",
        "\u22EB": "nrtri",
        "\u22B4": "ltrie",
        "\u22EC": "nltrie",
        "\u22B4\u20D2": "nvltrie",
        "\u22B5": "rtrie",
        "\u22ED": "nrtrie",
        "\u22B5\u20D2": "nvrtrie",
        "\u22B6": "origof",
        "\u22B7": "imof",
        "\u22B8": "mumap",
        "\u22B9": "hercon",
        "\u22BA": "intcal",
        "\u22BB": "veebar",
        "\u22BD": "barvee",
        "\u22BE": "angrtvb",
        "\u22BF": "lrtri",
        "\u22C0": "Wedge",
        "\u22C1": "Vee",
        "\u22C2": "xcap",
        "\u22C3": "xcup",
        "\u22C4": "diam",
        "\u22C5": "sdot",
        "\u22C6": "Star",
        "\u22C7": "divonx",
        "\u22C8": "bowtie",
        "\u22C9": "ltimes",
        "\u22CA": "rtimes",
        "\u22CB": "lthree",
        "\u22CC": "rthree",
        "\u22CD": "bsime",
        "\u22CE": "cuvee",
        "\u22CF": "cuwed",
        "\u22D0": "Sub",
        "\u22D1": "Sup",
        "\u22D2": "Cap",
        "\u22D3": "Cup",
        "\u22D4": "fork",
        "\u22D5": "epar",
        "\u22D6": "ltdot",
        "\u22D7": "gtdot",
        "\u22D8": "Ll",
        "\u22D8\u0338": "nLl",
        "\u22D9": "Gg",
        "\u22D9\u0338": "nGg",
        "\u22DA\uFE00": "lesg",
        "\u22DA": "leg",
        "\u22DB": "gel",
        "\u22DB\uFE00": "gesl",
        "\u22DE": "cuepr",
        "\u22DF": "cuesc",
        "\u22E6": "lnsim",
        "\u22E7": "gnsim",
        "\u22E8": "prnsim",
        "\u22E9": "scnsim",
        "\u22EE": "vellip",
        "\u22EF": "ctdot",
        "\u22F0": "utdot",
        "\u22F1": "dtdot",
        "\u22F2": "disin",
        "\u22F3": "isinsv",
        "\u22F4": "isins",
        "\u22F5": "isindot",
        "\u22F5\u0338": "notindot",
        "\u22F6": "notinvc",
        "\u22F7": "notinvb",
        "\u22F9": "isinE",
        "\u22F9\u0338": "notinE",
        "\u22FA": "nisd",
        "\u22FB": "xnis",
        "\u22FC": "nis",
        "\u22FD": "notnivc",
        "\u22FE": "notnivb",
        "\u2305": "barwed",
        "\u2306": "Barwed",
        "\u230C": "drcrop",
        "\u230D": "dlcrop",
        "\u230E": "urcrop",
        "\u230F": "ulcrop",
        "\u2310": "bnot",
        "\u2312": "profline",
        "\u2313": "profsurf",
        "\u2315": "telrec",
        "\u2316": "target",
        "\u231C": "ulcorn",
        "\u231D": "urcorn",
        "\u231E": "dlcorn",
        "\u231F": "drcorn",
        "\u2322": "frown",
        "\u2323": "smile",
        "\u232D": "cylcty",
        "\u232E": "profalar",
        "\u2336": "topbot",
        "\u233D": "ovbar",
        "\u233F": "solbar",
        "\u237C": "angzarr",
        "\u23B0": "lmoust",
        "\u23B1": "rmoust",
        "\u23B4": "tbrk",
        "\u23B5": "bbrk",
        "\u23B6": "bbrktbrk",
        "\u23DC": "OverParenthesis",
        "\u23DD": "UnderParenthesis",
        "\u23DE": "OverBrace",
        "\u23DF": "UnderBrace",
        "\u23E2": "trpezium",
        "\u23E7": "elinters",
        "\u2423": "blank",
        "\u2500": "boxh",
        "\u2502": "boxv",
        "\u250C": "boxdr",
        "\u2510": "boxdl",
        "\u2514": "boxur",
        "\u2518": "boxul",
        "\u251C": "boxvr",
        "\u2524": "boxvl",
        "\u252C": "boxhd",
        "\u2534": "boxhu",
        "\u253C": "boxvh",
        "\u2550": "boxH",
        "\u2551": "boxV",
        "\u2552": "boxdR",
        "\u2553": "boxDr",
        "\u2554": "boxDR",
        "\u2555": "boxdL",
        "\u2556": "boxDl",
        "\u2557": "boxDL",
        "\u2558": "boxuR",
        "\u2559": "boxUr",
        "\u255A": "boxUR",
        "\u255B": "boxuL",
        "\u255C": "boxUl",
        "\u255D": "boxUL",
        "\u255E": "boxvR",
        "\u255F": "boxVr",
        "\u2560": "boxVR",
        "\u2561": "boxvL",
        "\u2562": "boxVl",
        "\u2563": "boxVL",
        "\u2564": "boxHd",
        "\u2565": "boxhD",
        "\u2566": "boxHD",
        "\u2567": "boxHu",
        "\u2568": "boxhU",
        "\u2569": "boxHU",
        "\u256A": "boxvH",
        "\u256B": "boxVh",
        "\u256C": "boxVH",
        "\u2580": "uhblk",
        "\u2584": "lhblk",
        "\u2588": "block",
        "\u2591": "blk14",
        "\u2592": "blk12",
        "\u2593": "blk34",
        "\u25A1": "squ",
        "\u25AA": "squf",
        "\u25AB": "EmptyVerySmallSquare",
        "\u25AD": "rect",
        "\u25AE": "marker",
        "\u25B1": "fltns",
        "\u25B3": "xutri",
        "\u25B4": "utrif",
        "\u25B5": "utri",
        "\u25B8": "rtrif",
        "\u25B9": "rtri",
        "\u25BD": "xdtri",
        "\u25BE": "dtrif",
        "\u25BF": "dtri",
        "\u25C2": "ltrif",
        "\u25C3": "ltri",
        "\u25CA": "loz",
        "\u25CB": "cir",
        "\u25EC": "tridot",
        "\u25EF": "xcirc",
        "\u25F8": "ultri",
        "\u25F9": "urtri",
        "\u25FA": "lltri",
        "\u25FB": "EmptySmallSquare",
        "\u25FC": "FilledSmallSquare",
        "\u2605": "starf",
        "\u2606": "star",
        "\u260E": "phone",
        "\u2640": "female",
        "\u2642": "male",
        "\u2660": "spades",
        "\u2663": "clubs",
        "\u2665": "hearts",
        "\u2666": "diams",
        "\u266A": "sung",
        "\u2713": "check",
        "\u2717": "cross",
        "\u2720": "malt",
        "\u2736": "sext",
        "\u2758": "VerticalSeparator",
        "\u27C8": "bsolhsub",
        "\u27C9": "suphsol",
        "\u27F5": "xlarr",
        "\u27F6": "xrarr",
        "\u27F7": "xharr",
        "\u27F8": "xlArr",
        "\u27F9": "xrArr",
        "\u27FA": "xhArr",
        "\u27FC": "xmap",
        "\u27FF": "dzigrarr",
        "\u2902": "nvlArr",
        "\u2903": "nvrArr",
        "\u2904": "nvHarr",
        "\u2905": "Map",
        "\u290C": "lbarr",
        "\u290D": "rbarr",
        "\u290E": "lBarr",
        "\u290F": "rBarr",
        "\u2910": "RBarr",
        "\u2911": "DDotrahd",
        "\u2912": "UpArrowBar",
        "\u2913": "DownArrowBar",
        "\u2916": "Rarrtl",
        "\u2919": "latail",
        "\u291A": "ratail",
        "\u291B": "lAtail",
        "\u291C": "rAtail",
        "\u291D": "larrfs",
        "\u291E": "rarrfs",
        "\u291F": "larrbfs",
        "\u2920": "rarrbfs",
        "\u2923": "nwarhk",
        "\u2924": "nearhk",
        "\u2925": "searhk",
        "\u2926": "swarhk",
        "\u2927": "nwnear",
        "\u2928": "toea",
        "\u2929": "tosa",
        "\u292A": "swnwar",
        "\u2933": "rarrc",
        "\u2933\u0338": "nrarrc",
        "\u2935": "cudarrr",
        "\u2936": "ldca",
        "\u2937": "rdca",
        "\u2938": "cudarrl",
        "\u2939": "larrpl",
        "\u293C": "curarrm",
        "\u293D": "cularrp",
        "\u2945": "rarrpl",
        "\u2948": "harrcir",
        "\u2949": "Uarrocir",
        "\u294A": "lurdshar",
        "\u294B": "ldrushar",
        "\u294E": "LeftRightVector",
        "\u294F": "RightUpDownVector",
        "\u2950": "DownLeftRightVector",
        "\u2951": "LeftUpDownVector",
        "\u2952": "LeftVectorBar",
        "\u2953": "RightVectorBar",
        "\u2954": "RightUpVectorBar",
        "\u2955": "RightDownVectorBar",
        "\u2956": "DownLeftVectorBar",
        "\u2957": "DownRightVectorBar",
        "\u2958": "LeftUpVectorBar",
        "\u2959": "LeftDownVectorBar",
        "\u295A": "LeftTeeVector",
        "\u295B": "RightTeeVector",
        "\u295C": "RightUpTeeVector",
        "\u295D": "RightDownTeeVector",
        "\u295E": "DownLeftTeeVector",
        "\u295F": "DownRightTeeVector",
        "\u2960": "LeftUpTeeVector",
        "\u2961": "LeftDownTeeVector",
        "\u2962": "lHar",
        "\u2963": "uHar",
        "\u2964": "rHar",
        "\u2965": "dHar",
        "\u2966": "luruhar",
        "\u2967": "ldrdhar",
        "\u2968": "ruluhar",
        "\u2969": "rdldhar",
        "\u296A": "lharul",
        "\u296B": "llhard",
        "\u296C": "rharul",
        "\u296D": "lrhard",
        "\u296E": "udhar",
        "\u296F": "duhar",
        "\u2970": "RoundImplies",
        "\u2971": "erarr",
        "\u2972": "simrarr",
        "\u2973": "larrsim",
        "\u2974": "rarrsim",
        "\u2975": "rarrap",
        "\u2976": "ltlarr",
        "\u2978": "gtrarr",
        "\u2979": "subrarr",
        "\u297B": "suplarr",
        "\u297C": "lfisht",
        "\u297D": "rfisht",
        "\u297E": "ufisht",
        "\u297F": "dfisht",
        "\u299A": "vzigzag",
        "\u299C": "vangrt",
        "\u299D": "angrtvbd",
        "\u29A4": "ange",
        "\u29A5": "range",
        "\u29A6": "dwangle",
        "\u29A7": "uwangle",
        "\u29A8": "angmsdaa",
        "\u29A9": "angmsdab",
        "\u29AA": "angmsdac",
        "\u29AB": "angmsdad",
        "\u29AC": "angmsdae",
        "\u29AD": "angmsdaf",
        "\u29AE": "angmsdag",
        "\u29AF": "angmsdah",
        "\u29B0": "bemptyv",
        "\u29B1": "demptyv",
        "\u29B2": "cemptyv",
        "\u29B3": "raemptyv",
        "\u29B4": "laemptyv",
        "\u29B5": "ohbar",
        "\u29B6": "omid",
        "\u29B7": "opar",
        "\u29B9": "operp",
        "\u29BB": "olcross",
        "\u29BC": "odsold",
        "\u29BE": "olcir",
        "\u29BF": "ofcir",
        "\u29C0": "olt",
        "\u29C1": "ogt",
        "\u29C2": "cirscir",
        "\u29C3": "cirE",
        "\u29C4": "solb",
        "\u29C5": "bsolb",
        "\u29C9": "boxbox",
        "\u29CD": "trisb",
        "\u29CE": "rtriltri",
        "\u29CF": "LeftTriangleBar",
        "\u29CF\u0338": "NotLeftTriangleBar",
        "\u29D0": "RightTriangleBar",
        "\u29D0\u0338": "NotRightTriangleBar",
        "\u29DC": "iinfin",
        "\u29DD": "infintie",
        "\u29DE": "nvinfin",
        "\u29E3": "eparsl",
        "\u29E4": "smeparsl",
        "\u29E5": "eqvparsl",
        "\u29EB": "lozf",
        "\u29F4": "RuleDelayed",
        "\u29F6": "dsol",
        "\u2A00": "xodot",
        "\u2A01": "xoplus",
        "\u2A02": "xotime",
        "\u2A04": "xuplus",
        "\u2A06": "xsqcup",
        "\u2A0D": "fpartint",
        "\u2A10": "cirfnint",
        "\u2A11": "awint",
        "\u2A12": "rppolint",
        "\u2A13": "scpolint",
        "\u2A14": "npolint",
        "\u2A15": "pointint",
        "\u2A16": "quatint",
        "\u2A17": "intlarhk",
        "\u2A22": "pluscir",
        "\u2A23": "plusacir",
        "\u2A24": "simplus",
        "\u2A25": "plusdu",
        "\u2A26": "plussim",
        "\u2A27": "plustwo",
        "\u2A29": "mcomma",
        "\u2A2A": "minusdu",
        "\u2A2D": "loplus",
        "\u2A2E": "roplus",
        "\u2A2F": "Cross",
        "\u2A30": "timesd",
        "\u2A31": "timesbar",
        "\u2A33": "smashp",
        "\u2A34": "lotimes",
        "\u2A35": "rotimes",
        "\u2A36": "otimesas",
        "\u2A37": "Otimes",
        "\u2A38": "odiv",
        "\u2A39": "triplus",
        "\u2A3A": "triminus",
        "\u2A3B": "tritime",
        "\u2A3C": "iprod",
        "\u2A3F": "amalg",
        "\u2A40": "capdot",
        "\u2A42": "ncup",
        "\u2A43": "ncap",
        "\u2A44": "capand",
        "\u2A45": "cupor",
        "\u2A46": "cupcap",
        "\u2A47": "capcup",
        "\u2A48": "cupbrcap",
        "\u2A49": "capbrcup",
        "\u2A4A": "cupcup",
        "\u2A4B": "capcap",
        "\u2A4C": "ccups",
        "\u2A4D": "ccaps",
        "\u2A50": "ccupssm",
        "\u2A53": "And",
        "\u2A54": "Or",
        "\u2A55": "andand",
        "\u2A56": "oror",
        "\u2A57": "orslope",
        "\u2A58": "andslope",
        "\u2A5A": "andv",
        "\u2A5B": "orv",
        "\u2A5C": "andd",
        "\u2A5D": "ord",
        "\u2A5F": "wedbar",
        "\u2A66": "sdote",
        "\u2A6A": "simdot",
        "\u2A6D": "congdot",
        "\u2A6D\u0338": "ncongdot",
        "\u2A6E": "easter",
        "\u2A6F": "apacir",
        "\u2A70": "apE",
        "\u2A70\u0338": "napE",
        "\u2A71": "eplus",
        "\u2A72": "pluse",
        "\u2A73": "Esim",
        "\u2A77": "eDDot",
        "\u2A78": "equivDD",
        "\u2A79": "ltcir",
        "\u2A7A": "gtcir",
        "\u2A7B": "ltquest",
        "\u2A7C": "gtquest",
        "\u2A7D": "les",
        "\u2A7D\u0338": "nles",
        "\u2A7E": "ges",
        "\u2A7E\u0338": "nges",
        "\u2A7F": "lesdot",
        "\u2A80": "gesdot",
        "\u2A81": "lesdoto",
        "\u2A82": "gesdoto",
        "\u2A83": "lesdotor",
        "\u2A84": "gesdotol",
        "\u2A85": "lap",
        "\u2A86": "gap",
        "\u2A87": "lne",
        "\u2A88": "gne",
        "\u2A89": "lnap",
        "\u2A8A": "gnap",
        "\u2A8B": "lEg",
        "\u2A8C": "gEl",
        "\u2A8D": "lsime",
        "\u2A8E": "gsime",
        "\u2A8F": "lsimg",
        "\u2A90": "gsiml",
        "\u2A91": "lgE",
        "\u2A92": "glE",
        "\u2A93": "lesges",
        "\u2A94": "gesles",
        "\u2A95": "els",
        "\u2A96": "egs",
        "\u2A97": "elsdot",
        "\u2A98": "egsdot",
        "\u2A99": "el",
        "\u2A9A": "eg",
        "\u2A9D": "siml",
        "\u2A9E": "simg",
        "\u2A9F": "simlE",
        "\u2AA0": "simgE",
        "\u2AA1": "LessLess",
        "\u2AA1\u0338": "NotNestedLessLess",
        "\u2AA2": "GreaterGreater",
        "\u2AA2\u0338": "NotNestedGreaterGreater",
        "\u2AA4": "glj",
        "\u2AA5": "gla",
        "\u2AA6": "ltcc",
        "\u2AA7": "gtcc",
        "\u2AA8": "lescc",
        "\u2AA9": "gescc",
        "\u2AAA": "smt",
        "\u2AAB": "lat",
        "\u2AAC": "smte",
        "\u2AAC\uFE00": "smtes",
        "\u2AAD": "late",
        "\u2AAD\uFE00": "lates",
        "\u2AAE": "bumpE",
        "\u2AAF": "pre",
        "\u2AAF\u0338": "npre",
        "\u2AB0": "sce",
        "\u2AB0\u0338": "nsce",
        "\u2AB3": "prE",
        "\u2AB4": "scE",
        "\u2AB5": "prnE",
        "\u2AB6": "scnE",
        "\u2AB7": "prap",
        "\u2AB8": "scap",
        "\u2AB9": "prnap",
        "\u2ABA": "scnap",
        "\u2ABB": "Pr",
        "\u2ABC": "Sc",
        "\u2ABD": "subdot",
        "\u2ABE": "supdot",
        "\u2ABF": "subplus",
        "\u2AC0": "supplus",
        "\u2AC1": "submult",
        "\u2AC2": "supmult",
        "\u2AC3": "subedot",
        "\u2AC4": "supedot",
        "\u2AC5": "subE",
        "\u2AC5\u0338": "nsubE",
        "\u2AC6": "supE",
        "\u2AC6\u0338": "nsupE",
        "\u2AC7": "subsim",
        "\u2AC8": "supsim",
        "\u2ACB\uFE00": "vsubnE",
        "\u2ACB": "subnE",
        "\u2ACC\uFE00": "vsupnE",
        "\u2ACC": "supnE",
        "\u2ACF": "csub",
        "\u2AD0": "csup",
        "\u2AD1": "csube",
        "\u2AD2": "csupe",
        "\u2AD3": "subsup",
        "\u2AD4": "supsub",
        "\u2AD5": "subsub",
        "\u2AD6": "supsup",
        "\u2AD7": "suphsub",
        "\u2AD8": "supdsub",
        "\u2AD9": "forkv",
        "\u2ADA": "topfork",
        "\u2ADB": "mlcp",
        "\u2AE4": "Dashv",
        "\u2AE6": "Vdashl",
        "\u2AE7": "Barv",
        "\u2AE8": "vBar",
        "\u2AE9": "vBarv",
        "\u2AEB": "Vbar",
        "\u2AEC": "Not",
        "\u2AED": "bNot",
        "\u2AEE": "rnmid",
        "\u2AEF": "cirmid",
        "\u2AF0": "midcir",
        "\u2AF1": "topcir",
        "\u2AF2": "nhpar",
        "\u2AF3": "parsim",
        "\u2AFD": "parsl",
        "\u2AFD\u20E5": "nparsl",
        "\u266D": "flat",
        "\u266E": "natur",
        "\u266F": "sharp",
        "\xa4": "curren",
        "\xa2": "cent",
        "$": "dollar",
        "\xa3": "pound",
        "\xa5": "yen",
        "\u20AC": "euro",
        "\xb9": "sup1",
        "\xbd": "half",
        "\u2153": "frac13",
        "\xbc": "frac14",
        "\u2155": "frac15",
        "\u2159": "frac16",
        "\u215B": "frac18",
        "\xb2": "sup2",
        "\u2154": "frac23",
        "\u2156": "frac25",
        "\xb3": "sup3",
        "\xbe": "frac34",
        "\u2157": "frac35",
        "\u215C": "frac38",
        "\u2158": "frac45",
        "\u215A": "frac56",
        "\u215D": "frac58",
        "\u215E": "frac78",
        "\uD835\uDCB6": "ascr",
        "\uD835\uDD52": "aopf",
        "\uD835\uDD1E": "afr",
        "\uD835\uDD38": "Aopf",
        "\uD835\uDD04": "Afr",
        "\uD835\uDC9C": "Ascr",
        "\xaa": "ordf",
        "\xe1": "aacute",
        "\xc1": "Aacute",
        "\xe0": "agrave",
        "\xc0": "Agrave",
        "\u0103": "abreve",
        "\u0102": "Abreve",
        "\xe2": "acirc",
        "\xc2": "Acirc",
        "\xe5": "aring",
        "\xc5": "angst",
        "\xe4": "auml",
        "\xc4": "Auml",
        "\xe3": "atilde",
        "\xc3": "Atilde",
        "\u0105": "aogon",
        "\u0104": "Aogon",
        "\u0101": "amacr",
        "\u0100": "Amacr",
        "\xe6": "aelig",
        "\xc6": "AElig",
        "\uD835\uDCB7": "bscr",
        "\uD835\uDD53": "bopf",
        "\uD835\uDD1F": "bfr",
        "\uD835\uDD39": "Bopf",
        "\u212C": "Bscr",
        "\uD835\uDD05": "Bfr",
        "\uD835\uDD20": "cfr",
        "\uD835\uDCB8": "cscr",
        "\uD835\uDD54": "copf",
        "\u212D": "Cfr",
        "\uD835\uDC9E": "Cscr",
        "\u2102": "Copf",
        "\u0107": "cacute",
        "\u0106": "Cacute",
        "\u0109": "ccirc",
        "\u0108": "Ccirc",
        "\u010D": "ccaron",
        "\u010C": "Ccaron",
        "\u010B": "cdot",
        "\u010A": "Cdot",
        "\xe7": "ccedil",
        "\xc7": "Ccedil",
        "\u2105": "incare",
        "\uD835\uDD21": "dfr",
        "\u2146": "dd",
        "\uD835\uDD55": "dopf",
        "\uD835\uDCB9": "dscr",
        "\uD835\uDC9F": "Dscr",
        "\uD835\uDD07": "Dfr",
        "\u2145": "DD",
        "\uD835\uDD3B": "Dopf",
        "\u010F": "dcaron",
        "\u010E": "Dcaron",
        "\u0111": "dstrok",
        "\u0110": "Dstrok",
        "\xf0": "eth",
        "\xd0": "ETH",
        "\u2147": "ee",
        "\u212F": "escr",
        "\uD835\uDD22": "efr",
        "\uD835\uDD56": "eopf",
        "\u2130": "Escr",
        "\uD835\uDD08": "Efr",
        "\uD835\uDD3C": "Eopf",
        "\xe9": "eacute",
        "\xc9": "Eacute",
        "\xe8": "egrave",
        "\xc8": "Egrave",
        "\xea": "ecirc",
        "\xca": "Ecirc",
        "\u011B": "ecaron",
        "\u011A": "Ecaron",
        "\xeb": "euml",
        "\xcb": "Euml",
        "\u0117": "edot",
        "\u0116": "Edot",
        "\u0119": "eogon",
        "\u0118": "Eogon",
        "\u0113": "emacr",
        "\u0112": "Emacr",
        "\uD835\uDD23": "ffr",
        "\uD835\uDD57": "fopf",
        "\uD835\uDCBB": "fscr",
        "\uD835\uDD09": "Ffr",
        "\uD835\uDD3D": "Fopf",
        "\u2131": "Fscr",
        "\uFB00": "fflig",
        "\uFB03": "ffilig",
        "\uFB04": "ffllig",
        "\uFB01": "filig",
        "fj": "fjlig",
        "\uFB02": "fllig",
        "\u0192": "fnof",
        "\u210A": "gscr",
        "\uD835\uDD58": "gopf",
        "\uD835\uDD24": "gfr",
        "\uD835\uDCA2": "Gscr",
        "\uD835\uDD3E": "Gopf",
        "\uD835\uDD0A": "Gfr",
        "\u01F5": "gacute",
        "\u011F": "gbreve",
        "\u011E": "Gbreve",
        "\u011D": "gcirc",
        "\u011C": "Gcirc",
        "\u0121": "gdot",
        "\u0120": "Gdot",
        "\u0122": "Gcedil",
        "\uD835\uDD25": "hfr",
        "\u210E": "planckh",
        "\uD835\uDCBD": "hscr",
        "\uD835\uDD59": "hopf",
        "\u210B": "Hscr",
        "\u210C": "Hfr",
        "\u210D": "Hopf",
        "\u0125": "hcirc",
        "\u0124": "Hcirc",
        "\u210F": "hbar",
        "\u0127": "hstrok",
        "\u0126": "Hstrok",
        "\uD835\uDD5A": "iopf",
        "\uD835\uDD26": "ifr",
        "\uD835\uDCBE": "iscr",
        "\u2148": "ii",
        "\uD835\uDD40": "Iopf",
        "\u2110": "Iscr",
        "\u2111": "Im",
        "\xed": "iacute",
        "\xcd": "Iacute",
        "\xec": "igrave",
        "\xcc": "Igrave",
        "\xee": "icirc",
        "\xce": "Icirc",
        "\xef": "iuml",
        "\xcf": "Iuml",
        "\u0129": "itilde",
        "\u0128": "Itilde",
        "\u0130": "Idot",
        "\u012F": "iogon",
        "\u012E": "Iogon",
        "\u012B": "imacr",
        "\u012A": "Imacr",
        "\u0133": "ijlig",
        "\u0132": "IJlig",
        "\u0131": "imath",
        "\uD835\uDCBF": "jscr",
        "\uD835\uDD5B": "jopf",
        "\uD835\uDD27": "jfr",
        "\uD835\uDCA5": "Jscr",
        "\uD835\uDD0D": "Jfr",
        "\uD835\uDD41": "Jopf",
        "\u0135": "jcirc",
        "\u0134": "Jcirc",
        "\u0237": "jmath",
        "\uD835\uDD5C": "kopf",
        "\uD835\uDCC0": "kscr",
        "\uD835\uDD28": "kfr",
        "\uD835\uDCA6": "Kscr",
        "\uD835\uDD42": "Kopf",
        "\uD835\uDD0E": "Kfr",
        "\u0137": "kcedil",
        "\u0136": "Kcedil",
        "\uD835\uDD29": "lfr",
        "\uD835\uDCC1": "lscr",
        "\u2113": "ell",
        "\uD835\uDD5D": "lopf",
        "\u2112": "Lscr",
        "\uD835\uDD0F": "Lfr",
        "\uD835\uDD43": "Lopf",
        "\u013A": "lacute",
        "\u0139": "Lacute",
        "\u013E": "lcaron",
        "\u013D": "Lcaron",
        "\u013C": "lcedil",
        "\u013B": "Lcedil",
        "\u0142": "lstrok",
        "\u0141": "Lstrok",
        "\u0140": "lmidot",
        "\u013F": "Lmidot",
        "\uD835\uDD2A": "mfr",
        "\uD835\uDD5E": "mopf",
        "\uD835\uDCC2": "mscr",
        "\uD835\uDD10": "Mfr",
        "\uD835\uDD44": "Mopf",
        "\u2133": "Mscr",
        "\uD835\uDD2B": "nfr",
        "\uD835\uDD5F": "nopf",
        "\uD835\uDCC3": "nscr",
        "\u2115": "Nopf",
        "\uD835\uDCA9": "Nscr",
        "\uD835\uDD11": "Nfr",
        "\u0144": "nacute",
        "\u0143": "Nacute",
        "\u0148": "ncaron",
        "\u0147": "Ncaron",
        "\xf1": "ntilde",
        "\xd1": "Ntilde",
        "\u0146": "ncedil",
        "\u0145": "Ncedil",
        "\u2116": "numero",
        "\u014B": "eng",
        "\u014A": "ENG",
        "\uD835\uDD60": "oopf",
        "\uD835\uDD2C": "ofr",
        "\u2134": "oscr",
        "\uD835\uDCAA": "Oscr",
        "\uD835\uDD12": "Ofr",
        "\uD835\uDD46": "Oopf",
        "\xba": "ordm",
        "\xf3": "oacute",
        "\xd3": "Oacute",
        "\xf2": "ograve",
        "\xd2": "Ograve",
        "\xf4": "ocirc",
        "\xd4": "Ocirc",
        "\xf6": "ouml",
        "\xd6": "Ouml",
        "\u0151": "odblac",
        "\u0150": "Odblac",
        "\xf5": "otilde",
        "\xd5": "Otilde",
        "\xf8": "oslash",
        "\xd8": "Oslash",
        "\u014D": "omacr",
        "\u014C": "Omacr",
        "\u0153": "oelig",
        "\u0152": "OElig",
        "\uD835\uDD2D": "pfr",
        "\uD835\uDCC5": "pscr",
        "\uD835\uDD61": "popf",
        "\u2119": "Popf",
        "\uD835\uDD13": "Pfr",
        "\uD835\uDCAB": "Pscr",
        "\uD835\uDD62": "qopf",
        "\uD835\uDD2E": "qfr",
        "\uD835\uDCC6": "qscr",
        "\uD835\uDCAC": "Qscr",
        "\uD835\uDD14": "Qfr",
        "\u211A": "Qopf",
        "\u0138": "kgreen",
        "\uD835\uDD2F": "rfr",
        "\uD835\uDD63": "ropf",
        "\uD835\uDCC7": "rscr",
        "\u211B": "Rscr",
        "\u211C": "Re",
        "\u211D": "Ropf",
        "\u0155": "racute",
        "\u0154": "Racute",
        "\u0159": "rcaron",
        "\u0158": "Rcaron",
        "\u0157": "rcedil",
        "\u0156": "Rcedil",
        "\uD835\uDD64": "sopf",
        "\uD835\uDCC8": "sscr",
        "\uD835\uDD30": "sfr",
        "\uD835\uDD4A": "Sopf",
        "\uD835\uDD16": "Sfr",
        "\uD835\uDCAE": "Sscr",
        "\u24C8": "oS",
        "\u015B": "sacute",
        "\u015A": "Sacute",
        "\u015D": "scirc",
        "\u015C": "Scirc",
        "\u0161": "scaron",
        "\u0160": "Scaron",
        "\u015F": "scedil",
        "\u015E": "Scedil",
        "\xdf": "szlig",
        "\uD835\uDD31": "tfr",
        "\uD835\uDCC9": "tscr",
        "\uD835\uDD65": "topf",
        "\uD835\uDCAF": "Tscr",
        "\uD835\uDD17": "Tfr",
        "\uD835\uDD4B": "Topf",
        "\u0165": "tcaron",
        "\u0164": "Tcaron",
        "\u0163": "tcedil",
        "\u0162": "Tcedil",
        "\u2122": "trade",
        "\u0167": "tstrok",
        "\u0166": "Tstrok",
        "\uD835\uDCCA": "uscr",
        "\uD835\uDD66": "uopf",
        "\uD835\uDD32": "ufr",
        "\uD835\uDD4C": "Uopf",
        "\uD835\uDD18": "Ufr",
        "\uD835\uDCB0": "Uscr",
        "\xfa": "uacute",
        "\xda": "Uacute",
        "\xf9": "ugrave",
        "\xd9": "Ugrave",
        "\u016D": "ubreve",
        "\u016C": "Ubreve",
        "\xfb": "ucirc",
        "\xdb": "Ucirc",
        "\u016F": "uring",
        "\u016E": "Uring",
        "\xfc": "uuml",
        "\xdc": "Uuml",
        "\u0171": "udblac",
        "\u0170": "Udblac",
        "\u0169": "utilde",
        "\u0168": "Utilde",
        "\u0173": "uogon",
        "\u0172": "Uogon",
        "\u016B": "umacr",
        "\u016A": "Umacr",
        "\uD835\uDD33": "vfr",
        "\uD835\uDD67": "vopf",
        "\uD835\uDCCB": "vscr",
        "\uD835\uDD19": "Vfr",
        "\uD835\uDD4D": "Vopf",
        "\uD835\uDCB1": "Vscr",
        "\uD835\uDD68": "wopf",
        "\uD835\uDCCC": "wscr",
        "\uD835\uDD34": "wfr",
        "\uD835\uDCB2": "Wscr",
        "\uD835\uDD4E": "Wopf",
        "\uD835\uDD1A": "Wfr",
        "\u0175": "wcirc",
        "\u0174": "Wcirc",
        "\uD835\uDD35": "xfr",
        "\uD835\uDCCD": "xscr",
        "\uD835\uDD69": "xopf",
        "\uD835\uDD4F": "Xopf",
        "\uD835\uDD1B": "Xfr",
        "\uD835\uDCB3": "Xscr",
        "\uD835\uDD36": "yfr",
        "\uD835\uDCCE": "yscr",
        "\uD835\uDD6A": "yopf",
        "\uD835\uDCB4": "Yscr",
        "\uD835\uDD1C": "Yfr",
        "\uD835\uDD50": "Yopf",
        "\xfd": "yacute",
        "\xdd": "Yacute",
        "\u0177": "ycirc",
        "\u0176": "Ycirc",
        "\xff": "yuml",
        "\u0178": "Yuml",
        "\uD835\uDCCF": "zscr",
        "\uD835\uDD37": "zfr",
        "\uD835\uDD6B": "zopf",
        "\u2128": "Zfr",
        "\u2124": "Zopf",
        "\uD835\uDCB5": "Zscr",
        "\u017A": "zacute",
        "\u0179": "Zacute",
        "\u017E": "zcaron",
        "\u017D": "Zcaron",
        "\u017C": "zdot",
        "\u017B": "Zdot",
        "\u01B5": "imped",
        "\xfe": "thorn",
        "\xde": "THORN",
        "\u0149": "napos",
        "\u03B1": "alpha",
        "\u0391": "Alpha",
        "\u03B2": "beta",
        "\u0392": "Beta",
        "\u03B3": "gamma",
        "\u0393": "Gamma",
        "\u03B4": "delta",
        "\u0394": "Delta",
        "\u03B5": "epsi",
        "\u03F5": "epsiv",
        "\u0395": "Epsilon",
        "\u03DD": "gammad",
        "\u03DC": "Gammad",
        "\u03B6": "zeta",
        "\u0396": "Zeta",
        "\u03B7": "eta",
        "\u0397": "Eta",
        "\u03B8": "theta",
        "\u03D1": "thetav",
        "\u0398": "Theta",
        "\u03B9": "iota",
        "\u0399": "Iota",
        "\u03BA": "kappa",
        "\u03F0": "kappav",
        "\u039A": "Kappa",
        "\u03BB": "lambda",
        "\u039B": "Lambda",
        "\u03BC": "mu",
        "\xb5": "micro",
        "\u039C": "Mu",
        "\u03BD": "nu",
        "\u039D": "Nu",
        "\u03BE": "xi",
        "\u039E": "Xi",
        "\u03BF": "omicron",
        "\u039F": "Omicron",
        "\u03C0": "pi",
        "\u03D6": "piv",
        "\u03A0": "Pi",
        "\u03C1": "rho",
        "\u03F1": "rhov",
        "\u03A1": "Rho",
        "\u03C3": "sigma",
        "\u03A3": "Sigma",
        "\u03C2": "sigmaf",
        "\u03C4": "tau",
        "\u03A4": "Tau",
        "\u03C5": "upsi",
        "\u03A5": "Upsilon",
        "\u03D2": "Upsi",
        "\u03C6": "phi",
        "\u03D5": "phiv",
        "\u03A6": "Phi",
        "\u03C7": "chi",
        "\u03A7": "Chi",
        "\u03C8": "psi",
        "\u03A8": "Psi",
        "\u03C9": "omega",
        "\u03A9": "ohm",
        "\u0430": "acy",
        "\u0410": "Acy",
        "\u0431": "bcy",
        "\u0411": "Bcy",
        "\u0432": "vcy",
        "\u0412": "Vcy",
        "\u0433": "gcy",
        "\u0413": "Gcy",
        "\u0453": "gjcy",
        "\u0403": "GJcy",
        "\u0434": "dcy",
        "\u0414": "Dcy",
        "\u0452": "djcy",
        "\u0402": "DJcy",
        "\u0435": "iecy",
        "\u0415": "IEcy",
        "\u0451": "iocy",
        "\u0401": "IOcy",
        "\u0454": "jukcy",
        "\u0404": "Jukcy",
        "\u0436": "zhcy",
        "\u0416": "ZHcy",
        "\u0437": "zcy",
        "\u0417": "Zcy",
        "\u0455": "dscy",
        "\u0405": "DScy",
        "\u0438": "icy",
        "\u0418": "Icy",
        "\u0456": "iukcy",
        "\u0406": "Iukcy",
        "\u0457": "yicy",
        "\u0407": "YIcy",
        "\u0439": "jcy",
        "\u0419": "Jcy",
        "\u0458": "jsercy",
        "\u0408": "Jsercy",
        "\u043A": "kcy",
        "\u041A": "Kcy",
        "\u045C": "kjcy",
        "\u040C": "KJcy",
        "\u043B": "lcy",
        "\u041B": "Lcy",
        "\u0459": "ljcy",
        "\u0409": "LJcy",
        "\u043C": "mcy",
        "\u041C": "Mcy",
        "\u043D": "ncy",
        "\u041D": "Ncy",
        "\u045A": "njcy",
        "\u040A": "NJcy",
        "\u043E": "ocy",
        "\u041E": "Ocy",
        "\u043F": "pcy",
        "\u041F": "Pcy",
        "\u0440": "rcy",
        "\u0420": "Rcy",
        "\u0441": "scy",
        "\u0421": "Scy",
        "\u0442": "tcy",
        "\u0422": "Tcy",
        "\u045B": "tshcy",
        "\u040B": "TSHcy",
        "\u0443": "ucy",
        "\u0423": "Ucy",
        "\u045E": "ubrcy",
        "\u040E": "Ubrcy",
        "\u0444": "fcy",
        "\u0424": "Fcy",
        "\u0445": "khcy",
        "\u0425": "KHcy",
        "\u0446": "tscy",
        "\u0426": "TScy",
        "\u0447": "chcy",
        "\u0427": "CHcy",
        "\u045F": "dzcy",
        "\u040F": "DZcy",
        "\u0448": "shcy",
        "\u0428": "SHcy",
        "\u0449": "shchcy",
        "\u0429": "SHCHcy",
        "\u044A": "hardcy",
        "\u042A": "HARDcy",
        "\u044B": "ycy",
        "\u042B": "Ycy",
        "\u044C": "softcy",
        "\u042C": "SOFTcy",
        "\u044D": "ecy",
        "\u042D": "Ecy",
        "\u044E": "yucy",
        "\u042E": "YUcy",
        "\u044F": "yacy",
        "\u042F": "YAcy",
        "\u2135": "aleph",
        "\u2136": "beth",
        "\u2137": "gimel",
        "\u2138": "daleth"
    };
    var regexEscape = /["&'<>`]/g;
    var escapeMap = {
        '"': "&quot;",
        "&": "&amp;",
        "'": "&#x27;",
        "<": "&lt;",
        // See https://mathiasbynens.be/notes/ambiguous-ampersands: in HTML, the
        // following is not strictly necessary unless it’s part of a tag or an
        // unquoted attribute value. We’re only escaping it to support those
        // situations, and for XML support.
        ">": "&gt;",
        // In Internet Explorer ≤ 8, the backtick character can be used
        // to break out of (un)quoted attribute values or HTML comments.
        // See http://html5sec.org/#102, http://html5sec.org/#108, and
        // http://html5sec.org/#133.
        "`": "&#x60;"
    };
    var regexInvalidEntity = /&#(?:[xX][^a-fA-F0-9]|[^0-9xX])/;
    var regexInvalidRawCodePoint = /[\0-\x08\x0B\x0E-\x1F\x7F-\x9F\uFDD0-\uFDEF\uFFFE\uFFFF]|[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F\uDBBF\uDBFF][\uDFFE\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;
    var regexDecode = /&(CounterClockwiseContourIntegral|DoubleLongLeftRightArrow|ClockwiseContourIntegral|NotNestedGreaterGreater|NotSquareSupersetEqual|DiacriticalDoubleAcute|NotRightTriangleEqual|NotSucceedsSlantEqual|NotPrecedesSlantEqual|CloseCurlyDoubleQuote|NegativeVeryThinSpace|DoubleContourIntegral|FilledVerySmallSquare|CapitalDifferentialD|OpenCurlyDoubleQuote|EmptyVerySmallSquare|NestedGreaterGreater|DoubleLongRightArrow|NotLeftTriangleEqual|NotGreaterSlantEqual|ReverseUpEquilibrium|DoubleLeftRightArrow|NotSquareSubsetEqual|NotDoubleVerticalBar|RightArrowLeftArrow|NotGreaterFullEqual|NotRightTriangleBar|SquareSupersetEqual|DownLeftRightVector|DoubleLongLeftArrow|leftrightsquigarrow|LeftArrowRightArrow|NegativeMediumSpace|blacktriangleright|RightDownVectorBar|PrecedesSlantEqual|RightDoubleBracket|SucceedsSlantEqual|NotLeftTriangleBar|RightTriangleEqual|SquareIntersection|RightDownTeeVector|ReverseEquilibrium|NegativeThickSpace|longleftrightarrow|Longleftrightarrow|LongLeftRightArrow|DownRightTeeVector|DownRightVectorBar|GreaterSlantEqual|SquareSubsetEqual|LeftDownVectorBar|LeftDoubleBracket|VerticalSeparator|rightleftharpoons|NotGreaterGreater|NotSquareSuperset|blacktriangleleft|blacktriangledown|NegativeThinSpace|LeftDownTeeVector|NotLessSlantEqual|leftrightharpoons|DoubleUpDownArrow|DoubleVerticalBar|LeftTriangleEqual|FilledSmallSquare|twoheadrightarrow|NotNestedLessLess|DownLeftTeeVector|DownLeftVectorBar|RightAngleBracket|NotTildeFullEqual|NotReverseElement|RightUpDownVector|DiacriticalTilde|NotSucceedsTilde|circlearrowright|NotPrecedesEqual|rightharpoondown|DoubleRightArrow|NotSucceedsEqual|NonBreakingSpace|NotRightTriangle|LessEqualGreater|RightUpTeeVector|LeftAngleBracket|GreaterFullEqual|DownArrowUpArrow|RightUpVectorBar|twoheadleftarrow|GreaterEqualLess|downharpoonright|RightTriangleBar|ntrianglerighteq|NotSupersetEqual|LeftUpDownVector|DiacriticalAcute|rightrightarrows|vartriangleright|UpArrowDownArrow|DiacriticalGrave|UnderParenthesis|EmptySmallSquare|LeftUpVectorBar|leftrightarrows|DownRightVector|downharpoonleft|trianglerighteq|ShortRightArrow|OverParenthesis|DoubleLeftArrow|DoubleDownArrow|NotSquareSubset|bigtriangledown|ntrianglelefteq|UpperRightArrow|curvearrowright|vartriangleleft|NotLeftTriangle|nleftrightarrow|LowerRightArrow|NotHumpDownHump|NotGreaterTilde|rightthreetimes|LeftUpTeeVector|NotGreaterEqual|straightepsilon|LeftTriangleBar|rightsquigarrow|ContourIntegral|rightleftarrows|CloseCurlyQuote|RightDownVector|LeftRightVector|nLeftrightarrow|leftharpoondown|circlearrowleft|SquareSuperset|OpenCurlyQuote|hookrightarrow|HorizontalLine|DiacriticalDot|NotLessGreater|ntriangleright|DoubleRightTee|InvisibleComma|InvisibleTimes|LowerLeftArrow|DownLeftVector|NotSubsetEqual|curvearrowleft|trianglelefteq|NotVerticalBar|TildeFullEqual|downdownarrows|NotGreaterLess|RightTeeVector|ZeroWidthSpace|looparrowright|LongRightArrow|doublebarwedge|ShortLeftArrow|ShortDownArrow|RightVectorBar|GreaterGreater|ReverseElement|rightharpoonup|LessSlantEqual|leftthreetimes|upharpoonright|rightarrowtail|LeftDownVector|Longrightarrow|NestedLessLess|UpperLeftArrow|nshortparallel|leftleftarrows|leftrightarrow|Leftrightarrow|LeftRightArrow|longrightarrow|upharpoonleft|RightArrowBar|ApplyFunction|LeftTeeVector|leftarrowtail|NotEqualTilde|varsubsetneqq|varsupsetneqq|RightTeeArrow|SucceedsEqual|SucceedsTilde|LeftVectorBar|SupersetEqual|hookleftarrow|DifferentialD|VerticalTilde|VeryThinSpace|blacktriangle|bigtriangleup|LessFullEqual|divideontimes|leftharpoonup|UpEquilibrium|ntriangleleft|RightTriangle|measuredangle|shortparallel|longleftarrow|Longleftarrow|LongLeftArrow|DoubleLeftTee|Poincareplane|PrecedesEqual|triangleright|DoubleUpArrow|RightUpVector|fallingdotseq|looparrowleft|PrecedesTilde|NotTildeEqual|NotTildeTilde|smallsetminus|Proportional|triangleleft|triangledown|UnderBracket|NotHumpEqual|exponentiale|ExponentialE|NotLessTilde|HilbertSpace|RightCeiling|blacklozenge|varsupsetneq|HumpDownHump|GreaterEqual|VerticalLine|LeftTeeArrow|NotLessEqual|DownTeeArrow|LeftTriangle|varsubsetneq|Intersection|NotCongruent|DownArrowBar|LeftUpVector|LeftArrowBar|risingdotseq|GreaterTilde|RoundImplies|SquareSubset|ShortUpArrow|NotSuperset|quaternions|precnapprox|backepsilon|preccurlyeq|OverBracket|blacksquare|MediumSpace|VerticalBar|circledcirc|circleddash|CircleMinus|CircleTimes|LessGreater|curlyeqprec|curlyeqsucc|diamondsuit|UpDownArrow|Updownarrow|RuleDelayed|Rrightarrow|updownarrow|RightVector|nRightarrow|nrightarrow|eqslantless|LeftCeiling|Equilibrium|SmallCircle|expectation|NotSucceeds|thickapprox|GreaterLess|SquareUnion|NotPrecedes|NotLessLess|straightphi|succnapprox|succcurlyeq|SubsetEqual|sqsupseteq|Proportion|Laplacetrf|ImaginaryI|supsetneqq|NotGreater|gtreqqless|NotElement|ThickSpace|TildeEqual|TildeTilde|Fouriertrf|rmoustache|EqualTilde|eqslantgtr|UnderBrace|LeftVector|UpArrowBar|nLeftarrow|nsubseteqq|subsetneqq|nsupseteqq|nleftarrow|succapprox|lessapprox|UpTeeArrow|upuparrows|curlywedge|lesseqqgtr|varepsilon|varnothing|RightFloor|complement|CirclePlus|sqsubseteq|Lleftarrow|circledast|RightArrow|Rightarrow|rightarrow|lmoustache|Bernoullis|precapprox|mapstoleft|mapstodown|longmapsto|dotsquare|downarrow|DoubleDot|nsubseteq|supsetneq|leftarrow|nsupseteq|subsetneq|ThinSpace|ngeqslant|subseteqq|HumpEqual|NotSubset|triangleq|NotCupCap|lesseqgtr|heartsuit|TripleDot|Leftarrow|Coproduct|Congruent|varpropto|complexes|gvertneqq|LeftArrow|LessTilde|supseteqq|MinusPlus|CircleDot|nleqslant|NotExists|gtreqless|nparallel|UnionPlus|LeftFloor|checkmark|CenterDot|centerdot|Mellintrf|gtrapprox|bigotimes|OverBrace|spadesuit|therefore|pitchfork|rationals|PlusMinus|Backslash|Therefore|DownBreve|backsimeq|backprime|DownArrow|nshortmid|Downarrow|lvertneqq|eqvparsl|imagline|imagpart|infintie|integers|Integral|intercal|LessLess|Uarrocir|intlarhk|sqsupset|angmsdaf|sqsubset|llcorner|vartheta|cupbrcap|lnapprox|Superset|SuchThat|succnsim|succneqq|angmsdag|biguplus|curlyvee|trpezium|Succeeds|NotTilde|bigwedge|angmsdah|angrtvbd|triminus|cwconint|fpartint|lrcorner|smeparsl|subseteq|urcorner|lurdshar|laemptyv|DDotrahd|approxeq|ldrushar|awconint|mapstoup|backcong|shortmid|triangle|geqslant|gesdotol|timesbar|circledR|circledS|setminus|multimap|naturals|scpolint|ncongdot|RightTee|boxminus|gnapprox|boxtimes|andslope|thicksim|angmsdaa|varsigma|cirfnint|rtriltri|angmsdab|rppolint|angmsdac|barwedge|drbkarow|clubsuit|thetasym|bsolhsub|capbrcup|dzigrarr|doteqdot|DotEqual|dotminus|UnderBar|NotEqual|realpart|otimesas|ulcorner|hksearow|hkswarow|parallel|PartialD|elinters|emptyset|plusacir|bbrktbrk|angmsdad|pointint|bigoplus|angmsdae|Precedes|bigsqcup|varkappa|notindot|supseteq|precneqq|precnsim|profalar|profline|profsurf|leqslant|lesdotor|raemptyv|subplus|notnivb|notnivc|subrarr|zigrarr|vzigzag|submult|subedot|Element|between|cirscir|larrbfs|larrsim|lotimes|lbrksld|lbrkslu|lozenge|ldrdhar|dbkarow|bigcirc|epsilon|simrarr|simplus|ltquest|Epsilon|luruhar|gtquest|maltese|npolint|eqcolon|npreceq|bigodot|ddagger|gtrless|bnequiv|harrcir|ddotseq|equivDD|backsim|demptyv|nsqsube|nsqsupe|Upsilon|nsubset|upsilon|minusdu|nsucceq|swarrow|nsupset|coloneq|searrow|boxplus|napprox|natural|asympeq|alefsym|congdot|nearrow|bigstar|diamond|supplus|tritime|LeftTee|nvinfin|triplus|NewLine|nvltrie|nvrtrie|nwarrow|nexists|Diamond|ruluhar|Implies|supmult|angzarr|suplarr|suphsub|questeq|because|digamma|Because|olcross|bemptyv|omicron|Omicron|rotimes|NoBreak|intprod|angrtvb|orderof|uwangle|suphsol|lesdoto|orslope|DownTee|realine|cudarrl|rdldhar|OverBar|supedot|lessdot|supdsub|topfork|succsim|rbrkslu|rbrksld|pertenk|cudarrr|isindot|planckh|lessgtr|pluscir|gesdoto|plussim|plustwo|lesssim|cularrp|rarrsim|Cayleys|notinva|notinvb|notinvc|UpArrow|Uparrow|uparrow|NotLess|dwangle|precsim|Product|curarrm|Cconint|dotplus|rarrbfs|ccupssm|Cedilla|cemptyv|notniva|quatint|frac35|frac38|frac45|frac56|frac58|frac78|tridot|xoplus|gacute|gammad|Gammad|lfisht|lfloor|bigcup|sqsupe|gbreve|Gbreve|lharul|sqsube|sqcups|Gcedil|apacir|llhard|lmidot|Lmidot|lmoust|andand|sqcaps|approx|Abreve|spades|circeq|tprime|divide|topcir|Assign|topbot|gesdot|divonx|xuplus|timesd|gesles|atilde|solbar|SOFTcy|loplus|timesb|lowast|lowbar|dlcorn|dlcrop|softcy|dollar|lparlt|thksim|lrhard|Atilde|lsaquo|smashp|bigvee|thinsp|wreath|bkarow|lsquor|lstrok|Lstrok|lthree|ltimes|ltlarr|DotDot|simdot|ltrPar|weierp|xsqcup|angmsd|sigmav|sigmaf|zeetrf|Zcaron|zcaron|mapsto|vsupne|thetav|cirmid|marker|mcomma|Zacute|vsubnE|there4|gtlPar|vsubne|bottom|gtrarr|SHCHcy|shchcy|midast|midcir|middot|minusb|minusd|gtrdot|bowtie|sfrown|mnplus|models|colone|seswar|Colone|mstpos|searhk|gtrsim|nacute|Nacute|boxbox|telrec|hairsp|Tcedil|nbumpe|scnsim|ncaron|Ncaron|ncedil|Ncedil|hamilt|Scedil|nearhk|hardcy|HARDcy|tcedil|Tcaron|commat|nequiv|nesear|tcaron|target|hearts|nexist|varrho|scedil|Scaron|scaron|hellip|Sacute|sacute|hercon|swnwar|compfn|rtimes|rthree|rsquor|rsaquo|zacute|wedgeq|homtht|barvee|barwed|Barwed|rpargt|horbar|conint|swarhk|roplus|nltrie|hslash|hstrok|Hstrok|rmoust|Conint|bprime|hybull|hyphen|iacute|Iacute|supsup|supsub|supsim|varphi|coprod|brvbar|agrave|Supset|supset|igrave|Igrave|notinE|Agrave|iiiint|iinfin|copysr|wedbar|Verbar|vangrt|becaus|incare|verbar|inodot|bullet|drcorn|intcal|drcrop|cularr|vellip|Utilde|bumpeq|cupcap|dstrok|Dstrok|CupCap|cupcup|cupdot|eacute|Eacute|supdot|iquest|easter|ecaron|Ecaron|ecolon|isinsv|utilde|itilde|Itilde|curarr|succeq|Bumpeq|cacute|ulcrop|nparsl|Cacute|nprcue|egrave|Egrave|nrarrc|nrarrw|subsup|subsub|nrtrie|jsercy|nsccue|Jsercy|kappav|kcedil|Kcedil|subsim|ulcorn|nsimeq|egsdot|veebar|kgreen|capand|elsdot|Subset|subset|curren|aacute|lacute|Lacute|emptyv|ntilde|Ntilde|lagran|lambda|Lambda|capcap|Ugrave|langle|subdot|emsp13|numero|emsp14|nvdash|nvDash|nVdash|nVDash|ugrave|ufisht|nvHarr|larrfs|nvlArr|larrhk|larrlp|larrpl|nvrArr|Udblac|nwarhk|larrtl|nwnear|oacute|Oacute|latail|lAtail|sstarf|lbrace|odblac|Odblac|lbrack|udblac|odsold|eparsl|lcaron|Lcaron|ograve|Ograve|lcedil|Lcedil|Aacute|ssmile|ssetmn|squarf|ldquor|capcup|ominus|cylcty|rharul|eqcirc|dagger|rfloor|rfisht|Dagger|daleth|equals|origof|capdot|equest|dcaron|Dcaron|rdquor|oslash|Oslash|otilde|Otilde|otimes|Otimes|urcrop|Ubreve|ubreve|Yacute|Uacute|uacute|Rcedil|rcedil|urcorn|parsim|Rcaron|Vdashl|rcaron|Tstrok|percnt|period|permil|Exists|yacute|rbrack|rbrace|phmmat|ccaron|Ccaron|planck|ccedil|plankv|tstrok|female|plusdo|plusdu|ffilig|plusmn|ffllig|Ccedil|rAtail|dfisht|bernou|ratail|Rarrtl|rarrtl|angsph|rarrpl|rarrlp|rarrhk|xwedge|xotime|forall|ForAll|Vvdash|vsupnE|preceq|bigcap|frac12|frac13|frac14|primes|rarrfs|prnsim|frac15|Square|frac16|square|lesdot|frac18|frac23|propto|prurel|rarrap|rangle|puncsp|frac25|Racute|qprime|racute|lesges|frac34|abreve|AElig|eqsim|utdot|setmn|urtri|Equal|Uring|seArr|uring|searr|dashv|Dashv|mumap|nabla|iogon|Iogon|sdote|sdotb|scsim|napid|napos|equiv|natur|Acirc|dblac|erarr|nbump|iprod|erDot|ucirc|awint|esdot|angrt|ncong|isinE|scnap|Scirc|scirc|ndash|isins|Ubrcy|nearr|neArr|isinv|nedot|ubrcy|acute|Ycirc|iukcy|Iukcy|xutri|nesim|caret|jcirc|Jcirc|caron|twixt|ddarr|sccue|exist|jmath|sbquo|ngeqq|angst|ccaps|lceil|ngsim|UpTee|delta|Delta|rtrif|nharr|nhArr|nhpar|rtrie|jukcy|Jukcy|kappa|rsquo|Kappa|nlarr|nlArr|TSHcy|rrarr|aogon|Aogon|fflig|xrarr|tshcy|ccirc|nleqq|filig|upsih|nless|dharl|nlsim|fjlig|ropar|nltri|dharr|robrk|roarr|fllig|fltns|roang|rnmid|subnE|subne|lAarr|trisb|Ccirc|acirc|ccups|blank|VDash|forkv|Vdash|langd|cedil|blk12|blk14|laquo|strns|diams|notin|vDash|larrb|blk34|block|disin|uplus|vdash|vBarv|aelig|starf|Wedge|check|xrArr|lates|lbarr|lBarr|notni|lbbrk|bcong|frasl|lbrke|frown|vrtri|vprop|vnsup|gamma|Gamma|wedge|xodot|bdquo|srarr|doteq|ldquo|boxdl|boxdL|gcirc|Gcirc|boxDl|boxDL|boxdr|boxdR|boxDr|TRADE|trade|rlhar|boxDR|vnsub|npart|vltri|rlarr|boxhd|boxhD|nprec|gescc|nrarr|nrArr|boxHd|boxHD|boxhu|boxhU|nrtri|boxHu|clubs|boxHU|times|colon|Colon|gimel|xlArr|Tilde|nsime|tilde|nsmid|nspar|THORN|thorn|xlarr|nsube|nsubE|thkap|xhArr|comma|nsucc|boxul|boxuL|nsupe|nsupE|gneqq|gnsim|boxUl|boxUL|grave|boxur|boxuR|boxUr|boxUR|lescc|angle|bepsi|boxvh|varpi|boxvH|numsp|Theta|gsime|gsiml|theta|boxVh|boxVH|boxvl|gtcir|gtdot|boxvL|boxVl|boxVL|crarr|cross|Cross|nvsim|boxvr|nwarr|nwArr|sqsup|dtdot|Uogon|lhard|lharu|dtrif|ocirc|Ocirc|lhblk|duarr|odash|sqsub|Hacek|sqcup|llarr|duhar|oelig|OElig|ofcir|boxvR|uogon|lltri|boxVr|csube|uuarr|ohbar|csupe|ctdot|olarr|olcir|harrw|oline|sqcap|omacr|Omacr|omega|Omega|boxVR|aleph|lneqq|lnsim|loang|loarr|rharu|lobrk|hcirc|operp|oplus|rhard|Hcirc|orarr|Union|order|ecirc|Ecirc|cuepr|szlig|cuesc|breve|reals|eDDot|Breve|hoarr|lopar|utrif|rdquo|Umacr|umacr|efDot|swArr|ultri|alpha|rceil|ovbar|swarr|Wcirc|wcirc|smtes|smile|bsemi|lrarr|aring|parsl|lrhar|bsime|uhblk|lrtri|cupor|Aring|uharr|uharl|slarr|rbrke|bsolb|lsime|rbbrk|RBarr|lsimg|phone|rBarr|rbarr|icirc|lsquo|Icirc|emacr|Emacr|ratio|simne|plusb|simlE|simgE|simeq|pluse|ltcir|ltdot|empty|xharr|xdtri|iexcl|Alpha|ltrie|rarrw|pound|ltrif|xcirc|bumpe|prcue|bumpE|asymp|amacr|cuvee|Sigma|sigma|iiint|udhar|iiota|ijlig|IJlig|supnE|imacr|Imacr|prime|Prime|image|prnap|eogon|Eogon|rarrc|mdash|mDDot|cuwed|imath|supne|imped|Amacr|udarr|prsim|micro|rarrb|cwint|raquo|infin|eplus|range|rangd|Ucirc|radic|minus|amalg|veeeq|rAarr|epsiv|ycirc|quest|sharp|quot|zwnj|Qscr|race|qscr|Qopf|qopf|qint|rang|Rang|Zscr|zscr|Zopf|zopf|rarr|rArr|Rarr|Pscr|pscr|prop|prod|prnE|prec|ZHcy|zhcy|prap|Zeta|zeta|Popf|popf|Zdot|plus|zdot|Yuml|yuml|phiv|YUcy|yucy|Yscr|yscr|perp|Yopf|yopf|part|para|YIcy|Ouml|rcub|yicy|YAcy|rdca|ouml|osol|Oscr|rdsh|yacy|real|oscr|xvee|andd|rect|andv|Xscr|oror|ordm|ordf|xscr|ange|aopf|Aopf|rHar|Xopf|opar|Oopf|xopf|xnis|rhov|oopf|omid|xmap|oint|apid|apos|ogon|ascr|Ascr|odot|odiv|xcup|xcap|ocir|oast|nvlt|nvle|nvgt|nvge|nvap|Wscr|wscr|auml|ntlg|ntgl|nsup|nsub|nsim|Nscr|nscr|nsce|Wopf|ring|npre|wopf|npar|Auml|Barv|bbrk|Nopf|nopf|nmid|nLtv|beta|ropf|Ropf|Beta|beth|nles|rpar|nleq|bnot|bNot|nldr|NJcy|rscr|Rscr|Vscr|vscr|rsqb|njcy|bopf|nisd|Bopf|rtri|Vopf|nGtv|ngtr|vopf|boxh|boxH|boxv|nges|ngeq|boxV|bscr|scap|Bscr|bsim|Vert|vert|bsol|bull|bump|caps|cdot|ncup|scnE|ncap|nbsp|napE|Cdot|cent|sdot|Vbar|nang|vBar|chcy|Mscr|mscr|sect|semi|CHcy|Mopf|mopf|sext|circ|cire|mldr|mlcp|cirE|comp|shcy|SHcy|vArr|varr|cong|copf|Copf|copy|COPY|malt|male|macr|lvnE|cscr|ltri|sime|ltcc|simg|Cscr|siml|csub|Uuml|lsqb|lsim|uuml|csup|Lscr|lscr|utri|smid|lpar|cups|smte|lozf|darr|Lopf|Uscr|solb|lopf|sopf|Sopf|lneq|uscr|spar|dArr|lnap|Darr|dash|Sqrt|LJcy|ljcy|lHar|dHar|Upsi|upsi|diam|lesg|djcy|DJcy|leqq|dopf|Dopf|dscr|Dscr|dscy|ldsh|ldca|squf|DScy|sscr|Sscr|dsol|lcub|late|star|Star|Uopf|Larr|lArr|larr|uopf|dtri|dzcy|sube|subE|Lang|lang|Kscr|kscr|Kopf|kopf|KJcy|kjcy|KHcy|khcy|DZcy|ecir|edot|eDot|Jscr|jscr|succ|Jopf|jopf|Edot|uHar|emsp|ensp|Iuml|iuml|eopf|isin|Iscr|iscr|Eopf|epar|sung|epsi|escr|sup1|sup2|sup3|Iota|iota|supe|supE|Iopf|iopf|IOcy|iocy|Escr|esim|Esim|imof|Uarr|QUOT|uArr|uarr|euml|IEcy|iecy|Idot|Euml|euro|excl|Hscr|hscr|Hopf|hopf|TScy|tscy|Tscr|hbar|tscr|flat|tbrk|fnof|hArr|harr|half|fopf|Fopf|tdot|gvnE|fork|trie|gtcc|fscr|Fscr|gdot|gsim|Gscr|gscr|Gopf|gopf|gneq|Gdot|tosa|gnap|Topf|topf|geqq|toea|GJcy|gjcy|tint|gesl|mid|Sfr|ggg|top|ges|gla|glE|glj|geq|gne|gEl|gel|gnE|Gcy|gcy|gap|Tfr|tfr|Tcy|tcy|Hat|Tau|Ffr|tau|Tab|hfr|Hfr|ffr|Fcy|fcy|icy|Icy|iff|ETH|eth|ifr|Ifr|Eta|eta|int|Int|Sup|sup|ucy|Ucy|Sum|sum|jcy|ENG|ufr|Ufr|eng|Jcy|jfr|els|ell|egs|Efr|efr|Jfr|uml|kcy|Kcy|Ecy|ecy|kfr|Kfr|lap|Sub|sub|lat|lcy|Lcy|leg|Dot|dot|lEg|leq|les|squ|div|die|lfr|Lfr|lgE|Dfr|dfr|Del|deg|Dcy|dcy|lne|lnE|sol|loz|smt|Cup|lrm|cup|lsh|Lsh|sim|shy|map|Map|mcy|Mcy|mfr|Mfr|mho|gfr|Gfr|sfr|cir|Chi|chi|nap|Cfr|vcy|Vcy|cfr|Scy|scy|ncy|Ncy|vee|Vee|Cap|cap|nfr|scE|sce|Nfr|nge|ngE|nGg|vfr|Vfr|ngt|bot|nGt|nis|niv|Rsh|rsh|nle|nlE|bne|Bfr|bfr|nLl|nlt|nLt|Bcy|bcy|not|Not|rlm|wfr|Wfr|npr|nsc|num|ocy|ast|Ocy|ofr|xfr|Xfr|Ofr|ogt|ohm|apE|olt|Rho|ape|rho|Rfr|rfr|ord|REG|ang|reg|orv|And|and|AMP|Rcy|amp|Afr|ycy|Ycy|yen|yfr|Yfr|rcy|par|pcy|Pcy|pfr|Pfr|phi|Phi|afr|Acy|acy|zcy|Zcy|piv|acE|acd|zfr|Zfr|pre|prE|psi|Psi|qfr|Qfr|zwj|Or|ge|Gg|gt|gg|el|oS|lt|Lt|LT|Re|lg|gl|eg|ne|Im|it|le|DD|wp|wr|nu|Nu|dd|lE|Sc|sc|pi|Pi|ee|af|ll|Ll|rx|gE|xi|pm|Xi|ic|pr|Pr|in|ni|mp|mu|ac|Mu|or|ap|Gt|GT|ii);|&(Aacute|Agrave|Atilde|Ccedil|Eacute|Egrave|Iacute|Igrave|Ntilde|Oacute|Ograve|Oslash|Otilde|Uacute|Ugrave|Yacute|aacute|agrave|atilde|brvbar|ccedil|curren|divide|eacute|egrave|frac12|frac14|frac34|iacute|igrave|iquest|middot|ntilde|oacute|ograve|oslash|otilde|plusmn|uacute|ugrave|yacute|AElig|Acirc|Aring|Ecirc|Icirc|Ocirc|THORN|Ucirc|acirc|acute|aelig|aring|cedil|ecirc|icirc|iexcl|laquo|micro|ocirc|pound|raquo|szlig|thorn|times|ucirc|Auml|COPY|Euml|Iuml|Ouml|QUOT|Uuml|auml|cent|copy|euml|iuml|macr|nbsp|ordf|ordm|ouml|para|quot|sect|sup1|sup2|sup3|uuml|yuml|AMP|ETH|REG|amp|deg|eth|not|reg|shy|uml|yen|GT|LT|gt|lt)(?!;)([=a-zA-Z0-9]?)|&#([0-9]+)(;?)|&#[xX]([a-fA-F0-9]+)(;?)|&([0-9a-zA-Z]+)/g;
    var decodeMap = {
        "aacute": "\xe1",
        "Aacute": "\xc1",
        "abreve": "\u0103",
        "Abreve": "\u0102",
        "ac": "\u223E",
        "acd": "\u223F",
        "acE": "\u223E\u0333",
        "acirc": "\xe2",
        "Acirc": "\xc2",
        "acute": "\xb4",
        "acy": "\u0430",
        "Acy": "\u0410",
        "aelig": "\xe6",
        "AElig": "\xc6",
        "af": "\u2061",
        "afr": "\uD835\uDD1E",
        "Afr": "\uD835\uDD04",
        "agrave": "\xe0",
        "Agrave": "\xc0",
        "alefsym": "\u2135",
        "aleph": "\u2135",
        "alpha": "\u03B1",
        "Alpha": "\u0391",
        "amacr": "\u0101",
        "Amacr": "\u0100",
        "amalg": "\u2A3F",
        "amp": "&",
        "AMP": "&",
        "and": "\u2227",
        "And": "\u2A53",
        "andand": "\u2A55",
        "andd": "\u2A5C",
        "andslope": "\u2A58",
        "andv": "\u2A5A",
        "ang": "\u2220",
        "ange": "\u29A4",
        "angle": "\u2220",
        "angmsd": "\u2221",
        "angmsdaa": "\u29A8",
        "angmsdab": "\u29A9",
        "angmsdac": "\u29AA",
        "angmsdad": "\u29AB",
        "angmsdae": "\u29AC",
        "angmsdaf": "\u29AD",
        "angmsdag": "\u29AE",
        "angmsdah": "\u29AF",
        "angrt": "\u221F",
        "angrtvb": "\u22BE",
        "angrtvbd": "\u299D",
        "angsph": "\u2222",
        "angst": "\xc5",
        "angzarr": "\u237C",
        "aogon": "\u0105",
        "Aogon": "\u0104",
        "aopf": "\uD835\uDD52",
        "Aopf": "\uD835\uDD38",
        "ap": "\u2248",
        "apacir": "\u2A6F",
        "ape": "\u224A",
        "apE": "\u2A70",
        "apid": "\u224B",
        "apos": "'",
        "ApplyFunction": "\u2061",
        "approx": "\u2248",
        "approxeq": "\u224A",
        "aring": "\xe5",
        "Aring": "\xc5",
        "ascr": "\uD835\uDCB6",
        "Ascr": "\uD835\uDC9C",
        "Assign": "\u2254",
        "ast": "*",
        "asymp": "\u2248",
        "asympeq": "\u224D",
        "atilde": "\xe3",
        "Atilde": "\xc3",
        "auml": "\xe4",
        "Auml": "\xc4",
        "awconint": "\u2233",
        "awint": "\u2A11",
        "backcong": "\u224C",
        "backepsilon": "\u03F6",
        "backprime": "\u2035",
        "backsim": "\u223D",
        "backsimeq": "\u22CD",
        "Backslash": "\u2216",
        "Barv": "\u2AE7",
        "barvee": "\u22BD",
        "barwed": "\u2305",
        "Barwed": "\u2306",
        "barwedge": "\u2305",
        "bbrk": "\u23B5",
        "bbrktbrk": "\u23B6",
        "bcong": "\u224C",
        "bcy": "\u0431",
        "Bcy": "\u0411",
        "bdquo": "\u201E",
        "becaus": "\u2235",
        "because": "\u2235",
        "Because": "\u2235",
        "bemptyv": "\u29B0",
        "bepsi": "\u03F6",
        "bernou": "\u212C",
        "Bernoullis": "\u212C",
        "beta": "\u03B2",
        "Beta": "\u0392",
        "beth": "\u2136",
        "between": "\u226C",
        "bfr": "\uD835\uDD1F",
        "Bfr": "\uD835\uDD05",
        "bigcap": "\u22C2",
        "bigcirc": "\u25EF",
        "bigcup": "\u22C3",
        "bigodot": "\u2A00",
        "bigoplus": "\u2A01",
        "bigotimes": "\u2A02",
        "bigsqcup": "\u2A06",
        "bigstar": "\u2605",
        "bigtriangledown": "\u25BD",
        "bigtriangleup": "\u25B3",
        "biguplus": "\u2A04",
        "bigvee": "\u22C1",
        "bigwedge": "\u22C0",
        "bkarow": "\u290D",
        "blacklozenge": "\u29EB",
        "blacksquare": "\u25AA",
        "blacktriangle": "\u25B4",
        "blacktriangledown": "\u25BE",
        "blacktriangleleft": "\u25C2",
        "blacktriangleright": "\u25B8",
        "blank": "\u2423",
        "blk12": "\u2592",
        "blk14": "\u2591",
        "blk34": "\u2593",
        "block": "\u2588",
        "bne": "=\u20E5",
        "bnequiv": "\u2261\u20E5",
        "bnot": "\u2310",
        "bNot": "\u2AED",
        "bopf": "\uD835\uDD53",
        "Bopf": "\uD835\uDD39",
        "bot": "\u22A5",
        "bottom": "\u22A5",
        "bowtie": "\u22C8",
        "boxbox": "\u29C9",
        "boxdl": "\u2510",
        "boxdL": "\u2555",
        "boxDl": "\u2556",
        "boxDL": "\u2557",
        "boxdr": "\u250C",
        "boxdR": "\u2552",
        "boxDr": "\u2553",
        "boxDR": "\u2554",
        "boxh": "\u2500",
        "boxH": "\u2550",
        "boxhd": "\u252C",
        "boxhD": "\u2565",
        "boxHd": "\u2564",
        "boxHD": "\u2566",
        "boxhu": "\u2534",
        "boxhU": "\u2568",
        "boxHu": "\u2567",
        "boxHU": "\u2569",
        "boxminus": "\u229F",
        "boxplus": "\u229E",
        "boxtimes": "\u22A0",
        "boxul": "\u2518",
        "boxuL": "\u255B",
        "boxUl": "\u255C",
        "boxUL": "\u255D",
        "boxur": "\u2514",
        "boxuR": "\u2558",
        "boxUr": "\u2559",
        "boxUR": "\u255A",
        "boxv": "\u2502",
        "boxV": "\u2551",
        "boxvh": "\u253C",
        "boxvH": "\u256A",
        "boxVh": "\u256B",
        "boxVH": "\u256C",
        "boxvl": "\u2524",
        "boxvL": "\u2561",
        "boxVl": "\u2562",
        "boxVL": "\u2563",
        "boxvr": "\u251C",
        "boxvR": "\u255E",
        "boxVr": "\u255F",
        "boxVR": "\u2560",
        "bprime": "\u2035",
        "breve": "\u02D8",
        "Breve": "\u02D8",
        "brvbar": "\xa6",
        "bscr": "\uD835\uDCB7",
        "Bscr": "\u212C",
        "bsemi": "\u204F",
        "bsim": "\u223D",
        "bsime": "\u22CD",
        "bsol": "\\",
        "bsolb": "\u29C5",
        "bsolhsub": "\u27C8",
        "bull": "\u2022",
        "bullet": "\u2022",
        "bump": "\u224E",
        "bumpe": "\u224F",
        "bumpE": "\u2AAE",
        "bumpeq": "\u224F",
        "Bumpeq": "\u224E",
        "cacute": "\u0107",
        "Cacute": "\u0106",
        "cap": "\u2229",
        "Cap": "\u22D2",
        "capand": "\u2A44",
        "capbrcup": "\u2A49",
        "capcap": "\u2A4B",
        "capcup": "\u2A47",
        "capdot": "\u2A40",
        "CapitalDifferentialD": "\u2145",
        "caps": "\u2229\uFE00",
        "caret": "\u2041",
        "caron": "\u02C7",
        "Cayleys": "\u212D",
        "ccaps": "\u2A4D",
        "ccaron": "\u010D",
        "Ccaron": "\u010C",
        "ccedil": "\xe7",
        "Ccedil": "\xc7",
        "ccirc": "\u0109",
        "Ccirc": "\u0108",
        "Cconint": "\u2230",
        "ccups": "\u2A4C",
        "ccupssm": "\u2A50",
        "cdot": "\u010B",
        "Cdot": "\u010A",
        "cedil": "\xb8",
        "Cedilla": "\xb8",
        "cemptyv": "\u29B2",
        "cent": "\xa2",
        "centerdot": "\xb7",
        "CenterDot": "\xb7",
        "cfr": "\uD835\uDD20",
        "Cfr": "\u212D",
        "chcy": "\u0447",
        "CHcy": "\u0427",
        "check": "\u2713",
        "checkmark": "\u2713",
        "chi": "\u03C7",
        "Chi": "\u03A7",
        "cir": "\u25CB",
        "circ": "\u02C6",
        "circeq": "\u2257",
        "circlearrowleft": "\u21BA",
        "circlearrowright": "\u21BB",
        "circledast": "\u229B",
        "circledcirc": "\u229A",
        "circleddash": "\u229D",
        "CircleDot": "\u2299",
        "circledR": "\xae",
        "circledS": "\u24C8",
        "CircleMinus": "\u2296",
        "CirclePlus": "\u2295",
        "CircleTimes": "\u2297",
        "cire": "\u2257",
        "cirE": "\u29C3",
        "cirfnint": "\u2A10",
        "cirmid": "\u2AEF",
        "cirscir": "\u29C2",
        "ClockwiseContourIntegral": "\u2232",
        "CloseCurlyDoubleQuote": "\u201D",
        "CloseCurlyQuote": "\u2019",
        "clubs": "\u2663",
        "clubsuit": "\u2663",
        "colon": ":",
        "Colon": "\u2237",
        "colone": "\u2254",
        "Colone": "\u2A74",
        "coloneq": "\u2254",
        "comma": ",",
        "commat": "@",
        "comp": "\u2201",
        "compfn": "\u2218",
        "complement": "\u2201",
        "complexes": "\u2102",
        "cong": "\u2245",
        "congdot": "\u2A6D",
        "Congruent": "\u2261",
        "conint": "\u222E",
        "Conint": "\u222F",
        "ContourIntegral": "\u222E",
        "copf": "\uD835\uDD54",
        "Copf": "\u2102",
        "coprod": "\u2210",
        "Coproduct": "\u2210",
        "copy": "\xa9",
        "COPY": "\xa9",
        "copysr": "\u2117",
        "CounterClockwiseContourIntegral": "\u2233",
        "crarr": "\u21B5",
        "cross": "\u2717",
        "Cross": "\u2A2F",
        "cscr": "\uD835\uDCB8",
        "Cscr": "\uD835\uDC9E",
        "csub": "\u2ACF",
        "csube": "\u2AD1",
        "csup": "\u2AD0",
        "csupe": "\u2AD2",
        "ctdot": "\u22EF",
        "cudarrl": "\u2938",
        "cudarrr": "\u2935",
        "cuepr": "\u22DE",
        "cuesc": "\u22DF",
        "cularr": "\u21B6",
        "cularrp": "\u293D",
        "cup": "\u222A",
        "Cup": "\u22D3",
        "cupbrcap": "\u2A48",
        "cupcap": "\u2A46",
        "CupCap": "\u224D",
        "cupcup": "\u2A4A",
        "cupdot": "\u228D",
        "cupor": "\u2A45",
        "cups": "\u222A\uFE00",
        "curarr": "\u21B7",
        "curarrm": "\u293C",
        "curlyeqprec": "\u22DE",
        "curlyeqsucc": "\u22DF",
        "curlyvee": "\u22CE",
        "curlywedge": "\u22CF",
        "curren": "\xa4",
        "curvearrowleft": "\u21B6",
        "curvearrowright": "\u21B7",
        "cuvee": "\u22CE",
        "cuwed": "\u22CF",
        "cwconint": "\u2232",
        "cwint": "\u2231",
        "cylcty": "\u232D",
        "dagger": "\u2020",
        "Dagger": "\u2021",
        "daleth": "\u2138",
        "darr": "\u2193",
        "dArr": "\u21D3",
        "Darr": "\u21A1",
        "dash": "\u2010",
        "dashv": "\u22A3",
        "Dashv": "\u2AE4",
        "dbkarow": "\u290F",
        "dblac": "\u02DD",
        "dcaron": "\u010F",
        "Dcaron": "\u010E",
        "dcy": "\u0434",
        "Dcy": "\u0414",
        "dd": "\u2146",
        "DD": "\u2145",
        "ddagger": "\u2021",
        "ddarr": "\u21CA",
        "DDotrahd": "\u2911",
        "ddotseq": "\u2A77",
        "deg": "\xb0",
        "Del": "\u2207",
        "delta": "\u03B4",
        "Delta": "\u0394",
        "demptyv": "\u29B1",
        "dfisht": "\u297F",
        "dfr": "\uD835\uDD21",
        "Dfr": "\uD835\uDD07",
        "dHar": "\u2965",
        "dharl": "\u21C3",
        "dharr": "\u21C2",
        "DiacriticalAcute": "\xb4",
        "DiacriticalDot": "\u02D9",
        "DiacriticalDoubleAcute": "\u02DD",
        "DiacriticalGrave": "`",
        "DiacriticalTilde": "\u02DC",
        "diam": "\u22C4",
        "diamond": "\u22C4",
        "Diamond": "\u22C4",
        "diamondsuit": "\u2666",
        "diams": "\u2666",
        "die": "\xa8",
        "DifferentialD": "\u2146",
        "digamma": "\u03DD",
        "disin": "\u22F2",
        "div": "\xf7",
        "divide": "\xf7",
        "divideontimes": "\u22C7",
        "divonx": "\u22C7",
        "djcy": "\u0452",
        "DJcy": "\u0402",
        "dlcorn": "\u231E",
        "dlcrop": "\u230D",
        "dollar": "$",
        "dopf": "\uD835\uDD55",
        "Dopf": "\uD835\uDD3B",
        "dot": "\u02D9",
        "Dot": "\xa8",
        "DotDot": "\u20DC",
        "doteq": "\u2250",
        "doteqdot": "\u2251",
        "DotEqual": "\u2250",
        "dotminus": "\u2238",
        "dotplus": "\u2214",
        "dotsquare": "\u22A1",
        "doublebarwedge": "\u2306",
        "DoubleContourIntegral": "\u222F",
        "DoubleDot": "\xa8",
        "DoubleDownArrow": "\u21D3",
        "DoubleLeftArrow": "\u21D0",
        "DoubleLeftRightArrow": "\u21D4",
        "DoubleLeftTee": "\u2AE4",
        "DoubleLongLeftArrow": "\u27F8",
        "DoubleLongLeftRightArrow": "\u27FA",
        "DoubleLongRightArrow": "\u27F9",
        "DoubleRightArrow": "\u21D2",
        "DoubleRightTee": "\u22A8",
        "DoubleUpArrow": "\u21D1",
        "DoubleUpDownArrow": "\u21D5",
        "DoubleVerticalBar": "\u2225",
        "downarrow": "\u2193",
        "Downarrow": "\u21D3",
        "DownArrow": "\u2193",
        "DownArrowBar": "\u2913",
        "DownArrowUpArrow": "\u21F5",
        "DownBreve": "\u0311",
        "downdownarrows": "\u21CA",
        "downharpoonleft": "\u21C3",
        "downharpoonright": "\u21C2",
        "DownLeftRightVector": "\u2950",
        "DownLeftTeeVector": "\u295E",
        "DownLeftVector": "\u21BD",
        "DownLeftVectorBar": "\u2956",
        "DownRightTeeVector": "\u295F",
        "DownRightVector": "\u21C1",
        "DownRightVectorBar": "\u2957",
        "DownTee": "\u22A4",
        "DownTeeArrow": "\u21A7",
        "drbkarow": "\u2910",
        "drcorn": "\u231F",
        "drcrop": "\u230C",
        "dscr": "\uD835\uDCB9",
        "Dscr": "\uD835\uDC9F",
        "dscy": "\u0455",
        "DScy": "\u0405",
        "dsol": "\u29F6",
        "dstrok": "\u0111",
        "Dstrok": "\u0110",
        "dtdot": "\u22F1",
        "dtri": "\u25BF",
        "dtrif": "\u25BE",
        "duarr": "\u21F5",
        "duhar": "\u296F",
        "dwangle": "\u29A6",
        "dzcy": "\u045F",
        "DZcy": "\u040F",
        "dzigrarr": "\u27FF",
        "eacute": "\xe9",
        "Eacute": "\xc9",
        "easter": "\u2A6E",
        "ecaron": "\u011B",
        "Ecaron": "\u011A",
        "ecir": "\u2256",
        "ecirc": "\xea",
        "Ecirc": "\xca",
        "ecolon": "\u2255",
        "ecy": "\u044D",
        "Ecy": "\u042D",
        "eDDot": "\u2A77",
        "edot": "\u0117",
        "eDot": "\u2251",
        "Edot": "\u0116",
        "ee": "\u2147",
        "efDot": "\u2252",
        "efr": "\uD835\uDD22",
        "Efr": "\uD835\uDD08",
        "eg": "\u2A9A",
        "egrave": "\xe8",
        "Egrave": "\xc8",
        "egs": "\u2A96",
        "egsdot": "\u2A98",
        "el": "\u2A99",
        "Element": "\u2208",
        "elinters": "\u23E7",
        "ell": "\u2113",
        "els": "\u2A95",
        "elsdot": "\u2A97",
        "emacr": "\u0113",
        "Emacr": "\u0112",
        "empty": "\u2205",
        "emptyset": "\u2205",
        "EmptySmallSquare": "\u25FB",
        "emptyv": "\u2205",
        "EmptyVerySmallSquare": "\u25AB",
        "emsp": "\u2003",
        "emsp13": "\u2004",
        "emsp14": "\u2005",
        "eng": "\u014B",
        "ENG": "\u014A",
        "ensp": "\u2002",
        "eogon": "\u0119",
        "Eogon": "\u0118",
        "eopf": "\uD835\uDD56",
        "Eopf": "\uD835\uDD3C",
        "epar": "\u22D5",
        "eparsl": "\u29E3",
        "eplus": "\u2A71",
        "epsi": "\u03B5",
        "epsilon": "\u03B5",
        "Epsilon": "\u0395",
        "epsiv": "\u03F5",
        "eqcirc": "\u2256",
        "eqcolon": "\u2255",
        "eqsim": "\u2242",
        "eqslantgtr": "\u2A96",
        "eqslantless": "\u2A95",
        "Equal": "\u2A75",
        "equals": "=",
        "EqualTilde": "\u2242",
        "equest": "\u225F",
        "Equilibrium": "\u21CC",
        "equiv": "\u2261",
        "equivDD": "\u2A78",
        "eqvparsl": "\u29E5",
        "erarr": "\u2971",
        "erDot": "\u2253",
        "escr": "\u212F",
        "Escr": "\u2130",
        "esdot": "\u2250",
        "esim": "\u2242",
        "Esim": "\u2A73",
        "eta": "\u03B7",
        "Eta": "\u0397",
        "eth": "\xf0",
        "ETH": "\xd0",
        "euml": "\xeb",
        "Euml": "\xcb",
        "euro": "\u20AC",
        "excl": "!",
        "exist": "\u2203",
        "Exists": "\u2203",
        "expectation": "\u2130",
        "exponentiale": "\u2147",
        "ExponentialE": "\u2147",
        "fallingdotseq": "\u2252",
        "fcy": "\u0444",
        "Fcy": "\u0424",
        "female": "\u2640",
        "ffilig": "\uFB03",
        "fflig": "\uFB00",
        "ffllig": "\uFB04",
        "ffr": "\uD835\uDD23",
        "Ffr": "\uD835\uDD09",
        "filig": "\uFB01",
        "FilledSmallSquare": "\u25FC",
        "FilledVerySmallSquare": "\u25AA",
        "fjlig": "fj",
        "flat": "\u266D",
        "fllig": "\uFB02",
        "fltns": "\u25B1",
        "fnof": "\u0192",
        "fopf": "\uD835\uDD57",
        "Fopf": "\uD835\uDD3D",
        "forall": "\u2200",
        "ForAll": "\u2200",
        "fork": "\u22D4",
        "forkv": "\u2AD9",
        "Fouriertrf": "\u2131",
        "fpartint": "\u2A0D",
        "frac12": "\xbd",
        "frac13": "\u2153",
        "frac14": "\xbc",
        "frac15": "\u2155",
        "frac16": "\u2159",
        "frac18": "\u215B",
        "frac23": "\u2154",
        "frac25": "\u2156",
        "frac34": "\xbe",
        "frac35": "\u2157",
        "frac38": "\u215C",
        "frac45": "\u2158",
        "frac56": "\u215A",
        "frac58": "\u215D",
        "frac78": "\u215E",
        "frasl": "\u2044",
        "frown": "\u2322",
        "fscr": "\uD835\uDCBB",
        "Fscr": "\u2131",
        "gacute": "\u01F5",
        "gamma": "\u03B3",
        "Gamma": "\u0393",
        "gammad": "\u03DD",
        "Gammad": "\u03DC",
        "gap": "\u2A86",
        "gbreve": "\u011F",
        "Gbreve": "\u011E",
        "Gcedil": "\u0122",
        "gcirc": "\u011D",
        "Gcirc": "\u011C",
        "gcy": "\u0433",
        "Gcy": "\u0413",
        "gdot": "\u0121",
        "Gdot": "\u0120",
        "ge": "\u2265",
        "gE": "\u2267",
        "gel": "\u22DB",
        "gEl": "\u2A8C",
        "geq": "\u2265",
        "geqq": "\u2267",
        "geqslant": "\u2A7E",
        "ges": "\u2A7E",
        "gescc": "\u2AA9",
        "gesdot": "\u2A80",
        "gesdoto": "\u2A82",
        "gesdotol": "\u2A84",
        "gesl": "\u22DB\uFE00",
        "gesles": "\u2A94",
        "gfr": "\uD835\uDD24",
        "Gfr": "\uD835\uDD0A",
        "gg": "\u226B",
        "Gg": "\u22D9",
        "ggg": "\u22D9",
        "gimel": "\u2137",
        "gjcy": "\u0453",
        "GJcy": "\u0403",
        "gl": "\u2277",
        "gla": "\u2AA5",
        "glE": "\u2A92",
        "glj": "\u2AA4",
        "gnap": "\u2A8A",
        "gnapprox": "\u2A8A",
        "gne": "\u2A88",
        "gnE": "\u2269",
        "gneq": "\u2A88",
        "gneqq": "\u2269",
        "gnsim": "\u22E7",
        "gopf": "\uD835\uDD58",
        "Gopf": "\uD835\uDD3E",
        "grave": "`",
        "GreaterEqual": "\u2265",
        "GreaterEqualLess": "\u22DB",
        "GreaterFullEqual": "\u2267",
        "GreaterGreater": "\u2AA2",
        "GreaterLess": "\u2277",
        "GreaterSlantEqual": "\u2A7E",
        "GreaterTilde": "\u2273",
        "gscr": "\u210A",
        "Gscr": "\uD835\uDCA2",
        "gsim": "\u2273",
        "gsime": "\u2A8E",
        "gsiml": "\u2A90",
        "gt": ">",
        "Gt": "\u226B",
        "GT": ">",
        "gtcc": "\u2AA7",
        "gtcir": "\u2A7A",
        "gtdot": "\u22D7",
        "gtlPar": "\u2995",
        "gtquest": "\u2A7C",
        "gtrapprox": "\u2A86",
        "gtrarr": "\u2978",
        "gtrdot": "\u22D7",
        "gtreqless": "\u22DB",
        "gtreqqless": "\u2A8C",
        "gtrless": "\u2277",
        "gtrsim": "\u2273",
        "gvertneqq": "\u2269\uFE00",
        "gvnE": "\u2269\uFE00",
        "Hacek": "\u02C7",
        "hairsp": "\u200A",
        "half": "\xbd",
        "hamilt": "\u210B",
        "hardcy": "\u044A",
        "HARDcy": "\u042A",
        "harr": "\u2194",
        "hArr": "\u21D4",
        "harrcir": "\u2948",
        "harrw": "\u21AD",
        "Hat": "^",
        "hbar": "\u210F",
        "hcirc": "\u0125",
        "Hcirc": "\u0124",
        "hearts": "\u2665",
        "heartsuit": "\u2665",
        "hellip": "\u2026",
        "hercon": "\u22B9",
        "hfr": "\uD835\uDD25",
        "Hfr": "\u210C",
        "HilbertSpace": "\u210B",
        "hksearow": "\u2925",
        "hkswarow": "\u2926",
        "hoarr": "\u21FF",
        "homtht": "\u223B",
        "hookleftarrow": "\u21A9",
        "hookrightarrow": "\u21AA",
        "hopf": "\uD835\uDD59",
        "Hopf": "\u210D",
        "horbar": "\u2015",
        "HorizontalLine": "\u2500",
        "hscr": "\uD835\uDCBD",
        "Hscr": "\u210B",
        "hslash": "\u210F",
        "hstrok": "\u0127",
        "Hstrok": "\u0126",
        "HumpDownHump": "\u224E",
        "HumpEqual": "\u224F",
        "hybull": "\u2043",
        "hyphen": "\u2010",
        "iacute": "\xed",
        "Iacute": "\xcd",
        "ic": "\u2063",
        "icirc": "\xee",
        "Icirc": "\xce",
        "icy": "\u0438",
        "Icy": "\u0418",
        "Idot": "\u0130",
        "iecy": "\u0435",
        "IEcy": "\u0415",
        "iexcl": "\xa1",
        "iff": "\u21D4",
        "ifr": "\uD835\uDD26",
        "Ifr": "\u2111",
        "igrave": "\xec",
        "Igrave": "\xcc",
        "ii": "\u2148",
        "iiiint": "\u2A0C",
        "iiint": "\u222D",
        "iinfin": "\u29DC",
        "iiota": "\u2129",
        "ijlig": "\u0133",
        "IJlig": "\u0132",
        "Im": "\u2111",
        "imacr": "\u012B",
        "Imacr": "\u012A",
        "image": "\u2111",
        "ImaginaryI": "\u2148",
        "imagline": "\u2110",
        "imagpart": "\u2111",
        "imath": "\u0131",
        "imof": "\u22B7",
        "imped": "\u01B5",
        "Implies": "\u21D2",
        "in": "\u2208",
        "incare": "\u2105",
        "infin": "\u221E",
        "infintie": "\u29DD",
        "inodot": "\u0131",
        "int": "\u222B",
        "Int": "\u222C",
        "intcal": "\u22BA",
        "integers": "\u2124",
        "Integral": "\u222B",
        "intercal": "\u22BA",
        "Intersection": "\u22C2",
        "intlarhk": "\u2A17",
        "intprod": "\u2A3C",
        "InvisibleComma": "\u2063",
        "InvisibleTimes": "\u2062",
        "iocy": "\u0451",
        "IOcy": "\u0401",
        "iogon": "\u012F",
        "Iogon": "\u012E",
        "iopf": "\uD835\uDD5A",
        "Iopf": "\uD835\uDD40",
        "iota": "\u03B9",
        "Iota": "\u0399",
        "iprod": "\u2A3C",
        "iquest": "\xbf",
        "iscr": "\uD835\uDCBE",
        "Iscr": "\u2110",
        "isin": "\u2208",
        "isindot": "\u22F5",
        "isinE": "\u22F9",
        "isins": "\u22F4",
        "isinsv": "\u22F3",
        "isinv": "\u2208",
        "it": "\u2062",
        "itilde": "\u0129",
        "Itilde": "\u0128",
        "iukcy": "\u0456",
        "Iukcy": "\u0406",
        "iuml": "\xef",
        "Iuml": "\xcf",
        "jcirc": "\u0135",
        "Jcirc": "\u0134",
        "jcy": "\u0439",
        "Jcy": "\u0419",
        "jfr": "\uD835\uDD27",
        "Jfr": "\uD835\uDD0D",
        "jmath": "\u0237",
        "jopf": "\uD835\uDD5B",
        "Jopf": "\uD835\uDD41",
        "jscr": "\uD835\uDCBF",
        "Jscr": "\uD835\uDCA5",
        "jsercy": "\u0458",
        "Jsercy": "\u0408",
        "jukcy": "\u0454",
        "Jukcy": "\u0404",
        "kappa": "\u03BA",
        "Kappa": "\u039A",
        "kappav": "\u03F0",
        "kcedil": "\u0137",
        "Kcedil": "\u0136",
        "kcy": "\u043A",
        "Kcy": "\u041A",
        "kfr": "\uD835\uDD28",
        "Kfr": "\uD835\uDD0E",
        "kgreen": "\u0138",
        "khcy": "\u0445",
        "KHcy": "\u0425",
        "kjcy": "\u045C",
        "KJcy": "\u040C",
        "kopf": "\uD835\uDD5C",
        "Kopf": "\uD835\uDD42",
        "kscr": "\uD835\uDCC0",
        "Kscr": "\uD835\uDCA6",
        "lAarr": "\u21DA",
        "lacute": "\u013A",
        "Lacute": "\u0139",
        "laemptyv": "\u29B4",
        "lagran": "\u2112",
        "lambda": "\u03BB",
        "Lambda": "\u039B",
        "lang": "\u27E8",
        "Lang": "\u27EA",
        "langd": "\u2991",
        "langle": "\u27E8",
        "lap": "\u2A85",
        "Laplacetrf": "\u2112",
        "laquo": "\xab",
        "larr": "\u2190",
        "lArr": "\u21D0",
        "Larr": "\u219E",
        "larrb": "\u21E4",
        "larrbfs": "\u291F",
        "larrfs": "\u291D",
        "larrhk": "\u21A9",
        "larrlp": "\u21AB",
        "larrpl": "\u2939",
        "larrsim": "\u2973",
        "larrtl": "\u21A2",
        "lat": "\u2AAB",
        "latail": "\u2919",
        "lAtail": "\u291B",
        "late": "\u2AAD",
        "lates": "\u2AAD\uFE00",
        "lbarr": "\u290C",
        "lBarr": "\u290E",
        "lbbrk": "\u2772",
        "lbrace": "{",
        "lbrack": "[",
        "lbrke": "\u298B",
        "lbrksld": "\u298F",
        "lbrkslu": "\u298D",
        "lcaron": "\u013E",
        "Lcaron": "\u013D",
        "lcedil": "\u013C",
        "Lcedil": "\u013B",
        "lceil": "\u2308",
        "lcub": "{",
        "lcy": "\u043B",
        "Lcy": "\u041B",
        "ldca": "\u2936",
        "ldquo": "\u201C",
        "ldquor": "\u201E",
        "ldrdhar": "\u2967",
        "ldrushar": "\u294B",
        "ldsh": "\u21B2",
        "le": "\u2264",
        "lE": "\u2266",
        "LeftAngleBracket": "\u27E8",
        "leftarrow": "\u2190",
        "Leftarrow": "\u21D0",
        "LeftArrow": "\u2190",
        "LeftArrowBar": "\u21E4",
        "LeftArrowRightArrow": "\u21C6",
        "leftarrowtail": "\u21A2",
        "LeftCeiling": "\u2308",
        "LeftDoubleBracket": "\u27E6",
        "LeftDownTeeVector": "\u2961",
        "LeftDownVector": "\u21C3",
        "LeftDownVectorBar": "\u2959",
        "LeftFloor": "\u230A",
        "leftharpoondown": "\u21BD",
        "leftharpoonup": "\u21BC",
        "leftleftarrows": "\u21C7",
        "leftrightarrow": "\u2194",
        "Leftrightarrow": "\u21D4",
        "LeftRightArrow": "\u2194",
        "leftrightarrows": "\u21C6",
        "leftrightharpoons": "\u21CB",
        "leftrightsquigarrow": "\u21AD",
        "LeftRightVector": "\u294E",
        "LeftTee": "\u22A3",
        "LeftTeeArrow": "\u21A4",
        "LeftTeeVector": "\u295A",
        "leftthreetimes": "\u22CB",
        "LeftTriangle": "\u22B2",
        "LeftTriangleBar": "\u29CF",
        "LeftTriangleEqual": "\u22B4",
        "LeftUpDownVector": "\u2951",
        "LeftUpTeeVector": "\u2960",
        "LeftUpVector": "\u21BF",
        "LeftUpVectorBar": "\u2958",
        "LeftVector": "\u21BC",
        "LeftVectorBar": "\u2952",
        "leg": "\u22DA",
        "lEg": "\u2A8B",
        "leq": "\u2264",
        "leqq": "\u2266",
        "leqslant": "\u2A7D",
        "les": "\u2A7D",
        "lescc": "\u2AA8",
        "lesdot": "\u2A7F",
        "lesdoto": "\u2A81",
        "lesdotor": "\u2A83",
        "lesg": "\u22DA\uFE00",
        "lesges": "\u2A93",
        "lessapprox": "\u2A85",
        "lessdot": "\u22D6",
        "lesseqgtr": "\u22DA",
        "lesseqqgtr": "\u2A8B",
        "LessEqualGreater": "\u22DA",
        "LessFullEqual": "\u2266",
        "LessGreater": "\u2276",
        "lessgtr": "\u2276",
        "LessLess": "\u2AA1",
        "lesssim": "\u2272",
        "LessSlantEqual": "\u2A7D",
        "LessTilde": "\u2272",
        "lfisht": "\u297C",
        "lfloor": "\u230A",
        "lfr": "\uD835\uDD29",
        "Lfr": "\uD835\uDD0F",
        "lg": "\u2276",
        "lgE": "\u2A91",
        "lHar": "\u2962",
        "lhard": "\u21BD",
        "lharu": "\u21BC",
        "lharul": "\u296A",
        "lhblk": "\u2584",
        "ljcy": "\u0459",
        "LJcy": "\u0409",
        "ll": "\u226A",
        "Ll": "\u22D8",
        "llarr": "\u21C7",
        "llcorner": "\u231E",
        "Lleftarrow": "\u21DA",
        "llhard": "\u296B",
        "lltri": "\u25FA",
        "lmidot": "\u0140",
        "Lmidot": "\u013F",
        "lmoust": "\u23B0",
        "lmoustache": "\u23B0",
        "lnap": "\u2A89",
        "lnapprox": "\u2A89",
        "lne": "\u2A87",
        "lnE": "\u2268",
        "lneq": "\u2A87",
        "lneqq": "\u2268",
        "lnsim": "\u22E6",
        "loang": "\u27EC",
        "loarr": "\u21FD",
        "lobrk": "\u27E6",
        "longleftarrow": "\u27F5",
        "Longleftarrow": "\u27F8",
        "LongLeftArrow": "\u27F5",
        "longleftrightarrow": "\u27F7",
        "Longleftrightarrow": "\u27FA",
        "LongLeftRightArrow": "\u27F7",
        "longmapsto": "\u27FC",
        "longrightarrow": "\u27F6",
        "Longrightarrow": "\u27F9",
        "LongRightArrow": "\u27F6",
        "looparrowleft": "\u21AB",
        "looparrowright": "\u21AC",
        "lopar": "\u2985",
        "lopf": "\uD835\uDD5D",
        "Lopf": "\uD835\uDD43",
        "loplus": "\u2A2D",
        "lotimes": "\u2A34",
        "lowast": "\u2217",
        "lowbar": "_",
        "LowerLeftArrow": "\u2199",
        "LowerRightArrow": "\u2198",
        "loz": "\u25CA",
        "lozenge": "\u25CA",
        "lozf": "\u29EB",
        "lpar": "(",
        "lparlt": "\u2993",
        "lrarr": "\u21C6",
        "lrcorner": "\u231F",
        "lrhar": "\u21CB",
        "lrhard": "\u296D",
        "lrm": "\u200E",
        "lrtri": "\u22BF",
        "lsaquo": "\u2039",
        "lscr": "\uD835\uDCC1",
        "Lscr": "\u2112",
        "lsh": "\u21B0",
        "Lsh": "\u21B0",
        "lsim": "\u2272",
        "lsime": "\u2A8D",
        "lsimg": "\u2A8F",
        "lsqb": "[",
        "lsquo": "\u2018",
        "lsquor": "\u201A",
        "lstrok": "\u0142",
        "Lstrok": "\u0141",
        "lt": "<",
        "Lt": "\u226A",
        "LT": "<",
        "ltcc": "\u2AA6",
        "ltcir": "\u2A79",
        "ltdot": "\u22D6",
        "lthree": "\u22CB",
        "ltimes": "\u22C9",
        "ltlarr": "\u2976",
        "ltquest": "\u2A7B",
        "ltri": "\u25C3",
        "ltrie": "\u22B4",
        "ltrif": "\u25C2",
        "ltrPar": "\u2996",
        "lurdshar": "\u294A",
        "luruhar": "\u2966",
        "lvertneqq": "\u2268\uFE00",
        "lvnE": "\u2268\uFE00",
        "macr": "\xaf",
        "male": "\u2642",
        "malt": "\u2720",
        "maltese": "\u2720",
        "map": "\u21A6",
        "Map": "\u2905",
        "mapsto": "\u21A6",
        "mapstodown": "\u21A7",
        "mapstoleft": "\u21A4",
        "mapstoup": "\u21A5",
        "marker": "\u25AE",
        "mcomma": "\u2A29",
        "mcy": "\u043C",
        "Mcy": "\u041C",
        "mdash": "\u2014",
        "mDDot": "\u223A",
        "measuredangle": "\u2221",
        "MediumSpace": "\u205F",
        "Mellintrf": "\u2133",
        "mfr": "\uD835\uDD2A",
        "Mfr": "\uD835\uDD10",
        "mho": "\u2127",
        "micro": "\xb5",
        "mid": "\u2223",
        "midast": "*",
        "midcir": "\u2AF0",
        "middot": "\xb7",
        "minus": "\u2212",
        "minusb": "\u229F",
        "minusd": "\u2238",
        "minusdu": "\u2A2A",
        "MinusPlus": "\u2213",
        "mlcp": "\u2ADB",
        "mldr": "\u2026",
        "mnplus": "\u2213",
        "models": "\u22A7",
        "mopf": "\uD835\uDD5E",
        "Mopf": "\uD835\uDD44",
        "mp": "\u2213",
        "mscr": "\uD835\uDCC2",
        "Mscr": "\u2133",
        "mstpos": "\u223E",
        "mu": "\u03BC",
        "Mu": "\u039C",
        "multimap": "\u22B8",
        "mumap": "\u22B8",
        "nabla": "\u2207",
        "nacute": "\u0144",
        "Nacute": "\u0143",
        "nang": "\u2220\u20D2",
        "nap": "\u2249",
        "napE": "\u2A70\u0338",
        "napid": "\u224B\u0338",
        "napos": "\u0149",
        "napprox": "\u2249",
        "natur": "\u266E",
        "natural": "\u266E",
        "naturals": "\u2115",
        "nbsp": "\xa0",
        "nbump": "\u224E\u0338",
        "nbumpe": "\u224F\u0338",
        "ncap": "\u2A43",
        "ncaron": "\u0148",
        "Ncaron": "\u0147",
        "ncedil": "\u0146",
        "Ncedil": "\u0145",
        "ncong": "\u2247",
        "ncongdot": "\u2A6D\u0338",
        "ncup": "\u2A42",
        "ncy": "\u043D",
        "Ncy": "\u041D",
        "ndash": "\u2013",
        "ne": "\u2260",
        "nearhk": "\u2924",
        "nearr": "\u2197",
        "neArr": "\u21D7",
        "nearrow": "\u2197",
        "nedot": "\u2250\u0338",
        "NegativeMediumSpace": "\u200B",
        "NegativeThickSpace": "\u200B",
        "NegativeThinSpace": "\u200B",
        "NegativeVeryThinSpace": "\u200B",
        "nequiv": "\u2262",
        "nesear": "\u2928",
        "nesim": "\u2242\u0338",
        "NestedGreaterGreater": "\u226B",
        "NestedLessLess": "\u226A",
        "NewLine": "\n",
        "nexist": "\u2204",
        "nexists": "\u2204",
        "nfr": "\uD835\uDD2B",
        "Nfr": "\uD835\uDD11",
        "nge": "\u2271",
        "ngE": "\u2267\u0338",
        "ngeq": "\u2271",
        "ngeqq": "\u2267\u0338",
        "ngeqslant": "\u2A7E\u0338",
        "nges": "\u2A7E\u0338",
        "nGg": "\u22D9\u0338",
        "ngsim": "\u2275",
        "ngt": "\u226F",
        "nGt": "\u226B\u20D2",
        "ngtr": "\u226F",
        "nGtv": "\u226B\u0338",
        "nharr": "\u21AE",
        "nhArr": "\u21CE",
        "nhpar": "\u2AF2",
        "ni": "\u220B",
        "nis": "\u22FC",
        "nisd": "\u22FA",
        "niv": "\u220B",
        "njcy": "\u045A",
        "NJcy": "\u040A",
        "nlarr": "\u219A",
        "nlArr": "\u21CD",
        "nldr": "\u2025",
        "nle": "\u2270",
        "nlE": "\u2266\u0338",
        "nleftarrow": "\u219A",
        "nLeftarrow": "\u21CD",
        "nleftrightarrow": "\u21AE",
        "nLeftrightarrow": "\u21CE",
        "nleq": "\u2270",
        "nleqq": "\u2266\u0338",
        "nleqslant": "\u2A7D\u0338",
        "nles": "\u2A7D\u0338",
        "nless": "\u226E",
        "nLl": "\u22D8\u0338",
        "nlsim": "\u2274",
        "nlt": "\u226E",
        "nLt": "\u226A\u20D2",
        "nltri": "\u22EA",
        "nltrie": "\u22EC",
        "nLtv": "\u226A\u0338",
        "nmid": "\u2224",
        "NoBreak": "\u2060",
        "NonBreakingSpace": "\xa0",
        "nopf": "\uD835\uDD5F",
        "Nopf": "\u2115",
        "not": "\xac",
        "Not": "\u2AEC",
        "NotCongruent": "\u2262",
        "NotCupCap": "\u226D",
        "NotDoubleVerticalBar": "\u2226",
        "NotElement": "\u2209",
        "NotEqual": "\u2260",
        "NotEqualTilde": "\u2242\u0338",
        "NotExists": "\u2204",
        "NotGreater": "\u226F",
        "NotGreaterEqual": "\u2271",
        "NotGreaterFullEqual": "\u2267\u0338",
        "NotGreaterGreater": "\u226B\u0338",
        "NotGreaterLess": "\u2279",
        "NotGreaterSlantEqual": "\u2A7E\u0338",
        "NotGreaterTilde": "\u2275",
        "NotHumpDownHump": "\u224E\u0338",
        "NotHumpEqual": "\u224F\u0338",
        "notin": "\u2209",
        "notindot": "\u22F5\u0338",
        "notinE": "\u22F9\u0338",
        "notinva": "\u2209",
        "notinvb": "\u22F7",
        "notinvc": "\u22F6",
        "NotLeftTriangle": "\u22EA",
        "NotLeftTriangleBar": "\u29CF\u0338",
        "NotLeftTriangleEqual": "\u22EC",
        "NotLess": "\u226E",
        "NotLessEqual": "\u2270",
        "NotLessGreater": "\u2278",
        "NotLessLess": "\u226A\u0338",
        "NotLessSlantEqual": "\u2A7D\u0338",
        "NotLessTilde": "\u2274",
        "NotNestedGreaterGreater": "\u2AA2\u0338",
        "NotNestedLessLess": "\u2AA1\u0338",
        "notni": "\u220C",
        "notniva": "\u220C",
        "notnivb": "\u22FE",
        "notnivc": "\u22FD",
        "NotPrecedes": "\u2280",
        "NotPrecedesEqual": "\u2AAF\u0338",
        "NotPrecedesSlantEqual": "\u22E0",
        "NotReverseElement": "\u220C",
        "NotRightTriangle": "\u22EB",
        "NotRightTriangleBar": "\u29D0\u0338",
        "NotRightTriangleEqual": "\u22ED",
        "NotSquareSubset": "\u228F\u0338",
        "NotSquareSubsetEqual": "\u22E2",
        "NotSquareSuperset": "\u2290\u0338",
        "NotSquareSupersetEqual": "\u22E3",
        "NotSubset": "\u2282\u20D2",
        "NotSubsetEqual": "\u2288",
        "NotSucceeds": "\u2281",
        "NotSucceedsEqual": "\u2AB0\u0338",
        "NotSucceedsSlantEqual": "\u22E1",
        "NotSucceedsTilde": "\u227F\u0338",
        "NotSuperset": "\u2283\u20D2",
        "NotSupersetEqual": "\u2289",
        "NotTilde": "\u2241",
        "NotTildeEqual": "\u2244",
        "NotTildeFullEqual": "\u2247",
        "NotTildeTilde": "\u2249",
        "NotVerticalBar": "\u2224",
        "npar": "\u2226",
        "nparallel": "\u2226",
        "nparsl": "\u2AFD\u20E5",
        "npart": "\u2202\u0338",
        "npolint": "\u2A14",
        "npr": "\u2280",
        "nprcue": "\u22E0",
        "npre": "\u2AAF\u0338",
        "nprec": "\u2280",
        "npreceq": "\u2AAF\u0338",
        "nrarr": "\u219B",
        "nrArr": "\u21CF",
        "nrarrc": "\u2933\u0338",
        "nrarrw": "\u219D\u0338",
        "nrightarrow": "\u219B",
        "nRightarrow": "\u21CF",
        "nrtri": "\u22EB",
        "nrtrie": "\u22ED",
        "nsc": "\u2281",
        "nsccue": "\u22E1",
        "nsce": "\u2AB0\u0338",
        "nscr": "\uD835\uDCC3",
        "Nscr": "\uD835\uDCA9",
        "nshortmid": "\u2224",
        "nshortparallel": "\u2226",
        "nsim": "\u2241",
        "nsime": "\u2244",
        "nsimeq": "\u2244",
        "nsmid": "\u2224",
        "nspar": "\u2226",
        "nsqsube": "\u22E2",
        "nsqsupe": "\u22E3",
        "nsub": "\u2284",
        "nsube": "\u2288",
        "nsubE": "\u2AC5\u0338",
        "nsubset": "\u2282\u20D2",
        "nsubseteq": "\u2288",
        "nsubseteqq": "\u2AC5\u0338",
        "nsucc": "\u2281",
        "nsucceq": "\u2AB0\u0338",
        "nsup": "\u2285",
        "nsupe": "\u2289",
        "nsupE": "\u2AC6\u0338",
        "nsupset": "\u2283\u20D2",
        "nsupseteq": "\u2289",
        "nsupseteqq": "\u2AC6\u0338",
        "ntgl": "\u2279",
        "ntilde": "\xf1",
        "Ntilde": "\xd1",
        "ntlg": "\u2278",
        "ntriangleleft": "\u22EA",
        "ntrianglelefteq": "\u22EC",
        "ntriangleright": "\u22EB",
        "ntrianglerighteq": "\u22ED",
        "nu": "\u03BD",
        "Nu": "\u039D",
        "num": "#",
        "numero": "\u2116",
        "numsp": "\u2007",
        "nvap": "\u224D\u20D2",
        "nvdash": "\u22AC",
        "nvDash": "\u22AD",
        "nVdash": "\u22AE",
        "nVDash": "\u22AF",
        "nvge": "\u2265\u20D2",
        "nvgt": ">\u20D2",
        "nvHarr": "\u2904",
        "nvinfin": "\u29DE",
        "nvlArr": "\u2902",
        "nvle": "\u2264\u20D2",
        "nvlt": "<\u20D2",
        "nvltrie": "\u22B4\u20D2",
        "nvrArr": "\u2903",
        "nvrtrie": "\u22B5\u20D2",
        "nvsim": "\u223C\u20D2",
        "nwarhk": "\u2923",
        "nwarr": "\u2196",
        "nwArr": "\u21D6",
        "nwarrow": "\u2196",
        "nwnear": "\u2927",
        "oacute": "\xf3",
        "Oacute": "\xd3",
        "oast": "\u229B",
        "ocir": "\u229A",
        "ocirc": "\xf4",
        "Ocirc": "\xd4",
        "ocy": "\u043E",
        "Ocy": "\u041E",
        "odash": "\u229D",
        "odblac": "\u0151",
        "Odblac": "\u0150",
        "odiv": "\u2A38",
        "odot": "\u2299",
        "odsold": "\u29BC",
        "oelig": "\u0153",
        "OElig": "\u0152",
        "ofcir": "\u29BF",
        "ofr": "\uD835\uDD2C",
        "Ofr": "\uD835\uDD12",
        "ogon": "\u02DB",
        "ograve": "\xf2",
        "Ograve": "\xd2",
        "ogt": "\u29C1",
        "ohbar": "\u29B5",
        "ohm": "\u03A9",
        "oint": "\u222E",
        "olarr": "\u21BA",
        "olcir": "\u29BE",
        "olcross": "\u29BB",
        "oline": "\u203E",
        "olt": "\u29C0",
        "omacr": "\u014D",
        "Omacr": "\u014C",
        "omega": "\u03C9",
        "Omega": "\u03A9",
        "omicron": "\u03BF",
        "Omicron": "\u039F",
        "omid": "\u29B6",
        "ominus": "\u2296",
        "oopf": "\uD835\uDD60",
        "Oopf": "\uD835\uDD46",
        "opar": "\u29B7",
        "OpenCurlyDoubleQuote": "\u201C",
        "OpenCurlyQuote": "\u2018",
        "operp": "\u29B9",
        "oplus": "\u2295",
        "or": "\u2228",
        "Or": "\u2A54",
        "orarr": "\u21BB",
        "ord": "\u2A5D",
        "order": "\u2134",
        "orderof": "\u2134",
        "ordf": "\xaa",
        "ordm": "\xba",
        "origof": "\u22B6",
        "oror": "\u2A56",
        "orslope": "\u2A57",
        "orv": "\u2A5B",
        "oS": "\u24C8",
        "oscr": "\u2134",
        "Oscr": "\uD835\uDCAA",
        "oslash": "\xf8",
        "Oslash": "\xd8",
        "osol": "\u2298",
        "otilde": "\xf5",
        "Otilde": "\xd5",
        "otimes": "\u2297",
        "Otimes": "\u2A37",
        "otimesas": "\u2A36",
        "ouml": "\xf6",
        "Ouml": "\xd6",
        "ovbar": "\u233D",
        "OverBar": "\u203E",
        "OverBrace": "\u23DE",
        "OverBracket": "\u23B4",
        "OverParenthesis": "\u23DC",
        "par": "\u2225",
        "para": "\xb6",
        "parallel": "\u2225",
        "parsim": "\u2AF3",
        "parsl": "\u2AFD",
        "part": "\u2202",
        "PartialD": "\u2202",
        "pcy": "\u043F",
        "Pcy": "\u041F",
        "percnt": "%",
        "period": ".",
        "permil": "\u2030",
        "perp": "\u22A5",
        "pertenk": "\u2031",
        "pfr": "\uD835\uDD2D",
        "Pfr": "\uD835\uDD13",
        "phi": "\u03C6",
        "Phi": "\u03A6",
        "phiv": "\u03D5",
        "phmmat": "\u2133",
        "phone": "\u260E",
        "pi": "\u03C0",
        "Pi": "\u03A0",
        "pitchfork": "\u22D4",
        "piv": "\u03D6",
        "planck": "\u210F",
        "planckh": "\u210E",
        "plankv": "\u210F",
        "plus": "+",
        "plusacir": "\u2A23",
        "plusb": "\u229E",
        "pluscir": "\u2A22",
        "plusdo": "\u2214",
        "plusdu": "\u2A25",
        "pluse": "\u2A72",
        "PlusMinus": "\xb1",
        "plusmn": "\xb1",
        "plussim": "\u2A26",
        "plustwo": "\u2A27",
        "pm": "\xb1",
        "Poincareplane": "\u210C",
        "pointint": "\u2A15",
        "popf": "\uD835\uDD61",
        "Popf": "\u2119",
        "pound": "\xa3",
        "pr": "\u227A",
        "Pr": "\u2ABB",
        "prap": "\u2AB7",
        "prcue": "\u227C",
        "pre": "\u2AAF",
        "prE": "\u2AB3",
        "prec": "\u227A",
        "precapprox": "\u2AB7",
        "preccurlyeq": "\u227C",
        "Precedes": "\u227A",
        "PrecedesEqual": "\u2AAF",
        "PrecedesSlantEqual": "\u227C",
        "PrecedesTilde": "\u227E",
        "preceq": "\u2AAF",
        "precnapprox": "\u2AB9",
        "precneqq": "\u2AB5",
        "precnsim": "\u22E8",
        "precsim": "\u227E",
        "prime": "\u2032",
        "Prime": "\u2033",
        "primes": "\u2119",
        "prnap": "\u2AB9",
        "prnE": "\u2AB5",
        "prnsim": "\u22E8",
        "prod": "\u220F",
        "Product": "\u220F",
        "profalar": "\u232E",
        "profline": "\u2312",
        "profsurf": "\u2313",
        "prop": "\u221D",
        "Proportion": "\u2237",
        "Proportional": "\u221D",
        "propto": "\u221D",
        "prsim": "\u227E",
        "prurel": "\u22B0",
        "pscr": "\uD835\uDCC5",
        "Pscr": "\uD835\uDCAB",
        "psi": "\u03C8",
        "Psi": "\u03A8",
        "puncsp": "\u2008",
        "qfr": "\uD835\uDD2E",
        "Qfr": "\uD835\uDD14",
        "qint": "\u2A0C",
        "qopf": "\uD835\uDD62",
        "Qopf": "\u211A",
        "qprime": "\u2057",
        "qscr": "\uD835\uDCC6",
        "Qscr": "\uD835\uDCAC",
        "quaternions": "\u210D",
        "quatint": "\u2A16",
        "quest": "?",
        "questeq": "\u225F",
        "quot": '"',
        "QUOT": '"',
        "rAarr": "\u21DB",
        "race": "\u223D\u0331",
        "racute": "\u0155",
        "Racute": "\u0154",
        "radic": "\u221A",
        "raemptyv": "\u29B3",
        "rang": "\u27E9",
        "Rang": "\u27EB",
        "rangd": "\u2992",
        "range": "\u29A5",
        "rangle": "\u27E9",
        "raquo": "\xbb",
        "rarr": "\u2192",
        "rArr": "\u21D2",
        "Rarr": "\u21A0",
        "rarrap": "\u2975",
        "rarrb": "\u21E5",
        "rarrbfs": "\u2920",
        "rarrc": "\u2933",
        "rarrfs": "\u291E",
        "rarrhk": "\u21AA",
        "rarrlp": "\u21AC",
        "rarrpl": "\u2945",
        "rarrsim": "\u2974",
        "rarrtl": "\u21A3",
        "Rarrtl": "\u2916",
        "rarrw": "\u219D",
        "ratail": "\u291A",
        "rAtail": "\u291C",
        "ratio": "\u2236",
        "rationals": "\u211A",
        "rbarr": "\u290D",
        "rBarr": "\u290F",
        "RBarr": "\u2910",
        "rbbrk": "\u2773",
        "rbrace": "}",
        "rbrack": "]",
        "rbrke": "\u298C",
        "rbrksld": "\u298E",
        "rbrkslu": "\u2990",
        "rcaron": "\u0159",
        "Rcaron": "\u0158",
        "rcedil": "\u0157",
        "Rcedil": "\u0156",
        "rceil": "\u2309",
        "rcub": "}",
        "rcy": "\u0440",
        "Rcy": "\u0420",
        "rdca": "\u2937",
        "rdldhar": "\u2969",
        "rdquo": "\u201D",
        "rdquor": "\u201D",
        "rdsh": "\u21B3",
        "Re": "\u211C",
        "real": "\u211C",
        "realine": "\u211B",
        "realpart": "\u211C",
        "reals": "\u211D",
        "rect": "\u25AD",
        "reg": "\xae",
        "REG": "\xae",
        "ReverseElement": "\u220B",
        "ReverseEquilibrium": "\u21CB",
        "ReverseUpEquilibrium": "\u296F",
        "rfisht": "\u297D",
        "rfloor": "\u230B",
        "rfr": "\uD835\uDD2F",
        "Rfr": "\u211C",
        "rHar": "\u2964",
        "rhard": "\u21C1",
        "rharu": "\u21C0",
        "rharul": "\u296C",
        "rho": "\u03C1",
        "Rho": "\u03A1",
        "rhov": "\u03F1",
        "RightAngleBracket": "\u27E9",
        "rightarrow": "\u2192",
        "Rightarrow": "\u21D2",
        "RightArrow": "\u2192",
        "RightArrowBar": "\u21E5",
        "RightArrowLeftArrow": "\u21C4",
        "rightarrowtail": "\u21A3",
        "RightCeiling": "\u2309",
        "RightDoubleBracket": "\u27E7",
        "RightDownTeeVector": "\u295D",
        "RightDownVector": "\u21C2",
        "RightDownVectorBar": "\u2955",
        "RightFloor": "\u230B",
        "rightharpoondown": "\u21C1",
        "rightharpoonup": "\u21C0",
        "rightleftarrows": "\u21C4",
        "rightleftharpoons": "\u21CC",
        "rightrightarrows": "\u21C9",
        "rightsquigarrow": "\u219D",
        "RightTee": "\u22A2",
        "RightTeeArrow": "\u21A6",
        "RightTeeVector": "\u295B",
        "rightthreetimes": "\u22CC",
        "RightTriangle": "\u22B3",
        "RightTriangleBar": "\u29D0",
        "RightTriangleEqual": "\u22B5",
        "RightUpDownVector": "\u294F",
        "RightUpTeeVector": "\u295C",
        "RightUpVector": "\u21BE",
        "RightUpVectorBar": "\u2954",
        "RightVector": "\u21C0",
        "RightVectorBar": "\u2953",
        "ring": "\u02DA",
        "risingdotseq": "\u2253",
        "rlarr": "\u21C4",
        "rlhar": "\u21CC",
        "rlm": "\u200F",
        "rmoust": "\u23B1",
        "rmoustache": "\u23B1",
        "rnmid": "\u2AEE",
        "roang": "\u27ED",
        "roarr": "\u21FE",
        "robrk": "\u27E7",
        "ropar": "\u2986",
        "ropf": "\uD835\uDD63",
        "Ropf": "\u211D",
        "roplus": "\u2A2E",
        "rotimes": "\u2A35",
        "RoundImplies": "\u2970",
        "rpar": ")",
        "rpargt": "\u2994",
        "rppolint": "\u2A12",
        "rrarr": "\u21C9",
        "Rrightarrow": "\u21DB",
        "rsaquo": "\u203A",
        "rscr": "\uD835\uDCC7",
        "Rscr": "\u211B",
        "rsh": "\u21B1",
        "Rsh": "\u21B1",
        "rsqb": "]",
        "rsquo": "\u2019",
        "rsquor": "\u2019",
        "rthree": "\u22CC",
        "rtimes": "\u22CA",
        "rtri": "\u25B9",
        "rtrie": "\u22B5",
        "rtrif": "\u25B8",
        "rtriltri": "\u29CE",
        "RuleDelayed": "\u29F4",
        "ruluhar": "\u2968",
        "rx": "\u211E",
        "sacute": "\u015B",
        "Sacute": "\u015A",
        "sbquo": "\u201A",
        "sc": "\u227B",
        "Sc": "\u2ABC",
        "scap": "\u2AB8",
        "scaron": "\u0161",
        "Scaron": "\u0160",
        "sccue": "\u227D",
        "sce": "\u2AB0",
        "scE": "\u2AB4",
        "scedil": "\u015F",
        "Scedil": "\u015E",
        "scirc": "\u015D",
        "Scirc": "\u015C",
        "scnap": "\u2ABA",
        "scnE": "\u2AB6",
        "scnsim": "\u22E9",
        "scpolint": "\u2A13",
        "scsim": "\u227F",
        "scy": "\u0441",
        "Scy": "\u0421",
        "sdot": "\u22C5",
        "sdotb": "\u22A1",
        "sdote": "\u2A66",
        "searhk": "\u2925",
        "searr": "\u2198",
        "seArr": "\u21D8",
        "searrow": "\u2198",
        "sect": "\xa7",
        "semi": ";",
        "seswar": "\u2929",
        "setminus": "\u2216",
        "setmn": "\u2216",
        "sext": "\u2736",
        "sfr": "\uD835\uDD30",
        "Sfr": "\uD835\uDD16",
        "sfrown": "\u2322",
        "sharp": "\u266F",
        "shchcy": "\u0449",
        "SHCHcy": "\u0429",
        "shcy": "\u0448",
        "SHcy": "\u0428",
        "ShortDownArrow": "\u2193",
        "ShortLeftArrow": "\u2190",
        "shortmid": "\u2223",
        "shortparallel": "\u2225",
        "ShortRightArrow": "\u2192",
        "ShortUpArrow": "\u2191",
        "shy": "\xad",
        "sigma": "\u03C3",
        "Sigma": "\u03A3",
        "sigmaf": "\u03C2",
        "sigmav": "\u03C2",
        "sim": "\u223C",
        "simdot": "\u2A6A",
        "sime": "\u2243",
        "simeq": "\u2243",
        "simg": "\u2A9E",
        "simgE": "\u2AA0",
        "siml": "\u2A9D",
        "simlE": "\u2A9F",
        "simne": "\u2246",
        "simplus": "\u2A24",
        "simrarr": "\u2972",
        "slarr": "\u2190",
        "SmallCircle": "\u2218",
        "smallsetminus": "\u2216",
        "smashp": "\u2A33",
        "smeparsl": "\u29E4",
        "smid": "\u2223",
        "smile": "\u2323",
        "smt": "\u2AAA",
        "smte": "\u2AAC",
        "smtes": "\u2AAC\uFE00",
        "softcy": "\u044C",
        "SOFTcy": "\u042C",
        "sol": "/",
        "solb": "\u29C4",
        "solbar": "\u233F",
        "sopf": "\uD835\uDD64",
        "Sopf": "\uD835\uDD4A",
        "spades": "\u2660",
        "spadesuit": "\u2660",
        "spar": "\u2225",
        "sqcap": "\u2293",
        "sqcaps": "\u2293\uFE00",
        "sqcup": "\u2294",
        "sqcups": "\u2294\uFE00",
        "Sqrt": "\u221A",
        "sqsub": "\u228F",
        "sqsube": "\u2291",
        "sqsubset": "\u228F",
        "sqsubseteq": "\u2291",
        "sqsup": "\u2290",
        "sqsupe": "\u2292",
        "sqsupset": "\u2290",
        "sqsupseteq": "\u2292",
        "squ": "\u25A1",
        "square": "\u25A1",
        "Square": "\u25A1",
        "SquareIntersection": "\u2293",
        "SquareSubset": "\u228F",
        "SquareSubsetEqual": "\u2291",
        "SquareSuperset": "\u2290",
        "SquareSupersetEqual": "\u2292",
        "SquareUnion": "\u2294",
        "squarf": "\u25AA",
        "squf": "\u25AA",
        "srarr": "\u2192",
        "sscr": "\uD835\uDCC8",
        "Sscr": "\uD835\uDCAE",
        "ssetmn": "\u2216",
        "ssmile": "\u2323",
        "sstarf": "\u22C6",
        "star": "\u2606",
        "Star": "\u22C6",
        "starf": "\u2605",
        "straightepsilon": "\u03F5",
        "straightphi": "\u03D5",
        "strns": "\xaf",
        "sub": "\u2282",
        "Sub": "\u22D0",
        "subdot": "\u2ABD",
        "sube": "\u2286",
        "subE": "\u2AC5",
        "subedot": "\u2AC3",
        "submult": "\u2AC1",
        "subne": "\u228A",
        "subnE": "\u2ACB",
        "subplus": "\u2ABF",
        "subrarr": "\u2979",
        "subset": "\u2282",
        "Subset": "\u22D0",
        "subseteq": "\u2286",
        "subseteqq": "\u2AC5",
        "SubsetEqual": "\u2286",
        "subsetneq": "\u228A",
        "subsetneqq": "\u2ACB",
        "subsim": "\u2AC7",
        "subsub": "\u2AD5",
        "subsup": "\u2AD3",
        "succ": "\u227B",
        "succapprox": "\u2AB8",
        "succcurlyeq": "\u227D",
        "Succeeds": "\u227B",
        "SucceedsEqual": "\u2AB0",
        "SucceedsSlantEqual": "\u227D",
        "SucceedsTilde": "\u227F",
        "succeq": "\u2AB0",
        "succnapprox": "\u2ABA",
        "succneqq": "\u2AB6",
        "succnsim": "\u22E9",
        "succsim": "\u227F",
        "SuchThat": "\u220B",
        "sum": "\u2211",
        "Sum": "\u2211",
        "sung": "\u266A",
        "sup": "\u2283",
        "Sup": "\u22D1",
        "sup1": "\xb9",
        "sup2": "\xb2",
        "sup3": "\xb3",
        "supdot": "\u2ABE",
        "supdsub": "\u2AD8",
        "supe": "\u2287",
        "supE": "\u2AC6",
        "supedot": "\u2AC4",
        "Superset": "\u2283",
        "SupersetEqual": "\u2287",
        "suphsol": "\u27C9",
        "suphsub": "\u2AD7",
        "suplarr": "\u297B",
        "supmult": "\u2AC2",
        "supne": "\u228B",
        "supnE": "\u2ACC",
        "supplus": "\u2AC0",
        "supset": "\u2283",
        "Supset": "\u22D1",
        "supseteq": "\u2287",
        "supseteqq": "\u2AC6",
        "supsetneq": "\u228B",
        "supsetneqq": "\u2ACC",
        "supsim": "\u2AC8",
        "supsub": "\u2AD4",
        "supsup": "\u2AD6",
        "swarhk": "\u2926",
        "swarr": "\u2199",
        "swArr": "\u21D9",
        "swarrow": "\u2199",
        "swnwar": "\u292A",
        "szlig": "\xdf",
        "Tab": "	",
        "target": "\u2316",
        "tau": "\u03C4",
        "Tau": "\u03A4",
        "tbrk": "\u23B4",
        "tcaron": "\u0165",
        "Tcaron": "\u0164",
        "tcedil": "\u0163",
        "Tcedil": "\u0162",
        "tcy": "\u0442",
        "Tcy": "\u0422",
        "tdot": "\u20DB",
        "telrec": "\u2315",
        "tfr": "\uD835\uDD31",
        "Tfr": "\uD835\uDD17",
        "there4": "\u2234",
        "therefore": "\u2234",
        "Therefore": "\u2234",
        "theta": "\u03B8",
        "Theta": "\u0398",
        "thetasym": "\u03D1",
        "thetav": "\u03D1",
        "thickapprox": "\u2248",
        "thicksim": "\u223C",
        "ThickSpace": "\u205F\u200A",
        "thinsp": "\u2009",
        "ThinSpace": "\u2009",
        "thkap": "\u2248",
        "thksim": "\u223C",
        "thorn": "\xfe",
        "THORN": "\xde",
        "tilde": "\u02DC",
        "Tilde": "\u223C",
        "TildeEqual": "\u2243",
        "TildeFullEqual": "\u2245",
        "TildeTilde": "\u2248",
        "times": "\xd7",
        "timesb": "\u22A0",
        "timesbar": "\u2A31",
        "timesd": "\u2A30",
        "tint": "\u222D",
        "toea": "\u2928",
        "top": "\u22A4",
        "topbot": "\u2336",
        "topcir": "\u2AF1",
        "topf": "\uD835\uDD65",
        "Topf": "\uD835\uDD4B",
        "topfork": "\u2ADA",
        "tosa": "\u2929",
        "tprime": "\u2034",
        "trade": "\u2122",
        "TRADE": "\u2122",
        "triangle": "\u25B5",
        "triangledown": "\u25BF",
        "triangleleft": "\u25C3",
        "trianglelefteq": "\u22B4",
        "triangleq": "\u225C",
        "triangleright": "\u25B9",
        "trianglerighteq": "\u22B5",
        "tridot": "\u25EC",
        "trie": "\u225C",
        "triminus": "\u2A3A",
        "TripleDot": "\u20DB",
        "triplus": "\u2A39",
        "trisb": "\u29CD",
        "tritime": "\u2A3B",
        "trpezium": "\u23E2",
        "tscr": "\uD835\uDCC9",
        "Tscr": "\uD835\uDCAF",
        "tscy": "\u0446",
        "TScy": "\u0426",
        "tshcy": "\u045B",
        "TSHcy": "\u040B",
        "tstrok": "\u0167",
        "Tstrok": "\u0166",
        "twixt": "\u226C",
        "twoheadleftarrow": "\u219E",
        "twoheadrightarrow": "\u21A0",
        "uacute": "\xfa",
        "Uacute": "\xda",
        "uarr": "\u2191",
        "uArr": "\u21D1",
        "Uarr": "\u219F",
        "Uarrocir": "\u2949",
        "ubrcy": "\u045E",
        "Ubrcy": "\u040E",
        "ubreve": "\u016D",
        "Ubreve": "\u016C",
        "ucirc": "\xfb",
        "Ucirc": "\xdb",
        "ucy": "\u0443",
        "Ucy": "\u0423",
        "udarr": "\u21C5",
        "udblac": "\u0171",
        "Udblac": "\u0170",
        "udhar": "\u296E",
        "ufisht": "\u297E",
        "ufr": "\uD835\uDD32",
        "Ufr": "\uD835\uDD18",
        "ugrave": "\xf9",
        "Ugrave": "\xd9",
        "uHar": "\u2963",
        "uharl": "\u21BF",
        "uharr": "\u21BE",
        "uhblk": "\u2580",
        "ulcorn": "\u231C",
        "ulcorner": "\u231C",
        "ulcrop": "\u230F",
        "ultri": "\u25F8",
        "umacr": "\u016B",
        "Umacr": "\u016A",
        "uml": "\xa8",
        "UnderBar": "_",
        "UnderBrace": "\u23DF",
        "UnderBracket": "\u23B5",
        "UnderParenthesis": "\u23DD",
        "Union": "\u22C3",
        "UnionPlus": "\u228E",
        "uogon": "\u0173",
        "Uogon": "\u0172",
        "uopf": "\uD835\uDD66",
        "Uopf": "\uD835\uDD4C",
        "uparrow": "\u2191",
        "Uparrow": "\u21D1",
        "UpArrow": "\u2191",
        "UpArrowBar": "\u2912",
        "UpArrowDownArrow": "\u21C5",
        "updownarrow": "\u2195",
        "Updownarrow": "\u21D5",
        "UpDownArrow": "\u2195",
        "UpEquilibrium": "\u296E",
        "upharpoonleft": "\u21BF",
        "upharpoonright": "\u21BE",
        "uplus": "\u228E",
        "UpperLeftArrow": "\u2196",
        "UpperRightArrow": "\u2197",
        "upsi": "\u03C5",
        "Upsi": "\u03D2",
        "upsih": "\u03D2",
        "upsilon": "\u03C5",
        "Upsilon": "\u03A5",
        "UpTee": "\u22A5",
        "UpTeeArrow": "\u21A5",
        "upuparrows": "\u21C8",
        "urcorn": "\u231D",
        "urcorner": "\u231D",
        "urcrop": "\u230E",
        "uring": "\u016F",
        "Uring": "\u016E",
        "urtri": "\u25F9",
        "uscr": "\uD835\uDCCA",
        "Uscr": "\uD835\uDCB0",
        "utdot": "\u22F0",
        "utilde": "\u0169",
        "Utilde": "\u0168",
        "utri": "\u25B5",
        "utrif": "\u25B4",
        "uuarr": "\u21C8",
        "uuml": "\xfc",
        "Uuml": "\xdc",
        "uwangle": "\u29A7",
        "vangrt": "\u299C",
        "varepsilon": "\u03F5",
        "varkappa": "\u03F0",
        "varnothing": "\u2205",
        "varphi": "\u03D5",
        "varpi": "\u03D6",
        "varpropto": "\u221D",
        "varr": "\u2195",
        "vArr": "\u21D5",
        "varrho": "\u03F1",
        "varsigma": "\u03C2",
        "varsubsetneq": "\u228A\uFE00",
        "varsubsetneqq": "\u2ACB\uFE00",
        "varsupsetneq": "\u228B\uFE00",
        "varsupsetneqq": "\u2ACC\uFE00",
        "vartheta": "\u03D1",
        "vartriangleleft": "\u22B2",
        "vartriangleright": "\u22B3",
        "vBar": "\u2AE8",
        "Vbar": "\u2AEB",
        "vBarv": "\u2AE9",
        "vcy": "\u0432",
        "Vcy": "\u0412",
        "vdash": "\u22A2",
        "vDash": "\u22A8",
        "Vdash": "\u22A9",
        "VDash": "\u22AB",
        "Vdashl": "\u2AE6",
        "vee": "\u2228",
        "Vee": "\u22C1",
        "veebar": "\u22BB",
        "veeeq": "\u225A",
        "vellip": "\u22EE",
        "verbar": "|",
        "Verbar": "\u2016",
        "vert": "|",
        "Vert": "\u2016",
        "VerticalBar": "\u2223",
        "VerticalLine": "|",
        "VerticalSeparator": "\u2758",
        "VerticalTilde": "\u2240",
        "VeryThinSpace": "\u200A",
        "vfr": "\uD835\uDD33",
        "Vfr": "\uD835\uDD19",
        "vltri": "\u22B2",
        "vnsub": "\u2282\u20D2",
        "vnsup": "\u2283\u20D2",
        "vopf": "\uD835\uDD67",
        "Vopf": "\uD835\uDD4D",
        "vprop": "\u221D",
        "vrtri": "\u22B3",
        "vscr": "\uD835\uDCCB",
        "Vscr": "\uD835\uDCB1",
        "vsubne": "\u228A\uFE00",
        "vsubnE": "\u2ACB\uFE00",
        "vsupne": "\u228B\uFE00",
        "vsupnE": "\u2ACC\uFE00",
        "Vvdash": "\u22AA",
        "vzigzag": "\u299A",
        "wcirc": "\u0175",
        "Wcirc": "\u0174",
        "wedbar": "\u2A5F",
        "wedge": "\u2227",
        "Wedge": "\u22C0",
        "wedgeq": "\u2259",
        "weierp": "\u2118",
        "wfr": "\uD835\uDD34",
        "Wfr": "\uD835\uDD1A",
        "wopf": "\uD835\uDD68",
        "Wopf": "\uD835\uDD4E",
        "wp": "\u2118",
        "wr": "\u2240",
        "wreath": "\u2240",
        "wscr": "\uD835\uDCCC",
        "Wscr": "\uD835\uDCB2",
        "xcap": "\u22C2",
        "xcirc": "\u25EF",
        "xcup": "\u22C3",
        "xdtri": "\u25BD",
        "xfr": "\uD835\uDD35",
        "Xfr": "\uD835\uDD1B",
        "xharr": "\u27F7",
        "xhArr": "\u27FA",
        "xi": "\u03BE",
        "Xi": "\u039E",
        "xlarr": "\u27F5",
        "xlArr": "\u27F8",
        "xmap": "\u27FC",
        "xnis": "\u22FB",
        "xodot": "\u2A00",
        "xopf": "\uD835\uDD69",
        "Xopf": "\uD835\uDD4F",
        "xoplus": "\u2A01",
        "xotime": "\u2A02",
        "xrarr": "\u27F6",
        "xrArr": "\u27F9",
        "xscr": "\uD835\uDCCD",
        "Xscr": "\uD835\uDCB3",
        "xsqcup": "\u2A06",
        "xuplus": "\u2A04",
        "xutri": "\u25B3",
        "xvee": "\u22C1",
        "xwedge": "\u22C0",
        "yacute": "\xfd",
        "Yacute": "\xdd",
        "yacy": "\u044F",
        "YAcy": "\u042F",
        "ycirc": "\u0177",
        "Ycirc": "\u0176",
        "ycy": "\u044B",
        "Ycy": "\u042B",
        "yen": "\xa5",
        "yfr": "\uD835\uDD36",
        "Yfr": "\uD835\uDD1C",
        "yicy": "\u0457",
        "YIcy": "\u0407",
        "yopf": "\uD835\uDD6A",
        "Yopf": "\uD835\uDD50",
        "yscr": "\uD835\uDCCE",
        "Yscr": "\uD835\uDCB4",
        "yucy": "\u044E",
        "YUcy": "\u042E",
        "yuml": "\xff",
        "Yuml": "\u0178",
        "zacute": "\u017A",
        "Zacute": "\u0179",
        "zcaron": "\u017E",
        "Zcaron": "\u017D",
        "zcy": "\u0437",
        "Zcy": "\u0417",
        "zdot": "\u017C",
        "Zdot": "\u017B",
        "zeetrf": "\u2128",
        "ZeroWidthSpace": "\u200B",
        "zeta": "\u03B6",
        "Zeta": "\u0396",
        "zfr": "\uD835\uDD37",
        "Zfr": "\u2128",
        "zhcy": "\u0436",
        "ZHcy": "\u0416",
        "zigrarr": "\u21DD",
        "zopf": "\uD835\uDD6B",
        "Zopf": "\u2124",
        "zscr": "\uD835\uDCCF",
        "Zscr": "\uD835\uDCB5",
        "zwj": "\u200D",
        "zwnj": "\u200C"
    };
    var decodeMapLegacy = {
        "aacute": "\xe1",
        "Aacute": "\xc1",
        "acirc": "\xe2",
        "Acirc": "\xc2",
        "acute": "\xb4",
        "aelig": "\xe6",
        "AElig": "\xc6",
        "agrave": "\xe0",
        "Agrave": "\xc0",
        "amp": "&",
        "AMP": "&",
        "aring": "\xe5",
        "Aring": "\xc5",
        "atilde": "\xe3",
        "Atilde": "\xc3",
        "auml": "\xe4",
        "Auml": "\xc4",
        "brvbar": "\xa6",
        "ccedil": "\xe7",
        "Ccedil": "\xc7",
        "cedil": "\xb8",
        "cent": "\xa2",
        "copy": "\xa9",
        "COPY": "\xa9",
        "curren": "\xa4",
        "deg": "\xb0",
        "divide": "\xf7",
        "eacute": "\xe9",
        "Eacute": "\xc9",
        "ecirc": "\xea",
        "Ecirc": "\xca",
        "egrave": "\xe8",
        "Egrave": "\xc8",
        "eth": "\xf0",
        "ETH": "\xd0",
        "euml": "\xeb",
        "Euml": "\xcb",
        "frac12": "\xbd",
        "frac14": "\xbc",
        "frac34": "\xbe",
        "gt": ">",
        "GT": ">",
        "iacute": "\xed",
        "Iacute": "\xcd",
        "icirc": "\xee",
        "Icirc": "\xce",
        "iexcl": "\xa1",
        "igrave": "\xec",
        "Igrave": "\xcc",
        "iquest": "\xbf",
        "iuml": "\xef",
        "Iuml": "\xcf",
        "laquo": "\xab",
        "lt": "<",
        "LT": "<",
        "macr": "\xaf",
        "micro": "\xb5",
        "middot": "\xb7",
        "nbsp": "\xa0",
        "not": "\xac",
        "ntilde": "\xf1",
        "Ntilde": "\xd1",
        "oacute": "\xf3",
        "Oacute": "\xd3",
        "ocirc": "\xf4",
        "Ocirc": "\xd4",
        "ograve": "\xf2",
        "Ograve": "\xd2",
        "ordf": "\xaa",
        "ordm": "\xba",
        "oslash": "\xf8",
        "Oslash": "\xd8",
        "otilde": "\xf5",
        "Otilde": "\xd5",
        "ouml": "\xf6",
        "Ouml": "\xd6",
        "para": "\xb6",
        "plusmn": "\xb1",
        "pound": "\xa3",
        "quot": '"',
        "QUOT": '"',
        "raquo": "\xbb",
        "reg": "\xae",
        "REG": "\xae",
        "sect": "\xa7",
        "shy": "\xad",
        "sup1": "\xb9",
        "sup2": "\xb2",
        "sup3": "\xb3",
        "szlig": "\xdf",
        "thorn": "\xfe",
        "THORN": "\xde",
        "times": "\xd7",
        "uacute": "\xfa",
        "Uacute": "\xda",
        "ucirc": "\xfb",
        "Ucirc": "\xdb",
        "ugrave": "\xf9",
        "Ugrave": "\xd9",
        "uml": "\xa8",
        "uuml": "\xfc",
        "Uuml": "\xdc",
        "yacute": "\xfd",
        "Yacute": "\xdd",
        "yen": "\xa5",
        "yuml": "\xff"
    };
    var decodeMapNumeric = {
        "0": "\uFFFD",
        "128": "\u20AC",
        "130": "\u201A",
        "131": "\u0192",
        "132": "\u201E",
        "133": "\u2026",
        "134": "\u2020",
        "135": "\u2021",
        "136": "\u02C6",
        "137": "\u2030",
        "138": "\u0160",
        "139": "\u2039",
        "140": "\u0152",
        "142": "\u017D",
        "145": "\u2018",
        "146": "\u2019",
        "147": "\u201C",
        "148": "\u201D",
        "149": "\u2022",
        "150": "\u2013",
        "151": "\u2014",
        "152": "\u02DC",
        "153": "\u2122",
        "154": "\u0161",
        "155": "\u203A",
        "156": "\u0153",
        "158": "\u017E",
        "159": "\u0178"
    };
    var invalidReferenceCodePoints = [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        11,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31,
        127,
        128,
        129,
        130,
        131,
        132,
        133,
        134,
        135,
        136,
        137,
        138,
        139,
        140,
        141,
        142,
        143,
        144,
        145,
        146,
        147,
        148,
        149,
        150,
        151,
        152,
        153,
        154,
        155,
        156,
        157,
        158,
        159,
        64976,
        64977,
        64978,
        64979,
        64980,
        64981,
        64982,
        64983,
        64984,
        64985,
        64986,
        64987,
        64988,
        64989,
        64990,
        64991,
        64992,
        64993,
        64994,
        64995,
        64996,
        64997,
        64998,
        64999,
        65000,
        65001,
        65002,
        65003,
        65004,
        65005,
        65006,
        65007,
        65534,
        65535,
        131070,
        131071,
        196606,
        196607,
        262142,
        262143,
        327678,
        327679,
        393214,
        393215,
        458750,
        458751,
        524286,
        524287,
        589822,
        589823,
        655358,
        655359,
        720894,
        720895,
        786430,
        786431,
        851966,
        851967,
        917502,
        917503,
        983038,
        983039,
        1048574,
        1048575,
        1114110,
        1114111
    ];
    /*--------------------------------------------------------------------------*/ var stringFromCharCode = String.fromCharCode;
    var object = {};
    var hasOwnProperty = object.hasOwnProperty;
    var has = function has(object, propertyName) {
        return hasOwnProperty.call(object, propertyName);
    };
    var contains = function contains(array, value) {
        var index = -1;
        var length = array.length;
        while(++index < length){
            if (array[index] == value) return true;
        }
        return false;
    };
    var merge = function merge(options, defaults) {
        if (!options) return defaults;
        var result = {};
        var key;
        for(key in defaults)// A `hasOwnProperty` check is not needed here, since only recognized
        // option names are used anyway. Any others are ignored.
        result[key] = has(options, key) ? options[key] : defaults[key];
        return result;
    };
    // Modified version of `ucs2encode`; see https://mths.be/punycode.
    var codePointToSymbol = function codePointToSymbol(codePoint, strict) {
        var output = "";
        if (codePoint >= 0xD800 && codePoint <= 0xDFFF || codePoint > 0x10FFFF) {
            // See issue #4:
            // “Otherwise, if the number is in the range 0xD800 to 0xDFFF or is
            // greater than 0x10FFFF, then this is a parse error. Return a U+FFFD
            // REPLACEMENT CHARACTER.”
            if (strict) parseError("character reference outside the permissible Unicode range");
            return "\uFFFD";
        }
        if (has(decodeMapNumeric, codePoint)) {
            if (strict) parseError("disallowed character reference");
            return decodeMapNumeric[codePoint];
        }
        if (strict && contains(invalidReferenceCodePoints, codePoint)) parseError("disallowed character reference");
        if (codePoint > 0xFFFF) {
            codePoint -= 0x10000;
            output += stringFromCharCode(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        output += stringFromCharCode(codePoint);
        return output;
    };
    var hexEscape = function hexEscape(codePoint) {
        return "&#x" + codePoint.toString(16).toUpperCase() + ";";
    };
    var decEscape = function decEscape(codePoint) {
        return "&#" + codePoint + ";";
    };
    var parseError = function parseError(message) {
        throw Error("Parse error: " + message);
    };
    /*--------------------------------------------------------------------------*/ var encode = function encode1(string, options) {
        options = merge(options, encode.options);
        var strict = options.strict;
        if (strict && regexInvalidRawCodePoint.test(string)) parseError("forbidden code point");
        var encodeEverything = options.encodeEverything;
        var useNamedReferences = options.useNamedReferences;
        var allowUnsafeSymbols = options.allowUnsafeSymbols;
        var escapeCodePoint = options.decimal ? decEscape : hexEscape;
        var escapeBmpSymbol = function escapeBmpSymbol(symbol) {
            return escapeCodePoint(symbol.charCodeAt(0));
        };
        if (encodeEverything) {
            // Encode ASCII symbols.
            string = string.replace(regexAsciiWhitelist, function(symbol) {
                // Use named references if requested & possible.
                if (useNamedReferences && has(encodeMap, symbol)) return "&" + encodeMap[symbol] + ";";
                return escapeBmpSymbol(symbol);
            });
            // Shorten a few escapes that represent two symbols, of which at least one
            // is within the ASCII range.
            if (useNamedReferences) string = string.replace(/&gt;\u20D2/g, "&nvgt;").replace(/&lt;\u20D2/g, "&nvlt;").replace(/&#x66;&#x6A;/g, "&fjlig;");
            // Encode non-ASCII symbols.
            if (useNamedReferences) // Encode non-ASCII symbols that can be replaced with a named reference.
            string = string.replace(regexEncodeNonAscii, function(string) {
                // Note: there is no need to check `has(encodeMap, string)` here.
                return "&" + encodeMap[string] + ";";
            });
        // Note: any remaining non-ASCII symbols are handled outside of the `if`.
        } else if (useNamedReferences) {
            // Apply named character references.
            // Encode `<>"'&` using named character references.
            if (!allowUnsafeSymbols) string = string.replace(regexEscape, function(string) {
                return "&" + encodeMap[string] + ";"; // no need to check `has()` here
            });
            // Shorten escapes that represent two symbols, of which at least one is
            // `<>"'&`.
            string = string.replace(/&gt;\u20D2/g, "&nvgt;").replace(/&lt;\u20D2/g, "&nvlt;");
            // Encode non-ASCII symbols that can be replaced with a named reference.
            string = string.replace(regexEncodeNonAscii, function(string) {
                // Note: there is no need to check `has(encodeMap, string)` here.
                return "&" + encodeMap[string] + ";";
            });
        } else if (!allowUnsafeSymbols) // Encode `<>"'&` using hexadecimal escapes, now that they’re not handled
        // using named character references.
        string = string.replace(regexEscape, escapeBmpSymbol);
        return string// Encode astral symbols.
        .replace(regexAstralSymbols, function($0) {
            // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
            var high = $0.charCodeAt(0);
            var low = $0.charCodeAt(1);
            var codePoint = (high - 0xD800) * 0x400 + low - 0xDC00 + 0x10000;
            return escapeCodePoint(codePoint);
        })// Encode any remaining BMP symbols that are not printable ASCII symbols
        // using a hexadecimal escape.
        .replace(regexBmpWhitelist, escapeBmpSymbol);
    };
    // Expose default options (so they can be overridden globally).
    encode.options = {
        "allowUnsafeSymbols": false,
        "encodeEverything": false,
        "strict": false,
        "useNamedReferences": false,
        "decimal": false
    };
    var decode = function decode1(html, options) {
        options = merge(options, decode.options);
        var strict = options.strict;
        if (strict && regexInvalidEntity.test(html)) parseError("malformed character reference");
        return html.replace(regexDecode, function($0, $1, $2, $3, $4, $5, $6, $7, $8) {
            var codePoint;
            var semicolon;
            var decDigits;
            var hexDigits;
            var reference;
            var next;
            if ($1) {
                reference = $1;
                // Note: there is no need to check `has(decodeMap, reference)`.
                return decodeMap[reference];
            }
            if ($2) {
                // Decode named character references without trailing `;`, e.g. `&amp`.
                // This is only a parse error if it gets converted to `&`, or if it is
                // followed by `=` in an attribute context.
                reference = $2;
                next = $3;
                if (next && options.isAttributeValue) {
                    if (strict && next == "=") parseError("`&` did not start a character reference");
                    return $0;
                } else {
                    if (strict) parseError("named character reference was not terminated by a semicolon");
                    // Note: there is no need to check `has(decodeMapLegacy, reference)`.
                    return decodeMapLegacy[reference] + (next || "");
                }
            }
            if ($4) {
                // Decode decimal escapes, e.g. `&#119558;`.
                decDigits = $4;
                semicolon = $5;
                if (strict && !semicolon) parseError("character reference was not terminated by a semicolon");
                codePoint = parseInt(decDigits, 10);
                return codePointToSymbol(codePoint, strict);
            }
            if ($6) {
                // Decode hexadecimal escapes, e.g. `&#x1D306;`.
                hexDigits = $6;
                semicolon = $7;
                if (strict && !semicolon) parseError("character reference was not terminated by a semicolon");
                codePoint = parseInt(hexDigits, 16);
                return codePointToSymbol(codePoint, strict);
            }
            // If we’re still here, `if ($7)` is implied; it’s an ambiguous
            // ampersand for sure. https://mths.be/notes/ambiguous-ampersands
            if (strict) parseError("named character reference was not terminated by a semicolon");
            return $0;
        });
    };
    // Expose default options (so they can be overridden globally).
    decode.options = {
        "isAttributeValue": false,
        "strict": false
    };
    var escape = function escape(string) {
        return string.replace(regexEscape, function($0) {
            // Note: there is no need to check `has(escapeMap, $0)` here.
            return escapeMap[$0];
        });
    };
    /*--------------------------------------------------------------------------*/ var he = {
        "version": "1.2.0",
        "encode": encode,
        "decode": decode,
        "escape": escape,
        "unescape": decode
    };
    // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) define(function() {
        return he;
    });
    else if (freeExports && !freeExports.nodeType) {
        if (freeModule) freeModule.exports = he;
        else for(var key in he)has(he, key) && (freeExports[key] = he[key]);
    } else root.he = he;
})(this);

});

parcelRegister("iyjDo", function(module, exports) {

$parcel$export(module.exports, "SanitizedHtml", function () { return $620db147a6982e1f$export$6e2f1cf591d7b78; });
//@ts-nocheck

var $1rY3h = parcelRequire("1rY3h");

var $a2Cc8 = parcelRequire("a2Cc8");
var $620db147a6982e1f$export$6e2f1cf591d7b78 = function(param) {
    var innerHTML = param.innerHTML, tmp = param.tagName, Component = tmp === void 0 ? "span" : tmp;
    if (typeof innerHTML === "string") return /*#__PURE__*/ (0, $1rY3h.jsx)(Component, {
        dangerouslySetInnerHTML: {
            __html: (0, (/*@__PURE__*/$parcel$interopDefault($a2Cc8)))(innerHTML)
        }
    });
    else return null;
};

});
parcelRegister("a2Cc8", function(module, exports) {
parcelRequire("2S6hK");
var $3Bsp8 = parcelRequire("3Bsp8");

var $L9gTQ = parcelRequire("L9gTQ");

var $6oFHO = parcelRequire("6oFHO");
var $74f7b7f7d47791bd$require$isPlainObject = $6oFHO.isPlainObject;

var $19s4F = parcelRequire("19s4F");

var $aktg7 = parcelRequire("aktg7");

var $7DtM5 = parcelRequire("7DtM5");
var $74f7b7f7d47791bd$var$postcssParse = $7DtM5.parse;
// Tags that can conceivably represent stand-alone media.
var $74f7b7f7d47791bd$var$mediaTags = [
    "img",
    "audio",
    "video",
    "picture",
    "svg",
    "object",
    "map",
    "iframe",
    "embed"
];
// Tags that are inherently vulnerable to being used in XSS attacks.
var $74f7b7f7d47791bd$var$vulnerableTags = [
    "script",
    "style"
];
function $74f7b7f7d47791bd$var$each(obj, cb) {
    if (obj) Object.keys(obj).forEach(function(key) {
        cb(obj[key], key);
    });
}
// Avoid false positives with .__proto__, .hasOwnProperty, etc.
function $74f7b7f7d47791bd$var$has(obj, key) {
    return ({}).hasOwnProperty.call(obj, key);
}
// Returns those elements of `a` for which `cb(a)` returns truthy
function $74f7b7f7d47791bd$var$filter(a, cb) {
    var n = [];
    $74f7b7f7d47791bd$var$each(a, function(v) {
        if (cb(v)) n.push(v);
    });
    return n;
}
function $74f7b7f7d47791bd$var$isEmptyObject(obj) {
    for(var key in obj){
        if ($74f7b7f7d47791bd$var$has(obj, key)) return false;
    }
    return true;
}
function $74f7b7f7d47791bd$var$stringifySrcset(parsedSrcset) {
    return parsedSrcset.map(function(part) {
        if (!part.url) throw new Error("URL missing");
        return part.url + (part.w ? " ".concat(part.w, "w") : "") + (part.h ? " ".concat(part.h, "h") : "") + (part.d ? " ".concat(part.d, "x") : "");
    }).join(", ");
}
module.exports = $74f7b7f7d47791bd$var$sanitizeHtml;
// A valid attribute name.
// We use a tolerant definition based on the set of strings defined by
// html.spec.whatwg.org/multipage/parsing.html#before-attribute-name-state
// and html.spec.whatwg.org/multipage/parsing.html#attribute-name-state .
// The characters accepted are ones which can be appended to the attribute
// name buffer without triggering a parse error:
//   * unexpected-equals-sign-before-attribute-name
//   * unexpected-null-character
//   * unexpected-character-in-attribute-name
// We exclude the empty string because it's impossible to get to the after
// attribute name state with an empty attribute name buffer.
var $74f7b7f7d47791bd$var$VALID_HTML_ATTRIBUTE_NAME = /^[^\0\t\n\f\r /<=>]+$/;
// Ignore the _recursing flag; it's there for recursive
// invocation as a guard against this exploit:
// https://github.com/fb55/htmlparser2/issues/105
function $74f7b7f7d47791bd$var$sanitizeHtml(html, options, _recursing) {
    if (html == null) return "";
    if (typeof html === "number") html = html.toString();
    var result = "";
    // Used for hot swapping the result variable with an empty string in order to "capture" the text written to it.
    var tempResult = "";
    function Frame(tag, attribs) {
        var that = this;
        this.tag = tag;
        this.attribs = attribs || {};
        this.tagPosition = result.length;
        this.text = ""; // Node inner text
        this.mediaChildren = [];
        this.updateParentNodeText = function() {
            if (stack.length) {
                var parentFrame = stack[stack.length - 1];
                parentFrame.text += that.text;
            }
        };
        this.updateParentNodeMediaChildren = function() {
            if (stack.length && $74f7b7f7d47791bd$var$mediaTags.includes(this.tag)) {
                var parentFrame = stack[stack.length - 1];
                parentFrame.mediaChildren.push(this.tag);
            }
        };
    }
    options = Object.assign({}, $74f7b7f7d47791bd$var$sanitizeHtml.defaults, options);
    options.parser = Object.assign({}, $74f7b7f7d47791bd$var$htmlParserDefaults, options.parser);
    var tagAllowed = function tagAllowed(name) {
        return options.allowedTags === false || (options.allowedTags || []).indexOf(name) > -1;
    };
    // vulnerableTags
    $74f7b7f7d47791bd$var$vulnerableTags.forEach(function(tag) {
        if (tagAllowed(tag) && !options.allowVulnerableTags) console.warn("\n\n\u26A0\uFE0F Your `allowedTags` option includes, `".concat(tag, "`, which is inherently\nvulnerable to XSS attacks. Please remove it from `allowedTags`.\nOr, to disable this warning, add the `allowVulnerableTags` option\nand ensure you are accounting for this risk.\n\n"));
    });
    // Tags that contain something other than HTML, or where discarding
    // the text when the tag is disallowed makes sense for other reasons.
    // If we are not allowing these tags, we should drop their content too.
    // For other tags you would drop the tag but keep its content.
    var nonTextTagsArray = options.nonTextTags || [
        "script",
        "style",
        "textarea",
        "option"
    ];
    var allowedAttributesMap;
    var allowedAttributesGlobMap;
    if (options.allowedAttributes) {
        allowedAttributesMap = {};
        allowedAttributesGlobMap = {};
        $74f7b7f7d47791bd$var$each(options.allowedAttributes, function(attributes, tag) {
            allowedAttributesMap[tag] = [];
            var globRegex = [];
            attributes.forEach(function(obj) {
                if (typeof obj === "string" && obj.indexOf("*") >= 0) globRegex.push($L9gTQ(obj).replace(/\\\*/g, ".*"));
                else allowedAttributesMap[tag].push(obj);
            });
            if (globRegex.length) allowedAttributesGlobMap[tag] = new RegExp("^(" + globRegex.join("|") + ")$");
        });
    }
    var allowedClassesMap = {};
    var allowedClassesGlobMap = {};
    var allowedClassesRegexMap = {};
    $74f7b7f7d47791bd$var$each(options.allowedClasses, function(classes, tag) {
        // Implicitly allows the class attribute
        if (allowedAttributesMap) {
            if (!$74f7b7f7d47791bd$var$has(allowedAttributesMap, tag)) allowedAttributesMap[tag] = [];
            allowedAttributesMap[tag].push("class");
        }
        allowedClassesMap[tag] = classes;
        if (Array.isArray(classes)) {
            var globRegex = [];
            allowedClassesMap[tag] = [];
            allowedClassesRegexMap[tag] = [];
            classes.forEach(function(obj) {
                if (typeof obj === "string" && obj.indexOf("*") >= 0) globRegex.push($L9gTQ(obj).replace(/\\\*/g, ".*"));
                else if (obj instanceof RegExp) allowedClassesRegexMap[tag].push(obj);
                else allowedClassesMap[tag].push(obj);
            });
            if (globRegex.length) allowedClassesGlobMap[tag] = new RegExp("^(" + globRegex.join("|") + ")$");
        }
    });
    var transformTagsMap = {};
    var transformTagsAll;
    $74f7b7f7d47791bd$var$each(options.transformTags, function(transform, tag) {
        var transFun;
        if (typeof transform === "function") transFun = transform;
        else if (typeof transform === "string") transFun = $74f7b7f7d47791bd$var$sanitizeHtml.simpleTransform(transform);
        if (tag === "*") transformTagsAll = transFun;
        else transformTagsMap[tag] = transFun;
    });
    var depth;
    var stack;
    var skipMap;
    var transformMap;
    var skipText;
    var skipTextDepth;
    var addedText = false;
    initializeState();
    var parser = new $3Bsp8.Parser({
        onopentag: function onopentag(name, attribs) {
            // If `enforceHtmlBoundary` is `true` and this has found the opening
            // `html` tag, reset the state.
            if (options.enforceHtmlBoundary && name === "html") initializeState();
            if (skipText) {
                skipTextDepth++;
                return;
            }
            var frame = new Frame(name, attribs);
            stack.push(frame);
            var skip = false;
            var hasText = !!frame.text;
            var transformedTag;
            if ($74f7b7f7d47791bd$var$has(transformTagsMap, name)) {
                transformedTag = transformTagsMap[name](name, attribs);
                frame.attribs = attribs = transformedTag.attribs;
                if (transformedTag.text !== undefined) frame.innerText = transformedTag.text;
                if (name !== transformedTag.tagName) {
                    frame.name = name = transformedTag.tagName;
                    transformMap[depth] = transformedTag.tagName;
                }
            }
            if (transformTagsAll) {
                transformedTag = transformTagsAll(name, attribs);
                frame.attribs = attribs = transformedTag.attribs;
                if (name !== transformedTag.tagName) {
                    frame.name = name = transformedTag.tagName;
                    transformMap[depth] = transformedTag.tagName;
                }
            }
            if (!tagAllowed(name) || options.disallowedTagsMode === "recursiveEscape" && !$74f7b7f7d47791bd$var$isEmptyObject(skipMap) || options.nestingLimit != null && depth >= options.nestingLimit) {
                skip = true;
                skipMap[depth] = true;
                if (options.disallowedTagsMode === "discard") {
                    if (nonTextTagsArray.indexOf(name) !== -1) {
                        skipText = true;
                        skipTextDepth = 1;
                    }
                }
                skipMap[depth] = true;
            }
            depth++;
            if (skip) {
                if (options.disallowedTagsMode === "discard") // We want the contents but not this tag
                return;
                tempResult = result;
                result = "";
            }
            result += "<" + name;
            if (name === "script") {
                if (options.allowedScriptHostnames || options.allowedScriptDomains) frame.innerText = "";
            }
            if (!allowedAttributesMap || $74f7b7f7d47791bd$var$has(allowedAttributesMap, name) || allowedAttributesMap["*"]) $74f7b7f7d47791bd$var$each(attribs, function(value, a) {
                if (!$74f7b7f7d47791bd$var$VALID_HTML_ATTRIBUTE_NAME.test(a)) {
                    // This prevents part of an attribute name in the output from being
                    // interpreted as the end of an attribute, or end of a tag.
                    delete frame.attribs[a];
                    return;
                }
                // If the value is empty, and this is a known non-boolean attribute, delete it
                // List taken from https://html.spec.whatwg.org/multipage/indices.html#attributes-3
                if (value === "" && (options.nonBooleanAttributes.includes(a) || options.nonBooleanAttributes.includes("*"))) {
                    delete frame.attribs[a];
                    return;
                }
                // check allowedAttributesMap for the element and attribute and modify the value
                // as necessary if there are specific values defined.
                var passedAllowedAttributesMapCheck = false;
                if (!allowedAttributesMap || $74f7b7f7d47791bd$var$has(allowedAttributesMap, name) && allowedAttributesMap[name].indexOf(a) !== -1 || allowedAttributesMap["*"] && allowedAttributesMap["*"].indexOf(a) !== -1 || $74f7b7f7d47791bd$var$has(allowedAttributesGlobMap, name) && allowedAttributesGlobMap[name].test(a) || allowedAttributesGlobMap["*"] && allowedAttributesGlobMap["*"].test(a)) passedAllowedAttributesMapCheck = true;
                else if (allowedAttributesMap && allowedAttributesMap[name]) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = allowedAttributesMap[name][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var o = _step.value;
                            if ($74f7b7f7d47791bd$require$isPlainObject(o) && o.name && o.name === a) {
                                passedAllowedAttributesMapCheck = true;
                                var newValue = "";
                                if (o.multiple === true) {
                                    // verify the values that are allowed
                                    var splitStrArray = value.split(" ");
                                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                    try {
                                        for(var _iterator1 = splitStrArray[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                            var s = _step1.value;
                                            if (o.values.indexOf(s) !== -1) {
                                                if (newValue === "") newValue = s;
                                                else newValue += " " + s;
                                            }
                                        }
                                    } catch (err) {
                                        _didIteratorError1 = true;
                                        _iteratorError1 = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                                _iterator1.return();
                                            }
                                        } finally{
                                            if (_didIteratorError1) {
                                                throw _iteratorError1;
                                            }
                                        }
                                    }
                                } else if (o.values.indexOf(value) >= 0) // verified an allowed value matches the entire attribute value
                                newValue = value;
                                value = newValue;
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                if (passedAllowedAttributesMapCheck) {
                    if (options.allowedSchemesAppliedToAttributes.indexOf(a) !== -1) {
                        if (naughtyHref(name, value)) {
                            delete frame.attribs[a];
                            return;
                        }
                    }
                    if (name === "script" && a === "src") {
                        var allowed = true;
                        try {
                            var parsed = parseUrl(value);
                            if (options.allowedScriptHostnames || options.allowedScriptDomains) {
                                var allowedHostname = (options.allowedScriptHostnames || []).find(function(hostname) {
                                    return hostname === parsed.url.hostname;
                                });
                                var allowedDomain = (options.allowedScriptDomains || []).find(function(domain) {
                                    return parsed.url.hostname === domain || parsed.url.hostname.endsWith(".".concat(domain));
                                });
                                allowed = allowedHostname || allowedDomain;
                            }
                        } catch (e) {
                            allowed = false;
                        }
                        if (!allowed) {
                            delete frame.attribs[a];
                            return;
                        }
                    }
                    if (name === "iframe" && a === "src") {
                        var allowed1 = true;
                        try {
                            var parsed1 = parseUrl(value);
                            if (parsed1.isRelativeUrl) // default value of allowIframeRelativeUrls is true
                            // unless allowedIframeHostnames or allowedIframeDomains specified
                            allowed1 = $74f7b7f7d47791bd$var$has(options, "allowIframeRelativeUrls") ? options.allowIframeRelativeUrls : !options.allowedIframeHostnames && !options.allowedIframeDomains;
                            else if (options.allowedIframeHostnames || options.allowedIframeDomains) {
                                var allowedHostname1 = (options.allowedIframeHostnames || []).find(function(hostname) {
                                    return hostname === parsed1.url.hostname;
                                });
                                var allowedDomain1 = (options.allowedIframeDomains || []).find(function(domain) {
                                    return parsed1.url.hostname === domain || parsed1.url.hostname.endsWith(".".concat(domain));
                                });
                                allowed1 = allowedHostname1 || allowedDomain1;
                            }
                        } catch (e) {
                            // Unparseable iframe src
                            allowed1 = false;
                        }
                        if (!allowed1) {
                            delete frame.attribs[a];
                            return;
                        }
                    }
                    if (a === "srcset") try {
                        var parsed2 = $aktg7(value);
                        parsed2.forEach(function(value) {
                            if (naughtyHref("srcset", value.url)) value.evil = true;
                        });
                        parsed2 = $74f7b7f7d47791bd$var$filter(parsed2, function(v) {
                            return !v.evil;
                        });
                        if (!parsed2.length) {
                            delete frame.attribs[a];
                            return;
                        } else {
                            value = $74f7b7f7d47791bd$var$stringifySrcset($74f7b7f7d47791bd$var$filter(parsed2, function(v) {
                                return !v.evil;
                            }));
                            frame.attribs[a] = value;
                        }
                    } catch (e) {
                        // Unparseable srcset
                        delete frame.attribs[a];
                        return;
                    }
                    if (a === "class") {
                        var allowedSpecificClasses = allowedClassesMap[name];
                        var allowedWildcardClasses = allowedClassesMap["*"];
                        var allowedSpecificClassesGlob = allowedClassesGlobMap[name];
                        var allowedSpecificClassesRegex = allowedClassesRegexMap[name];
                        var allowedWildcardClassesGlob = allowedClassesGlobMap["*"];
                        var allowedClassesGlobs = [
                            allowedSpecificClassesGlob,
                            allowedWildcardClassesGlob
                        ].concat(allowedSpecificClassesRegex).filter(function(t) {
                            return t;
                        });
                        if (allowedSpecificClasses && allowedWildcardClasses) value = filterClasses(value, $19s4F(allowedSpecificClasses, allowedWildcardClasses), allowedClassesGlobs);
                        else value = filterClasses(value, allowedSpecificClasses || allowedWildcardClasses, allowedClassesGlobs);
                        if (!value.length) {
                            delete frame.attribs[a];
                            return;
                        }
                    }
                    if (a === "style") {
                        if (options.parseStyleAttributes) try {
                            var abstractSyntaxTree = $74f7b7f7d47791bd$var$postcssParse(name + " {" + value + "}");
                            var filteredAST = filterCss(abstractSyntaxTree, options.allowedStyles);
                            value = stringifyStyleAttributes(filteredAST);
                            if (value.length === 0) {
                                delete frame.attribs[a];
                                return;
                            }
                        } catch (e) {
                            if (typeof window !== "undefined") console.warn('Failed to parse "' + name + " {" + value + "}" + "\", If you're running this in a browser, we recommend to disable style parsing: options.parseStyleAttributes: false, since this only works in a node environment due to a postcss dependency, More info: https://github.com/apostrophecms/sanitize-html/issues/547");
                            delete frame.attribs[a];
                            return;
                        }
                        else if (options.allowedStyles) throw new Error("allowedStyles option cannot be used together with parseStyleAttributes: false.");
                    }
                    result += " " + a;
                    if (value && value.length) result += '="' + escapeHtml(value, true) + '"';
                } else delete frame.attribs[a];
            });
            if (options.selfClosing.indexOf(name) !== -1) result += " />";
            else {
                result += ">";
                if (frame.innerText && !hasText && !options.textFilter) {
                    result += escapeHtml(frame.innerText);
                    addedText = true;
                }
            }
            if (skip) {
                result = tempResult + escapeHtml(result);
                tempResult = "";
            }
        },
        ontext: function ontext(text) {
            if (skipText) return;
            var lastFrame = stack[stack.length - 1];
            var tag;
            if (lastFrame) {
                tag = lastFrame.tag;
                // If inner text was set by transform function then let's use it
                text = lastFrame.innerText !== undefined ? lastFrame.innerText : text;
            }
            if (options.disallowedTagsMode === "discard" && (tag === "script" || tag === "style")) // htmlparser2 gives us these as-is. Escaping them ruins the content. Allowing
            // script tags is, by definition, game over for XSS protection, so if that's
            // your concern, don't allow them. The same is essentially true for style tags
            // which have their own collection of XSS vectors.
            result += text;
            else {
                var escaped = escapeHtml(text, false);
                if (options.textFilter && !addedText) result += options.textFilter(escaped, tag);
                else if (!addedText) result += escaped;
            }
            if (stack.length) {
                var frame = stack[stack.length - 1];
                frame.text += text;
            }
        },
        onclosetag: function onclosetag(name, isImplied) {
            if (skipText) {
                skipTextDepth--;
                if (!skipTextDepth) skipText = false;
                else return;
            }
            var frame = stack.pop();
            if (!frame) // Do not crash on bad markup
            return;
            if (frame.tag !== name) {
                // Another case of bad markup.
                // Push to stack, so that it will be used in future closing tags.
                stack.push(frame);
                return;
            }
            skipText = options.enforceHtmlBoundary ? name === "html" : false;
            depth--;
            var skip = skipMap[depth];
            if (skip) {
                delete skipMap[depth];
                if (options.disallowedTagsMode === "discard") {
                    frame.updateParentNodeText();
                    return;
                }
                tempResult = result;
                result = "";
            }
            if (transformMap[depth]) {
                name = transformMap[depth];
                delete transformMap[depth];
            }
            if (options.exclusiveFilter && options.exclusiveFilter(frame)) {
                result = result.substr(0, frame.tagPosition);
                return;
            }
            frame.updateParentNodeMediaChildren();
            frame.updateParentNodeText();
            if (// Already output />
            options.selfClosing.indexOf(name) !== -1 || // Escaped tag, closing tag is implied
            isImplied && !tagAllowed(name) && [
                "escape",
                "recursiveEscape"
            ].indexOf(options.disallowedTagsMode) >= 0) {
                if (skip) {
                    result = tempResult;
                    tempResult = "";
                }
                return;
            }
            result += "</" + name + ">";
            if (skip) {
                result = tempResult + escapeHtml(result);
                tempResult = "";
            }
            addedText = false;
        }
    }, options.parser);
    parser.write(html);
    parser.end();
    return result;
    function initializeState() {
        result = "";
        depth = 0;
        stack = [];
        skipMap = {};
        transformMap = {};
        skipText = false;
        skipTextDepth = 0;
    }
    function escapeHtml(s, quote) {
        if (typeof s !== "string") s = s + "";
        if (options.parser.decodeEntities) {
            s = s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
            if (quote) s = s.replace(/"/g, "&quot;");
        }
        // TODO: this is inadequate because it will pass `&0;`. This approach
        // will not work, each & must be considered with regard to whether it
        // is followed by a 100% syntactically valid entity or not, and escaped
        // if it is not. If this bothers you, don't set parser.decodeEntities
        // to false. (The default is true.)
        s = s.replace(/&(?![a-zA-Z0-9#]{1,20};)/g, "&amp;") // Match ampersands not part of existing HTML entity
        .replace(/</g, "&lt;").replace(/>/g, "&gt;");
        if (quote) s = s.replace(/"/g, "&quot;");
        return s;
    }
    function naughtyHref(name, href) {
        // Browsers ignore character codes of 32 (space) and below in a surprising
        // number of situations. Start reading here:
        // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet#Embedded_tab
        // eslint-disable-next-line no-control-regex
        href = href.replace(/[\x00-\x20]+/g, "");
        // Clobber any comments in URLs, which the browser might
        // interpret inside an XML data island, allowing
        // a javascript: URL to be snuck through
        while(true){
            var firstIndex = href.indexOf("<!--");
            if (firstIndex === -1) break;
            var lastIndex = href.indexOf("-->", firstIndex + 4);
            if (lastIndex === -1) break;
            href = href.substring(0, firstIndex) + href.substring(lastIndex + 3);
        }
        // Case insensitive so we don't get faked out by JAVASCRIPT #1
        // Allow more characters after the first so we don't get faked
        // out by certain schemes browsers accept
        var matches = href.match(/^([a-zA-Z][a-zA-Z0-9.\-+]*):/);
        if (!matches) {
            // Protocol-relative URL starting with any combination of '/' and '\'
            if (href.match(/^[/\\]{2}/)) return !options.allowProtocolRelative;
            // No scheme
            return false;
        }
        var scheme = matches[1].toLowerCase();
        if ($74f7b7f7d47791bd$var$has(options.allowedSchemesByTag, name)) return options.allowedSchemesByTag[name].indexOf(scheme) === -1;
        return !options.allowedSchemes || options.allowedSchemes.indexOf(scheme) === -1;
    }
    function parseUrl(value) {
        value = value.replace(/^(\w+:)?\s*[\\/]\s*[\\/]/, "$1//");
        if (value.startsWith("relative:")) // An attempt to exploit our workaround for base URLs being
        // mandatory for relative URL validation in the WHATWG
        // URL parser, reject it
        throw new Error("relative: exploit attempt");
        // naughtyHref is in charge of whether protocol relative URLs
        // are cool. Here we are concerned just with allowed hostnames and
        // whether to allow relative URLs.
        //
        // Build a placeholder "base URL" against which any reasonable
        // relative URL may be parsed successfully
        var base = "relative://relative-site";
        for(var i = 0; i < 100; i++)base += "/".concat(i);
        var parsed = new URL(value, base);
        var isRelativeUrl = parsed && parsed.hostname === "relative-site" && parsed.protocol === "relative:";
        return {
            isRelativeUrl: isRelativeUrl,
            url: parsed
        };
    }
    /**
   * Filters user input css properties by allowlisted regex attributes.
   * Modifies the abstractSyntaxTree object.
   *
   * @param {object} abstractSyntaxTree  - Object representation of CSS attributes.
   * @property {array[Declaration]} abstractSyntaxTree.nodes[0] - Each object cointains prop and value key, i.e { prop: 'color', value: 'red' }.
   * @param {object} allowedStyles       - Keys are properties (i.e color), value is list of permitted regex rules (i.e /green/i).
   * @return {object}                    - The modified tree.
   */ function filterCss(abstractSyntaxTree, allowedStyles) {
        if (!allowedStyles) return abstractSyntaxTree;
        var astRules = abstractSyntaxTree.nodes[0];
        var selectedRule;
        // Merge global and tag-specific styles into new AST.
        if (allowedStyles[astRules.selector] && allowedStyles["*"]) selectedRule = $19s4F(allowedStyles[astRules.selector], allowedStyles["*"]);
        else selectedRule = allowedStyles[astRules.selector] || allowedStyles["*"];
        if (selectedRule) abstractSyntaxTree.nodes[0].nodes = astRules.nodes.reduce(filterDeclarations(selectedRule), []);
        return abstractSyntaxTree;
    }
    /**
   * Extracts the style attributes from an AbstractSyntaxTree and formats those
   * values in the inline style attribute format.
   *
   * @param  {AbstractSyntaxTree} filteredAST
   * @return {string}             - Example: "color:yellow;text-align:center !important;font-family:helvetica;"
   */ function stringifyStyleAttributes(filteredAST) {
        return filteredAST.nodes[0].nodes.reduce(function(extractedAttributes, attrObject) {
            extractedAttributes.push("".concat(attrObject.prop, ":").concat(attrObject.value).concat(attrObject.important ? " !important" : ""));
            return extractedAttributes;
        }, []).join(";");
    }
    /**
    * Filters the existing attributes for the given property. Discards any attributes
    * which don't match the allowlist.
    *
    * @param  {object} selectedRule             - Example: { color: red, font-family: helvetica }
    * @param  {array} allowedDeclarationsList   - List of declarations which pass the allowlist.
    * @param  {object} attributeObject          - Object representing the current css property.
    * @property {string} attributeObject.type   - Typically 'declaration'.
    * @property {string} attributeObject.prop   - The CSS property, i.e 'color'.
    * @property {string} attributeObject.value  - The corresponding value to the css property, i.e 'red'.
    * @return {function}                        - When used in Array.reduce, will return an array of Declaration objects
    */ function filterDeclarations(selectedRule) {
        return function(allowedDeclarationsList, attributeObject) {
            // If this property is allowlisted...
            if ($74f7b7f7d47791bd$var$has(selectedRule, attributeObject.prop)) {
                var matchesRegex = selectedRule[attributeObject.prop].some(function(regularExpression) {
                    return regularExpression.test(attributeObject.value);
                });
                if (matchesRegex) allowedDeclarationsList.push(attributeObject);
            }
            return allowedDeclarationsList;
        };
    }
    function filterClasses(classes, allowed, allowedGlobs) {
        if (!allowed) // The class attribute is allowed without filtering on this tag
        return classes;
        classes = classes.split(/\s+/);
        return classes.filter(function(clss) {
            return allowed.indexOf(clss) !== -1 || allowedGlobs.some(function(glob) {
                return glob.test(clss);
            });
        }).join(" ");
    }
}
// Defaults are accessible to you so that you can use them as a starting point
// programmatically if you wish
var $74f7b7f7d47791bd$var$htmlParserDefaults = {
    decodeEntities: true
};
$74f7b7f7d47791bd$var$sanitizeHtml.defaults = {
    allowedTags: [
        // Sections derived from MDN element categories and limited to the more
        // benign categories.
        // https://developer.mozilla.org/en-US/docs/Web/HTML/Element
        // Content sectioning
        "address",
        "article",
        "aside",
        "footer",
        "header",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "hgroup",
        "main",
        "nav",
        "section",
        // Text content
        "blockquote",
        "dd",
        "div",
        "dl",
        "dt",
        "figcaption",
        "figure",
        "hr",
        "li",
        "main",
        "ol",
        "p",
        "pre",
        "ul",
        // Inline text semantics
        "a",
        "abbr",
        "b",
        "bdi",
        "bdo",
        "br",
        "cite",
        "code",
        "data",
        "dfn",
        "em",
        "i",
        "kbd",
        "mark",
        "q",
        "rb",
        "rp",
        "rt",
        "rtc",
        "ruby",
        "s",
        "samp",
        "small",
        "span",
        "strong",
        "sub",
        "sup",
        "time",
        "u",
        "var",
        "wbr",
        // Table content
        "caption",
        "col",
        "colgroup",
        "table",
        "tbody",
        "td",
        "tfoot",
        "th",
        "thead",
        "tr"
    ],
    // Tags that cannot be boolean
    nonBooleanAttributes: [
        "abbr",
        "accept",
        "accept-charset",
        "accesskey",
        "action",
        "allow",
        "alt",
        "as",
        "autocapitalize",
        "autocomplete",
        "blocking",
        "charset",
        "cite",
        "class",
        "color",
        "cols",
        "colspan",
        "content",
        "contenteditable",
        "coords",
        "crossorigin",
        "data",
        "datetime",
        "decoding",
        "dir",
        "dirname",
        "download",
        "draggable",
        "enctype",
        "enterkeyhint",
        "fetchpriority",
        "for",
        "form",
        "formaction",
        "formenctype",
        "formmethod",
        "formtarget",
        "headers",
        "height",
        "hidden",
        "high",
        "href",
        "hreflang",
        "http-equiv",
        "id",
        "imagesizes",
        "imagesrcset",
        "inputmode",
        "integrity",
        "is",
        "itemid",
        "itemprop",
        "itemref",
        "itemtype",
        "kind",
        "label",
        "lang",
        "list",
        "loading",
        "low",
        "max",
        "maxlength",
        "media",
        "method",
        "min",
        "minlength",
        "name",
        "nonce",
        "optimum",
        "pattern",
        "ping",
        "placeholder",
        "popover",
        "popovertarget",
        "popovertargetaction",
        "poster",
        "preload",
        "referrerpolicy",
        "rel",
        "rows",
        "rowspan",
        "sandbox",
        "scope",
        "shape",
        "size",
        "sizes",
        "slot",
        "span",
        "spellcheck",
        "src",
        "srcdoc",
        "srclang",
        "srcset",
        "start",
        "step",
        "style",
        "tabindex",
        "target",
        "title",
        "translate",
        "type",
        "usemap",
        "value",
        "width",
        "wrap",
        // Event handlers
        "onauxclick",
        "onafterprint",
        "onbeforematch",
        "onbeforeprint",
        "onbeforeunload",
        "onbeforetoggle",
        "onblur",
        "oncancel",
        "oncanplay",
        "oncanplaythrough",
        "onchange",
        "onclick",
        "onclose",
        "oncontextlost",
        "oncontextmenu",
        "oncontextrestored",
        "oncopy",
        "oncuechange",
        "oncut",
        "ondblclick",
        "ondrag",
        "ondragend",
        "ondragenter",
        "ondragleave",
        "ondragover",
        "ondragstart",
        "ondrop",
        "ondurationchange",
        "onemptied",
        "onended",
        "onerror",
        "onfocus",
        "onformdata",
        "onhashchange",
        "oninput",
        "oninvalid",
        "onkeydown",
        "onkeypress",
        "onkeyup",
        "onlanguagechange",
        "onload",
        "onloadeddata",
        "onloadedmetadata",
        "onloadstart",
        "onmessage",
        "onmessageerror",
        "onmousedown",
        "onmouseenter",
        "onmouseleave",
        "onmousemove",
        "onmouseout",
        "onmouseover",
        "onmouseup",
        "onoffline",
        "ononline",
        "onpagehide",
        "onpageshow",
        "onpaste",
        "onpause",
        "onplay",
        "onplaying",
        "onpopstate",
        "onprogress",
        "onratechange",
        "onreset",
        "onresize",
        "onrejectionhandled",
        "onscroll",
        "onscrollend",
        "onsecuritypolicyviolation",
        "onseeked",
        "onseeking",
        "onselect",
        "onslotchange",
        "onstalled",
        "onstorage",
        "onsubmit",
        "onsuspend",
        "ontimeupdate",
        "ontoggle",
        "onunhandledrejection",
        "onunload",
        "onvolumechange",
        "onwaiting",
        "onwheel"
    ],
    disallowedTagsMode: "discard",
    allowedAttributes: {
        a: [
            "href",
            "name",
            "target"
        ],
        // We don't currently allow img itself by default, but
        // these attributes would make sense if we did.
        img: [
            "src",
            "srcset",
            "alt",
            "title",
            "width",
            "height",
            "loading"
        ]
    },
    // Lots of these won't come up by default because we don't allow them
    selfClosing: [
        "img",
        "br",
        "hr",
        "area",
        "base",
        "basefont",
        "input",
        "link",
        "meta"
    ],
    // URL schemes we permit
    allowedSchemes: [
        "http",
        "https",
        "ftp",
        "mailto",
        "tel"
    ],
    allowedSchemesByTag: {},
    allowedSchemesAppliedToAttributes: [
        "href",
        "src",
        "cite"
    ],
    allowProtocolRelative: true,
    enforceHtmlBoundary: false,
    parseStyleAttributes: true
};
$74f7b7f7d47791bd$var$sanitizeHtml.simpleTransform = function(newTagName, newAttribs, merge) {
    merge = merge === undefined ? true : merge;
    newAttribs = newAttribs || {};
    return function(tagName, attribs) {
        var attrib;
        if (merge) for(attrib in newAttribs)attribs[attrib] = newAttribs[attrib];
        else attribs = newAttribs;
        return {
            tagName: newTagName,
            attribs: attribs
        };
    };
};

});
parcelRegister("2S6hK", function(module, exports) {

$parcel$export(module.exports, "Parser", function () { return (parcelRequire("3Bsp8")).Parser; });

var $3Bsp8 = parcelRequire("3Bsp8");

var $7UyMy = parcelRequire("7UyMy");

var $fyapH = parcelRequire("fyapH");

var $3Qx6e = parcelRequire("3Qx6e");
parcelRequire("5lyM5");
var $bmgv1 = parcelRequire("bmgv1");
var $5lyM5 = parcelRequire("5lyM5");
function $21758008e9f86115$export$b6a9369736b19f4d(data, options) {
    var handler = new (0, $7UyMy.DomHandler)(undefined, options);
    new (0, $3Bsp8.Parser)(handler, options).end(data);
    return handler.root;
}
function $21758008e9f86115$export$d66b332881d9723f(data, options) {
    return $21758008e9f86115$export$b6a9369736b19f4d(data, options).children;
}
function $21758008e9f86115$export$2bbd0317573b00fc(callback, options, elementCallback) {
    var handler = new (0, $7UyMy.DomHandler)(callback, options, elementCallback);
    return new (0, $3Bsp8.Parser)(handler, options);
}
var $21758008e9f86115$var$parseFeedDefaultOptions = {
    xmlMode: true
};
function $21758008e9f86115$export$5267abf679cd576b(feed) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $21758008e9f86115$var$parseFeedDefaultOptions;
    return (0, $bmgv1.getFeed)($21758008e9f86115$export$d66b332881d9723f(feed, options));
}

});
parcelRegister("3Bsp8", function(module, exports) {

$parcel$export(module.exports, "Parser", function () { return $29fadc55332c76da$export$7acfa6ed01010e37; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $fyapH = parcelRequire("fyapH");

var $7aIFT = parcelRequire("7aIFT");
var $29fadc55332c76da$var$formTags = new Set([
    "input",
    "option",
    "optgroup",
    "select",
    "button",
    "datalist",
    "textarea"
]);
var $29fadc55332c76da$var$pTag = new Set([
    "p"
]);
var $29fadc55332c76da$var$tableSectionTags = new Set([
    "thead",
    "tbody"
]);
var $29fadc55332c76da$var$ddtTags = new Set([
    "dd",
    "dt"
]);
var $29fadc55332c76da$var$rtpTags = new Set([
    "rt",
    "rp"
]);
var $29fadc55332c76da$var$openImpliesClose = new Map([
    [
        "tr",
        new Set([
            "tr",
            "th",
            "td"
        ])
    ],
    [
        "th",
        new Set([
            "th"
        ])
    ],
    [
        "td",
        new Set([
            "thead",
            "th",
            "td"
        ])
    ],
    [
        "body",
        new Set([
            "head",
            "link",
            "script"
        ])
    ],
    [
        "li",
        new Set([
            "li"
        ])
    ],
    [
        "p",
        $29fadc55332c76da$var$pTag
    ],
    [
        "h1",
        $29fadc55332c76da$var$pTag
    ],
    [
        "h2",
        $29fadc55332c76da$var$pTag
    ],
    [
        "h3",
        $29fadc55332c76da$var$pTag
    ],
    [
        "h4",
        $29fadc55332c76da$var$pTag
    ],
    [
        "h5",
        $29fadc55332c76da$var$pTag
    ],
    [
        "h6",
        $29fadc55332c76da$var$pTag
    ],
    [
        "select",
        $29fadc55332c76da$var$formTags
    ],
    [
        "input",
        $29fadc55332c76da$var$formTags
    ],
    [
        "output",
        $29fadc55332c76da$var$formTags
    ],
    [
        "button",
        $29fadc55332c76da$var$formTags
    ],
    [
        "datalist",
        $29fadc55332c76da$var$formTags
    ],
    [
        "textarea",
        $29fadc55332c76da$var$formTags
    ],
    [
        "option",
        new Set([
            "option"
        ])
    ],
    [
        "optgroup",
        new Set([
            "optgroup",
            "option"
        ])
    ],
    [
        "dd",
        $29fadc55332c76da$var$ddtTags
    ],
    [
        "dt",
        $29fadc55332c76da$var$ddtTags
    ],
    [
        "address",
        $29fadc55332c76da$var$pTag
    ],
    [
        "article",
        $29fadc55332c76da$var$pTag
    ],
    [
        "aside",
        $29fadc55332c76da$var$pTag
    ],
    [
        "blockquote",
        $29fadc55332c76da$var$pTag
    ],
    [
        "details",
        $29fadc55332c76da$var$pTag
    ],
    [
        "div",
        $29fadc55332c76da$var$pTag
    ],
    [
        "dl",
        $29fadc55332c76da$var$pTag
    ],
    [
        "fieldset",
        $29fadc55332c76da$var$pTag
    ],
    [
        "figcaption",
        $29fadc55332c76da$var$pTag
    ],
    [
        "figure",
        $29fadc55332c76da$var$pTag
    ],
    [
        "footer",
        $29fadc55332c76da$var$pTag
    ],
    [
        "form",
        $29fadc55332c76da$var$pTag
    ],
    [
        "header",
        $29fadc55332c76da$var$pTag
    ],
    [
        "hr",
        $29fadc55332c76da$var$pTag
    ],
    [
        "main",
        $29fadc55332c76da$var$pTag
    ],
    [
        "nav",
        $29fadc55332c76da$var$pTag
    ],
    [
        "ol",
        $29fadc55332c76da$var$pTag
    ],
    [
        "pre",
        $29fadc55332c76da$var$pTag
    ],
    [
        "section",
        $29fadc55332c76da$var$pTag
    ],
    [
        "table",
        $29fadc55332c76da$var$pTag
    ],
    [
        "ul",
        $29fadc55332c76da$var$pTag
    ],
    [
        "rt",
        $29fadc55332c76da$var$rtpTags
    ],
    [
        "rp",
        $29fadc55332c76da$var$rtpTags
    ],
    [
        "tbody",
        $29fadc55332c76da$var$tableSectionTags
    ],
    [
        "tfoot",
        $29fadc55332c76da$var$tableSectionTags
    ]
]);
var $29fadc55332c76da$var$voidElements = new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
]);
var $29fadc55332c76da$var$foreignContextElements = new Set([
    "math",
    "svg"
]);
var $29fadc55332c76da$var$htmlIntegrationElements = new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignobject",
    "desc",
    "title"
]);
var $29fadc55332c76da$var$reNameEnd = /\s|\//;
var $29fadc55332c76da$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    "use strict";
    function Parser(cbs) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $4GJKx._)(this, Parser);
        var _a, _b, _c, _d, _e;
        this.options = options;
        /** The start index of the last event. */ this.startIndex = 0;
        /** The end index of the last event. */ this.endIndex = 0;
        /**
         * Store the start index of the current open tag,
         * so we can update the start index for attributes.
         */ this.openTagStart = 0;
        this.tagname = "";
        this.attribname = "";
        this.attribvalue = "";
        this.attribs = null;
        this.stack = [];
        this.foreignContext = [];
        this.buffers = [];
        this.bufferOffset = 0;
        /** The index of the last written buffer. Used when resuming after a `pause()`. */ this.writeIndex = 0;
        /** Indicates whether the parser has finished running / `.end` has been called. */ this.ended = false;
        this.cbs = cbs !== null && cbs !== void 0 ? cbs : {};
        this.lowerCaseTagNames = (_a = options.lowerCaseTags) !== null && _a !== void 0 ? _a : !options.xmlMode;
        this.lowerCaseAttributeNames = (_b = options.lowerCaseAttributeNames) !== null && _b !== void 0 ? _b : !options.xmlMode;
        this.tokenizer = new ((_c = options.Tokenizer) !== null && _c !== void 0 ? _c : (0, $fyapH.default))(this.options, this);
        (_e = (_d = this.cbs).onparserinit) === null || _e === void 0 || _e.call(_d, this);
    }
    (0, $1wc17._)(Parser, [
        {
            // Tokenizer event handlers
            /** @internal */ key: "ontext",
            value: function ontext(start, endIndex) {
                var _a, _b;
                var data = this.getSlice(start, endIndex);
                this.endIndex = endIndex - 1;
                (_b = (_a = this.cbs).ontext) === null || _b === void 0 || _b.call(_a, data);
                this.startIndex = endIndex;
            }
        },
        {
            /** @internal */ key: "ontextentity",
            value: function ontextentity(cp) {
                var _a, _b;
                /*
         * Entities can be emitted on the character, or directly after.
         * We use the section start here to get accurate indices.
         */ var index = this.tokenizer.getSectionStart();
                this.endIndex = index - 1;
                (_b = (_a = this.cbs).ontext) === null || _b === void 0 || _b.call(_a, (0, $7aIFT.fromCodePoint)(cp));
                this.startIndex = index;
            }
        },
        {
            key: "isVoidElement",
            value: function isVoidElement(name) {
                return !this.options.xmlMode && $29fadc55332c76da$var$voidElements.has(name);
            }
        },
        {
            /** @internal */ key: "onopentagname",
            value: function onopentagname(start, endIndex) {
                this.endIndex = endIndex;
                var name = this.getSlice(start, endIndex);
                if (this.lowerCaseTagNames) name = name.toLowerCase();
                this.emitOpenTag(name);
            }
        },
        {
            key: "emitOpenTag",
            value: function emitOpenTag(name) {
                var _a, _b, _c, _d;
                this.openTagStart = this.startIndex;
                this.tagname = name;
                var impliesClose = !this.options.xmlMode && $29fadc55332c76da$var$openImpliesClose.get(name);
                if (impliesClose) while(this.stack.length > 0 && impliesClose.has(this.stack[this.stack.length - 1])){
                    var element = this.stack.pop();
                    (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 || _b.call(_a, element, true);
                }
                if (!this.isVoidElement(name)) {
                    this.stack.push(name);
                    if ($29fadc55332c76da$var$foreignContextElements.has(name)) this.foreignContext.push(true);
                    else if ($29fadc55332c76da$var$htmlIntegrationElements.has(name)) this.foreignContext.push(false);
                }
                (_d = (_c = this.cbs).onopentagname) === null || _d === void 0 || _d.call(_c, name);
                if (this.cbs.onopentag) this.attribs = {};
            }
        },
        {
            key: "endOpenTag",
            value: function endOpenTag(isImplied) {
                var _a, _b;
                this.startIndex = this.openTagStart;
                if (this.attribs) {
                    (_b = (_a = this.cbs).onopentag) === null || _b === void 0 || _b.call(_a, this.tagname, this.attribs, isImplied);
                    this.attribs = null;
                }
                if (this.cbs.onclosetag && this.isVoidElement(this.tagname)) this.cbs.onclosetag(this.tagname, true);
                this.tagname = "";
            }
        },
        {
            /** @internal */ key: "onopentagend",
            value: function onopentagend(endIndex) {
                this.endIndex = endIndex;
                this.endOpenTag(false);
                // Set `startIndex` for next node
                this.startIndex = endIndex + 1;
            }
        },
        {
            /** @internal */ key: "onclosetag",
            value: function onclosetag(start, endIndex) {
                var _a, _b, _c, _d, _e, _f;
                this.endIndex = endIndex;
                var name = this.getSlice(start, endIndex);
                if (this.lowerCaseTagNames) name = name.toLowerCase();
                if ($29fadc55332c76da$var$foreignContextElements.has(name) || $29fadc55332c76da$var$htmlIntegrationElements.has(name)) this.foreignContext.pop();
                if (!this.isVoidElement(name)) {
                    var pos = this.stack.lastIndexOf(name);
                    if (pos !== -1) {
                        if (this.cbs.onclosetag) {
                            var count = this.stack.length - pos;
                            while(count--)// We know the stack has sufficient elements.
                            this.cbs.onclosetag(this.stack.pop(), count !== 0);
                        } else this.stack.length = pos;
                    } else if (!this.options.xmlMode && name === "p") {
                        // Implicit open before close
                        this.emitOpenTag("p");
                        this.closeCurrentTag(true);
                    }
                } else if (!this.options.xmlMode && name === "br") {
                    // We can't use `emitOpenTag` for implicit open, as `br` would be implicitly closed.
                    (_b = (_a = this.cbs).onopentagname) === null || _b === void 0 || _b.call(_a, "br");
                    (_d = (_c = this.cbs).onopentag) === null || _d === void 0 || _d.call(_c, "br", {}, true);
                    (_f = (_e = this.cbs).onclosetag) === null || _f === void 0 || _f.call(_e, "br", false);
                }
                // Set `startIndex` for next node
                this.startIndex = endIndex + 1;
            }
        },
        {
            /** @internal */ key: "onselfclosingtag",
            value: function onselfclosingtag(endIndex) {
                this.endIndex = endIndex;
                if (this.options.xmlMode || this.options.recognizeSelfClosing || this.foreignContext[this.foreignContext.length - 1]) {
                    this.closeCurrentTag(false);
                    // Set `startIndex` for next node
                    this.startIndex = endIndex + 1;
                } else // Ignore the fact that the tag is self-closing.
                this.onopentagend(endIndex);
            }
        },
        {
            key: "closeCurrentTag",
            value: function closeCurrentTag(isOpenImplied) {
                var _a, _b;
                var name = this.tagname;
                this.endOpenTag(isOpenImplied);
                // Self-closing tags will be on the top of the stack
                if (this.stack[this.stack.length - 1] === name) {
                    // If the opening tag isn't implied, the closing tag has to be implied.
                    (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 || _b.call(_a, name, !isOpenImplied);
                    this.stack.pop();
                }
            }
        },
        {
            /** @internal */ key: "onattribname",
            value: function onattribname(start, endIndex) {
                this.startIndex = start;
                var name = this.getSlice(start, endIndex);
                this.attribname = this.lowerCaseAttributeNames ? name.toLowerCase() : name;
            }
        },
        {
            /** @internal */ key: "onattribdata",
            value: function onattribdata(start, endIndex) {
                this.attribvalue += this.getSlice(start, endIndex);
            }
        },
        {
            /** @internal */ key: "onattribentity",
            value: function onattribentity(cp) {
                this.attribvalue += (0, $7aIFT.fromCodePoint)(cp);
            }
        },
        {
            /** @internal */ key: "onattribend",
            value: function onattribend(quote, endIndex) {
                var _a, _b;
                this.endIndex = endIndex;
                (_b = (_a = this.cbs).onattribute) === null || _b === void 0 || _b.call(_a, this.attribname, this.attribvalue, quote === (0, $fyapH.QuoteType).Double ? '"' : quote === (0, $fyapH.QuoteType).Single ? "'" : quote === (0, $fyapH.QuoteType).NoValue ? undefined : null);
                if (this.attribs && !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname)) this.attribs[this.attribname] = this.attribvalue;
                this.attribvalue = "";
            }
        },
        {
            key: "getInstructionName",
            value: function getInstructionName(value) {
                var index = value.search($29fadc55332c76da$var$reNameEnd);
                var name = index < 0 ? value : value.substr(0, index);
                if (this.lowerCaseTagNames) name = name.toLowerCase();
                return name;
            }
        },
        {
            /** @internal */ key: "ondeclaration",
            value: function ondeclaration(start, endIndex) {
                this.endIndex = endIndex;
                var value = this.getSlice(start, endIndex);
                if (this.cbs.onprocessinginstruction) {
                    var name = this.getInstructionName(value);
                    this.cbs.onprocessinginstruction("!".concat(name), "!".concat(value));
                }
                // Set `startIndex` for next node
                this.startIndex = endIndex + 1;
            }
        },
        {
            /** @internal */ key: "onprocessinginstruction",
            value: function onprocessinginstruction(start, endIndex) {
                this.endIndex = endIndex;
                var value = this.getSlice(start, endIndex);
                if (this.cbs.onprocessinginstruction) {
                    var name = this.getInstructionName(value);
                    this.cbs.onprocessinginstruction("?".concat(name), "?".concat(value));
                }
                // Set `startIndex` for next node
                this.startIndex = endIndex + 1;
            }
        },
        {
            /** @internal */ key: "oncomment",
            value: function oncomment(start, endIndex, offset) {
                var _a, _b, _c, _d;
                this.endIndex = endIndex;
                (_b = (_a = this.cbs).oncomment) === null || _b === void 0 || _b.call(_a, this.getSlice(start, endIndex - offset));
                (_d = (_c = this.cbs).oncommentend) === null || _d === void 0 || _d.call(_c);
                // Set `startIndex` for next node
                this.startIndex = endIndex + 1;
            }
        },
        {
            /** @internal */ key: "oncdata",
            value: function oncdata(start, endIndex, offset) {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
                this.endIndex = endIndex;
                var value = this.getSlice(start, endIndex - offset);
                if (this.options.xmlMode || this.options.recognizeCDATA) {
                    (_b = (_a = this.cbs).oncdatastart) === null || _b === void 0 || _b.call(_a);
                    (_d = (_c = this.cbs).ontext) === null || _d === void 0 || _d.call(_c, value);
                    (_f = (_e = this.cbs).oncdataend) === null || _f === void 0 || _f.call(_e);
                } else {
                    (_h = (_g = this.cbs).oncomment) === null || _h === void 0 || _h.call(_g, "[CDATA[".concat(value, "]]"));
                    (_k = (_j = this.cbs).oncommentend) === null || _k === void 0 || _k.call(_j);
                }
                // Set `startIndex` for next node
                this.startIndex = endIndex + 1;
            }
        },
        {
            /** @internal */ key: "onend",
            value: function onend() {
                var _a, _b;
                if (this.cbs.onclosetag) {
                    // Set the end index for all remaining tags
                    this.endIndex = this.startIndex;
                    for(var index = this.stack.length; index > 0; this.cbs.onclosetag(this.stack[--index], true));
                }
                (_b = (_a = this.cbs).onend) === null || _b === void 0 || _b.call(_a);
            }
        },
        {
            /**
     * Resets the parser to a blank state, ready to parse a new HTML document
     */ key: "reset",
            value: function reset() {
                var _a, _b, _c, _d;
                (_b = (_a = this.cbs).onreset) === null || _b === void 0 || _b.call(_a);
                this.tokenizer.reset();
                this.tagname = "";
                this.attribname = "";
                this.attribs = null;
                this.stack.length = 0;
                this.startIndex = 0;
                this.endIndex = 0;
                (_d = (_c = this.cbs).onparserinit) === null || _d === void 0 || _d.call(_c, this);
                this.buffers.length = 0;
                this.bufferOffset = 0;
                this.writeIndex = 0;
                this.ended = false;
            }
        },
        {
            /**
     * Resets the parser, then parses a complete document and
     * pushes it to the handler.
     *
     * @param data Document to parse.
     */ key: "parseComplete",
            value: function parseComplete(data) {
                this.reset();
                this.end(data);
            }
        },
        {
            key: "getSlice",
            value: function getSlice(start, end) {
                while(start - this.bufferOffset >= this.buffers[0].length)this.shiftBuffer();
                var slice = this.buffers[0].slice(start - this.bufferOffset, end - this.bufferOffset);
                while(end - this.bufferOffset > this.buffers[0].length){
                    this.shiftBuffer();
                    slice += this.buffers[0].slice(0, end - this.bufferOffset);
                }
                return slice;
            }
        },
        {
            key: "shiftBuffer",
            value: function shiftBuffer() {
                this.bufferOffset += this.buffers[0].length;
                this.writeIndex--;
                this.buffers.shift();
            }
        },
        {
            /**
     * Parses a chunk of data and calls the corresponding callbacks.
     *
     * @param chunk Chunk to parse.
     */ key: "write",
            value: function write(chunk) {
                var _a, _b;
                if (this.ended) {
                    (_b = (_a = this.cbs).onerror) === null || _b === void 0 || _b.call(_a, new Error(".write() after done!"));
                    return;
                }
                this.buffers.push(chunk);
                if (this.tokenizer.running) {
                    this.tokenizer.write(chunk);
                    this.writeIndex++;
                }
            }
        },
        {
            /**
     * Parses the end of the buffer and clears the stack, calls onend.
     *
     * @param chunk Optional final chunk to parse.
     */ key: "end",
            value: function end(chunk) {
                var _a, _b;
                if (this.ended) {
                    (_b = (_a = this.cbs).onerror) === null || _b === void 0 || _b.call(_a, new Error(".end() after done!"));
                    return;
                }
                if (chunk) this.write(chunk);
                this.ended = true;
                this.tokenizer.end();
            }
        },
        {
            /**
     * Pauses parsing. The parser won't emit events until `resume` is called.
     */ key: "pause",
            value: function pause() {
                this.tokenizer.pause();
            }
        },
        {
            /**
     * Resumes parsing after `pause` was called.
     */ key: "resume",
            value: function resume() {
                this.tokenizer.resume();
                while(this.tokenizer.running && this.writeIndex < this.buffers.length)this.tokenizer.write(this.buffers[this.writeIndex++]);
                if (this.ended) this.tokenizer.end();
            }
        },
        {
            /**
     * Alias of `write`, for backwards compatibility.
     *
     * @param chunk Chunk to parse.
     * @deprecated
     */ key: "parseChunk",
            value: function parseChunk(chunk) {
                this.write(chunk);
            }
        },
        {
            /**
     * Alias of `end`, for backwards compatibility.
     *
     * @param chunk Optional final chunk to parse.
     * @deprecated
     */ key: "done",
            value: function done(chunk) {
                this.end(chunk);
            }
        }
    ]);
    return Parser;
}();

});
parcelRegister("fyapH", function(module, exports) {

$parcel$export(module.exports, "QuoteType", function () { return $b5221be11024c0fb$export$cbf5509cea2ad22; });
$parcel$export(module.exports, "default", function () { return $b5221be11024c0fb$export$2e2bcd8739ae039; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $7aIFT = parcelRequire("7aIFT");
var $b5221be11024c0fb$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["Tab"] = 9] = "Tab";
    CharCodes[CharCodes["NewLine"] = 10] = "NewLine";
    CharCodes[CharCodes["FormFeed"] = 12] = "FormFeed";
    CharCodes[CharCodes["CarriageReturn"] = 13] = "CarriageReturn";
    CharCodes[CharCodes["Space"] = 32] = "Space";
    CharCodes[CharCodes["ExclamationMark"] = 33] = "ExclamationMark";
    CharCodes[CharCodes["Number"] = 35] = "Number";
    CharCodes[CharCodes["Amp"] = 38] = "Amp";
    CharCodes[CharCodes["SingleQuote"] = 39] = "SingleQuote";
    CharCodes[CharCodes["DoubleQuote"] = 34] = "DoubleQuote";
    CharCodes[CharCodes["Dash"] = 45] = "Dash";
    CharCodes[CharCodes["Slash"] = 47] = "Slash";
    CharCodes[CharCodes["Zero"] = 48] = "Zero";
    CharCodes[CharCodes["Nine"] = 57] = "Nine";
    CharCodes[CharCodes["Semi"] = 59] = "Semi";
    CharCodes[CharCodes["Lt"] = 60] = "Lt";
    CharCodes[CharCodes["Eq"] = 61] = "Eq";
    CharCodes[CharCodes["Gt"] = 62] = "Gt";
    CharCodes[CharCodes["Questionmark"] = 63] = "Questionmark";
    CharCodes[CharCodes["UpperA"] = 65] = "UpperA";
    CharCodes[CharCodes["LowerA"] = 97] = "LowerA";
    CharCodes[CharCodes["UpperF"] = 70] = "UpperF";
    CharCodes[CharCodes["LowerF"] = 102] = "LowerF";
    CharCodes[CharCodes["UpperZ"] = 90] = "UpperZ";
    CharCodes[CharCodes["LowerZ"] = 122] = "LowerZ";
    CharCodes[CharCodes["LowerX"] = 120] = "LowerX";
    CharCodes[CharCodes["OpeningSquareBracket"] = 91] = "OpeningSquareBracket";
})($b5221be11024c0fb$var$CharCodes || ($b5221be11024c0fb$var$CharCodes = {}));
/** All the states the tokenizer can be in. */ var $b5221be11024c0fb$var$State;
(function(State) {
    State[State["Text"] = 1] = "Text";
    State[State["BeforeTagName"] = 2] = "BeforeTagName";
    State[State["InTagName"] = 3] = "InTagName";
    State[State["InSelfClosingTag"] = 4] = "InSelfClosingTag";
    State[State["BeforeClosingTagName"] = 5] = "BeforeClosingTagName";
    State[State["InClosingTagName"] = 6] = "InClosingTagName";
    State[State["AfterClosingTagName"] = 7] = "AfterClosingTagName";
    // Attributes
    State[State["BeforeAttributeName"] = 8] = "BeforeAttributeName";
    State[State["InAttributeName"] = 9] = "InAttributeName";
    State[State["AfterAttributeName"] = 10] = "AfterAttributeName";
    State[State["BeforeAttributeValue"] = 11] = "BeforeAttributeValue";
    State[State["InAttributeValueDq"] = 12] = "InAttributeValueDq";
    State[State["InAttributeValueSq"] = 13] = "InAttributeValueSq";
    State[State["InAttributeValueNq"] = 14] = "InAttributeValueNq";
    // Declarations
    State[State["BeforeDeclaration"] = 15] = "BeforeDeclaration";
    State[State["InDeclaration"] = 16] = "InDeclaration";
    // Processing instructions
    State[State["InProcessingInstruction"] = 17] = "InProcessingInstruction";
    // Comments & CDATA
    State[State["BeforeComment"] = 18] = "BeforeComment";
    State[State["CDATASequence"] = 19] = "CDATASequence";
    State[State["InSpecialComment"] = 20] = "InSpecialComment";
    State[State["InCommentLike"] = 21] = "InCommentLike";
    // Special tags
    State[State["BeforeSpecialS"] = 22] = "BeforeSpecialS";
    State[State["SpecialStartSequence"] = 23] = "SpecialStartSequence";
    State[State["InSpecialTag"] = 24] = "InSpecialTag";
    State[State["BeforeEntity"] = 25] = "BeforeEntity";
    State[State["BeforeNumericEntity"] = 26] = "BeforeNumericEntity";
    State[State["InNamedEntity"] = 27] = "InNamedEntity";
    State[State["InNumericEntity"] = 28] = "InNumericEntity";
    State[State["InHexEntity"] = 29] = "InHexEntity";
})($b5221be11024c0fb$var$State || ($b5221be11024c0fb$var$State = {}));
function $b5221be11024c0fb$var$isWhitespace(c) {
    return c === $b5221be11024c0fb$var$CharCodes.Space || c === $b5221be11024c0fb$var$CharCodes.NewLine || c === $b5221be11024c0fb$var$CharCodes.Tab || c === $b5221be11024c0fb$var$CharCodes.FormFeed || c === $b5221be11024c0fb$var$CharCodes.CarriageReturn;
}
function $b5221be11024c0fb$var$isEndOfTagSection(c) {
    return c === $b5221be11024c0fb$var$CharCodes.Slash || c === $b5221be11024c0fb$var$CharCodes.Gt || $b5221be11024c0fb$var$isWhitespace(c);
}
function $b5221be11024c0fb$var$isNumber(c) {
    return c >= $b5221be11024c0fb$var$CharCodes.Zero && c <= $b5221be11024c0fb$var$CharCodes.Nine;
}
function $b5221be11024c0fb$var$isASCIIAlpha(c) {
    return c >= $b5221be11024c0fb$var$CharCodes.LowerA && c <= $b5221be11024c0fb$var$CharCodes.LowerZ || c >= $b5221be11024c0fb$var$CharCodes.UpperA && c <= $b5221be11024c0fb$var$CharCodes.UpperZ;
}
function $b5221be11024c0fb$var$isHexDigit(c) {
    return c >= $b5221be11024c0fb$var$CharCodes.UpperA && c <= $b5221be11024c0fb$var$CharCodes.UpperF || c >= $b5221be11024c0fb$var$CharCodes.LowerA && c <= $b5221be11024c0fb$var$CharCodes.LowerF;
}
var $b5221be11024c0fb$export$cbf5509cea2ad22;
(function(QuoteType) {
    QuoteType[QuoteType["NoValue"] = 0] = "NoValue";
    QuoteType[QuoteType["Unquoted"] = 1] = "Unquoted";
    QuoteType[QuoteType["Single"] = 2] = "Single";
    QuoteType[QuoteType["Double"] = 3] = "Double";
})($b5221be11024c0fb$export$cbf5509cea2ad22 || ($b5221be11024c0fb$export$cbf5509cea2ad22 = {}));
/**
 * Sequences used to match longer strings.
 *
 * We don't have `Script`, `Style`, or `Title` here. Instead, we re-use the *End
 * sequences with an increased offset.
 */ var $b5221be11024c0fb$var$Sequences = {
    Cdata: new Uint8Array([
        0x43,
        0x44,
        0x41,
        0x54,
        0x41,
        0x5b
    ]),
    CdataEnd: new Uint8Array([
        0x5d,
        0x5d,
        0x3e
    ]),
    CommentEnd: new Uint8Array([
        0x2d,
        0x2d,
        0x3e
    ]),
    ScriptEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x73,
        0x63,
        0x72,
        0x69,
        0x70,
        0x74
    ]),
    StyleEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x73,
        0x74,
        0x79,
        0x6c,
        0x65
    ]),
    TitleEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x74,
        0x69,
        0x74,
        0x6c,
        0x65
    ])
};
var $b5221be11024c0fb$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function Tokenizer(param, cbs) {
        var _param_xmlMode = param.xmlMode, xmlMode = _param_xmlMode === void 0 ? false : _param_xmlMode, _param_decodeEntities = param.decodeEntities, decodeEntities = _param_decodeEntities === void 0 ? true : _param_decodeEntities;
        (0, $4GJKx._)(this, Tokenizer);
        this.cbs = cbs;
        /** The current state the tokenizer is in. */ this.state = $b5221be11024c0fb$var$State.Text;
        /** The read buffer. */ this.buffer = "";
        /** The beginning of the section that is currently being read. */ this.sectionStart = 0;
        /** The index within the buffer that we are currently looking at. */ this.index = 0;
        /** Some behavior, eg. when decoding entities, is done while we are in another state. This keeps track of the other state type. */ this.baseState = $b5221be11024c0fb$var$State.Text;
        /** For special parsing behavior inside of script and style tags. */ this.isSpecial = false;
        /** Indicates whether the tokenizer has been paused. */ this.running = true;
        /** The offset of the current buffer. */ this.offset = 0;
        this.currentSequence = undefined;
        this.sequenceIndex = 0;
        this.trieIndex = 0;
        this.trieCurrent = 0;
        /** For named entities, the index of the value. For numeric entities, the code point. */ this.entityResult = 0;
        this.entityExcess = 0;
        this.xmlMode = xmlMode;
        this.decodeEntities = decodeEntities;
        this.entityTrie = xmlMode ? (0, $7aIFT.xmlDecodeTree) : (0, $7aIFT.htmlDecodeTree);
    }
    (0, $1wc17._)(Tokenizer, [
        {
            key: "reset",
            value: function reset() {
                this.state = $b5221be11024c0fb$var$State.Text;
                this.buffer = "";
                this.sectionStart = 0;
                this.index = 0;
                this.baseState = $b5221be11024c0fb$var$State.Text;
                this.currentSequence = undefined;
                this.running = true;
                this.offset = 0;
            }
        },
        {
            key: "write",
            value: function write(chunk) {
                this.offset += this.buffer.length;
                this.buffer = chunk;
                this.parse();
            }
        },
        {
            key: "end",
            value: function end() {
                if (this.running) this.finish();
            }
        },
        {
            key: "pause",
            value: function pause() {
                this.running = false;
            }
        },
        {
            key: "resume",
            value: function resume() {
                this.running = true;
                if (this.index < this.buffer.length + this.offset) this.parse();
            }
        },
        {
            /**
     * The current index within all of the written data.
     */ key: "getIndex",
            value: function getIndex() {
                return this.index;
            }
        },
        {
            /**
     * The start of the current section.
     */ key: "getSectionStart",
            value: function getSectionStart() {
                return this.sectionStart;
            }
        },
        {
            key: "stateText",
            value: function stateText(c) {
                if (c === $b5221be11024c0fb$var$CharCodes.Lt || !this.decodeEntities && this.fastForwardTo($b5221be11024c0fb$var$CharCodes.Lt)) {
                    if (this.index > this.sectionStart) this.cbs.ontext(this.sectionStart, this.index);
                    this.state = $b5221be11024c0fb$var$State.BeforeTagName;
                    this.sectionStart = this.index;
                } else if (this.decodeEntities && c === $b5221be11024c0fb$var$CharCodes.Amp) this.state = $b5221be11024c0fb$var$State.BeforeEntity;
            }
        },
        {
            key: "stateSpecialStartSequence",
            value: function stateSpecialStartSequence(c) {
                var isEnd = this.sequenceIndex === this.currentSequence.length;
                var isMatch = isEnd ? $b5221be11024c0fb$var$isEndOfTagSection(c) : (c | 0x20) === this.currentSequence[this.sequenceIndex];
                if (!isMatch) this.isSpecial = false;
                else if (!isEnd) {
                    this.sequenceIndex++;
                    return;
                }
                this.sequenceIndex = 0;
                this.state = $b5221be11024c0fb$var$State.InTagName;
                this.stateInTagName(c);
            }
        },
        {
            /** Look for an end tag. For <title> tags, also decode entities. */ key: "stateInSpecialTag",
            value: function stateInSpecialTag(c) {
                if (this.sequenceIndex === this.currentSequence.length) {
                    if (c === $b5221be11024c0fb$var$CharCodes.Gt || $b5221be11024c0fb$var$isWhitespace(c)) {
                        var endOfText = this.index - this.currentSequence.length;
                        if (this.sectionStart < endOfText) {
                            // Spoof the index so that reported locations match up.
                            var actualIndex = this.index;
                            this.index = endOfText;
                            this.cbs.ontext(this.sectionStart, endOfText);
                            this.index = actualIndex;
                        }
                        this.isSpecial = false;
                        this.sectionStart = endOfText + 2; // Skip over the `</`
                        this.stateInClosingTagName(c);
                        return; // We are done; skip the rest of the function.
                    }
                    this.sequenceIndex = 0;
                }
                if ((c | 0x20) === this.currentSequence[this.sequenceIndex]) this.sequenceIndex += 1;
                else if (this.sequenceIndex === 0) {
                    if (this.currentSequence === $b5221be11024c0fb$var$Sequences.TitleEnd) // We have to parse entities in <title> tags.
                    {
                        if (this.decodeEntities && c === $b5221be11024c0fb$var$CharCodes.Amp) this.state = $b5221be11024c0fb$var$State.BeforeEntity;
                    } else if (this.fastForwardTo($b5221be11024c0fb$var$CharCodes.Lt)) // Outside of <title> tags, we can fast-forward.
                    this.sequenceIndex = 1;
                } else // If we see a `<`, set the sequence index to 1; useful for eg. `<</script>`.
                this.sequenceIndex = Number(c === $b5221be11024c0fb$var$CharCodes.Lt);
            }
        },
        {
            key: "stateCDATASequence",
            value: function stateCDATASequence(c) {
                if (c === $b5221be11024c0fb$var$Sequences.Cdata[this.sequenceIndex]) {
                    if (++this.sequenceIndex === $b5221be11024c0fb$var$Sequences.Cdata.length) {
                        this.state = $b5221be11024c0fb$var$State.InCommentLike;
                        this.currentSequence = $b5221be11024c0fb$var$Sequences.CdataEnd;
                        this.sequenceIndex = 0;
                        this.sectionStart = this.index + 1;
                    }
                } else {
                    this.sequenceIndex = 0;
                    this.state = $b5221be11024c0fb$var$State.InDeclaration;
                    this.stateInDeclaration(c); // Reconsume the character
                }
            }
        },
        {
            /**
     * When we wait for one specific character, we can speed things up
     * by skipping through the buffer until we find it.
     *
     * @returns Whether the character was found.
     */ key: "fastForwardTo",
            value: function fastForwardTo(c) {
                while(++this.index < this.buffer.length + this.offset){
                    if (this.buffer.charCodeAt(this.index - this.offset) === c) return true;
                }
                /*
         * We increment the index at the end of the `parse` loop,
         * so set it to `buffer.length - 1` here.
         *
         * TODO: Refactor `parse` to increment index before calling states.
         */ this.index = this.buffer.length + this.offset - 1;
                return false;
            }
        },
        {
            /**
     * Comments and CDATA end with `-->` and `]]>`.
     *
     * Their common qualities are:
     * - Their end sequences have a distinct character they start with.
     * - That character is then repeated, so we have to check multiple repeats.
     * - All characters but the start character of the sequence can be skipped.
     */ key: "stateInCommentLike",
            value: function stateInCommentLike(c) {
                if (c === this.currentSequence[this.sequenceIndex]) {
                    if (++this.sequenceIndex === this.currentSequence.length) {
                        if (this.currentSequence === $b5221be11024c0fb$var$Sequences.CdataEnd) this.cbs.oncdata(this.sectionStart, this.index, 2);
                        else this.cbs.oncomment(this.sectionStart, this.index, 2);
                        this.sequenceIndex = 0;
                        this.sectionStart = this.index + 1;
                        this.state = $b5221be11024c0fb$var$State.Text;
                    }
                } else if (this.sequenceIndex === 0) // Fast-forward to the first character of the sequence
                {
                    if (this.fastForwardTo(this.currentSequence[0])) this.sequenceIndex = 1;
                } else if (c !== this.currentSequence[this.sequenceIndex - 1]) // Allow long sequences, eg. --->, ]]]>
                this.sequenceIndex = 0;
            }
        },
        {
            /**
     * HTML only allows ASCII alpha characters (a-z and A-Z) at the beginning of a tag name.
     *
     * XML allows a lot more characters here (@see https://www.w3.org/TR/REC-xml/#NT-NameStartChar).
     * We allow anything that wouldn't end the tag.
     */ key: "isTagStartChar",
            value: function isTagStartChar(c) {
                return this.xmlMode ? !$b5221be11024c0fb$var$isEndOfTagSection(c) : $b5221be11024c0fb$var$isASCIIAlpha(c);
            }
        },
        {
            key: "startSpecial",
            value: function startSpecial(sequence, offset) {
                this.isSpecial = true;
                this.currentSequence = sequence;
                this.sequenceIndex = offset;
                this.state = $b5221be11024c0fb$var$State.SpecialStartSequence;
            }
        },
        {
            key: "stateBeforeTagName",
            value: function stateBeforeTagName(c) {
                if (c === $b5221be11024c0fb$var$CharCodes.ExclamationMark) {
                    this.state = $b5221be11024c0fb$var$State.BeforeDeclaration;
                    this.sectionStart = this.index + 1;
                } else if (c === $b5221be11024c0fb$var$CharCodes.Questionmark) {
                    this.state = $b5221be11024c0fb$var$State.InProcessingInstruction;
                    this.sectionStart = this.index + 1;
                } else if (this.isTagStartChar(c)) {
                    var lower = c | 0x20;
                    this.sectionStart = this.index;
                    if (!this.xmlMode && lower === $b5221be11024c0fb$var$Sequences.TitleEnd[2]) this.startSpecial($b5221be11024c0fb$var$Sequences.TitleEnd, 3);
                    else this.state = !this.xmlMode && lower === $b5221be11024c0fb$var$Sequences.ScriptEnd[2] ? $b5221be11024c0fb$var$State.BeforeSpecialS : $b5221be11024c0fb$var$State.InTagName;
                } else if (c === $b5221be11024c0fb$var$CharCodes.Slash) this.state = $b5221be11024c0fb$var$State.BeforeClosingTagName;
                else {
                    this.state = $b5221be11024c0fb$var$State.Text;
                    this.stateText(c);
                }
            }
        },
        {
            key: "stateInTagName",
            value: function stateInTagName(c) {
                if ($b5221be11024c0fb$var$isEndOfTagSection(c)) {
                    this.cbs.onopentagname(this.sectionStart, this.index);
                    this.sectionStart = -1;
                    this.state = $b5221be11024c0fb$var$State.BeforeAttributeName;
                    this.stateBeforeAttributeName(c);
                }
            }
        },
        {
            key: "stateBeforeClosingTagName",
            value: function stateBeforeClosingTagName(c) {
                if ($b5221be11024c0fb$var$isWhitespace(c)) ;
                else if (c === $b5221be11024c0fb$var$CharCodes.Gt) this.state = $b5221be11024c0fb$var$State.Text;
                else {
                    this.state = this.isTagStartChar(c) ? $b5221be11024c0fb$var$State.InClosingTagName : $b5221be11024c0fb$var$State.InSpecialComment;
                    this.sectionStart = this.index;
                }
            }
        },
        {
            key: "stateInClosingTagName",
            value: function stateInClosingTagName(c) {
                if (c === $b5221be11024c0fb$var$CharCodes.Gt || $b5221be11024c0fb$var$isWhitespace(c)) {
                    this.cbs.onclosetag(this.sectionStart, this.index);
                    this.sectionStart = -1;
                    this.state = $b5221be11024c0fb$var$State.AfterClosingTagName;
                    this.stateAfterClosingTagName(c);
                }
            }
        },
        {
            key: "stateAfterClosingTagName",
            value: function stateAfterClosingTagName(c) {
                // Skip everything until ">"
                if (c === $b5221be11024c0fb$var$CharCodes.Gt || this.fastForwardTo($b5221be11024c0fb$var$CharCodes.Gt)) {
                    this.state = $b5221be11024c0fb$var$State.Text;
                    this.baseState = $b5221be11024c0fb$var$State.Text;
                    this.sectionStart = this.index + 1;
                }
            }
        },
        {
            key: "stateBeforeAttributeName",
            value: function stateBeforeAttributeName(c) {
                if (c === $b5221be11024c0fb$var$CharCodes.Gt) {
                    this.cbs.onopentagend(this.index);
                    if (this.isSpecial) {
                        this.state = $b5221be11024c0fb$var$State.InSpecialTag;
                        this.sequenceIndex = 0;
                    } else this.state = $b5221be11024c0fb$var$State.Text;
                    this.baseState = this.state;
                    this.sectionStart = this.index + 1;
                } else if (c === $b5221be11024c0fb$var$CharCodes.Slash) this.state = $b5221be11024c0fb$var$State.InSelfClosingTag;
                else if (!$b5221be11024c0fb$var$isWhitespace(c)) {
                    this.state = $b5221be11024c0fb$var$State.InAttributeName;
                    this.sectionStart = this.index;
                }
            }
        },
        {
            key: "stateInSelfClosingTag",
            value: function stateInSelfClosingTag(c) {
                if (c === $b5221be11024c0fb$var$CharCodes.Gt) {
                    this.cbs.onselfclosingtag(this.index);
                    this.state = $b5221be11024c0fb$var$State.Text;
                    this.baseState = $b5221be11024c0fb$var$State.Text;
                    this.sectionStart = this.index + 1;
                    this.isSpecial = false; // Reset special state, in case of self-closing special tags
                } else if (!$b5221be11024c0fb$var$isWhitespace(c)) {
                    this.state = $b5221be11024c0fb$var$State.BeforeAttributeName;
                    this.stateBeforeAttributeName(c);
                }
            }
        },
        {
            key: "stateInAttributeName",
            value: function stateInAttributeName(c) {
                if (c === $b5221be11024c0fb$var$CharCodes.Eq || $b5221be11024c0fb$var$isEndOfTagSection(c)) {
                    this.cbs.onattribname(this.sectionStart, this.index);
                    this.sectionStart = -1;
                    this.state = $b5221be11024c0fb$var$State.AfterAttributeName;
                    this.stateAfterAttributeName(c);
                }
            }
        },
        {
            key: "stateAfterAttributeName",
            value: function stateAfterAttributeName(c) {
                if (c === $b5221be11024c0fb$var$CharCodes.Eq) this.state = $b5221be11024c0fb$var$State.BeforeAttributeValue;
                else if (c === $b5221be11024c0fb$var$CharCodes.Slash || c === $b5221be11024c0fb$var$CharCodes.Gt) {
                    this.cbs.onattribend($b5221be11024c0fb$export$cbf5509cea2ad22.NoValue, this.index);
                    this.state = $b5221be11024c0fb$var$State.BeforeAttributeName;
                    this.stateBeforeAttributeName(c);
                } else if (!$b5221be11024c0fb$var$isWhitespace(c)) {
                    this.cbs.onattribend($b5221be11024c0fb$export$cbf5509cea2ad22.NoValue, this.index);
                    this.state = $b5221be11024c0fb$var$State.InAttributeName;
                    this.sectionStart = this.index;
                }
            }
        },
        {
            key: "stateBeforeAttributeValue",
            value: function stateBeforeAttributeValue(c) {
                if (c === $b5221be11024c0fb$var$CharCodes.DoubleQuote) {
                    this.state = $b5221be11024c0fb$var$State.InAttributeValueDq;
                    this.sectionStart = this.index + 1;
                } else if (c === $b5221be11024c0fb$var$CharCodes.SingleQuote) {
                    this.state = $b5221be11024c0fb$var$State.InAttributeValueSq;
                    this.sectionStart = this.index + 1;
                } else if (!$b5221be11024c0fb$var$isWhitespace(c)) {
                    this.sectionStart = this.index;
                    this.state = $b5221be11024c0fb$var$State.InAttributeValueNq;
                    this.stateInAttributeValueNoQuotes(c); // Reconsume token
                }
            }
        },
        {
            key: "handleInAttributeValue",
            value: function handleInAttributeValue(c, quote) {
                if (c === quote || !this.decodeEntities && this.fastForwardTo(quote)) {
                    this.cbs.onattribdata(this.sectionStart, this.index);
                    this.sectionStart = -1;
                    this.cbs.onattribend(quote === $b5221be11024c0fb$var$CharCodes.DoubleQuote ? $b5221be11024c0fb$export$cbf5509cea2ad22.Double : $b5221be11024c0fb$export$cbf5509cea2ad22.Single, this.index);
                    this.state = $b5221be11024c0fb$var$State.BeforeAttributeName;
                } else if (this.decodeEntities && c === $b5221be11024c0fb$var$CharCodes.Amp) {
                    this.baseState = this.state;
                    this.state = $b5221be11024c0fb$var$State.BeforeEntity;
                }
            }
        },
        {
            key: "stateInAttributeValueDoubleQuotes",
            value: function stateInAttributeValueDoubleQuotes(c) {
                this.handleInAttributeValue(c, $b5221be11024c0fb$var$CharCodes.DoubleQuote);
            }
        },
        {
            key: "stateInAttributeValueSingleQuotes",
            value: function stateInAttributeValueSingleQuotes(c) {
                this.handleInAttributeValue(c, $b5221be11024c0fb$var$CharCodes.SingleQuote);
            }
        },
        {
            key: "stateInAttributeValueNoQuotes",
            value: function stateInAttributeValueNoQuotes(c) {
                if ($b5221be11024c0fb$var$isWhitespace(c) || c === $b5221be11024c0fb$var$CharCodes.Gt) {
                    this.cbs.onattribdata(this.sectionStart, this.index);
                    this.sectionStart = -1;
                    this.cbs.onattribend($b5221be11024c0fb$export$cbf5509cea2ad22.Unquoted, this.index);
                    this.state = $b5221be11024c0fb$var$State.BeforeAttributeName;
                    this.stateBeforeAttributeName(c);
                } else if (this.decodeEntities && c === $b5221be11024c0fb$var$CharCodes.Amp) {
                    this.baseState = this.state;
                    this.state = $b5221be11024c0fb$var$State.BeforeEntity;
                }
            }
        },
        {
            key: "stateBeforeDeclaration",
            value: function stateBeforeDeclaration(c) {
                if (c === $b5221be11024c0fb$var$CharCodes.OpeningSquareBracket) {
                    this.state = $b5221be11024c0fb$var$State.CDATASequence;
                    this.sequenceIndex = 0;
                } else this.state = c === $b5221be11024c0fb$var$CharCodes.Dash ? $b5221be11024c0fb$var$State.BeforeComment : $b5221be11024c0fb$var$State.InDeclaration;
            }
        },
        {
            key: "stateInDeclaration",
            value: function stateInDeclaration(c) {
                if (c === $b5221be11024c0fb$var$CharCodes.Gt || this.fastForwardTo($b5221be11024c0fb$var$CharCodes.Gt)) {
                    this.cbs.ondeclaration(this.sectionStart, this.index);
                    this.state = $b5221be11024c0fb$var$State.Text;
                    this.sectionStart = this.index + 1;
                }
            }
        },
        {
            key: "stateInProcessingInstruction",
            value: function stateInProcessingInstruction(c) {
                if (c === $b5221be11024c0fb$var$CharCodes.Gt || this.fastForwardTo($b5221be11024c0fb$var$CharCodes.Gt)) {
                    this.cbs.onprocessinginstruction(this.sectionStart, this.index);
                    this.state = $b5221be11024c0fb$var$State.Text;
                    this.sectionStart = this.index + 1;
                }
            }
        },
        {
            key: "stateBeforeComment",
            value: function stateBeforeComment(c) {
                if (c === $b5221be11024c0fb$var$CharCodes.Dash) {
                    this.state = $b5221be11024c0fb$var$State.InCommentLike;
                    this.currentSequence = $b5221be11024c0fb$var$Sequences.CommentEnd;
                    // Allow short comments (eg. <!-->)
                    this.sequenceIndex = 2;
                    this.sectionStart = this.index + 1;
                } else this.state = $b5221be11024c0fb$var$State.InDeclaration;
            }
        },
        {
            key: "stateInSpecialComment",
            value: function stateInSpecialComment(c) {
                if (c === $b5221be11024c0fb$var$CharCodes.Gt || this.fastForwardTo($b5221be11024c0fb$var$CharCodes.Gt)) {
                    this.cbs.oncomment(this.sectionStart, this.index, 0);
                    this.state = $b5221be11024c0fb$var$State.Text;
                    this.sectionStart = this.index + 1;
                }
            }
        },
        {
            key: "stateBeforeSpecialS",
            value: function stateBeforeSpecialS(c) {
                var lower = c | 0x20;
                if (lower === $b5221be11024c0fb$var$Sequences.ScriptEnd[3]) this.startSpecial($b5221be11024c0fb$var$Sequences.ScriptEnd, 4);
                else if (lower === $b5221be11024c0fb$var$Sequences.StyleEnd[3]) this.startSpecial($b5221be11024c0fb$var$Sequences.StyleEnd, 4);
                else {
                    this.state = $b5221be11024c0fb$var$State.InTagName;
                    this.stateInTagName(c); // Consume the token again
                }
            }
        },
        {
            key: "stateBeforeEntity",
            value: function stateBeforeEntity(c) {
                // Start excess with 1 to include the '&'
                this.entityExcess = 1;
                this.entityResult = 0;
                if (c === $b5221be11024c0fb$var$CharCodes.Number) this.state = $b5221be11024c0fb$var$State.BeforeNumericEntity;
                else if (c === $b5221be11024c0fb$var$CharCodes.Amp) ;
                else {
                    this.trieIndex = 0;
                    this.trieCurrent = this.entityTrie[0];
                    this.state = $b5221be11024c0fb$var$State.InNamedEntity;
                    this.stateInNamedEntity(c);
                }
            }
        },
        {
            key: "stateInNamedEntity",
            value: function stateInNamedEntity(c) {
                this.entityExcess += 1;
                this.trieIndex = (0, $7aIFT.determineBranch)(this.entityTrie, this.trieCurrent, this.trieIndex + 1, c);
                if (this.trieIndex < 0) {
                    this.emitNamedEntity();
                    this.index--;
                    return;
                }
                this.trieCurrent = this.entityTrie[this.trieIndex];
                var masked = this.trieCurrent & (0, $7aIFT.BinTrieFlags).VALUE_LENGTH;
                // If the branch is a value, store it and continue
                if (masked) {
                    // The mask is the number of bytes of the value, including the current byte.
                    var valueLength = (masked >> 14) - 1;
                    // If we have a legacy entity while parsing strictly, just skip the number of bytes
                    if (!this.allowLegacyEntity() && c !== $b5221be11024c0fb$var$CharCodes.Semi) this.trieIndex += valueLength;
                    else {
                        // Add 1 as we have already incremented the excess
                        var entityStart = this.index - this.entityExcess + 1;
                        if (entityStart > this.sectionStart) this.emitPartial(this.sectionStart, entityStart);
                        // If this is a surrogate pair, consume the next two bytes
                        this.entityResult = this.trieIndex;
                        this.trieIndex += valueLength;
                        this.entityExcess = 0;
                        this.sectionStart = this.index + 1;
                        if (valueLength === 0) this.emitNamedEntity();
                    }
                }
            }
        },
        {
            key: "emitNamedEntity",
            value: function emitNamedEntity() {
                this.state = this.baseState;
                if (this.entityResult === 0) return;
                var valueLength = (this.entityTrie[this.entityResult] & (0, $7aIFT.BinTrieFlags).VALUE_LENGTH) >> 14;
                switch(valueLength){
                    case 1:
                        this.emitCodePoint(this.entityTrie[this.entityResult] & ~(0, $7aIFT.BinTrieFlags).VALUE_LENGTH);
                        break;
                    case 2:
                        this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
                        break;
                    case 3:
                        this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
                        this.emitCodePoint(this.entityTrie[this.entityResult + 2]);
                }
            }
        },
        {
            key: "stateBeforeNumericEntity",
            value: function stateBeforeNumericEntity(c) {
                if ((c | 0x20) === $b5221be11024c0fb$var$CharCodes.LowerX) {
                    this.entityExcess++;
                    this.state = $b5221be11024c0fb$var$State.InHexEntity;
                } else {
                    this.state = $b5221be11024c0fb$var$State.InNumericEntity;
                    this.stateInNumericEntity(c);
                }
            }
        },
        {
            key: "emitNumericEntity",
            value: function emitNumericEntity(strict) {
                var entityStart = this.index - this.entityExcess - 1;
                var numberStart = entityStart + 2 + Number(this.state === $b5221be11024c0fb$var$State.InHexEntity);
                if (numberStart !== this.index) {
                    // Emit leading data if any
                    if (entityStart > this.sectionStart) this.emitPartial(this.sectionStart, entityStart);
                    this.sectionStart = this.index + Number(strict);
                    this.emitCodePoint((0, $7aIFT.replaceCodePoint)(this.entityResult));
                }
                this.state = this.baseState;
            }
        },
        {
            key: "stateInNumericEntity",
            value: function stateInNumericEntity(c) {
                if (c === $b5221be11024c0fb$var$CharCodes.Semi) this.emitNumericEntity(true);
                else if ($b5221be11024c0fb$var$isNumber(c)) {
                    this.entityResult = this.entityResult * 10 + (c - $b5221be11024c0fb$var$CharCodes.Zero);
                    this.entityExcess++;
                } else {
                    if (this.allowLegacyEntity()) this.emitNumericEntity(false);
                    else this.state = this.baseState;
                    this.index--;
                }
            }
        },
        {
            key: "stateInHexEntity",
            value: function stateInHexEntity(c) {
                if (c === $b5221be11024c0fb$var$CharCodes.Semi) this.emitNumericEntity(true);
                else if ($b5221be11024c0fb$var$isNumber(c)) {
                    this.entityResult = this.entityResult * 16 + (c - $b5221be11024c0fb$var$CharCodes.Zero);
                    this.entityExcess++;
                } else if ($b5221be11024c0fb$var$isHexDigit(c)) {
                    this.entityResult = this.entityResult * 16 + ((c | 0x20) - $b5221be11024c0fb$var$CharCodes.LowerA + 10);
                    this.entityExcess++;
                } else {
                    if (this.allowLegacyEntity()) this.emitNumericEntity(false);
                    else this.state = this.baseState;
                    this.index--;
                }
            }
        },
        {
            key: "allowLegacyEntity",
            value: function allowLegacyEntity() {
                return !this.xmlMode && (this.baseState === $b5221be11024c0fb$var$State.Text || this.baseState === $b5221be11024c0fb$var$State.InSpecialTag);
            }
        },
        {
            /**
     * Remove data that has already been consumed from the buffer.
     */ key: "cleanup",
            value: function cleanup() {
                // If we are inside of text or attributes, emit what we already have.
                if (this.running && this.sectionStart !== this.index) {
                    if (this.state === $b5221be11024c0fb$var$State.Text || this.state === $b5221be11024c0fb$var$State.InSpecialTag && this.sequenceIndex === 0) {
                        this.cbs.ontext(this.sectionStart, this.index);
                        this.sectionStart = this.index;
                    } else if (this.state === $b5221be11024c0fb$var$State.InAttributeValueDq || this.state === $b5221be11024c0fb$var$State.InAttributeValueSq || this.state === $b5221be11024c0fb$var$State.InAttributeValueNq) {
                        this.cbs.onattribdata(this.sectionStart, this.index);
                        this.sectionStart = this.index;
                    }
                }
            }
        },
        {
            key: "shouldContinue",
            value: function shouldContinue() {
                return this.index < this.buffer.length + this.offset && this.running;
            }
        },
        {
            /**
     * Iterates through the buffer, calling the function corresponding to the current state.
     *
     * States that are more likely to be hit are higher up, as a performance improvement.
     */ key: "parse",
            value: function parse() {
                while(this.shouldContinue()){
                    var c = this.buffer.charCodeAt(this.index - this.offset);
                    switch(this.state){
                        case $b5221be11024c0fb$var$State.Text:
                            this.stateText(c);
                            break;
                        case $b5221be11024c0fb$var$State.SpecialStartSequence:
                            this.stateSpecialStartSequence(c);
                            break;
                        case $b5221be11024c0fb$var$State.InSpecialTag:
                            this.stateInSpecialTag(c);
                            break;
                        case $b5221be11024c0fb$var$State.CDATASequence:
                            this.stateCDATASequence(c);
                            break;
                        case $b5221be11024c0fb$var$State.InAttributeValueDq:
                            this.stateInAttributeValueDoubleQuotes(c);
                            break;
                        case $b5221be11024c0fb$var$State.InAttributeName:
                            this.stateInAttributeName(c);
                            break;
                        case $b5221be11024c0fb$var$State.InCommentLike:
                            this.stateInCommentLike(c);
                            break;
                        case $b5221be11024c0fb$var$State.InSpecialComment:
                            this.stateInSpecialComment(c);
                            break;
                        case $b5221be11024c0fb$var$State.BeforeAttributeName:
                            this.stateBeforeAttributeName(c);
                            break;
                        case $b5221be11024c0fb$var$State.InTagName:
                            this.stateInTagName(c);
                            break;
                        case $b5221be11024c0fb$var$State.InClosingTagName:
                            this.stateInClosingTagName(c);
                            break;
                        case $b5221be11024c0fb$var$State.BeforeTagName:
                            this.stateBeforeTagName(c);
                            break;
                        case $b5221be11024c0fb$var$State.AfterAttributeName:
                            this.stateAfterAttributeName(c);
                            break;
                        case $b5221be11024c0fb$var$State.InAttributeValueSq:
                            this.stateInAttributeValueSingleQuotes(c);
                            break;
                        case $b5221be11024c0fb$var$State.BeforeAttributeValue:
                            this.stateBeforeAttributeValue(c);
                            break;
                        case $b5221be11024c0fb$var$State.BeforeClosingTagName:
                            this.stateBeforeClosingTagName(c);
                            break;
                        case $b5221be11024c0fb$var$State.AfterClosingTagName:
                            this.stateAfterClosingTagName(c);
                            break;
                        case $b5221be11024c0fb$var$State.BeforeSpecialS:
                            this.stateBeforeSpecialS(c);
                            break;
                        case $b5221be11024c0fb$var$State.InAttributeValueNq:
                            this.stateInAttributeValueNoQuotes(c);
                            break;
                        case $b5221be11024c0fb$var$State.InSelfClosingTag:
                            this.stateInSelfClosingTag(c);
                            break;
                        case $b5221be11024c0fb$var$State.InDeclaration:
                            this.stateInDeclaration(c);
                            break;
                        case $b5221be11024c0fb$var$State.BeforeDeclaration:
                            this.stateBeforeDeclaration(c);
                            break;
                        case $b5221be11024c0fb$var$State.BeforeComment:
                            this.stateBeforeComment(c);
                            break;
                        case $b5221be11024c0fb$var$State.InProcessingInstruction:
                            this.stateInProcessingInstruction(c);
                            break;
                        case $b5221be11024c0fb$var$State.InNamedEntity:
                            this.stateInNamedEntity(c);
                            break;
                        case $b5221be11024c0fb$var$State.BeforeEntity:
                            this.stateBeforeEntity(c);
                            break;
                        case $b5221be11024c0fb$var$State.InHexEntity:
                            this.stateInHexEntity(c);
                            break;
                        case $b5221be11024c0fb$var$State.InNumericEntity:
                            this.stateInNumericEntity(c);
                            break;
                        default:
                            // `this._state === State.BeforeNumericEntity`
                            this.stateBeforeNumericEntity(c);
                    }
                    this.index++;
                }
                this.cleanup();
            }
        },
        {
            key: "finish",
            value: function finish() {
                if (this.state === $b5221be11024c0fb$var$State.InNamedEntity) this.emitNamedEntity();
                // If there is remaining data, emit it in a reasonable way
                if (this.sectionStart < this.index) this.handleTrailingData();
                this.cbs.onend();
            }
        },
        {
            /** Handle any trailing data. */ key: "handleTrailingData",
            value: function handleTrailingData() {
                var endIndex = this.buffer.length + this.offset;
                if (this.state === $b5221be11024c0fb$var$State.InCommentLike) {
                    if (this.currentSequence === $b5221be11024c0fb$var$Sequences.CdataEnd) this.cbs.oncdata(this.sectionStart, endIndex, 0);
                    else this.cbs.oncomment(this.sectionStart, endIndex, 0);
                } else if (this.state === $b5221be11024c0fb$var$State.InNumericEntity && this.allowLegacyEntity()) this.emitNumericEntity(false);
                else if (this.state === $b5221be11024c0fb$var$State.InHexEntity && this.allowLegacyEntity()) this.emitNumericEntity(false);
                else if (this.state === $b5221be11024c0fb$var$State.InTagName || this.state === $b5221be11024c0fb$var$State.BeforeAttributeName || this.state === $b5221be11024c0fb$var$State.BeforeAttributeValue || this.state === $b5221be11024c0fb$var$State.AfterAttributeName || this.state === $b5221be11024c0fb$var$State.InAttributeName || this.state === $b5221be11024c0fb$var$State.InAttributeValueSq || this.state === $b5221be11024c0fb$var$State.InAttributeValueDq || this.state === $b5221be11024c0fb$var$State.InAttributeValueNq || this.state === $b5221be11024c0fb$var$State.InClosingTagName) ;
                else this.cbs.ontext(this.sectionStart, endIndex);
            }
        },
        {
            key: "emitPartial",
            value: function emitPartial(start, endIndex) {
                if (this.baseState !== $b5221be11024c0fb$var$State.Text && this.baseState !== $b5221be11024c0fb$var$State.InSpecialTag) this.cbs.onattribdata(start, endIndex);
                else this.cbs.ontext(start, endIndex);
            }
        },
        {
            key: "emitCodePoint",
            value: function emitCodePoint(cp) {
                if (this.baseState !== $b5221be11024c0fb$var$State.Text && this.baseState !== $b5221be11024c0fb$var$State.InSpecialTag) this.cbs.onattribentity(cp);
                else this.cbs.ontextentity(cp);
            }
        }
    ]);
    return Tokenizer;
}();

});
parcelRegister("7aIFT", function(module, exports) {
"use strict";
var $0158f83e2e94c6f3$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0158f83e2e94c6f3$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $0158f83e2e94c6f3$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $0158f83e2e94c6f3$var$__createBinding(result, mod, k);
    }
    $0158f83e2e94c6f3$var$__setModuleDefault(result, mod);
    return result;
};
var $0158f83e2e94c6f3$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.decodeXML = module.exports.decodeHTMLStrict = module.exports.decodeHTMLAttribute = module.exports.decodeHTML = module.exports.determineBranch = module.exports.EntityDecoder = module.exports.DecodingMode = module.exports.BinTrieFlags = module.exports.fromCodePoint = module.exports.replaceCodePoint = module.exports.decodeCodePoint = module.exports.xmlDecodeTree = module.exports.htmlDecodeTree = void 0;

var $0158f83e2e94c6f3$var$decode_data_html_js_1 = $0158f83e2e94c6f3$var$__importDefault((parcelRequire("iTT55")));
module.exports.htmlDecodeTree = $0158f83e2e94c6f3$var$decode_data_html_js_1.default;

var $0158f83e2e94c6f3$var$decode_data_xml_js_1 = $0158f83e2e94c6f3$var$__importDefault((parcelRequire("dGzMK")));
module.exports.xmlDecodeTree = $0158f83e2e94c6f3$var$decode_data_xml_js_1.default;

var $0158f83e2e94c6f3$var$decode_codepoint_js_1 = $0158f83e2e94c6f3$var$__importStar((parcelRequire("if5Pf")));
module.exports.decodeCodePoint = $0158f83e2e94c6f3$var$decode_codepoint_js_1.default;

Object.defineProperty(module.exports, "replaceCodePoint", {
    enumerable: true,
    get: function get() {
        return (parcelRequire("if5Pf")).replaceCodePoint;
    }
});
Object.defineProperty(module.exports, "fromCodePoint", {
    enumerable: true,
    get: function get() {
        return (parcelRequire("if5Pf")).fromCodePoint;
    }
});
var $0158f83e2e94c6f3$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["NUM"] = 35] = "NUM";
    CharCodes[CharCodes["SEMI"] = 59] = "SEMI";
    CharCodes[CharCodes["EQUALS"] = 61] = "EQUALS";
    CharCodes[CharCodes["ZERO"] = 48] = "ZERO";
    CharCodes[CharCodes["NINE"] = 57] = "NINE";
    CharCodes[CharCodes["LOWER_A"] = 97] = "LOWER_A";
    CharCodes[CharCodes["LOWER_F"] = 102] = "LOWER_F";
    CharCodes[CharCodes["LOWER_X"] = 120] = "LOWER_X";
    CharCodes[CharCodes["LOWER_Z"] = 122] = "LOWER_Z";
    CharCodes[CharCodes["UPPER_A"] = 65] = "UPPER_A";
    CharCodes[CharCodes["UPPER_F"] = 70] = "UPPER_F";
    CharCodes[CharCodes["UPPER_Z"] = 90] = "UPPER_Z";
})($0158f83e2e94c6f3$var$CharCodes || ($0158f83e2e94c6f3$var$CharCodes = {}));
/** Bit that needs to be set to convert an upper case ASCII character to lower case */ var $0158f83e2e94c6f3$var$TO_LOWER_BIT = 32;
var $0158f83e2e94c6f3$var$BinTrieFlags;
(function(BinTrieFlags) {
    BinTrieFlags[BinTrieFlags["VALUE_LENGTH"] = 49152] = "VALUE_LENGTH";
    BinTrieFlags[BinTrieFlags["BRANCH_LENGTH"] = 16256] = "BRANCH_LENGTH";
    BinTrieFlags[BinTrieFlags["JUMP_TABLE"] = 127] = "JUMP_TABLE";
})($0158f83e2e94c6f3$var$BinTrieFlags = module.exports.BinTrieFlags || (module.exports.BinTrieFlags = {}));
function $0158f83e2e94c6f3$var$isNumber(code) {
    return code >= $0158f83e2e94c6f3$var$CharCodes.ZERO && code <= $0158f83e2e94c6f3$var$CharCodes.NINE;
}
function $0158f83e2e94c6f3$var$isHexadecimalCharacter(code) {
    return code >= $0158f83e2e94c6f3$var$CharCodes.UPPER_A && code <= $0158f83e2e94c6f3$var$CharCodes.UPPER_F || code >= $0158f83e2e94c6f3$var$CharCodes.LOWER_A && code <= $0158f83e2e94c6f3$var$CharCodes.LOWER_F;
}
function $0158f83e2e94c6f3$var$isAsciiAlphaNumeric(code) {
    return code >= $0158f83e2e94c6f3$var$CharCodes.UPPER_A && code <= $0158f83e2e94c6f3$var$CharCodes.UPPER_Z || code >= $0158f83e2e94c6f3$var$CharCodes.LOWER_A && code <= $0158f83e2e94c6f3$var$CharCodes.LOWER_Z || $0158f83e2e94c6f3$var$isNumber(code);
}
/**
 * Checks if the given character is a valid end character for an entity in an attribute.
 *
 * Attribute values that aren't terminated properly aren't parsed, and shouldn't lead to a parser error.
 * See the example in https://html.spec.whatwg.org/multipage/parsing.html#named-character-reference-state
 */ function $0158f83e2e94c6f3$var$isEntityInAttributeInvalidEnd(code) {
    return code === $0158f83e2e94c6f3$var$CharCodes.EQUALS || $0158f83e2e94c6f3$var$isAsciiAlphaNumeric(code);
}
var $0158f83e2e94c6f3$var$EntityDecoderState;
(function(EntityDecoderState) {
    EntityDecoderState[EntityDecoderState["EntityStart"] = 0] = "EntityStart";
    EntityDecoderState[EntityDecoderState["NumericStart"] = 1] = "NumericStart";
    EntityDecoderState[EntityDecoderState["NumericDecimal"] = 2] = "NumericDecimal";
    EntityDecoderState[EntityDecoderState["NumericHex"] = 3] = "NumericHex";
    EntityDecoderState[EntityDecoderState["NamedEntity"] = 4] = "NamedEntity";
})($0158f83e2e94c6f3$var$EntityDecoderState || ($0158f83e2e94c6f3$var$EntityDecoderState = {}));
var $0158f83e2e94c6f3$var$DecodingMode;
(function(DecodingMode) {
    /** Entities in text nodes that can end with any character. */ DecodingMode[DecodingMode["Legacy"] = 0] = "Legacy";
    /** Only allow entities terminated with a semicolon. */ DecodingMode[DecodingMode["Strict"] = 1] = "Strict";
    /** Entities in attributes have limitations on ending characters. */ DecodingMode[DecodingMode["Attribute"] = 2] = "Attribute";
})($0158f83e2e94c6f3$var$DecodingMode = module.exports.DecodingMode || (module.exports.DecodingMode = {}));
/**
 * Token decoder with support of writing partial entities.
 */ var $0158f83e2e94c6f3$var$EntityDecoder = /** @class */ function() {
    function EntityDecoder(/** The tree used to decode entities. */ decodeTree, /**
     * The function that is called when a codepoint is decoded.
     *
     * For multi-byte named entities, this will be called multiple times,
     * with the second codepoint, and the same `consumed` value.
     *
     * @param codepoint The decoded codepoint.
     * @param consumed The number of bytes consumed by the decoder.
     */ emitCodePoint, /** An object that is used to produce errors. */ errors) {
        this.decodeTree = decodeTree;
        this.emitCodePoint = emitCodePoint;
        this.errors = errors;
        /** The current state of the decoder. */ this.state = $0158f83e2e94c6f3$var$EntityDecoderState.EntityStart;
        /** Characters that were consumed while parsing an entity. */ this.consumed = 1;
        /**
         * The result of the entity.
         *
         * Either the result index of a numeric entity, or the codepoint of a
         * numeric entity.
         */ this.result = 0;
        /** The current index in the decode tree. */ this.treeIndex = 0;
        /** The number of characters that were consumed in excess. */ this.excess = 1;
        /** The mode in which the decoder is operating. */ this.decodeMode = $0158f83e2e94c6f3$var$DecodingMode.Strict;
    }
    /** Resets the instance to make it reusable. */ EntityDecoder.prototype.startEntity = function(decodeMode) {
        this.decodeMode = decodeMode;
        this.state = $0158f83e2e94c6f3$var$EntityDecoderState.EntityStart;
        this.result = 0;
        this.treeIndex = 0;
        this.excess = 1;
        this.consumed = 1;
    };
    /**
     * Write an entity to the decoder. This can be called multiple times with partial entities.
     * If the entity is incomplete, the decoder will return -1.
     *
     * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
     * entity is incomplete, and resume when the next string is written.
     *
     * @param string The string containing the entity (or a continuation of the entity).
     * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ EntityDecoder.prototype.write = function(str, offset) {
        switch(this.state){
            case $0158f83e2e94c6f3$var$EntityDecoderState.EntityStart:
                if (str.charCodeAt(offset) === $0158f83e2e94c6f3$var$CharCodes.NUM) {
                    this.state = $0158f83e2e94c6f3$var$EntityDecoderState.NumericStart;
                    this.consumed += 1;
                    return this.stateNumericStart(str, offset + 1);
                }
                this.state = $0158f83e2e94c6f3$var$EntityDecoderState.NamedEntity;
                return this.stateNamedEntity(str, offset);
            case $0158f83e2e94c6f3$var$EntityDecoderState.NumericStart:
                return this.stateNumericStart(str, offset);
            case $0158f83e2e94c6f3$var$EntityDecoderState.NumericDecimal:
                return this.stateNumericDecimal(str, offset);
            case $0158f83e2e94c6f3$var$EntityDecoderState.NumericHex:
                return this.stateNumericHex(str, offset);
            case $0158f83e2e94c6f3$var$EntityDecoderState.NamedEntity:
                return this.stateNamedEntity(str, offset);
        }
    };
    /**
     * Switches between the numeric decimal and hexadecimal states.
     *
     * Equivalent to the `Numeric character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ EntityDecoder.prototype.stateNumericStart = function(str, offset) {
        if (offset >= str.length) return -1;
        if ((str.charCodeAt(offset) | $0158f83e2e94c6f3$var$TO_LOWER_BIT) === $0158f83e2e94c6f3$var$CharCodes.LOWER_X) {
            this.state = $0158f83e2e94c6f3$var$EntityDecoderState.NumericHex;
            this.consumed += 1;
            return this.stateNumericHex(str, offset + 1);
        }
        this.state = $0158f83e2e94c6f3$var$EntityDecoderState.NumericDecimal;
        return this.stateNumericDecimal(str, offset);
    };
    EntityDecoder.prototype.addToNumericResult = function(str, start, end, base) {
        if (start !== end) {
            var digitCount = end - start;
            this.result = this.result * Math.pow(base, digitCount) + parseInt(str.substr(start, digitCount), base);
            this.consumed += digitCount;
        }
    };
    /**
     * Parses a hexadecimal numeric entity.
     *
     * Equivalent to the `Hexademical character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ EntityDecoder.prototype.stateNumericHex = function(str, offset) {
        var startIdx = offset;
        while(offset < str.length){
            var char = str.charCodeAt(offset);
            if ($0158f83e2e94c6f3$var$isNumber(char) || $0158f83e2e94c6f3$var$isHexadecimalCharacter(char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 16);
                return this.emitNumericEntity(char, 3);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 16);
        return -1;
    };
    /**
     * Parses a decimal numeric entity.
     *
     * Equivalent to the `Decimal character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ EntityDecoder.prototype.stateNumericDecimal = function(str, offset) {
        var startIdx = offset;
        while(offset < str.length){
            var char = str.charCodeAt(offset);
            if ($0158f83e2e94c6f3$var$isNumber(char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 10);
                return this.emitNumericEntity(char, 2);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 10);
        return -1;
    };
    /**
     * Validate and emit a numeric entity.
     *
     * Implements the logic from the `Hexademical character reference start
     * state` and `Numeric character reference end state` in the HTML spec.
     *
     * @param lastCp The last code point of the entity. Used to see if the
     *               entity was terminated with a semicolon.
     * @param expectedLength The minimum number of characters that should be
     *                       consumed. Used to validate that at least one digit
     *                       was consumed.
     * @returns The number of characters that were consumed.
     */ EntityDecoder.prototype.emitNumericEntity = function(lastCp, expectedLength) {
        var _a;
        // Ensure we consumed at least one digit.
        if (this.consumed <= expectedLength) {
            (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
            return 0;
        }
        // Figure out if this is a legit end of the entity
        if (lastCp === $0158f83e2e94c6f3$var$CharCodes.SEMI) this.consumed += 1;
        else if (this.decodeMode === $0158f83e2e94c6f3$var$DecodingMode.Strict) return 0;
        this.emitCodePoint((0, $0158f83e2e94c6f3$var$decode_codepoint_js_1.replaceCodePoint)(this.result), this.consumed);
        if (this.errors) {
            if (lastCp !== $0158f83e2e94c6f3$var$CharCodes.SEMI) this.errors.missingSemicolonAfterCharacterReference();
            this.errors.validateNumericCharacterReference(this.result);
        }
        return this.consumed;
    };
    /**
     * Parses a named entity.
     *
     * Equivalent to the `Named character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ EntityDecoder.prototype.stateNamedEntity = function(str, offset) {
        var decodeTree = this.decodeTree;
        var current = decodeTree[this.treeIndex];
        // The mask is the number of bytes of the value, including the current byte.
        var valueLength = (current & $0158f83e2e94c6f3$var$BinTrieFlags.VALUE_LENGTH) >> 14;
        for(; offset < str.length; offset++, this.excess++){
            var char = str.charCodeAt(offset);
            this.treeIndex = $0158f83e2e94c6f3$var$determineBranch(decodeTree, current, this.treeIndex + Math.max(1, valueLength), char);
            if (this.treeIndex < 0) return this.result === 0 || // If we are parsing an attribute
            this.decodeMode === $0158f83e2e94c6f3$var$DecodingMode.Attribute && // We shouldn't have consumed any characters after the entity,
            (valueLength === 0 || // And there should be no invalid characters.
            $0158f83e2e94c6f3$var$isEntityInAttributeInvalidEnd(char)) ? 0 : this.emitNotTerminatedNamedEntity();
            current = decodeTree[this.treeIndex];
            valueLength = (current & $0158f83e2e94c6f3$var$BinTrieFlags.VALUE_LENGTH) >> 14;
            // If the branch is a value, store it and continue
            if (valueLength !== 0) {
                // If the entity is terminated by a semicolon, we are done.
                if (char === $0158f83e2e94c6f3$var$CharCodes.SEMI) return this.emitNamedEntityData(this.treeIndex, valueLength, this.consumed + this.excess);
                // If we encounter a non-terminated (legacy) entity while parsing strictly, then ignore it.
                if (this.decodeMode !== $0158f83e2e94c6f3$var$DecodingMode.Strict) {
                    this.result = this.treeIndex;
                    this.consumed += this.excess;
                    this.excess = 0;
                }
            }
        }
        return -1;
    };
    /**
     * Emit a named entity that was not terminated with a semicolon.
     *
     * @returns The number of characters consumed.
     */ EntityDecoder.prototype.emitNotTerminatedNamedEntity = function() {
        var _a;
        var _b = this, result = _b.result, decodeTree = _b.decodeTree;
        var valueLength = (decodeTree[result] & $0158f83e2e94c6f3$var$BinTrieFlags.VALUE_LENGTH) >> 14;
        this.emitNamedEntityData(result, valueLength, this.consumed);
        (_a = this.errors) === null || _a === void 0 || _a.missingSemicolonAfterCharacterReference();
        return this.consumed;
    };
    /**
     * Emit a named entity.
     *
     * @param result The index of the entity in the decode tree.
     * @param valueLength The number of bytes in the entity.
     * @param consumed The number of characters consumed.
     *
     * @returns The number of characters consumed.
     */ EntityDecoder.prototype.emitNamedEntityData = function(result, valueLength, consumed) {
        var decodeTree = this.decodeTree;
        this.emitCodePoint(valueLength === 1 ? decodeTree[result] & ~$0158f83e2e94c6f3$var$BinTrieFlags.VALUE_LENGTH : decodeTree[result + 1], consumed);
        if (valueLength === 3) // For multi-byte values, we need to emit the second byte.
        this.emitCodePoint(decodeTree[result + 2], consumed);
        return consumed;
    };
    /**
     * Signal to the parser that the end of the input was reached.
     *
     * Remaining data will be emitted and relevant errors will be produced.
     *
     * @returns The number of characters consumed.
     */ EntityDecoder.prototype.end = function() {
        var _a;
        switch(this.state){
            case $0158f83e2e94c6f3$var$EntityDecoderState.NamedEntity:
                // Emit a named entity if we have one.
                return this.result !== 0 && (this.decodeMode !== $0158f83e2e94c6f3$var$DecodingMode.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
            // Otherwise, emit a numeric entity if we have one.
            case $0158f83e2e94c6f3$var$EntityDecoderState.NumericDecimal:
                return this.emitNumericEntity(0, 2);
            case $0158f83e2e94c6f3$var$EntityDecoderState.NumericHex:
                return this.emitNumericEntity(0, 3);
            case $0158f83e2e94c6f3$var$EntityDecoderState.NumericStart:
                (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
                return 0;
            case $0158f83e2e94c6f3$var$EntityDecoderState.EntityStart:
                // Return 0 if we have no entity.
                return 0;
        }
    };
    return EntityDecoder;
}();
module.exports.EntityDecoder = $0158f83e2e94c6f3$var$EntityDecoder;
/**
 * Creates a function that decodes entities in a string.
 *
 * @param decodeTree The decode tree.
 * @returns A function that decodes entities in a string.
 */ function $0158f83e2e94c6f3$var$getDecoder(decodeTree) {
    var ret = "";
    var decoder = new $0158f83e2e94c6f3$var$EntityDecoder(decodeTree, function(str) {
        return ret += (0, $0158f83e2e94c6f3$var$decode_codepoint_js_1.fromCodePoint)(str);
    });
    return function decodeWithTrie(str, decodeMode) {
        var lastIndex = 0;
        var offset = 0;
        while((offset = str.indexOf("&", offset)) >= 0){
            ret += str.slice(lastIndex, offset);
            decoder.startEntity(decodeMode);
            var len = decoder.write(str, // Skip the "&"
            offset + 1);
            if (len < 0) {
                lastIndex = offset + decoder.end();
                break;
            }
            lastIndex = offset + len;
            // If `len` is 0, skip the current `&` and continue.
            offset = len === 0 ? lastIndex + 1 : lastIndex;
        }
        var result = ret + str.slice(lastIndex);
        // Make sure we don't keep a reference to the final string.
        ret = "";
        return result;
    };
}
/**
 * Determines the branch of the current node that is taken given the current
 * character. This function is used to traverse the trie.
 *
 * @param decodeTree The trie.
 * @param current The current node.
 * @param nodeIdx The index right after the current node and its value.
 * @param char The current character.
 * @returns The index of the next node, or -1 if no branch is taken.
 */ function $0158f83e2e94c6f3$var$determineBranch(decodeTree, current, nodeIdx, char) {
    var branchCount = (current & $0158f83e2e94c6f3$var$BinTrieFlags.BRANCH_LENGTH) >> 7;
    var jumpOffset = current & $0158f83e2e94c6f3$var$BinTrieFlags.JUMP_TABLE;
    // Case 1: Single branch encoded in jump offset
    if (branchCount === 0) return jumpOffset !== 0 && char === jumpOffset ? nodeIdx : -1;
    // Case 2: Multiple branches encoded in jump table
    if (jumpOffset) {
        var value = char - jumpOffset;
        return value < 0 || value >= branchCount ? -1 : decodeTree[nodeIdx + value] - 1;
    }
    // Case 3: Multiple branches encoded in dictionary
    // Binary search for the character.
    var lo = nodeIdx;
    var hi = lo + branchCount - 1;
    while(lo <= hi){
        var mid = lo + hi >>> 1;
        var midVal = decodeTree[mid];
        if (midVal < char) lo = mid + 1;
        else if (midVal > char) hi = mid - 1;
        else return decodeTree[mid + branchCount];
    }
    return -1;
}
module.exports.determineBranch = $0158f83e2e94c6f3$var$determineBranch;
var $0158f83e2e94c6f3$var$htmlDecoder = $0158f83e2e94c6f3$var$getDecoder($0158f83e2e94c6f3$var$decode_data_html_js_1.default);
var $0158f83e2e94c6f3$var$xmlDecoder = $0158f83e2e94c6f3$var$getDecoder($0158f83e2e94c6f3$var$decode_data_xml_js_1.default);
/**
 * Decodes an HTML string.
 *
 * @param str The string to decode.
 * @param mode The decoding mode.
 * @returns The decoded string.
 */ function $0158f83e2e94c6f3$var$decodeHTML(str, mode) {
    if (mode === void 0) mode = $0158f83e2e94c6f3$var$DecodingMode.Legacy;
    return $0158f83e2e94c6f3$var$htmlDecoder(str, mode);
}
module.exports.decodeHTML = $0158f83e2e94c6f3$var$decodeHTML;
/**
 * Decodes an HTML string in an attribute.
 *
 * @param str The string to decode.
 * @returns The decoded string.
 */ function $0158f83e2e94c6f3$var$decodeHTMLAttribute(str) {
    return $0158f83e2e94c6f3$var$htmlDecoder(str, $0158f83e2e94c6f3$var$DecodingMode.Attribute);
}
module.exports.decodeHTMLAttribute = $0158f83e2e94c6f3$var$decodeHTMLAttribute;
/**
 * Decodes an HTML string, requiring all entities to be terminated by a semicolon.
 *
 * @param str The string to decode.
 * @returns The decoded string.
 */ function $0158f83e2e94c6f3$var$decodeHTMLStrict(str) {
    return $0158f83e2e94c6f3$var$htmlDecoder(str, $0158f83e2e94c6f3$var$DecodingMode.Strict);
}
module.exports.decodeHTMLStrict = $0158f83e2e94c6f3$var$decodeHTMLStrict;
/**
 * Decodes an XML string, requiring all entities to be terminated by a semicolon.
 *
 * @param str The string to decode.
 * @returns The decoded string.
 */ function $0158f83e2e94c6f3$var$decodeXML(str) {
    return $0158f83e2e94c6f3$var$xmlDecoder(str, $0158f83e2e94c6f3$var$DecodingMode.Strict);
}
module.exports.decodeXML = $0158f83e2e94c6f3$var$decodeXML;

});
parcelRegister("iTT55", function(module, exports) {
"use strict";
// Generated using scripts/write-decode-map.ts
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = new Uint16Array(// prettier-ignore
'\u1D41<\xd5\u0131\u028A\u049D\u057B\u05D0\u0675\u06DE\u07A2\u07D6\u080F\u0A4A\u0A91\u0DA1\u0E6D\u0F09\u0F26\u10CA\u1228\u12E1\u1415\u149D\u14C3\u14DF\u1525\x00\x00\x00\x00\x00\x00\u156B\u16CD\u198D\u1C12\u1DDD\u1F7E\u2060\u21B0\u228D\u23C0\u23FB\u2442\u2824\u2912\u2D08\u2E48\u2FCE\u3016\u32BA\u3639\u37AC\u38FE\u3A28\u3A71\u3AE0\u3B2E\u0800EMabcfglmnoprstu\\bfms\x7f\x84\x8b\x90\x95\x98\xa6\xb3\xb9\xc8\xcflig\u803B\xc6\u40C6P\u803B&\u4026cute\u803B\xc1\u40C1reve;\u4102\u0100iyx}rc\u803B\xc2\u40C2;\u4410r;\uC000\ud835\udd04rave\u803B\xc0\u40C0pha;\u4391acr;\u4100d;\u6A53\u0100gp\x9d\xa1on;\u4104f;\uC000\ud835\udd38plyFunction;\u6061ing\u803B\xc5\u40C5\u0100cs\xbe\xc3r;\uC000\ud835\udc9cign;\u6254ilde\u803B\xc3\u40C3ml\u803B\xc4\u40C4\u0400aceforsu\xe5\xfb\xfe\u0117\u011C\u0122\u0127\u012A\u0100cr\xea\xf2kslash;\u6216\u0176\xf6\xf8;\u6AE7ed;\u6306y;\u4411\u0180crt\u0105\u010B\u0114ause;\u6235noullis;\u612Ca;\u4392r;\uC000\ud835\udd05pf;\uC000\ud835\udd39eve;\u42D8c\xf2\u0113mpeq;\u624E\u0700HOacdefhilorsu\u014D\u0151\u0156\u0180\u019E\u01A2\u01B5\u01B7\u01BA\u01DC\u0215\u0273\u0278\u027Ecy;\u4427PY\u803B\xa9\u40A9\u0180cpy\u015D\u0162\u017Aute;\u4106\u0100;i\u0167\u0168\u62D2talDifferentialD;\u6145leys;\u612D\u0200aeio\u0189\u018E\u0194\u0198ron;\u410Cdil\u803B\xc7\u40C7rc;\u4108nint;\u6230ot;\u410A\u0100dn\u01A7\u01ADilla;\u40B8terDot;\u40B7\xf2\u017Fi;\u43A7rcle\u0200DMPT\u01C7\u01CB\u01D1\u01D6ot;\u6299inus;\u6296lus;\u6295imes;\u6297o\u0100cs\u01E2\u01F8kwiseContourIntegral;\u6232eCurly\u0100DQ\u0203\u020FoubleQuote;\u601Duote;\u6019\u0200lnpu\u021E\u0228\u0247\u0255on\u0100;e\u0225\u0226\u6237;\u6A74\u0180git\u022F\u0236\u023Aruent;\u6261nt;\u622FourIntegral;\u622E\u0100fr\u024C\u024E;\u6102oduct;\u6210nterClockwiseContourIntegral;\u6233oss;\u6A2Fcr;\uC000\ud835\udc9ep\u0100;C\u0284\u0285\u62D3ap;\u624D\u0580DJSZacefios\u02A0\u02AC\u02B0\u02B4\u02B8\u02CB\u02D7\u02E1\u02E6\u0333\u048D\u0100;o\u0179\u02A5trahd;\u6911cy;\u4402cy;\u4405cy;\u440F\u0180grs\u02BF\u02C4\u02C7ger;\u6021r;\u61A1hv;\u6AE4\u0100ay\u02D0\u02D5ron;\u410E;\u4414l\u0100;t\u02DD\u02DE\u6207a;\u4394r;\uC000\ud835\udd07\u0100af\u02EB\u0327\u0100cm\u02F0\u0322ritical\u0200ADGT\u0300\u0306\u0316\u031Ccute;\u40B4o\u0174\u030B\u030D;\u42D9bleAcute;\u42DDrave;\u4060ilde;\u42DCond;\u62C4ferentialD;\u6146\u0470\u033D\x00\x00\x00\u0342\u0354\x00\u0405f;\uC000\ud835\udd3b\u0180;DE\u0348\u0349\u034D\u40A8ot;\u60DCqual;\u6250ble\u0300CDLRUV\u0363\u0372\u0382\u03CF\u03E2\u03F8ontourIntegra\xec\u0239o\u0274\u0379\x00\x00\u037B\xbb\u0349nArrow;\u61D3\u0100eo\u0387\u03A4ft\u0180ART\u0390\u0396\u03A1rrow;\u61D0ightArrow;\u61D4e\xe5\u02CAng\u0100LR\u03AB\u03C4eft\u0100AR\u03B3\u03B9rrow;\u67F8ightArrow;\u67FAightArrow;\u67F9ight\u0100AT\u03D8\u03DErrow;\u61D2ee;\u62A8p\u0241\u03E9\x00\x00\u03EFrrow;\u61D1ownArrow;\u61D5erticalBar;\u6225n\u0300ABLRTa\u0412\u042A\u0430\u045E\u047F\u037Crrow\u0180;BU\u041D\u041E\u0422\u6193ar;\u6913pArrow;\u61F5reve;\u4311eft\u02D2\u043A\x00\u0446\x00\u0450ightVector;\u6950eeVector;\u695Eector\u0100;B\u0459\u045A\u61BDar;\u6956ight\u01D4\u0467\x00\u0471eeVector;\u695Fector\u0100;B\u047A\u047B\u61C1ar;\u6957ee\u0100;A\u0486\u0487\u62A4rrow;\u61A7\u0100ct\u0492\u0497r;\uC000\ud835\udc9frok;\u4110\u0800NTacdfglmopqstux\u04BD\u04C0\u04C4\u04CB\u04DE\u04E2\u04E7\u04EE\u04F5\u0521\u052F\u0536\u0552\u055D\u0560\u0565G;\u414AH\u803B\xd0\u40D0cute\u803B\xc9\u40C9\u0180aiy\u04D2\u04D7\u04DCron;\u411Arc\u803B\xca\u40CA;\u442Dot;\u4116r;\uC000\ud835\udd08rave\u803B\xc8\u40C8ement;\u6208\u0100ap\u04FA\u04FEcr;\u4112ty\u0253\u0506\x00\x00\u0512mallSquare;\u65FBerySmallSquare;\u65AB\u0100gp\u0526\u052Aon;\u4118f;\uC000\ud835\udd3csilon;\u4395u\u0100ai\u053C\u0549l\u0100;T\u0542\u0543\u6A75ilde;\u6242librium;\u61CC\u0100ci\u0557\u055Ar;\u6130m;\u6A73a;\u4397ml\u803B\xcb\u40CB\u0100ip\u056A\u056Fsts;\u6203onentialE;\u6147\u0280cfios\u0585\u0588\u058D\u05B2\u05CCy;\u4424r;\uC000\ud835\udd09lled\u0253\u0597\x00\x00\u05A3mallSquare;\u65FCerySmallSquare;\u65AA\u0370\u05BA\x00\u05BF\x00\x00\u05C4f;\uC000\ud835\udd3dAll;\u6200riertrf;\u6131c\xf2\u05CB\u0600JTabcdfgorst\u05E8\u05EC\u05EF\u05FA\u0600\u0612\u0616\u061B\u061D\u0623\u066C\u0672cy;\u4403\u803B>\u403Emma\u0100;d\u05F7\u05F8\u4393;\u43DCreve;\u411E\u0180eiy\u0607\u060C\u0610dil;\u4122rc;\u411C;\u4413ot;\u4120r;\uC000\ud835\udd0a;\u62D9pf;\uC000\ud835\udd3eeater\u0300EFGLST\u0635\u0644\u064E\u0656\u065B\u0666qual\u0100;L\u063E\u063F\u6265ess;\u62DBullEqual;\u6267reater;\u6AA2ess;\u6277lantEqual;\u6A7Eilde;\u6273cr;\uC000\ud835\udca2;\u626B\u0400Aacfiosu\u0685\u068B\u0696\u069B\u069E\u06AA\u06BE\u06CARDcy;\u442A\u0100ct\u0690\u0694ek;\u42C7;\u405Eirc;\u4124r;\u610ClbertSpace;\u610B\u01F0\u06AF\x00\u06B2f;\u610DizontalLine;\u6500\u0100ct\u06C3\u06C5\xf2\u06A9rok;\u4126mp\u0144\u06D0\u06D8ownHum\xf0\u012Fqual;\u624F\u0700EJOacdfgmnostu\u06FA\u06FE\u0703\u0707\u070E\u071A\u071E\u0721\u0728\u0744\u0778\u078B\u078F\u0795cy;\u4415lig;\u4132cy;\u4401cute\u803B\xcd\u40CD\u0100iy\u0713\u0718rc\u803B\xce\u40CE;\u4418ot;\u4130r;\u6111rave\u803B\xcc\u40CC\u0180;ap\u0720\u072F\u073F\u0100cg\u0734\u0737r;\u412AinaryI;\u6148lie\xf3\u03DD\u01F4\u0749\x00\u0762\u0100;e\u074D\u074E\u622C\u0100gr\u0753\u0758ral;\u622Bsection;\u62C2isible\u0100CT\u076C\u0772omma;\u6063imes;\u6062\u0180gpt\u077F\u0783\u0788on;\u412Ef;\uC000\ud835\udd40a;\u4399cr;\u6110ilde;\u4128\u01EB\u079A\x00\u079Ecy;\u4406l\u803B\xcf\u40CF\u0280cfosu\u07AC\u07B7\u07BC\u07C2\u07D0\u0100iy\u07B1\u07B5rc;\u4134;\u4419r;\uC000\ud835\udd0dpf;\uC000\ud835\udd41\u01E3\u07C7\x00\u07CCr;\uC000\ud835\udca5rcy;\u4408kcy;\u4404\u0380HJacfos\u07E4\u07E8\u07EC\u07F1\u07FD\u0802\u0808cy;\u4425cy;\u440Cppa;\u439A\u0100ey\u07F6\u07FBdil;\u4136;\u441Ar;\uC000\ud835\udd0epf;\uC000\ud835\udd42cr;\uC000\ud835\udca6\u0580JTaceflmost\u0825\u0829\u082C\u0850\u0863\u09B3\u09B8\u09C7\u09CD\u0A37\u0A47cy;\u4409\u803B<\u403C\u0280cmnpr\u0837\u083C\u0841\u0844\u084Dute;\u4139bda;\u439Bg;\u67EAlacetrf;\u6112r;\u619E\u0180aey\u0857\u085C\u0861ron;\u413Ddil;\u413B;\u441B\u0100fs\u0868\u0970t\u0500ACDFRTUVar\u087E\u08A9\u08B1\u08E0\u08E6\u08FC\u092F\u095B\u0390\u096A\u0100nr\u0883\u088FgleBracket;\u67E8row\u0180;BR\u0899\u089A\u089E\u6190ar;\u61E4ightArrow;\u61C6eiling;\u6308o\u01F5\u08B7\x00\u08C3bleBracket;\u67E6n\u01D4\u08C8\x00\u08D2eeVector;\u6961ector\u0100;B\u08DB\u08DC\u61C3ar;\u6959loor;\u630Aight\u0100AV\u08EF\u08F5rrow;\u6194ector;\u694E\u0100er\u0901\u0917e\u0180;AV\u0909\u090A\u0910\u62A3rrow;\u61A4ector;\u695Aiangle\u0180;BE\u0924\u0925\u0929\u62B2ar;\u69CFqual;\u62B4p\u0180DTV\u0937\u0942\u094CownVector;\u6951eeVector;\u6960ector\u0100;B\u0956\u0957\u61BFar;\u6958ector\u0100;B\u0965\u0966\u61BCar;\u6952ight\xe1\u039Cs\u0300EFGLST\u097E\u098B\u0995\u099D\u09A2\u09ADqualGreater;\u62DAullEqual;\u6266reater;\u6276ess;\u6AA1lantEqual;\u6A7Dilde;\u6272r;\uC000\ud835\udd0f\u0100;e\u09BD\u09BE\u62D8ftarrow;\u61DAidot;\u413F\u0180npw\u09D4\u0A16\u0A1Bg\u0200LRlr\u09DE\u09F7\u0A02\u0A10eft\u0100AR\u09E6\u09ECrrow;\u67F5ightArrow;\u67F7ightArrow;\u67F6eft\u0100ar\u03B3\u0A0Aight\xe1\u03BFight\xe1\u03CAf;\uC000\ud835\udd43er\u0100LR\u0A22\u0A2CeftArrow;\u6199ightArrow;\u6198\u0180cht\u0A3E\u0A40\u0A42\xf2\u084C;\u61B0rok;\u4141;\u626A\u0400acefiosu\u0A5A\u0A5D\u0A60\u0A77\u0A7C\u0A85\u0A8B\u0A8Ep;\u6905y;\u441C\u0100dl\u0A65\u0A6FiumSpace;\u605Flintrf;\u6133r;\uC000\ud835\udd10nusPlus;\u6213pf;\uC000\ud835\udd44c\xf2\u0A76;\u439C\u0480Jacefostu\u0AA3\u0AA7\u0AAD\u0AC0\u0B14\u0B19\u0D91\u0D97\u0D9Ecy;\u440Acute;\u4143\u0180aey\u0AB4\u0AB9\u0ABEron;\u4147dil;\u4145;\u441D\u0180gsw\u0AC7\u0AF0\u0B0Eative\u0180MTV\u0AD3\u0ADF\u0AE8ediumSpace;\u600Bhi\u0100cn\u0AE6\u0AD8\xeb\u0AD9eryThi\xee\u0AD9ted\u0100GL\u0AF8\u0B06reaterGreate\xf2\u0673essLes\xf3\u0A48Line;\u400Ar;\uC000\ud835\udd11\u0200Bnpt\u0B22\u0B28\u0B37\u0B3Areak;\u6060BreakingSpace;\u40A0f;\u6115\u0680;CDEGHLNPRSTV\u0B55\u0B56\u0B6A\u0B7C\u0BA1\u0BEB\u0C04\u0C5E\u0C84\u0CA6\u0CD8\u0D61\u0D85\u6AEC\u0100ou\u0B5B\u0B64ngruent;\u6262pCap;\u626DoubleVerticalBar;\u6226\u0180lqx\u0B83\u0B8A\u0B9Bement;\u6209ual\u0100;T\u0B92\u0B93\u6260ilde;\uC000\u2242\u0338ists;\u6204reater\u0380;EFGLST\u0BB6\u0BB7\u0BBD\u0BC9\u0BD3\u0BD8\u0BE5\u626Fqual;\u6271ullEqual;\uC000\u2267\u0338reater;\uC000\u226B\u0338ess;\u6279lantEqual;\uC000\u2A7E\u0338ilde;\u6275ump\u0144\u0BF2\u0BFDownHump;\uC000\u224E\u0338qual;\uC000\u224F\u0338e\u0100fs\u0C0A\u0C27tTriangle\u0180;BE\u0C1A\u0C1B\u0C21\u62EAar;\uC000\u29CF\u0338qual;\u62ECs\u0300;EGLST\u0C35\u0C36\u0C3C\u0C44\u0C4B\u0C58\u626Equal;\u6270reater;\u6278ess;\uC000\u226A\u0338lantEqual;\uC000\u2A7D\u0338ilde;\u6274ested\u0100GL\u0C68\u0C79reaterGreater;\uC000\u2AA2\u0338essLess;\uC000\u2AA1\u0338recedes\u0180;ES\u0C92\u0C93\u0C9B\u6280qual;\uC000\u2AAF\u0338lantEqual;\u62E0\u0100ei\u0CAB\u0CB9verseElement;\u620CghtTriangle\u0180;BE\u0CCB\u0CCC\u0CD2\u62EBar;\uC000\u29D0\u0338qual;\u62ED\u0100qu\u0CDD\u0D0CuareSu\u0100bp\u0CE8\u0CF9set\u0100;E\u0CF0\u0CF3\uC000\u228F\u0338qual;\u62E2erset\u0100;E\u0D03\u0D06\uC000\u2290\u0338qual;\u62E3\u0180bcp\u0D13\u0D24\u0D4Eset\u0100;E\u0D1B\u0D1E\uC000\u2282\u20D2qual;\u6288ceeds\u0200;EST\u0D32\u0D33\u0D3B\u0D46\u6281qual;\uC000\u2AB0\u0338lantEqual;\u62E1ilde;\uC000\u227F\u0338erset\u0100;E\u0D58\u0D5B\uC000\u2283\u20D2qual;\u6289ilde\u0200;EFT\u0D6E\u0D6F\u0D75\u0D7F\u6241qual;\u6244ullEqual;\u6247ilde;\u6249erticalBar;\u6224cr;\uC000\ud835\udca9ilde\u803B\xd1\u40D1;\u439D\u0700Eacdfgmoprstuv\u0DBD\u0DC2\u0DC9\u0DD5\u0DDB\u0DE0\u0DE7\u0DFC\u0E02\u0E20\u0E22\u0E32\u0E3F\u0E44lig;\u4152cute\u803B\xd3\u40D3\u0100iy\u0DCE\u0DD3rc\u803B\xd4\u40D4;\u441Eblac;\u4150r;\uC000\ud835\udd12rave\u803B\xd2\u40D2\u0180aei\u0DEE\u0DF2\u0DF6cr;\u414Cga;\u43A9cron;\u439Fpf;\uC000\ud835\udd46enCurly\u0100DQ\u0E0E\u0E1AoubleQuote;\u601Cuote;\u6018;\u6A54\u0100cl\u0E27\u0E2Cr;\uC000\ud835\udcaaash\u803B\xd8\u40D8i\u016C\u0E37\u0E3Cde\u803B\xd5\u40D5es;\u6A37ml\u803B\xd6\u40D6er\u0100BP\u0E4B\u0E60\u0100ar\u0E50\u0E53r;\u603Eac\u0100ek\u0E5A\u0E5C;\u63DEet;\u63B4arenthesis;\u63DC\u0480acfhilors\u0E7F\u0E87\u0E8A\u0E8F\u0E92\u0E94\u0E9D\u0EB0\u0EFCrtialD;\u6202y;\u441Fr;\uC000\ud835\udd13i;\u43A6;\u43A0usMinus;\u40B1\u0100ip\u0EA2\u0EADncareplan\xe5\u069Df;\u6119\u0200;eio\u0EB9\u0EBA\u0EE0\u0EE4\u6ABBcedes\u0200;EST\u0EC8\u0EC9\u0ECF\u0EDA\u627Aqual;\u6AAFlantEqual;\u627Cilde;\u627Eme;\u6033\u0100dp\u0EE9\u0EEEuct;\u620Fortion\u0100;a\u0225\u0EF9l;\u621D\u0100ci\u0F01\u0F06r;\uC000\ud835\udcab;\u43A8\u0200Ufos\u0F11\u0F16\u0F1B\u0F1FOT\u803B"\u4022r;\uC000\ud835\udd14pf;\u611Acr;\uC000\ud835\udcac\u0600BEacefhiorsu\u0F3E\u0F43\u0F47\u0F60\u0F73\u0FA7\u0FAA\u0FAD\u1096\u10A9\u10B4\u10BEarr;\u6910G\u803B\xae\u40AE\u0180cnr\u0F4E\u0F53\u0F56ute;\u4154g;\u67EBr\u0100;t\u0F5C\u0F5D\u61A0l;\u6916\u0180aey\u0F67\u0F6C\u0F71ron;\u4158dil;\u4156;\u4420\u0100;v\u0F78\u0F79\u611Cerse\u0100EU\u0F82\u0F99\u0100lq\u0F87\u0F8Eement;\u620Builibrium;\u61CBpEquilibrium;\u696Fr\xbb\u0F79o;\u43A1ght\u0400ACDFTUVa\u0FC1\u0FEB\u0FF3\u1022\u1028\u105B\u1087\u03D8\u0100nr\u0FC6\u0FD2gleBracket;\u67E9row\u0180;BL\u0FDC\u0FDD\u0FE1\u6192ar;\u61E5eftArrow;\u61C4eiling;\u6309o\u01F5\u0FF9\x00\u1005bleBracket;\u67E7n\u01D4\u100A\x00\u1014eeVector;\u695Dector\u0100;B\u101D\u101E\u61C2ar;\u6955loor;\u630B\u0100er\u102D\u1043e\u0180;AV\u1035\u1036\u103C\u62A2rrow;\u61A6ector;\u695Biangle\u0180;BE\u1050\u1051\u1055\u62B3ar;\u69D0qual;\u62B5p\u0180DTV\u1063\u106E\u1078ownVector;\u694FeeVector;\u695Cector\u0100;B\u1082\u1083\u61BEar;\u6954ector\u0100;B\u1091\u1092\u61C0ar;\u6953\u0100pu\u109B\u109Ef;\u611DndImplies;\u6970ightarrow;\u61DB\u0100ch\u10B9\u10BCr;\u611B;\u61B1leDelayed;\u69F4\u0680HOacfhimoqstu\u10E4\u10F1\u10F7\u10FD\u1119\u111E\u1151\u1156\u1161\u1167\u11B5\u11BB\u11BF\u0100Cc\u10E9\u10EEHcy;\u4429y;\u4428FTcy;\u442Ccute;\u415A\u0280;aeiy\u1108\u1109\u110E\u1113\u1117\u6ABCron;\u4160dil;\u415Erc;\u415C;\u4421r;\uC000\ud835\udd16ort\u0200DLRU\u112A\u1134\u113E\u1149ownArrow\xbb\u041EeftArrow\xbb\u089AightArrow\xbb\u0FDDpArrow;\u6191gma;\u43A3allCircle;\u6218pf;\uC000\ud835\udd4a\u0272\u116D\x00\x00\u1170t;\u621Aare\u0200;ISU\u117B\u117C\u1189\u11AF\u65A1ntersection;\u6293u\u0100bp\u118F\u119Eset\u0100;E\u1197\u1198\u628Fqual;\u6291erset\u0100;E\u11A8\u11A9\u6290qual;\u6292nion;\u6294cr;\uC000\ud835\udcaear;\u62C6\u0200bcmp\u11C8\u11DB\u1209\u120B\u0100;s\u11CD\u11CE\u62D0et\u0100;E\u11CD\u11D5qual;\u6286\u0100ch\u11E0\u1205eeds\u0200;EST\u11ED\u11EE\u11F4\u11FF\u627Bqual;\u6AB0lantEqual;\u627Dilde;\u627FTh\xe1\u0F8C;\u6211\u0180;es\u1212\u1213\u1223\u62D1rset\u0100;E\u121C\u121D\u6283qual;\u6287et\xbb\u1213\u0580HRSacfhiors\u123E\u1244\u1249\u1255\u125E\u1271\u1276\u129F\u12C2\u12C8\u12D1ORN\u803B\xde\u40DEADE;\u6122\u0100Hc\u124E\u1252cy;\u440By;\u4426\u0100bu\u125A\u125C;\u4009;\u43A4\u0180aey\u1265\u126A\u126Fron;\u4164dil;\u4162;\u4422r;\uC000\ud835\udd17\u0100ei\u127B\u1289\u01F2\u1280\x00\u1287efore;\u6234a;\u4398\u0100cn\u128E\u1298kSpace;\uC000\u205F\u200ASpace;\u6009lde\u0200;EFT\u12AB\u12AC\u12B2\u12BC\u623Cqual;\u6243ullEqual;\u6245ilde;\u6248pf;\uC000\ud835\udd4bipleDot;\u60DB\u0100ct\u12D6\u12DBr;\uC000\ud835\udcafrok;\u4166\u0AE1\u12F7\u130E\u131A\u1326\x00\u132C\u1331\x00\x00\x00\x00\x00\u1338\u133D\u1377\u1385\x00\u13FF\u1404\u140A\u1410\u0100cr\u12FB\u1301ute\u803B\xda\u40DAr\u0100;o\u1307\u1308\u619Fcir;\u6949r\u01E3\u1313\x00\u1316y;\u440Eve;\u416C\u0100iy\u131E\u1323rc\u803B\xdb\u40DB;\u4423blac;\u4170r;\uC000\ud835\udd18rave\u803B\xd9\u40D9acr;\u416A\u0100di\u1341\u1369er\u0100BP\u1348\u135D\u0100ar\u134D\u1350r;\u405Fac\u0100ek\u1357\u1359;\u63DFet;\u63B5arenthesis;\u63DDon\u0100;P\u1370\u1371\u62C3lus;\u628E\u0100gp\u137B\u137Fon;\u4172f;\uC000\ud835\udd4c\u0400ADETadps\u1395\u13AE\u13B8\u13C4\u03E8\u13D2\u13D7\u13F3rrow\u0180;BD\u1150\u13A0\u13A4ar;\u6912ownArrow;\u61C5ownArrow;\u6195quilibrium;\u696Eee\u0100;A\u13CB\u13CC\u62A5rrow;\u61A5own\xe1\u03F3er\u0100LR\u13DE\u13E8eftArrow;\u6196ightArrow;\u6197i\u0100;l\u13F9\u13FA\u43D2on;\u43A5ing;\u416Ecr;\uC000\ud835\udcb0ilde;\u4168ml\u803B\xdc\u40DC\u0480Dbcdefosv\u1427\u142C\u1430\u1433\u143E\u1485\u148A\u1490\u1496ash;\u62ABar;\u6AEBy;\u4412ash\u0100;l\u143B\u143C\u62A9;\u6AE6\u0100er\u1443\u1445;\u62C1\u0180bty\u144C\u1450\u147Aar;\u6016\u0100;i\u144F\u1455cal\u0200BLST\u1461\u1465\u146A\u1474ar;\u6223ine;\u407Ceparator;\u6758ilde;\u6240ThinSpace;\u600Ar;\uC000\ud835\udd19pf;\uC000\ud835\udd4dcr;\uC000\ud835\udcb1dash;\u62AA\u0280cefos\u14A7\u14AC\u14B1\u14B6\u14BCirc;\u4174dge;\u62C0r;\uC000\ud835\udd1apf;\uC000\ud835\udd4ecr;\uC000\ud835\udcb2\u0200fios\u14CB\u14D0\u14D2\u14D8r;\uC000\ud835\udd1b;\u439Epf;\uC000\ud835\udd4fcr;\uC000\ud835\udcb3\u0480AIUacfosu\u14F1\u14F5\u14F9\u14FD\u1504\u150F\u1514\u151A\u1520cy;\u442Fcy;\u4407cy;\u442Ecute\u803B\xdd\u40DD\u0100iy\u1509\u150Drc;\u4176;\u442Br;\uC000\ud835\udd1cpf;\uC000\ud835\udd50cr;\uC000\ud835\udcb4ml;\u4178\u0400Hacdefos\u1535\u1539\u153F\u154B\u154F\u155D\u1560\u1564cy;\u4416cute;\u4179\u0100ay\u1544\u1549ron;\u417D;\u4417ot;\u417B\u01F2\u1554\x00\u155BoWidt\xe8\u0AD9a;\u4396r;\u6128pf;\u6124cr;\uC000\ud835\udcb5\u0BE1\u1583\u158A\u1590\x00\u15B0\u15B6\u15BF\x00\x00\x00\x00\u15C6\u15DB\u15EB\u165F\u166D\x00\u1695\u169B\u16B2\u16B9\x00\u16BEcute\u803B\xe1\u40E1reve;\u4103\u0300;Ediuy\u159C\u159D\u15A1\u15A3\u15A8\u15AD\u623E;\uC000\u223E\u0333;\u623Frc\u803B\xe2\u40E2te\u80BB\xb4\u0306;\u4430lig\u803B\xe6\u40E6\u0100;r\xb2\u15BA;\uC000\ud835\udd1erave\u803B\xe0\u40E0\u0100ep\u15CA\u15D6\u0100fp\u15CF\u15D4sym;\u6135\xe8\u15D3ha;\u43B1\u0100ap\u15DFc\u0100cl\u15E4\u15E7r;\u4101g;\u6A3F\u0264\u15F0\x00\x00\u160A\u0280;adsv\u15FA\u15FB\u15FF\u1601\u1607\u6227nd;\u6A55;\u6A5Clope;\u6A58;\u6A5A\u0380;elmrsz\u1618\u1619\u161B\u161E\u163F\u164F\u1659\u6220;\u69A4e\xbb\u1619sd\u0100;a\u1625\u1626\u6221\u0461\u1630\u1632\u1634\u1636\u1638\u163A\u163C\u163E;\u69A8;\u69A9;\u69AA;\u69AB;\u69AC;\u69AD;\u69AE;\u69AFt\u0100;v\u1645\u1646\u621Fb\u0100;d\u164C\u164D\u62BE;\u699D\u0100pt\u1654\u1657h;\u6222\xbb\xb9arr;\u637C\u0100gp\u1663\u1667on;\u4105f;\uC000\ud835\udd52\u0380;Eaeiop\u12C1\u167B\u167D\u1682\u1684\u1687\u168A;\u6A70cir;\u6A6F;\u624Ad;\u624Bs;\u4027rox\u0100;e\u12C1\u1692\xf1\u1683ing\u803B\xe5\u40E5\u0180cty\u16A1\u16A6\u16A8r;\uC000\ud835\udcb6;\u402Amp\u0100;e\u12C1\u16AF\xf1\u0288ilde\u803B\xe3\u40E3ml\u803B\xe4\u40E4\u0100ci\u16C2\u16C8onin\xf4\u0272nt;\u6A11\u0800Nabcdefiklnoprsu\u16ED\u16F1\u1730\u173C\u1743\u1748\u1778\u177D\u17E0\u17E6\u1839\u1850\u170D\u193D\u1948\u1970ot;\u6AED\u0100cr\u16F6\u171Ek\u0200ceps\u1700\u1705\u170D\u1713ong;\u624Cpsilon;\u43F6rime;\u6035im\u0100;e\u171A\u171B\u623Dq;\u62CD\u0176\u1722\u1726ee;\u62BDed\u0100;g\u172C\u172D\u6305e\xbb\u172Drk\u0100;t\u135C\u1737brk;\u63B6\u0100oy\u1701\u1741;\u4431quo;\u601E\u0280cmprt\u1753\u175B\u1761\u1764\u1768aus\u0100;e\u010A\u0109ptyv;\u69B0s\xe9\u170Cno\xf5\u0113\u0180ahw\u176F\u1771\u1773;\u43B2;\u6136een;\u626Cr;\uC000\ud835\udd1fg\u0380costuvw\u178D\u179D\u17B3\u17C1\u17D5\u17DB\u17DE\u0180aiu\u1794\u1796\u179A\xf0\u0760rc;\u65EFp\xbb\u1371\u0180dpt\u17A4\u17A8\u17ADot;\u6A00lus;\u6A01imes;\u6A02\u0271\u17B9\x00\x00\u17BEcup;\u6A06ar;\u6605riangle\u0100du\u17CD\u17D2own;\u65BDp;\u65B3plus;\u6A04e\xe5\u1444\xe5\u14ADarow;\u690D\u0180ako\u17ED\u1826\u1835\u0100cn\u17F2\u1823k\u0180lst\u17FA\u05AB\u1802ozenge;\u69EBriangle\u0200;dlr\u1812\u1813\u1818\u181D\u65B4own;\u65BEeft;\u65C2ight;\u65B8k;\u6423\u01B1\u182B\x00\u1833\u01B2\u182F\x00\u1831;\u6592;\u65914;\u6593ck;\u6588\u0100eo\u183E\u184D\u0100;q\u1843\u1846\uC000=\u20E5uiv;\uC000\u2261\u20E5t;\u6310\u0200ptwx\u1859\u185E\u1867\u186Cf;\uC000\ud835\udd53\u0100;t\u13CB\u1863om\xbb\u13CCtie;\u62C8\u0600DHUVbdhmptuv\u1885\u1896\u18AA\u18BB\u18D7\u18DB\u18EC\u18FF\u1905\u190A\u1910\u1921\u0200LRlr\u188E\u1890\u1892\u1894;\u6557;\u6554;\u6556;\u6553\u0280;DUdu\u18A1\u18A2\u18A4\u18A6\u18A8\u6550;\u6566;\u6569;\u6564;\u6567\u0200LRlr\u18B3\u18B5\u18B7\u18B9;\u655D;\u655A;\u655C;\u6559\u0380;HLRhlr\u18CA\u18CB\u18CD\u18CF\u18D1\u18D3\u18D5\u6551;\u656C;\u6563;\u6560;\u656B;\u6562;\u655Fox;\u69C9\u0200LRlr\u18E4\u18E6\u18E8\u18EA;\u6555;\u6552;\u6510;\u650C\u0280;DUdu\u06BD\u18F7\u18F9\u18FB\u18FD;\u6565;\u6568;\u652C;\u6534inus;\u629Flus;\u629Eimes;\u62A0\u0200LRlr\u1919\u191B\u191D\u191F;\u655B;\u6558;\u6518;\u6514\u0380;HLRhlr\u1930\u1931\u1933\u1935\u1937\u1939\u193B\u6502;\u656A;\u6561;\u655E;\u653C;\u6524;\u651C\u0100ev\u0123\u1942bar\u803B\xa6\u40A6\u0200ceio\u1951\u1956\u195A\u1960r;\uC000\ud835\udcb7mi;\u604Fm\u0100;e\u171A\u171Cl\u0180;bh\u1968\u1969\u196B\u405C;\u69C5sub;\u67C8\u016C\u1974\u197El\u0100;e\u1979\u197A\u6022t\xbb\u197Ap\u0180;Ee\u012F\u1985\u1987;\u6AAE\u0100;q\u06DC\u06DB\u0CE1\u19A7\x00\u19E8\u1A11\u1A15\u1A32\x00\u1A37\u1A50\x00\x00\u1AB4\x00\x00\u1AC1\x00\x00\u1B21\u1B2E\u1B4D\u1B52\x00\u1BFD\x00\u1C0C\u0180cpr\u19AD\u19B2\u19DDute;\u4107\u0300;abcds\u19BF\u19C0\u19C4\u19CA\u19D5\u19D9\u6229nd;\u6A44rcup;\u6A49\u0100au\u19CF\u19D2p;\u6A4Bp;\u6A47ot;\u6A40;\uC000\u2229\uFE00\u0100eo\u19E2\u19E5t;\u6041\xee\u0693\u0200aeiu\u19F0\u19FB\u1A01\u1A05\u01F0\u19F5\x00\u19F8s;\u6A4Don;\u410Ddil\u803B\xe7\u40E7rc;\u4109ps\u0100;s\u1A0C\u1A0D\u6A4Cm;\u6A50ot;\u410B\u0180dmn\u1A1B\u1A20\u1A26il\u80BB\xb8\u01ADptyv;\u69B2t\u8100\xa2;e\u1A2D\u1A2E\u40A2r\xe4\u01B2r;\uC000\ud835\udd20\u0180cei\u1A3D\u1A40\u1A4Dy;\u4447ck\u0100;m\u1A47\u1A48\u6713ark\xbb\u1A48;\u43C7r\u0380;Ecefms\u1A5F\u1A60\u1A62\u1A6B\u1AA4\u1AAA\u1AAE\u65CB;\u69C3\u0180;el\u1A69\u1A6A\u1A6D\u42C6q;\u6257e\u0261\u1A74\x00\x00\u1A88rrow\u0100lr\u1A7C\u1A81eft;\u61BAight;\u61BB\u0280RSacd\u1A92\u1A94\u1A96\u1A9A\u1A9F\xbb\u0F47;\u64C8st;\u629Birc;\u629Aash;\u629Dnint;\u6A10id;\u6AEFcir;\u69C2ubs\u0100;u\u1ABB\u1ABC\u6663it\xbb\u1ABC\u02EC\u1AC7\u1AD4\u1AFA\x00\u1B0Aon\u0100;e\u1ACD\u1ACE\u403A\u0100;q\xc7\xc6\u026D\u1AD9\x00\x00\u1AE2a\u0100;t\u1ADE\u1ADF\u402C;\u4040\u0180;fl\u1AE8\u1AE9\u1AEB\u6201\xee\u1160e\u0100mx\u1AF1\u1AF6ent\xbb\u1AE9e\xf3\u024D\u01E7\u1AFE\x00\u1B07\u0100;d\u12BB\u1B02ot;\u6A6Dn\xf4\u0246\u0180fry\u1B10\u1B14\u1B17;\uC000\ud835\udd54o\xe4\u0254\u8100\xa9;s\u0155\u1B1Dr;\u6117\u0100ao\u1B25\u1B29rr;\u61B5ss;\u6717\u0100cu\u1B32\u1B37r;\uC000\ud835\udcb8\u0100bp\u1B3C\u1B44\u0100;e\u1B41\u1B42\u6ACF;\u6AD1\u0100;e\u1B49\u1B4A\u6AD0;\u6AD2dot;\u62EF\u0380delprvw\u1B60\u1B6C\u1B77\u1B82\u1BAC\u1BD4\u1BF9arr\u0100lr\u1B68\u1B6A;\u6938;\u6935\u0270\u1B72\x00\x00\u1B75r;\u62DEc;\u62DFarr\u0100;p\u1B7F\u1B80\u61B6;\u693D\u0300;bcdos\u1B8F\u1B90\u1B96\u1BA1\u1BA5\u1BA8\u622Arcap;\u6A48\u0100au\u1B9B\u1B9Ep;\u6A46p;\u6A4Aot;\u628Dr;\u6A45;\uC000\u222A\uFE00\u0200alrv\u1BB5\u1BBF\u1BDE\u1BE3rr\u0100;m\u1BBC\u1BBD\u61B7;\u693Cy\u0180evw\u1BC7\u1BD4\u1BD8q\u0270\u1BCE\x00\x00\u1BD2re\xe3\u1B73u\xe3\u1B75ee;\u62CEedge;\u62CFen\u803B\xa4\u40A4earrow\u0100lr\u1BEE\u1BF3eft\xbb\u1B80ight\xbb\u1BBDe\xe4\u1BDD\u0100ci\u1C01\u1C07onin\xf4\u01F7nt;\u6231lcty;\u632D\u0980AHabcdefhijlorstuwz\u1C38\u1C3B\u1C3F\u1C5D\u1C69\u1C75\u1C8A\u1C9E\u1CAC\u1CB7\u1CFB\u1CFF\u1D0D\u1D7B\u1D91\u1DAB\u1DBB\u1DC6\u1DCDr\xf2\u0381ar;\u6965\u0200glrs\u1C48\u1C4D\u1C52\u1C54ger;\u6020eth;\u6138\xf2\u1133h\u0100;v\u1C5A\u1C5B\u6010\xbb\u090A\u016B\u1C61\u1C67arow;\u690Fa\xe3\u0315\u0100ay\u1C6E\u1C73ron;\u410F;\u4434\u0180;ao\u0332\u1C7C\u1C84\u0100gr\u02BF\u1C81r;\u61CAtseq;\u6A77\u0180glm\u1C91\u1C94\u1C98\u803B\xb0\u40B0ta;\u43B4ptyv;\u69B1\u0100ir\u1CA3\u1CA8sht;\u697F;\uC000\ud835\udd21ar\u0100lr\u1CB3\u1CB5\xbb\u08DC\xbb\u101E\u0280aegsv\u1CC2\u0378\u1CD6\u1CDC\u1CE0m\u0180;os\u0326\u1CCA\u1CD4nd\u0100;s\u0326\u1CD1uit;\u6666amma;\u43DDin;\u62F2\u0180;io\u1CE7\u1CE8\u1CF8\u40F7de\u8100\xf7;o\u1CE7\u1CF0ntimes;\u62C7n\xf8\u1CF7cy;\u4452c\u026F\u1D06\x00\x00\u1D0Arn;\u631Eop;\u630D\u0280lptuw\u1D18\u1D1D\u1D22\u1D49\u1D55lar;\u4024f;\uC000\ud835\udd55\u0280;emps\u030B\u1D2D\u1D37\u1D3D\u1D42q\u0100;d\u0352\u1D33ot;\u6251inus;\u6238lus;\u6214quare;\u62A1blebarwedg\xe5\xfan\u0180adh\u112E\u1D5D\u1D67ownarrow\xf3\u1C83arpoon\u0100lr\u1D72\u1D76ef\xf4\u1CB4igh\xf4\u1CB6\u0162\u1D7F\u1D85karo\xf7\u0F42\u026F\u1D8A\x00\x00\u1D8Ern;\u631Fop;\u630C\u0180cot\u1D98\u1DA3\u1DA6\u0100ry\u1D9D\u1DA1;\uC000\ud835\udcb9;\u4455l;\u69F6rok;\u4111\u0100dr\u1DB0\u1DB4ot;\u62F1i\u0100;f\u1DBA\u1816\u65BF\u0100ah\u1DC0\u1DC3r\xf2\u0429a\xf2\u0FA6angle;\u69A6\u0100ci\u1DD2\u1DD5y;\u445Fgrarr;\u67FF\u0900Dacdefglmnopqrstux\u1E01\u1E09\u1E19\u1E38\u0578\u1E3C\u1E49\u1E61\u1E7E\u1EA5\u1EAF\u1EBD\u1EE1\u1F2A\u1F37\u1F44\u1F4E\u1F5A\u0100Do\u1E06\u1D34o\xf4\u1C89\u0100cs\u1E0E\u1E14ute\u803B\xe9\u40E9ter;\u6A6E\u0200aioy\u1E22\u1E27\u1E31\u1E36ron;\u411Br\u0100;c\u1E2D\u1E2E\u6256\u803B\xea\u40EAlon;\u6255;\u444Dot;\u4117\u0100Dr\u1E41\u1E45ot;\u6252;\uC000\ud835\udd22\u0180;rs\u1E50\u1E51\u1E57\u6A9Aave\u803B\xe8\u40E8\u0100;d\u1E5C\u1E5D\u6A96ot;\u6A98\u0200;ils\u1E6A\u1E6B\u1E72\u1E74\u6A99nters;\u63E7;\u6113\u0100;d\u1E79\u1E7A\u6A95ot;\u6A97\u0180aps\u1E85\u1E89\u1E97cr;\u4113ty\u0180;sv\u1E92\u1E93\u1E95\u6205et\xbb\u1E93p\u01001;\u1E9D\u1EA4\u0133\u1EA1\u1EA3;\u6004;\u6005\u6003\u0100gs\u1EAA\u1EAC;\u414Bp;\u6002\u0100gp\u1EB4\u1EB8on;\u4119f;\uC000\ud835\udd56\u0180als\u1EC4\u1ECE\u1ED2r\u0100;s\u1ECA\u1ECB\u62D5l;\u69E3us;\u6A71i\u0180;lv\u1EDA\u1EDB\u1EDF\u43B5on\xbb\u1EDB;\u43F5\u0200csuv\u1EEA\u1EF3\u1F0B\u1F23\u0100io\u1EEF\u1E31rc\xbb\u1E2E\u0269\u1EF9\x00\x00\u1EFB\xed\u0548ant\u0100gl\u1F02\u1F06tr\xbb\u1E5Dess\xbb\u1E7A\u0180aei\u1F12\u1F16\u1F1Als;\u403Dst;\u625Fv\u0100;D\u0235\u1F20D;\u6A78parsl;\u69E5\u0100Da\u1F2F\u1F33ot;\u6253rr;\u6971\u0180cdi\u1F3E\u1F41\u1EF8r;\u612Fo\xf4\u0352\u0100ah\u1F49\u1F4B;\u43B7\u803B\xf0\u40F0\u0100mr\u1F53\u1F57l\u803B\xeb\u40EBo;\u60AC\u0180cip\u1F61\u1F64\u1F67l;\u4021s\xf4\u056E\u0100eo\u1F6C\u1F74ctatio\xee\u0559nential\xe5\u0579\u09E1\u1F92\x00\u1F9E\x00\u1FA1\u1FA7\x00\x00\u1FC6\u1FCC\x00\u1FD3\x00\u1FE6\u1FEA\u2000\x00\u2008\u205Allingdotse\xf1\u1E44y;\u4444male;\u6640\u0180ilr\u1FAD\u1FB3\u1FC1lig;\u8000\uFB03\u0269\u1FB9\x00\x00\u1FBDg;\u8000\uFB00ig;\u8000\uFB04;\uC000\ud835\udd23lig;\u8000\uFB01lig;\uC000fj\u0180alt\u1FD9\u1FDC\u1FE1t;\u666Dig;\u8000\uFB02ns;\u65B1of;\u4192\u01F0\u1FEE\x00\u1FF3f;\uC000\ud835\udd57\u0100ak\u05BF\u1FF7\u0100;v\u1FFC\u1FFD\u62D4;\u6AD9artint;\u6A0D\u0100ao\u200C\u2055\u0100cs\u2011\u2052\u03B1\u201A\u2030\u2038\u2045\u2048\x00\u2050\u03B2\u2022\u2025\u2027\u202A\u202C\x00\u202E\u803B\xbd\u40BD;\u6153\u803B\xbc\u40BC;\u6155;\u6159;\u615B\u01B3\u2034\x00\u2036;\u6154;\u6156\u02B4\u203E\u2041\x00\x00\u2043\u803B\xbe\u40BE;\u6157;\u615C5;\u6158\u01B6\u204C\x00\u204E;\u615A;\u615D8;\u615El;\u6044wn;\u6322cr;\uC000\ud835\udcbb\u0880Eabcdefgijlnorstv\u2082\u2089\u209F\u20A5\u20B0\u20B4\u20F0\u20F5\u20FA\u20FF\u2103\u2112\u2138\u0317\u213E\u2152\u219E\u0100;l\u064D\u2087;\u6A8C\u0180cmp\u2090\u2095\u209Dute;\u41F5ma\u0100;d\u209C\u1CDA\u43B3;\u6A86reve;\u411F\u0100iy\u20AA\u20AErc;\u411D;\u4433ot;\u4121\u0200;lqs\u063E\u0642\u20BD\u20C9\u0180;qs\u063E\u064C\u20C4lan\xf4\u0665\u0200;cdl\u0665\u20D2\u20D5\u20E5c;\u6AA9ot\u0100;o\u20DC\u20DD\u6A80\u0100;l\u20E2\u20E3\u6A82;\u6A84\u0100;e\u20EA\u20ED\uC000\u22DB\uFE00s;\u6A94r;\uC000\ud835\udd24\u0100;g\u0673\u061Bmel;\u6137cy;\u4453\u0200;Eaj\u065A\u210C\u210E\u2110;\u6A92;\u6AA5;\u6AA4\u0200Eaes\u211B\u211D\u2129\u2134;\u6269p\u0100;p\u2123\u2124\u6A8Arox\xbb\u2124\u0100;q\u212E\u212F\u6A88\u0100;q\u212E\u211Bim;\u62E7pf;\uC000\ud835\udd58\u0100ci\u2143\u2146r;\u610Am\u0180;el\u066B\u214E\u2150;\u6A8E;\u6A90\u8300>;cdlqr\u05EE\u2160\u216A\u216E\u2173\u2179\u0100ci\u2165\u2167;\u6AA7r;\u6A7Aot;\u62D7Par;\u6995uest;\u6A7C\u0280adels\u2184\u216A\u2190\u0656\u219B\u01F0\u2189\x00\u218Epro\xf8\u209Er;\u6978q\u0100lq\u063F\u2196les\xf3\u2088i\xed\u066B\u0100en\u21A3\u21ADrtneqq;\uC000\u2269\uFE00\xc5\u21AA\u0500Aabcefkosy\u21C4\u21C7\u21F1\u21F5\u21FA\u2218\u221D\u222F\u2268\u227Dr\xf2\u03A0\u0200ilmr\u21D0\u21D4\u21D7\u21DBrs\xf0\u1484f\xbb\u2024il\xf4\u06A9\u0100dr\u21E0\u21E4cy;\u444A\u0180;cw\u08F4\u21EB\u21EFir;\u6948;\u61ADar;\u610Firc;\u4125\u0180alr\u2201\u220E\u2213rts\u0100;u\u2209\u220A\u6665it\xbb\u220Alip;\u6026con;\u62B9r;\uC000\ud835\udd25s\u0100ew\u2223\u2229arow;\u6925arow;\u6926\u0280amopr\u223A\u223E\u2243\u225E\u2263rr;\u61FFtht;\u623Bk\u0100lr\u2249\u2253eftarrow;\u61A9ightarrow;\u61AAf;\uC000\ud835\udd59bar;\u6015\u0180clt\u226F\u2274\u2278r;\uC000\ud835\udcbdas\xe8\u21F4rok;\u4127\u0100bp\u2282\u2287ull;\u6043hen\xbb\u1C5B\u0AE1\u22A3\x00\u22AA\x00\u22B8\u22C5\u22CE\x00\u22D5\u22F3\x00\x00\u22F8\u2322\u2367\u2362\u237F\x00\u2386\u23AA\u23B4cute\u803B\xed\u40ED\u0180;iy\u0771\u22B0\u22B5rc\u803B\xee\u40EE;\u4438\u0100cx\u22BC\u22BFy;\u4435cl\u803B\xa1\u40A1\u0100fr\u039F\u22C9;\uC000\ud835\udd26rave\u803B\xec\u40EC\u0200;ino\u073E\u22DD\u22E9\u22EE\u0100in\u22E2\u22E6nt;\u6A0Ct;\u622Dfin;\u69DCta;\u6129lig;\u4133\u0180aop\u22FE\u231A\u231D\u0180cgt\u2305\u2308\u2317r;\u412B\u0180elp\u071F\u230F\u2313in\xe5\u078Ear\xf4\u0720h;\u4131f;\u62B7ed;\u41B5\u0280;cfot\u04F4\u232C\u2331\u233D\u2341are;\u6105in\u0100;t\u2338\u2339\u621Eie;\u69DDdo\xf4\u2319\u0280;celp\u0757\u234C\u2350\u235B\u2361al;\u62BA\u0100gr\u2355\u2359er\xf3\u1563\xe3\u234Darhk;\u6A17rod;\u6A3C\u0200cgpt\u236F\u2372\u2376\u237By;\u4451on;\u412Ff;\uC000\ud835\udd5aa;\u43B9uest\u803B\xbf\u40BF\u0100ci\u238A\u238Fr;\uC000\ud835\udcben\u0280;Edsv\u04F4\u239B\u239D\u23A1\u04F3;\u62F9ot;\u62F5\u0100;v\u23A6\u23A7\u62F4;\u62F3\u0100;i\u0777\u23AElde;\u4129\u01EB\u23B8\x00\u23BCcy;\u4456l\u803B\xef\u40EF\u0300cfmosu\u23CC\u23D7\u23DC\u23E1\u23E7\u23F5\u0100iy\u23D1\u23D5rc;\u4135;\u4439r;\uC000\ud835\udd27ath;\u4237pf;\uC000\ud835\udd5b\u01E3\u23EC\x00\u23F1r;\uC000\ud835\udcbfrcy;\u4458kcy;\u4454\u0400acfghjos\u240B\u2416\u2422\u2427\u242D\u2431\u2435\u243Bppa\u0100;v\u2413\u2414\u43BA;\u43F0\u0100ey\u241B\u2420dil;\u4137;\u443Ar;\uC000\ud835\udd28reen;\u4138cy;\u4445cy;\u445Cpf;\uC000\ud835\udd5ccr;\uC000\ud835\udcc0\u0B80ABEHabcdefghjlmnoprstuv\u2470\u2481\u2486\u248D\u2491\u250E\u253D\u255A\u2580\u264E\u265E\u2665\u2679\u267D\u269A\u26B2\u26D8\u275D\u2768\u278B\u27C0\u2801\u2812\u0180art\u2477\u247A\u247Cr\xf2\u09C6\xf2\u0395ail;\u691Barr;\u690E\u0100;g\u0994\u248B;\u6A8Bar;\u6962\u0963\u24A5\x00\u24AA\x00\u24B1\x00\x00\x00\x00\x00\u24B5\u24BA\x00\u24C6\u24C8\u24CD\x00\u24F9ute;\u413Amptyv;\u69B4ra\xee\u084Cbda;\u43BBg\u0180;dl\u088E\u24C1\u24C3;\u6991\xe5\u088E;\u6A85uo\u803B\xab\u40ABr\u0400;bfhlpst\u0899\u24DE\u24E6\u24E9\u24EB\u24EE\u24F1\u24F5\u0100;f\u089D\u24E3s;\u691Fs;\u691D\xeb\u2252p;\u61ABl;\u6939im;\u6973l;\u61A2\u0180;ae\u24FF\u2500\u2504\u6AABil;\u6919\u0100;s\u2509\u250A\u6AAD;\uC000\u2AAD\uFE00\u0180abr\u2515\u2519\u251Drr;\u690Crk;\u6772\u0100ak\u2522\u252Cc\u0100ek\u2528\u252A;\u407B;\u405B\u0100es\u2531\u2533;\u698Bl\u0100du\u2539\u253B;\u698F;\u698D\u0200aeuy\u2546\u254B\u2556\u2558ron;\u413E\u0100di\u2550\u2554il;\u413C\xec\u08B0\xe2\u2529;\u443B\u0200cqrs\u2563\u2566\u256D\u257Da;\u6936uo\u0100;r\u0E19\u1746\u0100du\u2572\u2577har;\u6967shar;\u694Bh;\u61B2\u0280;fgqs\u258B\u258C\u0989\u25F3\u25FF\u6264t\u0280ahlrt\u2598\u25A4\u25B7\u25C2\u25E8rrow\u0100;t\u0899\u25A1a\xe9\u24F6arpoon\u0100du\u25AF\u25B4own\xbb\u045Ap\xbb\u0966eftarrows;\u61C7ight\u0180ahs\u25CD\u25D6\u25DErrow\u0100;s\u08F4\u08A7arpoon\xf3\u0F98quigarro\xf7\u21F0hreetimes;\u62CB\u0180;qs\u258B\u0993\u25FAlan\xf4\u09AC\u0280;cdgs\u09AC\u260A\u260D\u261D\u2628c;\u6AA8ot\u0100;o\u2614\u2615\u6A7F\u0100;r\u261A\u261B\u6A81;\u6A83\u0100;e\u2622\u2625\uC000\u22DA\uFE00s;\u6A93\u0280adegs\u2633\u2639\u263D\u2649\u264Bppro\xf8\u24C6ot;\u62D6q\u0100gq\u2643\u2645\xf4\u0989gt\xf2\u248C\xf4\u099Bi\xed\u09B2\u0180ilr\u2655\u08E1\u265Asht;\u697C;\uC000\ud835\udd29\u0100;E\u099C\u2663;\u6A91\u0161\u2669\u2676r\u0100du\u25B2\u266E\u0100;l\u0965\u2673;\u696Alk;\u6584cy;\u4459\u0280;acht\u0A48\u2688\u268B\u2691\u2696r\xf2\u25C1orne\xf2\u1D08ard;\u696Bri;\u65FA\u0100io\u269F\u26A4dot;\u4140ust\u0100;a\u26AC\u26AD\u63B0che\xbb\u26AD\u0200Eaes\u26BB\u26BD\u26C9\u26D4;\u6268p\u0100;p\u26C3\u26C4\u6A89rox\xbb\u26C4\u0100;q\u26CE\u26CF\u6A87\u0100;q\u26CE\u26BBim;\u62E6\u0400abnoptwz\u26E9\u26F4\u26F7\u271A\u272F\u2741\u2747\u2750\u0100nr\u26EE\u26F1g;\u67ECr;\u61FDr\xeb\u08C1g\u0180lmr\u26FF\u270D\u2714eft\u0100ar\u09E6\u2707ight\xe1\u09F2apsto;\u67FCight\xe1\u09FDparrow\u0100lr\u2725\u2729ef\xf4\u24EDight;\u61AC\u0180afl\u2736\u2739\u273Dr;\u6985;\uC000\ud835\udd5dus;\u6A2Dimes;\u6A34\u0161\u274B\u274Fst;\u6217\xe1\u134E\u0180;ef\u2757\u2758\u1800\u65CAnge\xbb\u2758ar\u0100;l\u2764\u2765\u4028t;\u6993\u0280achmt\u2773\u2776\u277C\u2785\u2787r\xf2\u08A8orne\xf2\u1D8Car\u0100;d\u0F98\u2783;\u696D;\u600Eri;\u62BF\u0300achiqt\u2798\u279D\u0A40\u27A2\u27AE\u27BBquo;\u6039r;\uC000\ud835\udcc1m\u0180;eg\u09B2\u27AA\u27AC;\u6A8D;\u6A8F\u0100bu\u252A\u27B3o\u0100;r\u0E1F\u27B9;\u601Arok;\u4142\u8400<;cdhilqr\u082B\u27D2\u2639\u27DC\u27E0\u27E5\u27EA\u27F0\u0100ci\u27D7\u27D9;\u6AA6r;\u6A79re\xe5\u25F2mes;\u62C9arr;\u6976uest;\u6A7B\u0100Pi\u27F5\u27F9ar;\u6996\u0180;ef\u2800\u092D\u181B\u65C3r\u0100du\u2807\u280Dshar;\u694Ahar;\u6966\u0100en\u2817\u2821rtneqq;\uC000\u2268\uFE00\xc5\u281E\u0700Dacdefhilnopsu\u2840\u2845\u2882\u288E\u2893\u28A0\u28A5\u28A8\u28DA\u28E2\u28E4\u0A83\u28F3\u2902Dot;\u623A\u0200clpr\u284E\u2852\u2863\u287Dr\u803B\xaf\u40AF\u0100et\u2857\u2859;\u6642\u0100;e\u285E\u285F\u6720se\xbb\u285F\u0100;s\u103B\u2868to\u0200;dlu\u103B\u2873\u2877\u287Bow\xee\u048Cef\xf4\u090F\xf0\u13D1ker;\u65AE\u0100oy\u2887\u288Cmma;\u6A29;\u443Cash;\u6014asuredangle\xbb\u1626r;\uC000\ud835\udd2ao;\u6127\u0180cdn\u28AF\u28B4\u28C9ro\u803B\xb5\u40B5\u0200;acd\u1464\u28BD\u28C0\u28C4s\xf4\u16A7ir;\u6AF0ot\u80BB\xb7\u01B5us\u0180;bd\u28D2\u1903\u28D3\u6212\u0100;u\u1D3C\u28D8;\u6A2A\u0163\u28DE\u28E1p;\u6ADB\xf2\u2212\xf0\u0A81\u0100dp\u28E9\u28EEels;\u62A7f;\uC000\ud835\udd5e\u0100ct\u28F8\u28FDr;\uC000\ud835\udcc2pos\xbb\u159D\u0180;lm\u2909\u290A\u290D\u43BCtimap;\u62B8\u0C00GLRVabcdefghijlmoprstuvw\u2942\u2953\u297E\u2989\u2998\u29DA\u29E9\u2A15\u2A1A\u2A58\u2A5D\u2A83\u2A95\u2AA4\u2AA8\u2B04\u2B07\u2B44\u2B7F\u2BAE\u2C34\u2C67\u2C7C\u2CE9\u0100gt\u2947\u294B;\uC000\u22D9\u0338\u0100;v\u2950\u0BCF\uC000\u226B\u20D2\u0180elt\u295A\u2972\u2976ft\u0100ar\u2961\u2967rrow;\u61CDightarrow;\u61CE;\uC000\u22D8\u0338\u0100;v\u297B\u0C47\uC000\u226A\u20D2ightarrow;\u61CF\u0100Dd\u298E\u2993ash;\u62AFash;\u62AE\u0280bcnpt\u29A3\u29A7\u29AC\u29B1\u29CCla\xbb\u02DEute;\u4144g;\uC000\u2220\u20D2\u0280;Eiop\u0D84\u29BC\u29C0\u29C5\u29C8;\uC000\u2A70\u0338d;\uC000\u224B\u0338s;\u4149ro\xf8\u0D84ur\u0100;a\u29D3\u29D4\u666El\u0100;s\u29D3\u0B38\u01F3\u29DF\x00\u29E3p\u80BB\xa0\u0B37mp\u0100;e\u0BF9\u0C00\u0280aeouy\u29F4\u29FE\u2A03\u2A10\u2A13\u01F0\u29F9\x00\u29FB;\u6A43on;\u4148dil;\u4146ng\u0100;d\u0D7E\u2A0Aot;\uC000\u2A6D\u0338p;\u6A42;\u443Dash;\u6013\u0380;Aadqsx\u0B92\u2A29\u2A2D\u2A3B\u2A41\u2A45\u2A50rr;\u61D7r\u0100hr\u2A33\u2A36k;\u6924\u0100;o\u13F2\u13F0ot;\uC000\u2250\u0338ui\xf6\u0B63\u0100ei\u2A4A\u2A4Ear;\u6928\xed\u0B98ist\u0100;s\u0BA0\u0B9Fr;\uC000\ud835\udd2b\u0200Eest\u0BC5\u2A66\u2A79\u2A7C\u0180;qs\u0BBC\u2A6D\u0BE1\u0180;qs\u0BBC\u0BC5\u2A74lan\xf4\u0BE2i\xed\u0BEA\u0100;r\u0BB6\u2A81\xbb\u0BB7\u0180Aap\u2A8A\u2A8D\u2A91r\xf2\u2971rr;\u61AEar;\u6AF2\u0180;sv\u0F8D\u2A9C\u0F8C\u0100;d\u2AA1\u2AA2\u62FC;\u62FAcy;\u445A\u0380AEadest\u2AB7\u2ABA\u2ABE\u2AC2\u2AC5\u2AF6\u2AF9r\xf2\u2966;\uC000\u2266\u0338rr;\u619Ar;\u6025\u0200;fqs\u0C3B\u2ACE\u2AE3\u2AEFt\u0100ar\u2AD4\u2AD9rro\xf7\u2AC1ightarro\xf7\u2A90\u0180;qs\u0C3B\u2ABA\u2AEAlan\xf4\u0C55\u0100;s\u0C55\u2AF4\xbb\u0C36i\xed\u0C5D\u0100;r\u0C35\u2AFEi\u0100;e\u0C1A\u0C25i\xe4\u0D90\u0100pt\u2B0C\u2B11f;\uC000\ud835\udd5f\u8180\xac;in\u2B19\u2B1A\u2B36\u40ACn\u0200;Edv\u0B89\u2B24\u2B28\u2B2E;\uC000\u22F9\u0338ot;\uC000\u22F5\u0338\u01E1\u0B89\u2B33\u2B35;\u62F7;\u62F6i\u0100;v\u0CB8\u2B3C\u01E1\u0CB8\u2B41\u2B43;\u62FE;\u62FD\u0180aor\u2B4B\u2B63\u2B69r\u0200;ast\u0B7B\u2B55\u2B5A\u2B5Flle\xec\u0B7Bl;\uC000\u2AFD\u20E5;\uC000\u2202\u0338lint;\u6A14\u0180;ce\u0C92\u2B70\u2B73u\xe5\u0CA5\u0100;c\u0C98\u2B78\u0100;e\u0C92\u2B7D\xf1\u0C98\u0200Aait\u2B88\u2B8B\u2B9D\u2BA7r\xf2\u2988rr\u0180;cw\u2B94\u2B95\u2B99\u619B;\uC000\u2933\u0338;\uC000\u219D\u0338ghtarrow\xbb\u2B95ri\u0100;e\u0CCB\u0CD6\u0380chimpqu\u2BBD\u2BCD\u2BD9\u2B04\u0B78\u2BE4\u2BEF\u0200;cer\u0D32\u2BC6\u0D37\u2BC9u\xe5\u0D45;\uC000\ud835\udcc3ort\u026D\u2B05\x00\x00\u2BD6ar\xe1\u2B56m\u0100;e\u0D6E\u2BDF\u0100;q\u0D74\u0D73su\u0100bp\u2BEB\u2BED\xe5\u0CF8\xe5\u0D0B\u0180bcp\u2BF6\u2C11\u2C19\u0200;Ees\u2BFF\u2C00\u0D22\u2C04\u6284;\uC000\u2AC5\u0338et\u0100;e\u0D1B\u2C0Bq\u0100;q\u0D23\u2C00c\u0100;e\u0D32\u2C17\xf1\u0D38\u0200;Ees\u2C22\u2C23\u0D5F\u2C27\u6285;\uC000\u2AC6\u0338et\u0100;e\u0D58\u2C2Eq\u0100;q\u0D60\u2C23\u0200gilr\u2C3D\u2C3F\u2C45\u2C47\xec\u0BD7lde\u803B\xf1\u40F1\xe7\u0C43iangle\u0100lr\u2C52\u2C5Ceft\u0100;e\u0C1A\u2C5A\xf1\u0C26ight\u0100;e\u0CCB\u2C65\xf1\u0CD7\u0100;m\u2C6C\u2C6D\u43BD\u0180;es\u2C74\u2C75\u2C79\u4023ro;\u6116p;\u6007\u0480DHadgilrs\u2C8F\u2C94\u2C99\u2C9E\u2CA3\u2CB0\u2CB6\u2CD3\u2CE3ash;\u62ADarr;\u6904p;\uC000\u224D\u20D2ash;\u62AC\u0100et\u2CA8\u2CAC;\uC000\u2265\u20D2;\uC000>\u20D2nfin;\u69DE\u0180Aet\u2CBD\u2CC1\u2CC5rr;\u6902;\uC000\u2264\u20D2\u0100;r\u2CCA\u2CCD\uC000<\u20D2ie;\uC000\u22B4\u20D2\u0100At\u2CD8\u2CDCrr;\u6903rie;\uC000\u22B5\u20D2im;\uC000\u223C\u20D2\u0180Aan\u2CF0\u2CF4\u2D02rr;\u61D6r\u0100hr\u2CFA\u2CFDk;\u6923\u0100;o\u13E7\u13E5ear;\u6927\u1253\u1A95\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\u2D2D\x00\u2D38\u2D48\u2D60\u2D65\u2D72\u2D84\u1B07\x00\x00\u2D8D\u2DAB\x00\u2DC8\u2DCE\x00\u2DDC\u2E19\u2E2B\u2E3E\u2E43\u0100cs\u2D31\u1A97ute\u803B\xf3\u40F3\u0100iy\u2D3C\u2D45r\u0100;c\u1A9E\u2D42\u803B\xf4\u40F4;\u443E\u0280abios\u1AA0\u2D52\u2D57\u01C8\u2D5Alac;\u4151v;\u6A38old;\u69BClig;\u4153\u0100cr\u2D69\u2D6Dir;\u69BF;\uC000\ud835\udd2c\u036F\u2D79\x00\x00\u2D7C\x00\u2D82n;\u42DBave\u803B\xf2\u40F2;\u69C1\u0100bm\u2D88\u0DF4ar;\u69B5\u0200acit\u2D95\u2D98\u2DA5\u2DA8r\xf2\u1A80\u0100ir\u2D9D\u2DA0r;\u69BEoss;\u69BBn\xe5\u0E52;\u69C0\u0180aei\u2DB1\u2DB5\u2DB9cr;\u414Dga;\u43C9\u0180cdn\u2DC0\u2DC5\u01CDron;\u43BF;\u69B6pf;\uC000\ud835\udd60\u0180ael\u2DD4\u2DD7\u01D2r;\u69B7rp;\u69B9\u0380;adiosv\u2DEA\u2DEB\u2DEE\u2E08\u2E0D\u2E10\u2E16\u6228r\xf2\u1A86\u0200;efm\u2DF7\u2DF8\u2E02\u2E05\u6A5Dr\u0100;o\u2DFE\u2DFF\u6134f\xbb\u2DFF\u803B\xaa\u40AA\u803B\xba\u40BAgof;\u62B6r;\u6A56lope;\u6A57;\u6A5B\u0180clo\u2E1F\u2E21\u2E27\xf2\u2E01ash\u803B\xf8\u40F8l;\u6298i\u016C\u2E2F\u2E34de\u803B\xf5\u40F5es\u0100;a\u01DB\u2E3As;\u6A36ml\u803B\xf6\u40F6bar;\u633D\u0AE1\u2E5E\x00\u2E7D\x00\u2E80\u2E9D\x00\u2EA2\u2EB9\x00\x00\u2ECB\u0E9C\x00\u2F13\x00\x00\u2F2B\u2FBC\x00\u2FC8r\u0200;ast\u0403\u2E67\u2E72\u0E85\u8100\xb6;l\u2E6D\u2E6E\u40B6le\xec\u0403\u0269\u2E78\x00\x00\u2E7Bm;\u6AF3;\u6AFDy;\u443Fr\u0280cimpt\u2E8B\u2E8F\u2E93\u1865\u2E97nt;\u4025od;\u402Eil;\u6030enk;\u6031r;\uC000\ud835\udd2d\u0180imo\u2EA8\u2EB0\u2EB4\u0100;v\u2EAD\u2EAE\u43C6;\u43D5ma\xf4\u0A76ne;\u660E\u0180;tv\u2EBF\u2EC0\u2EC8\u43C0chfork\xbb\u1FFD;\u43D6\u0100au\u2ECF\u2EDFn\u0100ck\u2ED5\u2EDDk\u0100;h\u21F4\u2EDB;\u610E\xf6\u21F4s\u0480;abcdemst\u2EF3\u2EF4\u1908\u2EF9\u2EFD\u2F04\u2F06\u2F0A\u2F0E\u402Bcir;\u6A23ir;\u6A22\u0100ou\u1D40\u2F02;\u6A25;\u6A72n\u80BB\xb1\u0E9Dim;\u6A26wo;\u6A27\u0180ipu\u2F19\u2F20\u2F25ntint;\u6A15f;\uC000\ud835\udd61nd\u803B\xa3\u40A3\u0500;Eaceinosu\u0EC8\u2F3F\u2F41\u2F44\u2F47\u2F81\u2F89\u2F92\u2F7E\u2FB6;\u6AB3p;\u6AB7u\xe5\u0ED9\u0100;c\u0ECE\u2F4C\u0300;acens\u0EC8\u2F59\u2F5F\u2F66\u2F68\u2F7Eppro\xf8\u2F43urlye\xf1\u0ED9\xf1\u0ECE\u0180aes\u2F6F\u2F76\u2F7Approx;\u6AB9qq;\u6AB5im;\u62E8i\xed\u0EDFme\u0100;s\u2F88\u0EAE\u6032\u0180Eas\u2F78\u2F90\u2F7A\xf0\u2F75\u0180dfp\u0EEC\u2F99\u2FAF\u0180als\u2FA0\u2FA5\u2FAAlar;\u632Eine;\u6312urf;\u6313\u0100;t\u0EFB\u2FB4\xef\u0EFBrel;\u62B0\u0100ci\u2FC0\u2FC5r;\uC000\ud835\udcc5;\u43C8ncsp;\u6008\u0300fiopsu\u2FDA\u22E2\u2FDF\u2FE5\u2FEB\u2FF1r;\uC000\ud835\udd2epf;\uC000\ud835\udd62rime;\u6057cr;\uC000\ud835\udcc6\u0180aeo\u2FF8\u3009\u3013t\u0100ei\u2FFE\u3005rnion\xf3\u06B0nt;\u6A16st\u0100;e\u3010\u3011\u403F\xf1\u1F19\xf4\u0F14\u0A80ABHabcdefhilmnoprstux\u3040\u3051\u3055\u3059\u30E0\u310E\u312B\u3147\u3162\u3172\u318E\u3206\u3215\u3224\u3229\u3258\u326E\u3272\u3290\u32B0\u32B7\u0180art\u3047\u304A\u304Cr\xf2\u10B3\xf2\u03DDail;\u691Car\xf2\u1C65ar;\u6964\u0380cdenqrt\u3068\u3075\u3078\u307F\u308F\u3094\u30CC\u0100eu\u306D\u3071;\uC000\u223D\u0331te;\u4155i\xe3\u116Emptyv;\u69B3g\u0200;del\u0FD1\u3089\u308B\u308D;\u6992;\u69A5\xe5\u0FD1uo\u803B\xbb\u40BBr\u0580;abcfhlpstw\u0FDC\u30AC\u30AF\u30B7\u30B9\u30BC\u30BE\u30C0\u30C3\u30C7\u30CAp;\u6975\u0100;f\u0FE0\u30B4s;\u6920;\u6933s;\u691E\xeb\u225D\xf0\u272El;\u6945im;\u6974l;\u61A3;\u619D\u0100ai\u30D1\u30D5il;\u691Ao\u0100;n\u30DB\u30DC\u6236al\xf3\u0F1E\u0180abr\u30E7\u30EA\u30EEr\xf2\u17E5rk;\u6773\u0100ak\u30F3\u30FDc\u0100ek\u30F9\u30FB;\u407D;\u405D\u0100es\u3102\u3104;\u698Cl\u0100du\u310A\u310C;\u698E;\u6990\u0200aeuy\u3117\u311C\u3127\u3129ron;\u4159\u0100di\u3121\u3125il;\u4157\xec\u0FF2\xe2\u30FA;\u4440\u0200clqs\u3134\u3137\u313D\u3144a;\u6937dhar;\u6969uo\u0100;r\u020E\u020Dh;\u61B3\u0180acg\u314E\u315F\u0F44l\u0200;ips\u0F78\u3158\u315B\u109Cn\xe5\u10BBar\xf4\u0FA9t;\u65AD\u0180ilr\u3169\u1023\u316Esht;\u697D;\uC000\ud835\udd2f\u0100ao\u3177\u3186r\u0100du\u317D\u317F\xbb\u047B\u0100;l\u1091\u3184;\u696C\u0100;v\u318B\u318C\u43C1;\u43F1\u0180gns\u3195\u31F9\u31FCht\u0300ahlrst\u31A4\u31B0\u31C2\u31D8\u31E4\u31EErrow\u0100;t\u0FDC\u31ADa\xe9\u30C8arpoon\u0100du\u31BB\u31BFow\xee\u317Ep\xbb\u1092eft\u0100ah\u31CA\u31D0rrow\xf3\u0FEAarpoon\xf3\u0551ightarrows;\u61C9quigarro\xf7\u30CBhreetimes;\u62CCg;\u42DAingdotse\xf1\u1F32\u0180ahm\u320D\u3210\u3213r\xf2\u0FEAa\xf2\u0551;\u600Foust\u0100;a\u321E\u321F\u63B1che\xbb\u321Fmid;\u6AEE\u0200abpt\u3232\u323D\u3240\u3252\u0100nr\u3237\u323Ag;\u67EDr;\u61FEr\xeb\u1003\u0180afl\u3247\u324A\u324Er;\u6986;\uC000\ud835\udd63us;\u6A2Eimes;\u6A35\u0100ap\u325D\u3267r\u0100;g\u3263\u3264\u4029t;\u6994olint;\u6A12ar\xf2\u31E3\u0200achq\u327B\u3280\u10BC\u3285quo;\u603Ar;\uC000\ud835\udcc7\u0100bu\u30FB\u328Ao\u0100;r\u0214\u0213\u0180hir\u3297\u329B\u32A0re\xe5\u31F8mes;\u62CAi\u0200;efl\u32AA\u1059\u1821\u32AB\u65B9tri;\u69CEluhar;\u6968;\u611E\u0D61\u32D5\u32DB\u32DF\u332C\u3338\u3371\x00\u337A\u33A4\x00\x00\u33EC\u33F0\x00\u3428\u3448\u345A\u34AD\u34B1\u34CA\u34F1\x00\u3616\x00\x00\u3633cute;\u415Bqu\xef\u27BA\u0500;Eaceinpsy\u11ED\u32F3\u32F5\u32FF\u3302\u330B\u330F\u331F\u3326\u3329;\u6AB4\u01F0\u32FA\x00\u32FC;\u6AB8on;\u4161u\xe5\u11FE\u0100;d\u11F3\u3307il;\u415Frc;\u415D\u0180Eas\u3316\u3318\u331B;\u6AB6p;\u6ABAim;\u62E9olint;\u6A13i\xed\u1204;\u4441ot\u0180;be\u3334\u1D47\u3335\u62C5;\u6A66\u0380Aacmstx\u3346\u334A\u3357\u335B\u335E\u3363\u336Drr;\u61D8r\u0100hr\u3350\u3352\xeb\u2228\u0100;o\u0A36\u0A34t\u803B\xa7\u40A7i;\u403Bwar;\u6929m\u0100in\u3369\xf0nu\xf3\xf1t;\u6736r\u0100;o\u3376\u2055\uC000\ud835\udd30\u0200acoy\u3382\u3386\u3391\u33A0rp;\u666F\u0100hy\u338B\u338Fcy;\u4449;\u4448rt\u026D\u3399\x00\x00\u339Ci\xe4\u1464ara\xec\u2E6F\u803B\xad\u40AD\u0100gm\u33A8\u33B4ma\u0180;fv\u33B1\u33B2\u33B2\u43C3;\u43C2\u0400;deglnpr\u12AB\u33C5\u33C9\u33CE\u33D6\u33DE\u33E1\u33E6ot;\u6A6A\u0100;q\u12B1\u12B0\u0100;E\u33D3\u33D4\u6A9E;\u6AA0\u0100;E\u33DB\u33DC\u6A9D;\u6A9Fe;\u6246lus;\u6A24arr;\u6972ar\xf2\u113D\u0200aeit\u33F8\u3408\u340F\u3417\u0100ls\u33FD\u3404lsetm\xe9\u336Ahp;\u6A33parsl;\u69E4\u0100dl\u1463\u3414e;\u6323\u0100;e\u341C\u341D\u6AAA\u0100;s\u3422\u3423\u6AAC;\uC000\u2AAC\uFE00\u0180flp\u342E\u3433\u3442tcy;\u444C\u0100;b\u3438\u3439\u402F\u0100;a\u343E\u343F\u69C4r;\u633Ff;\uC000\ud835\udd64a\u0100dr\u344D\u0402es\u0100;u\u3454\u3455\u6660it\xbb\u3455\u0180csu\u3460\u3479\u349F\u0100au\u3465\u346Fp\u0100;s\u1188\u346B;\uC000\u2293\uFE00p\u0100;s\u11B4\u3475;\uC000\u2294\uFE00u\u0100bp\u347F\u348F\u0180;es\u1197\u119C\u3486et\u0100;e\u1197\u348D\xf1\u119D\u0180;es\u11A8\u11AD\u3496et\u0100;e\u11A8\u349D\xf1\u11AE\u0180;af\u117B\u34A6\u05B0r\u0165\u34AB\u05B1\xbb\u117Car\xf2\u1148\u0200cemt\u34B9\u34BE\u34C2\u34C5r;\uC000\ud835\udcc8tm\xee\xf1i\xec\u3415ar\xe6\u11BE\u0100ar\u34CE\u34D5r\u0100;f\u34D4\u17BF\u6606\u0100an\u34DA\u34EDight\u0100ep\u34E3\u34EApsilo\xee\u1EE0h\xe9\u2EAFs\xbb\u2852\u0280bcmnp\u34FB\u355E\u1209\u358B\u358E\u0480;Edemnprs\u350E\u350F\u3511\u3515\u351E\u3523\u352C\u3531\u3536\u6282;\u6AC5ot;\u6ABD\u0100;d\u11DA\u351Aot;\u6AC3ult;\u6AC1\u0100Ee\u3528\u352A;\u6ACB;\u628Alus;\u6ABFarr;\u6979\u0180eiu\u353D\u3552\u3555t\u0180;en\u350E\u3545\u354Bq\u0100;q\u11DA\u350Feq\u0100;q\u352B\u3528m;\u6AC7\u0100bp\u355A\u355C;\u6AD5;\u6AD3c\u0300;acens\u11ED\u356C\u3572\u3579\u357B\u3326ppro\xf8\u32FAurlye\xf1\u11FE\xf1\u11F3\u0180aes\u3582\u3588\u331Bppro\xf8\u331Aq\xf1\u3317g;\u666A\u0680123;Edehlmnps\u35A9\u35AC\u35AF\u121C\u35B2\u35B4\u35C0\u35C9\u35D5\u35DA\u35DF\u35E8\u35ED\u803B\xb9\u40B9\u803B\xb2\u40B2\u803B\xb3\u40B3;\u6AC6\u0100os\u35B9\u35BCt;\u6ABEub;\u6AD8\u0100;d\u1222\u35C5ot;\u6AC4s\u0100ou\u35CF\u35D2l;\u67C9b;\u6AD7arr;\u697Bult;\u6AC2\u0100Ee\u35E4\u35E6;\u6ACC;\u628Blus;\u6AC0\u0180eiu\u35F4\u3609\u360Ct\u0180;en\u121C\u35FC\u3602q\u0100;q\u1222\u35B2eq\u0100;q\u35E7\u35E4m;\u6AC8\u0100bp\u3611\u3613;\u6AD4;\u6AD6\u0180Aan\u361C\u3620\u362Drr;\u61D9r\u0100hr\u3626\u3628\xeb\u222E\u0100;o\u0A2B\u0A29war;\u692Alig\u803B\xdf\u40DF\u0BE1\u3651\u365D\u3660\u12CE\u3673\u3679\x00\u367E\u36C2\x00\x00\x00\x00\x00\u36DB\u3703\x00\u3709\u376C\x00\x00\x00\u3787\u0272\u3656\x00\x00\u365Bget;\u6316;\u43C4r\xeb\u0E5F\u0180aey\u3666\u366B\u3670ron;\u4165dil;\u4163;\u4442lrec;\u6315r;\uC000\ud835\udd31\u0200eiko\u3686\u369D\u36B5\u36BC\u01F2\u368B\x00\u3691e\u01004f\u1284\u1281a\u0180;sv\u3698\u3699\u369B\u43B8ym;\u43D1\u0100cn\u36A2\u36B2k\u0100as\u36A8\u36AEppro\xf8\u12C1im\xbb\u12ACs\xf0\u129E\u0100as\u36BA\u36AE\xf0\u12C1rn\u803B\xfe\u40FE\u01EC\u031F\u36C6\u22E7es\u8180\xd7;bd\u36CF\u36D0\u36D8\u40D7\u0100;a\u190F\u36D5r;\u6A31;\u6A30\u0180eps\u36E1\u36E3\u3700\xe1\u2A4D\u0200;bcf\u0486\u36EC\u36F0\u36F4ot;\u6336ir;\u6AF1\u0100;o\u36F9\u36FC\uC000\ud835\udd65rk;\u6ADA\xe1\u3362rime;\u6034\u0180aip\u370F\u3712\u3764d\xe5\u1248\u0380adempst\u3721\u374D\u3740\u3751\u3757\u375C\u375Fngle\u0280;dlqr\u3730\u3731\u3736\u3740\u3742\u65B5own\xbb\u1DBBeft\u0100;e\u2800\u373E\xf1\u092E;\u625Cight\u0100;e\u32AA\u374B\xf1\u105Aot;\u65ECinus;\u6A3Alus;\u6A39b;\u69CDime;\u6A3Bezium;\u63E2\u0180cht\u3772\u377D\u3781\u0100ry\u3777\u377B;\uC000\ud835\udcc9;\u4446cy;\u445Brok;\u4167\u0100io\u378B\u378Ex\xf4\u1777head\u0100lr\u3797\u37A0eftarro\xf7\u084Fightarrow\xbb\u0F5D\u0900AHabcdfghlmoprstuw\u37D0\u37D3\u37D7\u37E4\u37F0\u37FC\u380E\u381C\u3823\u3834\u3851\u385D\u386B\u38A9\u38CC\u38D2\u38EA\u38F6r\xf2\u03EDar;\u6963\u0100cr\u37DC\u37E2ute\u803B\xfa\u40FA\xf2\u1150r\u01E3\u37EA\x00\u37EDy;\u445Eve;\u416D\u0100iy\u37F5\u37FArc\u803B\xfb\u40FB;\u4443\u0180abh\u3803\u3806\u380Br\xf2\u13ADlac;\u4171a\xf2\u13C3\u0100ir\u3813\u3818sht;\u697E;\uC000\ud835\udd32rave\u803B\xf9\u40F9\u0161\u3827\u3831r\u0100lr\u382C\u382E\xbb\u0957\xbb\u1083lk;\u6580\u0100ct\u3839\u384D\u026F\u383F\x00\x00\u384Arn\u0100;e\u3845\u3846\u631Cr\xbb\u3846op;\u630Fri;\u65F8\u0100al\u3856\u385Acr;\u416B\u80BB\xa8\u0349\u0100gp\u3862\u3866on;\u4173f;\uC000\ud835\udd66\u0300adhlsu\u114B\u3878\u387D\u1372\u3891\u38A0own\xe1\u13B3arpoon\u0100lr\u3888\u388Cef\xf4\u382Digh\xf4\u382Fi\u0180;hl\u3899\u389A\u389C\u43C5\xbb\u13FAon\xbb\u389Aparrows;\u61C8\u0180cit\u38B0\u38C4\u38C8\u026F\u38B6\x00\x00\u38C1rn\u0100;e\u38BC\u38BD\u631Dr\xbb\u38BDop;\u630Eng;\u416Fri;\u65F9cr;\uC000\ud835\udcca\u0180dir\u38D9\u38DD\u38E2ot;\u62F0lde;\u4169i\u0100;f\u3730\u38E8\xbb\u1813\u0100am\u38EF\u38F2r\xf2\u38A8l\u803B\xfc\u40FCangle;\u69A7\u0780ABDacdeflnoprsz\u391C\u391F\u3929\u392D\u39B5\u39B8\u39BD\u39DF\u39E4\u39E8\u39F3\u39F9\u39FD\u3A01\u3A20r\xf2\u03F7ar\u0100;v\u3926\u3927\u6AE8;\u6AE9as\xe8\u03E1\u0100nr\u3932\u3937grt;\u699C\u0380eknprst\u34E3\u3946\u394B\u3952\u395D\u3964\u3996app\xe1\u2415othin\xe7\u1E96\u0180hir\u34EB\u2EC8\u3959op\xf4\u2FB5\u0100;h\u13B7\u3962\xef\u318D\u0100iu\u3969\u396Dgm\xe1\u33B3\u0100bp\u3972\u3984setneq\u0100;q\u397D\u3980\uC000\u228A\uFE00;\uC000\u2ACB\uFE00setneq\u0100;q\u398F\u3992\uC000\u228B\uFE00;\uC000\u2ACC\uFE00\u0100hr\u399B\u399Fet\xe1\u369Ciangle\u0100lr\u39AA\u39AFeft\xbb\u0925ight\xbb\u1051y;\u4432ash\xbb\u1036\u0180elr\u39C4\u39D2\u39D7\u0180;be\u2DEA\u39CB\u39CFar;\u62BBq;\u625Alip;\u62EE\u0100bt\u39DC\u1468a\xf2\u1469r;\uC000\ud835\udd33tr\xe9\u39AEsu\u0100bp\u39EF\u39F1\xbb\u0D1C\xbb\u0D59pf;\uC000\ud835\udd67ro\xf0\u0EFBtr\xe9\u39B4\u0100cu\u3A06\u3A0Br;\uC000\ud835\udccb\u0100bp\u3A10\u3A18n\u0100Ee\u3980\u3A16\xbb\u397En\u0100Ee\u3992\u3A1E\xbb\u3990igzag;\u699A\u0380cefoprs\u3A36\u3A3B\u3A56\u3A5B\u3A54\u3A61\u3A6Airc;\u4175\u0100di\u3A40\u3A51\u0100bg\u3A45\u3A49ar;\u6A5Fe\u0100;q\u15FA\u3A4F;\u6259erp;\u6118r;\uC000\ud835\udd34pf;\uC000\ud835\udd68\u0100;e\u1479\u3A66at\xe8\u1479cr;\uC000\ud835\udccc\u0AE3\u178E\u3A87\x00\u3A8B\x00\u3A90\u3A9B\x00\x00\u3A9D\u3AA8\u3AAB\u3AAF\x00\x00\u3AC3\u3ACE\x00\u3AD8\u17DC\u17DFtr\xe9\u17D1r;\uC000\ud835\udd35\u0100Aa\u3A94\u3A97r\xf2\u03C3r\xf2\u09F6;\u43BE\u0100Aa\u3AA1\u3AA4r\xf2\u03B8r\xf2\u09EBa\xf0\u2713is;\u62FB\u0180dpt\u17A4\u3AB5\u3ABE\u0100fl\u3ABA\u17A9;\uC000\ud835\udd69im\xe5\u17B2\u0100Aa\u3AC7\u3ACAr\xf2\u03CEr\xf2\u0A01\u0100cq\u3AD2\u17B8r;\uC000\ud835\udccd\u0100pt\u17D6\u3ADCr\xe9\u17D4\u0400acefiosu\u3AF0\u3AFD\u3B08\u3B0C\u3B11\u3B15\u3B1B\u3B21c\u0100uy\u3AF6\u3AFBte\u803B\xfd\u40FD;\u444F\u0100iy\u3B02\u3B06rc;\u4177;\u444Bn\u803B\xa5\u40A5r;\uC000\ud835\udd36cy;\u4457pf;\uC000\ud835\udd6acr;\uC000\ud835\udcce\u0100cm\u3B26\u3B29y;\u444El\u803B\xff\u40FF\u0500acdefhiosw\u3B42\u3B48\u3B54\u3B58\u3B64\u3B69\u3B6D\u3B74\u3B7A\u3B80cute;\u417A\u0100ay\u3B4D\u3B52ron;\u417E;\u4437ot;\u417C\u0100et\u3B5D\u3B61tr\xe6\u155Fa;\u43B6r;\uC000\ud835\udd37cy;\u4436grarr;\u61DDpf;\uC000\ud835\udd6bcr;\uC000\ud835\udccf\u0100jn\u3B85\u3B87;\u600Dj;\u600C'.split("").map(function(c) {
    return c.charCodeAt(0);
}));

});

parcelRegister("dGzMK", function(module, exports) {
"use strict";
// Generated using scripts/write-decode-map.ts
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = new Uint16Array(// prettier-ignore
"\u0200aglq	\x15\x18\x1b\u026D\x0f\x00\x00\x12p;\u4026os;\u4027t;\u403Et;\u403Cuot;\u4022".split("").map(function(c) {
    return c.charCodeAt(0);
}));

});

parcelRegister("if5Pf", function(module, exports) {
"use strict";
// Adapted from https://github.com/mathiasbynens/he/blob/36afe179392226cf1b6ccdb16ebbb7a5a844d93a/src/he.js#L106-L134
var $d47e258956a5cbe7$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.replaceCodePoint = module.exports.fromCodePoint = void 0;
var $d47e258956a5cbe7$var$decodeMap = new Map([
    [
        0,
        65533
    ],
    // C1 Unicode control character reference replacements
    [
        128,
        8364
    ],
    [
        130,
        8218
    ],
    [
        131,
        402
    ],
    [
        132,
        8222
    ],
    [
        133,
        8230
    ],
    [
        134,
        8224
    ],
    [
        135,
        8225
    ],
    [
        136,
        710
    ],
    [
        137,
        8240
    ],
    [
        138,
        352
    ],
    [
        139,
        8249
    ],
    [
        140,
        338
    ],
    [
        142,
        381
    ],
    [
        145,
        8216
    ],
    [
        146,
        8217
    ],
    [
        147,
        8220
    ],
    [
        148,
        8221
    ],
    [
        149,
        8226
    ],
    [
        150,
        8211
    ],
    [
        151,
        8212
    ],
    [
        152,
        732
    ],
    [
        153,
        8482
    ],
    [
        154,
        353
    ],
    [
        155,
        8250
    ],
    [
        156,
        339
    ],
    [
        158,
        382
    ],
    [
        159,
        376
    ]
]);
/**
 * Polyfill for `String.fromCodePoint`. It is used to create a string from a Unicode code point.
 */ module.exports.fromCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
($d47e258956a5cbe7$var$_a = String.fromCodePoint) !== null && $d47e258956a5cbe7$var$_a !== void 0 ? $d47e258956a5cbe7$var$_a : function(codePoint) {
    var output = "";
    if (codePoint > 0xffff) {
        codePoint -= 0x10000;
        output += String.fromCharCode(codePoint >>> 10 & 0x3ff | 0xd800);
        codePoint = 0xdc00 | codePoint & 0x3ff;
    }
    output += String.fromCharCode(codePoint);
    return output;
};
/**
 * Replace the given code point with a replacement character if it is a
 * surrogate or is outside the valid range. Otherwise return the code
 * point unchanged.
 */ function $d47e258956a5cbe7$var$replaceCodePoint(codePoint) {
    var _a;
    if (codePoint >= 0xd800 && codePoint <= 0xdfff || codePoint > 0x10ffff) return 0xfffd;
    return (_a = $d47e258956a5cbe7$var$decodeMap.get(codePoint)) !== null && _a !== void 0 ? _a : codePoint;
}
module.exports.replaceCodePoint = $d47e258956a5cbe7$var$replaceCodePoint;
/**
 * Replace the code point if relevant, then convert it to a string.
 *
 * @deprecated Use `fromCodePoint(replaceCodePoint(codePoint))` instead.
 * @param codePoint The code point to decode.
 * @returns The decoded code point.
 */ function $d47e258956a5cbe7$var$decodeCodePoint(codePoint) {
    return (0, module.exports.fromCodePoint)($d47e258956a5cbe7$var$replaceCodePoint(codePoint));
}
module.exports.default = $d47e258956a5cbe7$var$decodeCodePoint;

});




parcelRegister("7UyMy", function(module, exports) {
$parcel$export(module.exports, "CDATA", function () { return (parcelRequire("79X3L")).CDATA; });
$parcel$export(module.exports, "Comment", function () { return (parcelRequire("79X3L")).Comment; });
$parcel$export(module.exports, "Document", function () { return (parcelRequire("79X3L")).Document; });
$parcel$export(module.exports, "Element", function () { return (parcelRequire("79X3L")).Element; });
$parcel$export(module.exports, "hasChildren", function () { return (parcelRequire("79X3L")).hasChildren; });
$parcel$export(module.exports, "isCDATA", function () { return (parcelRequire("79X3L")).isCDATA; });
$parcel$export(module.exports, "isComment", function () { return (parcelRequire("79X3L")).isComment; });
$parcel$export(module.exports, "isTag", function () { return (parcelRequire("79X3L")).isTag; });
$parcel$export(module.exports, "isText", function () { return (parcelRequire("79X3L")).isText; });
$parcel$export(module.exports, "ProcessingInstruction", function () { return (parcelRequire("79X3L")).ProcessingInstruction; });
$parcel$export(module.exports, "Text", function () { return (parcelRequire("79X3L")).Text; });

$parcel$export(module.exports, "DomHandler", function () { return $5c28be5ad7d18608$export$ff8ccbac9225de62; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $3Qx6e = parcelRequire("3Qx6e");

var $79X3L = parcelRequire("79X3L");
// Default options
var $5c28be5ad7d18608$var$defaultOpts = {
    withStartIndices: false,
    withEndIndices: false,
    xmlMode: false
};
var $5c28be5ad7d18608$export$ff8ccbac9225de62 = /*#__PURE__*/ function() {
    "use strict";
    function DomHandler(callback, options, elementCB) {
        (0, $4GJKx._)(this, DomHandler);
        /** The elements of the DOM */ this.dom = [];
        /** The root element for the DOM */ this.root = new (0, $79X3L.Document)(this.dom);
        /** Indicated whether parsing has been completed. */ this.done = false;
        /** Stack of open tags. */ this.tagStack = [
            this.root
        ];
        /** A data node that is still being written to. */ this.lastNode = null;
        /** Reference to the parser instance. Used for location information. */ this.parser = null;
        // Make it possible to skip arguments, for backwards-compatibility
        if (typeof options === "function") {
            elementCB = options;
            options = $5c28be5ad7d18608$var$defaultOpts;
        }
        if (typeof callback === "object") {
            options = callback;
            callback = undefined;
        }
        this.callback = callback !== null && callback !== void 0 ? callback : null;
        this.options = options !== null && options !== void 0 ? options : $5c28be5ad7d18608$var$defaultOpts;
        this.elementCB = elementCB !== null && elementCB !== void 0 ? elementCB : null;
    }
    (0, $1wc17._)(DomHandler, [
        {
            key: "onparserinit",
            value: function onparserinit(parser) {
                this.parser = parser;
            }
        },
        {
            // Resets the handler back to starting state
            key: "onreset",
            value: function onreset() {
                this.dom = [];
                this.root = new (0, $79X3L.Document)(this.dom);
                this.done = false;
                this.tagStack = [
                    this.root
                ];
                this.lastNode = null;
                this.parser = null;
            }
        },
        {
            // Signals the handler that parsing is done
            key: "onend",
            value: function onend() {
                if (this.done) return;
                this.done = true;
                this.parser = null;
                this.handleCallback(null);
            }
        },
        {
            key: "onerror",
            value: function onerror(error) {
                this.handleCallback(error);
            }
        },
        {
            key: "onclosetag",
            value: function onclosetag() {
                this.lastNode = null;
                var elem = this.tagStack.pop();
                if (this.options.withEndIndices) elem.endIndex = this.parser.endIndex;
                if (this.elementCB) this.elementCB(elem);
            }
        },
        {
            key: "onopentag",
            value: function onopentag(name, attribs) {
                var type = this.options.xmlMode ? (0, $3Qx6e.ElementType).Tag : undefined;
                var element = new (0, $79X3L.Element)(name, attribs, undefined, type);
                this.addNode(element);
                this.tagStack.push(element);
            }
        },
        {
            key: "ontext",
            value: function ontext(data) {
                var lastNode = this.lastNode;
                if (lastNode && lastNode.type === (0, $3Qx6e.ElementType).Text) {
                    lastNode.data += data;
                    if (this.options.withEndIndices) lastNode.endIndex = this.parser.endIndex;
                } else {
                    var node = new (0, $79X3L.Text)(data);
                    this.addNode(node);
                    this.lastNode = node;
                }
            }
        },
        {
            key: "oncomment",
            value: function oncomment(data) {
                if (this.lastNode && this.lastNode.type === (0, $3Qx6e.ElementType).Comment) {
                    this.lastNode.data += data;
                    return;
                }
                var node = new (0, $79X3L.Comment)(data);
                this.addNode(node);
                this.lastNode = node;
            }
        },
        {
            key: "oncommentend",
            value: function oncommentend() {
                this.lastNode = null;
            }
        },
        {
            key: "oncdatastart",
            value: function oncdatastart() {
                var text = new (0, $79X3L.Text)("");
                var node = new (0, $79X3L.CDATA)([
                    text
                ]);
                this.addNode(node);
                text.parent = node;
                this.lastNode = text;
            }
        },
        {
            key: "oncdataend",
            value: function oncdataend() {
                this.lastNode = null;
            }
        },
        {
            key: "onprocessinginstruction",
            value: function onprocessinginstruction(name, data) {
                var node = new (0, $79X3L.ProcessingInstruction)(name, data);
                this.addNode(node);
            }
        },
        {
            key: "handleCallback",
            value: function handleCallback(error) {
                if (typeof this.callback === "function") this.callback(error, this.dom);
                else if (error) throw error;
            }
        },
        {
            key: "addNode",
            value: function addNode(node) {
                var parent = this.tagStack[this.tagStack.length - 1];
                var previousSibling = parent.children[parent.children.length - 1];
                if (this.options.withStartIndices) node.startIndex = this.parser.startIndex;
                if (this.options.withEndIndices) node.endIndex = this.parser.endIndex;
                parent.children.push(node);
                if (previousSibling) {
                    node.prev = previousSibling;
                    previousSibling.next = node;
                }
                node.parent = parent;
                this.lastNode = null;
            }
        }
    ]);
    return DomHandler;
}();
var $5c28be5ad7d18608$export$2e2bcd8739ae039 = $5c28be5ad7d18608$export$ff8ccbac9225de62;

});
parcelRegister("3Qx6e", function(module, exports) {

$parcel$export(module.exports, "ElementType", function () { return $2ccfe74c53a19759$export$b992dc138d950e31; });
$parcel$export(module.exports, "isTag", function () { return $2ccfe74c53a19759$export$3bf645f08efe3292; });
$parcel$export(module.exports, "Root", function () { return $2ccfe74c53a19759$export$be92b6f5f03c0fe9; });
$parcel$export(module.exports, "Text", function () { return $2ccfe74c53a19759$export$5f1af8db9871e1d6; });
$parcel$export(module.exports, "Directive", function () { return $2ccfe74c53a19759$export$befdefbdce210f91; });
$parcel$export(module.exports, "Comment", function () { return $2ccfe74c53a19759$export$4d299b491347818a; });
$parcel$export(module.exports, "Script", function () { return $2ccfe74c53a19759$export$2f8b47a141e57afc; });
$parcel$export(module.exports, "Style", function () { return $2ccfe74c53a19759$export$d9e45bc13d335801; });
$parcel$export(module.exports, "Tag", function () { return $2ccfe74c53a19759$export$3288d34c523a1192; });
$parcel$export(module.exports, "CDATA", function () { return $2ccfe74c53a19759$export$1f8b8f7e5c763232; });
$parcel$export(module.exports, "Doctype", function () { return $2ccfe74c53a19759$export$31b44af36ff2c60f; });
/** Types of elements found in htmlparser2's DOM */ var $2ccfe74c53a19759$export$b992dc138d950e31;
(function(ElementType) {
    /** Type for the root element of a document */ ElementType["Root"] = "root";
    /** Type for Text */ ElementType["Text"] = "text";
    /** Type for <? ... ?> */ ElementType["Directive"] = "directive";
    /** Type for <!-- ... --> */ ElementType["Comment"] = "comment";
    /** Type for <script> tags */ ElementType["Script"] = "script";
    /** Type for <style> tags */ ElementType["Style"] = "style";
    /** Type for Any tag */ ElementType["Tag"] = "tag";
    /** Type for <![CDATA[ ... ]]> */ ElementType["CDATA"] = "cdata";
    /** Type for <!doctype ...> */ ElementType["Doctype"] = "doctype";
})($2ccfe74c53a19759$export$b992dc138d950e31 || ($2ccfe74c53a19759$export$b992dc138d950e31 = {}));
function $2ccfe74c53a19759$export$3bf645f08efe3292(elem) {
    return elem.type === $2ccfe74c53a19759$export$b992dc138d950e31.Tag || elem.type === $2ccfe74c53a19759$export$b992dc138d950e31.Script || elem.type === $2ccfe74c53a19759$export$b992dc138d950e31.Style;
}
var $2ccfe74c53a19759$export$be92b6f5f03c0fe9 = $2ccfe74c53a19759$export$b992dc138d950e31.Root;
var $2ccfe74c53a19759$export$5f1af8db9871e1d6 = $2ccfe74c53a19759$export$b992dc138d950e31.Text;
var $2ccfe74c53a19759$export$befdefbdce210f91 = $2ccfe74c53a19759$export$b992dc138d950e31.Directive;
var $2ccfe74c53a19759$export$4d299b491347818a = $2ccfe74c53a19759$export$b992dc138d950e31.Comment;
var $2ccfe74c53a19759$export$2f8b47a141e57afc = $2ccfe74c53a19759$export$b992dc138d950e31.Script;
var $2ccfe74c53a19759$export$d9e45bc13d335801 = $2ccfe74c53a19759$export$b992dc138d950e31.Style;
var $2ccfe74c53a19759$export$3288d34c523a1192 = $2ccfe74c53a19759$export$b992dc138d950e31.Tag;
var $2ccfe74c53a19759$export$1f8b8f7e5c763232 = $2ccfe74c53a19759$export$b992dc138d950e31.CDATA;
var $2ccfe74c53a19759$export$31b44af36ff2c60f = $2ccfe74c53a19759$export$b992dc138d950e31.Doctype;

});

parcelRegister("79X3L", function(module, exports) {

$parcel$export(module.exports, "Text", function () { return $53672faeedb40c3b$export$5f1af8db9871e1d6; });
$parcel$export(module.exports, "Comment", function () { return $53672faeedb40c3b$export$4d299b491347818a; });
$parcel$export(module.exports, "ProcessingInstruction", function () { return $53672faeedb40c3b$export$9269dce19ee35e96; });
$parcel$export(module.exports, "CDATA", function () { return $53672faeedb40c3b$export$1f8b8f7e5c763232; });
$parcel$export(module.exports, "Document", function () { return $53672faeedb40c3b$export$b34a105447964f9f; });
$parcel$export(module.exports, "Element", function () { return $53672faeedb40c3b$export$db77ccec0bb4ccac; });
$parcel$export(module.exports, "isTag", function () { return $53672faeedb40c3b$export$3bf645f08efe3292; });
$parcel$export(module.exports, "isCDATA", function () { return $53672faeedb40c3b$export$c2d65aed98d39b56; });
$parcel$export(module.exports, "isText", function () { return $53672faeedb40c3b$export$1879817ac5c922b7; });
$parcel$export(module.exports, "isComment", function () { return $53672faeedb40c3b$export$3ab01370f5e64ac8; });
$parcel$export(module.exports, "hasChildren", function () { return $53672faeedb40c3b$export$bd5ff50f0e53d41c; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $do9pw = parcelRequire("do9pw");

var $FuVm8 = parcelRequire("FuVm8");

var $ohfOJ = parcelRequire("ohfOJ");

var $3Qx6e = parcelRequire("3Qx6e");
var $53672faeedb40c3b$export$85c928794f8d04d4 = /*#__PURE__*/ function() {
    "use strict";
    function Node() {
        (0, $4GJKx._)(this, Node);
        /** Parent of the node */ this.parent = null;
        /** Previous sibling */ this.prev = null;
        /** Next sibling */ this.next = null;
        /** The start index of the node. Requires `withStartIndices` on the handler to be `true. */ this.startIndex = null;
        /** The end index of the node. Requires `withEndIndices` on the handler to be `true. */ this.endIndex = null;
    }
    (0, $1wc17._)(Node, [
        {
            key: "parentNode",
            get: // Read-write aliases for properties
            /**
     * Same as {@link parent}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ function get() {
                return this.parent;
            },
            set: function set(parent) {
                this.parent = parent;
            }
        },
        {
            key: "previousSibling",
            get: /**
     * Same as {@link prev}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ function get() {
                return this.prev;
            },
            set: function set(prev) {
                this.prev = prev;
            }
        },
        {
            key: "nextSibling",
            get: /**
     * Same as {@link next}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ function get() {
                return this.next;
            },
            set: function set(next) {
                this.next = next;
            }
        },
        {
            /**
     * Clone this node, and optionally its children.
     *
     * @param recursive Clone child nodes as well.
     * @returns A clone of the node.
     */ key: "cloneNode",
            value: function cloneNode1() {
                var recursive = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                return $53672faeedb40c3b$export$ae8e35ea29ddac22(this, recursive);
            }
        }
    ]);
    return Node;
}();
var $53672faeedb40c3b$export$c3569d91cd44d357 = /*#__PURE__*/ function(Node) {
    "use strict";
    (0, $dcsZi._)(DataNode, Node);
    var _super = (0, $ohfOJ._)(DataNode);
    function DataNode(data) {
        (0, $4GJKx._)(this, DataNode);
        var _this;
        _this = _super.call(this);
        _this.data = data;
        return _this;
    }
    (0, $1wc17._)(DataNode, [
        {
            key: "nodeValue",
            get: /**
     * Same as {@link data}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ function get() {
                return this.data;
            },
            set: function set(data) {
                this.data = data;
            }
        }
    ]);
    return DataNode;
}((0, $FuVm8._)($53672faeedb40c3b$export$85c928794f8d04d4));
var $53672faeedb40c3b$export$5f1af8db9871e1d6 = /*#__PURE__*/ function(DataNode) {
    "use strict";
    (0, $dcsZi._)(Text, DataNode);
    var _super = (0, $ohfOJ._)(Text);
    function Text() {
        (0, $4GJKx._)(this, Text);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.type = (0, $3Qx6e.ElementType).Text;
        return _this;
    }
    (0, $1wc17._)(Text, [
        {
            key: "nodeType",
            get: function get() {
                return 3;
            }
        }
    ]);
    return Text;
}($53672faeedb40c3b$export$c3569d91cd44d357);
var $53672faeedb40c3b$export$4d299b491347818a = /*#__PURE__*/ function(DataNode) {
    "use strict";
    (0, $dcsZi._)(Comment, DataNode);
    var _super = (0, $ohfOJ._)(Comment);
    function Comment() {
        (0, $4GJKx._)(this, Comment);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.type = (0, $3Qx6e.ElementType).Comment;
        return _this;
    }
    (0, $1wc17._)(Comment, [
        {
            key: "nodeType",
            get: function get() {
                return 8;
            }
        }
    ]);
    return Comment;
}($53672faeedb40c3b$export$c3569d91cd44d357);
var $53672faeedb40c3b$export$9269dce19ee35e96 = /*#__PURE__*/ function(DataNode) {
    "use strict";
    (0, $dcsZi._)(ProcessingInstruction, DataNode);
    var _super = (0, $ohfOJ._)(ProcessingInstruction);
    function ProcessingInstruction(name, data) {
        (0, $4GJKx._)(this, ProcessingInstruction);
        var _this;
        _this = _super.call(this, data);
        _this.name = name;
        _this.type = (0, $3Qx6e.ElementType).Directive;
        return _this;
    }
    (0, $1wc17._)(ProcessingInstruction, [
        {
            key: "nodeType",
            get: function get() {
                return 1;
            }
        }
    ]);
    return ProcessingInstruction;
}($53672faeedb40c3b$export$c3569d91cd44d357);
var $53672faeedb40c3b$export$62be934f90997196 = /*#__PURE__*/ function(Node) {
    "use strict";
    (0, $dcsZi._)(NodeWithChildren, Node);
    var _super = (0, $ohfOJ._)(NodeWithChildren);
    function NodeWithChildren(children) {
        (0, $4GJKx._)(this, NodeWithChildren);
        var _this;
        _this = _super.call(this);
        _this.children = children;
        return _this;
    }
    (0, $1wc17._)(NodeWithChildren, [
        {
            key: "firstChild",
            get: // Aliases
            /** First child of the node. */ function get() {
                var _a;
                return (_a = this.children[0]) !== null && _a !== void 0 ? _a : null;
            }
        },
        {
            key: "lastChild",
            get: /** Last child of the node. */ function get() {
                return this.children.length > 0 ? this.children[this.children.length - 1] : null;
            }
        },
        {
            key: "childNodes",
            get: /**
     * Same as {@link children}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ function get() {
                return this.children;
            },
            set: function set(children) {
                this.children = children;
            }
        }
    ]);
    return NodeWithChildren;
}((0, $FuVm8._)($53672faeedb40c3b$export$85c928794f8d04d4));
var $53672faeedb40c3b$export$1f8b8f7e5c763232 = /*#__PURE__*/ function(NodeWithChildren) {
    "use strict";
    (0, $dcsZi._)(CDATA, NodeWithChildren);
    var _super = (0, $ohfOJ._)(CDATA);
    function CDATA() {
        (0, $4GJKx._)(this, CDATA);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.type = (0, $3Qx6e.ElementType).CDATA;
        return _this;
    }
    (0, $1wc17._)(CDATA, [
        {
            key: "nodeType",
            get: function get() {
                return 4;
            }
        }
    ]);
    return CDATA;
}($53672faeedb40c3b$export$62be934f90997196);
var $53672faeedb40c3b$export$b34a105447964f9f = /*#__PURE__*/ function(NodeWithChildren) {
    "use strict";
    (0, $dcsZi._)(Document, NodeWithChildren);
    var _super = (0, $ohfOJ._)(Document);
    function Document() {
        (0, $4GJKx._)(this, Document);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.type = (0, $3Qx6e.ElementType).Root;
        return _this;
    }
    (0, $1wc17._)(Document, [
        {
            key: "nodeType",
            get: function get() {
                return 9;
            }
        }
    ]);
    return Document;
}($53672faeedb40c3b$export$62be934f90997196);
var $53672faeedb40c3b$export$db77ccec0bb4ccac = /*#__PURE__*/ function(NodeWithChildren) {
    "use strict";
    (0, $dcsZi._)(Element, NodeWithChildren);
    var _super = (0, $ohfOJ._)(Element);
    function Element(name, attribs) {
        var children = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], type = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : name === "script" ? (0, $3Qx6e.ElementType).Script : name === "style" ? (0, $3Qx6e.ElementType).Style : (0, $3Qx6e.ElementType).Tag;
        (0, $4GJKx._)(this, Element);
        var _this;
        _this = _super.call(this, children);
        _this.name = name;
        _this.attribs = attribs;
        _this.type = type;
        return _this;
    }
    (0, $1wc17._)(Element, [
        {
            key: "nodeType",
            get: function get() {
                return 1;
            }
        },
        {
            key: "tagName",
            get: // DOM Level 1 aliases
            /**
     * Same as {@link name}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ function get() {
                return this.name;
            },
            set: function set(name) {
                this.name = name;
            }
        },
        {
            key: "attributes",
            get: function get() {
                var _this = this;
                return Object.keys(this.attribs).map(function(name) {
                    var _a, _b;
                    return {
                        name: name,
                        value: _this.attribs[name],
                        namespace: (_a = _this["x-attribsNamespace"]) === null || _a === void 0 ? void 0 : _a[name],
                        prefix: (_b = _this["x-attribsPrefix"]) === null || _b === void 0 ? void 0 : _b[name]
                    };
                });
            }
        }
    ]);
    return Element;
}($53672faeedb40c3b$export$62be934f90997196);
function $53672faeedb40c3b$export$3bf645f08efe3292(node) {
    return (0, $3Qx6e.isTag)(node);
}
function $53672faeedb40c3b$export$c2d65aed98d39b56(node) {
    return node.type === (0, $3Qx6e.ElementType).CDATA;
}
function $53672faeedb40c3b$export$1879817ac5c922b7(node) {
    return node.type === (0, $3Qx6e.ElementType).Text;
}
function $53672faeedb40c3b$export$3ab01370f5e64ac8(node) {
    return node.type === (0, $3Qx6e.ElementType).Comment;
}
function $53672faeedb40c3b$export$4b5d79f26e0e3ad5(node) {
    return node.type === (0, $3Qx6e.ElementType).Directive;
}
function $53672faeedb40c3b$export$62858bae88b53fd0(node) {
    return node.type === (0, $3Qx6e.ElementType).Root;
}
function $53672faeedb40c3b$export$bd5ff50f0e53d41c(node) {
    return Object.prototype.hasOwnProperty.call(node, "children");
}
function $53672faeedb40c3b$export$ae8e35ea29ddac22(node) {
    var recursive = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var result;
    if ($53672faeedb40c3b$export$1879817ac5c922b7(node)) result = new $53672faeedb40c3b$export$5f1af8db9871e1d6(node.data);
    else if ($53672faeedb40c3b$export$3ab01370f5e64ac8(node)) result = new $53672faeedb40c3b$export$4d299b491347818a(node.data);
    else if ($53672faeedb40c3b$export$3bf645f08efe3292(node)) {
        var children = recursive ? $53672faeedb40c3b$var$cloneChildren(node.children) : [];
        var clone = new $53672faeedb40c3b$export$db77ccec0bb4ccac(node.name, (0, $do9pw._)({}, node.attribs), children);
        children.forEach(function(child) {
            return child.parent = clone;
        });
        if (node.namespace != null) clone.namespace = node.namespace;
        if (node["x-attribsNamespace"]) clone["x-attribsNamespace"] = (0, $do9pw._)({}, node["x-attribsNamespace"]);
        if (node["x-attribsPrefix"]) clone["x-attribsPrefix"] = (0, $do9pw._)({}, node["x-attribsPrefix"]);
        result = clone;
    } else if ($53672faeedb40c3b$export$c2d65aed98d39b56(node)) {
        var children1 = recursive ? $53672faeedb40c3b$var$cloneChildren(node.children) : [];
        var clone1 = new $53672faeedb40c3b$export$1f8b8f7e5c763232(children1);
        children1.forEach(function(child) {
            return child.parent = clone1;
        });
        result = clone1;
    } else if ($53672faeedb40c3b$export$62858bae88b53fd0(node)) {
        var children2 = recursive ? $53672faeedb40c3b$var$cloneChildren(node.children) : [];
        var clone2 = new $53672faeedb40c3b$export$b34a105447964f9f(children2);
        children2.forEach(function(child) {
            return child.parent = clone2;
        });
        if (node["x-mode"]) clone2["x-mode"] = node["x-mode"];
        result = clone2;
    } else if ($53672faeedb40c3b$export$4b5d79f26e0e3ad5(node)) {
        var instruction = new $53672faeedb40c3b$export$9269dce19ee35e96(node.name, node.data);
        if (node["x-name"] != null) {
            instruction["x-name"] = node["x-name"];
            instruction["x-publicId"] = node["x-publicId"];
            instruction["x-systemId"] = node["x-systemId"];
        }
        result = instruction;
    } else throw new Error("Not implemented yet: ".concat(node.type));
    result.startIndex = node.startIndex;
    result.endIndex = node.endIndex;
    if (node.sourceCodeLocation != null) result.sourceCodeLocation = node.sourceCodeLocation;
    return result;
}
function $53672faeedb40c3b$var$cloneChildren(childs) {
    var children = childs.map(function(child) {
        return $53672faeedb40c3b$export$ae8e35ea29ddac22(child, true);
    });
    for(var i = 1; i < children.length; i++){
        children[i].prev = children[i - 1];
        children[i - 1].next = children[i];
    }
    return children;
}

});


parcelRegister("5lyM5", function(module, exports) {
$parcel$export(module.exports, "getFeed", function () { return (parcelRequire("bmgv1")).getFeed; });
parcelRequire("8sIsY");
parcelRequire("jsnEY");
parcelRequire("jiCwi");
parcelRequire("gS874");
parcelRequire("jN9Ry");
parcelRequire("1IrSv");
parcelRequire("bmgv1");
parcelRequire("7UyMy");
var $79X3L = parcelRequire("79X3L");

});
parcelRegister("8sIsY", function(module, exports) {

$parcel$export(module.exports, "textContent", function () { return $62936e583f8d2a3a$export$e0e0794250e9118f; });
parcelRequire("7UyMy");
var $79X3L = parcelRequire("79X3L");

var $jPViD = parcelRequire("jPViD");

var $3Qx6e = parcelRequire("3Qx6e");
function $62936e583f8d2a3a$export$39484b727cc2f324(node, options) {
    return (0, $jPViD.default)(node, options);
}
function $62936e583f8d2a3a$export$7ed15b4d2218408(node, options) {
    return (0, $79X3L.hasChildren)(node) ? node.children.map(function(node) {
        return $62936e583f8d2a3a$export$39484b727cc2f324(node, options);
    }).join("") : "";
}
function $62936e583f8d2a3a$export$c72d34660a162238(node) {
    if (Array.isArray(node)) return node.map($62936e583f8d2a3a$export$c72d34660a162238).join("");
    if ((0, $79X3L.isTag)(node)) return node.name === "br" ? "\n" : $62936e583f8d2a3a$export$c72d34660a162238(node.children);
    if ((0, $79X3L.isCDATA)(node)) return $62936e583f8d2a3a$export$c72d34660a162238(node.children);
    if ((0, $79X3L.isText)(node)) return node.data;
    return "";
}
function $62936e583f8d2a3a$export$e0e0794250e9118f(node) {
    if (Array.isArray(node)) return node.map($62936e583f8d2a3a$export$e0e0794250e9118f).join("");
    if ((0, $79X3L.hasChildren)(node) && !(0, $79X3L.isComment)(node)) return $62936e583f8d2a3a$export$e0e0794250e9118f(node.children);
    if ((0, $79X3L.isText)(node)) return node.data;
    return "";
}
function $62936e583f8d2a3a$export$5864bc2a45f1eb81(node) {
    if (Array.isArray(node)) return node.map($62936e583f8d2a3a$export$5864bc2a45f1eb81).join("");
    if ((0, $79X3L.hasChildren)(node) && (node.type === (0, $3Qx6e.ElementType).Tag || (0, $79X3L.isCDATA)(node))) return $62936e583f8d2a3a$export$5864bc2a45f1eb81(node.children);
    if ((0, $79X3L.isText)(node)) return node.data;
    return "";
}

});
parcelRegister("jPViD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e70f3a3e69ac841c$export$2e2bcd8739ae039; });
/*
 * Module dependencies
 */ 
var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $3Qx6e = parcelRequire("3Qx6e");
parcelRequire("9ICgo");
var $34Tlx = parcelRequire("34Tlx");

var $2H2Iy = parcelRequire("2H2Iy");
var $e70f3a3e69ac841c$var$unencodedElements = new Set([
    "style",
    "script",
    "xmp",
    "iframe",
    "noembed",
    "noframes",
    "plaintext",
    "noscript"
]);
function $e70f3a3e69ac841c$var$replaceQuotes(value) {
    return value.replace(/"/g, "&quot;");
}
/**
 * Format attributes
 */ function $e70f3a3e69ac841c$var$formatAttributes(attributes, opts) {
    var _a;
    if (!attributes) return;
    var encode = ((_a = opts.encodeEntities) !== null && _a !== void 0 ? _a : opts.decodeEntities) === false ? $e70f3a3e69ac841c$var$replaceQuotes : opts.xmlMode || opts.encodeEntities !== "utf8" ? (0, $34Tlx.encodeXML) : (0, $34Tlx.escapeAttribute);
    return Object.keys(attributes).map(function(key) {
        var _a, _b;
        var value = (_a = attributes[key]) !== null && _a !== void 0 ? _a : "";
        if (opts.xmlMode === "foreign") /* Fix up mixed-case attribute names */ key = (_b = (0, $2H2Iy.attributeNames).get(key)) !== null && _b !== void 0 ? _b : key;
        if (!opts.emptyAttrs && !opts.xmlMode && value === "") return key;
        return "".concat(key, '="').concat(encode(value), '"');
    }).join(" ");
}
/**
 * Self-enclosing tags
 */ var $e70f3a3e69ac841c$var$singleTag = new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
]);
function $e70f3a3e69ac841c$export$b3890eb0ae9dca99(node) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var nodes = "length" in node ? node : [
        node
    ];
    var output = "";
    for(var i = 0; i < nodes.length; i++)output += $e70f3a3e69ac841c$var$renderNode(nodes[i], options);
    return output;
}
var $e70f3a3e69ac841c$export$2e2bcd8739ae039 = $e70f3a3e69ac841c$export$b3890eb0ae9dca99;
function $e70f3a3e69ac841c$var$renderNode(node, options) {
    switch(node.type){
        case $3Qx6e.Root:
            return $e70f3a3e69ac841c$export$b3890eb0ae9dca99(node.children, options);
        // @ts-expect-error We don't use `Doctype` yet
        case $3Qx6e.Doctype:
        case $3Qx6e.Directive:
            return $e70f3a3e69ac841c$var$renderDirective(node);
        case $3Qx6e.Comment:
            return $e70f3a3e69ac841c$var$renderComment(node);
        case $3Qx6e.CDATA:
            return $e70f3a3e69ac841c$var$renderCdata(node);
        case $3Qx6e.Script:
        case $3Qx6e.Style:
        case $3Qx6e.Tag:
            return $e70f3a3e69ac841c$var$renderTag(node, options);
        case $3Qx6e.Text:
            return $e70f3a3e69ac841c$var$renderText(node, options);
    }
}
var $e70f3a3e69ac841c$var$foreignModeIntegrationPoints = new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignObject",
    "desc",
    "title"
]);
var $e70f3a3e69ac841c$var$foreignElements = new Set([
    "svg",
    "math"
]);
function $e70f3a3e69ac841c$var$renderTag(elem, opts) {
    var _a;
    // Handle SVG / MathML in HTML
    if (opts.xmlMode === "foreign") {
        /* Fix up mixed-case element names */ elem.name = (_a = (0, $2H2Iy.elementNames).get(elem.name)) !== null && _a !== void 0 ? _a : elem.name;
        /* Exit foreign mode at integration points */ if (elem.parent && $e70f3a3e69ac841c$var$foreignModeIntegrationPoints.has(elem.parent.name)) opts = (0, $cxjpp._)((0, $do9pw._)({}, opts), {
            xmlMode: false
        });
    }
    if (!opts.xmlMode && $e70f3a3e69ac841c$var$foreignElements.has(elem.name)) opts = (0, $cxjpp._)((0, $do9pw._)({}, opts), {
        xmlMode: "foreign"
    });
    var tag = "<".concat(elem.name);
    var attribs = $e70f3a3e69ac841c$var$formatAttributes(elem.attribs, opts);
    if (attribs) tag += " ".concat(attribs);
    if (elem.children.length === 0 && (opts.xmlMode ? opts.selfClosingTags !== false : opts.selfClosingTags && $e70f3a3e69ac841c$var$singleTag.has(elem.name))) {
        if (!opts.xmlMode) tag += " ";
        tag += "/>";
    } else {
        tag += ">";
        if (elem.children.length > 0) tag += $e70f3a3e69ac841c$export$b3890eb0ae9dca99(elem.children, opts);
        if (opts.xmlMode || !$e70f3a3e69ac841c$var$singleTag.has(elem.name)) tag += "</".concat(elem.name, ">");
    }
    return tag;
}
function $e70f3a3e69ac841c$var$renderDirective(elem) {
    return "<".concat(elem.data, ">");
}
function $e70f3a3e69ac841c$var$renderText(elem, opts) {
    var _a;
    var data = elem.data || "";
    // If entities weren't decoded, no need to encode them back
    if (((_a = opts.encodeEntities) !== null && _a !== void 0 ? _a : opts.decodeEntities) !== false && !(!opts.xmlMode && elem.parent && $e70f3a3e69ac841c$var$unencodedElements.has(elem.parent.name))) data = opts.xmlMode || opts.encodeEntities !== "utf8" ? (0, $34Tlx.encodeXML)(data) : (0, $34Tlx.escapeText)(data);
    return data;
}
function $e70f3a3e69ac841c$var$renderCdata(elem) {
    return "<![CDATA[".concat(elem.children[0].data, "]]>");
}
function $e70f3a3e69ac841c$var$renderComment(elem) {
    return "<!--".concat(elem.data, "-->");
}

});
parcelRegister("9ICgo", function(module, exports) {

$parcel$export(module.exports, "encodeXML", function () { return (parcelRequire("34Tlx")).encodeXML; });
$parcel$export(module.exports, "escapeAttribute", function () { return (parcelRequire("34Tlx")).escapeAttribute; });
$parcel$export(module.exports, "escapeText", function () { return (parcelRequire("34Tlx")).escapeText; });

var $5zXAY = parcelRequire("5zXAY");

var $gYsdX = parcelRequire("gYsdX");

var $34Tlx = parcelRequire("34Tlx");
var $7135e76a1bd347d5$export$b8c86583d9718b50;
(function(EntityLevel) {
    /** Support only XML entities. */ EntityLevel[EntityLevel["XML"] = 0] = "XML";
    /** Support HTML entities, which are a superset of XML entities. */ EntityLevel[EntityLevel["HTML"] = 1] = "HTML";
})($7135e76a1bd347d5$export$b8c86583d9718b50 || ($7135e76a1bd347d5$export$b8c86583d9718b50 = {}));
var $7135e76a1bd347d5$export$1851b20d614eb756;
(function(EncodingMode) {
    /**
     * The output is UTF-8 encoded. Only characters that need escaping within
     * XML will be escaped.
     */ EncodingMode[EncodingMode["UTF8"] = 0] = "UTF8";
    /**
     * The output consists only of ASCII characters. Characters that need
     * escaping within HTML, and characters that aren't ASCII characters will
     * be escaped.
     */ EncodingMode[EncodingMode["ASCII"] = 1] = "ASCII";
    /**
     * Encode all characters that have an equivalent entity, as well as all
     * characters that are not ASCII characters.
     */ EncodingMode[EncodingMode["Extensive"] = 2] = "Extensive";
    /**
     * Encode all characters that have to be escaped in HTML attributes,
     * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
     */ EncodingMode[EncodingMode["Attribute"] = 3] = "Attribute";
    /**
     * Encode all characters that have to be escaped in HTML text,
     * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
     */ EncodingMode[EncodingMode["Text"] = 4] = "Text";
})($7135e76a1bd347d5$export$1851b20d614eb756 || ($7135e76a1bd347d5$export$1851b20d614eb756 = {}));
function $7135e76a1bd347d5$export$2f872c0f2117be69(data) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $7135e76a1bd347d5$export$b8c86583d9718b50.XML;
    var level = typeof options === "number" ? options : options.level;
    if (level === $7135e76a1bd347d5$export$b8c86583d9718b50.HTML) {
        var mode = typeof options === "object" ? options.mode : undefined;
        return (0, $5zXAY.decodeHTML)(data, mode);
    }
    return (0, $5zXAY.decodeXML)(data);
}
function $7135e76a1bd347d5$export$c94669f4c7d36be4(data) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $7135e76a1bd347d5$export$b8c86583d9718b50.XML;
    var _a;
    var opts = typeof options === "number" ? {
        level: options
    } : options;
    (_a = opts.mode) !== null && _a !== void 0 ? _a : opts.mode = (0, $5zXAY.DecodingMode).Strict;
    return $7135e76a1bd347d5$export$2f872c0f2117be69(data, opts);
}
function $7135e76a1bd347d5$export$c564cdbbe6da493(data) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $7135e76a1bd347d5$export$b8c86583d9718b50.XML;
    var opts = typeof options === "number" ? {
        level: options
    } : options;
    // Mode `UTF8` just escapes XML entities
    if (opts.mode === $7135e76a1bd347d5$export$1851b20d614eb756.UTF8) return (0, $34Tlx.escapeUTF8)(data);
    if (opts.mode === $7135e76a1bd347d5$export$1851b20d614eb756.Attribute) return (0, $34Tlx.escapeAttribute)(data);
    if (opts.mode === $7135e76a1bd347d5$export$1851b20d614eb756.Text) return (0, $34Tlx.escapeText)(data);
    if (opts.level === $7135e76a1bd347d5$export$b8c86583d9718b50.HTML) {
        if (opts.mode === $7135e76a1bd347d5$export$1851b20d614eb756.ASCII) return (0, $gYsdX.encodeNonAsciiHTML)(data);
        return (0, $gYsdX.encodeHTML)(data);
    }
    // ASCII and Extensive are equivalent
    return (0, $34Tlx.encodeXML)(data);
}

});
parcelRegister("5zXAY", function(module, exports) {

$parcel$export(module.exports, "DecodingMode", function () { return $40fe73073b33f821$export$8c8f129ce60f53c; });
$parcel$export(module.exports, "decodeHTML", function () { return $40fe73073b33f821$export$f045cb747ce77a19; });
$parcel$export(module.exports, "decodeXML", function () { return $40fe73073b33f821$export$88e3b9643a8bd06e; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $fG71e = parcelRequire("fG71e");

var $Gij1U = parcelRequire("Gij1U");

var $aGPEI = parcelRequire("aGPEI");
var $40fe73073b33f821$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["NUM"] = 35] = "NUM";
    CharCodes[CharCodes["SEMI"] = 59] = "SEMI";
    CharCodes[CharCodes["EQUALS"] = 61] = "EQUALS";
    CharCodes[CharCodes["ZERO"] = 48] = "ZERO";
    CharCodes[CharCodes["NINE"] = 57] = "NINE";
    CharCodes[CharCodes["LOWER_A"] = 97] = "LOWER_A";
    CharCodes[CharCodes["LOWER_F"] = 102] = "LOWER_F";
    CharCodes[CharCodes["LOWER_X"] = 120] = "LOWER_X";
    CharCodes[CharCodes["LOWER_Z"] = 122] = "LOWER_Z";
    CharCodes[CharCodes["UPPER_A"] = 65] = "UPPER_A";
    CharCodes[CharCodes["UPPER_F"] = 70] = "UPPER_F";
    CharCodes[CharCodes["UPPER_Z"] = 90] = "UPPER_Z";
})($40fe73073b33f821$var$CharCodes || ($40fe73073b33f821$var$CharCodes = {}));
/** Bit that needs to be set to convert an upper case ASCII character to lower case */ var $40fe73073b33f821$var$TO_LOWER_BIT = 32;
var $40fe73073b33f821$export$6a4325c613e0faec;
(function(BinTrieFlags) {
    BinTrieFlags[BinTrieFlags["VALUE_LENGTH"] = 49152] = "VALUE_LENGTH";
    BinTrieFlags[BinTrieFlags["BRANCH_LENGTH"] = 16256] = "BRANCH_LENGTH";
    BinTrieFlags[BinTrieFlags["JUMP_TABLE"] = 127] = "JUMP_TABLE";
})($40fe73073b33f821$export$6a4325c613e0faec || ($40fe73073b33f821$export$6a4325c613e0faec = {}));
function $40fe73073b33f821$var$isNumber(code) {
    return code >= $40fe73073b33f821$var$CharCodes.ZERO && code <= $40fe73073b33f821$var$CharCodes.NINE;
}
function $40fe73073b33f821$var$isHexadecimalCharacter(code) {
    return code >= $40fe73073b33f821$var$CharCodes.UPPER_A && code <= $40fe73073b33f821$var$CharCodes.UPPER_F || code >= $40fe73073b33f821$var$CharCodes.LOWER_A && code <= $40fe73073b33f821$var$CharCodes.LOWER_F;
}
function $40fe73073b33f821$var$isAsciiAlphaNumeric(code) {
    return code >= $40fe73073b33f821$var$CharCodes.UPPER_A && code <= $40fe73073b33f821$var$CharCodes.UPPER_Z || code >= $40fe73073b33f821$var$CharCodes.LOWER_A && code <= $40fe73073b33f821$var$CharCodes.LOWER_Z || $40fe73073b33f821$var$isNumber(code);
}
/**
 * Checks if the given character is a valid end character for an entity in an attribute.
 *
 * Attribute values that aren't terminated properly aren't parsed, and shouldn't lead to a parser error.
 * See the example in https://html.spec.whatwg.org/multipage/parsing.html#named-character-reference-state
 */ function $40fe73073b33f821$var$isEntityInAttributeInvalidEnd(code) {
    return code === $40fe73073b33f821$var$CharCodes.EQUALS || $40fe73073b33f821$var$isAsciiAlphaNumeric(code);
}
var $40fe73073b33f821$var$EntityDecoderState;
(function(EntityDecoderState) {
    EntityDecoderState[EntityDecoderState["EntityStart"] = 0] = "EntityStart";
    EntityDecoderState[EntityDecoderState["NumericStart"] = 1] = "NumericStart";
    EntityDecoderState[EntityDecoderState["NumericDecimal"] = 2] = "NumericDecimal";
    EntityDecoderState[EntityDecoderState["NumericHex"] = 3] = "NumericHex";
    EntityDecoderState[EntityDecoderState["NamedEntity"] = 4] = "NamedEntity";
})($40fe73073b33f821$var$EntityDecoderState || ($40fe73073b33f821$var$EntityDecoderState = {}));
var $40fe73073b33f821$export$8c8f129ce60f53c;
(function(DecodingMode) {
    /** Entities in text nodes that can end with any character. */ DecodingMode[DecodingMode["Legacy"] = 0] = "Legacy";
    /** Only allow entities terminated with a semicolon. */ DecodingMode[DecodingMode["Strict"] = 1] = "Strict";
    /** Entities in attributes have limitations on ending characters. */ DecodingMode[DecodingMode["Attribute"] = 2] = "Attribute";
})($40fe73073b33f821$export$8c8f129ce60f53c || ($40fe73073b33f821$export$8c8f129ce60f53c = {}));
var $40fe73073b33f821$export$15263a93ff7ec8ba = /*#__PURE__*/ function() {
    "use strict";
    function EntityDecoder(/** The tree used to decode entities. */ decodeTree, /**
     * The function that is called when a codepoint is decoded.
     *
     * For multi-byte named entities, this will be called multiple times,
     * with the second codepoint, and the same `consumed` value.
     *
     * @param codepoint The decoded codepoint.
     * @param consumed The number of bytes consumed by the decoder.
     */ emitCodePoint, /** An object that is used to produce errors. */ errors) {
        (0, $4GJKx._)(this, EntityDecoder);
        this.decodeTree = decodeTree;
        this.emitCodePoint = emitCodePoint;
        this.errors = errors;
        /** The current state of the decoder. */ this.state = $40fe73073b33f821$var$EntityDecoderState.EntityStart;
        /** Characters that were consumed while parsing an entity. */ this.consumed = 1;
        /**
         * The result of the entity.
         *
         * Either the result index of a numeric entity, or the codepoint of a
         * numeric entity.
         */ this.result = 0;
        /** The current index in the decode tree. */ this.treeIndex = 0;
        /** The number of characters that were consumed in excess. */ this.excess = 1;
        /** The mode in which the decoder is operating. */ this.decodeMode = $40fe73073b33f821$export$8c8f129ce60f53c.Strict;
    }
    (0, $1wc17._)(EntityDecoder, [
        {
            /** Resets the instance to make it reusable. */ key: "startEntity",
            value: function startEntity(decodeMode) {
                this.decodeMode = decodeMode;
                this.state = $40fe73073b33f821$var$EntityDecoderState.EntityStart;
                this.result = 0;
                this.treeIndex = 0;
                this.excess = 1;
                this.consumed = 1;
            }
        },
        {
            /**
     * Write an entity to the decoder. This can be called multiple times with partial entities.
     * If the entity is incomplete, the decoder will return -1.
     *
     * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
     * entity is incomplete, and resume when the next string is written.
     *
     * @param string The string containing the entity (or a continuation of the entity).
     * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ key: "write",
            value: function write(str, offset) {
                switch(this.state){
                    case $40fe73073b33f821$var$EntityDecoderState.EntityStart:
                        if (str.charCodeAt(offset) === $40fe73073b33f821$var$CharCodes.NUM) {
                            this.state = $40fe73073b33f821$var$EntityDecoderState.NumericStart;
                            this.consumed += 1;
                            return this.stateNumericStart(str, offset + 1);
                        }
                        this.state = $40fe73073b33f821$var$EntityDecoderState.NamedEntity;
                        return this.stateNamedEntity(str, offset);
                    case $40fe73073b33f821$var$EntityDecoderState.NumericStart:
                        return this.stateNumericStart(str, offset);
                    case $40fe73073b33f821$var$EntityDecoderState.NumericDecimal:
                        return this.stateNumericDecimal(str, offset);
                    case $40fe73073b33f821$var$EntityDecoderState.NumericHex:
                        return this.stateNumericHex(str, offset);
                    case $40fe73073b33f821$var$EntityDecoderState.NamedEntity:
                        return this.stateNamedEntity(str, offset);
                }
            }
        },
        {
            /**
     * Switches between the numeric decimal and hexadecimal states.
     *
     * Equivalent to the `Numeric character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ key: "stateNumericStart",
            value: function stateNumericStart(str, offset) {
                if (offset >= str.length) return -1;
                if ((str.charCodeAt(offset) | $40fe73073b33f821$var$TO_LOWER_BIT) === $40fe73073b33f821$var$CharCodes.LOWER_X) {
                    this.state = $40fe73073b33f821$var$EntityDecoderState.NumericHex;
                    this.consumed += 1;
                    return this.stateNumericHex(str, offset + 1);
                }
                this.state = $40fe73073b33f821$var$EntityDecoderState.NumericDecimal;
                return this.stateNumericDecimal(str, offset);
            }
        },
        {
            key: "addToNumericResult",
            value: function addToNumericResult(str, start, end, base) {
                if (start !== end) {
                    var digitCount = end - start;
                    this.result = this.result * Math.pow(base, digitCount) + parseInt(str.substr(start, digitCount), base);
                    this.consumed += digitCount;
                }
            }
        },
        {
            /**
     * Parses a hexadecimal numeric entity.
     *
     * Equivalent to the `Hexademical character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ key: "stateNumericHex",
            value: function stateNumericHex(str, offset) {
                var startIdx = offset;
                while(offset < str.length){
                    var char = str.charCodeAt(offset);
                    if ($40fe73073b33f821$var$isNumber(char) || $40fe73073b33f821$var$isHexadecimalCharacter(char)) offset += 1;
                    else {
                        this.addToNumericResult(str, startIdx, offset, 16);
                        return this.emitNumericEntity(char, 3);
                    }
                }
                this.addToNumericResult(str, startIdx, offset, 16);
                return -1;
            }
        },
        {
            /**
     * Parses a decimal numeric entity.
     *
     * Equivalent to the `Decimal character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ key: "stateNumericDecimal",
            value: function stateNumericDecimal(str, offset) {
                var startIdx = offset;
                while(offset < str.length){
                    var char = str.charCodeAt(offset);
                    if ($40fe73073b33f821$var$isNumber(char)) offset += 1;
                    else {
                        this.addToNumericResult(str, startIdx, offset, 10);
                        return this.emitNumericEntity(char, 2);
                    }
                }
                this.addToNumericResult(str, startIdx, offset, 10);
                return -1;
            }
        },
        {
            /**
     * Validate and emit a numeric entity.
     *
     * Implements the logic from the `Hexademical character reference start
     * state` and `Numeric character reference end state` in the HTML spec.
     *
     * @param lastCp The last code point of the entity. Used to see if the
     *               entity was terminated with a semicolon.
     * @param expectedLength The minimum number of characters that should be
     *                       consumed. Used to validate that at least one digit
     *                       was consumed.
     * @returns The number of characters that were consumed.
     */ key: "emitNumericEntity",
            value: function emitNumericEntity(lastCp, expectedLength) {
                var _a;
                // Ensure we consumed at least one digit.
                if (this.consumed <= expectedLength) {
                    (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
                    return 0;
                }
                // Figure out if this is a legit end of the entity
                if (lastCp === $40fe73073b33f821$var$CharCodes.SEMI) this.consumed += 1;
                else if (this.decodeMode === $40fe73073b33f821$export$8c8f129ce60f53c.Strict) return 0;
                this.emitCodePoint((0, $aGPEI.replaceCodePoint)(this.result), this.consumed);
                if (this.errors) {
                    if (lastCp !== $40fe73073b33f821$var$CharCodes.SEMI) this.errors.missingSemicolonAfterCharacterReference();
                    this.errors.validateNumericCharacterReference(this.result);
                }
                return this.consumed;
            }
        },
        {
            /**
     * Parses a named entity.
     *
     * Equivalent to the `Named character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ key: "stateNamedEntity",
            value: function stateNamedEntity(str, offset) {
                var decodeTree = this.decodeTree;
                var current = decodeTree[this.treeIndex];
                // The mask is the number of bytes of the value, including the current byte.
                var valueLength = (current & $40fe73073b33f821$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
                for(; offset < str.length; offset++, this.excess++){
                    var char = str.charCodeAt(offset);
                    this.treeIndex = $40fe73073b33f821$export$44c08d99945e6276(decodeTree, current, this.treeIndex + Math.max(1, valueLength), char);
                    if (this.treeIndex < 0) return this.result === 0 || // If we are parsing an attribute
                    this.decodeMode === $40fe73073b33f821$export$8c8f129ce60f53c.Attribute && // We shouldn't have consumed any characters after the entity,
                    (valueLength === 0 || // And there should be no invalid characters.
                    $40fe73073b33f821$var$isEntityInAttributeInvalidEnd(char)) ? 0 : this.emitNotTerminatedNamedEntity();
                    current = decodeTree[this.treeIndex];
                    valueLength = (current & $40fe73073b33f821$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
                    // If the branch is a value, store it and continue
                    if (valueLength !== 0) {
                        // If the entity is terminated by a semicolon, we are done.
                        if (char === $40fe73073b33f821$var$CharCodes.SEMI) return this.emitNamedEntityData(this.treeIndex, valueLength, this.consumed + this.excess);
                        // If we encounter a non-terminated (legacy) entity while parsing strictly, then ignore it.
                        if (this.decodeMode !== $40fe73073b33f821$export$8c8f129ce60f53c.Strict) {
                            this.result = this.treeIndex;
                            this.consumed += this.excess;
                            this.excess = 0;
                        }
                    }
                }
                return -1;
            }
        },
        {
            /**
     * Emit a named entity that was not terminated with a semicolon.
     *
     * @returns The number of characters consumed.
     */ key: "emitNotTerminatedNamedEntity",
            value: function emitNotTerminatedNamedEntity() {
                var _a;
                var _this = this, result = _this.result, decodeTree = _this.decodeTree;
                var valueLength = (decodeTree[result] & $40fe73073b33f821$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
                this.emitNamedEntityData(result, valueLength, this.consumed);
                (_a = this.errors) === null || _a === void 0 || _a.missingSemicolonAfterCharacterReference();
                return this.consumed;
            }
        },
        {
            /**
     * Emit a named entity.
     *
     * @param result The index of the entity in the decode tree.
     * @param valueLength The number of bytes in the entity.
     * @param consumed The number of characters consumed.
     *
     * @returns The number of characters consumed.
     */ key: "emitNamedEntityData",
            value: function emitNamedEntityData(result, valueLength, consumed) {
                var decodeTree = this.decodeTree;
                this.emitCodePoint(valueLength === 1 ? decodeTree[result] & ~$40fe73073b33f821$export$6a4325c613e0faec.VALUE_LENGTH : decodeTree[result + 1], consumed);
                if (valueLength === 3) // For multi-byte values, we need to emit the second byte.
                this.emitCodePoint(decodeTree[result + 2], consumed);
                return consumed;
            }
        },
        {
            /**
     * Signal to the parser that the end of the input was reached.
     *
     * Remaining data will be emitted and relevant errors will be produced.
     *
     * @returns The number of characters consumed.
     */ key: "end",
            value: function end() {
                var _a;
                switch(this.state){
                    case $40fe73073b33f821$var$EntityDecoderState.NamedEntity:
                        // Emit a named entity if we have one.
                        return this.result !== 0 && (this.decodeMode !== $40fe73073b33f821$export$8c8f129ce60f53c.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
                    // Otherwise, emit a numeric entity if we have one.
                    case $40fe73073b33f821$var$EntityDecoderState.NumericDecimal:
                        return this.emitNumericEntity(0, 2);
                    case $40fe73073b33f821$var$EntityDecoderState.NumericHex:
                        return this.emitNumericEntity(0, 3);
                    case $40fe73073b33f821$var$EntityDecoderState.NumericStart:
                        (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
                        return 0;
                    case $40fe73073b33f821$var$EntityDecoderState.EntityStart:
                        // Return 0 if we have no entity.
                        return 0;
                }
            }
        }
    ]);
    return EntityDecoder;
}();
/**
 * Creates a function that decodes entities in a string.
 *
 * @param decodeTree The decode tree.
 * @returns A function that decodes entities in a string.
 */ function $40fe73073b33f821$var$getDecoder(decodeTree) {
    var ret = "";
    var decoder = new $40fe73073b33f821$export$15263a93ff7ec8ba(decodeTree, function(str) {
        return ret += (0, $aGPEI.fromCodePoint)(str);
    });
    return function decodeWithTrie(str, decodeMode) {
        var lastIndex = 0;
        var offset = 0;
        while((offset = str.indexOf("&", offset)) >= 0){
            ret += str.slice(lastIndex, offset);
            decoder.startEntity(decodeMode);
            var len = decoder.write(str, // Skip the "&"
            offset + 1);
            if (len < 0) {
                lastIndex = offset + decoder.end();
                break;
            }
            lastIndex = offset + len;
            // If `len` is 0, skip the current `&` and continue.
            offset = len === 0 ? lastIndex + 1 : lastIndex;
        }
        var result = ret + str.slice(lastIndex);
        // Make sure we don't keep a reference to the final string.
        ret = "";
        return result;
    };
}
function $40fe73073b33f821$export$44c08d99945e6276(decodeTree, current, nodeIdx, char) {
    var branchCount = (current & $40fe73073b33f821$export$6a4325c613e0faec.BRANCH_LENGTH) >> 7;
    var jumpOffset = current & $40fe73073b33f821$export$6a4325c613e0faec.JUMP_TABLE;
    // Case 1: Single branch encoded in jump offset
    if (branchCount === 0) return jumpOffset !== 0 && char === jumpOffset ? nodeIdx : -1;
    // Case 2: Multiple branches encoded in jump table
    if (jumpOffset) {
        var value = char - jumpOffset;
        return value < 0 || value >= branchCount ? -1 : decodeTree[nodeIdx + value] - 1;
    }
    // Case 3: Multiple branches encoded in dictionary
    // Binary search for the character.
    var lo = nodeIdx;
    var hi = lo + branchCount - 1;
    while(lo <= hi){
        var mid = lo + hi >>> 1;
        var midVal = decodeTree[mid];
        if (midVal < char) lo = mid + 1;
        else if (midVal > char) hi = mid - 1;
        else return decodeTree[mid + branchCount];
    }
    return -1;
}
var $40fe73073b33f821$var$htmlDecoder = $40fe73073b33f821$var$getDecoder((0, $fG71e.default));
var $40fe73073b33f821$var$xmlDecoder = $40fe73073b33f821$var$getDecoder((0, $Gij1U.default));
function $40fe73073b33f821$export$f045cb747ce77a19(str) {
    var mode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $40fe73073b33f821$export$8c8f129ce60f53c.Legacy;
    return $40fe73073b33f821$var$htmlDecoder(str, mode);
}
function $40fe73073b33f821$export$49f5e8089adb006a(str) {
    return $40fe73073b33f821$var$htmlDecoder(str, $40fe73073b33f821$export$8c8f129ce60f53c.Attribute);
}
function $40fe73073b33f821$export$da52f4371b3f37de(str) {
    return $40fe73073b33f821$var$htmlDecoder(str, $40fe73073b33f821$export$8c8f129ce60f53c.Strict);
}
function $40fe73073b33f821$export$88e3b9643a8bd06e(str) {
    return $40fe73073b33f821$var$xmlDecoder(str, $40fe73073b33f821$export$8c8f129ce60f53c.Strict);
}

});
parcelRegister("fG71e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b6a0390b28e1b369$export$2e2bcd8739ae039; });
// Generated using scripts/write-decode-map.ts
var $b6a0390b28e1b369$export$2e2bcd8739ae039 = new Uint16Array(// prettier-ignore
'\u1D41<\xd5\u0131\u028A\u049D\u057B\u05D0\u0675\u06DE\u07A2\u07D6\u080F\u0A4A\u0A91\u0DA1\u0E6D\u0F09\u0F26\u10CA\u1228\u12E1\u1415\u149D\u14C3\u14DF\u1525\x00\x00\x00\x00\x00\x00\u156B\u16CD\u198D\u1C12\u1DDD\u1F7E\u2060\u21B0\u228D\u23C0\u23FB\u2442\u2824\u2912\u2D08\u2E48\u2FCE\u3016\u32BA\u3639\u37AC\u38FE\u3A28\u3A71\u3AE0\u3B2E\u0800EMabcfglmnoprstu\\bfms\x7f\x84\x8b\x90\x95\x98\xa6\xb3\xb9\xc8\xcflig\u803B\xc6\u40C6P\u803B&\u4026cute\u803B\xc1\u40C1reve;\u4102\u0100iyx}rc\u803B\xc2\u40C2;\u4410r;\uC000\ud835\udd04rave\u803B\xc0\u40C0pha;\u4391acr;\u4100d;\u6A53\u0100gp\x9d\xa1on;\u4104f;\uC000\ud835\udd38plyFunction;\u6061ing\u803B\xc5\u40C5\u0100cs\xbe\xc3r;\uC000\ud835\udc9cign;\u6254ilde\u803B\xc3\u40C3ml\u803B\xc4\u40C4\u0400aceforsu\xe5\xfb\xfe\u0117\u011C\u0122\u0127\u012A\u0100cr\xea\xf2kslash;\u6216\u0176\xf6\xf8;\u6AE7ed;\u6306y;\u4411\u0180crt\u0105\u010B\u0114ause;\u6235noullis;\u612Ca;\u4392r;\uC000\ud835\udd05pf;\uC000\ud835\udd39eve;\u42D8c\xf2\u0113mpeq;\u624E\u0700HOacdefhilorsu\u014D\u0151\u0156\u0180\u019E\u01A2\u01B5\u01B7\u01BA\u01DC\u0215\u0273\u0278\u027Ecy;\u4427PY\u803B\xa9\u40A9\u0180cpy\u015D\u0162\u017Aute;\u4106\u0100;i\u0167\u0168\u62D2talDifferentialD;\u6145leys;\u612D\u0200aeio\u0189\u018E\u0194\u0198ron;\u410Cdil\u803B\xc7\u40C7rc;\u4108nint;\u6230ot;\u410A\u0100dn\u01A7\u01ADilla;\u40B8terDot;\u40B7\xf2\u017Fi;\u43A7rcle\u0200DMPT\u01C7\u01CB\u01D1\u01D6ot;\u6299inus;\u6296lus;\u6295imes;\u6297o\u0100cs\u01E2\u01F8kwiseContourIntegral;\u6232eCurly\u0100DQ\u0203\u020FoubleQuote;\u601Duote;\u6019\u0200lnpu\u021E\u0228\u0247\u0255on\u0100;e\u0225\u0226\u6237;\u6A74\u0180git\u022F\u0236\u023Aruent;\u6261nt;\u622FourIntegral;\u622E\u0100fr\u024C\u024E;\u6102oduct;\u6210nterClockwiseContourIntegral;\u6233oss;\u6A2Fcr;\uC000\ud835\udc9ep\u0100;C\u0284\u0285\u62D3ap;\u624D\u0580DJSZacefios\u02A0\u02AC\u02B0\u02B4\u02B8\u02CB\u02D7\u02E1\u02E6\u0333\u048D\u0100;o\u0179\u02A5trahd;\u6911cy;\u4402cy;\u4405cy;\u440F\u0180grs\u02BF\u02C4\u02C7ger;\u6021r;\u61A1hv;\u6AE4\u0100ay\u02D0\u02D5ron;\u410E;\u4414l\u0100;t\u02DD\u02DE\u6207a;\u4394r;\uC000\ud835\udd07\u0100af\u02EB\u0327\u0100cm\u02F0\u0322ritical\u0200ADGT\u0300\u0306\u0316\u031Ccute;\u40B4o\u0174\u030B\u030D;\u42D9bleAcute;\u42DDrave;\u4060ilde;\u42DCond;\u62C4ferentialD;\u6146\u0470\u033D\x00\x00\x00\u0342\u0354\x00\u0405f;\uC000\ud835\udd3b\u0180;DE\u0348\u0349\u034D\u40A8ot;\u60DCqual;\u6250ble\u0300CDLRUV\u0363\u0372\u0382\u03CF\u03E2\u03F8ontourIntegra\xec\u0239o\u0274\u0379\x00\x00\u037B\xbb\u0349nArrow;\u61D3\u0100eo\u0387\u03A4ft\u0180ART\u0390\u0396\u03A1rrow;\u61D0ightArrow;\u61D4e\xe5\u02CAng\u0100LR\u03AB\u03C4eft\u0100AR\u03B3\u03B9rrow;\u67F8ightArrow;\u67FAightArrow;\u67F9ight\u0100AT\u03D8\u03DErrow;\u61D2ee;\u62A8p\u0241\u03E9\x00\x00\u03EFrrow;\u61D1ownArrow;\u61D5erticalBar;\u6225n\u0300ABLRTa\u0412\u042A\u0430\u045E\u047F\u037Crrow\u0180;BU\u041D\u041E\u0422\u6193ar;\u6913pArrow;\u61F5reve;\u4311eft\u02D2\u043A\x00\u0446\x00\u0450ightVector;\u6950eeVector;\u695Eector\u0100;B\u0459\u045A\u61BDar;\u6956ight\u01D4\u0467\x00\u0471eeVector;\u695Fector\u0100;B\u047A\u047B\u61C1ar;\u6957ee\u0100;A\u0486\u0487\u62A4rrow;\u61A7\u0100ct\u0492\u0497r;\uC000\ud835\udc9frok;\u4110\u0800NTacdfglmopqstux\u04BD\u04C0\u04C4\u04CB\u04DE\u04E2\u04E7\u04EE\u04F5\u0521\u052F\u0536\u0552\u055D\u0560\u0565G;\u414AH\u803B\xd0\u40D0cute\u803B\xc9\u40C9\u0180aiy\u04D2\u04D7\u04DCron;\u411Arc\u803B\xca\u40CA;\u442Dot;\u4116r;\uC000\ud835\udd08rave\u803B\xc8\u40C8ement;\u6208\u0100ap\u04FA\u04FEcr;\u4112ty\u0253\u0506\x00\x00\u0512mallSquare;\u65FBerySmallSquare;\u65AB\u0100gp\u0526\u052Aon;\u4118f;\uC000\ud835\udd3csilon;\u4395u\u0100ai\u053C\u0549l\u0100;T\u0542\u0543\u6A75ilde;\u6242librium;\u61CC\u0100ci\u0557\u055Ar;\u6130m;\u6A73a;\u4397ml\u803B\xcb\u40CB\u0100ip\u056A\u056Fsts;\u6203onentialE;\u6147\u0280cfios\u0585\u0588\u058D\u05B2\u05CCy;\u4424r;\uC000\ud835\udd09lled\u0253\u0597\x00\x00\u05A3mallSquare;\u65FCerySmallSquare;\u65AA\u0370\u05BA\x00\u05BF\x00\x00\u05C4f;\uC000\ud835\udd3dAll;\u6200riertrf;\u6131c\xf2\u05CB\u0600JTabcdfgorst\u05E8\u05EC\u05EF\u05FA\u0600\u0612\u0616\u061B\u061D\u0623\u066C\u0672cy;\u4403\u803B>\u403Emma\u0100;d\u05F7\u05F8\u4393;\u43DCreve;\u411E\u0180eiy\u0607\u060C\u0610dil;\u4122rc;\u411C;\u4413ot;\u4120r;\uC000\ud835\udd0a;\u62D9pf;\uC000\ud835\udd3eeater\u0300EFGLST\u0635\u0644\u064E\u0656\u065B\u0666qual\u0100;L\u063E\u063F\u6265ess;\u62DBullEqual;\u6267reater;\u6AA2ess;\u6277lantEqual;\u6A7Eilde;\u6273cr;\uC000\ud835\udca2;\u626B\u0400Aacfiosu\u0685\u068B\u0696\u069B\u069E\u06AA\u06BE\u06CARDcy;\u442A\u0100ct\u0690\u0694ek;\u42C7;\u405Eirc;\u4124r;\u610ClbertSpace;\u610B\u01F0\u06AF\x00\u06B2f;\u610DizontalLine;\u6500\u0100ct\u06C3\u06C5\xf2\u06A9rok;\u4126mp\u0144\u06D0\u06D8ownHum\xf0\u012Fqual;\u624F\u0700EJOacdfgmnostu\u06FA\u06FE\u0703\u0707\u070E\u071A\u071E\u0721\u0728\u0744\u0778\u078B\u078F\u0795cy;\u4415lig;\u4132cy;\u4401cute\u803B\xcd\u40CD\u0100iy\u0713\u0718rc\u803B\xce\u40CE;\u4418ot;\u4130r;\u6111rave\u803B\xcc\u40CC\u0180;ap\u0720\u072F\u073F\u0100cg\u0734\u0737r;\u412AinaryI;\u6148lie\xf3\u03DD\u01F4\u0749\x00\u0762\u0100;e\u074D\u074E\u622C\u0100gr\u0753\u0758ral;\u622Bsection;\u62C2isible\u0100CT\u076C\u0772omma;\u6063imes;\u6062\u0180gpt\u077F\u0783\u0788on;\u412Ef;\uC000\ud835\udd40a;\u4399cr;\u6110ilde;\u4128\u01EB\u079A\x00\u079Ecy;\u4406l\u803B\xcf\u40CF\u0280cfosu\u07AC\u07B7\u07BC\u07C2\u07D0\u0100iy\u07B1\u07B5rc;\u4134;\u4419r;\uC000\ud835\udd0dpf;\uC000\ud835\udd41\u01E3\u07C7\x00\u07CCr;\uC000\ud835\udca5rcy;\u4408kcy;\u4404\u0380HJacfos\u07E4\u07E8\u07EC\u07F1\u07FD\u0802\u0808cy;\u4425cy;\u440Cppa;\u439A\u0100ey\u07F6\u07FBdil;\u4136;\u441Ar;\uC000\ud835\udd0epf;\uC000\ud835\udd42cr;\uC000\ud835\udca6\u0580JTaceflmost\u0825\u0829\u082C\u0850\u0863\u09B3\u09B8\u09C7\u09CD\u0A37\u0A47cy;\u4409\u803B<\u403C\u0280cmnpr\u0837\u083C\u0841\u0844\u084Dute;\u4139bda;\u439Bg;\u67EAlacetrf;\u6112r;\u619E\u0180aey\u0857\u085C\u0861ron;\u413Ddil;\u413B;\u441B\u0100fs\u0868\u0970t\u0500ACDFRTUVar\u087E\u08A9\u08B1\u08E0\u08E6\u08FC\u092F\u095B\u0390\u096A\u0100nr\u0883\u088FgleBracket;\u67E8row\u0180;BR\u0899\u089A\u089E\u6190ar;\u61E4ightArrow;\u61C6eiling;\u6308o\u01F5\u08B7\x00\u08C3bleBracket;\u67E6n\u01D4\u08C8\x00\u08D2eeVector;\u6961ector\u0100;B\u08DB\u08DC\u61C3ar;\u6959loor;\u630Aight\u0100AV\u08EF\u08F5rrow;\u6194ector;\u694E\u0100er\u0901\u0917e\u0180;AV\u0909\u090A\u0910\u62A3rrow;\u61A4ector;\u695Aiangle\u0180;BE\u0924\u0925\u0929\u62B2ar;\u69CFqual;\u62B4p\u0180DTV\u0937\u0942\u094CownVector;\u6951eeVector;\u6960ector\u0100;B\u0956\u0957\u61BFar;\u6958ector\u0100;B\u0965\u0966\u61BCar;\u6952ight\xe1\u039Cs\u0300EFGLST\u097E\u098B\u0995\u099D\u09A2\u09ADqualGreater;\u62DAullEqual;\u6266reater;\u6276ess;\u6AA1lantEqual;\u6A7Dilde;\u6272r;\uC000\ud835\udd0f\u0100;e\u09BD\u09BE\u62D8ftarrow;\u61DAidot;\u413F\u0180npw\u09D4\u0A16\u0A1Bg\u0200LRlr\u09DE\u09F7\u0A02\u0A10eft\u0100AR\u09E6\u09ECrrow;\u67F5ightArrow;\u67F7ightArrow;\u67F6eft\u0100ar\u03B3\u0A0Aight\xe1\u03BFight\xe1\u03CAf;\uC000\ud835\udd43er\u0100LR\u0A22\u0A2CeftArrow;\u6199ightArrow;\u6198\u0180cht\u0A3E\u0A40\u0A42\xf2\u084C;\u61B0rok;\u4141;\u626A\u0400acefiosu\u0A5A\u0A5D\u0A60\u0A77\u0A7C\u0A85\u0A8B\u0A8Ep;\u6905y;\u441C\u0100dl\u0A65\u0A6FiumSpace;\u605Flintrf;\u6133r;\uC000\ud835\udd10nusPlus;\u6213pf;\uC000\ud835\udd44c\xf2\u0A76;\u439C\u0480Jacefostu\u0AA3\u0AA7\u0AAD\u0AC0\u0B14\u0B19\u0D91\u0D97\u0D9Ecy;\u440Acute;\u4143\u0180aey\u0AB4\u0AB9\u0ABEron;\u4147dil;\u4145;\u441D\u0180gsw\u0AC7\u0AF0\u0B0Eative\u0180MTV\u0AD3\u0ADF\u0AE8ediumSpace;\u600Bhi\u0100cn\u0AE6\u0AD8\xeb\u0AD9eryThi\xee\u0AD9ted\u0100GL\u0AF8\u0B06reaterGreate\xf2\u0673essLes\xf3\u0A48Line;\u400Ar;\uC000\ud835\udd11\u0200Bnpt\u0B22\u0B28\u0B37\u0B3Areak;\u6060BreakingSpace;\u40A0f;\u6115\u0680;CDEGHLNPRSTV\u0B55\u0B56\u0B6A\u0B7C\u0BA1\u0BEB\u0C04\u0C5E\u0C84\u0CA6\u0CD8\u0D61\u0D85\u6AEC\u0100ou\u0B5B\u0B64ngruent;\u6262pCap;\u626DoubleVerticalBar;\u6226\u0180lqx\u0B83\u0B8A\u0B9Bement;\u6209ual\u0100;T\u0B92\u0B93\u6260ilde;\uC000\u2242\u0338ists;\u6204reater\u0380;EFGLST\u0BB6\u0BB7\u0BBD\u0BC9\u0BD3\u0BD8\u0BE5\u626Fqual;\u6271ullEqual;\uC000\u2267\u0338reater;\uC000\u226B\u0338ess;\u6279lantEqual;\uC000\u2A7E\u0338ilde;\u6275ump\u0144\u0BF2\u0BFDownHump;\uC000\u224E\u0338qual;\uC000\u224F\u0338e\u0100fs\u0C0A\u0C27tTriangle\u0180;BE\u0C1A\u0C1B\u0C21\u62EAar;\uC000\u29CF\u0338qual;\u62ECs\u0300;EGLST\u0C35\u0C36\u0C3C\u0C44\u0C4B\u0C58\u626Equal;\u6270reater;\u6278ess;\uC000\u226A\u0338lantEqual;\uC000\u2A7D\u0338ilde;\u6274ested\u0100GL\u0C68\u0C79reaterGreater;\uC000\u2AA2\u0338essLess;\uC000\u2AA1\u0338recedes\u0180;ES\u0C92\u0C93\u0C9B\u6280qual;\uC000\u2AAF\u0338lantEqual;\u62E0\u0100ei\u0CAB\u0CB9verseElement;\u620CghtTriangle\u0180;BE\u0CCB\u0CCC\u0CD2\u62EBar;\uC000\u29D0\u0338qual;\u62ED\u0100qu\u0CDD\u0D0CuareSu\u0100bp\u0CE8\u0CF9set\u0100;E\u0CF0\u0CF3\uC000\u228F\u0338qual;\u62E2erset\u0100;E\u0D03\u0D06\uC000\u2290\u0338qual;\u62E3\u0180bcp\u0D13\u0D24\u0D4Eset\u0100;E\u0D1B\u0D1E\uC000\u2282\u20D2qual;\u6288ceeds\u0200;EST\u0D32\u0D33\u0D3B\u0D46\u6281qual;\uC000\u2AB0\u0338lantEqual;\u62E1ilde;\uC000\u227F\u0338erset\u0100;E\u0D58\u0D5B\uC000\u2283\u20D2qual;\u6289ilde\u0200;EFT\u0D6E\u0D6F\u0D75\u0D7F\u6241qual;\u6244ullEqual;\u6247ilde;\u6249erticalBar;\u6224cr;\uC000\ud835\udca9ilde\u803B\xd1\u40D1;\u439D\u0700Eacdfgmoprstuv\u0DBD\u0DC2\u0DC9\u0DD5\u0DDB\u0DE0\u0DE7\u0DFC\u0E02\u0E20\u0E22\u0E32\u0E3F\u0E44lig;\u4152cute\u803B\xd3\u40D3\u0100iy\u0DCE\u0DD3rc\u803B\xd4\u40D4;\u441Eblac;\u4150r;\uC000\ud835\udd12rave\u803B\xd2\u40D2\u0180aei\u0DEE\u0DF2\u0DF6cr;\u414Cga;\u43A9cron;\u439Fpf;\uC000\ud835\udd46enCurly\u0100DQ\u0E0E\u0E1AoubleQuote;\u601Cuote;\u6018;\u6A54\u0100cl\u0E27\u0E2Cr;\uC000\ud835\udcaaash\u803B\xd8\u40D8i\u016C\u0E37\u0E3Cde\u803B\xd5\u40D5es;\u6A37ml\u803B\xd6\u40D6er\u0100BP\u0E4B\u0E60\u0100ar\u0E50\u0E53r;\u603Eac\u0100ek\u0E5A\u0E5C;\u63DEet;\u63B4arenthesis;\u63DC\u0480acfhilors\u0E7F\u0E87\u0E8A\u0E8F\u0E92\u0E94\u0E9D\u0EB0\u0EFCrtialD;\u6202y;\u441Fr;\uC000\ud835\udd13i;\u43A6;\u43A0usMinus;\u40B1\u0100ip\u0EA2\u0EADncareplan\xe5\u069Df;\u6119\u0200;eio\u0EB9\u0EBA\u0EE0\u0EE4\u6ABBcedes\u0200;EST\u0EC8\u0EC9\u0ECF\u0EDA\u627Aqual;\u6AAFlantEqual;\u627Cilde;\u627Eme;\u6033\u0100dp\u0EE9\u0EEEuct;\u620Fortion\u0100;a\u0225\u0EF9l;\u621D\u0100ci\u0F01\u0F06r;\uC000\ud835\udcab;\u43A8\u0200Ufos\u0F11\u0F16\u0F1B\u0F1FOT\u803B"\u4022r;\uC000\ud835\udd14pf;\u611Acr;\uC000\ud835\udcac\u0600BEacefhiorsu\u0F3E\u0F43\u0F47\u0F60\u0F73\u0FA7\u0FAA\u0FAD\u1096\u10A9\u10B4\u10BEarr;\u6910G\u803B\xae\u40AE\u0180cnr\u0F4E\u0F53\u0F56ute;\u4154g;\u67EBr\u0100;t\u0F5C\u0F5D\u61A0l;\u6916\u0180aey\u0F67\u0F6C\u0F71ron;\u4158dil;\u4156;\u4420\u0100;v\u0F78\u0F79\u611Cerse\u0100EU\u0F82\u0F99\u0100lq\u0F87\u0F8Eement;\u620Builibrium;\u61CBpEquilibrium;\u696Fr\xbb\u0F79o;\u43A1ght\u0400ACDFTUVa\u0FC1\u0FEB\u0FF3\u1022\u1028\u105B\u1087\u03D8\u0100nr\u0FC6\u0FD2gleBracket;\u67E9row\u0180;BL\u0FDC\u0FDD\u0FE1\u6192ar;\u61E5eftArrow;\u61C4eiling;\u6309o\u01F5\u0FF9\x00\u1005bleBracket;\u67E7n\u01D4\u100A\x00\u1014eeVector;\u695Dector\u0100;B\u101D\u101E\u61C2ar;\u6955loor;\u630B\u0100er\u102D\u1043e\u0180;AV\u1035\u1036\u103C\u62A2rrow;\u61A6ector;\u695Biangle\u0180;BE\u1050\u1051\u1055\u62B3ar;\u69D0qual;\u62B5p\u0180DTV\u1063\u106E\u1078ownVector;\u694FeeVector;\u695Cector\u0100;B\u1082\u1083\u61BEar;\u6954ector\u0100;B\u1091\u1092\u61C0ar;\u6953\u0100pu\u109B\u109Ef;\u611DndImplies;\u6970ightarrow;\u61DB\u0100ch\u10B9\u10BCr;\u611B;\u61B1leDelayed;\u69F4\u0680HOacfhimoqstu\u10E4\u10F1\u10F7\u10FD\u1119\u111E\u1151\u1156\u1161\u1167\u11B5\u11BB\u11BF\u0100Cc\u10E9\u10EEHcy;\u4429y;\u4428FTcy;\u442Ccute;\u415A\u0280;aeiy\u1108\u1109\u110E\u1113\u1117\u6ABCron;\u4160dil;\u415Erc;\u415C;\u4421r;\uC000\ud835\udd16ort\u0200DLRU\u112A\u1134\u113E\u1149ownArrow\xbb\u041EeftArrow\xbb\u089AightArrow\xbb\u0FDDpArrow;\u6191gma;\u43A3allCircle;\u6218pf;\uC000\ud835\udd4a\u0272\u116D\x00\x00\u1170t;\u621Aare\u0200;ISU\u117B\u117C\u1189\u11AF\u65A1ntersection;\u6293u\u0100bp\u118F\u119Eset\u0100;E\u1197\u1198\u628Fqual;\u6291erset\u0100;E\u11A8\u11A9\u6290qual;\u6292nion;\u6294cr;\uC000\ud835\udcaear;\u62C6\u0200bcmp\u11C8\u11DB\u1209\u120B\u0100;s\u11CD\u11CE\u62D0et\u0100;E\u11CD\u11D5qual;\u6286\u0100ch\u11E0\u1205eeds\u0200;EST\u11ED\u11EE\u11F4\u11FF\u627Bqual;\u6AB0lantEqual;\u627Dilde;\u627FTh\xe1\u0F8C;\u6211\u0180;es\u1212\u1213\u1223\u62D1rset\u0100;E\u121C\u121D\u6283qual;\u6287et\xbb\u1213\u0580HRSacfhiors\u123E\u1244\u1249\u1255\u125E\u1271\u1276\u129F\u12C2\u12C8\u12D1ORN\u803B\xde\u40DEADE;\u6122\u0100Hc\u124E\u1252cy;\u440By;\u4426\u0100bu\u125A\u125C;\u4009;\u43A4\u0180aey\u1265\u126A\u126Fron;\u4164dil;\u4162;\u4422r;\uC000\ud835\udd17\u0100ei\u127B\u1289\u01F2\u1280\x00\u1287efore;\u6234a;\u4398\u0100cn\u128E\u1298kSpace;\uC000\u205F\u200ASpace;\u6009lde\u0200;EFT\u12AB\u12AC\u12B2\u12BC\u623Cqual;\u6243ullEqual;\u6245ilde;\u6248pf;\uC000\ud835\udd4bipleDot;\u60DB\u0100ct\u12D6\u12DBr;\uC000\ud835\udcafrok;\u4166\u0AE1\u12F7\u130E\u131A\u1326\x00\u132C\u1331\x00\x00\x00\x00\x00\u1338\u133D\u1377\u1385\x00\u13FF\u1404\u140A\u1410\u0100cr\u12FB\u1301ute\u803B\xda\u40DAr\u0100;o\u1307\u1308\u619Fcir;\u6949r\u01E3\u1313\x00\u1316y;\u440Eve;\u416C\u0100iy\u131E\u1323rc\u803B\xdb\u40DB;\u4423blac;\u4170r;\uC000\ud835\udd18rave\u803B\xd9\u40D9acr;\u416A\u0100di\u1341\u1369er\u0100BP\u1348\u135D\u0100ar\u134D\u1350r;\u405Fac\u0100ek\u1357\u1359;\u63DFet;\u63B5arenthesis;\u63DDon\u0100;P\u1370\u1371\u62C3lus;\u628E\u0100gp\u137B\u137Fon;\u4172f;\uC000\ud835\udd4c\u0400ADETadps\u1395\u13AE\u13B8\u13C4\u03E8\u13D2\u13D7\u13F3rrow\u0180;BD\u1150\u13A0\u13A4ar;\u6912ownArrow;\u61C5ownArrow;\u6195quilibrium;\u696Eee\u0100;A\u13CB\u13CC\u62A5rrow;\u61A5own\xe1\u03F3er\u0100LR\u13DE\u13E8eftArrow;\u6196ightArrow;\u6197i\u0100;l\u13F9\u13FA\u43D2on;\u43A5ing;\u416Ecr;\uC000\ud835\udcb0ilde;\u4168ml\u803B\xdc\u40DC\u0480Dbcdefosv\u1427\u142C\u1430\u1433\u143E\u1485\u148A\u1490\u1496ash;\u62ABar;\u6AEBy;\u4412ash\u0100;l\u143B\u143C\u62A9;\u6AE6\u0100er\u1443\u1445;\u62C1\u0180bty\u144C\u1450\u147Aar;\u6016\u0100;i\u144F\u1455cal\u0200BLST\u1461\u1465\u146A\u1474ar;\u6223ine;\u407Ceparator;\u6758ilde;\u6240ThinSpace;\u600Ar;\uC000\ud835\udd19pf;\uC000\ud835\udd4dcr;\uC000\ud835\udcb1dash;\u62AA\u0280cefos\u14A7\u14AC\u14B1\u14B6\u14BCirc;\u4174dge;\u62C0r;\uC000\ud835\udd1apf;\uC000\ud835\udd4ecr;\uC000\ud835\udcb2\u0200fios\u14CB\u14D0\u14D2\u14D8r;\uC000\ud835\udd1b;\u439Epf;\uC000\ud835\udd4fcr;\uC000\ud835\udcb3\u0480AIUacfosu\u14F1\u14F5\u14F9\u14FD\u1504\u150F\u1514\u151A\u1520cy;\u442Fcy;\u4407cy;\u442Ecute\u803B\xdd\u40DD\u0100iy\u1509\u150Drc;\u4176;\u442Br;\uC000\ud835\udd1cpf;\uC000\ud835\udd50cr;\uC000\ud835\udcb4ml;\u4178\u0400Hacdefos\u1535\u1539\u153F\u154B\u154F\u155D\u1560\u1564cy;\u4416cute;\u4179\u0100ay\u1544\u1549ron;\u417D;\u4417ot;\u417B\u01F2\u1554\x00\u155BoWidt\xe8\u0AD9a;\u4396r;\u6128pf;\u6124cr;\uC000\ud835\udcb5\u0BE1\u1583\u158A\u1590\x00\u15B0\u15B6\u15BF\x00\x00\x00\x00\u15C6\u15DB\u15EB\u165F\u166D\x00\u1695\u169B\u16B2\u16B9\x00\u16BEcute\u803B\xe1\u40E1reve;\u4103\u0300;Ediuy\u159C\u159D\u15A1\u15A3\u15A8\u15AD\u623E;\uC000\u223E\u0333;\u623Frc\u803B\xe2\u40E2te\u80BB\xb4\u0306;\u4430lig\u803B\xe6\u40E6\u0100;r\xb2\u15BA;\uC000\ud835\udd1erave\u803B\xe0\u40E0\u0100ep\u15CA\u15D6\u0100fp\u15CF\u15D4sym;\u6135\xe8\u15D3ha;\u43B1\u0100ap\u15DFc\u0100cl\u15E4\u15E7r;\u4101g;\u6A3F\u0264\u15F0\x00\x00\u160A\u0280;adsv\u15FA\u15FB\u15FF\u1601\u1607\u6227nd;\u6A55;\u6A5Clope;\u6A58;\u6A5A\u0380;elmrsz\u1618\u1619\u161B\u161E\u163F\u164F\u1659\u6220;\u69A4e\xbb\u1619sd\u0100;a\u1625\u1626\u6221\u0461\u1630\u1632\u1634\u1636\u1638\u163A\u163C\u163E;\u69A8;\u69A9;\u69AA;\u69AB;\u69AC;\u69AD;\u69AE;\u69AFt\u0100;v\u1645\u1646\u621Fb\u0100;d\u164C\u164D\u62BE;\u699D\u0100pt\u1654\u1657h;\u6222\xbb\xb9arr;\u637C\u0100gp\u1663\u1667on;\u4105f;\uC000\ud835\udd52\u0380;Eaeiop\u12C1\u167B\u167D\u1682\u1684\u1687\u168A;\u6A70cir;\u6A6F;\u624Ad;\u624Bs;\u4027rox\u0100;e\u12C1\u1692\xf1\u1683ing\u803B\xe5\u40E5\u0180cty\u16A1\u16A6\u16A8r;\uC000\ud835\udcb6;\u402Amp\u0100;e\u12C1\u16AF\xf1\u0288ilde\u803B\xe3\u40E3ml\u803B\xe4\u40E4\u0100ci\u16C2\u16C8onin\xf4\u0272nt;\u6A11\u0800Nabcdefiklnoprsu\u16ED\u16F1\u1730\u173C\u1743\u1748\u1778\u177D\u17E0\u17E6\u1839\u1850\u170D\u193D\u1948\u1970ot;\u6AED\u0100cr\u16F6\u171Ek\u0200ceps\u1700\u1705\u170D\u1713ong;\u624Cpsilon;\u43F6rime;\u6035im\u0100;e\u171A\u171B\u623Dq;\u62CD\u0176\u1722\u1726ee;\u62BDed\u0100;g\u172C\u172D\u6305e\xbb\u172Drk\u0100;t\u135C\u1737brk;\u63B6\u0100oy\u1701\u1741;\u4431quo;\u601E\u0280cmprt\u1753\u175B\u1761\u1764\u1768aus\u0100;e\u010A\u0109ptyv;\u69B0s\xe9\u170Cno\xf5\u0113\u0180ahw\u176F\u1771\u1773;\u43B2;\u6136een;\u626Cr;\uC000\ud835\udd1fg\u0380costuvw\u178D\u179D\u17B3\u17C1\u17D5\u17DB\u17DE\u0180aiu\u1794\u1796\u179A\xf0\u0760rc;\u65EFp\xbb\u1371\u0180dpt\u17A4\u17A8\u17ADot;\u6A00lus;\u6A01imes;\u6A02\u0271\u17B9\x00\x00\u17BEcup;\u6A06ar;\u6605riangle\u0100du\u17CD\u17D2own;\u65BDp;\u65B3plus;\u6A04e\xe5\u1444\xe5\u14ADarow;\u690D\u0180ako\u17ED\u1826\u1835\u0100cn\u17F2\u1823k\u0180lst\u17FA\u05AB\u1802ozenge;\u69EBriangle\u0200;dlr\u1812\u1813\u1818\u181D\u65B4own;\u65BEeft;\u65C2ight;\u65B8k;\u6423\u01B1\u182B\x00\u1833\u01B2\u182F\x00\u1831;\u6592;\u65914;\u6593ck;\u6588\u0100eo\u183E\u184D\u0100;q\u1843\u1846\uC000=\u20E5uiv;\uC000\u2261\u20E5t;\u6310\u0200ptwx\u1859\u185E\u1867\u186Cf;\uC000\ud835\udd53\u0100;t\u13CB\u1863om\xbb\u13CCtie;\u62C8\u0600DHUVbdhmptuv\u1885\u1896\u18AA\u18BB\u18D7\u18DB\u18EC\u18FF\u1905\u190A\u1910\u1921\u0200LRlr\u188E\u1890\u1892\u1894;\u6557;\u6554;\u6556;\u6553\u0280;DUdu\u18A1\u18A2\u18A4\u18A6\u18A8\u6550;\u6566;\u6569;\u6564;\u6567\u0200LRlr\u18B3\u18B5\u18B7\u18B9;\u655D;\u655A;\u655C;\u6559\u0380;HLRhlr\u18CA\u18CB\u18CD\u18CF\u18D1\u18D3\u18D5\u6551;\u656C;\u6563;\u6560;\u656B;\u6562;\u655Fox;\u69C9\u0200LRlr\u18E4\u18E6\u18E8\u18EA;\u6555;\u6552;\u6510;\u650C\u0280;DUdu\u06BD\u18F7\u18F9\u18FB\u18FD;\u6565;\u6568;\u652C;\u6534inus;\u629Flus;\u629Eimes;\u62A0\u0200LRlr\u1919\u191B\u191D\u191F;\u655B;\u6558;\u6518;\u6514\u0380;HLRhlr\u1930\u1931\u1933\u1935\u1937\u1939\u193B\u6502;\u656A;\u6561;\u655E;\u653C;\u6524;\u651C\u0100ev\u0123\u1942bar\u803B\xa6\u40A6\u0200ceio\u1951\u1956\u195A\u1960r;\uC000\ud835\udcb7mi;\u604Fm\u0100;e\u171A\u171Cl\u0180;bh\u1968\u1969\u196B\u405C;\u69C5sub;\u67C8\u016C\u1974\u197El\u0100;e\u1979\u197A\u6022t\xbb\u197Ap\u0180;Ee\u012F\u1985\u1987;\u6AAE\u0100;q\u06DC\u06DB\u0CE1\u19A7\x00\u19E8\u1A11\u1A15\u1A32\x00\u1A37\u1A50\x00\x00\u1AB4\x00\x00\u1AC1\x00\x00\u1B21\u1B2E\u1B4D\u1B52\x00\u1BFD\x00\u1C0C\u0180cpr\u19AD\u19B2\u19DDute;\u4107\u0300;abcds\u19BF\u19C0\u19C4\u19CA\u19D5\u19D9\u6229nd;\u6A44rcup;\u6A49\u0100au\u19CF\u19D2p;\u6A4Bp;\u6A47ot;\u6A40;\uC000\u2229\uFE00\u0100eo\u19E2\u19E5t;\u6041\xee\u0693\u0200aeiu\u19F0\u19FB\u1A01\u1A05\u01F0\u19F5\x00\u19F8s;\u6A4Don;\u410Ddil\u803B\xe7\u40E7rc;\u4109ps\u0100;s\u1A0C\u1A0D\u6A4Cm;\u6A50ot;\u410B\u0180dmn\u1A1B\u1A20\u1A26il\u80BB\xb8\u01ADptyv;\u69B2t\u8100\xa2;e\u1A2D\u1A2E\u40A2r\xe4\u01B2r;\uC000\ud835\udd20\u0180cei\u1A3D\u1A40\u1A4Dy;\u4447ck\u0100;m\u1A47\u1A48\u6713ark\xbb\u1A48;\u43C7r\u0380;Ecefms\u1A5F\u1A60\u1A62\u1A6B\u1AA4\u1AAA\u1AAE\u65CB;\u69C3\u0180;el\u1A69\u1A6A\u1A6D\u42C6q;\u6257e\u0261\u1A74\x00\x00\u1A88rrow\u0100lr\u1A7C\u1A81eft;\u61BAight;\u61BB\u0280RSacd\u1A92\u1A94\u1A96\u1A9A\u1A9F\xbb\u0F47;\u64C8st;\u629Birc;\u629Aash;\u629Dnint;\u6A10id;\u6AEFcir;\u69C2ubs\u0100;u\u1ABB\u1ABC\u6663it\xbb\u1ABC\u02EC\u1AC7\u1AD4\u1AFA\x00\u1B0Aon\u0100;e\u1ACD\u1ACE\u403A\u0100;q\xc7\xc6\u026D\u1AD9\x00\x00\u1AE2a\u0100;t\u1ADE\u1ADF\u402C;\u4040\u0180;fl\u1AE8\u1AE9\u1AEB\u6201\xee\u1160e\u0100mx\u1AF1\u1AF6ent\xbb\u1AE9e\xf3\u024D\u01E7\u1AFE\x00\u1B07\u0100;d\u12BB\u1B02ot;\u6A6Dn\xf4\u0246\u0180fry\u1B10\u1B14\u1B17;\uC000\ud835\udd54o\xe4\u0254\u8100\xa9;s\u0155\u1B1Dr;\u6117\u0100ao\u1B25\u1B29rr;\u61B5ss;\u6717\u0100cu\u1B32\u1B37r;\uC000\ud835\udcb8\u0100bp\u1B3C\u1B44\u0100;e\u1B41\u1B42\u6ACF;\u6AD1\u0100;e\u1B49\u1B4A\u6AD0;\u6AD2dot;\u62EF\u0380delprvw\u1B60\u1B6C\u1B77\u1B82\u1BAC\u1BD4\u1BF9arr\u0100lr\u1B68\u1B6A;\u6938;\u6935\u0270\u1B72\x00\x00\u1B75r;\u62DEc;\u62DFarr\u0100;p\u1B7F\u1B80\u61B6;\u693D\u0300;bcdos\u1B8F\u1B90\u1B96\u1BA1\u1BA5\u1BA8\u622Arcap;\u6A48\u0100au\u1B9B\u1B9Ep;\u6A46p;\u6A4Aot;\u628Dr;\u6A45;\uC000\u222A\uFE00\u0200alrv\u1BB5\u1BBF\u1BDE\u1BE3rr\u0100;m\u1BBC\u1BBD\u61B7;\u693Cy\u0180evw\u1BC7\u1BD4\u1BD8q\u0270\u1BCE\x00\x00\u1BD2re\xe3\u1B73u\xe3\u1B75ee;\u62CEedge;\u62CFen\u803B\xa4\u40A4earrow\u0100lr\u1BEE\u1BF3eft\xbb\u1B80ight\xbb\u1BBDe\xe4\u1BDD\u0100ci\u1C01\u1C07onin\xf4\u01F7nt;\u6231lcty;\u632D\u0980AHabcdefhijlorstuwz\u1C38\u1C3B\u1C3F\u1C5D\u1C69\u1C75\u1C8A\u1C9E\u1CAC\u1CB7\u1CFB\u1CFF\u1D0D\u1D7B\u1D91\u1DAB\u1DBB\u1DC6\u1DCDr\xf2\u0381ar;\u6965\u0200glrs\u1C48\u1C4D\u1C52\u1C54ger;\u6020eth;\u6138\xf2\u1133h\u0100;v\u1C5A\u1C5B\u6010\xbb\u090A\u016B\u1C61\u1C67arow;\u690Fa\xe3\u0315\u0100ay\u1C6E\u1C73ron;\u410F;\u4434\u0180;ao\u0332\u1C7C\u1C84\u0100gr\u02BF\u1C81r;\u61CAtseq;\u6A77\u0180glm\u1C91\u1C94\u1C98\u803B\xb0\u40B0ta;\u43B4ptyv;\u69B1\u0100ir\u1CA3\u1CA8sht;\u697F;\uC000\ud835\udd21ar\u0100lr\u1CB3\u1CB5\xbb\u08DC\xbb\u101E\u0280aegsv\u1CC2\u0378\u1CD6\u1CDC\u1CE0m\u0180;os\u0326\u1CCA\u1CD4nd\u0100;s\u0326\u1CD1uit;\u6666amma;\u43DDin;\u62F2\u0180;io\u1CE7\u1CE8\u1CF8\u40F7de\u8100\xf7;o\u1CE7\u1CF0ntimes;\u62C7n\xf8\u1CF7cy;\u4452c\u026F\u1D06\x00\x00\u1D0Arn;\u631Eop;\u630D\u0280lptuw\u1D18\u1D1D\u1D22\u1D49\u1D55lar;\u4024f;\uC000\ud835\udd55\u0280;emps\u030B\u1D2D\u1D37\u1D3D\u1D42q\u0100;d\u0352\u1D33ot;\u6251inus;\u6238lus;\u6214quare;\u62A1blebarwedg\xe5\xfan\u0180adh\u112E\u1D5D\u1D67ownarrow\xf3\u1C83arpoon\u0100lr\u1D72\u1D76ef\xf4\u1CB4igh\xf4\u1CB6\u0162\u1D7F\u1D85karo\xf7\u0F42\u026F\u1D8A\x00\x00\u1D8Ern;\u631Fop;\u630C\u0180cot\u1D98\u1DA3\u1DA6\u0100ry\u1D9D\u1DA1;\uC000\ud835\udcb9;\u4455l;\u69F6rok;\u4111\u0100dr\u1DB0\u1DB4ot;\u62F1i\u0100;f\u1DBA\u1816\u65BF\u0100ah\u1DC0\u1DC3r\xf2\u0429a\xf2\u0FA6angle;\u69A6\u0100ci\u1DD2\u1DD5y;\u445Fgrarr;\u67FF\u0900Dacdefglmnopqrstux\u1E01\u1E09\u1E19\u1E38\u0578\u1E3C\u1E49\u1E61\u1E7E\u1EA5\u1EAF\u1EBD\u1EE1\u1F2A\u1F37\u1F44\u1F4E\u1F5A\u0100Do\u1E06\u1D34o\xf4\u1C89\u0100cs\u1E0E\u1E14ute\u803B\xe9\u40E9ter;\u6A6E\u0200aioy\u1E22\u1E27\u1E31\u1E36ron;\u411Br\u0100;c\u1E2D\u1E2E\u6256\u803B\xea\u40EAlon;\u6255;\u444Dot;\u4117\u0100Dr\u1E41\u1E45ot;\u6252;\uC000\ud835\udd22\u0180;rs\u1E50\u1E51\u1E57\u6A9Aave\u803B\xe8\u40E8\u0100;d\u1E5C\u1E5D\u6A96ot;\u6A98\u0200;ils\u1E6A\u1E6B\u1E72\u1E74\u6A99nters;\u63E7;\u6113\u0100;d\u1E79\u1E7A\u6A95ot;\u6A97\u0180aps\u1E85\u1E89\u1E97cr;\u4113ty\u0180;sv\u1E92\u1E93\u1E95\u6205et\xbb\u1E93p\u01001;\u1E9D\u1EA4\u0133\u1EA1\u1EA3;\u6004;\u6005\u6003\u0100gs\u1EAA\u1EAC;\u414Bp;\u6002\u0100gp\u1EB4\u1EB8on;\u4119f;\uC000\ud835\udd56\u0180als\u1EC4\u1ECE\u1ED2r\u0100;s\u1ECA\u1ECB\u62D5l;\u69E3us;\u6A71i\u0180;lv\u1EDA\u1EDB\u1EDF\u43B5on\xbb\u1EDB;\u43F5\u0200csuv\u1EEA\u1EF3\u1F0B\u1F23\u0100io\u1EEF\u1E31rc\xbb\u1E2E\u0269\u1EF9\x00\x00\u1EFB\xed\u0548ant\u0100gl\u1F02\u1F06tr\xbb\u1E5Dess\xbb\u1E7A\u0180aei\u1F12\u1F16\u1F1Als;\u403Dst;\u625Fv\u0100;D\u0235\u1F20D;\u6A78parsl;\u69E5\u0100Da\u1F2F\u1F33ot;\u6253rr;\u6971\u0180cdi\u1F3E\u1F41\u1EF8r;\u612Fo\xf4\u0352\u0100ah\u1F49\u1F4B;\u43B7\u803B\xf0\u40F0\u0100mr\u1F53\u1F57l\u803B\xeb\u40EBo;\u60AC\u0180cip\u1F61\u1F64\u1F67l;\u4021s\xf4\u056E\u0100eo\u1F6C\u1F74ctatio\xee\u0559nential\xe5\u0579\u09E1\u1F92\x00\u1F9E\x00\u1FA1\u1FA7\x00\x00\u1FC6\u1FCC\x00\u1FD3\x00\u1FE6\u1FEA\u2000\x00\u2008\u205Allingdotse\xf1\u1E44y;\u4444male;\u6640\u0180ilr\u1FAD\u1FB3\u1FC1lig;\u8000\uFB03\u0269\u1FB9\x00\x00\u1FBDg;\u8000\uFB00ig;\u8000\uFB04;\uC000\ud835\udd23lig;\u8000\uFB01lig;\uC000fj\u0180alt\u1FD9\u1FDC\u1FE1t;\u666Dig;\u8000\uFB02ns;\u65B1of;\u4192\u01F0\u1FEE\x00\u1FF3f;\uC000\ud835\udd57\u0100ak\u05BF\u1FF7\u0100;v\u1FFC\u1FFD\u62D4;\u6AD9artint;\u6A0D\u0100ao\u200C\u2055\u0100cs\u2011\u2052\u03B1\u201A\u2030\u2038\u2045\u2048\x00\u2050\u03B2\u2022\u2025\u2027\u202A\u202C\x00\u202E\u803B\xbd\u40BD;\u6153\u803B\xbc\u40BC;\u6155;\u6159;\u615B\u01B3\u2034\x00\u2036;\u6154;\u6156\u02B4\u203E\u2041\x00\x00\u2043\u803B\xbe\u40BE;\u6157;\u615C5;\u6158\u01B6\u204C\x00\u204E;\u615A;\u615D8;\u615El;\u6044wn;\u6322cr;\uC000\ud835\udcbb\u0880Eabcdefgijlnorstv\u2082\u2089\u209F\u20A5\u20B0\u20B4\u20F0\u20F5\u20FA\u20FF\u2103\u2112\u2138\u0317\u213E\u2152\u219E\u0100;l\u064D\u2087;\u6A8C\u0180cmp\u2090\u2095\u209Dute;\u41F5ma\u0100;d\u209C\u1CDA\u43B3;\u6A86reve;\u411F\u0100iy\u20AA\u20AErc;\u411D;\u4433ot;\u4121\u0200;lqs\u063E\u0642\u20BD\u20C9\u0180;qs\u063E\u064C\u20C4lan\xf4\u0665\u0200;cdl\u0665\u20D2\u20D5\u20E5c;\u6AA9ot\u0100;o\u20DC\u20DD\u6A80\u0100;l\u20E2\u20E3\u6A82;\u6A84\u0100;e\u20EA\u20ED\uC000\u22DB\uFE00s;\u6A94r;\uC000\ud835\udd24\u0100;g\u0673\u061Bmel;\u6137cy;\u4453\u0200;Eaj\u065A\u210C\u210E\u2110;\u6A92;\u6AA5;\u6AA4\u0200Eaes\u211B\u211D\u2129\u2134;\u6269p\u0100;p\u2123\u2124\u6A8Arox\xbb\u2124\u0100;q\u212E\u212F\u6A88\u0100;q\u212E\u211Bim;\u62E7pf;\uC000\ud835\udd58\u0100ci\u2143\u2146r;\u610Am\u0180;el\u066B\u214E\u2150;\u6A8E;\u6A90\u8300>;cdlqr\u05EE\u2160\u216A\u216E\u2173\u2179\u0100ci\u2165\u2167;\u6AA7r;\u6A7Aot;\u62D7Par;\u6995uest;\u6A7C\u0280adels\u2184\u216A\u2190\u0656\u219B\u01F0\u2189\x00\u218Epro\xf8\u209Er;\u6978q\u0100lq\u063F\u2196les\xf3\u2088i\xed\u066B\u0100en\u21A3\u21ADrtneqq;\uC000\u2269\uFE00\xc5\u21AA\u0500Aabcefkosy\u21C4\u21C7\u21F1\u21F5\u21FA\u2218\u221D\u222F\u2268\u227Dr\xf2\u03A0\u0200ilmr\u21D0\u21D4\u21D7\u21DBrs\xf0\u1484f\xbb\u2024il\xf4\u06A9\u0100dr\u21E0\u21E4cy;\u444A\u0180;cw\u08F4\u21EB\u21EFir;\u6948;\u61ADar;\u610Firc;\u4125\u0180alr\u2201\u220E\u2213rts\u0100;u\u2209\u220A\u6665it\xbb\u220Alip;\u6026con;\u62B9r;\uC000\ud835\udd25s\u0100ew\u2223\u2229arow;\u6925arow;\u6926\u0280amopr\u223A\u223E\u2243\u225E\u2263rr;\u61FFtht;\u623Bk\u0100lr\u2249\u2253eftarrow;\u61A9ightarrow;\u61AAf;\uC000\ud835\udd59bar;\u6015\u0180clt\u226F\u2274\u2278r;\uC000\ud835\udcbdas\xe8\u21F4rok;\u4127\u0100bp\u2282\u2287ull;\u6043hen\xbb\u1C5B\u0AE1\u22A3\x00\u22AA\x00\u22B8\u22C5\u22CE\x00\u22D5\u22F3\x00\x00\u22F8\u2322\u2367\u2362\u237F\x00\u2386\u23AA\u23B4cute\u803B\xed\u40ED\u0180;iy\u0771\u22B0\u22B5rc\u803B\xee\u40EE;\u4438\u0100cx\u22BC\u22BFy;\u4435cl\u803B\xa1\u40A1\u0100fr\u039F\u22C9;\uC000\ud835\udd26rave\u803B\xec\u40EC\u0200;ino\u073E\u22DD\u22E9\u22EE\u0100in\u22E2\u22E6nt;\u6A0Ct;\u622Dfin;\u69DCta;\u6129lig;\u4133\u0180aop\u22FE\u231A\u231D\u0180cgt\u2305\u2308\u2317r;\u412B\u0180elp\u071F\u230F\u2313in\xe5\u078Ear\xf4\u0720h;\u4131f;\u62B7ed;\u41B5\u0280;cfot\u04F4\u232C\u2331\u233D\u2341are;\u6105in\u0100;t\u2338\u2339\u621Eie;\u69DDdo\xf4\u2319\u0280;celp\u0757\u234C\u2350\u235B\u2361al;\u62BA\u0100gr\u2355\u2359er\xf3\u1563\xe3\u234Darhk;\u6A17rod;\u6A3C\u0200cgpt\u236F\u2372\u2376\u237By;\u4451on;\u412Ff;\uC000\ud835\udd5aa;\u43B9uest\u803B\xbf\u40BF\u0100ci\u238A\u238Fr;\uC000\ud835\udcben\u0280;Edsv\u04F4\u239B\u239D\u23A1\u04F3;\u62F9ot;\u62F5\u0100;v\u23A6\u23A7\u62F4;\u62F3\u0100;i\u0777\u23AElde;\u4129\u01EB\u23B8\x00\u23BCcy;\u4456l\u803B\xef\u40EF\u0300cfmosu\u23CC\u23D7\u23DC\u23E1\u23E7\u23F5\u0100iy\u23D1\u23D5rc;\u4135;\u4439r;\uC000\ud835\udd27ath;\u4237pf;\uC000\ud835\udd5b\u01E3\u23EC\x00\u23F1r;\uC000\ud835\udcbfrcy;\u4458kcy;\u4454\u0400acfghjos\u240B\u2416\u2422\u2427\u242D\u2431\u2435\u243Bppa\u0100;v\u2413\u2414\u43BA;\u43F0\u0100ey\u241B\u2420dil;\u4137;\u443Ar;\uC000\ud835\udd28reen;\u4138cy;\u4445cy;\u445Cpf;\uC000\ud835\udd5ccr;\uC000\ud835\udcc0\u0B80ABEHabcdefghjlmnoprstuv\u2470\u2481\u2486\u248D\u2491\u250E\u253D\u255A\u2580\u264E\u265E\u2665\u2679\u267D\u269A\u26B2\u26D8\u275D\u2768\u278B\u27C0\u2801\u2812\u0180art\u2477\u247A\u247Cr\xf2\u09C6\xf2\u0395ail;\u691Barr;\u690E\u0100;g\u0994\u248B;\u6A8Bar;\u6962\u0963\u24A5\x00\u24AA\x00\u24B1\x00\x00\x00\x00\x00\u24B5\u24BA\x00\u24C6\u24C8\u24CD\x00\u24F9ute;\u413Amptyv;\u69B4ra\xee\u084Cbda;\u43BBg\u0180;dl\u088E\u24C1\u24C3;\u6991\xe5\u088E;\u6A85uo\u803B\xab\u40ABr\u0400;bfhlpst\u0899\u24DE\u24E6\u24E9\u24EB\u24EE\u24F1\u24F5\u0100;f\u089D\u24E3s;\u691Fs;\u691D\xeb\u2252p;\u61ABl;\u6939im;\u6973l;\u61A2\u0180;ae\u24FF\u2500\u2504\u6AABil;\u6919\u0100;s\u2509\u250A\u6AAD;\uC000\u2AAD\uFE00\u0180abr\u2515\u2519\u251Drr;\u690Crk;\u6772\u0100ak\u2522\u252Cc\u0100ek\u2528\u252A;\u407B;\u405B\u0100es\u2531\u2533;\u698Bl\u0100du\u2539\u253B;\u698F;\u698D\u0200aeuy\u2546\u254B\u2556\u2558ron;\u413E\u0100di\u2550\u2554il;\u413C\xec\u08B0\xe2\u2529;\u443B\u0200cqrs\u2563\u2566\u256D\u257Da;\u6936uo\u0100;r\u0E19\u1746\u0100du\u2572\u2577har;\u6967shar;\u694Bh;\u61B2\u0280;fgqs\u258B\u258C\u0989\u25F3\u25FF\u6264t\u0280ahlrt\u2598\u25A4\u25B7\u25C2\u25E8rrow\u0100;t\u0899\u25A1a\xe9\u24F6arpoon\u0100du\u25AF\u25B4own\xbb\u045Ap\xbb\u0966eftarrows;\u61C7ight\u0180ahs\u25CD\u25D6\u25DErrow\u0100;s\u08F4\u08A7arpoon\xf3\u0F98quigarro\xf7\u21F0hreetimes;\u62CB\u0180;qs\u258B\u0993\u25FAlan\xf4\u09AC\u0280;cdgs\u09AC\u260A\u260D\u261D\u2628c;\u6AA8ot\u0100;o\u2614\u2615\u6A7F\u0100;r\u261A\u261B\u6A81;\u6A83\u0100;e\u2622\u2625\uC000\u22DA\uFE00s;\u6A93\u0280adegs\u2633\u2639\u263D\u2649\u264Bppro\xf8\u24C6ot;\u62D6q\u0100gq\u2643\u2645\xf4\u0989gt\xf2\u248C\xf4\u099Bi\xed\u09B2\u0180ilr\u2655\u08E1\u265Asht;\u697C;\uC000\ud835\udd29\u0100;E\u099C\u2663;\u6A91\u0161\u2669\u2676r\u0100du\u25B2\u266E\u0100;l\u0965\u2673;\u696Alk;\u6584cy;\u4459\u0280;acht\u0A48\u2688\u268B\u2691\u2696r\xf2\u25C1orne\xf2\u1D08ard;\u696Bri;\u65FA\u0100io\u269F\u26A4dot;\u4140ust\u0100;a\u26AC\u26AD\u63B0che\xbb\u26AD\u0200Eaes\u26BB\u26BD\u26C9\u26D4;\u6268p\u0100;p\u26C3\u26C4\u6A89rox\xbb\u26C4\u0100;q\u26CE\u26CF\u6A87\u0100;q\u26CE\u26BBim;\u62E6\u0400abnoptwz\u26E9\u26F4\u26F7\u271A\u272F\u2741\u2747\u2750\u0100nr\u26EE\u26F1g;\u67ECr;\u61FDr\xeb\u08C1g\u0180lmr\u26FF\u270D\u2714eft\u0100ar\u09E6\u2707ight\xe1\u09F2apsto;\u67FCight\xe1\u09FDparrow\u0100lr\u2725\u2729ef\xf4\u24EDight;\u61AC\u0180afl\u2736\u2739\u273Dr;\u6985;\uC000\ud835\udd5dus;\u6A2Dimes;\u6A34\u0161\u274B\u274Fst;\u6217\xe1\u134E\u0180;ef\u2757\u2758\u1800\u65CAnge\xbb\u2758ar\u0100;l\u2764\u2765\u4028t;\u6993\u0280achmt\u2773\u2776\u277C\u2785\u2787r\xf2\u08A8orne\xf2\u1D8Car\u0100;d\u0F98\u2783;\u696D;\u600Eri;\u62BF\u0300achiqt\u2798\u279D\u0A40\u27A2\u27AE\u27BBquo;\u6039r;\uC000\ud835\udcc1m\u0180;eg\u09B2\u27AA\u27AC;\u6A8D;\u6A8F\u0100bu\u252A\u27B3o\u0100;r\u0E1F\u27B9;\u601Arok;\u4142\u8400<;cdhilqr\u082B\u27D2\u2639\u27DC\u27E0\u27E5\u27EA\u27F0\u0100ci\u27D7\u27D9;\u6AA6r;\u6A79re\xe5\u25F2mes;\u62C9arr;\u6976uest;\u6A7B\u0100Pi\u27F5\u27F9ar;\u6996\u0180;ef\u2800\u092D\u181B\u65C3r\u0100du\u2807\u280Dshar;\u694Ahar;\u6966\u0100en\u2817\u2821rtneqq;\uC000\u2268\uFE00\xc5\u281E\u0700Dacdefhilnopsu\u2840\u2845\u2882\u288E\u2893\u28A0\u28A5\u28A8\u28DA\u28E2\u28E4\u0A83\u28F3\u2902Dot;\u623A\u0200clpr\u284E\u2852\u2863\u287Dr\u803B\xaf\u40AF\u0100et\u2857\u2859;\u6642\u0100;e\u285E\u285F\u6720se\xbb\u285F\u0100;s\u103B\u2868to\u0200;dlu\u103B\u2873\u2877\u287Bow\xee\u048Cef\xf4\u090F\xf0\u13D1ker;\u65AE\u0100oy\u2887\u288Cmma;\u6A29;\u443Cash;\u6014asuredangle\xbb\u1626r;\uC000\ud835\udd2ao;\u6127\u0180cdn\u28AF\u28B4\u28C9ro\u803B\xb5\u40B5\u0200;acd\u1464\u28BD\u28C0\u28C4s\xf4\u16A7ir;\u6AF0ot\u80BB\xb7\u01B5us\u0180;bd\u28D2\u1903\u28D3\u6212\u0100;u\u1D3C\u28D8;\u6A2A\u0163\u28DE\u28E1p;\u6ADB\xf2\u2212\xf0\u0A81\u0100dp\u28E9\u28EEels;\u62A7f;\uC000\ud835\udd5e\u0100ct\u28F8\u28FDr;\uC000\ud835\udcc2pos\xbb\u159D\u0180;lm\u2909\u290A\u290D\u43BCtimap;\u62B8\u0C00GLRVabcdefghijlmoprstuvw\u2942\u2953\u297E\u2989\u2998\u29DA\u29E9\u2A15\u2A1A\u2A58\u2A5D\u2A83\u2A95\u2AA4\u2AA8\u2B04\u2B07\u2B44\u2B7F\u2BAE\u2C34\u2C67\u2C7C\u2CE9\u0100gt\u2947\u294B;\uC000\u22D9\u0338\u0100;v\u2950\u0BCF\uC000\u226B\u20D2\u0180elt\u295A\u2972\u2976ft\u0100ar\u2961\u2967rrow;\u61CDightarrow;\u61CE;\uC000\u22D8\u0338\u0100;v\u297B\u0C47\uC000\u226A\u20D2ightarrow;\u61CF\u0100Dd\u298E\u2993ash;\u62AFash;\u62AE\u0280bcnpt\u29A3\u29A7\u29AC\u29B1\u29CCla\xbb\u02DEute;\u4144g;\uC000\u2220\u20D2\u0280;Eiop\u0D84\u29BC\u29C0\u29C5\u29C8;\uC000\u2A70\u0338d;\uC000\u224B\u0338s;\u4149ro\xf8\u0D84ur\u0100;a\u29D3\u29D4\u666El\u0100;s\u29D3\u0B38\u01F3\u29DF\x00\u29E3p\u80BB\xa0\u0B37mp\u0100;e\u0BF9\u0C00\u0280aeouy\u29F4\u29FE\u2A03\u2A10\u2A13\u01F0\u29F9\x00\u29FB;\u6A43on;\u4148dil;\u4146ng\u0100;d\u0D7E\u2A0Aot;\uC000\u2A6D\u0338p;\u6A42;\u443Dash;\u6013\u0380;Aadqsx\u0B92\u2A29\u2A2D\u2A3B\u2A41\u2A45\u2A50rr;\u61D7r\u0100hr\u2A33\u2A36k;\u6924\u0100;o\u13F2\u13F0ot;\uC000\u2250\u0338ui\xf6\u0B63\u0100ei\u2A4A\u2A4Ear;\u6928\xed\u0B98ist\u0100;s\u0BA0\u0B9Fr;\uC000\ud835\udd2b\u0200Eest\u0BC5\u2A66\u2A79\u2A7C\u0180;qs\u0BBC\u2A6D\u0BE1\u0180;qs\u0BBC\u0BC5\u2A74lan\xf4\u0BE2i\xed\u0BEA\u0100;r\u0BB6\u2A81\xbb\u0BB7\u0180Aap\u2A8A\u2A8D\u2A91r\xf2\u2971rr;\u61AEar;\u6AF2\u0180;sv\u0F8D\u2A9C\u0F8C\u0100;d\u2AA1\u2AA2\u62FC;\u62FAcy;\u445A\u0380AEadest\u2AB7\u2ABA\u2ABE\u2AC2\u2AC5\u2AF6\u2AF9r\xf2\u2966;\uC000\u2266\u0338rr;\u619Ar;\u6025\u0200;fqs\u0C3B\u2ACE\u2AE3\u2AEFt\u0100ar\u2AD4\u2AD9rro\xf7\u2AC1ightarro\xf7\u2A90\u0180;qs\u0C3B\u2ABA\u2AEAlan\xf4\u0C55\u0100;s\u0C55\u2AF4\xbb\u0C36i\xed\u0C5D\u0100;r\u0C35\u2AFEi\u0100;e\u0C1A\u0C25i\xe4\u0D90\u0100pt\u2B0C\u2B11f;\uC000\ud835\udd5f\u8180\xac;in\u2B19\u2B1A\u2B36\u40ACn\u0200;Edv\u0B89\u2B24\u2B28\u2B2E;\uC000\u22F9\u0338ot;\uC000\u22F5\u0338\u01E1\u0B89\u2B33\u2B35;\u62F7;\u62F6i\u0100;v\u0CB8\u2B3C\u01E1\u0CB8\u2B41\u2B43;\u62FE;\u62FD\u0180aor\u2B4B\u2B63\u2B69r\u0200;ast\u0B7B\u2B55\u2B5A\u2B5Flle\xec\u0B7Bl;\uC000\u2AFD\u20E5;\uC000\u2202\u0338lint;\u6A14\u0180;ce\u0C92\u2B70\u2B73u\xe5\u0CA5\u0100;c\u0C98\u2B78\u0100;e\u0C92\u2B7D\xf1\u0C98\u0200Aait\u2B88\u2B8B\u2B9D\u2BA7r\xf2\u2988rr\u0180;cw\u2B94\u2B95\u2B99\u619B;\uC000\u2933\u0338;\uC000\u219D\u0338ghtarrow\xbb\u2B95ri\u0100;e\u0CCB\u0CD6\u0380chimpqu\u2BBD\u2BCD\u2BD9\u2B04\u0B78\u2BE4\u2BEF\u0200;cer\u0D32\u2BC6\u0D37\u2BC9u\xe5\u0D45;\uC000\ud835\udcc3ort\u026D\u2B05\x00\x00\u2BD6ar\xe1\u2B56m\u0100;e\u0D6E\u2BDF\u0100;q\u0D74\u0D73su\u0100bp\u2BEB\u2BED\xe5\u0CF8\xe5\u0D0B\u0180bcp\u2BF6\u2C11\u2C19\u0200;Ees\u2BFF\u2C00\u0D22\u2C04\u6284;\uC000\u2AC5\u0338et\u0100;e\u0D1B\u2C0Bq\u0100;q\u0D23\u2C00c\u0100;e\u0D32\u2C17\xf1\u0D38\u0200;Ees\u2C22\u2C23\u0D5F\u2C27\u6285;\uC000\u2AC6\u0338et\u0100;e\u0D58\u2C2Eq\u0100;q\u0D60\u2C23\u0200gilr\u2C3D\u2C3F\u2C45\u2C47\xec\u0BD7lde\u803B\xf1\u40F1\xe7\u0C43iangle\u0100lr\u2C52\u2C5Ceft\u0100;e\u0C1A\u2C5A\xf1\u0C26ight\u0100;e\u0CCB\u2C65\xf1\u0CD7\u0100;m\u2C6C\u2C6D\u43BD\u0180;es\u2C74\u2C75\u2C79\u4023ro;\u6116p;\u6007\u0480DHadgilrs\u2C8F\u2C94\u2C99\u2C9E\u2CA3\u2CB0\u2CB6\u2CD3\u2CE3ash;\u62ADarr;\u6904p;\uC000\u224D\u20D2ash;\u62AC\u0100et\u2CA8\u2CAC;\uC000\u2265\u20D2;\uC000>\u20D2nfin;\u69DE\u0180Aet\u2CBD\u2CC1\u2CC5rr;\u6902;\uC000\u2264\u20D2\u0100;r\u2CCA\u2CCD\uC000<\u20D2ie;\uC000\u22B4\u20D2\u0100At\u2CD8\u2CDCrr;\u6903rie;\uC000\u22B5\u20D2im;\uC000\u223C\u20D2\u0180Aan\u2CF0\u2CF4\u2D02rr;\u61D6r\u0100hr\u2CFA\u2CFDk;\u6923\u0100;o\u13E7\u13E5ear;\u6927\u1253\u1A95\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\u2D2D\x00\u2D38\u2D48\u2D60\u2D65\u2D72\u2D84\u1B07\x00\x00\u2D8D\u2DAB\x00\u2DC8\u2DCE\x00\u2DDC\u2E19\u2E2B\u2E3E\u2E43\u0100cs\u2D31\u1A97ute\u803B\xf3\u40F3\u0100iy\u2D3C\u2D45r\u0100;c\u1A9E\u2D42\u803B\xf4\u40F4;\u443E\u0280abios\u1AA0\u2D52\u2D57\u01C8\u2D5Alac;\u4151v;\u6A38old;\u69BClig;\u4153\u0100cr\u2D69\u2D6Dir;\u69BF;\uC000\ud835\udd2c\u036F\u2D79\x00\x00\u2D7C\x00\u2D82n;\u42DBave\u803B\xf2\u40F2;\u69C1\u0100bm\u2D88\u0DF4ar;\u69B5\u0200acit\u2D95\u2D98\u2DA5\u2DA8r\xf2\u1A80\u0100ir\u2D9D\u2DA0r;\u69BEoss;\u69BBn\xe5\u0E52;\u69C0\u0180aei\u2DB1\u2DB5\u2DB9cr;\u414Dga;\u43C9\u0180cdn\u2DC0\u2DC5\u01CDron;\u43BF;\u69B6pf;\uC000\ud835\udd60\u0180ael\u2DD4\u2DD7\u01D2r;\u69B7rp;\u69B9\u0380;adiosv\u2DEA\u2DEB\u2DEE\u2E08\u2E0D\u2E10\u2E16\u6228r\xf2\u1A86\u0200;efm\u2DF7\u2DF8\u2E02\u2E05\u6A5Dr\u0100;o\u2DFE\u2DFF\u6134f\xbb\u2DFF\u803B\xaa\u40AA\u803B\xba\u40BAgof;\u62B6r;\u6A56lope;\u6A57;\u6A5B\u0180clo\u2E1F\u2E21\u2E27\xf2\u2E01ash\u803B\xf8\u40F8l;\u6298i\u016C\u2E2F\u2E34de\u803B\xf5\u40F5es\u0100;a\u01DB\u2E3As;\u6A36ml\u803B\xf6\u40F6bar;\u633D\u0AE1\u2E5E\x00\u2E7D\x00\u2E80\u2E9D\x00\u2EA2\u2EB9\x00\x00\u2ECB\u0E9C\x00\u2F13\x00\x00\u2F2B\u2FBC\x00\u2FC8r\u0200;ast\u0403\u2E67\u2E72\u0E85\u8100\xb6;l\u2E6D\u2E6E\u40B6le\xec\u0403\u0269\u2E78\x00\x00\u2E7Bm;\u6AF3;\u6AFDy;\u443Fr\u0280cimpt\u2E8B\u2E8F\u2E93\u1865\u2E97nt;\u4025od;\u402Eil;\u6030enk;\u6031r;\uC000\ud835\udd2d\u0180imo\u2EA8\u2EB0\u2EB4\u0100;v\u2EAD\u2EAE\u43C6;\u43D5ma\xf4\u0A76ne;\u660E\u0180;tv\u2EBF\u2EC0\u2EC8\u43C0chfork\xbb\u1FFD;\u43D6\u0100au\u2ECF\u2EDFn\u0100ck\u2ED5\u2EDDk\u0100;h\u21F4\u2EDB;\u610E\xf6\u21F4s\u0480;abcdemst\u2EF3\u2EF4\u1908\u2EF9\u2EFD\u2F04\u2F06\u2F0A\u2F0E\u402Bcir;\u6A23ir;\u6A22\u0100ou\u1D40\u2F02;\u6A25;\u6A72n\u80BB\xb1\u0E9Dim;\u6A26wo;\u6A27\u0180ipu\u2F19\u2F20\u2F25ntint;\u6A15f;\uC000\ud835\udd61nd\u803B\xa3\u40A3\u0500;Eaceinosu\u0EC8\u2F3F\u2F41\u2F44\u2F47\u2F81\u2F89\u2F92\u2F7E\u2FB6;\u6AB3p;\u6AB7u\xe5\u0ED9\u0100;c\u0ECE\u2F4C\u0300;acens\u0EC8\u2F59\u2F5F\u2F66\u2F68\u2F7Eppro\xf8\u2F43urlye\xf1\u0ED9\xf1\u0ECE\u0180aes\u2F6F\u2F76\u2F7Approx;\u6AB9qq;\u6AB5im;\u62E8i\xed\u0EDFme\u0100;s\u2F88\u0EAE\u6032\u0180Eas\u2F78\u2F90\u2F7A\xf0\u2F75\u0180dfp\u0EEC\u2F99\u2FAF\u0180als\u2FA0\u2FA5\u2FAAlar;\u632Eine;\u6312urf;\u6313\u0100;t\u0EFB\u2FB4\xef\u0EFBrel;\u62B0\u0100ci\u2FC0\u2FC5r;\uC000\ud835\udcc5;\u43C8ncsp;\u6008\u0300fiopsu\u2FDA\u22E2\u2FDF\u2FE5\u2FEB\u2FF1r;\uC000\ud835\udd2epf;\uC000\ud835\udd62rime;\u6057cr;\uC000\ud835\udcc6\u0180aeo\u2FF8\u3009\u3013t\u0100ei\u2FFE\u3005rnion\xf3\u06B0nt;\u6A16st\u0100;e\u3010\u3011\u403F\xf1\u1F19\xf4\u0F14\u0A80ABHabcdefhilmnoprstux\u3040\u3051\u3055\u3059\u30E0\u310E\u312B\u3147\u3162\u3172\u318E\u3206\u3215\u3224\u3229\u3258\u326E\u3272\u3290\u32B0\u32B7\u0180art\u3047\u304A\u304Cr\xf2\u10B3\xf2\u03DDail;\u691Car\xf2\u1C65ar;\u6964\u0380cdenqrt\u3068\u3075\u3078\u307F\u308F\u3094\u30CC\u0100eu\u306D\u3071;\uC000\u223D\u0331te;\u4155i\xe3\u116Emptyv;\u69B3g\u0200;del\u0FD1\u3089\u308B\u308D;\u6992;\u69A5\xe5\u0FD1uo\u803B\xbb\u40BBr\u0580;abcfhlpstw\u0FDC\u30AC\u30AF\u30B7\u30B9\u30BC\u30BE\u30C0\u30C3\u30C7\u30CAp;\u6975\u0100;f\u0FE0\u30B4s;\u6920;\u6933s;\u691E\xeb\u225D\xf0\u272El;\u6945im;\u6974l;\u61A3;\u619D\u0100ai\u30D1\u30D5il;\u691Ao\u0100;n\u30DB\u30DC\u6236al\xf3\u0F1E\u0180abr\u30E7\u30EA\u30EEr\xf2\u17E5rk;\u6773\u0100ak\u30F3\u30FDc\u0100ek\u30F9\u30FB;\u407D;\u405D\u0100es\u3102\u3104;\u698Cl\u0100du\u310A\u310C;\u698E;\u6990\u0200aeuy\u3117\u311C\u3127\u3129ron;\u4159\u0100di\u3121\u3125il;\u4157\xec\u0FF2\xe2\u30FA;\u4440\u0200clqs\u3134\u3137\u313D\u3144a;\u6937dhar;\u6969uo\u0100;r\u020E\u020Dh;\u61B3\u0180acg\u314E\u315F\u0F44l\u0200;ips\u0F78\u3158\u315B\u109Cn\xe5\u10BBar\xf4\u0FA9t;\u65AD\u0180ilr\u3169\u1023\u316Esht;\u697D;\uC000\ud835\udd2f\u0100ao\u3177\u3186r\u0100du\u317D\u317F\xbb\u047B\u0100;l\u1091\u3184;\u696C\u0100;v\u318B\u318C\u43C1;\u43F1\u0180gns\u3195\u31F9\u31FCht\u0300ahlrst\u31A4\u31B0\u31C2\u31D8\u31E4\u31EErrow\u0100;t\u0FDC\u31ADa\xe9\u30C8arpoon\u0100du\u31BB\u31BFow\xee\u317Ep\xbb\u1092eft\u0100ah\u31CA\u31D0rrow\xf3\u0FEAarpoon\xf3\u0551ightarrows;\u61C9quigarro\xf7\u30CBhreetimes;\u62CCg;\u42DAingdotse\xf1\u1F32\u0180ahm\u320D\u3210\u3213r\xf2\u0FEAa\xf2\u0551;\u600Foust\u0100;a\u321E\u321F\u63B1che\xbb\u321Fmid;\u6AEE\u0200abpt\u3232\u323D\u3240\u3252\u0100nr\u3237\u323Ag;\u67EDr;\u61FEr\xeb\u1003\u0180afl\u3247\u324A\u324Er;\u6986;\uC000\ud835\udd63us;\u6A2Eimes;\u6A35\u0100ap\u325D\u3267r\u0100;g\u3263\u3264\u4029t;\u6994olint;\u6A12ar\xf2\u31E3\u0200achq\u327B\u3280\u10BC\u3285quo;\u603Ar;\uC000\ud835\udcc7\u0100bu\u30FB\u328Ao\u0100;r\u0214\u0213\u0180hir\u3297\u329B\u32A0re\xe5\u31F8mes;\u62CAi\u0200;efl\u32AA\u1059\u1821\u32AB\u65B9tri;\u69CEluhar;\u6968;\u611E\u0D61\u32D5\u32DB\u32DF\u332C\u3338\u3371\x00\u337A\u33A4\x00\x00\u33EC\u33F0\x00\u3428\u3448\u345A\u34AD\u34B1\u34CA\u34F1\x00\u3616\x00\x00\u3633cute;\u415Bqu\xef\u27BA\u0500;Eaceinpsy\u11ED\u32F3\u32F5\u32FF\u3302\u330B\u330F\u331F\u3326\u3329;\u6AB4\u01F0\u32FA\x00\u32FC;\u6AB8on;\u4161u\xe5\u11FE\u0100;d\u11F3\u3307il;\u415Frc;\u415D\u0180Eas\u3316\u3318\u331B;\u6AB6p;\u6ABAim;\u62E9olint;\u6A13i\xed\u1204;\u4441ot\u0180;be\u3334\u1D47\u3335\u62C5;\u6A66\u0380Aacmstx\u3346\u334A\u3357\u335B\u335E\u3363\u336Drr;\u61D8r\u0100hr\u3350\u3352\xeb\u2228\u0100;o\u0A36\u0A34t\u803B\xa7\u40A7i;\u403Bwar;\u6929m\u0100in\u3369\xf0nu\xf3\xf1t;\u6736r\u0100;o\u3376\u2055\uC000\ud835\udd30\u0200acoy\u3382\u3386\u3391\u33A0rp;\u666F\u0100hy\u338B\u338Fcy;\u4449;\u4448rt\u026D\u3399\x00\x00\u339Ci\xe4\u1464ara\xec\u2E6F\u803B\xad\u40AD\u0100gm\u33A8\u33B4ma\u0180;fv\u33B1\u33B2\u33B2\u43C3;\u43C2\u0400;deglnpr\u12AB\u33C5\u33C9\u33CE\u33D6\u33DE\u33E1\u33E6ot;\u6A6A\u0100;q\u12B1\u12B0\u0100;E\u33D3\u33D4\u6A9E;\u6AA0\u0100;E\u33DB\u33DC\u6A9D;\u6A9Fe;\u6246lus;\u6A24arr;\u6972ar\xf2\u113D\u0200aeit\u33F8\u3408\u340F\u3417\u0100ls\u33FD\u3404lsetm\xe9\u336Ahp;\u6A33parsl;\u69E4\u0100dl\u1463\u3414e;\u6323\u0100;e\u341C\u341D\u6AAA\u0100;s\u3422\u3423\u6AAC;\uC000\u2AAC\uFE00\u0180flp\u342E\u3433\u3442tcy;\u444C\u0100;b\u3438\u3439\u402F\u0100;a\u343E\u343F\u69C4r;\u633Ff;\uC000\ud835\udd64a\u0100dr\u344D\u0402es\u0100;u\u3454\u3455\u6660it\xbb\u3455\u0180csu\u3460\u3479\u349F\u0100au\u3465\u346Fp\u0100;s\u1188\u346B;\uC000\u2293\uFE00p\u0100;s\u11B4\u3475;\uC000\u2294\uFE00u\u0100bp\u347F\u348F\u0180;es\u1197\u119C\u3486et\u0100;e\u1197\u348D\xf1\u119D\u0180;es\u11A8\u11AD\u3496et\u0100;e\u11A8\u349D\xf1\u11AE\u0180;af\u117B\u34A6\u05B0r\u0165\u34AB\u05B1\xbb\u117Car\xf2\u1148\u0200cemt\u34B9\u34BE\u34C2\u34C5r;\uC000\ud835\udcc8tm\xee\xf1i\xec\u3415ar\xe6\u11BE\u0100ar\u34CE\u34D5r\u0100;f\u34D4\u17BF\u6606\u0100an\u34DA\u34EDight\u0100ep\u34E3\u34EApsilo\xee\u1EE0h\xe9\u2EAFs\xbb\u2852\u0280bcmnp\u34FB\u355E\u1209\u358B\u358E\u0480;Edemnprs\u350E\u350F\u3511\u3515\u351E\u3523\u352C\u3531\u3536\u6282;\u6AC5ot;\u6ABD\u0100;d\u11DA\u351Aot;\u6AC3ult;\u6AC1\u0100Ee\u3528\u352A;\u6ACB;\u628Alus;\u6ABFarr;\u6979\u0180eiu\u353D\u3552\u3555t\u0180;en\u350E\u3545\u354Bq\u0100;q\u11DA\u350Feq\u0100;q\u352B\u3528m;\u6AC7\u0100bp\u355A\u355C;\u6AD5;\u6AD3c\u0300;acens\u11ED\u356C\u3572\u3579\u357B\u3326ppro\xf8\u32FAurlye\xf1\u11FE\xf1\u11F3\u0180aes\u3582\u3588\u331Bppro\xf8\u331Aq\xf1\u3317g;\u666A\u0680123;Edehlmnps\u35A9\u35AC\u35AF\u121C\u35B2\u35B4\u35C0\u35C9\u35D5\u35DA\u35DF\u35E8\u35ED\u803B\xb9\u40B9\u803B\xb2\u40B2\u803B\xb3\u40B3;\u6AC6\u0100os\u35B9\u35BCt;\u6ABEub;\u6AD8\u0100;d\u1222\u35C5ot;\u6AC4s\u0100ou\u35CF\u35D2l;\u67C9b;\u6AD7arr;\u697Bult;\u6AC2\u0100Ee\u35E4\u35E6;\u6ACC;\u628Blus;\u6AC0\u0180eiu\u35F4\u3609\u360Ct\u0180;en\u121C\u35FC\u3602q\u0100;q\u1222\u35B2eq\u0100;q\u35E7\u35E4m;\u6AC8\u0100bp\u3611\u3613;\u6AD4;\u6AD6\u0180Aan\u361C\u3620\u362Drr;\u61D9r\u0100hr\u3626\u3628\xeb\u222E\u0100;o\u0A2B\u0A29war;\u692Alig\u803B\xdf\u40DF\u0BE1\u3651\u365D\u3660\u12CE\u3673\u3679\x00\u367E\u36C2\x00\x00\x00\x00\x00\u36DB\u3703\x00\u3709\u376C\x00\x00\x00\u3787\u0272\u3656\x00\x00\u365Bget;\u6316;\u43C4r\xeb\u0E5F\u0180aey\u3666\u366B\u3670ron;\u4165dil;\u4163;\u4442lrec;\u6315r;\uC000\ud835\udd31\u0200eiko\u3686\u369D\u36B5\u36BC\u01F2\u368B\x00\u3691e\u01004f\u1284\u1281a\u0180;sv\u3698\u3699\u369B\u43B8ym;\u43D1\u0100cn\u36A2\u36B2k\u0100as\u36A8\u36AEppro\xf8\u12C1im\xbb\u12ACs\xf0\u129E\u0100as\u36BA\u36AE\xf0\u12C1rn\u803B\xfe\u40FE\u01EC\u031F\u36C6\u22E7es\u8180\xd7;bd\u36CF\u36D0\u36D8\u40D7\u0100;a\u190F\u36D5r;\u6A31;\u6A30\u0180eps\u36E1\u36E3\u3700\xe1\u2A4D\u0200;bcf\u0486\u36EC\u36F0\u36F4ot;\u6336ir;\u6AF1\u0100;o\u36F9\u36FC\uC000\ud835\udd65rk;\u6ADA\xe1\u3362rime;\u6034\u0180aip\u370F\u3712\u3764d\xe5\u1248\u0380adempst\u3721\u374D\u3740\u3751\u3757\u375C\u375Fngle\u0280;dlqr\u3730\u3731\u3736\u3740\u3742\u65B5own\xbb\u1DBBeft\u0100;e\u2800\u373E\xf1\u092E;\u625Cight\u0100;e\u32AA\u374B\xf1\u105Aot;\u65ECinus;\u6A3Alus;\u6A39b;\u69CDime;\u6A3Bezium;\u63E2\u0180cht\u3772\u377D\u3781\u0100ry\u3777\u377B;\uC000\ud835\udcc9;\u4446cy;\u445Brok;\u4167\u0100io\u378B\u378Ex\xf4\u1777head\u0100lr\u3797\u37A0eftarro\xf7\u084Fightarrow\xbb\u0F5D\u0900AHabcdfghlmoprstuw\u37D0\u37D3\u37D7\u37E4\u37F0\u37FC\u380E\u381C\u3823\u3834\u3851\u385D\u386B\u38A9\u38CC\u38D2\u38EA\u38F6r\xf2\u03EDar;\u6963\u0100cr\u37DC\u37E2ute\u803B\xfa\u40FA\xf2\u1150r\u01E3\u37EA\x00\u37EDy;\u445Eve;\u416D\u0100iy\u37F5\u37FArc\u803B\xfb\u40FB;\u4443\u0180abh\u3803\u3806\u380Br\xf2\u13ADlac;\u4171a\xf2\u13C3\u0100ir\u3813\u3818sht;\u697E;\uC000\ud835\udd32rave\u803B\xf9\u40F9\u0161\u3827\u3831r\u0100lr\u382C\u382E\xbb\u0957\xbb\u1083lk;\u6580\u0100ct\u3839\u384D\u026F\u383F\x00\x00\u384Arn\u0100;e\u3845\u3846\u631Cr\xbb\u3846op;\u630Fri;\u65F8\u0100al\u3856\u385Acr;\u416B\u80BB\xa8\u0349\u0100gp\u3862\u3866on;\u4173f;\uC000\ud835\udd66\u0300adhlsu\u114B\u3878\u387D\u1372\u3891\u38A0own\xe1\u13B3arpoon\u0100lr\u3888\u388Cef\xf4\u382Digh\xf4\u382Fi\u0180;hl\u3899\u389A\u389C\u43C5\xbb\u13FAon\xbb\u389Aparrows;\u61C8\u0180cit\u38B0\u38C4\u38C8\u026F\u38B6\x00\x00\u38C1rn\u0100;e\u38BC\u38BD\u631Dr\xbb\u38BDop;\u630Eng;\u416Fri;\u65F9cr;\uC000\ud835\udcca\u0180dir\u38D9\u38DD\u38E2ot;\u62F0lde;\u4169i\u0100;f\u3730\u38E8\xbb\u1813\u0100am\u38EF\u38F2r\xf2\u38A8l\u803B\xfc\u40FCangle;\u69A7\u0780ABDacdeflnoprsz\u391C\u391F\u3929\u392D\u39B5\u39B8\u39BD\u39DF\u39E4\u39E8\u39F3\u39F9\u39FD\u3A01\u3A20r\xf2\u03F7ar\u0100;v\u3926\u3927\u6AE8;\u6AE9as\xe8\u03E1\u0100nr\u3932\u3937grt;\u699C\u0380eknprst\u34E3\u3946\u394B\u3952\u395D\u3964\u3996app\xe1\u2415othin\xe7\u1E96\u0180hir\u34EB\u2EC8\u3959op\xf4\u2FB5\u0100;h\u13B7\u3962\xef\u318D\u0100iu\u3969\u396Dgm\xe1\u33B3\u0100bp\u3972\u3984setneq\u0100;q\u397D\u3980\uC000\u228A\uFE00;\uC000\u2ACB\uFE00setneq\u0100;q\u398F\u3992\uC000\u228B\uFE00;\uC000\u2ACC\uFE00\u0100hr\u399B\u399Fet\xe1\u369Ciangle\u0100lr\u39AA\u39AFeft\xbb\u0925ight\xbb\u1051y;\u4432ash\xbb\u1036\u0180elr\u39C4\u39D2\u39D7\u0180;be\u2DEA\u39CB\u39CFar;\u62BBq;\u625Alip;\u62EE\u0100bt\u39DC\u1468a\xf2\u1469r;\uC000\ud835\udd33tr\xe9\u39AEsu\u0100bp\u39EF\u39F1\xbb\u0D1C\xbb\u0D59pf;\uC000\ud835\udd67ro\xf0\u0EFBtr\xe9\u39B4\u0100cu\u3A06\u3A0Br;\uC000\ud835\udccb\u0100bp\u3A10\u3A18n\u0100Ee\u3980\u3A16\xbb\u397En\u0100Ee\u3992\u3A1E\xbb\u3990igzag;\u699A\u0380cefoprs\u3A36\u3A3B\u3A56\u3A5B\u3A54\u3A61\u3A6Airc;\u4175\u0100di\u3A40\u3A51\u0100bg\u3A45\u3A49ar;\u6A5Fe\u0100;q\u15FA\u3A4F;\u6259erp;\u6118r;\uC000\ud835\udd34pf;\uC000\ud835\udd68\u0100;e\u1479\u3A66at\xe8\u1479cr;\uC000\ud835\udccc\u0AE3\u178E\u3A87\x00\u3A8B\x00\u3A90\u3A9B\x00\x00\u3A9D\u3AA8\u3AAB\u3AAF\x00\x00\u3AC3\u3ACE\x00\u3AD8\u17DC\u17DFtr\xe9\u17D1r;\uC000\ud835\udd35\u0100Aa\u3A94\u3A97r\xf2\u03C3r\xf2\u09F6;\u43BE\u0100Aa\u3AA1\u3AA4r\xf2\u03B8r\xf2\u09EBa\xf0\u2713is;\u62FB\u0180dpt\u17A4\u3AB5\u3ABE\u0100fl\u3ABA\u17A9;\uC000\ud835\udd69im\xe5\u17B2\u0100Aa\u3AC7\u3ACAr\xf2\u03CEr\xf2\u0A01\u0100cq\u3AD2\u17B8r;\uC000\ud835\udccd\u0100pt\u17D6\u3ADCr\xe9\u17D4\u0400acefiosu\u3AF0\u3AFD\u3B08\u3B0C\u3B11\u3B15\u3B1B\u3B21c\u0100uy\u3AF6\u3AFBte\u803B\xfd\u40FD;\u444F\u0100iy\u3B02\u3B06rc;\u4177;\u444Bn\u803B\xa5\u40A5r;\uC000\ud835\udd36cy;\u4457pf;\uC000\ud835\udd6acr;\uC000\ud835\udcce\u0100cm\u3B26\u3B29y;\u444El\u803B\xff\u40FF\u0500acdefhiosw\u3B42\u3B48\u3B54\u3B58\u3B64\u3B69\u3B6D\u3B74\u3B7A\u3B80cute;\u417A\u0100ay\u3B4D\u3B52ron;\u417E;\u4437ot;\u417C\u0100et\u3B5D\u3B61tr\xe6\u155Fa;\u43B6r;\uC000\ud835\udd37cy;\u4436grarr;\u61DDpf;\uC000\ud835\udd6bcr;\uC000\ud835\udccf\u0100jn\u3B85\u3B87;\u600Dj;\u600C'.split("").map(function(c) {
    return c.charCodeAt(0);
}));

});

parcelRegister("Gij1U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07f21f891c8e27f4$export$2e2bcd8739ae039; });
// Generated using scripts/write-decode-map.ts
var $07f21f891c8e27f4$export$2e2bcd8739ae039 = new Uint16Array(// prettier-ignore
"\u0200aglq	\x15\x18\x1b\u026D\x0f\x00\x00\x12p;\u4026os;\u4027t;\u403Et;\u403Cuot;\u4022".split("").map(function(c) {
    return c.charCodeAt(0);
}));

});

parcelRegister("aGPEI", function(module, exports) {

$parcel$export(module.exports, "fromCodePoint", function () { return $7c85e55e561a290f$export$73bfc63873071f74; });
$parcel$export(module.exports, "replaceCodePoint", function () { return $7c85e55e561a290f$export$b978ab756102108a; });
// Adapted from https://github.com/mathiasbynens/he/blob/36afe179392226cf1b6ccdb16ebbb7a5a844d93a/src/he.js#L106-L134
var $7c85e55e561a290f$var$_a;
var $7c85e55e561a290f$var$decodeMap = new Map([
    [
        0,
        65533
    ],
    // C1 Unicode control character reference replacements
    [
        128,
        8364
    ],
    [
        130,
        8218
    ],
    [
        131,
        402
    ],
    [
        132,
        8222
    ],
    [
        133,
        8230
    ],
    [
        134,
        8224
    ],
    [
        135,
        8225
    ],
    [
        136,
        710
    ],
    [
        137,
        8240
    ],
    [
        138,
        352
    ],
    [
        139,
        8249
    ],
    [
        140,
        338
    ],
    [
        142,
        381
    ],
    [
        145,
        8216
    ],
    [
        146,
        8217
    ],
    [
        147,
        8220
    ],
    [
        148,
        8221
    ],
    [
        149,
        8226
    ],
    [
        150,
        8211
    ],
    [
        151,
        8212
    ],
    [
        152,
        732
    ],
    [
        153,
        8482
    ],
    [
        154,
        353
    ],
    [
        155,
        8250
    ],
    [
        156,
        339
    ],
    [
        158,
        382
    ],
    [
        159,
        376
    ]
]);
var $7c85e55e561a290f$export$73bfc63873071f74 = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
($7c85e55e561a290f$var$_a = String.fromCodePoint) !== null && $7c85e55e561a290f$var$_a !== void 0 ? $7c85e55e561a290f$var$_a : function fromCodePoint(codePoint) {
    var output = "";
    if (codePoint > 0xffff) {
        codePoint -= 0x10000;
        output += String.fromCharCode(codePoint >>> 10 & 0x3ff | 0xd800);
        codePoint = 0xdc00 | codePoint & 0x3ff;
    }
    output += String.fromCharCode(codePoint);
    return output;
};
function $7c85e55e561a290f$export$b978ab756102108a(codePoint) {
    var _a;
    if (codePoint >= 0xd800 && codePoint <= 0xdfff || codePoint > 0x10ffff) return 0xfffd;
    return (_a = $7c85e55e561a290f$var$decodeMap.get(codePoint)) !== null && _a !== void 0 ? _a : codePoint;
}
function $7c85e55e561a290f$export$2e2bcd8739ae039(codePoint) {
    return $7c85e55e561a290f$export$73bfc63873071f74($7c85e55e561a290f$export$b978ab756102108a(codePoint));
}

});


parcelRegister("gYsdX", function(module, exports) {

$parcel$export(module.exports, "encodeHTML", function () { return $c5b824a983822ea9$export$f9d6449b9af28dc1; });
$parcel$export(module.exports, "encodeNonAsciiHTML", function () { return $c5b824a983822ea9$export$e6e86c76506f1190; });

var $4TJ87 = parcelRequire("4TJ87");

var $34Tlx = parcelRequire("34Tlx");
var $c5b824a983822ea9$var$htmlReplacer = /[\t\n!-,./:-@[-`\f{-}$\x80-\uFFFF]/g;
function $c5b824a983822ea9$export$f9d6449b9af28dc1(data) {
    return $c5b824a983822ea9$var$encodeHTMLTrieRe($c5b824a983822ea9$var$htmlReplacer, data);
}
function $c5b824a983822ea9$export$e6e86c76506f1190(data) {
    return $c5b824a983822ea9$var$encodeHTMLTrieRe((0, $34Tlx.xmlReplacer), data);
}
function $c5b824a983822ea9$var$encodeHTMLTrieRe(regExp, str) {
    var ret = "";
    var lastIdx = 0;
    var match;
    while((match = regExp.exec(str)) !== null){
        var i = match.index;
        ret += str.substring(lastIdx, i);
        var char = str.charCodeAt(i);
        var next = (0, $4TJ87.default).get(char);
        if (typeof next === "object") {
            // We are in a branch. Try to match the next char.
            if (i + 1 < str.length) {
                var nextChar = str.charCodeAt(i + 1);
                var value = typeof next.n === "number" ? next.n === nextChar ? next.o : undefined : next.n.get(nextChar);
                if (value !== undefined) {
                    ret += value;
                    lastIdx = regExp.lastIndex += 1;
                    continue;
                }
            }
            next = next.v;
        }
        // We might have a tree node without a value; skip and use a numeric entity.
        if (next !== undefined) {
            ret += next;
            lastIdx = i + 1;
        } else {
            var cp = (0, $34Tlx.getCodePoint)(str, i);
            ret += "&#x".concat(cp.toString(16), ";");
            // Increase by 1 if we have a surrogate pair
            lastIdx = regExp.lastIndex += Number(cp !== char);
        }
    }
    return ret + str.substr(lastIdx);
}

});
parcelRegister("4TJ87", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $390f4e5d04a2e1fa$export$2e2bcd8739ae039; });
// Generated using scripts/write-encode-map.ts
function $390f4e5d04a2e1fa$var$restoreDiff(arr) {
    for(var i = 1; i < arr.length; i++)arr[i][0] += arr[i - 1][0] + 1;
    return arr;
}
var // prettier-ignore
$390f4e5d04a2e1fa$export$2e2bcd8739ae039 = new Map(/* #__PURE__ */ $390f4e5d04a2e1fa$var$restoreDiff([
    [
        9,
        "&Tab;"
    ],
    [
        0,
        "&NewLine;"
    ],
    [
        22,
        "&excl;"
    ],
    [
        0,
        "&quot;"
    ],
    [
        0,
        "&num;"
    ],
    [
        0,
        "&dollar;"
    ],
    [
        0,
        "&percnt;"
    ],
    [
        0,
        "&amp;"
    ],
    [
        0,
        "&apos;"
    ],
    [
        0,
        "&lpar;"
    ],
    [
        0,
        "&rpar;"
    ],
    [
        0,
        "&ast;"
    ],
    [
        0,
        "&plus;"
    ],
    [
        0,
        "&comma;"
    ],
    [
        1,
        "&period;"
    ],
    [
        0,
        "&sol;"
    ],
    [
        10,
        "&colon;"
    ],
    [
        0,
        "&semi;"
    ],
    [
        0,
        {
            v: "&lt;",
            n: 8402,
            o: "&nvlt;"
        }
    ],
    [
        0,
        {
            v: "&equals;",
            n: 8421,
            o: "&bne;"
        }
    ],
    [
        0,
        {
            v: "&gt;",
            n: 8402,
            o: "&nvgt;"
        }
    ],
    [
        0,
        "&quest;"
    ],
    [
        0,
        "&commat;"
    ],
    [
        26,
        "&lbrack;"
    ],
    [
        0,
        "&bsol;"
    ],
    [
        0,
        "&rbrack;"
    ],
    [
        0,
        "&Hat;"
    ],
    [
        0,
        "&lowbar;"
    ],
    [
        0,
        "&DiacriticalGrave;"
    ],
    [
        5,
        {
            n: 106,
            o: "&fjlig;"
        }
    ],
    [
        20,
        "&lbrace;"
    ],
    [
        0,
        "&verbar;"
    ],
    [
        0,
        "&rbrace;"
    ],
    [
        34,
        "&nbsp;"
    ],
    [
        0,
        "&iexcl;"
    ],
    [
        0,
        "&cent;"
    ],
    [
        0,
        "&pound;"
    ],
    [
        0,
        "&curren;"
    ],
    [
        0,
        "&yen;"
    ],
    [
        0,
        "&brvbar;"
    ],
    [
        0,
        "&sect;"
    ],
    [
        0,
        "&die;"
    ],
    [
        0,
        "&copy;"
    ],
    [
        0,
        "&ordf;"
    ],
    [
        0,
        "&laquo;"
    ],
    [
        0,
        "&not;"
    ],
    [
        0,
        "&shy;"
    ],
    [
        0,
        "&circledR;"
    ],
    [
        0,
        "&macr;"
    ],
    [
        0,
        "&deg;"
    ],
    [
        0,
        "&PlusMinus;"
    ],
    [
        0,
        "&sup2;"
    ],
    [
        0,
        "&sup3;"
    ],
    [
        0,
        "&acute;"
    ],
    [
        0,
        "&micro;"
    ],
    [
        0,
        "&para;"
    ],
    [
        0,
        "&centerdot;"
    ],
    [
        0,
        "&cedil;"
    ],
    [
        0,
        "&sup1;"
    ],
    [
        0,
        "&ordm;"
    ],
    [
        0,
        "&raquo;"
    ],
    [
        0,
        "&frac14;"
    ],
    [
        0,
        "&frac12;"
    ],
    [
        0,
        "&frac34;"
    ],
    [
        0,
        "&iquest;"
    ],
    [
        0,
        "&Agrave;"
    ],
    [
        0,
        "&Aacute;"
    ],
    [
        0,
        "&Acirc;"
    ],
    [
        0,
        "&Atilde;"
    ],
    [
        0,
        "&Auml;"
    ],
    [
        0,
        "&angst;"
    ],
    [
        0,
        "&AElig;"
    ],
    [
        0,
        "&Ccedil;"
    ],
    [
        0,
        "&Egrave;"
    ],
    [
        0,
        "&Eacute;"
    ],
    [
        0,
        "&Ecirc;"
    ],
    [
        0,
        "&Euml;"
    ],
    [
        0,
        "&Igrave;"
    ],
    [
        0,
        "&Iacute;"
    ],
    [
        0,
        "&Icirc;"
    ],
    [
        0,
        "&Iuml;"
    ],
    [
        0,
        "&ETH;"
    ],
    [
        0,
        "&Ntilde;"
    ],
    [
        0,
        "&Ograve;"
    ],
    [
        0,
        "&Oacute;"
    ],
    [
        0,
        "&Ocirc;"
    ],
    [
        0,
        "&Otilde;"
    ],
    [
        0,
        "&Ouml;"
    ],
    [
        0,
        "&times;"
    ],
    [
        0,
        "&Oslash;"
    ],
    [
        0,
        "&Ugrave;"
    ],
    [
        0,
        "&Uacute;"
    ],
    [
        0,
        "&Ucirc;"
    ],
    [
        0,
        "&Uuml;"
    ],
    [
        0,
        "&Yacute;"
    ],
    [
        0,
        "&THORN;"
    ],
    [
        0,
        "&szlig;"
    ],
    [
        0,
        "&agrave;"
    ],
    [
        0,
        "&aacute;"
    ],
    [
        0,
        "&acirc;"
    ],
    [
        0,
        "&atilde;"
    ],
    [
        0,
        "&auml;"
    ],
    [
        0,
        "&aring;"
    ],
    [
        0,
        "&aelig;"
    ],
    [
        0,
        "&ccedil;"
    ],
    [
        0,
        "&egrave;"
    ],
    [
        0,
        "&eacute;"
    ],
    [
        0,
        "&ecirc;"
    ],
    [
        0,
        "&euml;"
    ],
    [
        0,
        "&igrave;"
    ],
    [
        0,
        "&iacute;"
    ],
    [
        0,
        "&icirc;"
    ],
    [
        0,
        "&iuml;"
    ],
    [
        0,
        "&eth;"
    ],
    [
        0,
        "&ntilde;"
    ],
    [
        0,
        "&ograve;"
    ],
    [
        0,
        "&oacute;"
    ],
    [
        0,
        "&ocirc;"
    ],
    [
        0,
        "&otilde;"
    ],
    [
        0,
        "&ouml;"
    ],
    [
        0,
        "&div;"
    ],
    [
        0,
        "&oslash;"
    ],
    [
        0,
        "&ugrave;"
    ],
    [
        0,
        "&uacute;"
    ],
    [
        0,
        "&ucirc;"
    ],
    [
        0,
        "&uuml;"
    ],
    [
        0,
        "&yacute;"
    ],
    [
        0,
        "&thorn;"
    ],
    [
        0,
        "&yuml;"
    ],
    [
        0,
        "&Amacr;"
    ],
    [
        0,
        "&amacr;"
    ],
    [
        0,
        "&Abreve;"
    ],
    [
        0,
        "&abreve;"
    ],
    [
        0,
        "&Aogon;"
    ],
    [
        0,
        "&aogon;"
    ],
    [
        0,
        "&Cacute;"
    ],
    [
        0,
        "&cacute;"
    ],
    [
        0,
        "&Ccirc;"
    ],
    [
        0,
        "&ccirc;"
    ],
    [
        0,
        "&Cdot;"
    ],
    [
        0,
        "&cdot;"
    ],
    [
        0,
        "&Ccaron;"
    ],
    [
        0,
        "&ccaron;"
    ],
    [
        0,
        "&Dcaron;"
    ],
    [
        0,
        "&dcaron;"
    ],
    [
        0,
        "&Dstrok;"
    ],
    [
        0,
        "&dstrok;"
    ],
    [
        0,
        "&Emacr;"
    ],
    [
        0,
        "&emacr;"
    ],
    [
        2,
        "&Edot;"
    ],
    [
        0,
        "&edot;"
    ],
    [
        0,
        "&Eogon;"
    ],
    [
        0,
        "&eogon;"
    ],
    [
        0,
        "&Ecaron;"
    ],
    [
        0,
        "&ecaron;"
    ],
    [
        0,
        "&Gcirc;"
    ],
    [
        0,
        "&gcirc;"
    ],
    [
        0,
        "&Gbreve;"
    ],
    [
        0,
        "&gbreve;"
    ],
    [
        0,
        "&Gdot;"
    ],
    [
        0,
        "&gdot;"
    ],
    [
        0,
        "&Gcedil;"
    ],
    [
        1,
        "&Hcirc;"
    ],
    [
        0,
        "&hcirc;"
    ],
    [
        0,
        "&Hstrok;"
    ],
    [
        0,
        "&hstrok;"
    ],
    [
        0,
        "&Itilde;"
    ],
    [
        0,
        "&itilde;"
    ],
    [
        0,
        "&Imacr;"
    ],
    [
        0,
        "&imacr;"
    ],
    [
        2,
        "&Iogon;"
    ],
    [
        0,
        "&iogon;"
    ],
    [
        0,
        "&Idot;"
    ],
    [
        0,
        "&imath;"
    ],
    [
        0,
        "&IJlig;"
    ],
    [
        0,
        "&ijlig;"
    ],
    [
        0,
        "&Jcirc;"
    ],
    [
        0,
        "&jcirc;"
    ],
    [
        0,
        "&Kcedil;"
    ],
    [
        0,
        "&kcedil;"
    ],
    [
        0,
        "&kgreen;"
    ],
    [
        0,
        "&Lacute;"
    ],
    [
        0,
        "&lacute;"
    ],
    [
        0,
        "&Lcedil;"
    ],
    [
        0,
        "&lcedil;"
    ],
    [
        0,
        "&Lcaron;"
    ],
    [
        0,
        "&lcaron;"
    ],
    [
        0,
        "&Lmidot;"
    ],
    [
        0,
        "&lmidot;"
    ],
    [
        0,
        "&Lstrok;"
    ],
    [
        0,
        "&lstrok;"
    ],
    [
        0,
        "&Nacute;"
    ],
    [
        0,
        "&nacute;"
    ],
    [
        0,
        "&Ncedil;"
    ],
    [
        0,
        "&ncedil;"
    ],
    [
        0,
        "&Ncaron;"
    ],
    [
        0,
        "&ncaron;"
    ],
    [
        0,
        "&napos;"
    ],
    [
        0,
        "&ENG;"
    ],
    [
        0,
        "&eng;"
    ],
    [
        0,
        "&Omacr;"
    ],
    [
        0,
        "&omacr;"
    ],
    [
        2,
        "&Odblac;"
    ],
    [
        0,
        "&odblac;"
    ],
    [
        0,
        "&OElig;"
    ],
    [
        0,
        "&oelig;"
    ],
    [
        0,
        "&Racute;"
    ],
    [
        0,
        "&racute;"
    ],
    [
        0,
        "&Rcedil;"
    ],
    [
        0,
        "&rcedil;"
    ],
    [
        0,
        "&Rcaron;"
    ],
    [
        0,
        "&rcaron;"
    ],
    [
        0,
        "&Sacute;"
    ],
    [
        0,
        "&sacute;"
    ],
    [
        0,
        "&Scirc;"
    ],
    [
        0,
        "&scirc;"
    ],
    [
        0,
        "&Scedil;"
    ],
    [
        0,
        "&scedil;"
    ],
    [
        0,
        "&Scaron;"
    ],
    [
        0,
        "&scaron;"
    ],
    [
        0,
        "&Tcedil;"
    ],
    [
        0,
        "&tcedil;"
    ],
    [
        0,
        "&Tcaron;"
    ],
    [
        0,
        "&tcaron;"
    ],
    [
        0,
        "&Tstrok;"
    ],
    [
        0,
        "&tstrok;"
    ],
    [
        0,
        "&Utilde;"
    ],
    [
        0,
        "&utilde;"
    ],
    [
        0,
        "&Umacr;"
    ],
    [
        0,
        "&umacr;"
    ],
    [
        0,
        "&Ubreve;"
    ],
    [
        0,
        "&ubreve;"
    ],
    [
        0,
        "&Uring;"
    ],
    [
        0,
        "&uring;"
    ],
    [
        0,
        "&Udblac;"
    ],
    [
        0,
        "&udblac;"
    ],
    [
        0,
        "&Uogon;"
    ],
    [
        0,
        "&uogon;"
    ],
    [
        0,
        "&Wcirc;"
    ],
    [
        0,
        "&wcirc;"
    ],
    [
        0,
        "&Ycirc;"
    ],
    [
        0,
        "&ycirc;"
    ],
    [
        0,
        "&Yuml;"
    ],
    [
        0,
        "&Zacute;"
    ],
    [
        0,
        "&zacute;"
    ],
    [
        0,
        "&Zdot;"
    ],
    [
        0,
        "&zdot;"
    ],
    [
        0,
        "&Zcaron;"
    ],
    [
        0,
        "&zcaron;"
    ],
    [
        19,
        "&fnof;"
    ],
    [
        34,
        "&imped;"
    ],
    [
        63,
        "&gacute;"
    ],
    [
        65,
        "&jmath;"
    ],
    [
        142,
        "&circ;"
    ],
    [
        0,
        "&caron;"
    ],
    [
        16,
        "&breve;"
    ],
    [
        0,
        "&DiacriticalDot;"
    ],
    [
        0,
        "&ring;"
    ],
    [
        0,
        "&ogon;"
    ],
    [
        0,
        "&DiacriticalTilde;"
    ],
    [
        0,
        "&dblac;"
    ],
    [
        51,
        "&DownBreve;"
    ],
    [
        127,
        "&Alpha;"
    ],
    [
        0,
        "&Beta;"
    ],
    [
        0,
        "&Gamma;"
    ],
    [
        0,
        "&Delta;"
    ],
    [
        0,
        "&Epsilon;"
    ],
    [
        0,
        "&Zeta;"
    ],
    [
        0,
        "&Eta;"
    ],
    [
        0,
        "&Theta;"
    ],
    [
        0,
        "&Iota;"
    ],
    [
        0,
        "&Kappa;"
    ],
    [
        0,
        "&Lambda;"
    ],
    [
        0,
        "&Mu;"
    ],
    [
        0,
        "&Nu;"
    ],
    [
        0,
        "&Xi;"
    ],
    [
        0,
        "&Omicron;"
    ],
    [
        0,
        "&Pi;"
    ],
    [
        0,
        "&Rho;"
    ],
    [
        1,
        "&Sigma;"
    ],
    [
        0,
        "&Tau;"
    ],
    [
        0,
        "&Upsilon;"
    ],
    [
        0,
        "&Phi;"
    ],
    [
        0,
        "&Chi;"
    ],
    [
        0,
        "&Psi;"
    ],
    [
        0,
        "&ohm;"
    ],
    [
        7,
        "&alpha;"
    ],
    [
        0,
        "&beta;"
    ],
    [
        0,
        "&gamma;"
    ],
    [
        0,
        "&delta;"
    ],
    [
        0,
        "&epsi;"
    ],
    [
        0,
        "&zeta;"
    ],
    [
        0,
        "&eta;"
    ],
    [
        0,
        "&theta;"
    ],
    [
        0,
        "&iota;"
    ],
    [
        0,
        "&kappa;"
    ],
    [
        0,
        "&lambda;"
    ],
    [
        0,
        "&mu;"
    ],
    [
        0,
        "&nu;"
    ],
    [
        0,
        "&xi;"
    ],
    [
        0,
        "&omicron;"
    ],
    [
        0,
        "&pi;"
    ],
    [
        0,
        "&rho;"
    ],
    [
        0,
        "&sigmaf;"
    ],
    [
        0,
        "&sigma;"
    ],
    [
        0,
        "&tau;"
    ],
    [
        0,
        "&upsi;"
    ],
    [
        0,
        "&phi;"
    ],
    [
        0,
        "&chi;"
    ],
    [
        0,
        "&psi;"
    ],
    [
        0,
        "&omega;"
    ],
    [
        7,
        "&thetasym;"
    ],
    [
        0,
        "&Upsi;"
    ],
    [
        2,
        "&phiv;"
    ],
    [
        0,
        "&piv;"
    ],
    [
        5,
        "&Gammad;"
    ],
    [
        0,
        "&digamma;"
    ],
    [
        18,
        "&kappav;"
    ],
    [
        0,
        "&rhov;"
    ],
    [
        3,
        "&epsiv;"
    ],
    [
        0,
        "&backepsilon;"
    ],
    [
        10,
        "&IOcy;"
    ],
    [
        0,
        "&DJcy;"
    ],
    [
        0,
        "&GJcy;"
    ],
    [
        0,
        "&Jukcy;"
    ],
    [
        0,
        "&DScy;"
    ],
    [
        0,
        "&Iukcy;"
    ],
    [
        0,
        "&YIcy;"
    ],
    [
        0,
        "&Jsercy;"
    ],
    [
        0,
        "&LJcy;"
    ],
    [
        0,
        "&NJcy;"
    ],
    [
        0,
        "&TSHcy;"
    ],
    [
        0,
        "&KJcy;"
    ],
    [
        1,
        "&Ubrcy;"
    ],
    [
        0,
        "&DZcy;"
    ],
    [
        0,
        "&Acy;"
    ],
    [
        0,
        "&Bcy;"
    ],
    [
        0,
        "&Vcy;"
    ],
    [
        0,
        "&Gcy;"
    ],
    [
        0,
        "&Dcy;"
    ],
    [
        0,
        "&IEcy;"
    ],
    [
        0,
        "&ZHcy;"
    ],
    [
        0,
        "&Zcy;"
    ],
    [
        0,
        "&Icy;"
    ],
    [
        0,
        "&Jcy;"
    ],
    [
        0,
        "&Kcy;"
    ],
    [
        0,
        "&Lcy;"
    ],
    [
        0,
        "&Mcy;"
    ],
    [
        0,
        "&Ncy;"
    ],
    [
        0,
        "&Ocy;"
    ],
    [
        0,
        "&Pcy;"
    ],
    [
        0,
        "&Rcy;"
    ],
    [
        0,
        "&Scy;"
    ],
    [
        0,
        "&Tcy;"
    ],
    [
        0,
        "&Ucy;"
    ],
    [
        0,
        "&Fcy;"
    ],
    [
        0,
        "&KHcy;"
    ],
    [
        0,
        "&TScy;"
    ],
    [
        0,
        "&CHcy;"
    ],
    [
        0,
        "&SHcy;"
    ],
    [
        0,
        "&SHCHcy;"
    ],
    [
        0,
        "&HARDcy;"
    ],
    [
        0,
        "&Ycy;"
    ],
    [
        0,
        "&SOFTcy;"
    ],
    [
        0,
        "&Ecy;"
    ],
    [
        0,
        "&YUcy;"
    ],
    [
        0,
        "&YAcy;"
    ],
    [
        0,
        "&acy;"
    ],
    [
        0,
        "&bcy;"
    ],
    [
        0,
        "&vcy;"
    ],
    [
        0,
        "&gcy;"
    ],
    [
        0,
        "&dcy;"
    ],
    [
        0,
        "&iecy;"
    ],
    [
        0,
        "&zhcy;"
    ],
    [
        0,
        "&zcy;"
    ],
    [
        0,
        "&icy;"
    ],
    [
        0,
        "&jcy;"
    ],
    [
        0,
        "&kcy;"
    ],
    [
        0,
        "&lcy;"
    ],
    [
        0,
        "&mcy;"
    ],
    [
        0,
        "&ncy;"
    ],
    [
        0,
        "&ocy;"
    ],
    [
        0,
        "&pcy;"
    ],
    [
        0,
        "&rcy;"
    ],
    [
        0,
        "&scy;"
    ],
    [
        0,
        "&tcy;"
    ],
    [
        0,
        "&ucy;"
    ],
    [
        0,
        "&fcy;"
    ],
    [
        0,
        "&khcy;"
    ],
    [
        0,
        "&tscy;"
    ],
    [
        0,
        "&chcy;"
    ],
    [
        0,
        "&shcy;"
    ],
    [
        0,
        "&shchcy;"
    ],
    [
        0,
        "&hardcy;"
    ],
    [
        0,
        "&ycy;"
    ],
    [
        0,
        "&softcy;"
    ],
    [
        0,
        "&ecy;"
    ],
    [
        0,
        "&yucy;"
    ],
    [
        0,
        "&yacy;"
    ],
    [
        1,
        "&iocy;"
    ],
    [
        0,
        "&djcy;"
    ],
    [
        0,
        "&gjcy;"
    ],
    [
        0,
        "&jukcy;"
    ],
    [
        0,
        "&dscy;"
    ],
    [
        0,
        "&iukcy;"
    ],
    [
        0,
        "&yicy;"
    ],
    [
        0,
        "&jsercy;"
    ],
    [
        0,
        "&ljcy;"
    ],
    [
        0,
        "&njcy;"
    ],
    [
        0,
        "&tshcy;"
    ],
    [
        0,
        "&kjcy;"
    ],
    [
        1,
        "&ubrcy;"
    ],
    [
        0,
        "&dzcy;"
    ],
    [
        7074,
        "&ensp;"
    ],
    [
        0,
        "&emsp;"
    ],
    [
        0,
        "&emsp13;"
    ],
    [
        0,
        "&emsp14;"
    ],
    [
        1,
        "&numsp;"
    ],
    [
        0,
        "&puncsp;"
    ],
    [
        0,
        "&ThinSpace;"
    ],
    [
        0,
        "&hairsp;"
    ],
    [
        0,
        "&NegativeMediumSpace;"
    ],
    [
        0,
        "&zwnj;"
    ],
    [
        0,
        "&zwj;"
    ],
    [
        0,
        "&lrm;"
    ],
    [
        0,
        "&rlm;"
    ],
    [
        0,
        "&dash;"
    ],
    [
        2,
        "&ndash;"
    ],
    [
        0,
        "&mdash;"
    ],
    [
        0,
        "&horbar;"
    ],
    [
        0,
        "&Verbar;"
    ],
    [
        1,
        "&lsquo;"
    ],
    [
        0,
        "&CloseCurlyQuote;"
    ],
    [
        0,
        "&lsquor;"
    ],
    [
        1,
        "&ldquo;"
    ],
    [
        0,
        "&CloseCurlyDoubleQuote;"
    ],
    [
        0,
        "&bdquo;"
    ],
    [
        1,
        "&dagger;"
    ],
    [
        0,
        "&Dagger;"
    ],
    [
        0,
        "&bull;"
    ],
    [
        2,
        "&nldr;"
    ],
    [
        0,
        "&hellip;"
    ],
    [
        9,
        "&permil;"
    ],
    [
        0,
        "&pertenk;"
    ],
    [
        0,
        "&prime;"
    ],
    [
        0,
        "&Prime;"
    ],
    [
        0,
        "&tprime;"
    ],
    [
        0,
        "&backprime;"
    ],
    [
        3,
        "&lsaquo;"
    ],
    [
        0,
        "&rsaquo;"
    ],
    [
        3,
        "&oline;"
    ],
    [
        2,
        "&caret;"
    ],
    [
        1,
        "&hybull;"
    ],
    [
        0,
        "&frasl;"
    ],
    [
        10,
        "&bsemi;"
    ],
    [
        7,
        "&qprime;"
    ],
    [
        7,
        {
            v: "&MediumSpace;",
            n: 8202,
            o: "&ThickSpace;"
        }
    ],
    [
        0,
        "&NoBreak;"
    ],
    [
        0,
        "&af;"
    ],
    [
        0,
        "&InvisibleTimes;"
    ],
    [
        0,
        "&ic;"
    ],
    [
        72,
        "&euro;"
    ],
    [
        46,
        "&tdot;"
    ],
    [
        0,
        "&DotDot;"
    ],
    [
        37,
        "&complexes;"
    ],
    [
        2,
        "&incare;"
    ],
    [
        4,
        "&gscr;"
    ],
    [
        0,
        "&hamilt;"
    ],
    [
        0,
        "&Hfr;"
    ],
    [
        0,
        "&Hopf;"
    ],
    [
        0,
        "&planckh;"
    ],
    [
        0,
        "&hbar;"
    ],
    [
        0,
        "&imagline;"
    ],
    [
        0,
        "&Ifr;"
    ],
    [
        0,
        "&lagran;"
    ],
    [
        0,
        "&ell;"
    ],
    [
        1,
        "&naturals;"
    ],
    [
        0,
        "&numero;"
    ],
    [
        0,
        "&copysr;"
    ],
    [
        0,
        "&weierp;"
    ],
    [
        0,
        "&Popf;"
    ],
    [
        0,
        "&Qopf;"
    ],
    [
        0,
        "&realine;"
    ],
    [
        0,
        "&real;"
    ],
    [
        0,
        "&reals;"
    ],
    [
        0,
        "&rx;"
    ],
    [
        3,
        "&trade;"
    ],
    [
        1,
        "&integers;"
    ],
    [
        2,
        "&mho;"
    ],
    [
        0,
        "&zeetrf;"
    ],
    [
        0,
        "&iiota;"
    ],
    [
        2,
        "&bernou;"
    ],
    [
        0,
        "&Cayleys;"
    ],
    [
        1,
        "&escr;"
    ],
    [
        0,
        "&Escr;"
    ],
    [
        0,
        "&Fouriertrf;"
    ],
    [
        1,
        "&Mellintrf;"
    ],
    [
        0,
        "&order;"
    ],
    [
        0,
        "&alefsym;"
    ],
    [
        0,
        "&beth;"
    ],
    [
        0,
        "&gimel;"
    ],
    [
        0,
        "&daleth;"
    ],
    [
        12,
        "&CapitalDifferentialD;"
    ],
    [
        0,
        "&dd;"
    ],
    [
        0,
        "&ee;"
    ],
    [
        0,
        "&ii;"
    ],
    [
        10,
        "&frac13;"
    ],
    [
        0,
        "&frac23;"
    ],
    [
        0,
        "&frac15;"
    ],
    [
        0,
        "&frac25;"
    ],
    [
        0,
        "&frac35;"
    ],
    [
        0,
        "&frac45;"
    ],
    [
        0,
        "&frac16;"
    ],
    [
        0,
        "&frac56;"
    ],
    [
        0,
        "&frac18;"
    ],
    [
        0,
        "&frac38;"
    ],
    [
        0,
        "&frac58;"
    ],
    [
        0,
        "&frac78;"
    ],
    [
        49,
        "&larr;"
    ],
    [
        0,
        "&ShortUpArrow;"
    ],
    [
        0,
        "&rarr;"
    ],
    [
        0,
        "&darr;"
    ],
    [
        0,
        "&harr;"
    ],
    [
        0,
        "&updownarrow;"
    ],
    [
        0,
        "&nwarr;"
    ],
    [
        0,
        "&nearr;"
    ],
    [
        0,
        "&LowerRightArrow;"
    ],
    [
        0,
        "&LowerLeftArrow;"
    ],
    [
        0,
        "&nlarr;"
    ],
    [
        0,
        "&nrarr;"
    ],
    [
        1,
        {
            v: "&rarrw;",
            n: 824,
            o: "&nrarrw;"
        }
    ],
    [
        0,
        "&Larr;"
    ],
    [
        0,
        "&Uarr;"
    ],
    [
        0,
        "&Rarr;"
    ],
    [
        0,
        "&Darr;"
    ],
    [
        0,
        "&larrtl;"
    ],
    [
        0,
        "&rarrtl;"
    ],
    [
        0,
        "&LeftTeeArrow;"
    ],
    [
        0,
        "&mapstoup;"
    ],
    [
        0,
        "&map;"
    ],
    [
        0,
        "&DownTeeArrow;"
    ],
    [
        1,
        "&hookleftarrow;"
    ],
    [
        0,
        "&hookrightarrow;"
    ],
    [
        0,
        "&larrlp;"
    ],
    [
        0,
        "&looparrowright;"
    ],
    [
        0,
        "&harrw;"
    ],
    [
        0,
        "&nharr;"
    ],
    [
        1,
        "&lsh;"
    ],
    [
        0,
        "&rsh;"
    ],
    [
        0,
        "&ldsh;"
    ],
    [
        0,
        "&rdsh;"
    ],
    [
        1,
        "&crarr;"
    ],
    [
        0,
        "&cularr;"
    ],
    [
        0,
        "&curarr;"
    ],
    [
        2,
        "&circlearrowleft;"
    ],
    [
        0,
        "&circlearrowright;"
    ],
    [
        0,
        "&leftharpoonup;"
    ],
    [
        0,
        "&DownLeftVector;"
    ],
    [
        0,
        "&RightUpVector;"
    ],
    [
        0,
        "&LeftUpVector;"
    ],
    [
        0,
        "&rharu;"
    ],
    [
        0,
        "&DownRightVector;"
    ],
    [
        0,
        "&dharr;"
    ],
    [
        0,
        "&dharl;"
    ],
    [
        0,
        "&RightArrowLeftArrow;"
    ],
    [
        0,
        "&udarr;"
    ],
    [
        0,
        "&LeftArrowRightArrow;"
    ],
    [
        0,
        "&leftleftarrows;"
    ],
    [
        0,
        "&upuparrows;"
    ],
    [
        0,
        "&rightrightarrows;"
    ],
    [
        0,
        "&ddarr;"
    ],
    [
        0,
        "&leftrightharpoons;"
    ],
    [
        0,
        "&Equilibrium;"
    ],
    [
        0,
        "&nlArr;"
    ],
    [
        0,
        "&nhArr;"
    ],
    [
        0,
        "&nrArr;"
    ],
    [
        0,
        "&DoubleLeftArrow;"
    ],
    [
        0,
        "&DoubleUpArrow;"
    ],
    [
        0,
        "&DoubleRightArrow;"
    ],
    [
        0,
        "&dArr;"
    ],
    [
        0,
        "&DoubleLeftRightArrow;"
    ],
    [
        0,
        "&DoubleUpDownArrow;"
    ],
    [
        0,
        "&nwArr;"
    ],
    [
        0,
        "&neArr;"
    ],
    [
        0,
        "&seArr;"
    ],
    [
        0,
        "&swArr;"
    ],
    [
        0,
        "&lAarr;"
    ],
    [
        0,
        "&rAarr;"
    ],
    [
        1,
        "&zigrarr;"
    ],
    [
        6,
        "&larrb;"
    ],
    [
        0,
        "&rarrb;"
    ],
    [
        15,
        "&DownArrowUpArrow;"
    ],
    [
        7,
        "&loarr;"
    ],
    [
        0,
        "&roarr;"
    ],
    [
        0,
        "&hoarr;"
    ],
    [
        0,
        "&forall;"
    ],
    [
        0,
        "&comp;"
    ],
    [
        0,
        {
            v: "&part;",
            n: 824,
            o: "&npart;"
        }
    ],
    [
        0,
        "&exist;"
    ],
    [
        0,
        "&nexist;"
    ],
    [
        0,
        "&empty;"
    ],
    [
        1,
        "&Del;"
    ],
    [
        0,
        "&Element;"
    ],
    [
        0,
        "&NotElement;"
    ],
    [
        1,
        "&ni;"
    ],
    [
        0,
        "&notni;"
    ],
    [
        2,
        "&prod;"
    ],
    [
        0,
        "&coprod;"
    ],
    [
        0,
        "&sum;"
    ],
    [
        0,
        "&minus;"
    ],
    [
        0,
        "&MinusPlus;"
    ],
    [
        0,
        "&dotplus;"
    ],
    [
        1,
        "&Backslash;"
    ],
    [
        0,
        "&lowast;"
    ],
    [
        0,
        "&compfn;"
    ],
    [
        1,
        "&radic;"
    ],
    [
        2,
        "&prop;"
    ],
    [
        0,
        "&infin;"
    ],
    [
        0,
        "&angrt;"
    ],
    [
        0,
        {
            v: "&ang;",
            n: 8402,
            o: "&nang;"
        }
    ],
    [
        0,
        "&angmsd;"
    ],
    [
        0,
        "&angsph;"
    ],
    [
        0,
        "&mid;"
    ],
    [
        0,
        "&nmid;"
    ],
    [
        0,
        "&DoubleVerticalBar;"
    ],
    [
        0,
        "&NotDoubleVerticalBar;"
    ],
    [
        0,
        "&and;"
    ],
    [
        0,
        "&or;"
    ],
    [
        0,
        {
            v: "&cap;",
            n: 65024,
            o: "&caps;"
        }
    ],
    [
        0,
        {
            v: "&cup;",
            n: 65024,
            o: "&cups;"
        }
    ],
    [
        0,
        "&int;"
    ],
    [
        0,
        "&Int;"
    ],
    [
        0,
        "&iiint;"
    ],
    [
        0,
        "&conint;"
    ],
    [
        0,
        "&Conint;"
    ],
    [
        0,
        "&Cconint;"
    ],
    [
        0,
        "&cwint;"
    ],
    [
        0,
        "&ClockwiseContourIntegral;"
    ],
    [
        0,
        "&awconint;"
    ],
    [
        0,
        "&there4;"
    ],
    [
        0,
        "&becaus;"
    ],
    [
        0,
        "&ratio;"
    ],
    [
        0,
        "&Colon;"
    ],
    [
        0,
        "&dotminus;"
    ],
    [
        1,
        "&mDDot;"
    ],
    [
        0,
        "&homtht;"
    ],
    [
        0,
        {
            v: "&sim;",
            n: 8402,
            o: "&nvsim;"
        }
    ],
    [
        0,
        {
            v: "&backsim;",
            n: 817,
            o: "&race;"
        }
    ],
    [
        0,
        {
            v: "&ac;",
            n: 819,
            o: "&acE;"
        }
    ],
    [
        0,
        "&acd;"
    ],
    [
        0,
        "&VerticalTilde;"
    ],
    [
        0,
        "&NotTilde;"
    ],
    [
        0,
        {
            v: "&eqsim;",
            n: 824,
            o: "&nesim;"
        }
    ],
    [
        0,
        "&sime;"
    ],
    [
        0,
        "&NotTildeEqual;"
    ],
    [
        0,
        "&cong;"
    ],
    [
        0,
        "&simne;"
    ],
    [
        0,
        "&ncong;"
    ],
    [
        0,
        "&ap;"
    ],
    [
        0,
        "&nap;"
    ],
    [
        0,
        "&ape;"
    ],
    [
        0,
        {
            v: "&apid;",
            n: 824,
            o: "&napid;"
        }
    ],
    [
        0,
        "&backcong;"
    ],
    [
        0,
        {
            v: "&asympeq;",
            n: 8402,
            o: "&nvap;"
        }
    ],
    [
        0,
        {
            v: "&bump;",
            n: 824,
            o: "&nbump;"
        }
    ],
    [
        0,
        {
            v: "&bumpe;",
            n: 824,
            o: "&nbumpe;"
        }
    ],
    [
        0,
        {
            v: "&doteq;",
            n: 824,
            o: "&nedot;"
        }
    ],
    [
        0,
        "&doteqdot;"
    ],
    [
        0,
        "&efDot;"
    ],
    [
        0,
        "&erDot;"
    ],
    [
        0,
        "&Assign;"
    ],
    [
        0,
        "&ecolon;"
    ],
    [
        0,
        "&ecir;"
    ],
    [
        0,
        "&circeq;"
    ],
    [
        1,
        "&wedgeq;"
    ],
    [
        0,
        "&veeeq;"
    ],
    [
        1,
        "&triangleq;"
    ],
    [
        2,
        "&equest;"
    ],
    [
        0,
        "&ne;"
    ],
    [
        0,
        {
            v: "&Congruent;",
            n: 8421,
            o: "&bnequiv;"
        }
    ],
    [
        0,
        "&nequiv;"
    ],
    [
        1,
        {
            v: "&le;",
            n: 8402,
            o: "&nvle;"
        }
    ],
    [
        0,
        {
            v: "&ge;",
            n: 8402,
            o: "&nvge;"
        }
    ],
    [
        0,
        {
            v: "&lE;",
            n: 824,
            o: "&nlE;"
        }
    ],
    [
        0,
        {
            v: "&gE;",
            n: 824,
            o: "&ngE;"
        }
    ],
    [
        0,
        {
            v: "&lnE;",
            n: 65024,
            o: "&lvertneqq;"
        }
    ],
    [
        0,
        {
            v: "&gnE;",
            n: 65024,
            o: "&gvertneqq;"
        }
    ],
    [
        0,
        {
            v: "&ll;",
            n: new Map(/* #__PURE__ */ $390f4e5d04a2e1fa$var$restoreDiff([
                [
                    824,
                    "&nLtv;"
                ],
                [
                    7577,
                    "&nLt;"
                ]
            ]))
        }
    ],
    [
        0,
        {
            v: "&gg;",
            n: new Map(/* #__PURE__ */ $390f4e5d04a2e1fa$var$restoreDiff([
                [
                    824,
                    "&nGtv;"
                ],
                [
                    7577,
                    "&nGt;"
                ]
            ]))
        }
    ],
    [
        0,
        "&between;"
    ],
    [
        0,
        "&NotCupCap;"
    ],
    [
        0,
        "&nless;"
    ],
    [
        0,
        "&ngt;"
    ],
    [
        0,
        "&nle;"
    ],
    [
        0,
        "&nge;"
    ],
    [
        0,
        "&lesssim;"
    ],
    [
        0,
        "&GreaterTilde;"
    ],
    [
        0,
        "&nlsim;"
    ],
    [
        0,
        "&ngsim;"
    ],
    [
        0,
        "&LessGreater;"
    ],
    [
        0,
        "&gl;"
    ],
    [
        0,
        "&NotLessGreater;"
    ],
    [
        0,
        "&NotGreaterLess;"
    ],
    [
        0,
        "&pr;"
    ],
    [
        0,
        "&sc;"
    ],
    [
        0,
        "&prcue;"
    ],
    [
        0,
        "&sccue;"
    ],
    [
        0,
        "&PrecedesTilde;"
    ],
    [
        0,
        {
            v: "&scsim;",
            n: 824,
            o: "&NotSucceedsTilde;"
        }
    ],
    [
        0,
        "&NotPrecedes;"
    ],
    [
        0,
        "&NotSucceeds;"
    ],
    [
        0,
        {
            v: "&sub;",
            n: 8402,
            o: "&NotSubset;"
        }
    ],
    [
        0,
        {
            v: "&sup;",
            n: 8402,
            o: "&NotSuperset;"
        }
    ],
    [
        0,
        "&nsub;"
    ],
    [
        0,
        "&nsup;"
    ],
    [
        0,
        "&sube;"
    ],
    [
        0,
        "&supe;"
    ],
    [
        0,
        "&NotSubsetEqual;"
    ],
    [
        0,
        "&NotSupersetEqual;"
    ],
    [
        0,
        {
            v: "&subne;",
            n: 65024,
            o: "&varsubsetneq;"
        }
    ],
    [
        0,
        {
            v: "&supne;",
            n: 65024,
            o: "&varsupsetneq;"
        }
    ],
    [
        1,
        "&cupdot;"
    ],
    [
        0,
        "&UnionPlus;"
    ],
    [
        0,
        {
            v: "&sqsub;",
            n: 824,
            o: "&NotSquareSubset;"
        }
    ],
    [
        0,
        {
            v: "&sqsup;",
            n: 824,
            o: "&NotSquareSuperset;"
        }
    ],
    [
        0,
        "&sqsube;"
    ],
    [
        0,
        "&sqsupe;"
    ],
    [
        0,
        {
            v: "&sqcap;",
            n: 65024,
            o: "&sqcaps;"
        }
    ],
    [
        0,
        {
            v: "&sqcup;",
            n: 65024,
            o: "&sqcups;"
        }
    ],
    [
        0,
        "&CirclePlus;"
    ],
    [
        0,
        "&CircleMinus;"
    ],
    [
        0,
        "&CircleTimes;"
    ],
    [
        0,
        "&osol;"
    ],
    [
        0,
        "&CircleDot;"
    ],
    [
        0,
        "&circledcirc;"
    ],
    [
        0,
        "&circledast;"
    ],
    [
        1,
        "&circleddash;"
    ],
    [
        0,
        "&boxplus;"
    ],
    [
        0,
        "&boxminus;"
    ],
    [
        0,
        "&boxtimes;"
    ],
    [
        0,
        "&dotsquare;"
    ],
    [
        0,
        "&RightTee;"
    ],
    [
        0,
        "&dashv;"
    ],
    [
        0,
        "&DownTee;"
    ],
    [
        0,
        "&bot;"
    ],
    [
        1,
        "&models;"
    ],
    [
        0,
        "&DoubleRightTee;"
    ],
    [
        0,
        "&Vdash;"
    ],
    [
        0,
        "&Vvdash;"
    ],
    [
        0,
        "&VDash;"
    ],
    [
        0,
        "&nvdash;"
    ],
    [
        0,
        "&nvDash;"
    ],
    [
        0,
        "&nVdash;"
    ],
    [
        0,
        "&nVDash;"
    ],
    [
        0,
        "&prurel;"
    ],
    [
        1,
        "&LeftTriangle;"
    ],
    [
        0,
        "&RightTriangle;"
    ],
    [
        0,
        {
            v: "&LeftTriangleEqual;",
            n: 8402,
            o: "&nvltrie;"
        }
    ],
    [
        0,
        {
            v: "&RightTriangleEqual;",
            n: 8402,
            o: "&nvrtrie;"
        }
    ],
    [
        0,
        "&origof;"
    ],
    [
        0,
        "&imof;"
    ],
    [
        0,
        "&multimap;"
    ],
    [
        0,
        "&hercon;"
    ],
    [
        0,
        "&intcal;"
    ],
    [
        0,
        "&veebar;"
    ],
    [
        1,
        "&barvee;"
    ],
    [
        0,
        "&angrtvb;"
    ],
    [
        0,
        "&lrtri;"
    ],
    [
        0,
        "&bigwedge;"
    ],
    [
        0,
        "&bigvee;"
    ],
    [
        0,
        "&bigcap;"
    ],
    [
        0,
        "&bigcup;"
    ],
    [
        0,
        "&diam;"
    ],
    [
        0,
        "&sdot;"
    ],
    [
        0,
        "&sstarf;"
    ],
    [
        0,
        "&divideontimes;"
    ],
    [
        0,
        "&bowtie;"
    ],
    [
        0,
        "&ltimes;"
    ],
    [
        0,
        "&rtimes;"
    ],
    [
        0,
        "&leftthreetimes;"
    ],
    [
        0,
        "&rightthreetimes;"
    ],
    [
        0,
        "&backsimeq;"
    ],
    [
        0,
        "&curlyvee;"
    ],
    [
        0,
        "&curlywedge;"
    ],
    [
        0,
        "&Sub;"
    ],
    [
        0,
        "&Sup;"
    ],
    [
        0,
        "&Cap;"
    ],
    [
        0,
        "&Cup;"
    ],
    [
        0,
        "&fork;"
    ],
    [
        0,
        "&epar;"
    ],
    [
        0,
        "&lessdot;"
    ],
    [
        0,
        "&gtdot;"
    ],
    [
        0,
        {
            v: "&Ll;",
            n: 824,
            o: "&nLl;"
        }
    ],
    [
        0,
        {
            v: "&Gg;",
            n: 824,
            o: "&nGg;"
        }
    ],
    [
        0,
        {
            v: "&leg;",
            n: 65024,
            o: "&lesg;"
        }
    ],
    [
        0,
        {
            v: "&gel;",
            n: 65024,
            o: "&gesl;"
        }
    ],
    [
        2,
        "&cuepr;"
    ],
    [
        0,
        "&cuesc;"
    ],
    [
        0,
        "&NotPrecedesSlantEqual;"
    ],
    [
        0,
        "&NotSucceedsSlantEqual;"
    ],
    [
        0,
        "&NotSquareSubsetEqual;"
    ],
    [
        0,
        "&NotSquareSupersetEqual;"
    ],
    [
        2,
        "&lnsim;"
    ],
    [
        0,
        "&gnsim;"
    ],
    [
        0,
        "&precnsim;"
    ],
    [
        0,
        "&scnsim;"
    ],
    [
        0,
        "&nltri;"
    ],
    [
        0,
        "&NotRightTriangle;"
    ],
    [
        0,
        "&nltrie;"
    ],
    [
        0,
        "&NotRightTriangleEqual;"
    ],
    [
        0,
        "&vellip;"
    ],
    [
        0,
        "&ctdot;"
    ],
    [
        0,
        "&utdot;"
    ],
    [
        0,
        "&dtdot;"
    ],
    [
        0,
        "&disin;"
    ],
    [
        0,
        "&isinsv;"
    ],
    [
        0,
        "&isins;"
    ],
    [
        0,
        {
            v: "&isindot;",
            n: 824,
            o: "&notindot;"
        }
    ],
    [
        0,
        "&notinvc;"
    ],
    [
        0,
        "&notinvb;"
    ],
    [
        1,
        {
            v: "&isinE;",
            n: 824,
            o: "&notinE;"
        }
    ],
    [
        0,
        "&nisd;"
    ],
    [
        0,
        "&xnis;"
    ],
    [
        0,
        "&nis;"
    ],
    [
        0,
        "&notnivc;"
    ],
    [
        0,
        "&notnivb;"
    ],
    [
        6,
        "&barwed;"
    ],
    [
        0,
        "&Barwed;"
    ],
    [
        1,
        "&lceil;"
    ],
    [
        0,
        "&rceil;"
    ],
    [
        0,
        "&LeftFloor;"
    ],
    [
        0,
        "&rfloor;"
    ],
    [
        0,
        "&drcrop;"
    ],
    [
        0,
        "&dlcrop;"
    ],
    [
        0,
        "&urcrop;"
    ],
    [
        0,
        "&ulcrop;"
    ],
    [
        0,
        "&bnot;"
    ],
    [
        1,
        "&profline;"
    ],
    [
        0,
        "&profsurf;"
    ],
    [
        1,
        "&telrec;"
    ],
    [
        0,
        "&target;"
    ],
    [
        5,
        "&ulcorn;"
    ],
    [
        0,
        "&urcorn;"
    ],
    [
        0,
        "&dlcorn;"
    ],
    [
        0,
        "&drcorn;"
    ],
    [
        2,
        "&frown;"
    ],
    [
        0,
        "&smile;"
    ],
    [
        9,
        "&cylcty;"
    ],
    [
        0,
        "&profalar;"
    ],
    [
        7,
        "&topbot;"
    ],
    [
        6,
        "&ovbar;"
    ],
    [
        1,
        "&solbar;"
    ],
    [
        60,
        "&angzarr;"
    ],
    [
        51,
        "&lmoustache;"
    ],
    [
        0,
        "&rmoustache;"
    ],
    [
        2,
        "&OverBracket;"
    ],
    [
        0,
        "&bbrk;"
    ],
    [
        0,
        "&bbrktbrk;"
    ],
    [
        37,
        "&OverParenthesis;"
    ],
    [
        0,
        "&UnderParenthesis;"
    ],
    [
        0,
        "&OverBrace;"
    ],
    [
        0,
        "&UnderBrace;"
    ],
    [
        2,
        "&trpezium;"
    ],
    [
        4,
        "&elinters;"
    ],
    [
        59,
        "&blank;"
    ],
    [
        164,
        "&circledS;"
    ],
    [
        55,
        "&boxh;"
    ],
    [
        1,
        "&boxv;"
    ],
    [
        9,
        "&boxdr;"
    ],
    [
        3,
        "&boxdl;"
    ],
    [
        3,
        "&boxur;"
    ],
    [
        3,
        "&boxul;"
    ],
    [
        3,
        "&boxvr;"
    ],
    [
        7,
        "&boxvl;"
    ],
    [
        7,
        "&boxhd;"
    ],
    [
        7,
        "&boxhu;"
    ],
    [
        7,
        "&boxvh;"
    ],
    [
        19,
        "&boxH;"
    ],
    [
        0,
        "&boxV;"
    ],
    [
        0,
        "&boxdR;"
    ],
    [
        0,
        "&boxDr;"
    ],
    [
        0,
        "&boxDR;"
    ],
    [
        0,
        "&boxdL;"
    ],
    [
        0,
        "&boxDl;"
    ],
    [
        0,
        "&boxDL;"
    ],
    [
        0,
        "&boxuR;"
    ],
    [
        0,
        "&boxUr;"
    ],
    [
        0,
        "&boxUR;"
    ],
    [
        0,
        "&boxuL;"
    ],
    [
        0,
        "&boxUl;"
    ],
    [
        0,
        "&boxUL;"
    ],
    [
        0,
        "&boxvR;"
    ],
    [
        0,
        "&boxVr;"
    ],
    [
        0,
        "&boxVR;"
    ],
    [
        0,
        "&boxvL;"
    ],
    [
        0,
        "&boxVl;"
    ],
    [
        0,
        "&boxVL;"
    ],
    [
        0,
        "&boxHd;"
    ],
    [
        0,
        "&boxhD;"
    ],
    [
        0,
        "&boxHD;"
    ],
    [
        0,
        "&boxHu;"
    ],
    [
        0,
        "&boxhU;"
    ],
    [
        0,
        "&boxHU;"
    ],
    [
        0,
        "&boxvH;"
    ],
    [
        0,
        "&boxVh;"
    ],
    [
        0,
        "&boxVH;"
    ],
    [
        19,
        "&uhblk;"
    ],
    [
        3,
        "&lhblk;"
    ],
    [
        3,
        "&block;"
    ],
    [
        8,
        "&blk14;"
    ],
    [
        0,
        "&blk12;"
    ],
    [
        0,
        "&blk34;"
    ],
    [
        13,
        "&square;"
    ],
    [
        8,
        "&blacksquare;"
    ],
    [
        0,
        "&EmptyVerySmallSquare;"
    ],
    [
        1,
        "&rect;"
    ],
    [
        0,
        "&marker;"
    ],
    [
        2,
        "&fltns;"
    ],
    [
        1,
        "&bigtriangleup;"
    ],
    [
        0,
        "&blacktriangle;"
    ],
    [
        0,
        "&triangle;"
    ],
    [
        2,
        "&blacktriangleright;"
    ],
    [
        0,
        "&rtri;"
    ],
    [
        3,
        "&bigtriangledown;"
    ],
    [
        0,
        "&blacktriangledown;"
    ],
    [
        0,
        "&dtri;"
    ],
    [
        2,
        "&blacktriangleleft;"
    ],
    [
        0,
        "&ltri;"
    ],
    [
        6,
        "&loz;"
    ],
    [
        0,
        "&cir;"
    ],
    [
        32,
        "&tridot;"
    ],
    [
        2,
        "&bigcirc;"
    ],
    [
        8,
        "&ultri;"
    ],
    [
        0,
        "&urtri;"
    ],
    [
        0,
        "&lltri;"
    ],
    [
        0,
        "&EmptySmallSquare;"
    ],
    [
        0,
        "&FilledSmallSquare;"
    ],
    [
        8,
        "&bigstar;"
    ],
    [
        0,
        "&star;"
    ],
    [
        7,
        "&phone;"
    ],
    [
        49,
        "&female;"
    ],
    [
        1,
        "&male;"
    ],
    [
        29,
        "&spades;"
    ],
    [
        2,
        "&clubs;"
    ],
    [
        1,
        "&hearts;"
    ],
    [
        0,
        "&diamondsuit;"
    ],
    [
        3,
        "&sung;"
    ],
    [
        2,
        "&flat;"
    ],
    [
        0,
        "&natural;"
    ],
    [
        0,
        "&sharp;"
    ],
    [
        163,
        "&check;"
    ],
    [
        3,
        "&cross;"
    ],
    [
        8,
        "&malt;"
    ],
    [
        21,
        "&sext;"
    ],
    [
        33,
        "&VerticalSeparator;"
    ],
    [
        25,
        "&lbbrk;"
    ],
    [
        0,
        "&rbbrk;"
    ],
    [
        84,
        "&bsolhsub;"
    ],
    [
        0,
        "&suphsol;"
    ],
    [
        28,
        "&LeftDoubleBracket;"
    ],
    [
        0,
        "&RightDoubleBracket;"
    ],
    [
        0,
        "&lang;"
    ],
    [
        0,
        "&rang;"
    ],
    [
        0,
        "&Lang;"
    ],
    [
        0,
        "&Rang;"
    ],
    [
        0,
        "&loang;"
    ],
    [
        0,
        "&roang;"
    ],
    [
        7,
        "&longleftarrow;"
    ],
    [
        0,
        "&longrightarrow;"
    ],
    [
        0,
        "&longleftrightarrow;"
    ],
    [
        0,
        "&DoubleLongLeftArrow;"
    ],
    [
        0,
        "&DoubleLongRightArrow;"
    ],
    [
        0,
        "&DoubleLongLeftRightArrow;"
    ],
    [
        1,
        "&longmapsto;"
    ],
    [
        2,
        "&dzigrarr;"
    ],
    [
        258,
        "&nvlArr;"
    ],
    [
        0,
        "&nvrArr;"
    ],
    [
        0,
        "&nvHarr;"
    ],
    [
        0,
        "&Map;"
    ],
    [
        6,
        "&lbarr;"
    ],
    [
        0,
        "&bkarow;"
    ],
    [
        0,
        "&lBarr;"
    ],
    [
        0,
        "&dbkarow;"
    ],
    [
        0,
        "&drbkarow;"
    ],
    [
        0,
        "&DDotrahd;"
    ],
    [
        0,
        "&UpArrowBar;"
    ],
    [
        0,
        "&DownArrowBar;"
    ],
    [
        2,
        "&Rarrtl;"
    ],
    [
        2,
        "&latail;"
    ],
    [
        0,
        "&ratail;"
    ],
    [
        0,
        "&lAtail;"
    ],
    [
        0,
        "&rAtail;"
    ],
    [
        0,
        "&larrfs;"
    ],
    [
        0,
        "&rarrfs;"
    ],
    [
        0,
        "&larrbfs;"
    ],
    [
        0,
        "&rarrbfs;"
    ],
    [
        2,
        "&nwarhk;"
    ],
    [
        0,
        "&nearhk;"
    ],
    [
        0,
        "&hksearow;"
    ],
    [
        0,
        "&hkswarow;"
    ],
    [
        0,
        "&nwnear;"
    ],
    [
        0,
        "&nesear;"
    ],
    [
        0,
        "&seswar;"
    ],
    [
        0,
        "&swnwar;"
    ],
    [
        8,
        {
            v: "&rarrc;",
            n: 824,
            o: "&nrarrc;"
        }
    ],
    [
        1,
        "&cudarrr;"
    ],
    [
        0,
        "&ldca;"
    ],
    [
        0,
        "&rdca;"
    ],
    [
        0,
        "&cudarrl;"
    ],
    [
        0,
        "&larrpl;"
    ],
    [
        2,
        "&curarrm;"
    ],
    [
        0,
        "&cularrp;"
    ],
    [
        7,
        "&rarrpl;"
    ],
    [
        2,
        "&harrcir;"
    ],
    [
        0,
        "&Uarrocir;"
    ],
    [
        0,
        "&lurdshar;"
    ],
    [
        0,
        "&ldrushar;"
    ],
    [
        2,
        "&LeftRightVector;"
    ],
    [
        0,
        "&RightUpDownVector;"
    ],
    [
        0,
        "&DownLeftRightVector;"
    ],
    [
        0,
        "&LeftUpDownVector;"
    ],
    [
        0,
        "&LeftVectorBar;"
    ],
    [
        0,
        "&RightVectorBar;"
    ],
    [
        0,
        "&RightUpVectorBar;"
    ],
    [
        0,
        "&RightDownVectorBar;"
    ],
    [
        0,
        "&DownLeftVectorBar;"
    ],
    [
        0,
        "&DownRightVectorBar;"
    ],
    [
        0,
        "&LeftUpVectorBar;"
    ],
    [
        0,
        "&LeftDownVectorBar;"
    ],
    [
        0,
        "&LeftTeeVector;"
    ],
    [
        0,
        "&RightTeeVector;"
    ],
    [
        0,
        "&RightUpTeeVector;"
    ],
    [
        0,
        "&RightDownTeeVector;"
    ],
    [
        0,
        "&DownLeftTeeVector;"
    ],
    [
        0,
        "&DownRightTeeVector;"
    ],
    [
        0,
        "&LeftUpTeeVector;"
    ],
    [
        0,
        "&LeftDownTeeVector;"
    ],
    [
        0,
        "&lHar;"
    ],
    [
        0,
        "&uHar;"
    ],
    [
        0,
        "&rHar;"
    ],
    [
        0,
        "&dHar;"
    ],
    [
        0,
        "&luruhar;"
    ],
    [
        0,
        "&ldrdhar;"
    ],
    [
        0,
        "&ruluhar;"
    ],
    [
        0,
        "&rdldhar;"
    ],
    [
        0,
        "&lharul;"
    ],
    [
        0,
        "&llhard;"
    ],
    [
        0,
        "&rharul;"
    ],
    [
        0,
        "&lrhard;"
    ],
    [
        0,
        "&udhar;"
    ],
    [
        0,
        "&duhar;"
    ],
    [
        0,
        "&RoundImplies;"
    ],
    [
        0,
        "&erarr;"
    ],
    [
        0,
        "&simrarr;"
    ],
    [
        0,
        "&larrsim;"
    ],
    [
        0,
        "&rarrsim;"
    ],
    [
        0,
        "&rarrap;"
    ],
    [
        0,
        "&ltlarr;"
    ],
    [
        1,
        "&gtrarr;"
    ],
    [
        0,
        "&subrarr;"
    ],
    [
        1,
        "&suplarr;"
    ],
    [
        0,
        "&lfisht;"
    ],
    [
        0,
        "&rfisht;"
    ],
    [
        0,
        "&ufisht;"
    ],
    [
        0,
        "&dfisht;"
    ],
    [
        5,
        "&lopar;"
    ],
    [
        0,
        "&ropar;"
    ],
    [
        4,
        "&lbrke;"
    ],
    [
        0,
        "&rbrke;"
    ],
    [
        0,
        "&lbrkslu;"
    ],
    [
        0,
        "&rbrksld;"
    ],
    [
        0,
        "&lbrksld;"
    ],
    [
        0,
        "&rbrkslu;"
    ],
    [
        0,
        "&langd;"
    ],
    [
        0,
        "&rangd;"
    ],
    [
        0,
        "&lparlt;"
    ],
    [
        0,
        "&rpargt;"
    ],
    [
        0,
        "&gtlPar;"
    ],
    [
        0,
        "&ltrPar;"
    ],
    [
        3,
        "&vzigzag;"
    ],
    [
        1,
        "&vangrt;"
    ],
    [
        0,
        "&angrtvbd;"
    ],
    [
        6,
        "&ange;"
    ],
    [
        0,
        "&range;"
    ],
    [
        0,
        "&dwangle;"
    ],
    [
        0,
        "&uwangle;"
    ],
    [
        0,
        "&angmsdaa;"
    ],
    [
        0,
        "&angmsdab;"
    ],
    [
        0,
        "&angmsdac;"
    ],
    [
        0,
        "&angmsdad;"
    ],
    [
        0,
        "&angmsdae;"
    ],
    [
        0,
        "&angmsdaf;"
    ],
    [
        0,
        "&angmsdag;"
    ],
    [
        0,
        "&angmsdah;"
    ],
    [
        0,
        "&bemptyv;"
    ],
    [
        0,
        "&demptyv;"
    ],
    [
        0,
        "&cemptyv;"
    ],
    [
        0,
        "&raemptyv;"
    ],
    [
        0,
        "&laemptyv;"
    ],
    [
        0,
        "&ohbar;"
    ],
    [
        0,
        "&omid;"
    ],
    [
        0,
        "&opar;"
    ],
    [
        1,
        "&operp;"
    ],
    [
        1,
        "&olcross;"
    ],
    [
        0,
        "&odsold;"
    ],
    [
        1,
        "&olcir;"
    ],
    [
        0,
        "&ofcir;"
    ],
    [
        0,
        "&olt;"
    ],
    [
        0,
        "&ogt;"
    ],
    [
        0,
        "&cirscir;"
    ],
    [
        0,
        "&cirE;"
    ],
    [
        0,
        "&solb;"
    ],
    [
        0,
        "&bsolb;"
    ],
    [
        3,
        "&boxbox;"
    ],
    [
        3,
        "&trisb;"
    ],
    [
        0,
        "&rtriltri;"
    ],
    [
        0,
        {
            v: "&LeftTriangleBar;",
            n: 824,
            o: "&NotLeftTriangleBar;"
        }
    ],
    [
        0,
        {
            v: "&RightTriangleBar;",
            n: 824,
            o: "&NotRightTriangleBar;"
        }
    ],
    [
        11,
        "&iinfin;"
    ],
    [
        0,
        "&infintie;"
    ],
    [
        0,
        "&nvinfin;"
    ],
    [
        4,
        "&eparsl;"
    ],
    [
        0,
        "&smeparsl;"
    ],
    [
        0,
        "&eqvparsl;"
    ],
    [
        5,
        "&blacklozenge;"
    ],
    [
        8,
        "&RuleDelayed;"
    ],
    [
        1,
        "&dsol;"
    ],
    [
        9,
        "&bigodot;"
    ],
    [
        0,
        "&bigoplus;"
    ],
    [
        0,
        "&bigotimes;"
    ],
    [
        1,
        "&biguplus;"
    ],
    [
        1,
        "&bigsqcup;"
    ],
    [
        5,
        "&iiiint;"
    ],
    [
        0,
        "&fpartint;"
    ],
    [
        2,
        "&cirfnint;"
    ],
    [
        0,
        "&awint;"
    ],
    [
        0,
        "&rppolint;"
    ],
    [
        0,
        "&scpolint;"
    ],
    [
        0,
        "&npolint;"
    ],
    [
        0,
        "&pointint;"
    ],
    [
        0,
        "&quatint;"
    ],
    [
        0,
        "&intlarhk;"
    ],
    [
        10,
        "&pluscir;"
    ],
    [
        0,
        "&plusacir;"
    ],
    [
        0,
        "&simplus;"
    ],
    [
        0,
        "&plusdu;"
    ],
    [
        0,
        "&plussim;"
    ],
    [
        0,
        "&plustwo;"
    ],
    [
        1,
        "&mcomma;"
    ],
    [
        0,
        "&minusdu;"
    ],
    [
        2,
        "&loplus;"
    ],
    [
        0,
        "&roplus;"
    ],
    [
        0,
        "&Cross;"
    ],
    [
        0,
        "&timesd;"
    ],
    [
        0,
        "&timesbar;"
    ],
    [
        1,
        "&smashp;"
    ],
    [
        0,
        "&lotimes;"
    ],
    [
        0,
        "&rotimes;"
    ],
    [
        0,
        "&otimesas;"
    ],
    [
        0,
        "&Otimes;"
    ],
    [
        0,
        "&odiv;"
    ],
    [
        0,
        "&triplus;"
    ],
    [
        0,
        "&triminus;"
    ],
    [
        0,
        "&tritime;"
    ],
    [
        0,
        "&intprod;"
    ],
    [
        2,
        "&amalg;"
    ],
    [
        0,
        "&capdot;"
    ],
    [
        1,
        "&ncup;"
    ],
    [
        0,
        "&ncap;"
    ],
    [
        0,
        "&capand;"
    ],
    [
        0,
        "&cupor;"
    ],
    [
        0,
        "&cupcap;"
    ],
    [
        0,
        "&capcup;"
    ],
    [
        0,
        "&cupbrcap;"
    ],
    [
        0,
        "&capbrcup;"
    ],
    [
        0,
        "&cupcup;"
    ],
    [
        0,
        "&capcap;"
    ],
    [
        0,
        "&ccups;"
    ],
    [
        0,
        "&ccaps;"
    ],
    [
        2,
        "&ccupssm;"
    ],
    [
        2,
        "&And;"
    ],
    [
        0,
        "&Or;"
    ],
    [
        0,
        "&andand;"
    ],
    [
        0,
        "&oror;"
    ],
    [
        0,
        "&orslope;"
    ],
    [
        0,
        "&andslope;"
    ],
    [
        1,
        "&andv;"
    ],
    [
        0,
        "&orv;"
    ],
    [
        0,
        "&andd;"
    ],
    [
        0,
        "&ord;"
    ],
    [
        1,
        "&wedbar;"
    ],
    [
        6,
        "&sdote;"
    ],
    [
        3,
        "&simdot;"
    ],
    [
        2,
        {
            v: "&congdot;",
            n: 824,
            o: "&ncongdot;"
        }
    ],
    [
        0,
        "&easter;"
    ],
    [
        0,
        "&apacir;"
    ],
    [
        0,
        {
            v: "&apE;",
            n: 824,
            o: "&napE;"
        }
    ],
    [
        0,
        "&eplus;"
    ],
    [
        0,
        "&pluse;"
    ],
    [
        0,
        "&Esim;"
    ],
    [
        0,
        "&Colone;"
    ],
    [
        0,
        "&Equal;"
    ],
    [
        1,
        "&ddotseq;"
    ],
    [
        0,
        "&equivDD;"
    ],
    [
        0,
        "&ltcir;"
    ],
    [
        0,
        "&gtcir;"
    ],
    [
        0,
        "&ltquest;"
    ],
    [
        0,
        "&gtquest;"
    ],
    [
        0,
        {
            v: "&leqslant;",
            n: 824,
            o: "&nleqslant;"
        }
    ],
    [
        0,
        {
            v: "&geqslant;",
            n: 824,
            o: "&ngeqslant;"
        }
    ],
    [
        0,
        "&lesdot;"
    ],
    [
        0,
        "&gesdot;"
    ],
    [
        0,
        "&lesdoto;"
    ],
    [
        0,
        "&gesdoto;"
    ],
    [
        0,
        "&lesdotor;"
    ],
    [
        0,
        "&gesdotol;"
    ],
    [
        0,
        "&lap;"
    ],
    [
        0,
        "&gap;"
    ],
    [
        0,
        "&lne;"
    ],
    [
        0,
        "&gne;"
    ],
    [
        0,
        "&lnap;"
    ],
    [
        0,
        "&gnap;"
    ],
    [
        0,
        "&lEg;"
    ],
    [
        0,
        "&gEl;"
    ],
    [
        0,
        "&lsime;"
    ],
    [
        0,
        "&gsime;"
    ],
    [
        0,
        "&lsimg;"
    ],
    [
        0,
        "&gsiml;"
    ],
    [
        0,
        "&lgE;"
    ],
    [
        0,
        "&glE;"
    ],
    [
        0,
        "&lesges;"
    ],
    [
        0,
        "&gesles;"
    ],
    [
        0,
        "&els;"
    ],
    [
        0,
        "&egs;"
    ],
    [
        0,
        "&elsdot;"
    ],
    [
        0,
        "&egsdot;"
    ],
    [
        0,
        "&el;"
    ],
    [
        0,
        "&eg;"
    ],
    [
        2,
        "&siml;"
    ],
    [
        0,
        "&simg;"
    ],
    [
        0,
        "&simlE;"
    ],
    [
        0,
        "&simgE;"
    ],
    [
        0,
        {
            v: "&LessLess;",
            n: 824,
            o: "&NotNestedLessLess;"
        }
    ],
    [
        0,
        {
            v: "&GreaterGreater;",
            n: 824,
            o: "&NotNestedGreaterGreater;"
        }
    ],
    [
        1,
        "&glj;"
    ],
    [
        0,
        "&gla;"
    ],
    [
        0,
        "&ltcc;"
    ],
    [
        0,
        "&gtcc;"
    ],
    [
        0,
        "&lescc;"
    ],
    [
        0,
        "&gescc;"
    ],
    [
        0,
        "&smt;"
    ],
    [
        0,
        "&lat;"
    ],
    [
        0,
        {
            v: "&smte;",
            n: 65024,
            o: "&smtes;"
        }
    ],
    [
        0,
        {
            v: "&late;",
            n: 65024,
            o: "&lates;"
        }
    ],
    [
        0,
        "&bumpE;"
    ],
    [
        0,
        {
            v: "&PrecedesEqual;",
            n: 824,
            o: "&NotPrecedesEqual;"
        }
    ],
    [
        0,
        {
            v: "&sce;",
            n: 824,
            o: "&NotSucceedsEqual;"
        }
    ],
    [
        2,
        "&prE;"
    ],
    [
        0,
        "&scE;"
    ],
    [
        0,
        "&precneqq;"
    ],
    [
        0,
        "&scnE;"
    ],
    [
        0,
        "&prap;"
    ],
    [
        0,
        "&scap;"
    ],
    [
        0,
        "&precnapprox;"
    ],
    [
        0,
        "&scnap;"
    ],
    [
        0,
        "&Pr;"
    ],
    [
        0,
        "&Sc;"
    ],
    [
        0,
        "&subdot;"
    ],
    [
        0,
        "&supdot;"
    ],
    [
        0,
        "&subplus;"
    ],
    [
        0,
        "&supplus;"
    ],
    [
        0,
        "&submult;"
    ],
    [
        0,
        "&supmult;"
    ],
    [
        0,
        "&subedot;"
    ],
    [
        0,
        "&supedot;"
    ],
    [
        0,
        {
            v: "&subE;",
            n: 824,
            o: "&nsubE;"
        }
    ],
    [
        0,
        {
            v: "&supE;",
            n: 824,
            o: "&nsupE;"
        }
    ],
    [
        0,
        "&subsim;"
    ],
    [
        0,
        "&supsim;"
    ],
    [
        2,
        {
            v: "&subnE;",
            n: 65024,
            o: "&varsubsetneqq;"
        }
    ],
    [
        0,
        {
            v: "&supnE;",
            n: 65024,
            o: "&varsupsetneqq;"
        }
    ],
    [
        2,
        "&csub;"
    ],
    [
        0,
        "&csup;"
    ],
    [
        0,
        "&csube;"
    ],
    [
        0,
        "&csupe;"
    ],
    [
        0,
        "&subsup;"
    ],
    [
        0,
        "&supsub;"
    ],
    [
        0,
        "&subsub;"
    ],
    [
        0,
        "&supsup;"
    ],
    [
        0,
        "&suphsub;"
    ],
    [
        0,
        "&supdsub;"
    ],
    [
        0,
        "&forkv;"
    ],
    [
        0,
        "&topfork;"
    ],
    [
        0,
        "&mlcp;"
    ],
    [
        8,
        "&Dashv;"
    ],
    [
        1,
        "&Vdashl;"
    ],
    [
        0,
        "&Barv;"
    ],
    [
        0,
        "&vBar;"
    ],
    [
        0,
        "&vBarv;"
    ],
    [
        1,
        "&Vbar;"
    ],
    [
        0,
        "&Not;"
    ],
    [
        0,
        "&bNot;"
    ],
    [
        0,
        "&rnmid;"
    ],
    [
        0,
        "&cirmid;"
    ],
    [
        0,
        "&midcir;"
    ],
    [
        0,
        "&topcir;"
    ],
    [
        0,
        "&nhpar;"
    ],
    [
        0,
        "&parsim;"
    ],
    [
        9,
        {
            v: "&parsl;",
            n: 8421,
            o: "&nparsl;"
        }
    ],
    [
        44343,
        {
            n: new Map(/* #__PURE__ */ $390f4e5d04a2e1fa$var$restoreDiff([
                [
                    56476,
                    "&Ascr;"
                ],
                [
                    1,
                    "&Cscr;"
                ],
                [
                    0,
                    "&Dscr;"
                ],
                [
                    2,
                    "&Gscr;"
                ],
                [
                    2,
                    "&Jscr;"
                ],
                [
                    0,
                    "&Kscr;"
                ],
                [
                    2,
                    "&Nscr;"
                ],
                [
                    0,
                    "&Oscr;"
                ],
                [
                    0,
                    "&Pscr;"
                ],
                [
                    0,
                    "&Qscr;"
                ],
                [
                    1,
                    "&Sscr;"
                ],
                [
                    0,
                    "&Tscr;"
                ],
                [
                    0,
                    "&Uscr;"
                ],
                [
                    0,
                    "&Vscr;"
                ],
                [
                    0,
                    "&Wscr;"
                ],
                [
                    0,
                    "&Xscr;"
                ],
                [
                    0,
                    "&Yscr;"
                ],
                [
                    0,
                    "&Zscr;"
                ],
                [
                    0,
                    "&ascr;"
                ],
                [
                    0,
                    "&bscr;"
                ],
                [
                    0,
                    "&cscr;"
                ],
                [
                    0,
                    "&dscr;"
                ],
                [
                    1,
                    "&fscr;"
                ],
                [
                    1,
                    "&hscr;"
                ],
                [
                    0,
                    "&iscr;"
                ],
                [
                    0,
                    "&jscr;"
                ],
                [
                    0,
                    "&kscr;"
                ],
                [
                    0,
                    "&lscr;"
                ],
                [
                    0,
                    "&mscr;"
                ],
                [
                    0,
                    "&nscr;"
                ],
                [
                    1,
                    "&pscr;"
                ],
                [
                    0,
                    "&qscr;"
                ],
                [
                    0,
                    "&rscr;"
                ],
                [
                    0,
                    "&sscr;"
                ],
                [
                    0,
                    "&tscr;"
                ],
                [
                    0,
                    "&uscr;"
                ],
                [
                    0,
                    "&vscr;"
                ],
                [
                    0,
                    "&wscr;"
                ],
                [
                    0,
                    "&xscr;"
                ],
                [
                    0,
                    "&yscr;"
                ],
                [
                    0,
                    "&zscr;"
                ],
                [
                    52,
                    "&Afr;"
                ],
                [
                    0,
                    "&Bfr;"
                ],
                [
                    1,
                    "&Dfr;"
                ],
                [
                    0,
                    "&Efr;"
                ],
                [
                    0,
                    "&Ffr;"
                ],
                [
                    0,
                    "&Gfr;"
                ],
                [
                    2,
                    "&Jfr;"
                ],
                [
                    0,
                    "&Kfr;"
                ],
                [
                    0,
                    "&Lfr;"
                ],
                [
                    0,
                    "&Mfr;"
                ],
                [
                    0,
                    "&Nfr;"
                ],
                [
                    0,
                    "&Ofr;"
                ],
                [
                    0,
                    "&Pfr;"
                ],
                [
                    0,
                    "&Qfr;"
                ],
                [
                    1,
                    "&Sfr;"
                ],
                [
                    0,
                    "&Tfr;"
                ],
                [
                    0,
                    "&Ufr;"
                ],
                [
                    0,
                    "&Vfr;"
                ],
                [
                    0,
                    "&Wfr;"
                ],
                [
                    0,
                    "&Xfr;"
                ],
                [
                    0,
                    "&Yfr;"
                ],
                [
                    1,
                    "&afr;"
                ],
                [
                    0,
                    "&bfr;"
                ],
                [
                    0,
                    "&cfr;"
                ],
                [
                    0,
                    "&dfr;"
                ],
                [
                    0,
                    "&efr;"
                ],
                [
                    0,
                    "&ffr;"
                ],
                [
                    0,
                    "&gfr;"
                ],
                [
                    0,
                    "&hfr;"
                ],
                [
                    0,
                    "&ifr;"
                ],
                [
                    0,
                    "&jfr;"
                ],
                [
                    0,
                    "&kfr;"
                ],
                [
                    0,
                    "&lfr;"
                ],
                [
                    0,
                    "&mfr;"
                ],
                [
                    0,
                    "&nfr;"
                ],
                [
                    0,
                    "&ofr;"
                ],
                [
                    0,
                    "&pfr;"
                ],
                [
                    0,
                    "&qfr;"
                ],
                [
                    0,
                    "&rfr;"
                ],
                [
                    0,
                    "&sfr;"
                ],
                [
                    0,
                    "&tfr;"
                ],
                [
                    0,
                    "&ufr;"
                ],
                [
                    0,
                    "&vfr;"
                ],
                [
                    0,
                    "&wfr;"
                ],
                [
                    0,
                    "&xfr;"
                ],
                [
                    0,
                    "&yfr;"
                ],
                [
                    0,
                    "&zfr;"
                ],
                [
                    0,
                    "&Aopf;"
                ],
                [
                    0,
                    "&Bopf;"
                ],
                [
                    1,
                    "&Dopf;"
                ],
                [
                    0,
                    "&Eopf;"
                ],
                [
                    0,
                    "&Fopf;"
                ],
                [
                    0,
                    "&Gopf;"
                ],
                [
                    1,
                    "&Iopf;"
                ],
                [
                    0,
                    "&Jopf;"
                ],
                [
                    0,
                    "&Kopf;"
                ],
                [
                    0,
                    "&Lopf;"
                ],
                [
                    0,
                    "&Mopf;"
                ],
                [
                    1,
                    "&Oopf;"
                ],
                [
                    3,
                    "&Sopf;"
                ],
                [
                    0,
                    "&Topf;"
                ],
                [
                    0,
                    "&Uopf;"
                ],
                [
                    0,
                    "&Vopf;"
                ],
                [
                    0,
                    "&Wopf;"
                ],
                [
                    0,
                    "&Xopf;"
                ],
                [
                    0,
                    "&Yopf;"
                ],
                [
                    1,
                    "&aopf;"
                ],
                [
                    0,
                    "&bopf;"
                ],
                [
                    0,
                    "&copf;"
                ],
                [
                    0,
                    "&dopf;"
                ],
                [
                    0,
                    "&eopf;"
                ],
                [
                    0,
                    "&fopf;"
                ],
                [
                    0,
                    "&gopf;"
                ],
                [
                    0,
                    "&hopf;"
                ],
                [
                    0,
                    "&iopf;"
                ],
                [
                    0,
                    "&jopf;"
                ],
                [
                    0,
                    "&kopf;"
                ],
                [
                    0,
                    "&lopf;"
                ],
                [
                    0,
                    "&mopf;"
                ],
                [
                    0,
                    "&nopf;"
                ],
                [
                    0,
                    "&oopf;"
                ],
                [
                    0,
                    "&popf;"
                ],
                [
                    0,
                    "&qopf;"
                ],
                [
                    0,
                    "&ropf;"
                ],
                [
                    0,
                    "&sopf;"
                ],
                [
                    0,
                    "&topf;"
                ],
                [
                    0,
                    "&uopf;"
                ],
                [
                    0,
                    "&vopf;"
                ],
                [
                    0,
                    "&wopf;"
                ],
                [
                    0,
                    "&xopf;"
                ],
                [
                    0,
                    "&yopf;"
                ],
                [
                    0,
                    "&zopf;"
                ]
            ]))
        }
    ],
    [
        8906,
        "&fflig;"
    ],
    [
        0,
        "&filig;"
    ],
    [
        0,
        "&fllig;"
    ],
    [
        0,
        "&ffilig;"
    ],
    [
        0,
        "&ffllig;"
    ]
]));

});

parcelRegister("34Tlx", function(module, exports) {

$parcel$export(module.exports, "xmlReplacer", function () { return $23dcad70516dd952$export$5699810ce3244ab8; });
$parcel$export(module.exports, "getCodePoint", function () { return $23dcad70516dd952$export$e02688b8085d016b; });
$parcel$export(module.exports, "encodeXML", function () { return $23dcad70516dd952$export$18855ec5be97da16; });
$parcel$export(module.exports, "escapeUTF8", function () { return $23dcad70516dd952$export$9e081872deefdcb0; });
$parcel$export(module.exports, "escapeAttribute", function () { return $23dcad70516dd952$export$30330f3d5eb70e11; });
$parcel$export(module.exports, "escapeText", function () { return $23dcad70516dd952$export$96e6fc3a139b2555; });
var $23dcad70516dd952$export$5699810ce3244ab8 = /["&'<>$\x80-\uFFFF]/g;
var $23dcad70516dd952$var$xmlCodeMap = new Map([
    [
        34,
        "&quot;"
    ],
    [
        38,
        "&amp;"
    ],
    [
        39,
        "&apos;"
    ],
    [
        60,
        "&lt;"
    ],
    [
        62,
        "&gt;"
    ]
]);
var $23dcad70516dd952$export$e02688b8085d016b = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
String.prototype.codePointAt != null ? function(str, index) {
    return str.codePointAt(index);
} : function(c, index) {
    return (c.charCodeAt(index) & 0xfc00) === 0xd800 ? (c.charCodeAt(index) - 0xd800) * 0x400 + c.charCodeAt(index + 1) - 0xdc00 + 0x10000 : c.charCodeAt(index);
};
function $23dcad70516dd952$export$18855ec5be97da16(str) {
    var ret = "";
    var lastIdx = 0;
    var match;
    while((match = $23dcad70516dd952$export$5699810ce3244ab8.exec(str)) !== null){
        var i = match.index;
        var char = str.charCodeAt(i);
        var next = $23dcad70516dd952$var$xmlCodeMap.get(char);
        if (next !== undefined) {
            ret += str.substring(lastIdx, i) + next;
            lastIdx = i + 1;
        } else {
            ret += "".concat(str.substring(lastIdx, i), "&#x").concat($23dcad70516dd952$export$e02688b8085d016b(str, i).toString(16), ";");
            // Increase by 1 if we have a surrogate pair
            lastIdx = $23dcad70516dd952$export$5699810ce3244ab8.lastIndex += Number((char & 0xfc00) === 0xd800);
        }
    }
    return ret + str.substr(lastIdx);
}
var $23dcad70516dd952$export$4e7f196112fea3c5 = $23dcad70516dd952$export$18855ec5be97da16;
/**
 * Creates a function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 *
 * @param regex Regular expression to match characters to escape.
 * @param map Map of characters to escape to their entities.
 *
 * @returns Function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 */ function $23dcad70516dd952$var$getEscaper(regex, map) {
    return function escape(data) {
        var match;
        var lastIdx = 0;
        var result = "";
        while(match = regex.exec(data)){
            if (lastIdx !== match.index) result += data.substring(lastIdx, match.index);
            // We know that this character will be in the map.
            result += map.get(match[0].charCodeAt(0));
            // Every match will be of length 1
            lastIdx = match.index + 1;
        }
        return result + data.substring(lastIdx);
    };
}
var $23dcad70516dd952$export$9e081872deefdcb0 = $23dcad70516dd952$var$getEscaper(/[&<>'"]/g, $23dcad70516dd952$var$xmlCodeMap);
var $23dcad70516dd952$export$30330f3d5eb70e11 = $23dcad70516dd952$var$getEscaper(/["&\u00A0]/g, new Map([
    [
        34,
        "&quot;"
    ],
    [
        38,
        "&amp;"
    ],
    [
        160,
        "&nbsp;"
    ]
]));
var $23dcad70516dd952$export$96e6fc3a139b2555 = $23dcad70516dd952$var$getEscaper(/[&<>\u00A0]/g, new Map([
    [
        38,
        "&amp;"
    ],
    [
        60,
        "&lt;"
    ],
    [
        62,
        "&gt;"
    ],
    [
        160,
        "&nbsp;"
    ]
]));

});



parcelRegister("2H2Iy", function(module, exports) {

$parcel$export(module.exports, "elementNames", function () { return $1f61b496e88f9d35$export$82b917442d249e05; });
$parcel$export(module.exports, "attributeNames", function () { return $1f61b496e88f9d35$export$b4cfbfd90280b005; });
var $1f61b496e88f9d35$export$82b917442d249e05 = new Map([
    "altGlyph",
    "altGlyphDef",
    "altGlyphItem",
    "animateColor",
    "animateMotion",
    "animateTransform",
    "clipPath",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "foreignObject",
    "glyphRef",
    "linearGradient",
    "radialGradient",
    "textPath"
].map(function(val) {
    return [
        val.toLowerCase(),
        val
    ];
}));
var $1f61b496e88f9d35$export$b4cfbfd90280b005 = new Map([
    "definitionURL",
    "attributeName",
    "attributeType",
    "baseFrequency",
    "baseProfile",
    "calcMode",
    "clipPathUnits",
    "diffuseConstant",
    "edgeMode",
    "filterUnits",
    "glyphRef",
    "gradientTransform",
    "gradientUnits",
    "kernelMatrix",
    "kernelUnitLength",
    "keyPoints",
    "keySplines",
    "keyTimes",
    "lengthAdjust",
    "limitingConeAngle",
    "markerHeight",
    "markerUnits",
    "markerWidth",
    "maskContentUnits",
    "maskUnits",
    "numOctaves",
    "pathLength",
    "patternContentUnits",
    "patternTransform",
    "patternUnits",
    "pointsAtX",
    "pointsAtY",
    "pointsAtZ",
    "preserveAlpha",
    "preserveAspectRatio",
    "primitiveUnits",
    "refX",
    "refY",
    "repeatCount",
    "repeatDur",
    "requiredExtensions",
    "requiredFeatures",
    "specularConstant",
    "specularExponent",
    "spreadMethod",
    "startOffset",
    "stdDeviation",
    "stitchTiles",
    "surfaceScale",
    "systemLanguage",
    "tableValues",
    "targetX",
    "targetY",
    "textLength",
    "viewBox",
    "viewTarget",
    "xChannelSelector",
    "yChannelSelector",
    "zoomAndPan"
].map(function(val) {
    return [
        val.toLowerCase(),
        val
    ];
}));

});



parcelRegister("jsnEY", function(module, exports) {
parcelRequire("7UyMy");
var $79X3L = parcelRequire("79X3L");
function $e2a2fc33475e1762$export$f8cf48ee793b41be(elem) {
    return (0, $79X3L.hasChildren)(elem) ? elem.children : [];
}
function $e2a2fc33475e1762$export$58081aedf094d85b(elem) {
    return elem.parent || null;
}
function $e2a2fc33475e1762$export$f312c3733b79ac0d(elem) {
    var parent = $e2a2fc33475e1762$export$58081aedf094d85b(elem);
    if (parent != null) return $e2a2fc33475e1762$export$f8cf48ee793b41be(parent);
    var siblings = [
        elem
    ];
    var prev = elem.prev, next = elem.next;
    while(prev != null){
        siblings.unshift(prev);
        prev = prev.prev;
    }
    while(next != null){
        siblings.push(next);
        next = next.next;
    }
    return siblings;
}
function $e2a2fc33475e1762$export$1e335898aa11b111(elem, name) {
    var _a;
    return (_a = elem.attribs) === null || _a === void 0 ? void 0 : _a[name];
}
function $e2a2fc33475e1762$export$aa37f90c17957f38(elem, name) {
    return elem.attribs != null && Object.prototype.hasOwnProperty.call(elem.attribs, name) && elem.attribs[name] != null;
}
function $e2a2fc33475e1762$export$7d9f7e9c1c02b41e(elem) {
    return elem.name;
}
function $e2a2fc33475e1762$export$9be3779649ef9cc7(elem) {
    var next = elem.next;
    while(next !== null && !(0, $79X3L.isTag)(next))next = next.next;
    return next;
}
function $e2a2fc33475e1762$export$c8bafb6e59c0b8e(elem) {
    var prev = elem.prev;
    while(prev !== null && !(0, $79X3L.isTag)(prev))prev = prev.prev;
    return prev;
}

});

parcelRegister("jiCwi", function(module, exports) {
/**
 * Remove an element from the dom
 *
 * @category Manipulation
 * @param elem The element to be removed
 */ function $e0cd9406eb963b70$export$f883456a56996078(elem) {
    if (elem.prev) elem.prev.next = elem.next;
    if (elem.next) elem.next.prev = elem.prev;
    if (elem.parent) {
        var childs = elem.parent.children;
        var childsIndex = childs.lastIndexOf(elem);
        if (childsIndex >= 0) childs.splice(childsIndex, 1);
    }
    elem.next = null;
    elem.prev = null;
    elem.parent = null;
}
function $e0cd9406eb963b70$export$2dfe578f95754f6a(elem, replacement) {
    var prev = replacement.prev = elem.prev;
    if (prev) prev.next = replacement;
    var next = replacement.next = elem.next;
    if (next) next.prev = replacement;
    var parent = replacement.parent = elem.parent;
    if (parent) {
        var childs = parent.children;
        childs[childs.lastIndexOf(elem)] = replacement;
        elem.parent = null;
    }
}
function $e0cd9406eb963b70$export$1b8e57c9ea42f1d2(parent, child) {
    $e0cd9406eb963b70$export$f883456a56996078(child);
    child.next = null;
    child.parent = parent;
    if (parent.children.push(child) > 1) {
        var sibling = parent.children[parent.children.length - 2];
        sibling.next = child;
        child.prev = sibling;
    } else child.prev = null;
}
function $e0cd9406eb963b70$export$10d8903dec122b9d(elem, next) {
    $e0cd9406eb963b70$export$f883456a56996078(next);
    var parent = elem.parent;
    var currNext = elem.next;
    next.next = currNext;
    next.prev = elem;
    elem.next = next;
    next.parent = parent;
    if (currNext) {
        currNext.prev = next;
        if (parent) {
            var childs = parent.children;
            childs.splice(childs.lastIndexOf(currNext), 0, next);
        }
    } else if (parent) parent.children.push(next);
}
function $e0cd9406eb963b70$export$47b51e6d100007bc(parent, child) {
    $e0cd9406eb963b70$export$f883456a56996078(child);
    child.parent = parent;
    child.prev = null;
    if (parent.children.unshift(child) !== 1) {
        var sibling = parent.children[1];
        sibling.prev = child;
        child.next = sibling;
    } else child.next = null;
}
function $e0cd9406eb963b70$export$68159836694e22c1(elem, prev) {
    $e0cd9406eb963b70$export$f883456a56996078(prev);
    var parent = elem.parent;
    if (parent) {
        var childs = parent.children;
        childs.splice(childs.indexOf(elem), 0, prev);
    }
    if (elem.prev) elem.prev.next = prev;
    prev.parent = parent;
    prev.prev = elem.prev;
    prev.next = elem;
    elem.prev = prev;
}

});

parcelRegister("gS874", function(module, exports) {

$parcel$export(module.exports, "filter", function () { return $c487fb929112518f$export$3dea766d36a8935f; });
$parcel$export(module.exports, "findOne", function () { return $c487fb929112518f$export$a541876d5d7daf90; });
parcelRequire("7UyMy");
var $79X3L = parcelRequire("79X3L");
function $c487fb929112518f$export$3dea766d36a8935f(test, node) {
    var recurse = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, limit = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Infinity;
    return $c487fb929112518f$export$71aa6c912b956294(test, Array.isArray(node) ? node : [
        node
    ], recurse, limit);
}
function $c487fb929112518f$export$71aa6c912b956294(test, nodes, recurse, limit) {
    var result = [];
    /** Stack of the arrays we are looking at. */ var nodeStack = [
        nodes
    ];
    /** Stack of the indices within the arrays. */ var indexStack = [
        0
    ];
    for(;;){
        // First, check if the current array has any more elements to look at.
        if (indexStack[0] >= nodeStack[0].length) {
            // If we have no more arrays to look at, we are done.
            if (indexStack.length === 1) return result;
            // Otherwise, remove the current array from the stack.
            nodeStack.shift();
            indexStack.shift();
            continue;
        }
        var elem = nodeStack[0][indexStack[0]++];
        if (test(elem)) {
            result.push(elem);
            if (--limit <= 0) return result;
        }
        if (recurse && (0, $79X3L.hasChildren)(elem) && elem.children.length > 0) {
            /*
             * Add the children to the stack. We are depth-first, so this is
             * the next array we look at.
             */ indexStack.unshift(0);
            nodeStack.unshift(elem.children);
        }
    }
}
function $c487fb929112518f$export$ac03a862904ce329(test, nodes) {
    return nodes.find(test);
}
function $c487fb929112518f$export$a541876d5d7daf90(test, nodes) {
    var recurse = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    var elem = null;
    for(var i = 0; i < nodes.length && !elem; i++){
        var node = nodes[i];
        if (!(0, $79X3L.isTag)(node)) continue;
        else if (test(node)) elem = node;
        else if (recurse && node.children.length > 0) elem = $c487fb929112518f$export$a541876d5d7daf90(test, node.children, true);
    }
    return elem;
}
function $c487fb929112518f$export$9d99dce58ac4a31b(test, nodes) {
    return nodes.some(function(checked) {
        return (0, $79X3L.isTag)(checked) && (test(checked) || $c487fb929112518f$export$9d99dce58ac4a31b(test, checked.children));
    });
}
function $c487fb929112518f$export$18200ea6c8035394(test, nodes) {
    var result = [];
    var nodeStack = [
        nodes
    ];
    var indexStack = [
        0
    ];
    for(;;){
        if (indexStack[0] >= nodeStack[0].length) {
            if (nodeStack.length === 1) return result;
            // Otherwise, remove the current array from the stack.
            nodeStack.shift();
            indexStack.shift();
            continue;
        }
        var elem = nodeStack[0][indexStack[0]++];
        if (!(0, $79X3L.isTag)(elem)) continue;
        if (test(elem)) result.push(elem);
        if (elem.children.length > 0) {
            indexStack.unshift(0);
            nodeStack.unshift(elem.children);
        }
    }
}

});

parcelRegister("jN9Ry", function(module, exports) {

$parcel$export(module.exports, "getElementsByTagName", function () { return $e68a3e77a12cf7a0$export$af941c3c7c3b40f5; });
parcelRequire("7UyMy");
var $79X3L = parcelRequire("79X3L");

var $gS874 = parcelRequire("gS874");
/**
 * A map of functions to check nodes against.
 */ var $e68a3e77a12cf7a0$var$Checks = {
    tag_name: function(name) {
        if (typeof name === "function") return function(elem) {
            return (0, $79X3L.isTag)(elem) && name(elem.name);
        };
        else if (name === "*") return 0, $79X3L.isTag;
        return function(elem) {
            return (0, $79X3L.isTag)(elem) && elem.name === name;
        };
    },
    tag_type: function(type) {
        if (typeof type === "function") return function(elem) {
            return type(elem.type);
        };
        return function(elem) {
            return elem.type === type;
        };
    },
    tag_contains: function(data) {
        if (typeof data === "function") return function(elem) {
            return (0, $79X3L.isText)(elem) && data(elem.data);
        };
        return function(elem) {
            return (0, $79X3L.isText)(elem) && elem.data === data;
        };
    }
};
/**
 * Returns a function to check whether a node has an attribute with a particular
 * value.
 *
 * @param attrib Attribute to check.
 * @param value Attribute value to look for.
 * @returns A function to check whether the a node has an attribute with a
 *   particular value.
 */ function $e68a3e77a12cf7a0$var$getAttribCheck(attrib, value) {
    if (typeof value === "function") return function(elem) {
        return (0, $79X3L.isTag)(elem) && value(elem.attribs[attrib]);
    };
    return function(elem) {
        return (0, $79X3L.isTag)(elem) && elem.attribs[attrib] === value;
    };
}
/**
 * Returns a function that returns `true` if either of the input functions
 * returns `true` for a node.
 *
 * @param a First function to combine.
 * @param b Second function to combine.
 * @returns A function taking a node and returning `true` if either of the input
 *   functions returns `true` for the node.
 */ function $e68a3e77a12cf7a0$var$combineFuncs(a, b) {
    return function(elem) {
        return a(elem) || b(elem);
    };
}
/**
 * Returns a function that executes all checks in `options` and returns `true`
 * if any of them match a node.
 *
 * @param options An object describing nodes to look for.
 * @returns A function that executes all checks in `options` and returns `true`
 *   if any of them match a node.
 */ function $e68a3e77a12cf7a0$var$compileTest(options) {
    var funcs = Object.keys(options).map(function(key) {
        var value = options[key];
        return Object.prototype.hasOwnProperty.call($e68a3e77a12cf7a0$var$Checks, key) ? $e68a3e77a12cf7a0$var$Checks[key](value) : $e68a3e77a12cf7a0$var$getAttribCheck(key, value);
    });
    return funcs.length === 0 ? null : funcs.reduce($e68a3e77a12cf7a0$var$combineFuncs);
}
function $e68a3e77a12cf7a0$export$7b31db6b5a0b2f32(options, node) {
    var test = $e68a3e77a12cf7a0$var$compileTest(options);
    return test ? test(node) : true;
}
function $e68a3e77a12cf7a0$export$73eac51a39d6b0eb(options, nodes, recurse) {
    var limit = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Infinity;
    var test = $e68a3e77a12cf7a0$var$compileTest(options);
    return test ? (0, $gS874.filter)(test, nodes, recurse, limit) : [];
}
function $e68a3e77a12cf7a0$export$83595b84fc78b9b4(id, nodes) {
    var recurse = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (!Array.isArray(nodes)) nodes = [
        nodes
    ];
    return (0, $gS874.findOne)($e68a3e77a12cf7a0$var$getAttribCheck("id", id), nodes, recurse);
}
function $e68a3e77a12cf7a0$export$af941c3c7c3b40f5(tagName, nodes) {
    var recurse = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, limit = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Infinity;
    return (0, $gS874.filter)($e68a3e77a12cf7a0$var$Checks["tag_name"](tagName), nodes, recurse, limit);
}
function $e68a3e77a12cf7a0$export$f5d981e30be5545b(type, nodes) {
    var recurse = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, limit = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Infinity;
    return (0, $gS874.filter)($e68a3e77a12cf7a0$var$Checks["tag_type"](type), nodes, recurse, limit);
}

});

parcelRegister("1IrSv", function(module, exports) {
parcelRequire("7UyMy");
var $79X3L = parcelRequire("79X3L");
function $13ff868b7da3b80b$export$171dc294232ebeef(nodes) {
    var idx = nodes.length;
    /*
     * Check if each node (or one of its ancestors) is already contained in the
     * array.
     */ while(--idx >= 0){
        var node = nodes[idx];
        /*
         * Remove the node if it is not unique.
         * We are going through the array from the end, so we only
         * have to check nodes that preceed the node under consideration in the array.
         */ if (idx > 0 && nodes.lastIndexOf(node, idx - 1) >= 0) {
            nodes.splice(idx, 1);
            continue;
        }
        for(var ancestor = node.parent; ancestor; ancestor = ancestor.parent)if (nodes.includes(ancestor)) {
            nodes.splice(idx, 1);
            break;
        }
    }
    return nodes;
}
var $13ff868b7da3b80b$export$406a59d989e8005a;
(function(DocumentPosition) {
    DocumentPosition[DocumentPosition["DISCONNECTED"] = 1] = "DISCONNECTED";
    DocumentPosition[DocumentPosition["PRECEDING"] = 2] = "PRECEDING";
    DocumentPosition[DocumentPosition["FOLLOWING"] = 4] = "FOLLOWING";
    DocumentPosition[DocumentPosition["CONTAINS"] = 8] = "CONTAINS";
    DocumentPosition[DocumentPosition["CONTAINED_BY"] = 16] = "CONTAINED_BY";
})($13ff868b7da3b80b$export$406a59d989e8005a || ($13ff868b7da3b80b$export$406a59d989e8005a = {}));
function $13ff868b7da3b80b$export$17303b8fea718ecc(nodeA, nodeB) {
    var aParents = [];
    var bParents = [];
    if (nodeA === nodeB) return 0;
    var current = (0, $79X3L.hasChildren)(nodeA) ? nodeA : nodeA.parent;
    while(current){
        aParents.unshift(current);
        current = current.parent;
    }
    current = (0, $79X3L.hasChildren)(nodeB) ? nodeB : nodeB.parent;
    while(current){
        bParents.unshift(current);
        current = current.parent;
    }
    var maxIdx = Math.min(aParents.length, bParents.length);
    var idx = 0;
    while(idx < maxIdx && aParents[idx] === bParents[idx])idx++;
    if (idx === 0) return $13ff868b7da3b80b$export$406a59d989e8005a.DISCONNECTED;
    var sharedParent = aParents[idx - 1];
    var siblings = sharedParent.children;
    var aSibling = aParents[idx];
    var bSibling = bParents[idx];
    if (siblings.indexOf(aSibling) > siblings.indexOf(bSibling)) {
        if (sharedParent === nodeB) return $13ff868b7da3b80b$export$406a59d989e8005a.FOLLOWING | $13ff868b7da3b80b$export$406a59d989e8005a.CONTAINED_BY;
        return $13ff868b7da3b80b$export$406a59d989e8005a.FOLLOWING;
    }
    if (sharedParent === nodeA) return $13ff868b7da3b80b$export$406a59d989e8005a.PRECEDING | $13ff868b7da3b80b$export$406a59d989e8005a.CONTAINS;
    return $13ff868b7da3b80b$export$406a59d989e8005a.PRECEDING;
}
function $13ff868b7da3b80b$export$1c267319665a7e7e(nodes) {
    nodes = nodes.filter(function(node, i, arr) {
        return !arr.includes(node, i + 1);
    });
    nodes.sort(function(a, b) {
        var relative = $13ff868b7da3b80b$export$17303b8fea718ecc(a, b);
        if (relative & $13ff868b7da3b80b$export$406a59d989e8005a.PRECEDING) return -1;
        else if (relative & $13ff868b7da3b80b$export$406a59d989e8005a.FOLLOWING) return 1;
        return 0;
    });
    return nodes;
}

});

parcelRegister("bmgv1", function(module, exports) {

$parcel$export(module.exports, "getFeed", function () { return $844e8c3a34be1cce$export$ad32138c9e09ad4; });

var $8sIsY = parcelRequire("8sIsY");

var $jN9Ry = parcelRequire("jN9Ry");
function $844e8c3a34be1cce$export$ad32138c9e09ad4(doc) {
    var feedRoot = $844e8c3a34be1cce$var$getOneElement($844e8c3a34be1cce$var$isValidFeed, doc);
    return !feedRoot ? null : feedRoot.name === "feed" ? $844e8c3a34be1cce$var$getAtomFeed(feedRoot) : $844e8c3a34be1cce$var$getRssFeed(feedRoot);
}
/**
 * Parse an Atom feed.
 *
 * @param feedRoot The root of the feed.
 * @returns The parsed feed.
 */ function $844e8c3a34be1cce$var$getAtomFeed(feedRoot) {
    var _a;
    var childs = feedRoot.children;
    var feed = {
        type: "atom",
        items: (0, $jN9Ry.getElementsByTagName)("entry", childs).map(function(item) {
            var _a;
            var children = item.children;
            var entry = {
                media: $844e8c3a34be1cce$var$getMediaElements(children)
            };
            $844e8c3a34be1cce$var$addConditionally(entry, "id", "id", children);
            $844e8c3a34be1cce$var$addConditionally(entry, "title", "title", children);
            var href = (_a = $844e8c3a34be1cce$var$getOneElement("link", children)) === null || _a === void 0 ? void 0 : _a.attribs["href"];
            if (href) entry.link = href;
            var description = $844e8c3a34be1cce$var$fetch("summary", children) || $844e8c3a34be1cce$var$fetch("content", children);
            if (description) entry.description = description;
            var pubDate = $844e8c3a34be1cce$var$fetch("updated", children);
            if (pubDate) entry.pubDate = new Date(pubDate);
            return entry;
        })
    };
    $844e8c3a34be1cce$var$addConditionally(feed, "id", "id", childs);
    $844e8c3a34be1cce$var$addConditionally(feed, "title", "title", childs);
    var href = (_a = $844e8c3a34be1cce$var$getOneElement("link", childs)) === null || _a === void 0 ? void 0 : _a.attribs["href"];
    if (href) feed.link = href;
    $844e8c3a34be1cce$var$addConditionally(feed, "description", "subtitle", childs);
    var updated = $844e8c3a34be1cce$var$fetch("updated", childs);
    if (updated) feed.updated = new Date(updated);
    $844e8c3a34be1cce$var$addConditionally(feed, "author", "email", childs, true);
    return feed;
}
/**
 * Parse a RSS feed.
 *
 * @param feedRoot The root of the feed.
 * @returns The parsed feed.
 */ function $844e8c3a34be1cce$var$getRssFeed(feedRoot) {
    var _a, _b;
    var childs = (_b = (_a = $844e8c3a34be1cce$var$getOneElement("channel", feedRoot.children)) === null || _a === void 0 ? void 0 : _a.children) !== null && _b !== void 0 ? _b : [];
    var feed = {
        type: feedRoot.name.substr(0, 3),
        id: "",
        items: (0, $jN9Ry.getElementsByTagName)("item", feedRoot.children).map(function(item) {
            var children = item.children;
            var entry = {
                media: $844e8c3a34be1cce$var$getMediaElements(children)
            };
            $844e8c3a34be1cce$var$addConditionally(entry, "id", "guid", children);
            $844e8c3a34be1cce$var$addConditionally(entry, "title", "title", children);
            $844e8c3a34be1cce$var$addConditionally(entry, "link", "link", children);
            $844e8c3a34be1cce$var$addConditionally(entry, "description", "description", children);
            var pubDate = $844e8c3a34be1cce$var$fetch("pubDate", children) || $844e8c3a34be1cce$var$fetch("dc:date", children);
            if (pubDate) entry.pubDate = new Date(pubDate);
            return entry;
        })
    };
    $844e8c3a34be1cce$var$addConditionally(feed, "title", "title", childs);
    $844e8c3a34be1cce$var$addConditionally(feed, "link", "link", childs);
    $844e8c3a34be1cce$var$addConditionally(feed, "description", "description", childs);
    var updated = $844e8c3a34be1cce$var$fetch("lastBuildDate", childs);
    if (updated) feed.updated = new Date(updated);
    $844e8c3a34be1cce$var$addConditionally(feed, "author", "managingEditor", childs, true);
    return feed;
}
var $844e8c3a34be1cce$var$MEDIA_KEYS_STRING = [
    "url",
    "type",
    "lang"
];
var $844e8c3a34be1cce$var$MEDIA_KEYS_INT = [
    "fileSize",
    "bitrate",
    "framerate",
    "samplingrate",
    "channels",
    "duration",
    "height",
    "width"
];
/**
 * Get all media elements of a feed item.
 *
 * @param where Nodes to search in.
 * @returns Media elements.
 */ function $844e8c3a34be1cce$var$getMediaElements(where) {
    return (0, $jN9Ry.getElementsByTagName)("media:content", where).map(function(elem) {
        var attribs = elem.attribs;
        var media = {
            medium: attribs["medium"],
            isDefault: !!attribs["isDefault"]
        };
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = $844e8c3a34be1cce$var$MEDIA_KEYS_STRING[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var attrib = _step.value;
                if (attribs[attrib]) media[attrib] = attribs[attrib];
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = $844e8c3a34be1cce$var$MEDIA_KEYS_INT[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var attrib1 = _step1.value;
                if (attribs[attrib1]) media[attrib1] = parseInt(attribs[attrib1], 10);
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        if (attribs["expression"]) media.expression = attribs["expression"];
        return media;
    });
}
/**
 * Get one element by tag name.
 *
 * @param tagName Tag name to look for
 * @param node Node to search in
 * @returns The element or null
 */ function $844e8c3a34be1cce$var$getOneElement(tagName, node) {
    return (0, $jN9Ry.getElementsByTagName)(tagName, node, true, 1)[0];
}
/**
 * Get the text content of an element with a certain tag name.
 *
 * @param tagName Tag name to look for.
 * @param where Node to search in.
 * @param recurse Whether to recurse into child nodes.
 * @returns The text content of the element.
 */ function $844e8c3a34be1cce$var$fetch(tagName, where) {
    var recurse = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return (0, $8sIsY.textContent)((0, $jN9Ry.getElementsByTagName)(tagName, where, recurse, 1)).trim();
}
/**
 * Adds a property to an object if it has a value.
 *
 * @param obj Object to be extended
 * @param prop Property name
 * @param tagName Tag name that contains the conditionally added property
 * @param where Element to search for the property
 * @param recurse Whether to recurse into child nodes.
 */ function $844e8c3a34be1cce$var$addConditionally(obj, prop, tagName, where) {
    var recurse = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    var val = $844e8c3a34be1cce$var$fetch(tagName, where, recurse);
    if (val) obj[prop] = val;
}
/**
 * Checks if an element is a feed root node.
 *
 * @param value The name of the element to check.
 * @returns Whether an element is a feed root node.
 */ function $844e8c3a34be1cce$var$isValidFeed(value) {
    return value === "rss" || value === "feed" || value === "rdf:RDF";
}

});



parcelRegister("L9gTQ", function(module, exports) {
"use strict";
module.exports = function(string) {
    if (typeof string !== "string") throw new TypeError("Expected a string");
    // Escape characters with special meaning either inside or outside character sets.
    // Use a simple backslash escape when it’s always valid, and a \unnnn escape when the simpler form would be disallowed by Unicode patterns’ stricter grammar.
    return string.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
};

});

parcelRegister("6oFHO", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $0e14a88b65792511$export$53b83ca8eaab0383; });
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */ function $0e14a88b65792511$var$isObject(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $0e14a88b65792511$export$53b83ca8eaab0383(o) {
    var ctor, prot;
    if ($0e14a88b65792511$var$isObject(o) === false) return false;
    // If has modified constructor
    ctor = o.constructor;
    if (ctor === undefined) return true;
    // If has modified prototype
    prot = ctor.prototype;
    if ($0e14a88b65792511$var$isObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (prot.hasOwnProperty("isPrototypeOf") === false) return false;
    // Most likely a plain Object
    return true;
}

});

parcelRegister("19s4F", function(module, exports) {
"use strict";
var $0d6c68b1e1dd9753$var$isMergeableObject = function isMergeableObject(value) {
    return $0d6c68b1e1dd9753$var$isNonNullObject(value) && !$0d6c68b1e1dd9753$var$isSpecial(value);
};
function $0d6c68b1e1dd9753$var$isNonNullObject(value) {
    return !!value && typeof value === "object";
}
function $0d6c68b1e1dd9753$var$isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === "[object RegExp]" || stringValue === "[object Date]" || $0d6c68b1e1dd9753$var$isReactElement(value);
}
// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var $0d6c68b1e1dd9753$var$canUseSymbol = typeof Symbol === "function" && Symbol.for;
var $0d6c68b1e1dd9753$var$REACT_ELEMENT_TYPE = $0d6c68b1e1dd9753$var$canUseSymbol ? Symbol.for("react.element") : 0xeac7;
function $0d6c68b1e1dd9753$var$isReactElement(value) {
    return value.$$typeof === $0d6c68b1e1dd9753$var$REACT_ELEMENT_TYPE;
}
function $0d6c68b1e1dd9753$var$emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}
function $0d6c68b1e1dd9753$var$cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? $0d6c68b1e1dd9753$var$deepmerge($0d6c68b1e1dd9753$var$emptyTarget(value), value, options) : value;
}
function $0d6c68b1e1dd9753$var$defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element) {
        return $0d6c68b1e1dd9753$var$cloneUnlessOtherwiseSpecified(element, options);
    });
}
function $0d6c68b1e1dd9753$var$getMergeFunction(key, options) {
    if (!options.customMerge) return $0d6c68b1e1dd9753$var$deepmerge;
    var customMerge = options.customMerge(key);
    return typeof customMerge === "function" ? customMerge : $0d6c68b1e1dd9753$var$deepmerge;
}
function $0d6c68b1e1dd9753$var$getEnumerableOwnPropertySymbols(target) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function(symbol) {
        return Object.propertyIsEnumerable.call(target, symbol);
    }) : [];
}
function $0d6c68b1e1dd9753$var$getKeys(target) {
    return Object.keys(target).concat($0d6c68b1e1dd9753$var$getEnumerableOwnPropertySymbols(target));
}
function $0d6c68b1e1dd9753$var$propertyIsOnObject(object, property) {
    try {
        return property in object;
    } catch (_) {
        return false;
    }
}
// Protects from prototype poisoning and unexpected merging up the prototype chain.
function $0d6c68b1e1dd9753$var$propertyIsUnsafe(target, key) {
    return $0d6c68b1e1dd9753$var$propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
     && !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
     && Object.propertyIsEnumerable.call(target, key) // and also unsafe if they're nonenumerable.
    );
}
function $0d6c68b1e1dd9753$var$mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) $0d6c68b1e1dd9753$var$getKeys(target).forEach(function(key) {
        destination[key] = $0d6c68b1e1dd9753$var$cloneUnlessOtherwiseSpecified(target[key], options);
    });
    $0d6c68b1e1dd9753$var$getKeys(source).forEach(function(key) {
        if ($0d6c68b1e1dd9753$var$propertyIsUnsafe(target, key)) return;
        if ($0d6c68b1e1dd9753$var$propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) destination[key] = $0d6c68b1e1dd9753$var$getMergeFunction(key, options)(target[key], source[key], options);
        else destination[key] = $0d6c68b1e1dd9753$var$cloneUnlessOtherwiseSpecified(source[key], options);
    });
    return destination;
}
function $0d6c68b1e1dd9753$var$deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || $0d6c68b1e1dd9753$var$defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || $0d6c68b1e1dd9753$var$isMergeableObject;
    // cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
    // implementations can use it. The caller may not replace it.
    options.cloneUnlessOtherwiseSpecified = $0d6c68b1e1dd9753$var$cloneUnlessOtherwiseSpecified;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) return $0d6c68b1e1dd9753$var$cloneUnlessOtherwiseSpecified(source, options);
    else if (sourceIsArray) return options.arrayMerge(target, source, options);
    else return $0d6c68b1e1dd9753$var$mergeObject(target, source, options);
}
$0d6c68b1e1dd9753$var$deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) throw new Error("first argument should be an array");
    return array.reduce(function(prev, next) {
        return $0d6c68b1e1dd9753$var$deepmerge(prev, next, options);
    }, {});
};
var $0d6c68b1e1dd9753$var$deepmerge_1 = $0d6c68b1e1dd9753$var$deepmerge;
module.exports = $0d6c68b1e1dd9753$var$deepmerge_1;

});

parcelRegister("aktg7", function(module, exports) {
/**
 * Srcset Parser
 *
 * By Alex Bell |  MIT License
 *
 * JS Parser for the string value that appears in markup <img srcset="here">
 *
 * @returns Array [{url: _, d: _, w: _, h:_}, ...]
 *
 * Based super duper closely on the reference algorithm at:
 * https://html.spec.whatwg.org/multipage/embedded-content.html#parse-a-srcset-attribute
 *
 * Most comments are copied in directly from the spec
 * (except for comments in parens).
 */ (function(root, factory) {
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([], factory);
    else if (0, module.exports) // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
    else // Browser globals (root is window)
    root.parseSrcset = factory();
})(module.exports, function() {
    // 1. Let input be the value passed to this algorithm.
    return function(input) {
        // UTILITY FUNCTIONS
        // Manual is faster than RegEx
        // http://bjorn.tipling.com/state-and-regular-expressions-in-javascript
        // http://jsperf.com/whitespace-character/5
        function isSpace(c) {
            return c === " " || // space
            c === "	" || // horizontal tab
            c === "\n" || // new line
            c === "\f" || // form feed
            c === "\r"; // carriage return
        }
        function collectCharacters(regEx) {
            var chars, match = regEx.exec(input.substring(pos));
            if (match) {
                chars = match[0];
                pos += chars.length;
                return chars;
            }
        }
        var inputLength = input.length, // (Don't use \s, to avoid matching non-breaking space)
        regexLeadingSpaces = /^[ \t\n\r\u000c]+/, regexLeadingCommasOrSpaces = /^[, \t\n\r\u000c]+/, regexLeadingNotSpaces = /^[^ \t\n\r\u000c]+/, regexTrailingCommas = /[,]+$/, regexNonNegativeInteger = /^\d+$/, // ( Positive or negative or unsigned integers or decimals, without or without exponents.
        // Must include at least one digit.
        // According to spec tests any decimal point must be followed by a digit.
        // No leading plus sign is allowed.)
        // https://html.spec.whatwg.org/multipage/infrastructure.html#valid-floating-point-number
        regexFloatingPoint = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/, url, descriptors, currentDescriptor, state, c, // 2. Let position be a pointer into input, initially pointing at the start
        //    of the string.
        pos = 0, // 3. Let candidates be an initially empty source set.
        candidates = [];
        // 4. Splitting loop: Collect a sequence of characters that are space
        //    characters or U+002C COMMA characters. If any U+002C COMMA characters
        //    were collected, that is a parse error.
        while(true){
            collectCharacters(regexLeadingCommasOrSpaces);
            // 5. If position is past the end of input, return candidates and abort these steps.
            if (pos >= inputLength) return candidates; // (we're done, this is the sole return path)
            // 6. Collect a sequence of characters that are not space characters,
            //    and let that be url.
            url = collectCharacters(regexLeadingNotSpaces);
            // 7. Let descriptors be a new empty list.
            descriptors = [];
            // 8. If url ends with a U+002C COMMA character (,), follow these substeps:
            //		(1). Remove all trailing U+002C COMMA characters from url. If this removed
            //         more than one character, that is a parse error.
            if (url.slice(-1) === ",") {
                url = url.replace(regexTrailingCommas, "");
                // (Jump ahead to step 9 to skip tokenization and just push the candidate).
                parseDescriptors();
            //	Otherwise, follow these substeps:
            } else tokenize();
             // (close else of step 8)
        // 16. Return to the step labeled splitting loop.
        } // (Close of big while loop.)
        /**
		 * Tokenizes descriptor properties prior to parsing
		 * Returns undefined.
		 */ function tokenize() {
            // 8.1. Descriptor tokeniser: Skip whitespace
            collectCharacters(regexLeadingSpaces);
            // 8.2. Let current descriptor be the empty string.
            currentDescriptor = "";
            // 8.3. Let state be in descriptor.
            state = "in descriptor";
            while(true){
                // 8.4. Let c be the character at position.
                c = input.charAt(pos);
                //  Do the following depending on the value of state.
                //  For the purpose of this step, "EOF" is a special character representing
                //  that position is past the end of input.
                // In descriptor
                if (state === "in descriptor") {
                    // Do the following, depending on the value of c:
                    // Space character
                    // If current descriptor is not empty, append current descriptor to
                    // descriptors and let current descriptor be the empty string.
                    // Set state to after descriptor.
                    if (isSpace(c)) {
                        if (currentDescriptor) {
                            descriptors.push(currentDescriptor);
                            currentDescriptor = "";
                            state = "after descriptor";
                        }
                    } else if (c === ",") {
                        pos += 1;
                        if (currentDescriptor) descriptors.push(currentDescriptor);
                        parseDescriptors();
                        return;
                    // U+0028 LEFT PARENTHESIS (()
                    // Append c to current descriptor. Set state to in parens.
                    } else if (c === "(") {
                        currentDescriptor = currentDescriptor + c;
                        state = "in parens";
                    // EOF
                    // If current descriptor is not empty, append current descriptor to
                    // descriptors. Jump to the step labeled descriptor parser.
                    } else if (c === "") {
                        if (currentDescriptor) descriptors.push(currentDescriptor);
                        parseDescriptors();
                        return;
                    // Anything else
                    // Append c to current descriptor.
                    } else currentDescriptor = currentDescriptor + c;
                // (end "in descriptor"
                // In parens
                } else if (state === "in parens") {
                    // U+0029 RIGHT PARENTHESIS ())
                    // Append c to current descriptor. Set state to in descriptor.
                    if (c === ")") {
                        currentDescriptor = currentDescriptor + c;
                        state = "in descriptor";
                    // EOF
                    // Append current descriptor to descriptors. Jump to the step labeled
                    // descriptor parser.
                    } else if (c === "") {
                        descriptors.push(currentDescriptor);
                        parseDescriptors();
                        return;
                    // Anything else
                    // Append c to current descriptor.
                    } else currentDescriptor = currentDescriptor + c;
                // After descriptor
                } else if (state === "after descriptor") {
                    // Do the following, depending on the value of c:
                    // Space character: Stay in this state.
                    if (isSpace(c)) ;
                    else if (c === "") {
                        parseDescriptors();
                        return;
                    // Anything else
                    // Set state to in descriptor. Set position to the previous character in input.
                    } else {
                        state = "in descriptor";
                        pos -= 1;
                    }
                }
                // Advance position to the next character in input.
                pos += 1;
            // Repeat this step.
            } // (close while true loop)
        }
        /**
		 * Adds descriptor properties to a candidate, pushes to the candidates array
		 * @return undefined
		 */ // Declared outside of the while loop so that it's only created once.
        function parseDescriptors() {
            // 9. Descriptor parser: Let error be no.
            var pError = false, // 10. Let width be absent.
            // 11. Let density be absent.
            // 12. Let future-compat-h be absent. (We're implementing it now as h)
            w, d, h, i, candidate = {}, desc, lastChar, value, intVal, floatVal;
            // 13. For each descriptor in descriptors, run the appropriate set of steps
            // from the following list:
            for(i = 0; i < descriptors.length; i++){
                desc = descriptors[i];
                lastChar = desc[desc.length - 1];
                value = desc.substring(0, desc.length - 1);
                intVal = parseInt(value, 10);
                floatVal = parseFloat(value);
                // If the descriptor consists of a valid non-negative integer followed by
                // a U+0077 LATIN SMALL LETTER W character
                if (regexNonNegativeInteger.test(value) && lastChar === "w") {
                    // If width and density are not both absent, then let error be yes.
                    if (w || d) pError = true;
                    // Apply the rules for parsing non-negative integers to the descriptor.
                    // If the result is zero, let error be yes.
                    // Otherwise, let width be the result.
                    if (intVal === 0) pError = true;
                    else w = intVal;
                // If the descriptor consists of a valid floating-point number followed by
                // a U+0078 LATIN SMALL LETTER X character
                } else if (regexFloatingPoint.test(value) && lastChar === "x") {
                    // If width, density and future-compat-h are not all absent, then let error
                    // be yes.
                    if (w || d || h) pError = true;
                    // Apply the rules for parsing floating-point number values to the descriptor.
                    // If the result is less than zero, let error be yes. Otherwise, let density
                    // be the result.
                    if (floatVal < 0) pError = true;
                    else d = floatVal;
                // If the descriptor consists of a valid non-negative integer followed by
                // a U+0068 LATIN SMALL LETTER H character
                } else if (regexNonNegativeInteger.test(value) && lastChar === "h") {
                    // If height and density are not both absent, then let error be yes.
                    if (h || d) pError = true;
                    // Apply the rules for parsing non-negative integers to the descriptor.
                    // If the result is zero, let error be yes. Otherwise, let future-compat-h
                    // be the result.
                    if (intVal === 0) pError = true;
                    else h = intVal;
                // Anything else, Let error be yes.
                } else pError = true;
            } // (close step 13 for loop)
            // 15. If error is still no, then append a new image source to candidates whose
            // URL is url, associated with a width width if not absent and a pixel
            // density density if not absent. Otherwise, there is a parse error.
            if (!pError) {
                candidate.url = url;
                if (w) candidate.w = w;
                if (d) candidate.d = d;
                if (h) candidate.h = h;
                candidates.push(candidate);
            } else if (console && console.log) console.log("Invalid srcset descriptor found in '" + input + "' at '" + desc + "'.");
        } // (close parseDescriptors fn)
    };
});

});

parcelRegister("7DtM5", function(module, exports) {

var $c6Xmf = parcelRequire("c6Xmf");
"use strict";

var $8wjAu = parcelRequire("8wjAu");

var $03KO9 = parcelRequire("03KO9");

var $7Phwu = parcelRequire("7Phwu");

var $jF4Xc = parcelRequire("jF4Xc");

var $1yJt7 = parcelRequire("1yJt7");

var $iQcw1 = parcelRequire("iQcw1");

var $cTidF = parcelRequire("cTidF");

var $bgmOa = parcelRequire("bgmOa");

var $6Klzj = parcelRequire("6Klzj");

var $e4Itr = parcelRequire("e4Itr");

var $3dB8P = parcelRequire("3dB8P");

var $2crP5 = parcelRequire("2crP5");

var $8YvnY = parcelRequire("8YvnY");

var $2DaUH = parcelRequire("2DaUH");

var $lEiGF = parcelRequire("lEiGF");

var $3Mwbh = parcelRequire("3Mwbh");

var $24VdH = parcelRequire("24VdH");

var $by0jV = parcelRequire("by0jV");
function $58f34586f5e03d5b$var$postcss() {
    for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++){
        plugins[_key] = arguments[_key];
    }
    if (plugins.length === 1 && Array.isArray(plugins[0])) plugins = plugins[0];
    return new $1yJt7(plugins);
}
$58f34586f5e03d5b$var$postcss.plugin = function plugin(name, initializer) {
    var warningPrinted = false;
    function creator() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        // eslint-disable-next-line no-console
        if (console && console.warn && !warningPrinted) {
            warningPrinted = true;
            // eslint-disable-next-line no-console
            console.warn(name + ": postcss.plugin was deprecated. Migration guide:\n" + "https://evilmartians.com/chronicles/postcss-8-plugin-migration");
        }
        var transformer = initializer.apply(void 0, (0, $c6Xmf._)(args));
        transformer.postcssPlugin = name;
        transformer.postcssVersion = new $1yJt7().version;
        return transformer;
    }
    var cache;
    Object.defineProperty(creator, "postcss", {
        get: function() {
            if (!cache) cache = creator();
            return cache;
        }
    });
    creator.process = function(css, processOpts, pluginOpts) {
        return $58f34586f5e03d5b$var$postcss([
            creator(pluginOpts)
        ]).process(css, processOpts);
    };
    return creator;
};
$58f34586f5e03d5b$var$postcss.stringify = $iQcw1;
$58f34586f5e03d5b$var$postcss.parse = $2DaUH;
$58f34586f5e03d5b$var$postcss.fromJSON = $cTidF;
$58f34586f5e03d5b$var$postcss.list = $lEiGF;
$58f34586f5e03d5b$var$postcss.comment = function(defaults) {
    return new $e4Itr(defaults);
};
$58f34586f5e03d5b$var$postcss.atRule = function(defaults) {
    return new $3dB8P(defaults);
};
$58f34586f5e03d5b$var$postcss.decl = function(defaults) {
    return new $03KO9(defaults);
};
$58f34586f5e03d5b$var$postcss.rule = function(defaults) {
    return new $3Mwbh(defaults);
};
$58f34586f5e03d5b$var$postcss.root = function(defaults) {
    return new $24VdH(defaults);
};
$58f34586f5e03d5b$var$postcss.document = function(defaults) {
    return new $bgmOa(defaults);
};
$58f34586f5e03d5b$var$postcss.CssSyntaxError = $8wjAu;
$58f34586f5e03d5b$var$postcss.Declaration = $03KO9;
$58f34586f5e03d5b$var$postcss.Container = $jF4Xc;
$58f34586f5e03d5b$var$postcss.Processor = $1yJt7;
$58f34586f5e03d5b$var$postcss.Document = $bgmOa;
$58f34586f5e03d5b$var$postcss.Comment = $e4Itr;
$58f34586f5e03d5b$var$postcss.Warning = $6Klzj;
$58f34586f5e03d5b$var$postcss.AtRule = $3dB8P;
$58f34586f5e03d5b$var$postcss.Result = $2crP5;
$58f34586f5e03d5b$var$postcss.Input = $8YvnY;
$58f34586f5e03d5b$var$postcss.Rule = $3Mwbh;
$58f34586f5e03d5b$var$postcss.Root = $24VdH;
$58f34586f5e03d5b$var$postcss.Node = $by0jV;
$7Phwu.registerPostcss($58f34586f5e03d5b$var$postcss);
module.exports = $58f34586f5e03d5b$var$postcss;
$58f34586f5e03d5b$var$postcss.default = $58f34586f5e03d5b$var$postcss;

});
parcelRegister("8wjAu", function(module, exports) {

var $d3H5E = parcelRequire("d3H5E");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $FuVm8 = parcelRequire("FuVm8");

var $ohfOJ = parcelRequire("ohfOJ");
"use strict";

var $92Vbp = parcelRequire("92Vbp");

var $9dH9K = parcelRequire("9dH9K");
var $63408192c2f39bcb$var$CssSyntaxError = /*#__PURE__*/ function(Error1) {
    (0, $dcsZi._)(CssSyntaxError, Error1);
    var _super = (0, $ohfOJ._)(CssSyntaxError);
    function CssSyntaxError(message, line, column, source, file, plugin) {
        (0, $4GJKx._)(this, CssSyntaxError);
        var _this;
        _this = _super.call(this, message);
        _this.name = "CssSyntaxError";
        _this.reason = message;
        if (file) _this.file = file;
        if (source) _this.source = source;
        if (plugin) _this.plugin = plugin;
        if (typeof line !== "undefined" && typeof column !== "undefined") {
            if (typeof line === "number") {
                _this.line = line;
                _this.column = column;
            } else {
                _this.line = line.line;
                _this.column = line.column;
                _this.endLine = column.line;
                _this.endColumn = column.column;
            }
        }
        _this.setMessage();
        if (Error.captureStackTrace) Error.captureStackTrace((0, $d3H5E._)(_this), CssSyntaxError);
        return _this;
    }
    (0, $1wc17._)(CssSyntaxError, [
        {
            key: "setMessage",
            value: function setMessage() {
                this.message = this.plugin ? this.plugin + ": " : "";
                this.message += this.file ? this.file : "<css input>";
                if (typeof this.line !== "undefined") this.message += ":" + this.line + ":" + this.column;
                this.message += ": " + this.reason;
            }
        },
        {
            key: "showSourceCode",
            value: function showSourceCode(color) {
                var _this = this;
                if (!this.source) return "";
                var css = this.source;
                if (color == null) color = $92Vbp.isColorSupported;
                if ($9dH9K) {
                    if (color) css = $9dH9K(css);
                }
                var lines = css.split(/\r?\n/);
                var start = Math.max(this.line - 3, 0);
                var end = Math.min(this.line + 2, lines.length);
                var maxWidth = String(end).length;
                var mark, aside;
                if (color) {
                    var _pico_createColors = $92Vbp.createColors(true), bold = _pico_createColors.bold, gray = _pico_createColors.gray, red = _pico_createColors.red;
                    mark = function(text) {
                        return bold(red(text));
                    };
                    aside = function(text) {
                        return gray(text);
                    };
                } else mark = aside = function(str) {
                    return str;
                };
                return lines.slice(start, end).map(function(line, index) {
                    var number = start + 1 + index;
                    var gutter = " " + (" " + number).slice(-maxWidth) + " | ";
                    if (number === _this.line) {
                        var spacing = aside(gutter.replace(/\d/g, " ")) + line.slice(0, _this.column - 1).replace(/[^\t]/g, " ");
                        return mark(">") + aside(gutter) + line + "\n " + spacing + mark("^");
                    }
                    return " " + aside(gutter) + line;
                }).join("\n");
            }
        },
        {
            key: "toString",
            value: function toString() {
                var code = this.showSourceCode();
                if (code) code = "\n\n" + code + "\n";
                return this.name + ": " + this.message + code;
            }
        }
    ]);
    return CssSyntaxError;
}((0, $FuVm8._)(Error));
module.exports = $63408192c2f39bcb$var$CssSyntaxError;
$63408192c2f39bcb$var$CssSyntaxError.default = $63408192c2f39bcb$var$CssSyntaxError;

});
parcelRegister("92Vbp", function(module, exports) {
var $6960a84d86958e52$var$x = String;
var $6960a84d86958e52$var$create = function create() {
    return {
        isColorSupported: false,
        reset: $6960a84d86958e52$var$x,
        bold: $6960a84d86958e52$var$x,
        dim: $6960a84d86958e52$var$x,
        italic: $6960a84d86958e52$var$x,
        underline: $6960a84d86958e52$var$x,
        inverse: $6960a84d86958e52$var$x,
        hidden: $6960a84d86958e52$var$x,
        strikethrough: $6960a84d86958e52$var$x,
        black: $6960a84d86958e52$var$x,
        red: $6960a84d86958e52$var$x,
        green: $6960a84d86958e52$var$x,
        yellow: $6960a84d86958e52$var$x,
        blue: $6960a84d86958e52$var$x,
        magenta: $6960a84d86958e52$var$x,
        cyan: $6960a84d86958e52$var$x,
        white: $6960a84d86958e52$var$x,
        gray: $6960a84d86958e52$var$x,
        bgBlack: $6960a84d86958e52$var$x,
        bgRed: $6960a84d86958e52$var$x,
        bgGreen: $6960a84d86958e52$var$x,
        bgYellow: $6960a84d86958e52$var$x,
        bgBlue: $6960a84d86958e52$var$x,
        bgMagenta: $6960a84d86958e52$var$x,
        bgCyan: $6960a84d86958e52$var$x,
        bgWhite: $6960a84d86958e52$var$x
    };
};
module.exports = $6960a84d86958e52$var$create();
module.exports.createColors = $6960a84d86958e52$var$create;

});


parcelRegister("03KO9", function(module, exports) {

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $FuVm8 = parcelRequire("FuVm8");

var $ohfOJ = parcelRequire("ohfOJ");
"use strict";

var $by0jV = parcelRequire("by0jV");
var $00b496fefdccb63c$var$Declaration = /*#__PURE__*/ function(Node) {
    (0, $dcsZi._)(Declaration, Node);
    var _super = (0, $ohfOJ._)(Declaration);
    function Declaration(defaults) {
        (0, $4GJKx._)(this, Declaration);
        var _this;
        if (defaults && typeof defaults.value !== "undefined" && typeof defaults.value !== "string") defaults = (0, $cxjpp._)((0, $do9pw._)({}, defaults), {
            value: String(defaults.value)
        });
        _this = _super.call(this, defaults);
        _this.type = "decl";
        return _this;
    }
    (0, $1wc17._)(Declaration, [
        {
            key: "variable",
            get: function get() {
                return this.prop.startsWith("--") || this.prop[0] === "$";
            }
        }
    ]);
    return Declaration;
}((0, $FuVm8._)($by0jV));
module.exports = $00b496fefdccb63c$var$Declaration;
$00b496fefdccb63c$var$Declaration.default = $00b496fefdccb63c$var$Declaration;

});
parcelRegister("by0jV", function(module, exports) {

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $c6Xmf = parcelRequire("c6Xmf");

var $l0HdX = parcelRequire("l0HdX");
"use strict";

var $8nXrl = parcelRequire("8nXrl");
var $86831e4ebf5c8af2$var$isClean = $8nXrl.isClean, $86831e4ebf5c8af2$var$my = $8nXrl.my;

var $8wjAu = parcelRequire("8wjAu");

var $4Ouxf = parcelRequire("4Ouxf");

var $iQcw1 = parcelRequire("iQcw1");
function $86831e4ebf5c8af2$var$cloneNode(obj, parent) {
    var cloned = new obj.constructor();
    for(var i in obj){
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        if (i === "proxyCache") continue;
        var value = obj[i];
        var type = typeof value === "undefined" ? "undefined" : (0, $l0HdX._)(value);
        if (i === "parent" && type === "object") {
            if (parent) cloned[i] = parent;
        } else if (i === "source") cloned[i] = value;
        else if (Array.isArray(value)) cloned[i] = value.map(function(j) {
            return $86831e4ebf5c8af2$var$cloneNode(j, cloned);
        });
        else {
            if (type === "object" && value !== null) value = $86831e4ebf5c8af2$var$cloneNode(value);
            cloned[i] = value;
        }
    }
    return cloned;
}
var $86831e4ebf5c8af2$var$Node = /*#__PURE__*/ function() {
    function Node() {
        var defaults = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, $4GJKx._)(this, Node);
        this.raws = {};
        this[$86831e4ebf5c8af2$var$isClean] = false;
        this[$86831e4ebf5c8af2$var$my] = true;
        for(var name in defaults)if (name === "nodes") {
            this.nodes = [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = defaults[name][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var node = _step.value;
                    if (typeof node.clone === "function") this.append(node.clone());
                    else this.append(node);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        } else this[name] = defaults[name];
    }
    (0, $1wc17._)(Node, [
        {
            key: "addToError",
            value: function addToError(error) {
                error.postcssNode = this;
                if (error.stack && this.source && /\n\s{4}at /.test(error.stack)) {
                    var s = this.source;
                    error.stack = error.stack.replace(/\n\s{4}at /, "$&".concat(s.input.from, ":").concat(s.start.line, ":").concat(s.start.column, "$&"));
                }
                return error;
            }
        },
        {
            key: "after",
            value: function after(add) {
                this.parent.insertAfter(this, add);
                return this;
            }
        },
        {
            key: "assign",
            value: function assign() {
                var overrides = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                for(var name in overrides)this[name] = overrides[name];
                return this;
            }
        },
        {
            key: "before",
            value: function before(add) {
                this.parent.insertBefore(this, add);
                return this;
            }
        },
        {
            key: "cleanRaws",
            value: function cleanRaws(keepBetween) {
                delete this.raws.before;
                delete this.raws.after;
                if (!keepBetween) delete this.raws.between;
            }
        },
        {
            key: "clone",
            value: function clone() {
                var overrides = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var cloned = $86831e4ebf5c8af2$var$cloneNode(this);
                for(var name in overrides)cloned[name] = overrides[name];
                return cloned;
            }
        },
        {
            key: "cloneAfter",
            value: function cloneAfter() {
                var overrides = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var cloned = this.clone(overrides);
                this.parent.insertAfter(this, cloned);
                return cloned;
            }
        },
        {
            key: "cloneBefore",
            value: function cloneBefore() {
                var overrides = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var cloned = this.clone(overrides);
                this.parent.insertBefore(this, cloned);
                return cloned;
            }
        },
        {
            key: "error",
            value: function error(message) {
                var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                if (this.source) {
                    var _this_rangeBy = this.rangeBy(opts), end = _this_rangeBy.end, start = _this_rangeBy.start;
                    return this.source.input.error(message, {
                        column: start.column,
                        line: start.line
                    }, {
                        column: end.column,
                        line: end.line
                    }, opts);
                }
                return new $8wjAu(message);
            }
        },
        {
            key: "getProxyProcessor",
            value: function getProxyProcessor() {
                return {
                    get: function(node, prop) {
                        if (prop === "proxyOf") return node;
                        else if (prop === "root") return function() {
                            return node.root().toProxy();
                        };
                        else return node[prop];
                    },
                    set: function(node, prop, value) {
                        if (node[prop] === value) return true;
                        node[prop] = value;
                        if (prop === "prop" || prop === "value" || prop === "name" || prop === "params" || prop === "important" || /* c8 ignore next */ prop === "text") node.markDirty();
                        return true;
                    }
                };
            }
        },
        {
            key: "markDirty",
            value: function markDirty() {
                if (this[$86831e4ebf5c8af2$var$isClean]) {
                    this[$86831e4ebf5c8af2$var$isClean] = false;
                    var next = this;
                    while(next = next.parent)next[$86831e4ebf5c8af2$var$isClean] = false;
                }
            }
        },
        {
            key: "next",
            value: function next() {
                if (!this.parent) return undefined;
                var index = this.parent.index(this);
                return this.parent.nodes[index + 1];
            }
        },
        {
            key: "positionBy",
            value: function positionBy(opts, stringRepresentation) {
                var pos = this.source.start;
                if (opts.index) pos = this.positionInside(opts.index, stringRepresentation);
                else if (opts.word) {
                    stringRepresentation = this.toString();
                    var index = stringRepresentation.indexOf(opts.word);
                    if (index !== -1) pos = this.positionInside(index, stringRepresentation);
                }
                return pos;
            }
        },
        {
            key: "positionInside",
            value: function positionInside(index, stringRepresentation) {
                var string = stringRepresentation || this.toString();
                var column = this.source.start.column;
                var line = this.source.start.line;
                for(var i = 0; i < index; i++)if (string[i] === "\n") {
                    column = 1;
                    line += 1;
                } else column += 1;
                return {
                    column: column,
                    line: line
                };
            }
        },
        {
            key: "prev",
            value: function prev() {
                if (!this.parent) return undefined;
                var index = this.parent.index(this);
                return this.parent.nodes[index - 1];
            }
        },
        {
            key: "rangeBy",
            value: function rangeBy(opts) {
                var start = {
                    column: this.source.start.column,
                    line: this.source.start.line
                };
                var end = this.source.end ? {
                    column: this.source.end.column + 1,
                    line: this.source.end.line
                } : {
                    column: start.column + 1,
                    line: start.line
                };
                if (opts.word) {
                    var stringRepresentation = this.toString();
                    var index = stringRepresentation.indexOf(opts.word);
                    if (index !== -1) {
                        start = this.positionInside(index, stringRepresentation);
                        end = this.positionInside(index + opts.word.length, stringRepresentation);
                    }
                } else {
                    if (opts.start) start = {
                        column: opts.start.column,
                        line: opts.start.line
                    };
                    else if (opts.index) start = this.positionInside(opts.index);
                    if (opts.end) end = {
                        column: opts.end.column,
                        line: opts.end.line
                    };
                    else if (opts.endIndex) end = this.positionInside(opts.endIndex);
                    else if (opts.index) end = this.positionInside(opts.index + 1);
                }
                if (end.line < start.line || end.line === start.line && end.column <= start.column) end = {
                    column: start.column + 1,
                    line: start.line
                };
                return {
                    end: end,
                    start: start
                };
            }
        },
        {
            key: "raw",
            value: function raw(prop, defaultType) {
                var str = new $4Ouxf();
                return str.raw(this, prop, defaultType);
            }
        },
        {
            key: "remove",
            value: function remove() {
                if (this.parent) this.parent.removeChild(this);
                this.parent = undefined;
                return this;
            }
        },
        {
            key: "replaceWith",
            value: function replaceWith() {
                for(var _len = arguments.length, nodes = new Array(_len), _key = 0; _key < _len; _key++){
                    nodes[_key] = arguments[_key];
                }
                if (this.parent) {
                    var bookmark = this;
                    var foundSelf = false;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var node = _step.value;
                            if (node === this) foundSelf = true;
                            else if (foundSelf) {
                                this.parent.insertAfter(bookmark, node);
                                bookmark = node;
                            } else this.parent.insertBefore(bookmark, node);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    if (!foundSelf) this.remove();
                }
                return this;
            }
        },
        {
            key: "root",
            value: function root() {
                var result = this;
                while(result.parent && result.parent.type !== "document")result = result.parent;
                return result;
            }
        },
        {
            key: "toJSON",
            value: function toJSON(_, inputs) {
                var fixed = {};
                var emitInputs = inputs == null;
                inputs = inputs || new Map();
                var inputsNextIndex = 0;
                for(var name in this){
                    if (!Object.prototype.hasOwnProperty.call(this, name)) continue;
                    if (name === "parent" || name === "proxyCache") continue;
                    var value = this[name];
                    if (Array.isArray(value)) fixed[name] = value.map(function(i) {
                        if (typeof i === "object" && i.toJSON) return i.toJSON(null, inputs);
                        else return i;
                    });
                    else if (typeof value === "object" && value.toJSON) fixed[name] = value.toJSON(null, inputs);
                    else if (name === "source") {
                        var inputId = inputs.get(value.input);
                        if (inputId == null) {
                            inputId = inputsNextIndex;
                            inputs.set(value.input, inputsNextIndex);
                            inputsNextIndex++;
                        }
                        fixed[name] = {
                            end: value.end,
                            inputId: inputId,
                            start: value.start
                        };
                    } else fixed[name] = value;
                }
                if (emitInputs) fixed.inputs = (0, $c6Xmf._)(inputs.keys()).map(function(input) {
                    return input.toJSON();
                });
                return fixed;
            }
        },
        {
            key: "toProxy",
            value: function toProxy() {
                if (!this.proxyCache) this.proxyCache = new Proxy(this, this.getProxyProcessor());
                return this.proxyCache;
            }
        },
        {
            key: "toString",
            value: function toString() {
                var stringifier = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $iQcw1;
                if (stringifier.stringify) stringifier = stringifier.stringify;
                var result = "";
                stringifier(this, function(i) {
                    result += i;
                });
                return result;
            }
        },
        {
            key: "warn",
            value: function warn(result, text, opts) {
                var data = {
                    node: this
                };
                for(var i in opts)data[i] = opts[i];
                return result.warn(text, data);
            }
        },
        {
            key: "proxyOf",
            get: function get() {
                return this;
            }
        }
    ]);
    return Node;
}();
module.exports = $86831e4ebf5c8af2$var$Node;
$86831e4ebf5c8af2$var$Node.default = $86831e4ebf5c8af2$var$Node;

});
parcelRegister("8nXrl", function(module, exports) {

$parcel$export(module.exports, "isClean", function () { return $61ae944145b685ee$export$ae5e7911ce0728f9; }, function (v) { return $61ae944145b685ee$export$ae5e7911ce0728f9 = v; });
$parcel$export(module.exports, "my", function () { return $61ae944145b685ee$export$94fa0a6beb22f989; }, function (v) { return $61ae944145b685ee$export$94fa0a6beb22f989 = v; });
var $61ae944145b685ee$export$ae5e7911ce0728f9;
var $61ae944145b685ee$export$94fa0a6beb22f989;
"use strict";
$61ae944145b685ee$export$ae5e7911ce0728f9 = Symbol("isClean");
$61ae944145b685ee$export$94fa0a6beb22f989 = Symbol("my");

});

parcelRegister("4Ouxf", function(module, exports) {

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");
"use strict";
var $3813849af5116a0f$var$DEFAULT_RAW = {
    after: "\n",
    beforeClose: "\n",
    beforeComment: "\n",
    beforeDecl: "\n",
    beforeOpen: " ",
    beforeRule: "\n",
    colon: ": ",
    commentLeft: " ",
    commentRight: " ",
    emptyBody: "",
    indent: "    ",
    semicolon: false
};
function $3813849af5116a0f$var$capitalize(str) {
    return str[0].toUpperCase() + str.slice(1);
}
var $3813849af5116a0f$var$Stringifier = /*#__PURE__*/ function() {
    function Stringifier(builder) {
        (0, $4GJKx._)(this, Stringifier);
        this.builder = builder;
    }
    (0, $1wc17._)(Stringifier, [
        {
            key: "atrule",
            value: function atrule(node, semicolon) {
                var name = "@" + node.name;
                var params = node.params ? this.rawValue(node, "params") : "";
                if (typeof node.raws.afterName !== "undefined") name += node.raws.afterName;
                else if (params) name += " ";
                if (node.nodes) this.block(node, name + params);
                else {
                    var end = (node.raws.between || "") + (semicolon ? ";" : "");
                    this.builder(name + params + end, node);
                }
            }
        },
        {
            key: "beforeAfter",
            value: function beforeAfter(node, detect) {
                var value;
                if (node.type === "decl") value = this.raw(node, null, "beforeDecl");
                else if (node.type === "comment") value = this.raw(node, null, "beforeComment");
                else if (detect === "before") value = this.raw(node, null, "beforeRule");
                else value = this.raw(node, null, "beforeClose");
                var buf = node.parent;
                var depth = 0;
                while(buf && buf.type !== "root"){
                    depth += 1;
                    buf = buf.parent;
                }
                if (value.includes("\n")) {
                    var indent = this.raw(node, null, "indent");
                    if (indent.length) for(var step = 0; step < depth; step++)value += indent;
                }
                return value;
            }
        },
        {
            key: "block",
            value: function block(node, start) {
                var between = this.raw(node, "between", "beforeOpen");
                this.builder(start + between + "{", node, "start");
                var after;
                if (node.nodes && node.nodes.length) {
                    this.body(node);
                    after = this.raw(node, "after");
                } else after = this.raw(node, "after", "emptyBody");
                if (after) this.builder(after);
                this.builder("}", node, "end");
            }
        },
        {
            key: "body",
            value: function body(node) {
                var last = node.nodes.length - 1;
                while(last > 0){
                    if (node.nodes[last].type !== "comment") break;
                    last -= 1;
                }
                var semicolon = this.raw(node, "semicolon");
                for(var i = 0; i < node.nodes.length; i++){
                    var child = node.nodes[i];
                    var before = this.raw(child, "before");
                    if (before) this.builder(before);
                    this.stringify(child, last !== i || semicolon);
                }
            }
        },
        {
            key: "comment",
            value: function comment(node) {
                var left = this.raw(node, "left", "commentLeft");
                var right = this.raw(node, "right", "commentRight");
                this.builder("/*" + left + node.text + right + "*/", node);
            }
        },
        {
            key: "decl",
            value: function decl(node, semicolon) {
                var between = this.raw(node, "between", "colon");
                var string = node.prop + between + this.rawValue(node, "value");
                if (node.important) string += node.raws.important || " !important";
                if (semicolon) string += ";";
                this.builder(string, node);
            }
        },
        {
            key: "document",
            value: function document(node) {
                this.body(node);
            }
        },
        {
            key: "raw",
            value: function raw(node, own, detect) {
                var value;
                if (!detect) detect = own;
                // Already had
                if (own) {
                    value = node.raws[own];
                    if (typeof value !== "undefined") return value;
                }
                var parent = node.parent;
                if (detect === "before") {
                    // Hack for first rule in CSS
                    if (!parent || parent.type === "root" && parent.first === node) return "";
                    // `root` nodes in `document` should use only their own raws
                    if (parent && parent.type === "document") return "";
                }
                // Floating child without parent
                if (!parent) return $3813849af5116a0f$var$DEFAULT_RAW[detect];
                // Detect style by other nodes
                var root = node.root();
                if (!root.rawCache) root.rawCache = {};
                if (typeof root.rawCache[detect] !== "undefined") return root.rawCache[detect];
                if (detect === "before" || detect === "after") return this.beforeAfter(node, detect);
                else {
                    var method = "raw" + $3813849af5116a0f$var$capitalize(detect);
                    if (this[method]) value = this[method](root, node);
                    else root.walk(function(i) {
                        value = i.raws[own];
                        if (typeof value !== "undefined") return false;
                    });
                }
                if (typeof value === "undefined") value = $3813849af5116a0f$var$DEFAULT_RAW[detect];
                root.rawCache[detect] = value;
                return value;
            }
        },
        {
            key: "rawBeforeClose",
            value: function rawBeforeClose(root) {
                var value;
                root.walk(function(i) {
                    if (i.nodes && i.nodes.length > 0) {
                        if (typeof i.raws.after !== "undefined") {
                            value = i.raws.after;
                            if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                            return false;
                        }
                    }
                });
                if (value) value = value.replace(/\S/g, "");
                return value;
            }
        },
        {
            key: "rawBeforeComment",
            value: function rawBeforeComment(root, node) {
                var value;
                root.walkComments(function(i) {
                    if (typeof i.raws.before !== "undefined") {
                        value = i.raws.before;
                        if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                        return false;
                    }
                });
                if (typeof value === "undefined") value = this.raw(node, null, "beforeDecl");
                else if (value) value = value.replace(/\S/g, "");
                return value;
            }
        },
        {
            key: "rawBeforeDecl",
            value: function rawBeforeDecl(root, node) {
                var value;
                root.walkDecls(function(i) {
                    if (typeof i.raws.before !== "undefined") {
                        value = i.raws.before;
                        if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                        return false;
                    }
                });
                if (typeof value === "undefined") value = this.raw(node, null, "beforeRule");
                else if (value) value = value.replace(/\S/g, "");
                return value;
            }
        },
        {
            key: "rawBeforeOpen",
            value: function rawBeforeOpen(root) {
                var value;
                root.walk(function(i) {
                    if (i.type !== "decl") {
                        value = i.raws.between;
                        if (typeof value !== "undefined") return false;
                    }
                });
                return value;
            }
        },
        {
            key: "rawBeforeRule",
            value: function rawBeforeRule(root) {
                var value;
                root.walk(function(i) {
                    if (i.nodes && (i.parent !== root || root.first !== i)) {
                        if (typeof i.raws.before !== "undefined") {
                            value = i.raws.before;
                            if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                            return false;
                        }
                    }
                });
                if (value) value = value.replace(/\S/g, "");
                return value;
            }
        },
        {
            key: "rawColon",
            value: function rawColon(root) {
                var value;
                root.walkDecls(function(i) {
                    if (typeof i.raws.between !== "undefined") {
                        value = i.raws.between.replace(/[^\s:]/g, "");
                        return false;
                    }
                });
                return value;
            }
        },
        {
            key: "rawEmptyBody",
            value: function rawEmptyBody(root) {
                var value;
                root.walk(function(i) {
                    if (i.nodes && i.nodes.length === 0) {
                        value = i.raws.after;
                        if (typeof value !== "undefined") return false;
                    }
                });
                return value;
            }
        },
        {
            key: "rawIndent",
            value: function rawIndent(root) {
                if (root.raws.indent) return root.raws.indent;
                var value;
                root.walk(function(i) {
                    var p = i.parent;
                    if (p && p !== root && p.parent && p.parent === root) {
                        if (typeof i.raws.before !== "undefined") {
                            var parts = i.raws.before.split("\n");
                            value = parts[parts.length - 1];
                            value = value.replace(/\S/g, "");
                            return false;
                        }
                    }
                });
                return value;
            }
        },
        {
            key: "rawSemicolon",
            value: function rawSemicolon(root) {
                var value;
                root.walk(function(i) {
                    if (i.nodes && i.nodes.length && i.last.type === "decl") {
                        value = i.raws.semicolon;
                        if (typeof value !== "undefined") return false;
                    }
                });
                return value;
            }
        },
        {
            key: "rawValue",
            value: function rawValue(node, prop) {
                var value = node[prop];
                var raw = node.raws[prop];
                if (raw && raw.value === value) return raw.raw;
                return value;
            }
        },
        {
            key: "root",
            value: function root(node) {
                this.body(node);
                if (node.raws.after) this.builder(node.raws.after);
            }
        },
        {
            key: "rule",
            value: function rule(node) {
                this.block(node, this.rawValue(node, "selector"));
                if (node.raws.ownSemicolon) this.builder(node.raws.ownSemicolon, node, "end");
            }
        },
        {
            key: "stringify",
            value: function stringify(node, semicolon) {
                /* c8 ignore start */ if (!this[node.type]) throw new Error("Unknown AST node type " + node.type + ". " + "Maybe you need to change PostCSS stringifier.");
                /* c8 ignore stop */ this[node.type](node, semicolon);
            }
        }
    ]);
    return Stringifier;
}();
module.exports = $3813849af5116a0f$var$Stringifier;
$3813849af5116a0f$var$Stringifier.default = $3813849af5116a0f$var$Stringifier;

});

parcelRegister("iQcw1", function(module, exports) {
"use strict";

var $4Ouxf = parcelRequire("4Ouxf");
function $db76caa9d26269bb$var$stringify(node, builder) {
    var str = new $4Ouxf(builder);
    str.stringify(node);
}
module.exports = $db76caa9d26269bb$var$stringify;
$db76caa9d26269bb$var$stringify.default = $db76caa9d26269bb$var$stringify;

});



parcelRegister("7Phwu", function(module, exports) {

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $cv9Rk = parcelRequire("cv9Rk");

var $l29cN = parcelRequire("l29cN");

var $l29cN = parcelRequire("l29cN");
"use strict";

var $8nXrl = parcelRequire("8nXrl");
var $5b2ae3881c508468$var$isClean = $8nXrl.isClean, $5b2ae3881c508468$var$my = $8nXrl.my;

var $4MNGy = parcelRequire("4MNGy");

var $iQcw1 = parcelRequire("iQcw1");

var $jF4Xc = parcelRequire("jF4Xc");

var $bgmOa = parcelRequire("bgmOa");
parcelRequire("iIBit");

var $2crP5 = parcelRequire("2crP5");

var $2DaUH = parcelRequire("2DaUH");

var $24VdH = parcelRequire("24VdH");
var $5b2ae3881c508468$var$TYPE_TO_CLASS_NAME = {
    atrule: "AtRule",
    comment: "Comment",
    decl: "Declaration",
    document: "Document",
    root: "Root",
    rule: "Rule"
};
var $5b2ae3881c508468$var$PLUGIN_PROPS = {
    AtRule: true,
    AtRuleExit: true,
    Comment: true,
    CommentExit: true,
    Declaration: true,
    DeclarationExit: true,
    Document: true,
    DocumentExit: true,
    Once: true,
    OnceExit: true,
    postcssPlugin: true,
    prepare: true,
    Root: true,
    RootExit: true,
    Rule: true,
    RuleExit: true
};
var $5b2ae3881c508468$var$NOT_VISITORS = {
    Once: true,
    postcssPlugin: true,
    prepare: true
};
var $5b2ae3881c508468$var$CHILDREN = 0;
function $5b2ae3881c508468$var$isPromise(obj) {
    return typeof obj === "object" && typeof obj.then === "function";
}
function $5b2ae3881c508468$var$getEvents(node) {
    var key = false;
    var type = $5b2ae3881c508468$var$TYPE_TO_CLASS_NAME[node.type];
    if (node.type === "decl") key = node.prop.toLowerCase();
    else if (node.type === "atrule") key = node.name.toLowerCase();
    if (key && node.append) return [
        type,
        type + "-" + key,
        $5b2ae3881c508468$var$CHILDREN,
        type + "Exit",
        type + "Exit-" + key
    ];
    else if (key) return [
        type,
        type + "-" + key,
        type + "Exit",
        type + "Exit-" + key
    ];
    else if (node.append) return [
        type,
        $5b2ae3881c508468$var$CHILDREN,
        type + "Exit"
    ];
    else return [
        type,
        type + "Exit"
    ];
}
function $5b2ae3881c508468$var$toStack(node) {
    var events;
    if (node.type === "document") events = [
        "Document",
        $5b2ae3881c508468$var$CHILDREN,
        "DocumentExit"
    ];
    else if (node.type === "root") events = [
        "Root",
        $5b2ae3881c508468$var$CHILDREN,
        "RootExit"
    ];
    else events = $5b2ae3881c508468$var$getEvents(node);
    return {
        eventIndex: 0,
        events: events,
        iterator: 0,
        node: node,
        visitorIndex: 0,
        visitors: []
    };
}
function $5b2ae3881c508468$var$cleanMarks(node) {
    node[$5b2ae3881c508468$var$isClean] = false;
    if (node.nodes) node.nodes.forEach(function(i) {
        return $5b2ae3881c508468$var$cleanMarks(i);
    });
    return node;
}
var $5b2ae3881c508468$var$postcss = {};
var $5b2ae3881c508468$var$LazyResult = /*#__PURE__*/ function() {
    function LazyResult(processor, css, opts) {
        var _this = this;
        (0, $4GJKx._)(this, LazyResult);
        this.stringified = false;
        this.processed = false;
        var root;
        if (typeof css === "object" && css !== null && (css.type === "root" || css.type === "document")) root = $5b2ae3881c508468$var$cleanMarks(css);
        else if (css instanceof LazyResult || css instanceof $2crP5) {
            root = $5b2ae3881c508468$var$cleanMarks(css.root);
            if (css.map) {
                if (typeof opts.map === "undefined") opts.map = {};
                if (!opts.map.inline) opts.map.inline = false;
                opts.map.prev = css.map;
            }
        } else {
            var parser = $2DaUH;
            if (opts.syntax) parser = opts.syntax.parse;
            if (opts.parser) parser = opts.parser;
            if (parser.parse) parser = parser.parse;
            try {
                root = parser(css, opts);
            } catch (error) {
                this.processed = true;
                this.error = error;
            }
            if (root && !root[$5b2ae3881c508468$var$my]) /* c8 ignore next 2 */ $jF4Xc.rebuild(root);
        }
        this.result = new $2crP5(processor, root, opts);
        this.helpers = (0, $cxjpp._)((0, $do9pw._)({}, $5b2ae3881c508468$var$postcss), {
            postcss: $5b2ae3881c508468$var$postcss,
            result: this.result
        });
        this.plugins = this.processor.plugins.map(function(plugin) {
            if (typeof plugin === "object" && plugin.prepare) return (0, $do9pw._)({}, plugin, plugin.prepare(_this.result));
            else return plugin;
        });
    }
    (0, $1wc17._)(LazyResult, [
        {
            key: "async",
            value: function async() {
                if (this.error) return Promise.reject(this.error);
                if (this.processed) return Promise.resolve(this.result);
                if (!this.processing) this.processing = this.runAsync();
                return this.processing;
            }
        },
        {
            key: "catch",
            value: function _catch(onRejected) {
                return this.async().catch(onRejected);
            }
        },
        {
            key: "finally",
            value: function _finally(onFinally) {
                return this.async().then(onFinally, onFinally);
            }
        },
        {
            key: "getAsyncError",
            value: function getAsyncError() {
                throw new Error("Use process(css).then(cb) to work with async plugins");
            }
        },
        {
            key: "handleError",
            value: function handleError(error, node) {
                var plugin = this.result.lastPlugin;
                try {
                    if (node) node.addToError(error);
                    this.error = error;
                    if (error.name === "CssSyntaxError" && !error.plugin) {
                        error.plugin = plugin.postcssPlugin;
                        error.setMessage();
                    } else plugin.postcssVersion;
                } catch (err) {
                    /* c8 ignore next 3 */ // eslint-disable-next-line no-console
                    if (console && console.error) console.error(err);
                }
                return error;
            }
        },
        {
            key: "prepareVisitors",
            value: function prepareVisitors() {
                var _this = this;
                this.listeners = {};
                var add = function(plugin, type, cb) {
                    if (!_this.listeners[type]) _this.listeners[type] = [];
                    _this.listeners[type].push([
                        plugin,
                        cb
                    ]);
                };
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.plugins[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var plugin = _step.value;
                        if (typeof plugin === "object") for(var event in plugin){
                            if (!$5b2ae3881c508468$var$PLUGIN_PROPS[event] && /^[A-Z]/.test(event)) throw new Error("Unknown event ".concat(event, " in ").concat(plugin.postcssPlugin, ". ") + "Try to update PostCSS (".concat(this.processor.version, " now)."));
                            if (!$5b2ae3881c508468$var$NOT_VISITORS[event]) {
                                if (typeof plugin[event] === "object") {
                                    for(var filter in plugin[event])if (filter === "*") add(plugin, event, plugin[event][filter]);
                                    else add(plugin, event + "-" + filter.toLowerCase(), plugin[event][filter]);
                                } else if (typeof plugin[event] === "function") add(plugin, event, plugin[event]);
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this.hasListener = Object.keys(this.listeners).length > 0;
            }
        },
        {
            key: "runAsync",
            value: function runAsync() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var i, plugin, promise, error, root, stack, promise1, e, node, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step, err;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.plugin = 0;
                                i = 0;
                                _state.label = 1;
                            case 1:
                                if (!(i < _this.plugins.length)) return [
                                    3,
                                    6
                                ];
                                plugin = _this.plugins[i];
                                promise = _this.runOnRoot(plugin);
                                if (!$5b2ae3881c508468$var$isPromise(promise)) return [
                                    3,
                                    5
                                ];
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    promise
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                error = _state.sent();
                                throw _this.handleError(error);
                            case 5:
                                i++;
                                return [
                                    3,
                                    1
                                ];
                            case 6:
                                _this.prepareVisitors();
                                if (!_this.hasListener) return [
                                    3,
                                    22
                                ];
                                root = _this.result.root;
                                _state.label = 7;
                            case 7:
                                if (!!root[$5b2ae3881c508468$var$isClean]) return [
                                    3,
                                    14
                                ];
                                root[$5b2ae3881c508468$var$isClean] = true;
                                stack = [
                                    $5b2ae3881c508468$var$toStack(root)
                                ];
                                _state.label = 8;
                            case 8:
                                if (!(stack.length > 0)) return [
                                    3,
                                    13
                                ];
                                promise1 = _this.visitTick(stack);
                                if (!$5b2ae3881c508468$var$isPromise(promise1)) return [
                                    3,
                                    12
                                ];
                                _state.label = 9;
                            case 9:
                                _state.trys.push([
                                    9,
                                    11,
                                    ,
                                    12
                                ]);
                                return [
                                    4,
                                    promise1
                                ];
                            case 10:
                                _state.sent();
                                return [
                                    3,
                                    12
                                ];
                            case 11:
                                e = _state.sent();
                                node = stack[stack.length - 1].node;
                                throw _this.handleError(e, node);
                            case 12:
                                return [
                                    3,
                                    8
                                ];
                            case 13:
                                return [
                                    3,
                                    7
                                ];
                            case 14:
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                if (!_this.listeners.OnceExit) return [
                                    3,
                                    22
                                ];
                                _state.label = 15;
                            case 15:
                                _state.trys.push([
                                    15,
                                    20,
                                    21,
                                    22
                                ]);
                                _loop = function() {
                                    var _step_value, plugin, visitor, roots, e;
                                    return (0, $l29cN.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                _step_value = (0, $cv9Rk._)(_step.value, 2), plugin = _step_value[0], visitor = _step_value[1];
                                                _this.result.lastPlugin = plugin;
                                                _state.label = 1;
                                            case 1:
                                                _state.trys.push([
                                                    1,
                                                    6,
                                                    ,
                                                    7
                                                ]);
                                                if (!(root.type === "document")) return [
                                                    3,
                                                    3
                                                ];
                                                roots = root.nodes.map(function(subRoot) {
                                                    return visitor(subRoot, _this.helpers);
                                                });
                                                return [
                                                    4,
                                                    Promise.all(roots)
                                                ];
                                            case 2:
                                                _state.sent();
                                                return [
                                                    3,
                                                    5
                                                ];
                                            case 3:
                                                return [
                                                    4,
                                                    visitor(root, _this.helpers)
                                                ];
                                            case 4:
                                                _state.sent();
                                                _state.label = 5;
                                            case 5:
                                                return [
                                                    3,
                                                    7
                                                ];
                                            case 6:
                                                e = _state.sent();
                                                throw _this.handleError(e);
                                            case 7:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                };
                                _iterator = _this.listeners.OnceExit[Symbol.iterator]();
                                _state.label = 16;
                            case 16:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    19
                                ];
                                return [
                                    5,
                                    (0, $l29cN.__values)(_loop())
                                ];
                            case 17:
                                _state.sent();
                                _state.label = 18;
                            case 18:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    16
                                ];
                            case 19:
                                return [
                                    3,
                                    22
                                ];
                            case 20:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    22
                                ];
                            case 21:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 22:
                                _this.processed = true;
                                return [
                                    2,
                                    _this.stringify()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "runOnRoot",
            value: function runOnRoot(plugin) {
                var _this = this;
                this.result.lastPlugin = plugin;
                try {
                    if (typeof plugin === "object" && plugin.Once) {
                        if (this.result.root.type === "document") {
                            var roots = this.result.root.nodes.map(function(root) {
                                return plugin.Once(root, _this.helpers);
                            });
                            if ($5b2ae3881c508468$var$isPromise(roots[0])) return Promise.all(roots);
                            return roots;
                        }
                        return plugin.Once(this.result.root, this.helpers);
                    } else if (typeof plugin === "function") return plugin(this.result.root, this.result);
                } catch (error) {
                    throw this.handleError(error);
                }
            }
        },
        {
            key: "stringify",
            value: function stringify1() {
                if (this.error) throw this.error;
                if (this.stringified) return this.result;
                this.stringified = true;
                this.sync();
                var opts = this.result.opts;
                var str = $iQcw1;
                if (opts.syntax) str = opts.syntax.stringify;
                if (opts.stringifier) str = opts.stringifier;
                if (str.stringify) str = str.stringify;
                var map = new $4MNGy(str, this.result.root, this.result.opts);
                var data = map.generate();
                this.result.css = data[0];
                this.result.map = data[1];
                return this.result;
            }
        },
        {
            key: "sync",
            value: function sync() {
                if (this.error) throw this.error;
                if (this.processed) return this.result;
                this.processed = true;
                if (this.processing) throw this.getAsyncError();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.plugins[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var plugin = _step.value;
                        var promise = this.runOnRoot(plugin);
                        if ($5b2ae3881c508468$var$isPromise(promise)) throw this.getAsyncError();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this.prepareVisitors();
                if (this.hasListener) {
                    var root = this.result.root;
                    while(!root[$5b2ae3881c508468$var$isClean]){
                        root[$5b2ae3881c508468$var$isClean] = true;
                        this.walkSync(root);
                    }
                    if (this.listeners.OnceExit) {
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        if (root.type === "document") try {
                            for(var _iterator1 = root.nodes[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var subRoot = _step1.value;
                                this.visitSync(this.listeners.OnceExit, subRoot);
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                        else this.visitSync(this.listeners.OnceExit, root);
                    }
                }
                return this.result;
            }
        },
        {
            key: "then",
            value: function then(onFulfilled, onRejected) {
                return this.async().then(onFulfilled, onRejected);
            }
        },
        {
            key: "toString",
            value: function toString() {
                return this.css;
            }
        },
        {
            key: "visitSync",
            value: function visitSync(visitors, node) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = visitors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $cv9Rk._)(_step.value, 2), plugin = _step_value[0], visitor = _step_value[1];
                        this.result.lastPlugin = plugin;
                        var promise = void 0;
                        try {
                            promise = visitor(node, this.helpers);
                        } catch (e) {
                            throw this.handleError(e, node.proxyOf);
                        }
                        if (node.type !== "root" && node.type !== "document" && !node.parent) return true;
                        if ($5b2ae3881c508468$var$isPromise(promise)) throw this.getAsyncError();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "visitTick",
            value: function visitTick(stack) {
                var visit = stack[stack.length - 1];
                var node = visit.node, visitors = visit.visitors;
                if (node.type !== "root" && node.type !== "document" && !node.parent) {
                    stack.pop();
                    return;
                }
                if (visitors.length > 0 && visit.visitorIndex < visitors.length) {
                    var _visitors_visit_visitorIndex = (0, $cv9Rk._)(visitors[visit.visitorIndex], 2), plugin = _visitors_visit_visitorIndex[0], visitor = _visitors_visit_visitorIndex[1];
                    visit.visitorIndex += 1;
                    if (visit.visitorIndex === visitors.length) {
                        visit.visitors = [];
                        visit.visitorIndex = 0;
                    }
                    this.result.lastPlugin = plugin;
                    try {
                        return visitor(node.toProxy(), this.helpers);
                    } catch (e) {
                        throw this.handleError(e, node);
                    }
                }
                if (visit.iterator !== 0) {
                    var iterator = visit.iterator;
                    var child;
                    while(child = node.nodes[node.indexes[iterator]]){
                        node.indexes[iterator] += 1;
                        if (!child[$5b2ae3881c508468$var$isClean]) {
                            child[$5b2ae3881c508468$var$isClean] = true;
                            stack.push($5b2ae3881c508468$var$toStack(child));
                            return;
                        }
                    }
                    visit.iterator = 0;
                    delete node.indexes[iterator];
                }
                var events = visit.events;
                while(visit.eventIndex < events.length){
                    var event = events[visit.eventIndex];
                    visit.eventIndex += 1;
                    if (event === $5b2ae3881c508468$var$CHILDREN) {
                        if (node.nodes && node.nodes.length) {
                            node[$5b2ae3881c508468$var$isClean] = true;
                            visit.iterator = node.getIterator();
                        }
                        return;
                    } else if (this.listeners[event]) {
                        visit.visitors = this.listeners[event];
                        return;
                    }
                }
                stack.pop();
            }
        },
        {
            key: "walkSync",
            value: function walkSync(node) {
                var _this = this;
                node[$5b2ae3881c508468$var$isClean] = true;
                var events = $5b2ae3881c508468$var$getEvents(node);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = events[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var event = _step.value;
                        if (event === $5b2ae3881c508468$var$CHILDREN) {
                            if (node.nodes) node.each(function(child) {
                                if (!child[$5b2ae3881c508468$var$isClean]) _this.walkSync(child);
                            });
                        } else {
                            var visitors = this.listeners[event];
                            if (visitors) {
                                if (this.visitSync(visitors, node.toProxy())) return;
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "warnings",
            value: function warnings() {
                return this.sync().warnings();
            }
        },
        {
            key: "content",
            get: function get() {
                return this.stringify().content;
            }
        },
        {
            key: "css",
            get: function get() {
                return this.stringify().css;
            }
        },
        {
            key: "map",
            get: function get() {
                return this.stringify().map;
            }
        },
        {
            key: "messages",
            get: function get() {
                return this.sync().messages;
            }
        },
        {
            key: "opts",
            get: function get() {
                return this.result.opts;
            }
        },
        {
            key: "processor",
            get: function get() {
                return this.result.processor;
            }
        },
        {
            key: "root",
            get: function get() {
                return this.sync().root;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "LazyResult";
            }
        }
    ]);
    return LazyResult;
}();
$5b2ae3881c508468$var$LazyResult.registerPostcss = function(dependant) {
    $5b2ae3881c508468$var$postcss = dependant;
};
module.exports = $5b2ae3881c508468$var$LazyResult;
$5b2ae3881c508468$var$LazyResult.default = $5b2ae3881c508468$var$LazyResult;
$24VdH.registerLazyResult($5b2ae3881c508468$var$LazyResult);
$bgmOa.registerLazyResult($5b2ae3881c508468$var$LazyResult);

});
parcelRegister("4MNGy", function(module, exports) {

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $8dlmd = parcelRequire("8dlmd");
var $37c22f9bf42badcc$require$Buffer = $8dlmd.Buffer;
"use strict";

var $9dH9K = parcelRequire("9dH9K");
var $37c22f9bf42badcc$var$SourceMapConsumer = $9dH9K.SourceMapConsumer, $37c22f9bf42badcc$var$SourceMapGenerator = $9dH9K.SourceMapGenerator;

var $9dH9K = parcelRequire("9dH9K");
var $37c22f9bf42badcc$var$dirname = $9dH9K.dirname, $37c22f9bf42badcc$var$relative = $9dH9K.relative, $37c22f9bf42badcc$var$resolve = $9dH9K.resolve, $37c22f9bf42badcc$var$sep = $9dH9K.sep;

var $9dH9K = parcelRequire("9dH9K");
var $37c22f9bf42badcc$require$pathToFileURL = $9dH9K.pathToFileURL;

var $8YvnY = parcelRequire("8YvnY");
var $37c22f9bf42badcc$var$sourceMapAvailable = Boolean($37c22f9bf42badcc$var$SourceMapConsumer && $37c22f9bf42badcc$var$SourceMapGenerator);
var $37c22f9bf42badcc$var$pathAvailable = Boolean($37c22f9bf42badcc$var$dirname && $37c22f9bf42badcc$var$resolve && $37c22f9bf42badcc$var$relative && $37c22f9bf42badcc$var$sep);
var $37c22f9bf42badcc$var$MapGenerator = /*#__PURE__*/ function() {
    "use strict";
    function MapGenerator(stringify, root, opts, cssString) {
        (0, $4GJKx._)(this, MapGenerator);
        this.stringify = stringify;
        this.mapOpts = opts.map || {};
        this.root = root;
        this.opts = opts;
        this.css = cssString;
        this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute;
        this.memoizedFileURLs = new Map();
        this.memoizedPaths = new Map();
        this.memoizedURLs = new Map();
    }
    (0, $1wc17._)(MapGenerator, [
        {
            key: "addAnnotation",
            value: function addAnnotation() {
                var content;
                if (this.isInline()) content = "data:application/json;base64," + this.toBase64(this.map.toString());
                else if (typeof this.mapOpts.annotation === "string") content = this.mapOpts.annotation;
                else if (typeof this.mapOpts.annotation === "function") content = this.mapOpts.annotation(this.opts.to, this.root);
                else content = this.outputFile() + ".map";
                var eol = "\n";
                if (this.css.includes("\r\n")) eol = "\r\n";
                this.css += eol + "/*# sourceMappingURL=" + content + " */";
            }
        },
        {
            key: "applyPrevMaps",
            value: function applyPrevMaps() {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.previous()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var prev = _step.value;
                        var from = this.toUrl(this.path(prev.file));
                        var root = prev.root || $37c22f9bf42badcc$var$dirname(prev.file);
                        var map = void 0;
                        if (this.mapOpts.sourcesContent === false) {
                            map = new $37c22f9bf42badcc$var$SourceMapConsumer(prev.text);
                            if (map.sourcesContent) map.sourcesContent = map.sourcesContent.map(function() {
                                return null;
                            });
                        } else map = prev.consumer();
                        this.map.applySourceMap(map, from, this.toUrl(this.path(root)));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "clearAnnotation",
            value: function clearAnnotation() {
                if (this.mapOpts.annotation === false) return;
                if (this.root) {
                    var node;
                    for(var i = this.root.nodes.length - 1; i >= 0; i--){
                        node = this.root.nodes[i];
                        if (node.type !== "comment") continue;
                        if (node.text.indexOf("# sourceMappingURL=") === 0) this.root.removeChild(i);
                    }
                } else if (this.css) this.css = this.css.replace(/(\n)?\/\*#[\S\s]*?\*\/$/gm, "");
            }
        },
        {
            key: "generate",
            value: function generate() {
                this.clearAnnotation();
                if ($37c22f9bf42badcc$var$pathAvailable && $37c22f9bf42badcc$var$sourceMapAvailable && this.isMap()) return this.generateMap();
                else {
                    var result = "";
                    this.stringify(this.root, function(i) {
                        result += i;
                    });
                    return [
                        result
                    ];
                }
            }
        },
        {
            key: "generateMap",
            value: function generateMap() {
                if (this.root) this.generateString();
                else if (this.previous().length === 1) {
                    var prev = this.previous()[0].consumer();
                    prev.file = this.outputFile();
                    this.map = $37c22f9bf42badcc$var$SourceMapGenerator.fromSourceMap(prev);
                } else {
                    this.map = new $37c22f9bf42badcc$var$SourceMapGenerator({
                        file: this.outputFile()
                    });
                    this.map.addMapping({
                        generated: {
                            column: 0,
                            line: 1
                        },
                        original: {
                            column: 0,
                            line: 1
                        },
                        source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
                    });
                }
                if (this.isSourcesContent()) this.setSourcesContent();
                if (this.root && this.previous().length > 0) this.applyPrevMaps();
                if (this.isAnnotation()) this.addAnnotation();
                if (this.isInline()) return [
                    this.css
                ];
                else return [
                    this.css,
                    this.map
                ];
            }
        },
        {
            key: "generateString",
            value: function generateString() {
                var _this = this;
                this.css = "";
                this.map = new $37c22f9bf42badcc$var$SourceMapGenerator({
                    file: this.outputFile()
                });
                var line = 1;
                var column = 1;
                var noSource = "<no source>";
                var mapping = {
                    generated: {
                        column: 0,
                        line: 0
                    },
                    original: {
                        column: 0,
                        line: 0
                    },
                    source: ""
                };
                var lines, last;
                this.stringify(this.root, function(str, node, type) {
                    _this.css += str;
                    if (node && type !== "end") {
                        mapping.generated.line = line;
                        mapping.generated.column = column - 1;
                        if (node.source && node.source.start) {
                            mapping.source = _this.sourcePath(node);
                            mapping.original.line = node.source.start.line;
                            mapping.original.column = node.source.start.column - 1;
                            _this.map.addMapping(mapping);
                        } else {
                            mapping.source = noSource;
                            mapping.original.line = 1;
                            mapping.original.column = 0;
                            _this.map.addMapping(mapping);
                        }
                    }
                    lines = str.match(/\n/g);
                    if (lines) {
                        line += lines.length;
                        last = str.lastIndexOf("\n");
                        column = str.length - last;
                    } else column += str.length;
                    if (node && type !== "start") {
                        var p = node.parent || {
                            raws: {}
                        };
                        var childless = node.type === "decl" || node.type === "atrule" && !node.nodes;
                        if (!childless || node !== p.last || p.raws.semicolon) {
                            if (node.source && node.source.end) {
                                mapping.source = _this.sourcePath(node);
                                mapping.original.line = node.source.end.line;
                                mapping.original.column = node.source.end.column - 1;
                                mapping.generated.line = line;
                                mapping.generated.column = column - 2;
                                _this.map.addMapping(mapping);
                            } else {
                                mapping.source = noSource;
                                mapping.original.line = 1;
                                mapping.original.column = 0;
                                mapping.generated.line = line;
                                mapping.generated.column = column - 1;
                                _this.map.addMapping(mapping);
                            }
                        }
                    }
                });
            }
        },
        {
            key: "isAnnotation",
            value: function isAnnotation() {
                if (this.isInline()) return true;
                if (typeof this.mapOpts.annotation !== "undefined") return this.mapOpts.annotation;
                if (this.previous().length) return this.previous().some(function(i) {
                    return i.annotation;
                });
                return true;
            }
        },
        {
            key: "isInline",
            value: function isInline() {
                if (typeof this.mapOpts.inline !== "undefined") return this.mapOpts.inline;
                var annotation = this.mapOpts.annotation;
                if (typeof annotation !== "undefined" && annotation !== true) return false;
                if (this.previous().length) return this.previous().some(function(i) {
                    return i.inline;
                });
                return true;
            }
        },
        {
            key: "isMap",
            value: function isMap() {
                if (typeof this.opts.map !== "undefined") return !!this.opts.map;
                return this.previous().length > 0;
            }
        },
        {
            key: "isSourcesContent",
            value: function isSourcesContent() {
                if (typeof this.mapOpts.sourcesContent !== "undefined") return this.mapOpts.sourcesContent;
                if (this.previous().length) return this.previous().some(function(i) {
                    return i.withContent();
                });
                return true;
            }
        },
        {
            key: "outputFile",
            value: function outputFile() {
                if (this.opts.to) return this.path(this.opts.to);
                else if (this.opts.from) return this.path(this.opts.from);
                else return "to.css";
            }
        },
        {
            key: "path",
            value: function path(file) {
                if (this.mapOpts.absolute) return file;
                if (file.charCodeAt(0) === 60 /* `<` */ ) return file;
                if (/^\w+:\/\//.test(file)) return file;
                var cached = this.memoizedPaths.get(file);
                if (cached) return cached;
                var from = this.opts.to ? $37c22f9bf42badcc$var$dirname(this.opts.to) : ".";
                if (typeof this.mapOpts.annotation === "string") from = $37c22f9bf42badcc$var$dirname($37c22f9bf42badcc$var$resolve(from, this.mapOpts.annotation));
                var path = $37c22f9bf42badcc$var$relative(from, file);
                this.memoizedPaths.set(file, path);
                return path;
            }
        },
        {
            key: "previous",
            value: function previous() {
                var _this = this;
                if (!this.previousMaps) {
                    this.previousMaps = [];
                    if (this.root) this.root.walk(function(node) {
                        if (node.source && node.source.input.map) {
                            var map = node.source.input.map;
                            if (!_this.previousMaps.includes(map)) _this.previousMaps.push(map);
                        }
                    });
                    else {
                        var input = new $8YvnY(this.css, this.opts);
                        if (input.map) this.previousMaps.push(input.map);
                    }
                }
                return this.previousMaps;
            }
        },
        {
            key: "setSourcesContent",
            value: function setSourcesContent() {
                var _this = this;
                var already = {};
                if (this.root) this.root.walk(function(node) {
                    if (node.source) {
                        var from = node.source.input.from;
                        if (from && !already[from]) {
                            already[from] = true;
                            var fromUrl = _this.usesFileUrls ? _this.toFileUrl(from) : _this.toUrl(_this.path(from));
                            _this.map.setSourceContent(fromUrl, node.source.input.css);
                        }
                    }
                });
                else if (this.css) {
                    var from = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
                    this.map.setSourceContent(from, this.css);
                }
            }
        },
        {
            key: "sourcePath",
            value: function sourcePath(node) {
                if (this.mapOpts.from) return this.toUrl(this.mapOpts.from);
                else if (this.usesFileUrls) return this.toFileUrl(node.source.input.from);
                else return this.toUrl(this.path(node.source.input.from));
            }
        },
        {
            key: "toBase64",
            value: function toBase64(str) {
                if ($37c22f9bf42badcc$require$Buffer) return $37c22f9bf42badcc$require$Buffer.from(str).toString("base64");
                else return window.btoa(unescape(encodeURIComponent(str)));
            }
        },
        {
            key: "toFileUrl",
            value: function toFileUrl(path) {
                var cached = this.memoizedFileURLs.get(path);
                if (cached) return cached;
                if ($37c22f9bf42badcc$require$pathToFileURL) {
                    var fileURL = $37c22f9bf42badcc$require$pathToFileURL(path).toString();
                    this.memoizedFileURLs.set(path, fileURL);
                    return fileURL;
                } else throw new Error("`map.absolute` option is not available in this PostCSS build");
            }
        },
        {
            key: "toUrl",
            value: function toUrl(path) {
                var cached = this.memoizedURLs.get(path);
                if (cached) return cached;
                if ($37c22f9bf42badcc$var$sep === "\\") path = path.replace(/\\/g, "/");
                var url = encodeURI(path).replace(/[#?]/g, encodeURIComponent);
                this.memoizedURLs.set(path, url);
                return url;
            }
        }
    ]);
    return MapGenerator;
}();
module.exports = $37c22f9bf42badcc$var$MapGenerator;

});
parcelRegister("8YvnY", function(module, exports) {

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $do9pw = parcelRequire("do9pw");
"use strict";

var $9dH9K = parcelRequire("9dH9K");
var $688c45e47c68b1c4$var$SourceMapConsumer = $9dH9K.SourceMapConsumer, $688c45e47c68b1c4$var$SourceMapGenerator = $9dH9K.SourceMapGenerator;

var $9dH9K = parcelRequire("9dH9K");
var $688c45e47c68b1c4$var$fileURLToPath = $9dH9K.fileURLToPath, $688c45e47c68b1c4$var$pathToFileURL = $9dH9K.pathToFileURL;

var $9dH9K = parcelRequire("9dH9K");
var $688c45e47c68b1c4$var$isAbsolute = $9dH9K.isAbsolute, $688c45e47c68b1c4$var$resolve = $9dH9K.resolve;

var $liEUQ = parcelRequire("liEUQ");
var $688c45e47c68b1c4$require$nanoid = $liEUQ.nanoid;

var $9dH9K = parcelRequire("9dH9K");

var $8wjAu = parcelRequire("8wjAu");

var $lqcup = parcelRequire("lqcup");
var $688c45e47c68b1c4$var$fromOffsetCache = Symbol("fromOffsetCache");
var $688c45e47c68b1c4$var$sourceMapAvailable = Boolean($688c45e47c68b1c4$var$SourceMapConsumer && $688c45e47c68b1c4$var$SourceMapGenerator);
var $688c45e47c68b1c4$var$pathAvailable = Boolean($688c45e47c68b1c4$var$resolve && $688c45e47c68b1c4$var$isAbsolute);
var $688c45e47c68b1c4$var$Input = /*#__PURE__*/ function() {
    function Input(css) {
        var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $4GJKx._)(this, Input);
        if (css === null || typeof css === "undefined" || typeof css === "object" && !css.toString) throw new Error("PostCSS received ".concat(css, " instead of CSS string"));
        this.css = css.toString();
        if (this.css[0] === "\uFEFF" || this.css[0] === "\uFFFE") {
            this.hasBOM = true;
            this.css = this.css.slice(1);
        } else this.hasBOM = false;
        if (opts.from) {
            if (!$688c45e47c68b1c4$var$pathAvailable || /^\w+:\/\//.test(opts.from) || $688c45e47c68b1c4$var$isAbsolute(opts.from)) this.file = opts.from;
            else this.file = $688c45e47c68b1c4$var$resolve(opts.from);
        }
        if ($688c45e47c68b1c4$var$pathAvailable && $688c45e47c68b1c4$var$sourceMapAvailable) {
            var map = new $lqcup(this.css, opts);
            if (map.text) {
                this.map = map;
                var file = map.consumer().file;
                if (!this.file && file) this.file = this.mapResolve(file);
            }
        }
        if (!this.file) this.id = "<input css " + $688c45e47c68b1c4$require$nanoid(6) + ">";
        if (this.map) this.map.file = this.from;
    }
    (0, $1wc17._)(Input, [
        {
            key: "error",
            value: function error(message, line, column) {
                var opts = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
                var result, endLine, endColumn;
                if (line && typeof line === "object") {
                    var start = line;
                    var end = column;
                    if (typeof start.offset === "number") {
                        var pos = this.fromOffset(start.offset);
                        line = pos.line;
                        column = pos.col;
                    } else {
                        line = start.line;
                        column = start.column;
                    }
                    if (typeof end.offset === "number") {
                        var pos1 = this.fromOffset(end.offset);
                        endLine = pos1.line;
                        endColumn = pos1.col;
                    } else {
                        endLine = end.line;
                        endColumn = end.column;
                    }
                } else if (!column) {
                    var pos2 = this.fromOffset(line);
                    line = pos2.line;
                    column = pos2.col;
                }
                var origin = this.origin(line, column, endLine, endColumn);
                if (origin) result = new $8wjAu(message, origin.endLine === undefined ? origin.line : {
                    column: origin.column,
                    line: origin.line
                }, origin.endLine === undefined ? origin.column : {
                    column: origin.endColumn,
                    line: origin.endLine
                }, origin.source, origin.file, opts.plugin);
                else result = new $8wjAu(message, endLine === undefined ? line : {
                    column: column,
                    line: line
                }, endLine === undefined ? column : {
                    column: endColumn,
                    line: endLine
                }, this.css, this.file, opts.plugin);
                result.input = {
                    column: column,
                    endColumn: endColumn,
                    endLine: endLine,
                    line: line,
                    source: this.css
                };
                if (this.file) {
                    if ($688c45e47c68b1c4$var$pathToFileURL) result.input.url = $688c45e47c68b1c4$var$pathToFileURL(this.file).toString();
                    result.input.file = this.file;
                }
                return result;
            }
        },
        {
            key: "fromOffset",
            value: function fromOffset(offset) {
                var lastLine, lineToIndex;
                if (!this[$688c45e47c68b1c4$var$fromOffsetCache]) {
                    var lines = this.css.split("\n");
                    lineToIndex = new Array(lines.length);
                    var prevIndex = 0;
                    for(var i = 0, l = lines.length; i < l; i++){
                        lineToIndex[i] = prevIndex;
                        prevIndex += lines[i].length + 1;
                    }
                    this[$688c45e47c68b1c4$var$fromOffsetCache] = lineToIndex;
                } else lineToIndex = this[$688c45e47c68b1c4$var$fromOffsetCache];
                lastLine = lineToIndex[lineToIndex.length - 1];
                var min = 0;
                if (offset >= lastLine) min = lineToIndex.length - 1;
                else {
                    var max = lineToIndex.length - 2;
                    var mid;
                    while(min < max){
                        mid = min + (max - min >> 1);
                        if (offset < lineToIndex[mid]) max = mid - 1;
                        else if (offset >= lineToIndex[mid + 1]) min = mid + 1;
                        else {
                            min = mid;
                            break;
                        }
                    }
                }
                return {
                    col: offset - lineToIndex[min] + 1,
                    line: min + 1
                };
            }
        },
        {
            key: "mapResolve",
            value: function mapResolve(file) {
                if (/^\w+:\/\//.test(file)) return file;
                return $688c45e47c68b1c4$var$resolve(this.map.consumer().sourceRoot || this.map.root || ".", file);
            }
        },
        {
            key: "origin",
            value: function origin(line, column, endLine, endColumn) {
                if (!this.map) return false;
                var consumer = this.map.consumer();
                var from = consumer.originalPositionFor({
                    column: column,
                    line: line
                });
                if (!from.source) return false;
                var to;
                if (typeof endLine === "number") to = consumer.originalPositionFor({
                    column: endColumn,
                    line: endLine
                });
                var fromUrl;
                if ($688c45e47c68b1c4$var$isAbsolute(from.source)) fromUrl = $688c45e47c68b1c4$var$pathToFileURL(from.source);
                else fromUrl = new URL(from.source, this.map.consumer().sourceRoot || $688c45e47c68b1c4$var$pathToFileURL(this.map.mapFile));
                var result = {
                    column: from.column,
                    endColumn: to && to.column,
                    endLine: to && to.line,
                    line: from.line,
                    url: fromUrl.toString()
                };
                if (fromUrl.protocol === "file:") {
                    if ($688c45e47c68b1c4$var$fileURLToPath) result.file = $688c45e47c68b1c4$var$fileURLToPath(fromUrl);
                    else /* c8 ignore next 2 */ throw new Error("file: protocol is not available in this PostCSS build");
                }
                var source = consumer.sourceContentFor(from.source);
                if (source) result.source = source;
                return result;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var json = {};
                for(var _i = 0, _iter = [
                    "hasBOM",
                    "css",
                    "file",
                    "id"
                ]; _i < _iter.length; _i++){
                    var name = _iter[_i];
                    if (this[name] != null) json[name] = this[name];
                }
                if (this.map) {
                    json.map = (0, $do9pw._)({}, this.map);
                    if (json.map.consumerCache) json.map.consumerCache = undefined;
                }
                return json;
            }
        },
        {
            key: "from",
            get: function get() {
                return this.file || this.id;
            }
        }
    ]);
    return Input;
}();
module.exports = $688c45e47c68b1c4$var$Input;
$688c45e47c68b1c4$var$Input.default = $688c45e47c68b1c4$var$Input;
if ($9dH9K && $9dH9K.registerInput) $9dH9K.registerInput($688c45e47c68b1c4$var$Input);

});
parcelRegister("liEUQ", function(module, exports) {

$parcel$export(module.exports, "nanoid", function () { return $f81b0477d105a024$export$ac4959f4f1338dfc; });
var $f81b0477d105a024$var$urlAlphabet = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
var $f81b0477d105a024$export$62e99e5c9f473d7f = function(alphabet) {
    var defaultSize = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 21;
    return function() {
        var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultSize;
        var id = "";
        var i = size;
        while(i--)id += alphabet[Math.random() * alphabet.length | 0];
        return id;
    };
};
var $f81b0477d105a024$export$ac4959f4f1338dfc = function() {
    var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 21;
    var id = "";
    var i = size;
    while(i--)id += $f81b0477d105a024$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};

});

parcelRegister("lqcup", function(module, exports) {

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $8dlmd = parcelRequire("8dlmd");
var $f985b6d9d306482d$require$Buffer = $8dlmd.Buffer;
"use strict";

var $9dH9K = parcelRequire("9dH9K");
var $f985b6d9d306482d$var$SourceMapConsumer = $9dH9K.SourceMapConsumer, $f985b6d9d306482d$var$SourceMapGenerator = $9dH9K.SourceMapGenerator;

var $9dH9K = parcelRequire("9dH9K");
var $f985b6d9d306482d$var$existsSync = $9dH9K.existsSync, $f985b6d9d306482d$var$readFileSync = $9dH9K.readFileSync;

var $9dH9K = parcelRequire("9dH9K");
var $f985b6d9d306482d$var$dirname = $9dH9K.dirname, $f985b6d9d306482d$var$join = $9dH9K.join;
function $f985b6d9d306482d$var$fromBase64(str) {
    if ($f985b6d9d306482d$require$Buffer) return $f985b6d9d306482d$require$Buffer.from(str, "base64").toString();
    else /* c8 ignore next 2 */ return window.atob(str);
}
var $f985b6d9d306482d$var$PreviousMap = /*#__PURE__*/ function() {
    "use strict";
    function PreviousMap(css, opts) {
        (0, $4GJKx._)(this, PreviousMap);
        if (opts.map === false) return;
        this.loadAnnotation(css);
        this.inline = this.startWith(this.annotation, "data:");
        var prev = opts.map ? opts.map.prev : undefined;
        var text = this.loadMap(opts.from, prev);
        if (!this.mapFile && opts.from) this.mapFile = opts.from;
        if (this.mapFile) this.root = $f985b6d9d306482d$var$dirname(this.mapFile);
        if (text) this.text = text;
    }
    (0, $1wc17._)(PreviousMap, [
        {
            key: "consumer",
            value: function consumer() {
                if (!this.consumerCache) this.consumerCache = new $f985b6d9d306482d$var$SourceMapConsumer(this.text);
                return this.consumerCache;
            }
        },
        {
            key: "decodeInline",
            value: function decodeInline(text) {
                var baseCharsetUri = /^data:application\/json;charset=utf-?8;base64,/;
                var baseUri = /^data:application\/json;base64,/;
                var charsetUri = /^data:application\/json;charset=utf-?8,/;
                var uri = /^data:application\/json,/;
                if (charsetUri.test(text) || uri.test(text)) return decodeURIComponent(text.substr(RegExp.lastMatch.length));
                if (baseCharsetUri.test(text) || baseUri.test(text)) return $f985b6d9d306482d$var$fromBase64(text.substr(RegExp.lastMatch.length));
                var encoding = text.match(/data:application\/json;([^,]+),/)[1];
                throw new Error("Unsupported source map encoding " + encoding);
            }
        },
        {
            key: "getAnnotationURL",
            value: function getAnnotationURL(sourceMapString) {
                return sourceMapString.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
            }
        },
        {
            key: "isMap",
            value: function isMap(map) {
                if (typeof map !== "object") return false;
                return typeof map.mappings === "string" || typeof map._mappings === "string" || Array.isArray(map.sections);
            }
        },
        {
            key: "loadAnnotation",
            value: function loadAnnotation(css) {
                var comments = css.match(/\/\*\s*# sourceMappingURL=/gm);
                if (!comments) return;
                // sourceMappingURLs from comments, strings, etc.
                var start = css.lastIndexOf(comments.pop());
                var end = css.indexOf("*/", start);
                if (start > -1 && end > -1) // Locate the last sourceMappingURL to avoid pickin
                this.annotation = this.getAnnotationURL(css.substring(start, end));
            }
        },
        {
            key: "loadFile",
            value: function loadFile(path) {
                this.root = $f985b6d9d306482d$var$dirname(path);
                if ($f985b6d9d306482d$var$existsSync(path)) {
                    this.mapFile = path;
                    return $f985b6d9d306482d$var$readFileSync(path, "utf-8").toString().trim();
                }
            }
        },
        {
            key: "loadMap",
            value: function loadMap(file, prev) {
                if (prev === false) return false;
                if (prev) {
                    if (typeof prev === "string") return prev;
                    else if (typeof prev === "function") {
                        var prevPath = prev(file);
                        if (prevPath) {
                            var map = this.loadFile(prevPath);
                            if (!map) throw new Error("Unable to load previous source map: " + prevPath.toString());
                            return map;
                        }
                    } else if (prev instanceof $f985b6d9d306482d$var$SourceMapConsumer) return $f985b6d9d306482d$var$SourceMapGenerator.fromSourceMap(prev).toString();
                    else if (prev instanceof $f985b6d9d306482d$var$SourceMapGenerator) return prev.toString();
                    else if (this.isMap(prev)) return JSON.stringify(prev);
                    else throw new Error("Unsupported previous source map format: " + prev.toString());
                } else if (this.inline) return this.decodeInline(this.annotation);
                else if (this.annotation) {
                    var map1 = this.annotation;
                    if (file) map1 = $f985b6d9d306482d$var$join($f985b6d9d306482d$var$dirname(file), map1);
                    return this.loadFile(map1);
                }
            }
        },
        {
            key: "startWith",
            value: function startWith(string, start) {
                if (!string) return false;
                return string.substr(0, start.length) === start;
            }
        },
        {
            key: "withContent",
            value: function withContent() {
                return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
            }
        }
    ]);
    return PreviousMap;
}();
module.exports = $f985b6d9d306482d$var$PreviousMap;
$f985b6d9d306482d$var$PreviousMap.default = $f985b6d9d306482d$var$PreviousMap;

});



parcelRegister("jF4Xc", function(module, exports) {

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $04RAu = parcelRequire("04RAu");

var $b8Rim = parcelRequire("b8Rim");

var $dcsZi = parcelRequire("dcsZi");

var $c6Xmf = parcelRequire("c6Xmf");

var $FuVm8 = parcelRequire("FuVm8");

var $ohfOJ = parcelRequire("ohfOJ");
"use strict";

var $8nXrl = parcelRequire("8nXrl");
var $e505b06397bd8261$var$isClean = $8nXrl.isClean, $e505b06397bd8261$var$my = $8nXrl.my;

var $03KO9 = parcelRequire("03KO9");

var $e4Itr = parcelRequire("e4Itr");

var $by0jV = parcelRequire("by0jV");
var $e505b06397bd8261$var$parse, $e505b06397bd8261$var$Rule, $e505b06397bd8261$var$AtRule, $e505b06397bd8261$var$Root;
function $e505b06397bd8261$var$cleanSource(nodes) {
    return nodes.map(function(i) {
        if (i.nodes) i.nodes = $e505b06397bd8261$var$cleanSource(i.nodes);
        delete i.source;
        return i;
    });
}
function $e505b06397bd8261$var$markDirtyUp(node) {
    node[$e505b06397bd8261$var$isClean] = false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (node.proxyOf.nodes) try {
        for(var _iterator = node.proxyOf.nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var i = _step.value;
            $e505b06397bd8261$var$markDirtyUp(i);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
var $e505b06397bd8261$var$Container = /*#__PURE__*/ function(Node) {
    (0, $dcsZi._)(Container, Node);
    var _super = (0, $ohfOJ._)(Container);
    function Container() {
        (0, $4GJKx._)(this, Container);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(Container, [
        {
            key: "append",
            value: function append() {
                for(var _len = arguments.length, children = new Array(_len), _key = 0; _key < _len; _key++){
                    children[_key] = arguments[_key];
                }
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var child = _step.value;
                        var nodes = this.normalize(child, this.last);
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = nodes[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var node = _step1.value;
                                this.proxyOf.nodes.push(node);
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this.markDirty();
                return this;
            }
        },
        {
            key: "cleanRaws",
            value: function cleanRaws(keepBetween) {
                (0, $04RAu._)((0, $b8Rim._)(Container.prototype), "cleanRaws", this).call(this, keepBetween);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (this.nodes) try {
                    for(var _iterator = this.nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var node = _step.value;
                        node.cleanRaws(keepBetween);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "each",
            value: function each(callback) {
                if (!this.proxyOf.nodes) return undefined;
                var iterator = this.getIterator();
                var index, result;
                while(this.indexes[iterator] < this.proxyOf.nodes.length){
                    index = this.indexes[iterator];
                    result = callback(this.proxyOf.nodes[index], index);
                    if (result === false) break;
                    this.indexes[iterator] += 1;
                }
                delete this.indexes[iterator];
                return result;
            }
        },
        {
            key: "every",
            value: function every(condition) {
                return this.nodes.every(condition);
            }
        },
        {
            key: "getIterator",
            value: function getIterator() {
                if (!this.lastEach) this.lastEach = 0;
                if (!this.indexes) this.indexes = {};
                this.lastEach += 1;
                var iterator = this.lastEach;
                this.indexes[iterator] = 0;
                return iterator;
            }
        },
        {
            key: "getProxyProcessor",
            value: function getProxyProcessor() {
                return {
                    get: function(node, prop) {
                        if (prop === "proxyOf") return node;
                        else if (!node[prop]) return node[prop];
                        else if (prop === "each" || typeof prop === "string" && prop.startsWith("walk")) return function() {
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                                args[_key] = arguments[_key];
                            }
                            var _node;
                            return (_node = node)[prop].apply(_node, (0, $c6Xmf._)(args.map(function(i) {
                                if (typeof i === "function") return function(child, index) {
                                    return i(child.toProxy(), index);
                                };
                                else return i;
                            })));
                        };
                        else if (prop === "every" || prop === "some") return function(cb) {
                            return node[prop](function(child) {
                                for(var _len = arguments.length, other = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                                    other[_key - 1] = arguments[_key];
                                }
                                return cb.apply(void 0, [
                                    child.toProxy()
                                ].concat((0, $c6Xmf._)(other)));
                            });
                        };
                        else if (prop === "root") return function() {
                            return node.root().toProxy();
                        };
                        else if (prop === "nodes") return node.nodes.map(function(i) {
                            return i.toProxy();
                        });
                        else if (prop === "first" || prop === "last") return node[prop].toProxy();
                        else return node[prop];
                    },
                    set: function(node, prop, value) {
                        if (node[prop] === value) return true;
                        node[prop] = value;
                        if (prop === "name" || prop === "params" || prop === "selector") node.markDirty();
                        return true;
                    }
                };
            }
        },
        {
            key: "index",
            value: function index(child) {
                if (typeof child === "number") return child;
                if (child.proxyOf) child = child.proxyOf;
                return this.proxyOf.nodes.indexOf(child);
            }
        },
        {
            key: "insertAfter",
            value: function insertAfter(exist, add) {
                var existIndex = this.index(exist);
                var nodes = this.normalize(add, this.proxyOf.nodes[existIndex]).reverse();
                existIndex = this.index(exist);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var node = _step.value;
                        this.proxyOf.nodes.splice(existIndex + 1, 0, node);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var index;
                for(var id in this.indexes){
                    index = this.indexes[id];
                    if (existIndex < index) this.indexes[id] = index + nodes.length;
                }
                this.markDirty();
                return this;
            }
        },
        {
            key: "insertBefore",
            value: function insertBefore(exist, add) {
                var existIndex = this.index(exist);
                var type = existIndex === 0 ? "prepend" : false;
                var nodes = this.normalize(add, this.proxyOf.nodes[existIndex], type).reverse();
                existIndex = this.index(exist);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var node = _step.value;
                        this.proxyOf.nodes.splice(existIndex, 0, node);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var index;
                for(var id in this.indexes){
                    index = this.indexes[id];
                    if (existIndex <= index) this.indexes[id] = index + nodes.length;
                }
                this.markDirty();
                return this;
            }
        },
        {
            key: "normalize",
            value: function normalize(nodes, sample) {
                var _this = this;
                if (typeof nodes === "string") nodes = $e505b06397bd8261$var$cleanSource($e505b06397bd8261$var$parse(nodes).nodes);
                else if (Array.isArray(nodes)) {
                    nodes = nodes.slice(0);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var i = _step.value;
                            if (i.parent) i.parent.removeChild(i, "ignore");
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                } else if (nodes.type === "root" && this.type !== "document") {
                    nodes = nodes.nodes.slice(0);
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = nodes[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var i1 = _step1.value;
                            if (i1.parent) i1.parent.removeChild(i1, "ignore");
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                } else if (nodes.type) nodes = [
                    nodes
                ];
                else if (nodes.prop) {
                    if (typeof nodes.value === "undefined") throw new Error("Value field is missed in node creation");
                    else if (typeof nodes.value !== "string") nodes.value = String(nodes.value);
                    nodes = [
                        new $03KO9(nodes)
                    ];
                } else if (nodes.selector) nodes = [
                    new $e505b06397bd8261$var$Rule(nodes)
                ];
                else if (nodes.name) nodes = [
                    new $e505b06397bd8261$var$AtRule(nodes)
                ];
                else if (nodes.text) nodes = [
                    new $e4Itr(nodes)
                ];
                else throw new Error("Unknown node type in node creation");
                var processed = nodes.map(function(i) {
                    /* c8 ignore next */ if (!i[$e505b06397bd8261$var$my]) Container.rebuild(i);
                    i = i.proxyOf;
                    if (i.parent) i.parent.removeChild(i);
                    if (i[$e505b06397bd8261$var$isClean]) $e505b06397bd8261$var$markDirtyUp(i);
                    if (typeof i.raws.before === "undefined") {
                        if (sample && typeof sample.raws.before !== "undefined") i.raws.before = sample.raws.before.replace(/\S/g, "");
                    }
                    i.parent = _this.proxyOf;
                    return i;
                });
                return processed;
            }
        },
        {
            key: "prepend",
            value: function prepend() {
                for(var _len = arguments.length, children = new Array(_len), _key = 0; _key < _len; _key++){
                    children[_key] = arguments[_key];
                }
                children = children.reverse();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var child = _step.value;
                        var nodes = this.normalize(child, this.first, "prepend").reverse();
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = nodes[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var node = _step1.value;
                                this.proxyOf.nodes.unshift(node);
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                        for(var id in this.indexes)this.indexes[id] = this.indexes[id] + nodes.length;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this.markDirty();
                return this;
            }
        },
        {
            key: "push",
            value: function push(child) {
                child.parent = this;
                this.proxyOf.nodes.push(child);
                return this;
            }
        },
        {
            key: "removeAll",
            value: function removeAll() {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.proxyOf.nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var node = _step.value;
                        node.parent = undefined;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this.proxyOf.nodes = [];
                this.markDirty();
                return this;
            }
        },
        {
            key: "removeChild",
            value: function removeChild(child) {
                child = this.index(child);
                this.proxyOf.nodes[child].parent = undefined;
                this.proxyOf.nodes.splice(child, 1);
                var index;
                for(var id in this.indexes){
                    index = this.indexes[id];
                    if (index >= child) this.indexes[id] = index - 1;
                }
                this.markDirty();
                return this;
            }
        },
        {
            key: "replaceValues",
            value: function replaceValues(pattern, opts, callback) {
                if (!callback) {
                    callback = opts;
                    opts = {};
                }
                this.walkDecls(function(decl) {
                    if (opts.props && !opts.props.includes(decl.prop)) return;
                    if (opts.fast && !decl.value.includes(opts.fast)) return;
                    decl.value = decl.value.replace(pattern, callback);
                });
                this.markDirty();
                return this;
            }
        },
        {
            key: "some",
            value: function some(condition) {
                return this.nodes.some(condition);
            }
        },
        {
            key: "walk",
            value: function walk(callback) {
                return this.each(function(child, i) {
                    var result;
                    try {
                        result = callback(child, i);
                    } catch (e) {
                        throw child.addToError(e);
                    }
                    if (result !== false && child.walk) result = child.walk(callback);
                    return result;
                });
            }
        },
        {
            key: "walkAtRules",
            value: function walkAtRules(name, callback) {
                if (!callback) {
                    callback = name;
                    return this.walk(function(child, i) {
                        if (child.type === "atrule") return callback(child, i);
                    });
                }
                if (name instanceof RegExp) return this.walk(function(child, i) {
                    if (child.type === "atrule" && name.test(child.name)) return callback(child, i);
                });
                return this.walk(function(child, i) {
                    if (child.type === "atrule" && child.name === name) return callback(child, i);
                });
            }
        },
        {
            key: "walkComments",
            value: function walkComments(callback) {
                return this.walk(function(child, i) {
                    if (child.type === "comment") return callback(child, i);
                });
            }
        },
        {
            key: "walkDecls",
            value: function walkDecls(prop, callback) {
                if (!callback) {
                    callback = prop;
                    return this.walk(function(child, i) {
                        if (child.type === "decl") return callback(child, i);
                    });
                }
                if (prop instanceof RegExp) return this.walk(function(child, i) {
                    if (child.type === "decl" && prop.test(child.prop)) return callback(child, i);
                });
                return this.walk(function(child, i) {
                    if (child.type === "decl" && child.prop === prop) return callback(child, i);
                });
            }
        },
        {
            key: "walkRules",
            value: function walkRules(selector, callback) {
                if (!callback) {
                    callback = selector;
                    return this.walk(function(child, i) {
                        if (child.type === "rule") return callback(child, i);
                    });
                }
                if (selector instanceof RegExp) return this.walk(function(child, i) {
                    if (child.type === "rule" && selector.test(child.selector)) return callback(child, i);
                });
                return this.walk(function(child, i) {
                    if (child.type === "rule" && child.selector === selector) return callback(child, i);
                });
            }
        },
        {
            key: "first",
            get: function get() {
                if (!this.proxyOf.nodes) return undefined;
                return this.proxyOf.nodes[0];
            }
        },
        {
            key: "last",
            get: function get() {
                if (!this.proxyOf.nodes) return undefined;
                return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
            }
        }
    ]);
    return Container;
}((0, $FuVm8._)($by0jV));
$e505b06397bd8261$var$Container.registerParse = function(dependant) {
    $e505b06397bd8261$var$parse = dependant;
};
$e505b06397bd8261$var$Container.registerRule = function(dependant) {
    $e505b06397bd8261$var$Rule = dependant;
};
$e505b06397bd8261$var$Container.registerAtRule = function(dependant) {
    $e505b06397bd8261$var$AtRule = dependant;
};
$e505b06397bd8261$var$Container.registerRoot = function(dependant) {
    $e505b06397bd8261$var$Root = dependant;
};
module.exports = $e505b06397bd8261$var$Container;
$e505b06397bd8261$var$Container.default = $e505b06397bd8261$var$Container;
/* c8 ignore start */ $e505b06397bd8261$var$Container.rebuild = function(node) {
    if (node.type === "atrule") Object.setPrototypeOf(node, $e505b06397bd8261$var$AtRule.prototype);
    else if (node.type === "rule") Object.setPrototypeOf(node, $e505b06397bd8261$var$Rule.prototype);
    else if (node.type === "decl") Object.setPrototypeOf(node, $03KO9.prototype);
    else if (node.type === "comment") Object.setPrototypeOf(node, $e4Itr.prototype);
    else if (node.type === "root") Object.setPrototypeOf(node, $e505b06397bd8261$var$Root.prototype);
    node[$e505b06397bd8261$var$my] = true;
    if (node.nodes) node.nodes.forEach(function(child) {
        $e505b06397bd8261$var$Container.rebuild(child);
    });
} /* c8 ignore stop */ ;

});
parcelRegister("e4Itr", function(module, exports) {

var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $FuVm8 = parcelRequire("FuVm8");

var $ohfOJ = parcelRequire("ohfOJ");
"use strict";

var $by0jV = parcelRequire("by0jV");
var $a3f3eff8f0e2f0d5$var$Comment = /*#__PURE__*/ function(Node) {
    (0, $dcsZi._)(Comment, Node);
    var _super = (0, $ohfOJ._)(Comment);
    function Comment(defaults) {
        (0, $4GJKx._)(this, Comment);
        var _this;
        _this = _super.call(this, defaults);
        _this.type = "comment";
        return _this;
    }
    return Comment;
}((0, $FuVm8._)($by0jV));
module.exports = $a3f3eff8f0e2f0d5$var$Comment;
$a3f3eff8f0e2f0d5$var$Comment.default = $a3f3eff8f0e2f0d5$var$Comment;

});


parcelRegister("bgmOa", function(module, exports) {

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $do9pw = parcelRequire("do9pw");

var $ohfOJ = parcelRequire("ohfOJ");
"use strict";

var $jF4Xc = parcelRequire("jF4Xc");
var $8332e193ab263d22$var$LazyResult, $8332e193ab263d22$var$Processor;
var $8332e193ab263d22$var$Document = /*#__PURE__*/ function(Container) {
    (0, $dcsZi._)(Document, Container);
    var _super = (0, $ohfOJ._)(Document);
    function Document(defaults) {
        (0, $4GJKx._)(this, Document);
        var _this;
        // type needs to be passed to super, otherwise child roots won't be normalized correctly
        _this = _super.call(this, (0, $do9pw._)({
            type: "document"
        }, defaults));
        if (!_this.nodes) _this.nodes = [];
        return _this;
    }
    (0, $1wc17._)(Document, [
        {
            key: "toResult",
            value: function toResult() {
                var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var lazy = new $8332e193ab263d22$var$LazyResult(new $8332e193ab263d22$var$Processor(), this, opts);
                return lazy.stringify();
            }
        }
    ]);
    return Document;
}($jF4Xc);
$8332e193ab263d22$var$Document.registerLazyResult = function(dependant) {
    $8332e193ab263d22$var$LazyResult = dependant;
};
$8332e193ab263d22$var$Document.registerProcessor = function(dependant) {
    $8332e193ab263d22$var$Processor = dependant;
};
module.exports = $8332e193ab263d22$var$Document;
$8332e193ab263d22$var$Document.default = $8332e193ab263d22$var$Document;

});

parcelRegister("iIBit", function(module, exports) {
/* eslint-disable no-console */ "use strict";
var $da0944729d08ace6$var$printed = {};
module.exports = function warnOnce(message) {
    if ($da0944729d08ace6$var$printed[message]) return;
    $da0944729d08ace6$var$printed[message] = true;
    if (typeof console !== "undefined" && console.warn) console.warn(message);
};

});

parcelRegister("2crP5", function(module, exports) {

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");
"use strict";

var $6Klzj = parcelRequire("6Klzj");
var $19a248d9234cfe8a$var$Result = /*#__PURE__*/ function() {
    function Result(processor, root, opts) {
        (0, $4GJKx._)(this, Result);
        this.processor = processor;
        this.messages = [];
        this.root = root;
        this.opts = opts;
        this.css = undefined;
        this.map = undefined;
    }
    (0, $1wc17._)(Result, [
        {
            key: "toString",
            value: function toString() {
                return this.css;
            }
        },
        {
            key: "warn",
            value: function warn(text) {
                var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                if (!opts.plugin) {
                    if (this.lastPlugin && this.lastPlugin.postcssPlugin) opts.plugin = this.lastPlugin.postcssPlugin;
                }
                var warning = new $6Klzj(text, opts);
                this.messages.push(warning);
                return warning;
            }
        },
        {
            key: "warnings",
            value: function warnings() {
                return this.messages.filter(function(i) {
                    return i.type === "warning";
                });
            }
        },
        {
            key: "content",
            get: function get() {
                return this.css;
            }
        }
    ]);
    return Result;
}();
module.exports = $19a248d9234cfe8a$var$Result;
$19a248d9234cfe8a$var$Result.default = $19a248d9234cfe8a$var$Result;

});
parcelRegister("6Klzj", function(module, exports) {

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");
"use strict";
var $4e97c509129bbab3$var$Warning = /*#__PURE__*/ function() {
    function Warning(text) {
        var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $4GJKx._)(this, Warning);
        this.type = "warning";
        this.text = text;
        if (opts.node && opts.node.source) {
            var range = opts.node.rangeBy(opts);
            this.line = range.start.line;
            this.column = range.start.column;
            this.endLine = range.end.line;
            this.endColumn = range.end.column;
        }
        for(var opt in opts)this[opt] = opts[opt];
    }
    (0, $1wc17._)(Warning, [
        {
            key: "toString",
            value: function toString() {
                if (this.node) return this.node.error(this.text, {
                    index: this.index,
                    plugin: this.plugin,
                    word: this.word
                }).message;
                if (this.plugin) return this.plugin + ": " + this.text;
                return this.text;
            }
        }
    ]);
    return Warning;
}();
module.exports = $4e97c509129bbab3$var$Warning;
$4e97c509129bbab3$var$Warning.default = $4e97c509129bbab3$var$Warning;

});


parcelRegister("2DaUH", function(module, exports) {
"use strict";

var $jF4Xc = parcelRequire("jF4Xc");

var $cFEYf = parcelRequire("cFEYf");

var $8YvnY = parcelRequire("8YvnY");
function $1ea7b07d60b30989$var$parse(css, opts) {
    var input = new $8YvnY(css, opts);
    var parser = new $cFEYf(input);
    try {
        parser.parse();
    } catch (e) {
        throw e;
    }
    return parser.root;
}
module.exports = $1ea7b07d60b30989$var$parse;
$1ea7b07d60b30989$var$parse.default = $1ea7b07d60b30989$var$parse;
$jF4Xc.registerParse($1ea7b07d60b30989$var$parse);

});
parcelRegister("cFEYf", function(module, exports) {

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $cv9Rk = parcelRequire("cv9Rk");
"use strict";

var $03KO9 = parcelRequire("03KO9");

var $2Y4XP = parcelRequire("2Y4XP");

var $e4Itr = parcelRequire("e4Itr");

var $3dB8P = parcelRequire("3dB8P");

var $24VdH = parcelRequire("24VdH");

var $3Mwbh = parcelRequire("3Mwbh");
var $93991848b611861e$var$SAFE_COMMENT_NEIGHBOR = {
    empty: true,
    space: true
};
function $93991848b611861e$var$findLastWithPosition(tokens) {
    for(var i = tokens.length - 1; i >= 0; i--){
        var token = tokens[i];
        var pos = token[3] || token[2];
        if (pos) return pos;
    }
}
var $93991848b611861e$var$Parser = /*#__PURE__*/ function() {
    function Parser(input) {
        (0, $4GJKx._)(this, Parser);
        this.input = input;
        this.root = new $24VdH();
        this.current = this.root;
        this.spaces = "";
        this.semicolon = false;
        this.customProperty = false;
        this.createTokenizer();
        this.root.source = {
            input: input,
            start: {
                column: 1,
                line: 1,
                offset: 0
            }
        };
    }
    (0, $1wc17._)(Parser, [
        {
            key: "atrule",
            value: function atrule(token) {
                var node = new $3dB8P();
                node.name = token[1].slice(1);
                if (node.name === "") this.unnamedAtrule(node, token);
                this.init(node, token[2]);
                var type;
                var prev;
                var shift;
                var last = false;
                var open = false;
                var params = [];
                var brackets = [];
                while(!this.tokenizer.endOfFile()){
                    token = this.tokenizer.nextToken();
                    type = token[0];
                    if (type === "(" || type === "[") brackets.push(type === "(" ? ")" : "]");
                    else if (type === "{" && brackets.length > 0) brackets.push("}");
                    else if (type === brackets[brackets.length - 1]) brackets.pop();
                    if (brackets.length === 0) {
                        if (type === ";") {
                            node.source.end = this.getPosition(token[2]);
                            node.source.end.offset++;
                            this.semicolon = true;
                            break;
                        } else if (type === "{") {
                            open = true;
                            break;
                        } else if (type === "}") {
                            if (params.length > 0) {
                                shift = params.length - 1;
                                prev = params[shift];
                                while(prev && prev[0] === "space")prev = params[--shift];
                                if (prev) {
                                    node.source.end = this.getPosition(prev[3] || prev[2]);
                                    node.source.end.offset++;
                                }
                            }
                            this.end(token);
                            break;
                        } else params.push(token);
                    } else params.push(token);
                    if (this.tokenizer.endOfFile()) {
                        last = true;
                        break;
                    }
                }
                node.raws.between = this.spacesAndCommentsFromEnd(params);
                if (params.length) {
                    node.raws.afterName = this.spacesAndCommentsFromStart(params);
                    this.raw(node, "params", params);
                    if (last) {
                        token = params[params.length - 1];
                        node.source.end = this.getPosition(token[3] || token[2]);
                        node.source.end.offset++;
                        this.spaces = node.raws.between;
                        node.raws.between = "";
                    }
                } else {
                    node.raws.afterName = "";
                    node.params = "";
                }
                if (open) {
                    node.nodes = [];
                    this.current = node;
                }
            }
        },
        {
            key: "checkMissedSemicolon",
            value: function checkMissedSemicolon(tokens) {
                var colon = this.colon(tokens);
                if (colon === false) return;
                var founded = 0;
                var token;
                for(var j = colon - 1; j >= 0; j--){
                    token = tokens[j];
                    if (token[0] !== "space") {
                        founded += 1;
                        if (founded === 2) break;
                    }
                }
                // If the token is a word, e.g. `!important`, `red` or any other valid property's value.
                // Then we need to return the colon after that word token. [3] is the "end" colon of that word.
                // And because we need it after that one we do +1 to get the next one.
                throw this.input.error("Missed semicolon", token[0] === "word" ? token[3] + 1 : token[2]);
            }
        },
        {
            key: "colon",
            value: function colon(tokens) {
                var brackets = 0;
                var token, type, prev;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = tokens.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $cv9Rk._)(_step.value, 2), i = _step_value[0], element = _step_value[1];
                        token = element;
                        type = token[0];
                        if (type === "(") brackets += 1;
                        if (type === ")") brackets -= 1;
                        if (brackets === 0 && type === ":") {
                            if (!prev) this.doubleColon(token);
                            else if (prev[0] === "word" && prev[1] === "progid") continue;
                            else return i;
                        }
                        prev = token;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return false;
            }
        },
        {
            key: "comment",
            value: function comment(token) {
                var node = new $e4Itr();
                this.init(node, token[2]);
                node.source.end = this.getPosition(token[3] || token[2]);
                node.source.end.offset++;
                var text = token[1].slice(2, -2);
                if (/^\s*$/.test(text)) {
                    node.text = "";
                    node.raws.left = text;
                    node.raws.right = "";
                } else {
                    var match = text.match(/^(\s*)([^]*\S)(\s*)$/);
                    node.text = match[2];
                    node.raws.left = match[1];
                    node.raws.right = match[3];
                }
            }
        },
        {
            key: "createTokenizer",
            value: function createTokenizer() {
                this.tokenizer = $2Y4XP(this.input);
            }
        },
        {
            key: "decl",
            value: function decl(tokens, customProperty) {
                var node = new $03KO9();
                this.init(node, tokens[0][2]);
                var last = tokens[tokens.length - 1];
                if (last[0] === ";") {
                    this.semicolon = true;
                    tokens.pop();
                }
                node.source.end = this.getPosition(last[3] || last[2] || $93991848b611861e$var$findLastWithPosition(tokens));
                node.source.end.offset++;
                while(tokens[0][0] !== "word"){
                    if (tokens.length === 1) this.unknownWord(tokens);
                    node.raws.before += tokens.shift()[1];
                }
                node.source.start = this.getPosition(tokens[0][2]);
                node.prop = "";
                while(tokens.length){
                    var type = tokens[0][0];
                    if (type === ":" || type === "space" || type === "comment") break;
                    node.prop += tokens.shift()[1];
                }
                node.raws.between = "";
                var token;
                while(tokens.length){
                    token = tokens.shift();
                    if (token[0] === ":") {
                        node.raws.between += token[1];
                        break;
                    } else {
                        if (token[0] === "word" && /\w/.test(token[1])) this.unknownWord([
                            token
                        ]);
                        node.raws.between += token[1];
                    }
                }
                if (node.prop[0] === "_" || node.prop[0] === "*") {
                    node.raws.before += node.prop[0];
                    node.prop = node.prop.slice(1);
                }
                var firstSpaces = [];
                var next;
                while(tokens.length){
                    next = tokens[0][0];
                    if (next !== "space" && next !== "comment") break;
                    firstSpaces.push(tokens.shift());
                }
                this.precheckMissedSemicolon(tokens);
                for(var i = tokens.length - 1; i >= 0; i--){
                    token = tokens[i];
                    if (token[1].toLowerCase() === "!important") {
                        node.important = true;
                        var string = this.stringFrom(tokens, i);
                        string = this.spacesFromEnd(tokens) + string;
                        if (string !== " !important") node.raws.important = string;
                        break;
                    } else if (token[1].toLowerCase() === "important") {
                        var cache = tokens.slice(0);
                        var str = "";
                        for(var j = i; j > 0; j--){
                            var type1 = cache[j][0];
                            if (str.trim().indexOf("!") === 0 && type1 !== "space") break;
                            str = cache.pop()[1] + str;
                        }
                        if (str.trim().indexOf("!") === 0) {
                            node.important = true;
                            node.raws.important = str;
                            tokens = cache;
                        }
                    }
                    if (token[0] !== "space" && token[0] !== "comment") break;
                }
                var hasWord = tokens.some(function(i) {
                    return i[0] !== "space" && i[0] !== "comment";
                });
                if (hasWord) {
                    node.raws.between += firstSpaces.map(function(i) {
                        return i[1];
                    }).join("");
                    firstSpaces = [];
                }
                this.raw(node, "value", firstSpaces.concat(tokens), customProperty);
                if (node.value.includes(":") && !customProperty) this.checkMissedSemicolon(tokens);
            }
        },
        {
            key: "doubleColon",
            value: function doubleColon(token) {
                throw this.input.error("Double colon", {
                    offset: token[2]
                }, {
                    offset: token[2] + token[1].length
                });
            }
        },
        {
            key: "emptyRule",
            value: function emptyRule(token) {
                var node = new $3Mwbh();
                this.init(node, token[2]);
                node.selector = "";
                node.raws.between = "";
                this.current = node;
            }
        },
        {
            key: "end",
            value: function end(token) {
                if (this.current.nodes && this.current.nodes.length) this.current.raws.semicolon = this.semicolon;
                this.semicolon = false;
                this.current.raws.after = (this.current.raws.after || "") + this.spaces;
                this.spaces = "";
                if (this.current.parent) {
                    this.current.source.end = this.getPosition(token[2]);
                    this.current.source.end.offset++;
                    this.current = this.current.parent;
                } else this.unexpectedClose(token);
            }
        },
        {
            key: "endFile",
            value: function endFile() {
                if (this.current.parent) this.unclosedBlock();
                if (this.current.nodes && this.current.nodes.length) this.current.raws.semicolon = this.semicolon;
                this.current.raws.after = (this.current.raws.after || "") + this.spaces;
                this.root.source.end = this.getPosition(this.tokenizer.position());
            }
        },
        {
            key: "freeSemicolon",
            value: function freeSemicolon(token) {
                this.spaces += token[1];
                if (this.current.nodes) {
                    var prev = this.current.nodes[this.current.nodes.length - 1];
                    if (prev && prev.type === "rule" && !prev.raws.ownSemicolon) {
                        prev.raws.ownSemicolon = this.spaces;
                        this.spaces = "";
                    }
                }
            }
        },
        {
            // Helpers
            key: "getPosition",
            value: function getPosition(offset) {
                var pos = this.input.fromOffset(offset);
                return {
                    column: pos.col,
                    line: pos.line,
                    offset: offset
                };
            }
        },
        {
            key: "init",
            value: function init(node, offset) {
                this.current.push(node);
                node.source = {
                    input: this.input,
                    start: this.getPosition(offset)
                };
                node.raws.before = this.spaces;
                this.spaces = "";
                if (node.type !== "comment") this.semicolon = false;
            }
        },
        {
            key: "other",
            value: function other(start) {
                var end = false;
                var type = null;
                var colon = false;
                var bracket = null;
                var brackets = [];
                var customProperty = start[1].startsWith("--");
                var tokens = [];
                var token = start;
                while(token){
                    type = token[0];
                    tokens.push(token);
                    if (type === "(" || type === "[") {
                        if (!bracket) bracket = token;
                        brackets.push(type === "(" ? ")" : "]");
                    } else if (customProperty && colon && type === "{") {
                        if (!bracket) bracket = token;
                        brackets.push("}");
                    } else if (brackets.length === 0) {
                        if (type === ";") {
                            if (colon) {
                                this.decl(tokens, customProperty);
                                return;
                            } else break;
                        } else if (type === "{") {
                            this.rule(tokens);
                            return;
                        } else if (type === "}") {
                            this.tokenizer.back(tokens.pop());
                            end = true;
                            break;
                        } else if (type === ":") colon = true;
                    } else if (type === brackets[brackets.length - 1]) {
                        brackets.pop();
                        if (brackets.length === 0) bracket = null;
                    }
                    token = this.tokenizer.nextToken();
                }
                if (this.tokenizer.endOfFile()) end = true;
                if (brackets.length > 0) this.unclosedBracket(bracket);
                if (end && colon) {
                    if (!customProperty) while(tokens.length){
                        token = tokens[tokens.length - 1][0];
                        if (token !== "space" && token !== "comment") break;
                        this.tokenizer.back(tokens.pop());
                    }
                    this.decl(tokens, customProperty);
                } else this.unknownWord(tokens);
            }
        },
        {
            key: "parse",
            value: function parse() {
                var token;
                while(!this.tokenizer.endOfFile()){
                    token = this.tokenizer.nextToken();
                    switch(token[0]){
                        case "space":
                            this.spaces += token[1];
                            break;
                        case ";":
                            this.freeSemicolon(token);
                            break;
                        case "}":
                            this.end(token);
                            break;
                        case "comment":
                            this.comment(token);
                            break;
                        case "at-word":
                            this.atrule(token);
                            break;
                        case "{":
                            this.emptyRule(token);
                            break;
                        default:
                            this.other(token);
                            break;
                    }
                }
                this.endFile();
            }
        },
        {
            key: "precheckMissedSemicolon",
            value: function precheckMissedSemicolon() {
            // Hook for Safe Parser
            }
        },
        {
            key: "raw",
            value: function raw(node, prop, tokens, customProperty) {
                var token, type;
                var length = tokens.length;
                var value = "";
                var clean = true;
                var next, prev;
                for(var i = 0; i < length; i += 1){
                    token = tokens[i];
                    type = token[0];
                    if (type === "space" && i === length - 1 && !customProperty) clean = false;
                    else if (type === "comment") {
                        prev = tokens[i - 1] ? tokens[i - 1][0] : "empty";
                        next = tokens[i + 1] ? tokens[i + 1][0] : "empty";
                        if (!$93991848b611861e$var$SAFE_COMMENT_NEIGHBOR[prev] && !$93991848b611861e$var$SAFE_COMMENT_NEIGHBOR[next]) {
                            if (value.slice(-1) === ",") clean = false;
                            else value += token[1];
                        } else clean = false;
                    } else value += token[1];
                }
                if (!clean) {
                    var raw = tokens.reduce(function(all, i) {
                        return all + i[1];
                    }, "");
                    node.raws[prop] = {
                        raw: raw,
                        value: value
                    };
                }
                node[prop] = value;
            }
        },
        {
            key: "rule",
            value: function rule(tokens) {
                tokens.pop();
                var node = new $3Mwbh();
                this.init(node, tokens[0][2]);
                node.raws.between = this.spacesAndCommentsFromEnd(tokens);
                this.raw(node, "selector", tokens);
                this.current = node;
            }
        },
        {
            key: "spacesAndCommentsFromEnd",
            value: function spacesAndCommentsFromEnd(tokens) {
                var lastTokenType;
                var spaces = "";
                while(tokens.length){
                    lastTokenType = tokens[tokens.length - 1][0];
                    if (lastTokenType !== "space" && lastTokenType !== "comment") break;
                    spaces = tokens.pop()[1] + spaces;
                }
                return spaces;
            }
        },
        {
            // Errors
            key: "spacesAndCommentsFromStart",
            value: function spacesAndCommentsFromStart(tokens) {
                var next;
                var spaces = "";
                while(tokens.length){
                    next = tokens[0][0];
                    if (next !== "space" && next !== "comment") break;
                    spaces += tokens.shift()[1];
                }
                return spaces;
            }
        },
        {
            key: "spacesFromEnd",
            value: function spacesFromEnd(tokens) {
                var lastTokenType;
                var spaces = "";
                while(tokens.length){
                    lastTokenType = tokens[tokens.length - 1][0];
                    if (lastTokenType !== "space") break;
                    spaces = tokens.pop()[1] + spaces;
                }
                return spaces;
            }
        },
        {
            key: "stringFrom",
            value: function stringFrom(tokens, from) {
                var result = "";
                for(var i = from; i < tokens.length; i++)result += tokens[i][1];
                tokens.splice(from, tokens.length - from);
                return result;
            }
        },
        {
            key: "unclosedBlock",
            value: function unclosedBlock() {
                var pos = this.current.source.start;
                throw this.input.error("Unclosed block", pos.line, pos.column);
            }
        },
        {
            key: "unclosedBracket",
            value: function unclosedBracket(bracket) {
                throw this.input.error("Unclosed bracket", {
                    offset: bracket[2]
                }, {
                    offset: bracket[2] + 1
                });
            }
        },
        {
            key: "unexpectedClose",
            value: function unexpectedClose(token) {
                throw this.input.error("Unexpected }", {
                    offset: token[2]
                }, {
                    offset: token[2] + 1
                });
            }
        },
        {
            key: "unknownWord",
            value: function unknownWord(tokens) {
                throw this.input.error("Unknown word", {
                    offset: tokens[0][2]
                }, {
                    offset: tokens[0][2] + tokens[0][1].length
                });
            }
        },
        {
            key: "unnamedAtrule",
            value: function unnamedAtrule(node, token) {
                throw this.input.error("At-rule without name", {
                    offset: token[2]
                }, {
                    offset: token[2] + token[1].length
                });
            }
        }
    ]);
    return Parser;
}();
module.exports = $93991848b611861e$var$Parser;

});
parcelRegister("2Y4XP", function(module, exports) {
"use strict";
var $22950917518c43e6$var$SINGLE_QUOTE = "'".charCodeAt(0);
var $22950917518c43e6$var$DOUBLE_QUOTE = '"'.charCodeAt(0);
var $22950917518c43e6$var$BACKSLASH = "\\".charCodeAt(0);
var $22950917518c43e6$var$SLASH = "/".charCodeAt(0);
var $22950917518c43e6$var$NEWLINE = "\n".charCodeAt(0);
var $22950917518c43e6$var$SPACE = " ".charCodeAt(0);
var $22950917518c43e6$var$FEED = "\f".charCodeAt(0);
var $22950917518c43e6$var$TAB = "	".charCodeAt(0);
var $22950917518c43e6$var$CR = "\r".charCodeAt(0);
var $22950917518c43e6$var$OPEN_SQUARE = "[".charCodeAt(0);
var $22950917518c43e6$var$CLOSE_SQUARE = "]".charCodeAt(0);
var $22950917518c43e6$var$OPEN_PARENTHESES = "(".charCodeAt(0);
var $22950917518c43e6$var$CLOSE_PARENTHESES = ")".charCodeAt(0);
var $22950917518c43e6$var$OPEN_CURLY = "{".charCodeAt(0);
var $22950917518c43e6$var$CLOSE_CURLY = "}".charCodeAt(0);
var $22950917518c43e6$var$SEMICOLON = ";".charCodeAt(0);
var $22950917518c43e6$var$ASTERISK = "*".charCodeAt(0);
var $22950917518c43e6$var$COLON = ":".charCodeAt(0);
var $22950917518c43e6$var$AT = "@".charCodeAt(0);
var $22950917518c43e6$var$RE_AT_END = /[\t\n\f\r "#'()/;[\\\]{}]/g;
var $22950917518c43e6$var$RE_WORD_END = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g;
var $22950917518c43e6$var$RE_BAD_BRACKET = /.[\r\n"'(/\\]/;
var $22950917518c43e6$var$RE_HEX_ESCAPE = /[\da-f]/i;
module.exports = function tokenizer(input) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var css = input.css.valueOf();
    var ignore = options.ignoreErrors;
    var code, next, quote, content, escape;
    var escaped, escapePos, prev, n, currentToken;
    var length = css.length;
    var pos = 0;
    var buffer = [];
    var returned = [];
    function position() {
        return pos;
    }
    function unclosed(what) {
        throw input.error("Unclosed " + what, pos);
    }
    function endOfFile() {
        return returned.length === 0 && pos >= length;
    }
    function nextToken(opts) {
        if (returned.length) return returned.pop();
        if (pos >= length) return;
        var ignoreUnclosed = opts ? opts.ignoreUnclosed : false;
        code = css.charCodeAt(pos);
        switch(code){
            case $22950917518c43e6$var$NEWLINE:
            case $22950917518c43e6$var$SPACE:
            case $22950917518c43e6$var$TAB:
            case $22950917518c43e6$var$CR:
            case $22950917518c43e6$var$FEED:
                next = pos;
                do {
                    next += 1;
                    code = css.charCodeAt(next);
                }while (code === $22950917518c43e6$var$SPACE || code === $22950917518c43e6$var$NEWLINE || code === $22950917518c43e6$var$TAB || code === $22950917518c43e6$var$CR || code === $22950917518c43e6$var$FEED);
                currentToken = [
                    "space",
                    css.slice(pos, next)
                ];
                pos = next - 1;
                break;
            case $22950917518c43e6$var$OPEN_SQUARE:
            case $22950917518c43e6$var$CLOSE_SQUARE:
            case $22950917518c43e6$var$OPEN_CURLY:
            case $22950917518c43e6$var$CLOSE_CURLY:
            case $22950917518c43e6$var$COLON:
            case $22950917518c43e6$var$SEMICOLON:
            case $22950917518c43e6$var$CLOSE_PARENTHESES:
                {
                    var controlChar = String.fromCharCode(code);
                    currentToken = [
                        controlChar,
                        controlChar,
                        pos
                    ];
                    break;
                }
            case $22950917518c43e6$var$OPEN_PARENTHESES:
                prev = buffer.length ? buffer.pop()[1] : "";
                n = css.charCodeAt(pos + 1);
                if (prev === "url" && n !== $22950917518c43e6$var$SINGLE_QUOTE && n !== $22950917518c43e6$var$DOUBLE_QUOTE && n !== $22950917518c43e6$var$SPACE && n !== $22950917518c43e6$var$NEWLINE && n !== $22950917518c43e6$var$TAB && n !== $22950917518c43e6$var$FEED && n !== $22950917518c43e6$var$CR) {
                    next = pos;
                    do {
                        escaped = false;
                        next = css.indexOf(")", next + 1);
                        if (next === -1) {
                            if (ignore || ignoreUnclosed) {
                                next = pos;
                                break;
                            } else unclosed("bracket");
                        }
                        escapePos = next;
                        while(css.charCodeAt(escapePos - 1) === $22950917518c43e6$var$BACKSLASH){
                            escapePos -= 1;
                            escaped = !escaped;
                        }
                    }while (escaped);
                    currentToken = [
                        "brackets",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    pos = next;
                } else {
                    next = css.indexOf(")", pos + 1);
                    content = css.slice(pos, next + 1);
                    if (next === -1 || $22950917518c43e6$var$RE_BAD_BRACKET.test(content)) currentToken = [
                        "(",
                        "(",
                        pos
                    ];
                    else {
                        currentToken = [
                            "brackets",
                            content,
                            pos,
                            next
                        ];
                        pos = next;
                    }
                }
                break;
            case $22950917518c43e6$var$SINGLE_QUOTE:
            case $22950917518c43e6$var$DOUBLE_QUOTE:
                quote = code === $22950917518c43e6$var$SINGLE_QUOTE ? "'" : '"';
                next = pos;
                do {
                    escaped = false;
                    next = css.indexOf(quote, next + 1);
                    if (next === -1) {
                        if (ignore || ignoreUnclosed) {
                            next = pos + 1;
                            break;
                        } else unclosed("string");
                    }
                    escapePos = next;
                    while(css.charCodeAt(escapePos - 1) === $22950917518c43e6$var$BACKSLASH){
                        escapePos -= 1;
                        escaped = !escaped;
                    }
                }while (escaped);
                currentToken = [
                    "string",
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            case $22950917518c43e6$var$AT:
                $22950917518c43e6$var$RE_AT_END.lastIndex = pos + 1;
                $22950917518c43e6$var$RE_AT_END.test(css);
                if ($22950917518c43e6$var$RE_AT_END.lastIndex === 0) next = css.length - 1;
                else next = $22950917518c43e6$var$RE_AT_END.lastIndex - 2;
                currentToken = [
                    "at-word",
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            case $22950917518c43e6$var$BACKSLASH:
                next = pos;
                escape = true;
                while(css.charCodeAt(next + 1) === $22950917518c43e6$var$BACKSLASH){
                    next += 1;
                    escape = !escape;
                }
                code = css.charCodeAt(next + 1);
                if (escape && code !== $22950917518c43e6$var$SLASH && code !== $22950917518c43e6$var$SPACE && code !== $22950917518c43e6$var$NEWLINE && code !== $22950917518c43e6$var$TAB && code !== $22950917518c43e6$var$CR && code !== $22950917518c43e6$var$FEED) {
                    next += 1;
                    if ($22950917518c43e6$var$RE_HEX_ESCAPE.test(css.charAt(next))) {
                        while($22950917518c43e6$var$RE_HEX_ESCAPE.test(css.charAt(next + 1)))next += 1;
                        if (css.charCodeAt(next + 1) === $22950917518c43e6$var$SPACE) next += 1;
                    }
                }
                currentToken = [
                    "word",
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            default:
                if (code === $22950917518c43e6$var$SLASH && css.charCodeAt(pos + 1) === $22950917518c43e6$var$ASTERISK) {
                    next = css.indexOf("*/", pos + 2) + 1;
                    if (next === 0) {
                        if (ignore || ignoreUnclosed) next = css.length;
                        else unclosed("comment");
                    }
                    currentToken = [
                        "comment",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    pos = next;
                } else {
                    $22950917518c43e6$var$RE_WORD_END.lastIndex = pos + 1;
                    $22950917518c43e6$var$RE_WORD_END.test(css);
                    if ($22950917518c43e6$var$RE_WORD_END.lastIndex === 0) next = css.length - 1;
                    else next = $22950917518c43e6$var$RE_WORD_END.lastIndex - 2;
                    currentToken = [
                        "word",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    buffer.push(currentToken);
                    pos = next;
                }
                break;
        }
        pos++;
        return currentToken;
    }
    function back(token) {
        returned.push(token);
    }
    return {
        back: back,
        endOfFile: endOfFile,
        nextToken: nextToken,
        position: position
    };
};

});

parcelRegister("3dB8P", function(module, exports) {

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $04RAu = parcelRequire("04RAu");

var $b8Rim = parcelRequire("b8Rim");

var $dcsZi = parcelRequire("dcsZi");

var $c6Xmf = parcelRequire("c6Xmf");

var $ohfOJ = parcelRequire("ohfOJ");
"use strict";

var $jF4Xc = parcelRequire("jF4Xc");
var $257f657d7b4091d9$var$AtRule = /*#__PURE__*/ function(Container) {
    (0, $dcsZi._)(AtRule, Container);
    var _super = (0, $ohfOJ._)(AtRule);
    function AtRule(defaults) {
        (0, $4GJKx._)(this, AtRule);
        var _this;
        _this = _super.call(this, defaults);
        _this.type = "atrule";
        return _this;
    }
    (0, $1wc17._)(AtRule, [
        {
            key: "append",
            value: function append() {
                for(var _len = arguments.length, children = new Array(_len), _key = 0; _key < _len; _key++){
                    children[_key] = arguments[_key];
                }
                var _$_get;
                if (!this.proxyOf.nodes) this.nodes = [];
                return (_$_get = (0, $04RAu._)((0, $b8Rim._)(AtRule.prototype), "append", this)).call.apply(_$_get, [
                    this
                ].concat((0, $c6Xmf._)(children)));
            }
        },
        {
            key: "prepend",
            value: function prepend() {
                for(var _len = arguments.length, children = new Array(_len), _key = 0; _key < _len; _key++){
                    children[_key] = arguments[_key];
                }
                var _$_get;
                if (!this.proxyOf.nodes) this.nodes = [];
                return (_$_get = (0, $04RAu._)((0, $b8Rim._)(AtRule.prototype), "prepend", this)).call.apply(_$_get, [
                    this
                ].concat((0, $c6Xmf._)(children)));
            }
        }
    ]);
    return AtRule;
}($jF4Xc);
module.exports = $257f657d7b4091d9$var$AtRule;
$257f657d7b4091d9$var$AtRule.default = $257f657d7b4091d9$var$AtRule;
$jF4Xc.registerAtRule($257f657d7b4091d9$var$AtRule);

});

parcelRegister("24VdH", function(module, exports) {

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $04RAu = parcelRequire("04RAu");

var $b8Rim = parcelRequire("b8Rim");

var $dcsZi = parcelRequire("dcsZi");

var $ohfOJ = parcelRequire("ohfOJ");
"use strict";

var $jF4Xc = parcelRequire("jF4Xc");
var $183857311b7b4919$var$LazyResult, $183857311b7b4919$var$Processor;
var $183857311b7b4919$var$Root = /*#__PURE__*/ function(Container) {
    (0, $dcsZi._)(Root, Container);
    var _super = (0, $ohfOJ._)(Root);
    function Root(defaults) {
        (0, $4GJKx._)(this, Root);
        var _this;
        _this = _super.call(this, defaults);
        _this.type = "root";
        if (!_this.nodes) _this.nodes = [];
        return _this;
    }
    (0, $1wc17._)(Root, [
        {
            key: "normalize",
            value: function normalize(child, sample, type) {
                var nodes = (0, $04RAu._)((0, $b8Rim._)(Root.prototype), "normalize", this).call(this, child);
                if (sample) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    if (type === "prepend") {
                        if (this.nodes.length > 1) sample.raws.before = this.nodes[1].raws.before;
                        else delete sample.raws.before;
                    } else if (this.first !== sample) try {
                        for(var _iterator = nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var node = _step.value;
                            node.raws.before = sample.raws.before;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                return nodes;
            }
        },
        {
            key: "removeChild",
            value: function removeChild(child, ignore) {
                var index = this.index(child);
                if (!ignore && index === 0 && this.nodes.length > 1) this.nodes[1].raws.before = this.nodes[index].raws.before;
                return (0, $04RAu._)((0, $b8Rim._)(Root.prototype), "removeChild", this).call(this, child);
            }
        },
        {
            key: "toResult",
            value: function toResult() {
                var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var lazy = new $183857311b7b4919$var$LazyResult(new $183857311b7b4919$var$Processor(), this, opts);
                return lazy.stringify();
            }
        }
    ]);
    return Root;
}($jF4Xc);
$183857311b7b4919$var$Root.registerLazyResult = function(dependant) {
    $183857311b7b4919$var$LazyResult = dependant;
};
$183857311b7b4919$var$Root.registerProcessor = function(dependant) {
    $183857311b7b4919$var$Processor = dependant;
};
module.exports = $183857311b7b4919$var$Root;
$183857311b7b4919$var$Root.default = $183857311b7b4919$var$Root;
$jF4Xc.registerRoot($183857311b7b4919$var$Root);

});

parcelRegister("3Mwbh", function(module, exports) {

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $ohfOJ = parcelRequire("ohfOJ");
"use strict";

var $jF4Xc = parcelRequire("jF4Xc");

var $lEiGF = parcelRequire("lEiGF");
var $2c0ed1481e388abe$var$Rule = /*#__PURE__*/ function(Container) {
    (0, $dcsZi._)(Rule, Container);
    var _super = (0, $ohfOJ._)(Rule);
    function Rule(defaults) {
        (0, $4GJKx._)(this, Rule);
        var _this;
        _this = _super.call(this, defaults);
        _this.type = "rule";
        if (!_this.nodes) _this.nodes = [];
        return _this;
    }
    (0, $1wc17._)(Rule, [
        {
            key: "selectors",
            get: function get() {
                return $lEiGF.comma(this.selector);
            },
            set: function set(values) {
                var match = this.selector ? this.selector.match(/,\s*/) : null;
                var sep = match ? match[0] : "," + this.raw("between", "beforeOpen");
                this.selector = values.join(sep);
            }
        }
    ]);
    return Rule;
}($jF4Xc);
module.exports = $2c0ed1481e388abe$var$Rule;
$2c0ed1481e388abe$var$Rule.default = $2c0ed1481e388abe$var$Rule;
$jF4Xc.registerRule($2c0ed1481e388abe$var$Rule);

});
parcelRegister("lEiGF", function(module, exports) {
"use strict";
var $fc2bd444752a7a8f$var$list = {
    comma: function(string) {
        return $fc2bd444752a7a8f$var$list.split(string, [
            ","
        ], true);
    },
    space: function(string) {
        var spaces = [
            " ",
            "\n",
            "	"
        ];
        return $fc2bd444752a7a8f$var$list.split(string, spaces);
    },
    split: function(string, separators, last) {
        var array = [];
        var current = "";
        var split = false;
        var func = 0;
        var inQuote = false;
        var prevQuote = "";
        var escape = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = string[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var letter = _step.value;
                if (escape) escape = false;
                else if (letter === "\\") escape = true;
                else if (inQuote) {
                    if (letter === prevQuote) inQuote = false;
                } else if (letter === '"' || letter === "'") {
                    inQuote = true;
                    prevQuote = letter;
                } else if (letter === "(") func += 1;
                else if (letter === ")") {
                    if (func > 0) func -= 1;
                } else if (func === 0) {
                    if (separators.includes(letter)) split = true;
                }
                if (split) {
                    if (current !== "") array.push(current.trim());
                    current = "";
                    split = false;
                } else current += letter;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (last || current !== "") array.push(current.trim());
        return array;
    }
};
module.exports = $fc2bd444752a7a8f$var$list;
$fc2bd444752a7a8f$var$list.default = $fc2bd444752a7a8f$var$list;

});





parcelRegister("1yJt7", function(module, exports) {

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");
"use strict";

var $7hWoi = parcelRequire("7hWoi");

var $7Phwu = parcelRequire("7Phwu");

var $bgmOa = parcelRequire("bgmOa");

var $24VdH = parcelRequire("24VdH");
var $122c3c8c7eb7dbf4$var$Processor = /*#__PURE__*/ function() {
    function Processor() {
        var plugins = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        (0, $4GJKx._)(this, Processor);
        this.version = "8.4.31";
        this.plugins = this.normalize(plugins);
    }
    (0, $1wc17._)(Processor, [
        {
            key: "normalize",
            value: function normalize(plugins) {
                var normalized = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = plugins[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        if (i.postcss === true) i = i();
                        else if (i.postcss) i = i.postcss;
                        if (typeof i === "object" && Array.isArray(i.plugins)) normalized = normalized.concat(i.plugins);
                        else if (typeof i === "object" && i.postcssPlugin) normalized.push(i);
                        else if (typeof i === "function") normalized.push(i);
                        else if (typeof i === "object" && (i.parse || i.stringify)) ;
                        else throw new Error(i + " is not a PostCSS plugin");
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return normalized;
            }
        },
        {
            key: "process",
            value: function process(css) {
                var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                if (this.plugins.length === 0 && typeof opts.parser === "undefined" && typeof opts.stringifier === "undefined" && typeof opts.syntax === "undefined") return new $7hWoi(this, css, opts);
                else return new $7Phwu(this, css, opts);
            }
        },
        {
            key: "use",
            value: function use(plugin) {
                this.plugins = this.plugins.concat(this.normalize([
                    plugin
                ]));
                return this;
            }
        }
    ]);
    return Processor;
}();
module.exports = $122c3c8c7eb7dbf4$var$Processor;
$122c3c8c7eb7dbf4$var$Processor.default = $122c3c8c7eb7dbf4$var$Processor;
$24VdH.registerProcessor($122c3c8c7eb7dbf4$var$Processor);
$bgmOa.registerProcessor($122c3c8c7eb7dbf4$var$Processor);

});
parcelRegister("7hWoi", function(module, exports) {

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $cv9Rk = parcelRequire("cv9Rk");
"use strict";

var $4MNGy = parcelRequire("4MNGy");

var $iQcw1 = parcelRequire("iQcw1");
parcelRequire("iIBit");

var $2DaUH = parcelRequire("2DaUH");

var $2crP5 = parcelRequire("2crP5");
var $54e76a26a29edcd5$var$NoWorkResult = /*#__PURE__*/ function() {
    function NoWorkResult(processor, css, opts) {
        (0, $4GJKx._)(this, NoWorkResult);
        css = css.toString();
        this.stringified = false;
        this._processor = processor;
        this._css = css;
        this._opts = opts;
        this._map = undefined;
        var root;
        var str = $iQcw1;
        this.result = new $2crP5(this._processor, root, this._opts);
        this.result.css = css;
        var self = this;
        Object.defineProperty(this.result, "root", {
            get: function() {
                return self.root;
            }
        });
        var map = new $4MNGy(str, root, this._opts, css);
        if (map.isMap()) {
            var _map_generate = (0, $cv9Rk._)(map.generate(), 2), generatedCSS = _map_generate[0], generatedMap = _map_generate[1];
            if (generatedCSS) this.result.css = generatedCSS;
            if (generatedMap) this.result.map = generatedMap;
        }
    }
    (0, $1wc17._)(NoWorkResult, [
        {
            key: "async",
            value: function async() {
                if (this.error) return Promise.reject(this.error);
                return Promise.resolve(this.result);
            }
        },
        {
            key: "catch",
            value: function _catch(onRejected) {
                return this.async().catch(onRejected);
            }
        },
        {
            key: "finally",
            value: function _finally(onFinally) {
                return this.async().then(onFinally, onFinally);
            }
        },
        {
            key: "sync",
            value: function sync() {
                if (this.error) throw this.error;
                return this.result;
            }
        },
        {
            key: "then",
            value: function then(onFulfilled, onRejected) {
                return this.async().then(onFulfilled, onRejected);
            }
        },
        {
            key: "toString",
            value: function toString() {
                return this._css;
            }
        },
        {
            key: "warnings",
            value: function warnings() {
                return [];
            }
        },
        {
            key: "content",
            get: function get() {
                return this.result.css;
            }
        },
        {
            key: "css",
            get: function get() {
                return this.result.css;
            }
        },
        {
            key: "map",
            get: function get() {
                return this.result.map;
            }
        },
        {
            key: "messages",
            get: function get() {
                return [];
            }
        },
        {
            key: "opts",
            get: function get() {
                return this.result.opts;
            }
        },
        {
            key: "processor",
            get: function get() {
                return this.result.processor;
            }
        },
        {
            key: "root",
            get: function get() {
                if (this._root) return this._root;
                var root;
                var parser = $2DaUH;
                try {
                    root = parser(this._css, this._opts);
                } catch (error) {
                    this.error = error;
                }
                if (this.error) throw this.error;
                else {
                    this._root = root;
                    return root;
                }
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "NoWorkResult";
            }
        }
    ]);
    return NoWorkResult;
}();
module.exports = $54e76a26a29edcd5$var$NoWorkResult;
$54e76a26a29edcd5$var$NoWorkResult.default = $54e76a26a29edcd5$var$NoWorkResult;

});


parcelRegister("cTidF", function(module, exports) {

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $dRLPW = parcelRequire("dRLPW");
"use strict";

var $03KO9 = parcelRequire("03KO9");

var $lqcup = parcelRequire("lqcup");

var $e4Itr = parcelRequire("e4Itr");

var $3dB8P = parcelRequire("3dB8P");

var $8YvnY = parcelRequire("8YvnY");

var $24VdH = parcelRequire("24VdH");

var $3Mwbh = parcelRequire("3Mwbh");
function $9628c11c3cfc2b19$var$fromJSON(json, inputs) {
    if (Array.isArray(json)) return json.map(function(n) {
        return $9628c11c3cfc2b19$var$fromJSON(n);
    });
    var ownInputs = json.inputs, defaults = (0, $dRLPW._)(json, [
        "inputs"
    ]);
    if (ownInputs) {
        inputs = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = ownInputs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var input = _step.value;
                var inputHydrated = (0, $cxjpp._)((0, $do9pw._)({}, input), {
                    __proto__: $8YvnY.prototype
                });
                if (inputHydrated.map) inputHydrated.map = (0, $cxjpp._)((0, $do9pw._)({}, inputHydrated.map), {
                    __proto__: $lqcup.prototype
                });
                inputs.push(inputHydrated);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    if (defaults.nodes) defaults.nodes = json.nodes.map(function(n) {
        return $9628c11c3cfc2b19$var$fromJSON(n, inputs);
    });
    if (defaults.source) {
        var _defaults_source = defaults.source, inputId = _defaults_source.inputId, source = (0, $dRLPW._)(_defaults_source, [
            "inputId"
        ]);
        defaults.source = source;
        if (inputId != null) defaults.source.input = inputs[inputId];
    }
    if (defaults.type === "root") return new $24VdH(defaults);
    else if (defaults.type === "decl") return new $03KO9(defaults);
    else if (defaults.type === "rule") return new $3Mwbh(defaults);
    else if (defaults.type === "comment") return new $e4Itr(defaults);
    else if (defaults.type === "atrule") return new $3dB8P(defaults);
    else throw new Error("Unknown node type: " + json.type);
}
module.exports = $9628c11c3cfc2b19$var$fromJSON;
$9628c11c3cfc2b19$var$fromJSON.default = $9628c11c3cfc2b19$var$fromJSON;

});






parcelRegister("bsIlm", function(module, exports) {
parcelRequire("fyQ9N");
parcelRequire("8o3lM");

});
parcelRegister("fyQ9N", function(module, exports) {

});

parcelRegister("8o3lM", function(module, exports) {

});




parcelRegister("gGKHl", function(module, exports) {

$parcel$export(module.exports, "usePageOverlayModal", function () { return $2cd945c07f34ad80$export$4ee29ae09fb673cf; });
$parcel$export(module.exports, "PageOverlayModalProvider", function () { return $2cd945c07f34ad80$export$3dec3f5d9617b47e; });
//@ts-nocheck

var $cv9Rk = parcelRequire("cv9Rk");

var $1rY3h = parcelRequire("1rY3h");

var $1Mpn7 = parcelRequire("1Mpn7");
parcelRequire("k24nj");
var $5FngR = parcelRequire("5FngR");
var $2cd945c07f34ad80$var$PageOverlayModalContext = /*#__PURE__*/ (0, $1Mpn7.createContext)({
    isModalOpen: false,
    setIsModalOpen: function() {
        return undefined;
    },
    showOffers: false,
    isModalEnabled: false,
    pageOverlayModalVariant: (0, $5FngR.ConfirmationPageOverlayVariants).UNENROLLED
});
function $2cd945c07f34ad80$export$4ee29ae09fb673cf() {
    return (0, $1Mpn7.useContext)($2cd945c07f34ad80$var$PageOverlayModalContext);
}
var $2cd945c07f34ad80$export$3dec3f5d9617b47e = function(param) {
    var isModalEnabled = param.isModalEnabled, bundleProvisioningStatus = param.bundleProvisioningStatus, children = param.children, featureFlags = param.featureFlags;
    var _useState = (0, $cv9Rk._)((0, $1Mpn7.useState)(false), 2), isModalOpen = _useState[0], setIsModalOpen = _useState[1];
    var _useState1 = (0, $cv9Rk._)((0, $1Mpn7.useState)(false), 2), showOffers = _useState1[0], setShowOffers = _useState1[1];
    var pageOverlayModalVariant = featureFlags.enableConfirmationPageOverlay;
    // Open modal 4s after confirmation page loads
    (0, $1Mpn7.useLayoutEffect)(function() {
        if (isModalEnabled && !isModalOpen) setTimeout(function() {
            setIsModalOpen(true);
            setShowOffers(true);
        }, 4000);
    }, []);
    // After second product is added hide the see offers/free bundles view
    (0, $1Mpn7.useEffect)(function() {
        if (isModalEnabled && bundleProvisioningStatus === "payload-ready") setShowOffers(false);
    }, [
        bundleProvisioningStatus
    ]);
    return /*#__PURE__*/ (0, $1rY3h.jsx)($2cd945c07f34ad80$var$PageOverlayModalContext.Provider, {
        value: {
            isModalOpen: isModalOpen,
            setIsModalOpen: setIsModalOpen,
            showOffers: showOffers,
            isModalEnabled: isModalEnabled,
            pageOverlayModalVariant: pageOverlayModalVariant
        },
        children: children
    });
};

});

parcelRegister("2DsRs", function(module, exports) {

$parcel$export(module.exports, "useFetchUserSegmentData", function () { return $04fe9ce282e8717f$export$b6ec02004dd895c7; });

var $kSuI9 = parcelRequire("kSuI9");

var $cv9Rk = parcelRequire("cv9Rk");

var $l29cN = parcelRequire("l29cN");

var $1Mpn7 = parcelRequire("1Mpn7");

var $i6xUE = parcelRequire("i6xUE");
var $04fe9ce282e8717f$var$USER_SEG_ENDPOINT = "/gateway/api/me";
var $04fe9ce282e8717f$var$getNormalizedEntry = function(value) {
    return Object.entries((0, $i6xUE.USER_SEGMENTATION_CLIENT_MAPPING)).find(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    function(param) {
        var _param = (0, $cv9Rk._)(param, 2), translatedValues = _param[1];
        return translatedValues.includes(value);
    });
};
var $04fe9ce282e8717f$var$normalizeUserSegmentationString = function(value) {
    if (value === "") return 0, $i6xUE.USER_SEGMENTATION_MAPPING_NONE;
    var normalizedEntry = $04fe9ce282e8717f$var$getNormalizedEntry(value);
    return normalizedEntry !== undefined ? normalizedEntry[0] : (0, $i6xUE.USER_SEGMENTATION_MAPPING_UNKNOWN);
};
var $04fe9ce282e8717f$var$isUserInBusinessCategory = function(userAccountData) {
    var _BUSINESS_ROLES_PER_TEAM_TYPE_normalizedTeamType, _BUSINESS_ROLES_PER_TEAM_TYPE_normalizedTeamType1;
    if (!userAccountData) return false;
    var _userAccountData_teamType = userAccountData.teamType, teamType = _userAccountData_teamType === void 0 ? "" : _userAccountData_teamType, _userAccountData_role = userAccountData.role, role = _userAccountData_role === void 0 ? "" : _userAccountData_role;
    var normalizedTeamType = $04fe9ce282e8717f$var$normalizeUserSegmentationString(teamType);
    var normalizedRole = $04fe9ce282e8717f$var$normalizeUserSegmentationString(role);
    var isTeamTypeEligible = (0, $i6xUE.BUSINESS_TEAM_TYPES).includes(normalizedTeamType);
    var isRoleEligible = Boolean(((_BUSINESS_ROLES_PER_TEAM_TYPE_normalizedTeamType = (0, $i6xUE.BUSINESS_ROLES_PER_TEAM_TYPE)[normalizedTeamType]) === null || _BUSINESS_ROLES_PER_TEAM_TYPE_normalizedTeamType === void 0 ? void 0 : _BUSINESS_ROLES_PER_TEAM_TYPE_normalizedTeamType.includes((0, $i6xUE.ALL_ROLES_ELIGIBLE))) || ((_BUSINESS_ROLES_PER_TEAM_TYPE_normalizedTeamType1 = (0, $i6xUE.BUSINESS_ROLES_PER_TEAM_TYPE)[normalizedTeamType]) === null || _BUSINESS_ROLES_PER_TEAM_TYPE_normalizedTeamType1 === void 0 ? void 0 : _BUSINESS_ROLES_PER_TEAM_TYPE_normalizedTeamType1.includes(normalizedRole)));
    return isTeamTypeEligible && isRoleEligible;
};
var $04fe9ce282e8717f$var$getUserAccountData = function() {
    var _ref = (0, $kSuI9._)(function() {
        var _ref, _ref_extended_profile, jobTitle, teamType, error;
        return (0, $l29cN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        fetch($04fe9ce282e8717f$var$USER_SEG_ENDPOINT).then(function(res) {
                            return res.json();
                        })
                    ];
                case 1:
                    _ref = _state.sent(), _ref_extended_profile = _ref.extended_profile, jobTitle = _ref_extended_profile.job_title, teamType = _ref_extended_profile.team_type;
                    return [
                        2,
                        {
                            role: jobTitle,
                            teamType: teamType
                        }
                    ];
                case 2:
                    error = _state.sent();
                    return [
                        2,
                        null
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getUserAccountData() {
        return _ref.apply(this, arguments);
    };
}();
var $04fe9ce282e8717f$var$fetchUserSegmentData = function() {
    var _ref = (0, $kSuI9._)(function() {
        var userAccountData, isBusinessSegmentUser, fetchError;
        return (0, $l29cN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $04fe9ce282e8717f$var$getUserAccountData()
                    ];
                case 1:
                    userAccountData = _state.sent();
                    isBusinessSegmentUser = $04fe9ce282e8717f$var$isUserInBusinessCategory(userAccountData);
                    fetchError = userAccountData === null;
                    return [
                        2,
                        {
                            userAccountData: userAccountData,
                            isBusinessSegmentUser: isBusinessSegmentUser,
                            fetchError: fetchError,
                            fetched: true
                        }
                    ];
            }
        });
    });
    return function fetchUserSegmentData() {
        return _ref.apply(this, arguments);
    };
}();
var $04fe9ce282e8717f$export$b6ec02004dd895c7 = function(shouldFetch) {
    var initialState = {
        userAccountData: null,
        isBusinessSegmentUser: false,
        fetchError: false,
        fetched: false
    };
    var _useState = (0, $cv9Rk._)((0, $1Mpn7.useState)(initialState), 2), state = _useState[0], setState = _useState[1];
    (0, $1Mpn7.useEffect)(function() {
        if (shouldFetch) $04fe9ce282e8717f$var$fetchUserSegmentData().then(function(fetchedState) {
            setState(fetchedState);
        }).catch(function() {
            setState({
                userAccountData: null,
                isBusinessSegmentUser: false,
                fetchError: true,
                fetched: true
            });
        });
    }, [
        shouldFetch
    ]);
    return state;
};

});
parcelRegister("i6xUE", function(module, exports) {

$parcel$export(module.exports, "ALL_ROLES_ELIGIBLE", function () { return $181a7cb253b387e7$export$390f94ade23c5f40; });
$parcel$export(module.exports, "USER_SEGMENTATION_MAPPING_UNKNOWN", function () { return $181a7cb253b387e7$export$2f3f9640393bd078; });
$parcel$export(module.exports, "USER_SEGMENTATION_MAPPING_NONE", function () { return $181a7cb253b387e7$export$4c9a72dac5ce80ae; });
$parcel$export(module.exports, "BUSINESS_ROLES_PER_TEAM_TYPE", function () { return $181a7cb253b387e7$export$9b10a383fdd95886; });
$parcel$export(module.exports, "BUSINESS_TEAM_TYPES", function () { return $181a7cb253b387e7$export$b07956d58f1245f1; });
$parcel$export(module.exports, "USER_SEGMENTATION_CLIENT_MAPPING", function () { return $181a7cb253b387e7$export$3709503ef3102dbe; });

var $3sHb8 = parcelRequire("3sHb8");
var $181a7cb253b387e7$export$390f94ade23c5f40 = "all-roles-eligible";
var $181a7cb253b387e7$export$2f3f9640393bd078 = "unknown";
var $181a7cb253b387e7$export$4c9a72dac5ce80ae = "";
// Roles defined in user segmentation
var $181a7cb253b387e7$var$USER_SEGMENTATION_ROLE_DESIGNER = "designer";
// Team types defined in user segmentation
var $181a7cb253b387e7$var$USER_SEGMENTATION_TEAM_TYPE_CUSTOMER_SERVICE = "customer-service";
var $181a7cb253b387e7$var$USER_SEGMENTATION_TEAM_TYPE_IT_SUPPORT = "it-support";
var $181a7cb253b387e7$var$USER_SEGMENTATION_TEAM_TYPE_HR = "human-resources";
var $181a7cb253b387e7$var$USER_SEGMENTATION_TEAM_TYPE_FINANCE = "finance";
var $181a7cb253b387e7$var$USER_SEGMENTATION_TEAM_TYPE_LEGAL = "legal";
var $181a7cb253b387e7$var$USER_SEGMENTATION_TEAM_TYPE_MARKETING = "marketing";
var $181a7cb253b387e7$var$USER_SEGMENTATION_TEAM_TYPE_OPERATIONS = "operations";
var $181a7cb253b387e7$var$USER_SEGMENTATION_TEAM_TYPE_SALES = "sales";
var $181a7cb253b387e7$var$USER_SEGMENTATION_TEAM_TYPE_SOFTWARE = "software-development";
var $181a7cb253b387e7$var$_obj;
var $181a7cb253b387e7$export$9b10a383fdd95886 = ($181a7cb253b387e7$var$_obj = {}, (0, $3sHb8._)($181a7cb253b387e7$var$_obj, $181a7cb253b387e7$var$USER_SEGMENTATION_TEAM_TYPE_HR, [
    $181a7cb253b387e7$export$390f94ade23c5f40
]), (0, $3sHb8._)($181a7cb253b387e7$var$_obj, $181a7cb253b387e7$var$USER_SEGMENTATION_TEAM_TYPE_FINANCE, [
    $181a7cb253b387e7$export$390f94ade23c5f40
]), (0, $3sHb8._)($181a7cb253b387e7$var$_obj, $181a7cb253b387e7$var$USER_SEGMENTATION_TEAM_TYPE_LEGAL, [
    $181a7cb253b387e7$export$390f94ade23c5f40
]), (0, $3sHb8._)($181a7cb253b387e7$var$_obj, $181a7cb253b387e7$var$USER_SEGMENTATION_TEAM_TYPE_MARKETING, [
    $181a7cb253b387e7$export$390f94ade23c5f40
]), (0, $3sHb8._)($181a7cb253b387e7$var$_obj, $181a7cb253b387e7$var$USER_SEGMENTATION_TEAM_TYPE_OPERATIONS, [
    $181a7cb253b387e7$export$390f94ade23c5f40
]), (0, $3sHb8._)($181a7cb253b387e7$var$_obj, $181a7cb253b387e7$var$USER_SEGMENTATION_TEAM_TYPE_SALES, [
    $181a7cb253b387e7$export$390f94ade23c5f40
]), (0, $3sHb8._)($181a7cb253b387e7$var$_obj, $181a7cb253b387e7$var$USER_SEGMENTATION_TEAM_TYPE_SOFTWARE, [
    $181a7cb253b387e7$var$USER_SEGMENTATION_ROLE_DESIGNER
]), $181a7cb253b387e7$var$_obj);
var $181a7cb253b387e7$export$b07956d58f1245f1 = [
    $181a7cb253b387e7$var$USER_SEGMENTATION_TEAM_TYPE_HR,
    $181a7cb253b387e7$var$USER_SEGMENTATION_TEAM_TYPE_FINANCE,
    $181a7cb253b387e7$var$USER_SEGMENTATION_TEAM_TYPE_LEGAL,
    $181a7cb253b387e7$var$USER_SEGMENTATION_TEAM_TYPE_MARKETING,
    $181a7cb253b387e7$var$USER_SEGMENTATION_TEAM_TYPE_OPERATIONS,
    $181a7cb253b387e7$var$USER_SEGMENTATION_TEAM_TYPE_SALES,
    $181a7cb253b387e7$var$USER_SEGMENTATION_TEAM_TYPE_SOFTWARE
];
var $181a7cb253b387e7$var$_obj1;
var $181a7cb253b387e7$export$3709503ef3102dbe = ($181a7cb253b387e7$var$_obj1 = {}, (0, $3sHb8._)($181a7cb253b387e7$var$_obj1, $181a7cb253b387e7$var$USER_SEGMENTATION_ROLE_DESIGNER, [
    "Designer",
    "Disainer",
    "Dise\xf1ador",
    "Formgivare",
    "Nh\xe0 thi\u1EBFt k\u1EBF",
    "Projektant",
    "Suunnittelija",
    "Tasar\u0131mc\u0131",
    "Tervez\u0151",
    "\u0414\u0438\u0437\u0430\u0439\u043D\u0435\u0440",
    "\u0E19\u0E31\u0E01\u0E2D\u0E2D\u0E01\u0E41\u0E1A\u0E1A",
    "\u30C7\u30B6\u30A4\u30CA\u30FC",
    "\u8A2D\u8A08\u5E2B",
    "\u8BBE\u8BA1\u5E08",
    "\uB514\uC790\uC774\uB108"
]), (0, $3sHb8._)($181a7cb253b387e7$var$_obj1, $181a7cb253b387e7$var$USER_SEGMENTATION_TEAM_TYPE_CUSTOMER_SERVICE, [
    "Asiakaspalvelu",
    "Atendimento ao cliente",
    "Customer Service",
    "D\u1ECBch v\u1EE5 kh\xe1ch h\xe0ng",
    "Klantenservice",
    "Klienditeenindus",
    "Kundenservice",
    "Kundeservice",
    "Kundservice",
    "M\xfc\u015Fteri Hizmetleri",
    "Obs\u0142uga klienta",
    "Service \xe0 la client\xe8le",
    "Servicio de atenci\xf3n al cliente",
    "Servizio clienti",
    "Servi\xe7o de apoio ao cliente",
    "Z\xe1kaznick\xfd servis",
    "Z\xe1kazn\xedcky servis",
    "\xdcgyf\xe9lszolg\xe1lati",
    "\u041E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u043D\u0438\u0435 \u043A\u043B\u0438\u0435\u043D\u0442\u043E\u0432",
    "\u0421\u043B\u0443\u0436\u0431\u0430 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u043A\u0438 \u043A\u043B\u0456\u0454\u043D\u0442\u0456\u0432",
    "\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32",
    "\u30AB\u30B9\u30BF\u30DE\u30FC \u30B5\u30FC\u30D3\u30B9",
    "\u5BA2\u6237\u670D\u52A1",
    "\u9867\u5BA2\u670D\u52D9",
    "\uACE0\uAC1D \uC11C\uBE44\uC2A4"
]), (0, $3sHb8._)($181a7cb253b387e7$var$_obj1, $181a7cb253b387e7$var$USER_SEGMENTATION_TEAM_TYPE_IT_SUPPORT, [
    "Assistenza IT",
    "BT Deste\u011Fi",
    "H\u1ED7 tr\u1EE3 CNTT",
    "IT",
    "IT Support",
    "IT podpora",
    "IT \u30B5\u30DD\u30FC\u30C8",
    "IT \u652F\u6301",
    "IT \u652F\u63F4",
    "IT \uC9C0\uC6D0",
    "IT_Support",
    "IT_st\xf8tte",
    "IT_support",
    "IT_tugi",
    "IT_tuki",
    "Informatikai t\xe1mogat\xe1si",
    "Soporte de TI",
    "Suporte de TI",
    "Support\xa0IT",
    "Wsparcie IT",
    "\u0418\u0422-\u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0430",
    "\u0421\u043B\u0443\u0436\u0431\u0430 \u0442\u0435\u0445\u043D\u0456\u0447\u043D\u043E\u0457 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u043A\u0438",
    "\u0E1D\u0E48\u0E32\u0E22\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19 IT"
]), (0, $3sHb8._)($181a7cb253b387e7$var$_obj1, $181a7cb253b387e7$var$USER_SEGMENTATION_TEAM_TYPE_FINANCE, [
    "Ekonomi",
    "Finance",
    "Financeiro",
    "Financie",
    "Finans",
    "Finanse",
    "Finants",
    "Finanza",
    "Finanzas",
    "Finanzen",
    "Finan\xe7as",
    "P\xe9nz\xfcgyi",
    "Rahoitus",
    "T\xe0i ch\xednh",
    "\xd8konomi",
    "\u0424\u0438\u043D\u0430\u043D\u0441\u044B",
    "\u0424\u0456\u043D\u0430\u043D\u0441\u0438",
    "\u0E01\u0E32\u0E23\u0E40\u0E07\u0E34\u0E19",
    "\u8CA1\u52D9",
    "\u91D1\u878D",
    "\uC7AC\uBB34"
]), (0, $3sHb8._)($181a7cb253b387e7$var$_obj1, $181a7cb253b387e7$var$USER_SEGMENTATION_TEAM_TYPE_HR, [
    "HR",
    "Henkil\xf6st\xf6hallinto",
    "Human Resources",
    "Human resources",
    "human-resources",
    // for Upaas
    "Lidsk\xe9 zdroje",
    "Menneskelige ressourcer",
    "Nh\xe2n s\u1EF1",
    "Personal",
    "Personalfr\xe5gor",
    "RH",
    "Recursos Humanos",
    "Recursos humanos",
    "Risorse umane",
    "Szem\xe9lyzeti",
    "Zasoby ludzkie",
    "\u0130nsan Kaynaklar\u0131",
    "\u013Dudsk\xe9 zdroje",
    "\u0412\u0456\u0434\u0434\u0456\u043B \u043A\u0430\u0434\u0440\u0456\u0432",
    "\u041A\u0430\u0434\u0440\u043E\u0432\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B",
    "\u0E17\u0E23\u0E31\u0E1E\u0E22\u0E32\u0E01\u0E23\u0E1A\u0E38\u0E04\u0E04\u0E25",
    "\u4EBA\u4E8B",
    "\u4EBA\u529B\u8CC7\u6E90",
    "\u4EBA\u529B\u8D44\u6E90",
    "\uC778\uC0AC"
]), (0, $3sHb8._)($181a7cb253b387e7$var$_obj1, $181a7cb253b387e7$var$USER_SEGMENTATION_TEAM_TYPE_LEGAL, [
    "Departamento jur\xeddico",
    "Hukuk",
    "Jogi",
    "Jura",
    "Juridik",
    "Juridisk",
    "Jur\xeddico",
    "Legal",
    "Legale",
    "Oikeudelliset asiat",
    "Ph\xe1p l\xfd",
    "Prawo",
    "Pr\xe1vne oddelenie",
    "Pr\xe1vn\xed odd\u011Blen\xed",
    "Rechtliches",
    "Service juridique",
    "\xd5igus",
    "\u042E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B",
    "\u042E\u0440\u0438\u0434\u0438\u0447\u043D\u0438\u0439 \u0432\u0456\u0434\u0434\u0456\u043B",
    "\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22",
    "\u6CD5\u52D9",
    "\u6CD5\u5F8B",
    "\uBC95\uB960"
]), (0, $3sHb8._)($181a7cb253b387e7$var$_obj1, $181a7cb253b387e7$var$USER_SEGMENTATION_TEAM_TYPE_MARKETING, [
    "Markedsf\xf8ring",
    "Marketing",
    "Markkinointi",
    "Marknadsf\xf6ring",
    "Pazarlama",
    "Ti\u1EBFp th\u1ECB",
    "Turundus",
    "\u041C\u0430\u0440\u043A\u0435\u0442\u0438\u043D\u0433",
    "\u0E01\u0E32\u0E23\u0E15\u0E25\u0E32\u0E14",
    "\u30DE\u30FC\u30B1\u30C6\u30A3\u30F3\u30B0",
    "\u8425\u9500",
    "\u884C\u92B7",
    "\uB9C8\uCF00\uD305"
]), (0, $3sHb8._)($181a7cb253b387e7$var$_obj1, $181a7cb253b387e7$var$USER_SEGMENTATION_TEAM_TYPE_OPERATIONS, [
    "Drift",
    "Haldus",
    "Operacional",
    "Operaciones",
    "Operacje",
    "Operasyonlar",
    "Operations",
    "Operativer Betrieb",
    "Operazioni",
    "Opera\xe7\xf5es",
    "Op\xe9rations",
    "Prev\xe1dzka",
    "Provoz",
    "Toiminnot",
    "V\u1EADn h\xe0nh",
    "\xdczemeltet\xe9si",
    "\u0412\u0438\u0440\u043E\u0431\u043D\u0438\u0447\u0438\u0439 \u0432\u0456\u0434\u0434\u0456\u043B",
    "\u041E\u043F\u0435\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B",
    "\u0E1D\u0E48\u0E32\u0E22\u0E1B\u0E0F\u0E34\u0E1A\u0E31\u0E15\u0E34\u0E01\u0E32\u0E23",
    "\u30AA\u30DA\u30EC\u30FC\u30B7\u30E7\u30F3",
    "\u71DF\u904B",
    "\u8FD0\u8425",
    "\uC6B4\uC601"
]), (0, $3sHb8._)($181a7cb253b387e7$var$_obj1, $181a7cb253b387e7$var$USER_SEGMENTATION_TEAM_TYPE_SALES, [
    "B\xe1n h\xe0ng",
    "F\xf6rs\xe4ljning",
    "Myynti",
    "M\xfc\xfck",
    "Predaj",
    "Prodej",
    "Sales",
    "Salg",
    "Sat\u0131\u015F",
    "Sprzeda\u017C",
    "Vendas",
    "Vendite",
    "Ventas",
    "Ventes",
    "Vertrieb",
    "\xc9rt\xe9kes\xedt\xe9si",
    "\u041F\u0440\u043E\u0434\u0430\u0436\u0438",
    "\u041F\u0440\u043E\u0434\u0430\u0436\u0456",
    "\u0E1D\u0E48\u0E32\u0E22\u0E02\u0E32\u0E22",
    "\u30BB\u30FC\u30EB\u30B9",
    "\u92B7\u552E",
    "\u9500\u552E",
    "\uC601\uC5C5"
]), (0, $3sHb8._)($181a7cb253b387e7$var$_obj1, $181a7cb253b387e7$var$USER_SEGMENTATION_TEAM_TYPE_SOFTWARE, [
    "Desarrollo de software",
    "Desenvolvimento de software",
    "D\xe9veloppement logiciel",
    "Ohjelmistokehitys",
    "Ph\xe1t tri\u1EC3n ph\u1EA7n m\u1EC1m",
    "Programutveckling",
    "Programvareutvikling",
    "Software Development",
    "Softwareentwicklung",
    "Softwareontwikkeling",
    "Softwareudvikling",
    "Sviluppo software",
    "Szoftverfejleszt\u0151",
    "Tarkvaraarendus",
    "Tworzenie oprogramowania",
    "V\xfdvoj softv\xe9ru",
    "V\xfdvoj softwaru",
    "Yaz\u0131l\u0131m Geli\u015Ftirme",
    "\u0420\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0430 \u041F\u041E",
    "\u0420\u043E\u0437\u0440\u043E\u0431\u043A\u0430 \u041F\u0417",
    "\u0E1E\u0E31\u0E12\u0E19\u0E32\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C",
    "\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u958B\u767A",
    "\u8EDF\u9AD4\u958B\u767C",
    "\u8F6F\u4EF6\u5F00\u53D1",
    "\uC18C\uD504\uD2B8\uC6E8\uC5B4 \uAC1C\uBC1C"
]), $181a7cb253b387e7$var$_obj1);

});


parcelRegister("iTEfn", function(module, exports) {

$parcel$export(module.exports, "useFreeBundlesStatus", function () { return $8fc433800a83249f$export$b24eb91b5b87b2f2; });
$parcel$export(module.exports, "FreeBundlesStatusProvider", function () { return $8fc433800a83249f$export$47d74afa51cc4722; });

var $1rY3h = parcelRequire("1rY3h");

var $1Mpn7 = parcelRequire("1Mpn7");
function $8fc433800a83249f$export$b24eb91b5b87b2f2() {
    return (0, $1Mpn7.useContext)($8fc433800a83249f$var$FreeBundlesStatusContext);
}
var $8fc433800a83249f$var$FreeBundlesStatusContext = /*#__PURE__*/ (0, $1Mpn7.createContext)({
    bundleProvisioningStatus: "waiting",
    setBundleProvisioningStatus: function() {
        return undefined;
    },
    bundleMap: {},
    productData: {}
});
var $8fc433800a83249f$export$47d74afa51cc4722 = function(param) {
    var _param_bundleProvisioningStatus = param.bundleProvisioningStatus, bundleProvisioningStatus = _param_bundleProvisioningStatus === void 0 ? "waiting" : _param_bundleProvisioningStatus, _param_setBundleProvisioningStatus = param.setBundleProvisioningStatus, setBundleProvisioningStatus = _param_setBundleProvisioningStatus === void 0 ? function() {
        return undefined;
    } : _param_setBundleProvisioningStatus, _param_bundleMap = param.bundleMap, bundleMap = _param_bundleMap === void 0 ? {} : _param_bundleMap, _param_productData = param.productData, productData = _param_productData === void 0 ? {} : _param_productData, children = param.children;
    return /*#__PURE__*/ (0, $1rY3h.jsx)($8fc433800a83249f$var$FreeBundlesStatusContext.Provider, {
        value: {
            bundleProvisioningStatus: bundleProvisioningStatus,
            setBundleProvisioningStatus: setBundleProvisioningStatus,
            bundleMap: bundleMap,
            productData: productData
        },
        children: children
    });
};

});

parcelRegister("JxlmM", function(module, exports) {

$parcel$export(module.exports, "useFreeBundles", function () { return $514a35bd82b79089$export$cb124b8d665406fd; });
parcelRequire("cyrDP");
var $5XR3v = parcelRequire("5XR3v");
parcelRequire("k24nj");
var $5FngR = parcelRequire("5FngR");
var $cqkTt = parcelRequire("cqkTt");
function $514a35bd82b79089$export$cb124b8d665406fd() {
    var featureFlags = (0, $5FngR.useCloudStatus)().featureFlags;
    var products = (0, $cqkTt.useSearchParameters)().products;
    return !!featureFlags.enableBundlesAfterSignup && products.length === 1 && products.includes((0, $5XR3v.ProductKey).JIRA_SOFTWARE);
}

});
parcelRegister("cyrDP", function(module, exports) {
$parcel$export(module.exports, "isProductKey", function () { return (parcelRequire("5XR3v")).isProductKey; });
$parcel$export(module.exports, "PRODUCT_NAMES", function () { return (parcelRequire("5XR3v")).PRODUCT_NAMES; });
$parcel$export(module.exports, "ProductKey", function () { return (parcelRequire("5XR3v")).ProductKey; });
parcelRequire("5XR3v");

});
parcelRegister("5XR3v", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_NAMES", function () { return $ee5525f32f07c1ff$export$a3c15905bd058cb9; });
$parcel$export(module.exports, "isProductKey", function () { return $ee5525f32f07c1ff$export$2a41a819c1db85b1; });
$parcel$export(module.exports, "ProductKey", function () { return $ee5525f32f07c1ff$export$f3a53bd43617a593; });
parcelRequire("8swxV");
var $hqPFZ = parcelRequire("hqPFZ");
var $ee5525f32f07c1ff$export$a3c15905bd058cb9 = {
    "jira.ondemand": "Jira",
    "jira-core.ondemand": "Jira Work Management",
    "greenhopper.jira.ondemand": "Jira Agile",
    "jira-software.ondemand": "Jira Software",
    "com.atlassian.servicedesk.ondemand": "Jira Service Desk",
    "jira-servicedesk.ondemand": "Jira Service Management",
    "jira-incident-manager.ondemand": "Jira Ops",
    "com.radiantminds.roadmaps-jira.ondemand": "Jira Portfolio",
    "bonfire.jira.ondemand": "Jira Capture",
    "confluence.ondemand": "Confluence",
    "com.atlassian.confluence.plugins.confluence-questions.ondemand": "Confluence Questions",
    "team.calendars.confluence.ondemand": "Confluence Team Calendars"
};
var $ee5525f32f07c1ff$export$fd33a5c1b7c7672e = (0, $hqPFZ.getRecordKeys)($ee5525f32f07c1ff$export$a3c15905bd058cb9);
function $ee5525f32f07c1ff$export$2a41a819c1db85b1(value) {
    return $ee5525f32f07c1ff$export$fd33a5c1b7c7672e.some(function(productKey) {
        return value === productKey;
    });
}
var $ee5525f32f07c1ff$export$f3a53bd43617a593;
(function(ProductKey) {
    ProductKey["JIRA_SOFTWARE"] = "jira-software.ondemand";
    ProductKey["BITBUCKET"] = "com.atlassian.bitbucket";
    ProductKey["CONFLUENCE"] = "confluence.ondemand";
    ProductKey["OPSGENIE"] = "opsgenie";
    ProductKey["JIRA_SERVICE_DESK"] = "jira-servicedesk.ondemand";
    ProductKey["JIRA_SERVICE_MANAGEMENT"] = "jira-servicedesk.ondemand";
    ProductKey["JIRA_CORE"] = "jira-core.ondemand";
    ProductKey["JIRA_WORK_MANAGEMENT"] = "jira-core.ondemand";
    ProductKey["ACCESS"] = "com.atlassian.identity-manager";
    ProductKey["STATUSPAGE"] = "statuspage";
    ProductKey["CONFLUENCE_PLUGIN_QUESTIONS"] = "com.atlassian.confluence.plugins.confluence-questions.ondemand";
    ProductKey["CONFLUENCE_TEAM_CALENDARS"] = "team.calendars.confluence.ondemand";
    ProductKey["JIRA_ROADMAPS"] = "com.radiantminds.roadmaps-jira.ondemand";
    ProductKey["JIRA_BONFIRE"] = "bonfire.jira.ondemand";
    ProductKey["JIRA_REFAPP"] = "refapp";
    ProductKey["TEAM_CENTRAL"] = "townsquare";
    ProductKey["JIRA_PRODUCT_DISCOVERY"] = "jira-product-discovery";
    ProductKey["COMPASS"] = "compass";
    ProductKey["ATLAS"] = "townsquare";
    ProductKey["FABRIC"] = "atlassian-whiteboard";
    ProductKey["BEACON"] = "beacon";
})($ee5525f32f07c1ff$export$f3a53bd43617a593 || ($ee5525f32f07c1ff$export$f3a53bd43617a593 = {}));

});



parcelRegister("9bye2", function(module, exports) {

$parcel$export(module.exports, "JiraTemplateChoiceProvider", function () { return $bcc6ed5c12514472$export$b91fd19354f2d79f; });
$parcel$export(module.exports, "useJiraTemplateChoice", function () { return $bcc6ed5c12514472$export$6aabfcd893a302bb; });
// @ts-ignore

var $cv9Rk = parcelRequire("cv9Rk");

var $1rY3h = parcelRequire("1rY3h");

var $1Mpn7 = parcelRequire("1Mpn7");

var $3P435 = parcelRequire("3P435");
parcelRequire("k24nj");
var $cqkTt = parcelRequire("cqkTt");
var $aVmvD = parcelRequire("aVmvD");
var $2DsRs = parcelRequire("2DsRs");
var $bcc6ed5c12514472$export$bda5b4e2d043b174 = /*#__PURE__*/ (0, $1Mpn7.createContext)({
    jiraTemplateChoiceView: "control",
    shouldShowJiraTemplateChoiceScreen: false,
    loadingUserSegmentData: false,
    templateChoice: undefined,
    setTemplateChoice: function() {
        return undefined;
    },
    templateChoiceError: undefined,
    setTemplateChoiceError: function() {
        return undefined;
    },
    isUserSegmentationViewRequired: true
});
var $bcc6ed5c12514472$export$b91fd19354f2d79f = function(param) {
    var children = param.children;
    var isJiraTemplateChoiceFeatureGateEnabled = (0, $3P435.default).checkGate("jsw_transparent_template_over_confirmation_page");
    var experimentConfig = (0, $3P435.default).getExperiment("jsw_signup_transparent_template_user_seg_redesign", {
        fireExperimentExposure: false
    });
    var jiraTemplateChoiceView = isJiraTemplateChoiceFeatureGateEnabled ? experimentConfig.get("jiraTemplateChoiceView", "control") : "control";
    var isUserSegmentationViewRequired = isJiraTemplateChoiceFeatureGateEnabled ? experimentConfig.get("isUserSegmentationViewRequired", true) : true;
    var products = (0, $cqkTt.useSearchParameters)().products;
    var _useCanShowJiraTemplateChoiceScreen = $bcc6ed5c12514472$export$1a3262f85c893015(products, isUserSegmentationViewRequired), canShowJiraTemplateChoiceScreen = _useCanShowJiraTemplateChoiceScreen.canShowJiraTemplateChoiceScreen, loadingUserSegmentData = _useCanShowJiraTemplateChoiceScreen.loadingUserSegmentData;
    var _useState = (0, $cv9Rk._)((0, $1Mpn7.useState)(), 2), templateChoice = _useState[0], setTemplateChoice = _useState[1];
    var _useState1 = (0, $cv9Rk._)((0, $1Mpn7.useState)(), 2), templateChoiceError = _useState1[0], setTemplateChoiceError = _useState1[1];
    var userHasPickedTemplate = templateChoice !== undefined;
    var shouldShowJiraTemplateChoiceScreen = templateChoiceError === undefined && canShowJiraTemplateChoiceScreen && !userHasPickedTemplate && isJiraTemplateChoiceFeatureGateEnabled;
    // manually log exposure once the user satisfies all precheck conditions
    (0, $1Mpn7.useEffect)(function() {
        if (shouldShowJiraTemplateChoiceScreen) $bcc6ed5c12514472$var$fireExposureEvent("jsw_signup_transparent_template_user_seg_redesign");
    }, [
        shouldShowJiraTemplateChoiceScreen
    ]);
    return /*#__PURE__*/ (0, $1rY3h.jsx)($bcc6ed5c12514472$export$bda5b4e2d043b174.Provider, {
        value: {
            jiraTemplateChoiceView: jiraTemplateChoiceView,
            templateChoice: templateChoice,
            loadingUserSegmentData: loadingUserSegmentData,
            setTemplateChoice: setTemplateChoice,
            shouldShowJiraTemplateChoiceScreen: shouldShowJiraTemplateChoiceScreen,
            templateChoiceError: templateChoiceError,
            setTemplateChoiceError: setTemplateChoiceError,
            isUserSegmentationViewRequired: isUserSegmentationViewRequired
        },
        children: children
    });
};
var $bcc6ed5c12514472$export$1a3262f85c893015 = function(products, isUserSegmentationViewRequired) {
    var _useUserSegmentationStatus = (0, $aVmvD.useUserSegmentationStatus)(products), isProvisioningUserSegProducts = _useUserSegmentationStatus.isProvisioningUserSegProducts, isUserSegHiddenByQueryParam = _useUserSegmentationStatus.isUserSegHiddenByQueryParam, alreadyViewedUserSegmentationScreen = _useUserSegmentationStatus.alreadyViewedUserSegmentationScreen, userSegmentationPageIsFinished = _useUserSegmentationStatus.userSegmentationPageIsFinished;
    var _useSearchParameters = (0, $cqkTt.useSearchParameters)(), templateId = _useSearchParameters.templateId, n2n = _useSearchParameters.n2n;
    var hasTemplateRecommendation = Boolean(templateId);
    var isN2NUser = Boolean(n2n);
    // don't make call to bxpkit-core for product key
    // caused build error
    var isProvisioningOnlyJSW = products.length === 1 && products[0] === "jira-software.ondemand";
    var exposedToUserSegScreen = isProvisioningUserSegProducts && !isUserSegHiddenByQueryParam;
    var canShowTTCPreFetchConditions = !hasTemplateRecommendation && isProvisioningOnlyJSW && isN2NUser;
    // verify the user has seen user segmentation before showing jira choice template.
    if (isUserSegmentationViewRequired) canShowTTCPreFetchConditions = canShowTTCPreFetchConditions && exposedToUserSegScreen && !alreadyViewedUserSegmentationScreen;
    var _useFetchUserSegmentData = (0, $2DsRs.useFetchUserSegmentData)(canShowTTCPreFetchConditions && userSegmentationPageIsFinished), fetched = _useFetchUserSegmentData.fetched, fetchError = _useFetchUserSegmentData.fetchError, isBusinessSegmentUser = _useFetchUserSegmentData.isBusinessSegmentUser;
    var canShowJiraTemplateChoiceScreen = isUserSegmentationViewRequired ? canShowTTCPreFetchConditions && !isBusinessSegmentUser && !fetchError : canShowTTCPreFetchConditions;
    return {
        canShowJiraTemplateChoiceScreen: canShowJiraTemplateChoiceScreen,
        loadingUserSegmentData: !fetched && isUserSegmentationViewRequired
    };
};
var $bcc6ed5c12514472$export$6aabfcd893a302bb = function() {
    return (0, $1Mpn7.useContext)($bcc6ed5c12514472$export$bda5b4e2d043b174);
};
function $bcc6ed5c12514472$var$fireExposureEvent(experiment) {
    (0, $3P435.default).manuallyLogExperimentExposure(experiment);
}

});
parcelRegister("3P435", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3209953ef0c7f938$export$2e2bcd8739ae039; });

var $coBSS = parcelRequire("coBSS");
var $3209953ef0c7f938$var$FeatureGates = (0, (/*@__PURE__*/$parcel$interopDefault($coBSS)));
var $3209953ef0c7f938$export$2e2bcd8739ae039 = $3209953ef0c7f938$var$FeatureGates;

});


parcelRegister("cqkTt", function(module, exports) {

$parcel$export(module.exports, "useSearchParameters", function () { return $1d68b230bcf57b77$export$a301eca0a780f275; });
parcelRequire("hAdR1");
var $2tZah = parcelRequire("2tZah");
/**
 * @returns {URLSearchParams} The search (query) parameters from the URL.
 *
 * This function is used to get the search parameters from the URL.
 * If in a router context, it uses the {@link useLocation} hook,
 * otherwise it uses the global location.
 */ var $1d68b230bcf57b77$var$getSearchParameters = function() {
    try {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        return new URLSearchParams((0, $2tZah.useLocation)().search);
    } catch (e) {
        return new URLSearchParams(location.search);
    }
};
function $1d68b230bcf57b77$export$a301eca0a780f275() {
    var searchParameters = $1d68b230bcf57b77$var$getSearchParameters();
    var _searchParameters_get;
    var cloudId = (_searchParameters_get = searchParameters.get("cloudId")) !== null && _searchParameters_get !== void 0 ? _searchParameters_get : "";
    var _searchParameters_get1;
    var requestId = (_searchParameters_get1 = searchParameters.get("requestId")) !== null && _searchParameters_get1 !== void 0 ? _searchParameters_get1 : "";
    var _searchParameters_get2;
    var products = (_searchParameters_get2 = searchParameters.get("products")) !== null && _searchParameters_get2 !== void 0 ? _searchParameters_get2 : "";
    var _searchParameters_get3;
    var referrer = (_searchParameters_get3 = searchParameters.get("referrer")) !== null && _searchParameters_get3 !== void 0 ? _searchParameters_get3 : undefined;
    var isClaiming = searchParameters.get("claim") === "true";
    var _searchParameters_get4;
    var dataRegion = (_searchParameters_get4 = searchParameters.get("dataRegion")) !== null && _searchParameters_get4 !== void 0 ? _searchParameters_get4 : undefined;
    var _searchParameters_get5;
    var onDemandUrl = (_searchParameters_get5 = searchParameters.get("ondemandurl")) !== null && _searchParameters_get5 !== void 0 ? _searchParameters_get5 : undefined;
    var admin = searchParameters.get("admin") === "true";
    var _searchParameters_get6;
    var siteRenameRequestId = (_searchParameters_get6 = searchParameters.get("siteRenameRequestId")) !== null && _searchParameters_get6 !== void 0 ? _searchParameters_get6 : undefined;
    var _searchParameters_get7;
    var locale = (_searchParameters_get7 = searchParameters.get("locale")) !== null && _searchParameters_get7 !== void 0 ? _searchParameters_get7 : "";
    var platformParam = searchParameters.get("platform");
    var platform = platformParam === "ccp" || platformParam === "hams" ? platformParam : "routing";
    var _searchParameters_get8;
    var provisioningRequestId = (_searchParameters_get8 = searchParameters.get("provisioningRequestId")) !== null && _searchParameters_get8 !== void 0 ? _searchParameters_get8 : undefined;
    var _searchParameters_get9;
    var signupSource = (_searchParameters_get9 = searchParameters.get("signupSource")) !== null && _searchParameters_get9 !== void 0 ? _searchParameters_get9 : undefined;
    var _searchParameters_get10;
    var isFoundingAdmin = (_searchParameters_get10 = searchParameters.get("isFoundingAdmin")) !== null && _searchParameters_get10 !== void 0 ? _searchParameters_get10 : undefined;
    var _searchParameters_get11;
    var provisionApp = (_searchParameters_get11 = searchParameters.get("provisionApp")) !== null && _searchParameters_get11 !== void 0 ? _searchParameters_get11 : undefined;
    var _searchParameters_get12;
    var hideUserSegmentation = (_searchParameters_get12 = searchParameters.get("hideUserSegmentation")) !== null && _searchParameters_get12 !== void 0 ? _searchParameters_get12 : undefined;
    var _searchParameters_get13;
    var appKey = (_searchParameters_get13 = searchParameters.get("appKey")) !== null && _searchParameters_get13 !== void 0 ? _searchParameters_get13 : undefined;
    var _searchParameters_get14;
    var templateId = (_searchParameters_get14 = searchParameters.get("templateId")) !== null && _searchParameters_get14 !== void 0 ? _searchParameters_get14 : undefined;
    var _searchParameters_get15;
    var edition = (_searchParameters_get15 = searchParameters.get("edition")) !== null && _searchParameters_get15 !== void 0 ? _searchParameters_get15 : undefined;
    var _searchParameters_get16;
    var asp = (_searchParameters_get16 = searchParameters.get("asp")) !== null && _searchParameters_get16 !== void 0 ? _searchParameters_get16 : "";
    var n2n = searchParameters.get("n2n") === "true";
    return {
        cloudId: cloudId,
        requestId: requestId,
        products: products.split(","),
        referrer: referrer,
        isClaiming: isClaiming,
        onDemandUrl: onDemandUrl,
        dataRegion: dataRegion,
        siteRenameRequestId: siteRenameRequestId,
        admin: admin,
        locale: locale,
        platform: platform,
        provisioningRequestId: provisioningRequestId,
        signupSource: signupSource,
        isFoundingAdmin: isFoundingAdmin,
        provisionApp: provisionApp,
        hideUserSegmentation: hideUserSegmentation,
        appKey: appKey,
        templateId: templateId,
        edition: edition,
        asp: asp,
        n2n: n2n
    };
}

});
parcelRegister("hAdR1", function(module, exports) {

$parcel$export(module.exports, "HashRouter", function () { return $ccd08b97ad39d035$export$7221d69dcfc8e36b; });
$parcel$export(module.exports, "useLocation", function () { return (parcelRequire("2tZah")).useLocation; });
$parcel$export(module.exports, "useNavigate", function () { return (parcelRequire("2tZah")).useNavigate; });
/**
 * React Router DOM v6.18.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $cv9Rk = parcelRequire("cv9Rk");

var $l29cN = parcelRequire("l29cN");

var $1Mpn7 = parcelRequire("1Mpn7");

var $2oFVr = parcelRequire("2oFVr");
var $2tZah = parcelRequire("2tZah");

var $2oFVr = parcelRequire("2oFVr");
function $ccd08b97ad39d035$var$_extends() {
    $ccd08b97ad39d035$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ccd08b97ad39d035$var$_extends.apply(this, arguments);
}
function $ccd08b97ad39d035$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $ccd08b97ad39d035$var$defaultMethod = "get";
var $ccd08b97ad39d035$var$defaultEncType = "application/x-www-form-urlencoded";
function $ccd08b97ad39d035$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $ccd08b97ad39d035$var$isButtonElement(object) {
    return $ccd08b97ad39d035$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $ccd08b97ad39d035$var$isFormElement(object) {
    return $ccd08b97ad39d035$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $ccd08b97ad39d035$var$isInputElement(object) {
    return $ccd08b97ad39d035$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $ccd08b97ad39d035$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $ccd08b97ad39d035$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$ccd08b97ad39d035$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $ccd08b97ad39d035$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce(function(memo, key) {
        var value = init[key];
        return memo.concat(Array.isArray(value) ? value.map(function(v) {
            return [
                key,
                v
            ];
        }) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $ccd08b97ad39d035$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    var searchParams = $ccd08b97ad39d035$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach(function(_, key) {
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach(function(value) {
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
var $ccd08b97ad39d035$var$_formDataSupportsSubmitter = null;
function $ccd08b97ad39d035$var$isFormDataSubmitterSupported() {
    if ($ccd08b97ad39d035$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $ccd08b97ad39d035$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $ccd08b97ad39d035$var$_formDataSupportsSubmitter = true;
    }
    return $ccd08b97ad39d035$var$_formDataSupportsSubmitter;
}
var $ccd08b97ad39d035$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $ccd08b97ad39d035$var$getFormEncType(encType) {
    if (encType != null && !$ccd08b97ad39d035$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $ccd08b97ad39d035$var$getFormSubmissionInfo(target, basename) {
    var method;
    var action;
    var encType;
    var formData;
    var body;
    if ($ccd08b97ad39d035$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        var attr = target.getAttribute("action");
        action = attr ? (0, $2oFVr.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || $ccd08b97ad39d035$var$defaultMethod;
        encType = $ccd08b97ad39d035$var$getFormEncType(target.getAttribute("enctype")) || $ccd08b97ad39d035$var$defaultEncType;
        formData = new FormData(target);
    } else if ($ccd08b97ad39d035$var$isButtonElement(target) || $ccd08b97ad39d035$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        var form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        var attr1 = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr1 ? (0, $2oFVr.stripBasename)(attr1, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $ccd08b97ad39d035$var$defaultMethod;
        encType = $ccd08b97ad39d035$var$getFormEncType(target.getAttribute("formenctype")) || $ccd08b97ad39d035$var$getFormEncType(form.getAttribute("enctype")) || $ccd08b97ad39d035$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$ccd08b97ad39d035$var$isFormDataSubmitterSupported()) {
            var name = target.name, type = target.type, value = target.value;
            if (type === "image") {
                var prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($ccd08b97ad39d035$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $ccd08b97ad39d035$var$defaultMethod;
        action = null;
        encType = $ccd08b97ad39d035$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
var $ccd08b97ad39d035$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $ccd08b97ad39d035$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $ccd08b97ad39d035$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
function $ccd08b97ad39d035$export$1f3f55432a00e06d(routes, opts) {
    return (0, $2oFVr.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $ccd08b97ad39d035$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $2oFVr.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $ccd08b97ad39d035$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $2tZah.UNSAFE_mapRouteProperties),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $ccd08b97ad39d035$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $2oFVr.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $ccd08b97ad39d035$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $2oFVr.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $ccd08b97ad39d035$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $2tZah.UNSAFE_mapRouteProperties),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $ccd08b97ad39d035$var$parseHydrationData() {
    var _window;
    var state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $ccd08b97ad39d035$var$_extends({}, state, {
        errors: $ccd08b97ad39d035$var$deserializeErrors(state.errors)
    });
    return state;
}
function $ccd08b97ad39d035$var$deserializeErrors(errors) {
    if (!errors) return null;
    var entries = Object.entries(errors);
    var serialized = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $cv9Rk._)(_step.value, 2), key = _step_value[0], val = _step_value[1];
            // Hey you!  If you change this, please change the corresponding logic in
            // serializeErrors in react-router-dom/server.tsx :)
            if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $2oFVr.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
            else if (val && val.__type === "Error") {
                // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
                if (val.__subType) {
                    var ErrorConstructor = window[val.__subType];
                    if (typeof ErrorConstructor === "function") try {
                        // @ts-expect-error
                        var error = new ErrorConstructor(val.message);
                        // Wipe away the client-side stack trace.  Nothing to fill it in with
                        // because we don't serialize SSR stack traces for security reasons
                        error.stack = "";
                        serialized[key] = error;
                    } catch (e) {
                    // no-op - fall through and create a normal Error
                    }
                }
                if (serialized[key] == null) {
                    var error1 = new Error(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error1.stack = "";
                    serialized[key] = error1;
                }
            } else serialized[key] = val;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return serialized;
}
var $ccd08b97ad39d035$export$7ad602f0e94e62d1 = /*#__PURE__*/ $1Mpn7.createContext({
    isTransitioning: false
});
var $ccd08b97ad39d035$export$148fd98d095596d4 = /*#__PURE__*/ $1Mpn7.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ var $ccd08b97ad39d035$var$START_TRANSITION = "startTransition";
var $ccd08b97ad39d035$var$startTransitionImpl = $1Mpn7[$ccd08b97ad39d035$var$START_TRANSITION];
function $ccd08b97ad39d035$var$startTransitionSafe(cb) {
    if ($ccd08b97ad39d035$var$startTransitionImpl) $ccd08b97ad39d035$var$startTransitionImpl(cb);
    else cb();
}
var $ccd08b97ad39d035$var$Deferred = function Deferred() {
    "use strict";
    var _this = this;
    (0, $4GJKx._)(this, Deferred);
    this.status = "pending";
    this.promise = new Promise(function(resolve, reject) {
        _this.resolve = function(value) {
            if (_this.status === "pending") {
                _this.status = "resolved";
                resolve(value);
            }
        };
        _this.reject = function(reason) {
            if (_this.status === "pending") {
                _this.status = "rejected";
                reject(reason);
            }
        };
    });
};
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $ccd08b97ad39d035$export$323e4fc2fa4753fb(_ref) {
    var fallbackElement = _ref.fallbackElement, router = _ref.router, future = _ref.future;
    var _React_useState = (0, $cv9Rk._)($1Mpn7.useState(router.state), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var _React_useState1 = (0, $cv9Rk._)($1Mpn7.useState(), 2), pendingState = _React_useState1[0], setPendingState = _React_useState1[1];
    var _React_useState2 = (0, $cv9Rk._)($1Mpn7.useState({
        isTransitioning: false
    }), 2), vtContext = _React_useState2[0], setVtContext = _React_useState2[1];
    var _React_useState3 = (0, $cv9Rk._)($1Mpn7.useState(), 2), renderDfd = _React_useState3[0], setRenderDfd = _React_useState3[1];
    var _React_useState4 = (0, $cv9Rk._)($1Mpn7.useState(), 2), transition = _React_useState4[0], setTransition = _React_useState4[1];
    var _React_useState5 = (0, $cv9Rk._)($1Mpn7.useState(), 2), interruption = _React_useState5[0], setInterruption = _React_useState5[1];
    var fetcherData = $1Mpn7.useRef(new Map());
    var v7_startTransition = (future || {}).v7_startTransition;
    var optInStartTransition = $1Mpn7.useCallback(function(cb) {
        if (v7_startTransition) $ccd08b97ad39d035$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    var setState = $1Mpn7.useCallback(function(newState, _ref2) {
        var deletedFetchers = _ref2.deletedFetchers, viewTransitionOpts = _ref2.unstable_viewTransitionOpts;
        deletedFetchers.forEach(function(key) {
            return fetcherData.current.delete(key);
        });
        newState.fetchers.forEach(function(fetcher, key) {
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        if (!viewTransitionOpts || router.window == null || typeof router.window.document.startViewTransition !== "function") // Mid-navigation state update, or startViewTransition isn't available
        optInStartTransition(function() {
            return setStateImpl(newState);
        });
        else if (transition && renderDfd) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $1Mpn7.useLayoutEffect(function() {
        return router.subscribe(setState);
    }, [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $1Mpn7.useEffect(function() {
        if (vtContext.isTransitioning) setRenderDfd(new $ccd08b97ad39d035$var$Deferred());
    }, [
        vtContext.isTransitioning
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $1Mpn7.useEffect(function() {
        if (renderDfd && pendingState && router.window) {
            var newState = pendingState;
            var renderPromise = renderDfd.promise;
            var transition = router.window.document.startViewTransition(/*#__PURE__*/ (0, $kSuI9._)(function() {
                return (0, $l29cN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            optInStartTransition(function() {
                                return setStateImpl(newState);
                            });
                            return [
                                4,
                                renderPromise
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }));
            transition.finished.finally(function() {
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $1Mpn7.useEffect(function() {
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $1Mpn7.useEffect(function() {
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    var navigator = $1Mpn7.useMemo(function() {
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: function(n) {
                return router.navigate(n);
            },
            push: function(to, state, opts) {
                return router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            },
            replace: function(to, state, opts) {
                return router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            }
        };
    }, [
        router
    ]);
    var basename = router.basename || "/";
    var dataRouterContext = $1Mpn7.useMemo(function() {
        return {
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        };
    }, [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $1Mpn7.createElement($1Mpn7.Fragment, null, /*#__PURE__*/ $1Mpn7.createElement((0, $2tZah.UNSAFE_DataRouterContext).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $1Mpn7.createElement((0, $2tZah.UNSAFE_DataRouterStateContext).Provider, {
        value: state
    }, /*#__PURE__*/ $1Mpn7.createElement($ccd08b97ad39d035$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $1Mpn7.createElement($ccd08b97ad39d035$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $1Mpn7.createElement((0, $2tZah.Router), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ $1Mpn7.createElement($ccd08b97ad39d035$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement))))), null);
}
function $ccd08b97ad39d035$var$DataRoutes(_ref3) {
    var routes = _ref3.routes, state = _ref3.state;
    return (0, $2tZah.UNSAFE_useRoutesImpl)(routes, undefined, state);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $ccd08b97ad39d035$export$9ba4e89fdfa1fc54(_ref4) {
    var basename = _ref4.basename, children = _ref4.children, future = _ref4.future, _$window = _ref4.window;
    var historyRef = $1Mpn7.useRef();
    if (historyRef.current == null) historyRef.current = (0, $2oFVr.createBrowserHistory)({
        window: _$window,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $cv9Rk._)($1Mpn7.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $1Mpn7.useCallback(function(newState) {
        v7_startTransition && $ccd08b97ad39d035$var$startTransitionImpl ? $ccd08b97ad39d035$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $1Mpn7.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $1Mpn7.createElement((0, $2tZah.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $ccd08b97ad39d035$export$7221d69dcfc8e36b(_ref5) {
    var basename = _ref5.basename, children = _ref5.children, future = _ref5.future, _$window = _ref5.window;
    var historyRef = $1Mpn7.useRef();
    if (historyRef.current == null) historyRef.current = (0, $2oFVr.createHashHistory)({
        window: _$window,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $cv9Rk._)($1Mpn7.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $1Mpn7.useCallback(function(newState) {
        v7_startTransition && $ccd08b97ad39d035$var$startTransitionImpl ? $ccd08b97ad39d035$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $1Mpn7.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $1Mpn7.createElement((0, $2tZah.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $ccd08b97ad39d035$export$eefb0c834599897e(_ref6) {
    var basename = _ref6.basename, children = _ref6.children, future = _ref6.future, history = _ref6.history;
    var _React_useState = (0, $cv9Rk._)($1Mpn7.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $1Mpn7.useCallback(function(newState) {
        v7_startTransition && $ccd08b97ad39d035$var$startTransitionImpl ? $ccd08b97ad39d035$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $1Mpn7.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $1Mpn7.createElement((0, $2tZah.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
var $ccd08b97ad39d035$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
var $ccd08b97ad39d035$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ var $ccd08b97ad39d035$export$a6c7ac8248d6e38a = /*#__PURE__*/ $1Mpn7.forwardRef(function LinkWithRef(_ref7, ref) {
    var onClick = _ref7.onClick, relative = _ref7.relative, reloadDocument = _ref7.reloadDocument, replace = _ref7.replace, state = _ref7.state, target = _ref7.target, to = _ref7.to, preventScrollReset = _ref7.preventScrollReset, unstable_viewTransition = _ref7.unstable_viewTransition, rest = $ccd08b97ad39d035$var$_objectWithoutPropertiesLoose(_ref7, $ccd08b97ad39d035$var$_excluded);
    var basename = $1Mpn7.useContext((0, $2tZah.UNSAFE_NavigationContext)).basename;
    // Rendered into <a href> for absolute URLs
    var absoluteHref;
    var isExternal = false;
    if (typeof to === "string" && $ccd08b97ad39d035$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($ccd08b97ad39d035$var$isBrowser) try {
            var currentUrl = new URL(window.location.href);
            var targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            var path = (0, $2oFVr.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    var href = (0, $2tZah.useHref)(to, {
        relative: relative
    });
    var internalOnClick = $ccd08b97ad39d035$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $1Mpn7.createElement("a", $ccd08b97ad39d035$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ var $ccd08b97ad39d035$export$b0d92dbee9b5b60d = /*#__PURE__*/ $1Mpn7.forwardRef(function NavLinkWithRef(_ref8, ref) {
    var tmp = _ref8["aria-current"], ariaCurrentProp = tmp === void 0 ? "page" : tmp, _ref8_caseSensitive = _ref8.caseSensitive, caseSensitive = _ref8_caseSensitive === void 0 ? false : _ref8_caseSensitive, tmp1 = _ref8.className, classNameProp = tmp1 === void 0 ? "" : tmp1, _ref8_end = _ref8.end, end = _ref8_end === void 0 ? false : _ref8_end, styleProp = _ref8.style, to = _ref8.to, unstable_viewTransition = _ref8.unstable_viewTransition, children = _ref8.children, rest = $ccd08b97ad39d035$var$_objectWithoutPropertiesLoose(_ref8, $ccd08b97ad39d035$var$_excluded2);
    var path = (0, $2tZah.useResolvedPath)(to, {
        relative: rest.relative
    });
    var location = (0, $2tZah.useLocation)();
    var routerState = $1Mpn7.useContext((0, $2tZah.UNSAFE_DataRouterStateContext));
    var navigator = $1Mpn7.useContext((0, $2tZah.UNSAFE_NavigationContext)).navigator;
    var isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $ccd08b97ad39d035$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    var toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    var locationPathname = location.pathname;
    var nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    var isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    var isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    var renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    var ariaCurrent = isActive ? ariaCurrentProp : undefined;
    var className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    var style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $1Mpn7.createElement($ccd08b97ad39d035$export$a6c7ac8248d6e38a, $ccd08b97ad39d035$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ var $ccd08b97ad39d035$export$a7fed597f4b8afd8 = /*#__PURE__*/ $1Mpn7.forwardRef(function(_ref9, forwardedRef) {
    var fetcherKey = _ref9.fetcherKey, navigate = _ref9.navigate, reloadDocument = _ref9.reloadDocument, replace = _ref9.replace, state = _ref9.state, _ref9_method = _ref9.method, method = _ref9_method === void 0 ? $ccd08b97ad39d035$var$defaultMethod : _ref9_method, action = _ref9.action, onSubmit = _ref9.onSubmit, relative = _ref9.relative, preventScrollReset = _ref9.preventScrollReset, unstable_viewTransition = _ref9.unstable_viewTransition, props = $ccd08b97ad39d035$var$_objectWithoutPropertiesLoose(_ref9, $ccd08b97ad39d035$var$_excluded3);
    var submit = $ccd08b97ad39d035$export$47c85c6e3a081d3();
    var formAction = $ccd08b97ad39d035$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    var formMethod = method.toLowerCase() === "get" ? "get" : "post";
    var submitHandler = function(event) {
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        var submitter = event.nativeEvent.submitter;
        var submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $1Mpn7.createElement("form", $ccd08b97ad39d035$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $ccd08b97ad39d035$export$11aac1aab828f1fa(_ref10) {
    var getKey = _ref10.getKey, storageKey = _ref10.storageKey;
    $ccd08b97ad39d035$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $ccd08b97ad39d035$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($ccd08b97ad39d035$var$DataRouterHook || ($ccd08b97ad39d035$var$DataRouterHook = {}));
var $ccd08b97ad39d035$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($ccd08b97ad39d035$var$DataRouterStateHook || ($ccd08b97ad39d035$var$DataRouterStateHook = {}));
// Internal hooks
function $ccd08b97ad39d035$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $ccd08b97ad39d035$var$useDataRouterContext(hookName) {
    var ctx = $1Mpn7.useContext((0, $2tZah.UNSAFE_DataRouterContext));
    !ctx && (0, $2oFVr.UNSAFE_invariant)(false);
    return ctx;
}
function $ccd08b97ad39d035$var$useDataRouterState(hookName) {
    var state = $1Mpn7.useContext((0, $2tZah.UNSAFE_DataRouterStateContext));
    !state && (0, $2oFVr.UNSAFE_invariant)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $ccd08b97ad39d035$export$67621102c14d847(to, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, target = _ref.target, replaceProp = _ref.replace, state = _ref.state, preventScrollReset = _ref.preventScrollReset, relative = _ref.relative, unstable_viewTransition = _ref.unstable_viewTransition;
    var navigate = (0, $2tZah.useNavigate)();
    var location = (0, $2tZah.useLocation)();
    var path = (0, $2tZah.useResolvedPath)(to, {
        relative: relative
    });
    return $1Mpn7.useCallback(function(event) {
        if ($ccd08b97ad39d035$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            var replace = replaceProp !== undefined ? replaceProp : (0, $2oFVr.createPath)(location) === (0, $2oFVr.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $ccd08b97ad39d035$export$f1a78c17382fe22a(defaultInit) {
    var defaultSearchParamsRef = $1Mpn7.useRef($ccd08b97ad39d035$export$a2e4e2dcc7b1f22f(defaultInit));
    var hasSetSearchParamsRef = $1Mpn7.useRef(false);
    var location = (0, $2tZah.useLocation)();
    var searchParams = $1Mpn7.useMemo(function() {
        return(// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $ccd08b97ad39d035$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current));
    }, [
        location.search
    ]);
    var navigate = (0, $2tZah.useNavigate)();
    var setSearchParams = $1Mpn7.useCallback(function(nextInit, navigateOptions) {
        var newSearchParams = $ccd08b97ad39d035$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $ccd08b97ad39d035$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
var $ccd08b97ad39d035$var$fetcherId = 0;
var $ccd08b97ad39d035$var$getUniqueFetcherId = function() {
    return "__" + String(++$ccd08b97ad39d035$var$fetcherId) + "__";
};
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $ccd08b97ad39d035$export$47c85c6e3a081d3() {
    var router = $ccd08b97ad39d035$var$useDataRouterContext($ccd08b97ad39d035$var$DataRouterHook.UseSubmit).router;
    var basename = $1Mpn7.useContext((0, $2tZah.UNSAFE_NavigationContext)).basename;
    var currentRouteId = (0, $2tZah.UNSAFE_useRouteId)();
    return $1Mpn7.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $ccd08b97ad39d035$var$validateClientSideSubmission();
        var _getFormSubmissionInfo = $ccd08b97ad39d035$var$getFormSubmissionInfo(target, basename), action = _getFormSubmissionInfo.action, method = _getFormSubmissionInfo.method, encType = _getFormSubmissionInfo.encType, formData = _getFormSubmissionInfo.formData, body = _getFormSubmissionInfo.body;
        if (options.navigate === false) {
            var key = options.fetcherKey || $ccd08b97ad39d035$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $ccd08b97ad39d035$export$89a6bd6db0d97c56(action, _temp2) {
    var relative = (_temp2 === void 0 ? {} : _temp2).relative;
    var basename = $1Mpn7.useContext((0, $2tZah.UNSAFE_NavigationContext)).basename;
    var routeContext = $1Mpn7.useContext((0, $2tZah.UNSAFE_RouteContext));
    !routeContext && (0, $2oFVr.UNSAFE_invariant)(false);
    var _routeContext_matches_slice = (0, $cv9Rk._)(routeContext.matches.slice(-1), 1), match = _routeContext_matches_slice[0];
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    var path = $ccd08b97ad39d035$var$_extends({}, (0, $2tZah.useResolvedPath)(action ? action : ".", {
        relative: relative
    }));
    // Previously we set the default action to ".". The problem with this is that
    // `useResolvedPath(".")` excludes search params of the resolved URL. This is
    // the intended behavior of when "." is specifically provided as
    // the form action, but inconsistent w/ browsers when the action is omitted.
    // https://github.com/remix-run/remix/issues/927
    var location = (0, $2tZah.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove the automatically
        // inserted ?index param so we match the useResolvedPath search behavior
        // which would not include ?index
        if (match.route.index) {
            var params = new URLSearchParams(path.search);
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $2oFVr.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $2oFVr.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $ccd08b97ad39d035$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    var key = (_temp3 === void 0 ? {} : _temp3).key;
    var router = $ccd08b97ad39d035$var$useDataRouterContext($ccd08b97ad39d035$var$DataRouterHook.UseFetcher).router;
    var state = $ccd08b97ad39d035$var$useDataRouterState($ccd08b97ad39d035$var$DataRouterStateHook.UseFetcher);
    var fetcherData = $1Mpn7.useContext($ccd08b97ad39d035$export$148fd98d095596d4);
    var route = $1Mpn7.useContext((0, $2tZah.UNSAFE_RouteContext));
    var routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $2oFVr.UNSAFE_invariant)(false);
    !route && (0, $2oFVr.UNSAFE_invariant)(false);
    !(routeId != null) && (0, $2oFVr.UNSAFE_invariant)(false);
    // Fetcher key handling
    var _React_useState = (0, $cv9Rk._)($1Mpn7.useState(key || ""), 2), fetcherKey = _React_useState[0], setFetcherKey = _React_useState[1];
    if (!fetcherKey) setFetcherKey($ccd08b97ad39d035$var$getUniqueFetcherId());
    // Registration/cleanup
    $1Mpn7.useEffect(function() {
        router.getFetcher(fetcherKey);
        return function() {
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    var load = $1Mpn7.useCallback(function(href) {
        !routeId && (0, $2oFVr.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, routeId, href);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    var submitImpl = $ccd08b97ad39d035$export$47c85c6e3a081d3();
    var submit = $1Mpn7.useCallback(function(target, opts) {
        submitImpl(target, $ccd08b97ad39d035$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    var FetcherForm = $1Mpn7.useMemo(function() {
        var FetcherForm = /*#__PURE__*/ $1Mpn7.forwardRef(function(props, ref) {
            return /*#__PURE__*/ $1Mpn7.createElement($ccd08b97ad39d035$export$a7fed597f4b8afd8, $ccd08b97ad39d035$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    var fetcher = state.fetchers.get(fetcherKey) || (0, $2oFVr.IDLE_FETCHER);
    var data = fetcherData.get(fetcherKey);
    var fetcherWithComponents = $1Mpn7.useMemo(function() {
        return $ccd08b97ad39d035$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        });
    }, [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $ccd08b97ad39d035$export$fa996778a3a31087() {
    var state = $ccd08b97ad39d035$var$useDataRouterState($ccd08b97ad39d035$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map(function(_ref11) {
        var _$_ref11 = (0, $cv9Rk._)(_ref11, 2), key = _$_ref11[0], fetcher = _$_ref11[1];
        return $ccd08b97ad39d035$var$_extends({}, fetcher, {
            key: key
        });
    });
}
var $ccd08b97ad39d035$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $ccd08b97ad39d035$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $ccd08b97ad39d035$export$25057cfe5591e3e9(_temp4) {
    var _ref = _temp4 === void 0 ? {} : _temp4, getKey = _ref.getKey, storageKey = _ref.storageKey;
    var router = $ccd08b97ad39d035$var$useDataRouterContext($ccd08b97ad39d035$var$DataRouterHook.UseScrollRestoration).router;
    var _useDataRouterState = $ccd08b97ad39d035$var$useDataRouterState($ccd08b97ad39d035$var$DataRouterStateHook.UseScrollRestoration), restoreScrollPosition = _useDataRouterState.restoreScrollPosition, preventScrollReset = _useDataRouterState.preventScrollReset;
    var basename = $1Mpn7.useContext((0, $2tZah.UNSAFE_NavigationContext)).basename;
    var location = (0, $2tZah.useLocation)();
    var matches = (0, $2tZah.useMatches)();
    var navigation = (0, $2tZah.useNavigation)();
    // Trigger manual scroll restoration while we're active
    $1Mpn7.useEffect(function() {
        window.history.scrollRestoration = "manual";
        return function() {
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $ccd08b97ad39d035$var$usePageHide($1Mpn7.useCallback(function() {
        if (navigation.state === "idle") {
            var key = (getKey ? getKey(location, matches) : null) || location.key;
            $ccd08b97ad39d035$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $ccd08b97ad39d035$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($ccd08b97ad39d035$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $1Mpn7.useLayoutEffect(function() {
            try {
                var sessionPositions = sessionStorage.getItem(storageKey || $ccd08b97ad39d035$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $ccd08b97ad39d035$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $1Mpn7.useLayoutEffect(function() {
            var getKeyWithoutBasename = getKey && basename !== "/" ? function(location, matches) {
                return getKey($ccd08b97ad39d035$var$_extends({}, location, {
                    pathname: (0, $2oFVr.stripBasename)(location.pathname, basename) || location.pathname
                }), matches);
            } : getKey;
            var disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($ccd08b97ad39d035$var$savedScrollPositions, function() {
                return window.scrollY;
            }, getKeyWithoutBasename);
            return function() {
                return disableScrollRestoration && disableScrollRestoration();
            };
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $1Mpn7.useLayoutEffect(function() {
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                var el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $ccd08b97ad39d035$export$c0a586b329cae57d(callback, options) {
    var capture = (options || {}).capture;
    $1Mpn7.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return function() {
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $ccd08b97ad39d035$var$usePageHide(callback, options) {
    var capture = (options || {}).capture;
    $1Mpn7.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return function() {
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $ccd08b97ad39d035$export$39f4eb3dbd812741(_ref12) {
    var when = _ref12.when, message = _ref12.message;
    var blocker = (0, $2tZah.unstable_useBlocker)(when);
    $1Mpn7.useEffect(function() {
        if (blocker.state === "blocked") {
            var proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $1Mpn7.useEffect(function() {
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $ccd08b97ad39d035$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    var vtContext = $1Mpn7.useContext($ccd08b97ad39d035$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $2oFVr.UNSAFE_invariant)(false);
    var basename = $ccd08b97ad39d035$var$useDataRouterContext($ccd08b97ad39d035$var$DataRouterHook.useViewTransitionState).basename;
    var path = (0, $2tZah.useResolvedPath)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    var currentPath = (0, $2oFVr.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    var nextPath = (0, $2oFVr.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $2oFVr.matchPath)(path.pathname, nextPath) != null || (0, $2oFVr.matchPath)(path.pathname, currentPath) != null;
}

});
parcelRegister("2oFVr", function(module, exports) {

$parcel$export(module.exports, "Action", function () { return $1bee5832b9fa8a3e$export$e19cd5f9376f8cee; });
$parcel$export(module.exports, "createMemoryHistory", function () { return $1bee5832b9fa8a3e$export$2b76ad033c6e6d08; });
$parcel$export(module.exports, "createPath", function () { return $1bee5832b9fa8a3e$export$fe53371bee54353d; });
$parcel$export(module.exports, "parsePath", function () { return $1bee5832b9fa8a3e$export$8ccf933b0513f8d0; });
$parcel$export(module.exports, "createBrowserHistory", function () { return $1bee5832b9fa8a3e$export$719fc203c4e16dee; });
$parcel$export(module.exports, "createHashHistory", function () { return $1bee5832b9fa8a3e$export$b71fdd3798280242; });
$parcel$export(module.exports, "UNSAFE_invariant", function () { return $1bee5832b9fa8a3e$export$3e9cee6b33872309; });
$parcel$export(module.exports, "matchRoutes", function () { return $1bee5832b9fa8a3e$export$2708184779ceb39d; });
$parcel$export(module.exports, "stripBasename", function () { return $1bee5832b9fa8a3e$export$b69e3301ce081aa3; });
$parcel$export(module.exports, "UNSAFE_convertRouteMatchToUiMatch", function () { return $1bee5832b9fa8a3e$export$b3fac024fad9e8ff; });
$parcel$export(module.exports, "joinPaths", function () { return $1bee5832b9fa8a3e$export$86d9a7913e44197e; });
$parcel$export(module.exports, "matchPath", function () { return $1bee5832b9fa8a3e$export$81336c211d5ff295; });
$parcel$export(module.exports, "UNSAFE_getPathContributingMatches", function () { return $1bee5832b9fa8a3e$export$90ba53ce1c7fdff2; });
$parcel$export(module.exports, "resolveTo", function () { return $1bee5832b9fa8a3e$export$cae722b0cc860f13; });
$parcel$export(module.exports, "AbortedDeferredError", function () { return $1bee5832b9fa8a3e$export$42a99a7a4bc0e76a; });
$parcel$export(module.exports, "UNSAFE_ErrorResponseImpl", function () { return $1bee5832b9fa8a3e$export$6c6580e81da25755; });
$parcel$export(module.exports, "isRouteErrorResponse", function () { return $1bee5832b9fa8a3e$export$972111febbeef05b; });
$parcel$export(module.exports, "IDLE_FETCHER", function () { return $1bee5832b9fa8a3e$export$52eace9c284d3585; });
$parcel$export(module.exports, "IDLE_BLOCKER", function () { return $1bee5832b9fa8a3e$export$386d57f03f0b2883; });
$parcel$export(module.exports, "createRouter", function () { return $1bee5832b9fa8a3e$export$baddd0131ee8c05b; });
/**
 * @remix-run/router v1.11.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $3sHb8 = parcelRequire("3sHb8");

var $dcsZi = parcelRequire("dcsZi");

var $cv9Rk = parcelRequire("cv9Rk");

var $gdHfP = parcelRequire("gdHfP");

var $c6Xmf = parcelRequire("c6Xmf");

var $FuVm8 = parcelRequire("FuVm8");

var $ohfOJ = parcelRequire("ohfOJ");

var $l29cN = parcelRequire("l29cN");

var $l29cN = parcelRequire("l29cN");
function $1bee5832b9fa8a3e$var$_extends() {
    $1bee5832b9fa8a3e$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1bee5832b9fa8a3e$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $1bee5832b9fa8a3e$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($1bee5832b9fa8a3e$export$e19cd5f9376f8cee || ($1bee5832b9fa8a3e$export$e19cd5f9376f8cee = {}));
var $1bee5832b9fa8a3e$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $1bee5832b9fa8a3e$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    var _options_initialEntries = options.initialEntries, initialEntries = _options_initialEntries === void 0 ? [
        "/"
    ] : _options_initialEntries, initialIndex = options.initialIndex, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map(function(entry, index) {
        return createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined);
    });
    var index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    var action = $1bee5832b9fa8a3e$export$e19cd5f9376f8cee.Pop;
    var listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        var location = $1bee5832b9fa8a3e$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $1bee5832b9fa8a3e$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $1bee5832b9fa8a3e$export$fe53371bee54353d(to);
    }
    var history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL: function(to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation: function(to) {
            var path = typeof to === "string" ? $1bee5832b9fa8a3e$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push: function(to, state) {
            action = $1bee5832b9fa8a3e$export$e19cd5f9376f8cee.Push;
            var nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace: function(to, state) {
            action = $1bee5832b9fa8a3e$export$e19cd5f9376f8cee.Replace;
            var nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go: function(delta) {
            action = $1bee5832b9fa8a3e$export$e19cd5f9376f8cee.Pop;
            var nextIndex = clampIndex(index + delta);
            var nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen: function(fn) {
            listener = fn;
            return function() {
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $1bee5832b9fa8a3e$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        var _window_location = window1.location, pathname = _window_location.pathname, search = _window_location.search, hash = _window_location.hash;
        return $1bee5832b9fa8a3e$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $1bee5832b9fa8a3e$export$fe53371bee54353d(to);
    }
    return $1bee5832b9fa8a3e$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $1bee5832b9fa8a3e$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        var _parsePath = $1bee5832b9fa8a3e$export$8ccf933b0513f8d0(window1.location.hash.substr(1)), _parsePath_pathname = _parsePath.pathname, pathname = _parsePath_pathname === void 0 ? "/" : _parsePath_pathname, _parsePath_search = _parsePath.search, search = _parsePath_search === void 0 ? "" : _parsePath_search, _parsePath_hash = _parsePath.hash, hash = _parsePath_hash === void 0 ? "" : _parsePath_hash;
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $1bee5832b9fa8a3e$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        var base = window1.document.querySelector("base");
        var href = "";
        if (base && base.getAttribute("href")) {
            var url = window1.location.href;
            var hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $1bee5832b9fa8a3e$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $1bee5832b9fa8a3e$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $1bee5832b9fa8a3e$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $1bee5832b9fa8a3e$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $1bee5832b9fa8a3e$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $1bee5832b9fa8a3e$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $1bee5832b9fa8a3e$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $1bee5832b9fa8a3e$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    var location = $1bee5832b9fa8a3e$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $1bee5832b9fa8a3e$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $1bee5832b9fa8a3e$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $1bee5832b9fa8a3e$export$fe53371bee54353d(_ref) {
    var _ref_pathname = _ref.pathname, pathname = _ref_pathname === void 0 ? "/" : _ref_pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $1bee5832b9fa8a3e$export$8ccf933b0513f8d0(path) {
    var parsedPath = {};
    if (path) {
        var hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        var searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $1bee5832b9fa8a3e$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    var _options_window = options.window, window1 = _options_window === void 0 ? document.defaultView : _options_window, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var globalHistory = window1.history;
    var action = $1bee5832b9fa8a3e$export$e19cd5f9376f8cee.Pop;
    var listener = null;
    var index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($1bee5832b9fa8a3e$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        var state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $1bee5832b9fa8a3e$export$e19cd5f9376f8cee.Pop;
        var nextIndex = getIndex();
        var delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $1bee5832b9fa8a3e$export$e19cd5f9376f8cee.Push;
        var location = $1bee5832b9fa8a3e$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        var historyState = $1bee5832b9fa8a3e$var$getHistoryState(location, index);
        var url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $1bee5832b9fa8a3e$export$e19cd5f9376f8cee.Replace;
        var location = $1bee5832b9fa8a3e$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        var historyState = $1bee5832b9fa8a3e$var$getHistoryState(location, index);
        var url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        var base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        var href = typeof to === "string" ? to : $1bee5832b9fa8a3e$export$fe53371bee54353d(to);
        $1bee5832b9fa8a3e$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen: function(fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($1bee5832b9fa8a3e$var$PopStateEventType, handlePop);
            listener = fn;
            return function() {
                window1.removeEventListener($1bee5832b9fa8a3e$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref: function(to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation: function(to) {
            // Encode a Location the same way window.location would
            var url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go: function(n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $1bee5832b9fa8a3e$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($1bee5832b9fa8a3e$var$ResultType || ($1bee5832b9fa8a3e$var$ResultType = {}));
var $1bee5832b9fa8a3e$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $1bee5832b9fa8a3e$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $1bee5832b9fa8a3e$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map(function(route, index) {
        var treePath = (0, $c6Xmf._)(parentPath).concat([
            index
        ]);
        var id = typeof route.id === "string" ? route.id : treePath.join("-");
        $1bee5832b9fa8a3e$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $1bee5832b9fa8a3e$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($1bee5832b9fa8a3e$var$isIndexRoute(route)) {
            var indexRoute = $1bee5832b9fa8a3e$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            var pathOrLayoutRoute = $1bee5832b9fa8a3e$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $1bee5832b9fa8a3e$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $1bee5832b9fa8a3e$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    var location = typeof locationArg === "string" ? $1bee5832b9fa8a3e$export$8ccf933b0513f8d0(locationArg) : locationArg;
    var pathname = $1bee5832b9fa8a3e$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    var branches = $1bee5832b9fa8a3e$var$flattenRoutes(routes);
    $1bee5832b9fa8a3e$var$rankRouteBranches(branches);
    var matches = null;
    for(var i = 0; matches == null && i < branches.length; ++i)matches = $1bee5832b9fa8a3e$var$matchRouteBranch(branches[i], // Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $1bee5832b9fa8a3e$var$safelyDecodeURI(pathname));
    return matches;
}
function $1bee5832b9fa8a3e$export$b3fac024fad9e8ff(match, loaderData) {
    var route = match.route, pathname = match.pathname, params = match.params;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $1bee5832b9fa8a3e$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    var flattenRoute = function(route, index, relativePath) {
        var meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $1bee5832b9fa8a3e$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        var path = $1bee5832b9fa8a3e$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        var routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $1bee5832b9fa8a3e$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $1bee5832b9fa8a3e$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $1bee5832b9fa8a3e$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach(function(route, index) {
        var _route$path;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else try {
            for(var _iterator = $1bee5832b9fa8a3e$var$explodeOptionalSegments(route.path)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var exploded = _step.value;
                flattenRoute(route, index, exploded);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $1bee5832b9fa8a3e$var$explodeOptionalSegments(path) {
    var // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    _result, _result1;
    var segments = path.split("/");
    if (segments.length === 0) return [];
    var _segments = (0, $gdHfP._)(segments), first = _segments[0], rest = _segments.slice(1);
    // Optional path segments are denoted by a trailing `?`
    var isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    var required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    var restExploded = $1bee5832b9fa8a3e$var$explodeOptionalSegments(rest.join("/"));
    var result = [];
    (_result = result).push.apply(_result, (0, $c6Xmf._)(restExploded.map(function(subpath) {
        return subpath === "" ? required : [
            required,
            subpath
        ].join("/");
    })));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) (_result1 = result).push.apply(_result1, (0, $c6Xmf._)(restExploded));
    // for absolute paths, ensure `/` instead of empty segment
    return result.map(function(exploded) {
        return path.startsWith("/") && exploded === "" ? "/" : exploded;
    });
}
function $1bee5832b9fa8a3e$var$rankRouteBranches(branches) {
    branches.sort(function(a, b) {
        return a.score !== b.score ? b.score - a.score // Higher score first
         : $1bee5832b9fa8a3e$var$compareIndexes(a.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }), b.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }));
    });
}
var $1bee5832b9fa8a3e$var$paramRe = /^:\w+$/;
var $1bee5832b9fa8a3e$var$dynamicSegmentValue = 3;
var $1bee5832b9fa8a3e$var$indexRouteValue = 2;
var $1bee5832b9fa8a3e$var$emptySegmentValue = 1;
var $1bee5832b9fa8a3e$var$staticSegmentValue = 10;
var $1bee5832b9fa8a3e$var$splatPenalty = -2;
var $1bee5832b9fa8a3e$var$isSplat = function(s) {
    return s === "*";
};
function $1bee5832b9fa8a3e$var$computeScore(path, index) {
    var segments = path.split("/");
    var initialScore = segments.length;
    if (segments.some($1bee5832b9fa8a3e$var$isSplat)) initialScore += $1bee5832b9fa8a3e$var$splatPenalty;
    if (index) initialScore += $1bee5832b9fa8a3e$var$indexRouteValue;
    return segments.filter(function(s) {
        return !$1bee5832b9fa8a3e$var$isSplat(s);
    }).reduce(function(score, segment) {
        return score + ($1bee5832b9fa8a3e$var$paramRe.test(segment) ? $1bee5832b9fa8a3e$var$dynamicSegmentValue : segment === "" ? $1bee5832b9fa8a3e$var$emptySegmentValue : $1bee5832b9fa8a3e$var$staticSegmentValue);
    }, initialScore);
}
function $1bee5832b9fa8a3e$var$compareIndexes(a, b) {
    var siblings = a.length === b.length && a.slice(0, -1).every(function(n, i) {
        return n === b[i];
    });
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $1bee5832b9fa8a3e$var$matchRouteBranch(branch, pathname) {
    var routesMeta = branch.routesMeta;
    var matchedParams = {};
    var matchedPathname = "/";
    var matches = [];
    for(var i = 0; i < routesMeta.length; ++i){
        var meta = routesMeta[i];
        var end = i === routesMeta.length - 1;
        var remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        var match = $1bee5832b9fa8a3e$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        var route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $1bee5832b9fa8a3e$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $1bee5832b9fa8a3e$export$a5c6d149b50c1d86($1bee5832b9fa8a3e$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $1bee5832b9fa8a3e$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $1bee5832b9fa8a3e$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    var path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $1bee5832b9fa8a3e$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    var prefix = path.startsWith("/") ? "/" : "";
    var stringify = function(p) {
        return p == null ? "" : typeof p === "string" ? p : String(p);
    };
    var segments = path.split(/\/+/).map(function(segment, index, array) {
        var isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            var star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        var keyMatch = segment.match(/^:(\w+)(\??)$/);
        if (keyMatch) {
            var _keyMatch = (0, $cv9Rk._)(keyMatch, 3), key = _keyMatch[1], optional = _keyMatch[2];
            var param = params[key];
            $1bee5832b9fa8a3e$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter(function(segment) {
        return !!segment;
    });
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $1bee5832b9fa8a3e$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    var _compilePath = (0, $cv9Rk._)($1bee5832b9fa8a3e$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end), 2), matcher = _compilePath[0], compiledParams = _compilePath[1];
    var match = pathname.match(matcher);
    if (!match) return null;
    var matchedPathname = match[0];
    var pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    var captureGroups = match.slice(1);
    var params = compiledParams.reduce(function(memo, _ref, index) {
        var paramName = _ref.paramName, isOptional = _ref.isOptional;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            var splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        var value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = $1bee5832b9fa8a3e$var$safelyDecodeURIComponent(value || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $1bee5832b9fa8a3e$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $1bee5832b9fa8a3e$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    var params = [];
    var regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)(\?)?/g, function(_, paramName, isOptional) {
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    var matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $1bee5832b9fa8a3e$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $1bee5832b9fa8a3e$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $1bee5832b9fa8a3e$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $1bee5832b9fa8a3e$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $1bee5832b9fa8a3e$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    var startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    var nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $1bee5832b9fa8a3e$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    var _ref = typeof to === "string" ? $1bee5832b9fa8a3e$export$8ccf933b0513f8d0(to) : to, toPathname = _ref.pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    var pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $1bee5832b9fa8a3e$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $1bee5832b9fa8a3e$var$normalizeSearch(search),
        hash: $1bee5832b9fa8a3e$var$normalizeHash(hash)
    };
}
function $1bee5832b9fa8a3e$var$resolvePathname(relativePath, fromPathname) {
    var segments = fromPathname.replace(/\/+$/, "").split("/");
    var relativeSegments = relativePath.split("/");
    relativeSegments.forEach(function(segment) {
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $1bee5832b9fa8a3e$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $1bee5832b9fa8a3e$export$90ba53ce1c7fdff2(matches) {
    return matches.filter(function(match, index) {
        return index === 0 || match.route.path && match.route.path.length > 0;
    });
}
/**
 * @private
 */ function $1bee5832b9fa8a3e$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    var to;
    if (typeof toArg === "string") to = $1bee5832b9fa8a3e$export$8ccf933b0513f8d0(toArg);
    else {
        to = $1bee5832b9fa8a3e$var$_extends({}, toArg);
        $1bee5832b9fa8a3e$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $1bee5832b9fa8a3e$var$getInvalidPathError("?", "pathname", "search", to));
        $1bee5832b9fa8a3e$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $1bee5832b9fa8a3e$var$getInvalidPathError("#", "pathname", "hash", to));
        $1bee5832b9fa8a3e$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $1bee5832b9fa8a3e$var$getInvalidPathError("#", "search", "hash", to));
    }
    var isEmptyPath = toArg === "" || to.pathname === "";
    var toPathname = isEmptyPath ? "/" : to.pathname;
    var from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (isPathRelative || toPathname == null) from = locationPathname;
    else {
        var routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            var toSegments = toPathname.split("/");
            // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    var path = $1bee5832b9fa8a3e$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    var hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    var hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $1bee5832b9fa8a3e$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $1bee5832b9fa8a3e$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ var $1bee5832b9fa8a3e$export$86d9a7913e44197e = function(paths) {
    return paths.join("/").replace(/\/\/+/g, "/");
};
/**
 * @private
 */ var $1bee5832b9fa8a3e$export$a5c6d149b50c1d86 = function(pathname) {
    return pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
};
/**
 * @private
 */ var $1bee5832b9fa8a3e$var$normalizeSearch = function(search) {
    return !search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
};
/**
 * @private
 */ var $1bee5832b9fa8a3e$var$normalizeHash = function(hash) {
    return !hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
};
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ var $1bee5832b9fa8a3e$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    var responseInit = typeof init === "number" ? {
        status: init
    } : init;
    var headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $1bee5832b9fa8a3e$var$_extends({}, responseInit, {
        headers: headers
    }));
};
var $1bee5832b9fa8a3e$export$42a99a7a4bc0e76a = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $dcsZi._)(AbortedDeferredError, Error1);
    var _super = (0, $ohfOJ._)(AbortedDeferredError);
    function AbortedDeferredError() {
        (0, $4GJKx._)(this, AbortedDeferredError);
        return _super.apply(this, arguments);
    }
    return AbortedDeferredError;
}((0, $FuVm8._)(Error));
var $1bee5832b9fa8a3e$export$61d759255b4eec65 = /*#__PURE__*/ function() {
    "use strict";
    function DeferredData(data, responseInit) {
        var _this = this;
        (0, $4GJKx._)(this, DeferredData);
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $1bee5832b9fa8a3e$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        var reject;
        this.abortPromise = new Promise(function(_, r) {
            return reject = r;
        });
        this.controller = new AbortController();
        var onAbort = function() {
            return reject(new $1bee5832b9fa8a3e$export$42a99a7a4bc0e76a("Deferred data aborted"));
        };
        this.unlistenAbortSignal = function() {
            return _this.controller.signal.removeEventListener("abort", onAbort);
        };
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce(function(acc, _ref2) {
            var _$_ref2 = (0, $cv9Rk._)(_ref2, 2), key = _$_ref2[0], value = _$_ref2[1];
            return Object.assign(acc, (0, $3sHb8._)({}, key, _this.trackPromise(key, value)));
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    (0, $1wc17._)(DeferredData, [
        {
            key: "trackPromise",
            value: function trackPromise(key, value) {
                var _this = this;
                if (!(value instanceof Promise)) return value;
                this.deferredKeys.push(key);
                this.pendingKeysSet.add(key);
                // We store a little wrapper promise that will be extended with
                // _data/_error props upon resolve/reject
                var promise = Promise.race([
                    value,
                    this.abortPromise
                ]).then(function(data) {
                    return _this.onSettle(promise, key, undefined, data);
                }, function(error) {
                    return _this.onSettle(promise, key, error);
                });
                // Register rejection listeners to avoid uncaught promise rejections on
                // errors or aborted deferred values
                promise.catch(function() {});
                Object.defineProperty(promise, "_tracked", {
                    get: function() {
                        return true;
                    }
                });
                return promise;
            }
        },
        {
            key: "onSettle",
            value: function onSettle(promise, key, error, data) {
                if (this.controller.signal.aborted && error instanceof $1bee5832b9fa8a3e$export$42a99a7a4bc0e76a) {
                    this.unlistenAbortSignal();
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return error;
                        }
                    });
                    return Promise.reject(error);
                }
                this.pendingKeysSet.delete(key);
                if (this.done) // Nothing left to abort!
                this.unlistenAbortSignal();
                // If the promise was resolved/rejected with undefined, we'll throw an error as you
                // should always resolve with a value or null
                if (error === undefined && data === undefined) {
                    var undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return undefinedError;
                        }
                    });
                    this.emit(false, key);
                    return Promise.reject(undefinedError);
                }
                if (data === undefined) {
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return error;
                        }
                    });
                    this.emit(false, key);
                    return Promise.reject(error);
                }
                Object.defineProperty(promise, "_data", {
                    get: function() {
                        return data;
                    }
                });
                this.emit(false, key);
                return data;
            }
        },
        {
            key: "emit",
            value: function emit(aborted, settledKey) {
                this.subscribers.forEach(function(subscriber) {
                    return subscriber(aborted, settledKey);
                });
            }
        },
        {
            key: "subscribe",
            value: function subscribe(fn) {
                var _this = this;
                this.subscribers.add(fn);
                return function() {
                    return _this.subscribers.delete(fn);
                };
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                var _this = this;
                this.controller.abort();
                this.pendingKeysSet.forEach(function(v, k) {
                    return _this.pendingKeysSet.delete(k);
                });
                this.emit(true);
            }
        },
        {
            key: "resolveData",
            value: function resolveData(signal) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var aborted, onAbort;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                aborted = false;
                                if (!!_this.done) return [
                                    3,
                                    2
                                ];
                                onAbort = function() {
                                    return _this.cancel();
                                };
                                signal.addEventListener("abort", onAbort);
                                return [
                                    4,
                                    new Promise(function(resolve) {
                                        _this.subscribe(function(aborted) {
                                            signal.removeEventListener("abort", onAbort);
                                            if (aborted || _this.done) resolve(aborted);
                                        });
                                    })
                                ];
                            case 1:
                                aborted = _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2,
                                    aborted
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "done",
            get: function get() {
                return this.pendingKeysSet.size === 0;
            }
        },
        {
            key: "unwrappedData",
            get: function get() {
                $1bee5832b9fa8a3e$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
                return Object.entries(this.data).reduce(function(acc, _ref3) {
                    var _$_ref3 = (0, $cv9Rk._)(_ref3, 2), key = _$_ref3[0], value = _$_ref3[1];
                    return Object.assign(acc, (0, $3sHb8._)({}, key, $1bee5832b9fa8a3e$var$unwrapTrackedPromise(value)));
                }, {});
            }
        },
        {
            key: "pendingKeys",
            get: function get() {
                return Array.from(this.pendingKeysSet);
            }
        }
    ]);
    return DeferredData;
}();
function $1bee5832b9fa8a3e$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $1bee5832b9fa8a3e$var$unwrapTrackedPromise(value) {
    if (!$1bee5832b9fa8a3e$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
var $1bee5832b9fa8a3e$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    var responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $1bee5832b9fa8a3e$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ var $1bee5832b9fa8a3e$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    var responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    var headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $1bee5832b9fa8a3e$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ var $1bee5832b9fa8a3e$export$a6cd19cd1951a23c = function(url, init) {
    var response = $1bee5832b9fa8a3e$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ var $1bee5832b9fa8a3e$export$6c6580e81da25755 = function ErrorResponseImpl(status, statusText, data, internal) {
    "use strict";
    (0, $4GJKx._)(this, ErrorResponseImpl);
    if (internal === void 0) internal = false;
    this.status = status;
    this.statusText = statusText || "";
    this.internal = internal;
    if (data instanceof Error) {
        this.data = data.toString();
        this.error = data;
    } else this.data = data;
};
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $1bee5832b9fa8a3e$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
var $1bee5832b9fa8a3e$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
var $1bee5832b9fa8a3e$var$validMutationMethods = new Set($1bee5832b9fa8a3e$var$validMutationMethodsArr);
var $1bee5832b9fa8a3e$var$validRequestMethodsArr = [
    "get"
].concat((0, $c6Xmf._)($1bee5832b9fa8a3e$var$validMutationMethodsArr));
var $1bee5832b9fa8a3e$var$validRequestMethods = new Set($1bee5832b9fa8a3e$var$validRequestMethodsArr);
var $1bee5832b9fa8a3e$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
var $1bee5832b9fa8a3e$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
var $1bee5832b9fa8a3e$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
var $1bee5832b9fa8a3e$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
var $1bee5832b9fa8a3e$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
var $1bee5832b9fa8a3e$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $1bee5832b9fa8a3e$var$defaultMapRouteProperties = function(route) {
    return {
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    };
};
var $1bee5832b9fa8a3e$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $1bee5832b9fa8a3e$export$baddd0131ee8c05b(init) {
    var routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    var isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    var isServer = !isBrowser;
    $1bee5832b9fa8a3e$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    var mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        var detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = function(route) {
            return {
                hasErrorBoundary: detectErrorBoundary(route)
            };
        };
    } else mapRouteProperties = $1bee5832b9fa8a3e$var$defaultMapRouteProperties;
    // Routes keyed by ID
    var manifest = {};
    // Routes in tree format for matching
    var dataRoutes = $1bee5832b9fa8a3e$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    var inFlightDataRoutes;
    var basename = init.basename || "/";
    // Config driven behavior flags
    var future = $1bee5832b9fa8a3e$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_prependBasename: false
    }, init.future);
    // Cleanup function for history
    var unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    var subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    var savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    var getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    var getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    var initialScrollRestored = init.hydrationData != null;
    var initialMatches = $1bee5832b9fa8a3e$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    var initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        var error = $1bee5832b9fa8a3e$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        var _getShortCircuitMatches = $1bee5832b9fa8a3e$var$getShortCircuitMatches(dataRoutes), matches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
        initialMatches = matches;
        initialErrors = (0, $3sHb8._)({}, route.id, error);
    }
    var initialized = // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    !initialMatches.some(function(m) {
        return m.route.lazy;
    }) && // And we have to either have no loaders or have been provided hydrationData
    (!initialMatches.some(function(m) {
        return m.route.loader;
    }) || init.hydrationData != null);
    var router;
    var state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $1bee5832b9fa8a3e$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    var pendingAction = $1bee5832b9fa8a3e$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    var pendingPreventScrollReset = false;
    // AbortController for the active navigation
    var pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    var pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    var appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    var removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    var isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    var isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    var cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    var cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    var fetchControllers = new Map();
    // Track loads based on the order in which they started
    var incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    var pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    var fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    var fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    var fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    var activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    var deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    var activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    var blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    var ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen(function(_ref) {
            var historyAction = _ref.action, location = _ref.location, delta = _ref.delta;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $1bee5832b9fa8a3e$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            var blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed: function() {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset: function() {
                        var blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $1bee5832b9fa8a3e$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $1bee5832b9fa8a3e$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            var _saveAppliedTransitions = function() {
                return $1bee5832b9fa8a3e$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            };
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = function() {
                return routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
            };
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($1bee5832b9fa8a3e$export$e19cd5f9376f8cee.Pop, state.location);
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach(function(_, key) {
            return deleteFetcher(key);
        });
        state.blockers.forEach(function(_, key) {
            return deleteBlocker(key);
        });
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return function() {
            return subscribers.delete(fn);
        };
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, viewTransitionOpts) {
        state = $1bee5832b9fa8a3e$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        var completedFetchers = [];
        var deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach(function(fetcher, key) {
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        subscribers.forEach(function(subscriber) {
            return subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: viewTransitionOpts
            });
        });
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach(function(key) {
                return state.fetchers.delete(key);
            });
            deletedFetchersKeys.forEach(function(key) {
                return deleteFetcher(key);
            });
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState) {
        var _location$state, _location$state2;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        var isActionReload = state.actionData != null && state.navigation.formMethod != null && $1bee5832b9fa8a3e$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        var actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        var loaderData = newState.loaderData ? $1bee5832b9fa8a3e$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        var blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach(function(_, k) {
                return blockers.set(k, $1bee5832b9fa8a3e$export$386d57f03f0b2883);
            });
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        var preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $1bee5832b9fa8a3e$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $1bee5832b9fa8a3e$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $1bee5832b9fa8a3e$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $1bee5832b9fa8a3e$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        var viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $1bee5832b9fa8a3e$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            var priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            var toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($1bee5832b9fa8a3e$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $1bee5832b9fa8a3e$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), viewTransitionOpts);
        // Reset stateful navigation vars
        pendingAction = $1bee5832b9fa8a3e$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    function navigate(to, opts) {
        return _navigate.apply(this, arguments);
    }
    function _navigate() {
        _navigate = // Trigger a navigation event, which can either be a numerical POP or a PUSH
        // replace with an optional submission
        (0, $kSuI9._)(function(to, opts) {
            var normalizedPath, _normalizeNavigateOptions, path, submission, error, currentLocation, nextLocation, userReplace, historyAction, preventScrollReset, blockerKey;
            return (0, $l29cN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (typeof to === "number") {
                            init.history.go(to);
                            return [
                                2
                            ];
                        }
                        normalizedPath = $1bee5832b9fa8a3e$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
                        _normalizeNavigateOptions = $1bee5832b9fa8a3e$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
                        currentLocation = state.location;
                        nextLocation = $1bee5832b9fa8a3e$var$createLocation(state.location, path, opts && opts.state);
                        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
                        // URL from window.location, so we need to encode it here so the behavior
                        // remains the same as POP and non-data-router usages.  new URL() does all
                        // the same encoding we'd get from a history.pushState/window.location read
                        // without having to touch history
                        nextLocation = $1bee5832b9fa8a3e$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
                        userReplace = opts && opts.replace != null ? opts.replace : undefined;
                        historyAction = $1bee5832b9fa8a3e$export$e19cd5f9376f8cee.Push;
                        if (userReplace === true) historyAction = $1bee5832b9fa8a3e$export$e19cd5f9376f8cee.Replace;
                        else if (userReplace === false) ;
                        else if (submission != null && $1bee5832b9fa8a3e$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
                        // users don't have to double-click the back button to get to the prior
                        // location.  If the user redirects to a different location from the
                        // action/loader this will be ignored and the redirect will be a PUSH
                        historyAction = $1bee5832b9fa8a3e$export$e19cd5f9376f8cee.Replace;
                        preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
                        blockerKey = shouldBlockNavigation({
                            currentLocation: currentLocation,
                            nextLocation: nextLocation,
                            historyAction: historyAction
                        });
                        if (blockerKey) {
                            // Put the blocker into a blocked state
                            updateBlocker(blockerKey, {
                                state: "blocked",
                                location: nextLocation,
                                proceed: function() {
                                    updateBlocker(blockerKey, {
                                        state: "proceeding",
                                        proceed: undefined,
                                        reset: undefined,
                                        location: nextLocation
                                    });
                                    // Send the same navigation through
                                    navigate(to, opts);
                                },
                                reset: function() {
                                    var blockers = new Map(state.blockers);
                                    blockers.set(blockerKey, $1bee5832b9fa8a3e$export$386d57f03f0b2883);
                                    updateState({
                                        blockers: blockers
                                    });
                                }
                            });
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            startNavigation(historyAction, nextLocation, {
                                submission: submission,
                                // Send through the formData serialization error if we have one so we can
                                // render at the right error boundary after we match routes
                                pendingError: error,
                                preventScrollReset: preventScrollReset,
                                replace: opts && opts.replace,
                                enableViewTransition: opts && opts.unstable_viewTransition
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return _navigate.apply(this, arguments);
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    function startNavigation(historyAction, location, opts) {
        return _startNavigation.apply(this, arguments);
    }
    function _startNavigation() {
        _startNavigation = // Start a navigation to the given action/location.  Can optionally provide a
        // overrideNavigation which will override the normalLoad in the case of a redirect
        // navigation
        (0, $kSuI9._)(function(historyAction, location, opts) {
            var routesToUse, loadingNavigation, matches, error, _getShortCircuitMatches, notFoundMatches, route, request, pendingActionData, pendingError, actionOutput, _ref, shortCircuited, loaderData, errors;
            return (0, $l29cN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Abort any in-progress navigations and start a new one. Unset any ongoing
                        // uninterrupted revalidations unless told otherwise, since we want this
                        // new navigation to update history normally
                        pendingNavigationController && pendingNavigationController.abort();
                        pendingNavigationController = null;
                        pendingAction = historyAction;
                        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
                        // Save the current scroll position every time we start a new navigation,
                        // and track whether we should reset scroll on completion
                        saveScrollPosition(state.location, state.matches);
                        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
                        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        loadingNavigation = opts && opts.overrideNavigation;
                        matches = $1bee5832b9fa8a3e$export$2708184779ceb39d(routesToUse, location, basename);
                        // Short circuit with a 404 on the root error boundary if we match nothing
                        if (!matches) {
                            error = $1bee5832b9fa8a3e$var$getInternalRouterError(404, {
                                pathname: location.pathname
                            });
                            _getShortCircuitMatches = $1bee5832b9fa8a3e$var$getShortCircuitMatches(routesToUse), notFoundMatches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
                            // Cancel all pending deferred on 404s since we don't keep any routes
                            cancelActiveDeferreds();
                            completeNavigation(location, {
                                matches: notFoundMatches,
                                loaderData: {},
                                errors: (0, $3sHb8._)({}, route.id, error)
                            });
                            return [
                                2
                            ];
                        }
                        // Short circuit if it's only a hash change and not a revalidation or
                        // mutation submission.
                        //
                        // Ignore on initial page loads because since the initial load will always
                        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
                        // which will default to a navigation to /page
                        if (state.initialized && !isRevalidationRequired && $1bee5832b9fa8a3e$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $1bee5832b9fa8a3e$var$isMutationMethod(opts.submission.formMethod))) {
                            completeNavigation(location, {
                                matches: matches
                            });
                            return [
                                2
                            ];
                        }
                        // Create a controller/Request for this navigation
                        pendingNavigationController = new AbortController();
                        request = $1bee5832b9fa8a3e$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
                        if (!(opts && opts.pendingError)) return [
                            3,
                            1
                        ];
                        // If we have a pendingError, it means the user attempted a GET submission
                        // with binary FormData so assign here and skip to handleLoaders.  That
                        // way we handle calling loaders above the boundary etc.  It's not really
                        // different from an actionError in that sense.
                        pendingError = (0, $3sHb8._)({}, $1bee5832b9fa8a3e$var$findNearestBoundary(matches).route.id, opts.pendingError);
                        return [
                            3,
                            3
                        ];
                    case 1:
                        if (!(opts && opts.submission && $1bee5832b9fa8a3e$var$isMutationMethod(opts.submission.formMethod))) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            handleAction(request, location, opts.submission, matches, {
                                replace: opts.replace
                            })
                        ];
                    case 2:
                        actionOutput = _state.sent();
                        if (actionOutput.shortCircuited) return [
                            2
                        ];
                        pendingActionData = actionOutput.pendingActionData;
                        pendingError = actionOutput.pendingActionError;
                        loadingNavigation = $1bee5832b9fa8a3e$var$getLoadingNavigation(location, opts.submission);
                        // Create a GET request for the loaders
                        request = new Request(request.url, {
                            signal: request.signal
                        });
                        _state.label = 3;
                    case 3:
                        return [
                            4,
                            handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, pendingActionData, pendingError)
                        ];
                    case 4:
                        _ref = _state.sent(), shortCircuited = _ref.shortCircuited, loaderData = _ref.loaderData, errors = _ref.errors;
                        if (shortCircuited) return [
                            2
                        ];
                        // Clean up now that the action/loaders have completed.  Don't clean up if
                        // we short circuited because pendingNavigationController will have already
                        // been assigned to a new controller for the next navigation
                        pendingNavigationController = null;
                        completeNavigation(location, $1bee5832b9fa8a3e$var$_extends({
                            matches: matches
                        }, pendingActionData ? {
                            actionData: pendingActionData
                        } : {}, {
                            loaderData: loaderData,
                            errors: errors
                        }));
                        return [
                            2
                        ];
                }
            });
        });
        return _startNavigation.apply(this, arguments);
    }
    function handleAction(request, location, submission, matches, opts) {
        return _handleAction.apply(this, arguments);
    }
    function _handleAction() {
        _handleAction = // Call the action matched by the leaf route for this navigation and handle
        // redirects/errors
        (0, $kSuI9._)(function(request, location, submission, matches, opts) {
            var navigation, result, actionMatch, replace, boundaryMatch;
            return (0, $l29cN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (opts === void 0) opts = {};
                        interruptActiveLoads();
                        // Put us in a submitting state
                        navigation = $1bee5832b9fa8a3e$var$getSubmittingNavigation(location, submission);
                        updateState({
                            navigation: navigation
                        });
                        actionMatch = $1bee5832b9fa8a3e$var$getTargetMatch(matches, location);
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            1
                        ];
                        result = {
                            type: $1bee5832b9fa8a3e$var$ResultType.error,
                            error: $1bee5832b9fa8a3e$var$getInternalRouterError(405, {
                                method: request.method,
                                pathname: location.pathname,
                                routeId: actionMatch.route.id
                            })
                        };
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            $1bee5832b9fa8a3e$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename)
                        ];
                    case 2:
                        result = _state.sent();
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        _state.label = 3;
                    case 3:
                        if (!$1bee5832b9fa8a3e$var$isRedirectResult(result)) return [
                            3,
                            5
                        ];
                        if (opts && opts.replace != null) replace = opts.replace;
                        else // If the user didn't explicity indicate replace behavior, replace if
                        // we redirected to the exact same location we're currently at to avoid
                        // double back-buttons
                        replace = result.location === state.location.pathname + state.location.search;
                        return [
                            4,
                            startRedirectNavigation(state, result, {
                                submission: submission,
                                replace: replace
                            })
                        ];
                    case 4:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 5:
                        if ($1bee5832b9fa8a3e$var$isErrorResult(result)) {
                            // Store off the pending error - we use it to determine which loaders
                            // to call and will commit it when we complete the navigation
                            boundaryMatch = $1bee5832b9fa8a3e$var$findNearestBoundary(matches, actionMatch.route.id);
                            // By default, all submissions are REPLACE navigations, but if the
                            // action threw an error that'll be rendered in an errorElement, we fall
                            // back to PUSH so that the user can use the back button to get back to
                            // the pre-submission form location to try again
                            if ((opts && opts.replace) !== true) pendingAction = $1bee5832b9fa8a3e$export$e19cd5f9376f8cee.Push;
                            return [
                                2,
                                {
                                    // Send back an empty object we can use to clear out any prior actionData
                                    pendingActionData: {},
                                    pendingActionError: (0, $3sHb8._)({}, boundaryMatch.route.id, result.error)
                                }
                            ];
                        }
                        if ($1bee5832b9fa8a3e$var$isDeferredResult(result)) throw $1bee5832b9fa8a3e$var$getInternalRouterError(400, {
                            type: "defer-action"
                        });
                        return [
                            2,
                            {
                                pendingActionData: (0, $3sHb8._)({}, actionMatch.route.id, result.data)
                            }
                        ];
                }
            });
        });
        return _handleAction.apply(this, arguments);
    }
    function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, pendingActionData, pendingError) {
        return _handleLoaders.apply(this, arguments);
    }
    function _handleLoaders() {
        _handleLoaders = // Call all applicable loaders for the given matches, handling redirects,
        // errors, etc.
        (0, $kSuI9._)(function(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, pendingActionData, pendingError) {
            var loadingNavigation, activeSubmission, routesToUse, _getMatchesToLoad, matchesToLoad, revalidatingFetchers, updatedFetchers, actionData, abortPendingFetchRevalidations, _ref, results, loaderResults, fetcherResults, redirect, fetcherKey, _processLoaderData, loaderData, errors, updatedFetchers1, didAbortFetchLoads, shouldUpdateFetchers;
            return (0, $l29cN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Figure out the right navigation we want to use for data loading
                        loadingNavigation = overrideNavigation || $1bee5832b9fa8a3e$var$getLoadingNavigation(location, submission);
                        // If this was a redirect from an action we don't have a "submission" but
                        // we have it on the loading navigation so use that if available
                        activeSubmission = submission || fetcherSubmission || $1bee5832b9fa8a3e$var$getSubmissionFromNavigation(loadingNavigation);
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        _getMatchesToLoad = (0, $cv9Rk._)($1bee5832b9fa8a3e$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError), 2), matchesToLoad = _getMatchesToLoad[0], revalidatingFetchers = _getMatchesToLoad[1];
                        // Cancel pending deferreds for no-longer-matched routes or routes we're
                        // about to reload.  Note that if this is an action reload we would have
                        // already cancelled all pending deferreds so this would be a no-op
                        cancelActiveDeferreds(function(routeId) {
                            return !(matches && matches.some(function(m) {
                                return m.route.id === routeId;
                            })) || matchesToLoad && matchesToLoad.some(function(m) {
                                return m.route.id === routeId;
                            });
                        });
                        pendingNavigationLoadId = ++incrementingLoadId;
                        // Short circuit if we have no loaders to run
                        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
                            updatedFetchers = markFetchRedirectsDone();
                            completeNavigation(location, $1bee5832b9fa8a3e$var$_extends({
                                matches: matches,
                                loaderData: {},
                                // Commit pending error if we're short circuiting
                                errors: pendingError || null
                            }, pendingActionData ? {
                                actionData: pendingActionData
                            } : {}, updatedFetchers ? {
                                fetchers: new Map(state.fetchers)
                            } : {}));
                            return [
                                2,
                                {
                                    shortCircuited: true
                                }
                            ];
                        }
                        // If this is an uninterrupted revalidation, we remain in our current idle
                        // state.  If not, we need to switch to our loading state and load data,
                        // preserving any new action data or existing action data (in the case of
                        // a revalidation interrupting an actionReload)
                        if (!isUninterruptedRevalidation) {
                            revalidatingFetchers.forEach(function(rf) {
                                var fetcher = state.fetchers.get(rf.key);
                                var revalidatingFetcher = $1bee5832b9fa8a3e$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                                state.fetchers.set(rf.key, revalidatingFetcher);
                            });
                            actionData = pendingActionData || state.actionData;
                            updateState($1bee5832b9fa8a3e$var$_extends({
                                navigation: loadingNavigation
                            }, actionData ? Object.keys(actionData).length === 0 ? {
                                actionData: null
                            } : {
                                actionData: actionData
                            } : {}, revalidatingFetchers.length > 0 ? {
                                fetchers: new Map(state.fetchers)
                            } : {}));
                        }
                        revalidatingFetchers.forEach(function(rf) {
                            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
                            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
                            // (via deleteFetcher) does not abort the triggering navigation that
                            // triggered the revalidation
                            fetchControllers.set(rf.key, rf.controller);
                        });
                        // Proxy navigation abort through to revalidation fetchers
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(f) {
                                return abortFetcher(f.key);
                            });
                        };
                        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request)
                        ];
                    case 1:
                        _ref = _state.sent(), results = _ref.results, loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        // Clean up _after_ loaders have completed.  Don't clean up if we short
                        // circuited because fetchControllers would have been aborted and
                        // reassigned to new controllers for the next navigation
                        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        revalidatingFetchers.forEach(function(rf) {
                            return fetchControllers.delete(rf.key);
                        });
                        // If any loaders returned a redirect Response, start a new REPLACE navigation
                        redirect = $1bee5832b9fa8a3e$var$findRedirect(results);
                        if (!redirect) return [
                            3,
                            3
                        ];
                        if (redirect.idx >= matchesToLoad.length) {
                            // If this redirect came from a fetcher make sure we mark it in
                            // fetchRedirectIds so it doesn't get revalidated on the next set of
                            // loader executions
                            fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                            fetchRedirectIds.add(fetcherKey);
                        }
                        return [
                            4,
                            startRedirectNavigation(state, redirect.result, {
                                replace: replace
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 3:
                        // Process and commit output from loaders
                        _processLoaderData = $1bee5832b9fa8a3e$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        // Wire up subscribers to update loaderData as promises settle
                        activeDeferreds.forEach(function(deferredData, routeId) {
                            deferredData.subscribe(function(aborted) {
                                // Note: No need to updateState here since the TrackedPromise on
                                // loaderData is stable across resolve/reject
                                // Remove this instance if we were aborted or if promises have settled
                                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
                            });
                        });
                        updatedFetchers1 = markFetchRedirectsDone();
                        didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
                        shouldUpdateFetchers = updatedFetchers1 || didAbortFetchLoads || revalidatingFetchers.length > 0;
                        return [
                            2,
                            $1bee5832b9fa8a3e$var$_extends({
                                loaderData: loaderData,
                                errors: errors
                            }, shouldUpdateFetchers ? {
                                fetchers: new Map(state.fetchers)
                            } : {})
                        ];
                }
            });
        });
        return _handleLoaders.apply(this, arguments);
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $1bee5832b9fa8a3e$export$52eace9c284d3585;
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        var routesToUse = inFlightDataRoutes || dataRoutes;
        var normalizedPath = $1bee5832b9fa8a3e$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, routeId, opts == null ? void 0 : opts.relative);
        var matches = $1bee5832b9fa8a3e$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $1bee5832b9fa8a3e$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }));
            return;
        }
        var _normalizeNavigateOptions = $1bee5832b9fa8a3e$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
        if (error) {
            setFetcherError(key, routeId, error);
            return;
        }
        var match = $1bee5832b9fa8a3e$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $1bee5832b9fa8a3e$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, submission);
    }
    function handleFetcherAction(key, routeId, path, match, requestMatches, submission) {
        return _handleFetcherAction.apply(this, arguments);
    }
    function _handleFetcherAction() {
        _handleFetcherAction = // Call the action for the matched fetcher.submit(), and then handle redirects,
        // errors, and revalidation
        (0, $kSuI9._)(function(key, routeId, path, match, requestMatches, submission) {
            var error, existingFetcher, fetcher, abortController, fetchRequest, originatingLoadId, actionResult, doneFetcher, loadingFetcher, nextLocation, revalidationRequest, routesToUse, matches, loadId, loadFetcher, _getMatchesToLoad, matchesToLoad, revalidatingFetchers, abortPendingFetchRevalidations, _ref, results, loaderResults, fetcherResults, redirect, fetcherKey, _processLoaderData, loaderData, errors, doneFetcher1;
            return (0, $l29cN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        interruptActiveLoads();
                        fetchLoadMatches.delete(key);
                        if (!match.route.action && !match.route.lazy) {
                            error = $1bee5832b9fa8a3e$var$getInternalRouterError(405, {
                                method: submission.formMethod,
                                pathname: path,
                                routeId: routeId
                            });
                            setFetcherError(key, routeId, error);
                            return [
                                2
                            ];
                        }
                        // Put this fetcher into it's submitting state
                        existingFetcher = state.fetchers.get(key);
                        fetcher = $1bee5832b9fa8a3e$var$getSubmittingFetcher(submission, existingFetcher);
                        state.fetchers.set(key, fetcher);
                        updateState({
                            fetchers: new Map(state.fetchers)
                        });
                        // Call the action for the fetcher
                        abortController = new AbortController();
                        fetchRequest = $1bee5832b9fa8a3e$var$createClientSideRequest(init.history, path, abortController.signal, submission);
                        fetchControllers.set(key, abortController);
                        originatingLoadId = incrementingLoadId;
                        return [
                            4,
                            $1bee5832b9fa8a3e$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename)
                        ];
                    case 1:
                        actionResult = _state.sent();
                        if (fetchRequest.signal.aborted) {
                            // We can delete this so long as we weren't aborted by our own fetcher
                            // re-submit which would have put _new_ controller is in fetchControllers
                            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
                            return [
                                2
                            ];
                        }
                        if (deletedFetchers.has(key)) {
                            state.fetchers.set(key, $1bee5832b9fa8a3e$var$getDoneFetcher(undefined));
                            updateState({
                                fetchers: new Map(state.fetchers)
                            });
                            return [
                                2
                            ];
                        }
                        if ($1bee5832b9fa8a3e$var$isRedirectResult(actionResult)) {
                            fetchControllers.delete(key);
                            if (pendingNavigationLoadId > originatingLoadId) {
                                // A new navigation was kicked off after our action started, so that
                                // should take precedence over this redirect navigation.  We already
                                // set isRevalidationRequired so all loaders for the new route should
                                // fire unless opted out via shouldRevalidate
                                doneFetcher = $1bee5832b9fa8a3e$var$getDoneFetcher(undefined);
                                state.fetchers.set(key, doneFetcher);
                                updateState({
                                    fetchers: new Map(state.fetchers)
                                });
                                return [
                                    2
                                ];
                            } else {
                                fetchRedirectIds.add(key);
                                loadingFetcher = $1bee5832b9fa8a3e$var$getLoadingFetcher(submission);
                                state.fetchers.set(key, loadingFetcher);
                                updateState({
                                    fetchers: new Map(state.fetchers)
                                });
                                return [
                                    2,
                                    startRedirectNavigation(state, actionResult, {
                                        fetcherSubmission: submission
                                    })
                                ];
                            }
                        }
                        // Process any non-redirect errors thrown
                        if ($1bee5832b9fa8a3e$var$isErrorResult(actionResult)) {
                            setFetcherError(key, routeId, actionResult.error);
                            return [
                                2
                            ];
                        }
                        if ($1bee5832b9fa8a3e$var$isDeferredResult(actionResult)) throw $1bee5832b9fa8a3e$var$getInternalRouterError(400, {
                            type: "defer-action"
                        });
                        // Start the data load for current matches, or the next location if we're
                        // in the middle of a navigation
                        nextLocation = state.navigation.location || state.location;
                        revalidationRequest = $1bee5832b9fa8a3e$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        matches = state.navigation.state !== "idle" ? $1bee5832b9fa8a3e$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
                        $1bee5832b9fa8a3e$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
                        loadId = ++incrementingLoadId;
                        fetchReloadIds.set(key, loadId);
                        loadFetcher = $1bee5832b9fa8a3e$var$getLoadingFetcher(submission, actionResult.data);
                        state.fetchers.set(key, loadFetcher);
                        _getMatchesToLoad = (0, $cv9Rk._)($1bee5832b9fa8a3e$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, (0, $3sHb8._)({}, match.route.id, actionResult.data), undefined // No need to send through errors since we short circuit above
                        ), 2), matchesToLoad = _getMatchesToLoad[0], revalidatingFetchers = _getMatchesToLoad[1];
                        // Put all revalidating fetchers into the loading state, except for the
                        // current fetcher which we want to keep in it's current loading state which
                        // contains it's action submission info + action data
                        revalidatingFetchers.filter(function(rf) {
                            return rf.key !== key;
                        }).forEach(function(rf) {
                            var staleKey = rf.key;
                            var existingFetcher = state.fetchers.get(staleKey);
                            var revalidatingFetcher = $1bee5832b9fa8a3e$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
                            state.fetchers.set(staleKey, revalidatingFetcher);
                            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
                            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
                        });
                        updateState({
                            fetchers: new Map(state.fetchers)
                        });
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(rf) {
                                return abortFetcher(rf.key);
                            });
                        };
                        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest)
                        ];
                    case 2:
                        _ref = _state.sent(), results = _ref.results, loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (abortController.signal.aborted) return [
                            2
                        ];
                        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        fetchReloadIds.delete(key);
                        fetchControllers.delete(key);
                        revalidatingFetchers.forEach(function(r) {
                            return fetchControllers.delete(r.key);
                        });
                        redirect = $1bee5832b9fa8a3e$var$findRedirect(results);
                        if (redirect) {
                            if (redirect.idx >= matchesToLoad.length) {
                                // If this redirect came from a fetcher make sure we mark it in
                                // fetchRedirectIds so it doesn't get revalidated on the next set of
                                // loader executions
                                fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                                fetchRedirectIds.add(fetcherKey);
                            }
                            return [
                                2,
                                startRedirectNavigation(state, redirect.result)
                            ];
                        }
                        // Process and commit output from loaders
                        _processLoaderData = $1bee5832b9fa8a3e$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        // Since we let revalidations complete even if the submitting fetcher was
                        // deleted, only put it back to idle if it hasn't been deleted
                        if (state.fetchers.has(key)) {
                            doneFetcher1 = $1bee5832b9fa8a3e$var$getDoneFetcher(actionResult.data);
                            state.fetchers.set(key, doneFetcher1);
                        }
                        abortStaleFetchLoads(loadId);
                        // If we are currently in a navigation loading state and this fetcher is
                        // more recent than the navigation, we want the newer data so abort the
                        // navigation and complete it with the fetcher data
                        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
                            $1bee5832b9fa8a3e$export$3e9cee6b33872309(pendingAction, "Expected pending action");
                            pendingNavigationController && pendingNavigationController.abort();
                            completeNavigation(state.navigation.location, {
                                matches: matches,
                                loaderData: loaderData,
                                errors: errors,
                                fetchers: new Map(state.fetchers)
                            });
                        } else {
                            // otherwise just update with the fetcher data, preserving any existing
                            // loaderData for loaders that did not need to reload.  We have to
                            // manually merge here since we aren't going through completeNavigation
                            updateState({
                                errors: errors,
                                loaderData: $1bee5832b9fa8a3e$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                                fetchers: new Map(state.fetchers)
                            });
                            isRevalidationRequired = false;
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return _handleFetcherAction.apply(this, arguments);
    }
    function handleFetcherLoader(key, routeId, path, match, matches, submission) {
        return _handleFetcherLoader.apply(this, arguments);
    }
    function _handleFetcherLoader() {
        _handleFetcherLoader = // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
        (0, $kSuI9._)(function(key, routeId, path, match, matches, submission) {
            var existingFetcher, loadingFetcher, abortController, fetchRequest, originatingLoadId, result, doneFetcher, doneFetcher1;
            return (0, $l29cN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        existingFetcher = state.fetchers.get(key);
                        // Put this fetcher into it's loading state
                        loadingFetcher = $1bee5832b9fa8a3e$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined);
                        state.fetchers.set(key, loadingFetcher);
                        updateState({
                            fetchers: new Map(state.fetchers)
                        });
                        // Call the loader for this fetcher route match
                        abortController = new AbortController();
                        fetchRequest = $1bee5832b9fa8a3e$var$createClientSideRequest(init.history, path, abortController.signal);
                        fetchControllers.set(key, abortController);
                        originatingLoadId = incrementingLoadId;
                        return [
                            4,
                            $1bee5832b9fa8a3e$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename)
                        ];
                    case 1:
                        result = _state.sent();
                        if (!$1bee5832b9fa8a3e$var$isDeferredResult(result)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            $1bee5832b9fa8a3e$var$resolveDeferredData(result, fetchRequest.signal, true)
                        ];
                    case 2:
                        result = _state.sent() || result;
                        _state.label = 3;
                    case 3:
                        // We can delete this so long as we weren't aborted by our our own fetcher
                        // re-load which would have put _new_ controller is in fetchControllers
                        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
                        if (fetchRequest.signal.aborted) return [
                            2
                        ];
                        if (deletedFetchers.has(key)) {
                            state.fetchers.set(key, $1bee5832b9fa8a3e$var$getDoneFetcher(undefined));
                            updateState({
                                fetchers: new Map(state.fetchers)
                            });
                            return [
                                2
                            ];
                        }
                        if (!$1bee5832b9fa8a3e$var$isRedirectResult(result)) return [
                            3,
                            6
                        ];
                        if (!(pendingNavigationLoadId > originatingLoadId)) return [
                            3,
                            4
                        ];
                        // A new navigation was kicked off after our loader started, so that
                        // should take precedence over this redirect navigation
                        doneFetcher = $1bee5832b9fa8a3e$var$getDoneFetcher(undefined);
                        state.fetchers.set(key, doneFetcher);
                        updateState({
                            fetchers: new Map(state.fetchers)
                        });
                        return [
                            2
                        ];
                    case 4:
                        fetchRedirectIds.add(key);
                        return [
                            4,
                            startRedirectNavigation(state, result)
                        ];
                    case 5:
                        _state.sent();
                        return [
                            2
                        ];
                    case 6:
                        // Process any non-redirect errors thrown
                        if ($1bee5832b9fa8a3e$var$isErrorResult(result)) {
                            setFetcherError(key, routeId, result.error);
                            return [
                                2
                            ];
                        }
                        $1bee5832b9fa8a3e$export$3e9cee6b33872309(!$1bee5832b9fa8a3e$var$isDeferredResult(result), "Unhandled fetcher deferred data");
                        // Put the fetcher back into an idle state
                        doneFetcher1 = $1bee5832b9fa8a3e$var$getDoneFetcher(result.data);
                        state.fetchers.set(key, doneFetcher1);
                        updateState({
                            fetchers: new Map(state.fetchers)
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return _handleFetcherLoader.apply(this, arguments);
    }
    function startRedirectNavigation(state, redirect, _temp) {
        return _startRedirectNavigation.apply(this, arguments);
    }
    function _startRedirectNavigation() {
        _startRedirectNavigation = /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ (0, $kSuI9._)(function(state, redirect, _temp) {
            var _ref, submission, fetcherSubmission, replace, redirectLocation, isDocumentReload, url, redirectHistoryAction, _state_navigation, formMethod, formAction, formEncType, activeSubmission, overrideNavigation;
            return (0, $l29cN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp === void 0 ? {} : _temp, submission = _ref.submission, fetcherSubmission = _ref.fetcherSubmission, replace = _ref.replace;
                        if (redirect.revalidate) isRevalidationRequired = true;
                        redirectLocation = $1bee5832b9fa8a3e$var$createLocation(state.location, redirect.location, {
                            _isRedirect: true
                        });
                        $1bee5832b9fa8a3e$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
                        if (isBrowser) {
                            isDocumentReload = false;
                            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
                            isDocumentReload = true;
                            else if ($1bee5832b9fa8a3e$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                                url = init.history.createURL(redirect.location);
                                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                                $1bee5832b9fa8a3e$export$b69e3301ce081aa3(url.pathname, basename) == null;
                            }
                            if (isDocumentReload) {
                                if (replace) routerWindow.location.replace(redirect.location);
                                else routerWindow.location.assign(redirect.location);
                                return [
                                    2
                                ];
                            }
                        }
                        // There's no need to abort on redirects, since we don't detect the
                        // redirect until the action/loaders have settled
                        pendingNavigationController = null;
                        redirectHistoryAction = replace === true ? $1bee5832b9fa8a3e$export$e19cd5f9376f8cee.Replace : $1bee5832b9fa8a3e$export$e19cd5f9376f8cee.Push;
                        // Use the incoming submission if provided, fallback on the active one in
                        // state.navigation
                        _state_navigation = state.navigation, formMethod = _state_navigation.formMethod, formAction = _state_navigation.formAction, formEncType = _state_navigation.formEncType;
                        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $1bee5832b9fa8a3e$var$getSubmissionFromNavigation(state.navigation);
                        // If this was a 307/308 submission we want to preserve the HTTP method and
                        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
                        // redirected location
                        activeSubmission = submission || fetcherSubmission;
                        if (!($1bee5832b9fa8a3e$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $1bee5832b9fa8a3e$var$isMutationMethod(activeSubmission.formMethod))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                submission: $1bee5832b9fa8a3e$var$_extends({}, activeSubmission, {
                                    formAction: redirect.location
                                }),
                                // Preserve this flag across redirects
                                preventScrollReset: pendingPreventScrollReset
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        // If we have a navigation submission, we will preserve it through the
                        // redirect navigation
                        overrideNavigation = $1bee5832b9fa8a3e$var$getLoadingNavigation(redirectLocation, submission);
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                overrideNavigation: overrideNavigation,
                                // Send fetcher submissions through for shouldRevalidate
                                fetcherSubmission: fetcherSubmission,
                                // Preserve this flag across redirects
                                preventScrollReset: pendingPreventScrollReset
                            })
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _startRedirectNavigation.apply(this, arguments);
    }
    function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        return _callLoadersAndMaybeResolveData.apply(this, arguments);
    }
    function _callLoadersAndMaybeResolveData() {
        _callLoadersAndMaybeResolveData = (0, $kSuI9._)(function(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
            var results, loaderResults, fetcherResults;
            return (0, $l29cN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            Promise.all((0, $c6Xmf._)(matchesToLoad.map(function(match) {
                                return $1bee5832b9fa8a3e$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename);
                            })).concat((0, $c6Xmf._)(fetchersToLoad.map(function(f) {
                                if (f.matches && f.match && f.controller) return $1bee5832b9fa8a3e$var$callLoaderOrAction("loader", $1bee5832b9fa8a3e$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename);
                                else {
                                    var error = {
                                        type: $1bee5832b9fa8a3e$var$ResultType.error,
                                        error: $1bee5832b9fa8a3e$var$getInternalRouterError(404, {
                                            pathname: f.path
                                        })
                                    };
                                    return error;
                                }
                            }))))
                        ];
                    case 1:
                        results = _state.sent();
                        loaderResults = results.slice(0, matchesToLoad.length);
                        fetcherResults = results.slice(matchesToLoad.length);
                        return [
                            4,
                            Promise.all([
                                $1bee5832b9fa8a3e$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(function() {
                                    return request.signal;
                                }), false, state.loaderData),
                                $1bee5832b9fa8a3e$var$resolveDeferredResults(currentMatches, fetchersToLoad.map(function(f) {
                                    return f.match;
                                }), fetcherResults, fetchersToLoad.map(function(f) {
                                    return f.controller ? f.controller.signal : null;
                                }), true)
                            ])
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            {
                                results: results,
                                loaderResults: loaderResults,
                                fetcherResults: fetcherResults
                            }
                        ];
                }
            });
        });
        return _callLoadersAndMaybeResolveData.apply(this, arguments);
    }
    function interruptActiveLoads() {
        var // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        _cancelledDeferredRoutes;
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        (_cancelledDeferredRoutes = cancelledDeferredRoutes).push.apply(_cancelledDeferredRoutes, (0, $c6Xmf._)(cancelActiveDeferreds()));
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach(function(_, key) {
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function setFetcherError(key, routeId, error) {
        var boundaryMatch = $1bee5832b9fa8a3e$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: (0, $3sHb8._)({}, boundaryMatch.route.id, error),
            fetchers: new Map(state.fetchers)
        });
    }
    function deleteFetcher(key) {
        var fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            var count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        var controller = fetchControllers.get(key);
        $1bee5832b9fa8a3e$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = getFetcher(key);
                var doneFetcher = $1bee5832b9fa8a3e$var$getDoneFetcher(fetcher.data);
                state.fetchers.set(key, doneFetcher);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function markFetchRedirectsDone() {
        var doneKeys = [];
        var updatedFetchers = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchRedirectIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = state.fetchers.get(key);
                $1bee5832b9fa8a3e$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
                if (fetcher.state === "loading") {
                    fetchRedirectIds.delete(key);
                    doneKeys.push(key);
                    updatedFetchers = true;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        var yeetedKeys = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchReloadIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $cv9Rk._)(_step.value, 2), key = _step_value[0], id = _step_value[1];
                if (id < landedId) {
                    var fetcher = state.fetchers.get(key);
                    $1bee5832b9fa8a3e$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
                    if (fetcher.state === "loading") {
                        abortFetcher(key);
                        fetchReloadIds.delete(key);
                        yeetedKeys.push(key);
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        var blocker = state.blockers.get(key) || $1bee5832b9fa8a3e$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        var blocker = state.blockers.get(key) || $1bee5832b9fa8a3e$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $1bee5832b9fa8a3e$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        var blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        var currentLocation = _ref2.currentLocation, nextLocation = _ref2.nextLocation, historyAction = _ref2.historyAction;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $1bee5832b9fa8a3e$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        var entries = Array.from(blockerFunctions.entries());
        var _entries_ = (0, $cv9Rk._)(entries[entries.length - 1], 2), blockerKey = _entries_[0], blockerFunction = _entries_[1];
        var blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        var cancelledRouteIds = [];
        activeDeferreds.forEach(function(dfd, routeId) {
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $1bee5832b9fa8a3e$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            var y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return function() {
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            var key = getScrollRestorationKey(location, matches.map(function(m) {
                return $1bee5832b9fa8a3e$export$b3fac024fad9e8ff(m, state.loaderData);
            }));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            var key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            var key = getScrollKey(location, matches);
            var y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $1bee5832b9fa8a3e$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: function(to) {
            return init.history.createHref(to);
        },
        encodeLocation: function(to) {
            return init.history.encodeLocation(to);
        },
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes: _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
var $1bee5832b9fa8a3e$export$4d0306f8f6a4585b = Symbol("deferred");
function $1bee5832b9fa8a3e$export$3336b097a6fbc59a(routes, opts) {
    $1bee5832b9fa8a3e$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    var manifest = {};
    var basename = (opts ? opts.basename : null) || "/";
    var mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        var detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = function(route) {
            return {
                hasErrorBoundary: detectErrorBoundary(route)
            };
        };
    } else mapRouteProperties = $1bee5832b9fa8a3e$var$defaultMapRouteProperties;
    var dataRoutes = $1bee5832b9fa8a3e$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    function query(request, _temp2) {
        return _query.apply(this, arguments);
    }
    function _query() {
        _query = /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ (0, $kSuI9._)(function(request, _temp2) {
            var requestContext, url, method, location, matches, error, _getShortCircuitMatches, methodNotAllowedMatches, route, error1, _getShortCircuitMatches1, notFoundMatches, route1, result;
            return (0, $l29cN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        requestContext = (_temp2 === void 0 ? {} : _temp2).requestContext;
                        url = new URL(request.url);
                        method = request.method;
                        location = $1bee5832b9fa8a3e$var$createLocation("", $1bee5832b9fa8a3e$export$fe53371bee54353d(url), null, "default");
                        matches = $1bee5832b9fa8a3e$export$2708184779ceb39d(dataRoutes, location, basename);
                        // SSR supports HEAD requests while SPA doesn't
                        if (!$1bee5832b9fa8a3e$var$isValidMethod(method) && method !== "HEAD") {
                            error = $1bee5832b9fa8a3e$var$getInternalRouterError(405, {
                                method: method
                            });
                            _getShortCircuitMatches = $1bee5832b9fa8a3e$var$getShortCircuitMatches(dataRoutes), methodNotAllowedMatches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
                            return [
                                2,
                                {
                                    basename: basename,
                                    location: location,
                                    matches: methodNotAllowedMatches,
                                    loaderData: {},
                                    actionData: null,
                                    errors: (0, $3sHb8._)({}, route.id, error),
                                    statusCode: error.status,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        } else if (!matches) {
                            error1 = $1bee5832b9fa8a3e$var$getInternalRouterError(404, {
                                pathname: location.pathname
                            });
                            _getShortCircuitMatches1 = $1bee5832b9fa8a3e$var$getShortCircuitMatches(dataRoutes), notFoundMatches = _getShortCircuitMatches1.matches, route1 = _getShortCircuitMatches1.route;
                            return [
                                2,
                                {
                                    basename: basename,
                                    location: location,
                                    matches: notFoundMatches,
                                    loaderData: {},
                                    actionData: null,
                                    errors: (0, $3sHb8._)({}, route1.id, error1),
                                    statusCode: error1.status,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        }
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext)
                        ];
                    case 1:
                        result = _state.sent();
                        if ($1bee5832b9fa8a3e$var$isResponse(result)) return [
                            2,
                            result
                        ];
                        // When returning StaticHandlerContext, we patch back in the location here
                        // since we need it for React Context.  But this helps keep our submit and
                        // loadRouteData operating on a Request instead of a Location
                        return [
                            2,
                            $1bee5832b9fa8a3e$var$_extends({
                                location: location,
                                basename: basename
                            }, result)
                        ];
                }
            });
        });
        return _query.apply(this, arguments);
    }
    function queryRoute(request, _temp3) {
        return _queryRoute.apply(this, arguments);
    }
    function _queryRoute() {
        _queryRoute = /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ (0, $kSuI9._)(function(request, _temp3) {
            var _ref, routeId, requestContext, url, method, location, matches, match, result, error, _result$activeDeferre, data;
            return (0, $l29cN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp3 === void 0 ? {} : _temp3, routeId = _ref.routeId, requestContext = _ref.requestContext;
                        url = new URL(request.url);
                        method = request.method;
                        location = $1bee5832b9fa8a3e$var$createLocation("", $1bee5832b9fa8a3e$export$fe53371bee54353d(url), null, "default");
                        matches = $1bee5832b9fa8a3e$export$2708184779ceb39d(dataRoutes, location, basename);
                        // SSR supports HEAD requests while SPA doesn't
                        if (!$1bee5832b9fa8a3e$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $1bee5832b9fa8a3e$var$getInternalRouterError(405, {
                            method: method
                        });
                        else if (!matches) throw $1bee5832b9fa8a3e$var$getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        match = routeId ? matches.find(function(m) {
                            return m.route.id === routeId;
                        }) : $1bee5832b9fa8a3e$var$getTargetMatch(matches, location);
                        if (routeId && !match) throw $1bee5832b9fa8a3e$var$getInternalRouterError(403, {
                            pathname: location.pathname,
                            routeId: routeId
                        });
                        else if (!match) // This should never hit I don't think?
                        throw $1bee5832b9fa8a3e$var$getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext, match)
                        ];
                    case 1:
                        result = _state.sent();
                        if ($1bee5832b9fa8a3e$var$isResponse(result)) return [
                            2,
                            result
                        ];
                        error = result.errors ? Object.values(result.errors)[0] : undefined;
                        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
                        // _something_ that wasn't a Response, but it's not guaranteed/required
                        // to be an `instanceof Error` either, so we have to use throw here to
                        // preserve the "error" state outside of queryImpl.
                        throw error;
                        // Pick off the right state value to return
                        if (result.actionData) return [
                            2,
                            Object.values(result.actionData)[0]
                        ];
                        if (result.loaderData) {
                            ;
                            data = Object.values(result.loaderData)[0];
                            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$1bee5832b9fa8a3e$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
                            return [
                                2,
                                data
                            ];
                        }
                        return [
                            2,
                            undefined
                        ];
                }
            });
        });
        return _queryRoute.apply(this, arguments);
    }
    function queryImpl(request, location, matches, requestContext, routeMatch) {
        return _queryImpl.apply(this, arguments);
    }
    function _queryImpl() {
        _queryImpl = (0, $kSuI9._)(function(request, location, matches, requestContext, routeMatch) {
            var result, result1, e;
            return (0, $l29cN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        $1bee5832b9fa8a3e$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        if (!$1bee5832b9fa8a3e$var$isMutationMethod(request.method.toLowerCase())) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            submit(request, matches, routeMatch || $1bee5832b9fa8a3e$var$getTargetMatch(matches, location), requestContext, routeMatch != null)
                        ];
                    case 2:
                        result = _state.sent();
                        return [
                            2,
                            result
                        ];
                    case 3:
                        return [
                            4,
                            loadRouteData(request, matches, requestContext, routeMatch)
                        ];
                    case 4:
                        result1 = _state.sent();
                        return [
                            2,
                            $1bee5832b9fa8a3e$var$isResponse(result1) ? result1 : $1bee5832b9fa8a3e$var$_extends({}, result1, {
                                actionData: null,
                                actionHeaders: {}
                            })
                        ];
                    case 5:
                        e = _state.sent();
                        // If the user threw/returned a Response in callLoaderOrAction, we throw
                        // it to bail out and then return or throw here based on whether the user
                        // returned or threw
                        if ($1bee5832b9fa8a3e$var$isQueryRouteResponse(e)) {
                            if (e.type === $1bee5832b9fa8a3e$var$ResultType.error) throw e.response;
                            return [
                                2,
                                e.response
                            ];
                        }
                        // Redirects are always returned since they don't propagate to catch
                        // boundaries
                        if ($1bee5832b9fa8a3e$var$isRedirectResponse(e)) return [
                            2,
                            e
                        ];
                        throw e;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return _queryImpl.apply(this, arguments);
    }
    function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        return _submit.apply(this, arguments);
    }
    function _submit() {
        _submit = (0, $kSuI9._)(function(request, matches, actionMatch, requestContext, isRouteRequest) {
            var result, error, method, error1, boundaryMatch, context, loaderRequest, context1;
            return (0, $l29cN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            1
                        ];
                        error = $1bee5832b9fa8a3e$var$getInternalRouterError(405, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: actionMatch.route.id
                        });
                        if (isRouteRequest) throw error;
                        result = {
                            type: $1bee5832b9fa8a3e$var$ResultType.error,
                            error: error
                        };
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            $1bee5832b9fa8a3e$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, {
                                isStaticRequest: true,
                                isRouteRequest: isRouteRequest,
                                requestContext: requestContext
                            })
                        ];
                    case 2:
                        result = _state.sent();
                        if (request.signal.aborted) {
                            method = isRouteRequest ? "queryRoute" : "query";
                            throw new Error(method + "() call aborted: " + request.method + " " + request.url);
                        }
                        _state.label = 3;
                    case 3:
                        if ($1bee5832b9fa8a3e$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
                        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
                        // can get back on the "throw all redirect responses" train here should
                        // this ever happen :/
                        throw new Response(null, {
                            status: result.status,
                            headers: {
                                Location: result.location
                            }
                        });
                        if ($1bee5832b9fa8a3e$var$isDeferredResult(result)) {
                            error1 = $1bee5832b9fa8a3e$var$getInternalRouterError(400, {
                                type: "defer-action"
                            });
                            if (isRouteRequest) throw error1;
                            result = {
                                type: $1bee5832b9fa8a3e$var$ResultType.error,
                                error: error1
                            };
                        }
                        if (isRouteRequest) {
                            // Note: This should only be non-Response values if we get here, since
                            // isRouteRequest should throw any Response received in callLoaderOrAction
                            if ($1bee5832b9fa8a3e$var$isErrorResult(result)) throw result.error;
                            return [
                                2,
                                {
                                    matches: [
                                        actionMatch
                                    ],
                                    loaderData: {},
                                    actionData: (0, $3sHb8._)({}, actionMatch.route.id, result.data),
                                    errors: null,
                                    // Note: statusCode + headers are unused here since queryRoute will
                                    // return the raw Response or value
                                    statusCode: 200,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        }
                        if (!$1bee5832b9fa8a3e$var$isErrorResult(result)) return [
                            3,
                            5
                        ];
                        // Store off the pending error - we use it to determine which loaders
                        // to call and will commit it when we complete the navigation
                        boundaryMatch = $1bee5832b9fa8a3e$var$findNearestBoundary(matches, actionMatch.route.id);
                        return [
                            4,
                            loadRouteData(request, matches, requestContext, undefined, (0, $3sHb8._)({}, boundaryMatch.route.id, result.error))
                        ];
                    case 4:
                        context = _state.sent();
                        // action status codes take precedence over loader status codes
                        return [
                            2,
                            $1bee5832b9fa8a3e$var$_extends({}, context, {
                                statusCode: $1bee5832b9fa8a3e$export$972111febbeef05b(result.error) ? result.error.status : 500,
                                actionData: null,
                                actionHeaders: $1bee5832b9fa8a3e$var$_extends({}, result.headers ? (0, $3sHb8._)({}, actionMatch.route.id, result.headers) : {})
                            })
                        ];
                    case 5:
                        // Create a GET request for the loaders
                        loaderRequest = new Request(request.url, {
                            headers: request.headers,
                            redirect: request.redirect,
                            signal: request.signal
                        });
                        return [
                            4,
                            loadRouteData(loaderRequest, matches, requestContext)
                        ];
                    case 6:
                        context1 = _state.sent();
                        return [
                            2,
                            $1bee5832b9fa8a3e$var$_extends({}, context1, result.statusCode ? {
                                statusCode: result.statusCode
                            } : {}, {
                                actionData: (0, $3sHb8._)({}, actionMatch.route.id, result.data),
                                actionHeaders: $1bee5832b9fa8a3e$var$_extends({}, result.headers ? (0, $3sHb8._)({}, actionMatch.route.id, result.headers) : {})
                            })
                        ];
                }
            });
        });
        return _submit.apply(this, arguments);
    }
    function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        return _loadRouteData.apply(this, arguments);
    }
    function _loadRouteData() {
        _loadRouteData = (0, $kSuI9._)(function(request, matches, requestContext, routeMatch, pendingActionError) {
            var isRouteRequest, requestMatches, matchesToLoad, results, method, activeDeferreds, context, executedLoaders;
            return (0, $l29cN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isRouteRequest = routeMatch != null;
                        // Short circuit if we have no loaders to run (queryRoute())
                        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $1bee5832b9fa8a3e$var$getInternalRouterError(400, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: routeMatch == null ? void 0 : routeMatch.route.id
                        });
                        requestMatches = routeMatch ? [
                            routeMatch
                        ] : $1bee5832b9fa8a3e$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
                        matchesToLoad = requestMatches.filter(function(m) {
                            return m.route.loader || m.route.lazy;
                        });
                        // Short circuit if we have no loaders to run (query())
                        if (matchesToLoad.length === 0) return [
                            2,
                            {
                                matches: matches,
                                // Add a null for all matched routes for proper revalidation on the client
                                loaderData: matches.reduce(function(acc, m) {
                                    return Object.assign(acc, (0, $3sHb8._)({}, m.route.id, null));
                                }, {}),
                                errors: pendingActionError || null,
                                statusCode: 200,
                                loaderHeaders: {},
                                activeDeferreds: null
                            }
                        ];
                        return [
                            4,
                            Promise.all((0, $c6Xmf._)(matchesToLoad.map(function(match) {
                                return $1bee5832b9fa8a3e$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, {
                                    isStaticRequest: true,
                                    isRouteRequest: isRouteRequest,
                                    requestContext: requestContext
                                });
                            })))
                        ];
                    case 1:
                        results = _state.sent();
                        if (request.signal.aborted) {
                            method = isRouteRequest ? "queryRoute" : "query";
                            throw new Error(method + "() call aborted: " + request.method + " " + request.url);
                        }
                        // Process and commit output from loaders
                        activeDeferreds = new Map();
                        context = $1bee5832b9fa8a3e$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
                        // Add a null for any non-loader matches for proper revalidation on the client
                        executedLoaders = new Set(matchesToLoad.map(function(match) {
                            return match.route.id;
                        }));
                        matches.forEach(function(match) {
                            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
                        });
                        return [
                            2,
                            $1bee5832b9fa8a3e$var$_extends({}, context, {
                                matches: matches,
                                activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
                            })
                        ];
                }
            });
        });
        return _loadRouteData.apply(this, arguments);
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $1bee5832b9fa8a3e$export$fec11da027c70692(routes, context, error) {
    var newContext = $1bee5832b9fa8a3e$var$_extends({}, context, {
        statusCode: 500,
        errors: (0, $3sHb8._)({}, context._deepestRenderedBoundaryId || routes[0].id, error)
    });
    return newContext;
}
function $1bee5832b9fa8a3e$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $1bee5832b9fa8a3e$var$normalizeTo(location, matches, basename, prependBasename, to, fromRouteId, relative) {
    var contextualMatches;
    var activeRouteMatch;
    if (fromRouteId != null && relative !== "path") {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route.  When using relative:path,
        // fromRouteId is ignored since that is always relative to the current
        // location path
        contextualMatches = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var match = _step.value;
                contextualMatches.push(match);
                if (match.route.id === fromRouteId) {
                    activeRouteMatch = match;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    var path = $1bee5832b9fa8a3e$export$cae722b0cc860f13(to ? to : ".", $1bee5832b9fa8a3e$export$90ba53ce1c7fdff2(contextualMatches).map(function(m) {
        return m.pathnameBase;
    }), $1bee5832b9fa8a3e$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$1bee5832b9fa8a3e$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $1bee5832b9fa8a3e$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $1bee5832b9fa8a3e$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $1bee5832b9fa8a3e$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$1bee5832b9fa8a3e$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$1bee5832b9fa8a3e$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $1bee5832b9fa8a3e$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    var getInvalidBodyError = function() {
        return {
            path: path,
            error: $1bee5832b9fa8a3e$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        };
    };
    // Create a Submission on non-GET navigations
    var rawFormMethod = opts.formMethod || "get";
    var formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    var formAction = $1bee5832b9fa8a3e$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$1bee5832b9fa8a3e$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            var text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce(function(acc, _ref3) {
                var _$_ref3 = (0, $cv9Rk._)(_ref3, 2), name = _$_ref3[0], value = _$_ref3[1];
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$1bee5832b9fa8a3e$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                var json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $1bee5832b9fa8a3e$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    var searchParams;
    var formData;
    if (opts.formData) {
        searchParams = $1bee5832b9fa8a3e$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $1bee5832b9fa8a3e$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $1bee5832b9fa8a3e$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $1bee5832b9fa8a3e$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    var submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($1bee5832b9fa8a3e$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    var parsedPath = $1bee5832b9fa8a3e$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $1bee5832b9fa8a3e$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $1bee5832b9fa8a3e$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $1bee5832b9fa8a3e$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    var boundaryMatches = matches;
    if (boundaryId) {
        var index = matches.findIndex(function(m) {
            return m.route.id === boundaryId;
        });
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $1bee5832b9fa8a3e$var$getMatchesToLoad(history, state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    var actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    var currentUrl = history.createURL(state.location);
    var nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    var boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    var boundaryMatches = $1bee5832b9fa8a3e$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    var navigationMatches = boundaryMatches.filter(function(match, index) {
        if (match.route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (match.route.loader == null) return false;
        // Always call the loader on new route instances and pending defer cancellations
        if ($1bee5832b9fa8a3e$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some(function(id) {
            return id === match.route.id;
        })) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        var currentRouteMatch = state.matches[index];
        var nextRouteMatch = match;
        return $1bee5832b9fa8a3e$var$shouldRevalidateLoader(match, $1bee5832b9fa8a3e$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $1bee5832b9fa8a3e$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    var revalidatingFetchers = [];
    fetchLoadMatches.forEach(function(f, key) {
        // Don't revalidate if fetcher won't be present in the subsequent render
        if (!matches.some(function(m) {
            return m.route.id === f.routeId;
        })) return;
        var fetcherMatches = $1bee5832b9fa8a3e$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        var fetcher = state.fetchers.get(key);
        var fetcherMatch = $1bee5832b9fa8a3e$var$getTargetMatch(fetcherMatches, f.path);
        var shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $1bee5832b9fa8a3e$var$shouldRevalidateLoader(fetcherMatch, $1bee5832b9fa8a3e$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $1bee5832b9fa8a3e$var$isNewLoader(currentLoaderData, currentMatch, match) {
    var isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    var isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $1bee5832b9fa8a3e$var$isNewRouteInstance(currentMatch, match) {
    var currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $1bee5832b9fa8a3e$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        var routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $1bee5832b9fa8a3e$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    return $1bee5832b9fa8a3e$var$_loadLazyRouteModule.apply(this, arguments);
}
function $1bee5832b9fa8a3e$var$_loadLazyRouteModule() {
    $1bee5832b9fa8a3e$var$_loadLazyRouteModule = /**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ (0, $kSuI9._)(function(route, mapRouteProperties, manifest) {
        var lazyRoute, routeToUpdate, routeUpdates, lazyRouteProperty, staticRouteValue, isPropertyStaticallyDefined;
        return (0, $l29cN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!route.lazy) return [
                        2
                    ];
                    return [
                        4,
                        route.lazy()
                    ];
                case 1:
                    lazyRoute = _state.sent();
                    // If the lazy route function was executed and removed by another parallel
                    // call then we can return - first lazy() to finish wins because the return
                    // value of lazy is expected to be static
                    if (!route.lazy) return [
                        2
                    ];
                    routeToUpdate = manifest[route.id];
                    $1bee5832b9fa8a3e$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
                    // Update the route in place.  This should be safe because there's no way
                    // we could yet be sitting on this route as we can't get there without
                    // resolving lazy() first.
                    //
                    // This is different than the HMR "update" use-case where we may actively be
                    // on the route being updated.  The main concern boils down to "does this
                    // mutation affect any ongoing navigations or any current state.matches
                    // values?".  If not, it should be safe to update in place.
                    routeUpdates = {};
                    for(var lazyRouteProperty in lazyRoute){
                        staticRouteValue = routeToUpdate[lazyRouteProperty];
                        isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
                        // on the route updates
                        lazyRouteProperty !== "hasErrorBoundary";
                        $1bee5832b9fa8a3e$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
                        if (!isPropertyStaticallyDefined && !$1bee5832b9fa8a3e$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
                    }
                    // Mutate the route with the provided updates.  Do this first so we pass
                    // the updated version to mapRouteProperties
                    Object.assign(routeToUpdate, routeUpdates);
                    // Mutate the `hasErrorBoundary` property on the route based on the route
                    // updates and remove the `lazy` function so we don't resolve the lazy
                    // route again.
                    Object.assign(routeToUpdate, $1bee5832b9fa8a3e$var$_extends({}, mapRouteProperties(routeToUpdate), {
                        lazy: undefined
                    }));
                    return [
                        2
                    ];
            }
        });
    });
    return $1bee5832b9fa8a3e$var$_loadLazyRouteModule.apply(this, arguments);
}
function $1bee5832b9fa8a3e$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, opts) {
    return $1bee5832b9fa8a3e$var$_callLoaderOrAction.apply(this, arguments);
}
function $1bee5832b9fa8a3e$var$_callLoaderOrAction() {
    $1bee5832b9fa8a3e$var$_callLoaderOrAction = (0, $kSuI9._)(function(type, request, match, matches, manifest, mapRouteProperties, basename, opts) {
        var resultType, result, onReject, runHandler, handler, handlerError, values, url, pathname, url1, pathname1, e, status, location, currentUrl, url2, isSameBasename, queryRouteResponse, data, contentType, _result$init, _result$init2;
        return (0, $l29cN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (opts === void 0) opts = {};
                    runHandler = function(handler) {
                        // Setup a promise we can race against so that abort signals short circuit
                        var reject;
                        var abortPromise = new Promise(function(_, r) {
                            return reject = r;
                        });
                        onReject = function() {
                            return reject();
                        };
                        request.signal.addEventListener("abort", onReject);
                        return Promise.race([
                            handler({
                                request: request,
                                params: match.params,
                                context: opts.requestContext
                            }),
                            abortPromise
                        ]);
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        12,
                        13,
                        14
                    ]);
                    handler = match.route[type];
                    if (!match.route.lazy) return [
                        3,
                        8
                    ];
                    if (!handler) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        Promise.all([
                            // If the handler throws, don't let it immediately bubble out,
                            // since we need to let the lazy() execution finish so we know if this
                            // route has a boundary that can handle the error
                            runHandler(handler).catch(function(e) {
                                handlerError = e;
                            }),
                            $1bee5832b9fa8a3e$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                        ])
                    ];
                case 2:
                    values = _state.sent();
                    if (handlerError) throw handlerError;
                    result = values[0];
                    return [
                        3,
                        7
                    ];
                case 3:
                    // Load lazy route module, then run any returned handler
                    return [
                        4,
                        $1bee5832b9fa8a3e$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                    ];
                case 4:
                    _state.sent();
                    handler = match.route[type];
                    if (!handler) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 5:
                    // Handler still run even if we got interrupted to maintain consistency
                    // with un-abortable behavior of handler execution on non-lazy or
                    // previously-lazy-loaded routes
                    result = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 6:
                    if (type === "action") {
                        url = new URL(request.url);
                        pathname = url.pathname + url.search;
                        throw $1bee5832b9fa8a3e$var$getInternalRouterError(405, {
                            method: request.method,
                            pathname: pathname,
                            routeId: match.route.id
                        });
                    } else // lazy() route has no loader to run.  Short circuit here so we don't
                    // hit the invariant below that errors on returning undefined.
                    return [
                        2,
                        {
                            type: $1bee5832b9fa8a3e$var$ResultType.data,
                            data: undefined
                        }
                    ];
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        11
                    ];
                case 8:
                    if (!!handler) return [
                        3,
                        9
                    ];
                    url1 = new URL(request.url);
                    pathname1 = url1.pathname + url1.search;
                    throw $1bee5832b9fa8a3e$var$getInternalRouterError(404, {
                        pathname: pathname1
                    });
                case 9:
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 10:
                    result = _state.sent();
                    _state.label = 11;
                case 11:
                    $1bee5832b9fa8a3e$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
                    return [
                        3,
                        14
                    ];
                case 12:
                    e = _state.sent();
                    resultType = $1bee5832b9fa8a3e$var$ResultType.error;
                    result = e;
                    return [
                        3,
                        14
                    ];
                case 13:
                    if (onReject) request.signal.removeEventListener("abort", onReject);
                    return [
                        7
                    ];
                case 14:
                    if (!$1bee5832b9fa8a3e$var$isResponse(result)) return [
                        3,
                        19
                    ];
                    status = result.status;
                    // Process redirects
                    if ($1bee5832b9fa8a3e$var$redirectStatusCodes.has(status)) {
                        location = result.headers.get("Location");
                        $1bee5832b9fa8a3e$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
                        // Support relative routing in internal redirects
                        if (!$1bee5832b9fa8a3e$var$ABSOLUTE_URL_REGEX.test(location)) location = $1bee5832b9fa8a3e$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location);
                        else if (!opts.isStaticRequest) {
                            // Strip off the protocol+origin for same-origin + same-basename absolute
                            // redirects. If this is a static request, we can let it go back to the
                            // browser as-is
                            currentUrl = new URL(request.url);
                            url2 = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                            isSameBasename = $1bee5832b9fa8a3e$export$b69e3301ce081aa3(url2.pathname, basename) != null;
                            if (url2.origin === currentUrl.origin && isSameBasename) location = url2.pathname + url2.search + url2.hash;
                        }
                        // Don't process redirects in the router during static requests requests.
                        // Instead, throw the Response and let the server handle it with an HTTP
                        // redirect.  We also update the Location header in place in this flow so
                        // basename and relative routing is taken into account
                        if (opts.isStaticRequest) {
                            result.headers.set("Location", location);
                            throw result;
                        }
                        return [
                            2,
                            {
                                type: $1bee5832b9fa8a3e$var$ResultType.redirect,
                                status: status,
                                location: location,
                                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
                            }
                        ];
                    }
                    // For SSR single-route requests, we want to hand Responses back directly
                    // without unwrapping.  We do this with the QueryRouteResponse wrapper
                    // interface so we can know whether it was returned or thrown
                    if (opts.isRouteRequest) {
                        queryRouteResponse = {
                            type: resultType === $1bee5832b9fa8a3e$var$ResultType.error ? $1bee5832b9fa8a3e$var$ResultType.error : $1bee5832b9fa8a3e$var$ResultType.data,
                            response: result
                        };
                        throw queryRouteResponse;
                    }
                    contentType = result.headers.get("Content-Type");
                    if (!(contentType && /\bapplication\/json\b/.test(contentType))) return [
                        3,
                        16
                    ];
                    return [
                        4,
                        result.json()
                    ];
                case 15:
                    data = _state.sent();
                    return [
                        3,
                        18
                    ];
                case 16:
                    return [
                        4,
                        result.text()
                    ];
                case 17:
                    data = _state.sent();
                    _state.label = 18;
                case 18:
                    if (resultType === $1bee5832b9fa8a3e$var$ResultType.error) return [
                        2,
                        {
                            type: resultType,
                            error: new $1bee5832b9fa8a3e$export$6c6580e81da25755(status, result.statusText, data),
                            headers: result.headers
                        }
                    ];
                    return [
                        2,
                        {
                            type: $1bee5832b9fa8a3e$var$ResultType.data,
                            data: data,
                            statusCode: result.status,
                            headers: result.headers
                        }
                    ];
                case 19:
                    if (resultType === $1bee5832b9fa8a3e$var$ResultType.error) return [
                        2,
                        {
                            type: resultType,
                            error: result
                        }
                    ];
                    if ($1bee5832b9fa8a3e$export$fbcedacb60443473(result)) {
                        ;
                        return [
                            2,
                            {
                                type: $1bee5832b9fa8a3e$var$ResultType.deferred,
                                deferredData: result,
                                statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                                headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            type: $1bee5832b9fa8a3e$var$ResultType.data,
                            data: result
                        }
                    ];
            }
        });
    });
    return $1bee5832b9fa8a3e$var$_callLoaderOrAction.apply(this, arguments);
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $1bee5832b9fa8a3e$var$createClientSideRequest(history, location, signal, submission) {
    var url = history.createURL($1bee5832b9fa8a3e$var$stripHashFromPath(location)).toString();
    var init = {
        signal: signal
    };
    if (submission && $1bee5832b9fa8a3e$var$isMutationMethod(submission.formMethod)) {
        var formMethod = submission.formMethod, formEncType = submission.formEncType;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $1bee5832b9fa8a3e$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $1bee5832b9fa8a3e$var$convertFormDataToSearchParams(formData) {
    var searchParams = new URLSearchParams();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = formData.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $cv9Rk._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
            searchParams.append(key, typeof value === "string" ? value : value.name);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return searchParams;
}
function $1bee5832b9fa8a3e$var$convertSearchParamsToFormData(searchParams) {
    var formData = new FormData();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = searchParams.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $cv9Rk._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            formData.append(key, value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return formData;
}
function $1bee5832b9fa8a3e$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    var loaderData = {};
    var errors = null;
    var statusCode;
    var foundError = false;
    var loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach(function(result, index) {
        var id = matchesToLoad[index].route.id;
        $1bee5832b9fa8a3e$export$3e9cee6b33872309(!$1bee5832b9fa8a3e$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($1bee5832b9fa8a3e$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            var boundaryMatch = $1bee5832b9fa8a3e$var$findNearestBoundary(matches, id);
            var error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $1bee5832b9fa8a3e$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($1bee5832b9fa8a3e$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $1bee5832b9fa8a3e$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    var _processRouteLoaderData = $1bee5832b9fa8a3e$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds), loaderData = _processRouteLoaderData.loaderData, errors = _processRouteLoaderData.errors;
    // Process results from our revalidating fetchers
    for(var index = 0; index < revalidatingFetchers.length; index++){
        var _revalidatingFetchers_index = revalidatingFetchers[index], key = _revalidatingFetchers_index.key, match = _revalidatingFetchers_index.match, controller = _revalidatingFetchers_index.controller;
        $1bee5832b9fa8a3e$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        var result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($1bee5832b9fa8a3e$var$isErrorResult(result)) {
            var boundaryMatch = $1bee5832b9fa8a3e$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $1bee5832b9fa8a3e$var$_extends({}, errors, (0, $3sHb8._)({}, boundaryMatch.route.id, result.error));
            state.fetchers.delete(key);
        } else if ($1bee5832b9fa8a3e$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $1bee5832b9fa8a3e$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($1bee5832b9fa8a3e$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $1bee5832b9fa8a3e$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            var doneFetcher = $1bee5832b9fa8a3e$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $1bee5832b9fa8a3e$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    var mergedLoaderData = $1bee5832b9fa8a3e$var$_extends({}, newLoaderData);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var match = _step.value;
            var id = match.route.id;
            if (newLoaderData.hasOwnProperty(id)) {
                if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
            } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
            // wasn't removed by HMR
            mergedLoaderData[id] = loaderData[id];
            if (errors && errors.hasOwnProperty(id)) break;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $1bee5832b9fa8a3e$var$findNearestBoundary(matches, routeId) {
    var eligibleMatches = routeId ? matches.slice(0, matches.findIndex(function(m) {
        return m.route.id === routeId;
    }) + 1) : (0, $c6Xmf._)(matches);
    return eligibleMatches.reverse().find(function(m) {
        return m.route.hasErrorBoundary === true;
    }) || matches[0];
}
function $1bee5832b9fa8a3e$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    var route = routes.length === 1 ? routes[0] : routes.find(function(r) {
        return r.index || !r.path || r.path === "/";
    }) || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $1bee5832b9fa8a3e$var$getInternalRouterError(status, _temp4) {
    var _ref = _temp4 === void 0 ? {} : _temp4, pathname = _ref.pathname, routeId = _ref.routeId, method = _ref.method, type = _ref.type;
    var statusText = "Unknown Server Error";
    var errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $1bee5832b9fa8a3e$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $1bee5832b9fa8a3e$var$findRedirect(results) {
    for(var i = results.length - 1; i >= 0; i--){
        var result = results[i];
        if ($1bee5832b9fa8a3e$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $1bee5832b9fa8a3e$var$stripHashFromPath(path) {
    var parsedPath = typeof path === "string" ? $1bee5832b9fa8a3e$export$8ccf933b0513f8d0(path) : path;
    return $1bee5832b9fa8a3e$export$fe53371bee54353d($1bee5832b9fa8a3e$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $1bee5832b9fa8a3e$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $1bee5832b9fa8a3e$var$isDeferredResult(result) {
    return result.type === $1bee5832b9fa8a3e$var$ResultType.deferred;
}
function $1bee5832b9fa8a3e$var$isErrorResult(result) {
    return result.type === $1bee5832b9fa8a3e$var$ResultType.error;
}
function $1bee5832b9fa8a3e$var$isRedirectResult(result) {
    return (result && result.type) === $1bee5832b9fa8a3e$var$ResultType.redirect;
}
function $1bee5832b9fa8a3e$export$fbcedacb60443473(value) {
    var deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $1bee5832b9fa8a3e$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $1bee5832b9fa8a3e$var$isRedirectResponse(result) {
    if (!$1bee5832b9fa8a3e$var$isResponse(result)) return false;
    var status = result.status;
    var location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $1bee5832b9fa8a3e$var$isQueryRouteResponse(obj) {
    return obj && $1bee5832b9fa8a3e$var$isResponse(obj.response) && (obj.type === $1bee5832b9fa8a3e$var$ResultType.data || obj.type === $1bee5832b9fa8a3e$var$ResultType.error);
}
function $1bee5832b9fa8a3e$var$isValidMethod(method) {
    return $1bee5832b9fa8a3e$var$validRequestMethods.has(method.toLowerCase());
}
function $1bee5832b9fa8a3e$var$isMutationMethod(method) {
    return $1bee5832b9fa8a3e$var$validMutationMethods.has(method.toLowerCase());
}
function $1bee5832b9fa8a3e$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    return $1bee5832b9fa8a3e$var$_resolveDeferredResults.apply(this, arguments);
}
function $1bee5832b9fa8a3e$var$_resolveDeferredResults() {
    $1bee5832b9fa8a3e$var$_resolveDeferredResults = (0, $kSuI9._)(function(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
        var _loop, index;
        return (0, $l29cN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _loop = function(index) {
                        var result, match, currentMatch, isRevalidatingLoader, signal;
                        return (0, $l29cN.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    result = results[index];
                                    match = matchesToLoad[index];
                                    // If we don't have a match, then we can have a deferred result to do
                                    // anything with.  This is for revalidating fetchers where the route was
                                    // removed during HMR
                                    if (!match) return [
                                        2,
                                        "continue"
                                    ];
                                    currentMatch = currentMatches.find(function(m) {
                                        return m.route.id === match.route.id;
                                    });
                                    isRevalidatingLoader = currentMatch != null && !$1bee5832b9fa8a3e$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
                                    if (!($1bee5832b9fa8a3e$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader))) return [
                                        3,
                                        2
                                    ];
                                    // Note: we do not have to touch activeDeferreds here since we race them
                                    // against the signal in resolveDeferredData and they'll get aborted
                                    // there if needed
                                    signal = signals[index];
                                    $1bee5832b9fa8a3e$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
                                    return [
                                        4,
                                        $1bee5832b9fa8a3e$var$resolveDeferredData(result, signal, isFetcher).then(function(result) {
                                            if (result) results[index] = result || results[index];
                                        })
                                    ];
                                case 1:
                                    _state.sent();
                                    _state.label = 2;
                                case 2:
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    index = 0;
                    _state.label = 1;
                case 1:
                    if (!(index < results.length)) return [
                        3,
                        4
                    ];
                    return [
                        5,
                        (0, $l29cN.__values)(_loop(index))
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    index++;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $1bee5832b9fa8a3e$var$_resolveDeferredResults.apply(this, arguments);
}
function $1bee5832b9fa8a3e$var$resolveDeferredData(result, signal, unwrap) {
    return $1bee5832b9fa8a3e$var$_resolveDeferredData.apply(this, arguments);
}
function $1bee5832b9fa8a3e$var$_resolveDeferredData() {
    $1bee5832b9fa8a3e$var$_resolveDeferredData = (0, $kSuI9._)(function(result, signal, unwrap) {
        var aborted;
        return (0, $l29cN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (unwrap === void 0) unwrap = false;
                    return [
                        4,
                        result.deferredData.resolveData(signal)
                    ];
                case 1:
                    aborted = _state.sent();
                    if (aborted) return [
                        2
                    ];
                    if (unwrap) try {
                        return [
                            2,
                            {
                                type: $1bee5832b9fa8a3e$var$ResultType.data,
                                data: result.deferredData.unwrappedData
                            }
                        ];
                    } catch (e) {
                        // Handle any TrackedPromise._error values encountered while unwrapping
                        return [
                            2,
                            {
                                type: $1bee5832b9fa8a3e$var$ResultType.error,
                                error: e
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            type: $1bee5832b9fa8a3e$var$ResultType.data,
                            data: result.deferredData.data
                        }
                    ];
            }
        });
    });
    return $1bee5832b9fa8a3e$var$_resolveDeferredData.apply(this, arguments);
}
function $1bee5832b9fa8a3e$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some(function(v) {
        return v === "";
    });
}
function $1bee5832b9fa8a3e$var$getTargetMatch(matches, location) {
    var search = typeof location === "string" ? $1bee5832b9fa8a3e$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $1bee5832b9fa8a3e$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    var pathMatches = $1bee5832b9fa8a3e$export$90ba53ce1c7fdff2(matches);
    return pathMatches[pathMatches.length - 1];
}
function $1bee5832b9fa8a3e$var$getSubmissionFromNavigation(navigation) {
    var formMethod = navigation.formMethod, formAction = navigation.formAction, formEncType = navigation.formEncType, text = navigation.text, formData = navigation.formData, json = navigation.json;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $1bee5832b9fa8a3e$var$getLoadingNavigation(location, submission) {
    if (submission) {
        var navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        var navigation1 = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation1;
    }
}
function $1bee5832b9fa8a3e$var$getSubmittingNavigation(location, submission) {
    var navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $1bee5832b9fa8a3e$var$getLoadingFetcher(submission, data) {
    if (submission) {
        var fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        var fetcher1 = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher1;
    }
}
function $1bee5832b9fa8a3e$var$getSubmittingFetcher(submission, existingFetcher) {
    var fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $1bee5832b9fa8a3e$var$getDoneFetcher(data) {
    var fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $1bee5832b9fa8a3e$var$restoreAppliedTransitions(_window, transitions) {
    try {
        var sessionPositions = _window.sessionStorage.getItem($1bee5832b9fa8a3e$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            var json = JSON.parse(sessionPositions);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.entries(json || {})[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, $cv9Rk._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                    if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $1bee5832b9fa8a3e$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        var json = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = transitions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $cv9Rk._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                json[k] = (0, $c6Xmf._)(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        try {
            _window.sessionStorage.setItem($1bee5832b9fa8a3e$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $1bee5832b9fa8a3e$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

});
parcelRegister("gdHfP", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $bcef69a70d431a1a$export$e62c166da838fa3; });

var $hrk7H = parcelRequire("hrk7H");

var $djrl5 = parcelRequire("djrl5");

var $e8oCh = parcelRequire("e8oCh");

var $1hjNY = parcelRequire("1hjNY");
function $bcef69a70d431a1a$export$e62c166da838fa3(arr) {
    return (0, $hrk7H._array_with_holes)(arr) || (0, $djrl5._iterable_to_array)(arr) || (0, $1hjNY._unsupported_iterable_to_array)(arr) || (0, $e8oCh._non_iterable_rest)();
}

});


parcelRegister("2tZah", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_DataRouterContext", function () { return $1cedbc3c615c1b1b$export$3add0d5dce533e2e; });
$parcel$export(module.exports, "UNSAFE_DataRouterStateContext", function () { return $1cedbc3c615c1b1b$export$145dfa71566a64dc; });
$parcel$export(module.exports, "UNSAFE_NavigationContext", function () { return $1cedbc3c615c1b1b$export$26749e8557646306; });
$parcel$export(module.exports, "UNSAFE_RouteContext", function () { return $1cedbc3c615c1b1b$export$9072aa6dd1f93057; });
$parcel$export(module.exports, "useHref", function () { return $1cedbc3c615c1b1b$export$b66bb29c5006f12f; });
$parcel$export(module.exports, "useResolvedPath", function () { return $1cedbc3c615c1b1b$export$e75d2a2d1b3c245b; });
$parcel$export(module.exports, "useLocation", function () { return $1cedbc3c615c1b1b$export$45d76561a5302f2b; });
$parcel$export(module.exports, "useNavigate", function () { return $1cedbc3c615c1b1b$export$9770f232ac06a008; });
$parcel$export(module.exports, "UNSAFE_useRoutesImpl", function () { return $1cedbc3c615c1b1b$export$5fcee62552a12fbf; });
$parcel$export(module.exports, "UNSAFE_useRouteId", function () { return $1cedbc3c615c1b1b$export$5fc8298006ad9e58; });
$parcel$export(module.exports, "useNavigation", function () { return $1cedbc3c615c1b1b$export$d0fd4b7106de2769; });
$parcel$export(module.exports, "useMatches", function () { return $1cedbc3c615c1b1b$export$2378eb7f5ff86053; });
$parcel$export(module.exports, "unstable_useBlocker", function () { return $1cedbc3c615c1b1b$export$2af03a1de5c0910; });
$parcel$export(module.exports, "Router", function () { return $1cedbc3c615c1b1b$export$55185c17a0fcbe46; });
$parcel$export(module.exports, "Route", function () { return $1cedbc3c615c1b1b$export$e7b0ac011bb776c6; });
$parcel$export(module.exports, "Routes", function () { return $1cedbc3c615c1b1b$export$3565eb3d00ca5a74; });
$parcel$export(module.exports, "UNSAFE_mapRouteProperties", function () { return $1cedbc3c615c1b1b$export$52b333d321859367; });
/**
 * React Router v6.18.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");

var $ohfOJ = parcelRequire("ohfOJ");

var $1Mpn7 = parcelRequire("1Mpn7");

var $2oFVr = parcelRequire("2oFVr");
function $1cedbc3c615c1b1b$var$_extends() {
    $1cedbc3c615c1b1b$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1cedbc3c615c1b1b$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
var $1cedbc3c615c1b1b$export$3add0d5dce533e2e = /*#__PURE__*/ $1Mpn7.createContext(null);
var $1cedbc3c615c1b1b$export$145dfa71566a64dc = /*#__PURE__*/ $1Mpn7.createContext(null);
var $1cedbc3c615c1b1b$var$AwaitContext = /*#__PURE__*/ $1Mpn7.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ var $1cedbc3c615c1b1b$export$26749e8557646306 = /*#__PURE__*/ $1Mpn7.createContext(null);
var $1cedbc3c615c1b1b$export$c7914228fb69b0f5 = /*#__PURE__*/ $1Mpn7.createContext(null);
var $1cedbc3c615c1b1b$export$9072aa6dd1f93057 = /*#__PURE__*/ $1Mpn7.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
var $1cedbc3c615c1b1b$var$RouteErrorContext = /*#__PURE__*/ $1Mpn7.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $1cedbc3c615c1b1b$export$b66bb29c5006f12f(to, _temp) {
    var relative = (_temp === void 0 ? {} : _temp).relative;
    !$1cedbc3c615c1b1b$export$9c954a9d03d32f4a() && (0, $2oFVr.UNSAFE_invariant)(false);
    var _React_useContext = $1Mpn7.useContext($1cedbc3c615c1b1b$export$26749e8557646306), basename = _React_useContext.basename, navigator = _React_useContext.navigator;
    var _useResolvedPath = $1cedbc3c615c1b1b$export$e75d2a2d1b3c245b(to, {
        relative: relative
    }), hash = _useResolvedPath.hash, pathname = _useResolvedPath.pathname, search = _useResolvedPath.search;
    var joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $2oFVr.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $1cedbc3c615c1b1b$export$9c954a9d03d32f4a() {
    return $1Mpn7.useContext($1cedbc3c615c1b1b$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $1cedbc3c615c1b1b$export$45d76561a5302f2b() {
    !$1cedbc3c615c1b1b$export$9c954a9d03d32f4a() && (0, $2oFVr.UNSAFE_invariant)(false);
    return $1Mpn7.useContext($1cedbc3c615c1b1b$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $1cedbc3c615c1b1b$export$1b3f31771c5d07c() {
    return $1Mpn7.useContext($1cedbc3c615c1b1b$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $1cedbc3c615c1b1b$export$6c330e8992e8a295(pattern) {
    !$1cedbc3c615c1b1b$export$9c954a9d03d32f4a() && (0, $2oFVr.UNSAFE_invariant)(false);
    var pathname = $1cedbc3c615c1b1b$export$45d76561a5302f2b().pathname;
    return $1Mpn7.useMemo(function() {
        return (0, $2oFVr.matchPath)(pattern, pathname);
    }, [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ var $1cedbc3c615c1b1b$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $1cedbc3c615c1b1b$var$useIsomorphicLayoutEffect(cb) {
    var isStatic = $1Mpn7.useContext($1cedbc3c615c1b1b$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $1Mpn7.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $1cedbc3c615c1b1b$export$9770f232ac06a008() {
    var isDataRoute = $1Mpn7.useContext($1cedbc3c615c1b1b$export$9072aa6dd1f93057).isDataRoute;
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $1cedbc3c615c1b1b$var$useNavigateStable() : $1cedbc3c615c1b1b$var$useNavigateUnstable();
}
function $1cedbc3c615c1b1b$var$useNavigateUnstable() {
    !$1cedbc3c615c1b1b$export$9c954a9d03d32f4a() && (0, $2oFVr.UNSAFE_invariant)(false);
    var dataRouterContext = $1Mpn7.useContext($1cedbc3c615c1b1b$export$3add0d5dce533e2e);
    var _React_useContext = $1Mpn7.useContext($1cedbc3c615c1b1b$export$26749e8557646306), basename = _React_useContext.basename, navigator = _React_useContext.navigator;
    var matches = $1Mpn7.useContext($1cedbc3c615c1b1b$export$9072aa6dd1f93057).matches;
    var _useLocation = $1cedbc3c615c1b1b$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify((0, $2oFVr.UNSAFE_getPathContributingMatches)(matches).map(function(match) {
        return match.pathnameBase;
    }));
    var activeRef = $1Mpn7.useRef(false);
    $1cedbc3c615c1b1b$var$useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = $1Mpn7.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        var path = (0, $2oFVr.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $2oFVr.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $1cedbc3c615c1b1b$var$OutletContext = /*#__PURE__*/ $1Mpn7.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $1cedbc3c615c1b1b$export$4138103a3ae699cc() {
    return $1Mpn7.useContext($1cedbc3c615c1b1b$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $1cedbc3c615c1b1b$export$a3be3530d8e40d0b(context) {
    var outlet = $1Mpn7.useContext($1cedbc3c615c1b1b$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $1Mpn7.createElement($1cedbc3c615c1b1b$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $1cedbc3c615c1b1b$export$99eaa27ddbbb95ef() {
    var matches = $1Mpn7.useContext($1cedbc3c615c1b1b$export$9072aa6dd1f93057).matches;
    var routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $1cedbc3c615c1b1b$export$e75d2a2d1b3c245b(to, _temp2) {
    var relative = (_temp2 === void 0 ? {} : _temp2).relative;
    var matches = $1Mpn7.useContext($1cedbc3c615c1b1b$export$9072aa6dd1f93057).matches;
    var _useLocation = $1cedbc3c615c1b1b$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify((0, $2oFVr.UNSAFE_getPathContributingMatches)(matches).map(function(match) {
        return match.pathnameBase;
    }));
    return $1Mpn7.useMemo(function() {
        return (0, $2oFVr.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path");
    }, [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $1cedbc3c615c1b1b$export$5d3fca4a98652595(routes, locationArg) {
    return $1cedbc3c615c1b1b$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $1cedbc3c615c1b1b$export$5fcee62552a12fbf(routes, locationArg, dataRouterState) {
    !$1cedbc3c615c1b1b$export$9c954a9d03d32f4a() && (0, $2oFVr.UNSAFE_invariant)(false);
    var navigator = $1Mpn7.useContext($1cedbc3c615c1b1b$export$26749e8557646306).navigator;
    var _React_useContext = $1Mpn7.useContext($1cedbc3c615c1b1b$export$9072aa6dd1f93057), parentMatches = _React_useContext.matches;
    var routeMatch = parentMatches[parentMatches.length - 1];
    var parentParams = routeMatch ? routeMatch.params : {};
    var parentPathname = routeMatch ? routeMatch.pathname : "/";
    var parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    var parentRoute = routeMatch && routeMatch.route;
    var locationFromContext = $1cedbc3c615c1b1b$export$45d76561a5302f2b();
    var location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        var parsedLocationArg = typeof locationArg === "string" ? (0, $2oFVr.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $2oFVr.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    var pathname = location.pathname || "/";
    var remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    var matches = (0, $2oFVr.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    var renderedMatches = $1cedbc3c615c1b1b$var$_renderMatches(matches && matches.map(function(match) {
        return Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $2oFVr.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $2oFVr.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        });
    }), parentMatches, dataRouterState);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $1Mpn7.createElement($1cedbc3c615c1b1b$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $1cedbc3c615c1b1b$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $2oFVr.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $1cedbc3c615c1b1b$var$DefaultErrorComponent() {
    var error = $1cedbc3c615c1b1b$export$ed527bf60f6e05f2();
    var message = (0, $2oFVr.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    var stack = error instanceof Error ? error.stack : null;
    var lightgrey = "rgba(200,200,200, 0.5)";
    var preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    var codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    var devInfo = null;
    return /*#__PURE__*/ $1Mpn7.createElement($1Mpn7.Fragment, null, /*#__PURE__*/ $1Mpn7.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $1Mpn7.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $1Mpn7.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $1cedbc3c615c1b1b$var$defaultErrorElement = /*#__PURE__*/ $1Mpn7.createElement($1cedbc3c615c1b1b$var$DefaultErrorComponent, null);
var $1cedbc3c615c1b1b$var$RenderErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $dcsZi._)(RenderErrorBoundary, _React_Component);
    var _super = (0, $ohfOJ._)(RenderErrorBoundary);
    function RenderErrorBoundary(props) {
        (0, $4GJKx._)(this, RenderErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
        return _this;
    }
    (0, $1wc17._)(RenderErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error("React Router caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                return this.state.error ? /*#__PURE__*/ $1Mpn7.createElement($1cedbc3c615c1b1b$export$9072aa6dd1f93057.Provider, {
                    value: this.props.routeContext
                }, /*#__PURE__*/ $1Mpn7.createElement($1cedbc3c615c1b1b$var$RouteErrorContext.Provider, {
                    value: this.state.error,
                    children: this.props.component
                })) : this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                // When we get into an error state, the user will likely click "back" to the
                // previous page that didn't have an error. Because this wraps the entire
                // application, that will have no effect--the error page continues to display.
                // This gives us a mechanism to recover from the error when the location changes.
                //
                // Whether we're in an error state or not, we update the location in state
                // so that when we are in an error state, it gets reset when a new location
                // comes in and the user recovers from the error.
                if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
                    error: props.error,
                    location: props.location,
                    revalidation: props.revalidation
                };
                // If we're not changing locations, preserve the location but still surface
                // any new errors that may come through. We retain the existing error, we do
                // this because the error provided from the app state may be cleared without
                // the location changing.
                return {
                    error: props.error || state.error,
                    location: state.location,
                    revalidation: props.revalidation || state.revalidation
                };
            }
        }
    ]);
    return RenderErrorBoundary;
}($1Mpn7.Component);
function $1cedbc3c615c1b1b$var$RenderedRoute(_ref) {
    var routeContext = _ref.routeContext, match = _ref.match, children = _ref.children;
    var dataRouterContext = $1Mpn7.useContext($1cedbc3c615c1b1b$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $1Mpn7.createElement($1cedbc3c615c1b1b$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $1cedbc3c615c1b1b$var$_renderMatches(matches, parentMatches, dataRouterState) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    var renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    var errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        var errorIndex = renderedMatches.findIndex(function(m) {
            return m.route.id && (errors == null ? void 0 : errors[m.route.id]);
        });
        !(errorIndex >= 0) && (0, $2oFVr.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight(function(outlet, match, index) {
        var error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null;
        // Only data routers handle errors
        var errorElement = null;
        if (dataRouterState) errorElement = match.route.errorElement || $1cedbc3c615c1b1b$var$defaultErrorElement;
        var _$matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        var getChildren = function() {
            var children;
            if (error) children = errorElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $1Mpn7.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $1Mpn7.createElement($1cedbc3c615c1b1b$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: _$matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $1Mpn7.createElement($1cedbc3c615c1b1b$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: _$matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $1cedbc3c615c1b1b$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($1cedbc3c615c1b1b$var$DataRouterHook || {});
var $1cedbc3c615c1b1b$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($1cedbc3c615c1b1b$var$DataRouterStateHook || {});
function $1cedbc3c615c1b1b$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $1cedbc3c615c1b1b$var$useDataRouterContext(hookName) {
    var ctx = $1Mpn7.useContext($1cedbc3c615c1b1b$export$3add0d5dce533e2e);
    !ctx && (0, $2oFVr.UNSAFE_invariant)(false);
    return ctx;
}
function $1cedbc3c615c1b1b$var$useDataRouterState(hookName) {
    var state = $1Mpn7.useContext($1cedbc3c615c1b1b$export$145dfa71566a64dc);
    !state && (0, $2oFVr.UNSAFE_invariant)(false);
    return state;
}
function $1cedbc3c615c1b1b$var$useRouteContext(hookName) {
    var route = $1Mpn7.useContext($1cedbc3c615c1b1b$export$9072aa6dd1f93057);
    !route && (0, $2oFVr.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $1cedbc3c615c1b1b$var$useCurrentRouteId(hookName) {
    var route = $1cedbc3c615c1b1b$var$useRouteContext(hookName);
    var thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $2oFVr.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $1cedbc3c615c1b1b$export$5fc8298006ad9e58() {
    return $1cedbc3c615c1b1b$var$useCurrentRouteId($1cedbc3c615c1b1b$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $1cedbc3c615c1b1b$export$d0fd4b7106de2769() {
    var state = $1cedbc3c615c1b1b$var$useDataRouterState($1cedbc3c615c1b1b$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $1cedbc3c615c1b1b$export$600dc272ed516c15() {
    var dataRouterContext = $1cedbc3c615c1b1b$var$useDataRouterContext($1cedbc3c615c1b1b$var$DataRouterHook.UseRevalidator);
    var state = $1cedbc3c615c1b1b$var$useDataRouterState($1cedbc3c615c1b1b$var$DataRouterStateHook.UseRevalidator);
    return $1Mpn7.useMemo(function() {
        return {
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        };
    }, [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $1cedbc3c615c1b1b$export$2378eb7f5ff86053() {
    var _useDataRouterState = $1cedbc3c615c1b1b$var$useDataRouterState($1cedbc3c615c1b1b$var$DataRouterStateHook.UseMatches), matches = _useDataRouterState.matches, loaderData = _useDataRouterState.loaderData;
    return $1Mpn7.useMemo(function() {
        return matches.map(function(m) {
            return (0, $2oFVr.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData);
        });
    }, [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $1cedbc3c615c1b1b$export$1448a5050d252c4d() {
    var state = $1cedbc3c615c1b1b$var$useDataRouterState($1cedbc3c615c1b1b$var$DataRouterStateHook.UseLoaderData);
    var routeId = $1cedbc3c615c1b1b$var$useCurrentRouteId($1cedbc3c615c1b1b$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $1cedbc3c615c1b1b$export$fd5d37484eab868d(routeId) {
    var state = $1cedbc3c615c1b1b$var$useDataRouterState($1cedbc3c615c1b1b$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $1cedbc3c615c1b1b$export$fdc00f3f26066d5e() {
    var state = $1cedbc3c615c1b1b$var$useDataRouterState($1cedbc3c615c1b1b$var$DataRouterStateHook.UseActionData);
    var route = $1Mpn7.useContext($1cedbc3c615c1b1b$export$9072aa6dd1f93057);
    !route && (0, $2oFVr.UNSAFE_invariant)(false);
    return Object.values((state == null ? void 0 : state.actionData) || {})[0];
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $1cedbc3c615c1b1b$export$ed527bf60f6e05f2() {
    var _state$errors;
    var error = $1Mpn7.useContext($1cedbc3c615c1b1b$var$RouteErrorContext);
    var state = $1cedbc3c615c1b1b$var$useDataRouterState($1cedbc3c615c1b1b$var$DataRouterStateHook.UseRouteError);
    var routeId = $1cedbc3c615c1b1b$var$useCurrentRouteId($1cedbc3c615c1b1b$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $1cedbc3c615c1b1b$export$78a72ddb39bdd145() {
    var value = $1Mpn7.useContext($1cedbc3c615c1b1b$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $1cedbc3c615c1b1b$export$17f53340677d5831() {
    var value = $1Mpn7.useContext($1cedbc3c615c1b1b$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
var $1cedbc3c615c1b1b$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $1cedbc3c615c1b1b$export$2af03a1de5c0910(shouldBlock) {
    var _useDataRouterContext = $1cedbc3c615c1b1b$var$useDataRouterContext($1cedbc3c615c1b1b$var$DataRouterHook.UseBlocker), router = _useDataRouterContext.router, basename = _useDataRouterContext.basename;
    var state = $1cedbc3c615c1b1b$var$useDataRouterState($1cedbc3c615c1b1b$var$DataRouterStateHook.UseBlocker);
    var _React_useState = (0, $cv9Rk._)($1Mpn7.useState(""), 2), blockerKey = _React_useState[0], setBlockerKey = _React_useState[1];
    var blockerFunction = $1Mpn7.useCallback(function(arg) {
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        var currentLocation = arg.currentLocation, nextLocation = arg.nextLocation, historyAction = arg.historyAction;
        return shouldBlock({
            currentLocation: $1cedbc3c615c1b1b$var$_extends({}, currentLocation, {
                pathname: (0, $2oFVr.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $1cedbc3c615c1b1b$var$_extends({}, nextLocation, {
                pathname: (0, $2oFVr.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $1Mpn7.useEffect(function() {
        var key = String(++$1cedbc3c615c1b1b$var$blockerId);
        setBlockerKey(key);
        return function() {
            return router.deleteBlocker(key);
        };
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $1Mpn7.useEffect(function() {
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $2oFVr.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $1cedbc3c615c1b1b$var$useNavigateStable() {
    var router = $1cedbc3c615c1b1b$var$useDataRouterContext($1cedbc3c615c1b1b$var$DataRouterHook.UseNavigateStable).router;
    var id = $1cedbc3c615c1b1b$var$useCurrentRouteId($1cedbc3c615c1b1b$var$DataRouterStateHook.UseNavigateStable);
    var activeRef = $1Mpn7.useRef(false);
    $1cedbc3c615c1b1b$var$useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = $1Mpn7.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $1cedbc3c615c1b1b$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
var $1cedbc3c615c1b1b$var$alreadyWarned = {};
function $1cedbc3c615c1b1b$var$warningOnce(key, cond, message) {
    if (!cond && !$1cedbc3c615c1b1b$var$alreadyWarned[key]) $1cedbc3c615c1b1b$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ var $1cedbc3c615c1b1b$var$START_TRANSITION = "startTransition";
var $1cedbc3c615c1b1b$var$startTransitionImpl = $1Mpn7[$1cedbc3c615c1b1b$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $1cedbc3c615c1b1b$export$323e4fc2fa4753fb(_ref) {
    var fallbackElement = _ref.fallbackElement, router = _ref.router, future = _ref.future;
    var _React_useState = (0, $cv9Rk._)($1Mpn7.useState(router.state), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $1Mpn7.useCallback(function(newState) {
        if (v7_startTransition && $1cedbc3c615c1b1b$var$startTransitionImpl) $1cedbc3c615c1b1b$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        });
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $1Mpn7.useLayoutEffect(function() {
        return router.subscribe(setState);
    }, [
        router,
        setState
    ]);
    var navigator = $1Mpn7.useMemo(function() {
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: function(n) {
                return router.navigate(n);
            },
            push: function(to, state, opts) {
                return router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            },
            replace: function(to, state, opts) {
                return router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            }
        };
    }, [
        router
    ]);
    var basename = router.basename || "/";
    var dataRouterContext = $1Mpn7.useMemo(function() {
        return {
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        };
    }, [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $1Mpn7.createElement($1Mpn7.Fragment, null, /*#__PURE__*/ $1Mpn7.createElement($1cedbc3c615c1b1b$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $1Mpn7.createElement($1cedbc3c615c1b1b$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $1Mpn7.createElement($1cedbc3c615c1b1b$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ $1Mpn7.createElement($1cedbc3c615c1b1b$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement))), null);
}
function $1cedbc3c615c1b1b$var$DataRoutes(_ref2) {
    var routes = _ref2.routes, state = _ref2.state;
    return $1cedbc3c615c1b1b$export$5fcee62552a12fbf(routes, undefined, state);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $1cedbc3c615c1b1b$export$ae46f04cfaffe093(_ref3) {
    var basename = _ref3.basename, children = _ref3.children, initialEntries = _ref3.initialEntries, initialIndex = _ref3.initialIndex, future = _ref3.future;
    var historyRef = $1Mpn7.useRef();
    if (historyRef.current == null) historyRef.current = (0, $2oFVr.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $cv9Rk._)($1Mpn7.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $1Mpn7.useCallback(function(newState) {
        v7_startTransition && $1cedbc3c615c1b1b$var$startTransitionImpl ? $1cedbc3c615c1b1b$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $1Mpn7.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $1Mpn7.createElement($1cedbc3c615c1b1b$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $1cedbc3c615c1b1b$export$444b3ab0cb9aec40(_ref4) {
    var to = _ref4.to, replace = _ref4.replace, state = _ref4.state, relative = _ref4.relative;
    !$1cedbc3c615c1b1b$export$9c954a9d03d32f4a() && (0, $2oFVr.UNSAFE_invariant)(false);
    var matches = $1Mpn7.useContext($1cedbc3c615c1b1b$export$9072aa6dd1f93057).matches;
    var _useLocation = $1cedbc3c615c1b1b$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var navigate = $1cedbc3c615c1b1b$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    var path = (0, $2oFVr.resolveTo)(to, (0, $2oFVr.UNSAFE_getPathContributingMatches)(matches).map(function(match) {
        return match.pathnameBase;
    }), locationPathname, relative === "path");
    var jsonPath = JSON.stringify(path);
    $1Mpn7.useEffect(function() {
        return navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $1cedbc3c615c1b1b$export$910ae8079b2c2852(props) {
    return $1cedbc3c615c1b1b$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $1cedbc3c615c1b1b$export$e7b0ac011bb776c6(_props) {
    (0, $2oFVr.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $1cedbc3c615c1b1b$export$55185c17a0fcbe46(_ref5) {
    var tmp = _ref5.basename, basenameProp = tmp === void 0 ? "/" : tmp, _ref5_children = _ref5.children, children = _ref5_children === void 0 ? null : _ref5_children, locationProp = _ref5.location, _ref5_navigationType = _ref5.navigationType, navigationType = _ref5_navigationType === void 0 ? (0, $2oFVr.Action).Pop : _ref5_navigationType, navigator = _ref5.navigator, tmp1 = _ref5.static, staticProp = tmp1 === void 0 ? false : tmp1;
    !!$1cedbc3c615c1b1b$export$9c954a9d03d32f4a() && (0, $2oFVr.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    var basename = basenameProp.replace(/^\/*/, "/");
    var navigationContext = $1Mpn7.useMemo(function() {
        return {
            basename: basename,
            navigator: navigator,
            static: staticProp
        };
    }, [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $2oFVr.parsePath)(locationProp);
    var _locationProp_pathname = locationProp.pathname, pathname = _locationProp_pathname === void 0 ? "/" : _locationProp_pathname, _locationProp_search = locationProp.search, search = _locationProp_search === void 0 ? "" : _locationProp_search, _locationProp_hash = locationProp.hash, hash = _locationProp_hash === void 0 ? "" : _locationProp_hash, _locationProp_state = locationProp.state, state = _locationProp_state === void 0 ? null : _locationProp_state, _locationProp_key = locationProp.key, key = _locationProp_key === void 0 ? "default" : _locationProp_key;
    var locationContext = $1Mpn7.useMemo(function() {
        var trailingPathname = (0, $2oFVr.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $1Mpn7.createElement($1cedbc3c615c1b1b$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $1Mpn7.createElement($1cedbc3c615c1b1b$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $1cedbc3c615c1b1b$export$3565eb3d00ca5a74(_ref6) {
    var children = _ref6.children, location = _ref6.location;
    return $1cedbc3c615c1b1b$export$5d3fca4a98652595($1cedbc3c615c1b1b$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $1cedbc3c615c1b1b$export$6ddabde395c8c576(_ref7) {
    var children = _ref7.children, errorElement = _ref7.errorElement, resolve = _ref7.resolve;
    return /*#__PURE__*/ $1Mpn7.createElement($1cedbc3c615c1b1b$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $1Mpn7.createElement($1cedbc3c615c1b1b$var$ResolveAwait, null, children));
}
var $1cedbc3c615c1b1b$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($1cedbc3c615c1b1b$var$AwaitRenderStatus || {});
var $1cedbc3c615c1b1b$var$neverSettledPromise = new Promise(function() {});
var $1cedbc3c615c1b1b$var$AwaitErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $dcsZi._)(AwaitErrorBoundary, _React_Component);
    var _super = (0, $ohfOJ._)(AwaitErrorBoundary);
    function AwaitErrorBoundary(props) {
        (0, $4GJKx._)(this, AwaitErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            error: null
        };
        return _this;
    }
    (0, $1wc17._)(AwaitErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error("<Await> caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, children = _this_props.children, errorElement = _this_props.errorElement, resolve = _this_props.resolve;
                var promise = null;
                var status = $1cedbc3c615c1b1b$var$AwaitRenderStatus.pending;
                if (!(resolve instanceof Promise)) {
                    // Didn't get a promise - provide as a resolved promise
                    status = $1cedbc3c615c1b1b$var$AwaitRenderStatus.success;
                    promise = Promise.resolve();
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_data", {
                        get: function() {
                            return resolve;
                        }
                    });
                } else if (this.state.error) {
                    // Caught a render error, provide it as a rejected promise
                    status = $1cedbc3c615c1b1b$var$AwaitRenderStatus.error;
                    var renderError = this.state.error;
                    promise = Promise.reject().catch(function() {}); // Avoid unhandled rejection warnings
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return renderError;
                        }
                    });
                } else if (resolve._tracked) {
                    // Already tracked promise - check contents
                    promise = resolve;
                    status = promise._error !== undefined ? $1cedbc3c615c1b1b$var$AwaitRenderStatus.error : promise._data !== undefined ? $1cedbc3c615c1b1b$var$AwaitRenderStatus.success : $1cedbc3c615c1b1b$var$AwaitRenderStatus.pending;
                } else {
                    // Raw (untracked) promise - track it
                    status = $1cedbc3c615c1b1b$var$AwaitRenderStatus.pending;
                    Object.defineProperty(resolve, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    promise = resolve.then(function(data) {
                        return Object.defineProperty(resolve, "_data", {
                            get: function() {
                                return data;
                            }
                        });
                    }, function(error) {
                        return Object.defineProperty(resolve, "_error", {
                            get: function() {
                                return error;
                            }
                        });
                    });
                }
                if (status === $1cedbc3c615c1b1b$var$AwaitRenderStatus.error && promise._error instanceof (0, $2oFVr.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
                throw $1cedbc3c615c1b1b$var$neverSettledPromise;
                if (status === $1cedbc3c615c1b1b$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
                throw promise._error;
                if (status === $1cedbc3c615c1b1b$var$AwaitRenderStatus.error) // Render via our errorElement
                return /*#__PURE__*/ $1Mpn7.createElement($1cedbc3c615c1b1b$var$AwaitContext.Provider, {
                    value: promise,
                    children: errorElement
                });
                if (status === $1cedbc3c615c1b1b$var$AwaitRenderStatus.success) // Render children with resolved value
                return /*#__PURE__*/ $1Mpn7.createElement($1cedbc3c615c1b1b$var$AwaitContext.Provider, {
                    value: promise,
                    children: children
                });
                // Throw to the suspense boundary
                throw promise;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        }
    ]);
    return AwaitErrorBoundary;
}($1Mpn7.Component);
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $1cedbc3c615c1b1b$var$ResolveAwait(_ref8) {
    var children = _ref8.children;
    var data = $1cedbc3c615c1b1b$export$78a72ddb39bdd145();
    var toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $1Mpn7.createElement($1Mpn7.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $1cedbc3c615c1b1b$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    var routes = [];
    $1Mpn7.Children.forEach(children, function(element, index) {
        if (!/*#__PURE__*/ $1Mpn7.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        var treePath = (0, $c6Xmf._)(parentPath).concat([
            index
        ]);
        if (element.type === $1Mpn7.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $1cedbc3c615c1b1b$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $1cedbc3c615c1b1b$export$e7b0ac011bb776c6) && (0, $2oFVr.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $2oFVr.UNSAFE_invariant)(false);
        var route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $1cedbc3c615c1b1b$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $1cedbc3c615c1b1b$export$daf73786167a7f72(matches) {
    return $1cedbc3c615c1b1b$var$_renderMatches(matches);
}
function $1cedbc3c615c1b1b$export$52b333d321859367(route) {
    var updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $1Mpn7.createElement(route.Component),
        Component: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $1Mpn7.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $1cedbc3c615c1b1b$export$f30f7e456d254e83(routes, opts) {
    return (0, $2oFVr.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $1cedbc3c615c1b1b$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $2oFVr.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $1cedbc3c615c1b1b$export$52b333d321859367
    }).initialize();
}

});



parcelRegister("aVmvD", function(module, exports) {

$parcel$export(module.exports, "useUserSegmentationStatus", function () { return $f1777ce6cbfa880f$export$28a88b8bef42d118; });

var $cv9Rk = parcelRequire("cv9Rk");

var $1Mpn7 = parcelRequire("1Mpn7");

var $145N3 = parcelRequire("145N3");
parcelRequire("k24nj");
var $cqkTt = parcelRequire("cqkTt");
var $9bye2 = parcelRequire("9bye2");
var $f1777ce6cbfa880f$var$UserSegmentationProducts = [
    "confluence.ondemand",
    "jira-software.ondemand",
    "jira-servicedesk.ondemand",
    "jira-core.ondemand"
];
var $f1777ce6cbfa880f$var$isProvisioningUserSegmentationProducts = function(products) {
    var otherProducts = products.filter(function(product) {
        return !$f1777ce6cbfa880f$var$UserSegmentationProducts.includes(product);
    });
    return otherProducts.length === 0;
};
var $f1777ce6cbfa880f$export$28a88b8bef42d118 = function(products) {
    var hideUserSegmentation = (0, $cqkTt.useSearchParameters)().hideUserSegmentation;
    var isUserSegmentationViewRequired = (0, $9bye2.useJiraTemplateChoice)().isUserSegmentationViewRequired;
    var isUserSegHiddenByQueryParam = hideUserSegmentation === "true";
    var _useState = (0, $cv9Rk._)((0, $1Mpn7.useState)(false), 2), userSegmentationPageIsFinished = _useState[0], setUserSegmentationPageIsFinished = _useState[1];
    var _useState1 = (0, $cv9Rk._)((0, $1Mpn7.useState)(false), 2), alreadyViewedUserSegmentationScreen = _useState1[0], setAlreadyViewedUserSegmentationScreen = _useState1[1];
    var createAnalyticsEvent = (0, $145N3.useAnalyticsEvents)().createAnalyticsEvent;
    var listenForUserSegmentationPage = function(event) {
        var data;
        try {
            data = JSON.parse(event.data);
            if (data.source !== "user-segmentation-ui") data = null;
        } catch (e) {
            data = null;
        }
        if (!data) return;
        if (!data.message) return;
        if (data.message === "finished") {
            if (data.error !== "shouldView was false") createAnalyticsEvent({
                eventName: "userSegmentationPageClosed",
                eventType: "UI",
                eventComponent: "userSegmentationPage",
                event: "closed",
                products: products
            }).fire("signup");
            else /* The iFramed user segmentation screen makes an API call to check if the user has viewed
        the screen before. If they have, the screen will NOT show again. */ setAlreadyViewedUserSegmentationScreen(true);
            setUserSegmentationPageIsFinished(true);
        }
        if (data.message === "rendered") createAnalyticsEvent({
            eventName: "userSegmentationPageViewed",
            eventComponent: "userSegmentationPage",
            event: "viewed"
        }).fire("signup");
    };
    (0, $1Mpn7.useEffect)(function() {
        window.addEventListener("message", listenForUserSegmentationPage, false);
        return function() {
            window.removeEventListener("message", listenForUserSegmentationPage, false);
        };
    }, []);
    return {
        /* isEligibleToSeeUserSegmentationPage is agnostic to whether the user has already seen the user segmentation screen.
    since the iFramed screen itself handles this. */ shouldShowUserSegmentationPage: $f1777ce6cbfa880f$var$isProvisioningUserSegmentationProducts(products) && !userSegmentationPageIsFinished && !isUserSegHiddenByQueryParam && isUserSegmentationViewRequired,
        isProvisioningUserSegProducts: $f1777ce6cbfa880f$var$isProvisioningUserSegmentationProducts(products),
        userSegmentationPageIsFinished: userSegmentationPageIsFinished,
        isUserSegHiddenByQueryParam: isUserSegHiddenByQueryParam,
        alreadyViewedUserSegmentationScreen: alreadyViewedUserSegmentationScreen
    };
};

});

parcelRegister("7fxFq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a575d9b89c01ea0$export$2e2bcd8739ae039; });

var $3P435 = parcelRequire("3P435");

var $9bye2 = parcelRequire("9bye2");
parcelRequire("k24nj");
var $cqkTt = parcelRequire("cqkTt");
var $aVmvD = parcelRequire("aVmvD");
var $5a575d9b89c01ea0$var$useConfirmationPageType = function(createCloudStatus, deferRedirect) {
    var shouldShowJiraTemplateChoiceScreen = (0, $9bye2.useJiraTemplateChoice)().shouldShowJiraTemplateChoiceScreen;
    var products = (0, $cqkTt.useSearchParameters)().products;
    var shouldShowUserSegmentationPage = (0, $aVmvD.useUserSegmentationStatus)(products).shouldShowUserSegmentationPage;
    if (shouldShowUserSegmentationPage) return "user-segmentation";
    if (shouldShowJiraTemplateChoiceScreen) return "jira-template-selection";
    switch(createCloudStatus){
        case "error":
            return "error";
        case "timeout":
            return "timeout";
        case "success":
            // ATLAS-56326: show JiraAnimatedProvisioningScreen instead of robots.
            // JiraAnimatedProvisioningScreen handles redirection
            var showAnimatedProvisioningScreen = (0, $3P435.default).getExperimentValue("redesign_jira_provisioning_screen", "showAnimatedProvisioningScreen", false, {
                fireExperimentExposure: false
            });
            if (deferRedirect && showAnimatedProvisioningScreen) return "jira-animated-provisioning-screen";
            return "redirect";
        // "pending" status
        default:
            if (products.some($5a575d9b89c01ea0$var$includesBitbucketOrOpsGenie)) return "robots";
            else if (products.length > 1 && products.some($5a575d9b89c01ea0$var$includesJira)) return "tips";
            else {
                // ATLAS-56326: show JiraAnimatedProvisioningScreen instead of robots
                var showAnimatedProvisioningScreen1 = (0, $3P435.default).getExperimentValue("redesign_jira_provisioning_screen", "showAnimatedProvisioningScreen", false);
                if (showAnimatedProvisioningScreen1) return "jira-animated-provisioning-screen";
                return "robots";
            }
    }
};
var $5a575d9b89c01ea0$export$2e2bcd8739ae039 = $5a575d9b89c01ea0$var$useConfirmationPageType;
function $5a575d9b89c01ea0$var$includesBitbucketOrOpsGenie(text) {
    return text.includes("bitbucket") || text.includes("opsgenie");
}
// We arent testing real product keys here, unlike what occurs in sign-up
function $5a575d9b89c01ea0$var$includesJira(text) {
    return text.includes("jira");
}

});

parcelRegister("ksfH5", function(module, exports) {

$parcel$export(module.exports, "useTipsViewType", function () { return $7b9f737369ff45e6$export$91f3262e957e6924; });
parcelRequire("k24nj");
var $6911k = parcelRequire("6911k");
function $7b9f737369ff45e6$export$91f3262e957e6924() {
    var productKeys = (0, $6911k.useProductKeys)();
    var _productKeys_filter = productKeys.filter(function(product) {
        return product.includes("jira");
    }), jiraProductsCount = _productKeys_filter.length;
    var nonJiraProductsCount = productKeys.length - jiraProductsCount;
    if (jiraProductsCount >= 2 && nonJiraProductsCount > 0) return "jira_bundle";
    else if (jiraProductsCount >= 2 && nonJiraProductsCount === 0) return "jira_only_bundle";
    else return "default";
}

});

parcelRegister("6911k", function(module, exports) {

$parcel$export(module.exports, "useProductKeys", function () { return $651ece19391f15bf$export$9e78901f2b4dc2dd; });
parcelRequire("cyrDP");
var $5XR3v = parcelRequire("5XR3v");

var $cqkTt = parcelRequire("cqkTt");
function $651ece19391f15bf$export$9e78901f2b4dc2dd() {
    var products = (0, $cqkTt.useSearchParameters)().products;
    return products.filter((0, $5XR3v.isProductKey));
}

});


parcelRegister("aTcOY", function(module, exports) {

$parcel$export(module.exports, "isValidLocale", function () { return $5c250ec6f4ce178b$export$b7c662043e31af59; });
var $5c250ec6f4ce178b$var$VALID_LOCALES = [
    "br",
    "de",
    "en",
    "es",
    "fr",
    "hu",
    "it",
    "ja",
    "ko",
    "nl",
    "pl",
    "ru",
    "zh"
];
var $5c250ec6f4ce178b$export$b7c662043e31af59 = function(locale) {
    return $5c250ec6f4ce178b$var$VALID_LOCALES.includes(locale);
};

});




parcelRegister("6SrBz", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwarePage", function () { return $aeddf55263a1e8fc$export$a6be62ed06c967ea; });
// @ts-ignore

var $1rY3h = parcelRequire("1rY3h");
parcelRequire("1Mpn7");
parcelRequire("dGMez");
var $1APpA = parcelRequire("1APpA");
var $aeddf55263a1e8fc$export$a6be62ed06c967ea = function(props) {
    var template = /*#__PURE__*/ (0, $1rY3h.jsx)((0, $1APpA.JiraProductTourOverview), {
        availableProducts: props.availableProducts,
        userProfile: props.userProfile
    });
    return template;
};

});
parcelRegister("dGMez", function(module, exports) {
$parcel$export(module.exports, "JiraProductTourOverview", function () { return (parcelRequire("1APpA")).JiraProductTourOverview; });

$parcel$export(module.exports, "JiraProductTourOverview", function () { return (parcelRequire("1APpA")).JiraProductTourOverview; });

var $1APpA = parcelRequire("1APpA");

});
parcelRegister("1APpA", function(module, exports) {

$parcel$export(module.exports, "JiraProductTourOverview", function () { return $7776da4c0c9bb93f$export$3d5fbb12b62ad296; });

var $1rY3h = parcelRequire("1rY3h");

var $8pPrt = parcelRequire("8pPrt");

var $coBSS = parcelRequire("coBSS");

var $cKX0P = parcelRequire("cKX0P");
parcelRequire("2Q3Zm");
var $5AeXF = parcelRequire("5AeXF");
parcelRequire("2miCy");
var $hot2Q = parcelRequire("hot2Q");
parcelRequire("fn5Fs");
var $7cc3a = parcelRequire("7cc3a");

var $hmyWO = parcelRequire("hmyWO");
parcelRequire("a3t2U");
var $6CGhB = parcelRequire("6CGhB");
var $acPtc = parcelRequire("acPtc");
var $5XId8 = parcelRequire("5XId8");
var $kPein = parcelRequire("kPein");
var $ijlgi = parcelRequire("ijlgi");
var $9CZdO = parcelRequire("9CZdO");
var $bGk4Z = parcelRequire("bGk4Z");
var $hRgqn = parcelRequire("hRgqn");
var $4Aeb4 = parcelRequire("4Aeb4");
var $7776da4c0c9bb93f$export$3d5fbb12b62ad296 = function(param) {
    var availableProducts = param.availableProducts, userProfile = param.userProfile;
    var intl = (0, $8pPrt.default)();
    var availableJiraSites = (0, $cKX0P.filterAvailableJiraSites)(availableProducts);
    var bannerMessages = {
        identifier: "jira-software.banner-alert.atlassian-intelligence",
        text: intl.formatMessage({
            id: "jira-software.banner-alert.text",
            defaultMessage: "Transform teamwork with Atlassian Intelligence - now available."
        }),
        linkText: intl.formatMessage({
            id: "jira-software.banner-alert.link-text",
            defaultMessage: "Learn more"
        }),
        linkUrl: (0, $hot2Q.useLocalizedHref)("/software/artificial-intelligence"),
        dataEventProps: {
            "data-product-key": "jiraSoftware",
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": "Learn more",
            "data-label-english": "Learn more"
        }
    };
    var showLoggedInWelcomeMessage;
    // @ts-ignore
    // TODO: Ignoring unused var for now until SPICE-1118
    var showLoginModalJswProductTour;
    if (userProfile && availableJiraSites.length > 0) // ATLAS-53087: Show welcome message and product link to logged in users
    showLoggedInWelcomeMessage = (0, (/*@__PURE__*/$parcel$interopDefault($coBSS))).getExperimentValue("get_logged_in_users_back_into_jsw_faster_exp", "showLoggedInWelcomeMessage", false);
    else // ATLAS-45338: Target users to increase logins
    // Only seek to enroll a user in this experiment if they are detected to be Logged OUT
    showLoginModalJswProductTour = (0, (/*@__PURE__*/$parcel$interopDefault($coBSS))).getExperimentValue("get_logged_out_users_back_into_jsw_faster_exp", "showLoginModalJswProductTour", false);
    var HeroSection = showLoggedInWelcomeMessage ? /*#__PURE__*/ (0, $1rY3h.jsx)((0, $cKX0P.default), {
        availableJiraSites: availableJiraSites,
        userProfileName: userProfile === null || userProfile === void 0 ? void 0 : userProfile.name
    }) : /*#__PURE__*/ (0, $1rY3h.jsx)((0, $6CGhB.default), {});
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $hmyWO.default), {
                    showTryNow: false,
                    color: "#f4f5f7",
                    productKey: "jiraSoftware"
                })
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)((0, $acPtc.default), {}),
            /*#__PURE__*/ (0, $1rY3h.jsx)((0, $5AeXF.BannerAlert), {
                identifier: bannerMessages.identifier,
                text: bannerMessages.text,
                linkUrl: bannerMessages.linkUrl,
                linkText: bannerMessages.linkText
            }),
            HeroSection,
            /*#__PURE__*/ (0, $1rY3h.jsx)((0, $5XId8.default), {}),
            /*#__PURE__*/ (0, $1rY3h.jsx)((0, $kPein.default), {}),
            /*#__PURE__*/ (0, $1rY3h.jsx)((0, $ijlgi.default), {}),
            /*#__PURE__*/ (0, $1rY3h.jsx)((0, $9CZdO.default), {}),
            /*#__PURE__*/ (0, $1rY3h.jsx)((0, $bGk4Z.default), {}),
            /*#__PURE__*/ (0, $1rY3h.jsx)((0, $hRgqn.default), {}),
            /*#__PURE__*/ (0, $1rY3h.jsx)((0, $4Aeb4.default), {}),
            /*#__PURE__*/ (0, $1rY3h.jsx)((0, $7cc3a.GlobalFooter), {})
        ]
    });
};

});
parcelRegister("cKX0P", function(module, exports) {

$parcel$export(module.exports, "filterAvailableJiraSites", function () { return $46c917f5e99c46a5$export$c88497b4217b9e30; });
$parcel$export(module.exports, "default", function () { return $46c917f5e99c46a5$export$2e2bcd8739ae039; });
/* hero-variant-ATLAS-53087.tsx generated by @compiled/babel-plugin v0.28.2 */ 
var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $cv9Rk = parcelRequire("cv9Rk");

var $1rY3h = parcelRequire("1rY3h");

var $1Mpn7 = parcelRequire("1Mpn7");

var $2vwrh = parcelRequire("2vwrh");

var $dFwuF = parcelRequire("dFwuF");

var $145N3 = parcelRequire("145N3");

var $7Xcnn = parcelRequire("7Xcnn");

var $4OkGb = parcelRequire("4OkGb");
parcelRequire("eb65f");
var $8JWVu = parcelRequire("8JWVu");
parcelRequire("9DBuW");
var $l227w = parcelRequire("l227w");

var $2NtzU = parcelRequire("2NtzU");
parcelRequire("eTpQo");
var $af5n8 = parcelRequire("af5n8");

var $8tQC2 = parcelRequire("8tQC2");

var $rDj8o = parcelRequire("rDj8o");

var $b5KHh = parcelRequire("b5KHh");
var $46c917f5e99c46a5$var$GRAPHQL_GATEWAY_URL = "https://www.atlassian.com/gateway/api/graphql";
var $46c917f5e99c46a5$var$START_URL = "https://start.atlassian.com";
var $46c917f5e99c46a5$export$c88497b4217b9e30 = function(availableProducts) {
    if (availableProducts) {
        var filteredSites = availableProducts.sites.filter(function(site) {
            return site.products.includes("jira-software.ondemand");
        }) || [];
        return filteredSites;
    } else return [];
};
var $46c917f5e99c46a5$var$constructLoginUrl = function(url) {
    var loginUrl = new URL(url);
    loginUrl.pathname = "/login.jsp";
    var searchParam = new URLSearchParams();
    var browseUrl = new URL(loginUrl);
    browseUrl.pathname = "/browse";
    searchParam.append("os_destination", browseUrl.href);
    loginUrl.search = searchParam.toString();
    return loginUrl;
};
var $46c917f5e99c46a5$var$getSitenameFromUrl = function(url) {
    try {
        var tempUrl = new URL(url);
        return tempUrl.hostname.split(".")[0] || "";
    } catch (e) {
        return "";
    }
};
var $46c917f5e99c46a5$var$HeroSection = function(param) {
    var availableJiraSites = param.availableJiraSites, userProfileName = param.userProfileName;
    var _availableJiraSites_;
    var loggedInUserName = (0, $af5n8.useLoggedInUser)().name;
    // Splitting the name string by a space to separate possible first/last names
    var splitName = userProfileName ? userProfileName.split(" ") : loggedInUserName === null || loggedInUserName === void 0 ? void 0 : loggedInUserName.split(" ");
    var stargateClient = (0, $8JWVu.useBxpWebStargateClient)();
    var activityClient = (0, $4OkGb.useActivityClient)("v3", "www.atlassian.com", undefined, $46c917f5e99c46a5$var$GRAPHQL_GATEWAY_URL);
    // Default state to whatever we might have got from SSR
    var _useState = (0, $cv9Rk._)((0, $1Mpn7.useState)(availableJiraSites.length > 1), 2), hasMultipleJiras = _useState[0], setHasMulitpleJiras = _useState[1];
    var _useState1 = (0, $cv9Rk._)((0, $1Mpn7.useState)($46c917f5e99c46a5$var$getSitenameFromUrl(((_availableJiraSites_ = availableJiraSites[0]) === null || _availableJiraSites_ === void 0 ? void 0 : _availableJiraSites_.url) || "")), 2), siteName = _useState1[0], setSiteName = _useState1[1];
    var _useState2 = (0, $cv9Rk._)((0, $1Mpn7.useState)(""), 2), siteUrl = _useState2[0], setSiteUrl = _useState2[1];
    (0, $1Mpn7.useEffect)(function() {
        var promises = [];
        // Fetch available-products if not available from SSR
        if (availableJiraSites.length == 0) promises.push(stargateClient.availableProducts({}).then(function(data) {
            $46c917f5e99c46a5$export$c88497b4217b9e30(data);
        }).catch(function(error) {
            return console.log(error);
        }));
        // Fetch recent Jira activity
        var mostRecentActivity;
        var fetchActivitiesPromise = activityClient.fetchActivities([
            50,
            125,
            250
        ], // retries
        {
            limit: 5,
            products: [
                "jira"
            ]
        }, [
            "workedOn",
            "viewed"
        ]).then(function(data) {
            // Which is more recent? The newest viewed or the newest worked on object?
            var mostRecentlyViewed = data.viewed[0];
            var mostRecentlyWorkedOn = data.workedOn[0];
            if (mostRecentlyViewed && mostRecentlyWorkedOn) mostRecentActivity = new Date(mostRecentlyViewed.timestamp) > new Date(mostRecentlyWorkedOn.timestamp) ? mostRecentlyViewed : mostRecentlyWorkedOn;
            else if (mostRecentlyWorkedOn) mostRecentActivity = mostRecentlyWorkedOn;
            else if (mostRecentlyViewed) mostRecentActivity = mostRecentlyViewed;
        }).catch(function(error) {
            return console.log(error);
        });
        promises.push(fetchActivitiesPromise);
        // Set state after receiving all responses
        Promise.allSettled(promises).then(function() {
            // Set hasMultipleJiras based on availableJiraSites result
            setHasMulitpleJiras(availableJiraSites.length > 1);
            // First try to use most recent activity if available
            if (mostRecentActivity) {
                var loginUrl = $46c917f5e99c46a5$var$constructLoginUrl(mostRecentActivity.object.url);
                setSiteUrl(loginUrl.href);
                setSiteName(loginUrl.hostname.split(".")[0] || "");
            } else if (availableJiraSites[0]) {
                var loginUrl1 = $46c917f5e99c46a5$var$constructLoginUrl(availableJiraSites[0].url);
                setSiteUrl(loginUrl1.href);
                setSiteName(loginUrl1.hostname.split(".")[0] || "");
            } else {
                setSiteUrl($46c917f5e99c46a5$var$START_URL);
                setSiteName("");
            }
        });
    }, [
        stargateClient,
        activityClient,
        availableJiraSites
    ]);
    var createAnalyticsEvent = (0, $145N3.useAnalyticsEvents)().createAnalyticsEvent;
    var analyticsClient = (0, $2NtzU.useAnalyticsClient)();
    (0, $1Mpn7.useEffect)(function() {
        //if client side, fire analytics event
        if (typeof window !== "undefined") createAnalyticsEvent((0, $do9pw._)({}, (0, $8tQC2.loggedInHeroLoadedAnalyticsPayload))).fire();
    }, [
        analyticsClient,
        createAnalyticsEvent
    ]);
    var clickHandler = function(eventName) {
        createAnalyticsEvent((0, $cxjpp._)((0, $do9pw._)({}, (0, $8tQC2.loggedInHeroAnalyticsPayload)), {
            attributes: {
                eventName: eventName,
                url: window.location.href,
                atlasId: "ATLAS-53087"
            }
        })).fire();
    };
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("section", {
        className: (0, $2vwrh.default)([
            "_1itkpso1 _ouxl1ssb _12vemgnk _1lrw1dfr _1e0c1txw _4cvr1h6o _1bah1h6o _ca0qidpf _u5f3o7ao _n3tdidpf _19bvo7ao"
        ]),
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                className: (0, $2vwrh.default)([
                    "_kqswstnw _1e02idpf _152tidpf _1ycoglyw"
                ]),
                children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $b5KHh.default), {})
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                className: (0, $2vwrh.default)([
                    "_kqswstnw _rjxpidpf _152tr0r7 _1ycoglyw"
                ]),
                children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $rDj8o.default), {})
            }),
            /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
                className: (0, $2vwrh.default)([
                    "_syazu67f _1bsb1osq _p12fk3xj _19pk53f4 _2hwx7l9q _otyr12am _18u07l9q _q7gqgktf _zcqx1f4h _1adi1nn1 _6zrg53f4 _1f17o7ao _kqq412am _1io0o7ao"
                ]),
                children: [
                    /*#__PURE__*/ (0, $1rY3h.jsx)("h1", {
                        className: (0, $2vwrh.default)([
                            "_1wybckbl _vwz48vuz _k48pbfng _6rtho7ao"
                        ]),
                        children: splitName && splitName.length > 0 ? /*#__PURE__*/ (0, $1rY3h.jsx)((0, $dFwuF.default), {
                            id: "JiraSoftwarePageTemplate.loggedInHero.welcomeBackWithName",
                            defaultMessage: "Welcome back, {name}.",
                            values: {
                                name: splitName[0]
                            }
                        }) : /*#__PURE__*/ (0, $1rY3h.jsx)((0, $dFwuF.default), {
                            id: "JiraSoftwarePageTemplate.loggedInHero.welcomeBack",
                            defaultMessage: "Welcome back"
                        })
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("p", {
                        className: (0, $2vwrh.default)([
                            "_1pfho7ao _6rtho7ao"
                        ]),
                        children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $dFwuF.default), {
                            id: "JiraSoftwarePageTemplate.loggedInHero.pickUpWhereYouLeftOff",
                            defaultMessage: "Pick up where you left off in Jira Software."
                        })
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsxs)("a", {
                        href: siteUrl,
                        onClick: function() {
                            return clickHandler((0, $8tQC2.TRACKING_EVENT_NAMES).loggedInHeroProductCtaClicked);
                        },
                        className: (0, $2vwrh.default)([
                            "_1bsb1osq _4t3it9kd _1e0c1txw _1bah1yb4 _2lx2vrvc _4cvr1h6o _19it1vx7 _ca0q19bv _u5f319bv _n3td19bv _19bv19bv _1pfhgktf _6rthgktf"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
                                className: (0, $2vwrh.default)([
                                    "_1e0c1txw _2lx2vrvc _4cvr1h6o _1ul9idpf"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                                        className: (0, $2vwrh.default)([
                                            "_12l219bv _1pfhrdoj"
                                        ]),
                                        children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $l227w.Logo), {
                                            brand: "jirasoftware",
                                            type: "mark",
                                            appearance: "brand"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
                                        className: (0, $2vwrh.default)([
                                            "_vwz4qslr _1wyb7vkz _1reo15vq _18m915vq"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                                                className: (0, $2vwrh.default)([
                                                    "_k48pbfng _4t3iqslr _1wybl52n"
                                                ]),
                                                children: "Jira Software"
                                            }),
                                            /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                                                className: (0, $2vwrh.default)([
                                                    "_k48powjs _1bto1l2s _1reo15vq _18m915vq _o5721q9c _4t3iqslr"
                                                ]),
                                                children: siteName
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)((0, $7Xcnn.default), {
                                id: "jira-button",
                                appearance: "warning",
                                className: (0, $2vwrh.default)([
                                    "_ahbqo7ao"
                                ]),
                                children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $dFwuF.default), {
                                    id: "JiraSoftwarePageTemplate.loggedInHero.goToJira",
                                    defaultMessage: "Go to Jira"
                                })
                            })
                        ]
                    }),
                    hasMultipleJiras && /*#__PURE__*/ (0, $1rY3h.jsx)((0, $7Xcnn.default), {
                        href: $46c917f5e99c46a5$var$START_URL,
                        appearance: "subtle-link",
                        onClick: function() {
                            return clickHandler((0, $8tQC2.TRACKING_EVENT_NAMES).loggedInHeroAnotherSiteCtaClicked);
                        },
                        children: /*#__PURE__*/ (0, $1rY3h.jsx)("span", {
                            className: (0, $2vwrh.default)([
                                "_1pfho7ao _1wyb7vkz _4bfu1r31 _1hms8stv _ajmmnqa1 _syazu67f _k48p1kdj"
                            ]),
                            children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $dFwuF.default), {
                                id: "JiraSoftwarePageTemplate.loggedInHero.lookingForAnotherSite",
                                defaultMessage: "I\u2019m looking for another Jira site"
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var $46c917f5e99c46a5$var$jswHeroSectionStyle = null;
var $46c917f5e99c46a5$var$targetStyle = null;
var $46c917f5e99c46a5$var$arrowCircleStyle = null;
var $46c917f5e99c46a5$var$heroTextSectionStyle = null;
var $46c917f5e99c46a5$var$jiraSiteBoxStyle = null;
var $46c917f5e99c46a5$var$headingStyle = null;
var $46c917f5e99c46a5$var$siteStyle = null;
var $46c917f5e99c46a5$var$productStyle = null;
var $46c917f5e99c46a5$var$siteNameStyle = null;
var $46c917f5e99c46a5$var$buttonStyle = null;
var $46c917f5e99c46a5$var$otherJiraSiteStyle = null;
var $46c917f5e99c46a5$var$subHeadingStyle = null;
var $46c917f5e99c46a5$var$logoStyle = null;
var $46c917f5e99c46a5$var$logoAndSiteNameStyle = null;
var $46c917f5e99c46a5$export$2e2bcd8739ae039 = $46c917f5e99c46a5$var$HeroSection;

});
parcelRegister("2vwrh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d37a3bcd049c79d$export$2e2bcd8739ae039; });
var $1d37a3bcd049c79d$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ var $1d37a3bcd049c79d$var$ATOMIC_GROUP_LENGTH = 5;
function $1d37a3bcd049c79d$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(" ") === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    var atomicGroups = {};
    for(var i = 0; i < classNames.length; i++){
        var cls = classNames[i];
        if (!cls) continue;
        var groups = cls.split(" ");
        for(var x = 0; x < groups.length; x++){
            var atomic = groups[x];
            var atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $1d37a3bcd049c79d$var$UNDERSCORE_UNICODE ? $1d37a3bcd049c79d$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    var str = "";
    for(var key in atomicGroups){
        var value = atomicGroups[key];
        str += value + " ";
    }
    return str.slice(0, -1);
}

});

parcelRegister("7Xcnn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ca7a4b320f3c32d$export$2e2bcd8739ae039; });

var $fjkYW = parcelRequire("fjkYW");

var $e6gyJ = parcelRequire("e6gyJ");

var $04Kcc = parcelRequire("04Kcc");

var $1Mpn7 = parcelRequire("1Mpn7");

var $x0QfA = parcelRequire("x0QfA");

var $iCmLV = parcelRequire("iCmLV");

var $6C4Za = parcelRequire("6C4Za");

var $9ETxX = parcelRequire("9ETxX");

var $aB1kl = parcelRequire("aB1kl");
var $5ca7a4b320f3c32d$var$_excluded = [
    "appearance",
    "children",
    "iconBefore",
    "iconAfter",
    "isSelected",
    "onMouseDown",
    "onMouseUp",
    "shouldFitContainer",
    "spacing"
];
var $5ca7a4b320f3c32d$var$isFirefox = typeof navigator !== "undefined" && navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
/**
 * __Button__
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ var $5ca7a4b320f3c32d$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).forwardRef(function Button(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$onMouseDown = _ref.onMouseDown, providedOnMouseDown = _ref$onMouseDown === void 0 ? (0, $x0QfA.default) : _ref$onMouseDown, _ref$onMouseUp = _ref.onMouseUp, providedOnMouseUp = _ref$onMouseUp === void 0 ? (0, $x0QfA.default) : _ref$onMouseUp, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "default" : _ref$spacing, rest = (0, (/*@__PURE__*/$parcel$interopDefault($04Kcc)))(_ref, $5ca7a4b320f3c32d$var$_excluded);
    var _useGlobalTheme = (0, $iCmLV.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    var isOnlySingleIcon = (0, $aB1kl.default)({
        children: children,
        iconBefore: iconBefore,
        iconAfter: iconAfter
    });
    var _useState = (0, $1Mpn7.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($e6gyJ)))(_useState, 2), isActive = _useState2[0], setIsActive = _useState2[1];
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    //  in Firefox
    var onMouseDown = (0, $1Mpn7.useCallback)(function(event) {
        providedOnMouseDown(event);
        if ($5ca7a4b320f3c32d$var$isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    var onMouseUp = (0, $1Mpn7.useCallback)(function(event) {
        providedOnMouseUp(event);
        if ($5ca7a4b320f3c32d$var$isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    var buttonCss = (0, $1Mpn7.useMemo)(function() {
        return (0, $9ETxX.getCss)({
            appearance: appearance,
            spacing: spacing,
            mode: mode,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        });
    }, [
        appearance,
        spacing,
        mode,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $6C4Za.default), (0, (/*@__PURE__*/$parcel$interopDefault($fjkYW)))({}, rest, {
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    }));
}));
// Tools including enzyme rely on components having a display name
$5ca7a4b320f3c32d$var$Button.displayName = "Button";
var $5ca7a4b320f3c32d$export$2e2bcd8739ae039 = $5ca7a4b320f3c32d$var$Button;

});
parcelRegister("x0QfA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0633bc560e86ad5d$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $0633bc560e86ad5d$export$2e2bcd8739ae039() {}

});

parcelRegister("iCmLV", function(module, exports) {

$parcel$export(module.exports, "useGlobalTheme", function () { return $d8dd70a31a3c38b7$export$7692396083754928; });
$parcel$export(module.exports, "default", function () { return $d8dd70a31a3c38b7$export$2e2bcd8739ae039; });

var $a7b0G = parcelRequire("a7b0G");
// Create default global light theme
var $d8dd70a31a3c38b7$var$_createTheme = (0, $a7b0G.createTheme)(function() {
    return {
        mode: "light"
    };
}), $d8dd70a31a3c38b7$var$Provider = $d8dd70a31a3c38b7$var$_createTheme.Provider, $d8dd70a31a3c38b7$var$Consumer = $d8dd70a31a3c38b7$var$_createTheme.Consumer, $d8dd70a31a3c38b7$export$7692396083754928 = $d8dd70a31a3c38b7$var$_createTheme.useTheme;
var $d8dd70a31a3c38b7$export$2e2bcd8739ae039 = {
    Provider: $d8dd70a31a3c38b7$var$Provider,
    Consumer: $d8dd70a31a3c38b7$var$Consumer
};

});
parcelRegister("a7b0G", function(module, exports) {

$parcel$export(module.exports, "createTheme", function () { return $75d3192e86b50a74$export$25d302a5b900a763; });

var $04Kcc = parcelRequire("04Kcc");

var $1Mpn7 = parcelRequire("1Mpn7");
var $75d3192e86b50a74$var$_excluded = [
    "children"
];
function $75d3192e86b50a74$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $1Mpn7.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $1Mpn7.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, (/*@__PURE__*/$parcel$interopDefault($04Kcc)))(props, $75d3192e86b50a74$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $1Mpn7.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $1Mpn7.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});


parcelRegister("6C4Za", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d0a28bd359071d8$export$2e2bcd8739ae039; });

var $fjkYW = parcelRequire("fjkYW");

var $04Kcc = parcelRequire("04Kcc");

var $1Mpn7 = parcelRequire("1Mpn7");

var $fBy54 = parcelRequire("fBy54");

var $159JV = parcelRequire("159JV");

var $x0QfA = parcelRequire("x0QfA");

var $bTGim = parcelRequire("bTGim");

var $imeJC = parcelRequire("imeJC");

var $f3uqe = parcelRequire("f3uqe");

var $cWK60 = parcelRequire("cWK60");

var $csE0A = parcelRequire("csE0A");

var $hdJkV = parcelRequire("hdJkV");

var $9ETxX = parcelRequire("9ETxX");

var $kO69v = parcelRequire("kO69v");
var $4d0a28bd359071d8$var$_excluded = [
    "analyticsContext",
    "appearance",
    "autoFocus",
    "buttonCss",
    "children",
    "className",
    "href",
    "component",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onBlur",
    "onClick",
    "onFocus",
    "onMouseDown",
    "overlay",
    "shouldFitContainer",
    "spacing",
    "tabIndex",
    "type",
    "testId"
];
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
var $4d0a28bd359071d8$var$noPointerEventsOnChildrenCss = {
    "> *": {
        pointerEvents: "none"
    }
};
var $4d0a28bd359071d8$var$iconBeforeSpacingFixStyle = (0, $fBy54.css)({
    marginLeft: "var(--ds-space-negative-025, -2px)"
});
var $4d0a28bd359071d8$var$iconAfterSpacingFixStyle = (0, $fBy54.css)({
    marginRight: "var(--ds-space-negative-025, -2px)"
});
var $4d0a28bd359071d8$var$getSpacingFix = function getSpacingFix(children, spacingStyles) {
    if (!(0, $cWK60.getBooleanFF)("platform.design-system-team.icon-button-spacing-fix_o1zc5") || !children || (0, $kO69v.getIfVisuallyHiddenChildren)(children)) return null;
    return spacingStyles;
};
var $4d0a28bd359071d8$var$getChildren = function getChildren(children, childrenStyles) {
    if ((0, $kO69v.getIfVisuallyHiddenChildren)(children)) return children;
    return children ? (0, $fBy54.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
var $4d0a28bd359071d8$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).forwardRef(function ButtonBase(props, ref) {
    var analyticsContext = props.analyticsContext, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? "default" : _props$appearance, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, buttonCss = props.buttonCss, children = props.children, className = props.className, href = props.href, _props$component = props.component, Component = _props$component === void 0 ? href ? "a" : "button" : _props$component, iconAfter = props.iconAfter, iconBefore = props.iconBefore, interactionName = props.interactionName, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onBlur = props.onBlur, _props$onClick = props.onClick, providedOnClick = _props$onClick === void 0 ? (0, $x0QfA.default) : _props$onClick, onFocus = props.onFocus, _props$onMouseDown = props.onMouseDown, providedOnMouseDown = _props$onMouseDown === void 0 ? (0, $x0QfA.default) : _props$onMouseDown, overlay = props.overlay, shouldFitContainer = props.shouldFitContainer, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? "default" : _props$spacing, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, _props$type = props.type, type = _props$type === void 0 ? !href ? "button" : undefined : _props$type, testId = props.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($04Kcc)))(props, $4d0a28bd359071d8$var$_excluded);
    var ourRef = (0, $1Mpn7.useRef)();
    var setRef = (0, $1Mpn7.useCallback)(function(node) {
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === "function") {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $bTGim.default)(ourRef, autoFocus);
    var interactionContext = (0, $1Mpn7.useContext)((0, $f3uqe.default));
    var handleClick = (0, $1Mpn7.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $159JV.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: "clicked",
        componentName: "button",
        packageName: "@atlaskit/button",
        packageVersion: "16.10.2",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    var onMouseDown = (0, $1Mpn7.useCallback)(function(event) {
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $1Mpn7.useEffect)(function() {
        var el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    var hasOverlay = Boolean(overlay);
    var fadeStyles = (0, $fBy54.css)((0, $9ETxX.getFadingCss)({
        hasOverlay: hasOverlay
    }));
    var isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === "warning") spinnerHackCss = {
        "[data-theme] & circle": {
            stroke: "".concat(isSelected || isDisabled ? "var(--ds-icon-subtle, ".concat((0, $csE0A.N500), ")") : "var(--ds-icon-warning-inverse, ".concat((0, $csE0A.N500), ")"), " !important")
        }
    };
    return (0, $fBy54.jsx)((0, $imeJC.default), null, (0, $fBy54.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($fjkYW)))({}, rest, {
        ref: setRef,
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $4d0a28bd359071d8$var$noPointerEventsOnChildrenCss
        ],
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type
    }, (0, $hdJkV.default)({
        isInteractive: isInteractive
    })), iconBefore ? (0, $fBy54.jsx)("span", {
        css: [
            fadeStyles,
            (0, $9ETxX.getIconStyle)({
                spacing: spacing
            }),
            $4d0a28bd359071d8$var$getSpacingFix(children, $4d0a28bd359071d8$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, !(0, $cWK60.getBooleanFF)("platform.design-system-team.icon-button-spacing-fix_o1zc5") && children ? (0, $fBy54.jsx)("span", {
        css: [
            fadeStyles,
            (0, $9ETxX.getContentStyle)({
                spacing: spacing
            })
        ]
    }, children) : null, (0, $cWK60.getBooleanFF)("platform.design-system-team.icon-button-spacing-fix_o1zc5") && $4d0a28bd359071d8$var$getChildren(children, [
        fadeStyles,
        (0, $9ETxX.getContentStyle)({
            spacing: spacing
        })
    ]), iconAfter ? (0, $fBy54.jsx)("span", {
        css: [
            fadeStyles,
            (0, $9ETxX.getIconStyle)({
                spacing: spacing
            }),
            $4d0a28bd359071d8$var$getSpacingFix(children, $4d0a28bd359071d8$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? (0, $fBy54.jsx)("span", {
        css: [
            (0, $9ETxX.overlayCss),
            spinnerHackCss
        ]
    }, overlay) : null));
});

});
parcelRegister("fBy54", function(module, exports) {

$parcel$export(module.exports, "createElement", function () { return $b5c4bf70a2faa2ff$export$c8a8987d4410bf2d; });
$parcel$export(module.exports, "Global", function () { return $b5c4bf70a2faa2ff$export$98f03c5d19621d70; });
$parcel$export(module.exports, "css", function () { return $b5c4bf70a2faa2ff$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $b5c4bf70a2faa2ff$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "ClassNames", function () { return $b5c4bf70a2faa2ff$export$9b9c0f9d9f3552b8; });
$parcel$export(module.exports, "jsx", function () { return $b5c4bf70a2faa2ff$export$c8a8987d4410bf2d; });
$parcel$export(module.exports, "CacheProvider", function () { return (parcelRequire("7qdHr")).C; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("7qdHr")).T; });
$parcel$export(module.exports, "ThemeProvider", function () { return (parcelRequire("7qdHr")).a; });
$parcel$export(module.exports, "__unsafe_useEmotionCache", function () { return (parcelRequire("7qdHr"))._; });
$parcel$export(module.exports, "useTheme", function () { return (parcelRequire("7qdHr")).u; });
$parcel$export(module.exports, "withEmotionCache", function () { return (parcelRequire("7qdHr")).w; });
$parcel$export(module.exports, "withTheme", function () { return (parcelRequire("7qdHr")).b; });

var $l0HdX = parcelRequire("l0HdX");

var $7qdHr = parcelRequire("7qdHr");

var $1Mpn7 = parcelRequire("1Mpn7");

var $2B9xT = parcelRequire("2B9xT");

var $dkd4E = parcelRequire("dkd4E");

var $dvoqA = parcelRequire("dvoqA");
parcelRequire("9t3nQ");
parcelRequire("fjkYW");
parcelRequire("eZw11");

parcelRequire("knVHJ");
var $b5c4bf70a2faa2ff$var$pkg = {
    name: "@emotion/react",
    version: "11.11.1",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.2",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.0",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $b5c4bf70a2faa2ff$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $7qdHr.h).call(props, "css")) // $FlowFixMe
    return $1Mpn7.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $7qdHr.E);
    createElementArgArray[1] = (0, $7qdHr.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return $1Mpn7.createElement.apply(null, createElementArgArray);
};
var $b5c4bf70a2faa2ff$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $b5c4bf70a2faa2ff$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $7qdHr.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $dvoqA.serializeStyles)([
        styles
    ], undefined, $1Mpn7.useContext((0, $7qdHr.T)));
    if (!(0, $7qdHr.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $1Mpn7.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $1Mpn7.useRef();
    (0, $dkd4E.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $dkd4E.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $2B9xT.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $b5c4bf70a2faa2ff$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $dvoqA.serializeStyles)(args);
}
var $b5c4bf70a2faa2ff$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $b5c4bf70a2faa2ff$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $b5c4bf70a2faa2ff$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg === "undefined" ? "undefined" : (0, $l0HdX._)(arg)){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $b5c4bf70a2faa2ff$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $2B9xT.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $b5c4bf70a2faa2ff$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $dkd4E.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $2B9xT.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $b5c4bf70a2faa2ff$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $7qdHr.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $dvoqA.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $2B9xT.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $b5c4bf70a2faa2ff$var$merge(cache.registered, css, $b5c4bf70a2faa2ff$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $1Mpn7.useContext((0, $7qdHr.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $1Mpn7.createElement($1Mpn7.Fragment, null, /*#__PURE__*/ $1Mpn7.createElement($b5c4bf70a2faa2ff$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $b5c4bf70a2faa2ff$var$isBrowser, $b5c4bf70a2faa2ff$var$isTestEnv, $b5c4bf70a2faa2ff$var$globalContext, $b5c4bf70a2faa2ff$var$globalKey;

});

parcelRegister("159JV", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $0c9dd0325c18d105$export$a4687b0234b40e28; });

var $jjExS = parcelRequire("jjExS");

var $1Mpn7 = parcelRequire("1Mpn7");

var $145N3 = parcelRequire("145N3");

var $8JCSe = parcelRequire("8JCSe");
function $0c9dd0325c18d105$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $0c9dd0325c18d105$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $0c9dd0325c18d105$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $0c9dd0325c18d105$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $0c9dd0325c18d105$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $145N3.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $8JCSe.useTrackedRef)(analyticsData);
    var fnRef = (0, $8JCSe.useTrackedRef)(fn);
    var handler = (0, $1Mpn7.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $0c9dd0325c18d105$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("bTGim", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a95a3b33c0efce9$export$2e2bcd8739ae039; });

var $1Mpn7 = parcelRequire("1Mpn7");
function $8a95a3b33c0efce9$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $1Mpn7.useRef)(true);
    (0, $1Mpn7.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("imeJC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d5d5b615832d4d09$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $1Mpn7 = parcelRequire("1Mpn7");

var $fBy54 = parcelRequire("fBy54");
var $d5d5b615832d4d09$var$BORDER_WIDTH = 2;
var $d5d5b615832d4d09$var$baseFocusOutsideStyles = (0, $fBy54.css)({
    outline: "".concat($d5d5b615832d4d09$var$BORDER_WIDTH, "px solid ", "var(--ds-border-focused, #2684FF)"),
    outlineOffset: $d5d5b615832d4d09$var$BORDER_WIDTH
});
var $d5d5b615832d4d09$var$baseInsetStyles = (0, $fBy54.css)({
    outlineColor: "var(--ds-border-focused, #2684FF)",
    outlineOffset: -$d5d5b615832d4d09$var$BORDER_WIDTH,
    outlineStyle: "solid",
    outlineWidth: "var(--ds-border-width-outline, 2px)"
});
var $d5d5b615832d4d09$var$focusRingStyles = (0, $fBy54.css)({
    "&:focus-visible": $d5d5b615832d4d09$var$baseFocusOutsideStyles,
    "@supports not selector(*:focus-visible)": {
        "&:focus": $d5d5b615832d4d09$var$baseFocusOutsideStyles
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        "&:focus-visible": {
            outline: "1px solid"
        }
    }
});
var $d5d5b615832d4d09$var$insetFocusRingStyles = (0, $fBy54.css)({
    "&:focus-visible": $d5d5b615832d4d09$var$baseInsetStyles,
    "@supports not selector(*:focus-visible)": {
        "&:focus": $d5d5b615832d4d09$var$baseInsetStyles
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        "&:focus-visible": {
            outline: "1px solid",
            outlineOffset: "-1px"
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * There are known accessibility issues with this component.
 * Do not use without assistance from the Design System accessibility team.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 */ var $d5d5b615832d4d09$var$FocusRing = /*#__PURE__*/ (0, $1Mpn7.memo)(function(_ref) {
    var children = _ref.children, isInset = _ref.isInset, focus = _ref.focus;
    var controlledStyles = isInset ? $d5d5b615832d4d09$var$baseInsetStyles : $d5d5b615832d4d09$var$baseFocusOutsideStyles;
    var uncontrolledStyles = isInset ? $d5d5b615832d4d09$var$insetFocusRingStyles : $d5d5b615832d4d09$var$focusRingStyles;
    var focusCls = typeof focus === "undefined" ? uncontrolledStyles : focus === "on" && controlledStyles;
    return (0, $fBy54.jsx)((0, $fBy54.ClassNames), null, function(_ref2) {
        var _$css = _ref2.css, cx = _ref2.cx;
        return (0, $1Mpn7.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, $1Mpn7.cloneElement)(children, {
            className: cx([
                _$css(focusCls),
                children.props.className
            ])
        }) : children);
    });
});
$d5d5b615832d4d09$var$FocusRing.displayName = "FocusRing";
var $d5d5b615832d4d09$export$2e2bcd8739ae039 = $d5d5b615832d4d09$var$FocusRing;

});

parcelRegister("csE0A", function(module, exports) {

$parcel$export(module.exports, "R300", function () { return $9127226cc527affc$export$4a7404f376229999; });
$parcel$export(module.exports, "R400", function () { return $9127226cc527affc$export$2010d0fb4295b346; });
$parcel$export(module.exports, "R500", function () { return $9127226cc527affc$export$2837b5a1a71d5c02; });
$parcel$export(module.exports, "Y200", function () { return $9127226cc527affc$export$5aae31392d72caaa; });
$parcel$export(module.exports, "Y300", function () { return $9127226cc527affc$export$c6930421db9fa514; });
$parcel$export(module.exports, "Y400", function () { return $9127226cc527affc$export$59619663aa6500fb; });
$parcel$export(module.exports, "B50", function () { return $9127226cc527affc$export$226de0355ed012f8; });
$parcel$export(module.exports, "B75", function () { return $9127226cc527affc$export$8c13c2ee36917869; });
$parcel$export(module.exports, "B100", function () { return $9127226cc527affc$export$ecfc1dff386a3e7a; });
$parcel$export(module.exports, "B200", function () { return $9127226cc527affc$export$215b7063051591f1; });
$parcel$export(module.exports, "B300", function () { return $9127226cc527affc$export$e62e8919cca44969; });
$parcel$export(module.exports, "B400", function () { return $9127226cc527affc$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "B500", function () { return $9127226cc527affc$export$a6ee3d71bc067634; });
$parcel$export(module.exports, "N0", function () { return $9127226cc527affc$export$29a4f05edc054374; });
$parcel$export(module.exports, "N20", function () { return $9127226cc527affc$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N70", function () { return $9127226cc527affc$export$5f71e19f3a7ad9de; });
$parcel$export(module.exports, "N90", function () { return $9127226cc527affc$export$7c87d337fb91a97d; });
$parcel$export(module.exports, "N200", function () { return $9127226cc527affc$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N400", function () { return $9127226cc527affc$export$eece5f492e429f08; });
$parcel$export(module.exports, "N500", function () { return $9127226cc527affc$export$c39c0fe0f26207ae; });
$parcel$export(module.exports, "N700", function () { return $9127226cc527affc$export$ad0bacf983b7ddaa; });
$parcel$export(module.exports, "N800", function () { return $9127226cc527affc$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N20A", function () { return $9127226cc527affc$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $9127226cc527affc$export$920c0d5c49070351; });
$parcel$export(module.exports, "DN900", function () { return $9127226cc527affc$export$2f6319cf7d736c2a; });
$parcel$export(module.exports, "DN500", function () { return $9127226cc527affc$export$9f0a771d16ec8d36; });
$parcel$export(module.exports, "DN400", function () { return $9127226cc527affc$export$abcf8c38338b4aa5; });
$parcel$export(module.exports, "DN300", function () { return $9127226cc527affc$export$97e81faa16a182c7; });
$parcel$export(module.exports, "DN100", function () { return $9127226cc527affc$export$ee82aa2ea6a1558; });
$parcel$export(module.exports, "DN70", function () { return $9127226cc527affc$export$d281fbfe3cff2df6; });
$parcel$export(module.exports, "DN60", function () { return $9127226cc527affc$export$3902c91d8b98a753; });
$parcel$export(module.exports, "DN30", function () { return $9127226cc527affc$export$633847cf062b69e0; });
$parcel$export(module.exports, "DN0", function () { return $9127226cc527affc$export$3d4f271a500072a; });
$parcel$export(module.exports, "skeleton", function () { return $9127226cc527affc$export$2a0674ff2eb10214; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $dXv5R = parcelRequire("dXv5R");
var $9127226cc527affc$export$4b84fd0e2c617bd = "#FFEBE6";
var $9127226cc527affc$export$b34b069eff244586 = "#FFBDAD";
var $9127226cc527affc$export$be802dd0d8b57f35 = "#FF8F73";
var $9127226cc527affc$export$60847d42f9da92a6 = "#FF7452";
var $9127226cc527affc$export$4a7404f376229999 = "#FF5630";
var $9127226cc527affc$export$2010d0fb4295b346 = "#DE350B";
var $9127226cc527affc$export$2837b5a1a71d5c02 = "#BF2600";
var $9127226cc527affc$export$8d9596b529bbb9cf = "#FFFAE6";
var $9127226cc527affc$export$41060a744ab0b7ae = "#FFF0B3";
var $9127226cc527affc$export$1cc05bbbf340e559 = "#FFE380";
var $9127226cc527affc$export$5aae31392d72caaa = "#FFC400";
var $9127226cc527affc$export$c6930421db9fa514 = "#FFAB00";
var $9127226cc527affc$export$59619663aa6500fb = "#FF991F";
var $9127226cc527affc$export$874739ea9e379ab6 = "#FF8B00";
var $9127226cc527affc$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $9127226cc527affc$export$69a3bf21b9686c2b = "#ABF5D1";
var $9127226cc527affc$export$afbce1382ec95f73 = "#79F2C0";
var $9127226cc527affc$export$747d86715d4175de = "#57D9A3";
var $9127226cc527affc$export$940e1f69e873f202 = "#36B37E";
var $9127226cc527affc$export$a49394138f7b8e85 = "#00875A";
var $9127226cc527affc$export$6fa04827ac68a4fb = "#006644";
var $9127226cc527affc$export$226de0355ed012f8 = "#DEEBFF";
var $9127226cc527affc$export$8c13c2ee36917869 = "#B3D4FF";
var $9127226cc527affc$export$ecfc1dff386a3e7a = "#4C9AFF";
var $9127226cc527affc$export$215b7063051591f1 = "#2684FF";
var $9127226cc527affc$export$e62e8919cca44969 = "#0065FF";
var $9127226cc527affc$export$b3de0ae08da2ce64 = "#0052CC";
var $9127226cc527affc$export$a6ee3d71bc067634 = "#0747A6";
var $9127226cc527affc$export$363e4475840015bb = "#EAE6FF";
var $9127226cc527affc$export$4b0a4417ed59760f = "#C0B6F2";
var $9127226cc527affc$export$6011520a64d9a187 = "#998DD9";
var $9127226cc527affc$export$a7175d4e9206bc80 = "#8777D9";
var $9127226cc527affc$export$b48405b95304b5a1 = "#6554C0";
var $9127226cc527affc$export$c71e4279dd54a18d = "#5243AA";
var $9127226cc527affc$export$147899de772240ec = "#403294";
var $9127226cc527affc$export$2cf711fe14c66f06 = "#E6FCFF";
var $9127226cc527affc$export$7a8f4d33f6f9772c = "#B3F5FF";
var $9127226cc527affc$export$776c9c497ef08533 = "#79E2F2";
var $9127226cc527affc$export$69cb3ca10c1e330e = "#00C7E6";
var $9127226cc527affc$export$9dc1ef0f3f48059b = "#00B8D9";
var $9127226cc527affc$export$7c835c78b6fcdef8 = "#00A3BF";
var $9127226cc527affc$export$6036577f95c3877e = "#008DA6";
var $9127226cc527affc$export$29a4f05edc054374 = "#FFFFFF";
var $9127226cc527affc$export$e655ef011c4aa1a2 = "#FAFBFC";
var $9127226cc527affc$export$9fdfb749e33cdf97 = "#F4F5F7";
var $9127226cc527affc$export$3e51e8f1440314ba = "#EBECF0";
var $9127226cc527affc$export$1ce2d1575d444ceb = "#DFE1E6";
var $9127226cc527affc$export$8754fc7e6d8b3000 = "#C1C7D0";
var $9127226cc527affc$export$c2e91cbeada39b8b = "#B3BAC5";
var $9127226cc527affc$export$5f71e19f3a7ad9de = "#A5ADBA";
var $9127226cc527affc$export$eaa8c8a70ac22806 = "#97A0AF";
var $9127226cc527affc$export$7c87d337fb91a97d = "#8993A4";
var $9127226cc527affc$export$d6447c357493214f = "#7A869A";
var $9127226cc527affc$export$f563ee71e9ee74cd = "#6B778C";
var $9127226cc527affc$export$e2ef2124cf4024b1 = "#5E6C84";
var $9127226cc527affc$export$eece5f492e429f08 = "#505F79";
var $9127226cc527affc$export$c39c0fe0f26207ae = "#42526E";
var $9127226cc527affc$export$7090862dc3038a9f = "#344563";
var $9127226cc527affc$export$ad0bacf983b7ddaa = "#253858";
var $9127226cc527affc$export$7d61b15e0da132af = "#172B4D";
var $9127226cc527affc$export$fbda843f0a27fe96 = "#091E42";
var $9127226cc527affc$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $9127226cc527affc$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $9127226cc527affc$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $9127226cc527affc$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $9127226cc527affc$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $9127226cc527affc$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $9127226cc527affc$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $9127226cc527affc$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $9127226cc527affc$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $9127226cc527affc$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $9127226cc527affc$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $9127226cc527affc$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $9127226cc527affc$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $9127226cc527affc$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $9127226cc527affc$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $9127226cc527affc$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $9127226cc527affc$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $9127226cc527affc$export$2f6319cf7d736c2a = "#E6EDFA";
var $9127226cc527affc$export$95126bc8884d6634 = "#DCE5F5";
var $9127226cc527affc$export$8338d8c35d44ff1 = "#CED9EB";
var $9127226cc527affc$export$5368d76ae4fbbda7 = "#B8C7E0";
var $9127226cc527affc$export$9f0a771d16ec8d36 = "#ABBBD6";
var $9127226cc527affc$export$abcf8c38338b4aa5 = "#9FB0CC";
var $9127226cc527affc$export$97e81faa16a182c7 = "#8C9CB8";
var $9127226cc527affc$export$bfe21c59123ecf33 = "#7988A3";
var $9127226cc527affc$export$ee82aa2ea6a1558 = "#67758F";
var $9127226cc527affc$export$682927c6ed76be02 = "#56637A";
var $9127226cc527affc$export$91fd9994c5be9757 = "#455166";
var $9127226cc527affc$export$d281fbfe3cff2df6 = "#3B475C";
var $9127226cc527affc$export$3902c91d8b98a753 = "#313D52";
var $9127226cc527affc$export$8e8133c1ba5845b5 = "#283447";
var $9127226cc527affc$export$33ff357f6620b39 = "#202B3D";
var $9127226cc527affc$export$633847cf062b69e0 = "#1B2638";
var $9127226cc527affc$export$9776a6e503bdbf76 = "#121A29";
var $9127226cc527affc$export$6c813d5160dff5db = "#0E1624";
var $9127226cc527affc$export$3d4f271a500072a = "#0D1424";
var $9127226cc527affc$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $9127226cc527affc$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $9127226cc527affc$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $9127226cc527affc$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $9127226cc527affc$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $9127226cc527affc$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $9127226cc527affc$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $9127226cc527affc$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $9127226cc527affc$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $9127226cc527affc$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $9127226cc527affc$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $9127226cc527affc$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $9127226cc527affc$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $9127226cc527affc$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $9127226cc527affc$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $9127226cc527affc$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $9127226cc527affc$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $9127226cc527affc$export$8ce1fd94bee2f412 = (0, $dXv5R.default)({
    light: "var(--ds-surface, ".concat($9127226cc527affc$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface, ".concat($9127226cc527affc$export$633847cf062b69e0, ")")
});
var $9127226cc527affc$export$b861914ea877b580 = (0, $dXv5R.default)({
    light: "var(--ds-background-selected, ".concat($9127226cc527affc$export$226de0355ed012f8, ")"),
    dark: "var(--ds-background-selected, ".concat($9127226cc527affc$export$8c13c2ee36917869, ")")
});
var $9127226cc527affc$export$3f1b020df94387af = (0, $dXv5R.default)({
    light: "var(--ds-background-neutral-hovered, ".concat($9127226cc527affc$export$3e51e8f1440314ba, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat($9127226cc527affc$export$d281fbfe3cff2df6, ")")
});
var $9127226cc527affc$export$c0183dbab98ca63e = (0, $dXv5R.default)({
    light: "var(--ds-surface-overlay, ".concat($9127226cc527affc$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface-overlay, ".concat($9127226cc527affc$export$8e8133c1ba5845b5, ")")
});
var $9127226cc527affc$export$6f093cfa640b7166 = (0, $dXv5R.default)({
    light: "var(--ds-text, ".concat($9127226cc527affc$export$fbda843f0a27fe96, ")"),
    dark: "var(--ds-text, ".concat($9127226cc527affc$export$5368d76ae4fbbda7, ")")
});
var $9127226cc527affc$export$42f8e9c698766e7a = (0, $dXv5R.default)({
    light: "var(--ds-text, ".concat($9127226cc527affc$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($9127226cc527affc$export$5368d76ae4fbbda7, ")")
});
var $9127226cc527affc$export$c2d157ca1c34b6e3 = (0, $dXv5R.default)({
    light: "var(--ds-text-selected, ".concat($9127226cc527affc$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-text-selected, ".concat($9127226cc527affc$export$b3de0ae08da2ce64, ")")
});
var $9127226cc527affc$export$1905ba28d7cf066f = (0, $dXv5R.default)({
    light: "var(--ds-text-subtlest, ".concat($9127226cc527affc$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($9127226cc527affc$export$97e81faa16a182c7, ")")
});
var $9127226cc527affc$export$bd9002130d306d39 = (0, $dXv5R.default)({
    light: "var(--ds-text-subtlest, ".concat($9127226cc527affc$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($9127226cc527affc$export$bfe21c59123ecf33, ")")
});
var $9127226cc527affc$export$46e4a324ac90507f = (0, $dXv5R.default)({
    light: "var(--ds-text, ".concat($9127226cc527affc$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($9127226cc527affc$export$5368d76ae4fbbda7, ")")
});
var $9127226cc527affc$export$79f3f2b82beb0d36 = (0, $dXv5R.default)({
    light: "var(--ds-text-subtlest, ".concat($9127226cc527affc$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($9127226cc527affc$export$97e81faa16a182c7, ")")
});
var $9127226cc527affc$export$7bb0d5c671655cc4 = (0, $dXv5R.default)({
    light: $9127226cc527affc$export$9fdfb749e33cdf97,
    dark: $9127226cc527affc$export$8e8133c1ba5845b5
});
var $9127226cc527affc$export$9c30223ca0a664fb = (0, $dXv5R.default)({
    light: "var(--ds-link, ".concat($9127226cc527affc$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-link, ".concat($9127226cc527affc$export$ecfc1dff386a3e7a, ")")
});
var $9127226cc527affc$export$7ed258b0728b004b = (0, $dXv5R.default)({
    light: "var(--ds-link-pressed, ".concat($9127226cc527affc$export$e62e8919cca44969, ")"),
    dark: "var(--ds-link-pressed, ".concat($9127226cc527affc$export$215b7063051591f1, ")")
});
var $9127226cc527affc$export$dfa920d8decc8a59 = (0, $dXv5R.default)({
    light: "var(--ds-link-pressed, ".concat($9127226cc527affc$export$a6ee3d71bc067634, ")"),
    dark: "var(--ds-link-pressed, ".concat($9127226cc527affc$export$ecfc1dff386a3e7a, ")")
});
var $9127226cc527affc$export$6069e6ad5c78f632 = (0, $dXv5R.default)({
    light: "var(--ds-border-focused, ".concat($9127226cc527affc$export$215b7063051591f1, ")"),
    dark: "var(--ds-border-focused, ".concat($9127226cc527affc$export$215b7063051591f1, ")")
});
var $9127226cc527affc$export$9ad721cf3b3debe0 = (0, $dXv5R.default)({
    light: "var(--ds-background-brand-bold, ".concat($9127226cc527affc$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-background-brand-bold, ".concat($9127226cc527affc$export$ecfc1dff386a3e7a, ")")
});
var $9127226cc527affc$export$2aa0182783e7e9de = (0, $dXv5R.default)({
    light: $9127226cc527affc$export$b3de0ae08da2ce64,
    dark: $9127226cc527affc$export$ecfc1dff386a3e7a
});
var $9127226cc527affc$export$8bf7dff220b82b4a = (0, $dXv5R.default)({
    light: $9127226cc527affc$export$9dc1ef0f3f48059b,
    dark: $9127226cc527affc$export$69cb3ca10c1e330e
});
var $9127226cc527affc$export$e13cce2a2d16a9d4 = (0, $dXv5R.default)({
    light: $9127226cc527affc$export$b48405b95304b5a1,
    dark: $9127226cc527affc$export$6011520a64d9a187
});
var $9127226cc527affc$export$a90204d1394caf30 = (0, $dXv5R.default)({
    light: $9127226cc527affc$export$4a7404f376229999,
    dark: $9127226cc527affc$export$4a7404f376229999
});
var $9127226cc527affc$export$594c5a8758200c32 = (0, $dXv5R.default)({
    light: $9127226cc527affc$export$c6930421db9fa514,
    dark: $9127226cc527affc$export$c6930421db9fa514
});
var $9127226cc527affc$export$955a2ebd2fb142ae = (0, $dXv5R.default)({
    light: $9127226cc527affc$export$940e1f69e873f202,
    dark: $9127226cc527affc$export$940e1f69e873f202
});
var $9127226cc527affc$export$2a0674ff2eb10214 = function skeleton() {
    return "var(--ds-skeleton, ".concat($9127226cc527affc$export$8d43898f60b96a82, ")");
};

});
parcelRegister("dXv5R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a298e7902b888cbc$export$2e2bcd8739ae039; });
/* eslint-disable prefer-rest-params */ 
var $eHxe6 = parcelRequire("eHxe6");
// Unpack custom variants, and get correct value for the current theme
function $a298e7902b888cbc$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $eHxe6.default)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return "";
    };
}
function $a298e7902b888cbc$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === "string") return $a298e7902b888cbc$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $eHxe6.default)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return "";
    };
}

});
parcelRegister("eHxe6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab3edaec0d206f25$export$2e2bcd8739ae039; });

var $8FUxt = parcelRequire("8FUxt");
function $ab3edaec0d206f25$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $8FUxt.CHANNEL) in props.theme) return props.theme[0, $8FUxt.CHANNEL];
        else if ("mode" in props.theme && (0, $8FUxt.THEME_MODES).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $8FUxt.DEFAULT_THEME_MODE)
    };
}

});
parcelRegister("8FUxt", function(module, exports) {

$parcel$export(module.exports, "CHANNEL", function () { return $650e0285c7e647eb$export$44ffba16bd48dac6; });
$parcel$export(module.exports, "DEFAULT_THEME_MODE", function () { return $650e0285c7e647eb$export$c93026a968943f95; });
$parcel$export(module.exports, "THEME_MODES", function () { return $650e0285c7e647eb$export$6ba72c8346b4c57e; });
$parcel$export(module.exports, "gridSize", function () { return $650e0285c7e647eb$export$6d8204c2cb2e06b8; });
$parcel$export(module.exports, "fontSize", function () { return $650e0285c7e647eb$export$85e3c3ca0c6fb93; });

var $2Eqc7 = parcelRequire("2Eqc7");

var $csE0A = parcelRequire("csE0A");
var $650e0285c7e647eb$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $650e0285c7e647eb$export$c93026a968943f95 = "light";
var $650e0285c7e647eb$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $650e0285c7e647eb$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $650e0285c7e647eb$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $650e0285c7e647eb$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $650e0285c7e647eb$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $650e0285c7e647eb$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $650e0285c7e647eb$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $650e0285c7e647eb$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $csE0A.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $650e0285c7e647eb$export$6d8204c2cb2e06b8() / 4;
    (0, $2Eqc7.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $650e0285c7e647eb$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $650e0285c7e647eb$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $650e0285c7e647eb$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $2Eqc7.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $650e0285c7e647eb$export$ba1d834b86d72a09 = $650e0285c7e647eb$export$a1b3edb637fb4f35;
var $650e0285c7e647eb$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $csE0A.skeleton)(), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $csE0A.skeleton)(), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $csE0A.N30A), ")")
            }
        }
    };
};

});
parcelRegister("2Eqc7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ee3a2e0bc14643a$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "propDeprecationWarning", function () { return $1ee3a2e0bc14643a$export$eb1decd851a5ae56; });

var $l0HdX = parcelRequire("l0HdX");

var $24eof = parcelRequire("24eof");

var $3qWgZ = parcelRequire("3qWgZ");
function $1ee3a2e0bc14643a$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $24eof.default)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $1ee3a2e0bc14643a$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $3qWgZ === "undefined" ? "undefined" : (0, $l0HdX._)($3qWgZ);
}

});
parcelRegister("24eof", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $18171e159587ca6d$export$2e2bcd8739ae039; });
/* eslint-disable no-console */ var $18171e159587ca6d$var$printed = {};
function $18171e159587ca6d$export$2e2bcd8739ae039(message) {
    if ($18171e159587ca6d$var$printed[message]) return;
    $18171e159587ca6d$var$printed[message] = true;
    if (typeof window !== "undefined") console.warn(message);
}

});






parcelRegister("hdJkV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c896d17505af449c$export$2e2bcd8739ae039; });
function $c896d17505af449c$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $c896d17505af449c$var$tabKeyCode = 9;
function $c896d17505af449c$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $c896d17505af449c$var$tabKeyCode) return;
    $c896d17505af449c$var$abort(event);
}
var $c896d17505af449c$var$block = {
    onMouseDownCapture: $c896d17505af449c$var$abort,
    onMouseUpCapture: $c896d17505af449c$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $c896d17505af449c$var$onKey,
    onKeyUpCapture: $c896d17505af449c$var$onKey,
    onTouchStartCapture: $c896d17505af449c$var$abort,
    onTouchEndCapture: $c896d17505af449c$var$abort,
    onPointerDownCapture: $c896d17505af449c$var$abort,
    onPointerUpCapture: $c896d17505af449c$var$abort,
    onClickCapture: $c896d17505af449c$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $c896d17505af449c$var$abort
};
var $c896d17505af449c$var$doNotBlock = {};
function $c896d17505af449c$export$2e2bcd8739ae039(_ref) {
    var isInteractive = _ref.isInteractive;
    return isInteractive ? $c896d17505af449c$var$doNotBlock : $c896d17505af449c$var$block;
}

});

parcelRegister("9ETxX", function(module, exports) {

$parcel$export(module.exports, "getCss", function () { return $7082efe7592a9cf5$export$955358618f994a11; });
$parcel$export(module.exports, "getIconStyle", function () { return $7082efe7592a9cf5$export$864eea3f4ec3368f; });
$parcel$export(module.exports, "getContentStyle", function () { return $7082efe7592a9cf5$export$7ad0316cc0dd65a; });
$parcel$export(module.exports, "getFadingCss", function () { return $7082efe7592a9cf5$export$1b5827d324e945b1; });
$parcel$export(module.exports, "overlayCss", function () { return $7082efe7592a9cf5$export$1a9fe1b84c876bb5; });

var $jjExS = parcelRequire("jjExS");

var $fBy54 = parcelRequire("fBy54");

var $8FUxt = parcelRequire("8FUxt");

var $cREuz = parcelRequire("cREuz");
function $7082efe7592a9cf5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7082efe7592a9cf5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7082efe7592a9cf5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7082efe7592a9cf5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7082efe7592a9cf5$var$gridSize = (0, $8FUxt.gridSize)();
var $7082efe7592a9cf5$var$fontSize = (0, $8FUxt.fontSize)();
// ## Button layout
//
// /------------------------------------------------------------------------------------------------------------------\
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// |  10px →  |  ← 2px  |   icon   |  2px →  |  ← 2px  |           |  2px →  |  ← 2px  |  icon   |  2px →  |  ← 10px  |
// |  padding |  margin |  before  |  margin |  margin |  content  |  margin |  margin |  after  |  margin |  padding |
// |    (12px total)    |          |    (4px total)    |           |    (4px total)    |         |    (12px total)    |
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// \------------------------------------------------------------------------------------------------------------------/
//                                           ↑                               ↑
//                                        Margins don't collapse with inline-flex
//
var $7082efe7592a9cf5$var$heights = {
    default: "".concat($7082efe7592a9cf5$var$gridSize * 4 / $7082efe7592a9cf5$var$fontSize, "em"),
    // 32px
    compact: "".concat($7082efe7592a9cf5$var$gridSize * 3 / $7082efe7592a9cf5$var$fontSize, "em"),
    none: "auto"
};
var $7082efe7592a9cf5$var$lineHeights = {
    default: $7082efe7592a9cf5$var$heights.default,
    compact: $7082efe7592a9cf5$var$heights.compact,
    none: "inherit"
};
var $7082efe7592a9cf5$var$padding = {
    // 10px gutter
    default: "0 ".concat($7082efe7592a9cf5$var$gridSize + $7082efe7592a9cf5$var$gridSize / 4, "px"),
    compact: "0 ".concat($7082efe7592a9cf5$var$gridSize + $7082efe7592a9cf5$var$gridSize / 4, "px"),
    none: "0"
};
var $7082efe7592a9cf5$var$singleIconPadding = {
    // 2px gutter
    compact: "0 ".concat($7082efe7592a9cf5$var$gridSize / 4, "px"),
    default: "0 ".concat($7082efe7592a9cf5$var$gridSize / 4, "px"),
    none: "0"
};
var $7082efe7592a9cf5$var$verticalAlign = {
    default: "middle",
    compact: "middle",
    none: "baseline"
};
var $7082efe7592a9cf5$var$innerMargin = {
    content: "0 ".concat($7082efe7592a9cf5$var$gridSize / 4, "px"),
    icon: "0 ".concat($7082efe7592a9cf5$var$gridSize / 4, "px")
};
function $7082efe7592a9cf5$var$getColor(_ref) {
    var group = _ref.group, key = _ref.key, mode = _ref.mode;
    var rule = group[key] || group.default;
    return rule[mode];
}
function $7082efe7592a9cf5$var$getColors(_ref2) {
    var appearance = _ref2.appearance, key = _ref2.key, mode = _ref2.mode;
    return {
        background: $7082efe7592a9cf5$var$getColor({
            group: (0, $cREuz.default).background[appearance],
            key: key,
            mode: mode
        }),
        // Needing to add !important to overcome specificity issue caused by deprecated AtlaskitThemeProvider
        color: "".concat($7082efe7592a9cf5$var$getColor({
            group: (0, $cREuz.default).color[appearance],
            key: key,
            mode: mode
        }), " !important")
    };
}
function $7082efe7592a9cf5$export$955358618f994a11(_ref3) {
    var appearance = _ref3.appearance, spacing = _ref3.spacing, mode = _ref3.mode, isSelected = _ref3.isSelected, shouldFitContainer = _ref3.shouldFitContainer, isOnlySingleIcon = _ref3.isOnlySingleIcon;
    var baseColors = $7082efe7592a9cf5$var$getColors({
        appearance: appearance,
        key: isSelected ? "selected" : "default",
        mode: mode
    });
    return $7082efe7592a9cf5$var$_objectSpread($7082efe7592a9cf5$var$_objectSpread({
        // 0px margin added to css-reset
        alignItems: "baseline",
        borderWidth: 0,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxSizing: "border-box",
        display: "inline-flex",
        fontSize: "inherit",
        fontStyle: "normal",
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: "inherit",
        fontWeight: 500,
        // margin for button has been applied to css reset
        maxWidth: "100%",
        // Needed to position overlay
        position: "relative",
        textAlign: "center",
        textDecoration: "none",
        transition: "background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)",
        whiteSpace: "nowrap"
    }, baseColors), {}, {
        cursor: "pointer",
        height: $7082efe7592a9cf5$var$heights[spacing],
        lineHeight: $7082efe7592a9cf5$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $7082efe7592a9cf5$var$singleIconPadding[spacing] : $7082efe7592a9cf5$var$padding[spacing],
        verticalAlign: $7082efe7592a9cf5$var$verticalAlign[spacing],
        width: shouldFitContainer ? "100%" : "auto",
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: "center",
        // Note: we cannot disable pointer events when there is an overlay.
        // That would be easy for styling, but it would start letting events through on disabled buttons
        // Disabling visited styles (just using the base colors)
        "&:visited": $7082efe7592a9cf5$var$_objectSpread({}, baseColors),
        "&:hover": $7082efe7592a9cf5$var$_objectSpread($7082efe7592a9cf5$var$_objectSpread({}, $7082efe7592a9cf5$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "hover",
            mode: mode
        })), {}, {
            textDecoration: !isSelected && (appearance === "link" || appearance === "subtle-link") ? "underline" : "inherit",
            // background, box-shadow
            transitionDuration: "0s, 0.15s"
        }),
        // giving active styles preference by listing them after focus
        "&:active": $7082efe7592a9cf5$var$_objectSpread($7082efe7592a9cf5$var$_objectSpread({}, $7082efe7592a9cf5$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "active",
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: "0s, 0s"
        }),
        // preventDefault prevents regular active styles from applying in Firefox
        '&[data-firefox-is-active="true"]': $7082efe7592a9cf5$var$_objectSpread($7082efe7592a9cf5$var$_objectSpread({}, $7082efe7592a9cf5$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "active",
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: "0s, 0s"
        }),
        // Giving disabled styles preference over active by listing them after.
        // Not using '&:disabled' because :disabled is not a valid state for all element types
        // so we are targeting the attribute
        // Attributes have the same specificity a pseudo classes so we are overriding :disabled here
        "&[disabled]": $7082efe7592a9cf5$var$_objectSpread($7082efe7592a9cf5$var$_objectSpread({}, $7082efe7592a9cf5$var$getColors({
            appearance: appearance,
            key: "disabled",
            mode: mode
        })), {}, {
            cursor: "not-allowed",
            textDecoration: "none"
        }),
        '&[data-has-overlay="true"]': {
            cursor: "default",
            textDecoration: "none"
        },
        // disabling hover and active color changes when there is an overlay, but the button is not disabled
        '&[data-has-overlay="true"]:not([disabled]):hover, &[data-has-overlay="true"]:not([disabled]):active': $7082efe7592a9cf5$var$_objectSpread({}, $7082efe7592a9cf5$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "default",
            mode: mode
        })),
        "&::-moz-focus-inner": {
            border: 0,
            margin: 0,
            padding: 0
        }
    });
}
function $7082efe7592a9cf5$export$864eea3f4ec3368f(_ref4) {
    var spacing = _ref4.spacing;
    return (0, $fBy54.css)({
        display: "flex",
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        margin: spacing === "none" ? 0 : $7082efe7592a9cf5$var$innerMargin.icon,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: "center",
        fontSize: 0,
        lineHeight: 0,
        userSelect: "none"
    });
}
function $7082efe7592a9cf5$export$7ad0316cc0dd65a(_ref5) {
    var spacing = _ref5.spacing;
    return (0, $fBy54.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        margin: spacing === "none" ? 0 : $7082efe7592a9cf5$var$innerMargin.content,
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    });
}
function $7082efe7592a9cf5$export$1b5827d324e945b1(_ref6) {
    var hasOverlay = _ref6.hasOverlay;
    return (0, $fBy54.css)({
        opacity: hasOverlay ? 0 : 1,
        transition: "opacity 0.3s"
    });
}
var $7082efe7592a9cf5$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
};

});
parcelRegister("cREuz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95d9d8259d2eb1ef$export$2e2bcd8739ae039; });

var $csE0A = parcelRequire("csE0A");
// Hard coding the active rgba color value rather than using a helper to convert it
// With helper it would be: hex2rgba(colors.B75, 0.6)
var $95d9d8259d2eb1ef$var$fadedB75 = "rgba(179, 212, 255, 0.6)";
var $95d9d8259d2eb1ef$var$values = {
    // Default appearance
    background: {
        default: {
            default: {
                light: "var(--ds-background-neutral, ".concat($csE0A.N20A, ")"),
                dark: "var(--ds-background-neutral, ".concat($csE0A.DN70, ")")
            },
            hover: {
                light: "var(--ds-background-neutral-hovered, ".concat($csE0A.N30A, ")"),
                dark: "var(--ds-background-neutral-hovered, ".concat($csE0A.DN60, ")")
            },
            active: {
                light: "var(--ds-background-neutral-pressed, ".concat($95d9d8259d2eb1ef$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-pressed, ".concat($csE0A.B75, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($csE0A.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($csE0A.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($csE0A.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($csE0A.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($csE0A.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($csE0A.DN0, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-background-brand-bold, ".concat($csE0A.B400, ")"),
                dark: "var(--ds-background-brand-bold, ".concat($csE0A.B100, ")")
            },
            hover: {
                light: "var(--ds-background-brand-bold-hovered, ".concat($csE0A.B300, ")"),
                dark: "var(--ds-background-brand-bold-hovered, ".concat($csE0A.B75, ")")
            },
            active: {
                light: "var(--ds-background-brand-bold-pressed, ".concat($csE0A.B500, ")"),
                dark: "var(--ds-background-brand-bold-pressed, ".concat($csE0A.B200, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($csE0A.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($csE0A.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($csE0A.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($csE0A.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($csE0A.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($csE0A.DN0, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-background-warning-bold, ".concat($csE0A.Y300, ")"),
                dark: "var(--ds-background-warning-bold, ".concat($csE0A.Y300, ")")
            },
            hover: {
                light: "var(--ds-background-warning-bold-hovered, ".concat($csE0A.Y200, ")"),
                dark: "var(--ds-background-warning-bold-hovered, ".concat($csE0A.Y200, ")")
            },
            active: {
                light: "var(--ds-background-warning-bold-pressed, ".concat($csE0A.Y400, ")"),
                dark: "var(--ds-background-warning-bold-pressed, ".concat($csE0A.Y400, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($csE0A.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($csE0A.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($csE0A.Y400, ")"),
                dark: "var(--ds-background-selected, ".concat($csE0A.Y400, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($csE0A.Y400, ")"),
                dark: "var(--ds-background-selected, ".concat($csE0A.Y400, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-background-danger-bold, ".concat($csE0A.R400, ")"),
                dark: "var(--ds-background-danger-bold, ".concat($csE0A.R400, ")")
            },
            hover: {
                light: "var(--ds-background-danger-bold-hovered, ".concat($csE0A.R300, ")"),
                dark: "var(--ds-background-danger-bold-hovered, ".concat($csE0A.R300, ")")
            },
            active: {
                light: "var(--ds-background-danger-bold-pressed, ".concat($csE0A.R500, ")"),
                dark: "var(--ds-background-danger-bold-pressed, ".concat($csE0A.R500, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($csE0A.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($csE0A.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($csE0A.R500, ")"),
                dark: "var(--ds-background-selected, ".concat($csE0A.R500, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($csE0A.R500, ")"),
                dark: "var(--ds-background-selected, ".concat($csE0A.R500, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($csE0A.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($csE0A.N20, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($csE0A.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($csE0A.N20, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            hover: {
                light: "var(--ds-background-neutral-subtle-hovered, ".concat($csE0A.N30A, ")"),
                dark: "var(--ds-background-neutral-subtle-hovered, ".concat($csE0A.DN60, ")")
            },
            active: {
                light: "var(--ds-background-neutral-subtle-pressed, ".concat($95d9d8259d2eb1ef$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-subtle-pressed, ".concat($csE0A.B75, ")")
            },
            disabled: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($csE0A.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($csE0A.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($csE0A.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($csE0A.DN0, ")")
            }
        },
        "subtle-link": {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($csE0A.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($csE0A.N20, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($csE0A.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($csE0A.N20, ")")
            }
        }
    },
    color: {
        default: {
            default: {
                light: "var(--ds-text, ".concat($csE0A.N500, ")"),
                dark: "var(--ds-text, ".concat($csE0A.DN400, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($csE0A.B400, ")"),
                dark: "var(--ds-text, ".concat($csE0A.B400, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($csE0A.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($csE0A.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($csE0A.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($csE0A.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($csE0A.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($csE0A.DN400, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-text-inverse, ".concat($csE0A.N0, ")"),
                dark: "var(--ds-text-inverse, ".concat($csE0A.DN30, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($csE0A.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($csE0A.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($csE0A.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($csE0A.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($csE0A.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($csE0A.DN400, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-text-warning-inverse, ".concat($csE0A.N800, ")"),
                dark: "var(--ds-text-warning-inverse, ".concat($csE0A.N800, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($csE0A.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($csE0A.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($csE0A.N800, ")"),
                dark: "var(--ds-text-selected, ".concat($csE0A.N800, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($csE0A.N800, ")"),
                dark: "var(--ds-text-selected, ".concat($csE0A.N800, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-text-inverse, ".concat($csE0A.N0, ")"),
                dark: "var(--ds-text-inverse, ".concat($csE0A.N0, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($csE0A.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($csE0A.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($csE0A.N0, ")"),
                dark: "var(--ds-text-selected, ".concat($csE0A.N0, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($csE0A.N0, ")"),
                dark: "var(--ds-text-selected, ".concat($csE0A.N0, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-link, ".concat($csE0A.B400, ")"),
                dark: "var(--ds-link, ".concat($csE0A.B100, ")")
            },
            hover: {
                light: "var(--ds-link, ".concat($csE0A.B300, ")"),
                dark: "var(--ds-link, ".concat($csE0A.B75, ")")
            },
            active: {
                light: "var(--ds-link-pressed, ".concat($csE0A.B500, ")"),
                dark: "var(--ds-link-pressed, ".concat($csE0A.B200, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($csE0A.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($csE0A.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($csE0A.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($csE0A.N700, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($csE0A.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($csE0A.N700, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-text, ".concat($csE0A.N500, ")"),
                dark: "var(--ds-text, ".concat($csE0A.DN400, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($csE0A.B400, ")"),
                dark: "var(--ds-text, ".concat($csE0A.B400, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($csE0A.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($csE0A.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($csE0A.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($csE0A.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($csE0A.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($csE0A.DN400, ")")
            }
        },
        "subtle-link": {
            default: {
                light: "var(--ds-text-subtle, ".concat($csE0A.N200, ")"),
                dark: "var(--ds-text-subtle, ".concat($csE0A.DN400, ")")
            },
            hover: {
                light: "var(--ds-text-subtle, ".concat($csE0A.N90, ")"),
                dark: "var(--ds-text-subtle, ".concat($csE0A.B50, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($csE0A.N400, ")"),
                dark: "var(--ds-text, ".concat($csE0A.DN300, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($csE0A.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($csE0A.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($csE0A.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($csE0A.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($csE0A.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($csE0A.DN400, ")")
            }
        }
    }
};
var $95d9d8259d2eb1ef$export$2e2bcd8739ae039 = $95d9d8259d2eb1ef$var$values;

});


parcelRegister("kO69v", function(module, exports) {

$parcel$export(module.exports, "getIfVisuallyHiddenChildren", function () { return $f25d3fded32363bf$export$20bbd2efb0d734c4; });

var $1Mpn7 = parcelRequire("1Mpn7");

var $j33pI = parcelRequire("j33pI");
var $f25d3fded32363bf$export$20bbd2efb0d734c4 = function getIfVisuallyHiddenChildren(children) {
    return children && /*#__PURE__*/ (0, $1Mpn7.isValidElement)(children) && children.type === (0, $j33pI.default);
};

});
parcelRegister("j33pI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $039424efac6ab417$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $fBy54 = parcelRequire("fBy54");
// eslint-disable-next-line @atlaskit/design-system/use-visually-hidden
var $039424efac6ab417$var$visuallyHiddenStyles = (0, $fBy54.css)({
    width: "1px",
    height: "1px",
    padding: "0",
    position: "absolute",
    border: "0",
    clip: "rect(1px, 1px, 1px, 1px)",
    overflow: "hidden",
    whiteSpace: "nowrap"
});
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $039424efac6ab417$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return (0, $fBy54.jsx)("span", {
        id: id,
        "data-testid": testId,
        css: $039424efac6ab417$var$visuallyHiddenStyles,
        role: role
    }, children);
};
var $039424efac6ab417$export$2e2bcd8739ae039 = $039424efac6ab417$var$VisuallyHidden;

});



parcelRegister("aB1kl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b6e639af77d304c$export$2e2bcd8739ae039; });

var $cWK60 = parcelRequire("cWK60");

var $kO69v = parcelRequire("kO69v");
function $7b6e639af77d304c$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter;
    if ((0, $cWK60.getBooleanFF)("platform.design-system-team.icon-button-spacing-fix_o1zc5") && (0, $kO69v.getIfVisuallyHiddenChildren)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}

});


parcelRegister("4OkGb", function(module, exports) {

$parcel$export(module.exports, "useActivityClient", function () { return $380bdf74055a33f2$export$6620595b7f837f8f; });

var $1Mpn7 = parcelRequire("1Mpn7");

var $5HO7B = parcelRequire("5HO7B");

var $5sy5L = parcelRequire("5sy5L");

var $eLNCI = parcelRequire("eLNCI");
var $380bdf74055a33f2$export$6620595b7f837f8f = function useActivityClient(version, product, logger, baseUrl) {
    var _useFlightDeckContext = (0, $5HO7B.useFlightDeckContext)(), getArtifact = _useFlightDeckContext.getArtifact;
    return (0, $1Mpn7.useMemo)(function() {
        return (0, $eLNCI.createActivityClient)(version, product, logger, baseUrl, // If the rw-client is wrapped in a FD provider, use the provided fetch function
        getArtifact ? function() {
            return getArtifact((0, $5sy5L.FD_CLIENT_FETCH_PROPS).name, (0, $5sy5L.FD_CLIENT_FETCH_PROPS).dimensions);
        } : undefined);
    }, [
        version,
        product,
        logger,
        baseUrl,
        getArtifact
    ]);
};

});
parcelRegister("5HO7B", function(module, exports) {

$parcel$export(module.exports, "useFlightDeckContext", function () { return $4277d8fed7f7e5dd$export$73c96350a5e69ec; });

var $kSuI9 = parcelRequire("kSuI9");

var $cv9Rk = parcelRequire("cv9Rk");

var $l29cN = parcelRequire("l29cN");

var $1Mpn7 = parcelRequire("1Mpn7");

var $cAUYO = parcelRequire("cAUYO");
var $4277d8fed7f7e5dd$export$ca1b33377afa620 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createContext({
    getArtifact: null
});
function $4277d8fed7f7e5dd$export$56da85ac9d40dbcd(param) {
    var children = param.children, product = param.product, config = param.config, fallbackArtifacts = param.fallbackArtifacts;
    var flightDeckClient = (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).useMemo(function() {
        return new (0, $cAUYO.default)(product, {
            handlers: {
                captureException: config === null || config === void 0 ? void 0 : config.captureException
            }
        }, fallbackArtifacts);
    }, [
        product,
        config === null || config === void 0 ? void 0 : config.captureException,
        fallbackArtifacts
    ]);
    var getArtifact = (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).useCallback(function() {
        var _ref = (0, $kSuI9._)(function(name, dimensions) {
            return (0, $l29cN.__generator)(this, function(_state) {
                return [
                    2,
                    flightDeckClient.fetchConfigFromFlightDeck({
                        name: name,
                        dimensions: dimensions
                    })
                ];
            });
        });
        return function(name, dimensions) {
            return _ref.apply(this, arguments);
        };
    }(), [
        flightDeckClient
    ]);
    var providerValue = (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).useMemo(function() {
        return {
            getArtifact: getArtifact
        };
    }, [
        getArtifact
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement($4277d8fed7f7e5dd$export$ca1b33377afa620.Provider, {
        value: providerValue
    }, children);
}
var $4277d8fed7f7e5dd$export$73c96350a5e69ec = function() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).useContext($4277d8fed7f7e5dd$export$ca1b33377afa620);
};
function $4277d8fed7f7e5dd$export$3b241cde208d2c5e(key, dimensions) {
    var _React_useState = (0, $cv9Rk._)((0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).useState(), 2), artifact = _React_useState[0], setArtifact = _React_useState[1];
    var getArtifact = $4277d8fed7f7e5dd$export$73c96350a5e69ec().getArtifact;
    (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).useEffect(function() {
        if (!getArtifact) throw new Error("Flight Deck Context not provided");
        getArtifact(key, dimensions).then(function(resp) {
            return setArtifact(resp);
        })// we don't need to do anything with the error as it is already instrumented in the flightDeckClient
        .catch();
    }, [
        dimensions,
        key,
        getArtifact,
        setArtifact
    ]);
    return artifact;
}

});
parcelRegister("cAUYO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $92b50bd4c06c3ddb$export$2e2bcd8739ae039; });

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $l29cN = parcelRequire("l29cN");

var $jjExS = parcelRequire("jjExS");

var $lCDpQ = parcelRequire("lCDpQ");

var $5ZDH2 = parcelRequire("5ZDH2");

var $amFBp = parcelRequire("amFBp");

var $ks3HS = parcelRequire("ks3HS");

var $1vATs = parcelRequire("1vATs");

var $5yOsy = parcelRequire("5yOsy");
function $92b50bd4c06c3ddb$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $92b50bd4c06c3ddb$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $92b50bd4c06c3ddb$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $92b50bd4c06c3ddb$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $92b50bd4c06c3ddb$var$STORAGE_KEY_BASE = "@atlassiansox/flight-deck-frontend-client";
var $92b50bd4c06c3ddb$var$RETRIABLE_FD_ERROR_MESSAGES = [
    "Failed to fetch",
    "NetworkError when attempting to fetch resource.",
    "Load failed"
];
var $92b50bd4c06c3ddb$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function FlightDeckClient(product) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
            handlers: {}
        }, fallbackArtifacts = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
        var _this = this;
        (0, $4GJKx._)(this, FlightDeckClient);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "fallbackArtifactMap", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "fetchFromFlightDeckPromises", new Map());
        this.expiryMS = options.expiryMS;
        this.handlers = options.handlers;
        this.product = product;
        this.storageClient = new (0, $5ZDH2.default)($92b50bd4c06c3ddb$var$STORAGE_KEY_BASE, options);
        fallbackArtifacts.forEach(function(artifact) {
            return _this.fallbackArtifactMap.set((0, $1vATs.artifactKey)(artifact.name, artifact.dimensions), artifact.value);
        });
        this.captureException = this.captureException.bind(this);
    }
    (0, $1wc17._)(FlightDeckClient, [
        {
            key: "captureException",
            value: function captureException(e, tags) {
                if (this.handlers.captureException) this.handlers.captureException(e, tags);
            }
        },
        {
            key: "fetchAndCacheArtifact",
            value: function fetchAndCacheArtifact(artifact, retryConfig) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var response, missingArtifactError;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $lCDpQ.retryOnException)(/*#__PURE__*/ (0, $kSuI9._)(function() {
                                        var result, error;
                                        return (0, $l29cN.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    _state.trys.push([
                                                        0,
                                                        2,
                                                        ,
                                                        3
                                                    ]);
                                                    return [
                                                        4,
                                                        (0, $amFBp.fetchFlightDeckConfiguration)(artifact.name, artifact.dimensions)
                                                    ];
                                                case 1:
                                                    result = _state.sent();
                                                    return [
                                                        2,
                                                        result
                                                    ];
                                                case 2:
                                                    error = _state.sent();
                                                    throw new (0, $ks3HS.default)({
                                                        artifact: artifact.key,
                                                        dimensions: artifact.dimensions,
                                                        error: error
                                                    });
                                                case 3:
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    }), {
                                        captureException: _this.captureException,
                                        retryOn: function(err) {
                                            return $92b50bd4c06c3ddb$var$RETRIABLE_FD_ERROR_MESSAGES.includes(err.message);
                                        },
                                        intervalsMS: retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.intervalsMS,
                                        onRetry: retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.onRetry
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                if (!response) {
                                    missingArtifactError = new Error("Missing artifact: ".concat(artifact.key));
                                    _this.captureException(missingArtifactError);
                                    throw missingArtifactError;
                                }
                                _this.storageClient.setItemWithExpiry(artifact.key, response, _this.expiryMS);
                                // Clear the in-flight check
                                _this.fetchFromFlightDeckPromises.delete(artifact.key);
                                return [
                                    2,
                                    response
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "fetchArtifactPromise",
            value: function fetchArtifactPromise(artifact, retryConfig) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var fetchPromise;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        // Check for in-flight requests for this artifact
                        if (_this.fetchFromFlightDeckPromises.has(artifact.key)) return [
                            2,
                            _this.fetchFromFlightDeckPromises.get(artifact.key)
                        ];
                        fetchPromise = _this.fetchAndCacheArtifact(artifact, retryConfig);
                        _this.fetchFromFlightDeckPromises.set(artifact.key, fetchPromise);
                        return [
                            2,
                            fetchPromise
                        ];
                    });
                })();
            }
        },
        {
            key: "fetchConfigFromFlightDeck",
            value: function fetchConfigFromFlightDeck(artifact, retryConfig) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var experience, artifactWithKey, artifactPromise, localConfig, result, e;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                experience = (0, $5yOsy.flightDeckClientExperience)();
                                experience.start();
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    4,
                                    5
                                ]);
                                artifactWithKey = $92b50bd4c06c3ddb$var$_objectSpread($92b50bd4c06c3ddb$var$_objectSpread({}, artifact), {}, {
                                    key: (0, $1vATs.artifactKey)(artifact.name, artifact.dimensions)
                                });
                                experience.addMetadata({
                                    key: artifactWithKey.key,
                                    product: _this.product
                                });
                                // Create the promise to fetch the config, we only need to await this if we don't have local config
                                artifactPromise = _this.fetchArtifactPromise(artifactWithKey, retryConfig);
                                // Check local storage for the artifact
                                localConfig = _this.storageClient.getItem(artifactWithKey.key);
                                if (localConfig) {
                                    experience.addMetadata({
                                        configSource: "localStorage"
                                    });
                                    return [
                                        2,
                                        localConfig
                                    ];
                                }
                                // Was a fallback config provided?
                                if (_this.fallbackArtifactMap.has(artifactWithKey.key)) {
                                    experience.addMetadata({
                                        configSource: "fallback"
                                    });
                                    return [
                                        2,
                                        _this.fallbackArtifactMap.get(artifactWithKey.key)
                                    ];
                                }
                                experience.addMetadata({
                                    configSource: "fetch"
                                });
                                return [
                                    4,
                                    artifactPromise
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                e = _state.sent();
                                experience.failure({
                                    metadata: {
                                        error: (0, $5yOsy.exceptionToMetadata)(e)
                                    }
                                });
                                throw e;
                            case 4:
                                // if the experience has been failed in the "catch" block, calling "success" will have no effect
                                experience.success();
                                return [
                                    7
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return FlightDeckClient;
}();

});
parcelRegister("lCDpQ", function(module, exports) {

$parcel$export(module.exports, "retryOnException", function () { return $fbdbb8ba47c2f87e$export$1d94629c94e7a17f; });
$parcel$export(module.exports, "FailedFetchError", function () { return (parcelRequire("lxHms")).default; });

var $eetQ9 = parcelRequire("eetQ9");

var $e8dor = parcelRequire("e8dor");

var $fGIeY = parcelRequire("fGIeY");

var $fKxXY = parcelRequire("fKxXY");

var $v9tzE = parcelRequire("v9tzE");

var $lxHms = parcelRequire("lxHms");
var $fbdbb8ba47c2f87e$export$5c069c93d2b7493f = function wait(ms) {
    return new Promise(function(resolve) {
        setTimeout(resolve, ms);
    });
};
var $fbdbb8ba47c2f87e$var$NO_CALLS_ERROR = "No calls made";
var $fbdbb8ba47c2f87e$export$1d94629c94e7a17f = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($e8dor)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).mark(function _callee(invokeOperation, _ref) {
        var _ref$intervalsMS, intervalsMS, _ref$retryOn, retryOn, captureException, onRetry, intervals, nextMSInterval, error;
        return (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _ref$intervalsMS = _ref.intervalsMS, intervalsMS = _ref$intervalsMS === void 0 ? (0, $v9tzE.NO_RETRIES) : _ref$intervalsMS, _ref$retryOn = _ref.retryOn, retryOn = _ref$retryOn === void 0 ? [
                        (0, $lxHms.default)
                    ] : _ref$retryOn, captureException = _ref.captureException, onRetry = _ref.onRetry;
                    intervals = (0, (/*@__PURE__*/$parcel$interopDefault($eetQ9)))(intervalsMS);
                    nextMSInterval = 0;
                    error = new Error($fbdbb8ba47c2f87e$var$NO_CALLS_ERROR);
                case 4:
                    if (!(nextMSInterval !== undefined)) {
                        _context.next = 22;
                        break;
                    }
                    _context.prev = 5;
                    if (!(nextMSInterval > 0)) {
                        _context.next = 9;
                        break;
                    }
                    _context.next = 9;
                    return $fbdbb8ba47c2f87e$export$5c069c93d2b7493f(nextMSInterval);
                case 9:
                    if (onRetry && error.message !== $fbdbb8ba47c2f87e$var$NO_CALLS_ERROR) onRetry(error);
                    _context.next = 12;
                    return invokeOperation();
                case 12:
                    return _context.abrupt("return", _context.sent);
                case 15:
                    _context.prev = 15;
                    _context.t0 = _context["catch"](5);
                    error = (0, $fKxXY.default)(_context.t0);
                    if (captureException) captureException(error);
                    // Retry ONLY when the error is an instance of one of the provided `retryOn` errors, or passes the `retryOn` test.
                    // You need to ensure you are throwing one of the `retryOn` errors if that is the method you are using.
                    if (typeof retryOn === "function" ? retryOn(error) : retryOn.some(function(err) {
                        return error instanceof err;
                    })) nextMSInterval = intervals.shift();
                    else nextMSInterval = undefined;
                case 20:
                    _context.next = 4;
                    break;
                case 22:
                    throw error;
                case 23:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                5,
                15
            ]
        ]);
    }));
    return function retryOnException(_x, _x2) {
        return _ref2.apply(this, arguments);
    };
}();

});
parcelRegister("fKxXY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b7757fe65b338f03$export$2e2bcd8739ae039; });

var $2nffd = parcelRequire("2nffd");
var $b7757fe65b338f03$var$convertToError = function convertToError(e) {
    var error;
    if (e instanceof Error) error = e;
    else if (typeof e === "string") error = new Error(e);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($2nffd)))(e) === "object") try {
        error = new Error("Object error instance thrown for operation: " + JSON.stringify(e));
    } catch (jsonError) {
        error = new Error("Object serialisation error thrown during operation: " + String(e));
    }
    else error = new Error("No error instance thrown for operation: " + String(e));
    return error;
};
var $b7757fe65b338f03$export$2e2bcd8739ae039 = $b7757fe65b338f03$var$convertToError;

});

parcelRegister("v9tzE", function(module, exports) {

$parcel$export(module.exports, "NO_RETRIES", function () { return $05da3f19dc8bd918$export$a0a1c8f90becc136; });
var $05da3f19dc8bd918$export$a0a1c8f90becc136 = [];
var $05da3f19dc8bd918$export$972171517b12aa4 = [
    0,
    0
];
var $05da3f19dc8bd918$export$746d2203ed8cdc40 = [
    0,
    50,
    100
];
var $05da3f19dc8bd918$export$f6858378b665f957 = [
    100,
    500,
    1000
];

});

parcelRegister("lxHms", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $faee50b39beb0f3a$export$2e2bcd8739ae039; });

var $2Yk1N = parcelRequire("2Yk1N");

var $6QU8A = parcelRequire("6QU8A");

var $eZhUW = parcelRequire("eZhUW");

var $kcuts = parcelRequire("kcuts");

var $6pDhi = parcelRequire("6pDhi");

var $8B3ag = parcelRequire("8B3ag");
function $faee50b39beb0f3a$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $faee50b39beb0f3a$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($6pDhi)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($6pDhi)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($kcuts)))(this, result);
    };
}
function $faee50b39beb0f3a$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $faee50b39beb0f3a$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Error) {
    (0, (/*@__PURE__*/$parcel$interopDefault($eZhUW)))(FailedFetchError, _Error);
    var _super = $faee50b39beb0f3a$var$_createSuper(FailedFetchError);
    function FailedFetchError(_ref) {
        var _this;
        var error = _ref.error, path = _ref.path, method = _ref.method;
        (0, (/*@__PURE__*/$parcel$interopDefault($6QU8A)))(this, FailedFetchError);
        _this = _super.call(this);
        _this.name = "FailedFetchError";
        _this.message = error.message || "Unknown fetch error";
        _this.stack = error.stack;
        _this.originalName = error.name;
        _this.method = method;
        var p = path.split("?")[0];
        _this.path = /^[/-a-z]+$/i.test(p) ? p : "";
        return _this;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($2Yk1N)))(FailedFetchError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8B3ag)))(Error));

});
parcelRegister("8B3ag", function(module, exports) {

var $6pDhi = parcelRequire("6pDhi");

var $iQaLx = parcelRequire("iQaLx");

var $bRYZe = parcelRequire("bRYZe");

var $1XYap = parcelRequire("1XYap");
function $64243bdd5159da08$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    module.exports = $64243bdd5159da08$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$bRYZe(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $1XYap(Class, arguments, $6pDhi(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $iQaLx(Wrapper, Class);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $64243bdd5159da08$var$_wrapNativeSuper(Class);
}
module.exports = $64243bdd5159da08$var$_wrapNativeSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("bRYZe", function(module, exports) {
function $8a43f39c0f9768a4$var$_isNativeFunction(fn) {
    try {
        return Function.toString.call(fn).indexOf("[native code]") !== -1;
    } catch (e) {
        return typeof fn === "function";
    }
}
module.exports = $8a43f39c0f9768a4$var$_isNativeFunction, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("1XYap", function(module, exports) {

var $iQaLx = parcelRequire("iQaLx");

var $f188g = parcelRequire("f188g");
function $16e9f906c4ae5f7a$var$_construct(Parent, args, Class) {
    if ($f188g()) module.exports = $16e9f906c4ae5f7a$var$_construct = Reflect.construct.bind(), module.exports.__esModule = true, module.exports["default"] = module.exports;
    else module.exports = $16e9f906c4ae5f7a$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $iQaLx(instance, Class.prototype);
        return instance;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $16e9f906c4ae5f7a$var$_construct.apply(null, arguments);
}
module.exports = $16e9f906c4ae5f7a$var$_construct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("f188g", function(module, exports) {
function $aeed41ec2c9cee3e$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
module.exports = $aeed41ec2c9cee3e$var$_isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});





parcelRegister("5ZDH2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $45d1708108dae005$export$2e2bcd8739ae039; });

var $6QU8A = parcelRequire("6QU8A");

var $2Yk1N = parcelRequire("2Yk1N");

var $jjExS = parcelRequire("jjExS");

var $6R3pa = parcelRequire("6R3pa");
var $45d1708108dae005$var$DEFAULT_STORAGE_ENGINE = "localStorage";
var $45d1708108dae005$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function StorageClient(clientKey, options) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($6QU8A)))(this, StorageClient);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "getItem", function(key) {
            var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                useExpiredItem: false
            }, useExpiredItem = _ref.useExpiredItem;
            var item = _this.client.getItem(_this.itemKey(key));
            if (item) try {
                var parsedItem = JSON.parse(item);
                // item is expired
                if (parsedItem.expires && new Date(parsedItem.expires) < new Date()) {
                    /**
             * Commented out removing this item, as it is a slightly different state
             * to the item not existing that we may want to preserve.
             *  this.client.removeItem(this.itemKey(key));
             */ if (!useExpiredItem) return undefined;
                }
                return parsedItem.value;
            } catch (e) {
                _this.captureException(e);
            }
            return undefined;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "removeItem", function(key) {
            try {
                _this.client.removeItem(_this.itemKey(key));
            } catch (e) {
                _this.captureException(e);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "setItemWithExpiry", function(key, value, expireInMS) {
            var itemWithExpiry = {
                value: value,
                expires: typeof expireInMS === "number" ? Date.now() + expireInMS : undefined
            };
            try {
                _this.client.setItem(_this.itemKey(key), JSON.stringify(itemWithExpiry));
            } catch (e) {
                _this.captureException(e);
            }
        });
        this.clientKey = clientKey;
        this.handlers = options === null || options === void 0 ? void 0 : options.handlers;
        var storageEngine = (options === null || options === void 0 ? void 0 : options.storageEngine) || $45d1708108dae005$var$DEFAULT_STORAGE_ENGINE;
        if (!Object.prototype.hasOwnProperty.call(window, storageEngine)) (0, $6R3pa.mockWindowStorage)([
            storageEngine
        ]);
        this.client = window[storageEngine];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($2Yk1N)))(StorageClient, [
        {
            key: "captureException",
            value: function captureException(e, tags) {
                var _this$handlers;
                if ((_this$handlers = this.handlers) !== null && _this$handlers !== void 0 && _this$handlers.captureException) {
                    var _this$handlers2;
                    (_this$handlers2 = this.handlers) === null || _this$handlers2 === void 0 || _this$handlers2.captureException(e, tags);
                }
            }
        },
        {
            key: "itemKey",
            value: function itemKey(key) {
                return "".concat(this.clientKey, "_").concat(key);
            }
        }
    ]);
    return StorageClient;
}();

});
parcelRegister("6R3pa", function(module, exports) {

$parcel$export(module.exports, "mockWindowStorage", function () { return $4fda557acb67a69f$export$efebfe7859cae3c7; });

var $jjExS = parcelRequire("jjExS");
function $4fda557acb67a69f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4fda557acb67a69f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $4fda557acb67a69f$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $4fda557acb67a69f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $4fda557acb67a69f$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $4fda557acb67a69f$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $4fda557acb67a69f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $4fda557acb67a69f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $4fda557acb67a69f$var$_arrayLikeToArray(o, minLen);
}
function $4fda557acb67a69f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $4fda557acb67a69f$export$c65e688d8b365035 = {
    _data: {},
    length: 0,
    setItem: function setItem(id, val) {
        return this._data[id] = String(val);
    },
    getItem: function getItem(id) {
        return this._data.hasOwnProperty(id) ? this._data[id] : undefined;
    },
    removeItem: function removeItem(id) {
        return delete this._data[id];
    },
    clear: function clear() {
        return this._data = {};
    },
    key: function key(index) {
        return Object.keys(this._data)[index];
    }
};
var $4fda557acb67a69f$export$efebfe7859cae3c7 = function mockWindowStorage() {
    var storageToMock = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [
        "localStorage",
        "sessionStorage"
    ];
    var _iterator = $4fda557acb67a69f$var$_createForOfIteratorHelper(storageToMock), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var storageToMockElement = _step.value;
            Object.defineProperty(window, storageToMockElement, {
                value: $4fda557acb67a69f$var$_objectSpread({}, $4fda557acb67a69f$export$c65e688d8b365035),
                configurable: true
            });
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
};

});


parcelRegister("amFBp", function(module, exports) {

$parcel$export(module.exports, "fetchFlightDeckConfiguration", function () { return $78bc3acfc8f22844$export$6026918e023c9101; });

var $kSuI9 = parcelRequire("kSuI9");

var $l29cN = parcelRequire("l29cN");

var $9OGwd = parcelRequire("9OGwd");

var $bRlu3 = parcelRequire("bRlu3");

var $7bKn3 = parcelRequire("7bKn3");

var $dZMYX = parcelRequire("dZMYX");

var $ki9Sr = parcelRequire("ki9Sr");

var $c9QGe = parcelRequire("c9QGe");

var $iDgCp = parcelRequire("iDgCp");

var $levO6 = parcelRequire("levO6");

var $2OfQz = parcelRequire("2OfQz");
var $78bc3acfc8f22844$var$DefaultNamespace = "flight-deck";
function $78bc3acfc8f22844$export$6026918e023c9101(artifactName) {
    return $78bc3acfc8f22844$var$_fetchFlightDeckConfiguration.apply(this, arguments);
}
function $78bc3acfc8f22844$var$_fetchFlightDeckConfiguration() {
    $78bc3acfc8f22844$var$_fetchFlightDeckConfiguration = (0, $kSuI9._)(function(artifactName) {
        var dim, environment, locale, artifactDimensions, client;
        var _arguments = arguments;
        return (0, $l29cN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    dim = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    environment = $78bc3acfc8f22844$var$getEnvFromEnvDependentDimensions(dim.environmentType);
                    locale = dim.locale && (0, $9OGwd.default)(dim.locale);
                    artifactDimensions = {
                        environment: environment,
                        locale: locale
                    };
                    return [
                        4,
                        $78bc3acfc8f22844$var$getConfigClient(dim)
                    ];
                case 1:
                    client = _state.sent();
                    return [
                        2,
                        client.getArtifact(artifactName, artifactDimensions)
                    ];
            }
        });
    });
    return $78bc3acfc8f22844$var$_fetchFlightDeckConfiguration.apply(this, arguments);
}
function $78bc3acfc8f22844$export$4abbe3ae0811355() {
    return $78bc3acfc8f22844$var$_getLatestVersionMetadata.apply(this, arguments);
}
function $78bc3acfc8f22844$var$_getLatestVersionMetadata() {
    $78bc3acfc8f22844$var$_getLatestVersionMetadata = (0, $kSuI9._)(function() {
        var dim, client;
        var _arguments = arguments;
        return (0, $l29cN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    dim = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
                    return [
                        4,
                        $78bc3acfc8f22844$var$getConfigClient(dim)
                    ];
                case 1:
                    client = _state.sent();
                    return [
                        2,
                        client.getLatestVersionMetadata()
                    ];
            }
        });
    });
    return $78bc3acfc8f22844$var$_getLatestVersionMetadata.apply(this, arguments);
}
function $78bc3acfc8f22844$var$getConfigClient(dim) {
    return $78bc3acfc8f22844$var$_getConfigClient.apply(this, arguments);
}
function $78bc3acfc8f22844$var$_getConfigClient() {
    $78bc3acfc8f22844$var$_getConfigClient = (0, $kSuI9._)(function(dim) {
        var fetchArtifactExperience, fetchVersionMetadataExperience, _dim$namespace;
        return (0, $l29cN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $iDgCp.getFlightDeckFetchExperience)()
                    ];
                case 1:
                    fetchArtifactExperience = _state.sent();
                    return [
                        4,
                        (0, $iDgCp.getVersionMetadataFetchExperience)()
                    ];
                case 2:
                    fetchVersionMetadataExperience = _state.sent();
                    if (dim.environmentType === undefined || dim.environmentType === "prod") return [
                        2,
                        new (0, $ki9Sr.ConfigClient)(new (0, $7bKn3.CdnDataSource)(new (0, $dZMYX.CdnHttpClientImpl)(), (0, $bRlu3.Versions).ManifestVersion), "CDN", fetchArtifactExperience, fetchVersionMetadataExperience)
                    ];
                    else if (dim.environmentType === "adev" || dim.environmentType === "pdev" || dim.environmentType === "ddev" || dim.environmentType === "stg") {
                        ;
                        /**
     * For other environments, a namepace must be specified.
     * In this case,we fetch directly from the config registry with the specified namespace (for testing purposes).
     */ return [
                            2,
                            new (0, $ki9Sr.ConfigClient)(new (0, $bRlu3.ConfigRegistryDataSource)((0, $bRlu3.Versions).ManifestVersion, new (0, $c9QGe.ConfigRegistryHttpClientImpl)((_dim$namespace = dim.namespace) !== null && _dim$namespace !== void 0 ? _dim$namespace : $78bc3acfc8f22844$var$DefaultNamespace, "flight-deck-front-end-sdk")), "Config Registry", fetchArtifactExperience, fetchVersionMetadataExperience)
                        ];
                    }
                    (0, $levO6.assertUnreachable)(dim.environmentType);
                    return [
                        2
                    ];
            }
        });
    });
    return $78bc3acfc8f22844$var$_getConfigClient.apply(this, arguments);
}
/**
 *
 * This function is necessary since all artifacts are tagged using an environment,
 * so to get an artifact we need to specify an environment. However, users only
 * specify an environmentType since that's all that matters to them. Flight Deck
 * ensures that frontend artifacts don't vary based on region so this is safe to do.
 *
 * @param environmentDependentDimensions
 * @returns a specific environment that has that envtype
 */ function $78bc3acfc8f22844$var$getEnvFromEnvDependentDimensions(environmentDependentDimensions) {
    if (environmentDependentDimensions === undefined || environmentDependentDimensions === "prod") return "prod-west";
    switch(environmentDependentDimensions){
        case "stg":
            return "stg-west";
        case "adev":
            return "adev";
        case "ddev":
            return "ddev";
        case "pdev":
            return "pdev-apse2";
    }
}

});
parcelRegister("9OGwd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7259c3e435886068$export$2e2bcd8739ae039; });
/**
 * This function is being used to address locale discrepancies in Atlassian products;
 * see: https://hello.atlassian.net/wiki/spaces/i18n/pages/528623554/Locale+Discrepancies+Across+Atlassian+Products+and+Platform+Areas
 */ var $7259c3e435886068$export$852ff24d0930c62f = function mapLocaleToPrsLocale(locale) {
    var standardizedLocale = locale.replace("_", "-");
    switch(standardizedLocale){
        case "en-US":
        case "en-GB":
        case "pt-BR":
        case "zh-CN":
        case "zh-TW":
            return standardizedLocale;
        case "en-UK":
            return "en-GB";
        case "en":
            return "en-US";
        default:
            return standardizedLocale.split("-")[0];
    }
};
var $7259c3e435886068$export$2e2bcd8739ae039 = $7259c3e435886068$export$852ff24d0930c62f;

});

parcelRegister("bRlu3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UriSegments = module.exports.Versions = module.exports.BaseUrls = module.exports.ConfigRegistryDataSource = module.exports.checkManifest = module.exports.parseVersionMetadata = module.exports.parseArtifactManifest = module.exports.tryGetArtifactData = module.exports.getArtifactFromSource = module.exports.Either = void 0;

var $76UCK = parcelRequire("76UCK");
Object.defineProperty(module.exports, "Either", {
    enumerable: true,
    get: function get() {
        return $76UCK.Either;
    }
});

var $guCeg = parcelRequire("guCeg");
Object.defineProperty(module.exports, "getArtifactFromSource", {
    enumerable: true,
    get: function get() {
        return $guCeg.getArtifactFromSource;
    }
});
Object.defineProperty(module.exports, "tryGetArtifactData", {
    enumerable: true,
    get: function get() {
        return $guCeg.tryGetArtifactData;
    }
});

var $iOvpV = parcelRequire("iOvpV");
Object.defineProperty(module.exports, "parseArtifactManifest", {
    enumerable: true,
    get: function get() {
        return $iOvpV.parseArtifactManifest;
    }
});

var $7Lu49 = parcelRequire("7Lu49");
Object.defineProperty(module.exports, "parseVersionMetadata", {
    enumerable: true,
    get: function get() {
        return $7Lu49.parseVersionMetadata;
    }
});

var $f2y27 = parcelRequire("f2y27");
Object.defineProperty(module.exports, "checkManifest", {
    enumerable: true,
    get: function get() {
        return $f2y27.checkManifest;
    }
});

var $2gZnK = parcelRequire("2gZnK");
Object.defineProperty(module.exports, "ConfigRegistryDataSource", {
    enumerable: true,
    get: function get() {
        return $2gZnK.ConfigRegistryDataSource;
    }
});

var $l1Wyy = parcelRequire("l1Wyy");
Object.defineProperty(module.exports, "BaseUrls", {
    enumerable: true,
    get: function get() {
        return $l1Wyy.BaseUrls;
    }
});
Object.defineProperty(module.exports, "Versions", {
    enumerable: true,
    get: function get() {
        return $l1Wyy.Versions;
    }
});
Object.defineProperty(module.exports, "UriSegments", {
    enumerable: true,
    get: function get() {
        return $l1Wyy.UriSegments;
    }
});

});
parcelRegister("76UCK", function(module, exports) {
"use strict";
var $52d50441dddb5349$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function extendStatics1(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Either = void 0;
var $52d50441dddb5349$var$Either = /** @class */ function() {
    function Either() {}
    Either.prototype.map = function(f) {
        return this.flatMap(function(a) {
            return Either.right(f(a));
        });
    };
    Either.right = function(value) {
        return new $52d50441dddb5349$var$Right(value);
    };
    Either.left = function(error) {
        return new $52d50441dddb5349$var$Left(error);
    };
    return Either;
}();
module.exports.Either = $52d50441dddb5349$var$Either;
var $52d50441dddb5349$var$Right = /** @class */ function(_super) {
    $52d50441dddb5349$var$__extends(Right, _super);
    function Right(r) {
        var _this = _super.call(this) || this;
        _this.right = r;
        return _this;
    }
    Right.prototype.bimap = function(_f, g) {
        return $52d50441dddb5349$var$Either.right(g(this.right));
    };
    Right.prototype.flatMap = function(f) {
        return f(this.right);
    };
    Right.prototype.fold = function(_onLeft, onRight) {
        return onRight(this.right);
    };
    Right.prototype.leftMap = function(_f) {
        return $52d50441dddb5349$var$Either.right(this.right);
    };
    return Right;
}($52d50441dddb5349$var$Either);
var $52d50441dddb5349$var$Left = /** @class */ function(_super) {
    $52d50441dddb5349$var$__extends(Left, _super);
    function Left(e) {
        var _this = _super.call(this) || this;
        _this.left = e;
        return _this;
    }
    Left.prototype.bimap = function(f, _g) {
        return $52d50441dddb5349$var$Either.left(f(this.left));
    };
    Left.prototype.flatMap = function(_f) {
        return $52d50441dddb5349$var$Either.left(this.left);
    };
    Left.prototype.fold = function(onLeft, _onRight) {
        return onLeft(this.left);
    };
    Left.prototype.leftMap = function(f) {
        return $52d50441dddb5349$var$Either.left(f(this.left));
    };
    return Left;
}($52d50441dddb5349$var$Either);

});

parcelRegister("guCeg", function(module, exports) {
"use strict";
var $c01d1a2d375fda45$var$__assign = module.exports && module.exports.__assign || function() {
    $c01d1a2d375fda45$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c01d1a2d375fda45$var$__assign.apply(this, arguments);
};
var $c01d1a2d375fda45$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $c01d1a2d375fda45$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.tryGetArtifactData = module.exports.getArtifactFromSource = void 0;

var $9U9fz = parcelRequire("9U9fz");

var $bRlu3 = parcelRequire("bRlu3");

var $6azSK = parcelRequire("6azSK");

var $5JEdh = parcelRequire("5JEdh");

var $1irfz = parcelRequire("1irfz");
function $c01d1a2d375fda45$var$getArtifactFromSource(dataSource, specifiedDimensions, deniedArtifactType) {
    return $c01d1a2d375fda45$var$__awaiter(this, void 0, void 0, function() {
        var manifestResult;
        var _this = this;
        return $c01d1a2d375fda45$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        dataSource.getManifest(specifiedDimensions.name, specifiedDimensions.version)
                    ];
                case 1:
                    manifestResult = _a.sent();
                    return [
                        2 /*return*/ ,
                        manifestResult.fold(function(error) {
                            return Promise.resolve({
                                type: "manifest-fetch-error",
                                error: error
                            });
                        }, function(manifest) {
                            return $c01d1a2d375fda45$var$__awaiter(_this, void 0, void 0, function() {
                                var manifestCheckResult, publishMetadata, dimensionContextResult;
                                return $c01d1a2d375fda45$var$__generator(this, function(_a) {
                                    manifestCheckResult = (0, $bRlu3.checkManifest)(manifest, {
                                        name: specifiedDimensions.name,
                                        version: specifiedDimensions.version
                                    });
                                    if (manifestCheckResult.key !== "success") return [
                                        2 /*return*/ ,
                                        {
                                            type: manifestCheckResult.key
                                        }
                                    ];
                                    publishMetadata = manifest.publishMetadata;
                                    if (manifest.frontend && deniedArtifactType === "frontend") return [
                                        2 /*return*/ ,
                                        {
                                            type: "denied-artifact-type",
                                            deniedType: "frontend",
                                            publishMetadata: publishMetadata
                                        }
                                    ];
                                    else if (!manifest.frontend && deniedArtifactType === "backend") return [
                                        2 /*return*/ ,
                                        {
                                            type: "denied-artifact-type",
                                            deniedType: "backend",
                                            publishMetadata: publishMetadata
                                        }
                                    ];
                                    dimensionContextResult = (0, $6azSK.getDimensionContext)(specifiedDimensions, manifest);
                                    switch(dimensionContextResult.type){
                                        case "missing-dimension-specification":
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    type: "missing-dimension-specification",
                                                    publishMetadata: publishMetadata
                                                }
                                            ];
                                        case "unsupported-value-specified-for-supported-dimension":
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    type: "unsupported-value-specified-for-supported-dimension",
                                                    publishMetadata: publishMetadata
                                                }
                                            ];
                                        case "success":
                                            return [
                                                2 /*return*/ ,
                                                $c01d1a2d375fda45$var$getArtifact(dataSource, manifest, dimensionContextResult.dimensionContext)
                                            ];
                                        default:
                                            (0, $5JEdh.assertUnreachable)(dimensionContextResult);
                                    }
                                    return [
                                        2 /*return*/ 
                                    ];
                                });
                            });
                        })
                    ];
            }
        });
    });
}
module.exports.getArtifactFromSource = $c01d1a2d375fda45$var$getArtifactFromSource;
function $c01d1a2d375fda45$var$getArtifact(dataSource, manifest, dimensionContext) {
    return $c01d1a2d375fda45$var$__awaiter(this, void 0, void 0, function() {
        var publishMetadata, tag, artifactResult;
        var _this = this;
        return $c01d1a2d375fda45$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    publishMetadata = manifest.publishMetadata;
                    try {
                        tag = (0, $9U9fz.interpolateTagScheme)(manifest.tagScheme, $c01d1a2d375fda45$var$__assign($c01d1a2d375fda45$var$__assign({}, dimensionContext), {
                            name: manifest.name
                        }));
                    } catch (e) {
                        return [
                            2 /*return*/ ,
                            {
                                type: "tag-scheme-interpolation-error",
                                publishMetadata: publishMetadata
                            }
                        ];
                    }
                    return [
                        4 /*yield*/ ,
                        dataSource.getArtifact(manifest.name, tag)
                    ];
                case 1:
                    artifactResult = _a.sent();
                    return [
                        2 /*return*/ ,
                        artifactResult.fold(function(error) {
                            return Promise.resolve({
                                type: "artifact-fetch-error",
                                error: error,
                                publishMetadata: publishMetadata
                            });
                        }, function(data) {
                            return $c01d1a2d375fda45$var$__awaiter(_this, void 0, void 0, function() {
                                return $c01d1a2d375fda45$var$__generator(this, function(_a) {
                                    return [
                                        2 /*return*/ ,
                                        {
                                            type: "success",
                                            data: data,
                                            publishMetadata: publishMetadata,
                                            artifactVersion: dimensionContext["version"]
                                        }
                                    ];
                                });
                            });
                        })
                    ];
            }
        });
    });
}
function $c01d1a2d375fda45$var$tryGetArtifactData(artifact, dataSourceName) {
    switch(artifact.type){
        case "manifest-fetch-error":
            throw new Error("Unable to fetch manifest due to ".concat(dataSourceName, " response error: ").concat((0, $1irfz.toPrettyJson)(artifact.error)));
        case "artifact-fetch-error":
            throw new Error("Unable to fetch artifact due to ".concat(dataSourceName, " response error: ").concat((0, $1irfz.toPrettyJson)(artifact.error)));
        case "denied-artifact-type":
            throw new Error("No artifacts should be denied, but type ".concat(artifact.deniedType, " was denied."));
        case "unsupported-value-specified-for-supported-dimension":
            throw new Error("An unsupported value was specified for a supported dimension");
        case "missing-dimension-specification":
            throw new Error("A required dimension specification was missing");
        case "tag-scheme-interpolation-error":
            throw new Error("Ran into failure when trying to interpolate tag scheme");
        case "mismatched-manifest-name":
            throw new Error("Manifest has been corrupted. Manifest name is mismatched.");
        case "mismatched-manifest-version":
            throw new Error("Manifest has been corrupted. Manifest version is mismatched.");
        case "success":
            return artifact.data;
        default:
            (0, $5JEdh.assertUnreachable)(artifact);
    }
}
module.exports.tryGetArtifactData = $c01d1a2d375fda45$var$tryGetArtifactData;

});
parcelRegister("9U9fz", function(module, exports) {

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getVersionMetadataTag = module.exports.getDataTagForManifest = module.exports.getDimensionsFromTagScheme = module.exports.generateTagScheme = module.exports.interpolateTagScheme = void 0;
var $736084e6eed74fa4$var$TAG_SCHEME_VERSION = 2;
function $736084e6eed74fa4$var$interpolateTagScheme(tagSchema, context) {
    var dimensions = Array.from($736084e6eed74fa4$var$getDimensionsFromTagScheme(tagSchema));
    return dimensions.reduce(function(interpolatedTagScheme, dimension) {
        if (context.hasOwnProperty(dimension)) return interpolatedTagScheme.replace(new RegExp("\\$".concat(dimension, "\\$"), "g"), context[dimension]);
        else {
            var contextAsJson = $736084e6eed74fa4$var$toPrettyJson(context);
            throw new Error('Bad variable "'.concat(dimension, "\" found enclosed in '$', so cannot infer\n                     filename for artifact from tag schema: was expecting that\n                     '").concat(dimension, "' would be a known dimension passed in context. This\n                     is most likely a bug in Flight Deck. To help you debug, the Context\n                     received was:\n\"").concat(contextAsJson, "\"\nOne of the keys in that object should\n                     have been '").concat(contextAsJson, "'."));
        }
    }, tagSchema);
}
module.exports.interpolateTagScheme = $736084e6eed74fa4$var$interpolateTagScheme;
/**
 *
 * @param dimensions - the dimensions that this tag scheme needs to use
 *
 * @param supportedDimensionPrefixes - a map of those dimensions to
 * shortened versions (ie name to n)
 *
 *  @param effectiveContextDimension - maps dimensions down into dimensions supported
 *  by original context. NOTE:
 *
 *  There is only 1 correct implementation of this function, but
 *  it is not defined in this module because the most typesafe
 *  (least error prone) definition of this function requires referencing
 *  the specific dimension types (specific available dimensions), and
 *  we are intentionally keeping this module unaware of the specific
 *  dimensions to enable adding/changing dimensions easily in consumers
 *  which use this tags library. So therefore we define effectiveContextDimension
 *  outside of this package, but accept it as an argument. Note that in this
 *  package we redefine the meaning of common Flight Deck types (e.g.
 *  Dimension == string, rather than the specific subset of supported
 *  dimension strings), so when generateTagScheme is called then effectiveContextDimension
 *  needs to be cast (using `as`) in order to have the types
 *
 * @returns a generated schema
 */ function $736084e6eed74fa4$var$generateTagScheme(dimensions, supportedDimensionPrefixes) {
    var effectiveContextDimension = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function(d) {
        return d;
    };
    var effectiveDimensions = new Set((0, $c6Xmf._)(dimensions).map(effectiveContextDimension));
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = effectiveDimensions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var dimensionToInclude = _step.value;
            if (!supportedDimensionPrefixes.has(effectiveContextDimension(dimensionToInclude))) throw new Error([
                "Building a tag scheme failed! The dimension '".concat(dimensionToInclude, "' is not "),
                "recognized as a dimension (known dimensions are ".concat((0, $c6Xmf._)(supportedDimensionPrefixes.keys()).join(", "), "!")
            ].join(" "));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // pad the version number to 3 digits (e.g. 001, 002, 003, etc) so that artifacts will sort by
    // version when sorted lexicographically (helpful for debugging)
    var padded_version = $736084e6eed74fa4$var$TAG_SCHEME_VERSION.toString().padStart(3, "0");
    // IMPORTANT! Update {@link TAG_SCHEME_VERSION} if you change the tagging scheme logic!
    var tagScheme = "v".concat(padded_version);
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = supportedDimensionPrefixes.entries()[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var entry = _step1.value;
            var _entry = (0, $cv9Rk._)(entry, 2), dimension = _entry[0], prefix = _entry[1];
            if (effectiveDimensions.has(dimension)) // We avoid using `:` or `/` or `\` as separator characters because these characters have
            // meaning on certain filesystems that make them painful to work with; we also don't use
            // ` ` or similar because whitespace characters are the default values used by shells
            // to word-split, which makes scripting harder (see https://bash.cyberciti.biz/guide/$IFS ).
            tagScheme += "-".concat(prefix, "_$").concat(dimension, "$");
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return tagScheme;
}
module.exports.generateTagScheme = $736084e6eed74fa4$var$generateTagScheme;
// Important! Context: Front end client will be using old version of tags.When we make changes to this function
// we need to be extra cautious that it will be compatible with older versions
// Step -1
// we have test in frontend package :integration-test/frontend/frontend-fetch.spec.ts to test oldest front end client
// make sure we add sample artifact to the test which will test newest functionality against oldest client
// Step-2
// Update manifest version across flight-deck
// step-3
// update manifest version in poop-deck repo
// step-4
// communicate with external customers and #flight-deck channel announcements
// step-5
// Update oldest supported version in integration-test/frontend/frontend-fetch.spec.ts and the test will be passed
function $736084e6eed74fa4$var$getDimensionsFromTagScheme(tagSchema) {
    // regex to get all dimensions
    // for a dimension:
    // \$ means the expression starts with a `$` sign
    // [A-Za-z]+ means dollar sign is followed by one or more alphabetical chars
    // \$ means the dimension ends with a `$` sign
    var dimensionsFormat = /\$([A-Za-z]+)\$/g;
    // regex to ensure that we have the right format
    // for the dimension format:
    // ^v means it must start with a v
    // \d{3} means it is followed by three digits
    // ?: tries to match the expression without capturing the group
    // -[a-z]_ means expression starts with `-<single lowercase a-z char>_`
    // (\$[A-Za-z]+\$) defines that a dimension is in the format `<one or more alphabetical chars>` and this group is captured.
    // + means we could have one or more dimensions.
    // $ means we must end at the end of a dimension.
    var tagSchemeFormat = /^v\d{3}(?:-[a-z]_(\$[A-Za-z]+\$))+$/;
    var isValidTag = tagSchemeFormat.test(tagSchema);
    if (!isValidTag) throw new Error('The provided tag scheme: "'.concat(tagSchema, '" is invalid.\n                Tag schemes must have the following format:\n                v<3 digit number>-<letter>$<dimension_name>$\n                where -<letter>$<dimension_name>$ can be repeated\n                and all characters of <letter> and <dimension_name>\n                must be alphabetical characters\n                e.g "v001-n_$name$-d_$dimension$" is a valid tag scheme'));
    var allDim = Array.from(tagSchema.matchAll(dimensionsFormat));
    try {
        // Grab the second element of each element in matches
        var captures = allDim.map(function(param) {
            var _param = (0, $cv9Rk._)(param, 2), _ = _param[0], capture = _param[1];
            return capture;
        });
        var dimensions = new Set(captures);
        return dimensions;
    } catch (e) {
        throw new Error("Could not capture dimensions. Expected dimension format to look like \n             ".concat(dimensionsFormat));
    }
}
module.exports.getDimensionsFromTagScheme = $736084e6eed74fa4$var$getDimensionsFromTagScheme;
function $736084e6eed74fa4$var$getDataTagForManifest(artifactName, manifestVersion, artifactVersion) {
    return artifactVersion === undefined ? "".concat(artifactName, "_manifest_").concat(manifestVersion) : "".concat(artifactName, "_").concat(artifactVersion, "_manifest_").concat(manifestVersion);
}
module.exports.getDataTagForManifest = $736084e6eed74fa4$var$getDataTagForManifest;
function $736084e6eed74fa4$var$getVersionMetadataTag(version) {
    return version ? "version_metadata_".concat(version) : "version_metadata";
}
module.exports.getVersionMetadataTag = $736084e6eed74fa4$var$getVersionMetadataTag;
function $736084e6eed74fa4$var$toPrettyJson(obj) {
    return JSON.stringify(obj, null, 2);
}

});

parcelRegister("6azSK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getDimensionContext = void 0;
/**
 * Resolves a record of Dimensions and their values based on the manifest
 * and the user specified dimensions values.
 *
 * If a dimension is not specified by the user, then the fallback value
 * will be used as the value for that dimension. If the fallback value
 * does not exist in this case, then a "missing-dimension-specification"
 * result will be reported.
 *
 * If a dimension value specified by the user is not part of the list
 * of supported values, then the dimension value will be the fallback
 * value defined. If a fallback value does not exist for that dimension,
 * then an "unsupported-value-specified-for-supported-dimension" result
 * will be reported.
 *
 * Otherwise, a "success" result will be reported on a valid context
 * resolution.
 *
 * @param specifiedDimensions the dimensions the user specified
 * @param manifest the manifest to validate and fallback user specifications
 * @returns a record of Dimensions and their valid values, or an error type
 *      if a record of valid values could not be derived from the user input
 */ function $47df82a858b4a3af$var$getDimensionContext(specifiedDimensions, manifest) {
    var dimensionToValues = {};
    for(var dimension in manifest.dimensions){
        var manifestDimensionSpecs = manifest.dimensions[dimension];
        var dimensionValue = specifiedDimensions[dimension];
        var fallback = manifestDimensionSpecs.fallback;
        if (dimensionValue === undefined) {
            if (fallback === undefined) return {
                type: "missing-dimension-specification"
            };
            else dimensionValue = fallback;
        }
        if (!manifestDimensionSpecs.supported.includes(dimensionValue)) {
            if (fallback === undefined) return {
                type: "unsupported-value-specified-for-supported-dimension"
            };
            else dimensionValue = fallback;
        }
        dimensionToValues[dimension] = dimensionValue;
    }
    return {
        type: "success",
        dimensionContext: dimensionToValues
    };
}
module.exports.getDimensionContext = $47df82a858b4a3af$var$getDimensionContext;

});

parcelRegister("5JEdh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assertUnreachable = void 0;
function $42d0593bd33c34ce$var$assertUnreachable(_x) {
    throw new Error("This function should never be called. This is for yielding compile errors on non-exhaustive case checking.");
}
module.exports.assertUnreachable = $42d0593bd33c34ce$var$assertUnreachable;

});

parcelRegister("1irfz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toPrettyJson = module.exports.toJson = void 0;
function $0f1c9c383a3e3c6c$var$toJson(buffer) {
    return JSON.parse(buffer.toString());
}
module.exports.toJson = $0f1c9c383a3e3c6c$var$toJson;
function $0f1c9c383a3e3c6c$var$toPrettyJson(obj) {
    return JSON.stringify(obj, null, 2);
}
module.exports.toPrettyJson = $0f1c9c383a3e3c6c$var$toPrettyJson;

});


parcelRegister("iOvpV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseArtifactManifest = void 0;

var $3QcN5 = parcelRequire("3QcN5");
function $db25444975a989d6$var$parseMetricTags(metricTags) {
    var unparsedMetricTags = (0, $3QcN5.parseUnknownObject)(metricTags);
    var parsedMetricTags = {};
    for(var _i = 0, _a = Object.keys(unparsedMetricTags); _i < _a.length; _i++){
        var key = _a[_i];
        var tag = (0, $3QcN5.parseString)(unparsedMetricTags[key]);
        parsedMetricTags[key] = tag;
    }
    return parsedMetricTags;
}
function $db25444975a989d6$var$parsePublishMetadata(publishMetadata) {
    var unparsedPublishMetadata = (0, $3QcN5.parseUnknownObject)(publishMetadata);
    var metricTags = "metricTags" in unparsedPublishMetadata ? $db25444975a989d6$var$parseMetricTags(unparsedPublishMetadata.metricTags) : undefined;
    return {
        metricTags: metricTags
    };
}
function $db25444975a989d6$var$parseDimensions(dimensions) {
    var unparsedDimensions = (0, $3QcN5.parseUnknownObject)(dimensions);
    var supported = (0, $3QcN5.parseArray)(unparsedDimensions.supported).map($3QcN5.parseString);
    var fallback = (0, $3QcN5.parseUndefinedOr)($3QcN5.parseString, unparsedDimensions.fallback);
    return {
        fallback: fallback,
        supported: supported
    };
}
function $db25444975a989d6$var$parseDimensionsRecord(dimensionRecord) {
    var parsedDimensionRecord = {};
    var unparsedDimensionRecord = (0, $3QcN5.parseUnknownObject)(dimensionRecord);
    for(var _i = 0, _a = Object.keys(unparsedDimensionRecord); _i < _a.length; _i++){
        var key = _a[_i];
        var dimensionsSpec = $db25444975a989d6$var$parseDimensions(unparsedDimensionRecord[key]);
        parsedDimensionRecord[key] = dimensionsSpec;
    }
    return parsedDimensionRecord;
}
function $db25444975a989d6$var$parseArtifactManifest(potentialArtifactManifest) {
    var unparsedArtifactManifest = (0, $3QcN5.parseUnknownObject)(potentialArtifactManifest);
    var name = (0, $3QcN5.parseString)(unparsedArtifactManifest.name);
    var tagScheme = (0, $3QcN5.parseString)(unparsedArtifactManifest.tagScheme);
    var frontend = (0, $3QcN5.parseUndefinedOr)($3QcN5.parseBoolean, unparsedArtifactManifest.frontend);
    var dimensions = $db25444975a989d6$var$parseDimensionsRecord(unparsedArtifactManifest.dimensions);
    var publishMetadata = $db25444975a989d6$var$parsePublishMetadata(unparsedArtifactManifest.publishMetadata);
    return {
        name: name,
        frontend: frontend,
        tagScheme: tagScheme,
        dimensions: dimensions,
        publishMetadata: publishMetadata
    };
}
module.exports.parseArtifactManifest = $db25444975a989d6$var$parseArtifactManifest;

});
parcelRegister("3QcN5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseUndefinedOr = module.exports.parseUnknownObject = module.exports.parseBoolean = module.exports.parseArray = module.exports.parseString = void 0;
function $2cc0265fd5f5248b$var$parseString(string) {
    if (typeof string === "string") return string;
    throw new Error("Couldn't parse String");
}
module.exports.parseString = $2cc0265fd5f5248b$var$parseString;
function $2cc0265fd5f5248b$var$parseArray(array) {
    if (Array.isArray(array)) return array;
    throw new Error("Couldn't parse List or Undefined");
}
module.exports.parseArray = $2cc0265fd5f5248b$var$parseArray;
function $2cc0265fd5f5248b$var$parseBoolean(boolean) {
    if (typeof boolean === "boolean") return boolean;
    throw new Error("Couldn't parse Boolean or undefined");
}
module.exports.parseBoolean = $2cc0265fd5f5248b$var$parseBoolean;
function $2cc0265fd5f5248b$var$parseUnknownObject(object) {
    if (typeof object === "object") return object;
    throw new Error("Couldn't parse object");
}
module.exports.parseUnknownObject = $2cc0265fd5f5248b$var$parseUnknownObject;
function $2cc0265fd5f5248b$var$parseUndefinedOr(parse, thing) {
    if (typeof thing === "undefined") return thing;
    else return parse(thing);
}
module.exports.parseUndefinedOr = $2cc0265fd5f5248b$var$parseUndefinedOr;

});


parcelRegister("7Lu49", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseVersionMetadata = void 0;

var $3QcN5 = parcelRequire("3QcN5");
function $5a743eac9b63af84$var$parseVersionMetadata(possiblyVersionMetadata) {
    var unknownObject = (0, $3QcN5.parseUnknownObject)(possiblyVersionMetadata);
    var version = (0, $3QcN5.parseString)(unknownObject.version);
    var publishTime = new Date((0, $3QcN5.parseString)(unknownObject.publishTime));
    var sidecarImageDigestVersion = (0, $3QcN5.parseString)(unknownObject.sidecarImageDigestVersion);
    return {
        version: version,
        publishTime: publishTime,
        sidecarImageDigestVersion: sidecarImageDigestVersion
    };
}
module.exports.parseVersionMetadata = $5a743eac9b63af84$var$parseVersionMetadata;

});

parcelRegister("f2y27", function(module, exports) {
"use strict";
var $af317132c195ce99$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkManifest = void 0;
/**
 * @param manifest manifest retrieved from data source
 * @param request request used to retrieve manifest (ie the artifact name and version specified)
 * @returns the manifest, but now it is guaranteed that the manifest name is the same as the requested name,
 * the version is the same as the requested version (if one is requested) and the version dimension (if it exists)
 * specifies exactly one version
 */ function $af317132c195ce99$var$checkManifest(manifest, request) {
    if (manifest.name !== request.name) return {
        key: "mismatched-manifest-name"
    };
    var manifestVersionDimension = manifest.dimensions.version;
    if (request.version) {
        var manifestVersions = manifestVersionDimension ? $af317132c195ce99$var$__spreadArray([
            manifestVersionDimension === null || manifestVersionDimension === void 0 ? void 0 : manifestVersionDimension.fallback
        ], manifestVersionDimension === null || manifestVersionDimension === void 0 ? void 0 : manifestVersionDimension.supported, true).filter(function(s) {
            return !!s;
        }) : [];
        var allVersionsMatch = manifestVersions.every(function(v) {
            return v === request.version;
        });
        if (!allVersionsMatch || manifestVersions.length === 0) return {
            key: "mismatched-manifest-version"
        };
    }
    return {
        key: "success"
    };
}
module.exports.checkManifest = $af317132c195ce99$var$checkManifest;

});

parcelRegister("2gZnK", function(module, exports) {
"use strict";
var $1a7cb09760c2ee46$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $1a7cb09760c2ee46$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConfigRegistryDataSource = void 0;

var $9U9fz = parcelRequire("9U9fz");

var $76UCK = parcelRequire("76UCK");

var $iOvpV = parcelRequire("iOvpV");

var $7Lu49 = parcelRequire("7Lu49");
var $1a7cb09760c2ee46$var$ConfigRegistryDataSource = /** @class */ function() {
    function ConfigRegistryDataSource(manifestVersion, configRegistryHttpClient) {
        this.manifestVersion = manifestVersion;
        this.configRegistryHttpClient = configRegistryHttpClient;
    }
    ConfigRegistryDataSource.prototype.getManifest = function(artifactName, artifactVersion) {
        return $1a7cb09760c2ee46$var$__awaiter(this, void 0, void 0, function() {
            var tag, configRegistryResponse, e_1;
            return $1a7cb09760c2ee46$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        tag = (0, $9U9fz.getDataTagForManifest)(artifactName, this.manifestVersion, artifactVersion);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(tag)
                        ];
                    case 2:
                        configRegistryResponse = _a.sent();
                        return [
                            2 /*return*/ ,
                            configRegistryResponse.leftMap(function(e) {
                                return e;
                            }).map($iOvpV.parseArtifactManifest)
                        ];
                    case 3:
                        e_1 = _a.sent();
                        return [
                            2 /*return*/ ,
                            $76UCK.Either.left({
                                key: "config-registry-error",
                                error: e_1
                            })
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    ConfigRegistryDataSource.prototype.getArtifact = function(_artifactName, tag) {
        return $1a7cb09760c2ee46$var$__awaiter(this, void 0, void 0, function() {
            return $1a7cb09760c2ee46$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(tag)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    ConfigRegistryDataSource.prototype.getLatestVersionMetadata = function() {
        return $1a7cb09760c2ee46$var$__awaiter(this, void 0, void 0, function() {
            var dataTag, configRegistryResponse;
            return $1a7cb09760c2ee46$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        dataTag = (0, $9U9fz.getVersionMetadataTag)();
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(dataTag)
                        ];
                    case 1:
                        configRegistryResponse = _a.sent();
                        return [
                            2 /*return*/ ,
                            configRegistryResponse.bimap(function(error) {
                                return error;
                            }, function(response) {
                                return (0, $7Lu49.parseVersionMetadata)(response);
                            })
                        ];
                }
            });
        });
    };
    return ConfigRegistryDataSource;
}();
module.exports.ConfigRegistryDataSource = $1a7cb09760c2ee46$var$ConfigRegistryDataSource;

});

parcelRegister("l1Wyy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Versions = module.exports.UriSegments = module.exports.BaseUrls = void 0;
var $f4f71d06781e4fba$var$BaseUrls = /** @class */ function() {
    function BaseUrls() {}
    BaseUrls.ConfigRegistryProd = "https://config-registry.prod.atl-paas.net";
    BaseUrls.FrontendProxyStaging = "https://fd-frontend-sidecar-proxy.us-east-1.staging.atl-paas.net";
    return BaseUrls;
}();
module.exports.BaseUrls = $f4f71d06781e4fba$var$BaseUrls;
var $f4f71d06781e4fba$var$UriSegments = /** @class */ function() {
    function UriSegments() {}
    UriSegments.ConfigRegistryProxy = "config-registry-proxy";
    return UriSegments;
}();
module.exports.UriSegments = $f4f71d06781e4fba$var$UriSegments;
var $f4f71d06781e4fba$var$Versions = /** @class */ function() {
    function Versions() {}
    Versions.ManifestVersion = "v1";
    return Versions;
}();
module.exports.Versions = $f4f71d06781e4fba$var$Versions;

});


parcelRegister("7bKn3", function(module, exports) {

$parcel$export(module.exports, "CdnDataSource", function () { return $53bd87c280ca86da$export$b282d502ae22d0ca; });

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $l29cN = parcelRequire("l29cN");

var $bRlu3 = parcelRequire("bRlu3");

var $9U9fz = parcelRequire("9U9fz");
var $53bd87c280ca86da$export$b282d502ae22d0ca = /*#__PURE__*/ function() {
    "use strict";
    function CdnDataSource(cdnClient, manifestVersion) {
        (0, $4GJKx._)(this, CdnDataSource);
        this.cdnClient = cdnClient;
        this.manifestVersion = manifestVersion;
    }
    (0, $1wc17._)(CdnDataSource, [
        {
            key: "getLatestVersionMetadata",
            value: function getLatestVersionMetadata() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var tag, cdnResponse;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                tag = (0, $9U9fz.getVersionMetadataTag)();
                                return [
                                    4,
                                    _this.cdnClient.getBlob("".concat(tag, ".json"))
                                ];
                            case 1:
                                cdnResponse = _state.sent();
                                return [
                                    2,
                                    cdnResponse.fold(function(error) {
                                        return (0, $bRlu3.Either).left(error);
                                    }, function(response) {
                                        try {
                                            var parsedVersionMetadata = (0, $bRlu3.parseVersionMetadata)(response);
                                            return (0, $bRlu3.Either).right(parsedVersionMetadata);
                                        } catch (e) {
                                            var error = {
                                                key: "invalid-version-metadata"
                                            };
                                            return (0, $bRlu3.Either).left(error);
                                        }
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getManifest",
            value: function getManifest(artifactName, artifactVersion) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var manifestTag, cdnResponse;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                manifestTag = (0, $9U9fz.getDataTagForManifest)(artifactName, _this.manifestVersion, artifactVersion);
                                return [
                                    4,
                                    _this.cdnClient.getBlob("".concat(manifestTag, ".json"), artifactName)
                                ];
                            case 1:
                                cdnResponse = _state.sent();
                                return [
                                    2,
                                    cdnResponse.fold(function(error) {
                                        return (0, $bRlu3.Either).left(error);
                                    }, function(response) {
                                        try {
                                            var parsedArtifact = (0, $bRlu3.parseArtifactManifest)(response);
                                            return (0, $bRlu3.Either).right(parsedArtifact);
                                        } catch (e) {
                                            var error = {
                                                key: "invalid-manifest"
                                            };
                                            return (0, $bRlu3.Either).left(error);
                                        }
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getArtifact",
            value: function getArtifact(artifactName, tag) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $l29cN.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.cdnClient.getBlob("".concat(tag, ".json"), artifactName)
                        ];
                    });
                })();
            }
        }
    ]);
    return CdnDataSource;
}();

});

parcelRegister("dZMYX", function(module, exports) {

$parcel$export(module.exports, "CdnHttpClientImpl", function () { return $a306f7b63c51d991$export$b1dddb1dd5820417; });

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $l29cN = parcelRequire("l29cN");

var $jjExS = parcelRequire("jjExS");

var $bRlu3 = parcelRequire("bRlu3");
var $a306f7b63c51d991$export$b1dddb1dd5820417 = /*#__PURE__*/ function() {
    "use strict";
    function CdnHttpClientImpl() {
        (0, $4GJKx._)(this, CdnHttpClientImpl);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "baseUrl", "https://fd-config.us-east-1.prod.public.atl-paas.net");
    }
    (0, $1wc17._)(CdnHttpClientImpl, [
        {
            key: "getBlob",
            value: function getBlob(tag, artifactName) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var endpoint, response, _;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                endpoint = artifactName !== undefined ? "".concat(_this.baseUrl, "/").concat(artifactName, "/").concat(tag) : "".concat(_this.baseUrl, "/").concat(tag);
                                return [
                                    4,
                                    fetch(endpoint)
                                ];
                            case 1:
                                response = _state.sent();
                                if (!response.ok) return [
                                    2,
                                    (0, $bRlu3.Either).left({
                                        key: "unexpected-response-code",
                                        httpResponseCode: response.status,
                                        httpResponseStatusText: response.statusText
                                    })
                                ];
                                _ = (0, $bRlu3.Either).right;
                                return [
                                    4,
                                    response.json()
                                ];
                            case 2:
                                return [
                                    2,
                                    _.apply((0, $bRlu3.Either), [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return CdnHttpClientImpl;
}();

});

parcelRegister("ki9Sr", function(module, exports) {

$parcel$export(module.exports, "ConfigClient", function () { return $ec5d267240e748d9$export$8489e2f039bfcc4c; });

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $l29cN = parcelRequire("l29cN");

var $jjExS = parcelRequire("jjExS");

var $bRlu3 = parcelRequire("bRlu3");

var $lK9BM = parcelRequire("lK9BM");
function $ec5d267240e748d9$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ec5d267240e748d9$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $ec5d267240e748d9$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $ec5d267240e748d9$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $ec5d267240e748d9$export$8489e2f039bfcc4c = /*#__PURE__*/ function() {
    "use strict";
    function ConfigClient(dataSource, dataSourceName, fetchArtifactExperience, versionMetadataExperience) {
        (0, $4GJKx._)(this, ConfigClient);
        this.fetchArtifactExperience = fetchArtifactExperience;
        this.versionMetadataExperience = versionMetadataExperience;
        this.dataSource = new (0, $lK9BM.ExperienceDataSourceWrapper)(dataSource, this.fetchArtifactExperience, this.versionMetadataExperience);
        this.dataSourceName = dataSourceName;
    }
    (0, $1wc17._)(ConfigClient, [
        {
            key: "getArtifact",
            value: function getArtifact(artifactName, dimensions) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var specifiedDimensions, artifact;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.fetchArtifactExperience.addMetadata(dimensions);
                                _this.fetchArtifactExperience.start();
                                specifiedDimensions = $ec5d267240e748d9$var$_objectSpread($ec5d267240e748d9$var$_objectSpread({}, dimensions), {}, {
                                    name: artifactName
                                });
                                return [
                                    4,
                                    (0, $bRlu3.getArtifactFromSource)(_this.dataSource, specifiedDimensions, "backend")
                                ];
                            case 1:
                                artifact = _state.sent();
                                if (artifact.type === "success") _this.fetchArtifactExperience.success();
                                else {
                                    _this.fetchArtifactExperience.addMetadata({
                                        error: artifact.type
                                    });
                                    _this.fetchArtifactExperience.failure();
                                }
                                return [
                                    2,
                                    (0, $bRlu3.tryGetArtifactData)(artifact, _this.dataSourceName)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getLatestVersionMetadata",
            value: function getLatestVersionMetadata() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var getVersionMetadataResult;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.versionMetadataExperience.start();
                                return [
                                    4,
                                    _this.dataSource.getLatestVersionMetadata()
                                ];
                            case 1:
                                getVersionMetadataResult = _state.sent();
                                return [
                                    2,
                                    getVersionMetadataResult.fold(function(error) {
                                        _this.versionMetadataExperience.addMetadata({
                                            error: error.key
                                        });
                                        _this.versionMetadataExperience.failure();
                                        throw new Error("Unable to get latest version metadata from ".concat(_this.dataSourceName, " due to error: ").concat(error.key));
                                    }, function(data) {
                                        _this.versionMetadataExperience.success();
                                        return data;
                                    })
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return ConfigClient;
}();

});
parcelRegister("lK9BM", function(module, exports) {

$parcel$export(module.exports, "ExperienceDataSourceWrapper", function () { return $fd4558e377a2432c$export$1cc944571619e6e8; });
/**
 * Wraps a standard Datasource as defined by @atlassiansox/flight-deck-core && uses
 * the experience to mark when events happen.
 */ 
var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $l29cN = parcelRequire("l29cN");
var $fd4558e377a2432c$export$1cc944571619e6e8 = /*#__PURE__*/ function() {
    "use strict";
    function ExperienceDataSourceWrapper(dataSource, artifactExperience, versionMetadataExperience) {
        (0, $4GJKx._)(this, ExperienceDataSourceWrapper);
        this.dataSource = dataSource;
        this.artifactExperience = artifactExperience;
        this.versionMetadataExperience = versionMetadataExperience;
    }
    (0, $1wc17._)(ExperienceDataSourceWrapper, [
        {
            key: "getLatestVersionMetadata",
            value: function getLatestVersionMetadata() {
                this.versionMetadataExperience.mark("start-fetch-metadata");
                var result = this.dataSource.getLatestVersionMetadata();
                this.versionMetadataExperience.mark("end-fetch-metadata");
                return result;
            }
        },
        {
            key: "getManifest",
            value: function getManifest(artifactName, artifactVersion) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var result;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.artifactExperience.mark("start-fetch-artifact");
                                return [
                                    4,
                                    _this.dataSource.getManifest(artifactName, artifactVersion)
                                ];
                            case 1:
                                result = _state.sent();
                                result.leftMap(function(error) {
                                    _this.artifactExperience.failure();
                                    return error;
                                });
                                _this.artifactExperience.mark("end-fetch-artifact");
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getArtifact",
            value: function getArtifact(artifactName, tag) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var result;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.artifactExperience.mark("start-fetch-manifest");
                                return [
                                    4,
                                    _this.dataSource.getArtifact(artifactName, tag)
                                ];
                            case 1:
                                result = _state.sent();
                                result.leftMap(function(error) {
                                    _this.artifactExperience.failure();
                                    return error;
                                });
                                _this.artifactExperience.mark("end-fetch-manifest");
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return ExperienceDataSourceWrapper;
}();

});


parcelRegister("c9QGe", function(module, exports) {

$parcel$export(module.exports, "ConfigRegistryHttpClientImpl", function () { return $8d9f307c2520b515$export$fd145377da8851d0; });

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $l29cN = parcelRequire("l29cN");

var $jjExS = parcelRequire("jjExS");

var $bRlu3 = parcelRequire("bRlu3");
var $8d9f307c2520b515$export$fd145377da8851d0 = /*#__PURE__*/ function() {
    "use strict";
    function ConfigRegistryHttpClientImpl(namespace, userAgent) {
        (0, $4GJKx._)(this, ConfigRegistryHttpClientImpl);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "headers", {});
        this.namespace = namespace;
        this.headers = {
            "X-SSRF-Protection": "definitely-protected",
            "User-Agent": userAgent
        };
    }
    (0, $1wc17._)(ConfigRegistryHttpClientImpl, [
        {
            key: "getBlob",
            value: function getBlob(tag) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var response, failure, _;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetch("".concat((0, $bRlu3.BaseUrls).FrontendProxyStaging, "/").concat((0, $bRlu3.UriSegments).ConfigRegistryProxy, "/api/v1/namespaces/").concat(encodeURIComponent(_this.namespace), "/tags/").concat(tag), {
                                        method: "GET",
                                        headers: _this.headers
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                if (!response.ok) {
                                    failure = response.status === 429 ? {
                                        key: "rate-limit-error"
                                    } : response.status === 404 ? {
                                        key: "live-unavailable"
                                    } : {
                                        key: "config-registry-error",
                                        error: response.status
                                    };
                                    return [
                                        2,
                                        (0, $bRlu3.Either).left(failure)
                                    ];
                                }
                                _ = (0, $bRlu3.Either).right;
                                return [
                                    4,
                                    response.json()
                                ];
                            case 2:
                                return [
                                    2,
                                    _.apply((0, $bRlu3.Either), [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return ConfigRegistryHttpClientImpl;
}();

});

parcelRegister("iDgCp", function(module, exports) {

$parcel$export(module.exports, "getFlightDeckFetchExperience", function () { return $d908c2979a5d98bc$export$a3006f8f221c0a3b; });
$parcel$export(module.exports, "getVersionMetadataFetchExperience", function () { return $d908c2979a5d98bc$export$c3ac7702bfd47c1b; });

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $l29cN = parcelRequire("l29cN");
var $d908c2979a5d98bc$var$SAMPLING_RATE = 10;
var $d908c2979a5d98bc$var$UFOExperienceWrapper = /*#__PURE__*/ function() {
    "use strict";
    function UFOExperienceWrapper(experience) {
        (0, $4GJKx._)(this, UFOExperienceWrapper);
        this.experience = experience;
    }
    (0, $1wc17._)(UFOExperienceWrapper, [
        {
            key: "start",
            value: function start(startTime) {
                return this.experience.start(startTime);
            }
        },
        {
            key: "success",
            value: function success() {
                return this.experience.success();
            }
        },
        {
            key: "failure",
            value: function failure() {
                return this.experience.failure();
            }
        },
        {
            key: "addMetadata",
            value: function addMetadata(data) {
                return this.experience.addMetadata(data);
            }
        },
        {
            key: "mark",
            value: function mark(mark) {
                return this.experience.mark(mark);
            }
        }
    ]);
    return UFOExperienceWrapper;
}();
var $d908c2979a5d98bc$export$5e7536cf7bc56fee = /*#__PURE__*/ function() {
    "use strict";
    function MockExperience() {
        (0, $4GJKx._)(this, MockExperience);
    }
    (0, $1wc17._)(MockExperience, [
        {
            key: "start",
            value: function start() {
                return Promise.resolve();
            }
        },
        {
            key: "success",
            value: function success() {
                return Promise.resolve(null);
            }
        },
        {
            key: "failure",
            value: function failure() {
                return Promise.resolve(null);
            }
        },
        {
            key: "mark",
            value: function mark() {
                return;
            }
        },
        {
            key: "addMetadata",
            value: function addMetadata() {
                return;
            }
        }
    ]);
    return MockExperience;
}();
function $d908c2979a5d98bc$var$flightDeckSDKOperationExperience(id, timings, metadata) {
    return $d908c2979a5d98bc$var$_flightDeckSDKOperationExperience.apply(this, arguments);
}

function $d908c2979a5d98bc$var$_flightDeckSDKOperationExperience() {
    $d908c2979a5d98bc$var$_flightDeckSDKOperationExperience = (0, $kSuI9._)(function(id, timings, metadata) {
        var _ref, UFOExperience, ExperienceTypes, ExperiencePerformanceTypes, ufoExperience, _unused;
        return (0, $l29cN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    // only emit metrics 1 in every 10 times a Flight Deck Configuration is fetched
                    // to not flood Perf Portal with logs.
                    if (Math.random() * 100 > $d908c2979a5d98bc$var$SAMPLING_RATE) return [
                        2,
                        new $d908c2979a5d98bc$export$5e7536cf7bc56fee()
                    ];
                    return [
                        4,
                        (parcelRequire("kXNyl"))
                    ];
                case 1:
                    _ref = _state.sent(), UFOExperience = _ref.UFOExperience, ExperienceTypes = _ref.ExperienceTypes, ExperiencePerformanceTypes = _ref.ExperiencePerformanceTypes;
                    ufoExperience = new UFOExperience(id, {
                        type: ExperienceTypes.Operation,
                        performanceType: ExperiencePerformanceTypes.Custom,
                        platform: {
                            component: "flight-deck-client"
                        },
                        timings: timings
                    });
                    ufoExperience.addMetadata(metadata);
                    return [
                        2,
                        new $d908c2979a5d98bc$var$UFOExperienceWrapper(ufoExperience)
                    ];
                case 2:
                    _unused = _state.sent();
                    return [
                        2,
                        new $d908c2979a5d98bc$export$5e7536cf7bc56fee()
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return $d908c2979a5d98bc$var$_flightDeckSDKOperationExperience.apply(this, arguments);
}
var $d908c2979a5d98bc$export$a3006f8f221c0a3b = function() {
    return $d908c2979a5d98bc$var$flightDeckSDKOperationExperience("fetch", [
        {
            key: "fetch-artifact",
            endMark: "end-fetch-artifact",
            startMark: "start-fetch-artifact"
        },
        {
            key: "fetch-manifest",
            endMark: "end-fetch-manifest",
            startMark: "start-fetch-manifest"
        }
    ], {});
};
var $d908c2979a5d98bc$export$c3ac7702bfd47c1b = function() {
    return $d908c2979a5d98bc$var$flightDeckSDKOperationExperience("fetch-version-metadata", [
        {
            key: "fetch-metadata",
            startMark: "start-fetch-metadata",
            endMark: "end-fetch-metadata"
        }
    ], {});
};

});
parcelRegister("kXNyl", function(module, exports) {


module.exports = (parcelRequire("eg86f"))((parcelRequire("bRvn3")).resolve("bTvGy")).then(function() {
    return parcelRequire("fHJhX");
});

});


parcelRegister("levO6", function(module, exports) {

$parcel$export(module.exports, "assertUnreachable", function () { return $f7539401cd7ff13d$export$f2525c1d596f8d46; });
function $f7539401cd7ff13d$export$f2525c1d596f8d46(_x) {
    throw new Error("This function should never be called. This is for yielding compile errors on non-exhaustive case checking.");
}

});

parcelRegister("2OfQz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TargetedConfig = module.exports.parseConfigWithTargeting = void 0;

var $2s7Fw = parcelRequire("2s7Fw");
Object.defineProperty(module.exports, "parseConfigWithTargeting", {
    enumerable: true,
    get: function get() {
        return $2s7Fw.parseConfigWithTargeting;
    }
});

var $gJuFH = parcelRequire("gJuFH");
Object.defineProperty(module.exports, "TargetedConfig", {
    enumerable: true,
    get: function get() {
        return $gJuFH.TargetedConfig;
    }
});

});
parcelRegister("2s7Fw", function(module, exports) {
"use strict";
var $1c94251f8bec89c5$var$__assign = module.exports && module.exports.__assign || function() {
    $1c94251f8bec89c5$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1c94251f8bec89c5$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseConfigWithTargeting = void 0;

var $gJuFH = parcelRequire("gJuFH");
/**
 * For a given configuration, return the same configuration back
 * with {@link TargetedConfig} substituted where applicable.
 *
 * So anywhere in the JSON that has the objects:
 * ```
 * {
 *   "defaultConfig": ...
 * }
 * ```
 *
 * OR
 *
 * ```
 * {
 *   "defaultConfig": ...
 *   "targeting": {
 *     "targets": [...]
 *     "targetedConfig": ...
 *   }
 * }
 * ```
 *
 * become an instance of {@link TargetedConfig}.
 *
 * @param config configuration that may contain unparsed {@link TargetedConfig}
 * @returns the same configuration with targeted config sub-objects transformed
 *     into {@link TargetedConfig}
 */ function $1c94251f8bec89c5$var$parseConfigWithTargeting(data) {
    // All "object" types will also need to have a null check because null is an "object", but an
    // invalid one for this use case.
    if (typeof data === "object") {
        if (Array.isArray(data)) return data.map(function(element) {
            return $1c94251f8bec89c5$var$parseConfigWithTargeting(element);
        });
        else if (data) {
            var parsedObject_1 = data;
            var keys = Object.keys(parsedObject_1);
            if (keys.length === 1 && parsedObject_1.defaultConfig) return new $gJuFH.TargetedConfig({
                defaultConfig: $1c94251f8bec89c5$var$parseConfigWithTargeting(parsedObject_1.defaultConfig)
            });
            else if (keys.length === 2 && parsedObject_1.defaultConfig && parsedObject_1.targeting) {
                var parseResult = $1c94251f8bec89c5$var$parseTargeting(parsedObject_1.targeting);
                if (parseResult.type === "match") return new $gJuFH.TargetedConfig({
                    targeting: parseResult.result,
                    defaultConfig: $1c94251f8bec89c5$var$parseConfigWithTargeting(parsedObject_1.defaultConfig)
                });
            }
            return keys.reduce(function(accObject, key) {
                var _a;
                return $1c94251f8bec89c5$var$__assign($1c94251f8bec89c5$var$__assign({}, accObject), (_a = {}, _a[key] = $1c94251f8bec89c5$var$parseConfigWithTargeting(parsedObject_1[key]), _a));
            }, {});
        } else return null;
    } else return data;
}
module.exports.parseConfigWithTargeting = $1c94251f8bec89c5$var$parseConfigWithTargeting;
function $1c94251f8bec89c5$var$parseTargeting(targeting) {
    if (typeof targeting === "object" && targeting && !Array.isArray(targeting)) {
        var targetingKeyValue = targeting;
        var targetingKeys = Object.keys(targetingKeyValue);
        if (targetingKeys.length == 2 && targetingKeyValue.targets && targetingKeyValue.targetedConfig) return {
            type: "match",
            result: {
                targets: $1c94251f8bec89c5$var$parseTargets(targetingKeyValue.targets),
                targetedConfig: $1c94251f8bec89c5$var$parseConfigWithTargeting(targetingKeyValue.targetedConfig)
            }
        };
    }
    return {
        type: "no-match"
    };
}
function $1c94251f8bec89c5$var$parseTargets(targets) {
    if (Array.isArray(targets)) return targets.map(function(target) {
        return {
            orgIds: $1c94251f8bec89c5$var$parseIdentifierList(target.orgIds),
            siteIds: $1c94251f8bec89c5$var$parseIdentifierList(target.siteIds),
            userIds: $1c94251f8bec89c5$var$parseIdentifierList(target.userIds)
        };
    });
    else throw new Error("The targets for Flight Deck targeted configuration must come in an array.");
}
function $1c94251f8bec89c5$var$parseIdentifierList(identifierList) {
    if (identifierList === undefined) return undefined;
    if (Array.isArray(identifierList)) return identifierList.map(function(id) {
        if (typeof id === "string") return id;
        else throw new Error("Identifiers for targets must be strings!");
    });
    else throw new Error("Identifier list must be an array!");
}

});
parcelRegister("gJuFH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TargetedConfig = void 0;
/**
 * Defines a part of the overall configuration that has different
 * values based on the intended target. The target is a specification
 * of a combination of site id, user id and org id.
 */ var $c2e8a40f6ab4cde1$var$TargetedConfig = /** @class */ function() {
    function TargetedConfig(targetedConfigDefinition) {
        this.targetedConfigDefinition = targetedConfigDefinition;
    }
    /**
     * Determines whether to use the targeted configuration value or the default value
     * depending on whether the specified values match any of the target's rules.
     *
     * @param target the values to use to evaluate the config
     * @returns the {@link TargetingResult}, which would be the default value
     *     if the specified target did not match, or the targeted value if there
     *     was a match
     */ TargetedConfig.prototype.resolve = function(target) {
        var targeting = this.targetedConfigDefinition.targeting;
        if (targeting) {
            var targeted = targeting.targets.some(function(configuredTarget) {
                var criteria = [];
                if (configuredTarget.orgIds) criteria.push({
                    allowList: configuredTarget.orgIds,
                    identifier: target.orgId
                });
                if (configuredTarget.siteIds) criteria.push({
                    allowList: configuredTarget.siteIds,
                    identifier: target.siteId
                });
                if (configuredTarget.userIds) criteria.push({
                    allowList: configuredTarget.userIds,
                    identifier: target.userId
                });
                if (criteria.length === 0) return false;
                else return criteria.every(function(criteria) {
                    return $c2e8a40f6ab4cde1$var$resolveForTargetCriteria(criteria);
                });
            });
            if (targeted) return {
                type: "targeted",
                value: targeting.targetedConfig
            };
        }
        return {
            type: "default",
            value: this.targetedConfigDefinition.defaultConfig
        };
    };
    return TargetedConfig;
}();
module.exports.TargetedConfig = $c2e8a40f6ab4cde1$var$TargetedConfig;
function $c2e8a40f6ab4cde1$var$resolveForTargetCriteria(criteria) {
    return !!criteria.identifier && criteria.allowList.includes(criteria.identifier);
}

});




parcelRegister("ks3HS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee394c3c6fc7ae3f$export$2e2bcd8739ae039; });

var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $FuVm8 = parcelRequire("FuVm8");

var $ohfOJ = parcelRequire("ohfOJ");
var $ee394c3c6fc7ae3f$export$2e2bcd8739ae039 = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $dcsZi._)(FlightDeckSDKError, Error1);
    var _super = (0, $ohfOJ._)(FlightDeckSDKError);
    function FlightDeckSDKError(param) {
        var artifact = param.artifact, dimensions = param.dimensions, error = param.error;
        (0, $4GJKx._)(this, FlightDeckSDKError);
        var _this;
        _this = _super.call(this, error instanceof Error && error.message ? error.message : "Unknown Flight Deck SDK error");
        _this.name = "FlightDeckSDKError";
        _this.error = error;
        _this.artifact = artifact;
        _this.environmentType = dimensions === null || dimensions === void 0 ? void 0 : dimensions.environmentType;
        _this.locale = dimensions === null || dimensions === void 0 ? void 0 : dimensions.locale;
        return _this;
    }
    return FlightDeckSDKError;
}((0, $FuVm8._)(Error));
var $ee394c3c6fc7ae3f$export$1d76d155060824c9 = function(e) {
    return e instanceof $ee394c3c6fc7ae3f$export$2e2bcd8739ae039;
};

});

parcelRegister("1vATs", function(module, exports) {

$parcel$export(module.exports, "artifactKey", function () { return $11954df49a6dbbb4$export$e3553dc63541d477; });
var $11954df49a6dbbb4$export$e3553dc63541d477 = function(artifactName, dimensions) {
    return "".concat(artifactName).concat(dimensions ? "_" + Object.keys(dimensions).sort().map(function(key) {
        return dimensions[key];
    }).filter(Boolean).join("_") : "");
};

});

parcelRegister("5yOsy", function(module, exports) {

$parcel$export(module.exports, "flightDeckClientExperience", function () { return $40c744ed70108028$export$1e3a41a51f6457c5; });
$parcel$export(module.exports, "exceptionToMetadata", function () { return $40c744ed70108028$export$f33622abb5224195; });

var $jjExS = parcelRequire("jjExS");

var $kqLwi = parcelRequire("kqLwi");
var $7vVo6 = parcelRequire("7vVo6");
function $40c744ed70108028$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $40c744ed70108028$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $40c744ed70108028$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $40c744ed70108028$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $40c744ed70108028$export$6061a1a9a61f2e21 = function() {
    return new (0, $7vVo6.UFOExperience)("fetch", {
        type: (0, $kqLwi.ExperienceTypes).Operation,
        performanceType: (0, $kqLwi.ExperiencePerformanceTypes).Custom,
        platform: {
            component: "flight-deck-client"
        }
    });
};
var $40c744ed70108028$export$1e3a41a51f6457c5 = function() {
    return new (0, $7vVo6.UFOExperience)("retrieve-artifact", {
        type: (0, $kqLwi.ExperienceTypes).Operation,
        performanceType: (0, $kqLwi.ExperiencePerformanceTypes).Custom,
        platform: {
            component: "flight-deck-client"
        }
    });
};
var $40c744ed70108028$export$f33622abb5224195 = function(e) {
    return e instanceof Error ? $40c744ed70108028$var$_objectSpread($40c744ed70108028$var$_objectSpread({}, e), {}, {
        cause: undefined
    }) : "unknown";
};

});
parcelRegister("kqLwi", function(module, exports) {

$parcel$export(module.exports, "ExperienceTypes", function () { return $edfb18d7cc84cefd$export$994164cf3ae1cc9a; });
$parcel$export(module.exports, "ExperiencePerformanceTypes", function () { return $edfb18d7cc84cefd$export$cc26007c03242fff; });
var $edfb18d7cc84cefd$export$994164cf3ae1cc9a;
(function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
})($edfb18d7cc84cefd$export$994164cf3ae1cc9a || ($edfb18d7cc84cefd$export$994164cf3ae1cc9a = {}));
var $edfb18d7cc84cefd$export$cc26007c03242fff;
(function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
})($edfb18d7cc84cefd$export$cc26007c03242fff || ($edfb18d7cc84cefd$export$cc26007c03242fff = {}));

});

parcelRegister("7vVo6", function(module, exports) {

$parcel$export(module.exports, "UFOExperience", function () { return $5787f1aeb5d20cf0$export$c00d22927c60484a; });

var $2Yk1N = parcelRequire("2Yk1N");

var $6QU8A = parcelRequire("6QU8A");

var $eZhUW = parcelRequire("eZhUW");

var $kcuts = parcelRequire("kcuts");

var $6pDhi = parcelRequire("6pDhi");

var $l6a15 = parcelRequire("l6a15");
function $5787f1aeb5d20cf0$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $5787f1aeb5d20cf0$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($6pDhi)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($6pDhi)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($kcuts)))(this, result);
    };
}
function $5787f1aeb5d20cf0$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $5787f1aeb5d20cf0$export$c00d22927c60484a = /*#__PURE__*/ function(_UFOAbstractExperienc) {
    (0, (/*@__PURE__*/$parcel$interopDefault($eZhUW)))(UFOExperience, _UFOAbstractExperienc);
    var _super = $5787f1aeb5d20cf0$var$_createSuper(UFOExperience);
    function UFOExperience() {
        (0, (/*@__PURE__*/$parcel$interopDefault($6QU8A)))(this, UFOExperience);
        return _super.apply(this, arguments);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($2Yk1N)))(UFOExperience);
}((0, $l6a15.UFOAbstractExperience));

});
parcelRegister("l6a15", function(module, exports) {

$parcel$export(module.exports, "UFOAbstractExperience", function () { return $f5c1ed8f3d2a9843$export$d31c89db257648c; });

var $eetQ9 = parcelRequire("eetQ9");

var $e8dor = parcelRequire("e8dor");

var $6QU8A = parcelRequire("6QU8A");

var $2Yk1N = parcelRequire("2Yk1N");

var $jjExS = parcelRequire("jjExS");

var $fGIeY = parcelRequire("fGIeY");

var $ku8iA = parcelRequire("ku8iA");

var $2PYXG = parcelRequire("2PYXG");

var $397CT = parcelRequire("397CT");

var $leTid = parcelRequire("leTid");

var $jyh1L = parcelRequire("jyh1L");

var $fE7C5 = parcelRequire("fE7C5");

var $bYxiS = parcelRequire("bYxiS");

var $8ryWc = parcelRequire("8ryWc");

var $d5tCP = parcelRequire("d5tCP");

var $7XKNE = parcelRequire("7XKNE");

var $kqLwi = parcelRequire("kqLwi");
function $f5c1ed8f3d2a9843$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f5c1ed8f3d2a9843$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $f5c1ed8f3d2a9843$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $f5c1ed8f3d2a9843$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $f5c1ed8f3d2a9843$var$getPageVisibleState = function getPageVisibleState() {
    return !(0, $397CT.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === "visible" ? (0, $bYxiS.PageVisibleState).VISIBLE : (0, $bYxiS.PageVisibleState).HIDDEN;
};
var $f5c1ed8f3d2a9843$export$c753e8669d30c8ad = function perfNowOrTimestamp(timestamp) {
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $8ryWc.roundPerfNow)();
};
var $f5c1ed8f3d2a9843$export$d31c89db257648c = /*#__PURE__*/ function() {
    // for concurrent
    // @todo move to page load experience when proper classes/inheritance prepared
    function UFOAbstractExperience(id, config) {
        var _this = this;
        var instanceId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        (0, (/*@__PURE__*/$parcel$interopDefault($6QU8A)))(this, UFOAbstractExperience);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "state", (0, $d5tCP.UFOExperienceState).NOT_STARTED);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "instanceId", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "parent", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "category", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "metadata", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "onDoneCallbacks", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "childExperiences", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "explicitTimings", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "isSSROutputAsFMP", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "uuid", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_until", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "metrics", {
            startTime: null,
            endTime: null,
            marks: []
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "performanceConfig", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "setPageVisibleStateToMixed", function() {
            _this.pageVisibleState = (0, $bYxiS.PageVisibleState).MIXED;
            (0, $fE7C5.visibilityChangeObserver).unsubscribe(_this.setPageVisibleStateToMixed);
        });
        this.id = id;
        this.category = (config === null || config === void 0 ? void 0 : config.category) || null;
        this.until = (config === null || config === void 0 ? void 0 : config.until) || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $f5c1ed8f3d2a9843$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $kqLwi.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $kqLwi.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($2Yk1N)))(UFOAbstractExperience, [
        {
            key: "transition",
            value: function() {
                var _transition = (0, (/*@__PURE__*/$parcel$interopDefault($e8dor)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).mark(function _callee(newState, timestamp) {
                    var data;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                (0, $jyh1L.ufolog)("async transition", this.id, this.state.id, newState.id);
                                if (!(0, $7XKNE.canTransition)(this.state, newState)) {
                                    _context.next = 15;
                                    break;
                                }
                                (0, $jyh1L.ufolog)("TRANSITION: ".concat(this.id, " from ").concat(this.state.id, " to ").concat(newState.id, " successful"), this.state.final, !newState.final);
                                if (newState === (0, $d5tCP.UFOExperienceState).STARTED) this._reset();
                                if (this.state.final && !newState.final) {
                                    this.metrics.startTime = $f5c1ed8f3d2a9843$export$c753e8669d30c8ad(timestamp);
                                    this.uuid = (0, $ku8iA.v4)();
                                }
                                this.state = newState;
                                if (!newState.final) {
                                    _context.next = 14;
                                    break;
                                }
                                this.metrics.endTime = $f5c1ed8f3d2a9843$export$c753e8669d30c8ad(timestamp);
                                if (!this._isManualStateEnabled()) (0, $leTid.getGlobalEventStream)().push((0, $leTid.unsubscribeEvent)((0, $bYxiS.SUBSCRIBE_ALL), this.handleDoneBind));
                                _context.next = 11;
                                return this.exportData();
                            case 11:
                                data = _context.sent;
                                (0, $jyh1L.ufolog)("this.parent", this.parent);
                                (0, $leTid.getGlobalEventStream)().push((0, $leTid.experiencePayloadEvent)(data));
                            case 14:
                                return _context.abrupt("return", true);
                            case 15:
                                (0, $jyh1L.ufolog)("TRANSITION: ".concat(this.id, " from ").concat(this.state.id, " to ").concat(newState.id, " unsuccessful"));
                                (0, $jyh1L.ufowarn)("transition of ".concat(this.id, " from ").concat(this.state, " to ").concat(newState, " is not possible"));
                                return _context.abrupt("return", false);
                            case 18:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function transition(_x, _x2) {
                    return _transition.apply(this, arguments);
                }
                return transition;
            }()
        },
        {
            key: "start",
            value: function() {
                var _start = (0, (/*@__PURE__*/$parcel$interopDefault($e8dor)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).mark(function _callee2(startTime) {
                    var transitionSuccessful;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 2;
                                return this.transition((0, $d5tCP.UFOExperienceState).STARTED, startTime);
                            case 2:
                                transitionSuccessful = _context2.sent;
                                if (transitionSuccessful) {
                                    this.pageVisibleState = $f5c1ed8f3d2a9843$var$getPageVisibleState();
                                    (0, $fE7C5.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
                                    if (!this._isManualStateEnabled()) {
                                        (0, $jyh1L.ufolog)("subscribed", this.id);
                                        (0, $leTid.getGlobalEventStream)().push((0, $leTid.subscribeEvent)((0, $bYxiS.SUBSCRIBE_ALL), this.handleDoneBind));
                                    }
                                }
                            case 4:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function start(_x3) {
                    return _start.apply(this, arguments);
                }
                return start;
            }()
        },
        {
            key: "mark",
            value: function mark(name, timestamp) {
                if (name !== (0, $bYxiS.FMP_MARK) && name !== (0, $bYxiS.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
                else (0, $jyh1L.ufowarn)("please use markFMP or markInlineResponse for specialised marks");
            }
        },
        {
            key: "_mark",
            value: function _mark(name, timestamp) {
                this.metrics.marks.push({
                    name: name,
                    time: $f5c1ed8f3d2a9843$export$c753e8669d30c8ad(timestamp)
                });
                this.transition((0, $d5tCP.UFOExperienceState).IN_PROGRESS);
            }
        },
        {
            key: "markFMP",
            value: function markFMP(timestamp) {
                this._mark((0, $bYxiS.FMP_MARK), timestamp);
            }
        },
        {
            key: "markInlineResponse",
            value: function markInlineResponse(timestamp) {
                this._mark((0, $bYxiS.INLINE_RESPONSE_MARK), timestamp);
            }
        },
        {
            key: "_isManualStateEnabled",
            value: function _isManualStateEnabled() {
                return this.until === null;
            }
        },
        {
            key: "_validateManualState",
            value: function _validateManualState() {
                if (!this._isManualStateEnabled()) {
                    (0, $jyh1L.ufowarn)('manual change of state not allowed as "until" is defined');
                    return false;
                }
                return true;
            }
        },
        {
            key: "switchToEndState",
            value: function switchToEndState(state, config) {
                if (!(config !== null && config !== void 0 && config.force) && !this._validateManualState()) return null;
                if (config !== null && config !== void 0 && config.metadata) this.addMetadata(config.metadata);
                (0, $fE7C5.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
                return this.transition(state);
            }
        },
        {
            key: "success",
            value: function() {
                var _success = (0, (/*@__PURE__*/$parcel$interopDefault($e8dor)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).mark(function _callee3(config) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", this.switchToEndState((0, $d5tCP.UFOExperienceState).SUCCEEDED, config));
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function success(_x4) {
                    return _success.apply(this, arguments);
                }
                return success;
            }()
        },
        {
            key: "failure",
            value: function() {
                var _failure = (0, (/*@__PURE__*/$parcel$interopDefault($e8dor)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).mark(function _callee4(config) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                return _context4.abrupt("return", this.switchToEndState((0, $d5tCP.UFOExperienceState).FAILED, config));
                            case 1:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function failure(_x5) {
                    return _failure.apply(this, arguments);
                }
                return failure;
            }()
        },
        {
            key: "abort",
            value: function() {
                var _abort = (0, (/*@__PURE__*/$parcel$interopDefault($e8dor)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).mark(function _callee5(config) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                return _context5.abrupt("return", this.switchToEndState((0, $d5tCP.UFOExperienceState).ABORTED, config));
                            case 1:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function abort(_x6) {
                    return _abort.apply(this, arguments);
                }
                return abort;
            }()
        },
        {
            key: "addMetadata",
            value: function addMetadata(data) {
                Object.assign(this.metadata, data);
            }
        },
        {
            key: "_handleDoneExperience",
            value: function _handleDoneExperience(data) {
                (0, $jyh1L.ufolog)("_handleDoneExperience in", this.id, data.state, data, this._until);
                if (data.state.final) {
                    if (this._until !== null) {
                        var _this$_until = this._until(data), done = _this$_until.done, state = _this$_until.state;
                        if (done && !this.state.final) this.transition(state);
                    }
                }
            }
        },
        {
            key: "getId",
            value: function() {
                var _getId = (0, (/*@__PURE__*/$parcel$interopDefault($e8dor)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).mark(function _callee6() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                return _context6.abrupt("return", this.id);
                            case 1:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function getId() {
                    return _getId.apply(this, arguments);
                }
                return getId;
            }()
        },
        {
            key: "exportData",
            value: function() {
                var _exportData = (0, (/*@__PURE__*/$parcel$interopDefault($e8dor)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).mark(function _callee7() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                _context7.next = 2;
                                return this.getId();
                            case 2:
                                _context7.t0 = _context7.sent;
                                _context7.t1 = this.uuid;
                                _context7.t2 = this.type;
                                _context7.t3 = (0, $2PYXG.UFO_EXPERIMENTAL_BUILD_VERSION) || "unknown";
                                _context7.t4 = this.performanceType;
                                _context7.t5 = this.category;
                                _context7.t6 = this.state;
                                _context7.t7 = $f5c1ed8f3d2a9843$var$_objectSpread({}, this.metadata);
                                _context7.t8 = $f5c1ed8f3d2a9843$var$_objectSpread({}, this.metrics);
                                _context7.t9 = (0, (/*@__PURE__*/$parcel$interopDefault($eetQ9)))(this.childExperiences);
                                _context7.t10 = {
                                    success: !!this.state.success,
                                    startTime: this.metrics.startTime,
                                    duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
                                };
                                _context7.t11 = this.config.platform || null;
                                _context7.t12 = this.pageVisibleState;
                                _context7.t13 = this.featureFlags;
                                _context7.t14 = this.isSSROutputAsFMP;
                                _context7.t15 = this.timings;
                                _context7.t16 = this.explicitTimings;
                                _context7.t17 = this.performanceConfig;
                                return _context7.abrupt("return", {
                                    id: _context7.t0,
                                    uuid: _context7.t1,
                                    type: _context7.t2,
                                    schemaVersion: _context7.t3,
                                    performanceType: _context7.t4,
                                    category: _context7.t5,
                                    state: _context7.t6,
                                    metadata: _context7.t7,
                                    metrics: _context7.t8,
                                    children: _context7.t9,
                                    result: _context7.t10,
                                    platform: _context7.t11,
                                    pageVisibleState: _context7.t12,
                                    featureFlags: _context7.t13,
                                    isSSROutputAsFMP: _context7.t14,
                                    timings: _context7.t15,
                                    explicitTimings: _context7.t16,
                                    performanceConfig: _context7.t17
                                });
                            case 21:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function exportData() {
                    return _exportData.apply(this, arguments);
                }
                return exportData;
            }()
        },
        {
            key: "_reset",
            value: function _reset() {
                this.parent = null;
                this.metadata = {};
                this.onDoneCallbacks = [];
                this.childExperiences = [];
                this.metrics = {
                    startTime: null,
                    endTime: null,
                    marks: []
                };
                this._until = this.until ? this.until() : null;
            }
        }
    ]);
    return UFOAbstractExperience;
}();

});
parcelRegister("ku8iA", function(module, exports) {

var $fkgz2 = parcelRequire("fkgz2");

var $1kpRq = parcelRequire("1kpRq");
var $ee9d0beefb4470c9$var$uuid = $1kpRq;
$ee9d0beefb4470c9$var$uuid.v1 = $fkgz2;
$ee9d0beefb4470c9$var$uuid.v4 = $1kpRq;
module.exports = $ee9d0beefb4470c9$var$uuid;

});
parcelRegister("fkgz2", function(module, exports) {

var $1rwEP = parcelRequire("1rwEP");

var $9LkGp = parcelRequire("9LkGp");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $b285928ce5a11301$var$_nodeId;
var $b285928ce5a11301$var$_clockseq;
// Previous uuid creation time
var $b285928ce5a11301$var$_lastMSecs = 0;
var $b285928ce5a11301$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $b285928ce5a11301$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $b285928ce5a11301$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $b285928ce5a11301$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $1rwEP();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $b285928ce5a11301$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $b285928ce5a11301$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $b285928ce5a11301$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $b285928ce5a11301$var$_lastMSecs + (nsecs - $b285928ce5a11301$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $b285928ce5a11301$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    $b285928ce5a11301$var$_lastMSecs = msecs;
    $b285928ce5a11301$var$_lastNSecs = nsecs;
    $b285928ce5a11301$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $9LkGp(b);
}
module.exports = $b285928ce5a11301$var$v1;

});
parcelRegister("1rwEP", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $10d1a52c2b85a90b$var$getRandomValues = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
if ($10d1a52c2b85a90b$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $10d1a52c2b85a90b$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $10d1a52c2b85a90b$var$getRandomValues($10d1a52c2b85a90b$var$rnds8);
        return $10d1a52c2b85a90b$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $10d1a52c2b85a90b$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $10d1a52c2b85a90b$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $10d1a52c2b85a90b$var$rnds;
    };
}

});

parcelRegister("9LkGp", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $71b88c09ef9374cb$var$byteToHex = [];
for(var $71b88c09ef9374cb$var$i = 0; $71b88c09ef9374cb$var$i < 256; ++$71b88c09ef9374cb$var$i)$71b88c09ef9374cb$var$byteToHex[$71b88c09ef9374cb$var$i] = ($71b88c09ef9374cb$var$i + 0x100).toString(16).substr(1);
function $71b88c09ef9374cb$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $71b88c09ef9374cb$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join("");
}
module.exports = $71b88c09ef9374cb$var$bytesToUuid;

});


parcelRegister("1kpRq", function(module, exports) {

var $1rwEP = parcelRequire("1rwEP");

var $9LkGp = parcelRequire("9LkGp");
function $0f7bb8134cfadb3b$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == "string") {
        buf = options === "binary" ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $1rwEP)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $9LkGp(rnds);
}
module.exports = $0f7bb8134cfadb3b$var$v4;

});


parcelRegister("2PYXG", function(module, exports) {

$parcel$export(module.exports, "UFO_EXPERIMENTAL_BUILD_VERSION", function () { return $210fa1e56cfa8d97$export$2295b861f318254a; });
// temp solution until we can get it automated
var $210fa1e56cfa8d97$export$2295b861f318254a = "0.1.5";

});

parcelRegister("397CT", function(module, exports) {

$parcel$export(module.exports, "isWindowObjectAvailable", function () { return $24a820c7124b0fd2$export$15e172712955e18f; });
var $24a820c7124b0fd2$export$15e172712955e18f = function isWindowObjectAvailable() {
    return typeof window !== "undefined";
};

});

parcelRegister("leTid", function(module, exports) {

$parcel$export(module.exports, "getGlobalEventStream", function () { return $f765cbc9ac8c9ec6$export$6123a44dc2384540; });
$parcel$export(module.exports, "subscribeEvent", function () { return $f765cbc9ac8c9ec6$export$37863216db4b714d; });
$parcel$export(module.exports, "unsubscribeEvent", function () { return $f765cbc9ac8c9ec6$export$ee1a7bd1fc9ea85e; });
$parcel$export(module.exports, "experiencePayloadEvent", function () { return $f765cbc9ac8c9ec6$export$7c957416596ca127; });

var $jyh1L = parcelRequire("jyh1L");

var $bYxiS = parcelRequire("bYxiS");
var $f765cbc9ac8c9ec6$var$MAX_EARLY_QUEUE_LENGTH = 250;
var $f765cbc9ac8c9ec6$export$6123a44dc2384540 = function getGlobalEventStream() {
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        var earlyStream = function() {
            var stream = [];
            return {
                __buffer_only__: true,
                push: function push(event) {
                    if (stream.length < $f765cbc9ac8c9ec6$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: function getStream() {
                    return stream;
                }
            };
        }();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
var $f765cbc9ac8c9ec6$export$c1522520b417b066 = function setGlobalEventStream(eventStream) {
    var _globalThis$__UFO_GLO, _globalThis$__UFO_GLO2;
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !((_globalThis$__UFO_GLO = globalThis.__UFO_GLOBAL_EVENT_STREAM__) !== null && _globalThis$__UFO_GLO !== void 0 && _globalThis$__UFO_GLO.__buffer_only__)) {
        (0, $jyh1L.ufowarn)("Global Event Stream already initialised. Ignoring new event stream setup");
        return;
    }
    if ((_globalThis$__UFO_GLO2 = globalThis.__UFO_GLOBAL_EVENT_STREAM__) !== null && _globalThis$__UFO_GLO2 !== void 0 && _globalThis$__UFO_GLO2.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
var $f765cbc9ac8c9ec6$export$37863216db4b714d = function subscribeEvent(experienceId, callback) {
    return {
        type: (0, $bYxiS.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
var $f765cbc9ac8c9ec6$export$ee1a7bd1fc9ea85e = function unsubscribeEvent(experienceId, callback) {
    return {
        type: (0, $bYxiS.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
var $f765cbc9ac8c9ec6$export$7c957416596ca127 = function experiencePayloadEvent(data) {
    return {
        type: (0, $bYxiS.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("jyh1L", function(module, exports) {

$parcel$export(module.exports, "ufolog", function () { return $e3be669d9dbdb0bd$export$b4958caff08a0960; });
$parcel$export(module.exports, "ufowarn", function () { return $e3be669d9dbdb0bd$export$d53d07b6034c4560; });

var $6QU8A = parcelRequire("6QU8A");

var $2Yk1N = parcelRequire("2Yk1N");

var $jjExS = parcelRequire("jjExS");
var $e3be669d9dbdb0bd$var$UFOLogger = /*#__PURE__*/ function() {
    function UFOLogger() {
        (0, (/*@__PURE__*/$parcel$interopDefault($6QU8A)))(this, UFOLogger);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "enabled", false);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($2Yk1N)))(UFOLogger, [
        {
            key: "log",
            value: function log() {
                var _console;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                // eslint-disable-next-line no-console
                this.enabled && (_console = console).log.apply(_console, [
                    UFOLogger.UFOprefix
                ].concat(args));
            }
        },
        {
            key: "warn",
            value: function warn() {
                var _console2;
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                // eslint-disable-next-line no-console
                this.enabled && (_console2 = console).warn.apply(_console2, [
                    UFOLogger.UFOprefix
                ].concat(args));
            }
        },
        {
            key: "enable",
            value: function enable() {
                this.enabled = true;
            }
        },
        {
            key: "disable",
            value: function disable() {
                this.enabled = false;
            }
        }
    ]);
    return UFOLogger;
}();
(0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))($e3be669d9dbdb0bd$var$UFOLogger, "UFOprefix", "[ufo\uD83D\uDEF8]");
var $e3be669d9dbdb0bd$export$4ab84f6f04f6566d = new $e3be669d9dbdb0bd$var$UFOLogger();
var $e3be669d9dbdb0bd$export$b4958caff08a0960 = function ufolog() {
    $e3be669d9dbdb0bd$export$4ab84f6f04f6566d.log.apply($e3be669d9dbdb0bd$export$4ab84f6f04f6566d, arguments);
};
var $e3be669d9dbdb0bd$export$d53d07b6034c4560 = function ufowarn() {
    $e3be669d9dbdb0bd$export$4ab84f6f04f6566d.warn.apply($e3be669d9dbdb0bd$export$4ab84f6f04f6566d, arguments);
};

});

parcelRegister("bYxiS", function(module, exports) {

$parcel$export(module.exports, "UFOGlobalEventStreamEventType", function () { return $8b7f21b2c55af819$export$96253c35c37cf96b; });
$parcel$export(module.exports, "PageVisibleState", function () { return $8b7f21b2c55af819$export$a12c67b37a306b13; });
$parcel$export(module.exports, "SUBSCRIBE_ALL", function () { return $8b7f21b2c55af819$export$79bf131685ad41d7; });
$parcel$export(module.exports, "FMP_MARK", function () { return $8b7f21b2c55af819$export$9f2bf58999404c75; });
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", function () { return $8b7f21b2c55af819$export$837e0f79a8056912; });

var $8b7f21b2c55af819$export$96253c35c37cf96b;
(function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
})($8b7f21b2c55af819$export$96253c35c37cf96b || ($8b7f21b2c55af819$export$96253c35c37cf96b = {}));
var $8b7f21b2c55af819$export$a12c67b37a306b13;
(function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
})($8b7f21b2c55af819$export$a12c67b37a306b13 || ($8b7f21b2c55af819$export$a12c67b37a306b13 = {}));
var $8b7f21b2c55af819$export$66b33c055cbb625e;
(function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
})($8b7f21b2c55af819$export$66b33c055cbb625e || ($8b7f21b2c55af819$export$66b33c055cbb625e = {}));
var $8b7f21b2c55af819$export$3ce489cbe02dc21b;
(function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
})($8b7f21b2c55af819$export$3ce489cbe02dc21b || ($8b7f21b2c55af819$export$3ce489cbe02dc21b = {}));
var $8b7f21b2c55af819$export$341b330828bd3906;
(function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
})($8b7f21b2c55af819$export$341b330828bd3906 || ($8b7f21b2c55af819$export$341b330828bd3906 = {}));
var $8b7f21b2c55af819$export$b9b20160f581e4f8;
(function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
})($8b7f21b2c55af819$export$b9b20160f581e4f8 || ($8b7f21b2c55af819$export$b9b20160f581e4f8 = {}));
var $8b7f21b2c55af819$export$79bf131685ad41d7 = "__SUBSCRIBE_ALL__";
var $8b7f21b2c55af819$export$9f2bf58999404c75 = "fmp";
var $8b7f21b2c55af819$export$837e0f79a8056912 = "inline-response";

});


parcelRegister("fE7C5", function(module, exports) {

$parcel$export(module.exports, "visibilityChangeObserver", function () { return $b6407f42ec29ea65$export$13e680397ec8f3eb; });

var $6QU8A = parcelRequire("6QU8A");

var $2Yk1N = parcelRequire("2Yk1N");

var $jjExS = parcelRequire("jjExS");

var $397CT = parcelRequire("397CT");
var $b6407f42ec29ea65$var$VisibilityChangeObserver = /*#__PURE__*/ function() {
    function VisibilityChangeObserver() {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($6QU8A)))(this, VisibilityChangeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "started", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "observers", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "broadcast", function() {
            _this.observers.forEach(function(fn) {
                return fn();
            });
            _this.observers = [];
        });
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($2Yk1N)))(VisibilityChangeObserver, [
        {
            key: "start",
            value: function start() {
                if (this.started) return;
                this.started = true;
                document.addEventListener("visibilitychange", this.broadcast);
                /**
       * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
       * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
       * so for that case, you need to also include code to listen for the pagehide event.
       */ if ((0, $397CT.isWindowObjectAvailable)()) window.addEventListener("pagehide", this.broadcast);
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                this.observers.push(callback);
            }
        },
        {
            key: "unsubscribe",
            value: function unsubscribe(callback) {
                this.observers = this.observers.filter(function(fn) {
                    return fn !== callback;
                });
            }
        }
    ]);
    return VisibilityChangeObserver;
}();
var $b6407f42ec29ea65$export$13e680397ec8f3eb = new $b6407f42ec29ea65$var$VisibilityChangeObserver();

});

parcelRegister("8ryWc", function(module, exports) {

$parcel$export(module.exports, "roundPerfNow", function () { return $625bf245248acef5$export$5f490af6b2b115cf; });
var $625bf245248acef5$export$5f490af6b2b115cf = function roundPerfNow() {
    return ~~performance.now();
};

});

parcelRegister("d5tCP", function(module, exports) {

$parcel$export(module.exports, "UFOExperienceState", function () { return $9872b8edc5c3abc3$export$81b70111112841a0; });
var $9872b8edc5c3abc3$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: "NOT_STARTED",
        final: true
    },
    STARTED: {
        id: "STARTED"
    },
    IN_PROGRESS: {
        id: "IN_PROGRESS"
    },
    BLOCKED: {
        id: "BLOCKED"
    },
    RECOVERED: {
        id: "RECOVERED"
    },
    // isn't recovered IN_PROGRESS?
    SUCCEEDED: {
        id: "SUCCEEDED",
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: "SUCCEEDED_WAITING_FOR_DEPS"
    },
    FAILED: {
        id: "FAILED",
        final: true
    },
    ABORTED: {
        id: "ABORTED",
        final: true
    }
};

});

parcelRegister("7XKNE", function(module, exports) {

$parcel$export(module.exports, "canTransition", function () { return $5cc2588ad54745cd$export$178881f329fdb81f; });

var $jjExS = parcelRequire("jjExS");

var $d5tCP = parcelRequire("d5tCP");
var $5cc2588ad54745cd$var$_UFOStateAvailableTra;
var $5cc2588ad54745cd$var$UFOStateAvailableTransitions = ($5cc2588ad54745cd$var$_UFOStateAvailableTra = {}, (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))($5cc2588ad54745cd$var$_UFOStateAvailableTra, (0, $d5tCP.UFOExperienceState).NOT_STARTED.id, [
    (0, $d5tCP.UFOExperienceState).STARTED.id
]), (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))($5cc2588ad54745cd$var$_UFOStateAvailableTra, (0, $d5tCP.UFOExperienceState).STARTED.id, [
    (0, $d5tCP.UFOExperienceState).IN_PROGRESS.id,
    (0, $d5tCP.UFOExperienceState).BLOCKED.id,
    (0, $d5tCP.UFOExperienceState).SUCCEEDED.id,
    (0, $d5tCP.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
    (0, $d5tCP.UFOExperienceState).FAILED.id,
    (0, $d5tCP.UFOExperienceState).ABORTED.id
]), (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))($5cc2588ad54745cd$var$_UFOStateAvailableTra, (0, $d5tCP.UFOExperienceState).IN_PROGRESS.id, [
    (0, $d5tCP.UFOExperienceState).BLOCKED.id,
    (0, $d5tCP.UFOExperienceState).SUCCEEDED.id,
    (0, $d5tCP.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
    (0, $d5tCP.UFOExperienceState).FAILED.id,
    (0, $d5tCP.UFOExperienceState).ABORTED.id
]), (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))($5cc2588ad54745cd$var$_UFOStateAvailableTra, (0, $d5tCP.UFOExperienceState).BLOCKED.id, [
    (0, $d5tCP.UFOExperienceState).RECOVERED.id,
    (0, $d5tCP.UFOExperienceState).ABORTED.id
]), (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))($5cc2588ad54745cd$var$_UFOStateAvailableTra, (0, $d5tCP.UFOExperienceState).RECOVERED.id, [
    (0, $d5tCP.UFOExperienceState).STARTED.id,
    (0, $d5tCP.UFOExperienceState).SUCCEEDED.id,
    (0, $d5tCP.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
    (0, $d5tCP.UFOExperienceState).FAILED.id,
    (0, $d5tCP.UFOExperienceState).ABORTED.id
]), (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))($5cc2588ad54745cd$var$_UFOStateAvailableTra, (0, $d5tCP.UFOExperienceState).SUCCEEDED.id, [
    (0, $d5tCP.UFOExperienceState).STARTED.id
]), (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))($5cc2588ad54745cd$var$_UFOStateAvailableTra, (0, $d5tCP.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id, [
    (0, $d5tCP.UFOExperienceState).SUCCEEDED.id,
    (0, $d5tCP.UFOExperienceState).FAILED.id,
    (0, $d5tCP.UFOExperienceState).ABORTED.id
]), (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))($5cc2588ad54745cd$var$_UFOStateAvailableTra, (0, $d5tCP.UFOExperienceState).FAILED.id, [
    (0, $d5tCP.UFOExperienceState).STARTED.id
]), (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))($5cc2588ad54745cd$var$_UFOStateAvailableTra, (0, $d5tCP.UFOExperienceState).ABORTED.id, [
    (0, $d5tCP.UFOExperienceState).STARTED.id
]), $5cc2588ad54745cd$var$_UFOStateAvailableTra);
var $5cc2588ad54745cd$export$178881f329fdb81f = function canTransition(state1, state2) {
    return $5cc2588ad54745cd$var$UFOStateAvailableTransitions[state1.id] && $5cc2588ad54745cd$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});






parcelRegister("5sy5L", function(module, exports) {

$parcel$export(module.exports, "FD_CLIENT_FETCH_PROPS", function () { return $3f9a033c44401821$export$c270c412a04ff3e6; });
$parcel$export(module.exports, "default", function () { return $3f9a033c44401821$export$2e2bcd8739ae039; });

var $e8dor = parcelRequire("e8dor");

var $6QU8A = parcelRequire("6QU8A");

var $2Yk1N = parcelRequire("2Yk1N");

var $jjExS = parcelRequire("jjExS");

var $fGIeY = parcelRequire("fGIeY");

var $cAUYO = parcelRequire("cAUYO");

var $5PGLG = parcelRequire("5PGLG");
var $3f9a033c44401821$var$RECENT_WORK_ARTIFACT = "recent-work-service";
var $3f9a033c44401821$var$FD_ENVIRONMENT = "prod";
var $3f9a033c44401821$export$c270c412a04ff3e6 = {
    name: $3f9a033c44401821$var$RECENT_WORK_ARTIFACT,
    dimensions: {
        environmentType: $3f9a033c44401821$var$FD_ENVIRONMENT
    }
};
var $3f9a033c44401821$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function HydratorConfigClient(handlers, product, artifactFetch) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($6QU8A)))(this, HydratorConfigClient);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "fetchConfig", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($e8dor)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).mark(function _callee() {
            var artifact, fragments, hydrators;
            return (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        _context.next = 2;
                        return _this.fetchArtifact();
                    case 2:
                        artifact = _context.sent;
                        fragments = artifact.queryFragments, hydrators = artifact.hydrators;
                        return _context.abrupt("return", {
                            fragments: fragments,
                            hydrators: hydrators
                        });
                    case 5:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        })));
        this.flightDeck = new (0, $cAUYO.default)(product || "recent-work-client", {
            handlers: handlers
        }, [
            {
                name: "recent-work-service",
                dimensions: {
                    environmentType: $3f9a033c44401821$var$FD_ENVIRONMENT
                },
                value: (0, $5PGLG.default)
            }
        ]);
        this.artifactFetch = artifactFetch;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($2Yk1N)))(HydratorConfigClient, [
        {
            key: "fetchArtifact",
            value: function() {
                var _fetchArtifact = (0, (/*@__PURE__*/$parcel$interopDefault($e8dor)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).mark(function _callee2() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                if (!this.artifactFetch) {
                                    _context2.next = 2;
                                    break;
                                }
                                return _context2.abrupt("return", this.artifactFetch());
                            case 2:
                                return _context2.abrupt("return", this.flightDeck.fetchConfigFromFlightDeck($3f9a033c44401821$export$c270c412a04ff3e6, // Retries are for the background refresh, so not too aggressive
                                {
                                    intervalsMS: [
                                        100,
                                        500
                                    ]
                                }));
                            case 3:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function fetchArtifact() {
                    return _fetchArtifact.apply(this, arguments);
                }
                return fetchArtifact;
            }()
        }
    ]);
    return HydratorConfigClient;
}();

});
parcelRegister("5PGLG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $43f2e40793192785$export$2e2bcd8739ae039; });
var $43f2e40793192785$export$2e2bcd8739ae039 = {
    localization: {
        eventTypes: {
            commented: {
                absolute: "You commented on {absoluteTime}",
                relative: "You commented {relativeTime}",
                standalone: "You commented",
                multiAbsolute: "Commented on {absoluteTime}",
                multiRelative: "Commented {relativeTime}",
                multiStandalone: "Commented"
            },
            created: {
                absolute: "You created on {absoluteTime}",
                relative: "You created {relativeTime}",
                standalone: "You created",
                multiAbsolute: "Created on {absoluteTime}",
                multiRelative: "Created {relativeTime}",
                multiStandalone: "Created"
            },
            edited: {
                absolute: "You edited on {absoluteTime}",
                relative: "You edited {relativeTime}",
                standalone: "You edited",
                multiAbsolute: "Edited on {absoluteTime}",
                multiRelative: "Edited {relativeTime}",
                multiStandalone: "Edited"
            },
            published: {
                absolute: "You published on {absoluteTime}",
                relative: "You published {relativeTime}",
                standalone: "You published",
                multiAbsolute: "Published on {absoluteTime}",
                multiRelative: "Published {relativeTime}",
                multiStandalone: "Published"
            },
            updated: {
                absolute: "You updated on {absoluteTime}",
                relative: "You updated {relativeTime}",
                standalone: "You updated",
                multiAbsolute: "Updated on {absoluteTime}",
                multiRelative: "Updated {relativeTime}",
                multiStandalone: "Updated"
            },
            viewed: {
                absolute: "You viewed on {absoluteTime}",
                relative: "You viewed {relativeTime}",
                standalone: "You viewed",
                multiAbsolute: "Viewed on {absoluteTime}",
                multiRelative: "Viewed {relativeTime}",
                multiStandalone: "Viewed"
            }
        }
    },
    hydrators: {
        TownsquareGoal: {
            hydratorPaths: {
                id: [
                    "id"
                ],
                key: [
                    "key"
                ],
                name: [
                    "name"
                ],
                url: [
                    "url"
                ],
                icon: [
                    "iconData"
                ]
            }
        },
        TownsquareProject: {
            hydratorPaths: {
                id: [
                    "id"
                ],
                key: [
                    "key"
                ],
                name: [
                    "name"
                ],
                url: [
                    "url"
                ],
                icon: [
                    "iconData"
                ]
            }
        },
        TownsquareComment: {
            hydratorPaths: {
                id: [
                    "id"
                ],
                key: [
                    "container.key"
                ],
                name: [
                    "container.name"
                ],
                url: [
                    "container.url"
                ],
                icon: [
                    "container.iconData"
                ],
                deduplicateId: [
                    "container.id"
                ]
            }
        },
        ConfluencePage: {
            hydratorPaths: {
                id: [
                    "id"
                ],
                name: [
                    "title"
                ],
                localResourceId: [
                    "pageId"
                ],
                url: [
                    "links.base",
                    "links.webUi"
                ],
                containers: [
                    "space.name"
                ]
            },
            staticFallbacks: {
                icon: "https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg"
            }
        },
        ConfluenceBlogPost: {
            hydratorPaths: {
                id: [
                    "id"
                ],
                name: [
                    "title"
                ],
                localResourceId: [
                    "blogPostId"
                ],
                url: [
                    "links.base",
                    "links.webUi"
                ],
                containers: [
                    "space.name"
                ]
            },
            staticFallbacks: {
                icon: "https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/blogpost.svg"
            }
        },
        ConfluenceComment: {
            hydratorPaths: {
                id: [
                    "id"
                ],
                name: [
                    "container.title"
                ],
                url: [
                    "links.base",
                    "links.webUi"
                ],
                containers: [
                    "container.space.name"
                ],
                deduplicateId: [
                    "container.id"
                ]
            },
            staticFallbacks: {
                icon: "https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg",
                confluenceBlogIcon: "https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/blogpost.svg",
                confluencePageIcon: "https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg"
            }
        },
        ConfluenceFooterComment: {
            hydratorPaths: {
                id: [
                    "id"
                ],
                name: [
                    "container.title"
                ],
                url: [
                    "links.base",
                    "links.webUi"
                ],
                containers: [
                    "container.space.name"
                ],
                deduplicateId: [
                    "container.id"
                ]
            },
            staticFallbacks: {
                icon: "https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg",
                confluenceBlogIcon: "https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/blogpost.svg",
                confluencePageIcon: "https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg"
            }
        },
        ConfluenceInlineComment: {
            hydratorPaths: {
                id: [
                    "id"
                ],
                name: [
                    "container.title"
                ],
                url: [
                    "links.base",
                    "links.webUi"
                ],
                containers: [
                    "container.space.name"
                ],
                deduplicateId: [
                    "container.id"
                ]
            },
            staticFallbacks: {
                icon: "https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg",
                confluenceBlogIcon: "https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/blogpost.svg",
                confluencePageIcon: "https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg"
            }
        },
        JiraIssue: {
            hydratorPaths: {
                id: [
                    "id"
                ],
                name: [
                    'fieldsById.edges(node.fieldId: "summary").node.text'
                ],
                url: [
                    "webUrl"
                ],
                containers: [
                    'fieldsById.edges(node.fieldId: "project").node.project.name'
                ],
                icon: [
                    'fieldsById.edges(node.fieldId: "issuetype").node.issueType.avatar.xsmall'
                ],
                key: [
                    "key"
                ]
            }
        },
        JiraPlatformComment: {
            hydratorPaths: {
                id: [
                    "commentId"
                ],
                name: [
                    'issue.fieldsById.edges(node.fieldId: "summary").node.text'
                ],
                url: [
                    "webUrl"
                ],
                containers: [
                    'issue.fieldsById.edges(node.fieldId: "project").node.project.name'
                ],
                icon: [
                    'issue.fieldsById.edges(node.fieldId: "issuetype").node.issueType.avatar.xsmall'
                ],
                key: [
                    "issue.key"
                ],
                deduplicateId: [
                    "issue.id"
                ]
            }
        },
        JiraServiceManagementComment: {
            hydratorPaths: {
                id: [
                    "commentId"
                ],
                name: [
                    'issue.fieldsById.edges(node.fieldId: "summary").node.text'
                ],
                url: [
                    "webUrl"
                ],
                containers: [
                    'issue.fieldsById.edges(node.fieldId: "project").node.project.name'
                ],
                icon: [
                    'issue.fieldsById.edges(node.fieldId: "issuetype").node.issueType.avatar.xsmall'
                ],
                key: [
                    "issue.key"
                ],
                deduplicateId: [
                    "issue.id"
                ]
            }
        }
    },
    queryFragments: '\n\n  fragment townsquareGoal on TownsquareGoal {\n    id\n    key\n    name\n    url\n    iconData\n  }\n\n\n  fragment townsquareProject on TownsquareProject {\n    id\n    key\n    name\n    url\n    iconData\n  }\n\n\n  fragment townsquareComment on TownsquareComment {\n    id\n    url\n    container {\n      __typename\n      ...townsquareGoal\n      ...townsquareProject\n    }\n  }\n\n\n  fragment confluencePage on ConfluencePage {\n    id\n    title\n    pageId\n    links {\n      base\n      webUi\n    }\n    space {\n      name\n    }\n  }\n\n\n  fragment confluenceBlogPost on ConfluenceBlogPost {\n    id\n    title\n    blogPostId\n    links {\n      base\n      webUi\n    }\n    space {\n      name\n    }\n  }\n\n\n  fragment confluenceComment on ConfluenceComment {\n    id\n    links {\n      base\n      webUi\n    }\n    container {\n      __typename\n      ...confluenceBlogPost\n      ...confluencePage\n    }\n  }\n\n\n  fragment confluenceFooterComment on ConfluenceFooterComment {\n    id\n    links {\n      base\n      webUi\n    }\n    container {\n      __typename\n      ...confluenceBlogPost\n      ...confluencePage\n    }\n  }\n\n\n  fragment confluenceInlineComment on ConfluenceInlineComment {\n    id\n    links {\n      base\n      webUi\n    }\n    container {\n      __typename\n      ...confluenceBlogPost\n      ...confluencePage\n    }\n  }\n\n\nfragment jiraIssue on JiraIssue {\n  id\n  key\n  webUrl\n  fieldsById(ids: ["summary", "issuetype", "project"]) {\n    edges {\n      node {\n        __typename\n        fieldId\n        ...jiraSingleLineTextField\n        ...jiraIssueTypeField\n        ...jiraProjectField\n      }\n    }\n  }\n}\nfragment jiraSingleLineTextField on JiraSingleLineTextField {\n  text\n}\nfragment jiraIssueTypeField on JiraIssueTypeField {\n  issueType {\n    avatar {\n      xsmall\n    }\n  }\n}\nfragment jiraProjectField on JiraProjectField {\n  project {\n    name\n  }\n}\n\n\nfragment jiraPlatformComment on JiraPlatformComment {\n  commentId\n  webUrl\n  issue {\n    ...jiraIssue\n  }\n}\n\n\nfragment jiraServiceManagementComment on JiraServiceManagementComment {\n  commentId\n  webUrl\n  issue {\n    ...jiraIssue\n  }\n}\n\nfragment activityItemEdge on ActivityItemEdge {\n  cursor\n  node {\n    id\n    object {\n      id\n      type\n      product\n      subProduct\n      rootContainerId\n      contributors {\n        profile {\n          name\n          picture\n          accountId\n        }\n      }\n      data {\n        __typename\n	...townsquareGoal\n	...townsquareProject\n	...townsquareComment\n	...confluencePage\n	...confluenceBlogPost\n	...confluenceComment\n	...confluenceFooterComment\n	...confluenceInlineComment\n	...jiraIssue\n	...jiraPlatformComment\n	...jiraServiceManagementComment\n      }\n    }\n    event {\n      id\n      timestamp\n      eventType\n      actor {\n        name\n        picture\n        accountId\n      }\n    }\n  }\n}\nfragment activityItemConnection on ActivityConnection {\n  edges {\n    ...activityItemEdge\n  }\n}\n\n'
};

});


parcelRegister("eLNCI", function(module, exports) {

$parcel$export(module.exports, "createActivityClient", function () { return $ac0bf2a39f5dba1b$export$224367b01f71f2aa; });

var $fYpvx = parcelRequire("fYpvx");

var $j5Mot = parcelRequire("j5Mot");
var $ac0bf2a39f5dba1b$var$previousClientVersion;
var $ac0bf2a39f5dba1b$export$224367b01f71f2aa = function createActivityClient(version, product, logger, baseUrl, configFetch) {
    if ($ac0bf2a39f5dba1b$var$previousClientVersion && $ac0bf2a39f5dba1b$var$previousClientVersion !== version && logger !== null && logger !== void 0 && logger.captureWarning) logger.captureWarning("ActivityClient version has changed, is this intentional?");
    $ac0bf2a39f5dba1b$var$previousClientVersion = version || "v3";
    if (version === "v2") return new (0, $fYpvx.ActivityClientV2)(product, baseUrl);
    return new (0, $j5Mot.ActivityClientV3)(product, baseUrl, logger, configFetch);
};

});
parcelRegister("fYpvx", function(module, exports) {

$parcel$export(module.exports, "ActivityClientV2", function () { return $ba103ee3d257b8a8$export$330ab0047f2fb745; });

var $e8dor = parcelRequire("e8dor");

var $2Yk1N = parcelRequire("2Yk1N");

var $6QU8A = parcelRequire("6QU8A");

var $hgJzq = parcelRequire("hgJzq");

var $eZhUW = parcelRequire("eZhUW");

var $kcuts = parcelRequire("kcuts");

var $6pDhi = parcelRequire("6pDhi");

var $jjExS = parcelRequire("jjExS");

var $fGIeY = parcelRequire("fGIeY");

var $a0gqW = parcelRequire("a0gqW");

var $7lDUt = parcelRequire("7lDUt");

var $8yY79 = parcelRequire("8yY79");
function $ba103ee3d257b8a8$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $ba103ee3d257b8a8$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($6pDhi)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($6pDhi)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($kcuts)))(this, result);
    };
}
function $ba103ee3d257b8a8$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $ba103ee3d257b8a8$export$330ab0047f2fb745 = /*#__PURE__*/ function(_ActivityClient) {
    (0, (/*@__PURE__*/$parcel$interopDefault($eZhUW)))(ActivityClientV2, _ActivityClient);
    var _super = $ba103ee3d257b8a8$var$_createSuper(ActivityClientV2);
    function ActivityClientV2(_product, baseUrl) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($6QU8A)))(this, ActivityClientV2);
        _this = _super.call(this, "v2", _product, undefined, baseUrl);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))((0, (/*@__PURE__*/$parcel$interopDefault($hgJzq)))(_this), "fetchActivities", /*#__PURE__*/ function() {
            var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($e8dor)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).mark(function _callee(retryMS, filters, activityQueries) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            return _context.abrupt("return", (0, $a0gqW.fetchActivitiesWithExperience)(function(experience) {
                                return (0, $8yY79.fetchActivitiesV2)({
                                    experience: experience,
                                    product: _this.product,
                                    retryMS: retryMS,
                                    filters: filters,
                                    activityQueries: activityQueries,
                                    baseUrl: _this.baseUrl
                                });
                            }, "v2"));
                        case 1:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }));
            return function(_x, _x2, _x3) {
                return _ref.apply(this, arguments);
            };
        }());
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))((0, (/*@__PURE__*/$parcel$interopDefault($hgJzq)))(_this), "setProduct", function(product) {
            _this.product = product;
        });
        return _this;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($2Yk1N)))(ActivityClientV2);
}((0, $7lDUt.ActivityClient));

});
parcelRegister("a0gqW", function(module, exports) {

$parcel$export(module.exports, "fetchActivitiesWithExperience", function () { return $7486a6cfe7608c61$export$4a906f16800734f3; });

var $jjExS = parcelRequire("jjExS");

var $e8dor = parcelRequire("e8dor");

var $fGIeY = parcelRequire("fGIeY");

var $fM9he = parcelRequire("fM9he");

var $lyMYQ = parcelRequire("lyMYQ");

var $3p2sj = parcelRequire("3p2sj");
function $7486a6cfe7608c61$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $7486a6cfe7608c61$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $7486a6cfe7608c61$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $7486a6cfe7608c61$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $7486a6cfe7608c61$export$4a906f16800734f3(_x, _x2) {
    return $7486a6cfe7608c61$var$_fetchActivitiesWithExperience.apply(this, arguments);
}
function $7486a6cfe7608c61$var$_fetchActivitiesWithExperience() {
    $7486a6cfe7608c61$var$_fetchActivitiesWithExperience = (0, (/*@__PURE__*/$parcel$interopDefault($e8dor)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).mark(function _callee(fetchActivities, clientVersion) {
        var experience, data;
        return (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    experience = clientVersion === "v2" ? (0, $3p2sj.recentWorkClientExperienceV2)() : (0, $3p2sj.recentWorkClientExperienceV3)();
                    _context.prev = 1;
                    experience.start();
                    experience.addMetadata({
                        clientVersion: clientVersion,
                        packageName: (0, $lyMYQ.packageName),
                        packageVersion: (0, $lyMYQ.packageVersion)
                    });
                    _context.next = 6;
                    return fetchActivities(experience);
                case 6:
                    data = _context.sent;
                    experience.success();
                    return _context.abrupt("return", data);
                case 11:
                    _context.prev = 11;
                    _context.t0 = _context["catch"](1);
                    experience.failure({
                        metadata: {
                            error: $7486a6cfe7608c61$export$f33622abb5224195(_context.t0)
                        }
                    });
                    throw _context.t0;
                case 15:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                1,
                11
            ]
        ]);
    }));
    return $7486a6cfe7608c61$var$_fetchActivitiesWithExperience.apply(this, arguments);
}
var $7486a6cfe7608c61$export$f33622abb5224195 = function exceptionToMetadata(e) {
    if (e instanceof (0, $fM9he.default)) {
        var _e$xRequestId;
        return $7486a6cfe7608c61$var$_objectSpread($7486a6cfe7608c61$var$_objectSpread({}, e), {}, {
            xRequestId: (_e$xRequestId = e.xRequestId) !== null && _e$xRequestId !== void 0 ? _e$xRequestId : undefined,
            cause: undefined
        });
    }
    return e instanceof Error ? $7486a6cfe7608c61$var$_objectSpread($7486a6cfe7608c61$var$_objectSpread({}, e), {}, {
        cause: undefined
    }) : "unknown";
};

});
parcelRegister("fM9he", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b7c288e7d55575d9$export$2e2bcd8739ae039; });

var $2Yk1N = parcelRequire("2Yk1N");

var $6QU8A = parcelRequire("6QU8A");

var $eZhUW = parcelRequire("eZhUW");

var $kcuts = parcelRequire("kcuts");

var $6pDhi = parcelRequire("6pDhi");

var $8B3ag = parcelRequire("8B3ag");
function $b7c288e7d55575d9$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $b7c288e7d55575d9$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($6pDhi)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($6pDhi)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($kcuts)))(this, result);
    };
}
function $b7c288e7d55575d9$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $b7c288e7d55575d9$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Error) {
    (0, (/*@__PURE__*/$parcel$interopDefault($eZhUW)))(HttpError, _Error);
    var _super = $b7c288e7d55575d9$var$_createSuper(HttpError);
    function HttpError(_ref) {
        var _this;
        var message = _ref.message, statusCode = _ref.statusCode, path = _ref.path, method = _ref.method, xRequestId = _ref.xRequestId, headers = _ref.headers;
        (0, (/*@__PURE__*/$parcel$interopDefault($6QU8A)))(this, HttpError);
        _this = _super.call(this);
        _this.name = "HttpError";
        _this.message = message;
        var p = path.split("?")[0];
        _this.path = /^[/-a-z]+$/i.test(p) ? p : "";
        _this.method = method;
        _this.statusCode = statusCode;
        _this.xRequestId = xRequestId;
        _this.headers = Array.from(headers.entries()).map(function(value, key) {
            return "".concat(key, ":").concat(value);
        }).sort().join(",");
        return _this;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($2Yk1N)))(HttpError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8B3ag)))(Error));
var $b7c288e7d55575d9$export$97b788730ba59845 = function isHttpError(e) {
    return e instanceof $b7c288e7d55575d9$export$2e2bcd8739ae039;
};

});

parcelRegister("lyMYQ", function(module, exports) {

$parcel$export(module.exports, "packageName", function () { return $fb22c46bdd6f1a70$export$9345d7360ffe0722; });
$parcel$export(module.exports, "packageVersion", function () { return $fb22c46bdd6f1a70$export$91546b032799aa40; });
var $fb22c46bdd6f1a70$export$9345d7360ffe0722 = "@atlassian/recent-work-client";
var $fb22c46bdd6f1a70$export$91546b032799aa40 = "1.8.5";

});

parcelRegister("3p2sj", function(module, exports) {

$parcel$export(module.exports, "recentWorkClientExperienceV2", function () { return $27a59c894a61c134$export$d7769758f5eaa63b; });
$parcel$export(module.exports, "recentWorkClientExperienceV3", function () { return $27a59c894a61c134$export$9e32a4ed888f4717; });

var $kqNHG = parcelRequire("kqNHG");
var $8Dq1b = parcelRequire("8Dq1b");
var $27a59c894a61c134$var$keyToTiming = function keyToTiming(key) {
    return {
        key: key,
        startMark: "".concat(key, "_start"),
        endMark: "".concat(key, "_end")
    };
};
var $27a59c894a61c134$var$timings = [
    "FetchedActivities",
    "TransformedActivityItems",
    "GeneratedQueryWithFilters"
].map($27a59c894a61c134$var$keyToTiming);
var $27a59c894a61c134$export$d7769758f5eaa63b = function recentWorkClientExperienceV2() {
    return new (0, $8Dq1b.UFOExperience)("client", {
        type: (0, $kqNHG.ExperienceTypes).Load,
        performanceType: (0, $kqNHG.ExperiencePerformanceTypes).Custom,
        platform: {
            component: "recent-work"
        },
        timings: $27a59c894a61c134$var$timings
    });
};
var $27a59c894a61c134$export$9e32a4ed888f4717 = function recentWorkClientExperienceV3() {
    return new (0, $8Dq1b.UFOExperience)("client-v3", {
        type: (0, $kqNHG.ExperienceTypes).Load,
        performanceType: (0, $kqNHG.ExperiencePerformanceTypes).Custom,
        platform: {
            component: "recent-work"
        },
        timings: $27a59c894a61c134$var$timings
    });
};

});
parcelRegister("kqNHG", function(module, exports) {

$parcel$export(module.exports, "ExperienceTypes", function () { return $edfcca712d0be524$export$994164cf3ae1cc9a; });
$parcel$export(module.exports, "ExperiencePerformanceTypes", function () { return $edfcca712d0be524$export$cc26007c03242fff; });
var $edfcca712d0be524$export$994164cf3ae1cc9a = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var $edfcca712d0be524$export$cc26007c03242fff = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});

});

parcelRegister("8Dq1b", function(module, exports) {

$parcel$export(module.exports, "UFOExperience", function () { return $649625e08be402e6$export$c00d22927c60484a; });

var $2Yk1N = parcelRequire("2Yk1N");

var $6QU8A = parcelRequire("6QU8A");

var $eZhUW = parcelRequire("eZhUW");

var $kcuts = parcelRequire("kcuts");

var $6pDhi = parcelRequire("6pDhi");

var $6OVVR = parcelRequire("6OVVR");
function $649625e08be402e6$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $649625e08be402e6$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($6pDhi)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($6pDhi)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($kcuts)))(this, result);
    };
}
function $649625e08be402e6$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $649625e08be402e6$export$c00d22927c60484a = /*#__PURE__*/ function(_UFOAbstractExperienc) {
    (0, (/*@__PURE__*/$parcel$interopDefault($eZhUW)))(UFOExperience, _UFOAbstractExperienc);
    var _super = $649625e08be402e6$var$_createSuper(UFOExperience);
    function UFOExperience() {
        (0, (/*@__PURE__*/$parcel$interopDefault($6QU8A)))(this, UFOExperience);
        return _super.apply(this, arguments);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($2Yk1N)))(UFOExperience);
}((0, $6OVVR.UFOAbstractExperience));

});
parcelRegister("6OVVR", function(module, exports) {

$parcel$export(module.exports, "UFOAbstractExperience", function () { return $4f7459b88048369d$export$d31c89db257648c; });

var $eetQ9 = parcelRequire("eetQ9");

var $e8dor = parcelRequire("e8dor");

var $6QU8A = parcelRequire("6QU8A");

var $2Yk1N = parcelRequire("2Yk1N");

var $jjExS = parcelRequire("jjExS");

var $fGIeY = parcelRequire("fGIeY");

var $7Tx2g = parcelRequire("7Tx2g");

var $db09C = parcelRequire("db09C");

var $aHgIf = parcelRequire("aHgIf");

var $3gJ2A = parcelRequire("3gJ2A");

var $1qEbR = parcelRequire("1qEbR");

var $hRkSu = parcelRequire("hRkSu");

var $kJabx = parcelRequire("kJabx");

var $2LWZL = parcelRequire("2LWZL");

var $abQpr = parcelRequire("abQpr");

var $k3mVC = parcelRequire("k3mVC");

var $kqNHG = parcelRequire("kqNHG");
function $4f7459b88048369d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4f7459b88048369d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $4f7459b88048369d$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $4f7459b88048369d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $4f7459b88048369d$var$getPageVisibleState = function getPageVisibleState() {
    return !(0, $aHgIf.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === "visible" ? (0, $kJabx.PageVisibleState).VISIBLE : (0, $kJabx.PageVisibleState).HIDDEN;
};
var $4f7459b88048369d$export$c753e8669d30c8ad = function perfNowOrTimestamp(timestamp) {
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $2LWZL.roundPerfNow)();
};
var $4f7459b88048369d$export$d31c89db257648c = /*#__PURE__*/ function() {
    function UFOAbstractExperience(id, config) {
        var _this = this;
        var instanceId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        (0, (/*@__PURE__*/$parcel$interopDefault($6QU8A)))(this, UFOAbstractExperience);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "state", (0, $abQpr.UFOExperienceState).NOT_STARTED);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "instanceId", null);
        // for concurrent
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "parent", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "category", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "metadata", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "onDoneCallbacks", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "childExperiences", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "explicitTimings", {});
        // @todo move to page load experience when proper classes/inheritance prepared
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "isSSROutputAsFMP", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "uuid", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_until", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "metrics", {
            startTime: null,
            endTime: null,
            marks: []
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "performanceConfig", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "setPageVisibleStateToMixed", function() {
            _this.pageVisibleState = (0, $kJabx.PageVisibleState).MIXED;
            (0, $hRkSu.visibilityChangeObserver).unsubscribe(_this.setPageVisibleStateToMixed);
        });
        this.id = id;
        this.category = (config === null || config === void 0 ? void 0 : config.category) || null;
        this.until = (config === null || config === void 0 ? void 0 : config.until) || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $4f7459b88048369d$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $kqNHG.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $kqNHG.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($2Yk1N)))(UFOAbstractExperience, [
        {
            key: "transition",
            value: function() {
                var _transition = (0, (/*@__PURE__*/$parcel$interopDefault($e8dor)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).mark(function _callee(newState, timestamp) {
                    var data;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                (0, $1qEbR.ufolog)("async transition", this.id, this.state.id, newState.id);
                                if (!(0, $k3mVC.canTransition)(this.state, newState)) {
                                    _context.next = 15;
                                    break;
                                }
                                (0, $1qEbR.ufolog)("TRANSITION: ".concat(this.id, " from ").concat(this.state.id, " to ").concat(newState.id, " successful"), this.state.final, !newState.final);
                                if (newState === (0, $abQpr.UFOExperienceState).STARTED) this._reset();
                                if (this.state.final && !newState.final) {
                                    this.metrics.startTime = $4f7459b88048369d$export$c753e8669d30c8ad(timestamp);
                                    this.uuid = (0, $7Tx2g.v4)();
                                }
                                this.state = newState;
                                if (!newState.final) {
                                    _context.next = 14;
                                    break;
                                }
                                this.metrics.endTime = $4f7459b88048369d$export$c753e8669d30c8ad(timestamp);
                                if (!this._isManualStateEnabled()) (0, $3gJ2A.getGlobalEventStream)().push((0, $3gJ2A.unsubscribeEvent)((0, $kJabx.SUBSCRIBE_ALL), this.handleDoneBind));
                                _context.next = 11;
                                return this.exportData();
                            case 11:
                                data = _context.sent;
                                (0, $1qEbR.ufolog)("this.parent", this.parent);
                                (0, $3gJ2A.getGlobalEventStream)().push((0, $3gJ2A.experiencePayloadEvent)(data));
                            case 14:
                                return _context.abrupt("return", true);
                            case 15:
                                (0, $1qEbR.ufolog)("TRANSITION: ".concat(this.id, " from ").concat(this.state.id, " to ").concat(newState.id, " unsuccessful"));
                                (0, $1qEbR.ufowarn)("transition of ".concat(this.id, " from ").concat(this.state, " to ").concat(newState, " is not possible"));
                                return _context.abrupt("return", false);
                            case 18:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function transition(_x, _x2) {
                    return _transition.apply(this, arguments);
                }
                return transition;
            }()
        },
        {
            key: "start",
            value: function() {
                var _start = (0, (/*@__PURE__*/$parcel$interopDefault($e8dor)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).mark(function _callee2(startTime) {
                    var transitionSuccessful;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 2;
                                return this.transition((0, $abQpr.UFOExperienceState).STARTED, startTime);
                            case 2:
                                transitionSuccessful = _context2.sent;
                                if (transitionSuccessful) {
                                    this.pageVisibleState = $4f7459b88048369d$var$getPageVisibleState();
                                    (0, $hRkSu.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
                                    if (!this._isManualStateEnabled()) {
                                        (0, $1qEbR.ufolog)("subscribed", this.id);
                                        (0, $3gJ2A.getGlobalEventStream)().push((0, $3gJ2A.subscribeEvent)((0, $kJabx.SUBSCRIBE_ALL), this.handleDoneBind));
                                    }
                                }
                            case 4:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function start(_x3) {
                    return _start.apply(this, arguments);
                }
                return start;
            }()
        },
        {
            key: "mark",
            value: function mark(name, timestamp) {
                if (name !== (0, $kJabx.FMP_MARK) && name !== (0, $kJabx.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
                else (0, $1qEbR.ufowarn)("please use markFMP or markInlineResponse for specialised marks");
            }
        },
        {
            key: "_mark",
            value: function _mark(name, timestamp) {
                this.metrics.marks.push({
                    name: name,
                    time: $4f7459b88048369d$export$c753e8669d30c8ad(timestamp)
                });
                this.transition((0, $abQpr.UFOExperienceState).IN_PROGRESS);
            }
        },
        {
            key: "markFMP",
            value: function markFMP(timestamp) {
                this._mark((0, $kJabx.FMP_MARK), timestamp);
            }
        },
        {
            key: "markInlineResponse",
            value: function markInlineResponse(timestamp) {
                this._mark((0, $kJabx.INLINE_RESPONSE_MARK), timestamp);
            }
        },
        {
            key: "_isManualStateEnabled",
            value: function _isManualStateEnabled() {
                return this.until === null;
            }
        },
        {
            key: "_validateManualState",
            value: function _validateManualState() {
                if (!this._isManualStateEnabled()) {
                    (0, $1qEbR.ufowarn)('manual change of state not allowed as "until" is defined');
                    return false;
                }
                return true;
            }
        },
        {
            key: "switchToEndState",
            value: function switchToEndState(state, config) {
                if (!(config !== null && config !== void 0 && config.force) && !this._validateManualState()) return null;
                if (config !== null && config !== void 0 && config.metadata) this.addMetadata(config.metadata);
                (0, $hRkSu.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
                return this.transition(state);
            }
        },
        {
            key: "success",
            value: function() {
                var _success = (0, (/*@__PURE__*/$parcel$interopDefault($e8dor)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).mark(function _callee3(config) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", this.switchToEndState((0, $abQpr.UFOExperienceState).SUCCEEDED, config));
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function success(_x4) {
                    return _success.apply(this, arguments);
                }
                return success;
            }()
        },
        {
            key: "failure",
            value: function() {
                var _failure = (0, (/*@__PURE__*/$parcel$interopDefault($e8dor)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).mark(function _callee4(config) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                return _context4.abrupt("return", this.switchToEndState((0, $abQpr.UFOExperienceState).FAILED, config));
                            case 1:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function failure(_x5) {
                    return _failure.apply(this, arguments);
                }
                return failure;
            }()
        },
        {
            key: "abort",
            value: function() {
                var _abort = (0, (/*@__PURE__*/$parcel$interopDefault($e8dor)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).mark(function _callee5(config) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                return _context5.abrupt("return", this.switchToEndState((0, $abQpr.UFOExperienceState).ABORTED, config));
                            case 1:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function abort(_x6) {
                    return _abort.apply(this, arguments);
                }
                return abort;
            }()
        },
        {
            key: "addMetadata",
            value: function addMetadata(data) {
                Object.assign(this.metadata, data);
            }
        },
        {
            key: "_handleDoneExperience",
            value: function _handleDoneExperience(data) {
                (0, $1qEbR.ufolog)("_handleDoneExperience in", this.id, data.state, data, this._until);
                if (data.state.final) {
                    if (this._until !== null) {
                        var _this$_until = this._until(data), done = _this$_until.done, state = _this$_until.state;
                        if (done && !this.state.final) this.transition(state);
                    }
                }
            }
        },
        {
            key: "getId",
            value: function() {
                var _getId = (0, (/*@__PURE__*/$parcel$interopDefault($e8dor)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).mark(function _callee6() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                return _context6.abrupt("return", this.id);
                            case 1:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function getId() {
                    return _getId.apply(this, arguments);
                }
                return getId;
            }()
        },
        {
            key: "exportData",
            value: function() {
                var _exportData = (0, (/*@__PURE__*/$parcel$interopDefault($e8dor)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).mark(function _callee7() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                _context7.next = 2;
                                return this.getId();
                            case 2:
                                _context7.t0 = _context7.sent;
                                _context7.t1 = this.uuid;
                                _context7.t2 = this.type;
                                _context7.t3 = (0, $db09C.UFO_EXPERIMENTAL_BUILD_VERSION) || "unknown";
                                _context7.t4 = this.performanceType;
                                _context7.t5 = this.category;
                                _context7.t6 = this.state;
                                _context7.t7 = $4f7459b88048369d$var$_objectSpread({}, this.metadata);
                                _context7.t8 = $4f7459b88048369d$var$_objectSpread({}, this.metrics);
                                _context7.t9 = (0, (/*@__PURE__*/$parcel$interopDefault($eetQ9)))(this.childExperiences);
                                _context7.t10 = {
                                    success: !!this.state.success,
                                    startTime: this.metrics.startTime,
                                    duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
                                };
                                _context7.t11 = this.config.platform || null;
                                _context7.t12 = this.pageVisibleState;
                                _context7.t13 = this.featureFlags;
                                _context7.t14 = this.isSSROutputAsFMP;
                                _context7.t15 = this.timings;
                                _context7.t16 = this.explicitTimings;
                                _context7.t17 = this.performanceConfig;
                                return _context7.abrupt("return", {
                                    id: _context7.t0,
                                    uuid: _context7.t1,
                                    type: _context7.t2,
                                    schemaVersion: _context7.t3,
                                    performanceType: _context7.t4,
                                    category: _context7.t5,
                                    state: _context7.t6,
                                    metadata: _context7.t7,
                                    metrics: _context7.t8,
                                    children: _context7.t9,
                                    result: _context7.t10,
                                    platform: _context7.t11,
                                    pageVisibleState: _context7.t12,
                                    featureFlags: _context7.t13,
                                    isSSROutputAsFMP: _context7.t14,
                                    timings: _context7.t15,
                                    explicitTimings: _context7.t16,
                                    performanceConfig: _context7.t17
                                });
                            case 21:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function exportData() {
                    return _exportData.apply(this, arguments);
                }
                return exportData;
            }()
        },
        {
            key: "_reset",
            value: function _reset() {
                this.parent = null;
                this.metadata = {};
                this.onDoneCallbacks = [];
                this.childExperiences = [];
                this.metrics = {
                    startTime: null,
                    endTime: null,
                    marks: []
                };
                this._until = this.until ? this.until() : null;
            }
        }
    ]);
    return UFOAbstractExperience;
}();

});
parcelRegister("7Tx2g", function(module, exports) {

var $b9Zqz = parcelRequire("b9Zqz");

var $7PESE = parcelRequire("7PESE");
var $5bf74ba4de083968$var$uuid = $7PESE;
$5bf74ba4de083968$var$uuid.v1 = $b9Zqz;
$5bf74ba4de083968$var$uuid.v4 = $7PESE;
module.exports = $5bf74ba4de083968$var$uuid;

});
parcelRegister("b9Zqz", function(module, exports) {

var $aNFH1 = parcelRequire("aNFH1");

var $hhsbW = parcelRequire("hhsbW");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $82002f37cbf5465a$var$_nodeId;
var $82002f37cbf5465a$var$_clockseq;
// Previous uuid creation time
var $82002f37cbf5465a$var$_lastMSecs = 0;
var $82002f37cbf5465a$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $82002f37cbf5465a$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $82002f37cbf5465a$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $82002f37cbf5465a$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $aNFH1();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $82002f37cbf5465a$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $82002f37cbf5465a$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $82002f37cbf5465a$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $82002f37cbf5465a$var$_lastMSecs + (nsecs - $82002f37cbf5465a$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $82002f37cbf5465a$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    $82002f37cbf5465a$var$_lastMSecs = msecs;
    $82002f37cbf5465a$var$_lastNSecs = nsecs;
    $82002f37cbf5465a$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $hhsbW(b);
}
module.exports = $82002f37cbf5465a$var$v1;

});
parcelRegister("aNFH1", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $7dced24e69804e5b$var$getRandomValues = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
if ($7dced24e69804e5b$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $7dced24e69804e5b$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $7dced24e69804e5b$var$getRandomValues($7dced24e69804e5b$var$rnds8);
        return $7dced24e69804e5b$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $7dced24e69804e5b$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $7dced24e69804e5b$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $7dced24e69804e5b$var$rnds;
    };
}

});

parcelRegister("hhsbW", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $c949e475c7220504$var$byteToHex = [];
for(var $c949e475c7220504$var$i = 0; $c949e475c7220504$var$i < 256; ++$c949e475c7220504$var$i)$c949e475c7220504$var$byteToHex[$c949e475c7220504$var$i] = ($c949e475c7220504$var$i + 0x100).toString(16).substr(1);
function $c949e475c7220504$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $c949e475c7220504$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join("");
}
module.exports = $c949e475c7220504$var$bytesToUuid;

});


parcelRegister("7PESE", function(module, exports) {

var $aNFH1 = parcelRequire("aNFH1");

var $hhsbW = parcelRequire("hhsbW");
function $5b3d01dab50f015a$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == "string") {
        buf = options === "binary" ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $aNFH1)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $hhsbW(rnds);
}
module.exports = $5b3d01dab50f015a$var$v4;

});


parcelRegister("db09C", function(module, exports) {

$parcel$export(module.exports, "UFO_EXPERIMENTAL_BUILD_VERSION", function () { return $997c6c1319697cd2$export$2295b861f318254a; });
// temp solution until we can get it automated
var $997c6c1319697cd2$export$2295b861f318254a = "0.1.5";

});

parcelRegister("aHgIf", function(module, exports) {

$parcel$export(module.exports, "isWindowObjectAvailable", function () { return $7c9ae24ff3ac3169$export$15e172712955e18f; });
var $7c9ae24ff3ac3169$export$15e172712955e18f = function isWindowObjectAvailable() {
    return typeof window !== "undefined";
};

});

parcelRegister("3gJ2A", function(module, exports) {

$parcel$export(module.exports, "getGlobalEventStream", function () { return $2615cdde2da26ea7$export$6123a44dc2384540; });
$parcel$export(module.exports, "subscribeEvent", function () { return $2615cdde2da26ea7$export$37863216db4b714d; });
$parcel$export(module.exports, "unsubscribeEvent", function () { return $2615cdde2da26ea7$export$ee1a7bd1fc9ea85e; });
$parcel$export(module.exports, "experiencePayloadEvent", function () { return $2615cdde2da26ea7$export$7c957416596ca127; });

var $1qEbR = parcelRequire("1qEbR");

var $kJabx = parcelRequire("kJabx");
var $2615cdde2da26ea7$var$MAX_EARLY_QUEUE_LENGTH = 250;
var $2615cdde2da26ea7$export$6123a44dc2384540 = function getGlobalEventStream() {
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        var earlyStream = function() {
            var stream = [];
            return {
                __buffer_only__: true,
                push: function push(event) {
                    if (stream.length < $2615cdde2da26ea7$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: function getStream() {
                    return stream;
                }
            };
        }();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
var $2615cdde2da26ea7$export$c1522520b417b066 = function setGlobalEventStream(eventStream) {
    var _globalThis$__UFO_GLO, _globalThis$__UFO_GLO2;
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !((_globalThis$__UFO_GLO = globalThis.__UFO_GLOBAL_EVENT_STREAM__) !== null && _globalThis$__UFO_GLO !== void 0 && _globalThis$__UFO_GLO.__buffer_only__)) {
        (0, $1qEbR.ufowarn)("Global Event Stream already initialised. Ignoring new event stream setup");
        return;
    }
    if ((_globalThis$__UFO_GLO2 = globalThis.__UFO_GLOBAL_EVENT_STREAM__) !== null && _globalThis$__UFO_GLO2 !== void 0 && _globalThis$__UFO_GLO2.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
var $2615cdde2da26ea7$export$37863216db4b714d = function subscribeEvent(experienceId, callback) {
    return {
        type: (0, $kJabx.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
var $2615cdde2da26ea7$export$ee1a7bd1fc9ea85e = function unsubscribeEvent(experienceId, callback) {
    return {
        type: (0, $kJabx.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
var $2615cdde2da26ea7$export$7c957416596ca127 = function experiencePayloadEvent(data) {
    return {
        type: (0, $kJabx.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("1qEbR", function(module, exports) {

$parcel$export(module.exports, "ufolog", function () { return $10a7652030e75fa1$export$b4958caff08a0960; });
$parcel$export(module.exports, "ufowarn", function () { return $10a7652030e75fa1$export$d53d07b6034c4560; });

var $6QU8A = parcelRequire("6QU8A");

var $2Yk1N = parcelRequire("2Yk1N");

var $jjExS = parcelRequire("jjExS");
var $10a7652030e75fa1$var$UFOLogger = /*#__PURE__*/ function() {
    function UFOLogger() {
        (0, (/*@__PURE__*/$parcel$interopDefault($6QU8A)))(this, UFOLogger);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "enabled", false);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($2Yk1N)))(UFOLogger, [
        {
            key: "log",
            value: function log() {
                var _console;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                // eslint-disable-next-line no-console
                this.enabled && (_console = console).log.apply(_console, [
                    UFOLogger.UFOprefix
                ].concat(args));
            }
        },
        {
            key: "warn",
            value: function warn() {
                var _console2;
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                // eslint-disable-next-line no-console
                this.enabled && (_console2 = console).warn.apply(_console2, [
                    UFOLogger.UFOprefix
                ].concat(args));
            }
        },
        {
            key: "enable",
            value: function enable() {
                this.enabled = true;
            }
        },
        {
            key: "disable",
            value: function disable() {
                this.enabled = false;
            }
        }
    ]);
    return UFOLogger;
}();
(0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))($10a7652030e75fa1$var$UFOLogger, "UFOprefix", "[ufo\uD83D\uDEF8]");
var $10a7652030e75fa1$export$4ab84f6f04f6566d = new $10a7652030e75fa1$var$UFOLogger();
var $10a7652030e75fa1$export$b4958caff08a0960 = function ufolog() {
    $10a7652030e75fa1$export$4ab84f6f04f6566d.log.apply($10a7652030e75fa1$export$4ab84f6f04f6566d, arguments);
};
var $10a7652030e75fa1$export$d53d07b6034c4560 = function ufowarn() {
    $10a7652030e75fa1$export$4ab84f6f04f6566d.warn.apply($10a7652030e75fa1$export$4ab84f6f04f6566d, arguments);
};

});

parcelRegister("kJabx", function(module, exports) {

$parcel$export(module.exports, "UFOGlobalEventStreamEventType", function () { return $f16fe92fdf3ed145$export$96253c35c37cf96b; });
$parcel$export(module.exports, "PageVisibleState", function () { return $f16fe92fdf3ed145$export$a12c67b37a306b13; });
$parcel$export(module.exports, "SUBSCRIBE_ALL", function () { return $f16fe92fdf3ed145$export$79bf131685ad41d7; });
$parcel$export(module.exports, "FMP_MARK", function () { return $f16fe92fdf3ed145$export$9f2bf58999404c75; });
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", function () { return $f16fe92fdf3ed145$export$837e0f79a8056912; });

var $f16fe92fdf3ed145$export$96253c35c37cf96b = /*#__PURE__*/ function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    return UFOGlobalEventStreamEventType;
}({});
var $f16fe92fdf3ed145$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
    return PageVisibleState;
}({});
var $f16fe92fdf3ed145$export$66b33c055cbb625e = /*#__PURE__*/ function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
    return PageLoadMetrics;
}({});
var $f16fe92fdf3ed145$export$3ce489cbe02dc21b = /*#__PURE__*/ function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
    return PageSegmentLoadMetrics;
}({});
var $f16fe92fdf3ed145$export$341b330828bd3906 = /*#__PURE__*/ function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
    return InteractionMetrics;
}({});
var $f16fe92fdf3ed145$export$b9b20160f581e4f8 = /*#__PURE__*/ function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
    return CustomMetrics;
}({});
var $f16fe92fdf3ed145$export$79bf131685ad41d7 = "__SUBSCRIBE_ALL__";
var $f16fe92fdf3ed145$export$9f2bf58999404c75 = "fmp";
var $f16fe92fdf3ed145$export$837e0f79a8056912 = "inline-response";

});


parcelRegister("hRkSu", function(module, exports) {

$parcel$export(module.exports, "visibilityChangeObserver", function () { return $d00794d40cd013d8$export$13e680397ec8f3eb; });

var $6QU8A = parcelRequire("6QU8A");

var $2Yk1N = parcelRequire("2Yk1N");

var $jjExS = parcelRequire("jjExS");

var $aHgIf = parcelRequire("aHgIf");
var $d00794d40cd013d8$var$VisibilityChangeObserver = /*#__PURE__*/ function() {
    function VisibilityChangeObserver() {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($6QU8A)))(this, VisibilityChangeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "started", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "observers", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "broadcast", function() {
            _this.observers.forEach(function(fn) {
                return fn();
            });
            _this.observers = [];
        });
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($2Yk1N)))(VisibilityChangeObserver, [
        {
            key: "start",
            value: function start() {
                if (this.started) return;
                this.started = true;
                document.addEventListener("visibilitychange", this.broadcast);
                /**
       * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
       * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
       * so for that case, you need to also include code to listen for the pagehide event.
       */ if ((0, $aHgIf.isWindowObjectAvailable)()) window.addEventListener("pagehide", this.broadcast);
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                this.observers.push(callback);
            }
        },
        {
            key: "unsubscribe",
            value: function unsubscribe(callback) {
                this.observers = this.observers.filter(function(fn) {
                    return fn !== callback;
                });
            }
        }
    ]);
    return VisibilityChangeObserver;
}();
var $d00794d40cd013d8$export$13e680397ec8f3eb = new $d00794d40cd013d8$var$VisibilityChangeObserver();

});

parcelRegister("2LWZL", function(module, exports) {

$parcel$export(module.exports, "roundPerfNow", function () { return $204dbbc5c73ba20b$export$5f490af6b2b115cf; });
var $204dbbc5c73ba20b$export$5f490af6b2b115cf = function roundPerfNow() {
    return ~~performance.now();
};

});

parcelRegister("abQpr", function(module, exports) {

$parcel$export(module.exports, "UFOExperienceState", function () { return $76b395dc11a4d0b0$export$81b70111112841a0; });
var $76b395dc11a4d0b0$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: "NOT_STARTED",
        final: true
    },
    STARTED: {
        id: "STARTED"
    },
    IN_PROGRESS: {
        id: "IN_PROGRESS"
    },
    BLOCKED: {
        id: "BLOCKED"
    },
    RECOVERED: {
        id: "RECOVERED"
    },
    // isn't recovered IN_PROGRESS?
    SUCCEEDED: {
        id: "SUCCEEDED",
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: "SUCCEEDED_WAITING_FOR_DEPS"
    },
    FAILED: {
        id: "FAILED",
        final: true
    },
    ABORTED: {
        id: "ABORTED",
        final: true
    }
};

});

parcelRegister("k3mVC", function(module, exports) {

$parcel$export(module.exports, "canTransition", function () { return $e995df8a6ccedef0$export$178881f329fdb81f; });

var $jjExS = parcelRequire("jjExS");

var $abQpr = parcelRequire("abQpr");
var $e995df8a6ccedef0$var$_UFOStateAvailableTra;
var $e995df8a6ccedef0$var$UFOStateAvailableTransitions = ($e995df8a6ccedef0$var$_UFOStateAvailableTra = {}, (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))($e995df8a6ccedef0$var$_UFOStateAvailableTra, (0, $abQpr.UFOExperienceState).NOT_STARTED.id, [
    (0, $abQpr.UFOExperienceState).STARTED.id
]), (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))($e995df8a6ccedef0$var$_UFOStateAvailableTra, (0, $abQpr.UFOExperienceState).STARTED.id, [
    (0, $abQpr.UFOExperienceState).IN_PROGRESS.id,
    (0, $abQpr.UFOExperienceState).BLOCKED.id,
    (0, $abQpr.UFOExperienceState).SUCCEEDED.id,
    (0, $abQpr.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
    (0, $abQpr.UFOExperienceState).FAILED.id,
    (0, $abQpr.UFOExperienceState).ABORTED.id
]), (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))($e995df8a6ccedef0$var$_UFOStateAvailableTra, (0, $abQpr.UFOExperienceState).IN_PROGRESS.id, [
    (0, $abQpr.UFOExperienceState).BLOCKED.id,
    (0, $abQpr.UFOExperienceState).SUCCEEDED.id,
    (0, $abQpr.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
    (0, $abQpr.UFOExperienceState).FAILED.id,
    (0, $abQpr.UFOExperienceState).ABORTED.id
]), (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))($e995df8a6ccedef0$var$_UFOStateAvailableTra, (0, $abQpr.UFOExperienceState).BLOCKED.id, [
    (0, $abQpr.UFOExperienceState).RECOVERED.id,
    (0, $abQpr.UFOExperienceState).ABORTED.id
]), (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))($e995df8a6ccedef0$var$_UFOStateAvailableTra, (0, $abQpr.UFOExperienceState).RECOVERED.id, [
    (0, $abQpr.UFOExperienceState).STARTED.id,
    (0, $abQpr.UFOExperienceState).SUCCEEDED.id,
    (0, $abQpr.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
    (0, $abQpr.UFOExperienceState).FAILED.id,
    (0, $abQpr.UFOExperienceState).ABORTED.id
]), (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))($e995df8a6ccedef0$var$_UFOStateAvailableTra, (0, $abQpr.UFOExperienceState).SUCCEEDED.id, [
    (0, $abQpr.UFOExperienceState).STARTED.id
]), (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))($e995df8a6ccedef0$var$_UFOStateAvailableTra, (0, $abQpr.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id, [
    (0, $abQpr.UFOExperienceState).SUCCEEDED.id,
    (0, $abQpr.UFOExperienceState).FAILED.id,
    (0, $abQpr.UFOExperienceState).ABORTED.id
]), (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))($e995df8a6ccedef0$var$_UFOStateAvailableTra, (0, $abQpr.UFOExperienceState).FAILED.id, [
    (0, $abQpr.UFOExperienceState).STARTED.id
]), (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))($e995df8a6ccedef0$var$_UFOStateAvailableTra, (0, $abQpr.UFOExperienceState).ABORTED.id, [
    (0, $abQpr.UFOExperienceState).STARTED.id
]), $e995df8a6ccedef0$var$_UFOStateAvailableTra);
var $e995df8a6ccedef0$export$178881f329fdb81f = function canTransition(state1, state2) {
    return $e995df8a6ccedef0$var$UFOStateAvailableTransitions[state1.id] && $e995df8a6ccedef0$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});





parcelRegister("7lDUt", function(module, exports) {

$parcel$export(module.exports, "ActivityClient", function () { return $559973d2c5e8b3c8$export$157740f5433f3dbe; });

var $2Yk1N = parcelRequire("2Yk1N");

var $6QU8A = parcelRequire("6QU8A");

var $jjExS = parcelRequire("jjExS");

var $aMSmJ = parcelRequire("aMSmJ");
var $559973d2c5e8b3c8$export$157740f5433f3dbe = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2Yk1N)))(function ActivityClient(clientVersion, product, headers, baseUrl) {
    (0, (/*@__PURE__*/$parcel$interopDefault($6QU8A)))(this, ActivityClient);
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "product", "unknown");
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "baseUrl", (0, $aMSmJ.GRAPHQL_GATEWAY_PATH));
    if (product) this.product = product;
    this.clientVersion = clientVersion;
    this.headers = headers !== null && headers !== void 0 ? headers : {};
    if (baseUrl) this.baseUrl = baseUrl;
});

});
parcelRegister("aMSmJ", function(module, exports) {

$parcel$export(module.exports, "GRAPHQL_GATEWAY_PATH", function () { return $7da88ef5dd7c021c$export$851c5df667ca24c8; });
$parcel$export(module.exports, "WORKED_EVENT", function () { return $7da88ef5dd7c021c$export$eb4e9f525aef1cc3; });
var $7da88ef5dd7c021c$export$851c5df667ca24c8 = "/gateway/api/graphql";
var $7da88ef5dd7c021c$export$d245b105c09339d8 = /*#__PURE__*/ function(VIEWED_EVENT) {
    VIEWED_EVENT["VIEWED"] = "viewed";
    return VIEWED_EVENT;
}({});
var $7da88ef5dd7c021c$export$eb4e9f525aef1cc3 = /*#__PURE__*/ function(WORKED_EVENT) {
    WORKED_EVENT["COMMENTED"] = "commented";
    WORKED_EVENT["CREATED"] = "created";
    WORKED_EVENT["EDITED"] = "edited";
    WORKED_EVENT["PUBLISHED"] = "published";
    WORKED_EVENT["UPDATED"] = "updated";
    return WORKED_EVENT;
}({});
var $7da88ef5dd7c021c$export$d02a56686be43f69 = /*#__PURE__*/ function(ActivityObjectType) {
    ActivityObjectType["BLOGPOST"] = "BLOGPOST";
    ActivityObjectType["COMMENT"] = "COMMENT";
    ActivityObjectType["ISSUE"] = "ISSUE";
    ActivityObjectType["PAGE"] = "PAGE";
    ActivityObjectType["PROJECT"] = "PROJECT";
    ActivityObjectType["SITE"] = "SITE";
    ActivityObjectType["SPACE"] = "SPACE";
    ActivityObjectType["TASK"] = "TASK";
    return ActivityObjectType;
}({});

});


parcelRegister("8yY79", function(module, exports) {

$parcel$export(module.exports, "fetchActivitiesV2", function () { return $63c02127fd2df142$export$750ec7816fdd2f9e; });

var $04Kcc = parcelRequire("04Kcc");

var $e8dor = parcelRequire("e8dor");

var $fGIeY = parcelRequire("fGIeY");

var $gkElj = parcelRequire("gkElj");

var $8X2jc = parcelRequire("8X2jc");

var $hXjTV = parcelRequire("hXjTV");

var $c5oYN = parcelRequire("c5oYN");
var $63c02127fd2df142$var$_excluded = [
    "limit"
];
var $63c02127fd2df142$var$ACTIVITIES_LIMIT = 50;
// typescript guard for validating the activities connection type
var $63c02127fd2df142$var$isMyActivitiesConnection = function isMyActivitiesConnection(activities) {
    return activities.myActivities !== undefined;
};
var $63c02127fd2df142$var$V2_AVAILABLE_PRODUCTS = [
    "teamCentral",
    "editor",
    "people",
    "jira",
    "townsquare",
    "apOnboarding",
    "worklens",
    "confluence",
    "start"
];
var $63c02127fd2df142$export$750ec7816fdd2f9e = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($e8dor)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).mark(function _callee(_ref) {
        var _response$data;
        var experience, product, retryMS, _ref$filters, filters, activityQueries, baseUrl, _filters$limit, limit, restFilters, _generateActivityQuer, query, queryFilters, operationProduct, response, workedOn, viewed, all;
        return (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    experience = _ref.experience, product = _ref.product, retryMS = _ref.retryMS, _ref$filters = _ref.filters, filters = _ref$filters === void 0 ? {} : _ref$filters, activityQueries = _ref.activityQueries, baseUrl = _ref.baseUrl;
                    _filters$limit = filters.limit, limit = _filters$limit === void 0 ? $63c02127fd2df142$var$ACTIVITIES_LIMIT : _filters$limit, restFilters = (0, (/*@__PURE__*/$parcel$interopDefault($04Kcc)))(filters, $63c02127fd2df142$var$_excluded);
                    experience.mark("GeneratedQueryWithFilters_start");
                    _generateActivityQuer = (0, $hXjTV.generateActivityQueryWithFilters)(product, restFilters, activityQueries), query = _generateActivityQuer.query, queryFilters = _generateActivityQuer.queryFilters;
                    experience.mark("GeneratedQueryWithFilters_end");
                    // This is to make v2 forwards compatible. Defaulting to start as the product
                    operationProduct = $63c02127fd2df142$var$V2_AVAILABLE_PRODUCTS.includes(product) ? product : "start";
                    experience.mark("FetchedActivities_start");
                    _context.prev = 7;
                    _context.next = 10;
                    return (0, $8X2jc.postResource)(baseUrl, {
                        operationName: (0, $gkElj.getOperationName)(operationProduct),
                        query: query,
                        variables: {
                            first: limit,
                            filters: queryFilters
                        }
                    }, retryMS);
                case 10:
                    response = _context.sent;
                    _context.next = 17;
                    break;
                case 13:
                    _context.prev = 13;
                    _context.t0 = _context["catch"](7);
                    if (!(!_context.t0 || _context.t0.statusCode !== 401 && _context.t0.message !== "The operation was aborted.")) {
                        _context.next = 17;
                        break;
                    }
                    throw _context.t0;
                case 17:
                    experience.mark("FetchedActivities_end");
                    workedOn = [], viewed = [], all = [];
                    if (!(!response || !((_response$data = response.data) !== null && _response$data !== void 0 && _response$data.activities))) {
                        _context.next = 21;
                        break;
                    }
                    return _context.abrupt("return", {
                        all: all,
                        workedOn: workedOn,
                        viewed: viewed
                    });
                case 21:
                    experience.mark("TransformedActivityItems_start");
                    if ($63c02127fd2df142$var$isMyActivitiesConnection(response.data.activities)) {
                        if (response.data.activities.myActivities.workedOn && activityQueries.includes("workedOn")) workedOn = (0, $c5oYN.transformActivitiesItems)("workedOn", response.data.activities.myActivities.workedOn);
                        if (response.data.activities.myActivities.viewed && activityQueries.includes("viewed")) viewed = (0, $c5oYN.transformActivitiesItems)("viewed", response.data.activities.myActivities.viewed);
                        if (response.data.activities.myActivities.all && activityQueries.includes("all")) all = (0, $c5oYN.transformActivitiesItems)("all", response.data.activities.myActivities.all);
                    } else {
                        if (response.data.activities.workedOn && activityQueries.includes("workedOn")) workedOn = (0, $c5oYN.transformActivitiesItems)("workedOn", response.data.activities.workedOn);
                        if (response.data.activities.all && activityQueries.includes("all")) all = (0, $c5oYN.transformActivitiesItems)("all", response.data.activities.all);
                    }
                    experience.mark("TransformedActivityItems_end");
                    return _context.abrupt("return", {
                        all: all,
                        viewed: viewed,
                        workedOn: workedOn
                    });
                case 25:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                7,
                13
            ]
        ]);
    }));
    return function fetchActivitiesV2(_x) {
        return _ref2.apply(this, arguments);
    };
}();

});
parcelRegister("gkElj", function(module, exports) {

$parcel$export(module.exports, "getOperationName", function () { return $be3dcecf034c9360$export$41bca9dc6871dd4e; });

var $8BOAK = parcelRequire("8BOAK");
var $be3dcecf034c9360$export$ad1e21d37f385bcb = function formatProductForOperation(product) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($8BOAK)))(product);
};
var $be3dcecf034c9360$export$41bca9dc6871dd4e = function getOperationName(product) {
    return "".concat($be3dcecf034c9360$export$ad1e21d37f385bcb(product), "_activity_recentWorkClient");
};

});
parcelRegister("8BOAK", function(module, exports) {

var $fhg6E = parcelRequire("fhg6E");

var $3iUkC = parcelRequire("3iUkC");
/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */ var $644905e77cf27039$var$camelCase = $3iUkC(function(result, word, index) {
    word = word.toLowerCase();
    return result + (index ? $fhg6E(word) : word);
});
module.exports = $644905e77cf27039$var$camelCase;

});
parcelRegister("fhg6E", function(module, exports) {

var $jRfzF = parcelRequire("jRfzF");

var $2dXwU = parcelRequire("2dXwU");
/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function $b1f4efee6b983512$var$capitalize(string) {
    return $2dXwU($jRfzF(string).toLowerCase());
}
module.exports = $b1f4efee6b983512$var$capitalize;

});
parcelRegister("2dXwU", function(module, exports) {

var $44OZ6 = parcelRequire("44OZ6");
/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $19eaf90feb840062$var$upperFirst = $44OZ6("toUpperCase");
module.exports = $19eaf90feb840062$var$upperFirst;

});
parcelRegister("44OZ6", function(module, exports) {

var $b32Lo = parcelRequire("b32Lo");

var $eQaHF = parcelRequire("eQaHF");

var $aMKIQ = parcelRequire("aMKIQ");

var $jRfzF = parcelRequire("jRfzF");
/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $2f7f15a23b6cc557$var$createCaseFirst(methodName) {
    return function(string) {
        string = $jRfzF(string);
        var strSymbols = $eQaHF(string) ? $aMKIQ(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $b32Lo(strSymbols, 1).join("") : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
module.exports = $2f7f15a23b6cc557$var$createCaseFirst;

});
parcelRegister("b32Lo", function(module, exports) {

var $89LOh = parcelRequire("89LOh");
/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $80b21e49ff397838$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $89LOh(array, start, end);
}
module.exports = $80b21e49ff397838$var$castSlice;

});
parcelRegister("89LOh", function(module, exports) {
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $5f04400c231a5330$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
module.exports = $5f04400c231a5330$var$baseSlice;

});


parcelRegister("eQaHF", function(module, exports) {
/** Used to compose unicode character classes. */ var $acde397a6d097f27$var$rsAstralRange = "\ud800-\udfff", $acde397a6d097f27$var$rsComboMarksRange = "\\u0300-\\u036f", $acde397a6d097f27$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $acde397a6d097f27$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $acde397a6d097f27$var$rsComboRange = $acde397a6d097f27$var$rsComboMarksRange + $acde397a6d097f27$var$reComboHalfMarksRange + $acde397a6d097f27$var$rsComboSymbolsRange, $acde397a6d097f27$var$rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var $acde397a6d097f27$var$rsZWJ = "\\u200d";
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $acde397a6d097f27$var$reHasUnicode = RegExp("[" + $acde397a6d097f27$var$rsZWJ + $acde397a6d097f27$var$rsAstralRange + $acde397a6d097f27$var$rsComboRange + $acde397a6d097f27$var$rsVarRange + "]");
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $acde397a6d097f27$var$hasUnicode(string) {
    return $acde397a6d097f27$var$reHasUnicode.test(string);
}
module.exports = $acde397a6d097f27$var$hasUnicode;

});

parcelRegister("aMKIQ", function(module, exports) {

var $aeaW0 = parcelRequire("aeaW0");

var $eQaHF = parcelRequire("eQaHF");

var $hKjDa = parcelRequire("hKjDa");
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $7da2a1218483ea26$var$stringToArray(string) {
    return $eQaHF(string) ? $hKjDa(string) : $aeaW0(string);
}
module.exports = $7da2a1218483ea26$var$stringToArray;

});
parcelRegister("aeaW0", function(module, exports) {
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $7723b1911be870b8$var$asciiToArray(string) {
    return string.split("");
}
module.exports = $7723b1911be870b8$var$asciiToArray;

});

parcelRegister("hKjDa", function(module, exports) {
/** Used to compose unicode character classes. */ var $ceb5f5c711b88ac8$var$rsAstralRange = "\ud800-\udfff", $ceb5f5c711b88ac8$var$rsComboMarksRange = "\\u0300-\\u036f", $ceb5f5c711b88ac8$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $ceb5f5c711b88ac8$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $ceb5f5c711b88ac8$var$rsComboRange = $ceb5f5c711b88ac8$var$rsComboMarksRange + $ceb5f5c711b88ac8$var$reComboHalfMarksRange + $ceb5f5c711b88ac8$var$rsComboSymbolsRange, $ceb5f5c711b88ac8$var$rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var $ceb5f5c711b88ac8$var$rsAstral = "[" + $ceb5f5c711b88ac8$var$rsAstralRange + "]", $ceb5f5c711b88ac8$var$rsCombo = "[" + $ceb5f5c711b88ac8$var$rsComboRange + "]", $ceb5f5c711b88ac8$var$rsFitz = "\ud83c[\udffb-\udfff]", $ceb5f5c711b88ac8$var$rsModifier = "(?:" + $ceb5f5c711b88ac8$var$rsCombo + "|" + $ceb5f5c711b88ac8$var$rsFitz + ")", $ceb5f5c711b88ac8$var$rsNonAstral = "[^" + $ceb5f5c711b88ac8$var$rsAstralRange + "]", $ceb5f5c711b88ac8$var$rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", $ceb5f5c711b88ac8$var$rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", $ceb5f5c711b88ac8$var$rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */ var $ceb5f5c711b88ac8$var$reOptMod = $ceb5f5c711b88ac8$var$rsModifier + "?", $ceb5f5c711b88ac8$var$rsOptVar = "[" + $ceb5f5c711b88ac8$var$rsVarRange + "]?", $ceb5f5c711b88ac8$var$rsOptJoin = "(?:" + $ceb5f5c711b88ac8$var$rsZWJ + "(?:" + [
    $ceb5f5c711b88ac8$var$rsNonAstral,
    $ceb5f5c711b88ac8$var$rsRegional,
    $ceb5f5c711b88ac8$var$rsSurrPair
].join("|") + ")" + $ceb5f5c711b88ac8$var$rsOptVar + $ceb5f5c711b88ac8$var$reOptMod + ")*", $ceb5f5c711b88ac8$var$rsSeq = $ceb5f5c711b88ac8$var$rsOptVar + $ceb5f5c711b88ac8$var$reOptMod + $ceb5f5c711b88ac8$var$rsOptJoin, $ceb5f5c711b88ac8$var$rsSymbol = "(?:" + [
    $ceb5f5c711b88ac8$var$rsNonAstral + $ceb5f5c711b88ac8$var$rsCombo + "?",
    $ceb5f5c711b88ac8$var$rsCombo,
    $ceb5f5c711b88ac8$var$rsRegional,
    $ceb5f5c711b88ac8$var$rsSurrPair,
    $ceb5f5c711b88ac8$var$rsAstral
].join("|") + ")";
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $ceb5f5c711b88ac8$var$reUnicode = RegExp($ceb5f5c711b88ac8$var$rsFitz + "(?=" + $ceb5f5c711b88ac8$var$rsFitz + ")|" + $ceb5f5c711b88ac8$var$rsSymbol + $ceb5f5c711b88ac8$var$rsSeq, "g");
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $ceb5f5c711b88ac8$var$unicodeToArray(string) {
    return string.match($ceb5f5c711b88ac8$var$reUnicode) || [];
}
module.exports = $ceb5f5c711b88ac8$var$unicodeToArray;

});





parcelRegister("3iUkC", function(module, exports) {

var $aXYCc = parcelRequire("aXYCc");

var $i2tRL = parcelRequire("i2tRL");

var $c5jOa = parcelRequire("c5jOa");
/** Used to compose unicode capture groups. */ var $267ebfcba8a4d48b$var$rsApos = "['\u2019]";
/** Used to match apostrophes. */ var $267ebfcba8a4d48b$var$reApos = RegExp($267ebfcba8a4d48b$var$rsApos, "g");
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $267ebfcba8a4d48b$var$createCompounder(callback) {
    return function(string) {
        return $aXYCc($c5jOa($i2tRL(string).replace($267ebfcba8a4d48b$var$reApos, "")), callback, "");
    };
}
module.exports = $267ebfcba8a4d48b$var$createCompounder;

});
parcelRegister("aXYCc", function(module, exports) {
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $7fbe6efe7dbe652b$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
module.exports = $7fbe6efe7dbe652b$var$arrayReduce;

});

parcelRegister("i2tRL", function(module, exports) {

var $5h8yv = parcelRequire("5h8yv");

var $jRfzF = parcelRequire("jRfzF");
/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $d21f94b7e83af525$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $d21f94b7e83af525$var$rsComboMarksRange = "\\u0300-\\u036f", $d21f94b7e83af525$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $d21f94b7e83af525$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $d21f94b7e83af525$var$rsComboRange = $d21f94b7e83af525$var$rsComboMarksRange + $d21f94b7e83af525$var$reComboHalfMarksRange + $d21f94b7e83af525$var$rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var $d21f94b7e83af525$var$rsCombo = "[" + $d21f94b7e83af525$var$rsComboRange + "]";
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $d21f94b7e83af525$var$reComboMark = RegExp($d21f94b7e83af525$var$rsCombo, "g");
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $d21f94b7e83af525$var$deburr(string) {
    string = $jRfzF(string);
    return string && string.replace($d21f94b7e83af525$var$reLatin, $5h8yv).replace($d21f94b7e83af525$var$reComboMark, "");
}
module.exports = $d21f94b7e83af525$var$deburr;

});
parcelRegister("5h8yv", function(module, exports) {

var $iweYJ = parcelRequire("iweYJ");
/** Used to map Latin Unicode letters to basic Latin letters. */ var $3d752d3614eebba1$var$deburredLetters = {
    // Latin-1 Supplement block.
    "\xc0": "A",
    "\xc1": "A",
    "\xc2": "A",
    "\xc3": "A",
    "\xc4": "A",
    "\xc5": "A",
    "\xe0": "a",
    "\xe1": "a",
    "\xe2": "a",
    "\xe3": "a",
    "\xe4": "a",
    "\xe5": "a",
    "\xc7": "C",
    "\xe7": "c",
    "\xd0": "D",
    "\xf0": "d",
    "\xc8": "E",
    "\xc9": "E",
    "\xca": "E",
    "\xcb": "E",
    "\xe8": "e",
    "\xe9": "e",
    "\xea": "e",
    "\xeb": "e",
    "\xcc": "I",
    "\xcd": "I",
    "\xce": "I",
    "\xcf": "I",
    "\xec": "i",
    "\xed": "i",
    "\xee": "i",
    "\xef": "i",
    "\xd1": "N",
    "\xf1": "n",
    "\xd2": "O",
    "\xd3": "O",
    "\xd4": "O",
    "\xd5": "O",
    "\xd6": "O",
    "\xd8": "O",
    "\xf2": "o",
    "\xf3": "o",
    "\xf4": "o",
    "\xf5": "o",
    "\xf6": "o",
    "\xf8": "o",
    "\xd9": "U",
    "\xda": "U",
    "\xdb": "U",
    "\xdc": "U",
    "\xf9": "u",
    "\xfa": "u",
    "\xfb": "u",
    "\xfc": "u",
    "\xdd": "Y",
    "\xfd": "y",
    "\xff": "y",
    "\xc6": "Ae",
    "\xe6": "ae",
    "\xde": "Th",
    "\xfe": "th",
    "\xdf": "ss",
    // Latin Extended-A block.
    "\u0100": "A",
    "\u0102": "A",
    "\u0104": "A",
    "\u0101": "a",
    "\u0103": "a",
    "\u0105": "a",
    "\u0106": "C",
    "\u0108": "C",
    "\u010A": "C",
    "\u010C": "C",
    "\u0107": "c",
    "\u0109": "c",
    "\u010B": "c",
    "\u010D": "c",
    "\u010E": "D",
    "\u0110": "D",
    "\u010F": "d",
    "\u0111": "d",
    "\u0112": "E",
    "\u0114": "E",
    "\u0116": "E",
    "\u0118": "E",
    "\u011A": "E",
    "\u0113": "e",
    "\u0115": "e",
    "\u0117": "e",
    "\u0119": "e",
    "\u011B": "e",
    "\u011C": "G",
    "\u011E": "G",
    "\u0120": "G",
    "\u0122": "G",
    "\u011D": "g",
    "\u011F": "g",
    "\u0121": "g",
    "\u0123": "g",
    "\u0124": "H",
    "\u0126": "H",
    "\u0125": "h",
    "\u0127": "h",
    "\u0128": "I",
    "\u012A": "I",
    "\u012C": "I",
    "\u012E": "I",
    "\u0130": "I",
    "\u0129": "i",
    "\u012B": "i",
    "\u012D": "i",
    "\u012F": "i",
    "\u0131": "i",
    "\u0134": "J",
    "\u0135": "j",
    "\u0136": "K",
    "\u0137": "k",
    "\u0138": "k",
    "\u0139": "L",
    "\u013B": "L",
    "\u013D": "L",
    "\u013F": "L",
    "\u0141": "L",
    "\u013A": "l",
    "\u013C": "l",
    "\u013E": "l",
    "\u0140": "l",
    "\u0142": "l",
    "\u0143": "N",
    "\u0145": "N",
    "\u0147": "N",
    "\u014A": "N",
    "\u0144": "n",
    "\u0146": "n",
    "\u0148": "n",
    "\u014B": "n",
    "\u014C": "O",
    "\u014E": "O",
    "\u0150": "O",
    "\u014D": "o",
    "\u014F": "o",
    "\u0151": "o",
    "\u0154": "R",
    "\u0156": "R",
    "\u0158": "R",
    "\u0155": "r",
    "\u0157": "r",
    "\u0159": "r",
    "\u015A": "S",
    "\u015C": "S",
    "\u015E": "S",
    "\u0160": "S",
    "\u015B": "s",
    "\u015D": "s",
    "\u015F": "s",
    "\u0161": "s",
    "\u0162": "T",
    "\u0164": "T",
    "\u0166": "T",
    "\u0163": "t",
    "\u0165": "t",
    "\u0167": "t",
    "\u0168": "U",
    "\u016A": "U",
    "\u016C": "U",
    "\u016E": "U",
    "\u0170": "U",
    "\u0172": "U",
    "\u0169": "u",
    "\u016B": "u",
    "\u016D": "u",
    "\u016F": "u",
    "\u0171": "u",
    "\u0173": "u",
    "\u0174": "W",
    "\u0175": "w",
    "\u0176": "Y",
    "\u0177": "y",
    "\u0178": "Y",
    "\u0179": "Z",
    "\u017B": "Z",
    "\u017D": "Z",
    "\u017A": "z",
    "\u017C": "z",
    "\u017E": "z",
    "\u0132": "IJ",
    "\u0133": "ij",
    "\u0152": "Oe",
    "\u0153": "oe",
    "\u0149": "'n",
    "\u017F": "s"
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $3d752d3614eebba1$var$deburrLetter = $iweYJ($3d752d3614eebba1$var$deburredLetters);
module.exports = $3d752d3614eebba1$var$deburrLetter;

});
parcelRegister("iweYJ", function(module, exports) {
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $d7b6d5901592cf77$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $d7b6d5901592cf77$var$basePropertyOf;

});



parcelRegister("c5jOa", function(module, exports) {

var $63IuK = parcelRequire("63IuK");

var $2Lnun = parcelRequire("2Lnun");

var $jRfzF = parcelRequire("jRfzF");

var $ecP6t = parcelRequire("ecP6t");
/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $8cc55126fadd8306$var$words(string, pattern, guard) {
    string = $jRfzF(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return $2Lnun(string) ? $ecP6t(string) : $63IuK(string);
    return string.match(pattern) || [];
}
module.exports = $8cc55126fadd8306$var$words;

});
parcelRegister("63IuK", function(module, exports) {
/** Used to match words composed of alphanumeric characters. */ var $469589a279539d7d$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $469589a279539d7d$var$asciiWords(string) {
    return string.match($469589a279539d7d$var$reAsciiWord) || [];
}
module.exports = $469589a279539d7d$var$asciiWords;

});

parcelRegister("2Lnun", function(module, exports) {
/** Used to detect strings that need a more robust regexp to match words. */ var $203230fbec7d80cd$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $203230fbec7d80cd$var$hasUnicodeWord(string) {
    return $203230fbec7d80cd$var$reHasUnicodeWord.test(string);
}
module.exports = $203230fbec7d80cd$var$hasUnicodeWord;

});

parcelRegister("ecP6t", function(module, exports) {
/** Used to compose unicode character classes. */ var $a579d3bc2fba18e2$var$rsAstralRange = "\ud800-\udfff", $a579d3bc2fba18e2$var$rsComboMarksRange = "\\u0300-\\u036f", $a579d3bc2fba18e2$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $a579d3bc2fba18e2$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $a579d3bc2fba18e2$var$rsComboRange = $a579d3bc2fba18e2$var$rsComboMarksRange + $a579d3bc2fba18e2$var$reComboHalfMarksRange + $a579d3bc2fba18e2$var$rsComboSymbolsRange, $a579d3bc2fba18e2$var$rsDingbatRange = "\\u2700-\\u27bf", $a579d3bc2fba18e2$var$rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", $a579d3bc2fba18e2$var$rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", $a579d3bc2fba18e2$var$rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", $a579d3bc2fba18e2$var$rsPunctuationRange = "\\u2000-\\u206f", $a579d3bc2fba18e2$var$rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", $a579d3bc2fba18e2$var$rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", $a579d3bc2fba18e2$var$rsVarRange = "\\ufe0e\\ufe0f", $a579d3bc2fba18e2$var$rsBreakRange = $a579d3bc2fba18e2$var$rsMathOpRange + $a579d3bc2fba18e2$var$rsNonCharRange + $a579d3bc2fba18e2$var$rsPunctuationRange + $a579d3bc2fba18e2$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $a579d3bc2fba18e2$var$rsApos = "['\u2019]", $a579d3bc2fba18e2$var$rsBreak = "[" + $a579d3bc2fba18e2$var$rsBreakRange + "]", $a579d3bc2fba18e2$var$rsCombo = "[" + $a579d3bc2fba18e2$var$rsComboRange + "]", $a579d3bc2fba18e2$var$rsDigits = "\\d+", $a579d3bc2fba18e2$var$rsDingbat = "[" + $a579d3bc2fba18e2$var$rsDingbatRange + "]", $a579d3bc2fba18e2$var$rsLower = "[" + $a579d3bc2fba18e2$var$rsLowerRange + "]", $a579d3bc2fba18e2$var$rsMisc = "[^" + $a579d3bc2fba18e2$var$rsAstralRange + $a579d3bc2fba18e2$var$rsBreakRange + $a579d3bc2fba18e2$var$rsDigits + $a579d3bc2fba18e2$var$rsDingbatRange + $a579d3bc2fba18e2$var$rsLowerRange + $a579d3bc2fba18e2$var$rsUpperRange + "]", $a579d3bc2fba18e2$var$rsFitz = "\ud83c[\udffb-\udfff]", $a579d3bc2fba18e2$var$rsModifier = "(?:" + $a579d3bc2fba18e2$var$rsCombo + "|" + $a579d3bc2fba18e2$var$rsFitz + ")", $a579d3bc2fba18e2$var$rsNonAstral = "[^" + $a579d3bc2fba18e2$var$rsAstralRange + "]", $a579d3bc2fba18e2$var$rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", $a579d3bc2fba18e2$var$rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", $a579d3bc2fba18e2$var$rsUpper = "[" + $a579d3bc2fba18e2$var$rsUpperRange + "]", $a579d3bc2fba18e2$var$rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */ var $a579d3bc2fba18e2$var$rsMiscLower = "(?:" + $a579d3bc2fba18e2$var$rsLower + "|" + $a579d3bc2fba18e2$var$rsMisc + ")", $a579d3bc2fba18e2$var$rsMiscUpper = "(?:" + $a579d3bc2fba18e2$var$rsUpper + "|" + $a579d3bc2fba18e2$var$rsMisc + ")", $a579d3bc2fba18e2$var$rsOptContrLower = "(?:" + $a579d3bc2fba18e2$var$rsApos + "(?:d|ll|m|re|s|t|ve))?", $a579d3bc2fba18e2$var$rsOptContrUpper = "(?:" + $a579d3bc2fba18e2$var$rsApos + "(?:D|LL|M|RE|S|T|VE))?", $a579d3bc2fba18e2$var$reOptMod = $a579d3bc2fba18e2$var$rsModifier + "?", $a579d3bc2fba18e2$var$rsOptVar = "[" + $a579d3bc2fba18e2$var$rsVarRange + "]?", $a579d3bc2fba18e2$var$rsOptJoin = "(?:" + $a579d3bc2fba18e2$var$rsZWJ + "(?:" + [
    $a579d3bc2fba18e2$var$rsNonAstral,
    $a579d3bc2fba18e2$var$rsRegional,
    $a579d3bc2fba18e2$var$rsSurrPair
].join("|") + ")" + $a579d3bc2fba18e2$var$rsOptVar + $a579d3bc2fba18e2$var$reOptMod + ")*", $a579d3bc2fba18e2$var$rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", $a579d3bc2fba18e2$var$rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", $a579d3bc2fba18e2$var$rsSeq = $a579d3bc2fba18e2$var$rsOptVar + $a579d3bc2fba18e2$var$reOptMod + $a579d3bc2fba18e2$var$rsOptJoin, $a579d3bc2fba18e2$var$rsEmoji = "(?:" + [
    $a579d3bc2fba18e2$var$rsDingbat,
    $a579d3bc2fba18e2$var$rsRegional,
    $a579d3bc2fba18e2$var$rsSurrPair
].join("|") + ")" + $a579d3bc2fba18e2$var$rsSeq;
/** Used to match complex or compound words. */ var $a579d3bc2fba18e2$var$reUnicodeWord = RegExp([
    $a579d3bc2fba18e2$var$rsUpper + "?" + $a579d3bc2fba18e2$var$rsLower + "+" + $a579d3bc2fba18e2$var$rsOptContrLower + "(?=" + [
        $a579d3bc2fba18e2$var$rsBreak,
        $a579d3bc2fba18e2$var$rsUpper,
        "$"
    ].join("|") + ")",
    $a579d3bc2fba18e2$var$rsMiscUpper + "+" + $a579d3bc2fba18e2$var$rsOptContrUpper + "(?=" + [
        $a579d3bc2fba18e2$var$rsBreak,
        $a579d3bc2fba18e2$var$rsUpper + $a579d3bc2fba18e2$var$rsMiscLower,
        "$"
    ].join("|") + ")",
    $a579d3bc2fba18e2$var$rsUpper + "?" + $a579d3bc2fba18e2$var$rsMiscLower + "+" + $a579d3bc2fba18e2$var$rsOptContrLower,
    $a579d3bc2fba18e2$var$rsUpper + "+" + $a579d3bc2fba18e2$var$rsOptContrUpper,
    $a579d3bc2fba18e2$var$rsOrdUpper,
    $a579d3bc2fba18e2$var$rsOrdLower,
    $a579d3bc2fba18e2$var$rsDigits,
    $a579d3bc2fba18e2$var$rsEmoji
].join("|"), "g");
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $a579d3bc2fba18e2$var$unicodeWords(string) {
    return string.match($a579d3bc2fba18e2$var$reUnicodeWord) || [];
}
module.exports = $a579d3bc2fba18e2$var$unicodeWords;

});





parcelRegister("8X2jc", function(module, exports) {

$parcel$export(module.exports, "postResource", function () { return $01ae8ad61f0bc860$export$2ff3e1f219ccfad6; });

var $jjExS = parcelRequire("jjExS");

var $e8dor = parcelRequire("e8dor");

var $fGIeY = parcelRequire("fGIeY");
parcelRequire("lCDpQ");
var $lxHms = parcelRequire("lxHms");
var $lCDpQ = parcelRequire("lCDpQ");

var $aNiNb = parcelRequire("aNiNb");

var $fM9he = parcelRequire("fM9he");
function $01ae8ad61f0bc860$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $01ae8ad61f0bc860$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $01ae8ad61f0bc860$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $01ae8ad61f0bc860$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $01ae8ad61f0bc860$var$fetchResource = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($e8dor)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).mark(function _callee(path, method) {
        var options, url, response, statusCode, text, httpError, _args = arguments;
        return (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    options = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
                    url = (0, $aNiNb.getFullUrl)(path);
                    _context.next = 4;
                    return fetch(url, $01ae8ad61f0bc860$var$_objectSpread({
                        credentials: "include",
                        method: method
                    }, options)).catch(function(error) {
                        throw new (0, $lxHms.default)({
                            error: error,
                            path: path,
                            method: method
                        });
                    });
                case 4:
                    response = _context.sent;
                    statusCode = response.status;
                    if (response.ok) {
                        _context.next = 15;
                        break;
                    }
                    statusCode;
                    _context.t0 = $01ae8ad61f0bc860$var$scrubTimestampFromErrorBody;
                    _context.next = 11;
                    return response.text();
                case 11:
                    _context.t1 = _context.sent;
                    text = (0, _context.t0)(_context.t1);
                    httpError = new (0, $fM9he.default)({
                        message: text,
                        method: method,
                        path: path,
                        statusCode: statusCode,
                        xRequestId: response.headers.get("x-request-id"),
                        headers: response.headers
                    });
                    throw httpError;
                case 15:
                    return _context.abrupt("return", response);
                case 16:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function fetchResource(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();
var $01ae8ad61f0bc860$var$makeJsonRquest = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($e8dor)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).mark(function _callee2(path, method) {
        var additionalFetchOptions, response, text, _args2 = arguments;
        return (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    additionalFetchOptions = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {};
                    _context2.next = 3;
                    return $01ae8ad61f0bc860$var$fetchResource(path, method, additionalFetchOptions);
                case 3:
                    response = _context2.sent;
                    _context2.next = 6;
                    return response.text();
                case 6:
                    text = _context2.sent;
                    return _context2.abrupt("return", text ? JSON.parse(text) : {});
                case 8:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function makeJsonRquest(_x3, _x4) {
        return _ref2.apply(this, arguments);
    };
}();
var $01ae8ad61f0bc860$export$2ff3e1f219ccfad6 = /*#__PURE__*/ function() {
    var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($e8dor)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).mark(function _callee3(path, data, retryMS, extraHeaders) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    return _context3.abrupt("return", (0, $lCDpQ.retryOnException)(function() {
                        return $01ae8ad61f0bc860$var$makeJsonRquest(path, "POST", {
                            body: JSON.stringify(data),
                            headers: $01ae8ad61f0bc860$var$_objectSpread({
                                "content-type": "application/json"
                            }, extraHeaders)
                        });
                    }, {
                        intervalsMS: retryMS !== null && retryMS !== void 0 ? retryMS : []
                    }));
                case 1:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return function postResource(_x5, _x6, _x7, _x8) {
        return _ref3.apply(this, arguments);
    };
}();
// to dedup sentry, scrub non-unique 'timestamp' field from the error body
function $01ae8ad61f0bc860$var$scrubTimestampFromErrorBody(text) {
    var json;
    try {
        json = JSON.parse(text);
    } catch (err) {
        return text;
    }
    delete json.timestamp;
    return JSON.stringify(json);
}

});
parcelRegister("aNiNb", function(module, exports) {

$parcel$export(module.exports, "getFullUrl", function () { return $7dbd0ec219ad7dc6$export$2414511207262909; });
var $7dbd0ec219ad7dc6$var$urlRegex = new RegExp(/^https?:\/\//);
function $7dbd0ec219ad7dc6$export$2414511207262909(path) {
    var hostConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        host: window.location.hostname,
        port: window.location.port
    };
    // always return a just the URL if one is provided
    if ($7dbd0ec219ad7dc6$var$urlRegex.test(path)) return path;
    return hostConfig.host === "localhost" ? "http://".concat(hostConfig.host, ":").concat(hostConfig.port).concat(path) : path;
}

});


parcelRegister("hXjTV", function(module, exports) {

$parcel$export(module.exports, "generateActivityQueryWithFilters", function () { return $d12762480f993e0b$export$855cd08371c65b8c; });

var $gkElj = parcelRequire("gkElj");

var $jdAs8 = parcelRequire("jdAs8");
var $d12762480f993e0b$var$ACTIVITIES = "\n  nodes {\n    id\n    timestamp\n    object {\n      id\n      name\n      cloudId\n      localResourceId\n      product\n      type\n      url\n      iconUrl\n      containers {\n        name\n      }\n      contributors {\n        profile {\n          accountId\n          name\n          picture\n        }\n      }\n      events {\n        eventType\n      }\n      extension {\n        ... on ActivitiesJiraIssue {\n          issueKey\n        }\n      }\n    }\n  }\n";
var $d12762480f993e0b$var$WORKED_ON_QUERY = "\n   workedOn(first: $first, filters: $filters) {\n     ".concat($d12762480f993e0b$var$ACTIVITIES, "\n   }\n");
var $d12762480f993e0b$var$VIEWED__QUERY = "\n   viewed(first: $first, filters: $filters) {\n     ".concat($d12762480f993e0b$var$ACTIVITIES, "\n   }\n");
var $d12762480f993e0b$var$ALL__QUERY = "\n    all(first: $first, filters: $filters) {\n      ".concat($d12762480f993e0b$var$ACTIVITIES, "\n    }\n");
var $d12762480f993e0b$var$activityQueryMap = new Map([
    [
        "workedOn",
        $d12762480f993e0b$var$WORKED_ON_QUERY
    ],
    [
        "viewed",
        $d12762480f993e0b$var$VIEWED__QUERY
    ],
    [
        "all",
        $d12762480f993e0b$var$ALL__QUERY
    ]
]);
var $d12762480f993e0b$var$getMyActivitiesQuery = function getMyActivitiesQuery(queries) {
    return "\n      myActivities {\n        ".concat(queries.join("\n"), "\n      }\n");
};
var $d12762480f993e0b$var$getActivitiesQuery = function getActivitiesQuery(product, content) {
    return "\n    query ".concat((0, $gkElj.getOperationName)(product), "($first: Int, $filters: [ActivitiesFilter!]) {\n      activities {\n        ").concat(content, "\n      }\n    }\n");
};
var $d12762480f993e0b$export$855cd08371c65b8c = function generateActivityQueryWithFilters(product, filters, activityQueries) {
    /**
   * If we are filtering by `accountIds` then we can't use the `myActivity` query.
   */ if (Array.isArray(filters.actors)) {
        // you can't view `viewed` events for other accounts
        var filteredAccountQueries = activityQueries.filter(function(query) {
            return query !== "viewed";
        });
        return {
            query: $d12762480f993e0b$var$getActivitiesQuery(product, filteredAccountQueries.map(function(query) {
                return $d12762480f993e0b$var$activityQueryMap.get(query);
            }).join("\n")),
            queryFilters: (0, $jdAs8.ACTIVITY_FILTER_COLLECTION).v2.get("activities")(filters)
        };
    } else return {
        query: $d12762480f993e0b$var$getActivitiesQuery(product, $d12762480f993e0b$var$getMyActivitiesQuery(activityQueries.map(function(query) {
            return $d12762480f993e0b$var$activityQueryMap.get(query);
        }))),
        queryFilters: (0, $jdAs8.ACTIVITY_FILTER_COLLECTION).v2.get("myActivity")(filters)
    };
};

});
parcelRegister("jdAs8", function(module, exports) {

$parcel$export(module.exports, "ACTIVITY_FILTER_COLLECTION", function () { return $dfdb81fd2796ff8d$export$5201d39848130041; });

var $1FhK3 = parcelRequire("1FhK3");

var $9vENa = parcelRequire("9vENa");
var $dfdb81fd2796ff8d$export$5201d39848130041 = {
    v2: (0, $1FhK3.ACTIVITY_FILTER_V2_MAP),
    v3: (0, $9vENa.ACTIVITY_FILTER_V3_MAP)
};

});
parcelRegister("1FhK3", function(module, exports) {

$parcel$export(module.exports, "ACTIVITY_FILTER_V2_MAP", function () { return $136761ef85eea0b6$export$1dca7bc1ec360897; });

var $9xTwK = parcelRequire("9xTwK");

var $lPjbd = parcelRequire("lPjbd");
var $136761ef85eea0b6$export$1dca7bc1ec360897 = new Map([
    [
        "myActivity",
        (0, $lPjbd.default)
    ],
    [
        "activities",
        (0, $9xTwK.default)
    ]
]);

});
parcelRegister("9xTwK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01cb2223c6db8a7c$export$2e2bcd8739ae039; });

var $04Kcc = parcelRequire("04Kcc");

var $hu5TE = parcelRequire("hu5TE");
var $01cb2223c6db8a7c$var$_excluded = [
    "limit"
];
/**
 * This is the query builder for the v2 - activities API
 *
 * @param filters
 */ var $01cb2223c6db8a7c$var$generateV2ActivitiesFilters = function generateV2ActivitiesFilters() {
    var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var limit = filters.limit, restFilters = (0, (/*@__PURE__*/$parcel$interopDefault($04Kcc)))(filters, $01cb2223c6db8a7c$var$_excluded);
    return (0, $hu5TE.generateActivityFiltersV2)(restFilters);
};
var $01cb2223c6db8a7c$export$2e2bcd8739ae039 = $01cb2223c6db8a7c$var$generateV2ActivitiesFilters;

});
parcelRegister("hu5TE", function(module, exports) {

$parcel$export(module.exports, "generateActivityFiltersV2", function () { return $cba9cff9f57093dc$export$ebef9c1f1e15c057; });

var $jjExS = parcelRequire("jjExS");

var $5kNUZ = parcelRequire("5kNUZ");
// in V2 API the values for certain filters should be in UPPERCASE as are ENUMs in the GraphQL
// likewise for the V3 handler we should ensure we do appropriate lowercase conversion
var $cba9cff9f57093dc$var$FILTERS_TO_TRANSFORM__UPPERCASE = [
    "products",
    "eventTypes",
    "objectTypes"
];
var $cba9cff9f57093dc$var$KEYS_TO_TRANSFROM = new Map([
    [
        "actors",
        "accountIds"
    ]
]);
var $cba9cff9f57093dc$export$ebef9c1f1e15c057 = function generateActivityFiltersV2() {
    var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return (0, $5kNUZ.generateActivityFilters)(filters, function(originalkey, originalFilter) {
        var filter = Array.isArray(originalFilter) && $cba9cff9f57093dc$var$FILTERS_TO_TRANSFORM__UPPERCASE.includes(originalkey) ? originalFilter.map(function(f) {
            return f.toUpperCase();
        }) : originalFilter;
        var key = $cba9cff9f57093dc$var$KEYS_TO_TRANSFROM.has(originalkey) ? $cba9cff9f57093dc$var$KEYS_TO_TRANSFROM.get(originalkey) : originalkey;
        return (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))({}, key, filter);
    });
};

});
parcelRegister("5kNUZ", function(module, exports) {

$parcel$export(module.exports, "generateActivityFilters", function () { return $3e258ab5b16030e1$export$23c75313f46dd54e; });

var $jjExS = parcelRequire("jjExS");

var $e6gyJ = parcelRequire("e6gyJ");
function $3e258ab5b16030e1$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $3e258ab5b16030e1$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $3e258ab5b16030e1$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $3e258ab5b16030e1$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $3e258ab5b16030e1$export$23c75313f46dd54e = function generateActivityFilters() {
    var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var transform = arguments.length > 1 ? arguments[1] : undefined;
    var rootLevelFilters = arguments.length > 2 ? arguments[2] : undefined;
    return Object.entries(filters).reduce(function(acc, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($e6gyJ)))(_ref, 2), key = _ref2[0], filter = _ref2[1];
        var entry = transform ? transform(key, filter) : (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))({}, key, filter);
        return rootLevelFilters !== null && rootLevelFilters !== void 0 && rootLevelFilters.includes(key) ? $3e258ab5b16030e1$var$_objectSpread($3e258ab5b16030e1$var$_objectSpread({}, acc), entry) : $3e258ab5b16030e1$var$_objectSpread($3e258ab5b16030e1$var$_objectSpread({}, acc), {}, {
            arguments: $3e258ab5b16030e1$var$_objectSpread($3e258ab5b16030e1$var$_objectSpread({}, acc.arguments), entry)
        });
    }, {
        type: "AND",
        arguments: {}
    });
};

});



parcelRegister("lPjbd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe3d3d1c7ae5fc54$export$2e2bcd8739ae039; });

var $04Kcc = parcelRequire("04Kcc");

var $hu5TE = parcelRequire("hu5TE");
var $fe3d3d1c7ae5fc54$var$_excluded = [
    "limit",
    "actors"
];
/**
 * This is the query builder for the v2 - myActivity API
 *
 * @param filters
 */ var $fe3d3d1c7ae5fc54$var$generateV2MyActivityFilters = function generateV2MyActivityFilters() {
    var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var limit = filters.limit, actors = filters.actors, restFilters = (0, (/*@__PURE__*/$parcel$interopDefault($04Kcc)))(filters, $fe3d3d1c7ae5fc54$var$_excluded);
    return (0, $hu5TE.generateActivityFiltersV2)(restFilters);
};
var $fe3d3d1c7ae5fc54$export$2e2bcd8739ae039 = $fe3d3d1c7ae5fc54$var$generateV2MyActivityFilters;

});


parcelRegister("9vENa", function(module, exports) {

$parcel$export(module.exports, "ACTIVITY_FILTER_V3_MAP", function () { return $6ec6a6c2a39acb5c$export$9a1782843b6e99d2; });

var $6Boay = parcelRequire("6Boay");

var $f5a7p = parcelRequire("f5a7p");
var $6ec6a6c2a39acb5c$export$9a1782843b6e99d2 = new Map([
    [
        "myActivity",
        (0, $f5a7p.default)
    ],
    [
        "activities",
        (0, $6Boay.default)
    ]
]);

});
parcelRegister("6Boay", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ce8f24ad25d1d7b$export$2e2bcd8739ae039; });

var $04Kcc = parcelRequire("04Kcc");

var $5tQYj = parcelRequire("5tQYj");
var $4ce8f24ad25d1d7b$var$_excluded = [
    "limit"
];
/**
 * This is the query builder for the v3 - activities API
 *
 * @param filters
 */ var $4ce8f24ad25d1d7b$var$generateV3ActivityFilters = function generateV3ActivityFilters() {
    var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var limit = filters.limit, restFilters = (0, (/*@__PURE__*/$parcel$interopDefault($04Kcc)))(filters, $4ce8f24ad25d1d7b$var$_excluded);
    return (0, $5tQYj.generateActivityFiltersV3)(restFilters);
};
var $4ce8f24ad25d1d7b$export$2e2bcd8739ae039 = $4ce8f24ad25d1d7b$var$generateV3ActivityFilters;

});
parcelRegister("5tQYj", function(module, exports) {

$parcel$export(module.exports, "generateActivityFiltersV3", function () { return $3fd8c04967f41a18$export$e73fe7ded3fe2664; });

var $jjExS = parcelRequire("jjExS");

var $5kNUZ = parcelRequire("5kNUZ");
// in V2 API the values for certain filters should be in UPPERCASE as are ENUMs in the GraphQL
// likewise for the V3 handler we should ensure we do appropriate lowercase conversion
var $3fd8c04967f41a18$var$FILTERS_TO_TRANSFORM__LOWERCASE = [
    "products",
    "eventTypes",
    "objectTypes"
];
var $3fd8c04967f41a18$var$ROOT_LEVEL_FILTERS = [
    "actors",
    "rootContainerIds"
];
var $3fd8c04967f41a18$export$e73fe7ded3fe2664 = function generateActivityFiltersV3() {
    var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return (0, $5kNUZ.generateActivityFilters)(filters, function(key, filter) {
        return Array.isArray(filter) && $3fd8c04967f41a18$var$FILTERS_TO_TRANSFORM__LOWERCASE.includes(key) ? (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))({}, key, filter.map(function(f) {
            return f.toLowerCase();
        })) : (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))({}, key, filter);
    }, $3fd8c04967f41a18$var$ROOT_LEVEL_FILTERS);
};

});


parcelRegister("f5a7p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $afaf2bf7e32ef8e8$export$2e2bcd8739ae039; });

var $04Kcc = parcelRequire("04Kcc");

var $5tQYj = parcelRequire("5tQYj");
var $afaf2bf7e32ef8e8$var$_excluded = [
    "limit",
    "actors"
];
/**
 * This is the query builder for the v3 - myActivity API
 *
 * @param filters
 */ var $afaf2bf7e32ef8e8$var$generateV3MyActivityFilters = function generateV3MyActivityFilters() {
    var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var limit = filters.limit, actors = filters.actors, restFilters = (0, (/*@__PURE__*/$parcel$interopDefault($04Kcc)))(filters, $afaf2bf7e32ef8e8$var$_excluded);
    return (0, $5tQYj.generateActivityFiltersV3)(restFilters);
};
var $afaf2bf7e32ef8e8$export$2e2bcd8739ae039 = $afaf2bf7e32ef8e8$var$generateV3MyActivityFilters;

});




parcelRegister("c5oYN", function(module, exports) {

$parcel$export(module.exports, "transformActivitiesItems", function () { return $8cc9541472b194f9$export$306a8b649360ca6f; });
var $8cc9541472b194f9$var$SITE_ARI_PREFIX = "ari:cloud:platform::site/";
function $8cc9541472b194f9$export$306a8b649360ca6f(query) {
    var activities = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!activities || !activities.nodes) return [];
    return activities.nodes.map(function(item) {
        var object = item.object, timestamp = item.timestamp;
        var cloudId = object.cloudId, events = object.events, extension = object.extension, iconUrl = object.iconUrl, id = object.id, localResourceId = object.localResourceId, name = object.name, product = object.product, url = object.url, type = object.type;
        // V2 returns eventType captilised, V3 returns lowercase
        var eventType = events[0].eventType.toLowerCase();
        var issueKey = extension && extension.issueKey;
        var containers = [];
        if (issueKey) containers.push({
            name: issueKey
        });
        if (Array.isArray(object.containers)) containers = containers.concat(object.containers);
        containers = containers.filter(function(container) {
            return !!container.name;
        });
        return {
            query: query,
            containers: containers,
            contributors: (object.contributors || []).reduce(function(contributors, contributor) {
                if (contributor.profile) {
                    var _contributor$profile = contributor.profile, accountId = _contributor$profile.accountId, picture = _contributor$profile.picture;
                    contributors.push({
                        accountId: accountId,
                        name: contributor.profile.name,
                        picture: picture
                    });
                }
                return contributors;
            }, []),
            eventType: eventType,
            object: {
                rootContainerIdentifier: {
                    id: cloudId,
                    type: "SITE",
                    ari: "".concat($8cc9541472b194f9$var$SITE_ARI_PREFIX).concat(cloudId)
                },
                deduplicateId: id,
                icon: {
                    type: "URL",
                    value: iconUrl
                },
                id: id,
                localResourceId: localResourceId,
                name: name,
                product: product,
                subProduct: null,
                type: type,
                url: url
            },
            timestamp: timestamp
        };
    });
}

});



parcelRegister("j5Mot", function(module, exports) {

$parcel$export(module.exports, "ActivityClientV3", function () { return $de6405ef95e5f809$export$3c3c237c92ca1fb9; });

var $e8dor = parcelRequire("e8dor");

var $2Yk1N = parcelRequire("2Yk1N");

var $6QU8A = parcelRequire("6QU8A");

var $hgJzq = parcelRequire("hgJzq");

var $eZhUW = parcelRequire("eZhUW");

var $kcuts = parcelRequire("kcuts");

var $6pDhi = parcelRequire("6pDhi");

var $jjExS = parcelRequire("jjExS");

var $fGIeY = parcelRequire("fGIeY");

var $lCDpQ = parcelRequire("lCDpQ");

var $aMSmJ = parcelRequire("aMSmJ");

var $lyMYQ = parcelRequire("lyMYQ");

var $a0gqW = parcelRequire("a0gqW");

var $8X2jc = parcelRequire("8X2jc");

var $k8HJ7 = parcelRequire("k8HJ7");

var $9RDlE = parcelRequire("9RDlE");

var $iRrle = parcelRequire("iRrle");

var $1gLMm = parcelRequire("1gLMm");

var $droAA = parcelRequire("droAA");

var $5sy5L = parcelRequire("5sy5L");

var $7lDUt = parcelRequire("7lDUt");

var $24cQF = parcelRequire("24cQF");

var $hRpCS = parcelRequire("hRpCS");

var $j6kYC = parcelRequire("j6kYC");
function $de6405ef95e5f809$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $de6405ef95e5f809$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $de6405ef95e5f809$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $de6405ef95e5f809$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $de6405ef95e5f809$var$_arrayLikeToArray(o, minLen);
}
function $de6405ef95e5f809$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $de6405ef95e5f809$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $de6405ef95e5f809$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $de6405ef95e5f809$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $de6405ef95e5f809$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $de6405ef95e5f809$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $de6405ef95e5f809$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($6pDhi)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($6pDhi)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($kcuts)))(this, result);
    };
}
function $de6405ef95e5f809$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $de6405ef95e5f809$var$CONFLUENCE_COMMENT_TYPENAMES = [
    "ConfluenceComment",
    "ConfluenceFooterComment",
    "ConfluenceInlineComment"
];
var $de6405ef95e5f809$var$IGNORED_HTTP_ERRORS = new Map([
    // ignore all 401 errors
    [
        401,
        [
            /.*/
        ]
    ],
    [
        403,
        [
            /Invalid CORS request/
        ]
    ]
]);
var $de6405ef95e5f809$var$IGNORED_ERROR_MESSAGES = [
    "The operation was aborted."
];
var $de6405ef95e5f809$var$DEFAULT_TAGS = {
    source: (0, $lyMYQ.packageName),
    sourcePackageVersion: (0, $lyMYQ.packageVersion)
};
var $de6405ef95e5f809$export$3c3c237c92ca1fb9 = /*#__PURE__*/ function(_ActivityClient) {
    (0, (/*@__PURE__*/$parcel$interopDefault($eZhUW)))(ActivityClientV3, _ActivityClient);
    var _super = $de6405ef95e5f809$var$_createSuper(ActivityClientV3);
    function ActivityClientV3(_product, baseUrl, logger, configFetch) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($6QU8A)))(this, ActivityClientV3);
        _this = _super.call(this, "v3", _product, {
            "X-ExperimentalApi": "ActivityV3Api"
        }, baseUrl);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))((0, (/*@__PURE__*/$parcel$interopDefault($hgJzq)))(_this), "setProduct", function(product) {
            _this.product = product;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))((0, (/*@__PURE__*/$parcel$interopDefault($hgJzq)))(_this), "captureException", function(error, tags) {
            if (_this.clientHandlers) _this.clientHandlers.captureException(error, $de6405ef95e5f809$var$_objectSpread($de6405ef95e5f809$var$_objectSpread({}, $de6405ef95e5f809$var$DEFAULT_TAGS), tags));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))((0, (/*@__PURE__*/$parcel$interopDefault($hgJzq)))(_this), "captureWarning", function(message, tags) {
            if (_this.clientHandlers) _this.clientHandlers.captureWarning(message, $de6405ef95e5f809$var$_objectSpread($de6405ef95e5f809$var$_objectSpread({}, $de6405ef95e5f809$var$DEFAULT_TAGS), tags));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))((0, (/*@__PURE__*/$parcel$interopDefault($hgJzq)))(_this), "fetchHydratorConfig", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($e8dor)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).mark(function _callee() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        _context.next = 2;
                        return _this.hydratorConfigClient.fetchConfig();
                    case 2:
                        return _context.abrupt("return", _context.sent);
                    case 3:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        })));
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))((0, (/*@__PURE__*/$parcel$interopDefault($hgJzq)))(_this), "handleGraphQLErrors", function(errors) {
            var invalidFragments = [];
            if (Array.isArray(errors)) {
                var _iterator = $de6405ef95e5f809$var$_createForOfIteratorHelper(errors), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var _$err = _step.value;
                        _this.captureException(new (0, $9RDlE.GraphQLJSError)(_$err));
                        var invalidFragment = (0, $24cQF.default)(_$err);
                        if (invalidFragment) invalidFragments.push(invalidFragment);
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                return invalidFragments;
            }
            return [];
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))((0, (/*@__PURE__*/$parcel$interopDefault($hgJzq)))(_this), "fetchActivitiesV3", /*#__PURE__*/ function() {
            var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($e8dor)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).mark(function _callee3(experience, retryMS, filters, activityQueries) {
                var _response$data, _activityRoot, _activityRoot$workedO, _response$data$activi, _response$data$activi2, _response$data$activi3, _activityRoot2, _activityRoot2$all;
                var deduplicateActivities, _yield$_this$fetchHyd, fragments, hydrators, response, _IGNORED_HTTP_ERRORS$, workedOn, viewed, all, activities, _args3 = arguments;
                return (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).wrap(function _callee3$(_context3) {
                    while(true)switch(_context3.prev = _context3.next){
                        case 0:
                            deduplicateActivities = _args3.length > 4 && _args3[4] !== undefined ? _args3[4] : true;
                            _context3.next = 3;
                            return _this.fetchHydratorConfig();
                        case 3:
                            _yield$_this$fetchHyd = _context3.sent;
                            fragments = _yield$_this$fetchHyd.fragments;
                            hydrators = _yield$_this$fetchHyd.hydrators;
                            experience.mark("GeneratedQueryWithFilters_start");
                            _context3.prev = 7;
                            _context3.next = 10;
                            return (0, $lCDpQ.retryOnException)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($e8dor)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).mark(function _callee2() {
                                var request, res, invalidFragments;
                                return (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).wrap(function _callee2$(_context2) {
                                    while(true)switch(_context2.prev = _context2.next){
                                        case 0:
                                            request = (0, $hRpCS.generateGraphQLRequest)(_this.product, filters, activityQueries, fragments);
                                            experience.mark("GeneratedQueryWithFilters_end");
                                            experience.mark("FetchedActivities_start");
                                            experience.addMetadata({
                                                filters: (0, $j6kYC.filtersToMetadata)(filters)
                                            });
                                            _context2.next = 6;
                                            return (0, $8X2jc.postResource)(_this.baseUrl, request, retryMS, $de6405ef95e5f809$var$_objectSpread({}, _this.headers));
                                        case 6:
                                            res = _context2.sent;
                                            experience.mark("FetchedActivities_end");
                                            invalidFragments = _this.handleGraphQLErrors(res === null || res === void 0 ? void 0 : res.errors);
                                            if (!(invalidFragments.length > 0)) {
                                                _context2.next = 12;
                                                break;
                                            }
                                            fragments = (0, $j6kYC.filterInvalidFragments)(invalidFragments, fragments);
                                            throw new (0, $k8HJ7.GraphQLFragmentError)("Missing fragments: [".concat(invalidFragments.toString(), "]"));
                                        case 12:
                                            return _context2.abrupt("return", res);
                                        case 13:
                                        case "end":
                                            return _context2.stop();
                                    }
                                }, _callee2);
                            })), {
                                intervalsMS: [
                                    0,
                                    0,
                                    0
                                ],
                                retryOn: function retryOn(err) {
                                    return [
                                        (0, $k8HJ7.GraphQLFragmentError)
                                    ].some(function(retriableErr) {
                                        return err instanceof retriableErr;
                                    });
                                },
                                captureException: _this.captureException
                            });
                        case 10:
                            response = _context3.sent;
                            _context3.next = 17;
                            break;
                        case 13:
                            _context3.prev = 13;
                            _context3.t0 = _context3["catch"](7);
                            if (!(!_context3.t0 || !((_IGNORED_HTTP_ERRORS$ = $de6405ef95e5f809$var$IGNORED_HTTP_ERRORS.get(_context3.t0.statusCode)) !== null && _IGNORED_HTTP_ERRORS$ !== void 0 && _IGNORED_HTTP_ERRORS$.some(function(regExp) {
                                return regExp.test(_context3.t0.message);
                            })) && !$de6405ef95e5f809$var$IGNORED_ERROR_MESSAGES.includes(_context3.t0.message))) {
                                _context3.next = 17;
                                break;
                            }
                            throw _context3.t0;
                        case 17:
                            if (!(0, $j6kYC.isEmptyActivitiesWithErrorsResponse)(response)) {
                                _context3.next = 19;
                                break;
                            }
                            throw new (0, $iRrle.GraphQLNoResultsError)(response.errors);
                        case 19:
                            if (!(!response || !((_response$data = response.data) !== null && _response$data !== void 0 && _response$data.activity))) {
                                _context3.next = 21;
                                break;
                            }
                            return _context3.abrupt("return", {
                                workedOn: [],
                                viewed: [],
                                all: []
                            });
                        case 21:
                            experience.mark("TransformedActivityItems_start");
                            workedOn = $de6405ef95e5f809$var$transformActivityItem("workedOn", ((_activityRoot = (0, $j6kYC.activityRoot)(response.data.activity)) === null || _activityRoot === void 0 ? void 0 : (_activityRoot$workedO = _activityRoot.workedOn) === null || _activityRoot$workedO === void 0 ? void 0 : _activityRoot$workedO.edges) || [], hydrators, _this.captureException); // We don't need the activity root function here as viewed only exists on myActivity
                            viewed = $de6405ef95e5f809$var$transformActivityItem("viewed", ((_response$data$activi = response.data.activity) === null || _response$data$activi === void 0 ? void 0 : (_response$data$activi2 = _response$data$activi.myActivity) === null || _response$data$activi2 === void 0 ? void 0 : (_response$data$activi3 = _response$data$activi2.viewed) === null || _response$data$activi3 === void 0 ? void 0 : _response$data$activi3.edges) || [], hydrators, _this.captureException);
                            all = $de6405ef95e5f809$var$transformActivityItem("all", ((_activityRoot2 = (0, $j6kYC.activityRoot)(response.data.activity)) === null || _activityRoot2 === void 0 ? void 0 : (_activityRoot2$all = _activityRoot2.all) === null || _activityRoot2$all === void 0 ? void 0 : _activityRoot2$all.edges) || [], hydrators, _this.captureException);
                            experience.mark("TransformedActivityItems_end");
                            activities = {
                                viewed: viewed,
                                workedOn: workedOn,
                                all: all
                            };
                            return _context3.abrupt("return", deduplicateActivities ? (0, $j6kYC.rollupActivitiesData)(activities) : activities);
                        case 28:
                        case "end":
                            return _context3.stop();
                    }
                }, _callee3, null, [
                    [
                        7,
                        13
                    ]
                ]);
            }));
            return function(_x, _x2, _x3, _x4) {
                return _ref2.apply(this, arguments);
            };
        }());
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))((0, (/*@__PURE__*/$parcel$interopDefault($hgJzq)))(_this), "fetchActivities", /*#__PURE__*/ function() {
            var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($e8dor)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).mark(function _callee4(retryMS, filters, activityQueries) {
                var deduplicateActivities, _args4 = arguments;
                return (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).wrap(function _callee4$(_context4) {
                    while(true)switch(_context4.prev = _context4.next){
                        case 0:
                            deduplicateActivities = _args4.length > 3 && _args4[3] !== undefined ? _args4[3] : true;
                            return _context4.abrupt("return", (0, $a0gqW.fetchActivitiesWithExperience)(function(experience) {
                                return _this.fetchActivitiesV3(experience, retryMS, filters, activityQueries, deduplicateActivities);
                            }, "v3"));
                        case 2:
                        case "end":
                            return _context4.stop();
                    }
                }, _callee4);
            }));
            return function(_x5, _x6, _x7) {
                return _ref4.apply(this, arguments);
            };
        }());
        _this.clientHandlers = logger;
        _this.hydratorConfigClient = new (0, $5sy5L.default)({
            captureException: _this.captureException,
            captureWarning: _this.captureWarning
        }, _product, configFetch);
        return _this;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($2Yk1N)))(ActivityClientV3);
}((0, $7lDUt.ActivityClient));
function $de6405ef95e5f809$var$transformActivityItem(query, activities, hydrators, captureException) {
    return activities.reduce(function(acc, item) {
        if (item && item.node && item.node.object && item.node.event) {
            var _item$node = item.node, object = _item$node.object, event = _item$node.event;
            if (!object.product || !object.type) return acc;
            var containers = [];
            var c = object.contributors || [];
            var contributors = c.reduce(function(contributors, contributor) {
                if (contributor.profile) {
                    var _contributor$profile = contributor.profile, accountId = _contributor$profile.accountId, picture = _contributor$profile.picture;
                    contributors.push({
                        accountId: accountId,
                        name: contributor.profile.name,
                        picture: picture
                    });
                }
                return contributors;
            }, []);
            var hydratedData = (0, $1gLMm.hydratePolymorphicData)(hydrators, object.data, captureException);
            if (hydratedData) {
                var _object$data, _object$data$containe;
                if (hydratedData.key) containers.push({
                    name: (0, $droAA.hydratedValueToString)(hydratedData.key, " ")
                });
                if (hydratedData.containers) containers.push({
                    name: (0, $droAA.hydratedValueToString)(hydratedData.containers, " ")
                });
                var actor = event.actor ? {
                    name: event.actor.name,
                    picture: event.actor.picture,
                    accountId: event.actor.accountId
                } : undefined;
                // The V3 API returns "Created" for a new comment, we want this to display as "Commented"
                var eventType = object.type === "comment" && event.eventType === (0, $aMSmJ.WORKED_EVENT).CREATED ? (0, $aMSmJ.WORKED_EVENT).COMMENTED : event.eventType;
                acc.push({
                    actor: actor,
                    query: query,
                    containers: containers,
                    contributors: contributors,
                    eventType: eventType,
                    object: {
                        rootContainerIdentifier: (0, $j6kYC.parseRootContainerARI)(object.rootContainerId),
                        icon: $de6405ef95e5f809$var$CONFLUENCE_COMMENT_TYPENAMES.includes(object.data.__typename) ? (0, $droAA.hydrateConfluenceIcon)((_object$data = object.data) === null || _object$data === void 0 ? void 0 : (_object$data$containe = _object$data.container) === null || _object$data$containe === void 0 ? void 0 : _object$data$containe.__typename, hydratedData.icon, hydratedData.staticFallbacks) : (0, $droAA.hydrateIcon)(hydratedData.icon, hydratedData.staticFallbacks),
                        id: object.id,
                        deduplicateId: (0, $droAA.hydratedValueToString)(hydratedData.deduplicateId) || object.id,
                        localResourceId: (0, $droAA.hydratedValueToString)(hydratedData.localResourceId),
                        name: (0, $droAA.hydratedValueToString)(hydratedData.name, " "),
                        product: object.product,
                        subProduct: object.subProduct,
                        type: object.type,
                        url: (0, $droAA.hydratedValueToString)(hydratedData.url)
                    },
                    timestamp: event.timestamp
                });
            }
        }
        return acc;
    }, []);
}

});
parcelRegister("k8HJ7", function(module, exports) {

$parcel$export(module.exports, "GraphQLFragmentError", function () { return $ea967939e8e58d6b$export$2d1b192199788179; });

var $2Yk1N = parcelRequire("2Yk1N");

var $6QU8A = parcelRequire("6QU8A");

var $eZhUW = parcelRequire("eZhUW");

var $kcuts = parcelRequire("kcuts");

var $6pDhi = parcelRequire("6pDhi");

var $8B3ag = parcelRequire("8B3ag");
function $ea967939e8e58d6b$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $ea967939e8e58d6b$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($6pDhi)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($6pDhi)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($kcuts)))(this, result);
    };
}
function $ea967939e8e58d6b$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $ea967939e8e58d6b$export$2d1b192199788179 = /*#__PURE__*/ function(_Error) {
    (0, (/*@__PURE__*/$parcel$interopDefault($eZhUW)))(GraphQLFragmentError, _Error);
    var _super = $ea967939e8e58d6b$var$_createSuper(GraphQLFragmentError);
    function GraphQLFragmentError(message) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($6QU8A)))(this, GraphQLFragmentError);
        _this = _super.call(this, message);
        _this.name = "GraphQLFragmentError";
        _this.message = message;
        return _this;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($2Yk1N)))(GraphQLFragmentError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8B3ag)))(Error));

});

parcelRegister("9RDlE", function(module, exports) {

$parcel$export(module.exports, "GraphQLJSError", function () { return $72e7960933e8020b$export$8d4af49ee2a0fbe2; });

var $2Yk1N = parcelRequire("2Yk1N");

var $6QU8A = parcelRequire("6QU8A");

var $eZhUW = parcelRequire("eZhUW");

var $kcuts = parcelRequire("kcuts");

var $6pDhi = parcelRequire("6pDhi");

var $8B3ag = parcelRequire("8B3ag");
function $72e7960933e8020b$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $72e7960933e8020b$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($6pDhi)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($6pDhi)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($kcuts)))(this, result);
    };
}
function $72e7960933e8020b$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $72e7960933e8020b$export$8d4af49ee2a0fbe2 = /*#__PURE__*/ function(_Error) {
    (0, (/*@__PURE__*/$parcel$interopDefault($eZhUW)))(GraphQLJSError, _Error);
    var _super = $72e7960933e8020b$var$_createSuper(GraphQLJSError);
    function GraphQLJSError(graphQLError) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($6QU8A)))(this, GraphQLJSError);
        _this = _super.call(this, graphQLError.message);
        _this.name = "GraphQLJSError";
        _this.error = graphQLError;
        _this.message = graphQLError.message;
        return _this;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($2Yk1N)))(GraphQLJSError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8B3ag)))(Error));

});

parcelRegister("iRrle", function(module, exports) {

$parcel$export(module.exports, "GraphQLNoResultsError", function () { return $dbb262adcecd337d$export$3f19ff30d409b70; });

var $2Yk1N = parcelRequire("2Yk1N");

var $6QU8A = parcelRequire("6QU8A");

var $eZhUW = parcelRequire("eZhUW");

var $kcuts = parcelRequire("kcuts");

var $6pDhi = parcelRequire("6pDhi");

var $8B3ag = parcelRequire("8B3ag");
function $dbb262adcecd337d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $dbb262adcecd337d$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($6pDhi)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($6pDhi)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($kcuts)))(this, result);
    };
}
function $dbb262adcecd337d$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $dbb262adcecd337d$export$3f19ff30d409b70 = /*#__PURE__*/ function(_Error) {
    (0, (/*@__PURE__*/$parcel$interopDefault($eZhUW)))(GraphQLNoResultsError, _Error);
    var _super = $dbb262adcecd337d$var$_createSuper(GraphQLNoResultsError);
    function GraphQLNoResultsError(graphQLErrors) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($6QU8A)))(this, GraphQLNoResultsError);
        _this = _super.call(this);
        _this.name = "GraphQLNoResultsError";
        _this.errors = graphQLErrors;
        _this.message = "GraphQL returned errors & no results";
        _this.errorMessages = graphQLErrors.map(function(error) {
            return error.message;
        });
        return _this;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($2Yk1N)))(GraphQLNoResultsError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8B3ag)))(Error));

});

parcelRegister("1gLMm", function(module, exports) {

$parcel$export(module.exports, "hydratePolymorphicData", function () { return $0ecc590270d0f240$export$d658049bf1a63492; });

var $jjExS = parcelRequire("jjExS");

var $e6gyJ = parcelRequire("e6gyJ");

var $gnlCg = parcelRequire("gnlCg");

var $e6ETf = parcelRequire("e6ETf");
function $0ecc590270d0f240$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $0ecc590270d0f240$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $0ecc590270d0f240$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $0ecc590270d0f240$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $0ecc590270d0f240$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $0ecc590270d0f240$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $0ecc590270d0f240$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $0ecc590270d0f240$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $0ecc590270d0f240$var$_arrayLikeToArray(o, minLen);
}
function $0ecc590270d0f240$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $0ecc590270d0f240$export$d658049bf1a63492 = function hydratePolymorphicData(hydrators, data, captureException) {
    if (data) {
        if ("__typename" in data) {
            var hydrator = hydrators[data.__typename];
            if (hydrator) try {
                return $0ecc590270d0f240$var$hydrateData(data, hydrator);
            } catch (error) {
                captureException && captureException(new (0, $e6ETf.default)({
                    error: error,
                    message: "Hydrator failed for [".concat(data.__typename, "].")
                }));
            }
            else captureException && captureException(new (0, $e6ETf.default)({
                message: "Missing hydrator for [".concat(data.__typename, "].")
            }));
        } else captureException && captureException(new (0, $e6ETf.default)({
            message: "Missing [__typename] field from data."
        }));
    }
    return null;
};
function $0ecc590270d0f240$var$getOrSearch(object, path) {
    if (!object) return object;
    if (path.includes(":")) {
        var _path$split = path.split(":"), _path$split2 = (0, (/*@__PURE__*/$parcel$interopDefault($e6gyJ)))(_path$split, 2), searchField = _path$split2[0], searchValue = _path$split2[1];
        return $0ecc590270d0f240$var$findNodeByField(object, searchField.trim(), searchValue.trim().replace(/"/g, "") // Strip any preceding whitesepace and quotes
        );
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($gnlCg)))(object, path);
}
function $0ecc590270d0f240$var$resolvePath(object, path) {
    // Split the path on each bracket
    var splitPath = path.split(/\(|\)./);
    // Traverse the split path as a tree, resolving as we go
    var current = object;
    var _iterator = $0ecc590270d0f240$var$_createForOfIteratorHelper(splitPath), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var split = _step.value;
            current = $0ecc590270d0f240$var$getOrSearch(current, split);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return current;
}
function $0ecc590270d0f240$var$findNodeByField(edges, fieldId, searchValue) {
    return edges.find(function(edge) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($gnlCg)))(edge, fieldId) === searchValue;
    });
}
function $0ecc590270d0f240$export$a5c4301012ad6f07(object, paths) {
    return paths.map(function(path) {
        return $0ecc590270d0f240$var$resolvePath(object, path);
    });
}
var $0ecc590270d0f240$var$hydrateData = function hydrateData(data, hydrator) {
    var hydratorPaths = hydrator.hydratorPaths, staticFallbacks = hydrator.staticFallbacks;
    return $0ecc590270d0f240$var$_objectSpread({
        staticFallbacks: staticFallbacks
    }, Object.entries(hydratorPaths).reduce(function(acc, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($e6gyJ)))(_ref, 2), key = _ref2[0], dataValue = _ref2[1];
        var item = $0ecc590270d0f240$export$a5c4301012ad6f07(data, dataValue);
        if (item) acc[key] = item;
        else throw new Error("Bad hydrator path: ".concat(key));
        return acc;
    }, {}));
};

});
parcelRegister("e6ETf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4515820c89cde6b$export$2e2bcd8739ae039; });

var $2Yk1N = parcelRequire("2Yk1N");

var $6QU8A = parcelRequire("6QU8A");

var $eZhUW = parcelRequire("eZhUW");

var $kcuts = parcelRequire("kcuts");

var $6pDhi = parcelRequire("6pDhi");

var $8B3ag = parcelRequire("8B3ag");
function $a4515820c89cde6b$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $a4515820c89cde6b$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($6pDhi)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($6pDhi)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($kcuts)))(this, result);
    };
}
function $a4515820c89cde6b$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $a4515820c89cde6b$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Error) {
    (0, (/*@__PURE__*/$parcel$interopDefault($eZhUW)))(HydratorError, _Error);
    var _super = $a4515820c89cde6b$var$_createSuper(HydratorError);
    function HydratorError(_ref) {
        var _this;
        var error = _ref.error, message = _ref.message;
        (0, (/*@__PURE__*/$parcel$interopDefault($6QU8A)))(this, HydratorError);
        _this = _super.call(this);
        var err = error instanceof Error ? error : new Error();
        _this.name = "HydratorError";
        _this.message = message;
        _this.originalMessage = err.message;
        _this.stack = err.stack;
        _this.originalName = err.name;
        return _this;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($2Yk1N)))(HydratorError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8B3ag)))(Error));

});


parcelRegister("droAA", function(module, exports) {

$parcel$export(module.exports, "hydratedValueToString", function () { return $9c90ded97cce3b0f$export$c5cea44a1f75b431; });
$parcel$export(module.exports, "hydrateConfluenceIcon", function () { return $9c90ded97cce3b0f$export$86b9f44277b105a6; });
$parcel$export(module.exports, "hydrateIcon", function () { return $9c90ded97cce3b0f$export$a328b2bb0d21d984; });

var $2nffd = parcelRequire("2nffd");
var $9c90ded97cce3b0f$export$c5cea44a1f75b431 = function hydratedValueToString(value) {
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    if (!value) return null;
    return Array.isArray(value) ? value.join(separator) : value;
};
function $9c90ded97cce3b0f$var$isURL(icon) {
    return typeof icon === "string";
}
function $9c90ded97cce3b0f$var$isValidEmoji(icon) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($2nffd)))(icon) === "object" && icon.value !== undefined && !!icon.value;
}
var $9c90ded97cce3b0f$export$86b9f44277b105a6 = function hydrateConfluenceIcon(confluenceContainerType, icons, fallbacks) {
    switch(confluenceContainerType){
        case "ConfluenceBlogPost":
            return $9c90ded97cce3b0f$export$a328b2bb0d21d984(icons, fallbacks, "confluenceBlogIcon") || $9c90ded97cce3b0f$export$a328b2bb0d21d984(icons, fallbacks);
        case "ConfluencePage":
            return $9c90ded97cce3b0f$export$a328b2bb0d21d984(icons, fallbacks, "confluencePageIcon") || $9c90ded97cce3b0f$export$a328b2bb0d21d984(icons, fallbacks);
        default:
            return $9c90ded97cce3b0f$export$a328b2bb0d21d984(icons, fallbacks);
    }
};
var $9c90ded97cce3b0f$export$a328b2bb0d21d984 = function hydrateIcon(icons, fallbacks) {
    var fallbackKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "icon";
    if (Array.isArray(icons) && icons.length > 0) {
        var emojiIcons = icons.filter($9c90ded97cce3b0f$var$isValidEmoji);
        if (emojiIcons.length > 0) return {
            type: "EMOJI",
            value: emojiIcons[0].value,
            // return the first emoji
            fallback: fallbacks === null || fallbacks === void 0 ? void 0 : fallbacks[fallbackKey]
        };
        var urlIcons = icons.filter($9c90ded97cce3b0f$var$isURL);
        if (urlIcons.length > 0) {
            var hydratedIcons = $9c90ded97cce3b0f$export$c5cea44a1f75b431(urlIcons);
            if (hydratedIcons !== null) return {
                type: "URL",
                value: hydratedIcons
            };
        }
    }
    if (fallbacks && fallbackKey in fallbacks && fallbacks[fallbackKey]) return {
        type: "URL",
        value: fallbacks[fallbackKey]
    };
    return null;
};

});

parcelRegister("24cQF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1815ebf23be5ba3c$export$2e2bcd8739ae039; });

var $2OG1a = parcelRequire("2OG1a");
var $1815ebf23be5ba3c$var$errorHandlerMap = new Map([
    [
        "ValidationError",
        (0, $2OG1a.default)
    ]
]);
var $1815ebf23be5ba3c$var$graphQLErrorHandler = function graphQLErrorHandler(err) {
    var errorHandler = $1815ebf23be5ba3c$var$errorHandlerMap.get(err.extensions.classification);
    if (typeof errorHandler === "function") return errorHandler(err);
    return null;
};
var $1815ebf23be5ba3c$export$2e2bcd8739ae039 = $1815ebf23be5ba3c$var$graphQLErrorHandler;

});
parcelRegister("2OG1a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $20d0d8297581c975$export$2e2bcd8739ae039; });
/**
 * ^Validation error - look for validation errors from the start
 * .*?@ ' - look through everything up to the first instance of "@ '"
 * (\w+) - capture the first word, that's our invalid fragment
 */ var $20d0d8297581c975$var$captureRegex = new RegExp(/^Validation error.*?@ '(\w+)/);
var $20d0d8297581c975$var$validationErrorHandler = function validationErrorHandler(graphQLError) {
    var invalidFragmentMatch = $20d0d8297581c975$var$captureRegex.exec(graphQLError.message);
    if (Array.isArray(invalidFragmentMatch)) {
        var invalidFragment = invalidFragmentMatch[1];
        if (invalidFragment) return invalidFragment;
    }
    return null;
};
var $20d0d8297581c975$export$2e2bcd8739ae039 = $20d0d8297581c975$var$validationErrorHandler;

});


parcelRegister("hRpCS", function(module, exports) {

$parcel$export(module.exports, "generateGraphQLRequest", function () { return $d00b43b4eaa8e0a6$export$7489a6ef09862e48; });

var $04Kcc = parcelRequire("04Kcc");

var $gkElj = parcelRequire("gkElj");

var $jdAs8 = parcelRequire("jdAs8");
var $d00b43b4eaa8e0a6$var$_excluded = [
    "limit"
];
var $d00b43b4eaa8e0a6$var$ACTIVITIES_LIMIT = 50;
var $d00b43b4eaa8e0a6$var$WORKED_ON_QUERY = "\n   workedOn(first: $first, filter: $filter) {\n     ...activityItemConnection\n   }\n";
var $d00b43b4eaa8e0a6$var$VIEWED__QUERY = "\n   viewed(first: $first, filter: $filter) {\n     ...activityItemConnection\n   }\n";
var $d00b43b4eaa8e0a6$var$ALL__QUERY = "\n    all(first: $first, filter: $filter) {\n      ...activityItemConnection\n    }\n";
var $d00b43b4eaa8e0a6$var$activityQueryMap = new Map([
    [
        "workedOn",
        $d00b43b4eaa8e0a6$var$WORKED_ON_QUERY
    ],
    [
        "viewed",
        $d00b43b4eaa8e0a6$var$VIEWED__QUERY
    ],
    [
        "all",
        $d00b43b4eaa8e0a6$var$ALL__QUERY
    ]
]);
var $d00b43b4eaa8e0a6$var$getMyActivitiesQuery = function getMyActivitiesQuery(queries) {
    return "\n      myActivity {\n        ".concat(queries.join("\n"), "\n      }\n");
};
var $d00b43b4eaa8e0a6$var$getActivitiesQuery = function getActivitiesQuery(product, content, fragments) {
    var activityFilterType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "ActivityFilter";
    return "\n    query ".concat((0, $gkElj.getOperationName)(product), "($first: Int, $filter: ").concat(activityFilterType, ") {\n      activity {\n        ").concat(content, "\n      }\n    }\n").concat(fragments, "\n");
};
var $d00b43b4eaa8e0a6$export$855cd08371c65b8c = function generateActivityQueryWithFilters(product, filters, activityQueries, fragments) {
    /**
   * If we are filtering by `actors` then we can't use the `myActivity` query.
   */ if (Array.isArray(filters.actors)) {
        // you can't view `viewed` events for other accounts
        var filteredAccountQueries = activityQueries.filter(function(query) {
            return query !== "viewed";
        });
        return {
            query: $d00b43b4eaa8e0a6$var$getActivitiesQuery(product, filteredAccountQueries.map(function(query) {
                return $d00b43b4eaa8e0a6$var$activityQueryMap.get(query);
            }).join("\n"), fragments, "ActivityFilter"),
            queryFilters: (0, $jdAs8.ACTIVITY_FILTER_COLLECTION).v3.get("activities")(filters)
        };
    } else return {
        query: $d00b43b4eaa8e0a6$var$getActivitiesQuery(product, $d00b43b4eaa8e0a6$var$getMyActivitiesQuery(activityQueries.map(function(query) {
            return $d00b43b4eaa8e0a6$var$activityQueryMap.get(query);
        })), fragments, "MyActivityFilter"),
        queryFilters: (0, $jdAs8.ACTIVITY_FILTER_COLLECTION).v3.get("myActivity")(filters)
    };
};
var $d00b43b4eaa8e0a6$export$7489a6ef09862e48 = function generateGraphQLRequest(product, filters, activityQueries, fragments) {
    var _filters$limit = filters.limit, limit = _filters$limit === void 0 ? $d00b43b4eaa8e0a6$var$ACTIVITIES_LIMIT : _filters$limit, restFilters = (0, (/*@__PURE__*/$parcel$interopDefault($04Kcc)))(filters, $d00b43b4eaa8e0a6$var$_excluded);
    var _generateActivityQuer = $d00b43b4eaa8e0a6$export$855cd08371c65b8c(product, restFilters, activityQueries, fragments), query = _generateActivityQuer.query, queryFilters = _generateActivityQuer.queryFilters;
    return {
        operationName: (0, $gkElj.getOperationName)(product),
        query: query,
        variables: {
            first: limit,
            filter: queryFilters
        }
    };
};

});

parcelRegister("j6kYC", function(module, exports) {

$parcel$export(module.exports, "rollupActivitiesData", function () { return $de7ed96869db3ac7$export$750d93207e30f59a; });
$parcel$export(module.exports, "activityRoot", function () { return $de7ed96869db3ac7$export$ea55e8e0446efa94; });
$parcel$export(module.exports, "parseRootContainerARI", function () { return $de7ed96869db3ac7$export$788e6013936a6bb4; });
$parcel$export(module.exports, "filtersToMetadata", function () { return $de7ed96869db3ac7$export$e8f56bed6776c7ea; });
$parcel$export(module.exports, "filterInvalidFragments", function () { return $de7ed96869db3ac7$export$e22863ec502608d2; });
$parcel$export(module.exports, "isEmptyActivitiesWithErrorsResponse", function () { return $de7ed96869db3ac7$export$c939d6148e47244a; });

var $jjExS = parcelRequire("jjExS");

var $eetQ9 = parcelRequire("eetQ9");
function $de7ed96869db3ac7$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $de7ed96869db3ac7$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $de7ed96869db3ac7$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $de7ed96869db3ac7$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $de7ed96869db3ac7$export$750d93207e30f59a(activitiesData) {
    var all = activitiesData.all, viewed = activitiesData.viewed, workedOn = activitiesData.workedOn;
    return {
        all: $de7ed96869db3ac7$var$rollUpActivityItems(all),
        viewed: $de7ed96869db3ac7$var$rollUpActivityItems(viewed),
        workedOn: $de7ed96869db3ac7$var$rollUpActivityItems(workedOn)
    };
}
function $de7ed96869db3ac7$var$rollUpActivityItems(activityItems) {
    // https://stackoverflow.com/a/49460534
    // creates an ordered 'hashmap' containing unique ids in the same order that the activity items appear
    var latestActivityItemsObjectWithLatestTimestamp = activityItems.reduce(function(acc, activityItem) {
        var deduplicateId = activityItem.object.deduplicateId || activityItem.object.id;
        var existingItem = acc[deduplicateId];
        if (existingItem) {
            var aggregatedItems = existingItem.aggregatedActivityItems || [];
            if (Date.parse(existingItem.timestamp) < Date.parse(activityItem.timestamp)) {
                activityItem.aggregatedActivityItems = [].concat((0, (/*@__PURE__*/$parcel$interopDefault($eetQ9)))(aggregatedItems), [
                    existingItem
                ]);
                // remove the current activity for that id so when we add the more recent activity it is in the order that it appears
                delete acc[deduplicateId];
                acc[deduplicateId] = activityItem;
            } else acc[deduplicateId].aggregatedActivityItems = [].concat((0, (/*@__PURE__*/$parcel$interopDefault($eetQ9)))(aggregatedItems), [
                activityItem
            ]);
        } else acc[deduplicateId] = activityItem;
        return acc;
    }, {});
    return Object.values(latestActivityItemsObjectWithLatestTimestamp);
}
var $de7ed96869db3ac7$export$213ba2e9f2d143b9 = function extractFragmentRegex(key) {
    return new RegExp("fragment ".concat($de7ed96869db3ac7$var$fragmentName(key), " on ").concat($de7ed96869db3ac7$var$fragmentType(key), " ({(.|\\n)+?(?=fragment))"), "gm");
};
var $de7ed96869db3ac7$var$fragmentName = function fragmentName(key) {
    return key.charAt(0).toLowerCase() + key.slice(1);
};
var $de7ed96869db3ac7$var$fragmentType = function fragmentType(key) {
    return key.charAt(0).toUpperCase() + key.slice(1);
};
var $de7ed96869db3ac7$export$ea55e8e0446efa94 = function activityRoot(activity) {
    if (activity.myActivity) return activity.myActivity;
    return activity;
};
var $de7ed96869db3ac7$var$SITE_ARI_PREFIX = "ari:cloud:platform::site/";
var $de7ed96869db3ac7$var$containerMapTypes = new Map([
    [
        $de7ed96869db3ac7$var$SITE_ARI_PREFIX,
        "SITE"
    ]
]);
function $de7ed96869db3ac7$export$788e6013936a6bb4(rootContainerARI) {
    // the "ID" portion of the ARI begins after the first '/'
    var ariSplitIndex = rootContainerARI.indexOf("/");
    return {
        ari: rootContainerARI,
        id: rootContainerARI.slice(ariSplitIndex + 1),
        type: $de7ed96869db3ac7$var$containerMapTypes.get(rootContainerARI.slice(0, ariSplitIndex + 1)) || "OTHER"
    };
}
function $de7ed96869db3ac7$export$e8f56bed6776c7ea(filters) {
    var _filters$actors, _filters$containerIds, _filters$products, _filters$eventTypes, _filters$objectTypes, _filters$rootContaine;
    return $de7ed96869db3ac7$var$_objectSpread($de7ed96869db3ac7$var$_objectSpread({}, filters), {}, {
        // These have V high cardinality, so using a length
        actors: (_filters$actors = filters.actors) === null || _filters$actors === void 0 ? void 0 : _filters$actors.length,
        containerIds: (_filters$containerIds = filters.containerIds) === null || _filters$containerIds === void 0 ? void 0 : _filters$containerIds.length,
        // comma separated lists
        products: (_filters$products = filters.products) === null || _filters$products === void 0 ? void 0 : _filters$products.join(","),
        eventTypes: (_filters$eventTypes = filters.eventTypes) === null || _filters$eventTypes === void 0 ? void 0 : _filters$eventTypes.join(","),
        objectTypes: (_filters$objectTypes = filters.objectTypes) === null || _filters$objectTypes === void 0 ? void 0 : _filters$objectTypes.join(","),
        rootContainerIds: (_filters$rootContaine = filters.rootContainerIds) === null || _filters$rootContaine === void 0 ? void 0 : _filters$rootContaine.join(",")
    });
}
/**
 * These fragments are the core of our query, without them it will always fail,
 * so we shouldn't remove them. It is possible that removing other offending fragments
 * will fix the error in these core fragments. (e.g. Field conflict)
 */ var $de7ed96869db3ac7$var$RESTRICTED_FRAGMENTS = [
    "activity",
    "all",
    "myActivity",
    "workedOn",
    "viewed",
    "activityItemConnection",
    "activityItemEdge"
];
function $de7ed96869db3ac7$export$e22863ec502608d2(invalidFragments, allFragments) {
    return invalidFragments.filter(function(fragment) {
        return !$de7ed96869db3ac7$var$RESTRICTED_FRAGMENTS.includes(fragment);
    }).reduce(function(acc, invalidFragment) {
        return acc.replace(new RegExp("...".concat(invalidFragment, "\n"), "g"), "").replace($de7ed96869db3ac7$export$213ba2e9f2d143b9(invalidFragment), "");
    }, allFragments);
}
var $de7ed96869db3ac7$var$IGNORED_ERROR_CLASSIFICATIONS = [
    "IncorrectAuthException"
];
function $de7ed96869db3ac7$export$c939d6148e47244a(response) {
    if (!(response !== null && response !== void 0 && response.data) || !Array.isArray(response.errors)) return false;
    var filteredAggErrors = response.errors.filter(function(e) {
        return !e.extensions.classification || !$de7ed96869db3ac7$var$IGNORED_ERROR_CLASSIFICATIONS.includes(e.extensions.classification);
    });
    return filteredAggErrors.length > 0 && $de7ed96869db3ac7$export$884573c560ed3600(response.data);
}
function $de7ed96869db3ac7$export$884573c560ed3600(queryData) {
    var _activityRoot$all, _activityRoot$all$edg, _activityRoot$workedO, _activityRoot$workedO2, _queryData$activity, _queryData$activity$m, _queryData$activity$m2, _queryData$activity$m3;
    return !queryData.activity || ((_activityRoot$all = $de7ed96869db3ac7$export$ea55e8e0446efa94(queryData.activity).all) === null || _activityRoot$all === void 0 ? void 0 : (_activityRoot$all$edg = _activityRoot$all.edges) === null || _activityRoot$all$edg === void 0 ? void 0 : _activityRoot$all$edg.length) === 0 && ((_activityRoot$workedO = $de7ed96869db3ac7$export$ea55e8e0446efa94(queryData.activity).workedOn) === null || _activityRoot$workedO === void 0 ? void 0 : (_activityRoot$workedO2 = _activityRoot$workedO.edges) === null || _activityRoot$workedO2 === void 0 ? void 0 : _activityRoot$workedO2.length) === 0 && ((_queryData$activity = queryData.activity) === null || _queryData$activity === void 0 ? void 0 : (_queryData$activity$m = _queryData$activity.myActivity) === null || _queryData$activity$m === void 0 ? void 0 : (_queryData$activity$m2 = _queryData$activity$m.viewed) === null || _queryData$activity$m2 === void 0 ? void 0 : (_queryData$activity$m3 = _queryData$activity$m2.edges) === null || _queryData$activity$m3 === void 0 ? void 0 : _queryData$activity$m3.length) === 0;
}

});




parcelRegister("9DBuW", function(module, exports) {
$parcel$export(module.exports, "Row", function () { return (parcelRequire("dXeyw")).Row; });
$parcel$export(module.exports, "RowWrapper", function () { return (parcelRequire("dXeyw")).RowWrapper; });
$parcel$export(module.exports, "RowRevised", function () { return (parcelRequire("0r70l")).RowRevised; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("hvst7")).Icon; });
$parcel$export(module.exports, "Cross", function () { return (parcelRequire("bLsIZ")).Cross; });
$parcel$export(module.exports, "Logo", function () { return (parcelRequire("l227w")).Logo; });
$parcel$export(module.exports, "StyledBackground", function () { return (parcelRequire("91Gob")).StyledBackground; });
parcelRequire("djfza");
parcelRequire("dXeyw");
parcelRequire("0r70l");
parcelRequire("hvst7");
parcelRequire("bLsIZ");
parcelRequire("jFpHW");
parcelRequire("l227w");
parcelRequire("cwD0M");
parcelRequire("91Gob");

});
parcelRegister("djfza", function(module, exports) {
/**
 * Temporary container query for migration from emotion to compiled. This is not a permanent solution.
 * Please use mobile first patterns instead.
 */ var $c76cfdf706601ced$export$53b4bd0bde95b4a0 = Object.freeze({
    below: {
        xs: "@container not all and (min-width: 30rem)",
        sm: "@container not all and (min-width: 48rem)",
        md: "@container not all and (min-width: 64rem)",
        lg: "@container not all and (min-width: 90rem)",
        xl: "@container not all and (min-width: 110rem)"
    }
});

});

parcelRegister("dXeyw", function(module, exports) {

$parcel$export(module.exports, "Row", function () { return $e732249e5ea2be92$export$b59bdbef9ce70de2; });
$parcel$export(module.exports, "RowWrapper", function () { return $e732249e5ea2be92$export$bc7adc8ef74607f; });

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $cv9Rk = parcelRequire("cv9Rk");

var $1rY3h = parcelRequire("1rY3h");

var $1Mpn7 = parcelRequire("1Mpn7");

var $fBy54 = parcelRequire("fBy54");

var $3AwYQ = parcelRequire("3AwYQ");

var $0r70l = parcelRequire("0r70l");
var $e732249e5ea2be92$var$gridOrganizers = function(breakpoint, gridCols, gridRows, customChildGrids) {
    var customChildGridsBreakpoint = customChildGrids ? customChildGrids[breakpoint] : false;
    return "\n  grid-template-columns: ".concat(gridCols[breakpoint], ";\n  ").concat(gridRows && gridRows[breakpoint] ? "grid-template-rows: ".concat(gridRows[breakpoint], ";") : "", "\n  ").concat(customChildGrids && customChildGridsBreakpoint ? Object.keys(customChildGridsBreakpoint).map(function(child) {
        return "\n          > *:nth-of-type(".concat(child, ") {\n            ").concat(customChildGridsBreakpoint[child], ";\n          } \n        ");
    }).join("") : "");
};
var $e732249e5ea2be92$var$gridStyles = function(gridCols, gridRows, customChildGrids, isReduced) {
    return /*#__PURE__*/ (0, $fBy54.css)("display:grid;justify-content:space-between;margin:auto;max-width:100%;box-sizing:border-box;", (0, $3AwYQ.UNSAFE_media).below.md, "{gap:24px;padding-left:32px;padding-right:32px;&+.row-layout{margin-top:24px;}}", (0, $3AwYQ.media).above.md, "{gap:32px;padding-left:60px;padding-right:60px;&+.row-layout{margin-top:32px;}}", (0, $3AwYQ.UNSAFE_media).below.xs, "{width:328px;", $e732249e5ea2be92$var$gridOrganizers(0, gridCols, gridRows, customChildGrids), ";}", (0, $3AwYQ.UNSAFE_media).only.xs, "{width:508px;", $e732249e5ea2be92$var$gridOrganizers(1, gridCols, gridRows, customChildGrids), ";}", (0, $3AwYQ.UNSAFE_media).only.sm, "{width:", isReduced ? "588" : "768", "px;", $e732249e5ea2be92$var$gridOrganizers(2, gridCols, gridRows, customChildGrids), ";}", (0, $3AwYQ.UNSAFE_media).only.md, "{width:", isReduced ? "768" : "1024", "px;", $e732249e5ea2be92$var$gridOrganizers(3, gridCols, gridRows, customChildGrids), ";}", (0, $3AwYQ.media).above.lg, "{width:", isReduced ? "888" : "1168", "px;", $e732249e5ea2be92$var$gridOrganizers(4, gridCols, gridRows, customChildGrids), ";}");
};
// DefaultStyles depends on the order of keys in LayoutStyles.
// Any future layouts should be added to the end, not the beginning.
var $e732249e5ea2be92$var$LayoutStyles = {
    "12": {
        style: $e732249e5ea2be92$var$gridStyles(Array(5).fill("minmax(0, 1fr)")),
        count: 1
    },
    "6-6": {
        style: $e732249e5ea2be92$var$gridStyles([
            "minmax(0, 1fr)",
            "minmax(0, 1fr)",
            "minmax(0, 1fr) minmax(0, 1fr)",
            "minmax(0, 1fr) minmax(0, 1fr)",
            "minmax(0, 1fr) minmax(0, 1fr)"
        ]),
        count: 2
    },
    "4-4-4": {
        style: $e732249e5ea2be92$var$gridStyles([
            "minmax(0, 1fr)",
            "minmax(0, 1fr)",
            "repeat(3, minmax(0, 1fr))",
            "repeat(3, minmax(0, 1fr))",
            "repeat(3, minmax(0, 1fr))"
        ]),
        count: 3
    },
    "3-3-3-3": {
        style: $e732249e5ea2be92$var$gridStyles([
            "minmax(0, 1fr)",
            "minmax(0, 1fr) minmax(0, 1fr)",
            "minmax(0, 1fr) minmax(0, 1fr)",
            "repeat(4, minmax(0, 1fr))",
            "repeat(4, minmax(0, 1fr))"
        ]),
        count: 4
    },
    "2-2-2-2-2-2": {
        style: $e732249e5ea2be92$var$gridStyles([
            "minmax(0, 1fr) minmax(0, 1fr)",
            "minmax(0, 1fr) minmax(0, 1fr)",
            "minmax(0, 1fr) minmax(0, 1fr)",
            "repeat(6, minmax(0, 1fr))",
            "repeat(6, minmax(0, 1fr))"
        ]),
        count: 6
    },
    "4-8": {
        style: $e732249e5ea2be92$var$gridStyles([
            "minmax(0, 1fr)",
            "minmax(0, 1fr)",
            "minmax(0px, 0.965fr) minmax(0px, 2.035fr)",
            "minmax(0px, 0.962fr) minmax(0px, 2.038fr)",
            "minmax(0px, 0.97fr) minmax(0px, 2.03fr)"
        ]),
        count: 2
    },
    "7-5": {
        style: $e732249e5ea2be92$var$gridStyles([
            "minmax(0, 1fr)",
            "minmax(0, 1fr)",
            "minmax(0px, 1fr) minmax(0px, 1fr)",
            "minmax(0px, 1.4fr) minmax(0px, 1fr)",
            "minmax(0px, 1.4fr) minmax(0px, 1fr)"
        ]),
        count: 2
    },
    "3-9": {
        style: $e732249e5ea2be92$var$gridStyles([
            "minmax(0, 1fr)",
            "minmax(0, 1fr)",
            "minmax(0, 1fr)",
            "minmax(0px, .925fr) minmax(0px, 3.075fr)",
            "minmax(0px, .937fr) minmax(0px, 3.063fr)"
        ]),
        count: 2
    },
    "8-4": {
        style: $e732249e5ea2be92$var$gridStyles([
            "minmax(0, 1fr)",
            "minmax(0, 1fr)",
            "minmax(0px, 2.035fr) minmax(0px, 0.965fr)",
            "minmax(0px, 2.038fr) minmax(0px, 0.962fr)",
            "minmax(0px, 2.03fr) minmax(0px, 0.97fr)"
        ]),
        count: 2
    },
    "9-3": {
        style: $e732249e5ea2be92$var$gridStyles([
            "minmax(0, 1fr)",
            "minmax(0, 1fr)",
            "minmax(0, 1fr)",
            "minmax(0px, 3.075fr) minmax(0px, .925fr)",
            "minmax(0px, 3.063fr) minmax(0px, .937fr)"
        ]),
        count: 2
    },
    "3-3-6": {
        style: $e732249e5ea2be92$var$gridStyles([
            "minmax(0, 1fr)",
            "minmax(0, 1fr) minmax(0, 1fr)",
            "minmax(0, 1fr) minmax(0, 1fr)",
            "minmax(0px, 0.962fr) minmax(0px, 0.962fr) minmax(0px, 2.076fr)",
            "minmax(0px, 0.967fr) minmax(0px, 0.967fr) minmax(0px, 2.066fr)"
        ], [
            "auto",
            "minmax(0, 1fr) minmax(0, auto)",
            "minmax(0, 1fr) minmax(0, auto)",
            "auto",
            "auto"
        ], [
            {},
            {
                3: "grid-area: 2 / 1 / 3 / 3;"
            },
            {
                3: "grid-area: 2 / 1 / 3 / 3;"
            },
            {},
            {}
        ]),
        count: 3
    },
    "6-3-3": {
        style: $e732249e5ea2be92$var$gridStyles([
            "minmax(0, 1fr)",
            "minmax(0, 1fr) minmax(0, 1fr)",
            "minmax(0, 1fr) minmax(0, 1fr)",
            "minmax(0px, 2.076fr) minmax(0px, 0.962fr) minmax(0px, 0.962fr)",
            "minmax(0px, 2.066fr) minmax(0px, 0.967fr) minmax(0px, 0.967fr)"
        ], [
            "auto",
            "minmax(0, auto) minmax(0, 1fr)",
            "minmax(0, auto) minmax(0, 1fr)",
            "auto",
            "auto"
        ], [
            {},
            {
                1: "grid-area: 1 / 1 / 1 / 3;",
                2: "grid-area: 2 / 1 / 3 / 2;",
                3: "grid-area: 2 / 2 / 3 / 3;"
            },
            {
                1: "grid-area: 1 / 1 / 1 / 3;",
                2: "grid-area: 2 / 1 / 3 / 2;",
                3: "grid-area: 2 / 2 / 3 / 3;"
            },
            {},
            {}
        ]),
        count: 3
    },
    "reduced": {
        style: $e732249e5ea2be92$var$gridStyles(Array(5).fill("minmax(0, 1fr)"), [], {}, true),
        count: 1
    }
};
var $e732249e5ea2be92$var$getEntries = function(obj) {
    return Object.entries(obj);
};
var $e732249e5ea2be92$var$DefaultStyles = Object.fromEntries($e732249e5ea2be92$var$getEntries($e732249e5ea2be92$var$LayoutStyles).slice(0, 5).map(function(param) {
    var _param = (0, $cv9Rk._)(param, 2), key = _param[0], val = _param[1];
    return [
        val["count"],
        key
    ];
}));
Object.freeze($e732249e5ea2be92$var$LayoutStyles);
Object.freeze($e732249e5ea2be92$var$DefaultStyles);
var $e732249e5ea2be92$var$verticalAlignment = {
    default: "stretch",
    top: "start",
    bottom: "end",
    center: "center"
};
var $e732249e5ea2be92$var$getLayoutStyles = function(childCount, layout) {
    if (layout === undefined) {
        layout = $e732249e5ea2be92$var$DefaultStyles[childCount];
        if (layout === undefined) throw new Error("".concat(childCount, " is an invalid number of children"));
    }
    if (childCount != $e732249e5ea2be92$var$LayoutStyles[layout]["count"]) throw new Error('Row with layout "'.concat(layout, '" should have ').concat($e732249e5ea2be92$var$LayoutStyles[layout]["count"], " children"));
    return $e732249e5ea2be92$var$LayoutStyles[layout]["style"];
};
var $e732249e5ea2be92$export$b59bdbef9ce70de2 = function(props) {
    var layout = props.layout;
    var alignItems = props.alignItems;
    var children = (0, $1Mpn7.Children).toArray(props.children);
    var style = $e732249e5ea2be92$var$getLayoutStyles(children.length, layout);
    return /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
        className: "row-layout",
        css: (0, $fBy54.css)(style, " align-items:", alignItems ? $e732249e5ea2be92$var$verticalAlignment[alignItems] : $e732249e5ea2be92$var$verticalAlignment.default, ";"),
        children: children.map(function(child) {
            return child;
        })
    });
};
var $e732249e5ea2be92$export$bc7adc8ef74607f = function(props) {
    return props.rowRevised ? /*#__PURE__*/ (0, $1rY3h.jsx)((0, $0r70l.RowRevised), (0, $cxjpp._)((0, $do9pw._)({}, props.rowRevised), {
        children: props.children
    })) : /*#__PURE__*/ (0, $1rY3h.jsx)($e732249e5ea2be92$export$b59bdbef9ce70de2, (0, $cxjpp._)((0, $do9pw._)({}, props.row), {
        children: props.children
    }));
};

});
parcelRegister("3AwYQ", function(module, exports) {

$parcel$export(module.exports, "media", function () { return $29ce511bc3d88dc7$export$987d49ffe1b0900f; });
$parcel$export(module.exports, "UNSAFE_media", function () { return $29ce511bc3d88dc7$export$c881183ca713c214; });
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see https://compiledcssinjs.com/docs/atomic-css#selector-specificity
 */ var $29ce511bc3d88dc7$export$987d49ffe1b0900f = {
    above: {
        xxs: "@media all",
        xs: "@media (min-width: 30rem)",
        sm: "@media (min-width: 48rem)",
        md: "@media (min-width: 64rem)",
        lg: "@media (min-width: 90rem)",
        xl: "@media (min-width: 110rem)"
    },
    only: {
        xxs: "@media (min-width: 0rem) and (max-width: 29.99rem)",
        xs: "@media (min-width: 30rem) and (max-width: 47.99rem)",
        sm: "@media (min-width: 48rem) and (max-width: 63.99rem)",
        md: "@media (min-width: 64rem) and (max-width: 89.99rem)",
        lg: "@media (min-width: 90rem) and (max-width: 109.99rem)",
        xl: "@media (min-width: 110rem)"
    },
    below: {
        xs: "@media not all and (min-width: 30rem)",
        sm: "@media not all and (min-width: 48rem)",
        md: "@media not all and (min-width: 64rem)",
        lg: "@media not all and (min-width: 90rem)",
        xl: "@media not all and (min-width: 110rem)"
    }
};
var $29ce511bc3d88dc7$export$c881183ca713c214 = $29ce511bc3d88dc7$export$987d49ffe1b0900f;

});

parcelRegister("0r70l", function(module, exports) {

$parcel$export(module.exports, "RowRevised", function () { return $44fd8d90e8577fab$export$9a48b402fee4a6d2; });
/* grid-revised.tsx generated by @compiled/babel-plugin v0.28.2 */ 
var $3sHb8 = parcelRequire("3sHb8");

var $do9pw = parcelRequire("do9pw");

var $cv9Rk = parcelRequire("cv9Rk");

var $1rY3h = parcelRequire("1rY3h");

var $1Mpn7 = parcelRequire("1Mpn7");

var $2vwrh = parcelRequire("2vwrh");
var $bStPI = parcelRequire("bStPI");

var $3AwYQ = parcelRequire("3AwYQ");
var $44fd8d90e8577fab$var$FIXED_MOBILE_PADDING = 32;
var $44fd8d90e8577fab$var$FIXED_PADDING = 60;
var $44fd8d90e8577fab$var$MAX_CONTENT_WIDTH = 1152;
// DefaultStyles depends on the order of keys in revisedLayoutCounts.
// Any future layouts should be added to the end, not the beginning.
var $44fd8d90e8577fab$var$revisedLayoutCounts = {
    "12": 1,
    "6-6": 2,
    "4-4-4": 3,
    "3-3-3-3": 4,
    "2-2-2-2-2-2": 6,
    "4-8": 2,
    "7-5": 2,
    "3-9": 2,
    "8-4": 2,
    "9-3": 2,
    "3-3-6": 3,
    "6-3-3": 3,
    "8": 1,
    "10": 1
};
var $44fd8d90e8577fab$var$getEntries = function(obj) {
    return Object.entries(obj);
};
var $44fd8d90e8577fab$var$DefaultStyles = Object.fromEntries($44fd8d90e8577fab$var$getEntries($44fd8d90e8577fab$var$revisedLayoutCounts).slice(0, 5).map(function(param) {
    var _param = (0, $cv9Rk._)(param, 2), key = _param[0], val = _param[1];
    return [
        val,
        key
    ];
}));
Object.freeze($44fd8d90e8577fab$var$DefaultStyles);
var $44fd8d90e8577fab$export$9a48b402fee4a6d2 = function(props) {
    var layout = props.layout;
    var alignItems = props.alignItems;
    var adjustedMobilePadding = props.adjustedMobilePadding;
    var adjustedPadding = props.adjustedPadding;
    var adjustedMaxContentWidth = props.adjustedMaxContentWidth;
    // null and undefined checks to accomodate when padding = 0
    var mobilePadding = adjustedMobilePadding !== null && adjustedMobilePadding !== undefined ? adjustedMobilePadding : $44fd8d90e8577fab$var$FIXED_MOBILE_PADDING;
    var padding = adjustedPadding !== null && adjustedPadding !== undefined ? adjustedPadding : $44fd8d90e8577fab$var$FIXED_PADDING;
    var maxContentWidth = adjustedMaxContentWidth ? adjustedMaxContentWidth : $44fd8d90e8577fab$var$MAX_CONTENT_WIDTH;
    var children = (0, $1Mpn7.Children).toArray(props.children);
    if (layout === undefined) {
        layout = $44fd8d90e8577fab$var$DefaultStyles[children.length];
        if (layout === "") throw new Error("".concat(children.length, " is an invalid number of children"));
    } else {
        // @ts-ignore
        if (children.length != $44fd8d90e8577fab$var$revisedLayoutCounts[layout]) throw new Error(// @ts-ignore
        'Row with layout "'.concat(layout, '" should have ').concat($44fd8d90e8577fab$var$revisedLayoutCounts[layout], " children"));
    }
    var alignItemStyles = (0, $do9pw._)({}, alignItems === "default" && {
        alignItems: "stretch"
    }, alignItems === "top" && {
        alignItems: "start"
    }, alignItems === "bottom" && {
        alignItems: "end"
    }, alignItems === "center" && {
        alignItems: "center"
    }, !alignItems && {
        alignItems: "stretch"
    });
    var commonLayoutStyles = (0, $3sHb8._)({
        display: "grid",
        justifyContent: "space-between",
        margin: "auto",
        maxWidth: "100%",
        boxSizing: "border-box",
        paddingInlineStart: "".concat(mobilePadding),
        paddingInlineEnd: "".concat(mobilePadding),
        gap: "24px"
    }, "+ .row-layout", (0, $3sHb8._)({
        marginBlockStart: "24px"
    }, (0, $3AwYQ.media).above.sm, {
        marginBlockStart: "32px"
    }));
    return /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
        className: (0, $2vwrh.default)([
            layout === "12" && alignItems === "default" && "_4cvr1fhb",
            layout === "12" && alignItems === "top" && "_4cvrv2br",
            layout === "12" && alignItems === "bottom" && "_4cvrh9n0",
            layout === "12" && alignItems === "center" && "_4cvr1h6o",
            layout === "12" && !alignItems && "_4cvr1fhb",
            layout === "12" && "_1e0c11p5 _1bah1yb4 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _vchhusvi _bozgerv3 _y4tierv3 _zulp1tcg _1mcm1tcg _pnnxzwfg _yv0ei47z _kzvi11p5 _1m491yb4 _lg5r1wug _d97m1wug _1b7e1wug _12521wug _j6qu1osq _1ra6usvi _1gzv1tcg _qwmh18y6 _yu8o18y6 _1da7i47z _b91widpf _1p7sidpf _ttfqidpf _45efidpf _dm2511p5 _msup1yb4 _dbjg1wug _1hvk1wug _isu41wug _15qm1wug _10jx1osq _1gs5usvi _d2ik18y6 _exxm18y6 _glte1rlh _1rqti47z _pdlmzwfg _1ad3idpf _xbkjidpf _13onidpf _1e43idpf",
            layout === "6-6" && alignItems === "default" && "_4cvr1fhb",
            layout === "6-6" && alignItems === "top" && "_4cvrv2br",
            layout === "6-6" && alignItems === "bottom" && "_4cvrh9n0",
            layout === "6-6" && alignItems === "center" && "_4cvr1h6o",
            layout === "6-6" && !alignItems && "_4cvr1fhb",
            layout === "6-6" && "_1e0c11p5 _1bah1yb4 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _vchhusvi _bozgerv3 _y4tierv3 _zulp1tcg _1mcm1tcg _pnnxzwfg _yv0ei47z _3intidpf _4fugidpf _1ynqidpf _1j3nidpf _kzvi11p5 _1m491yb4 _lg5r1wug _d97m1wug _1b7e1wug _12521wug _j6qu1osq _1ra6usvi _qwmh18y6 _yu8o18y6 _1da7f9jr _1gzv1tcg _dm2511p5 _msup1yb4 _dbjg1wug _1hvk1wug _isu41wug _15qm1wug _10jx1osq _1gs5usvi _d2ik18y6 _exxm18y6 _glte1rlh _1rqtf9jr _pdlmzwfg",
            layout === "4-4-4" && alignItems === "default" && "_4cvr1fhb",
            layout === "4-4-4" && alignItems === "top" && "_4cvrv2br",
            layout === "4-4-4" && alignItems === "bottom" && "_4cvrh9n0",
            layout === "4-4-4" && alignItems === "center" && "_4cvr1h6o",
            layout === "4-4-4" && !alignItems && "_4cvr1fhb",
            layout === "4-4-4" && "_1e0c11p5 _1bah1yb4 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _vchhusvi _bozgerv3 _y4tierv3 _zulp1tcg _1mcm1tcg _pnnxzwfg _yv0ei47z _kzvi11p5 _1m491yb4 _lg5r1wug _d97m1wug _1b7e1wug _12521wug _j6qu1osq _1ra6usvi _1gzv1tcg _qwmh18y6 _yu8o18y6 _1da713mt _b91widpf _1p7sidpf _ttfqidpf _45efidpf _dm2511p5 _msup1yb4 _dbjg1wug _1hvk1wug _isu41wug _15qm1wug _10jx1osq _1gs5usvi _d2ik18y6 _exxm18y6 _glte1rlh _1rqt13mt _pdlmzwfg _1ad3idpf _xbkjidpf _13onidpf _1e43idpf",
            layout === "3-3-3-3" && alignItems === "default" && "_4cvr1fhb",
            layout === "3-3-3-3" && alignItems === "top" && "_4cvrv2br",
            layout === "3-3-3-3" && alignItems === "bottom" && "_4cvrh9n0",
            layout === "3-3-3-3" && alignItems === "center" && "_4cvr1h6o",
            layout === "3-3-3-3" && !alignItems && "_4cvr1fhb",
            layout === "3-3-3-3" && "_1e0c11p5 _1bah1yb4 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _vchhusvi _bozgerv3 _y4tierv3 _zulp1tcg _1mcm1tcg _pnnxzwfg _yv0ei47z _kzvi11p5 _1m491yb4 _lg5r1wug _d97m1wug _1b7e1wug _12521wug _j6qu1osq _1ra6usvi _1gzv1tcg _qwmh18y6 _yu8o18y6 _1da714vn _b91widpf _1p7sidpf _ttfqidpf _45efidpf _dm2511p5 _msup1yb4 _dbjg1wug _1hvk1wug _isu41wug _15qm1wug _10jx1osq _1gs5usvi _d2ik18y6 _exxm18y6 _glte1rlh _1rqtorlc _pdlmzwfg _1ad3idpf _xbkjidpf _13onidpf _1e43idpf",
            layout === "2-2-2-2-2-2" && alignItems === "default" && "_4cvr1fhb",
            layout === "2-2-2-2-2-2" && alignItems === "top" && "_4cvrv2br",
            layout === "2-2-2-2-2-2" && alignItems === "bottom" && "_4cvrh9n0",
            layout === "2-2-2-2-2-2" && alignItems === "center" && "_4cvr1h6o",
            layout === "2-2-2-2-2-2" && !alignItems && "_4cvr1fhb",
            layout === "2-2-2-2-2-2" && "_1e0c11p5 _1bah1yb4 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _vchhusvi _bozgerv3 _y4tierv3 _zulp1tcg _1mcm1tcg _pnnxzwfg _yv0ef9jr _kzvi11p5 _1m491yb4 _lg5r1wug _d97m1wug _1b7e1wug _12521wug _j6qu1osq _1ra6usvi _1gzv1tcg _qwmh18y6 _yu8o18y6 _1da79sye _b91widpf _1p7sidpf _ttfqidpf _45efidpf _dm2511p5 _msup1yb4 _dbjg1wug _1hvk1wug _isu41wug _15qm1wug _10jx1osq _1gs5usvi _d2ik18y6 _exxm18y6 _glte1rlh _1rqt14bh _pdlmzwfg _1ad3idpf _xbkjidpf _13onidpf _1e43idpf",
            layout === "4-8" && alignItems === "default" && "_4cvr1fhb",
            layout === "4-8" && alignItems === "top" && "_4cvrv2br",
            layout === "4-8" && alignItems === "bottom" && "_4cvrh9n0",
            layout === "4-8" && alignItems === "center" && "_4cvr1h6o",
            layout === "4-8" && !alignItems && "_4cvr1fhb",
            layout === "4-8" && "_1e0c11p5 _1bah1yb4 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _vchhusvi _bozgerv3 _y4tierv3 _zulp1tcg _1mcm1tcg _pnnxzwfg _yv0ei47z _kzvi11p5 _1m491yb4 _lg5r1wug _d97m1wug _1b7e1wug _12521wug _j6qu1osq _1ra6usvi _qwmh18y6 _yu8o18y6 _1da7wbji _1gzv1tcg _b91widpf _1p7sidpf _ttfqidpf _45efidpf _dm2511p5 _msup1yb4 _dbjg1wug _1hvk1wug _isu41wug _15qm1wug _10jx1osq _1gs5usvi _d2ik18y6 _exxm18y6 _glte1rlh _1rqtwbji _pdlmzwfg _1ad3idpf _xbkjidpf _13onidpf _1e43idpf",
            layout === "7-5" && alignItems === "default" && "_4cvr1fhb",
            layout === "7-5" && alignItems === "top" && "_4cvrv2br",
            layout === "7-5" && alignItems === "bottom" && "_4cvrh9n0",
            layout === "7-5" && alignItems === "center" && "_4cvr1h6o",
            layout === "7-5" && !alignItems && "_4cvr1fhb",
            layout === "7-5" && "_1e0c11p5 _1bah1yb4 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _vchhusvi _bozgerv3 _y4tierv3 _zulp1tcg _1mcm1tcg _pnnxzwfg _yv0ei47z _kzvi11p5 _1m491yb4 _lg5r1wug _d97m1wug _1b7e1wug _12521wug _j6qu1osq _1ra6usvi _1gzv1tcg _qwmh18y6 _yu8o18y6 _1da7bfkv _b91widpf _1p7sidpf _ttfqidpf _45efidpf _dm2511p5 _msup1yb4 _dbjg1wug _1hvk1wug _isu41wug _15qm1wug _10jx1osq _1gs5usvi _d2ik18y6 _exxm18y6 _glte1rlh _1rqtbfkv _pdlmzwfg _1ad3idpf _xbkjidpf _13onidpf _1e43idpf",
            layout === "3-9" && alignItems === "default" && "_4cvr1fhb",
            layout === "3-9" && alignItems === "top" && "_4cvrv2br",
            layout === "3-9" && alignItems === "bottom" && "_4cvrh9n0",
            layout === "3-9" && alignItems === "center" && "_4cvr1h6o",
            layout === "3-9" && !alignItems && "_4cvr1fhb",
            layout === "3-9" && "_1e0c11p5 _1bah1yb4 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _vchhusvi _bozgerv3 _y4tierv3 _zulp1tcg _1mcm1tcg _pnnxzwfg _yv0ei47z _kzvi11p5 _1m491yb4 _lg5r1wug _d97m1wug _1b7e1wug _12521wug _j6qu1osq _1ra6usvi _1gzv1tcg _qwmh18y6 _yu8o18y6 _1da7i47z _b91widpf _1p7sidpf _ttfqidpf _45efidpf _dm2511p5 _msup1yb4 _dbjg1wug _1hvk1wug _isu41wug _15qm1wug _10jx1osq _1gs5usvi _d2ik18y6 _exxm18y6 _glte1rlh _1rqt1oql _pdlmzwfg _1ad3idpf _xbkjidpf _13onidpf _1e43idpf",
            layout === "8-4" && alignItems === "default" && "_4cvr1fhb",
            layout === "8-4" && alignItems === "top" && "_4cvrv2br",
            layout === "8-4" && alignItems === "bottom" && "_4cvrh9n0",
            layout === "8-4" && alignItems === "center" && "_4cvr1h6o",
            layout === "8-4" && !alignItems && "_4cvr1fhb",
            layout === "8-4" && "_1e0c11p5 _1bah1yb4 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _vchhusvi _bozgerv3 _y4tierv3 _zulp1tcg _1mcm1tcg _pnnxzwfg _yv0ei47z _kzvi11p5 _1m491yb4 _lg5r1wug _d97m1wug _1b7e1wug _12521wug _j6qu1osq _1ra6usvi _1gzv1tcg _qwmh18y6 _yu8o18y6 _1da717no _b91widpf _1p7sidpf _ttfqidpf _45efidpf _dm2511p5 _msup1yb4 _dbjg1wug _1hvk1wug _isu41wug _15qm1wug _10jx1osq _1gs5usvi _d2ik18y6 _exxm18y6 _glte1rlh _1rqt17no _pdlmzwfg _1ad3idpf _xbkjidpf _13onidpf _1e43idpf",
            layout === "9-3" && alignItems === "default" && "_4cvr1fhb",
            layout === "9-3" && alignItems === "top" && "_4cvrv2br",
            layout === "9-3" && alignItems === "bottom" && "_4cvrh9n0",
            layout === "9-3" && alignItems === "center" && "_4cvr1h6o",
            layout === "9-3" && !alignItems && "_4cvr1fhb",
            layout === "9-3" && "_1e0c11p5 _1bah1yb4 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _vchhusvi _bozgerv3 _y4tierv3 _zulp1tcg _1mcm1tcg _pnnxzwfg _yv0ei47z _kzvi11p5 _1m491yb4 _lg5r1wug _d97m1wug _1b7e1wug _12521wug _j6qu1osq _1ra6usvi _1gzv1tcg _qwmh18y6 _yu8o18y6 _1da7i47z _b91widpf _1p7sidpf _ttfqidpf _45efidpf _dm2511p5 _msup1yb4 _dbjg1wug _1hvk1wug _isu41wug _15qm1wug _10jx1osq _1gs5usvi _d2ik18y6 _exxm18y6 _glte1rlh _1rqtwnk2 _pdlmzwfg _1ad3idpf _xbkjidpf _13onidpf _1e43idpf",
            layout === "3-3-6" && alignItems === "default" && "_4cvr1fhb",
            layout === "3-3-6" && alignItems === "top" && "_4cvrv2br",
            layout === "3-3-6" && alignItems === "bottom" && "_4cvrh9n0",
            layout === "3-3-6" && alignItems === "center" && "_4cvr1h6o",
            layout === "3-3-6" && !alignItems && "_4cvr1fhb",
            layout === "3-3-6" && "_1e0c11p5 _1bah1yb4 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _vchhusvi _bozgerv3 _y4tierv3 _zulp1tcg _1mcm1tcg _pnnxzwfg _yv0ef9jr _2z05f5ih _1fcv1ceo _kzvi11p5 _1m491yb4 _lg5r1wug _d97m1wug _1b7e1wug _12521wug _j6qu1osq _1ra6usvi _1gzv1tcg _qwmh18y6 _yu8o18y6 _1da79sye _rmr2f5ih _x0711ceo _b91widpf _1p7sidpf _ttfqidpf _45efidpf _dm2511p5 _msup1yb4 _dbjg1wug _1hvk1wug _isu41wug _15qm1wug _10jx1osq _1gs5usvi _d2ik18y6 _exxm18y6 _glte1rlh _1rqte55f _12qz1wug _pdlmzwfg _albg1wug _1ad3idpf _xbkjidpf _13onidpf _1e43idpf",
            layout === "6-3-3" && alignItems === "default" && "_4cvr1fhb",
            layout === "6-3-3" && alignItems === "top" && "_4cvrv2br",
            layout === "6-3-3" && alignItems === "bottom" && "_4cvrh9n0",
            layout === "6-3-3" && alignItems === "center" && "_4cvr1h6o",
            layout === "6-3-3" && !alignItems && "_4cvr1fhb",
            layout === "6-3-3" && "_1e0c11p5 _1bah1yb4 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _vchhusvi _bozgerv3 _y4tierv3 _zulp1tcg _1mcm1tcg _pnnxzwfg _yv0ef9jr _2z05155w _1nr16qap _xd84e2es _1fcvj2mo _kzvi11p5 _1m491yb4 _lg5r1wug _d97m1wug _1b7e1wug _12521wug _j6qu1osq _1ra6usvi _1gzv1tcg _qwmh18y6 _yu8o18y6 _1da79sye _rmr2155w _1ktq6qap _1bude2es _x071j2mo _b91widpf _1p7sidpf _ttfqidpf _45efidpf _dm2511p5 _msup1yb4 _dbjg1wug _1hvk1wug _isu41wug _15qm1wug _10jx1osq _1gs5usvi _d2ik18y6 _exxm18y6 _glte1rlh _1rqtm79v _12qz1wug _pdlmzwfg _pq9q1wug _121g1wug _albg1wug _1ad3idpf _xbkjidpf _13onidpf _1e43idpf",
            layout === "8" && alignItems === "default" && "_4cvr1fhb",
            layout === "8" && alignItems === "top" && "_4cvrv2br",
            layout === "8" && alignItems === "bottom" && "_4cvrh9n0",
            layout === "8" && alignItems === "center" && "_4cvr1h6o",
            layout === "8" && !alignItems && "_4cvr1fhb",
            layout === "8" && "_1e0c11p5 _1bah1yb4 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _vchhusvi _zulpidpf _bozgerv3 _y4tierv3 _yv0ei47z _kzvi11p5 _1m491yb4 _lg5r1wug _d97m1wug _1b7e1wug _12521wug _j6qu1osq _1ra6usvi _1gzvidpf _qwmh18y6 _yu8o18y6 _1da74iae _x6ovcs5v _b91widpf _1p7sidpf _ttfqidpf _45efidpf _dm2511p5 _msup1yb4 _dbjg1wug _1hvk1wug _isu41wug _15qm1wug _10jx1osq _1gs5usvi _d2ik18y6 _exxm18y6 _glte1rlh _1rqt10cj _pdlmidpf _1nrmcs5v _1ad3idpf _xbkjidpf _13onidpf _1e43idpf",
            layout === "10" && alignItems === "default" && "_4cvr1fhb",
            layout === "10" && alignItems === "top" && "_4cvrv2br",
            layout === "10" && alignItems === "bottom" && "_4cvrh9n0",
            layout === "10" && alignItems === "center" && "_4cvr1h6o",
            layout === "10" && !alignItems && "_4cvr1fhb",
            layout === "10" && "_1e0c11p5 _1bah1yb4 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _vchhusvi _zulpidpf _bozgerv3 _y4tierv3 _yv0ei47z _kzvi11p5 _1m491yb4 _lg5r1wug _d97m1wug _1b7e1wug _12521wug _j6qu1osq _1ra6usvi _1gzvidpf _qwmh18y6 _yu8o18y6 _1da7i47z _b91widpf _1p7sidpf _ttfqidpf _45efidpf _dm2511p5 _msup1yb4 _dbjg1wug _1hvk1wug _isu41wug _15qm1wug _10jx1osq _1gs5usvi _d2ik18y6 _exxm18y6 _glte1rlh _1rqt4iae _pdlmidpf _1nrmcs5v _1ad3idpf _xbkjidpf _13onidpf _1e43idpf",
            "row-layout"
        ]),
        style: {
            "--_u6oseo": (0, $bStPI.default)(mobilePadding, "px"),
            "--_1xumd0e": (0, $bStPI.default)(padding, "px"),
            "--_1iotmxl": (0, $bStPI.default)(maxContentWidth + padding * 2, "px")
        },
        children: children.map(function(child) {
            return child;
        })
    });
};

});
parcelRegister("bStPI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a5be113006bbbd7$export$2e2bcd8739ae039; });
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $8a5be113006bbbd7$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return "var(--c-, )";
}

});



parcelRegister("hvst7", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $50937f0b06ef7da7$export$f04a61298a47a40f; });
/* icon.tsx generated by @compiled/babel-plugin v0.28.2 */ /* eslint-disable complexity */ 
var $1rY3h = parcelRequire("1rY3h");
parcelRequire("1Mpn7");

var $2vwrh = parcelRequire("2vwrh");

var $ezmrD = parcelRequire("ezmrD");

var $746sZ = parcelRequire("746sZ");

var $aonTn = parcelRequire("aonTn");

var $2rkHV = parcelRequire("2rkHV");

var $bLsIZ = parcelRequire("bLsIZ");

var $a1r98 = parcelRequire("a1r98");

var $fiGZG = parcelRequire("fiGZG");

var $2hdVC = parcelRequire("2hdVC");

var $d5zhD = parcelRequire("d5zhD");

var $1nOCl = parcelRequire("1nOCl");

var $hlgLf = parcelRequire("hlgLf");

var $L6wJo = parcelRequire("L6wJo");

var $2rgkc = parcelRequire("2rgkc");

var $kv0wa = parcelRequire("kv0wa");

var $imDLZ = parcelRequire("imDLZ");

var $8cWLo = parcelRequire("8cWLo");

var $5hWNL = parcelRequire("5hWNL");

var $lyWte = parcelRequire("lyWte");

var $cjttc = parcelRequire("cjttc");

var $3HRil = parcelRequire("3HRil");

var $ccgJ9 = parcelRequire("ccgJ9");

var $dXEF7 = parcelRequire("dXEF7");

var $hVpBS = parcelRequire("hVpBS");

var $eEB6V = parcelRequire("eEB6V");

var $fmncI = parcelRequire("fmncI");

var $2J0Tn = parcelRequire("2J0Tn");

var $bozG9 = parcelRequire("bozG9");

var $ddO6b = parcelRequire("ddO6b");
var $50937f0b06ef7da7$var$IconNames = [
    "adduser",
    "longhair",
    "checkmarkbasic",
    "checkmark",
    "checkmarkcircle",
    "featurecheckmark",
    "circleunions",
    "cross",
    "no",
    "diagramorgchart",
    "maximize",
    "pagemultiple",
    "bold",
    "building",
    "puzzlepiece",
    "securitycheckmark",
    "lightbulb",
    "locationpin",
    "lock",
    "video",
    "wrench",
    "cloudcheckmark",
    "datacenter",
    "accelerator",
    "team",
    "lightning",
    "id",
    "info",
    "infocircle"
];
var $50937f0b06ef7da7$var$getIconSize = function(size) {
    switch(size){
        case "xs":
            return "24px";
        case "small":
            return "32px";
        case "medium":
            return "48px";
        case "large":
            return "64px";
        default:
            return "48px";
    }
};
var $50937f0b06ef7da7$var$basicStyle = null;
var $50937f0b06ef7da7$export$aa4d92373c6fc66f = function(name, size) {
    var iconSize = $50937f0b06ef7da7$var$getIconSize(size);
    switch(name.toLowerCase()){
        // avatar
        case "adduser":
            return /*#__PURE__*/ (0, $1rY3h.jsx)((0, $ezmrD.AddUser), {
                size: iconSize
            });
        case "longhair":
            return /*#__PURE__*/ (0, $1rY3h.jsx)((0, $746sZ.LongHair), {
                size: iconSize
            });
        // basic
        case "checkmarkbasic":
            return /*#__PURE__*/ (0, $1rY3h.jsx)((0, $aonTn.Checkmark), {
                size: iconSize
            });
        case "checkmarkcircle":
            return /*#__PURE__*/ (0, $1rY3h.jsx)((0, $2rkHV.CheckmarkCircle), {
                size: iconSize
            });
        case "featurecheckmark":
            return /*#__PURE__*/ (0, $1rY3h.jsx)((0, $a1r98.FeatureCheckmark), {
                size: iconSize
            });
        case "cross":
            return /*#__PURE__*/ (0, $1rY3h.jsx)((0, $bLsIZ.Cross), {
                size: iconSize
            });
        case "no":
            return /*#__PURE__*/ (0, $1rY3h.jsx)((0, $2hdVC.No), {
                size: iconSize
            });
        case "infocircle":
            return /*#__PURE__*/ (0, $1rY3h.jsx)((0, $fiGZG.InfoCircle), {
                size: iconSize
            });
        // content
        case "checkmark":
            return /*#__PURE__*/ (0, $1rY3h.jsx)((0, $1nOCl.Checkmark), {
                size: iconSize
            });
        case "diagramorgchart":
            return /*#__PURE__*/ (0, $1rY3h.jsx)((0, $hlgLf.DiagramOrgChart), {
                size: iconSize
            });
        case "maximize":
            return /*#__PURE__*/ (0, $1rY3h.jsx)((0, $2rgkc.Maximize), {
                size: iconSize
            });
        case "pagemultiple":
            return /*#__PURE__*/ (0, $1rY3h.jsx)((0, $kv0wa.PageMultiple), {
                size: iconSize
            });
        // object
        case "bold":
            return /*#__PURE__*/ (0, $1rY3h.jsx)((0, $8cWLo.Bold), {
                size: iconSize
            });
        case "building":
            return /*#__PURE__*/ (0, $1rY3h.jsx)((0, $5hWNL.Building), {
                size: iconSize
            });
        case "circleunions":
            return /*#__PURE__*/ (0, $1rY3h.jsx)((0, $lyWte.CircleUnions), {
                size: iconSize
            });
        case "id":
            return /*#__PURE__*/ (0, $1rY3h.jsx)((0, $cjttc.Id), {
                size: iconSize
            });
        case "puzzlepiece":
            return /*#__PURE__*/ (0, $1rY3h.jsx)((0, $hVpBS.PuzzlePiece), {
                size: iconSize
            });
        case "securitycheckmark":
            return /*#__PURE__*/ (0, $1rY3h.jsx)((0, $eEB6V.SecurityCheckmark), {
                size: iconSize
            });
        case "lightbulb":
            return /*#__PURE__*/ (0, $1rY3h.jsx)((0, $3HRil.Lightbulb), {
                size: iconSize
            });
        case "locationpin":
            return /*#__PURE__*/ (0, $1rY3h.jsx)((0, $ccgJ9.LocationPin), {
                size: iconSize
            });
        case "lock":
            return /*#__PURE__*/ (0, $1rY3h.jsx)((0, $dXEF7.Lock), {
                size: iconSize
            });
        case "video":
            return /*#__PURE__*/ (0, $1rY3h.jsx)((0, $fmncI.Video), {
                size: iconSize
            });
        case "wrench":
            return /*#__PURE__*/ (0, $1rY3h.jsx)((0, $2J0Tn.Wrench), {
                size: iconSize
            });
        case "accelerator":
            return /*#__PURE__*/ (0, $1rY3h.jsx)((0, $d5zhD.Accelerator), {
                size: iconSize
            });
        case "team":
            return /*#__PURE__*/ (0, $1rY3h.jsx)((0, $imDLZ.Team), {
                size: iconSize
            });
        case "lightning":
            return /*#__PURE__*/ (0, $1rY3h.jsx)((0, $L6wJo.Lightning), {
                size: iconSize
            });
        // software
        case "cloudcheckmark":
            return /*#__PURE__*/ (0, $1rY3h.jsx)((0, $bozG9.CloudCheckmark), {
                size: iconSize
            });
        case "datacenter":
            return /*#__PURE__*/ (0, $1rY3h.jsx)((0, $ddO6b.DataCenter), {
                size: iconSize
            });
        default:
            return null;
    }
};
var $50937f0b06ef7da7$export$f04a61298a47a40f = function(param) {
    var name = param.name, size = param.size, color = param.color;
    var iconColor = color;
    return /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
        className: (0, $2vwrh.default)([
            "_vwz4idpf",
            "icon"
        ]),
        style: {
            color: iconColor ? iconColor : "inherit"
        },
        children: $50937f0b06ef7da7$export$aa4d92373c6fc66f(name, size)
    });
};

});
parcelRegister("ezmrD", function(module, exports) {

$parcel$export(module.exports, "AddUser", function () { return $a6a89f9e361d0c83$export$a2fae8d9b81b1013; });

var $1rY3h = parcelRequire("1rY3h");
var $a6a89f9e361d0c83$export$a2fae8d9b81b1013 = function(param) {
    var size = param.size;
    return /*#__PURE__*/ (0, $1rY3h.jsx)("svg", {
        id: "icon-avatar-add user",
        width: size,
        height: size,
        viewBox: "0 0 65 64",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                        d: "M32.0518,0 C14.3786,0 0.0518,14.3269 0.0518,32 C0.0518,42.7687 5.371,52.295 13.5254,58.0948 L13.5254,55.9989 C13.5254,47.9763 20.0291,41.4726 28.0517,41.4726 L36.0517,41.4726 C39.9589,41.4726 43.5058,43.0152 46.1166,45.5246 C48.0215,43.7503 50.5765,42.6649 53.385,42.6649 C56.3337,42.6649 59.0029,43.8614 60.9337,45.7953 C62.9325,41.6181 64.0517,36.9398 64.0517,32 C64.0517,14.3269 49.7249,0 32.0518,0 Z M32.0518,16.7006 C26.1608,16.7006 21.3852,21.4762 21.3852,27.3673 C21.3852,33.2583 26.1608,38.0339 32.0518,38.0339 C37.9429,38.0339 42.7185,33.2583 42.7185,27.3673 C42.7185,21.4762 37.9429,16.7006 32.0518,16.7006 Z"
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("g", {
                        transform: "translate(42.000000, 42.000000)",
                        opacity: "0.5",
                        children: /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                            d: "M11.3854,21.9974 C17.2765,21.9974 22.0521,17.2218 22.0521,11.3307 C22.0521,5.4397 17.2765,0.6641 11.3854,0.6641 C5.4944,0.6641 0.7188,5.4397 0.7188,11.3307 C0.7188,17.2218 5.4944,21.9974 11.3854,21.9974 Z M13.3506,16.2717 C13.3506,17.2018 12.5966,17.9559 11.6664,17.9559 C10.7695,17.9559 10.0363,17.2547 9.9851,16.3706 L9.9822,16.2717 L9.9822,12.9029 L6.6137,12.9029 C5.6836,12.9029 4.9295,12.1489 4.9295,11.2187 C4.9295,10.3218 5.6307,9.5886 6.5148,9.5374 L6.6137,9.5345 L9.9822,9.5345 L9.9822,6.1664 C9.9822,5.2362 10.7363,4.4822 11.6664,4.4822 C12.5634,4.4822 13.2965,5.1833 13.3478,6.0674 L13.3506,6.1664 L13.3506,9.5345 L16.719,9.5345 C17.6492,9.5345 18.4032,10.2886 18.4032,11.2187 C18.4032,12.1157 17.7021,12.8489 16.818,12.9001 L16.719,12.9029 L13.3506,12.9029 L13.3506,16.2717 Z"
                        })
                    })
                ]
            })
        })
    });
};

});

parcelRegister("746sZ", function(module, exports) {

$parcel$export(module.exports, "LongHair", function () { return $4fa5d910f2d4e0a3$export$c8fa71fb10453bb; });

var $1rY3h = parcelRequire("1rY3h");
var $4fa5d910f2d4e0a3$export$c8fa71fb10453bb = function(param) {
    var size = param.size;
    return /*#__PURE__*/ (0, $1rY3h.jsx)("svg", {
        id: "icon-avatar-long hair",
        width: size,
        height: size,
        viewBox: "0 0 65 59",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                        d: "M21.9824,27.925 C22.0571,33.752 26.8037,38.452 32.6482,38.452 C38.4927,38.452 43.2393,33.752 43.314,27.925 L40.8203,27.925 C40.2702,27.925 39.7523,27.666 39.4223,27.226 L37.0441,24.055 C36.8111,23.745 36.3451,23.745 36.1121,24.055 L33.7339,27.226 C33.4039,27.666 32.886,27.925 32.336,27.925 L21.9824,27.925 Z",
                        opacity: "0.5"
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                        d: "M32.6484,0.416 C14.9753,0.416 0.6484,14.743 0.6484,32.416 C0.6484,43.185 5.9677,52.711 14.1222,58.511 L14.1222,56.417 C14.1222,48.394 20.6258,41.89 28.6485,41.89 L36.6485,41.89 C44.6711,41.89 51.1748,48.394 51.1748,56.417 L51.1748,58.511 C59.3292,52.711 64.6484,43.185 64.6484,32.416 C64.6484,14.743 50.3215,0.416 32.6484,0.416 Z M24.3598,21.07 C22.8728,22.903 21.9818,25.239 21.9818,27.784 C21.9818,33.675 26.7574,38.451 32.6485,38.451 C38.5395,38.451 43.3151,33.675 43.3151,27.784 C43.3151,21.893 38.5395,17.117 32.6485,17.117 C32.2004,17.117 31.7588,17.145 31.3252,17.199 C31.3648,16.944 31.3853,16.683 31.3853,16.417 C31.3853,13.626 29.1232,11.364 26.3327,11.364 C23.5422,11.364 21.2801,13.626 21.2801,16.417 C21.2801,18.507 22.5496,20.301 24.3598,21.07 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("aonTn", function(module, exports) {

$parcel$export(module.exports, "Checkmark", function () { return $fa1ee7f5355fb696$export$4f481e0a96cfbed6; });

var $1rY3h = parcelRequire("1rY3h");
var $fa1ee7f5355fb696$export$4f481e0a96cfbed6 = function(param) {
    var size = param.size;
    return /*#__PURE__*/ (0, $1rY3h.jsx)("svg", {
        fill: "none",
        stroke: "currentColor",
        version: "1.2",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 30",
        width: size,
        height: size,
        children: /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
            d: "m1.5 16.4c1.8-1.7 4.2-0.3 4.2-0.3l5.6 5.9 15.4-18.7c0 0 1.7-1.2 3.5 0.1 1.9 1.4 0.8 3.6 0.8 3.6l-18 22h-2l-9.1-8.7c0 0-2.1-2.2-0.4-3.9z"
        })
    });
};

});

parcelRegister("2rkHV", function(module, exports) {

$parcel$export(module.exports, "CheckmarkCircle", function () { return $6fc209cacbe41f3c$export$7f2957f440d043b5; });

var $1rY3h = parcelRequire("1rY3h");
var $6fc209cacbe41f3c$export$7f2957f440d043b5 = function(param) {
    var size = param.size;
    return /*#__PURE__*/ (0, $1rY3h.jsx)("svg", {
        id: "icon-basic-checkmark circle",
        width: size,
        height: size,
        viewBox: "0 0 64 64",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $1rY3h.jsx)("g", {
                fill: "currentColor",
                children: /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                    d: "M32,0 C14.33,0 0,14.33 0,32 C0,49.67 14.33,64 32,64 C49.67,64 64,49.67 64,32 C64,14.33 49.67,0 32,0 Z M44.59,25.97 C45.49,24.97 45.46,23.44 44.5,22.48 L44.42,22.4 C43.43,21.49 41.89,21.52 40.93,22.48 L27.63,35.78 L23.07,31.21 L22.98,31.13 C21.99,30.23 20.45,30.25 19.5,31.21 C18.51,32.2 18.51,33.8 19.5,34.78 L25.85,41.14 L25.93,41.22 C26.92,42.12 28.46,42.09 29.42,41.14 L44.5,26.05 L44.59,25.97 Z"
                })
            })
        })
    });
};

});

parcelRegister("bLsIZ", function(module, exports) {

$parcel$export(module.exports, "Cross", function () { return $db0dbc13644962b3$export$3c877bb842c36952; });

var $1rY3h = parcelRequire("1rY3h");
var $db0dbc13644962b3$export$3c877bb842c36952 = function(param) {
    var size = param.size;
    return /*#__PURE__*/ (0, $1rY3h.jsx)("svg", {
        id: "icon-basic-cross",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        color: "#7a869a",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
            d: "M12 10.586L6.707 5.293a1 1 0 00-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 001.414 1.414L12 13.414l5.293 5.293a1 1 0 001.414-1.414L13.414 12l5.293-5.293a1 1 0 10-1.414-1.414L12 10.586z",
            fill: "currentColor"
        })
    });
};

});

parcelRegister("a1r98", function(module, exports) {

$parcel$export(module.exports, "FeatureCheckmark", function () { return $96143c5ebb484b95$export$7d54ddbe8d02bf0; });

var $1rY3h = parcelRequire("1rY3h");
var $96143c5ebb484b95$export$7d54ddbe8d02bf0 = function(param) {
    var size = param.size;
    return /*#__PURE__*/ (0, $1rY3h.jsx)("svg", {
        fill: "currentColor",
        version: "1.2",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        width: size,
        height: size,
        role: "presentation",
        children: /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
            d: "M6.735 12.322a1 1 0 00-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2335.638 2335.638 0 003.939-3.883l.04-.04a492.598 492.598 0 003.658-3.643 1 1 0 00-1.424-1.404 518.42 518.42 0 01-3.64 3.625l-.04.04a2049.114 2049.114 0 01-3.775 3.722l-3.098-3.363z"
        })
    });
};

});

parcelRegister("fiGZG", function(module, exports) {

$parcel$export(module.exports, "InfoCircle", function () { return $2be1611a02f052fe$export$6e50c69d980cc044; });

var $1rY3h = parcelRequire("1rY3h");
var $2be1611a02f052fe$export$6e50c69d980cc044 = function(param) {
    var size = param.size;
    return /*#__PURE__*/ (0, $1rY3h.jsx)("svg", {
        id: "icon-basic-info circle",
        width: size,
        height: size,
        viewBox: "0 0 64 64",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $1rY3h.jsx)("g", {
                fill: "currentColor",
                children: /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                    d: "M32,0 C14.33,0 0,14.327 0,32 C0,49.673 14.33,64 32,64 C49.67,64 64,49.673 64,32 C64,14.327 49.67,0 32,0 Z M32.28,17.964 C34.92,17.964 37.05,15.828 37.05,13.192 C37.05,10.557 34.92,8.42 32.28,8.42 C29.65,8.42 27.51,10.557 27.51,13.192 C27.51,15.828 29.65,17.964 32.28,17.964 Z M37.89,45.753 C39.29,45.753 40.42,46.884 40.42,48.28 C40.42,49.635 39.35,50.741 38.01,50.803 L37.89,50.806 L32.35,50.806 C32.34,50.806 32.33,50.806 32.31,50.806 C32.3,50.806 32.29,50.806 32.28,50.806 L26.7,50.806 C25.3,50.806 24.17,49.675 24.17,48.28 C24.17,46.924 25.24,45.818 26.58,45.756 L26.7,45.753 L29.79,45.753 L29.79,26.666 L26.67,26.666 C25.31,26.666 24.21,25.598 24.14,24.258 L24.14,24.139 C24.14,22.784 25.21,21.678 26.55,21.616 L26.67,21.613 L32.31,21.613 C33.67,21.613 34.78,22.681 34.84,24.021 L34.84,24.139 L34.84,45.753 L37.89,45.753 Z"
                })
            })
        })
    });
};

});

parcelRegister("2hdVC", function(module, exports) {

$parcel$export(module.exports, "No", function () { return $4d2275b5907eb1ab$export$830dad7b282f77fd; });

var $1rY3h = parcelRequire("1rY3h");
var $4d2275b5907eb1ab$export$830dad7b282f77fd = function(param) {
    var size = param.size;
    return /*#__PURE__*/ (0, $1rY3h.jsx)("svg", {
        id: "icon-basic-no",
        width: size,
        height: size,
        viewBox: "0 0 64 64",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                        d: "M0,32 C0,14.33 14.33,0 32,0 C49.67,0 64,14.33 64,32 C64,49.77 50.14,64 32.56,64 C14.79,64 0,49.58 0,32 Z M58.99,32 C58.99,17.09 46.91,5.01 32,5.01 C17.09,5.01 5.01,17.09 5.01,32 C5.01,46.79 17.53,58.99 32.56,58.99 C47.34,58.99 58.99,47.03 58.99,32 Z"
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                        d: "M54.36,9.64 C53.41,8.69 51.9,8.66 50.91,9.55 L50.82,9.64 L10.19,50.26 C9.22,51.24 9.22,52.83 10.19,53.81 C11.14,54.75 12.66,54.78 13.64,53.89 L13.74,53.81 L54.36,13.18 C55.34,12.2 55.34,10.62 54.36,9.64 Z",
                        fillRule: "nonzero"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("d5zhD", function(module, exports) {

$parcel$export(module.exports, "Accelerator", function () { return $cddcc75c15625278$export$427f6a19cea2f209; });

var $1rY3h = parcelRequire("1rY3h");
var $cddcc75c15625278$export$427f6a19cea2f209 = function(param) {
    var size = param.size;
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("svg", {
        id: "icon-accelerator",
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMinYMin meet",
        viewBox: "0 0 36 36",
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                style: {
                    opacity: 0.5,
                    fill: "#0065ff",
                    fillRule: "evenodd"
                },
                d: "M17 10.37a1.38 1.38 0 0 1 2.28-1 1.31 1.31 0 0 1 .46 1V13a1.44 1.44 0 0 1-1.25 1.46 1.39 1.39 0 0 1-1.49-1.3v-2.79ZM8.9 24a1.26 1.26 0 0 1-1 .46H5.23a1.43 1.43 0 0 1-1.45-1.25 1.38 1.38 0 0 1 1.31-1.49h2.79A1.38 1.38 0 0 1 8.9 24Zm3.03-6.85a1.44 1.44 0 0 1-2 .06l-.06-.06-2-2a1.43 1.43 0 0 1 2-2.08h.05l2 2a1.46 1.46 0 0 1 .01 2.08ZM32 24a1.26 1.26 0 0 1-1 .46h-2.68a1.43 1.43 0 0 1-1.45-1.25 1.38 1.38 0 0 1 1.31-1.49H31A1.38 1.38 0 0 1 32 24Z"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                style: {
                    fill: "#0065ff",
                    fillRule: "evenodd"
                },
                d: "M.29 20.43a18.5 18.5 0 0 0 1 10h33.4A17.84 17.84 0 0 0 36 23.61a17.88 17.88 0 0 0-18.24-18A18.18 18.18 0 0 0 .29 20.43ZM17 10.37a1.38 1.38 0 0 1 2.28-1 1.31 1.31 0 0 1 .46 1V13a1.44 1.44 0 0 1-1.25 1.46 1.39 1.39 0 0 1-1.49-1.3v-2.79ZM8.9 24a1.26 1.26 0 0 1-1 .46H5.23a1.43 1.43 0 0 1-1.45-1.25 1.38 1.38 0 0 1 1.31-1.49h2.79A1.38 1.38 0 0 1 8.9 24Zm3-6.82a1.44 1.44 0 0 1-2 .06l-.06-.06-2-2a1.43 1.43 0 0 1 2-2.08h.05l2 2a1.46 1.46 0 0 1 .04 2.05Zm6.12 10a3.78 3.78 0 0 1 0-7.55 4.29 4.29 0 0 1 1.48.27l5.75-5.74a1.43 1.43 0 0 1 2.07 2l-.05.05-5.71 5.59a3.37 3.37 0 0 1 .27 1.48 3.8 3.8 0 0 1-3.78 3.83ZM32 24a1.26 1.26 0 0 1-1 .46h-2.68a1.43 1.43 0 0 1-1.45-1.25 1.38 1.38 0 0 1 1.31-1.49H31A1.38 1.38 0 0 1 32 24Z"
            })
        ]
    });
};

});

parcelRegister("1nOCl", function(module, exports) {

$parcel$export(module.exports, "Checkmark", function () { return $0afeea5528fd38c0$export$4f481e0a96cfbed6; });

var $1rY3h = parcelRequire("1rY3h");
var $0afeea5528fd38c0$export$4f481e0a96cfbed6 = function(param) {
    var size = param.size;
    return /*#__PURE__*/ (0, $1rY3h.jsx)("svg", {
        id: "icon-content-checkmark",
        width: size,
        height: size,
        viewBox: "0 0 64 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                        d: "M42.25,50.27 C46.37,50.27 49.71,46.93 49.71,42.81 L49.71,8.64 L56.54,8.64 C60.66,8.64 64,11.98 64,16.09 L64,57.1 C64,61.22 60.66,64.56 56.54,64.56 L15.53,64.56 C11.42,64.56 8.08,61.22 8.08,57.1 L8.08,50.27 L42.25,50.27 Z",
                        opacity: "0.5"
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                        d: "M7.46,0.56 C3.34,0.56 0,3.9 0,8.02 L0,49.03 C0,53.15 3.34,56.48 7.46,56.48 L48.47,56.48 C52.58,56.48 55.92,53.15 55.92,49.03 L55.92,8.02 C55.92,3.9 52.58,0.56 48.47,0.56 L7.46,0.56 Z M41.89,21.84 C42.89,20.75 42.86,19.05 41.8,17.99 L41.71,17.89 C40.61,16.89 38.91,16.92 37.85,17.99 L23.13,32.7 L18.08,27.65 L17.98,27.56 C16.88,26.56 15.18,26.59 14.12,27.65 C13.03,28.74 13.03,30.51 14.12,31.61 L21.15,38.64 L21.25,38.73 C22.34,39.73 24.04,39.7 25.11,38.64 L41.8,21.94 L41.89,21.84 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("hlgLf", function(module, exports) {

$parcel$export(module.exports, "DiagramOrgChart", function () { return $c87915e1f4a159ca$export$50ccabbebab12b45; });

var $1rY3h = parcelRequire("1rY3h");
var $c87915e1f4a159ca$export$50ccabbebab12b45 = function(param) {
    var size = param.size;
    return /*#__PURE__*/ (0, $1rY3h.jsx)("svg", {
        id: "icon-content-diagram org chart",
        width: size,
        height: size,
        viewBox: "0 0 64 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ (0, $1rY3h.jsx)("g", {
                        transform: "translate(8.000000, 6.000000)",
                        opacity: "0.5",
                        children: /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                            d: "M26.57,2.63 C26.51,1.27 25.38,0.18 24,0.18 C22.58,0.18 21.43,1.33 21.43,2.75 L21.43,23.61 L10,23.61 L9.82,23.61 C4.69,23.71 0.57,27.89 0.57,33.04 L0.57,49.61 L0.57,49.73 C0.64,51.1 1.76,52.18 3.14,52.18 C4.56,52.18 5.71,51.03 5.71,49.61 L5.71,33.04 L5.72,32.9 C5.79,30.6 7.68,28.75 10,28.75 L23.99,28.75 C23.99,28.75 24,28.75 24,28.75 C24,28.75 24.01,28.75 24.01,28.75 L38,28.75 L38.14,28.76 C40.44,28.83 42.29,30.72 42.29,33.04 L42.29,49.61 L42.29,49.73 C42.35,51.1 43.48,52.18 44.86,52.18 C46.28,52.18 47.43,51.03 47.43,49.61 L47.43,33.04 L47.43,32.86 C47.33,27.73 43.15,23.61 38,23.61 L26.57,23.61 L26.57,2.75 L26.57,2.63 Z"
                        })
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                        d: "M0,53.04 C0,46.89 4.99,41.9 11.14,41.9 C17.3,41.9 22.29,46.89 22.29,53.04 C22.29,59.2 17.3,64.18 11.14,64.18 C4.99,64.18 0,59.2 0,53.04 Z",
                        fillRule: "nonzero"
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                        d: "M41.71,53.04 C41.71,46.89 46.7,41.9 52.86,41.9 C59.01,41.9 64,46.89 64,53.04 C64,59.2 59.01,64.18 52.86,64.18 C46.7,64.18 41.71,59.2 41.71,53.04 Z",
                        fillRule: "nonzero"
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                        d: "M20.86,11.33 C20.86,5.17 25.85,0.18 32,0.18 C38.15,0.18 43.14,5.17 43.14,11.33 C43.14,17.48 38.15,22.47 32,22.47 C25.85,22.47 20.86,17.48 20.86,11.33 Z",
                        fillRule: "nonzero"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("L6wJo", function(module, exports) {

$parcel$export(module.exports, "Lightning", function () { return $601c824d7a72a226$export$71809dd4a5478fb0; });

var $1rY3h = parcelRequire("1rY3h");
var $601c824d7a72a226$export$71809dd4a5478fb0 = function(param) {
    var size = param.size;
    return /*#__PURE__*/ (0, $1rY3h.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMinYMin meet",
        viewBox: "0 0 36 36",
        width: size,
        height: size,
        children: /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
            style: {
                fill: "#0065ff",
                fillRule: "evenodd"
            },
            d: "M29.12 13.67h-8L22.8 1.2a1 1 0 0 0-1.88-.77L6 20.65a1.06 1.06 0 0 0 .85 1.68h8.05L13.2 34.8a1 1 0 0 0 1.88.77L30 15.35a1.06 1.06 0 0 0-.88-1.68Z"
        })
    });
};

});

parcelRegister("2rgkc", function(module, exports) {

$parcel$export(module.exports, "Maximize", function () { return $4382b31ec0618c6a$export$641c2d00a5a05a3e; });

var $1rY3h = parcelRequire("1rY3h");
var $4382b31ec0618c6a$export$641c2d00a5a05a3e = function(param) {
    var size = param.size;
    return /*#__PURE__*/ (0, $1rY3h.jsx)("svg", {
        id: "icon-content-maximize",
        width: size,
        height: size,
        viewBox: "0 0 64 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                        d: "M56.54,0.18 C60.66,0.18 64,3.52 64,7.64 L64,56.73 C64,60.85 60.66,64.18 56.54,64.18 L7.46,64.18 L7.42,64.18 L25.37,64.18 C29.2,64.18 32.31,61.08 32.31,57.24 L32.31,38.81 C32.31,38 32.17,37.21 31.91,36.49 L48.79,19.61 L48.79,26.83 L48.79,26.98 C48.86,28.45 50.09,29.63 51.58,29.63 C53.13,29.63 54.38,28.38 54.38,26.83 L54.38,12.54 L54.37,12.39 C54.3,10.92 53.08,9.74 51.58,9.74 L36.85,9.74 L36.7,9.75 C35.23,9.82 34.05,11.04 34.05,12.54 L34.06,12.68 C34.13,14.16 35.35,15.33 36.85,15.33 L45.15,15.33 L28.07,32.42 C27.24,32.07 26.33,31.87 25.37,31.87 L6.94,31.87 C3.11,31.87 0,34.98 0,38.81 L0,7.64 C0,3.52 3.34,0.18 7.46,0.18 L56.54,0.18 Z"
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                        d: "M24.85,31.87 C25.96,31.87 27,32.11 27.95,32.54 L14,46.49 L13.91,46.58 C12.91,47.68 12.94,49.38 14,50.44 C15.09,51.53 16.86,51.53 17.96,50.44 L31.8,36.6 C32.13,37.45 32.31,38.37 32.31,39.33 L32.31,56.73 C32.31,60.85 28.97,64.18 24.85,64.18 L7.46,64.18 C3.34,64.18 0,60.85 0,56.73 L0,39.33 C0,35.21 3.34,31.87 7.46,31.87 L24.85,31.87 Z",
                        opacity: "0.5"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("kv0wa", function(module, exports) {

$parcel$export(module.exports, "PageMultiple", function () { return $7f6a1e518b81f534$export$23b02afe38134aca; });

var $1rY3h = parcelRequire("1rY3h");
var $7f6a1e518b81f534$export$23b02afe38134aca = function(param) {
    var size = param.size;
    return /*#__PURE__*/ (0, $1rY3h.jsx)("svg", {
        id: "icon-content-page multiple",
        width: size,
        height: size,
        viewBox: "0 0 64 77",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ (0, $1rY3h.jsx)("g", {
                        transform: "translate(49.000000, 0.000000)",
                        children: /*#__PURE__*/ (0, $1rY3h.jsx)("polygon", {
                            points: "15 15.27 0.19 15.27 0.19 0.46"
                        })
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsxs)("g", {
                        children: [
                            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                                d: "M42.07,76.31 C46,76.31 49.19,73.13 49.19,69.2 L49.19,30.09 L34.37,15.27 L7.11,15.27 C3.18,15.27 0,18.46 0,22.38 L0,69.2 C0,73.13 3.18,76.31 7.11,76.31 L42.07,76.31 Z M40.59,39.27 C40.59,37.8 39.4,36.61 37.93,36.61 L11.85,36.61 L11.73,36.61 C10.31,36.67 9.19,37.84 9.19,39.27 C9.19,40.75 10.38,41.94 11.85,41.94 L37.93,41.94 L38.05,41.94 C39.47,41.87 40.59,40.7 40.59,39.27 Z M24.89,50.24 C26.36,50.24 27.56,51.43 27.56,52.9 C27.56,54.33 26.43,55.5 25.01,55.57 L24.89,55.57 L11.85,55.57 C10.38,55.57 9.19,54.38 9.19,52.9 C9.19,51.47 10.31,50.3 11.73,50.24 L11.85,50.24 L24.89,50.24 Z M34.37,30.09 L49.19,30.09 L34.37,15.27 L34.37,30.09 Z"
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                                d: "M56.89,61.49 C60.82,61.49 64,58.31 64,54.38 L64,15.27 L49.18,0.46 L21.93,0.46 C18,0.46 14.81,3.64 14.81,7.57 L14.81,33.64 L43.26,33.64 L43.26,61.49 L56.89,61.49 Z M34.37,30.09 L49.18,30.09 L34.37,15.27 L34.37,30.09 Z",
                                opacity: "0.5"
                            })
                        ]
                    })
                ]
            })
        })
    });
};

});

parcelRegister("imDLZ", function(module, exports) {

$parcel$export(module.exports, "Team", function () { return $671d3311d53bf743$export$3e5d0af8e738b082; });

var $1rY3h = parcelRequire("1rY3h");
var $671d3311d53bf743$export$3e5d0af8e738b082 = function(param) {
    var size = param.size;
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMinYMin meet",
        viewBox: "0 0 36 36",
        width: size,
        height: size,
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                style: {
                    opacity: 0.5,
                    fill: "#0065ff",
                    fillRule: "evenodd"
                },
                d: "M10.84 28.07v-3.71a5.57 5.57 0 0 1 1.74-4.05 5.57 5.57 0 0 0-3.88-1.56H5.61A5.61 5.61 0 0 0 0 24.36v3.71a1 1 0 0 0 1 1h10.82a1 1 0 0 1-.98-1Zm-3.68-10.6A4.12 4.12 0 1 0 3 13.35a4.12 4.12 0 0 0 4.16 4.12Zm23.23 1.28H27.3a5.57 5.57 0 0 0-3.88 1.56 5.57 5.57 0 0 1 1.74 4.05v3.71a1 1 0 0 1-1 1H35a1 1 0 0 0 1-1v-3.71a5.61 5.61 0 0 0-5.61-5.61Zm-1.55-1.28a4.12 4.12 0 1 0-4.12-4.12 4.11 4.11 0 0 0 4.12 4.12Zm-13.99-6.75a4.08 4.08 0 0 0-.92 2.58h4a.65.65 0 0 0 .52-.26l.93-1.24a.22.22 0 0 1 .35 0l.93 1.24a.68.68 0 0 0 .53.26h.91A4.07 4.07 0 0 0 18 9.23a4.41 4.41 0 0 0-.52 0 2 2 0 0 0 0-.36 2 2 0 1 0-2.66 1.82Z"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                style: {
                    fill: "#0065ff",
                    fillRule: "evenodd"
                },
                d: "M23.42 20.31a5.55 5.55 0 0 0-3.87-1.57h-3.09a5.65 5.65 0 0 0-5.62 5.62v4.69h13.34a1 1 0 0 0 1-1v-3.69a5.57 5.57 0 0 0-1.76-4.05Zm-2.8-7.22-.93-1.24a.22.22 0 0 0-.35 0l-.93 1.24a.65.65 0 0 1-.52.26h-4a1 1 0 0 0 0 .17 1.62 1.62 0 0 0 0 .22v.4c0 .06 0 .12.05.19s0 .13 0 .2l.07.18.07.19.09.17.08.18.11.17a1.4 1.4 0 0 0 .1.16l.12.17a1.71 1.71 0 0 0 .11.14l.14.16.12.13.16.15a.69.69 0 0 1 .13.11l.19.14.12.09.21.13.13.07a1.67 1.67 0 0 0 .23.12l.12.05.28.11h.09l.35.09a4.47 4.47 0 0 0 .82.08 4 4 0 0 0 1.21-.18l.34-.13h.06l.3-.15h.06l.27-.16.07-.05.24-.18.08-.07.21-.19.07-.08.19-.21.07-.09.17-.22.06-.11.14-.22.06-.13a1.63 1.63 0 0 0 .11-.23s0-.09.05-.13l.09-.24a.83.83 0 0 1 0-.15l.06-.24L22 14v-.24a.91.91 0 0 0 0-.17 1.48 1.48 0 0 0 0-.21h-.91a.68.68 0 0 1-.47-.29Z"
            })
        ]
    });
};

});

parcelRegister("8cWLo", function(module, exports) {

$parcel$export(module.exports, "Bold", function () { return $2ac4995419df426c$export$95aa4184327d6b72; });

var $1rY3h = parcelRequire("1rY3h");
var $2ac4995419df426c$export$95aa4184327d6b72 = function(param) {
    var size = param.size;
    return /*#__PURE__*/ (0, $1rY3h.jsx)("svg", {
        id: "icon-object-bolt",
        width: size,
        height: size,
        viewBox: "0 0 44 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                        d: "M27.28,1.13 C28.43,-0.43 30.91,0.57 30.64,2.49 L25.42,40.05 L2.32,40.05 C0.79,40.05 -0.09,38.31 0.82,37.08 L27.28,1.13 Z"
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                        d: "M41.87,24.67 C43.4,24.67 44.29,26.41 43.38,27.65 L16.92,63.59 C15.77,65.16 13.29,64.15 13.56,62.23 L18.77,24.67 L41.87,24.67 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("5hWNL", function(module, exports) {

$parcel$export(module.exports, "Building", function () { return $95968246fe14e13a$export$bb414d9e15d07212; });

var $1rY3h = parcelRequire("1rY3h");
var $95968246fe14e13a$export$bb414d9e15d07212 = function(param) {
    var size = param.size;
    return /*#__PURE__*/ (0, $1rY3h.jsx)("svg", {
        id: "icon-object-building",
        width: size,
        height: size,
        viewBox: "0 0 65 41",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                        d: "M38.99,15.13 C40.27,15.42 41.22,16.56 41.22,17.92 C41.22,19.49 39.94,20.77 38.35,20.77 C36.76,20.77 35.48,19.49 35.48,17.92 C35.48,16.56 36.43,15.42 37.7,15.13 L27.1,15.13 C28.57,15.25 29.73,16.48 29.73,17.98 C29.73,19.56 28.44,20.84 26.86,20.84 C25.27,20.84 23.99,19.56 23.99,17.98 C23.99,16.48 25.15,15.25 26.62,15.13 L10.24,15.13 C7.7,15.13 5.34,17.18 5.34,19.7 L5.34,39.45 L60.19,39.45 L60.19,19.7 C60.19,17.18 58.13,15.13 55.59,15.13 L38.99,15.13 Z",
                        opacity: "0.5"
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                        d: "M16.71,37.14 L16.71,4.77 C16.71,2.24 18.77,0.19 21.3,0.19 L43.9,0.19 C46.44,0.19 48.5,2.24 48.5,4.77 L48.5,37.14 L62.67,37.14 C63.74,37.14 64.6,38 64.6,39.07 C64.6,40.14 63.74,41 62.67,41 L2.54,41 C1.47,41 0.6,40.14 0.6,39.07 C0.6,38 1.47,37.14 2.54,37.14 L16.71,37.14 Z M28.96,37.14 L28.96,31.16 C28.96,29.22 30.55,27.63 32.51,27.63 C34.47,27.63 36.06,29.22 36.06,31.16 L36.06,37.14 L28.96,37.14 Z M29.73,17.98 C29.73,16.4 28.44,15.12 26.86,15.12 C25.27,15.12 23.99,16.4 23.99,17.98 C23.99,19.56 25.27,20.84 26.86,20.84 C28.44,20.84 29.73,19.56 29.73,17.98 Z M38.35,15.06 C39.94,15.06 41.22,16.34 41.22,17.92 C41.22,19.49 39.94,20.77 38.35,20.77 C36.76,20.77 35.48,19.49 35.48,17.92 C35.48,16.34 36.76,15.06 38.35,15.06 Z M29.73,8.77 C29.73,7.19 28.44,5.91 26.86,5.91 C25.27,5.91 23.99,7.19 23.99,8.77 C23.99,10.35 25.27,11.63 26.86,11.63 C28.44,11.63 29.73,10.35 29.73,8.77 Z M38.35,5.91 C39.94,5.91 41.22,7.19 41.22,8.77 C41.22,10.35 39.94,11.63 38.35,11.63 C36.76,11.63 35.48,10.35 35.48,8.77 C35.48,7.19 36.76,5.91 38.35,5.91 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("lyWte", function(module, exports) {

$parcel$export(module.exports, "CircleUnions", function () { return $22b75f3d6dacabc8$export$f636abc3133e4e68; });

var $1rY3h = parcelRequire("1rY3h");
var $22b75f3d6dacabc8$export$f636abc3133e4e68 = function(param) {
    var size = param.size;
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("svg", {
        id: "icon-object-circle-unions",
        width: size,
        height: size,
        viewBox: "0 0 29 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                opacity: "0.5",
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.9826 18.6349C15.2121 16.6342 12.3815 16.6342 11.611 18.6349L11.4673 19.0081L11.0941 19.1518C9.09347 19.9223 9.09347 22.7528 11.0941 23.5233L11.4673 23.6671L11.611 24.0402C12.3815 26.0409 15.2121 26.0409 15.9826 24.0402L16.1263 23.6671L16.4995 23.5233C18.5001 22.7528 18.5001 19.9223 16.4995 19.1518L16.1263 19.0081L15.9826 18.6349Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.5 0.923096C22.5081 0.923096 29 7.41497 29 15.4231C29 23.4312 22.5081 29.9231 14.5 29.9231C6.49187 29.9231 0 23.4312 0 15.4231C0 7.41497 6.49187 0.923096 14.5 0.923096ZM21.1305 12.0019C20.9409 11.5095 20.2442 11.5095 20.0546 12.0019L19.3272 13.8905L17.4385 14.6179C16.9461 14.8076 16.9461 15.5042 17.4385 15.6939L19.3272 16.4212L20.0546 18.3099C20.2442 18.8023 20.9409 18.8023 21.1305 18.3099L21.8579 16.4212L23.7465 15.6939C24.239 15.5042 24.239 14.8076 23.7465 14.6179L21.8579 13.8905L21.1305 12.0019ZM14.4147 18.1835C14.2251 17.6911 13.5284 17.6911 13.3388 18.1835L12.6114 20.0722L10.7228 20.7995C10.2303 20.9892 10.2303 21.6859 10.7228 21.8755L12.6114 22.6029L13.3388 24.4915C13.5284 24.9839 14.2251 24.9839 14.4147 24.4915L15.1421 22.6029L17.0308 21.8755C17.5232 21.6859 17.5232 20.9892 17.0308 20.7995L15.1421 20.0722L14.4147 18.1835ZM10.2929 6.98007C10.5205 6.38917 11.3565 6.38917 11.5841 6.98007L12.479 9.30358L14.8025 10.1984C15.3934 10.426 15.3934 11.262 14.8025 11.4896L12.479 12.3844L11.5841 14.7079C11.3565 15.2989 10.5205 15.2989 10.2929 14.7079L9.3981 12.3844L7.07459 11.4896C6.48369 11.262 6.48368 10.426 7.07459 10.1984L9.3981 9.30358L10.2929 6.98007Z",
                fill: "currentColor"
            })
        ]
    });
};

});

parcelRegister("cjttc", function(module, exports) {

$parcel$export(module.exports, "Id", function () { return $652d5b67cbe31f7b$export$46b83a6aabf254e3; });

var $1rY3h = parcelRequire("1rY3h");
var $652d5b67cbe31f7b$export$46b83a6aabf254e3 = function(param) {
    var size = param.size;
    return /*#__PURE__*/ (0, $1rY3h.jsx)("svg", {
        id: "icon-object-id",
        width: size,
        height: size,
        viewBox: "0 0 65 50",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                        d: "M54.67,49.007 C60.22,49.007 64.72,44.508 64.72,38.958 C64.72,33.408 60.22,28.908 54.67,28.908 C49.12,28.908 44.62,33.408 44.62,38.958 C44.62,44.508 49.12,49.007 54.67,49.007 Z M60.89,37.253 C61.44,36.63 61.41,35.68 60.82,35.085 L60.74,35.014 C60.12,34.467 59.17,34.49 58.58,35.085 L53.8,39.864 L51.21,37.647 L51.13,37.584 C50.47,37.084 49.52,37.18 48.97,37.819 C48.4,38.485 48.48,39.486 49.14,40.057 L52.85,43.23 L52.93,43.295 C53.55,43.766 54.44,43.709 55,43.148 L60.82,37.329 L60.89,37.253 Z",
                        opacity: "0.5"
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsxs)("g", {
                        transform: "translate(27.000000, 14.000000)",
                        fillRule: "nonzero",
                        opacity: "0.5",
                        children: [
                            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                                d: "M23.92,0.67 C25.23,0.67 26.3,1.736 26.3,3.05 C26.3,4.327 25.29,5.369 24.03,5.428 L23.92,5.43 L3.29,5.43 C1.97,5.43 0.91,4.365 0.91,3.05 C0.91,1.773 1.91,0.731 3.18,0.673 L3.29,0.67 L23.92,0.67 Z"
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                                d: "M13.34,11.248 C14.65,11.248 15.72,12.314 15.72,13.628 C15.72,14.905 14.71,15.947 13.45,16.006 L13.34,16.008 L3.29,16.008 C1.97,16.008 0.91,14.943 0.91,13.628 C0.91,12.351 1.91,11.309 3.18,11.251 L3.29,11.248 L13.34,11.248 Z"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                        d: "M7.07,0.346 C3.56,0.346 0.72,3.187 0.72,6.693 L0.72,37.899 C0.72,41.405 3.56,44.247 7.07,44.247 L46.13,44.247 C45.17,42.71 44.62,40.898 44.62,38.957 C44.62,33.407 49.12,28.908 54.67,28.908 C56.61,28.908 58.43,29.458 59.96,30.411 L59.96,6.693 C59.96,3.187 57.12,0.346 53.62,0.346 L7.07,0.346 Z M10.24,33.819 L19.76,33.819 C21.87,33.819 23.57,32.113 23.57,30.008 L23.57,28.121 C23.57,24.43 20.48,21.414 16.76,21.414 L13.07,21.414 C9.37,21.414 6.43,24.408 6.43,28.121 L6.43,30.008 C6.43,32.113 8.14,33.819 10.24,33.819 Z M15,10.287 C12.31,10.287 10.13,12.467 10.13,15.156 C10.13,17.845 12.31,20.024 15,20.024 C17.69,20.024 19.87,17.845 19.87,15.156 C19.87,12.467 17.69,10.287 15,10.287 Z M53.3,17.049 C53.3,15.735 52.23,14.669 50.92,14.669 L30.29,14.669 L30.18,14.672 C28.91,14.73 27.91,15.772 27.91,17.049 C27.91,18.364 28.97,19.429 30.29,19.429 L50.92,19.429 L51.03,19.427 C52.29,19.368 53.3,18.326 53.3,17.049 Z M40.34,25.248 C41.65,25.248 42.72,26.313 42.72,27.628 C42.72,28.905 41.71,29.947 40.45,30.005 L40.34,30.008 L30.29,30.008 C28.97,30.008 27.91,28.942 27.91,27.628 C27.91,26.351 28.91,25.309 30.18,25.25 L30.29,25.248 L40.34,25.248 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("3HRil", function(module, exports) {

$parcel$export(module.exports, "Lightbulb", function () { return $51e20de6982ee824$export$3d88f82d313e52c; });

var $1rY3h = parcelRequire("1rY3h");
var $51e20de6982ee824$export$3d88f82d313e52c = function(param) {
    var size = param.size;
    return /*#__PURE__*/ (0, $1rY3h.jsx)("svg", {
        id: "icon-object-lightbulb",
        width: size,
        height: size,
        viewBox: "0 0 46 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                        d: "M39.49,38 C47.99,29.5 47.99,15.7 39.49,7.2 C30.59,-1.7 16.15,-1.7 7.24,7.2 C6.99,7.5 6.76,7.7 6.52,8 C-1.56,16.9 -0.9,30.6 7.99,38.7 L11.98,42.3 L11.98,49.7 L34.75,49.7 L34.75,42.3 L38.75,38.7 C39,38.5 39.25,38.2 39.49,38 Z M25.49,10 C25.49,8.6 24.33,7.4 22.91,7.4 C14.53,7.4 7.74,14.2 7.74,22.6 L7.74,23.2 L7.74,23.3 C7.8,24.7 8.93,25.8 10.31,25.8 C11.74,25.8 12.89,24.6 12.89,23.2 L12.89,22.6 L12.89,22.4 C12.99,17 17.44,12.6 22.91,12.6 C24.33,12.6 25.49,11.4 25.49,10 Z"
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                        d: "M34.75,54.9 L34.75,54.9 L11.98,54.9 L11.98,56.9 C11.98,61.1 15.42,64.6 19.66,64.6 L27.07,64.6 C31.31,64.6 34.75,61.1 34.75,56.9 L34.75,54.9 Z",
                        opacity: "0.5"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("ccgJ9", function(module, exports) {

$parcel$export(module.exports, "LocationPin", function () { return $6114c7203da252dd$export$31790a3eeff59d4a; });

var $1rY3h = parcelRequire("1rY3h");
var $6114c7203da252dd$export$31790a3eeff59d4a = function(param) {
    var size = param.size;
    return /*#__PURE__*/ (0, $1rY3h.jsx)("svg", {
        id: "icon-object-location pin",
        width: size,
        height: size,
        viewBox: "0 0 56 64",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $1rY3h.jsx)("g", {
                fill: "currentColor",
                children: /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                    d: "M47.87,8.1 C37.03,-2.7 19.46,-2.7 8.62,8.1 C-2.22,18.9 -2.22,36.4 8.62,47.2 L23.43,62 C26.09,64.6 30.4,64.6 33.06,62 L47.87,47.2 C58.71,36.4 58.71,18.9 47.87,8.1 Z M28.08,38.4 C34.02,38.4 38.84,33.6 38.84,27.7 C38.84,21.7 34.02,16.9 28.08,16.9 C22.13,16.9 17.31,21.7 17.31,27.7 C17.31,33.6 22.13,38.4 28.08,38.4 Z"
                })
            })
        })
    });
};

});

parcelRegister("dXEF7", function(module, exports) {

$parcel$export(module.exports, "Lock", function () { return $85266e075d3de1cd$export$5b9db7ce80343746; });

var $1rY3h = parcelRequire("1rY3h");
var $85266e075d3de1cd$export$5b9db7ce80343746 = function(param) {
    var size = param.size;
    return /*#__PURE__*/ (0, $1rY3h.jsx)("svg", {
        id: "icon-object-lock",
        width: size,
        height: size,
        viewBox: "0 0 52 64",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                        d: "M29.03,28.9 L22.85,28.9 C18.36,28.9 14.71,25.3 14.71,20.8 L14.71,11.2 C14.71,5 19.74,0 25.94,0 C32.14,0 37.17,5 37.17,11.2 L37.17,20.8 C37.17,25.3 33.52,28.9 29.03,28.9 Z M22.85,23.8 L29.03,23.8 C30.73,23.8 32.12,22.5 32.12,20.8 L32.12,11.2 C32.12,7.8 29.35,5 25.94,5 C22.53,5 19.77,7.8 19.77,11.2 L19.77,20.8 C19.77,22.5 21.15,23.8 22.85,23.8 Z",
                        opacity: "0.5"
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                        d: "M7.13,17.4 C3.41,17.4 0.4,20.4 0.4,24.1 L0.4,57.2 C0.4,61 3.41,64 7.13,64 L44.75,64 C48.47,64 51.49,61 51.49,57.2 L51.49,24.1 C51.49,20.4 48.47,17.4 44.75,17.4 L7.13,17.4 Z M25.94,48.3 C29.51,48.3 32.4,45.4 32.4,41.8 C32.4,38.2 29.51,35.4 25.94,35.4 C22.38,35.4 19.49,38.2 19.49,41.8 C19.49,45.4 22.38,48.3 25.94,48.3 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("hVpBS", function(module, exports) {

$parcel$export(module.exports, "PuzzlePiece", function () { return $8f3578c4e37a94ff$export$c8d5f6414677f141; });

var $1rY3h = parcelRequire("1rY3h");
var $8f3578c4e37a94ff$export$c8d5f6414677f141 = function(param) {
    var size = param.size;
    return /*#__PURE__*/ (0, $1rY3h.jsx)("svg", {
        id: "icon-object-puzzle piece",
        width: size,
        height: size,
        viewBox: "0 0 65 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $1rY3h.jsx)("g", {
                fill: "currentColor",
                fillRule: "nonzero",
                children: /*#__PURE__*/ (0, $1rY3h.jsxs)("g", {
                    children: [
                        /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                            d: "M48.46,10.6 C51.94,10.6 54.76,13.5 54.76,16.9 L54.76,58.4 C54.76,61.9 51.94,64.7 48.46,64.7 L36.33,64.7 C36.37,64.3 36.39,64 36.39,63.6 C36.39,58.7 32.4,54.7 27.48,54.7 C22.55,54.7 18.56,58.7 18.56,63.6 C18.56,64 18.58,64.3 18.62,64.7 L7.02,64.7 C3.54,64.7 0.72,61.9 0.72,58.4 L0.72,46.8 C1.07,46.8 1.42,46.8 1.77,46.8 C6.7,46.8 10.69,42.8 10.69,37.9 C10.69,33 6.7,29 1.77,29 C1.42,29 1.07,29 0.72,29.1 L0.72,16.9 C0.72,13.5 3.54,10.6 7.02,10.6 L48.46,10.6 Z"
                        }),
                        /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                            d: "M64.72,37.9 C64.72,42.8 60.73,46.8 55.8,46.8 C50.88,46.8 46.89,42.8 46.89,37.9 C46.89,33 50.88,29 55.8,29 C60.73,29 64.72,33 64.72,37.9 Z"
                        }),
                        /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                            d: "M36.39,9.6 C36.39,14.5 32.4,18.5 27.48,18.5 C22.55,18.5 18.56,14.5 18.56,9.6 C18.56,4.7 22.55,0.7 27.48,0.7 C32.4,0.7 36.39,4.7 36.39,9.6 Z"
                        })
                    ]
                })
            })
        })
    });
};

});

parcelRegister("eEB6V", function(module, exports) {

$parcel$export(module.exports, "SecurityCheckmark", function () { return $8c724c54d05dc11c$export$992764df22cf8b12; });

var $1rY3h = parcelRequire("1rY3h");
var $8c724c54d05dc11c$export$992764df22cf8b12 = function(param) {
    var size = param.size;
    return /*#__PURE__*/ (0, $1rY3h.jsx)("svg", {
        id: "icon-object-security checkmark",
        width: size,
        height: size,
        viewBox: "0 0 56 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $1rY3h.jsx)("g", {
                fill: "currentColor",
                children: /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                    d: "M55.36,7.5 C55.71,6.6 55.94,6 54.78,6 L50.86,6 C43.02,6 32.95,2.3 29.32,0.8 C28.44,0.5 27.45,0.5 26.57,0.8 C22.94,2.3 12.87,6 5.03,6 L1.11,6 C-0.06,6 0.17,6.6 0.53,7.5 C0.75,8 1.02,8.7 1.02,9.4 L1.02,30.2 C1.02,43 8.21,54.8 19.64,60.7 L26.37,64.2 C27.36,64.7 28.53,64.7 29.52,64.2 L36.25,60.7 C47.68,54.8 54.87,43 54.87,30.2 L54.87,9.4 C54.87,8.7 55.14,8 55.36,7.5 Z M41.36,23.3 C42.28,22.3 42.25,20.7 41.28,19.8 L41.19,19.7 C40.18,18.8 38.61,18.8 37.63,19.8 L24.06,33.3 L19.4,28.7 L19.32,28.6 C18.3,27.7 16.74,27.7 15.76,28.7 C14.75,29.7 14.75,31.3 15.76,32.3 L22.24,38.8 L22.33,38.9 C23.34,39.8 24.91,39.8 25.88,38.8 L41.28,23.4 L41.36,23.3 Z"
                })
            })
        })
    });
};

});

parcelRegister("fmncI", function(module, exports) {

$parcel$export(module.exports, "Video", function () { return $00e0ed19f8c3c8bb$export$ae01dedf5c052bb; });

var $1rY3h = parcelRequire("1rY3h");
var $00e0ed19f8c3c8bb$export$ae01dedf5c052bb = function(param) {
    var size = param.size;
    return /*#__PURE__*/ (0, $1rY3h.jsx)("svg", {
        id: "icon-object-video",
        width: size,
        height: size,
        viewBox: "0 0 65 48",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                        d: "M46.69,17.5 L58.31,6.2 C60.45,4.1 64.04,5.7 64.04,8.6 L64.04,39.3 C64.04,42.3 60.45,43.8 58.31,41.7 L46.69,30.5 L41.07,30.5 L41.07,17.5 L46.69,17.5 Z"
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                        d: "M39.95,0.7 C43.67,0.7 46.69,3.7 46.69,7.4 L46.69,40.6 C46.69,44.3 43.67,47.3 39.95,47.3 L6.78,47.3 C3.06,47.3 0.04,44.3 0.04,40.6 L0.04,7.4 C0.04,3.7 3.06,0.7 6.78,0.7 L39.95,0.7 Z M38.82,13.3 C38.82,15.9 36.68,18.1 34.04,18.1 C31.4,18.1 29.27,15.9 29.27,13.3 C29.27,10.7 31.4,8.5 34.04,8.5 C36.68,8.5 38.82,10.7 38.82,13.3 Z M38.54,35.8 C38.54,34.4 37.41,33.3 36.01,33.3 L11.28,33.3 L11.16,33.3 C9.82,33.3 8.75,34.4 8.75,35.8 C8.75,37.2 9.88,38.3 11.28,38.3 L36.01,38.3 L36.13,38.3 C37.47,38.3 38.54,37.1 38.54,35.8 Z"
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("g", {
                        transform: "translate(8.000000, 33.000000)",
                        fillRule: "nonzero",
                        opacity: "0.5",
                        children: /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                            d: "M28.01,0.3 C29.41,0.3 30.54,1.4 30.54,2.8 C30.54,4.1 29.47,5.3 28.13,5.3 L28.01,5.3 L3.28,5.3 C1.88,5.3 0.75,4.2 0.75,2.8 C0.75,1.4 1.82,0.3 3.16,0.3 L3.28,0.3 L28.01,0.3 Z"
                        })
                    })
                ]
            })
        })
    });
};

});

parcelRegister("2J0Tn", function(module, exports) {

$parcel$export(module.exports, "Wrench", function () { return $cb15612396ce520b$export$4421f7c88022a750; });

var $1rY3h = parcelRequire("1rY3h");
var $cb15612396ce520b$export$4421f7c88022a750 = function(param) {
    var size = param.size;
    return /*#__PURE__*/ (0, $1rY3h.jsx)("svg", {
        id: "icon-object-magnifying glass_2",
        width: size,
        height: size,
        viewBox: "0 0 65 64",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                        d: "M3.67,60.2 C8.27,64.8 15.73,64.8 20.33,60.2 L38.71,41.8 L22.05,25.1 L3.67,43.5 C-0.93,48.1 -0.93,55.6 3.67,60.2 Z M16.63,52.5 C16.63,49.5 14.15,47 11.09,47 C8.02,47 5.54,49.5 5.54,52.5 C5.54,55.6 8.02,58.1 11.09,58.1 C14.15,58.1 16.63,55.6 16.63,52.5 Z",
                        opacity: "0.5"
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                        d: "M64.22,24.2 C64.22,37.4 53.54,48.1 40.38,48.1 C27.21,48.1 16.54,37.4 16.54,24.2 C16.54,11.1 27.21,0.4 40.38,0.4 C41.9,0.4 43.39,0.5 44.83,0.8 C45.66,1 45.94,2 45.35,2.6 L37.72,10.3 C33.06,14.9 33.07,22.5 37.73,27.1 C42.39,31.8 49.96,31.8 54.62,27.1 L62.1,19.7 C62.69,19.1 63.73,19.4 63.87,20.2 C64.1,21.5 64.22,22.9 64.22,24.2 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("bozG9", function(module, exports) {

$parcel$export(module.exports, "CloudCheckmark", function () { return $a6ea2f6506f37340$export$c680fbc74fda3897; });

var $1rY3h = parcelRequire("1rY3h");
var $a6ea2f6506f37340$export$c680fbc74fda3897 = function(param) {
    var size = param.size;
    return /*#__PURE__*/ (0, $1rY3h.jsx)("svg", {
        id: "icon-software-cloud checkmark",
        width: size,
        height: size,
        viewBox: "0 0 65 44",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $1rY3h.jsx)("g", {
                fill: "currentColor",
                children: /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                    d: "M44.93,8.67 C41.37,3.38 35.38,0.08 28.8,0.08 C18.68,0.08 10.37,7.81 9.45,17.69 C4.45,19.6 0.99,24.44 0.99,29.99 C0.99,37.26 6.88,43.15 14.15,43.15 L47.64,43.15 L47.93,43.15 C57.38,42.99 64.99,35.29 64.99,25.8 C64.99,16.22 57.22,8.46 47.64,8.46 C46.73,8.46 45.82,8.53 44.93,8.67 Z M44.06,19.15 C44.87,18.27 44.84,16.9 43.99,16.05 L43.91,15.98 C43.03,15.18 41.67,15.2 40.82,16.05 L29.01,27.86 L24.96,23.81 L24.88,23.73 C24,22.93 22.64,22.96 21.79,23.81 C20.91,24.68 20.91,26.1 21.79,26.98 L27.43,32.62 L27.5,32.69 C28.38,33.49 29.75,33.47 30.6,32.62 L43.99,19.22 L44.06,19.15 Z"
                })
            })
        })
    });
};

});

parcelRegister("ddO6b", function(module, exports) {

$parcel$export(module.exports, "DataCenter", function () { return $2ab1c54a23cf0f58$export$f4645eafb2eadc0c; });

var $1rY3h = parcelRequire("1rY3h");
var $2ab1c54a23cf0f58$export$f4645eafb2eadc0c = function(param) {
    var size = param.size;
    return /*#__PURE__*/ (0, $1rY3h.jsx)("svg", {
        id: "icon-software-data center",
        width: size,
        height: size,
        viewBox: "0 0 65 71",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ (0, $1rY3h.jsxs)("g", {
                        children: [
                            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                                d: "M64.93,51.51 L64.93,66.43 C64.93,68.49 63.26,70.15 61.2,70.15 L4.66,70.15 C2.6,70.15 0.93,68.49 0.93,66.43 L0.93,51.51 L64.93,51.51 Z M15.84,60.83 C15.84,62.89 14.17,64.56 12.11,64.56 C10.05,64.56 8.38,62.89 8.38,60.83 C8.38,58.77 10.05,57.1 12.11,57.1 C14.17,57.1 15.84,58.77 15.84,60.83 Z M57.78,60.83 C57.78,59.29 56.53,58.04 54.99,58.04 L27.65,58.04 L27.51,58.04 C26.03,58.11 24.85,59.33 24.85,60.83 C24.85,62.38 26.1,63.63 27.65,63.63 L54.99,63.63 L55.12,63.63 C56.6,63.56 57.78,62.33 57.78,60.83 Z"
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                                d: "M64.93,26.04 L64.93,44.68 L0.93,44.68 L0.93,26.04 L64.93,26.04 Z M15.84,35.36 C15.84,37.42 14.17,39.08 12.11,39.08 C10.05,39.08 8.38,37.42 8.38,35.36 C8.38,33.3 10.05,31.63 12.11,31.63 C14.17,31.63 15.84,33.3 15.84,35.36 Z M57.78,35.36 C57.78,33.81 56.53,32.56 54.99,32.56 L27.65,32.56 L27.51,32.56 C26.03,32.63 24.85,33.86 24.85,35.36 C24.85,36.9 26.1,38.15 27.65,38.15 L54.99,38.15 L55.12,38.15 C56.6,38.08 57.78,36.86 57.78,35.36 Z"
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                                d: "M61.2,0.56 C63.26,0.56 64.93,2.23 64.93,4.29 L64.93,19.2 L0.93,19.2 L0.93,4.29 C0.93,2.23 2.6,0.56 4.66,0.56 L61.2,0.56 Z M15.84,9.88 C15.84,11.94 14.17,13.61 12.11,13.61 C10.05,13.61 8.38,11.94 8.38,9.88 C8.38,7.82 10.05,6.15 12.11,6.15 C14.17,6.15 15.84,7.82 15.84,9.88 Z M57.78,9.88 C57.78,8.34 56.53,7.09 54.99,7.09 L27.65,7.09 L27.51,7.09 C26.03,7.16 24.85,8.38 24.85,9.88 C24.85,11.43 26.1,12.68 27.65,12.68 L54.99,12.68 L55.12,12.68 C56.6,12.61 57.78,11.38 57.78,9.88 Z"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("rect", {
                        fillRule: "nonzero",
                        opacity: "0.5",
                        x: "0.93",
                        y: "44.68",
                        width: "63.9997",
                        height: "6.83492"
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("rect", {
                        fillRule: "nonzero",
                        opacity: "0.5",
                        x: "0.93",
                        y: "19.2",
                        width: "63.9997",
                        height: "6.83492"
                    })
                ]
            })
        })
    });
};

});


parcelRegister("jFpHW", function(module, exports) {

$parcel$export(module.exports, "getGradient", function () { return $9c164866cd5c7159$export$e14995d3ec1747ee; });
var $9c164866cd5c7159$export$e14995d3ec1747ee = function(angle, color1, color2) {
    if (angle && color1 && color2) return "linear-gradient(".concat(angle, "deg, ").concat(color1, ", ").concat(color2, ")");
    return "";
};

});

parcelRegister("l227w", function(module, exports) {

$parcel$export(module.exports, "Logo", function () { return $d37cef68a5f2c362$export$e6ff31bff12b7ff4; });

var $1rY3h = parcelRequire("1rY3h");

var $5o2Pg = parcelRequire("5o2Pg");

var $i557m = parcelRequire("i557m");

var $l0SPD = parcelRequire("l0SPD");

var $7A42A = parcelRequire("7A42A");

var $f6Yvu = parcelRequire("f6Yvu");

var $iFGle = parcelRequire("iFGle");

var $5FYSv = parcelRequire("5FYSv");

var $gOnrr = parcelRequire("gOnrr");

var $iJ53B = parcelRequire("iJ53B");

var $7KmBg = parcelRequire("7KmBg");

var $avyHy = parcelRequire("avyHy");

var $8YCBc = parcelRequire("8YCBc");

var $4pNZF = parcelRequire("4pNZF");

var $lOhFL = parcelRequire("lOhFL");

var $kIrQm = parcelRequire("kIrQm");

var $4P0be = parcelRequire("4P0be");

var $jThhL = parcelRequire("jThhL");

var $i6sD3 = parcelRequire("i6sD3");

var $1CSrR = parcelRequire("1CSrR");
var $d37cef68a5f2c362$var$Logos = {
    atlas: {
        mark: {
            brand: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $5o2Pg.AtlasMarkBrand), {})
        }
    },
    atlassian: {
        logo: {
            brand: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $i557m.AtlassianLogoBrand), {}),
            neutral: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $l0SPD.AtlassianLogoNeutral), {})
        }
    },
    bitbucket: {
        mark: {
            brand: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $7A42A.BitbucketMarkBrand), {})
        }
    },
    compass: {
        mark: {
            brand: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $f6Yvu.CompassMarkBrand), {})
        }
    },
    confluence: {
        logo: {
            brand: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $iFGle.ConfluenceLogoBrand), {})
        },
        mark: {
            brand: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $5FYSv.ConfluenceMarkBrand), {})
        }
    },
    halp: {
        logo: {
            brand: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $gOnrr.HalpLogoBrand), {})
        }
    },
    jira: {
        logo: {
            brand: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $iJ53B.JiraLogoBrand), {})
        },
        mark: {
            brand: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $7KmBg.JiraMarkBrand), {})
        }
    },
    jiraalign: {
        mark: {
            brand: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $avyHy.JiraAlignMarkBrand), {})
        }
    },
    jiraservicemanagement: {
        logo: {
            brand: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $lOhFL.JiraServiceManagementLogoBrand), {})
        },
        mark: {
            brand: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $kIrQm.JiraServiceManagementMarkBrand), {})
        }
    },
    jiraproductdiscovery: {
        logo: {
            brand: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $8YCBc.JiraProductDiscoveryLogoBrand), {})
        },
        mark: {
            brand: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $4pNZF.JiraProductDiscoveryMarkBrand), {})
        }
    },
    jirasoftware: {
        logo: {
            brand: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $4P0be.JiraSoftwareLogoBrand), {})
        },
        mark: {
            brand: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $jThhL.JiraSoftwareMarkBrand), {})
        }
    },
    jiraworkmanagement: {
        mark: {
            brand: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $i6sD3.JiraWorkManagementMarkBrand), {})
        }
    },
    trello: {
        mark: {
            brand: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $1CSrR.TrelloMarkBrand), {})
        }
    }
};
var $d37cef68a5f2c362$export$e6ff31bff12b7ff4 = function(param) {
    var brand = param.brand, type = param.type, appearance = param.appearance;
    var _Logos_brand_type, _Logos_brand;
    return (_Logos_brand = $d37cef68a5f2c362$var$Logos[brand]) === null || _Logos_brand === void 0 ? void 0 : (_Logos_brand_type = _Logos_brand[type]) === null || _Logos_brand_type === void 0 ? void 0 : _Logos_brand_type[appearance];
};

});
parcelRegister("5o2Pg", function(module, exports) {

$parcel$export(module.exports, "AtlasMarkBrand", function () { return $731e15eb160bbf3b$export$41a3624cc2b0f936; });

var $1rY3h = parcelRequire("1rY3h");
var $731e15eb160bbf3b$export$41a3624cc2b0f936 = function() {
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M24 42.7982C14.016 42.7982 5.89795 34.6802 5.89795 24.6962C5.89795 14.7122 14.016 6.59424 24 6.59424V9.47624C15.604 9.47624 8.78095 16.2992 8.78095 24.6952C8.78095 33.0912 15.604 39.9142 24 39.9142V42.7962V42.7982Z",
                fill: "url(#paint0_linear_818_466)"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M23.9999 42.7983V39.9163C32.3959 39.9163 39.2189 33.0933 39.2189 24.6973H42.1009C42.1009 34.6813 33.9829 42.7993 23.9989 42.7993L23.9999 42.7983Z",
                fill: "url(#paint1_linear_818_466)"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M42.102 24.6962H39.22C39.22 16.3002 32.397 9.47722 24.001 9.47722V6.59521C33.985 6.59521 42.103 14.7132 42.103 24.6972L42.102 24.6962Z",
                fill: "url(#paint2_linear_818_466)"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M31.711 30.238C29.7889 29.862 28.2719 29.18 25.7509 28.038C25.055 27.732 24.289 27.384 23.412 26.994C22.883 26.757 22.396 26.548 21.908 26.34C18.107 24.655 16.018 23.736 13.4559 23.736C11.6599 23.736 10.3089 24.223 9.55695 25.142C9.04195 25.755 8.83295 26.548 8.98595 27.314L6.15895 27.857C5.85295 26.242 6.26995 24.585 7.32895 23.304C8.24795 22.19 10.0579 20.853 13.4559 20.853C16.6309 20.853 19.1929 21.995 23.0779 23.708C23.5509 23.917 24.039 24.14 24.568 24.362C25.459 24.752 26.239 25.1 26.9349 25.42C29.344 26.506 30.667 27.105 32.268 27.411L31.711 30.238Z",
                fill: "url(#paint3_linear_818_466)"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M34.5259 30.516C33.5649 30.516 32.6459 30.432 31.7129 30.238L32.2699 27.411C33.0219 27.564 33.7599 27.634 34.5259 27.634C36.3079 27.634 37.6589 27.188 38.4389 26.339C39.2189 25.49 39.2469 24.459 39.2049 23.916L42.0729 23.665C42.2259 25.419 41.6969 27.063 40.5689 28.288C39.6359 29.304 37.8399 30.516 34.5259 30.516Z",
                fill: "url(#paint4_linear_818_466)"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M23.9999 42.798V39.916C28.1359 39.916 30.5999 35.697 30.5999 28.637C30.5999 21.577 28.0939 15.659 22.9559 10.187L25.0589 8.20996C30.7259 14.239 33.4829 20.923 33.4829 28.637C33.4829 37.368 29.8489 42.798 23.9999 42.798Z",
                fill: "url(#paint5_linear_818_466)"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M23.998 42.7981C17.774 42.7981 14.209 37.7301 14.209 28.8881C14.209 18.5701 18.721 12.8051 22.94 8.22412L25.057 10.1731C20.142 15.5201 17.092 20.5051 17.092 28.8871C17.092 38.0071 20.852 39.9151 23.999 39.9151V42.7971L23.998 42.7981Z",
                fill: "url(#paint6_linear_818_466)"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M16.2849 26.2C18.1459 26.2 19.6549 24.691 19.6549 22.83C19.6549 20.969 18.1459 19.46 16.2849 19.46C14.4239 19.46 12.9149 20.969 12.9149 22.83C12.9149 24.691 14.4239 26.2 16.2849 26.2Z",
                fill: "#1D7AFC"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M31.8629 32.0071C33.7239 32.0071 35.2329 30.4981 35.2329 28.6371C35.2329 26.7761 33.7239 25.2671 31.8629 25.2671C30.0019 25.2671 28.4929 26.7761 28.4929 28.6371C28.4929 30.4981 30.0019 32.0071 31.8629 32.0071Z",
                fill: "#1D7AFC"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M23.997 11.9412C25.858 11.9412 27.367 10.4322 27.367 8.57117C27.367 6.71017 25.858 5.20117 23.997 5.20117C22.136 5.20117 20.627 6.71017 20.627 8.57117C20.627 10.4322 22.136 11.9412 23.997 11.9412Z",
                fill: "#1D7AFC"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $1rY3h.jsxs)("linearGradient", {
                        id: "paint0_linear_818_466",
                        x1: "15.989",
                        y1: "43.1032",
                        x2: "14.6109",
                        y2: "6.93924",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                offset: "0.5",
                                stopColor: "#1D7AFC"
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                offset: "1",
                                stopColor: "#0055CC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsxs)("linearGradient", {
                        id: "paint1_linear_818_466",
                        x1: "42.4099",
                        y1: "26.2853",
                        x2: "26.3829",
                        y2: "42.8553",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                stopColor: "#0055CC"
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                offset: "1",
                                stopColor: "#0055CC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsxs)("linearGradient", {
                        id: "paint2_linear_818_466",
                        x1: "33.051",
                        y1: "6.59421",
                        x2: "33.051",
                        y2: "24.6962",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                stopColor: "#1D7AFC"
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                offset: "0.59",
                                stopColor: "#1D7AFC"
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                offset: "1",
                                stopColor: "#0055CC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsxs)("linearGradient", {
                        id: "paint3_linear_818_466",
                        x1: "6.06095",
                        y1: "25.546",
                        x2: "32.268",
                        y2: "25.546",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                offset: "0.26",
                                stopColor: "#1D7AFC"
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                offset: "1",
                                stopColor: "#0055CC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsxs)("linearGradient", {
                        id: "paint4_linear_818_466",
                        x1: "34.6069",
                        y1: "29.777",
                        x2: "40.3299",
                        y2: "23.692",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                stopColor: "#0055CC"
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                offset: "1",
                                stopColor: "#0055CC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsxs)("linearGradient", {
                        id: "paint5_linear_818_466",
                        x1: "28.2189",
                        y1: "42.798",
                        x2: "28.2189",
                        y2: "8.20996",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                offset: "0.36",
                                stopColor: "#1D7AFC"
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                offset: "1",
                                stopColor: "#0055CC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsxs)("linearGradient", {
                        id: "paint6_linear_818_466",
                        x1: "19.633",
                        y1: "42.7981",
                        x2: "19.633",
                        y2: "8.22312",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                offset: "0.06",
                                stopColor: "#1D7AFC"
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                offset: "0.58",
                                stopColor: "#0055CC"
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1D7AFC"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("i557m", function(module, exports) {

$parcel$export(module.exports, "AtlassianLogoBrand", function () { return $a8a4b389e33fb98d$export$be4b880845d08afc; });

var $1rY3h = parcelRequire("1rY3h");
var $a8a4b389e33fb98d$export$be4b880845d08afc = function() {
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("svg", {
        width: "282",
        height: "48",
        viewBox: "0 0 282 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsx)("title", {
                children: "Atlassian logo"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsxs)("g", {
                clipPath: "url(#clip0_994_4077)",
                children: [
                    /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                        d: "M10.3 19.9003C9.80005 19.3003 9.00005 19.4003 8.60005 20.1003L0.100048 37.1003C-0.199952 37.8003 0.300048 38.6003 1.00005 38.6003H12.8C13.2 38.6003 13.5 38.4003 13.7 38.0003C16.3 32.7003 14.7 24.7003 10.3 19.9003Z",
                        fill: "url(#paint0_linear_994_4077)"
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                        d: "M16.5001 4.5001C11.8001 12.0001 12.1001 20.3001 15.2001 26.6001C18.3001 32.9001 20.7001 37.6001 20.9001 38.0001C21.1001 38.4001 21.4001 38.6001 21.8001 38.6001H33.6001C34.4001 38.6001 34.8001 37.8001 34.5001 37.1001C34.5001 37.1001 18.6001 5.3001 18.2001 4.5001C17.9001 3.8001 16.9001 3.8001 16.5001 4.5001Z",
                        fill: "#0082FF"
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                        d: "M155 18.1004C155 22.3004 156.9 25.6004 164.6 27.1004C169.1 28.1004 170.1 28.8004 170.1 30.3004C170.1 31.8004 169.1 32.7004 165.9 32.7004C162.2 32.7004 157.8 31.4004 154.9 29.7004V36.5004C157.2 37.6004 160.2 38.9004 165.9 38.9004C173.9 38.9004 177 35.3004 177 30.1004M177 30.2004C177 25.2004 174.4 22.9004 166.9 21.3004C162.8 20.4004 161.8 19.5004 161.8 18.2004C161.8 16.6004 163.3 15.9004 166 15.9004C169.3 15.9004 172.5 16.9004 175.6 18.3004V11.8004C173.4 10.7004 170.1 9.90039 166.2 9.90039C158.8 9.90039 155 13.1004 155 18.3004",
                        fill: "#0050D3"
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                        d: "M257.4 10.1001V38.6001H263.5V16.9001L266 22.6001L274.6 38.6001H282.2V10.1001H276.2V28.5001L273.9 23.1001L267 10.1001H257.4Z",
                        fill: "#0050D3"
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                        d: "M218.8 10.1001H212.2V38.6001H218.8V10.1001Z",
                        fill: "#0050D3"
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                        d: "M204.6 30.1003C204.6 25.1003 202 22.8003 194.5 21.2003C190.4 20.3003 189.4 19.4003 189.4 18.1003C189.4 16.5003 190.9 15.8003 193.6 15.8003C196.9 15.8003 200.1 16.8003 203.2 18.2003V11.7003C201 10.6003 197.7 9.80029 193.8 9.80029C186.4 9.80029 182.6 13.0003 182.6 18.2003C182.6 22.4003 184.5 25.7003 192.2 27.2003C196.7 28.2003 197.7 28.9003 197.7 30.4003C197.7 31.9003 196.7 32.8003 193.5 32.8003C189.8 32.8003 185.4 31.5003 182.5 29.8003V36.6003C184.8 37.7003 187.8 39.0003 193.5 39.0003C201.4 39.0003 204.6 35.4003 204.6 30.1003Z",
                        fill: "#0050D3"
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                        d: "M103.6 10.1001V38.6001H117.2L119.3 32.4001H110.2V10.1001H103.6Z",
                        fill: "#0050D3"
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                        d: "M76.7001 10.1001V16.2001H84.0001V38.6001H90.7001V16.2001H98.6001V10.1001H76.7001Z",
                        fill: "#0050D3"
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                        d: "M67 10.1001H58.3L48.4 38.6001H56L57.4 33.8001C59.1 34.3001 60.9 34.6001 62.7 34.6001C64.5 34.6001 66.3 34.3001 68 33.8001L69.4 38.6001H77C76.9 38.6001 67 10.1001 67 10.1001ZM62.6 28.6001C61.3 28.6001 60.1 28.4001 59 28.1001L62.6 15.7001L66.2 28.1001C65.1 28.4001 63.9 28.6001 62.6 28.6001Z",
                        fill: "#0050D3"
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                        d: "M140.7 10.1001H132L122 38.6001H129.6L131 33.8001C132.7 34.3001 134.5 34.6001 136.3 34.6001C138.1 34.6001 139.9 34.3001 141.6 33.8001L143 38.6001H150.6L140.7 10.1001ZM136.3 28.6001C135 28.6001 133.8 28.4001 132.7 28.1001L136.3 15.7001L139.9 28.1001C138.8 28.4001 137.6 28.6001 136.3 28.6001Z",
                        fill: "#0050D3"
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                        d: "M242.7 10.1001H234L224.1 38.6001H231.7L233.1 33.8001C234.8 34.3001 236.6 34.6001 238.4 34.6001C240.2 34.6001 242 34.3001 243.7 33.8001L245.1 38.6001H252.7L242.7 10.1001ZM238.4 28.6001C237.1 28.6001 235.9 28.4001 234.8 28.1001L238.4 15.7001L242 28.1001C240.9 28.4001 239.6 28.6001 238.4 28.6001Z",
                        fill: "#0050D3"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1rY3h.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $1rY3h.jsxs)("linearGradient", {
                        id: "paint0_linear_994_4077",
                        x1: "14.9161",
                        y1: "22.5557",
                        x2: "5.96115",
                        y2: "38.0657",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                stopColor: "#0050D3"
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                offset: "0.923",
                                stopColor: "#0082FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("clipPath", {
                        id: "clip0_994_4077",
                        children: /*#__PURE__*/ (0, $1rY3h.jsx)("rect", {
                            width: "282",
                            height: "48",
                            fill: "white"
                        })
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("l0SPD", function(module, exports) {

$parcel$export(module.exports, "AtlassianLogoNeutral", function () { return $ad132b5f760f8e51$export$2146dec71e451533; });

var $1rY3h = parcelRequire("1rY3h");
var $ad132b5f760f8e51$export$2146dec71e451533 = function() {
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("svg", {
        width: "282",
        height: "48",
        viewBox: "0 0 282 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsx)("title", {
                children: "Atlassian logo"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsxs)("g", {
                clipPath: "url(#clip0_994_3735)",
                children: [
                    /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                        d: "M10.3 19.9003C9.79999 19.3003 8.99999 19.4003 8.59999 20.1003L0.0999871 37.1003C-0.200013 37.8003 0.299987 38.6003 0.999987 38.6003H12.8C13.2 38.6003 13.5 38.4003 13.7 38.0003C16.3 32.7003 14.7 24.7003 10.3 19.9003Z",
                        fill: "url(#paint0_linear_994_3735)"
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                        d: "M16.5 4.5001C11.8 12.0001 12.1 20.3001 15.2 26.6001C18.3 32.9001 20.7 37.6001 20.9 38.0001C21.1 38.4001 21.4 38.6001 21.8 38.6001H33.6C34.4 38.6001 34.8 37.8001 34.5 37.1001C34.5 37.1001 18.6 5.3001 18.2 4.5001C17.9 3.8001 16.9 3.8001 16.5 4.5001Z",
                        fill: "#77859B"
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                        d: "M155 18.1004C155 22.3004 156.9 25.6004 164.6 27.1004C169.1 28.1004 170.1 28.8004 170.1 30.3004C170.1 31.8004 169.1 32.7004 165.9 32.7004C162.2 32.7004 157.8 31.4004 154.9 29.7004V36.5004C157.2 37.6004 160.2 38.9004 165.9 38.9004C173.9 38.9004 177 35.3004 177 30.1004M177 30.2004C177 25.2004 174.4 22.9004 166.9 21.3004C162.8 20.4004 161.8 19.5004 161.8 18.2004C161.8 16.6004 163.3 15.9004 166 15.9004C169.3 15.9004 172.5 16.9004 175.6 18.3004V11.8004C173.4 10.7004 170.1 9.90039 166.2 9.90039C158.8 9.90039 155 13.1004 155 18.3004",
                        fill: "#44546F"
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                        d: "M257.4 10.1001V38.6001H263.5V16.9001L266 22.6001L274.6 38.6001H282.2V10.1001H276.2V28.5001L273.9 23.1001L267 10.1001H257.4Z",
                        fill: "#44546F"
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                        d: "M218.8 10.1001H212.2V38.6001H218.8V10.1001Z",
                        fill: "#44546F"
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                        d: "M204.6 30.1003C204.6 25.1003 202 22.8003 194.5 21.2003C190.4 20.3003 189.4 19.4003 189.4 18.1003C189.4 16.5003 190.9 15.8003 193.6 15.8003C196.9 15.8003 200.1 16.8003 203.2 18.2003V11.7003C201 10.6003 197.7 9.80029 193.8 9.80029C186.4 9.80029 182.6 13.0003 182.6 18.2003C182.6 22.4003 184.5 25.7003 192.2 27.2003C196.7 28.2003 197.7 28.9003 197.7 30.4003C197.7 31.9003 196.7 32.8003 193.5 32.8003C189.8 32.8003 185.4 31.5003 182.5 29.8003V36.6003C184.8 37.7003 187.8 39.0003 193.5 39.0003C201.4 39.0003 204.6 35.4003 204.6 30.1003Z",
                        fill: "#44546F"
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                        d: "M103.6 10.1001V38.6001H117.2L119.3 32.4001H110.2V10.1001H103.6Z",
                        fill: "#44546F"
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                        d: "M76.7 10.1001V16.2001H84V38.6001H90.7V16.2001H98.6V10.1001H76.7Z",
                        fill: "#44546F"
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                        d: "M67 10.1001H58.3L48.4 38.6001H56L57.4 33.8001C59.1 34.3001 60.9 34.6001 62.7 34.6001C64.5 34.6001 66.3 34.3001 68 33.8001L69.4 38.6001H77C76.9 38.6001 67 10.1001 67 10.1001ZM62.6 28.6001C61.3 28.6001 60.1 28.4001 59 28.1001L62.6 15.7001L66.2 28.1001C65.1 28.4001 63.9 28.6001 62.6 28.6001Z",
                        fill: "#44546F"
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                        d: "M140.7 10.1001H132L122 38.6001H129.6L131 33.8001C132.7 34.3001 134.5 34.6001 136.3 34.6001C138.1 34.6001 139.9 34.3001 141.6 33.8001L143 38.6001H150.6L140.7 10.1001ZM136.3 28.6001C135 28.6001 133.8 28.4001 132.7 28.1001L136.3 15.7001L139.9 28.1001C138.8 28.4001 137.6 28.6001 136.3 28.6001Z",
                        fill: "#44546F"
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                        d: "M242.7 10.1001H234L224.1 38.6001H231.7L233.1 33.8001C234.8 34.3001 236.6 34.6001 238.4 34.6001C240.2 34.6001 242 34.3001 243.7 33.8001L245.1 38.6001H252.7L242.7 10.1001ZM238.4 28.6001C237.1 28.6001 235.9 28.4001 234.8 28.1001L238.4 15.7001L242 28.1001C240.9 28.4001 239.6 28.6001 238.4 28.6001Z",
                        fill: "#44546F"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1rY3h.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $1rY3h.jsxs)("linearGradient", {
                        id: "paint0_linear_994_3735",
                        x1: "14.9161",
                        y1: "22.5567",
                        x2: "5.96109",
                        y2: "38.0667",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                stopColor: "#304566"
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                offset: "0.923",
                                stopColor: "#77859B"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("clipPath", {
                        id: "clip0_994_3735",
                        children: /*#__PURE__*/ (0, $1rY3h.jsx)("rect", {
                            width: "282",
                            height: "48",
                            fill: "white"
                        })
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("7A42A", function(module, exports) {

$parcel$export(module.exports, "BitbucketMarkBrand", function () { return $9c5fb454a391c304$export$51dbe3f91062dd43; });

var $1rY3h = parcelRequire("1rY3h");
var $9c5fb454a391c304$export$51dbe3f91062dd43 = function() {
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M8.73796 10.3291C8.09296 10.3291 7.60196 10.9071 7.70596 11.5441L12.13 38.4841C12.242 39.1661 12.831 39.6661 13.521 39.6721L34.812 39.6681C35.325 39.6681 35.763 39.2961 35.845 38.7901L40.294 11.5491C40.398 10.9131 39.907 10.3351 39.262 10.3351L8.73696 10.3281L8.73796 10.3291ZM27.427 29.8001H20.606L18.79 20.1901H29.072L27.427 29.8001Z",
                fill: "#1D7AFC"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M38.883 20.1899H29.072L27.427 29.7999H20.606L12.605 39.3269C12.605 39.3269 12.964 39.6709 13.521 39.6709L34.813 39.6669C35.325 39.6669 35.762 39.2949 35.844 38.7899L38.882 20.1899H38.883Z",
                fill: "url(#paint0_linear_818_495)"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("defs", {
                children: /*#__PURE__*/ (0, $1rY3h.jsxs)("linearGradient", {
                    id: "paint0_linear_818_495",
                    x1: "41.152",
                    y1: "22.8799",
                    x2: "24.937",
                    y2: "35.5379",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                            offset: "0.176",
                            stopColor: "#0055CC"
                        }),
                        /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                            offset: "1",
                            stopColor: "#1D7AFC"
                        })
                    ]
                })
            })
        ]
    });
};

});

parcelRegister("f6Yvu", function(module, exports) {

$parcel$export(module.exports, "CompassMarkBrand", function () { return $3c959e37cf505e56$export$95ba070e064f69d4; });

var $1rY3h = parcelRequire("1rY3h");
var $3c959e37cf505e56$export$95ba070e064f69d4 = function() {
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M23.5 23.179V32.092H14.57V23.179H23.5V14.272H7.20997C6.33997 14.278 5.63997 14.976 5.64597 15.832C5.64597 15.839 5.64597 15.846 5.64597 15.853V39.465C5.62797 40.321 6.31897 41.028 7.18797 41.046C7.19497 41.046 7.20297 41.046 7.20997 41.046H30.844C31.714 41.04 32.414 40.342 32.408 39.486C32.408 39.479 32.408 39.472 32.408 39.465V23.179H23.5Z",
                fill: "url(#paint0_linear_2304_2419)"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M23.5 5.35987V14.2719H32.451V23.1789H41.354V6.91987C41.372 6.06387 40.681 5.35687 39.812 5.33887C39.805 5.33887 39.797 5.33887 39.79 5.33887L23.5 5.35987Z",
                fill: "#1D7AFC"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("defs", {
                children: /*#__PURE__*/ (0, $1rY3h.jsxs)("linearGradient", {
                    id: "paint0_linear_2304_2419",
                    x1: "30.859",
                    y1: "15.827",
                    x2: "15.688",
                    y2: "30.998",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                            offset: "0.2",
                            stopColor: "#0055CC"
                        }),
                        /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                            offset: "1",
                            stopColor: "#1D7AFC"
                        })
                    ]
                })
            })
        ]
    });
};

});

parcelRegister("iFGle", function(module, exports) {

$parcel$export(module.exports, "ConfluenceLogoBrand", function () { return $4284936811367679$export$688c79db1f7ed58e; });

var $1rY3h = parcelRequire("1rY3h");
var $4284936811367679$export$688c79db1f7ed58e = function() {
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("svg", {
        width: "267",
        height: "48",
        viewBox: "0 0 267 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M70.2961 37.4057C68.4101 38.6477 65.4201 39.1997 62.2911 39.1997C52.3541 39.1997 46.7411 33.2197 46.7411 23.6957C46.7411 14.4957 52.3541 8.05371 62.1991 8.05371C65.1431 8.05371 68.0881 8.60671 70.2501 10.1697V14.1727C68.0881 12.7927 65.6951 12.0567 62.1991 12.0567C55.1141 12.0567 50.8821 16.7487 50.8821 23.6957C50.8821 30.6427 55.2531 35.2437 62.4301 35.2437C65.6041 35.2437 68.0881 34.5077 70.2961 33.4037V37.4057Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M73.1921 27.1929C73.1921 20.2919 77.2401 15.2769 84.1411 15.2769C90.9951 15.2769 94.9981 20.2919 94.9981 27.1929C94.9981 34.0939 90.9951 39.1999 84.1411 39.1999C77.2401 39.1999 73.1921 34.0939 73.1921 27.1929ZM77.0561 27.1929C77.0561 31.5629 79.2181 35.5199 84.1411 35.5199C89.0171 35.5199 91.1331 31.5629 91.1331 27.1929C91.1331 22.8229 89.0171 18.9579 84.1411 18.9579C79.2181 18.9579 77.0561 22.8219 77.0561 27.1929Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M119.148 38.7399H115.191V24.8459C115.191 20.7049 113.535 18.8659 109.762 18.8659C106.082 18.8659 103.552 21.3039 103.552 25.9509V38.7399H99.5951V15.7379H103.552V19.5099C105.024 16.7949 107.738 15.2769 110.821 15.2769C116.111 15.2769 119.148 18.9119 119.148 25.2599V38.7389V38.7399Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M130.139 15.7378H136.073V19.4178H130.139V38.7398H126.275V19.4178H122.548V15.7378H126.275V13.2078C126.275 8.92879 128.668 6.02979 133.589 6.02979C134.785 6.02979 135.568 6.21478 136.258 6.39778V10.0328C135.568 9.89478 134.694 9.80279 133.774 9.80279C131.336 9.80279 130.14 11.2298 130.14 13.2998V15.7378H130.139Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M146.515 38.8786C142.743 38.8786 140.35 37.0836 140.35 32.8516V6.12256H144.307V32.3916C144.307 34.4616 145.687 35.1986 147.389 35.1986C147.803 35.1986 148.078 35.1986 148.539 35.1526V38.6946C148.217 38.7866 147.526 38.8796 146.515 38.8796V38.8786Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M151.896 15.7378H155.852V29.6318C155.852 33.7718 157.508 35.6118 161.281 35.6118C164.962 35.6118 167.492 33.1738 167.492 28.5268V15.7378H171.449V38.7398H167.492V34.9678C166.02 37.6828 163.305 39.1998 160.223 39.1998C154.932 39.1998 151.896 35.5658 151.896 29.2178V15.7378Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M188.42 39.1999C179.817 39.1999 176.045 34.2319 176.045 27.1929C176.045 20.2459 179.909 15.2769 186.902 15.2769C193.986 15.2769 196.839 20.1999 196.839 27.1929V28.9869H180.047C180.6 32.8969 183.13 35.4269 188.559 35.4269C191.227 35.4269 193.481 34.9209 195.551 34.1849V37.8199C193.665 38.8319 190.767 39.1999 188.42 39.1999ZM180.001 25.5829H192.837C192.607 21.3049 190.675 18.8659 186.718 18.8659C182.531 18.8659 180.415 21.5799 180.001 25.5829Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M221.081 38.7399H217.124V24.8459C217.124 20.7049 215.468 18.8659 211.695 18.8659C208.015 18.8659 205.485 21.3039 205.485 25.9509V38.7399H201.528V15.7379H205.485V19.5099C206.957 16.7949 209.671 15.2769 212.754 15.2769C218.044 15.2769 221.081 18.9119 221.081 25.2599V38.7389V38.7399Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M242.839 38.1419C241.458 38.8779 239.342 39.1999 237.226 39.1999C229.038 39.1999 225.219 34.2319 225.219 27.1929C225.219 20.2459 229.037 15.2769 237.226 15.2769C239.296 15.2769 240.907 15.5529 242.701 16.3809V20.0619C241.229 19.3719 239.665 18.9579 237.503 18.9579C231.523 18.9579 229.084 22.7299 229.084 27.1929C229.084 31.6559 231.568 35.4269 237.595 35.4269C239.942 35.4269 241.413 35.1059 242.84 34.5989V38.1419H242.839Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M258.339 39.1999C249.736 39.1999 245.964 34.2319 245.964 27.1929C245.964 20.2459 249.828 15.2769 256.821 15.2769C263.905 15.2769 266.758 20.1999 266.758 27.1929V28.9869H249.966C250.519 32.8969 253.049 35.4269 258.478 35.4269C261.146 35.4269 263.4 34.9209 265.47 34.1849V37.8199C263.584 38.8319 260.686 39.1999 258.339 39.1999ZM249.92 25.5829H262.756C262.526 21.3049 260.594 18.8659 256.637 18.8659C252.45 18.8659 250.334 21.5799 249.92 25.5829Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M1.16806 31.3314C0.829057 31.8834 0.444057 32.5304 0.145057 33.0394C-0.142943 33.5304 0.0120573 34.1614 0.497057 34.4604L7.29106 38.6534C7.78906 38.9604 8.44106 38.8024 8.73806 38.2984C9.00806 37.8414 9.35806 37.2534 9.74006 36.6214C12.4331 32.1774 15.1411 32.7194 20.0201 35.0384L26.7581 38.2414C27.2891 38.4944 27.9241 38.2584 28.1631 37.7204L31.3991 30.4144C31.6291 29.8944 31.4031 29.2874 30.8891 29.0454C29.4661 28.3764 26.6381 27.0414 24.1061 25.8154C14.9051 21.3604 7.12006 21.6554 1.16806 31.3314Z",
                fill: "url(#paint0_linear_818_483)"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M31.6351 14.7276C31.9741 14.1756 32.3591 13.5286 32.6581 13.0196C32.9461 12.5286 32.7911 11.8976 32.3061 11.5986L25.5121 7.40562C25.0141 7.09862 24.3621 7.25662 24.0651 7.76062C23.7951 8.21762 23.4451 8.80561 23.0631 9.43761C20.3701 13.8816 17.6621 13.3396 12.7831 11.0206L6.04512 7.81762C5.51412 7.56462 4.87912 7.80061 4.64012 8.33861L1.40412 15.6446C1.17412 16.1646 1.40012 16.7716 1.91412 17.0136C3.33712 17.6826 6.16512 19.0176 8.69712 20.2436C17.8971 24.6986 25.6821 24.4046 31.6341 14.7276H31.6351Z",
                fill: "url(#paint1_linear_818_483)"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $1rY3h.jsxs)("linearGradient", {
                        id: "paint0_linear_818_483",
                        x1: "31.1981",
                        y1: "40.8054",
                        x2: "10.6381",
                        y2: "28.9914",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                stopColor: "#0055CC"
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1D7AFC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsxs)("linearGradient", {
                        id: "paint1_linear_818_483",
                        x1: "1.60412",
                        y1: "5.25362",
                        x2: "22.1641",
                        y2: "17.0676",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                stopColor: "#0055CC"
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1D7AFC"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("5FYSv", function(module, exports) {

$parcel$export(module.exports, "ConfluenceMarkBrand", function () { return $e94bb095028b446e$export$c3c079c94b97bdde; });

var $1rY3h = parcelRequire("1rY3h");
var $e94bb095028b446e$export$c3c079c94b97bdde = function() {
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M8.76706 32.3019C8.42806 32.8539 8.04306 33.5009 7.74406 34.0099C7.45606 34.5009 7.61106 35.1319 8.09606 35.4309L14.8901 39.6239C15.3881 39.9309 16.0401 39.7729 16.3371 39.2689C16.6071 38.8119 16.9571 38.2239 17.3391 37.5919C20.0321 33.1479 22.7401 33.6899 27.6191 36.0089L34.3571 39.2119C34.8881 39.4649 35.5231 39.2289 35.7621 38.6909L38.9981 31.3849C39.2281 30.8649 39.0021 30.2579 38.4881 30.0159C37.0651 29.3469 34.2371 28.0119 31.7051 26.7859C22.5051 22.3309 14.7201 22.6249 8.76806 32.3019H8.76706Z",
                fill: "url(#paint0_linear_818_553)"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M39.233 15.6978C39.572 15.1458 39.957 14.4988 40.256 13.9898C40.544 13.4988 40.389 12.8678 39.904 12.5688L33.11 8.37583C32.612 8.06883 31.96 8.22683 31.663 8.73083C31.393 9.18783 31.043 9.77583 30.661 10.4078C27.968 14.8518 25.26 14.3098 20.381 11.9908L13.643 8.78783C13.112 8.53483 12.477 8.77083 12.238 9.30883L9.00202 16.6148C8.77202 17.1348 8.99802 17.7418 9.51202 17.9838C10.935 18.6528 13.763 19.9878 16.295 21.2138C25.495 25.6688 33.28 25.3748 39.232 15.6978H39.233Z",
                fill: "url(#paint1_linear_818_553)"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $1rY3h.jsxs)("linearGradient", {
                        id: "paint0_linear_818_553",
                        x1: "38.7961",
                        y1: "41.7759",
                        x2: "18.2371",
                        y2: "29.9619",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                stopColor: "#0055CC"
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                offset: "0.972",
                                stopColor: "#1C78FA"
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1D7AFC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsxs)("linearGradient", {
                        id: "paint1_linear_818_553",
                        x1: "9.20302",
                        y1: "6.22383",
                        x2: "29.763",
                        y2: "18.0378",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                stopColor: "#0055CC"
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                offset: "0.972",
                                stopColor: "#1C78FA"
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1D7AFC"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("gOnrr", function(module, exports) {

$parcel$export(module.exports, "HalpLogoBrand", function () { return $37f716ca6b1ebe99$export$528edb2ffd8d250d; });

var $1rY3h = parcelRequire("1rY3h");
var $37f716ca6b1ebe99$export$528edb2ffd8d250d = function() {
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("svg", {
        width: "95",
        height: "32",
        viewBox: "0 0 95 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M50.8924 1.68506V22.1372H48.0904V13.2927H37.3177V22.1372H34.5157V1.68506H37.3177V10.6181H48.0904V1.68506H50.8924Z",
                fill: "#253858"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M65.928 19.3352C64.9339 21.3907 63.0659 22.4485 60.6673 22.4485C56.528 22.4485 54.4407 18.9319 54.4407 14.3539C54.4407 9.96704 56.62 6.2594 60.9786 6.2594C63.2534 6.2594 64.994 7.28891 65.9315 9.31254V6.57073H68.6097V22.1372H65.9315L65.928 19.3352ZM61.3854 19.9579C63.7805 19.9579 65.928 18.4331 65.928 14.9766V13.7313C65.928 10.2784 63.968 8.75003 61.6826 8.75003C58.6613 8.75003 57.1047 10.7454 57.1047 14.3539C57.1047 18.0899 58.6118 19.9579 61.3854 19.9579Z",
                fill: "#253858"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M76.8245 22.2327C74.2738 22.2327 72.6534 21.0157 72.6534 18.1536V0.0646973H75.3316V17.8423C75.3316 19.2574 76.2656 19.7421 77.4189 19.7421C77.6787 19.7467 77.9386 19.736 78.1972 19.7103V22.1054C77.7467 22.2042 77.2856 22.247 76.8245 22.2327Z",
                fill: "#253858"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M83.458 19.3989V28.2081H80.7799V6.57073H83.458V9.37269C84.4522 7.32075 86.3201 6.2594 88.7188 6.2594C92.858 6.2594 94.9454 9.79723 94.9454 14.3539C94.9454 18.7444 92.7661 22.4485 88.4075 22.4485C86.1326 22.4485 84.392 21.4225 83.458 19.3989ZM88.0006 8.75003C85.6055 8.75003 83.458 10.2784 83.458 13.7313V14.9766C83.458 18.4331 85.418 19.9579 87.7034 19.9579C90.7247 19.9579 92.2814 17.9661 92.2814 14.3539C92.2672 10.618 90.7743 8.75003 88.0006 8.75003Z",
                fill: "#253858"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.2901 3.87848C21.8726 5.46206 22.9501 7.47929 23.3863 9.67515C23.8225 11.871 23.5979 14.1469 22.7408 16.2151C21.8837 18.2833 20.4327 20.051 18.5711 21.2946C16.7095 22.5382 14.521 23.202 12.2822 23.202C10.0435 23.202 7.85496 22.5382 5.99339 21.2946C4.13181 20.051 2.68076 18.2833 1.82368 16.2151C0.96659 14.1469 0.741953 11.871 1.17816 9.67515C1.61437 7.47929 2.69184 5.46206 4.27436 3.87848C5.32572 2.82642 6.57408 1.99184 7.9481 1.42243C9.32213 0.853016 10.7949 0.559937 12.2822 0.559937C13.7696 0.559937 15.2423 0.853016 16.6164 1.42243C17.9904 1.99184 19.2388 2.82642 20.2901 3.87848ZM6.19186 17.9909L6.16002 17.959L6.18125 17.9803L6.19186 17.9909ZM15.3124 7.10144L17.4351 4.97874C15.9436 3.86422 14.1317 3.262 12.2699 3.262C10.408 3.262 8.59606 3.86422 7.10462 4.97874L9.22732 7.10144L7.48671 8.84205L5.36401 6.71935C4.24949 8.21079 3.64727 10.0227 3.64727 11.8846C3.64727 13.7464 4.24949 15.5584 5.36401 17.0498L7.48671 14.9271L9.22732 16.6748L7.10462 18.7975C8.59606 19.912 10.408 20.5142 12.2699 20.5142C14.1317 20.5142 15.9436 19.912 17.4351 18.7975L15.3124 16.6748L17.053 14.9271L19.1757 17.0498C20.2902 15.5584 20.8924 13.7464 20.8924 11.8846C20.8924 10.0227 20.2902 8.21079 19.1757 6.71935L17.053 8.84205L15.3124 7.10144Z",
                fill: "url(#paint0_radial_1486_1400)"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.2805 6.21692C11.161 6.21692 10.0666 6.5489 9.1357 7.17089C8.20483 7.79288 7.47931 8.67693 7.05088 9.71125C6.62245 10.7456 6.51035 11.8837 6.72876 12.9818C6.94718 14.0798 7.48629 15.0884 8.27793 15.88C9.06957 16.6717 10.0782 17.2108 11.1762 17.4292C12.2742 17.6476 13.4124 17.5355 14.4467 17.1071C15.481 16.6787 16.3651 15.9531 16.9871 15.0223C17.6091 14.0914 17.941 12.997 17.941 11.8774C17.941 10.3762 17.3447 8.9364 16.2831 7.87485C15.2216 6.81329 13.7818 6.21692 12.2805 6.21692ZM12.2805 15.0615C11.6508 15.0615 11.0352 14.8747 10.5116 14.5249C9.98795 14.175 9.57984 13.6777 9.33885 13.0959C9.09786 12.5141 9.0348 11.8739 9.15766 11.2563C9.28051 10.6386 9.58377 10.0713 10.0291 9.62598C10.4744 9.18069 11.0417 8.87744 11.6593 8.75458C12.277 8.63172 12.9172 8.69477 13.499 8.93577C14.0808 9.17676 14.5781 9.58487 14.928 10.1085C15.2778 10.6321 15.4646 11.2477 15.4646 11.8774C15.465 12.2959 15.383 12.7103 15.2232 13.097C15.0634 13.4837 14.8289 13.8351 14.5332 14.1312C14.2375 14.4272 13.8864 14.6621 13.4998 14.8223C13.1133 14.9825 12.699 15.065 12.2805 15.065V15.0615Z",
                fill: "#2684FF"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("defs", {
                children: /*#__PURE__*/ (0, $1rY3h.jsxs)("radialGradient", {
                    id: "paint0_radial_1486_1400",
                    cx: "0",
                    cy: "0",
                    r: "1",
                    gradientUnits: "userSpaceOnUse",
                    gradientTransform: "translate(12.2805 11.8775) scale(11.321 11.321)",
                    children: [
                        /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                            offset: "0.43",
                            stopColor: "#0052CC"
                        }),
                        /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                            offset: "0.84",
                            stopColor: "#1B75F0"
                        }),
                        /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                            offset: "1",
                            stopColor: "#2684FF"
                        })
                    ]
                })
            })
        ]
    });
};

});

parcelRegister("iJ53B", function(module, exports) {

$parcel$export(module.exports, "JiraLogoBrand", function () { return $0bddb762e1427694$export$34b140e48658af06; });

var $1rY3h = parcelRequire("1rY3h");
var $0bddb762e1427694$export$34b140e48658af06 = function() {
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("svg", {
        width: "111",
        height: "48",
        viewBox: "0 0 111 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M35.971 3.5H17.894C17.894 8.006 21.547 11.658 26.052 11.658H29.381V14.871C29.381 19.377 33.034 23.029 37.539 23.029V5.068C37.539 4.202 36.837 3.5 35.971 3.5Z",
                fill: "#1D7AFC"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M27.024 12.5049H8.94702C8.94702 17.0109 12.6 20.6629 17.105 20.6629H20.434V23.8759C20.434 28.3819 24.087 32.0339 28.592 32.0339V14.0729C28.592 13.2069 27.89 12.5049 27.024 12.5049Z",
                fill: "url(#paint0_linear_818_558)"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M18.077 21.5098H0C0 26.0158 3.653 29.6688 8.158 29.6688H11.487V32.8818C11.487 37.3878 15.14 41.0398 19.645 41.0398V23.0788C19.645 22.2128 18.943 21.5108 18.077 21.5108V21.5098Z",
                fill: "url(#paint1_linear_818_558)"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M56.641 8.38574H60.782V29.4097C60.782 34.9757 58.344 38.7947 52.639 38.7947C50.477 38.7947 48.821 38.4267 47.67 38.0127V34.0107C48.912 34.5167 50.431 34.7927 51.948 34.7927C55.445 34.7927 56.64 32.6767 56.64 29.6867V8.38574H56.641Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M68.324 6.7749C69.934 6.7749 71.084 7.7869 71.084 9.5359C71.084 11.2849 69.935 12.2959 68.324 12.2959C66.713 12.2959 65.563 11.2839 65.563 9.5359C65.563 7.7879 66.713 6.7749 68.324 6.7749ZM66.3 15.6079H70.257V38.6109H66.3V15.6079Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M80.1001 38.6108H76.2361V15.6078H80.1001V19.6568C81.4341 16.9418 83.7351 15.0108 88.2441 15.2858V19.1498C83.1831 18.6438 80.1001 20.1628 80.1001 25.0388V38.6108Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M106.781 34.4709C105.309 37.5069 102.549 39.0719 99.007 39.0719C92.888 39.0719 89.806 33.8729 89.806 27.1099C89.806 20.6239 93.026 15.1489 99.467 15.1489C102.825 15.1489 105.402 16.6679 106.781 19.6579V15.6089H110.738V38.6119H106.781V34.4709ZM100.064 35.3909C103.607 35.3909 106.781 33.1369 106.781 28.0309V26.1899C106.781 21.0839 103.883 18.8299 100.524 18.8299C96.062 18.8299 93.761 21.7739 93.761 27.1099C93.761 32.6309 95.969 35.3909 100.064 35.3909Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $1rY3h.jsxs)("linearGradient", {
                        id: "paint0_linear_818_558",
                        x1: "28.208",
                        y1: "12.5359",
                        x2: "20.519",
                        y2: "20.4659",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                offset: "0.176",
                                stopColor: "#0055CC"
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1D7AFC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsxs)("linearGradient", {
                        id: "paint1_linear_818_558",
                        x1: "19.772",
                        y1: "21.5938",
                        x2: "10.882",
                        y2: "30.2448",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                offset: "0.176",
                                stopColor: "#0055CC"
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1D7AFC"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("7KmBg", function(module, exports) {

$parcel$export(module.exports, "JiraMarkBrand", function () { return $0a8cc7b104a3a4b4$export$2c53bf5b8775580d; });

var $1rY3h = parcelRequire("1rY3h");
var $0a8cc7b104a3a4b4$export$2c53bf5b8775580d = function() {
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M40.202 7.22998H22.124C22.124 11.736 25.777 15.388 30.282 15.388H33.611V18.601C33.611 23.107 37.264 26.759 41.769 26.759V8.79798C41.769 7.93198 41.067 7.22998 40.201 7.22998H40.202Z",
                fill: "#1D7AFC"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M31.255 16.2358H13.177C13.177 20.7418 16.83 24.3938 21.335 24.3938H24.664V27.6068C24.664 32.1128 28.317 35.7648 32.822 35.7648V17.8038C32.822 16.9378 32.12 16.2358 31.254 16.2358H31.255Z",
                fill: "url(#paint0_linear_818_567)"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M22.308 25.2412H4.22998C4.22998 29.7472 7.88298 33.3992 12.388 33.3992H15.717V36.6122C15.717 41.1182 19.37 44.7702 23.875 44.7702V26.8092C23.875 25.9432 23.173 25.2412 22.307 25.2412H22.308Z",
                fill: "url(#paint1_linear_818_567)"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $1rY3h.jsxs)("linearGradient", {
                        id: "paint0_linear_818_567",
                        x1: "32.439",
                        y1: "16.2658",
                        x2: "24.749",
                        y2: "24.1958",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                offset: "0.176",
                                stopColor: "#0055CC"
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1D7AFC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsxs)("linearGradient", {
                        id: "paint1_linear_818_567",
                        x1: "24.003",
                        y1: "25.3252",
                        x2: "15.112",
                        y2: "33.9752",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                offset: "0.176",
                                stopColor: "#0055CC"
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1D7AFC"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("avyHy", function(module, exports) {

$parcel$export(module.exports, "JiraAlignMarkBrand", function () { return $6f48a939b8795412$export$3a24b449db907a8d; });

var $1rY3h = parcelRequire("1rY3h");
var $6f48a939b8795412$export$3a24b449db907a8d = function() {
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M9.71802 9.71777C9.71802 15.1008 14.101 19.4648 19.479 19.4648H28.52V28.5348H38.281V11.2608C38.281 10.4088 37.591 9.71777 36.74 9.71777H9.71802Z",
                fill: "url(#paint0_linear_818_552)"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M38.282 38.2818C38.282 32.8988 33.899 28.5348 28.521 28.5348H19.48V19.4648H9.71802V36.7388C9.71802 37.5908 10.408 38.2818 11.259 38.2818H38.282Z",
                fill: "url(#paint1_linear_818_552)"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $1rY3h.jsxs)("linearGradient", {
                        id: "paint0_linear_818_552",
                        x1: "21.692",
                        y1: "31.0018",
                        x2: "23.912",
                        y2: "19.5788",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                offset: "0.15",
                                stopColor: "#0055CC"
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                offset: "0.522",
                                stopColor: "#0B63DE"
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1D7AFC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsxs)("linearGradient", {
                        id: "paint1_linear_818_552",
                        x1: "26.308",
                        y1: "16.9978",
                        x2: "24.088",
                        y2: "28.4208",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                offset: "0.15",
                                stopColor: "#0055CC"
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                offset: "0.522",
                                stopColor: "#0B63DE"
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1D7AFC"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("8YCBc", function(module, exports) {

$parcel$export(module.exports, "JiraProductDiscoveryLogoBrand", function () { return $1e4e5eb2c675e007$export$dbd49e0788c3653b; });

var $1rY3h = parcelRequire("1rY3h");
var $1e4e5eb2c675e007$export$dbd49e0788c3653b = function() {
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("svg", {
        width: "475",
        height: "48",
        viewBox: "0 0 475 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M54.471 8.479H58.612V29.503C58.612 35.069 56.174 38.888 50.469 38.888C48.307 38.888 46.651 38.521 45.5 38.107V34.104C46.742 34.61 48.261 34.886 49.778 34.886C53.275 34.886 54.47 32.77 54.47 29.78V8.479H54.471Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M66.155 6.86816C67.765 6.86816 68.915 7.88116 68.915 9.62916C68.915 11.3772 67.766 12.3892 66.155 12.3892C64.544 12.3892 63.394 11.3772 63.394 9.62916C63.394 7.88116 64.544 6.86816 66.155 6.86816ZM64.131 15.7012H68.088V38.7042H64.131V15.7012Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M77.93 38.7038H74.066V15.7008H77.93V19.7498C79.264 17.0348 81.565 15.1038 86.074 15.3798V19.2438C81.013 18.7378 77.93 20.2558 77.93 25.1328V38.7038Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M104.612 34.5627C103.14 37.5987 100.38 39.1637 96.838 39.1637C90.719 39.1637 87.637 33.9657 87.637 27.2027C87.637 20.7157 90.857 15.2407 97.298 15.2407C100.656 15.2407 103.233 16.7597 104.612 19.7497V15.7007H108.569V38.7037H104.612V34.5627ZM97.895 35.4827C101.438 35.4827 104.612 33.2287 104.612 28.1227V26.2817C104.612 21.1757 101.714 18.9217 98.355 18.9217C93.893 18.9217 91.592 21.8657 91.592 27.2027C91.592 32.7237 93.8 35.4827 97.895 35.4827Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M133.867 28.812H127.841V38.704H123.7V8.479H133.867C141.412 8.479 145.093 12.343 145.093 18.554C145.093 25.133 141.412 28.813 133.867 28.813V28.812ZM140.814 18.645C140.814 14.965 138.744 12.435 133.407 12.435H127.841V24.856H133.407C138.744 25.041 140.814 22.51 140.814 18.645Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M152.587 38.7038H148.723V15.7008H152.587V19.7498C153.921 17.0348 156.222 15.1038 160.731 15.3798V19.2438C155.67 18.7378 152.587 20.2558 152.587 25.1328V38.7038Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M162.293 27.1567C162.293 20.2557 166.341 15.2407 173.242 15.2407C180.096 15.2407 184.099 20.2557 184.099 27.1567C184.099 34.0577 180.096 39.1637 173.242 39.1637C166.341 39.1637 162.293 34.0577 162.293 27.1567ZM166.157 27.1567C166.157 31.5267 168.319 35.4827 173.242 35.4827C178.118 35.4827 180.234 31.5267 180.234 27.1567C180.234 22.7867 178.118 18.9217 173.242 18.9217C168.319 18.9217 166.157 22.7857 166.157 27.1567Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M204.292 34.5629C202.82 37.5989 200.06 39.1639 196.518 39.1639C190.399 39.1639 187.317 33.9659 187.317 27.2029C187.317 20.7159 190.537 15.2409 196.978 15.2409C200.336 15.2409 202.913 16.7599 204.292 19.7499V6.08594H208.249V38.7039H204.292V34.5629ZM197.575 35.4829C201.118 35.4829 204.292 33.2289 204.292 28.1229V26.2819C204.292 21.1759 201.394 18.9219 198.035 18.9219C193.573 18.9219 191.272 21.8659 191.272 27.2029C191.272 32.7239 193.48 35.4829 197.575 35.4829Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M213.766 15.7012H217.722V29.5952C217.722 33.7362 219.378 35.5762 223.151 35.5762C226.832 35.5762 229.362 33.1382 229.362 28.4912V15.7012H233.318V38.7042H229.362V34.9322C227.89 37.6462 225.175 39.1642 222.093 39.1642C216.802 39.1642 213.766 35.5292 213.766 29.1812V15.7012Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M255.537 38.1057C254.156 38.8407 252.04 39.1637 249.924 39.1637C241.736 39.1637 237.917 34.1947 237.917 27.1567C237.917 20.2097 241.735 15.2407 249.924 15.2407C251.994 15.2407 253.605 15.5167 255.399 16.3447V20.0257C253.927 19.3357 252.363 18.9217 250.201 18.9217C244.221 18.9217 241.782 22.6937 241.782 27.1567C241.782 31.6197 244.266 35.3907 250.293 35.3907C252.64 35.3907 254.111 35.0687 255.538 34.5627V38.1057H255.537Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M269.151 34.9777C270.071 34.9777 270.945 34.7937 271.635 34.6557V38.4737C270.945 38.6587 270.162 38.8417 268.966 38.8417C264.044 38.8417 261.652 35.9437 261.652 31.6647V19.3817H257.925V15.7007H261.652V10.8247H265.516V15.7007H271.635V19.3817H265.516V31.5727C265.516 33.5967 266.712 34.9767 269.151 34.9767V34.9777Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M285.618 8.479H296.752C306.551 8.479 311.289 14.598 311.289 23.661C311.289 32.816 306.505 38.705 296.752 38.705H285.618V8.479ZM289.759 12.436V34.748H296.798C303.698 34.748 307.149 31.113 307.149 23.799C307.149 16.438 303.883 12.436 296.568 12.436H289.759Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M317.679 6.86816C319.289 6.86816 320.439 7.88116 320.439 9.62916C320.439 11.3772 319.29 12.3892 317.679 12.3892C316.068 12.3892 314.918 11.3772 314.918 9.62916C314.918 7.88116 316.068 6.86816 317.679 6.86816ZM315.655 15.7012H319.612V38.7042H315.655V15.7012Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M332.813 39.1637C329.363 39.1637 326.556 38.3817 324.808 37.4617V33.2747C326.787 34.4247 330.099 35.5287 332.997 35.5287C336.033 35.5287 337.598 34.2877 337.598 32.4927C337.598 30.7447 336.263 29.7327 331.893 28.6747C326.787 27.4327 324.624 25.4537 324.624 21.6827C324.624 17.6797 327.706 15.2417 332.951 15.2417C335.941 15.2417 338.655 15.9777 340.357 16.8977V20.9927C337.597 19.6127 335.342 18.8767 332.905 18.8767C330.007 18.8767 328.442 19.8887 328.442 21.6837C328.442 23.2927 329.546 24.3057 333.779 25.3177C338.885 26.5597 341.462 28.4467 341.462 32.4487C341.462 36.2667 338.978 39.1657 332.813 39.1657V39.1637Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M362.254 38.1057C360.873 38.8407 358.757 39.1637 356.641 39.1637C348.453 39.1637 344.634 34.1947 344.634 27.1567C344.634 20.2097 348.452 15.2407 356.641 15.2407C358.711 15.2407 360.322 15.5167 362.116 16.3447V20.0257C360.644 19.3357 359.08 18.9217 356.918 18.9217C350.938 18.9217 348.499 22.6937 348.499 27.1567C348.499 31.6197 350.983 35.3907 357.01 35.3907C359.357 35.3907 360.828 35.0687 362.255 34.5627V38.1057H362.254Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M365.379 27.1567C365.379 20.2557 369.427 15.2407 376.328 15.2407C383.182 15.2407 387.185 20.2557 387.185 27.1567C387.185 34.0577 383.182 39.1637 376.328 39.1637C369.427 39.1637 365.379 34.0577 365.379 27.1567ZM369.243 27.1567C369.243 31.5267 371.405 35.4827 376.328 35.4827C381.204 35.4827 383.32 31.5267 383.32 27.1567C383.32 22.7867 381.204 18.9217 376.328 18.9217C371.405 18.9217 369.243 22.7857 369.243 27.1567Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M397.211 38.7042L388.286 15.7012H392.427L399.88 35.3462L407.286 15.7012H411.427L402.502 38.7042H397.211Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M424.905 39.1637C416.302 39.1637 412.53 34.1947 412.53 27.1567C412.53 20.2097 416.394 15.2407 423.387 15.2407C430.471 15.2407 433.324 20.1637 433.324 27.1567V28.9507H416.532C417.085 32.8607 419.615 35.3907 425.044 35.3907C427.712 35.3907 429.966 34.8847 432.036 34.1487V37.7837C430.15 38.7957 427.252 39.1637 424.905 39.1637ZM416.486 25.5467H429.322C429.092 21.2687 427.16 18.8297 423.203 18.8297C419.016 18.8297 416.9 21.5437 416.486 25.5467Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M441.877 38.7038H438.013V15.7008H441.877V19.7498C443.211 17.0348 445.512 15.1038 450.021 15.3798V19.2438C444.96 18.7378 441.877 20.2558 441.877 25.1328V38.7038Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M459.173 37.2312L450.846 15.7012H455.078L462.439 35.3912L469.799 15.7012H474.031L465.336 37.9682C462.76 44.5472 461.288 47.9512 455.445 47.9512C453.466 47.9512 452.363 47.7672 451.213 47.3062V43.9022C452.547 44.3162 454.066 44.4552 455.215 44.4552C458.436 44.4552 459.861 42.2462 461.748 37.2312H459.172H459.173Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M20.998 22.8301C20.998 22.8301 21.027 23.4001 21.027 24.1871C21.027 27.1191 18.65 29.4961 15.718 29.4961C12.786 29.4961 10.409 27.1191 10.409 24.1871C10.409 21.2551 12.786 18.8781 15.718 18.8781C16.505 18.8781 16.988 18.9071 16.988 18.9071V8.53107C16.569 8.49707 16.146 8.47607 15.718 8.47607C7.037 8.47507 0 15.5121 0 24.1931C0 32.8741 7.037 39.9101 15.717 39.9101C24.397 39.9101 31.434 32.8731 31.434 24.1931C31.434 23.6931 31.425 23.3461 31.384 22.8311H20.997L20.998 22.8301Z",
                fill: "url(#paint0_linear_818_529)"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M19.385 6.92496C23.747 8.10396 28.109 8.10396 32.471 6.92496C32.786 6.83996 33.069 7.12296 32.984 7.43796C31.805 11.8 31.805 16.162 32.984 20.524C33.069 20.839 32.786 21.122 32.471 21.037C28.109 19.858 23.747 19.858 19.385 21.037C19.07 21.122 18.787 20.839 18.872 20.524C20.051 16.162 20.051 11.8 18.872 7.43796C18.787 7.12296 19.07 6.83996 19.385 6.92496Z",
                fill: "#1D7AFC"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("defs", {
                children: /*#__PURE__*/ (0, $1rY3h.jsxs)("linearGradient", {
                    id: "paint0_linear_818_529",
                    x1: "13.767",
                    y1: "26.1431",
                    x2: "24.658",
                    y2: "15.2531",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                            stopColor: "#1D7AFC"
                        }),
                        /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                            offset: "1",
                            stopColor: "#0055CC"
                        })
                    ]
                })
            })
        ]
    });
};

});

parcelRegister("4pNZF", function(module, exports) {

$parcel$export(module.exports, "JiraProductDiscoveryMarkBrand", function () { return $abba373844c56879$export$1b2ff0e46e1f1569; });

var $1rY3h = parcelRequire("1rY3h");
var $abba373844c56879$export$1b2ff0e46e1f1569 = function() {
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M28.498 24.4199C28.498 24.4199 28.527 24.9899 28.527 25.7769C28.527 28.7089 26.15 31.0859 23.218 31.0859C20.286 31.0859 17.909 28.7089 17.909 25.7769C17.909 22.8449 20.286 20.4679 23.218 20.4679C24.005 20.4679 24.488 20.4969 24.488 20.4969V10.1209C24.069 10.0869 23.646 10.0659 23.218 10.0659C14.538 10.0659 7.50098 17.1029 7.50098 25.7829C7.50098 34.4629 14.538 41.4999 23.218 41.4999C31.898 41.4999 38.935 34.4629 38.935 25.7829C38.935 25.2829 38.926 24.9359 38.885 24.4209H28.498V24.4199Z",
                fill: "url(#paint0_linear_818_557)"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M26.885 8.5148C31.247 9.6938 35.609 9.6938 39.971 8.5148C40.286 8.4298 40.569 8.7128 40.484 9.0278C39.305 13.3898 39.305 17.7518 40.484 22.1138C40.569 22.4288 40.286 22.7118 39.971 22.6268C35.609 21.4478 31.247 21.4478 26.885 22.6268C26.57 22.7118 26.287 22.4288 26.372 22.1138C27.551 17.7518 27.551 13.3898 26.372 9.0278C26.287 8.7128 26.57 8.4298 26.885 8.5148Z",
                fill: "#1D7AFC"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("defs", {
                children: /*#__PURE__*/ (0, $1rY3h.jsxs)("linearGradient", {
                    id: "paint0_linear_818_557",
                    x1: "21.267",
                    y1: "27.7329",
                    x2: "32.158",
                    y2: "16.8419",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                            stopColor: "#1D7AFC"
                        }),
                        /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                            offset: "1",
                            stopColor: "#0055CC"
                        })
                    ]
                })
            })
        ]
    });
};

});

parcelRegister("lOhFL", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementLogoBrand", function () { return $883359a92d62a3fb$export$962842ccd0a7c0b9; });

var $1rY3h = parcelRequire("1rY3h");
var $883359a92d62a3fb$export$962842ccd0a7c0b9 = function() {
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("svg", {
        width: "542",
        height: "48",
        viewBox: "0 0 542 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M53.655 8.47705H57.796V29.5021C57.796 35.0681 55.358 38.8871 49.653 38.8871C47.491 38.8871 45.835 38.519 44.684 38.105V34.1031C45.926 34.6091 47.445 34.885 48.962 34.885C52.459 34.885 53.654 32.769 53.654 29.779V8.47705H53.655Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M65.3379 6.86719C66.9479 6.86719 68.0979 7.87919 68.0979 9.62819C68.0979 11.3772 66.9489 12.3882 65.3379 12.3882C63.7269 12.3882 62.5769 11.3762 62.5769 9.62819C62.5769 7.88019 63.7269 6.86719 65.3379 6.86719ZM63.3139 15.7002H67.2709V38.7032H63.3139V15.7002Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M77.114 38.7031H73.25V15.7001H77.114V19.7491C78.448 17.0341 80.749 15.1031 85.258 15.3781V19.2421C80.197 18.7361 77.114 20.2551 77.114 25.1311V38.7031Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M103.795 34.5622C102.323 37.5982 99.563 39.1632 96.021 39.1632C89.902 39.1632 86.8199 33.9642 86.8199 27.2012C86.8199 20.7152 90.0399 15.2402 96.4809 15.2402C99.8389 15.2402 102.416 16.7592 103.795 19.7492V15.7002H107.752V38.7032H103.795V34.5622ZM97.0779 35.4822C100.621 35.4822 103.795 33.2282 103.795 28.1222V26.2812C103.795 21.1752 100.897 18.9212 97.5379 18.9212C93.0759 18.9212 90.7749 21.8652 90.7749 27.2012C90.7749 32.7222 92.9829 35.4822 97.0779 35.4822Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M131.164 39.1631C125.322 39.1631 122.607 38.0131 120.261 36.8161V32.5841C123.067 34.0571 127.392 35.1141 131.394 35.1141C135.949 35.1141 137.65 33.3201 137.65 30.6521C137.65 27.9841 135.994 26.5571 130.243 25.1771C123.434 23.5211 120.398 21.1741 120.398 16.2051C120.398 11.5131 123.986 8.01709 131.024 8.01709C135.395 8.01709 138.202 9.07509 140.272 10.2251V14.3661C137.235 12.6181 133.969 12.0651 130.841 12.0651C126.884 12.0651 124.538 13.4461 124.538 16.2061C124.538 18.6901 126.47 19.9331 131.807 21.2671C138.202 22.8771 141.789 24.9481 141.789 30.3761C141.789 35.6201 138.66 39.1631 131.162 39.1631H131.164Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M157.66 39.1632C149.056 39.1632 145.285 34.1942 145.285 27.1552C145.285 20.2092 149.148 15.2402 156.142 15.2402C163.226 15.2402 166.078 20.1632 166.078 27.1552V28.9502H149.287C149.84 32.8602 152.369 35.3902 157.799 35.3902C160.467 35.3902 162.721 34.8842 164.791 34.1482V37.7832C162.904 38.7952 160.006 39.1632 157.66 39.1632ZM149.24 25.5452H162.076C161.846 21.2672 159.914 18.8292 155.957 18.8292C151.771 18.8292 149.654 21.5432 149.24 25.5452Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M174.633 38.7031H170.768V15.7001H174.633V19.7491C175.967 17.0341 178.268 15.1031 182.776 15.3781V19.2421C177.715 18.7361 174.633 20.2551 174.633 25.1311V38.7031Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M192.525 38.7032L183.601 15.7002H187.742L195.195 35.3452L202.601 15.7002H206.742L197.816 38.7032H192.525Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M212.168 6.86719C213.777 6.86719 214.928 7.87919 214.928 9.62819C214.928 11.3772 213.778 12.3882 212.168 12.3882C210.558 12.3882 209.406 11.3762 209.406 9.62819C209.406 7.88019 210.556 6.86719 212.168 6.86719ZM210.143 15.7002H214.1V38.7032H210.143V15.7002Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M236.318 38.1042C234.937 38.8402 232.822 39.1632 230.705 39.1632C222.517 39.1632 218.699 34.1942 218.699 27.1552C218.699 20.2092 222.517 15.2402 230.705 15.2402C232.775 15.2402 234.387 15.5162 236.18 16.3442V20.0242C234.709 19.3352 233.145 18.9202 230.983 18.9202C225.003 18.9202 222.563 22.6922 222.563 27.1542C222.563 31.6162 225.047 35.3892 231.075 35.3892C233.421 35.3892 234.893 35.0672 236.319 34.5612V38.1032L236.318 38.1042Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M251.818 39.1632C243.216 39.1632 239.443 34.1942 239.443 27.1552C239.443 20.2092 243.308 15.2402 250.3 15.2402C257.384 15.2402 260.238 20.1632 260.238 27.1552V28.9502H243.445C243.998 32.8602 246.529 35.3902 251.957 35.3902C254.625 35.3902 256.879 34.8842 258.949 34.1482V37.7832C257.064 38.7952 254.166 39.1632 251.818 39.1632ZM243.4 25.5452H256.236C256.006 21.2672 254.074 18.8292 250.117 18.8292C245.929 18.8292 243.814 21.5432 243.4 25.5452Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M278.223 10.9621V38.703H274.082V8.47705H281.258L288.113 25.821L290.92 34.148L293.727 25.821L300.627 8.47705H307.297V38.703H303.156V11.2841L299.615 22.1861L292.943 38.703H288.941L282.363 22.1861L278.222 10.9611L278.223 10.9621Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M329.514 34.5622C328.041 37.5982 325.282 39.1632 321.739 39.1632C315.62 39.1632 312.538 33.9642 312.538 27.2012C312.538 20.7152 315.759 15.2402 322.2 15.2402C325.557 15.2402 328.134 16.7592 329.514 19.7492V15.7002H333.471V38.7032H329.514V34.5622ZM322.797 35.4822C326.34 35.4822 329.514 33.2282 329.514 28.1222V26.2812C329.514 21.1752 326.616 18.9212 323.256 18.9212C318.795 18.9212 316.494 21.8652 316.494 27.2012C316.494 32.7222 318.701 35.4822 322.797 35.4822Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M359 38.7032H355.043V24.8092C355.043 20.6682 353.387 18.8292 349.615 18.8292C345.935 18.8292 343.404 21.2672 343.404 25.9132V38.7032H339.447V15.7002H343.404V19.4722C344.877 16.7582 347.59 15.2402 350.674 15.2402C355.963 15.2402 359 18.8752 359 25.2232V38.7022V38.7032Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M380.113 34.5622C378.64 37.5982 375.881 39.1632 372.338 39.1632C366.219 39.1632 363.137 33.9642 363.137 27.2012C363.137 20.7152 366.358 15.2402 372.799 15.2402C376.156 15.2402 378.733 16.7592 380.113 19.7492V15.7002H384.07V38.7032H380.113V34.5622ZM373.396 35.4822C376.939 35.4822 380.113 33.2282 380.113 28.1222V26.2812C380.113 21.1752 377.215 18.9212 373.855 18.9212C369.394 18.9212 367.093 21.8652 367.093 27.2012C367.093 32.7222 369.3 35.4822 373.396 35.4822Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M405.551 34.5622C404.078 37.5982 401.319 39.1632 397.776 39.1632C391.704 39.1632 388.667 33.9642 388.667 27.2012C388.667 20.7152 391.841 15.2402 398.237 15.2402C401.594 15.2402 404.171 16.7592 405.551 19.7492V15.7002H409.414V36.6332C409.414 43.3962 406.24 47.9502 398.006 47.9502C394.141 47.9502 392.026 47.4442 389.817 46.7082V42.8442C392.348 43.6722 394.969 44.2242 397.823 44.2242C403.573 44.2242 405.552 41.1422 405.552 36.8632V34.5632L405.551 34.5622ZM398.834 35.4822C402.375 35.4822 405.551 33.2282 405.551 28.1222V26.2812C405.551 21.1752 402.653 18.9212 399.293 18.9212C394.83 18.9212 392.531 21.8652 392.531 27.2012C392.531 32.7222 394.738 35.4822 398.834 35.4822Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M426.389 39.1632C417.785 39.1632 414.014 34.1942 414.014 27.1552C414.014 20.2092 417.877 15.2402 424.871 15.2402C431.955 15.2402 434.807 20.1632 434.807 27.1552V28.9502H418.016C418.569 32.8602 421.098 35.3902 426.528 35.3902C429.196 35.3902 431.45 34.8842 433.52 34.1482V37.7832C431.633 38.7952 428.735 39.1632 426.389 39.1632ZM417.969 25.5452H430.805C430.575 21.2672 428.643 18.8292 424.686 18.8292C420.5 18.8292 418.383 21.5432 417.969 25.5452Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M459.049 38.7032H455.092V24.8092C455.092 20.6682 453.436 18.8292 449.662 18.8292C445.982 18.8292 443.453 21.2672 443.453 25.9132V38.7032H439.496V15.7002H443.453V19.4722C444.924 16.7582 447.639 15.2402 450.721 15.2402C454.631 15.2402 457.299 17.2192 458.45 20.8522C459.739 17.3102 462.821 15.2402 466.639 15.2402C471.791 15.2402 474.645 18.7362 474.645 25.2232V38.7022H470.688V25.9122C470.688 21.1742 469.032 18.8282 465.258 18.8282C461.578 18.8282 459.049 21.2662 459.049 25.9122V38.7022V38.7032Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M491.154 39.1632C482.552 39.1632 478.779 34.1942 478.779 27.1552C478.779 20.2092 482.644 15.2402 489.636 15.2402C496.72 15.2402 499.574 20.1632 499.574 27.1552V28.9502H482.781C483.334 32.8602 485.865 35.3902 491.293 35.3902C493.961 35.3902 496.215 34.8842 498.285 34.1482V37.7832C496.4 38.7952 493.502 39.1632 491.154 39.1632ZM482.736 25.5452H495.572C495.342 21.2672 493.41 18.8292 489.453 18.8292C485.265 18.8292 483.15 21.5432 482.736 25.5452Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M523.816 38.7032H519.859V24.8092C519.859 20.6682 518.203 18.8292 514.429 18.8292C510.749 18.8292 508.22 21.2672 508.22 25.9132V38.7032H504.263V15.7002H508.22V19.4722C509.691 16.7582 512.406 15.2402 515.488 15.2402C520.779 15.2402 523.816 18.8752 523.816 25.2232V38.7022V38.7032Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M538.541 34.9763C539.461 34.9763 540.336 34.7913 541.025 34.6543V38.4723C540.336 38.6573 539.552 38.8403 538.357 38.8403C533.435 38.8403 531.043 35.9423 531.043 31.6633V19.3803H527.316V15.6993H531.043V10.8223H534.906V15.6993H541.025V19.3803H534.906V31.5713C534.906 33.5953 536.103 34.9753 538.541 34.9753V34.9763Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M18.7379 19.3652L29.6659 19.4322C31.0659 19.4412 31.8589 21.0402 31.0189 22.1602L14.8909 43.6712C9.82089 39.8822 8.78189 32.7002 12.5709 27.6302L18.7379 19.3652Z",
                fill: "url(#paint0_linear_818_526)"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M12.5619 27.63L1.69695 27.563C0.29795 27.554 -0.49505 25.958 0.34195 24.838L16.316 3.5C21.386 7.289 22.4249 14.471 18.636 19.541L12.5619 27.63Z",
                fill: "#1D7AFC"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("defs", {
                children: /*#__PURE__*/ (0, $1rY3h.jsxs)("linearGradient", {
                    id: "paint0_linear_818_526",
                    x1: "18.3052",
                    y1: "20.9799",
                    x2: "22.8997",
                    y2: "34.8695",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                            stopColor: "#0055CC"
                        }),
                        /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                            offset: "1",
                            stopColor: "#1D7AFC"
                        })
                    ]
                })
            })
        ]
    });
};

});

parcelRegister("kIrQm", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementMarkBrand", function () { return $54160a46b101216d$export$366b2081a44f303c; });

var $1rY3h = parcelRequire("1rY3h");
var $54160a46b101216d$export$366b2081a44f303c = function() {
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M27.057 19.7803L37.985 19.8473C39.385 19.8563 40.178 21.4553 39.338 22.5753L23.21 44.0863C18.14 40.2973 17.101 33.1153 20.89 28.0453L27.057 19.7803Z",
                fill: "url(#paint0_linear_818_533)"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M20.8799 28.0451L10.0149 27.9781C8.61594 27.9691 7.82294 26.3731 8.65994 25.2531L24.6339 3.91406C29.7039 7.70306 30.7429 14.8851 26.9539 19.9551L20.8799 28.0441V28.0451Z",
                fill: "#1D7AFC"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("defs", {
                children: /*#__PURE__*/ (0, $1rY3h.jsxs)("linearGradient", {
                    id: "paint0_linear_818_533",
                    x1: "26.6233",
                    y1: "21.3952",
                    x2: "31.2178",
                    y2: "35.2838",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                            stopColor: "#0055CC"
                        }),
                        /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                            offset: "1",
                            stopColor: "#1D7AFC"
                        })
                    ]
                })
            })
        ]
    });
};

});

parcelRegister("4P0be", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwareLogoBrand", function () { return $aecd4716ac65de75$export$eb01765c5894c7d3; });

var $1rY3h = parcelRequire("1rY3h");
var $aecd4716ac65de75$export$eb01765c5894c7d3 = function() {
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("svg", {
        width: "306",
        height: "48",
        viewBox: "0 0 306 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M57.123 8.48291H61.264V29.5079C61.264 35.0749 58.826 38.8939 53.121 38.8939C50.959 38.8939 49.303 38.5259 48.152 38.1119V34.1089C49.394 34.6159 50.913 34.8909 52.43 34.8909C55.927 34.8909 57.122 32.7749 57.122 29.7849V8.48291H57.123Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M68.807 6.87402C70.417 6.87402 71.567 7.88602 71.567 9.63402C71.567 11.382 70.418 12.395 68.807 12.395C67.196 12.395 66.046 11.382 66.046 9.63402C66.046 7.88602 67.196 6.87402 68.807 6.87402ZM66.783 15.707H70.74V38.709H66.783V15.707Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M80.582 38.7091H76.718V15.7071H80.582V19.7551C81.916 17.0411 84.217 15.1091 88.726 15.3851V19.2491C83.665 18.7431 80.582 20.2611 80.582 25.1381V38.7091Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M107.264 34.5681C105.792 37.6051 103.032 39.1691 99.4899 39.1691C93.3709 39.1691 90.2889 33.9711 90.2889 27.2081C90.2889 20.7211 93.5089 15.2461 99.9499 15.2461C103.308 15.2461 105.885 16.7651 107.264 19.7551V15.7071H111.221V38.7091H107.264V34.5681ZM100.547 35.4891C104.09 35.4891 107.264 33.2341 107.264 28.1281V26.2881C107.264 21.1821 104.366 18.9271 101.007 18.9271C96.5449 18.9271 94.2439 21.8711 94.2439 27.2081C94.2439 32.7291 96.4519 35.4891 100.547 35.4891Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M134.633 39.1689C128.79 39.1689 126.075 38.02 123.73 36.823V32.591C126.536 34.063 130.861 35.1209 134.863 35.1209C139.418 35.1209 141.12 33.326 141.12 30.658C141.12 27.99 139.464 26.5629 133.713 25.1829C126.904 23.5269 123.868 21.1809 123.868 16.2119C123.868 11.5199 127.456 8.02295 134.495 8.02295C138.866 8.02295 141.672 9.08195 143.742 10.2319V14.3719C140.706 12.6239 137.439 12.0719 134.311 12.0719C130.354 12.0719 128.008 13.4519 128.008 16.2129C128.008 18.6969 129.94 19.9399 135.277 21.2739C141.672 22.8839 145.26 24.955 145.26 30.382C145.26 35.6269 142.131 39.1689 134.633 39.1689Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M148.753 27.1621C148.753 20.2611 152.801 15.2461 159.702 15.2461C166.556 15.2461 170.559 20.2611 170.559 27.1621C170.559 34.0631 166.556 39.1691 159.702 39.1691C152.801 39.1691 148.753 34.0631 148.753 27.1621ZM152.617 27.1621C152.617 31.5321 154.779 35.4891 159.702 35.4891C164.578 35.4891 166.694 31.5321 166.694 27.1621C166.694 22.7921 164.578 18.9271 159.702 18.9271C154.779 18.9271 152.617 22.7911 152.617 27.1621Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M180.631 15.707H186.566V19.387H180.631V38.709H176.767V19.387H173.04V15.707H176.767V13.177C176.767 8.89802 179.16 5.99902 184.081 5.99902C185.277 5.99902 186.06 6.18402 186.75 6.36702V10.002C186.06 9.86402 185.186 9.77202 184.266 9.77202C181.828 9.77202 180.631 11.199 180.631 13.269V15.707Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M199.951 34.9821C200.871 34.9821 201.745 34.7981 202.435 34.6611V38.4791C201.745 38.6631 200.962 38.8471 199.766 38.8471C194.844 38.8471 192.452 35.9491 192.452 31.6701V19.3861H188.725V15.7061H192.452V10.8291H196.316V15.7061H202.435V19.3861H196.316V31.5771C196.316 33.6011 197.512 34.9811 199.951 34.9811V34.9821Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M229.208 38.709L225.252 27.576L223.136 20.491L221.02 27.576L217.063 38.709H212.002L203.537 15.707H207.907L214.532 35.213L221.249 15.707H225.021L231.738 35.213L238.363 15.707H242.733L234.268 38.709H229.207H229.208Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M260.81 34.5681C259.338 37.6051 256.578 39.1691 253.036 39.1691C246.917 39.1691 243.835 33.9711 243.835 27.2081C243.835 20.7211 247.055 15.2461 253.496 15.2461C256.854 15.2461 259.431 16.7651 260.81 19.7551V15.7071H264.767V38.7091H260.81V34.5681ZM254.093 35.4891C257.636 35.4891 260.81 33.2341 260.81 28.1281V26.2881C260.81 21.1821 257.912 18.9271 254.553 18.9271C250.091 18.9271 247.79 21.8711 247.79 27.2081C247.79 32.7291 249.998 35.4891 254.093 35.4891Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M274.607 38.7091H270.743V15.7071H274.607V19.7551C275.941 17.0411 278.242 15.1091 282.751 15.3851V19.2491C277.69 18.7431 274.607 20.2611 274.607 25.1381V38.7091Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M296.688 39.1691C288.085 39.1691 284.313 34.2011 284.313 27.1621C284.313 20.2151 288.177 15.2461 295.17 15.2461C302.254 15.2461 305.107 20.1691 305.107 27.1621V28.9561H288.315C288.868 32.8661 291.398 35.3961 296.827 35.3961C299.495 35.3961 301.749 34.8901 303.819 34.1541V37.7891C301.933 38.8011 299.035 39.1691 296.688 39.1691ZM288.269 25.5521H301.105C300.875 21.2741 298.943 18.8351 294.986 18.8351C290.799 18.8351 288.683 21.5491 288.269 25.5521Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M37.843 22.2901L20.803 5.25014L19.151 3.59814L6.323 16.4271L0.459 22.2901C-0.153 22.9021 -0.153 23.8951 0.459 24.5081L12.178 36.2271L19.151 43.2001L31.979 30.3721L32.178 30.1731L37.842 24.5091C38.454 23.8971 38.454 22.9041 37.842 22.2911L37.843 22.2901ZM19.151 29.2541L13.296 23.3991L19.152 17.5431L25.007 23.3981L19.151 29.2541Z",
                fill: "#1D7AFC"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M19.151 17.5441C15.314 13.7071 15.303 7.49707 19.111 3.64307L6.30103 16.4531L13.274 23.4261L19.153 17.5471L19.151 17.5451V17.5441Z",
                fill: "url(#paint0_linear_818_478)"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M25.023 23.3843L19.151 29.2563C23.001 33.1073 23.001 39.3503 19.151 43.2003L31.995 30.3573L25.022 23.3843H25.023Z",
                fill: "url(#paint1_linear_818_478)"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $1rY3h.jsxs)("linearGradient", {
                        id: "paint0_linear_818_478",
                        x1: "18.107",
                        y1: "11.6201",
                        x2: "9.93002",
                        y2: "19.7961",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                offset: "0.176",
                                stopColor: "#0055CC"
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1D7AFC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsxs)("linearGradient", {
                        id: "paint1_linear_818_478",
                        x1: "20.271",
                        y1: "35.1083",
                        x2: "28.431",
                        y2: "26.9483",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                offset: "0.176",
                                stopColor: "#0055CC"
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1D7AFC"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("jThhL", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwareMarkBrand", function () { return $d2dc9a986d1dab03$export$9b971ecc437a809; });

var $1rY3h = parcelRequire("1rY3h");
var $d2dc9a986d1dab03$export$9b971ecc437a809 = function() {
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M42.692 22.8912L25.652 5.85122L24 4.19922L11.172 17.0272L5.308 22.8912C4.696 23.5032 4.696 24.4962 5.308 25.1092L17.027 36.8282L24 43.8012L36.828 30.9732L37.027 30.7742L42.691 25.1102C43.303 24.4982 43.303 23.5052 42.691 22.8922L42.692 22.8912ZM24 29.8552L18.145 24.0002L24.001 18.1442L29.856 23.9992L24 29.8552Z",
                fill: "#1D7AFC"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M24 18.1442C20.163 14.3072 20.152 8.09716 23.96 4.24316L11.15 17.0532L18.123 24.0262L24.002 18.1472L24 18.1452V18.1442Z",
                fill: "url(#paint0_linear_818_577)"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M29.872 23.9844L24 29.8564C27.85 33.7074 27.85 39.9504 24 43.8004L36.844 30.9574L29.871 23.9844H29.872Z",
                fill: "url(#paint1_linear_818_577)"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $1rY3h.jsxs)("linearGradient", {
                        id: "paint0_linear_818_577",
                        x1: "22.956",
                        y1: "12.2212",
                        x2: "14.779",
                        y2: "20.3972",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                offset: "0.176",
                                stopColor: "#0055CC"
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1D7AFC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsxs)("linearGradient", {
                        id: "paint1_linear_818_577",
                        x1: "25.12",
                        y1: "35.7094",
                        x2: "33.28",
                        y2: "27.5494",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                offset: "0.176",
                                stopColor: "#0055CC"
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1D7AFC"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("i6sD3", function(module, exports) {

$parcel$export(module.exports, "JiraWorkManagementMarkBrand", function () { return $e7a49b99f9d9e587$export$5a8caf8da5dd1ba6; });

var $1rY3h = parcelRequire("1rY3h");
var $e7a49b99f9d9e587$export$5a8caf8da5dd1ba6 = function() {
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M27.852 9.79885L22.156 32.2829C29.408 34.3319 35.191 31.6679 37.407 22.9199L40.731 9.79785H27.852V9.79885Z",
                fill: "url(#paint0_linear_818_510)"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M20.148 40.2007L25.844 17.7167C18.592 15.6677 12.809 18.3317 10.593 27.0797L7.26904 40.2017H20.148V40.2007Z",
                fill: "#1D7AFC"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("defs", {
                children: /*#__PURE__*/ (0, $1rY3h.jsxs)("linearGradient", {
                    id: "paint0_linear_818_510",
                    x1: "20.469",
                    y1: "32.3659",
                    x2: "32.167",
                    y2: "18.3079",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                            stopColor: "#0055CC"
                        }),
                        /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                            offset: "1",
                            stopColor: "#1D7AFC"
                        })
                    ]
                })
            })
        ]
    });
};

});

parcelRegister("1CSrR", function(module, exports) {

$parcel$export(module.exports, "TrelloMarkBrand", function () { return $34024992d75070db$export$f4e51c099e77aab7; });

var $1rY3h = parcelRequire("1rY3h");
var $34024992d75070db$export$f4e51c099e77aab7 = function() {
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M36.429 7.69385H11.571C9.42997 7.69385 7.69397 9.42985 7.69397 11.5708V36.4288C7.69397 38.5698 9.42997 40.3058 11.571 40.3058H36.429C38.57 40.3058 40.306 38.5698 40.306 36.4288V11.5708C40.306 9.42985 38.57 7.69385 36.429 7.69385ZM21.742 31.1828C21.742 31.8948 21.165 32.4708 20.454 32.4708H15.003C14.291 32.4708 13.715 31.8938 13.715 31.1828V15.0028C13.715 14.2908 14.292 13.7148 15.003 13.7148H20.454C21.166 13.7148 21.742 14.2918 21.742 15.0028V31.1828ZM34.285 23.7548C34.285 24.4668 33.708 25.0428 32.997 25.0428H27.546C26.834 25.0428 26.258 24.4658 26.258 23.7548V15.0028C26.258 14.2908 26.835 13.7148 27.546 13.7148H32.997C33.709 13.7148 34.285 14.2918 34.285 15.0028V23.7548Z",
                fill: "url(#paint0_linear_818_512)"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("defs", {
                children: /*#__PURE__*/ (0, $1rY3h.jsxs)("linearGradient", {
                    id: "paint0_linear_818_512",
                    x1: "24",
                    y1: "40.3058",
                    x2: "24",
                    y2: "7.69385",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                            stopColor: "#0055CC"
                        }),
                        /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                            offset: "1",
                            stopColor: "#1D7AFC"
                        })
                    ]
                })
            })
        ]
    });
};

});


parcelRegister("cwD0M", function(module, exports) {

});

parcelRegister("91Gob", function(module, exports) {

$parcel$export(module.exports, "StyledBackground", function () { return $ac29dc85036ce43a$export$d5a32b9384a657de; });
/* styled-backgrounds.tsx generated by @compiled/babel-plugin v0.28.2 */ 
var $1rY3h = parcelRequire("1rY3h");
parcelRequire("1Mpn7");

var $2vwrh = parcelRequire("2vwrh");
var $bStPI = parcelRequire("bStPI");

var $jFpHW = parcelRequire("jFpHW");
var $ac29dc85036ce43a$var$positioner = {
    cornerTopLeft: "top left",
    cornerTopRight: "top right",
    cornerBottomLeft: "bottom left",
    cornerBottomRight: "bottom right",
    sideTop: "center top",
    sideLeft: "left center",
    sideRight: "right center",
    sideBottom: "center bottom",
    hidden: "-100% -100%"
};
var $ac29dc85036ce43a$var$sizes = {
    desktop: {
        cornerTopLeft: "400px auto",
        cornerTopRight: "400px auto",
        cornerBottomLeft: "400px auto",
        cornerBottomRight: "400px auto",
        sideTop: "auto 150px",
        sideLeft: "400px auto",
        sideRight: "400px auto",
        sideBottom: "auto 150px",
        hidden: "0 0"
    },
    tablet: {
        cornerTopLeft: "auto 50%",
        cornerTopRight: "auto 50%",
        cornerBottomLeft: "auto 50%",
        cornerBottomRight: "auto 50%",
        sideTop: "auto 150px",
        sideLeft: "calc(50% - 350px) auto",
        sideRight: "calc(50% - 350px) auto",
        sideBottom: "auto 150px",
        hidden: "0 0"
    },
    mobile: {
        cornerTopLeft: "auto 200px",
        cornerTopRight: "auto 200px",
        cornerBottomLeft: "auto 200px",
        cornerBottomRight: "auto 200px",
        sideTop: "auto 150px",
        sideLeft: "50%",
        sideRight: "50%",
        sideBottom: "auto 200px",
        hidden: "0 0"
    }
};
var $ac29dc85036ce43a$var$getBGObject = function(bg) {
    return {
        src: "url(".concat(bg.imageLink, ")"),
        posDesktop: $ac29dc85036ce43a$var$positioner[bg.positionDesktop],
        posTablet: $ac29dc85036ce43a$var$positioner[bg.positionTablet],
        posMobile: $ac29dc85036ce43a$var$positioner[bg.positionMobile],
        sizeDesktop: $ac29dc85036ce43a$var$sizes.desktop[bg.positionDesktop],
        sizeTablet: $ac29dc85036ce43a$var$sizes.tablet[bg.positionTablet],
        sizeMobile: $ac29dc85036ce43a$var$sizes.mobile[bg.positionMobile]
    };
};
var $ac29dc85036ce43a$export$d5a32b9384a657de = function(backgroundProperties) {
    var obj = backgroundProperties || {};
    var hasGradient = obj.gradientDirection && obj.bgColor && obj.bgColor2;
    var totalBGs = [];
    var collections = {
        desktop: {
            topCorners: false,
            bottomCorners: false
        },
        tablet: {
            topCorners: false,
            bottomCorners: false
        },
        mobile: {
            topCorners: false,
            bottomCorners: false
        }
    };
    if (hasGradient) totalBGs.unshift({
        src: (0, $jFpHW.getGradient)(obj.gradientDirection, obj.bgColor, obj.bgColor2),
        posDesktop: "top left",
        posTablet: "top left",
        posMobile: "top left",
        sizeDesktop: "100% 100%",
        sizeTablet: "100% 100%",
        sizeMobile: "100% 100%"
    });
    if (obj.bgImage) totalBGs.unshift({
        src: "url(".concat(obj.bgImage, " )"),
        posDesktop: "center center",
        posTablet: "center center",
        posMobile: "center center",
        sizeDesktop: "cover",
        sizeTablet: "cover",
        sizeMobile: "cover"
    });
    if (obj.partialBackgrounds) obj.partialBackgrounds.forEach(function(bg) {
        totalBGs.unshift($ac29dc85036ce43a$var$getBGObject(bg));
        if (bg.positionDesktop.startsWith("cornerTop") || bg.positionDesktop == "sideTop") collections.desktop.topCorners = true;
        if (bg.positionDesktop.startsWith("cornerBottom") || bg.positionDesktop == "sideBottom") collections.desktop.bottomCorners = true;
        if (bg.positionTablet.startsWith("cornerTop") || bg.positionTablet == "sideTop") collections.tablet.topCorners = true;
        if (bg.positionTablet.startsWith("cornerBottom") || bg.positionTablet == "sideBottom") collections.tablet.bottomCorners = true;
        if (bg.positionMobile.startsWith("cornerTop") || bg.positionMobile == "sideTop") collections.mobile.topCorners = true;
        if (bg.positionMobile.startsWith("cornerBottom") || bg.positionMobile == "sideBottom") collections.mobile.bottomCorners = true;
    });
    var backgroundImage = null;
    return /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
        className: (0, $2vwrh.default)([
            obj.bgColor && "_bfhk9eee",
            !obj.bgColor && "_bfhk1j28",
            obj.textColor && "_syazy0xq",
            !obj.textColor && "_dvo71mpp",
            (hasGradient || obj.bgImage || obj.partialBackgrounds) && "_1itk1svi _12vem49c _1lrwh408 _ouxl1h2r _1l14x2mw _2cw21ntp _1o601bqw _1odri93q",
            collections.mobile.topCorners && "_1q51uuw1",
            collections.mobile.bottomCorners && "_85i5uuw1",
            collections.tablet.topCorners && "_1waf68cl",
            collections.tablet.bottomCorners && "_1yd368cl",
            collections.desktop.topCorners && "_h14068cl",
            collections.desktop.bottomCorners && "_1rgh68cl",
            "styled-background"
        ]),
        style: {
            "--_1j0zdu3": (0, $bStPI.default)(obj.bgColor),
            "--_xtedcl": (0, $bStPI.default)(obj.textColor),
            "--_1rxcoa2": (0, $bStPI.default)(totalBGs.map(function(__cmplp) {
                return __cmplp.src;
            }).join(", ")),
            "--_g1sd1f": (0, $bStPI.default)(totalBGs.map(function() {
                return "no-repeat";
            }).join(", ")),
            "--_13otiam": (0, $bStPI.default)(totalBGs.map(function(__cmplp) {
                return __cmplp.sizeMobile;
            }).join(", ")),
            "--_4ewux3": (0, $bStPI.default)(totalBGs.map(function(__cmplp) {
                return __cmplp.posMobile;
            }).join(", ")),
            "--_1tw01p1": (0, $bStPI.default)(totalBGs.map(function(__cmplp) {
                return __cmplp.sizeTablet;
            }).join(", ")),
            "--_15mdg0r": (0, $bStPI.default)(totalBGs.map(function(__cmplp) {
                return __cmplp.posTablet;
            }).join(", ")),
            "--_jw8k5i": (0, $bStPI.default)(totalBGs.map(function(__cmplp) {
                return __cmplp.sizeDesktop;
            }).join(", ")),
            "--_1owty5r": (0, $bStPI.default)(totalBGs.map(function(__cmplp) {
                return __cmplp.posDesktop;
            }).join(", "))
        },
        children: obj.children
    });
};

});


parcelRegister("eTpQo", function(module, exports) {
$parcel$export(module.exports, "ClientOnly", function () { return (parcelRequire("8b1dJ")).ClientOnly; });
$parcel$export(module.exports, "useLoggedInUser", function () { return (parcelRequire("af5n8")).useLoggedInUser; });
parcelRequire("8b1dJ");
parcelRequire("7Y96P");
parcelRequire("aTcOY");
parcelRequire("af5n8");
parcelRequire("5nhFh");

});
parcelRegister("8b1dJ", function(module, exports) {

$parcel$export(module.exports, "ClientOnly", function () { return $cebaecd992afbeab$export$70f10949f62d7670; });
// @ts-ignore

var $cv9Rk = parcelRequire("cv9Rk");

var $1rY3h = parcelRequire("1rY3h");

var $1Mpn7 = parcelRequire("1Mpn7");
var $cebaecd992afbeab$var$hydrating = true;
function $cebaecd992afbeab$export$1b590bd8f758497b() {
    var _useState = (0, $cv9Rk._)((0, $1Mpn7.useState)(function() {
        return !$cebaecd992afbeab$var$hydrating;
    }), 2), hydrated = _useState[0], setHydrated = _useState[1];
    (0, $1Mpn7.useEffect)(function hydrate() {
        $cebaecd992afbeab$var$hydrating = false;
        console.debug("hydrating:", $cebaecd992afbeab$var$hydrating);
        setHydrated(true);
    }, []);
    return hydrated;
}
var $cebaecd992afbeab$export$70f10949f62d7670 = function(param) {
    var children = param.children;
    return $cebaecd992afbeab$export$1b590bd8f758497b() ? /*#__PURE__*/ (0, $1rY3h.jsx)((0, $1rY3h.Fragment), {
        children: children
    }) : null;
};

});

parcelRegister("5nhFh", function(module, exports) {

$parcel$export(module.exports, "useOutsideEvent", function () { return $fa22146aa04e7d61$export$a1ec931873402d14; });

var $1Mpn7 = parcelRequire("1Mpn7");
var $fa22146aa04e7d61$export$a1ec931873402d14 = function(elRef, eventName, callback) {
    var callbackRef = (0, $1Mpn7.useRef)();
    callbackRef.current = callback;
    (0, $1Mpn7.useEffect)(function() {
        var listener = function(event) {
            var _elRef_current;
            if (callbackRef.current && !((_elRef_current = elRef.current) === null || _elRef_current === void 0 ? void 0 : _elRef_current.contains(event.target))) callbackRef.current(event);
        };
        document.addEventListener(eventName, listener, true);
        return function() {
            return document.removeEventListener(eventName, listener, true);
        };
    }, [
        elRef,
        eventName
    ]);
};

});


parcelRegister("8tQC2", function(module, exports) {

$parcel$export(module.exports, "TRACKING_EVENT_NAMES", function () { return $bf5fb6c4e52327ea$export$9a56b303ccc53008; });
$parcel$export(module.exports, "loggedInHeroAnalyticsPayload", function () { return $bf5fb6c4e52327ea$export$cbc42fadf8b93ea3; });
$parcel$export(module.exports, "loggedInHeroLoadedAnalyticsPayload", function () { return $bf5fb6c4e52327ea$export$572cd721c4c6631c; });
var $bf5fb6c4e52327ea$export$9a56b303ccc53008;
(function(TRACKING_EVENT_NAMES) {
    TRACKING_EVENT_NAMES["loggedInHeroProductCtaClicked"] = "loggedInHeroProductCtaClicked";
    TRACKING_EVENT_NAMES["loggedInHeroAnotherSiteCtaClicked"] = "loggedInHeroAnotherSiteCtaClicked";
})($bf5fb6c4e52327ea$export$9a56b303ccc53008 || ($bf5fb6c4e52327ea$export$9a56b303ccc53008 = {}));
var $bf5fb6c4e52327ea$export$cbc42fadf8b93ea3 = {
    eventType: "ui",
    action: "clicked",
    actionSubject: "button",
    actionSubjectId: "loggedInHero",
    source: "/software/jira"
};
var $bf5fb6c4e52327ea$export$572cd721c4c6631c = {
    eventType: "ui",
    action: "loaded",
    actionSubject: "ATLAS-53087",
    actionSubjectId: "loggedInHero",
    source: "/software/jira",
    attributes: {
        atlasId: "ATLAS-53087"
    }
};

});

parcelRegister("rDj8o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $deb1a4529d7263ee$export$2e2bcd8739ae039; });

var $1rY3h = parcelRequire("1rY3h");
var $deb1a4529d7263ee$var$ArrowCircle = function() {
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("svg", {
        width: "157",
        height: "343",
        viewBox: "0 0 157 343",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M134 240C85.3995 240 46 200.601 46 152C46 103.399 85.3995 64 134 64",
                stroke: "url(#paint0_linear_1167_22236)",
                strokeWidth: "2.10383",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M118 48L134 63.976L118 80",
                stroke: "white",
                strokeWidth: "2.10383",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("circle", {
                cx: "148.5",
                cy: "148.5",
                r: "147.25",
                stroke: "#4C9AFF",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsxs)("g", {
                filter: "url(#filter0_d_1167_22236)",
                children: [
                    /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                        d: "M160.785 218H136.262L124 239L136.262 260H160.785L173 239L160.785 218Z",
                        fill: "url(#paint1_linear_1167_22236)",
                        shapeRendering: "crispEdges"
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                        d: "M125.158 239L136.836 219H160.21L171.843 239L160.21 259H136.836L125.158 239Z",
                        stroke: "#B3D4FF",
                        strokeWidth: "2",
                        shapeRendering: "crispEdges"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("rect", {
                x: "112.25",
                y: "341.75",
                width: "148.5",
                height: "72.5",
                rx: "36.25",
                transform: "rotate(-90 112.25 341.75)",
                stroke: "#4C9AFF",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M148.5 319C161.479 319 172 308.479 172 295.5C172 282.521 161.479 272 148.5 272C135.521 272 125 282.521 125 295.5C125 308.479 135.521 319 148.5 319Z",
                fill: "url(#paint2_linear_1167_22236)"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $1rY3h.jsxs)("filter", {
                        id: "filter0_d_1167_22236",
                        x: "92",
                        y: "186",
                        width: "113",
                        height: "106",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $1rY3h.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)("feOffset", {}),
                            /*#__PURE__*/ (0, $1rY3h.jsx)("feGaussianBlur", {
                                stdDeviation: "16"
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.0156863 0 0 0 0 0.364706 0 0 0 0 0.894118 0 0 0 1 0"
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_1167_22236"
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_1167_22236",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsxs)("linearGradient", {
                        id: "paint0_linear_1167_22236",
                        x1: "90",
                        y1: "64",
                        x2: "90",
                        y2: "240",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                stopColor: "white"
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                offset: "1",
                                stopColor: "white",
                                stopOpacity: "0.15"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsxs)("linearGradient", {
                        id: "paint1_linear_1167_22236",
                        x1: "131.776",
                        y1: "255.539",
                        x2: "164.898",
                        y2: "222.066",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                stopColor: "#0065FF"
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                offset: "1",
                                stopColor: "#0065FF",
                                stopOpacity: "0.67"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsxs)("linearGradient", {
                        id: "paint2_linear_1167_22236",
                        x1: "131.894",
                        y1: "312.131",
                        x2: "165.128",
                        y2: "278.897",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                stopColor: "#F8A703"
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FAA802",
                                stopOpacity: "0.67"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $deb1a4529d7263ee$export$2e2bcd8739ae039 = $deb1a4529d7263ee$var$ArrowCircle;

});

parcelRegister("b5KHh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4e67551e1fd9b5ee$export$2e2bcd8739ae039; });

var $1rY3h = parcelRequire("1rY3h");
var $4e67551e1fd9b5ee$var$TargetSvg = function() {
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("svg", {
        width: "254",
        height: "421",
        viewBox: "0 0 254 421",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M-9.5332 158.174C-38.8225 187.463 -39.1391 234.634 -10.2403 263.533C18.6585 292.432 65.8293 292.115 95.1186 262.826C124.408 233.537 124.725 186.366 95.8257 157.467C66.9269 128.568 19.7561 128.885 -9.5332 158.174Z",
                fill: "url(#paint0_linear_1058_39888)"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("circle", {
                cx: "43.4999",
                cy: "209.793",
                r: "107.75",
                transform: "rotate(135 43.4999 209.793)",
                stroke: "url(#paint1_linear_1058_39888)",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("circle", {
                cx: "43.4998",
                cy: "210.5",
                r: "147.25",
                transform: "rotate(135 43.4998 210.5)",
                stroke: "url(#paint2_linear_1058_39888)",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $1rY3h.jsxs)("linearGradient", {
                        id: "paint0_linear_1058_39888",
                        x1: "43.2371",
                        y1: "135.994",
                        x2: "44.237",
                        y2: "284.98",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                stopColor: "#2684FF"
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                offset: "1",
                                stopColor: "#0E64DF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsxs)("linearGradient", {
                        id: "paint1_linear_1058_39888",
                        x1: "141",
                        y1: "128.793",
                        x2: "23.9999",
                        y2: "328.793",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                stopColor: "white"
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                offset: "1",
                                stopColor: "white",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsxs)("linearGradient", {
                        id: "paint2_linear_1058_39888",
                        x1: "43.4998",
                        y1: "62",
                        x2: "43.4998",
                        y2: "359",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                stopColor: "#4C9AFF"
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)("stop", {
                                offset: "1",
                                stopColor: "#9BB2D1",
                                stopOpacity: "0"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $4e67551e1fd9b5ee$export$2e2bcd8739ae039 = $4e67551e1fd9b5ee$var$TargetSvg;

});


parcelRegister("2Q3Zm", function(module, exports) {
$parcel$export(module.exports, "BannerAlert", function () { return (parcelRequire("5AeXF")).BannerAlert; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("5AeXF")).BannerAlert; });

var $5AeXF = parcelRequire("5AeXF");

});
parcelRegister("5AeXF", function(module, exports) {

$parcel$export(module.exports, "BannerAlert", function () { return $7805f8e877b5aec2$export$4eb8f3e4e539379b; });
/* banner-alert.tsx generated by @compiled/babel-plugin v0.28.2 */ 
var $cv9Rk = parcelRequire("cv9Rk");

var $1rY3h = parcelRequire("1rY3h");

var $1Mpn7 = parcelRequire("1Mpn7");

var $2vwrh = parcelRequire("2vwrh");

var $8pPrt = parcelRequire("8pPrt");

var $jpiYS = parcelRequire("jpiYS");
parcelRequire("9DBuW");
var $bLsIZ = parcelRequire("bLsIZ");
parcelRequire("dLifx");
var $6WnuF = parcelRequire("6WnuF");
var $7805f8e877b5aec2$var$containerStyles = null;
var $7805f8e877b5aec2$var$contentStyles = null;
var $7805f8e877b5aec2$var$closeIconStyles = null;
var $7805f8e877b5aec2$export$4eb8f3e4e539379b = function(param) {
    var identifier = param.identifier, text = param.text, linkText = param.linkText, linkUrl = param.linkUrl, dataEventProps = param.dataEventProps;
    var intl = (0, $8pPrt.default)();
    var bannerStorageItem = "BannerAlert_dismiss-".concat(identifier);
    var translatedLabel = intl.formatMessage({
        id: "banner-alert.close.aria-label",
        defaultMessage: "Close"
    });
    var _useState = (0, $cv9Rk._)((0, $1Mpn7.useState)(true), 2), isHidden = _useState[0], setIsHidden = _useState[1];
    (0, $1Mpn7.useEffect)(function() {
        var dismissValue = localStorage.getItem(bannerStorageItem);
        if (dismissValue !== "1") setIsHidden(false);
    }, []);
    return /*#__PURE__*/ (0, $1rY3h.jsx)((0, $jpiYS.default), {
        name: "banner-alert",
        children: /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
            "data-dismissed": isHidden ? "true" : undefined,
            className: (0, $2vwrh.default)([
                "_bfhkuzct _kqswh2mm _y4til6l0 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1e0c1txw _1pbykb7n _nzmgglyw"
            ]),
            children: [
                /*#__PURE__*/ (0, $1rY3h.jsx)("button", {
                    "aria-label": translatedLabel,
                    onClick: function() {
                        setIsHidden(true);
                        localStorage.setItem(bannerStorageItem, "1");
                    },
                    className: (0, $2vwrh.default)([
                        "_r06hglyw _bfhk1j28 _19itidpf _80omtlke _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw _rjxp1ul9 _152txjmg _1nj119tk"
                    ]),
                    children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $bLsIZ.Cross), {
                        size: "20"
                    })
                }),
                /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                    className: (0, $2vwrh.default)([
                        "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _bozghiv4 _y4tiap9k _1e0c11p5 _syaz1mpp _1a9ox7w3 _oxk4oelr _rfqo1r31 _1bgkglyw _1t0pnqa1 _1d61glyw _14l31rrv"
                    ]),
                    children: /*#__PURE__*/ (0, $1rY3h.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, $1rY3h.jsx)("span", {
                                children: text
                            }),
                            "\xa0",
                            /*#__PURE__*/ (0, $1rY3h.jsx)((0, $6WnuF.Link), {
                                customLinkColor: "#0052cc",
                                text: linkText,
                                href: linkUrl,
                                type: "inline-basic",
                                dataEventProps: dataEventProps
                            })
                        ]
                    })
                })
            ]
        })
    });
};

});
parcelRegister("dLifx", function(module, exports) {
$parcel$export(module.exports, "Link", function () { return (parcelRequire("6WnuF")).Link; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("6WnuF")).Link; });

var $6WnuF = parcelRequire("6WnuF");

});
parcelRegister("6WnuF", function(module, exports) {

$parcel$export(module.exports, "Link", function () { return $a785ec3424153a1c$export$a6c7ac8248d6e38a; });
/* link.tsx generated by @compiled/babel-plugin v0.28.2 */ /* eslint-disable complexity */ 
var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $1rY3h = parcelRequire("1rY3h");

var $2vwrh = parcelRequire("2vwrh");
var $bStPI = parcelRequire("bStPI");

var $1Mpn7 = parcelRequire("1Mpn7");
//CSS
var $a785ec3424153a1c$var$linkColors = {
    bgWhite: {
        default: "#0052cc",
        hover: "#0065ff",
        visited: "#403294"
    },
    bgLight: {
        default: "#172b4d",
        hover: "#0049b0",
        visited: "#403294"
    },
    bgDark: {
        default: "#fafbfc",
        hover: "#4c9aff",
        visited: "#c0b6f2"
    }
};
//Functions
var $a785ec3424153a1c$var$Icon = function(type) {
    if (type === "basic" || type === "basic-underline" || type === "inline-basic") return /*#__PURE__*/ (0, $1rY3h.jsx)("svg", {
        width: "11",
        height: "8",
        viewBox: "0 0 11 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: (0, $2vwrh.default)([
            "_19pk14y2 _2hwxidpf _otyryh40 _18u014y2 _v564x7w3"
        ]),
        children: /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.40796 0L6.32831 1.2021L8.07854 3.1497H0.763182C0.341906 3.1497 0 3.53038 0 3.99943C0 4.46849 0.341906 4.84917 0.763182 4.84917H8.07854L6.32831 6.7979L7.40796 8L11 3.99943L7.40796 0Z"
        })
    });
    if (type === "external" || type === "external-icon") return /*#__PURE__*/ (0, $1rY3h.jsx)("svg", {
        width: "7",
        height: "8",
        viewBox: "0 0 7 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: (0, $2vwrh.default)([
            "_19pk14y2 _2hwxidpf _otyryh40 _18u014y2"
        ]),
        children: /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2.04815 0.5V1.98788H4.46059L0.217983 6.22935C-0.0726609 6.51998 -0.0726609 6.99114 0.217983 7.28178C0.363801 7.4266 0.553265 7.5 0.744713 7.5C0.935169 7.5 1.12463 7.4266 1.27045 7.28178L5.51206 3.04031V5.45168H7V0.5H2.04815Z"
        })
    });
    if (type === "video") return /*#__PURE__*/ (0, $1rY3h.jsx)("svg", {
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: (0, $2vwrh.default)([
            "_12l21l7b"
        ]),
        children: /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM10.3561 7.10299L4.79449 4.21918V9.78082L10.3561 7.10299Z"
        })
    });
    return;
};
var $a785ec3424153a1c$var$formatLinkText = function(text, type) {
    var typeOfLink = type ? type : "basic";
    if (type === "video") return /*#__PURE__*/ (0, $1rY3h.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).Fragment, {
        children: [
            $a785ec3424153a1c$var$Icon(typeOfLink),
            /*#__PURE__*/ (0, $1rY3h.jsx)("span", {
                children: text
            })
        ]
    });
    if (type === "external-icon") return /*#__PURE__*/ (0, $1rY3h.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).Fragment, {
        children: /*#__PURE__*/ (0, $1rY3h.jsxs)("span", {
            children: [
                text,
                $a785ec3424153a1c$var$Icon(typeOfLink)
            ]
        })
    });
    return /*#__PURE__*/ (0, $1rY3h.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsx)("span", {
                children: text
            }),
            $a785ec3424153a1c$var$Icon(typeOfLink)
        ]
    });
};
var $a785ec3424153a1c$export$39aecc95f0365819 = function(props) {
    var children = (0, $1Mpn7.Children).toArray(props.children);
    if (props.type === "inline" || props.type === "inline-basic") return /*#__PURE__*/ (0, $1rY3h.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).Fragment, {
        children: children.map(function(child) {
            return child;
        })
    });
    return /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
        className: "link-wrapper",
        children: children.map(function(child) {
            return child;
        })
    });
};
var $a785ec3424153a1c$export$a6c7ac8248d6e38a = function(param) {
    var text = param.text, href = param.href, type = param.type, customLinkColor = param.customLinkColor, bgColor = param.bgColor, onClick = param.onClick, className = param.className, _param_doesArrowAnimate = param.doesArrowAnimate, doesArrowAnimate = _param_doesArrowAnimate === void 0 ? false : _param_doesArrowAnimate, dataEventProps = param.dataEventProps;
    var bg = bgColor ? bgColor : "bgWhite";
    var colorDefault = $a785ec3424153a1c$var$linkColors[bg].default;
    var colorHover = $a785ec3424153a1c$var$linkColors[bg].hover;
    var colorVisited = $a785ec3424153a1c$var$linkColors[bg].visited;
    if (customLinkColor) colorDefault = colorHover = colorVisited = customLinkColor;
    var linkStyles = [
        customLinkColor && null,
        !customLinkColor && null,
        type === "basic-underline" && null,
        type === "modal" && null,
        (type === "inline" || type === "inline-basic") && null,
        type !== "modal" && type !== "inline" && type !== "inline-basic" && null,
        doesArrowAnimate && (type === "basic" || type === "basic-underline" || type === "inline-basic") && null,
        null
    ];
    return /*#__PURE__*/ (0, $1rY3h.jsx)($a785ec3424153a1c$export$39aecc95f0365819, {
        type: type,
        text: text,
        href: href,
        children: /*#__PURE__*/ (0, $1rY3h.jsx)("a", (0, $cxjpp._)((0, $do9pw._)({
            className: (0, $2vwrh.default)([
                customLinkColor && "_16bt1q1b _1up41q1b",
                !customLinkColor && "",
                type === "basic-underline" && "_9oik1r31 _1bnx8stv _jf4cnqa1",
                type === "modal" && "_1hms8stv _ajmmgq9o _1kegt94y _l7ed1l7b",
                (type === "inline" || type === "inline-basic") && "_4bfu1r31 _1hms8stv _ajmmnqa1",
                type !== "modal" && type !== "inline" && type !== "inline-basic" && "_4bfu1r31 _1hmsglyw _ajmmnqa1",
                doesArrowAnimate && (type === "basic" || type === "basic-underline" || type === "inline-basic") && "_1up4glyw _12sv1rrv",
                "_4cvr1h6o _syazaexi _1e0c116y _10531pdu _f8pji0o6 _30l3i0o6 _1axpaexi _aelyaexi _pb8z1pdu _kj55i0o6 _12lvi0o6 _l8kux7w3",
                className
            ]),
            href: href,
            target: type == "external" ? "_blank" : "",
            rel: type == "external" ? "noreferrer" : "",
            onClick: onClick
        }, dataEventProps), {
            style: {
                "--_1bmh097": (0, $bStPI.default)(colorDefault),
                "--_d4pjwz": (0, $bStPI.default)(colorVisited),
                "--_amadh5": (0, $bStPI.default)(colorHover)
            },
            children: $a785ec3424153a1c$var$formatLinkText(text, type)
        }))
    });
};

});




parcelRegister("2miCy", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_VALUES", function () { return (parcelRequire("7UzgT")).DEFAULT_VALUES; });
$parcel$export(module.exports, "useLocalizedHref", function () { return (parcelRequire("hot2Q")).useLocalizedHref; });
parcelRequire("f3oy0");

});
parcelRegister("f3oy0", function(module, exports) {
$parcel$export(module.exports, "useLocalizedHref", function () { return (parcelRequire("hot2Q")).useLocalizedHref; });
$parcel$export(module.exports, "DEFAULT_VALUES", function () { return (parcelRequire("7UzgT")).DEFAULT_VALUES; });
parcelRequire("g9QCP");
parcelRequire("1aG2I");
parcelRequire("hot2Q");
parcelRequire("7UzgT");

});
parcelRegister("g9QCP", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LOCALE", function () { return $76ef23cf39785c44$export$1af4c7e47ad72f44; });

var $3sHb8 = parcelRequire("3sHb8");
var $76ef23cf39785c44$export$1af4c7e47ad72f44 = "en";
var $76ef23cf39785c44$var$_obj;
var $76ef23cf39785c44$export$75c094d97cea9594 = Object.freeze(($76ef23cf39785c44$var$_obj = {}, (0, $3sHb8._)($76ef23cf39785c44$var$_obj, $76ef23cf39785c44$export$1af4c7e47ad72f44, {
    label: "English"
}), (0, $3sHb8._)($76ef23cf39785c44$var$_obj, "de", {
    label: "Deutsch"
}), (0, $3sHb8._)($76ef23cf39785c44$var$_obj, "es", {
    label: "Espa\xf1ol"
}), (0, $3sHb8._)($76ef23cf39785c44$var$_obj, "fr", {
    label: "Fran\xe7ais"
}), (0, $3sHb8._)($76ef23cf39785c44$var$_obj, "it", {
    label: "Italiano"
}), (0, $3sHb8._)($76ef23cf39785c44$var$_obj, "ko", {
    label: "\uD55C\uAD6D\uC5B4"
}), (0, $3sHb8._)($76ef23cf39785c44$var$_obj, "hu", {
    label: "Magyar"
}), (0, $3sHb8._)($76ef23cf39785c44$var$_obj, "nl", {
    label: "Nederlands"
}), (0, $3sHb8._)($76ef23cf39785c44$var$_obj, "ja", {
    label: "\u65E5\u672C\u8A9E"
}), (0, $3sHb8._)($76ef23cf39785c44$var$_obj, "pl", {
    label: "Polski"
}), (0, $3sHb8._)($76ef23cf39785c44$var$_obj, "br", {
    label: "Portugu\xeas"
}), (0, $3sHb8._)($76ef23cf39785c44$var$_obj, "ru", {
    label: "\u0440\u0443\u0441\u0441\u043A\u0438\u0439"
}), (0, $3sHb8._)($76ef23cf39785c44$var$_obj, "zh", {
    label: "\u4E2D\u6587"
}), $76ef23cf39785c44$var$_obj));
var $76ef23cf39785c44$export$e49c1078bc46f17 = Object.keys($76ef23cf39785c44$export$75c094d97cea9594);

});

parcelRegister("1aG2I", function(module, exports) {

$parcel$export(module.exports, "useLocale", function () { return $786d8840b558b6a4$export$43bb16f9c6d9e3f7; });

var $8pPrt = parcelRequire("8pPrt");
function $786d8840b558b6a4$export$43bb16f9c6d9e3f7() {
    var intl = (0, $8pPrt.default)();
    return intl.locale;
}

});

parcelRegister("hot2Q", function(module, exports) {

$parcel$export(module.exports, "useLocalizedHref", function () { return $b1964cf631335135$export$a5c4c45429ec5d04; });

var $g9QCP = parcelRequire("g9QCP");

var $1aG2I = parcelRequire("1aG2I");
function $b1964cf631335135$export$a5c4c45429ec5d04(href) {
    var locale = (0, $1aG2I.useLocale)();
    if (locale === (0, $g9QCP.DEFAULT_LOCALE)) return href;
    else return "/".concat(locale).concat(href);
}

});

parcelRegister("7UzgT", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_VALUES", function () { return $727030105aa1beac$export$d7e66ef6999696cf; });

var $1rY3h = parcelRequire("1rY3h");
var $727030105aa1beac$export$d7e66ef6999696cf = Object.freeze({
    br: /*#__PURE__*/ (0, $1rY3h.jsx)("br", {}),
    p: function(chunks) {
        return /*#__PURE__*/ (0, $1rY3h.jsx)("p", {
            children: chunks
        });
    },
    strong: function(chunks) {
        return /*#__PURE__*/ (0, $1rY3h.jsx)("strong", {
            children: chunks
        });
    },
    span: function(chunks) {
        return /*#__PURE__*/ (0, $1rY3h.jsx)("span", {
            children: chunks
        });
    }
});

});



parcelRegister("fn5Fs", function(module, exports) {
$parcel$export(module.exports, "GlobalFooter", function () { return (parcelRequire("7cc3a")).GlobalFooter; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("7cc3a")).GlobalFooter; });

var $7cc3a = parcelRequire("7cc3a");
parcelRequire("8z0nh");
parcelRequire("81soM");

});
parcelRegister("7cc3a", function(module, exports) {

$parcel$export(module.exports, "GlobalFooter", function () { return $2f5f6dcea1a2fab7$export$4bf04f8af9c4c55; });
/* global-footer.tsx generated by @compiled/babel-plugin v0.28.2 */ 
var $1rY3h = parcelRequire("1rY3h");
parcelRequire("1Mpn7");

var $2vwrh = parcelRequire("2vwrh");

var $jpiYS = parcelRequire("jpiYS");

var $81soM = parcelRequire("81soM");

var $8z0nh = parcelRequire("8z0nh");
// ==================================================================
// CSS styling
// ==================================================================
var $2f5f6dcea1a2fab7$var$globalFooterStyle = null;
var $2f5f6dcea1a2fab7$export$4bf04f8af9c4c55 = function(param) {
    var selectedLanguage = param.selectedLanguage, onLanguageChangeHandler = param.onLanguageChangeHandler;
    return /*#__PURE__*/ (0, $1rY3h.jsx)((0, $jpiYS.default), {
        name: "global-footer",
        children: /*#__PURE__*/ (0, $1rY3h.jsxs)("footer", {
            className: (0, $2vwrh.default)([
                "_bfhk1hxd _ca0q7vkz _u5f3idpf _n3tdidpf _19bvidpf _kqswh2mm _12l21wug _ahbq1wug _1ul91osq _11rm1hrf"
            ]),
            children: [
                /*#__PURE__*/ (0, $1rY3h.jsx)((0, $8z0nh.GlobalFooterTop), {}),
                /*#__PURE__*/ (0, $1rY3h.jsx)((0, $81soM.GlobalFooterBottom), {
                    selectedLanguage: selectedLanguage,
                    onLanguageChangeHandler: onLanguageChangeHandler
                })
            ]
        })
    });
};

});
parcelRegister("81soM", function(module, exports) {

$parcel$export(module.exports, "GlobalFooterBottom", function () { return $859e552290c199f0$export$8eb5df03385c4090; });
/* global-footer-bottom.tsx generated by @compiled/babel-plugin v0.28.2 */ // @ts-ignore

var $1rY3h = parcelRequire("1rY3h");

var $2vwrh = parcelRequire("2vwrh");
parcelRequire("1Mpn7");

var $8pPrt = parcelRequire("8pPrt");
parcelRequire("2miCy");
var $hot2Q = parcelRequire("hot2Q");
parcelRequire("ibbD1");
var $1PvmE = parcelRequire("1PvmE");
parcelRequire("kuuPa");
var $iF02n = parcelRequire("iF02n");
parcelRequire("4qa8L");
var $l0ZtL = parcelRequire("l0ZtL");
parcelRequire("dLifx");
var $6WnuF = parcelRequire("6WnuF");
// ==================================================================
// CSS styling
// ==================================================================
var $859e552290c199f0$var$containerStyle = null;
var $859e552290c199f0$var$rowStyle = null;
var $859e552290c199f0$var$columnStyle = null;
var $859e552290c199f0$var$languageSelectorStyle = null;
var $859e552290c199f0$var$linkStyle = null;
var $859e552290c199f0$var$copyrightStyle = null;
var $859e552290c199f0$var$socialLinksStyle = null;
var $859e552290c199f0$export$8eb5df03385c4090 = function(param) {
    var selectedLanguage = param.selectedLanguage, onLanguageChangeHandler = param.onLanguageChangeHandler, className = param.className;
    var intl = (0, $8pPrt.default)();
    var bottomLinks = [
        {
            text: intl.formatMessage({
                id: "globalFooter.bottom.privacy-policy",
                defaultMessage: "Privacy policy"
            }),
            href: (0, $hot2Q.useLocalizedHref)("/legal/privacy-policy"),
            isOneTrustWrapped: false
        },
        {
            text: intl.formatMessage({
                id: "globalFooter.bottom.notice-at-collection",
                defaultMessage: "Notice at Collection"
            }),
            href: "/legal/privacy-policy#additional-disclosures-for-ca-residents",
            isOneTrustWrapped: true
        },
        {
            text: intl.formatMessage({
                id: "globalFooter.bottom.terms",
                defaultMessage: "Terms"
            }),
            href: "/legal/cloud-terms-of-service",
            isOneTrustWrapped: false
        },
        {
            text: intl.formatMessage({
                id: "globalFooter.bottom.impressum",
                defaultMessage: "Impressum"
            }),
            href: "/legal/impressum",
            isOneTrustWrapped: false
        }
    ];
    var copyRightYear = new Date().getFullYear();
    return /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
        className: (0, $2vwrh.default)([
            "_mqm21jv8 _7cca15wb",
            className
        ]),
        children: /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
            className: (0, $2vwrh.default)([
                "_p12f1git _ahbq1wug _12l21wug"
            ]),
            children: /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
                className: (0, $2vwrh.default)([
                    "_1wyboxwj _1e0c1txw _1n261g80 _1kmx7vkz _1ggm7vkz _1ykz7vkz _1mae7vkz _1gde1bp4 _nssp1y6m _ag851y6m _131y14y2 _55brvrvc _19vu1h6o _i6jx7vkz _1lh77vkz _z3nc7vkz _wpai7vkz _bcla1j6v _1inivrvc _1jsv1h6o _3l1a1abu _glteknxo _ikjd1k8s"
                ]),
                children: [
                    /*#__PURE__*/ (0, $1rY3h.jsx)((0, $1PvmE.LanguageSelector), {
                        selectedLanguage: selectedLanguage,
                        onLanguageChangeHandler: onLanguageChangeHandler,
                        className: (0, $2vwrh.default)([
                            "_srwz1lpd"
                        ])
                    }),
                    bottomLinks.map(function(bottomLink) {
                        if (bottomLink.isOneTrustWrapped) return /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                            className: "link-wrapper atl-policy-link-container",
                            children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $l0ZtL.LinkWithIcon), {
                                linkText: bottomLink.text,
                                href: bottomLink.href,
                                type: "anchor",
                                isHaveIcon: false,
                                isUsePlainSpanTagForLinkText: true,
                                className: "atl-policy-link",
                                spanLinkTextClassName: "atl-policy-link-text"
                            })
                        }, bottomLink.text);
                        else return /*#__PURE__*/ (0, $1rY3h.jsx)((0, $6WnuF.Link), {
                            text: bottomLink.text,
                            href: bottomLink.href,
                            type: "anchor",
                            customLinkColor: "#42526e",
                            className: (0, $2vwrh.default)([
                                "_4t3i1ou6 _4bfu1r31 _1hmsglyw _ajmmnqa1 _9oik1r31 _1bnx8stv _jf4cnqa1 _1up4glyw _16btglyw _1taiglyw _11cgyh40"
                            ])
                        }, bottomLink.text);
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
                        className: (0, $2vwrh.default)([
                            "_syazvwuj _4t3i1ou6 _vwz41ou6 _11cgyh40"
                        ]),
                        children: [
                            "Copyright \xa9 ",
                            copyRightYear,
                            " Atlassian"
                        ]
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)((0, $iF02n.SocialLinks), {
                        className: (0, $2vwrh.default)([
                            "_1wpzesu3 _1ywm1wug"
                        ])
                    })
                ]
            })
        })
    });
};

});
parcelRegister("ibbD1", function(module, exports) {

$parcel$export(module.exports, "LanguageSelector", function () { return (parcelRequire("1PvmE")).LanguageSelector; });

var $1PvmE = parcelRequire("1PvmE");

});
parcelRegister("1PvmE", function(module, exports) {

$parcel$export(module.exports, "LanguageSelector", function () { return $8ae05ff9c5b0f027$export$ddd501dda1f62236; });
/* async.tsx generated by @compiled/babel-plugin v0.28.2 */ 
var $1rY3h = parcelRequire("1rY3h");

var $2vwrh = parcelRequire("2vwrh");

var $1Mpn7 = parcelRequire("1Mpn7");

var $8pPrt = parcelRequire("8pPrt");
parcelRequire("eTpQo");
var $af5n8 = parcelRequire("af5n8");

var $eZ1WC = parcelRequire("eZ1WC");

// @ts-expect-error
var $8ae05ff9c5b0f027$var$Selector = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).lazy(function() {
    return (parcelRequire("eLh5W"));
});
var $8ae05ff9c5b0f027$var$containerStyles = null;
var $8ae05ff9c5b0f027$var$labelStyles = null;
var $8ae05ff9c5b0f027$var$arrowStyles = null;
var $8ae05ff9c5b0f027$var$SelectorFallback = function(param) {
    var label = param.label;
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
        className: (0, $2vwrh.default)([
            "_syazvwuj _80omtlke _1e0c116y _4cvr1h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsx)((0, $eZ1WC.LanguageGlobeIcon), {
                color: "#42526e"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("span", {
                className: (0, $2vwrh.default)([
                    "_ahbqh461 _1wyboxwj"
                ]),
                children: label
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("span", {
                "aria-hidden": "true",
                className: (0, $2vwrh.default)([
                    "_ahbqh461 _1wyb1k8s"
                ]),
                children: "\u25BE"
            })
        ]
    });
};
var $8ae05ff9c5b0f027$export$ddd501dda1f62236 = function(param) {
    var selectedLanguage = param.selectedLanguage, onLanguageChangeHandler = param.onLanguageChangeHandler, className = param.className, testId = param.testId;
    var _languages_find;
    var intl = (0, $8pPrt.default)();
    var userInfo = (0, $af5n8.useLoggedInUser)();
    if (!selectedLanguage) selectedLanguage = intl.locale || "en";
    var _languages_find_label;
    var label = (_languages_find_label = (_languages_find = (0, $eZ1WC.languages).find(function(language) {
        return language.value === selectedLanguage;
    })) === null || _languages_find === void 0 ? void 0 : _languages_find.label) !== null && _languages_find_label !== void 0 ? _languages_find_label : "English";
    if (userInfo.requestInProgress) return /*#__PURE__*/ (0, $1rY3h.jsx)($8ae05ff9c5b0f027$var$SelectorFallback, {
        label: label
    });
    return /*#__PURE__*/ (0, $1rY3h.jsx)((0, $1Mpn7.Suspense), {
        fallback: /*#__PURE__*/ (0, $1rY3h.jsx)($8ae05ff9c5b0f027$var$SelectorFallback, {
            label: label
        }),
        children: /*#__PURE__*/ (0, $1rY3h.jsx)($8ae05ff9c5b0f027$var$Selector, {
            selectedLanguage: selectedLanguage,
            onLanguageChangeHandler: onLanguageChangeHandler,
            className: className,
            testId: testId
        })
    });
};

});
parcelRegister("eZ1WC", function(module, exports) {

$parcel$export(module.exports, "languages", function () { return $6df2f754d9196050$export$d0d68bb9ed2c643d; });
$parcel$export(module.exports, "LanguageGlobeIcon", function () { return $6df2f754d9196050$export$a7259a7df7627186; });

var $1rY3h = parcelRequire("1rY3h");
var $6df2f754d9196050$export$d0d68bb9ed2c643d = [
    {
        label: "Deutsch",
        value: "de"
    },
    {
        label: "English",
        value: "en"
    },
    {
        label: "Espa\xf1ol",
        value: "es"
    },
    {
        label: "Fran\xe7ais",
        value: "fr"
    },
    {
        label: "Italiano",
        value: "it"
    },
    {
        label: "\uD55C\uAD6D\uC5B4",
        value: "ko"
    },
    {
        label: "Magyar",
        value: "hu"
    },
    {
        label: "Nederlands",
        value: "nl"
    },
    {
        label: "\u65E5\u672C\u8A9E",
        value: "ja"
    },
    {
        label: "Polski",
        value: "pl"
    },
    {
        label: "Portugu\xeas",
        value: "br"
    },
    {
        label: "\u0440\u0443\u0441\u0441\u043A\u0438\u0439",
        value: "ru"
    },
    {
        label: "\u4E2D\u6587",
        value: "zh"
    }
];
var $6df2f754d9196050$export$a7259a7df7627186 = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("svg", {
        id: "icon-wac-language-globe",
        width: "18px",
        height: "18px",
        viewBox: "0 0 25 24",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsx)("defs", {
                children: /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                    d: "M2.33514634,13.0909091 C2.80456741,17.1674997 5.87382928,20.4918664 9.91593939,21.5020963 C8.18760918,19.0069673 7.13798566,16.119686 6.87807529,13.0909091 L2.33514634,13.0909091 Z M2.33514634,10.9090909 L6.8751035,10.9090909 C7.12988231,7.89470494 8.18079774,5.00118821 9.91557751,2.49799419 C5.87364609,3.50833206 2.8045534,6.83262197 2.33514634,10.9090909 Z M22.6648537,10.9090909 C22.1954326,6.83250032 19.1261707,3.50813364 15.0840606,2.49790374 C16.8123908,4.99303266 17.8620143,7.88031403 18.1219247,10.9090909 L22.6648537,10.9090909 Z M22.6648537,13.0909091 L18.1248965,13.0909091 C17.8701177,16.1052951 16.8192023,18.9988118 15.0844225,21.5020058 C19.1263539,20.4916679 22.1954466,17.167378 22.6648537,13.0909091 Z M9.15315078,10.9090909 L15.843646,10.9090909 C15.5581939,7.94925479 14.3973512,5.12935736 12.4999751,2.78265622 C10.595448,5.13778492 9.43302782,7.96652031 9.15315078,10.9090909 Z M15.8468492,13.0909091 L9.15635402,13.0909091 C9.44180608,16.0507452 10.6026488,18.8706426 12.5000249,21.2173438 C14.404552,18.8622151 15.5669722,16.0334797 15.8468492,13.0909091 Z M12.5,24 C5.59644063,24 0,18.627417 0,12 C0,5.372583 5.59644063,0 12.5,0 C19.4035594,0 25,5.372583 25,12 C25,18.627417 19.4035594,24 12.5,24 Z",
                    id: "path-1"
                })
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("g", {
                id: "Final-Designs-",
                stroke: "none",
                strokeWidth: "1",
                fill: "none",
                fillRule: "evenodd",
                children: /*#__PURE__*/ (0, $1rY3h.jsx)("g", {
                    id: "WAC-Language-Banner-Drop-Down-Icon",
                    transform: "translate(-426.000000, -19.000000)",
                    children: /*#__PURE__*/ (0, $1rY3h.jsx)("g", {
                        id: "Alert-banner",
                        transform: "translate(-4.000000, 0.000000)",
                        children: /*#__PURE__*/ (0, $1rY3h.jsxs)("g", {
                            id: "language-globe-icon",
                            transform: "translate(430.000000, 19.000000)",
                            children: [
                                /*#__PURE__*/ (0, $1rY3h.jsx)("mask", {
                                    id: "mask-2",
                                    fill: "#ffffff",
                                    children: /*#__PURE__*/ (0, $1rY3h.jsx)("use", {
                                        xlinkHref: "#path-1"
                                    })
                                }),
                                /*#__PURE__*/ (0, $1rY3h.jsx)("g", {
                                    id: "language-globe-icon-color",
                                    mask: "url(#mask-2)",
                                    fill: color,
                                    children: /*#__PURE__*/ (0, $1rY3h.jsx)("g", {
                                        transform: "translate(-1.000000, -1.000000)",
                                        id: "Rectangle",
                                        children: /*#__PURE__*/ (0, $1rY3h.jsx)("rect", {
                                            x: "0",
                                            y: "0",
                                            width: "27.2727273",
                                            height: "26.4827586"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};

});

parcelRegister("eLh5W", function(module, exports) {


module.exports = (parcelRequire("eg86f"))((parcelRequire("bRvn3")).resolve("fGmim")).then(function() {
    return parcelRequire("iQuXN");
});

});



parcelRegister("kuuPa", function(module, exports) {
$parcel$export(module.exports, "SocialLinks", function () { return (parcelRequire("iF02n")).SocialLinks; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("iF02n")).SocialLinks; });

var $iF02n = parcelRequire("iF02n");

});
parcelRegister("iF02n", function(module, exports) {

$parcel$export(module.exports, "SocialLinks", function () { return $e2678289bce96879$export$1782e62edd12a1f5; });
/* social-links.tsx generated by @compiled/babel-plugin v0.28.2 */ 
var $1rY3h = parcelRequire("1rY3h");
parcelRequire("1Mpn7");

var $2vwrh = parcelRequire("2vwrh");
var $e2678289bce96879$var$socialLinksUrls = [
    {
        href: "https://www.facebook.com/Atlassian",
        title: "Atlassian on Facebook",
        socialImagePath: "https://wac-cdn.atlassian.com/assets/img/icons/social-icons/facebook-badge.svg"
    },
    {
        href: "https://twitter.com/atlassian",
        title: "Follow us on Twitter",
        socialImagePath: "https://wac-cdn.atlassian.com/assets/img/icons/social-icons/twitter.svg"
    },
    {
        href: "https://www.linkedin.com/company/atlassian",
        title: "Atlassian on LinkedIn",
        socialImagePath: "https://wac-cdn.atlassian.com/assets/img/icons/social-icons/linked-in.svg"
    },
    {
        href: "https://www.youtube.com/user/GoAtlassian",
        title: "Atlassian on YouTube",
        socialImagePath: "https://wac-cdn.atlassian.com/assets/img/icons/social-icons/youtube-round-gray-adg.svg"
    }
];
var $e2678289bce96879$var$socialLinksUlStyle = null;
var $e2678289bce96879$var$socialLinksLiStyle = null;
var $e2678289bce96879$var$socialAnchorStaticStyle = null;
var $e2678289bce96879$var$socialAnchorDynamicStyle = function(socialLinksUrlImage) {
    return {
        background: "url(".concat(socialLinksUrlImage, ") no-repeat scroll center center"),
        backgroundSize: "100%"
    };
};
var $e2678289bce96879$export$1782e62edd12a1f5 = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
        className: (0, $2vwrh.default)([
            "_1e0c116y",
            className
        ]),
        children: /*#__PURE__*/ (0, $1rY3h.jsx)("ul", {
            className: (0, $2vwrh.default)([
                "_1e0c1txw _2lx2vrvc _4cvr1h6o _ca0qn7od _u5f3n7od _n3tdn7od _19bvn7od _8164w1gv _19wg14y2"
            ]),
            children: $e2678289bce96879$var$socialLinksUrls.map(function(socialLinkUrl) {
                return /*#__PURE__*/ (0, $1rY3h.jsx)("li", {
                    className: (0, $2vwrh.default)([
                        "_2mzuglyw _1knel6l0 _1s4pl6l0 _165thiv4 _gltehiv4"
                    ]),
                    children: /*#__PURE__*/ (0, $1rY3h.jsx)("a", {
                        style: $e2678289bce96879$var$socialAnchorDynamicStyle(socialLinkUrl.socialImagePath),
                        href: socialLinkUrl.href,
                        title: socialLinkUrl.title,
                        className: (0, $2vwrh.default)([
                            "_syazvwuj _1wyboxwj _vwz4rrl5 _4bfu1r31 _1hmsglyw _ajmmnqa1 _1e0c1ule _azhwdzkh _1bsb1osq _4t3i1osq"
                        ])
                    })
                }, socialLinkUrl.title);
            })
        })
    });
};

});


parcelRegister("4qa8L", function(module, exports) {
$parcel$export(module.exports, "LinkWithIcon", function () { return (parcelRequire("l0ZtL")).LinkWithIcon; });
$parcel$export(module.exports, "ListOfLinks", function () { return (parcelRequire("bzS2B")).ListOfLinks; });
$parcel$export(module.exports, "ListOfLinksHeaderText", function () { return (parcelRequire("7LDiG")).ListOfLinksHeaderText; });
parcelRequire("l0ZtL");

var $bzS2B = parcelRequire("bzS2B");
parcelRequire("7LDiG");

});
parcelRegister("l0ZtL", function(module, exports) {

$parcel$export(module.exports, "LinkWithIcon", function () { return $f34a12054fab9e42$export$e67e718b4b9e91b1; });
/* link-with-icon.tsx generated by @compiled/babel-plugin v0.28.2 */ 
var $1rY3h = parcelRequire("1rY3h");
parcelRequire("1Mpn7");

var $2vwrh = parcelRequire("2vwrh");
parcelRequire("9DBuW");
var $hvst7 = parcelRequire("hvst7");
var $f34a12054fab9e42$var$linkWithIconStyle = null;
var $f34a12054fab9e42$var$linkIsUsePlainSpanTagForLinkTextClassStyle = null;
/**
 * Return a xs gray icon via iconNAme and linkText. This is specifically used for Global Nav header
 * This is not a WPL approved component, it's an one off. Do not use this anywhere else other than global nav
 * @param formatLinkTextProps
 * @returns
 */ var $f34a12054fab9e42$var$formatLinkText = function(param) {
    var isHaveIcon = param.isHaveIcon, isCustomIcon = param.isCustomIcon, iconName = param.iconName, linkText = param.linkText;
    var formatLinkStyles = [
        isHaveIcon && null,
        !isHaveIcon && null,
        null
    ];
    var linkIconDivStyle = null;
    var linkTextStyle = null;
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
        className: (0, $2vwrh.default)([
            isHaveIcon && "_6rth1bcc",
            !isHaveIcon && "_6rth14y2",
            "_lcxvglyw _1e0c1txw _4cvr1h6o"
        ]),
        children: [
            isHaveIcon && /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                className: (0, $2vwrh.default)([
                    "_4t3i1bcc _1bsb1ul9 _17521bcc"
                ]),
                children: isCustomIcon ? iconName : /*#__PURE__*/ (0, $1rY3h.jsx)((0, $hvst7.Icon), {
                    name: iconName,
                    size: "xs",
                    color: "n500"
                })
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("p", {
                className: (0, $2vwrh.default)([
                    "_1wybxjmg _vwz4bs82 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                ]),
                children: linkText
            })
        ]
    });
};
var $f34a12054fab9e42$export$e67e718b4b9e91b1 = function(param) {
    var href = param.href, type = param.type, onClick = param.onClick, className = param.className, isHaveIcon = param.isHaveIcon, isCustomIcon = param.isCustomIcon, iconName = param.iconName, linkText = param.linkText, dataUuid = param.dataUuid, dataEventContainer = param.dataEventContainer, dataEventColumn = param.dataEventColumn, dataParentLabel = param.dataParentLabel, _param_isUsePlainSpanTagForLinkText = param.isUsePlainSpanTagForLinkText, isUsePlainSpanTagForLinkText = _param_isUsePlainSpanTagForLinkText === void 0 ? false : _param_isUsePlainSpanTagForLinkText, spanLinkTextClassName = param.spanLinkTextClassName;
    return /*#__PURE__*/ (0, $1rY3h.jsx)("a", {
        className: (0, $2vwrh.default)([
            isUsePlainSpanTagForLinkText && "_4cvr1h6o _syazvwuj _4t3i1ou6 _1e0c116y _9oik1r31 _1bnx8stv _jf4cnqa1 _1up4glyw _16btglyw _1taiglyw _1axpoelr _aelyoelr _pb8z1ltp _kj55u7gi _12lvu7gi _4bfu1r31 _1hmsglyw _ajmmnqa1 _11cgyh40",
            !isUsePlainSpanTagForLinkText && "_4cvr1h6o _syazvwuj _vwz4rrl5 _4bfu1r31 _1hmsglyw _ajmmnqa1 _30l3oelr _1up4glyw _16btglyw _1taiglyw _1e0c1ule _s7n4nkob _1axpvwuj _aelyvwuj",
            className
        ]),
        href: href,
        target: type == "external" ? "_blank" : "",
        rel: type == "external" ? "noreferrer" : "",
        onClick: onClick,
        "data-event": "clicked",
        "data-uuid": dataUuid,
        "data-event-component": "linkButton",
        "data-event-container": dataEventContainer,
        "data-event-column": dataEventColumn,
        "data-parent-label": dataParentLabel,
        "data-schema-version": "1",
        children: isUsePlainSpanTagForLinkText ? /*#__PURE__*/ (0, $1rY3h.jsx)("span", {
            className: spanLinkTextClassName,
            children: linkText
        }) : $f34a12054fab9e42$var$formatLinkText({
            isHaveIcon: isHaveIcon,
            isCustomIcon: isCustomIcon,
            iconName: iconName,
            linkText: linkText
        })
    });
};

});

parcelRegister("bzS2B", function(module, exports) {

$parcel$export(module.exports, "ListOfLinks", function () { return $38c96344625b3c32$export$e9f30a544b6096f7; });
/* list-of-links.tsx generated by @compiled/babel-plugin v0.28.2 */ // @ts-ignore

var $do9pw = parcelRequire("do9pw");

var $1rY3h = parcelRequire("1rY3h");

var $2vwrh = parcelRequire("2vwrh");

var $1Mpn7 = parcelRequire("1Mpn7");

var $l0ZtL = parcelRequire("l0ZtL");

var $7LDiG = parcelRequire("7LDiG");
var $38c96344625b3c32$export$e9f30a544b6096f7 = function(param) {
    var isSideBar = param.isSideBar, headerText = param.headerText, listOfLinkWithProps = param.listOfLinkWithProps;
    var linkListContainerStyle = [
        isSideBar && null,
        !isSideBar && null
    ];
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
        className: (0, $2vwrh.default)([
            isSideBar && "_1bsb1osq _1e0c1txw _1n261g80 _2lx21bp4 _1aax1e5h _1yt4opbz _6rth19bv",
            !isSideBar && "_1bsb1osq _1e0c1txw _1n261g80 _2lx21bp4 _1aax1e5h _1yt46dbt _6rth19bv"
        ]),
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsx)((0, $7LDiG.ListOfLinksHeaderText), {
                isSideBar: isSideBar,
                headerText: headerText
            }),
            listOfLinkWithProps.map(function(listOfLinkWithProp, index) {
                var listOfLinkKey = headerText.trim().toLowerCase() + "-" + listOfLinkWithProp.linkText.trim().toLowerCase() + "-" + index.toString();
                return /*#__PURE__*/ (0, $1rY3h.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).Fragment, {
                    children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $l0ZtL.LinkWithIcon), (0, $do9pw._)({}, listOfLinkWithProp))
                }, listOfLinkKey);
            })
        ]
    });
};

});
parcelRegister("7LDiG", function(module, exports) {

$parcel$export(module.exports, "ListOfLinksHeaderText", function () { return $5111d51d3de747f6$export$4c59118dc0b93493; });
/* list-of-links-header-text.tsx generated by @compiled/babel-plugin v0.28.2 */ 
var $1rY3h = parcelRequire("1rY3h");
parcelRequire("1Mpn7");

var $2vwrh = parcelRequire("2vwrh");
var $5111d51d3de747f6$export$4c59118dc0b93493 = function(param) {
    var isSideBar = param.isSideBar, headerText = param.headerText;
    var headerTextStyle = [
        isSideBar && null,
        !isSideBar && null
    ];
    return /*#__PURE__*/ (0, $1rY3h.jsx)("h2", {
        className: (0, $2vwrh.default)([
            isSideBar && "_85i5xjmg _1q51o7ao _syazvwuj _18s815w3 _k48pbfng _1wyboxav _vwz4bs82 _1dyzt94y _1p1dangw _1bsb1osq",
            !isSideBar && "_85i5idpf _1q51idpf _syazvwuj _18s815w3 _k48pbfng _1wyboxav _vwz4bs82 _1dyzt94y _1p1dangw _1bsb1osq"
        ]),
        children: headerText.trim().toUpperCase()
    });
};

});




parcelRegister("8z0nh", function(module, exports) {

$parcel$export(module.exports, "GlobalFooterTop", function () { return $6a498c2c8245ae54$export$38e7ae23a4703911; });
/* global-footer-top.tsx generated by @compiled/babel-plugin v0.28.2 */ 
var $do9pw = parcelRequire("do9pw");

var $1rY3h = parcelRequire("1rY3h");
parcelRequire("1Mpn7");

var $2vwrh = parcelRequire("2vwrh");

var $8pPrt = parcelRequire("8pPrt");
parcelRequire("2miCy");
var $hot2Q = parcelRequire("hot2Q");

var $5ap9N = parcelRequire("5ap9N");

var $3J1nM = parcelRequire("3J1nM");
// ==================================================================
// CSS styling
// ==================================================================
var $6a498c2c8245ae54$var$containerStyle = null;
var $6a498c2c8245ae54$var$rowStyle = null;
var $6a498c2c8245ae54$export$26b6a80e48da8316 = {
    margin: "0",
    padding: "0",
    border: "0",
    fontSize: "100%",
    verticalAlign: "baseline"
};
var $6a498c2c8245ae54$export$38e7ae23a4703911 = function() {
    var intl = (0, $8pPrt.default)();
    var productsLinkList = {
        headerText: intl.formatMessage({
            id: "globalFooter.top.products",
            defaultMessage: "Products"
        }),
        listOfLinks: [
            {
                text: intl.formatMessage({
                    id: "globalFooter.top.jira-software",
                    defaultMessage: "Jira Software"
                }),
                href: (0, $hot2Q.useLocalizedHref)("/software/jira")
            },
            {
                text: intl.formatMessage({
                    id: "globalFooter.top.jira-align",
                    defaultMessage: "Jira Align"
                }),
                href: (0, $hot2Q.useLocalizedHref)("/software/jira/align")
            },
            {
                text: intl.formatMessage({
                    id: "globalFooter.top.jira-service-management",
                    defaultMessage: "Jira Service Management"
                }),
                href: (0, $hot2Q.useLocalizedHref)("/software/jira/service-management")
            },
            {
                text: intl.formatMessage({
                    id: "globalFooter.top.jira-product-discovery",
                    defaultMessage: "Jira Product Discovery"
                }),
                href: (0, $hot2Q.useLocalizedHref)("/software/jira/product-discovery")
            },
            {
                text: intl.formatMessage({
                    id: "globalFooter.top.confluence",
                    defaultMessage: "Confluence"
                }),
                href: (0, $hot2Q.useLocalizedHref)("/software/confluence")
            },
            {
                text: intl.formatMessage({
                    id: "globalFooter.top.trello",
                    defaultMessage: "Trello"
                }),
                href: "https://trello.com/home"
            },
            {
                text: intl.formatMessage({
                    id: "globalFooter.top.bitbucket",
                    defaultMessage: "Bitbucket"
                }),
                href: (0, $hot2Q.useLocalizedHref)("/software/bitbucket")
            }
        ],
        bottomViewAllLink: {
            text: intl.formatMessage({
                id: "globalFooter.top.view-all-products",
                defaultMessage: "View all products"
            }),
            href: (0, $hot2Q.useLocalizedHref)("/software"),
            bgColor: "bgWhite"
        }
    };
    var resourcesLinkList = {
        headerText: intl.formatMessage({
            id: "globalFooter.top.resources",
            defaultMessage: "Resources"
        }),
        listOfLinks: [
            {
                text: intl.formatMessage({
                    id: "globalFooter.top.technical-support",
                    defaultMessage: "Technical Support"
                }),
                href: "https://support.atlassian.com/"
            },
            {
                text: intl.formatMessage({
                    id: "globalFooter.top.purchasing-and-licensing",
                    defaultMessage: "Purchasing & licensing"
                }),
                href: (0, $hot2Q.useLocalizedHref)("/licensing/purchase-licensing")
            },
            {
                text: intl.formatMessage({
                    id: "globalFooter.top.atlassian-community",
                    defaultMessage: "Atlassian Community"
                }),
                href: "https://community.atlassian.com/"
            },
            {
                text: intl.formatMessage({
                    id: "globalFooter.top.knowledge-base",
                    defaultMessage: "Knowledge base"
                }),
                href: "https://confluence.atlassian.com/kb"
            },
            {
                text: intl.formatMessage({
                    id: "globalFooter.top.marketplace",
                    defaultMessage: "Marketplace"
                }),
                href: "https://marketplace.atlassian.com/"
            },
            {
                text: intl.formatMessage({
                    id: "globalFooter.top.my-account",
                    defaultMessage: "My Account"
                }),
                href: "https://my.atlassian.com/products/index"
            }
        ],
        bottomViewAllLink: {
            text: intl.formatMessage({
                id: "globalFooter.top.create-support-ticket",
                defaultMessage: "Create support ticket"
            }),
            href: "https://support.atlassian.com/contact/",
            bgColor: "bgWhite"
        }
    };
    var expandAndLearnLinkList = {
        headerText: intl.formatMessage({
            id: "globalFooter.top.expand-and-learn",
            defaultMessage: "Expand & Learn"
        }),
        listOfLinks: [
            {
                text: intl.formatMessage({
                    id: "globalFooter.top.partners",
                    defaultMessage: "Partners"
                }),
                href: (0, $hot2Q.useLocalizedHref)("/partners")
            },
            {
                text: intl.formatMessage({
                    id: "globalFooter.top.training-and-certification",
                    defaultMessage: "Training & Certification"
                }),
                href: (0, $hot2Q.useLocalizedHref)("/university")
            },
            {
                text: intl.formatMessage({
                    id: "globalFooter.top.documentation",
                    defaultMessage: "Documentation"
                }),
                href: "https://confluence.atlassian.com/display/ALLDOC/Atlassian+Documentation"
            },
            {
                text: intl.formatMessage({
                    id: "globalFooter.top.developer-resources",
                    defaultMessage: "Developer Resources"
                }),
                href: (0, $hot2Q.useLocalizedHref)("/developers")
            },
            {
                text: intl.formatMessage({
                    id: "globalFooter.top.enterprise-services",
                    defaultMessage: "Enterprise services"
                }),
                href: (0, $hot2Q.useLocalizedHref)("/enterprise/services")
            }
        ],
        bottomViewAllLink: {
            text: intl.formatMessage({
                id: "globalFooter.top.view-all-resources",
                defaultMessage: "View all resources"
            }),
            href: (0, $hot2Q.useLocalizedHref)("/resources"),
            bgColor: "bgWhite"
        }
    };
    var aboutAtlassianLinkList = {
        headerText: intl.formatMessage({
            id: "globalFooter.top.about-atlassian",
            defaultMessage: "About Atlassian"
        }),
        listOfLinks: [
            {
                text: intl.formatMessage({
                    id: "globalFooter.top.company",
                    defaultMessage: "Company"
                }),
                href: (0, $hot2Q.useLocalizedHref)("/company")
            },
            {
                text: intl.formatMessage({
                    id: "globalFooter.top.careers",
                    defaultMessage: "Careers"
                }),
                href: (0, $hot2Q.useLocalizedHref)("/company/careers")
            },
            {
                text: intl.formatMessage({
                    id: "globalFooter.top.events",
                    defaultMessage: "Events"
                }),
                href: (0, $hot2Q.useLocalizedHref)("/company/events")
            },
            {
                text: intl.formatMessage({
                    id: "globalFooter.top.blogs",
                    defaultMessage: "Blogs"
                }),
                href: (0, $hot2Q.useLocalizedHref)("/blog")
            },
            {
                text: intl.formatMessage({
                    id: "globalFooter.top.atlassian-foundation",
                    defaultMessage: "Atlassian Foundation"
                }),
                href: "https://www.atlassianfoundation.org/"
            },
            {
                text: intl.formatMessage({
                    id: "globalFooter.top.investor-relations",
                    defaultMessage: "Investor Relations"
                }),
                href: "https://investors.atlassian.com"
            },
            {
                text: intl.formatMessage({
                    id: "globalFooter.top.trust-and-security",
                    defaultMessage: "Trust & Security"
                }),
                href: (0, $hot2Q.useLocalizedHref)("/trust")
            }
        ],
        bottomViewAllLink: {
            text: intl.formatMessage({
                id: "globalFooter.top.contact-us",
                defaultMessage: "Contact us"
            }),
            href: (0, $hot2Q.useLocalizedHref)("/company/contact"),
            bgColor: "bgWhite"
        }
    };
    return /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
        className: (0, $2vwrh.default)([
            "_ca0qidpf _u5f3idpf _n3td7vkz _19bvidpf _kqswh2mm _12l21wug _ahbq1wug _1ul91osq _11rm1hrf _19itidpf _1wyb1osq _s7n41q9y"
        ]),
        children: /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
            className: (0, $2vwrh.default)([
                "_p12f1git _ahbq1wug _12l21wug _1e0c1txw _2lx2vrvc _1n261g80 _4cvr1y6m _ae4v1y6m"
            ]),
            children: [
                /*#__PURE__*/ (0, $1rY3h.jsx)((0, $3J1nM.LogoLinkContainer), {}),
                /*#__PURE__*/ (0, $1rY3h.jsx)((0, $5ap9N.LinkListContainer), (0, $do9pw._)({}, productsLinkList)),
                /*#__PURE__*/ (0, $1rY3h.jsx)((0, $5ap9N.LinkListContainer), (0, $do9pw._)({}, resourcesLinkList)),
                /*#__PURE__*/ (0, $1rY3h.jsx)((0, $5ap9N.LinkListContainer), (0, $do9pw._)({}, expandAndLearnLinkList)),
                /*#__PURE__*/ (0, $1rY3h.jsx)((0, $5ap9N.LinkListContainer), (0, $do9pw._)({}, aboutAtlassianLinkList))
            ]
        })
    });
};

});
parcelRegister("5ap9N", function(module, exports) {

$parcel$export(module.exports, "LinkListContainer", function () { return $1fb04945f1bf9b60$export$e07e28d16ae87608; });
/* global-footer-top-link-list-container.tsx generated by @compiled/babel-plugin v0.28.2 */ 
var $1rY3h = parcelRequire("1rY3h");
parcelRequire("1Mpn7");

var $2vwrh = parcelRequire("2vwrh");
parcelRequire("dLifx");
var $6WnuF = parcelRequire("6WnuF");
// ==================================================================
// Style Functions
// ==================================================================
var $1fb04945f1bf9b60$var$listOfLinksColumnStyle = null;
var $1fb04945f1bf9b60$var$listOfLinksUlStyle = null;
var $1fb04945f1bf9b60$var$listOfLinksUlLiStyle = null;
var $1fb04945f1bf9b60$var$listOfLinksUlLiAnchorTagStyle = null;
var $1fb04945f1bf9b60$var$listOfLinksColumnHeaderStyle = null;
var $1fb04945f1bf9b60$var$bottomViewAllLinkLiStyle = null;
var $1fb04945f1bf9b60$var$bottomViewAllLinkLiAnchorStyle = null;
var $1fb04945f1bf9b60$var$ComponentStyle = null;
var $1fb04945f1bf9b60$export$e07e28d16ae87608 = function(param) {
    var headerText = param.headerText, listOfLinks = param.listOfLinks, bottomViewAllLink = param.bottomViewAllLink;
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
        className: (0, $2vwrh.default)([
            "_1rfm1ssb _12rr1x1l _glte1jgg _kqswh2mm _1tket94y _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _19pkidpf _2hwxidpf _otyridpf _18u0idpf _19itidpf _1wyb1osq _s7n41q9y _1e0c1ule _syaz1mpp _vchhusvi"
        ]),
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                className: (0, $2vwrh.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1wyb1osq _s7n41q9y"
                ]),
                children: /*#__PURE__*/ (0, $1rY3h.jsx)("h3", {
                    className: (0, $2vwrh.default)([
                        "_1wybdlk8 _1dyzt94y _6rthgktf _1pfhidpf _syazvwuj _o10x10nf _1p1dangw _k48p1fw0 _1eglgktf _1tnt1tcg"
                    ]),
                    children: headerText.trim().toUpperCase()
                })
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                className: (0, $2vwrh.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1wyb1osq _s7n41q9y"
                ]),
                children: /*#__PURE__*/ (0, $1rY3h.jsxs)("ul", {
                    className: (0, $2vwrh.default)([
                        "_lswumhro _6rthidpf _2mzu1wth _bozggktf _qtt8glyw"
                    ]),
                    children: [
                        listOfLinks.map(function(listOfLink) {
                            return /*#__PURE__*/ (0, $1rY3h.jsx)("li", {
                                className: (0, $2vwrh.default)([
                                    "_6rthidpf _2mzuglyw _ahbq1fm0 _syaz1kw7 _1wyb1j6v _vwz4bs82"
                                ]),
                                children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $6WnuF.Link), {
                                    text: listOfLink.text,
                                    href: listOfLink.href,
                                    type: "anchor",
                                    customLinkColor: "#42526e",
                                    bgColor: listOfLink.bgColor,
                                    onClick: listOfLink.onClick,
                                    className: (0, $2vwrh.default)([
                                        "_syazvwuj _1wyboxwj _vwz4rrl5 _4bfu1r31 _1hmsglyw _ajmmnqa1 _s7n41q9y _9oik1r31 _1bnx8stv _jf4cnqa1 _1up4glyw _16btglyw _1taiglyw",
                                        listOfLink.className
                                    ])
                                })
                            }, listOfLink.text.trim().replace(" ", "-"));
                        }),
                        /*#__PURE__*/ (0, $1rY3h.jsx)("li", {
                            className: (0, $2vwrh.default)([
                                "_1pfh7vkz _6rthidpf _2mzuglyw _ahbq1fm0 _syaz1kw7 _1wyb1j6v _vwz4bs82"
                            ]),
                            children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $6WnuF.Link), {
                                text: bottomViewAllLink.text,
                                href: bottomViewAllLink.href,
                                type: "anchor",
                                customLinkColor: bottomViewAllLink.customLinkColor,
                                bgColor: bottomViewAllLink.bgColor,
                                onClick: bottomViewAllLink.onClick,
                                className: (0, $2vwrh.default)([
                                    "_syazrbzz _1wyboxwj _vwz4rrl5 _4bfu1r31 _1hmsglyw _ajmmnqa1 _s7n41q9y _1a3b1r31 _9oik1r31 _1ydc1r31 _4fpr8stv _1bnx8stv _1x288stv _5goinqa1 _jf4cnqa1 _1726nqa1",
                                    bottomViewAllLink.className
                                ])
                            })
                        }, bottomViewAllLink.text.trim().replace(" ", "-"))
                    ]
                })
            })
        ]
    });
};

});

parcelRegister("3J1nM", function(module, exports) {

$parcel$export(module.exports, "LogoLinkContainer", function () { return $8853e1d736caf7ce$export$8a742823b1bccd90; });
/* global-footer-top-logo.tsx generated by @compiled/babel-plugin v0.28.2 */ 
var $1rY3h = parcelRequire("1rY3h");
parcelRequire("1Mpn7");

var $2vwrh = parcelRequire("2vwrh");
parcelRequire("9DBuW");
var $l227w = parcelRequire("l227w");
// ==================================================================
// Style Functions
// ==================================================================
var $8853e1d736caf7ce$var$logoColumnStyle = null;
var $8853e1d736caf7ce$var$logoColumnAnchorTagStyle = null;
var $8853e1d736caf7ce$var$ComponentStyle = null;
var $8853e1d736caf7ce$export$8a742823b1bccd90 = function() {
    var href = "/wac";
    //TODO: Figure out data event values
    var dataEvent = "some-random-data-event";
    var dataUuid = "some-random-data-uuid";
    var dataEventComponent = "some-random-data-event-component";
    var dataEventContainer = "some-random-data-event-container";
    var dataSchemaVersion = "1";
    return /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
        className: (0, $2vwrh.default)([
            "_19itidpf _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _3l1a1abu _glte1jgg _13wnh2mm _1945t94y _1s4p1osq"
        ]),
        children: /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
            className: (0, $2vwrh.default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1wyb1osq _s7n41q9y"
            ]),
            children: /*#__PURE__*/ (0, $1rY3h.jsx)("a", {
                href: href,
                "data-event": dataEvent,
                "data-uuid": dataUuid,
                "data-event-component": dataEventComponent,
                "data-event-container": dataEventContainer,
                "data-schema-version": dataSchemaVersion,
                className: (0, $2vwrh.default)([
                    "_syazvwuj _1wyboxwj _vwz4rrl5 _4bfu1r31 _1hmsglyw _ajmmnqa1 _6rthidpf _1e0c1ule _s7n41q9y _w8l5176v _17521wug _nn40glyw _1i4x7vkz _z239yfq0 _4x201osq"
                ]),
                children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $l227w.Logo), {
                    brand: "atlassian",
                    type: "logo",
                    appearance: "neutral"
                })
            })
        })
    });
};

});




parcelRegister("hmyWO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e9ce087d622abbb$export$2e2bcd8739ae039; });
/* index.tsx generated by @compiled/babel-plugin v0.28.2 */ /* eslint-disable jsx-a11y/anchor-is-valid */ 
var $cv9Rk = parcelRequire("cv9Rk");

var $1rY3h = parcelRequire("1rY3h");

var $2vwrh = parcelRequire("2vwrh");

var $1Mpn7 = parcelRequire("1Mpn7");

var $8pPrt = parcelRequire("8pPrt");

var $h9oax = parcelRequire("h9oax");

var $55ftS = parcelRequire("55ftS");

var $1bWwP = parcelRequire("1bWwP");

var $g8DvY = parcelRequire("g8DvY");

var $lQiSD = parcelRequire("lQiSD");

var $coBSS = parcelRequire("coBSS");

var $jpiYS = parcelRequire("jpiYS");
parcelRequire("du32H");
var $b146G = parcelRequire("b146G");
parcelRequire("2miCy");
var $hot2Q = parcelRequire("hot2Q");

var $2Pnqs = parcelRequire("2Pnqs");
parcelRequire("220RR");
var $iAbbD = parcelRequire("iAbbD");
parcelRequire("2pMYh");
var $7psCn = parcelRequire("7psCn");
parcelRequire("izRo7");
var $4zflm = parcelRequire("4zflm");
parcelRequire("iH8wz");
var $hR975 = parcelRequire("hR975");
parcelRequire("9DBuW");
var $l227w = parcelRequire("l227w");

var $af5n8 = parcelRequire("af5n8");

var $gowpE = parcelRequire("gowpE");

var $i0Zmt = parcelRequire("i0Zmt");

var $gPANu = parcelRequire("gPANu");

var $7e9ce087d622abbb$var$WacAppSwitcher = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).lazy(function() {
    return(// without the line ts-ignored below TSC throws this error:
    // "Relative import paths need explicit file extensions in EcmaScript imports when '--moduleResolution' is 'node16' or 'nodenext'. Did you mean '../../../components/global-nav/app-switcher/src/index.js'?"
    // the file of course ends in .tsx, when you try to add that there is a different error:
    // "An import path can only end with a '.tsx' extension when 'allowImportingTsExtensions' is enabled."
    // @ts-ignore
    (parcelRequire("3xTws")).then(function(module) {
        return {
            default: module.WacAppSwitcher
        };
    }));
});
var $7e9ce087d622abbb$var$navigationBarWrapperCss = null;
var $7e9ce087d622abbb$var$navigationBarCss = null;
var $7e9ce087d622abbb$var$logoWrapperCss = null;
var $7e9ce087d622abbb$var$logoLinkWrapperCss = null;
var $7e9ce087d622abbb$var$mobileTitleWrapperCss = null;
var $7e9ce087d622abbb$var$categoriesWrapperCss = null;
var $7e9ce087d622abbb$var$categoryArrowDownCss = null;
var $7e9ce087d622abbb$var$categoryArrowRightCss = null;
var $7e9ce087d622abbb$var$dropdownSlideDownAnimation = null;
var $7e9ce087d622abbb$var$dropdownSlideUpAnimation = null;
var $7e9ce087d622abbb$var$searchWrapperCss = null;
var $7e9ce087d622abbb$var$actionsWrapperCss = null;
var $7e9ce087d622abbb$var$menuButtonCss = null;
var $7e9ce087d622abbb$var$tryNowCss = null;
var $7e9ce087d622abbb$var$switcherDividerCss = null;
var $7e9ce087d622abbb$var$cartButtonCss = null;
var $7e9ce087d622abbb$var$mobileMenuToggleCss = null;
var $7e9ce087d622abbb$var$closeMenuCss = null;
var $7e9ce087d622abbb$var$pageBlurCss = null;
// eslint-disable-next-line complexity
var $7e9ce087d622abbb$var$GlobalNav = function(props) {
    var intl = (0, $8pPrt.default)();
    var navigationDropdowns = [
        {
            key: "products",
            title: intl.formatMessage({
                id: "wacGlobalNavigation.category.products",
                defaultMessage: "Products"
            }),
            content: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $iAbbD.DropdownLayout), {
                main: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $gowpE.ProductsMain), {
                    productKey: props.productKey
                }),
                sidebar: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $gowpE.ProductsSideBar), {
                    productKey: props.productKey
                })
            })
        },
        {
            key: "solutions",
            title: intl.formatMessage({
                id: "wacGlobalNavigation.category.solutions",
                defaultMessage: "Solutions"
            }),
            content: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $iAbbD.DropdownLayout), {
                main: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $gPANu.SolutionsMain), {
                    productKey: props.productKey
                }),
                sidebar: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $gPANu.SolutionsSideBar), {
                    productKey: props.productKey
                })
            })
        },
        {
            key: "resources",
            title: intl.formatMessage({
                id: "wacGlobalNavigation.category.resources",
                defaultMessage: "Resources"
            }),
            content: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $iAbbD.DropdownLayout), {
                main: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $i0Zmt.ResourcesMain), {
                    productKey: props.productKey
                }),
                sidebar: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $i0Zmt.ResourcesSideBar), {
                    productKey: props.productKey
                })
            })
        }
    ];
    var _useState = (0, $cv9Rk._)((0, $1Mpn7.useState)(false), 2), showMenu = _useState[0], setShowMenu = _useState[1];
    var _useState1 = (0, $cv9Rk._)((0, $1Mpn7.useState)(null), 2), activeDropdown = _useState1[0], setActiveDropdown = _useState1[1];
    var _useState2 = (0, $cv9Rk._)((0, $1Mpn7.useState)(false), 2), activePageBlur = _useState2[0], setActivePageBlur = _useState2[1];
    var _useState3 = (0, $cv9Rk._)((0, $1Mpn7.useState)(true), 2), activeDownAnimation = _useState3[0], setActiveDownAnimation = _useState3[1];
    var _useState4 = (0, $cv9Rk._)((0, $1Mpn7.useState)(false), 2), activeUpAnimation = _useState4[0], setActiveUpAnimation = _useState4[1];
    var _useState5 = (0, $cv9Rk._)((0, $1Mpn7.useState)(false), 2), isSearchOpen = _useState5[0], setIsSearchOpen = _useState5[1];
    (0, $1Mpn7.useEffect)(function() {
        (0, $2Pnqs.Initializer).autoTrack();
    }, [
        showMenu,
        activeDropdown,
        isSearchOpen
    ]);
    function dismissMenu() {
        setActiveUpAnimation(true);
        setActiveDownAnimation(false);
        setTimeout(function() {
            setActivePageBlur(false);
            setShowMenu(false);
            setActiveDropdown(null);
        }, 300);
    }
    var escFunction = (0, $1Mpn7.useCallback)(function(event) {
        if (event.key === "Escape" && (showMenu || isSearchOpen)) {
            dismissMenu();
            setIsSearchOpen(false);
        }
    }, [
        isSearchOpen,
        showMenu
    ]);
    (0, $1Mpn7.useEffect)(function() {
        document.addEventListener("keydown", escFunction, false);
        return function() {
            document.removeEventListener("keydown", escFunction, false);
        };
    }, [
        escFunction
    ]);
    /* TODO: Implement setIsUserLoggedIn, user logged in status (in useEffect), once GWP-51 in implemented  */ var isUserLoggedIn = (0, $af5n8.useLoggedInUser)().isUserLoggedIn;
    var navigationWrapperClassName = "".concat(activeDropdown ? "categoryActive" : "", " ").concat(showMenu ? "showMenu" : "", " ").concat(activePageBlur ? "showPageBlur" : "");
    var toggleDropdown = function(dropdownData) {
        setIsSearchOpen(false);
        if (activeDropdown && activeDropdown.key === dropdownData.key) {
            dismissMenu();
            return;
        } else if (activeDropdown) {
            setActiveDownAnimation(false);
            setActiveUpAnimation(false);
            setActiveDropdown(dropdownData);
            return;
        }
        setActivePageBlur(true);
        setActiveDownAnimation(true);
        setActiveUpAnimation(false);
        setShowMenu(true);
        setActiveDropdown(dropdownData);
    };
    // This is an A/A test - we don't actually do anything differently based on cohort, we just want the exposure
    (0, (/*@__PURE__*/$parcel$interopDefault($coBSS))).getExperiment(// https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/wac-uip-global-nav-try-now-aa-test/setup
    "wac-uip-global-nav-try-now-aa-test");
    (0, (/*@__PURE__*/$parcel$interopDefault($coBSS))).getExperiment(//  https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/growth_aa_educational/setup
    "growth_aa_educational");
    var dropdownWrapperCss = [
        !activeUpAnimation && null,
        !activeDownAnimation && null,
        activeUpAnimation && null,
        activeDownAnimation && null
    ];
    var scrollFunction = (0, $1Mpn7.useCallback)(function() {
        if (window.innerWidth > 1024) {
            if (showMenu || isSearchOpen) {
                dismissMenu();
                setIsSearchOpen(false);
            }
        }
    }, [
        showMenu,
        isSearchOpen,
        dismissMenu
    ]);
    (0, $1Mpn7.useEffect)(function() {
        window.addEventListener("wheel", scrollFunction);
        return function() {
            window.removeEventListener("wheel", scrollFunction);
        };
    }, [
        scrollFunction,
        showMenu
    ]);
    return /*#__PURE__*/ (0, $1rY3h.jsx)((0, $jpiYS.default), {
        name: "global-nav",
        children: /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
            className: navigationWrapperClassName,
            children: [
                showMenu,
                /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                    style: {
                        backgroundColor: !showMenu && props.color ? props.color : "#ffffff"
                    },
                    className: (0, $2vwrh.default)([
                        "_4cvr1y6m _bfhku67f _1e0c1txw _2lx2vrvc _1bah1h6o _kqswh2mm _1pbyqfx8 _11d91hxd _1b5l1kxc _1ekj1wug _ll9f1wug _dqxp1n9t _12rsidpf _qqgo1osq"
                    ]),
                    children: /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
                        className: (0, $2vwrh.default)([
                            "_4cvr1h6o _1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _2lx2vrvc _1yt4z5p3 _165tt9kd _10jx1fra _1kne8vuz _z115h2mm _a6fgkb7n"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                                className: (0, $2vwrh.default)([
                                    "_1e0c1txw _4cvr1h6o _1s4p1osq _1hx3idpf"
                                ]),
                                children: /*#__PURE__*/ (0, $1rY3h.jsx)("a", {
                                    href: (0, $hot2Q.useLocalizedHref)("/"),
                                    "aria-label": intl.formatMessage({
                                        id: "wacGlobalNavigation.logo-label",
                                        defaultMessage: "Atlassian logo"
                                    }),
                                    "data-event": "clicked",
                                    "data-event-component": "linkButton",
                                    "data-event-container": "globalNavWac",
                                    "data-product-key": "jiraSoftware",
                                    className: (0, $2vwrh.default)([
                                        "_1e0c1txw _zbji1wug _5fdi4h73 _1hn86vh0 _17jm9jx3 _108gidpf _1sjd1crf"
                                    ]),
                                    children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $l227w.Logo), {
                                        brand: "atlassian",
                                        type: "logo",
                                        appearance: "brand"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                                className: (0, $2vwrh.default)([
                                    "_1e0cglyw _1bsb1n8h _dh1a1h6o _1mjb1txw _1kne1osq _101fidpf _qbe9glyw _z115stnw _16mqidpf _3xct17vy _rqkd1auz _1hx3kb7n _vjhb1wug _b3ezsqz4 _ohpy1h6o _xeiqvwuj _qgiv1txw _tkq91cby _1en51nn1 _pzii1r31 _182jglyw _k6s3nqa1"
                                ]),
                                children: /*#__PURE__*/ (0, $1rY3h.jsxs)("a", {
                                    href: "#",
                                    "aria-label": intl.formatMessage({
                                        id: "wacGlobalNavigation.mobile-title-return",
                                        defaultMessage: "Return to categories menu"
                                    }),
                                    onClick: function(e) {
                                        e.preventDefault();
                                        setActiveDropdown(null);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $1rY3h.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($55ftS))), {
                                            label: ""
                                        }),
                                        " ",
                                        activeDropdown && activeDropdown.title
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)("ul", {
                                className: (0, $2vwrh.default)([
                                    "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _2lx2vrvc _qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1eb71h6o _v5iivwuj _1du41txw _kv1z1r31 _norkglyw _ojh8nqa1 _3l1a1eps _oe5v1l7b _1h021fcb _1phzoxav _16at1r31 _159kglyw _1ma0nqa1 _1wdeyh40 _x3exj1oc _1t8xj1oc _tnv2u67f _1mjbglyw _na0i1bp4 _1iye1m6u _3xct161g _rqkd4h09 _vug31ei3 _1qob1cby _p5qc1nn1 _1bjzckbl _18x3z5p3 _1sivj1oc _xbip1txw _ehb9idpf _dqxpstnw _12rs15ob _qqgo1osq _b3ezvpi3"
                                ]),
                                children: !props.isHideNavigationDropdowns && navigationDropdowns.map(function(dropdownData) {
                                    return /*#__PURE__*/ (0, $1rY3h.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0, $1rY3h.jsxs)("a", {
                                                href: "#",
                                                onClick: function(e) {
                                                    e.preventDefault();
                                                    toggleDropdown(dropdownData);
                                                },
                                                "data-event": "clicked",
                                                "data-event-component": "linkButton",
                                                "data-event-container": "headerDropdownLink",
                                                "data-product-key": "jiraSoftware",
                                                children: [
                                                    dropdownData.title,
                                                    /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                                                        className: (0, $2vwrh.default)([
                                                            "_1e0c1ule _syazrbzz _4t3i1tcg _1mjbglyw"
                                                        ]),
                                                        children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($h9oax))), {
                                                            label: ""
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                                                        className: (0, $2vwrh.default)([
                                                            "_1e0cglyw _7w28vwuj _1mjb1txw _si80f6fq _z115h2mm _16mqyh40 _rulpdlk8"
                                                        ]),
                                                        children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1bWwP))), {
                                                            label: ""
                                                        })
                                                    })
                                                ]
                                            }),
                                            activeDropdown && dropdownData.key === activeDropdown.key && /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                                                className: (0, $2vwrh.default)([
                                                    !activeUpAnimation && "_1reo15vq _18m915vq _kqswstnw _bfhku67f _1bsb1osq _bbxw136u _scbp1m19 _1190idpf _180k1osq _nqop1osq _6ssjz5p3 _z115stnw _16mqidpf",
                                                    !activeDownAnimation && "_1reo15vq _18m915vq _kqswstnw _bfhku67f _1bsb1osq _bbxw136u _scbp1m19 _1190idpf _180k1osq _nqop1osq _6ssjz5p3 _z115stnw _16mqidpf",
                                                    activeUpAnimation && "",
                                                    activeUpAnimation && "_b2rh1p0w _hyzq1ial _1reo15vq _18m915vq _kqswstnw _bfhku67f _1bsb1osq _bbxw136u _scbp1m19 _1190idpf _180k1osq _nqop1osq _6ssjz5p3 _z115stnw _16mqidpf",
                                                    activeDownAnimation && "",
                                                    activeDownAnimation && "_b2rhbuqt _hyzq1ial _1reo15vq _18m915vq _kqswstnw _bfhku67f _1bsb1osq _bbxw136u _scbp1m19 _1190idpf _180k1osq _nqop1osq _6ssjz5p3 _z115stnw _16mqidpf"
                                                ]),
                                                children: activeDropdown.content
                                            })
                                        ]
                                    }, dropdownData.key);
                                })
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                                className: (0, $2vwrh.default)([
                                    "_1e0c1txw _xbipglyw"
                                ]),
                                children: /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $7psCn.Search), {
                                        isOpen: isSearchOpen,
                                        openSearch: function() {
                                            setIsSearchOpen(true);
                                            dismissMenu();
                                        },
                                        closeSearch: function() {
                                            return setIsSearchOpen(false);
                                        }
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsxs)("ul", {
                                className: (0, $2vwrh.default)([
                                    "_4cvr1h6o _1e0c1txw _2lx2vrvc _qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _196g1ei3 _1mjbglyw _11d9u67f _xbip1txw _1b5l1osq _ehb9idpf _dqxpstnw _12rs1osq _qqgo1osq _1od5kb7n _l59wkb7n _1ezgf1ug _1vdqxjmg _5l7qxjmg _1b5n1h6o _6v7r1txw _1ht2vrvc _1qwe1crf"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $1rY3h.jsx)("li", {
                                        className: (0, $2vwrh.default)([
                                            "_bpspbfng"
                                        ]),
                                        children: props.showTryNow && /*#__PURE__*/ (0, $1rY3h.jsx)((0, $hR975.Button), {
                                            text: intl.formatMessage({
                                                id: "wacGlobalNavigation.try-now-button-label",
                                                defaultMessage: "Try Now"
                                            }),
                                            // eslint-disable-next-line react-hooks/rules-of-hooks
                                            url: (0, $hot2Q.useLocalizedHref)("/try"),
                                            size: "small",
                                            dataEventProps: {
                                                "data-product-key": props.productKey,
                                                "data-event": "clicked",
                                                "data-event-component": "linkButton",
                                                "data-event-container": "navbar"
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $1rY3h.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                                                className: (0, $2vwrh.default)([
                                                    "_191w1jv8 _1bsbt94y _4t3i1tcg _12l21eps _1mjbglyw"
                                                ])
                                            }),
                                            isUserLoggedIn && /*#__PURE__*/ (0, $1rY3h.jsx)((0, $1Mpn7.Suspense), {
                                                children: /*#__PURE__*/ (0, $1rY3h.jsx)($7e9ce087d622abbb$var$WacAppSwitcher, {
                                                    allowJoinSitesProvider: true,
                                                    appSwitcherLabel: intl.formatMessage({
                                                        id: "wacGlobalNavigation.app-switcher-my-products",
                                                        defaultMessage: "My products"
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $1rY3h.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $4zflm.GlobalNavUserProfile), {})
                                    }),
                                    /*#__PURE__*/ (0, $1rY3h.jsx)("li", {
                                        className: (0, $2vwrh.default)([
                                            "_bozggrf3 _tiurgktf _k8em1ul9 _nvsuftgi _13wuh2mm _1ceaidpf _1lm8idpf _1jqgidpf _xfocidpf _19rlidpf _uirfidpf"
                                        ]),
                                        children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $b146G.default), {
                                            version: 0,
                                            fields: {}
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                                className: (0, $2vwrh.default)([
                                    "_1e0cglyw _1mjb1ule _19ekckbl _rulpckbl"
                                ]),
                                children: /*#__PURE__*/ (0, $1rY3h.jsx)("a", {
                                    href: "#",
                                    "aria-label": intl.formatMessage({
                                        id: "wacGlobalNavigation.menu-icon.toggle",
                                        defaultMessage: "Toggle Menu"
                                    }),
                                    onClick: function(e) {
                                        e.preventDefault();
                                        if (showMenu) setActiveDropdown(null);
                                        setShowMenu(!showMenu);
                                        setIsSearchOpen(false);
                                    },
                                    className: (0, $2vwrh.default)([
                                        "_1e0c1txw _1bah1h6o _bozg1j6v"
                                    ]),
                                    children: showMenu ? /*#__PURE__*/ (0, $1rY3h.jsx)("a", {
                                        onKeyDown: dismissMenu,
                                        onClick: dismissMenu,
                                        "aria-label": intl.formatMessage({
                                            id: "wacGlobalNavigation.menu-icon.close-link",
                                            defaultMessage: "Toggle Menu"
                                        }),
                                        className: (0, $2vwrh.default)([
                                            "_1e6zftgi _z115h2mm _a6fgkb7n _1e371n67 _19ekzwfg _rulpzwfg"
                                        ]),
                                        children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g8DvY))), {
                                            label: intl.formatMessage({
                                                id: "wacGlobalNavigation.menu-icon.close",
                                                defaultMessage: "Close Menu"
                                            })
                                        })
                                    }) : /*#__PURE__*/ (0, $1rY3h.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lQiSD))), {
                                        primaryColor: "#64686f",
                                        label: intl.formatMessage({
                                            id: "wacGlobalNavigation.menu-icon.open",
                                            defaultMessage: "Open Menu"
                                        })
                                    })
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $1rY3h.jsx)("button", {
                    "aria-hidden": "true",
                    "data-event": "clicked",
                    onClick: dismissMenu,
                    className: (0, $2vwrh.default)([
                        "_1e0cglyw _19itglyw _uo2l1l0i _1v4tidpf _1k8nf705 _1m8s1ule _1jpmidpf _1n0ystnw _45s3idpf _70nx1osq _19bakb7n"
                    ])
                })
            ]
        })
    });
};
$7e9ce087d622abbb$var$GlobalNav.displayName = "GlobalNav";
var $7e9ce087d622abbb$export$2e2bcd8739ae039 = $7e9ce087d622abbb$var$GlobalNav;

});
parcelRegister("h9oax", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0338df1234c39387$var$_react = $0338df1234c39387$var$_interopRequireDefault((parcelRequire("1Mpn7")));

var $cotNw = parcelRequire("cotNw");
function $0338df1234c39387$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $0338df1234c39387$var$ChevronDownIcon = function(props) {
    return /*#__PURE__*/ $0338df1234c39387$var$_react.default.createElement($cotNw.Icon, Object.assign({
        dangerouslySetGlyph: '<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M8.292 10.293a1.009 1.009 0 000 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 000-1.419.987.987 0 00-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 00-1.406 0z" fill="currentColor" fill-rule="evenodd"/></svg>'
    }, props));
};
$0338df1234c39387$var$ChevronDownIcon.displayName = "ChevronDownIcon";
var $0338df1234c39387$var$_default = $0338df1234c39387$var$ChevronDownIcon;
module.exports.default = $0338df1234c39387$var$_default;

});
parcelRegister("cotNw", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $905ed71d4efc38d5$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $905ed71d4efc38d5$export$2e2bcd8739ae039; });

var $fjkYW = parcelRequire("fjkYW");

var $jjExS = parcelRequire("jjExS");

var $1Mpn7 = parcelRequire("1Mpn7");

var $fBy54 = parcelRequire("fBy54");

var $fGZWg = parcelRequire("fGZWg");

var $jp9Gu = parcelRequire("jp9Gu");

var $69WLm = parcelRequire("69WLm");
function $905ed71d4efc38d5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $905ed71d4efc38d5$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $905ed71d4efc38d5$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $905ed71d4efc38d5$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $905ed71d4efc38d5$var$iconStyles = (0, $fBy54.css)({
    display: "inline-block",
    flexShrink: 0,
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "> svg": $905ed71d4efc38d5$var$_objectSpread($905ed71d4efc38d5$var$_objectSpread({}, (0, $69WLm.commonSVGStyles)), {}, {
        maxWidth: "100%",
        maxHeight: "100%",
        color: "var(--icon-primary-color)",
        fill: "var(--icon-secondary-color)",
        verticalAlign: "bottom"
    })
});
/**
 * For windows high contrast mode
 */ var $905ed71d4efc38d5$var$baseHcmStyles = (0, $fBy54.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "> svg": {
            filter: "grayscale(1)",
            "--icon-primary-color": "CanvasText",
            // foreground
            "--icon-secondary-color": "Canvas" // background
        }
    }
});
var $905ed71d4efc38d5$var$primaryEqualsSecondaryHcmStyles = (0, $fBy54.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "> svg": {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            "--icon-primary-color": "Canvas" // foreground
        }
    }
});
var $905ed71d4efc38d5$var$secondaryTransparentHcmStyles = (0, $fBy54.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "> svg": {
            "--icon-secondary-color": "transparent" // background
        }
    }
});
var $905ed71d4efc38d5$export$f04a61298a47a40f = /*#__PURE__*/ (0, $1Mpn7.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $fBy54.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $69WLm.getIconSize)({
        width: width,
        height: height,
        size: size
    });
    var _useGlobalTheme = (0, $fGZWg.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    return (0, $fBy54.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($fjkYW)))({
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            "--icon-primary-color": primaryColor,
            "--icon-secondary-color": secondaryColor || (0, $jp9Gu.getBackground)(mode)
        }
    }, glyphProps, {
        css: [
            $905ed71d4efc38d5$var$iconStyles,
            $905ed71d4efc38d5$var$baseHcmStyles,
            primaryColor === secondaryColor && $905ed71d4efc38d5$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === "transparent" && $905ed71d4efc38d5$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsualting them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            (0, $fBy54.css)({
                width: dimensions.width,
                height: dimensions.height,
                "> svg": dimensions
            })
        ]
    }));
});
var $905ed71d4efc38d5$export$2e2bcd8739ae039 = $905ed71d4efc38d5$export$f04a61298a47a40f;

});
parcelRegister("fGZWg", function(module, exports) {

$parcel$export(module.exports, "useGlobalTheme", function () { return $b6cad301a6da3d15$export$7692396083754928; });

var $dH7ik = parcelRequire("dH7ik");
// Create default global light theme
var $b6cad301a6da3d15$var$_createTheme = (0, $dH7ik.createTheme)(function() {
    return {
        mode: "light"
    };
}), $b6cad301a6da3d15$var$Provider = $b6cad301a6da3d15$var$_createTheme.Provider, $b6cad301a6da3d15$var$Consumer = $b6cad301a6da3d15$var$_createTheme.Consumer, $b6cad301a6da3d15$export$7692396083754928 = $b6cad301a6da3d15$var$_createTheme.useTheme;
var $b6cad301a6da3d15$export$2e2bcd8739ae039 = {
    Provider: $b6cad301a6da3d15$var$Provider,
    Consumer: $b6cad301a6da3d15$var$Consumer
};

});
parcelRegister("dH7ik", function(module, exports) {

$parcel$export(module.exports, "createTheme", function () { return $9f84f313c73a02b8$export$25d302a5b900a763; });

var $04Kcc = parcelRequire("04Kcc");

var $1Mpn7 = parcelRequire("1Mpn7");
var $9f84f313c73a02b8$var$_excluded = [
    "children"
];
function $9f84f313c73a02b8$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $1Mpn7.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $1Mpn7.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, (/*@__PURE__*/$parcel$interopDefault($04Kcc)))(props, $9f84f313c73a02b8$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $1Mpn7.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $1Mpn7.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});


parcelRegister("jp9Gu", function(module, exports) {

$parcel$export(module.exports, "getBackground", function () { return $e207dd3a7efbbd3b$export$18cb9425622d4e06; });
var $e207dd3a7efbbd3b$var$themedBackground = {
    light: "var(--ds-surface, #FFFFFF)",
    dark: "var(--ds-surface, #1B2638)"
};
var $e207dd3a7efbbd3b$export$18cb9425622d4e06 = function getBackground() {
    var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "light";
    return $e207dd3a7efbbd3b$var$themedBackground[mode];
};

});

parcelRegister("69WLm", function(module, exports) {

$parcel$export(module.exports, "commonSVGStyles", function () { return $47c12a6939d4688d$export$16374db1c3e6dfba; });
$parcel$export(module.exports, "sizeStyleMap", function () { return $47c12a6939d4688d$export$ef0ad74202575b64; });
$parcel$export(module.exports, "getIconSize", function () { return $47c12a6939d4688d$export$3eb7d6130acfda37; });

var $3eQdW = parcelRequire("3eQdW");

var $fBy54 = parcelRequire("fBy54");
var $47c12a6939d4688d$export$16374db1c3e6dfba = {
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: "currentColor"
    }
};
var $47c12a6939d4688d$var$smallStyles = (0, $fBy54.css)((0, $3eQdW.dimensions).small);
var $47c12a6939d4688d$var$mediumStyles = (0, $fBy54.css)((0, $3eQdW.dimensions).medium);
var $47c12a6939d4688d$var$largeStyles = (0, $fBy54.css)((0, $3eQdW.dimensions).large);
var $47c12a6939d4688d$var$xlargeStyles = (0, $fBy54.css)((0, $3eQdW.dimensions).xlarge);
var $47c12a6939d4688d$export$ef0ad74202575b64 = {
    small: $47c12a6939d4688d$var$smallStyles,
    medium: $47c12a6939d4688d$var$mediumStyles,
    large: $47c12a6939d4688d$var$largeStyles,
    xlarge: $47c12a6939d4688d$var$xlargeStyles
};
var $47c12a6939d4688d$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $3eQdW.dimensions)[size];
    return undefined;
};

});
parcelRegister("3eQdW", function(module, exports) {

$parcel$export(module.exports, "dimensions", function () { return $25bb307ff42ee629$export$62ad7b0c781000e9; });
var $25bb307ff42ee629$export$c647cb0ee6e282fe = {
    small: "16px",
    medium: "24px",
    large: "32px",
    xlarge: "48px"
};
var $25bb307ff42ee629$export$7bd66fc94c81bf84 = {
    small: "small",
    medium: "medium",
    large: "large",
    xlarge: "xlarge"
};
var $25bb307ff42ee629$export$62ad7b0c781000e9 = {
    small: {
        width: $25bb307ff42ee629$export$c647cb0ee6e282fe.small,
        height: $25bb307ff42ee629$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $25bb307ff42ee629$export$c647cb0ee6e282fe.medium,
        height: $25bb307ff42ee629$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $25bb307ff42ee629$export$c647cb0ee6e282fe.large,
        height: $25bb307ff42ee629$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $25bb307ff42ee629$export$c647cb0ee6e282fe.xlarge,
        height: $25bb307ff42ee629$export$c647cb0ee6e282fe.xlarge
    }
};

});




parcelRegister("55ftS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3b396d894785a6c9$var$_react = $3b396d894785a6c9$var$_interopRequireDefault((parcelRequire("1Mpn7")));

var $cotNw = parcelRequire("cotNw");
function $3b396d894785a6c9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $3b396d894785a6c9$var$ChevronLeftLargeIcon = function(props) {
    return /*#__PURE__*/ $3b396d894785a6c9$var$_react.default.createElement($cotNw.Icon, Object.assign({
        dangerouslySetGlyph: '<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" fill-rule="evenodd" d="M9.005 10.995l4.593-4.593a.99.99 0 111.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 01-1.4 1.4L9.005 12.41a1 1 0 010-1.414z"/></svg>'
    }, props));
};
$3b396d894785a6c9$var$ChevronLeftLargeIcon.displayName = "ChevronLeftLargeIcon";
var $3b396d894785a6c9$var$_default = $3b396d894785a6c9$var$ChevronLeftLargeIcon;
module.exports.default = $3b396d894785a6c9$var$_default;

});

parcelRegister("1bWwP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0de43812f74f1570$var$_react = $0de43812f74f1570$var$_interopRequireDefault((parcelRequire("1Mpn7")));

var $cotNw = parcelRequire("cotNw");
function $0de43812f74f1570$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $0de43812f74f1570$var$ChevronRightLargeIcon = function(props) {
    return /*#__PURE__*/ $0de43812f74f1570$var$_react.default.createElement($cotNw.Icon, Object.assign({
        dangerouslySetGlyph: '<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 010 1.414l-4.593 4.593a.99.99 0 01-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 011.4-1.4l4.593 4.593z"/></svg>'
    }, props));
};
$0de43812f74f1570$var$ChevronRightLargeIcon.displayName = "ChevronRightLargeIcon";
var $0de43812f74f1570$var$_default = $0de43812f74f1570$var$ChevronRightLargeIcon;
module.exports.default = $0de43812f74f1570$var$_default;

});

parcelRegister("g8DvY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bbfc0b8053d89c1c$var$_react = $bbfc0b8053d89c1c$var$_interopRequireDefault((parcelRequire("1Mpn7")));

var $cotNw = parcelRequire("cotNw");
function $bbfc0b8053d89c1c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $bbfc0b8053d89c1c$var$CrossIcon = function(props) {
    return /*#__PURE__*/ $bbfc0b8053d89c1c$var$_react.default.createElement($cotNw.Icon, Object.assign({
        dangerouslySetGlyph: '<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M12 10.586L6.707 5.293a1 1 0 00-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 001.414 1.414L12 13.414l5.293 5.293a1 1 0 001.414-1.414L13.414 12l5.293-5.293a1 1 0 10-1.414-1.414L12 10.586z" fill="currentColor"/></svg>'
    }, props));
};
$bbfc0b8053d89c1c$var$CrossIcon.displayName = "CrossIcon";
var $bbfc0b8053d89c1c$var$_default = $bbfc0b8053d89c1c$var$CrossIcon;
module.exports.default = $bbfc0b8053d89c1c$var$_default;

});

parcelRegister("lQiSD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $041a88ab76bd3a44$var$_react = $041a88ab76bd3a44$var$_interopRequireDefault((parcelRequire("1Mpn7")));

var $cotNw = parcelRequire("cotNw");
function $041a88ab76bd3a44$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $041a88ab76bd3a44$var$MenuIcon = function(props) {
    return /*#__PURE__*/ $041a88ab76bd3a44$var$_react.default.createElement($cotNw.Icon, Object.assign({
        dangerouslySetGlyph: '<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M5 15h14v2H5zm0-8h14v2H5zm0 4h14v2H5z" fill="currentColor" fill-rule="evenodd"/></svg>'
    }, props));
};
$041a88ab76bd3a44$var$MenuIcon.displayName = "MenuIcon";
var $041a88ab76bd3a44$var$_default = $041a88ab76bd3a44$var$MenuIcon;
module.exports.default = $041a88ab76bd3a44$var$_default;

});

parcelRegister("du32H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("b146G")).default; });
/* istanbul ignore file */ 
var $b146G = parcelRequire("b146G");

var $gMq3p = parcelRequire("gMq3p");

});
parcelRegister("b146G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8052f937ad606e83$export$2e2bcd8739ae039; });

var $do9pw = parcelRequire("do9pw");

var $1rY3h = parcelRequire("1rY3h");
parcelRequire("f2zNZ");
var $4gWmx = parcelRequire("4gWmx");
var $8052f937ad606e83$var$versionSelect = function(param) {
    var version = param.version, fields = param.fields;
    switch(version){
        case 0:
            return (0, $1rY3h.jsx)((0, $4gWmx.default), (0, $do9pw._)({}, fields));
        default:
            throw new Error("Unknown module version");
    }
};
var $8052f937ad606e83$export$2e2bcd8739ae039 = $8052f937ad606e83$var$versionSelect;

});
parcelRegister("f2zNZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("4gWmx")).default; });
/* istanbul ignore file */ parcelRequire("lQaUE");
var $4gWmx = parcelRequire("4gWmx");

var $iEnWS = parcelRequire("iEnWS");

});
parcelRegister("lQaUE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("4gWmx")).default; });

var $4gWmx = parcelRequire("4gWmx");

});
parcelRegister("4gWmx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31c5eda5f04b9344$export$2e2bcd8739ae039; });

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $1rY3h = parcelRequire("1rY3h");

var $coBSS = parcelRequire("coBSS");

var $dGfZm = parcelRequire("dGfZm");

var $1Mpn7 = parcelRequire("1Mpn7");

var $5vvNu = parcelRequire("5vvNu");
var $31c5eda5f04b9344$var$StatsigContainer = function(props) {
    return (0, $1rY3h.jsx)($31c5eda5f04b9344$var$FeatureGatedAdminTrialCart, (0, $do9pw._)({}, props));
};
var $31c5eda5f04b9344$var$NonEnrolledCart = function() {
    (0, $1Mpn7.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($coBSS))).manuallyLogExperimentExposure("wac_cart_a-b_experiment");
    }, []);
    return (0, $1rY3h.jsx)((0, $1rY3h.Fragment), {});
};
var $31c5eda5f04b9344$var$FeatureGatedAdminTrialCart = function(props) {
    var aaid = (0, (/*@__PURE__*/$parcel$interopDefault($5vvNu))).get("__aid_user_id");
    if (!aaid || aaid === "") return (0, $1rY3h.jsx)((0, $1rY3h.Fragment), {});
    var enrolledAb = (0, (/*@__PURE__*/$parcel$interopDefault($coBSS))).getExperimentValue("wac_cart_a-b_experiment", "treatment", "non-enrolled", {
        fireExperimentExposure: false
    });
    if (enrolledAb === "non-enrolled") return (0, $1rY3h.jsx)($31c5eda5f04b9344$var$NonEnrolledCart, {});
    return (0, $1rY3h.jsx)((0, $dGfZm.default), (0, $cxjpp._)((0, $do9pw._)({}, props), {
        enrolled: enrolledAb
    }));
};
var $31c5eda5f04b9344$export$2e2bcd8739ae039 = $31c5eda5f04b9344$var$StatsigContainer;

});
parcelRegister("dGfZm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f5b99a0d2cf256f$export$2e2bcd8739ae039; });

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $cv9Rk = parcelRequire("cv9Rk");

var $1rY3h = parcelRequire("1rY3h");

var $145N3 = parcelRequire("145N3");
parcelRequire("abOFo");
var $5DDnU = parcelRequire("5DDnU");

var $RRKsg = parcelRequire("RRKsg");

var $5vvNu = parcelRequire("5vvNu");

var $1Mpn7 = parcelRequire("1Mpn7");
parcelRequire("7Pj87");
var $8khbJ = parcelRequire("8khbJ");
parcelRequire("iUkrv");
var $8Fo5C = parcelRequire("8Fo5C");
var $afdAm = parcelRequire("afdAm");
parcelRequire("2fcCi");
var $f1zlB = parcelRequire("f1zlB");

var $cVzdx = parcelRequire("cVzdx");

var $crWuu = parcelRequire("crWuu");
parcelRequire("bQ5AI");
var $9SuoP = parcelRequire("9SuoP");

var $cBZF0 = parcelRequire("cBZF0");

var $coBSS = parcelRequire("coBSS");
var $9f5b99a0d2cf256f$var$AdminCartWrapper = function(param) {
    var enrolled = param.enrolled, children = param.children;
    var createAnalyticsEvent = (0, $145N3.useAnalyticsEvents)().createAnalyticsEvent;
    (0, $1Mpn7.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($coBSS))).manuallyLogExperimentExposure("wac_cart_a-b_experiment");
        createAnalyticsEvent({
            action: "exposed",
            actionSubject: "feature",
            actionSubjectId: (0, $cVzdx.ACTION_SUBJECT_IDS).wacCartFeatureExposed,
            attributes: {
                aaid: (0, (/*@__PURE__*/$parcel$interopDefault($5vvNu))).get("__aid_user_id"),
                flagKey: "wac_cart_a-b_experiment",
                value: enrolled
            }
        }).fire();
    }, []);
    if (enrolled === "control") return;
    return (0, $1rY3h.jsx)("div", {
        "data-testid": "admin-trial-cart",
        css: (0, $crWuu.containerStyle),
        children: (0, $1rY3h.jsx)("div", {
            children: children
        })
    });
};
var $9f5b99a0d2cf256f$var$AdminTrialCart = function(param) {
    var enrolled = param.enrolled;
    var createAnalyticsEvent = (0, $145N3.useAnalyticsEvents)().createAnalyticsEvent;
    var _useEntitlements = (0, $cv9Rk._)((0, $9SuoP.useEntitlements)(), 4), entitlements = _useEntitlements[0], transactionAccountId = _useEntitlements[1], invoiceGroupId = _useEntitlements[2], totalEntitlementsCount = _useEntitlements[3];
    var _useEntitlementListings = (0, $cv9Rk._)((0, $cBZF0.useEntitlementListings)(entitlements !== null && entitlements !== void 0 ? entitlements : []), 5), formattedTotalPrice = _useEntitlementListings[0], estimates = _useEntitlementListings[1], fetchEntitlementListings = _useEntitlementListings[2], isLoadingEntitlementListings = _useEntitlementListings[3], fetchEntitlementListingsError = _useEntitlementListings[4];
    var _useState = (0, $cv9Rk._)((0, $1Mpn7.useState)(false), 2), popupOpen = _useState[0], setPopupOpen = _useState[1];
    var isProd = location.hostname === "www.atlassian.com";
    var analyticsAttributes = {
        aaid: (0, (/*@__PURE__*/$parcel$interopDefault($5vvNu))).get("__aid_user_id"),
        transactionAccountId: transactionAccountId,
        invoiceGroupId: invoiceGroupId,
        numberOfEntitlements: (entitlements === null || entitlements === void 0 ? void 0 : entitlements.length) || 0
    };
    var handleCartClick = function() {
        fetchEntitlementListings();
        createAnalyticsEvent({
            eventName: (0, $cVzdx.TRACKING_EVENT_NAMES).wacCartIconClicked,
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: (0, $cVzdx.ACTION_SUBJECT_IDS).wacCartIcon,
            attributes: (0, $do9pw._)({
                popupState: popupOpen ? "closed" : "open"
            }, analyticsAttributes)
        }).fire();
        if (popupOpen) handleClosePopup();
        else setPopupOpen(true);
    };
    var handleClosePopup = function() {
        createAnalyticsEvent({
            eventName: (0, $cVzdx.TRACKING_EVENT_NAMES).wacCartPopoverClosed,
            action: "closed",
            actionSubjectId: (0, $cVzdx.ACTION_SUBJECT_IDS).wacCartPopoverClosed,
            attributes: analyticsAttributes
        }).fire();
        setPopupOpen(false);
    };
    var getAddPaymentDetailsURL = function() {
        var addPaymentDetailsURL = "https://admin".concat(!isProd ? ".stg" : "", ".atlassian.com/billing/").concat(transactionAccountId, "/").concat(invoiceGroupId, "/payment-flow");
        var origin = new (0, $RRKsg.default)({
            product: "marketing"
        });
        return origin.addToUrl(addPaymentDetailsURL);
    };
    if (!(entitlements === null || entitlements === void 0 ? void 0 : entitlements.length)) return;
    return (0, $1rY3h.jsx)($9f5b99a0d2cf256f$var$AdminCartWrapper, {
        enrolled: enrolled,
        children: (0, $1rY3h.jsx)((0, $5DDnU.Popup), {
            placement: "bottom-end",
            isOpen: popupOpen,
            onClose: handleClosePopup,
            trigger: function(triggerProps) {
                return (0, $1rY3h.jsx)("div", (0, $cxjpp._)((0, $do9pw._)({}, triggerProps), {
                    children: (0, $1rY3h.jsx)((0, $8khbJ.CartButton), {
                        onClick: handleCartClick,
                        numberOfProductTrials: (entitlements === null || entitlements === void 0 ? void 0 : entitlements.length) || 0,
                        analyticsAttributes: analyticsAttributes
                    })
                }));
            },
            content: function() {
                return (0, $1rY3h.jsx)((0, $8Fo5C.EntitlementsPopup), {
                    addPaymentDetailsURL: getAddPaymentDetailsURL(),
                    analyticsAttributes: analyticsAttributes,
                    formattedTotalPrice: formattedTotalPrice,
                    hasError: fetchEntitlementListingsError,
                    isLoading: isLoadingEntitlementListings || estimates.length === 0,
                    children: (0, $1rY3h.jsxs)("div", {
                        children: [
                            estimates === null || estimates === void 0 ? void 0 : estimates.slice(0, 5).map(function(estimate) {
                                var entitlementId = estimate.entitlementId, siteName = estimate.siteName, formattedTotalPrice = estimate.formattedTotalPrice, usersPriceBreakdown = estimate.usersPriceBreakdown, productAndPlanName = estimate.productAndPlanName, productKey = estimate.productKey, daysLeftInTrial = estimate.daysLeftInTrial;
                                return (0, $1rY3h.jsx)((0, $afdAm.EntitlementItem), {
                                    daysLeft: daysLeftInTrial,
                                    productKey: productKey,
                                    productAndPlanName: productAndPlanName,
                                    siteName: siteName,
                                    formattedTotalPrice: formattedTotalPrice,
                                    usersPriceBreakdown: usersPriceBreakdown
                                }, entitlementId);
                            }),
                            (estimates === null || estimates === void 0 ? void 0 : estimates.length) > 5 && (0, $1rY3h.jsx)((0, $f1zlB.ShowAllLink), {
                                addPaymentDetailsURL: getAddPaymentDetailsURL(),
                                analyticsAttributes: analyticsAttributes,
                                totalEntitlementsCount: totalEntitlementsCount
                            })
                        ]
                    })
                });
            }
        })
    });
};
var $9f5b99a0d2cf256f$export$2e2bcd8739ae039 = $9f5b99a0d2cf256f$var$AdminTrialCart;

});
parcelRegister("abOFo", function(module, exports) {

$parcel$export(module.exports, "Popup", function () { return (parcelRequire("5DDnU")).Popup; });

var $5DDnU = parcelRequire("5DDnU");
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$76b23bcc32e6ca4f$export$2e2bcd8739ae039 = (0, $5DDnU.Popup);

});
parcelRegister("5DDnU", function(module, exports) {

$parcel$export(module.exports, "Popup", function () { return $41af253681a7ad35$export$129a32eedafa97c5; });

var $e6gyJ = parcelRequire("e6gyJ");

var $1Mpn7 = parcelRequire("1Mpn7");

var $fBy54 = parcelRequire("fBy54");

var $dNl4p = parcelRequire("dNl4p");

var $cWK60 = parcelRequire("cWK60");

var $byyI5 = parcelRequire("byyI5");
var $lmwLN = parcelRequire("lmwLN");

var $bTh1j = parcelRequire("bTh1j");

var $7HY3q = parcelRequire("7HY3q");

var $auKEG = parcelRequire("auKEG");
var $41af253681a7ad35$var$defaultLayer = (0, $7HY3q.layers).layer();
var $41af253681a7ad35$export$129a32eedafa97c5 = /*#__PURE__*/ (0, $1Mpn7.memo)(function(_ref) {
    var isOpen = _ref.isOpen, id = _ref.id, offset = _ref.offset, testId = _ref.testId, trigger = _ref.trigger, content = _ref.content, onClose = _ref.onClose, boundary = _ref.boundary, _ref$rootBoundary = _ref.rootBoundary, rootBoundary = _ref$rootBoundary === void 0 ? "viewport" : _ref$rootBoundary, _ref$shouldFlip = _ref.shouldFlip, shouldFlip = _ref$shouldFlip === void 0 ? true : _ref$shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "auto" : _ref$placement, fallbackPlacements = _ref.fallbackPlacements, PopupContainer = _ref.popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? $41af253681a7ad35$var$defaultLayer : _ref$zIndex, _ref$shouldUseCapture = _ref.shouldUseCaptureOnOutsideClick, shouldUseCaptureOnOutsideClick = _ref$shouldUseCapture === void 0 ? false : _ref$shouldUseCapture, _ref$shouldRenderToPa = _ref.shouldRenderToParent, shouldRenderToParent = _ref$shouldRenderToPa === void 0 ? false : _ref$shouldRenderToPa;
    var _useState = (0, $1Mpn7.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($e6gyJ)))(_useState, 2), triggerRef = _useState2[0], setTriggerRef = _useState2[1];
    var renderPopperWrapper = (0, $fBy54.jsx)((0, $dNl4p.UNSAFE_LAYERING), {
        isDisabled: (0, $cWK60.getBooleanFF)("platform.design-system-team.layering_popup_1cnzt") ? false : true
    }, (0, $fBy54.jsx)((0, $auKEG.default), {
        content: content,
        isOpen: isOpen,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        boundary: boundary,
        rootBoundary: rootBoundary,
        shouldFlip: shouldFlip,
        offset: offset,
        popupComponent: PopupContainer,
        id: id,
        testId: testId,
        onClose: onClose,
        autoFocus: autoFocus,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldRenderToParent: shouldRenderToParent,
        triggerRef: triggerRef
    }));
    return (0, $fBy54.jsx)((0, $byyI5.Manager), null, (0, $fBy54.jsx)((0, $lmwLN.Reference), null, function(_ref2) {
        var _ref3 = _ref2.ref;
        return trigger({
            ref: function ref(node) {
                if (node && isOpen) {
                    if (typeof _ref3 === "function") _ref3(node);
                    else _ref3.current = node;
                    setTriggerRef(node);
                }
            },
            "aria-controls": id,
            "aria-expanded": isOpen,
            "aria-haspopup": true
        });
    }), isOpen && (shouldRenderToParent ? renderPopperWrapper : (0, $fBy54.jsx)((0, $bTh1j.default), {
        zIndex: zIndex
    }, renderPopperWrapper)));
});
var $41af253681a7ad35$export$2e2bcd8739ae039 = $41af253681a7ad35$export$129a32eedafa97c5;

});
parcelRegister("dNl4p", function(module, exports) {

$parcel$export(module.exports, "LevelContext", function () { return $a0b0320f6f451967$export$650d12d3c2ddb8fc; });
$parcel$export(module.exports, "TopLevelContext", function () { return $a0b0320f6f451967$export$48b383b280e20440; });
$parcel$export(module.exports, "UNSAFE_LAYERING", function () { return $a0b0320f6f451967$export$a183686c3f6f4ea8; });

var $1Mpn7 = parcelRequire("1Mpn7");

var $x0QfA = parcelRequire("x0QfA");

var $cWK60 = parcelRequire("cWK60");
var $a0b0320f6f451967$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $1Mpn7.createContext)(0);
var $a0b0320f6f451967$export$48b383b280e20440 = /*#__PURE__*/ (0, $1Mpn7.createContext)({
    topLevelRef: {
        current: null
    },
    setTopLevel: (0, $x0QfA.default)
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ var $a0b0320f6f451967$var$LevelProvider = function LevelProvider(_ref) {
    var children = _ref.children, currentLevel = _ref.currentLevel;
    var _useContext = (0, $1Mpn7.useContext)($a0b0320f6f451967$export$48b383b280e20440), setTopLevel = _useContext.setTopLevel;
    setTopLevel(currentLevel);
    (0, $1Mpn7.useEffect)(function() {
        // avoid immediate cleanup using setTimeout when component unmount
        // this will make sure non-top layer components can get the correct top level value
        // when multiple layers trigger onClose in sequence.
        // From React 17, the useEffect cleanup functions are delayed till the commit phase is completed. In other words, the useEffect cleanup functions run asynchronously - for example, if the component is unmounting, the cleanup runs after the screen has been updated.
        // TODO revisit after we migrate to react 18. https://product-fabric.atlassian.net/browse/DSP-13139
        return function() {
            setTimeout(function() {
                setTopLevel(currentLevel - 1);
            }, 0);
        };
    }, [
        setTopLevel,
        currentLevel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement($a0b0320f6f451967$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, children);
};
/**
 *
 *  @internal
 * Context Provider Component which provides the top level of all nested layers
 * It provides initial top level ref value as 0 and set top level method
 *
 */ var $a0b0320f6f451967$var$LayeringProvider = function LayeringProvider(_ref2) {
    var children = _ref2.children;
    var topLevelRef = (0, $1Mpn7.useRef)(0);
    var value = (0, $1Mpn7.useMemo)(function() {
        return {
            topLevelRef: topLevelRef,
            setTopLevel: function setTopLevel(level) {
                topLevelRef.current = level;
            }
        };
    }, [
        topLevelRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement($a0b0320f6f451967$export$48b383b280e20440.Provider, {
        value: value
    }, children);
};
var $a0b0320f6f451967$export$a183686c3f6f4ea8 = function UNSAFE_LAYERING(_ref3) {
    var children = _ref3.children;
    var currentLevel = (0, $1Mpn7.useContext)($a0b0320f6f451967$export$650d12d3c2ddb8fc);
    var isNested = currentLevel > 0;
    if (!(0, $cWK60.getBooleanFF)("platform.design-system-team.layering_qmiw3")) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).Fragment, null, children);
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement($a0b0320f6f451967$var$LevelProvider, {
        currentLevel: currentLevel + 1
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement($a0b0320f6f451967$var$LayeringProvider, null, content);
};

});

parcelRegister("byyI5", function(module, exports) {

$parcel$export(module.exports, "ManagerReferenceNodeContext", function () { return $869dcb60ebc3d1b5$export$3dbd3405086fec7b; });
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", function () { return $869dcb60ebc3d1b5$export$cbabb21c2529b130; });
$parcel$export(module.exports, "Manager", function () { return $869dcb60ebc3d1b5$export$d0d38e7dec7a1a61; });

var $1Mpn7 = parcelRequire("1Mpn7");
var $869dcb60ebc3d1b5$export$3dbd3405086fec7b = $1Mpn7.createContext();
var $869dcb60ebc3d1b5$export$cbabb21c2529b130 = $1Mpn7.createContext();
function $869dcb60ebc3d1b5$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $1Mpn7.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $1Mpn7.useRef(false);
    $1Mpn7.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $1Mpn7.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $1Mpn7.createElement($869dcb60ebc3d1b5$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $1Mpn7.createElement($869dcb60ebc3d1b5$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("lmwLN", function(module, exports) {

$parcel$export(module.exports, "Reference", function () { return $f8d5127dd87d00d0$export$e0be378c32fb70a7; });

var $1Mpn7 = parcelRequire("1Mpn7");

var $fta5F = parcelRequire("fta5F");

var $byyI5 = parcelRequire("byyI5");

var $aAv3b = parcelRequire("aAv3b");
function $f8d5127dd87d00d0$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $1Mpn7.useContext((0, $byyI5.ManagerReferenceNodeSetterContext));
    var refHandler = $1Mpn7.useCallback(function(node) {
        (0, $aAv3b.setRef)(innerRef, node);
        (0, $aAv3b.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $1Mpn7.useEffect(function() {
        return function() {
            return (0, $aAv3b.setRef)(innerRef, null);
        };
    }, []);
    $1Mpn7.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fta5F)))(Boolean(setReferenceNode), "`Reference` should not be used outside of a `Manager` component.");
    }, [
        setReferenceNode
    ]);
    return (0, $aAv3b.unwrapArray)(children)({
        ref: refHandler
    });
}

});
parcelRegister("fta5F", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $b431642b2ae483e7$var$__DEV__ = false;
var $b431642b2ae483e7$var$warning = function warning() {};
if ($b431642b2ae483e7$var$__DEV__) {
    var $b431642b2ae483e7$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = "Warning: " + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== "undefined") console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $b431642b2ae483e7$var$warning = function warning(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $b431642b2ae483e7$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = $b431642b2ae483e7$var$warning;

});

parcelRegister("aAv3b", function(module, exports) {

$parcel$export(module.exports, "unwrapArray", function () { return $7b555a24bf03c5ad$export$f52c55943429c8b6; });
$parcel$export(module.exports, "safeInvoke", function () { return $7b555a24bf03c5ad$export$3dfa7c28635fe028; });
$parcel$export(module.exports, "setRef", function () { return $7b555a24bf03c5ad$export$4bb192c7cacf928f; });
$parcel$export(module.exports, "fromEntries", function () { return $7b555a24bf03c5ad$export$5150077fc2e7c662; });
$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $7b555a24bf03c5ad$export$700979bc83e7db82; });

var $1Mpn7 = parcelRequire("1Mpn7");
var $7b555a24bf03c5ad$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $7b555a24bf03c5ad$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === "function") {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $7b555a24bf03c5ad$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === "function") return $7b555a24bf03c5ad$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $7b555a24bf03c5ad$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $7b555a24bf03c5ad$export$700979bc83e7db82 = typeof window !== "undefined" && window.document && window.document.createElement ? $1Mpn7.useLayoutEffect : $1Mpn7.useEffect;

});


parcelRegister("bTh1j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a82089bb7da9b14$export$2e2bcd8739ae039; });

var $1Mpn7 = parcelRequire("1Mpn7");

var $j0r9t = parcelRequire("j0r9t");

var $iqfpF = parcelRequire("iqfpF");

var $4xPic = parcelRequire("4xPic");
function $8a82089bb7da9b14$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? "effect" : _ref$mountStrategy;
    var isSubsequentRender = (0, $iqfpF.default)(mountStrategy);
    (0, $4xPic.default)(zIndex);
    return isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $j0r9t.default), {
        zIndex: zIndex
    }, children) : null;
}

});
parcelRegister("j0r9t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd63142a2890f787$export$2e2bcd8739ae039; });

var $1Mpn7 = parcelRequire("1Mpn7");

var $eaouD = parcelRequire("eaouD");

var $jhaMV = parcelRequire("jhaMV");
function $dd63142a2890f787$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var container = (0, $1Mpn7.useMemo)(function() {
        return (0, $jhaMV.createContainer)(zIndex);
    }, [
        zIndex
    ]);
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $jhaMV.appendPortalContainerIfNotAppended)(container);
    (0, $1Mpn7.useEffect)(function() {
        return function() {
            (0, $jhaMV.removePortalContainer)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $eaouD.createPortal)(children, container);
}

});
parcelRegister("jhaMV", function(module, exports) {

$parcel$export(module.exports, "createContainer", function () { return $e087f91f78bb568e$export$26ae5ca175b4ec5a; });
$parcel$export(module.exports, "removePortalContainer", function () { return $e087f91f78bb568e$export$da99f98bf3fe55b3; });
$parcel$export(module.exports, "appendPortalContainerIfNotAppended", function () { return $e087f91f78bb568e$export$c582005add11e141; });

var $h9lJh = parcelRequire("h9lJh");
var $e087f91f78bb568e$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement("div");
    container.className = (0, $h9lJh.portalClassName);
    container.style.zIndex = "".concat(zIndex);
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $e087f91f78bb568e$var$getBody = function getBody() {
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ var $e087f91f78bb568e$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $h9lJh.portalParentSelector));
    if (!parentElement) {
        var parent = document.createElement("div");
        parent.className = (0, $h9lJh.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = "flex";
        $e087f91f78bb568e$var$getBody().appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $e087f91f78bb568e$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    $e087f91f78bb568e$var$getPortalParent().removeChild(container);
};
var $e087f91f78bb568e$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $e087f91f78bb568e$var$getPortalParent().appendChild(container);
};

});
parcelRegister("h9lJh", function(module, exports) {

$parcel$export(module.exports, "portalParentClassName", function () { return $c7c421e6422ac015$export$e4c79eb95c23a0da; });
$parcel$export(module.exports, "portalParentSelector", function () { return $c7c421e6422ac015$export$72f415121273627e; });
$parcel$export(module.exports, "portalClassName", function () { return $c7c421e6422ac015$export$13f57c02915787b3; });
var $c7c421e6422ac015$export$e4c79eb95c23a0da = "atlaskit-portal-container";
var $c7c421e6422ac015$export$72f415121273627e = "body > .atlaskit-portal-container";
var $c7c421e6422ac015$export$13f57c02915787b3 = "atlaskit-portal";

});



parcelRegister("iqfpF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d6969c6aad663dd5$export$2e2bcd8739ae039; });

var $e6gyJ = parcelRequire("e6gyJ");

var $1Mpn7 = parcelRequire("1Mpn7");

var $7QfkG = parcelRequire("7QfkG");
var $d6969c6aad663dd5$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $1Mpn7.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($e6gyJ)))(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $1Mpn7.useState)(function() {
        return mountStrategy === "layoutEffect" ? (0, $7QfkG.useIsomorphicLayoutEffect) : (0, $1Mpn7.useEffect);
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($e6gyJ)))(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $d6969c6aad663dd5$export$2e2bcd8739ae039 = $d6969c6aad663dd5$var$useIsSubsequentRender;

});
parcelRegister("7QfkG", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $5b59487529cb9b3a$export$700979bc83e7db82; });

var $1Mpn7 = parcelRequire("1Mpn7");
var $5b59487529cb9b3a$export$700979bc83e7db82 = typeof window !== "undefined" ? (0, $1Mpn7.useLayoutEffect) : (0, $1Mpn7.useEffect);

});


parcelRegister("4xPic", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $34f20820ac6958a5$export$2e2bcd8739ae039; });

var $1Mpn7 = parcelRequire("1Mpn7");

var $ad7zc = parcelRequire("ad7zc");

var $g86tb = parcelRequire("g86tb");
var $34f20820ac6958a5$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $1Mpn7.useEffect)(function() {
        (0, $g86tb.default)((0, $ad7zc.PORTAL_MOUNT_EVENT), zIndexNumber);
        return function() {
            (0, $g86tb.default)((0, $ad7zc.PORTAL_UNMOUNT_EVENT), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $34f20820ac6958a5$export$2e2bcd8739ae039 = $34f20820ac6958a5$var$useFirePortalEvent;

});
parcelRegister("ad7zc", function(module, exports) {

$parcel$export(module.exports, "PORTAL_MOUNT_EVENT", function () { return $76f0fcdfde58433e$export$ed5835cc67e87f72; });
$parcel$export(module.exports, "PORTAL_UNMOUNT_EVENT", function () { return $76f0fcdfde58433e$export$80816bd900e5bd00; });
var $76f0fcdfde58433e$export$ed5835cc67e87f72 = "akPortalMount";
var $76f0fcdfde58433e$export$80816bd900e5bd00 = "akPortalUnmount";

});

parcelRegister("g86tb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bbe2697296581c27$export$2e2bcd8739ae039; });
var $bbe2697296581c27$var$zIndexToName = {
    100: "card",
    200: "navigation",
    300: "dialog",
    400: "layer",
    500: "blanket",
    510: "modal",
    600: "flag",
    700: "spotlight",
    9999: "tooltip"
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $bbe2697296581c27$var$getLayerName = function getLayerName(zIndex) {
    return $bbe2697296581c27$var$zIndexToName.hasOwnProperty(zIndex) ? $bbe2697296581c27$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $bbe2697296581c27$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $bbe2697296581c27$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $bbe2697296581c27$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $bbe2697296581c27$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}

});



parcelRegister("7HY3q", function(module, exports) {

$parcel$export(module.exports, "CHANNEL", function () { return $59cb221704b9d60b$export$44ffba16bd48dac6; });
$parcel$export(module.exports, "DEFAULT_THEME_MODE", function () { return $59cb221704b9d60b$export$c93026a968943f95; });
$parcel$export(module.exports, "THEME_MODES", function () { return $59cb221704b9d60b$export$6ba72c8346b4c57e; });
$parcel$export(module.exports, "layers", function () { return $59cb221704b9d60b$export$7be255094ccdc533; });

var $2Eqc7 = parcelRequire("2Eqc7");

var $eB7oR = parcelRequire("eB7oR");
var $59cb221704b9d60b$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $59cb221704b9d60b$export$c93026a968943f95 = "light";
var $59cb221704b9d60b$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $59cb221704b9d60b$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $59cb221704b9d60b$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $59cb221704b9d60b$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $59cb221704b9d60b$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $59cb221704b9d60b$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $59cb221704b9d60b$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $59cb221704b9d60b$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $eB7oR.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $59cb221704b9d60b$export$6d8204c2cb2e06b8() / 4;
    (0, $2Eqc7.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $59cb221704b9d60b$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $59cb221704b9d60b$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $59cb221704b9d60b$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $2Eqc7.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $59cb221704b9d60b$export$ba1d834b86d72a09 = $59cb221704b9d60b$export$a1b3edb637fb4f35;
var $59cb221704b9d60b$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $eB7oR.skeleton)(), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $eB7oR.skeleton)(), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $eB7oR.N30A), ")")
            }
        }
    };
};

});
parcelRegister("eB7oR", function(module, exports) {

$parcel$export(module.exports, "B200", function () { return $aa0a42dca305c30e$export$215b7063051591f1; });
$parcel$export(module.exports, "N0", function () { return $aa0a42dca305c30e$export$29a4f05edc054374; });
$parcel$export(module.exports, "N30A", function () { return $aa0a42dca305c30e$export$920c0d5c49070351; });
$parcel$export(module.exports, "N50A", function () { return $aa0a42dca305c30e$export$7d3359664e8bb0e5; });
$parcel$export(module.exports, "N60A", function () { return $aa0a42dca305c30e$export$d2d3bedfb276cac0; });
$parcel$export(module.exports, "skeleton", function () { return $aa0a42dca305c30e$export$2a0674ff2eb10214; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $5ctCF = parcelRequire("5ctCF");
var $aa0a42dca305c30e$export$4b84fd0e2c617bd = "#FFEBE6";
var $aa0a42dca305c30e$export$b34b069eff244586 = "#FFBDAD";
var $aa0a42dca305c30e$export$be802dd0d8b57f35 = "#FF8F73";
var $aa0a42dca305c30e$export$60847d42f9da92a6 = "#FF7452";
var $aa0a42dca305c30e$export$4a7404f376229999 = "#FF5630";
var $aa0a42dca305c30e$export$2010d0fb4295b346 = "#DE350B";
var $aa0a42dca305c30e$export$2837b5a1a71d5c02 = "#BF2600";
var $aa0a42dca305c30e$export$8d9596b529bbb9cf = "#FFFAE6";
var $aa0a42dca305c30e$export$41060a744ab0b7ae = "#FFF0B3";
var $aa0a42dca305c30e$export$1cc05bbbf340e559 = "#FFE380";
var $aa0a42dca305c30e$export$5aae31392d72caaa = "#FFC400";
var $aa0a42dca305c30e$export$c6930421db9fa514 = "#FFAB00";
var $aa0a42dca305c30e$export$59619663aa6500fb = "#FF991F";
var $aa0a42dca305c30e$export$874739ea9e379ab6 = "#FF8B00";
var $aa0a42dca305c30e$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $aa0a42dca305c30e$export$69a3bf21b9686c2b = "#ABF5D1";
var $aa0a42dca305c30e$export$afbce1382ec95f73 = "#79F2C0";
var $aa0a42dca305c30e$export$747d86715d4175de = "#57D9A3";
var $aa0a42dca305c30e$export$940e1f69e873f202 = "#36B37E";
var $aa0a42dca305c30e$export$a49394138f7b8e85 = "#00875A";
var $aa0a42dca305c30e$export$6fa04827ac68a4fb = "#006644";
var $aa0a42dca305c30e$export$226de0355ed012f8 = "#DEEBFF";
var $aa0a42dca305c30e$export$8c13c2ee36917869 = "#B3D4FF";
var $aa0a42dca305c30e$export$ecfc1dff386a3e7a = "#4C9AFF";
var $aa0a42dca305c30e$export$215b7063051591f1 = "#2684FF";
var $aa0a42dca305c30e$export$e62e8919cca44969 = "#0065FF";
var $aa0a42dca305c30e$export$b3de0ae08da2ce64 = "#0052CC";
var $aa0a42dca305c30e$export$a6ee3d71bc067634 = "#0747A6";
var $aa0a42dca305c30e$export$363e4475840015bb = "#EAE6FF";
var $aa0a42dca305c30e$export$4b0a4417ed59760f = "#C0B6F2";
var $aa0a42dca305c30e$export$6011520a64d9a187 = "#998DD9";
var $aa0a42dca305c30e$export$a7175d4e9206bc80 = "#8777D9";
var $aa0a42dca305c30e$export$b48405b95304b5a1 = "#6554C0";
var $aa0a42dca305c30e$export$c71e4279dd54a18d = "#5243AA";
var $aa0a42dca305c30e$export$147899de772240ec = "#403294";
var $aa0a42dca305c30e$export$2cf711fe14c66f06 = "#E6FCFF";
var $aa0a42dca305c30e$export$7a8f4d33f6f9772c = "#B3F5FF";
var $aa0a42dca305c30e$export$776c9c497ef08533 = "#79E2F2";
var $aa0a42dca305c30e$export$69cb3ca10c1e330e = "#00C7E6";
var $aa0a42dca305c30e$export$9dc1ef0f3f48059b = "#00B8D9";
var $aa0a42dca305c30e$export$7c835c78b6fcdef8 = "#00A3BF";
var $aa0a42dca305c30e$export$6036577f95c3877e = "#008DA6";
var $aa0a42dca305c30e$export$29a4f05edc054374 = "#FFFFFF";
var $aa0a42dca305c30e$export$e655ef011c4aa1a2 = "#FAFBFC";
var $aa0a42dca305c30e$export$9fdfb749e33cdf97 = "#F4F5F7";
var $aa0a42dca305c30e$export$3e51e8f1440314ba = "#EBECF0";
var $aa0a42dca305c30e$export$1ce2d1575d444ceb = "#DFE1E6";
var $aa0a42dca305c30e$export$8754fc7e6d8b3000 = "#C1C7D0";
var $aa0a42dca305c30e$export$c2e91cbeada39b8b = "#B3BAC5";
var $aa0a42dca305c30e$export$5f71e19f3a7ad9de = "#A5ADBA";
var $aa0a42dca305c30e$export$eaa8c8a70ac22806 = "#97A0AF";
var $aa0a42dca305c30e$export$7c87d337fb91a97d = "#8993A4";
var $aa0a42dca305c30e$export$d6447c357493214f = "#7A869A";
var $aa0a42dca305c30e$export$f563ee71e9ee74cd = "#6B778C";
var $aa0a42dca305c30e$export$e2ef2124cf4024b1 = "#5E6C84";
var $aa0a42dca305c30e$export$eece5f492e429f08 = "#505F79";
var $aa0a42dca305c30e$export$c39c0fe0f26207ae = "#42526E";
var $aa0a42dca305c30e$export$7090862dc3038a9f = "#344563";
var $aa0a42dca305c30e$export$ad0bacf983b7ddaa = "#253858";
var $aa0a42dca305c30e$export$7d61b15e0da132af = "#172B4D";
var $aa0a42dca305c30e$export$fbda843f0a27fe96 = "#091E42";
var $aa0a42dca305c30e$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $aa0a42dca305c30e$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $aa0a42dca305c30e$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $aa0a42dca305c30e$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $aa0a42dca305c30e$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $aa0a42dca305c30e$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $aa0a42dca305c30e$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $aa0a42dca305c30e$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $aa0a42dca305c30e$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $aa0a42dca305c30e$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $aa0a42dca305c30e$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $aa0a42dca305c30e$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $aa0a42dca305c30e$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $aa0a42dca305c30e$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $aa0a42dca305c30e$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $aa0a42dca305c30e$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $aa0a42dca305c30e$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $aa0a42dca305c30e$export$2f6319cf7d736c2a = "#E6EDFA";
var $aa0a42dca305c30e$export$95126bc8884d6634 = "#DCE5F5";
var $aa0a42dca305c30e$export$8338d8c35d44ff1 = "#CED9EB";
var $aa0a42dca305c30e$export$5368d76ae4fbbda7 = "#B8C7E0";
var $aa0a42dca305c30e$export$9f0a771d16ec8d36 = "#ABBBD6";
var $aa0a42dca305c30e$export$abcf8c38338b4aa5 = "#9FB0CC";
var $aa0a42dca305c30e$export$97e81faa16a182c7 = "#8C9CB8";
var $aa0a42dca305c30e$export$bfe21c59123ecf33 = "#7988A3";
var $aa0a42dca305c30e$export$ee82aa2ea6a1558 = "#67758F";
var $aa0a42dca305c30e$export$682927c6ed76be02 = "#56637A";
var $aa0a42dca305c30e$export$91fd9994c5be9757 = "#455166";
var $aa0a42dca305c30e$export$d281fbfe3cff2df6 = "#3B475C";
var $aa0a42dca305c30e$export$3902c91d8b98a753 = "#313D52";
var $aa0a42dca305c30e$export$8e8133c1ba5845b5 = "#283447";
var $aa0a42dca305c30e$export$33ff357f6620b39 = "#202B3D";
var $aa0a42dca305c30e$export$633847cf062b69e0 = "#1B2638";
var $aa0a42dca305c30e$export$9776a6e503bdbf76 = "#121A29";
var $aa0a42dca305c30e$export$6c813d5160dff5db = "#0E1624";
var $aa0a42dca305c30e$export$3d4f271a500072a = "#0D1424";
var $aa0a42dca305c30e$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $aa0a42dca305c30e$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $aa0a42dca305c30e$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $aa0a42dca305c30e$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $aa0a42dca305c30e$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $aa0a42dca305c30e$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $aa0a42dca305c30e$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $aa0a42dca305c30e$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $aa0a42dca305c30e$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $aa0a42dca305c30e$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $aa0a42dca305c30e$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $aa0a42dca305c30e$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $aa0a42dca305c30e$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $aa0a42dca305c30e$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $aa0a42dca305c30e$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $aa0a42dca305c30e$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $aa0a42dca305c30e$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $aa0a42dca305c30e$export$8ce1fd94bee2f412 = (0, $5ctCF.default)({
    light: "var(--ds-surface, ".concat($aa0a42dca305c30e$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface, ".concat($aa0a42dca305c30e$export$633847cf062b69e0, ")")
});
var $aa0a42dca305c30e$export$b861914ea877b580 = (0, $5ctCF.default)({
    light: "var(--ds-background-selected, ".concat($aa0a42dca305c30e$export$226de0355ed012f8, ")"),
    dark: "var(--ds-background-selected, ".concat($aa0a42dca305c30e$export$8c13c2ee36917869, ")")
});
var $aa0a42dca305c30e$export$3f1b020df94387af = (0, $5ctCF.default)({
    light: "var(--ds-background-neutral-hovered, ".concat($aa0a42dca305c30e$export$3e51e8f1440314ba, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat($aa0a42dca305c30e$export$d281fbfe3cff2df6, ")")
});
var $aa0a42dca305c30e$export$c0183dbab98ca63e = (0, $5ctCF.default)({
    light: "var(--ds-surface-overlay, ".concat($aa0a42dca305c30e$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface-overlay, ".concat($aa0a42dca305c30e$export$8e8133c1ba5845b5, ")")
});
var $aa0a42dca305c30e$export$6f093cfa640b7166 = (0, $5ctCF.default)({
    light: "var(--ds-text, ".concat($aa0a42dca305c30e$export$fbda843f0a27fe96, ")"),
    dark: "var(--ds-text, ".concat($aa0a42dca305c30e$export$5368d76ae4fbbda7, ")")
});
var $aa0a42dca305c30e$export$42f8e9c698766e7a = (0, $5ctCF.default)({
    light: "var(--ds-text, ".concat($aa0a42dca305c30e$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($aa0a42dca305c30e$export$5368d76ae4fbbda7, ")")
});
var $aa0a42dca305c30e$export$c2d157ca1c34b6e3 = (0, $5ctCF.default)({
    light: "var(--ds-text-selected, ".concat($aa0a42dca305c30e$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-text-selected, ".concat($aa0a42dca305c30e$export$b3de0ae08da2ce64, ")")
});
var $aa0a42dca305c30e$export$1905ba28d7cf066f = (0, $5ctCF.default)({
    light: "var(--ds-text-subtlest, ".concat($aa0a42dca305c30e$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($aa0a42dca305c30e$export$97e81faa16a182c7, ")")
});
var $aa0a42dca305c30e$export$bd9002130d306d39 = (0, $5ctCF.default)({
    light: "var(--ds-text-subtlest, ".concat($aa0a42dca305c30e$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($aa0a42dca305c30e$export$bfe21c59123ecf33, ")")
});
var $aa0a42dca305c30e$export$46e4a324ac90507f = (0, $5ctCF.default)({
    light: "var(--ds-text, ".concat($aa0a42dca305c30e$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($aa0a42dca305c30e$export$5368d76ae4fbbda7, ")")
});
var $aa0a42dca305c30e$export$79f3f2b82beb0d36 = (0, $5ctCF.default)({
    light: "var(--ds-text-subtlest, ".concat($aa0a42dca305c30e$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($aa0a42dca305c30e$export$97e81faa16a182c7, ")")
});
var $aa0a42dca305c30e$export$7bb0d5c671655cc4 = (0, $5ctCF.default)({
    light: $aa0a42dca305c30e$export$9fdfb749e33cdf97,
    dark: $aa0a42dca305c30e$export$8e8133c1ba5845b5
});
var $aa0a42dca305c30e$export$9c30223ca0a664fb = (0, $5ctCF.default)({
    light: "var(--ds-link, ".concat($aa0a42dca305c30e$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-link, ".concat($aa0a42dca305c30e$export$ecfc1dff386a3e7a, ")")
});
var $aa0a42dca305c30e$export$7ed258b0728b004b = (0, $5ctCF.default)({
    light: "var(--ds-link-pressed, ".concat($aa0a42dca305c30e$export$e62e8919cca44969, ")"),
    dark: "var(--ds-link-pressed, ".concat($aa0a42dca305c30e$export$215b7063051591f1, ")")
});
var $aa0a42dca305c30e$export$dfa920d8decc8a59 = (0, $5ctCF.default)({
    light: "var(--ds-link-pressed, ".concat($aa0a42dca305c30e$export$a6ee3d71bc067634, ")"),
    dark: "var(--ds-link-pressed, ".concat($aa0a42dca305c30e$export$ecfc1dff386a3e7a, ")")
});
var $aa0a42dca305c30e$export$6069e6ad5c78f632 = (0, $5ctCF.default)({
    light: "var(--ds-border-focused, ".concat($aa0a42dca305c30e$export$215b7063051591f1, ")"),
    dark: "var(--ds-border-focused, ".concat($aa0a42dca305c30e$export$215b7063051591f1, ")")
});
var $aa0a42dca305c30e$export$9ad721cf3b3debe0 = (0, $5ctCF.default)({
    light: "var(--ds-background-brand-bold, ".concat($aa0a42dca305c30e$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-background-brand-bold, ".concat($aa0a42dca305c30e$export$ecfc1dff386a3e7a, ")")
});
var $aa0a42dca305c30e$export$2aa0182783e7e9de = (0, $5ctCF.default)({
    light: $aa0a42dca305c30e$export$b3de0ae08da2ce64,
    dark: $aa0a42dca305c30e$export$ecfc1dff386a3e7a
});
var $aa0a42dca305c30e$export$8bf7dff220b82b4a = (0, $5ctCF.default)({
    light: $aa0a42dca305c30e$export$9dc1ef0f3f48059b,
    dark: $aa0a42dca305c30e$export$69cb3ca10c1e330e
});
var $aa0a42dca305c30e$export$e13cce2a2d16a9d4 = (0, $5ctCF.default)({
    light: $aa0a42dca305c30e$export$b48405b95304b5a1,
    dark: $aa0a42dca305c30e$export$6011520a64d9a187
});
var $aa0a42dca305c30e$export$a90204d1394caf30 = (0, $5ctCF.default)({
    light: $aa0a42dca305c30e$export$4a7404f376229999,
    dark: $aa0a42dca305c30e$export$4a7404f376229999
});
var $aa0a42dca305c30e$export$594c5a8758200c32 = (0, $5ctCF.default)({
    light: $aa0a42dca305c30e$export$c6930421db9fa514,
    dark: $aa0a42dca305c30e$export$c6930421db9fa514
});
var $aa0a42dca305c30e$export$955a2ebd2fb142ae = (0, $5ctCF.default)({
    light: $aa0a42dca305c30e$export$940e1f69e873f202,
    dark: $aa0a42dca305c30e$export$940e1f69e873f202
});
var $aa0a42dca305c30e$export$2a0674ff2eb10214 = function skeleton() {
    return "var(--ds-skeleton, ".concat($aa0a42dca305c30e$export$8d43898f60b96a82, ")");
};

});
parcelRegister("5ctCF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c950d2fb535a038$export$2e2bcd8739ae039; });
/* eslint-disable prefer-rest-params */ 
var $5rSL9 = parcelRequire("5rSL9");
// Unpack custom variants, and get correct value for the current theme
function $3c950d2fb535a038$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $5rSL9.default)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return "";
    };
}
function $3c950d2fb535a038$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === "string") return $3c950d2fb535a038$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $5rSL9.default)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return "";
    };
}

});
parcelRegister("5rSL9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f79f378326bb5b6$export$2e2bcd8739ae039; });

var $7HY3q = parcelRequire("7HY3q");
function $3f79f378326bb5b6$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $7HY3q.CHANNEL) in props.theme) return props.theme[0, $7HY3q.CHANNEL];
        else if ("mode" in props.theme && (0, $7HY3q.THEME_MODES).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $7HY3q.DEFAULT_THEME_MODE)
    };
}

});




parcelRegister("auKEG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a40e579503b434a$export$2e2bcd8739ae039; });

var $e6gyJ = parcelRequire("e6gyJ");

var $fjkYW = parcelRequire("fjkYW");

var $04Kcc = parcelRequire("04Kcc");

var $jjExS = parcelRequire("jjExS");

var $1Mpn7 = parcelRequire("1Mpn7");

var $fBy54 = parcelRequire("fBy54");

var $ixpGB = parcelRequire("ixpGB");

var $eB7oR = parcelRequire("eB7oR");

var $7HY3q = parcelRequire("7HY3q");

var $8x66C = parcelRequire("8x66C");

var $aqEis = parcelRequire("aqEis");

var $dKmhH = parcelRequire("dKmhH");

var $gB1Qc = parcelRequire("gB1Qc");
var $7a40e579503b434a$var$_excluded = [
    "shouldRenderToParent",
    "children"
];
var $7a40e579503b434a$var$_css;
var $7a40e579503b434a$var$popupStyles = (0, $fBy54.css)(($7a40e579503b434a$var$_css = {
    display: "block",
    boxSizing: "border-box",
    zIndex: (0, $7HY3q.layers).layer(),
    flex: "1 1 auto",
    backgroundColor: "var(--ds-surface-overlay, ".concat((0, $eB7oR.N0), ")"),
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: "var(--ds-shadow-overlay, ".concat("0 4px 8px -2px ".concat((0, $eB7oR.N50A), ", 0 0 1px ").concat((0, $eB7oR.N60A)), ")")
}, (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))($7a40e579503b434a$var$_css, (0, $8x66C.CURRENT_SURFACE_CSS_VAR), "var(--ds-surface-overlay, ".concat((0, $eB7oR.N0), ")")), (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))($7a40e579503b434a$var$_css, ":focus", {
    outline: "none"
}), $7a40e579503b434a$var$_css));
var $7a40e579503b434a$var$popupOverflowStyles = (0, $fBy54.css)({
    overflow: "auto"
});
var $7a40e579503b434a$var$DefaultPopupComponent = /*#__PURE__*/ (0, $1Mpn7.forwardRef)(function(props, ref) {
    var shouldRenderToParent = props.shouldRenderToParent, children = props.children, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($04Kcc)))(props, $7a40e579503b434a$var$_excluded);
    return (0, $fBy54.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($fjkYW)))({
        css: [
            $7a40e579503b434a$var$popupStyles,
            !shouldRenderToParent && $7a40e579503b434a$var$popupOverflowStyles
        ]
    }, htmlAttributes, {
        ref: ref
    }), children);
});
function $7a40e579503b434a$var$PopperWrapper(_ref) {
    var isOpen = _ref.isOpen, id = _ref.id, offset = _ref.offset, testId = _ref.testId, content = _ref.content, fallbackPlacements = _ref.fallbackPlacements, onClose = _ref.onClose, boundary = _ref.boundary, rootBoundary = _ref.rootBoundary, shouldFlip = _ref.shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "auto" : _ref$placement, _ref$popupComponent = _ref.popupComponent, PopupContainer = _ref$popupComponent === void 0 ? $7a40e579503b434a$var$DefaultPopupComponent : _ref$popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, triggerRef = _ref.triggerRef, shouldUseCaptureOnOutsideClick = _ref.shouldUseCaptureOnOutsideClick, shouldRenderToParent = _ref.shouldRenderToParent;
    var _useState = (0, $1Mpn7.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($e6gyJ)))(_useState, 2), popupRef = _useState2[0], setPopupRef = _useState2[1];
    var _useState3 = (0, $1Mpn7.useState)(null), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($e6gyJ)))(_useState3, 2), initialFocusRef = _useState4[0], setInitialFocusRef = _useState4[1];
    (0, $gB1Qc.useFocusManager)({
        initialFocusRef: initialFocusRef,
        popupRef: popupRef
    });
    (0, $dKmhH.useCloseManager)({
        isOpen: isOpen,
        onClose: onClose,
        popupRef: popupRef,
        triggerRef: triggerRef,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick
    });
    var modifiers = (0, $1Mpn7.useMemo)(function() {
        return [
            {
                name: "flip",
                enabled: shouldFlip,
                options: {
                    rootBoundary: rootBoundary,
                    boundary: boundary,
                    fallbackPlacements: fallbackPlacements
                }
            }
        ];
    }, [
        shouldFlip,
        rootBoundary,
        boundary,
        fallbackPlacements
    ]);
    return (0, $fBy54.jsx)((0, $ixpGB.Popper), {
        placement: placement,
        offset: offset,
        modifiers: modifiers
    }, function(_ref2) {
        var _ref3 = _ref2.ref, style = _ref2.style, placement = _ref2.placement, update = _ref2.update;
        return (0, $fBy54.jsx)(PopupContainer, {
            id: id,
            "data-placement": placement,
            "data-testid": testId,
            ref: function ref(node) {
                if (node) {
                    if (typeof _ref3 === "function") _ref3(node);
                    else _ref3.current = node;
                    setPopupRef(node);
                }
            },
            style: style,
            tabIndex: autoFocus ? 0 : undefined,
            shouldRenderToParent: shouldRenderToParent
        }, (0, $fBy54.jsx)((0, $aqEis.RepositionOnUpdate), {
            update: update
        }, content({
            update: update,
            isOpen: isOpen,
            onClose: onClose,
            setInitialFocusRef: setInitialFocusRef
        })));
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7a40e579503b434a$export$2e2bcd8739ae039 = $7a40e579503b434a$var$PopperWrapper;

});
parcelRegister("ixpGB", function(module, exports) {

$parcel$export(module.exports, "Popper", function () { return $d7ef3bcb4c091683$export$badac9ada3a0bdf9; });

var $eetQ9 = parcelRequire("eetQ9");

var $e6gyJ = parcelRequire("e6gyJ");

var $1Mpn7 = parcelRequire("1Mpn7");

var $jT0tC = parcelRequire("jT0tC");

// Export types from PopperJS / React Popper
var $d7ef3bcb4c091683$var$constantModifiers = [
    {
        name: "flip",
        options: {
            flipVariations: false,
            padding: 5,
            boundary: "clippingParents",
            rootBoundary: "viewport"
        }
    },
    {
        name: "preventOverflow",
        options: {
            padding: 5,
            rootBoundary: "document"
        }
    }
];
function $d7ef3bcb4c091683$var$defaultChildrenFn() {
    return null;
}
var $d7ef3bcb4c091683$var$defaultOffset = [
    0,
    8
];
function $d7ef3bcb4c091683$export$badac9ada3a0bdf9(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? $d7ef3bcb4c091683$var$defaultChildrenFn : _ref$children, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? $d7ef3bcb4c091683$var$defaultOffset : _ref$offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "bottom-start" : _ref$placement, _ref$referenceElement = _ref.referenceElement, referenceElement = _ref$referenceElement === void 0 ? undefined : _ref$referenceElement, modifiers = _ref.modifiers, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "fixed" : _ref$strategy;
    var _offset = (0, (/*@__PURE__*/$parcel$interopDefault($e6gyJ)))(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    // Merge a new offset modifier only if new offset values passed in
    var internalModifiers = (0, $1Mpn7.useMemo)(function() {
        var offsetModifier = {
            name: "offset",
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        return [].concat($d7ef3bcb4c091683$var$constantModifiers, [
            offsetModifier
        ]);
    }, [
        offsetX,
        offsetY
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $1Mpn7.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($eetQ9)))(internalModifiers), (0, (/*@__PURE__*/$parcel$interopDefault($eetQ9)))(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $jT0tC.Popper), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}

});
parcelRegister("jT0tC", function(module, exports) {

$parcel$export(module.exports, "Popper", function () { return $e7a3860501cdc19d$export$badac9ada3a0bdf9; });

var $1Mpn7 = parcelRequire("1Mpn7");

var $byyI5 = parcelRequire("byyI5");

var $aAv3b = parcelRequire("aAv3b");

var $lWBEj = parcelRequire("lWBEj");
var $e7a3860501cdc19d$var$NOOP = function NOOP() {
    return void 0;
};
var $e7a3860501cdc19d$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $e7a3860501cdc19d$var$EMPTY_MODIFIERS = [];
function $e7a3860501cdc19d$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "bottom" : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "absolute" : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $e7a3860501cdc19d$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $1Mpn7.useContext((0, $byyI5.ManagerReferenceNodeContext));
    var _React$useState = $1Mpn7.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $1Mpn7.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $1Mpn7.useEffect(function() {
        (0, $aAv3b.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $1Mpn7.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: "arrow",
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $lWBEj.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $1Mpn7.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $e7a3860501cdc19d$var$NOOP,
            update: update || $e7a3860501cdc19d$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $aAv3b.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("lWBEj", function(module, exports) {

$parcel$export(module.exports, "usePopper", function () { return $ff9c3817e9d67764$export$f4d5bf230a36dd6e; });

var $1Mpn7 = parcelRequire("1Mpn7");

var $eaouD = parcelRequire("eaouD");

var $lMy30 = parcelRequire("lMy30");

var $1PxJM = parcelRequire("1PxJM");

var $aAv3b = parcelRequire("aAv3b");
var $ff9c3817e9d67764$var$EMPTY_MODIFIERS = [];
var $ff9c3817e9d67764$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $1Mpn7.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || "bottom",
        strategy: options.strategy || "absolute",
        modifiers: options.modifiers || $ff9c3817e9d67764$var$EMPTY_MODIFIERS
    };
    var _React$useState = $1Mpn7.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: "0",
                top: "0"
            },
            arrow: {
                position: "absolute"
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $1Mpn7.useMemo(function() {
        return {
            name: "updateState",
            enabled: true,
            phase: "write",
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $eaouD.flushSync(function() {
                    setState({
                        styles: (0, $aAv3b.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $aAv3b.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                "computeStyles"
            ]
        };
    }, []);
    var popperOptions = $1Mpn7.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: "applyStyles",
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($1PxJM)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $1Mpn7.useRef();
    (0, $aAv3b.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $aAv3b.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $lMy30.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("lMy30", function(module, exports) {

$parcel$export(module.exports, "createPopper", function () { return $fdb87dcb672c28f7$export$8f7491d57c8f97a9; });

var $eoZLp = parcelRequire("eoZLp");

var $jbunQ = parcelRequire("jbunQ");

var $5adWy = parcelRequire("5adWy");

var $bDxli = parcelRequire("bDxli");

var $iJvlY = parcelRequire("iJvlY");

var $bbP3o = parcelRequire("bbP3o");

var $a5BAZ = parcelRequire("a5BAZ");

var $hABNX = parcelRequire("hABNX");

var $gNAUH = parcelRequire("gNAUH");

var $gvY5G = parcelRequire("gvY5G");


var $fdb87dcb672c28f7$export$d34966752335dd47 = [
    (0, $jbunQ.default),
    (0, $5adWy.default),
    (0, $bDxli.default),
    (0, $iJvlY.default),
    (0, $bbP3o.default),
    (0, $a5BAZ.default),
    (0, $hABNX.default),
    (0, $gNAUH.default),
    (0, $gvY5G.default)
];
var $fdb87dcb672c28f7$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $eoZLp.popperGenerator)({
    defaultModifiers: $fdb87dcb672c28f7$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("eoZLp", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", function () { return $a7c337914e2302ee$export$ed5e13716264f202; });

var $f0xEv = parcelRequire("f0xEv");

var $fwt70 = parcelRequire("fwt70");

var $8gnVX = parcelRequire("8gnVX");

var $2yGDr = parcelRequire("2yGDr");

var $j2r9k = parcelRequire("j2r9k");

var $6apSG = parcelRequire("6apSG");

var $3qbPL = parcelRequire("3qbPL");


var $f0LQT = parcelRequire("f0LQT");
var $a7c337914e2302ee$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $a7c337914e2302ee$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $a7c337914e2302ee$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $a7c337914e2302ee$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $a7c337914e2302ee$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var _$options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, _$options);
                state.scrollParents = {
                    reference: (0, $f0LQT.isElement)(reference) ? (0, $8gnVX.default)(reference) : reference.contextElement ? (0, $8gnVX.default)(reference.contextElement) : [],
                    popper: (0, $8gnVX.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $j2r9k.default)((0, $3qbPL.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, _$reference = _state$elements.reference, _$popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$a7c337914e2302ee$var$areValidElements(_$reference, _$popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $f0xEv.default)(_$reference, (0, $2yGDr.default)(_$popper), state.options.strategy === "fixed"),
                    popper: (0, $fwt70.default)(_$popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $6apSG.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$a7c337914e2302ee$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, _$options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: _$options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $a7c337914e2302ee$export$8f7491d57c8f97a9 = /*#__PURE__*/ $a7c337914e2302ee$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("f0xEv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aed0f5bd5a2fe4fb$export$2e2bcd8739ae039; });

var $3CoUz = parcelRequire("3CoUz");

var $1dIoR = parcelRequire("1dIoR");

var $gAlLz = parcelRequire("gAlLz");

var $f0LQT = parcelRequire("f0LQT");

var $2lJzP = parcelRequire("2lJzP");

var $1SUSD = parcelRequire("1SUSD");

var $ffFkM = parcelRequire("ffFkM");

var $fFRyz = parcelRequire("fFRyz");
function $aed0f5bd5a2fe4fb$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $fFRyz.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $fFRyz.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $aed0f5bd5a2fe4fb$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $f0LQT.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $f0LQT.isHTMLElement)(offsetParent) && $aed0f5bd5a2fe4fb$var$isElementScaled(offsetParent);
    var documentElement = (0, $1SUSD.default)(offsetParent);
    var rect = (0, $3CoUz.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $gAlLz.default)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $ffFkM.default)(documentElement)) scroll = (0, $1dIoR.default)(offsetParent);
        if ((0, $f0LQT.isHTMLElement)(offsetParent)) {
            offsets = (0, $3CoUz.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $2lJzP.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("3CoUz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a283e9f69fa5241$export$2e2bcd8739ae039; });

var $f0LQT = parcelRequire("f0LQT");

var $fFRyz = parcelRequire("fFRyz");

var $f3Mqv = parcelRequire("f3Mqv");

var $18R1S = parcelRequire("18R1S");
function $2a283e9f69fa5241$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $f0LQT.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $fFRyz.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $fFRyz.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $f0LQT.isElement)(element) ? (0, $f3Mqv.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $18R1S.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("f0LQT", function(module, exports) {

$parcel$export(module.exports, "isElement", function () { return $aedbf98734c0722d$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $aedbf98734c0722d$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isShadowRoot", function () { return $aedbf98734c0722d$export$af51f0f06c0f328a; });

var $f3Mqv = parcelRequire("f3Mqv");
function $aedbf98734c0722d$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $f3Mqv.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $aedbf98734c0722d$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $f3Mqv.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $aedbf98734c0722d$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $f3Mqv.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("f3Mqv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af6cb34ec3a60734$export$2e2bcd8739ae039; });
function $af6cb34ec3a60734$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("fFRyz", function(module, exports) {

$parcel$export(module.exports, "max", function () { return $b6943a8f1c24fba3$export$8960430cfd85939f; });
$parcel$export(module.exports, "min", function () { return $b6943a8f1c24fba3$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "round", function () { return $b6943a8f1c24fba3$export$2077e0241d6afd3c; });
var $b6943a8f1c24fba3$export$8960430cfd85939f = Math.max;
var $b6943a8f1c24fba3$export$96ec731ed4dcb222 = Math.min;
var $b6943a8f1c24fba3$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("18R1S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0d4fac486dac360c$export$2e2bcd8739ae039; });

var $3RLft = parcelRequire("3RLft");
function $0d4fac486dac360c$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $3RLft.default)());
}

});
parcelRegister("3RLft", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d0af8e94a9c35a9$export$2e2bcd8739ae039; });
function $2d0af8e94a9c35a9$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}

});



parcelRegister("1dIoR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e397246105daaeb$export$2e2bcd8739ae039; });

var $74nQ5 = parcelRequire("74nQ5");

var $f3Mqv = parcelRequire("f3Mqv");

var $f0LQT = parcelRequire("f0LQT");

var $541sF = parcelRequire("541sF");
function $0e397246105daaeb$export$2e2bcd8739ae039(node) {
    if (node === (0, $f3Mqv.default)(node) || !(0, $f0LQT.isHTMLElement)(node)) return (0, $74nQ5.default)(node);
    else return (0, $541sF.default)(node);
}

});
parcelRegister("74nQ5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $525b660ce7696abf$export$2e2bcd8739ae039; });

var $f3Mqv = parcelRequire("f3Mqv");
function $525b660ce7696abf$export$2e2bcd8739ae039(node) {
    var win = (0, $f3Mqv.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("541sF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3afe75a669dc91ac$export$2e2bcd8739ae039; });
function $3afe75a669dc91ac$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("gAlLz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c130e4747aae88d7$export$2e2bcd8739ae039; });
function $c130e4747aae88d7$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}

});

parcelRegister("2lJzP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b60e58e3765036c$export$2e2bcd8739ae039; });

var $3CoUz = parcelRequire("3CoUz");

var $1SUSD = parcelRequire("1SUSD");

var $74nQ5 = parcelRequire("74nQ5");
function $1b60e58e3765036c$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $3CoUz.default)((0, $1SUSD.default)(element)).left + (0, $74nQ5.default)(element).scrollLeft;
}

});
parcelRegister("1SUSD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15f6f4d34d8bd4a5$export$2e2bcd8739ae039; });

var $f0LQT = parcelRequire("f0LQT");
function $15f6f4d34d8bd4a5$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $f0LQT.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("ffFkM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b1a851d3c50238da$export$2e2bcd8739ae039; });

var $Gp0UX = parcelRequire("Gp0UX");
function $b1a851d3c50238da$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $Gp0UX.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("Gp0UX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07f75393f96c23d1$export$2e2bcd8739ae039; });

var $f3Mqv = parcelRequire("f3Mqv");
function $07f75393f96c23d1$export$2e2bcd8739ae039(element) {
    return (0, $f3Mqv.default)(element).getComputedStyle(element);
}

});



parcelRegister("fwt70", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b4d06d32dda8bb29$export$2e2bcd8739ae039; });

var $3CoUz = parcelRequire("3CoUz");
function $b4d06d32dda8bb29$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $3CoUz.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("8gnVX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $604262165ab4df09$export$2e2bcd8739ae039; });

var $bqzis = parcelRequire("bqzis");

var $liuiz = parcelRequire("liuiz");

var $f3Mqv = parcelRequire("f3Mqv");

var $ffFkM = parcelRequire("ffFkM");
function $604262165ab4df09$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $bqzis.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $f3Mqv.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $ffFkM.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($604262165ab4df09$export$2e2bcd8739ae039((0, $liuiz.default)(target)));
}

});
parcelRegister("bqzis", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $851d80a14c201c2c$export$2e2bcd8739ae039; });

var $liuiz = parcelRequire("liuiz");

var $ffFkM = parcelRequire("ffFkM");

var $gAlLz = parcelRequire("gAlLz");

var $f0LQT = parcelRequire("f0LQT");
function $851d80a14c201c2c$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $gAlLz.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $f0LQT.isHTMLElement)(node) && (0, $ffFkM.default)(node)) return node;
    return $851d80a14c201c2c$export$2e2bcd8739ae039((0, $liuiz.default)(node));
}

});
parcelRegister("liuiz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f812c80dbaf5026c$export$2e2bcd8739ae039; });

var $gAlLz = parcelRequire("gAlLz");

var $1SUSD = parcelRequire("1SUSD");

var $f0LQT = parcelRequire("f0LQT");
function $f812c80dbaf5026c$export$2e2bcd8739ae039(element) {
    if ((0, $gAlLz.default)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $f0LQT.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $1SUSD.default)(element) // fallback
    );
}

});



parcelRegister("2yGDr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1dcfd4378e3f7b2b$export$2e2bcd8739ae039; });

var $f3Mqv = parcelRequire("f3Mqv");

var $gAlLz = parcelRequire("gAlLz");

var $Gp0UX = parcelRequire("Gp0UX");

var $f0LQT = parcelRequire("f0LQT");

var $6iGB2 = parcelRequire("6iGB2");

var $liuiz = parcelRequire("liuiz");

var $3RLft = parcelRequire("3RLft");
function $1dcfd4378e3f7b2b$var$getTrueOffsetParent(element) {
    if (!(0, $f0LQT.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $Gp0UX.default)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $1dcfd4378e3f7b2b$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $3RLft.default)());
    var isIE = /Trident/i.test((0, $3RLft.default)());
    if (isIE && (0, $f0LQT.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $Gp0UX.default)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $liuiz.default)(element);
    if ((0, $f0LQT.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $f0LQT.isHTMLElement)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $gAlLz.default)(currentNode)) < 0){
        var css = (0, $Gp0UX.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $1dcfd4378e3f7b2b$export$2e2bcd8739ae039(element) {
    var window = (0, $f3Mqv.default)(element);
    var offsetParent = $1dcfd4378e3f7b2b$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $6iGB2.default)(offsetParent) && (0, $Gp0UX.default)(offsetParent).position === "static")offsetParent = $1dcfd4378e3f7b2b$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $gAlLz.default)(offsetParent) === "html" || (0, $gAlLz.default)(offsetParent) === "body" && (0, $Gp0UX.default)(offsetParent).position === "static")) return window;
    return offsetParent || $1dcfd4378e3f7b2b$var$getContainingBlock(element) || window;
}

});
parcelRegister("6iGB2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49657749c355d726$export$2e2bcd8739ae039; });

var $gAlLz = parcelRequire("gAlLz");
function $49657749c355d726$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $gAlLz.default)(element)) >= 0;
}

});


parcelRegister("j2r9k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ddc34388ad9c74f0$export$2e2bcd8739ae039; });

var $8sePK = parcelRequire("8sePK");
function $ddc34388ad9c74f0$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $ddc34388ad9c74f0$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $ddc34388ad9c74f0$var$order(modifiers); // order based on phase
    return (0, $8sePK.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("8sePK", function(module, exports) {

$parcel$export(module.exports, "top", function () { return $627c71e31dd38e96$export$1e95b668f3b82d; });
$parcel$export(module.exports, "bottom", function () { return $627c71e31dd38e96$export$40e543e69a8b3fbb; });
$parcel$export(module.exports, "right", function () { return $627c71e31dd38e96$export$79ffe56a765070d2; });
$parcel$export(module.exports, "left", function () { return $627c71e31dd38e96$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "auto", function () { return $627c71e31dd38e96$export$dfb5619354ba860; });
$parcel$export(module.exports, "basePlacements", function () { return $627c71e31dd38e96$export$aec2ce47c367b8c3; });
$parcel$export(module.exports, "start", function () { return $627c71e31dd38e96$export$b3571188c770cc5a; });
$parcel$export(module.exports, "end", function () { return $627c71e31dd38e96$export$bd5df0f255a350f8; });
$parcel$export(module.exports, "clippingParents", function () { return $627c71e31dd38e96$export$390fd549c5303b4d; });
$parcel$export(module.exports, "viewport", function () { return $627c71e31dd38e96$export$d7b7311ec04a3e8f; });
$parcel$export(module.exports, "popper", function () { return $627c71e31dd38e96$export$ae5ab1c730825774; });
$parcel$export(module.exports, "reference", function () { return $627c71e31dd38e96$export$ca50aac9f3ba507f; });
$parcel$export(module.exports, "variationPlacements", function () { return $627c71e31dd38e96$export$368f9a87e87fa4e1; });
$parcel$export(module.exports, "placements", function () { return $627c71e31dd38e96$export$803cd8101b6c182b; });
$parcel$export(module.exports, "modifierPhases", function () { return $627c71e31dd38e96$export$d087d3878fdf71d5; });
var $627c71e31dd38e96$export$1e95b668f3b82d = "top";
var $627c71e31dd38e96$export$40e543e69a8b3fbb = "bottom";
var $627c71e31dd38e96$export$79ffe56a765070d2 = "right";
var $627c71e31dd38e96$export$eabcd2c8791e7bf4 = "left";
var $627c71e31dd38e96$export$dfb5619354ba860 = "auto";
var $627c71e31dd38e96$export$aec2ce47c367b8c3 = [
    $627c71e31dd38e96$export$1e95b668f3b82d,
    $627c71e31dd38e96$export$40e543e69a8b3fbb,
    $627c71e31dd38e96$export$79ffe56a765070d2,
    $627c71e31dd38e96$export$eabcd2c8791e7bf4
];
var $627c71e31dd38e96$export$b3571188c770cc5a = "start";
var $627c71e31dd38e96$export$bd5df0f255a350f8 = "end";
var $627c71e31dd38e96$export$390fd549c5303b4d = "clippingParents";
var $627c71e31dd38e96$export$d7b7311ec04a3e8f = "viewport";
var $627c71e31dd38e96$export$ae5ab1c730825774 = "popper";
var $627c71e31dd38e96$export$ca50aac9f3ba507f = "reference";
var $627c71e31dd38e96$export$368f9a87e87fa4e1 = /*#__PURE__*/ $627c71e31dd38e96$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $627c71e31dd38e96$export$b3571188c770cc5a,
        placement + "-" + $627c71e31dd38e96$export$bd5df0f255a350f8
    ]);
}, []);
var $627c71e31dd38e96$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($627c71e31dd38e96$export$aec2ce47c367b8c3, [
    $627c71e31dd38e96$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $627c71e31dd38e96$export$b3571188c770cc5a,
        placement + "-" + $627c71e31dd38e96$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $627c71e31dd38e96$export$421679a7c3d56e = "beforeRead";
var $627c71e31dd38e96$export$aafa59e2e03f2942 = "read";
var $627c71e31dd38e96$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $627c71e31dd38e96$export$c65e99957a05207c = "beforeMain";
var $627c71e31dd38e96$export$f22da7240b7add18 = "main";
var $627c71e31dd38e96$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $627c71e31dd38e96$export$8d4d2d70e7d46032 = "beforeWrite";
var $627c71e31dd38e96$export$68d8715fc104d294 = "write";
var $627c71e31dd38e96$export$70a6e5159acce2e6 = "afterWrite";
var $627c71e31dd38e96$export$d087d3878fdf71d5 = [
    $627c71e31dd38e96$export$421679a7c3d56e,
    $627c71e31dd38e96$export$aafa59e2e03f2942,
    $627c71e31dd38e96$export$6964f6c886723980,
    $627c71e31dd38e96$export$c65e99957a05207c,
    $627c71e31dd38e96$export$f22da7240b7add18,
    $627c71e31dd38e96$export$bab79516f2d662fe,
    $627c71e31dd38e96$export$8d4d2d70e7d46032,
    $627c71e31dd38e96$export$68d8715fc104d294,
    $627c71e31dd38e96$export$70a6e5159acce2e6
];

});


parcelRegister("6apSG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $47d7c0ade81554d5$export$2e2bcd8739ae039; });
function $47d7c0ade81554d5$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("3qbPL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $27dcfac06bc83ea3$export$2e2bcd8739ae039; });
function $27dcfac06bc83ea3$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("jbunQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $df769cf55660f08e$export$2e2bcd8739ae039; });

var $f3Mqv = parcelRequire("f3Mqv");
var $df769cf55660f08e$var$passive = {
    passive: true
};
function $df769cf55660f08e$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $f3Mqv.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $df769cf55660f08e$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $df769cf55660f08e$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $df769cf55660f08e$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $df769cf55660f08e$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $df769cf55660f08e$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $df769cf55660f08e$var$effect,
    data: {}
};

});

parcelRegister("5adWy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c28b3d197e80476$export$2e2bcd8739ae039; });

var $2O2xF = parcelRequire("2O2xF");
function $3c28b3d197e80476$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $2O2xF.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $3c28b3d197e80476$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $3c28b3d197e80476$var$popperOffsets,
    data: {}
};

});
parcelRegister("2O2xF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $20b239195d1f63f1$export$2e2bcd8739ae039; });

var $hSSa4 = parcelRequire("hSSa4");

var $cvnIc = parcelRequire("cvnIc");

var $2jg7K = parcelRequire("2jg7K");

var $8sePK = parcelRequire("8sePK");
function $20b239195d1f63f1$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $hSSa4.default)(placement) : null;
    var variation = placement ? (0, $cvnIc.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $8sePK.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $8sePK.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $8sePK.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $8sePK.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $2jg7K.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $8sePK.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $8sePK.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("hSSa4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0517e2b4275dcfe$export$2e2bcd8739ae039; });

function $d0517e2b4275dcfe$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}

});

parcelRegister("cvnIc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91aac5f511cacf19$export$2e2bcd8739ae039; });
function $91aac5f511cacf19$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}

});

parcelRegister("2jg7K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ae9dd00dcf6a9b1$export$2e2bcd8739ae039; });
function $1ae9dd00dcf6a9b1$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}

});



parcelRegister("bDxli", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $878d3357246efe25$export$2e2bcd8739ae039; });

var $8sePK = parcelRequire("8sePK");

var $2yGDr = parcelRequire("2yGDr");

var $f3Mqv = parcelRequire("f3Mqv");

var $1SUSD = parcelRequire("1SUSD");

var $Gp0UX = parcelRequire("Gp0UX");

var $hSSa4 = parcelRequire("hSSa4");

var $cvnIc = parcelRequire("cvnIc");

var $fFRyz = parcelRequire("fFRyz");
var $878d3357246efe25$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $878d3357246efe25$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $fFRyz.round)(x * dpr) / dpr || 0,
        y: (0, $fFRyz.round)(y * dpr) / dpr || 0
    };
}
function $878d3357246efe25$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $8sePK.left);
    var sideY = (0, $8sePK.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $2yGDr.default)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $f3Mqv.default)(popper)) {
            offsetParent = (0, $1SUSD.default)(popper);
            if ((0, $Gp0UX.default)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $8sePK.top) || (placement === (0, $8sePK.left) || placement === (0, $8sePK.right)) && variation === (0, $8sePK.end)) {
            sideY = (0, $8sePK.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $8sePK.left) || (placement === (0, $8sePK.top) || placement === (0, $8sePK.bottom)) && variation === (0, $8sePK.end)) {
            sideX = (0, $8sePK.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $878d3357246efe25$var$unsetSides);
    var _ref4 = roundOffsets === true ? $878d3357246efe25$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $f3Mqv.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $878d3357246efe25$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $hSSa4.default)(state.placement),
        variation: (0, $cvnIc.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $878d3357246efe25$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $878d3357246efe25$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $878d3357246efe25$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $878d3357246efe25$var$computeStyles,
    data: {}
};

});

parcelRegister("iJvlY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da34c01ed6ecd80d$export$2e2bcd8739ae039; });

var $gAlLz = parcelRequire("gAlLz");

var $f0LQT = parcelRequire("f0LQT");
// and applies them to the HTMLElements such as popper and arrow
function $da34c01ed6ecd80d$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $f0LQT.isHTMLElement)(element) || !(0, $gAlLz.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $da34c01ed6ecd80d$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $f0LQT.isHTMLElement)(element) || !(0, $gAlLz.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $da34c01ed6ecd80d$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $da34c01ed6ecd80d$var$applyStyles,
    effect: $da34c01ed6ecd80d$var$effect,
    requires: [
        "computeStyles"
    ]
};

});

parcelRegister("bbP3o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $82585302cc8cf79e$export$2e2bcd8739ae039; });

var $hSSa4 = parcelRequire("hSSa4");

var $8sePK = parcelRequire("8sePK");
function $82585302cc8cf79e$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $hSSa4.default)(placement);
    var invertDistance = [
        (0, $8sePK.left),
        (0, $8sePK.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $8sePK.left),
        (0, $8sePK.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $82585302cc8cf79e$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, _$offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $8sePK.placements).reduce(function(acc, placement) {
        acc[placement] = $82585302cc8cf79e$export$7fa02d8595b015ed(placement, state.rects, _$offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $82585302cc8cf79e$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $82585302cc8cf79e$var$offset
};

});

parcelRegister("a5BAZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $758788ba757493e3$export$2e2bcd8739ae039; });

var $5K6tU = parcelRequire("5K6tU");

var $hSSa4 = parcelRequire("hSSa4");

var $7tdOa = parcelRequire("7tdOa");

var $3oxfR = parcelRequire("3oxfR");

var $aqEsD = parcelRequire("aqEsD");

var $8sePK = parcelRequire("8sePK");

var $cvnIc = parcelRequire("cvnIc");
function $758788ba757493e3$var$getExpandedFallbackPlacements(placement) {
    if ((0, $hSSa4.default)(placement) === (0, $8sePK.auto)) return [];
    var oppositePlacement = (0, $5K6tU.default)(placement);
    return [
        (0, $7tdOa.default)(placement),
        oppositePlacement,
        (0, $7tdOa.default)(oppositePlacement)
    ];
}
function $758788ba757493e3$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $hSSa4.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $5K6tU.default)(preferredPlacement)
    ] : $758788ba757493e3$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $hSSa4.default)(placement) === (0, $8sePK.auto) ? (0, $aqEsD.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $hSSa4.default)(placement);
        var isStartVariation = (0, $cvnIc.default)(placement) === (0, $8sePK.start);
        var isVertical = [
            (0, $8sePK.top),
            (0, $8sePK.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $3oxfR.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $8sePK.right) : (0, $8sePK.left) : isStartVariation ? (0, $8sePK.bottom) : (0, $8sePK.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $5K6tU.default)(mainVariationSide);
        var altVariationSide = (0, $5K6tU.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $758788ba757493e3$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $758788ba757493e3$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("5K6tU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42e646b8ae3d74d5$export$2e2bcd8739ae039; });
var $42e646b8ae3d74d5$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $42e646b8ae3d74d5$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $42e646b8ae3d74d5$var$hash[matched];
    });
}

});

parcelRegister("7tdOa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5705f3d3e0f935ea$export$2e2bcd8739ae039; });
var $5705f3d3e0f935ea$var$hash = {
    start: "end",
    end: "start"
};
function $5705f3d3e0f935ea$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $5705f3d3e0f935ea$var$hash[matched];
    });
}

});

parcelRegister("3oxfR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $278d68b96bbcd402$export$2e2bcd8739ae039; });

var $aP7rv = parcelRequire("aP7rv");

var $1SUSD = parcelRequire("1SUSD");

var $3CoUz = parcelRequire("3CoUz");

var $2O2xF = parcelRequire("2O2xF");

var $6UgXl = parcelRequire("6UgXl");

var $8sePK = parcelRequire("8sePK");

var $f0LQT = parcelRequire("f0LQT");

var $71d4G = parcelRequire("71d4G");

var $cijbE = parcelRequire("cijbE");
function $278d68b96bbcd402$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $8sePK.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $8sePK.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $8sePK.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $71d4G.default)(typeof padding !== "number" ? padding : (0, $cijbE.default)(padding, (0, $8sePK.basePlacements)));
    var altContext = elementContext === (0, $8sePK.popper) ? (0, $8sePK.reference) : (0, $8sePK.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $aP7rv.default)((0, $f0LQT.isElement)(element) ? element : element.contextElement || (0, $1SUSD.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $3CoUz.default)(state.elements.reference);
    var popperOffsets = (0, $2O2xF.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $6UgXl.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $8sePK.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $8sePK.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $8sePK.right),
                (0, $8sePK.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $8sePK.top),
                (0, $8sePK.bottom)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("aP7rv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e1470c6f1298b91$export$2e2bcd8739ae039; });

var $8sePK = parcelRequire("8sePK");

var $gJrUs = parcelRequire("gJrUs");

var $jZUya = parcelRequire("jZUya");

var $8gnVX = parcelRequire("8gnVX");

var $2yGDr = parcelRequire("2yGDr");

var $1SUSD = parcelRequire("1SUSD");

var $Gp0UX = parcelRequire("Gp0UX");

var $f0LQT = parcelRequire("f0LQT");

var $3CoUz = parcelRequire("3CoUz");

var $liuiz = parcelRequire("liuiz");

var $eFrBR = parcelRequire("eFrBR");

var $gAlLz = parcelRequire("gAlLz");

var $6UgXl = parcelRequire("6UgXl");

var $fFRyz = parcelRequire("fFRyz");
function $7e1470c6f1298b91$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $3CoUz.default)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $7e1470c6f1298b91$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $8sePK.viewport) ? (0, $6UgXl.default)((0, $gJrUs.default)(element, strategy)) : (0, $f0LQT.isElement)(clippingParent) ? $7e1470c6f1298b91$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $6UgXl.default)((0, $jZUya.default)((0, $1SUSD.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $7e1470c6f1298b91$var$getClippingParents(element) {
    var clippingParents = (0, $8gnVX.default)((0, $liuiz.default)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $Gp0UX.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $f0LQT.isHTMLElement)(element) ? (0, $2yGDr.default)(element) : element;
    if (!(0, $f0LQT.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $f0LQT.isElement)(clippingParent) && (0, $eFrBR.default)(clippingParent, clipperElement) && (0, $gAlLz.default)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $7e1470c6f1298b91$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $7e1470c6f1298b91$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $7e1470c6f1298b91$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $fFRyz.max)(rect.top, accRect.top);
        accRect.right = (0, $fFRyz.min)(rect.right, accRect.right);
        accRect.bottom = (0, $fFRyz.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $fFRyz.max)(rect.left, accRect.left);
        return accRect;
    }, $7e1470c6f1298b91$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("gJrUs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2e67f929a43cf61$export$2e2bcd8739ae039; });

var $f3Mqv = parcelRequire("f3Mqv");

var $1SUSD = parcelRequire("1SUSD");

var $2lJzP = parcelRequire("2lJzP");

var $18R1S = parcelRequire("18R1S");
function $c2e67f929a43cf61$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $f3Mqv.default)(element);
    var html = (0, $1SUSD.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $18R1S.default)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $2lJzP.default)(element),
        y: y
    };
}

});

parcelRegister("jZUya", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8ef947ec98757db$export$2e2bcd8739ae039; });

var $1SUSD = parcelRequire("1SUSD");

var $Gp0UX = parcelRequire("Gp0UX");

var $2lJzP = parcelRequire("2lJzP");

var $74nQ5 = parcelRequire("74nQ5");

var $fFRyz = parcelRequire("fFRyz");
function $e8ef947ec98757db$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $1SUSD.default)(element);
    var winScroll = (0, $74nQ5.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $fFRyz.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $fFRyz.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $2lJzP.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $Gp0UX.default)(body || html).direction === "rtl") x += (0, $fFRyz.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("eFrBR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aada4fbf485ad78b$export$2e2bcd8739ae039; });

var $f0LQT = parcelRequire("f0LQT");
function $aada4fbf485ad78b$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $f0LQT.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("6UgXl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $507520350f48f746$export$2e2bcd8739ae039; });
function $507520350f48f746$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("71d4G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $51c2c4bbc9b3b637$export$2e2bcd8739ae039; });

var $5mDfl = parcelRequire("5mDfl");
function $51c2c4bbc9b3b637$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $5mDfl.default)(), paddingObject);
}

});
parcelRegister("5mDfl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e7d73590ab879d2$export$2e2bcd8739ae039; });
function $3e7d73590ab879d2$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("cijbE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f360c98de215c50$export$2e2bcd8739ae039; });
function $8f360c98de215c50$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("aqEsD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $797bb7cbe018d671$export$2e2bcd8739ae039; });

var $cvnIc = parcelRequire("cvnIc");

var $8sePK = parcelRequire("8sePK");

var $3oxfR = parcelRequire("3oxfR");

var $hSSa4 = parcelRequire("hSSa4");
function $797bb7cbe018d671$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $8sePK.placements) : _options$allowedAutoP;
    var variation = (0, $cvnIc.default)(placement);
    var placements = variation ? flipVariations ? (0, $8sePK.variationPlacements) : (0, $8sePK.variationPlacements).filter(function(placement) {
        return (0, $cvnIc.default)(placement) === variation;
    }) : (0, $8sePK.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $3oxfR.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $hSSa4.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("hABNX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cce31fb48846fad4$export$2e2bcd8739ae039; });

var $8sePK = parcelRequire("8sePK");

var $hSSa4 = parcelRequire("hSSa4");

var $2jg7K = parcelRequire("2jg7K");

var $1aRIS = parcelRequire("1aRIS");

var $lWunG = parcelRequire("lWunG");

var $fwt70 = parcelRequire("fwt70");

var $2yGDr = parcelRequire("2yGDr");

var $3oxfR = parcelRequire("3oxfR");

var $cvnIc = parcelRequire("cvnIc");

var $5mDfl = parcelRequire("5mDfl");

var $fFRyz = parcelRequire("fFRyz");
function $cce31fb48846fad4$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $3oxfR.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $hSSa4.default)(state.placement);
    var variation = (0, $cvnIc.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $2jg7K.default)(basePlacement);
    var altAxis = (0, $1aRIS.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $8sePK.top) : (0, $8sePK.left);
        var altSide = mainAxis === "y" ? (0, $8sePK.bottom) : (0, $8sePK.right);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $8sePK.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $8sePK.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $fwt70.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $5mDfl.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $lWunG.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $2yGDr.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $lWunG.within)(tether ? (0, $fFRyz.min)(min, tetherMin) : min, offset, tether ? (0, $fFRyz.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $8sePK.top) : (0, $8sePK.left);
        var _altSide = mainAxis === "x" ? (0, $8sePK.bottom) : (0, $8sePK.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $8sePK.top),
            (0, $8sePK.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $lWunG.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $lWunG.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $cce31fb48846fad4$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $cce31fb48846fad4$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};

});
parcelRegister("1aRIS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0db065d93719de22$export$2e2bcd8739ae039; });
function $0db065d93719de22$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}

});

parcelRegister("lWunG", function(module, exports) {

$parcel$export(module.exports, "within", function () { return $ff9694c3167be62e$export$f28d906d67a997f3; });
$parcel$export(module.exports, "withinMaxClamp", function () { return $ff9694c3167be62e$export$86c8af6d3ef0b4a; });

var $fFRyz = parcelRequire("fFRyz");
function $ff9694c3167be62e$export$f28d906d67a997f3(min, value, max) {
    return (0, $fFRyz.max)(min, (0, $fFRyz.min)(value, max));
}
function $ff9694c3167be62e$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $ff9694c3167be62e$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("gNAUH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c3addb2d98365a25$export$2e2bcd8739ae039; });

var $hSSa4 = parcelRequire("hSSa4");

var $fwt70 = parcelRequire("fwt70");

var $eFrBR = parcelRequire("eFrBR");

var $2yGDr = parcelRequire("2yGDr");

var $2jg7K = parcelRequire("2jg7K");

var $lWunG = parcelRequire("lWunG");

var $71d4G = parcelRequire("71d4G");

var $cijbE = parcelRequire("cijbE");

var $8sePK = parcelRequire("8sePK");
var $c3addb2d98365a25$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $71d4G.default)(typeof padding !== "number" ? padding : (0, $cijbE.default)(padding, (0, $8sePK.basePlacements)));
};
function $c3addb2d98365a25$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $hSSa4.default)(state.placement);
    var axis = (0, $2jg7K.default)(basePlacement);
    var isVertical = [
        (0, $8sePK.left),
        (0, $8sePK.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $c3addb2d98365a25$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $fwt70.default)(arrowElement);
    var minProp = axis === "y" ? (0, $8sePK.top) : (0, $8sePK.left);
    var maxProp = axis === "y" ? (0, $8sePK.bottom) : (0, $8sePK.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $2yGDr.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $lWunG.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $c3addb2d98365a25$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $eFrBR.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $c3addb2d98365a25$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $c3addb2d98365a25$var$arrow,
    effect: $c3addb2d98365a25$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};

});

parcelRegister("gvY5G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c05e275705968ab7$export$2e2bcd8739ae039; });

var $8sePK = parcelRequire("8sePK");

var $3oxfR = parcelRequire("3oxfR");
function $c05e275705968ab7$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $c05e275705968ab7$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $8sePK.top),
        (0, $8sePK.right),
        (0, $8sePK.bottom),
        (0, $8sePK.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $c05e275705968ab7$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $3oxfR.default)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $3oxfR.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $c05e275705968ab7$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $c05e275705968ab7$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $c05e275705968ab7$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $c05e275705968ab7$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $c05e275705968ab7$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $c05e275705968ab7$var$hide
};

});


parcelRegister("1PxJM", function(module, exports) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $1554b96e344edce7$var$hasElementType = typeof Element !== "undefined";
var $1554b96e344edce7$var$hasMap = typeof Map === "function";
var $1554b96e344edce7$var$hasSet = typeof Set === "function";
var $1554b96e344edce7$var$hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $1554b96e344edce7$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$1554b96e344edce7$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($1554b96e344edce7$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$1554b96e344edce7$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($1554b96e344edce7$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($1554b96e344edce7$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === "function" && typeof b.valueOf === "function") return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === "function" && typeof b.toString === "function") return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($1554b96e344edce7$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$1554b96e344edce7$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return $1554b96e344edce7$var$equal(a, b);
    } catch (error) {
        if ((error.message || "").match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("react-fast-compare cannot handle circular refs");
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});




parcelRegister("8x66C", function(module, exports) {

$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", function () { return $63662444507b9e2e$export$9d7b58831ae93caa; });
var $63662444507b9e2e$export$4ef52930e33717cd = "data-theme";
var $63662444507b9e2e$export$a00eac3f8684bcd0 = "data-color-mode";
var $63662444507b9e2e$export$2112803007239c61 = "data-contrast-mode";
var $63662444507b9e2e$export$352e418ed5b6193a = "data-custom-theme";
var $63662444507b9e2e$export$2faeed762aac6741 = "light";
var $63662444507b9e2e$export$6f0c6fb8c80fcc92 = "ds";
var $63662444507b9e2e$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $63662444507b9e2e$export$dddac1532e822863 = "--".concat($63662444507b9e2e$export$6f0c6fb8c80fcc92, "-token-not-found");
var $63662444507b9e2e$export$9d7b58831ae93caa = "--".concat($63662444507b9e2e$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRegister("aqEis", function(module, exports) {

$parcel$export(module.exports, "RepositionOnUpdate", function () { return $797b97301762a15c$export$51eddd7655ca235a; });

var $1Mpn7 = parcelRequire("1Mpn7");
var $797b97301762a15c$export$51eddd7655ca235a = function RepositionOnUpdate(_ref) {
    var children = _ref.children, update = _ref.update;
    // Ref used here to skip update on first render (when refs haven't been set)
    var isFirstRenderRef = (0, $1Mpn7.useRef)(true);
    (0, $1Mpn7.useLayoutEffect)(function() {
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update
        update();
    }, [
        update
    ]);
    // wrapping in fragment to make TS happy (known issue with FC returning children)
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $1Mpn7.Fragment), null, children);
};

});

parcelRegister("dKmhH", function(module, exports) {

$parcel$export(module.exports, "useCloseManager", function () { return $a020db7b82afe46c$export$92dae2778ae88f9d; });

var $1Mpn7 = parcelRequire("1Mpn7");

var $12aDa = parcelRequire("12aDa");

var $x0QfA = parcelRequire("x0QfA");

var $3oL5X = parcelRequire("3oL5X");
var $a020db7b82afe46c$export$92dae2778ae88f9d = function useCloseManager(_ref) {
    var isOpen = _ref.isOpen, onClose = _ref.onClose, popupRef = _ref.popupRef, triggerRef = _ref.triggerRef, capture = _ref.shouldUseCaptureOnOutsideClick;
    var _UNSAFE_useLayering = (0, $3oL5X.UNSAFE_useLayering)(), isLayerDisabled = _UNSAFE_useLayering.isLayerDisabled;
    (0, $1Mpn7.useEffect)(function() {
        if (!isOpen || !popupRef) return 0, $x0QfA.default;
        var closePopup = function closePopup(event) {
            if (onClose) onClose(event);
        };
        // This check is required for cases where components like
        // Select or DDM are placed inside a Popup. A click
        // on a MenuItem or Option would close the Popup, without registering
        // a click on DDM/Select.
        // Users would have to call `onClose` manually to close the Popup in these cases.
        // You can see the bug in action here:
        // https://codesandbox.io/s/atlaskitpopup-default-forked-2eb87?file=/example.tsx:0-1788
        var onClick = function onClick(event) {
            var target = event.target;
            var doesDomNodeExist = document.body.contains(target);
            if (!doesDomNodeExist) return;
            var isClickOnPopup = popupRef && popupRef.contains(target);
            var isClickOnTrigger = triggerRef && triggerRef.contains(target);
            if (!isClickOnPopup && !isClickOnTrigger) closePopup(event);
        };
        var onKeyDown = function onKeyDown(event) {
            if (isLayerDisabled()) return;
            var key = event.key;
            if (key === "Escape" || key === "Esc") closePopup(event);
        };
        var unbind = (0, $12aDa.bindAll)(window, [
            {
                type: "click",
                listener: onClick,
                options: {
                    capture: capture
                }
            },
            {
                type: "keydown",
                listener: onKeyDown
            }
        ]);
        return unbind;
    }, [
        isOpen,
        onClose,
        popupRef,
        triggerRef,
        capture,
        isLayerDisabled
    ]);
};

});
parcelRegister("3oL5X", function(module, exports) {

$parcel$export(module.exports, "useCloseOnEscapePress", function () { return $2798251c5c169149$export$4a4bf067ea9e7886; });
$parcel$export(module.exports, "UNSAFE_useLayering", function () { return $2798251c5c169149$export$cec37b93989366d4; });

var $1Mpn7 = parcelRequire("1Mpn7");

var $12aDa = parcelRequire("12aDa");

var $dNl4p = parcelRequire("dNl4p");
var $2798251c5c169149$var$ESCAPE = "Escape";
function $2798251c5c169149$export$4a4bf067ea9e7886(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $1Mpn7.useRef)(false);
    var _UNSAFE_useLayering = $2798251c5c169149$export$cec37b93989366d4(), isLayerDisabled = _UNSAFE_useLayering.isLayerDisabled;
    var onKeyDown = (0, $1Mpn7.useCallback)(function(e) {
        var isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $2798251c5c169149$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    var onKeyUp = (0, $1Mpn7.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $1Mpn7.useEffect)(function() {
        return (0, $12aDa.bindAll)(document, [
            {
                type: "keydown",
                listener: onKeyDown
            },
            {
                type: "keyup",
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $2798251c5c169149$export$cec37b93989366d4() {
    var currentLevel = (0, $1Mpn7.useContext)((0, $dNl4p.LevelContext));
    var _useContext = (0, $1Mpn7.useContext)((0, $dNl4p.TopLevelContext)), topLevelRef = _useContext.topLevelRef;
    var isLayerDisabled = (0, $1Mpn7.useCallback)(function() {
        return !!topLevelRef.current && currentLevel !== topLevelRef.current;
    }, [
        currentLevel,
        topLevelRef
    ]);
    return {
        currentLevel: currentLevel,
        topLevelRef: topLevelRef,
        isLayerDisabled: isLayerDisabled
    };
}

});


parcelRegister("gB1Qc", function(module, exports) {

$parcel$export(module.exports, "useFocusManager", function () { return $c1518797d04b5ab5$export$10c5169755ce7bd7; });

var $1Mpn7 = parcelRequire("1Mpn7");

var $dKZSK = parcelRequire("dKZSK");

var $x0QfA = parcelRequire("x0QfA");
var $c1518797d04b5ab5$export$10c5169755ce7bd7 = function useFocusManager(_ref) {
    var initialFocusRef = _ref.initialFocusRef, popupRef = _ref.popupRef;
    (0, $1Mpn7.useEffect)(function() {
        if (!popupRef) return 0, $x0QfA.default;
        var trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: true,
            initialFocus: initialFocusRef || popupRef,
            fallbackFocus: popupRef,
            returnFocusOnDeactivate: true
        };
        var focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($dKZSK)))(popupRef, trapConfig);
        var frameId = null;
        // wait for the popup to reposition itself before we focus
        frameId = requestAnimationFrame(function() {
            frameId = null;
            focusTrap.activate();
        });
        return function() {
            if (frameId != null) {
                cancelAnimationFrame(frameId);
                frameId = null;
            }
            focusTrap.deactivate();
        };
    }, [
        popupRef,
        initialFocusRef
    ]);
};

});
parcelRegister("dKZSK", function(module, exports) {

var $2PpPD = parcelRequire("2PpPD");
var $a03f92b6cdfeca5f$var$listeningFocusTrap = null;
function $a03f92b6cdfeca5f$var$focusTrap(element, userOptions) {
    var tabbableNodes = [];
    var firstTabbableNode = null;
    var lastTabbableNode = null;
    var nodeFocusedBeforeActivation = null;
    var active = false;
    var paused = false;
    var tabEvent = null;
    var container = typeof element === "string" ? document.querySelector(element) : element;
    var config = userOptions || {};
    config.returnFocusOnDeactivate = userOptions && userOptions.returnFocusOnDeactivate !== undefined ? userOptions.returnFocusOnDeactivate : true;
    config.escapeDeactivates = userOptions && userOptions.escapeDeactivates !== undefined ? userOptions.escapeDeactivates : true;
    var trap = {
        activate: activate,
        deactivate: deactivate,
        pause: pause,
        unpause: unpause
    };
    return trap;
    function activate(activateOptions) {
        if (active) return;
        var defaultedActivateOptions = {
            onActivate: activateOptions && activateOptions.onActivate !== undefined ? activateOptions.onActivate : config.onActivate
        };
        active = true;
        paused = false;
        nodeFocusedBeforeActivation = document.activeElement;
        if (defaultedActivateOptions.onActivate) defaultedActivateOptions.onActivate();
        addListeners();
        return trap;
    }
    function deactivate(deactivateOptions) {
        if (!active) return;
        var defaultedDeactivateOptions = {
            returnFocus: deactivateOptions && deactivateOptions.returnFocus !== undefined ? deactivateOptions.returnFocus : config.returnFocusOnDeactivate,
            onDeactivate: deactivateOptions && deactivateOptions.onDeactivate !== undefined ? deactivateOptions.onDeactivate : config.onDeactivate
        };
        removeListeners();
        if (defaultedDeactivateOptions.onDeactivate) defaultedDeactivateOptions.onDeactivate();
        if (defaultedDeactivateOptions.returnFocus) setTimeout(function() {
            $a03f92b6cdfeca5f$var$tryFocus(nodeFocusedBeforeActivation);
        }, 0);
        active = false;
        paused = false;
        return this;
    }
    function pause() {
        if (paused || !active) return;
        paused = true;
        removeListeners();
    }
    function unpause() {
        if (!paused || !active) return;
        paused = false;
        addListeners();
    }
    function addListeners() {
        if (!active) return;
        // There can be only one listening focus trap at a time
        if ($a03f92b6cdfeca5f$var$listeningFocusTrap) $a03f92b6cdfeca5f$var$listeningFocusTrap.pause();
        $a03f92b6cdfeca5f$var$listeningFocusTrap = trap;
        updateTabbableNodes();
        // Ensure that the focused element doesn't capture the event that caused the focus trap activation
        setTimeout(function() {
            $a03f92b6cdfeca5f$var$tryFocus(firstFocusNode());
        }, 0);
        document.addEventListener("focus", checkFocus, true);
        document.addEventListener("click", checkClick, true);
        document.addEventListener("mousedown", checkPointerDown, true);
        document.addEventListener("touchstart", checkPointerDown, true);
        document.addEventListener("keydown", checkKey, true);
        return trap;
    }
    function removeListeners() {
        if (!active || $a03f92b6cdfeca5f$var$listeningFocusTrap !== trap) return;
        document.removeEventListener("focus", checkFocus, true);
        document.removeEventListener("click", checkClick, true);
        document.removeEventListener("mousedown", checkPointerDown, true);
        document.removeEventListener("touchstart", checkPointerDown, true);
        document.removeEventListener("keydown", checkKey, true);
        $a03f92b6cdfeca5f$var$listeningFocusTrap = null;
        return trap;
    }
    function getNodeForOption(optionName) {
        var optionValue = config[optionName];
        var node = optionValue;
        if (!optionValue) return null;
        if (typeof optionValue === "string") {
            node = document.querySelector(optionValue);
            if (!node) throw new Error("`" + optionName + "` refers to no known node");
        }
        if (typeof optionValue === "function") {
            node = optionValue();
            if (!node) throw new Error("`" + optionName + "` did not return a node");
        }
        return node;
    }
    function firstFocusNode() {
        var node;
        if (getNodeForOption("initialFocus") !== null) node = getNodeForOption("initialFocus");
        else if (container.contains(document.activeElement)) node = document.activeElement;
        else node = tabbableNodes[0] || getNodeForOption("fallbackFocus");
        if (!node) throw new Error("You can't have a focus-trap without at least one focusable element");
        return node;
    }
    // This needs to be done on mousedown and touchstart instead of click
    // so that it precedes the focus event
    function checkPointerDown(e) {
        if (config.clickOutsideDeactivates && !container.contains(e.target)) deactivate({
            returnFocus: false
        });
    }
    function checkClick(e) {
        if (config.clickOutsideDeactivates) return;
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    }
    function checkFocus(e) {
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        // Checking for a blur method here resolves a Firefox issue (#15)
        if (typeof e.target.blur === "function") e.target.blur();
        if (tabEvent) readjustFocus(tabEvent);
    }
    function checkKey(e) {
        if (e.key === "Tab" || e.keyCode === 9) handleTab(e);
        if (config.escapeDeactivates !== false && $a03f92b6cdfeca5f$var$isEscapeEvent(e)) deactivate();
    }
    function handleTab(e) {
        updateTabbableNodes();
        if (e.target.hasAttribute("tabindex") && Number(e.target.getAttribute("tabindex")) < 0) return tabEvent = e;
        e.preventDefault();
        var currentFocusIndex = tabbableNodes.indexOf(e.target);
        if (e.shiftKey) {
            if (e.target === firstTabbableNode || tabbableNodes.indexOf(e.target) === -1) return $a03f92b6cdfeca5f$var$tryFocus(lastTabbableNode);
            return $a03f92b6cdfeca5f$var$tryFocus(tabbableNodes[currentFocusIndex - 1]);
        }
        if (e.target === lastTabbableNode) return $a03f92b6cdfeca5f$var$tryFocus(firstTabbableNode);
        $a03f92b6cdfeca5f$var$tryFocus(tabbableNodes[currentFocusIndex + 1]);
    }
    function updateTabbableNodes() {
        tabbableNodes = $2PpPD(container);
        firstTabbableNode = tabbableNodes[0];
        lastTabbableNode = tabbableNodes[tabbableNodes.length - 1];
    }
    function readjustFocus(e) {
        if (e.shiftKey) return $a03f92b6cdfeca5f$var$tryFocus(lastTabbableNode);
        $a03f92b6cdfeca5f$var$tryFocus(firstTabbableNode);
    }
}
function $a03f92b6cdfeca5f$var$isEscapeEvent(e) {
    return e.key === "Escape" || e.key === "Esc" || e.keyCode === 27;
}
function $a03f92b6cdfeca5f$var$tryFocus(node) {
    if (!node || !node.focus) return;
    if (node === document.activeElement) return;
    node.focus();
    if (node.tagName.toLowerCase() === "input") node.select();
}
module.exports = $a03f92b6cdfeca5f$var$focusTrap;

});
parcelRegister("2PpPD", function(module, exports) {
module.exports = function(el, options) {
    options = options || {};
    var elementDocument = el.ownerDocument || el;
    var basicTabbables = [];
    var orderedTabbables = [];
    // A node is "available" if
    // - it's computed style
    var isUnavailable = $20f461d8ca344f65$var$createIsUnavailable(elementDocument);
    var candidateSelectors = [
        "input",
        "select",
        "a[href]",
        "textarea",
        "button",
        "[tabindex]"
    ];
    var candidates = el.querySelectorAll(candidateSelectors.join(","));
    if (options.includeContainer) {
        var matches = Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
        if (candidateSelectors.some(function(candidateSelector) {
            return matches.call(el, candidateSelector);
        })) {
            candidates = Array.prototype.slice.apply(candidates);
            candidates.unshift(el);
        }
    }
    var candidate, candidateIndexAttr, candidateIndex;
    for(var i = 0, l = candidates.length; i < l; i++){
        candidate = candidates[i];
        candidateIndexAttr = parseInt(candidate.getAttribute("tabindex"), 10);
        candidateIndex = isNaN(candidateIndexAttr) ? candidate.tabIndex : candidateIndexAttr;
        if (candidateIndex < 0 || candidate.tagName === "INPUT" && candidate.type === "hidden" || candidate.disabled || isUnavailable(candidate, elementDocument)) continue;
        if (candidateIndex === 0) basicTabbables.push(candidate);
        else orderedTabbables.push({
            index: i,
            tabIndex: candidateIndex,
            node: candidate
        });
    }
    var tabbableNodes = orderedTabbables.sort(function(a, b) {
        return a.tabIndex === b.tabIndex ? a.index - b.index : a.tabIndex - b.tabIndex;
    }).map(function(a) {
        return a.node;
    });
    Array.prototype.push.apply(tabbableNodes, basicTabbables);
    return tabbableNodes;
};
function $20f461d8ca344f65$var$createIsUnavailable(elementDocument) {
    // Node cache must be refreshed on every check, in case
    // the content of the element has changed
    var isOffCache = [];
    // "off" means `display: none;`, as opposed to "hidden",
    // which means `visibility: hidden;`. getComputedStyle
    // accurately reflects visiblity in context but not
    // "off" state, so we need to recursively check parents.
    function isOff(node, nodeComputedStyle) {
        if (node === elementDocument.documentElement) return false;
        // Find the cached node (Array.prototype.find not available in IE9)
        for(var i = 0, length = isOffCache.length; i < length; i++){
            if (isOffCache[i][0] === node) return isOffCache[i][1];
        }
        nodeComputedStyle = nodeComputedStyle || elementDocument.defaultView.getComputedStyle(node);
        var result = false;
        if (nodeComputedStyle.display === "none") result = true;
        else if (node.parentNode) result = isOff(node.parentNode);
        isOffCache.push([
            node,
            result
        ]);
        return result;
    }
    return function isUnavailable(node) {
        if (node === elementDocument.documentElement) return false;
        var computedStyle = elementDocument.defaultView.getComputedStyle(node);
        if (isOff(node, computedStyle)) return true;
        return computedStyle.visibility === "hidden";
    };
}

});






parcelRegister("RRKsg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a1ea4a3a37de652$export$2e2bcd8739ae039; });

var $eZhUW = parcelRequire("eZhUW");

var $kcuts = parcelRequire("kcuts");

var $6pDhi = parcelRequire("6pDhi");

var $jjExS = parcelRequire("jjExS");

var $6QU8A = parcelRequire("6QU8A");

var $2Yk1N = parcelRequire("2Yk1N");

var $iR7ee = parcelRequire("iR7ee");

var $6ODMR = parcelRequire("6ODMR");

var $g7WDC = parcelRequire("g7WDC");
function $0a1ea4a3a37de652$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $0a1ea4a3a37de652$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($6pDhi)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($6pDhi)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($kcuts)))(this, result);
    };
}
function $0a1ea4a3a37de652$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $0a1ea4a3a37de652$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0a1ea4a3a37de652$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0a1ea4a3a37de652$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0a1ea4a3a37de652$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0a1ea4a3a37de652$var$packageVersion = "6.1.3";
var $0a1ea4a3a37de652$var$originParamName = "atlOrigin";
var $0a1ea4a3a37de652$var$originVersioningAttributes = {
    originLibrary: "origin-tracing.js@".concat($0a1ea4a3a37de652$var$packageVersion)
};
var $0a1ea4a3a37de652$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function OriginTracer(_ref) {
        var _ref$id = _ref.id, id = _ref$id === void 0 ? OriginTracer.generateId() : _ref$id, product = _ref.product, _ref$dangerouslySkipV = _ref.dangerouslySkipValidation, dangerouslySkipValidation = _ref$dangerouslySkipV === void 0 ? false : _ref$dangerouslySkipV;
        (0, (/*@__PURE__*/$parcel$interopDefault($6QU8A)))(this, OriginTracer);
        this.id = id;
        this.product = product;
        if (!dangerouslySkipValidation) this.validate();
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($2Yk1N)))(OriginTracer, [
        {
            key: "encode",
            value: function encode() {
                return (0, $6ODMR.encode)({
                    id: this.id,
                    product: this.product
                });
            }
        },
        {
            key: "addToUrl",
            value: function addToUrl(url) {
                var _this = this;
                return $0a1ea4a3a37de652$var$replaceQuery(url, function(originalQueryString) {
                    var params = new ((0, $g7WDC.getEnv)()).URLSearchParams(originalQueryString);
                    params.set($0a1ea4a3a37de652$var$originParamName, _this.encode());
                    return params.toString();
                });
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return false;
            }
        },
        {
            key: "isMalformed",
            value: function isMalformed() {
                return !this.isEmpty() && !this.isValid();
            }
        },
        {
            key: "isValid",
            value: function isValid() {
                return true;
            }
        },
        {
            key: "toAnalyticsAttributes",
            value: function toAnalyticsAttributes() {
                var _objectSpread2;
                var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref2$transformValue = _ref2.transformValue, transformValue = _ref2$transformValue === void 0 ? function transformValue(v) {
                    return v === null ? undefined : v;
                } : _ref2$transformValue, _ref2$hasGeneratedId = _ref2.hasGeneratedId, hasGeneratedId = _ref2$hasGeneratedId === void 0 ? false : _ref2$hasGeneratedId;
                // `originIdGenerated` should be used in analytic events that generated this originId.
                // Subsequent events should use `originId`.
                // No two events should have the same value of originIdGenerated.
                var originIdProp = hasGeneratedId ? "originIdGenerated" : "originId";
                return $0a1ea4a3a37de652$var$_objectSpread((_objectSpread2 = {}, (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(_objectSpread2, originIdProp, transformValue(this.id)), (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(_objectSpread2, "originProduct", transformValue(this.product)), _objectSpread2), $0a1ea4a3a37de652$var$originVersioningAttributes);
            }
        },
        {
            key: "validate",
            value: function validate() {
                if (!OriginTracer.isValidId(this.id)) throw new TypeError("Invalid Origin id");
                if (!OriginTracer.isValidProduct(this.product)) throw new TypeError("Missing/invalid Origin product");
            }
        }
    ], [
        {
            key: "isValidId",
            value: function isValidId(value) {
                return typeof value === "string" && /^[-_a-zA-Z0-9]{1,36}$/.test(value);
            }
        },
        {
            key: "isValidProduct",
            value: function isValidProduct(value) {
                return typeof value === "string" && /^[-_a-zA-Z0-9]{1,20}$/.test(value);
            }
        },
        {
            key: "generateId",
            value: function generateId() {
                var id = (0, (/*@__PURE__*/$parcel$interopDefault($iR7ee)))();
                // Dash positions are fixed so they don't add to uniqueness.
                // Remove them to save space in the encoded form.
                return id.replace(/-/g, "");
            }
        },
        {
            key: "createEmpty",
            value: function createEmpty() {
                return new $0a1ea4a3a37de652$var$EmptyOriginTracer();
            }
        },
        {
            key: "createMalformed",
            value: function createMalformed() {
                return new $0a1ea4a3a37de652$var$MalformedOriginTracer();
            }
        },
        {
            key: "fromUrl",
            value: function fromUrl(url) {
                var params = new ((0, $g7WDC.getEnv)()).URLSearchParams();
                $0a1ea4a3a37de652$var$replaceQuery(url, function(queryString) {
                    params = new ((0, $g7WDC.getEnv)()).URLSearchParams(queryString);
                });
                return OriginTracer.fromEncoded(params.get($0a1ea4a3a37de652$var$originParamName));
            }
        },
        {
            key: "fromEncoded",
            value: function fromEncoded(encoded) {
                if (!encoded) return OriginTracer.createEmpty();
                try {
                    return OriginTracer.decode(encoded);
                } catch (e) {
                    return OriginTracer.createMalformed();
                }
            }
        },
        {
            key: "removeFromUrl",
            value: function removeFromUrl(url) {
                return $0a1ea4a3a37de652$var$replaceQuery(url, function(queryString) {
                    var params = new ((0, $g7WDC.getEnv)()).URLSearchParams(queryString);
                    params.delete($0a1ea4a3a37de652$var$originParamName);
                    return params.toString();
                });
            }
        },
        {
            key: "decode",
            value: function decode(encodedOrigin) {
                var originData = (0, $6ODMR.decode)(encodedOrigin);
                return new OriginTracer(originData);
            }
        }
    ]);
    return OriginTracer;
}();
var $0a1ea4a3a37de652$var$EmptyOriginTracer = /*#__PURE__*/ function(_OriginTracer) {
    (0, (/*@__PURE__*/$parcel$interopDefault($eZhUW)))(EmptyOriginTracer, _OriginTracer);
    var _super = $0a1ea4a3a37de652$var$_createSuper(EmptyOriginTracer);
    function EmptyOriginTracer() {
        (0, (/*@__PURE__*/$parcel$interopDefault($6QU8A)))(this, EmptyOriginTracer);
        return _super.call(this, {
            id: null,
            product: null,
            dangerouslySkipValidation: true
        });
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($2Yk1N)))(EmptyOriginTracer, [
        {
            key: "isValid",
            value: function isValid() {
                return false;
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return true;
            }
        },
        {
            key: "toAnalyticsAttributes",
            value: function toAnalyticsAttributes() {
                return $0a1ea4a3a37de652$var$_objectSpread({}, $0a1ea4a3a37de652$var$originVersioningAttributes);
            }
        }
    ]);
    return EmptyOriginTracer;
}($0a1ea4a3a37de652$export$2e2bcd8739ae039);
var $0a1ea4a3a37de652$var$MalformedOriginTracer = /*#__PURE__*/ function(_OriginTracer2) {
    (0, (/*@__PURE__*/$parcel$interopDefault($eZhUW)))(MalformedOriginTracer, _OriginTracer2);
    var _super2 = $0a1ea4a3a37de652$var$_createSuper(MalformedOriginTracer);
    function MalformedOriginTracer() {
        (0, (/*@__PURE__*/$parcel$interopDefault($6QU8A)))(this, MalformedOriginTracer);
        return _super2.call(this, {
            id: null,
            product: null,
            dangerouslySkipValidation: true
        });
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($2Yk1N)))(MalformedOriginTracer, [
        {
            key: "isValid",
            value: function isValid() {
                return false;
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return false;
            }
        },
        {
            key: "toAnalyticsAttributes",
            value: function toAnalyticsAttributes() {
                return $0a1ea4a3a37de652$var$_objectSpread({
                    originMalformed: true
                }, $0a1ea4a3a37de652$var$originVersioningAttributes);
            }
        }
    ]);
    return MalformedOriginTracer;
}($0a1ea4a3a37de652$export$2e2bcd8739ae039);
function $0a1ea4a3a37de652$var$replaceQuery(url, replacer) {
    var urlWithQueryStringRegex = /(^[^?#]*)(?:\?)?([^#]*?)(#.*|$)$/;
    // If we get passed window.location, we don't want to call window.location.replace()
    var urlString = String(url);
    return urlString.replace(urlWithQueryStringRegex, function(wholeMatch, beforeQuery, queryString, afterQuery) {
        var newQueryString = replacer(queryString);
        if (newQueryString) newQueryString = "?".concat(newQueryString);
        return "".concat(beforeQuery).concat(newQueryString).concat(afterQuery);
    });
}

});
parcelRegister("iR7ee", function(module, exports) {

var $ltw03 = parcelRequire("ltw03");

var $frVHS = parcelRequire("frVHS");
function $dba2c8a717722905$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == "string") {
        buf = options === "binary" ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $ltw03)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $frVHS(rnds);
}
module.exports = $dba2c8a717722905$var$v4;

});
parcelRegister("ltw03", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $fa2520ec15a9f29d$var$getRandomValues = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
if ($fa2520ec15a9f29d$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $fa2520ec15a9f29d$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $fa2520ec15a9f29d$var$getRandomValues($fa2520ec15a9f29d$var$rnds8);
        return $fa2520ec15a9f29d$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $fa2520ec15a9f29d$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $fa2520ec15a9f29d$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $fa2520ec15a9f29d$var$rnds;
    };
}

});

parcelRegister("frVHS", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $b3f623f679d626cb$var$byteToHex = [];
for(var $b3f623f679d626cb$var$i = 0; $b3f623f679d626cb$var$i < 256; ++$b3f623f679d626cb$var$i)$b3f623f679d626cb$var$byteToHex[$b3f623f679d626cb$var$i] = ($b3f623f679d626cb$var$i + 0x100).toString(16).substr(1);
function $b3f623f679d626cb$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $b3f623f679d626cb$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join("");
}
module.exports = $b3f623f679d626cb$var$bytesToUuid;

});


parcelRegister("6ODMR", function(module, exports) {

$parcel$export(module.exports, "encode", function () { return $4f66467888edf666$export$c564cdbbe6da493; });
$parcel$export(module.exports, "decode", function () { return $4f66467888edf666$export$2f872c0f2117be69; });

var $jPbNo = parcelRequire("jPbNo");

var $g7WDC = parcelRequire("g7WDC");
var $4f66467888edf666$var$productShorthands = {
    confluence: "c",
    jira: "j",
    stride: "s",
    bitbucket: "b",
    trello: "t"
};
function $4f66467888edf666$export$c564cdbbe6da493(originData) {
    var json = JSON.stringify($4f66467888edf666$export$4bc4b533a565aabe(originData));
    var base64 = (0, $g7WDC.getEnv)().btoa(json);
    return (0, $jPbNo.base64ToBase64Url)(base64);
}
function $4f66467888edf666$export$2f872c0f2117be69(encodedOriginString) {
    var base64 = (0, $jPbNo.base64UrlToBase64)(encodedOriginString);
    var json = (0, $g7WDC.getEnv)().atob(base64);
    return $4f66467888edf666$export$46d5cda6b884b7ab(JSON.parse(json));
}
function $4f66467888edf666$export$4bc4b533a565aabe(_ref) {
    var id = _ref.id, product = _ref.product;
    return {
        i: id,
        p: product && product in $4f66467888edf666$var$productShorthands ? $4f66467888edf666$var$productShorthands[product] : product
    };
}
function $4f66467888edf666$export$46d5cda6b884b7ab(originJSONObject) {
    var originData = {};
    if (originJSONObject.i) originData.id = originJSONObject.i;
    if (originJSONObject.p) originData.product = $4f66467888edf666$var$expandProductShorthand(originJSONObject.p);
    return originData;
}
function $4f66467888edf666$var$expandProductShorthand(maybeShorthand) {
    var products = Object.keys($4f66467888edf666$var$productShorthands);
    for(var i = 0; i < products.length; i++){
        var product = products[i];
        var shorthand = $4f66467888edf666$var$productShorthands[product];
        if (maybeShorthand === shorthand) return product;
    }
    return maybeShorthand;
}

});
parcelRegister("jPbNo", function(module, exports) {

$parcel$export(module.exports, "base64ToBase64Url", function () { return $e6ebee20555cb872$export$3b91e21dac1023c6; });
$parcel$export(module.exports, "base64UrlToBase64", function () { return $e6ebee20555cb872$export$47c5265a25535d02; });
/**
 * This file converts between Base64 and Base 64 Encoding with URL and Filename Safe Alphabet,
 * the latter of which has URL-safe characters only (drops =, + and /).
 *
 * Why not use a library? The popular libs use Buffer to be able to
 * encode any data to base64. We don't need this capability, and it causes
 * Webpack to include 30KB of a Buffer polyfill.
 * Webpack's/UglifyJS's Tree Shaking seems to be unable to drop it.
 *
 * See: RFC 4648 section 5 (https://tools.ietf.org/html/rfc4648#section-5)
 */ function $e6ebee20555cb872$export$3b91e21dac1023c6(base64) {
    if (base64 == null) return "";
    return String(base64).replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
}
function $e6ebee20555cb872$export$47c5265a25535d02(base64url) {
    if (base64url == null) return "";
    var base64 = String(base64url).replace(/-/g, "+").replace(/_/g, "/");
    var padLength = (4 - base64url.length % 4) % 4;
    var pad = "===".slice(0, padLength);
    return base64 + pad;
}

});

parcelRegister("g7WDC", function(module, exports) {

$parcel$export(module.exports, "getEnv", function () { return $bbdac916c5323159$export$4bd44a2aa29d3d6e; });

var $8dlmd = parcelRequire("8dlmd");

var $bbdac916c5323159$export$d3cd91e0fdbfdbc0 = function getEnvGlobals() {
    return {
        atob: // atob/btoa need to be bound because they throw an illegal invocation error when called as a method (obj.atob())
        typeof atob === "function" && atob.bind(undefined) || typeof (0, $8dlmd.Buffer) !== "undefined" && function(encoded) {
            return (0, $8dlmd.Buffer).from(encoded, "base64").toString();
        },
        btoa: typeof btoa === "function" && btoa.bind(undefined) || typeof (0, $8dlmd.Buffer) !== "undefined" && function(str) {
            return (0, $8dlmd.Buffer).from(str).toString("base64");
        },
        URLSearchParams: typeof URLSearchParams === "function" && URLSearchParams || (0, (parcelRequire("aDwao")).URLSearchParams)
    };
};
var $bbdac916c5323159$var$env;
var $bbdac916c5323159$export$4bd44a2aa29d3d6e = function getEnv() {
    return $bbdac916c5323159$var$env || ($bbdac916c5323159$var$env = $bbdac916c5323159$var$validateEnv($bbdac916c5323159$export$d3cd91e0fdbfdbc0()));
};
var $bbdac916c5323159$var$validateEnv = function validateEnv(env) {
    if (!(env.atob && env.btoa && env.URLSearchParams)) throw new TypeError("Origin-Tracing: missing environment APIs. Required: btoa(), atob(), URLSearchParams() (or in Node: Buffer, require('url').URLSearchParams).");
    return env;
};

});
parcelRegister("aDwao", function(module, exports) {
/*
 * Copyright Joyent, Inc. and other Node contributors.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to permit
 * persons to whom the Software is furnished to do so, subject to the
 * following conditions:
 *
 * The above copyright notice and this permission notice shall be included
 * in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 * OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
 * NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
 * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
 * OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
 * USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ 
var $l0HdX = parcelRequire("l0HdX");
"use strict";

var $8H0bB = parcelRequire("8H0bB");
function Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.host = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.query = null;
    this.pathname = null;
    this.path = null;
    this.href = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
/*
 * define these here so at least they only have to be
 * compiled once on the first module load.
 */ var protocolPattern = /^([a-z0-9.+-]+:)/i, portPattern = /:[0-9]*$/, // Special case for a simple path URL
simplePathPattern = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/, /*
   * RFC 2396: characters reserved for delimiting URLs.
   * We actually just auto-escape these.
   */ delims = [
    "<",
    ">",
    '"',
    "`",
    " ",
    "\r",
    "\n",
    "	"
], // RFC 2396: characters not allowed for various reasons.
unwise = [
    "{",
    "}",
    "|",
    "\\",
    "^",
    "`"
].concat(delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
autoEscape = [
    "'"
].concat(unwise), /*
   * Characters that are never ever allowed in a hostname.
   * Note that any invalid chars are also handled, but these
   * are the ones that are *expected* to be seen, so we fast-path
   * them.
   */ nonHostChars = [
    "%",
    "/",
    "?",
    ";",
    "#"
].concat(autoEscape), hostEndingChars = [
    "/",
    "?",
    "#"
], hostnameMaxLen = 255, hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
unsafeProtocol = {
    javascript: true,
    "javascript:": true
}, // protocols that never have a hostname.
hostlessProtocol = {
    javascript: true,
    "javascript:": true
}, // protocols that always contain a // bit.
slashedProtocol = {
    http: true,
    https: true,
    ftp: true,
    gopher: true,
    file: true,
    "http:": true,
    "https:": true,
    "ftp:": true,
    "gopher:": true,
    "file:": true
};

var $hmq1b = parcelRequire("hmq1b");
function urlParse(url, parseQueryString, slashesDenoteHost) {
    if (url && typeof url === "object" && url instanceof Url) return url;
    var u = new Url();
    u.parse(url, parseQueryString, slashesDenoteHost);
    return u;
}
Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
    if (typeof url !== "string") throw new TypeError("Parameter 'url' must be a string, not " + (typeof url === "undefined" ? "undefined" : (0, $l0HdX._)(url)));
    /*
   * Copy chrome, IE, opera backslash-handling behavior.
   * Back slashes before the query string get converted to forward slashes
   * See: https://code.google.com/p/chromium/issues/detail?id=25916
   */ var queryIndex = url.indexOf("?"), splitter = queryIndex !== -1 && queryIndex < url.indexOf("#") ? "?" : "#", uSplit = url.split(splitter), slashRegex = /\\/g;
    uSplit[0] = uSplit[0].replace(slashRegex, "/");
    url = uSplit.join(splitter);
    var rest = url;
    /*
   * trim before proceeding.
   * This is to support parse stuff like "  http://foo.com  \n"
   */ rest = rest.trim();
    if (!slashesDenoteHost && url.split("#").length === 1) {
        // Try fast path regexp
        var simplePath = simplePathPattern.exec(rest);
        if (simplePath) {
            this.path = rest;
            this.href = rest;
            this.pathname = simplePath[1];
            if (simplePath[2]) {
                this.search = simplePath[2];
                if (parseQueryString) this.query = $hmq1b.parse(this.search.substr(1));
                else this.query = this.search.substr(1);
            } else if (parseQueryString) {
                this.search = "";
                this.query = {};
            }
            return this;
        }
    }
    var proto = protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        var lowerProto = proto.toLowerCase();
        this.protocol = lowerProto;
        rest = rest.substr(proto.length);
    }
    /*
   * figure out if it's got a host
   * user@server is *always* interpreted as a hostname, and url
   * resolution will treat //foo/bar as host=foo,path=bar because that's
   * how the browser resolves relative URLs.
   */ if (slashesDenoteHost || proto || rest.match(/^\/\/[^@/]+@[^@/]+/)) {
        var slashes = rest.substr(0, 2) === "//";
        if (slashes && !(proto && hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
        /*
     * there's a hostname.
     * the first instance of /, ?, ;, or # ends the host.
     *
     * If there is an @ in the hostname, then non-host chars *are* allowed
     * to the left of the last @ sign, unless some host-ending character
     * comes *before* the @-sign.
     * URLs are obnoxious.
     *
     * ex:
     * http://a@b@c/ => user:a@b host:c
     * http://a@b?@c => user:a host:c path:/?@c
     */ /*
     * v0.12 TODO(isaacs): This is not quite how Chrome does things.
     * Review our test case against browsers more comprehensively.
     */ // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(var i = 0; i < hostEndingChars.length; i++){
            var hec = rest.indexOf(hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        /*
     * at this point, either we have an explicit point where the
     * auth portion cannot go past, or the last @ char is the decider.
     */ var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf("@");
        else /*
       * atSign must be in auth portion.
       * http://a@b/c@d => host:b auth:a path:/c@d
       */ atSign = rest.lastIndexOf("@", hostEnd);
        /*
     * Now we have a portion which is definitely the auth.
     * Pull that off.
     */ if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = decodeURIComponent(auth);
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(var i = 0; i < nonHostChars.length; i++){
            var hec = rest.indexOf(nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        this.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost();
        /*
     * we've indicated that there is a hostname,
     * so even if it's empty, it has to be present.
     */ this.hostname = this.hostname || "";
        /*
     * if hostname begins with [ and ends with ]
     * assume that it's an IPv6 address.
     */ var ipv6Hostname = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(var i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match(hostnamePartPattern)) {
                    var newpart = "";
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) /*
               * we replace non-ASCII char with a temporary placeholder
               * we need this to make sure size of hostname is not
               * broken by replacing non-ASCII by nothing
               */ newpart += "x";
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match(hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match(hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = "/" + notHost.join(".") + rest;
                        this.hostname = validParts.join(".");
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > hostnameMaxLen) this.hostname = "";
        else // hostnames are always lower case.
        this.hostname = this.hostname.toLowerCase();
        if (!ipv6Hostname) /*
       * IDNA Support: Returns a punycoded representation of "domain".
       * It only converts parts of the domain name that
       * have non-ASCII characters, i.e. it doesn't matter if
       * you call it with a domain that already is ASCII-only.
       */ this.hostname = $8H0bB.toASCII(this.hostname);
        var p = this.port ? ":" + this.port : "";
        var h = this.hostname || "";
        this.host = h + p;
        this.href += this.host;
        /*
     * strip [ and ] from the hostname
     * the host field still retains them, though
     */ if (ipv6Hostname) {
            this.hostname = this.hostname.substr(1, this.hostname.length - 2);
            if (rest[0] !== "/") rest = "/" + rest;
        }
    }
    /*
   * now rest is set to the post-host stuff.
   * chop off any delim chars.
   */ if (!unsafeProtocol[lowerProto]) /*
     * First, make 100% sure that any "autoEscape" chars get
     * escaped, even if encodeURIComponent doesn't think they
     * need to be.
     */ for(var i = 0, l = autoEscape.length; i < l; i++){
        var ae = autoEscape[i];
        if (rest.indexOf(ae) === -1) continue;
        var esc = encodeURIComponent(ae);
        if (esc === ae) esc = escape(ae);
        rest = rest.split(ae).join(esc);
    }
    // chop off from the tail first.
    var hash = rest.indexOf("#");
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf("?");
    if (qm !== -1) {
        this.search = rest.substr(qm);
        this.query = rest.substr(qm + 1);
        if (parseQueryString) this.query = $hmq1b.parse(this.query);
        rest = rest.slice(0, qm);
    } else if (parseQueryString) {
        // no query string, but parseQueryString still requested
        this.search = "";
        this.query = {};
    }
    if (rest) this.pathname = rest;
    if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = "/";
    // to support http.request
    if (this.pathname || this.search) {
        var p = this.pathname || "";
        var s = this.search || "";
        this.path = p + s;
    }
    // finally, reconstruct the href based on what has been validated.
    this.href = this.format();
    return this;
};
// format a parsed object into a url string
function urlFormat(obj) {
    /*
   * ensure it's an object, and not a string url.
   * If it's an obj, this is a no-op.
   * this way, you can call url_format() on strings
   * to clean up potentially wonky urls.
   */ if (typeof obj === "string") obj = urlParse(obj);
    if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
    return obj.format();
}
Url.prototype.format = function() {
    var auth = this.auth || "";
    if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ":");
        auth += "@";
    }
    var protocol = this.protocol || "", pathname = this.pathname || "", hash = this.hash || "", host = false, query = "";
    if (this.host) host = auth + this.host;
    else if (this.hostname) {
        host = auth + (this.hostname.indexOf(":") === -1 ? this.hostname : "[" + this.hostname + "]");
        if (this.port) host += ":" + this.port;
    }
    if (this.query && typeof this.query === "object" && Object.keys(this.query).length) query = $hmq1b.stringify(this.query, {
        arrayFormat: "repeat",
        addQueryPrefix: false
    });
    var search = this.search || query && "?" + query || "";
    if (protocol && protocol.substr(-1) !== ":") protocol += ":";
    /*
   * only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
   * unless they had them to begin with.
   */ if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
        host = "//" + (host || "");
        if (pathname && pathname.charAt(0) !== "/") pathname = "/" + pathname;
    } else if (!host) host = "";
    if (hash && hash.charAt(0) !== "#") hash = "#" + hash;
    if (search && search.charAt(0) !== "?") search = "?" + search;
    pathname = pathname.replace(/[?#]/g, function(match) {
        return encodeURIComponent(match);
    });
    search = search.replace("#", "%23");
    return protocol + host + pathname + search + hash;
};
function urlResolve(source, relative) {
    return urlParse(source, false, true).resolve(relative);
}
Url.prototype.resolve = function(relative) {
    return this.resolveObject(urlParse(relative, false, true)).format();
};
function urlResolveObject(source, relative) {
    if (!source) return relative;
    return urlParse(source, false, true).resolveObject(relative);
}
Url.prototype.resolveObject = function(relative) {
    if (typeof relative === "string") {
        var rel = new Url();
        rel.parse(relative, false, true);
        relative = rel;
    }
    var result = new Url();
    var tkeys = Object.keys(this);
    for(var tk = 0; tk < tkeys.length; tk++){
        var tkey = tkeys[tk];
        result[tkey] = this[tkey];
    }
    /*
   * hash is always overridden, no matter what.
   * even href="" will remove it.
   */ result.hash = relative.hash;
    // if the relative url is empty, then there's nothing left to do here.
    if (relative.href === "") {
        result.href = result.format();
        return result;
    }
    // hrefs like //foo/bar always cut to the protocol.
    if (relative.slashes && !relative.protocol) {
        // take everything except the protocol from relative
        var rkeys = Object.keys(relative);
        for(var rk = 0; rk < rkeys.length; rk++){
            var rkey = rkeys[rk];
            if (rkey !== "protocol") result[rkey] = relative[rkey];
        }
        // urlParse appends trailing / to urls like http://www.example.com
        if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
            result.pathname = "/";
            result.path = result.pathname;
        }
        result.href = result.format();
        return result;
    }
    if (relative.protocol && relative.protocol !== result.protocol) {
        /*
     * if it's a known url protocol, then changing
     * the protocol does weird things
     * first, if it's not file:, then we MUST have a host,
     * and if there was a path
     * to begin with, then we MUST have a path.
     * if it is file:, then the host is dropped,
     * because that's known to be hostless.
     * anything else is assumed to be absolute.
     */ if (!slashedProtocol[relative.protocol]) {
            var keys = Object.keys(relative);
            for(var v = 0; v < keys.length; v++){
                var k = keys[v];
                result[k] = relative[k];
            }
            result.href = result.format();
            return result;
        }
        result.protocol = relative.protocol;
        if (!relative.host && !hostlessProtocol[relative.protocol]) {
            var relPath = (relative.pathname || "").split("/");
            while(relPath.length && !(relative.host = relPath.shift()));
            if (!relative.host) relative.host = "";
            if (!relative.hostname) relative.hostname = "";
            if (relPath[0] !== "") relPath.unshift("");
            if (relPath.length < 2) relPath.unshift("");
            result.pathname = relPath.join("/");
        } else result.pathname = relative.pathname;
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || "";
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        // to support http.request
        if (result.pathname || result.search) {
            var p = result.pathname || "";
            var s = result.search || "";
            result.path = p + s;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
    }
    var isSourceAbs = result.pathname && result.pathname.charAt(0) === "/", isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === "/", mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split("/") || [], relPath = relative.pathname && relative.pathname.split("/") || [], psychotic = result.protocol && !slashedProtocol[result.protocol];
    /*
   * if the url is a non-slashed url, then relative
   * links like ../.. should be able
   * to crawl up to the hostname, as well.  This is strange.
   * result.protocol has already been set by now.
   * Later on, put the first path part into the host field.
   */ if (psychotic) {
        result.hostname = "";
        result.port = null;
        if (result.host) {
            if (srcPath[0] === "") srcPath[0] = result.host;
            else srcPath.unshift(result.host);
        }
        result.host = "";
        if (relative.protocol) {
            relative.hostname = null;
            relative.port = null;
            if (relative.host) {
                if (relPath[0] === "") relPath[0] = relative.host;
                else relPath.unshift(relative.host);
            }
            relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === "" || srcPath[0] === "");
    }
    if (isRelAbs) {
        // it's absolute.
        result.host = relative.host || relative.host === "" ? relative.host : result.host;
        result.hostname = relative.hostname || relative.hostname === "" ? relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;
    // fall through to the dot-handling below.
    } else if (relPath.length) {
        /*
     * it's relative
     * throw away the existing file, and take the new path instead.
     */ if (!srcPath) srcPath = [];
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
    } else if (relative.search != null) {
        /*
     * just pull out the search.
     * like href='?foo'.
     * Put this after the other two cases because it simplifies the booleans
     */ if (psychotic) {
            result.host = srcPath.shift();
            result.hostname = result.host;
            /*
       * occationaly the auth can get stuck only in host
       * this especially happens in cases like
       * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
       */ var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
            if (authInHost) {
                result.auth = authInHost.shift();
                result.hostname = authInHost.shift();
                result.host = result.hostname;
            }
        }
        result.search = relative.search;
        result.query = relative.query;
        // to support http.request
        if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
        result.href = result.format();
        return result;
    }
    if (!srcPath.length) {
        /*
     * no path at all.  easy.
     * we've already handled the other stuff above.
     */ result.pathname = null;
        // to support http.request
        if (result.search) result.path = "/" + result.search;
        else result.path = null;
        result.href = result.format();
        return result;
    }
    /*
   * if a url ENDs in . or .., then it must get a trailing slash.
   * however, if it ends in anything else non-slashy,
   * then it must NOT get a trailing slash.
   */ var last = srcPath.slice(-1)[0];
    var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === "." || last === "..") || last === "";
    /*
   * strip single dots, resolve double dots to parent dir
   * if the path tries to go above the root, `up` ends up > 0
   */ var up = 0;
    for(var i = srcPath.length; i >= 0; i--){
        last = srcPath[i];
        if (last === ".") srcPath.splice(i, 1);
        else if (last === "..") {
            srcPath.splice(i, 1);
            up++;
        } else if (up) {
            srcPath.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift("..");
    if (mustEndAbs && srcPath[0] !== "" && (!srcPath[0] || srcPath[0].charAt(0) !== "/")) srcPath.unshift("");
    if (hasTrailingSlash && srcPath.join("/").substr(-1) !== "/") srcPath.push("");
    var isAbsolute = srcPath[0] === "" || srcPath[0] && srcPath[0].charAt(0) === "/";
    // put the host back
    if (psychotic) {
        result.hostname = isAbsolute ? "" : srcPath.length ? srcPath.shift() : "";
        result.host = result.hostname;
        /*
     * occationaly the auth can get stuck only in host
     * this especially happens in cases like
     * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
     */ var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
        if (authInHost) {
            result.auth = authInHost.shift();
            result.hostname = authInHost.shift();
            result.host = result.hostname;
        }
    }
    mustEndAbs = mustEndAbs || result.host && srcPath.length;
    if (mustEndAbs && !isAbsolute) srcPath.unshift("");
    if (srcPath.length > 0) result.pathname = srcPath.join("/");
    else {
        result.pathname = null;
        result.path = null;
    }
    // to support request.http
    if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
    result.auth = relative.auth || result.auth;
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
};
Url.prototype.parseHost = function() {
    var host = this.host;
    var port = portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ":") this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;
exports.Url = Url;

});
parcelRegister("8H0bB", function(module, exports) {
(function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof $parcel$global == "object" && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = "-", /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        "overflow": "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw new RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split("@");
        var result = "";
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + "@";
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, ".");
        var labels = string.split(".");
        var encoded = map(labels, fn).join(".");
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = "";
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join("");
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error("not-basic");
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error("invalid-input");
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error("overflow");
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error("overflow");
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error("overflow");
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error("overflow");
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error("overflow");
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join("");
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? "xn--" + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ "version": "1.4.1",
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ "ucs2": {
            "decode": ucs2decode,
            "encode": ucs2encode
        },
        "decode": decode,
        "encode": encode,
        "toASCII": toASCII,
        "toUnicode": toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) define("punycode", function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) // in Node.js, io.js, or RingoJS v0.8.0+
        freeModule.exports = punycode;
        else // in Narwhal or RingoJS v0.7.0-
        for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else // in Rhino or a web browser
    root.punycode = punycode;
})(this);

});

parcelRegister("hmq1b", function(module, exports) {
"use strict";

var $gY8ql = parcelRequire("gY8ql");

var $bC7wP = parcelRequire("bC7wP");

var $kaiyL = parcelRequire("kaiyL");
module.exports = {
    formats: $kaiyL,
    parse: $bC7wP,
    stringify: $gY8ql
};

});
parcelRegister("gY8ql", function(module, exports) {

var $l0HdX = parcelRequire("l0HdX");
"use strict";

var $2K3SL = parcelRequire("2K3SL");

var $ceunP = parcelRequire("ceunP");

var $kaiyL = parcelRequire("kaiyL");
var $033024452caeb15f$var$has = Object.prototype.hasOwnProperty;
var $033024452caeb15f$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + "[]";
    },
    comma: "comma",
    indices: function indices(prefix, key) {
        return prefix + "[" + key + "]";
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $033024452caeb15f$var$isArray = Array.isArray;
var $033024452caeb15f$var$push = Array.prototype.push;
var $033024452caeb15f$var$pushToArray = function pushToArray(arr, valueOrArray) {
    $033024452caeb15f$var$push.apply(arr, $033024452caeb15f$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $033024452caeb15f$var$toISO = Date.prototype.toISOString;
var $033024452caeb15f$var$defaultFormat = $kaiyL.default;
var $033024452caeb15f$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: "utf-8",
    charsetSentinel: false,
    delimiter: "&",
    encode: true,
    encoder: $ceunP.encode,
    encodeValuesOnly: false,
    format: $033024452caeb15f$var$defaultFormat,
    formatter: $kaiyL.formatters[$033024452caeb15f$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $033024452caeb15f$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $033024452caeb15f$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === "string" || typeof v === "number" || typeof v === "boolean" || (typeof v === "undefined" ? "undefined" : (0, $l0HdX._)(v)) === "symbol" || (typeof v === "undefined" ? "undefined" : (0, $l0HdX._)(v)) === "bigint";
};
var $033024452caeb15f$var$sentinel = {};
var $033024452caeb15f$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($033024452caeb15f$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== "undefined") {
            if (pos === step) throw new RangeError("Cyclic object value");
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($033024452caeb15f$var$sentinel) === "undefined") step = 0;
    }
    if (typeof filter === "function") obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === "comma" && $033024452caeb15f$var$isArray(obj)) obj = $ceunP.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $033024452caeb15f$var$defaults.encoder, charset, "key", format) : prefix;
        obj = "";
    }
    if ($033024452caeb15f$var$isNonNullishPrimitive(obj) || $ceunP.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $033024452caeb15f$var$defaults.encoder, charset, "key", format);
            return [
                formatter(keyValue) + "=" + formatter(encoder(obj, $033024452caeb15f$var$defaults.encoder, charset, "value", format))
            ];
        }
        return [
            formatter(prefix) + "=" + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === "undefined") return values;
    var objKeys;
    if (generateArrayPrefix === "comma" && $033024452caeb15f$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $ceunP.maybeMap(obj, encoder);
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(",") || null : void 0
            }
        ];
    } else if ($033024452caeb15f$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var adjustedPrefix = commaRoundTrip && $033024452caeb15f$var$isArray(obj) && obj.length === 1 ? prefix + "[]" : prefix;
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === "object" && typeof key.value !== "undefined" ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var keyPrefix = $033024452caeb15f$var$isArray(obj) ? typeof generateArrayPrefix === "function" ? generateArrayPrefix(adjustedPrefix, key) : adjustedPrefix : adjustedPrefix + (allowDots ? "." + key : "[" + key + "]");
        sideChannel.set(object, step);
        var valueSideChannel = $2K3SL();
        valueSideChannel.set($033024452caeb15f$var$sentinel, sideChannel);
        $033024452caeb15f$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, strictNullHandling, skipNulls, generateArrayPrefix === "comma" && encodeValuesOnly && $033024452caeb15f$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var $033024452caeb15f$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $033024452caeb15f$var$defaults;
    if (opts.encoder !== null && typeof opts.encoder !== "undefined" && typeof opts.encoder !== "function") throw new TypeError("Encoder has to be a function.");
    var charset = opts.charset || $033024452caeb15f$var$defaults.charset;
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var format = $kaiyL.default;
    if (typeof opts.format !== "undefined") {
        if (!$033024452caeb15f$var$has.call($kaiyL.formatters, opts.format)) throw new TypeError("Unknown format option provided.");
        format = opts.format;
    }
    var formatter = $kaiyL.formatters[format];
    var filter = $033024452caeb15f$var$defaults.filter;
    if (typeof opts.filter === "function" || $033024452caeb15f$var$isArray(opts.filter)) filter = opts.filter;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === "boolean" ? opts.addQueryPrefix : $033024452caeb15f$var$defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === "undefined" ? $033024452caeb15f$var$defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $033024452caeb15f$var$defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === "undefined" ? $033024452caeb15f$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === "boolean" ? opts.encode : $033024452caeb15f$var$defaults.encode,
        encoder: typeof opts.encoder === "function" ? opts.encoder : $033024452caeb15f$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === "boolean" ? opts.encodeValuesOnly : $033024452caeb15f$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === "function" ? opts.serializeDate : $033024452caeb15f$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === "boolean" ? opts.skipNulls : $033024452caeb15f$var$defaults.skipNulls,
        sort: typeof opts.sort === "function" ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $033024452caeb15f$var$defaults.strictNullHandling
    };
};
module.exports = function(object, opts) {
    var obj = object;
    var options = $033024452caeb15f$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === "function") {
        filter = options.filter;
        obj = filter("", obj);
    } else if ($033024452caeb15f$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== "object" || obj === null) return "";
    var arrayFormat;
    if (opts && opts.arrayFormat in $033024452caeb15f$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if (opts && "indices" in opts) arrayFormat = opts.indices ? "indices" : "repeat";
    else arrayFormat = "indices";
    var generateArrayPrefix = $033024452caeb15f$var$arrayPrefixGenerators[arrayFormat];
    if (opts && "commaRoundTrip" in opts && typeof opts.commaRoundTrip !== "boolean") throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var commaRoundTrip = generateArrayPrefix === "comma" && opts && opts.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $2K3SL();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (options.skipNulls && obj[key] === null) continue;
        $033024452caeb15f$var$pushToArray(keys, $033024452caeb15f$var$stringify(obj[key], key, generateArrayPrefix, commaRoundTrip, options.strictNullHandling, options.skipNulls, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? "?" : "";
    if (options.charsetSentinel) {
        if (options.charset === "iso-8859-1") // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += "utf8=%26%2310003%3B&";
        else // encodeURIComponent('✓')
        prefix += "utf8=%E2%9C%93&";
    }
    return joined.length > 0 ? prefix + joined : "";
};

});
parcelRegister("2K3SL", function(module, exports) {
"use strict";

var $i8ZMJ = parcelRequire("i8ZMJ");

var $7SltU = parcelRequire("7SltU");

var $dlTW1 = parcelRequire("dlTW1");
var $1ff2e39bf4e3c562$var$$TypeError = $i8ZMJ("%TypeError%");
var $1ff2e39bf4e3c562$var$$WeakMap = $i8ZMJ("%WeakMap%", true);
var $1ff2e39bf4e3c562$var$$Map = $i8ZMJ("%Map%", true);
var $1ff2e39bf4e3c562$var$$weakMapGet = $7SltU("WeakMap.prototype.get", true);
var $1ff2e39bf4e3c562$var$$weakMapSet = $7SltU("WeakMap.prototype.set", true);
var $1ff2e39bf4e3c562$var$$weakMapHas = $7SltU("WeakMap.prototype.has", true);
var $1ff2e39bf4e3c562$var$$mapGet = $7SltU("Map.prototype.get", true);
var $1ff2e39bf4e3c562$var$$mapSet = $7SltU("Map.prototype.set", true);
var $1ff2e39bf4e3c562$var$$mapHas = $7SltU("Map.prototype.has", true);
/*
 * This function traverses the list returning the node corresponding to the
 * given key.
 *
 * That node is also moved to the head of the list, so that if it's accessed
 * again we don't need to traverse the whole list. By doing so, all the recently
 * used nodes can be accessed relatively quickly.
 */ var $1ff2e39bf4e3c562$var$listGetNode = function listGetNode(list, key) {
    for(var prev = list, curr; (curr = prev.next) !== null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        curr.next = list.next;
        list.next = curr; // eslint-disable-line no-param-reassign
        return curr;
    }
};
var $1ff2e39bf4e3c562$var$listGet = function listGet(objects, key) {
    var node = $1ff2e39bf4e3c562$var$listGetNode(objects, key);
    return node && node.value;
};
var $1ff2e39bf4e3c562$var$listSet = function listSet(objects, key, value) {
    var node = $1ff2e39bf4e3c562$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = {
        key: key,
        next: objects.next,
        value: value
    };
};
var $1ff2e39bf4e3c562$var$listHas = function listHas(objects, key) {
    return !!$1ff2e39bf4e3c562$var$listGetNode(objects, key);
};
module.exports = function getSideChannel() {
    var $wm;
    var $m;
    var $o;
    var channel = {
        assert: function assert(key) {
            if (!channel.has(key)) throw new $1ff2e39bf4e3c562$var$$TypeError("Side channel does not contain " + $dlTW1(key));
        },
        get: function get(key) {
            if ($1ff2e39bf4e3c562$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $1ff2e39bf4e3c562$var$$weakMapGet($wm, key);
            } else if ($1ff2e39bf4e3c562$var$$Map) {
                if ($m) return $1ff2e39bf4e3c562$var$$mapGet($m, key);
            } else {
                if ($o) return $1ff2e39bf4e3c562$var$listGet($o, key);
            }
        },
        has: function has(key) {
            if ($1ff2e39bf4e3c562$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $1ff2e39bf4e3c562$var$$weakMapHas($wm, key);
            } else if ($1ff2e39bf4e3c562$var$$Map) {
                if ($m) return $1ff2e39bf4e3c562$var$$mapHas($m, key);
            } else {
                if ($o) return $1ff2e39bf4e3c562$var$listHas($o, key);
            }
            return false;
        },
        set: function set(key, value) {
            if ($1ff2e39bf4e3c562$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if (!$wm) $wm = new $1ff2e39bf4e3c562$var$$WeakMap();
                $1ff2e39bf4e3c562$var$$weakMapSet($wm, key, value);
            } else if ($1ff2e39bf4e3c562$var$$Map) {
                if (!$m) $m = new $1ff2e39bf4e3c562$var$$Map();
                $1ff2e39bf4e3c562$var$$mapSet($m, key, value);
            } else {
                if (!$o) /*
					 * Initialize the linked list as an empty node, so that we don't have
					 * to special-case handling of the first node: we can always refer to
					 * it as (previous node).next, instead of something like (list).head
					 */ $o = {
                    key: {},
                    next: null
                };
                $1ff2e39bf4e3c562$var$listSet($o, key, value);
            }
        }
    };
    return channel;
};

});
parcelRegister("dlTW1", function(module, exports) {

var $l0HdX = parcelRequire("l0HdX");
var $9b88a0010bec0a10$var$hasMap = typeof Map === "function" && Map.prototype;
var $9b88a0010bec0a10$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $9b88a0010bec0a10$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null;
var $9b88a0010bec0a10$var$mapSize = $9b88a0010bec0a10$var$hasMap && $9b88a0010bec0a10$var$mapSizeDescriptor && typeof $9b88a0010bec0a10$var$mapSizeDescriptor.get === "function" ? $9b88a0010bec0a10$var$mapSizeDescriptor.get : null;
var $9b88a0010bec0a10$var$mapForEach = $9b88a0010bec0a10$var$hasMap && Map.prototype.forEach;
var $9b88a0010bec0a10$var$hasSet = typeof Set === "function" && Set.prototype;
var $9b88a0010bec0a10$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $9b88a0010bec0a10$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null;
var $9b88a0010bec0a10$var$setSize = $9b88a0010bec0a10$var$hasSet && $9b88a0010bec0a10$var$setSizeDescriptor && typeof $9b88a0010bec0a10$var$setSizeDescriptor.get === "function" ? $9b88a0010bec0a10$var$setSizeDescriptor.get : null;
var $9b88a0010bec0a10$var$setForEach = $9b88a0010bec0a10$var$hasSet && Set.prototype.forEach;
var $9b88a0010bec0a10$var$hasWeakMap = typeof WeakMap === "function" && WeakMap.prototype;
var $9b88a0010bec0a10$var$weakMapHas = $9b88a0010bec0a10$var$hasWeakMap ? WeakMap.prototype.has : null;
var $9b88a0010bec0a10$var$hasWeakSet = typeof WeakSet === "function" && WeakSet.prototype;
var $9b88a0010bec0a10$var$weakSetHas = $9b88a0010bec0a10$var$hasWeakSet ? WeakSet.prototype.has : null;
var $9b88a0010bec0a10$var$hasWeakRef = typeof WeakRef === "function" && WeakRef.prototype;
var $9b88a0010bec0a10$var$weakRefDeref = $9b88a0010bec0a10$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $9b88a0010bec0a10$var$booleanValueOf = Boolean.prototype.valueOf;
var $9b88a0010bec0a10$var$objectToString = Object.prototype.toString;
var $9b88a0010bec0a10$var$functionToString = Function.prototype.toString;
var $9b88a0010bec0a10$var$$match = String.prototype.match;
var $9b88a0010bec0a10$var$$slice = String.prototype.slice;
var $9b88a0010bec0a10$var$$replace = String.prototype.replace;
var $9b88a0010bec0a10$var$$toUpperCase = String.prototype.toUpperCase;
var $9b88a0010bec0a10$var$$toLowerCase = String.prototype.toLowerCase;
var $9b88a0010bec0a10$var$$test = RegExp.prototype.test;
var $9b88a0010bec0a10$var$$concat = Array.prototype.concat;
var $9b88a0010bec0a10$var$$join = Array.prototype.join;
var $9b88a0010bec0a10$var$$arrSlice = Array.prototype.slice;
var $9b88a0010bec0a10$var$$floor = Math.floor;
var $9b88a0010bec0a10$var$bigIntValueOf = typeof BigInt === "function" ? BigInt.prototype.valueOf : null;
var $9b88a0010bec0a10$var$gOPS = Object.getOwnPropertySymbols;
var $9b88a0010bec0a10$var$symToString = typeof Symbol === "function" && (0, $l0HdX._)(Symbol.iterator) === "symbol" ? Symbol.prototype.toString : null;
var $9b88a0010bec0a10$var$hasShammedSymbols = typeof Symbol === "function" && typeof Symbol.iterator === "object";
// ie, `has-tostringtag/shams
var $9b88a0010bec0a10$var$toStringTag = typeof Symbol === "function" && Symbol.toStringTag && ((0, $l0HdX._)(Symbol.toStringTag) === $9b88a0010bec0a10$var$hasShammedSymbols ? "object" : "symbol") ? Symbol.toStringTag : null;
var $9b88a0010bec0a10$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $9b88a0010bec0a10$var$gPO = (typeof Reflect === "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $9b88a0010bec0a10$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $9b88a0010bec0a10$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === "number") {
        var int = num < 0 ? -$9b88a0010bec0a10$var$$floor(-num) : $9b88a0010bec0a10$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $9b88a0010bec0a10$var$$slice.call(str, intStr.length + 1);
            return $9b88a0010bec0a10$var$$replace.call(intStr, sepRegex, "$&_") + "." + $9b88a0010bec0a10$var$$replace.call($9b88a0010bec0a10$var$$replace.call(dec, /([0-9]{3})/g, "$&_"), /_$/, "");
        }
    }
    return $9b88a0010bec0a10$var$$replace.call(str, sepRegex, "$&_");
}

var $9dH9K = parcelRequire("9dH9K");
var $9b88a0010bec0a10$var$inspectCustom = $9dH9K.custom;
var $9b88a0010bec0a10$var$inspectSymbol = $9b88a0010bec0a10$var$isSymbol($9b88a0010bec0a10$var$inspectCustom) ? $9b88a0010bec0a10$var$inspectCustom : null;
module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($9b88a0010bec0a10$var$has(opts, "quoteStyle") && opts.quoteStyle !== "single" && opts.quoteStyle !== "double") throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($9b88a0010bec0a10$var$has(opts, "maxStringLength") && (typeof opts.maxStringLength === "number" ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $9b88a0010bec0a10$var$has(opts, "customInspect") ? opts.customInspect : true;
    if (typeof customInspect !== "boolean" && customInspect !== "symbol") throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if ($9b88a0010bec0a10$var$has(opts, "indent") && opts.indent !== null && opts.indent !== "	" && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($9b88a0010bec0a10$var$has(opts, "numericSeparator") && typeof opts.numericSeparator !== "boolean") throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === "undefined") return "undefined";
    if (obj === null) return "null";
    if (typeof obj === "boolean") return obj ? "true" : "false";
    if (typeof obj === "string") return $9b88a0010bec0a10$var$inspectString(obj, opts);
    if (typeof obj === "number") {
        if (obj === 0) return Infinity / obj > 0 ? "0" : "-0";
        var str = String(obj);
        return numericSeparator ? $9b88a0010bec0a10$var$addNumericSeparator(obj, str) : str;
    }
    if ((typeof obj === "undefined" ? "undefined" : (0, $l0HdX._)(obj)) === "bigint") {
        var bigIntStr = String(obj) + "n";
        return numericSeparator ? $9b88a0010bec0a10$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === "undefined" ? 5 : opts.depth;
    if (typeof depth === "undefined") depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === "object") return $9b88a0010bec0a10$var$isArray(obj) ? "[Array]" : "[Object]";
    var indent = $9b88a0010bec0a10$var$getIndent(opts, depth);
    if (typeof seen === "undefined") seen = [];
    else if ($9b88a0010bec0a10$var$indexOf(seen, obj) >= 0) return "[Circular]";
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $9b88a0010bec0a10$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($9b88a0010bec0a10$var$has(opts, "quoteStyle")) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === "function" && !$9b88a0010bec0a10$var$isRegExp(obj)) {
        var name = $9b88a0010bec0a10$var$nameOf(obj);
        var keys = $9b88a0010bec0a10$var$arrObjKeys(obj, inspect);
        return "[Function" + (name ? ": " + name : " (anonymous)") + "]" + (keys.length > 0 ? " { " + $9b88a0010bec0a10$var$$join.call(keys, ", ") + " }" : "");
    }
    if ($9b88a0010bec0a10$var$isSymbol(obj)) {
        var symString = $9b88a0010bec0a10$var$hasShammedSymbols ? $9b88a0010bec0a10$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, "$1") : $9b88a0010bec0a10$var$symToString.call(obj);
        return typeof obj === "object" && !$9b88a0010bec0a10$var$hasShammedSymbols ? $9b88a0010bec0a10$var$markBoxed(symString) : symString;
    }
    if ($9b88a0010bec0a10$var$isElement(obj)) {
        var s = "<" + $9b88a0010bec0a10$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += " " + attrs[i].name + "=" + $9b88a0010bec0a10$var$wrapQuotes($9b88a0010bec0a10$var$quote(attrs[i].value), "double", opts);
        s += ">";
        if (obj.childNodes && obj.childNodes.length) s += "...";
        s += "</" + $9b88a0010bec0a10$var$$toLowerCase.call(String(obj.nodeName)) + ">";
        return s;
    }
    if ($9b88a0010bec0a10$var$isArray(obj)) {
        if (obj.length === 0) return "[]";
        var xs = $9b88a0010bec0a10$var$arrObjKeys(obj, inspect);
        if (indent && !$9b88a0010bec0a10$var$singleLineValues(xs)) return "[" + $9b88a0010bec0a10$var$indentedJoin(xs, indent) + "]";
        return "[ " + $9b88a0010bec0a10$var$$join.call(xs, ", ") + " ]";
    }
    if ($9b88a0010bec0a10$var$isError(obj)) {
        var parts = $9b88a0010bec0a10$var$arrObjKeys(obj, inspect);
        if (!("cause" in Error.prototype) && "cause" in obj && !$9b88a0010bec0a10$var$isEnumerable.call(obj, "cause")) return "{ [" + String(obj) + "] " + $9b88a0010bec0a10$var$$join.call($9b88a0010bec0a10$var$$concat.call("[cause]: " + inspect(obj.cause), parts), ", ") + " }";
        if (parts.length === 0) return "[" + String(obj) + "]";
        return "{ [" + String(obj) + "] " + $9b88a0010bec0a10$var$$join.call(parts, ", ") + " }";
    }
    if (typeof obj === "object" && customInspect) {
        if ($9b88a0010bec0a10$var$inspectSymbol && typeof obj[$9b88a0010bec0a10$var$inspectSymbol] === "function" && $9dH9K) return $9dH9K(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== "symbol" && typeof obj.inspect === "function") return obj.inspect();
    }
    if ($9b88a0010bec0a10$var$isMap(obj)) {
        var mapParts = [];
        if ($9b88a0010bec0a10$var$mapForEach) $9b88a0010bec0a10$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + " => " + inspect(value, obj));
        });
        return $9b88a0010bec0a10$var$collectionOf("Map", $9b88a0010bec0a10$var$mapSize.call(obj), mapParts, indent);
    }
    if ($9b88a0010bec0a10$var$isSet(obj)) {
        var setParts = [];
        if ($9b88a0010bec0a10$var$setForEach) $9b88a0010bec0a10$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $9b88a0010bec0a10$var$collectionOf("Set", $9b88a0010bec0a10$var$setSize.call(obj), setParts, indent);
    }
    if ($9b88a0010bec0a10$var$isWeakMap(obj)) return $9b88a0010bec0a10$var$weakCollectionOf("WeakMap");
    if ($9b88a0010bec0a10$var$isWeakSet(obj)) return $9b88a0010bec0a10$var$weakCollectionOf("WeakSet");
    if ($9b88a0010bec0a10$var$isWeakRef(obj)) return $9b88a0010bec0a10$var$weakCollectionOf("WeakRef");
    if ($9b88a0010bec0a10$var$isNumber(obj)) return $9b88a0010bec0a10$var$markBoxed(inspect(Number(obj)));
    if ($9b88a0010bec0a10$var$isBigInt(obj)) return $9b88a0010bec0a10$var$markBoxed(inspect($9b88a0010bec0a10$var$bigIntValueOf.call(obj)));
    if ($9b88a0010bec0a10$var$isBoolean(obj)) return $9b88a0010bec0a10$var$markBoxed($9b88a0010bec0a10$var$booleanValueOf.call(obj));
    if ($9b88a0010bec0a10$var$isString(obj)) return $9b88a0010bec0a10$var$markBoxed(inspect(String(obj)));
    if (obj === $parcel$global) {
        /* eslint-env browser */ if (typeof window !== "undefined") return "{ [object Window] }";
        return "{ [object global] }";
    }
    if (!$9b88a0010bec0a10$var$isDate(obj) && !$9b88a0010bec0a10$var$isRegExp(obj)) {
        var ys = $9b88a0010bec0a10$var$arrObjKeys(obj, inspect);
        var isPlainObject = $9b88a0010bec0a10$var$gPO ? $9b88a0010bec0a10$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? "" : "null prototype";
        var stringTag = !isPlainObject && $9b88a0010bec0a10$var$toStringTag && Object(obj) === obj && $9b88a0010bec0a10$var$toStringTag in obj ? $9b88a0010bec0a10$var$$slice.call($9b88a0010bec0a10$var$toStr(obj), 8, -1) : protoTag ? "Object" : "";
        var constructorTag = isPlainObject || typeof obj.constructor !== "function" ? "" : obj.constructor.name ? obj.constructor.name + " " : "";
        var tag = constructorTag + (stringTag || protoTag ? "[" + $9b88a0010bec0a10$var$$join.call($9b88a0010bec0a10$var$$concat.call([], stringTag || [], protoTag || []), ": ") + "] " : "");
        if (ys.length === 0) return tag + "{}";
        if (indent) return tag + "{" + $9b88a0010bec0a10$var$indentedJoin(ys, indent) + "}";
        return tag + "{ " + $9b88a0010bec0a10$var$$join.call(ys, ", ") + " }";
    }
    return String(obj);
};
function $9b88a0010bec0a10$var$wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === "double" ? '"' : "'";
    return quoteChar + s + quoteChar;
}
function $9b88a0010bec0a10$var$quote(s) {
    return $9b88a0010bec0a10$var$$replace.call(String(s), /"/g, "&quot;");
}
function $9b88a0010bec0a10$var$isArray(obj) {
    return $9b88a0010bec0a10$var$toStr(obj) === "[object Array]" && (!$9b88a0010bec0a10$var$toStringTag || !(typeof obj === "object" && $9b88a0010bec0a10$var$toStringTag in obj));
}
function $9b88a0010bec0a10$var$isDate(obj) {
    return $9b88a0010bec0a10$var$toStr(obj) === "[object Date]" && (!$9b88a0010bec0a10$var$toStringTag || !(typeof obj === "object" && $9b88a0010bec0a10$var$toStringTag in obj));
}
function $9b88a0010bec0a10$var$isRegExp(obj) {
    return $9b88a0010bec0a10$var$toStr(obj) === "[object RegExp]" && (!$9b88a0010bec0a10$var$toStringTag || !(typeof obj === "object" && $9b88a0010bec0a10$var$toStringTag in obj));
}
function $9b88a0010bec0a10$var$isError(obj) {
    return $9b88a0010bec0a10$var$toStr(obj) === "[object Error]" && (!$9b88a0010bec0a10$var$toStringTag || !(typeof obj === "object" && $9b88a0010bec0a10$var$toStringTag in obj));
}
function $9b88a0010bec0a10$var$isString(obj) {
    return $9b88a0010bec0a10$var$toStr(obj) === "[object String]" && (!$9b88a0010bec0a10$var$toStringTag || !(typeof obj === "object" && $9b88a0010bec0a10$var$toStringTag in obj));
}
function $9b88a0010bec0a10$var$isNumber(obj) {
    return $9b88a0010bec0a10$var$toStr(obj) === "[object Number]" && (!$9b88a0010bec0a10$var$toStringTag || !(typeof obj === "object" && $9b88a0010bec0a10$var$toStringTag in obj));
}
function $9b88a0010bec0a10$var$isBoolean(obj) {
    return $9b88a0010bec0a10$var$toStr(obj) === "[object Boolean]" && (!$9b88a0010bec0a10$var$toStringTag || !(typeof obj === "object" && $9b88a0010bec0a10$var$toStringTag in obj));
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $9b88a0010bec0a10$var$isSymbol(obj) {
    if ($9b88a0010bec0a10$var$hasShammedSymbols) return obj && typeof obj === "object" && obj instanceof Symbol;
    if ((typeof obj === "undefined" ? "undefined" : (0, $l0HdX._)(obj)) === "symbol") return true;
    if (!obj || typeof obj !== "object" || !$9b88a0010bec0a10$var$symToString) return false;
    try {
        $9b88a0010bec0a10$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $9b88a0010bec0a10$var$isBigInt(obj) {
    if (!obj || typeof obj !== "object" || !$9b88a0010bec0a10$var$bigIntValueOf) return false;
    try {
        $9b88a0010bec0a10$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $9b88a0010bec0a10$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $9b88a0010bec0a10$var$has(obj, key) {
    return $9b88a0010bec0a10$var$hasOwn.call(obj, key);
}
function $9b88a0010bec0a10$var$toStr(obj) {
    return $9b88a0010bec0a10$var$objectToString.call(obj);
}
function $9b88a0010bec0a10$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $9b88a0010bec0a10$var$$match.call($9b88a0010bec0a10$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $9b88a0010bec0a10$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $9b88a0010bec0a10$var$isMap(x) {
    if (!$9b88a0010bec0a10$var$mapSize || !x || typeof x !== "object") return false;
    try {
        $9b88a0010bec0a10$var$mapSize.call(x);
        try {
            $9b88a0010bec0a10$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $9b88a0010bec0a10$var$isWeakMap(x) {
    if (!$9b88a0010bec0a10$var$weakMapHas || !x || typeof x !== "object") return false;
    try {
        $9b88a0010bec0a10$var$weakMapHas.call(x, $9b88a0010bec0a10$var$weakMapHas);
        try {
            $9b88a0010bec0a10$var$weakSetHas.call(x, $9b88a0010bec0a10$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $9b88a0010bec0a10$var$isWeakRef(x) {
    if (!$9b88a0010bec0a10$var$weakRefDeref || !x || typeof x !== "object") return false;
    try {
        $9b88a0010bec0a10$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $9b88a0010bec0a10$var$isSet(x) {
    if (!$9b88a0010bec0a10$var$setSize || !x || typeof x !== "object") return false;
    try {
        $9b88a0010bec0a10$var$setSize.call(x);
        try {
            $9b88a0010bec0a10$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $9b88a0010bec0a10$var$isWeakSet(x) {
    if (!$9b88a0010bec0a10$var$weakSetHas || !x || typeof x !== "object") return false;
    try {
        $9b88a0010bec0a10$var$weakSetHas.call(x, $9b88a0010bec0a10$var$weakSetHas);
        try {
            $9b88a0010bec0a10$var$weakMapHas.call(x, $9b88a0010bec0a10$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $9b88a0010bec0a10$var$isElement(x) {
    if (!x || typeof x !== "object") return false;
    if (typeof HTMLElement !== "undefined" && x instanceof HTMLElement) return true;
    return typeof x.nodeName === "string" && typeof x.getAttribute === "function";
}
function $9b88a0010bec0a10$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = "... " + remaining + " more character" + (remaining > 1 ? "s" : "");
        return $9b88a0010bec0a10$var$inspectString($9b88a0010bec0a10$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $9b88a0010bec0a10$var$$replace.call($9b88a0010bec0a10$var$$replace.call(str, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, $9b88a0010bec0a10$var$lowbyte);
    return $9b88a0010bec0a10$var$wrapQuotes(s, "single", opts);
}
function $9b88a0010bec0a10$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: "b",
        9: "t",
        10: "n",
        12: "f",
        13: "r"
    }[n];
    if (x) return "\\" + x;
    return "\\x" + (n < 0x10 ? "0" : "") + $9b88a0010bec0a10$var$$toUpperCase.call(n.toString(16));
}
function $9b88a0010bec0a10$var$markBoxed(str) {
    return "Object(" + str + ")";
}
function $9b88a0010bec0a10$var$weakCollectionOf(type) {
    return type + " { ? }";
}
function $9b88a0010bec0a10$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $9b88a0010bec0a10$var$indentedJoin(entries, indent) : $9b88a0010bec0a10$var$$join.call(entries, ", ");
    return type + " (" + size + ") {" + joinedEntries + "}";
}
function $9b88a0010bec0a10$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($9b88a0010bec0a10$var$indexOf(xs[i], "\n") >= 0) return false;
    }
    return true;
}
function $9b88a0010bec0a10$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === "	") baseIndent = "	";
    else if (typeof opts.indent === "number" && opts.indent > 0) baseIndent = $9b88a0010bec0a10$var$$join.call(Array(opts.indent + 1), " ");
    else return null;
    return {
        base: baseIndent,
        prev: $9b88a0010bec0a10$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $9b88a0010bec0a10$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return "";
    var lineJoiner = "\n" + indent.prev + indent.base;
    return lineJoiner + $9b88a0010bec0a10$var$$join.call(xs, "," + lineJoiner) + "\n" + indent.prev;
}
function $9b88a0010bec0a10$var$arrObjKeys(obj, inspect) {
    var isArr = $9b88a0010bec0a10$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $9b88a0010bec0a10$var$has(obj, i) ? inspect(obj[i], obj) : "";
    }
    var syms = typeof $9b88a0010bec0a10$var$gOPS === "function" ? $9b88a0010bec0a10$var$gOPS(obj) : [];
    var symMap;
    if ($9b88a0010bec0a10$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap["$" + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$9b88a0010bec0a10$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($9b88a0010bec0a10$var$hasShammedSymbols && symMap["$" + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($9b88a0010bec0a10$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ": " + inspect(obj[key], obj));
        else xs.push(key + ": " + inspect(obj[key], obj));
    }
    if (typeof $9b88a0010bec0a10$var$gOPS === "function") {
        for(var j = 0; j < syms.length; j++)if ($9b88a0010bec0a10$var$isEnumerable.call(obj, syms[j])) xs.push("[" + inspect(syms[j]) + "]: " + inspect(obj[syms[j]], obj));
    }
    return xs;
}

});


parcelRegister("ceunP", function(module, exports) {

var $l0HdX = parcelRequire("l0HdX");
"use strict";

var $kaiyL = parcelRequire("kaiyL");
var $8e7e5c59b2cdc677$var$has = Object.prototype.hasOwnProperty;
var $8e7e5c59b2cdc677$var$isArray = Array.isArray;
var $8e7e5c59b2cdc677$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push("%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
    return array;
}();
var $8e7e5c59b2cdc677$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($8e7e5c59b2cdc677$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== "undefined") compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $8e7e5c59b2cdc677$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== "undefined") obj[i] = source[i];
    return obj;
};
var $8e7e5c59b2cdc677$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== "object") {
        if ($8e7e5c59b2cdc677$var$isArray(target)) target.push(source);
        else if (target && typeof target === "object") {
            if (options && (options.plainObjects || options.allowPrototypes) || !$8e7e5c59b2cdc677$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== "object") return [
        target
    ].concat(source);
    var mergeTarget = target;
    if ($8e7e5c59b2cdc677$var$isArray(target) && !$8e7e5c59b2cdc677$var$isArray(source)) mergeTarget = $8e7e5c59b2cdc677$var$arrayToObject(target, options);
    if ($8e7e5c59b2cdc677$var$isArray(target) && $8e7e5c59b2cdc677$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($8e7e5c59b2cdc677$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === "object" && item && typeof item === "object") target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($8e7e5c59b2cdc677$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $8e7e5c59b2cdc677$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $8e7e5c59b2cdc677$var$decode = function decode(str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, " ");
    if (charset === "iso-8859-1") // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $8e7e5c59b2cdc677$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if ((typeof str === "undefined" ? "undefined" : (0, $l0HdX._)(str)) === "symbol") string = Symbol.prototype.toString.call(str);
    else if (typeof str !== "string") string = String(str);
    if (charset === "iso-8859-1") return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
    });
    var out = "";
    for(var i = 0; i < string.length; ++i){
        var c = string.charCodeAt(i);
        if (c === 0x2D // -
         || c === 0x2E // .
         || c === 0x5F // _
         || c === 0x7E // ~
         || c >= 0x30 && c <= 0x39 // 0-9
         || c >= 0x41 && c <= 0x5A // a-z
         || c >= 0x61 && c <= 0x7A // A-Z
         || format === $kaiyL.RFC1738 && (c === 0x28 || c === 0x29) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }
        if (c < 0x80) {
            out = out + $8e7e5c59b2cdc677$var$hexTable[c];
            continue;
        }
        if (c < 0x800) {
            out = out + ($8e7e5c59b2cdc677$var$hexTable[0xC0 | c >> 6] + $8e7e5c59b2cdc677$var$hexTable[0x80 | c & 0x3F]);
            continue;
        }
        if (c < 0xD800 || c >= 0xE000) {
            out = out + ($8e7e5c59b2cdc677$var$hexTable[0xE0 | c >> 12] + $8e7e5c59b2cdc677$var$hexTable[0x80 | c >> 6 & 0x3F] + $8e7e5c59b2cdc677$var$hexTable[0x80 | c & 0x3F]);
            continue;
        }
        i += 1;
        c = 0x10000 + ((c & 0x3FF) << 10 | string.charCodeAt(i) & 0x3FF);
        /* eslint operator-linebreak: [2, "before"] */ out += $8e7e5c59b2cdc677$var$hexTable[0xF0 | c >> 18] + $8e7e5c59b2cdc677$var$hexTable[0x80 | c >> 12 & 0x3F] + $8e7e5c59b2cdc677$var$hexTable[0x80 | c >> 6 & 0x3F] + $8e7e5c59b2cdc677$var$hexTable[0x80 | c & 0x3F];
    }
    return out;
};
var $8e7e5c59b2cdc677$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: "o"
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === "object" && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $8e7e5c59b2cdc677$var$compactQueue(queue);
    return value;
};
var $8e7e5c59b2cdc677$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === "[object RegExp]";
};
var $8e7e5c59b2cdc677$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== "object") return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $8e7e5c59b2cdc677$var$combine = function combine(a, b) {
    return [].concat(a, b);
};
var $8e7e5c59b2cdc677$var$maybeMap = function maybeMap(val, fn) {
    if ($8e7e5c59b2cdc677$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
module.exports = {
    arrayToObject: $8e7e5c59b2cdc677$var$arrayToObject,
    assign: $8e7e5c59b2cdc677$var$assign,
    combine: $8e7e5c59b2cdc677$var$combine,
    compact: $8e7e5c59b2cdc677$var$compact,
    decode: $8e7e5c59b2cdc677$var$decode,
    encode: $8e7e5c59b2cdc677$var$encode,
    isBuffer: $8e7e5c59b2cdc677$var$isBuffer,
    isRegExp: $8e7e5c59b2cdc677$var$isRegExp,
    maybeMap: $8e7e5c59b2cdc677$var$maybeMap,
    merge: $8e7e5c59b2cdc677$var$merge
};

});
parcelRegister("kaiyL", function(module, exports) {
"use strict";
var $eae3235f3c6efaab$var$replace = String.prototype.replace;
var $eae3235f3c6efaab$var$percentTwenties = /%20/g;
var $eae3235f3c6efaab$var$Format = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
};
module.exports = {
    "default": $eae3235f3c6efaab$var$Format.RFC3986,
    formatters: {
        RFC1738: function RFC1738(value) {
            return $eae3235f3c6efaab$var$replace.call(value, $eae3235f3c6efaab$var$percentTwenties, "+");
        },
        RFC3986: function RFC3986(value) {
            return String(value);
        }
    },
    RFC1738: $eae3235f3c6efaab$var$Format.RFC1738,
    RFC3986: $eae3235f3c6efaab$var$Format.RFC3986
};

});



parcelRegister("bC7wP", function(module, exports) {
"use strict";

var $ceunP = parcelRequire("ceunP");
var $874915579dde22f1$var$has = Object.prototype.hasOwnProperty;
var $874915579dde22f1$var$isArray = Array.isArray;
var $874915579dde22f1$var$defaults = {
    allowDots: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: false,
    comma: false,
    decoder: $ceunP.decode,
    delimiter: "&",
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};
var $874915579dde22f1$var$interpretNumericEntities = function interpretNumericEntities(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $874915579dde22f1$var$parseArrayValue = function parseArrayValue(val, options) {
    if (val && typeof val === "string" && options.comma && val.indexOf(",") > -1) return val.split(",");
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $874915579dde22f1$var$isoSentinel = "utf8=%26%2310003%3B"; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $874915579dde22f1$var$charsetSentinel = "utf8=%E2%9C%93"; // encodeURIComponent('✓')
var $874915579dde22f1$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, "") : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf("utf8=") === 0) {
            if (parts[i] === $874915579dde22f1$var$charsetSentinel) charset = "utf-8";
            else if (parts[i] === $874915579dde22f1$var$isoSentinel) charset = "iso-8859-1";
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf("]=");
        var pos = bracketEqualsPos === -1 ? part.indexOf("=") : bracketEqualsPos + 1;
        var key, val;
        if (pos === -1) {
            key = options.decoder(part, $874915579dde22f1$var$defaults.decoder, charset, "key");
            val = options.strictNullHandling ? null : "";
        } else {
            key = options.decoder(part.slice(0, pos), $874915579dde22f1$var$defaults.decoder, charset, "key");
            val = $ceunP.maybeMap($874915579dde22f1$var$parseArrayValue(part.slice(pos + 1), options), function(encodedVal) {
                return options.decoder(encodedVal, $874915579dde22f1$var$defaults.decoder, charset, "value");
            });
        }
        if (val && options.interpretNumericEntities && charset === "iso-8859-1") val = $874915579dde22f1$var$interpretNumericEntities(val);
        if (part.indexOf("[]=") > -1) val = $874915579dde22f1$var$isArray(val) ? [
            val
        ] : val;
        if ($874915579dde22f1$var$has.call(obj, key)) obj[key] = $ceunP.combine(obj[key], val);
        else obj[key] = val;
    }
    return obj;
};
var $874915579dde22f1$var$parseObject = function parseObject(chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : $874915579dde22f1$var$parseArrayValue(val, options);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === "[]" && options.parseArrays) obj = [].concat(leaf);
        else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === "[" && root.charAt(root.length - 1) === "]" ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === "") obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== cleanRoot && String(index) === cleanRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (cleanRoot !== "__proto__") obj[cleanRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $874915579dde22f1$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && $874915579dde22f1$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $874915579dde22f1$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, just add whatever is left
    if (segment) keys.push("[" + key.slice(segment.index) + "]");
    return $874915579dde22f1$var$parseObject(keys, val, options, valuesParsed);
};
var $874915579dde22f1$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $874915579dde22f1$var$defaults;
    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== "function") throw new TypeError("Decoder has to be a function.");
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var charset = typeof opts.charset === "undefined" ? $874915579dde22f1$var$defaults.charset : opts.charset;
    return {
        allowDots: typeof opts.allowDots === "undefined" ? $874915579dde22f1$var$defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === "boolean" ? opts.allowPrototypes : $874915579dde22f1$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === "boolean" ? opts.allowSparse : $874915579dde22f1$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === "number" ? opts.arrayLimit : $874915579dde22f1$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $874915579dde22f1$var$defaults.charsetSentinel,
        comma: typeof opts.comma === "boolean" ? opts.comma : $874915579dde22f1$var$defaults.comma,
        decoder: typeof opts.decoder === "function" ? opts.decoder : $874915579dde22f1$var$defaults.decoder,
        delimiter: typeof opts.delimiter === "string" || $ceunP.isRegExp(opts.delimiter) ? opts.delimiter : $874915579dde22f1$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === "number" || opts.depth === false ? +opts.depth : $874915579dde22f1$var$defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === "boolean" ? opts.interpretNumericEntities : $874915579dde22f1$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === "number" ? opts.parameterLimit : $874915579dde22f1$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === "boolean" ? opts.plainObjects : $874915579dde22f1$var$defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $874915579dde22f1$var$defaults.strictNullHandling
    };
};
module.exports = function(str, opts) {
    var options = $874915579dde22f1$var$normalizeParseOptions(opts);
    if (str === "" || str === null || typeof str === "undefined") return options.plainObjects ? Object.create(null) : {};
    var tempObj = typeof str === "string" ? $874915579dde22f1$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $874915579dde22f1$var$parseKeys(key, tempObj[key], options, typeof str === "string");
        obj = $ceunP.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $ceunP.compact(obj);
};

});






parcelRegister("7Pj87", function(module, exports) {
$parcel$export(module.exports, "CartButton", function () { return (parcelRequire("8khbJ")).CartButton; });
parcelRequire("8khbJ");

});
parcelRegister("8khbJ", function(module, exports) {

$parcel$export(module.exports, "CartButton", function () { return $60fd863491e44344$export$2188299c4297c9f7; });

var $1rY3h = parcelRequire("1rY3h");

var $145N3 = parcelRequire("145N3");

var $1Mpn7 = parcelRequire("1Mpn7");

var $cVzdx = parcelRequire("cVzdx");

var $iqdRi = parcelRequire("iqdRi");

var $9uOkP = parcelRequire("9uOkP");
var $60fd863491e44344$export$2188299c4297c9f7 = function(param) {
    var analyticsAttributes = param.analyticsAttributes, numberOfProductTrials = param.numberOfProductTrials, onClick = param.onClick;
    var createAnalyticsEvent = (0, $145N3.useAnalyticsEvents)().createAnalyticsEvent;
    (0, $1Mpn7.useEffect)(function() {
        createAnalyticsEvent({
            eventName: (0, $cVzdx.TRACKING_EVENT_NAMES).wacCartRendered,
            action: "rendered",
            actionSubject: "wacCart",
            actionSubjectId: (0, $cVzdx.ACTION_SUBJECT_IDS).wacCartRendered,
            attributes: analyticsAttributes
        }).fire();
    }, []);
    return (0, $1rY3h.jsx)("div", {
        css: (0, $iqdRi.containerStyle),
        children: (0, $1rY3h.jsx)("button", {
            "data-testid": "cart-button",
            css: (0, $iqdRi.buttonStyle),
            onClick: onClick,
            title: "View ".concat(numberOfProductTrials, " product ").concat(numberOfProductTrials > 1 ? "trials" : "trial", " ending soon"),
            children: (0, $1rY3h.jsx)((0, $9uOkP.CartIcon), {
                numberOfProductTrials: numberOfProductTrials > 5 ? "5 +" : "".concat(numberOfProductTrials)
            })
        })
    });
};

});
parcelRegister("cVzdx", function(module, exports) {

$parcel$export(module.exports, "TRACKING_EVENT_NAMES", function () { return $9696205aeb9b447c$export$9a56b303ccc53008; });
$parcel$export(module.exports, "ACTION_SUBJECT_IDS", function () { return $9696205aeb9b447c$export$2707ebe13f6c03b7; });
var $9696205aeb9b447c$export$9a56b303ccc53008;
(function(TRACKING_EVENT_NAMES) {
    TRACKING_EVENT_NAMES["errorScreenDisplayed"] = "errorScreenDisplayed";
    TRACKING_EVENT_NAMES["noEntitlementsFound"] = "noEntitlementsFound";
    TRACKING_EVENT_NAMES["noSitesFound"] = "noSitesFound";
    TRACKING_EVENT_NAMES["showAllLinkDisplayed"] = "showAllLinkDisplayed";
    TRACKING_EVENT_NAMES["showAllLinkClicked"] = "showAllLinkClicked";
    TRACKING_EVENT_NAMES["wacCartAddPaymentDetailsButtonClicked"] = "wacCartAddPaymentDetailsButtonClicked";
    TRACKING_EVENT_NAMES["wacCartIconClicked"] = "wacCartIconClicked";
    TRACKING_EVENT_NAMES["wacCartPopoverClosed"] = "wacCartPopoverClosed";
    TRACKING_EVENT_NAMES["wacCartPopoverViewed"] = "wacCartPopoverViewed";
    TRACKING_EVENT_NAMES["wacCartRendered"] = "wacCartRendered";
})($9696205aeb9b447c$export$9a56b303ccc53008 || ($9696205aeb9b447c$export$9a56b303ccc53008 = {}));
var $9696205aeb9b447c$export$2707ebe13f6c03b7;
(function(ACTION_SUBJECT_IDS) {
    ACTION_SUBJECT_IDS["wacCartRendered"] = "wacCartRendered";
    ACTION_SUBJECT_IDS["wacCartPopoverErrorScreen"] = "wacCartPopoverErrorScreen";
    ACTION_SUBJECT_IDS["wacCartShowAllLinkDisplayed"] = "wacCartShowAllLinkDisplayed";
    ACTION_SUBJECT_IDS["wacCartShowAllLinkClicked"] = "wacCartShowAllLinkClicked";
    ACTION_SUBJECT_IDS["wacCartFeatureExposed"] = "wacCartFeatureExposed";
    ACTION_SUBJECT_IDS["wacCartEstimateCallFailed"] = "wacCartEstimateCallFailed";
    ACTION_SUBJECT_IDS["wacCartUseEntitlementsFailed"] = "wacCartUseEntitlementsFailed";
    ACTION_SUBJECT_IDS["wacCartUseEntitlementListingsFailed"] = "wacCartUseEntitlementListingsFailed";
    ACTION_SUBJECT_IDS["wacCartInvoiceGroupsCallFailed"] = "wacCartInvoiceGroupsCallFailed";
    ACTION_SUBJECT_IDS["wacCartProductHubInfoReturnedNoSites"] = "wacCartProductHubInfoReturnedNoSites";
    ACTION_SUBJECT_IDS["wacCartProductHubInfoReturnedNoEntitlements"] = "wacCartProductHubInfoReturnedNoEntitlements";
    ACTION_SUBJECT_IDS["wacCartIcon"] = "wacCartIcon";
    ACTION_SUBJECT_IDS["wacCartPopover"] = "wacCartPopover";
    ACTION_SUBJECT_IDS["wacCartPopoverClosed"] = "wacCartPopoverClosed";
})($9696205aeb9b447c$export$2707ebe13f6c03b7 || ($9696205aeb9b447c$export$2707ebe13f6c03b7 = {}));

});

parcelRegister("iqdRi", function(module, exports) {

$parcel$export(module.exports, "containerStyle", function () { return $d69567c139f6182e$export$856b6de7fac89c7f; });
$parcel$export(module.exports, "buttonStyle", function () { return $d69567c139f6182e$export$fd4d27a26b4854f3; });

var $j06k0 = parcelRequire("j06k0");

var $fBy54 = parcelRequire("fBy54");
function $d69567c139f6182e$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  position: relative;\n"
    ]);
    $d69567c139f6182e$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $d69567c139f6182e$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "\n  background: none;\n  border: none;\n  margin: 0;\n  padding: 0;\n  cursor: pointer;\n"
    ]);
    $d69567c139f6182e$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $d69567c139f6182e$export$856b6de7fac89c7f = (0, $fBy54.css)($d69567c139f6182e$var$_templateObject());
var $d69567c139f6182e$export$fd4d27a26b4854f3 = (0, $fBy54.css)($d69567c139f6182e$var$_templateObject1());

});
parcelRegister("j06k0", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $dd52ebc95e8f0a15$export$263b15b19e6ed8f; });
function $dd52ebc95e8f0a15$export$263b15b19e6ed8f(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

});


parcelRegister("9uOkP", function(module, exports) {

$parcel$export(module.exports, "CartIcon", function () { return $6e9df5dfb2a6260e$export$e1c754c3bd8c71b6; });

var $1rY3h = parcelRequire("1rY3h");

var $9rZrG = parcelRequire("9rZrG");
var $6e9df5dfb2a6260e$export$e1c754c3bd8c71b6 = function(param) {
    var numberOfProductTrials = param.numberOfProductTrials;
    return (0, $1rY3h.jsxs)("div", {
        children: [
            (0, $1rY3h.jsx)("div", {
                css: (0, $9rZrG.indicatorStyle),
                children: numberOfProductTrials
            }),
            (0, $1rY3h.jsxs)("svg", {
                width: "24",
                height: "20",
                viewBox: "0 0 24 20",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        opacity: "0.5",
                        d: "M23.1329 0C23.6118 0 23.9999 0.388153 23.9999 0.866965C23.9999 1.3321 23.6336 1.71167 23.1738 1.73299L23.1329 1.73393H19.914L16.2529 13.2668C16.1428 13.6135 15.8288 13.8532 15.4684 13.8704L15.4266 13.8714H3.28908C2.81027 13.8714 2.42212 13.4833 2.42212 13.0045C2.42212 12.5393 2.78841 12.1598 3.24827 12.1384L3.28908 12.1375H14.792L18.4534 0.604639C18.5635 0.257928 18.8776 0.0182764 19.238 0.000999996L19.2798 0H23.1329Z",
                        fill: "#091E42"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M18.2356 1.29105C17.9629 1.03075 17.5925 0.867065 17.1735 0.867065H1.54237C0.499654 0.867065 -0.242156 1.88085 0.0733482 2.87469L2.77732 11.3922C2.86608 11.6718 3.0046 11.9253 3.18124 12.1442C3.20337 12.1414 3.22575 12.1395 3.24837 12.1385L3.28918 12.1375H14.7921L18.2356 1.29105Z",
                        fill: "#091E42"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M2.80762 17.1467C2.80762 15.923 3.79956 14.9311 5.02319 14.9311C6.24682 14.9311 7.23877 15.923 7.23877 17.1467C7.23877 18.3703 6.24682 19.3622 5.02319 19.3622C3.79956 19.3622 2.80762 18.3703 2.80762 17.1467Z",
                        fill: "#091E42"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M11.8625 17.1467C11.8625 15.923 12.8545 14.9311 14.0781 14.9311C15.3018 14.9311 16.2937 15.923 16.2937 17.1467C16.2937 18.3703 15.3018 19.3622 14.0781 19.3622C12.8545 19.3622 11.8625 18.3703 11.8625 17.1467Z",
                        fill: "#091E42"
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("9rZrG", function(module, exports) {

$parcel$export(module.exports, "indicatorStyle", function () { return $6e164c77a6abe678$export$11aaee185e8cb4cf; });

var $j06k0 = parcelRequire("j06k0");

var $fBy54 = parcelRequire("fBy54");

var $gDEpB = parcelRequire("gDEpB");
function $6e164c77a6abe678$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  display: flex;\n  position: absolute;\n  color: ",
        ";\n  background-color: ",
        ";\n  border-radius: 10px;\n  height: 12px;\n  min-width: 9px;\n  padding: 0 3px;\n  font-size: 8.5px;\n  top: -5px;\n  left: -9px;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    $6e164c77a6abe678$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $6e164c77a6abe678$export$11aaee185e8cb4cf = (0, $fBy54.css)($6e164c77a6abe678$var$_templateObject(), (0, $gDEpB.getColor)("n0"), (0, $gDEpB.getColor)("r500"));

});
parcelRegister("gDEpB", function(module, exports) {

$parcel$export(module.exports, "getColor", function () { return $c1cfa2d7d88f399d$export$5551a2d24ff40153; });
var $c1cfa2d7d88f399d$var$rawColors = {
    n0: "#ffffff",
    n10: "#fafbfc",
    n20: "#f4f5f7",
    n30: "#ebecf0",
    n40: "#dfe1e5",
    n50: "#c1c7d0",
    n60: "#b3bac5",
    n70: "#a5adba",
    n80: "#97a0af",
    n90: "#8993a4",
    n100: "#7a869a",
    n200: "#6c798f",
    n300: "#5e6c84",
    n400: "#505f79",
    n500: "#42526e",
    n600: "#344563",
    n700: "#253858",
    n800: "#172b4d",
    n900: "#091e42",
    y500: "#ff8b00",
    y400: "#ff991f",
    y300: "#ffab00",
    y200: "#ffc400",
    y100: "#ffe380",
    y75: "#fff0b2",
    y50: "#fffae5",
    g500: "#006644",
    g400: "#00875a",
    g300: "#36b37e",
    g200: "#57d9a3",
    g100: "#79f2c0",
    g75: "#abf5d1",
    g50: "#e3fcef",
    t500: "#008da6",
    t400: "#00a3bf",
    t300: "#00b8d9",
    t200: "#00c7e5",
    t100: "#79e2f2",
    t75: "#b3f5ff",
    t50: "#e6fcff",
    b500: "#0049b0",
    b400: "#0052cc",
    b300: "#0065ff",
    b200: "#2684ff",
    b100: "#4c9aff",
    b75: "#b2d4ff",
    b50: "#deebff",
    r500: "#bf2600",
    r400: "#de350b",
    r300: "#ff5630",
    r200: "#ff7452",
    r100: "#ff8f73",
    r75: "#ffbdad",
    r50: "#ffebe5",
    p500: "#403294",
    p400: "#5243aa",
    p300: "#6554c0",
    p200: "#8777d9",
    p100: "#998dd9",
    p75: "#c0b6f2",
    p50: "#eae6ff"
};
var $c1cfa2d7d88f399d$var$adgColors = Object.freeze($c1cfa2d7d88f399d$var$rawColors);
var $c1cfa2d7d88f399d$export$5551a2d24ff40153 = function(colorId) {
    return $c1cfa2d7d88f399d$var$adgColors["".concat(colorId.toLowerCase())] || "";
};

});





parcelRegister("iUkrv", function(module, exports) {
$parcel$export(module.exports, "EntitlementsPopup", function () { return (parcelRequire("8Fo5C")).EntitlementsPopup; });
$parcel$export(module.exports, "EntitlementItem", function () { return (parcelRequire("afdAm")).EntitlementItem; });
parcelRequire("8Fo5C");
parcelRequire("bNsTa");

});
parcelRegister("8Fo5C", function(module, exports) {

$parcel$export(module.exports, "EntitlementsPopup", function () { return $64f4d6bf0df058f2$export$15729e2920da4fd8; });

var $1rY3h = parcelRequire("1rY3h");

var $1Mpn7 = parcelRequire("1Mpn7");

var $145N3 = parcelRequire("145N3");

var $inigL = parcelRequire("inigL");

var $86q8Y = parcelRequire("86q8Y");
var $9UMwL = parcelRequire("9UMwL");

var $cVzdx = parcelRequire("cVzdx");

var $6jjHq = parcelRequire("6jjHq");

var $a7Efx = parcelRequire("a7Efx");
var $64f4d6bf0df058f2$export$15729e2920da4fd8 = function(param) {
    var addPaymentDetailsURL = param.addPaymentDetailsURL, analyticsAttributes = param.analyticsAttributes, children = param.children, formattedTotalPrice = param.formattedTotalPrice, hasError = param.hasError, isLoading = param.isLoading;
    var createAnalyticsEvent = (0, $145N3.useAnalyticsEvents)().createAnalyticsEvent;
    var handleAddPaymentDetails = function() {
        createAnalyticsEvent({
            eventName: (0, $cVzdx.TRACKING_EVENT_NAMES).wacCartAddPaymentDetailsButtonClicked,
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: "wacCartAddPaymentDetails",
            attributes: analyticsAttributes
        }).fire();
    };
    (0, $1Mpn7.useEffect)(function() {
        createAnalyticsEvent({
            eventName: (0, $cVzdx.TRACKING_EVENT_NAMES).wacCartPopoverViewed,
            action: "viewed",
            actionSubjectId: "wacCartPopover",
            attributes: analyticsAttributes
        }).fire();
    }, []);
    if (hasError) return (0, $1rY3h.jsx)("div", {
        css: (0, $6jjHq.containerStyle),
        children: (0, $1rY3h.jsx)((0, $a7Efx.ErrorState), {
            analyticsAttributes: analyticsAttributes
        })
    });
    if (isLoading) return (0, $1rY3h.jsx)("div", {
        css: (0, $6jjHq.spinnerContainerStyle),
        children: (0, $1rY3h.jsx)((0, $inigL.default), {
            size: "xlarge"
        })
    });
    return (0, $1rY3h.jsxs)("div", {
        css: (0, $6jjHq.containerStyle),
        children: [
            (0, $1rY3h.jsxs)("div", {
                css: (0, $6jjHq.headerContainerStyle),
                children: [
                    (0, $1rY3h.jsx)((0, $9UMwL.Icon), {
                        name: "exclamation",
                        size: "xs"
                    }),
                    (0, $1rY3h.jsx)("h3", {
                        css: (0, $6jjHq.headerStyle),
                        children: "Action required"
                    })
                ]
            }),
            (0, $1rY3h.jsx)("div", {
                css: (0, $6jjHq.descriptionStyle),
                children: "To avoid product deactivation, add your payment details now. Your payment details will be stored in your account for the following plans and any future purchases you make."
            }),
            (0, $1rY3h.jsx)("div", {
                css: (0, $6jjHq.dividerStyle)
            }),
            (0, $1rY3h.jsx)("div", {
                children: children
            }),
            (0, $1rY3h.jsx)("div", {
                css: (0, $6jjHq.dividerStyle)
            }),
            (0, $1rY3h.jsxs)("div", {
                css: (0, $6jjHq.footerContainerStyle),
                children: [
                    (0, $1rY3h.jsx)("div", {
                        children: "Monthly total"
                    }),
                    (0, $1rY3h.jsx)("div", {
                        css: (0, $6jjHq.totalValueStyle),
                        children: formattedTotalPrice
                    })
                ]
            }),
            (0, $1rY3h.jsx)("div", {
                css: (0, $6jjHq.taxSubtextStyle),
                children: "(excluding tax)"
            }),
            (0, $1rY3h.jsx)("div", {
                css: (0, $6jjHq.buttonWrapper),
                children: (0, $1rY3h.jsx)((0, $86q8Y.Button), {
                    text: "Add payment details",
                    color: "green",
                    onClick: handleAddPaymentDetails,
                    url: addPaymentDetailsURL
                })
            })
        ]
    });
};

});
parcelRegister("inigL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d6088be6e7a2c8bd$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $1Mpn7 = parcelRequire("1Mpn7");

var $fBy54 = parcelRequire("fBy54");

var $f3uqe = parcelRequire("f3uqe");

var $5U6pZ = parcelRequire("5U6pZ");

var $itYaQ = parcelRequire("itYaQ");

var $9Fq6Q = parcelRequire("9Fq6Q");
/**
 * Returns the appropriate circle stroke color.
 */ function $d6088be6e7a2c8bd$var$getStrokeColor(_ref) {
    var mode = _ref.mode, appearance = _ref.appearance;
    if (mode === "light") return appearance === "inherit" ? "var(--ds-icon-subtle, ".concat((0, $5U6pZ.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $5U6pZ.N0), ")");
    return appearance === "inherit" ? "var(--ds-icon-subtle, ".concat((0, $5U6pZ.DN900), ")") : "var(--ds-icon-inverse, ".concat((0, $5U6pZ.DN500), ")");
}
var $d6088be6e7a2c8bd$var$rotate = (0, $fBy54.keyframes)({
    to: {
        transform: "rotate(360deg)"
    }
});
var $d6088be6e7a2c8bd$var$rotateStyles = (0, $fBy54.css)({
    animation: "".concat($d6088be6e7a2c8bd$var$rotate, " 0.86s infinite"),
    animationTimingFunction: "cubic-bezier(0.4, 0.15, 0.6, 0.85)",
    transformOrigin: "center"
});
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $d6088be6e7a2c8bd$var$loadIn = (0, $fBy54.keyframes)({
    from: {
        transform: "rotate(50deg)",
        opacity: 0,
        strokeDashoffset: 60
    },
    to: {
        transform: "rotate(230deg)",
        opacity: 1,
        strokeDashoffset: 50
    }
});
var $d6088be6e7a2c8bd$var$loadInStyles = (0, $fBy54.css)({
    animation: "".concat($d6088be6e7a2c8bd$var$loadIn, " 1s ease-in-out"),
    /**
   * When the animation completes, stay at the last frame of the animation.
   */ animationFillMode: "forwards",
    /**
   * We are going to animate this in.
   */ opacity: 0
});
var $d6088be6e7a2c8bd$var$wrapperStyles = (0, $fBy54.css)({
    display: "inline-flex",
    /**
   * Align better inline with text.
   */ verticalAlign: "middle"
});
var $d6088be6e7a2c8bd$var$circleStyles = (0, $fBy54.css)({
    fill: "none",
    strokeDasharray: 60,
    strokeDashoffset: "inherit",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    "@media screen and (forced-colors: active)": {
        filter: "grayscale(100%)",
        stroke: "CanvasText"
    }
});
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $d6088be6e7a2c8bd$var$useLayoutEffect = typeof window === "undefined" ? (0, $1Mpn7.useEffect) : (0, $1Mpn7.useLayoutEffect);
var $d6088be6e7a2c8bd$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).forwardRef(function Spinner(_ref2, ref) {
    var _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? "inherit" : _ref2$appearance, _ref2$delay = _ref2.delay, delay = _ref2$delay === void 0 ? 0 : _ref2$delay, interactionName = _ref2.interactionName, label = _ref2.label, _ref2$size = _ref2.size, providedSize = _ref2$size === void 0 ? "medium" : _ref2$size, testId = _ref2.testId;
    var size = typeof providedSize === "number" ? providedSize : (0, $9Fq6Q.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var _useGlobalTheme = (0, $itYaQ.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    var stroke = $d6088be6e7a2c8bd$var$getStrokeColor({
        mode: mode,
        appearance: appearance
    });
    var context = (0, $1Mpn7.useContext)((0, $f3uqe.default));
    $d6088be6e7a2c8bd$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return (0, $fBy54.jsx)("span", {
        /**
     * This span exists to off-load animations from the circle element,
     * which were causing performance issues (style recalculations)
     * on Safari and older versions of Chrome.
     *
     * This can be removed and styles placed back on the circle element once
     * Safari fixes this bug and off-loads rendering to the GPU from the CPU.
     */ css: [
            $d6088be6e7a2c8bd$var$wrapperStyles,
            $d6088be6e7a2c8bd$var$rotateStyles
        ],
        "data-testid": testId && "".concat(testId, "-wrapper"),
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        }
    }, (0, $fBy54.jsx)("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label,
        css: $d6088be6e7a2c8bd$var$loadInStyles,
        style: {
            animationDelay: animationDelay
        }
    }, (0, $fBy54.jsx)("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        css: $d6088be6e7a2c8bd$var$circleStyles,
        style: {
            stroke: stroke
        }
    })));
}));

});
parcelRegister("5U6pZ", function(module, exports) {

$parcel$export(module.exports, "B200", function () { return $44c72939dd9fce68$export$215b7063051591f1; });
$parcel$export(module.exports, "N0", function () { return $44c72939dd9fce68$export$29a4f05edc054374; });
$parcel$export(module.exports, "N500", function () { return $44c72939dd9fce68$export$c39c0fe0f26207ae; });
$parcel$export(module.exports, "N30A", function () { return $44c72939dd9fce68$export$920c0d5c49070351; });
$parcel$export(module.exports, "DN900", function () { return $44c72939dd9fce68$export$2f6319cf7d736c2a; });
$parcel$export(module.exports, "DN500", function () { return $44c72939dd9fce68$export$9f0a771d16ec8d36; });
$parcel$export(module.exports, "skeleton", function () { return $44c72939dd9fce68$export$2a0674ff2eb10214; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $hNfyF = parcelRequire("hNfyF");
var $44c72939dd9fce68$export$4b84fd0e2c617bd = "#FFEBE6";
var $44c72939dd9fce68$export$b34b069eff244586 = "#FFBDAD";
var $44c72939dd9fce68$export$be802dd0d8b57f35 = "#FF8F73";
var $44c72939dd9fce68$export$60847d42f9da92a6 = "#FF7452";
var $44c72939dd9fce68$export$4a7404f376229999 = "#FF5630";
var $44c72939dd9fce68$export$2010d0fb4295b346 = "#DE350B";
var $44c72939dd9fce68$export$2837b5a1a71d5c02 = "#BF2600";
var $44c72939dd9fce68$export$8d9596b529bbb9cf = "#FFFAE6";
var $44c72939dd9fce68$export$41060a744ab0b7ae = "#FFF0B3";
var $44c72939dd9fce68$export$1cc05bbbf340e559 = "#FFE380";
var $44c72939dd9fce68$export$5aae31392d72caaa = "#FFC400";
var $44c72939dd9fce68$export$c6930421db9fa514 = "#FFAB00";
var $44c72939dd9fce68$export$59619663aa6500fb = "#FF991F";
var $44c72939dd9fce68$export$874739ea9e379ab6 = "#FF8B00";
var $44c72939dd9fce68$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $44c72939dd9fce68$export$69a3bf21b9686c2b = "#ABF5D1";
var $44c72939dd9fce68$export$afbce1382ec95f73 = "#79F2C0";
var $44c72939dd9fce68$export$747d86715d4175de = "#57D9A3";
var $44c72939dd9fce68$export$940e1f69e873f202 = "#36B37E";
var $44c72939dd9fce68$export$a49394138f7b8e85 = "#00875A";
var $44c72939dd9fce68$export$6fa04827ac68a4fb = "#006644";
var $44c72939dd9fce68$export$226de0355ed012f8 = "#DEEBFF";
var $44c72939dd9fce68$export$8c13c2ee36917869 = "#B3D4FF";
var $44c72939dd9fce68$export$ecfc1dff386a3e7a = "#4C9AFF";
var $44c72939dd9fce68$export$215b7063051591f1 = "#2684FF";
var $44c72939dd9fce68$export$e62e8919cca44969 = "#0065FF";
var $44c72939dd9fce68$export$b3de0ae08da2ce64 = "#0052CC";
var $44c72939dd9fce68$export$a6ee3d71bc067634 = "#0747A6";
var $44c72939dd9fce68$export$363e4475840015bb = "#EAE6FF";
var $44c72939dd9fce68$export$4b0a4417ed59760f = "#C0B6F2";
var $44c72939dd9fce68$export$6011520a64d9a187 = "#998DD9";
var $44c72939dd9fce68$export$a7175d4e9206bc80 = "#8777D9";
var $44c72939dd9fce68$export$b48405b95304b5a1 = "#6554C0";
var $44c72939dd9fce68$export$c71e4279dd54a18d = "#5243AA";
var $44c72939dd9fce68$export$147899de772240ec = "#403294";
var $44c72939dd9fce68$export$2cf711fe14c66f06 = "#E6FCFF";
var $44c72939dd9fce68$export$7a8f4d33f6f9772c = "#B3F5FF";
var $44c72939dd9fce68$export$776c9c497ef08533 = "#79E2F2";
var $44c72939dd9fce68$export$69cb3ca10c1e330e = "#00C7E6";
var $44c72939dd9fce68$export$9dc1ef0f3f48059b = "#00B8D9";
var $44c72939dd9fce68$export$7c835c78b6fcdef8 = "#00A3BF";
var $44c72939dd9fce68$export$6036577f95c3877e = "#008DA6";
var $44c72939dd9fce68$export$29a4f05edc054374 = "#FFFFFF";
var $44c72939dd9fce68$export$e655ef011c4aa1a2 = "#FAFBFC";
var $44c72939dd9fce68$export$9fdfb749e33cdf97 = "#F4F5F7";
var $44c72939dd9fce68$export$3e51e8f1440314ba = "#EBECF0";
var $44c72939dd9fce68$export$1ce2d1575d444ceb = "#DFE1E6";
var $44c72939dd9fce68$export$8754fc7e6d8b3000 = "#C1C7D0";
var $44c72939dd9fce68$export$c2e91cbeada39b8b = "#B3BAC5";
var $44c72939dd9fce68$export$5f71e19f3a7ad9de = "#A5ADBA";
var $44c72939dd9fce68$export$eaa8c8a70ac22806 = "#97A0AF";
var $44c72939dd9fce68$export$7c87d337fb91a97d = "#8993A4";
var $44c72939dd9fce68$export$d6447c357493214f = "#7A869A";
var $44c72939dd9fce68$export$f563ee71e9ee74cd = "#6B778C";
var $44c72939dd9fce68$export$e2ef2124cf4024b1 = "#5E6C84";
var $44c72939dd9fce68$export$eece5f492e429f08 = "#505F79";
var $44c72939dd9fce68$export$c39c0fe0f26207ae = "#42526E";
var $44c72939dd9fce68$export$7090862dc3038a9f = "#344563";
var $44c72939dd9fce68$export$ad0bacf983b7ddaa = "#253858";
var $44c72939dd9fce68$export$7d61b15e0da132af = "#172B4D";
var $44c72939dd9fce68$export$fbda843f0a27fe96 = "#091E42";
var $44c72939dd9fce68$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $44c72939dd9fce68$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $44c72939dd9fce68$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $44c72939dd9fce68$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $44c72939dd9fce68$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $44c72939dd9fce68$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $44c72939dd9fce68$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $44c72939dd9fce68$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $44c72939dd9fce68$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $44c72939dd9fce68$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $44c72939dd9fce68$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $44c72939dd9fce68$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $44c72939dd9fce68$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $44c72939dd9fce68$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $44c72939dd9fce68$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $44c72939dd9fce68$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $44c72939dd9fce68$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $44c72939dd9fce68$export$2f6319cf7d736c2a = "#E6EDFA";
var $44c72939dd9fce68$export$95126bc8884d6634 = "#DCE5F5";
var $44c72939dd9fce68$export$8338d8c35d44ff1 = "#CED9EB";
var $44c72939dd9fce68$export$5368d76ae4fbbda7 = "#B8C7E0";
var $44c72939dd9fce68$export$9f0a771d16ec8d36 = "#ABBBD6";
var $44c72939dd9fce68$export$abcf8c38338b4aa5 = "#9FB0CC";
var $44c72939dd9fce68$export$97e81faa16a182c7 = "#8C9CB8";
var $44c72939dd9fce68$export$bfe21c59123ecf33 = "#7988A3";
var $44c72939dd9fce68$export$ee82aa2ea6a1558 = "#67758F";
var $44c72939dd9fce68$export$682927c6ed76be02 = "#56637A";
var $44c72939dd9fce68$export$91fd9994c5be9757 = "#455166";
var $44c72939dd9fce68$export$d281fbfe3cff2df6 = "#3B475C";
var $44c72939dd9fce68$export$3902c91d8b98a753 = "#313D52";
var $44c72939dd9fce68$export$8e8133c1ba5845b5 = "#283447";
var $44c72939dd9fce68$export$33ff357f6620b39 = "#202B3D";
var $44c72939dd9fce68$export$633847cf062b69e0 = "#1B2638";
var $44c72939dd9fce68$export$9776a6e503bdbf76 = "#121A29";
var $44c72939dd9fce68$export$6c813d5160dff5db = "#0E1624";
var $44c72939dd9fce68$export$3d4f271a500072a = "#0D1424";
var $44c72939dd9fce68$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $44c72939dd9fce68$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $44c72939dd9fce68$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $44c72939dd9fce68$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $44c72939dd9fce68$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $44c72939dd9fce68$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $44c72939dd9fce68$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $44c72939dd9fce68$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $44c72939dd9fce68$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $44c72939dd9fce68$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $44c72939dd9fce68$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $44c72939dd9fce68$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $44c72939dd9fce68$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $44c72939dd9fce68$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $44c72939dd9fce68$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $44c72939dd9fce68$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $44c72939dd9fce68$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $44c72939dd9fce68$export$8ce1fd94bee2f412 = (0, $hNfyF.default)({
    light: "var(--ds-surface, ".concat($44c72939dd9fce68$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface, ".concat($44c72939dd9fce68$export$633847cf062b69e0, ")")
});
var $44c72939dd9fce68$export$b861914ea877b580 = (0, $hNfyF.default)({
    light: "var(--ds-background-selected, ".concat($44c72939dd9fce68$export$226de0355ed012f8, ")"),
    dark: "var(--ds-background-selected, ".concat($44c72939dd9fce68$export$8c13c2ee36917869, ")")
});
var $44c72939dd9fce68$export$3f1b020df94387af = (0, $hNfyF.default)({
    light: "var(--ds-background-neutral-hovered, ".concat($44c72939dd9fce68$export$3e51e8f1440314ba, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat($44c72939dd9fce68$export$d281fbfe3cff2df6, ")")
});
var $44c72939dd9fce68$export$c0183dbab98ca63e = (0, $hNfyF.default)({
    light: "var(--ds-surface-overlay, ".concat($44c72939dd9fce68$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface-overlay, ".concat($44c72939dd9fce68$export$8e8133c1ba5845b5, ")")
});
var $44c72939dd9fce68$export$6f093cfa640b7166 = (0, $hNfyF.default)({
    light: "var(--ds-text, ".concat($44c72939dd9fce68$export$fbda843f0a27fe96, ")"),
    dark: "var(--ds-text, ".concat($44c72939dd9fce68$export$5368d76ae4fbbda7, ")")
});
var $44c72939dd9fce68$export$42f8e9c698766e7a = (0, $hNfyF.default)({
    light: "var(--ds-text, ".concat($44c72939dd9fce68$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($44c72939dd9fce68$export$5368d76ae4fbbda7, ")")
});
var $44c72939dd9fce68$export$c2d157ca1c34b6e3 = (0, $hNfyF.default)({
    light: "var(--ds-text-selected, ".concat($44c72939dd9fce68$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-text-selected, ".concat($44c72939dd9fce68$export$b3de0ae08da2ce64, ")")
});
var $44c72939dd9fce68$export$1905ba28d7cf066f = (0, $hNfyF.default)({
    light: "var(--ds-text-subtlest, ".concat($44c72939dd9fce68$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($44c72939dd9fce68$export$97e81faa16a182c7, ")")
});
var $44c72939dd9fce68$export$bd9002130d306d39 = (0, $hNfyF.default)({
    light: "var(--ds-text-subtlest, ".concat($44c72939dd9fce68$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($44c72939dd9fce68$export$bfe21c59123ecf33, ")")
});
var $44c72939dd9fce68$export$46e4a324ac90507f = (0, $hNfyF.default)({
    light: "var(--ds-text, ".concat($44c72939dd9fce68$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($44c72939dd9fce68$export$5368d76ae4fbbda7, ")")
});
var $44c72939dd9fce68$export$79f3f2b82beb0d36 = (0, $hNfyF.default)({
    light: "var(--ds-text-subtlest, ".concat($44c72939dd9fce68$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($44c72939dd9fce68$export$97e81faa16a182c7, ")")
});
var $44c72939dd9fce68$export$7bb0d5c671655cc4 = (0, $hNfyF.default)({
    light: $44c72939dd9fce68$export$9fdfb749e33cdf97,
    dark: $44c72939dd9fce68$export$8e8133c1ba5845b5
});
var $44c72939dd9fce68$export$9c30223ca0a664fb = (0, $hNfyF.default)({
    light: "var(--ds-link, ".concat($44c72939dd9fce68$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-link, ".concat($44c72939dd9fce68$export$ecfc1dff386a3e7a, ")")
});
var $44c72939dd9fce68$export$7ed258b0728b004b = (0, $hNfyF.default)({
    light: "var(--ds-link-pressed, ".concat($44c72939dd9fce68$export$e62e8919cca44969, ")"),
    dark: "var(--ds-link-pressed, ".concat($44c72939dd9fce68$export$215b7063051591f1, ")")
});
var $44c72939dd9fce68$export$dfa920d8decc8a59 = (0, $hNfyF.default)({
    light: "var(--ds-link-pressed, ".concat($44c72939dd9fce68$export$a6ee3d71bc067634, ")"),
    dark: "var(--ds-link-pressed, ".concat($44c72939dd9fce68$export$ecfc1dff386a3e7a, ")")
});
var $44c72939dd9fce68$export$6069e6ad5c78f632 = (0, $hNfyF.default)({
    light: "var(--ds-border-focused, ".concat($44c72939dd9fce68$export$215b7063051591f1, ")"),
    dark: "var(--ds-border-focused, ".concat($44c72939dd9fce68$export$215b7063051591f1, ")")
});
var $44c72939dd9fce68$export$9ad721cf3b3debe0 = (0, $hNfyF.default)({
    light: "var(--ds-background-brand-bold, ".concat($44c72939dd9fce68$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-background-brand-bold, ".concat($44c72939dd9fce68$export$ecfc1dff386a3e7a, ")")
});
var $44c72939dd9fce68$export$2aa0182783e7e9de = (0, $hNfyF.default)({
    light: $44c72939dd9fce68$export$b3de0ae08da2ce64,
    dark: $44c72939dd9fce68$export$ecfc1dff386a3e7a
});
var $44c72939dd9fce68$export$8bf7dff220b82b4a = (0, $hNfyF.default)({
    light: $44c72939dd9fce68$export$9dc1ef0f3f48059b,
    dark: $44c72939dd9fce68$export$69cb3ca10c1e330e
});
var $44c72939dd9fce68$export$e13cce2a2d16a9d4 = (0, $hNfyF.default)({
    light: $44c72939dd9fce68$export$b48405b95304b5a1,
    dark: $44c72939dd9fce68$export$6011520a64d9a187
});
var $44c72939dd9fce68$export$a90204d1394caf30 = (0, $hNfyF.default)({
    light: $44c72939dd9fce68$export$4a7404f376229999,
    dark: $44c72939dd9fce68$export$4a7404f376229999
});
var $44c72939dd9fce68$export$594c5a8758200c32 = (0, $hNfyF.default)({
    light: $44c72939dd9fce68$export$c6930421db9fa514,
    dark: $44c72939dd9fce68$export$c6930421db9fa514
});
var $44c72939dd9fce68$export$955a2ebd2fb142ae = (0, $hNfyF.default)({
    light: $44c72939dd9fce68$export$940e1f69e873f202,
    dark: $44c72939dd9fce68$export$940e1f69e873f202
});
var $44c72939dd9fce68$export$2a0674ff2eb10214 = function skeleton() {
    return "var(--ds-skeleton, ".concat($44c72939dd9fce68$export$8d43898f60b96a82, ")");
};

});
parcelRegister("hNfyF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf4314c6d4648f83$export$2e2bcd8739ae039; });
/* eslint-disable prefer-rest-params */ 
var $fwvgd = parcelRequire("fwvgd");
// Unpack custom variants, and get correct value for the current theme
function $cf4314c6d4648f83$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $fwvgd.default)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return "";
    };
}
function $cf4314c6d4648f83$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === "string") return $cf4314c6d4648f83$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $fwvgd.default)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return "";
    };
}

});
parcelRegister("fwvgd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b4d217d7e62d4a8f$export$2e2bcd8739ae039; });

var $bHYtW = parcelRequire("bHYtW");
function $b4d217d7e62d4a8f$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $bHYtW.CHANNEL) in props.theme) return props.theme[0, $bHYtW.CHANNEL];
        else if ("mode" in props.theme && (0, $bHYtW.THEME_MODES).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $bHYtW.DEFAULT_THEME_MODE)
    };
}

});
parcelRegister("bHYtW", function(module, exports) {

$parcel$export(module.exports, "CHANNEL", function () { return $8862a04a9e456dff$export$44ffba16bd48dac6; });
$parcel$export(module.exports, "DEFAULT_THEME_MODE", function () { return $8862a04a9e456dff$export$c93026a968943f95; });
$parcel$export(module.exports, "THEME_MODES", function () { return $8862a04a9e456dff$export$6ba72c8346b4c57e; });

var $2Eqc7 = parcelRequire("2Eqc7");

var $5U6pZ = parcelRequire("5U6pZ");
var $8862a04a9e456dff$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $8862a04a9e456dff$export$c93026a968943f95 = "light";
var $8862a04a9e456dff$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $8862a04a9e456dff$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $8862a04a9e456dff$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $8862a04a9e456dff$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $8862a04a9e456dff$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $8862a04a9e456dff$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $8862a04a9e456dff$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $8862a04a9e456dff$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $5U6pZ.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $8862a04a9e456dff$export$6d8204c2cb2e06b8() / 4;
    (0, $2Eqc7.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $8862a04a9e456dff$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $8862a04a9e456dff$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $8862a04a9e456dff$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $2Eqc7.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $8862a04a9e456dff$export$ba1d834b86d72a09 = $8862a04a9e456dff$export$a1b3edb637fb4f35;
var $8862a04a9e456dff$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $5U6pZ.skeleton)(), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $5U6pZ.skeleton)(), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $5U6pZ.N30A), ")")
            }
        }
    };
};

});




parcelRegister("itYaQ", function(module, exports) {

$parcel$export(module.exports, "useGlobalTheme", function () { return $d7499cb5f7b5bc0a$export$7692396083754928; });

var $hGyfN = parcelRequire("hGyfN");
// Create default global light theme
var $d7499cb5f7b5bc0a$var$_createTheme = (0, $hGyfN.createTheme)(function() {
    return {
        mode: "light"
    };
}), $d7499cb5f7b5bc0a$var$Provider = $d7499cb5f7b5bc0a$var$_createTheme.Provider, $d7499cb5f7b5bc0a$var$Consumer = $d7499cb5f7b5bc0a$var$_createTheme.Consumer, $d7499cb5f7b5bc0a$export$7692396083754928 = $d7499cb5f7b5bc0a$var$_createTheme.useTheme;
var $d7499cb5f7b5bc0a$export$2e2bcd8739ae039 = {
    Provider: $d7499cb5f7b5bc0a$var$Provider,
    Consumer: $d7499cb5f7b5bc0a$var$Consumer
};

});
parcelRegister("hGyfN", function(module, exports) {

$parcel$export(module.exports, "createTheme", function () { return $ce00ee05ffaf7329$export$25d302a5b900a763; });

var $04Kcc = parcelRequire("04Kcc");

var $1Mpn7 = parcelRequire("1Mpn7");
var $ce00ee05ffaf7329$var$_excluded = [
    "children"
];
function $ce00ee05ffaf7329$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $1Mpn7.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $1Mpn7.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, (/*@__PURE__*/$parcel$interopDefault($04Kcc)))(props, $ce00ee05ffaf7329$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $1Mpn7.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $1Mpn7.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});


parcelRegister("9Fq6Q", function(module, exports) {

$parcel$export(module.exports, "presetSizes", function () { return $709c322682799c44$export$4e9f1640bbe7a1a8; });
var $709c322682799c44$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});


parcelRegister("86q8Y", function(module, exports) {

$parcel$export(module.exports, "Button", function () { return $5e6329e230549c75$export$353f5b6fc5456de1; });

var $j06k0 = parcelRequire("j06k0");

var $1rY3h = parcelRequire("1rY3h");

var $fBy54 = parcelRequire("fBy54");

var $gDEpB = parcelRequire("gDEpB");
function $5e6329e230549c75$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n    align-items: center;\n    background: ",
        ";\n    border-radius: 0.25rem;\n    box-sizing: border-box;\n    border: ",
        ";\n    cursor: ",
        ";\n    color: ",
        ";\n    display: inline-flex;\n    font-weight: 600;\n    font-size: ",
        "rem;\n    font-family: var(--bxp-charlie-text-font-family);\n    height: ",
        "rem;\n    line-height: 1.25rem;\n    padding: 0 1rem;\n    text-align: center;\n    text-decoration: none;\n    :hover,\n    :focus {\n      background: ",
        ";\n    }\n    :active {\n      background: ",
        ";\n    }\n  "
    ]);
    $5e6329e230549c75$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $5e6329e230549c75$var$buttonStyles = {
    primary: {
        // default styles
        darkblue: {
            textColor: (0, $gDEpB.getColor)("n0"),
            buttonBackgroundColor: (0, $gDEpB.getColor)("b400"),
            buttonHoverColor: "#0047B3",
            buttonFocusColor: "#004099",
            border: "none"
        },
        yellow: {
            textColor: (0, $gDEpB.getColor)("n800"),
            buttonBackgroundColor: (0, $gDEpB.getColor)("y300"),
            buttonHoverColor: (0, $gDEpB.getColor)("y400"),
            buttonFocusColor: (0, $gDEpB.getColor)("y500"),
            border: "none"
        },
        green: {
            textColor: (0, $gDEpB.getColor)("n800"),
            buttonBackgroundColor: (0, $gDEpB.getColor)("g100"),
            buttonHoverColor: (0, $gDEpB.getColor)("g200"),
            buttonFocusColor: (0, $gDEpB.getColor)("g300"),
            border: "none"
        },
        lightblue: {
            textColor: (0, $gDEpB.getColor)("b400"),
            buttonBackgroundColor: (0, $gDEpB.getColor)("b50"),
            buttonHoverColor: "#B3D4FF",
            buttonFocusColor: (0, $gDEpB.getColor)("b100"),
            border: "none"
        },
        gray: {
            textColor: (0, $gDEpB.getColor)("n800"),
            buttonBackgroundColor: (0, $gDEpB.getColor)("n30"),
            buttonHoverColor: "#DFE1E6",
            buttonFocusColor: (0, $gDEpB.getColor)("n50"),
            border: "none"
        },
        disabled: {
            textColor: (0, $gDEpB.getColor)("n80"),
            buttonBackgroundColor: (0, $gDEpB.getColor)("n30"),
            buttonHoverColor: "",
            buttonFocusColor: "",
            border: "none"
        }
    },
    secondary: {
        darkblue: {
            textColor: (0, $gDEpB.getColor)("b400"),
            buttonBackgroundColor: "transparent",
            buttonHoverColor: (0, $gDEpB.getColor)("n30"),
            buttonFocusColor: (0, $gDEpB.getColor)("b50"),
            border: "0.063rem solid ".concat((0, $gDEpB.getColor)("b400"))
        },
        yellow: {
            textColor: (0, $gDEpB.getColor)("n800"),
            buttonBackgroundColor: "transparent",
            buttonHoverColor: (0, $gDEpB.getColor)("n20"),
            buttonFocusColor: "#FFF0B3",
            border: "0.063rem solid ".concat((0, $gDEpB.getColor)("y300"))
        },
        green: {
            textColor: (0, $gDEpB.getColor)("n800"),
            buttonBackgroundColor: "transparent",
            buttonHoverColor: (0, $gDEpB.getColor)("n20"),
            buttonFocusColor: (0, $gDEpB.getColor)("g50"),
            border: "0.063rem solid ".concat((0, $gDEpB.getColor)("g100"))
        },
        white: {
            textColor: (0, $gDEpB.getColor)("n0"),
            buttonBackgroundColor: "transparent",
            buttonHoverColor: "rgba(255, 255, 255, 0.10)",
            buttonFocusColor: "rgba(255, 255, 255, 0.20)",
            border: "0.063rem solid ".concat((0, $gDEpB.getColor)("n0"))
        },
        disabled: {
            textColor: (0, $gDEpB.getColor)("n80"),
            buttonBackgroundColor: (0, $gDEpB.getColor)("n30"),
            buttonHoverColor: "",
            buttonFocusColor: "",
            border: "none"
        }
    }
};
var $5e6329e230549c75$var$getButtonSize = function(size) {
    if (size) {
        var buttonSize = size.toLowerCase();
        return buttonSize ? buttonSize : "large";
    }
    return "large";
};
var $5e6329e230549c75$var$getButtonType = function(type) {
    var buttonType = type === null || type === void 0 ? void 0 : type.toLowerCase();
    if (buttonType) return buttonType;
    return "primary";
};
var $5e6329e230549c75$var$getButtonColor = function(color, disabled) {
    var buttonColor = color === null || color === void 0 ? void 0 : color.toLowerCase();
    if (disabled) return "disabled";
    if (buttonColor) return buttonColor;
    return "darkblue";
};
var $5e6329e230549c75$var$getButtonStyles = function(color, type) {
    var buttonTypeStyles = $5e6329e230549c75$var$buttonStyles[type];
    var styles = buttonTypeStyles[color];
    if (styles) return styles;
    // return darkblue primary styles if style was not found
    return $5e6329e230549c75$var$buttonStyles.primary.darkblue;
};
var $5e6329e230549c75$export$353f5b6fc5456de1 = function(param) {
    var text = param.text, type = param.type, color = param.color, size = param.size, onClick = param.onClick, url = param.url, inputType = param.inputType, disabled = param.disabled, className = param.className;
    var buttonType = $5e6329e230549c75$var$getButtonType(type);
    var buttonColor = $5e6329e230549c75$var$getButtonColor(color, disabled);
    var _getButtonStyles = $5e6329e230549c75$var$getButtonStyles(buttonColor, buttonType), textColor = _getButtonStyles.textColor, buttonBackgroundColor = _getButtonStyles.buttonBackgroundColor, buttonHoverColor = _getButtonStyles.buttonHoverColor, buttonFocusColor = _getButtonStyles.buttonFocusColor, border = _getButtonStyles.border;
    var buttonSize = $5e6329e230549c75$var$getButtonSize(size);
    var buttonHeight = buttonSize === "large" ? 2.5 : 2;
    var fontSize = buttonSize === "large" ? 1 : 0.875;
    var cursor = disabled ? "cursor" : "pointer";
    var serializedStyles = (0, $fBy54.css)($5e6329e230549c75$var$_templateObject(), buttonBackgroundColor, border, cursor, textColor, fontSize, buttonHeight, buttonHoverColor, buttonFocusColor);
    if ((onClick || inputType) && !url) return (0, $1rY3h.jsx)("button", {
        className: className,
        css: serializedStyles,
        onClick: onClick,
        disabled: disabled,
        type: inputType,
        children: text
    });
    return (0, $1rY3h.jsx)("a", {
        className: className,
        css: serializedStyles,
        onClick: onClick,
        href: url,
        children: text
    });
};

});

parcelRegister("9UMwL", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $737efc93158d5e31$export$f04a61298a47a40f; });

var $j06k0 = parcelRequire("j06k0");

var $1rY3h = parcelRequire("1rY3h");

var $1sdSq = parcelRequire("1sdSq");

var $4WayF = parcelRequire("4WayF");

var $4GLK6 = parcelRequire("4GLK6");

var $l4PIC = parcelRequire("l4PIC");

var $5jeiR = parcelRequire("5jeiR");

var $9x9Gr = parcelRequire("9x9Gr");

var $bqlHL = parcelRequire("bqlHL");

var $2cJvN = parcelRequire("2cJvN");

var $99M7w = parcelRequire("99M7w");

var $bXno7 = parcelRequire("bXno7");

var $igz15 = parcelRequire("igz15");

var $1sKJ3 = parcelRequire("1sKJ3");

var $eK5GP = parcelRequire("eK5GP");

var $3L83V = parcelRequire("3L83V");

var $5imT3 = parcelRequire("5imT3");

var $ecGKx = parcelRequire("ecGKx");

var $gUdRh = parcelRequire("gUdRh");

var $72VhV = parcelRequire("72VhV");

var $80smX = parcelRequire("80smX");

var $1kG8v = parcelRequire("1kG8v");

var $dqXGo = parcelRequire("dqXGo");

var $lxqDS = parcelRequire("lxqDS");

var $6RjL7 = parcelRequire("6RjL7");

var $c6hAX = parcelRequire("c6hAX");

var $dYiSZ = parcelRequire("dYiSZ");

var $lHyqP = parcelRequire("lHyqP");

var $kzZQ5 = parcelRequire("kzZQ5");

var $hZw5k = parcelRequire("hZw5k");

var $fSROr = parcelRequire("fSROr");

var $5q1H2 = parcelRequire("5q1H2");

var $fYyLp = parcelRequire("fYyLp");

var $2iaWw = parcelRequire("2iaWw");

var $jhpRG = parcelRequire("jhpRG");

var $79uDZ = parcelRequire("79uDZ");

var $Kjn7K = parcelRequire("Kjn7K");

var $84UrG = parcelRequire("84UrG");

var $c3xu1 = parcelRequire("c3xu1");

var $hnqHH = parcelRequire("hnqHH");

var $6dHHN = parcelRequire("6dHHN");

var $hEfAB = parcelRequire("hEfAB");

var $cJdRZ = parcelRequire("cJdRZ");

var $kgLUC = parcelRequire("kgLUC");

var $j2AWN = parcelRequire("j2AWN");

var $dSNCm = parcelRequire("dSNCm");

var $iYhKo = parcelRequire("iYhKo");

var $1ZVrE = parcelRequire("1ZVrE");

var $89NJj = parcelRequire("89NJj");

var $4lWxZ = parcelRequire("4lWxZ");

var $cVIPN = parcelRequire("cVIPN");

var $cruFA = parcelRequire("cruFA");

var $gjryf = parcelRequire("gjryf");

var $7WpHj = parcelRequire("7WpHj");

var $2ho8t = parcelRequire("2ho8t");

var $fgpyD = parcelRequire("fgpyD");

var $iY3Qo = parcelRequire("iY3Qo");

var $60CU0 = parcelRequire("60CU0");

var $9GPbT = parcelRequire("9GPbT");

var $c9Bb7 = parcelRequire("c9Bb7");

var $1Q6qD = parcelRequire("1Q6qD");

var $5lVc4 = parcelRequire("5lVc4");

var $5d2m8 = parcelRequire("5d2m8");

var $6zTaB = parcelRequire("6zTaB");

var $d7YRX = parcelRequire("d7YRX");

var $2d8PF = parcelRequire("2d8PF");

var $2caah = parcelRequire("2caah");

var $iZWiv = parcelRequire("iZWiv");

var $jsl99 = parcelRequire("jsl99");

var $bLc9o = parcelRequire("bLc9o");

var $23dQH = parcelRequire("23dQH");

var $cWo99 = parcelRequire("cWo99");

var $e8Wg9 = parcelRequire("e8Wg9");

var $3XnA3 = parcelRequire("3XnA3");

var $83JNv = parcelRequire("83JNv");

var $4T9wY = parcelRequire("4T9wY");

var $89ffd = parcelRequire("89ffd");

var $buEWq = parcelRequire("buEWq");

var $3iGkz = parcelRequire("3iGkz");

var $4kgJO = parcelRequire("4kgJO");

var $kssg0 = parcelRequire("kssg0");

var $5JKJp = parcelRequire("5JKJp");

var $y6HFH = parcelRequire("y6HFH");

var $7uSpA = parcelRequire("7uSpA");

var $8sU4a = parcelRequire("8sU4a");

var $fWfPz = parcelRequire("fWfPz");

var $4a6nf = parcelRequire("4a6nf");

var $fv9M2 = parcelRequire("fv9M2");

var $cZBJi = parcelRequire("cZBJi");

var $fPdFb = parcelRequire("fPdFb");

var $7OC0z = parcelRequire("7OC0z");

var $4IVy6 = parcelRequire("4IVy6");

var $9fn0O = parcelRequire("9fn0O");

var $2eLrk = parcelRequire("2eLrk");

var $IDulL = parcelRequire("IDulL");

var $hWtcH = parcelRequire("hWtcH");

var $flNq6 = parcelRequire("flNq6");

var $g1GYo = parcelRequire("g1GYo");

var $eDZ7Y = parcelRequire("eDZ7Y");

var $2GfFa = parcelRequire("2GfFa");

var $iVuUd = parcelRequire("iVuUd");

var $bO06j = parcelRequire("bO06j");

var $fJxZA = parcelRequire("fJxZA");

var $cSNv3 = parcelRequire("cSNv3");

var $2HPqn = parcelRequire("2HPqn");

var $c3DOg = parcelRequire("c3DOg");

var $axYxr = parcelRequire("axYxr");

var $9hy0Y = parcelRequire("9hy0Y");

var $8EIOd = parcelRequire("8EIOd");

var $akmn5 = parcelRequire("akmn5");

var $2fx8N = parcelRequire("2fx8N");

var $5DZ5M = parcelRequire("5DZ5M");

var $32N3Z = parcelRequire("32N3Z");

var $y11yg = parcelRequire("y11yg");

var $dC1ZG = parcelRequire("dC1ZG");

var $aBxBD = parcelRequire("aBxBD");

var $iyCw2 = parcelRequire("iyCw2");

var $kLpeD = parcelRequire("kLpeD");

var $fChtk = parcelRequire("fChtk");

var $bPPvN = parcelRequire("bPPvN");

var $5Q6bk = parcelRequire("5Q6bk");

var $3arRy = parcelRequire("3arRy");

var $j2pub = parcelRequire("j2pub");

var $2y5Fy = parcelRequire("2y5Fy");

var $2Uzy1 = parcelRequire("2Uzy1");

var $fB9Me = parcelRequire("fB9Me");

var $h7iOA = parcelRequire("h7iOA");

var $gd415 = parcelRequire("gd415");

var $2weR5 = parcelRequire("2weR5");

var $gtRWF = parcelRequire("gtRWF");

var $kET9Z = parcelRequire("kET9Z");

var $jaE3v = parcelRequire("jaE3v");

var $gRPoa = parcelRequire("gRPoa");

var $hP3aT = parcelRequire("hP3aT");

var $5Xzri = parcelRequire("5Xzri");

var $bciKd = parcelRequire("bciKd");

var $2VED3 = parcelRequire("2VED3");

var $d1F1T = parcelRequire("d1F1T");

var $apOGQ = parcelRequire("apOGQ");

var $huMrE = parcelRequire("huMrE");

var $8jk5f = parcelRequire("8jk5f");

var $ixEjJ = parcelRequire("ixEjJ");

var $koSWo = parcelRequire("koSWo");

var $lIQ9r = parcelRequire("lIQ9r");

var $bUhTm = parcelRequire("bUhTm");

var $g5Woz = parcelRequire("g5Woz");

var $9qiqk = parcelRequire("9qiqk");

var $9V6dX = parcelRequire("9V6dX");

var $2FCbO = parcelRequire("2FCbO");

var $k8naB = parcelRequire("k8naB");

var $8Eq85 = parcelRequire("8Eq85");

var $6BHX5 = parcelRequire("6BHX5");

var $nGhoH = parcelRequire("nGhoH");

var $84pwJ = parcelRequire("84pwJ");

var $100Ph = parcelRequire("100Ph");

var $61z2V = parcelRequire("61z2V");

var $kQkE3 = parcelRequire("kQkE3");

var $PqOMb = parcelRequire("PqOMb");

var $3aYSv = parcelRequire("3aYSv");

var $4tQtC = parcelRequire("4tQtC");

var $6OhQm = parcelRequire("6OhQm");

var $6iGyx = parcelRequire("6iGyx");

var $9DfNj = parcelRequire("9DfNj");

var $fiuCn = parcelRequire("fiuCn");

var $3VSq5 = parcelRequire("3VSq5");

var $g2Au7 = parcelRequire("g2Au7");

var $88Rcr = parcelRequire("88Rcr");

var $22xfN = parcelRequire("22xfN");

var $brafE = parcelRequire("brafE");

var $6grkJ = parcelRequire("6grkJ");

var $exsmi = parcelRequire("exsmi");

var $fGdwN = parcelRequire("fGdwN");

var $5Ic6A = parcelRequire("5Ic6A");

var $dpVLK = parcelRequire("dpVLK");

var $iDVTJ = parcelRequire("iDVTJ");

var $kDXGq = parcelRequire("kDXGq");

var $RxYJZ = parcelRequire("RxYJZ");

var $apmZy = parcelRequire("apmZy");

var $hLfbM = parcelRequire("hLfbM");

var $gr4ta = parcelRequire("gr4ta");

var $49ePZ = parcelRequire("49ePZ");

var $dCkYU = parcelRequire("dCkYU");

var $ajKJ7 = parcelRequire("ajKJ7");

var $5AkR7 = parcelRequire("5AkR7");

var $5LGF4 = parcelRequire("5LGF4");

var $ci4Cn = parcelRequire("ci4Cn");

var $fBy54 = parcelRequire("fBy54");

var $gDEpB = parcelRequire("gDEpB");
function $737efc93158d5e31$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n        color: ",
        ";\n        line-height: 0;\n      "
    ]);
    $737efc93158d5e31$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $737efc93158d5e31$var$IconNames = [
    "adduser",
    "group",
    "longhair",
    "shorthair",
    "usersettings",
    "arrowleft",
    "arrowright",
    "arrowsleftright",
    "checkmarkcircle",
    "cycle",
    "dollarsigncircle",
    "dollarsign",
    "exclamation",
    "infocircle",
    "info",
    "minus",
    "new",
    "no",
    "plus",
    "questionmarkcircle",
    "questionmark",
    "restartcircle",
    "restart",
    "x",
    "attachment",
    "calendardate",
    "calendar",
    "checklists",
    "checkmark",
    "contentshare",
    "diagramnetwork",
    "diagramorgchart",
    "diagramvenn",
    "email",
    "filter",
    "folder",
    "graphbar",
    "graphline",
    "graphpie",
    "hive",
    "link",
    "list",
    "mappin",
    "map",
    "maximize",
    "message",
    "news",
    "orgchart",
    "pagemultiple",
    "pagerefresh",
    "pagetree",
    "page",
    "process",
    "rss",
    "smileyface",
    "translate",
    "zipfile",
    "zoomin",
    "zoomout",
    "computer",
    "laptop",
    "smartphone",
    "twofactorauth",
    "watch",
    "badge",
    "ball",
    "balloon",
    "beer",
    "binoculars",
    "bold",
    "bomb",
    "book",
    "bookmark",
    "box",
    "briefcase",
    "building",
    "campfire",
    "clock",
    "coffeemug",
    "cogwheel",
    "compass",
    "creditcard",
    "direction",
    "directory",
    "dumbbell",
    "eye",
    "flag",
    "gravestone",
    "headset",
    "heart",
    "heartrate",
    "home",
    "hourglass",
    "id",
    "image",
    "key",
    "keyhole",
    "lamp",
    "leaf",
    "lego",
    "lifebouy",
    "lightbulb",
    "localization",
    "locationpin",
    "lock",
    "lockpassword",
    "magicwand",
    "magnifyingglass",
    "mailbox",
    "medic",
    "megaphone",
    "oneup",
    "paperplane",
    "partypopper",
    "pencil",
    "pencilwriting",
    "pendantlamp",
    "pin",
    "puzzlepiece",
    "radar",
    "radardashboard",
    "rocket",
    "securitycheckmark",
    "securitygear",
    "shoppingbag",
    "shoppingcart",
    "skull",
    "speedometer",
    "spinner",
    "star",
    "stickers",
    "stopwatch",
    "tag",
    "thumbsup",
    "trafficcone",
    "trafficlight",
    "trash",
    "trophy",
    "upgradetopaid",
    "vault",
    "video",
    "wrench",
    "agile",
    "android",
    "browserarrowright",
    "browsercode",
    "browserterminal",
    "browserwindow",
    "bug",
    "butlerautomation",
    "cloud",
    "cloudcheckmark",
    "clouddownload",
    "cloudencryption",
    "cloudserver",
    "cloudsettings",
    "cloudupload",
    "clouds",
    "cursorarrow",
    "cursorhand",
    "datacenter",
    "database",
    "firewall",
    "gitbranch",
    "gitmerge",
    "globenetwork",
    "globenetworklocation",
    "kanbanmove",
    "server",
    "settings",
    "trelloboards",
    "trellocard",
    "trellocardfullcover",
    "trellocardregularcover",
    "trellocardrepeating",
    "trellocardtemplates",
    "trellocardtextfield",
    "trellochecklists",
    "trellolabels",
    "trellolistshorizontal",
    "trellolistsvertical",
    "trelloworkspaces",
    "vector",
    "webhook",
    "wifi"
];
var $737efc93158d5e31$var$getIconSize = function(size) {
    switch(size){
        case "xs":
            return "24px";
        case "small":
            return "32px";
        case "medium":
            return "48px";
        case "large":
            return "64px";
        default:
            return "48px";
    }
};
var $737efc93158d5e31$export$aa4d92373c6fc66f = function(name, size) {
    var iconSize = $737efc93158d5e31$var$getIconSize(size);
    switch(name.toLowerCase()){
        // avatar
        case "adduser":
            return (0, $1rY3h.jsx)((0, $1sdSq.AddUser), {
                size: iconSize
            });
        case "group":
            return (0, $1rY3h.jsx)((0, $4WayF.Group), {
                size: iconSize
            });
        case "longhair":
            return (0, $1rY3h.jsx)((0, $4GLK6.LongHair), {
                size: iconSize
            });
        case "shorthair":
            return (0, $1rY3h.jsx)((0, $l4PIC.ShortHair), {
                size: iconSize
            });
        case "usersettings":
            return (0, $1rY3h.jsx)((0, $5jeiR.UserSettings), {
                size: iconSize
            });
        // basic
        case "arrowleft":
            return (0, $1rY3h.jsx)((0, $9x9Gr.ArrowLeft), {
                size: iconSize
            });
        case "arrowright":
            return (0, $1rY3h.jsx)((0, $bqlHL.ArrowRight), {
                size: iconSize
            });
        case "arrowsleftright":
            return (0, $1rY3h.jsx)((0, $2cJvN.ArrowsLeftRight), {
                size: iconSize
            });
        case "checkmarkcircle":
            return (0, $1rY3h.jsx)((0, $99M7w.CheckmarkCircle), {
                size: iconSize
            });
        case "cycle":
            return (0, $1rY3h.jsx)((0, $bXno7.Cycle), {
                size: iconSize
            });
        case "dollarsigncircle":
            return (0, $1rY3h.jsx)((0, $1sKJ3.DollarSignCircle), {
                size: iconSize
            });
        case "dollarsign":
            return (0, $1rY3h.jsx)((0, $igz15.DollarSign), {
                size: iconSize
            });
        case "exclamation":
            return (0, $1rY3h.jsx)((0, $eK5GP.Exclamation), {
                size: iconSize
            });
        case "infocircle":
            return (0, $1rY3h.jsx)((0, $5imT3.InfoCircle), {
                size: iconSize
            });
        case "info":
            return (0, $1rY3h.jsx)((0, $3L83V.Info), {
                size: iconSize
            });
        case "minus":
            return (0, $1rY3h.jsx)((0, $ecGKx.Minus), {
                size: iconSize
            });
        case "new":
            return (0, $1rY3h.jsx)((0, $gUdRh.New), {
                size: iconSize
            });
        case "no":
            return (0, $1rY3h.jsx)((0, $72VhV.No), {
                size: iconSize
            });
        case "plus":
            return (0, $1rY3h.jsx)((0, $80smX.Plus), {
                size: iconSize
            });
        case "questionmarkcircle":
            return (0, $1rY3h.jsx)((0, $dqXGo.QuestionMarkCircle), {
                size: iconSize
            });
        case "questionmark":
            return (0, $1rY3h.jsx)((0, $1kG8v.QuestionMark), {
                size: iconSize
            });
        case "restartcircle":
            return (0, $1rY3h.jsx)((0, $6RjL7.RestartCircle), {
                size: iconSize
            });
        case "restart":
            return (0, $1rY3h.jsx)((0, $lxqDS.Restart), {
                size: iconSize
            });
        case "x":
            return (0, $1rY3h.jsx)((0, $c6hAX.X), {
                size: iconSize
            });
        // content
        case "attachment":
            return (0, $1rY3h.jsx)((0, $dYiSZ.Attachment), {
                size: iconSize
            });
        case "calendardate":
            return (0, $1rY3h.jsx)((0, $kzZQ5.CalendarDate), {
                size: iconSize
            });
        case "calendar":
            return (0, $1rY3h.jsx)((0, $lHyqP.Calendar), {
                size: iconSize
            });
        case "checklists":
            return (0, $1rY3h.jsx)((0, $hZw5k.Checklists), {
                size: iconSize
            });
        case "checkmark":
            return (0, $1rY3h.jsx)((0, $fSROr.Checkmark), {
                size: iconSize
            });
        case "contentshare":
            return (0, $1rY3h.jsx)((0, $5q1H2.ContentShare), {
                size: iconSize
            });
        case "diagramnetwork":
            return (0, $1rY3h.jsx)((0, $fYyLp.DiagramNetwork), {
                size: iconSize
            });
        case "diagramorgchart":
            return (0, $1rY3h.jsx)((0, $2iaWw.DiagramOrgChart), {
                size: iconSize
            });
        case "diagramvenn":
            return (0, $1rY3h.jsx)((0, $jhpRG.DiagramVenn), {
                size: iconSize
            });
        case "email":
            return (0, $1rY3h.jsx)((0, $79uDZ.Email), {
                size: iconSize
            });
        case "filter":
            return (0, $1rY3h.jsx)((0, $Kjn7K.Filter), {
                size: iconSize
            });
        case "folder":
            return (0, $1rY3h.jsx)((0, $84UrG.Folder), {
                size: iconSize
            });
        case "graphbar":
            return (0, $1rY3h.jsx)((0, $c3xu1.GraphBar), {
                size: iconSize
            });
        case "graphline":
            return (0, $1rY3h.jsx)((0, $hnqHH.GraphLine), {
                size: iconSize
            });
        case "graphpie":
            return (0, $1rY3h.jsx)((0, $6dHHN.GraphPie), {
                size: iconSize
            });
        case "hive":
            return (0, $1rY3h.jsx)((0, $hEfAB.Hive), {
                size: iconSize
            });
        case "link":
            return (0, $1rY3h.jsx)((0, $cJdRZ.Link), {
                size: iconSize
            });
        case "list":
            return (0, $1rY3h.jsx)((0, $kgLUC.List), {
                size: iconSize
            });
        case "mappin":
            return (0, $1rY3h.jsx)((0, $dSNCm.MapPin), {
                size: iconSize
            });
        case "map":
            return (0, $1rY3h.jsx)((0, $j2AWN.Map), {
                size: iconSize
            });
        case "maximize":
            return (0, $1rY3h.jsx)((0, $iYhKo.Maximize), {
                size: iconSize
            });
        case "message":
            return (0, $1rY3h.jsx)((0, $1ZVrE.Message), {
                size: iconSize
            });
        case "news":
            return (0, $1rY3h.jsx)((0, $5AkR7.News), {
                size: iconSize
            });
        case "orgchart":
            return (0, $1rY3h.jsx)((0, $89NJj.OrgChart), {
                size: iconSize
            });
        case "pagemultiple":
            return (0, $1rY3h.jsx)((0, $cVIPN.PageMultiple), {
                size: iconSize
            });
        case "pagerefresh":
            return (0, $1rY3h.jsx)((0, $cruFA.PageRefresh), {
                size: iconSize
            });
        case "pagetree":
            return (0, $1rY3h.jsx)((0, $gjryf.PageTree), {
                size: iconSize
            });
        case "page":
            return (0, $1rY3h.jsx)((0, $4lWxZ.Page), {
                size: iconSize
            });
        case "process":
            return (0, $1rY3h.jsx)((0, $7WpHj.Process), {
                size: iconSize
            });
        case "rss":
            return (0, $1rY3h.jsx)((0, $2ho8t.Rss), {
                size: iconSize
            });
        case "smileyface":
            return (0, $1rY3h.jsx)((0, $fgpyD.SmileyFace), {
                size: iconSize
            });
        case "translate":
            return (0, $1rY3h.jsx)((0, $iY3Qo.Translate), {
                size: iconSize
            });
        case "zipfile":
            return (0, $1rY3h.jsx)((0, $60CU0.ZipFile), {
                size: iconSize
            });
        case "zoomin":
            return (0, $1rY3h.jsx)((0, $9GPbT.ZoomIn), {
                size: iconSize
            });
        case "zoomout":
            return (0, $1rY3h.jsx)((0, $c9Bb7.ZoomOut), {
                size: iconSize
            });
        // device
        case "computer":
            return (0, $1rY3h.jsx)((0, $1Q6qD.Computer), {
                size: iconSize
            });
        case "laptop":
            return (0, $1rY3h.jsx)((0, $5lVc4.Laptop), {
                size: iconSize
            });
        case "smartphone":
            return (0, $1rY3h.jsx)((0, $5d2m8.Smartphone), {
                size: iconSize
            });
        case "twofactorauth":
            return (0, $1rY3h.jsx)((0, $6zTaB.TwoFactorAuth), {
                size: iconSize
            });
        case "watch":
            return (0, $1rY3h.jsx)((0, $d7YRX.Watch), {
                size: iconSize
            });
        // object
        case "badge":
            return (0, $1rY3h.jsx)((0, $2d8PF.Badge), {
                size: iconSize
            });
        case "ball":
            return (0, $1rY3h.jsx)((0, $2caah.Ball), {
                size: iconSize
            });
        case "balloon":
            return (0, $1rY3h.jsx)((0, $iZWiv.Balloon), {
                size: iconSize
            });
        case "beer":
            return (0, $1rY3h.jsx)((0, $jsl99.Beer), {
                size: iconSize
            });
        case "binoculars":
            return (0, $1rY3h.jsx)((0, $bLc9o.Binoculars), {
                size: iconSize
            });
        case "bold":
            return (0, $1rY3h.jsx)((0, $23dQH.Bold), {
                size: iconSize
            });
        case "bomb":
            return (0, $1rY3h.jsx)((0, $cWo99.Bomb), {
                size: iconSize
            });
        case "book":
            return (0, $1rY3h.jsx)((0, $e8Wg9.Book), {
                size: iconSize
            });
        case "bookmark":
            return (0, $1rY3h.jsx)((0, $3XnA3.Bookmark), {
                size: iconSize
            });
        case "box":
            return (0, $1rY3h.jsx)((0, $83JNv.Box), {
                size: iconSize
            });
        case "briefcase":
            return (0, $1rY3h.jsx)((0, $4T9wY.Briefcase), {
                size: iconSize
            });
        case "building":
            return (0, $1rY3h.jsx)((0, $89ffd.Building), {
                size: iconSize
            });
        case "campfire":
            return (0, $1rY3h.jsx)((0, $buEWq.Campfire), {
                size: iconSize
            });
        case "clock":
            return (0, $1rY3h.jsx)((0, $3iGkz.Clock), {
                size: iconSize
            });
        case "coffeemug":
            return (0, $1rY3h.jsx)((0, $4kgJO.CoffeeMug), {
                size: iconSize
            });
        case "cogwheel":
            return (0, $1rY3h.jsx)((0, $4kgJO.CoffeeMug), {
                size: iconSize
            });
        case "compass":
            return (0, $1rY3h.jsx)((0, $kssg0.Compass), {
                size: iconSize
            });
        case "creditcard":
            return (0, $1rY3h.jsx)((0, $5JKJp.CreditCard), {
                size: iconSize
            });
        case "direction":
            return (0, $1rY3h.jsx)((0, $y6HFH.Direction), {
                size: iconSize
            });
        case "directory":
            return (0, $1rY3h.jsx)((0, $7uSpA.Directory), {
                size: iconSize
            });
        case "dumbbell":
            return (0, $1rY3h.jsx)((0, $8sU4a.Dumbbell), {
                size: iconSize
            });
        case "eye":
            return (0, $1rY3h.jsx)((0, $fWfPz.Eye), {
                size: iconSize
            });
        case "flag":
            return (0, $1rY3h.jsx)((0, $4a6nf.Flag), {
                size: iconSize
            });
        case "gravestone":
            return (0, $1rY3h.jsx)((0, $fv9M2.Gravestone), {
                size: iconSize
            });
        case "headset":
            return (0, $1rY3h.jsx)((0, $cZBJi.Headset), {
                size: iconSize
            });
        case "heart":
            return (0, $1rY3h.jsx)((0, $fPdFb.Heart), {
                size: iconSize
            });
        case "heartrate":
            return (0, $1rY3h.jsx)((0, $7OC0z.HeartRate), {
                size: iconSize
            });
        case "home":
            return (0, $1rY3h.jsx)((0, $4IVy6.Home), {
                size: iconSize
            });
        case "hourglass":
            return (0, $1rY3h.jsx)((0, $9fn0O.HourGlass), {
                size: iconSize
            });
        case "id":
            return (0, $1rY3h.jsx)((0, $2eLrk.Id), {
                size: iconSize
            });
        case "image":
            return (0, $1rY3h.jsx)((0, $IDulL.Image), {
                size: iconSize
            });
        case "key":
            return (0, $1rY3h.jsx)((0, $hWtcH.Key), {
                size: iconSize
            });
        case "keyhole":
            return (0, $1rY3h.jsx)((0, $flNq6.Keyhole), {
                size: iconSize
            });
        case "lamp":
            return (0, $1rY3h.jsx)((0, $g1GYo.Lamp), {
                size: iconSize
            });
        case "leaf":
            return (0, $1rY3h.jsx)((0, $eDZ7Y.Leaf), {
                size: iconSize
            });
        case "lego":
            return (0, $1rY3h.jsx)((0, $2GfFa.Lego), {
                size: iconSize
            });
        case "lifebouy":
            return (0, $1rY3h.jsx)((0, $iVuUd.Lifebouy), {
                size: iconSize
            });
        case "lightbulb":
            return (0, $1rY3h.jsx)((0, $5LGF4.Lightbulb), {
                size: iconSize
            });
        case "localization":
            return (0, $1rY3h.jsx)((0, $bO06j.Localization), {
                size: iconSize
            });
        case "locationpin":
            return (0, $1rY3h.jsx)((0, $fJxZA.LocationPin), {
                size: iconSize
            });
        case "lock":
            return (0, $1rY3h.jsx)((0, $cSNv3.Lock), {
                size: iconSize
            });
        case "lockpassword":
            return (0, $1rY3h.jsx)((0, $2HPqn.LockPassword), {
                size: iconSize
            });
        case "magicwand":
            return (0, $1rY3h.jsx)((0, $c3DOg.MagicWand), {
                size: iconSize
            });
        case "magnifyingglass":
            return (0, $1rY3h.jsx)((0, $axYxr.MagnifyingGlass), {
                size: iconSize
            });
        case "mailbox":
            return (0, $1rY3h.jsx)((0, $9hy0Y.Mailbox), {
                size: iconSize
            });
        case "medic":
            return (0, $1rY3h.jsx)((0, $8EIOd.Medic), {
                size: iconSize
            });
        case "megaphone":
            return (0, $1rY3h.jsx)((0, $akmn5.Megaphone), {
                size: iconSize
            });
        case "oneup":
            return (0, $1rY3h.jsx)((0, $2fx8N.OneUp), {
                size: iconSize
            });
        case "paperplane":
            return (0, $1rY3h.jsx)((0, $5DZ5M.PaperPlane), {
                size: iconSize
            });
        case "partypopper":
            return (0, $1rY3h.jsx)((0, $32N3Z.PartyPopper), {
                size: iconSize
            });
        case "pencil":
            return (0, $1rY3h.jsx)((0, $y11yg.Pencil), {
                size: iconSize
            });
        case "pencilwriting":
            return (0, $1rY3h.jsx)((0, $dC1ZG.PencilWriting), {
                size: iconSize
            });
        case "pendantlamp":
            return (0, $1rY3h.jsx)((0, $aBxBD.PendantLamp), {
                size: iconSize
            });
        case "pin":
            return (0, $1rY3h.jsx)((0, $iyCw2.Pin), {
                size: iconSize
            });
        case "puzzlepiece":
            return (0, $1rY3h.jsx)((0, $kLpeD.PuzzlePiece), {
                size: iconSize
            });
        case "radar":
            return (0, $1rY3h.jsx)((0, $fChtk.Radar), {
                size: iconSize
            });
        case "radardashboard":
            return (0, $1rY3h.jsx)((0, $bPPvN.RadarDashboard), {
                size: iconSize
            });
        case "rocket":
            return (0, $1rY3h.jsx)((0, $5Q6bk.Rocket), {
                size: iconSize
            });
        case "securitycheckmark":
            return (0, $1rY3h.jsx)((0, $3arRy.SecurityCheckmark), {
                size: iconSize
            });
        case "securitygear":
            return (0, $1rY3h.jsx)((0, $j2pub.SecurityGear), {
                size: iconSize
            });
        case "shoppingbag":
            return (0, $1rY3h.jsx)((0, $2y5Fy.ShoppingBag), {
                size: iconSize
            });
        case "shoppingcart":
            return (0, $1rY3h.jsx)((0, $2Uzy1.ShoppingCart), {
                size: iconSize
            });
        case "skull":
            return (0, $1rY3h.jsx)((0, $fB9Me.Skull), {
                size: iconSize
            });
        case "speedometer":
            return (0, $1rY3h.jsx)((0, $h7iOA.Speedometer), {
                size: iconSize
            });
        case "spinner":
            return (0, $1rY3h.jsx)((0, $gd415.Spinner), {
                size: iconSize
            });
        case "star":
            return (0, $1rY3h.jsx)((0, $2weR5.Star), {
                size: iconSize
            });
        case "stickers":
            return (0, $1rY3h.jsx)((0, $gtRWF.Stickers), {
                size: iconSize
            });
        case "stopwatch":
            return (0, $1rY3h.jsx)((0, $kET9Z.Stopwatch), {
                size: iconSize
            });
        case "tag":
            return (0, $1rY3h.jsx)((0, $jaE3v.Tag), {
                size: iconSize
            });
        case "thumbsup":
            return (0, $1rY3h.jsx)((0, $gRPoa.ThumbsUp), {
                size: iconSize
            });
        case "trafficcone":
            return (0, $1rY3h.jsx)((0, $hP3aT.TrafficCone), {
                size: iconSize
            });
        case "trafficlight":
            return (0, $1rY3h.jsx)((0, $5Xzri.TrafficLight), {
                size: iconSize
            });
        case "trash":
            return (0, $1rY3h.jsx)((0, $bciKd.Trash), {
                size: iconSize
            });
        case "trophy":
            return (0, $1rY3h.jsx)((0, $2VED3.Trophy), {
                size: iconSize
            });
        case "upgradetopaid":
            return (0, $1rY3h.jsx)((0, $d1F1T.UpgradeToPaid), {
                size: iconSize
            });
        case "vault":
            return (0, $1rY3h.jsx)((0, $apOGQ.Vault), {
                size: iconSize
            });
        case "video":
            return (0, $1rY3h.jsx)((0, $huMrE.Video), {
                size: iconSize
            });
        case "wrench":
            return (0, $1rY3h.jsx)((0, $dCkYU.Wrench), {
                size: iconSize
            });
        // software
        case "agile":
            return (0, $1rY3h.jsx)((0, $8jk5f.Agile), {
                size: iconSize
            });
        case "android":
            return (0, $1rY3h.jsx)((0, $ixEjJ.Android), {
                size: iconSize
            });
        case "browserarrowright":
            return (0, $1rY3h.jsx)((0, $koSWo.BrowserArrowRight), {
                size: iconSize
            });
        case "browsercode":
            return (0, $1rY3h.jsx)((0, $g5Woz.BrowserCode), {
                size: iconSize
            });
        case "browserterminal":
            return (0, $1rY3h.jsx)((0, $lIQ9r.BrowserTerminal), {
                size: iconSize
            });
        case "browserwindow":
            return (0, $1rY3h.jsx)((0, $bUhTm.BrowserWindow), {
                size: iconSize
            });
        case "bug":
            return (0, $1rY3h.jsx)((0, $9qiqk.Bug), {
                size: iconSize
            });
        case "butlerautomation":
            return (0, $1rY3h.jsx)((0, $9V6dX.ButlerAutomation), {
                size: iconSize
            });
        case "cloud":
            return (0, $1rY3h.jsx)((0, $2FCbO.Cloud), {
                size: iconSize
            });
        case "cloudcheckmark":
            return (0, $1rY3h.jsx)((0, $k8naB.CloudCheckmark), {
                size: iconSize
            });
        case "clouddownload":
            return (0, $1rY3h.jsx)((0, $8Eq85.CloudDownload), {
                size: iconSize
            });
        case "cloudencryption":
            return (0, $1rY3h.jsx)((0, $6BHX5.CloudEncryption), {
                size: iconSize
            });
        case "cloudserver":
            return (0, $1rY3h.jsx)((0, $nGhoH.CloudServer), {
                size: iconSize
            });
        case "cloudsettings":
            return (0, $1rY3h.jsx)((0, $84pwJ.CloudSettings), {
                size: iconSize
            });
        case "cloudupload":
            return (0, $1rY3h.jsx)((0, $ci4Cn.CloudUpload), {
                size: iconSize
            });
        case "clouds":
            return (0, $1rY3h.jsx)((0, $100Ph.Clouds), {
                size: iconSize
            });
        case "cursorarrow":
            return (0, $1rY3h.jsx)((0, $61z2V.CursorArrow), {
                size: iconSize
            });
        case "cursorhand":
            return (0, $1rY3h.jsx)((0, $kQkE3.CursorHand), {
                size: iconSize
            });
        case "datacenter":
            return (0, $1rY3h.jsx)((0, $3aYSv.DataCenter), {
                size: iconSize
            });
        case "database":
            return (0, $1rY3h.jsx)((0, $PqOMb.Database), {
                size: iconSize
            });
        case "firewall":
            return (0, $1rY3h.jsx)((0, $4tQtC.Firewall), {
                size: iconSize
            });
        case "gitbranch":
            return (0, $1rY3h.jsx)((0, $6OhQm.GitBranch), {
                size: iconSize
            });
        case "gitmerge":
            return (0, $1rY3h.jsx)((0, $ajKJ7.GitMerge), {
                size: iconSize
            });
        case "globenetwork":
            return (0, $1rY3h.jsx)((0, $6iGyx.GlobeNetwork), {
                size: iconSize
            });
        case "globenetworklocation":
            return (0, $1rY3h.jsx)((0, $9DfNj.GlobeNetworkLocation), {
                size: iconSize
            });
        case "kanbanmove":
            return (0, $1rY3h.jsx)((0, $fiuCn.KanbanMove), {
                size: iconSize
            });
        case "server":
            return (0, $1rY3h.jsx)((0, $3VSq5.Server), {
                size: iconSize
            });
        case "settings":
            return (0, $1rY3h.jsx)((0, $g2Au7.Settings), {
                size: iconSize
            });
        case "trelloboards":
            return (0, $1rY3h.jsx)((0, $88Rcr.TrelloBoards), {
                size: iconSize
            });
        case "trellocard":
            return (0, $1rY3h.jsx)((0, $22xfN.TrelloCard), {
                size: iconSize
            });
        case "trellocardfullcover":
            return (0, $1rY3h.jsx)((0, $brafE.TrelloCardFullCover), {
                size: iconSize
            });
        case "trellocardregularcover":
            return (0, $1rY3h.jsx)((0, $6grkJ.TrelloCardRegularCover), {
                size: iconSize
            });
        case "trellocardrepeating":
            return (0, $1rY3h.jsx)((0, $exsmi.TrelloCardRepeating), {
                size: iconSize
            });
        case "trellocardtemplates":
            return (0, $1rY3h.jsx)((0, $fGdwN.TrelloCardTemplates), {
                size: iconSize
            });
        case "trellocardtextfield":
            return (0, $1rY3h.jsx)((0, $5Ic6A.TrelloCardTextField), {
                size: iconSize
            });
        case "trellochecklists":
            return (0, $1rY3h.jsx)((0, $dpVLK.TrelloChecklists), {
                size: iconSize
            });
        case "trellolabels":
            return (0, $1rY3h.jsx)((0, $iDVTJ.TrelloLabels), {
                size: iconSize
            });
        case "trellolistshorizontal":
            return (0, $1rY3h.jsx)((0, $kDXGq.TrelloListsHorizontal), {
                size: iconSize
            });
        case "trellolistsvertical":
            return (0, $1rY3h.jsx)((0, $RxYJZ.TrelloListsVertical), {
                size: iconSize
            });
        case "trelloworkspaces":
            return (0, $1rY3h.jsx)((0, $apmZy.TrelloWorkspaces), {
                size: iconSize
            });
        case "vector":
            return (0, $1rY3h.jsx)((0, $hLfbM.Vector), {
                size: iconSize
            });
        case "webhook":
            return (0, $1rY3h.jsx)((0, $gr4ta.Webhook), {
                size: iconSize
            });
        case "wifi":
            return (0, $1rY3h.jsx)((0, $49ePZ.Wifi), {
                size: iconSize
            });
        default:
            return null;
    }
};
var $737efc93158d5e31$export$f04a61298a47a40f = function(param) {
    var name = param.name, size = param.size, color = param.color;
    var iconColor = color ? (0, $gDEpB.getColor)(color) : (0, $gDEpB.getColor)("n900");
    return (0, $1rY3h.jsx)("div", {
        className: "icon",
        css: (0, $fBy54.css)($737efc93158d5e31$var$_templateObject(), iconColor),
        children: $737efc93158d5e31$export$aa4d92373c6fc66f(name, size)
    });
};

});
parcelRegister("1sdSq", function(module, exports) {

$parcel$export(module.exports, "AddUser", function () { return $10f32b9cc0bc1045$export$a2fae8d9b81b1013; });

var $1rY3h = parcelRequire("1rY3h");
var $10f32b9cc0bc1045$export$a2fae8d9b81b1013 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-avatar-add user",
        width: size,
        height: size,
        viewBox: "0 0 65 64",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M32.0518,0 C14.3786,0 0.0518,14.3269 0.0518,32 C0.0518,42.7687 5.371,52.295 13.5254,58.0948 L13.5254,55.9989 C13.5254,47.9763 20.0291,41.4726 28.0517,41.4726 L36.0517,41.4726 C39.9589,41.4726 43.5058,43.0152 46.1166,45.5246 C48.0215,43.7503 50.5765,42.6649 53.385,42.6649 C56.3337,42.6649 59.0029,43.8614 60.9337,45.7953 C62.9325,41.6181 64.0517,36.9398 64.0517,32 C64.0517,14.3269 49.7249,0 32.0518,0 Z M32.0518,16.7006 C26.1608,16.7006 21.3852,21.4762 21.3852,27.3673 C21.3852,33.2583 26.1608,38.0339 32.0518,38.0339 C37.9429,38.0339 42.7185,33.2583 42.7185,27.3673 C42.7185,21.4762 37.9429,16.7006 32.0518,16.7006 Z"
                    }),
                    (0, $1rY3h.jsx)("g", {
                        transform: "translate(42.000000, 42.000000)",
                        opacity: "0.5",
                        children: (0, $1rY3h.jsx)("path", {
                            d: "M11.3854,21.9974 C17.2765,21.9974 22.0521,17.2218 22.0521,11.3307 C22.0521,5.4397 17.2765,0.6641 11.3854,0.6641 C5.4944,0.6641 0.7188,5.4397 0.7188,11.3307 C0.7188,17.2218 5.4944,21.9974 11.3854,21.9974 Z M13.3506,16.2717 C13.3506,17.2018 12.5966,17.9559 11.6664,17.9559 C10.7695,17.9559 10.0363,17.2547 9.9851,16.3706 L9.9822,16.2717 L9.9822,12.9029 L6.6137,12.9029 C5.6836,12.9029 4.9295,12.1489 4.9295,11.2187 C4.9295,10.3218 5.6307,9.5886 6.5148,9.5374 L6.6137,9.5345 L9.9822,9.5345 L9.9822,6.1664 C9.9822,5.2362 10.7363,4.4822 11.6664,4.4822 C12.5634,4.4822 13.2965,5.1833 13.3478,6.0674 L13.3506,6.1664 L13.3506,9.5345 L16.719,9.5345 C17.6492,9.5345 18.4032,10.2886 18.4032,11.2187 C18.4032,12.1157 17.7021,12.8489 16.818,12.9001 L16.719,12.9029 L13.3506,12.9029 L13.3506,16.2717 Z"
                        })
                    })
                ]
            })
        })
    });
};

});

parcelRegister("4WayF", function(module, exports) {

$parcel$export(module.exports, "Group", function () { return $3984c4d0dba4fac2$export$eb2fcfdbd7ba97d4; });

var $1rY3h = parcelRequire("1rY3h");
var $3984c4d0dba4fac2$export$eb2fcfdbd7ba97d4 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-avatar-group",
        width: size,
        height: size,
        viewBox: "0 0 98 61",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsxs)("g", {
                        transform: "translate(0.000000, 6.000000)",
                        opacity: "0.5",
                        children: [
                            (0, $1rY3h.jsx)("path", {
                                d: "M36.2185,54.477 L2.6501,54.477 C1.1865,54.477 0,53.29 0,51.826 L0,41.741 C0,33.325 6.8224,26.503 15.2383,26.503 L23.6304,26.503 C32.0463,26.503 38.8687,33.325 38.8687,41.741 L38.8687,51.826 C38.8687,53.29 37.6822,54.477 36.2185,54.477 Z",
                                fillRule: "nonzero"
                            }),
                            (0, $1rY3h.jsx)("path", {
                                d: "M8.2451,11.854 C8.2451,5.674 13.2548,0.664 19.4346,0.664 C25.6144,0.664 30.6241,5.674 30.6241,11.854 C30.6241,18.033 25.6144,23.043 19.4346,23.043 C13.2548,23.043 8.2451,18.033 8.2451,11.854 Z"
                            })
                        ]
                    }),
                    (0, $1rY3h.jsxs)("g", {
                        transform: "translate(58.000000, 6.000000)",
                        opacity: "0.5",
                        children: [
                            (0, $1rY3h.jsx)("path", {
                                d: "M37.11,54.477 L3.5417,54.477 C2.0781,54.477 0.8916,53.29 0.8916,51.826 L0.8916,41.741 C0.8916,33.325 7.714,26.503 16.1299,26.503 L24.522,26.503 C32.938,26.503 39.76,33.325 39.76,41.741 L39.76,51.826 C39.76,53.29 38.574,54.477 37.11,54.477 Z",
                                fillRule: "nonzero"
                            }),
                            (0, $1rY3h.jsx)("path", {
                                d: "M9.1367,11.854 C9.1367,5.674 14.1464,0.664 20.3262,0.664 C26.506,0.664 31.516,5.674 31.516,11.854 C31.516,18.033 26.506,23.043 20.3262,23.043 C14.1464,23.043 9.1367,18.033 9.1367,11.854 Z"
                            })
                        ]
                    }),
                    (0, $1rY3h.jsxs)("g", {
                        transform: "translate(29.000000, 0.000000)",
                        children: [
                            (0, $1rY3h.jsxs)("g", {
                                children: [
                                    (0, $1rY3h.jsx)("path", {
                                        d: "M7.9551,5.777 C7.9551,2.85 10.3281,0.477 13.2554,0.477 C16.1826,0.477 18.5556,2.85 18.5556,5.777 C18.5556,6.11 18.525,6.435 18.4663,6.751 C18.9294,6.692 19.4015,6.661 19.8807,6.661 C25.9791,6.661 30.9229,11.605 30.9229,17.703 C30.9229,23.802 25.9791,28.746 19.8807,28.746 C13.7822,28.746 8.8384,23.802 8.8384,17.703 C8.8384,15.053 9.7726,12.62 11.3296,10.716 C9.3545,9.946 7.9551,8.025 7.9551,5.777 Z",
                                        opacity: "0.5"
                                    }),
                                    (0, $1rY3h.jsx)("path", {
                                        d: "M36.6648,60.473 L3.0964,60.473 C1.6328,60.473 0.4463,59.286 0.4463,57.823 L0.4463,47.737 C0.4463,39.321 7.2687,32.499 15.6846,32.499 L24.0767,32.499 C32.4926,32.499 39.315,39.321 39.315,47.737 L39.315,57.823 C39.315,59.286 38.1285,60.473 36.6648,60.473 Z",
                                        fillRule: "nonzero"
                                    })
                                ]
                            }),
                            (0, $1rY3h.jsx)("path", {
                                d: "M8.8398,17.851 C8.9177,23.883 13.8312,28.748 19.8811,28.748 C25.9311,28.748 30.8446,23.883 30.9225,17.851 L28.4218,17.851 C27.8648,17.851 27.3404,17.589 27.0062,17.144 L24.4754,13.769 C24.2395,13.455 23.7676,13.455 23.5317,13.769 L21.0009,17.144 C20.6667,17.589 20.1422,17.851 19.5853,17.851 L8.8398,17.851 Z"
                            })
                        ]
                    })
                ]
            })
        })
    });
};

});

parcelRegister("4GLK6", function(module, exports) {

$parcel$export(module.exports, "LongHair", function () { return $36a01e5fc3df2572$export$c8fa71fb10453bb; });

var $1rY3h = parcelRequire("1rY3h");
var $36a01e5fc3df2572$export$c8fa71fb10453bb = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-avatar-long hair",
        width: size,
        height: size,
        viewBox: "0 0 65 59",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M21.9824,27.925 C22.0571,33.752 26.8037,38.452 32.6482,38.452 C38.4927,38.452 43.2393,33.752 43.314,27.925 L40.8203,27.925 C40.2702,27.925 39.7523,27.666 39.4223,27.226 L37.0441,24.055 C36.8111,23.745 36.3451,23.745 36.1121,24.055 L33.7339,27.226 C33.4039,27.666 32.886,27.925 32.336,27.925 L21.9824,27.925 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M32.6484,0.416 C14.9753,0.416 0.6484,14.743 0.6484,32.416 C0.6484,43.185 5.9677,52.711 14.1222,58.511 L14.1222,56.417 C14.1222,48.394 20.6258,41.89 28.6485,41.89 L36.6485,41.89 C44.6711,41.89 51.1748,48.394 51.1748,56.417 L51.1748,58.511 C59.3292,52.711 64.6484,43.185 64.6484,32.416 C64.6484,14.743 50.3215,0.416 32.6484,0.416 Z M24.3598,21.07 C22.8728,22.903 21.9818,25.239 21.9818,27.784 C21.9818,33.675 26.7574,38.451 32.6485,38.451 C38.5395,38.451 43.3151,33.675 43.3151,27.784 C43.3151,21.893 38.5395,17.117 32.6485,17.117 C32.2004,17.117 31.7588,17.145 31.3252,17.199 C31.3648,16.944 31.3853,16.683 31.3853,16.417 C31.3853,13.626 29.1232,11.364 26.3327,11.364 C23.5422,11.364 21.2801,13.626 21.2801,16.417 C21.2801,18.507 22.5496,20.301 24.3598,21.07 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("l4PIC", function(module, exports) {

$parcel$export(module.exports, "ShortHair", function () { return $f58216f07e93769e$export$b2f897cbac90df99; });

var $1rY3h = parcelRequire("1rY3h");
var $f58216f07e93769e$export$b2f897cbac90df99 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-avatar-short hair",
        width: size,
        height: size,
        viewBox: "0 0 65 59",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("rect", {
                        fillRule: "nonzero",
                        opacity: "0.5",
                        x: "21.9668",
                        y: "17.05",
                        width: "21.3333",
                        height: "21.3333",
                        rx: "10.66665"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M0.6338,32.35 C0.6338,14.68 14.9607,0.35 32.6338,0.35 C50.3069,0.35 64.6338,14.68 64.6338,32.35 C64.6338,43.12 59.3145,52.65 51.16,58.45 L51.16,56.35 C51.16,48.33 44.6563,41.83 36.6337,41.83 L28.6337,41.83 C20.611,41.83 14.1074,48.33 14.1074,56.35 L14.1074,58.45 C5.953,52.65 0.6338,43.12 0.6338,32.35 Z M21.9672,27.72 C21.9672,21.83 26.7428,17.05 32.6338,17.05 C38.5249,17.05 43.3005,21.83 43.3005,27.72 C43.3005,33.61 38.5249,38.39 32.6338,38.39 C26.7428,38.39 21.9672,33.61 21.9672,27.72 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("5jeiR", function(module, exports) {

$parcel$export(module.exports, "UserSettings", function () { return $3dd9d26b5deaaf4c$export$6587c76ebf15601c; });

var $1rY3h = parcelRequire("1rY3h");
var $3dd9d26b5deaaf4c$export$6587c76ebf15601c = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-avatar-usersettings",
        width: size,
        height: size,
        viewBox: "0 0 65 64",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M31.6194,0.25 C14.6532,0.25 0.8994,14 0.8994,30.97 C0.8994,41.3 6.006,50.45 13.8342,56.02 L13.8342,54.01 C13.8342,46.3 20.0777,40.06 27.7795,40.06 L35.4595,40.06 C38.3149,40.06 40.9699,40.92 43.1806,42.39 C43.2389,42.32 43.3021,42.25 43.3702,42.18 C44.2903,41.26 45.7657,41.23 46.7175,42.1 L46.8001,42.18 L47.5105,42.89 C48.2383,42.47 49.0281,42.15 49.8628,41.94 L49.8628,40.91 C49.8628,39.57 50.9486,38.49 52.288,38.49 C53.5892,38.49 54.6511,39.51 54.7107,40.8 L54.7133,40.91 L54.7133,42.01 C55.5127,42.24 56.2682,42.57 56.9641,42.99 L57.7758,42.18 C58.4929,41.46 59.5474,41.29 60.4284,41.66 C61.6642,38.33 62.3394,34.73 62.3394,30.97 C62.3394,14 48.5856,0.25 31.6194,0.25 Z M31.6192,16.28 C25.9638,16.28 21.3792,20.86 21.3792,26.52 C21.3792,32.18 25.9638,36.76 31.6192,36.76 C37.2746,36.76 41.8592,32.18 41.8592,26.52 C41.8592,20.86 37.2746,16.28 31.6192,16.28 Z"
                    }),
                    (0, $1rY3h.jsx)("g", {
                        transform: "translate(39.000000, 38.000000)",
                        opacity: "0.5",
                        children: (0, $1rY3h.jsx)("path", {
                            d: "M15.7108,2.8 C15.6512,1.51 14.5893,0.48 13.2882,0.48 C11.9487,0.48 10.8629,1.57 10.8629,2.91 L10.8629,3.93 C10.0282,4.15 9.2384,4.47 8.5106,4.89 L7.8002,4.18 L7.7176,4.1 C6.7658,3.23 5.2904,3.26 4.3704,4.18 C3.4232,5.13 3.4232,6.66 4.3704,7.61 L5.0807,8.32 C4.6612,9.05 4.3373,9.84 4.1262,10.67 L3.102,10.67 L2.9879,10.67 C1.7014,10.73 0.6768,11.8 0.6768,13.1 C0.6768,14.44 1.7626,15.52 3.102,15.52 L4.1995,15.52 C4.4278,16.32 4.7602,17.08 5.1812,17.77 L4.3706,18.58 L4.2917,18.67 C3.4242,19.62 3.4505,21.09 4.3706,22.01 C5.3177,22.96 6.8533,22.96 7.8004,22.01 L8.6838,21.13 C9.3632,21.5 10.094,21.79 10.8629,21.99 L10.8629,23.28 L10.8656,23.4 C10.9252,24.68 11.987,25.71 13.2882,25.71 C14.6276,25.71 15.7134,24.62 15.7134,23.28 L15.7134,21.91 C16.4482,21.7 17.1458,21.41 17.7941,21.03 L18.7757,22.01 L18.8583,22.09 C19.8101,22.96 21.2855,22.93 22.2055,22.01 C23.1527,21.07 23.1527,19.53 22.2055,18.58 L21.2239,17.6 C21.5974,16.95 21.8951,16.26 22.1049,15.52 L23.4742,15.52 L23.5884,15.52 C24.8748,15.46 25.8995,14.4 25.8995,13.1 C25.8995,11.76 24.8137,10.67 23.4742,10.67 L22.1782,10.67 C21.9838,9.9 21.6937,9.17 21.3212,8.49 L22.2058,7.61 L22.2846,7.52 C23.1521,6.57 23.1258,5.1 22.2058,4.18 C21.2586,3.23 19.723,3.23 18.7759,4.18 L17.9642,4.99 C17.2683,4.57 16.5129,4.24 15.7134,4.01 L15.7134,2.91 L15.7108,2.8 Z M13.1522,8.37 C10.6187,8.37 8.5648,10.43 8.5648,12.96 C8.5648,15.5 10.6187,17.55 13.1522,17.55 C15.6857,17.55 17.7396,15.5 17.7396,12.96 C17.7396,10.43 15.6857,8.37 13.1522,8.37 Z"
                        })
                    })
                ]
            })
        })
    });
};

});

parcelRegister("9x9Gr", function(module, exports) {

$parcel$export(module.exports, "ArrowLeft", function () { return $6f0eb5138c996688$export$e4c291d45fea4cd0; });

var $1rY3h = parcelRequire("1rY3h");
var $6f0eb5138c996688$export$e4c291d45fea4cd0 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-basic-arrow left",
        width: size,
        height: size,
        viewBox: "0 0 65 64",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsx)("g", {
                fill: "currentColor",
                children: (0, $1rY3h.jsx)("path", {
                    d: "M64.96,32 C64.96,14.33 50.64,0 32.96,0 C15.29,0 0.96,14.33 0.96,32 C0.96,49.67 15.29,64 32.96,64 C50.64,64 64.96,49.67 64.96,32 Z M24.63,20.75 C25.63,19.75 27.23,19.75 28.22,20.75 C29.18,21.71 29.21,23.26 28.31,24.27 L28.22,24.36 L23.62,29 L48.43,29 L48.55,29 C49.89,29.06 50.96,30.16 50.96,31.5 C50.96,32.88 49.83,34 48.43,34 L23.52,34 L28.13,38.64 C29.09,39.61 29.12,41.15 28.22,42.16 L28.13,42.25 C27.17,43.22 25.63,43.25 24.63,42.34 L24.54,42.25 L15.71,33.35 C14.75,32.39 14.72,30.84 15.62,29.84 L15.71,29.74 L24.63,20.75 Z"
                })
            })
        })
    });
};

});

parcelRegister("bqlHL", function(module, exports) {

$parcel$export(module.exports, "ArrowRight", function () { return $8512f591f2e2b7da$export$acad20503ad73ac1; });

var $1rY3h = parcelRequire("1rY3h");
var $8512f591f2e2b7da$export$acad20503ad73ac1 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-basic-arrow right",
        width: size,
        height: size,
        viewBox: "0 0 65 64",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsx)("g", {
                fill: "currentColor",
                children: (0, $1rY3h.jsx)("path", {
                    d: "M0.96,32 C0.96,14.33 15.29,0 32.96,0 C50.64,0 64.96,14.33 64.96,32 C64.96,49.67 50.64,64 32.96,64 C15.29,64 0.96,49.67 0.96,32 Z M41.29,20.75 C40.3,19.75 38.7,19.75 37.71,20.75 C36.75,21.71 36.72,23.26 37.62,24.27 L37.71,24.36 L42.31,29 L17.49,29 L17.38,29 C16.03,29.06 14.96,30.16 14.96,31.5 C14.96,32.88 16.1,34 17.49,34 L42.41,34 L37.8,38.64 C36.84,39.61 36.81,41.15 37.71,42.16 L37.8,42.25 C38.76,43.22 40.3,43.25 41.29,42.34 L41.39,42.25 L50.22,33.35 C51.18,32.39 51.21,30.84 50.31,29.84 L50.22,29.74 L41.29,20.75 Z"
                })
            })
        })
    });
};

});

parcelRegister("2cJvN", function(module, exports) {

$parcel$export(module.exports, "ArrowsLeftRight", function () { return $19b00179f2f0fd0b$export$1d3c8d39d0ce31f0; });

var $1rY3h = parcelRequire("1rY3h");
var $19b00179f2f0fd0b$export$1d3c8d39d0ce31f0 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-basic-arrows left right",
        width: size,
        height: size,
        viewBox: "0 0 64 64",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsx)("g", {
                fill: "currentColor",
                children: (0, $1rY3h.jsx)("path", {
                    d: "M0,32 C0,14.33 14.33,0 32,0 C49.67,0 64,14.33 64,32 C64,49.67 49.67,64 32,64 C14.33,64 0,49.67 0,32 Z M39.96,13.93 C38.98,12.95 37.38,12.95 36.39,13.93 C35.43,14.89 35.4,16.42 36.3,17.41 L36.39,17.51 L38.25,19.37 L21.89,19.37 L21.78,19.37 C20.44,19.43 19.37,20.54 19.37,21.89 C19.37,23.29 20.5,24.42 21.89,24.42 L38.25,24.42 L36.39,26.28 C35.43,27.24 35.4,28.77 36.3,29.76 L36.39,29.86 C37.34,30.81 38.88,30.84 39.87,29.95 L39.96,29.86 L46.14,23.68 C46.39,23.42 46.58,23.13 46.71,22.81 C46.8,22.57 46.86,22.31 46.87,22.05 C46.89,21.69 46.84,21.33 46.71,20.99 C46.6,20.7 46.44,20.44 46.23,20.2 L46.22,20.2 C46.2,20.17 46.17,20.14 46.14,20.11 L46.14,20.11 L39.96,13.93 Z M23.48,33.02 C24.46,32.03 26.06,32.03 27.05,33.02 C28.01,33.98 28.04,35.51 27.14,36.5 L27.05,36.59 L25.19,38.46 L41.54,38.46 C42.94,38.46 44.07,39.59 44.07,40.98 C44.07,42.34 43,43.44 41.66,43.51 L41.54,43.51 L25.19,43.51 L27.05,45.37 C28.01,46.33 28.04,47.86 27.14,48.85 L27.05,48.94 C26.09,49.9 24.56,49.93 23.57,49.03 L23.48,48.94 L17.32,42.78 C17.26,42.73 17.21,42.68 17.16,42.62 C16.79,42.18 16.56,41.61 16.56,40.99 C16.56,40.99 16.56,40.98 16.56,40.98 C16.56,40.98 16.56,40.97 16.56,40.96 C16.56,40.65 16.62,40.35 16.73,40.07 C16.84,39.79 17,39.52 17.21,39.29 L17.22,39.29 C17.24,39.26 17.27,39.23 17.3,39.2 L17.3,39.2 L23.48,33.02 Z"
                })
            })
        })
    });
};

});

parcelRegister("99M7w", function(module, exports) {

$parcel$export(module.exports, "CheckmarkCircle", function () { return $6aaa4808f3a85f4c$export$7f2957f440d043b5; });

var $1rY3h = parcelRequire("1rY3h");
var $6aaa4808f3a85f4c$export$7f2957f440d043b5 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-basic-checkmark circle",
        width: size,
        height: size,
        viewBox: "0 0 64 64",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsx)("g", {
                fill: "currentColor",
                children: (0, $1rY3h.jsx)("path", {
                    d: "M32,0 C14.33,0 0,14.33 0,32 C0,49.67 14.33,64 32,64 C49.67,64 64,49.67 64,32 C64,14.33 49.67,0 32,0 Z M44.59,25.97 C45.49,24.97 45.46,23.44 44.5,22.48 L44.42,22.4 C43.43,21.49 41.89,21.52 40.93,22.48 L27.63,35.78 L23.07,31.21 L22.98,31.13 C21.99,30.23 20.45,30.25 19.5,31.21 C18.51,32.2 18.51,33.8 19.5,34.78 L25.85,41.14 L25.93,41.22 C26.92,42.12 28.46,42.09 29.42,41.14 L44.5,26.05 L44.59,25.97 Z"
                })
            })
        })
    });
};

});

parcelRegister("bXno7", function(module, exports) {

$parcel$export(module.exports, "Cycle", function () { return $8b4758c6d404679e$export$126db9180177689d; });

var $1rY3h = parcelRequire("1rY3h");
var $8b4758c6d404679e$export$126db9180177689d = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-basic-cycle",
        width: size,
        height: size,
        viewBox: "0 0 64 86",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsx)("g", {
                fill: "currentColor",
                fillRule: "nonzero",
                children: (0, $1rY3h.jsxs)("g", {
                    children: [
                        (0, $1rY3h.jsx)("path", {
                            d: "M12.95,19.87 C13.93,20.85 13.93,22.45 12.95,23.44 C2.42,33.96 2.42,51.03 12.95,61.55 C18.05,66.66 24.85,69.42 31.94,69.44 L32.28,69.44 L40.52,69.44 C41.92,69.44 43.05,70.57 43.05,71.97 C43.05,73.32 41.99,74.42 40.65,74.49 L40.52,74.49 L32.31,74.49 C23.77,74.57 15.53,71.28 9.37,65.12 C-3.12,52.62 -3.12,32.36 9.37,19.87 C10.36,18.88 11.96,18.88 12.95,19.87 Z"
                        }),
                        (0, $1rY3h.jsx)("path", {
                            d: "M54.63,19.87 C67.12,32.36 67.12,52.62 54.63,65.12 C53.64,66.11 52.04,66.11 51.05,65.12 C50.07,64.14 50.07,62.54 51.05,61.55 C61.58,51.03 61.58,33.96 51.05,23.44 C46.07,18.46 39.49,15.7 32.62,15.55 L32.28,15.55 L22.46,15.55 C21.06,15.55 19.93,14.42 19.93,13.02 C19.93,11.67 20.99,10.57 22.33,10.5 L22.46,10.5 L32.3,10.5 C40.63,10.57 48.62,13.86 54.63,19.87 Z"
                        }),
                        (0, $1rY3h.jsx)("path", {
                            d: "M33.28,25.75 C32.32,26.71 30.78,26.73 29.79,25.83 L29.7,25.75 L18.99,15.03 C18.03,14.07 18,12.54 18.9,11.54 L18.99,11.46 L29.7,0.74 C30.69,-0.25 32.29,-0.25 33.28,0.74 C34.23,1.7 34.26,3.24 33.36,4.23 L33.28,4.31 L24.34,13.24 L33.28,22.18 C34.23,23.13 34.26,24.67 33.36,25.66 L33.28,25.75 Z"
                        }),
                        (0, $1rY3h.jsx)("path", {
                            d: "M29.7,84.7 C30.66,85.65 32.2,85.68 33.19,84.78 L33.28,84.7 L43.99,73.98 C44.95,73.02 44.98,71.48 44.08,70.49 L43.99,70.41 L33.28,59.69 C32.29,58.7 30.69,58.7 29.7,59.69 C28.75,60.65 28.72,62.18 29.62,63.17 L29.7,63.26 L38.64,72.19 L29.7,81.12 C28.75,82.08 28.72,83.62 29.62,84.61 L29.7,84.7 Z"
                        })
                    ]
                })
            })
        })
    });
};

});

parcelRegister("igz15", function(module, exports) {

$parcel$export(module.exports, "DollarSign", function () { return $d4c4e22ec2a26fb7$export$10b604ad3c19432a; });

var $1rY3h = parcelRequire("1rY3h");
var $d4c4e22ec2a26fb7$export$10b604ad3c19432a = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-basic-dollar sign",
        width: size,
        height: size,
        viewBox: "0 0 30 72",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M14.91,7.6367 C23.06,7.6367 29.68,14.1777 29.81,22.2965 L29.81,22.543 L29.81,25.1839 C29.81,26.5395 28.71,27.6384 27.36,27.6384 C26.04,27.6384 24.97,26.6014 24.91,25.2995 L24.9,25.1839 L24.9,22.543 C24.9,17.0217 20.43,12.5458 14.91,12.5458 C9.45,12.5458 5.01,16.9239 4.91,22.3614 L4.91,22.543 L4.91,23.5486 C4.91,29.0092 9.29,33.4473 14.72,33.5441 L14.91,33.5458 C23.06,33.5458 29.68,40.0867 29.81,48.2056 L29.81,48.4521 L29.81,49.4576 C29.81,57.6901 23.14,64.3639 14.91,64.3639 C6.76,64.3639 0.13,57.8229 0,49.7041 L0,49.4576 L0,46.8167 C0,45.4611 1.1,44.3622 2.45,44.3622 C3.77,44.3622 4.85,45.3992 4.91,46.7012 L4.91,46.8167 L4.91,49.4576 C4.91,54.9789 9.38,59.4548 14.91,59.4548 C20.37,59.4548 24.8,55.0767 24.9,49.6392 L24.9,49.4576 L24.9,48.4521 C24.9,42.9914 20.53,38.5533 15.09,38.4565 L14.91,38.4548 C6.76,38.4548 0.13,31.9139 0,23.7951 L0,23.5486 L0,22.543 C0,14.3105 6.67,7.6367 14.91,7.6367 Z",
                        fillRule: "nonzero"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M17.36,2.339 C17.3,1.037 16.22,0 14.91,0 C13.55,0 12.45,1.0989 12.45,2.4545 L12.45,7.9091 L12.46,8.0246 C12.52,9.3266 13.59,10.3636 14.91,10.3636 C16.26,10.3636 17.36,9.2647 17.36,7.9091 L17.36,2.4545 L17.36,2.339 Z M17.36,63.9752 C17.3,62.6733 16.22,61.6362 14.91,61.6362 C13.55,61.6362 12.45,62.7352 12.45,64.0908 L12.45,69.5453 L12.45,69.6608 C12.52,70.9628 13.59,71.9998 14.91,71.9998 C16.26,71.9998 17.36,70.9009 17.36,69.5453 L17.36,64.0908 L17.36,63.9752 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("1sKJ3", function(module, exports) {

$parcel$export(module.exports, "DollarSignCircle", function () { return $110ca6b2d5343ff3$export$7db165b2b706b17a; });

var $1rY3h = parcelRequire("1rY3h");
var $110ca6b2d5343ff3$export$7db165b2b706b17a = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-basic-dollar sign circle",
        width: size,
        height: size,
        viewBox: "0 0 64 64",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsx)("g", {
                fill: "currentColor",
                children: (0, $1rY3h.jsx)("path", {
                    d: "M0,32 C0,14.327 14.33,0 32,0 C49.67,0 64,14.327 64,32 C64,49.673 49.67,64 32,64 C14.33,64 0,49.673 0,32 Z M34.36,13.732 C38.72,14.842 41.96,18.758 42.04,23.445 L42.05,23.633 L42.05,25.264 C42.05,26.659 40.91,27.79 39.52,27.79 C38.16,27.79 37.06,26.723 37,25.383 L36.99,25.264 L36.99,23.633 C36.99,20.781 34.68,18.47 31.83,18.47 C29.03,18.47 26.75,20.701 26.67,23.483 L26.67,23.633 L26.67,24.254 C26.67,27.055 28.9,29.336 31.68,29.415 L31.83,29.417 C37.41,29.417 41.94,33.89 42.04,39.445 L42.05,39.633 L42.05,40.254 C42.05,45.024 38.78,49.031 34.36,50.155 L34.36,52.659 C34.36,54.054 33.23,55.185 31.83,55.185 C30.47,55.185 29.37,54.118 29.31,52.778 L29.3,52.659 L29.3,50.155 C24.94,49.045 21.7,45.129 21.62,40.442 L21.61,40.254 L21.61,38.623 C21.61,37.228 22.75,36.097 24.14,36.097 C25.5,36.097 26.6,37.164 26.66,38.504 L26.67,38.623 L26.67,40.254 C26.67,43.106 28.98,45.417 31.83,45.417 C34.63,45.417 36.91,43.186 36.99,40.404 L36.99,40.254 L36.99,39.633 C36.99,36.831 34.76,34.551 31.98,34.472 L31.83,34.47 C26.25,34.47 21.72,29.997 21.62,24.442 L21.61,24.254 L21.61,23.633 C21.61,18.863 24.88,14.856 29.3,13.732 L29.3,11.227 C29.3,9.832 30.43,8.701 31.83,8.701 C33.19,8.701 34.29,9.768 34.35,11.108 L34.36,11.227 L34.36,13.732 Z"
                })
            })
        })
    });
};

});

parcelRegister("eK5GP", function(module, exports) {

$parcel$export(module.exports, "Exclamation", function () { return $abb9c66a8f7854e6$export$6ec7d6546a5aa6ad; });

var $1rY3h = parcelRequire("1rY3h");
var $abb9c66a8f7854e6$export$6ec7d6546a5aa6ad = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-basic-exclamation",
        width: size,
        height: size,
        viewBox: "0 0 64 64",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsx)("g", {
                fill: "currentColor",
                children: (0, $1rY3h.jsx)("path", {
                    d: "M0,32 C0,14.33 14.33,0 32,0 C49.67,0 64,14.33 64,32 C64,49.67 49.67,64 32,64 C14.33,64 0,49.67 0,32 Z M32.46,14 C33.81,14 34.9,15.07 34.96,16.41 L34.96,16.53 L34.96,34.47 C34.96,35.87 33.84,37 32.46,37 C31.12,37 30.03,35.93 29.97,34.59 L29.96,34.47 L29.96,16.53 C29.96,15.13 31.08,14 32.46,14 Z M32.46,47 C34.4,47 35.96,45.43 35.96,43.5 C35.96,41.57 34.4,40 32.46,40 C30.53,40 28.96,41.57 28.96,43.5 C28.96,45.43 30.53,47 32.46,47 Z"
                })
            })
        })
    });
};

});

parcelRegister("3L83V", function(module, exports) {

$parcel$export(module.exports, "Info", function () { return $2bcc03e0c2b5a5b9$export$c4868e4a24d48fad; });

var $1rY3h = parcelRequire("1rY3h");
var $2bcc03e0c2b5a5b9$export$c4868e4a24d48fad = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-basic-info",
        width: size,
        height: size,
        viewBox: "0 0 27 64",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsx)("g", {
                fill: "currentColor",
                fillRule: "nonzero",
                children: (0, $1rY3h.jsxs)("g", {
                    children: [
                        (0, $1rY3h.jsx)("circle", {
                            cx: "12.97",
                            cy: "4.511",
                            r: "4.51101"
                        }),
                        (0, $1rY3h.jsx)("path", {
                            d: "M23.47,58.926 C24.87,58.926 26.01,60.062 26.01,61.463 C26.01,62.825 24.93,63.936 23.59,63.998 L23.47,64.001 L2.54,64.001 C1.14,64.001 0,62.865 0,61.463 C0,60.102 1.07,58.991 2.42,58.929 L2.54,58.926 L23.47,58.926 Z"
                        }),
                        (0, $1rY3h.jsx)("path", {
                            d: "M13,12.123 C14.36,12.123 15.48,13.195 15.54,14.541 L15.54,14.66 L15.54,61.462 C15.54,62.864 14.4,64 13,64 C11.64,64 10.53,62.928 10.47,61.582 L10.47,61.462 L10.46,17.198 L2.54,17.198 C1.18,17.198 0.07,16.126 0,14.78 L0,14.66 C0,13.299 1.07,12.188 2.42,12.126 L2.54,12.123 L13,12.123 Z"
                        })
                    ]
                })
            })
        })
    });
};

});

parcelRegister("5imT3", function(module, exports) {

$parcel$export(module.exports, "InfoCircle", function () { return $3db0630d5e3088f0$export$6e50c69d980cc044; });

var $1rY3h = parcelRequire("1rY3h");
var $3db0630d5e3088f0$export$6e50c69d980cc044 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-basic-info circle",
        width: size,
        height: size,
        viewBox: "0 0 64 64",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsx)("g", {
                fill: "currentColor",
                children: (0, $1rY3h.jsx)("path", {
                    d: "M32,0 C14.33,0 0,14.327 0,32 C0,49.673 14.33,64 32,64 C49.67,64 64,49.673 64,32 C64,14.327 49.67,0 32,0 Z M32.28,17.964 C34.92,17.964 37.05,15.828 37.05,13.192 C37.05,10.557 34.92,8.42 32.28,8.42 C29.65,8.42 27.51,10.557 27.51,13.192 C27.51,15.828 29.65,17.964 32.28,17.964 Z M37.89,45.753 C39.29,45.753 40.42,46.884 40.42,48.28 C40.42,49.635 39.35,50.741 38.01,50.803 L37.89,50.806 L32.35,50.806 C32.34,50.806 32.33,50.806 32.31,50.806 C32.3,50.806 32.29,50.806 32.28,50.806 L26.7,50.806 C25.3,50.806 24.17,49.675 24.17,48.28 C24.17,46.924 25.24,45.818 26.58,45.756 L26.7,45.753 L29.79,45.753 L29.79,26.666 L26.67,26.666 C25.31,26.666 24.21,25.598 24.14,24.258 L24.14,24.139 C24.14,22.784 25.21,21.678 26.55,21.616 L26.67,21.613 L32.31,21.613 C33.67,21.613 34.78,22.681 34.84,24.021 L34.84,24.139 L34.84,45.753 L37.89,45.753 Z"
                })
            })
        })
    });
};

});

parcelRegister("ecGKx", function(module, exports) {

$parcel$export(module.exports, "Minus", function () { return $a57358e2c2c9dec6$export$da45d96ed490d127; });

var $1rY3h = parcelRequire("1rY3h");
var $a57358e2c2c9dec6$export$da45d96ed490d127 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-basic-minus",
        width: size,
        height: size,
        viewBox: "0 0 65 64",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsx)("g", {
                fill: "currentColor",
                children: (0, $1rY3h.jsx)("path", {
                    d: "M32.96,0 C50.64,0 64.96,14.33 64.96,32 C64.96,49.67 50.64,64 32.96,64 C15.29,64 0.96,49.67 0.96,32 C0.96,14.33 15.29,0 32.96,0 Z M15.96,32.5 C15.96,31.12 17.06,30 18.42,30 L47.51,30 L47.62,30 C48.93,30.06 49.96,31.16 49.96,32.5 C49.96,33.88 48.86,35 47.51,35 L18.42,35 L18.31,35 C17,34.94 15.96,33.84 15.96,32.5 Z"
                })
            })
        })
    });
};

});

parcelRegister("gUdRh", function(module, exports) {

$parcel$export(module.exports, "New", function () { return $c4eca04f03381093$export$6fbbeb565555321b; });

var $1rY3h = parcelRequire("1rY3h");
var $c4eca04f03381093$export$6fbbeb565555321b = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-basic-new",
        width: size,
        height: size,
        viewBox: "0 0 64 64",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M31.81,38.09 C31.39,37.01 29.86,37.01 29.44,38.09 L27.83,42.26 L23.66,43.87 C22.58,44.28 22.58,45.82 23.66,46.24 L27.83,47.85 L29.44,52.01 C29.86,53.1 31.39,53.1 31.81,52.01 L33.42,47.85 L37.58,46.24 C38.67,45.82 38.67,44.28 37.58,43.87 L33.42,42.26 L31.81,38.09 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M32,0 C49.67,0 64,14.33 64,32 C64,49.67 49.67,64 32,64 C14.33,64 0,49.67 0,32 C0,14.33 14.33,0 32,0 Z M46.63,24.45 C46.21,23.36 44.68,23.36 44.26,24.45 L42.65,28.62 L38.49,30.22 C37.4,30.64 37.4,32.18 38.49,32.6 L42.65,34.2 L44.26,38.37 C44.68,39.46 46.21,39.46 46.63,38.37 L48.24,34.2 L52.41,32.6 C53.49,32.18 53.49,30.64 52.41,30.22 L48.24,28.62 L46.63,24.45 Z M31.81,38.09 C31.39,37.01 29.86,37.01 29.44,38.09 L27.83,42.26 L23.66,43.87 C22.58,44.28 22.58,45.82 23.66,46.24 L27.83,47.84 L29.44,52.01 C29.86,53.1 31.39,53.1 31.81,52.01 L33.42,47.84 L37.59,46.24 C38.67,45.82 38.67,44.28 37.59,43.87 L33.42,42.26 L31.81,38.09 Z M22.72,13.37 C23.22,12.06 25.06,12.06 25.56,13.37 L27.54,18.49 L32.67,20.47 C33.97,20.97 33.97,22.82 32.67,23.32 L27.54,25.29 L25.56,30.42 C25.06,31.73 23.22,31.73 22.72,30.42 L20.74,25.29 L15.61,23.32 C14.31,22.82 14.31,20.97 15.61,20.47 L20.74,18.49 L22.72,13.37 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("72VhV", function(module, exports) {

$parcel$export(module.exports, "No", function () { return $52152882c6c69f96$export$830dad7b282f77fd; });

var $1rY3h = parcelRequire("1rY3h");
var $52152882c6c69f96$export$830dad7b282f77fd = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-basic-no",
        width: size,
        height: size,
        viewBox: "0 0 64 64",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M0,32 C0,14.33 14.33,0 32,0 C49.67,0 64,14.33 64,32 C64,49.77 50.14,64 32.56,64 C14.79,64 0,49.58 0,32 Z M58.99,32 C58.99,17.09 46.91,5.01 32,5.01 C17.09,5.01 5.01,17.09 5.01,32 C5.01,46.79 17.53,58.99 32.56,58.99 C47.34,58.99 58.99,47.03 58.99,32 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M54.36,9.64 C53.41,8.69 51.9,8.66 50.91,9.55 L50.82,9.64 L10.19,50.26 C9.22,51.24 9.22,52.83 10.19,53.81 C11.14,54.75 12.66,54.78 13.64,53.89 L13.74,53.81 L54.36,13.18 C55.34,12.2 55.34,10.62 54.36,9.64 Z",
                        fillRule: "nonzero"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("80smX", function(module, exports) {

$parcel$export(module.exports, "Plus", function () { return $5d4454633194f92a$export$2d9ac7aa84f97a08; });

var $1rY3h = parcelRequire("1rY3h");
var $5d4454633194f92a$export$2d9ac7aa84f97a08 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-basic-plus",
        width: size,
        height: size,
        viewBox: "0 0 65 64",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsx)("g", {
                fill: "currentColor",
                children: (0, $1rY3h.jsx)("path", {
                    d: "M64.96,32 C64.96,14.33 50.64,0 32.96,0 C15.29,0 0.96,14.33 0.96,32 C0.96,49.67 15.29,64 32.96,64 C50.64,64 64.96,49.67 64.96,32 Z M18.42,30 C17.06,30 15.96,31.12 15.96,32.5 C15.96,33.84 17,34.94 18.31,35 L18.42,35 L29.96,35 L29.96,46.54 C29.96,47.9 31.08,49 32.46,49 C33.81,49 34.9,47.96 34.96,46.66 L34.96,46.54 L34.96,35 L47.51,35 C48.86,35 49.96,33.88 49.96,32.5 C49.96,31.16 48.93,30.06 47.62,30 L47.51,30 L34.96,30 L34.96,17.46 C34.96,16.1 33.84,15 32.46,15 C31.12,15 30.03,16.04 29.97,17.34 L29.96,17.46 L29.96,30 L18.42,30 Z"
                })
            })
        })
    });
};

});

parcelRegister("1kG8v", function(module, exports) {

$parcel$export(module.exports, "QuestionMark", function () { return $0f88581466c07870$export$e76f05f5f778b829; });

var $1rY3h = parcelRequire("1rY3h");
var $0f88581466c07870$export$e76f05f5f778b829 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-basic-question mark",
        width: size,
        height: size,
        viewBox: "0 0 33 64",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsx)("g", {
                fill: "currentColor",
                fillRule: "nonzero",
                children: (0, $1rY3h.jsxs)("g", {
                    children: [
                        (0, $1rY3h.jsx)("path", {
                            d: "M16.21,0 C25.17,0 32.43,7.26 32.43,16.21 C32.43,25.17 25.17,32.43 16.21,32.43 C14.8,32.43 13.65,31.28 13.65,29.87 C13.65,28.49 14.73,27.37 16.09,27.31 L16.21,27.31 C22.34,27.31 27.31,22.34 27.31,16.21 C27.31,10.09 22.34,5.12 16.21,5.12 C10.09,5.12 5.12,10.09 5.12,16.21 C5.12,17.63 3.97,18.77 2.56,18.77 C1.15,18.77 0,17.63 0,16.21 C0,7.26 7.26,0 16.21,0 Z"
                        }),
                        (0, $1rY3h.jsx)("path", {
                            d: "M16.21,27.31 C17.59,27.31 18.71,28.39 18.77,29.75 L18.77,29.87 L18.77,46.36 C18.77,47.78 17.63,48.92 16.21,48.92 C14.84,48.92 13.72,47.84 13.66,46.48 L13.65,46.36 L13.65,29.87 C13.65,28.45 14.8,27.31 16.21,27.31 Z"
                        }),
                        (0, $1rY3h.jsx)("circle", {
                            cx: "16.21",
                            cy: "59.16",
                            r: "4.83554"
                        })
                    ]
                })
            })
        })
    });
};

});

parcelRegister("dqXGo", function(module, exports) {

$parcel$export(module.exports, "QuestionMarkCircle", function () { return $9c7bffd4b630a70d$export$3345d9d1109973c3; });

var $1rY3h = parcelRequire("1rY3h");
var $9c7bffd4b630a70d$export$3345d9d1109973c3 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-basic-question mark_2",
        width: size,
        height: size,
        viewBox: "0 0 64 64",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsx)("g", {
                fill: "currentColor",
                children: (0, $1rY3h.jsx)("path", {
                    d: "M32,0 C14.33,0 0,14.33 0,32 C0,49.67 14.33,64 32,64 C49.67,64 64,49.67 64,32 C64,14.33 49.67,0 32,0 Z M40.7,24.42 C40.7,19.46 36.68,15.44 31.72,15.44 C26.76,15.44 22.74,19.46 22.74,24.42 C22.74,25.82 23.87,26.95 25.26,26.95 C26.66,26.95 27.79,25.82 27.79,24.42 L27.79,24.29 C27.86,22.18 29.59,20.49 31.72,20.49 C33.89,20.49 35.65,22.25 35.65,24.42 C35.65,26.59 33.89,28.35 31.72,28.35 L31.66,28.35 C31.63,28.35 31.6,28.35 31.57,28.35 C30.18,28.35 29.05,29.48 29.05,30.88 L29.05,34.81 L29.05,34.93 C29.11,36.27 30.22,37.33 31.57,37.33 C32.97,37.33 34.1,36.2 34.1,34.81 L34.1,33.09 C37.9,32.04 40.7,28.56 40.7,24.42 Z M31.44,47.16 C33.3,47.16 34.81,45.65 34.81,43.79 C34.81,41.93 33.3,40.42 31.44,40.42 C29.58,40.42 28.07,41.93 28.07,43.79 C28.07,45.65 29.58,47.16 31.44,47.16 Z"
                })
            })
        })
    });
};

});

parcelRegister("lxqDS", function(module, exports) {

$parcel$export(module.exports, "Restart", function () { return $fae1589c2206914a$export$9c2ba28ab86431ff; });

var $1rY3h = parcelRequire("1rY3h");
var $fae1589c2206914a$export$9c2ba28ab86431ff = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-basic-restart",
        width: size,
        height: size,
        viewBox: "0 0 64 75",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsx)("g", {
                fill: "currentColor",
                fillRule: "nonzero",
                children: (0, $1rY3h.jsxs)("g", {
                    children: [
                        (0, $1rY3h.jsx)("path", {
                            d: "M33.27,25.96 C32.32,26.91 30.79,26.94 29.81,26.04 L29.72,25.96 L19.1,15.34 C18.15,14.39 18.12,12.86 19.02,11.88 L19.1,11.8 L29.72,1.17 C30.7,0.19 32.29,0.19 33.27,1.17 C34.22,2.12 34.24,3.64 33.35,4.63 L33.27,4.71 L24.41,13.57 L33.27,22.42 C34.22,23.37 34.24,24.89 33.35,25.88 L33.27,25.96 Z"
                        }),
                        (0, $1rY3h.jsx)("path", {
                            d: "M32,10.28 C49.67,10.28 64,24.61 64,42.28 C64,59.96 49.67,74.28 32,74.28 C14.33,74.28 0,59.96 0,42.28 C0,40.9 1.12,39.78 2.5,39.78 C3.89,39.78 5.01,40.9 5.01,42.28 C5.01,57.19 17.09,69.27 32,69.27 C46.91,69.27 58.99,57.19 58.99,42.28 C58.99,27.52 47.15,15.53 32.45,15.3 L32,15.29 L23.1,15.29 C21.71,15.29 20.59,14.17 20.59,12.79 C20.59,11.44 21.65,10.35 22.98,10.29 L23.1,10.28 L32,10.28 Z"
                        })
                    ]
                })
            })
        })
    });
};

});

parcelRegister("6RjL7", function(module, exports) {

$parcel$export(module.exports, "RestartCircle", function () { return $4fe7050cc3b22582$export$7da50820850be8fa; });

var $1rY3h = parcelRequire("1rY3h");
var $4fe7050cc3b22582$export$7da50820850be8fa = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-basic-restart circle",
        width: size,
        height: size,
        viewBox: "0 0 64 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsx)("g", {
                fill: "currentColor",
                children: (0, $1rY3h.jsx)("path", {
                    d: "M0,32.28 C0,14.61 14.33,0.28 32,0.28 C49.67,0.28 64,14.61 64,32.28 C64,49.95 49.67,64.28 32,64.28 C14.33,64.28 0,49.95 0,32.28 Z M31.69,25.12 C30.73,26.08 29.19,26.1 28.2,25.2 L28.12,25.12 L22.86,19.87 C21.9,18.91 21.88,17.37 22.78,16.38 L22.86,16.29 L28.12,11.04 C29.1,10.05 30.7,10.05 31.69,11.04 C32.65,12 32.67,13.54 31.77,14.53 L31.69,14.61 L30.75,15.55 L32.08,15.55 C41.27,15.55 48.72,23 48.72,32.19 C48.72,41.38 41.27,48.83 32.08,48.83 C22.89,48.83 15.44,41.38 15.44,32.19 C15.44,30.8 16.57,29.66 17.96,29.66 C19.36,29.66 20.49,30.8 20.49,32.19 C20.49,38.59 25.68,43.78 32.08,43.78 C38.48,43.78 43.66,38.59 43.66,32.19 C43.66,25.86 38.58,20.71 32.27,20.61 L32.08,20.61 L30.75,20.61 L31.69,21.54 C32.65,22.5 32.67,24.04 31.77,25.03 L31.69,25.12 Z"
                })
            })
        })
    });
};

});

parcelRegister("c6hAX", function(module, exports) {

$parcel$export(module.exports, "X", function () { return $8cf3b1986219c245$export$78acf4525d8a74c4; });

var $1rY3h = parcelRequire("1rY3h");
var $8cf3b1986219c245$export$78acf4525d8a74c4 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-basic-x",
        width: size,
        height: size,
        viewBox: "0 0 65 64",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsx)("g", {
                fill: "currentColor",
                children: (0, $1rY3h.jsx)("path", {
                    d: "M55.59,54.63 C68.09,42.13 68.09,21.87 55.59,9.37 C43.09,-3.12 22.83,-3.12 10.34,9.37 C-2.16,21.87 -2.16,42.13 10.34,54.63 C22.83,67.12 43.09,67.12 55.59,54.63 Z M24.1,20.3 C23.14,19.34 21.57,19.36 20.59,20.33 C19.64,21.28 19.6,22.79 20.48,23.76 L20.56,23.84 L28.72,32 L20.56,40.16 C19.6,41.12 19.61,42.69 20.59,43.67 C21.54,44.62 23.05,44.66 24.01,43.78 L24.1,43.7 L32.26,35.54 L41.13,44.4 C42.09,45.36 43.65,45.35 44.63,44.37 C45.58,43.43 45.62,41.92 44.74,40.95 L44.66,40.87 L35.79,32 L44.66,23.13 C45.62,22.17 45.61,20.6 44.63,19.63 C43.68,18.68 42.17,18.64 41.21,19.52 L41.13,19.6 L32.26,28.46 L24.1,20.3 Z"
                })
            })
        })
    });
};

});

parcelRegister("dYiSZ", function(module, exports) {

$parcel$export(module.exports, "Attachment", function () { return $a2bf875492188bf8$export$71e4db985cfcf9e3; });

var $1rY3h = parcelRequire("1rY3h");
var $a2bf875492188bf8$export$71e4db985cfcf9e3 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-content-attachment",
        width: size,
        height: size,
        viewBox: "0 0 50 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsx)("g", {
                fill: "currentColor",
                fillRule: "nonzero",
                children: (0, $1rY3h.jsx)("g", {
                    children: (0, $1rY3h.jsx)("path", {
                        d: "M17.24,0.5625 C26.67,0.5625 34.33,8.1289 34.48,17.5204 L34.49,17.8056 L34.49,39.941 C34.49,45.413 30.05,49.848 24.58,49.848 C19.17,49.848 14.77,45.513 14.67,40.127 L14.67,39.941 L14.67,17.8482 C14.67,16.4281 15.82,15.2768 17.24,15.2768 C18.62,15.2768 19.75,16.3632 19.81,17.7272 L19.81,17.8482 L19.81,39.941 C19.81,42.572 21.95,44.705 24.58,44.705 C27.16,44.705 29.26,42.651 29.34,40.087 L29.34,39.941 L29.34,17.8056 C29.34,11.1228 23.93,5.7054 17.24,5.7054 C13.97,5.7054 11,7.0061 8.82,9.1191 L8.56,9.3818 C6.49,11.5158 5.2,14.4101 5.14,17.6055 L5.14,17.8056 L5.14,39.984 C5.14,50.718 13.84,59.42 24.58,59.42 C35.21,59.42 43.84,50.891 44.01,40.305 L44.01,39.984 L44.01,17.8482 C44.01,16.4281 45.17,15.2768 46.59,15.2768 C47.97,15.2768 49.09,16.3632 49.15,17.7272 L49.16,17.8482 L49.16,39.984 C49.16,53.558 38.15,64.563 24.58,64.563 C11.14,64.563 0.22,53.777 0,40.39 L0,39.984 L0,17.8056 C0,8.2825 7.72,0.5625 17.24,0.5625 Z"
                    })
                })
            })
        })
    });
};

});

parcelRegister("lHyqP", function(module, exports) {

$parcel$export(module.exports, "Calendar", function () { return $fcc8528e8ec9c22a$export$e1aef45b828286de; });

var $1rY3h = parcelRequire("1rY3h");
var $fcc8528e8ec9c22a$export$e1aef45b828286de = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-content-calendar",
        width: size,
        height: size,
        viewBox: "0 0 58 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M21.61,23 L36.49,23 L36.49,33.686 L21.61,33.686 L21.61,23 Z M16.56,38.739 L16.56,48.844 L0,48.844 L0,38.739 L16.56,38.739 Z M16.56,64.563 L16.56,53.896 L0,53.896 L0,57.826 C0,61.547 3.02,64.563 6.74,64.563 L51.09,64.563 C54.81,64.563 57.82,61.547 57.82,57.826 L57.82,53.896 L41.54,53.896 L41.54,64.563 L36.49,64.563 L36.49,53.896 L21.61,53.896 L21.61,64.563 L16.56,64.563 Z M57.82,38.739 L57.82,48.844 L41.54,48.844 L41.54,38.739 L57.82,38.739 Z M36.49,38.739 L36.49,48.844 L21.61,48.844 L21.61,38.739 L36.49,38.739 Z M16.56,33.686 L16.56,23 L0,23 L0,33.686 L16.56,33.686 Z M57.82,33.686 L57.82,23 L41.54,23 L41.54,33.686 L57.82,33.686 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M0,23.001 L57.82,23.001 L57.82,14.475 C57.82,10.754 54.81,7.738 51.09,7.738 L6.74,7.738 C3.02,7.738 0,10.754 0,14.475 L0,23.001 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M41.26,10.948 C41.26,12.343 40.13,13.474 38.74,13.474 C37.38,13.474 36.28,12.407 36.21,11.067 L36.21,10.948 L36.21,3.089 C36.21,1.694 37.34,0.562 38.74,0.562 C40.09,0.562 41.2,1.63 41.26,2.97 L41.26,3.089 L41.26,10.948 Z",
                        fillRule: "nonzero"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M21.61,10.948 C21.61,12.343 20.48,13.474 19.09,13.474 C17.73,13.474 16.63,12.407 16.56,11.067 L16.56,10.948 L16.56,3.089 C16.56,1.694 17.69,0.562 19.09,0.562 C20.44,0.562 21.55,1.63 21.61,2.97 L21.61,3.089 L21.61,10.948 Z",
                        fillRule: "nonzero"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("kzZQ5", function(module, exports) {

$parcel$export(module.exports, "CalendarDate", function () { return $efb70b7c45227e5a$export$99faa760c7908e4f; });

var $1rY3h = parcelRequire("1rY3h");
var $efb70b7c45227e5a$export$99faa760c7908e4f = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-content-calendar date",
        width: size,
        height: size,
        viewBox: "0 0 58 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M57.83,13.473 C57.83,9.753 54.81,6.736 51.09,6.736 L6.74,6.736 C3.02,6.736 0,9.753 0,13.473 L0,13.677 C0,9.844 3.11,6.737 6.94,6.737 L50.89,6.737 C54.72,6.737 57.82,9.84 57.83,13.669 L57.83,13.473 Z M57.83,22.457 L0,22.457 L0,57.825 C0,61.546 3.02,64.562 6.74,64.562 L51.09,64.562 C54.81,64.562 57.83,61.546 57.83,57.825 L57.83,22.457 Z M46.7,35.828 C45.71,34.841 44.11,34.841 43.13,35.828 L39.02,39.936 L34.91,35.828 C33.92,34.841 32.32,34.841 31.34,35.828 C30.38,36.784 30.35,38.315 31.25,39.307 L31.34,39.401 L35.73,43.79 L31.34,48.179 C30.38,49.135 30.35,50.666 31.25,51.658 L31.34,51.752 C32.29,52.708 33.82,52.738 34.82,51.842 L34.91,51.752 L39.02,47.644 L43.13,51.752 L43.22,51.842 C44.21,52.738 45.74,52.708 46.7,51.752 L46.79,51.658 C47.69,50.666 47.66,49.135 46.7,48.179 L42.31,43.79 L46.7,39.401 L46.79,39.307 C47.69,38.315 47.66,36.784 46.7,35.828 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M0,22.458 L57.83,22.458 L57.83,13.475 C57.83,9.755 54.81,6.738 51.09,6.738 L6.74,6.738 C3.02,6.738 0,9.755 0,13.475 L0,22.458 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M41.26,10.949 C41.26,12.344 40.13,13.475 38.74,13.475 C37.38,13.475 36.28,12.408 36.21,11.068 L36.21,10.949 L36.21,3.089 C36.21,1.694 37.34,0.562 38.74,0.562 C40.09,0.562 41.2,1.63 41.26,2.97 L41.26,3.089 L41.26,10.949 Z",
                        fillRule: "nonzero"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M21.61,10.949 C21.61,12.344 20.48,13.475 19.09,13.475 C17.73,13.475 16.63,12.408 16.56,11.068 L16.56,10.949 L16.56,3.089 C16.56,1.694 17.69,0.562 19.09,0.562 C20.44,0.562 21.55,1.63 21.61,2.97 L21.61,3.089 L21.61,10.949 Z",
                        fillRule: "nonzero"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("hZw5k", function(module, exports) {

$parcel$export(module.exports, "Checklists", function () { return $d19105963526e899$export$bd1c95fb49389e9d; });

var $1rY3h = parcelRequire("1rY3h");
var $d19105963526e899$export$bd1c95fb49389e9d = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-content-checklists",
        width: size,
        height: size,
        viewBox: "0 0 64 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M53.44,16.715 C54.98,16.715 56.23,15.463 56.23,13.919 C56.23,12.419 55.05,11.194 53.57,11.126 L53.44,11.123 L30.45,11.123 C28.9,11.123 27.65,12.374 27.65,13.919 C27.65,15.419 28.83,16.643 30.31,16.712 L30.45,16.715 L53.44,16.715 Z",
                        fillRule: "nonzero",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M53.44,30.39 C54.98,30.39 56.23,31.64 56.23,33.18 C56.23,34.68 55.05,35.91 53.57,35.98 L53.44,35.98 L30.45,35.98 C28.9,35.98 27.65,34.73 27.65,33.18 C27.65,31.68 28.83,30.46 30.31,30.39 L30.45,30.39 L53.44,30.39 Z",
                        fillRule: "nonzero",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M53.44,49.02 C54.98,49.02 56.23,50.28 56.23,51.82 C56.23,53.32 55.05,54.54 53.57,54.61 L53.44,54.62 L30.45,54.62 C28.9,54.62 27.65,53.36 27.65,51.82 C27.65,50.32 28.83,49.1 30.31,49.03 L30.45,49.02 L53.44,49.02 Z",
                        fillRule: "nonzero",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M56.54,64.56 C60.66,64.56 64,61.22 64,57.11 L64,8.019 C64,3.901 60.66,0.562 56.54,0.562 L7.46,0.562 C3.34,0.562 0,3.901 0,8.019 L0,57.11 C0,61.22 3.34,64.56 7.46,64.56 L56.54,64.56 Z M18.53,8.52 C19.63,7.431 21.4,7.435 22.49,8.53 C23.54,9.59 23.57,11.285 22.58,12.38 L22.48,12.484 L16.23,18.697 C15.18,19.749 13.49,19.782 12.39,18.796 L12.29,18.697 L8.59,15.018 C7.5,13.929 7.49,12.158 8.58,11.064 C9.64,10.003 11.33,9.966 12.43,10.955 L12.53,11.054 L14.26,12.771 L18.53,8.52 Z M22.49,27.17 C21.4,26.08 19.63,26.07 18.53,27.16 L14.26,31.41 L12.53,29.7 L12.43,29.6 C11.33,28.61 9.64,28.65 8.58,29.71 C7.49,30.8 7.5,32.57 8.59,33.66 L12.29,37.34 L12.39,37.44 C13.49,38.42 15.18,38.39 16.23,37.34 L22.48,31.13 L22.58,31.02 C23.57,29.93 23.54,28.23 22.49,27.17 Z M18.53,45.8 C19.63,44.71 21.4,44.72 22.49,45.81 C23.54,46.87 23.57,48.57 22.58,49.66 L22.48,49.77 L16.23,55.98 C15.18,57.03 13.49,57.06 12.39,56.08 L12.29,55.98 L8.59,52.3 C7.5,51.21 7.49,49.44 8.58,48.35 C9.64,47.29 11.33,47.25 12.43,48.24 L12.53,48.34 L14.26,50.05 L18.53,45.8 Z M56.23,13.92 C56.23,15.464 54.98,16.716 53.44,16.716 L30.45,16.716 L30.31,16.713 C28.83,16.644 27.65,15.42 27.65,13.92 C27.65,12.375 28.9,11.123 30.45,11.123 L53.44,11.123 L53.57,11.127 C55.05,11.195 56.23,12.419 56.23,13.92 Z M53.44,30.39 C54.98,30.39 56.23,31.64 56.23,33.18 C56.23,34.68 55.05,35.91 53.57,35.98 L53.44,35.98 L30.45,35.98 C28.9,35.98 27.65,34.73 27.65,33.18 C27.65,31.68 28.83,30.46 30.31,30.39 L30.45,30.39 L53.44,30.39 Z M56.23,51.82 C56.23,50.28 54.98,49.02 53.44,49.02 L30.45,49.02 L30.31,49.03 C28.83,49.1 27.65,50.32 27.65,51.82 C27.65,53.36 28.9,54.62 30.45,54.62 L53.44,54.62 L53.57,54.61 C55.05,54.54 56.23,53.32 56.23,51.82 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("fSROr", function(module, exports) {

$parcel$export(module.exports, "Checkmark", function () { return $b905a438d8b0e61f$export$4f481e0a96cfbed6; });

var $1rY3h = parcelRequire("1rY3h");
var $b905a438d8b0e61f$export$4f481e0a96cfbed6 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-content-checkmark",
        width: size,
        height: size,
        viewBox: "0 0 64 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M42.25,50.27 C46.37,50.27 49.71,46.93 49.71,42.81 L49.71,8.64 L56.54,8.64 C60.66,8.64 64,11.98 64,16.09 L64,57.1 C64,61.22 60.66,64.56 56.54,64.56 L15.53,64.56 C11.42,64.56 8.08,61.22 8.08,57.1 L8.08,50.27 L42.25,50.27 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M7.46,0.56 C3.34,0.56 0,3.9 0,8.02 L0,49.03 C0,53.15 3.34,56.48 7.46,56.48 L48.47,56.48 C52.58,56.48 55.92,53.15 55.92,49.03 L55.92,8.02 C55.92,3.9 52.58,0.56 48.47,0.56 L7.46,0.56 Z M41.89,21.84 C42.89,20.75 42.86,19.05 41.8,17.99 L41.71,17.89 C40.61,16.89 38.91,16.92 37.85,17.99 L23.13,32.7 L18.08,27.65 L17.98,27.56 C16.88,26.56 15.18,26.59 14.12,27.65 C13.03,28.74 13.03,30.51 14.12,31.61 L21.15,38.64 L21.25,38.73 C22.34,39.73 24.04,39.7 25.11,38.64 L41.8,21.94 L41.89,21.84 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("5q1H2", function(module, exports) {

$parcel$export(module.exports, "ContentShare", function () { return $3f20b1b067d0589f$export$dd558fb2e54b3dc8; });

var $1rY3h = parcelRequire("1rY3h");
var $3f20b1b067d0589f$export$dd558fb2e54b3dc8 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-content-content share",
        width: size,
        height: size,
        viewBox: "0 0 63 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsx)("g", {
                fill: "currentColor",
                fillRule: "nonzero",
                children: (0, $1rY3h.jsxs)("g", {
                    children: [
                        (0, $1rY3h.jsx)("path", {
                            d: "M8.82,30.79 C9.48,29.54 11,29.04 12.27,29.63 L12.39,29.68 L52.61,50.82 C53.9,51.5 54.39,53.1 53.72,54.39 C53.06,55.64 51.54,56.15 50.27,55.56 L50.15,55.5 L9.93,34.36 C8.64,33.68 8.14,32.09 8.82,30.79 Z",
                            opacity: "0.5"
                        }),
                        (0, $1rY3h.jsx)("circle", {
                            cx: "51.38",
                            cy: "52.57",
                            r: "11.4497"
                        }),
                        (0, $1rY3h.jsx)("path", {
                            d: "M50.19,9.7 C51.5,9.04 53.09,9.57 53.74,10.88 C54.37,12.14 53.89,13.68 52.67,14.36 L52.56,14.42 L12.63,34.39 C11.33,35.04 9.74,34.51 9.09,33.21 C8.45,31.94 8.93,30.41 10.15,29.72 L10.27,29.66 L50.19,9.7 Z",
                            opacity: "0.5"
                        }),
                        (0, $1rY3h.jsx)("circle", {
                            cx: "11.45",
                            cy: "32.02",
                            r: "11.4497"
                        }),
                        (0, $1rY3h.jsx)("circle", {
                            cx: "51.38",
                            cy: "11.47",
                            r: "11.4497"
                        })
                    ]
                })
            })
        })
    });
};

});

parcelRegister("fYyLp", function(module, exports) {

$parcel$export(module.exports, "DiagramNetwork", function () { return $ba176cf9d137b8d8$export$6e1112c8af42012b; });

var $1rY3h = parcelRequire("1rY3h");
var $ba176cf9d137b8d8$export$6e1112c8af42012b = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-content-diagram network",
        width: size,
        height: size,
        viewBox: "0 0 61 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsx)("g", {
                fill: "currentColor",
                fillRule: "nonzero",
                children: (0, $1rY3h.jsxs)("g", {
                    children: [
                        (0, $1rY3h.jsx)("path", {
                            d: "M41.96,8.78 C42.66,7.66 44.14,7.31 45.26,8.01 C46.36,8.69 46.72,10.1 46.1,11.21 L46.04,11.31 L29.51,37.98 C28.81,39.11 27.33,39.45 26.2,38.76 C25.11,38.08 24.75,36.67 25.37,35.55 L25.43,35.45 L41.96,8.78 Z",
                            opacity: "0.5"
                        }),
                        (0, $1rY3h.jsx)("path", {
                            d: "M4.46,13.67 C5.38,12.77 6.83,12.76 7.76,13.62 L7.85,13.71 L29.18,35.58 C30.11,36.52 30.09,38.04 29.14,38.97 C28.22,39.87 26.77,39.88 25.84,39.01 L25.75,38.93 L4.42,17.06 C3.49,16.11 3.51,14.59 4.46,13.67 Z",
                            opacity: "0.5"
                        }),
                        (0, $1rY3h.jsx)("path", {
                            d: "M25.77,35.02 C26.71,34.08 28.23,34.08 29.16,35.02 C30.07,35.93 30.1,37.38 29.25,38.32 L29.16,38.41 L7.83,59.75 C6.89,60.68 5.37,60.68 4.44,59.75 C3.53,58.84 3.5,57.38 4.35,56.44 L4.44,56.35 L25.77,35.02 Z",
                            opacity: "0.5"
                        }),
                        (0, $1rY3h.jsx)("path", {
                            d: "M24.97,35.83 C25.44,34.64 26.77,34.03 27.98,34.45 L28.08,34.49 L55.02,45.15 C56.25,45.64 56.85,47.04 56.37,48.27 C55.89,49.46 54.56,50.07 53.36,49.66 L53.25,49.62 L26.32,38.95 C25.08,38.46 24.48,37.07 24.97,35.83 Z",
                            opacity: "0.5"
                        }),
                        (0, $1rY3h.jsx)("circle", {
                            cx: "27.47",
                            cy: "36.72",
                            r: "9.33333"
                        }),
                        (0, $1rY3h.jsx)("circle", {
                            cx: "6.13",
                            cy: "15.38",
                            r: "6.13333"
                        }),
                        (0, $1rY3h.jsx)("circle", {
                            cx: "54.13",
                            cy: "47.38",
                            r: "6.13333"
                        }),
                        (0, $1rY3h.jsx)("circle", {
                            cx: "43.47",
                            cy: "9.52",
                            r: "9.33333"
                        }),
                        (0, $1rY3h.jsx)("circle", {
                            cx: "6.13",
                            cy: "58.05",
                            r: "6.13333"
                        })
                    ]
                })
            })
        })
    });
};

});

parcelRegister("2iaWw", function(module, exports) {

$parcel$export(module.exports, "DiagramOrgChart", function () { return $1ab5c03a197cae34$export$50ccabbebab12b45; });

var $1rY3h = parcelRequire("1rY3h");
var $1ab5c03a197cae34$export$50ccabbebab12b45 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-content-diagram org chart",
        width: size,
        height: size,
        viewBox: "0 0 64 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("g", {
                        transform: "translate(8.000000, 6.000000)",
                        opacity: "0.5",
                        children: (0, $1rY3h.jsx)("path", {
                            d: "M26.57,2.63 C26.51,1.27 25.38,0.18 24,0.18 C22.58,0.18 21.43,1.33 21.43,2.75 L21.43,23.61 L10,23.61 L9.82,23.61 C4.69,23.71 0.57,27.89 0.57,33.04 L0.57,49.61 L0.57,49.73 C0.64,51.1 1.76,52.18 3.14,52.18 C4.56,52.18 5.71,51.03 5.71,49.61 L5.71,33.04 L5.72,32.9 C5.79,30.6 7.68,28.75 10,28.75 L23.99,28.75 C23.99,28.75 24,28.75 24,28.75 C24,28.75 24.01,28.75 24.01,28.75 L38,28.75 L38.14,28.76 C40.44,28.83 42.29,30.72 42.29,33.04 L42.29,49.61 L42.29,49.73 C42.35,51.1 43.48,52.18 44.86,52.18 C46.28,52.18 47.43,51.03 47.43,49.61 L47.43,33.04 L47.43,32.86 C47.33,27.73 43.15,23.61 38,23.61 L26.57,23.61 L26.57,2.75 L26.57,2.63 Z"
                        })
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M0,53.04 C0,46.89 4.99,41.9 11.14,41.9 C17.3,41.9 22.29,46.89 22.29,53.04 C22.29,59.2 17.3,64.18 11.14,64.18 C4.99,64.18 0,59.2 0,53.04 Z",
                        fillRule: "nonzero"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M41.71,53.04 C41.71,46.89 46.7,41.9 52.86,41.9 C59.01,41.9 64,46.89 64,53.04 C64,59.2 59.01,64.18 52.86,64.18 C46.7,64.18 41.71,59.2 41.71,53.04 Z",
                        fillRule: "nonzero"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M20.86,11.33 C20.86,5.17 25.85,0.18 32,0.18 C38.15,0.18 43.14,5.17 43.14,11.33 C43.14,17.48 38.15,22.47 32,22.47 C25.85,22.47 20.86,17.48 20.86,11.33 Z",
                        fillRule: "nonzero"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("jhpRG", function(module, exports) {

$parcel$export(module.exports, "DiagramVenn", function () { return $e093ab0fa480064e$export$24ec4ec2dde88eef; });

var $1rY3h = parcelRequire("1rY3h");
var $e093ab0fa480064e$export$24ec4ec2dde88eef = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-content-diagram venn",
        width: size,
        height: size,
        viewBox: "0 0 67 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M33.21,0.18 C45.66,0.18 55.74,10.27 55.74,22.71 C55.74,35.15 45.66,45.24 33.21,45.24 C20.77,45.24 10.69,35.15 10.69,22.71 C10.69,10.27 20.77,0.18 33.21,0.18 Z M33.21,40.06 C42.8,40.06 50.56,32.29 50.56,22.71 C50.56,13.13 42.8,5.36 33.21,5.36 C23.63,5.36 15.87,13.13 15.87,22.71 C15.87,32.29 23.63,40.06 33.21,40.06 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M22.53,19.13 C34.97,19.13 45.05,29.21 45.05,41.66 C45.05,54.1 34.97,64.18 22.53,64.18 C10.09,64.18 0,54.1 0,41.66 C0,29.21 10.09,19.13 22.53,19.13 Z M22.53,59 C32.11,59 39.87,51.24 39.87,41.66 C39.87,32.07 32.11,24.31 22.53,24.31 C12.95,24.31 5.18,32.07 5.18,41.66 C5.18,51.24 12.95,59 22.53,59 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M44.39,19.13 C56.83,19.13 66.92,29.21 66.92,41.66 C66.92,54.1 56.83,64.18 44.39,64.18 C31.95,64.18 21.86,54.1 21.86,41.66 C21.86,29.21 31.95,19.13 44.39,19.13 Z M44.39,59 C53.97,59 61.74,51.24 61.74,41.66 C61.74,32.07 53.97,24.31 44.39,24.31 C34.81,24.31 27.04,32.07 27.04,41.66 C27.04,51.24 34.81,59 44.39,59 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("79uDZ", function(module, exports) {

$parcel$export(module.exports, "Email", function () { return $535124e709c20e5c$export$5a6b8595f311cbb0; });

var $1rY3h = parcelRequire("1rY3h");
var $535124e709c20e5c$export$5a6b8595f311cbb0 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-content-email",
        width: size,
        height: size,
        viewBox: "0 0 64 53",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M59.03,0.56 C61.77,0.56 64,2.79 64,5.53 L64,5.53 L36.26,27.08 C33.75,29.03 30.25,29.03 27.74,27.08 L0,5.53 L0,5.53 C0,2.79 2.23,0.56 4.97,0.56 L59.03,0.56 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M0,5.53 L0,44.68 C0,48.8 3.34,52.14 7.46,52.14 L56.54,52.14 C60.66,52.14 64,48.8 64,44.68 L64,5.53 C64,4.16 63.44,2.92 62.54,2.02 C63.44,2.92 64,4.16 64,5.53 L36.57,26.84 C33.88,28.93 30.12,28.93 27.43,26.84 L0,5.53 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("Kjn7K", function(module, exports) {

$parcel$export(module.exports, "Filter", function () { return $08b352dca19929a4$export$ec91da630f36d5ea; });

var $1rY3h = parcelRequire("1rY3h");
var $08b352dca19929a4$export$ec91da630f36d5ea = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-content-filter",
        width: size,
        height: size,
        viewBox: "0 0 52 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M32.15,60.38 C32.15,63.72 28.11,65.39 25.75,63.03 L20.76,58.04 C20.06,57.34 19.66,56.38 19.66,55.39 L19.66,33.84 C19.66,31.78 21.34,30.1 23.41,30.1 L28.4,30.1 C30.47,30.1 32.15,31.78 32.15,33.84 L32.15,60.38 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M34.2,37.86 C33.5,38.86 32.35,39.46 31.13,39.46 L20.68,39.46 C19.46,39.46 18.31,38.86 17.61,37.86 L0.67,13.59 C0.24,12.96 0,12.21 0,11.44 L0,3.88 C0,1.81 1.68,0.14 3.75,0.14 L48.07,0.14 C50.13,0.14 51.81,1.81 51.81,3.88 L51.81,11.44 C51.81,12.21 51.58,12.96 51.14,13.59 L34.2,37.86 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("84UrG", function(module, exports) {

$parcel$export(module.exports, "Folder", function () { return $5e1a7b5fbe23cab8$export$80729fed35a16515; });

var $1rY3h = parcelRequire("1rY3h");
var $5e1a7b5fbe23cab8$export$80729fed35a16515 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-content-folder",
        width: size,
        height: size,
        viewBox: "0 0 64 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M56.27,7.38 C60.37,7.38 63.69,10.7 63.69,14.8 L63.69,56.41 C63.69,60.51 60.37,63.83 56.27,63.83 L7.42,63.83 C3.32,63.83 0,60.51 0,56.41 L0,7.56 C0,3.46 3.32,0.14 7.42,0.14 L21.45,0.14 C22.29,0.14 23.1,0.42 23.76,0.94 L30.83,6.57 C31.49,7.1 32.3,7.38 33.14,7.38 L56.27,7.38 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M56.27,12.81 C60.37,12.81 63.69,16.13 63.69,20.23 L63.69,56.72 C63.69,60.81 60.37,64.14 56.27,64.14 L7.42,64.14 C3.32,64.14 0,60.81 0,56.72 L0,20.23 C0,16.13 3.32,12.81 7.42,12.81 L56.27,12.81 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("c3xu1", function(module, exports) {

$parcel$export(module.exports, "GraphBar", function () { return $8c6fbceede8f584c$export$630b74b270eecb49; });

var $1rY3h = parcelRequire("1rY3h");
var $8c6fbceede8f584c$export$630b74b270eecb49 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-content-graph bar",
        width: size,
        height: size,
        viewBox: "0 0 64 60",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M54.49,0.14 C58.32,0.14 61.43,3.24 61.43,7.08 L61.43,52.05 C61.43,55.89 58.32,58.99 54.49,58.99 L9.51,58.99 C5.68,58.99 2.57,55.89 2.57,52.05 L2.57,7.08 C2.57,3.24 5.68,0.14 9.51,0.14 L54.49,0.14 Z",
                        opacity: "0.01"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M15.14,19.57 C17.04,19.57 18.57,21.1 18.57,22.99 L18.57,45.57 C18.57,47.46 17.04,48.99 15.14,48.99 L6,48.99 C4.11,48.99 2.57,47.46 2.57,45.57 L2.57,22.99 C2.57,21.1 4.11,19.57 6,19.57 L15.14,19.57 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M36.57,13.85 C38.46,13.85 40,15.39 40,17.28 L40,45.57 C40,47.46 38.46,48.99 36.57,48.99 L27.43,48.99 C25.54,48.99 24,47.46 24,45.57 L24,17.28 C24,15.39 25.54,13.85 27.43,13.85 L36.57,13.85 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M58,0.14 C59.89,0.14 61.43,1.67 61.43,3.57 L61.43,45.57 C61.43,47.46 59.89,48.99 58,48.99 L48.86,48.99 C46.96,48.99 45.43,47.46 45.43,45.57 L45.43,3.57 C45.43,1.67 46.96,0.14 48.86,0.14 L58,0.14 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M61.43,54.14 C62.85,54.14 64,55.29 64,56.71 C64,58.09 62.91,59.21 61.55,59.28 L61.43,59.28 L2.57,59.28 C1.15,59.28 0,58.13 0,56.71 C0,55.33 1.09,54.2 2.45,54.14 L2.57,54.14 L61.43,54.14 Z",
                        fillRule: "nonzero",
                        opacity: "0.5"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("hnqHH", function(module, exports) {

$parcel$export(module.exports, "GraphLine", function () { return $ca694c79e1de5feb$export$ae98c6031c9cc33e; });

var $1rY3h = parcelRequire("1rY3h");
var $ca694c79e1de5feb$export$ae98c6031c9cc33e = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-content-graph line",
        width: size,
        height: size,
        viewBox: "0 0 64 64",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsx)("g", {
                fill: "currentColor",
                fillRule: "nonzero",
                children: (0, $1rY3h.jsxs)("g", {
                    children: [
                        (0, $1rY3h.jsxs)("g", {
                            children: [
                                (0, $1rY3h.jsx)("path", {
                                    d: "M19.12,5.31 C20.18,4.29 21.84,4.29 22.9,5.28 L23,5.38 L41.28,24.27 C42.34,25.36 42.31,27.1 41.22,28.15 C40.17,29.17 38.5,29.18 37.44,28.19 L37.34,28.09 L19.06,9.19 C18,8.1 18.03,6.37 19.12,5.31 Z",
                                    opacity: "0.5"
                                }),
                                (0, $1rY3h.jsx)("path", {
                                    d: "M59.51,5.31 C58.45,4.29 56.79,4.29 55.73,5.28 L55.63,5.38 L37.34,24.27 C36.29,25.36 36.32,27.1 37.41,28.15 C38.46,29.17 40.12,29.18 41.18,28.19 L41.29,28.09 L59.57,9.19 C60.62,8.1 60.6,6.37 59.51,5.31 Z",
                                    opacity: "0.5"
                                }),
                                (0, $1rY3h.jsx)("path", {
                                    d: "M22.94,5.31 C21.88,4.29 20.22,4.29 19.16,5.28 L19.06,5.38 L0.77,24.27 C-0.28,25.36 -0.25,27.1 0.84,28.15 C1.89,29.17 3.55,29.18 4.61,28.19 L4.71,28.09 L23,9.19 C24.05,8.1 24.02,6.37 22.94,5.31 Z",
                                    opacity: "0.5"
                                }),
                                (0, $1rY3h.jsx)("circle", {
                                    cx: "39.31",
                                    cy: "25.57",
                                    r: "7.00949"
                                }),
                                (0, $1rY3h.jsx)("circle", {
                                    cx: "21.03",
                                    cy: "7.29",
                                    r: "7.00949"
                                }),
                                (0, $1rY3h.jsx)("circle", {
                                    cx: "56.99",
                                    cy: "7.29",
                                    r: "7.00949"
                                })
                            ]
                        }),
                        (0, $1rY3h.jsxs)("g", {
                            transform: "translate(0.000000, 30.000000)",
                            children: [
                                (0, $1rY3h.jsx)("path", {
                                    d: "M12.29,7.03 C12.68,5.62 14.11,4.77 15.53,5.08 L15.66,5.12 L40.04,11.82 C41.5,12.22 42.36,13.73 41.96,15.19 C41.57,16.61 40.14,17.46 38.72,17.14 L38.59,17.11 L14.21,10.41 C12.75,10 11.89,8.49 12.29,7.03 Z",
                                    opacity: "0.5"
                                }),
                                (0, $1rY3h.jsx)("path", {
                                    d: "M40.87,12.21 C39.62,11.35 37.92,11.66 37.06,12.91 C36.22,14.12 36.49,15.76 37.65,16.64 L37.76,16.72 L55.43,28.91 C56.68,29.77 58.39,29.46 59.25,28.21 C60.08,27 59.81,25.36 58.66,24.48 L58.55,24.4 L40.87,12.21 Z",
                                    opacity: "0.5"
                                }),
                                (0, $1rY3h.jsx)("path", {
                                    d: "M16.42,5.46 C15.19,4.66 13.55,4.98 12.71,6.16 L12.63,6.27 L0.44,25.17 C-0.38,26.44 -0.02,28.14 1.26,28.96 C2.49,29.76 4.12,29.44 4.97,28.26 L5.05,28.14 L17.24,9.25 C18.06,7.97 17.69,6.28 16.42,5.46 Z",
                                    opacity: "0.5"
                                }),
                                (0, $1rY3h.jsx)("circle", {
                                    cx: "39.31",
                                    cy: "13.86",
                                    r: "7.00949"
                                }),
                                (0, $1rY3h.jsx)("circle", {
                                    cx: "14.93",
                                    cy: "7.76",
                                    r: "7.00949"
                                }),
                                (0, $1rY3h.jsx)("circle", {
                                    cx: "56.99",
                                    cy: "26.05",
                                    r: "7.00949"
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};

});

parcelRegister("6dHHN", function(module, exports) {

$parcel$export(module.exports, "GraphPie", function () { return $4875dbf44496e592$export$24bf33cf8b203ff6; });

var $1rY3h = parcelRequire("1rY3h");
var $4875dbf44496e592$export$24bf33cf8b203ff6 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-content-graph pie",
        width: size,
        height: size,
        viewBox: "0 0 59 60",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsx)("g", {
                fill: "currentColor",
                children: (0, $1rY3h.jsx)("path", {
                    d: "M29.42,0.22 C13.17,0.22 0,13.39 0,29.64 C0,45.89 13.17,59.06 29.42,59.06 C45.67,59.06 58.84,45.89 58.84,29.64 C58.84,13.39 45.67,0.22 29.42,0.22 Z M58.84,29.64 C58.84,13.39 45.67,0.22 29.42,0.22 L29.42,29.64 L58.84,29.64 Z"
                })
            })
        })
    });
};

});

parcelRegister("hEfAB", function(module, exports) {

$parcel$export(module.exports, "Hive", function () { return $cd9243ccf1252172$export$a2a93e4baf52ad39; });

var $1rY3h = parcelRequire("1rY3h");
var $cd9243ccf1252172$export$a2a93e4baf52ad39 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-content-hive",
        width: size,
        height: size,
        viewBox: "0 0 64 62",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M46.39,30.75 C48.23,29.69 50.5,29.69 52.34,30.75 L61.02,35.75 C62.86,36.81 64,38.78 64,40.91 L64,50.9 C64,53.02 62.86,54.99 61.02,56.05 L52.34,61.06 C50.5,62.12 48.23,62.12 46.39,61.06 L37.71,56.05 C35.87,54.99 34.73,53.02 34.73,50.9 L34.73,40.91 C34.73,38.78 35.87,36.81 37.71,35.75 L46.39,30.75 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M11.66,30.75 C13.5,29.69 15.77,29.69 17.61,30.75 L26.29,35.75 C28.13,36.81 29.27,38.78 29.27,40.91 L29.27,50.9 C29.27,53.02 28.13,54.99 26.29,56.05 L17.61,61.06 C15.77,62.12 13.5,62.12 11.66,61.06 L2.98,56.05 C1.14,54.99 0,53.02 0,50.9 L0,40.91 C0,38.78 1.14,36.81 2.98,35.75 L11.66,30.75 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M29.03,0.98 C30.87,-0.08 33.13,-0.08 34.97,0.98 L43.65,5.98 C45.5,7.04 46.64,9.01 46.64,11.14 L46.64,21.13 C46.64,23.26 45.5,25.22 43.65,26.29 L34.97,31.29 C33.13,32.35 30.87,32.35 29.03,31.29 L20.35,26.29 C18.5,25.22 17.36,23.26 17.36,21.13 L17.36,11.14 C17.36,9.01 18.5,7.04 20.35,5.98 L29.03,0.98 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("cJdRZ", function(module, exports) {

$parcel$export(module.exports, "Link", function () { return $94447247b6c367ea$export$a6c7ac8248d6e38a; });

var $1rY3h = parcelRequire("1rY3h");
var $94447247b6c367ea$export$a6c7ac8248d6e38a = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-content-link",
        width: size,
        height: size,
        viewBox: "0 0 77 36",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsx)("g", {
                fill: "currentColor",
                fillRule: "nonzero",
                children: (0, $1rY3h.jsxs)("g", {
                    children: [
                        (0, $1rY3h.jsx)("path", {
                            d: "M59.11,0.37993896 C68.78,0.45 76.66,8.33 76.730476,18 C76.8,27.59 69.14,35.35 59.58,35.44 L59.29,35.44 L44.47,35.35 C34.81,35.28 26.93,27.4 26.8599385,17.73 C26.85,16.23 28.06,15 29.57,14.99 C31.07,14.98 32.3,16.19 32.31,17.69 C32.36,24.3 37.7,29.72 44.28,29.89 L44.51,29.89 L59.32,29.99 C65.98,30.03 71.32,24.69 71.28,18.03 C71.23,11.35 65.76,5.88 59.08,5.84 C57.57,5.83 56.36,4.6 56.37,3.09 C56.38,1.59 57.61,0.37 59.11,0.37993896 Z"
                        }),
                        (0, $1rY3h.jsx)("path", {
                            d: "M32.51,0.77 C42.18,0.84 50.06,8.72 50.130061,18.39 C50.14,19.89 48.92,21.12 47.42,21.13 C45.91,21.14 44.68,19.93 44.67,18.42 C44.63,11.81 39.29,6.4 32.7,6.23 L32.47,6.22 L17.68,6.12 C11.02,6.07 5.67,11.42 5.72,18.08 C5.76,24.69 11.1,30.11 17.68,30.28 L17.86,30.28 L20.89,30.16 C22.35,30.1 23.59,31.19 23.72,32.63 L23.73,32.77 C23.79,34.23 22.69,35.46 21.26,35.6 L21.12,35.61 L18.01,35.73 L17.88,35.73 C8.21,35.67 0.33,27.79 0.259649917,18.12 C0.2,8.52 7.86,0.76 17.43,0.67 L17.72,0.67 L32.51,0.77 Z"
                        })
                    ]
                })
            })
        })
    });
};

});

parcelRegister("kgLUC", function(module, exports) {

$parcel$export(module.exports, "List", function () { return $ec1a779efc82bcf6$export$54c2e3dc7acea9f5; });

var $1rY3h = parcelRequire("1rY3h");
var $ec1a779efc82bcf6$export$54c2e3dc7acea9f5 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-content-list",
        width: size,
        height: size,
        viewBox: "0 0 64 54",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsx)("g", {
                fill: "currentColor",
                fillRule: "nonzero",
                children: (0, $1rY3h.jsxs)("g", {
                    children: [
                        (0, $1rY3h.jsx)("path", {
                            d: "M61.43,44.63 C62.85,44.63 64,45.78 64,47.2 C64,48.58 62.91,49.71 61.55,49.77 L61.43,49.77 L24.86,49.77 C23.44,49.77 22.29,48.62 22.29,47.2 C22.29,45.82 23.37,44.69 24.74,44.63 L24.86,44.63 L61.43,44.63 Z",
                            opacity: "0.5"
                        }),
                        (0, $1rY3h.jsx)("circle", {
                            cx: "6.86",
                            cy: "46.92",
                            r: "6.85714"
                        }),
                        (0, $1rY3h.jsx)("path", {
                            d: "M61.43,4.63 C62.85,4.63 64,5.78 64,7.2 C64,8.58 62.91,9.71 61.55,9.77 L61.43,9.77 L24.86,9.77 C23.44,9.77 22.29,8.62 22.29,7.2 C22.29,5.82 23.37,4.69 24.74,4.63 L24.86,4.63 L61.43,4.63 Z",
                            opacity: "0.5"
                        }),
                        (0, $1rY3h.jsx)("circle", {
                            cx: "6.86",
                            cy: "6.92",
                            r: "6.85714"
                        }),
                        (0, $1rY3h.jsx)("path", {
                            d: "M61.43,24.63 C62.85,24.63 64,25.78 64,27.2 C64,28.58 62.91,29.71 61.55,29.77 L61.43,29.77 L24.86,29.77 C23.44,29.77 22.29,28.62 22.29,27.2 C22.29,25.82 23.37,24.69 24.74,24.63 L24.86,24.63 L61.43,24.63 Z",
                            opacity: "0.5"
                        }),
                        (0, $1rY3h.jsx)("circle", {
                            cx: "6.86",
                            cy: "26.92",
                            r: "6.85714"
                        })
                    ]
                })
            })
        })
    });
};

});

parcelRegister("j2AWN", function(module, exports) {

$parcel$export(module.exports, "Map", function () { return $ddcadd2dd87da65a$export$a5c7b93649eaf8f8; });

var $1rY3h = parcelRequire("1rY3h");
var $ddcadd2dd87da65a$export$a5c7b93649eaf8f8 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-content-map pin",
        width: size,
        height: size,
        viewBox: "0 0 50 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("g", {
                        transform: "translate(21.000000, 0.000000)",
                        opacity: "0.5",
                        children: (0, $1rY3h.jsx)("path", {
                            d: "M20.21,4.24 C15.59,-0.38 8.1,-0.38 3.48,4.24 C-1.14,8.86 -1.14,16.35 3.48,20.98 L9.39,26.89 C10.75,28.24 12.94,28.24 14.3,26.89 L20.21,20.98 C24.84,16.35 24.84,8.86 20.21,4.24 Z M11.85,17.2 C14.38,17.2 16.43,15.14 16.43,12.61 C16.43,10.07 14.38,8.02 11.85,8.02 C9.31,8.02 7.26,10.07 7.26,12.61 C7.26,15.14 9.31,17.2 11.85,17.2 Z"
                        })
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M6.94,15.02 L21.26,15.02 C21.71,17.21 22.78,19.28 24.48,20.98 L30.39,26.89 C31.75,28.25 33.94,28.25 35.3,26.89 L41.21,20.98 C42.86,19.33 43.92,17.32 44.39,15.2 C47.46,15.92 49.75,18.67 49.75,21.96 L49.75,57.83 C49.75,61.67 46.64,64.77 42.81,64.77 L35.02,64.77 L35.02,42.07 L49.75,42.07 L49.75,37.73 L17.63,37.73 L17.63,15.02 L13.28,15.02 L13.28,64.77 L6.94,64.77 C3.11,64.77 0,61.67 0,57.83 L0,21.96 C0,18.13 3.11,15.02 6.94,15.02 Z M30.67,64.77 L30.67,42.07 L17.63,42.07 L17.63,64.77 L30.67,64.77 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M21.26,15.02 L5.8,15.02 C2.6,15.02 0,17.62 0,20.82 L0,58.98 C0,62.18 2.6,64.77 5.8,64.77 L43.95,64.77 C47.16,64.77 49.75,62.18 49.75,58.98 L49.75,20.82 C49.75,17.78 47.41,15.28 44.43,15.04 C43.97,17.22 42.9,19.29 41.21,20.98 L34.89,27.3 C33.76,28.43 31.93,28.43 30.8,27.3 L24.48,20.98 C22.78,19.28 21.71,17.21 21.26,15.02 Z",
                        opacity: "0.5"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("dSNCm", function(module, exports) {

$parcel$export(module.exports, "MapPin", function () { return $a1b6ce889b58892c$export$cadbb3a6d7f856e2; });

var $1rY3h = parcelRequire("1rY3h");
var $a1b6ce889b58892c$export$cadbb3a6d7f856e2 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-content-map pin",
        width: size,
        height: size,
        viewBox: "0 0 50 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("g", {
                        transform: "translate(21.000000, 0.000000)",
                        opacity: "0.5",
                        children: (0, $1rY3h.jsx)("path", {
                            d: "M20.21,4.24 C15.59,-0.38 8.1,-0.38 3.48,4.24 C-1.14,8.86 -1.14,16.35 3.48,20.98 L9.39,26.89 C10.75,28.24 12.94,28.24 14.3,26.89 L20.21,20.98 C24.84,16.35 24.84,8.86 20.21,4.24 Z M11.85,17.2 C14.38,17.2 16.43,15.14 16.43,12.61 C16.43,10.07 14.38,8.02 11.85,8.02 C9.31,8.02 7.26,10.07 7.26,12.61 C7.26,15.14 9.31,17.2 11.85,17.2 Z"
                        })
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M6.94,15.02 L21.26,15.02 C21.71,17.21 22.78,19.28 24.48,20.98 L30.39,26.89 C31.75,28.25 33.94,28.25 35.3,26.89 L41.21,20.98 C42.86,19.33 43.92,17.32 44.39,15.2 C47.46,15.92 49.75,18.67 49.75,21.96 L49.75,57.83 C49.75,61.67 46.64,64.77 42.81,64.77 L35.02,64.77 L35.02,42.07 L49.75,42.07 L49.75,37.73 L17.63,37.73 L17.63,15.02 L13.28,15.02 L13.28,64.77 L6.94,64.77 C3.11,64.77 0,61.67 0,57.83 L0,21.96 C0,18.13 3.11,15.02 6.94,15.02 Z M30.67,64.77 L30.67,42.07 L17.63,42.07 L17.63,64.77 L30.67,64.77 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M21.26,15.02 L5.8,15.02 C2.6,15.02 0,17.62 0,20.82 L0,58.98 C0,62.18 2.6,64.77 5.8,64.77 L43.95,64.77 C47.16,64.77 49.75,62.18 49.75,58.98 L49.75,20.82 C49.75,17.78 47.41,15.28 44.43,15.04 C43.97,17.22 42.9,19.29 41.21,20.98 L34.89,27.3 C33.76,28.43 31.93,28.43 30.8,27.3 L24.48,20.98 C22.78,19.28 21.71,17.21 21.26,15.02 Z",
                        opacity: "0.5"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("iYhKo", function(module, exports) {

$parcel$export(module.exports, "Maximize", function () { return $dcfb98d04cb51f34$export$641c2d00a5a05a3e; });

var $1rY3h = parcelRequire("1rY3h");
var $dcfb98d04cb51f34$export$641c2d00a5a05a3e = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-content-maximize",
        width: size,
        height: size,
        viewBox: "0 0 64 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M56.54,0.18 C60.66,0.18 64,3.52 64,7.64 L64,56.73 C64,60.85 60.66,64.18 56.54,64.18 L7.46,64.18 L7.42,64.18 L25.37,64.18 C29.2,64.18 32.31,61.08 32.31,57.24 L32.31,38.81 C32.31,38 32.17,37.21 31.91,36.49 L48.79,19.61 L48.79,26.83 L48.79,26.98 C48.86,28.45 50.09,29.63 51.58,29.63 C53.13,29.63 54.38,28.38 54.38,26.83 L54.38,12.54 L54.37,12.39 C54.3,10.92 53.08,9.74 51.58,9.74 L36.85,9.74 L36.7,9.75 C35.23,9.82 34.05,11.04 34.05,12.54 L34.06,12.68 C34.13,14.16 35.35,15.33 36.85,15.33 L45.15,15.33 L28.07,32.42 C27.24,32.07 26.33,31.87 25.37,31.87 L6.94,31.87 C3.11,31.87 0,34.98 0,38.81 L0,7.64 C0,3.52 3.34,0.18 7.46,0.18 L56.54,0.18 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M24.85,31.87 C25.96,31.87 27,32.11 27.95,32.54 L14,46.49 L13.91,46.58 C12.91,47.68 12.94,49.38 14,50.44 C15.09,51.53 16.86,51.53 17.96,50.44 L31.8,36.6 C32.13,37.45 32.31,38.37 32.31,39.33 L32.31,56.73 C32.31,60.85 28.97,64.18 24.85,64.18 L7.46,64.18 C3.34,64.18 0,60.85 0,56.73 L0,39.33 C0,35.21 3.34,31.87 7.46,31.87 L24.85,31.87 Z",
                        opacity: "0.5"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("1ZVrE", function(module, exports) {

$parcel$export(module.exports, "Message", function () { return $17480c54f6fb741d$export$f69c19e57285b83a; });

var $1rY3h = parcelRequire("1rY3h");
var $17480c54f6fb741d$export$f69c19e57285b83a = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-content-message",
        width: size,
        height: size,
        viewBox: "0 0 64 62",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsx)("g", {
                fill: "currentColor",
                children: (0, $1rY3h.jsx)("path", {
                    d: "M64,8.23 C64,4.11 60.66,0.77 56.54,0.77 L7.46,0.77 C3.34,0.77 0,4.11 0,8.23 L0,44.89 C0,49.01 3.34,52.35 7.46,52.35 L21.35,52.35 L29.36,60.36 C30.82,61.82 33.18,61.82 34.64,60.36 L42.65,52.35 L56.54,52.35 C60.66,52.35 64,49.01 64,44.89 L64,8.23 Z M44.12,17.55 C45.66,17.55 46.91,18.8 46.91,20.35 C46.91,21.85 45.73,23.07 44.25,23.14 L44.12,23.14 L19.88,23.14 C18.34,23.14 17.09,21.89 17.09,20.35 C17.09,18.85 18.27,17.62 19.75,17.55 L19.88,17.55 L44.12,17.55 Z M34.49,32.77 C34.49,31.23 33.23,29.98 31.69,29.98 L19.88,29.98 L19.75,29.98 C18.27,30.05 17.09,31.27 17.09,32.77 C17.09,34.32 18.34,35.57 19.88,35.57 L31.69,35.57 L31.82,35.57 C33.3,35.5 34.49,34.27 34.49,32.77 Z"
                })
            })
        })
    });
};

});

parcelRegister("89NJj", function(module, exports) {

$parcel$export(module.exports, "OrgChart", function () { return $5f05bd51551a4b36$export$8929951f37b9096e; });

var $1rY3h = parcelRequire("1rY3h");
var $5f05bd51551a4b36$export$8929951f37b9096e = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-content-org chart",
        width: size,
        height: size,
        viewBox: "0 0 59 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("g", {
                        transform: "translate(6.000000, 6.000000)",
                        opacity: "0.5",
                        children: (0, $1rY3h.jsx)("path", {
                            d: "M26,3.3 C25.93,1.9 24.81,0.9 23.43,0.9 C22.01,0.9 20.86,2 20.86,3.4 L20.86,24.3 L9.43,24.3 L9.25,24.3 C4.12,24.4 0,28.6 0,33.7 L0,50.3 L0,50.4 C0.07,51.8 1.19,52.9 2.57,52.9 C3.99,52.9 5.14,51.7 5.14,50.3 L5.14,33.7 L5.15,33.6 C5.22,31.3 7.11,29.4 9.43,29.4 L20.86,29.4 L20.86,50.3 L20.86,50.4 C20.92,51.8 22.05,52.9 23.43,52.9 C24.85,52.9 26,51.7 26,50.3 L26,29.4 L37.43,29.4 L37.57,29.4 C39.87,29.5 41.71,31.4 41.71,33.7 L41.71,50.3 L41.72,50.4 C41.78,51.8 42.91,52.9 44.29,52.9 C45.71,52.9 46.86,51.7 46.86,50.3 L46.86,33.7 L46.86,33.5 C46.76,28.4 42.57,24.3 37.43,24.3 L26,24.3 L26,3.4 L26,3.3 Z"
                        })
                    }),
                    (0, $1rY3h.jsxs)("g", {
                        children: [
                            (0, $1rY3h.jsx)("path", {
                                d: "M55.43,0.9 C57.32,0.9 58.86,2.4 58.86,4.3 L58.86,14.6 C58.86,16.5 57.32,18 55.43,18 L3.43,18 C1.54,18 0,16.5 0,14.6 L0,4.3 C0,2.4 1.54,0.9 3.43,0.9 L55.43,0.9 Z"
                            }),
                            (0, $1rY3h.jsx)("path", {
                                d: "M0,51.1 C0,49.2 1.54,47.7 3.43,47.7 L13.71,47.7 C15.61,47.7 17.14,49.2 17.14,51.1 L17.14,61.4 C17.14,63.3 15.61,64.9 13.71,64.9 L3.43,64.9 C1.54,64.9 0,63.3 0,61.4 L0,51.1 Z",
                                fillRule: "nonzero"
                            }),
                            (0, $1rY3h.jsx)("path", {
                                d: "M41.71,51.1 C41.71,49.2 43.25,47.7 45.14,47.7 L55.43,47.7 C57.32,47.7 58.86,49.2 58.86,51.1 L58.86,61.4 C58.86,63.3 57.32,64.9 55.43,64.9 L45.14,64.9 C43.25,64.9 41.71,63.3 41.71,61.4 L41.71,51.1 Z",
                                fillRule: "nonzero"
                            }),
                            (0, $1rY3h.jsx)("path", {
                                d: "M20.86,51.1 C20.86,49.2 22.39,47.7 24.29,47.7 L34.57,47.7 C36.46,47.7 38,49.2 38,51.1 L38,61.4 C38,63.3 36.46,64.9 34.57,64.9 L24.29,64.9 C22.39,64.9 20.86,63.3 20.86,61.4 L20.86,51.1 Z",
                                fillRule: "nonzero"
                            })
                        ]
                    })
                ]
            })
        })
    });
};

});

parcelRegister("4lWxZ", function(module, exports) {

$parcel$export(module.exports, "Page", function () { return $32b689d6430b764e$export$6955bcca4cd3539f; });

var $1rY3h = parcelRequire("1rY3h");
var $32b689d6430b764e$export$6955bcca4cd3539f = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-content-page",
        width: size,
        height: size,
        viewBox: "0 0 52 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M44.12,64.46 C48.23,64.46 51.57,61.12 51.57,57 L51.57,15.99 L51.57,15.99 L36.04,15.99 L36.04,0.46 L7.46,0.46 C3.34,0.46 0,3.8 0,7.91 L0,57 C0,61.12 3.34,64.46 7.46,64.46 L44.12,64.46 Z M42.56,25.62 C42.56,24.08 41.31,22.83 39.77,22.83 L12.43,22.83 L12.3,22.83 C10.81,22.9 9.63,24.12 9.63,25.62 C9.63,27.17 10.88,28.42 12.43,28.42 L39.77,28.42 L39.9,28.42 C41.38,28.35 42.56,27.12 42.56,25.62 Z M26.1,37.12 C27.64,37.12 28.89,38.37 28.89,39.91 C28.89,41.41 27.71,42.64 26.23,42.71 L26.1,42.71 L12.43,42.71 C10.88,42.71 9.63,41.46 9.63,39.91 C9.63,38.41 10.81,37.19 12.3,37.12 L12.43,37.12 L26.1,37.12 Z"
                    }),
                    (0, $1rY3h.jsx)("polygon", {
                        opacity: "0.5",
                        points: "51.57 15.99 36.04 15.99 36.04 0.46"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("cVIPN", function(module, exports) {

$parcel$export(module.exports, "PageMultiple", function () { return $969d961cc75c0ed3$export$23b02afe38134aca; });

var $1rY3h = parcelRequire("1rY3h");
var $969d961cc75c0ed3$export$23b02afe38134aca = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-content-page multiple",
        width: size,
        height: size,
        viewBox: "0 0 64 77",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("g", {
                        transform: "translate(49.000000, 0.000000)",
                        children: (0, $1rY3h.jsx)("polygon", {
                            points: "15 15.27 0.19 15.27 0.19 0.46"
                        })
                    }),
                    (0, $1rY3h.jsxs)("g", {
                        children: [
                            (0, $1rY3h.jsx)("path", {
                                d: "M42.07,76.31 C46,76.31 49.19,73.13 49.19,69.2 L49.19,30.09 L34.37,15.27 L7.11,15.27 C3.18,15.27 0,18.46 0,22.38 L0,69.2 C0,73.13 3.18,76.31 7.11,76.31 L42.07,76.31 Z M40.59,39.27 C40.59,37.8 39.4,36.61 37.93,36.61 L11.85,36.61 L11.73,36.61 C10.31,36.67 9.19,37.84 9.19,39.27 C9.19,40.75 10.38,41.94 11.85,41.94 L37.93,41.94 L38.05,41.94 C39.47,41.87 40.59,40.7 40.59,39.27 Z M24.89,50.24 C26.36,50.24 27.56,51.43 27.56,52.9 C27.56,54.33 26.43,55.5 25.01,55.57 L24.89,55.57 L11.85,55.57 C10.38,55.57 9.19,54.38 9.19,52.9 C9.19,51.47 10.31,50.3 11.73,50.24 L11.85,50.24 L24.89,50.24 Z M34.37,30.09 L49.19,30.09 L34.37,15.27 L34.37,30.09 Z"
                            }),
                            (0, $1rY3h.jsx)("path", {
                                d: "M56.89,61.49 C60.82,61.49 64,58.31 64,54.38 L64,15.27 L49.18,0.46 L21.93,0.46 C18,0.46 14.81,3.64 14.81,7.57 L14.81,33.64 L43.26,33.64 L43.26,61.49 L56.89,61.49 Z M34.37,30.09 L49.18,30.09 L34.37,15.27 L34.37,30.09 Z",
                                opacity: "0.5"
                            })
                        ]
                    })
                ]
            })
        })
    });
};

});

parcelRegister("cruFA", function(module, exports) {

$parcel$export(module.exports, "PageRefresh", function () { return $90efcc0a868e844b$export$f9943ebbfe9323c8; });

var $1rY3h = parcelRequire("1rY3h");
var $90efcc0a868e844b$export$f9943ebbfe9323c8 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-content-page refresh",
        width: size,
        height: size,
        viewBox: "0 0 52 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M51.57,56.85 C51.57,60.97 48.23,64.31 44.12,64.31 L7.46,64.31 C3.34,64.31 0,60.97 0,56.85 L0,7.76 C0,3.65 3.34,0.31 7.46,0.31 L36.04,0.31 L36.04,0.31 L36.04,15.84 L51.57,15.84 L51.57,56.85 Z M40.7,35.33 C40.7,27.27 34.16,20.73 26.1,20.73 L24.77,20.73 L25.59,19.91 L25.68,19.81 C26.68,18.72 26.65,17.02 25.59,15.96 C24.5,14.86 22.73,14.86 21.63,15.96 L16.04,21.55 L15.95,21.64 C14.95,22.74 14.98,24.44 16.04,25.5 L21.63,31.09 L21.73,31.19 C22.83,32.19 24.53,32.16 25.59,31.09 L25.68,31 C26.68,29.9 26.65,28.2 25.59,27.14 L24.77,26.32 L26.1,26.32 L26.29,26.32 C31.18,26.43 35.11,30.42 35.11,35.33 L35.11,35.46 C35.18,36.95 36.4,38.13 37.9,38.13 C39.45,38.13 40.7,36.88 40.7,35.33 Z M17.09,35.33 C17.09,33.79 15.84,32.54 14.29,32.54 C12.75,32.54 11.5,33.79 11.5,35.33 C11.5,43.02 17.44,49.32 24.98,49.89 L24.12,50.75 C23.06,51.81 23.03,53.51 24.03,54.61 L24.12,54.71 C25.18,55.77 26.88,55.8 27.98,54.8 L28.07,54.71 L33.67,49.11 C34.73,48.05 34.76,46.35 33.76,45.25 L33.67,45.16 L28.07,39.57 C26.98,38.48 25.21,38.48 24.12,39.57 C23.06,40.63 23.03,42.33 24.03,43.43 L24.12,43.52 L24.85,44.26 C20.47,43.65 17.09,39.89 17.09,35.33 Z"
                    }),
                    (0, $1rY3h.jsx)("polygon", {
                        opacity: "0.5",
                        points: "51.57 15.84 36.04 15.84 36.04 0.31"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("gjryf", function(module, exports) {

$parcel$export(module.exports, "PageTree", function () { return $be03cacf3e6f8401$export$73500bf5f2e2b0c4; });

var $1rY3h = parcelRequire("1rY3h");
var $be03cacf3e6f8401$export$73500bf5f2e2b0c4 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-content-page tree",
        width: size,
        height: size,
        viewBox: "0 0 50 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsxs)("g", {
                        transform: "translate(25.000000, 0.000000)",
                        children: [
                            (0, $1rY3h.jsxs)("g", {
                                children: [
                                    (0, $1rY3h.jsx)("path", {
                                        d: "M17.17,0.59 L4.07,0.59 C2.19,0.59 0.66,2.12 0.66,4.01 L0.66,26.5 C0.66,28.38 2.19,29.91 4.07,29.91 L20.87,29.91 C22.75,29.91 24.28,28.38 24.28,26.5 L24.28,7.71 L24.28,7.71 L17.17,7.71 L17.17,0.59 Z"
                                    }),
                                    (0, $1rY3h.jsx)("polygon", {
                                        opacity: "0.5",
                                        points: "24.28 7.71 17.17 7.71 17.17 0.59"
                                    })
                                ]
                            }),
                            (0, $1rY3h.jsxs)("g", {
                                transform: "translate(0.000000, 34.000000)",
                                children: [
                                    (0, $1rY3h.jsx)("path", {
                                        d: "M17.17,0.99 L17.17,0.99 L4.07,0.99 C2.19,0.99 0.66,2.52 0.66,4.4 L0.66,26.89 C0.66,28.78 2.19,30.31 4.07,30.31 L20.87,30.31 C22.75,30.31 24.28,28.78 24.28,26.89 L24.28,8.1 L24.28,8.1 L17.17,8.1 L17.17,0.99 Z"
                                    }),
                                    (0, $1rY3h.jsx)("polygon", {
                                        opacity: "0.5",
                                        points: "24.28 8.1 17.17 8.1 17.17 0.99"
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M5.07,2.73 C5.01,1.38 3.9,0.31 2.54,0.31 C1.14,0.31 0,1.44 0,2.85 L0,14.69 L0,14.69 L0,43.73 L0,43.91 C0.1,48.96 4.23,53.03 9.3,53.03 L18.04,53.03 L18.16,53.03 C19.51,52.97 20.58,51.85 20.58,50.49 C20.58,49.09 19.45,47.96 18.04,47.96 L9.3,47.96 L9.17,47.95 C6.89,47.88 5.07,46.02 5.07,43.73 L5.07,17.22 L18.04,17.22 L18.16,17.22 C19.51,17.16 20.58,16.05 20.58,14.69 C20.58,13.29 19.45,12.15 18.04,12.15 L5.07,12.15 L5.07,2.85 L5.07,2.73 Z",
                        opacity: "0.5"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("7WpHj", function(module, exports) {

$parcel$export(module.exports, "Process", function () { return $5c81e230c4e01513$export$ddab65ae98aaa487; });

var $1rY3h = parcelRequire("1rY3h");
var $5c81e230c4e01513$export$ddab65ae98aaa487 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-content-process",
        width: size,
        height: size,
        viewBox: "0 0 87 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M86.86,16.1 C86.76,11 82.57,6.9 77.43,6.9 L43.71,6.9 L43.59,6.9 C42.23,6.9 41.14,8 41.14,9.4 C41.14,10.8 42.29,12 43.71,12 L77.43,12 L77.57,12 C79.87,12.1 81.71,14 81.71,16.3 L81.71,26 L81.71,26.1 C81.64,28.4 79.75,30.3 77.43,30.3 L72.86,30.3 L72.86,27.7 C72.86,25.8 71.32,24.3 69.43,24.3 L17.43,24.3 C15.54,24.3 14,25.8 14,27.7 L14,30.3 L9.43,30.3 L9.25,30.3 C4.12,30.4 0,34.6 0,39.7 L0,49.4 L0,49.6 C0.1,54.7 4.28,58.9 9.43,58.9 L43.43,58.9 L43.55,58.9 C44.91,58.8 46,57.7 46,56.3 C46,54.9 44.85,53.7 43.43,53.7 L9.43,53.7 L9.29,53.7 C6.99,53.6 5.14,51.7 5.14,49.4 L5.14,39.7 L5.15,39.6 C5.22,37.3 7.11,35.4 9.43,35.4 L14,35.4 L14,38 C14,39.9 15.54,41.4 17.43,41.4 L69.43,41.4 C71.32,41.4 72.86,39.9 72.86,38 L72.86,35.4 L77.43,35.4 L77.61,35.4 C82.73,35.3 86.86,31.1 86.86,26 L86.86,16.3 L86.86,16.1 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M69.43,47.7 C71.32,47.7 72.86,49.2 72.86,51.1 L72.86,61.4 C72.86,63.3 71.32,64.9 69.43,64.9 L17.43,64.9 C15.54,64.9 14,63.3 14,61.4 L14,51.1 C14,49.2 15.54,47.7 17.43,47.7 L69.43,47.7 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M69.43,0.9 C71.32,0.9 72.86,2.4 72.86,4.3 L72.86,14.6 C72.86,16.5 71.32,18 69.43,18 L17.43,18 C15.54,18 14,16.5 14,14.6 L14,4.3 C14,2.4 15.54,0.9 17.43,0.9 L69.43,0.9 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("2ho8t", function(module, exports) {

$parcel$export(module.exports, "Rss", function () { return $1a8fe423addab9ef$export$931c8cb50984cb09; });

var $1rY3h = parcelRequire("1rY3h");
var $1a8fe423addab9ef$export$931c8cb50984cb09 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-content-rss",
        width: size,
        height: size,
        viewBox: "0 0 64 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M4.55,0.31 C37.06,0.31 63.47,26.4 63.99,58.77 L64,59.76 L64,61.46 C64,62.88 62.85,64.02 61.44,64.02 C60.07,64.02 58.95,62.94 58.88,61.58 L58.88,61.46 L58.88,59.76 C58.88,30.05 35.04,5.92 5.45,5.44 L4.55,5.43 L2.84,5.43 C1.43,5.43 0.28,4.28 0.28,2.87 C0.28,1.5 1.37,0.37 2.72,0.31 L2.84,0.31 L4.55,0.31 Z",
                        fillRule: "nonzero"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M2.84,23.63 C23.74,23.63 40.68,40.57 40.68,61.46 C40.68,62.88 39.53,64.02 38.12,64.02 C36.7,64.02 35.56,62.88 35.56,61.46 C35.56,43.4 20.91,28.75 2.84,28.75 C1.43,28.75 0.28,27.61 0.28,26.19 C0.28,24.78 1.43,23.63 2.84,23.63 Z",
                        fillRule: "nonzero"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M6.83,50.09 C10.6,50.09 13.65,53.14 13.65,56.91 C13.65,60.68 10.6,63.74 6.83,63.74 C3.06,63.74 0,60.68 0,56.91 C0,53.14 3.06,50.09 6.83,50.09 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("fgpyD", function(module, exports) {

$parcel$export(module.exports, "SmileyFace", function () { return $b1cc2cdc27dec8aa$export$ce49b7e1855b43f5; });

var $1rY3h = parcelRequire("1rY3h");
var $b1cc2cdc27dec8aa$export$ce49b7e1855b43f5 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-content-smiley face",
        width: size,
        height: size,
        viewBox: "0 0 64 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M0,32.02 C0,14.35 14.33,0.02 32,0.02 C49.67,0.02 64,14.35 64,32.02 C64,49.7 49.67,64.02 32,64.02 C14.33,64.02 0,49.7 0,32.02 Z M58.99,32.02 C58.99,17.12 46.91,5.03 32,5.03 C17.09,5.03 5.01,17.12 5.01,32.02 C5.01,46.93 17.09,59.01 32,59.01 C46.91,59.01 58.99,46.93 58.99,32.02 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M16.5,34.96 C17.8,34.48 19.24,35.15 19.71,36.45 C21.53,41.42 26.42,44.82 32,44.82 C37.58,44.82 42.47,41.42 44.29,36.46 C44.77,35.16 46.2,34.49 47.5,34.97 C48.8,35.45 49.47,36.89 48.99,38.18 C46.45,45.12 39.68,49.83 32,49.83 C24.32,49.83 17.55,45.12 15.01,38.17 C14.53,36.87 15.2,35.43 16.5,34.96 Z",
                        fillRule: "nonzero"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M26.43,24.51 C26.43,27.12 24.32,29.24 21.7,29.24 C19.09,29.24 16.97,27.12 16.97,24.51 C16.97,21.9 19.09,19.78 21.7,19.78 C24.32,19.78 26.43,21.9 26.43,24.51 Z",
                        fillRule: "nonzero"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M47.58,24.51 C47.58,27.12 45.46,29.24 42.85,29.24 C40.24,29.24 38.12,27.12 38.12,24.51 C38.12,21.9 40.24,19.78 42.85,19.78 C45.46,19.78 47.58,21.9 47.58,24.51 Z",
                        fillRule: "nonzero"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("iY3Qo", function(module, exports) {

$parcel$export(module.exports, "Translate", function () { return $dcf0cfed5f9c65f5$export$9db2ba50894db2b9; });

var $1rY3h = parcelRequire("1rY3h");
var $dcf0cfed5f9c65f5$export$9db2ba50894db2b9 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-content-translate",
        width: size,
        height: size,
        viewBox: "0 0 62 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsxs)("g", {
                        children: [
                            (0, $1rY3h.jsx)("path", {
                                d: "M54.73,0.03 C54.7,0.03 54.68,0.03 54.66,0.03 L30.95,0.03 L30.95,49.43 L18.45,49.43 L6.03,63.04 C3.9,65.39 0,63.88 0,60.71 L0,6.96 C0,3.13 3.11,0.02 6.94,0.02 L54.37,0.02 C54.49,0.02 54.61,0.03 54.73,0.03 Z M6.64,37.31 C7.96,37.88 9.49,37.31 10.11,36.04 L10.17,35.92 L10.76,34.55 L20.19,34.55 L20.78,35.92 C21.37,37.28 22.95,37.9 24.31,37.31 C25.62,36.74 26.25,35.23 25.74,33.9 L25.7,33.78 L17.93,15.93 C17.77,15.56 17.54,15.24 17.25,14.99 C17.11,14.87 16.96,14.76 16.79,14.66 C16.68,14.6 16.56,14.54 16.44,14.5 C15.8,14.25 15.11,14.27 14.51,14.5 C14.39,14.54 14.28,14.6 14.16,14.66 C13.99,14.76 13.83,14.87 13.69,15 C13.44,15.22 13.23,15.49 13.07,15.81 L13.07,15.81 C13.05,15.85 13.04,15.89 13.02,15.92 L13.02,15.93 L5.26,33.78 C4.67,35.14 5.29,36.72 6.64,37.31 Z M15.48,23.71 L13.09,29.2 L17.86,29.2 L15.48,23.71 Z"
                            }),
                            (0, $1rY3h.jsx)("path", {
                                d: "M54.46,0.03 C58.41,0.03 61.6,3.23 61.6,7.18 L61.6,42.29 C61.6,46.24 58.41,49.44 54.46,49.44 L30.95,49.44 L30.95,0.03 L54.46,0.03 Z",
                                opacity: "0.5"
                            })
                        ]
                    }),
                    (0, $1rY3h.jsxs)("g", {
                        transform: "translate(35.000000, 10.000000)",
                        fillRule: "nonzero",
                        children: [
                            (0, $1rY3h.jsx)("path", {
                                d: "M18.59,4.32 C20.07,4.32 21.27,5.52 21.27,7 C21.27,8.43 20.14,9.61 18.72,9.67 L18.59,9.67 L3.07,9.67 C1.59,9.67 0.39,8.48 0.39,7 C0.39,5.56 1.52,4.39 2.94,4.32 L3.07,4.32 L18.59,4.32 Z"
                            }),
                            (0, $1rY3h.jsx)("path", {
                                d: "M10.83,0.15 C12.27,0.15 13.44,1.28 13.51,2.7 L13.51,2.83 L13.51,5.81 C13.51,7.28 12.31,8.48 10.83,8.48 C9.39,8.48 8.22,7.35 8.16,5.93 L8.15,5.81 L8.15,2.83 C8.15,1.35 9.35,0.15 10.83,0.15 Z"
                            }),
                            (0, $1rY3h.jsx)("path", {
                                d: "M10.25,12.73 C9.47,11.48 7.82,11.09 6.56,11.87 C5.31,12.64 4.92,14.29 5.7,15.55 C8.99,20.88 12.87,24.79 17.31,27.21 C18.61,27.91 20.24,27.43 20.95,26.13 C21.65,24.83 21.17,23.21 19.87,22.5 C16.3,20.56 13.08,17.31 10.25,12.73 Z"
                            }),
                            (0, $1rY3h.jsx)("path", {
                                d: "M14.94,5.94 C15.53,4.58 17.1,3.95 18.46,4.54 C19.82,5.12 20.45,6.7 19.86,8.06 C15.87,17.34 10.72,23.75 4.37,27.21 C3.07,27.91 1.45,27.43 0.74,26.13 C0.03,24.83 0.51,23.21 1.81,22.5 C6.99,19.69 11.38,14.2 14.94,5.94 Z"
                            })
                        ]
                    })
                ]
            })
        })
    });
};

});

parcelRegister("60CU0", function(module, exports) {

$parcel$export(module.exports, "ZipFile", function () { return $4600eb5d2d32cc6e$export$361a87d8d0c7288a; });

var $1rY3h = parcelRequire("1rY3h");
var $4600eb5d2d32cc6e$export$361a87d8d0c7288a = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-content-zip file",
        width: size,
        height: size,
        viewBox: "0 0 52 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M47.84,64.18 C49.9,64.18 51.57,62.51 51.57,60.46 L51.57,15.72 L36.04,15.72 L36.04,0.31 L35.91,0.18 L3.73,0.18 C1.67,0.18 0,1.85 0,3.91 L0,60.46 C0,62.51 1.67,64.18 3.73,64.18 L47.84,64.18 Z M26.1,13.85 L16.78,13.85 L16.78,23.17 L26.1,23.17 L26.1,13.85 Z M26.1,41.81 L35.42,41.81 L35.42,51.13 L26.1,51.13 L26.1,41.81 L16.78,41.81 L16.78,32.49 L26.1,32.49 L26.1,23.17 L35.42,23.17 L35.42,32.49 L26.1,32.49 L26.1,41.81 Z"
                    }),
                    (0, $1rY3h.jsx)("polygon", {
                        opacity: "0.5",
                        points: "51.57 15.72 36.04 15.72 36.04 0.18"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("9GPbT", function(module, exports) {

$parcel$export(module.exports, "ZoomIn", function () { return $01d20f7695f92b0b$export$d13069184bfa0730; });

var $1rY3h = parcelRequire("1rY3h");
var $01d20f7695f92b0b$export$d13069184bfa0730 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-content-zoom in",
        width: size,
        height: size,
        viewBox: "0 0 62 63",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M59.66,53.76 C61.58,55.68 61.58,58.79 59.66,60.71 C57.74,62.63 54.63,62.63 52.71,60.71 L37.65,45.65 L44.6,38.7 L59.66,53.76 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M26.23,0.18 C40.72,0.18 52.46,11.93 52.46,26.42 C52.46,40.9 40.72,52.65 26.23,52.65 C11.74,52.65 0,40.9 0,26.42 C0,11.93 11.74,0.18 26.23,0.18 Z M46.97,26.42 C46.97,37.87 37.69,47.16 26.23,47.16 C14.78,47.16 5.49,37.87 5.49,26.42 C5.49,14.96 14.78,5.67 26.23,5.67 C37.69,5.67 46.97,14.96 46.97,26.42 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M26.23,47.16 C37.69,47.16 46.97,37.87 46.97,26.42 C46.97,14.96 37.69,5.67 26.23,5.67 C14.78,5.67 5.49,14.96 5.49,26.42 C5.49,37.87 14.78,47.16 26.23,47.16 Z M26.54,14.52 C28.05,14.52 29.28,15.75 29.28,17.26 L29.28,23.97 L35.99,23.97 C37.51,23.97 38.74,25.2 38.74,26.72 C38.74,28.24 37.51,29.46 35.99,29.46 L29.28,29.46 L29.28,36.18 C29.28,37.69 28.05,38.92 26.54,38.92 C25.02,38.92 23.79,37.69 23.79,36.18 L23.79,29.46 L17.08,29.46 C15.56,29.46 14.34,28.24 14.34,26.72 C14.34,25.2 15.56,23.97 17.08,23.97 L23.79,23.97 L23.79,17.26 C23.79,15.75 25.02,14.52 26.54,14.52 Z",
                        opacity: "0.5"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("c9Bb7", function(module, exports) {

$parcel$export(module.exports, "ZoomOut", function () { return $8d932a1dfecc3d9c$export$adc4acb67269225; });

var $1rY3h = parcelRequire("1rY3h");
var $8d932a1dfecc3d9c$export$adc4acb67269225 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-content-zoom out",
        width: size,
        height: size,
        viewBox: "0 0 62 63",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M59.66,53.76 C61.58,55.68 61.58,58.79 59.66,60.71 C57.74,62.63 54.63,62.63 52.71,60.71 L37.33,45.33 L44.28,38.38 L59.66,53.76 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M52.46,26.42 C52.46,11.93 40.72,0.18 26.23,0.18 C11.74,0.18 0,11.93 0,26.42 C0,40.9 11.74,52.65 26.23,52.65 C40.72,52.65 52.46,40.9 52.46,26.42 Z M26.23,47.16 C37.69,47.16 46.97,37.87 46.97,26.42 C46.97,14.96 37.69,5.67 26.23,5.67 C14.78,5.67 5.49,14.96 5.49,26.42 C5.49,37.87 14.78,47.16 26.23,47.16 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M26.23,47.16 C37.69,47.16 46.97,37.87 46.97,26.42 C46.97,14.96 37.69,5.67 26.23,5.67 C14.78,5.67 5.49,14.96 5.49,26.42 C5.49,37.87 14.78,47.16 26.23,47.16 Z M38.74,26.72 C38.74,25.2 37.51,23.97 35.99,23.97 L17.08,23.97 L16.95,23.98 C15.5,24.05 14.34,25.25 14.34,26.72 C14.34,28.24 15.56,29.47 17.08,29.47 L35.99,29.47 L36.12,29.46 C37.58,29.39 38.74,28.19 38.74,26.72 Z",
                        opacity: "0.5"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("1Q6qD", function(module, exports) {

$parcel$export(module.exports, "Computer", function () { return $156fa25fe3cabed4$export$2454fd0de010f4bb; });

var $1rY3h = parcelRequire("1rY3h");
var $156fa25fe3cabed4$export$2454fd0de010f4bb = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-device-computer",
        width: size,
        height: size,
        viewBox: "0 0 65 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M64.31,33.866 L64.31,7.404 C64.31,3.326 61.01,0.02 56.93,0.02 L8.31,0.02 C4.23,0.02 0.93,3.326 0.93,7.404 L0.93,33.866 L64.31,33.866 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M17.54,61.25 C17.54,62.78 18.78,64.02 20.31,64.02 L44.93,64.02 C46.46,64.02 47.7,62.78 47.7,61.25 C47.7,59.721 46.46,58.481 44.93,58.481 L39.65,58.481 C39.68,58.281 39.7,58.076 39.7,57.866 L39.7,51.097 L56.93,51.097 C61.01,51.097 64.31,47.791 64.31,43.713 L64.31,33.866 L0.93,33.866 L0.93,43.713 C0.93,47.791 4.23,51.097 8.31,51.097 L25.54,51.097 L25.54,57.866 C25.54,58.076 25.56,58.281 25.59,58.481 L20.31,58.481 C18.78,58.481 17.54,59.721 17.54,61.25 Z",
                        opacity: "0.5"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("5lVc4", function(module, exports) {

$parcel$export(module.exports, "Laptop", function () { return $3e5b47684d1d90d6$export$650c7f4d72afd4aa; });

var $1rY3h = parcelRequire("1rY3h");
var $3e5b47684d1d90d6$export$650c7f4d72afd4aa = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-device-laptop",
        width: size,
        height: size,
        viewBox: "0 0 64 45",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M0,41.72 C0,43.01 1.04,44.05 2.32,44.05 L61.68,44.05 C62.96,44.05 64,43.01 64,41.72 C64,40.44 62.96,39.4 61.68,39.4 L2.32,39.4 C1.04,39.4 0,40.44 0,41.72 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M58.58,36.56 C58.58,38.27 57.19,39.66 55.48,39.66 L8.52,39.66 C6.81,39.66 5.42,38.27 5.42,36.56 L5.42,7.14 C5.42,3.72 8.19,0.95 11.61,0.95 L52.39,0.95 C55.81,0.95 58.58,3.72 58.58,7.14 L58.58,36.56 Z M53.94,5.59 L10.07,5.59 L10.07,34.76 L53.94,34.76 L53.94,5.59 Z"
                    }),
                    (0, $1rY3h.jsx)("polygon", {
                        opacity: "0.5",
                        points: "10.06 5.6 53.94 5.6 53.94 34.76 10.06 34.76"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("5d2m8", function(module, exports) {

$parcel$export(module.exports, "Smartphone", function () { return $3caffe8277307d96$export$e16bb4f10df080b3; });

var $1rY3h = parcelRequire("1rY3h");
var $3caffe8277307d96$export$e16bb4f10df080b3 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-device-smartphone",
        width: size,
        height: size,
        viewBox: "0 0 40 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M39.22,7.9094 C39.22,3.7914 35.88,0.4531 31.76,0.4531 L7.53,0.4531 C3.41,0.4531 0.07,3.7914 0.07,7.9094 L0.07,56.997 C0.07,61.115 3.41,64.453 7.53,64.453 L31.76,64.453 C35.88,64.453 39.22,61.115 39.22,56.997 L39.22,7.9094 Z M19.96,59.482 C22.01,59.482 23.68,57.813 23.68,55.754 C23.68,53.695 22.01,52.026 19.96,52.026 C17.9,52.026 16.23,53.695 16.23,55.754 C16.23,57.813 17.9,59.482 19.96,59.482 Z M24.31,4.1811 C25.85,4.1811 27.1,5.433 27.1,6.9772 C27.1,8.4774 25.92,9.7016 24.44,9.7703 L24.31,9.7733 L15.61,9.7733 C14.06,9.7733 12.81,8.5215 12.81,6.9772 C12.81,5.4771 13.99,4.2529 15.47,4.1842 L15.61,4.1811 L24.31,4.1811 Z M33,47.055 L33,12.8805 L6.29,12.8805 L6.29,47.055 L33,47.055 Z"
                    }),
                    (0, $1rY3h.jsx)("polygon", {
                        opacity: "0.5",
                        points: "33 12.8809 33 47.056 6.29 47.056 6.29 12.8809"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("6zTaB", function(module, exports) {

$parcel$export(module.exports, "TwoFactorAuth", function () { return $4ca0ce9525a043e7$export$c0f25332e4457fe4; });

var $1rY3h = parcelRequire("1rY3h");
var $4ca0ce9525a043e7$export$c0f25332e4457fe4 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-device-2factorauth",
        width: size,
        height: size,
        viewBox: "0 0 82 64",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsxs)("g", {
                        transform: "translate(0.000000, 6.000000)",
                        children: [
                            (0, $1rY3h.jsx)("path", {
                                d: "M38.84,41.53 L38.84,47.44 L10.25,47.44 C8.19,47.44 6.52,45.77 6.52,43.71 L6.52,8.29 C6.52,4.17 9.86,0.84 13.98,0.84 L38.84,0.84 L38.84,6.43 L12.12,6.43 L12.12,41.53 L38.84,41.53 Z"
                            }),
                            (0, $1rY3h.jsxs)("g", {
                                opacity: "0.5",
                                transform: "translate(0.000000, 47.000000)",
                                children: [
                                    (0, $1rY3h.jsx)("path", {
                                        d: "M0,2.92 C0,4.47 1.25,5.72 2.8,5.72 L32.62,5.72 C34.17,5.72 35.42,4.47 35.42,2.92 C35.42,1.38 34.17,0.13 32.62,0.13 L2.8,0.13 C1.25,0.13 0,1.38 0,2.92 Z"
                                    }),
                                    (0, $1rY3h.jsx)("polygon", {
                                        points: "38.83 0.13 9.01 0.13 9.01 5.72 38.83 5.72"
                                    })
                                ]
                            }),
                            (0, $1rY3h.jsx)("path", {
                                d: "M38.83,6.43 L12.12,6.43 L12.12,41.53 L38.83,41.53 L38.83,6.43 Z M34.6,19.37 C33.51,18.27 31.74,18.27 30.65,19.36 L26.38,23.61 L24.65,21.89 L24.55,21.79 C23.45,20.8 21.75,20.84 20.7,21.9 C19.61,23 19.61,24.77 20.71,25.86 L24.4,29.53 L24.51,29.63 C25.61,30.62 27.29,30.59 28.35,29.53 L34.59,23.32 L34.69,23.22 C35.69,22.12 35.66,20.43 34.6,19.37 Z",
                                opacity: "0.5"
                            })
                        ]
                    }),
                    (0, $1rY3h.jsxs)("g", {
                        transform: "translate(42.000000, 0.000000)",
                        children: [
                            (0, $1rY3h.jsx)("path", {
                                d: "M33.5,46.6 L33.5,12.43 L6.78,12.43 L6.78,46.6 L33.5,46.6 Z M28.02,25.37 C26.93,24.27 25.16,24.27 24.07,25.36 L19.8,29.61 L18.07,27.89 L17.97,27.79 C16.87,26.8 15.17,26.84 14.12,27.9 C13.03,29 13.03,30.77 14.13,31.86 L17.82,35.54 L17.93,35.63 C19.02,36.62 20.71,36.59 21.77,35.54 L28.01,29.32 L28.11,29.22 C29.11,28.12 29.08,26.43 28.02,25.37 Z",
                                opacity: "0.5"
                            }),
                            (0, $1rY3h.jsx)("path", {
                                d: "M39.71,7.46 C39.71,3.34 36.37,0 32.25,0 L8.02,0 C3.9,0 0.56,3.34 0.56,7.46 L0.56,56.54 C0.56,60.66 3.9,64 8.02,64 L32.25,64 C36.37,64 39.71,60.66 39.71,56.54 L39.71,7.46 Z M20.45,59.03 C22.51,59.03 24.18,57.36 24.18,55.3 C24.18,53.24 22.51,51.57 20.45,51.57 C18.39,51.57 16.72,53.24 16.72,55.3 C16.72,57.36 18.39,59.03 20.45,59.03 Z M24.8,3.73 C26.34,3.73 27.59,4.98 27.59,6.52 C27.59,8.02 26.41,9.25 24.93,9.32 L24.8,9.32 L16.1,9.32 C14.55,9.32 13.3,8.07 13.3,6.52 C13.3,5.02 14.48,3.8 15.97,3.73 L16.1,3.73 L24.8,3.73 Z M33.5,46.6 L33.5,12.43 L6.78,12.43 L6.78,46.6 L33.5,46.6 Z"
                            })
                        ]
                    })
                ]
            })
        })
    });
};

});

parcelRegister("d7YRX", function(module, exports) {

$parcel$export(module.exports, "Watch", function () { return $98eb2530f71a5933$export$4c68f1a79f88778c; });

var $1rY3h = parcelRequire("1rY3h");
var $98eb2530f71a5933$export$4c68f1a79f88778c = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-device-watch",
        width: size,
        height: size,
        viewBox: "0 0 42 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M0.4,20.001 C0.4,17.035 2.8,14.631 5.77,14.631 L35.75,14.631 C38.72,14.631 41.12,17.035 41.12,20.001 L41.12,44.617 C41.12,47.583 38.72,49.988 35.75,49.988 L5.77,49.988 C2.8,49.988 0.4,47.583 0.4,44.617 L0.4,20.001 Z M32.84,37.904 C33.96,37.904 34.86,38.806 34.86,39.918 C34.86,40.998 34.01,41.88 32.94,41.93 L32.84,41.932 L8.68,41.932 C7.56,41.932 6.66,41.03 6.66,39.918 C6.66,38.837 7.51,37.956 8.58,37.906 L8.68,37.904 L32.84,37.904 Z M34.86,20.002 L6.66,20.002 L6.66,32.533 L34.86,32.533 L34.86,20.002 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M8.45,2.994 C8.45,1.511 9.66,0.309 11.14,0.309 L30.38,0.309 C31.87,0.309 33.07,1.511 33.07,2.994 L33.07,9.26 L8.45,9.26 L8.45,2.994 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M8.45,55.357 L33.07,55.357 L33.07,61.623 C33.07,63.106 31.87,64.308 30.38,64.308 L11.14,64.308 C9.66,64.308 8.45,63.106 8.45,61.623 L8.45,55.357 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M8.45,9.26 L33.07,9.26 C33.07,11.011 33.59,12.723 34.56,14.179 L34.86,14.63 L6.66,14.63 L6.96,14.179 C7.94,12.723 8.45,11.011 8.45,9.26 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M8.45,55.357 L33.07,55.357 C33.07,53.606 33.59,51.894 34.56,50.437 L34.86,49.986 L6.66,49.986 L6.96,50.437 C7.94,51.894 8.45,53.606 8.45,55.357 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("g", {
                        transform: "translate(6.000000, 20.000000)",
                        fillRule: "nonzero",
                        opacity: "0.5",
                        children: (0, $1rY3h.jsx)("polygon", {
                            points: "0.66 0.002 28.86 0.002 28.86 12.533 0.66 12.533"
                        })
                    })
                ]
            })
        })
    });
};

});

parcelRegister("2d8PF", function(module, exports) {

$parcel$export(module.exports, "Badge", function () { return $19c3a593e607766a$export$37acb3580601e69a; });

var $1rY3h = parcelRequire("1rY3h");
var $19c3a593e607766a$export$37acb3580601e69a = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-badge",
        width: size,
        height: size,
        viewBox: "0 0 48 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M8.58,41.4 C8.58,38.7 10.82,36.4 13.58,36.4 L34.43,36.4 C37.19,36.4 39.43,38.7 39.43,41.4 L39.43,62.2 C39.43,64.3 37.01,65.5 35.37,64.2 L25.56,56.4 C24.65,55.7 23.36,55.7 22.45,56.4 L12.64,64.2 C11,65.5 8.58,64.3 8.58,62.2 L8.58,41.4 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M47.74,24.5 C47.74,11.4 37.12,0.8 24.01,0.8 C10.89,0.8 0.27,11.4 0.27,24.5 C0.27,37.6 10.89,48.2 24.01,48.2 C37.12,48.2 47.74,37.6 47.74,24.5 Z M20.16,18.5 L22.43,13.9 C22.99,12.8 24.35,12.3 25.48,12.9 C25.93,13.1 26.3,13.5 26.52,13.9 L28.78,18.5 L33.85,19.2 C35.06,19.4 35.91,20.5 35.8,21.7 L35.78,21.8 C35.71,22.3 35.48,22.8 35.12,23.1 L31.45,26.7 L32.32,31.8 C32.52,33 31.75,34.1 30.57,34.4 L30.45,34.4 C29.96,34.5 29.45,34.4 29.01,34.2 L24.47,31.8 L19.94,34.2 C18.86,34.7 17.54,34.3 16.92,33.3 L16.86,33.2 C16.63,32.8 16.55,32.2 16.63,31.8 L17.5,26.7 L13.83,23.1 C12.96,22.3 12.91,20.9 13.71,20 L13.79,19.9 C14.14,19.6 14.6,19.3 15.09,19.2 L20.16,18.5 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("2caah", function(module, exports) {

$parcel$export(module.exports, "Ball", function () { return $19949642f14e5a66$export$a83d7c3fa53790c9; });

var $1rY3h = parcelRequire("1rY3h");
var $19949642f14e5a66$export$a83d7c3fa53790c9 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-ball",
        width: size,
        height: size,
        viewBox: "0 0 65 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("rect", {
                        fillRule: "nonzero",
                        opacity: "0.5",
                        transform: "translate(32.040000, 32.984000) rotate(-180.000000) translate(-32.040000, -32.984000) ",
                        x: "0.04",
                        y: "0.984",
                        width: "64",
                        height: "64",
                        rx: "32"
                    }),
                    (0, $1rY3h.jsx)("g", {
                        transform: "translate(0.000000, 1.000000)",
                        children: (0, $1rY3h.jsx)("path", {
                            d: "M63.96,29.738 C63.57,24.099 61.72,18.862 58.78,14.403 C54.21,18.123 51.09,23.564 50.42,29.738 L63.96,29.738 Z M45.34,29.738 C46.04,21.943 49.92,15.064 55.68,10.415 C50.3,4.522 42.74,0.647 34.28,0.061 L34.28,29.738 L45.34,29.738 Z M34.28,34.791 L45.34,34.791 C46.02,42.452 49.79,49.227 55.38,53.871 C50.02,59.585 42.59,63.33 34.28,63.905 L34.28,34.791 Z M29.23,29.738 L29.23,0.104 C21,0.82 13.66,4.652 8.4,10.415 C14.15,15.064 18.04,21.943 18.73,29.738 L29.23,29.738 Z M18.73,34.791 L29.23,34.791 L29.23,63.862 C21.15,63.16 13.93,59.456 8.69,53.871 C14.29,49.227 18.05,42.452 18.73,34.791 Z M13.65,29.738 C12.98,23.564 9.86,18.123 5.29,14.403 C2.36,18.862 0.5,24.099 0.11,29.738 L13.65,29.738 Z M0.16,34.791 L13.65,34.791 C12.99,40.854 9.97,46.21 5.53,49.924 C2.56,45.535 0.64,40.368 0.16,34.791 Z M50.42,34.791 L63.91,34.791 C63.43,40.368 61.51,45.535 58.54,49.924 C54.1,46.21 51.08,40.854 50.42,34.791 Z"
                        })
                    })
                ]
            })
        })
    });
};

});

parcelRegister("iZWiv", function(module, exports) {

$parcel$export(module.exports, "Balloon", function () { return $dd4b252c68d50f97$export$3016537a1ffc38d5; });

var $1rY3h = parcelRequire("1rY3h");
var $dd4b252c68d50f97$export$3016537a1ffc38d5 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-balloon",
        width: size,
        height: size,
        viewBox: "0 0 45 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M44.35,22.18 C44.35,10.04 34.51,0.2 22.37,0.2 C10.24,0.2 0.4,10.04 0.4,22.18 C0.4,34.32 10.24,44.16 22.37,44.16 C34.51,44.16 44.35,34.32 44.35,22.18 Z M23.82,6.96 C23.82,5.76 22.85,4.79 21.65,4.79 C12.45,4.79 4.99,12.25 4.99,21.45 L4.99,21.94 L4.99,22.04 C5.04,23.19 5.99,24.11 7.16,24.11 C8.36,24.11 9.33,23.14 9.33,21.94 L9.33,21.45 L9.33,21.25 C9.44,14.54 14.92,9.14 21.65,9.14 C22.85,9.14 23.82,8.16 23.82,6.96 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M24.55,45.89 C24.55,44.69 23.58,43.72 22.37,43.72 C21.21,43.72 20.26,44.64 20.2,45.79 L20.2,45.89 L20.2,62.03 C20.2,63.23 21.17,64.2 22.37,64.2 C23.54,64.2 24.49,63.28 24.55,62.13 L24.55,62.03 L24.55,45.89 Z",
                        fillRule: "nonzero",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M17.95,48.02 C17.17,48.02 16.71,47.14 17.16,46.5 L22.37,39.03 L27.59,46.5 C28.04,47.14 27.58,48.02 26.8,48.02 L17.95,48.02 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("jsl99", function(module, exports) {

$parcel$export(module.exports, "Beer", function () { return $e2a1091b1fe742a2$export$6e292bffe1e39e29; });

var $1rY3h = parcelRequire("1rY3h");
var $e2a1091b1fe742a2$export$6e292bffe1e39e29 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-beer",
        width: size,
        height: size,
        viewBox: "0 0 65 73",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M54.7,35.51 C60,35.51 64.3,39.81 64.3,45.11 C64.3,50.41 60,54.71 54.7,54.71 L47.5,54.71 C46.18,54.71 45.1,53.64 45.1,52.31 L45.1,37.91 C45.1,36.59 46.18,35.51 47.5,35.51 L54.7,35.51 Z M54.7,49.91 C57.3,49.91 59.42,47.84 59.5,45.25 L59.5,45.11 C59.5,42.46 57.35,40.31 54.7,40.31 L49.9,40.31 L49.9,49.91 L54.7,49.91 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M19.7,23.57 C18.04,25.49 15.58,26.71 12.83,26.71 C10.05,26.71 7.56,25.46 5.9,23.49 L5.9,68.05 L50.17,68.05 L50.17,23.49 C48.5,25.46 46.02,26.71 43.23,26.71 C40.61,26.71 38.25,25.6 36.59,23.82 C34.32,25.63 31.44,26.71 28.3,26.71 C25.02,26.71 22.02,25.53 19.7,23.57 Z M30.43,38.33 C30.37,37.06 29.32,36.05 28.03,36.05 C26.71,36.05 25.63,37.12 25.63,38.45 L25.63,51.78 L25.64,51.89 C25.7,53.17 26.75,54.18 28.03,54.18 C29.36,54.18 30.43,53.11 30.43,51.78 L30.43,38.45 L30.43,38.33 Z M37.1,36.05 C38.39,36.05 39.44,37.06 39.5,38.33 L39.5,38.45 L39.5,51.78 C39.5,53.11 38.43,54.18 37.1,54.18 C35.81,54.18 34.76,53.17 34.7,51.89 L34.7,51.78 L34.7,38.45 C34.7,37.12 35.77,36.05 37.1,36.05 Z M21.36,38.33 C21.31,37.06 20.25,36.05 18.97,36.05 C17.64,36.05 16.57,37.12 16.57,38.45 L16.57,51.78 L16.57,51.89 C16.63,53.17 17.68,54.18 18.97,54.18 C20.29,54.18 21.37,53.11 21.37,51.78 L21.37,38.45 L21.36,38.33 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M19.7,23.57 C18.04,25.49 15.58,26.71 12.83,26.71 C7.83,26.71 3.77,22.65 3.77,17.64 C3.77,12.64 7.83,8.58 12.83,8.58 C13.83,8.58 14.79,8.74 15.69,9.04 C17.49,3.8 22.46,0.04 28.3,0.04 C34.09,0.04 39.02,3.74 40.86,8.89 C41.62,8.69 42.41,8.58 43.23,8.58 C48.24,8.58 52.3,12.64 52.3,17.64 C52.3,22.65 48.24,26.71 43.23,26.71 C40.61,26.71 38.25,25.6 36.59,23.82 C34.32,25.63 31.44,26.71 28.3,26.71 C25.02,26.71 22.02,25.53 19.7,23.57 Z",
                        fillRule: "nonzero",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M53.37,68.04 C54.69,68.04 55.77,69.12 55.77,70.44 C55.77,71.73 54.75,72.78 53.48,72.84 L53.37,72.84 L2.7,72.84 C1.38,72.84 0.3,71.77 0.3,70.44 C0.3,69.16 1.31,68.11 2.59,68.05 L2.7,68.04 L53.37,68.04 Z",
                        fillRule: "nonzero",
                        opacity: "0.5"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("bLc9o", function(module, exports) {

$parcel$export(module.exports, "Binoculars", function () { return $88fd8252613ac63f$export$b055e3db3c7e28b5; });

var $1rY3h = parcelRequire("1rY3h");
var $88fd8252613ac63f$export$b055e3db3c7e28b5 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-binoculars",
        width: size,
        height: size,
        viewBox: "0 0 65 40",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M25.64,20.95 C24.63,20.95 23.8,20.15 23.75,19.15 L23.75,19.05 L23.75,9.17 C23.75,4.53 27.52,0.76 32.16,0.76 C36.76,0.76 40.49,4.44 40.57,9.02 L40.57,9.17 L40.57,19.05 C40.57,20.1 39.73,20.95 38.68,20.95 C37.67,20.95 36.84,20.15 36.79,19.15 L36.79,19.05 L36.79,9.17 C36.79,6.62 34.72,4.55 32.16,4.55 C29.65,4.55 27.61,6.55 27.54,9.04 L27.54,9.17 L27.54,19.05 C27.54,20.1 26.69,20.95 25.64,20.95 Z",
                        fillRule: "nonzero",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M64.1,24.98 C64.1,16.72 57.4,10.03 49.15,10.03 C40.89,10.03 34.2,16.72 34.2,24.98 C34.2,33.23 40.89,39.92 49.15,39.92 C57.4,39.92 64.1,33.23 64.1,24.98 Z M39.3,25.26 C39.3,30.91 43.87,35.48 49.51,35.48 C55.16,35.48 59.73,30.91 59.73,25.26 C59.73,19.62 55.16,15.05 49.51,15.05 C43.87,15.05 39.3,19.62 39.3,25.26 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M29.99,24.98 C29.99,16.72 23.3,10.03 15.05,10.03 C6.79,10.03 0.1,16.72 0.1,24.98 C0.1,33.23 6.79,39.92 15.05,39.92 C23.3,39.92 29.99,33.23 29.99,24.98 Z M4.88,25.11 C4.88,30.79 9.48,35.39 15.15,35.39 C20.83,35.39 25.43,30.79 25.43,25.11 C25.43,19.44 20.83,14.83 15.15,14.83 C9.48,14.83 4.88,19.44 4.88,25.11 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M4.88,25.11 C4.88,30.79 9.48,35.39 15.15,35.39 C20.83,35.39 25.43,30.79 25.43,25.11 C25.43,19.44 20.83,14.83 15.15,14.83 C9.48,14.83 4.88,19.44 4.88,25.11 Z M15.95,16.58 C11.27,16.58 7.51,20.51 7.51,25.32 L7.51,25.48 L7.52,25.57 C7.56,26.57 8.39,27.37 9.41,27.37 C10.45,27.37 11.3,26.52 11.3,25.48 L11.3,25.32 L11.3,25.18 C11.37,22.49 13.44,20.36 15.95,20.36 L16.04,20.36 C17.04,20.31 17.84,19.48 17.84,18.47 C17.84,17.43 16.99,16.58 15.95,16.58 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M39.29,25.26 C39.29,30.91 43.87,35.48 49.51,35.48 C55.16,35.48 59.73,30.91 59.73,25.26 C59.73,19.62 55.16,15.05 49.51,15.05 C43.87,15.05 39.29,19.62 39.29,25.26 Z M50.7,17.07 C45.8,17.07 41.8,20.98 41.8,25.81 L41.8,25.97 L41.81,26.07 C41.86,27.07 42.68,27.87 43.7,27.87 C44.74,27.87 45.59,27.02 45.59,25.97 L45.59,25.81 L45.59,25.68 C45.66,23.02 47.91,20.86 50.7,20.86 L50.8,20.86 C51.8,20.81 52.6,19.98 52.6,18.97 C52.6,17.92 51.75,17.07 50.7,17.07 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("rect", {
                        fillRule: "nonzero",
                        x: "26.75",
                        y: "20.11",
                        width: "11.3535",
                        height: "10.092"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("23dQH", function(module, exports) {

$parcel$export(module.exports, "Bold", function () { return $17e69aba60f3fa7d$export$95aa4184327d6b72; });

var $1rY3h = parcelRequire("1rY3h");
var $17e69aba60f3fa7d$export$95aa4184327d6b72 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-bolt",
        width: size,
        height: size,
        viewBox: "0 0 44 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M27.28,1.13 C28.43,-0.43 30.91,0.57 30.64,2.49 L25.42,40.05 L2.32,40.05 C0.79,40.05 -0.09,38.31 0.82,37.08 L27.28,1.13 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M41.87,24.67 C43.4,24.67 44.29,26.41 43.38,27.65 L16.92,63.59 C15.77,65.16 13.29,64.15 13.56,62.23 L18.77,24.67 L41.87,24.67 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("cWo99", function(module, exports) {

$parcel$export(module.exports, "Bomb", function () { return $96bda1d7d1bdab35$export$3a0f78411bc2215d; });

var $1rY3h = parcelRequire("1rY3h");
var $96bda1d7d1bdab35$export$3a0f78411bc2215d = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-bomb",
        width: size,
        height: size,
        viewBox: "0 0 65 86",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M32.08,21.49 C49.76,21.49 64.08,35.82 64.08,53.49 C64.08,71.17 49.76,85.49 32.08,85.49 C14.41,85.49 0.08,71.17 0.08,53.49 C0.08,35.82 14.41,21.49 32.08,21.49 Z M12.56,54.78 C12.56,56.37 11.27,57.66 9.68,57.66 C8.09,57.66 6.8,56.37 6.8,54.78 C6.8,40.83 18.12,29.52 32.07,29.52 C33.66,29.52 34.95,30.8 34.95,32.39 C34.95,33.98 33.66,35.27 32.07,35.27 L31.75,35.28 C21.12,35.45 12.56,44.12 12.56,54.78 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M54.05,9.31 C54.05,13.53 50.63,16.96 46.4,16.96 C42.24,16.96 38.86,13.64 38.75,9.5 L38.75,9.31 L38.75,7.85 C38.75,6.81 37.9,5.96 36.86,5.96 C35.85,5.96 35.02,6.75 34.97,7.74 L34.96,7.85 L34.96,19.69 C34.96,21.28 33.68,22.57 32.09,22.57 C30.54,22.57 29.28,21.36 29.21,19.83 L29.21,19.69 L29.21,7.85 C29.21,3.63 32.63,0.2 36.86,0.2 C41.02,0.2 44.4,3.52 44.51,7.66 L44.51,7.85 L44.51,9.31 C44.51,10.35 45.36,11.2 46.4,11.2 C47.41,11.2 48.23,10.41 48.29,9.42 L48.29,9.31 L48.29,5.77 C48.29,4.18 49.58,2.89 51.17,2.89 C52.72,2.89 53.98,4.11 54.05,5.64 L54.05,5.77 L54.05,9.31 Z",
                        fillRule: "nonzero",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M20.86,21.01 C20.86,18.48 22.9,16.44 25.42,16.44 L38.75,16.44 C41.27,16.44 43.31,18.48 43.31,21.01 L43.31,26.54 L20.86,26.54 L20.86,21.01 Z",
                        fillRule: "nonzero"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("e8Wg9", function(module, exports) {

$parcel$export(module.exports, "Book", function () { return $a4bf0129fd37f988$export$c959ddfb5bf9a14a; });

var $1rY3h = parcelRequire("1rY3h");
var $a4bf0129fd37f988$export$c959ddfb5bf9a14a = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-book",
        width: size,
        height: size,
        viewBox: "0 0 52 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M51.71,44.99 L51.71,4.6 C51.71,2.54 50.04,0.88 47.98,0.88 L10.08,0.88 C4.59,0.88 0.14,5.33 0.14,10.82 L0.14,54.93 C0.14,57.85 1.39,60.47 3.4,62.29 C1.39,60.47 0.14,57.85 0.14,54.93 C0.14,49.44 4.59,44.99 10.08,44.99 L51.71,44.99 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M51.71,52.14 L51.71,44.99 L10.08,44.99 C4.59,44.99 0.14,49.44 0.14,54.93 C0.14,60.42 4.59,64.87 10.08,64.87 L47.98,64.87 C50.04,64.87 51.71,63.2 51.71,61.15 L51.71,57.73 L51.71,57.73 L12.82,57.73 C11.27,57.73 10.02,56.48 10.02,54.93 C10.02,53.43 11.2,52.21 12.68,52.14 L12.82,52.14 L51.71,52.14 C51.71,52.14 51.71,52.14 51.71,52.14 Z",
                        opacity: "0.5"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("3XnA3", function(module, exports) {

$parcel$export(module.exports, "Bookmark", function () { return $2e192c66cf741f96$export$301ef70c5c7bdf65; });

var $1rY3h = parcelRequire("1rY3h");
var $2e192c66cf741f96$export$301ef70c5c7bdf65 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-bookmark",
        width: size,
        height: size,
        viewBox: "0 0 51 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsxs)("g", {
                        transform: "translate(16.000000, 17.000000)",
                        fillRule: "nonzero",
                        opacity: "0.5",
                        children: [
                            (0, $1rY3h.jsx)("path", {
                                d: "M6.39,16.24 C6.39,17.74 5.18,18.95 3.68,18.95 C2.23,18.95 1.04,17.8 0.97,16.37 L0.97,16.24 L0.97,2.99 C0.97,1.49 2.18,0.28 3.68,0.28 C5.14,0.28 6.32,1.42 6.39,2.86 L6.39,2.99 L6.39,16.24 Z"
                            }),
                            (0, $1rY3h.jsx)("path", {
                                d: "M18.44,16.24 C18.44,17.74 17.22,18.95 15.73,18.95 C14.27,18.95 13.09,17.8 13.02,16.37 L13.02,16.24 L13.02,2.99 C13.02,1.49 14.23,0.28 15.73,0.28 C17.18,0.28 18.37,1.42 18.43,2.86 L18.44,2.99 L18.44,16.24 Z"
                            })
                        ]
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M43.47,0.72 C47.46,0.72 50.7,3.95 50.7,7.95 L50.7,61.1 C50.7,64.05 47.36,65.75 44.97,64.03 L25.7,50.1 L6.44,64.03 C4.05,65.75 0.71,64.05 0.71,61.1 L0.71,7.95 C0.71,3.95 3.95,0.72 7.94,0.72 L43.47,0.72 Z M22.39,33.24 C22.39,34.74 21.18,35.95 19.68,35.95 C18.23,35.95 17.04,34.8 16.98,33.37 L16.97,33.24 L16.97,19.99 C16.97,18.49 18.19,17.28 19.68,17.28 C21.14,17.28 22.32,18.43 22.39,19.86 L22.39,19.99 L22.39,33.24 Z M31.73,35.95 C33.22,35.95 34.44,34.74 34.44,33.24 L34.44,19.99 L34.43,19.86 C34.37,18.43 33.18,17.28 31.73,17.28 C30.23,17.28 29.02,18.49 29.02,19.99 L29.02,33.24 L29.02,33.37 C29.09,34.8 30.27,35.95 31.73,35.95 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("83JNv", function(module, exports) {

$parcel$export(module.exports, "Box", function () { return $5de220fb78915a7f$export$e71c4d32a2263218; });

var $1rY3h = parcelRequire("1rY3h");
var $5de220fb78915a7f$export$e71c4d32a2263218 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-box",
        width: size,
        height: size,
        viewBox: "0 0 65 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("polygon", {
                        opacity: "0.5",
                        points: "16.46 33.81 49.39 33.81 49.39 55.55 16.46 55.55"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M8.38,0.88 L29.2,0.88 L29.2,14.86 L36.66,14.86 L36.66,0.88 L57.47,0.88 C61.59,0.88 64.93,4.21 64.93,8.33 L64.93,57.42 C64.93,61.54 61.59,64.87 57.47,64.87 L8.38,64.87 C4.27,64.87 0.93,61.54 0.93,57.42 L0.93,8.33 C0.93,4.21 4.27,0.88 8.38,0.88 Z M48.66,34.43 L17.08,34.43 L17.08,54.93 L48.66,54.93 L48.66,34.43 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("4T9wY", function(module, exports) {

$parcel$export(module.exports, "Briefcase", function () { return $38f3b11455a5e3aa$export$e7d61f8a47ad0cdc; });

var $1rY3h = parcelRequire("1rY3h");
var $38f3b11455a5e3aa$export$e7d61f8a47ad0cdc = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-briefcase",
        width: size,
        height: size,
        viewBox: "0 0 63 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M21.26,11.49 C21.26,5.54 26.08,0.72 32.03,0.72 C37.98,0.72 42.8,5.54 42.8,11.49 L42.8,15.07 L37.41,15.07 L37.41,11.49 C37.41,8.57 35.09,6.19 32.19,6.1 L32.03,6.1 C29.06,6.1 26.65,8.51 26.65,11.49 L26.65,15.07 L21.26,15.07 L21.26,11.49 Z M35.02,31.82 L62.54,31.82 L62.54,57.54 C62.54,61.51 59.32,64.72 55.36,64.72 L8.11,64.72 C4.14,64.72 0.93,61.51 0.93,57.54 L0.93,31.82 L29.64,31.82 L29.64,35.71 C29.64,37.2 30.84,38.4 32.33,38.4 C33.82,38.4 35.02,37.2 35.02,35.71 L35.02,31.82 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M62.54,22.25 C62.54,18.29 59.32,15.07 55.36,15.07 L8.11,15.07 C4.14,15.07 0.93,18.29 0.93,22.25 L0.93,31.82 L29.64,31.82 L29.64,26.74 C29.64,25.25 30.84,24.04 32.33,24.04 C33.82,24.04 35.02,25.25 35.02,26.74 L35.02,31.82 L62.54,31.82 L62.54,22.25 Z",
                        opacity: "0.5"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("89ffd", function(module, exports) {

$parcel$export(module.exports, "Building", function () { return $5eeafd39c1e6573c$export$bb414d9e15d07212; });

var $1rY3h = parcelRequire("1rY3h");
var $5eeafd39c1e6573c$export$bb414d9e15d07212 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-building",
        width: size,
        height: size,
        viewBox: "0 0 65 41",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M38.99,15.13 C40.27,15.42 41.22,16.56 41.22,17.92 C41.22,19.49 39.94,20.77 38.35,20.77 C36.76,20.77 35.48,19.49 35.48,17.92 C35.48,16.56 36.43,15.42 37.7,15.13 L27.1,15.13 C28.57,15.25 29.73,16.48 29.73,17.98 C29.73,19.56 28.44,20.84 26.86,20.84 C25.27,20.84 23.99,19.56 23.99,17.98 C23.99,16.48 25.15,15.25 26.62,15.13 L10.24,15.13 C7.7,15.13 5.34,17.18 5.34,19.7 L5.34,39.45 L60.19,39.45 L60.19,19.7 C60.19,17.18 58.13,15.13 55.59,15.13 L38.99,15.13 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M16.71,37.14 L16.71,4.77 C16.71,2.24 18.77,0.19 21.3,0.19 L43.9,0.19 C46.44,0.19 48.5,2.24 48.5,4.77 L48.5,37.14 L62.67,37.14 C63.74,37.14 64.6,38 64.6,39.07 C64.6,40.14 63.74,41 62.67,41 L2.54,41 C1.47,41 0.6,40.14 0.6,39.07 C0.6,38 1.47,37.14 2.54,37.14 L16.71,37.14 Z M28.96,37.14 L28.96,31.16 C28.96,29.22 30.55,27.63 32.51,27.63 C34.47,27.63 36.06,29.22 36.06,31.16 L36.06,37.14 L28.96,37.14 Z M29.73,17.98 C29.73,16.4 28.44,15.12 26.86,15.12 C25.27,15.12 23.99,16.4 23.99,17.98 C23.99,19.56 25.27,20.84 26.86,20.84 C28.44,20.84 29.73,19.56 29.73,17.98 Z M38.35,15.06 C39.94,15.06 41.22,16.34 41.22,17.92 C41.22,19.49 39.94,20.77 38.35,20.77 C36.76,20.77 35.48,19.49 35.48,17.92 C35.48,16.34 36.76,15.06 38.35,15.06 Z M29.73,8.77 C29.73,7.19 28.44,5.91 26.86,5.91 C25.27,5.91 23.99,7.19 23.99,8.77 C23.99,10.35 25.27,11.63 26.86,11.63 C28.44,11.63 29.73,10.35 29.73,8.77 Z M38.35,5.91 C39.94,5.91 41.22,7.19 41.22,8.77 C41.22,10.35 39.94,11.63 38.35,11.63 C36.76,11.63 35.48,10.35 35.48,8.77 C35.48,7.19 36.76,5.91 38.35,5.91 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("buEWq", function(module, exports) {

$parcel$export(module.exports, "Campfire", function () { return $85e2412bd985553b$export$5eba784616efe0e4; });

var $1rY3h = parcelRequire("1rY3h");
var $85e2412bd985553b$export$5eba784616efe0e4 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-campfire",
        width: size,
        height: size,
        viewBox: "0 0 65 63",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M50.14,53.57 C60.11,43.6 60.11,27.44 50.14,17.47 L47.08,14.41 C46.53,13.86 45.79,13.56 45.02,13.56 C44.25,13.56 43.51,13.86 42.96,14.41 L35.01,22.38 L34.99,3.53 C34.99,2.35 34.28,1.29 33.2,0.84 C32.11,0.39 30.86,0.64 30.03,1.47 L14.03,17.47 C4.06,27.44 4.06,43.6 14.03,53.57 C15.31,54.86 16.7,55.98 18.16,56.93 L46.14,56.84 C47.55,55.91 48.89,54.82 50.14,53.57 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M61.16,56.7999427 C62.77,56.79 64.0800605,58.09 64.0800605,59.7 C64.09,61.26 62.86,62.54 61.32,62.62 L61.18,62.62 L3,62.8 C1.4,62.8 0.09,61.5 0.08,59.89 C0.08,58.33 1.31,57.06 2.85,56.98 L2.99,56.98 L61.16,56.7999427 Z",
                        fillRule: "nonzero",
                        opacity: "0.5"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("3iGkz", function(module, exports) {

$parcel$export(module.exports, "Clock", function () { return $2673e38cf5604c9d$export$9735c82c4bae3302; });

var $1rY3h = parcelRequire("1rY3h");
var $2673e38cf5604c9d$export$9735c82c4bae3302 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-clock",
        width: size,
        height: size,
        viewBox: "0 0 65 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M32.04,6.04 C17.15,6.04 5.09,18.1 5.09,32.98 C5.09,47.87 17.15,59.93 32.04,59.93 C46.92,59.93 58.98,47.87 58.98,32.98 C58.98,18.1 46.92,6.04 32.04,6.04 Z M29.51,11.65 L29.51,26.74 C27.04,27.74 25.3,30.16 25.3,32.98 C25.3,36.7 28.32,39.72 32.04,39.72 C33,39.72 33.91,39.52 34.74,39.16 L44.83,49.35 L44.93,49.44 C45.91,50.34 47.45,50.32 48.41,49.37 C49.4,48.39 49.41,46.79 48.42,45.8 L38.27,35.54 C38.59,34.76 38.77,33.89 38.77,32.98 C38.77,30.16 37.03,27.74 34.56,26.74 L34.56,11.65 L34.56,11.52 C34.49,10.19 33.39,9.12 32.04,9.12 C30.64,9.12 29.51,10.26 29.51,11.65 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M32.04,0.98 C14.36,0.98 0.04,15.31 0.04,32.98 C0.04,50.66 14.36,64.98 32.04,64.98 C49.71,64.98 64.04,50.66 64.04,32.98 C64.04,15.31 49.71,0.98 32.04,0.98 Z M32.04,6.04 C17.15,6.04 5.09,18.1 5.09,32.98 C5.09,47.87 17.15,59.93 32.04,59.93 C46.92,59.93 58.98,47.87 58.98,32.98 C58.98,18.1 46.92,6.04 32.04,6.04 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("4kgJO", function(module, exports) {

$parcel$export(module.exports, "CoffeeMug", function () { return $32660377f8fbf5a7$export$5132caf11f5e28b; });

var $1rY3h = parcelRequire("1rY3h");
var $32660377f8fbf5a7$export$5132caf11f5e28b = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-coffee mug",
        width: size,
        height: size,
        viewBox: "0 0 65 90",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsxs)("g", {
                        transform: "translate(0.000000, 26.000000)",
                        children: [
                            (0, $1rY3h.jsx)("path", {
                                d: "M54.01,20.21 C59.95,20.21 64.77,25.03 64.77,30.98 C64.77,36.92 59.95,41.74 54.01,41.74 L45.93,41.74 C44.44,41.74 43.24,40.54 43.24,39.05 L43.24,22.9 C43.24,21.41 44.44,20.21 45.93,20.21 L54.01,20.21 Z M54.01,36.36 C56.93,36.36 59.3,34.03 59.39,31.13 L59.39,30.98 C59.39,28 56.98,25.59 54.01,25.59 L48.62,25.59 L48.62,36.36 L54.01,36.36 Z",
                                opacity: "0.5"
                            }),
                            (0, $1rY3h.jsx)("path", {
                                d: "M50.42,54.9 C50.42,58.86 47.2,62.08 43.24,62.08 L7.95,62.08 C3.98,62.08 0.77,58.86 0.77,54.9 L0.77,7.65 C0.77,3.68 3.98,0.47 7.95,0.47 L43.24,0.47 C47.2,0.47 50.42,3.68 50.42,7.65 L50.42,54.9 Z"
                            })
                        ]
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M25.29,0.15 C23.81,0.15 22.6,1.36 22.6,2.84 C22.6,4.29 23.74,5.47 25.17,5.53 L25.29,5.54 L27.54,5.54 C28.28,5.54 28.88,6.14 28.88,6.88 C28.88,7.59 28.33,8.18 27.63,8.22 L27.54,8.23 L23.05,8.23 C19.33,8.23 16.32,11.24 16.32,14.96 C16.32,18.61 19.24,21.59 22.88,21.68 L23.05,21.69 L31.57,21.69 C33.06,21.69 34.27,20.48 34.27,18.99 C34.27,17.55 33.13,16.37 31.7,16.3 L31.57,16.3 L23.05,16.3 C22.31,16.3 21.71,15.7 21.71,14.96 C21.71,14.24 22.26,13.66 22.96,13.61 L23.05,13.61 L27.54,13.61 C31.25,13.61 34.27,10.6 34.27,6.88 C34.27,3.22 31.35,0.25 27.71,0.15 L27.54,0.15 L25.29,0.15 Z",
                        fillRule: "nonzero",
                        opacity: "0.5"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("kssg0", function(module, exports) {

$parcel$export(module.exports, "Compass", function () { return $ee4c577479b6d1b5$export$87ae43576cc53e22; });

var $1rY3h = parcelRequire("1rY3h");
var $ee4c577479b6d1b5$export$87ae43576cc53e22 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-compass",
        width: size,
        height: size,
        viewBox: "0 0 65 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M32.04,64.98 C49.71,64.98 64.04,50.66 64.04,32.98 C64.04,15.31 49.71,0.98 32.04,0.98 C14.36,0.98 0.04,15.31 0.04,32.98 C0.04,50.66 14.36,64.98 32.04,64.98 Z M32.04,13.33 C33.9,13.33 35.4,11.83 35.4,9.96 C35.4,8.1 33.9,6.6 32.04,6.6 C30.18,6.6 28.67,8.1 28.67,9.96 C28.67,11.83 30.18,13.33 32.04,13.33 Z M12.39,32.98 C12.39,34.84 10.88,36.35 9.02,36.35 C7.16,36.35 5.65,34.84 5.65,32.98 C5.65,31.12 7.16,29.61 9.02,29.61 C10.88,29.61 12.39,31.12 12.39,32.98 Z M55.05,36.35 C56.91,36.35 58.42,34.84 58.42,32.98 C58.42,31.12 56.91,29.61 55.05,29.61 C53.19,29.61 51.69,31.12 51.69,32.98 C51.69,34.84 53.19,36.35 55.05,36.35 Z M35.4,56 C35.4,57.86 33.9,59.37 32.04,59.37 C30.18,59.37 28.67,57.86 28.67,56 C28.67,54.14 30.18,52.63 32.04,52.63 C33.9,52.63 35.4,54.14 35.4,56 Z M39.46,38.79 L44.49,23.7 C45.15,21.73 43.27,19.85 41.29,20.51 L26.21,25.53 C25.45,25.78 24.86,26.38 24.61,27.13 L19.58,42.22 C18.92,44.19 20.8,46.07 22.78,45.41 L37.86,40.38 C38.62,40.13 39.21,39.54 39.46,38.79 Z"
                    }),
                    (0, $1rY3h.jsx)("g", {
                        transform: "translate(5.000000, 6.000000)",
                        fillRule: "nonzero",
                        opacity: "0.5",
                        children: (0, $1rY3h.jsxs)("g", {
                            children: [
                                (0, $1rY3h.jsx)("path", {
                                    d: "M30.4,3.96 C30.4,5.82 28.9,7.33 27.04,7.33 C25.18,7.33 23.67,5.82 23.67,3.96 C23.67,2.1 25.18,0.6 27.04,0.6 C28.9,0.6 30.4,2.1 30.4,3.96 Z"
                                }),
                                (0, $1rY3h.jsx)("path", {
                                    d: "M7.39,26.98 C7.39,28.84 5.88,30.35 4.02,30.35 C2.16,30.35 0.65,28.84 0.65,26.98 C0.65,25.12 2.16,23.61 4.02,23.61 C5.88,23.61 7.39,25.12 7.39,26.98 Z"
                                }),
                                (0, $1rY3h.jsx)("path", {
                                    d: "M53.42,26.98 C53.42,28.84 51.91,30.35 50.05,30.35 C48.19,30.35 46.69,28.84 46.69,26.98 C46.69,25.12 48.19,23.61 50.05,23.61 C51.91,23.61 53.42,25.12 53.42,26.98 Z"
                                }),
                                (0, $1rY3h.jsx)("path", {
                                    d: "M30.4,50 C30.4,51.86 28.9,53.37 27.04,53.37 C25.18,53.37 23.67,51.86 23.67,50 C23.67,48.14 25.18,46.63 27.04,46.63 C28.9,46.63 30.4,48.14 30.4,50 Z"
                                })
                            ]
                        })
                    }),
                    (0, $1rY3h.jsx)("polygon", {
                        fillRule: "nonzero",
                        points: "38.1 26.89 29.01 29.93 25.97 39.02 35.07 35.99"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("5JKJp", function(module, exports) {

$parcel$export(module.exports, "CreditCard", function () { return $0113f548c0465da2$export$769b6865db9774d4; });

var $1rY3h = parcelRequire("1rY3h");
var $0113f548c0465da2$export$769b6865db9774d4 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-credit card",
        width: size,
        height: size,
        viewBox: "0 0 65 49",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M7.47,0.95 C3.68,0.95 0.61,4.02 0.61,7.81 L0.61,13.81 L64.61,13.81 L64.61,7.81 C64.61,4.02 61.54,0.95 57.76,0.95 L7.47,0.95 Z M64.61,18.95 L0.61,18.95 L0.61,41.52 C0.61,45.31 3.68,48.38 7.47,48.38 L57.76,48.38 C61.54,48.38 64.61,45.31 64.61,41.52 L64.61,18.95 Z M38.33,28.09 C38.33,26.67 37.18,25.52 35.76,25.52 L10.61,25.52 L10.49,25.52 C9.13,25.59 8.04,26.71 8.04,28.09 C8.04,29.51 9.19,30.66 10.61,30.66 L35.76,30.66 L35.88,30.66 C37.24,30.6 38.33,29.47 38.33,28.09 Z M23.19,35.81 C24.61,35.81 25.76,36.96 25.76,38.38 C25.76,39.76 24.67,40.88 23.31,40.95 L23.19,40.95 L10.61,40.95 C9.19,40.95 8.04,39.8 8.04,38.38 C8.04,37 9.13,35.87 10.49,35.81 L10.61,35.81 L23.19,35.81 Z"
                    }),
                    (0, $1rY3h.jsx)("polygon", {
                        fillRule: "nonzero",
                        opacity: "0.5",
                        points: "64.61 13.81 64.61 18.95 0.61 18.95 0.61 13.81"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("y6HFH", function(module, exports) {

$parcel$export(module.exports, "Direction", function () { return $0668603df72d49cf$export$cacd6541cfeeb6c1; });

var $1rY3h = parcelRequire("1rY3h");
var $0668603df72d49cf$export$cacd6541cfeeb6c1 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-direction",
        width: size,
        height: size,
        viewBox: "0 0 65 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsx)("g", {
                fill: "currentColor",
                children: (0, $1rY3h.jsx)("path", {
                    d: "M32.04,0.98 C14.36,0.98 0.04,15.31 0.04,32.98 C0.04,50.66 14.36,64.98 32.04,64.98 C49.71,64.98 64.04,50.66 64.04,32.98 C64.04,15.31 49.71,0.98 32.04,0.98 Z M46.74,19.7 C47.48,18.25 45.93,16.7 44.47,17.44 L14.61,32.67 C13.03,33.47 13.6,35.85 15.37,35.85 L26.64,35.85 C27.57,35.85 28.32,36.61 28.32,37.54 L28.32,48.8 C28.32,50.57 30.71,51.15 31.51,49.57 L46.74,19.7 Z"
                })
            })
        })
    });
};

});

parcelRegister("7uSpA", function(module, exports) {

$parcel$export(module.exports, "Directory", function () { return $57558ac7360207ec$export$1dbf9926a0d54d98; });

var $1rY3h = parcelRequire("1rY3h");
var $57558ac7360207ec$export$1dbf9926a0d54d98 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-directory",
        width: size,
        height: size,
        viewBox: "0 0 60 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M14.41,15.79 C15.95,15.79 17.2,17.04 17.2,18.58 C17.2,20.08 16.02,21.31 14.54,21.38 L14.41,21.38 L3.04,21.38 C1.49,21.38 0.24,20.13 0.24,18.58 C0.24,17.08 1.42,15.86 2.91,15.79 L3.04,15.79 L14.41,15.79 Z",
                        fillRule: "nonzero",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M14.41,30.08 C15.95,30.08 17.2,31.33 17.2,32.87 C17.2,34.37 16.02,35.6 14.54,35.67 L14.41,35.67 L3.04,35.67 C1.49,35.67 0.24,34.42 0.24,32.87 C0.24,31.37 1.42,30.15 2.91,30.08 L3.04,30.08 L14.41,30.08 Z",
                        fillRule: "nonzero",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M14.41,44.37 C15.95,44.37 17.2,45.62 17.2,47.17 C17.2,48.67 16.02,49.89 14.54,49.96 L14.41,49.96 L3.04,49.96 C1.49,49.96 0.24,48.71 0.24,47.17 C0.24,45.67 1.42,44.44 2.91,44.37 L3.04,44.37 L14.41,44.37 Z",
                        fillRule: "nonzero",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M52.31,64.87 C56.43,64.87 59.76,61.54 59.76,57.42 L59.76,8.33 C59.76,4.21 56.43,0.88 52.31,0.88 L15.65,0.88 C11.53,0.88 8.19,4.21 8.19,8.33 L8.19,15.79 L14.4,15.79 C15.95,15.79 17.2,17.04 17.2,18.58 C17.2,20.08 16.02,21.31 14.54,21.38 L14.4,21.38 L8.19,21.38 L8.19,30.08 L14.4,30.08 C15.95,30.08 17.2,31.33 17.2,32.87 C17.2,34.38 16.02,35.6 14.54,35.67 L14.4,35.67 L8.19,35.67 L8.19,44.37 L14.4,44.37 C15.95,44.37 17.2,45.62 17.2,47.17 C17.2,48.67 16.02,49.89 14.54,49.96 L14.4,49.96 L8.19,49.96 L8.19,57.42 C8.19,61.54 11.53,64.87 15.65,64.87 L52.31,64.87 Z M28.67,47.77 L39.82,47.77 C42.29,47.77 44.29,45.77 44.29,43.29 L44.29,41.19 C44.29,36.84 40.77,33.31 36.41,33.31 L32.08,33.31 C27.72,33.31 24.2,36.84 24.2,41.19 L24.2,43.29 C24.2,45.77 26.2,47.77 28.67,47.77 Z M34.25,19.95 C31.09,19.95 28.54,22.51 28.54,25.66 C28.54,28.81 31.09,31.37 34.25,31.37 C37.4,31.37 39.95,28.81 39.95,25.66 C39.95,22.51 37.4,19.95 34.25,19.95 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("8sU4a", function(module, exports) {

$parcel$export(module.exports, "Dumbbell", function () { return $629c6dd076e3fa86$export$befdbc9fee1f342a; });

var $1rY3h = parcelRequire("1rY3h");
var $629c6dd076e3fa86$export$befdbc9fee1f342a = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-dumbbell",
        width: size,
        height: size,
        viewBox: "0 0 65 34",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M62.54,15.3 C63.72,15.3 64.67,16.25 64.67,17.43 C64.67,18.58 63.77,19.51 62.64,19.56 L62.54,19.57 L2.81,19.57 C1.63,19.57 0.67,18.61 0.67,17.43 C0.67,16.29 1.58,15.35 2.71,15.3 L2.81,15.3 L62.54,15.3 Z",
                        fillRule: "nonzero",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M5.65,11.98 C5.65,9.1 7.99,6.77 10.87,6.77 C13.75,6.77 16.08,9.1 16.08,11.98 L16.08,21.94 C16.08,24.82 13.75,27.15 10.87,27.15 C7.99,27.15 5.65,24.82 5.65,21.94 L5.65,11.98 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M59.7,12.08 C59.7,9.14 57.32,6.77 54.39,6.77 C51.46,6.77 49.08,9.14 49.08,12.08 L49.08,22.03 C49.08,24.96 51.46,27.34 54.39,27.34 C57.32,27.34 59.7,24.96 59.7,22.03 L59.7,12.08 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M49.08,5.44 C49.08,2.51 46.7,0.13 43.77,0.13 C40.84,0.13 38.46,2.51 38.46,5.44 L38.46,28.67 C38.46,31.6 40.84,33.98 43.77,33.98 C46.7,33.98 49.08,31.6 49.08,28.67 L49.08,5.44 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M16.08,5.34 C16.08,2.46 18.42,0.13 21.3,0.13 C24.18,0.13 26.51,2.46 26.51,5.34 L26.51,28.57 C26.51,31.45 24.18,33.79 21.3,33.79 C18.42,33.79 16.08,31.45 16.08,28.57 L16.08,5.34 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("fWfPz", function(module, exports) {

$parcel$export(module.exports, "Eye", function () { return $b9a88d6ebd75ffc4$export$c42ab4f9cd72fed3; });

var $1rY3h = parcelRequire("1rY3h");
var $b9a88d6ebd75ffc4$export$c42ab4f9cd72fed3 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-eye",
        width: size,
        height: size,
        viewBox: "0 0 80 61",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M38.92,8.6 C27.57,8.6 18.36,17.8 18.36,29.1 L18.36,31.5 C18.36,42.8 27.57,52 38.92,52 L41.27,52 C52.63,52 61.83,42.8 61.83,31.5 L61.83,29.1 C61.83,17.8 52.63,8.6 41.27,8.6 L38.92,8.6 Z M43.77,31.8 C46.65,31.8 48.98,29.5 48.98,26.6 C48.98,23.8 46.65,21.4 43.77,21.4 C40.9,21.4 38.57,23.8 38.57,26.6 C38.57,29.5 40.9,31.8 43.77,31.8 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M61.01,9.4 C49.29,-2.3 30.29,-2.3 18.58,9.4 L2.56,25.4 C-0.31,28.3 -0.31,32.9 2.56,35.8 L18.58,51.8 C30.29,63.5 49.29,63.5 61.01,51.8 L77.02,35.8 C79.89,32.9 79.89,28.3 77.02,25.4 L61.01,9.4 Z M40.1,8.6 C28.09,8.6 18.36,18.3 18.36,30.3 C18.36,42.3 28.09,52 40.1,52 C52.1,52 61.83,42.3 61.83,30.3 C61.83,18.3 52.1,8.6 40.1,8.6 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M40.1,41 C46.02,41 50.81,36.2 50.81,30.3 C50.81,24.4 46.02,19.6 40.1,19.6 C34.18,19.6 29.38,24.4 29.38,30.3 C29.38,36.2 34.18,41 40.1,41 Z M43.77,31.8 C46.65,31.8 48.98,29.5 48.98,26.6 C48.98,23.8 46.65,21.4 43.77,21.4 C40.9,21.4 38.57,23.8 38.57,26.6 C38.57,29.5 40.9,31.8 43.77,31.8 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("4a6nf", function(module, exports) {

$parcel$export(module.exports, "Flag", function () { return $307d0a52a6725b33$export$48ea269755562084; });

var $1rY3h = parcelRequire("1rY3h");
var $307d0a52a6725b33$export$48ea269755562084 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-flag",
        width: size,
        height: size,
        viewBox: "0 0 60 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M6.05,3.41 L6.05,3.41 L6.05,47.67 L55.43,47.67 C58.43,47.67 60.11,44.2 58.24,41.85 L47.04,27.77 C46,26.47 46,24.61 47.04,23.31 L58.24,9.23 C60.11,6.88 58.43,3.41 55.43,3.41 L6.05,3.41 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M6.05,62.03 C6.05,63.51 4.84,64.72 3.35,64.72 C1.91,64.72 0.73,63.58 0.67,62.15 L0.66,62.03 L0.66,3.41 C0.66,1.92 1.87,0.72 3.35,0.72 C4.8,0.72 5.98,1.86 6.04,3.28 L6.05,3.41 L6.05,62.03 Z",
                        fillRule: "nonzero",
                        opacity: "0.5"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("fv9M2", function(module, exports) {

$parcel$export(module.exports, "Gravestone", function () { return $b491551fa40ebc29$export$71acb15b0a4f55c2; });

var $1rY3h = parcelRequire("1rY3h");
var $b491551fa40ebc29$export$71acb15b0a4f55c2 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-gravestone",
        width: size,
        height: size,
        viewBox: "0 0 64 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M57.12,59.3 L57.12,25.7 C57.12,11.9 45.95,0.7 32.18,0.7 C18.4,0.7 7.24,11.9 7.24,25.7 L7.24,59.3 L57.12,59.3 Z M20.16,24.5 C20.16,23 21.37,21.8 22.86,21.8 L41.49,21.8 C42.98,21.8 44.2,23 44.2,24.5 C44.2,26 42.98,27.2 41.49,27.2 L22.86,27.2 C21.37,27.2 20.16,26 20.16,24.5 Z M27.07,32.6 C25.57,32.6 24.36,33.8 24.36,35.3 C24.36,36.8 25.57,38 27.07,38 L36.68,38 C38.18,38 39.39,36.8 39.39,35.3 C39.39,33.8 38.18,32.6 36.68,32.6 L27.07,32.6 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M0.93,62 C0.93,60.5 2.14,59.3 3.63,59.3 L60.72,59.3 C62.21,59.3 63.43,60.5 63.43,62 C63.43,63.5 62.21,64.7 60.72,64.7 L3.63,64.7 C2.14,64.7 0.93,63.5 0.93,62 Z",
                        opacity: "0.5"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("cZBJi", function(module, exports) {

$parcel$export(module.exports, "Headset", function () { return $975872d5a1743632$export$2d2afa4e2c836258; });

var $1rY3h = parcelRequire("1rY3h");
var $975872d5a1743632$export$2d2afa4e2c836258 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-headset",
        width: size,
        height: size,
        viewBox: "0 0 65 64",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M32.93,0.16 C45.84,0.16 56.33,10.52 56.54,23.39 L56.54,23.78 L56.54,31.85 C56.54,33.4 55.29,34.65 53.74,34.65 C52.24,34.65 51.02,33.47 50.95,31.99 L50.95,31.85 L50.95,23.78 C50.95,13.82 42.88,5.76 32.93,5.76 C23.08,5.76 15.07,13.66 14.91,23.48 L14.91,23.78 L14.91,31.85 C14.91,33.4 13.66,34.65 12.11,34.65 C10.61,34.65 9.39,33.47 9.32,31.99 L9.32,31.85 L9.32,23.78 C9.32,10.74 19.89,0.16 32.93,0.16 Z",
                        fillRule: "nonzero",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M53.74,43.97 C55.24,43.97 56.47,45.15 56.54,46.64 L56.54,46.77 L56.54,50.18 C56.54,55.78 52.06,60.33 46.49,60.43 L46.29,60.44 L32.93,60.44 C31.38,60.44 30.13,59.18 30.13,57.64 C30.13,56.14 31.31,54.92 32.8,54.85 L32.93,54.84 L46.29,54.84 C48.81,54.84 50.87,52.84 50.94,50.34 L50.95,50.18 L50.95,46.77 C50.95,45.22 52.2,43.97 53.74,43.97 Z",
                        fillRule: "nonzero",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M5.9,33.1 C5.9,28.98 9.24,25.64 13.35,25.64 L16.46,25.64 C17.49,25.64 18.33,26.48 18.33,27.5 L18.33,48.01 C18.33,49.04 17.49,49.87 16.46,49.87 L13.35,49.87 C9.24,49.87 5.9,46.54 5.9,42.42 L5.9,33.1 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M47.53,27.5 C47.53,26.48 48.36,25.64 49.39,25.64 L52.5,25.64 C56.62,25.64 59.96,28.98 59.96,33.1 L59.96,42.42 C59.96,46.54 56.62,49.87 52.5,49.87 L49.39,49.87 C48.36,49.87 47.53,49.04 47.53,48.01 L47.53,27.5 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M0.93,35.58 C0.93,33.52 2.6,31.85 4.66,31.85 L5.9,31.85 L5.9,43.66 L4.66,43.66 C2.6,43.66 0.93,41.99 0.93,39.93 L0.93,35.58 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M64.93,35.58 C64.93,33.52 63.26,31.85 61.2,31.85 L59.96,31.85 L59.96,43.66 L61.2,43.66 C63.26,43.66 64.93,41.99 64.93,39.93 L64.93,35.58 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M27.02,57.64 C27.02,54.21 29.81,51.43 33.24,51.43 C36.67,51.43 39.45,54.21 39.45,57.64 C39.45,61.07 36.67,63.85 33.24,63.85 C29.81,63.85 27.02,61.07 27.02,57.64 Z",
                        fillRule: "nonzero"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("fPdFb", function(module, exports) {

$parcel$export(module.exports, "Heart", function () { return $b85637aa9a5dfed4$export$51def8c33e56fa36; });

var $1rY3h = parcelRequire("1rY3h");
var $b85637aa9a5dfed4$export$51def8c33e56fa36 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-heart",
        width: size,
        height: size,
        viewBox: "0 0 65 58",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M6.39,6.43 C13.74,-0.98 25.66,-0.98 33.01,6.43 L59.51,33.14 L37.55,55.27 C34.98,57.86 30.79,57.86 28.23,55.27 L6.39,33.27 C-0.96,25.86 -0.96,13.84 6.39,6.43 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M59.37,6.43 C52.02,-0.98 40.1,-0.98 32.75,6.43 L6.25,33.14 L28.21,55.27 C30.78,57.86 34.97,57.86 37.53,55.27 L59.37,33.27 C66.72,25.86 66.72,13.84 59.37,6.43 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("7OC0z", function(module, exports) {

$parcel$export(module.exports, "HeartRate", function () { return $5b0aaf8770872548$export$c21e70669a708ef7; });

var $1rY3h = parcelRequire("1rY3h");
var $5b0aaf8770872548$export$c21e70669a708ef7 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-heart rate",
        width: size,
        height: size,
        viewBox: "0 0 65 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M57.99,0.88 C61.82,0.88 64.93,3.98 64.93,7.81 L64.93,30.39 L46.94,30.39 L40.3,19.32 L40.23,19.21 C38.96,17.3 36.02,17.64 35.26,19.84 L28.69,38.79 L24.81,31.83 L24.74,31.71 C24.23,30.89 23.33,30.39 22.36,30.39 L0.93,30.39 L0.93,7.81 C0.93,3.98 4.03,0.88 7.87,0.88 L57.99,0.88 Z M0.93,35.98 L0.93,57.94 C0.93,61.77 4.03,64.88 7.87,64.88 L57.99,64.88 C61.82,64.88 64.93,61.77 64.93,57.94 L64.93,35.98 L45.35,35.98 C44.42,35.98 43.55,35.52 43.04,34.75 L42.96,34.62 L38.58,27.33 L31.92,46.53 C31.15,48.77 28.13,49.07 26.91,47.09 L26.84,46.97 L20.72,35.98 L0.93,35.98 Z M18.95,12.37 C18.95,15.29 16.58,17.65 13.67,17.65 C10.75,17.65 8.38,15.29 8.38,12.37 C8.38,9.45 10.75,7.09 13.67,7.09 C16.58,7.09 18.95,9.45 18.95,12.37 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M64.93,8.33 C64.93,4.21 61.59,0.88 57.47,0.88 L8.38,0.88 C4.27,0.88 0.93,4.21 0.93,8.33 L0.93,57.42 C0.93,61.54 4.27,64.87 8.38,64.87 L57.47,64.87 C61.59,64.87 64.93,61.54 64.93,57.42 L64.93,8.33 Z M13.67,17.65 C16.58,17.65 18.95,15.29 18.95,12.37 C18.95,9.45 16.58,7.09 13.67,7.09 C10.75,7.09 8.38,9.45 8.38,12.37 C8.38,15.29 10.75,17.65 13.67,17.65 Z",
                        opacity: "0.5"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("4IVy6", function(module, exports) {

$parcel$export(module.exports, "Home", function () { return $3707e98c4f891bb8$export$b94310965bed44e6; });

var $1rY3h = parcelRequire("1rY3h");
var $3707e98c4f891bb8$export$b94310965bed44e6 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-home",
        width: size,
        height: size,
        viewBox: "0 0 65 58",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M23.75,57.71 L23.75,34.1 C23.75,32.19 25.3,30.63 27.22,30.63 L37.86,30.63 C39.78,30.63 41.33,32.19 41.33,34.1 L41.33,57.71 L23.75,57.71 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M5.1,23.42 L5.1,51.37 C5.1,54.9 7.96,57.76 11.49,57.76 L53.59,57.76 C57.12,57.76 59.98,54.9 59.98,51.37 L59.98,23.77 L32.27,5.46 L5.1,23.42 Z M23.7,57.72 L23.7,33.83 C23.7,32.07 25.13,30.64 26.9,30.64 L38.09,30.64 C39.85,30.64 41.29,32.07 41.29,33.83 L41.29,57.72 L23.7,57.72 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M31.11,1.08 C31.8,0.62 32.68,0.6 33.39,1.01 L33.49,1.08 L63.33,20.79 C64.33,21.45 64.6,22.79 63.94,23.78 C63.31,24.75 62.03,25.03 61.05,24.46 L60.95,24.39 L32.3,5.46 L3.65,24.39 C2.69,25.03 1.4,24.79 0.72,23.88 L0.66,23.78 C0.02,22.82 0.26,21.54 1.18,20.86 L1.27,20.79 L31.11,1.08 Z",
                        fillRule: "nonzero",
                        opacity: "0.5"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("9fn0O", function(module, exports) {

$parcel$export(module.exports, "HourGlass", function () { return $6bb75d8278dce3b5$export$92d3ab51febfd6ca; });

var $1rY3h = parcelRequire("1rY3h");
var $6bb75d8278dce3b5$export$92d3ab51febfd6ca = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-hour glass",
        width: size,
        height: size,
        viewBox: "0 0 41 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M20.57,39.78 C27.3,39.78 32.75,45.23 32.75,51.96 L32.75,54.63 C32.75,54.87 32.55,55.07 32.3,55.07 L8.84,55.07 C8.59,55.07 8.39,54.87 8.39,54.63 L8.39,51.96 C8.39,45.23 13.85,39.78 20.57,39.78 L20.57,39.78 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M38.41,59.89 C39.82,59.89 40.96,61.03 40.96,62.44 C40.96,63.8 39.88,64.92 38.53,64.98 L38.41,64.98 L2.73,64.98 C1.32,64.98 0.18,63.84 0.18,62.44 C0.18,61.07 1.26,59.95 2.61,59.89 L2.73,59.89 L38.41,59.89 Z",
                        fillRule: "nonzero",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M20.57,32.98 C30.42,32.98 38.41,40.97 38.41,50.83 L38.41,59.89 C38.41,59.89 38.41,59.89 38.41,59.89 L2.73,59.89 L2.73,50.83 C2.73,40.97 10.72,32.98 20.57,32.98 Z M20.57,39.78 C27.3,39.78 32.75,45.23 32.75,51.96 L32.75,54.63 C32.75,54.87 32.55,55.07 32.3,55.07 L8.84,55.07 C8.59,55.07 8.39,54.87 8.39,54.63 L8.39,51.96 C8.39,45.23 13.84,39.78 20.57,39.78 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M38.41,0.98 C39.82,0.98 40.96,2.13 40.96,3.53 C40.96,4.9 39.88,6.02 38.53,6.08 L38.41,6.08 L2.73,6.08 C1.32,6.08 0.18,4.94 0.18,3.53 C0.18,2.17 1.26,1.05 2.61,0.99 L2.73,0.98 L38.41,0.98 Z",
                        fillRule: "nonzero",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M2.73,6.08 L2.73,15.14 C2.73,25 10.72,32.98 20.57,32.98 C30.42,32.98 38.41,25 38.41,15.14 L38.41,6.08 L2.73,6.08 C2.73,6.08 2.73,6.08 2.73,6.08 Z M20.57,27.32 C27.3,27.32 32.75,21.87 32.75,15.14 L32.75,12.47 C32.75,12.23 32.55,12.03 32.3,12.03 L8.84,12.03 C8.59,12.03 8.39,12.23 8.39,12.47 L8.39,15.14 C8.39,21.87 13.84,27.32 20.57,27.32 Z"
                    }),
                    (0, $1rY3h.jsx)("rect", {
                        fillRule: "nonzero",
                        x: "6.13",
                        y: "10.9",
                        width: "28.885",
                        height: "7.9292"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("2eLrk", function(module, exports) {

$parcel$export(module.exports, "Id", function () { return $1a11b0226e84eda8$export$46b83a6aabf254e3; });

var $1rY3h = parcelRequire("1rY3h");
var $1a11b0226e84eda8$export$46b83a6aabf254e3 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-id",
        width: size,
        height: size,
        viewBox: "0 0 65 50",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M54.67,49.007 C60.22,49.007 64.72,44.508 64.72,38.958 C64.72,33.408 60.22,28.908 54.67,28.908 C49.12,28.908 44.62,33.408 44.62,38.958 C44.62,44.508 49.12,49.007 54.67,49.007 Z M60.89,37.253 C61.44,36.63 61.41,35.68 60.82,35.085 L60.74,35.014 C60.12,34.467 59.17,34.49 58.58,35.085 L53.8,39.864 L51.21,37.647 L51.13,37.584 C50.47,37.084 49.52,37.18 48.97,37.819 C48.4,38.485 48.48,39.486 49.14,40.057 L52.85,43.23 L52.93,43.295 C53.55,43.766 54.44,43.709 55,43.148 L60.82,37.329 L60.89,37.253 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsxs)("g", {
                        transform: "translate(27.000000, 14.000000)",
                        fillRule: "nonzero",
                        opacity: "0.5",
                        children: [
                            (0, $1rY3h.jsx)("path", {
                                d: "M23.92,0.67 C25.23,0.67 26.3,1.736 26.3,3.05 C26.3,4.327 25.29,5.369 24.03,5.428 L23.92,5.43 L3.29,5.43 C1.97,5.43 0.91,4.365 0.91,3.05 C0.91,1.773 1.91,0.731 3.18,0.673 L3.29,0.67 L23.92,0.67 Z"
                            }),
                            (0, $1rY3h.jsx)("path", {
                                d: "M13.34,11.248 C14.65,11.248 15.72,12.314 15.72,13.628 C15.72,14.905 14.71,15.947 13.45,16.006 L13.34,16.008 L3.29,16.008 C1.97,16.008 0.91,14.943 0.91,13.628 C0.91,12.351 1.91,11.309 3.18,11.251 L3.29,11.248 L13.34,11.248 Z"
                            })
                        ]
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M7.07,0.346 C3.56,0.346 0.72,3.187 0.72,6.693 L0.72,37.899 C0.72,41.405 3.56,44.247 7.07,44.247 L46.13,44.247 C45.17,42.71 44.62,40.898 44.62,38.957 C44.62,33.407 49.12,28.908 54.67,28.908 C56.61,28.908 58.43,29.458 59.96,30.411 L59.96,6.693 C59.96,3.187 57.12,0.346 53.62,0.346 L7.07,0.346 Z M10.24,33.819 L19.76,33.819 C21.87,33.819 23.57,32.113 23.57,30.008 L23.57,28.121 C23.57,24.43 20.48,21.414 16.76,21.414 L13.07,21.414 C9.37,21.414 6.43,24.408 6.43,28.121 L6.43,30.008 C6.43,32.113 8.14,33.819 10.24,33.819 Z M15,10.287 C12.31,10.287 10.13,12.467 10.13,15.156 C10.13,17.845 12.31,20.024 15,20.024 C17.69,20.024 19.87,17.845 19.87,15.156 C19.87,12.467 17.69,10.287 15,10.287 Z M53.3,17.049 C53.3,15.735 52.23,14.669 50.92,14.669 L30.29,14.669 L30.18,14.672 C28.91,14.73 27.91,15.772 27.91,17.049 C27.91,18.364 28.97,19.429 30.29,19.429 L50.92,19.429 L51.03,19.427 C52.29,19.368 53.3,18.326 53.3,17.049 Z M40.34,25.248 C41.65,25.248 42.72,26.313 42.72,27.628 C42.72,28.905 41.71,29.947 40.45,30.005 L40.34,30.008 L30.29,30.008 C28.97,30.008 27.91,28.942 27.91,27.628 C27.91,26.351 28.91,25.309 30.18,25.25 L30.29,25.248 L40.34,25.248 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("IDulL", function(module, exports) {

$parcel$export(module.exports, "Image", function () { return $0862bdc5ad8be99d$export$3e431a229df88919; });

var $1rY3h = parcelRequire("1rY3h");
var $0862bdc5ad8be99d$export$3e431a229df88919 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-image",
        width: size,
        height: size,
        viewBox: "0 0 65 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M59.34,5.85 L7.14,5.85 L7.14,43.13 L59.34,43.13 L59.34,5.85 Z M22.36,15.17 C18.42,15.17 15.22,18.36 15.22,22.31 C15.22,26.26 18.42,29.46 22.36,29.46 C26.31,29.46 29.51,26.26 29.51,22.31 C29.51,18.36 26.31,15.17 22.36,15.17 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M57.47,0.88 C61.59,0.88 64.93,4.21 64.93,8.33 L64.93,57.42 C64.93,61.54 61.59,64.87 57.47,64.87 L8.38,64.87 C4.27,64.87 0.93,61.54 0.93,57.42 L0.93,8.33 C0.93,4.21 4.27,0.88 8.38,0.88 L57.47,0.88 Z M9.01,8.95 L56.85,8.95 L56.85,40.02 L51.88,40.02 L51.88,40.02 L41.71,29.85 C40.47,28.61 38.46,28.64 37.26,29.9 L27.65,40.02 L27.65,40.02 L9.01,40.02 L9.01,8.95 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("hWtcH", function(module, exports) {

$parcel$export(module.exports, "Key", function () { return $d0fe81bd144e602d$export$cd0f44441c3b7719; });

var $1rY3h = parcelRequire("1rY3h");
var $d0fe81bd144e602d$export$cd0f44441c3b7719 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-key",
        width: size,
        height: size,
        viewBox: "0 0 97 45",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M42.26,12.27 L48.52,12.27 C49.67,12.27 50.61,13.2 50.61,14.35 L50.61,15.75 L89.56,15.75 C90.11,15.75 90.65,15.97 91.04,16.36 L95.91,21.23 C96.72,22.04 96.72,23.36 95.91,24.18 L91.04,29.05 C90.65,29.44 90.11,29.66 89.56,29.66 L84.16,29.66 L78.68,35.14 C77.87,35.96 76.55,35.96 75.73,35.14 L70.25,29.66 L64.77,35.14 C63.95,35.96 62.63,35.96 61.82,35.14 L56.34,29.66 L50.61,29.66 L50.61,31.05 C50.61,32.2 49.67,33.14 48.52,33.14 L42.26,33.14 L42.26,12.27 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("g", {
                        children: (0, $1rY3h.jsx)("path", {
                            d: "M0.52,22.7 C0.52,35 10.48,44.97 22.78,44.97 C35.08,44.97 45.04,35 45.04,22.7 C45.04,10.41 35.08,0.44 22.78,0.44 C10.48,0.44 0.52,10.41 0.52,22.7 Z M15.82,30.36 C20.05,30.36 23.48,26.93 23.48,22.7 C23.48,18.48 20.05,15.05 15.82,15.05 C11.6,15.05 8.17,18.48 8.17,22.7 C8.17,26.93 11.6,30.36 15.82,30.36 Z"
                        })
                    })
                ]
            })
        })
    });
};

});

parcelRegister("flNq6", function(module, exports) {

$parcel$export(module.exports, "Keyhole", function () { return $b2cf26f23f44e5f0$export$40315999b936814b; });

var $1rY3h = parcelRequire("1rY3h");
var $b2cf26f23f44e5f0$export$40315999b936814b = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-keyhole",
        width: size,
        height: size,
        viewBox: "0 0 65 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("rect", {
                        fillRule: "nonzero",
                        opacity: "0.5",
                        transform: "translate(32.040000, 32.980000) rotate(90.000000) translate(-32.040000, -32.980000) ",
                        x: "0.04",
                        y: "0.98",
                        width: "64",
                        height: "64",
                        rx: "32"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M64.04,32.98 C64.04,15.31 49.71,0.98 32.04,0.98 C14.36,0.98 0.04,15.31 0.04,32.98 C0.04,50.66 14.36,64.98 32.04,64.98 C49.71,64.98 64.04,50.66 64.04,32.98 Z M28.48,33.42 C24.97,32.01 22.49,28.58 22.49,24.56 C22.49,19.29 26.77,15.02 32.04,15.02 C37.31,15.02 41.58,19.29 41.58,24.56 C41.58,28.39 39.33,31.69 36.07,33.21 L42.35,47.71 C42.78,48.71 42.05,49.83 40.96,49.83 L23.68,49.83 C22.59,49.83 21.85,48.71 22.29,47.71 L28.48,33.42 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("g1GYo", function(module, exports) {

$parcel$export(module.exports, "Lamp", function () { return $baae12e748d6c814$export$a436f46e281334; });

var $1rY3h = parcelRequire("1rY3h");
var $baae12e748d6c814$export$a436f46e281334 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-lamp",
        width: size,
        height: size,
        viewBox: "0 0 65 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M31.83,43.6 C31.83,48 28.29,51.6 23.92,51.6 L23.67,51.6 C19.31,51.6 15.76,48 15.76,43.6 L15.76,35.5 L31.83,35.5 L31.83,43.6 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M58.13,26.5 C57.92,13.8 47.61,3.6 34.92,3.6 L29.67,3.6 L29.54,3.6 C27.71,3.7 26.25,5.2 26.25,7.1 C26.25,8.9 27.78,10.5 29.67,10.5 L34.92,10.5 L35.2,10.5 C44.1,10.6 51.28,17.9 51.28,26.8 L51.28,57.4 L43.27,57.4 C41.38,57.4 39.85,58.9 39.85,60.8 C39.85,62.7 41.38,64.3 43.27,64.3 L61.5,64.3 C63.4,64.3 64.93,62.7 64.93,60.8 C64.93,58.9 63.4,57.4 61.5,57.4 L58.13,57.4 L58.13,26.8 L58.13,26.5 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M13.91,10.8 C13.91,5.3 18.34,0.9 23.8,0.9 C29.26,0.9 33.69,5.3 33.69,10.8 L33.69,16.8 C40.78,18.4 46.05,24.8 46.05,32.4 L46.05,39.8 C46.05,41.9 44.39,43.5 42.34,43.5 L4.64,43.5 C2.59,43.5 0.93,41.9 0.93,39.8 L0.93,32.4 C0.93,24.6 6.51,18.1 13.91,16.6 L13.91,10.8 Z M41.42,31.5 C41.42,25.7 36.71,21 30.91,21 C29.37,21 28.13,22.2 28.13,23.7 C28.13,25.3 29.37,26.5 30.91,26.5 L31.06,26.5 C33.72,26.6 35.85,28.8 35.85,31.5 L35.86,31.6 C35.92,33.1 37.14,34.3 38.63,34.3 C40.17,34.3 41.42,33 41.42,31.5 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("eDZ7Y", function(module, exports) {

$parcel$export(module.exports, "Leaf", function () { return $aa941fe1bbcee21a$export$3024f3bfb62054a3; });

var $1rY3h = parcelRequire("1rY3h");
var $aa941fe1bbcee21a$export$3024f3bfb62054a3 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-leaf",
        width: size,
        height: size,
        viewBox: "0 0 65 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M15.13,52.7 C20.35,57.2 27.13,59.9 34.54,59.9 C51,59.9 64.35,46.6 64.35,30.1 L64.35,7.2 C64.35,3.4 61.24,0.3 57.41,0.3 L34.54,0.3 C18.07,0.3 4.72,13.6 4.72,30.1 C4.72,37.4 7.35,44.1 11.71,49.3 L1.34,59.7 L1.24,59.8 C0.17,60.9 0.04,62.5 0.97,63.5 C1.92,64.4 3.63,64.3 4.78,63.1 L15.13,52.7 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M41.84,0.3 L34.54,0.3 C31.8,0.3 29.14,0.7 26.63,1.4 L26.63,34.4 L41.84,19.2 L41.84,0.3 Z M21.76,3.2 C11.68,8 4.72,18.2 4.72,30.1 C4.72,37.5 7.38,44.2 11.78,49.4 C11.9,49.2 12.04,49 12.2,48.8 L12.29,48.7 L21.76,39.3 L21.76,3.2 Z M15.07,52.7 C20.3,57.2 27.1,59.9 34.54,59.9 C46.43,59.9 56.69,53 61.48,42.9 L25.02,42.9 L15.74,52.2 C15.53,52.4 15.31,52.6 15.07,52.7 Z M63.29,38 C63.98,35.5 64.35,32.9 64.35,30.1 L64.35,22.8 L45.1,22.8 L29.89,38 L63.29,38 Z M64.35,17.9 L64.35,7.6 C64.35,6.4 64.07,5.3 63.58,4.3 L49.97,17.9 L64.35,17.9 Z M60.08,1 C59.15,0.5 58.13,0.3 57.05,0.3 L46.7,0.3 L46.7,14.3 L60.08,1 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("2GfFa", function(module, exports) {

$parcel$export(module.exports, "Lego", function () { return $1f3ba75c394cb8f0$export$a5ffdce5e33c0d1c; });

var $1rY3h = parcelRequire("1rY3h");
var $1f3ba75c394cb8f0$export$a5ffdce5e33c0d1c = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-lego",
        width: size,
        height: size,
        viewBox: "0 0 65 63",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M13.35,3.8 C13.35,1.7 15.02,0 17.08,0 L23.92,0 C25.98,0 27.65,1.7 27.65,3.8 L27.65,10.6 C27.65,12.7 25.98,14.3 23.92,14.3 L17.08,14.3 C15.02,14.3 13.35,12.7 13.35,10.6 L13.35,3.8 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M38.21,3.8 C38.21,1.7 39.88,0 41.94,0 L48.77,0 C50.83,0 52.5,1.7 52.5,3.8 L52.5,10.6 C52.5,12.7 50.83,14.3 48.77,14.3 L41.94,14.3 C39.88,14.3 38.21,12.7 38.21,10.6 L38.21,3.8 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M57.47,10.6 C61.59,10.6 64.93,13.9 64.93,18.1 L64.93,54.7 C64.93,58.8 61.59,62.2 57.47,62.2 L8.38,62.2 C4.27,62.2 0.93,58.8 0.93,54.7 L0.93,18.1 C0.93,13.9 4.27,10.6 8.38,10.6 L57.47,10.6 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("iVuUd", function(module, exports) {

$parcel$export(module.exports, "Lifebouy", function () { return $dc75861e66c170f2$export$90ae7c9abc8cbf50; });

var $1rY3h = parcelRequire("1rY3h");
var $dc75861e66c170f2$export$90ae7c9abc8cbf50 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-lifebouy",
        width: size,
        height: size,
        viewBox: "0 0 65 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M2.58,29.8 C3.71,15.2 15.29,3.7 29.8,2.5 L29.8,22.5 C30.04,22.4 30.28,22.4 30.52,22.3 C25.83,23.1 22.26,27.2 22.26,32.1 C22.26,37.2 26.19,41.5 31.21,41.9 C30.73,41.9 30.26,41.8 29.8,41.7 L29.8,61.7 C15.29,60.5 3.71,48.9 2.58,34.4 L22.54,34.4 C22.36,33.7 22.26,32.9 22.26,32.1 C22.26,31.3 22.36,30.5 22.54,29.8 L2.58,29.8 Z M34.49,22.5 C38.07,23.4 40.88,26.2 41.75,29.8 L61.71,29.8 C60.58,15.2 49,3.7 34.49,2.5 L34.49,22.5 Z M41.75,34.4 L61.71,34.4 C60.58,48.9 49,60.5 34.49,61.7 L34.49,41.7 C38.07,40.8 40.88,38 41.75,34.4 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M32.14,0.1 C33.44,0.1 34.49,1.1 34.49,2.4 L34.49,22.5 C33.74,22.3 32.95,22.2 32.14,22.2 C31.34,22.2 30.55,22.3 29.8,22.5 L29.8,2.4 C29.8,1.1 30.85,0.1 32.14,0.1 Z M22.54,29.8 L2.49,29.8 C1.19,29.8 0.14,30.8 0.14,32.1 C0.14,33.4 1.19,34.4 2.49,34.4 L22.54,34.4 C22.35,33.7 22.26,32.9 22.26,32.1 C22.26,31.3 22.35,30.5 22.54,29.8 Z M29.8,41.7 L29.8,61.8 C29.8,63 30.85,64.1 32.14,64.1 C33.44,64.1 34.49,63 34.49,61.8 L34.49,41.7 C33.74,41.9 32.95,42 32.14,42 C31.34,42 30.55,41.9 29.8,41.7 Z M41.75,34.4 L61.8,34.4 C63.1,34.4 64.14,33.4 64.14,32.1 C64.14,30.8 63.1,29.8 61.8,29.8 L41.75,29.8 C41.93,30.5 42.03,31.3 42.03,32.1 C42.03,32.9 41.93,33.7 41.75,34.4 Z",
                        opacity: "0.5"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("bO06j", function(module, exports) {

$parcel$export(module.exports, "Localization", function () { return $8984713bcd3b2bd2$export$b6fc69901997e05; });

var $1rY3h = parcelRequire("1rY3h");
var $8984713bcd3b2bd2$export$b6fc69901997e05 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsxs)("svg", {
        id: "icon-object-localization",
        width: size,
        height: size,
        viewBox: "0 0 65 80",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            (0, $1rY3h.jsx)("defs", {
                children: (0, $1rY3h.jsx)("rect", {
                    x: "0.55",
                    y: "0.05",
                    width: "64",
                    height: "64",
                    rx: "32"
                })
            }),
            (0, $1rY3h.jsx)("g", {
                stroke: "none",
                strokeWidth: "1",
                fill: "none",
                fillRule: "evenodd",
                children: (0, $1rY3h.jsxs)("g", {
                    children: [
                        (0, $1rY3h.jsxs)("g", {
                            transform: "translate(0.000000, 15.000000)",
                            children: [
                                (0, $1rY3h.jsx)("mask", {
                                    fill: "white",
                                    children: (0, $1rY3h.jsx)("use", {
                                        xlinkHref: "#path-1"
                                    })
                                }),
                                (0, $1rY3h.jsx)("g", {
                                    transform: "translate(32.550000, 32.050000) rotate(-180.000000) translate(-32.550000, -32.050000) "
                                }),
                                (0, $1rY3h.jsx)("g", {
                                    mask: "url(#mask-2)",
                                    opacity: "0.5",
                                    children: (0, $1rY3h.jsxs)("g", {
                                        transform: "translate(-5.000000, -19.000000)",
                                        children: [
                                            (0, $1rY3h.jsx)("path", {
                                                d: "M3.31,60.14 C3.31,58.22 4.86,56.67 6.78,56.67 L36.23,56.67 C40.06,56.67 43.17,59.78 43.17,63.61 L43.17,83.62 L6.78,83.62 C4.86,83.62 3.31,82.06 3.31,80.15 L3.31,60.14 Z",
                                                fill: "currentColor"
                                            }),
                                            (0, $1rY3h.jsx)("path", {
                                                d: "M61.62,6.14 C57.78,6.14 54.68,9.25 54.68,13.08 L54.68,55.34 C54.68,59.18 57.78,62.28 61.62,62.28 L81.8,62.28 C83.72,62.28 85.27,60.73 85.27,58.81 L85.27,9.61 C85.27,7.7 83.72,6.14 81.8,6.14 L61.62,6.14 Z",
                                                fill: "currentColor"
                                            }),
                                            (0, $1rY3h.jsx)("path", {
                                                d: "M43.17,38.22 L43.17,0.9 L0.5,0.9 L0.5,38.22 C0.5,42.05 3.61,45.16 7.44,45.16 L36.23,45.16 C40.06,45.16 43.17,42.05 43.17,38.22 Z M23.52,23.27 C26.46,23.27 28.85,20.88 28.85,17.93 C28.85,14.99 26.46,12.6 23.52,12.6 C20.57,12.6 18.19,14.99 18.19,17.93 C18.19,20.88 20.57,23.27 23.52,23.27 Z",
                                                fill: "currentColor"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        (0, $1rY3h.jsx)("path", {
                            d: "M49.68,51.55 L49.68,20.02 C46.23,17.83 42.34,16.28 38.17,15.54 L38.17,34.42 C38.17,38.14 35.15,41.16 31.43,41.16 L2.24,41.16 C1.86,41.16 1.48,41.13 1.11,41.07 C0.75,43.01 0.55,45.01 0.55,47.05 C0.55,48.99 0.73,50.88 1.06,52.72 C1.26,52.69 1.46,52.67 1.68,52.67 L31.43,52.67 C35.15,52.67 38.17,55.68 38.17,59.4 L38.17,78.56 C49.4,76.57 58.62,68.72 62.53,58.28 L56.41,58.28 C52.69,58.28 49.68,55.27 49.68,51.55 Z",
                            fill: "currentColor"
                        }),
                        (0, $1rY3h.jsx)("path", {
                            d: "M28.24,4.21 C22.87,-1.17 14.16,-1.17 8.79,4.21 C3.42,9.58 3.42,18.29 8.79,23.66 L16.14,31 C17.45,32.32 19.59,32.32 20.9,31 L28.24,23.66 C33.62,18.29 33.62,9.58 28.24,4.21 Z M18.52,19.27 C21.46,19.27 23.85,16.88 23.85,13.93 C23.85,10.99 21.46,8.6 18.52,8.6 C15.57,8.6 13.19,10.99 13.19,13.93 C13.19,16.88 15.57,19.27 18.52,19.27 Z",
                            fill: "currentColor"
                        })
                    ]
                })
            })
        ]
    });
};

});

parcelRegister("fJxZA", function(module, exports) {

$parcel$export(module.exports, "LocationPin", function () { return $b7456d247df7d42d$export$31790a3eeff59d4a; });

var $1rY3h = parcelRequire("1rY3h");
var $b7456d247df7d42d$export$31790a3eeff59d4a = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-location pin",
        width: size,
        height: size,
        viewBox: "0 0 56 64",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsx)("g", {
                fill: "currentColor",
                children: (0, $1rY3h.jsx)("path", {
                    d: "M47.87,8.1 C37.03,-2.7 19.46,-2.7 8.62,8.1 C-2.22,18.9 -2.22,36.4 8.62,47.2 L23.43,62 C26.09,64.6 30.4,64.6 33.06,62 L47.87,47.2 C58.71,36.4 58.71,18.9 47.87,8.1 Z M28.08,38.4 C34.02,38.4 38.84,33.6 38.84,27.7 C38.84,21.7 34.02,16.9 28.08,16.9 C22.13,16.9 17.31,21.7 17.31,27.7 C17.31,33.6 22.13,38.4 28.08,38.4 Z"
                })
            })
        })
    });
};

});

parcelRegister("cSNv3", function(module, exports) {

$parcel$export(module.exports, "Lock", function () { return $9610eccd9f07146a$export$5b9db7ce80343746; });

var $1rY3h = parcelRequire("1rY3h");
var $9610eccd9f07146a$export$5b9db7ce80343746 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-lock",
        width: size,
        height: size,
        viewBox: "0 0 52 64",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M29.03,28.9 L22.85,28.9 C18.36,28.9 14.71,25.3 14.71,20.8 L14.71,11.2 C14.71,5 19.74,0 25.94,0 C32.14,0 37.17,5 37.17,11.2 L37.17,20.8 C37.17,25.3 33.52,28.9 29.03,28.9 Z M22.85,23.8 L29.03,23.8 C30.73,23.8 32.12,22.5 32.12,20.8 L32.12,11.2 C32.12,7.8 29.35,5 25.94,5 C22.53,5 19.77,7.8 19.77,11.2 L19.77,20.8 C19.77,22.5 21.15,23.8 22.85,23.8 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M7.13,17.4 C3.41,17.4 0.4,20.4 0.4,24.1 L0.4,57.2 C0.4,61 3.41,64 7.13,64 L44.75,64 C48.47,64 51.49,61 51.49,57.2 L51.49,24.1 C51.49,20.4 48.47,17.4 44.75,17.4 L7.13,17.4 Z M25.94,48.3 C29.51,48.3 32.4,45.4 32.4,41.8 C32.4,38.2 29.51,35.4 25.94,35.4 C22.38,35.4 19.49,38.2 19.49,41.8 C19.49,45.4 22.38,48.3 25.94,48.3 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("2HPqn", function(module, exports) {

$parcel$export(module.exports, "LockPassword", function () { return $1f877cc4fcc6a85e$export$caed512d16ef56b1; });

var $1rY3h = parcelRequire("1rY3h");
var $1f877cc4fcc6a85e$export$caed512d16ef56b1 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-lock password",
        width: size,
        height: size,
        viewBox: "0 0 73 64",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M39.08,30.7 C32.3,30.7 26.81,25.2 26.81,18.4 C26.81,11.7 32.3,6.2 39.08,6.2 L59.85,6.2 C66.63,6.2 72.12,11.7 72.12,18.4 C72.12,25.2 66.63,30.7 59.85,30.7 L39.08,30.7 Z M64.06,18.4 C64.06,16.6 62.56,15.1 60.7,15.1 C58.84,15.1 57.33,16.6 57.33,18.4 C57.33,20.3 58.84,21.8 60.7,21.8 C62.56,21.8 64.06,20.3 64.06,18.4 Z M49.47,15.1 C51.33,15.1 52.84,16.6 52.84,18.4 C52.84,20.3 51.33,21.8 49.47,21.8 C47.61,21.8 46.1,20.3 46.1,18.4 C46.1,16.6 47.61,15.1 49.47,15.1 Z M41.61,18.4 C41.61,16.6 40.1,15.1 38.24,15.1 C36.38,15.1 34.87,16.6 34.87,18.4 C34.87,20.3 36.38,21.8 38.24,21.8 C40.1,21.8 41.61,20.3 41.61,18.4 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M52.08,30.7 L52.08,57.2 C52.08,61 49.06,64 45.34,64 L7.72,64 C4,64 0.99,61 0.99,57.2 L0.99,24.1 C0.99,20.4 4,17.4 7.72,17.4 L15.3,17.4 L15.3,11.2 C15.3,5 20.33,0 26.53,0 C31.01,0 34.87,2.6 36.68,6.4 C34.97,6.7 33.4,7.4 32.03,8.4 C31,6.4 28.92,5 26.53,5 C23.12,5 20.36,7.8 20.36,11.2 L20.36,17.4 L26.86,17.4 C26.83,17.7 26.81,18.1 26.81,18.4 C26.81,25.2 32.31,30.7 39.08,30.7 L52.08,30.7 Z M26.53,48.3 C30.1,48.3 32.99,45.4 32.99,41.8 C32.99,38.2 30.1,35.4 26.53,35.4 C22.97,35.4 20.07,38.2 20.07,41.8 C20.07,45.4 22.97,48.3 26.53,48.3 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("c3DOg", function(module, exports) {

$parcel$export(module.exports, "MagicWand", function () { return $8c74a53b7b5b2dd7$export$8b253004761c5525; });

var $1rY3h = parcelRequire("1rY3h");
var $8c74a53b7b5b2dd7$export$8b253004761c5525 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-magic wand",
        width: size,
        height: size,
        viewBox: "0 0 65 64",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsxs)("g", {
                        transform: "translate(0.000000, 1.000000)",
                        children: [
                            (0, $1rY3h.jsx)("path", {
                                d: "M41.03,14.9 L48.08,22 L62.26,7.8 C62.99,7.1 62.99,5.9 62.26,5.2 L57.84,0.7 C57.11,2.77555756e-17 55.93,2.77555756e-17 55.21,0.7 L41.03,14.9 Z",
                                opacity: "0.5"
                            }),
                            (0, $1rY3h.jsx)("path", {
                                d: "M48.08,22 L41.03,14.9 L1.81,54.1 C-0.14,56.1 -0.14,59.2 1.81,61.2 C3.76,63.1 6.92,63.1 8.87,61.2 L48.08,22 Z M50.95,5 L50.95,5 L41.03,14.9 L50.95,5 Z"
                            })
                        ]
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M41.93,4.2 C41.93,6.2 40.26,7.9 38.21,7.9 C36.16,7.9 34.49,6.2 34.49,4.2 C34.49,2.1 36.16,0.5 38.21,0.5 C40.26,0.5 41.93,2.1 41.93,4.2 Z",
                        fillRule: "nonzero",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsxs)("g", {
                        transform: "translate(48.000000, 27.000000)",
                        children: [
                            (0, $1rY3h.jsx)("path", {
                                d: "M8.04,4.7 C8.32,4.6 8.64,4.6 8.93,4.7 L15.56,7.3 C16.61,7.7 16.61,9.2 15.56,9.6 L8.93,12.2 C8.64,12.3 8.32,12.3 8.04,12.2 L1.41,9.6 C0.35,9.2 0.35,7.7 1.41,7.3 L8.04,4.7 Z"
                            }),
                            (0, $1rY3h.jsx)("path", {
                                d: "M7.33,1.4 C7.73,0.3 9.23,0.3 9.64,1.4 L12.19,8 C12.3,8.3 12.3,8.6 12.19,8.9 L9.64,15.5 C9.23,16.6 7.73,16.6 7.33,15.5 L4.77,8.9 C4.66,8.6 4.66,8.3 4.77,8 L7.33,1.4 Z"
                            })
                        ]
                    }),
                    (0, $1rY3h.jsxs)("g", {
                        transform: "translate(15.000000, 5.000000)",
                        children: [
                            (0, $1rY3h.jsx)("path", {
                                d: "M8.21,5.1 C8.49,5 8.81,5 9.1,5.1 L15.72,7.6 C16.78,8 16.78,9.5 15.72,9.9 L9.1,12.5 C8.81,12.6 8.49,12.6 8.21,12.5 L1.58,9.9 C0.52,9.5 0.52,8 1.58,7.6 L8.21,5.1 Z"
                            }),
                            (0, $1rY3h.jsx)("path", {
                                d: "M7.49,1.7 C7.9,0.6 9.4,0.6 9.81,1.7 L12.36,8.3 C12.47,8.6 12.47,8.9 12.36,9.2 L9.81,15.8 C9.4,16.9 7.9,16.9 7.49,15.8 L4.94,9.2 C4.83,8.9 4.83,8.6 4.94,8.3 L7.49,1.7 Z"
                            })
                        ]
                    })
                ]
            })
        })
    });
};

});

parcelRegister("axYxr", function(module, exports) {

$parcel$export(module.exports, "MagnifyingGlass", function () { return $7adbf21d05eab05a$export$bdf537af43a20db5; });

var $1rY3h = parcelRequire("1rY3h");
var $7adbf21d05eab05a$export$bdf537af43a20db5 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-magnifying glass",
        width: size,
        height: size,
        viewBox: "0 0 65 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M62.55,56.2 C64.53,58.2 64.53,61.4 62.55,63.4 C60.57,65.4 57.35,65.4 55.37,63.4 L39.74,47.8 L46.92,40.6 L62.55,56.2 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M55.11,28 C55.11,13 42.98,0.9 28.02,0.9 C13.06,0.9 0.93,13 0.93,28 C0.93,42.9 13.06,55.1 28.02,55.1 C42.98,55.1 55.11,42.9 55.11,28 Z M28.02,49.6 C39.85,49.6 49.44,40 49.44,28.2 C49.44,16.3 39.85,6.7 28.02,6.7 C16.19,6.7 6.6,16.3 6.6,28.2 C6.6,40 16.19,49.6 28.02,49.6 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M28.02,49.6 C39.85,49.6 49.44,40 49.44,28.2 C49.44,16.3 39.85,6.7 28.02,6.7 C16.19,6.7 6.6,16.3 6.6,28.2 C6.6,40 16.19,49.6 28.02,49.6 Z M14.19,27.7 C14.19,29.2 15.46,30.5 17.02,30.5 C18.59,30.5 19.86,29.2 19.86,27.7 L19.86,27.4 C19.86,23.9 22.72,21.1 26.48,21.1 C28.04,21.1 29.31,19.8 29.31,18.2 C29.31,16.7 28.04,15.4 26.48,15.4 C19.79,15.4 14.19,20.6 14.19,27.4 L14.19,27.7 Z",
                        opacity: "0.5"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("9hy0Y", function(module, exports) {

$parcel$export(module.exports, "Mailbox", function () { return $6c201630056fd610$export$a7410dfcb4ee500e; });

var $1rY3h = parcelRequire("1rY3h");
var $6c201630056fd610$export$a7410dfcb4ee500e = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-mailbox",
        width: size,
        height: size,
        viewBox: "0 0 65 89",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M32.93,54.1 C34.43,54.1 35.65,55.2 35.72,56.7 L35.72,56.9 L35.72,86.1 C35.72,87.6 34.47,88.9 32.93,88.9 C31.43,88.9 30.2,87.7 30.13,86.2 L30.13,86.1 L30.13,56.9 C30.13,55.3 31.38,54.1 32.93,54.1 Z",
                        fillRule: "nonzero",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M27.65,29 C27.65,25.2 24.54,22.1 20.71,22.1 L7.87,22.1 C4.03,22.1 0.93,25.2 0.93,29 L0.93,57.7 C0.93,59.6 2.48,61.2 4.4,61.2 L24.18,61.2 C26.09,61.2 27.65,59.6 27.65,57.7 L27.65,29 Z M7.45,51.3 C7.45,52.8 8.7,54.1 10.25,54.1 L18.95,54.1 L19.08,54.1 C20.56,54 21.74,52.8 21.74,51.3 C21.74,49.7 20.49,48.5 18.95,48.5 L10.25,48.5 L10.12,48.5 C8.63,48.5 7.45,49.8 7.45,51.3 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M22.05,61.2 L22.05,61.2 L61.2,61.2 C63.26,61.2 64.93,59.5 64.93,57.5 L64.93,29.5 C64.93,25.4 61.59,22.1 57.47,22.1 L22.05,22.1 L22.05,22.3 C25.27,23.1 27.65,26 27.65,29.5 L27.65,57.5 C27.65,59.5 25.98,61.2 23.92,61.2 L22.05,61.2 Z"
                    }),
                    (0, $1rY3h.jsxs)("g", {
                        transform: "translate(11.000000, 0.000000)",
                        children: [
                            (0, $1rY3h.jsx)("path", {
                                d: "M0.49,9 L0.49,22.4 L0.49,22.5 C0.56,24 1.79,25.2 3.29,25.2 C4.83,25.2 6.08,23.9 6.08,22.4 L6.08,9 L0.49,9 Z"
                            }),
                            (0, $1rY3h.jsx)("path", {
                                d: "M0.49,2.2 C0.49,1.1 1.33,0.3 2.36,0.3 L12.92,0.3 C13.95,0.3 14.78,1.1 14.78,2.2 L14.78,7.1 C14.78,8.2 13.95,9 12.92,9 L0.49,9 L0.49,2.2 Z",
                                opacity: "0.5"
                            })
                        ]
                    })
                ]
            })
        })
    });
};

});

parcelRegister("8EIOd", function(module, exports) {

$parcel$export(module.exports, "Medic", function () { return $64d4d14a22aa0232$export$65495339c2c2b0ff; });

var $1rY3h = parcelRequire("1rY3h");
var $64d4d14a22aa0232$export$65495339c2c2b0ff = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-medic",
        width: size,
        height: size,
        viewBox: "0 0 63 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M20.87,11.4 C20.87,5.5 25.67,0.7 31.59,0.7 C37.51,0.7 42.3,5.5 42.3,11.4 L42.3,19.5 C42.3,21 41.11,22.2 39.63,22.2 L23.55,22.2 C22.07,22.2 20.87,21 20.87,19.5 L20.87,11.4 Z M31.59,6.1 C28.63,6.1 26.23,8.5 26.23,11.4 L26.23,16.8 L36.95,16.8 L36.95,11.4 C36.95,8.5 34.55,6.1 31.59,6.1 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M62.25,22.4 C62.25,18.5 59.05,15.3 55.1,15.3 L8.07,15.3 C4.13,15.3 0.93,18.5 0.93,22.4 L0.93,57.6 C0.93,61.5 4.13,64.7 8.07,64.7 L55.1,64.7 C59.05,64.7 62.25,61.5 62.25,57.6 L62.25,22.4 Z M43.59,40.2 C43.59,41.7 42.4,42.9 40.92,42.9 L34.2,42.9 L34.2,49.5 L34.2,49.6 C34.13,51 32.96,52.2 31.52,52.2 L31.38,52.2 C29.97,52.1 28.84,50.9 28.84,49.5 L28.84,42.9 L22.26,42.9 L22.12,42.9 C20.71,42.8 19.58,41.7 19.58,40.2 C19.58,38.7 20.78,37.5 22.26,37.5 L28.98,37.5 L28.98,31 L28.98,30.8 C29.05,29.4 30.22,28.3 31.65,28.3 L31.79,28.3 C33.21,28.4 34.33,29.5 34.33,31 L34.33,37.6 L40.92,37.6 L41.05,37.6 C42.47,37.6 43.59,38.8 43.59,40.2 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("akmn5", function(module, exports) {

$parcel$export(module.exports, "Megaphone", function () { return $784d201b9625a2b1$export$79c66221ddbb3eb1; });

var $1rY3h = parcelRequire("1rY3h");
var $784d201b9625a2b1$export$79c66221ddbb3eb1 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-megaphone",
        width: size,
        height: size,
        viewBox: "0 0 64 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M36.64,36.6 L30.22,36.6 C25.55,36.6 21.77,40.4 21.77,45 L21.77,52.9 C21.77,59.4 26.99,64.6 33.43,64.6 C39.87,64.6 45.09,59.4 45.09,52.9 L45.09,45 C45.09,40.4 41.31,36.6 36.64,36.6 Z M30.22,41.8 L36.64,41.8 C38.41,41.8 39.85,43.3 39.85,45 L39.85,52.9 C39.85,56.5 36.97,59.3 33.43,59.3 C29.89,59.3 27.02,56.5 27.02,52.9 L27.02,45 C27.02,43.3 28.45,41.8 30.22,41.8 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M3.4,39.2 L58.99,55.4 C61.23,56.1 63.47,54.4 63.47,52 L63.47,4.1 C63.47,1.6 60.99,-0.1 58.7,0.8 L3.4,22.3 L3.4,39.2 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M3.4,18.5 C4.8,18.5 5.95,19.6 6.02,21 L6.02,21.1 L6.02,40.4 C6.02,41.8 4.85,43 3.4,43 C1.99,43 0.84,41.9 0.77,40.5 L0.77,40.4 L0.77,21.1 C0.77,19.7 1.95,18.5 3.4,18.5 Z",
                        fillRule: "nonzero",
                        opacity: "0.5"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("2fx8N", function(module, exports) {

$parcel$export(module.exports, "OneUp", function () { return $1a36b08e1601c599$export$9e58e91dd5b2ef24; });

var $1rY3h = parcelRequire("1rY3h");
var $1a36b08e1601c599$export$9e58e91dd5b2ef24 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-1up",
        width: size,
        height: size,
        viewBox: "0 0 53 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M6.93,42.368 C6.93,40.452 8.49,38.898 10.4,38.898 L42.66,38.898 C44.57,38.898 46.13,40.452 46.13,42.368 L46.13,58.008 C46.13,61.841 43.02,64.948 39.19,64.948 L13.87,64.948 C10.04,64.948 6.93,61.841 6.93,58.008 L6.93,42.368 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M33.75,1.9735 C32.53,3.7442 31.82,5.8909 31.82,8.2046 L31.82,9.8695 C31.82,15.938 36.74,20.8575 42.8,20.8575 L44.47,20.8575 C46.94,20.8575 49.22,20.0433 51.05,18.6688 C51.89,21.216 52.35,23.9386 52.35,26.7675 L52.35,47.053 C52.35,50.109 49.87,52.586 46.82,52.586 L46.13,52.586 L46.13,42.632 C46.13,40.57 44.45,38.899 42.39,38.899 L10.66,38.899 C8.6,38.899 6.93,40.57 6.93,42.632 L6.93,52.586 L6.24,52.586 C3.19,52.586 0.71,50.109 0.71,47.053 L0.71,26.7675 C0.71,12.5085 12.27,0.9492 26.53,0.9492 C29.04,0.9492 31.46,1.3067 33.75,1.9735 Z M15.64,12.147 C12.21,12.147 9.42,14.9324 9.42,18.3683 C9.42,21.8042 12.21,24.5896 15.64,24.5896 C19.08,24.5896 21.86,21.8042 21.86,18.3683 C21.86,14.9324 19.08,12.147 15.64,12.147 Z M33.06,30.8127 C33.06,28.064 35.29,25.8357 38.04,25.8357 C40.79,25.8357 43.02,28.064 43.02,30.8127 C43.02,33.5614 40.79,35.79 38.04,35.79 C35.29,35.79 33.06,33.5614 33.06,30.8127 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M20.84,48.359 C22.54,48.359 23.91,49.733 23.91,51.427 L23.91,53.124 C23.91,54.818 22.54,56.191 20.84,56.191 C19.15,56.191 17.78,54.818 17.78,53.124 L17.78,51.427 C17.78,49.733 19.15,48.359 20.84,48.359 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M32.04,48.359 C33.74,48.359 35.11,49.733 35.11,51.427 L35.11,53.124 C35.11,54.818 33.74,56.191 32.04,56.191 C30.35,56.191 28.98,54.818 28.98,53.124 L28.98,51.427 C28.98,49.733 30.35,48.359 32.04,48.359 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M33.47,1.8945 C31.92,4.0011 31,6.6373 31,9.498 C31,16.4015 36.37,21.998 43,21.998 C46.11,21.998 48.94,20.7652 51.08,18.7431 C48.41,10.5822 41.79,4.2106 33.47,1.8945 Z",
                        fillRule: "nonzero",
                        opacity: "0.5"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("5DZ5M", function(module, exports) {

$parcel$export(module.exports, "PaperPlane", function () { return $41bffbed2b7d5b61$export$d99b69494bb1cd29; });

var $1rY3h = parcelRequire("1rY3h");
var $41bffbed2b7d5b61$export$d99b69494bb1cd29 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-paper plane",
        width: size,
        height: size,
        viewBox: "0 0 60 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsxs)("g", {
                        transform: "translate(17.000000, 53.000000)",
                        fillRule: "nonzero",
                        children: [
                            (0, $1rY3h.jsx)("g", {
                                transform: "translate(13.000000, 0.000000)",
                                opacity: "0.5",
                                children: (0, $1rY3h.jsx)("g", {
                                    children: (0, $1rY3h.jsx)("path", {
                                        d: "M0.14,11.3 C2.43,11.4 4.76,10.4 6.33,8.4 L12.73,0.3 L0.14,0.3 L0.14,11.3 Z"
                                    })
                                })
                            }),
                            (0, $1rY3h.jsx)("g", {
                                children: (0, $1rY3h.jsx)("path", {
                                    d: "M13.14,11.3 C10.85,11.4 8.52,10.4 6.95,8.4 L0.56,0.3 L13.14,0.3 L13.14,11.3 Z"
                                })
                            })
                        ]
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M28.53,1.2 C28.53,1.2 28.53,1.2 28.53,1.2 L1.33,47.7 C1.32,47.7 1.31,47.7 1.3,47.7 C0.99,48.3 0.82,48.9 0.82,49.5 C0.82,50 0.91,50.5 1.08,50.9 C1.17,51.2 1.3,51.4 1.44,51.6 C2.11,52.6 3.26,53.3 4.56,53.3 L30.14,53.3 L30.14,0.3 C29.52,0.3 28.9,0.6 28.53,1.2 Z",
                        fillRule: "nonzero",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("g", {
                        transform: "translate(30.000000, 0.000000)",
                        children: (0, $1rY3h.jsx)("path", {
                            d: "M29.01,47.8 C28.99,47.7 28.97,47.7 28.95,47.7 L1.74,1.2 C1.38,0.6 0.76,0.3 0.14,0.3 L0.14,53.3 L25.72,53.3 C27.01,53.3 28.15,52.6 28.82,51.6 C28.98,51.4 29.11,51.1 29.22,50.9 C29.38,50.5 29.46,50 29.46,49.5 C29.46,48.9 29.31,48.3 29.01,47.8 Z"
                        })
                    })
                ]
            })
        })
    });
};

});

parcelRegister("32N3Z", function(module, exports) {

$parcel$export(module.exports, "PartyPopper", function () { return $23779df835c52cc8$export$f0462cf72e962b45; });

var $1rY3h = parcelRequire("1rY3h");
var $23779df835c52cc8$export$f0462cf72e962b45 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-party popper",
        width: size,
        height: size,
        viewBox: "0 0 65 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsxs)("g", {
                        transform: "translate(37.000000, 0.000000)",
                        children: [
                            (0, $1rY3h.jsxs)("g", {
                                opacity: "0.5",
                                children: [
                                    (0, $1rY3h.jsx)("path", {
                                        d: "M8.38,12.3 C8.67,12.4 9,12.4 9.29,12.3 L16.05,9.7 C17.13,9.2 17.13,7.7 16.05,7.3 L9.29,4.7 C9,4.6 8.67,4.6 8.38,4.7 L1.62,7.3 C0.54,7.7 0.54,9.2 1.62,9.7 L8.38,12.3 Z"
                                    }),
                                    (0, $1rY3h.jsx)("path", {
                                        d: "M7.66,15.7 C8.07,16.8 9.6,16.8 10.02,15.7 L12.62,8.9 C12.73,8.6 12.73,8.3 12.62,8 L10.02,1.3 C9.6,0.2 8.07,0.2 7.66,1.3 L5.05,8 C4.94,8.3 4.94,8.6 5.05,8.9 L7.66,15.7 Z"
                                    })
                                ]
                            }),
                            (0, $1rY3h.jsx)("path", {
                                d: "M24.95,21.4 C24.95,19.3 23.25,17.6 21.16,17.6 C19.06,17.6 17.37,19.3 17.37,21.4 C17.37,23.5 19.06,25.2 21.16,25.2 C23.25,25.2 24.95,23.5 24.95,21.4 Z",
                                fillRule: "nonzero"
                            }),
                            (0, $1rY3h.jsx)("path", {
                                d: "M27.47,4.4 C27.47,2.3 25.78,0.6 23.68,0.6 C21.59,0.6 19.89,2.3 19.89,4.4 C19.89,6.5 21.59,8.2 23.68,8.2 C25.78,8.2 27.47,6.5 27.47,4.4 Z",
                                fillRule: "nonzero",
                                opacity: "0.5"
                            })
                        ]
                    }),
                    (0, $1rY3h.jsxs)("g", {
                        transform: "translate(0.000000, 3.000000)",
                        fillRule: "nonzero",
                        children: [
                            (0, $1rY3h.jsx)("polygon", {
                                points: "14.39 16.6 10.16 29.6 31.64 51.1 44.32 46.5"
                            }),
                            (0, $1rY3h.jsx)("polygon", {
                                points: "3.96 48.7 8.18 35.7 25.73 53.2 13.05 57.7"
                            }),
                            (0, $1rY3h.jsx)("path", {
                                d: "M1.98,54.7 L0.6,59 C0.47,59.4 0.48,59.8 0.62,60.2 C0.97,61.2 2.06,61.7 3.04,61.3 L7.14,59.9 L1.98,54.7 Z"
                            }),
                            (0, $1rY3h.jsx)("path", {
                                d: "M50.23,44.4 L58.68,41.4 C59.24,41.2 59.74,40.8 60.15,40.4 C61.59,38.9 61.53,36.5 60.01,35 L24.92,1.7 C24.51,1.3 24.02,1 23.48,0.9 C21.49,0.2 19.36,1.3 18.71,3.3 L16.36,10.5 L50.23,44.4 Z"
                            })
                        ]
                    }),
                    (0, $1rY3h.jsxs)("g", {
                        opacity: "0.5",
                        transform: "translate(1.000000, 12.000000)",
                        fillRule: "nonzero",
                        children: [
                            (0, $1rY3h.jsx)("polygon", {
                                points: "15.86 0 15.36 1.5 49.23 35.4 43.32 37.5 13.39 7.6 12.45 10.5"
                            }),
                            (0, $1rY3h.jsx)("polygon", {
                                points: "2.96 39.7 0.98 45.7 6.14 50.9 12.05 48.7"
                            }),
                            (0, $1rY3h.jsx)("polygon", {
                                points: "24.73 44.2 7.18 26.7 5.73 31.1 9.14 20.6 30.59 42.1"
                            })
                        ]
                    })
                ]
            })
        })
    });
};

});

parcelRegister("y11yg", function(module, exports) {

$parcel$export(module.exports, "Pencil", function () { return $0663f870f598b0d4$export$889aff59bd27773b; });

var $1rY3h = parcelRequire("1rY3h");
var $0663f870f598b0d4$export$889aff59bd27773b = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-pencil",
        width: size,
        height: size,
        viewBox: "0 0 65 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M32.92,9 L5.1,36.8 L9.5,41.4 L37.13,13.8 C37.24,13.7 37.35,13.6 37.46,13.5 L32.92,9 Z M19.13,51.6 L13.33,45.5 L41.07,17.7 L41.16,17.6 C41.23,17.5 41.29,17.5 41.35,17.4 L47.36,23.4 C47.24,23.5 47.13,23.6 47.02,23.7 L19.2,51.5 L19.13,51.6 Z M22.94,55.6 L27.35,60.3 L55.79,31.8 L51.24,27.3 C51.18,27.4 51.12,27.4 51.06,27.5 L50.96,27.6 L23.14,55.4 C23.08,55.5 23.01,55.6 22.94,55.6 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M32.92,9 L55.79,31.8 L61.98,25.6 C64.88,22.7 64.88,18 61.98,15.1 L49.6,2.8 C46.7,-0.1 42,-0.1 39.11,2.8 L32.92,9 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M5.1,36.8 L1.86,40 C1.16,40.7 0.77,41.7 0.77,42.6 L0.77,60.9 C0.77,62.9 2.43,64.6 4.48,64.6 L21.49,64.6 C22.47,64.6 23.42,64.2 24.11,63.5 L27.35,60.3 L5.1,36.8 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("dC1ZG", function(module, exports) {

$parcel$export(module.exports, "PencilWriting", function () { return $9e905ee922077f9e$export$c5b8759462e730b4; });

var $1rY3h = parcelRequire("1rY3h");
var $9e905ee922077f9e$export$c5b8759462e730b4 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-pencil writing",
        width: size,
        height: size,
        viewBox: "0 0 91 64",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M30.61,58.5 C32.14,58.5 33.39,59.7 33.39,61.2 C33.39,62.7 32.22,63.9 30.74,64 L30.61,64 L3.41,64 C1.87,64 0.63,62.8 0.63,61.2 C0.63,59.7 1.8,58.5 3.28,58.5 L3.41,58.5 L30.61,58.5 Z",
                        fillRule: "nonzero",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsxs)("g", {
                        transform: "translate(26.000000, 0.000000)",
                        children: [
                            (0, $1rY3h.jsx)("path", {
                                d: "M33.04,8.4 L5.23,36.2 L9.63,40.8 L37.26,13.2 C37.36,13.1 37.48,13 37.59,12.9 L33.04,8.4 Z M19.25,51 L13.46,44.9 L41.19,17.1 L41.29,17 C41.36,17 41.42,16.9 41.48,16.8 L47.48,22.8 C47.37,22.9 47.25,23 47.15,23.1 L19.33,50.9 L19.25,51 Z M23.07,55 L27.48,59.7 L55.92,31.3 L51.37,26.7 C51.31,26.8 51.25,26.9 51.18,26.9 L51.08,27 L23.27,54.9 C23.2,54.9 23.14,55 23.07,55 Z",
                                opacity: "0.5"
                            }),
                            (0, $1rY3h.jsx)("path", {
                                d: "M33.04,8.4 L55.92,31.3 L62.11,25.1 C65.01,22.2 65.01,17.5 62.11,14.6 L49.73,2.2 C46.83,-0.7 42.13,-0.7 39.24,2.2 L33.04,8.4 Z"
                            }),
                            (0, $1rY3h.jsx)("path", {
                                d: "M5.23,36.2 L1.99,39.4 C1.29,40.1 0.9,41.1 0.9,42.1 L0.9,60.3 C0.9,62.4 2.56,64 4.61,64 L21.62,64 C22.6,64 23.54,63.6 24.24,62.9 L27.48,59.7 L5.23,36.2 Z"
                            })
                        ]
                    })
                ]
            })
        })
    });
};

});

parcelRegister("aBxBD", function(module, exports) {

$parcel$export(module.exports, "PendantLamp", function () { return $7b876d8d0230784f$export$1c5d36f1a5404b93; });

var $1rY3h = parcelRequire("1rY3h");
var $7b876d8d0230784f$export$1c5d36f1a5404b93 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-pendant lamp",
        width: size,
        height: size,
        viewBox: "0 0 58 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M36.32,57.1 C36.32,61 33.2,64.1 29.35,64.1 L29.13,64.1 C25.28,64.1 22.16,61 22.16,57.1 L22.16,49.9 L36.32,49.9 L36.32,57.1 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M0.93,57 C0.93,57 0.95,57 0.97,57 L56.97,57 C56.99,57 57.01,57 57.01,57 C57.01,43.8 46.3,33.1 33.09,33.1 L24.85,33.1 C11.64,33.1 0.93,43.8 0.93,57 Z M48.03,48.3 C48.03,43.2 43.88,39 38.77,39 C37.42,39 36.32,40.1 36.32,41.5 C36.32,42.8 37.42,43.9 38.77,43.9 L38.91,43.9 C41.25,44 43.13,45.9 43.13,48.3 L43.13,48.4 C43.19,49.7 44.26,50.8 45.58,50.8 C46.93,50.8 48.03,49.7 48.03,48.3 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M28.97,0.1 C30.6,0.1 31.92,1.4 31.98,3 L31.99,3.1 L31.99,24.9 C31.99,26.6 30.64,27.9 28.97,27.9 C27.34,27.9 26.02,26.6 25.96,25 L25.95,24.9 L25.95,3.1 C25.95,1.4 27.3,0.1 28.97,0.1 Z",
                        fillRule: "nonzero",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M20.53,28.2 C20.53,23.3 24.43,19.4 29.24,19.4 C34.05,19.4 37.95,23.3 37.95,28.2 L37.95,36.9 L20.53,36.9 L20.53,28.2 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("iyCw2", function(module, exports) {

$parcel$export(module.exports, "Pin", function () { return $d82947600180821f$export$656559010049c8e; });

var $1rY3h = parcelRequire("1rY3h");
var $d82947600180821f$export$656559010049c8e = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-pin",
        width: size,
        height: size,
        viewBox: "0 0 44 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M24.71,61.8 C24.71,63.1 23.67,64.1 22.39,64.1 C21.14,64.1 20.13,63.1 20.07,61.9 L20.07,61.8 L20.07,39.1 C20.07,37.8 21.11,36.7 22.39,36.7 C23.63,36.7 24.65,37.7 24.71,39 L24.71,39.1 L24.71,61.8 Z",
                        fillRule: "nonzero",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsxs)("g", {
                        children: [
                            (0, $1rY3h.jsx)("path", {
                                d: "M40.45,0.1 C42.16,0.1 43.55,1.5 43.55,3.2 L43.55,11.4 C43.55,13.2 42.16,14.5 40.45,14.5 L35.29,14.5 L35.29,19.7 L8.97,14.5 L3.81,14.5 C2.1,14.5 0.71,13.2 0.71,11.4 L0.71,3.2 C0.71,1.5 2.1,0.1 3.81,0.1 L40.45,0.1 Z"
                            }),
                            (0, $1rY3h.jsx)("path", {
                                d: "M35.29,27 C35.29,27.6 35.49,28.2 35.87,28.8 L39.88,34.4 C40.25,34.9 40.45,35.5 40.45,36.2 L40.45,39.3 C40.45,41 39.07,42.4 37.36,42.4 L6.9,42.4 C5.19,42.4 3.81,41 3.81,39.3 L3.81,36.2 C3.81,35.5 4.01,34.9 4.38,34.4 L8.39,28.8 C8.77,28.2 8.97,27.6 8.97,27 L8.97,13 L22.22,7.8 L35.29,13 L35.29,27 Z"
                            })
                        ]
                    })
                ]
            })
        })
    });
};

});

parcelRegister("kLpeD", function(module, exports) {

$parcel$export(module.exports, "PuzzlePiece", function () { return $f1dbc599b56c5ddf$export$c8d5f6414677f141; });

var $1rY3h = parcelRequire("1rY3h");
var $f1dbc599b56c5ddf$export$c8d5f6414677f141 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-puzzle piece",
        width: size,
        height: size,
        viewBox: "0 0 65 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsx)("g", {
                fill: "currentColor",
                fillRule: "nonzero",
                children: (0, $1rY3h.jsxs)("g", {
                    children: [
                        (0, $1rY3h.jsx)("path", {
                            d: "M48.46,10.6 C51.94,10.6 54.76,13.5 54.76,16.9 L54.76,58.4 C54.76,61.9 51.94,64.7 48.46,64.7 L36.33,64.7 C36.37,64.3 36.39,64 36.39,63.6 C36.39,58.7 32.4,54.7 27.48,54.7 C22.55,54.7 18.56,58.7 18.56,63.6 C18.56,64 18.58,64.3 18.62,64.7 L7.02,64.7 C3.54,64.7 0.72,61.9 0.72,58.4 L0.72,46.8 C1.07,46.8 1.42,46.8 1.77,46.8 C6.7,46.8 10.69,42.8 10.69,37.9 C10.69,33 6.7,29 1.77,29 C1.42,29 1.07,29 0.72,29.1 L0.72,16.9 C0.72,13.5 3.54,10.6 7.02,10.6 L48.46,10.6 Z"
                        }),
                        (0, $1rY3h.jsx)("path", {
                            d: "M64.72,37.9 C64.72,42.8 60.73,46.8 55.8,46.8 C50.88,46.8 46.89,42.8 46.89,37.9 C46.89,33 50.88,29 55.8,29 C60.73,29 64.72,33 64.72,37.9 Z"
                        }),
                        (0, $1rY3h.jsx)("path", {
                            d: "M36.39,9.6 C36.39,14.5 32.4,18.5 27.48,18.5 C22.55,18.5 18.56,14.5 18.56,9.6 C18.56,4.7 22.55,0.7 27.48,0.7 C32.4,0.7 36.39,4.7 36.39,9.6 Z"
                        })
                    ]
                })
            })
        })
    });
};

});

parcelRegister("fChtk", function(module, exports) {

$parcel$export(module.exports, "Radar", function () { return $b5e7f5332c6d72dd$export$bace472c466fdd25; });

var $1rY3h = parcelRequire("1rY3h");
var $b5e7f5332c6d72dd$export$bace472c466fdd25 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-radar",
        width: size,
        height: size,
        viewBox: "0 0 65 64",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M32.04,0 C49.71,0 64.04,14.3 64.04,32 C64.04,49.7 49.71,64 32.04,64 C14.36,64 0.04,49.7 0.04,32 C0.04,14.3 14.36,0 32.04,0 Z M42.7,47.7 C42.7,44.6 45.22,42.1 48.32,42.1 C51.42,42.1 53.93,44.6 53.93,47.7 C53.93,50.8 51.42,53.3 48.32,53.3 C45.22,53.3 42.7,50.8 42.7,47.7 Z M16.32,10.1 C13.22,10.1 10.7,12.6 10.7,15.7 C10.7,18.8 13.22,21.3 16.32,21.3 C19.42,21.3 21.93,18.8 21.93,15.7 C21.93,12.6 19.42,10.1 16.32,10.1 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M29.51,0.1 C13.66,1.3 1.06,14.1 0.1,30 L7.13,30 C7.47,25.6 8.94,21.6 11.25,18.1 C12.01,19.7 13.49,20.9 15.26,21.2 C13.6,23.8 12.52,26.8 12.2,30 L22.83,30 C23.72,26.8 26.27,24.2 29.51,23.3 L29.51,12.2 C26.75,12.6 24.16,13.5 21.87,14.8 C21.91,15.1 21.93,15.4 21.93,15.7 C21.93,18.8 19.42,21.3 16.32,21.3 C13.22,21.3 10.7,18.8 10.7,15.7 C10.7,12.6 13.22,10.1 16.32,10.1 C17.25,10.1 18.14,10.3 18.91,10.7 C22.05,8.8 25.65,7.5 29.51,7.1 L29.51,0.1 Z M0.18,35.1 C1.66,50.5 14.04,62.7 29.51,63.9 L29.51,56.8 C17.92,55.7 8.66,46.6 7.24,35.1 L0.18,35.1 Z M34.56,63.9 C50.03,62.7 62.42,50.5 63.89,35.1 L56.83,35.1 C56.38,38.7 55.14,42.1 53.3,45.1 C53.7,45.9 53.93,46.8 53.93,47.7 C53.93,50.8 51.42,53.3 48.32,53.3 C45.22,53.3 42.7,50.8 42.7,47.7 C42.7,44.6 45.22,42.1 48.32,42.1 C48.61,42.1 48.9,42.1 49.18,42.2 C50.45,40 51.33,37.6 51.73,35.1 L41.24,35.1 C40.36,38.3 37.8,40.9 34.56,41.8 L34.56,51.8 C37.57,51.4 40.37,50.3 42.8,48.8 C43.14,50.5 44.31,52 45.9,52.8 C42.59,55 38.73,56.4 34.56,56.8 L34.56,63.9 Z M63.98,30 L56.94,30 C56.01,18 46.53,8.3 34.56,7.1 L34.56,0.1 C50.41,1.3 63.01,14.1 63.98,30 Z M12.34,35.1 L22.83,35.1 C23.72,38.3 26.27,40.9 29.51,41.8 L29.51,51.8 C20.71,50.6 13.7,43.8 12.34,35.1 Z M51.87,30 L41.24,30 C40.36,26.8 37.8,24.2 34.56,23.3 L34.56,12.2 C43.74,13.4 50.97,20.8 51.87,30 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("bPPvN", function(module, exports) {

$parcel$export(module.exports, "RadarDashboard", function () { return $89dc6a551aa3e94f$export$d291d67066e6dc65; });

var $1rY3h = parcelRequire("1rY3h");
var $89dc6a551aa3e94f$export$d291d67066e6dc65 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-radar dashboard",
        width: size,
        height: size,
        viewBox: "0 0 65 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M57.99,0.5 C61.82,0.5 64.93,3.6 64.93,7.4 L64.93,57.5 C64.93,61.3 61.82,64.5 57.99,64.5 L7.87,64.5 C4.03,64.5 0.93,61.3 0.93,57.5 L0.93,7.4 C0.93,3.6 4.03,0.5 7.87,0.5 L57.99,0.5 Z M44.42,49.5 C44.42,46.1 47.21,43.3 50.64,43.3 C54.07,43.3 56.85,46.1 56.85,49.5 C56.85,53 54.07,55.8 50.64,55.8 C47.21,55.8 44.42,53 44.42,49.5 Z M15.22,7.9 C11.79,7.9 9.01,10.7 9.01,14.1 C9.01,17.6 11.79,20.3 15.22,20.3 C18.65,20.3 21.43,17.6 21.43,14.1 C21.43,10.7 18.65,7.9 15.22,7.9 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M29.82,0.5 L8.38,0.5 C4.27,0.5 0.93,3.8 0.93,7.9 L0.93,30 L5.05,30 C5.43,25.1 7.06,20.6 9.61,16.8 C9.22,16 9.01,15.1 9.01,14.1 C9.01,10.7 11.79,7.9 15.22,7.9 C18.65,7.9 21.43,10.7 21.43,14.1 C21.43,17.6 18.65,20.3 15.22,20.3 C14.82,20.3 14.43,20.3 14.05,20.2 C12.21,23.1 11.01,26.4 10.67,30 L19.43,30 C20.32,24.5 24.48,20.2 29.82,19.1 L29.82,10.3 C26.76,10.6 23.9,11.7 21.36,13.2 C21.05,11.2 19.81,9.5 18.09,8.6 C21.56,6.5 25.55,5.1 29.82,4.6 L29.82,0.5 Z M0.93,35.6 L0.93,57 C0.93,61.1 4.27,64.5 8.38,64.5 L29.82,64.5 L29.82,59.7 C16.99,58.4 6.75,48.3 5.18,35.6 L0.93,35.6 Z M35.41,64.5 L57.47,64.5 C61.59,64.5 64.93,61.1 64.93,57 L64.93,35.6 L60.06,35.6 C59.56,39.6 58.19,43.4 56.15,46.7 C56.6,47.5 56.85,48.5 56.85,49.5 C56.85,53 54.07,55.8 50.64,55.8 C49.68,55.8 48.77,55.5 47.96,55.2 C44.3,57.6 40.02,59.2 35.41,59.7 L35.41,64.5 Z M45.46,53 C44.81,52 44.42,50.8 44.42,49.5 C44.42,46.1 47.21,43.3 50.64,43.3 C52.65,43.3 54.45,44.3 55.58,45.8 C54.63,44.5 53.21,43.7 51.59,43.4 C53,41 53.97,38.4 54.41,35.6 L45.54,35.6 C44.26,40.4 40.34,44.2 35.41,45.2 L35.41,54 C38.74,53.6 41.84,52.4 44.53,50.7 C44.69,51.5 45.01,52.3 45.46,53 Z M64.93,30 L60.18,30 C59.15,16.6 48.66,6 35.41,4.6 L35.41,0.5 L57.47,0.5 C61.59,0.5 64.93,3.8 64.93,7.9 L64.93,30 Z M10.82,35.6 L19.7,35.6 C20.98,40.4 24.9,44.2 29.82,45.2 L29.82,54 C20.08,52.8 12.32,45.2 10.82,35.6 Z M54.57,30 L45.8,30 C44.91,24.5 40.75,20.2 35.41,19.1 L35.41,10.3 C45.57,11.5 53.57,19.7 54.57,30 Z"
                    }),
                    (0, $1rY3h.jsx)("rect", {
                        fillRule: "nonzero",
                        x: "26.4",
                        y: "26.6",
                        width: "12.4272",
                        height: "12.4272",
                        rx: "6.21359"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("5Q6bk", function(module, exports) {

$parcel$export(module.exports, "Rocket", function () { return $44069a9d94ffb9d9$export$c622ac6ddd491a46; });

var $1rY3h = parcelRequire("1rY3h");
var $44069a9d94ffb9d9$export$c622ac6ddd491a46 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-rocket",
        width: size,
        height: size,
        viewBox: "0 0 39 87",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M30.65,83.6 C31.4,84.7 30.54,86.3 29.14,86.3 L9.39,86.3 C7.98,86.3 7.13,84.7 7.88,83.6 L12.71,75.9 L25.82,75.9 L30.65,83.6 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M38.03,28.2 L0.49,28.2 L0.49,68.7 C0.49,72.7 3.7,75.9 7.64,75.9 L30.88,75.9 C34.83,75.9 38.03,72.7 38.03,68.7 L38.03,28.2 Z M23.48,62.8 C25.8,60.5 25.8,56.7 23.48,54.4 C21.15,52.1 17.38,52.1 15.05,54.4 C12.72,56.7 12.72,60.5 15.05,62.8 C17.38,65.1 21.15,65.1 23.48,62.8 Z M23.48,37.1 C25.8,39.4 25.8,43.2 23.48,45.5 C21.15,47.9 17.38,47.9 15.05,45.5 C12.72,43.2 12.72,39.4 15.05,37.1 C17.38,34.8 21.15,34.8 23.48,37.1 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M38.03,28.2 L22.33,2 C20.94,-0.3 17.59,-0.3 16.2,2 L0.49,28.2 L38.03,28.2 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("3arRy", function(module, exports) {

$parcel$export(module.exports, "SecurityCheckmark", function () { return $24e7eb3beb8ab053$export$992764df22cf8b12; });

var $1rY3h = parcelRequire("1rY3h");
var $24e7eb3beb8ab053$export$992764df22cf8b12 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-security checkmark",
        width: size,
        height: size,
        viewBox: "0 0 56 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsx)("g", {
                fill: "currentColor",
                children: (0, $1rY3h.jsx)("path", {
                    d: "M55.36,7.5 C55.71,6.6 55.94,6 54.78,6 L50.86,6 C43.02,6 32.95,2.3 29.32,0.8 C28.44,0.5 27.45,0.5 26.57,0.8 C22.94,2.3 12.87,6 5.03,6 L1.11,6 C-0.06,6 0.17,6.6 0.53,7.5 C0.75,8 1.02,8.7 1.02,9.4 L1.02,30.2 C1.02,43 8.21,54.8 19.64,60.7 L26.37,64.2 C27.36,64.7 28.53,64.7 29.52,64.2 L36.25,60.7 C47.68,54.8 54.87,43 54.87,30.2 L54.87,9.4 C54.87,8.7 55.14,8 55.36,7.5 Z M41.36,23.3 C42.28,22.3 42.25,20.7 41.28,19.8 L41.19,19.7 C40.18,18.8 38.61,18.8 37.63,19.8 L24.06,33.3 L19.4,28.7 L19.32,28.6 C18.3,27.7 16.74,27.7 15.76,28.7 C14.75,29.7 14.75,31.3 15.76,32.3 L22.24,38.8 L22.33,38.9 C23.34,39.8 24.91,39.8 25.88,38.8 L41.28,23.4 L41.36,23.3 Z"
                })
            })
        })
    });
};

});

parcelRegister("j2pub", function(module, exports) {

$parcel$export(module.exports, "SecurityGear", function () { return $ddc1f92d51d91d4e$export$812262bb4d67bbd6; });

var $1rY3h = parcelRequire("1rY3h");
var $ddc1f92d51d91d4e$export$812262bb4d67bbd6 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-security gear",
        width: size,
        height: size,
        viewBox: "0 0 65 70",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsx)("g", {
                fill: "currentColor",
                children: (0, $1rY3h.jsx)("path", {
                    d: "M64.61,36.2 L64.61,8.8 C64.61,4.3 60.96,0.7 56.44,0.7 L8.78,0.7 C4.27,0.7 0.61,4.3 0.61,8.8 L0.61,36.2 C0.61,47.2 6.79,57.2 16.61,62.3 L30.74,69.5 C31.92,70.1 33.31,70.1 34.49,69.5 L48.61,62.3 C58.44,57.2 64.61,47.2 64.61,36.2 Z M33.75,14.2 C34.95,14.2 35.93,15.2 35.93,16.4 L35.93,19.1 C37.15,19.4 38.3,19.8 39.36,20.5 L41.24,18.6 C42.09,17.7 43.48,17.7 44.33,18.6 L45.93,20.2 C46.79,21 46.79,22.4 45.93,23.3 L44.05,25.1 C44.68,26.2 45.16,27.3 45.47,28.6 L48.13,28.6 C49.34,28.6 50.32,29.5 50.32,30.7 L50.32,33 C50.32,34.2 49.34,35.2 48.13,35.2 L45.47,35.2 C45.16,36.4 44.68,37.5 44.05,38.6 L45.93,40.4 C46.79,41.3 46.79,42.7 45.93,43.5 L44.33,45.1 C43.48,46 42.09,46 41.24,45.1 L39.36,43.2 C38.3,43.9 37.15,44.4 35.93,44.7 L35.93,47.3 C35.93,48.5 34.95,49.5 33.75,49.5 L31.48,49.5 C30.27,49.5 29.3,48.5 29.3,47.3 L29.29,44.7 C28.08,44.4 26.93,43.9 25.87,43.2 L23.99,45.1 C23.14,46 21.75,46 20.9,45.1 L19.3,43.5 C18.44,42.7 18.44,41.3 19.3,40.4 L21.18,38.6 C20.55,37.5 20.07,36.4 19.76,35.2 L17.1,35.2 C15.89,35.2 14.91,34.2 14.91,33 L14.91,30.7 C14.91,29.5 15.89,28.6 17.1,28.6 L19.76,28.6 C20.07,27.3 20.55,26.2 21.18,25.1 L19.3,23.3 C18.44,22.4 18.44,21 19.3,20.2 L20.9,18.6 C21.75,17.7 23.14,17.7 23.99,18.6 L25.87,20.5 C26.93,19.8 28.08,19.4 29.29,19.1 L29.3,16.4 C29.3,15.2 30.27,14.2 31.48,14.2 L33.75,14.2 Z M32.61,25.2 C36.28,25.2 39.25,28.2 39.25,31.9 C39.25,35.5 36.28,38.5 32.61,38.5 C28.95,38.5 25.98,35.5 25.98,31.9 C25.98,28.2 28.95,25.2 32.61,25.2 Z"
                })
            })
        })
    });
};

});

parcelRegister("2y5Fy", function(module, exports) {

$parcel$export(module.exports, "ShoppingBag", function () { return $1db327865cbc5d62$export$acda254a1ccd05c3; });

var $1rY3h = parcelRequire("1rY3h");
var $1db327865cbc5d62$export$acda254a1ccd05c3 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-shopping bag",
        width: size,
        height: size,
        viewBox: "0 0 53 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsx)("g", {
                fill: "currentColor",
                children: (0, $1rY3h.jsx)("path", {
                    d: "M44.83,64.9 C48.95,64.9 52.28,61.5 52.28,57.4 L52.28,4.6 C52.28,2.5 50.61,0.9 48.56,0.9 L4.44,0.9 C2.38,0.9 0.71,2.5 0.71,4.6 L0.71,57.4 C0.71,61.5 4.05,64.9 8.17,64.9 L44.83,64.9 Z M14.07,13.2 C14.14,11.7 15.37,10.5 16.87,10.5 C18.41,10.5 19.66,11.8 19.66,13.3 L19.66,27.9 L19.66,28.1 C19.76,31.8 22.78,34.7 26.5,34.7 C30.27,34.7 33.33,31.7 33.33,27.9 L33.33,13.3 L33.34,13.2 C33.4,11.7 34.63,10.5 36.13,10.5 C37.67,10.5 38.92,11.8 38.92,13.3 L38.92,27.9 L38.92,28.1 C38.81,34.9 33.29,40.3 26.5,40.3 C19.63,40.3 14.07,34.8 14.07,27.9 L14.07,13.3 L14.07,13.2 Z"
                })
            })
        })
    });
};

});

parcelRegister("2Uzy1", function(module, exports) {

$parcel$export(module.exports, "ShoppingCart", function () { return $21ec62c18d9f5ef5$export$b09d44dc9283a8f5; });

var $1rY3h = parcelRequire("1rY3h");
var $21ec62c18d9f5ef5$export$b09d44dc9283a8f5 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-shopping cart",
        width: size,
        height: size,
        viewBox: "0 0 75 60",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M71.83,0 C73.31,0 74.52,1.2 74.52,2.7 C74.52,4.2 73.38,5.3 71.96,5.4 L71.83,5.4 L61.85,5.4 L50.51,41.1 C50.17,42.2 49.2,43 48.08,43 L47.95,43 L10.34,43 C8.85,43 7.65,41.8 7.65,40.3 C7.65,38.9 8.79,37.7 10.21,37.6 L10.34,37.6 L45.98,37.6 L57.33,1.9 C57.67,0.8 58.64,0.1 59.76,0 L59.89,0 L71.83,0 Z",
                        fillRule: "nonzero",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M56.65,4 C55.81,3.2 54.66,2.7 53.36,2.7 L4.92,2.7 C1.69,2.7 -0.61,5.9 0.37,8.9 L8.75,35.3 C9.03,36.2 9.46,37 10,37.7 C10.07,37.7 10.14,37.7 10.21,37.6 L10.34,37.6 L45.98,37.6 L56.65,4 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M8.84,53.2 C8.84,49.4 11.92,46.3 15.71,46.3 C19.5,46.3 22.58,49.4 22.58,53.2 C22.58,57 19.5,60 15.71,60 C11.92,60 8.84,57 8.84,53.2 Z",
                        fillRule: "nonzero"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M36.9,53.2 C36.9,49.4 39.98,46.3 43.77,46.3 C47.56,46.3 50.64,49.4 50.64,53.2 C50.64,57 47.56,60 43.77,60 C39.98,60 36.9,57 36.9,53.2 Z",
                        fillRule: "nonzero"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("fB9Me", function(module, exports) {

$parcel$export(module.exports, "Skull", function () { return $b5b1e53662eec3f0$export$cde503dbe302db71; });

var $1rY3h = parcelRequire("1rY3h");
var $b5b1e53662eec3f0$export$cde503dbe302db71 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-skull",
        width: size,
        height: size,
        viewBox: "0 0 53 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsxs)("g", {
                        transform: "translate(12.000000, 38.000000)",
                        opacity: "0.5",
                        children: [
                            (0, $1rY3h.jsx)("path", {
                                d: "M13.35,1.8 C14.03,0.7 15.58,0.7 16.26,1.8 L19.91,7.4 C20.66,8.6 19.83,10.1 18.45,10.1 L11.16,10.1 C9.79,10.1 8.96,8.6 9.71,7.4 L13.35,1.8 Z"
                            }),
                            (0, $1rY3h.jsx)("path", {
                                d: "M17.29,20.4 C17.29,18.8 16.04,17.6 14.5,17.6 C12.95,17.6 11.7,18.8 11.7,20.4 L11.7,20.4 L11.7,22.1 L11.7,26.8 L17.29,26.8 L17.29,22.1 L17.29,20.4 L17.29,20.4 Z"
                            }),
                            (0, $1rY3h.jsx)("path", {
                                d: "M6.42,20.4 C6.42,18.8 5.17,17.6 3.62,17.6 C2.08,17.6 0.83,18.8 0.83,20.4 L0.83,20.4 L0.83,22.1 L0.83,26.8 L6.42,26.8 L6.42,22.1 L6.42,20.4 L6.42,20.4 Z"
                            }),
                            (0, $1rY3h.jsx)("path", {
                                d: "M28.17,20.4 C28.17,18.8 26.92,17.6 25.37,17.6 C23.83,17.6 22.58,18.8 22.58,20.4 C22.58,20.4 22.58,20.4 22.58,20.4 L22.58,22.1 L22.58,26.8 L28.17,26.8 L28.17,22.1 L28.17,20.4 C28.17,20.4 28.17,20.4 28.17,20.4 Z"
                            })
                        ]
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M6.24,52.4 C3.18,52.4 0.71,50 0.71,46.9 L0.71,26.7 C0.71,12.4 12.26,0.9 26.5,0.9 C40.74,0.9 52.28,12.4 52.28,26.7 L52.28,46.9 C52.28,50 49.81,52.4 46.76,52.4 L46.07,52.4 L46.07,61.1 C46.07,63.2 44.4,64.9 42.34,64.9 L10.65,64.9 C8.59,64.9 6.92,63.2 6.92,61.1 L6.92,52.4 L6.24,52.4 Z M9.41,30.7 C9.41,27.3 12.19,24.5 15.62,24.5 C19.06,24.5 21.84,27.3 21.84,30.7 C21.84,34.1 19.06,36.9 15.62,36.9 C12.19,36.9 9.41,34.1 9.41,30.7 Z M37.99,24.5 C34.56,24.5 31.78,27.3 31.78,30.7 C31.78,34.1 34.56,36.9 37.99,36.9 C41.42,36.9 44.21,34.1 44.21,30.7 C44.21,27.3 41.42,24.5 37.99,24.5 Z M25.24,40 C25.98,38.8 27.64,38.8 28.37,40 L31.78,45.2 C32.58,46.5 31.69,48.1 30.22,48.1 L23.4,48.1 C21.92,48.1 21.03,46.5 21.83,45.2 L25.24,40 Z M29.29,58.4 C29.29,56.8 28.04,55.6 26.5,55.6 C24.95,55.6 23.7,56.8 23.7,58.4 L23.7,64.8 L29.29,64.8 L29.29,58.4 Z M15.62,55.6 C17.17,55.6 18.42,56.8 18.42,58.4 L18.42,64.8 L12.83,64.8 L12.83,58.4 C12.83,56.8 14.08,55.6 15.62,55.6 Z M40.17,58.4 C40.17,56.8 38.92,55.6 37.37,55.6 C35.83,55.6 34.58,56.8 34.57,58.4 L34.57,64.8 L40.17,64.8 L40.17,58.4 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("h7iOA", function(module, exports) {

$parcel$export(module.exports, "Speedometer", function () { return $c761af5d06ec087b$export$5e7bc19708935aeb; });

var $1rY3h = parcelRequire("1rY3h");
var $c761af5d06ec087b$export$5e7bc19708935aeb = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-speedometer",
        width: size,
        height: size,
        viewBox: "0 0 66 47",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M0,33.9 C0,15.7 14.76,0.9 32.96,0.9 C51.17,0.9 65.93,15.7 65.93,33.9 C65.93,38.6 64.96,43 63.23,47 L2.7,47 C0.96,43 0,38.6 0,33.9 Z M49.84,17 C48.82,16 47.18,16 46.16,17 L35.68,27.5 C34.84,27.2 33.93,27 32.96,27 C29.13,27 26.02,30.1 26.02,33.9 C26.02,37.7 29.13,40.9 32.96,40.9 C36.8,40.9 39.9,37.7 39.9,33.9 C39.9,33 39.71,32 39.36,31.2 L49.84,20.7 L49.93,20.6 C50.86,19.6 50.83,18 49.84,17 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M0,33.9 C0,15.7 14.76,0.9 32.96,0.9 C51.17,0.9 65.93,15.7 65.93,33.9 C65.93,38.6 64.96,43 63.23,47 L2.7,47 C0.96,43 0,38.6 0,33.9 Z M9.13,31.3 C7.75,31.4 6.65,32.5 6.65,33.9 C6.65,35.3 7.82,36.5 9.25,36.5 L14.46,36.5 L14.58,36.5 C15.96,36.4 17.06,35.3 17.06,33.9 C17.06,32.5 15.9,31.3 14.46,31.3 L9.25,31.3 L9.13,31.3 Z M48.87,33.9 C48.87,32.5 49.97,31.4 51.35,31.3 L51.47,31.3 L56.67,31.3 C58.11,31.3 59.28,32.5 59.28,33.9 C59.28,35.3 58.18,36.4 56.8,36.5 L56.67,36.5 L51.47,36.5 C50.03,36.5 48.87,35.3 48.87,33.9 Z M35.56,10.1 C35.5,8.7 34.36,7.6 32.96,7.6 C31.53,7.6 30.36,8.8 30.36,10.2 L30.36,15.4 L30.36,15.5 C30.43,16.9 31.57,18 32.96,18 C34.4,18 35.57,16.8 35.57,15.4 L35.57,10.2 L35.56,10.1 Z M21.72,19 C22.73,20 22.73,21.7 21.72,22.7 C20.73,23.7 19.15,23.7 18.13,22.8 L18.04,22.7 L14.36,19 C13.34,18 13.34,16.3 14.36,15.3 C15.35,14.3 16.93,14.3 17.95,15.2 L18.04,15.3 L21.72,19 Z M46.16,17 C47.18,16 48.82,16 49.84,17 C50.83,18 50.86,19.6 49.93,20.6 L49.84,20.7 L39.36,31.2 C39.71,32 39.9,33 39.9,33.9 C39.9,37.7 36.8,40.9 32.96,40.9 C29.13,40.9 26.02,37.7 26.02,33.9 C26.02,30.1 29.13,27 32.96,27 C33.93,27 34.84,27.2 35.68,27.5 L46.16,17 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("gd415", function(module, exports) {

$parcel$export(module.exports, "Spinner", function () { return $030ba0eed2ecf684$export$7f7cbe89f1eacd2; });

var $1rY3h = parcelRequire("1rY3h");
var $030ba0eed2ecf684$export$7f7cbe89f1eacd2 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-spinner",
        width: size,
        height: size,
        viewBox: "0 0 65 75",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsx)("g", {
                fill: "currentColor",
                fillRule: "nonzero",
                children: (0, $1rY3h.jsxs)("g", {
                    children: [
                        (0, $1rY3h.jsx)("path", {
                            d: "M32.14,0.3 C33.4,0.3 34.43,1.3 34.48,2.5 L34.49,2.7 L34.49,23.5 C34.49,24.8 33.44,25.8 32.14,25.8 C30.89,25.8 29.86,24.8 29.81,23.6 L29.8,23.5 L29.8,2.7 C29.8,1.4 30.85,0.3 32.14,0.3 Z"
                        }),
                        (0, $1rY3h.jsx)("path", {
                            d: "M32.14,59.6 C33.4,59.6 34.43,60.6 34.48,61.9 L34.49,62 L34.49,72.4 C34.49,73.7 33.44,74.7 32.14,74.7 C30.89,74.7 29.86,73.7 29.81,72.5 L29.8,72.4 L29.8,62 C29.8,60.7 30.85,59.6 32.14,59.6 Z"
                        }),
                        (0, $1rY3h.jsx)("path", {
                            d: "M48.14,15 C49.23,15.6 49.63,17 49.05,18.1 L49,18.2 L43.8,27.2 C43.15,28.3 41.72,28.7 40.6,28.1 C39.51,27.4 39.12,26.1 39.69,25 L39.74,24.9 L44.95,15.9 C45.59,14.7 47.02,14.4 48.14,15 Z"
                        }),
                        (0, $1rY3h.jsx)("path", {
                            d: "M23.69,57.4 C24.78,58 25.17,59.4 24.6,60.5 L24.55,60.6 L19.34,69.6 C18.7,70.7 17.26,71.1 16.14,70.4 C15.06,69.8 14.66,68.4 15.24,67.3 L15.29,67.2 L20.49,58.2 C21.14,57.1 22.57,56.7 23.69,57.4 Z"
                        }),
                        (0, $1rY3h.jsx)("path", {
                            d: "M59.86,26.7 C60.49,27.8 60.14,29.2 59.09,29.9 L59,29.9 L49.99,35.1 C48.87,35.8 47.44,35.4 46.79,34.3 C46.16,33.2 46.51,31.8 47.55,31.1 L47.65,31.1 L56.66,25.9 C57.78,25.2 59.21,25.6 59.86,26.7 Z"
                        }),
                        (0, $1rY3h.jsx)("path", {
                            d: "M17.5,51.2 C18.13,52.3 17.78,53.6 16.74,54.3 L16.64,54.4 L7.63,59.6 C6.51,60.2 5.08,59.8 4.43,58.7 C3.8,57.6 4.15,56.2 5.19,55.6 L5.29,55.5 L14.3,50.3 C15.42,49.7 16.85,50.1 17.5,51.2 Z"
                        }),
                        (0, $1rY3h.jsx)("path", {
                            d: "M64.14,42.7 C64.14,44 63.16,45 61.91,45.1 L61.8,45.1 L51.4,45.1 C50.1,45.1 49.06,44 49.06,42.7 C49.06,41.5 50.04,40.4 51.29,40.4 L51.4,40.4 L61.8,40.4 C63.1,40.4 64.14,41.4 64.14,42.7 Z"
                        }),
                        (0, $1rY3h.jsx)("path", {
                            d: "M15.23,42.7 C15.23,44 14.24,45 13,45.1 L12.89,45.1 L2.49,45.1 C1.19,45.1 0.14,44 0.14,42.7 C0.14,41.5 1.13,40.4 2.38,40.4 L2.49,40.4 L12.89,40.4 C14.19,40.4 15.23,41.4 15.23,42.7 Z"
                        }),
                        (0, $1rY3h.jsx)("path", {
                            d: "M59.86,58.7 C59.23,59.8 57.86,60.2 56.76,59.6 L56.66,59.6 L47.65,54.4 C46.53,53.7 46.14,52.3 46.79,51.2 C47.42,50.1 48.79,49.7 49.89,50.3 L49.99,50.3 L59,55.5 C60.12,56.2 60.5,57.6 59.86,58.7 Z"
                        }),
                        (0, $1rY3h.jsx)("path", {
                            d: "M17.5,34.3 C16.87,35.3 15.5,35.7 14.4,35.2 L14.3,35.1 L5.29,29.9 C4.17,29.3 3.79,27.8 4.43,26.7 C5.06,25.6 6.43,25.2 7.53,25.8 L7.63,25.9 L16.64,31.1 C17.76,31.7 18.15,33.1 17.5,34.3 Z"
                        }),
                        (0, $1rY3h.jsx)("path", {
                            d: "M48.14,70.4 C47.06,71.1 45.67,70.7 45,69.7 L44.94,69.6 L39.74,60.6 C39.1,59.4 39.48,58 40.6,57.4 C41.69,56.7 43.07,57.1 43.74,58.1 L43.8,58.2 L49,67.2 C49.65,68.4 49.26,69.8 48.14,70.4 Z"
                        }),
                        (0, $1rY3h.jsx)("path", {
                            d: "M23.69,28.1 C22.6,28.7 21.22,28.4 20.55,27.3 L20.49,27.2 L15.29,18.2 C14.64,17.1 15.02,15.7 16.14,15 C17.23,14.4 18.62,14.7 19.29,15.8 L19.34,15.9 L24.55,24.9 C25.19,26 24.81,27.4 23.69,28.1 Z"
                        })
                    ]
                })
            })
        })
    });
};

});

parcelRegister("2weR5", function(module, exports) {

$parcel$export(module.exports, "Star", function () { return $1d5a17e3279afd89$export$1644ba17714857f1; });

var $1rY3h = parcelRequire("1rY3h");
var $1d5a17e3279afd89$export$1644ba17714857f1 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-spinner",
        width: size,
        height: size,
        viewBox: "0 0 65 75",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsx)("g", {
                fill: "currentColor",
                fillRule: "nonzero",
                children: (0, $1rY3h.jsxs)("g", {
                    children: [
                        (0, $1rY3h.jsx)("path", {
                            d: "M32.14,0.3 C33.4,0.3 34.43,1.3 34.48,2.5 L34.49,2.7 L34.49,23.5 C34.49,24.8 33.44,25.8 32.14,25.8 C30.89,25.8 29.86,24.8 29.81,23.6 L29.8,23.5 L29.8,2.7 C29.8,1.4 30.85,0.3 32.14,0.3 Z"
                        }),
                        (0, $1rY3h.jsx)("path", {
                            d: "M32.14,59.6 C33.4,59.6 34.43,60.6 34.48,61.9 L34.49,62 L34.49,72.4 C34.49,73.7 33.44,74.7 32.14,74.7 C30.89,74.7 29.86,73.7 29.81,72.5 L29.8,72.4 L29.8,62 C29.8,60.7 30.85,59.6 32.14,59.6 Z"
                        }),
                        (0, $1rY3h.jsx)("path", {
                            d: "M48.14,15 C49.23,15.6 49.63,17 49.05,18.1 L49,18.2 L43.8,27.2 C43.15,28.3 41.72,28.7 40.6,28.1 C39.51,27.4 39.12,26.1 39.69,25 L39.74,24.9 L44.95,15.9 C45.59,14.7 47.02,14.4 48.14,15 Z"
                        }),
                        (0, $1rY3h.jsx)("path", {
                            d: "M23.69,57.4 C24.78,58 25.17,59.4 24.6,60.5 L24.55,60.6 L19.34,69.6 C18.7,70.7 17.26,71.1 16.14,70.4 C15.06,69.8 14.66,68.4 15.24,67.3 L15.29,67.2 L20.49,58.2 C21.14,57.1 22.57,56.7 23.69,57.4 Z"
                        }),
                        (0, $1rY3h.jsx)("path", {
                            d: "M59.86,26.7 C60.49,27.8 60.14,29.2 59.09,29.9 L59,29.9 L49.99,35.1 C48.87,35.8 47.44,35.4 46.79,34.3 C46.16,33.2 46.51,31.8 47.55,31.1 L47.65,31.1 L56.66,25.9 C57.78,25.2 59.21,25.6 59.86,26.7 Z"
                        }),
                        (0, $1rY3h.jsx)("path", {
                            d: "M17.5,51.2 C18.13,52.3 17.78,53.6 16.74,54.3 L16.64,54.4 L7.63,59.6 C6.51,60.2 5.08,59.8 4.43,58.7 C3.8,57.6 4.15,56.2 5.19,55.6 L5.29,55.5 L14.3,50.3 C15.42,49.7 16.85,50.1 17.5,51.2 Z"
                        }),
                        (0, $1rY3h.jsx)("path", {
                            d: "M64.14,42.7 C64.14,44 63.16,45 61.91,45.1 L61.8,45.1 L51.4,45.1 C50.1,45.1 49.06,44 49.06,42.7 C49.06,41.5 50.04,40.4 51.29,40.4 L51.4,40.4 L61.8,40.4 C63.1,40.4 64.14,41.4 64.14,42.7 Z"
                        }),
                        (0, $1rY3h.jsx)("path", {
                            d: "M15.23,42.7 C15.23,44 14.24,45 13,45.1 L12.89,45.1 L2.49,45.1 C1.19,45.1 0.14,44 0.14,42.7 C0.14,41.5 1.13,40.4 2.38,40.4 L2.49,40.4 L12.89,40.4 C14.19,40.4 15.23,41.4 15.23,42.7 Z"
                        }),
                        (0, $1rY3h.jsx)("path", {
                            d: "M59.86,58.7 C59.23,59.8 57.86,60.2 56.76,59.6 L56.66,59.6 L47.65,54.4 C46.53,53.7 46.14,52.3 46.79,51.2 C47.42,50.1 48.79,49.7 49.89,50.3 L49.99,50.3 L59,55.5 C60.12,56.2 60.5,57.6 59.86,58.7 Z"
                        }),
                        (0, $1rY3h.jsx)("path", {
                            d: "M17.5,34.3 C16.87,35.3 15.5,35.7 14.4,35.2 L14.3,35.1 L5.29,29.9 C4.17,29.3 3.79,27.8 4.43,26.7 C5.06,25.6 6.43,25.2 7.53,25.8 L7.63,25.9 L16.64,31.1 C17.76,31.7 18.15,33.1 17.5,34.3 Z"
                        }),
                        (0, $1rY3h.jsx)("path", {
                            d: "M48.14,70.4 C47.06,71.1 45.67,70.7 45,69.7 L44.94,69.6 L39.74,60.6 C39.1,59.4 39.48,58 40.6,57.4 C41.69,56.7 43.07,57.1 43.74,58.1 L43.8,58.2 L49,67.2 C49.65,68.4 49.26,69.8 48.14,70.4 Z"
                        }),
                        (0, $1rY3h.jsx)("path", {
                            d: "M23.69,28.1 C22.6,28.7 21.22,28.4 20.55,27.3 L20.49,27.2 L15.29,18.2 C14.64,17.1 15.02,15.7 16.14,15 C17.23,14.4 18.62,14.7 19.29,15.8 L19.34,15.9 L24.55,24.9 C25.19,26 24.81,27.4 23.69,28.1 Z"
                        })
                    ]
                })
            })
        })
    });
};

});

parcelRegister("gtRWF", function(module, exports) {

$parcel$export(module.exports, "Stickers", function () { return $bff933335f607c62$export$c2995e8124c74c6f; });

var $1rY3h = parcelRequire("1rY3h");
var $bff933335f607c62$export$c2995e8124c74c6f = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-stickers",
        width: size,
        height: size,
        viewBox: "0 0 65 64",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M0.04,32 C0.04,49.7 14.36,64 32.04,64 C32.04,46.3 46.36,32 64.04,32 C64.04,14.3 49.71,0 32.04,0 C14.36,0 0.04,14.3 0.04,32 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M64.04,32 L32.04,64 C32.04,46.3 46.36,32 64.04,32 Z",
                        opacity: "0.5"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("kET9Z", function(module, exports) {

$parcel$export(module.exports, "Stopwatch", function () { return $f0a254bc20dc9cbf$export$e16de4ea1abb52c8; });

var $1rY3h = parcelRequire("1rY3h");
var $f0a254bc20dc9cbf$export$e16de4ea1abb52c8 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-stopwatch",
        width: size,
        height: size,
        viewBox: "0 0 65 89",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M17.44,15.4 C17.44,7.4 23.97,0.8 32.04,0.8 C40.1,0.8 46.63,7.4 46.63,15.4 C46.63,22.7 41.31,28.7 34.35,29.9 C40.33,30.4 45.75,32.8 49.97,36.6 C49.88,35.9 50.09,35.1 50.6,34.6 L50.69,34.5 L55.68,29.5 C56.67,28.5 58.27,28.5 59.26,29.5 C60.21,30.4 60.24,32 59.35,33 L59.26,33.1 L54.26,38 C53.69,38.6 52.9,38.9 52.15,38.8 C56.4,43.5 58.98,49.8 58.98,56.7 C58.98,71.6 46.92,83.6 32.04,83.6 C17.15,83.6 5.09,71.6 5.09,56.7 C5.09,42.6 15.92,31 29.72,29.9 C22.76,28.7 17.44,22.7 17.44,15.4 Z M41.58,15.4 C41.58,10.2 37.31,5.9 32.04,5.9 C26.77,5.9 22.49,10.2 22.49,15.4 C22.49,20.7 26.77,25 32.04,25 C37.31,25 41.58,20.7 41.58,15.4 Z M44.85,40.3 C45.83,39.3 47.43,39.3 48.42,40.3 C49.38,41.3 49.4,42.8 48.51,43.8 L48.42,43.9 L38.24,54.1 C38.58,54.9 38.77,55.8 38.77,56.7 C38.77,60.4 35.76,63.4 32.04,63.4 C28.32,63.4 25.3,60.4 25.3,56.7 C25.3,53 28.32,50 32.04,50 C32.97,50 33.86,50.2 34.67,50.5 L44.85,40.3 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M36.53,13.2 C37.92,13.2 39.05,14.3 39.05,15.7 C39.05,17.1 37.99,18.2 36.65,18.2 L36.53,18.2 L34.56,18.2 L34.56,24.7 C34.56,24.7 34.56,24.8 34.56,24.8 C51.05,26.1 64.04,39.9 64.04,56.7 C64.04,74.4 49.71,88.7 32.04,88.7 C14.36,88.7 0.04,74.4 0.04,56.7 C0.04,39.9 13.02,26.1 29.51,24.8 L29.51,24.7 L29.51,18.2 L27.54,18.2 C26.15,18.2 25.02,17.1 25.02,15.7 C25.02,14.4 26.09,13.3 27.43,13.2 L27.54,13.2 L36.53,13.2 Z M32.04,29.8 C17.15,29.8 5.09,41.8 5.09,56.7 C5.09,71.6 17.15,83.6 32.04,83.6 C46.92,83.6 58.98,71.6 58.98,56.7 C58.98,41.8 46.92,29.8 32.04,29.8 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("jaE3v", function(module, exports) {

$parcel$export(module.exports, "Tag", function () { return $df4e05b53fb535e4$export$3288d34c523a1192; });

var $1rY3h = parcelRequire("1rY3h");
var $df4e05b53fb535e4$export$3288d34c523a1192 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-tag",
        width: size,
        height: size,
        viewBox: "0 0 65 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M30.62,47.2 C29.53,48.3 27.78,48.3 26.69,47.3 C25.63,46.2 25.6,44.5 26.59,43.4 L26.68,43.3 L37.14,32.8 C38.23,31.7 39.98,31.7 41.07,32.8 C42.13,33.9 42.16,35.6 41.17,36.7 L41.08,36.8 L30.62,47.2 Z",
                        fillRule: "nonzero",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M25.43,62.7 C28.19,65.4 32.69,65.4 35.44,62.6 L62.5,35.1 C63.79,33.8 64.52,32 64.52,30.1 L64.52,7.8 C64.52,3.9 61.36,0.7 57.47,0.7 L35.13,0.7 C33.26,0.7 31.47,1.5 30.15,2.8 L2.84,30.1 C0.08,32.9 0.08,37.3 2.84,40.1 L25.43,62.7 Z M48.14,24.9 C51.87,24.9 54.9,21.9 54.9,18.2 C54.9,14.4 51.87,11.4 48.14,11.4 C44.41,11.4 41.39,14.4 41.39,18.2 C41.39,21.9 44.41,24.9 48.14,24.9 Z M31.17,46.7 C30.14,47.7 28.47,47.7 27.43,46.7 C26.43,45.7 26.4,44.1 27.34,43 L27.43,42.9 L37.38,33 C38.41,31.9 40.08,31.9 41.12,33 C42.12,34 42.15,35.6 41.21,36.6 L41.12,36.7 L31.17,46.7 Z M19.13,38.4 C20.16,39.4 21.84,39.4 22.87,38.4 L32.82,28.4 L32.9,28.3 C33.85,27.3 33.82,25.7 32.81,24.7 C31.78,23.6 30.1,23.6 29.07,24.7 L19.12,34.6 L19.04,34.7 C18.09,35.8 18.12,37.4 19.13,38.4 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M22.31,38.9 C21.23,40 19.47,40 18.38,38.9 C17.33,37.9 17.29,36.2 18.29,35.1 L18.38,35 L28.84,24.5 C29.92,23.4 31.68,23.4 32.76,24.5 C33.82,25.6 33.85,27.3 32.86,28.4 L32.77,28.4 L22.31,38.9 Z",
                        fillRule: "nonzero",
                        opacity: "0.5"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("gRPoa", function(module, exports) {

$parcel$export(module.exports, "ThumbsUp", function () { return $c479755805722892$export$3058ab2b4b055ec4; });

var $1rY3h = parcelRequire("1rY3h");
var $c479755805722892$export$3058ab2b4b055ec4 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-tag",
        width: size,
        height: size,
        viewBox: "0 0 65 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M30.62,47.2 C29.53,48.3 27.78,48.3 26.69,47.3 C25.63,46.2 25.6,44.5 26.59,43.4 L26.68,43.3 L37.14,32.8 C38.23,31.7 39.98,31.7 41.07,32.8 C42.13,33.9 42.16,35.6 41.17,36.7 L41.08,36.8 L30.62,47.2 Z",
                        fillRule: "nonzero",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M25.43,62.7 C28.19,65.4 32.69,65.4 35.44,62.6 L62.5,35.1 C63.79,33.8 64.52,32 64.52,30.1 L64.52,7.8 C64.52,3.9 61.36,0.7 57.47,0.7 L35.13,0.7 C33.26,0.7 31.47,1.5 30.15,2.8 L2.84,30.1 C0.08,32.9 0.08,37.3 2.84,40.1 L25.43,62.7 Z M48.14,24.9 C51.87,24.9 54.9,21.9 54.9,18.2 C54.9,14.4 51.87,11.4 48.14,11.4 C44.41,11.4 41.39,14.4 41.39,18.2 C41.39,21.9 44.41,24.9 48.14,24.9 Z M31.17,46.7 C30.14,47.7 28.47,47.7 27.43,46.7 C26.43,45.7 26.4,44.1 27.34,43 L27.43,42.9 L37.38,33 C38.41,31.9 40.08,31.9 41.12,33 C42.12,34 42.15,35.6 41.21,36.6 L41.12,36.7 L31.17,46.7 Z M19.13,38.4 C20.16,39.4 21.84,39.4 22.87,38.4 L32.82,28.4 L32.9,28.3 C33.85,27.3 33.82,25.7 32.81,24.7 C31.78,23.6 30.1,23.6 29.07,24.7 L19.12,34.6 L19.04,34.7 C18.09,35.8 18.12,37.4 19.13,38.4 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M22.31,38.9 C21.23,40 19.47,40 18.38,38.9 C17.33,37.9 17.29,36.2 18.29,35.1 L18.38,35 L28.84,24.5 C29.92,23.4 31.68,23.4 32.76,24.5 C33.82,25.6 33.85,27.3 32.86,28.4 L32.77,28.4 L22.31,38.9 Z",
                        fillRule: "nonzero",
                        opacity: "0.5"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("hP3aT", function(module, exports) {

$parcel$export(module.exports, "TrafficCone", function () { return $cf99a97fdcac43cb$export$adf54dea6d40c719; });

var $1rY3h = parcelRequire("1rY3h");
var $cf99a97fdcac43cb$export$adf54dea6d40c719 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-traffic cone",
        width: size,
        height: size,
        viewBox: "0 0 65 63",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M9.83,57.2 L3.19,57.2 C1.77,57.2 0.61,58.3 0.61,59.8 C0.61,61.1 1.7,62.3 3.06,62.3 L3.19,62.3 L62.04,62.3 C63.46,62.3 64.61,61.2 64.61,59.8 C64.61,58.4 63.53,57.3 62.16,57.2 L62.04,57.2 L55.4,57.2 L35.88,3.1 C34.78,0 30.45,0 29.35,3.1 L9.83,57.2 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M42.51,21.5 L47.87,36.3 L17.35,36.3 L22.72,21.5 L42.51,21.5 Z M15.5,41.5 L49.73,41.5 L55.4,57.2 L9.83,57.2 L15.5,41.5 Z M40.66,16.3 L35.84,3 C34.75,0 30.48,0 29.39,3 L24.57,16.3 L40.66,16.3 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("5Xzri", function(module, exports) {

$parcel$export(module.exports, "TrafficLight", function () { return $456df3edf7c896e6$export$d4fc9733947c2cf9; });

var $1rY3h = parcelRequire("1rY3h");
var $456df3edf7c896e6$export$d4fc9733947c2cf9 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-traffic light",
        width: size,
        height: size,
        viewBox: "0 0 65 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M0.93,26 L15.29,26 L15.29,40.4 C7.36,40.4 0.93,33.9 0.93,26 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M0.93,6.5 L15.29,6.5 L15.29,20.9 C7.36,20.9 0.93,14.5 0.93,6.5 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M50.57,26 L64.93,26 C64.93,33.9 58.5,40.4 50.57,40.4 L50.57,26 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M50.57,6.5 L64.93,6.5 C64.93,14.5 58.5,20.9 50.57,20.9 L50.57,6.5 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M50.57,45.5 L64.93,45.5 C64.93,53.4 58.5,59.9 50.57,59.9 L50.57,45.5 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M0.93,45.5 L15.29,45.5 L15.29,59.9 C7.36,59.9 0.93,53.4 0.93,45.5 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M13.34,57.3 C13.34,61.4 16.67,64.8 20.78,64.8 L44.98,64.8 C49.09,64.8 52.42,61.4 52.42,57.3 L52.42,8.3 C52.42,4.2 49.09,0.9 44.98,0.9 L20.78,0.9 C16.67,0.9 13.34,4.2 13.34,8.3 L13.34,57.3 Z M32.57,26.9 C29.14,26.9 26.36,29.7 26.36,33.1 C26.36,36.6 29.14,39.3 32.57,39.3 C36,39.3 38.77,36.6 38.77,33.1 C38.77,29.7 36,26.9 32.57,26.9 Z M26.36,13.9 C26.36,10.5 29.14,7.7 32.57,7.7 C36,7.7 38.77,10.5 38.77,13.9 C38.77,17.3 36,20.1 32.57,20.1 C29.14,20.1 26.36,17.3 26.36,13.9 Z M32.57,46.2 C29.14,46.2 26.36,48.9 26.36,52.4 C26.36,55.8 29.14,58.6 32.57,58.6 C36,58.6 38.77,55.8 38.77,52.4 C38.77,48.9 36,46.2 32.57,46.2 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("bciKd", function(module, exports) {

$parcel$export(module.exports, "Trash", function () { return $826f5af0ce3799f6$export$99442c433de1441d; });

var $1rY3h = parcelRequire("1rY3h");
var $826f5af0ce3799f6$export$99442c433de1441d = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-trash",
        width: size,
        height: size,
        viewBox: "0 0 57 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M18.99,10.3 C18.99,4.9 23.44,0.4 28.92,0.4 C34.4,0.4 38.85,4.9 38.85,10.3 L38.85,12.5 L33.89,12.5 L33.89,10.3 C33.89,7.6 31.74,5.5 29.07,5.4 L28.92,5.4 C26.18,5.4 23.95,7.6 23.95,10.3 L23.95,12.5 L18.99,12.5 L18.99,10.3 Z M6.02,17.5 L6.02,57.8 C6.02,61.4 8.99,64.4 12.64,64.4 L45.2,64.4 C48.85,64.4 51.82,61.4 51.82,57.8 L51.82,17.5 L6.02,17.5 Z M23.4,28.3 C24.73,28.3 25.82,29.3 25.88,30.6 L25.89,30.8 L25.89,45.6 C25.89,47 24.77,48.1 23.4,48.1 C22.07,48.1 20.98,47.1 20.92,45.8 L20.92,45.6 L20.92,30.8 C20.92,29.4 22.03,28.3 23.4,28.3 Z M36.92,30.6 C36.86,29.3 35.77,28.3 34.44,28.3 C33.07,28.3 31.95,29.4 31.95,30.8 L31.95,45.6 L31.96,45.8 C32.02,47.1 33.11,48.1 34.44,48.1 C35.81,48.1 36.92,47 36.92,45.6 L36.92,30.8 L36.92,30.6 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M0.51,15 C0.51,13.7 1.62,12.5 2.99,12.5 L54.3,12.5 C55.67,12.5 56.78,13.7 56.78,15 C56.78,16.4 55.67,17.5 54.3,17.5 L2.99,17.5 C1.62,17.5 0.51,16.4 0.51,15 Z",
                        opacity: "0.5"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("2VED3", function(module, exports) {

$parcel$export(module.exports, "Trophy", function () { return $22206bb018ad6a56$export$c902dcd836bd9c4f; });

var $1rY3h = parcelRequire("1rY3h");
var $22206bb018ad6a56$export$c902dcd836bd9c4f = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-trophy",
        width: size,
        height: size,
        viewBox: "0 0 65 57",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M26.36,27 C26.36,25.6 25.24,24.4 23.83,24.3 L23.72,24.3 L20.47,24.3 C16.59,24.3 13.07,22.8 10.48,20.3 L10.19,20.1 C8.23,18.1 6.83,15.5 6.27,12.7 L6.24,12.5 L14.69,12.5 C16.11,12.5 17.27,11.4 17.33,10 L17.33,9.9 C17.33,8.4 16.21,7.3 14.8,7.2 L14.69,7.2 L3.36,7.2 C1.9,7.2 0.72,8.4 0.72,9.9 C0.72,20.7 9.39,29.4 20.14,29.6 L20.47,29.6 L23.72,29.6 C25.17,29.6 26.36,28.4 26.36,27 Z",
                        fillRule: "nonzero",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M39.09,27 C39.09,25.6 40.21,24.4 41.61,24.3 L41.73,24.3 L44.98,24.3 C52.01,24.3 57.87,19.3 59.18,12.7 L59.21,12.5 L50.76,12.5 C49.34,12.5 48.18,11.4 48.12,10 L48.12,9.9 C48.12,8.4 49.24,7.3 50.64,7.2 L50.76,7.2 L62.08,7.2 C63.54,7.2 64.72,8.4 64.72,9.9 C64.72,20.7 56.06,29.4 45.3,29.6 L44.98,29.6 L41.73,29.6 C40.27,29.6 39.09,28.4 39.09,27 Z",
                        fillRule: "nonzero",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M12.22,0 C12.21,0 12.21,0 12.21,0 L12.21,13.1 C12.21,24.3 21.3,33.4 32.52,33.4 C43.74,33.4 52.83,24.3 52.83,13.1 L52.83,0 C52.83,0 52.83,0 52.82,0 L12.22,0 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M25.3,32.9 C25.3,36.9 28.53,40.2 32.52,40.2 C36.51,40.2 39.74,36.9 39.74,32.9 L39.74,25.7 L25.3,25.7 L25.3,32.9 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M46.22,53.7 C46.22,55.2 45.03,56.3 43.58,56.3 L20.78,56.3 L20.67,56.3 C19.27,56.3 18.15,55.1 18.15,53.7 C18.15,52.2 19.33,51.1 20.78,51.1 L29.66,51.1 L29.66,26.6 L34.93,26.6 L34.93,51.1 L43.58,51.1 L43.69,51.1 C45.1,51.1 46.22,52.3 46.22,53.7 Z",
                        opacity: "0.5"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("d1F1T", function(module, exports) {

$parcel$export(module.exports, "UpgradeToPaid", function () { return $97bb31f1dec8e4ab$export$9ea404e48d222f2; });

var $1rY3h = parcelRequire("1rY3h");
var $97bb31f1dec8e4ab$export$9ea404e48d222f2 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-upgrade to paid",
        width: size,
        height: size,
        viewBox: "0 0 63 64",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M20.87,10.7 C20.87,4.8 25.67,0 31.59,0 C37.51,0 42.3,4.8 42.3,10.7 L42.3,18.8 C42.3,20.2 41.11,21.4 39.63,21.4 L23.55,21.4 C22.07,21.4 20.87,20.2 20.87,18.8 L20.87,10.7 Z M36.95,10.7 C36.95,7.8 34.63,5.5 31.75,5.4 L31.59,5.4 C28.63,5.4 26.23,7.8 26.23,10.7 L26.23,16.1 L36.95,16.1 L36.95,10.7 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M55.31,14.6 C59.14,14.6 62.25,17.7 62.25,21.5 L62.25,57.1 C62.25,60.9 59.14,64 55.31,64 L7.87,64 C4.03,64 0.93,60.9 0.93,57.1 L0.93,21.5 C0.93,17.7 4.03,14.6 7.87,14.6 L55.31,14.6 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M6.88,14.7 C3.5,15.3 0.93,18.2 0.93,21.7 L0.93,56.9 C0.93,60.4 3.5,63.3 6.88,63.9 L6.88,14.7 Z M12.24,64 L50.04,64 L50.04,64 L50.04,14.6 L12.24,14.6 L12.24,64 C12.24,64 12.24,64 12.24,64 Z M62.25,56.9 C62.25,60.7 59.21,63.8 55.4,64 L55.4,14.6 C59.21,14.8 62.25,17.9 62.25,21.7 L62.25,56.9 Z M23.44,31.2 C22.4,32.2 22.4,33.9 23.44,34.9 C24.46,36 26.08,36 27.13,35 L27.23,34.9 L29.21,33 L29.21,53.3 L29.21,53.4 C29.28,54.8 30.45,56 31.89,56 C33.37,56 34.56,54.8 34.56,53.3 L34.56,33 L36.54,34.9 C37.55,36 39.18,36 40.23,35 L40.33,34.9 C41.34,33.9 41.37,32.3 40.42,31.3 L40.33,31.2 L33.78,24.6 C32.77,23.6 31.14,23.6 30.09,24.5 L29.99,24.6 L23.44,31.2 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("apOGQ", function(module, exports) {

$parcel$export(module.exports, "Vault", function () { return $79538f2ab94b1ac7$export$78184e1725f184c5; });

var $1rY3h = parcelRequire("1rY3h");
var $79538f2ab94b1ac7$export$78184e1725f184c5 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-vault",
        width: size,
        height: size,
        viewBox: "0 0 65 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M64.93,8.3 C64.93,4.2 61.59,0.9 57.47,0.9 L8.38,0.9 C4.27,0.9 0.93,4.2 0.93,8.3 L0.93,57.4 C0.93,61.5 4.27,64.9 8.38,64.9 L57.47,64.9 C61.59,64.9 64.93,61.5 64.93,57.4 L64.93,8.3 Z M9.93,17.5 C9.87,16 8.64,14.9 7.14,14.9 C5.6,14.9 4.35,16.1 4.35,17.7 L4.35,25.7 L4.35,25.9 C4.42,27.3 5.64,28.5 7.14,28.5 C8.69,28.5 9.94,27.3 9.94,25.7 L9.94,17.7 L9.93,17.5 Z M7.14,37.2 C8.64,37.2 9.87,38.4 9.93,39.9 L9.94,40 L9.94,48.1 C9.94,49.6 8.69,50.9 7.14,50.9 C5.64,50.9 4.42,49.7 4.35,48.2 L4.35,48.1 L4.35,40 C4.35,38.5 5.6,37.2 7.14,37.2 Z M32.93,27.6 C30.01,27.6 27.65,30 27.65,32.9 C27.65,35.8 30.01,38.2 32.93,38.2 C35.84,38.2 38.21,35.8 38.21,32.9 C38.21,30 35.84,27.6 32.93,27.6 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M10.87,7.1 C8.81,7.1 7.14,8.8 7.14,10.8 L7.14,14.9 C8.64,14.9 9.87,16 9.93,17.5 L9.94,17.7 L9.94,25.7 C9.94,27.3 8.69,28.5 7.14,28.5 L7.14,37.2 C8.64,37.2 9.87,38.4 9.93,39.9 L9.94,40 L9.94,48.1 C9.94,49.6 8.69,50.9 7.14,50.9 L7.14,54.9 C7.14,57 8.81,58.7 10.87,58.7 L54.99,58.7 C57.05,58.7 58.71,57 58.71,54.9 L58.71,10.8 C58.71,8.8 57.05,7.1 54.99,7.1 L10.87,7.1 Z M20.81,32.9 C20.81,39.6 26.24,45 32.93,45 C39.62,45 45.04,39.6 45.04,32.9 C45.04,26.2 39.62,20.8 32.93,20.8 C26.24,20.8 20.81,26.2 20.81,32.9 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("huMrE", function(module, exports) {

$parcel$export(module.exports, "Video", function () { return $cbcad12af379994b$export$ae01dedf5c052bb; });

var $1rY3h = parcelRequire("1rY3h");
var $cbcad12af379994b$export$ae01dedf5c052bb = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-video",
        width: size,
        height: size,
        viewBox: "0 0 65 48",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M46.69,17.5 L58.31,6.2 C60.45,4.1 64.04,5.7 64.04,8.6 L64.04,39.3 C64.04,42.3 60.45,43.8 58.31,41.7 L46.69,30.5 L41.07,30.5 L41.07,17.5 L46.69,17.5 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M39.95,0.7 C43.67,0.7 46.69,3.7 46.69,7.4 L46.69,40.6 C46.69,44.3 43.67,47.3 39.95,47.3 L6.78,47.3 C3.06,47.3 0.04,44.3 0.04,40.6 L0.04,7.4 C0.04,3.7 3.06,0.7 6.78,0.7 L39.95,0.7 Z M38.82,13.3 C38.82,15.9 36.68,18.1 34.04,18.1 C31.4,18.1 29.27,15.9 29.27,13.3 C29.27,10.7 31.4,8.5 34.04,8.5 C36.68,8.5 38.82,10.7 38.82,13.3 Z M38.54,35.8 C38.54,34.4 37.41,33.3 36.01,33.3 L11.28,33.3 L11.16,33.3 C9.82,33.3 8.75,34.4 8.75,35.8 C8.75,37.2 9.88,38.3 11.28,38.3 L36.01,38.3 L36.13,38.3 C37.47,38.3 38.54,37.1 38.54,35.8 Z"
                    }),
                    (0, $1rY3h.jsx)("g", {
                        transform: "translate(8.000000, 33.000000)",
                        fillRule: "nonzero",
                        opacity: "0.5",
                        children: (0, $1rY3h.jsx)("path", {
                            d: "M28.01,0.3 C29.41,0.3 30.54,1.4 30.54,2.8 C30.54,4.1 29.47,5.3 28.13,5.3 L28.01,5.3 L3.28,5.3 C1.88,5.3 0.75,4.2 0.75,2.8 C0.75,1.4 1.82,0.3 3.16,0.3 L3.28,0.3 L28.01,0.3 Z"
                        })
                    })
                ]
            })
        })
    });
};

});

parcelRegister("8jk5f", function(module, exports) {

$parcel$export(module.exports, "Agile", function () { return $60cfad4a1eac0a4e$export$ce09609e01eede2d; });

var $1rY3h = parcelRequire("1rY3h");
var $60cfad4a1eac0a4e$export$ce09609e01eede2d = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-software-agile",
        width: size,
        height: size,
        viewBox: "0 0 64 42",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsx)("g", {
                fill: "currentColor",
                fillRule: "nonzero",
                children: (0, $1rY3h.jsxs)("g", {
                    children: [
                        (0, $1rY3h.jsx)("path", {
                            d: "M31.52,34.699 C22.05,34.699 14.37,27.02 14.37,17.5474 C14.37,8.0748 22.05,0.3956 31.52,0.3956 C40.99,0.3956 48.67,8.0748 48.67,17.5474 C48.67,18.9046 47.57,20.0047 46.21,20.0047 C44.86,20.0047 43.76,18.9046 43.76,17.5474 C43.76,10.789 38.28,5.3102 31.52,5.3102 C24.76,5.3102 19.28,10.789 19.28,17.5474 C19.28,24.2383 24.65,29.675 31.32,29.783 L31.52,29.785 L55.44,29.785 C56.8,29.785 57.9,30.885 57.9,32.242 C57.9,33.56 56.86,34.636 55.56,34.697 L55.44,34.699 L31.52,34.699 Z"
                        }),
                        (0, $1rY3h.jsx)("path", {
                            d: "M52.64,23.4772 C53.57,22.545 55.07,22.5183 56.03,23.3973 L56.11,23.4772 L63.14,30.505 C64.07,31.437 64.1,32.932 63.22,33.896 L63.14,33.98 L56.11,41.007 C55.15,41.967 53.6,41.967 52.64,41.007 C51.71,40.075 51.68,38.58 52.56,37.616 L52.64,37.532 L57.93,32.242 L52.64,26.952 C51.71,26.02 51.68,24.5252 52.56,23.5609 L52.64,23.4772 Z"
                        }),
                        (0, $1rY3h.jsx)("path", {
                            d: "M3.34,34.77 C1.98,34.77 0.88,33.669 0.88,32.312 C0.88,30.994 1.92,29.918 3.22,29.858 L3.34,29.855 L13.42,29.855 C14.77,29.855 15.87,30.955 15.87,32.312 C15.87,33.631 14.83,34.706 13.53,34.767 L13.42,34.77 L3.34,34.77 Z"
                        })
                    ]
                })
            })
        })
    });
};

});

parcelRegister("ixEjJ", function(module, exports) {

$parcel$export(module.exports, "Android", function () { return $d7fa9536a8697357$export$9c05caacc72cdd64; });

var $1rY3h = parcelRequire("1rY3h");
var $d7fa9536a8697357$export$9c05caacc72cdd64 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-software-android",
        width: size,
        height: size,
        viewBox: "0 0 55 64",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsxs)("g", {
                        transform: "translate(6.000000, 0.000000)",
                        children: [
                            (0, $1rY3h.jsxs)("g", {
                                transform: "translate(7.000000, 0.000000)",
                                fillRule: "nonzero",
                                opacity: "0.5",
                                children: [
                                    (0, $1rY3h.jsx)("path", {
                                        d: "M0.97,0.591 C1.81,-0.206 3.13,-0.192 3.96,0.604 L4.04,0.684 L11.77,8.895 C12.59,9.769 12.55,11.145 11.67,11.968 C10.83,12.765 9.51,12.751 8.68,11.954 L8.6,11.875 L0.87,3.663 C0.05,2.789 0.09,1.414 0.97,0.591 Z"
                                    }),
                                    (0, $1rY3h.jsx)("path", {
                                        d: "M24.06,0.684 C24.88,-0.19 26.26,-0.232 27.13,0.591 C27.98,1.388 28.04,2.704 27.3,3.58 L27.22,3.663 L19.49,11.875 C18.67,12.749 17.3,12.791 16.42,11.968 C15.58,11.171 15.51,9.855 16.25,8.979 L16.33,8.895 L24.06,0.684 Z"
                                    })
                                ]
                            }),
                            (0, $1rY3h.jsx)("path", {
                                d: "M0.76,26.807 L0.76,26.083 C0.76,15.012 9.74,6.037 20.81,6.037 C31.88,6.037 40.85,15.012 40.85,26.083 L40.85,26.807 L0.76,26.807 Z M11.39,17.388 C11.39,15.387 13.01,13.765 15.01,13.765 C17.01,13.765 18.63,15.387 18.63,17.388 C18.63,19.388 17.01,21.01 15.01,21.01 C13.01,21.01 11.39,19.388 11.39,17.388 Z M27.09,13.765 C25.09,13.765 23.46,15.387 23.46,17.388 C23.46,19.388 25.09,21.01 27.09,21.01 C29.09,21.01 30.71,19.388 30.71,17.388 C30.71,15.387 29.09,13.765 27.09,13.765 Z"
                            }),
                            (0, $1rY3h.jsx)("path", {
                                d: "M0.76,26.807 L13.58,26.324 L40.85,26.807 C40.85,28.141 39.77,29.222 38.44,29.222 L3.18,29.222 C1.84,29.222 0.76,28.141 0.76,26.807 Z"
                            })
                        ]
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M6.76,37.676 L6.76,58.204 C6.76,61.406 9.36,64.001 12.56,64.001 L41.06,64.001 C44.26,64.001 46.85,61.406 46.85,58.204 L46.85,37.676 L6.78,37.676 C6.77,37.676 6.77,37.676 6.76,37.676 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M47.09,33.328 C50.91,33.328 54.02,36.382 54.1,40.18 L54.1,40.332 L54.1,59.17 C54.1,60.37 53.13,61.343 51.92,61.343 C50.76,61.343 49.81,60.425 49.75,59.272 L49.75,59.17 L49.75,40.332 C49.75,38.901 48.62,37.734 47.2,37.677 L47.09,37.675 L7.02,37.675 C5.58,37.675 4.4,38.817 4.35,40.246 L4.35,40.351 L4.35,59.17 C4.35,60.37 3.37,61.343 2.17,61.343 C1.01,61.343 0.06,60.425 0,59.272 L0,59.17 L0,40.351 C0,36.524 3.06,33.411 6.87,33.33 L7.02,33.328 L47.09,33.328 Z",
                        fillRule: "nonzero",
                        opacity: "0.5"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("koSWo", function(module, exports) {

$parcel$export(module.exports, "BrowserArrowRight", function () { return $eda0aa9eb743d864$export$8ee6fe1efac48ede; });

var $1rY3h = parcelRequire("1rY3h");
var $eda0aa9eb743d864$export$8ee6fe1efac48ede = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-software-browser arrow right",
        width: size,
        height: size,
        viewBox: "0 0 65 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M37.47,31.21 C38.57,30.118 40.34,30.118 41.43,31.21 L48.26,38.045 L48.36,38.149 C49.36,39.247 49.32,40.941 48.26,41.999 L41.43,48.834 L41.32,48.933 C40.23,49.925 38.53,49.892 37.47,48.834 L37.38,48.73 C36.38,47.632 36.42,45.938 37.47,44.88 L39.54,42.818 L18.64,42.818 C17.09,42.818 15.84,41.566 15.84,40.022 C15.84,38.522 17.02,37.297 18.5,37.229 L18.64,37.226 L39.54,37.226 L37.47,35.164 L37.38,35.06 C36.38,33.962 36.42,32.267 37.47,31.21 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M0.93,18.271 L64.93,18.271 L64.93,57.418 C64.93,61.536 61.59,64.874 57.47,64.874 L8.38,64.874 C4.27,64.874 0.93,61.536 0.93,57.418 L0.93,18.271 Z M41.43,31.207 C40.34,30.115 38.57,30.115 37.48,31.207 C36.42,32.265 36.38,33.96 37.38,35.057 L37.48,35.162 L39.54,37.223 L18.64,37.223 L18.51,37.226 C17.02,37.295 15.84,38.519 15.84,40.019 C15.84,41.564 17.09,42.816 18.64,42.816 L39.54,42.816 L37.48,44.877 C36.42,45.935 36.38,47.63 37.38,48.727 L37.48,48.832 C38.53,49.89 40.23,49.923 41.33,48.931 L41.43,48.832 L48.26,41.997 C49.32,40.939 49.36,39.244 48.36,38.147 L48.26,38.042 L41.43,31.207 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M64.93,18.273 L0.93,18.273 L0.93,8.331 C0.93,4.213 4.27,0.875 8.38,0.875 L57.47,0.875 C61.59,0.875 64.93,4.213 64.93,8.331 L64.93,18.273 Z M9.63,13.924 C11.69,13.924 13.36,12.255 13.36,10.196 C13.36,8.137 11.69,6.467 9.63,6.467 C7.57,6.467 5.9,8.137 5.9,10.196 C5.9,12.255 7.57,13.924 9.63,13.924 Z M23.3,10.196 C23.3,12.255 21.63,13.924 19.57,13.924 C17.51,13.924 15.84,12.255 15.84,10.196 C15.84,8.137 17.51,6.467 19.57,6.467 C21.63,6.467 23.3,8.137 23.3,10.196 Z M29.51,13.924 C31.57,13.924 33.24,12.255 33.24,10.196 C33.24,8.137 31.57,6.467 29.51,6.467 C27.45,6.467 25.78,8.137 25.78,10.196 C25.78,12.255 27.45,13.924 29.51,13.924 Z",
                        opacity: "0.5"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("lIQ9r", function(module, exports) {

$parcel$export(module.exports, "BrowserTerminal", function () { return $fd062936619b8a0a$export$13c1099ae3472666; });

var $1rY3h = parcelRequire("1rY3h");
var $fd062936619b8a0a$export$13c1099ae3472666 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-software-browser terminal",
        width: size,
        height: size,
        viewBox: "0 0 65 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M64.93,18.28 L0.93,18.28 L0.93,7.82 C0.93,3.98 4.03,0.88 7.87,0.88 L57.99,0.88 C61.82,0.88 64.93,3.98 64.93,7.82 L64.93,18.28 Z M9.63,13.92 C11.69,13.92 13.35,12.26 13.35,10.2 C13.35,8.14 11.69,6.47 9.63,6.47 C7.57,6.47 5.9,8.14 5.9,10.2 C5.9,12.26 7.57,13.92 9.63,13.92 Z M23.3,10.2 C23.3,12.26 21.63,13.92 19.57,13.92 C17.51,13.92 15.84,12.26 15.84,10.2 C15.84,8.14 17.51,6.47 19.57,6.47 C21.63,6.47 23.3,8.14 23.3,10.2 Z M29.51,13.92 C31.57,13.92 33.24,12.26 33.24,10.2 C33.24,8.14 31.57,6.47 29.51,6.47 C27.45,6.47 25.78,8.14 25.78,10.2 C25.78,12.26 27.45,13.92 29.51,13.92 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M64.93,8.33 C64.93,4.21 61.59,0.88 57.47,0.88 L8.38,0.88 C4.27,0.88 0.93,4.21 0.93,8.33 L0.93,8.33 C0.93,4.21 4.27,0.88 8.38,0.88 L57.47,0.88 C61.59,0.88 64.93,4.21 64.93,8.33 L64.93,8.33 Z M64.93,18.27 L0.93,18.27 L0.93,57.42 C0.93,61.54 4.27,64.87 8.38,64.87 L57.47,64.87 C61.59,64.87 64.93,61.54 64.93,57.42 L64.93,18.27 Z M22.17,31.21 C21.08,30.12 19.3,30.12 18.21,31.21 C17.15,32.27 17.12,33.96 18.11,35.06 L18.21,35.16 L23.07,40.02 L18.21,44.88 C17.15,45.94 17.12,47.63 18.11,48.73 L18.21,48.83 C19.27,49.89 20.97,49.92 22.06,48.93 L22.17,48.83 L29,42 C30.06,40.94 30.09,39.25 29.1,38.15 L29,38.04 L22.17,31.21 Z M36.65,44.06 C35.17,44.14 34,45.36 34,46.86 C34,48.4 35.25,49.65 36.79,49.65 L46.46,49.65 L46.6,49.65 C48.08,49.57 49.26,48.35 49.26,46.86 C49.26,45.31 48,44.06 46.46,44.06 L36.79,44.06 L36.65,44.06 Z"
                    }),
                    (0, $1rY3h.jsxs)("g", {
                        transform: "translate(17.000000, 30.000000)",
                        fillRule: "nonzero",
                        opacity: "0.5",
                        children: [
                            (0, $1rY3h.jsx)("path", {
                                d: "M5.17,1.21 C4.08,0.12 2.31,0.12 1.21,1.21 C0.16,2.27 0.12,3.96 1.11,5.06 L1.21,5.16 L6.07,10.02 L1.21,14.88 C0.16,15.94 0.12,17.63 1.11,18.73 L1.21,18.83 C2.27,19.89 3.97,19.92 5.06,18.93 L5.17,18.83 L12,12 C13.06,10.94 13.09,9.25 12.1,8.15 L12,8.04 L5.17,1.21 Z"
                            }),
                            (0, $1rY3h.jsx)("path", {
                                d: "M17,16.86 C17,15.36 18.17,14.14 19.65,14.06 L19.79,14.06 L29.46,14.06 C31,14.06 32.26,15.31 32.26,16.86 C32.26,18.35 31.08,19.58 29.6,19.65 L29.46,19.65 L19.79,19.65 C18.25,19.65 17,18.4 17,16.86 Z"
                            })
                        ]
                    })
                ]
            })
        })
    });
};

});

parcelRegister("bUhTm", function(module, exports) {

$parcel$export(module.exports, "BrowserWindow", function () { return $8ab2cda07a282e03$export$d4c8edbcf5678e61; });

var $1rY3h = parcelRequire("1rY3h");
var $8ab2cda07a282e03$export$d4c8edbcf5678e61 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-software-browser window",
        width: size,
        height: size,
        viewBox: "0 0 65 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M64.93,18.27 L0.93,18.27 L0.93,7.81 C0.93,3.98 4.03,0.88 7.87,0.88 L57.99,0.88 C61.82,0.88 64.93,3.98 64.93,7.81 L64.93,18.27 Z M9.63,13.92 C11.69,13.92 13.35,12.25 13.35,10.2 C13.35,8.14 11.69,6.47 9.63,6.47 C7.57,6.47 5.9,8.14 5.9,10.2 C5.9,12.25 7.57,13.92 9.63,13.92 Z M23.3,10.2 C23.3,12.25 21.63,13.92 19.57,13.92 C17.51,13.92 15.84,12.25 15.84,10.2 C15.84,8.14 17.51,6.47 19.57,6.47 C21.63,6.47 23.3,8.14 23.3,10.2 Z M29.51,13.92 C31.57,13.92 33.24,12.25 33.24,10.2 C33.24,8.14 31.57,6.47 29.51,6.47 C27.45,6.47 25.78,8.14 25.78,10.2 C25.78,12.25 27.45,13.92 29.51,13.92 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M64.93,18.27 L0.93,18.27 L0.93,8.33 C0.93,8.12 0.94,7.91 0.95,7.7 C0.94,7.91 0.93,8.12 0.93,8.33 L0.93,57.42 C0.93,61.54 4.27,64.87 8.38,64.87 L57.47,64.87 C61.59,64.87 64.93,61.54 64.93,57.42 L64.93,18.27 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("g5Woz", function(module, exports) {

$parcel$export(module.exports, "BrowserCode", function () { return $bb7a690d51da9438$export$a08f4612fe78677e; });

var $1rY3h = parcelRequire("1rY3h");
var $bb7a690d51da9438$export$a08f4612fe78677e = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-software-browser code",
        width: size,
        height: size,
        viewBox: "0 0 65 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("rect", {
                        fillRule: "nonzero",
                        opacity: "0.5",
                        x: "10.87",
                        y: "25.73",
                        width: "45.3592",
                        height: "27.3398"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M57.5,0.88 C57.49,0.88 57.48,0.88 57.47,0.88 L8.38,0.88 C8.38,0.88 8.37,0.88 8.36,0.88 L57.5,0.88 Z M64.93,18.28 L0.93,18.28 L0.93,57.42 C0.93,61.54 4.27,64.88 8.38,64.88 L57.47,64.88 C61.59,64.88 64.93,61.54 64.93,57.42 L64.93,18.28 Z M28.38,31.21 C27.29,30.12 25.52,30.12 24.43,31.21 L17.59,38.05 L17.49,38.15 C16.5,39.25 16.53,40.94 17.59,42 L24.43,48.83 L24.53,48.93 C25.63,49.93 27.32,49.89 28.38,48.83 L28.48,48.73 C29.47,47.63 29.44,45.94 28.38,44.88 L23.52,40.02 L28.38,35.16 L28.48,35.06 C29.47,33.96 29.44,32.27 28.38,31.21 Z M42.05,31.21 C40.96,30.12 39.19,30.12 38.1,31.21 C37.04,32.27 37.01,33.96 38,35.06 L38.1,35.16 L42.95,40.02 L38.1,44.88 C37.04,45.94 37.01,47.63 38,48.73 L38.1,48.83 C39.15,49.89 40.85,49.93 41.95,48.93 L42.05,48.83 L48.89,42 C49.94,40.94 49.98,39.25 48.98,38.15 L48.89,38.05 L42.05,31.21 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M64.93,18.27 L0.93,18.27 L0.93,8.33 C0.93,4.22 4.27,0.88 8.38,0.88 L57.47,0.88 C61.59,0.88 64.93,4.22 64.93,8.33 L64.93,18.27 Z M9.63,13.93 C11.69,13.93 13.35,12.26 13.35,10.2 C13.35,8.14 11.69,6.47 9.63,6.47 C7.57,6.47 5.9,8.14 5.9,10.2 C5.9,12.26 7.57,13.93 9.63,13.93 Z M23.3,10.2 C23.3,12.26 21.63,13.93 19.57,13.93 C17.51,13.93 15.84,12.26 15.84,10.2 C15.84,8.14 17.51,6.47 19.57,6.47 C21.63,6.47 23.3,8.14 23.3,10.2 Z M29.51,13.93 C31.57,13.93 33.24,12.26 33.24,10.2 C33.24,8.14 31.57,6.47 29.51,6.47 C27.45,6.47 25.78,8.14 25.78,10.2 C25.78,12.26 27.45,13.93 29.51,13.93 Z",
                        opacity: "0.5"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("9qiqk", function(module, exports) {

$parcel$export(module.exports, "Bug", function () { return $6dc4d555eed2cb9e$export$1d4edeb465626d27; });

var $1rY3h = parcelRequire("1rY3h");
var $6dc4d555eed2cb9e$export$1d4edeb465626d27 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-software-bug",
        width: size,
        height: size,
        viewBox: "0 0 61 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsxs)("g", {
                        opacity: "0.5",
                        children: [
                            (0, $1rY3h.jsx)("path", {
                                d: "M2.28,9.89 C3.51,9.89 4.51,10.86 4.56,12.07 L4.57,12.18 C4.57,17.4 8.8,21.64 14.03,21.64 C15.29,21.64 16.31,22.66 16.31,23.92 C16.31,25.18 15.29,26.2 14.03,26.2 C6.28,26.2 0,19.92 0,12.18 C0,10.91 1.02,9.89 2.28,9.89 Z",
                                fillRule: "nonzero"
                            }),
                            (0, $1rY3h.jsx)("path", {
                                d: "M14.03,45.12 C15.29,45.12 16.31,46.14 16.31,47.4 C16.31,48.67 15.29,49.69 14.03,49.69 C8.86,49.69 4.66,53.83 4.57,58.98 L4.57,59.15 C4.57,60.41 3.54,61.43 2.28,61.43 C1.02,61.43 0,60.41 0,59.15 C0,51.4 6.28,45.12 14.03,45.12 Z",
                                fillRule: "nonzero"
                            }),
                            (0, $1rY3h.jsx)("path", {
                                d: "M58.06,9.89 C59.32,9.89 60.34,10.91 60.34,12.18 C60.34,19.92 54.06,26.2 46.32,26.2 C45.06,26.2 44.03,25.18 44.03,23.92 C44.03,22.66 45.06,21.64 46.32,21.64 C51.54,21.64 55.78,17.4 55.78,12.18 C55.78,10.91 56.8,9.89 58.06,9.89 Z",
                                fillRule: "nonzero"
                            }),
                            (0, $1rY3h.jsx)("path", {
                                d: "M46.32,45.12 C54.06,45.12 60.34,51.4 60.34,59.15 C60.34,60.41 59.32,61.43 58.06,61.43 C56.8,61.43 55.78,60.41 55.78,59.15 C55.78,53.92 51.54,49.69 46.32,49.69 C45.06,49.69 44.03,48.67 44.03,47.4 C44.03,46.14 45.06,45.12 46.32,45.12 Z",
                                fillRule: "nonzero"
                            }),
                            (0, $1rY3h.jsx)("path", {
                                d: "M18.55,1.19 C19.65,0.64 20.97,1.06 21.56,2.11 L21.62,2.21 L25.53,10.04 C26.09,11.17 25.64,12.54 24.51,13.1 C23.41,13.65 22.09,13.24 21.5,12.18 L21.44,12.08 L17.53,4.25 C16.97,3.13 17.42,1.75 18.55,1.19 Z",
                                fillRule: "nonzero"
                            }),
                            (0, $1rY3h.jsx)("path", {
                                d: "M38.72,2.21 C39.29,1.08 40.66,0.63 41.79,1.19 C42.88,1.74 43.34,3.04 42.86,4.15 L42.81,4.25 L38.89,12.08 C38.33,13.21 36.96,13.67 35.83,13.1 C34.74,12.56 34.27,11.25 34.76,10.14 L34.81,10.04 L38.72,2.21 Z",
                                fillRule: "nonzero"
                            }),
                            (0, $1rY3h.jsx)("path", {
                                d: "M11.23,33.38 L3.78,33.38 L3.67,33.38 C2.46,33.44 1.49,34.44 1.49,35.66 C1.49,36.92 2.51,37.95 3.78,37.95 L11.23,37.95 L11.23,33.38 Z M48.64,37.95 L56.57,37.95 L56.67,37.94 C57.89,37.89 58.85,36.89 58.85,35.66 C58.85,34.4 57.83,33.38 56.57,33.38 L48.64,33.38 L48.64,37.95 Z"
                            })
                        ]
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M29.93,7.54 C40.27,7.54 48.64,15.92 48.64,26.25 L48.64,46.24 C48.64,56.57 40.27,64.95 29.93,64.95 L29.93,64.95 C19.6,64.95 11.23,56.57 11.23,46.24 L11.23,26.25 C11.23,15.92 19.6,7.54 29.93,7.54 L29.93,7.54 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M27.67,7.68 C18.41,8.8 11.23,16.69 11.23,26.25 L11.23,46.24 C11.23,55.81 18.41,63.7 27.67,64.81 L27.67,7.68 Z M32.24,64.81 C41.48,63.68 48.64,55.79 48.64,46.24 L48.64,26.25 C48.64,16.7 41.48,8.82 32.24,7.69 L32.24,64.81 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("9V6dX", function(module, exports) {

$parcel$export(module.exports, "ButlerAutomation", function () { return $738e43e7476aae78$export$1dcfdaccfd79838f; });

var $1rY3h = parcelRequire("1rY3h");
var $738e43e7476aae78$export$1dcfdaccfd79838f = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-software-butler automation",
        width: size,
        height: size,
        viewBox: "0 0 51 66",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsxs)("g", {
                        transform: "translate(0.000000, 15.000000)",
                        children: [
                            (0, $1rY3h.jsx)("g", {
                                transform: "translate(3.000000, 0.000000)",
                                children: (0, $1rY3h.jsx)("path", {
                                    d: "M5.43,30.45 C6.26,30.22 7.13,30.09 8.03,30.07 L8.2,30.07 L36.8,30.07 C37.76,30.07 38.69,30.2 39.57,30.45 C42.19,30.17 44.23,27.95 44.23,25.26 L44.23,5.71 C44.23,2.82 41.89,0.48 39.01,0.48 L5.99,0.48 C3.11,0.48 0.77,2.82 0.77,5.71 L0.77,25.26 C0.77,27.95 2.81,30.17 5.43,30.45 Z M8.78,34.37 L8.78,35.49 C8.78,43.06 14.93,49.2 22.5,49.2 C30.07,49.2 36.21,43.06 36.21,35.49 L36.21,34.37 L8.78,34.37 Z M19.18,15.53 C19.18,17.77 17.36,19.59 15.12,19.59 C12.88,19.59 11.06,17.77 11.06,15.53 C11.06,13.29 12.88,11.47 15.12,11.47 C17.36,11.47 19.18,13.29 19.18,15.53 Z M29.93,19.59 C32.17,19.59 33.99,17.77 33.99,15.53 C33.99,13.29 32.17,11.47 29.93,11.47 C27.69,11.47 25.87,13.29 25.87,15.53 C25.87,17.77 27.69,19.59 29.93,19.59 Z"
                                })
                            }),
                            (0, $1rY3h.jsx)("path", {
                                d: "M39.8,30.07 C45.42,30.07 49.98,34.58 50.07,40.17 L50.07,40.34 L50.07,40.49 C50.07,41.68 49.11,42.64 47.92,42.64 C46.77,42.64 45.83,41.74 45.78,40.6 L45.77,40.49 L45.77,40.34 C45.77,37.09 43.18,34.45 39.95,34.37 L39.8,34.37 L11.19,34.37 C7.95,34.37 5.31,36.96 5.23,40.19 L5.23,40.34 L5.23,40.49 C5.23,41.68 4.26,42.64 3.08,42.64 C1.92,42.64 0.98,41.74 0.93,40.6 L0.93,40.49 L0.93,40.34 C0.93,34.73 5.43,30.16 11.03,30.07 L11.19,30.07 L39.8,30.07 Z",
                                fillRule: "nonzero",
                                opacity: "0.5"
                            })
                        ]
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M25.5,0.2 C22.27,0.2 19.65,2.82 19.65,6.05 C19.65,8.53 21.18,10.64 23.35,11.5 L23.35,15.48 L23.35,15.59 C23.41,16.73 24.35,17.63 25.5,17.63 C26.69,17.63 27.65,16.67 27.65,15.48 L27.65,11.5 C29.82,10.64 31.35,8.53 31.35,6.05 C31.35,2.82 28.73,0.2 25.5,0.2 Z M25.51,7.6 C26.36,7.6 27.05,6.91 27.05,6.05 C27.05,5.2 26.36,4.5 25.5,4.5 C24.64,4.5 23.95,5.2 23.95,6.05 C23.95,6.91 24.64,7.6 25.49,7.6 C25.49,7.6 25.5,7.6 25.5,7.6 C25.5,7.6 25.51,7.6 25.51,7.6 Z",
                        opacity: "0.5"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("2FCbO", function(module, exports) {

$parcel$export(module.exports, "Cloud", function () { return $1f1d08bf348bb07a$export$e2767e27b246eae1; });

var $1rY3h = parcelRequire("1rY3h");
var $1f1d08bf348bb07a$export$e2767e27b246eae1 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-software-cloud",
        width: size,
        height: size,
        viewBox: "0 0 65 44",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsx)("g", {
                fill: "currentColor",
                fillRule: "nonzero",
                children: (0, $1rY3h.jsx)("g", {
                    children: (0, $1rY3h.jsx)("path", {
                        d: "M28.58,0.13 C35.16,0.13 41.15,3.42 44.71,8.71 C45.61,8.57 46.51,8.5 47.43,8.5 C57.01,8.5 64.77,16.27 64.77,25.85 C64.77,35.33 57.16,43.04 47.71,43.19 L47.43,43.19 L13.93,43.19 C6.66,43.19 0.77,37.3 0.77,30.04 C0.77,24.49 4.23,19.65 9.23,17.74 C10.15,7.86 18.46,0.13 28.58,0.13 Z"
                    })
                })
            })
        })
    });
};

});

parcelRegister("k8naB", function(module, exports) {

$parcel$export(module.exports, "CloudCheckmark", function () { return $ea86870f6d9711cc$export$c680fbc74fda3897; });

var $1rY3h = parcelRequire("1rY3h");
var $ea86870f6d9711cc$export$c680fbc74fda3897 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-software-cloud checkmark",
        width: size,
        height: size,
        viewBox: "0 0 65 44",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsx)("g", {
                fill: "currentColor",
                children: (0, $1rY3h.jsx)("path", {
                    d: "M44.93,8.67 C41.37,3.38 35.38,0.08 28.8,0.08 C18.68,0.08 10.37,7.81 9.45,17.69 C4.45,19.6 0.99,24.44 0.99,29.99 C0.99,37.26 6.88,43.15 14.15,43.15 L47.64,43.15 L47.93,43.15 C57.38,42.99 64.99,35.29 64.99,25.8 C64.99,16.22 57.22,8.46 47.64,8.46 C46.73,8.46 45.82,8.53 44.93,8.67 Z M44.06,19.15 C44.87,18.27 44.84,16.9 43.99,16.05 L43.91,15.98 C43.03,15.18 41.67,15.2 40.82,16.05 L29.01,27.86 L24.96,23.81 L24.88,23.73 C24,22.93 22.64,22.96 21.79,23.81 C20.91,24.68 20.91,26.1 21.79,26.98 L27.43,32.62 L27.5,32.69 C28.38,33.49 29.75,33.47 30.6,32.62 L43.99,19.22 L44.06,19.15 Z"
                })
            })
        })
    });
};

});

parcelRegister("8Eq85", function(module, exports) {

$parcel$export(module.exports, "CloudDownload", function () { return $64c653ecfd166d98$export$3a083cd204da2316; });

var $1rY3h = parcelRequire("1rY3h");
var $64c653ecfd166d98$export$3a083cd204da2316 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-software-cloud download",
        width: size,
        height: size,
        viewBox: "0 0 63 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M43.13,8.84 C39.7,3.74 33.92,0.56 27.58,0.56 C17.83,0.56 9.81,8.02 8.93,17.54 C4.11,19.38 0.77,24.04 0.77,29.39 C0.77,36.4 6.45,42.08 13.46,42.08 L29.02,42.08 L29.02,19.59 L29.03,19.47 C29.09,18.09 30.23,16.99 31.62,16.99 C33.05,16.99 34.21,18.16 34.21,19.59 L34.21,42.08 L45.74,42.08 L46.02,42.07 C55.13,41.93 62.46,34.5 62.46,25.35 C62.46,16.12 54.98,8.63 45.74,8.63 C44.86,8.63 43.99,8.7 43.13,8.84 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M31.62,17 C33.05,17 34.21,18.16 34.21,19.59 L34.21,55.63 L37.78,52.06 L37.87,51.98 C38.88,51.05 40.46,51.08 41.45,52.06 C42.46,53.08 42.46,54.72 41.45,55.73 L33.79,63.39 C33.33,64.09 32.53,64.56 31.62,64.56 C31.61,64.56 31.6,64.56 31.59,64.56 C30.91,64.58 30.22,64.32 29.7,63.8 L21.63,55.73 L21.55,55.64 C20.62,54.62 20.65,53.05 21.63,52.06 L21.72,51.98 C22.74,51.05 24.32,51.08 25.3,52.06 L29.02,55.78 L29.02,19.59 L29.03,19.47 C29.09,18.09 30.23,17 31.62,17 Z",
                        opacity: "0.5"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("6BHX5", function(module, exports) {

$parcel$export(module.exports, "CloudEncryption", function () { return $4cf84ab53d898f42$export$ff550f1bfd0dd589; });

var $1rY3h = parcelRequire("1rY3h");
var $4cf84ab53d898f42$export$ff550f1bfd0dd589 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-software-cloud encryption",
        width: size,
        height: size,
        viewBox: "0 0 65 42",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M35.4,22.29 C29.45,22.29 24.63,17.46 24.63,11.52 C24.63,9.63 25.12,7.85 25.97,6.31 C25.11,6.17 24.22,6.09 23.33,6.09 C14.99,6.09 8.14,12.47 7.38,20.61 C3.26,22.18 0.41,26.16 0.41,30.74 C0.41,36.72 5.26,41.58 11.25,41.58 L38.85,41.58 L39.09,41.58 C46.87,41.45 53.15,35.1 53.15,27.29 C53.15,25.53 52.83,23.84 52.25,22.29 L35.4,22.29 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M35.4,22.29 C29.45,22.29 24.63,17.46 24.63,11.52 C24.63,5.57 29.45,0.74 35.4,0.74 L53.64,0.74 C59.59,0.74 64.41,5.57 64.41,11.52 C64.41,17.46 59.59,22.29 53.64,22.29 L35.4,22.29 Z M57.33,11.52 C57.33,9.88 56.01,8.56 54.38,8.56 C52.74,8.56 51.42,9.88 51.42,11.52 C51.42,13.15 52.74,14.47 54.38,14.47 C56.01,14.47 57.33,13.15 57.33,11.52 Z M44.52,8.56 C46.15,8.56 47.48,9.88 47.48,11.52 C47.48,13.15 46.15,14.47 44.52,14.47 C42.89,14.47 41.56,13.15 41.56,11.52 C41.56,9.88 42.89,8.56 44.52,8.56 Z M37.62,11.52 C37.62,9.88 36.3,8.56 34.66,8.56 C33.03,8.56 31.71,9.88 31.71,11.52 C31.71,13.15 33.03,14.47 34.66,14.47 C36.3,14.47 37.62,13.15 37.62,11.52 Z",
                        opacity: "0.5"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("nGhoH", function(module, exports) {

$parcel$export(module.exports, "CloudServer", function () { return $0472f1f22a55b030$export$6dcd210c7bd29bf3; });

var $1rY3h = parcelRequire("1rY3h");
var $0472f1f22a55b030$export$6dcd210c7bd29bf3 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-software-cloud server",
        width: size,
        height: size,
        viewBox: "0 0 51 66",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M23.29,0.2 C27.09,0.2 30.56,2.11 32.62,5.19 C33.14,5.11 33.66,5.06 34.19,5.06 C39.74,5.06 44.24,9.58 44.24,15.14 C44.24,20.65 39.83,25.13 34.36,25.22 L34.19,25.22 L14.8,25.22 C10.59,25.22 7.18,21.8 7.18,17.58 C7.18,14.35 9.19,11.54 12.08,10.43 C12.61,4.69 17.43,0.2 23.29,0.2 Z",
                        fillRule: "nonzero",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsxs)("g", {
                        transform: "translate(0.000000, 30.000000)",
                        children: [
                            (0, $1rY3h.jsx)("path", {
                                d: "M50.49,19.76 L50.49,31.31 C50.49,32.91 49.2,34.2 47.6,34.2 L3.81,34.2 C2.22,34.2 0.93,32.91 0.93,31.31 L0.93,19.76 L50.49,19.76 Z M42.79,24.82 C43.99,24.82 44.96,25.79 44.96,26.98 C44.96,28.14 44.04,29.09 42.89,29.14 L42.79,29.15 L21.62,29.15 C20.42,29.15 19.45,28.18 19.45,26.98 C19.45,25.82 20.37,24.87 21.52,24.82 L21.62,24.82 L42.79,24.82 Z M9.59,29.87 C11.18,29.87 12.48,28.58 12.48,26.98 C12.48,25.39 11.18,24.1 9.59,24.1 C8,24.1 6.7,25.39 6.7,26.98 C6.7,28.58 8,29.87 9.59,29.87 Z"
                            }),
                            (0, $1rY3h.jsx)("circle", {
                                fillRule: "nonzero",
                                opacity: "0.5",
                                cx: "9.59",
                                cy: "26.98",
                                r: "2.88717"
                            }),
                            (0, $1rY3h.jsx)("path", {
                                d: "M47.6,0.04 C49.2,0.04 50.49,1.33 50.49,2.92 L50.49,14.47 L0.93,14.47 L0.93,2.92 C0.93,1.33 2.22,0.04 3.81,0.04 L47.6,0.04 Z M42.79,5.09 C43.99,5.09 44.96,6.06 44.96,7.25 C44.96,8.41 44.04,9.36 42.89,9.42 L42.79,9.42 L21.62,9.42 C20.42,9.42 19.45,8.45 19.45,7.25 C19.45,6.09 20.37,5.14 21.52,5.09 L21.62,5.09 L42.79,5.09 Z M9.59,10.14 C11.18,10.14 12.48,8.85 12.48,7.25 C12.48,5.66 11.18,4.37 9.59,4.37 C8,4.37 6.7,5.66 6.7,7.25 C6.7,8.85 8,10.14 9.59,10.14 Z"
                            }),
                            (0, $1rY3h.jsx)("polygon", {
                                fillRule: "nonzero",
                                opacity: "0.5",
                                points: "0.93 14.47 50.49 14.47 50.49 19.76 0.93 19.76"
                            }),
                            (0, $1rY3h.jsx)("circle", {
                                fillRule: "nonzero",
                                opacity: "0.5",
                                cx: "9.59",
                                cy: "7.25",
                                r: "2.88717"
                            })
                        ]
                    })
                ]
            })
        })
    });
};

});

parcelRegister("84pwJ", function(module, exports) {

$parcel$export(module.exports, "CloudSettings", function () { return $5e027f90207651f4$export$b941fa7d338526; });

var $1rY3h = parcelRequire("1rY3h");
var $5e027f90207651f4$export$b941fa7d338526 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-software-cloud settings",
        width: size,
        height: size,
        viewBox: "0 0 71 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M41.51,47.83 C41.51,44.39 38.72,41.6 35.28,41.6 C31.84,41.6 29.05,44.39 29.05,47.83 C29.05,51.27 31.84,54.06 35.28,54.06 C38.72,54.06 41.51,51.27 41.51,47.83 Z",
                        fillRule: "nonzero"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M38.4,33.26 C38.4,32.13 37.48,31.21 36.35,31.21 L34.22,31.21 C33.09,31.21 32.17,32.13 32.17,33.26 L32.17,35.76 C31.03,36.05 29.95,36.5 28.96,37.09 L27.19,35.33 C26.39,34.52 25.09,34.52 24.29,35.33 L22.79,36.83 C21.99,37.63 21.99,38.93 22.79,39.73 L24.55,41.5 C23.97,42.49 23.51,43.57 23.22,44.71 L20.73,44.71 C19.59,44.71 18.68,45.63 18.68,46.77 L18.68,48.89 C18.68,50.03 19.59,50.95 20.73,50.95 L23.22,50.95 C23.51,52.09 23.97,53.17 24.55,54.16 L22.79,55.93 C21.99,56.73 21.99,58.03 22.79,58.83 L24.29,60.34 C25.09,61.14 26.39,61.14 27.19,60.34 L28.96,58.57 C29.95,59.16 31.03,59.61 32.17,59.9 L32.17,62.4 C32.17,63.53 33.09,64.45 34.22,64.45 L36.35,64.45 C37.48,64.45 38.4,63.53 38.4,62.4 L38.4,59.9 C39.54,59.61 40.62,59.16 41.61,58.57 L43.37,60.34 C44.17,61.14 45.47,61.14 46.27,60.34 L47.78,58.83 C48.58,58.03 48.58,56.73 47.78,55.93 L46.01,54.16 C46.6,53.17 47.05,52.09 47.35,50.95 L49.84,50.95 C50.97,50.95 51.89,50.03 51.89,48.89 L51.89,46.77 C51.89,45.63 50.97,44.71 49.84,44.71 L47.35,44.71 C47.05,43.57 46.6,42.49 46.01,41.5 L47.78,39.73 C48.58,38.93 48.58,37.63 47.78,36.83 L46.27,35.33 C45.47,34.52 44.17,34.52 43.37,35.33 L41.61,37.09 C40.62,36.5 39.54,36.05 38.4,35.76 L38.4,33.26 Z M35.28,41.6 C38.72,41.6 41.51,44.39 41.51,47.83 C41.51,51.27 38.72,54.06 35.28,54.06 C31.84,54.06 29.06,51.27 29.06,47.83 C29.06,44.39 31.84,41.6 35.28,41.6 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M9.92,19.84 C10.92,8.97 20.05,0.45 31.18,0.45 C38.57,0.45 45.08,4.21 48.91,9.91 C49.89,9.75 50.89,9.67 51.9,9.67 C62.43,9.67 70.96,18.21 70.96,28.74 C70.96,39.27 62.43,47.81 51.9,47.81 L51.89,47.81 L51.89,46.77 C51.89,45.63 50.97,44.71 49.84,44.71 L47.35,44.71 C47.05,43.57 46.6,42.49 46.01,41.5 L47.78,39.73 C48.58,38.93 48.58,37.63 47.78,36.83 L46.27,35.33 C45.47,34.52 44.17,34.52 43.37,35.33 L41.61,37.09 C40.62,36.51 39.54,36.05 38.4,35.76 L38.4,33.26 C38.4,32.13 37.48,31.21 36.34,31.21 L34.22,31.21 C33.09,31.21 32.17,32.13 32.17,33.26 L32.17,35.76 C31.03,36.05 29.95,36.51 28.96,37.09 L27.19,35.33 C26.39,34.52 25.09,34.52 24.29,35.33 L22.79,36.83 C21.99,37.63 21.99,38.93 22.79,39.73 L24.55,41.5 C23.97,42.49 23.51,43.57 23.22,44.71 L20.73,44.71 C19.59,44.71 18.68,45.63 18.68,46.77 L18.68,47.81 L15.06,47.81 C7.08,47.81 0.62,41.33 0.62,33.35 C0.62,27.18 4.48,21.91 9.92,19.84 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("100Ph", function(module, exports) {

$parcel$export(module.exports, "Clouds", function () { return $0ba66e8f13385d11$export$517de9992f3047ca; });

var $1rY3h = parcelRequire("1rY3h");
var $0ba66e8f13385d11$export$517de9992f3047ca = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-software-clouds",
        width: size,
        height: size,
        viewBox: "0 0 65 56",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M44.71,8.93 C41.15,3.64 35.16,0.35 28.58,0.35 C18.46,0.35 10.15,8.08 9.23,17.96 C4.23,19.87 0.77,24.7 0.77,30.25 C0.77,36.23 4.76,41.28 10.22,42.88 C11.11,40.19 13.17,38.01 15.83,36.99 C16.49,29.85 22.48,24.27 29.76,24.27 C34.49,24.27 38.8,26.65 41.37,30.47 C42.01,30.37 42.66,30.32 43.32,30.32 C49.69,30.32 54.95,35.12 55.71,41.31 C61.11,38.37 64.77,32.65 64.77,26.07 C64.77,16.49 57.01,8.72 47.43,8.72 C46.51,8.72 45.61,8.79 44.71,8.93 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M29.76,24.27 C34.49,24.27 38.8,26.65 41.37,30.47 C42.01,30.37 42.66,30.32 43.32,30.32 C50.21,30.32 55.8,35.93 55.8,42.84 C55.8,49.69 50.32,55.26 43.52,55.37 L43.32,55.37 L19.21,55.37 C13.98,55.37 9.74,51.12 9.74,45.87 C9.74,41.86 12.23,38.37 15.83,36.99 C16.49,29.85 22.48,24.27 29.76,24.27 Z",
                        fillRule: "nonzero",
                        opacity: "0.5"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("61z2V", function(module, exports) {

$parcel$export(module.exports, "CursorArrow", function () { return $462e05859f23b46f$export$5b781f9caebb973f; });

var $1rY3h = parcelRequire("1rY3h");
var $462e05859f23b46f$export$5b781f9caebb973f = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-software-cursor arrow",
        width: size,
        height: size,
        viewBox: "0 0 65 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsx)("g", {
                fill: "currentColor",
                children: (0, $1rY3h.jsx)("path", {
                    d: "M5.57,0.4 C2.31,-1.08 -1.03,2.27 0.44,5.53 L21.67,52.43 C22.79,54.9 26.03,55.49 27.94,53.57 L37.1,44.42 L55.2,62.51 C57.23,64.55 60.53,64.55 62.56,62.51 C64.59,60.48 64.59,57.19 62.56,55.15 L44.46,37.06 L53.62,27.9 C55.53,25.98 54.94,22.74 52.47,21.63 L5.57,0.4 Z"
                })
            })
        })
    });
};

});

parcelRegister("kQkE3", function(module, exports) {

$parcel$export(module.exports, "CursorHand", function () { return $f2c8ada4c239c2c7$export$18ae1c8a42d46588; });

var $1rY3h = parcelRequire("1rY3h");
var $f2c8ada4c239c2c7$export$18ae1c8a42d46588 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-software-cursor hand",
        width: size,
        height: size,
        viewBox: "0 0 53 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M19.76,64.55 C17.26,64.55 14.96,63.18 13.73,60.94 L6.39,47.67 C5.96,46.88 5.83,45.95 6.04,45.07 L8.9,33.04 L14.56,20.32 L41.43,29.89 L41.43,28.04 C41.43,24.96 43.85,22.47 46.85,22.47 C49.84,22.47 52.27,24.96 52.27,28.04 L52.27,45.11 C52.27,48.1 51.36,51.02 49.65,53.44 L42.9,63.07 C42.25,64 41.2,64.55 40.08,64.55 L19.76,64.55 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M8.9,6.12 C8.9,3.05 11.32,0.55 14.32,0.55 C17.31,0.55 19.74,3.05 19.74,6.12 L19.74,34.81 L8.9,34.81 L8.9,6.12 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M19.74,22.1 C19.74,19.03 22.17,16.53 25.16,16.53 C28.16,16.53 30.58,19.03 30.58,22.1 L30.58,43.25 L19.74,43.25 L19.74,22.1 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M1.28,38.63 C-0.08,36.21 0.72,33.13 3.08,31.73 C5.43,30.34 8.43,31.17 9.79,33.58 L18.72,49.47 L10.21,54.51 L1.28,38.63 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M30.58,25.07 C30.58,22 33.01,19.5 36.01,19.5 C39,19.5 41.43,22 41.43,25.07 L41.43,46.22 L30.58,46.22 L30.58,25.07 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("PqOMb", function(module, exports) {

$parcel$export(module.exports, "Database", function () { return $09a9910662c6490b$export$6feb5ea51a7b0b47; });

var $1rY3h = parcelRequire("1rY3h");
var $09a9910662c6490b$export$6feb5ea51a7b0b47 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-software-database",
        width: size,
        height: size,
        viewBox: "0 0 65 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M32.61,0.27 C14.76,0.27 0.62,4.12 0.62,10.84 C0.62,17.57 14.76,21.42 32.61,21.42 C50.47,21.42 64.61,17.57 64.61,10.84 C64.61,4.12 50.47,0.27 32.61,0.27 Z",
                        fillRule: "nonzero",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M1.1,9.34 C1.03,9.66 0.99,9.99 0.99,10.33 C0.99,16.97 14.97,20.77 32.61,20.77 C50.26,20.77 64.23,16.97 64.23,10.33 C64.23,9.99 64.2,9.66 64.13,9.34 C64.43,9.76 64.61,10.28 64.61,10.85 L64.61,33.86 C64.47,33.97 64.32,34.07 64.15,34.18 C62.99,34.92 61.37,35.65 59.35,36.31 L58.76,36.5 L58.16,36.68 C57.85,36.77 57.53,36.86 57.21,36.95 C50.78,38.69 42,39.7 32.61,39.7 C23.22,39.7 14.44,38.69 8.02,36.95 C7.7,36.86 7.38,36.77 7.07,36.68 L6.46,36.5 L5.88,36.31 C3.86,35.65 2.23,34.92 1.08,34.18 C0.91,34.07 0.76,33.97 0.61,33.86 L0.61,10.85 C0.61,10.28 0.79,9.76 1.1,9.34 Z M0.61,53.7 L0.61,39.73 C7.43,43.01 19.15,44.85 32.61,44.85 C46.07,44.85 57.79,43.01 64.61,39.73 L64.61,53.7 C64.61,60.43 50.47,64.27 32.61,64.27 C14.75,64.27 0.61,60.43 0.61,53.7 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("3aYSv", function(module, exports) {

$parcel$export(module.exports, "DataCenter", function () { return $25018761df4f8eb0$export$f4645eafb2eadc0c; });

var $1rY3h = parcelRequire("1rY3h");
var $25018761df4f8eb0$export$f4645eafb2eadc0c = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-software-data center",
        width: size,
        height: size,
        viewBox: "0 0 65 71",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsxs)("g", {
                        children: [
                            (0, $1rY3h.jsx)("path", {
                                d: "M64.93,51.51 L64.93,66.43 C64.93,68.49 63.26,70.15 61.2,70.15 L4.66,70.15 C2.6,70.15 0.93,68.49 0.93,66.43 L0.93,51.51 L64.93,51.51 Z M15.84,60.83 C15.84,62.89 14.17,64.56 12.11,64.56 C10.05,64.56 8.38,62.89 8.38,60.83 C8.38,58.77 10.05,57.1 12.11,57.1 C14.17,57.1 15.84,58.77 15.84,60.83 Z M57.78,60.83 C57.78,59.29 56.53,58.04 54.99,58.04 L27.65,58.04 L27.51,58.04 C26.03,58.11 24.85,59.33 24.85,60.83 C24.85,62.38 26.1,63.63 27.65,63.63 L54.99,63.63 L55.12,63.63 C56.6,63.56 57.78,62.33 57.78,60.83 Z"
                            }),
                            (0, $1rY3h.jsx)("path", {
                                d: "M64.93,26.04 L64.93,44.68 L0.93,44.68 L0.93,26.04 L64.93,26.04 Z M15.84,35.36 C15.84,37.42 14.17,39.08 12.11,39.08 C10.05,39.08 8.38,37.42 8.38,35.36 C8.38,33.3 10.05,31.63 12.11,31.63 C14.17,31.63 15.84,33.3 15.84,35.36 Z M57.78,35.36 C57.78,33.81 56.53,32.56 54.99,32.56 L27.65,32.56 L27.51,32.56 C26.03,32.63 24.85,33.86 24.85,35.36 C24.85,36.9 26.1,38.15 27.65,38.15 L54.99,38.15 L55.12,38.15 C56.6,38.08 57.78,36.86 57.78,35.36 Z"
                            }),
                            (0, $1rY3h.jsx)("path", {
                                d: "M61.2,0.56 C63.26,0.56 64.93,2.23 64.93,4.29 L64.93,19.2 L0.93,19.2 L0.93,4.29 C0.93,2.23 2.6,0.56 4.66,0.56 L61.2,0.56 Z M15.84,9.88 C15.84,11.94 14.17,13.61 12.11,13.61 C10.05,13.61 8.38,11.94 8.38,9.88 C8.38,7.82 10.05,6.15 12.11,6.15 C14.17,6.15 15.84,7.82 15.84,9.88 Z M57.78,9.88 C57.78,8.34 56.53,7.09 54.99,7.09 L27.65,7.09 L27.51,7.09 C26.03,7.16 24.85,8.38 24.85,9.88 C24.85,11.43 26.1,12.68 27.65,12.68 L54.99,12.68 L55.12,12.68 C56.6,12.61 57.78,11.38 57.78,9.88 Z"
                            })
                        ]
                    }),
                    (0, $1rY3h.jsx)("rect", {
                        fillRule: "nonzero",
                        opacity: "0.5",
                        x: "0.93",
                        y: "44.68",
                        width: "63.9997",
                        height: "6.83492"
                    }),
                    (0, $1rY3h.jsx)("rect", {
                        fillRule: "nonzero",
                        opacity: "0.5",
                        x: "0.93",
                        y: "19.2",
                        width: "63.9997",
                        height: "6.83492"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("4tQtC", function(module, exports) {

$parcel$export(module.exports, "Firewall", function () { return $343293a9007ae25f$export$a0e020eeac88cef2; });

var $1rY3h = parcelRequire("1rY3h");
var $343293a9007ae25f$export$a0e020eeac88cef2 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-software-firewall",
        width: size,
        height: size,
        viewBox: "0 0 60 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsx)("g", {
                fill: "currentColor",
                children: (0, $1rY3h.jsx)("path", {
                    d: "M59.66,8.39 C59.66,4.24 56.29,0.88 52.15,0.88 L8.33,0.88 C4.18,0.88 0.82,4.24 0.82,8.39 L0.82,27.29 C0.82,41.35 8.67,54.23 21.17,60.67 L28.52,64.46 C29.6,65.01 30.88,65.01 31.96,64.46 L39.31,60.67 C51.81,54.23 59.66,41.35 59.66,27.29 L59.66,8.39 Z M40.72,20.44 C46.5,26.23 46.5,35.61 40.71,41.4 C34.99,47.12 25.74,47.19 19.92,41.56 L19.76,41.4 C13.97,35.61 13.97,26.23 19.76,20.44 L29.05,11.15 C30.11,10.09 31.91,10.84 31.91,12.33 L31.92,23.32 L36.57,18.67 C37.2,18.04 38.2,18.01 38.86,18.59 L38.94,18.66 L40.72,20.44 Z"
                })
            })
        })
    });
};

});

parcelRegister("6OhQm", function(module, exports) {

$parcel$export(module.exports, "GitBranch", function () { return $4f5540f540f1bdb7$export$42cc5f4d9846574a; });

var $1rY3h = parcelRequire("1rY3h");
var $4f5540f540f1bdb7$export$42cc5f4d9846574a = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-software-git branch",
        width: size,
        height: size,
        viewBox: "0 0 65 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M13.69,55.92 C13.62,57.28 12.5,58.36 11.13,58.36 C9.71,58.36 8.57,57.22 8.57,55.8 L8.57,43.32 C8.57,43.31 8.57,43.3 8.57,43.29 L8.57,39.3 L8.57,39.27 L8.57,9.15 L8.57,9.03 C8.63,7.67 9.76,6.59 11.13,6.59 C12.54,6.59 13.69,7.74 13.69,9.15 L13.69,30.94 C14.97,30.29 16.42,29.92 17.95,29.92 L46.11,29.92 L46.25,29.91 C48.55,29.84 50.38,27.96 50.38,25.65 L50.38,9.15 L50.38,9.03 C50.45,7.67 51.57,6.59 52.94,6.59 C54.36,6.59 55.5,7.74 55.5,9.15 L55.5,25.65 L55.5,25.83 C55.4,30.93 51.24,35.04 46.11,35.04 L17.95,35.04 L17.82,35.04 C15.54,35.11 13.71,36.97 13.69,39.25 L13.69,55.8 L13.69,55.92 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("rect", {
                        fillRule: "nonzero",
                        transform: "translate(11.413350, 9.156650) scale(-1, 1) rotate(-180.000000) translate(-11.413350, -9.156650) ",
                        x: "2.88",
                        y: "0.6233",
                        width: "17.0667",
                        height: "17.0667",
                        rx: "8.53333"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M41.85,11.71 C41.85,17.84 46.81,22.81 52.94,22.81 C59.07,22.81 64.03,17.84 64.03,11.71 C64.03,5.59 59.07,0.62 52.94,0.62 C46.81,0.62 41.85,5.59 41.85,11.71 Z",
                        fillRule: "nonzero"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M0.04,11.71 C0.04,17.84 5,22.81 11.13,22.81 C17.26,22.81 22.22,17.84 22.22,11.71 C22.22,5.59 17.26,0.62 11.13,0.62 C5,0.62 0.04,5.59 0.04,11.71 Z",
                        fillRule: "nonzero"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M11.13,64.33 C17.26,64.33 22.22,59.37 22.22,53.24 C22.22,47.11 17.26,42.15 11.13,42.15 C5,42.15 0.04,47.11 0.04,53.24 C0.04,59.37 5,64.33 11.13,64.33 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("6iGyx", function(module, exports) {

$parcel$export(module.exports, "GlobeNetwork", function () { return $49656f3d7fbfa985$export$99eb63777644763f; });

var $1rY3h = parcelRequire("1rY3h");
var $49656f3d7fbfa985$export$99eb63777644763f = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-software-globe network",
        width: size,
        height: size,
        viewBox: "0 0 65 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M64.04,32.98 C64.04,50.66 49.71,64.98 32.04,64.98 C14.36,64.98 0.04,50.66 0.04,32.98 C0.04,15.31 14.36,0.98 32.04,0.98 C49.71,0.98 64.04,15.31 64.04,32.98 Z",
                        fillRule: "nonzero",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M52.43,41.69 C52.86,39.04 53.09,36.32 53.09,33.55 C53.09,30.38 52.8,27.29 52.24,24.28 L62.84,24.28 C63.62,27.05 64.04,29.97 64.04,32.98 C64.04,36 63.62,38.92 62.84,41.69 L52.43,41.69 Z M60.94,46.74 L51.34,46.74 C49.75,52.58 47.14,58 43.71,62.79 C51.28,59.82 57.45,54.04 60.94,46.74 Z M29.2,1.11 C29.21,1.11 29.22,1.11 29.23,1.11 L29.23,19.23 L17.79,19.23 C20.11,12.29 24.06,6.09 29.2,1.11 Z M29.23,64.86 C28.8,64.83 28.38,64.78 27.95,64.73 C23.16,59.7 19.51,53.56 17.43,46.74 L29.23,46.74 L29.23,64.86 Z M35.49,64.8 C35.09,64.84 34.68,64.88 34.28,64.91 L34.28,46.74 L46.08,46.74 C43.99,53.59 40.32,59.76 35.49,64.8 Z M19.58,62.47 C12.36,59.41 6.49,53.79 3.13,46.74 L12.17,46.74 C13.72,52.45 16.25,57.76 19.58,62.47 Z M1.23,41.69 C0.45,38.92 0.04,36 0.04,32.98 C0.04,29.97 0.45,27.05 1.23,24.28 L11.27,24.28 C10.71,27.29 10.42,30.38 10.42,33.55 C10.42,36.32 10.65,39.04 11.08,41.69 L1.23,41.69 Z M3.13,19.23 L12.49,19.23 C14.25,13.3 17.07,7.83 20.74,3.03 C12.99,5.96 6.67,11.8 3.13,19.23 Z M42.55,2.75 C50.65,5.57 57.28,11.56 60.94,19.23 L51.02,19.23 C49.22,13.18 46.32,7.61 42.55,2.75 Z M29.23,24.28 L16.42,24.28 C15.8,27.27 15.47,30.37 15.47,33.55 C15.47,36.33 15.72,39.05 16.21,41.69 L29.23,41.69 L29.23,24.28 Z M47.3,41.69 C47.78,39.05 48.04,36.33 48.04,33.55 C48.04,30.37 47.71,27.27 47.09,24.28 L34.28,24.28 L34.28,41.69 L47.3,41.69 Z M34.28,1.08 L34.28,19.23 L45.72,19.23 C43.4,12.27 39.43,6.07 34.28,1.08 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("9DfNj", function(module, exports) {

$parcel$export(module.exports, "GlobeNetworkLocation", function () { return $7034020699748afd$export$a77ccf4e15db1c7a; });

var $1rY3h = parcelRequire("1rY3h");
var $7034020699748afd$export$a77ccf4e15db1c7a = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsxs)("svg", {
        id: "icon-software-globe network location",
        width: size,
        height: size,
        viewBox: "0 0 65 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            (0, $1rY3h.jsx)("defs", {
                children: (0, $1rY3h.jsx)("rect", {
                    x: "0.04",
                    y: "0.56",
                    width: "64",
                    height: "64",
                    rx: "32"
                })
            }),
            (0, $1rY3h.jsx)("g", {
                stroke: "none",
                strokeWidth: "1",
                fill: "none",
                fillRule: "evenodd",
                children: (0, $1rY3h.jsxs)("g", {
                    children: [
                        (0, $1rY3h.jsxs)("g", {
                            children: [
                                (0, $1rY3h.jsx)("g", {
                                    transform: "translate(32.040000, 32.560000) rotate(-180.000000) translate(-32.040000, -32.560000) "
                                }),
                                (0, $1rY3h.jsx)("path", {
                                    d: "M60.67,83.37 C88.42,83.37 110.91,60.87 110.91,33.12 C110.91,5.37 88.42,-17.12 60.67,-17.12 C49.9,-17.12 39.93,-13.74 31.75,-7.97 C23.58,-13.74 13.61,-17.12 2.84,-17.12 C-24.91,-17.12 -47.4,5.37 -47.4,33.12 C-47.4,60.87 -24.91,83.37 2.84,83.37 C13.61,83.37 23.58,79.99 31.75,74.22 C39.93,79.99 49.9,83.37 60.67,83.37 Z M60.67,-12.07 C51.53,-12.07 43.03,-9.36 35.92,-4.7 C42.97,1.48 48.28,9.59 51.02,18.81 L68.53,18.81 C69.92,18.81 71.05,19.94 71.05,21.34 C71.05,22.69 69.99,23.8 68.65,23.86 L68.53,23.86 L52.24,23.86 C52.45,25.03 52.63,26.22 52.77,27.42 C51.42,28.61 50.56,30.34 50.56,32.28 C50.56,34.29 51.48,36.09 52.92,37.27 C52.81,38.62 52.65,39.95 52.43,41.26 L68.53,41.26 C69.92,41.26 71.05,42.4 71.05,43.79 C71.05,45.15 69.99,46.25 68.65,46.31 L68.53,46.32 L51.34,46.32 C48.71,56 43.26,64.52 35.92,70.95 C43.03,75.61 51.53,78.32 60.67,78.32 C85.63,78.32 105.86,58.08 105.86,33.12 C105.86,8.16 85.63,-12.07 60.67,-12.07 Z M2.84,-12.07 C11.98,-12.07 20.48,-9.36 27.59,-4.7 C20.54,1.47 15.23,9.59 12.49,18.81 L-2.21,18.81 L-2.33,18.81 C-3.67,18.87 -4.74,19.98 -4.74,21.34 C-4.74,22.73 -3.61,23.86 -2.21,23.86 L11.27,23.86 C10.71,26.86 10.42,29.96 10.42,33.12 C10.42,35.9 10.65,38.62 11.08,41.26 L-2.21,41.26 L-2.33,41.27 C-3.67,41.33 -4.74,42.44 -4.74,43.79 C-4.74,45.19 -3.61,46.32 -2.21,46.32 L12.17,46.32 C14.8,56 20.25,64.52 27.59,70.95 C20.48,75.61 11.98,78.32 2.84,78.32 C-22.12,78.32 -42.35,58.08 -42.35,33.12 C-42.35,8.16 -22.12,-12.07 2.84,-12.07 Z M33.07,66.72 C32.64,67.11 32.2,67.49 31.75,67.86 C31.31,67.49 30.87,67.11 30.44,66.72 C30.82,66.95 31.27,67.09 31.75,67.09 C32.24,67.09 32.69,66.95 33.07,66.72 Z M46.08,46.32 C43.75,53.95 39.46,60.73 33.79,66.06 C34.1,65.64 34.28,65.12 34.28,64.56 L34.28,46.32 L46.08,46.32 Z M48.04,33.12 C48.04,35.9 47.78,38.62 47.3,41.26 L34.28,41.26 L34.28,25.39 C32.91,24.2 32.03,22.45 32.03,20.49 C32.03,18.54 32.91,16.78 34.28,15.6 L34.28,0.66 C39.43,5.65 43.4,11.85 45.72,18.81 L44.73,18.81 C44.87,19.35 44.95,19.91 44.95,20.49 C44.95,21.73 44.6,22.88 44,23.86 L47.09,23.86 C47.71,26.85 48.04,29.95 48.04,33.12 Z M18,48.06 C20.42,54.98 24.48,61.13 29.72,66.05 C29.43,65.67 29.25,65.19 29.23,64.68 L29.23,64.56 L29.23,46.32 L26.21,46.32 C27.05,45.23 27.54,43.87 27.54,42.39 C27.54,42 27.51,41.63 27.45,41.26 L29.23,41.26 L29.23,23.86 L16.42,23.86 C15.8,26.85 15.47,29.95 15.47,33.12 C15.47,35 15.59,36.85 15.81,38.67 C15.07,39.72 14.63,41 14.63,42.39 C14.63,44.83 15.99,46.96 18,48.06 Z M29.23,0.66 C24.08,5.65 20.11,11.85 17.79,18.81 L29.23,18.81 L29.23,0.66 Z",
                                    fill: "currentColor",
                                    opacity: "0.5",
                                    mask: "url(#mask-2)"
                                })
                            ]
                        }),
                        (0, $1rY3h.jsx)("path", {
                            d: "M29.23,0.68 L29.2,0.69 C24.06,5.67 20.11,11.86 17.79,18.81 L29.23,18.81 L29.23,0.68 Z M27.95,64.3 C28.38,64.36 28.8,64.4 29.23,64.44 L29.23,46.32 L26.21,46.32 C25.03,47.85 23.17,48.84 21.09,48.84 C19.97,48.84 18.92,48.56 18,48.06 C20.14,54.18 23.57,59.71 27.95,64.3 Z M15.81,38.67 C15.59,36.85 15.47,35 15.47,33.12 C15.47,29.95 15.8,26.85 16.42,23.86 L29.23,23.86 L29.23,41.26 L27.45,41.26 C26.92,38.23 24.27,35.93 21.09,35.93 C18.91,35.93 16.98,37.01 15.81,38.67 Z M34.28,64.48 C34.68,64.46 35.09,64.42 35.49,64.38 C40.32,59.33 43.99,53.17 46.08,46.32 L34.28,46.32 L34.28,64.48 Z M60.94,46.32 C57.45,53.62 51.28,59.4 43.71,62.37 C47.14,57.58 49.75,52.16 51.34,46.32 L60.94,46.32 Z M64.04,32.56 C64.04,35.58 63.62,38.5 62.84,41.26 L52.43,41.26 C52.65,39.95 52.81,38.62 52.92,37.27 C54.03,38.19 55.46,38.74 57.02,38.74 C60.58,38.74 63.47,35.85 63.47,32.28 C63.47,28.72 60.58,25.83 57.02,25.83 C55.39,25.83 53.9,26.43 52.77,27.42 C52.63,26.22 52.45,25.03 52.24,23.86 L62.84,23.86 C63.62,26.63 64.04,29.55 64.04,32.56 Z M51.02,18.81 L60.94,18.81 C57.28,11.14 50.65,5.15 42.55,2.33 C46.32,7.19 49.22,12.76 51.02,18.81 Z M3.13,46.32 C6.49,53.37 12.36,58.99 19.57,62.05 C16.25,57.34 13.72,52.03 12.17,46.32 L3.13,46.32 Z M11.08,41.26 L1.23,41.26 C0.45,38.5 0.04,35.58 0.04,32.56 C0.04,29.55 0.45,26.63 1.23,23.86 L11.27,23.86 C10.71,26.86 10.42,29.96 10.42,33.12 C10.42,35.9 10.65,38.61 11.08,41.26 Z M20.74,2.61 C12.99,5.54 6.67,11.38 3.13,18.81 L12.49,18.81 C14.25,12.88 17.07,7.4 20.74,2.61 Z M47.3,41.26 C47.78,38.62 48.04,35.9 48.04,33.12 C48.04,29.95 47.71,26.85 47.09,23.86 L44,23.86 C42.87,25.71 40.82,26.95 38.49,26.95 C36.88,26.95 35.41,26.36 34.28,25.39 L34.28,41.26 L47.3,41.26 Z M38.49,14.04 C36.88,14.04 35.41,14.62 34.28,15.6 L34.28,0.66 C39.43,5.65 43.4,11.85 45.72,18.81 L44.73,18.81 C43.98,16.06 41.47,14.04 38.49,14.04 Z",
                            fill: "currentColor"
                        })
                    ]
                })
            })
        ]
    });
};

});

parcelRegister("fiuCn", function(module, exports) {

$parcel$export(module.exports, "KanbanMove", function () { return $b230498eb691832a$export$1ec379b7b27c9eb0; });

var $1rY3h = parcelRequire("1rY3h");
var $b230498eb691832a$export$1ec379b7b27c9eb0 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-software-kanban move",
        width: size,
        height: size,
        viewBox: "0 0 65 53",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M44.92,38.46 C46.45,38.46 47.69,39.7 47.69,41.23 L47.69,49.55 C47.69,51.08 46.45,52.32 44.92,52.32 L2.87,52.32 C1.34,52.32 0.1,51.08 0.1,49.55 L0.1,41.23 C0.1,39.7 1.34,38.46 2.87,38.46 L44.92,38.46 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M44.92,19.51 C46.45,19.51 47.69,20.75 47.69,22.28 L47.69,30.6 C47.69,32.13 46.45,33.37 44.92,33.37 L2.87,33.37 C1.34,33.37 0.1,32.13 0.1,30.6 L0.1,22.28 C0.1,20.75 1.34,19.51 2.87,19.51 L44.92,19.51 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M44.92,0.56 C46.45,0.56 47.69,1.8 47.69,3.34 L47.69,11.65 C47.69,13.18 46.45,14.43 44.92,14.43 L2.87,14.43 C1.34,14.43 0.1,13.18 0.1,11.65 L0.1,3.34 C0.1,1.8 1.34,0.56 2.87,0.56 L44.92,0.56 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M53.15,17.58 C53.94,16.79 55.2,16.76 56.02,17.5 L56.09,17.58 L63.49,24.97 C64.27,25.76 64.3,27.02 63.56,27.83 L63.49,27.91 L56.09,35.3 C55.28,36.12 53.97,36.12 53.15,35.3 C52.37,34.52 52.34,33.26 53.08,32.44 L53.15,32.36 L59.08,26.44 L53.15,20.52 C52.37,19.73 52.34,18.47 53.08,17.65 L53.15,17.58 Z",
                        fillRule: "nonzero"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M56.93,24.36 C58.08,24.36 59.01,25.29 59.01,26.44 C59.01,27.56 58.14,28.47 57.03,28.52 L56.93,28.52 L24.13,28.52 C22.98,28.52 22.05,27.59 22.05,26.44 C22.05,25.33 22.93,24.41 24.03,24.36 L24.13,24.36 L56.93,24.36 Z",
                        fillRule: "nonzero"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("3VSq5", function(module, exports) {

$parcel$export(module.exports, "Server", function () { return $2dd0e8964c76cab4$export$d59771a2e9612de9; });

var $1rY3h = parcelRequire("1rY3h");
var $2dd0e8964c76cab4$export$d59771a2e9612de9 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-software-server",
        width: size,
        height: size,
        viewBox: "0 0 49 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsxs)("g", {
                        transform: "translate(9.000000, 10.000000)",
                        fillRule: "nonzero",
                        opacity: "0.5",
                        children: [
                            (0, $1rY3h.jsx)("path", {
                                d: "M27.71,11.71 C29.13,11.71 30.28,12.86 30.28,14.28 C30.28,15.66 29.2,16.78 27.83,16.85 L27.71,16.85 L3.14,16.85 C1.72,16.85 0.57,15.7 0.57,14.28 C0.57,12.9 1.65,11.77 3.02,11.71 L3.14,11.71 L27.71,11.71 Z"
                            }),
                            (0, $1rY3h.jsx)("path", {
                                d: "M27.71,0.28 C29.13,0.28 30.28,1.43 30.28,2.85 C30.28,4.23 29.2,5.35 27.83,5.42 L27.71,5.42 L3.14,5.42 C1.72,5.42 0.57,4.27 0.57,2.85 C0.57,1.47 1.65,0.34 3.02,0.28 L3.14,0.28 L27.71,0.28 Z"
                            })
                        ]
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M41.28,0.56 C45.07,0.56 48.14,3.63 48.14,7.42 L48.14,57.71 C48.14,61.49 45.07,64.56 41.28,64.56 L7.57,64.56 C3.78,64.56 0.71,61.49 0.71,57.71 L0.71,7.42 C0.71,3.63 3.78,0.56 7.57,0.56 L41.28,0.56 Z M27.57,51.42 C27.57,49.53 26.03,47.99 24.14,47.99 C22.25,47.99 20.71,49.53 20.71,51.42 C20.71,53.31 22.25,54.85 24.14,54.85 C26.03,54.85 27.57,53.31 27.57,51.42 Z M24.14,33.71 C26.82,33.71 29,35.88 29,38.56 C29,41.25 26.82,43.42 24.14,43.42 C21.46,43.42 19.28,41.25 19.28,38.56 C19.28,35.88 21.46,33.71 24.14,33.71 Z M36.71,21.71 C38.13,21.71 39.28,22.86 39.28,24.28 C39.28,25.66 38.2,26.78 36.83,26.85 L36.71,26.85 L12.14,26.85 C10.72,26.85 9.57,25.7 9.57,24.28 C9.57,22.9 10.65,21.77 12.02,21.71 L12.14,21.71 L36.71,21.71 Z M39.28,12.85 C39.28,11.43 38.13,10.28 36.71,10.28 L12.14,10.28 L12.02,10.28 C10.65,10.34 9.57,11.47 9.57,12.85 C9.57,14.27 10.72,15.42 12.14,15.42 L36.71,15.42 L36.83,15.42 C38.2,15.35 39.28,14.23 39.28,12.85 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("g2Au7", function(module, exports) {

$parcel$export(module.exports, "Settings", function () { return $bad9225e5dbfebb9$export$c72f6eaae7b9adff; });

var $1rY3h = parcelRequire("1rY3h");
var $bad9225e5dbfebb9$export$c72f6eaae7b9adff = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-software-settings",
        width: size,
        height: size,
        viewBox: "0 0 65 63",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsx)("g", {
                fill: "currentColor",
                fillRule: "nonzero",
                children: (0, $1rY3h.jsxs)("g", {
                    children: [
                        (0, $1rY3h.jsx)("path", {
                            d: "M62.04,49.28 C63.46,49.28 64.62,50.43 64.62,51.85 C64.62,53.23 63.53,54.36 62.16,54.42 L62.04,54.43 L3.19,54.43 C1.77,54.43 0.62,53.27 0.62,51.85 C0.62,50.48 1.7,49.35 3.07,49.29 L3.19,49.28 L62.04,49.28 Z",
                            opacity: "0.5"
                        }),
                        (0, $1rY3h.jsx)("path", {
                            d: "M32.62,51.28 C32.62,57.44 27.63,62.43 21.47,62.43 C15.32,62.43 10.33,57.44 10.33,51.28 C10.33,45.13 15.32,40.14 21.47,40.14 C27.63,40.14 32.62,45.13 32.62,51.28 Z"
                        }),
                        (0, $1rY3h.jsx)("path", {
                            d: "M62.04,9.28 C63.46,9.28 64.62,10.43 64.62,11.85 C64.62,13.23 63.53,14.36 62.16,14.42 L62.04,14.43 L3.19,14.43 C1.77,14.43 0.62,13.27 0.62,11.85 C0.62,10.48 1.7,9.35 3.07,9.29 L3.19,9.28 L62.04,9.28 Z",
                            opacity: "0.5"
                        }),
                        (0, $1rY3h.jsx)("path", {
                            d: "M32.62,11.28 C32.62,17.44 27.63,22.43 21.47,22.43 C15.32,22.43 10.33,17.44 10.33,11.28 C10.33,5.13 15.32,0.14 21.47,0.14 C27.63,0.14 32.62,5.13 32.62,11.28 Z"
                        }),
                        (0, $1rY3h.jsx)("path", {
                            d: "M62.04,29.28 C63.46,29.28 64.62,30.43 64.62,31.85 C64.62,33.23 63.53,34.36 62.16,34.42 L62.04,34.43 L3.19,34.43 C1.77,34.43 0.62,33.27 0.62,31.85 C0.62,30.48 1.7,29.35 3.07,29.29 L3.19,29.28 L62.04,29.28 Z",
                            opacity: "0.5"
                        }),
                        (0, $1rY3h.jsx)("path", {
                            d: "M64.62,31.86 C64.62,38.01 59.63,43 53.47,43 C47.32,43 42.33,38.01 42.33,31.86 C42.33,25.7 47.32,20.71 53.47,20.71 C59.63,20.71 64.62,25.7 64.62,31.86 Z"
                        })
                    ]
                })
            })
        })
    });
};

});

parcelRegister("88Rcr", function(module, exports) {

$parcel$export(module.exports, "TrelloBoards", function () { return $5ed8566d8f6d83d0$export$90a05f55e5b2edae; });

var $1rY3h = parcelRequire("1rY3h");
var $5ed8566d8f6d83d0$export$90a05f55e5b2edae = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-software-trello boards",
        width: size,
        height: size,
        viewBox: "0 0 65 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M64.14,47.44 C64.14,50.89 61.35,53.69 57.9,53.69 L46.97,53.69 L46.97,31.31 L38.65,31.31 L38.65,10.5 L10.55,10.5 L10.55,6.34 C10.55,2.89 13.35,0.09 16.79,0.09 L57.9,0.09 C61.35,0.09 64.14,2.89 64.14,6.34 L64.14,47.44 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M6.91,57.33 L46.97,57.33 L46.97,31.31 L6.91,31.31 L6.91,57.33 Z M34.49,35.74 C35.78,35.74 36.83,36.78 36.83,38.08 C36.83,39.33 35.84,40.36 34.6,40.42 L34.49,40.42 L14.19,40.42 C12.9,40.42 11.85,39.37 11.85,38.08 C11.85,36.82 12.84,35.8 14.08,35.74 L14.19,35.74 L34.49,35.74 Z M26.42,48.48 C26.42,47.19 25.37,46.14 24.08,46.14 L14.19,46.14 L14.08,46.14 C12.84,46.2 11.85,47.23 11.85,48.48 C11.85,49.78 12.9,50.82 14.19,50.82 L24.08,50.82 L24.19,50.82 C25.43,50.76 26.42,49.74 26.42,48.48 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M53.74,57.85 C53.74,61.3 50.94,64.09 47.49,64.09 L6.39,64.09 C2.94,64.09 0.14,61.3 0.14,57.85 L0.14,16.74 C0.14,13.3 2.94,10.5 6.39,10.5 L47.49,10.5 C50.94,10.5 53.74,13.3 53.74,16.74 L53.74,57.85 Z M21.22,18.83 C21.22,17.53 20.17,16.48 18.88,16.48 L8.99,16.48 L8.88,16.49 C7.64,16.54 6.65,17.57 6.65,18.83 C6.65,20.12 7.7,21.17 8.99,21.17 L18.88,21.17 L18.99,21.16 C20.23,21.11 21.22,20.08 21.22,18.83 Z M46.97,18.83 C46.97,17.1 45.58,15.7 43.85,15.7 C42.13,15.7 40.73,17.1 40.73,18.83 C40.73,20.55 42.13,21.95 43.85,21.95 C45.58,21.95 46.97,20.55 46.97,18.83 Z M46.97,57.33 L6.91,57.33 L6.91,31.31 L46.97,31.31 L46.97,57.33 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("22xfN", function(module, exports) {

$parcel$export(module.exports, "TrelloCard", function () { return $17c5902e21a677b7$export$4ac305cbd8e60e82; });

var $1rY3h = parcelRequire("1rY3h");
var $17c5902e21a677b7$export$4ac305cbd8e60e82 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-software-trello card",
        width: size,
        height: size,
        viewBox: "0 0 64 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M56.54,64.87 C60.66,64.87 64,61.54 64,57.42 L64,8.33 C64,4.21 60.66,0.87 56.54,0.87 L7.46,0.87 C3.34,0.87 0,4.21 0,8.33 L0,57.42 C0,61.54 3.34,64.87 7.46,64.87 L56.54,64.87 Z M32,53.38 C33.54,53.38 34.8,54.63 34.8,56.18 C34.8,57.68 33.61,58.9 32.13,58.97 L32,58.97 L10.56,58.97 C9.02,58.97 7.77,57.72 7.77,56.18 C7.77,54.68 8.95,53.45 10.43,53.38 L10.56,53.38 L32,53.38 Z M51.26,51.83 C53.66,51.83 55.61,53.77 55.61,56.18 C55.61,58.58 53.66,60.53 51.26,60.53 C48.86,60.53 46.91,58.58 46.91,56.18 C46.91,53.77 48.86,51.83 51.26,51.83 Z M32,26.04 C33.54,26.04 34.8,24.79 34.8,23.24 C34.8,21.74 33.61,20.52 32.13,20.45 L32,20.45 L10.56,20.45 C9.02,20.45 7.77,21.7 7.77,23.24 C7.77,24.74 8.95,25.97 10.43,26.04 L10.56,26.04 L32,26.04 Z M56.23,10.82 C56.23,12.36 54.98,13.61 53.44,13.61 L10.56,13.61 L10.43,13.61 C8.95,13.54 7.77,12.32 7.77,10.82 C7.77,9.27 9.02,8.02 10.56,8.02 L53.44,8.02 L53.57,8.02 C55.05,8.09 56.23,9.32 56.23,10.82 Z"
                    }),
                    (0, $1rY3h.jsxs)("g", {
                        transform: "translate(7.000000, 8.000000)",
                        fillRule: "nonzero",
                        opacity: "0.5",
                        children: [
                            (0, $1rY3h.jsx)("path", {
                                d: "M25,18.04 C26.54,18.04 27.8,16.79 27.8,15.24 C27.8,13.74 26.62,12.52 25.13,12.45 L25,12.45 L3.56,12.45 C2.02,12.45 0.77,13.7 0.77,15.24 C0.77,16.74 1.95,17.97 3.43,18.04 L3.56,18.04 L25,18.04 Z"
                            }),
                            (0, $1rY3h.jsx)("path", {
                                d: "M46.44,5.61 C47.98,5.61 49.23,4.36 49.23,2.82 C49.23,1.32 48.05,0.09 46.57,0.02 L46.44,0.02 L3.56,0.02 C2.02,0.02 0.77,1.27 0.77,2.82 C0.77,4.32 1.95,5.54 3.43,5.61 L3.56,5.61 L46.44,5.61 Z"
                            })
                        ]
                    })
                ]
            })
        })
    });
};

});

parcelRegister("brafE", function(module, exports) {

$parcel$export(module.exports, "TrelloCardFullCover", function () { return $853a2b0cee563b5c$export$f07fd0fc7a8431ec; });

var $1rY3h = parcelRequire("1rY3h");
var $853a2b0cee563b5c$export$f07fd0fc7a8431ec = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-software-trello card full cover",
        width: size,
        height: size,
        viewBox: "0 0 65 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M57.47,0.88 C61.59,0.88 64.93,4.21 64.93,8.33 L64.93,47.48 L59.14,47.48 L41.51,29.85 C40.28,28.61 38.27,28.64 37.06,29.9 L20.37,47.48 L0.93,47.48 L0.93,8.33 C0.93,4.21 4.27,0.88 8.38,0.88 L57.47,0.88 Z M21.87,15.17 C18.2,15.17 15.22,18.14 15.22,21.82 L15.22,22.81 C15.22,26.48 18.2,29.46 21.87,29.46 L22.86,29.46 C26.53,29.46 29.51,26.48 29.51,22.81 L29.51,21.82 C29.51,18.14 26.53,15.17 22.86,15.17 L21.87,15.17 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M57.47,64.87 C61.59,64.87 64.93,61.54 64.93,57.42 L64.93,47.48 L0.93,47.48 L0.93,57.42 C0.93,61.54 4.27,64.87 8.38,64.87 L57.47,64.87 Z M32.93,53.38 C34.47,53.38 35.72,54.63 35.72,56.18 C35.72,57.68 34.54,58.9 33.06,58.97 L32.93,58.97 L11.49,58.97 C9.95,58.97 8.69,57.72 8.69,56.18 C8.69,54.68 9.88,53.45 11.36,53.38 L11.49,53.38 L32.93,53.38 Z M52.19,51.83 C54.59,51.83 56.54,53.77 56.54,56.18 C56.54,58.58 54.59,60.53 52.19,60.53 C49.79,60.53 47.84,58.58 47.84,56.18 C47.84,53.77 49.79,51.83 52.19,51.83 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M15.22,22.31 C15.22,18.37 18.42,15.17 22.36,15.17 C26.31,15.17 29.51,18.37 29.51,22.31 C29.51,26.26 26.31,29.46 22.36,29.46 C18.42,29.46 15.22,26.26 15.22,22.31 Z",
                        fillRule: "nonzero",
                        opacity: "0.5"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("6grkJ", function(module, exports) {

$parcel$export(module.exports, "TrelloCardRegularCover", function () { return $48f97083ffa21438$export$f94f6ba703a78150; });

var $1rY3h = parcelRequire("1rY3h");
var $48f97083ffa21438$export$f94f6ba703a78150 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-software-trello card regular cover",
        width: size,
        height: size,
        viewBox: "0 0 65 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M64.93,8.3 C64.93,4.2 61.59,0.9 57.47,0.9 L8.38,0.9 C4.27,0.9 0.93,4.2 0.93,8.3 L0.93,47.5 L64.93,47.5 L64.93,57.4 C64.93,57.4 64.93,57.4 64.93,57.4 L64.93,8.3 Z M57.49,64.9 L8.37,64.9 C8.37,64.9 8.38,64.9 8.38,64.9 L57.47,64.9 C57.48,64.9 57.48,64.9 57.49,64.9 Z M56.85,9 L9.01,9 L9.01,40 L27.65,40 L37.26,29.9 C38.46,28.6 40.47,28.6 41.71,29.8 L51.88,40 L56.85,40 L56.85,9 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M56.85,9 L9.01,9 L9.01,40 L56.85,40 L56.85,9 Z M22.37,15.2 C18.42,15.2 15.22,18.4 15.22,22.3 C15.22,26.3 18.42,29.5 22.37,29.5 C26.31,29.5 29.51,26.3 29.51,22.3 C29.51,18.4 26.31,15.2 22.37,15.2 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M57.47,64.9 C61.59,64.9 64.93,61.5 64.93,57.4 L64.93,47.5 L0.93,47.5 L0.93,57.4 C0.93,61.5 4.27,64.9 8.38,64.9 L57.47,64.9 Z M32.93,53.4 C34.47,53.4 35.72,54.6 35.72,56.2 C35.72,57.7 34.54,58.9 33.06,59 L32.93,59 L11.49,59 C9.95,59 8.69,57.7 8.69,56.2 C8.69,54.7 9.88,53.5 11.36,53.4 L11.49,53.4 L32.93,53.4 Z M52.19,51.8 C54.59,51.8 56.54,53.8 56.54,56.2 C56.54,58.6 54.59,60.5 52.19,60.5 C49.79,60.5 47.84,58.6 47.84,56.2 C47.84,53.8 49.79,51.8 52.19,51.8 Z",
                        opacity: "0.5"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("exsmi", function(module, exports) {

$parcel$export(module.exports, "TrelloCardRepeating", function () { return $a95a252dce6b976c$export$1b16364b4f7884fd; });

var $1rY3h = parcelRequire("1rY3h");
var $a95a252dce6b976c$export$1b16364b4f7884fd = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-software-trello card repeating",
        width: size,
        height: size,
        viewBox: "0 0 65 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M28.87,21.2 C29.97,22.2 31.67,22.2 32.73,21.1 L32.82,21 C33.82,19.9 33.79,18.2 32.73,17.1 L31.91,16.3 L33.24,16.3 L33.43,16.3 C38.32,16.4 42.25,20.4 42.25,25.3 C42.25,30.3 38.21,34.3 33.24,34.3 C28.26,34.3 24.23,30.3 24.23,25.3 C24.23,23.8 22.98,22.5 21.43,22.5 C19.89,22.5 18.64,23.8 18.64,25.3 C18.64,33.4 25.17,39.9 33.24,39.9 C41.3,39.9 47.84,33.4 47.84,25.3 C47.84,17.3 41.3,10.7 33.24,10.7 L31.91,10.7 L32.73,9.9 L32.82,9.8 C33.82,8.7 33.79,7 32.73,6 C31.64,4.9 29.87,4.9 28.78,6 L23.18,11.6 L23.09,11.6 C22.09,12.7 22.12,14.4 23.18,15.5 L28.78,21.1 L28.87,21.2 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M64.93,8.3 L64.93,47.5 L0.93,47.5 L0.93,8.3 C0.93,4.2 4.27,0.9 8.38,0.9 L57.47,0.9 C61.59,0.9 64.93,4.2 64.93,8.3 Z M28.87,21.2 C29.97,22.2 31.67,22.2 32.73,21.1 L32.82,21 C33.82,19.9 33.79,18.2 32.73,17.1 L31.91,16.3 L33.24,16.3 L33.43,16.3 C38.32,16.4 42.25,20.4 42.25,25.3 C42.25,30.3 38.21,34.3 33.24,34.3 C28.26,34.3 24.23,30.3 24.23,25.3 C24.23,23.8 22.98,22.5 21.43,22.5 C19.89,22.5 18.64,23.8 18.64,25.3 C18.64,33.4 25.17,39.9 33.24,39.9 C41.3,39.9 47.84,33.4 47.84,25.3 C47.84,17.3 41.3,10.7 33.24,10.7 L31.91,10.7 L32.73,9.9 L32.82,9.8 C33.82,8.7 33.79,7 32.73,6 C31.64,4.9 29.87,4.9 28.78,6 L23.18,11.6 L23.09,11.6 C22.09,12.7 22.12,14.4 23.18,15.5 L28.78,21.1 L28.87,21.2 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M57.47,64.9 C61.59,64.9 64.93,61.5 64.93,57.4 L64.93,47.5 L0.93,47.5 L0.93,57.4 C0.93,61.5 4.27,64.9 8.38,64.9 L57.47,64.9 Z M32.93,53.4 C34.47,53.4 35.72,54.6 35.72,56.2 C35.72,57.7 34.54,58.9 33.06,59 L32.93,59 L11.49,59 C9.95,59 8.69,57.7 8.69,56.2 C8.69,54.7 9.88,53.5 11.36,53.4 L11.49,53.4 L32.93,53.4 Z M52.19,51.8 C54.59,51.8 56.54,53.8 56.54,56.2 C56.54,58.6 54.59,60.5 52.19,60.5 C49.79,60.5 47.84,58.6 47.84,56.2 C47.84,53.8 49.79,51.8 52.19,51.8 Z",
                        opacity: "0.5"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("fGdwN", function(module, exports) {

$parcel$export(module.exports, "TrelloCardTemplates", function () { return $b6a545a6bae8b72d$export$7f1a87d866e6e15f; });

var $1rY3h = parcelRequire("1rY3h");
var $b6a545a6bae8b72d$export$7f1a87d866e6e15f = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-software-trello card templates",
        width: size,
        height: size,
        viewBox: "0 0 64 64",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M64,47 C64,50.4 61.28,53.1 57.93,53.1 L52.34,53.1 L52.34,48 L17.95,48 C14.76,48 12.15,45.6 11.89,42.4 L45.55,42.4 L45.55,17.6 L11.87,17.6 L11.87,7 C11.87,3.7 14.59,0.9 17.95,0.9 L57.93,0.9 C61.28,0.9 64,3.7 64,7 L64,47 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsxs)("g", {
                        transform: "translate(0.000000, 11.000000)",
                        children: [
                            (0, $1rY3h.jsx)("path", {
                                d: "M52.34,6.1 C52.34,2.8 49.62,0.1 46.27,0.1 L6.07,0.1 C2.72,0.1 0,2.8 0,6.1 L0,38 L52.34,38 L52.34,6.1 Z M45.55,6.6 L6.58,6.6 L6.58,31.4 L45.55,31.4 L45.55,6.6 Z"
                            }),
                            (0, $1rY3h.jsx)("path", {
                                d: "M46.27,52.2 C49.62,52.2 52.34,49.5 52.34,46.1 L52.34,38 L0,38 L0,46.1 C0,49.5 2.72,52.2 6.07,52.2 L46.27,52.2 Z M26.06,42.8 C27.32,42.8 28.34,43.9 28.34,45.1 C28.34,46.3 27.38,47.3 26.17,47.4 L26.06,47.4 L8.6,47.4 C7.35,47.4 6.33,46.4 6.33,45.1 C6.33,43.9 7.29,42.9 8.5,42.8 L8.6,42.8 L26.06,42.8 Z M41.75,41.6 C43.71,41.6 45.3,43.2 45.3,45.1 C45.3,47.1 43.71,48.7 41.75,48.7 C39.8,48.7 38.21,47.1 38.21,45.1 C38.21,43.2 39.8,41.6 41.75,41.6 Z",
                                opacity: "0.5"
                            })
                        ]
                    })
                ]
            })
        })
    });
};

});

parcelRegister("5Ic6A", function(module, exports) {

$parcel$export(module.exports, "TrelloCardTextField", function () { return $428a73a480f00b0b$export$c07b0f6028148651; });

var $1rY3h = parcelRequire("1rY3h");
var $428a73a480f00b0b$export$c07b0f6028148651 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-software-trello card text field",
        width: size,
        height: size,
        viewBox: "0 0 64 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M8.08,56.9 L55.92,56.9 L55.92,25.8 L8.08,25.8 L8.08,56.9 Z M41.01,31.1 C42.55,31.1 43.81,32.3 43.81,33.9 C43.81,35.4 42.62,36.6 41.14,36.7 L41.01,36.7 L16.78,36.7 C15.23,36.7 13.98,35.4 13.98,33.9 C13.98,32.4 15.16,31.2 16.65,31.1 L16.78,31.1 L41.01,31.1 Z M31.38,46.3 C31.38,44.8 30.13,43.5 28.58,43.5 L16.78,43.5 L16.65,43.5 C15.16,43.6 13.98,44.8 13.98,46.3 C13.98,47.9 15.23,49.1 16.78,49.1 L28.58,49.1 L28.71,49.1 C30.2,49 31.38,47.8 31.38,46.3 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("circle", {
                        fillRule: "nonzero",
                        opacity: "0.5",
                        transform: "translate(52.198160, 10.871840) scale(-1, 1) rotate(-180.000000) translate(-52.198160, -10.871840) ",
                        cx: "52.19816",
                        cy: "10.87184",
                        r: "3.72816"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M64,57.5 C64,61.6 60.66,64.9 56.54,64.9 L7.46,64.9 C3.34,64.9 0,61.6 0,57.5 L0,8.4 C0,4.3 3.34,0.9 7.46,0.9 L56.54,0.9 C60.66,0.9 64,4.3 64,8.4 L64,57.5 Z M25.16,10.9 C25.16,9.3 23.91,8.1 22.37,8.1 L10.56,8.1 L10.43,8.1 C8.95,8.2 7.77,9.4 7.77,10.9 C7.77,12.4 9.02,13.7 10.56,13.7 L22.37,13.7 L22.5,13.7 C23.98,13.6 25.16,12.4 25.16,10.9 Z M8.08,56.9 L55.92,56.9 L55.92,25.8 L8.08,25.8 L8.08,56.9 Z M52.19,7.2 C54.25,7.2 55.92,8.8 55.92,10.9 C55.92,12.9 54.25,14.6 52.19,14.6 C50.14,14.6 48.47,12.9 48.47,10.9 C48.47,8.8 50.14,7.2 52.19,7.2 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("dpVLK", function(module, exports) {

$parcel$export(module.exports, "TrelloChecklists", function () { return $9c4a6be4579109e8$export$51b21658e3df9a6e; });

var $1rY3h = parcelRequire("1rY3h");
var $9c4a6be4579109e8$export$51b21658e3df9a6e = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-software-trello checklists",
        width: size,
        height: size,
        viewBox: "0 0 65 51",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M19.02,50.4 L6.03,50.4 C2.84,50.4 0.25,47.9 0.25,44.7 L0.25,34.6 C0.25,31.4 2.84,28.8 6.03,28.8 L19.02,28.8 L19.02,50.4 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M58.48,50.4 C61.67,50.4 64.25,47.9 64.25,44.7 L64.25,34.6 C64.25,31.4 61.67,28.8 58.48,28.8 L20.46,28.8 C17.27,28.8 14.69,31.4 14.69,34.6 L14.69,44.7 C14.69,47.9 17.27,50.4 20.46,50.4 L58.48,50.4 Z M23.59,35.7 C23.54,34.5 22.59,33.6 21.43,33.6 C20.23,33.6 19.26,34.6 19.26,35.8 L19.26,43.9 L19.26,44 C19.32,45.2 20.26,46.1 21.43,46.1 C22.62,46.1 23.59,45.1 23.59,43.9 L23.59,35.8 L23.59,35.7 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M44.04,22.5 C47.23,22.5 49.82,19.9 49.82,16.8 L49.82,6.7 C49.82,3.5 47.23,0.9 44.04,0.9 L6.03,0.9 C2.84,0.9 0.25,3.5 0.25,6.7 L0.25,16.8 C0.25,19.9 2.84,22.5 6.03,22.5 L44.04,22.5 Z M9.15,7.8 C9.1,6.6 8.15,5.7 6.99,5.7 C5.79,5.7 4.83,6.7 4.83,7.9 L4.83,16 L4.83,16.1 C4.88,17.3 5.83,18.2 6.99,18.2 C8.19,18.2 9.16,17.2 9.16,16 L9.16,7.9 L9.15,7.8 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("iDVTJ", function(module, exports) {

$parcel$export(module.exports, "TrelloLabels", function () { return $d928c7d305289e1d$export$e1b5a7219182e12d; });

var $1rY3h = parcelRequire("1rY3h");
var $d928c7d305289e1d$export$e1b5a7219182e12d = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-software-trello labels",
        width: size,
        height: size,
        viewBox: "0 0 65 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsxs)("g", {
                        transform: "translate(8.000000, 8.000000)",
                        fillRule: "nonzero",
                        opacity: "0.5",
                        children: [
                            (0, $1rY3h.jsx)("path", {
                                d: "M9.08,5.6 C10.63,5.6 11.88,4.4 11.88,2.8 C11.88,1.3 10.7,0.1 9.22,0 L9.08,0 L3.49,0 C1.95,0 0.7,1.3 0.7,2.8 C0.7,4.3 1.88,5.5 3.36,5.6 L3.49,5.6 L9.08,5.6 Z"
                            }),
                            (0, $1rY3h.jsx)("path", {
                                d: "M23.37,5.6 C24.92,5.6 26.17,4.4 26.17,2.8 C26.17,1.3 24.99,0.1 23.51,0 L23.37,0 L17.78,0 C16.24,0 14.99,1.3 14.99,2.8 C14.99,4.3 16.17,5.5 17.65,5.6 L17.78,5.6 L23.37,5.6 Z"
                            }),
                            (0, $1rY3h.jsx)("path", {
                                d: "M37.67,5.6 C39.21,5.6 40.46,4.4 40.46,2.8 C40.46,1.3 39.28,0.1 37.8,0 L37.67,0 L32.07,0 C30.53,0 29.28,1.3 29.28,2.8 C29.28,4.3 30.46,5.5 31.94,5.6 L32.07,5.6 L37.67,5.6 Z"
                            })
                        ]
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M64.93,8.3 L64.93,47.5 L0.93,47.5 L0.93,8.3 C0.93,4.2 4.27,0.9 8.38,0.9 L57.47,0.9 C61.59,0.9 64.93,4.2 64.93,8.3 Z M19.88,10.8 C19.88,12.4 18.63,13.6 17.08,13.6 L11.49,13.6 L11.36,13.6 C9.88,13.5 8.69,12.3 8.69,10.8 C8.69,9.3 9.95,8 11.49,8 L17.08,8 L17.21,8 C18.7,8.1 19.88,9.3 19.88,10.8 Z M31.37,13.6 C32.92,13.6 34.17,12.4 34.17,10.8 C34.17,9.3 32.99,8.1 31.51,8 L31.37,8 L25.78,8 C24.24,8 22.99,9.3 22.99,10.8 C22.99,12.3 24.17,13.5 25.65,13.6 L25.78,13.6 L31.37,13.6 Z M48.46,10.8 C48.46,12.4 47.21,13.6 45.67,13.6 L40.07,13.6 L39.94,13.6 C38.46,13.5 37.28,12.3 37.28,10.8 C37.28,9.3 38.53,8 40.07,8 L45.67,8 L45.8,8 C47.28,8.1 48.46,9.3 48.46,10.8 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M57.47,64.9 C61.59,64.9 64.93,61.5 64.93,57.4 L64.93,47.5 L0.93,47.5 L0.93,57.4 C0.93,61.5 4.27,64.9 8.38,64.9 L57.47,64.9 Z M32.93,53.4 C34.47,53.4 35.72,54.6 35.72,56.2 C35.72,57.7 34.54,58.9 33.06,59 L32.93,59 L11.49,59 C9.95,59 8.69,57.7 8.69,56.2 C8.69,54.7 9.88,53.5 11.36,53.4 L11.49,53.4 L32.93,53.4 Z M52.19,51.8 C54.59,51.8 56.54,53.8 56.54,56.2 C56.54,58.6 54.59,60.5 52.19,60.5 C49.79,60.5 47.84,58.6 47.84,56.2 C47.84,53.8 49.79,51.8 52.19,51.8 Z",
                        opacity: "0.5"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("kDXGq", function(module, exports) {

$parcel$export(module.exports, "TrelloListsHorizontal", function () { return $f075bf0176704e7e$export$a96fd782a9d9dbf5; });

var $1rY3h = parcelRequire("1rY3h");
var $f075bf0176704e7e$export$a96fd782a9d9dbf5 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-software-trello lists_2",
        width: size,
        height: size,
        viewBox: "0 0 65 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsxs)("g", {
                        children: [
                            (0, $1rY3h.jsx)("circle", {
                                fillRule: "nonzero",
                                opacity: "0.5",
                                cx: "53.74",
                                cy: "9.6",
                                r: "3.72815"
                            }),
                            (0, $1rY3h.jsx)("path", {
                                d: "M57.47,28.8 C61.59,28.8 64.93,25.5 64.93,21.4 L64.93,8.3 C64.93,4.2 61.59,0.9 57.47,0.9 L8.38,0.9 C4.27,0.9 0.93,4.2 0.93,8.3 L0.93,21.4 C0.93,25.5 4.27,28.8 8.38,28.8 L57.47,28.8 Z M36.66,9.3 C36.66,7.7 35.4,6.5 33.86,6.5 L9.63,6.5 L9.5,6.5 C8.01,6.5 6.83,7.8 6.83,9.3 C6.83,10.8 8.08,12.1 9.63,12.1 L33.86,12.1 L33.99,12.1 C35.47,12 36.66,10.8 36.66,9.3 Z M21.43,17 C22.98,17 24.23,18.3 24.23,19.8 C24.23,21.3 23.05,22.6 21.56,22.6 L21.43,22.6 L9.63,22.6 C8.08,22.6 6.83,21.4 6.83,19.8 C6.83,18.3 8.01,17.1 9.5,17 L9.63,17 L21.43,17 Z M53.74,13.3 C55.8,13.3 57.47,11.6 57.47,9.6 C57.47,7.5 55.8,5.8 53.74,5.8 C51.68,5.8 50.02,7.5 50.02,9.6 C50.02,11.6 51.68,13.3 53.74,13.3 Z"
                            })
                        ]
                    }),
                    (0, $1rY3h.jsxs)("g", {
                        transform: "translate(0.000000, 36.000000)",
                        children: [
                            (0, $1rY3h.jsx)("circle", {
                                fillRule: "nonzero",
                                opacity: "0.5",
                                cx: "53.74",
                                cy: "9.6",
                                r: "3.72815"
                            }),
                            (0, $1rY3h.jsx)("path", {
                                d: "M57.47,28.9 C61.59,28.9 64.93,25.5 64.93,21.4 L64.93,8.4 C64.93,4.3 61.59,0.9 57.47,0.9 L8.38,0.9 C4.27,0.9 0.93,4.3 0.93,8.4 L0.93,21.4 C0.93,25.5 4.27,28.9 8.38,28.9 L57.47,28.9 Z M36.66,9.3 C36.66,7.8 35.4,6.5 33.86,6.5 L9.63,6.5 L9.5,6.5 C8.01,6.6 6.83,7.8 6.83,9.3 C6.83,10.8 8.08,12.1 9.63,12.1 L33.86,12.1 L33.99,12.1 C35.47,12 36.66,10.8 36.66,9.3 Z M21.43,17.1 C22.98,17.1 24.23,18.3 24.23,19.9 C24.23,21.4 23.05,22.6 21.56,22.7 L21.43,22.7 L9.63,22.7 C8.08,22.7 6.83,21.4 6.83,19.9 C6.83,18.4 8.01,17.1 9.5,17.1 L9.63,17.1 L21.43,17.1 Z M53.74,13.3 C55.8,13.3 57.47,11.7 57.47,9.6 C57.47,7.6 55.8,5.9 53.74,5.9 C51.68,5.9 50.02,7.6 50.02,9.6 C50.02,11.7 51.68,13.3 53.74,13.3 Z"
                            })
                        ]
                    })
                ]
            })
        })
    });
};

});

parcelRegister("RxYJZ", function(module, exports) {

$parcel$export(module.exports, "TrelloListsVertical", function () { return $0a0f4ecfd9a14771$export$a22e94d2e98518bc; });

var $1rY3h = parcelRequire("1rY3h");
var $0a0f4ecfd9a14771$export$a22e94d2e98518bc = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-software-trello lists",
        width: size,
        height: size,
        viewBox: "0 0 71 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M44.87,42.6 C44.87,44.7 43.2,46.4 41.14,46.4 L29.95,46.4 C27.89,46.4 26.22,44.7 26.22,42.6 L26.22,3.9 C26.22,1.8 27.89,0.2 29.95,0.2 L41.14,0.2 C43.2,0.2 44.87,1.8 44.87,3.9 L44.87,42.6 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M18.77,53.3 C18.77,55.4 17.1,57 15.04,57 L3.86,57 C1.8,57 0.13,55.4 0.13,53.3 L0.13,3.9 C0.13,1.8 1.8,0.2 3.86,0.2 L15.04,0.2 C17.1,0.2 18.77,1.8 18.77,3.9 L18.77,53.3 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M70.96,60.4 C70.96,62.5 69.29,64.2 67.23,64.2 L56.05,64.2 C53.99,64.2 52.32,62.5 52.32,60.4 L52.32,3.9 C52.32,1.8 53.99,0.2 56.05,0.2 L67.23,0.2 C69.29,0.2 70.96,1.8 70.96,3.9 L70.96,60.4 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("apmZy", function(module, exports) {

$parcel$export(module.exports, "TrelloWorkspaces", function () { return $793e12df493f009b$export$ad85ee75e3c446b7; });

var $1rY3h = parcelRequire("1rY3h");
var $793e12df493f009b$export$ad85ee75e3c446b7 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-software-trello workspaces",
        width: size,
        height: size,
        viewBox: "0 0 65 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsxs)("g", {
                        children: [
                            (0, $1rY3h.jsx)("path", {
                                d: "M28.47,21 C28.47,25.1 25.13,28.4 21.01,28.4 L7.96,28.4 C3.84,28.4 0.51,25.1 0.51,21 L0.51,7.9 C0.51,3.8 3.84,0.5 7.96,0.5 L21.01,0.5 C25.13,0.5 28.47,3.8 28.47,7.9 L28.47,21 Z",
                                opacity: "0.5"
                            }),
                            (0, $1rY3h.jsxs)("g", {
                                transform: "translate(6.000000, 6.000000)",
                                fillRule: "nonzero",
                                children: [
                                    (0, $1rY3h.jsx)("path", {
                                        d: "M13.77,0 C15.31,0 16.56,1.3 16.56,2.8 C16.56,4.3 15.38,5.6 13.9,5.6 L13.77,5.6 L3.2,5.6 C1.66,5.6 0.41,4.4 0.41,2.8 C0.41,1.3 1.59,0.1 3.07,0 L3.2,0 L13.77,0 Z"
                                    }),
                                    (0, $1rY3h.jsx)("path", {
                                        d: "M8.49,10.6 C10.03,10.6 11.28,11.9 11.28,13.4 C11.28,14.9 10.1,16.1 8.62,16.2 L8.49,16.2 L3.2,16.2 C1.66,16.2 0.41,15 0.41,13.4 C0.41,11.9 1.59,10.7 3.07,10.6 L3.2,10.6 L8.49,10.6 Z"
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $1rY3h.jsxs)("g", {
                        transform: "translate(0.000000, 36.000000)",
                        children: [
                            (0, $1rY3h.jsx)("path", {
                                d: "M28.47,21 C28.47,25.1 25.13,28.5 21.01,28.5 L7.96,28.5 C3.84,28.5 0.51,25.1 0.51,21 L0.51,8 C0.51,3.8 3.84,0.5 7.96,0.5 L21.01,0.5 C25.13,0.5 28.47,3.8 28.47,8 L28.47,21 Z",
                                opacity: "0.5"
                            }),
                            (0, $1rY3h.jsxs)("g", {
                                transform: "translate(6.000000, 6.000000)",
                                fillRule: "nonzero",
                                children: [
                                    (0, $1rY3h.jsx)("path", {
                                        d: "M13.77,0.1 C15.31,0.1 16.56,1.3 16.56,2.9 C16.56,4.4 15.38,5.6 13.9,5.7 L13.77,5.7 L3.2,5.7 C1.66,5.7 0.41,4.4 0.41,2.9 C0.41,1.4 1.59,0.2 3.07,0.1 L3.2,0.1 L13.77,0.1 Z"
                                    }),
                                    (0, $1rY3h.jsx)("path", {
                                        d: "M8.49,10.6 C10.03,10.6 11.28,11.9 11.28,13.4 C11.28,14.9 10.1,16.2 8.62,16.2 L8.49,16.2 L3.2,16.2 C1.66,16.2 0.41,15 0.41,13.4 C0.41,11.9 1.59,10.7 3.07,10.7 L3.2,10.6 L8.49,10.6 Z"
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $1rY3h.jsx)("g", {
                        transform: "translate(36.000000, 36.000000)",
                        children: (0, $1rY3h.jsx)("path", {
                            d: "M28.51,21 C28.51,25.1 25.17,28.5 21.05,28.5 L8,28.5 C3.88,28.5 0.54,25.1 0.54,21 L0.54,8 C0.54,3.8 3.88,0.5 8,0.5 L21.05,0.5 C25.17,0.5 28.51,3.8 28.51,8 L28.51,21 Z M19.81,12 C21.35,12 22.6,13.2 22.6,14.8 C22.6,16.3 21.42,17.5 19.94,17.6 L19.81,17.6 L17.32,17.6 L17.32,20.1 C17.32,21.6 16.07,22.9 14.53,22.9 C13.03,22.9 11.8,21.7 11.73,20.2 L11.73,20.1 L11.73,17.6 L9.24,17.6 C7.7,17.6 6.45,16.3 6.45,14.8 C6.45,13.3 7.63,12.1 9.11,12 L9.24,12 L11.73,12 L11.73,9.5 C11.73,8 12.98,6.7 14.53,6.7 C16.03,6.7 17.25,7.9 17.32,9.4 L17.32,9.5 L17.32,12 L19.81,12 Z"
                        })
                    }),
                    (0, $1rY3h.jsxs)("g", {
                        transform: "translate(36.000000, 0.000000)",
                        children: [
                            (0, $1rY3h.jsx)("path", {
                                d: "M28.51,21 C28.51,25.1 25.17,28.4 21.05,28.4 L8,28.4 C3.88,28.4 0.54,25.1 0.54,21 L0.54,7.9 C0.54,3.8 3.88,0.5 8,0.5 L21.05,0.5 C25.17,0.5 28.51,3.8 28.51,7.9 L28.51,21 Z",
                                opacity: "0.5"
                            }),
                            (0, $1rY3h.jsxs)("g", {
                                transform: "translate(6.000000, 6.000000)",
                                fillRule: "nonzero",
                                children: [
                                    (0, $1rY3h.jsx)("path", {
                                        d: "M13.81,0 C15.35,0 16.6,1.3 16.6,2.8 C16.6,4.3 15.42,5.6 13.94,5.6 L13.81,5.6 L3.24,5.6 C1.7,5.6 0.45,4.4 0.45,2.8 C0.45,1.3 1.63,0.1 3.11,0 L3.24,0 L13.81,0 Z"
                                    }),
                                    (0, $1rY3h.jsx)("path", {
                                        d: "M8.52,10.6 C10.07,10.6 11.32,11.9 11.32,13.4 C11.32,14.9 10.14,16.1 8.66,16.2 L8.52,16.2 L3.24,16.2 C1.7,16.2 0.45,15 0.45,13.4 C0.45,11.9 1.63,10.7 3.11,10.6 L3.24,10.6 L8.52,10.6 Z"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};

});

parcelRegister("hLfbM", function(module, exports) {

$parcel$export(module.exports, "Vector", function () { return $cee29ba8bd31efc5$export$9b781de7bf37bf48; });

var $1rY3h = parcelRequire("1rY3h");
var $cee29ba8bd31efc5$export$9b781de7bf37bf48 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-software-Vector",
        width: size,
        height: size,
        viewBox: "0 0 65 32",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsx)("g", {
                fill: "currentColor",
                fillRule: "nonzero",
                children: (0, $1rY3h.jsxs)("g", {
                    children: [
                        (0, $1rY3h.jsx)("path", {
                            d: "M4.83,6.78 C10.51,1.1 19.72,1.1 25.4,6.78 C26.29,7.68 26.29,9.14 25.4,10.03 C24.5,10.93 23.05,10.93 22.15,10.03 C18.26,6.15 11.96,6.15 8.07,10.03 C4.19,13.92 4.19,20.22 8.07,24.11 C11.92,27.95 18.11,27.99 22.01,24.24 L22.15,24.11 L30.81,15.45 C31.71,14.55 33.16,14.55 34.06,15.45 C34.93,16.31 34.95,17.71 34.14,18.61 L34.06,18.69 L25.4,27.35 C19.72,33.03 10.51,33.03 4.83,27.35 C-0.85,21.67 -0.85,12.46 4.83,6.78 Z"
                        }),
                        (0, $1rY3h.jsx)("path", {
                            d: "M39.74,6.61 C45.42,0.93 54.63,0.93 60.31,6.61 C65.99,12.29 65.99,21.5 60.31,27.18 C54.63,32.86 45.42,32.86 39.74,27.18 C38.84,26.28 38.84,24.83 39.74,23.93 C40.63,23.04 42.09,23.04 42.98,23.93 C46.87,27.82 53.17,27.82 57.06,23.93 C60.94,20.05 60.94,13.74 57.06,9.86 C53.22,6.02 47.02,5.97 43.12,9.72 L42.98,9.86 L34.32,18.52 C33.43,19.42 31.97,19.42 31.07,18.52 C30.21,17.65 30.18,16.26 30.99,15.36 L31.07,15.27 L39.74,6.61 Z"
                        }),
                        (0, $1rY3h.jsx)("path", {
                            d: "M26.84,0.6 C28.07,0.6 29.07,1.57 29.13,2.79 L29.13,2.9 L29.13,12.08 C29.13,13.32 28.16,14.32 26.94,14.38 L26.84,14.38 L18.26,14.38 C16.99,14.38 15.96,13.35 15.96,12.08 C15.96,10.85 16.93,9.85 18.15,9.79 L18.26,9.79 L24.54,9.79 L24.54,2.9 C24.54,1.66 25.51,0.66 26.73,0.6 L26.84,0.6 Z"
                        })
                    ]
                })
            })
        })
    });
};

});

parcelRegister("gr4ta", function(module, exports) {

$parcel$export(module.exports, "Webhook", function () { return $bf72a27fadd9f44a$export$c50bcb0995e47a56; });

var $1rY3h = parcelRequire("1rY3h");
var $bf72a27fadd9f44a$export$c50bcb0995e47a56 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-software-webhook",
        width: size,
        height: size,
        viewBox: "0 0 65 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsx)("g", {
                fill: "currentColor",
                fillRule: "nonzero",
                children: (0, $1rY3h.jsxs)("g", {
                    children: [
                        (0, $1rY3h.jsx)("circle", {
                            opacity: "0.5",
                            transform: "translate(15.600000, 49.100000) rotate(90.000000) translate(-15.600000, -49.100000) ",
                            cx: "15.6",
                            cy: "49.1",
                            r: "15.3124"
                        }),
                        (0, $1rY3h.jsx)("circle", {
                            opacity: "0.5",
                            transform: "translate(49.460000, 49.400000) rotate(90.000000) translate(-49.460000, -49.400000) ",
                            cx: "49.46",
                            cy: "49.4",
                            r: "15.3124"
                        }),
                        (0, $1rY3h.jsx)("circle", {
                            opacity: "0.5",
                            transform: "translate(32.290000, 16.000000) rotate(90.000000) translate(-32.290000, -16.000000) ",
                            cx: "32.29",
                            cy: "16",
                            r: "15.3124"
                        }),
                        (0, $1rY3h.jsx)("path", {
                            d: "M25.96,49.1 C25.96,54.8 21.32,59.5 15.6,59.5 C9.88,59.5 5.24,54.8 5.24,49.1 C5.24,46.4 6.28,43.9 8.1,42 C9,41 10.51,41 11.46,41.9 C12.38,42.8 12.44,44.2 11.62,45.2 L11.54,45.3 C10.55,46.3 9.99,47.7 9.99,49.1 C9.99,52.2 12.5,54.7 15.6,54.7 C18.64,54.7 21.12,52.3 21.2,49.3 L21.2,49.1 C21.2,47.8 22.27,46.7 23.58,46.7 C24.89,46.7 25.96,47.8 25.96,49.1 Z"
                        }),
                        (0, $1rY3h.jsx)("path", {
                            d: "M52.08,48.9 C52.08,50.2 51.07,51.2 49.81,51.2 L49.7,51.3 L23.58,51.3 C22.27,51.3 21.2,50.2 21.2,48.9 C21.2,47.6 22.21,46.6 23.47,46.5 L23.58,46.5 L49.7,46.5 C51.01,46.5 52.08,47.6 52.08,48.9 Z"
                        }),
                        (0, $1rY3h.jsx)("circle", {
                            transform: "translate(49.460000, 49.100000) rotate(90.000000) translate(-49.460000, -49.100000) ",
                            cx: "49.46",
                            cy: "49.1",
                            r: "3.86959"
                        }),
                        (0, $1rY3h.jsx)("circle", {
                            transform: "translate(32.050000, 16.000000) rotate(90.000000) translate(-32.050000, -16.000000) ",
                            cx: "32.05",
                            cy: "16",
                            r: "3.86959"
                        }),
                        (0, $1rY3h.jsx)("circle", {
                            transform: "translate(15.600000, 49.100000) rotate(90.000000) translate(-15.600000, -49.100000) ",
                            cx: "15.6",
                            cy: "49.1",
                            r: "3.86959"
                        }),
                        (0, $1rY3h.jsx)("path", {
                            d: "M47.7,40.3 C48.3,41.4 47.86,42.9 46.69,43.5 C45.57,44.1 44.18,43.7 43.54,42.6 L43.49,42.5 L30.18,17.1 C29.57,15.9 30.02,14.5 31.19,13.9 C32.31,13.3 33.7,13.7 34.34,14.8 L34.39,14.9 L47.7,40.3 Z"
                        }),
                        (0, $1rY3h.jsx)("path", {
                            d: "M59.85,49.4 C59.85,55.1 55.21,59.7 49.49,59.7 C46.73,59.7 44.13,58.6 42.2,56.7 C41.27,55.8 41.26,54.3 42.19,53.4 C43.08,52.4 44.52,52.4 45.46,53.3 L45.55,53.3 C46.59,54.4 47.99,55 49.49,55 C52.59,55 55.1,52.5 55.1,49.4 C55.1,46.3 52.67,43.8 49.65,43.8 L49.49,43.8 L45.59,43.8 C44.28,43.8 43.21,42.7 43.21,41.4 C43.21,40.1 44.22,39.1 45.48,39 L45.59,39 L49.49,39 C55.21,39 59.85,43.6 59.85,49.4 Z"
                        }),
                        (0, $1rY3h.jsx)("path", {
                            d: "M42.64,16 C42.64,17.3 41.58,18.4 40.27,18.4 C38.99,18.4 37.95,17.4 37.89,16.1 L37.89,16 C37.89,12.9 35.38,10.4 32.29,10.4 C29.19,10.4 26.68,12.9 26.68,16 C26.68,18.1 27.89,20 29.75,21 L29.9,21.1 C31.08,21.6 31.59,23 31.03,24.2 C30.47,25.4 29.05,25.9 27.87,25.4 C24.27,23.7 21.93,20 21.93,16 C21.93,10.3 26.57,5.6 32.29,5.6 C38.01,5.6 42.64,10.3 42.64,16 Z"
                        }),
                        (0, $1rY3h.jsx)("path", {
                            d: "M30.03,21.2 C31.16,21.8 31.64,23.2 31.13,24.3 L31.08,24.4 L17.96,50.4 C17.37,51.6 15.95,52.1 14.77,51.5 C13.64,50.9 13.16,49.5 13.67,48.4 L13.72,48.3 L26.84,22.3 C27.43,21.1 28.86,20.6 30.03,21.2 Z"
                        })
                    ]
                })
            })
        })
    });
};

});

parcelRegister("49ePZ", function(module, exports) {

$parcel$export(module.exports, "Wifi", function () { return $30538319621861ae$export$218f293018a09125; });

var $1rY3h = parcelRequire("1rY3h");
var $30538319621861ae$export$218f293018a09125 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-software-wifi",
        width: size,
        height: size,
        viewBox: "0 0 58 44",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M23.07,37.4 C23.07,34.2 25.66,31.6 28.85,31.6 L29.11,31.6 C32.31,31.6 34.9,34.2 34.9,37.4 L34.9,37.7 C34.9,40.9 32.31,43.4 29.11,43.4 L28.85,43.4 C25.65,43.4 23.07,40.9 23.07,37.7 L23.07,37.4 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M2.9,11.5 C17.28,-3 40.66,-3 55.09,11.4 L55.12,11.5 L55.17,11.5 L55.32,11.7 L56.59,13 C57.43,13.8 57.46,15.2 56.66,16 L56.59,16.1 C55.75,17 54.4,17 53.53,16.2 L53.45,16.1 L51.95,14.6 C51.88,14.5 51.81,14.5 51.75,14.4 L51.73,14.3 L51.57,14.2 C38.98,2 18.98,2 6.42,14.2 L6.04,14.6 L4.54,16.1 C3.67,17 2.27,17 1.4,16.1 C0.56,15.3 0.53,13.9 1.33,13.1 L1.4,13 L2.9,11.5 Z",
                        fillRule: "nonzero"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M10.08,23.1 C20.53,12.6 37.47,12.6 47.92,23.1 C48.78,23.9 48.78,25.3 47.92,26.2 C47.05,27.1 45.64,27.1 44.78,26.2 C36.06,17.5 21.93,17.5 13.21,26.2 C12.35,27.1 10.94,27.1 10.08,26.2 C9.21,25.3 9.21,23.9 10.08,23.1 Z",
                        fillRule: "nonzero"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("dCkYU", function(module, exports) {

$parcel$export(module.exports, "Wrench", function () { return $9e9f1971e37ee2c0$export$4421f7c88022a750; });

var $1rY3h = parcelRequire("1rY3h");
var $9e9f1971e37ee2c0$export$4421f7c88022a750 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-magnifying glass_2",
        width: size,
        height: size,
        viewBox: "0 0 65 64",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M3.67,60.2 C8.27,64.8 15.73,64.8 20.33,60.2 L38.71,41.8 L22.05,25.1 L3.67,43.5 C-0.93,48.1 -0.93,55.6 3.67,60.2 Z M16.63,52.5 C16.63,49.5 14.15,47 11.09,47 C8.02,47 5.54,49.5 5.54,52.5 C5.54,55.6 8.02,58.1 11.09,58.1 C14.15,58.1 16.63,55.6 16.63,52.5 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M64.22,24.2 C64.22,37.4 53.54,48.1 40.38,48.1 C27.21,48.1 16.54,37.4 16.54,24.2 C16.54,11.1 27.21,0.4 40.38,0.4 C41.9,0.4 43.39,0.5 44.83,0.8 C45.66,1 45.94,2 45.35,2.6 L37.72,10.3 C33.06,14.9 33.07,22.5 37.73,27.1 C42.39,31.8 49.96,31.8 54.62,27.1 L62.1,19.7 C62.69,19.1 63.73,19.4 63.87,20.2 C64.1,21.5 64.22,22.9 64.22,24.2 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("ajKJ7", function(module, exports) {

$parcel$export(module.exports, "GitMerge", function () { return $782fecaa8971193a$export$ea6373a4a927c724; });

var $1rY3h = parcelRequire("1rY3h");
var $782fecaa8971193a$export$ea6373a4a927c724 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-software-git merge",
        width: size,
        height: size,
        viewBox: "0 0 65 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("g", {
                        transform: "translate(6.000000, 9.000000)",
                        opacity: "0.5",
                        children: (0, $1rY3h.jsx)("path", {
                            d: "M49.93,26.13 C51.3,26.07 52.38,24.94 52.38,23.56 C52.38,22.14 51.23,20.99 49.81,20.99 L28.96,20.99 L28.96,9.56 L28.95,9.38 C28.86,4.26 24.67,0.13 19.53,0.13 L2.96,0.13 L2.84,0.14 C1.47,0.2 0.38,1.33 0.38,2.71 C0.38,4.13 1.54,5.28 2.96,5.28 L19.53,5.28 L19.67,5.28 C21.97,5.35 23.81,7.24 23.81,9.56 L23.81,23.56 L23.81,37.56 L23.81,37.7 C23.74,40 21.85,41.85 19.53,41.85 L2.96,41.85 L2.84,41.85 C1.47,41.92 0.38,43.04 0.38,44.42 C0.38,45.84 1.54,46.99 2.96,46.99 L19.53,46.99 L19.71,46.99 C24.83,46.89 28.96,42.71 28.96,37.56 L28.96,26.13 L49.81,26.13 L49.93,26.13 Z"
                        })
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M11.53,0.56 C17.68,0.56 22.67,5.55 22.67,11.71 C22.67,17.86 17.68,22.85 11.53,22.85 C5.37,22.85 0.38,17.86 0.38,11.71 C0.38,5.55 5.37,0.56 11.53,0.56 Z",
                        fillRule: "nonzero"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M11.53,42.28 C17.68,42.28 22.67,47.27 22.67,53.42 C22.67,59.57 17.68,64.56 11.53,64.56 C5.37,64.56 0.38,59.57 0.38,53.42 C0.38,47.27 5.37,42.28 11.53,42.28 Z",
                        fillRule: "nonzero"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M53.24,21.42 C59.4,21.42 64.39,26.41 64.39,32.56 C64.39,38.72 59.4,43.71 53.24,43.71 C47.09,43.71 42.1,38.72 42.1,32.56 C42.1,26.41 47.09,21.42 53.24,21.42 Z",
                        fillRule: "nonzero"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("5AkR7", function(module, exports) {

$parcel$export(module.exports, "News", function () { return $41107e0dc0692ad9$export$aec6fe3795564851; });

var $1rY3h = parcelRequire("1rY3h");
var $41107e0dc0692ad9$export$aec6fe3795564851 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-content-news",
        width: size,
        height: size,
        viewBox: "0 0 48 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M7.52,26.64 C7.52,25.09 8.68,23.84 10.12,23.84 L20.53,23.84 C21.97,23.84 23.13,25.09 23.13,26.64 L23.13,37.82 C23.13,39.37 21.97,40.62 20.53,40.62 L10.12,40.62 C8.68,40.62 7.52,39.37 7.52,37.82 L7.52,26.64 Z",
                        opacity: "0.5"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M41.06,64.46 C44.89,64.46 48,61.12 48,57 L48,7.91 C48,3.8 44.89,0.46 41.06,0.46 L6.94,0.46 C3.11,0.46 0,3.8 0,7.91 L0,57 C0,61.12 3.11,64.46 6.94,64.46 L41.06,64.46 Z M41.0200683,15.58 C41.0200683,14.04 39.84,12.79 38.41,12.8 L9.82,12.97 L9.69,12.97 C8.31,13.05 7.22,14.28 7.22993174,15.78 C7.24,17.32 8.41,18.57 9.85,18.56 L38.44,18.39 L38.56,18.39 C39.94,18.31 41.03,17.08 41.0200683,15.58 Z M38.42,24.01 C39.86,24.01 41.02,25.26 41.02,26.81 C41.02,28.31 39.92,29.53 38.54,29.6 L38.42,29.6 L29.77,29.6 C28.33,29.6 27.16,28.35 27.16,26.81 C27.16,25.31 28.26,24.08 29.64,24.01 L29.77,24.01 L38.42,24.01 Z M41.35,37.99 C41.35,36.45 40.18,35.2 38.75,35.2 L29.77,35.2 L29.64,35.2 C28.26,35.27 27.16,36.49 27.16,37.99 C27.16,39.54 28.33,40.79 29.77,40.79 L38.75,40.79 L38.87,40.79 C40.25,40.72 41.35,39.49 41.35,37.99 Z M38.41,46.21 C39.84,46.2 41.0200683,47.45 41.0200683,48.99 C41.03,50.49 39.94,51.72 38.56,51.8 L38.44,51.8 L9.85,51.97 C8.41,51.98 7.24,50.74 7.22993174,49.19 C7.22,47.69 8.31,46.46 9.69,46.39 L9.82,46.38 L38.41,46.21 Z M10.12,23.84 C8.68,23.84 7.52,25.09 7.52,26.64 L7.52,37.82 C7.52,39.37 8.68,40.62 10.12,40.62 L20.53,40.62 C21.97,40.62 23.13,39.37 23.13,37.82 L23.13,26.64 C23.13,25.09 21.97,23.84 20.53,23.84 L10.12,23.84 Z"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("5LGF4", function(module, exports) {

$parcel$export(module.exports, "Lightbulb", function () { return $43326f34646ebd85$export$3d88f82d313e52c; });

var $1rY3h = parcelRequire("1rY3h");
var $43326f34646ebd85$export$3d88f82d313e52c = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-object-lightbulb",
        width: size,
        height: size,
        viewBox: "0 0 46 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M39.49,38 C47.99,29.5 47.99,15.7 39.49,7.2 C30.59,-1.7 16.15,-1.7 7.24,7.2 C6.99,7.5 6.76,7.7 6.52,8 C-1.56,16.9 -0.9,30.6 7.99,38.7 L11.98,42.3 L11.98,49.7 L34.75,49.7 L34.75,42.3 L38.75,38.7 C39,38.5 39.25,38.2 39.49,38 Z M25.49,10 C25.49,8.6 24.33,7.4 22.91,7.4 C14.53,7.4 7.74,14.2 7.74,22.6 L7.74,23.2 L7.74,23.3 C7.8,24.7 8.93,25.8 10.31,25.8 C11.74,25.8 12.89,24.6 12.89,23.2 L12.89,22.6 L12.89,22.4 C12.99,17 17.44,12.6 22.91,12.6 C24.33,12.6 25.49,11.4 25.49,10 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M34.75,54.9 L34.75,54.9 L11.98,54.9 L11.98,56.9 C11.98,61.1 15.42,64.6 19.66,64.6 L27.07,64.6 C31.31,64.6 34.75,61.1 34.75,56.9 L34.75,54.9 Z",
                        opacity: "0.5"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("ci4Cn", function(module, exports) {

$parcel$export(module.exports, "CloudUpload", function () { return $8f2abf81a4d0c799$export$613a29ed35edc9c6; });

var $1rY3h = parcelRequire("1rY3h");
var $8f2abf81a4d0c799$export$613a29ed35edc9c6 = function(param) {
    var size = param.size;
    return (0, $1rY3h.jsx)("svg", {
        id: "icon-software-cloud upload",
        width: size,
        height: size,
        viewBox: "0 0 63 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: (0, $1rY3h.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, $1rY3h.jsxs)("g", {
                fill: "currentColor",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M43.13,8.42 C39.7,3.32 33.92,0.14 27.58,0.14 C17.83,0.14 9.81,7.59 8.93,17.12 C4.11,18.96 0.77,23.62 0.77,28.97 C0.77,35.98 6.45,41.65 13.46,41.65 L29.02,41.65 L29.02,25.14 L25.38,28.79 C24.4,29.77 22.82,29.8 21.8,28.87 L21.71,28.79 C20.73,27.8 20.7,26.22 21.63,25.2 L21.71,25.12 L29.78,17.04 C30.77,16.06 32.35,16.03 33.36,16.96 L33.38,16.97 C33.4,16.99 33.42,17.01 33.44,17.03 L33.45,17.04 L41.53,25.12 C42.54,26.13 42.54,27.77 41.53,28.79 C40.54,29.77 38.96,29.8 37.94,28.87 L37.86,28.79 L34.21,25.14 L34.21,41.65 L45.74,41.65 L46.02,41.65 C55.13,41.5 62.47,34.08 62.47,24.93 C62.47,15.7 54.98,8.21 45.74,8.21 C44.86,8.21 43.99,8.28 43.13,8.42 Z"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M45.02,13.98 L17.92,13.98 L17.92,41.08 L29.02,41.08 L29.02,61.56 C29.02,62.99 30.18,64.14 31.62,64.14 C33.05,64.14 34.21,62.99 34.21,61.56 L34.21,41.08 L45.02,41.08 L45.02,13.98 Z",
                        opacity: "0.5"
                    })
                ]
            })
        })
    });
};

});


parcelRegister("6jjHq", function(module, exports) {

$parcel$export(module.exports, "containerStyle", function () { return $4983cc4f299a80fb$export$856b6de7fac89c7f; });
$parcel$export(module.exports, "spinnerContainerStyle", function () { return $4983cc4f299a80fb$export$6a0b3429fb2258a6; });
$parcel$export(module.exports, "headerContainerStyle", function () { return $4983cc4f299a80fb$export$1f10f17b2c50ad22; });
$parcel$export(module.exports, "headerStyle", function () { return $4983cc4f299a80fb$export$5939e41228734fb7; });
$parcel$export(module.exports, "descriptionStyle", function () { return $4983cc4f299a80fb$export$8ff268355c25979e; });
$parcel$export(module.exports, "dividerStyle", function () { return $4983cc4f299a80fb$export$b20b1b09433e7417; });
$parcel$export(module.exports, "footerContainerStyle", function () { return $4983cc4f299a80fb$export$f1a66c57466c7d3e; });
$parcel$export(module.exports, "totalValueStyle", function () { return $4983cc4f299a80fb$export$b7fd5df4dd51f378; });
$parcel$export(module.exports, "taxSubtextStyle", function () { return $4983cc4f299a80fb$export$4a8191bb572b33be; });
$parcel$export(module.exports, "buttonWrapper", function () { return $4983cc4f299a80fb$export$a3b9b213fa74e4fd; });

var $j06k0 = parcelRequire("j06k0");

var $fBy54 = parcelRequire("fBy54");
parcelRequire("1DvYB");
var $pDfcT = parcelRequire("pDfcT");

var $gDEpB = parcelRequire("gDEpB");
function $4983cc4f299a80fb$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  font-family: Charlie Text, sans-serif;\n  box-sizing: border-box;\n  width: 400px;\n  min-height: 300px;\n  padding: ",
        ";\n"
    ]);
    $4983cc4f299a80fb$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $4983cc4f299a80fb$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "\n  width: 400px;\n  min-height: 300px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    $4983cc4f299a80fb$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $4983cc4f299a80fb$var$_templateObject2() {
    var data = (0, $j06k0._)([
        "\n  display: flex;\n  align-items: center;\n  margin-bottom: ",
        ";\n\n  svg {\n    margin-bottom: 0px !important;\n  }\n"
    ]);
    $4983cc4f299a80fb$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $4983cc4f299a80fb$var$_templateObject3() {
    var data = (0, $j06k0._)([
        "\n  display: inline-block;\n  margin: 0 0 0 ",
        ";\n  font-family: Charlie Display, sans-serif;\n  font-size: 24px;\n  font-weight: 500;\n  line-height: 32px;\n  letter-spacing: 0.3px;\n"
    ]);
    $4983cc4f299a80fb$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $4983cc4f299a80fb$var$_templateObject4() {
    var data = (0, $j06k0._)([
        "\n  font-size: 14px;\n  line-height: 18px;\n"
    ]);
    $4983cc4f299a80fb$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $4983cc4f299a80fb$var$_templateObject5() {
    var data = (0, $j06k0._)([
        "\n  border-bottom: 1px solid ",
        ";\n  margin: ",
        " 0;\n"
    ]);
    $4983cc4f299a80fb$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function $4983cc4f299a80fb$var$_templateObject6() {
    var data = (0, $j06k0._)([
        "\n  font-family: Charlie Display, sans-serif;\n  font-size: 22px;\n  line-height: 24px;\n  display: flex;\n\n  div {\n    flex: 1 1 auto;\n  }\n"
    ]);
    $4983cc4f299a80fb$var$_templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function $4983cc4f299a80fb$var$_templateObject7() {
    var data = (0, $j06k0._)([
        "\n  font-weight: 500;\n  text-align: right;\n"
    ]);
    $4983cc4f299a80fb$var$_templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function $4983cc4f299a80fb$var$_templateObject8() {
    var data = (0, $j06k0._)([
        "\n  font-size: 10px;\n  line-height: 20px;\n  text-align: right;\n  margin-bottom: ",
        ";\n  color: ",
        ";\n"
    ]);
    $4983cc4f299a80fb$var$_templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function $4983cc4f299a80fb$var$_templateObject9() {
    var data = (0, $j06k0._)([
        "\n  display: flex;\n  justify-content: center;\n\n  a {\n    font-weight: 500 !important;\n  }\n"
    ]);
    $4983cc4f299a80fb$var$_templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
var $4983cc4f299a80fb$export$856b6de7fac89c7f = (0, $fBy54.css)($4983cc4f299a80fb$var$_templateObject(), (0, $pDfcT.wplToken)("space.300"));
var $4983cc4f299a80fb$export$6a0b3429fb2258a6 = (0, $fBy54.css)($4983cc4f299a80fb$var$_templateObject1());
var $4983cc4f299a80fb$export$1f10f17b2c50ad22 = (0, $fBy54.css)($4983cc4f299a80fb$var$_templateObject2(), (0, $pDfcT.wplToken)("space.100"));
var $4983cc4f299a80fb$export$5939e41228734fb7 = (0, $fBy54.css)($4983cc4f299a80fb$var$_templateObject3(), (0, $pDfcT.wplToken)("space.100"));
var $4983cc4f299a80fb$export$8ff268355c25979e = (0, $fBy54.css)($4983cc4f299a80fb$var$_templateObject4());
var $4983cc4f299a80fb$export$b20b1b09433e7417 = (0, $fBy54.css)($4983cc4f299a80fb$var$_templateObject5(), (0, $gDEpB.getColor)("n50"), (0, $pDfcT.wplToken)("space.300"));
var $4983cc4f299a80fb$export$f1a66c57466c7d3e = (0, $fBy54.css)($4983cc4f299a80fb$var$_templateObject6());
var $4983cc4f299a80fb$export$b7fd5df4dd51f378 = (0, $fBy54.css)($4983cc4f299a80fb$var$_templateObject7());
var $4983cc4f299a80fb$export$4a8191bb572b33be = (0, $fBy54.css)($4983cc4f299a80fb$var$_templateObject8(), (0, $pDfcT.wplToken)("space.200"), (0, $gDEpB.getColor)("n200"));
var $4983cc4f299a80fb$export$a3b9b213fa74e4fd = (0, $fBy54.css)($4983cc4f299a80fb$var$_templateObject9());

});
parcelRegister("1DvYB", function(module, exports) {

$parcel$export(module.exports, "wplToken", function () { return (parcelRequire("pDfcT")).wplToken; });

var $pDfcT = parcelRequire("pDfcT");

});
parcelRegister("pDfcT", function(module, exports) {

$parcel$export(module.exports, "wplToken", function () { return $04d0c7026ebc14b0$export$18b45da0f6fe9d15; });

var $hag9a = parcelRequire("hag9a");
var $04d0c7026ebc14b0$export$18b45da0f6fe9d15 = function(tokenName) {
    return (0, $hag9a.default)["".concat(tokenName)];
};

});
parcelRegister("hag9a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7efe54894c37a71$export$2e2bcd8739ae039; });

var $do9pw = parcelRequire("do9pw");
parcelRequire("9EXip");
var $lmsgd = parcelRequire("lmsgd");
parcelRequire("eOf84");
var $6Y65K = parcelRequire("6Y65K");
var $5vx95 = parcelRequire("5vx95");
var $cLmoz = parcelRequire("cLmoz");
var $c7efe54894c37a71$var$tokenList = Object.freeze((0, $do9pw._)({}, (0, $lmsgd.spacingTokens), (0, $6Y65K.colorBackgroundDefaultTokens), (0, $5vx95.colorBorderDefaultTokens), (0, $cLmoz.colorTextDefaultTokens)));
var $c7efe54894c37a71$export$2e2bcd8739ae039 = $c7efe54894c37a71$var$tokenList;

});
parcelRegister("9EXip", function(module, exports) {
$parcel$export(module.exports, "spacingTokens", function () { return (parcelRequire("lmsgd")).spacingTokens; });
parcelRequire("lmsgd");

});
parcelRegister("lmsgd", function(module, exports) {

$parcel$export(module.exports, "spacingTokens", function () { return $f8d19303046f85e0$export$8bb4873bbbc0aab9; });
var $f8d19303046f85e0$export$8bb4873bbbc0aab9 = Object.freeze({
    "space.0": "0",
    "space.025": "0.125rem",
    "space.050": "0.25rem",
    "space.075": "0.375rem",
    "space.100": "0.5rem",
    "space.150": "0.75rem",
    "space.200": "1rem",
    "space.250": "1.25rem",
    "space.300": "1.5rem",
    "space.400": "2rem",
    "space.500": "2.5rem",
    "space.600": "3rem",
    "space.800": "4rem",
    "space.1000": "5rem" //80px
});

});


parcelRegister("eOf84", function(module, exports) {
$parcel$export(module.exports, "colorBackgroundDefaultTokens", function () { return (parcelRequire("6Y65K")).colorBackgroundDefaultTokens; });
$parcel$export(module.exports, "colorBorderDefaultTokens", function () { return (parcelRequire("5vx95")).colorBorderDefaultTokens; });
$parcel$export(module.exports, "colorTextDefaultTokens", function () { return (parcelRequire("cLmoz")).colorTextDefaultTokens; });
parcelRequire("aF836");
 // export * from './inverse';

});
parcelRegister("aF836", function(module, exports) {
$parcel$export(module.exports, "colorBackgroundDefaultTokens", function () { return (parcelRequire("6Y65K")).colorBackgroundDefaultTokens; });
$parcel$export(module.exports, "colorBorderDefaultTokens", function () { return (parcelRequire("5vx95")).colorBorderDefaultTokens; });
$parcel$export(module.exports, "colorTextDefaultTokens", function () { return (parcelRequire("cLmoz")).colorTextDefaultTokens; });
parcelRequire("6Y65K");
parcelRequire("5vx95");
parcelRequire("cLmoz");

});
parcelRegister("6Y65K", function(module, exports) {

$parcel$export(module.exports, "colorBackgroundDefaultTokens", function () { return $512d125e6103b004$export$e55b107d89d30c72; });

var $6yULb = parcelRequire("6yULb");

var $cVbTT = parcelRequire("cVbTT");
var $512d125e6103b004$export$e55b107d89d30c72 = Object.freeze({
    "color.background.accent.red.bolder": (0, $cVbTT.getValue)((0, $6yULb.color), "default.background.accent.red.bolder"),
    "color.background.accent.red.subtle": (0, $cVbTT.getValue)((0, $6yULb.color), "default.background.accent.red.subtle"),
    "color.background.accent.red.subtler": (0, $cVbTT.getValue)((0, $6yULb.color), "default.background.accent.red.subtler"),
    "color.background.accent.red.subtlest": (0, $cVbTT.getValue)((0, $6yULb.color), "default.background.accent.red.subtlest"),
    "color.background.accent.orange.bolder": (0, $cVbTT.getValue)((0, $6yULb.color), "default.background.accent.orange.bolder"),
    "color.background.accent.orange.subtle": (0, $cVbTT.getValue)((0, $6yULb.color), "default.background.accent.orange.subtle"),
    "color.background.accent.orange.subtler": (0, $cVbTT.getValue)((0, $6yULb.color), "default.background.accent.orange.subtler"),
    "color.background.accent.orange.subtlest": (0, $cVbTT.getValue)((0, $6yULb.color), "default.background.accent.orange.subtlest"),
    "color.background.accent.yellow.bolder": (0, $cVbTT.getValue)((0, $6yULb.color), "default.background.accent.yellow.bolder"),
    "color.background.accent.yellow.subtle": (0, $cVbTT.getValue)((0, $6yULb.color), "default.background.accent.yellow.subtle"),
    "color.background.accent.yellow.subtler": (0, $cVbTT.getValue)((0, $6yULb.color), "default.background.accent.yellow.subtler"),
    "color.background.accent.yellow.subtlest": (0, $cVbTT.getValue)((0, $6yULb.color), "default.background.accent.yellow.subtlest"),
    "color.background.accent.green.bolder": (0, $cVbTT.getValue)((0, $6yULb.color), "default.background.accent.green.bolder"),
    "color.background.accent.green.subtle": (0, $cVbTT.getValue)((0, $6yULb.color), "default.background.accent.green.subtle"),
    "color.background.accent.green.subtler": (0, $cVbTT.getValue)((0, $6yULb.color), "default.background.accent.green.subtler"),
    "color.background.accent.green.subtlest": (0, $cVbTT.getValue)((0, $6yULb.color), "default.background.accent.green.subtlest"),
    "color.background.accent.teal.bolder": (0, $cVbTT.getValue)((0, $6yULb.color), "default.background.accent.teal.bolder"),
    "color.background.accent.teal.subtle": (0, $cVbTT.getValue)((0, $6yULb.color), "default.background.accent.teal.subtle"),
    "color.background.accent.teal.subtler": (0, $cVbTT.getValue)((0, $6yULb.color), "default.background.accent.teal.subtler"),
    "color.background.accent.teal.subtlest": (0, $cVbTT.getValue)((0, $6yULb.color), "default.background.accent.teal.subtlest"),
    "color.background.accent.blue.bolder": (0, $cVbTT.getValue)((0, $6yULb.color), "default.background.accent.blue.bolder"),
    "color.background.accent.blue.subtle": (0, $cVbTT.getValue)((0, $6yULb.color), "default.background.accent.blue.subtle"),
    "color.background.accent.blue.subtler": (0, $cVbTT.getValue)((0, $6yULb.color), "default.background.accent.blue.subtler"),
    "color.background.accent.blue.subtlest": (0, $cVbTT.getValue)((0, $6yULb.color), "default.background.accent.blue.subtlest"),
    "color.background.accent.purple.bolder": (0, $cVbTT.getValue)((0, $6yULb.color), "default.background.accent.purple.bolder"),
    "color.background.accent.purple.subtle": (0, $cVbTT.getValue)((0, $6yULb.color), "default.background.accent.purple.subtle"),
    "color.background.accent.purple.subtler": (0, $cVbTT.getValue)((0, $6yULb.color), "default.background.accent.purple.subtler"),
    "color.background.accent.purple.subtlest": (0, $cVbTT.getValue)((0, $6yULb.color), "default.background.accent.purple.subtlest"),
    "color.background.accent.magenta.bolder": (0, $cVbTT.getValue)((0, $6yULb.color), "default.background.accent.magenta.bolder"),
    "color.background.accent.magenta.subtle": (0, $cVbTT.getValue)((0, $6yULb.color), "default.background.accent.magenta.subtle"),
    "color.background.accent.magenta.subtler": (0, $cVbTT.getValue)((0, $6yULb.color), "default.background.accent.magenta.subtler"),
    "color.background.accent.magenta.subtlest": (0, $cVbTT.getValue)((0, $6yULb.color), "default.background.accent.magenta.subtlest"),
    "color.background.accent.gray.bolder": (0, $cVbTT.getValue)((0, $6yULb.color), "default.background.accent.gray.bolder"),
    "color.background.accent.gray.subtle": (0, $cVbTT.getValue)((0, $6yULb.color), "default.background.accent.gray.subtle"),
    "color.background.accent.gray.subtler": (0, $cVbTT.getValue)((0, $6yULb.color), "default.background.accent.gray.subtler"),
    "color.background.accent.gray.subtlest": (0, $cVbTT.getValue)((0, $6yULb.color), "default.background.accent.gray.subtlest"),
    "color.background.disabled": (0, $cVbTT.getValue)((0, $6yULb.color), "default.background.disabled"),
    "color.background.input": (0, $cVbTT.getValue)((0, $6yULb.color), "default.background.input.default"),
    "color.background.selected": (0, $cVbTT.getValue)((0, $6yULb.color), "default.background.selected.default"),
    "color.background.selected.bold": (0, $cVbTT.getValue)((0, $6yULb.color), "default.background.selected.bold.default"),
    "color.background.brand.bold": (0, $cVbTT.getValue)((0, $6yULb.color), "default.background.brand.bold.default"),
    "color.background.danger": (0, $cVbTT.getValue)((0, $6yULb.color), "default.background.danger.default"),
    "color.background.danger.bold": (0, $cVbTT.getValue)((0, $6yULb.color), "default.background.danger.bold.default"),
    "color.background.warning": (0, $cVbTT.getValue)((0, $6yULb.color), "default.background.warning.default"),
    "color.background.warning.bold": (0, $cVbTT.getValue)((0, $6yULb.color), "default.background.warning.bold.default"),
    "color.background.success": (0, $cVbTT.getValue)((0, $6yULb.color), "default.background.success.default"),
    "color.background.success.bold": (0, $cVbTT.getValue)((0, $6yULb.color), "default.background.success.bold.default"),
    "color.background.discovery": (0, $cVbTT.getValue)((0, $6yULb.color), "default.background.discovery.default"),
    "color.background.discovery.bold": (0, $cVbTT.getValue)((0, $6yULb.color), "default.background.discovery.bold.default"),
    "color.background.information": (0, $cVbTT.getValue)((0, $6yULb.color), "default.background.information.default"),
    "color.background.information.bold": (0, $cVbTT.getValue)((0, $6yULb.color), "default.background.information.bold.default")
});

});
parcelRegister("6yULb", function(module, exports) {

$parcel$export(module.exports, "color", function () { return $4c71f2643a670f61$export$35e9368ef982300f; });
var $4c71f2643a670f61$export$35e9368ef982300f = Object.freeze({
    // colors for light backgrounds
    "default": {
        background: {
            disabled: "",
            accent: {
                blue: {
                    bolder: "#2684ff",
                    subtle: "#4c9aff",
                    subtler: "#B3D4FF",
                    subtlest: "#deebff"
                },
                gray: {
                    bolder: "#97a0af",
                    subtle: "#b3bac5",
                    subtler: "#c1c7d0",
                    subtlest: "#f4f5f7"
                },
                green: {
                    bolder: "#57D9A3",
                    subtle: "#79f2c0",
                    subtler: "#abf5d1",
                    subtlest: "#e3fcef"
                },
                magenta: {
                    bolder: "",
                    subtle: "",
                    subtler: "",
                    subtlest: ""
                },
                orange: {
                    bolder: "",
                    subtle: "",
                    subtler: "",
                    subtlest: ""
                },
                purple: {
                    bolder: "#8777d9",
                    subtle: "#998dd9",
                    subtler: "#c0b6f2",
                    subtlest: "#eae6ff"
                },
                red: {
                    bolder: "#ff7452",
                    subtle: "#ff8f73",
                    subtler: "#ffbdad",
                    subtlest: "#FFEBE6"
                },
                teal: {
                    bolder: "#00C7E6",
                    subtle: "#79e2f2",
                    subtler: "#b3f5ff",
                    subtlest: "#e6fcff"
                },
                yellow: {
                    bolder: "",
                    subtle: "",
                    subtler: "",
                    subtlest: ""
                }
            },
            brand: {
                default: "#deebff",
                hovered: "#B3D4FF",
                pressed: "#deebff",
                bold: {
                    default: "#0052cc",
                    hovered: "#0747A6",
                    pressed: "#091e42"
                }
            },
            danger: {
                default: "#FFEBE6",
                hovered: "#ffbdad",
                pressed: "#ff8f73",
                bold: {
                    default: "#de350b",
                    hovered: "#bf2600",
                    pressed: "#751902"
                }
            },
            discovery: {
                default: "#c0b6f2",
                hovered: "#998dd9",
                pressed: "#8777d9",
                bold: {
                    default: "#6554c0",
                    hovered: "#5243aa",
                    pressed: "#403294"
                }
            },
            information: {
                default: "#deebff",
                bold: {
                    default: "#0052cc",
                    hovered: "#0747A6",
                    pressed: "#091e42"
                }
            },
            input: {
                default: "#ebecf0",
                hovered: "#a5adba",
                pressed: "#c1c7d0"
            },
            selected: {
                default: "#B3D4FF",
                hovered: "#4c9aff",
                pressed: "#2684ff",
                bold: {
                    default: "#6B778C",
                    hovered: "#42526e",
                    pressed: "#091e42"
                }
            },
            success: {
                default: "#abf5d1",
                hovered: "#79f2c0",
                pressed: "#57D9A3",
                bold: {
                    default: "#00875a",
                    hovered: "#006644",
                    pressed: "#003D28"
                }
            },
            warning: {
                default: "#FFF0B3",
                hovered: "#ffe380",
                pressed: "#ffc400",
                bold: {
                    default: "#ffab00",
                    hovered: "#ff991f",
                    pressed: "#ff8b00"
                }
            }
        },
        blanket: {
            default: "#505f79"
        },
        border: {
            bold: "#42526e",
            brand: "#0052cc",
            danger: "#de350b",
            default: "#a5adba",
            disabled: "#c1c7d0",
            discovery: "#5243aa",
            focus: "#2684ff",
            information: "#0065ff",
            inverse: "#ffffff",
            selected: "#0052cc",
            success: "#00875a",
            warning: "#ff991f",
            accent: {
                blue: "#0065ff",
                gray: "#97a0af",
                green: "#36b37e",
                magenta: "",
                orange: "#ff991f",
                purple: "#8777d9",
                red: "#ff5630",
                teal: "#00b8d9",
                yellow: "#ffc400"
            }
        },
        elevation: {
            surface: {
                footer: "#f4f5f7",
                default: {
                    solid: {
                        alternate1: "#c0b6f2",
                        alternate2: "#B3D4FF",
                        alternate3: "#DFE1E6",
                        primary: "#ffffff"
                    }
                },
                overlay: {
                    default: "#ffffff"
                },
                raised: {
                    default: "#ffffff"
                }
            }
        },
        icon: {
            "brand": "#0052cc",
            "danger": "#bf2600",
            "default": "#172b4d",
            "disabled": "#b3bac5",
            "discovery": "#403294",
            "information": "#0747A6",
            "inverse": "#ffffff",
            "selected": "#0747A6",
            "subtle": "#6B778C",
            "subtlest": "#97a0af",
            "success": "#006644",
            "warning-inverse": "#091e42",
            "warning": "#ff8b00",
            "accent": {
                blue: "#0747A6",
                gray: "#7a869a",
                green: "#00875a",
                magenta: "",
                orange: "#ff8b00",
                purple: "#5243aa",
                red: "#de350b",
                teal: "#00a3bf",
                yellow: "#ffc400"
            }
        },
        link: {
            default: "#0052cc",
            pressed: "#0747A6",
            subtle: "#505f79"
        },
        text: {
            "brand": "#0052cc",
            "danger": "#bf2600",
            "default": "#253858",
            "disabled": "#97a0af",
            "discovery": "#403294",
            "information": "#091e42",
            "inverse": "#ffffff",
            "selected": "#0052cc",
            "subtle": "#505f79",
            "subtlest": "#7a869a",
            "success": "#006644",
            "warning-inverse": "#253858",
            "warning": "#ff8b00",
            "accent": {
                "blue-bolder": "#091e42",
                "blue": "#0747A6",
                "gray-bolder": "",
                "gray": "#505f79",
                "green-bolder": "",
                "green": "#006644",
                "magenta-bolder": "",
                "magenta": "",
                "orange-bolder": "",
                "orange": "#ff8b00",
                "purple-bolder": "",
                "purple": "#403294",
                "red-bolder": "",
                "red": "#bf2600",
                "teal-bolder": "",
                "teal": "#008da6",
                "yellow-bolder": "",
                "yellow": "#ffc400"
            }
        },
        utility: {
            MISSING_TOKEN: "#FA11F2"
        }
    },
    "lo-fi": {
        background: {
            "items-light": "#ffffff",
            "items": "#42526e",
            "surface": "#ffffff"
        },
        text: {
            default: "#000000"
        }
    },
    // colors for dark backgrounds
    "inverse": {
        background: {
            disabled: "",
            accent: {
                blue: {
                    bolder: "#2684ff",
                    subtle: "#0747A6",
                    subtler: "#344563",
                    subtlest: "#253858"
                },
                gray: {
                    bolder: "#8993a4",
                    subtle: "#5e6c84",
                    subtler: "#42526e",
                    subtlest: "#253858"
                },
                green: {
                    bolder: "#57D9A3",
                    subtle: "#79f2c0",
                    subtler: "#abf5d1",
                    subtlest: "#e3fcef"
                },
                magenta: {
                    bolder: "",
                    subtle: "",
                    subtler: "",
                    subtlest: ""
                },
                orange: {
                    bolder: "",
                    subtle: "",
                    subtler: "",
                    subtlest: ""
                },
                purple: {
                    bolder: "#403294",
                    subtle: "#998dd9",
                    subtler: "#c0b6f2",
                    subtlest: "#eae6ff"
                },
                red: {
                    bolder: "#ff7452",
                    subtle: "#ff8f73",
                    subtler: "#ffbdad",
                    subtlest: "#FFEBE6"
                },
                teal: {
                    bolder: "#00C7E6",
                    subtle: "#79e2f2",
                    subtler: "#b3f5ff",
                    subtlest: "#e6fcff"
                },
                yellow: {
                    bolder: "",
                    subtle: "",
                    subtler: "",
                    subtlest: ""
                }
            },
            brand: {
                default: "#deebff",
                hovered: "",
                pressed: "",
                bold: {
                    default: "#091e42",
                    hovered: "#0747A6",
                    pressed: "#091e42"
                }
            },
            danger: {
                default: "#FFEBE6",
                hovered: "#ffbdad",
                pressed: "#ff8f73",
                bold: {
                    default: "#de350b",
                    hovered: "#bf2600",
                    pressed: "#751902"
                }
            },
            discovery: {
                default: "#c0b6f2",
                hovered: "#998dd9",
                pressed: "#8777d9",
                bold: {
                    default: "#6554c0",
                    hovered: "#5243aa",
                    pressed: "#403294"
                }
            },
            information: {
                default: "#B3D4FF",
                hovered: "#4c9aff",
                pressed: "#2684ff",
                bold: {
                    default: "#0052cc",
                    hovered: "#0747A6",
                    pressed: "#091e42"
                }
            },
            input: {
                default: "#091e42"
            },
            selected: {
                default: "#ffffff",
                hovered: "#4c9aff",
                pressed: "#2684ff",
                bold: {
                    default: "#0052cc",
                    hovered: "#0747A6",
                    pressed: "#091e42"
                }
            },
            success: {
                default: "#abf5d1",
                hovered: "#79f2c0",
                pressed: "#57D9A3",
                bold: {
                    default: "#00875a",
                    hovered: "#006644",
                    pressed: "#003D28"
                }
            },
            warning: {
                default: "#FFF0B3",
                hovered: "#ffe380",
                pressed: "#ffc400",
                bold: {
                    default: "#ffab00",
                    hovered: "#ff991f",
                    pressed: "#ff8b00"
                }
            }
        },
        blanket: {
            default: "#000000"
        },
        border: {
            bold: "#42526e",
            brand: "#B3D4FF",
            danger: "#de350b",
            default: "#5e6c84",
            disabled: "#c1c7d0",
            discovery: "#5243aa",
            focus: "#2684ff",
            information: "#0065ff",
            inverse: "#ffffff",
            selected: "#0052cc",
            success: "#00875a",
            warning: "#ff991f",
            accent: {
                blue: "#2684ff",
                gray: "#97a0af",
                green: "#57D9A3",
                magenta: "",
                orange: "#ffab00",
                purple: "#998dd9",
                red: "#ff5630",
                teal: "#79e2f2",
                yellow: "#ffe380"
            }
        },
        elevation: {
            surface: {
                default: {
                    solid: {
                        alternate1: "#5243aa",
                        alternate2: "#0747A6",
                        primary: "#172b4d"
                    }
                },
                overlay: {
                    default: "#ffffff"
                },
                raised: {
                    default: "#253858"
                }
            }
        },
        icon: {
            "brand": "#2684ff",
            "danger": "#ff7452",
            "default": "#ffffff",
            "disabled": "#b3bac5",
            "discovery": "#998dd9",
            "information": "#B3D4FF",
            "inverse": "#000000",
            "selected": "#4c9aff",
            "subtle": "#6B778C",
            "success": "#57D9A3",
            "warning-inverse": "#000000",
            "warning": "#ffe380",
            "accent": {
                blue: "#4c9aff",
                gray: "#7a869a",
                green: "#57D9A3",
                magenta: "",
                orange: "#ffe380",
                purple: "#998dd9",
                red: "#ff8f73",
                teal: "#79e2f2",
                yellow: "#FFF0B3"
            }
        },
        link: {
            alternate: "#ffffff",
            default: "#B3D4FF",
            pressed: "#4c9aff"
        },
        text: {
            "brand": "#B3D4FF",
            "danger": "#ff7452",
            "default": "#f4f5f7",
            "disabled": "#DFE1E6",
            "discovery": "#998dd9",
            "information": "#4c9aff",
            "inverse": "#0747A6",
            "selected": "#2684ff",
            "subtle": "#DFE1E6",
            "subtlest": "#b3bac5",
            "success": "#57D9A3",
            "warning-inverse": "#000000",
            "warning": "#ffc400",
            "accent": {
                "blue-bolder": "#deebff",
                "blue": "#2684ff",
                "gray-bolder": "",
                "gray": "#b3bac5",
                "green-bolder": "",
                "green": "#57D9A3",
                "magenta-bolder": "",
                "magenta": "",
                "orange-bolder": "",
                "orange": "#ffe380",
                "purple-bolder": "",
                "purple": "#998dd9",
                "red-bolder": "",
                "red": "#ff8f73",
                "teal-bolder": "",
                "teal": "#79e2f2",
                "yellow-bolder": "",
                "yellow": "#FFF0B3"
            }
        },
        utility: {
            MISSING_TOKEN: "#FA11F2"
        }
    }
});

});

parcelRegister("cVbTT", function(module, exports) {

$parcel$export(module.exports, "getValue", function () { return $96840a189471fe3b$export$bf7199a9ebcb84a9; });
var $96840a189471fe3b$var$isValidNestedObject = function(rawTokens) {
    return typeof rawTokens === "object" && !Array.isArray(rawTokens) && rawTokens !== null;
};
var $96840a189471fe3b$export$bf7199a9ebcb84a9 = function(rawTokens, tokenName) {
    var keys = tokenName.split(".");
    var current = rawTokens;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if ($96840a189471fe3b$var$isValidNestedObject(current) && (current === null || current === void 0 ? void 0 : current.hasOwnProperty(key))) current = current[key];
            else return "";
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return current;
};

});


parcelRegister("5vx95", function(module, exports) {

$parcel$export(module.exports, "colorBorderDefaultTokens", function () { return $40298f026f3fad35$export$8be79acd9e50eebf; });

var $6yULb = parcelRequire("6yULb");

var $cVbTT = parcelRequire("cVbTT");
var $40298f026f3fad35$export$8be79acd9e50eebf = Object.freeze({
    "color.border": (0, $cVbTT.getValue)((0, $6yULb.color), "default.border.default"),
    "color.border.accent.red": (0, $cVbTT.getValue)((0, $6yULb.color), "default.border.accent.red"),
    "color.border.accent.orange": (0, $cVbTT.getValue)((0, $6yULb.color), "default.border.accent.orange"),
    "color.border.accent.yellow": (0, $cVbTT.getValue)((0, $6yULb.color), "default.border.accent.yellow"),
    "color.border.accent.green": (0, $cVbTT.getValue)((0, $6yULb.color), "default.border.accent.green"),
    "color.border.accent.teal": (0, $cVbTT.getValue)((0, $6yULb.color), "default.border.accent.teal"),
    "color.border.accent.blue": (0, $cVbTT.getValue)((0, $6yULb.color), "default.border.accent.blue"),
    "color.border.accent.purple": (0, $cVbTT.getValue)((0, $6yULb.color), "default.border.accent.purple"),
    "color.border.accent.magenta": (0, $cVbTT.getValue)((0, $6yULb.color), "default.border.accent.magenta"),
    "color.border.accent.gray": (0, $cVbTT.getValue)((0, $6yULb.color), "default.border.accent.gray"),
    "color.border.disabled": (0, $cVbTT.getValue)((0, $6yULb.color), "default.border.disabled"),
    "color.border.focused": (0, $cVbTT.getValue)((0, $6yULb.color), "default.border.focused"),
    "color.border.input": (0, $cVbTT.getValue)((0, $6yULb.color), "default.border.input"),
    "color.border.inverse": (0, $cVbTT.getValue)((0, $6yULb.color), "default.border.inverse"),
    "color.border.selected": (0, $cVbTT.getValue)((0, $6yULb.color), "default.border.selected"),
    "color.border.brand": (0, $cVbTT.getValue)((0, $6yULb.color), "default.border.brand"),
    "color.border.danger": (0, $cVbTT.getValue)((0, $6yULb.color), "default.border.danger"),
    "color.border.warning": (0, $cVbTT.getValue)((0, $6yULb.color), "default.border.warning"),
    "color.border.success": (0, $cVbTT.getValue)((0, $6yULb.color), "default.border.focused"),
    "color.border.discovery": (0, $cVbTT.getValue)((0, $6yULb.color), "default.border.discovery"),
    "color.border.information: ": (0, $cVbTT.getValue)((0, $6yULb.color), "default.border.information"),
    "color.border.bold": (0, $cVbTT.getValue)((0, $6yULb.color), "default.border.bold")
});

});

parcelRegister("cLmoz", function(module, exports) {

$parcel$export(module.exports, "colorTextDefaultTokens", function () { return $94ab3f0f60e2b15e$export$8867b15f0207d8b5; });

var $6yULb = parcelRequire("6yULb");

var $cVbTT = parcelRequire("cVbTT");
var $94ab3f0f60e2b15e$export$8867b15f0207d8b5 = Object.freeze({
    "color.text": (0, $cVbTT.getValue)((0, $6yULb.color), "default.text.default"),
    "color.text.accent.red": (0, $cVbTT.getValue)((0, $6yULb.color), "default.text.accent.red"),
    "color.text.accent.red.bolder": (0, $cVbTT.getValue)((0, $6yULb.color), "default.text.accent.red-bolder"),
    "color.text.accent.orange": (0, $cVbTT.getValue)((0, $6yULb.color), "default.text.accent.orange"),
    "color.text.accent.orange.bolder": (0, $cVbTT.getValue)((0, $6yULb.color), "default.text.accent.orange-bolder"),
    "color.text.accent.yellow": (0, $cVbTT.getValue)((0, $6yULb.color), "default.text.accent.yellow"),
    "color.text.accent.yellow.bolder": (0, $cVbTT.getValue)((0, $6yULb.color), "default.text.accent.yellow-bolder"),
    "color.text.accent.green": (0, $cVbTT.getValue)((0, $6yULb.color), "default.text.accent.green"),
    "color.text.accent.green.bolder": (0, $cVbTT.getValue)((0, $6yULb.color), "default.text.accent.green-bolder"),
    "color.text.accent.teal": (0, $cVbTT.getValue)((0, $6yULb.color), "default.text.accent.teal"),
    "color.text.accent.teal.bolder": (0, $cVbTT.getValue)((0, $6yULb.color), "default.text.accent.teal-bolder"),
    "color.text.accent.blue": (0, $cVbTT.getValue)((0, $6yULb.color), "default.text.accent.blue"),
    "color.text.accent.blue.bolder": (0, $cVbTT.getValue)((0, $6yULb.color), "default.text.accent.blue-bolder"),
    "color.text.accent.purple": (0, $cVbTT.getValue)((0, $6yULb.color), "default.text.accent.purple"),
    "color.text.accent.purple.bolder": (0, $cVbTT.getValue)((0, $6yULb.color), "default.text.accent.purple-bolder"),
    "color.text.accent.magenta": (0, $cVbTT.getValue)((0, $6yULb.color), "default.text.accent.magenta"),
    "color.text.accent.magenta.bolder": (0, $cVbTT.getValue)((0, $6yULb.color), "default.text.accent.magenta-bolder"),
    "color.text.accent.gray": (0, $cVbTT.getValue)((0, $6yULb.color), "default.text.accent.gray"),
    "color.text.accent.gray.bolder": (0, $cVbTT.getValue)((0, $6yULb.color), "default.text.accent.gray-bolder"),
    "color.text.disabled": (0, $cVbTT.getValue)((0, $6yULb.color), "default.text.accent.disabled"),
    "color.text.inverse": (0, $cVbTT.getValue)((0, $6yULb.color), "default.text.inverse"),
    "color.text.selected": (0, $cVbTT.getValue)((0, $6yULb.color), "default.text.selected"),
    "color.text.brand": (0, $cVbTT.getValue)((0, $6yULb.color), "default.text.brand"),
    "color.text.danger": (0, $cVbTT.getValue)((0, $6yULb.color), "default.text.danger"),
    "color.text.warning": (0, $cVbTT.getValue)((0, $6yULb.color), "default.text.warning"),
    "color.text.warning.inverse": (0, $cVbTT.getValue)((0, $6yULb.color), "default.text.warning-inverse"),
    "color.text.success": (0, $cVbTT.getValue)((0, $6yULb.color), "default.text.success"),
    "color.text.discovery": (0, $cVbTT.getValue)((0, $6yULb.color), "default.text.discovery"),
    "color.text.information": (0, $cVbTT.getValue)((0, $6yULb.color), "default.text.information"),
    "color.text.subtlest": (0, $cVbTT.getValue)((0, $6yULb.color), "default.text.subtlest"),
    "color.text.subtle": (0, $cVbTT.getValue)((0, $6yULb.color), "default.text.subtle")
});

});







parcelRegister("a7Efx", function(module, exports) {

$parcel$export(module.exports, "ErrorState", function () { return $75e9c78b03954af0$export$c1ed4f415b9e7023; });

var $1rY3h = parcelRequire("1rY3h");

var $145N3 = parcelRequire("145N3");

var $1Mpn7 = parcelRequire("1Mpn7");

var $cVzdx = parcelRequire("cVzdx");

var $guA1I = parcelRequire("guA1I");

var $ikLBz = parcelRequire("ikLBz");
var $75e9c78b03954af0$export$c1ed4f415b9e7023 = function(param) {
    var analyticsAttributes = param.analyticsAttributes;
    var createAnalyticsEvent = (0, $145N3.useAnalyticsEvents)().createAnalyticsEvent;
    (0, $1Mpn7.useEffect)(function() {
        createAnalyticsEvent({
            eventName: (0, $cVzdx.TRACKING_EVENT_NAMES).errorScreenDisplayed,
            action: "displayed",
            actionSubject: "errorScreen",
            actionSubjectId: (0, $cVzdx.ACTION_SUBJECT_IDS).wacCartPopoverErrorScreen,
            attributes: analyticsAttributes
        }).fire();
    }, []);
    return (0, $1rY3h.jsxs)("div", {
        css: (0, $guA1I.containerStyle),
        "data-testid": "admin-cart-error-state",
        children: [
            (0, $1rY3h.jsx)((0, $ikLBz.ErrorIcon), {}),
            (0, $1rY3h.jsx)("h3", {
                css: (0, $guA1I.headerStyle),
                children: "Failed to load trial details"
            }),
            (0, $1rY3h.jsxs)("div", {
                css: (0, $guA1I.bodyStyle),
                children: [
                    "We couldn't get info about some of the products you're trialing. Try loading your trial details again. If the problem persists,",
                    " ",
                    (0, $1rY3h.jsx)("a", {
                        css: (0, $guA1I.linkStyle),
                        href: "https://support.atlassian.com/contact",
                        target: "_blank",
                        rel: "noreferrer",
                        children: "contact support"
                    }),
                    "."
                ]
            })
        ]
    });
};

});
parcelRegister("guA1I", function(module, exports) {

$parcel$export(module.exports, "bodyStyle", function () { return $c01b64d5b98de78f$export$f42854936a63861e; });
$parcel$export(module.exports, "containerStyle", function () { return $c01b64d5b98de78f$export$856b6de7fac89c7f; });
$parcel$export(module.exports, "headerStyle", function () { return $c01b64d5b98de78f$export$5939e41228734fb7; });
$parcel$export(module.exports, "linkStyle", function () { return $c01b64d5b98de78f$export$a4c1071d1005664f; });

var $j06k0 = parcelRequire("j06k0");

var $fBy54 = parcelRequire("fBy54");

var $gDEpB = parcelRequire("gDEpB");
function $c01b64d5b98de78f$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n"
    ]);
    $c01b64d5b98de78f$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $c01b64d5b98de78f$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "\n  text-align: center;\n"
    ]);
    $c01b64d5b98de78f$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $c01b64d5b98de78f$var$_templateObject2() {
    var data = (0, $j06k0._)([
        "\n  font-family: Charlie Display, sans-serif;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 32px;\n  letter-spacing: 0.3px;\n  margin-bottom: 8px;\n"
    ]);
    $c01b64d5b98de78f$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $c01b64d5b98de78f$var$_templateObject3() {
    var data = (0, $j06k0._)([
        "\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  color: ",
        ";\n  text-decoration: none;\n"
    ]);
    $c01b64d5b98de78f$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
var $c01b64d5b98de78f$export$f42854936a63861e = (0, $fBy54.css)($c01b64d5b98de78f$var$_templateObject());
var $c01b64d5b98de78f$export$856b6de7fac89c7f = (0, $fBy54.css)($c01b64d5b98de78f$var$_templateObject1());
var $c01b64d5b98de78f$export$5939e41228734fb7 = (0, $fBy54.css)($c01b64d5b98de78f$var$_templateObject2());
var $c01b64d5b98de78f$export$a4c1071d1005664f = (0, $fBy54.css)($c01b64d5b98de78f$var$_templateObject3(), (0, $gDEpB.getColor)("b300"));

});

parcelRegister("ikLBz", function(module, exports) {

$parcel$export(module.exports, "ErrorIcon", function () { return $d58f05a03da05619$export$19bc16ee58e19b3d; });

var $1rY3h = parcelRequire("1rY3h");

var $eewgE = parcelRequire("eewgE");
var $d58f05a03da05619$export$19bc16ee58e19b3d = function() {
    return (0, $1rY3h.jsxs)("div", {
        css: (0, $eewgE.errorContainerStyle),
        children: [
            (0, $1rY3h.jsxs)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "35",
                height: "32",
                viewBox: "0 0 35 32",
                fill: "none",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M21.9311 11.978L18.6684 0.176163C18.6626 0.106087 18.6291 0.0412016 18.5754 -0.00422009C18.5216 -0.0496417 18.452 -0.0718787 18.3819 -0.0660391C18.3117 -0.0601994 18.2467 -0.0267616 18.2012 0.0269186C18.1558 0.0805987 18.1335 0.150124 18.1394 0.220199L16.0671 11.2734L13.5098 10.789C13.4629 10.7777 13.4138 10.7795 13.3677 10.7941C13.3217 10.8087 13.2806 10.8356 13.2488 10.8719C13.217 10.9082 13.1958 10.9525 13.1874 11C13.179 11.0475 13.1838 11.0963 13.2012 11.1413L16.508 22.8991C16.5286 22.9462 16.5625 22.9864 16.6056 23.0145C16.6486 23.0427 16.699 23.0577 16.7505 23.0577C16.802 23.0577 16.8524 23.0427 16.8954 23.0145C16.9385 22.9864 16.9724 22.9462 16.993 22.8991L19.0653 11.8459L21.6225 12.2863C21.6648 12.2941 21.7083 12.2916 21.7494 12.2789C21.7904 12.2662 21.8278 12.2437 21.8582 12.2134C21.8886 12.183 21.9111 12.1457 21.9238 12.1047C21.9365 12.0637 21.939 12.0202 21.9311 11.978Z",
                        fill: "#FFC400"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M10.203 18.4074L5.39716 14.6642C5.30898 14.5762 5.1767 14.6642 5.22079 14.7963L7.68987 19.8165L6.49942 20.389C6.41124 20.433 6.41124 20.5211 6.49942 20.6092L11.2612 24.3523C11.3494 24.4404 11.5258 24.3083 11.4376 24.2202L9.01259 19.156L10.203 18.6275C10.2471 18.5835 10.2912 18.4514 10.203 18.4074Z",
                        fill: "#FFAB00"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M26.0756 24.9688H25.8111C25.7385 24.9042 25.6871 24.8192 25.6635 24.7249C25.6399 24.6307 25.6452 24.5316 25.6788 24.4404C25.5906 24.0881 24.6647 23.1633 24.1356 22.6349C22.8129 21.2698 21.9311 20.4331 22.4161 19.7725C22.9011 19.112 24.0033 19.6404 25.6788 20.5211C26.3075 20.8526 26.9553 21.1467 27.6188 21.4019C27.1953 20.8202 26.7072 20.2883 26.1638 19.8165C24.8852 18.4954 24.0033 17.6147 24.4883 16.9542C24.9733 16.2936 26.0756 16.8661 27.7511 17.7028C28.3798 18.0343 29.0276 18.3284 29.691 18.5835C29.2561 18.0113 28.769 17.4806 28.236 16.9982C26.9574 15.6771 26.0756 14.7964 26.5606 14.1358C27.0456 13.4753 28.1479 14.0477 29.7792 14.8844C30.4847 15.2367 31.631 15.8092 31.9838 15.8092C32.0565 15.7442 32.1507 15.7083 32.2483 15.7083C32.3459 15.7083 32.4401 15.7442 32.5128 15.8092C32.5626 15.8405 32.6056 15.8814 32.6393 15.9296C32.673 15.9778 32.6968 16.0322 32.7091 16.0896C32.7214 16.1471 32.7221 16.2064 32.7111 16.2641C32.7001 16.3218 32.6777 16.3768 32.6451 16.4257C32.1601 17.0863 31.0578 16.5138 29.3824 15.6771C28.7628 15.3274 28.1136 15.0327 27.4424 14.7964C27.8849 15.3488 28.3559 15.878 28.8533 16.3817C30.176 17.7028 31.0578 18.5835 30.5729 19.2441C30.0879 19.9046 28.9856 19.3321 27.3101 18.4954C26.6816 18.1507 26.0338 17.8419 25.3702 17.5707C25.8035 18.1577 26.2906 18.7032 26.8251 19.2C28.1038 20.5211 28.9856 21.4019 28.5006 22.0184C28.0156 22.6349 26.9133 22.1505 25.282 21.2698C24.6385 20.9375 23.976 20.6434 23.2979 20.389C23.6065 20.8294 24.312 21.534 24.7529 22.0184C26.0756 23.3395 26.9133 24.2202 26.4283 24.8367C26.3851 24.8862 26.3302 24.9242 26.2687 24.9473C26.2071 24.9703 26.1408 24.9777 26.0756 24.9688Z",
                        fill: "#344563"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M28.5447 31.3101C28.4656 31.3085 28.3881 31.2876 28.3189 31.2492C28.2497 31.2108 28.191 31.1561 28.1479 31.0899C27.707 30.2532 27.1779 29.2844 27.7511 28.756C28.3242 28.2275 29.2061 28.844 30.176 29.5046C30.5796 29.7908 31.0075 30.0413 31.4547 30.2532C31.3069 29.7741 31.0995 29.3155 30.8374 28.8881C30.2642 27.8752 29.7351 26.9505 30.3083 26.422C30.8815 25.8936 31.8074 26.5101 32.7333 27.1266C33.1458 27.4588 33.6068 27.7261 34.1001 27.9193C34.1419 27.8729 34.1932 27.836 34.2504 27.811C34.3075 27.7859 34.3694 27.7732 34.4319 27.7739C34.4943 27.7745 34.5559 27.7883 34.6126 27.8145C34.6693 27.8407 34.7198 27.8787 34.7607 27.9258C34.8016 27.9729 34.832 28.0282 34.8499 28.088C34.8678 28.1478 34.8728 28.2106 34.8645 28.2725C34.8563 28.3343 34.8349 28.3937 34.802 28.4467C34.769 28.4997 34.7251 28.545 34.6733 28.5798C34.1001 29.1082 33.1742 28.4917 32.2483 27.8752C31.8447 27.589 31.4169 27.3385 30.9697 27.1266C31.1187 27.5913 31.3261 28.0352 31.5869 28.4477C32.1601 29.4605 32.6892 30.4294 32.116 30.9578C31.5429 31.4862 30.617 30.8697 29.691 30.2092C29.2788 29.9122 28.8353 29.6611 28.3683 29.4605C28.5238 29.873 28.7156 30.2709 28.9415 30.6495C28.9898 30.7496 28.9985 30.8642 28.9658 30.9703C28.9331 31.0765 28.8614 31.1664 28.7651 31.222L28.5447 31.3101Z",
                        fill: "#5E6C84"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M4.6035 30.033L4.29486 29.9449C3.58941 29.6367 3.76578 28.5798 3.94214 27.4789C4.04469 26.9867 4.08908 26.4842 4.07441 25.9816C3.72258 26.3383 3.39832 26.721 3.10442 27.1266C2.44306 28.0514 1.82579 28.9321 1.07625 28.6238C0.972194 28.5758 0.890978 28.4891 0.849823 28.3822C0.808667 28.2754 0.81081 28.1567 0.855795 28.0514C0.870476 27.9976 0.896357 27.9475 0.931749 27.9043C0.967141 27.8612 1.01125 27.826 1.06118 27.8011C1.11112 27.7762 1.16576 27.762 1.22154 27.7596C1.27732 27.7572 1.33298 27.7666 1.38488 27.7871C1.60533 27.6991 2.09033 26.9945 2.39897 26.5982C2.7076 26.2018 3.72169 24.7926 4.42714 25.1009C5.13259 25.4092 5.00031 26.466 4.82395 27.611C4.70737 28.1016 4.64819 28.604 4.64759 29.1082C5.01367 28.7649 5.33913 28.3807 5.61758 27.9633C6.27894 27.0385 6.9403 26.1578 7.64575 26.466C8.3512 26.7743 8.21893 27.8312 8.04257 28.756C8.05079 28.8236 8.04319 28.8922 8.02036 28.9564C7.99753 29.0206 7.9601 29.0786 7.91101 29.1259C7.86192 29.1732 7.80252 29.2085 7.73746 29.229C7.67241 29.2495 7.60349 29.2546 7.53611 29.244C7.46873 29.2334 7.40474 29.2073 7.34918 29.1678C7.29361 29.1283 7.24797 29.0764 7.21587 29.0163C7.18376 28.9562 7.16605 28.8895 7.16414 28.8214C7.16223 28.7533 7.17616 28.6857 7.20484 28.6238C7.25612 28.1999 7.28556 27.7737 7.29303 27.3468C6.9164 27.68 6.58973 28.0656 6.32303 28.4917C5.74985 29.2844 5.17668 30.033 4.6035 30.033Z",
                        fill: "#5E6C84"
                    })
                ]
            }),
            (0, $1rY3h.jsxs)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "73",
                height: "65",
                viewBox: "0 0 73 65",
                fill: "none",
                children: [
                    (0, $1rY3h.jsx)("path", {
                        d: "M42.2979 4.31744L71.5741 54.9596C72.1755 55.9729 72.4966 57.1275 72.5047 58.3053C72.5127 59.4832 72.2074 60.642 71.6198 61.6634C71.0323 62.6847 70.1837 63.5318 69.1608 64.118C68.1379 64.7043 66.9775 65.0087 65.7982 65H7.20175C6.02245 65.0087 4.86201 64.7043 3.83913 64.118C2.81625 63.5318 1.96765 62.6847 1.38012 61.6634C0.792593 60.642 0.487232 59.4832 0.495272 58.3053C0.503312 57.1275 0.824464 55.9729 1.42588 54.9596L30.7021 4.31744C31.2819 3.29135 32.1243 2.43758 33.1431 1.84349C34.1618 1.2494 35.3203 0.93634 36.5 0.93634C37.6797 0.93634 38.8382 1.2494 39.8569 1.84349C40.8756 2.43758 41.718 3.29135 42.2979 4.31744Z",
                        fill: "url(#paint0_linear_1350_646)"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M38.947 41.0881L40.2256 21.5798C40.2554 21.0275 40.1729 20.4748 39.983 19.9552C39.793 19.4355 39.4997 18.9597 39.1206 18.5564C38.7416 18.1531 38.2846 17.8307 37.7774 17.6086C37.2701 17.3865 36.7231 17.2694 36.1693 17.2642C35.6154 17.2626 35.0671 17.3755 34.5591 17.5959C34.051 17.8163 33.5941 18.1394 33.2172 18.5448C32.8403 18.9502 32.5516 19.4291 32.3691 19.9515C32.1866 20.4738 32.1144 21.0282 32.157 21.5798L33.3916 41.0881C33.4465 41.7892 33.762 42.4445 34.2759 42.9252C34.7899 43.406 35.4652 43.6774 36.1693 43.6863C36.8764 43.6877 37.5575 43.4197 38.0736 42.9369C38.5897 42.4541 38.9021 41.7929 38.947 41.0881Z",
                        fill: "#253858"
                    }),
                    (0, $1rY3h.jsx)("path", {
                        d: "M31.9807 51.4367C31.9718 52.0248 32.0872 52.6081 32.3194 53.1486C32.5515 53.6892 32.8951 54.1747 33.3278 54.5736C33.7605 54.9726 34.2725 55.2759 34.8305 55.4638C35.3885 55.6517 35.9799 55.72 36.5661 55.6642C37.3981 55.6041 38.1942 55.3023 38.8566 54.796C39.519 54.2896 40.0187 53.6009 40.2942 52.8146C40.5697 52.0282 40.6089 51.1786 40.4071 50.3702C40.2052 49.5619 39.7711 48.8301 39.1582 48.2651C38.5453 47.7 37.7803 47.3263 36.9575 47.1899C36.1346 47.0535 35.2898 47.1604 34.527 47.4975C33.7642 47.8346 33.1167 48.3871 32.6643 49.087C32.2119 49.7869 31.9743 50.6036 31.9807 51.4367Z",
                        fill: "#253858"
                    }),
                    (0, $1rY3h.jsx)("defs", {
                        children: (0, $1rY3h.jsxs)("linearGradient", {
                            id: "paint0_linear_1350_646",
                            x1: "59.5197",
                            y1: "29.0793",
                            x2: "-0.703794",
                            y2: "57.1959",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                (0, $1rY3h.jsx)("stop", {
                                    stopColor: "#FFD740"
                                }),
                                (0, $1rY3h.jsx)("stop", {
                                    offset: "1",
                                    stopColor: "#FFAB00"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("eewgE", function(module, exports) {

$parcel$export(module.exports, "errorContainerStyle", function () { return $a5cb672be9ad693d$export$b08a9839129a06bf; });

var $j06k0 = parcelRequire("j06k0");

var $fBy54 = parcelRequire("fBy54");
function $a5cb672be9ad693d$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"
    ]);
    $a5cb672be9ad693d$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $a5cb672be9ad693d$export$b08a9839129a06bf = (0, $fBy54.css)($a5cb672be9ad693d$var$_templateObject());

});




parcelRegister("bNsTa", function(module, exports) {

$parcel$export(module.exports, "EntitlementItem", function () { return (parcelRequire("afdAm")).EntitlementItem; });

var $afdAm = parcelRequire("afdAm");

});
parcelRegister("afdAm", function(module, exports) {

$parcel$export(module.exports, "EntitlementItem", function () { return $7755d7e1e5883f68$export$42f77981e2d9cbc1; });

var $1rY3h = parcelRequire("1rY3h");

var $9KJ2a = parcelRequire("9KJ2a");

var $dFCZz = parcelRequire("dFCZz");

var $dpugK = parcelRequire("dpugK");
var $7755d7e1e5883f68$export$42f77981e2d9cbc1 = function(param) {
    var daysLeft = param.daysLeft, productKey = param.productKey, productAndPlanName = param.productAndPlanName, siteName = param.siteName, formattedTotalPrice = param.formattedTotalPrice, usersPriceBreakdown = param.usersPriceBreakdown;
    var IconComponent = (0, $dFCZz.PRODUCT_ICON_BY_KEY)[productKey];
    var pluralize = function(count) {
        return count === 1 ? "" : "s";
    };
    return (0, $1rY3h.jsxs)("div", {
        css: (0, $dpugK.containerStyle),
        children: [
            (0, $1rY3h.jsx)((0, $9KJ2a.default), {
                appearance: daysLeft ? "default" : "removed",
                children: daysLeft ? (0, $1rY3h.jsxs)("span", {
                    css: (0, $dpugK.lozengeStyle),
                    children: [
                        daysLeft,
                        " day",
                        pluralize(daysLeft),
                        " left in trial"
                    ]
                }) : (0, $1rY3h.jsx)("span", {
                    css: (0, $dpugK.lozengeStyle),
                    children: "URGENT ACTION NEEDED"
                })
            }),
            (0, $1rY3h.jsxs)("div", {
                css: (0, $dpugK.mainContentStyle),
                children: [
                    (0, $1rY3h.jsxs)("div", {
                        css: (0, $dpugK.productTextStyle),
                        children: [
                            (0, $1rY3h.jsx)(IconComponent, {
                                appearance: "brand",
                                size: "small"
                            }),
                            (0, $1rY3h.jsx)("div", {
                                css: (0, $dpugK.productNameStyle),
                                children: productAndPlanName
                            })
                        ]
                    }),
                    (0, $1rY3h.jsx)("div", {
                        css: (0, $dpugK.totalCostStyle),
                        children: formattedTotalPrice
                    })
                ]
            }),
            (0, $1rY3h.jsxs)("div", {
                css: (0, $dpugK.subContentStyle),
                children: [
                    (0, $1rY3h.jsx)("div", {
                        css: (0, $dpugK.siteNameStyle),
                        children: siteName
                    }),
                    (0, $1rY3h.jsx)("div", {
                        css: (0, $dpugK.userBreakdownStyle),
                        children: usersPriceBreakdown
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("9KJ2a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $719b57c0d9a65e41$export$2e2bcd8739ae039; });
/* eslint-disable @atlassian/tangerine/import/entry-points */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable @atlaskit/design-system/no-unsafe-design-token-usage */ 
var $1Mpn7 = parcelRequire("1Mpn7");

var $3jYyQ = parcelRequire("3jYyQ");

var $55AtB = parcelRequire("55AtB");
var $1I6VC = parcelRequire("1I6VC");
var $719b57c0d9a65e41$var$baseStyles = (0, $1I6VC.xcss)({
    display: "inline-flex",
    borderRadius: "border.radius",
    position: "static",
    overflow: "hidden"
});
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ var $719b57c0d9a65e41$var$Lozenge = /*#__PURE__*/ (0, $1Mpn7.memo)(function(_ref) {
    var children = _ref.children, testId = _ref.testId, _ref$isBold = _ref.isBold, isBold = _ref$isBold === void 0 ? false : _ref$isBold, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth, style = _ref.style;
    var appearanceStyle = isBold ? "bold" : "subtle";
    var appearanceType = appearance in $719b57c0d9a65e41$var$backgroundColors[appearanceStyle] ? appearance : "default";
    var maxWidthValue = typeof maxWidth === "string" ? maxWidth : "".concat(maxWidth, "px");
    var maxWidthIsPc = typeof maxWidth === "string" && /%$/.test(maxWidth);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $55AtB.default), {
        as: "span",
        backgroundColor: $719b57c0d9a65e41$var$backgroundColors[appearanceStyle][appearanceType],
        style: {
            backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : "100%"
        },
        paddingInline: "space.050",
        xcss: $719b57c0d9a65e41$var$baseStyles,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $3jYyQ.default), {
        fontSize: "size.050",
        fontWeight: "bold",
        lineHeight: "lineHeight.100",
        textTransform: "uppercase",
        color: $719b57c0d9a65e41$var$textColors[appearanceStyle][appearanceType],
        shouldTruncate: true,
        UNSAFE_style: {
            color: style === null || style === void 0 ? void 0 : style.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? "100%" : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")")
        },
        testId: testId && "".concat(testId, "--text")
    }, children));
});
$719b57c0d9a65e41$var$Lozenge.displayName = "Lozenge";
var $719b57c0d9a65e41$export$2e2bcd8739ae039 = $719b57c0d9a65e41$var$Lozenge;
// Lozenge colors
var $719b57c0d9a65e41$var$backgroundColors = {
    bold: {
        default: "color.background.neutral.bold",
        inprogress: "color.background.information.bold",
        moved: "color.background.warning.bold",
        new: "color.background.discovery.bold",
        removed: "color.background.danger.bold",
        success: "color.background.success.bold"
    },
    subtle: {
        default: "color.background.neutral",
        inprogress: "color.background.information",
        moved: "color.background.warning",
        new: "color.background.discovery",
        removed: "color.background.danger",
        success: "color.background.success"
    }
};
var $719b57c0d9a65e41$var$textColors = {
    bold: {
        default: "inverse",
        inprogress: "inverse",
        moved: "warning.inverse",
        new: "inverse",
        removed: "inverse",
        success: "inverse"
    },
    subtle: {
        default: "subtle",
        inprogress: "information",
        moved: "warning",
        new: "discovery",
        removed: "danger",
        success: "success"
    }
};

});
parcelRegister("3jYyQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26b21fa0424cb11d$export$2e2bcd8739ae039; });

var $04Kcc = parcelRequire("04Kcc");

var $1Mpn7 = parcelRequire("1Mpn7");

var $fBy54 = parcelRequire("fBy54");

var $u2nzd = parcelRequire("u2nzd");

var $ioAsB = parcelRequire("ioAsB");

var $dmEAC = parcelRequire("dmEAC");
var $26b21fa0424cb11d$var$_excluded = [
    "children"
];
var $26b21fa0424cb11d$var$asAllowlist = [
    "span",
    "div",
    "p",
    "strong"
];
var $26b21fa0424cb11d$var$textAlignMap = {
    center: (0, $fBy54.css)({
        textAlign: "center"
    }),
    end: (0, $fBy54.css)({
        textAlign: "end"
    }),
    start: (0, $fBy54.css)({
        textAlign: "start"
    })
};
var $26b21fa0424cb11d$var$textTransformMap = {
    none: (0, $fBy54.css)({
        textTransform: "none"
    }),
    lowercase: (0, $fBy54.css)({
        textTransform: "lowercase"
    }),
    uppercase: (0, $fBy54.css)({
        textTransform: "uppercase"
    })
};
var $26b21fa0424cb11d$var$verticalAlignMap = {
    top: (0, $fBy54.css)({
        verticalAlign: "top"
    }),
    middle: (0, $fBy54.css)({
        verticalAlign: "middle"
    }),
    bottom: (0, $fBy54.css)({
        verticalAlign: "bottom"
    })
};
var $26b21fa0424cb11d$var$baseStyles = (0, $fBy54.css)({
    boxSizing: "border-box",
    margin: "var(--ds-space-0, 0px)",
    padding: "var(--ds-space-0, 0px)"
});
var $26b21fa0424cb11d$var$truncateStyles = (0, $fBy54.css)({
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $26b21fa0424cb11d$var$useColor = function useColor(colorProp) {
    var surface = (0, $dmEAC.useSurface)();
    var inverseTextColor = (0, $ioAsB.default)[surface];
    /**
   * Where the color of the surface is inverted we override the user choice
   * as there is no valid choice that is not covered by the override.
   */ var color = inverseTextColor !== null && inverseTextColor !== void 0 ? inverseTextColor : colorProp;
    return color;
};
var $26b21fa0424cb11d$var$HasTextAncestorContext = /*#__PURE__*/ (0, $1Mpn7.createContext)(false);
var $26b21fa0424cb11d$var$useHasTextAncestor = function useHasTextAncestor() {
    return (0, $1Mpn7.useContext)($26b21fa0424cb11d$var$HasTextAncestorContext);
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $26b21fa0424cb11d$var$Text = function Text(_ref) {
    var children = _ref.children, props = (0, (/*@__PURE__*/$parcel$interopDefault($04Kcc)))(_ref, $26b21fa0424cb11d$var$_excluded);
    var _props$as = props.as, Component = _props$as === void 0 ? "span" : _props$as, colorProp = props.color, fontSize = props.fontSize, fontWeight = props.fontWeight, lineHeight = props.lineHeight, _props$shouldTruncate = props.shouldTruncate, shouldTruncate = _props$shouldTruncate === void 0 ? false : _props$shouldTruncate, textAlign = props.textAlign, textTransform = props.textTransform, verticalAlign = props.verticalAlign, testId = props.testId, UNSAFE_style = props.UNSAFE_style, id = props.id;
    (0, $u2nzd.default)($26b21fa0424cb11d$var$asAllowlist.includes(Component), '@atlaskit/ds-explorations: Text received an invalid "as" value of "'.concat(Component, '"'));
    var color = $26b21fa0424cb11d$var$useColor(colorProp);
    var isWrapped = $26b21fa0424cb11d$var$useHasTextAncestor();
    /**
   * If the text is already wrapped and applies no props we can just
   * render the children directly as a fragment.
   */ if (isWrapped && Object.keys(props).length === 0) return (0, $fBy54.jsx)((0, $1Mpn7.Fragment), null, children);
    var component = (0, $fBy54.jsx)(Component, {
        style: UNSAFE_style,
        css: [
            $26b21fa0424cb11d$var$baseStyles,
            $26b21fa0424cb11d$var$fontFamilyMap.sans,
            color && $26b21fa0424cb11d$var$textColorMap[color],
            fontSize && $26b21fa0424cb11d$var$fontSizeMap[fontSize],
            fontWeight && $26b21fa0424cb11d$var$fontWeightMap[fontWeight],
            lineHeight && $26b21fa0424cb11d$var$lineHeightMap[lineHeight],
            shouldTruncate && $26b21fa0424cb11d$var$truncateStyles,
            textAlign && $26b21fa0424cb11d$var$textAlignMap[textAlign],
            textTransform && $26b21fa0424cb11d$var$textTransformMap[textTransform],
            verticalAlign && $26b21fa0424cb11d$var$verticalAlignMap[verticalAlign]
        ],
        "data-testid": testId,
        id: id
    }, children);
    return isWrapped ? // no need to re-apply context if the text is already wrapped
    component : (0, $fBy54.jsx)($26b21fa0424cb11d$var$HasTextAncestorContext.Provider, {
        value: true
    }, component);
};
var $26b21fa0424cb11d$export$2e2bcd8739ae039 = $26b21fa0424cb11d$var$Text;
/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f42dabbb2f08c0ca0dd8a46fc3508937>>
 * @codegenId typography
 * @codegenCommand yarn codegen-styles
 * @codegenParams ["fontSize", "fontWeight", "fontFamily", "lineHeight"]
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-typography.tsx <<SignedSource::ca98df97c16967b7984f4ad4d557cc48>>
 */ var $26b21fa0424cb11d$var$fontSizeMap = {
    "size.050": (0, $fBy54.css)({
        fontSize: "var(--ds-font-size-050, 11px)"
    }),
    "size.075": (0, $fBy54.css)({
        fontSize: "var(--ds-font-size-075, 12px)"
    }),
    "size.100": (0, $fBy54.css)({
        fontSize: "var(--ds-font-size-100, 14px)"
    }),
    "size.200": (0, $fBy54.css)({
        fontSize: "var(--ds-font-size-200, 16px)"
    }),
    "size.300": (0, $fBy54.css)({
        fontSize: "var(--ds-font-size-300, 20px)"
    }),
    "size.400": (0, $fBy54.css)({
        fontSize: "var(--ds-font-size-400, 24px)"
    }),
    "size.500": (0, $fBy54.css)({
        fontSize: "var(--ds-font-size-500, 29px)"
    }),
    "size.600": (0, $fBy54.css)({
        fontSize: "var(--ds-font-size-600, 35px)"
    })
};
var $26b21fa0424cb11d$var$fontWeightMap = {
    bold: (0, $fBy54.css)({
        fontWeight: "var(--ds-font-weight-bold, 700)"
    }),
    medium: (0, $fBy54.css)({
        fontWeight: "var(--ds-font-weight-medium, 500)"
    }),
    regular: (0, $fBy54.css)({
        fontWeight: "var(--ds-font-weight-regular, 400)"
    }),
    semibold: (0, $fBy54.css)({
        fontWeight: "var(--ds-font-weight-semibold, 600)"
    })
};
var $26b21fa0424cb11d$var$fontFamilyMap = {
    body: (0, $fBy54.css)({
        fontFamily: 'var(--ds-font-family-body, ui-sans-serif, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    brand: (0, $fBy54.css)({
        fontFamily: "var(--ds-font-family-brand, Charlie Sans)"
    }),
    code: (0, $fBy54.css)({
        fontFamily: 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)'
    }),
    heading: (0, $fBy54.css)({
        fontFamily: 'var(--ds-font-family-heading, ui-sans-serif, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    monospace: (0, $fBy54.css)({
        fontFamily: 'var(--ds-font-family-monospace, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)'
    }),
    sans: (0, $fBy54.css)({
        fontFamily: 'var(--ds-font-family-sans, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif)'
    })
};
var $26b21fa0424cb11d$var$lineHeightMap = {
    "lineHeight.1": (0, $fBy54.css)({
        lineHeight: "var(--ds-font-lineHeight-1, 1)"
    }),
    "lineHeight.100": (0, $fBy54.css)({
        lineHeight: "var(--ds-font-lineHeight-100, 16px)"
    }),
    "lineHeight.200": (0, $fBy54.css)({
        lineHeight: "var(--ds-font-lineHeight-200, 20px)"
    }),
    "lineHeight.300": (0, $fBy54.css)({
        lineHeight: "var(--ds-font-lineHeight-300, 24px)"
    }),
    "lineHeight.400": (0, $fBy54.css)({
        lineHeight: "var(--ds-font-lineHeight-400, 28px)"
    }),
    "lineHeight.500": (0, $fBy54.css)({
        lineHeight: "var(--ds-font-lineHeight-500, 32px)"
    }),
    "lineHeight.600": (0, $fBy54.css)({
        lineHeight: "var(--ds-font-lineHeight-600, 40px)"
    })
};
/**
 * @codegenEnd
 */ /**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::95d4f240e36e302a634e8633a0782cba>>
 * @codegenId colors
 * @codegenCommand yarn codegen-styles
 * @codegenParams ["text"]
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::f1021f8d47ab63374e371ce18db72a1c>>
 */ var $26b21fa0424cb11d$var$textColorMap = {
    "color.text": (0, $fBy54.css)({
        color: "var(--ds-text, #172B4D)"
    }),
    disabled: (0, $fBy54.css)({
        color: "var(--ds-text-disabled, #A5ADBA)"
    }),
    inverse: (0, $fBy54.css)({
        color: "var(--ds-text-inverse, #FFFFFF)"
    }),
    selected: (0, $fBy54.css)({
        color: "var(--ds-text-selected, #0052CC)"
    }),
    brand: (0, $fBy54.css)({
        color: "var(--ds-text-brand, #0065FF)"
    }),
    danger: (0, $fBy54.css)({
        color: "var(--ds-text-danger, #DE350B)"
    }),
    warning: (0, $fBy54.css)({
        color: "var(--ds-text-warning, #974F0C)"
    }),
    "warning.inverse": (0, $fBy54.css)({
        color: "var(--ds-text-warning-inverse, #172B4D)"
    }),
    success: (0, $fBy54.css)({
        color: "var(--ds-text-success, #006644)"
    }),
    discovery: (0, $fBy54.css)({
        color: "var(--ds-text-discovery, #403294)"
    }),
    information: (0, $fBy54.css)({
        color: "var(--ds-text-information, #0052CC)"
    }),
    subtlest: (0, $fBy54.css)({
        color: "var(--ds-text-subtlest, #7A869A)"
    }),
    subtle: (0, $fBy54.css)({
        color: "var(--ds-text-subtle, #42526E)"
    })
}; /**
 * @codegenEnd
 */ 

});
parcelRegister("u2nzd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05a4a5e60878c7fe$export$2e2bcd8739ae039; });
var $05a4a5e60878c7fe$var$isProduction = true;
var $05a4a5e60878c7fe$var$prefix = "Invariant failed";
function $05a4a5e60878c7fe$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($05a4a5e60878c7fe$var$isProduction) throw new Error($05a4a5e60878c7fe$var$prefix);
    var provided = typeof message === "function" ? message() : message;
    var value = provided ? "".concat($05a4a5e60878c7fe$var$prefix, ": ").concat(provided) : $05a4a5e60878c7fe$var$prefix;
    throw new Error(value);
}

});

parcelRegister("ioAsB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d646c02824947ab0$export$2e2bcd8739ae039; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * The color map is used to map a background color token to a matching text color that will meet contrast.
 *
 * @codegen <<SignedSource::9db207c6fd205f6abc46eeb73ba02789>>
 * @codegenCommand yarn codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::f1021f8d47ab63374e371ce18db72a1c>>
 */ var $d646c02824947ab0$export$2e2bcd8739ae039 = {
    "neutral.bold": "inverse",
    "neutral.bold.hovered": "inverse",
    "neutral.bold.pressed": "inverse",
    "selected.bold": "inverse",
    "selected.bold.hovered": "inverse",
    "selected.bold.pressed": "inverse",
    "brand.bold": "inverse",
    "brand.bold.hovered": "inverse",
    "brand.bold.pressed": "inverse",
    "brand.boldest": "inverse",
    "brand.boldest.hovered": "inverse",
    "brand.boldest.pressed": "inverse",
    "danger.bold": "inverse",
    "danger.bold.hovered": "inverse",
    "danger.bold.pressed": "inverse",
    "warning.bold": "warning.inverse",
    "warning.bold.hovered": "warning.inverse",
    "warning.bold.pressed": "warning.inverse",
    "success.bold": "inverse",
    "success.bold.hovered": "inverse",
    "success.bold.pressed": "inverse",
    "discovery.bold": "inverse",
    "discovery.bold.hovered": "inverse",
    "discovery.bold.pressed": "inverse",
    "information.bold": "inverse",
    "information.bold.hovered": "inverse",
    "information.bold.pressed": "inverse"
};

});

parcelRegister("dmEAC", function(module, exports) {

$parcel$export(module.exports, "useSurface", function () { return $9bacd0abdabdc88b$export$1aeb4f6b93c4540d; });

var $1Mpn7 = parcelRequire("1Mpn7");
var $9bacd0abdabdc88b$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $1Mpn7.createContext)("elevation.surface");
var $9bacd0abdabdc88b$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $1Mpn7.useContext)($9bacd0abdabdc88b$export$1ca2a26fecb070ae);
};
$9bacd0abdabdc88b$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";

});


parcelRegister("55AtB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b49b6de8a072ab9$export$2e2bcd8739ae039; });

var $fjkYW = parcelRequire("fjkYW");

var $04Kcc = parcelRequire("04Kcc");

var $1Mpn7 = parcelRequire("1Mpn7");

var $fBy54 = parcelRequire("fBy54");

var $a7YLX = parcelRequire("a7YLX");

var $1I6VC = parcelRequire("1I6VC");

var $1DWwN = parcelRequire("1DWwN");
var $3b49b6de8a072ab9$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $3b49b6de8a072ab9$var$_excluded2 = [
    "className"
];
var $3b49b6de8a072ab9$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $1Mpn7.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, as = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($04Kcc)))(_ref, $3b49b6de8a072ab9$var$_excluded);
    var Component = as;
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($04Kcc)))(htmlAttributes, $3b49b6de8a072ab9$var$_excluded2);
    var className = xcss && (0, $1I6VC.parseXcss)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $fBy54.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($fjkYW)))({
        style: style,
        ref: ref
    }, safeHtmlAttributes, {
        css: [
            $3b49b6de8a072ab9$var$baseStyles,
            backgroundColor && (0, $a7YLX.backgroundColorStylesMap)[backgroundColor],
            (0, $a7YLX.isSurfaceColorToken)(backgroundColor) && (0, $a7YLX.surfaceColorStylesMap)[backgroundColor],
            padding && (0, $a7YLX.paddingStylesMap).padding[padding],
            paddingBlock && (0, $a7YLX.paddingStylesMap).paddingBlock[paddingBlock],
            paddingBlockStart && (0, $a7YLX.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            paddingBlockEnd && (0, $a7YLX.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            paddingInline && (0, $a7YLX.paddingStylesMap).paddingInline[paddingInline],
            paddingInlineStart && (0, $a7YLX.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            paddingInlineEnd && (0, $a7YLX.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            className
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $fBy54.jsx)((0, $1DWwN.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $3b49b6de8a072ab9$export$2e2bcd8739ae039 = $3b49b6de8a072ab9$export$e71c4d32a2263218;
var $3b49b6de8a072ab9$var$baseStyles = (0, $fBy54.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});

});
parcelRegister("a7YLX", function(module, exports) {

$parcel$export(module.exports, "dimensionMap", function () { return $75f9b30006f50ff0$export$6ccdbebca2ee545f; });
$parcel$export(module.exports, "spaceMap", function () { return $75f9b30006f50ff0$export$1f52408f03b1c9b4; });
$parcel$export(module.exports, "borderColorMap", function () { return $75f9b30006f50ff0$export$1531ad5bb3fbedac; });
$parcel$export(module.exports, "backgroundColorMap", function () { return $75f9b30006f50ff0$export$d1d79bf68ac056bd; });
$parcel$export(module.exports, "shadowMap", function () { return $75f9b30006f50ff0$export$7aff6e7ba39bb774; });
$parcel$export(module.exports, "textColorMap", function () { return $75f9b30006f50ff0$export$8473307aa00d6ea1; });
$parcel$export(module.exports, "layerMap", function () { return $75f9b30006f50ff0$export$b5f31a7e431d2eab; });
$parcel$export(module.exports, "borderWidthMap", function () { return $75f9b30006f50ff0$export$e1b83c5210c471b8; });
$parcel$export(module.exports, "borderRadiusMap", function () { return $75f9b30006f50ff0$export$3c0a6c3e64bb180d; });
$parcel$export(module.exports, "paddingStylesMap", function () { return $75f9b30006f50ff0$export$e615f061ca585a6c; });
$parcel$export(module.exports, "backgroundColorStylesMap", function () { return $75f9b30006f50ff0$export$e7af83bafe7f9e63; });
$parcel$export(module.exports, "surfaceColorStylesMap", function () { return $75f9b30006f50ff0$export$ff257d957d48c421; });
$parcel$export(module.exports, "isSurfaceColorToken", function () { return $75f9b30006f50ff0$export$5e65a44e5b6ecadb; });

var $jjExS = parcelRequire("jjExS");

var $fBy54 = parcelRequire("fBy54");

var $c8ZjH = parcelRequire("c8ZjH");
var $75f9b30006f50ff0$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $75f9b30006f50ff0$export$1f52408f03b1c9b4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $75f9b30006f50ff0$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $75f9b30006f50ff0$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $75f9b30006f50ff0$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $75f9b30006f50ff0$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $75f9b30006f50ff0$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $75f9b30006f50ff0$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)"
};
var $75f9b30006f50ff0$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $75f9b30006f50ff0$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $75f9b30006f50ff0$export$b5f31a7e431d2eab = {
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $75f9b30006f50ff0$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $75f9b30006f50ff0$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $75f9b30006f50ff0$export$6cc560b4dedf3816 = {
    "font.size.050": "var(--ds-font-size-050, 11px)",
    "font.size.075": "var(--ds-font-size-075, 12px)",
    "font.size.100": "var(--ds-font-size-100, 14px)",
    "font.size.200": "var(--ds-font-size-200, 16px)",
    "font.size.300": "var(--ds-font-size-300, 20px)",
    "font.size.400": "var(--ds-font-size-400, 24px)",
    "font.size.500": "var(--ds-font-size-500, 29px)",
    "font.size.600": "var(--ds-font-size-600, 35px)"
};
var $75f9b30006f50ff0$export$303e322c6b1ed114 = {
    "font.weight.bold": "var(--ds-font-weight-bold, 700)",
    "font.weight.medium": "var(--ds-font-weight-medium, 500)",
    "font.weight.regular": "var(--ds-font-weight-regular, 400)",
    "font.weight.semibold": "var(--ds-font-weight-semibold, 600)"
};
var $75f9b30006f50ff0$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, ui-sans-serif, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand": "var(--ds-font-family-brand, Charlie Sans)",
    "font.family.code": 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, ui-sans-serif, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.monospace": 'var(--ds-font-family-monospace, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.sans": 'var(--ds-font-family-sans, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif)'
};
var $75f9b30006f50ff0$export$360c29a380c1a34 = {
    "font.lineHeight.1": "var(--ds-font-lineHeight-1, 1)",
    "font.lineHeight.100": "var(--ds-font-lineHeight-100, 16px)",
    "font.lineHeight.200": "var(--ds-font-lineHeight-200, 20px)",
    "font.lineHeight.300": "var(--ds-font-lineHeight-300, 24px)",
    "font.lineHeight.400": "var(--ds-font-lineHeight-400, 28px)",
    "font.lineHeight.500": "var(--ds-font-lineHeight-500, 32px)",
    "font.lineHeight.600": "var(--ds-font-lineHeight-600, 40px)"
};
var $75f9b30006f50ff0$export$b5bac06d7d8fd0d1 = {
    body: "var(--ds-font-body, normal 400 14px/20px var(--ds-font-family-body))",
    "body.large": "var(--ds-font-body-large, normal 400 16px/24px var(--ds-font-family-body))",
    "body.small": "var(--ds-font-body-small, normal 400 11px/20px var(--ds-font-family-body))"
};
var $75f9b30006f50ff0$export$b27166c9cf2c9f74 = {
    ui: "var(--ds-font-ui, normal 400 14px/1 var(--ds-font-family-body))",
    "ui.small": "var(--ds-font-ui-small, normal 400 11px/1 var(--ds-font-family-body))"
};
/**
 * @codegenEnd
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $75f9b30006f50ff0$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $75f9b30006f50ff0$var$getSerializedStylesMap = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        emotionSpacingMap[token] = (0, $fBy54.css)((0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $75f9b30006f50ff0$export$e615f061ca585a6c = $75f9b30006f50ff0$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $75f9b30006f50ff0$var$getSerializedStylesMap(spacingProperty, $75f9b30006f50ff0$export$1f52408f03b1c9b4);
    return styleMap;
}, {});
var $75f9b30006f50ff0$export$bf46c3f9eeafc71f = $75f9b30006f50ff0$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $75f9b30006f50ff0$var$getSerializedStylesMap(spacingProperty, $75f9b30006f50ff0$export$1f52408f03b1c9b4);
    return styleMap;
}, {});
var $75f9b30006f50ff0$export$e7af83bafe7f9e63 = $75f9b30006f50ff0$var$getSerializedStylesMap("backgroundColor", $75f9b30006f50ff0$export$d1d79bf68ac056bd);
var $75f9b30006f50ff0$export$3a1bcba60b23d7f0 = $75f9b30006f50ff0$var$getSerializedStylesMap("color", $75f9b30006f50ff0$export$8473307aa00d6ea1);
var $75f9b30006f50ff0$export$f7183c9e2dbc2543 = $75f9b30006f50ff0$var$getSerializedStylesMap("fontSize", $75f9b30006f50ff0$export$6cc560b4dedf3816);
var $75f9b30006f50ff0$export$45f3f4fe16f9f7d5 = $75f9b30006f50ff0$var$getSerializedStylesMap("fontWeight", $75f9b30006f50ff0$export$303e322c6b1ed114);
var $75f9b30006f50ff0$export$68cc305da27dbaa4 = $75f9b30006f50ff0$var$getSerializedStylesMap("fontFamily", $75f9b30006f50ff0$export$3c7e9587132614b4);
var $75f9b30006f50ff0$export$8be4a21014f48eb1 = $75f9b30006f50ff0$var$getSerializedStylesMap("lineHeight", $75f9b30006f50ff0$export$360c29a380c1a34);
var $75f9b30006f50ff0$export$a1962444bbf058e = $75f9b30006f50ff0$var$getSerializedStylesMap("font", $75f9b30006f50ff0$export$b5bac06d7d8fd0d1);
var $75f9b30006f50ff0$export$ca3e246f24657bd6 = $75f9b30006f50ff0$var$getSerializedStylesMap("font", $75f9b30006f50ff0$export$b27166c9cf2c9f74);
var $75f9b30006f50ff0$export$ff257d957d48c421 = $75f9b30006f50ff0$var$getSerializedStylesMap((0, $c8ZjH.CURRENT_SURFACE_CSS_VAR), $75f9b30006f50ff0$export$41a358c9c2356760);
var $75f9b30006f50ff0$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $75f9b30006f50ff0$export$41a358c9c2356760[color] !== undefined;
};

});

parcelRegister("1I6VC", function(module, exports) {

$parcel$export(module.exports, "parseXcss", function () { return $13ef46560b55d700$export$a9c84988c8f81f2d; });
$parcel$export(module.exports, "xcss", function () { return $13ef46560b55d700$export$f6c783d06584602c; });

var $jjExS = parcelRequire("jjExS");

var $e6gyJ = parcelRequire("e6gyJ");

var $2nffd = parcelRequire("2nffd");

var $fBy54 = parcelRequire("fBy54");

var $a7YLX = parcelRequire("a7YLX");

var $3qWgZ = parcelRequire("3qWgZ");
var $13ef46560b55d700$var$tokensMap = {
    backgroundColor: (0, $a7YLX.backgroundColorMap),
    blockSize: (0, $a7YLX.dimensionMap),
    borderColor: (0, $a7YLX.borderColorMap),
    borderRadius: (0, $a7YLX.borderRadiusMap),
    borderWidth: (0, $a7YLX.borderWidthMap),
    bottom: (0, $a7YLX.spaceMap),
    boxShadow: (0, $a7YLX.shadowMap),
    color: (0, $a7YLX.textColorMap),
    columnGap: (0, $a7YLX.spaceMap),
    gap: (0, $a7YLX.spaceMap),
    height: (0, $a7YLX.dimensionMap),
    inlineSize: (0, $a7YLX.dimensionMap),
    inset: (0, $a7YLX.spaceMap),
    insetBlock: (0, $a7YLX.spaceMap),
    insetBlockEnd: (0, $a7YLX.spaceMap),
    insetBlockStart: (0, $a7YLX.spaceMap),
    insetInline: (0, $a7YLX.spaceMap),
    insetInlineEnd: (0, $a7YLX.spaceMap),
    insetInlineStart: (0, $a7YLX.spaceMap),
    margin: (0, $a7YLX.spaceMap),
    marginBlock: (0, $a7YLX.spaceMap),
    marginBlockEnd: (0, $a7YLX.spaceMap),
    marginBlockStart: (0, $a7YLX.spaceMap),
    marginBottom: (0, $a7YLX.spaceMap),
    marginInline: (0, $a7YLX.spaceMap),
    marginInlineEnd: (0, $a7YLX.spaceMap),
    marginInlineStart: (0, $a7YLX.spaceMap),
    marginLeft: (0, $a7YLX.spaceMap),
    marginRight: (0, $a7YLX.spaceMap),
    marginTop: (0, $a7YLX.spaceMap),
    left: (0, $a7YLX.spaceMap),
    maxBlockSize: (0, $a7YLX.dimensionMap),
    maxHeight: (0, $a7YLX.dimensionMap),
    maxInlineSize: (0, $a7YLX.dimensionMap),
    maxWidth: (0, $a7YLX.dimensionMap),
    minBlockSize: (0, $a7YLX.dimensionMap),
    minHeight: (0, $a7YLX.dimensionMap),
    minInlineSize: (0, $a7YLX.dimensionMap),
    minWidth: (0, $a7YLX.dimensionMap),
    outlineOffset: (0, $a7YLX.spaceMap),
    outlineWidth: (0, $a7YLX.borderWidthMap),
    outlineColor: (0, $a7YLX.borderColorMap),
    padding: (0, $a7YLX.spaceMap),
    paddingBlock: (0, $a7YLX.spaceMap),
    paddingBlockEnd: (0, $a7YLX.spaceMap),
    paddingBlockStart: (0, $a7YLX.spaceMap),
    paddingBottom: (0, $a7YLX.spaceMap),
    paddingInline: (0, $a7YLX.spaceMap),
    paddingInlineEnd: (0, $a7YLX.spaceMap),
    paddingInlineStart: (0, $a7YLX.spaceMap),
    paddingLeft: (0, $a7YLX.spaceMap),
    paddingRight: (0, $a7YLX.spaceMap),
    paddingTop: (0, $a7YLX.spaceMap),
    right: (0, $a7YLX.spaceMap),
    rowGap: (0, $a7YLX.spaceMap),
    top: (0, $a7YLX.spaceMap),
    width: (0, $a7YLX.dimensionMap),
    zIndex: (0, $a7YLX.layerMap)
};
var $13ef46560b55d700$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $13ef46560b55d700$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $3qWgZ === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($2nffd)))($3qWgZ)) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($2nffd)))($3qWgZ.env) === "object" && false;
};
var $13ef46560b55d700$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $13ef46560b55d700$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $13ef46560b55d700$var$transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($2nffd)))(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map(transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($e6gyJ)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($2nffd)))(value) === "object" && $13ef46560b55d700$var$safeSelectors.test(key)) {
            styleObj[key] = transformStyles(value);
            return;
        }
        if ($13ef46560b55d700$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($13ef46560b55d700$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $13ef46560b55d700$var$tokensMap)) return;
        var tokenValue = $13ef46560b55d700$var$tokensMap[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $13ef46560b55d700$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $13ef46560b55d700$var$transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))({}, $13ef46560b55d700$var$uniqueSymbol, (0, $fBy54.css)(transformedStyles));
};
var $13ef46560b55d700$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) return args.map(function(x) {
        return x && parseXcss(x);
    }).filter(Boolean);
    var styles = args[$13ef46560b55d700$var$uniqueSymbol];
    typeof $3qWgZ === "undefined" || (0, (/*@__PURE__*/$parcel$interopDefault($2nffd)))($3qWgZ);
    return styles;
};
function $13ef46560b55d700$export$f6c783d06584602c(style) {
    return $13ef46560b55d700$var$baseXcss(style);
}

});

parcelRegister("1DWwN", function(module, exports) {

$parcel$export(module.exports, "SurfaceContext", function () { return $1326d56479c43017$export$1ca2a26fecb070ae; });

var $1Mpn7 = parcelRequire("1Mpn7");
var $1326d56479c43017$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $1Mpn7.createContext)("elevation.surface");
var $1326d56479c43017$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $1Mpn7.useContext)($1326d56479c43017$export$1ca2a26fecb070ae);
};
$1326d56479c43017$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";

});



parcelRegister("dFCZz", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_NAME_BY_KEY", function () { return $9f3d59b5062c6427$export$ef33e2e29ace062a; });
$parcel$export(module.exports, "PRODUCT_ICON_BY_KEY", function () { return $9f3d59b5062c6427$export$83c44a239ff713de; });

var $3sHb8 = parcelRequire("3sHb8");

var $iSwre = parcelRequire("iSwre");
var $iDcqq = parcelRequire("iDcqq");
var $aYoHs = parcelRequire("aYoHs");
var $eESCE = parcelRequire("eESCE");
var $210Ck = parcelRequire("210Ck");
var $9f3d59b5062c6427$var$JSW_KEY = "jira-software.ondemand";
var $9f3d59b5062c6427$var$JSM_KEY = "jira-servicedesk.ondemand";
var $9f3d59b5062c6427$var$JWM_KEY = "jira-core.ondemand";
var $9f3d59b5062c6427$var$JPD_KEY = "jira-product-discovery";
var $9f3d59b5062c6427$var$CONFLUENCE_KEY = "confluence.ondemand";
var $9f3d59b5062c6427$var$_obj;
var $9f3d59b5062c6427$export$ef33e2e29ace062a = ($9f3d59b5062c6427$var$_obj = {}, (0, $3sHb8._)($9f3d59b5062c6427$var$_obj, $9f3d59b5062c6427$var$JSW_KEY, "Jira Software"), (0, $3sHb8._)($9f3d59b5062c6427$var$_obj, $9f3d59b5062c6427$var$JSM_KEY, "Jira Service Management"), (0, $3sHb8._)($9f3d59b5062c6427$var$_obj, $9f3d59b5062c6427$var$JWM_KEY, "Jira Work Management"), (0, $3sHb8._)($9f3d59b5062c6427$var$_obj, $9f3d59b5062c6427$var$JPD_KEY, "Jira Product Discovery"), (0, $3sHb8._)($9f3d59b5062c6427$var$_obj, $9f3d59b5062c6427$var$CONFLUENCE_KEY, "Confluence"), $9f3d59b5062c6427$var$_obj);
var $9f3d59b5062c6427$var$_obj1;
var $9f3d59b5062c6427$export$83c44a239ff713de = ($9f3d59b5062c6427$var$_obj1 = {}, (0, $3sHb8._)($9f3d59b5062c6427$var$_obj1, $9f3d59b5062c6427$var$JSW_KEY, (0, $eESCE.JiraSoftwareIcon)), (0, $3sHb8._)($9f3d59b5062c6427$var$_obj1, $9f3d59b5062c6427$var$JSM_KEY, (0, $aYoHs.JiraServiceManagementIcon)), (0, $3sHb8._)($9f3d59b5062c6427$var$_obj1, $9f3d59b5062c6427$var$JWM_KEY, (0, $210Ck.JiraWorkManagementIcon)), (0, $3sHb8._)($9f3d59b5062c6427$var$_obj1, $9f3d59b5062c6427$var$JPD_KEY, (0, $iDcqq.JiraProductDiscoveryIcon)), (0, $3sHb8._)($9f3d59b5062c6427$var$_obj1, $9f3d59b5062c6427$var$CONFLUENCE_KEY, (0, $iSwre.ConfluenceIcon)), $9f3d59b5062c6427$var$_obj1);

});
parcelRegister("iSwre", function(module, exports) {

$parcel$export(module.exports, "ConfluenceIcon", function () { return $dbe66eb59f142d3b$export$68f3db7f6af48bcb; });
/* eslint-disable max-len */ 
var $1Mpn7 = parcelRequire("1Mpn7");

var $cuQ94 = parcelRequire("cuQ94");

var $8vPVi = parcelRequire("8vPVi");

var $bpDjz = parcelRequire("bpDjz");

var $esDFv = parcelRequire("esDFv");
var $dbe66eb59f142d3b$var$svg = function svg(_ref) {
    var appearance = _ref.appearance, iconGradientStart = _ref.iconGradientStart, iconGradientStop = _ref.iconGradientStop, iconColor = _ref.iconColor;
    var colors = {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor
    };
    // Will be fixed upon removal of deprecated iconGradientStart and
    // iconGradientStop props, or with React 18's useId() hook when we update.
    // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    var id = (0, $cuQ94.uid)({
        iconGradientStart: iconGradientStop
    });
    if (appearance) colors = (0, $bpDjz.getColorsFromAppearance)(appearance);
    return '\n  <svg viewBox="0 0 32 32" height="32" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true">\n    <defs>\n      <linearGradient x1="60.6779047%" y1="137.626433%" x2="14.341981%" y2="112.08042%" id="'.concat(id, '-1">\n        <stop stop-color="').concat(colors.iconGradientStart, '" ').concat(colors.iconGradientStart === "inherit" ? 'stop-opacity="0.4"' : "", ' offset="0%"></stop>\n        <stop stop-color="').concat(colors.iconGradientStop, '" offset="100%"></stop>\n      </linearGradient>\n      <linearGradient x1="12.3282701%" y1="-53.9760846%" x2="74.1300776%" y2="-33.2553066%" id="').concat(id, '-2">\n        <stop stop-color="').concat(colors.iconGradientStart, '" ').concat(colors.iconGradientStart === "inherit" ? 'stop-opacity="0.4"' : "", ' offset="0%"></stop>\n        <stop stop-color="').concat(colors.iconGradientStop, '" offset="100%"></stop>\n      </linearGradient>\n    </defs>\n    <g stroke="none" stroke-width="1" fill-rule="nonzero">\n      <path fill="url(#').concat(id, '-1)" d="M5.21454927,22.0245336 C4.97082816,22.4219865 4.69711061,22.8831818 4.46463817,23.2506383 C4.25655728,23.602269 4.36826343,24.0557627 4.71585838,24.2705174 L9.59028054,27.2701618 C9.76138278,27.3758032 9.96774369,27.4083016 10.1630326,27.3603607 C10.3583215,27.3124197 10.5261749,27.1880564 10.6289074,27.015192 C10.8238843,26.6889807 11.0751045,26.2652809 11.3488221,25.8115847 C13.2798432,22.6244625 15.2221129,23.0144163 18.7241978,24.686718 L23.5573748,26.9851956 C23.7404243,27.0723219 23.9509502,27.0816253 24.1409716,27.0109854 C24.3309931,26.9403455 24.4843191,26.7957811 24.5660052,26.61024 L26.8869801,21.3608623 C27.0509607,20.9859459 26.8841076,20.5487907 26.5120245,20.3784788 C25.4921454,19.8985357 23.4636359,18.942399 21.6376024,18.0612535 C15.0683811,14.8741313 9.48529299,15.0841064 5.21454927,22.0245336 Z"></path>\n      <path fill="url(#').concat(id, '-2)" d="M27.0752616,9.74267061 C27.3190367,9.34512979 27.5928148,8.88383241 27.8253387,8.51629467 C28.0334656,8.1645861 27.9217347,7.71099215 27.5740629,7.4961899 L22.6985622,4.49588177 C22.5250856,4.3802891 22.3113292,4.3421035 22.1085604,4.39048341 C21.9057917,4.43886333 21.7323024,4.56944439 21.6297024,4.75090796 C21.4346824,5.07719147 21.1834066,5.50098499 20.9096284,5.9547816 C18.9781801,9.14260899 17.0354806,8.75256893 13.5326208,7.07989715 L8.71337588,4.78466143 C8.53028584,4.69751579 8.31971336,4.68821035 8.1296499,4.75886591 C7.93958645,4.82952147 7.78622651,4.97411777 7.70452227,5.15969994 L5.38303386,10.4102392 C5.21901692,10.7852385 5.38590698,11.2224905 5.75807237,11.3928401 C6.77817714,11.8728894 8.80713551,12.8292376 10.6335731,13.7105781 C17.2192494,16.8946551 22.8035729,16.6846336 27.0752616,9.74267061 Z"></path>\n    </g>\n  </svg>');
};
var $dbe66eb59f142d3b$export$68f3db7f6af48bcb = function ConfluenceIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Confluence" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8vPVi.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8vPVi.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$iconGradientSta = _ref2.iconGradientStart, iconGradientStart = _ref2$iconGradientSta === void 0 ? (0, $8vPVi.defaultLogoParams).iconGradientStart : _ref2$iconGradientSta, _ref2$iconGradientSto = _ref2.iconGradientStop, iconGradientStop = _ref2$iconGradientSto === void 0 ? (0, $8vPVi.defaultLogoParams).iconGradientStop : _ref2$iconGradientSto, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8vPVi.defaultLogoParams).textColor : _ref2$textColor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $esDFv.default), {
        appearance: appearance,
        label: label,
        svg: $dbe66eb59f142d3b$var$svg({
            appearance: appearance,
            iconGradientStart: iconGradientStart,
            iconGradientStop: iconGradientStop,
            iconColor: iconColor
        }),
        iconColor: iconColor,
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});
parcelRegister("cuQ94", function(module, exports) {

$parcel$export(module.exports, "generateUID", function () { return $9190bc5b70d3e18e$export$bdbb4cbb3078e58d; });
$parcel$export(module.exports, "uid", function () { return $9190bc5b70d3e18e$export$e2a22331486dcca0; });
/**
 * generates a UID factory
 * @internal
 * @example
 * const uid = generateUID();
 * uid(object) = 1;
 * uid(object) = 1;
 * uid(anotherObject) = 2;
 */ var $9190bc5b70d3e18e$export$bdbb4cbb3078e58d = function generateUID() {
    var counter = 1;
    var map = new WeakMap();
    /**
     * @borrows {uid}
     */ var uid = function uid1(item, index) {
        if (typeof item === "number" || typeof item === "string") return index ? "idx-".concat(index) : "val-".concat(item);
        if (!map.has(item)) {
            map.set(item, counter++);
            return uid(item);
        }
        return "uid" + map.get(item);
    };
    return uid;
};
var $9190bc5b70d3e18e$export$e2a22331486dcca0 = $9190bc5b70d3e18e$export$bdbb4cbb3078e58d();

});

parcelRegister("8vPVi", function(module, exports) {

$parcel$export(module.exports, "defaultLogoParams", function () { return $63297ed544fa04cc$export$438460117ae6b7ee; });
$parcel$export(module.exports, "sizes", function () { return $63297ed544fa04cc$export$c647cb0ee6e282fe; });
/**
 * These are the default parameters for LogoProps if the user does not specify values.
 */ var $63297ed544fa04cc$export$438460117ae6b7ee = {
    iconColor: "inherit",
    iconGradientStart: "inherit",
    iconGradientStop: "inherit",
    label: "",
    size: "medium",
    textColor: "currentColor"
};
var $63297ed544fa04cc$export$c647cb0ee6e282fe = {
    xsmall: 16,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 48
};
var $63297ed544fa04cc$export$31d7044b7540a6d8 = $63297ed544fa04cc$export$438460117ae6b7ee;

});

parcelRegister("bpDjz", function(module, exports) {

$parcel$export(module.exports, "getColorsFromAppearance", function () { return $84f0869583d692be$export$bbacc3980e0f3029; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $7UyAl = parcelRequire("7UyAl");
var $84f0869583d692be$export$bbacc3980e0f3029 = function getColorsFromAppearance(appearance) {
    var iconGradientStart, iconGradientStop, iconColor, textColor, atlassianLogoTextColor;
    switch(appearance){
        case "brand":
            iconGradientStart = (0, $7UyAl.B400);
            iconGradientStop = (0, $7UyAl.B200);
            iconColor = (0, $7UyAl.B200);
            textColor = "var(--ds-text, ".concat((0, $7UyAl.N800), ")");
            // This is only used for the top level Atlassian wordmark (see AtlassianLogo
            // or AtlassianStartLogo for example), and is only different for the Brand
            // appearance - a bold brand color. For other appearances,
            // atlassianLogoTextColor is the same as textColor.
            atlassianLogoTextColor = (0, $7UyAl.B400);
            break;
        case "neutral":
            iconGradientStart = (0, $7UyAl.N600);
            iconGradientStop = (0, $7UyAl.N100);
            iconColor = (0, $7UyAl.N100);
            textColor = (0, $7UyAl.N400);
            atlassianLogoTextColor = (0, $7UyAl.N400);
            break;
        case "inverse":
            iconGradientStart = (0, $7UyAl.N50);
            iconGradientStop = (0, $7UyAl.N0);
            iconColor = (0, $7UyAl.N0);
            textColor = "var(--ds-text-inverse, ".concat((0, $7UyAl.N0), ")");
            atlassianLogoTextColor = "var(--ds-text-inverse, ".concat((0, $7UyAl.N0), ")");
            break;
    }
    return {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};

});
parcelRegister("7UyAl", function(module, exports) {

$parcel$export(module.exports, "B200", function () { return $5c2897403046fbf4$export$215b7063051591f1; });
$parcel$export(module.exports, "B400", function () { return $5c2897403046fbf4$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "N0", function () { return $5c2897403046fbf4$export$29a4f05edc054374; });
$parcel$export(module.exports, "N50", function () { return $5c2897403046fbf4$export$8754fc7e6d8b3000; });
$parcel$export(module.exports, "N100", function () { return $5c2897403046fbf4$export$d6447c357493214f; });
$parcel$export(module.exports, "N400", function () { return $5c2897403046fbf4$export$eece5f492e429f08; });
$parcel$export(module.exports, "N600", function () { return $5c2897403046fbf4$export$7090862dc3038a9f; });
$parcel$export(module.exports, "N800", function () { return $5c2897403046fbf4$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N30A", function () { return $5c2897403046fbf4$export$920c0d5c49070351; });
$parcel$export(module.exports, "skeleton", function () { return $5c2897403046fbf4$export$2a0674ff2eb10214; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $8Tjf6 = parcelRequire("8Tjf6");
var $5c2897403046fbf4$export$4b84fd0e2c617bd = "#FFEBE6";
var $5c2897403046fbf4$export$b34b069eff244586 = "#FFBDAD";
var $5c2897403046fbf4$export$be802dd0d8b57f35 = "#FF8F73";
var $5c2897403046fbf4$export$60847d42f9da92a6 = "#FF7452";
var $5c2897403046fbf4$export$4a7404f376229999 = "#FF5630";
var $5c2897403046fbf4$export$2010d0fb4295b346 = "#DE350B";
var $5c2897403046fbf4$export$2837b5a1a71d5c02 = "#BF2600";
var $5c2897403046fbf4$export$8d9596b529bbb9cf = "#FFFAE6";
var $5c2897403046fbf4$export$41060a744ab0b7ae = "#FFF0B3";
var $5c2897403046fbf4$export$1cc05bbbf340e559 = "#FFE380";
var $5c2897403046fbf4$export$5aae31392d72caaa = "#FFC400";
var $5c2897403046fbf4$export$c6930421db9fa514 = "#FFAB00";
var $5c2897403046fbf4$export$59619663aa6500fb = "#FF991F";
var $5c2897403046fbf4$export$874739ea9e379ab6 = "#FF8B00";
var $5c2897403046fbf4$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $5c2897403046fbf4$export$69a3bf21b9686c2b = "#ABF5D1";
var $5c2897403046fbf4$export$afbce1382ec95f73 = "#79F2C0";
var $5c2897403046fbf4$export$747d86715d4175de = "#57D9A3";
var $5c2897403046fbf4$export$940e1f69e873f202 = "#36B37E";
var $5c2897403046fbf4$export$a49394138f7b8e85 = "#00875A";
var $5c2897403046fbf4$export$6fa04827ac68a4fb = "#006644";
var $5c2897403046fbf4$export$226de0355ed012f8 = "#DEEBFF";
var $5c2897403046fbf4$export$8c13c2ee36917869 = "#B3D4FF";
var $5c2897403046fbf4$export$ecfc1dff386a3e7a = "#4C9AFF";
var $5c2897403046fbf4$export$215b7063051591f1 = "#2684FF";
var $5c2897403046fbf4$export$e62e8919cca44969 = "#0065FF";
var $5c2897403046fbf4$export$b3de0ae08da2ce64 = "#0052CC";
var $5c2897403046fbf4$export$a6ee3d71bc067634 = "#0747A6";
var $5c2897403046fbf4$export$363e4475840015bb = "#EAE6FF";
var $5c2897403046fbf4$export$4b0a4417ed59760f = "#C0B6F2";
var $5c2897403046fbf4$export$6011520a64d9a187 = "#998DD9";
var $5c2897403046fbf4$export$a7175d4e9206bc80 = "#8777D9";
var $5c2897403046fbf4$export$b48405b95304b5a1 = "#6554C0";
var $5c2897403046fbf4$export$c71e4279dd54a18d = "#5243AA";
var $5c2897403046fbf4$export$147899de772240ec = "#403294";
var $5c2897403046fbf4$export$2cf711fe14c66f06 = "#E6FCFF";
var $5c2897403046fbf4$export$7a8f4d33f6f9772c = "#B3F5FF";
var $5c2897403046fbf4$export$776c9c497ef08533 = "#79E2F2";
var $5c2897403046fbf4$export$69cb3ca10c1e330e = "#00C7E6";
var $5c2897403046fbf4$export$9dc1ef0f3f48059b = "#00B8D9";
var $5c2897403046fbf4$export$7c835c78b6fcdef8 = "#00A3BF";
var $5c2897403046fbf4$export$6036577f95c3877e = "#008DA6";
var $5c2897403046fbf4$export$29a4f05edc054374 = "#FFFFFF";
var $5c2897403046fbf4$export$e655ef011c4aa1a2 = "#FAFBFC";
var $5c2897403046fbf4$export$9fdfb749e33cdf97 = "#F4F5F7";
var $5c2897403046fbf4$export$3e51e8f1440314ba = "#EBECF0";
var $5c2897403046fbf4$export$1ce2d1575d444ceb = "#DFE1E6";
var $5c2897403046fbf4$export$8754fc7e6d8b3000 = "#C1C7D0";
var $5c2897403046fbf4$export$c2e91cbeada39b8b = "#B3BAC5";
var $5c2897403046fbf4$export$5f71e19f3a7ad9de = "#A5ADBA";
var $5c2897403046fbf4$export$eaa8c8a70ac22806 = "#97A0AF";
var $5c2897403046fbf4$export$7c87d337fb91a97d = "#8993A4";
var $5c2897403046fbf4$export$d6447c357493214f = "#7A869A";
var $5c2897403046fbf4$export$f563ee71e9ee74cd = "#6B778C";
var $5c2897403046fbf4$export$e2ef2124cf4024b1 = "#5E6C84";
var $5c2897403046fbf4$export$eece5f492e429f08 = "#505F79";
var $5c2897403046fbf4$export$c39c0fe0f26207ae = "#42526E";
var $5c2897403046fbf4$export$7090862dc3038a9f = "#344563";
var $5c2897403046fbf4$export$ad0bacf983b7ddaa = "#253858";
var $5c2897403046fbf4$export$7d61b15e0da132af = "#172B4D";
var $5c2897403046fbf4$export$fbda843f0a27fe96 = "#091E42";
var $5c2897403046fbf4$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $5c2897403046fbf4$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $5c2897403046fbf4$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $5c2897403046fbf4$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $5c2897403046fbf4$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $5c2897403046fbf4$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $5c2897403046fbf4$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $5c2897403046fbf4$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $5c2897403046fbf4$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $5c2897403046fbf4$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $5c2897403046fbf4$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $5c2897403046fbf4$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $5c2897403046fbf4$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $5c2897403046fbf4$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $5c2897403046fbf4$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $5c2897403046fbf4$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $5c2897403046fbf4$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $5c2897403046fbf4$export$2f6319cf7d736c2a = "#E6EDFA";
var $5c2897403046fbf4$export$95126bc8884d6634 = "#DCE5F5";
var $5c2897403046fbf4$export$8338d8c35d44ff1 = "#CED9EB";
var $5c2897403046fbf4$export$5368d76ae4fbbda7 = "#B8C7E0";
var $5c2897403046fbf4$export$9f0a771d16ec8d36 = "#ABBBD6";
var $5c2897403046fbf4$export$abcf8c38338b4aa5 = "#9FB0CC";
var $5c2897403046fbf4$export$97e81faa16a182c7 = "#8C9CB8";
var $5c2897403046fbf4$export$bfe21c59123ecf33 = "#7988A3";
var $5c2897403046fbf4$export$ee82aa2ea6a1558 = "#67758F";
var $5c2897403046fbf4$export$682927c6ed76be02 = "#56637A";
var $5c2897403046fbf4$export$91fd9994c5be9757 = "#455166";
var $5c2897403046fbf4$export$d281fbfe3cff2df6 = "#3B475C";
var $5c2897403046fbf4$export$3902c91d8b98a753 = "#313D52";
var $5c2897403046fbf4$export$8e8133c1ba5845b5 = "#283447";
var $5c2897403046fbf4$export$33ff357f6620b39 = "#202B3D";
var $5c2897403046fbf4$export$633847cf062b69e0 = "#1B2638";
var $5c2897403046fbf4$export$9776a6e503bdbf76 = "#121A29";
var $5c2897403046fbf4$export$6c813d5160dff5db = "#0E1624";
var $5c2897403046fbf4$export$3d4f271a500072a = "#0D1424";
var $5c2897403046fbf4$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $5c2897403046fbf4$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $5c2897403046fbf4$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $5c2897403046fbf4$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $5c2897403046fbf4$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $5c2897403046fbf4$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $5c2897403046fbf4$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $5c2897403046fbf4$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $5c2897403046fbf4$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $5c2897403046fbf4$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $5c2897403046fbf4$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $5c2897403046fbf4$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $5c2897403046fbf4$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $5c2897403046fbf4$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $5c2897403046fbf4$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $5c2897403046fbf4$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $5c2897403046fbf4$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $5c2897403046fbf4$export$8ce1fd94bee2f412 = (0, $8Tjf6.default)({
    light: "var(--ds-surface, ".concat($5c2897403046fbf4$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface, ".concat($5c2897403046fbf4$export$633847cf062b69e0, ")")
});
var $5c2897403046fbf4$export$b861914ea877b580 = (0, $8Tjf6.default)({
    light: "var(--ds-background-selected, ".concat($5c2897403046fbf4$export$226de0355ed012f8, ")"),
    dark: "var(--ds-background-selected, ".concat($5c2897403046fbf4$export$8c13c2ee36917869, ")")
});
var $5c2897403046fbf4$export$3f1b020df94387af = (0, $8Tjf6.default)({
    light: "var(--ds-background-neutral-hovered, ".concat($5c2897403046fbf4$export$3e51e8f1440314ba, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat($5c2897403046fbf4$export$d281fbfe3cff2df6, ")")
});
var $5c2897403046fbf4$export$c0183dbab98ca63e = (0, $8Tjf6.default)({
    light: "var(--ds-surface-overlay, ".concat($5c2897403046fbf4$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface-overlay, ".concat($5c2897403046fbf4$export$8e8133c1ba5845b5, ")")
});
var $5c2897403046fbf4$export$6f093cfa640b7166 = (0, $8Tjf6.default)({
    light: "var(--ds-text, ".concat($5c2897403046fbf4$export$fbda843f0a27fe96, ")"),
    dark: "var(--ds-text, ".concat($5c2897403046fbf4$export$5368d76ae4fbbda7, ")")
});
var $5c2897403046fbf4$export$42f8e9c698766e7a = (0, $8Tjf6.default)({
    light: "var(--ds-text, ".concat($5c2897403046fbf4$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($5c2897403046fbf4$export$5368d76ae4fbbda7, ")")
});
var $5c2897403046fbf4$export$c2d157ca1c34b6e3 = (0, $8Tjf6.default)({
    light: "var(--ds-text-selected, ".concat($5c2897403046fbf4$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-text-selected, ".concat($5c2897403046fbf4$export$b3de0ae08da2ce64, ")")
});
var $5c2897403046fbf4$export$1905ba28d7cf066f = (0, $8Tjf6.default)({
    light: "var(--ds-text-subtlest, ".concat($5c2897403046fbf4$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($5c2897403046fbf4$export$97e81faa16a182c7, ")")
});
var $5c2897403046fbf4$export$bd9002130d306d39 = (0, $8Tjf6.default)({
    light: "var(--ds-text-subtlest, ".concat($5c2897403046fbf4$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($5c2897403046fbf4$export$bfe21c59123ecf33, ")")
});
var $5c2897403046fbf4$export$46e4a324ac90507f = (0, $8Tjf6.default)({
    light: "var(--ds-text, ".concat($5c2897403046fbf4$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($5c2897403046fbf4$export$5368d76ae4fbbda7, ")")
});
var $5c2897403046fbf4$export$79f3f2b82beb0d36 = (0, $8Tjf6.default)({
    light: "var(--ds-text-subtlest, ".concat($5c2897403046fbf4$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($5c2897403046fbf4$export$97e81faa16a182c7, ")")
});
var $5c2897403046fbf4$export$7bb0d5c671655cc4 = (0, $8Tjf6.default)({
    light: $5c2897403046fbf4$export$9fdfb749e33cdf97,
    dark: $5c2897403046fbf4$export$8e8133c1ba5845b5
});
var $5c2897403046fbf4$export$9c30223ca0a664fb = (0, $8Tjf6.default)({
    light: "var(--ds-link, ".concat($5c2897403046fbf4$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-link, ".concat($5c2897403046fbf4$export$ecfc1dff386a3e7a, ")")
});
var $5c2897403046fbf4$export$7ed258b0728b004b = (0, $8Tjf6.default)({
    light: "var(--ds-link-pressed, ".concat($5c2897403046fbf4$export$e62e8919cca44969, ")"),
    dark: "var(--ds-link-pressed, ".concat($5c2897403046fbf4$export$215b7063051591f1, ")")
});
var $5c2897403046fbf4$export$dfa920d8decc8a59 = (0, $8Tjf6.default)({
    light: "var(--ds-link-pressed, ".concat($5c2897403046fbf4$export$a6ee3d71bc067634, ")"),
    dark: "var(--ds-link-pressed, ".concat($5c2897403046fbf4$export$ecfc1dff386a3e7a, ")")
});
var $5c2897403046fbf4$export$6069e6ad5c78f632 = (0, $8Tjf6.default)({
    light: "var(--ds-border-focused, ".concat($5c2897403046fbf4$export$215b7063051591f1, ")"),
    dark: "var(--ds-border-focused, ".concat($5c2897403046fbf4$export$215b7063051591f1, ")")
});
var $5c2897403046fbf4$export$9ad721cf3b3debe0 = (0, $8Tjf6.default)({
    light: "var(--ds-background-brand-bold, ".concat($5c2897403046fbf4$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-background-brand-bold, ".concat($5c2897403046fbf4$export$ecfc1dff386a3e7a, ")")
});
var $5c2897403046fbf4$export$2aa0182783e7e9de = (0, $8Tjf6.default)({
    light: $5c2897403046fbf4$export$b3de0ae08da2ce64,
    dark: $5c2897403046fbf4$export$ecfc1dff386a3e7a
});
var $5c2897403046fbf4$export$8bf7dff220b82b4a = (0, $8Tjf6.default)({
    light: $5c2897403046fbf4$export$9dc1ef0f3f48059b,
    dark: $5c2897403046fbf4$export$69cb3ca10c1e330e
});
var $5c2897403046fbf4$export$e13cce2a2d16a9d4 = (0, $8Tjf6.default)({
    light: $5c2897403046fbf4$export$b48405b95304b5a1,
    dark: $5c2897403046fbf4$export$6011520a64d9a187
});
var $5c2897403046fbf4$export$a90204d1394caf30 = (0, $8Tjf6.default)({
    light: $5c2897403046fbf4$export$4a7404f376229999,
    dark: $5c2897403046fbf4$export$4a7404f376229999
});
var $5c2897403046fbf4$export$594c5a8758200c32 = (0, $8Tjf6.default)({
    light: $5c2897403046fbf4$export$c6930421db9fa514,
    dark: $5c2897403046fbf4$export$c6930421db9fa514
});
var $5c2897403046fbf4$export$955a2ebd2fb142ae = (0, $8Tjf6.default)({
    light: $5c2897403046fbf4$export$940e1f69e873f202,
    dark: $5c2897403046fbf4$export$940e1f69e873f202
});
var $5c2897403046fbf4$export$2a0674ff2eb10214 = function skeleton() {
    return "var(--ds-skeleton, ".concat($5c2897403046fbf4$export$8d43898f60b96a82, ")");
};

});
parcelRegister("8Tjf6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $679262f436e04e2a$export$2e2bcd8739ae039; });
/* eslint-disable prefer-rest-params */ 
var $eQrdU = parcelRequire("eQrdU");
// Unpack custom variants, and get correct value for the current theme
function $679262f436e04e2a$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $eQrdU.default)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return "";
    };
}
function $679262f436e04e2a$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === "string") return $679262f436e04e2a$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $eQrdU.default)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return "";
    };
}

});
parcelRegister("eQrdU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aceb09fc60452fb6$export$2e2bcd8739ae039; });

var $akv62 = parcelRequire("akv62");
function $aceb09fc60452fb6$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $akv62.CHANNEL) in props.theme) return props.theme[0, $akv62.CHANNEL];
        else if ("mode" in props.theme && (0, $akv62.THEME_MODES).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $akv62.DEFAULT_THEME_MODE)
    };
}

});
parcelRegister("akv62", function(module, exports) {

$parcel$export(module.exports, "CHANNEL", function () { return $7853e4bbed3fe107$export$44ffba16bd48dac6; });
$parcel$export(module.exports, "DEFAULT_THEME_MODE", function () { return $7853e4bbed3fe107$export$c93026a968943f95; });
$parcel$export(module.exports, "THEME_MODES", function () { return $7853e4bbed3fe107$export$6ba72c8346b4c57e; });

var $2Eqc7 = parcelRequire("2Eqc7");

var $7UyAl = parcelRequire("7UyAl");
var $7853e4bbed3fe107$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $7853e4bbed3fe107$export$c93026a968943f95 = "light";
var $7853e4bbed3fe107$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $7853e4bbed3fe107$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $7853e4bbed3fe107$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $7853e4bbed3fe107$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $7853e4bbed3fe107$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $7853e4bbed3fe107$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $7853e4bbed3fe107$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $7853e4bbed3fe107$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $7UyAl.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $7853e4bbed3fe107$export$6d8204c2cb2e06b8() / 4;
    (0, $2Eqc7.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $7853e4bbed3fe107$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $7853e4bbed3fe107$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $7853e4bbed3fe107$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $2Eqc7.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $7853e4bbed3fe107$export$ba1d834b86d72a09 = $7853e4bbed3fe107$export$a1b3edb637fb4f35;
var $7853e4bbed3fe107$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $7UyAl.skeleton)(), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $7UyAl.skeleton)(), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $7UyAl.N30A), ")")
            }
        }
    };
};

});





parcelRegister("esDFv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8727384f24fb2c7$export$2e2bcd8739ae039; });

var $fjkYW = parcelRequire("fjkYW");

var $jjExS = parcelRequire("jjExS");

var $04Kcc = parcelRequire("04Kcc");

var $e6gyJ = parcelRequire("e6gyJ");

var $fBy54 = parcelRequire("fBy54");

var $8vPVi = parcelRequire("8vPVi");
var $a8727384f24fb2c7$var$_excluded = [
    "label",
    "svg",
    "size",
    "appearance",
    "iconGradientStart",
    "iconGradientStop",
    "iconColor",
    "textColor",
    "testId"
];
var $a8727384f24fb2c7$var$CSS_VAR_COLOR = "--logo-color";
var $a8727384f24fb2c7$var$CSS_VAR_FILL = "--logo-fill";
var $a8727384f24fb2c7$var$baseWrapperStyles = (0, $fBy54.css)({
    display: "inline-block",
    position: "relative",
    color: "var(".concat($a8727384f24fb2c7$var$CSS_VAR_COLOR, ")"),
    fill: "var(".concat($a8727384f24fb2c7$var$CSS_VAR_FILL, ")"),
    lineHeight: 1,
    userSelect: "none",
    whiteSpace: "normal",
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "> svg": {
        height: "100%",
        fill: "inherit"
    }
});
var $a8727384f24fb2c7$var$stopColorStyles = (0, $fBy54.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    stop: {
        stopColor: "currentColor"
    }
});
var $a8727384f24fb2c7$var$sizeStyles = Object.entries((0, $8vPVi.sizes)).reduce(function(acc, _ref) {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($e6gyJ)))(_ref, 2), key = _ref2[0], val = _ref2[1];
    acc[key] = (0, $fBy54.css)({
        height: "".concat(val, "px")
    });
    return acc;
}, {});
/**
 * __Wrapper__
 *
 * An internal component used by `@atlaskit/logo` to render logo SVGs with correct styles.
 */ var $a8727384f24fb2c7$var$Wrapper = function Wrapper(_ref3) {
    var _ref4;
    var label = _ref3.label, svg = _ref3.svg, size = _ref3.size, appearance = _ref3.appearance, iconGradientStart = _ref3.iconGradientStart, iconGradientStop = _ref3.iconGradientStop, iconColor = _ref3.iconColor, textColor = _ref3.textColor, userDefinedTestId = _ref3.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($04Kcc)))(_ref3, $a8727384f24fb2c7$var$_excluded);
    var shouldApplyStopColor = iconGradientStart === "inherit" && iconGradientStop === "inherit" && appearance === undefined;
    var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
    return (0, $fBy54.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($fjkYW)))({
        css: [
            $a8727384f24fb2c7$var$baseWrapperStyles,
            shouldApplyStopColor && $a8727384f24fb2c7$var$stopColorStyles,
            size && $a8727384f24fb2c7$var$sizeStyles[size]
        ],
        "data-testid": testId,
        style: (_ref4 = {}, (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(_ref4, $a8727384f24fb2c7$var$CSS_VAR_COLOR, iconColor), (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(_ref4, $a8727384f24fb2c7$var$CSS_VAR_FILL, textColor), _ref4),
        "aria-label": label ? label : undefined,
        role: label ? "img" : undefined,
        dangerouslySetInnerHTML: {
            __html: svg
        }
    }, rest));
};
var $a8727384f24fb2c7$export$2e2bcd8739ae039 = $a8727384f24fb2c7$var$Wrapper;

});


parcelRegister("iDcqq", function(module, exports) {

$parcel$export(module.exports, "JiraProductDiscoveryIcon", function () { return $d90581e52cb8817c$export$21bfbeb62fdcce8d; });
/* eslint-disable max-len */ 
var $1Mpn7 = parcelRequire("1Mpn7");

var $cuQ94 = parcelRequire("cuQ94");

var $8vPVi = parcelRequire("8vPVi");

var $bpDjz = parcelRequire("bpDjz");

var $esDFv = parcelRequire("esDFv");
var $d90581e52cb8817c$var$svg = function svg(_ref) {
    var appearance = _ref.appearance, iconGradientStart = _ref.iconGradientStart, iconGradientStop = _ref.iconGradientStop, iconColor = _ref.iconColor;
    var colors = {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor
    };
    // Will be fixed upon removal of deprecated iconGradientStart and
    // iconGradientStop props, or with React 18's useId() hook when we update.
    // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    var id = (0, $cuQ94.uid)({
        iconGradientStart: iconGradientStop
    });
    if (appearance) colors = (0, $bpDjz.getColorsFromAppearance)(appearance);
    return '\n  <svg\n  height="32"\n  viewBox="0 0 32 32"\n  fill="none"\n  xmlns="http://www.w3.org/2000/svg"\n>\n  <path\n    d="M18.9987 15.6133C18.9987 15.6133 19.018 15.9933 19.018 16.518C19.018 18.4727 17.4333 20.0573 15.4787 20.0573C13.524 20.0573 11.9393 18.4727 11.9393 16.518C11.9393 14.5633 13.524 12.9787 15.4787 12.9787C16.0033 12.9787 16.3253 12.998 16.3253 12.998V6.08067C16.046 6.05801 15.764 6.04401 15.4787 6.04401C9.692 6.04401 5.00067 10.7353 5.00067 16.522C5.00067 22.3087 9.692 27 15.4787 27C21.2653 27 25.9567 22.3087 25.9567 16.522C25.9567 16.1887 25.9507 15.9573 25.9233 15.614H18.9987V15.6133Z"\n    fill="url(#'.concat(id, ')"\n  />\n  <path\n    d="M17.9233 5.01001C20.8313 5.79601 23.7393 5.79601 26.6473 5.01001C26.8573 4.95334 27.046 5.14201 26.9893 5.35201C26.2033 8.26001 26.2033 11.168 26.9893 14.076C27.046 14.286 26.8573 14.4747 26.6473 14.418C23.7393 13.632 20.8313 13.632 17.9233 14.418C17.7133 14.4747 17.5247 14.286 17.5813 14.076C18.3673 11.168 18.3673 8.26001 17.5813 5.35201C17.5247 5.14201 17.7133 4.95334 17.9233 5.01001Z"\n    fill="').concat(colors.iconColor, '"\n  />\n  <defs>\n    <linearGradient\n      id="').concat(id, '"\n      x1="14.178"\n      y1="17.822"\n      x2="21.4387"\n      y2="10.5613"\n      gradientUnits="userSpaceOnUse"\n    >\n      <stop stop-color="').concat(colors.iconGradientStop, '" />\n      <stop offset="0.927" stop-color="').concat(colors.iconGradientStart, '" ').concat(colors.iconGradientStart === "inherit" ? 'stop-opacity="0.4"' : "", " />\n    </linearGradient>\n  </defs>\n</svg>");
};
var $d90581e52cb8817c$export$21bfbeb62fdcce8d = function JiraProductDiscoveryIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Jira Product Discovery" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8vPVi.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8vPVi.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$iconGradientSta = _ref2.iconGradientStart, iconGradientStart = _ref2$iconGradientSta === void 0 ? (0, $8vPVi.defaultLogoParams).iconGradientStart : _ref2$iconGradientSta, _ref2$iconGradientSto = _ref2.iconGradientStop, iconGradientStop = _ref2$iconGradientSto === void 0 ? (0, $8vPVi.defaultLogoParams).iconGradientStop : _ref2$iconGradientSto, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8vPVi.defaultLogoParams).textColor : _ref2$textColor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $esDFv.default), {
        appearance: appearance,
        label: label,
        svg: $d90581e52cb8817c$var$svg({
            appearance: appearance,
            iconGradientStart: iconGradientStart,
            iconGradientStop: iconGradientStop,
            iconColor: iconColor
        }),
        iconColor: iconColor,
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("aYoHs", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementIcon", function () { return $7fd2aae26ed07766$export$3c6158790f5e01c4; });
/* eslint-disable max-len */ 
var $1Mpn7 = parcelRequire("1Mpn7");

var $cuQ94 = parcelRequire("cuQ94");

var $8vPVi = parcelRequire("8vPVi");

var $bpDjz = parcelRequire("bpDjz");

var $esDFv = parcelRequire("esDFv");
var $7fd2aae26ed07766$var$svg = function svg(_ref) {
    var appearance = _ref.appearance, iconGradientStart = _ref.iconGradientStart, iconGradientStop = _ref.iconGradientStop, iconColor = _ref.iconColor;
    var colors = {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor
    };
    // Will be fixed upon removal of deprecated iconGradientStart and
    // iconGradientStop props, or with React 18's useId() hook when we update.
    // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    var id = (0, $cuQ94.uid)({
        iconGradientStart: iconGradientStop
    });
    if (appearance) colors = (0, $bpDjz.getColorsFromAppearance)(appearance);
    return '\n  <svg viewBox="0 0 32 32" height="32" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true">\n    <defs>\n      <linearGradient x1="40.063%" x2="69.955%" y1="0%" y2="50%" id="'.concat(id, '">\n        <stop stop-color="').concat(colors.iconGradientStart, '" ').concat(colors.iconGradientStart === "inherit" ? 'stop-opacity="0.4"' : "", ' offset="0%"></stop>\n        <stop stop-color="').concat(colors.iconGradientStop, '" offset="100%"></stop>\n      </linearGradient>\n    </defs>\n    <g stroke="none" stroke-width="1" fill-rule="nonzero">\n      <path fill="url(#').concat(id, ')" d="M18.4838727,13.07 L26.3504842,13.1005351 C26.8138769,13.102696 27.2364009,13.3661074 27.4423455,13.781227 C27.64829,14.1963467 27.6024124,14.6921363 27.3237913,15.0624169 L15.7128101,30.5666265 C13.9597489,29.2574035 12.7986975,27.3052951 12.485161,25.1398891 C12.1716246,22.974483 12.731296,20.7732253 14.041012,19.0205325 L18.4838727,13.07 Z"></path>\n      <path fill="').concat(colors.iconColor, '" d="M14.0396053,19.0156579 L6.22105263,18.9660526 C5.75779361,18.9638923 5.33539149,18.700557 5.12950634,18.2855571 C4.92362119,17.8705572 4.96948557,17.3749106 5.24802632,17.0047368 L16.7411842,1.65 C18.4937397,2.9588453 19.6544561,4.91039056 19.9679021,7.0751719 C20.2813481,9.23995324 19.7218382,11.4405759 18.4125,13.1927632 L14.0396053,19.0156579 Z"></path>\n    </g>\n  </svg>');
};
var $7fd2aae26ed07766$export$3c6158790f5e01c4 = function JiraServiceManagementIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Jira Service Management" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8vPVi.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8vPVi.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$iconGradientSta = _ref2.iconGradientStart, iconGradientStart = _ref2$iconGradientSta === void 0 ? (0, $8vPVi.defaultLogoParams).iconGradientStart : _ref2$iconGradientSta, _ref2$iconGradientSto = _ref2.iconGradientStop, iconGradientStop = _ref2$iconGradientSto === void 0 ? (0, $8vPVi.defaultLogoParams).iconGradientStop : _ref2$iconGradientSto, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8vPVi.defaultLogoParams).textColor : _ref2$textColor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $esDFv.default), {
        appearance: appearance,
        label: label,
        svg: $7fd2aae26ed07766$var$svg({
            appearance: appearance,
            iconGradientStart: iconGradientStart,
            iconGradientStop: iconGradientStop,
            iconColor: iconColor
        }),
        iconColor: iconColor,
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("eESCE", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwareIcon", function () { return $02c104d6bd85e14c$export$c3835feba2a66e67; });
/* eslint-disable max-len */ 
var $1Mpn7 = parcelRequire("1Mpn7");

var $cuQ94 = parcelRequire("cuQ94");

var $8vPVi = parcelRequire("8vPVi");

var $bpDjz = parcelRequire("bpDjz");

var $esDFv = parcelRequire("esDFv");
var $02c104d6bd85e14c$var$svg = function svg(_ref) {
    var appearance = _ref.appearance, iconGradientStart = _ref.iconGradientStart, iconGradientStop = _ref.iconGradientStop, iconColor = _ref.iconColor;
    var colors = {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor
    };
    // Will be fixed upon removal of deprecated iconGradientStart and
    // iconGradientStop props, or with React 18's useId() hook when we update.
    // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    var id = (0, $cuQ94.uid)({
        iconGradientStart: iconGradientStop
    });
    if (appearance) colors = (0, $bpDjz.getColorsFromAppearance)(appearance);
    return '\n  <svg viewBox="0 0 32 32" height="32" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true">\n    <defs>\n      <linearGradient x1="108.695%" x2="12.439%" y1="-14.936%" y2="45.215%" id="'.concat(id, '-1">\n        <stop stop-color="').concat(colors.iconGradientStart, '" ').concat(colors.iconGradientStart === "inherit" ? 'stop-opacity="0.4"' : "", ' offset="0%"></stop>\n        <stop stop-color="').concat(colors.iconGradientStop, '" offset="100%"></stop>\n      </linearGradient>\n      <linearGradient x1="0%" x2="91.029%" y1="118.55%" y2="63.971%" id="').concat(id, '-2">\n        <stop stop-color="').concat(colors.iconGradientStart, '" ').concat(colors.iconGradientStart === "inherit" ? 'stop-opacity="0.4"' : "", ' offset="0%"></stop>\n        <stop stop-color="').concat(colors.iconGradientStop, '" offset="100%"></stop>\n      </linearGradient>\n    </defs>\n    <g stroke="none" stroke-width="1" fill-rule="nonzero">\n      <path fill="').concat(colors.iconColor, '" d="M15.9669691 29.3616152C17.2195568 28.1097726 17.9233158 26.4114623 17.9233158 24.6405626 17.9233158 22.8696629 17.2195568 21.1713527 15.9669691 19.91951L7.26805808 11.2489111 3.31143376 15.2055354C2.89743442 15.6200502 2.89743442 16.291565 3.31143376 16.7060799L15.9669691 29.3616152zM28.6225045 15.2055354L15.9669691 2.55 15.9280399 2.58892922C13.3485687 5.19994003 13.3612164 9.40374108 15.9563521 11.9991833L24.6623412 20.6662432 28.6225045 16.7060799C29.0365039 16.291565 29.0365039 15.6200502 28.6225045 15.2055354z" />\n      <path fill="url(#').concat(id, '-1" d="M15.9669691,11.9921053 C13.3718335,9.39666304 13.3591857,5.19286199 15.938657,2.58185118 L6.91061706,11.6063521 L11.6316697,16.3274047 L15.9669691,11.9921053 Z" />\n      <path fill="url(#').concat(id, '-2" d="M20.2951906,15.5912886 L15.9669691,19.91951 C17.2195568,21.1713527 17.9233158,22.8696629 17.9233158,24.6405626 C17.9233158,26.4114623 17.2195568,28.1097726 15.9669691,29.3616152 L25.0162432,20.3123412 L20.2951906,15.5912886 Z" />\n    </g>\n  </svg>');
};
var $02c104d6bd85e14c$export$c3835feba2a66e67 = function JiraSoftwareIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Jira Software" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8vPVi.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8vPVi.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$iconGradientSta = _ref2.iconGradientStart, iconGradientStart = _ref2$iconGradientSta === void 0 ? (0, $8vPVi.defaultLogoParams).iconGradientStart : _ref2$iconGradientSta, _ref2$iconGradientSto = _ref2.iconGradientStop, iconGradientStop = _ref2$iconGradientSto === void 0 ? (0, $8vPVi.defaultLogoParams).iconGradientStop : _ref2$iconGradientSto, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8vPVi.defaultLogoParams).textColor : _ref2$textColor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $esDFv.default), {
        appearance: appearance,
        label: label,
        svg: $02c104d6bd85e14c$var$svg({
            appearance: appearance,
            iconGradientStart: iconGradientStart,
            iconGradientStop: iconGradientStop,
            iconColor: iconColor
        }),
        iconColor: iconColor,
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("210Ck", function(module, exports) {

$parcel$export(module.exports, "JiraWorkManagementIcon", function () { return $177c275462b639cb$export$7330b9fc5718fd30; });
/* eslint-disable max-len */ 
var $1Mpn7 = parcelRequire("1Mpn7");

var $cuQ94 = parcelRequire("cuQ94");

var $8vPVi = parcelRequire("8vPVi");

var $bpDjz = parcelRequire("bpDjz");

var $esDFv = parcelRequire("esDFv");
var $177c275462b639cb$var$svg = function svg(_ref) {
    var appearance = _ref.appearance, iconGradientStart = _ref.iconGradientStart, iconGradientStop = _ref.iconGradientStop, iconColor = _ref.iconColor;
    var colors = {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor
    };
    // Will be fixed upon removal of deprecated iconGradientStart and
    // iconGradientStop props, or with React 18's useId() hook when we update.
    // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    var id = (0, $cuQ94.uid)({
        iconGradientStart: iconGradientStop
    });
    if (appearance) colors = (0, $bpDjz.getColorsFromAppearance)(appearance);
    return '\n    <svg\n      fill="none"\n      height="32"\n      viewBox="0 0 32 32"\n      xmlns="http://www.w3.org/2000/svg"\n    >\n      <linearGradient\n        id="'.concat(id, '"\n        gradientUnits="userSpaceOnUse"\n        x1="13.9485"\n        x2="20.7792"\n        y1="20.2388"\n        y2="11.8277"\n      >\n        <stop offset="0" stop-color="').concat(colors.iconGradientStart, '" ').concat(colors.iconGradientStart === "inherit" ? 'stop-opacity="0.4"' : "", ' />\n        <stop offset="100%" stop-color="').concat(colors.iconGradientStop, '" />\n      </linearGradient>\n      <path\n        d="m18.3893 7-3.4257 13.1867c4.3592 1.2052 7.8383-.3558 9.1709-5.4802l1.9988-7.6973z"\n        fill="url(#').concat(id, ')"\n      />\n      <path\n      fill="').concat(colors.iconColor, '"\n      d="m13.7566 24.8265 3.4257-13.1866c-4.3623-1.196-7.8383.3649-9.17087 5.4985l-2.01143 7.6881z"\n      />\n    </svg>');
};
var $177c275462b639cb$export$7330b9fc5718fd30 = function JiraWorkManagementIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Jira Work Management" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8vPVi.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8vPVi.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$iconGradientSta = _ref2.iconGradientStart, iconGradientStart = _ref2$iconGradientSta === void 0 ? (0, $8vPVi.defaultLogoParams).iconGradientStart : _ref2$iconGradientSta, _ref2$iconGradientSto = _ref2.iconGradientStop, iconGradientStop = _ref2$iconGradientSto === void 0 ? (0, $8vPVi.defaultLogoParams).iconGradientStop : _ref2$iconGradientSto, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8vPVi.defaultLogoParams).textColor : _ref2$textColor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $esDFv.default), {
        appearance: appearance,
        label: label,
        svg: $177c275462b639cb$var$svg({
            appearance: appearance,
            iconGradientStart: iconGradientStart,
            iconGradientStop: iconGradientStop,
            iconColor: iconColor
        }),
        iconColor: iconColor,
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});


parcelRegister("dpugK", function(module, exports) {

$parcel$export(module.exports, "containerStyle", function () { return $9c3516fa58906f45$export$856b6de7fac89c7f; });
$parcel$export(module.exports, "lozengeStyle", function () { return $9c3516fa58906f45$export$157f8c9c7b83e277; });
$parcel$export(module.exports, "mainContentStyle", function () { return $9c3516fa58906f45$export$d9774a58ba59ccc2; });
$parcel$export(module.exports, "productTextStyle", function () { return $9c3516fa58906f45$export$a217b6390327e332; });
$parcel$export(module.exports, "productNameStyle", function () { return $9c3516fa58906f45$export$bcdffbd8e6de8bec; });
$parcel$export(module.exports, "totalCostStyle", function () { return $9c3516fa58906f45$export$dfe70f1fb5a7d9de; });
$parcel$export(module.exports, "subContentStyle", function () { return $9c3516fa58906f45$export$682824546195b361; });
$parcel$export(module.exports, "siteNameStyle", function () { return $9c3516fa58906f45$export$77c57e4a1a21ce97; });
$parcel$export(module.exports, "userBreakdownStyle", function () { return $9c3516fa58906f45$export$9760442955de58; });

var $j06k0 = parcelRequire("j06k0");

var $fBy54 = parcelRequire("fBy54");
parcelRequire("1DvYB");
var $pDfcT = parcelRequire("pDfcT");

var $gDEpB = parcelRequire("gDEpB");
function $9c3516fa58906f45$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  padding: ",
        " 0;\n\n  &:first-child {\n    padding-top: 0;\n  }\n\n  &:last-child {\n    padding-bottom: 0;\n  }\n\n  &:not(:last-child) {\n    border-bottom: 1px solid ",
        ";\n  }\n"
    ]);
    $9c3516fa58906f45$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $9c3516fa58906f45$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "\n  font-weight: 500;\n"
    ]);
    $9c3516fa58906f45$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $9c3516fa58906f45$var$_templateObject2() {
    var data = (0, $j06k0._)([
        "\n  display: flex;\n  align-items: start;\n  font-size: 16px;\n  font-weight: 500;\n  margin: ",
        " 0;\n  line-height: 24px;\n"
    ]);
    $9c3516fa58906f45$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $9c3516fa58906f45$var$_templateObject3() {
    var data = (0, $j06k0._)([
        "\n  display: flex;\n  align-items: start;\n  flex: 1 1 auto;\n"
    ]);
    $9c3516fa58906f45$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $9c3516fa58906f45$var$_templateObject4() {
    var data = (0, $j06k0._)([
        "\n  text-transform: capitalize;\n  display: inline-block;\n"
    ]);
    $9c3516fa58906f45$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $9c3516fa58906f45$var$_templateObject5() {
    var data = (0, $j06k0._)([
        "\n  text-align: right;\n  flex-shrink: 0;\n  margin-left: ",
        ";\n"
    ]);
    $9c3516fa58906f45$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function $9c3516fa58906f45$var$_templateObject6() {
    var data = (0, $j06k0._)([
        "\n  display: flex;\n  font-size: 14px;\n  color: ",
        ";\n  margin: ",
        " 0 0;\n  line-height: 18px;\n"
    ]);
    $9c3516fa58906f45$var$_templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function $9c3516fa58906f45$var$_templateObject7() {
    var data = (0, $j06k0._)([
        "\n  flex: 1 1 auto;\n"
    ]);
    $9c3516fa58906f45$var$_templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function $9c3516fa58906f45$var$_templateObject8() {
    var data = (0, $j06k0._)([
        "\n  text-align: right;\n  flex-shrink: 0;\n  margin-left: ",
        ";\n"
    ]);
    $9c3516fa58906f45$var$_templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
var $9c3516fa58906f45$export$856b6de7fac89c7f = (0, $fBy54.css)($9c3516fa58906f45$var$_templateObject(), (0, $pDfcT.wplToken)("space.300"), (0, $gDEpB.getColor)("n50"));
var $9c3516fa58906f45$export$157f8c9c7b83e277 = (0, $fBy54.css)($9c3516fa58906f45$var$_templateObject1());
var $9c3516fa58906f45$export$d9774a58ba59ccc2 = (0, $fBy54.css)($9c3516fa58906f45$var$_templateObject2(), (0, $pDfcT.wplToken)("space.100"));
var $9c3516fa58906f45$export$a217b6390327e332 = (0, $fBy54.css)($9c3516fa58906f45$var$_templateObject3());
var $9c3516fa58906f45$export$bcdffbd8e6de8bec = (0, $fBy54.css)($9c3516fa58906f45$var$_templateObject4());
var $9c3516fa58906f45$export$dfe70f1fb5a7d9de = (0, $fBy54.css)($9c3516fa58906f45$var$_templateObject5(), (0, $pDfcT.wplToken)("space.300"));
var $9c3516fa58906f45$export$682824546195b361 = (0, $fBy54.css)($9c3516fa58906f45$var$_templateObject6(), (0, $gDEpB.getColor)("n300"), (0, $pDfcT.wplToken)("space.100"));
var $9c3516fa58906f45$export$77c57e4a1a21ce97 = (0, $fBy54.css)($9c3516fa58906f45$var$_templateObject7());
var $9c3516fa58906f45$export$9760442955de58 = (0, $fBy54.css)($9c3516fa58906f45$var$_templateObject8(), (0, $pDfcT.wplToken)("space.300"));

});




parcelRegister("2fcCi", function(module, exports) {
$parcel$export(module.exports, "ShowAllLink", function () { return (parcelRequire("f1zlB")).ShowAllLink; });
parcelRequire("f1zlB");

});
parcelRegister("f1zlB", function(module, exports) {

$parcel$export(module.exports, "ShowAllLink", function () { return $af025e41788e4112$export$dc3cb43be98bc786; });

var $1rY3h = parcelRequire("1rY3h");

var $145N3 = parcelRequire("145N3");

var $1Mpn7 = parcelRequire("1Mpn7");

var $cVzdx = parcelRequire("cVzdx");

var $1UxSA = parcelRequire("1UxSA");
var $af025e41788e4112$export$dc3cb43be98bc786 = function(param) {
    var addPaymentDetailsURL = param.addPaymentDetailsURL, analyticsAttributes = param.analyticsAttributes, totalEntitlementsCount = param.totalEntitlementsCount;
    var createAnalyticsEvent = (0, $145N3.useAnalyticsEvents)().createAnalyticsEvent;
    (0, $1Mpn7.useEffect)(function() {
        createAnalyticsEvent({
            eventName: (0, $cVzdx.TRACKING_EVENT_NAMES).showAllLinkDisplayed,
            action: "displayed",
            actionSubject: "showAllLink",
            actionSubjectId: (0, $cVzdx.ACTION_SUBJECT_IDS).wacCartShowAllLinkDisplayed,
            attributes: analyticsAttributes
        }).fire();
    }, []);
    return (0, $1rY3h.jsxs)("a", {
        css: (0, $1UxSA.linkStyle),
        href: addPaymentDetailsURL,
        target: "_blank",
        rel: "noreferrer",
        onClick: function() {
            createAnalyticsEvent({
                eventName: (0, $cVzdx.TRACKING_EVENT_NAMES).showAllLinkClicked,
                action: "clicked",
                actionSubject: "showAllLink",
                actionSubjectId: (0, $cVzdx.ACTION_SUBJECT_IDS).wacCartShowAllLinkClicked,
                attributes: analyticsAttributes
            }).fire();
        },
        children: [
            "Show all ",
            totalEntitlementsCount,
            " products"
        ]
    });
};

});
parcelRegister("1UxSA", function(module, exports) {

$parcel$export(module.exports, "linkStyle", function () { return $16454d2dbeb2e19a$export$a4c1071d1005664f; });

var $j06k0 = parcelRequire("j06k0");

var $fBy54 = parcelRequire("fBy54");
parcelRequire("1DvYB");
var $pDfcT = parcelRequire("pDfcT");

var $gDEpB = parcelRequire("gDEpB");
function $16454d2dbeb2e19a$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  text-align: center;\n  font-family: Charlie Text, sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  display: block;\n  margin: ",
        " 0;\n  padding: ",
        " ",
        ";\n  color: ",
        ";\n  text-decoration: none;\n\n  &:hover,\n  &:active,\n  &:focus {\n    text-decoration: none;\n  }\n"
    ]);
    $16454d2dbeb2e19a$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $16454d2dbeb2e19a$export$a4c1071d1005664f = (0, $fBy54.css)($16454d2dbeb2e19a$var$_templateObject(), (0, $pDfcT.wplToken)("space.300"), (0, $pDfcT.wplToken)("space.100"), (0, $pDfcT.wplToken)("space.200"), (0, $gDEpB.getColor)("b300"));

});



parcelRegister("crWuu", function(module, exports) {

$parcel$export(module.exports, "containerStyle", function () { return $910560b20d546d4f$export$856b6de7fac89c7f; });

var $j06k0 = parcelRequire("j06k0");

var $fBy54 = parcelRequire("fBy54");
function $910560b20d546d4f$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  display: inline-block;\n"
    ]);
    $910560b20d546d4f$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $910560b20d546d4f$export$856b6de7fac89c7f = (0, $fBy54.css)($910560b20d546d4f$var$_templateObject());

});

parcelRegister("bQ5AI", function(module, exports) {

$parcel$export(module.exports, "useEntitlements", function () { return (parcelRequire("9SuoP")).useEntitlements; });

var $9SuoP = parcelRequire("9SuoP");

});
parcelRegister("9SuoP", function(module, exports) {

$parcel$export(module.exports, "useEntitlements", function () { return $7310bce41592f32a$export$60923aa21903cc38; });

var $kSuI9 = parcelRequire("kSuI9");

var $3sHb8 = parcelRequire("3sHb8");

var $cv9Rk = parcelRequire("cv9Rk");

var $l29cN = parcelRequire("l29cN");

var $145N3 = parcelRequire("145N3");

var $dyK3f = parcelRequire("dyK3f");

var $5vvNu = parcelRequire("5vvNu");

var $1Mpn7 = parcelRequire("1Mpn7");

var $dFCZz = parcelRequire("dFCZz");

var $cVzdx = parcelRequire("cVzdx");

var $glI9a = parcelRequire("glI9a");
var $7310bce41592f32a$var$mapSiteToEntitlements = function() {
    var _ref = (0, $kSuI9._)(function(site, createAnalyticsEvent, existingTransactionAccountId, existingInvoiceGroupId) {
        var foundTransactionId, foundInvoiceGroupId, entitlements, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, productKey, product, ccpTransactionAccountId, invoiceGroupId, invoiceGroupResp, ok, status, statusText, invoiceable;
        return (0, $l29cN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    foundTransactionId = existingTransactionAccountId;
                    foundInvoiceGroupId = existingInvoiceGroupId;
                    entitlements = [];
                    if (!site.products) return [
                        2,
                        []
                    ];
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        // iterate over products in site in order to find
                        // products with same invoiceGroupId and ccpTransactionId
                        for(_iterator = Object.entries(site.products)[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            _step_value = (0, $cv9Rk._)(_step.value, 2), productKey = _step_value[0], product = _step_value[1];
                            ccpTransactionAccountId = product.ccpTransactionAccountId, invoiceGroupId = product.invoiceGroupId;
                            if (!invoiceGroupId || !ccpTransactionAccountId || !Object.keys((0, $dFCZz.PRODUCT_NAME_BY_KEY)).includes(productKey)) continue;
                            // on finding first ids set them as those to look for
                            if (!foundInvoiceGroupId && !foundTransactionId) {
                                foundInvoiceGroupId = invoiceGroupId;
                                foundTransactionId = ccpTransactionAccountId;
                            }
                            // return eligible entitlements in format required by UI
                            entitlements = Object.entries(site.products).filter(function(param) {
                                var _param = (0, $cv9Rk._)(param, 1), productKey = _param[0];
                                return(// only include Jira family and Confluence
                                Object.keys((0, $dFCZz.PRODUCT_NAME_BY_KEY)).includes(productKey));
                            }).filter(// only products with ids matching the first set found
                            function(param) {
                                var _param = (0, $cv9Rk._)(param, 2), _ = _param[0], _param_ = _param[1], invoiceGroupId = _param_.invoiceGroupId, ccpTransactionAccountId = _param_.ccpTransactionAccountId;
                                return invoiceGroupId === foundInvoiceGroupId && ccpTransactionAccountId === foundTransactionId;
                            }).map(function(param) {
                                var _param = (0, $cv9Rk._)(param, 2), productKey = _param[0], currentProduct = _param[1];
                                var _site_hostname;
                                var hostname = (_site_hostname = site.hostname) !== null && _site_hostname !== void 0 ? _site_hostname : "";
                                // strip hostname of protocol
                                var siteURLMatch = /https:\/\/(.*)/.exec(hostname);
                                var _ref;
                                var siteName = (_ref = siteURLMatch && siteURLMatch[1]) !== null && _ref !== void 0 ? _ref : "";
                                var currDate = new Date();
                                var utcZero = Date.UTC(currDate.getFullYear(), currDate.getMonth(), currDate.getDate());
                                var daysLeftInTrial;
                                if (currentProduct.trialEndDate) {
                                    daysLeftInTrial = (0, $dyK3f.seconds)((new Date(currentProduct.trialEndDate).valueOf() - new Date(utcZero).valueOf()) / 1000).toDays();
                                    if (daysLeftInTrial < 1) daysLeftInTrial = undefined;
                                }
                                return {
                                    entitlementId: currentProduct.ccpEntitlementId,
                                    siteName: siteName,
                                    // get product name plus capitalized plan (aka 'edition')
                                    productAndPlanName: (0, $dFCZz.PRODUCT_NAME_BY_KEY)[productKey] + " " + currentProduct.edition.slice(0, 1).toUpperCase() + currentProduct.edition.slice(1),
                                    productKey: productKey,
                                    daysLeftInTrial: daysLeftInTrial
                                };
                            });
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    if (!foundTransactionId) return [
                        2,
                        []
                    ];
                    if (!(!existingTransactionAccountId || !existingInvoiceGroupId)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        (0, $glI9a.fetchAPI)("/ccp/api/v1/invoice-groups/".concat(foundInvoiceGroupId, "/status"), {
                            headers: (0, $3sHb8._)({}, "X-transaction-account", foundTransactionId)
                        })
                    ];
                case 1:
                    invoiceGroupResp = _state.sent();
                    ok = invoiceGroupResp.ok, status = invoiceGroupResp.status, statusText = invoiceGroupResp.statusText;
                    if (!ok) {
                        console.error("Call to /invoice-groups/ failed: ".concat(status, " ").concat(statusText));
                        createAnalyticsEvent({
                            action: "failed",
                            actionSubject: "Call to /invoice-groups/",
                            actionSubjectId: (0, $cVzdx.ACTION_SUBJECT_IDS).wacCartInvoiceGroupsCallFailed,
                            attributes: {
                                aaid: (0, (/*@__PURE__*/$parcel$interopDefault($5vvNu))).get("__aid_user_id"),
                                error: "".concat(status, " ").concat(statusText),
                                foundInvoiceGroupId: foundInvoiceGroupId
                            }
                        }).fire();
                        return [
                            2,
                            []
                        ];
                    }
                    return [
                        4,
                        invoiceGroupResp.json()
                    ];
                case 2:
                    invoiceable = _state.sent().invoiceable;
                    if (invoiceable) return [
                        2,
                        []
                    ];
                    _state.label = 3;
                case 3:
                    return [
                        2,
                        [
                            entitlements,
                            foundTransactionId,
                            foundInvoiceGroupId,
                            entitlements.length
                        ]
                    ];
            }
        });
    });
    return function mapSiteToEntitlements(site, createAnalyticsEvent, existingTransactionAccountId, existingInvoiceGroupId) {
        return _ref.apply(this, arguments);
    };
}();
var $7310bce41592f32a$export$60923aa21903cc38 = function() {
    var createAnalyticsEvent = (0, $145N3.useAnalyticsEvents)().createAnalyticsEvent;
    var hasRun = (0, $1Mpn7.useRef)(false);
    var _useState = (0, $cv9Rk._)((0, $1Mpn7.useState)(), 2), cachedEntitlements = _useState[0], setCachedEntitlements = _useState[1];
    var _useState1 = (0, $cv9Rk._)((0, $1Mpn7.useState)(0), 2), totalEntitlementsCount = _useState1[0], setTotalEntitlementsCount = _useState1[1];
    var _useState2 = (0, $cv9Rk._)((0, $1Mpn7.useState)(""), 2), transactionAccountId = _useState2[0], setTransactionAccountId = _useState2[1];
    var _useState3 = (0, $cv9Rk._)((0, $1Mpn7.useState)(""), 2), invoiceGroupId = _useState3[0], setInvoiceGroupId = _useState3[1];
    (0, $1Mpn7.useEffect)(function() {
        if (hasRun.current) return;
        hasRun.current = true;
        (0, $kSuI9._)(function() {
            var productHubInfo, ok, status, statusText, sites, siteIdx, entitlements, countTotalEntitlements, recvTransactionAccountId, recvInvoiceGroupId, site, _ref, foundEntitlements, taId, iGroupId, numEntitlements, error;
            return (0, $l29cN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            7,
                            ,
                            8
                        ]);
                        return [
                            4,
                            (0, $glI9a.fetchAPI)("/producthub/info")
                        ];
                    case 1:
                        productHubInfo = _state.sent();
                        ok = productHubInfo.ok, status = productHubInfo.status, statusText = productHubInfo.statusText;
                        if (!ok && status !== 401) {
                            console.error("Call to /producthub/info failed with status ".concat(status, " ").concat(statusText));
                            throw Error("Call to /producthub/info failed with status ".concat(status, " ").concat(statusText));
                        } else if (status === 401) // user is not logged in so do nothing and log nothing
                        return [
                            2
                        ];
                        return [
                            4,
                            productHubInfo.json()
                        ];
                    case 2:
                        sites = _state.sent().sites;
                        if (!sites || sites.length === 0) {
                            createAnalyticsEvent({
                                eventName: (0, $cVzdx.TRACKING_EVENT_NAMES).noSitesFound,
                                action: "returnedNoSites",
                                actionSubject: "/producthub/info",
                                actionSubjectId: (0, $cVzdx.ACTION_SUBJECT_IDS).wacCartProductHubInfoReturnedNoSites,
                                attributes: {
                                    aaid: (0, (/*@__PURE__*/$parcel$interopDefault($5vvNu))).get("__aid_user_id")
                                }
                            }).fire();
                            return [
                                2
                            ];
                        }
                        siteIdx = 0;
                        entitlements = [];
                        countTotalEntitlements = 0;
                        _state.label = 3;
                    case 3:
                        if (!(siteIdx < sites.length)) return [
                            3,
                            6
                        ];
                        site = sites[siteIdx];
                        if (!site) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            $7310bce41592f32a$var$mapSiteToEntitlements(site, createAnalyticsEvent, recvTransactionAccountId, recvInvoiceGroupId)
                        ];
                    case 4:
                        _ref = (0, $cv9Rk._).apply(void 0, [
                            _state.sent(),
                            4
                        ]), foundEntitlements = _ref[0], taId = _ref[1], iGroupId = _ref[2], numEntitlements = _ref[3];
                        entitlements = entitlements.concat(foundEntitlements !== null && foundEntitlements !== void 0 ? foundEntitlements : []);
                        countTotalEntitlements += numEntitlements || 0;
                        recvTransactionAccountId = taId;
                        recvInvoiceGroupId = iGroupId;
                        _state.label = 5;
                    case 5:
                        siteIdx++;
                        return [
                            3,
                            3
                        ];
                    case 6:
                        if (entitlements.length === 0) createAnalyticsEvent({
                            eventName: (0, $cVzdx.TRACKING_EVENT_NAMES).noEntitlementsFound,
                            action: "returnedNoEntitlements",
                            actionSubject: "/producthub/info",
                            actionSubjectId: (0, $cVzdx.ACTION_SUBJECT_IDS).wacCartProductHubInfoReturnedNoEntitlements,
                            attributes: {
                                aaid: (0, (/*@__PURE__*/$parcel$interopDefault($5vvNu))).get("__aid_user_id")
                            }
                        }).fire();
                        setCachedEntitlements(entitlements);
                        setTotalEntitlementsCount(countTotalEntitlements);
                        setTransactionAccountId(recvTransactionAccountId !== null && recvTransactionAccountId !== void 0 ? recvTransactionAccountId : "");
                        setInvoiceGroupId(recvInvoiceGroupId !== null && recvInvoiceGroupId !== void 0 ? recvInvoiceGroupId : "");
                        return [
                            3,
                            8
                        ];
                    case 7:
                        error = _state.sent();
                        createAnalyticsEvent({
                            action: "failed",
                            actionSubject: "useEntitlements hook",
                            actionSubjectId: (0, $cVzdx.ACTION_SUBJECT_IDS).wacCartUseEntitlementsFailed,
                            attributes: {
                                aaid: (0, (/*@__PURE__*/$parcel$interopDefault($5vvNu))).get("__aid_user_id"),
                                error: error instanceof Error ? error.message : JSON.stringify(error)
                            }
                        }).fire();
                        return [
                            3,
                            8
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        })();
    });
    return [
        cachedEntitlements !== null && cachedEntitlements !== void 0 ? cachedEntitlements : [],
        transactionAccountId,
        invoiceGroupId,
        totalEntitlementsCount
    ];
};

});
parcelRegister("dyK3f", function(module, exports) {

$parcel$export(module.exports, "seconds", function () { return $9df22c2955f6da89$export$4792e48abc550fa1; });
var $9df22c2955f6da89$export$4792e48abc550fa1 = function seconds(numberOfSeconds) {
    return {
        toMilliseconds: function toMilliseconds() {
            return Math.round(numberOfSeconds * 1000);
        },
        toSeconds: function toSeconds() {
            return Math.round(numberOfSeconds);
        },
        toMinutes: function toMinutes() {
            return Math.round(numberOfSeconds / 60);
        },
        toHours: function toHours() {
            return Math.round(numberOfSeconds / 3600);
        },
        toDays: function toDays() {
            return Math.round(numberOfSeconds / 86400);
        },
        toWeeks: function toWeeks() {
            return Math.round(numberOfSeconds / 604800);
        },
        toMonths: function toMonths() {
            return Math.round(numberOfSeconds / 2592000);
        },
        toYears: function toYears() {
            return Math.round(numberOfSeconds / 31536000);
        }
    };
};
var $9df22c2955f6da89$export$666252b437cce0c7 = function minutes(numberOfMinutes) {
    return {
        toMilliseconds: function toMilliseconds() {
            return Math.round(numberOfMinutes * 60000);
        },
        toSeconds: function toSeconds() {
            return Math.round(numberOfMinutes * 60);
        },
        toMinutes: function toMinutes() {
            return Math.round(numberOfMinutes);
        },
        toHours: function toHours() {
            return Math.round(numberOfMinutes / 60);
        },
        toDays: function toDays() {
            return Math.round(numberOfMinutes / 1440);
        },
        toWeeks: function toWeeks() {
            return Math.round(numberOfMinutes / 10080);
        },
        toMonths: function toMonths() {
            return Math.round(numberOfMinutes / 43200);
        },
        toYears: function toYears() {
            return Math.round(numberOfMinutes / 525600);
        }
    };
};
var $9df22c2955f6da89$export$8d468796d69cdad1 = function hours(numberOfHours) {
    return {
        toMilliseconds: function toMilliseconds() {
            return Math.round(numberOfHours * 3600000);
        },
        toSeconds: function toSeconds() {
            return Math.round(numberOfHours * 3600);
        },
        toMinutes: function toMinutes() {
            return Math.round(numberOfHours * 60);
        },
        toHours: function toHours() {
            return Math.round(numberOfHours);
        },
        toDays: function toDays() {
            return Math.round(numberOfHours / 24);
        },
        toWeeks: function toWeeks() {
            return Math.round(numberOfHours / 168);
        },
        toMonths: function toMonths() {
            return Math.round(numberOfHours / 720);
        },
        toYears: function toYears() {
            return Math.round(numberOfHours / 8760);
        }
    };
};
var $9df22c2955f6da89$export$3cf5dda4201cc0f2 = function days(numberOfDays) {
    return {
        toMilliseconds: function toMilliseconds() {
            return Math.round(numberOfDays * 86400000);
        },
        toSeconds: function toSeconds() {
            return Math.round(numberOfDays * 86400);
        },
        toMinutes: function toMinutes() {
            return Math.round(numberOfDays * 1440);
        },
        toHours: function toHours() {
            return Math.round(numberOfDays * 24);
        },
        toDays: function toDays() {
            return Math.round(numberOfDays);
        },
        toWeeks: function toWeeks() {
            return Math.round(numberOfDays / 7);
        },
        toMonths: function toMonths() {
            return Math.round(numberOfDays / 30);
        },
        toYears: function toYears() {
            return Math.round(numberOfDays / 365);
        }
    };
};
var $9df22c2955f6da89$export$61d5ae0ccb45b636 = function weeks(numberOfWeeks) {
    return {
        toMilliseconds: function toMilliseconds() {
            return Math.round(numberOfWeeks * 604800000);
        },
        toSeconds: function toSeconds() {
            return Math.round(numberOfWeeks * 604800);
        },
        toMinutes: function toMinutes() {
            return Math.round(numberOfWeeks * 10080);
        },
        toHours: function toHours() {
            return Math.round(numberOfWeeks * 168);
        },
        toDays: function toDays() {
            return Math.round(numberOfWeeks * 7);
        },
        toWeeks: function toWeeks() {
            return Math.round(numberOfWeeks);
        },
        toMonths: function toMonths() {
            return Math.round(numberOfWeeks / 4.34524);
        },
        toYears: function toYears() {
            return Math.round(numberOfWeeks / 52.1429);
        }
    };
};
var $9df22c2955f6da89$export$16352d1b10c5eb38 = function months(numberOfMonths) {
    return {
        toMilliseconds: function toMilliseconds() {
            return Math.round(numberOfMonths * 2592000000);
        },
        toSeconds: function toSeconds() {
            return Math.round(numberOfMonths * 2592000);
        },
        toMinutes: function toMinutes() {
            return Math.round(numberOfMonths * 43200);
        },
        toHours: function toHours() {
            return Math.round(numberOfMonths * 720);
        },
        toDays: function toDays() {
            return Math.round(numberOfMonths * 30);
        },
        toWeeks: function toWeeks() {
            return Math.round(numberOfMonths * 30 / 7);
        },
        toMonths: function toMonths() {
            return Math.round(numberOfMonths);
        },
        toYears: function toYears() {
            return Math.round(numberOfMonths / 12);
        }
    };
};
var $9df22c2955f6da89$export$6fda41c7fb23acf9 = function years(numberOfYears) {
    return {
        toMilliseconds: function toMilliseconds() {
            return Math.round(numberOfYears * 31536000000);
        },
        toSeconds: function toSeconds() {
            return Math.round(numberOfYears * 31536000);
        },
        toMinutes: function toMinutes() {
            return Math.round(numberOfYears * 525600);
        },
        toHours: function toHours() {
            return Math.round(numberOfYears * 8760);
        },
        toDays: function toDays() {
            return Math.round(numberOfYears * 365);
        },
        toWeeks: function toWeeks() {
            return Math.round(numberOfYears * 365 / 7);
        },
        toMonths: function toMonths() {
            return Math.round(numberOfYears * 365 / 30);
        },
        toYears: function toYears() {
            return Math.round(numberOfYears);
        }
    };
};

});

parcelRegister("glI9a", function(module, exports) {

$parcel$export(module.exports, "fetchAPI", function () { return $be70da2c0479b487$export$23f83e165e686241; });

var $kSuI9 = parcelRequire("kSuI9");

var $do9pw = parcelRequire("do9pw");

var $l29cN = parcelRequire("l29cN");
var $be70da2c0479b487$export$23f83e165e686241 = function() {
    var _ref = (0, $kSuI9._)(function(url, initObj) {
        var baseURL, response, error;
        return (0, $l29cN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    baseURL = "/gateway/api";
                    if (location && location.hostname !== "www.atlassian.com") baseURL = "https://wac.stg.internal.atlassian.com" + baseURL;
                    return [
                        4,
                        fetch(baseURL + url, (0, $do9pw._)({
                            credentials: "include"
                        }, initObj))
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response
                    ];
                case 2:
                    error = _state.sent();
                    throw new Error((error instanceof Error ? error.message : JSON.stringify(error)) + " ".concat(url));
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchAPI(url, initObj) {
        return _ref.apply(this, arguments);
    };
}();

});



parcelRegister("cBZF0", function(module, exports) {

$parcel$export(module.exports, "useEntitlementListings", function () { return $92e8c530ad29ad4b$export$c365908a3399f244; });

var $kSuI9 = parcelRequire("kSuI9");

var $cv9Rk = parcelRequire("cv9Rk");

var $l29cN = parcelRequire("l29cN");

var $145N3 = parcelRequire("145N3");

var $5vvNu = parcelRequire("5vvNu");

var $1Mpn7 = parcelRequire("1Mpn7");

var $glI9a = parcelRequire("glI9a");

var $cVzdx = parcelRequire("cVzdx");
var $92e8c530ad29ad4b$var$formatPrice = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    style: "currency",
    currency: "USD",
    currencyDisplay: "code"
}).format;
var $92e8c530ad29ad4b$export$c365908a3399f244 = function(entitlements) {
    var createAnalyticsEvent = (0, $145N3.useAnalyticsEvents)().createAnalyticsEvent;
    var hasRun = (0, $1Mpn7.useRef)(false);
    var _useState = (0, $cv9Rk._)((0, $1Mpn7.useState)(false), 2), isFetching = _useState[0], setIsFetching = _useState[1];
    var _useState1 = (0, $cv9Rk._)((0, $1Mpn7.useState)(false), 2), hasError = _useState1[0], setHasError = _useState1[1];
    var _useState2 = (0, $cv9Rk._)((0, $1Mpn7.useState)(""), 2), formattedTotalPrice = _useState2[0], setFormattedTotalPrice = _useState2[1];
    var _useState3 = (0, $cv9Rk._)((0, $1Mpn7.useState)([]), 2), estimates = _useState3[0], setEstimates = _useState3[1];
    var fetchEstimates = function() {
        // only fetch (and only once) when we receive the entitlements
        if (entitlements.length === 0) return;
        if (hasRun.current === true) return;
        hasRun.current = true;
        var totalPrice = 0;
        var compiledEstimates = [];
        var entitlementById = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = entitlements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entitlement = _step.value;
                entitlementById[entitlement.entitlementId] = entitlement;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        (0, $kSuI9._)(function() {
            var allEstimateResponses, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, estimateResp, ok, status, statusText, _ref, entitlementId, items, item, chargeQuantity, total, chargeElement, quantity, entitlement, siteName, productAndPlanName, productKey, daysLeftInTrial, areDefined, estimate, err, error;
            return (0, $l29cN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            10,
                            ,
                            11
                        ]);
                        setIsFetching(true);
                        return [
                            4,
                            Promise.all(entitlements.map(function(param) {
                                var entitlementId = param.entitlementId;
                                return (0, $glI9a.fetchAPI)("/ccp/api/v1/bill/estimate?entitlementId=" + entitlementId);
                            }))
                        ];
                    case 1:
                        allEstimateResponses = _state.sent();
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            7,
                            8,
                            9
                        ]);
                        _iterator = allEstimateResponses[Symbol.iterator]();
                        _state.label = 3;
                    case 3:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            6
                        ];
                        estimateResp = _step.value;
                        ok = estimateResp.ok, status = estimateResp.status, statusText = estimateResp.statusText;
                        if (!ok) {
                            console.error("Call to /estimate for failed with error: ".concat(status, " ").concat(statusText));
                            createAnalyticsEvent({
                                action: "failed",
                                actionSubject: "Call to /estimate",
                                actionSubjectId: (0, $cVzdx.ACTION_SUBJECT_IDS).wacCartEstimateCallFailed,
                                attributes: {
                                    aaid: (0, (/*@__PURE__*/$parcel$interopDefault($5vvNu))).get("__aid_user_id"),
                                    error: "".concat(status, " for ccp entitlement id: ").concat(estimateResp.url.split("entitlementId=")[1])
                                }
                            }).fire();
                            return [
                                3,
                                5
                            ];
                        }
                        return [
                            4,
                            estimateResp.json()
                        ];
                    case 4:
                        _ref = _state.sent(), entitlementId = _ref.entitlementId, items = _ref.items;
                        if (!items || items.length === 0) {
                            console.error("Call to /estimate failed, 'items' were null or empty in response.");
                            createAnalyticsEvent({
                                action: "failed",
                                actionSubject: "Call to /estimate",
                                actionSubjectId: (0, $cVzdx.ACTION_SUBJECT_IDS).wacCartEstimateCallFailed,
                                attributes: {
                                    aaid: (0, (/*@__PURE__*/$parcel$interopDefault($5vvNu))).get("__aid_user_id"),
                                    error: "'items' were null or empty in response.",
                                    entitlementId: entitlementId
                                }
                            }).fire();
                            return [
                                3,
                                5
                            ];
                        }
                        item = items[0];
                        if (!item) return [
                            2
                        ];
                        chargeQuantity = item.chargeQuantity, total = item.total;
                        totalPrice += total;
                        chargeElement = chargeQuantity.chargeElement, quantity = chargeQuantity.quantity;
                        if (!quantity || Number.isNaN(parseInt(quantity)) || parseInt(quantity) === 0) createAnalyticsEvent({
                            action: "failed",
                            actionSubject: "Call to /estimate",
                            actionSubjectId: (0, $cVzdx.ACTION_SUBJECT_IDS).wacCartEstimateCallFailed,
                            attributes: {
                                aaid: (0, (/*@__PURE__*/$parcel$interopDefault($5vvNu))).get("__aid_user_id"),
                                error: "/estimate returned entitlement with zero users",
                                entitlementId: entitlementId
                            }
                        }).fire();
                        entitlement = entitlementById[entitlementId];
                        if (entitlement) {
                            siteName = entitlement.siteName, productAndPlanName = entitlement.productAndPlanName, productKey = entitlement.productKey, daysLeftInTrial = entitlement.daysLeftInTrial;
                            areDefined = [
                                siteName,
                                productAndPlanName
                            ].every(function(v) {
                                return v !== undefined;
                            });
                            if (areDefined) {
                                estimate = {
                                    entitlementId: entitlementId,
                                    siteName: siteName,
                                    productAndPlanName: productAndPlanName,
                                    productKey: productKey,
                                    daysLeftInTrial: daysLeftInTrial,
                                    formattedTotalPrice: $92e8c530ad29ad4b$var$formatPrice(total),
                                    usersPriceBreakdown: "".concat(quantity, " ").concat(chargeElement).concat(parseInt(quantity) === 1 ? "" : "s", " x $").concat(total / parseInt(quantity), " each")
                                };
                                compiledEstimates.push(estimate);
                            }
                        }
                        _state.label = 5;
                    case 5:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            3
                        ];
                    case 6:
                        return [
                            3,
                            9
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            9
                        ];
                    case 8:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 9:
                        setHasError(false);
                        return [
                            3,
                            11
                        ];
                    case 10:
                        error = _state.sent();
                        createAnalyticsEvent({
                            action: "failed",
                            actionSubject: "useEntitlementListings hook",
                            actionSubjectId: (0, $cVzdx.ACTION_SUBJECT_IDS).wacCartUseEntitlementListingsFailed,
                            attributes: {
                                aaid: (0, (/*@__PURE__*/$parcel$interopDefault($5vvNu))).get("__aid_user_id"),
                                error: error instanceof Error ? error.message : JSON.stringify(error)
                            }
                        }).fire();
                        setHasError(true);
                        return [
                            3,
                            11
                        ];
                    case 11:
                        setIsFetching(false);
                        setFormattedTotalPrice($92e8c530ad29ad4b$var$formatPrice(totalPrice));
                        setEstimates(compiledEstimates);
                        return [
                            2
                        ];
                }
            });
        })();
    };
    return [
        formattedTotalPrice,
        estimates,
        fetchEstimates,
        isFetching,
        hasError
    ];
};

});




parcelRegister("iEnWS", function(module, exports) {

$parcel$export(module.exports, "versionDefinitionV0", function () { return $d93e8a2425a64679$export$6fa5f6e5033b415a; });
parcelRequire("cdW0a");
var $5wFXF = parcelRequire("5wFXF");
var $d93e8a2425a64679$export$6fa5f6e5033b415a = (0, $5wFXF.createModuleDefinitionVersion)({
    label: "admin-trial-cart",
    description: "Cart-like UI for trialling JSW &amp; Confluence admins.",
    status: "active",
    channels: [
        "web",
        "mobile",
        "desktop"
    ],
    fieldDefinitions: []
});

});
parcelRegister("cdW0a", function(module, exports) {
$parcel$export(module.exports, "createModuleDefinitionVersion", function () { return (parcelRequire("5wFXF")).createModuleDefinitionVersion; });
$parcel$export(module.exports, "WebModuleDefinitionSchema", function () { return (parcelRequire("5wFXF")).WebModuleDefinitionSchema; });
$parcel$export(module.exports, "WebSurfaceDefinitionSchema", function () { return (parcelRequire("ffAbx")).WebSurfaceDefinitionSchema; });
$parcel$export(module.exports, "createDefinition", function () { return (parcelRequire("9nSI5")).createDefinition; });
parcelRequire("5wFXF");
parcelRequire("1UF5x");
parcelRequire("kMkgL");
parcelRequire("4M9am");
parcelRequire("l64XM");
parcelRequire("5X9vN");
parcelRequire("5IyZO");
parcelRequire("ffAbx");
parcelRequire("9nSI5");
parcelRequire("3rI61");
parcelRequire("9lSQT");
parcelRequire("jh3Cr");

});
parcelRegister("5wFXF", function(module, exports) {

$parcel$export(module.exports, "WebModuleDefinitionSchema", function () { return $40607d9395d9098f$export$14c7b41aa13a15bb; });
$parcel$export(module.exports, "createModuleDefinitionVersion", function () { return $40607d9395d9098f$export$4b6d85303c9df03c; });

var $jZoZ7 = parcelRequire("jZoZ7");
parcelRequire("5IyZO");
var $1n4ry = parcelRequire("1n4ry");
var $kzlGA = parcelRequire("kzlGA");
var $kjOdg = parcelRequire("kjOdg");

var $4M9am = parcelRequire("4M9am");
var $40607d9395d9098f$export$91d4e2d038ed36ae = (0, $jZoZ7.z).object({
    label: (0, $jZoZ7.z).string(),
    description: (0, $jZoZ7.z).string(),
    status: (0, $1n4ry.DefinitionStatusSchema),
    channels: (0, $jZoZ7.z).array((0, $kzlGA.ChannelSchema)),
    fieldDefinitions: (0, $jZoZ7.z).array((0, $kjOdg.FieldDefinitionSchema)),
    zonesDefinitions: (0, $jZoZ7.z).array((0, $4M9am.ZoneDefinitionSchema)).optional(),
    validations: (0, $jZoZ7.z).object({
        surfaceRestrictions: (0, $jZoZ7.z).array((0, $jZoZ7.z).object({
            name: (0, $jZoZ7.z).string().optional(),
            version: (0, $jZoZ7.z).string().optional()
        })).optional()
    }).optional()
});
var $40607d9395d9098f$export$2502f45110246a11 = (0, $jZoZ7.z).record((0, $jZoZ7.z).string(), $40607d9395d9098f$export$91d4e2d038ed36ae);
var $40607d9395d9098f$export$14c7b41aa13a15bb = (0, $jZoZ7.z).object({
    name: (0, $jZoZ7.z).string(),
    schema: (0, $jZoZ7.z).string(),
    type: (0, $jZoZ7.z).literal("module"),
    versions: $40607d9395d9098f$export$2502f45110246a11
});
function $40607d9395d9098f$export$4b6d85303c9df03c(moduleDefinition) {
    return $40607d9395d9098f$export$91d4e2d038ed36ae.parse(moduleDefinition);
}

});
parcelRegister("jZoZ7", function(module, exports) {

$parcel$export(module.exports, "z", function () { return z; });

var $d3H5E = parcelRequire("d3H5E");

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $3sHb8 = parcelRequire("3sHb8");

var $dcsZi = parcelRequire("dcsZi");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");

var $l0HdX = parcelRequire("l0HdX");

var $FuVm8 = parcelRequire("FuVm8");

var $ohfOJ = parcelRequire("ohfOJ");

var $l29cN = parcelRequire("l29cN");
var util;
(function(util) {
    util.assertEqual = function(val) {
        return val;
    };
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = function(items) {
        var obj = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var item = _step.value;
                obj[item] = item;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return obj;
    };
    util.getValidEnumValues = function(obj) {
        var validKeys = util.objectKeys(obj).filter(function(k) {
            return typeof obj[obj[k]] !== "number";
        });
        var filtered = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = validKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var k = _step.value;
                filtered[k] = obj[k];
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return util.objectValues(filtered);
    };
    util.objectValues = function(obj) {
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? function(obj) {
        return Object.keys(obj) // eslint-disable-line ban/ban
        ;
    } : function(object) {
        var keys = [];
        for(var key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = function(arr, checker) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = arr[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var item = _step.value;
                if (checker(item)) return item;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? function(val) {
        return Number.isInteger(val) // eslint-disable-line ban/ban
        ;
    } : function(val) {
        return typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    };
    function joinValues(array) {
        var separator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : " | ";
        return array.map(function(val) {
            return typeof val === "string" ? "'".concat(val, "'") : val;
        }).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = function(_, value) {
        if ((typeof value === "undefined" ? "undefined" : (0, $l0HdX._)(value)) === "bigint") return value.toString();
        return value;
    };
})(util || (util = {}));
var objectUtil;
(function(objectUtil) {
    objectUtil.mergeShapes = function(first, second) {
        return (0, $do9pw._)({}, first, second);
    };
})(objectUtil || (objectUtil = {}));
var ZodParsedType = util.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
var getParsedType = function(data) {
    var t = typeof data === "undefined" ? "undefined" : (0, $l0HdX._)(data);
    switch(t){
        case "undefined":
            return ZodParsedType.undefined;
        case "string":
            return ZodParsedType.string;
        case "number":
            return isNaN(data) ? ZodParsedType.nan : ZodParsedType.number;
        case "boolean":
            return ZodParsedType.boolean;
        case "function":
            return ZodParsedType.function;
        case "bigint":
            return ZodParsedType.bigint;
        case "symbol":
            return ZodParsedType.symbol;
        case "object":
            if (Array.isArray(data)) return ZodParsedType.array;
            if (data === null) return ZodParsedType.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return ZodParsedType.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return ZodParsedType.map;
            if (typeof Set !== "undefined" && data instanceof Set) return ZodParsedType.set;
            if (typeof Date !== "undefined" && data instanceof Date) return ZodParsedType.date;
            return ZodParsedType.object;
        default:
            return ZodParsedType.unknown;
    }
};
var ZodIssueCode = util.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
var quotelessJson = function(obj) {
    var json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
var ZodError = /*#__PURE__*/ function _target(Error1) {
    "use strict";
    (0, $dcsZi._)(ZodError, Error1);
    var _super = (0, $ohfOJ._)(ZodError);
    function ZodError(issues) {
        (0, $4GJKx._)(this, ZodError);
        var _this;
        _this = _super.call(this);
        _this.issues = [];
        _this.addIssue = function(sub) {
            _this.issues = (0, $c6Xmf._)(_this.issues).concat([
                sub
            ]);
        };
        _this.addIssues = function() {
            var subs = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
            _this.issues = (0, $c6Xmf._)(_this.issues).concat((0, $c6Xmf._)(subs));
        };
        var actualProto = (this instanceof ZodError ? this.constructor : void 0).prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf((0, $d3H5E._)(_this), actualProto);
        else _this.__proto__ = actualProto;
        _this.name = "ZodError";
        _this.issues = issues;
        return _this;
    }
    (0, $1wc17._)(ZodError, [
        {
            key: "errors",
            get: function get() {
                return this.issues;
            }
        },
        {
            key: "format",
            value: function format(_mapper) {
                var mapper = _mapper || function(issue) {
                    return issue.message;
                };
                var fieldErrors = {
                    _errors: []
                };
                var processError = function(error) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = error.issues[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var issue = _step.value;
                            if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                            else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                            else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                            else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                            else {
                                var curr = fieldErrors;
                                var i = 0;
                                while(i < issue.path.length){
                                    var el = issue.path[i];
                                    var terminal = i === issue.path.length - 1;
                                    if (!terminal) curr[el] = curr[el] || {
                                        _errors: []
                                    };
                                    else {
                                        curr[el] = curr[el] || {
                                            _errors: []
                                        };
                                        curr[el]._errors.push(mapper(issue));
                                    }
                                    curr = curr[el];
                                    i++;
                                }
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                };
                processError(this);
                return fieldErrors;
            }
        },
        {
            key: "toString",
            value: function toString() {
                return this.message;
            }
        },
        {
            key: "message",
            get: function get() {
                return JSON.stringify(this.issues, util.jsonStringifyReplacer, 2);
            }
        },
        {
            key: "isEmpty",
            get: function get() {
                return this.issues.length === 0;
            }
        },
        {
            key: "flatten",
            value: function flatten() {
                var mapper = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function(issue) {
                    return issue.message;
                };
                var fieldErrors = {};
                var formErrors = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.issues[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var sub = _step.value;
                        if (sub.path.length > 0) {
                            fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
                            fieldErrors[sub.path[0]].push(mapper(sub));
                        } else formErrors.push(mapper(sub));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return {
                    formErrors: formErrors,
                    fieldErrors: fieldErrors
                };
            }
        },
        {
            key: "formErrors",
            get: function get() {
                return this.flatten();
            }
        }
    ]);
    return ZodError;
}((0, $FuVm8._)(Error));
ZodError.create = function(issues) {
    var error = new ZodError(issues);
    return error;
};
var errorMap = function(issue, _ctx) {
    var message;
    switch(issue.code){
        case ZodIssueCode.invalid_type:
            if (issue.received === ZodParsedType.undefined) message = "Required";
            else message = "Expected ".concat(issue.expected, ", received ").concat(issue.received);
            break;
        case ZodIssueCode.invalid_literal:
            message = "Invalid literal value, expected ".concat(JSON.stringify(issue.expected, util.jsonStringifyReplacer));
            break;
        case ZodIssueCode.unrecognized_keys:
            message = "Unrecognized key(s) in object: ".concat(util.joinValues(issue.keys, ", "));
            break;
        case ZodIssueCode.invalid_union:
            message = "Invalid input";
            break;
        case ZodIssueCode.invalid_union_discriminator:
            message = "Invalid discriminator value. Expected ".concat(util.joinValues(issue.options));
            break;
        case ZodIssueCode.invalid_enum_value:
            message = "Invalid enum value. Expected ".concat(util.joinValues(issue.options), ", received '").concat(issue.received, "'");
            break;
        case ZodIssueCode.invalid_arguments:
            message = "Invalid function arguments";
            break;
        case ZodIssueCode.invalid_return_type:
            message = "Invalid function return type";
            break;
        case ZodIssueCode.invalid_date:
            message = "Invalid date";
            break;
        case ZodIssueCode.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = 'Invalid input: must include "'.concat(issue.validation.includes, '"');
                    if (typeof issue.validation.position === "number") message = "".concat(message, " at one or more positions greater than or equal to ").concat(issue.validation.position);
                } else if ("startsWith" in issue.validation) message = 'Invalid input: must start with "'.concat(issue.validation.startsWith, '"');
                else if ("endsWith" in issue.validation) message = 'Invalid input: must end with "'.concat(issue.validation.endsWith, '"');
                else util.assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = "Invalid ".concat(issue.validation);
            else message = "Invalid";
            break;
        case ZodIssueCode.too_small:
            if (issue.type === "array") message = "Array must contain ".concat(issue.exact ? "exactly" : issue.inclusive ? "at least" : "more than", " ").concat(issue.minimum, " element(s)");
            else if (issue.type === "string") message = "String must contain ".concat(issue.exact ? "exactly" : issue.inclusive ? "at least" : "over", " ").concat(issue.minimum, " character(s)");
            else if (issue.type === "number") message = "Number must be ".concat(issue.exact ? "exactly equal to " : issue.inclusive ? "greater than or equal to " : "greater than ").concat(issue.minimum);
            else if (issue.type === "date") message = "Date must be ".concat(issue.exact ? "exactly equal to " : issue.inclusive ? "greater than or equal to " : "greater than ").concat(new Date(Number(issue.minimum)));
            else message = "Invalid input";
            break;
        case ZodIssueCode.too_big:
            if (issue.type === "array") message = "Array must contain ".concat(issue.exact ? "exactly" : issue.inclusive ? "at most" : "less than", " ").concat(issue.maximum, " element(s)");
            else if (issue.type === "string") message = "String must contain ".concat(issue.exact ? "exactly" : issue.inclusive ? "at most" : "under", " ").concat(issue.maximum, " character(s)");
            else if (issue.type === "number") message = "Number must be ".concat(issue.exact ? "exactly" : issue.inclusive ? "less than or equal to" : "less than", " ").concat(issue.maximum);
            else if (issue.type === "bigint") message = "BigInt must be ".concat(issue.exact ? "exactly" : issue.inclusive ? "less than or equal to" : "less than", " ").concat(issue.maximum);
            else if (issue.type === "date") message = "Date must be ".concat(issue.exact ? "exactly" : issue.inclusive ? "smaller than or equal to" : "smaller than", " ").concat(new Date(Number(issue.maximum)));
            else message = "Invalid input";
            break;
        case ZodIssueCode.custom:
            message = "Invalid input";
            break;
        case ZodIssueCode.invalid_intersection_types:
            message = "Intersection results could not be merged";
            break;
        case ZodIssueCode.not_multiple_of:
            message = "Number must be a multiple of ".concat(issue.multipleOf);
            break;
        case ZodIssueCode.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            util.assertNever(issue);
    }
    return {
        message: message
    };
};
var overrideErrorMap = errorMap;
function setErrorMap(map) {
    overrideErrorMap = map;
}
function getErrorMap() {
    return overrideErrorMap;
}
var makeIssue = function(params) {
    var data = params.data, path = params.path, errorMaps = params.errorMaps, issueData = params.issueData;
    var fullPath = (0, $c6Xmf._)(path).concat((0, $c6Xmf._)(issueData.path || []));
    var fullIssue = (0, $cxjpp._)((0, $do9pw._)({}, issueData), {
        path: fullPath
    });
    var errorMessage = "";
    var maps = errorMaps.filter(function(m) {
        return !!m;
    }).slice().reverse();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = maps[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var map = _step.value;
            errorMessage = map(fullIssue, {
                data: data,
                defaultError: errorMessage
            }).message;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return (0, $cxjpp._)((0, $do9pw._)({}, issueData), {
        path: fullPath,
        message: issueData.message || errorMessage
    });
};
var EMPTY_PATH = [];
function addIssueToContext(ctx, issueData) {
    var issue = makeIssue({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            getErrorMap(),
            errorMap
        ].filter(function(x) {
            return !!x;
        })
    });
    ctx.common.issues.push(issue);
}
var ParseStatus = /*#__PURE__*/ function() {
    "use strict";
    function ParseStatus() {
        (0, $4GJKx._)(this, ParseStatus);
        this.value = "valid";
    }
    (0, $1wc17._)(ParseStatus, [
        {
            key: "dirty",
            value: function dirty() {
                if (this.value === "valid") this.value = "dirty";
            }
        },
        {
            key: "abort",
            value: function abort() {
                if (this.value !== "aborted") this.value = "aborted";
            }
        }
    ], [
        {
            key: "mergeArray",
            value: function mergeArray(status, results) {
                var arrayValue = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = results[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var s = _step.value;
                        if (s.status === "aborted") return INVALID;
                        if (s.status === "dirty") status.dirty();
                        arrayValue.push(s.value);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return {
                    status: status.value,
                    value: arrayValue
                };
            }
        },
        {
            key: "mergeObjectAsync",
            value: function mergeObjectAsync(status, pairs) {
                return (0, $kSuI9._)(function() {
                    var syncPairs, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, pair, _, _tmp, err;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                syncPairs = [];
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    7,
                                    8,
                                    9
                                ]);
                                _iterator = pairs[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    6
                                ];
                                pair = _step.value;
                                _ = syncPairs.push;
                                _tmp = {};
                                return [
                                    4,
                                    pair.key
                                ];
                            case 3:
                                _tmp.key = _state.sent();
                                return [
                                    4,
                                    pair.value
                                ];
                            case 4:
                                _.apply(syncPairs, [
                                    (_tmp.value = _state.sent(), _tmp)
                                ]);
                                _state.label = 5;
                            case 5:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    2
                                ];
                            case 6:
                                return [
                                    3,
                                    9
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    9
                                ];
                            case 8:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 9:
                                return [
                                    2,
                                    ParseStatus.mergeObjectSync(status, syncPairs)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "mergeObjectSync",
            value: function mergeObjectSync(status, pairs) {
                var finalObject = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = pairs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var pair = _step.value;
                        var key = pair.key, value = pair.value;
                        if (key.status === "aborted") return INVALID;
                        if (value.status === "aborted") return INVALID;
                        if (key.status === "dirty") status.dirty();
                        if (value.status === "dirty") status.dirty();
                        if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return {
                    status: status.value,
                    value: finalObject
                };
            }
        }
    ]);
    return ParseStatus;
}();
var INVALID = Object.freeze({
    status: "aborted"
});
var DIRTY = function(value) {
    return {
        status: "dirty",
        value: value
    };
};
var OK = function(value) {
    return {
        status: "valid",
        value: value
    };
};
var isAborted = function(x) {
    return x.status === "aborted";
};
var isDirty = function(x) {
    return x.status === "dirty";
};
var isValid = function(x) {
    return x.status === "valid";
};
var isAsync = function(x) {
    return typeof Promise !== "undefined" && x instanceof Promise;
};
var errorUtil;
(function(errorUtil) {
    errorUtil.errToObj = function(message) {
        return typeof message === "string" ? {
            message: message
        } : message || {};
    };
    errorUtil.toString = function(message) {
        return typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
    };
})(errorUtil || (errorUtil = {}));
var ParseInputLazyPath = /*#__PURE__*/ function() {
    "use strict";
    function ParseInputLazyPath(parent, value, path, key) {
        (0, $4GJKx._)(this, ParseInputLazyPath);
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    (0, $1wc17._)(ParseInputLazyPath, [
        {
            key: "path",
            get: function get() {
                if (!this._cachedPath.length) {
                    var _this__cachedPath, _this__cachedPath1;
                    if (this._key instanceof Array) (_this__cachedPath = this._cachedPath).push.apply(_this__cachedPath, (0, $c6Xmf._)(this._path).concat((0, $c6Xmf._)(this._key)));
                    else (_this__cachedPath1 = this._cachedPath).push.apply(_this__cachedPath1, (0, $c6Xmf._)(this._path).concat([
                        this._key
                    ]));
                }
                return this._cachedPath;
            }
        }
    ]);
    return ParseInputLazyPath;
}();
var handleResult = function(ctx, result) {
    if (isValid(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                var error = new ZodError(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function processCreateParams(params) {
    if (!params) return {};
    var errorMap = params.errorMap, invalid_type_error = params.invalid_type_error, required_error = params.required_error, description = params.description;
    if (errorMap && (invalid_type_error || required_error)) throw new Error('Can\'t use "invalid_type_error" or "required_error" in conjunction with custom error map.');
    if (errorMap) return {
        errorMap: errorMap,
        description: description
    };
    var customMap = function(iss, ctx) {
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: required_error !== null && required_error !== void 0 ? required_error : ctx.defaultError
        };
        return {
            message: invalid_type_error !== null && invalid_type_error !== void 0 ? invalid_type_error : ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description: description
    };
}
var ZodType = /*#__PURE__*/ function() {
    "use strict";
    function ZodType(def) {
        (0, $4GJKx._)(this, ZodType);
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
    }
    (0, $1wc17._)(ZodType, [
        {
            key: "description",
            get: function get() {
                return this._def.description;
            }
        },
        {
            key: "_getType",
            value: function _getType(input) {
                return getParsedType(input.data);
            }
        },
        {
            key: "_getOrReturnCtx",
            value: function _getOrReturnCtx(input, ctx) {
                return ctx || {
                    common: input.parent.common,
                    data: input.data,
                    parsedType: getParsedType(input.data),
                    schemaErrorMap: this._def.errorMap,
                    path: input.path,
                    parent: input.parent
                };
            }
        },
        {
            key: "_processInputParams",
            value: function _processInputParams(input) {
                return {
                    status: new ParseStatus(),
                    ctx: {
                        common: input.parent.common,
                        data: input.data,
                        parsedType: getParsedType(input.data),
                        schemaErrorMap: this._def.errorMap,
                        path: input.path,
                        parent: input.parent
                    }
                };
            }
        },
        {
            key: "_parseSync",
            value: function _parseSync(input) {
                var result = this._parse(input);
                if (isAsync(result)) throw new Error("Synchronous parse encountered promise.");
                return result;
            }
        },
        {
            key: "_parseAsync",
            value: function _parseAsync(input) {
                var result = this._parse(input);
                return Promise.resolve(result);
            }
        },
        {
            key: "parse",
            value: function parse(data, params) {
                var result = this.safeParse(data, params);
                if (result.success) return result.data;
                throw result.error;
            }
        },
        {
            key: "safeParse",
            value: function safeParse(data, params) {
                var _a;
                var ctx = {
                    common: {
                        issues: [],
                        async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                        contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
                    },
                    path: (params === null || params === void 0 ? void 0 : params.path) || [],
                    schemaErrorMap: this._def.errorMap,
                    parent: null,
                    data: data,
                    parsedType: getParsedType(data)
                };
                var result = this._parseSync({
                    data: data,
                    path: ctx.path,
                    parent: ctx
                });
                return handleResult(ctx, result);
            }
        },
        {
            key: "parseAsync",
            value: function parseAsync(data, params) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var result;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.safeParseAsync(data, params)
                                ];
                            case 1:
                                result = _state.sent();
                                if (result.success) return [
                                    2,
                                    result.data
                                ];
                                throw result.error;
                        }
                    });
                })();
            }
        },
        {
            key: "safeParseAsync",
            value: function safeParseAsync(data, params) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var ctx, maybeAsyncResult, result;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                ctx = {
                                    common: {
                                        issues: [],
                                        contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                                        async: true
                                    },
                                    path: (params === null || params === void 0 ? void 0 : params.path) || [],
                                    schemaErrorMap: _this._def.errorMap,
                                    parent: null,
                                    data: data,
                                    parsedType: getParsedType(data)
                                };
                                maybeAsyncResult = _this._parse({
                                    data: data,
                                    path: ctx.path,
                                    parent: ctx
                                });
                                return [
                                    4,
                                    isAsync(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult)
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    handleResult(ctx, result)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "refine",
            value: function refine(check, message) {
                var getIssueProperties = function(val) {
                    if (typeof message === "string" || typeof message === "undefined") return {
                        message: message
                    };
                    else if (typeof message === "function") return message(val);
                    else return message;
                };
                return this._refinement(function(val, ctx) {
                    var result = check(val);
                    var setError = function() {
                        return ctx.addIssue((0, $do9pw._)({
                            code: ZodIssueCode.custom
                        }, getIssueProperties(val)));
                    };
                    if (typeof Promise !== "undefined" && result instanceof Promise) return result.then(function(data) {
                        if (!data) {
                            setError();
                            return false;
                        } else return true;
                    });
                    if (!result) {
                        setError();
                        return false;
                    } else return true;
                });
            }
        },
        {
            key: "refinement",
            value: function refinement(check, refinementData) {
                return this._refinement(function(val, ctx) {
                    if (!check(val)) {
                        ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                        return false;
                    } else return true;
                });
            }
        },
        {
            key: "_refinement",
            value: function _refinement(refinement) {
                return new ZodEffects({
                    schema: this,
                    typeName: ZodFirstPartyTypeKind.ZodEffects,
                    effect: {
                        type: "refinement",
                        refinement: refinement
                    }
                });
            }
        },
        {
            key: "superRefine",
            value: function superRefine(refinement) {
                return this._refinement(refinement);
            }
        },
        {
            key: "optional",
            value: function optional() {
                return ZodOptional.create(this, this._def);
            }
        },
        {
            key: "nullable",
            value: function nullable() {
                return ZodNullable.create(this, this._def);
            }
        },
        {
            key: "nullish",
            value: function nullish() {
                return this.nullable().optional();
            }
        },
        {
            key: "array",
            value: function array() {
                return ZodArray.create(this, this._def);
            }
        },
        {
            key: "promise",
            value: function promise() {
                return ZodPromise.create(this, this._def);
            }
        },
        {
            key: "or",
            value: function or(option) {
                return ZodUnion.create([
                    this,
                    option
                ], this._def);
            }
        },
        {
            key: "and",
            value: function and(incoming) {
                return ZodIntersection.create(this, incoming, this._def);
            }
        },
        {
            key: "transform",
            value: function transform(transform) {
                return new ZodEffects((0, $cxjpp._)((0, $do9pw._)({}, processCreateParams(this._def)), {
                    schema: this,
                    typeName: ZodFirstPartyTypeKind.ZodEffects,
                    effect: {
                        type: "transform",
                        transform: transform
                    }
                }));
            }
        },
        {
            key: "default",
            value: function _default(def) {
                var defaultValueFunc = typeof def === "function" ? def : function() {
                    return def;
                };
                return new ZodDefault((0, $cxjpp._)((0, $do9pw._)({}, processCreateParams(this._def)), {
                    innerType: this,
                    defaultValue: defaultValueFunc,
                    typeName: ZodFirstPartyTypeKind.ZodDefault
                }));
            }
        },
        {
            key: "brand",
            value: function brand() {
                return new ZodBranded((0, $do9pw._)({
                    typeName: ZodFirstPartyTypeKind.ZodBranded,
                    type: this
                }, processCreateParams(this._def)));
            }
        },
        {
            key: "catch",
            value: function _catch(def) {
                var catchValueFunc = typeof def === "function" ? def : function() {
                    return def;
                };
                return new ZodCatch((0, $cxjpp._)((0, $do9pw._)({}, processCreateParams(this._def)), {
                    innerType: this,
                    catchValue: catchValueFunc,
                    typeName: ZodFirstPartyTypeKind.ZodCatch
                }));
            }
        },
        {
            key: "describe",
            value: function describe(description) {
                var This = this.constructor;
                return new This((0, $cxjpp._)((0, $do9pw._)({}, this._def), {
                    description: description
                }));
            }
        },
        {
            key: "pipe",
            value: function pipe(target) {
                return ZodPipeline.create(this, target);
            }
        },
        {
            key: "readonly",
            value: function readonly() {
                return ZodReadonly.create(this);
            }
        },
        {
            key: "isOptional",
            value: function isOptional() {
                return this.safeParse(undefined).success;
            }
        },
        {
            key: "isNullable",
            value: function isNullable() {
                return this.safeParse(null).success;
            }
        }
    ]);
    return ZodType;
}();
var cuidRegex = /^c[^\s-]{8,}$/i;
var cuid2Regex = /^[a-z][a-z0-9]*$/;
var ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
var uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
var emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_+-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
var _emojiRegex = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
var emojiRegex;
var ipv4Regex = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/;
var ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
// Adapted from https://stackoverflow.com/a/3143231
var datetimeRegex = function(args) {
    if (args.precision) {
        if (args.offset) return new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{".concat(args.precision, "}(([+-]\\d{2}(:?\\d{2})?)|Z)$"));
        else return new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{".concat(args.precision, "}Z$"));
    } else if (args.precision === 0) {
        if (args.offset) return new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$");
        else return new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$");
    } else {
        if (args.offset) return new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$");
        else return new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$");
    }
};
function isValidIP(ip, version) {
    if ((version === "v4" || !version) && ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && ipv6Regex.test(ip)) return true;
    return false;
}
var ZodString = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodString, ZodType);
    var _super = (0, $ohfOJ._)(ZodString);
    function ZodString() {
        (0, $4GJKx._)(this, ZodString);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodString, [
        {
            key: "_parse",
            value: function _parse(input) {
                if (this._def.coerce) input.data = String(input.data);
                var parsedType = this._getType(input);
                if (parsedType !== ZodParsedType.string) {
                    var ctx = this._getOrReturnCtx(input);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: ZodParsedType.string,
                        received: ctx.parsedType
                    });
                    return INVALID;
                }
                var status = new ParseStatus();
                var ctx1 = undefined;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var check = _step.value;
                        if (check.kind === "min") {
                            if (input.data.length < check.value) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    code: ZodIssueCode.too_small,
                                    minimum: check.value,
                                    type: "string",
                                    inclusive: true,
                                    exact: false,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "max") {
                            if (input.data.length > check.value) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    code: ZodIssueCode.too_big,
                                    maximum: check.value,
                                    type: "string",
                                    inclusive: true,
                                    exact: false,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "length") {
                            var tooBig = input.data.length > check.value;
                            var tooSmall = input.data.length < check.value;
                            if (tooBig || tooSmall) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                if (tooBig) addIssueToContext(ctx1, {
                                    code: ZodIssueCode.too_big,
                                    maximum: check.value,
                                    type: "string",
                                    inclusive: true,
                                    exact: true,
                                    message: check.message
                                });
                                else if (tooSmall) addIssueToContext(ctx1, {
                                    code: ZodIssueCode.too_small,
                                    minimum: check.value,
                                    type: "string",
                                    inclusive: true,
                                    exact: true,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "email") {
                            if (!emailRegex.test(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    validation: "email",
                                    code: ZodIssueCode.invalid_string,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "emoji") {
                            if (!emojiRegex) emojiRegex = new RegExp(_emojiRegex, "u");
                            if (!emojiRegex.test(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    validation: "emoji",
                                    code: ZodIssueCode.invalid_string,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "uuid") {
                            if (!uuidRegex.test(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    validation: "uuid",
                                    code: ZodIssueCode.invalid_string,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "cuid") {
                            if (!cuidRegex.test(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    validation: "cuid",
                                    code: ZodIssueCode.invalid_string,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "cuid2") {
                            if (!cuid2Regex.test(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    validation: "cuid2",
                                    code: ZodIssueCode.invalid_string,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "ulid") {
                            if (!ulidRegex.test(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    validation: "ulid",
                                    code: ZodIssueCode.invalid_string,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "url") try {
                            new URL(input.data);
                        } catch (_a) {
                            ctx1 = this._getOrReturnCtx(input, ctx1);
                            addIssueToContext(ctx1, {
                                validation: "url",
                                code: ZodIssueCode.invalid_string,
                                message: check.message
                            });
                            status.dirty();
                        }
                        else if (check.kind === "regex") {
                            check.regex.lastIndex = 0;
                            var testResult = check.regex.test(input.data);
                            if (!testResult) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    validation: "regex",
                                    code: ZodIssueCode.invalid_string,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "trim") input.data = input.data.trim();
                        else if (check.kind === "includes") {
                            if (!input.data.includes(check.value, check.position)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    code: ZodIssueCode.invalid_string,
                                    validation: {
                                        includes: check.value,
                                        position: check.position
                                    },
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
                        else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
                        else if (check.kind === "startsWith") {
                            if (!input.data.startsWith(check.value)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    code: ZodIssueCode.invalid_string,
                                    validation: {
                                        startsWith: check.value
                                    },
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "endsWith") {
                            if (!input.data.endsWith(check.value)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    code: ZodIssueCode.invalid_string,
                                    validation: {
                                        endsWith: check.value
                                    },
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "datetime") {
                            var regex = datetimeRegex(check);
                            if (!regex.test(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    code: ZodIssueCode.invalid_string,
                                    validation: "datetime",
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "ip") {
                            if (!isValidIP(input.data, check.version)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    validation: "ip",
                                    code: ZodIssueCode.invalid_string,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else util.assertNever(check);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return {
                    status: status.value,
                    value: input.data
                };
            }
        },
        {
            key: "_regex",
            value: function _regex(regex, validation, message) {
                return this.refinement(function(data) {
                    return regex.test(data);
                }, (0, $do9pw._)({
                    validation: validation,
                    code: ZodIssueCode.invalid_string
                }, errorUtil.errToObj(message)));
            }
        },
        {
            key: "_addCheck",
            value: function _addCheck(check) {
                return new ZodString((0, $cxjpp._)((0, $do9pw._)({}, this._def), {
                    checks: (0, $c6Xmf._)(this._def.checks).concat([
                        check
                    ])
                }));
            }
        },
        {
            key: "email",
            value: function email(message) {
                return this._addCheck((0, $do9pw._)({
                    kind: "email"
                }, errorUtil.errToObj(message)));
            }
        },
        {
            key: "url",
            value: function url(message) {
                return this._addCheck((0, $do9pw._)({
                    kind: "url"
                }, errorUtil.errToObj(message)));
            }
        },
        {
            key: "emoji",
            value: function emoji(message) {
                return this._addCheck((0, $do9pw._)({
                    kind: "emoji"
                }, errorUtil.errToObj(message)));
            }
        },
        {
            key: "uuid",
            value: function uuid(message) {
                return this._addCheck((0, $do9pw._)({
                    kind: "uuid"
                }, errorUtil.errToObj(message)));
            }
        },
        {
            key: "cuid",
            value: function cuid(message) {
                return this._addCheck((0, $do9pw._)({
                    kind: "cuid"
                }, errorUtil.errToObj(message)));
            }
        },
        {
            key: "cuid2",
            value: function cuid2(message) {
                return this._addCheck((0, $do9pw._)({
                    kind: "cuid2"
                }, errorUtil.errToObj(message)));
            }
        },
        {
            key: "ulid",
            value: function ulid(message) {
                return this._addCheck((0, $do9pw._)({
                    kind: "ulid"
                }, errorUtil.errToObj(message)));
            }
        },
        {
            key: "ip",
            value: function ip(options) {
                return this._addCheck((0, $do9pw._)({
                    kind: "ip"
                }, errorUtil.errToObj(options)));
            }
        },
        {
            key: "datetime",
            value: function datetime(options) {
                var _a;
                if (typeof options === "string") return this._addCheck({
                    kind: "datetime",
                    precision: null,
                    offset: false,
                    message: options
                });
                return this._addCheck((0, $do9pw._)({
                    kind: "datetime",
                    precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
                    offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false
                }, errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)));
            }
        },
        {
            key: "regex",
            value: function regex(regex, message) {
                return this._addCheck((0, $do9pw._)({
                    kind: "regex",
                    regex: regex
                }, errorUtil.errToObj(message)));
            }
        },
        {
            key: "includes",
            value: function includes(value, options) {
                return this._addCheck((0, $do9pw._)({
                    kind: "includes",
                    value: value,
                    position: options === null || options === void 0 ? void 0 : options.position
                }, errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)));
            }
        },
        {
            key: "startsWith",
            value: function startsWith(value, message) {
                return this._addCheck((0, $do9pw._)({
                    kind: "startsWith",
                    value: value
                }, errorUtil.errToObj(message)));
            }
        },
        {
            key: "endsWith",
            value: function endsWith(value, message) {
                return this._addCheck((0, $do9pw._)({
                    kind: "endsWith",
                    value: value
                }, errorUtil.errToObj(message)));
            }
        },
        {
            key: "min",
            value: function min(minLength, message) {
                return this._addCheck((0, $do9pw._)({
                    kind: "min",
                    value: minLength
                }, errorUtil.errToObj(message)));
            }
        },
        {
            key: "max",
            value: function max(maxLength, message) {
                return this._addCheck((0, $do9pw._)({
                    kind: "max",
                    value: maxLength
                }, errorUtil.errToObj(message)));
            }
        },
        {
            key: "length",
            value: function length(len, message) {
                return this._addCheck((0, $do9pw._)({
                    kind: "length",
                    value: len
                }, errorUtil.errToObj(message)));
            }
        },
        {
            /**
     * @deprecated Use z.string().min(1) instead.
     * @see {@link ZodString.min}
     */ key: "nonempty",
            value: function nonempty(message) {
                return this.min(1, errorUtil.errToObj(message));
            }
        },
        {
            key: "trim",
            value: function trim() {
                return new ZodString((0, $cxjpp._)((0, $do9pw._)({}, this._def), {
                    checks: (0, $c6Xmf._)(this._def.checks).concat([
                        {
                            kind: "trim"
                        }
                    ])
                }));
            }
        },
        {
            key: "toLowerCase",
            value: function toLowerCase() {
                return new ZodString((0, $cxjpp._)((0, $do9pw._)({}, this._def), {
                    checks: (0, $c6Xmf._)(this._def.checks).concat([
                        {
                            kind: "toLowerCase"
                        }
                    ])
                }));
            }
        },
        {
            key: "toUpperCase",
            value: function toUpperCase() {
                return new ZodString((0, $cxjpp._)((0, $do9pw._)({}, this._def), {
                    checks: (0, $c6Xmf._)(this._def.checks).concat([
                        {
                            kind: "toUpperCase"
                        }
                    ])
                }));
            }
        },
        {
            key: "isDatetime",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "datetime";
                });
            }
        },
        {
            key: "isEmail",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "email";
                });
            }
        },
        {
            key: "isURL",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "url";
                });
            }
        },
        {
            key: "isEmoji",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "emoji";
                });
            }
        },
        {
            key: "isUUID",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "uuid";
                });
            }
        },
        {
            key: "isCUID",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "cuid";
                });
            }
        },
        {
            key: "isCUID2",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "cuid2";
                });
            }
        },
        {
            key: "isULID",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "ulid";
                });
            }
        },
        {
            key: "isIP",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "ip";
                });
            }
        },
        {
            key: "minLength",
            get: function get() {
                var min = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ch = _step.value;
                        if (ch.kind === "min") {
                            if (min === null || ch.value > min) min = ch.value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return min;
            }
        },
        {
            key: "maxLength",
            get: function get() {
                var max = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ch = _step.value;
                        if (ch.kind === "max") {
                            if (max === null || ch.value < max) max = ch.value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return max;
            }
        }
    ]);
    return ZodString;
}(ZodType);
ZodString.create = function(params) {
    var _a;
    return new ZodString((0, $do9pw._)({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false
    }, processCreateParams(params)));
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function floatSafeRemainder(val, step) {
    var valDecCount = (val.toString().split(".")[1] || "").length;
    var stepDecCount = (step.toString().split(".")[1] || "").length;
    var decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    var valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    var stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / Math.pow(10, decCount);
}
var ZodNumber = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodNumber, ZodType);
    var _super = (0, $ohfOJ._)(ZodNumber);
    function ZodNumber() {
        (0, $4GJKx._)(this, ZodNumber);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.min = _this.gte;
        _this.max = _this.lte;
        _this.step = _this.multipleOf;
        return _this;
    }
    (0, $1wc17._)(ZodNumber, [
        {
            key: "_parse",
            value: function _parse(input) {
                if (this._def.coerce) input.data = Number(input.data);
                var parsedType = this._getType(input);
                if (parsedType !== ZodParsedType.number) {
                    var ctx = this._getOrReturnCtx(input);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: ZodParsedType.number,
                        received: ctx.parsedType
                    });
                    return INVALID;
                }
                var ctx1 = undefined;
                var status = new ParseStatus();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var check = _step.value;
                        if (check.kind === "int") {
                            if (!util.isInteger(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    code: ZodIssueCode.invalid_type,
                                    expected: "integer",
                                    received: "float",
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "min") {
                            var tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                            if (tooSmall) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    code: ZodIssueCode.too_small,
                                    minimum: check.value,
                                    type: "number",
                                    inclusive: check.inclusive,
                                    exact: false,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "max") {
                            var tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                            if (tooBig) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    code: ZodIssueCode.too_big,
                                    maximum: check.value,
                                    type: "number",
                                    inclusive: check.inclusive,
                                    exact: false,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "multipleOf") {
                            if (floatSafeRemainder(input.data, check.value) !== 0) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    code: ZodIssueCode.not_multiple_of,
                                    multipleOf: check.value,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "finite") {
                            if (!Number.isFinite(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    code: ZodIssueCode.not_finite,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else util.assertNever(check);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return {
                    status: status.value,
                    value: input.data
                };
            }
        },
        {
            key: "gte",
            value: function gte(value, message) {
                return this.setLimit("min", value, true, errorUtil.toString(message));
            }
        },
        {
            key: "gt",
            value: function gt(value, message) {
                return this.setLimit("min", value, false, errorUtil.toString(message));
            }
        },
        {
            key: "lte",
            value: function lte(value, message) {
                return this.setLimit("max", value, true, errorUtil.toString(message));
            }
        },
        {
            key: "lt",
            value: function lt(value, message) {
                return this.setLimit("max", value, false, errorUtil.toString(message));
            }
        },
        {
            key: "setLimit",
            value: function setLimit(kind, value, inclusive, message) {
                return new ZodNumber((0, $cxjpp._)((0, $do9pw._)({}, this._def), {
                    checks: (0, $c6Xmf._)(this._def.checks).concat([
                        {
                            kind: kind,
                            value: value,
                            inclusive: inclusive,
                            message: errorUtil.toString(message)
                        }
                    ])
                }));
            }
        },
        {
            key: "_addCheck",
            value: function _addCheck(check) {
                return new ZodNumber((0, $cxjpp._)((0, $do9pw._)({}, this._def), {
                    checks: (0, $c6Xmf._)(this._def.checks).concat([
                        check
                    ])
                }));
            }
        },
        {
            key: "int",
            value: function int(message) {
                return this._addCheck({
                    kind: "int",
                    message: errorUtil.toString(message)
                });
            }
        },
        {
            key: "positive",
            value: function positive(message) {
                return this._addCheck({
                    kind: "min",
                    value: 0,
                    inclusive: false,
                    message: errorUtil.toString(message)
                });
            }
        },
        {
            key: "negative",
            value: function negative(message) {
                return this._addCheck({
                    kind: "max",
                    value: 0,
                    inclusive: false,
                    message: errorUtil.toString(message)
                });
            }
        },
        {
            key: "nonpositive",
            value: function nonpositive(message) {
                return this._addCheck({
                    kind: "max",
                    value: 0,
                    inclusive: true,
                    message: errorUtil.toString(message)
                });
            }
        },
        {
            key: "nonnegative",
            value: function nonnegative(message) {
                return this._addCheck({
                    kind: "min",
                    value: 0,
                    inclusive: true,
                    message: errorUtil.toString(message)
                });
            }
        },
        {
            key: "multipleOf",
            value: function multipleOf(value, message) {
                return this._addCheck({
                    kind: "multipleOf",
                    value: value,
                    message: errorUtil.toString(message)
                });
            }
        },
        {
            key: "finite",
            value: function finite(message) {
                return this._addCheck({
                    kind: "finite",
                    message: errorUtil.toString(message)
                });
            }
        },
        {
            key: "safe",
            value: function safe(message) {
                return this._addCheck({
                    kind: "min",
                    inclusive: true,
                    value: Number.MIN_SAFE_INTEGER,
                    message: errorUtil.toString(message)
                })._addCheck({
                    kind: "max",
                    inclusive: true,
                    value: Number.MAX_SAFE_INTEGER,
                    message: errorUtil.toString(message)
                });
            }
        },
        {
            key: "minValue",
            get: function get() {
                var min = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ch = _step.value;
                        if (ch.kind === "min") {
                            if (min === null || ch.value > min) min = ch.value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return min;
            }
        },
        {
            key: "maxValue",
            get: function get() {
                var max = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ch = _step.value;
                        if (ch.kind === "max") {
                            if (max === null || ch.value < max) max = ch.value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return max;
            }
        },
        {
            key: "isInt",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "int" || ch.kind === "multipleOf" && util.isInteger(ch.value);
                });
            }
        },
        {
            key: "isFinite",
            get: function get() {
                var max = null, min = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ch = _step.value;
                        if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
                        else if (ch.kind === "min") {
                            if (min === null || ch.value > min) min = ch.value;
                        } else if (ch.kind === "max") {
                            if (max === null || ch.value < max) max = ch.value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return Number.isFinite(min) && Number.isFinite(max);
            }
        }
    ]);
    return ZodNumber;
}(ZodType);
ZodNumber.create = function(params) {
    return new ZodNumber((0, $do9pw._)({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false
    }, processCreateParams(params)));
};
var ZodBigInt = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodBigInt, ZodType);
    var _super = (0, $ohfOJ._)(ZodBigInt);
    function ZodBigInt() {
        (0, $4GJKx._)(this, ZodBigInt);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.min = _this.gte;
        _this.max = _this.lte;
        return _this;
    }
    (0, $1wc17._)(ZodBigInt, [
        {
            key: "_parse",
            value: function _parse(input) {
                if (this._def.coerce) input.data = BigInt(input.data);
                var parsedType = this._getType(input);
                if (parsedType !== ZodParsedType.bigint) {
                    var ctx = this._getOrReturnCtx(input);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: ZodParsedType.bigint,
                        received: ctx.parsedType
                    });
                    return INVALID;
                }
                var ctx1 = undefined;
                var status = new ParseStatus();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var check = _step.value;
                        if (check.kind === "min") {
                            var tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                            if (tooSmall) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    code: ZodIssueCode.too_small,
                                    type: "bigint",
                                    minimum: check.value,
                                    inclusive: check.inclusive,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "max") {
                            var tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                            if (tooBig) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    code: ZodIssueCode.too_big,
                                    type: "bigint",
                                    maximum: check.value,
                                    inclusive: check.inclusive,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "multipleOf") {
                            if (input.data % check.value !== BigInt(0)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    code: ZodIssueCode.not_multiple_of,
                                    multipleOf: check.value,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else util.assertNever(check);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return {
                    status: status.value,
                    value: input.data
                };
            }
        },
        {
            key: "gte",
            value: function gte(value, message) {
                return this.setLimit("min", value, true, errorUtil.toString(message));
            }
        },
        {
            key: "gt",
            value: function gt(value, message) {
                return this.setLimit("min", value, false, errorUtil.toString(message));
            }
        },
        {
            key: "lte",
            value: function lte(value, message) {
                return this.setLimit("max", value, true, errorUtil.toString(message));
            }
        },
        {
            key: "lt",
            value: function lt(value, message) {
                return this.setLimit("max", value, false, errorUtil.toString(message));
            }
        },
        {
            key: "setLimit",
            value: function setLimit(kind, value, inclusive, message) {
                return new ZodBigInt((0, $cxjpp._)((0, $do9pw._)({}, this._def), {
                    checks: (0, $c6Xmf._)(this._def.checks).concat([
                        {
                            kind: kind,
                            value: value,
                            inclusive: inclusive,
                            message: errorUtil.toString(message)
                        }
                    ])
                }));
            }
        },
        {
            key: "_addCheck",
            value: function _addCheck(check) {
                return new ZodBigInt((0, $cxjpp._)((0, $do9pw._)({}, this._def), {
                    checks: (0, $c6Xmf._)(this._def.checks).concat([
                        check
                    ])
                }));
            }
        },
        {
            key: "positive",
            value: function positive(message) {
                return this._addCheck({
                    kind: "min",
                    value: BigInt(0),
                    inclusive: false,
                    message: errorUtil.toString(message)
                });
            }
        },
        {
            key: "negative",
            value: function negative(message) {
                return this._addCheck({
                    kind: "max",
                    value: BigInt(0),
                    inclusive: false,
                    message: errorUtil.toString(message)
                });
            }
        },
        {
            key: "nonpositive",
            value: function nonpositive(message) {
                return this._addCheck({
                    kind: "max",
                    value: BigInt(0),
                    inclusive: true,
                    message: errorUtil.toString(message)
                });
            }
        },
        {
            key: "nonnegative",
            value: function nonnegative(message) {
                return this._addCheck({
                    kind: "min",
                    value: BigInt(0),
                    inclusive: true,
                    message: errorUtil.toString(message)
                });
            }
        },
        {
            key: "multipleOf",
            value: function multipleOf(value, message) {
                return this._addCheck({
                    kind: "multipleOf",
                    value: value,
                    message: errorUtil.toString(message)
                });
            }
        },
        {
            key: "minValue",
            get: function get() {
                var min = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ch = _step.value;
                        if (ch.kind === "min") {
                            if (min === null || ch.value > min) min = ch.value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return min;
            }
        },
        {
            key: "maxValue",
            get: function get() {
                var max = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ch = _step.value;
                        if (ch.kind === "max") {
                            if (max === null || ch.value < max) max = ch.value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return max;
            }
        }
    ]);
    return ZodBigInt;
}(ZodType);
ZodBigInt.create = function(params) {
    var _a;
    return new ZodBigInt((0, $do9pw._)({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false
    }, processCreateParams(params)));
};
var ZodBoolean = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodBoolean, ZodType);
    var _super = (0, $ohfOJ._)(ZodBoolean);
    function ZodBoolean() {
        (0, $4GJKx._)(this, ZodBoolean);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodBoolean, [
        {
            key: "_parse",
            value: function _parse(input) {
                if (this._def.coerce) input.data = Boolean(input.data);
                var parsedType = this._getType(input);
                if (parsedType !== ZodParsedType.boolean) {
                    var ctx = this._getOrReturnCtx(input);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: ZodParsedType.boolean,
                        received: ctx.parsedType
                    });
                    return INVALID;
                }
                return OK(input.data);
            }
        }
    ]);
    return ZodBoolean;
}(ZodType);
ZodBoolean.create = function(params) {
    return new ZodBoolean((0, $do9pw._)({
        typeName: ZodFirstPartyTypeKind.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false
    }, processCreateParams(params)));
};
var ZodDate = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodDate, ZodType);
    var _super = (0, $ohfOJ._)(ZodDate);
    function ZodDate() {
        (0, $4GJKx._)(this, ZodDate);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodDate, [
        {
            key: "_parse",
            value: function _parse(input) {
                if (this._def.coerce) input.data = new Date(input.data);
                var parsedType = this._getType(input);
                if (parsedType !== ZodParsedType.date) {
                    var ctx = this._getOrReturnCtx(input);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: ZodParsedType.date,
                        received: ctx.parsedType
                    });
                    return INVALID;
                }
                if (isNaN(input.data.getTime())) {
                    var ctx1 = this._getOrReturnCtx(input);
                    addIssueToContext(ctx1, {
                        code: ZodIssueCode.invalid_date
                    });
                    return INVALID;
                }
                var status = new ParseStatus();
                var ctx2 = undefined;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var check = _step.value;
                        if (check.kind === "min") {
                            if (input.data.getTime() < check.value) {
                                ctx2 = this._getOrReturnCtx(input, ctx2);
                                addIssueToContext(ctx2, {
                                    code: ZodIssueCode.too_small,
                                    message: check.message,
                                    inclusive: true,
                                    exact: false,
                                    minimum: check.value,
                                    type: "date"
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "max") {
                            if (input.data.getTime() > check.value) {
                                ctx2 = this._getOrReturnCtx(input, ctx2);
                                addIssueToContext(ctx2, {
                                    code: ZodIssueCode.too_big,
                                    message: check.message,
                                    inclusive: true,
                                    exact: false,
                                    maximum: check.value,
                                    type: "date"
                                });
                                status.dirty();
                            }
                        } else util.assertNever(check);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return {
                    status: status.value,
                    value: new Date(input.data.getTime())
                };
            }
        },
        {
            key: "_addCheck",
            value: function _addCheck(check) {
                return new ZodDate((0, $cxjpp._)((0, $do9pw._)({}, this._def), {
                    checks: (0, $c6Xmf._)(this._def.checks).concat([
                        check
                    ])
                }));
            }
        },
        {
            key: "min",
            value: function min(minDate, message) {
                return this._addCheck({
                    kind: "min",
                    value: minDate.getTime(),
                    message: errorUtil.toString(message)
                });
            }
        },
        {
            key: "max",
            value: function max(maxDate, message) {
                return this._addCheck({
                    kind: "max",
                    value: maxDate.getTime(),
                    message: errorUtil.toString(message)
                });
            }
        },
        {
            key: "minDate",
            get: function get() {
                var min = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ch = _step.value;
                        if (ch.kind === "min") {
                            if (min === null || ch.value > min) min = ch.value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return min != null ? new Date(min) : null;
            }
        },
        {
            key: "maxDate",
            get: function get() {
                var max = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ch = _step.value;
                        if (ch.kind === "max") {
                            if (max === null || ch.value < max) max = ch.value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return max != null ? new Date(max) : null;
            }
        }
    ]);
    return ZodDate;
}(ZodType);
ZodDate.create = function(params) {
    return new ZodDate((0, $do9pw._)({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: ZodFirstPartyTypeKind.ZodDate
    }, processCreateParams(params)));
};
var ZodSymbol = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodSymbol, ZodType);
    var _super = (0, $ohfOJ._)(ZodSymbol);
    function ZodSymbol() {
        (0, $4GJKx._)(this, ZodSymbol);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodSymbol, [
        {
            key: "_parse",
            value: function _parse(input) {
                var parsedType = this._getType(input);
                if (parsedType !== ZodParsedType.symbol) {
                    var ctx = this._getOrReturnCtx(input);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: ZodParsedType.symbol,
                        received: ctx.parsedType
                    });
                    return INVALID;
                }
                return OK(input.data);
            }
        }
    ]);
    return ZodSymbol;
}(ZodType);
ZodSymbol.create = function(params) {
    return new ZodSymbol((0, $do9pw._)({
        typeName: ZodFirstPartyTypeKind.ZodSymbol
    }, processCreateParams(params)));
};
var ZodUndefined = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodUndefined, ZodType);
    var _super = (0, $ohfOJ._)(ZodUndefined);
    function ZodUndefined() {
        (0, $4GJKx._)(this, ZodUndefined);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodUndefined, [
        {
            key: "_parse",
            value: function _parse(input) {
                var parsedType = this._getType(input);
                if (parsedType !== ZodParsedType.undefined) {
                    var ctx = this._getOrReturnCtx(input);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: ZodParsedType.undefined,
                        received: ctx.parsedType
                    });
                    return INVALID;
                }
                return OK(input.data);
            }
        }
    ]);
    return ZodUndefined;
}(ZodType);
ZodUndefined.create = function(params) {
    return new ZodUndefined((0, $do9pw._)({
        typeName: ZodFirstPartyTypeKind.ZodUndefined
    }, processCreateParams(params)));
};
var ZodNull = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodNull, ZodType);
    var _super = (0, $ohfOJ._)(ZodNull);
    function ZodNull() {
        (0, $4GJKx._)(this, ZodNull);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodNull, [
        {
            key: "_parse",
            value: function _parse(input) {
                var parsedType = this._getType(input);
                if (parsedType !== ZodParsedType.null) {
                    var ctx = this._getOrReturnCtx(input);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: ZodParsedType.null,
                        received: ctx.parsedType
                    });
                    return INVALID;
                }
                return OK(input.data);
            }
        }
    ]);
    return ZodNull;
}(ZodType);
ZodNull.create = function(params) {
    return new ZodNull((0, $do9pw._)({
        typeName: ZodFirstPartyTypeKind.ZodNull
    }, processCreateParams(params)));
};
var ZodAny = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodAny, ZodType);
    var _super = (0, $ohfOJ._)(ZodAny);
    function ZodAny() {
        (0, $4GJKx._)(this, ZodAny);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        _this._any = true;
        return _this;
    }
    (0, $1wc17._)(ZodAny, [
        {
            key: "_parse",
            value: function _parse(input) {
                return OK(input.data);
            }
        }
    ]);
    return ZodAny;
}(ZodType);
ZodAny.create = function(params) {
    return new ZodAny((0, $do9pw._)({
        typeName: ZodFirstPartyTypeKind.ZodAny
    }, processCreateParams(params)));
};
var ZodUnknown = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodUnknown, ZodType);
    var _super = (0, $ohfOJ._)(ZodUnknown);
    function ZodUnknown() {
        (0, $4GJKx._)(this, ZodUnknown);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        // required
        _this._unknown = true;
        return _this;
    }
    (0, $1wc17._)(ZodUnknown, [
        {
            key: "_parse",
            value: function _parse(input) {
                return OK(input.data);
            }
        }
    ]);
    return ZodUnknown;
}(ZodType);
ZodUnknown.create = function(params) {
    return new ZodUnknown((0, $do9pw._)({
        typeName: ZodFirstPartyTypeKind.ZodUnknown
    }, processCreateParams(params)));
};
var ZodNever = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodNever, ZodType);
    var _super = (0, $ohfOJ._)(ZodNever);
    function ZodNever() {
        (0, $4GJKx._)(this, ZodNever);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodNever, [
        {
            key: "_parse",
            value: function _parse(input) {
                var ctx = this._getOrReturnCtx(input);
                addIssueToContext(ctx, {
                    code: ZodIssueCode.invalid_type,
                    expected: ZodParsedType.never,
                    received: ctx.parsedType
                });
                return INVALID;
            }
        }
    ]);
    return ZodNever;
}(ZodType);
ZodNever.create = function(params) {
    return new ZodNever((0, $do9pw._)({
        typeName: ZodFirstPartyTypeKind.ZodNever
    }, processCreateParams(params)));
};
var ZodVoid = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodVoid, ZodType);
    var _super = (0, $ohfOJ._)(ZodVoid);
    function ZodVoid() {
        (0, $4GJKx._)(this, ZodVoid);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodVoid, [
        {
            key: "_parse",
            value: function _parse(input) {
                var parsedType = this._getType(input);
                if (parsedType !== ZodParsedType.undefined) {
                    var ctx = this._getOrReturnCtx(input);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: ZodParsedType.void,
                        received: ctx.parsedType
                    });
                    return INVALID;
                }
                return OK(input.data);
            }
        }
    ]);
    return ZodVoid;
}(ZodType);
ZodVoid.create = function(params) {
    return new ZodVoid((0, $do9pw._)({
        typeName: ZodFirstPartyTypeKind.ZodVoid
    }, processCreateParams(params)));
};
var ZodArray = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodArray, ZodType);
    var _super = (0, $ohfOJ._)(ZodArray);
    function ZodArray() {
        (0, $4GJKx._)(this, ZodArray);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodArray, [
        {
            key: "_parse",
            value: function _parse(input) {
                var _this__processInputParams = this._processInputParams(input), ctx = _this__processInputParams.ctx, status = _this__processInputParams.status;
                var def = this._def;
                if (ctx.parsedType !== ZodParsedType.array) {
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: ZodParsedType.array,
                        received: ctx.parsedType
                    });
                    return INVALID;
                }
                if (def.exactLength !== null) {
                    var tooBig = ctx.data.length > def.exactLength.value;
                    var tooSmall = ctx.data.length < def.exactLength.value;
                    if (tooBig || tooSmall) {
                        addIssueToContext(ctx, {
                            code: tooBig ? ZodIssueCode.too_big : ZodIssueCode.too_small,
                            minimum: tooSmall ? def.exactLength.value : undefined,
                            maximum: tooBig ? def.exactLength.value : undefined,
                            type: "array",
                            inclusive: true,
                            exact: true,
                            message: def.exactLength.message
                        });
                        status.dirty();
                    }
                }
                if (def.minLength !== null) {
                    if (ctx.data.length < def.minLength.value) {
                        addIssueToContext(ctx, {
                            code: ZodIssueCode.too_small,
                            minimum: def.minLength.value,
                            type: "array",
                            inclusive: true,
                            exact: false,
                            message: def.minLength.message
                        });
                        status.dirty();
                    }
                }
                if (def.maxLength !== null) {
                    if (ctx.data.length > def.maxLength.value) {
                        addIssueToContext(ctx, {
                            code: ZodIssueCode.too_big,
                            maximum: def.maxLength.value,
                            type: "array",
                            inclusive: true,
                            exact: false,
                            message: def.maxLength.message
                        });
                        status.dirty();
                    }
                }
                if (ctx.common.async) return Promise.all((0, $c6Xmf._)(ctx.data).map(function(item, i) {
                    return def.type._parseAsync(new ParseInputLazyPath(ctx, item, ctx.path, i));
                })).then(function(result) {
                    return ParseStatus.mergeArray(status, result);
                });
                var result = (0, $c6Xmf._)(ctx.data).map(function(item, i) {
                    return def.type._parseSync(new ParseInputLazyPath(ctx, item, ctx.path, i));
                });
                return ParseStatus.mergeArray(status, result);
            }
        },
        {
            key: "element",
            get: function get() {
                return this._def.type;
            }
        },
        {
            key: "min",
            value: function min(minLength, message) {
                return new ZodArray((0, $cxjpp._)((0, $do9pw._)({}, this._def), {
                    minLength: {
                        value: minLength,
                        message: errorUtil.toString(message)
                    }
                }));
            }
        },
        {
            key: "max",
            value: function max(maxLength, message) {
                return new ZodArray((0, $cxjpp._)((0, $do9pw._)({}, this._def), {
                    maxLength: {
                        value: maxLength,
                        message: errorUtil.toString(message)
                    }
                }));
            }
        },
        {
            key: "length",
            value: function length(len, message) {
                return new ZodArray((0, $cxjpp._)((0, $do9pw._)({}, this._def), {
                    exactLength: {
                        value: len,
                        message: errorUtil.toString(message)
                    }
                }));
            }
        },
        {
            key: "nonempty",
            value: function nonempty(message) {
                return this.min(1, message);
            }
        }
    ]);
    return ZodArray;
}(ZodType);
ZodArray.create = function(schema, params) {
    return new ZodArray((0, $do9pw._)({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: ZodFirstPartyTypeKind.ZodArray
    }, processCreateParams(params)));
};
function deepPartialify(schema) {
    if (schema instanceof ZodObject) {
        var newShape = {};
        for(var key in schema.shape){
            var fieldSchema = schema.shape[key];
            newShape[key] = ZodOptional.create(deepPartialify(fieldSchema));
        }
        return new ZodObject((0, $cxjpp._)((0, $do9pw._)({}, schema._def), {
            shape: function() {
                return newShape;
            }
        }));
    } else if (schema instanceof ZodArray) return new ZodArray((0, $cxjpp._)((0, $do9pw._)({}, schema._def), {
        type: deepPartialify(schema.element)
    }));
    else if (schema instanceof ZodOptional) return ZodOptional.create(deepPartialify(schema.unwrap()));
    else if (schema instanceof ZodNullable) return ZodNullable.create(deepPartialify(schema.unwrap()));
    else if (schema instanceof ZodTuple) return ZodTuple.create(schema.items.map(function(item) {
        return deepPartialify(item);
    }));
    else return schema;
}
var ZodObject = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodObject, ZodType);
    var _super = (0, $ohfOJ._)(ZodObject);
    function ZodObject() {
        (0, $4GJKx._)(this, ZodObject);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ _this.nonstrict = _this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ _this.augment = _this.extend;
        return _this;
    }
    (0, $1wc17._)(ZodObject, [
        {
            key: "_getCached",
            value: function _getCached() {
                if (this._cached !== null) return this._cached;
                var shape = this._def.shape();
                var keys = util.objectKeys(shape);
                return this._cached = {
                    shape: shape,
                    keys: keys
                };
            }
        },
        {
            key: "_parse",
            value: function _parse(input) {
                var parsedType = this._getType(input);
                if (parsedType !== ZodParsedType.object) {
                    var ctx = this._getOrReturnCtx(input);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: ZodParsedType.object,
                        received: ctx.parsedType
                    });
                    return INVALID;
                }
                var _this__processInputParams = this._processInputParams(input), status = _this__processInputParams.status, ctx1 = _this__processInputParams.ctx;
                var _this__getCached = this._getCached(), shape = _this__getCached.shape, shapeKeys = _this__getCached.keys;
                var extraKeys = [];
                if (!(this._def.catchall instanceof ZodNever && this._def.unknownKeys === "strip")) {
                    for(var key in ctx1.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
                }
                var pairs = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = shapeKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key1 = _step.value;
                        var keyValidator = shape[key1];
                        var value = ctx1.data[key1];
                        pairs.push({
                            key: {
                                status: "valid",
                                value: key1
                            },
                            value: keyValidator._parse(new ParseInputLazyPath(ctx1, value, ctx1.path, key1)),
                            alwaysSet: key1 in ctx1.data
                        });
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (this._def.catchall instanceof ZodNever) {
                    var unknownKeys = this._def.unknownKeys;
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    if (unknownKeys === "passthrough") try {
                        for(var _iterator1 = extraKeys[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var key2 = _step1.value;
                            pairs.push({
                                key: {
                                    status: "valid",
                                    value: key2
                                },
                                value: {
                                    status: "valid",
                                    value: ctx1.data[key2]
                                }
                            });
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    else if (unknownKeys === "strict") {
                        if (extraKeys.length > 0) {
                            addIssueToContext(ctx1, {
                                code: ZodIssueCode.unrecognized_keys,
                                keys: extraKeys
                            });
                            status.dirty();
                        }
                    } else if (unknownKeys === "strip") ;
                    else throw new Error("Internal ZodObject error: invalid unknownKeys value.");
                } else {
                    // run catchall validation
                    var catchall = this._def.catchall;
                    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                    try {
                        for(var _iterator2 = extraKeys[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                            var key3 = _step2.value;
                            var value1 = ctx1.data[key3];
                            pairs.push({
                                key: {
                                    status: "valid",
                                    value: key3
                                },
                                value: catchall._parse(new ParseInputLazyPath(ctx1, value1, ctx1.path, key3) //, ctx.child(key), value, getParsedType(value)
                                ),
                                alwaysSet: key3 in ctx1.data
                            });
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                _iterator2.return();
                            }
                        } finally{
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                }
                if (ctx1.common.async) return Promise.resolve().then(/*#__PURE__*/ (0, $kSuI9._)(function() {
                    var syncPairs, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, pair, key, _, _tmp, err;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                syncPairs = [];
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    7,
                                    8,
                                    9
                                ]);
                                _iterator = pairs[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    6
                                ];
                                pair = _step.value;
                                return [
                                    4,
                                    pair.key
                                ];
                            case 3:
                                key = _state.sent();
                                _ = syncPairs.push;
                                _tmp = {
                                    key: key
                                };
                                return [
                                    4,
                                    pair.value
                                ];
                            case 4:
                                _.apply(syncPairs, [
                                    (_tmp.value = _state.sent(), _tmp.alwaysSet = pair.alwaysSet, _tmp)
                                ]);
                                _state.label = 5;
                            case 5:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    2
                                ];
                            case 6:
                                return [
                                    3,
                                    9
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    9
                                ];
                            case 8:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 9:
                                return [
                                    2,
                                    syncPairs
                                ];
                        }
                    });
                })).then(function(syncPairs) {
                    return ParseStatus.mergeObjectSync(status, syncPairs);
                });
                else return ParseStatus.mergeObjectSync(status, pairs);
            }
        },
        {
            key: "shape",
            get: function get() {
                return this._def.shape();
            }
        },
        {
            key: "strict",
            value: function strict(message) {
                var _this = this;
                errorUtil.errToObj;
                return new ZodObject((0, $do9pw._)((0, $cxjpp._)((0, $do9pw._)({}, this._def), {
                    unknownKeys: "strict"
                }), message !== undefined ? {
                    errorMap: function(issue, ctx) {
                        var _a, _b, _c, _d;
                        var defaultError = (_c = (_b = (_a = _this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                        if (issue.code === "unrecognized_keys") return {
                            message: (_d = errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
                        };
                        return {
                            message: defaultError
                        };
                    }
                } : {}));
            }
        },
        {
            key: "strip",
            value: function strip() {
                return new ZodObject((0, $cxjpp._)((0, $do9pw._)({}, this._def), {
                    unknownKeys: "strip"
                }));
            }
        },
        {
            key: "passthrough",
            value: function passthrough() {
                return new ZodObject((0, $cxjpp._)((0, $do9pw._)({}, this._def), {
                    unknownKeys: "passthrough"
                }));
            }
        },
        {
            // const AugmentFactory =
            //   <Def extends ZodObjectDef>(def: Def) =>
            //   <Augmentation extends ZodRawShape>(
            //     augmentation: Augmentation
            //   ): ZodObject<
            //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
            //     Def["unknownKeys"],
            //     Def["catchall"]
            //   > => {
            //     return new ZodObject({
            //       ...def,
            //       shape: () => ({
            //         ...def.shape(),
            //         ...augmentation,
            //       }),
            //     }) as any;
            //   };
            key: "extend",
            value: function extend(augmentation) {
                var _this = this;
                return new ZodObject((0, $cxjpp._)((0, $do9pw._)({}, this._def), {
                    shape: function() {
                        return (0, $do9pw._)({}, _this._def.shape(), augmentation);
                    }
                }));
            }
        },
        {
            /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ key: "merge",
            value: function merge(merging) {
                var _this = this;
                var merged = new ZodObject({
                    unknownKeys: merging._def.unknownKeys,
                    catchall: merging._def.catchall,
                    shape: function() {
                        return (0, $do9pw._)({}, _this._def.shape(), merging._def.shape());
                    },
                    typeName: ZodFirstPartyTypeKind.ZodObject
                });
                return merged;
            }
        },
        {
            // merge<
            //   Incoming extends AnyZodObject,
            //   Augmentation extends Incoming["shape"],
            //   NewOutput extends {
            //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
            //       ? Augmentation[k]["_output"]
            //       : k extends keyof Output
            //       ? Output[k]
            //       : never;
            //   },
            //   NewInput extends {
            //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
            //       ? Augmentation[k]["_input"]
            //       : k extends keyof Input
            //       ? Input[k]
            //       : never;
            //   }
            // >(
            //   merging: Incoming
            // ): ZodObject<
            //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
            //   Incoming["_def"]["unknownKeys"],
            //   Incoming["_def"]["catchall"],
            //   NewOutput,
            //   NewInput
            // > {
            //   const merged: any = new ZodObject({
            //     unknownKeys: merging._def.unknownKeys,
            //     catchall: merging._def.catchall,
            //     shape: () =>
            //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
            //     typeName: ZodFirstPartyTypeKind.ZodObject,
            //   }) as any;
            //   return merged;
            // }
            key: "setKey",
            value: function setKey(key, schema) {
                return this.augment((0, $3sHb8._)({}, key, schema));
            }
        },
        {
            // merge<Incoming extends AnyZodObject>(
            //   merging: Incoming
            // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
            // ZodObject<
            //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
            //   Incoming["_def"]["unknownKeys"],
            //   Incoming["_def"]["catchall"]
            // > {
            //   // const mergedShape = objectUtil.mergeShapes(
            //   //   this._def.shape(),
            //   //   merging._def.shape()
            //   // );
            //   const merged: any = new ZodObject({
            //     unknownKeys: merging._def.unknownKeys,
            //     catchall: merging._def.catchall,
            //     shape: () =>
            //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
            //     typeName: ZodFirstPartyTypeKind.ZodObject,
            //   }) as any;
            //   return merged;
            // }
            key: "catchall",
            value: function catchall(index) {
                return new ZodObject((0, $cxjpp._)((0, $do9pw._)({}, this._def), {
                    catchall: index
                }));
            }
        },
        {
            key: "pick",
            value: function pick(mask) {
                var _this = this;
                var shape = {};
                util.objectKeys(mask).forEach(function(key) {
                    if (mask[key] && _this.shape[key]) shape[key] = _this.shape[key];
                });
                return new ZodObject((0, $cxjpp._)((0, $do9pw._)({}, this._def), {
                    shape: function() {
                        return shape;
                    }
                }));
            }
        },
        {
            key: "omit",
            value: function omit(mask) {
                var _this = this;
                var shape = {};
                util.objectKeys(this.shape).forEach(function(key) {
                    if (!mask[key]) shape[key] = _this.shape[key];
                });
                return new ZodObject((0, $cxjpp._)((0, $do9pw._)({}, this._def), {
                    shape: function() {
                        return shape;
                    }
                }));
            }
        },
        {
            /**
     * @deprecated
     */ key: "deepPartial",
            value: function deepPartial() {
                return deepPartialify(this);
            }
        },
        {
            key: "partial",
            value: function partial(mask) {
                var _this = this;
                var newShape = {};
                util.objectKeys(this.shape).forEach(function(key) {
                    var fieldSchema = _this.shape[key];
                    if (mask && !mask[key]) newShape[key] = fieldSchema;
                    else newShape[key] = fieldSchema.optional();
                });
                return new ZodObject((0, $cxjpp._)((0, $do9pw._)({}, this._def), {
                    shape: function() {
                        return newShape;
                    }
                }));
            }
        },
        {
            key: "required",
            value: function required(mask) {
                var _this = this;
                var newShape = {};
                util.objectKeys(this.shape).forEach(function(key) {
                    if (mask && !mask[key]) newShape[key] = _this.shape[key];
                    else {
                        var fieldSchema = _this.shape[key];
                        var newField = fieldSchema;
                        while(newField instanceof ZodOptional)newField = newField._def.innerType;
                        newShape[key] = newField;
                    }
                });
                return new ZodObject((0, $cxjpp._)((0, $do9pw._)({}, this._def), {
                    shape: function() {
                        return newShape;
                    }
                }));
            }
        },
        {
            key: "keyof",
            value: function keyof() {
                return createZodEnum(util.objectKeys(this.shape));
            }
        }
    ]);
    return ZodObject;
}(ZodType);
ZodObject.create = function(shape, params) {
    return new ZodObject((0, $do9pw._)({
        shape: function() {
            return shape;
        },
        unknownKeys: "strip",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject
    }, processCreateParams(params)));
};
ZodObject.strictCreate = function(shape, params) {
    return new ZodObject((0, $do9pw._)({
        shape: function() {
            return shape;
        },
        unknownKeys: "strict",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject
    }, processCreateParams(params)));
};
ZodObject.lazycreate = function(shape, params) {
    return new ZodObject((0, $do9pw._)({
        shape: shape,
        unknownKeys: "strip",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject
    }, processCreateParams(params)));
};
var ZodUnion = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodUnion, ZodType);
    var _super = (0, $ohfOJ._)(ZodUnion);
    function ZodUnion() {
        (0, $4GJKx._)(this, ZodUnion);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodUnion, [
        {
            key: "_parse",
            value: function _parse(input) {
                var ctx = this._processInputParams(input).ctx;
                var options = this._def.options;
                function handleResults(results) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        // return first issue-free validation if it exists
                        for(var _iterator = results[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var result = _step.value;
                            if (result.result.status === "valid") return result.result;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = results[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var result1 = _step1.value;
                            if (result1.result.status === "dirty") {
                                var // add issues from dirty option
                                _ctx_common_issues;
                                (_ctx_common_issues = ctx.common.issues).push.apply(_ctx_common_issues, (0, $c6Xmf._)(result1.ctx.common.issues));
                                return result1.result;
                            }
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    // return invalid
                    var unionErrors = results.map(function(result) {
                        return new ZodError(result.ctx.common.issues);
                    });
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_union,
                        unionErrors: unionErrors
                    });
                    return INVALID;
                }
                if (ctx.common.async) return Promise.all(options.map(function() {
                    var _ref = (0, $kSuI9._)(function(option) {
                        var childCtx, _tmp;
                        return (0, $l29cN.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    childCtx = (0, $cxjpp._)((0, $do9pw._)({}, ctx), {
                                        common: (0, $cxjpp._)((0, $do9pw._)({}, ctx.common), {
                                            issues: []
                                        }),
                                        parent: null
                                    });
                                    _tmp = {};
                                    return [
                                        4,
                                        option._parseAsync({
                                            data: ctx.data,
                                            path: ctx.path,
                                            parent: childCtx
                                        })
                                    ];
                                case 1:
                                    return [
                                        2,
                                        (_tmp.result = _state.sent(), _tmp.ctx = childCtx, _tmp)
                                    ];
                            }
                        });
                    });
                    return function(option) {
                        return _ref.apply(this, arguments);
                    };
                }())).then(handleResults);
                else {
                    var dirty = undefined;
                    var issues = [];
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = options[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var option = _step.value;
                            var childCtx = (0, $cxjpp._)((0, $do9pw._)({}, ctx), {
                                common: (0, $cxjpp._)((0, $do9pw._)({}, ctx.common), {
                                    issues: []
                                }),
                                parent: null
                            });
                            var result = option._parseSync({
                                data: ctx.data,
                                path: ctx.path,
                                parent: childCtx
                            });
                            if (result.status === "valid") return result;
                            else if (result.status === "dirty" && !dirty) dirty = {
                                result: result,
                                ctx: childCtx
                            };
                            if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    if (dirty) {
                        var _ctx_common_issues;
                        (_ctx_common_issues = ctx.common.issues).push.apply(_ctx_common_issues, (0, $c6Xmf._)(dirty.ctx.common.issues));
                        return dirty.result;
                    }
                    var unionErrors = issues.map(function(issues) {
                        return new ZodError(issues);
                    });
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_union,
                        unionErrors: unionErrors
                    });
                    return INVALID;
                }
            }
        },
        {
            key: "options",
            get: function get() {
                return this._def.options;
            }
        }
    ]);
    return ZodUnion;
}(ZodType);
ZodUnion.create = function(types, params) {
    return new ZodUnion((0, $do9pw._)({
        options: types,
        typeName: ZodFirstPartyTypeKind.ZodUnion
    }, processCreateParams(params)));
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
var getDiscriminator = function(type) {
    if (type instanceof ZodLazy) return getDiscriminator(type.schema);
    else if (type instanceof ZodEffects) return getDiscriminator(type.innerType());
    else if (type instanceof ZodLiteral) return [
        type.value
    ];
    else if (type instanceof ZodEnum) return type.options;
    else if (type instanceof ZodNativeEnum) // eslint-disable-next-line ban/ban
    return Object.keys(type.enum);
    else if (type instanceof ZodDefault) return getDiscriminator(type._def.innerType);
    else if (type instanceof ZodUndefined) return [
        undefined
    ];
    else if (type instanceof ZodNull) return [
        null
    ];
    else return null;
};
var ZodDiscriminatedUnion = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodDiscriminatedUnion, ZodType);
    var _super = (0, $ohfOJ._)(ZodDiscriminatedUnion);
    function ZodDiscriminatedUnion() {
        (0, $4GJKx._)(this, ZodDiscriminatedUnion);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodDiscriminatedUnion, [
        {
            key: "_parse",
            value: function _parse(input) {
                var ctx = this._processInputParams(input).ctx;
                if (ctx.parsedType !== ZodParsedType.object) {
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: ZodParsedType.object,
                        received: ctx.parsedType
                    });
                    return INVALID;
                }
                var discriminator = this.discriminator;
                var discriminatorValue = ctx.data[discriminator];
                var option = this.optionsMap.get(discriminatorValue);
                if (!option) {
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_union_discriminator,
                        options: Array.from(this.optionsMap.keys()),
                        path: [
                            discriminator
                        ]
                    });
                    return INVALID;
                }
                if (ctx.common.async) return option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                else return option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
            }
        },
        {
            key: "discriminator",
            get: function get() {
                return this._def.discriminator;
            }
        },
        {
            key: "options",
            get: function get() {
                return this._def.options;
            }
        },
        {
            key: "optionsMap",
            get: function get() {
                return this._def.optionsMap;
            }
        }
    ], [
        {
            key: "create",
            value: /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ function create(discriminator, options, params) {
                // Get all the valid discriminator values
                var optionsMap = new Map();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // try {
                    for(var _iterator = options[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var type = _step.value;
                        var discriminatorValues = getDiscriminator(type.shape[discriminator]);
                        if (!discriminatorValues) throw new Error("A discriminator value for key `".concat(discriminator, "` could not be extracted from all schema options"));
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = discriminatorValues[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var value = _step1.value;
                                if (optionsMap.has(value)) throw new Error("Discriminator property ".concat(String(discriminator), " has duplicate value ").concat(String(value)));
                                optionsMap.set(value, type);
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return new ZodDiscriminatedUnion((0, $do9pw._)({
                    typeName: ZodFirstPartyTypeKind.ZodDiscriminatedUnion,
                    discriminator: discriminator,
                    options: options,
                    optionsMap: optionsMap
                }, processCreateParams(params)));
            }
        }
    ]);
    return ZodDiscriminatedUnion;
}(ZodType);
function mergeValues(a, b) {
    var aType = getParsedType(a);
    var bType = getParsedType(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === ZodParsedType.object && bType === ZodParsedType.object) {
        var bKeys = util.objectKeys(b);
        var sharedKeys = util.objectKeys(a).filter(function(key) {
            return bKeys.indexOf(key) !== -1;
        });
        var newObj = (0, $do9pw._)({}, a, b);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = sharedKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var sharedValue = mergeValues(a[key], b[key]);
                if (!sharedValue.valid) return {
                    valid: false
                };
                newObj[key] = sharedValue.data;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === ZodParsedType.array && bType === ZodParsedType.array) {
        if (a.length !== b.length) return {
            valid: false
        };
        var newArray = [];
        for(var index = 0; index < a.length; index++){
            var itemA = a[index];
            var itemB = b[index];
            var sharedValue1 = mergeValues(itemA, itemB);
            if (!sharedValue1.valid) return {
                valid: false
            };
            newArray.push(sharedValue1.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === ZodParsedType.date && bType === ZodParsedType.date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
var ZodIntersection = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodIntersection, ZodType);
    var _super = (0, $ohfOJ._)(ZodIntersection);
    function ZodIntersection() {
        (0, $4GJKx._)(this, ZodIntersection);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodIntersection, [
        {
            key: "_parse",
            value: function _parse(input) {
                var _this__processInputParams = this._processInputParams(input), status = _this__processInputParams.status, ctx = _this__processInputParams.ctx;
                var handleParsed = function(parsedLeft, parsedRight) {
                    if (isAborted(parsedLeft) || isAborted(parsedRight)) return INVALID;
                    var merged = mergeValues(parsedLeft.value, parsedRight.value);
                    if (!merged.valid) {
                        addIssueToContext(ctx, {
                            code: ZodIssueCode.invalid_intersection_types
                        });
                        return INVALID;
                    }
                    if (isDirty(parsedLeft) || isDirty(parsedRight)) status.dirty();
                    return {
                        status: status.value,
                        value: merged.data
                    };
                };
                if (ctx.common.async) return Promise.all([
                    this._def.left._parseAsync({
                        data: ctx.data,
                        path: ctx.path,
                        parent: ctx
                    }),
                    this._def.right._parseAsync({
                        data: ctx.data,
                        path: ctx.path,
                        parent: ctx
                    })
                ]).then(function(param) {
                    var _param = (0, $cv9Rk._)(param, 2), left = _param[0], right = _param[1];
                    return handleParsed(left, right);
                });
                else return handleParsed(this._def.left._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                }), this._def.right._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                }));
            }
        }
    ]);
    return ZodIntersection;
}(ZodType);
ZodIntersection.create = function(left, right, params) {
    return new ZodIntersection((0, $do9pw._)({
        left: left,
        right: right,
        typeName: ZodFirstPartyTypeKind.ZodIntersection
    }, processCreateParams(params)));
};
var ZodTuple = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodTuple, ZodType);
    var _super = (0, $ohfOJ._)(ZodTuple);
    function ZodTuple() {
        (0, $4GJKx._)(this, ZodTuple);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodTuple, [
        {
            key: "_parse",
            value: function _parse(input) {
                var _this = this;
                var _this__processInputParams = this._processInputParams(input), status = _this__processInputParams.status, ctx = _this__processInputParams.ctx;
                if (ctx.parsedType !== ZodParsedType.array) {
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: ZodParsedType.array,
                        received: ctx.parsedType
                    });
                    return INVALID;
                }
                if (ctx.data.length < this._def.items.length) {
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_small,
                        minimum: this._def.items.length,
                        inclusive: true,
                        exact: false,
                        type: "array"
                    });
                    return INVALID;
                }
                var rest = this._def.rest;
                if (!rest && ctx.data.length > this._def.items.length) {
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_big,
                        maximum: this._def.items.length,
                        inclusive: true,
                        exact: false,
                        type: "array"
                    });
                    status.dirty();
                }
                var items = (0, $c6Xmf._)(ctx.data).map(function(item, itemIndex) {
                    var schema = _this._def.items[itemIndex] || _this._def.rest;
                    if (!schema) return null;
                    return schema._parse(new ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
                }).filter(function(x) {
                    return !!x;
                }); // filter nulls
                if (ctx.common.async) return Promise.all(items).then(function(results) {
                    return ParseStatus.mergeArray(status, results);
                });
                else return ParseStatus.mergeArray(status, items);
            }
        },
        {
            key: "items",
            get: function get() {
                return this._def.items;
            }
        },
        {
            key: "rest",
            value: function rest(rest) {
                return new ZodTuple((0, $cxjpp._)((0, $do9pw._)({}, this._def), {
                    rest: rest
                }));
            }
        }
    ]);
    return ZodTuple;
}(ZodType);
ZodTuple.create = function(schemas, params) {
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new ZodTuple((0, $do9pw._)({
        items: schemas,
        typeName: ZodFirstPartyTypeKind.ZodTuple,
        rest: null
    }, processCreateParams(params)));
};
var ZodRecord = /*#__PURE__*/ function(ZodType1) {
    "use strict";
    (0, $dcsZi._)(ZodRecord, ZodType1);
    var _super = (0, $ohfOJ._)(ZodRecord);
    function ZodRecord() {
        (0, $4GJKx._)(this, ZodRecord);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodRecord, [
        {
            key: "keySchema",
            get: function get() {
                return this._def.keyType;
            }
        },
        {
            key: "valueSchema",
            get: function get() {
                return this._def.valueType;
            }
        },
        {
            key: "_parse",
            value: function _parse(input) {
                var _this__processInputParams = this._processInputParams(input), status = _this__processInputParams.status, ctx = _this__processInputParams.ctx;
                if (ctx.parsedType !== ZodParsedType.object) {
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: ZodParsedType.object,
                        received: ctx.parsedType
                    });
                    return INVALID;
                }
                var pairs = [];
                var keyType = this._def.keyType;
                var valueType = this._def.valueType;
                for(var key in ctx.data)pairs.push({
                    key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, key)),
                    value: valueType._parse(new ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key))
                });
                if (ctx.common.async) return ParseStatus.mergeObjectAsync(status, pairs);
                else return ParseStatus.mergeObjectSync(status, pairs);
            }
        },
        {
            key: "element",
            get: function get() {
                return this._def.valueType;
            }
        }
    ], [
        {
            key: "create",
            value: function create(first, second, third) {
                if (second instanceof ZodType) return new ZodRecord((0, $do9pw._)({
                    keyType: first,
                    valueType: second,
                    typeName: ZodFirstPartyTypeKind.ZodRecord
                }, processCreateParams(third)));
                return new ZodRecord((0, $do9pw._)({
                    keyType: ZodString.create(),
                    valueType: first,
                    typeName: ZodFirstPartyTypeKind.ZodRecord
                }, processCreateParams(second)));
            }
        }
    ]);
    return ZodRecord;
}(ZodType);
var ZodMap = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodMap, ZodType);
    var _super = (0, $ohfOJ._)(ZodMap);
    function ZodMap() {
        (0, $4GJKx._)(this, ZodMap);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodMap, [
        {
            key: "keySchema",
            get: function get() {
                return this._def.keyType;
            }
        },
        {
            key: "valueSchema",
            get: function get() {
                return this._def.valueType;
            }
        },
        {
            key: "_parse",
            value: function _parse(input) {
                var _this__processInputParams = this._processInputParams(input), status = _this__processInputParams.status, ctx = _this__processInputParams.ctx;
                if (ctx.parsedType !== ZodParsedType.map) {
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: ZodParsedType.map,
                        received: ctx.parsedType
                    });
                    return INVALID;
                }
                var keyType = this._def.keyType;
                var valueType = this._def.valueType;
                var pairs = (0, $c6Xmf._)(ctx.data.entries()).map(function(param, index) {
                    var _param = (0, $cv9Rk._)(param, 2), key = _param[0], value = _param[1];
                    return {
                        key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, [
                            index,
                            "key"
                        ])),
                        value: valueType._parse(new ParseInputLazyPath(ctx, value, ctx.path, [
                            index,
                            "value"
                        ]))
                    };
                });
                if (ctx.common.async) {
                    var finalMap = new Map();
                    return Promise.resolve().then(/*#__PURE__*/ (0, $kSuI9._)(function() {
                        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, pair, key, value, err;
                        return (0, $l29cN.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        7,
                                        8,
                                        9
                                    ]);
                                    _iterator = pairs[Symbol.iterator]();
                                    _state.label = 2;
                                case 2:
                                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                        3,
                                        6
                                    ];
                                    pair = _step.value;
                                    return [
                                        4,
                                        pair.key
                                    ];
                                case 3:
                                    key = _state.sent();
                                    return [
                                        4,
                                        pair.value
                                    ];
                                case 4:
                                    value = _state.sent();
                                    if (key.status === "aborted" || value.status === "aborted") return [
                                        2,
                                        INVALID
                                    ];
                                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                                    finalMap.set(key.value, value.value);
                                    _state.label = 5;
                                case 5:
                                    _iteratorNormalCompletion = true;
                                    return [
                                        3,
                                        2
                                    ];
                                case 6:
                                    return [
                                        3,
                                        9
                                    ];
                                case 7:
                                    err = _state.sent();
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                    return [
                                        3,
                                        9
                                    ];
                                case 8:
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                    return [
                                        7
                                    ];
                                case 9:
                                    return [
                                        2,
                                        {
                                            status: status.value,
                                            value: finalMap
                                        }
                                    ];
                            }
                        });
                    }));
                } else {
                    var finalMap1 = new Map();
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = pairs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var pair = _step.value;
                            var key = pair.key;
                            var value = pair.value;
                            if (key.status === "aborted" || value.status === "aborted") return INVALID;
                            if (key.status === "dirty" || value.status === "dirty") status.dirty();
                            finalMap1.set(key.value, value.value);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return {
                        status: status.value,
                        value: finalMap1
                    };
                }
            }
        }
    ]);
    return ZodMap;
}(ZodType);
ZodMap.create = function(keyType, valueType, params) {
    return new ZodMap((0, $do9pw._)({
        valueType: valueType,
        keyType: keyType,
        typeName: ZodFirstPartyTypeKind.ZodMap
    }, processCreateParams(params)));
};
var ZodSet = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodSet, ZodType);
    var _super = (0, $ohfOJ._)(ZodSet);
    function ZodSet() {
        (0, $4GJKx._)(this, ZodSet);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodSet, [
        {
            key: "_parse",
            value: function _parse(input) {
                var _this__processInputParams = this._processInputParams(input), status = _this__processInputParams.status, ctx = _this__processInputParams.ctx;
                if (ctx.parsedType !== ZodParsedType.set) {
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: ZodParsedType.set,
                        received: ctx.parsedType
                    });
                    return INVALID;
                }
                var def = this._def;
                if (def.minSize !== null) {
                    if (ctx.data.size < def.minSize.value) {
                        addIssueToContext(ctx, {
                            code: ZodIssueCode.too_small,
                            minimum: def.minSize.value,
                            type: "set",
                            inclusive: true,
                            exact: false,
                            message: def.minSize.message
                        });
                        status.dirty();
                    }
                }
                if (def.maxSize !== null) {
                    if (ctx.data.size > def.maxSize.value) {
                        addIssueToContext(ctx, {
                            code: ZodIssueCode.too_big,
                            maximum: def.maxSize.value,
                            type: "set",
                            inclusive: true,
                            exact: false,
                            message: def.maxSize.message
                        });
                        status.dirty();
                    }
                }
                var valueType = this._def.valueType;
                function finalizeSet(elements) {
                    var parsedSet = new Set();
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var element = _step.value;
                            if (element.status === "aborted") return INVALID;
                            if (element.status === "dirty") status.dirty();
                            parsedSet.add(element.value);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return {
                        status: status.value,
                        value: parsedSet
                    };
                }
                var elements = (0, $c6Xmf._)(ctx.data.values()).map(function(item, i) {
                    return valueType._parse(new ParseInputLazyPath(ctx, item, ctx.path, i));
                });
                if (ctx.common.async) return Promise.all(elements).then(function(elements) {
                    return finalizeSet(elements);
                });
                else return finalizeSet(elements);
            }
        },
        {
            key: "min",
            value: function min(minSize, message) {
                return new ZodSet((0, $cxjpp._)((0, $do9pw._)({}, this._def), {
                    minSize: {
                        value: minSize,
                        message: errorUtil.toString(message)
                    }
                }));
            }
        },
        {
            key: "max",
            value: function max(maxSize, message) {
                return new ZodSet((0, $cxjpp._)((0, $do9pw._)({}, this._def), {
                    maxSize: {
                        value: maxSize,
                        message: errorUtil.toString(message)
                    }
                }));
            }
        },
        {
            key: "size",
            value: function size(size, message) {
                return this.min(size, message).max(size, message);
            }
        },
        {
            key: "nonempty",
            value: function nonempty(message) {
                return this.min(1, message);
            }
        }
    ]);
    return ZodSet;
}(ZodType);
ZodSet.create = function(valueType, params) {
    return new ZodSet((0, $do9pw._)({
        valueType: valueType,
        minSize: null,
        maxSize: null,
        typeName: ZodFirstPartyTypeKind.ZodSet
    }, processCreateParams(params)));
};
var ZodFunction = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodFunction, ZodType);
    var _super = (0, $ohfOJ._)(ZodFunction);
    function ZodFunction() {
        (0, $4GJKx._)(this, ZodFunction);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.validate = _this.implement;
        return _this;
    }
    (0, $1wc17._)(ZodFunction, [
        {
            key: "_parse",
            value: function _parse(input) {
                var ctx = this._processInputParams(input).ctx;
                if (ctx.parsedType !== ZodParsedType.function) {
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: ZodParsedType.function,
                        received: ctx.parsedType
                    });
                    return INVALID;
                }
                function makeArgsIssue(args, error) {
                    return makeIssue({
                        data: args,
                        path: ctx.path,
                        errorMaps: [
                            ctx.common.contextualErrorMap,
                            ctx.schemaErrorMap,
                            getErrorMap(),
                            errorMap
                        ].filter(function(x) {
                            return !!x;
                        }),
                        issueData: {
                            code: ZodIssueCode.invalid_arguments,
                            argumentsError: error
                        }
                    });
                }
                function makeReturnsIssue(returns, error) {
                    return makeIssue({
                        data: returns,
                        path: ctx.path,
                        errorMaps: [
                            ctx.common.contextualErrorMap,
                            ctx.schemaErrorMap,
                            getErrorMap(),
                            errorMap
                        ].filter(function(x) {
                            return !!x;
                        }),
                        issueData: {
                            code: ZodIssueCode.invalid_return_type,
                            returnTypeError: error
                        }
                    });
                }
                var params = {
                    errorMap: ctx.common.contextualErrorMap
                };
                var fn = ctx.data;
                if (this._def.returns instanceof ZodPromise) {
                    // Would love a way to avoid disabling this rule, but we need
                    // an alias (using an arrow function was what caused 2651).
                    // eslint-disable-next-line @typescript-eslint/no-this-alias
                    var me = this;
                    return OK(/*#__PURE__*/ (0, $kSuI9._)(function() {
                        var _len, args, _key, error, parsedArgs, result, parsedReturns;
                        var _arguments = arguments;
                        return (0, $l29cN.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    for(_len = _arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                                        args[_key] = _arguments[_key];
                                    }
                                    error = new ZodError([]);
                                    return [
                                        4,
                                        me._def.args.parseAsync(args, params).catch(function(e) {
                                            error.addIssue(makeArgsIssue(args, e));
                                            throw error;
                                        })
                                    ];
                                case 1:
                                    parsedArgs = _state.sent();
                                    return [
                                        4,
                                        Reflect.apply(fn, this, parsedArgs)
                                    ];
                                case 2:
                                    result = _state.sent();
                                    return [
                                        4,
                                        me._def.returns._def.type.parseAsync(result, params).catch(function(e) {
                                            error.addIssue(makeReturnsIssue(result, e));
                                            throw error;
                                        })
                                    ];
                                case 3:
                                    parsedReturns = _state.sent();
                                    return [
                                        2,
                                        parsedReturns
                                    ];
                            }
                        });
                    }));
                } else {
                    // Would love a way to avoid disabling this rule, but we need
                    // an alias (using an arrow function was what caused 2651).
                    // eslint-disable-next-line @typescript-eslint/no-this-alias
                    var me1 = this;
                    return OK(function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                            args[_key] = arguments[_key];
                        }
                        var parsedArgs = me1._def.args.safeParse(args, params);
                        if (!parsedArgs.success) throw new ZodError([
                            makeArgsIssue(args, parsedArgs.error)
                        ]);
                        var result = Reflect.apply(fn, this, parsedArgs.data);
                        var parsedReturns = me1._def.returns.safeParse(result, params);
                        if (!parsedReturns.success) throw new ZodError([
                            makeReturnsIssue(result, parsedReturns.error)
                        ]);
                        return parsedReturns.data;
                    });
                }
            }
        },
        {
            key: "parameters",
            value: function parameters() {
                return this._def.args;
            }
        },
        {
            key: "returnType",
            value: function returnType() {
                return this._def.returns;
            }
        },
        {
            key: "args",
            value: function args() {
                for(var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++){
                    items[_key] = arguments[_key];
                }
                return new ZodFunction((0, $cxjpp._)((0, $do9pw._)({}, this._def), {
                    args: ZodTuple.create(items).rest(ZodUnknown.create())
                }));
            }
        },
        {
            key: "returns",
            value: function returns(returnType) {
                return new ZodFunction((0, $cxjpp._)((0, $do9pw._)({}, this._def), {
                    returns: returnType
                }));
            }
        },
        {
            key: "implement",
            value: function implement(func) {
                var validatedFunc = this.parse(func);
                return validatedFunc;
            }
        },
        {
            key: "strictImplement",
            value: function strictImplement(func) {
                var validatedFunc = this.parse(func);
                return validatedFunc;
            }
        }
    ], [
        {
            key: "create",
            value: function create(args, returns, params) {
                return new ZodFunction((0, $do9pw._)({
                    args: args ? args : ZodTuple.create([]).rest(ZodUnknown.create()),
                    returns: returns || ZodUnknown.create(),
                    typeName: ZodFirstPartyTypeKind.ZodFunction
                }, processCreateParams(params)));
            }
        }
    ]);
    return ZodFunction;
}(ZodType);
var ZodLazy = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodLazy, ZodType);
    var _super = (0, $ohfOJ._)(ZodLazy);
    function ZodLazy() {
        (0, $4GJKx._)(this, ZodLazy);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodLazy, [
        {
            key: "schema",
            get: function get() {
                return this._def.getter();
            }
        },
        {
            key: "_parse",
            value: function _parse(input) {
                var ctx = this._processInputParams(input).ctx;
                var lazySchema = this._def.getter();
                return lazySchema._parse({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
            }
        }
    ]);
    return ZodLazy;
}(ZodType);
ZodLazy.create = function(getter, params) {
    return new ZodLazy((0, $do9pw._)({
        getter: getter,
        typeName: ZodFirstPartyTypeKind.ZodLazy
    }, processCreateParams(params)));
};
var ZodLiteral = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodLiteral, ZodType);
    var _super = (0, $ohfOJ._)(ZodLiteral);
    function ZodLiteral() {
        (0, $4GJKx._)(this, ZodLiteral);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodLiteral, [
        {
            key: "_parse",
            value: function _parse(input) {
                if (input.data !== this._def.value) {
                    var ctx = this._getOrReturnCtx(input);
                    addIssueToContext(ctx, {
                        received: ctx.data,
                        code: ZodIssueCode.invalid_literal,
                        expected: this._def.value
                    });
                    return INVALID;
                }
                return {
                    status: "valid",
                    value: input.data
                };
            }
        },
        {
            key: "value",
            get: function get() {
                return this._def.value;
            }
        }
    ]);
    return ZodLiteral;
}(ZodType);
ZodLiteral.create = function(value, params) {
    return new ZodLiteral((0, $do9pw._)({
        value: value,
        typeName: ZodFirstPartyTypeKind.ZodLiteral
    }, processCreateParams(params)));
};
function createZodEnum(values, params) {
    return new ZodEnum((0, $do9pw._)({
        values: values,
        typeName: ZodFirstPartyTypeKind.ZodEnum
    }, processCreateParams(params)));
}
var ZodEnum = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodEnum, ZodType);
    var _super = (0, $ohfOJ._)(ZodEnum);
    function ZodEnum() {
        (0, $4GJKx._)(this, ZodEnum);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodEnum, [
        {
            key: "_parse",
            value: function _parse(input) {
                if (typeof input.data !== "string") {
                    var ctx = this._getOrReturnCtx(input);
                    var expectedValues = this._def.values;
                    addIssueToContext(ctx, {
                        expected: util.joinValues(expectedValues),
                        received: ctx.parsedType,
                        code: ZodIssueCode.invalid_type
                    });
                    return INVALID;
                }
                if (this._def.values.indexOf(input.data) === -1) {
                    var ctx1 = this._getOrReturnCtx(input);
                    var expectedValues1 = this._def.values;
                    addIssueToContext(ctx1, {
                        received: ctx1.data,
                        code: ZodIssueCode.invalid_enum_value,
                        options: expectedValues1
                    });
                    return INVALID;
                }
                return OK(input.data);
            }
        },
        {
            key: "options",
            get: function get() {
                return this._def.values;
            }
        },
        {
            key: "enum",
            get: function get() {
                var enumValues = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var val = _step.value;
                        enumValues[val] = val;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return enumValues;
            }
        },
        {
            key: "Values",
            get: function get() {
                var enumValues = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var val = _step.value;
                        enumValues[val] = val;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return enumValues;
            }
        },
        {
            key: "Enum",
            get: function get() {
                var enumValues = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var val = _step.value;
                        enumValues[val] = val;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return enumValues;
            }
        },
        {
            key: "extract",
            value: function extract(values) {
                return ZodEnum.create(values);
            }
        },
        {
            key: "exclude",
            value: function exclude(values) {
                return ZodEnum.create(this.options.filter(function(opt) {
                    return !values.includes(opt);
                }));
            }
        }
    ]);
    return ZodEnum;
}(ZodType);
ZodEnum.create = createZodEnum;
var ZodNativeEnum = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodNativeEnum, ZodType);
    var _super = (0, $ohfOJ._)(ZodNativeEnum);
    function ZodNativeEnum() {
        (0, $4GJKx._)(this, ZodNativeEnum);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodNativeEnum, [
        {
            key: "_parse",
            value: function _parse(input) {
                var nativeEnumValues = util.getValidEnumValues(this._def.values);
                var ctx = this._getOrReturnCtx(input);
                if (ctx.parsedType !== ZodParsedType.string && ctx.parsedType !== ZodParsedType.number) {
                    var expectedValues = util.objectValues(nativeEnumValues);
                    addIssueToContext(ctx, {
                        expected: util.joinValues(expectedValues),
                        received: ctx.parsedType,
                        code: ZodIssueCode.invalid_type
                    });
                    return INVALID;
                }
                if (nativeEnumValues.indexOf(input.data) === -1) {
                    var expectedValues1 = util.objectValues(nativeEnumValues);
                    addIssueToContext(ctx, {
                        received: ctx.data,
                        code: ZodIssueCode.invalid_enum_value,
                        options: expectedValues1
                    });
                    return INVALID;
                }
                return OK(input.data);
            }
        },
        {
            key: "enum",
            get: function get() {
                return this._def.values;
            }
        }
    ]);
    return ZodNativeEnum;
}(ZodType);
ZodNativeEnum.create = function(values, params) {
    return new ZodNativeEnum((0, $do9pw._)({
        values: values,
        typeName: ZodFirstPartyTypeKind.ZodNativeEnum
    }, processCreateParams(params)));
};
var ZodPromise = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodPromise, ZodType);
    var _super = (0, $ohfOJ._)(ZodPromise);
    function ZodPromise() {
        (0, $4GJKx._)(this, ZodPromise);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodPromise, [
        {
            key: "unwrap",
            value: function unwrap() {
                return this._def.type;
            }
        },
        {
            key: "_parse",
            value: function _parse(input) {
                var _this = this;
                var ctx = this._processInputParams(input).ctx;
                if (ctx.parsedType !== ZodParsedType.promise && ctx.common.async === false) {
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: ZodParsedType.promise,
                        received: ctx.parsedType
                    });
                    return INVALID;
                }
                var promisified = ctx.parsedType === ZodParsedType.promise ? ctx.data : Promise.resolve(ctx.data);
                return OK(promisified.then(function(data) {
                    return _this._def.type.parseAsync(data, {
                        path: ctx.path,
                        errorMap: ctx.common.contextualErrorMap
                    });
                }));
            }
        }
    ]);
    return ZodPromise;
}(ZodType);
ZodPromise.create = function(schema, params) {
    return new ZodPromise((0, $do9pw._)({
        type: schema,
        typeName: ZodFirstPartyTypeKind.ZodPromise
    }, processCreateParams(params)));
};
var ZodEffects = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodEffects, ZodType);
    var _super = (0, $ohfOJ._)(ZodEffects);
    function ZodEffects() {
        (0, $4GJKx._)(this, ZodEffects);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodEffects, [
        {
            key: "innerType",
            value: function innerType() {
                return this._def.schema;
            }
        },
        {
            key: "sourceType",
            value: function sourceType() {
                return this._def.schema._def.typeName === ZodFirstPartyTypeKind.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
            }
        },
        {
            key: "_parse",
            value: function _parse(input) {
                var _this = this;
                var _this__processInputParams = this._processInputParams(input), status = _this__processInputParams.status, ctx = _this__processInputParams.ctx;
                var effect = this._def.effect || null;
                var checkCtx = {
                    addIssue: function(arg) {
                        addIssueToContext(ctx, arg);
                        if (arg.fatal) status.abort();
                        else status.dirty();
                    },
                    get path () {
                        return ctx.path;
                    }
                };
                checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
                if (effect.type === "preprocess") {
                    var processed = effect.transform(ctx.data, checkCtx);
                    if (ctx.common.issues.length) return {
                        status: "dirty",
                        value: ctx.data
                    };
                    if (ctx.common.async) return Promise.resolve(processed).then(function(processed) {
                        return _this._def.schema._parseAsync({
                            data: processed,
                            path: ctx.path,
                            parent: ctx
                        });
                    });
                    else return this._def.schema._parseSync({
                        data: processed,
                        path: ctx.path,
                        parent: ctx
                    });
                }
                if (effect.type === "refinement") {
                    var executeRefinement = function(acc) {
                        var result = effect.refinement(acc, checkCtx);
                        if (ctx.common.async) return Promise.resolve(result);
                        if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                        return acc;
                    };
                    if (ctx.common.async === false) {
                        var inner = this._def.schema._parseSync({
                            data: ctx.data,
                            path: ctx.path,
                            parent: ctx
                        });
                        if (inner.status === "aborted") return INVALID;
                        if (inner.status === "dirty") status.dirty();
                        // return value is ignored
                        executeRefinement(inner.value);
                        return {
                            status: status.value,
                            value: inner.value
                        };
                    } else return this._def.schema._parseAsync({
                        data: ctx.data,
                        path: ctx.path,
                        parent: ctx
                    }).then(function(inner) {
                        if (inner.status === "aborted") return INVALID;
                        if (inner.status === "dirty") status.dirty();
                        return executeRefinement(inner.value).then(function() {
                            return {
                                status: status.value,
                                value: inner.value
                            };
                        });
                    });
                }
                if (effect.type === "transform") {
                    if (ctx.common.async === false) {
                        var base = this._def.schema._parseSync({
                            data: ctx.data,
                            path: ctx.path,
                            parent: ctx
                        });
                        if (!isValid(base)) return base;
                        var result = effect.transform(base.value, checkCtx);
                        if (result instanceof Promise) throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
                        return {
                            status: status.value,
                            value: result
                        };
                    } else return this._def.schema._parseAsync({
                        data: ctx.data,
                        path: ctx.path,
                        parent: ctx
                    }).then(function(base) {
                        if (!isValid(base)) return base;
                        return Promise.resolve(effect.transform(base.value, checkCtx)).then(function(result) {
                            return {
                                status: status.value,
                                value: result
                            };
                        });
                    });
                }
                util.assertNever(effect);
            }
        }
    ]);
    return ZodEffects;
}(ZodType);
ZodEffects.create = function(schema, effect, params) {
    return new ZodEffects((0, $do9pw._)({
        schema: schema,
        typeName: ZodFirstPartyTypeKind.ZodEffects,
        effect: effect
    }, processCreateParams(params)));
};
ZodEffects.createWithPreprocess = function(preprocess, schema, params) {
    return new ZodEffects((0, $do9pw._)({
        schema: schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: ZodFirstPartyTypeKind.ZodEffects
    }, processCreateParams(params)));
};
var ZodOptional = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodOptional, ZodType);
    var _super = (0, $ohfOJ._)(ZodOptional);
    function ZodOptional() {
        (0, $4GJKx._)(this, ZodOptional);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodOptional, [
        {
            key: "_parse",
            value: function _parse(input) {
                var parsedType = this._getType(input);
                if (parsedType === ZodParsedType.undefined) return OK(undefined);
                return this._def.innerType._parse(input);
            }
        },
        {
            key: "unwrap",
            value: function unwrap() {
                return this._def.innerType;
            }
        }
    ]);
    return ZodOptional;
}(ZodType);
ZodOptional.create = function(type, params) {
    return new ZodOptional((0, $do9pw._)({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodOptional
    }, processCreateParams(params)));
};
var ZodNullable = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodNullable, ZodType);
    var _super = (0, $ohfOJ._)(ZodNullable);
    function ZodNullable() {
        (0, $4GJKx._)(this, ZodNullable);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodNullable, [
        {
            key: "_parse",
            value: function _parse(input) {
                var parsedType = this._getType(input);
                if (parsedType === ZodParsedType.null) return OK(null);
                return this._def.innerType._parse(input);
            }
        },
        {
            key: "unwrap",
            value: function unwrap() {
                return this._def.innerType;
            }
        }
    ]);
    return ZodNullable;
}(ZodType);
ZodNullable.create = function(type, params) {
    return new ZodNullable((0, $do9pw._)({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodNullable
    }, processCreateParams(params)));
};
var ZodDefault = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodDefault, ZodType);
    var _super = (0, $ohfOJ._)(ZodDefault);
    function ZodDefault() {
        (0, $4GJKx._)(this, ZodDefault);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodDefault, [
        {
            key: "_parse",
            value: function _parse(input) {
                var ctx = this._processInputParams(input).ctx;
                var data = ctx.data;
                if (ctx.parsedType === ZodParsedType.undefined) data = this._def.defaultValue();
                return this._def.innerType._parse({
                    data: data,
                    path: ctx.path,
                    parent: ctx
                });
            }
        },
        {
            key: "removeDefault",
            value: function removeDefault() {
                return this._def.innerType;
            }
        }
    ]);
    return ZodDefault;
}(ZodType);
ZodDefault.create = function(type, params) {
    return new ZodDefault((0, $do9pw._)({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : function() {
            return params.default;
        }
    }, processCreateParams(params)));
};
var ZodCatch = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodCatch, ZodType);
    var _super = (0, $ohfOJ._)(ZodCatch);
    function ZodCatch() {
        (0, $4GJKx._)(this, ZodCatch);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodCatch, [
        {
            key: "_parse",
            value: function _parse(input) {
                var _this = this;
                var ctx = this._processInputParams(input).ctx;
                // newCtx is used to not collect issues from inner types in ctx
                var newCtx = (0, $cxjpp._)((0, $do9pw._)({}, ctx), {
                    common: (0, $cxjpp._)((0, $do9pw._)({}, ctx.common), {
                        issues: []
                    })
                });
                var result = this._def.innerType._parse({
                    data: newCtx.data,
                    path: newCtx.path,
                    parent: (0, $do9pw._)({}, newCtx)
                });
                if (isAsync(result)) return result.then(function(result) {
                    return {
                        status: "valid",
                        value: result.status === "valid" ? result.value : _this._def.catchValue({
                            get error () {
                                return new ZodError(newCtx.common.issues);
                            },
                            input: newCtx.data
                        })
                    };
                });
                else return {
                    status: "valid",
                    value: result.status === "valid" ? result.value : this._def.catchValue({
                        get error () {
                            return new ZodError(newCtx.common.issues);
                        },
                        input: newCtx.data
                    })
                };
            }
        },
        {
            key: "removeCatch",
            value: function removeCatch() {
                return this._def.innerType;
            }
        }
    ]);
    return ZodCatch;
}(ZodType);
ZodCatch.create = function(type, params) {
    return new ZodCatch((0, $do9pw._)({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : function() {
            return params.catch;
        }
    }, processCreateParams(params)));
};
var ZodNaN = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodNaN, ZodType);
    var _super = (0, $ohfOJ._)(ZodNaN);
    function ZodNaN() {
        (0, $4GJKx._)(this, ZodNaN);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodNaN, [
        {
            key: "_parse",
            value: function _parse(input) {
                var parsedType = this._getType(input);
                if (parsedType !== ZodParsedType.nan) {
                    var ctx = this._getOrReturnCtx(input);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: ZodParsedType.nan,
                        received: ctx.parsedType
                    });
                    return INVALID;
                }
                return {
                    status: "valid",
                    value: input.data
                };
            }
        }
    ]);
    return ZodNaN;
}(ZodType);
ZodNaN.create = function(params) {
    return new ZodNaN((0, $do9pw._)({
        typeName: ZodFirstPartyTypeKind.ZodNaN
    }, processCreateParams(params)));
};
var BRAND = Symbol("zod_brand");
var ZodBranded = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodBranded, ZodType);
    var _super = (0, $ohfOJ._)(ZodBranded);
    function ZodBranded() {
        (0, $4GJKx._)(this, ZodBranded);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodBranded, [
        {
            key: "_parse",
            value: function _parse(input) {
                var ctx = this._processInputParams(input).ctx;
                var data = ctx.data;
                return this._def.type._parse({
                    data: data,
                    path: ctx.path,
                    parent: ctx
                });
            }
        },
        {
            key: "unwrap",
            value: function unwrap() {
                return this._def.type;
            }
        }
    ]);
    return ZodBranded;
}(ZodType);
var ZodPipeline = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodPipeline, ZodType);
    var _super = (0, $ohfOJ._)(ZodPipeline);
    function ZodPipeline() {
        (0, $4GJKx._)(this, ZodPipeline);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodPipeline, [
        {
            key: "_parse",
            value: function _parse(input) {
                var _this__processInputParams = this._processInputParams(input), status = _this__processInputParams.status, ctx = _this__processInputParams.ctx;
                if (ctx.common.async) {
                    var _this = this;
                    var handleAsync = function() {
                        var _ref = (0, $kSuI9._)(function() {
                            var inResult;
                            return (0, $l29cN.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            _this._def.in._parseAsync({
                                                data: ctx.data,
                                                path: ctx.path,
                                                parent: ctx
                                            })
                                        ];
                                    case 1:
                                        inResult = _state.sent();
                                        if (inResult.status === "aborted") return [
                                            2,
                                            INVALID
                                        ];
                                        if (inResult.status === "dirty") {
                                            status.dirty();
                                            return [
                                                2,
                                                DIRTY(inResult.value)
                                            ];
                                        } else return [
                                            2,
                                            _this._def.out._parseAsync({
                                                data: inResult.value,
                                                path: ctx.path,
                                                parent: ctx
                                            })
                                        ];
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function handleAsync() {
                            return _ref.apply(this, arguments);
                        };
                    }();
                    return handleAsync();
                } else {
                    var inResult = this._def.in._parseSync({
                        data: ctx.data,
                        path: ctx.path,
                        parent: ctx
                    });
                    if (inResult.status === "aborted") return INVALID;
                    if (inResult.status === "dirty") {
                        status.dirty();
                        return {
                            status: "dirty",
                            value: inResult.value
                        };
                    } else return this._def.out._parseSync({
                        data: inResult.value,
                        path: ctx.path,
                        parent: ctx
                    });
                }
            }
        }
    ], [
        {
            key: "create",
            value: function create(a, b) {
                return new ZodPipeline({
                    in: a,
                    out: b,
                    typeName: ZodFirstPartyTypeKind.ZodPipeline
                });
            }
        }
    ]);
    return ZodPipeline;
}(ZodType);
var ZodReadonly = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodReadonly, ZodType);
    var _super = (0, $ohfOJ._)(ZodReadonly);
    function ZodReadonly() {
        (0, $4GJKx._)(this, ZodReadonly);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodReadonly, [
        {
            key: "_parse",
            value: function _parse(input) {
                var result = this._def.innerType._parse(input);
                if (isValid(result)) result.value = Object.freeze(result.value);
                return result;
            }
        }
    ]);
    return ZodReadonly;
}(ZodType);
ZodReadonly.create = function(type, params) {
    return new ZodReadonly((0, $do9pw._)({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodReadonly
    }, processCreateParams(params)));
};
var custom = function(check) {
    var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal = arguments.length > 2 ? arguments[2] : void 0;
    if (check) return ZodAny.create().superRefine(function(data, ctx) {
        var _a, _b;
        if (!check(data)) {
            var p = typeof params === "function" ? params(data) : typeof params === "string" ? {
                message: params
            } : params;
            var _fatal = (_b = (_a = p.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
            var p2 = typeof p === "string" ? {
                message: p
            } : p;
            ctx.addIssue((0, $cxjpp._)((0, $do9pw._)({
                code: "custom"
            }, p2), {
                fatal: _fatal
            }));
        }
    });
    return ZodAny.create();
};
var late = {
    object: ZodObject.lazycreate
};
var ZodFirstPartyTypeKind;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})(ZodFirstPartyTypeKind || (ZodFirstPartyTypeKind = {}));
var instanceOfType = function(// const instanceOfType = <T extends new (...args: any[]) => any>(
cls) {
    var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        message: "Input not instance of ".concat(cls.name)
    };
    return custom(function(data) {
        return data instanceof cls;
    }, params);
};
var stringType = ZodString.create;
var numberType = ZodNumber.create;
var nanType = ZodNaN.create;
var bigIntType = ZodBigInt.create;
var booleanType = ZodBoolean.create;
var dateType = ZodDate.create;
var symbolType = ZodSymbol.create;
var undefinedType = ZodUndefined.create;
var nullType = ZodNull.create;
var anyType = ZodAny.create;
var unknownType = ZodUnknown.create;
var neverType = ZodNever.create;
var voidType = ZodVoid.create;
var arrayType = ZodArray.create;
var objectType = ZodObject.create;
var strictObjectType = ZodObject.strictCreate;
var unionType = ZodUnion.create;
var discriminatedUnionType = ZodDiscriminatedUnion.create;
var intersectionType = ZodIntersection.create;
var tupleType = ZodTuple.create;
var recordType = ZodRecord.create;
var mapType = ZodMap.create;
var setType = ZodSet.create;
var functionType = ZodFunction.create;
var lazyType = ZodLazy.create;
var literalType = ZodLiteral.create;
var enumType = ZodEnum.create;
var nativeEnumType = ZodNativeEnum.create;
var promiseType = ZodPromise.create;
var effectsType = ZodEffects.create;
var optionalType = ZodOptional.create;
var nullableType = ZodNullable.create;
var preprocessType = ZodEffects.createWithPreprocess;
var pipelineType = ZodPipeline.create;
var ostring = function() {
    return stringType().optional();
};
var onumber = function() {
    return numberType().optional();
};
var oboolean = function() {
    return booleanType().optional();
};
var coerce = {
    string: function(arg) {
        return ZodString.create((0, $cxjpp._)((0, $do9pw._)({}, arg), {
            coerce: true
        }));
    },
    number: function(arg) {
        return ZodNumber.create((0, $cxjpp._)((0, $do9pw._)({}, arg), {
            coerce: true
        }));
    },
    boolean: function(arg) {
        return ZodBoolean.create((0, $cxjpp._)((0, $do9pw._)({}, arg), {
            coerce: true
        }));
    },
    bigint: function(arg) {
        return ZodBigInt.create((0, $cxjpp._)((0, $do9pw._)({}, arg), {
            coerce: true
        }));
    },
    date: function(arg) {
        return ZodDate.create((0, $cxjpp._)((0, $do9pw._)({}, arg), {
            coerce: true
        }));
    }
};
var NEVER = INVALID;
var z = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    defaultErrorMap: errorMap,
    setErrorMap: setErrorMap,
    getErrorMap: getErrorMap,
    makeIssue: makeIssue,
    EMPTY_PATH: EMPTY_PATH,
    addIssueToContext: addIssueToContext,
    ParseStatus: ParseStatus,
    INVALID: INVALID,
    DIRTY: DIRTY,
    OK: OK,
    isAborted: isAborted,
    isDirty: isDirty,
    isValid: isValid,
    isAsync: isAsync,
    get util () {
        return util;
    },
    get objectUtil () {
        return objectUtil;
    },
    ZodParsedType: ZodParsedType,
    getParsedType: getParsedType,
    ZodType: ZodType,
    ZodString: ZodString,
    ZodNumber: ZodNumber,
    ZodBigInt: ZodBigInt,
    ZodBoolean: ZodBoolean,
    ZodDate: ZodDate,
    ZodSymbol: ZodSymbol,
    ZodUndefined: ZodUndefined,
    ZodNull: ZodNull,
    ZodAny: ZodAny,
    ZodUnknown: ZodUnknown,
    ZodNever: ZodNever,
    ZodVoid: ZodVoid,
    ZodArray: ZodArray,
    ZodObject: ZodObject,
    ZodUnion: ZodUnion,
    ZodDiscriminatedUnion: ZodDiscriminatedUnion,
    ZodIntersection: ZodIntersection,
    ZodTuple: ZodTuple,
    ZodRecord: ZodRecord,
    ZodMap: ZodMap,
    ZodSet: ZodSet,
    ZodFunction: ZodFunction,
    ZodLazy: ZodLazy,
    ZodLiteral: ZodLiteral,
    ZodEnum: ZodEnum,
    ZodNativeEnum: ZodNativeEnum,
    ZodPromise: ZodPromise,
    ZodEffects: ZodEffects,
    ZodTransformer: ZodEffects,
    ZodOptional: ZodOptional,
    ZodNullable: ZodNullable,
    ZodDefault: ZodDefault,
    ZodCatch: ZodCatch,
    ZodNaN: ZodNaN,
    BRAND: BRAND,
    ZodBranded: ZodBranded,
    ZodPipeline: ZodPipeline,
    ZodReadonly: ZodReadonly,
    custom: custom,
    Schema: ZodType,
    ZodSchema: ZodType,
    late: late,
    get ZodFirstPartyTypeKind () {
        return ZodFirstPartyTypeKind;
    },
    coerce: coerce,
    any: anyType,
    array: arrayType,
    bigint: bigIntType,
    boolean: booleanType,
    date: dateType,
    discriminatedUnion: discriminatedUnionType,
    effect: effectsType,
    "enum": enumType,
    "function": functionType,
    "instanceof": instanceOfType,
    intersection: intersectionType,
    lazy: lazyType,
    literal: literalType,
    map: mapType,
    nan: nanType,
    nativeEnum: nativeEnumType,
    never: neverType,
    "null": nullType,
    nullable: nullableType,
    number: numberType,
    object: objectType,
    oboolean: oboolean,
    onumber: onumber,
    optional: optionalType,
    ostring: ostring,
    pipeline: pipelineType,
    preprocess: preprocessType,
    promise: promiseType,
    record: recordType,
    set: setType,
    strictObject: strictObjectType,
    string: stringType,
    symbol: symbolType,
    transformer: effectsType,
    tuple: tupleType,
    "undefined": undefinedType,
    union: unionType,
    unknown: unknownType,
    "void": voidType,
    NEVER: NEVER,
    ZodIssueCode: ZodIssueCode,
    quotelessJson: quotelessJson,
    ZodError: ZodError
});

});

parcelRegister("5IyZO", function(module, exports) {
$parcel$export(module.exports, "FieldDefinitionSchema", function () { return (parcelRequire("kjOdg")).FieldDefinitionSchema; });
$parcel$export(module.exports, "ChannelSchema", function () { return (parcelRequire("kzlGA")).ChannelSchema; });
$parcel$export(module.exports, "ConfigurationStatusSchema", function () { return (parcelRequire("1n4ry")).ConfigurationStatusSchema; });
$parcel$export(module.exports, "DefinitionStatusSchema", function () { return (parcelRequire("1n4ry")).DefinitionStatusSchema; });
$parcel$export(module.exports, "FieldValueSchema", function () { return (parcelRequire("b4p6v")).FieldValueSchema; });
$parcel$export(module.exports, "VersionStringSchema", function () { return (parcelRequire("7wcDg")).VersionStringSchema; });
parcelRequire("digJf");
parcelRequire("cAXOY");

});
parcelRegister("digJf", function(module, exports) {
$parcel$export(module.exports, "FieldDefinitionSchema", function () { return (parcelRequire("kjOdg")).FieldDefinitionSchema; });
parcelRequire("bVTYb");
parcelRequire("1NZih");
parcelRequire("fqBdH");
parcelRequire("kjOdg");
parcelRequire("54KL5");
parcelRequire("gsEkB");
parcelRequire("bGdmL");
parcelRequire("jPfn6");
parcelRequire("8yxKI");

});
parcelRegister("bVTYb", function(module, exports) {

$parcel$export(module.exports, "BaseFieldDefinitionSchema", function () { return $8b006efd59827569$export$d705cae37194a6fd; });

var $jZoZ7 = parcelRequire("jZoZ7");
parcelRequire("cAXOY");
var $2s47m = parcelRequire("2s47m");
var $8b006efd59827569$export$d705cae37194a6fd = (0, $jZoZ7.z).object({
    name: (0, $jZoZ7.z).string(),
    label: (0, $jZoZ7.z).string(),
    description: (0, $jZoZ7.z).string().optional(),
    appearance: (0, $2s47m.AppearanceSchema).optional(),
    validations: (0, $jZoZ7.z).object({
        isRequired: (0, $jZoZ7.z).boolean().optional()
    }).optional()
});

});
parcelRegister("cAXOY", function(module, exports) {
$parcel$export(module.exports, "AppearanceSchema", function () { return (parcelRequire("2s47m")).AppearanceSchema; });
$parcel$export(module.exports, "ContentTypeSchema", function () { return (parcelRequire("kGXRM")).ContentTypeSchema; });
$parcel$export(module.exports, "ChannelSchema", function () { return (parcelRequire("kzlGA")).ChannelSchema; });
$parcel$export(module.exports, "ConfigurationStatusSchema", function () { return (parcelRequire("1n4ry")).ConfigurationStatusSchema; });
$parcel$export(module.exports, "DefinitionStatusSchema", function () { return (parcelRequire("1n4ry")).DefinitionStatusSchema; });
$parcel$export(module.exports, "VersionStringSchema", function () { return (parcelRequire("7wcDg")).VersionStringSchema; });
$parcel$export(module.exports, "FieldValueSchema", function () { return (parcelRequire("b4p6v")).FieldValueSchema; });
parcelRequire("2s47m");
parcelRequire("kGXRM");
parcelRequire("kzlGA");
parcelRequire("1n4ry");
parcelRequire("7wcDg");
parcelRequire("b4p6v");

});
parcelRegister("2s47m", function(module, exports) {

$parcel$export(module.exports, "AppearanceSchema", function () { return $1c916402707ca6bc$export$1ffbf42c7fd51c74; });

var $jZoZ7 = parcelRequire("jZoZ7");
var $1c916402707ca6bc$export$5b08de444ca2ce7;
(function(AppearanceType) {
    AppearanceType["Toggle"] = "TOGGLE";
    AppearanceType["Dropdown"] = "DROPDOWN";
})($1c916402707ca6bc$export$5b08de444ca2ce7 || ($1c916402707ca6bc$export$5b08de444ca2ce7 = {}));
var $1c916402707ca6bc$export$1ffbf42c7fd51c74 = (0, $jZoZ7.z).object({
    type: (0, $jZoZ7.z).nativeEnum($1c916402707ca6bc$export$5b08de444ca2ce7),
    helpText: (0, $jZoZ7.z).string()
});

});

parcelRegister("kGXRM", function(module, exports) {

$parcel$export(module.exports, "ContentTypeSchema", function () { return $f1062b21bd9345c7$export$72ef1e5a8ee296af; });

var $jZoZ7 = parcelRequire("jZoZ7");
var $f1062b21bd9345c7$export$72ef1e5a8ee296af = (0, $jZoZ7.z).enum([
    "image/gif",
    "image/jpeg",
    "image/png",
    "application/json",
    "application/pdf",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    "application/vnd.oasis.opendocument.presentation",
    "application/vnd.oasis.opendocument.spreadsheet",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/gzip",
    "application/x-tar",
    "application/x-7z-compressed",
    "application/zip",
    "video/mp4",
    "video/mpeg"
]);

});

parcelRegister("kzlGA", function(module, exports) {

$parcel$export(module.exports, "ChannelSchema", function () { return $ef97e5ea0f2d1ca9$export$fcb905a95c1e1360; });

var $jZoZ7 = parcelRequire("jZoZ7");
var $ef97e5ea0f2d1ca9$export$fcb905a95c1e1360 = (0, $jZoZ7.z).union([
    (0, $jZoZ7.z).literal("web"),
    (0, $jZoZ7.z).literal("mobile"),
    (0, $jZoZ7.z).literal("desktop")
]);

});

parcelRegister("1n4ry", function(module, exports) {

$parcel$export(module.exports, "DefinitionStatusSchema", function () { return $0ffb62c70fd56356$export$626c35e3788d9efe; });
$parcel$export(module.exports, "ConfigurationStatusSchema", function () { return $0ffb62c70fd56356$export$8e53b1063c85c3db; });

var $jZoZ7 = parcelRequire("jZoZ7");
var $0ffb62c70fd56356$export$bbdac32ea6bb280f;
(function(DefinitionStatus) {
    DefinitionStatus["Active"] = "active";
    DefinitionStatus["Inactive"] = "inactive";
})($0ffb62c70fd56356$export$bbdac32ea6bb280f || ($0ffb62c70fd56356$export$bbdac32ea6bb280f = {}));
var $0ffb62c70fd56356$export$626c35e3788d9efe = (0, $jZoZ7.z).nativeEnum($0ffb62c70fd56356$export$bbdac32ea6bb280f);
var $0ffb62c70fd56356$export$2f442b2791cfbb7d;
(function(ConfigurationStatus) {
    ConfigurationStatus["Draft"] = "draft";
    ConfigurationStatus["Staged"] = "staged";
    ConfigurationStatus["Published"] = "published";
    ConfigurationStatus["Unpublished"] = "unpublished";
    ConfigurationStatus["Deleted"] = "deleted";
    ConfigurationStatus["Revision"] = "revision";
})($0ffb62c70fd56356$export$2f442b2791cfbb7d || ($0ffb62c70fd56356$export$2f442b2791cfbb7d = {}));
var $0ffb62c70fd56356$export$8e53b1063c85c3db = (0, $jZoZ7.z).nativeEnum($0ffb62c70fd56356$export$2f442b2791cfbb7d);

});

parcelRegister("7wcDg", function(module, exports) {

$parcel$export(module.exports, "VersionStringSchema", function () { return $5795521043191c1a$export$56ffedcaf54b409e; });

var $jZoZ7 = parcelRequire("jZoZ7");
var $5795521043191c1a$var$verExpression = /^\d+\.\d+\.\d+$/;
var $5795521043191c1a$export$56ffedcaf54b409e = (0, $jZoZ7.z).custom(function(str) {
    return $5795521043191c1a$var$verExpression.test(str);
});

});

parcelRegister("b4p6v", function(module, exports) {

$parcel$export(module.exports, "FieldValueSchema", function () { return $80f38a9126c4a92a$export$eb1f8bd24ff3d687; });

var $jZoZ7 = parcelRequire("jZoZ7");
var $80f38a9126c4a92a$export$eb1f8bd24ff3d687 = (0, $jZoZ7.z).lazy(function() {
    return (0, $jZoZ7.z).union([
        (0, $jZoZ7.z).string(),
        (0, $jZoZ7.z).number(),
        (0, $jZoZ7.z).boolean(),
        (0, $jZoZ7.z).object({}),
        (0, $jZoZ7.z).array($80f38a9126c4a92a$export$eb1f8bd24ff3d687),
        (0, $jZoZ7.z).record((0, $jZoZ7.z).string(), $80f38a9126c4a92a$export$eb1f8bd24ff3d687)
    ]);
});

});



parcelRegister("1NZih", function(module, exports) {

$parcel$export(module.exports, "AssetFieldDefinitionSchema", function () { return $1509e9b9f8c324a9$export$f779283eb177a7f7; });

var $jZoZ7 = parcelRequire("jZoZ7");

var $bVTYb = parcelRequire("bVTYb");
parcelRequire("cAXOY");
var $kGXRM = parcelRequire("kGXRM");
var $1509e9b9f8c324a9$export$3f58308ad1138379;
(function(AssetFieldDefinition) {
    AssetFieldDefinition.TYPE = "assetReference";
})($1509e9b9f8c324a9$export$3f58308ad1138379 || ($1509e9b9f8c324a9$export$3f58308ad1138379 = {}));
var $1509e9b9f8c324a9$export$f779283eb177a7f7 = (0, $bVTYb.BaseFieldDefinitionSchema).and((0, $jZoZ7.z).object({
    type: (0, $jZoZ7.z).literal($1509e9b9f8c324a9$export$3f58308ad1138379.TYPE),
    i18n: (0, $jZoZ7.z).boolean().optional(),
    validations: (0, $jZoZ7.z).object({
        contentTypeRestrictions: (0, $jZoZ7.z).array((0, $kGXRM.ContentTypeSchema)).optional()
    }).optional()
}));

});

parcelRegister("fqBdH", function(module, exports) {

$parcel$export(module.exports, "DateFieldDefinitionSchema", function () { return $b3b627d8b6f6274b$export$edf0d271d329813b; });

var $jZoZ7 = parcelRequire("jZoZ7");

var $bVTYb = parcelRequire("bVTYb");
var $b3b627d8b6f6274b$export$4a87c0e84bddbe67;
(function(DateFieldDefinition) {
    DateFieldDefinition.TYPE = "date";
})($b3b627d8b6f6274b$export$4a87c0e84bddbe67 || ($b3b627d8b6f6274b$export$4a87c0e84bddbe67 = {}));
var $b3b627d8b6f6274b$export$edf0d271d329813b = (0, $bVTYb.BaseFieldDefinitionSchema).and((0, $jZoZ7.z).object({
    type: (0, $jZoZ7.z).literal($b3b627d8b6f6274b$export$4a87c0e84bddbe67.TYPE),
    defaultValue: (0, $jZoZ7.z).string().optional(),
    validations: (0, $jZoZ7.z).object({
        min: (0, $jZoZ7.z).string().optional(),
        max: (0, $jZoZ7.z).string().optional()
    }).optional()
}));

});

parcelRegister("kjOdg", function(module, exports) {

$parcel$export(module.exports, "FieldDefinitionSchema", function () { return $ecac883dbadffebb$export$9f35d942cd64c9da; });

var $54KL5 = parcelRequire("54KL5");

var $fqBdH = parcelRequire("fqBdH");

var $gsEkB = parcelRequire("gsEkB");

var $1NZih = parcelRequire("1NZih");

var $8yxKI = parcelRequire("8yxKI");

var $bGdmL = parcelRequire("bGdmL");

var $jPfn6 = parcelRequire("jPfn6");
var $ecac883dbadffebb$export$9f35d942cd64c9da = (0, $54KL5.PrimitiveFieldDefinitionSchema).or((0, $1NZih.AssetFieldDefinitionSchema)).or((0, $fqBdH.DateFieldDefinitionSchema)).or((0, $gsEkB.RichTextFieldDefinitionSchema)).or((0, $jPfn6.ArrayFieldDefinitionSchema)).or((0, $bGdmL.ObjectFieldDefinitionSchema)).or((0, $8yxKI.EnumFieldDefinitionSchema));

});
parcelRegister("54KL5", function(module, exports) {

$parcel$export(module.exports, "PrimitiveFieldDefinitionSchema", function () { return $3b2198bb410f739f$export$dd61538c4f3bdbeb; });

var $jZoZ7 = parcelRequire("jZoZ7");

var $bVTYb = parcelRequire("bVTYb");
var $3b2198bb410f739f$export$1c6679e2d82c03dd;
(function(StringFieldDefinition) {
    StringFieldDefinition.TYPE = "string";
})($3b2198bb410f739f$export$1c6679e2d82c03dd || ($3b2198bb410f739f$export$1c6679e2d82c03dd = {}));
var $3b2198bb410f739f$export$ffb57f371662239d = (0, $bVTYb.BaseFieldDefinitionSchema).and((0, $jZoZ7.z).object({
    type: (0, $jZoZ7.z).literal($3b2198bb410f739f$export$1c6679e2d82c03dd.TYPE),
    defaultValue: (0, $jZoZ7.z).string().optional(),
    i18n: (0, $jZoZ7.z).boolean().optional(),
    validations: (0, $jZoZ7.z).object({
        minLength: (0, $jZoZ7.z).number().optional(),
        maxLength: (0, $jZoZ7.z).number().optional(),
        pattern: (0, $jZoZ7.z).string().optional()
    }).optional()
}));
var $3b2198bb410f739f$export$d88d53756ef63bd;
(function(BooleanFieldDefinition) {
    BooleanFieldDefinition.TYPE = "boolean";
})($3b2198bb410f739f$export$d88d53756ef63bd || ($3b2198bb410f739f$export$d88d53756ef63bd = {}));
var $3b2198bb410f739f$export$f8b10ca3ac81c1f2 = (0, $bVTYb.BaseFieldDefinitionSchema).and((0, $jZoZ7.z).object({
    type: (0, $jZoZ7.z).literal($3b2198bb410f739f$export$d88d53756ef63bd.TYPE),
    defaultValue: (0, $jZoZ7.z).boolean().optional()
}));
var $3b2198bb410f739f$export$e8cfbf1c68de676b;
(function(NumberFieldDefinition) {
    NumberFieldDefinition.TYPE = "number";
})($3b2198bb410f739f$export$e8cfbf1c68de676b || ($3b2198bb410f739f$export$e8cfbf1c68de676b = {}));
var $3b2198bb410f739f$export$53d940b94a7e9ecd = (0, $bVTYb.BaseFieldDefinitionSchema).and((0, $jZoZ7.z).object({
    type: (0, $jZoZ7.z).literal($3b2198bb410f739f$export$e8cfbf1c68de676b.TYPE),
    defaultValue: (0, $jZoZ7.z).number().optional(),
    validations: (0, $jZoZ7.z).object({
        isInteger: (0, $jZoZ7.z).boolean().optional(),
        min: (0, $jZoZ7.z).number().optional(),
        max: (0, $jZoZ7.z).number().optional()
    }).optional()
}));
var $3b2198bb410f739f$export$dd61538c4f3bdbeb = $3b2198bb410f739f$export$ffb57f371662239d.or($3b2198bb410f739f$export$f8b10ca3ac81c1f2).or($3b2198bb410f739f$export$53d940b94a7e9ecd);

});

parcelRegister("gsEkB", function(module, exports) {

$parcel$export(module.exports, "RichTextFieldDefinitionSchema", function () { return $bfbe8bd7cac05693$export$4e8542e8ca81ca9; });

var $jZoZ7 = parcelRequire("jZoZ7");

var $bVTYb = parcelRequire("bVTYb");
var $bfbe8bd7cac05693$export$ec51ccdb0d98bbf2;
(function(RichTextFieldDefinition) {
    RichTextFieldDefinition.TYPE = "richText";
})($bfbe8bd7cac05693$export$ec51ccdb0d98bbf2 || ($bfbe8bd7cac05693$export$ec51ccdb0d98bbf2 = {}));
var $bfbe8bd7cac05693$export$4e8542e8ca81ca9 = (0, $bVTYb.BaseFieldDefinitionSchema).and((0, $jZoZ7.z).object({
    type: (0, $jZoZ7.z).literal($bfbe8bd7cac05693$export$ec51ccdb0d98bbf2.TYPE),
    i18n: (0, $jZoZ7.z).boolean().optional()
}));

});

parcelRegister("8yxKI", function(module, exports) {

$parcel$export(module.exports, "EnumFieldDefinitionSchema", function () { return $63abae3e70c119fb$export$a628ea0b5c8ade79; });

var $jZoZ7 = parcelRequire("jZoZ7");

var $bVTYb = parcelRequire("bVTYb");
var $63abae3e70c119fb$export$53aba312a60ce2c5;
(function(EnumFieldDefinition) {
    EnumFieldDefinition.TYPE = "enum";
})($63abae3e70c119fb$export$53aba312a60ce2c5 || ($63abae3e70c119fb$export$53aba312a60ce2c5 = {}));
var $63abae3e70c119fb$export$a628ea0b5c8ade79 = (0, $bVTYb.BaseFieldDefinitionSchema).and((0, $jZoZ7.z).object({
    type: (0, $jZoZ7.z).literal($63abae3e70c119fb$export$53aba312a60ce2c5.TYPE),
    validations: (0, $jZoZ7.z).object({
        cases: (0, $jZoZ7.z).array((0, $jZoZ7.z).string())
    })
}));

});

parcelRegister("bGdmL", function(module, exports) {

$parcel$export(module.exports, "ObjectFieldDefinitionSchema", function () { return $880dfc30d879880a$export$fbf5c120bb8a3b5f; });

var $jZoZ7 = parcelRequire("jZoZ7");

var $bVTYb = parcelRequire("bVTYb");

var $kjOdg = parcelRequire("kjOdg");
var $880dfc30d879880a$export$7c06493e16f2f9e9;
(function(ObjectFieldDefinition) {
    ObjectFieldDefinition.TYPE = "object";
})($880dfc30d879880a$export$7c06493e16f2f9e9 || ($880dfc30d879880a$export$7c06493e16f2f9e9 = {}));
var $880dfc30d879880a$export$fbf5c120bb8a3b5f = (0, $bVTYb.BaseFieldDefinitionSchema).and((0, $jZoZ7.z).object({
    type: (0, $jZoZ7.z).literal($880dfc30d879880a$export$7c06493e16f2f9e9.TYPE),
    fieldDefinitions: (0, $jZoZ7.z).array((0, $jZoZ7.z).lazy(function() {
        return 0, $kjOdg.FieldDefinitionSchema;
    }))
}));

});

parcelRegister("jPfn6", function(module, exports) {

$parcel$export(module.exports, "ArrayFieldDefinitionSchema", function () { return $e6eeb43c713705d3$export$75365c6b413e226f; });

var $jZoZ7 = parcelRequire("jZoZ7");

var $bVTYb = parcelRequire("bVTYb");

var $kjOdg = parcelRequire("kjOdg");
var $e6eeb43c713705d3$export$fdbaa03e335573a0;
(function(ArrayFieldDefinition) {
    ArrayFieldDefinition.TYPE = "array";
})($e6eeb43c713705d3$export$fdbaa03e335573a0 || ($e6eeb43c713705d3$export$fdbaa03e335573a0 = {}));
var $e6eeb43c713705d3$export$75365c6b413e226f = (0, $bVTYb.BaseFieldDefinitionSchema).and((0, $jZoZ7.z).object({
    type: (0, $jZoZ7.z).literal($e6eeb43c713705d3$export$fdbaa03e335573a0.TYPE),
    fieldDefinition: (0, $jZoZ7.z).lazy(function() {
        return 0, $kjOdg.FieldDefinitionSchema;
    }),
    validations: (0, $jZoZ7.z).object({
        minItems: (0, $jZoZ7.z).number().optional(),
        maxItems: (0, $jZoZ7.z).number().optional(),
        hasUniqueItems: (0, $jZoZ7.z).boolean().optional()
    }).optional()
}));

});




parcelRegister("4M9am", function(module, exports) {

$parcel$export(module.exports, "ZoneDefinitionSchema", function () { return $37a2c14e625d5fd3$export$552af0e1507ea76; });

var $jZoZ7 = parcelRequire("jZoZ7");
parcelRequire("5IyZO");
var $1n4ry = parcelRequire("1n4ry");
var $37a2c14e625d5fd3$export$479f9e32fa26e841 = (0, $jZoZ7.z).object({
    isInheritable: (0, $jZoZ7.z).boolean().optional(),
    moduleRestrictions: (0, $jZoZ7.z).array((0, $jZoZ7.z).object({
        name: (0, $jZoZ7.z).string(),
        version: (0, $jZoZ7.z).string()
    })).optional()
});
var $37a2c14e625d5fd3$export$552af0e1507ea76 = (0, $jZoZ7.z).object({
    name: (0, $jZoZ7.z).string(),
    label: (0, $jZoZ7.z).string(),
    description: (0, $jZoZ7.z).string(),
    status: (0, $1n4ry.DefinitionStatusSchema),
    validations: $37a2c14e625d5fd3$export$479f9e32fa26e841.optional()
});

});


parcelRegister("1UF5x", function(module, exports) {

});

parcelRegister("kMkgL", function(module, exports) {

});

parcelRegister("l64XM", function(module, exports) {

var $jZoZ7 = parcelRequire("jZoZ7");
var $f5be0218d0be9885$export$a7ef77bee88ea45c = (0, $jZoZ7.z).object({
    type: (0, $jZoZ7.z).literal("em")
});
var $f5be0218d0be9885$export$69c9c8c4e7b15ce = (0, $jZoZ7.z).object({
    type: (0, $jZoZ7.z).literal("strong")
});
var $f5be0218d0be9885$export$acaa7c3ae93c3013 = (0, $jZoZ7.z).object({
    type: (0, $jZoZ7.z).literal("underline")
});
var $f5be0218d0be9885$export$cf01888c01767206 = (0, $jZoZ7.z).object({
    href: (0, $jZoZ7.z).string(),
    title: (0, $jZoZ7.z).string().optional(),
    id: (0, $jZoZ7.z).string().optional(),
    collection: (0, $jZoZ7.z).string().optional(),
    occurrenceKey: (0, $jZoZ7.z).string().optional()
});
var $f5be0218d0be9885$export$b2df4bb9ff328852 = (0, $jZoZ7.z).object({
    type: (0, $jZoZ7.z).literal("link"),
    attrs: $f5be0218d0be9885$export$cf01888c01767206
});
var $f5be0218d0be9885$export$9f353554dcd0900c = (0, $jZoZ7.z).union([
    $f5be0218d0be9885$export$a7ef77bee88ea45c,
    $f5be0218d0be9885$export$b2df4bb9ff328852,
    $f5be0218d0be9885$export$69c9c8c4e7b15ce,
    $f5be0218d0be9885$export$acaa7c3ae93c3013
]);
var $f5be0218d0be9885$export$114fe2dd781dee1a = (0, $jZoZ7.z).object({
    type: (0, $jZoZ7.z).literal("text"),
    text: (0, $jZoZ7.z).string(),
    marks: (0, $jZoZ7.z).array($f5be0218d0be9885$export$9f353554dcd0900c).optional()
});
var $f5be0218d0be9885$export$e9f7c03eb6e92c48 = (0, $jZoZ7.z).object({
    type: (0, $jZoZ7.z).literal("hardBreak")
});
var $f5be0218d0be9885$export$2d9b603ae5583675 = (0, $jZoZ7.z).union([
    $f5be0218d0be9885$export$e9f7c03eb6e92c48,
    $f5be0218d0be9885$export$114fe2dd781dee1a
]);
var $f5be0218d0be9885$export$1337b65ca782d815 = (0, $jZoZ7.z).object({
    type: (0, $jZoZ7.z).literal("bulletList"),
    content: (0, $jZoZ7.z).array((0, $jZoZ7.z).lazy(function() {
        return $f5be0218d0be9885$export$765e4b94e2777b27;
    }))
});
var $f5be0218d0be9885$export$f07fad331b1bd4e0 = (0, $jZoZ7.z).object({
    level: (0, $jZoZ7.z).union([
        (0, $jZoZ7.z).literal(1),
        (0, $jZoZ7.z).literal(2),
        (0, $jZoZ7.z).literal(3),
        (0, $jZoZ7.z).literal(4),
        (0, $jZoZ7.z).literal(5),
        (0, $jZoZ7.z).literal(6)
    ])
});
var $f5be0218d0be9885$export$df4e8e19a9112020 = (0, $jZoZ7.z).object({
    type: (0, $jZoZ7.z).literal("heading"),
    attrs: $f5be0218d0be9885$export$f07fad331b1bd4e0,
    content: (0, $jZoZ7.z).array($f5be0218d0be9885$export$2d9b603ae5583675).optional()
});
var $f5be0218d0be9885$export$8e2b808e56e0e324 = (0, $jZoZ7.z).object({
    order: (0, $jZoZ7.z).number().optional()
});
var $f5be0218d0be9885$export$2b674188cdfef4c0 = (0, $jZoZ7.z).object({
    type: (0, $jZoZ7.z).literal("orderedList"),
    content: (0, $jZoZ7.z).array((0, $jZoZ7.z).lazy(function() {
        return $f5be0218d0be9885$export$765e4b94e2777b27;
    })),
    attrs: (0, $jZoZ7.z).optional($f5be0218d0be9885$export$8e2b808e56e0e324)
});
var $f5be0218d0be9885$export$aefd2a7fd72e4466 = (0, $jZoZ7.z).object({
    type: (0, $jZoZ7.z).literal("paragraph"),
    content: (0, $jZoZ7.z).array($f5be0218d0be9885$export$2d9b603ae5583675).optional()
});
var $f5be0218d0be9885$export$765e4b94e2777b27 = (0, $jZoZ7.z).object({
    type: (0, $jZoZ7.z).literal("listItem"),
    content: (0, $jZoZ7.z).array((0, $jZoZ7.z).union([
        $f5be0218d0be9885$export$1337b65ca782d815,
        $f5be0218d0be9885$export$2b674188cdfef4c0,
        $f5be0218d0be9885$export$aefd2a7fd72e4466
    ]))
});
var $f5be0218d0be9885$export$a6e85784fe266d1f = (0, $jZoZ7.z).object({
    type: (0, $jZoZ7.z).literal("rule")
});
var $f5be0218d0be9885$export$418319182702850e = (0, $jZoZ7.z).union([
    $f5be0218d0be9885$export$1337b65ca782d815,
    $f5be0218d0be9885$export$df4e8e19a9112020,
    $f5be0218d0be9885$export$2b674188cdfef4c0,
    $f5be0218d0be9885$export$aefd2a7fd72e4466,
    $f5be0218d0be9885$export$a6e85784fe266d1f
]);
var $f5be0218d0be9885$export$e9de088a85b4f3c5 = (0, $jZoZ7.z).object({
    version: (0, $jZoZ7.z).literal(1),
    type: (0, $jZoZ7.z).literal("doc"),
    content: (0, $jZoZ7.z).array($f5be0218d0be9885$export$418319182702850e)
});

});

parcelRegister("5X9vN", function(module, exports) {

var $jZoZ7 = parcelRequire("jZoZ7");
parcelRequire("cAXOY");
var $kGXRM = parcelRequire("kGXRM");
var $4559d749610c686b$export$745b533888c5cc54 = (0, $jZoZ7.z).object({
    contentType: (0, $kGXRM.ContentTypeSchema),
    description: (0, $jZoZ7.z).string(),
    details: (0, $jZoZ7.z).object({
        image: (0, $jZoZ7.z).object({
            height: (0, $jZoZ7.z).number(),
            width: (0, $jZoZ7.z).number()
        }).optional(),
        size: (0, $jZoZ7.z).number().optional()
    }),
    fileName: (0, $jZoZ7.z).string(),
    title: (0, $jZoZ7.z).string(),
    url: (0, $jZoZ7.z).string()
});

});

parcelRegister("ffAbx", function(module, exports) {

$parcel$export(module.exports, "WebSurfaceDefinitionSchema", function () { return $b1a45352d7396076$export$de247318890c1664; });

var $jZoZ7 = parcelRequire("jZoZ7");
parcelRequire("5IyZO");
var $1n4ry = parcelRequire("1n4ry");
var $kzlGA = parcelRequire("kzlGA");
var $kjOdg = parcelRequire("kjOdg");

var $4M9am = parcelRequire("4M9am");
var $b1a45352d7396076$export$4397fd93c54490d1 = (0, $jZoZ7.z).object({
    label: (0, $jZoZ7.z).string(),
    description: (0, $jZoZ7.z).string(),
    status: (0, $1n4ry.DefinitionStatusSchema),
    channels: (0, $jZoZ7.z).array((0, $kzlGA.ChannelSchema)),
    fieldDefinitions: (0, $jZoZ7.z).array((0, $kjOdg.FieldDefinitionSchema)),
    zonesDefinitions: (0, $jZoZ7.z).array((0, $4M9am.ZoneDefinitionSchema)).optional()
});
var $b1a45352d7396076$export$ce08d3b6ca8cb0ca = (0, $jZoZ7.z).record((0, $jZoZ7.z).string(), $b1a45352d7396076$export$4397fd93c54490d1);
var $b1a45352d7396076$export$de247318890c1664 = (0, $jZoZ7.z).object({
    name: (0, $jZoZ7.z).string(),
    schema: (0, $jZoZ7.z).string(),
    type: (0, $jZoZ7.z).literal("surface"),
    versions: $b1a45352d7396076$export$ce08d3b6ca8cb0ca
});
function $b1a45352d7396076$export$4b02ccd7d821faad(surfaceDefinition) {
    return $b1a45352d7396076$export$4397fd93c54490d1.parse(surfaceDefinition);
}

});

parcelRegister("9nSI5", function(module, exports) {

$parcel$export(module.exports, "createDefinition", function () { return $6d50b34baf3462f1$export$edf7b44ce02b0325; });
parcelRequire("cdW0a");
var $5wFXF = parcelRequire("5wFXF");
var $ffAbx = parcelRequire("ffAbx");
function $6d50b34baf3462f1$export$edf7b44ce02b0325(definition) {
    var type = definition.type;
    switch(type){
        case "module":
            return (0, $5wFXF.WebModuleDefinitionSchema).parse(definition);
        case "surface":
            return (0, $ffAbx.WebSurfaceDefinitionSchema).parse(definition);
    }
}

});

parcelRegister("3rI61", function(module, exports) {

$parcel$export(module.exports, "EnrichmentFieldConfigurationSchema", function () { return $282619467ef5056e$export$c8eca732e0beaaef; });

var $jZoZ7 = parcelRequire("jZoZ7");
parcelRequire("5IyZO");
var $b4p6v = parcelRequire("b4p6v");
var $282619467ef5056e$export$44088c7b80eff57d = (0, $b4p6v.FieldValueSchema).nullable().optional();
var $282619467ef5056e$export$c8eca732e0beaaef = (0, $jZoZ7.z).intersection((0, $jZoZ7.z).object({
    type: (0, $jZoZ7.z).string()
}), (0, $jZoZ7.z).record((0, $jZoZ7.z).string(), $282619467ef5056e$export$44088c7b80eff57d));

});

parcelRegister("9lSQT", function(module, exports) {

$parcel$export(module.exports, "ScheduleSchema", function () { return $6cf09fafe5812601$export$b6f835218a946d20; });
$parcel$export(module.exports, "VariantSchema", function () { return $6cf09fafe5812601$export$90131c15ba55db8c; });

var $jZoZ7 = parcelRequire("jZoZ7");

var $jh3Cr = parcelRequire("jh3Cr");
var $6cf09fafe5812601$export$b6f835218a946d20 = (0, $jZoZ7.z).object({
    startTime: (0, $jZoZ7.z).string().optional(),
    endTime: (0, $jZoZ7.z).string().optional()
});
var $6cf09fafe5812601$export$195c86134a0f323e = (0, $jZoZ7.z).object({
    variant: (0, $jZoZ7.z).union([
        (0, $jZoZ7.z).string(),
        (0, $jZoZ7.z).boolean()
    ]),
    value: (0, $jh3Cr.ModuleConfigurationSchema).optional()
});
var $6cf09fafe5812601$export$2b9d79573cabd64f = "experiment";
var $6cf09fafe5812601$export$30dd02271b27175a = (0, $jZoZ7.z).literal($6cf09fafe5812601$export$2b9d79573cabd64f);
var $6cf09fafe5812601$export$acaacf3d048c9727 = "personalization";
var $6cf09fafe5812601$export$76fc3ddfb7baaec3 = (0, $jZoZ7.z).literal($6cf09fafe5812601$export$acaacf3d048c9727);
var $6cf09fafe5812601$export$a7badb0e58c80f59 = (0, $jZoZ7.z).object({
    id: (0, $jZoZ7.z).string(),
    type: (0, $jZoZ7.z).union([
        (0, $jZoZ7.z).literal("string"),
        (0, $jZoZ7.z).literal("boolean")
    ])
});
var $6cf09fafe5812601$export$d4a965ddb836189a = (0, $jZoZ7.z).object({
    type: $6cf09fafe5812601$export$30dd02271b27175a,
    target: $6cf09fafe5812601$export$a7badb0e58c80f59,
    label: (0, $jZoZ7.z).string(),
    schedule: $6cf09fafe5812601$export$b6f835218a946d20.optional(),
    cases: (0, $jZoZ7.z).array($6cf09fafe5812601$export$195c86134a0f323e)
});
var $6cf09fafe5812601$export$9e5696267cc5898a = (0, $jZoZ7.z).object({
    id: (0, $jZoZ7.z).string(),
    entityType: (0, $jZoZ7.z).union([
        (0, $jZoZ7.z).literal("AJS_ANONYMOUS_USER"),
        (0, $jZoZ7.z).literal("ATLASSIAN_ACCOUNT"),
        (0, $jZoZ7.z).literal("EMAIL_UUID"),
        (0, $jZoZ7.z).literal("ORG"),
        (0, $jZoZ7.z).literal("SITE"),
        (0, $jZoZ7.z).literal("SITE_USER"),
        (0, $jZoZ7.z).literal("TRELLO_USER"),
        (0, $jZoZ7.z).literal("CUSTOMER_DOMAIN")
    ]),
    type: (0, $jZoZ7.z).union([
        (0, $jZoZ7.z).literal("string"),
        (0, $jZoZ7.z).literal("boolean")
    ])
});
var $6cf09fafe5812601$export$30bf6225399168a2 = (0, $jZoZ7.z).object({
    type: $6cf09fafe5812601$export$76fc3ddfb7baaec3,
    target: $6cf09fafe5812601$export$9e5696267cc5898a,
    label: (0, $jZoZ7.z).string(),
    schedule: $6cf09fafe5812601$export$b6f835218a946d20.optional(),
    cases: (0, $jZoZ7.z).array($6cf09fafe5812601$export$195c86134a0f323e)
});
var $6cf09fafe5812601$export$90131c15ba55db8c = (0, $jZoZ7.z).union([
    $6cf09fafe5812601$export$d4a965ddb836189a,
    $6cf09fafe5812601$export$30bf6225399168a2
]);

});
parcelRegister("jh3Cr", function(module, exports) {

$parcel$export(module.exports, "ModuleConfigurationSchema", function () { return $e082697d58a851bd$export$885871fdd1cdd7bd; });

var $jZoZ7 = parcelRequire("jZoZ7");
parcelRequire("5IyZO");
var $kzlGA = parcelRequire("kzlGA");
var $7wcDg = parcelRequire("7wcDg");
var $1n4ry = parcelRequire("1n4ry");
var $b4p6v = parcelRequire("b4p6v");

var $3rI61 = parcelRequire("3rI61");

var $9lSQT = parcelRequire("9lSQT");
var $e082697d58a851bd$export$460a5601111012d6 = (0, $jZoZ7.z).lazy(function() {
    return (0, $jZoZ7.z).object({
        key: (0, $jZoZ7.z).string(),
        label: (0, $jZoZ7.z).string(),
        default: $e082697d58a851bd$export$885871fdd1cdd7bd.optional(),
        schedule: (0, $9lSQT.ScheduleSchema).optional(),
        selections: (0, $jZoZ7.z).array((0, $9lSQT.VariantSchema))
    });
});
var $e082697d58a851bd$export$b2d3189b531d19 = (0, $jZoZ7.z).array($e082697d58a851bd$export$460a5601111012d6);
var $e082697d58a851bd$export$885871fdd1cdd7bd = (0, $jZoZ7.z).object({
    type: (0, $jZoZ7.z).string(),
    key: (0, $jZoZ7.z).string(),
    locale: (0, $jZoZ7.z).string(),
    label: (0, $jZoZ7.z).string(),
    description: (0, $jZoZ7.z).string().optional(),
    channel: (0, $kzlGA.ChannelSchema),
    definitionVersion: (0, $7wcDg.VersionStringSchema),
    revision: (0, $jZoZ7.z).number(),
    status: (0, $1n4ry.ConfigurationStatusSchema),
    fields: (0, $jZoZ7.z).record((0, $jZoZ7.z).string(), (0, $b4p6v.FieldValueSchema)),
    enrichmentFields: (0, $jZoZ7.z).record((0, $jZoZ7.z).string(), (0, $3rI61.EnrichmentFieldConfigurationSchema)).optional(),
    zones: (0, $jZoZ7.z).record((0, $jZoZ7.z).string(), $e082697d58a851bd$export$b2d3189b531d19).optional()
});
var $e082697d58a851bd$export$dee86696e64a1934 = $e082697d58a851bd$export$885871fdd1cdd7bd;
function $e082697d58a851bd$export$b55c732ace41b07(surfaceConfiguration) {
    return $e082697d58a851bd$export$dee86696e64a1934.parse(surfaceConfiguration);
}

});






parcelRegister("gMq3p", function(module, exports) {
parcelRequire("cdW0a");
var $9nSI5 = parcelRequire("9nSI5");

var $iEnWS = parcelRequire("iEnWS");
var $c37556d30f045b63$export$2e2bcd8739ae039 = (0, $9nSI5.createDefinition)({
    name: "adminTrialCart",
    schema: "0.1.0",
    type: "module",
    versions: {
        0: (0, $iEnWS.versionDefinitionV0)
    }
});

});


parcelRegister("220RR", function(module, exports) {
$parcel$export(module.exports, "DropdownLayout", function () { return (parcelRequire("iAbbD")).DropdownLayout; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("iAbbD")).DropdownLayout; });

var $iAbbD = parcelRequire("iAbbD");

});
parcelRegister("iAbbD", function(module, exports) {

$parcel$export(module.exports, "DropdownLayout", function () { return $87dce1735c5c359b$export$de70934dc6f8e21e; });
/* dropdown-layout.tsx generated by @compiled/babel-plugin v0.28.2 */ /* eslint-disable complexity */ 
var $1rY3h = parcelRequire("1rY3h");
parcelRequire("1Mpn7");

var $2vwrh = parcelRequire("2vwrh");
var $87dce1735c5c359b$var$containerDiv = null;
var $87dce1735c5c359b$var$flexDiv = null;
var $87dce1735c5c359b$var$leftContent = null;
var $87dce1735c5c359b$var$rightContent = null;
var $87dce1735c5c359b$var$rightContainer = null;
var $87dce1735c5c359b$var$leftContainer = null;
var $87dce1735c5c359b$export$de70934dc6f8e21e = function(param) {
    var main = param.main, sidebar = param.sidebar;
    return /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
        className: (0, $2vwrh.default)([
            "_p12f1fra _19pkidpf _2hwx1wug _otyridpf _18u01wug"
        ]),
        children: /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
            className: (0, $2vwrh.default)([
                "_1e0c1txw _na0i1bp4"
            ]),
            children: [
                /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                    className: (0, $2vwrh.default)([
                        "_bfhku67f _kqswh2mm _26vx1bcc _40tu53f4 _glte12it _10jx8stt _d2ik1bcc _ne9pb3bt _14u1stnw _pfu31gqn _1jqu16s2 _mszq1osq _1a62u67f _xc2ixjmg"
                    ]),
                    children: /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                        className: (0, $2vwrh.default)([
                            "_kqswh2mm"
                        ]),
                        children: main
                    })
                }),
                /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                    className: (0, $2vwrh.default)([
                        "_bfhk1hxd _1ul91mjv _16jlkb7n _1o9zkb7n _i0dl1wug _85i553f4 _kqswh2mm _26vx1bcc _1yag1kv0 _ne9pb3bt _14u1stnw _pfu3irm9 _1jqu8stt _mszq1osq _1a621hxd _tnv2u67f _196g1ehm _xc2ixjmg"
                    ]),
                    children: /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                        className: (0, $2vwrh.default)([
                            "_kqswh2mm"
                        ]),
                        children: sidebar
                    })
                })
            ]
        })
    });
};

});


parcelRegister("2pMYh", function(module, exports) {
$parcel$export(module.exports, "Search", function () { return (parcelRequire("7psCn")).Search; });

var $7psCn = parcelRequire("7psCn");

});
parcelRegister("7psCn", function(module, exports) {

$parcel$export(module.exports, "Search", function () { return $ab134f2dbb9bfc11$export$4b85d3515bd863a5; });
/* search.tsx generated by @compiled/babel-plugin v0.28.2 */ 
var $cv9Rk = parcelRequire("cv9Rk");

var $1rY3h = parcelRequire("1rY3h");

var $2vwrh = parcelRequire("2vwrh");

var $1Mpn7 = parcelRequire("1Mpn7");

var $8pPrt = parcelRequire("8pPrt");

var $9Qy4e = parcelRequire("9Qy4e");

var $2Pnqs = parcelRequire("2Pnqs");
parcelRequire("9DBuW");
var $bLsIZ = parcelRequire("bLsIZ");
parcelRequire("8Pfzs");
var $dPT2D = parcelRequire("dPT2D");
var $ab134f2dbb9bfc11$var$displayNone = null;
var $ab134f2dbb9bfc11$var$searchIconStyle = null;
var $ab134f2dbb9bfc11$var$searchMainContainerStyle = null;
var $ab134f2dbb9bfc11$var$searchContainerStyle = null;
var $ab134f2dbb9bfc11$var$searchInputContainerStyle = null;
var $ab134f2dbb9bfc11$var$searchFormStyle = null;
var $ab134f2dbb9bfc11$var$closePanelIconContainerStyle = null;
var $ab134f2dbb9bfc11$var$searchIconButtonStyle = null;
var $ab134f2dbb9bfc11$var$pageBlurCss = null;
var $ab134f2dbb9bfc11$export$4b85d3515bd863a5 = function(param) {
    var searchLabel = param.searchLabel, className = param.className, placeholder = param.placeholder, searchUrl = param.searchUrl, testId = param.testId, _param_isOpen = param.isOpen, isOpen = _param_isOpen === void 0 ? false : _param_isOpen, openSearch = param.openSearch, closeSearch = param.closeSearch;
    var _useState = (0, $cv9Rk._)((0, $1Mpn7.useState)(""), 2), searchText = _useState[0], setSearchText = _useState[1];
    var inputRef = (0, $1Mpn7.useRef)(null);
    var focusOnInput = function() {
        if (inputRef.current) inputRef.current.focus();
    };
    (0, $1Mpn7.useEffect)(function() {
        (0, $2Pnqs.Initializer).autoTrack();
        if (isOpen) focusOnInput();
    }, [
        isOpen
    ]);
    var intl = (0, $8pPrt.default)();
    var translated = {
        searchLabel: intl.formatMessage({
            id: "globalNav.search.label",
            defaultMessage: "Search"
        }),
        submitSearch: intl.formatMessage({
            id: "globalNav.search.submit",
            defaultMessage: "Submit"
        }),
        closeSearch: intl.formatMessage({
            id: "globalNav.search.close",
            defaultMessage: "Close"
        })
    };
    return /*#__PURE__*/ (0, $1rY3h.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsx)("button", {
                onClick: function(event) {
                    event.preventDefault();
                    focusOnInput();
                    openSearch();
                },
                id: "global-nav-search-icon",
                "aria-label": translated.searchLabel,
                "data-testid": testId || "global-nav-search-icon",
                "data-event": "clicked",
                "data-event-component": "linkButton",
                "data-event-container": "globalNavWac",
                "data-product-key": "jiraSoftware",
                className: (0, $2vwrh.default)([
                    "_bfhk1j28 _19itidpf _80omtlke _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _syaz14rb _ql0oj1oc _1nj114rb _11vn1ssb _17521wug _i2i314y2 _uhas14y2 _5jw914y2 _7wy914y2 _w8l5zwfg _rulp12am",
                    isOpen && "_sugaglyw"
                ]),
                children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9Qy4e))), {
                    label: translated.searchLabel
                })
            }),
            isOpen && /*#__PURE__*/ (0, $1rY3h.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                        className: (0, $2vwrh.default)([
                            "_152t1osq _1e021sck _bfhk1hxd _vwz4l6l0 _kqswstnw _1bsb1osq _1pbyibnn _179r1ugy",
                            className
                        ]),
                        id: "global-nav-wac-search",
                        "data-testid": "search-container",
                        children: /*#__PURE__*/ (0, $1rY3h.jsx)("form", {
                            action: searchUrl || "/search",
                            method: "GET",
                            id: "global-nav-wac-search-form",
                            "data-testid": "search-form",
                            className: (0, $2vwrh.default)([
                                "_vwz4l6l0 _p12f1fra _19pkidpf _2hwx1wug _otyridpf _18u01wug _ca0q14y2 _u5f3gktf _n3td1tcg _19bvgktf _kqswh2mm _oeuvidpf _1q9p1nn1 _1sgroxwj _1wv4h461 _15pj1ule _6ssjzky3 _gu181h6o"
                            ]),
                            children: /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
                                id: "global-nav-wac-search-container",
                                className: (0, $2vwrh.default)([
                                    "_1q51oxav _y3gn1h6o _18s81tav _xc2iidpf _1s4p1osq"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                                        id: "global-nav-wac-search-input-container",
                                        className: (0, $2vwrh.default)([
                                            "_1e0c1o8l _12l21eps _y3gn1e5h _1bsb1te3 _1s4p1oqc _1dksglyw"
                                        ]),
                                        children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $dPT2D.TextInput), {
                                            ref: inputRef,
                                            className: "fullWidth",
                                            label: searchLabel || "".concat(translated.searchLabel, " atlassian.com"),
                                            name: "q",
                                            id: "global-nav-search-input",
                                            value: searchText,
                                            placeholder: placeholder || translated.searchLabel,
                                            onChangeHandler: setSearchText,
                                            "data-testid": "search-input",
                                            "aria-label": "Search Input"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $1rY3h.jsx)("button", {
                                        type: "submit",
                                        id: "global-nav-search-submit",
                                        form: "global-nav-wac-search-form",
                                        "data-testid": "search-submit",
                                        "aria-label": translated.submitSearch,
                                        "data-event": "clicked",
                                        "data-event-component": "linkButton",
                                        "data-event-container": "globalNav",
                                        className: (0, $2vwrh.default)([
                                            "_bfhkrbzz _1lrwxjmg _19it36id _2rkoh461 _80omtlke _4t3ihiv4 _s7n4yfq0 _syazu67f _p12fgosd _1yt4mhsw _6rth1oug _1nj1u67f _10531hxd _1di6u7gi _irr3u7gi _n7dw181d _bfw7181d"
                                        ]),
                                        children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9Qy4e))), {
                                            label: translated.submitSearch
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $1rY3h.jsx)("button", {
                                        id: "global-nav-search-close",
                                        onClick: function(event) {
                                            event.preventDefault();
                                            return closeSearch();
                                        },
                                        "data-testid": "search-close",
                                        "aria-label": translated.closeSearch,
                                        "data-event": "clicked",
                                        "data-event-component": "linkButton",
                                        "data-event-container": "globalNav",
                                        className: (0, $2vwrh.default)([
                                            "_bfhk1j28 _19itidpf _80omtlke _1e0c1txw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _4t3ixjmg _kqswstnw _rjxp1bcc _1bsbxjmg _152txjmg _tnv21l0i _1kne1kxc _nqopidpf _16mq1osq _1s4p1osq _1i5aglyw"
                                        ]),
                                        children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $bLsIZ.Cross), {
                                            size: "16"
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("button", {
                        "aria-label": translated.closeSearch,
                        onClick: function() {
                            return closeSearch();
                        },
                        "data-event": "clicked",
                        "data-event-component": "linkButton",
                        "data-event-container": "globalNav",
                        className: (0, $2vwrh.default)([
                            "_bfhk1l0i _19itidpf _1e0c1ule _4t3i1kxc _1e02idpf _kqswstnw _152t1osq _1bsb1osq _1pbykb7n"
                        ])
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("9Qy4e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $72b36571437b49a7$var$_react = $72b36571437b49a7$var$_interopRequireDefault((parcelRequire("1Mpn7")));

var $cotNw = parcelRequire("cotNw");
function $72b36571437b49a7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $72b36571437b49a7$var$SearchIcon = function(props) {
    return /*#__PURE__*/ $72b36571437b49a7$var$_react.default.createElement($cotNw.Icon, Object.assign({
        dangerouslySetGlyph: '<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M16.436 15.085l3.94 4.01a1 1 0 01-1.425 1.402l-3.938-4.006a7.5 7.5 0 111.423-1.406zM10.5 16a5.5 5.5 0 100-11 5.5 5.5 0 000 11z" fill="currentColor" fill-rule="evenodd"/></svg>'
    }, props));
};
$72b36571437b49a7$var$SearchIcon.displayName = "SearchIcon";
var $72b36571437b49a7$var$_default = $72b36571437b49a7$var$SearchIcon;
module.exports.default = $72b36571437b49a7$var$_default;

});

parcelRegister("8Pfzs", function(module, exports) {
$parcel$export(module.exports, "TextInput", function () { return (parcelRequire("dPT2D")).TextInput; });

var $dPT2D = parcelRequire("dPT2D");

});
parcelRegister("dPT2D", function(module, exports) {

$parcel$export(module.exports, "TextInput", function () { return $ecd468eda899438c$export$c86715117507e8e5; });
/* text-input.tsx generated by @compiled/babel-plugin v0.28.2 */ 
var $cv9Rk = parcelRequire("cv9Rk");

var $1rY3h = parcelRequire("1rY3h");

var $2vwrh = parcelRequire("2vwrh");

var $1Mpn7 = parcelRequire("1Mpn7");
var $ecd468eda899438c$var$containerStyles = null;
var $ecd468eda899438c$var$labelStyles = null;
var $ecd468eda899438c$var$inputContainerStyles = null;
var $ecd468eda899438c$var$inputStyles = null;
var $ecd468eda899438c$var$errorStyles = null;
var $ecd468eda899438c$var$iconStyles = null;
var $ecd468eda899438c$export$c86715117507e8e5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).forwardRef(function(props, ref) {
    var name = props.name, value = props.value, id = props.id, testId = props.testId, label = props.label, placeholder = props.placeholder, disabled = props.disabled, validation = props.validation, Icon = props.Icon, onChangeHandler = props.onChangeHandler, className = props.className, autocomplete = props.autocomplete;
    var _useState = (0, $cv9Rk._)((0, $1Mpn7.useState)(""), 2), text = _useState[0], setText = _useState[1];
    var _useState1 = (0, $cv9Rk._)((0, $1Mpn7.useState)(true), 2), isValid = _useState1[0], setValid = _useState1[1];
    var _useState2 = (0, $cv9Rk._)((0, $1Mpn7.useState)(""), 2), error = _useState2[0], setError = _useState2[1];
    (0, $1Mpn7.useEffect)(function() {
        if (text && validation) {
            var _validation = validation(text), valid = _validation[0], error = _validation[1];
            if (valid) setError("");
            else setError(error);
            setValid(valid);
        }
        if (!text) setError("");
    }, [
        text
    ]);
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
        className: (0, $2vwrh.default)([
            "_1e0c1txw _2lx21bp4 _kqswh2mm _1cxkb0wy _gl1i1du8",
            className
        ]),
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsx)("label", {
                htmlFor: name,
                className: (0, $2vwrh.default)([
                    "_syaz1bqd _1wyboqnp _vwz41gnr _6rthh461 _y3gn1e5h"
                ]),
                children: label
            }),
            /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
                className: (0, $2vwrh.default)([
                    "_kqswh2mm",
                    "input-container"
                ]),
                children: [
                    /*#__PURE__*/ (0, $1rY3h.jsx)("input", {
                        className: (0, $2vwrh.default)([
                            "_vchhusvi _bfhki0pe _189eyh40 _1dqonqa1 _1h6d3739 _2rko1y44 _1o9zidpf _4t3i1jvk _bozgftgi _1bsb1osq _1wyb1j6v _vwz4cjiy _y3gn1e5h _syaz1mpp _1idrq25q _4cvx3739 _irr34m1f _27uw3739 _cun91hxd _vbqbq25q _nt751j28 _49pcnqa1 _1hvwt94y",
                            isValid ? "valid-inp" : "invalid-inp"
                        ]),
                        onChange: function(e) {
                            setText(e.target.value);
                            onChangeHandler && onChangeHandler(e.target.value);
                        },
                        type: "text",
                        ref: ref,
                        name: name,
                        id: id,
                        "data-testid": testId ? testId : id,
                        value: value,
                        placeholder: placeholder,
                        disabled: disabled || false,
                        "aria-invalid": !!error,
                        "aria-errormessage": !!error ? "err".concat(id) : "",
                        autoComplete: autocomplete
                    }),
                    Icon && /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                        className: (0, $2vwrh.default)([
                            "_kqswstnw _19pk1wug _2hwx1wug _otyr1wug _18u01wug _152tidpf _u7coidpf _rjxp19bv _1bsb1tcg _4t3i1tcg _lcxvglyw"
                        ]),
                        children: /*#__PURE__*/ (0, $1rY3h.jsx)(Icon, {})
                    })
                ]
            }),
            !!error && /*#__PURE__*/ (0, $1rY3h.jsx)("label", {
                id: "err".concat(id),
                className: (0, $2vwrh.default)([
                    "_syaz1du8 _1wyboqnp _zg8l4jg8 _k48p1nn1 _vwz4cjiy _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1pfh1y44"
                ]),
                children: error
            })
        ]
    });
});
$ecd468eda899438c$export$c86715117507e8e5.displayName = "TextInput";

});




parcelRegister("izRo7", function(module, exports) {
$parcel$export(module.exports, "GlobalNavUserProfile", function () { return (parcelRequire("4zflm")).GlobalNavUserProfile; });
parcelRequire("4zflm");

});
parcelRegister("4zflm", function(module, exports) {

$parcel$export(module.exports, "GlobalNavUserProfile", function () { return $85df1c6114ec3f5f$export$119e15e0a961cff6; });

var $cv9Rk = parcelRequire("cv9Rk");

var $1rY3h = parcelRequire("1rY3h");

var $1Mpn7 = parcelRequire("1Mpn7");

var $145N3 = parcelRequire("145N3");

var $af5n8 = parcelRequire("af5n8");

var $l4pIl = parcelRequire("l4pIl");

var $X4lBG = parcelRequire("X4lBG");

var $4AnAe = parcelRequire("4AnAe");
var $85df1c6114ec3f5f$var$analyticsLabels = {
    "JoinSiteUserDropdown.logOut": "Log out",
    "JoinSiteUserDropdown.logIn": "Sign in",
    "JoinSiteUserDropdown.joinTeam": "Find my team",
    "JoinSiteUserDropdown.profile": "Profile",
    "JoinSiteUserDropdown.switchAccount": "Switch Account",
    "JoinSiteUserDropdown.licenses": "Licenses"
};
var $85df1c6114ec3f5f$var$NEXT_PUBLIC_API_MAC_URL = "https://my.atlassian.com";
var $85df1c6114ec3f5f$var$NEXT_PUBLIC_IDENTITY_BASE_URL = "https://id.atlassian.com";
var $85df1c6114ec3f5f$var$NEXT_PUBLIC_API_PRIVATE_BASE_URL = "https://www.atlassian.com/gateway/api";
var $85df1c6114ec3f5f$export$119e15e0a961cff6 = function() {
    var userInfo = (0, $af5n8.useLoggedInUser)();
    var createAnalyticsEvent = (0, $145N3.useAnalyticsEvents)().createAnalyticsEvent;
    var _useState = (0, $cv9Rk._)((0, $1Mpn7.useState)(userInfo.requestInProgress), 2), isLoading = _useState[0], setIsLoading = _useState[1];
    (0, $1Mpn7.useEffect)(function() {
        setIsLoading(userInfo.requestInProgress);
    }, [
        userInfo.requestInProgress
    ]);
    var onManageLicensesClick = function() {
        createAnalyticsEvent({
            action: "clicked",
            name: "bxp.globalnavdropdown.click.manage.licenses",
            label: $85df1c6114ec3f5f$var$analyticsLabels["JoinSiteUserDropdown.licenses"]
        }).fire();
        window.location.assign($85df1c6114ec3f5f$var$NEXT_PUBLIC_API_MAC_URL);
    };
    var getManageProfileUrl = function(userEmail) {
        var applicationParam = encodeURIComponent("wac");
        var continueUrlParam = encodeURIComponent("".concat($85df1c6114ec3f5f$var$NEXT_PUBLIC_IDENTITY_BASE_URL, "/manage-profile"));
        var loginHintParam = encodeURIComponent(userEmail);
        return "".concat($85df1c6114ec3f5f$var$NEXT_PUBLIC_IDENTITY_BASE_URL, "/login?application=").concat(applicationParam, "&continue=").concat(continueUrlParam, "&login_hint=").concat(loginHintParam);
    };
    var onManageProfileClick = function() {
        createAnalyticsEvent({
            action: "clicked",
            name: "bxp.globalnavdropdown.click.manage.profile",
            label: $85df1c6114ec3f5f$var$analyticsLabels["JoinSiteUserDropdown.profile"]
        }).fire();
        window.location.assign(getManageProfileUrl(userInfo.email || ""));
    };
    var getLogoutUrl = function() {
        var continueUrl = window.location.href;
        return "".concat($85df1c6114ec3f5f$var$NEXT_PUBLIC_IDENTITY_BASE_URL, "/logout?continue=").concat(encodeURIComponent(continueUrl));
    };
    var onLogOutClick = function() {
        createAnalyticsEvent({
            action: "clicked",
            name: "bxp.globalnavdropdown.click.logout",
            label: $85df1c6114ec3f5f$var$analyticsLabels["JoinSiteUserDropdown.logOut"]
        }).fire();
        window.location.assign(getLogoutUrl());
    };
    var onLogInClick = function() {
        var baseUrl = $85df1c6114ec3f5f$var$NEXT_PUBLIC_IDENTITY_BASE_URL;
        var stargateBaseUrl = $85df1c6114ec3f5f$var$NEXT_PUBLIC_API_PRIVATE_BASE_URL;
        var continueUrl = stargateBaseUrl + "/start/authredirect";
        createAnalyticsEvent({
            action: "clicked",
            name: "bxp.globalnavdropdown.click.login",
            label: $85df1c6114ec3f5f$var$analyticsLabels["JoinSiteUserDropdown.logIn"]
        }).fire();
        window.location.assign("".concat(baseUrl, "/login?continue=").concat(encodeURIComponent(continueUrl)));
    };
    var getSwitchAccountURL = function(continueUrlParam) {
        var continueUrl = continueUrlParam ? continueUrlParam : window.location.href;
        return "".concat($85df1c6114ec3f5f$var$NEXT_PUBLIC_IDENTITY_BASE_URL, "/login/select-account?continue=").concat(encodeURIComponent(continueUrl));
    };
    var onSwitchAccountClick = function() {
        createAnalyticsEvent({
            action: "clicked",
            name: "bxp.globalnavdropdown.click.switchAccount",
            label: $85df1c6114ec3f5f$var$analyticsLabels["JoinSiteUserDropdown.switchAccount"]
        }).fire();
        window.location.assign(getSwitchAccountURL());
    };
    if (isLoading) return 0, $4AnAe.LoadingSpinner;
    return /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
        children: userInfo.isUserLoggedIn ? /*#__PURE__*/ (0, $1rY3h.jsx)((0, $l4pIl.LoggedInUser), {
            userInfo: {
                displayName: userInfo.name || "",
                email: userInfo.email || "",
                avatar: userInfo.picture || ""
            },
            onSwitchAccountClick: onSwitchAccountClick,
            onManageProfileClick: onManageProfileClick,
            onManageLicensesClick: onManageLicensesClick,
            onLogOutClick: onLogOutClick
        }) : /*#__PURE__*/ (0, $1rY3h.jsx)((0, $X4lBG.LoggedOutUser), {
            onLogInClick: onLogInClick
        })
    });
};

});
parcelRegister("l4pIl", function(module, exports) {

$parcel$export(module.exports, "LoggedInUser", function () { return $a70115a82bb9036a$export$5effdf6804a02eac; });
/* loggedin-user-view.tsx generated by @compiled/babel-plugin v0.28.2 */ // @ts-ignore

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $dRLPW = parcelRequire("dRLPW");

var $1rY3h = parcelRequire("1rY3h");

var $2vwrh = parcelRequire("2vwrh");

var $1Mpn7 = parcelRequire("1Mpn7");

var $dFwuF = parcelRequire("dFwuF");

var $7Xcnn = parcelRequire("7Xcnn");

var $4JIdr = parcelRequire("4JIdr");

var $hH5Se = parcelRequire("hH5Se");

var $4AnAe = parcelRequire("4AnAe");

var $juD8y = parcelRequire("juD8y");

var $a70115a82bb9036a$var$DropdownMenu = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).lazy(function() {
    return(// @ts-ignore
    (parcelRequire("lKVDr")).then(function(param) {
        var DropdownMenu = param.DropdownMenu;
        return {
            default: DropdownMenu
        };
    }));
});

var $a70115a82bb9036a$var$DropdownItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).lazy(function() {
    return (parcelRequire("8mDCT")).then(function(param) {
        var DropdownItem = param.DropdownItem;
        return {
            default: DropdownItem
        };
    });
});

var $a70115a82bb9036a$var$DropdownItemGroup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).lazy(function() {
    return (parcelRequire("8mDCT")).then(function(param) {
        var DropdownItemGroup = param.DropdownItemGroup;
        return {
            default: DropdownItemGroup
        };
    });
});
var $a70115a82bb9036a$export$5effdf6804a02eac = function(param) {
    var userInfo = param.userInfo, onLogOutClick = param.onLogOutClick, onManageLicensesClick = param.onManageLicensesClick, onManageProfileClick = param.onManageProfileClick, onSwitchAccountClick = param.onSwitchAccountClick;
    return /*#__PURE__*/ (0, $1rY3h.jsx)((0, $1Mpn7.Suspense), {
        fallback: (0, $4AnAe.LoadingSpinner),
        children: /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
            "data-testid": "main-container",
            className: (0, $2vwrh.default)([
                "_ect4q6fz _1y2ztxnc _1h7htxnc _16l4txnc"
            ]),
            children: /*#__PURE__*/ (0, $1rY3h.jsx)($a70115a82bb9036a$var$DropdownMenu, {
                spacing: "compact",
                placement: "bottom-end",
                // @ts-ignore
                trigger: function(_param) /*#__PURE__*/ {
                    var triggerRef = _param.triggerRef, props = (0, $dRLPW._)(_param, [
                        "triggerRef"
                    ]);
                    return (0, $1rY3h.jsx)((0, $7Xcnn.default), (0, $cxjpp._)((0, $do9pw._)({
                        className: (0, $2vwrh.default)([
                            "_1yt41sck _1bsb1bcc _4t3i1bcc _2rko1ssb",
                            "avatar-button"
                        ])
                    }, props), {
                        iconBefore: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $hH5Se.WACAvatar), {
                            name: userInfo.displayName,
                            src: userInfo.avatar,
                            size: "small",
                            showTooltip: true
                        }),
                        ref: triggerRef
                    }));
                },
                children: /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                    "data-testid": "global-nav-user-profile-container-user-loggedin",
                    className: (0, $2vwrh.default)([
                        "_ect4q6fz _1bsbr0r7 _vwz4oxav _18e6b3bt _1umo1sck _1rzf1wug _3n48q6fz _by5noxav"
                    ]),
                    children: /*#__PURE__*/ (0, $1rY3h.jsxs)($a70115a82bb9036a$var$DropdownItemGroup, {
                        children: [
                            /*#__PURE__*/ (0, $1rY3h.jsx)($a70115a82bb9036a$var$DropdownItem, {
                                isDisabled: true,
                                children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $juD8y.UserDetailsCard), {
                                    name: userInfo.displayName,
                                    src: userInfo.avatar,
                                    email: userInfo.email,
                                    size: "small"
                                })
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)($a70115a82bb9036a$var$DropdownItem, {
                                onClick: onSwitchAccountClick,
                                children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $dFwuF.default), (0, $do9pw._)({}, (0, $4JIdr.messages).switchAccount))
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)($a70115a82bb9036a$var$DropdownItem, {
                                onClick: onManageProfileClick,
                                children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $dFwuF.default), (0, $do9pw._)({}, (0, $4JIdr.messages).profile))
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)($a70115a82bb9036a$var$DropdownItem, {
                                onClick: onManageLicensesClick,
                                children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $dFwuF.default), (0, $do9pw._)({}, (0, $4JIdr.messages).licenses))
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)($a70115a82bb9036a$var$DropdownItem, {
                                onClick: onLogOutClick,
                                children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $dFwuF.default), (0, $do9pw._)({}, (0, $4JIdr.messages).logOut))
                            })
                        ]
                    })
                })
            })
        })
    });
};
var $a70115a82bb9036a$var$mainContainer = null;
var $a70115a82bb9036a$var$loggedInUserContainer = null;
var $a70115a82bb9036a$var$overrideAvatarButtonStyle = null;

});
parcelRegister("4JIdr", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $75670d5bd6739552$export$defe85febe8b728c; });

var $6gDD1 = parcelRequire("6gDD1");
var $75670d5bd6739552$export$defe85febe8b728c = (0, $6gDD1.defineMessages)({
    logIn: {
        id: "JoinSiteUserDropdown.logIn",
        defaultMessage: "Sign in"
    },
    joinTeam: {
        id: "JoinSiteUserDropdown.joinTeam",
        defaultMessage: "Find my team"
    },
    profile: {
        id: "JoinSiteUserDropdown.profile",
        defaultMessage: "Profile"
    },
    licenses: {
        id: "JoinSiteUserDropdown.licenses",
        defaultMessage: "Licenses"
    },
    logOut: {
        id: "JoinSiteUserDropdown.logOut",
        defaultMessage: "Log out"
    },
    logOutTriggerText: {
        id: "JoinSiteUserDropdown.logOutTriggerText",
        defaultMessage: "My account"
    },
    switchAccount: {
        id: "JoinSiteUserDropdown.switchAccount",
        defaultMessage: "Switch Account"
    }
});

});

parcelRegister("hH5Se", function(module, exports) {

$parcel$export(module.exports, "WACAvatar", function () { return $051470dbabffe1ff$export$c4e152e3661f6058; });

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $1rY3h = parcelRequire("1rY3h");

var $dawho = parcelRequire("dawho");

var $axDQK = parcelRequire("axDQK");
var $051470dbabffe1ff$export$c4e152e3661f6058 = function(props) {
    return props.showTooltip ? /*#__PURE__*/ (0, $1rY3h.jsx)((0, $axDQK.default), {
        content: props.name,
        children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $dawho.default), (0, $cxjpp._)((0, $do9pw._)({}, props), {
            appearance: "circle"
        }))
    }) : /*#__PURE__*/ (0, $1rY3h.jsx)((0, $dawho.default), (0, $cxjpp._)((0, $do9pw._)({}, props), {
        appearance: "circle"
    }));
};

});
parcelRegister("dawho", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $99653f9881894c89$export$2e2bcd8739ae039; });

var $jjExS = parcelRequire("jjExS");

var $1UIph = parcelRequire("1UIph");

var $1Mpn7 = parcelRequire("1Mpn7");

var $fBy54 = parcelRequire("fBy54");

var $145N3 = parcelRequire("145N3");

var $aUwNi = parcelRequire("aUwNi");

var $kVHEk = parcelRequire("kVHEk");

var $jsG43 = parcelRequire("jsG43");

var $g7vQ0 = parcelRequire("g7vQ0");

var $bQiXQ = parcelRequire("bQiXQ");

var $c15dP = parcelRequire("c15dP");
var $99653f9881894c89$var$_templateObject;
function $99653f9881894c89$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $99653f9881894c89$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $99653f9881894c89$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $99653f9881894c89$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $99653f9881894c89$var$packageName = "@atlaskit/avatar";
var $99653f9881894c89$var$packageVersion = "21.4.0";
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $99653f9881894c89$var$getStyles = function getStyles(css, _ref) {
    var size = _ref.size, radius = _ref.radius, appearance = _ref.appearance, _ref$borderColor = _ref.borderColor, borderColor = _ref$borderColor === void 0 ? "var(--ds-surface-overlay, ".concat((0, $aUwNi.N0), ")") : _ref$borderColor, stackIndex = _ref.stackIndex, isInteractive = _ref.isInteractive, isDisabled = _ref.isDisabled;
    return css($99653f9881894c89$var$_templateObject || ($99653f9881894c89$var$_templateObject = (0, (/*@__PURE__*/$parcel$interopDefault($1UIph)))([
        "\n    height: ",
        "px;\n    width: ",
        "px;\n    align-items: stretch;\n    background-color: ",
        ";\n    border-radius: ",
        ";\n    box-sizing: content-box;\n    cursor: inherit;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    outline: none;\n    overflow: hidden;\n    position: static;\n    transform: translateZ(0);\n    transition: transform 200ms, opacity 200ms;\n    box-shadow: 0 0 0 ",
        "px ",
        ";\n    border: none;\n    margin: ",
        ";\n    padding: ",
        ";\n\n    /* Added font-size and font-family styles to fix alignment issue in firefox for interactive button avatar */\n    font-size: inherit;\n    font-family: inherit;\n\n    &::-moz-focus-inner {\n      border: 0;\n      margin: ",
        ";\n      padding: ",
        ";\n    }\n\n    &::after {\n      background-color: transparent;\n      inset: 0px;\n\n      /* Added border-radius style to fix hover issue in safari */\n      border-radius: ",
        ";\n      content: ' ';\n      opacity: 0;\n      pointer-events: none;\n      position: absolute;\n      transition: opacity 200ms;\n      width: 100%;\n    }\n\n    ",
        "\n\n    ",
        "\n\n    ",
        "\n  "
    ])), size, size, borderColor, appearance === "circle" ? "50%" : "".concat(radius, "px"), (0, $jsG43.BORDER_WIDTH), borderColor, "var(--ds-space-025, 2px)", "var(--ds-space-0, 0px)", "var(--ds-space-0, 0px)", "var(--ds-space-0, 0px)", appearance === "circle" ? "50%" : "".concat(radius, "px"), stackIndex && "position: relative;", isInteractive && "\n      cursor: pointer;\n\n      :focus {\n        outline: none;\n        box-shadow: 0 0 0 ".concat((0, $jsG43.BORDER_WIDTH), "px ", "var(--ds-border-focused, ".concat((0, $aUwNi.B300), ")"), "\n      }\n\n      :hover {\n        &::after {\n          background-color: ", "var(--ds-interaction-hovered, ".concat((0, $aUwNi.N70A), ")"), ";\n          opacity: 1;\n        }\n      }\n\n      :active {\n        &::after {\n          background-color: ", "var(--ds-interaction-pressed, ".concat((0, $aUwNi.N70A), ")"), ";\n          opacity: 1;\n        }\n      }\n\n      :active {\n        transform: scale(").concat((0, $jsG43.ACTIVE_SCALE_FACTOR), ");\n      }\n\n      @media screen and (forced-colors: active) {\n        &:focus-visible {\n          outline: 1px solid\n        }\n      }\n    "), isDisabled && "\n        cursor: not-allowed;\n\n        &::after {\n          opacity: ".concat("var(--ds-opacity-disabled, 0.7)", ";\n          pointer-events: none;\n          background-color: ", "var(--ds-surface, ".concat((0, $aUwNi.N0), ")"), ";\n        }\n      "));
};
/**
 * __Avatar__
 *
 * An avatar is a visual representation of a user or entity.
 *
 * - [Examples](https://atlassian.design/components/avatar/examples)
 * - [Code](https://atlassian.design/components/avatar/code)
 * - [Usage](https://atlassian.design/components/avatar/usage)
 */ var $99653f9881894c89$var$Avatar = /*#__PURE__*/ (0, $1Mpn7.forwardRef)(function(_ref2, ref) {
    var analyticsContext = _ref2.analyticsContext, _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? "circle" : _ref2$appearance, label = _ref2.label, borderColor = _ref2.borderColor, children = _ref2.children, href = _ref2.href, isDisabled = _ref2.isDisabled, name = _ref2.name, onClick = _ref2.onClick, presence = _ref2.presence, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? "medium" : _ref2$size, src = _ref2.src, stackIndex = _ref2.stackIndex, status = _ref2.status, target = _ref2.target, testId = _ref2.testId, _ref2$as = _ref2.as, AvatarContainer = _ref2$as === void 0 ? "div" : _ref2$as;
    var _useAnalyticsEvents = (0, $145N3.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var customPresenceNode = /*#__PURE__*/ (0, $1Mpn7.isValidElement)(presence) ? presence : null;
    var customStatusNode = /*#__PURE__*/ (0, $1Mpn7.isValidElement)(status) ? status : null;
    var isValidIconSize = size !== "xxlarge" && size !== "xsmall";
    var lastAnalytics = (0, $1Mpn7.useRef)(analyticsContext);
    (0, $1Mpn7.useEffect)(function() {
        lastAnalytics.current = analyticsContext;
    }, [
        analyticsContext
    ]);
    var onClickHandler = (0, $1Mpn7.useCallback)(function(event) {
        if (isDisabled || typeof onClick !== "function") return;
        var analyticsEvent = createAnalyticsEvent({
            action: "clicked",
            actionSubject: "avatar",
            attributes: {
                componentName: "avatar",
                packageName: $99653f9881894c89$var$packageName,
                packageVersion: $99653f9881894c89$var$packageVersion
            }
        });
        /**
     * To avoid wrapping this component in AnalyticsContext we manually
     * push the parent context's meta data into the context.
     */ var context = $99653f9881894c89$var$_objectSpread({
            componentName: "avatar",
            packageName: $99653f9881894c89$var$packageName,
            packageVersion: $99653f9881894c89$var$packageVersion
        }, lastAnalytics.current);
        analyticsEvent.context.push(context);
        /**
     * Replicating the logic in the `withAnalyticsEvents` HOC
     */ var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        onClick(event, analyticsEvent);
    }, [
        createAnalyticsEvent,
        isDisabled,
        onClick
    ]);
    var getTestId = function getTestId(testId, children) {
        return !children ? {
            "data-testid": "".concat(testId, "--inner")
        } : {
            testId: "".concat(testId, "--inner")
        };
    };
    var componentProps = function componentProps() {
        if (isDisabled) return {
            disabled: true
        };
        // return only relevant props for either anchor or button elements
        return $99653f9881894c89$var$_objectSpread($99653f9881894c89$var$_objectSpread({}, href && (0, $c15dP.getLinkProps)(href, target)), onClick && !href ? (0, $c15dP.getButtonProps)(onClickHandler) : {
            onClick: onClick
        });
    };
    var isPresence = isValidIconSize && presence && !status;
    var isStatus = isValidIconSize && status;
    // add presence or status to the label by default if presence and status are passed as a string
    // if status or presence are nodes this is not added to the label by default
    var generateDefaultLabel = function generateDefaultLabel() {
        if (!name && !status && !presence) return;
        return "".concat(name || "", " ").concat(isStatus && !customStatusNode ? "(".concat(status, ")") : "", " ").concat(isPresence && !customPresenceNode ? "(".concat(presence, ")") : "");
    };
    return (0, $fBy54.jsx)(AvatarContainer, {
        "data-testid": testId,
        style: {
            display: "inline-block",
            position: "relative",
            outline: 0,
            zIndex: stackIndex
        }
    }, (0, $fBy54.jsx)((0, $fBy54.ClassNames), null, function(_ref3) {
        var css = _ref3.css;
        var props = $99653f9881894c89$var$_objectSpread($99653f9881894c89$var$_objectSpread($99653f9881894c89$var$_objectSpread($99653f9881894c89$var$_objectSpread({
            className: $99653f9881894c89$var$getStyles(css, {
                size: (0, $jsG43.AVATAR_SIZES)[size],
                radius: (0, $jsG43.AVATAR_RADIUS)[size],
                appearance: appearance,
                borderColor: borderColor,
                stackIndex: stackIndex,
                isInteractive: Boolean(href || onClick) && !isDisabled,
                isDisabled: isDisabled
            })
        }, componentProps()), testId && getTestId(testId, children)), (onClick || href) && {
            "aria-label": label || generateDefaultLabel()
        }), {}, {
            children: (0, $fBy54.jsx)((0, $kVHEk.default), {
                alt: name,
                appearance: appearance,
                size: size,
                src: src,
                testId: testId
            }),
            ref: ref
        });
        return children ? children(props) : /*#__PURE__*/ (0, $1Mpn7.createElement)((0, $c15dP.getCustomElement)(isDisabled, href, onClick), props);
    }), isPresence && (0, $fBy54.jsx)((0, $g7vQ0.PresenceWrapper), {
        appearance: appearance,
        size: size,
        presence: typeof presence === "string" ? presence : undefined,
        testId: testId
    }, customPresenceNode), isStatus && (0, $fBy54.jsx)((0, $bQiXQ.StatusWrapper), {
        appearance: appearance,
        size: size,
        borderColor: borderColor,
        status: typeof status === "string" ? status : undefined,
        testId: testId
    }, customStatusNode));
});
$99653f9881894c89$var$Avatar.displayName = "Avatar";
var $99653f9881894c89$export$2e2bcd8739ae039 = $99653f9881894c89$var$Avatar;

});
parcelRegister("1UIph", function(module, exports) {
function $164d77a54c54b342$var$_taggedTemplateLiteral(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
module.exports = $164d77a54c54b342$var$_taggedTemplateLiteral, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("aUwNi", function(module, exports) {

$parcel$export(module.exports, "R300", function () { return $7f18929496ce1ff5$export$4a7404f376229999; });
$parcel$export(module.exports, "R400", function () { return $7f18929496ce1ff5$export$2010d0fb4295b346; });
$parcel$export(module.exports, "G300", function () { return $7f18929496ce1ff5$export$940e1f69e873f202; });
$parcel$export(module.exports, "G400", function () { return $7f18929496ce1ff5$export$a49394138f7b8e85; });
$parcel$export(module.exports, "B50", function () { return $7f18929496ce1ff5$export$226de0355ed012f8; });
$parcel$export(module.exports, "B200", function () { return $7f18929496ce1ff5$export$215b7063051591f1; });
$parcel$export(module.exports, "B300", function () { return $7f18929496ce1ff5$export$e62e8919cca44969; });
$parcel$export(module.exports, "P300", function () { return $7f18929496ce1ff5$export$b48405b95304b5a1; });
$parcel$export(module.exports, "N0", function () { return $7f18929496ce1ff5$export$29a4f05edc054374; });
$parcel$export(module.exports, "N30", function () { return $7f18929496ce1ff5$export$3e51e8f1440314ba; });
$parcel$export(module.exports, "N40", function () { return $7f18929496ce1ff5$export$1ce2d1575d444ceb; });
$parcel$export(module.exports, "N90", function () { return $7f18929496ce1ff5$export$7c87d337fb91a97d; });
$parcel$export(module.exports, "N200", function () { return $7f18929496ce1ff5$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N500", function () { return $7f18929496ce1ff5$export$c39c0fe0f26207ae; });
$parcel$export(module.exports, "N900", function () { return $7f18929496ce1ff5$export$fbda843f0a27fe96; });
$parcel$export(module.exports, "N30A", function () { return $7f18929496ce1ff5$export$920c0d5c49070351; });
$parcel$export(module.exports, "N70A", function () { return $7f18929496ce1ff5$export$6e5e7499ff054f6d; });
$parcel$export(module.exports, "skeleton", function () { return $7f18929496ce1ff5$export$2a0674ff2eb10214; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $hMLOe = parcelRequire("hMLOe");
var $7f18929496ce1ff5$export$4b84fd0e2c617bd = "#FFEBE6";
var $7f18929496ce1ff5$export$b34b069eff244586 = "#FFBDAD";
var $7f18929496ce1ff5$export$be802dd0d8b57f35 = "#FF8F73";
var $7f18929496ce1ff5$export$60847d42f9da92a6 = "#FF7452";
var $7f18929496ce1ff5$export$4a7404f376229999 = "#FF5630";
var $7f18929496ce1ff5$export$2010d0fb4295b346 = "#DE350B";
var $7f18929496ce1ff5$export$2837b5a1a71d5c02 = "#BF2600";
var $7f18929496ce1ff5$export$8d9596b529bbb9cf = "#FFFAE6";
var $7f18929496ce1ff5$export$41060a744ab0b7ae = "#FFF0B3";
var $7f18929496ce1ff5$export$1cc05bbbf340e559 = "#FFE380";
var $7f18929496ce1ff5$export$5aae31392d72caaa = "#FFC400";
var $7f18929496ce1ff5$export$c6930421db9fa514 = "#FFAB00";
var $7f18929496ce1ff5$export$59619663aa6500fb = "#FF991F";
var $7f18929496ce1ff5$export$874739ea9e379ab6 = "#FF8B00";
var $7f18929496ce1ff5$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $7f18929496ce1ff5$export$69a3bf21b9686c2b = "#ABF5D1";
var $7f18929496ce1ff5$export$afbce1382ec95f73 = "#79F2C0";
var $7f18929496ce1ff5$export$747d86715d4175de = "#57D9A3";
var $7f18929496ce1ff5$export$940e1f69e873f202 = "#36B37E";
var $7f18929496ce1ff5$export$a49394138f7b8e85 = "#00875A";
var $7f18929496ce1ff5$export$6fa04827ac68a4fb = "#006644";
var $7f18929496ce1ff5$export$226de0355ed012f8 = "#DEEBFF";
var $7f18929496ce1ff5$export$8c13c2ee36917869 = "#B3D4FF";
var $7f18929496ce1ff5$export$ecfc1dff386a3e7a = "#4C9AFF";
var $7f18929496ce1ff5$export$215b7063051591f1 = "#2684FF";
var $7f18929496ce1ff5$export$e62e8919cca44969 = "#0065FF";
var $7f18929496ce1ff5$export$b3de0ae08da2ce64 = "#0052CC";
var $7f18929496ce1ff5$export$a6ee3d71bc067634 = "#0747A6";
var $7f18929496ce1ff5$export$363e4475840015bb = "#EAE6FF";
var $7f18929496ce1ff5$export$4b0a4417ed59760f = "#C0B6F2";
var $7f18929496ce1ff5$export$6011520a64d9a187 = "#998DD9";
var $7f18929496ce1ff5$export$a7175d4e9206bc80 = "#8777D9";
var $7f18929496ce1ff5$export$b48405b95304b5a1 = "#6554C0";
var $7f18929496ce1ff5$export$c71e4279dd54a18d = "#5243AA";
var $7f18929496ce1ff5$export$147899de772240ec = "#403294";
var $7f18929496ce1ff5$export$2cf711fe14c66f06 = "#E6FCFF";
var $7f18929496ce1ff5$export$7a8f4d33f6f9772c = "#B3F5FF";
var $7f18929496ce1ff5$export$776c9c497ef08533 = "#79E2F2";
var $7f18929496ce1ff5$export$69cb3ca10c1e330e = "#00C7E6";
var $7f18929496ce1ff5$export$9dc1ef0f3f48059b = "#00B8D9";
var $7f18929496ce1ff5$export$7c835c78b6fcdef8 = "#00A3BF";
var $7f18929496ce1ff5$export$6036577f95c3877e = "#008DA6";
var $7f18929496ce1ff5$export$29a4f05edc054374 = "#FFFFFF";
var $7f18929496ce1ff5$export$e655ef011c4aa1a2 = "#FAFBFC";
var $7f18929496ce1ff5$export$9fdfb749e33cdf97 = "#F4F5F7";
var $7f18929496ce1ff5$export$3e51e8f1440314ba = "#EBECF0";
var $7f18929496ce1ff5$export$1ce2d1575d444ceb = "#DFE1E6";
var $7f18929496ce1ff5$export$8754fc7e6d8b3000 = "#C1C7D0";
var $7f18929496ce1ff5$export$c2e91cbeada39b8b = "#B3BAC5";
var $7f18929496ce1ff5$export$5f71e19f3a7ad9de = "#A5ADBA";
var $7f18929496ce1ff5$export$eaa8c8a70ac22806 = "#97A0AF";
var $7f18929496ce1ff5$export$7c87d337fb91a97d = "#8993A4";
var $7f18929496ce1ff5$export$d6447c357493214f = "#7A869A";
var $7f18929496ce1ff5$export$f563ee71e9ee74cd = "#6B778C";
var $7f18929496ce1ff5$export$e2ef2124cf4024b1 = "#5E6C84";
var $7f18929496ce1ff5$export$eece5f492e429f08 = "#505F79";
var $7f18929496ce1ff5$export$c39c0fe0f26207ae = "#42526E";
var $7f18929496ce1ff5$export$7090862dc3038a9f = "#344563";
var $7f18929496ce1ff5$export$ad0bacf983b7ddaa = "#253858";
var $7f18929496ce1ff5$export$7d61b15e0da132af = "#172B4D";
var $7f18929496ce1ff5$export$fbda843f0a27fe96 = "#091E42";
var $7f18929496ce1ff5$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $7f18929496ce1ff5$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $7f18929496ce1ff5$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $7f18929496ce1ff5$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $7f18929496ce1ff5$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $7f18929496ce1ff5$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $7f18929496ce1ff5$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $7f18929496ce1ff5$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $7f18929496ce1ff5$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $7f18929496ce1ff5$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $7f18929496ce1ff5$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $7f18929496ce1ff5$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $7f18929496ce1ff5$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $7f18929496ce1ff5$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $7f18929496ce1ff5$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $7f18929496ce1ff5$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $7f18929496ce1ff5$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $7f18929496ce1ff5$export$2f6319cf7d736c2a = "#E6EDFA";
var $7f18929496ce1ff5$export$95126bc8884d6634 = "#DCE5F5";
var $7f18929496ce1ff5$export$8338d8c35d44ff1 = "#CED9EB";
var $7f18929496ce1ff5$export$5368d76ae4fbbda7 = "#B8C7E0";
var $7f18929496ce1ff5$export$9f0a771d16ec8d36 = "#ABBBD6";
var $7f18929496ce1ff5$export$abcf8c38338b4aa5 = "#9FB0CC";
var $7f18929496ce1ff5$export$97e81faa16a182c7 = "#8C9CB8";
var $7f18929496ce1ff5$export$bfe21c59123ecf33 = "#7988A3";
var $7f18929496ce1ff5$export$ee82aa2ea6a1558 = "#67758F";
var $7f18929496ce1ff5$export$682927c6ed76be02 = "#56637A";
var $7f18929496ce1ff5$export$91fd9994c5be9757 = "#455166";
var $7f18929496ce1ff5$export$d281fbfe3cff2df6 = "#3B475C";
var $7f18929496ce1ff5$export$3902c91d8b98a753 = "#313D52";
var $7f18929496ce1ff5$export$8e8133c1ba5845b5 = "#283447";
var $7f18929496ce1ff5$export$33ff357f6620b39 = "#202B3D";
var $7f18929496ce1ff5$export$633847cf062b69e0 = "#1B2638";
var $7f18929496ce1ff5$export$9776a6e503bdbf76 = "#121A29";
var $7f18929496ce1ff5$export$6c813d5160dff5db = "#0E1624";
var $7f18929496ce1ff5$export$3d4f271a500072a = "#0D1424";
var $7f18929496ce1ff5$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $7f18929496ce1ff5$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $7f18929496ce1ff5$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $7f18929496ce1ff5$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $7f18929496ce1ff5$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $7f18929496ce1ff5$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $7f18929496ce1ff5$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $7f18929496ce1ff5$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $7f18929496ce1ff5$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $7f18929496ce1ff5$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $7f18929496ce1ff5$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $7f18929496ce1ff5$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $7f18929496ce1ff5$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $7f18929496ce1ff5$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $7f18929496ce1ff5$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $7f18929496ce1ff5$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $7f18929496ce1ff5$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $7f18929496ce1ff5$export$8ce1fd94bee2f412 = (0, $hMLOe.default)({
    light: "var(--ds-surface, ".concat($7f18929496ce1ff5$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface, ".concat($7f18929496ce1ff5$export$633847cf062b69e0, ")")
});
var $7f18929496ce1ff5$export$b861914ea877b580 = (0, $hMLOe.default)({
    light: "var(--ds-background-selected, ".concat($7f18929496ce1ff5$export$226de0355ed012f8, ")"),
    dark: "var(--ds-background-selected, ".concat($7f18929496ce1ff5$export$8c13c2ee36917869, ")")
});
var $7f18929496ce1ff5$export$3f1b020df94387af = (0, $hMLOe.default)({
    light: "var(--ds-background-neutral-hovered, ".concat($7f18929496ce1ff5$export$3e51e8f1440314ba, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat($7f18929496ce1ff5$export$d281fbfe3cff2df6, ")")
});
var $7f18929496ce1ff5$export$c0183dbab98ca63e = (0, $hMLOe.default)({
    light: "var(--ds-surface-overlay, ".concat($7f18929496ce1ff5$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface-overlay, ".concat($7f18929496ce1ff5$export$8e8133c1ba5845b5, ")")
});
var $7f18929496ce1ff5$export$6f093cfa640b7166 = (0, $hMLOe.default)({
    light: "var(--ds-text, ".concat($7f18929496ce1ff5$export$fbda843f0a27fe96, ")"),
    dark: "var(--ds-text, ".concat($7f18929496ce1ff5$export$5368d76ae4fbbda7, ")")
});
var $7f18929496ce1ff5$export$42f8e9c698766e7a = (0, $hMLOe.default)({
    light: "var(--ds-text, ".concat($7f18929496ce1ff5$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($7f18929496ce1ff5$export$5368d76ae4fbbda7, ")")
});
var $7f18929496ce1ff5$export$c2d157ca1c34b6e3 = (0, $hMLOe.default)({
    light: "var(--ds-text-selected, ".concat($7f18929496ce1ff5$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-text-selected, ".concat($7f18929496ce1ff5$export$b3de0ae08da2ce64, ")")
});
var $7f18929496ce1ff5$export$1905ba28d7cf066f = (0, $hMLOe.default)({
    light: "var(--ds-text-subtlest, ".concat($7f18929496ce1ff5$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($7f18929496ce1ff5$export$97e81faa16a182c7, ")")
});
var $7f18929496ce1ff5$export$bd9002130d306d39 = (0, $hMLOe.default)({
    light: "var(--ds-text-subtlest, ".concat($7f18929496ce1ff5$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($7f18929496ce1ff5$export$bfe21c59123ecf33, ")")
});
var $7f18929496ce1ff5$export$46e4a324ac90507f = (0, $hMLOe.default)({
    light: "var(--ds-text, ".concat($7f18929496ce1ff5$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($7f18929496ce1ff5$export$5368d76ae4fbbda7, ")")
});
var $7f18929496ce1ff5$export$79f3f2b82beb0d36 = (0, $hMLOe.default)({
    light: "var(--ds-text-subtlest, ".concat($7f18929496ce1ff5$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($7f18929496ce1ff5$export$97e81faa16a182c7, ")")
});
var $7f18929496ce1ff5$export$7bb0d5c671655cc4 = (0, $hMLOe.default)({
    light: $7f18929496ce1ff5$export$9fdfb749e33cdf97,
    dark: $7f18929496ce1ff5$export$8e8133c1ba5845b5
});
var $7f18929496ce1ff5$export$9c30223ca0a664fb = (0, $hMLOe.default)({
    light: "var(--ds-link, ".concat($7f18929496ce1ff5$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-link, ".concat($7f18929496ce1ff5$export$ecfc1dff386a3e7a, ")")
});
var $7f18929496ce1ff5$export$7ed258b0728b004b = (0, $hMLOe.default)({
    light: "var(--ds-link-pressed, ".concat($7f18929496ce1ff5$export$e62e8919cca44969, ")"),
    dark: "var(--ds-link-pressed, ".concat($7f18929496ce1ff5$export$215b7063051591f1, ")")
});
var $7f18929496ce1ff5$export$dfa920d8decc8a59 = (0, $hMLOe.default)({
    light: "var(--ds-link-pressed, ".concat($7f18929496ce1ff5$export$a6ee3d71bc067634, ")"),
    dark: "var(--ds-link-pressed, ".concat($7f18929496ce1ff5$export$ecfc1dff386a3e7a, ")")
});
var $7f18929496ce1ff5$export$6069e6ad5c78f632 = (0, $hMLOe.default)({
    light: "var(--ds-border-focused, ".concat($7f18929496ce1ff5$export$215b7063051591f1, ")"),
    dark: "var(--ds-border-focused, ".concat($7f18929496ce1ff5$export$215b7063051591f1, ")")
});
var $7f18929496ce1ff5$export$9ad721cf3b3debe0 = (0, $hMLOe.default)({
    light: "var(--ds-background-brand-bold, ".concat($7f18929496ce1ff5$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-background-brand-bold, ".concat($7f18929496ce1ff5$export$ecfc1dff386a3e7a, ")")
});
var $7f18929496ce1ff5$export$2aa0182783e7e9de = (0, $hMLOe.default)({
    light: $7f18929496ce1ff5$export$b3de0ae08da2ce64,
    dark: $7f18929496ce1ff5$export$ecfc1dff386a3e7a
});
var $7f18929496ce1ff5$export$8bf7dff220b82b4a = (0, $hMLOe.default)({
    light: $7f18929496ce1ff5$export$9dc1ef0f3f48059b,
    dark: $7f18929496ce1ff5$export$69cb3ca10c1e330e
});
var $7f18929496ce1ff5$export$e13cce2a2d16a9d4 = (0, $hMLOe.default)({
    light: $7f18929496ce1ff5$export$b48405b95304b5a1,
    dark: $7f18929496ce1ff5$export$6011520a64d9a187
});
var $7f18929496ce1ff5$export$a90204d1394caf30 = (0, $hMLOe.default)({
    light: $7f18929496ce1ff5$export$4a7404f376229999,
    dark: $7f18929496ce1ff5$export$4a7404f376229999
});
var $7f18929496ce1ff5$export$594c5a8758200c32 = (0, $hMLOe.default)({
    light: $7f18929496ce1ff5$export$c6930421db9fa514,
    dark: $7f18929496ce1ff5$export$c6930421db9fa514
});
var $7f18929496ce1ff5$export$955a2ebd2fb142ae = (0, $hMLOe.default)({
    light: $7f18929496ce1ff5$export$940e1f69e873f202,
    dark: $7f18929496ce1ff5$export$940e1f69e873f202
});
var $7f18929496ce1ff5$export$2a0674ff2eb10214 = function skeleton() {
    return "var(--ds-skeleton, ".concat($7f18929496ce1ff5$export$8d43898f60b96a82, ")");
};

});
parcelRegister("hMLOe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf2c0143cb7b202e$export$2e2bcd8739ae039; });
/* eslint-disable prefer-rest-params */ 
var $6B4ab = parcelRequire("6B4ab");
// Unpack custom variants, and get correct value for the current theme
function $cf2c0143cb7b202e$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $6B4ab.default)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return "";
    };
}
function $cf2c0143cb7b202e$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === "string") return $cf2c0143cb7b202e$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $6B4ab.default)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return "";
    };
}

});
parcelRegister("6B4ab", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4cd96d84f05d512e$export$2e2bcd8739ae039; });

var $lkXrC = parcelRequire("lkXrC");
function $4cd96d84f05d512e$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $lkXrC.CHANNEL) in props.theme) return props.theme[0, $lkXrC.CHANNEL];
        else if ("mode" in props.theme && (0, $lkXrC.THEME_MODES).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $lkXrC.DEFAULT_THEME_MODE)
    };
}

});
parcelRegister("lkXrC", function(module, exports) {

$parcel$export(module.exports, "CHANNEL", function () { return $f88993acd378c2ec$export$44ffba16bd48dac6; });
$parcel$export(module.exports, "DEFAULT_THEME_MODE", function () { return $f88993acd378c2ec$export$c93026a968943f95; });
$parcel$export(module.exports, "THEME_MODES", function () { return $f88993acd378c2ec$export$6ba72c8346b4c57e; });
$parcel$export(module.exports, "borderRadius", function () { return $f88993acd378c2ec$export$7a57f79000377ca2; });
$parcel$export(module.exports, "gridSize", function () { return $f88993acd378c2ec$export$6d8204c2cb2e06b8; });

var $2Eqc7 = parcelRequire("2Eqc7");

var $aUwNi = parcelRequire("aUwNi");
var $f88993acd378c2ec$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $f88993acd378c2ec$export$c93026a968943f95 = "light";
var $f88993acd378c2ec$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $f88993acd378c2ec$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $f88993acd378c2ec$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $f88993acd378c2ec$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $f88993acd378c2ec$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $f88993acd378c2ec$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $f88993acd378c2ec$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $f88993acd378c2ec$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $aUwNi.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $f88993acd378c2ec$export$6d8204c2cb2e06b8() / 4;
    (0, $2Eqc7.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $f88993acd378c2ec$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $f88993acd378c2ec$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $f88993acd378c2ec$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $2Eqc7.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $f88993acd378c2ec$export$ba1d834b86d72a09 = $f88993acd378c2ec$export$a1b3edb637fb4f35;
var $f88993acd378c2ec$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $aUwNi.skeleton)(), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $aUwNi.skeleton)(), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $aUwNi.N30A), ")")
            }
        }
    };
};

});




parcelRegister("kVHEk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f3cafd697a11de9c$export$2e2bcd8739ae039; });

var $jjExS = parcelRequire("jjExS");

var $e6gyJ = parcelRequire("e6gyJ");

var $1Mpn7 = parcelRequire("1Mpn7");

var $fBy54 = parcelRequire("fBy54");

var $4Akvz = parcelRequire("4Akvz");

var $292Ob = parcelRequire("292Ob");

var $aUwNi = parcelRequire("aUwNi");

var $jsG43 = parcelRequire("jsG43");
function $f3cafd697a11de9c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f3cafd697a11de9c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f3cafd697a11de9c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f3cafd697a11de9c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f3cafd697a11de9c$export$ebe0b8fe8b6acbfd = "var(--ds-icon-inverse, ".concat((0, $aUwNi.N0), ")");
var $f3cafd697a11de9c$export$72502e51aebdd94e = "var(--ds-icon-subtle, ".concat((0, $aUwNi.N90), ")");
var $f3cafd697a11de9c$var$avatarDefaultIconStyles = (0, $fBy54.css)({
    display: "block",
    width: "100%",
    height: "100%",
    backgroundColor: $f3cafd697a11de9c$export$72502e51aebdd94e
});
var $f3cafd697a11de9c$var$nestedAvatarStyles = Object.entries((0, $jsG43.AVATAR_SIZES)).reduce(function(styles, _ref) {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($e6gyJ)))(_ref, 2), key = _ref2[0], size = _ref2[1];
    return $f3cafd697a11de9c$var$_objectSpread($f3cafd697a11de9c$var$_objectSpread({}, styles), {}, (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))({}, key, (0, $fBy54.css)({
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "& svg": {
            width: "".concat(size, "px"),
            height: "".concat(size, "px")
        }
    })));
}, {});
var $f3cafd697a11de9c$var$avatarImageStyles = (0, $fBy54.css)({
    display: "flex",
    width: "100%",
    height: "100%",
    flex: "1 1 100%"
});
/**
 * __Avatar image__
 *
 * An avatar image is an internal component used to control the rendering phases of an image.
 */ var $f3cafd697a11de9c$var$AvatarImage = function AvatarImage(_ref3) {
    var _ref3$alt = _ref3.alt, alt = _ref3$alt === void 0 ? "" : _ref3$alt, src = _ref3.src, appearance = _ref3.appearance, size = _ref3.size, testId = _ref3.testId;
    var _useState = (0, $1Mpn7.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($e6gyJ)))(_useState, 2), hasImageErrored = _useState2[0], setHasImageErrored = _useState2[1];
    var borderRadius = appearance === "circle" ? "50%" : "".concat((0, $jsG43.AVATAR_RADIUS)[size], "px");
    // If src changes, reset state
    (0, $1Mpn7.useEffect)(function() {
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) return (0, $fBy54.jsx)("span", {
        css: [
            $f3cafd697a11de9c$var$avatarDefaultIconStyles,
            $f3cafd697a11de9c$var$nestedAvatarStyles[size]
        ]
    }, appearance === "circle" ? (0, $fBy54.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4Akvz))), {
        label: alt,
        primaryColor: $f3cafd697a11de9c$export$ebe0b8fe8b6acbfd,
        secondaryColor: $f3cafd697a11de9c$export$72502e51aebdd94e,
        testId: testId && "".concat(testId, "--person")
    }) : (0, $fBy54.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($292Ob))), {
        label: alt,
        primaryColor: $f3cafd697a11de9c$export$ebe0b8fe8b6acbfd,
        secondaryColor: $f3cafd697a11de9c$export$72502e51aebdd94e,
        testId: testId && "".concat(testId, "--ship")
    }));
    return (0, $fBy54.jsx)("img", {
        src: src,
        alt: alt,
        "data-testid": testId && "".concat(testId, "--image"),
        css: $f3cafd697a11de9c$var$avatarImageStyles,
        style: {
            borderRadius: borderRadius
        },
        onError: function onError() {
            return setHasImageErrored(true);
        }
    });
};
var $f3cafd697a11de9c$export$2e2bcd8739ae039 = $f3cafd697a11de9c$var$AvatarImage;

});
parcelRegister("4Akvz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $356a6ebb10541fad$var$_react = $356a6ebb10541fad$var$_interopRequireDefault((parcelRequire("1Mpn7")));

var $cotNw = parcelRequire("cotNw");
function $356a6ebb10541fad$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $356a6ebb10541fad$var$PersonIcon = function(props) {
    return /*#__PURE__*/ $356a6ebb10541fad$var$_react.default.createElement($cotNw.Icon, Object.assign({
        dangerouslySetGlyph: '<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M6 14c0-1.105.902-2 2.009-2h7.982c1.11 0 2.009.894 2.009 2.006v4.44c0 3.405-12 3.405-12 0V14z"/><circle cx="12" cy="7" r="4"/></g></svg>'
    }, props));
};
$356a6ebb10541fad$var$PersonIcon.displayName = "PersonIcon";
var $356a6ebb10541fad$var$_default = $356a6ebb10541fad$var$PersonIcon;
module.exports.default = $356a6ebb10541fad$var$_default;

});

parcelRegister("292Ob", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $18fe99b709773e7c$var$_react = $18fe99b709773e7c$var$_interopRequireDefault((parcelRequire("1Mpn7")));

var $cotNw = parcelRequire("cotNw");
function $18fe99b709773e7c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $18fe99b709773e7c$var$ShipIcon = function(props) {
    return /*#__PURE__*/ $18fe99b709773e7c$var$_react.default.createElement($cotNw.Icon, Object.assign({
        dangerouslySetGlyph: '<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M6 12h8v-2H6v2zM4 8.99C4 8.445 4.456 8 5.002 8h9.996C15.55 8 16 8.451 16 8.99V14H4V8.99z" fill-rule="nonzero"/><path d="M6 7.005C6 5.898 6.898 5 7.998 5h2.004C11.106 5 12 5.894 12 7.005V10H6V7.005zm4 0V7H7.999c.005 0 .002.003.002.005V8h2v-.995z"/><path d="M4.5 17h13.994l1.002-3H4.14l.36 3zm-2.495-4.012A.862.862 0 012.883 12h18.393c.55 0 .857.417.681.944l-1.707 5.112c-.174.521-.758.944-1.315.944H3.725a1.149 1.149 0 01-1.118-.988l-.602-5.024z" fill-rule="nonzero"/></g></svg>'
    }, props));
};
$18fe99b709773e7c$var$ShipIcon.displayName = "ShipIcon";
var $18fe99b709773e7c$var$_default = $18fe99b709773e7c$var$ShipIcon;
module.exports.default = $18fe99b709773e7c$var$_default;

});

parcelRegister("jsG43", function(module, exports) {

$parcel$export(module.exports, "AVATAR_SIZES", function () { return $e2b142f08359d6b3$export$9a270941bcff7e77; });
$parcel$export(module.exports, "AVATAR_RADIUS", function () { return $e2b142f08359d6b3$export$e6da6efe4d1a5c9b; });
$parcel$export(module.exports, "BORDER_WIDTH", function () { return $e2b142f08359d6b3$export$e2bd4c1faded7921; });
$parcel$export(module.exports, "ACTIVE_SCALE_FACTOR", function () { return $e2b142f08359d6b3$export$89a980dfdf90df51; });
$parcel$export(module.exports, "ICON_SIZES", function () { return $e2b142f08359d6b3$export$fdc820179f1f9be4; });
$parcel$export(module.exports, "ICON_OFFSET", function () { return $e2b142f08359d6b3$export$382610e783aa2ae8; });
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match, @atlaskit/design-system/no-deprecated-imports

var $lkXrC = parcelRequire("lkXrC");
var $e2b142f08359d6b3$export$9a270941bcff7e77 = {
    xsmall: (0, $lkXrC.gridSize)() * 2,
    small: (0, $lkXrC.gridSize)() * 3,
    medium: (0, $lkXrC.gridSize)() * 4,
    large: (0, $lkXrC.gridSize)() * 5,
    xlarge: (0, $lkXrC.gridSize)() * 12,
    xxlarge: (0, $lkXrC.gridSize)() * 16
};
var $e2b142f08359d6b3$export$e6da6efe4d1a5c9b = {
    xsmall: 2,
    small: 2,
    medium: 3,
    large: 3,
    xlarge: 6,
    xxlarge: 12
};
var $e2b142f08359d6b3$export$e2bd4c1faded7921 = 2;
var $e2b142f08359d6b3$export$89a980dfdf90df51 = 0.9;
var $e2b142f08359d6b3$export$3c061e31594ebabe = "--avatar-background-color";
var $e2b142f08359d6b3$export$fdc820179f1f9be4 = {
    small: 12,
    medium: 14,
    large: 15,
    xlarge: 18
};
var $e2b142f08359d6b3$export$382610e783aa2ae8 = {
    small: 0,
    medium: 0,
    large: 1,
    xlarge: 7
};

});


parcelRegister("g7vQ0", function(module, exports) {

$parcel$export(module.exports, "PresenceWrapper", function () { return $bbc5ff16cc39a8d3$export$972c5e90200fa0ef; });
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $1Mpn7 = parcelRequire("1Mpn7");

var $aUwNi = parcelRequire("aUwNi");

var $jsG43 = parcelRequire("jsG43");

var $enUkA = parcelRequire("enUkA");
var $bbc5ff16cc39a8d3$var$BusyIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $1Mpn7.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("circle", {
    fill: "var(--ds-icon-danger, ".concat((0, $aUwNi.R300), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $aUwNi.N0), ")"),
    d: "M3.3,1.9l2.8,2.8c0.2,0.2,0.2,0.5,0,0.7L5.4,6.1c-0.2,0.2-0.5,0.2-0.7,0L1.9,3.3c-0.2-0.2-0.2-0.5,0-0.7l0.7-0.7C2.8,1.7,3.1,1.7,3.3,1.9z"
}));
var $bbc5ff16cc39a8d3$var$FocusIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $1Mpn7.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("path", {
    fill: "var(--ds-icon-discovery, ".concat((0, $aUwNi.P300), ")"),
    d: "M4,8 C1.790861,8 0,6.209139 0,4 C0,1.790861 1.790861,0 4,0 C6.209139,0 8,1.790861 8,4 C8,6.209139 6.209139,8 4,8 Z M4,6.66666667 C5.47275933,6.66666667 6.66666667,5.47275933 6.66666667,4 C6.66666667,2.52724067 5.47275933,1.33333333 4,1.33333333 C2.52724067,1.33333333 1.33333333,2.52724067 1.33333333,4 C1.33333333,5.47275933 2.52724067,6.66666667 4,6.66666667 Z M4,5.33333333 C3.26362033,5.33333333 2.66666667,4.73637967 2.66666667,4 C2.66666667,3.26362033 3.26362033,2.66666667 4,2.66666667 C4.73637967,2.66666667 5.33333333,3.26362033 5.33333333,4 C5.33333333,4.73637967 4.73637967,5.33333333 4,5.33333333 Z"
}));
var $bbc5ff16cc39a8d3$var$OfflineIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $1Mpn7.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("path", {
    fill: "var(--ds-text-subtlest, ".concat((0, $aUwNi.N200), ")"),
    d: "M4,8 C6.209139,8 8,6.209139 8,4 C8,1.790861 6.209139,0 4,0 C1.790861,0 0,1.790861 0,4 C0,6.209139 1.790861,8 4,8 Z M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $aUwNi.N40), ")"),
    d: "M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}));
var $bbc5ff16cc39a8d3$var$OnlineIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("circle", {
    fill: "var(--ds-icon-success, ".concat((0, $aUwNi.G300), ")"),
    cx: "4",
    cy: "4",
    r: "4"
});
function $bbc5ff16cc39a8d3$var$getPresence(presence) {
    switch(presence){
        case "busy":
            return $bbc5ff16cc39a8d3$var$BusyIndicator;
        case "focus":
            return $bbc5ff16cc39a8d3$var$FocusIndicator;
        case "offline":
            return $bbc5ff16cc39a8d3$var$OfflineIndicator;
        case "online":
            return $bbc5ff16cc39a8d3$var$OnlineIndicator;
    }
}
/**
 * __Avatar presence__
 *
 * A presence shows an avatar’s availability.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-presence/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-presence/code)
 * - [Usage](https://atlassian.design/components/avatar/avatar-presence/usage)
 */ var $bbc5ff16cc39a8d3$var$AvatarPresence = function AvatarPresence(_ref) {
    var borderColor = _ref.borderColor, children = _ref.children, presence = _ref.presence;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $enUkA.default), {
        bgColor: borderColor,
        label: typeof presence === "string" ? presence : undefined
    }, presence ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("svg", {
        "aria-hidden": "true",
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $bbc5ff16cc39a8d3$var$getPresence(presence)) : children);
};
var $bbc5ff16cc39a8d3$export$2e2bcd8739ae039 = $bbc5ff16cc39a8d3$var$AvatarPresence;
var $bbc5ff16cc39a8d3$export$972c5e90200fa0ef = function PresenceWrapper(_ref2) {
    var size = _ref2.size, appearance = _ref2.appearance, children = _ref2.children, borderColor = _ref2.borderColor, presence = _ref2.presence, testId = _ref2.testId;
    var position = appearance === "square" ? -4 : (0, $jsG43.ICON_OFFSET)[size];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && "".concat(testId, "--presence"),
        style: {
            pointerEvents: "none",
            position: "absolute",
            bottom: "".concat(position, "px"),
            height: "".concat((0, $jsG43.ICON_SIZES)[size], "px"),
            right: "".concat(position, "px"),
            width: "".concat((0, $jsG43.ICON_SIZES)[size], "px")
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement($bbc5ff16cc39a8d3$var$AvatarPresence, {
        borderColor: borderColor,
        presence: !children ? presence : undefined
    }, children));
};

});
parcelRegister("enUkA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a78ee8d9f8ff7cef$export$2e2bcd8739ae039; });
/** @jsx jsx */ // eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $fBy54 = parcelRequire("fBy54");

var $aUwNi = parcelRequire("aUwNi");

var $jsG43 = parcelRequire("jsG43");
var $a78ee8d9f8ff7cef$var$iconWrapperStyles = (0, $fBy54.css)({
    display: "flex",
    boxSizing: "border-box",
    width: "100%",
    height: "100%",
    alignItems: "center",
    alignContent: "center",
    borderRadius: "var(--ds-border-radius-circle, 50%)",
    overflow: "hidden"
});
/**
 * __Icon wrapper__
 *
 * An icon wrapper is used internally only.
 */ var $a78ee8d9f8ff7cef$var$IconWrapper = function IconWrapper(_ref) {
    var _ref$bgColor = _ref.bgColor, bgColor = _ref$bgColor === void 0 ? "var(--ds-surface-overlay, ".concat((0, $aUwNi.N0), ")") : _ref$bgColor, children = _ref.children, label = _ref.label;
    return (0, $fBy54.jsx)("span", {
        "aria-label": label || undefined,
        css: $a78ee8d9f8ff7cef$var$iconWrapperStyles,
        role: label ? "img" : "presentation",
        style: {
            border: "".concat((0, $jsG43.BORDER_WIDTH), "px solid ").concat(bgColor),
            backgroundColor: bgColor
        }
    }, children);
};
var $a78ee8d9f8ff7cef$export$2e2bcd8739ae039 = $a78ee8d9f8ff7cef$var$IconWrapper;

});


parcelRegister("bQiXQ", function(module, exports) {

$parcel$export(module.exports, "StatusWrapper", function () { return $89f342f56d6979d8$export$8045894f255f9726; });
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $1Mpn7 = parcelRequire("1Mpn7");

var $aUwNi = parcelRequire("aUwNi");

var $jsG43 = parcelRequire("jsG43");

var $enUkA = parcelRequire("enUkA");
var $89f342f56d6979d8$var$ApprovedIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $1Mpn7.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("circle", {
    fill: "var(--ds-icon-success, ".concat((0, $aUwNi.G400), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $aUwNi.N0), ")"),
    d: "M2.47140452,3.52859548 C2.21105499,3.26824595 1.78894501,3.26824595 1.52859548,3.52859548 C1.26824595,3.78894501 1.26824595,4.21105499 1.52859548,4.47140452 L2.86192881,5.80473785 C3.12227834,6.06508738 3.54438833,6.06508738 3.80473785,5.80473785 L6.47140452,3.13807119 C6.73175405,2.87772166 6.73175405,2.45561167 6.47140452,2.19526215 C6.21105499,1.93491262 5.78894501,1.93491262 5.52859548,2.19526215 L3.33333333,4.39052429 L2.47140452,3.52859548 Z"
}));
var $89f342f56d6979d8$var$DeclinedIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $1Mpn7.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("circle", {
    fill: "var(--ds-icon-danger, ".concat((0, $aUwNi.R400), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $aUwNi.N0), ")"),
    d: "M4.890661,4.0088336 L5.81806461,3.07802178 C6.06167933,2.83351177 6.06048933,2.43826992 5.81540668,2.19522442 C5.57032402,1.95217891 5.17415651,1.95336612 4.93054179,2.19787613 L4.00765946,3.12415007 L3.06906871,2.18377143 C2.82523777,1.93947602 2.42906937,1.93863765 2.18420182,2.18189887 C1.93933427,2.42516008 1.93849394,2.82040282 2.18232488,3.06469822 L3.12544091,4.00961077 L2.20275024,4.93569234 C1.95913552,5.18020236 1.96032551,5.5754442 2.20540817,5.81848971 C2.45049083,6.06153521 2.84665833,6.060348 3.09027306,5.81583799 L4.00844245,4.89429431 L4.9092123,5.79678001 C5.15304324,6.04107541 5.54921164,6.04191379 5.79407919,5.79865257 C6.03894674,5.55539135 6.03978708,5.16014862 5.79595614,4.91585321 L4.890661,4.0088336 Z"
}));
var $89f342f56d6979d8$var$LockedIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $1Mpn7.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("circle", {
    fill: "var(--ds-text-subtlest, ".concat((0, $aUwNi.N40), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $aUwNi.N500), ")"),
    d: "M4.13074827,1.21766493 L4.10368158,1.21766493 C3.36340745,1.21766493 2.76388015,1.80793503 2.76388015,2.5367787 L2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,2.54344089 C3.44054754,2.17901906 3.74031119,1.88388401 4.11044825,1.88388401 L4.1239816,1.88388401 C4.49411866,1.88388401 4.79388232,2.17901906 4.79388232,2.54344089 L4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,2.5367787 C5.47054971,1.80793503 4.8710224,1.21766493 4.13074827,1.21766493 M2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,3.88254123 L2.76388015,3.88254123 L2.76388015,3.21632216 Z M4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,3.88254123 L4.79388232,3.88254123 L4.79388232,3.21632216 Z M4.79401765,3.88254123 L3.44068287,3.88254123 L2.76401548,3.88254123 C2.39049508,3.88254123 2.08734809,4.18100738 2.08734809,4.54876031 L2.08734809,5.54808892 C2.08734809,6.10000287 2.53735205,6.54741753 3.09094491,6.54741753 L5.14375561,6.54741753 C5.69802683,6.54741753 6.14735243,6.10385072 6.14735243,5.54808892 L6.14735243,4.54876031 C6.14735243,4.18100738 5.84420544,3.88254123 5.47068504,3.88254123 L4.79401765,3.88254123 Z"
}));
function $89f342f56d6979d8$var$getStatus(status) {
    switch(status){
        case "approved":
            return $89f342f56d6979d8$var$ApprovedIndicator;
        case "declined":
            return $89f342f56d6979d8$var$DeclinedIndicator;
        case "locked":
            return $89f342f56d6979d8$var$LockedIndicator;
    }
}
/**
 * __Avatar status__
 *
 * An avatar status shows contextual information, such as if someone approves or declines something.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-status/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-status/code)
 */ var $89f342f56d6979d8$var$AvatarStatus = function AvatarStatus(_ref) {
    var borderColor = _ref.borderColor, children = _ref.children, status = _ref.status;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $enUkA.default), {
        bgColor: borderColor,
        label: typeof status === "string" ? status : undefined
    }, status ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("svg", {
        "aria-hidden": "true",
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $89f342f56d6979d8$var$getStatus(status)) : children);
};
var $89f342f56d6979d8$export$2e2bcd8739ae039 = $89f342f56d6979d8$var$AvatarStatus;
var $89f342f56d6979d8$export$8045894f255f9726 = function StatusWrapper(_ref2) {
    var size = _ref2.size, status = _ref2.status, appearance = _ref2.appearance, borderColor = _ref2.borderColor, children = _ref2.children, testId = _ref2.testId;
    var position = appearance === "square" ? 0 : (0, $jsG43.ICON_OFFSET)[size];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && "".concat(testId, "--status"),
        style: {
            position: "absolute",
            height: "".concat((0, $jsG43.ICON_SIZES)[size], "px"),
            right: "".concat(position, "px"),
            top: "".concat(position, "px"),
            width: "".concat((0, $jsG43.ICON_SIZES)[size], "px")
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement($89f342f56d6979d8$var$AvatarStatus, {
        borderColor: borderColor,
        status: !children ? status : undefined
    }, children));
};

});

parcelRegister("c15dP", function(module, exports) {

$parcel$export(module.exports, "getLinkProps", function () { return $8bf9a105bb759098$export$60113ebe1cf0ecf; });
$parcel$export(module.exports, "getButtonProps", function () { return $8bf9a105bb759098$export$cca6f1bef43616d3; });
$parcel$export(module.exports, "getCustomElement", function () { return $8bf9a105bb759098$export$83ee468102cdf04c; });
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match
var $8bf9a105bb759098$export$60113ebe1cf0ecf = function getLinkProps(href, target) {
    return {
        href: href,
        rel: target === "_blank" ? "noopener noreferrer" : null,
        target: target
    };
};
var $8bf9a105bb759098$export$cca6f1bef43616d3 = function getButtonProps(onClick) {
    return {
        type: "button",
        onClick: onClick
    };
};
var $8bf9a105bb759098$export$83ee468102cdf04c = function getCustomElement(isDisabled, href, onClick) {
    if (href && !isDisabled) return "a";
    if (onClick || isDisabled) return "button";
    return "span";
};

});


parcelRegister("axDQK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7acbe5c9e47a56bf$export$2e2bcd8739ae039; });

var $fjkYW = parcelRequire("fjkYW");

var $e6gyJ = parcelRequire("e6gyJ");

var $jjExS = parcelRequire("jjExS");

var $1Mpn7 = parcelRequire("1Mpn7");

var $fBy54 = parcelRequire("fBy54");

var $12aDa = parcelRequire("12aDa");

var $8CHgt = parcelRequire("8CHgt");

var $x0QfA = parcelRequire("x0QfA");

var $4dgUA = parcelRequire("4dgUA");

var $6Pwhd = parcelRequire("6Pwhd");
var $gR05m = parcelRequire("gR05m");

var $gpTNI = parcelRequire("gpTNI");

var $ixpGB = parcelRequire("ixpGB");

var $kgCaS = parcelRequire("kgCaS");

var $lUOJ8 = parcelRequire("lUOJ8");

var $88RqW = parcelRequire("88RqW");

var $fRMN4 = parcelRequire("fRMN4");

var $hewdT = parcelRequire("hewdT");

var $e8FQQ = parcelRequire("e8FQQ");
function $7acbe5c9e47a56bf$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7acbe5c9e47a56bf$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7acbe5c9e47a56bf$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7acbe5c9e47a56bf$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7acbe5c9e47a56bf$var$tooltipZIndex = (0, $lUOJ8.layers).tooltip();
var $7acbe5c9e47a56bf$var$analyticsAttributes = {
    componentName: "tooltip",
    packageName: "@atlaskit/tooltip",
    packageVersion: "17.8.8"
};
// Inverts motion direction
var $7acbe5c9e47a56bf$var$invertedDirection = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param position - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $7acbe5c9e47a56bf$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split("-")[0];
};
function $7acbe5c9e47a56bf$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? "bottom" : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? "bottom" : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $hewdT.default) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? "div" : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $x0QfA.default) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $x0QfA.default) : _ref$onHide, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "fixed" : _ref$strategy;
    var tooltipPosition = position === "mouse" ? mousePosition : position;
    var onShowHandler = (0, $8CHgt.usePlatformLeafSyntheticEventHandler)($7acbe5c9e47a56bf$var$_objectSpread({
        fn: onShow,
        action: "displayed",
        analyticsData: analyticsContext
    }, $7acbe5c9e47a56bf$var$analyticsAttributes));
    var onHideHandler = (0, $8CHgt.usePlatformLeafSyntheticEventHandler)($7acbe5c9e47a56bf$var$_objectSpread({
        fn: onHide,
        action: "hidden",
        analyticsData: analyticsContext
    }, $7acbe5c9e47a56bf$var$analyticsAttributes));
    var apiRef = (0, $1Mpn7.useRef)(null);
    var _useState = (0, $1Mpn7.useState)("hide"), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($e6gyJ)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $1Mpn7.useRef)(null);
    var containerRef = (0, $1Mpn7.useRef)(null);
    var hasFunctionalChildren = typeof children === "function"; // Stored to keep our `setRef` callback cleaner.
    var setRef = (0, $1Mpn7.useCallback)(function(node) {
        if (!node) return;
        if (hasFunctionalChildren) targetRef.current = node;
        else {
            containerRef.current = node;
            targetRef.current = node.firstChild;
        }
    }, [
        hasFunctionalChildren
    ]);
    // Putting a few things into refs so that we don't have to break memoization
    var lastState = (0, $1Mpn7.useRef)(state);
    var lastDelay = (0, $1Mpn7.useRef)(delay);
    var lastHandlers = (0, $1Mpn7.useRef)({
        onShowHandler: onShowHandler,
        onHideHandler: onHideHandler
    });
    var hasCalledShowHandler = (0, $1Mpn7.useRef)(false);
    (0, $1Mpn7.useEffect)(function() {
        lastState.current = state;
        lastDelay.current = delay;
        lastHandlers.current = {
            onShowHandler: onShowHandler,
            onHideHandler: onHideHandler
        };
    }, [
        delay,
        onHideHandler,
        onShowHandler,
        state
    ]);
    var start = (0, $1Mpn7.useCallback)(function(api) {
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $1Mpn7.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) lastHandlers.current.onHideHandler();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState("hide");
    }, []);
    var abort = (0, $1Mpn7.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) lastHandlers.current.onHideHandler();
        // @ts-ignore
        apiRef.current = null;
    }, []);
    (0, $1Mpn7.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var showTooltip = (0, $1Mpn7.useCallback)(function(source) {
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // Tell the tooltip to keep showing
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        var entry = {
            source: source,
            delay: lastDelay.current,
            show: function show(_ref2) {
                var isImmediate = _ref2.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    lastHandlers.current.onShowHandler();
                }
                setState(isImmediate ? "show-immediate" : "fade-in");
            },
            hide: function hide(_ref3) {
                var isImmediate = _ref3.isImmediate;
                if (isImmediate) setState("hide");
                else setState("before-fade-out");
            },
            done: done
        };
        var api = (0, $88RqW.show)(entry);
        start(api);
    }, [
        abort,
        done,
        start
    ]);
    var hideTooltipOnEsc = (0, $1Mpn7.useCallback)(function() {
        var _apiRef$current;
        (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $4dgUA.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === "hide" || state === "fade-out"
    });
    (0, $1Mpn7.useEffect)(function() {
        if (state === "hide") return 0, $x0QfA.default;
        if (state === "before-fade-out") setState("fade-out");
        var unbind = (0, $12aDa.bind)(window, {
            type: "scroll",
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $1Mpn7.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $1Mpn7.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $1Mpn7.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = position === "mouse" ? {
            type: "mouse",
            // TODO: ideally not recalculating this object each time
            mouse: (0, $e8FQQ.getMousePosition)({
                left: event.clientX,
                top: event.clientY
            })
        } : {
            type: "keyboard"
        };
        showTooltip(source);
    }, [
        position,
        showTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $1Mpn7.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = position === "mouse" ? function onMouseMove(event) {
        var _apiRef$current2;
        if ((_apiRef$current2 = apiRef.current) !== null && _apiRef$current2 !== void 0 && _apiRef$current2.isActive()) apiRef.current.mousePosition = (0, $e8FQQ.getMousePosition)({
            left: event.clientX,
            top: event.clientY
        });
    } : undefined;
    var onMouseOverTooltip = (0, $1Mpn7.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $1Mpn7.useCallback)(function() {
        showTooltip({
            type: "keyboard"
        });
    }, [
        showTooltip
    ]);
    var onBlur = (0, $1Mpn7.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $1Mpn7.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === "exiting" && lastState.current === "fade-out" && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, []);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipContainer = state !== "hide" && Boolean(content);
    var shouldRenderTooltipChildren = state !== "hide" && state !== "fade-out";
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current3;
        if (position === "mouse" && (_apiRef$current3 = apiRef.current) !== null && _apiRef$current3 !== void 0 && _apiRef$current3.mousePosition) {
            var _apiRef$current4;
            return (_apiRef$current4 = apiRef.current) === null || _apiRef$current4 === void 0 ? void 0 : _apiRef$current4.mousePosition;
        }
        return targetRef.current || undefined;
    };
    var tooltipId = (0, $fRMN4.default)("tooltip", shouldRenderTooltipContainer);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        ref: setRef
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // @ts-expect-error - Adding `data-testid` to the TriggerProps interface breaks Buttons.
    tooltipTriggerProps["data-testid"] = "".concat(testId, "--container");
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    (0, $1Mpn7.useEffect)(function() {
        // If there is no container element, we should exit early, because that
        // means they are using the render prop API, and that is implemented in a
        // different way. If there is no target element yet or tooltipId, we also
        // shouldn't do anything because there is nothing to operate on or with.
        if (!containerRef.current || !targetRef.current || !tooltipId) return;
        // Necessary for TS to know that it has the attribute methods
        var target = targetRef.current;
        if (shouldRenderTooltipContainer) target.setAttribute("aria-describedby", tooltipId);
        else target.removeAttribute("aria-describedby");
    }, [
        shouldRenderTooltipContainer,
        tooltipId
    ]);
    return (0, $fBy54.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).Fragment, null, typeof children === "function" ? // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    children($7acbe5c9e47a56bf$var$_objectSpread($7acbe5c9e47a56bf$var$_objectSpread({}, tooltipTriggerProps), {}, {
        "aria-describedby": tooltipId
    })) : (0, $fBy54.jsx)(CastTargetContainer, (0, (/*@__PURE__*/$parcel$interopDefault($fjkYW)))({}, tooltipTriggerProps, {
        role: "presentation"
    }), children), shouldRenderTooltipContainer ? (0, $fBy54.jsx)((0, $kgCaS.default), {
        zIndex: $7acbe5c9e47a56bf$var$tooltipZIndex
    }, (0, $fBy54.jsx)((0, $ixpGB.Popper), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref4) {
        var ref = _ref4.ref, style = _ref4.style, update = _ref4.update, placement = _ref4.placement;
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        var direction = position === "mouse" ? undefined : $7acbe5c9e47a56bf$var$invertedDirection[$7acbe5c9e47a56bf$var$getDirectionFromPlacement(placement)];
        return (0, $fBy54.jsx)((0, $6Pwhd.default), {
            appear: true
        }, shouldRenderTooltipChildren && (0, $fBy54.jsx)((0, $gR05m.default), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state === "show-immediate" ? 0 : (0, $gpTNI.mediumDurationMs)
        }, function(_ref5) {
            var className = _ref5.className;
            return (0, $fBy54.jsx)(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: style,
                truncate: truncate,
                placement: tooltipPosition,
                testId: testId,
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip,
                id: tooltipId
            }, typeof content === "function" ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
$7acbe5c9e47a56bf$var$Tooltip.displayName = "Tooltip";
var $7acbe5c9e47a56bf$export$2e2bcd8739ae039 = $7acbe5c9e47a56bf$var$Tooltip;

});
parcelRegister("8CHgt", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", function () { return $64736ed3d1b30e44$export$1a04351537078b55; });

var $jjExS = parcelRequire("jjExS");

var $1Mpn7 = parcelRequire("1Mpn7");

var $145N3 = parcelRequire("145N3");

var $8JCSe = parcelRequire("8JCSe");
function $64736ed3d1b30e44$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $64736ed3d1b30e44$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $64736ed3d1b30e44$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $64736ed3d1b30e44$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $64736ed3d1b30e44$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $145N3.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $8JCSe.useTrackedRef)(analyticsData);
    var fnRef = (0, $8JCSe.useTrackedRef)(fn);
    var handler = (0, $1Mpn7.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $64736ed3d1b30e44$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("4dgUA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31157ea48576449e$export$2e2bcd8739ae039; });

var $1Mpn7 = parcelRequire("1Mpn7");

var $12aDa = parcelRequire("12aDa");

var $lEgiY = parcelRequire("lEgiY");
function $31157ea48576449e$export$2e2bcd8739ae039(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $1Mpn7.useRef)(false);
    var onKeyDown = (0, $1Mpn7.useCallback)(function(e) {
        if (isDisabled || escapePressed.current || e.key !== (0, $lEgiY.ESCAPE)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    var onKeyUp = (0, $1Mpn7.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $1Mpn7.useEffect)(function() {
        return (0, $12aDa.bindAll)(document, [
            {
                type: "keydown",
                listener: onKeyDown
            },
            {
                type: "keyup",
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}

});
parcelRegister("lEgiY", function(module, exports) {

$parcel$export(module.exports, "KEY_UP", function () { return $fc29fb36f636f3b0$export$390330c10ff2b9a1; });
$parcel$export(module.exports, "KEY_DOWN", function () { return $fc29fb36f636f3b0$export$a80636c6f41931fe; });
$parcel$export(module.exports, "KEY_HOME", function () { return $fc29fb36f636f3b0$export$4af703091671bc; });
$parcel$export(module.exports, "KEY_END", function () { return $fc29fb36f636f3b0$export$e2bc30913faa5db7; });
$parcel$export(module.exports, "ESCAPE", function () { return $fc29fb36f636f3b0$export$2bb790b9008907b4; });
/**
 * Character key codes which can be used in keyboard events.
 */ var $fc29fb36f636f3b0$export$390330c10ff2b9a1 = "ArrowUp";
var $fc29fb36f636f3b0$export$a80636c6f41931fe = "ArrowDown";
var $fc29fb36f636f3b0$export$4af703091671bc = "Home";
var $fc29fb36f636f3b0$export$e2bc30913faa5db7 = "End";
var $fc29fb36f636f3b0$export$2bb790b9008907b4 = "Escape";

});


parcelRegister("6Pwhd", function(module, exports) {

$parcel$export(module.exports, "useExitingPersistence", function () { return $4f908af2bddfa95f$export$3b6f38abbdcbd000; });
$parcel$export(module.exports, "default", function () { return $4f908af2bddfa95f$export$2e2bcd8739ae039; });

var $1Mpn7 = parcelRequire("1Mpn7");

var $c3bvG = parcelRequire("c3bvG");

var $5LhU5 = parcelRequire("5LhU5");
/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $4f908af2bddfa95f$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
var $4f908af2bddfa95f$var$ExitingContext = /*#__PURE__*/ (0, $1Mpn7.createContext)($4f908af2bddfa95f$var$emptyContext);
var $4f908af2bddfa95f$var$isAnyPreviousKeysMissingFromCurrent = function isAnyPreviousKeysMissingFromCurrent(currentMap, previous) {
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMap[_key]) return true;
    }
    return false;
};
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $4f908af2bddfa95f$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $4f908af2bddfa95f$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement($4f908af2bddfa95f$var$ExitingContext.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
var $4f908af2bddfa95f$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $4f908af2bddfa95f$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $4f908af2bddfa95f$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $4f908af2bddfa95f$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $1Mpn7.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== "boolean" && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
/**
 * This handles the case when a render updates during an exit motion.
 * If any child is mounted again we removed them from the exiting children object and return true.
 */ var $4f908af2bddfa95f$var$hasAnyExitingChildMountedAgain = function hasAnyExitingChildMountedAgain(exitingChildren, children) {
    var exitingChildMountedAgain = false;
    children.forEach(function(child) {
        if (exitingChildren.current[child.key]) {
            exitingChildMountedAgain = true;
            delete exitingChildren.current[child.key];
        }
    });
    return exitingChildMountedAgain;
};
/**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $4f908af2bddfa95f$var$ExitingPersistence = /*#__PURE__*/ (0, $1Mpn7.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appearFromProp = _ref$appear === void 0 ? false : _ref$appear, childs = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var children = $4f908af2bddfa95f$var$childrenToArray(childs);
    var childrenObj = $4f908af2bddfa95f$var$childrenToObj(children);
    var previousChildren = (0, $1Mpn7.useRef)([]);
    var persistedChildren = (0, $1Mpn7.useRef)([]);
    var forceRender = (0, $5LhU5.useForceRender)();
    var exitingChildren = (0, $1Mpn7.useRef)({});
    var appear = (0, $1Mpn7.useRef)(appearFromProp);
    var defaultContextValue = (0, $1Mpn7.useMemo)(function() {
        return {
            appear: appear.current,
            isExiting: false
        };
    }, // React rules of hooks says this isn't needed because mutating appear won't cause a re-render.
    // While technically true - it will trigger this to make a new object on the _next_ render which is what we want.
    // Remove this or use appear instead of appear.current and you will notice a test breaks.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        appear.current
    ]);
    if ((0, $c3bvG.isReducedMotion)()) return children;
    if (!appear.current) // We always want child motions to appear after the initial mount.
    appear.current = true;
    // This entire block can't be an effect because we need it to run synchronously during a render
    // else when elements are being removed they will be remounted instead of being updated.
    if (previousChildren.current.length && $4f908af2bddfa95f$var$isAnyPreviousKeysMissingFromCurrent(childrenObj, previousChildren.current)) {
        if (persistedChildren.current.length === 0 || $4f908af2bddfa95f$var$hasAnyExitingChildMountedAgain(exitingChildren, children)) persistedChildren.current = previousChildren.current;
        // We have persisted children now set from previous children.
        // Let's update previous children so we have it available next render.
        previousChildren.current = children;
        return (exitThenEnter ? persistedChildren.current : $4f908af2bddfa95f$var$spliceNewElementsIntoPrevious(children, persistedChildren.current)).map(function(child) {
            // eslint-disable-next-line @repo/internal/react/no-children-properties-access
            var currentChild = childrenObj[child.key];
            if (!currentChild) {
                // We've found an exiting child - mark it!
                exitingChildren.current[child.key] = true;
                return $4f908af2bddfa95f$var$wrapChildWithContextProvider(child, {
                    isExiting: true,
                    appear: true,
                    onFinish: function onFinish() {
                        delete exitingChildren.current[child.key];
                        // We will only remove the exiting elements when any subsequent exiting elements have also finished.
                        // Think of removing many items from a todo list - when removing a few over a few clicks we don't
                        // want the list jumping around when they exit.
                        if (Object.keys(exitingChildren.current).length === 0) {
                            // Set previous children to nothing.
                            // This let's us skip the next render check as it's assumed children and previous will be the same.
                            previousChildren.current = [];
                            persistedChildren.current = [];
                            // Re-render after the element(s) have animated away which will end up rendering the latest children.
                            forceRender();
                        }
                    }
                });
            }
            // This element isn't exiting.
            // Wrap context and let's continue on our way.
            return $4f908af2bddfa95f$var$wrapChildWithContextProvider(currentChild, defaultContextValue);
        });
    } else previousChildren.current = children;
    return children.map(function(child) {
        return $4f908af2bddfa95f$var$wrapChildWithContextProvider(child, defaultContextValue);
    });
});
var $4f908af2bddfa95f$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $1Mpn7.useContext)($4f908af2bddfa95f$var$ExitingContext);
};
$4f908af2bddfa95f$var$ExitingPersistence.displayName = "ExitingPersistence";
var $4f908af2bddfa95f$export$2e2bcd8739ae039 = $4f908af2bddfa95f$var$ExitingPersistence;

});
parcelRegister("c3bvG", function(module, exports) {

$parcel$export(module.exports, "isReducedMotion", function () { return $8c5eb17f686b9ae7$export$b7baf7667a68d87c; });
$parcel$export(module.exports, "reduceMotionAsPerUserPreference", function () { return $8c5eb17f686b9ae7$export$f0f789643ba5a83c; });

var $e6gyJ = parcelRequire("e6gyJ");

var $1Mpn7 = parcelRequire("1Mpn7");

var $12aDa = parcelRequire("12aDa");
var $8c5eb17f686b9ae7$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== "undefined" && "matchMedia" in window;
};
var $8c5eb17f686b9ae7$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$8c5eb17f686b9ae7$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia("(prefers-reduced-motion: reduce)"), matches = _window$matchMedia.matches;
    return matches;
};
var $8c5eb17f686b9ae7$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $1Mpn7.useState)($8c5eb17f686b9ae7$export$b7baf7667a68d87c), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($e6gyJ)))(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $1Mpn7.useEffect)(function() {
        if (!$8c5eb17f686b9ae7$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia("(prefers-reduced-motion: reduce)");
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $12aDa.bind)(mediaQueryList, {
            type: "change",
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $8c5eb17f686b9ae7$export$f0f789643ba5a83c = {
    "@media (prefers-reduced-motion: reduce)": {
        animation: "none",
        transition: "none"
    }
};
var $8c5eb17f686b9ae7$export$ff7706047246b98b = function prefersReducedMotion() {
    return $8c5eb17f686b9ae7$export$f0f789643ba5a83c;
};

});

parcelRegister("5LhU5", function(module, exports) {

$parcel$export(module.exports, "useForceRender", function () { return $431f3acc46710e49$export$b902f6ef73d6633a; });

var $e6gyJ = parcelRequire("e6gyJ");

var $1Mpn7 = parcelRequire("1Mpn7");
var $431f3acc46710e49$export$b902f6ef73d6633a = function useForceRender() {
    var _useState = (0, $1Mpn7.useState)({}), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($e6gyJ)))(_useState, 2), updateState = _useState2[1];
    var forceRender = (0, $1Mpn7.useCallback)(function() {
        return updateState({});
    }, []);
    return forceRender;
};

});


parcelRegister("gR05m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c451a98f8af7c353$export$2e2bcd8739ae039; });

var $jjExS = parcelRequire("jjExS");

var $1Mpn7 = parcelRequire("1Mpn7");

var $5QhfL = parcelRequire("5QhfL");

var $gpTNI = parcelRequire("gpTNI");

var $cIAml = parcelRequire("cIAml");
function $c451a98f8af7c353$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c451a98f8af7c353$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c451a98f8af7c353$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c451a98f8af7c353$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c451a98f8af7c353$var$directionMotions = {
    proportional: {
        bottom: "translate3d(0, calc(5% + 4px), 0)",
        left: "translate3d(calc(-5% - 4px), 0, 0)",
        right: "translate3d(calc(5% + 4px), 0, 0)",
        top: "translate3d(0, calc(-5% - 4px), 0)"
    },
    constant: {
        bottom: "translate3d(0, 4px, 0)",
        left: "translate3d(-4px, 0, 0)",
        right: "translate3d(4px, 0, 0)",
        top: "translate3d(0, -4px, 0)"
    }
};
var $c451a98f8af7c353$var$invertedDirection = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
var $c451a98f8af7c353$export$8497679fcaaeceb = function fadeInAnimation(direction) {
    var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "proportional";
    return {
        from: $c451a98f8af7c353$var$_objectSpread({
            opacity: 0
        }, direction !== undefined && {
            transform: $c451a98f8af7c353$var$directionMotions[distance][direction]
        }),
        "50%": {
            opacity: 1
        },
        to: {
            transform: direction !== undefined ? "none" : undefined
        }
    };
};
var $c451a98f8af7c353$export$c9190c6659ea755b = function fadeOutAnimation(direction) {
    var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "proportional";
    return {
        from: {
            opacity: 1,
            transform: direction !== undefined ? "translate3d(0, 0, 0)" : undefined
        },
        to: $c451a98f8af7c353$var$_objectSpread({
            opacity: 0
        }, direction !== undefined && {
            transform: $c451a98f8af7c353$var$directionMotions[distance][direction]
        })
    };
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $c451a98f8af7c353$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? (0, $gpTNI.largeDurationMs) : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? "proportional" : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection && $c451a98f8af7c353$var$invertedDirection[entranceDirection];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $cIAml.default), {
        duration: duration,
        enteringAnimation: $c451a98f8af7c353$export$8497679fcaaeceb(entranceDirection, distance),
        exitingAnimation: $c451a98f8af7c353$export$c9190c6659ea755b(exitDirection || invertedEntranceDirection, distance),
        animationTimingFunction: function animationTimingFunction() {
            return 0, $5QhfL.easeInOut;
        },
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $c451a98f8af7c353$export$2e2bcd8739ae039 = $c451a98f8af7c353$var$FadeIn;

});
parcelRegister("5QhfL", function(module, exports) {

$parcel$export(module.exports, "easeInOut", function () { return $440f3139bcb438f6$export$c07234257a03d5e9; });
var $440f3139bcb438f6$export$c07234257a03d5e9 = "cubic-bezier(0.15,1,0.3,1)";
var $440f3139bcb438f6$export$57636bb43b1ccbb0 = "cubic-bezier(0.2,0,0,1)";
var $440f3139bcb438f6$export$929e5a82286172a6 = "cubic-bezier(0.8,0,0,0.8)";

});

parcelRegister("gpTNI", function(module, exports) {

$parcel$export(module.exports, "mediumDurationMs", function () { return $bf3a440e0a0c72a3$export$6fa259be09e118a7; });
$parcel$export(module.exports, "largeDurationMs", function () { return $bf3a440e0a0c72a3$export$9424640c29bc466d; });
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $bf3a440e0a0c72a3$export$368bacef0dacbe05 = 25;
var $bf3a440e0a0c72a3$export$2023a81c8547415f = $bf3a440e0a0c72a3$export$368bacef0dacbe05 * 4;
var $bf3a440e0a0c72a3$export$6fa259be09e118a7 = $bf3a440e0a0c72a3$export$368bacef0dacbe05 * 14;
var $bf3a440e0a0c72a3$export$9424640c29bc466d = $bf3a440e0a0c72a3$export$368bacef0dacbe05 * 28;

});

parcelRegister("cIAml", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9425cc516acfd37b$export$2e2bcd8739ae039; });

var $jjExS = parcelRequire("jjExS");

var $e6gyJ = parcelRequire("e6gyJ");

var $1Mpn7 = parcelRequire("1Mpn7");

var $fBy54 = parcelRequire("fBy54");

var $c3bvG = parcelRequire("c3bvG");

var $gpTNI = parcelRequire("gpTNI");

var $cFhHw = parcelRequire("cFhHw");

var $6Pwhd = parcelRequire("6Pwhd");

var $bJV4T = parcelRequire("bJV4T");
function $9425cc516acfd37b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9425cc516acfd37b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9425cc516acfd37b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9425cc516acfd37b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * Used to multiply the initial duration for exiting motions.
 */ var $9425cc516acfd37b$var$EXITING_MOTION_MULTIPLIER = 0.5;
/**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $9425cc516acfd37b$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, enteringAnimation = _ref.enteringAnimation, exitingAnimation = _ref.exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? (0, $gpTNI.largeDurationMs) : _ref$duration;
    var staggered = (0, $bJV4T.useStaggeredEntrance)();
    var _useExitingPersistenc = (0, $6Pwhd.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $cFhHw.useSetTimeout)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? "exiting" : "entering";
    var _useState = (0, $1Mpn7.useState)(appear), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($e6gyJ)))(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $1Mpn7.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        setTimeout(function() {
            if (state === "exiting") onExitFinished && onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion && onFinishMotion(state);
        }, isExiting ? duration * $9425cc516acfd37b$var$EXITING_MOTION_MULTIPLIER : duration + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $fBy54.ClassNames), null, function(_ref2) {
        var css = _ref2.css;
        return children({
            ref: staggered.ref,
            className: hasAnimationStyles ? css($9425cc516acfd37b$var$_objectSpread($9425cc516acfd37b$var$_objectSpread({}, (0, $c3bvG.reduceMotionAsPerUserPreference)), {}, {
                animationDelay: "".concat(delay, "ms"),
                animationDuration: "".concat(isExiting ? duration * $9425cc516acfd37b$var$EXITING_MOTION_MULTIPLIER : duration, "ms"),
                animationFillMode: isExiting ? "forwards" : "backwards",
                animationName: "".concat((0, $fBy54.keyframes)(isExiting ? exitingAnimation || enteringAnimation : enteringAnimation)),
                animationPlayState: paused ? "paused" : "running",
                animationTimingFunction: animationTimingFunction(state)
            })) : ""
        }, state);
    });
};
var $9425cc516acfd37b$export$2e2bcd8739ae039 = $9425cc516acfd37b$var$EnteringMotion;

});
parcelRegister("cFhHw", function(module, exports) {

$parcel$export(module.exports, "useSetTimeout", function () { return $93870b6fa71923a4$export$4f34107a2b00f39c; });

var $1Mpn7 = parcelRequire("1Mpn7");
var $93870b6fa71923a4$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case "next-effect":
            return undefined;
        case "unmount":
        default:
            return [];
    }
};
var $93870b6fa71923a4$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: "unmount"
    };
    var frames = (0, $1Mpn7.useRef)([]);
    (0, $1Mpn7.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $93870b6fa71923a4$var$getHookDeps(opts));
    return (0, $1Mpn7.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var $93870b6fa71923a4$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: "unmount"
    };
    var timeouts = (0, $1Mpn7.useRef)([]);
    (0, $1Mpn7.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $93870b6fa71923a4$var$getHookDeps(opts));
    return (0, $1Mpn7.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};

});

parcelRegister("bJV4T", function(module, exports) {

$parcel$export(module.exports, "useStaggeredEntrance", function () { return $88c02c303efed704$export$25c7213fc07ec080; });

var $e6gyJ = parcelRequire("e6gyJ");

var $1Mpn7 = parcelRequire("1Mpn7");

var $x0QfA = parcelRequire("x0QfA");

var $fMe3p = parcelRequire("fMe3p");

var $c7KS8 = parcelRequire("c7KS8");
var $88c02c303efed704$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $1Mpn7.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $x0QfA.default)
    };
});
var $88c02c303efed704$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $c7KS8.useUniqueId)();
    var context = (0, $1Mpn7.useContext)($88c02c303efed704$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $88c02c303efed704$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? "responsive" : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $1Mpn7.useRef)([]);
    var indexes = [];
    var _useState = (0, $1Mpn7.useState)(function() {
        if (typeof columns === "number") // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === "number") // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($e6gyJ)))(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $fMe3p.useLayoutEffect)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === "responsive" && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement($88c02c303efed704$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var $88c02c303efed704$export$2e2bcd8739ae039 = $88c02c303efed704$var$StaggeredEntrance;

});
parcelRegister("fMe3p", function(module, exports) {

$parcel$export(module.exports, "useLayoutEffect", function () { return $b7c63d83cc504a8b$export$e5c5a5f917a5871c; });

var $1Mpn7 = parcelRequire("1Mpn7");
var $b7c63d83cc504a8b$export$e5c5a5f917a5871c = typeof window === "undefined" ? (0, $1Mpn7.useEffect) : (0, $1Mpn7.useLayoutEffect);

});

parcelRegister("c7KS8", function(module, exports) {

$parcel$export(module.exports, "useUniqueId", function () { return $8d3a7f4be05c215b$export$c485849f2e393253; });
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $1Mpn7 = parcelRequire("1Mpn7");
function $8d3a7f4be05c215b$export$c485849f2e393253() {
    var identifier = (0, $1Mpn7.useRef)("");
    if (!identifier.current) identifier.current = "_" + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

});




parcelRegister("kgCaS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec12e9f089b260e3$export$2e2bcd8739ae039; });

var $1Mpn7 = parcelRequire("1Mpn7");

var $7YXIE = parcelRequire("7YXIE");

var $adRG0 = parcelRequire("adRG0");

var $4BGm3 = parcelRequire("4BGm3");
function $ec12e9f089b260e3$export$2e2bcd8739ae039(props) {
    var _props$zIndex = props.zIndex, zIndex = _props$zIndex === void 0 ? 0 : _props$zIndex, children = props.children;
    var isSubsequentRender = (0, $adRG0.default)();
    (0, $4BGm3.default)(zIndex);
    return isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $7YXIE.default), {
        zIndex: zIndex
    }, children) : null;
}

});
parcelRegister("7YXIE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5cfc75f9dd0ea79a$export$2e2bcd8739ae039; });

var $1Mpn7 = parcelRequire("1Mpn7");

var $eaouD = parcelRequire("eaouD");

var $fgbos = parcelRequire("fgbos");
function $5cfc75f9dd0ea79a$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var container = (0, $1Mpn7.useMemo)(function() {
        return (0, $fgbos.createContainer)(zIndex);
    }, [
        zIndex
    ]);
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $fgbos.appendPortalContainerIfNotAppended)(container);
    (0, $1Mpn7.useEffect)(function() {
        return function() {
            (0, $fgbos.removePortalContainer)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $eaouD.createPortal)(children, container);
}

});
parcelRegister("fgbos", function(module, exports) {

$parcel$export(module.exports, "createContainer", function () { return $b1c1301f4ecf2988$export$26ae5ca175b4ec5a; });
$parcel$export(module.exports, "removePortalContainer", function () { return $b1c1301f4ecf2988$export$da99f98bf3fe55b3; });
$parcel$export(module.exports, "appendPortalContainerIfNotAppended", function () { return $b1c1301f4ecf2988$export$c582005add11e141; });

var $3z2YX = parcelRequire("3z2YX");
var $b1c1301f4ecf2988$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement("div");
    container.className = (0, $3z2YX.portalClassName);
    container.style.zIndex = "".concat(zIndex);
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $b1c1301f4ecf2988$var$getBody = function getBody() {
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ var $b1c1301f4ecf2988$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $3z2YX.portalParentSelector));
    if (!parentElement) {
        var parent = document.createElement("div");
        parent.className = (0, $3z2YX.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = "flex";
        $b1c1301f4ecf2988$var$getBody().appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $b1c1301f4ecf2988$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    $b1c1301f4ecf2988$var$getPortalParent().removeChild(container);
};
var $b1c1301f4ecf2988$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $b1c1301f4ecf2988$var$getPortalParent().appendChild(container);
};

});
parcelRegister("3z2YX", function(module, exports) {

$parcel$export(module.exports, "portalParentClassName", function () { return $2986f42c35faef62$export$e4c79eb95c23a0da; });
$parcel$export(module.exports, "portalParentSelector", function () { return $2986f42c35faef62$export$72f415121273627e; });
$parcel$export(module.exports, "portalClassName", function () { return $2986f42c35faef62$export$13f57c02915787b3; });
var $2986f42c35faef62$export$e4c79eb95c23a0da = "atlaskit-portal-container";
var $2986f42c35faef62$export$72f415121273627e = "body > .atlaskit-portal-container";
var $2986f42c35faef62$export$13f57c02915787b3 = "atlaskit-portal";

});



parcelRegister("adRG0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01ebb089a56a63ba$export$2e2bcd8739ae039; });

var $e6gyJ = parcelRequire("e6gyJ");

var $1Mpn7 = parcelRequire("1Mpn7");
var $01ebb089a56a63ba$var$useIsSubsequentRender = function useIsSubsequentRender() {
    var _useState = (0, $1Mpn7.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($e6gyJ)))(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    (0, $1Mpn7.useEffect)(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $01ebb089a56a63ba$export$2e2bcd8739ae039 = $01ebb089a56a63ba$var$useIsSubsequentRender;

});

parcelRegister("4BGm3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $35ab78e224ba4add$export$2e2bcd8739ae039; });

var $1Mpn7 = parcelRequire("1Mpn7");

var $cyJx1 = parcelRequire("cyJx1");

var $eCq5G = parcelRequire("eCq5G");
var $35ab78e224ba4add$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $1Mpn7.useEffect)(function() {
        (0, $eCq5G.default)((0, $cyJx1.PORTAL_MOUNT_EVENT), zIndexNumber);
        return function() {
            (0, $eCq5G.default)((0, $cyJx1.PORTAL_UNMOUNT_EVENT), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $35ab78e224ba4add$export$2e2bcd8739ae039 = $35ab78e224ba4add$var$useFirePortalEvent;

});
parcelRegister("cyJx1", function(module, exports) {

$parcel$export(module.exports, "PORTAL_MOUNT_EVENT", function () { return $924bfaa92cee81e5$export$ed5835cc67e87f72; });
$parcel$export(module.exports, "PORTAL_UNMOUNT_EVENT", function () { return $924bfaa92cee81e5$export$80816bd900e5bd00; });
var $924bfaa92cee81e5$export$ed5835cc67e87f72 = "akPortalMount";
var $924bfaa92cee81e5$export$80816bd900e5bd00 = "akPortalUnmount";

});

parcelRegister("eCq5G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aa48da5d78580a1c$export$2e2bcd8739ae039; });
var $aa48da5d78580a1c$var$zIndexToName = {
    100: "card",
    200: "navigation",
    300: "dialog",
    400: "layer",
    500: "blanket",
    510: "modal",
    600: "flag",
    700: "spotlight",
    9999: "tooltip"
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $aa48da5d78580a1c$var$getLayerName = function getLayerName(zIndex) {
    return $aa48da5d78580a1c$var$zIndexToName.hasOwnProperty(zIndex) ? $aa48da5d78580a1c$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $aa48da5d78580a1c$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $aa48da5d78580a1c$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $aa48da5d78580a1c$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $aa48da5d78580a1c$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}

});



parcelRegister("lUOJ8", function(module, exports) {

$parcel$export(module.exports, "CHANNEL", function () { return $ff462d3e8b158332$export$44ffba16bd48dac6; });
$parcel$export(module.exports, "DEFAULT_THEME_MODE", function () { return $ff462d3e8b158332$export$c93026a968943f95; });
$parcel$export(module.exports, "THEME_MODES", function () { return $ff462d3e8b158332$export$6ba72c8346b4c57e; });
$parcel$export(module.exports, "layers", function () { return $ff462d3e8b158332$export$7be255094ccdc533; });

var $2Eqc7 = parcelRequire("2Eqc7");

var $in1Yt = parcelRequire("in1Yt");
var $ff462d3e8b158332$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $ff462d3e8b158332$export$c93026a968943f95 = "light";
var $ff462d3e8b158332$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $ff462d3e8b158332$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $ff462d3e8b158332$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $ff462d3e8b158332$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $ff462d3e8b158332$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $ff462d3e8b158332$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $ff462d3e8b158332$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $ff462d3e8b158332$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $in1Yt.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $ff462d3e8b158332$export$6d8204c2cb2e06b8() / 4;
    (0, $2Eqc7.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $ff462d3e8b158332$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $ff462d3e8b158332$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $ff462d3e8b158332$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $2Eqc7.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $ff462d3e8b158332$export$ba1d834b86d72a09 = $ff462d3e8b158332$export$a1b3edb637fb4f35;
var $ff462d3e8b158332$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $in1Yt.skeleton)(), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $in1Yt.skeleton)(), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $in1Yt.N30A), ")")
            }
        }
    };
};

});
parcelRegister("in1Yt", function(module, exports) {

$parcel$export(module.exports, "B200", function () { return $d5fbe806e26ae710$export$215b7063051591f1; });
$parcel$export(module.exports, "N0", function () { return $d5fbe806e26ae710$export$29a4f05edc054374; });
$parcel$export(module.exports, "N800", function () { return $d5fbe806e26ae710$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N30A", function () { return $d5fbe806e26ae710$export$920c0d5c49070351; });
$parcel$export(module.exports, "DN600", function () { return $d5fbe806e26ae710$export$5368d76ae4fbbda7; });
$parcel$export(module.exports, "DN0", function () { return $d5fbe806e26ae710$export$3d4f271a500072a; });
$parcel$export(module.exports, "skeleton", function () { return $d5fbe806e26ae710$export$2a0674ff2eb10214; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $igrYN = parcelRequire("igrYN");
var $d5fbe806e26ae710$export$4b84fd0e2c617bd = "#FFEBE6";
var $d5fbe806e26ae710$export$b34b069eff244586 = "#FFBDAD";
var $d5fbe806e26ae710$export$be802dd0d8b57f35 = "#FF8F73";
var $d5fbe806e26ae710$export$60847d42f9da92a6 = "#FF7452";
var $d5fbe806e26ae710$export$4a7404f376229999 = "#FF5630";
var $d5fbe806e26ae710$export$2010d0fb4295b346 = "#DE350B";
var $d5fbe806e26ae710$export$2837b5a1a71d5c02 = "#BF2600";
var $d5fbe806e26ae710$export$8d9596b529bbb9cf = "#FFFAE6";
var $d5fbe806e26ae710$export$41060a744ab0b7ae = "#FFF0B3";
var $d5fbe806e26ae710$export$1cc05bbbf340e559 = "#FFE380";
var $d5fbe806e26ae710$export$5aae31392d72caaa = "#FFC400";
var $d5fbe806e26ae710$export$c6930421db9fa514 = "#FFAB00";
var $d5fbe806e26ae710$export$59619663aa6500fb = "#FF991F";
var $d5fbe806e26ae710$export$874739ea9e379ab6 = "#FF8B00";
var $d5fbe806e26ae710$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $d5fbe806e26ae710$export$69a3bf21b9686c2b = "#ABF5D1";
var $d5fbe806e26ae710$export$afbce1382ec95f73 = "#79F2C0";
var $d5fbe806e26ae710$export$747d86715d4175de = "#57D9A3";
var $d5fbe806e26ae710$export$940e1f69e873f202 = "#36B37E";
var $d5fbe806e26ae710$export$a49394138f7b8e85 = "#00875A";
var $d5fbe806e26ae710$export$6fa04827ac68a4fb = "#006644";
var $d5fbe806e26ae710$export$226de0355ed012f8 = "#DEEBFF";
var $d5fbe806e26ae710$export$8c13c2ee36917869 = "#B3D4FF";
var $d5fbe806e26ae710$export$ecfc1dff386a3e7a = "#4C9AFF";
var $d5fbe806e26ae710$export$215b7063051591f1 = "#2684FF";
var $d5fbe806e26ae710$export$e62e8919cca44969 = "#0065FF";
var $d5fbe806e26ae710$export$b3de0ae08da2ce64 = "#0052CC";
var $d5fbe806e26ae710$export$a6ee3d71bc067634 = "#0747A6";
var $d5fbe806e26ae710$export$363e4475840015bb = "#EAE6FF";
var $d5fbe806e26ae710$export$4b0a4417ed59760f = "#C0B6F2";
var $d5fbe806e26ae710$export$6011520a64d9a187 = "#998DD9";
var $d5fbe806e26ae710$export$a7175d4e9206bc80 = "#8777D9";
var $d5fbe806e26ae710$export$b48405b95304b5a1 = "#6554C0";
var $d5fbe806e26ae710$export$c71e4279dd54a18d = "#5243AA";
var $d5fbe806e26ae710$export$147899de772240ec = "#403294";
var $d5fbe806e26ae710$export$2cf711fe14c66f06 = "#E6FCFF";
var $d5fbe806e26ae710$export$7a8f4d33f6f9772c = "#B3F5FF";
var $d5fbe806e26ae710$export$776c9c497ef08533 = "#79E2F2";
var $d5fbe806e26ae710$export$69cb3ca10c1e330e = "#00C7E6";
var $d5fbe806e26ae710$export$9dc1ef0f3f48059b = "#00B8D9";
var $d5fbe806e26ae710$export$7c835c78b6fcdef8 = "#00A3BF";
var $d5fbe806e26ae710$export$6036577f95c3877e = "#008DA6";
var $d5fbe806e26ae710$export$29a4f05edc054374 = "#FFFFFF";
var $d5fbe806e26ae710$export$e655ef011c4aa1a2 = "#FAFBFC";
var $d5fbe806e26ae710$export$9fdfb749e33cdf97 = "#F4F5F7";
var $d5fbe806e26ae710$export$3e51e8f1440314ba = "#EBECF0";
var $d5fbe806e26ae710$export$1ce2d1575d444ceb = "#DFE1E6";
var $d5fbe806e26ae710$export$8754fc7e6d8b3000 = "#C1C7D0";
var $d5fbe806e26ae710$export$c2e91cbeada39b8b = "#B3BAC5";
var $d5fbe806e26ae710$export$5f71e19f3a7ad9de = "#A5ADBA";
var $d5fbe806e26ae710$export$eaa8c8a70ac22806 = "#97A0AF";
var $d5fbe806e26ae710$export$7c87d337fb91a97d = "#8993A4";
var $d5fbe806e26ae710$export$d6447c357493214f = "#7A869A";
var $d5fbe806e26ae710$export$f563ee71e9ee74cd = "#6B778C";
var $d5fbe806e26ae710$export$e2ef2124cf4024b1 = "#5E6C84";
var $d5fbe806e26ae710$export$eece5f492e429f08 = "#505F79";
var $d5fbe806e26ae710$export$c39c0fe0f26207ae = "#42526E";
var $d5fbe806e26ae710$export$7090862dc3038a9f = "#344563";
var $d5fbe806e26ae710$export$ad0bacf983b7ddaa = "#253858";
var $d5fbe806e26ae710$export$7d61b15e0da132af = "#172B4D";
var $d5fbe806e26ae710$export$fbda843f0a27fe96 = "#091E42";
var $d5fbe806e26ae710$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $d5fbe806e26ae710$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $d5fbe806e26ae710$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $d5fbe806e26ae710$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $d5fbe806e26ae710$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $d5fbe806e26ae710$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $d5fbe806e26ae710$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $d5fbe806e26ae710$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $d5fbe806e26ae710$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $d5fbe806e26ae710$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $d5fbe806e26ae710$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $d5fbe806e26ae710$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $d5fbe806e26ae710$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $d5fbe806e26ae710$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $d5fbe806e26ae710$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $d5fbe806e26ae710$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $d5fbe806e26ae710$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $d5fbe806e26ae710$export$2f6319cf7d736c2a = "#E6EDFA";
var $d5fbe806e26ae710$export$95126bc8884d6634 = "#DCE5F5";
var $d5fbe806e26ae710$export$8338d8c35d44ff1 = "#CED9EB";
var $d5fbe806e26ae710$export$5368d76ae4fbbda7 = "#B8C7E0";
var $d5fbe806e26ae710$export$9f0a771d16ec8d36 = "#ABBBD6";
var $d5fbe806e26ae710$export$abcf8c38338b4aa5 = "#9FB0CC";
var $d5fbe806e26ae710$export$97e81faa16a182c7 = "#8C9CB8";
var $d5fbe806e26ae710$export$bfe21c59123ecf33 = "#7988A3";
var $d5fbe806e26ae710$export$ee82aa2ea6a1558 = "#67758F";
var $d5fbe806e26ae710$export$682927c6ed76be02 = "#56637A";
var $d5fbe806e26ae710$export$91fd9994c5be9757 = "#455166";
var $d5fbe806e26ae710$export$d281fbfe3cff2df6 = "#3B475C";
var $d5fbe806e26ae710$export$3902c91d8b98a753 = "#313D52";
var $d5fbe806e26ae710$export$8e8133c1ba5845b5 = "#283447";
var $d5fbe806e26ae710$export$33ff357f6620b39 = "#202B3D";
var $d5fbe806e26ae710$export$633847cf062b69e0 = "#1B2638";
var $d5fbe806e26ae710$export$9776a6e503bdbf76 = "#121A29";
var $d5fbe806e26ae710$export$6c813d5160dff5db = "#0E1624";
var $d5fbe806e26ae710$export$3d4f271a500072a = "#0D1424";
var $d5fbe806e26ae710$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $d5fbe806e26ae710$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $d5fbe806e26ae710$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $d5fbe806e26ae710$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $d5fbe806e26ae710$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $d5fbe806e26ae710$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $d5fbe806e26ae710$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $d5fbe806e26ae710$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $d5fbe806e26ae710$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $d5fbe806e26ae710$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $d5fbe806e26ae710$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $d5fbe806e26ae710$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $d5fbe806e26ae710$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $d5fbe806e26ae710$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $d5fbe806e26ae710$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $d5fbe806e26ae710$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $d5fbe806e26ae710$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $d5fbe806e26ae710$export$8ce1fd94bee2f412 = (0, $igrYN.default)({
    light: "var(--ds-surface, ".concat($d5fbe806e26ae710$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface, ".concat($d5fbe806e26ae710$export$633847cf062b69e0, ")")
});
var $d5fbe806e26ae710$export$b861914ea877b580 = (0, $igrYN.default)({
    light: "var(--ds-background-selected, ".concat($d5fbe806e26ae710$export$226de0355ed012f8, ")"),
    dark: "var(--ds-background-selected, ".concat($d5fbe806e26ae710$export$8c13c2ee36917869, ")")
});
var $d5fbe806e26ae710$export$3f1b020df94387af = (0, $igrYN.default)({
    light: "var(--ds-background-neutral-hovered, ".concat($d5fbe806e26ae710$export$3e51e8f1440314ba, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat($d5fbe806e26ae710$export$d281fbfe3cff2df6, ")")
});
var $d5fbe806e26ae710$export$c0183dbab98ca63e = (0, $igrYN.default)({
    light: "var(--ds-surface-overlay, ".concat($d5fbe806e26ae710$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface-overlay, ".concat($d5fbe806e26ae710$export$8e8133c1ba5845b5, ")")
});
var $d5fbe806e26ae710$export$6f093cfa640b7166 = (0, $igrYN.default)({
    light: "var(--ds-text, ".concat($d5fbe806e26ae710$export$fbda843f0a27fe96, ")"),
    dark: "var(--ds-text, ".concat($d5fbe806e26ae710$export$5368d76ae4fbbda7, ")")
});
var $d5fbe806e26ae710$export$42f8e9c698766e7a = (0, $igrYN.default)({
    light: "var(--ds-text, ".concat($d5fbe806e26ae710$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($d5fbe806e26ae710$export$5368d76ae4fbbda7, ")")
});
var $d5fbe806e26ae710$export$c2d157ca1c34b6e3 = (0, $igrYN.default)({
    light: "var(--ds-text-selected, ".concat($d5fbe806e26ae710$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-text-selected, ".concat($d5fbe806e26ae710$export$b3de0ae08da2ce64, ")")
});
var $d5fbe806e26ae710$export$1905ba28d7cf066f = (0, $igrYN.default)({
    light: "var(--ds-text-subtlest, ".concat($d5fbe806e26ae710$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($d5fbe806e26ae710$export$97e81faa16a182c7, ")")
});
var $d5fbe806e26ae710$export$bd9002130d306d39 = (0, $igrYN.default)({
    light: "var(--ds-text-subtlest, ".concat($d5fbe806e26ae710$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($d5fbe806e26ae710$export$bfe21c59123ecf33, ")")
});
var $d5fbe806e26ae710$export$46e4a324ac90507f = (0, $igrYN.default)({
    light: "var(--ds-text, ".concat($d5fbe806e26ae710$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($d5fbe806e26ae710$export$5368d76ae4fbbda7, ")")
});
var $d5fbe806e26ae710$export$79f3f2b82beb0d36 = (0, $igrYN.default)({
    light: "var(--ds-text-subtlest, ".concat($d5fbe806e26ae710$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($d5fbe806e26ae710$export$97e81faa16a182c7, ")")
});
var $d5fbe806e26ae710$export$7bb0d5c671655cc4 = (0, $igrYN.default)({
    light: $d5fbe806e26ae710$export$9fdfb749e33cdf97,
    dark: $d5fbe806e26ae710$export$8e8133c1ba5845b5
});
var $d5fbe806e26ae710$export$9c30223ca0a664fb = (0, $igrYN.default)({
    light: "var(--ds-link, ".concat($d5fbe806e26ae710$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-link, ".concat($d5fbe806e26ae710$export$ecfc1dff386a3e7a, ")")
});
var $d5fbe806e26ae710$export$7ed258b0728b004b = (0, $igrYN.default)({
    light: "var(--ds-link-pressed, ".concat($d5fbe806e26ae710$export$e62e8919cca44969, ")"),
    dark: "var(--ds-link-pressed, ".concat($d5fbe806e26ae710$export$215b7063051591f1, ")")
});
var $d5fbe806e26ae710$export$dfa920d8decc8a59 = (0, $igrYN.default)({
    light: "var(--ds-link-pressed, ".concat($d5fbe806e26ae710$export$a6ee3d71bc067634, ")"),
    dark: "var(--ds-link-pressed, ".concat($d5fbe806e26ae710$export$ecfc1dff386a3e7a, ")")
});
var $d5fbe806e26ae710$export$6069e6ad5c78f632 = (0, $igrYN.default)({
    light: "var(--ds-border-focused, ".concat($d5fbe806e26ae710$export$215b7063051591f1, ")"),
    dark: "var(--ds-border-focused, ".concat($d5fbe806e26ae710$export$215b7063051591f1, ")")
});
var $d5fbe806e26ae710$export$9ad721cf3b3debe0 = (0, $igrYN.default)({
    light: "var(--ds-background-brand-bold, ".concat($d5fbe806e26ae710$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-background-brand-bold, ".concat($d5fbe806e26ae710$export$ecfc1dff386a3e7a, ")")
});
var $d5fbe806e26ae710$export$2aa0182783e7e9de = (0, $igrYN.default)({
    light: $d5fbe806e26ae710$export$b3de0ae08da2ce64,
    dark: $d5fbe806e26ae710$export$ecfc1dff386a3e7a
});
var $d5fbe806e26ae710$export$8bf7dff220b82b4a = (0, $igrYN.default)({
    light: $d5fbe806e26ae710$export$9dc1ef0f3f48059b,
    dark: $d5fbe806e26ae710$export$69cb3ca10c1e330e
});
var $d5fbe806e26ae710$export$e13cce2a2d16a9d4 = (0, $igrYN.default)({
    light: $d5fbe806e26ae710$export$b48405b95304b5a1,
    dark: $d5fbe806e26ae710$export$6011520a64d9a187
});
var $d5fbe806e26ae710$export$a90204d1394caf30 = (0, $igrYN.default)({
    light: $d5fbe806e26ae710$export$4a7404f376229999,
    dark: $d5fbe806e26ae710$export$4a7404f376229999
});
var $d5fbe806e26ae710$export$594c5a8758200c32 = (0, $igrYN.default)({
    light: $d5fbe806e26ae710$export$c6930421db9fa514,
    dark: $d5fbe806e26ae710$export$c6930421db9fa514
});
var $d5fbe806e26ae710$export$955a2ebd2fb142ae = (0, $igrYN.default)({
    light: $d5fbe806e26ae710$export$940e1f69e873f202,
    dark: $d5fbe806e26ae710$export$940e1f69e873f202
});
var $d5fbe806e26ae710$export$2a0674ff2eb10214 = function skeleton() {
    return "var(--ds-skeleton, ".concat($d5fbe806e26ae710$export$8d43898f60b96a82, ")");
};

});
parcelRegister("igrYN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4bf6cc40ba8b74e$export$2e2bcd8739ae039; });
/* eslint-disable prefer-rest-params */ 
var $hQxzk = parcelRequire("hQxzk");
// Unpack custom variants, and get correct value for the current theme
function $d4bf6cc40ba8b74e$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $hQxzk.default)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return "";
    };
}
function $d4bf6cc40ba8b74e$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === "string") return $d4bf6cc40ba8b74e$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $hQxzk.default)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return "";
    };
}

});
parcelRegister("hQxzk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cfe15515305de68c$export$2e2bcd8739ae039; });

var $lUOJ8 = parcelRequire("lUOJ8");
function $cfe15515305de68c$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $lUOJ8.CHANNEL) in props.theme) return props.theme[0, $lUOJ8.CHANNEL];
        else if ("mode" in props.theme && (0, $lUOJ8.THEME_MODES).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $lUOJ8.DEFAULT_THEME_MODE)
    };
}

});




parcelRegister("88RqW", function(module, exports) {

$parcel$export(module.exports, "show", function () { return $5ed884e3ffca5cd2$export$57bf213be019eeb0; });

var $kYYu3 = parcelRequire("kYYu3");
// This file is a singleton for managing tooltips
var $5ed884e3ffca5cd2$var$active = null;
function $5ed884e3ffca5cd2$export$57bf213be019eeb0(entry) {
    var phase = "waiting-to-show";
    function isActive() {
        return Boolean($5ed884e3ffca5cd2$var$active && $5ed884e3ffca5cd2$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $kYYu3.clearScheduled)();
            $5ed884e3ffca5cd2$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = "done";
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === "waiting-to-hide") {
            phase = "shown";
            (0, $kYYu3.clearScheduled)();
            return;
        }
        // aborting hide animation
        if (phase === "hide-animating") {
            phase = "shown";
            (0, $kYYu3.clearScheduled)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === "waiting-to-show") {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === "waiting-to-hide") return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = "waiting-to-hide";
        (0, $kYYu3.scheduleTimeout)(function() {
            phase = "hide-animating";
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === "hide-animating") done();
    }
    function isVisible() {
        return phase === "shown" || phase === "waiting-to-hide" || phase === "hide-animating";
    }
    function getInitialMouse() {
        if (entry.source.type === "mouse") return entry.source.mouse;
        return null;
    }
    function start() {
        var showImmediately = Boolean($5ed884e3ffca5cd2$var$active && $5ed884e3ffca5cd2$var$active.isVisible());
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($5ed884e3ffca5cd2$var$active) {
            (0, $kYYu3.clearScheduled)();
            $5ed884e3ffca5cd2$var$active.entry.hide({
                isImmediate: true
            });
            $5ed884e3ffca5cd2$var$active.entry.done();
            $5ed884e3ffca5cd2$var$active = null;
        }
        // this tooltip is now the active tooltip
        $5ed884e3ffca5cd2$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = "shown";
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = "waiting-to-show";
        (0, $kYYu3.scheduleTimeout)(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePosition: getInitialMouse()
    };
    return result;
}

});
parcelRegister("kYYu3", function(module, exports) {

$parcel$export(module.exports, "clearScheduled", function () { return $f468540c6c5a43e8$export$eaf678f6f93f5250; });
$parcel$export(module.exports, "scheduleTimeout", function () { return $f468540c6c5a43e8$export$5f4d6617421d489b; });
var $f468540c6c5a43e8$var$delayId = null;
function $f468540c6c5a43e8$export$eaf678f6f93f5250() {
    if ($f468540c6c5a43e8$var$delayId != null) {
        window.clearTimeout($f468540c6c5a43e8$var$delayId);
        $f468540c6c5a43e8$var$delayId = null;
    }
}
function $f468540c6c5a43e8$export$5f4d6617421d489b(fn, delay) {
    $f468540c6c5a43e8$export$eaf678f6f93f5250();
    $f468540c6c5a43e8$var$delayId = window.setTimeout(function() {
        $f468540c6c5a43e8$var$delayId = null;
        fn();
    }, delay);
}

});


parcelRegister("fRMN4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b8d1a705e3b756fa$export$2e2bcd8739ae039; });

var $8KoBN = parcelRequire("8KoBN");
function $b8d1a705e3b756fa$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $8KoBN.useUIDSeed)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}

});
parcelRegister("8KoBN", function(module, exports) {

$parcel$export(module.exports, "useUID", function () { return $65e5b55da3d11c0d$export$87d05f07e65211f1; });
$parcel$export(module.exports, "useUIDSeed", function () { return $65e5b55da3d11c0d$export$bb5ca5fba6fb4f1f; });

var $1Mpn7 = parcelRequire("1Mpn7");

var $l1oNI = parcelRequire("l1oNI");
var $65e5b55da3d11c0d$var$generateUID = function generateUID(context) {
    var quartz = context || (0, $l1oNI.counter);
    var prefix = (0, $l1oNI.getPrefix)(quartz);
    var id = (0, $l1oNI.getId)(quartz);
    var uid = prefix + id;
    var gen = function gen(item) {
        return uid + quartz.uid(item);
    };
    return {
        uid: uid,
        gen: gen
    };
};
var $65e5b55da3d11c0d$var$useUIDState = function useUIDState() {
    var context = (0, $1Mpn7.useContext)((0, $l1oNI.source));
    var uid = (0, $1Mpn7.useState)(function() {
        return $65e5b55da3d11c0d$var$generateUID(context);
    })[0];
    return uid;
};
var $65e5b55da3d11c0d$export$87d05f07e65211f1 = function useUID() {
    var uid = $65e5b55da3d11c0d$var$useUIDState().uid;
    return uid;
};
var $65e5b55da3d11c0d$export$bb5ca5fba6fb4f1f = function useUIDSeed() {
    var gen = $65e5b55da3d11c0d$var$useUIDState().gen;
    return gen;
};

});
parcelRegister("l1oNI", function(module, exports) {

$parcel$export(module.exports, "counter", function () { return $f4dcede6a37297c7$export$e575061ef2a070eb; });
$parcel$export(module.exports, "source", function () { return $f4dcede6a37297c7$export$b4d5da5f34fb77ad; });
$parcel$export(module.exports, "getId", function () { return $f4dcede6a37297c7$export$218c8c3169c024d2; });
$parcel$export(module.exports, "getPrefix", function () { return $f4dcede6a37297c7$export$36e24695f02d4503; });

var $1Mpn7 = parcelRequire("1Mpn7");

var $cuQ94 = parcelRequire("cuQ94");
var $f4dcede6a37297c7$export$1921362e86c73c88 = function createSource(prefix) {
    if (prefix === void 0) prefix = "";
    return {
        value: 1,
        prefix: prefix,
        uid: (0, $cuQ94.generateUID)()
    };
};
var $f4dcede6a37297c7$export$e575061ef2a070eb = $f4dcede6a37297c7$export$1921362e86c73c88();
var $f4dcede6a37297c7$export$b4d5da5f34fb77ad = $1Mpn7.createContext($f4dcede6a37297c7$export$1921362e86c73c88());
var $f4dcede6a37297c7$export$218c8c3169c024d2 = function getId(source) {
    return source.value++;
};
var $f4dcede6a37297c7$export$36e24695f02d4503 = function getPrefix(source) {
    return source ? source.prefix : "";
};

});



parcelRegister("hewdT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c8bcbd48a48a659a$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $1Mpn7 = parcelRequire("1Mpn7");

var $fBy54 = parcelRequire("fBy54");

var $in1Yt = parcelRequire("in1Yt");

var $f9F7m = parcelRequire("f9F7m");

var $hXfnl = parcelRequire("hXfnl");
var $c8bcbd48a48a659a$var$baseStyles = (0, $fBy54.css)({
    boxSizing: "border-box",
    maxWidth: "240px",
    padding: "var(--ds-space-025, 2px)".concat(" ", "var(--ds-space-075, 6px)"),
    insetBlockStart: "var(--ds-space-0, 0px)",
    insetInlineStart: "var(--ds-space-0, 0px)",
    borderRadius: "var(--ds-border-radius, 3px)",
    fontSize: "var(--ds-font-size-075, 12px)",
    lineHeight: 1.3,
    overflowWrap: "break-word",
    wordWrap: "break-word"
});
var $c8bcbd48a48a659a$var$truncateStyles = (0, $fBy54.css)({
    maxWidth: "420px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});
var $c8bcbd48a48a659a$var$lightStyles = (0, $fBy54.css)({
    backgroundColor: "var(--ds-background-neutral-bold, ".concat((0, $in1Yt.N800), ")"),
    color: "var(--ds-text-inverse, ".concat((0, $in1Yt.N0), ")")
});
var $c8bcbd48a48a659a$var$darkStyles = (0, $fBy54.css)({
    backgroundColor: "var(--ds-background-neutral-bold, ".concat((0, $in1Yt.DN0), ")"),
    color: "var(--ds-text-inverse, ".concat((0, $in1Yt.DN600), ")")
});
var $c8bcbd48a48a659a$var$TooltipContainer = /*#__PURE__*/ (0, $1Mpn7.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    return (0, $fBy54.jsx)((0, $f9F7m.default).Consumer, null, function(_ref2) {
        var mode = _ref2.mode;
        return (0, $fBy54.jsx)((0, $hXfnl.default), {
            ref: ref,
            style: style,
            className: className,
            placement: placement,
            testId: testId,
            id: id,
            onMouseOut: onMouseOut,
            onMouseOver: onMouseOver,
            css: [
                $c8bcbd48a48a659a$var$baseStyles,
                truncate ? $c8bcbd48a48a659a$var$truncateStyles : null,
                mode === "light" ? $c8bcbd48a48a659a$var$lightStyles : $c8bcbd48a48a659a$var$darkStyles
            ]
        }, children);
    });
});
$c8bcbd48a48a659a$var$TooltipContainer.displayName = "TooltipContainer";
var $c8bcbd48a48a659a$export$2e2bcd8739ae039 = $c8bcbd48a48a659a$var$TooltipContainer;

});
parcelRegister("f9F7m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b087976128a8e3f7$export$2e2bcd8739ae039; });

var $hhlRQ = parcelRequire("hhlRQ");
// Create default global light theme
var $b087976128a8e3f7$var$_createTheme = (0, $hhlRQ.createTheme)(function() {
    return {
        mode: "light"
    };
}), $b087976128a8e3f7$var$Provider = $b087976128a8e3f7$var$_createTheme.Provider, $b087976128a8e3f7$var$Consumer = $b087976128a8e3f7$var$_createTheme.Consumer, $b087976128a8e3f7$export$7692396083754928 = $b087976128a8e3f7$var$_createTheme.useTheme;
var $b087976128a8e3f7$export$2e2bcd8739ae039 = {
    Provider: $b087976128a8e3f7$var$Provider,
    Consumer: $b087976128a8e3f7$var$Consumer
};

});
parcelRegister("hhlRQ", function(module, exports) {

$parcel$export(module.exports, "createTheme", function () { return $c944fc9ccbbb6f00$export$25d302a5b900a763; });

var $04Kcc = parcelRequire("04Kcc");

var $1Mpn7 = parcelRequire("1Mpn7");
var $c944fc9ccbbb6f00$var$_excluded = [
    "children"
];
function $c944fc9ccbbb6f00$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $1Mpn7.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $1Mpn7.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, (/*@__PURE__*/$parcel$interopDefault($04Kcc)))(props, $c944fc9ccbbb6f00$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $1Mpn7.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $1Mpn7.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});


parcelRegister("hXfnl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d123dfa2ff635610$export$2e2bcd8739ae039; });

var $jjExS = parcelRequire("jjExS");

var $1Mpn7 = parcelRequire("1Mpn7");

var $fBy54 = parcelRequire("fBy54");

var $lUOJ8 = parcelRequire("lUOJ8");
function $d123dfa2ff635610$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d123dfa2ff635610$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d123dfa2ff635610$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d123dfa2ff635610$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d123dfa2ff635610$var$VAR_PRIMITIVE_ZINDEX = "tooltipPrimitiveZindex";
var $d123dfa2ff635610$var$primitiveStyles = (0, $fBy54.css)({
    zindex: "var(".concat($d123dfa2ff635610$var$VAR_PRIMITIVE_ZINDEX, ")"),
    cursor: "default"
});
var $d123dfa2ff635610$var$TooltipPrimitive = /*#__PURE__*/ (0, $1Mpn7.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    var styleWithZIndex = $d123dfa2ff635610$var$_objectSpread($d123dfa2ff635610$var$_objectSpread({}, style), {}, (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))({}, $d123dfa2ff635610$var$VAR_PRIMITIVE_ZINDEX, (0, $lUOJ8.layers).tooltip()));
    return (0, $fBy54.jsx)("div", {
        ref: ref,
        style: styleWithZIndex,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, (0, $fBy54.jsx)("div", {
        role: "tooltip",
        className: className,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        css: $d123dfa2ff635610$var$primitiveStyles,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children));
});
$d123dfa2ff635610$var$TooltipPrimitive.displayName = "TooltipPrimitive";
var $d123dfa2ff635610$export$2e2bcd8739ae039 = $d123dfa2ff635610$var$TooltipPrimitive;

});


parcelRegister("e8FQQ", function(module, exports) {

$parcel$export(module.exports, "getMousePosition", function () { return $a4b246dde7ac2c6e$export$642213d516a9b928; });
function $a4b246dde7ac2c6e$export$642213d516a9b928(mouseCoordinates) {
    var safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    var getBoundingClientRect = function getBoundingClientRect() {
        return {
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        };
    };
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}

});



parcelRegister("4AnAe", function(module, exports) {

$parcel$export(module.exports, "LoadingSpinner", function () { return $38b201944a91adff$export$b08b517936747730; });

var $1rY3h = parcelRequire("1rY3h");

var $inigL = parcelRequire("inigL");
var $38b201944a91adff$export$b08b517936747730 = /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
    role: "alert",
    "aria-label": "Loading",
    "data-testid": "global-nav-user-profile-container-spinner",
    children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $inigL.default), {})
});

});

parcelRegister("juD8y", function(module, exports) {

$parcel$export(module.exports, "UserDetailsCard", function () { return $f36749853d80e123$export$23a905c82baae3c5; });
/* user-details-card.tsx generated by @compiled/babel-plugin v0.28.2 */ 
var $1rY3h = parcelRequire("1rY3h");
parcelRequire("1Mpn7");

var $2vwrh = parcelRequire("2vwrh");

var $hH5Se = parcelRequire("hH5Se");
var $f36749853d80e123$export$23a905c82baae3c5 = function(param) {
    var email = param.email, name = param.name, size = param.size, src = param.src;
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
        className: (0, $2vwrh.default)([
            "_1e0c1txw _2lx2vrvc _1n261q9c _4cvr1h6o _1yt41fhj _1bsbr0r7 _bfhkalr3"
        ]),
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsx)((0, $hH5Se.WACAvatar), {
                name: name,
                src: src,
                size: size
            }),
            /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
                className: (0, $2vwrh.default)([
                    "_1e0c1txw _2lx21bp4 _1n261q9c _ahbq1eps"
                ]),
                children: [
                    /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
                        className: (0, $2vwrh.default)([
                            "_1wybxjmg _vwz41bcc _syazu67f"
                        ]),
                        children: [
                            name,
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
                        className: (0, $2vwrh.default)([
                            "_1wyboxav _vwz4oxav _syaz1kby _o5721q9c _1reo15vq _18m915vq _1bto1l2s"
                        ]),
                        children: [
                            email,
                            " "
                        ]
                    })
                ]
            })
        ]
    });
};
var $f36749853d80e123$var$userDetailsContainer = null;
var $f36749853d80e123$var$userInfoContainer = null;
var $f36749853d80e123$var$userNameLabel = null;
var $f36749853d80e123$var$userEmailLabel = null;

});

parcelRegister("lKVDr", function(module, exports) {


module.exports = (parcelRequire("eg86f"))((parcelRequire("bRvn3")).resolve("lz6mY")).then(function() {
    return parcelRequire("1qarn");
});

});

parcelRegister("8mDCT", function(module, exports) {


module.exports = (parcelRequire("eg86f"))((parcelRequire("bRvn3")).resolve("im0wQ")).then(function() {
    return parcelRequire("jvQNq");
});

});


parcelRegister("X4lBG", function(module, exports) {

$parcel$export(module.exports, "LoggedOutUser", function () { return $27a1f1d5b99f734b$export$8339543958fe900f; });
/* loggedout-user-view.tsx generated by @compiled/babel-plugin v0.28.2 */ 
var $do9pw = parcelRequire("do9pw");

var $1rY3h = parcelRequire("1rY3h");
parcelRequire("1Mpn7");

var $2vwrh = parcelRequire("2vwrh");

var $dFwuF = parcelRequire("dFwuF");

var $7Xcnn = parcelRequire("7Xcnn");

var $4JIdr = parcelRequire("4JIdr");
var $27a1f1d5b99f734b$export$8339543958fe900f = function(param) {
    var onLogInClick = param.onLogInClick;
    return /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
        children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $7Xcnn.default), {
            appearance: "subtle",
            name: "sign-in",
            onClick: onLogInClick,
            iconAfter: /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                className: (0, $2vwrh.default)([
                    "_d0altlke"
                ]),
                children: /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                    className: (0, $2vwrh.default)([
                        "_1e0c1txw _4cvr1h6o"
                    ]),
                    children: /*#__PURE__*/ (0, $1rY3h.jsx)("span", {
                        className: (0, $2vwrh.default)([
                            "_ect4q6fz _1wyboxav _syazrbzz"
                        ]),
                        children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $dFwuF.default), (0, $do9pw._)({}, (0, $4JIdr.messages).logIn))
                    })
                })
            })
        })
    });
};
var $27a1f1d5b99f734b$var$rootContainer = null;
var $27a1f1d5b99f734b$var$triggerContainer = null;
var $27a1f1d5b99f734b$var$titleLabel = null;

});



parcelRegister("iH8wz", function(module, exports) {
$parcel$export(module.exports, "Button", function () { return (parcelRequire("hR975")).Button; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("hR975")).Button; });

var $hR975 = parcelRequire("hR975");

});
parcelRegister("hR975", function(module, exports) {

$parcel$export(module.exports, "Button", function () { return $c6a1fd77821bded3$export$353f5b6fc5456de1; });
/* button.tsx generated by @compiled/babel-plugin v0.28.2 */ 
var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $1rY3h = parcelRequire("1rY3h");
parcelRequire("1Mpn7");

var $2vwrh = parcelRequire("2vwrh");
var $bStPI = parcelRequire("bStPI");
var $c6a1fd77821bded3$var$buttonStyles = {
    primary: {
        // default styles
        darkblue: {
            textColor: "#ffffff",
            buttonBackgroundColor: "#0052cc",
            buttonHoverColor: "#0047B3",
            buttonFocusColor: "#004099",
            border: "none"
        },
        yellow: {
            textColor: "#172b4d",
            buttonBackgroundColor: "#ffab00",
            buttonHoverColor: "#ff991f",
            buttonFocusColor: "#ff8b00",
            border: "none"
        },
        green: {
            textColor: "#172b4d",
            buttonBackgroundColor: "#79f2c0",
            buttonHoverColor: "#57d9a3",
            buttonFocusColor: "#36b37e",
            border: "none"
        },
        lightblue: {
            textColor: "#0052cc",
            buttonBackgroundColor: "#deebff",
            buttonHoverColor: "#B3D4FF",
            buttonFocusColor: "#4c9aff",
            border: "none"
        },
        gray: {
            textColor: "#172b4d",
            buttonBackgroundColor: "#ebecf0",
            buttonHoverColor: "#DFE1E6",
            buttonFocusColor: "#c1c7d0",
            border: "none"
        },
        disabled: {
            textColor: "#97a0af",
            buttonBackgroundColor: "#ebecf0",
            buttonHoverColor: "",
            buttonFocusColor: "",
            border: "none"
        }
    },
    secondary: {
        darkblue: {
            textColor: "#0052cc",
            buttonBackgroundColor: "transparent",
            buttonHoverColor: "#ebecf0",
            buttonFocusColor: "#deebff",
            border: "0.063rem solid #0052cc"
        },
        yellow: {
            textColor: "#172b4d",
            buttonBackgroundColor: "transparent",
            buttonHoverColor: "#f4f5f7",
            buttonFocusColor: "#FFF0B3",
            border: "0.063rem solid #ffab00"
        },
        green: {
            textColor: "#172b4d",
            buttonBackgroundColor: "transparent",
            buttonHoverColor: "#f4f5f7",
            buttonFocusColor: "#e3fcef",
            border: "0.063rem solid #79f2c0"
        },
        white: {
            textColor: "#ffffff",
            buttonBackgroundColor: "transparent",
            buttonHoverColor: "rgba(255, 255, 255, 0.10)",
            buttonFocusColor: "rgba(255, 255, 255, 0.20)",
            border: "0.063rem solid #ffffff"
        },
        disabled: {
            textColor: "#97a0af",
            buttonBackgroundColor: "#ebecf0",
            buttonHoverColor: "",
            buttonFocusColor: "",
            border: "none"
        }
    }
};
var $c6a1fd77821bded3$var$getButtonSize = function(size) {
    var buttonSize = size === null || size === void 0 ? void 0 : size.toLowerCase();
    if (buttonSize && buttonSize === "small") return "small";
    return "large";
};
var $c6a1fd77821bded3$var$getButtonType = function(type) {
    var buttonType = type === null || type === void 0 ? void 0 : type.toLowerCase();
    if (buttonType === "secondary") return "secondary";
    return "primary";
};
var $c6a1fd77821bded3$var$isButtonColor = function(color) {
    return color === "darkblue" || color === "yellow" || color === "green" || color === "lightblue" || color === "white" || color === "gray" || color === "disabled";
};
var $c6a1fd77821bded3$var$getButtonColor = function(color, disabled) {
    if (disabled) return "disabled";
    var buttonColor = color === null || color === void 0 ? void 0 : color.toLowerCase();
    if (buttonColor && $c6a1fd77821bded3$var$isButtonColor(buttonColor)) return buttonColor;
    return "darkblue";
};
var $c6a1fd77821bded3$var$getButtonStyles = function(type, color) {
    var styles = $c6a1fd77821bded3$var$buttonStyles[type][color];
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return styles ? styles : $c6a1fd77821bded3$var$buttonStyles.primary.darkblue;
};
var $c6a1fd77821bded3$export$353f5b6fc5456de1 = function(param) {
    var text = param.text, type = param.type, color = param.color, size = param.size, onClick = param.onClick, url = param.url, inputType = param.inputType, disabled = param.disabled, className = param.className, dataEventProps = param.dataEventProps;
    var buttonType = $c6a1fd77821bded3$var$getButtonType(type);
    var buttonColor = $c6a1fd77821bded3$var$getButtonColor(color, disabled);
    var _getButtonStyles = $c6a1fd77821bded3$var$getButtonStyles(buttonType, buttonColor), textColor = _getButtonStyles.textColor, buttonBackgroundColor = _getButtonStyles.buttonBackgroundColor, buttonHoverColor = _getButtonStyles.buttonHoverColor, buttonFocusColor = _getButtonStyles.buttonFocusColor, border = _getButtonStyles.border;
    var buttonSize = $c6a1fd77821bded3$var$getButtonSize(size);
    var fontSize = buttonSize === "large" ? "1rem" : "0.875rem";
    var height = buttonSize === "large" ? "2.5rem" : "2rem";
    var cursor = disabled ? "not-allowed" : "pointer";
    var styles = null;
    var handleOnClick = function(e) {
        if (disabled) e.preventDefault();
        else onClick === null || onClick === void 0 ? void 0 : onClick(e);
    };
    if ((onClick || inputType) && !url) return /*#__PURE__*/ (0, $1rY3h.jsx)("button", (0, $cxjpp._)((0, $do9pw._)({
        className: (0, $2vwrh.default)([
            "_4cvr1h6o _1bah1h6o _11q71otn _2rko6mu8 _vchhusvi _19it145r _syaz1u00 _1e0c116y _k48pbfng _ect4lnmy _vwz41k92 _ca0qidpf _u5f31j6v _n3tdidpf _19bv1j6v _y3gn1h6o _4bfu1r31 _1hmsglyw _ajmmnqa1 _1du2y4cq _19lcy4cq _j6xt4hdl _1wyb25dk _4t3imry4 _80om1q22",
            className
        ]),
        onClick: handleOnClick,
        disabled: disabled,
        type: inputType
    }, dataEventProps), {
        style: {
            "--_1yb8o8o": (0, $bStPI.default)(buttonBackgroundColor),
            "--_pruigo": (0, $bStPI.default)(border),
            "--_srel9g": (0, $bStPI.default)(textColor),
            "--_1hkmuwx": (0, $bStPI.default)(buttonHoverColor),
            "--_15riry1": (0, $bStPI.default)(buttonFocusColor),
            "--_1j2e0s2": (0, $bStPI.default)(fontSize),
            "--_roksyz": (0, $bStPI.default)(height),
            "--_15yp1he": (0, $bStPI.default)(cursor)
        },
        children: text
    }));
    return /*#__PURE__*/ (0, $1rY3h.jsx)("a", (0, $cxjpp._)((0, $do9pw._)({
        className: (0, $2vwrh.default)([
            "_4cvr1h6o _1bah1h6o _11q71otn _2rko6mu8 _vchhusvi _19it145r _syaz1u00 _1e0c116y _k48pbfng _ect4lnmy _vwz41k92 _ca0qidpf _u5f31j6v _n3tdidpf _19bv1j6v _y3gn1h6o _4bfu1r31 _1hmsglyw _ajmmnqa1 _1du2y4cq _19lcy4cq _j6xt4hdl _1wyb25dk _4t3imry4 _80om1q22",
            className
        ]),
        onClick: handleOnClick,
        href: url
    }, dataEventProps), {
        style: {
            "--_1yb8o8o": (0, $bStPI.default)(buttonBackgroundColor),
            "--_pruigo": (0, $bStPI.default)(border),
            "--_srel9g": (0, $bStPI.default)(textColor),
            "--_1hkmuwx": (0, $bStPI.default)(buttonHoverColor),
            "--_15riry1": (0, $bStPI.default)(buttonFocusColor),
            "--_1j2e0s2": (0, $bStPI.default)(fontSize),
            "--_roksyz": (0, $bStPI.default)(height),
            "--_15yp1he": (0, $bStPI.default)(cursor)
        },
        children: text
    }));
};

});


parcelRegister("gowpE", function(module, exports) {

$parcel$export(module.exports, "ProductsMain", function () { return $8fa3d1de0af849b4$export$ed492055b08646d5; });
$parcel$export(module.exports, "ProductsSideBar", function () { return $8fa3d1de0af849b4$export$7fd6b2bfe3b5498f; });
/* products-dropdown.tsx generated by @compiled/babel-plugin v0.28.2 */ 
var $do9pw = parcelRequire("do9pw");

var $1rY3h = parcelRequire("1rY3h");
parcelRequire("1Mpn7");

var $2vwrh = parcelRequire("2vwrh");

var $8pPrt = parcelRequire("8pPrt");
parcelRequire("2miCy");
var $hot2Q = parcelRequire("hot2Q");
parcelRequire("4qa8L");
var $7LDiG = parcelRequire("7LDiG");
var $bzS2B = parcelRequire("bzS2B");
parcelRequire("hUGPg");
var $biaYF = parcelRequire("biaYF");
parcelRequire("dLifx");
var $6WnuF = parcelRequire("6WnuF");
// ==================================================================
// Styles
// ==================================================================
var $8fa3d1de0af849b4$var$viewAllProductsStyle = null;
var $8fa3d1de0af849b4$var$marketplaceStyle = null;
var $8fa3d1de0af849b4$var$productCardTopRowStyle = null;
var $8fa3d1de0af849b4$var$productCardBottomRowStyle = null;
// ==================================================================
// Rendering Functions
// ==================================================================
var $8fa3d1de0af849b4$var$roadmapIcon = function() {
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 36 36",
        className: (0, $2vwrh.default)([
            "_ahbq1fcb"
        ]),
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M33.32,2.74,26.2,0V32.79L31.93,35a1.92,1.92,0,0,0,2.62-1.8V4.54A1.93,1.93,0,0,0,33.32,2.74Z",
                className: (0, $2vwrh.default)([
                    "_tzy4105o _lswu1mpp _rgxkt2ws"
                ])
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("polygon", {
                points: "18.16 36 26.2 32.79 26.2 0 18.16 3.21 18.16 36",
                className: (0, $2vwrh.default)([
                    "_lswu1mpp _rgxkt2ws"
                ])
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("polygon", {
                points: "9.8 0 9.8 32.79 18.16 36 18.16 3.21 9.8 0",
                className: (0, $2vwrh.default)([
                    "_tzy4105o _lswu1mpp _rgxkt2ws"
                ])
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                d: "M2.68,2.74a1.93,1.93,0,0,0-1.23,1.8V33.19A1.92,1.92,0,0,0,4.07,35l5.73-2.2V0Z",
                className: (0, $2vwrh.default)([
                    "_lswu1mpp _rgxkt2ws"
                ])
            })
        ]
    });
};
var $8fa3d1de0af849b4$var$linkArrow = function(color) {
    return /*#__PURE__*/ (0, $1rY3h.jsx)("svg", {
        width: "11",
        height: "8",
        viewBox: "0 0 11 8",
        fill: color,
        xmlns: "http://www.w3.org/2000/svg",
        className: (0, $2vwrh.default)([
            "_ahbq1eps"
        ]),
        children: /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.40796 0L6.32831 1.2021L8.07854 3.1497H0.763182C0.341906 3.1497 0 3.53038 0 3.99943C0 4.46849 0.341906 4.84917 0.763182 4.84917H8.07854L6.32831 6.7979L7.40796 8L11 3.99943L7.40796 0Z"
        })
    });
};
var $8fa3d1de0af849b4$var$FormatViewAllProductsLink = function() {
    var intl = (0, $8pPrt.default)();
    var linkText = intl.formatMessage({
        id: "products-dropdown.main.view-products-link",
        defaultMessage: "View all products"
    });
    return /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
        className: (0, $2vwrh.default)([
            "_1pfhxjmg _6rthl6l0"
        ]),
        children: /*#__PURE__*/ (0, $1rY3h.jsx)("a", {
            href: (0, $hot2Q.useLocalizedHref)("/software"),
            "data-event": "clicked",
            "data-event-component": "linkButton",
            "data-event-container": "globalNavWacDropdownContainer",
            className: (0, $2vwrh.default)([
                "_syazrbzz _ok1w2716 _zdz3h461"
            ]),
            children: /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
                className: (0, $2vwrh.default)([
                    "_1e0c116y _1wybdlk8"
                ]),
                children: [
                    /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                        children: linkText
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                        className: "link-arrow-products",
                        children: $8fa3d1de0af849b4$var$linkArrow("#0052cc")
                    })
                ]
            })
        })
    });
};
var $8fa3d1de0af849b4$var$FormatMarketplaceLink = function() {
    var intl = (0, $8pPrt.default)();
    var marketplaceDescription = intl.formatMessage({
        id: "products-dropdown.main.marketplace-description",
        defaultMessage: "Connect thousands of apps and integrations for all your Atlassian products"
    });
    return /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
        className: (0, $2vwrh.default)([
            "_1pfhoxav _6rthoxav"
        ]),
        children: /*#__PURE__*/ (0, $1rY3h.jsx)("a", {
            href: "//marketplace.atlassian.com",
            "data-event": "clicked",
            "data-event-component": "linkButton",
            "data-event-container": "globalNavWacDropdownContainer",
            className: (0, $2vwrh.default)([
                "_4bfu1r31 _1hmsglyw _ajmmnqa1 _w38k2716 _j3yjh461 _dr2rrbzz _10531mpp"
            ]),
            children: /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
                className: (0, $2vwrh.default)([
                    "_1e0c1ule"
                ]),
                children: [
                    /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                        className: (0, $2vwrh.default)([
                            "_1wybxjmg",
                            "marketplace"
                        ]),
                        children: "Marketplace"
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
                        className: (0, $2vwrh.default)([
                            "_1e0c116y _syaz19tk _1wyboxav"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                                children: marketplaceDescription
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                                className: "link-arrow-marketplace",
                                children: $8fa3d1de0af849b4$var$linkArrow("#505f79")
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var $8fa3d1de0af849b4$export$ed492055b08646d5 = function(param) {
    var className = param.className;
    var intl = (0, $8pPrt.default)();
    var mainTitle = intl.formatMessage({
        id: "products-dropdown.main.title",
        defaultMessage: "Featured"
    });
    var mainJiraSoftwareCard = {
        href: (0, $hot2Q.useLocalizedHref)("/software/jira"),
        product: "jirasoftware",
        description: intl.formatMessage({
            id: "products-dropdown.main.jira-software",
            defaultMessage: "Project and issue tracking"
        })
    };
    var mainConfluenceCard = {
        href: (0, $hot2Q.useLocalizedHref)("/software/confluence"),
        product: "confluence",
        description: intl.formatMessage({
            id: "products-dropdown.main.confluence",
            defaultMessage: "Content collaboration"
        })
    };
    var mainJiraServiceManagementCard = {
        href: (0, $hot2Q.useLocalizedHref)("/software/jira/service-management"),
        product: "jiraservicemanagement",
        description: intl.formatMessage({
            id: "products-dropdown.main.jira-service-management",
            defaultMessage: "High-velocity ITSM"
        })
    };
    var mainTrelloCard = {
        href: "//trello.com/home",
        product: "trello",
        description: intl.formatMessage({
            id: "products-dropdown.main.trello",
            defaultMessage: "Visual project management"
        })
    };
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
        className: (0, $2vwrh.default)([
            "_1pfhl6l0",
            className
        ]),
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $1rY3h.jsx)((0, $7LDiG.ListOfLinksHeaderText), {
                        isSideBar: false,
                        headerText: mainTitle
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
                        className: (0, $2vwrh.default)([
                            "_1e0c11p5 _1rqtwxkt _1ph4hkll"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $1rY3h.jsx)((0, $biaYF.ProductCard), {
                                productDetails: mainJiraSoftwareCard
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)((0, $biaYF.ProductCard), {
                                productDetails: mainConfluenceCard
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
                        className: (0, $2vwrh.default)([
                            "_1e0c11p5 _1rqtwxkt _1ph4hkll"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $1rY3h.jsx)((0, $biaYF.ProductCard), {
                                productDetails: mainJiraServiceManagementCard
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)((0, $biaYF.ProductCard), {
                                productDetails: mainTrelloCard
                            })
                        ]
                    }),
                    $8fa3d1de0af849b4$var$FormatViewAllProductsLink()
                ]
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                className: (0, $2vwrh.default)([
                    "_mqm21ei3 _12l2oxav"
                ]),
                children: $8fa3d1de0af849b4$var$FormatMarketplaceLink()
            })
        ]
    });
};
var $8fa3d1de0af849b4$export$7fd6b2bfe3b5498f = function(param) {
    var className = param.className, productKey = param.productKey;
    var intl = (0, $8pPrt.default)();
    var sideBarTitle = intl.formatMessage({
        id: "products-dropdown.sidebar.title",
        defaultMessage: "What's new"
    });
    var sideBarCompassCard = {
        href: (0, $hot2Q.useLocalizedHref)("/software/compass"),
        product: "compass",
        description: intl.formatMessage({
            id: "products-dropdown.sidebar.compass",
            defaultMessage: "Developer Experience Platform"
        })
    };
    var sideBarJiraProductDiscoveryCard = {
        href: (0, $hot2Q.useLocalizedHref)("/software/jira/product-discovery"),
        product: "jiraproductdiscovery",
        description: intl.formatMessage({
            id: "products-dropdown.sidebar.jira-product-discovery",
            defaultMessage: "Prioritization and roadmapping"
        })
    };
    var viewAllText = intl.formatMessage({
        id: "products-dropdown.sidebar.view-all",
        defaultMessage: "View all"
    });
    var listOfLinksProps = {
        isSideBar: true,
        headerText: intl.formatMessage({
            id: "products-dropdown.sidebar.helpful",
            defaultMessage: "You might find helpful"
        }),
        listOfLinkWithProps: [
            {
                href: (0, $hot2Q.useLocalizedHref)("/roadmap/cloud"),
                isHaveIcon: true,
                isCustomIcon: true,
                iconName: $8fa3d1de0af849b4$var$roadmapIcon(),
                linkText: intl.formatMessage({
                    id: "products-dropdown.sidebar.roadmap",
                    defaultMessage: "Cloud Product Roadmap"
                }),
                dataEventContainer: "globalNavWacDropdownContainer"
            },
            {
                href: (0, $hot2Q.useLocalizedHref)("/migration"),
                isHaveIcon: true,
                iconName: "cloudcheckmark",
                linkText: intl.formatMessage({
                    id: "products-dropdown.sidebar.migration",
                    defaultMessage: "Atlassian Migration Program"
                }),
                dataEventContainer: "globalNavWacDropdownContainer"
            }
        ]
    };
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsx)((0, $7LDiG.ListOfLinksHeaderText), {
                isSideBar: false,
                headerText: sideBarTitle
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $biaYF.ProductCard), {
                    productDetails: sideBarCompassCard
                })
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $biaYF.ProductCard), {
                    productDetails: sideBarJiraProductDiscoveryCard
                })
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                className: (0, $2vwrh.default)([
                    "_6rthgosd _1pfhgosd"
                ]),
                children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $6WnuF.Link), {
                    text: viewAllText,
                    href: (0, $hot2Q.useLocalizedHref)("/point-a"),
                    type: "basic",
                    customLinkColor: "#0052cc",
                    dataEventProps: {
                        "data-product-key": productKey,
                        "data-event-component": "linkButton",
                        "data-event-container": "globalNavWacDropdownContainer",
                        "data-event": "clicked"
                    },
                    className: (0, $2vwrh.default)([
                        "_16btglyw _1up4glyw"
                    ])
                })
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)((0, $bzS2B.ListOfLinks), (0, $do9pw._)({}, listOfLinksProps))
        ]
    });
};

});
parcelRegister("hUGPg", function(module, exports) {
$parcel$export(module.exports, "ProductCard", function () { return (parcelRequire("biaYF")).ProductCard; });

var $biaYF = parcelRequire("biaYF");

});
parcelRegister("biaYF", function(module, exports) {

$parcel$export(module.exports, "ProductCard", function () { return $3bc4ab50b57b35f6$export$e6cbe35324ccf844; });
/* product-card.tsx generated by @compiled/babel-plugin v0.28.2 */ /* eslint-disable complexity */ 
var $cv9Rk = parcelRequire("cv9Rk");

var $1rY3h = parcelRequire("1rY3h");

var $1Mpn7 = parcelRequire("1Mpn7");

var $2vwrh = parcelRequire("2vwrh");
parcelRequire("9DBuW");
var $l227w = parcelRequire("l227w");
var $3bc4ab50b57b35f6$var$Products = {
    atlas: "Atlas",
    compass: "Compass",
    confluence: "Confluence",
    jiraproductdiscovery: "Jira Product Discovery",
    jiraservicemanagement: "Jira Service Management",
    jirasoftware: "Jira Software",
    trello: "Trello"
};
var $3bc4ab50b57b35f6$export$e6cbe35324ccf844 = function(param) {
    var productDetails = param.productDetails, className = param.className, testId = param.testId;
    var _useState = (0, $cv9Rk._)((0, $1Mpn7.useState)(false), 2), isMouseOver = _useState[0], setMouseOver = _useState[1];
    var panelStyle = null;
    // TODO: adjust logo sizing when support is added for it
    var iconStyle = [
        isMouseOver && null,
        !isMouseOver && null
    ];
    var titleStyle = [
        isMouseOver && null,
        !isMouseOver && null
    ];
    var descriptionStyle = null;
    return /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
        className: (0, $2vwrh.default)([
            "_6rth1bcc",
            className
        ]),
        children: /*#__PURE__*/ (0, $1rY3h.jsx)("a", {
            href: productDetails.href,
            target: productDetails.product === "trello" ? "_blank" : "",
            rel: "noreferrer",
            "data-event": "clicked",
            "data-event-component": "linkButton",
            "data-event-container": "globalNavWacDropdownContainer",
            children: /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
                onMouseEnter: function() {
                    return setMouseOver(true);
                },
                onMouseLeave: function() {
                    return setMouseOver(false);
                },
                "data-testid": testId,
                className: (0, $2vwrh.default)([
                    "_1e0c116y _4cvr1h6o"
                ]),
                children: [
                    /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                        "data-testid": "icon",
                        className: (0, $2vwrh.default)([
                            isMouseOver && "_bfhk1kby _12l21bcc _2rko1fcb _1yt41r3q",
                            !isMouseOver && "_bfhkj1oc _12l21bcc _2rko1fcb _1yt41r3q"
                        ]),
                        children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $l227w.Logo), {
                            brand: productDetails.product,
                            type: "mark",
                            appearance: "brand"
                        })
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                                "data-testid": "title",
                                className: (0, $2vwrh.default)([
                                    isMouseOver && "_syazrbzz _1wybxjmg",
                                    !isMouseOver && "_syaz1mpp _1wybxjmg"
                                ]),
                                children: $3bc4ab50b57b35f6$var$Products[productDetails.product]
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                                className: (0, $2vwrh.default)([
                                    "_syaz19tk _1wyboxav"
                                ]),
                                children: productDetails.description
                            })
                        ]
                    })
                ]
            })
        })
    });
};

});



parcelRegister("i0Zmt", function(module, exports) {

$parcel$export(module.exports, "ResourcesMain", function () { return $da88de990ac1bf97$export$da873a99b5e70a79; });
$parcel$export(module.exports, "ResourcesSideBar", function () { return $da88de990ac1bf97$export$62bc570aa9d75240; });
/* resources-dropdown.tsx generated by @compiled/babel-plugin v0.28.2 */ 
var $do9pw = parcelRequire("do9pw");

var $1rY3h = parcelRequire("1rY3h");
parcelRequire("1Mpn7");

var $2vwrh = parcelRequire("2vwrh");

var $8pPrt = parcelRequire("8pPrt");
parcelRequire("2miCy");
var $hot2Q = parcelRequire("hot2Q");
parcelRequire("ltftH");
var $qztMO = parcelRequire("qztMO");
parcelRequire("4qa8L");
var $bzS2B = parcelRequire("bzS2B");
var $7LDiG = parcelRequire("7LDiG");
parcelRequire("dLifx");
var $6WnuF = parcelRequire("6WnuF");
// ==================================================================
// Styles
// ==================================================================
var $da88de990ac1bf97$var$listOfLinksRowStyle = null;
var $da88de990ac1bf97$var$listOfLinksStyle = null;
var $da88de990ac1bf97$var$bannerStyle = null;
var $da88de990ac1bf97$var$atlassianTeam23Style = null;
var $da88de990ac1bf97$export$24a86cf9f9fbf3d5 = function() {
    var intl = (0, $8pPrt.default)();
    var descriptionText = intl.formatMessage({
        id: "resources-dropdown.sidebar.unleash.at-description",
        defaultMessage: "Product updates, hands-on training, and technical demos - catch all that and more at our biggest agile & DevOps event."
    });
    var CTAText = intl.formatMessage({
        id: "resources-dropdown.sidebar.unleash.watch-now.cta",
        defaultMessage: "Watch now"
    });
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsx)("a", {
                href: "https://events.atlassian.com/unleash?ref=Unleash&utm_source=marketing&utm_campaign=acquisition&utm_content=global_subnav&utm_medium=web",
                "data-event": "clicked",
                "data-event-component": "linkButton",
                "data-event-container": "image",
                className: (0, $2vwrh.default)([
                    "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syaz1mpp _hefvoelr _10531mpp"
                ]),
                children: /*#__PURE__*/ (0, $1rY3h.jsx)("img", {
                    id: "ed54ffcf",
                    alt: "",
                    className: (0, $2vwrh.default)([
                        "_1bsbmgvx",
                        "component__image"
                    ]),
                    src: "https://wac-cdn.atlassian.com/dam/jcr:175bb96f-63a8-4b66-bd94-a3e5ea7e7d1d/Social%20Unleash%20193x122.png?cdnVersion=1234"
                })
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                className: (0, $2vwrh.default)([
                    "_1pfhoxav _6rtha5zd"
                ]),
                children: /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                    className: (0, $2vwrh.default)([
                        "_1e0c1ule"
                    ]),
                    children: /*#__PURE__*/ (0, $1rY3h.jsxs)("a", {
                        href: "https://events.atlassian.com/unleash?ref=Unleash&utm_source=marketing&utm_campaign=acquisition&utm_content=global_subnav&utm_medium=web",
                        className: (0, $2vwrh.default)([
                            "_1wybxjmg _6rth1eps _1pfhxjmg",
                            "atlassianteam23"
                        ]),
                        "data-event": "clicked",
                        "data-event-component": "linkButton",
                        "data-event-container": "globalNavWacDropdownContainer",
                        children: [
                            "Atlassian Presents: Unleash",
                            /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                                className: (0, $2vwrh.default)([
                                    "_syaz19tk _1wyboxav _6rth1oug"
                                ]),
                                children: /*#__PURE__*/ (0, $1rY3h.jsx)("p", {
                                    className: (0, $2vwrh.default)([
                                        "_p12f1ogy"
                                    ]),
                                    children: descriptionText
                                })
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)((0, $6WnuF.Link), {
                                text: CTAText,
                                href: "https://events.atlassian.com/unleash?ref=Unleash&utm_source=marketing&utm_campaign=acquisition&utm_content=global_subnav&utm_medium=web",
                                type: "basic",
                                customLinkColor: "#0052cc",
                                className: (0, $2vwrh.default)([
                                    "_16btglyw _1up4glyw"
                                ])
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var $da88de990ac1bf97$export$c684134a71d9feb = function() {
    var intl = (0, $8pPrt.default)();
    var descriptionText = intl.formatMessage({
        id: "resources-dropdown.sidebar.atlassian23.at-description",
        defaultMessage: "Catch up on the latest Atlassian product announcements and innovations shared live on stage in Las Vegas."
    });
    var watchNowText = intl.formatMessage({
        id: "resources-dropdown.sidebar.atlassian23.watch-now",
        defaultMessage: "Watch now"
    });
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsx)("img", {
                id: "ed54ffcf",
                alt: "",
                className: "component__image",
                src: "https://wac-cdn.atlassian.com/dam/jcr:41056f05-6198-44af-8680-1efc2e926789/Screen%20Shot%202023-01-05%20at%203.48%201.jpg?cdnVersion=1223"
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                className: (0, $2vwrh.default)([
                    "_1pfhoxav _6rtha5zd"
                ]),
                children: /*#__PURE__*/ (0, $1rY3h.jsx)("a", {
                    href: "https://events.atlassian.com/team23/v/s-1430980?ref=Team_23&utm_source=butterbar&utm_campaign=od_drop2&utm_medium=internal&utm_type=Team_23_404",
                    className: (0, $2vwrh.default)([
                        "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syaz1mpp _hefvoelr _10531mpp"
                    ]),
                    children: /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
                        className: (0, $2vwrh.default)([
                            "_1e0c1ule"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                                className: (0, $2vwrh.default)([
                                    "_1wybxjmg _6rth1eps _1pfhxjmg",
                                    "atlassianteam23"
                                ]),
                                children: "Atlassian Team '23"
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                                className: (0, $2vwrh.default)([
                                    "_syaz19tk _1wyboxav _6rth1oug"
                                ]),
                                children: descriptionText
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)((0, $6WnuF.Link), {
                                text: watchNowText,
                                href: "https://events.atlassian.com/team23/v/s-1430980?ref=Team_23&utm_source=butterbar&utm_campaign=od_drop2&utm_medium=internal&utm_type=Team_23_404",
                                type: "basic",
                                customLinkColor: "#0052cc"
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var $da88de990ac1bf97$export$da873a99b5e70a79 = function(param) {
    var className = param.className, productKey = param.productKey;
    var intl = (0, $8pPrt.default)();
    var learnListProps = {
        isSideBar: false,
        headerText: intl.formatMessage({
            id: "resources-dropdown.main.learn",
            defaultMessage: "Learn"
        }),
        listOfLinkWithProps: [
            {
                href: "https://university.atlassian.com/",
                isHaveIcon: false,
                linkText: intl.formatMessage({
                    id: "resources-dropdown.main.university",
                    defaultMessage: "Atlassian University"
                }),
                dataEventContainer: "globalNavWacDropdownContainer"
            },
            {
                href: (0, $hot2Q.useLocalizedHref)("/team-playbook"),
                isHaveIcon: false,
                linkText: intl.formatMessage({
                    id: "resources-dropdown.main.tp",
                    defaultMessage: "Atlassian Playbook"
                }),
                dataEventContainer: "globalNavWacDropdownContainer"
            },
            {
                href: "https://support.atlassian.com/",
                isHaveIcon: false,
                linkText: intl.formatMessage({
                    id: "resources-dropdown.main.startup",
                    defaultMessage: "Product Documentation"
                }),
                dataEventContainer: "globalNavWacDropdownContainer"
            },
            {
                href: "https://developer.atlassian.com/",
                isHaveIcon: false,
                linkText: intl.formatMessage({
                    id: "resources-dropdown.main.dr",
                    defaultMessage: "Developer Resources"
                }),
                dataEventContainer: "globalNavWacDropdownContainer"
            }
        ]
    };
    var supportListProps = {
        isSideBar: false,
        headerText: intl.formatMessage({
            id: "resources-dropdown.main.support",
            defaultMessage: "Support"
        }),
        listOfLinkWithProps: [
            {
                href: (0, $hot2Q.useLocalizedHref)("/community"),
                isHaveIcon: false,
                linkText: intl.formatMessage({
                    id: "resources-dropdown.main.ac",
                    defaultMessage: "Atlassian Community"
                }),
                dataEventContainer: "globalNavWacDropdownContainer"
            },
            {
                href: "https://support.atlassian.com/",
                isHaveIcon: false,
                linkText: intl.formatMessage({
                    id: "resources-dropdown.main.as",
                    defaultMessage: "Atlassian Support"
                }),
                dataEventContainer: "globalNavWacDropdownContainer"
            },
            {
                href: (0, $hot2Q.useLocalizedHref)("/migration"),
                isHaveIcon: false,
                linkText: intl.formatMessage({
                    id: "resources-dropdown.main.migration",
                    defaultMessage: "Atlassian Migration Program"
                }),
                dataEventContainer: "globalNavWacDropdownContainer"
            },
            {
                href: (0, $hot2Q.useLocalizedHref)("/enterprise/services"),
                isHaveIcon: false,
                linkText: intl.formatMessage({
                    id: "resources-dropdown.main.es",
                    defaultMessage: "Enterprise Services"
                }),
                dataEventContainer: "globalNavWacDropdownContainer"
            },
            {
                href: (0, $hot2Q.useLocalizedHref)("/partners"),
                isHaveIcon: false,
                linkText: intl.formatMessage({
                    id: "resources-dropdown.main.partners",
                    defaultMessage: "Partner Support"
                }),
                dataEventContainer: "globalNavWacDropdownContainer"
            },
            {
                href: (0, $hot2Q.useLocalizedHref)("/licensing/purchase-licensing#pricing-discounts"),
                isHaveIcon: false,
                linkText: intl.formatMessage({
                    id: "resources-dropdown.main.p&l",
                    defaultMessage: "Purchasing & Licensing"
                }),
                dataEventContainer: "globalNavWacDropdownContainer"
            }
        ]
    };
    var connectListProps = {
        isSideBar: false,
        headerText: intl.formatMessage({
            id: "resources-dropdown.main.connect",
            defaultMessage: "Connect"
        }),
        listOfLinkWithProps: [
            {
                href: (0, $hot2Q.useLocalizedHref)("/company"),
                isHaveIcon: false,
                linkText: intl.formatMessage({
                    id: "resources-dropdown.main.company",
                    defaultMessage: "About us"
                }),
                dataEventContainer: "globalNavWacDropdownContainer"
            },
            {
                href: (0, $hot2Q.useLocalizedHref)("/company/careers"),
                isHaveIcon: false,
                linkText: intl.formatMessage({
                    id: "resources-dropdown.main.careers",
                    defaultMessage: "Careers"
                }),
                dataEventContainer: "globalNavWacDropdownContainer"
            },
            {
                href: (0, $hot2Q.useLocalizedHref)("/blog"),
                isHaveIcon: false,
                linkText: intl.formatMessage({
                    id: "resources-dropdown.main.blog",
                    defaultMessage: "Work Life Blog"
                }),
                dataEventContainer: "globalNavWacDropdownContainer"
            },
            {
                href: (0, $hot2Q.useLocalizedHref)("/company/events"),
                isHaveIcon: false,
                linkText: intl.formatMessage({
                    id: "resources-dropdown.main.events",
                    defaultMessage: "Events"
                }),
                dataEventContainer: "globalNavWacDropdownContainer"
            }
        ]
    };
    var SupportForServerProps = {
        title: intl.formatMessage({
            id: "resources-dropdown.server-support-msg.title",
            defaultMessage: "Support for Server products ends February 15, 2024"
        }),
        body: intl.formatMessage({
            id: "resources-dropdown.server-support-msg.description",
            defaultMessage: "With end of support for our Server products fast approaching, create a winning plan for your Cloud migration with the Atlassian Migration Program."
        }),
        linkText: intl.formatMessage({
            id: "resources-dropdown.server-support-msg.button",
            defaultMessage: "Assess my options"
        }),
        linkUrl: (0, $hot2Q.useLocalizedHref)("/migration/assess/journey-to-cloud"),
        dataEventProps: {
            "data-product-key": productKey,
            "data-event-component": "linkButton",
            "data-event-container": "globalNavWacDropdownContainer",
            "data-event": "clicked"
        }
    };
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
        className: (0, $2vwrh.default)([
            "_1bsb1osq",
            className
        ]),
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
                className: (0, $2vwrh.default)([
                    "_1pfhl6l0 _1e0c11p5 _1j8b1ckl _1ph4hkll"
                ]),
                children: [
                    /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                        className: (0, $2vwrh.default)([
                            "_6rthxjmg"
                        ]),
                        children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $bzS2B.ListOfLinks), (0, $do9pw._)({}, learnListProps))
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                        className: (0, $2vwrh.default)([
                            "_6rthxjmg"
                        ]),
                        children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $bzS2B.ListOfLinks), (0, $do9pw._)({}, supportListProps))
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                        className: (0, $2vwrh.default)([
                            "_6rthxjmg"
                        ]),
                        children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $bzS2B.ListOfLinks), (0, $do9pw._)({}, connectListProps))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                className: (0, $2vwrh.default)([
                    "_y4ti1bcc _85i5hiv4"
                ]),
                children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $qztMO.Banner), (0, $do9pw._)({}, SupportForServerProps))
            })
        ]
    });
};
var $da88de990ac1bf97$export$62bc570aa9d75240 = function(param) {
    var className = param.className;
    var intl = (0, $8pPrt.default)();
    var sideBarTitle = intl.formatMessage({
        id: "resources-dropdown.sidebar.title",
        defaultMessage: "What's new"
    });
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsx)((0, $7LDiG.ListOfLinksHeaderText), {
                isSideBar: false,
                headerText: sideBarTitle
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)($da88de990ac1bf97$export$24a86cf9f9fbf3d5, {})
        ]
    });
};

});
parcelRegister("ltftH", function(module, exports) {
$parcel$export(module.exports, "Banner", function () { return (parcelRequire("qztMO")).Banner; });

var $qztMO = parcelRequire("qztMO");

});
parcelRegister("qztMO", function(module, exports) {

$parcel$export(module.exports, "Banner", function () { return $b02e68b1a4e96514$export$3b4e64e77073e307; });
/* banner.tsx generated by @compiled/babel-plugin v0.28.2 */ 
var $1rY3h = parcelRequire("1rY3h");
parcelRequire("1Mpn7");

var $2vwrh = parcelRequire("2vwrh");
parcelRequire("iH8wz");
var $hR975 = parcelRequire("hR975");

var $7Cvu1 = parcelRequire("7Cvu1");

var $cvyiX = parcelRequire("cvyiX");
var $b02e68b1a4e96514$export$3b4e64e77073e307 = function(param) {
    var title = param.title, body = param.body, linkText = param.linkText, linkUrl = param.linkUrl, dataEventProps = param.dataEventProps;
    var bannerStyle = null;
    var bannerLeftStyle = null;
    var bannerRightStyle = null;
    var buttonStyle = null;
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
        className: (0, $2vwrh.default)([
            "_vchhusvi _7cca15wb _1e0c1txw _2lx2vrvc _1n261g80 _1bah1yb4 _4cvr1h6o _ae4v1fhb _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1yt41bcc _1bsb1osq _1wybxjmg _syazvwuj _bfhk1keg _2rko1l7b"
        ]),
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
                className: (0, $2vwrh.default)([
                    "_1bsb4xhq _1e0c1txw _2lx21bp4 _1n261g80 _1bahesu3 _4cvr1y6m _ae4v1h6o"
                ]),
                children: [
                    /*#__PURE__*/ (0, $1rY3h.jsx)((0, $cvyiX.default), {
                        children: title
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)((0, $7Cvu1.default), {
                        children: body
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                className: (0, $2vwrh.default)([
                    "_1wfq1eps _1a1x1osq _476d1bcc _1e0c1txw _1bahesu3"
                ]),
                children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $hR975.Button), {
                    text: linkText,
                    url: linkUrl,
                    type: "secondary",
                    dataEventProps: dataEventProps,
                    className: (0, $2vwrh.default)([
                        "_1a1x1osq _1wybxjmg _k48p4jg8 _1di61j28 _jomr1j28 _irr31j28"
                    ])
                })
            })
        ]
    });
};

});
parcelRegister("7Cvu1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d6b90f5a9dd8fdd5$export$2e2bcd8739ae039; });
/* banner-body.tsx generated by @compiled/babel-plugin v0.28.2 */ 
var $1rY3h = parcelRequire("1rY3h");
parcelRequire("1Mpn7");

var $2vwrh = parcelRequire("2vwrh");
var $d6b90f5a9dd8fdd5$var$bodyCss = null;
var $d6b90f5a9dd8fdd5$var$BannerBody = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0, $1rY3h.jsx)("p", {
        className: (0, $2vwrh.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wyboxav _vwz41bcc"
        ]),
        children: children
    });
};
var $d6b90f5a9dd8fdd5$export$2e2bcd8739ae039 = $d6b90f5a9dd8fdd5$var$BannerBody;

});

parcelRegister("cvyiX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae2358169073d4d1$export$2e2bcd8739ae039; });
/* banner-title.tsx generated by @compiled/babel-plugin v0.28.2 */ 
var $1rY3h = parcelRequire("1rY3h");
parcelRequire("1Mpn7");

var $2vwrh = parcelRequire("2vwrh");
var $ae2358169073d4d1$var$bodyCss = null;
var $ae2358169073d4d1$var$BannerTitle = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0, $1rY3h.jsx)("h3", {
        className: (0, $2vwrh.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wybxjmg _vwz4l6l0 _k48p4jg8"
        ]),
        children: children
    });
};
var $ae2358169073d4d1$export$2e2bcd8739ae039 = $ae2358169073d4d1$var$BannerTitle;

});




parcelRegister("gPANu", function(module, exports) {

$parcel$export(module.exports, "SolutionsMain", function () { return $b7bed5d6e1b46a80$export$29516c31cd257e9e; });
$parcel$export(module.exports, "SolutionsSideBar", function () { return $b7bed5d6e1b46a80$export$82cce7f9d365dc54; });
/* solutions-dropdown.tsx generated by @compiled/babel-plugin v0.28.2 */ 
var $do9pw = parcelRequire("do9pw");

var $1rY3h = parcelRequire("1rY3h");
parcelRequire("1Mpn7");

var $2vwrh = parcelRequire("2vwrh");

var $dFwuF = parcelRequire("dFwuF");
var $8pPrt = parcelRequire("8pPrt");
parcelRequire("2miCy");
var $7UzgT = parcelRequire("7UzgT");
var $hot2Q = parcelRequire("hot2Q");
parcelRequire("4qa8L");
var $7LDiG = parcelRequire("7LDiG");
var $bzS2B = parcelRequire("bzS2B");
parcelRequire("h2Ufe");
var $ktyxS = parcelRequire("ktyxS");
parcelRequire("dLifx");
var $6WnuF = parcelRequire("6WnuF");
// ==================================================================
// Styles
// ==================================================================
var $b7bed5d6e1b46a80$var$atlassianTogetherStyle = null;
var $b7bed5d6e1b46a80$var$solutionsCardRowStyle = null;
var $b7bed5d6e1b46a80$var$solutionsCardStyle = null;
var $b7bed5d6e1b46a80$var$listOfLinksRowStyle = null;
var $b7bed5d6e1b46a80$var$listOfLinksStyle = null;
// ==================================================================
// Rendering Functions
// ==================================================================
var $b7bed5d6e1b46a80$var$FormatAtlassianTogether = function(productKey) {
    var intl = (0, $8pPrt.default)();
    var descriptionText = /*#__PURE__*/ (0, $1rY3h.jsx)((0, $dFwuF.default), {
        id: "solutions-dropdown.sidebar.at-description",
        defaultMessage: "Get Atlassian work management products in one convenient package for enterprise teams.",
        values: (0, $7UzgT.DEFAULT_VALUES)
    });
    var learnMoreText = intl.formatMessage({
        id: "solutions-dropdown.sidebar.learn-more",
        defaultMessage: "Learn more"
    });
    return /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
        className: (0, $2vwrh.default)([
            "_1pfhoxav _6rtha5zd"
        ]),
        children: /*#__PURE__*/ (0, $1rY3h.jsx)("a", {
            href: (0, $hot2Q.useLocalizedHref)("/solutions/work-management/together"),
            "data-event": "clicked",
            "data-event-component": "linkButton",
            "data-event-container": "globalNavWacDropdownContainer",
            className: (0, $2vwrh.default)([
                "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syaz1mpp _1u78oelr _10531mpp"
            ]),
            children: /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
                className: (0, $2vwrh.default)([
                    "_1e0c1ule"
                ]),
                children: [
                    /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                        className: (0, $2vwrh.default)([
                            "_1wybxjmg _6rth1eps _1pfhxjmg",
                            "atlassiantogether"
                        ]),
                        children: "Atlassian Together"
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                        className: (0, $2vwrh.default)([
                            "_syaz19tk _1wyboxav _6rth1oug"
                        ]),
                        children: /*#__PURE__*/ (0, $1rY3h.jsx)("p", {
                            className: (0, $2vwrh.default)([
                                "_p12f1ogy"
                            ]),
                            children: descriptionText
                        })
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)((0, $6WnuF.Link), {
                        text: learnMoreText,
                        href: (0, $hot2Q.useLocalizedHref)("/solutions/work-management/together"),
                        type: "basic",
                        customLinkColor: "#0052cc",
                        dataEventProps: {
                            "data-product-key": productKey,
                            "data-event-component": "linkButton",
                            "data-event-container": "globalNavWacDropdownContainer",
                            "data-event": "clicked"
                        },
                        className: (0, $2vwrh.default)([
                            "_16btglyw _1up4glyw"
                        ])
                    })
                ]
            })
        })
    });
};
var $b7bed5d6e1b46a80$export$29516c31cd257e9e = function(param) {
    var className = param.className;
    var intl = (0, $8pPrt.default)();
    var mainTitle = intl.formatMessage({
        id: "solutions-dropdown.main.title",
        defaultMessage: "Featured"
    });
    var workManagementCard = {
        href: (0, $hot2Q.useLocalizedHref)("/solutions/work-management"),
        title: intl.formatMessage({
            id: "solutions-dropdown.main.wm-title",
            defaultMessage: "Work Management"
        }),
        body: intl.formatMessage({
            id: "solutions-dropdown.main.wm-body",
            defaultMessage: "Manage projects and align goals across all teams to achieve deliverables"
        }),
        icon: "pagemultiple",
        gradient: {
            firstColor: "#b2d4ff",
            secondColor: "#eae6ff"
        }
    };
    var itServiceManagementCard = {
        href: (0, $hot2Q.useLocalizedHref)("/solutions/itsm"),
        title: intl.formatMessage({
            id: "solutions-dropdown.main.itsm-title",
            defaultMessage: "IT Service Management"
        }),
        body: intl.formatMessage({
            id: "solutions-dropdown.main.itsm-body",
            defaultMessage: "Enable dev, IT ops, and business teams to deliver great service at high velocity"
        }),
        icon: "bold",
        gradient: {
            firstColor: "#b2d4ff",
            secondColor: "#e3fcef"
        }
    };
    var agileDevOpsCard = {
        href: (0, $hot2Q.useLocalizedHref)("/solutions/devops"),
        title: intl.formatMessage({
            id: "solutions-dropdown.main.devops-title",
            defaultMessage: "Agile & DevOps"
        }),
        body: intl.formatMessage({
            id: "solutions-dropdown.main.devops-body",
            defaultMessage: "Run a world-class agile software organization from discovery to delivery and operations"
        }),
        icon: "diagramorgchart",
        gradient: {
            firstColor: "#eae6ff",
            secondColor: "#ffebe5"
        }
    };
    var teamSizeListProps = {
        isSideBar: false,
        headerText: intl.formatMessage({
            id: "solutions-dropdown.main.team-size",
            defaultMessage: "By team size"
        }),
        listOfLinkWithProps: [
            {
                href: (0, $hot2Q.useLocalizedHref)("/enterprise"),
                isHaveIcon: false,
                linkText: intl.formatMessage({
                    id: "solutions-dropdown.main.enterprise",
                    defaultMessage: "Enterprise"
                }),
                dataEventContainer: "globalNavWacDropdownContainer"
            },
            {
                href: (0, $hot2Q.useLocalizedHref)("/software/small-business"),
                isHaveIcon: false,
                linkText: intl.formatMessage({
                    id: "solutions-dropdown.main.sb",
                    defaultMessage: "Small Business"
                }),
                dataEventContainer: "globalNavWacDropdownContainer"
            },
            {
                href: (0, $hot2Q.useLocalizedHref)("/software/startups"),
                isHaveIcon: false,
                linkText: intl.formatMessage({
                    id: "solutions-dropdown.main.startup",
                    defaultMessage: "Startup"
                }),
                dataEventContainer: "globalNavWacDropdownContainer"
            },
            {
                href: (0, $hot2Q.useLocalizedHref)("/teams/nonprofits"),
                isHaveIcon: false,
                linkText: intl.formatMessage({
                    id: "solutions-dropdown.main.nonprofit",
                    defaultMessage: "Non-profit"
                }),
                dataEventContainer: "globalNavWacDropdownContainer"
            }
        ]
    };
    var teamFunctionListProps = {
        isSideBar: false,
        headerText: intl.formatMessage({
            id: "solutions-dropdown.main.team-function",
            defaultMessage: "By team function"
        }),
        listOfLinkWithProps: [
            {
                href: (0, $hot2Q.useLocalizedHref)("/teams/software-development"),
                isHaveIcon: false,
                linkText: intl.formatMessage({
                    id: "solutions-dropdown.main.sd",
                    defaultMessage: "Software Development"
                }),
                dataEventContainer: "globalNavWacDropdownContainer"
            },
            {
                href: (0, $hot2Q.useLocalizedHref)("/teams/it"),
                isHaveIcon: false,
                linkText: intl.formatMessage({
                    id: "solutions-dropdown.main.it",
                    defaultMessage: "IT"
                }),
                dataEventContainer: "globalNavWacDropdownContainer"
            },
            {
                href: (0, $hot2Q.useLocalizedHref)("/teams/finance"),
                isHaveIcon: false,
                linkText: intl.formatMessage({
                    id: "solutions-dropdown.main.finance",
                    defaultMessage: "Finance"
                }),
                dataEventContainer: "globalNavWacDropdownContainer"
            },
            {
                href: (0, $hot2Q.useLocalizedHref)("/teams/marketing"),
                isHaveIcon: false,
                linkText: intl.formatMessage({
                    id: "solutions-dropdown.main.marketing",
                    defaultMessage: "Marketing"
                }),
                dataEventContainer: "globalNavWacDropdownContainer"
            },
            {
                href: (0, $hot2Q.useLocalizedHref)("/teams/hr"),
                isHaveIcon: false,
                linkText: intl.formatMessage({
                    id: "solutions-dropdown.main.hr",
                    defaultMessage: "HR"
                }),
                dataEventContainer: "globalNavWacDropdownContainer"
            }
        ]
    };
    var industryListProps = {
        isSideBar: false,
        headerText: intl.formatMessage({
            id: "solutions-dropdown.main.industry",
            defaultMessage: "By industry"
        }),
        listOfLinkWithProps: [
            {
                href: (0, $hot2Q.useLocalizedHref)("/industries/retail"),
                isHaveIcon: false,
                linkText: intl.formatMessage({
                    id: "solutions-dropdown.main.retail",
                    defaultMessage: "Retail"
                }),
                dataEventContainer: "globalNavWacDropdownContainer"
            },
            {
                href: (0, $hot2Q.useLocalizedHref)("/industries/telecom"),
                isHaveIcon: false,
                linkText: intl.formatMessage({
                    id: "solutions-dropdown.main.telecom",
                    defaultMessage: "Telecommunications"
                }),
                dataEventContainer: "globalNavWacDropdownContainer"
            },
            {
                href: (0, $hot2Q.useLocalizedHref)("/industries/professional-services"),
                isHaveIcon: false,
                linkText: intl.formatMessage({
                    id: "solutions-dropdown.main.ps",
                    defaultMessage: "Professional Services"
                }),
                dataEventContainer: "globalNavWacDropdownContainer"
            },
            {
                href: (0, $hot2Q.useLocalizedHref)("/government"),
                isHaveIcon: false,
                linkText: intl.formatMessage({
                    id: "solutions-dropdown.main.government",
                    defaultMessage: "Government"
                }),
                dataEventContainer: "globalNavWacDropdownContainer"
            }
        ]
    };
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
        className: (0, $2vwrh.default)([
            "_1bsb1osq _1pfhl6l0",
            className
        ]),
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $1rY3h.jsx)((0, $7LDiG.ListOfLinksHeaderText), {
                        isSideBar: false,
                        headerText: mainTitle
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
                        className: (0, $2vwrh.default)([
                            "_1pfh1bcc _181n11p5 _1j8b1ckl"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                                className: (0, $2vwrh.default)([
                                    "_6rthoxav _1lva1bcc _181n1txw"
                                ]),
                                children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $ktyxS.SolutionsCard), (0, $do9pw._)({}, workManagementCard))
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                                className: (0, $2vwrh.default)([
                                    "_6rthoxav _1lva1bcc _181n1txw"
                                ]),
                                children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $ktyxS.SolutionsCard), (0, $do9pw._)({}, itServiceManagementCard))
                            }),
                            /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                                className: (0, $2vwrh.default)([
                                    "_6rthoxav _1lva1bcc _181n1txw"
                                ]),
                                children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $ktyxS.SolutionsCard), (0, $do9pw._)({}, agileDevOpsCard))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
                className: (0, $2vwrh.default)([
                    "_1pfhhiv4 _1e0c11p5 _1j8b1ckl _19d7hkll"
                ]),
                children: [
                    /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                        className: (0, $2vwrh.default)([
                            "_6rthxjmg"
                        ]),
                        children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $bzS2B.ListOfLinks), (0, $do9pw._)({}, teamSizeListProps))
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                        className: (0, $2vwrh.default)([
                            "_6rthxjmg"
                        ]),
                        children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $bzS2B.ListOfLinks), (0, $do9pw._)({}, teamFunctionListProps))
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                        className: (0, $2vwrh.default)([
                            "_6rthxjmg"
                        ]),
                        children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $bzS2B.ListOfLinks), (0, $do9pw._)({}, industryListProps))
                    })
                ]
            })
        ]
    });
};
var $b7bed5d6e1b46a80$export$82cce7f9d365dc54 = function(param) {
    var className = param.className, productKey = param.productKey;
    var intl = (0, $8pPrt.default)();
    var sideBarTitle = intl.formatMessage({
        id: "solutions-dropdown.sidebar.title",
        defaultMessage: "What's new"
    });
    var listOfLinksProps = {
        isSideBar: true,
        headerText: intl.formatMessage({
            id: "solutions-dropdown.sidebar.helpful",
            defaultMessage: "You might find helpful"
        }),
        listOfLinkWithProps: [
            {
                href: (0, $hot2Q.useLocalizedHref)("/trust"),
                isHaveIcon: true,
                iconName: "securitycheckmark",
                linkText: intl.formatMessage({
                    id: "solutions-dropdown.sidebar.trust",
                    defaultMessage: "Atlassian Trust & Security"
                }),
                dataEventContainer: "globalNavWacDropdownContainer"
            },
            {
                href: (0, $hot2Q.useLocalizedHref)("/customers"),
                isHaveIcon: true,
                iconName: "building",
                linkText: intl.formatMessage({
                    id: "solutions-dropdown.sidebar.customers",
                    defaultMessage: "Customer Case Studies"
                }),
                dataEventContainer: "globalNavWacDropdownContainer"
            }
        ]
    };
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsx)((0, $7LDiG.ListOfLinksHeaderText), {
                isSideBar: false,
                headerText: sideBarTitle
            }),
            $b7bed5d6e1b46a80$var$FormatAtlassianTogether(productKey),
            /*#__PURE__*/ (0, $1rY3h.jsx)((0, $bzS2B.ListOfLinks), (0, $do9pw._)({}, listOfLinksProps))
        ]
    });
};

});
parcelRegister("h2Ufe", function(module, exports) {
$parcel$export(module.exports, "SolutionsCard", function () { return (parcelRequire("ktyxS")).SolutionsCard; });

var $ktyxS = parcelRequire("ktyxS");

});
parcelRegister("ktyxS", function(module, exports) {

$parcel$export(module.exports, "SolutionsCard", function () { return $8824abae657c84c3$export$7412cefcb7d2c833; });
/* solutions-card.tsx generated by @compiled/babel-plugin v0.28.2 */ /* eslint-disable complexity */ 
var $1rY3h = parcelRequire("1rY3h");
parcelRequire("1Mpn7");

var $2vwrh = parcelRequire("2vwrh");
var $bStPI = parcelRequire("bStPI");
parcelRequire("9DBuW");
var $hvst7 = parcelRequire("hvst7");
var $8824abae657c84c3$export$7412cefcb7d2c833 = function(param) {
    var href = param.href, title = param.title, body = param.body, icon = param.icon, gradient = param.gradient, className = param.className;
    var shadow = "var(--ds-space-025) var(--ds-space-025) var(--ds-space-150) #c1c7d0";
    var panelStyle = null;
    var textStyle = null;
    var iconStyle = null;
    return /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
        className: (0, $2vwrh.default)([
            "_1e0c1txw _1n261g80 _1itk7gp3 _2rkoh461 _kqswh2mm _v5641cdp _1dbz1e74 _16l4kb7n _1llw7tl6 _ez1yidpf _1b1b1h7a"
        ]),
        style: {
            "--_2f3x6c": (0, $bStPI.default)(gradient.firstColor),
            "--_1tnj67s": (0, $bStPI.default)(gradient.secondColor)
        },
        children: /*#__PURE__*/ (0, $1rY3h.jsxs)("a", {
            href: href,
            className: (0, $2vwrh.default)([
                "_4bfu1r31 _1hmsglyw _ajmmnqa1",
                className
            ]),
            "data-event": "clicked",
            "data-event-component": "linkButton",
            "data-event-container": "globalNavWacDropdownContainer",
            children: [
                /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
                    className: (0, $2vwrh.default)([
                        "_1e0c1ule _syazalr3 _1yt41bcc"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                            className: (0, $2vwrh.default)([
                                "_1wybxjmg"
                            ]),
                            children: title
                        }),
                        /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                            className: (0, $2vwrh.default)([
                                "_1pfh1bcc _1wybdlk8 _1e0c1txw _1n261g80"
                            ]),
                            children: body
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                    className: (0, $2vwrh.default)([
                        "_kqswstnw _rjxpidpf _152tidpf _1yt4xjmg"
                    ]),
                    children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $hvst7.Icon), {
                        name: icon,
                        size: "small",
                        color: "#172b4d"
                    })
                })
            ]
        })
    });
};

});



parcelRegister("3xTws", function(module, exports) {


module.exports = (parcelRequire("eg86f"))((parcelRequire("bRvn3")).resolve("67RI7")).then(function() {
    return parcelRequire("gQ2K1");
});

});


parcelRegister("a3t2U", function(module, exports) {

$parcel$export(module.exports, "BlogsSection", function () { return (parcelRequire("bGk4Z")).default; });
$parcel$export(module.exports, "CTASection", function () { return (parcelRequire("4Aeb4")).default; });
$parcel$export(module.exports, "DevOpsSection", function () { return (parcelRequire("9CZdO")).default; });
$parcel$export(module.exports, "HeroSectionControl", function () { return (parcelRequire("6CGhB")).default; });
$parcel$export(module.exports, "IntegrationSection", function () { return (parcelRequire("ijlgi")).default; });
$parcel$export(module.exports, "ScalingSection", function () { return (parcelRequire("hRgqn")).default; });
$parcel$export(module.exports, "JiraSoftwareNav", function () { return (parcelRequire("acPtc")).default; });
$parcel$export(module.exports, "TabsSection", function () { return (parcelRequire("5XId8")).default; });
$parcel$export(module.exports, "WorkflowSection", function () { return (parcelRequire("kPein")).default; });

var $bGk4Z = parcelRequire("bGk4Z");

var $4Aeb4 = parcelRequire("4Aeb4");

var $9CZdO = parcelRequire("9CZdO");

var $6CGhB = parcelRequire("6CGhB");

var $ijlgi = parcelRequire("ijlgi");

var $hRgqn = parcelRequire("hRgqn");

var $acPtc = parcelRequire("acPtc");

var $5XId8 = parcelRequire("5XId8");

var $kPein = parcelRequire("kPein");

});
parcelRegister("bGk4Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e26359df89cd1e6$export$2e2bcd8739ae039; });
/* blogs.tsx generated by @compiled/babel-plugin v0.28.2 */ 
var $1rY3h = parcelRequire("1rY3h");
parcelRequire("1Mpn7");

var $2vwrh = parcelRequire("2vwrh");

var $dFwuF = parcelRequire("dFwuF");
var $8pPrt = parcelRequire("8pPrt");
parcelRequire("8AsWs");
var $4OHyT = parcelRequire("4OHyT");
parcelRequire("55RaN");
var $6mH68 = parcelRequire("6mH68");
parcelRequire("2miCy");
var $7UzgT = parcelRequire("7UzgT");
var $hot2Q = parcelRequire("hot2Q");
var $9e26359df89cd1e6$var$blogLinkStyles = null;
var $9e26359df89cd1e6$var$blogSectionStyles = null;
var $9e26359df89cd1e6$var$flexWrap = null;
var $9e26359df89cd1e6$var$blogLinkTextStyles = null;
var $9e26359df89cd1e6$var$BlogsSection = function() {
    var intl = (0, $8pPrt.default)();
    return /*#__PURE__*/ (0, $1rY3h.jsx)("section", {
        className: (0, $2vwrh.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o _1yt41mnt _bfhku67f"
        ]),
        children: /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
            className: (0, $2vwrh.default)([
                "_1e0c1txw _p12f1git _1mjb1ule"
            ]),
            children: [
                /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
                    className: (0, $2vwrh.default)([
                        "_kzvi11p5 _1da7f9jr _19d7i47z"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                            className: (0, $2vwrh.default)([
                                "_1bsb1h3m _1yt4xjmg _1s4p1vuk _1e6zidpf _p0az1nbz"
                            ]),
                            children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $6mH68.Image), {
                                src: "https://wac-cdn.atlassian.com/dam/jcr:aa8f5b1f-b8ac-4d6e-9e7c-abe573b68164/number-one.svg?cdnVersion=1198",
                                alt: "#1"
                            })
                        }),
                        /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
                            className: (0, $2vwrh.default)([
                                "_ahbq1yxt _1yt4xjmg _glte1e9y _15paidpf _11eb1lne _cg41l4fm _1kll1k8s _q7gq1j6v _1adi4jg8 _125xl4fm"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $1rY3h.jsx)((0, $4OHyT.ContentBlock), {
                                    headerType: "h2",
                                    headerText: intl.formatMessage({
                                        id: "JiraSoftwarePageTemplate.blogsSection.headerText",
                                        defaultMessage: "Why Jira is the #1 tool recommended by agile teams.*"
                                    }),
                                    bodyText: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $dFwuF.default), {
                                        id: "JiraSoftwarePageTemplate.blogsSection.bodyText",
                                        defaultMessage: "Trusted by more than 100,000 organizations, Jira Software comes out-of-the-box with the features and best practices agile teams need to develop and evolve their agile practices.",
                                        values: (0, $7UzgT.DEFAULT_VALUES)
                                    })
                                }),
                                /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                                    className: (0, $2vwrh.default)([
                                        "_q7gq11yk _125xvwuj _clfdidpf _11pqidpf _q0a5idpf _c3k8idpf"
                                    ]),
                                    children: /*#__PURE__*/ (0, $1rY3h.jsx)("p", {
                                        children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $dFwuF.default), {
                                            id: "JiraSoftwarePageTemplate.blogsSection.contentFooter",
                                            defaultMessage: "*2021 State of Agile Report",
                                            values: (0, $7UzgT.DEFAULT_VALUES)
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
                            className: (0, $2vwrh.default)([
                                "_1e0c1txw _navj1g80"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $1rY3h.jsx)($9e26359df89cd1e6$var$BlogLink, {
                                    imageSrc: "https://wac-cdn.atlassian.com/dam/jcr:c30fba51-a9ab-4815-ad95-83e3f7582349/resource-agile.png?cdnVersion=1198",
                                    imageAlt: intl.formatMessage({
                                        id: "JiraSoftwarePageTemplate.blogsSection.agileAltText",
                                        defaultMessage: "Agile illustration"
                                    }),
                                    href: (0, $hot2Q.useLocalizedHref)("/agile"),
                                    linkText: intl.formatMessage({
                                        id: "JiraSoftwarePageTemplate.blogsSection.agileLinkText",
                                        defaultMessage: "Learn agile best practices"
                                    })
                                }),
                                /*#__PURE__*/ (0, $1rY3h.jsx)($9e26359df89cd1e6$var$BlogLink, {
                                    imageSrc: "https://wac-cdn.atlassian.com/misc-assets/webp-images/resource-playbook.webp",
                                    imageAlt: intl.formatMessage({
                                        id: "JiraSoftwarePageTemplate.blogsSection.teamPlaybookAltText",
                                        defaultMessage: "Team playbook illustration"
                                    }),
                                    href: (0, $hot2Q.useLocalizedHref)("/team-playbook"),
                                    linkText: intl.formatMessage({
                                        id: "JiraSoftwarePageTemplate.blogsSection.teamPlaybookLinkText",
                                        defaultMessage: "Team Playbook"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
                            className: (0, $2vwrh.default)([
                                "_1e0c1txw _navj1g80"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $1rY3h.jsx)($9e26359df89cd1e6$var$BlogLink, {
                                    imageSrc: "https://wac-cdn.atlassian.com/misc-assets/webp-images/resource-community.webp",
                                    imageAlt: intl.formatMessage({
                                        id: "JiraSoftwarePageTemplate.blogsSection.communityAltText",
                                        defaultMessage: "Community illustration"
                                    }),
                                    href: "https://community.atlassian.com/",
                                    linkText: intl.formatMessage({
                                        id: "JiraSoftwarePageTemplate.blogsSection.communityLinkText",
                                        defaultMessage: "Jira Software community"
                                    })
                                }),
                                /*#__PURE__*/ (0, $1rY3h.jsx)($9e26359df89cd1e6$var$BlogLink, {
                                    imageSrc: "https://wac-cdn.atlassian.com/dam/jcr:1de028c2-f441-40e9-b3ee-721e35e4a649/resource-devops.png?cdnVersion=1198",
                                    imageAlt: intl.formatMessage({
                                        id: "JiraSoftwarePageTemplate.blogsSection.devOpsAltText",
                                        defaultMessage: "DevOps loop illustration"
                                    }),
                                    href: (0, $hot2Q.useLocalizedHref)("/devops"),
                                    linkText: intl.formatMessage({
                                        id: "JiraSoftwarePageTemplate.blogsSection.devOpsLinkText",
                                        defaultMessage: "Learn DevOps best practices"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $9e26359df89cd1e6$var$BlogLink = function(props) {
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
        className: (0, $2vwrh.default)([
            "_18s81llo _1wybxjmg _1iu21eps"
        ]),
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsx)("a", {
                href: props.href,
                "data-event-component": "linkButton",
                "data-event-container": "blogsSection",
                "data-event": "clicked",
                "data-label": props.linkText,
                "data-product-key": "jiraSoftware",
                children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $6mH68.Image), {
                    src: props.imageSrc,
                    alt: props.imageAlt,
                    aspectRatio: "16/9"
                })
            }),
            $9e26359df89cd1e6$var$blogLinkText(props.href, props.linkText)
        ]
    });
};
var $9e26359df89cd1e6$var$blogLinkText = function(href, linkText) {
    return /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
        children: /*#__PURE__*/ (0, $1rY3h.jsx)("a", {
            href: href,
            "data-event-component": "linkButton",
            "data-event-container": "blogsSection",
            "data-event": "clicked",
            "data-label": linkText,
            "data-product-key": "jiraSoftware",
            className: (0, $2vwrh.default)([
                "_ysv7rbzz _1053rbzz _5bd61r31 _1ydc1r31 _13jxglyw _1x28glyw _xatrnqa1 _1726nqa1 _30l3oelr _1mfn1gfk _nalzh461 _1y8f1r31 _kttp8stv _14t1nqa1"
            ]),
            children: /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
                className: (0, $2vwrh.default)([
                    "_1e0c116y _1wybxjmg",
                    "link-text"
                ]),
                children: [
                    linkText,
                    /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                        className: "link-arrow",
                        children: $9e26359df89cd1e6$var$linkArrow()
                    })
                ]
            })
        })
    });
};
var $9e26359df89cd1e6$var$linkArrow = function() {
    return /*#__PURE__*/ (0, $1rY3h.jsx)("svg", {
        fill: "currentColor",
        width: "11",
        height: "8",
        viewBox: "0 0 11 8",
        xmlns: "http://www.w3.org/2000/svg",
        className: (0, $2vwrh.default)([
            "_ahbq1oug"
        ]),
        children: /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.40796 0L6.32831 1.2021L8.07854 3.1497H0.763182C0.341906 3.1497 0 3.53038 0 3.99943C0 4.46849 0.341906 4.84917 0.763182 4.84917H8.07854L6.32831 6.7979L7.40796 8L11 3.99943L7.40796 0Z"
        })
    });
};
var $9e26359df89cd1e6$export$2e2bcd8739ae039 = $9e26359df89cd1e6$var$BlogsSection;

});
parcelRegister("8AsWs", function(module, exports) {
$parcel$export(module.exports, "ContentBlock", function () { return (parcelRequire("4OHyT")).ContentBlock; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("4OHyT")).ContentBlock; });

var $4OHyT = parcelRequire("4OHyT");

});
parcelRegister("4OHyT", function(module, exports) {

$parcel$export(module.exports, "ContentBlock", function () { return $6c191bb16ffea754$export$eb38b3b9c7f5f31b; });
/* content-block.tsx generated by @compiled/babel-plugin v0.28.2 */ 
var $do9pw = parcelRequire("do9pw");

var $1rY3h = parcelRequire("1rY3h");

var $1Mpn7 = parcelRequire("1Mpn7");

var $2vwrh = parcelRequire("2vwrh");
parcelRequire("9DBuW");
var $hvst7 = parcelRequire("hvst7");
parcelRequire("iH8wz");
var $hR975 = parcelRequire("hR975");
parcelRequire("55RaN");
var $6mH68 = parcelRequire("6mH68");
parcelRequire("dLifx");
var $6WnuF = parcelRequire("6WnuF");
function $6c191bb16ffea754$var$getHeaderTag(text, header) {
    var headerTag = header ? header : "h3";
    return /*#__PURE__*/ (0, $1Mpn7.createElement)(headerTag, null, text);
}
/* Gives h tag one less than header */ function $6c191bb16ffea754$var$getEyebrowTag(headerType, eyebrowText) {
    var tagNumber = headerType ? Number(headerType.slice(-1)) : 5;
    return /*#__PURE__*/ (0, $1Mpn7.createElement)("h".concat(tagNumber + 1), {
        className: "contentBlock-eyebrow"
    }, eyebrowText);
}
function $6c191bb16ffea754$var$renderLinks(ctaProps) {
    if (!ctaProps) return null;
    var firstLink;
    if ("buttonProps" in ctaProps) firstLink = /*#__PURE__*/ (0, $1rY3h.jsx)((0, $hR975.Button), (0, $do9pw._)({}, ctaProps.buttonProps));
    else if ("primaryLinkProps" in ctaProps && ctaProps.primaryLinkProps) firstLink = /*#__PURE__*/ (0, $1rY3h.jsx)((0, $6WnuF.Link), (0, $do9pw._)({}, ctaProps.primaryLinkProps));
    var secondaryLink = "secondaryLinkProps" in ctaProps ? /*#__PURE__*/ (0, $1rY3h.jsx)((0, $6WnuF.Link), (0, $do9pw._)({}, ctaProps.secondaryLinkProps)) : null;
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
        className: "contentBlock-linkFlex",
        children: [
            firstLink,
            secondaryLink
        ]
    });
}
/**
 * This method retrieves either the eyebrow or icon decoration. If both are present, the icon is returned.
 * @param headerType
 */ var $6c191bb16ffea754$var$getDecoration = function(headerType, eyebrowText, iconName, iconColor) {
    if (iconName) return /*#__PURE__*/ (0, $1rY3h.jsx)((0, $hvst7.Icon), {
        name: iconName,
        color: iconColor
    });
    else if (eyebrowText) return $6c191bb16ffea754$var$getEyebrowTag(headerType, eyebrowText);
    return null;
};
var $6c191bb16ffea754$var$getImage = function(pictureProps, imageLink, imageAltText, aspectRatio) {
    if (pictureProps) return /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
        className: "img-section",
        children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $6mH68.Picture), (0, $do9pw._)({}, pictureProps))
    });
    else if (imageLink && imageAltText) return /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
        className: "img-section",
        children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $6mH68.Image), {
            src: imageLink,
            alt: imageAltText,
            aspectRatio: aspectRatio
        })
    });
    else return null;
};
var $6c191bb16ffea754$export$eb38b3b9c7f5f31b = function(param) {
    var headerText = param.headerText, bodyText = param.bodyText, _param_headerType = param.headerType, headerType = _param_headerType === void 0 ? "h3" : _param_headerType, eyebrowText = param.eyebrowText, _param_className = param.className, className = _param_className === void 0 ? "" : _param_className, imageLink = param.imageLink, imageAltText = param.imageAltText, pictureProps = param.pictureProps, iconName = param.iconName, iconColor = param.iconColor, ctaProps = param.ctaProps, _param_aspectRatio = param.aspectRatio, aspectRatio = _param_aspectRatio === void 0 ? "1/1" : _param_aspectRatio, orientation = param.orientation, cardStyle = param.cardStyle, _param_isCentered = param.isCentered, isCentered = _param_isCentered === void 0 ? false : _param_isCentered, horizontalRule = param.horizontalRule;
    if (imageLink && !imageAltText) throw new Error("If using an image, please provide an alt text for accessibility purposes!");
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
        className: (0, $2vwrh.default)([
            isCentered && orientation === "horizontal" && cardStyle && headerType === "h1" && "_1e0c11p5 _yv0e1ewx _zulp1j6v _1s8mi47z _1wm0idpf _1br3idpf _1xqk1ule _1wmp1osq _a5ip1osq _z5ukgktf _1boagktf _16itgktf _ad5cgktf _1xqd1h6o _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _q7gq1k92 _ecfq8ypw _1csa1td8 _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1h6o _6o9b1h6o",
            isCentered && orientation === "horizontal" && !cardStyle && headerType === "h1" && "_1e0c11p5 _yv0e1ewx _zulp1j6v _1s8mi47z _1wm0idpf _1br3idpf _1xqk1ule _1wmp1osq _a5ip1osq _1ma11kwk _1xqd1h6o _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _q7gq1k92 _ecfq8ypw _1csa1td8 _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1h6o _6o9b1h6o",
            !isCentered && orientation === "horizontal" && cardStyle && headerType === "h1" && "_1e0c11p5 _yv0e1ewx _zulp1j6v _1s8mi47z _1wm0idpf _1br3idpf _1xqk1ule _1wmp1osq _z5ukgktf _1boagktf _16itgktf _ad5cgktf _1xqd1e5h _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _q7gq1k92 _ecfq8ypw _1csa1td8 _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1y6m _6o9b1h6o",
            !isCentered && orientation === "horizontal" && !cardStyle && headerType === "h1" && "_1e0c11p5 _yv0e1ewx _zulp1j6v _1s8mi47z _1wm0idpf _1br3idpf _1xqk1ule _1wmp1osq _1ma11kwk _1xqd1e5h _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _q7gq1k92 _ecfq8ypw _1csa1td8 _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1y6m _6o9b1h6o",
            isCentered && orientation === "horizontal" && cardStyle && headerType !== "h1" && "_1e0c11p5 _yv0e1ewx _zulp1j6v _1s8mi47z _1wm0idpf _1br3idpf _1xqk1ule _1wmp1osq _z5ukgktf _1boagktf _16itgktf _ad5cgktf _1xqd1h6o _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1h6o _6o9b1h6o",
            isCentered && orientation === "horizontal" && !cardStyle && headerType !== "h1" && "_1e0c11p5 _yv0e1ewx _zulp1j6v _1s8mi47z _1wm0idpf _1br3idpf _1xqk1ule _1wmp1osq _a5ip1osq _1ma11kwk _1xqd1h6o _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1h6o _6o9b1h6o",
            !isCentered && orientation === "horizontal" && cardStyle && headerType !== "h1" && "_1e0c11p5 _yv0e1ewx _zulp1j6v _1s8mi47z _1wm0idpf _1br3idpf _1xqk1ule _1wmp1osq _z5ukgktf _1boagktf _16itgktf _ad5cgktf _1xqd1e5h _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1y6m _6o9b1h6o",
            !isCentered && orientation === "horizontal" && !cardStyle && headerType !== "h1" && "_1e0c11p5 _yv0e1ewx _zulp1j6v _1s8mi47z _1wm0idpf _1br3idpf _1xqk1ule _1wmp1osq _1ma11kwk _1xqd1e5h _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1y6m _6o9b1h6o",
            isCentered && orientation !== "horizontal" && cardStyle && headerType === "h1" && "_1e0c1txw _2lx21bp4 _1br3idpf _1xqk1ule _1wmp1osq _z5ukgktf _1boagktf _16itgktf _ad5cgktf _1xqd1h6o _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _q7gq1k92 _ecfq8ypw _1csa1td8 _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1h6o _6o9b1h6o",
            isCentered && orientation !== "horizontal" && !cardStyle && headerType !== "h1" && "_1e0c1txw _2lx21bp4 _1br3idpf _1xqk1ule _1wmp1osq _1xqd1h6o _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1h6o _6o9b1h6o",
            !isCentered && orientation !== "horizontal" && cardStyle && headerType === "h1" && "_1e0c1txw _2lx21bp4 _1br3idpf _1xqk1ule _1wmp1osq _z5ukgktf _1boagktf _16itgktf _ad5cgktf _1xqd1e5h _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _q7gq1k92 _ecfq8ypw _1csa1td8 _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1y6m _6o9b1h6o",
            !isCentered && orientation !== "horizontal" && !cardStyle && headerType === "h1" && "_1e0c1txw _2lx21bp4 _1br3idpf _1xqk1ule _1wmp1osq _1ma11kwk _1xqd1e5h _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _q7gq1k92 _ecfq8ypw _1csa1td8 _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1y6m _6o9b1h6o",
            isCentered && orientation !== "horizontal" && cardStyle && headerType !== "h1" && "_1e0c1txw _2lx21bp4 _1br3idpf _1xqk1ule _1wmp1osq _z5ukgktf _1boagktf _16itgktf _ad5cgktf _1xqd1h6o _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1h6o _6o9b1h6o",
            !isCentered && orientation !== "horizontal" && cardStyle && headerType !== "h1" && "_1e0c1txw _2lx21bp4 _1br3idpf _1xqk1ule _1wmp1osq _z5ukgktf _1boagktf _16itgktf _ad5cgktf _1xqd1e5h _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1y6m _6o9b1h6o",
            !isCentered && orientation !== "horizontal" && !cardStyle && headerType !== "h1" && "_1e0c1txw _2lx21bp4 _1br3idpf _1xqk1ule _1wmp1osq _1ma11kwk _1xqd1e5h _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1y6m _6o9b1h6o",
            "content-block ".concat(className)
        ]),
        children: [
            $6c191bb16ffea754$var$getImage(pictureProps, imageLink, imageAltText, aspectRatio),
            /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
                className: "text-section",
                children: [
                    headerText && $6c191bb16ffea754$var$getHeaderTag(headerText, headerType),
                    $6c191bb16ffea754$var$getDecoration(headerType, eyebrowText, iconName, iconColor),
                    horizontalRule && /*#__PURE__*/ (0, $1rY3h.jsx)("hr", {
                        className: (0, $2vwrh.default)([
                            "_4t3iyh40 _p12f1fra"
                        ])
                    }),
                    bodyText && /*#__PURE__*/ (0, $1rY3h.jsx)("p", {
                        className: "contentBlock-body",
                        children: bodyText
                    }),
                    $6c191bb16ffea754$var$renderLinks(ctaProps)
                ]
            })
        ]
    });
};

});
parcelRegister("55RaN", function(module, exports) {
$parcel$export(module.exports, "Image", function () { return (parcelRequire("6mH68")).Image; });
$parcel$export(module.exports, "Picture", function () { return (parcelRequire("6mH68")).Picture; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("6mH68")).Image; });

var $6mH68 = parcelRequire("6mH68");

});
parcelRegister("6mH68", function(module, exports) {

$parcel$export(module.exports, "Image", function () { return $b2a71c6ff68d3d43$export$3e431a229df88919; });
$parcel$export(module.exports, "Picture", function () { return $b2a71c6ff68d3d43$export$f0d5dc2ce3e4cb5f; });

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $dRLPW = parcelRequire("dRLPW");

var $1rY3h = parcelRequire("1rY3h");
var $b2a71c6ff68d3d43$var$imageCSS = function(ratio) {
    var aspectRatioCSS = ratio && ratio !== "none" ? {
        aspectRatio: ratio,
        objectFit: "cover",
        width: "100%"
    } : {};
    return (0, $do9pw._)({
        maxWidth: "100%"
    }, aspectRatioCSS);
};
var $b2a71c6ff68d3d43$export$3e431a229df88919 = function(_param) {
    var src = _param.src, alt = _param.alt, aspectRatio = _param.aspectRatio, rest = (0, $dRLPW._)(_param, [
        "src",
        "alt",
        "aspectRatio"
    ]);
    return /*#__PURE__*/ (0, $1rY3h.jsx)("img", (0, $do9pw._)({
        src: src,
        alt: alt,
        style: $b2a71c6ff68d3d43$var$imageCSS(aspectRatio)
    }, rest));
};
var $b2a71c6ff68d3d43$export$f0d5dc2ce3e4cb5f = function(_param) {
    var sources = _param.sources, _param_image = _param.image, src = _param_image.src, alt = _param_image.alt, aspectRatio = _param_image.aspectRatio, image = (0, $dRLPW._)(_param.image, [
        "src",
        "alt",
        "aspectRatio"
    ]);
    return sources ? /*#__PURE__*/ (0, $1rY3h.jsxs)("picture", {
        children: [
            sources.map(function(source, index) {
                return /*#__PURE__*/ (0, $1rY3h.jsx)("source", (0, $do9pw._)({}, source), index);
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("img", (0, $cxjpp._)((0, $do9pw._)({}, image), {
                src: src,
                alt: alt,
                style: $b2a71c6ff68d3d43$var$imageCSS(aspectRatio)
            }))
        ]
    }) : /*#__PURE__*/ (0, $1rY3h.jsx)("img", (0, $cxjpp._)((0, $do9pw._)({}, image), {
        src: src,
        alt: alt,
        style: $b2a71c6ff68d3d43$var$imageCSS(aspectRatio)
    }));
};

});





parcelRegister("4Aeb4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e0eb778f342318d$export$2e2bcd8739ae039; });
/* cta.tsx generated by @compiled/babel-plugin v0.28.2 */ 
var $1rY3h = parcelRequire("1rY3h");
parcelRequire("1Mpn7");

var $2vwrh = parcelRequire("2vwrh");

var $8pPrt = parcelRequire("8pPrt");
parcelRequire("8AsWs");
var $4OHyT = parcelRequire("4OHyT");
parcelRequire("dLifx");
var $6WnuF = parcelRequire("6WnuF");
parcelRequire("2miCy");
var $hot2Q = parcelRequire("hot2Q");
var $9e0eb778f342318d$var$CTASection = function() {
    var intl = (0, $8pPrt.default)();
    var linkDataEventProps = {
        "data-event-component": "linkButton",
        "data-event-container": "ctaSection",
        "data-event": "clicked",
        "data-product-key": "jiraSoftware"
    };
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("section", {
        className: (0, $2vwrh.default)([
            "_4cvr1h6o _bfhk1mpp _syazu67f _1e0c1txw _2lx21bp4 _zulp1tcg _ca0qzwfg _u5f3idpf _n3tdzwfg _19bvidpf _11ebahaf _8v2f1td8 _l5k1bfng _1kll1k8s _1nte1td8 _1qnibfng _1a7ix7w3 _ma1vi0pe _knqji0pe _sj7ki0pe _bnxci0pe _w5ku1r31 _zs4t8stv _1tjrnqa1 _1m2pvkbu"
        ]),
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsx)((0, $4OHyT.ContentBlock), {
                headerType: "h2",
                headerText: intl.formatMessage({
                    id: "JiraSoftwarePageTemplate.ctaSection.getStarted",
                    defaultMessage: "Get Started with Jira Software"
                }),
                orientation: "vertical",
                ctaProps: {
                    buttonProps: {
                        text: intl.formatMessage({
                            id: "JiraSoftwarePageTemplate.ctaSection.getItFree",
                            defaultMessage: "Get it free"
                        }),
                        color: "yellow",
                        url: (0, $hot2Q.useLocalizedHref)("/software/jira/free"),
                        dataEventProps: linkDataEventProps
                    }
                },
                isCentered: true
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)((0, $6WnuF.Link), {
                className: "features-link",
                href: (0, $hot2Q.useLocalizedHref)("/software/jira/features"),
                text: intl.formatMessage({
                    id: "JiraSoftwarePageTemplate.ctaSection.seeFeatures",
                    defaultMessage: "See features"
                }),
                bgColor: "bgDark",
                dataEventProps: linkDataEventProps
            })
        ]
    });
};
var $9e0eb778f342318d$export$2e2bcd8739ae039 = $9e0eb778f342318d$var$CTASection;

});

parcelRegister("9CZdO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bbb6467fbbf23336$export$2e2bcd8739ae039; });
/* dev-ops.tsx generated by @compiled/babel-plugin v0.28.2 */ 
var $1rY3h = parcelRequire("1rY3h");
parcelRequire("1Mpn7");

var $2vwrh = parcelRequire("2vwrh");

var $dFwuF = parcelRequire("dFwuF");
var $8pPrt = parcelRequire("8pPrt");
parcelRequire("8AsWs");
var $4OHyT = parcelRequire("4OHyT");
parcelRequire("55RaN");
var $6mH68 = parcelRequire("6mH68");
parcelRequire("2miCy");
var $7UzgT = parcelRequire("7UzgT");

var $bvCMH = parcelRequire("bvCMH");
var $bbb6467fbbf23336$var$devOpsSectionStyle = null;
var $bbb6467fbbf23336$var$DevOpsSection = function() {
    var intl = (0, $8pPrt.default)();
    return /*#__PURE__*/ (0, $1rY3h.jsx)("section", {
        className: (0, $2vwrh.default)([
            "_1itkomr4 _ouxl1ssb _12vemgnk _1lrw1dfr _syazu67f _ca0q16xz _u5f316xz _n3td16xz _19bvidpf _ai3d7vkz _fglvidpf _y5sa7vkz _1a4pidpf _1qj84jg8 _3skuahaf _1lcr1k8s _1oebvbgk _g5nwidpf _1sl9vbgk _1bkeidpf _18k6idpf _1i1pidpf _i6bg19bv _16tsidpf _1e02oqnp _3nsg4jg8 _5k96angw _vdmg1j6v _1ic74jg8 _1bl7bs82 _19p2ahaf _1o7bbfng _r6guclii _yhom1hwh _2gm6idpf _lgxkidpf _11sridpf _1217idpf _2wcg1k92 _1ghd1nn1 _9brunl7k _11mk19ii _5c641txw _1o2r1bp4 _1von1h6o _1ufw7vkz _qaroidpf _3ogj7vkz _1r46idpf _1fwdglyw _1khm1bp4 _1vh71h6o _5cwf7vkz _uok1idpf _15x77vkz _1l1jidpf _yerozwfg _235vidpf _ugxvzwfg _1v4xidpf _1y7y7vkz _1ewg1w81 _1fes1vuk _1em61bp9 _n1ju1wug _1sly1wug _exgw1wug _ow8r1wug _jss411p5 _1p0waj1j _17eu1a0z _15txxjmg _ofslglyw _1lhl1ule"
        ]),
        children: /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
            className: "section-container",
            children: [
                /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                    className: "desktop-img",
                    children: /*#__PURE__*/ (0, $1rY3h.jsx)($bbb6467fbbf23336$var$DevOpsImage, {})
                }),
                /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
                    className: "content-container",
                    children: [
                        /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                            className: "dev-ops-content",
                            children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $4OHyT.ContentBlock), {
                                headerType: "h2",
                                headerText: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $dFwuF.default), {
                                    id: "JiraSoftwarePageTemplate.devOpsSection.header",
                                    defaultMessage: "Let developers focus on code",
                                    values: (0, $7UzgT.DEFAULT_VALUES)
                                }),
                                bodyText: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $dFwuF.default), {
                                    id: "JiraSoftwarePageTemplate.devOpsSection.body",
                                    defaultMessage: "Developers want to focus on code, not update issues. We get it! Open DevOps makes it easier to do both regardless of the tools you use. Now developers can stay focused and the business can stay aligned.",
                                    values: (0, $7UzgT.DEFAULT_VALUES)
                                }),
                                ctaProps: {
                                    buttonProps: {
                                        text: intl.formatMessage({
                                            id: "JiraSoftwarePageTemplate.devOpsSection.cta",
                                            defaultMessage: "Explore Open DevOps"
                                        }),
                                        url: "https://www.atlassian.com/solutions/devops",
                                        type: "secondary",
                                        color: "white",
                                        size: "small",
                                        dataEventProps: {
                                            "data-event-component": "linkButton",
                                            "data-event-container": "devOpsSection",
                                            "data-event": "clicked",
                                            "data-product-key": "jiraSoftware"
                                        }
                                    }
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                            className: "mobile-img",
                            children: /*#__PURE__*/ (0, $1rY3h.jsx)($bbb6467fbbf23336$var$DevOpsImage, {})
                        }),
                        /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
                            className: "benefits-container",
                            children: [
                                /*#__PURE__*/ (0, $1rY3h.jsx)("h3", {
                                    children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $dFwuF.default), {
                                        id: "JiraSoftwarePageTemplate.devOpsSection.benefits",
                                        defaultMessage: "How customers are benefiting",
                                        values: (0, $7UzgT.DEFAULT_VALUES)
                                    })
                                }),
                                /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                                    className: "company-image-container",
                                    children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $6mH68.Image), {
                                        src: "https://wac-cdn.atlassian.com/dam/jcr:c137f24d-10a9-473e-bbcc-0fababfb9857/FLO_logo_horizontal_white%201.png?cdnVersion=1196",
                                        alt: intl.formatMessage({
                                            id: "JiraSoftwarePageTemplate.devOpsSection.flowLogoAlt",
                                            defaultMessage: "Flow company logo"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $1rY3h.jsxs)("h4", {
                                    children: [
                                        /*#__PURE__*/ (0, $1rY3h.jsx)((0, $dFwuF.default), {
                                            id: "JiraSoftwarePageTemplate.devOpsSection.floIncreasePercent",
                                            defaultMessage: "900%",
                                            values: (0, $7UzgT.DEFAULT_VALUES)
                                        }),
                                        /*#__PURE__*/ (0, $1rY3h.jsx)((0, $dFwuF.default), {
                                            id: "JiraSoftwarePageTemplate.devOpsSection.floIncreaseMessage",
                                            defaultMessage: "<p>increase in deployments</p>",
                                            values: (0, $7UzgT.DEFAULT_VALUES)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $1rY3h.jsxs)("h4", {
                                    children: [
                                        /*#__PURE__*/ (0, $1rY3h.jsx)((0, $dFwuF.default), {
                                            id: "JiraSoftwarePageTemplate.devOpsSection.floDecreasePercent",
                                            defaultMessage: "50%"
                                        }),
                                        /*#__PURE__*/ (0, $1rY3h.jsx)((0, $dFwuF.default), {
                                            id: "JiraSoftwarePageTemplate.devOpsSection.floDecreaseMessage",
                                            defaultMessage: "<p>decrease in cycle time</p>",
                                            values: (0, $7UzgT.DEFAULT_VALUES)
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $bbb6467fbbf23336$var$DevOpsImage = function() {
    var intl = (0, $8pPrt.default)();
    var localizedImageSrc = (0, $bvCMH.getDevOpsSectionImage)(intl.locale);
    return /*#__PURE__*/ (0, $1rY3h.jsx)((0, $6mH68.Image), {
        src: localizedImageSrc,
        alt: intl.formatMessage({
            id: "JiraSoftwarePageTemplate.devOpsSection.imageAlt",
            defaultMessage: "Jira Software DevOps diagram: Plan, code, deploy, operate, and collaborate"
        })
    });
};
var $bbb6467fbbf23336$export$2e2bcd8739ae039 = $bbb6467fbbf23336$var$DevOpsSection;

});
parcelRegister("bvCMH", function(module, exports) {

$parcel$export(module.exports, "getDevOpsSectionImage", function () { return $16e28dc2ebb93a44$export$f5fc726b1f3a764d; });
$parcel$export(module.exports, "getHeroSectionImage", function () { return $16e28dc2ebb93a44$export$55b4ecbb6fe6298e; });
$parcel$export(module.exports, "getPlanTabsSectionImage", function () { return $16e28dc2ebb93a44$export$d0eb8e3477c372df; });
$parcel$export(module.exports, "getPlanTabsSectionVideo", function () { return $16e28dc2ebb93a44$export$1185e048a42a7692; });
$parcel$export(module.exports, "getTrackTabsSectionImage", function () { return $16e28dc2ebb93a44$export$3cebe896652d6248; });
$parcel$export(module.exports, "getReleaseTabsSectionImage", function () { return $16e28dc2ebb93a44$export$dbda4fbdc6bac37c; });
$parcel$export(module.exports, "getReportTabsSectionImage", function () { return $16e28dc2ebb93a44$export$7e0f538c5fb0ac2d; });
$parcel$export(module.exports, "getAutomateTabsSectionImage", function () { return $16e28dc2ebb93a44$export$7a3d5ba0eee41c3d; });
$parcel$export(module.exports, "getWorkflowSectionImage", function () { return $16e28dc2ebb93a44$export$af440fac00a2a630; });
// no localized image for hu, it, ko, nl, pl, zh
var $16e28dc2ebb93a44$var$devOpsSectionImageMap = {
    de: "https://wac-cdn.atlassian.com/dam/jcr:a0b944ea-1046-4d41-a92d-5c90ec1d4fc7/devops-diagram-compressed.png?cdnVersion=1234",
    es: "https://wac-cdn.atlassian.com/dam/jcr:5c9e9577-c614-409b-9a77-6066cd098fd0/devops-diagram-compressed.png?cdnVersion=1234",
    fr: "https://wac-cdn.atlassian.com/dam/jcr:29249a01-930d-4581-817d-e6a5a2fc7ee5/devops-diagram-compressed.png?cdnVersion=1234",
    br: "https://wac-cdn.atlassian.com/dam/jcr:40ae976e-4ce9-4b16-a0b1-b03d5c513afb/devops-diagram-compressed.png?cdnVersion=1234",
    en: "https://wac-cdn.atlassian.com/dam/jcr:7eb430e2-e868-4f2d-973d-b5d6314e3d8d/devops-diagram-compressed.png?cdnVersion=1195",
    ja: "https://wac-cdn.atlassian.com/dam/jcr:9107fd14-0119-4612-898a-91f1b28cc5a2/devops-diagram-compressed.png?cdnVersion=1232",
    ru: "https://wac-cdn.atlassian.com/dam/jcr:d8679854-700d-43b6-8666-011568c3fe88/devops-diagram-compressed.png?cdnVersion=1234"
};
// no localized image for hu, it, ko, nl, pl, zh
var $16e28dc2ebb93a44$var$heroSectionImageMap = {
    de: "https://wac-cdn.atlassian.com/dam/jcr:a0aa83d8-cae8-40e5-8e08-d08072005fad/hero-illustration%20(1).png?cdnVersion=1234",
    en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_ProductTour_DarkModeIllustration_Hero.webp",
    es: "https://wac-cdn.atlassian.com/dam/jcr:2364d326-6464-409e-b218-faad35118be4/hero-illustration%20(1).png?cdnVersion=1234",
    fr: "https://wac-cdn.atlassian.com/dam/jcr:4968f3cd-2b82-41ef-9dac-e5057dd324f0/hero-illustration%20(1).png?cdnVersion=1234",
    ja: "https://wac-cdn.atlassian.com/dam/jcr:f1f2c4a5-2899-42f9-8f61-00aba6f0f1ff/hero-illustration%20(1).png?cdnVersion=1232",
    br: "https://wac-cdn.atlassian.com/dam/jcr:3fb66ce1-2dc1-4b17-99b6-cf366afcface/hero-illustration%20(1).png?cdnVersion=1234",
    ru: "https://wac-cdn.atlassian.com/dam/jcr:e32254d7-5bef-4ffa-adae-0192c1d98074/hero-illustration%20(1).png?cdnVersion=1234"
};
// no localized images available for the placeholder image for the plan tab video
var $16e28dc2ebb93a44$var$planTabsSectionImageMap = {
    en: "https://wac-cdn.atlassian.com/dam/jcr:49c215de-3b05-40f8-96e2-6dc65c70caa6/Board.png?cdnVersion=1187"
};
// no localized image for hu, it, ko, nl, pl, zh
var $16e28dc2ebb93a44$var$planTabsSectionVideoMap = {
    en: "https://wac-cdn-2.atlassian.com/video/upload/f_auto,q_auto/misc-assets/videos/jira-software/JSW-Plan.mp4",
    ja: "https://wac-cdn-2.atlassian.com/video/upload/f_auto,q_auto/misc-assets/videos/jira-software/JA/JSW-Plan-JA.mp4",
    de: "https://wac-cdn-2.atlassian.com/video/upload/f_auto,q_auto/misc-assets/videos/jira-software/DE/JSW-Plan-DE.mp4",
    es: "https://wac-cdn-2.atlassian.com/video/upload/f_auto,q_auto/misc-assets/videos/jira-software/ES/JSW-Plan-ES.mp4",
    fr: "https://wac-cdn-2.atlassian.com/video/upload/f_auto,q_auto/misc-assets/videos/jira-software/FR/JSW-Plan-FR.mp4",
    br: "https://wac-cdn-2.atlassian.com/video/upload/f_auto,q_auto/misc-assets/videos/jira-software/PT/JSW-Plan-PT-BR.mp4",
    ru: "https://wac-cdn-2.atlassian.com/video/upload/f_auto,q_auto/misc-assets/videos/jira-software/RU/JSW-Plan-RU.mp4"
};
// no localized images available
var $16e28dc2ebb93a44$var$trackTabsSectionImageMap = {
    en: "https://wac-cdn.atlassian.com/dam/jcr:7adc5875-52b0-4fa5-bcd0-c24daa205d0d/Timeline.png?cdnVersion=1192"
};
// no localized images available
var $16e28dc2ebb93a44$var$releaseTabsSectionImageMap = {
    en: "https://wac-cdn.atlassian.com/dam/jcr:709971e1-5536-4739-8e44-e38541091e9a/Releases.png?cdnVersion=1192"
};
// no localized images available
var $16e28dc2ebb93a44$var$reportTabsSectionImageMap = {
    en: "https://wac-cdn.atlassian.com/dam/jcr:3a0e3680-c9a9-4b9d-bb63-fe5995db85f3/Insights.png?cdnVersion=1192"
};
// no localized images available
var $16e28dc2ebb93a44$var$automateTabsSectionImageMap = {
    en: "https://wac-cdn.atlassian.com/dam/jcr:16dcb91e-8263-4ea8-91af-a8eedfc99700/Automation.png?cdnVersion=1192"
};
// no localized image for hu, it, ko, nl, pl, zh
var $16e28dc2ebb93a44$var$workflowSectionImageMap = {
    de: "https://wac-cdn.atlassian.com/dam/jcr:13006b4d-1461-4392-a11a-4bcf6e086788/workflow.png?cdnVersion=1234",
    es: "https://wac-cdn.atlassian.com/dam/jcr:7b3d5b36-147c-49ea-9ee6-8de21ea19059/workflow.png?cdnVersion=1234",
    fr: "https://wac-cdn.atlassian.com/dam/jcr:58f20760-b605-4378-b53b-17c9fdb77b3b/workflow.png?cdnVersion=1234",
    br: "https://wac-cdn.atlassian.com/dam/jcr:381387d5-6e0b-46d6-9c38-eda6e193adc9/workflow.png?cdnVersion=1234",
    ru: "https://wac-cdn.atlassian.com/dam/jcr:22282735-3e16-4e41-9f0d-90af8d47485d/workflow.png?cdnVersion=1234",
    en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_ProductTour_DarkModeIllustration_Workflow.webp",
    ja: "https://wac-cdn.atlassian.com/dam/jcr:9f4579ac-d22e-4714-b793-6d5aae4ad49e/workflow.png?cdnVersion=1232"
};
var $16e28dc2ebb93a44$export$f5fc726b1f3a764d = function(locale) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return $16e28dc2ebb93a44$var$devOpsSectionImageMap[locale] || $16e28dc2ebb93a44$var$devOpsSectionImageMap["en"];
};
var $16e28dc2ebb93a44$export$55b4ecbb6fe6298e = function(locale) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return $16e28dc2ebb93a44$var$heroSectionImageMap[locale] || $16e28dc2ebb93a44$var$heroSectionImageMap["en"];
};
var $16e28dc2ebb93a44$export$d0eb8e3477c372df = function(locale) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return $16e28dc2ebb93a44$var$planTabsSectionImageMap[locale] || $16e28dc2ebb93a44$var$planTabsSectionImageMap["en"];
};
var $16e28dc2ebb93a44$export$1185e048a42a7692 = function(locale) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return $16e28dc2ebb93a44$var$planTabsSectionVideoMap[locale] || $16e28dc2ebb93a44$var$planTabsSectionVideoMap["en"];
};
var $16e28dc2ebb93a44$export$3cebe896652d6248 = function(locale) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return $16e28dc2ebb93a44$var$trackTabsSectionImageMap[locale] || $16e28dc2ebb93a44$var$trackTabsSectionImageMap["en"];
};
var $16e28dc2ebb93a44$export$dbda4fbdc6bac37c = function(locale) {
    return(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    $16e28dc2ebb93a44$var$releaseTabsSectionImageMap[locale] || $16e28dc2ebb93a44$var$releaseTabsSectionImageMap["en"]);
};
var $16e28dc2ebb93a44$export$7e0f538c5fb0ac2d = function(locale) {
    return(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    $16e28dc2ebb93a44$var$reportTabsSectionImageMap[locale] || $16e28dc2ebb93a44$var$reportTabsSectionImageMap["en"]);
};
var $16e28dc2ebb93a44$export$7a3d5ba0eee41c3d = function(locale) {
    return $16e28dc2ebb93a44$var$automateTabsSectionImageMap[locale] || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    $16e28dc2ebb93a44$var$automateTabsSectionImageMap["en"];
};
var $16e28dc2ebb93a44$export$af440fac00a2a630 = function(locale) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return $16e28dc2ebb93a44$var$workflowSectionImageMap[locale] || $16e28dc2ebb93a44$var$workflowSectionImageMap["en"];
};

});


parcelRegister("6CGhB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ea6ac4d1f8f6a3c$export$2e2bcd8739ae039; });
/* hero.tsx generated by @compiled/babel-plugin v0.28.2 */ 
var $1rY3h = parcelRequire("1rY3h");
parcelRequire("1Mpn7");

var $2vwrh = parcelRequire("2vwrh");

var $dFwuF = parcelRequire("dFwuF");
var $8pPrt = parcelRequire("8pPrt");
parcelRequire("2miCy");
var $7UzgT = parcelRequire("7UzgT");
var $hot2Q = parcelRequire("hot2Q");
parcelRequire("bLs3l");
var $2Fq2b = parcelRequire("2Fq2b");

var $bvCMH = parcelRequire("bvCMH");
// Styles for adding a Lifted Bar
// const adBannerContainerStyles = css`
//     margin: auto;
//     position: relative;
//     background: #091e42;
//     display: flex;
//     justify-content: center;
//     ${media.above.sm} {
//         img {
//             display: block;
//         }
//     }
//     ${media.above.md} {
//         img {
//             display: unset;
//         }
//     }
// `;
var $0ea6ac4d1f8f6a3c$var$jswHeroSectionStyle = null;
var $0ea6ac4d1f8f6a3c$var$HeroSection = function() {
    var intl = (0, $8pPrt.default)();
    var localizedImageSrc = (0, $bvCMH.getHeroSectionImage)(intl.locale);
    return /*#__PURE__*/ (0, $1rY3h.jsx)("section", {
        className: (0, $2vwrh.default)([
            "_137615vq _1msg15vq _1l3p146b _sstt7vkz _x74k1ul9 _dowv7vkz _e1dj1git _1s1a1wug _12ymidpf _2lxvidpf _1hriidpf _ncuiidpf _1ypzcs5v _mh8aviql _147q10nf _1fa4dlk8 _1q7dbys6 _1tfovehm _1jge1k92 _fduynl7k _pv9c19ii _jjo51tcg _uthsbys6 _tzrevehm _dt5lbys6 _6r4jvehm _h7jvidpf _lgjykb7n _144f1osq _uab5glyw _1h5zdf73 _1tbaidpf _2gjjkb7n _1lab187t _sua0bp7d _1k72yn4p _1x6fzz36 _j4ic7vkz _1jjc1k92 _6vppnl7k _g79o19ii _qan31tcg _1wi11an8 _1vfocs5v _68j21q9y _1gnqdf73 _lloaidpf _rij9kb7n _dpeoidpf _5c621lk2 _1s3616au _p7ekcs5v _kjmy1q9y _lmjpyn4p _rioazz36 _1g5b7vkz _o20z1k92 _o14knl7k _1pgr19ii _1twt1tcg _1uvg9yk2 _e3d7df73 _1c8oidpf _ei8t7vkz _4rjz7vkz _np2zkb7n _xewu187t _1tc2bp7d _1vr81an8 _rvk8cs5v _1fq41q9y _18mc1wto _h0ec1k7u _13b31tcg _y3eo1k92 _xs16nl7k _shrw19ii _829tkb7n _1wf7187t _zohbbp7d _11mndf73 _kksjidpf _1tib7vkz _dj2f7vkz _1ags1an8 _oh6jcs5v _1nu61q9y _1b5g1wto _1mzr1k7u _1im61tcg _1i311k92 _1mzanl7k _kru619ii"
        ]),
        children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $2Fq2b.HeroImageTextSide), {
            headerText: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $dFwuF.default), {
                id: "JiraSoftwarePageTemplate.heroHeader",
                defaultMessage: "Move fast, stay aligned, and build better - together",
                values: (0, $7UzgT.DEFAULT_VALUES)
            }),
            bodyText: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $dFwuF.default), {
                id: "JiraSoftwarePageTemplate.heroBody",
                defaultMessage: "The #1 software development tool used by agile teams",
                values: (0, $7UzgT.DEFAULT_VALUES)
            }),
            ctaProps: {
                buttonProps: {
                    text: intl.formatMessage({
                        id: "JiraSoftwarePageTemplate.heroCTA",
                        defaultMessage: "Get it free"
                    }),
                    color: "yellow",
                    url: (0, $hot2Q.useLocalizedHref)("/software/jira/free"),
                    dataEventProps: {
                        "data-event-component": "linkButton",
                        "data-event-container": "heroSection",
                        "data-event": "clicked",
                        "data-product-key": "jiraSoftware"
                    }
                }
            },
            className: "jsw-hero-section",
            // TODO: replace with locally stored asset in the repo or content platform?
            imageLink: localizedImageSrc,
            imageAltText: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.heroImageAltText",
                defaultMessage: "Illustration demonstrating workflows in Jira Software"
            }),
            backgroundProperties: {
                bgColor: "#253858",
                textColor: "#ffffff",
                bgColor2: "#091e42",
                gradientDirection: "180"
            },
            aspectRatio: "none"
        })
    });
};
var $0ea6ac4d1f8f6a3c$export$2e2bcd8739ae039 = $0ea6ac4d1f8f6a3c$var$HeroSection;

});
parcelRegister("bLs3l", function(module, exports) {
$parcel$export(module.exports, "HeroImageTextSide", function () { return (parcelRequire("2Fq2b")).HeroImageTextSide; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("2Fq2b")).HeroImageTextSide; });

var $2Fq2b = parcelRequire("2Fq2b");

});
parcelRegister("2Fq2b", function(module, exports) {

$parcel$export(module.exports, "HeroImageTextSide", function () { return $2f292ecdf57dde56$export$4dea18f851efd67; });
/* hero-image-text-side.tsx generated by @compiled/babel-plugin v0.28.2 */ 
var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $1rY3h = parcelRequire("1rY3h");
parcelRequire("1Mpn7");

var $2vwrh = parcelRequire("2vwrh");
var $bStPI = parcelRequire("bStPI");
parcelRequire("8AsWs");
var $4OHyT = parcelRequire("4OHyT");
parcelRequire("55RaN");
var $6mH68 = parcelRequire("6mH68");
parcelRequire("9DBuW");
var $91Gob = parcelRequire("91Gob");
var $0r70l = parcelRequire("0r70l");
var $2f292ecdf57dde56$var$heroStyle = null;
var $2f292ecdf57dde56$export$4dea18f851efd67 = function(param) {
    var headerText = param.headerText, bodyText = param.bodyText, imageLink = param.imageLink, imageAltText = param.imageAltText, imagePosition = param.imagePosition, imageCss = param.imageCss, _param_className = param.className, className = _param_className === void 0 ? "" : _param_className, ctaProps = param.ctaProps, backgroundProperties = param.backgroundProperties, aspectRatio = param.aspectRatio;
    return /*#__PURE__*/ (0, $1rY3h.jsx)((0, $91Gob.StyledBackground), (0, $cxjpp._)((0, $do9pw._)({}, backgroundProperties), {
        children: /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
            className: (0, $2vwrh.default)([
                "_1akoys9h _c7s7idpf _4puvys9h _1r3vidpf _i6jx1wqb _1lh7idpf _z3nc1wqb _wpaiidpf _1kmx1ylp _1ggmidpf _1ykz1ylp _1maeidpf",
                className
            ]),
            children: /*#__PURE__*/ (0, $1rY3h.jsxs)((0, $0r70l.RowRevised), {
                layout: "6-6",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0, $1rY3h.jsx)((0, $4OHyT.ContentBlock), {
                        headerText: headerText,
                        headerType: "h1",
                        bodyText: bodyText,
                        ctaProps: ctaProps
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)((0, $6mH68.Image), {
                        src: imageLink,
                        alt: imageAltText,
                        aspectRatio: aspectRatio || "none",
                        className: (0, $2vwrh.default)([
                            imagePosition === "left" && "_1f491mrw _1psuyibt",
                            imagePosition !== "left" && "_1psuyibt"
                        ]),
                        style: {
                            "--_1y9p5uo": (0, $bStPI.default)(imageCss)
                        }
                    })
                ]
            })
        })
    }));
};

});



parcelRegister("ijlgi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $617437f25e4082ae$export$2e2bcd8739ae039; });
/* integrations.tsx generated by @compiled/babel-plugin v0.28.2 */ 
var $1rY3h = parcelRequire("1rY3h");
parcelRequire("1Mpn7");

var $2vwrh = parcelRequire("2vwrh");

var $dFwuF = parcelRequire("dFwuF");
var $8pPrt = parcelRequire("8pPrt");
parcelRequire("8AsWs");
var $4OHyT = parcelRequire("4OHyT");
parcelRequire("2miCy");
var $7UzgT = parcelRequire("7UzgT");
var $617437f25e4082ae$var$integrationStyles = null;
var $617437f25e4082ae$var$IntegrationSection = function() {
    var intl = (0, $8pPrt.default)();
    return /*#__PURE__*/ (0, $1rY3h.jsx)("section", {
        className: (0, $2vwrh.default)([
            "_4cvr1h6o _1e0c1txw _1bah1h6o _ca0qd36x _u5f3idpf _n3tdd36x _19bvidpf _bfhku67f _1mfrk4p6 _10j01wp6 _1jg6eva1 _1j44ffox _14q21bp4 _1vlrn6wy _kgiyidpf _1w0xn6wy _958cidpf _1glwk4p6 _bzzi1wp6 _16tjeva1 _2h351pr0 _bpkw1bp4 _gkko2aub _13hpzgvh _74gkeva1 _b2g01omv _i6jx16xz _1lh7idpf _z3nc16xz _wpaiidpf _1gnk6jl5 _p17a1nw7 _1u5reva1 _rb2g1omv _3vsh16xz _op2cidpf _gos316xz _50abidpf _ij146jl5 _1odr1h4v _18xueva1 _1o6012og _122l1yw0 _15l27vkz _vvoe7vkz _jq287vkz _cksc7vkz _4s0m1ssb _1nq4ahaf _96o01j6v _x5m01tcg _f1ug1git _1gq61osq _1i2s1k8s _14o511ph _1pkrbys6 _k51wvehm _x22w1bqd _htr7dlk8 _1sm8bfng _1oki1mpp _mrde1tcg _11cj4jg8 _1bmsbys6 _rtzsvehm _17o5idpf _19zhidpf _1wroidpf _1a6aidpf _wqjv1y44 _1lrs19bv _8sqc1y44 _1i4a19bv _11y6bfng _1hlgn7od _1ykebys6 _7ihwvehm"
        ]),
        children: /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
            className: "integrations-content",
            children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $4OHyT.ContentBlock), {
                headerText: intl.formatMessage({
                    id: "JiraSoftwarePageTemplate.integrationSection.header",
                    defaultMessage: "We believe in open relationships"
                }),
                bodyText: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $dFwuF.default), {
                    id: "JiraSoftwarePageTemplate.integrationSection.body",
                    defaultMessage: "If your team uses it, we integrate with it. Easily add your tools from the Atlassian Marketplace, keeping Jira as your central source of truth.",
                    values: (0, $7UzgT.DEFAULT_VALUES)
                }),
                headerType: "h2",
                isCentered: true,
                orientation: "vertical",
                ctaProps: {
                    buttonProps: {
                        text: intl.formatMessage({
                            id: "JiraSoftwarePageTemplate.integrationSection.cta",
                            defaultMessage: "Explore integrations"
                        }),
                        url: "https://marketplace.atlassian.com/",
                        type: "secondary",
                        size: "small",
                        dataEventProps: {
                            "data-event-component": "linkButton",
                            "data-event-container": "integrationSection",
                            "data-event": "clicked",
                            "data-product-key": "jiraSoftware"
                        }
                    }
                }
            })
        })
    });
};
var $617437f25e4082ae$export$2e2bcd8739ae039 = $617437f25e4082ae$var$IntegrationSection;

});

parcelRegister("hRgqn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2894135c66268e06$export$2e2bcd8739ae039; });
/* scaling.tsx generated by @compiled/babel-plugin v0.28.2 */ 
var $do9pw = parcelRequire("do9pw");

var $1rY3h = parcelRequire("1rY3h");
parcelRequire("1Mpn7");

var $2vwrh = parcelRequire("2vwrh");
var $bStPI = parcelRequire("bStPI");

var $dFwuF = parcelRequire("dFwuF");
var $8pPrt = parcelRequire("8pPrt");
parcelRequire("8AsWs");
var $4OHyT = parcelRequire("4OHyT");
parcelRequire("55RaN");
var $6mH68 = parcelRequire("6mH68");
parcelRequire("2miCy");
var $7UzgT = parcelRequire("7UzgT");
var $hot2Q = parcelRequire("hot2Q");
var $2894135c66268e06$var$backgroundStyles = null;
var $2894135c66268e06$var$ScalingSection = function() {
    var intl = (0, $8pPrt.default)();
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("section", {
        className: (0, $2vwrh.default)([
            "_bfhk1mpp _12vemgnk _syazu67f _ca0qzwfg _u5f3idpf _n3tdzwfg _19bvidpf _59381r31 _yha28stv _1nmznqa1 _gkko1pdx _13hp1ssb _b2g01dfr _kzvi1txw _1gnkditx _p17a1m79 _rb2g1s9t _ij14ditx _1odr1c44 _1o601i26"
        ]),
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                className: (0, $2vwrh.default)([
                    "_ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _1bsbzufs _p12fjsxk _11ebahaf _l5k14jg8 _17z41g1n _jw8h1tcg _q7gq1j6v _zcqxbs82 _1b2sidpf _2dx01wug _nkieidpf _1yoq1wug _16puh2mm _1hvl1hsx _tkvqh8g5 _1hr2uxkd _1rfm1osq _1kll1k8s"
                ]),
                children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $4OHyT.ContentBlock), {
                    headerType: "h2",
                    headerText: intl.formatMessage({
                        id: "JiraSoftwarePageTemplate.scalingSection.headerText",
                        defaultMessage: "Built for teams of 1 to 35,000"
                    }),
                    bodyText: intl.formatMessage({
                        id: "JiraSoftwarePageTemplate.scalingSection.bodyText",
                        defaultMessage: "A growing team doesn\u2019t need to mean growing pains. With best-of-breed features, security, privacy, and the right tool for every step of your journey - Jira Software allows you to scale without friction - regardless of your company size."
                    })
                })
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                className: (0, $2vwrh.default)([
                    "_1e0cglyw _1itkcsvi _ouxl19bj _12vemgnk _1lrwgi01 _1mjb1txw"
                ]),
                children: /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
                    className: (0, $2vwrh.default)([
                        "_1e0c1txw _2lx21bp4 _zulpor1b _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $1rY3h.jsx)($2894135c66268e06$var$ScalingStepsForSmallScreen, {
                            imageSrc: "https://wac-cdn.atlassian.com/dam/jcr:b1013bac-01ff-4be2-827a-8a16b76d0a4b/JSW%20free-responsive.png?cdnVersion=1203",
                            imageAltText: intl.formatMessage({
                                id: "JiraSoftwarePageTemplate.scalingSection.small.jiraFree",
                                defaultMessage: "Jira free"
                            }),
                            bodyText: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $dFwuF.default), {
                                id: "JiraSoftwarePageTemplate.scalingSection.small.jiraSoftwareFree",
                                defaultMessage: "Jira Software free forever for teams up to 10",
                                values: (0, $7UzgT.DEFAULT_VALUES)
                            })
                        }),
                        /*#__PURE__*/ (0, $1rY3h.jsx)($2894135c66268e06$var$ScalingStepsForSmallScreen, {
                            imageSrc: "https://wac-cdn.atlassian.com/dam/jcr:5cae308d-24a4-40d0-8fe2-ce7f46cd7a02/JSW%20sign-responsive.png?cdnVersion=1203",
                            imageAltText: intl.formatMessage({
                                id: "JiraSoftwarePageTemplate.scalingSection.small.jiraSoftware",
                                defaultMessage: "Jira Software"
                            }),
                            bodyText: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $dFwuF.default), {
                                id: "JiraSoftwarePageTemplate.scalingSection.small.jiraSoftwareStandard",
                                defaultMessage: "Jira Software Standard for growing teams",
                                values: (0, $7UzgT.DEFAULT_VALUES)
                            })
                        }),
                        /*#__PURE__*/ (0, $1rY3h.jsx)($2894135c66268e06$var$ScalingStepsForSmallScreen, {
                            imageSrc: "https://wac-cdn.atlassian.com/dam/jcr:c36a7707-da80-46a7-9cc2-38abca992964/Prem%20sign-responsive.png?cdnVersion=1203",
                            imageAltText: intl.formatMessage({
                                id: "JiraSoftwarePageTemplate.scalingSection.small.jiraSoftwarePremium",
                                defaultMessage: "Jira Software Premium"
                            }),
                            bodyText: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $dFwuF.default), {
                                id: "JiraSoftwarePageTemplate.scalingSection.small.jiraSoftwarePremiumScale",
                                defaultMessage: "Scale across teams with <a>Jira Software Premium</a>",
                                values: (0, $do9pw._)({
                                    a: function(str) {
                                        return /*#__PURE__*/ (0, $1rY3h.jsx)("a", {
                                            // eslint-disable-next-line react-hooks/rules-of-hooks
                                            href: (0, $hot2Q.useLocalizedHref)("/software/jira/premium"),
                                            "data-event-component": "linkButton",
                                            "data-event-container": "textBlock",
                                            "data-event": "clicked",
                                            "data-label": "Jira Software Premium",
                                            "data-product-key": "jiraSoftware",
                                            children: str
                                        });
                                    }
                                }, (0, $7UzgT.DEFAULT_VALUES))
                            })
                        }),
                        /*#__PURE__*/ (0, $1rY3h.jsx)($2894135c66268e06$var$ScalingStepsForSmallScreen, {
                            imageSrc: "https://wac-cdn.atlassian.com/dam/jcr:e4223ecb-8867-46cb-b73d-4218e4807778/Ent%20sign-responsive.png?cdnVersion=1203",
                            imageAltText: intl.formatMessage({
                                id: "JiraSoftwarePageTemplate.scalingSection.small.jiraSoftwareEnterprise",
                                defaultMessage: "Jira Software Enterprise"
                            }),
                            bodyText: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $dFwuF.default), {
                                id: "JiraSoftwarePageTemplate.scalingSection.small.jiraSoftwareEnterpriseConnect",
                                defaultMessage: "Connect and accelerate your entire <a>enterprise</a>",
                                values: (0, $do9pw._)({
                                    a: function(str) {
                                        return /*#__PURE__*/ (0, $1rY3h.jsx)("a", {
                                            // eslint-disable-next-line react-hooks/rules-of-hooks
                                            href: (0, $hot2Q.useLocalizedHref)("/software/jira/enterprise"),
                                            "data-event-component": "linkButton",
                                            "data-event-container": "textBlock",
                                            "data-event": "clicked",
                                            "data-label": "enterprise",
                                            "data-product-key": "jiraSoftware",
                                            children: str
                                        });
                                    }
                                }, (0, $7UzgT.DEFAULT_VALUES))
                            })
                        }),
                        /*#__PURE__*/ (0, $1rY3h.jsx)($2894135c66268e06$var$ScalingStepsForSmallScreen, {
                            imageSrc: "https://wac-cdn.atlassian.com/dam/jcr:c177344d-7e41-4576-b4eb-85b346d6653b/JA%20sign-responsive.png?cdnVersion=1203",
                            imageAltText: intl.formatMessage({
                                id: "JiraSoftwarePageTemplate.scalingSection.small.jiraAlign",
                                defaultMessage: "Jira Align"
                            }),
                            bodyText: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $dFwuF.default), {
                                id: "JiraSoftwarePageTemplate.scalingSection.small.jiraAlignEnterprise",
                                defaultMessage: "Enterprise agility with Jira Align",
                                values: (0, $7UzgT.DEFAULT_VALUES)
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                className: (0, $2vwrh.default)([
                    "_ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _1pfh1cg9 _6rthgktf _1mjbglyw"
                ]),
                children: /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
                    className: (0, $2vwrh.default)([
                        "_1e0c1txw _1bah1h6o _1itk5eq5 _ouxl44ox _12vemgnk _1lrw1vx1 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1git"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $1rY3h.jsx)($2894135c66268e06$var$ScalingStepsForLargeScreen, {
                            imageSrc: "https://wac-cdn.atlassian.com/dam/jcr:b1013bac-01ff-4be2-827a-8a16b76d0a4b/JSW%20free-responsive.png?cdnVersion=1203",
                            imageAltText: intl.formatMessage({
                                id: "JiraSoftwarePageTemplate.scalingSection.large.jiraFree",
                                defaultMessage: "Jira free"
                            }),
                            cssTop: "80px",
                            bodyText: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $dFwuF.default), {
                                id: "JiraSoftwarePageTemplate.scalingSection.large.jiraSoftwareFree",
                                defaultMessage: "Jira Software free forever for teams up to 10",
                                values: (0, $7UzgT.DEFAULT_VALUES)
                            })
                        }),
                        /*#__PURE__*/ (0, $1rY3h.jsx)($2894135c66268e06$var$ScalingStepsForLargeScreen, {
                            imageSrc: "https://wac-cdn.atlassian.com/dam/jcr:5cae308d-24a4-40d0-8fe2-ce7f46cd7a02/JSW%20sign-responsive.png?cdnVersion=1203",
                            imageAltText: intl.formatMessage({
                                id: "JiraSoftwarePageTemplate.scalingSection.large.jiraSoftware",
                                defaultMessage: "Jira Software"
                            }),
                            cssTop: "60px",
                            bodyText: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $dFwuF.default), {
                                id: "JiraSoftwarePageTemplate.scalingSection.large.jiraSoftwareStandard",
                                defaultMessage: "Jira Software Standard for growing teams",
                                values: (0, $7UzgT.DEFAULT_VALUES)
                            })
                        }),
                        /*#__PURE__*/ (0, $1rY3h.jsx)($2894135c66268e06$var$ScalingStepsForLargeScreen, {
                            imageSrc: "https://wac-cdn.atlassian.com/dam/jcr:c36a7707-da80-46a7-9cc2-38abca992964/Prem%20sign-responsive.png?cdnVersion=1203",
                            imageAltText: intl.formatMessage({
                                id: "JiraSoftwarePageTemplate.scalingSection.large.jiraSoftwarePremium",
                                defaultMessage: "Jira Software Premium"
                            }),
                            cssTop: "40px",
                            bodyText: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $dFwuF.default), {
                                id: "JiraSoftwarePageTemplate.scalingSection.large.jiraSoftwarePremiumScale",
                                defaultMessage: "Scale across teams with <a>Jira Software Premium</a>",
                                values: (0, $do9pw._)({
                                    a: function(str) {
                                        return /*#__PURE__*/ (0, $1rY3h.jsx)("a", {
                                            // eslint-disable-next-line react-hooks/rules-of-hooks
                                            href: (0, $hot2Q.useLocalizedHref)("/software/jira/premium"),
                                            "data-event-component": "linkButton",
                                            "data-event-container": "textBlock",
                                            "data-event": "clicked",
                                            "data-label": "Jira Software Premium",
                                            "data-product-key": "jiraSoftware",
                                            children: str
                                        });
                                    }
                                }, (0, $7UzgT.DEFAULT_VALUES))
                            })
                        }),
                        /*#__PURE__*/ (0, $1rY3h.jsx)($2894135c66268e06$var$ScalingStepsForLargeScreen, {
                            imageSrc: "https://wac-cdn.atlassian.com/dam/jcr:e4223ecb-8867-46cb-b73d-4218e4807778/Ent%20sign-responsive.png?cdnVersion=1203",
                            imageAltText: intl.formatMessage({
                                id: "JiraSoftwarePageTemplate.scalingSection.large.jiraSoftwareEnterprise",
                                defaultMessage: "Jira Software Enterprise"
                            }),
                            cssTop: "20px",
                            // disabling eslint because the bodyText prop is a ReactNode
                            bodyText: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $dFwuF.default), {
                                id: "JiraSoftwarePageTemplate.scalingSection.large.jiraSoftwareEnterpriseConnect",
                                defaultMessage: "Connect and accelerate your entire <a>enterprise</a>",
                                values: (0, $do9pw._)({
                                    a: function(str) {
                                        return /*#__PURE__*/ (0, $1rY3h.jsx)("a", {
                                            // eslint-disable-next-line react-hooks/rules-of-hooks
                                            href: (0, $hot2Q.useLocalizedHref)("/software/jira/enterprise"),
                                            "data-event-component": "linkButton",
                                            "data-event-container": "textBlock",
                                            "data-event": "clicked",
                                            "data-label": "enterprise",
                                            "data-product-key": "jiraSoftware",
                                            children: str
                                        });
                                    }
                                }, (0, $7UzgT.DEFAULT_VALUES))
                            })
                        }),
                        /*#__PURE__*/ (0, $1rY3h.jsx)($2894135c66268e06$var$ScalingStepsForLargeScreen, {
                            imageSrc: "https://wac-cdn.atlassian.com/dam/jcr:c177344d-7e41-4576-b4eb-85b346d6653b/JA%20sign-responsive.png?cdnVersion=1203",
                            imageAltText: intl.formatMessage({
                                id: "JiraSoftwarePageTemplate.scalingSection.large.jiraAlign",
                                defaultMessage: "Jira Align"
                            }),
                            cssTop: "0",
                            bodyText: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $dFwuF.default), {
                                id: "JiraSoftwarePageTemplate.scalingSection.large.jiraAlignEnterprise",
                                defaultMessage: "Enterprise agility with Jira Align",
                                values: (0, $7UzgT.DEFAULT_VALUES)
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $2894135c66268e06$var$ScalingStepsForSmallScreen = function(props) {
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
        className: (0, $2vwrh.default)([
            "_1e0c1txw"
        ]),
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                className: (0, $2vwrh.default)([
                    "_1e0c1txw _4cvr1h6o _bna753f4 _1rg253f4 _mezj53f4 _1lx8cs5v"
                ]),
                children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $6mH68.Image), {
                    src: props.imageSrc,
                    alt: props.imageAltText
                })
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                className: (0, $2vwrh.default)([
                    "_4cvr1h6o _1e0c1txw _bozgzwfg _1bsb1ssb _1s4p1wug"
                ]),
                children: /*#__PURE__*/ (0, $1rY3h.jsx)("p", {
                    className: (0, $2vwrh.default)([
                        "_1wyb1j6v _19pkidpf _2hwxidpf _otyridpf _18u0idpf _vwz4bs82"
                    ]),
                    children: props.bodyText
                })
            })
        ]
    });
};
var $2894135c66268e06$var$ScalingStepsForLargeScreen = function(props) {
    return /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
        className: (0, $2vwrh.default)([
            "_4cvr1h6o _1e0c1txw _2lx21bp4 _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _1bsbauyy"
        ]),
        children: /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                    className: (0, $2vwrh.default)([
                        "_1e0c1txw _1bah1h6o _1tke1wdt _kqswh2mm _1iu27vkz _f45rh2mm _12xta1to _mezj53f4 _bna753f4 _1lx8cs5v _aetrb3bt _18postnw _1qdgmgvx _19nq14em _eq431r3d _19h91cud _1v5vlllb _8s22gvcq _1bqqkb7n"
                    ]),
                    style: {
                        "--_1wfsy9y": (0, $bStPI.default)(props.cssTop)
                    },
                    children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $6mH68.Image), {
                        src: props.imageSrc,
                        alt: props.imageAltText
                    })
                }),
                /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                    className: (0, $2vwrh.default)([
                        "_bfhkdu3w _2rko1ssb _4t3igktf _19pkidpf _2hwx1wug _otyr1ul9 _18u01wug _1bsbgktf"
                    ])
                }),
                /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                    children: /*#__PURE__*/ (0, $1rY3h.jsx)("p", {
                        className: (0, $2vwrh.default)([
                            "_1wyb1j6v _19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o _vwz4bs82"
                        ]),
                        children: props.bodyText
                    })
                })
            ]
        })
    });
};
var $2894135c66268e06$export$2e2bcd8739ae039 = $2894135c66268e06$var$ScalingSection;

});

parcelRegister("acPtc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $80785f262bcebfa6$export$2e2bcd8739ae039; });

var $1rY3h = parcelRequire("1rY3h");

var $8pPrt = parcelRequire("8pPrt");
parcelRequire("4eDLP");
var $bf0Bh = parcelRequire("bf0Bh");
var $kDLXw = parcelRequire("kDLXw");
parcelRequire("2miCy");
var $hot2Q = parcelRequire("hot2Q");
var $80785f262bcebfa6$var$JiraSoftwareNav = function() {
    var intl = (0, $8pPrt.default)();
    return /*#__PURE__*/ (0, $1rY3h.jsxs)((0, $bf0Bh.ProductNavBar), {
        productHref: (0, $hot2Q.useLocalizedHref)("/software/jira"),
        productName: "jirasoftware",
        freeHref: (0, $hot2Q.useLocalizedHref)("/software/jira/free"),
        ariaLabel: intl.formatMessage({
            id: "wacJiraSoftwareNavigation.logo-label",
            defaultMessage: "Jira Software logo"
        }),
        dataProductKey: "jiraSoftware",
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsx)((0, $kDLXw.ProductNavLink), {
                label: intl.formatMessage({
                    id: "software-jira.navbar.features",
                    defaultMessage: "Features"
                }),
                href: (0, $hot2Q.useLocalizedHref)("/software/jira/features")
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)((0, $kDLXw.ProductNavLink), {
                label: intl.formatMessage({
                    id: "software-jira.navbar.product-guide",
                    defaultMessage: "Product guide"
                }),
                href: (0, $hot2Q.useLocalizedHref)("/software/jira/guides/getting-started/introduction")
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)((0, $kDLXw.ProductNavLink), {
                label: intl.formatMessage({
                    id: "software-jira.navbar.templates",
                    defaultMessage: "Templates"
                }),
                href: (0, $hot2Q.useLocalizedHref)("/software/jira/templates")
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)((0, $kDLXw.ProductNavLink), {
                label: intl.formatMessage({
                    id: "software-jira.navbar.pricing",
                    defaultMessage: "Pricing"
                }),
                href: (0, $hot2Q.useLocalizedHref)("/software/jira/pricing")
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)((0, $kDLXw.ProductNavLink), {
                label: intl.formatMessage({
                    id: "software-jira.navbar.enterprise",
                    defaultMessage: "Enterprise"
                }),
                href: (0, $hot2Q.useLocalizedHref)("/software/jira/enterprise")
            })
        ]
    });
};
$80785f262bcebfa6$var$JiraSoftwareNav.displayName = "JiraSoftwareNav";
var $80785f262bcebfa6$export$2e2bcd8739ae039 = $80785f262bcebfa6$var$JiraSoftwareNav;

});
parcelRegister("4eDLP", function(module, exports) {
$parcel$export(module.exports, "ProductNavBar", function () { return (parcelRequire("bf0Bh")).ProductNavBar; });

$parcel$export(module.exports, "ProductNavBar", function () { return (parcelRequire("bf0Bh")).ProductNavBar; });
$parcel$export(module.exports, "ProductNavLink", function () { return (parcelRequire("kDLXw")).ProductNavLink; });
$parcel$export(module.exports, "ProductNavDropdown", function () { return (parcelRequire("axgTr")).ProductNavDropdown; });

var $bf0Bh = parcelRequire("bf0Bh");

var $kDLXw = parcelRequire("kDLXw");

var $axgTr = parcelRequire("axgTr");

});
parcelRegister("bf0Bh", function(module, exports) {

$parcel$export(module.exports, "ProductNavBar", function () { return $df0035056a6a7805$export$6bfdc568e00f9e3d; });
/* product-navbar.tsx generated by @compiled/babel-plugin v0.28.2 */ 
var $cv9Rk = parcelRequire("cv9Rk");

var $1rY3h = parcelRequire("1rY3h");

var $1Mpn7 = parcelRequire("1Mpn7");

var $2vwrh = parcelRequire("2vwrh");
var $bStPI = parcelRequire("bStPI");

var $8pPrt = parcelRequire("8pPrt");

var $fUIIu = parcelRequire("fUIIu");

var $2Pnqs = parcelRequire("2Pnqs");
parcelRequire("9DBuW");
var $l227w = parcelRequire("l227w");
parcelRequire("iH8wz");
var $hR975 = parcelRequire("hR975");
var $df0035056a6a7805$var$navigationWrapperCss = null;
var $df0035056a6a7805$var$navigationBarWrapperCss = null;
var $df0035056a6a7805$var$navigationBarCss = null;
var $df0035056a6a7805$var$logoAndLinksCss = null;
var $df0035056a6a7805$var$keyframeChevron = null;
var $df0035056a6a7805$var$removeKeyframeChevron = null;
var $df0035056a6a7805$var$dropdownSlideInAnimation = null;
var $df0035056a6a7805$var$dropdownSlideOutAnimation = null;
var $df0035056a6a7805$var$listItemCss = null;
var $df0035056a6a7805$var$buttonWrapper = null;
var $df0035056a6a7805$var$linkAndButtonWrapper = null;
var $df0035056a6a7805$var$buttonStyle = null;
var $df0035056a6a7805$export$6bfdc568e00f9e3d = function(props) {
    var intl = (0, $8pPrt.default)();
    var _props_showFreeHrefButton;
    var isShowFreeHrefButton = (_props_showFreeHrefButton = props.showFreeHrefButton) !== null && _props_showFreeHrefButton !== void 0 ? _props_showFreeHrefButton : true;
    var _useState = (0, $cv9Rk._)((0, $1Mpn7.useState)(null), 2), activeDropdown = _useState[0], setActive = _useState[1];
    var _useState1 = (0, $cv9Rk._)((0, $1Mpn7.useState)("secondary"), 2), buttonType = _useState1[0], setButtonType = _useState1[1];
    (0, $1Mpn7.useEffect)(function() {
        window.addEventListener("scroll", handleScroll);
    }, []);
    (0, $1Mpn7.useEffect)(function() {
        (0, $2Pnqs.Initializer).autoTrack();
    }, [
        activeDropdown,
        props.showFreeHrefButton
    ]);
    var handleScroll = function() {
        setButtonType(window.scrollY > 56 ? "primary" : "secondary");
    };
    var getItFreeText = intl.formatMessage({
        id: "productNavBar.get-it-free-button",
        defaultMessage: "Get it free"
    });
    var dropdownCss = [
        activeDropdown === null && null,
        activeDropdown && null,
        !activeDropdown && null
    ];
    var mobileCategoriesWrapperCss = [
        activeDropdown === null && null,
        activeDropdown && null,
        !activeDropdown && null
    ];
    var renderSelectionItems = function(isMobile) {
        var categoriesWrapperCss = [
            !isMobile && null
        ];
        return /*#__PURE__*/ (0, $1rY3h.jsx)("ul", {
            className: (0, $2vwrh.default)([
                !isMobile && "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _2lx2vrvc _qtt8glyw _18s8z5p3 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1mjbglyw"
            ]),
            children: props.children && (0, $1Mpn7.Children).map(props.children, function(child, index) {
                return child ? /*#__PURE__*/ (0, $1rY3h.jsx)("li", {
                    className: (0, $2vwrh.default)([
                        "_kqswh2mm"
                    ]),
                    children: /*#__PURE__*/ (0, $1Mpn7.cloneElement)(child, {
                        isMobile: isMobile
                    })
                }, index) : null;
            })
        });
    };
    var renderDropdownButton = function() {
        if (props.children) return /*#__PURE__*/ (0, $1rY3h.jsx)("button", {
            onClick: function() {
                return setActive(!activeDropdown);
            },
            className: (0, $2vwrh.default)([
                activeDropdown === null && "_1e0cglyw _80omtlke _tnv2qshr _13jeglyw _7w28rbzz _1mjb1ule _xc2i1oug _19ekhiv4 _rulphiv4",
                activeDropdown && "",
                activeDropdown && "_1px1qbue _48hmq7pw _1e0cglyw _80omtlke _tnv2qshr _13jeglyw _7w28rbzz _1mjb1ule _xc2i1oug _19ekhiv4 _rulphiv4",
                !activeDropdown && "",
                !activeDropdown && "_1px1k4ed _48hmq7pw _1e0cglyw _80omtlke _tnv2qshr _13jeglyw _7w28rbzz _1mjb1ule _xc2i1oug _19ekhiv4 _rulphiv4"
            ]),
            children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fUIIu))), {
                label: ""
            })
        });
        return null;
    };
    var logoWrapperCss = [
        props.logoLinkWrapperWidth !== "" && null,
        props.logoLinkWrapperWidth === "" && null,
        props.logoLinkWrapperWidth === undefined && null
    ];
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
        className: (0, $2vwrh.default)([
            "_kqsw1if8 _152tidpf _1pby11wp"
        ]),
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                className: (0, $2vwrh.default)([
                    "_4cvr1y6m _bfhku67f _1e0c1txw _2lx2vrvc _1bah1h6o _16qsg1bn"
                ]),
                children: /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
                    className: (0, $2vwrh.default)([
                        "_4cvr1h6o _1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _1bah1yb4 _165t1wqb _10jx1fra _1yagz5p3 _1vkh8vuz _13znjdy5 _em6nh2mm _4ik0kb7n _1gdevrvc _navj1g80 _tnru1wug _15txz5p3",
                        "productNavBar"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
                            className: (0, $2vwrh.default)([
                                "_1e0c1txw"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $1rY3h.jsx)("a", {
                                    href: props.productHref,
                                    "aria-label": props.ariaLabel,
                                    className: (0, $2vwrh.default)([
                                        props.logoLinkWrapperWidth !== "" && "_1bsb1izz _4cvr1h6o _1e0c1txw",
                                        props.logoLinkWrapperWidth === "" && "_1bsb2lms _4cvr1h6o _1e0c1txw",
                                        props.logoLinkWrapperWidth === undefined && "_1bsb2lms _4cvr1h6o _1e0c1txw"
                                    ]),
                                    style: {
                                        "--_evdsab": (0, $bStPI.default)(props.logoLinkWrapperWidth)
                                    },
                                    children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $l227w.Logo), {
                                        brand: props.productName,
                                        type: "logo",
                                        appearance: "brand"
                                    })
                                }),
                                renderDropdownButton(),
                                renderSelectionItems(false)
                            ]
                        }),
                        /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                            className: (0, $2vwrh.default)([
                                "_1e0c1txw _4cvr1h6o"
                            ]),
                            children: isShowFreeHrefButton && /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                                className: (0, $2vwrh.default)([
                                    "_1e0c1txw _ca0qo7ao _u5f3idpf _n3tdo7ao _19bvidpf",
                                    "showFreeHrefButton"
                                ]),
                                children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $hR975.Button), {
                                    text: getItFreeText,
                                    url: props.freeHref,
                                    type: buttonType,
                                    "aria-label": getItFreeText,
                                    dataEventProps: {
                                        "data-event-container": "navbar",
                                        "data-event": "clicked",
                                        "data-event-component": "linkButton",
                                        "data-label": getItFreeText,
                                        "data-product-key": props.dataProductKey
                                    },
                                    className: (0, $2vwrh.default)([
                                        "_1wyb1j6v _k48pbfng _4t3iviql _1bsb1wug _1aaxusic _v5647x7w _3fcw1q9c _13zmh2mm _1rfm1wug _1gdevrvc _navj1g80 _1l7dn7od"
                                    ])
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                className: (0, $2vwrh.default)([
                    activeDropdown === null && "_16jlkb7n _1o9zkb7n _i0dlf1ug _1h6d1mpp _bfhk1hxd _mqm21ehm _179r1jv8 _16qsg1bn _c71lidpf _1reo15vq _18m91wug _kqswstnw _1bsb1osq _102oidpf _1kvxidpf _1ysjidpf _17d4idpf _1hzio7ao _3n4midpf _ltofo7ao _k7zy1ul9 _1hmtglyw _163ro7ao _dm25glyw",
                    activeDropdown && "",
                    activeDropdown && "_y44v18yz _16jlkb7n _1o9zkb7n _i0dlf1ug _1h6d1mpp _bfhk1hxd _mqm21ehm _179r1jv8 _16qsg1bn _c71lidpf _1reo15vq _18m91wug _kqswstnw _1bsb1osq _102oidpf _1kvxidpf _1ysjidpf _17d4idpf _1hzio7ao _3n4midpf _ltofo7ao _k7zy1ul9 _1hmtglyw _163ro7ao _dm25glyw",
                    !activeDropdown && "",
                    !activeDropdown && "_y44v1eb4 _16jlkb7n _1o9zkb7n _i0dlf1ug _1h6d1mpp _bfhk1hxd _mqm21ehm _179r1jv8 _16qsg1bn _c71lidpf _1reo15vq _18m91wug _kqswstnw _1bsb1osq _102oidpf _1kvxidpf _1ysjidpf _17d4idpf _1hzio7ao _3n4midpf _ltofo7ao _k7zy1ul9 _1hmtglyw _163ro7ao _dm25glyw",
                    "mobileCategoriesWrapper"
                ]),
                children: renderSelectionItems(true)
            })
        ]
    });
};
var $df0035056a6a7805$export$2e2bcd8739ae039 = $df0035056a6a7805$export$6bfdc568e00f9e3d;

});
parcelRegister("fUIIu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b95ec5bd1da6094f$var$_react = $b95ec5bd1da6094f$var$_interopRequireDefault((parcelRequire("1Mpn7")));

var $cotNw = parcelRequire("cotNw");
function $b95ec5bd1da6094f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $b95ec5bd1da6094f$var$HipchatChevronDownIcon = function(props) {
    return /*#__PURE__*/ $b95ec5bd1da6094f$var$_react.default.createElement($cotNw.Icon, Object.assign({
        dangerouslySetGlyph: '<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M6.744 8.744a1.053 1.053 0 000 1.49l4.547 4.557a1 1 0 001.416 0l4.55-4.558a1.051 1.051 0 10-1.488-1.488l-3.77 3.776-3.768-3.776a1.051 1.051 0 00-1.487 0z" fill="currentColor"/></svg>'
    }, props));
};
$b95ec5bd1da6094f$var$HipchatChevronDownIcon.displayName = "HipchatChevronDownIcon";
var $b95ec5bd1da6094f$var$_default = $b95ec5bd1da6094f$var$HipchatChevronDownIcon;
module.exports.default = $b95ec5bd1da6094f$var$_default;

});


parcelRegister("kDLXw", function(module, exports) {

$parcel$export(module.exports, "ProductNavLink", function () { return $bcae995f435e7f67$export$df4f9873dfab197b; });
/* product-navlink.tsx generated by @compiled/babel-plugin v0.28.2 */ 
var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $1rY3h = parcelRequire("1rY3h");
parcelRequire("1Mpn7");

var $2vwrh = parcelRequire("2vwrh");
var $bcae995f435e7f67$var$linkStyle = null;
var $bcae995f435e7f67$export$df4f9873dfab197b = function(props) {
    return /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
        className: (0, $2vwrh.default)([
            "_18ywh2mm _9c4j1l7b _1hw71ule _19tb1j6v _1la1kb7n _8bvmz5p3 _i7kg1z0f _5i9qrbzz _1x5rusvi _1qxa59zy _1unt1r31 _jsn2glyw _1b4hnqa1 _1mcc10vn _1ry4oelr _906b1osq _1nzh16zg _1eucz5p3 _3uyxrbzz _1u7j19bv _c12j1r31 _1udz8stv _4ba5nqa1 _1u6y1r31 _14ifglyw _f3mxnqa1 _1sinoelr _jhsausvi _c3hm4m1f _1ohxni7l _4mi7nclz _b4f8nclz"
        ]),
        children: /*#__PURE__*/ (0, $1rY3h.jsx)("a", (0, $cxjpp._)((0, $do9pw._)({
            className: props.isSelected ? "selected" : "",
            href: props.href
        }, props.dataEventProps), {
            "data-label": props.label,
            children: props.label
        }))
    });
};
var $bcae995f435e7f67$export$2e2bcd8739ae039 = $bcae995f435e7f67$export$df4f9873dfab197b;

});

parcelRegister("axgTr", function(module, exports) {

$parcel$export(module.exports, "ProductNavDropdown", function () { return $32659ab46645420e$export$39cc2d4a9bc14e7d; });
/* product-navdropdown.tsx generated by @compiled/babel-plugin v0.28.2 */ /* eslint-disable jsx-a11y/anchor-is-valid */ 
var $cv9Rk = parcelRequire("cv9Rk");

var $1rY3h = parcelRequire("1rY3h");

var $1Mpn7 = parcelRequire("1Mpn7");

var $2vwrh = parcelRequire("2vwrh");

var $6E1VX = parcelRequire("6E1VX");

var $5nhFh = parcelRequire("5nhFh");
var $32659ab46645420e$var$parentItemStyle = null;
var $32659ab46645420e$var$dropdownStyle = null;
var $32659ab46645420e$var$listStyle = null;
var $32659ab46645420e$var$headerStyle = null;
var $32659ab46645420e$var$listItemStyle = null;
var $32659ab46645420e$var$linkStyle = null;
var $32659ab46645420e$var$mobileDropdownStyle = null;
var $32659ab46645420e$export$39cc2d4a9bc14e7d = function(param) {
    var label = param.label, _param_isMobile = param.isMobile, isMobile = _param_isMobile === void 0 ? false : _param_isMobile, groups = param.groups, _param_dataProductKey = param.dataProductKey, dataProductKey = _param_dataProductKey === void 0 ? "jiraSoftware" : _param_dataProductKey;
    var _useState = (0, $cv9Rk._)((0, $1Mpn7.useState)(false), 2), isDropdownVisible = _useState[0], setDropdownVisible = _useState[1];
    var _useState1 = (0, $cv9Rk._)((0, $1Mpn7.useState)(false), 2), isMobileDropdownVisible = _useState1[0], setMobileDropdownVisible = _useState1[1];
    var dropdownRef = (0, $1Mpn7.useRef)(null);
    (0, $5nhFh.useOutsideEvent)(dropdownRef, "click", function() {
        return setDropdownVisible(false);
    });
    (0, $5nhFh.useOutsideEvent)(dropdownRef, "focusin", function() {
        return setDropdownVisible(false);
    });
    var innerRef = (0, $1Mpn7.useRef)(null);
    (0, $5nhFh.useOutsideEvent)(innerRef, "click", function() {
        return setDropdownVisible(false);
    });
    (0, $5nhFh.useOutsideEvent)(innerRef, "focusin", function() {
        return setDropdownVisible(false);
    });
    var handleTouchEnd = function(event) {
        event.preventDefault();
        setMobileDropdownVisible(function(state) {
            return !state;
        });
    };
    var handleClick = function() {
        return setMobileDropdownVisible(function(state) {
            return !state;
        });
    };
    var handleMouseEnter = function() {
        return setDropdownVisible(true);
    };
    var handleMouseLeave = function() {
        return setDropdownVisible(false);
    };
    var handleKeyUp = function(event) {
        if (event.key === "Enter") setDropdownVisible(function(state) {
            return !state;
        });
    };
    (0, $1Mpn7.useEffect)(function() {
        if (isDropdownVisible || isMobileDropdownVisible) (0, $6E1VX.Tracking).autoTrackLinks(true);
    }, [
        isDropdownVisible,
        isMobileDropdownVisible
    ]);
    var renderGroups = function(dataProductKey) {
        return groups === null || groups === void 0 ? void 0 : groups.map(function(param, groupIndex) {
            var header = param.header, items = param.items;
            return /*#__PURE__*/ (0, $1rY3h.jsxs)((0, $1Mpn7.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $1rY3h.jsx)("li", {
                        children: /*#__PURE__*/ (0, $1rY3h.jsx)("h5", {
                            className: (0, $2vwrh.default)([
                                "_1e0c1ule _ca0q1y44 _u5f31ul9 _n3td1y44 _19bv1ul9 _o5721q9c _4bfu1r31 _1hmsglyw _ajmmnqa1 _1wyb1j6v _syaz1bqd _19pk1crf _2hwxidpf _otyridpf _18u0idpf _1p1dangw _k48p1fw0 _vwz410nf _1dyzt94y"
                            ]),
                            children: header
                        })
                    }),
                    items.map(function(param, index) {
                        var itemLabel = param.label, itemLabelEnglish = param.labelEnglish, href = param.href;
                        return /*#__PURE__*/ (0, $1rY3h.jsx)("li", {
                            className: (0, $2vwrh.default)([
                                "_kqswh2mm _1pfh1crf _6rth1crf"
                            ]),
                            children: /*#__PURE__*/ (0, $1rY3h.jsx)("a", {
                                href: href,
                                id: "dropdown-".concat(label.toLowerCase(), "-").concat(index),
                                "data-event": "clicked",
                                "data-event-component": "linkButton",
                                "data-event-container": "navbarDropdownLink",
                                "data-schema-version": "1",
                                "data-product-key": dataProductKey,
                                "data-label": itemLabel,
                                "data-label-english": itemLabelEnglish,
                                className: (0, $2vwrh.default)([
                                    "_1wyb1j6v _vwz4851k _1e0c1ule _ca0q1y44 _u5f31ul9 _n3td1y44 _19bv1ul9 _o5721q9c _4bfu1r31 _1hmsglyw _ajmmnqa1 _syazrbzz _1l4er3uz _irr3rbzz _30l3u67f"
                                ]),
                                children: itemLabel
                            })
                        }, "".concat(itemLabel, "-").concat(index));
                    })
                ]
            }, "".concat(header, "-").concat(groupIndex));
        });
    };
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
        ref: dropdownRef,
        onTouchEnd: handleTouchEnd,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onClick: handleClick,
        onFocus: handleMouseEnter,
        onKeyUp: handleKeyUp,
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsx)("a", {
                id: "dropdown-".concat(label.toLowerCase()),
                href: "#",
                "data-event": "clicked",
                "data-label": label,
                "data-event-component": "linkButton",
                "data-event-container": "navbarDropdown",
                "data-product-key": dataProductKey,
                "data-schema-version": "1",
                className: (0, $2vwrh.default)([
                    "_kqswh2mm _152t1l7b _1e0c1txw _4cvr1h6o _1wyb1j6v _vwz4kb7n _syazrbzz _30l3oelr _1b75y6p2 _rtay4h09 _16m51fys _1nbi1f51 _1l3vb3bt _1m5l1o8l _1t6ii2wt _1k6s1crf _1dqh1crf _d6wu1vv5 _1j5e4h09 _1y3ib3bt _1mhxi2wt _1nwwi2wt _fl6h1axk _l23r1axk _u5pl1kw7 _ytugq07a _gs6s19bv _1t7gbf4l _7wutjyd4 _k11laqso _1vie3iz4 _ue5gz5p3 _1yag1z0f _1gs5usvi _v9tz59zy _1s4p1osq _6ssj16zg _17p3z5p3 _1a5h19bv",
                    isMobileDropdownVisible ? "open" : ""
                ]),
                children: label
            }),
            !isMobile && isDropdownVisible ? /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                ref: innerRef,
                className: (0, $2vwrh.default)([
                    "_bfhku67f _19itulfz _2rko1y44 _16qsg1bn _kqswstnw _152t1osq _1e021ssb _t9ec1e6q _1pbyzo7u"
                ]),
                children: /*#__PURE__*/ (0, $1rY3h.jsx)("ul", {
                    className: (0, $2vwrh.default)([
                        "_qtt8glyw _bozgidpf _1q5114y2 _85i514y2 _kqswh2mm _1pbykb7n _1rusu67f _iajmidpf _1g0vidpf _1fkr1osq _z5wt1ssb _14h81fby _1kt9f705 _kfgtidpf _1mp4idpf _1cs8stnw _dsq4glyw _7dwzzr6s _15l21hqi _1bqq1mrw _1guf1osq _g0nf1ssb _eq43105i _aetrf705 _1qdgidpf _z0aiidpf _18postnw _11fnglyw _1cteu67f _clh3zr6s"
                    ]),
                    children: renderGroups(dataProductKey)
                })
            }) : null,
            isMobile && isMobileDropdownVisible ? /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                ref: innerRef,
                className: (0, $2vwrh.default)([
                    "_1hziidpf _3n4midpf _ltofidpf _k7zyidpf"
                ]),
                children: /*#__PURE__*/ (0, $1rY3h.jsx)("ul", {
                    children: renderGroups(dataProductKey)
                })
            }) : null
        ]
    });
};
var $32659ab46645420e$export$2e2bcd8739ae039 = $32659ab46645420e$export$39cc2d4a9bc14e7d;

});



parcelRegister("5XId8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f88a13f5f08925b9$export$2e2bcd8739ae039; });
/* tabs.tsx generated by @compiled/babel-plugin v0.28.2 */ 
var $1rY3h = parcelRequire("1rY3h");
parcelRequire("1Mpn7");

var $2vwrh = parcelRequire("2vwrh");

var $dFwuF = parcelRequire("dFwuF");
var $8pPrt = parcelRequire("8pPrt");
parcelRequire("2miCy");
var $7UzgT = parcelRequire("7UzgT");
parcelRequire("4b5hS");
var $9KBmC = parcelRequire("9KBmC");

var $bvCMH = parcelRequire("bvCMH");
var $f88a13f5f08925b9$var$TabsSection = function() {
    var intl = (0, $8pPrt.default)();
    var QUOTE_IMAGE_PROPS = {
        className: "tab-quote-image",
        src: "https://wac-cdn.atlassian.com/dam/jcr:5412ebd3-6135-4109-9ffc-666961b9bad2/quote.svg?cdnVersion=1220",
        alt: intl.formatMessage({
            id: "JiraSoftwarePageTemplate.tabs.quoteAlt",
            defaultMessage: "Quotation mark"
        })
    };
    var planLocalizedImageSrc = (0, $bvCMH.getPlanTabsSectionImage)(intl.locale);
    var planLocalizedVideoSrc = (0, $bvCMH.getPlanTabsSectionVideo)(intl.locale);
    var trackLocalizedImageSrc = (0, $bvCMH.getTrackTabsSectionImage)(intl.locale);
    var releaseLocalizedImageSrc = (0, $bvCMH.getReleaseTabsSectionImage)(intl.locale);
    var reportLocalizedImageSrc = (0, $bvCMH.getReportTabsSectionImage)(intl.locale);
    var automateLocalizedImageSrc = (0, $bvCMH.getAutomateTabsSectionImage)(intl.locale);
    var getPlanLocalizedMedia = function(locale) {
        // english should show a still image, other locales will show a localized gif (since the still has not been localized)
        if (locale === "en") return {
            imageProps: {
                src: "https://wac-cdn.atlassian.com/dam/jcr:49c215de-3b05-40f8-96e2-6dc65c70caa6/Board.png?cdnVersion=1187",
                alt: intl.formatMessage({
                    id: "JiraSoftwarePageTemplate.tabsPlan.imageAltText",
                    defaultMessage: "" // TODO - still awaiting what this should be
                }),
                aspectRatio: "none"
            }
        };
        return {
            videoProps: {
                videoLink: planLocalizedVideoSrc,
                videoPreviewImage: planLocalizedImageSrc,
                aspectRatio: "none"
            }
        };
    };
    var planLocalizedMedia = getPlanLocalizedMedia(intl.locale);
    var tabs = [
        {
            textLabel: "Plan",
            id: "tab-plan",
            headerText: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsHeader.plan",
                defaultMessage: "Plan"
            }),
            bodyText: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsBody.plan",
                defaultMessage: "Break the big ideas down into manageable chunks across teams with user stories, issues, and tasks."
            }),
            quoteImageProps: QUOTE_IMAGE_PROPS,
            quote: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsQuote.plan",
                defaultMessage: "Work becomes a lot more visible when it's all in one place. It makes collaboration a whole lot easier."
            }),
            name: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsName.plan",
                defaultMessage: "Jeff Lai"
            }),
            company: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $dFwuF.default), {
                id: "JiraSoftwarePageTemplate.tabsCompany.plan",
                defaultMessage: "Internal Infrastructure, canva",
                values: (0, $7UzgT.DEFAULT_VALUES)
            }),
            display: planLocalizedMedia
        },
        {
            textLabel: "Track",
            id: "tab-track",
            headerText: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsHeader.track",
                defaultMessage: "Track"
            }),
            bodyText: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsBody.track",
                defaultMessage: "Prioritize and discuss your team\u2019s work in context with complete visibility at every level."
            }),
            quoteImageProps: QUOTE_IMAGE_PROPS,
            quote: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsQuote.track",
                defaultMessage: "The pace of delivery from idea to reality has exploded."
            }),
            name: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsName.track",
                defaultMessage: "Greg Franklin"
            }),
            company: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $dFwuF.default), {
                id: "JiraSoftwarePageTemplate.tabsCompany.track",
                defaultMessage: "Agile lead, Cancer Research UK",
                values: (0, $7UzgT.DEFAULT_VALUES)
            }),
            display: {
                imageProps: {
                    src: trackLocalizedImageSrc,
                    alt: intl.formatMessage({
                        id: "JiraSoftwarePageTemplate.tabsImageAltText.track",
                        defaultMessage: "The timeline view in Jira allows users to review progress by sprints in weeks, months, or quarters. Status is by category in this example."
                    })
                }
            }
        },
        {
            textLabel: "Release",
            id: "tab-release",
            headerText: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsHeader.release",
                defaultMessage: "Release"
            }),
            bodyText: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsBody.release",
                defaultMessage: "Ship faster, with confidence knowing the information you have is always up-to-date."
            }),
            quoteImageProps: QUOTE_IMAGE_PROPS,
            quote: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsQuote.release",
                defaultMessage: "Less friction in the development process means better results and a faster time to market."
            }),
            name: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsName.release",
                defaultMessage: "Louis Bennett"
            }),
            company: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $dFwuF.default), {
                id: "JiraSoftwarePageTemplate.tabsCompany.release",
                defaultMessage: "Director of Engineering, Trulia",
                values: (0, $7UzgT.DEFAULT_VALUES)
            }),
            display: {
                imageProps: {
                    src: releaseLocalizedImageSrc,
                    alt: intl.formatMessage({
                        id: "JiraSoftwarePageTemplate.tabsImageAltText.release",
                        defaultMessage: "Releases within a Jira project. This view contains the version, status, progress, start date, release date, and description."
                    })
                }
            }
        },
        {
            textLabel: "Report",
            id: "tab-report",
            headerText: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsHeader.report",
                defaultMessage: "Report"
            }),
            bodyText: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsBody.report",
                defaultMessage: "Improve team performance in context, based on real-time, visual data."
            }),
            quoteImageProps: QUOTE_IMAGE_PROPS,
            quote: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsQuote.report",
                defaultMessage: "Full visibility in Jira across the whole organization enables you to make better management judgment. "
            }),
            name: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsName.report",
                defaultMessage: "Paul Leaon"
            }),
            company: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $dFwuF.default), {
                id: "JiraSoftwarePageTemplate.tabsCompany.report",
                defaultMessage: "Digital Portfolio Director, Inchcape",
                values: (0, $7UzgT.DEFAULT_VALUES)
            }),
            display: {
                imageProps: {
                    src: reportLocalizedImageSrc,
                    alt: intl.formatMessage({
                        id: "JiraSoftwarePageTemplate.tabsImageAltText.report",
                        defaultMessage: "Within the Kanban board in Jira, a project backlog shows 5 issues are on the board and 8 are in backlog."
                    })
                }
            }
        },
        {
            textLabel: "Automate",
            id: "tab-automate",
            headerText: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsHeader.automate",
                defaultMessage: "Automate"
            }),
            bodyText: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsBody.automate",
                defaultMessage: "Save time, keep your team focused, and help work flow with no-code automation."
            }),
            quoteImageProps: QUOTE_IMAGE_PROPS,
            quote: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsQuote.automate",
                defaultMessage: "We\u2019re saving 150 hours+ of valuable engineering time per month. "
            }),
            name: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsName.automate",
                defaultMessage: "Jeff Lai"
            }),
            company: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $dFwuF.default), {
                id: "JiraSoftwarePageTemplate.tabsCompany.automate",
                defaultMessage: "Internal Infrastructure, canva",
                values: (0, $7UzgT.DEFAULT_VALUES)
            }),
            display: {
                imageProps: {
                    src: automateLocalizedImageSrc,
                    alt: intl.formatMessage({
                        id: "JiraSoftwarePageTemplate.tabsImageAltText.automate",
                        defaultMessage: "Automation workflow in Jira. An example automation closes all stories in an epic when the epic is completed."
                    })
                }
            }
        }
    ];
    return /*#__PURE__*/ (0, $1rY3h.jsx)("section", {
        className: (0, $2vwrh.default)([
            "_1dyznl7k _30peazy9 _6k4u1ssb _8vi8mgnk _1ls11dfr _1so11y44 _5ilw7vkz _9oja1y44 _yf2h7vkz _1n8kokh7 _1r41p9y3 _14lo1ehm _1hkv1r31 _ntb519ly _spxy1o36 _hycx1k92 _1ijg1j28 _10ed1mjv _c2wd14gx _d7qx1osq _kzzg1wug _t4tn1wug _sfzq1wug _rsoa1wug _xkf4glyw _5e4v1j6v _zglv1ylp _10h7idpf _9enho7ao _10k7idpf _g2i4o7ao _1glu1osq _16gd1r31 _1ifu19ly _15ln1o36 _19p01osq _1flj66rk _w7gs7vkz _o1ft7vkz _vryy7vkz _rtmh7vkz _1lz31y6m _121fidpf _12k3idpf _8bimidpf _1cw3idpf _1b951git _14761osq _175ko9bh _rp0i1ewx _23ow1txw _1t831sxn _sbm7i47z _1j2u1h6o _1b6rbfng _wg8cnl7k _16y31td8 _vussahaf _i80qidpf _1y3uidpf _vq3zidpf _1x7sidpf _suv51td8 _uyj9ahaf _gem2idpf _1gtzidpf _19s1idpf _p2anidpf _10tn1tcg _v3z0lnmy _10vf1tcg _p1061k92 _7iyz4jg8 _zqtwnl7k _130319ii _ebc91k8s _18gv1k8s _lik2glyw _1wkh1msg _1nq1glyw _bh331k92 _1s0mcjiy _tq29oxwj _1bap10nf _9izn12it _14sx1l9c _1kz6cs5v _19mv12it _q7gq1k92 _zcqxcjiy"
        ]),
        children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $9KBmC.TabsQuote), {
            id: "tabs-section",
            label: "Tabs",
            headerText: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsHeader",
                defaultMessage: "All from a single source of truth"
            }),
            bodyText: "",
            tabs: tabs,
            colors: {
                defaultBG: "#42526e",
                defaultText: "#dfe1e6",
                activeBG: "#57d9a3",
                activeText: "#091e42",
                hoverBG: "#42526e",
                hoverText: "#dfe1e6",
                quoteColor: "#0065ff"
            },
            className: "software-jira-tabs"
        })
    });
};
var $f88a13f5f08925b9$export$2e2bcd8739ae039 = $f88a13f5f08925b9$var$TabsSection;

});
parcelRegister("4b5hS", function(module, exports) {
$parcel$export(module.exports, "TabsQuote", function () { return (parcelRequire("9KBmC")).TabsQuote; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("9KBmC")).TabsQuote; });

var $9KBmC = parcelRequire("9KBmC");

});
parcelRegister("9KBmC", function(module, exports) {

$parcel$export(module.exports, "TabsQuote", function () { return $efdd264f05677606$export$ad1b9d9a70aaa9a5; });
/* tabs-quote.tsx generated by @compiled/babel-plugin v0.28.2 */ 
var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $1rY3h = parcelRequire("1rY3h");
parcelRequire("1Mpn7");

var $2vwrh = parcelRequire("2vwrh");
parcelRequire("8AsWs");
var $4OHyT = parcelRequire("4OHyT");
parcelRequire("dLifx");
var $6WnuF = parcelRequire("6WnuF");
parcelRequire("faSeQ");
var $cosJC = parcelRequire("cosJC");
parcelRequire("9DBuW");
var $dXeyw = parcelRequire("dXeyw");
var $efdd264f05677606$var$StatsStyle = null;
var $efdd264f05677606$var$TabsWrapper = null;
var $efdd264f05677606$export$ad1b9d9a70aaa9a5 = function(param) {
    var id = param.id, label = param.label, headerText = param.headerText, bodyText = param.bodyText, tabs = param.tabs, colors = param.colors, ctaProps = param.ctaProps, _param_linkPosition = param.linkPosition, linkPosition = _param_linkPosition === void 0 ? "bottom" : _param_linkPosition, className = param.className, _param_tabContentType = param.tabContentType, tabContentType = _param_tabContentType === void 0 ? "quoteTextImage" : _param_tabContentType, _param_shouldUseRowRevised = param.shouldUseRowRevised, shouldUseRowRevised = _param_shouldUseRowRevised === void 0 ? false : _param_shouldUseRowRevised;
    var rowProps = shouldUseRowRevised ? {
        rowRevised: {
            layout: "10"
        }
    } : {
        row: {
            layout: "reduced"
        }
    };
    var linkRowProps = shouldUseRowRevised ? {
        rowRevised: {}
    } : {
        row: {}
    };
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
        className: (0, $2vwrh.default)([
            "_syazu67f _ca0qvbgk _u5f3idpf _n3tdvbgk _19bvidpf _i6jxckbl _1lh7idpf _z3ncckbl _wpaiidpf _1kmxzwfg _1ggmidpf _1ykzzwfg _1maeidpf",
            className
        ]),
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsx)((0, $dXeyw.RowWrapper), (0, $cxjpp._)((0, $do9pw._)({}, rowProps), {
                children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $4OHyT.ContentBlock), {
                    className: "tabs-quote-header-content-block",
                    headerText: headerText,
                    headerType: "h2",
                    bodyText: bodyText,
                    isCentered: true,
                    ctaProps: linkPosition == "top" && (ctaProps === null || ctaProps === void 0 ? void 0 : ctaProps.primaryLinkProps) ? ctaProps : {}
                })
            })),
            /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                className: (0, $2vwrh.default)([
                    "_ca0qgktf _u5f3idpf _n3tdgktf _19bvidpf",
                    "tabquote-tab-group-div"
                ]),
                children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $cosJC.TabGroup), {
                    colors: colors,
                    tabContentType: tabContentType,
                    tabs: tabs,
                    id: id,
                    label: label
                })
            }),
            linkPosition == "bottom" && (ctaProps === null || ctaProps === void 0 ? void 0 : ctaProps.primaryLinkProps) ? /*#__PURE__*/ (0, $1rY3h.jsx)((0, $dXeyw.RowWrapper), (0, $cxjpp._)((0, $do9pw._)({}, linkRowProps), {
                children: /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                    style: {
                        textAlign: "center"
                    },
                    children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $6WnuF.Link), (0, $do9pw._)({}, ctaProps.primaryLinkProps))
                })
            })) : null
        ]
    });
};

});
parcelRegister("faSeQ", function(module, exports) {
$parcel$export(module.exports, "Quote", function () { return (parcelRequire("cosJC")).Quote; });
$parcel$export(module.exports, "TabGroup", function () { return (parcelRequire("cosJC")).TabGroup; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("cosJC")).TabGroup; });

var $cosJC = parcelRequire("cosJC");

});
parcelRegister("cosJC", function(module, exports) {

$parcel$export(module.exports, "Quote", function () { return $48196cd0b796095d$export$82b8d343c504672; });
$parcel$export(module.exports, "TabGroup", function () { return $48196cd0b796095d$export$85fd4ed3b8ca1010; });
/* tab-group.tsx generated by @compiled/babel-plugin v0.28.2 */ 
var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $cv9Rk = parcelRequire("cv9Rk");

var $1rY3h = parcelRequire("1rY3h");

var $2vwrh = parcelRequire("2vwrh");
var $bStPI = parcelRequire("bStPI");

var $1Mpn7 = parcelRequire("1Mpn7");
parcelRequire("9DBuW");
var $0r70l = parcelRequire("0r70l");
parcelRequire("f69lk");
var $7Xv9a = parcelRequire("7Xv9a");
parcelRequire("8AsWs");
var $4OHyT = parcelRequire("4OHyT");
parcelRequire("55RaN");
var $6mH68 = parcelRequire("6mH68");
parcelRequire("dLifx");
var $6WnuF = parcelRequire("6WnuF");
parcelRequire("8MZtw");
var $bFWGH = parcelRequire("bFWGH");
var $48196cd0b796095d$var$TabGroupStyle = null;
var $48196cd0b796095d$var$quoteSidebar = null;
var $48196cd0b796095d$var$tabPanel = null;
var $48196cd0b796095d$var$contentBlockStyle = null;
var $48196cd0b796095d$var$cardRules = {
    6: 1,
    5: 2,
    4: 2,
    3: 3,
    2: 4
};
var $48196cd0b796095d$var$CardStyleDisplay = function(tab) {
    return /*#__PURE__*/ (0, $1rY3h.jsx)((0, $0r70l.RowRevised), {
        children: tab.cards.map(function(card, index) {
            return /*#__PURE__*/ (0, $1rY3h.jsx)((0, $7Xv9a.Card), (0, $cxjpp._)((0, $do9pw._)({}, card), {
                aspectRatio: tab.cards.length < 3 ? "16/9" : "3/2"
            }), index);
        })
    });
};
var $48196cd0b796095d$export$625d95e4189a6523 = function(props) {
    var _tabDisplay_videoProps_videoLink, _tabDisplay_imageProps_src, _tabDisplay_imageProps_alt;
    var tabDisplay = props.tab.display;
    var elementToDisplay = null;
    if ("videoProps" in tabDisplay && ((_tabDisplay_videoProps_videoLink = tabDisplay.videoProps.videoLink) === null || _tabDisplay_videoProps_videoLink === void 0 ? void 0 : _tabDisplay_videoProps_videoLink.length)) elementToDisplay = /*#__PURE__*/ (0, $1rY3h.jsx)((0, $bFWGH.Video), (0, $do9pw._)({}, tabDisplay.videoProps));
    else if ("imageProps" in tabDisplay && ((_tabDisplay_imageProps_src = tabDisplay.imageProps.src) === null || _tabDisplay_imageProps_src === void 0 ? void 0 : _tabDisplay_imageProps_src.length) && ((_tabDisplay_imageProps_alt = tabDisplay.imageProps.alt) === null || _tabDisplay_imageProps_alt === void 0 ? void 0 : _tabDisplay_imageProps_alt.length)) elementToDisplay = /*#__PURE__*/ (0, $1rY3h.jsx)((0, $6mH68.Image), (0, $do9pw._)({}, tabDisplay.imageProps));
    else if (/*#__PURE__*/ (0, $1Mpn7.isValidElement)(tabDisplay)) elementToDisplay = tabDisplay;
    return elementToDisplay;
};
var $48196cd0b796095d$export$82b8d343c504672 = function(props) {
    var _props_colors;
    var backgroundImageColor = ((_props_colors = props.colors) === null || _props_colors === void 0 ? void 0 : _props_colors.quoteColor) ? "linear-gradient(90deg, transparent, ".concat(props.colors.quoteColor, ")") : "transparent";
    var quoteWrapperClass = props.isDisplayInSmScreen ? "quote-wrapper isDisplayInSmScreen" : "quote-wrapper";
    var quoteStyle = null;
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
        className: (0, $2vwrh.default)([
            "_y3gn1e5h _19pkidpf _2hwxidpf _otyr1tcg _18u0idpf _ca0q1ul9 _u5f312am _n3td1ul9 _19bvidpf _2rko1ygb _1itk1mlj _urbdidpf _bh33qgp8 _z1c11td8 _1r1x8n31 _sjb1gktf _1pntidpf _1pugidpf _s3jyidpf _177hangw _1i5midpf _utopidpf _rggridpf _1ie3idpf _14sxoxwj _1uc8angw _sugaglyw _1kmxidpf _1ggmidpf _1ykzidpf _1maeidpf _p0bo1ule",
            quoteWrapperClass
        ]),
        style: {
            "--_xnxqej": (0, $bStPI.default)(backgroundImageColor)
        },
        children: [
            props.image ? props.image : null,
            /*#__PURE__*/ (0, $1rY3h.jsx)("p", {
                className: "quote-blurb",
                children: props.quote
            }),
            props.name ? /*#__PURE__*/ (0, $1rY3h.jsx)("p", {
                className: "quote-name",
                children: props.name
            }) : null,
            props.company ? /*#__PURE__*/ (0, $1rY3h.jsx)("p", {
                className: "quote-company",
                children: props.company
            }) : null
        ]
    });
};
var $48196cd0b796095d$var$QuoteTextImage = function(tab, colors) {
    var _tab_headerTextType;
    return /*#__PURE__*/ (0, $1rY3h.jsxs)((0, $0r70l.RowRevised), {
        layout: "4-8",
        adjustedMobilePadding: 0,
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
                className: (0, $2vwrh.default)([
                    "_y3gn1e5h"
                ]),
                children: [
                    tab.headerText ? /*#__PURE__*/ (0, $1rY3h.jsx)((0, $4OHyT.ContentBlock), {
                        headerText: tab.headerText,
                        bodyText: tab.bodyText,
                        headerType: (_tab_headerTextType = tab.headerTextType) !== null && _tab_headerTextType !== void 0 ? _tab_headerTextType : "h3",
                        iconName: tab.iconName,
                        className: (0, $2vwrh.default)([
                            "_p12f1osq _19pkidpf _2hwx1wug _otyr1tcg _18u01wug _gltebxu3"
                        ])
                    }) : null,
                    tab.quote ? /*#__PURE__*/ (0, $1rY3h.jsx)($48196cd0b796095d$export$82b8d343c504672, {
                        image: tab.quoteImageProps && /*#__PURE__*/ (0, $1rY3h.jsx)((0, $6mH68.Image), (0, $do9pw._)({}, tab.quoteImageProps)),
                        quote: tab.quote,
                        name: tab.name,
                        company: tab.company,
                        isDisplayInSmScreen: tab.isDisplayQuoteInSmScreen || false,
                        colors: colors
                    }) : null,
                    tab.ctaProps && tab.ctaProps.primaryLinkProps ? /*#__PURE__*/ (0, $1rY3h.jsx)((0, $6WnuF.Link), (0, $do9pw._)({}, tab.ctaProps.primaryLinkProps)) : null
                ]
            }),
            $48196cd0b796095d$export$625d95e4189a6523({
                tab: tab
            })
        ]
    });
};
var $48196cd0b796095d$var$TextImageFullWidth = function(tab) {
    return /*#__PURE__*/ (0, $1rY3h.jsx)((0, $0r70l.RowRevised), {
        children: /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
            children: [
                tab.headerText ? /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                    className: (0, $2vwrh.default)([
                        "_p12f1osq _19pkidpf _2hwx1wug _otyr1tcg _18u01wug _gltebxu3",
                        "content-block"
                    ]),
                    children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $4OHyT.ContentBlock), {
                        headerText: tab.headerText,
                        bodyText: tab.bodyText,
                        headerType: "h2",
                        isCentered: true
                    })
                }) : null,
                $48196cd0b796095d$export$625d95e4189a6523({
                    tab: tab
                })
            ]
        })
    });
};
var $48196cd0b796095d$var$TabContent = function(tabContentType, tab, tabsLength, colors) {
    var cardRule = $48196cd0b796095d$var$cardRules[tabsLength];
    switch(tabContentType){
        case "custom":
            if (!("component" in tab)) throw new Error("Must provide a `customComponent` JSX node");
            if (typeof tab.component === "function") {
                var TabComponent = tab.component;
                return /*#__PURE__*/ (0, $1rY3h.jsx)(TabComponent, {});
            }
            return tab.component;
        case "cards":
            if (!("cards" in tab)) throw new Error("Must provide an array of card values in the `cards` tab prop");
            else if (tab.cards.length > cardRule) throw new Error("For a group of ".concat(tabsLength, " tabs, no more than ").concat(cardRule, " cards per tab"));
            return $48196cd0b796095d$var$CardStyleDisplay(tab);
        case "quoteTextImage":
            if (!("display" in tab)) throw new Error("Please provide image or video props");
            return $48196cd0b796095d$var$QuoteTextImage(tab, colors);
        case "textImageFullWidth":
            if (!("display" in tab)) throw new Error("Please provide image or video props");
            return $48196cd0b796095d$var$TextImageFullWidth(tab);
        default:
            return null;
    }
};
var $48196cd0b796095d$var$updateURL = function(tabId) {
    var newParams = new URLSearchParams(window.location.search);
    if (tabId) {
        newParams.set("tab", tabId);
        console.log(newParams.toString());
        window.history.pushState({}, "", "?".concat(newParams.toString()));
    }
};
var $48196cd0b796095d$var$getTabStyle = function(colors, isActive) {
    if (isActive) return {
        backgroundColor: (colors === null || colors === void 0 ? void 0 : colors.activeBG) || "#b2d4ff",
        color: (colors === null || colors === void 0 ? void 0 : colors.activeText) || "#091e42",
        borderColor: (colors === null || colors === void 0 ? void 0 : colors.activeBG) || "#b2d4ff",
        hoverBG: (colors === null || colors === void 0 ? void 0 : colors.activeBG) || "#b2d4ff",
        hoverText: (colors === null || colors === void 0 ? void 0 : colors.activeText) || "#091e42",
        activeBGColor: (colors === null || colors === void 0 ? void 0 : colors.activeBG) || "#b2d4ff",
        hoverBGColor: (colors === null || colors === void 0 ? void 0 : colors.activeBG) || "#b2d4ff"
    };
    return {
        backgroundColor: (colors === null || colors === void 0 ? void 0 : colors.defaultBG) || "#f4f5f7",
        color: (colors === null || colors === void 0 ? void 0 : colors.defaultText) || "#091e42",
        borderColor: "transparent",
        hoverBG: (colors === null || colors === void 0 ? void 0 : colors.hoverBG) || "#ebecf0",
        hoverText: (colors === null || colors === void 0 ? void 0 : colors.hoverText) || "#091e42",
        activeBGColor: (colors === null || colors === void 0 ? void 0 : colors.activeBG) || "#b2d4ff",
        hoverBGColor: (colors === null || colors === void 0 ? void 0 : colors.hoverBG) || "#ebecf0"
    };
};
var $48196cd0b796095d$var$TabGroupInner = function(param) {
    var index = param.index, currentTab = param.currentTab, tab = param.tab, colors = param.colors, dataProductKey = param.dataProductKey, onDesktopClickHandler = param.onDesktopClickHandler, setCurrentTab = param.setCurrentTab;
    var isActive = index === currentTab;
    var _getTabStyle = $48196cd0b796095d$var$getTabStyle(colors, isActive), activeBGColor = _getTabStyle.activeBGColor, hoverBGColor = _getTabStyle.hoverBGColor, backgroundColor = _getTabStyle.backgroundColor, color = _getTabStyle.color, borderColor = _getTabStyle.borderColor, hoverBG = _getTabStyle.hoverBG, hoverText = _getTabStyle.hoverText;
    var tabStyle = null;
    var _tab_iconBefore;
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("button", {
        type: "button",
        role: "tab",
        value: tab.textLabel,
        "aria-selected": index === currentTab,
        "aria-controls": tab.id,
        id: tab.id,
        "data-event-component": "linkButton",
        "data-event-container": "tabContent",
        "data-event": "clicked",
        "data-label": tab.textLabel,
        "data-product-key": dataProductKey,
        onClick: function(event) {
            setCurrentTab(index);
            $48196cd0b796095d$var$updateURL(tab.id);
            if (onDesktopClickHandler) onDesktopClickHandler(event);
        },
        className: (0, $2vwrh.default)([
            "_80omtlke _2rko12am _vchhusvi _1y1m1u8q _ca0q19bv _u5f31ul9 _n3td19bv _19bv1ul9 _r06hglyw _1dqonqa1 _189eyh40 _1h6d1j28 _ect41td8 _1dyz1d98 _1seqidpf _zecv1wug _1uldidpf _1pp41wug _3zq41ule _1blx1osq _3p1c1k92 _so7d1qy7 _bfhkaxbu _syaz1aj3 _jomr10a2 _irr310a2 _f8pj7ny5 _30l37ny5 _858u1srq _4cvx1srq _1qyg1r31 _1vu3glyw _1j6qidpf _o6871w4s _q4ztj7jn"
        ]),
        style: {
            "--_1ly4823": (0, $bStPI.default)(backgroundColor),
            "--_1ylxx6h": (0, $bStPI.default)(color),
            "--_mf9og": (0, $bStPI.default)(hoverBG),
            "--_3siqzd": (0, $bStPI.default)(hoverText),
            "--_37cwmb": (0, $bStPI.default)(borderColor),
            "--_1kkre8f": (0, $bStPI.default)(activeBGColor),
            "--_h2utlw": (0, $bStPI.default)(hoverBGColor)
        },
        children: [
            (_tab_iconBefore = tab.iconBefore) !== null && _tab_iconBefore !== void 0 ? _tab_iconBefore : tab.iconBefore,
            tab.isForceDisplayTextLabelOnPill ? tab.textLabel : "headerText" in tab ? tab.headerText : tab.textLabel
        ]
    }, "tab-".concat(index, "-").concat(tab.id));
};
var $48196cd0b796095d$var$TabOption = function(param) {
    var index = param.index, currentTab = param.currentTab, tab = param.tab, colors = param.colors, dataProductKey = param.dataProductKey;
    var isActive = index === currentTab;
    var _getTabStyle = $48196cd0b796095d$var$getTabStyle(colors, isActive), activeBGColor = _getTabStyle.activeBGColor, hoverBGColor = _getTabStyle.hoverBGColor, backgroundColor = _getTabStyle.backgroundColor, color = _getTabStyle.color, borderColor = _getTabStyle.borderColor, hoverBG = _getTabStyle.hoverBG, hoverText = _getTabStyle.hoverText;
    var tabStyle = null;
    return /*#__PURE__*/ (0, $1rY3h.jsx)("option", {
        "data-index": index,
        "data-id": tab.id,
        "data-event-component": "linkButton",
        "data-event-container": "tabContent",
        "data-event": "clicked",
        "data-label": tab.textLabel,
        "data-product-key": dataProductKey,
        value: tab.textLabel,
        "aria-selected": index === currentTab,
        "aria-describedby": "tab-".concat(tab.id),
        className: (0, $2vwrh.default)([
            "_80omtlke _2rko12am _vchhusvi _1y1m1u8q _ca0q19bv _u5f31ul9 _n3td19bv _19bv1ul9 _r06hglyw _1dqonqa1 _189eyh40 _1h6d1j28 _ect41td8 _1dyz1d98 _1seqidpf _zecv1wug _1uldidpf _1pp41wug _3zq41ule _1blx1osq _3p1c1k92 _so7d1qy7 _bfhkaxbu _syaz1aj3 _jomr10a2 _irr310a2 _f8pj7ny5 _30l37ny5 _858u1srq _4cvx1srq _1qyg1r31 _1vu3glyw _1j6qidpf _o6871w4s _q4ztj7jn"
        ]),
        style: {
            "--_1ly4823": (0, $bStPI.default)(backgroundColor),
            "--_1ylxx6h": (0, $bStPI.default)(color),
            "--_mf9og": (0, $bStPI.default)(hoverBG),
            "--_3siqzd": (0, $bStPI.default)(hoverText),
            "--_37cwmb": (0, $bStPI.default)(borderColor),
            "--_1kkre8f": (0, $bStPI.default)(activeBGColor),
            "--_h2utlw": (0, $bStPI.default)(hoverBGColor)
        },
        children: tab.isForceDisplayTextLabelOnPill ? tab.textLabel : "headerText" in tab ? tab.headerText : tab.textLabel
    }, "option-".concat(index, "-").concat(tab.id));
};
var $48196cd0b796095d$var$TabSelect = function(param) {
    var id = param.id, currentTab = param.currentTab, tabs = param.tabs, colors = param.colors, updateURL = param.updateURL, onMobileChangeHandler = param.onMobileChangeHandler, setCurrentTab = param.setCurrentTab, dataProductKey = param.dataProductKey;
    var _tabs_currentTab, _tabs_;
    var isActive = true; // Always active for TabSelect
    var _getTabStyle = $48196cd0b796095d$var$getTabStyle(colors, isActive), activeBGColor = _getTabStyle.activeBGColor, hoverBGColor = _getTabStyle.hoverBGColor, backgroundColor = _getTabStyle.backgroundColor, color = _getTabStyle.color, borderColor = _getTabStyle.borderColor, hoverBG = _getTabStyle.hoverBG, hoverText = _getTabStyle.hoverText;
    var tabStyle = null;
    var handleChange = function(event) {
        var _event_target_selectedOptions_, _event_target, _event_target_selectedOptions_1, _event_target1;
        var selectedIndex = event === null || event === void 0 ? void 0 : (_event_target = event.target) === null || _event_target === void 0 ? void 0 : (_event_target_selectedOptions_ = _event_target.selectedOptions[0]) === null || _event_target_selectedOptions_ === void 0 ? void 0 : _event_target_selectedOptions_.dataset["index"];
        var selectedId = event === null || event === void 0 ? void 0 : (_event_target1 = event.target) === null || _event_target1 === void 0 ? void 0 : (_event_target_selectedOptions_1 = _event_target1.selectedOptions[0]) === null || _event_target_selectedOptions_1 === void 0 ? void 0 : _event_target_selectedOptions_1.dataset["id"];
        setCurrentTab(Number(selectedIndex));
        updateURL(selectedId);
        if (onMobileChangeHandler) onMobileChangeHandler(event);
    };
    return /*#__PURE__*/ (0, $1rY3h.jsx)("select", {
        id: id,
        className: (0, $2vwrh.default)([
            "_80omtlke _2rko12am _vchhusvi _1y1m1u8q _ca0q19bv _u5f31ul9 _n3td19bv _19bv1ul9 _r06hglyw _1dqonqa1 _189eyh40 _1h6d1j28 _ect41td8 _1dyz1d98 _1seqidpf _zecv1wug _1uldidpf _1pp41wug _3zq41ule _1blx1osq _3p1c1k92 _so7d1qy7 _bfhkaxbu _syaz1aj3 _jomr10a2 _irr310a2 _f8pj7ny5 _30l37ny5 _858u1srq _4cvx1srq _1qyg1r31 _1vu3glyw _1j6qidpf _o6871w4s _q4ztj7jn",
            "select"
        ]),
        value: ((_tabs_currentTab = tabs[currentTab]) === null || _tabs_currentTab === void 0 ? void 0 : _tabs_currentTab.textLabel) || ((_tabs_ = tabs[0]) === null || _tabs_ === void 0 ? void 0 : _tabs_.textLabel),
        onChange: handleChange,
        style: {
            "--_1ly4823": (0, $bStPI.default)(backgroundColor),
            "--_1ylxx6h": (0, $bStPI.default)(color),
            "--_mf9og": (0, $bStPI.default)(hoverBG),
            "--_3siqzd": (0, $bStPI.default)(hoverText),
            "--_37cwmb": (0, $bStPI.default)(borderColor),
            "--_1kkre8f": (0, $bStPI.default)(activeBGColor),
            "--_h2utlw": (0, $bStPI.default)(hoverBGColor)
        },
        children: tabs.map(function(tab, index) {
            return /*#__PURE__*/ (0, $1rY3h.jsx)($48196cd0b796095d$var$TabOption, {
                index: index,
                tab: tab,
                colors: colors,
                dataProductKey: dataProductKey,
                currentTab: currentTab
            }, "option-".concat(index, "-").concat(tab.id));
        })
    });
};
var $48196cd0b796095d$export$85fd4ed3b8ca1010 = function(props) {
    var _tabsMap_currentTab, _tabsMap_currentTab1;
    var tabContentType = props.tabContentType, tabs = props.tabs, colors = props.colors, id = props.id, label = props.label, dataProductKey = props.dataProductKey, onDesktopClickHandler = props.onDesktopClickHandler, onMobileChangeHandler = props.onMobileChangeHandler;
    var _useState = (0, $cv9Rk._)((0, $1Mpn7.useState)(function() {
        var params = new URLSearchParams(window.location.search);
        var paramID = params.get("tab");
        var matchingTab = tabs.findIndex(function(tab) {
            return tab.id === paramID;
        });
        if (matchingTab >= 0) return matchingTab;
        return 0;
    }), 2), currentTab = _useState[0], setCurrentTab = _useState[1];
    if (!id || !label) throw new Error('"id" and "label" props are required for accessibility!');
    if (tabs.length > 6 || tabs.length < 2) throw new Error("Must have a minimum of 2 and a maximum of 6 tabs per group!");
    var tabsMap = tabs.reduce(function(map, obj, index) {
        map[index] = obj;
        return map;
    }, {});
    var MobileSelect = function() {
        var selectContainerColor = (colors === null || colors === void 0 ? void 0 : colors.activeText) ? colors.activeText : "#091e42";
        var selectContainerStyles = null;
        return /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
            className: (0, $2vwrh.default)([
                "_1bah1h6o _suga1txw _181nglyw _12xhh2mm _d7qx1osq _c2wd1pna _qj6jstnw _14z6gktf _7x8didpf _jm44idpf _wppf1wug _6mc91wug _1yyz1wug _c8mx1wug _1vd7171q",
                "select-container"
            ]),
            style: {
                "--_1uth3n3": (0, $bStPI.default)(selectContainerColor)
            },
            children: /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
                className: "select-container-inner",
                children: [
                    /*#__PURE__*/ (0, $1rY3h.jsx)("label", {
                        htmlFor: id,
                        "aria-label": label,
                        children: /*#__PURE__*/ (0, $1rY3h.jsx)($48196cd0b796095d$var$TabSelect, {
                            id: id,
                            currentTab: currentTab,
                            tabs: tabs,
                            colors: colors,
                            updateURL: $48196cd0b796095d$var$updateURL,
                            setCurrentTab: setCurrentTab,
                            dataProductKey: dataProductKey,
                            onMobileChangeHandler: onMobileChangeHandler
                        })
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("svg", {
                        width: "15",
                        height: "8",
                        viewBox: "0 0 15 8",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0, $1rY3h.jsx)("path", {
                            d: "M1.5 1L7.5 7L13.5 1",
                            stroke: "currentColor",
                            strokeWidth: "2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        })
                    })
                ]
            })
        });
    };
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
        className: (0, $2vwrh.default)([
            "_p12f1osq",
            "tab-group"
        ]),
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                role: "tablist",
                className: (0, $2vwrh.default)([
                    "_sugaglyw _1cj31txw _196r1h6o _270t1g80 _wmdl7vkz"
                ]),
                children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $0r70l.RowRevised), {
                    children: /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                        className: "tab-group-inner",
                        children: tabs.map(function(tab, index) {
                            return /*#__PURE__*/ (0, $1rY3h.jsx)($48196cd0b796095d$var$TabGroupInner, {
                                tab: tab,
                                index: index,
                                colors: colors,
                                dataProductKey: dataProductKey,
                                onDesktopClickHandler: onDesktopClickHandler,
                                setCurrentTab: setCurrentTab,
                                currentTab: currentTab
                            }, "tab-".concat(index, "-").concat(tab.id));
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)((0, $0r70l.RowRevised), {
                children: /*#__PURE__*/ (0, $1rY3h.jsx)(MobileSelect, {})
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                className: "tab-panels",
                children: /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                    className: (0, $2vwrh.default)([
                        "_19pkgktf _2hwx1wug _otyridpf _18u01wug _mderglyw",
                        "tab-panel"
                    ]),
                    "aria-hidden": false,
                    id: "tab-".concat((_tabsMap_currentTab = tabsMap[currentTab]) === null || _tabsMap_currentTab === void 0 ? void 0 : _tabsMap_currentTab.id),
                    children: $48196cd0b796095d$var$TabContent(tabContentType, tabsMap[currentTab], tabs.length, colors)
                }, "tabpanel-".concat(currentTab, "-").concat((_tabsMap_currentTab1 = tabsMap[currentTab]) === null || _tabsMap_currentTab1 === void 0 ? void 0 : _tabsMap_currentTab1.id))
            })
        ]
    });
};

});
parcelRegister("f69lk", function(module, exports) {
$parcel$export(module.exports, "Card", function () { return (parcelRequire("7Xv9a")).Card; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("7Xv9a")).Card; });

var $7Xv9a = parcelRequire("7Xv9a");

});
parcelRegister("7Xv9a", function(module, exports) {

$parcel$export(module.exports, "Card", function () { return $9da4f3cad7a8c1ee$export$60332b2344f7fe41; });
/* card.tsx generated by @compiled/babel-plugin v0.28.2 */ 
var $1rY3h = parcelRequire("1rY3h");
parcelRequire("1Mpn7");

var $2vwrh = parcelRequire("2vwrh");
var $bStPI = parcelRequire("bStPI");
parcelRequire("8AsWs");
var $4OHyT = parcelRequire("4OHyT");
var $9da4f3cad7a8c1ee$var$containerStyles = null;
var $9da4f3cad7a8c1ee$var$contentBlockStyles = null;
var $9da4f3cad7a8c1ee$var$barStyles = null;
var $9da4f3cad7a8c1ee$export$60332b2344f7fe41 = function(props) {
    var textColor = props.textColor, headerType = props.headerType, headerText = props.headerText, bodyText = props.bodyText, eyebrowText = props.eyebrowText, footerHeader = props.footerHeader, footerText = props.footerText, imageLink = props.imageLink, imageAltText = props.imageAltText, backgroundColor = props.backgroundColor, colorBars = props.colorBars, iconName = props.iconName, iconColor = props.iconColor, _props_barColor = props.barColor, barColor = _props_barColor === void 0 ? "" : _props_barColor, className = props.className, ctaProps = props.ctaProps, aspectRatio = props.aspectRatio, orientation = props.orientation, pictureProps = props.pictureProps;
    if (imageLink && !imageAltText) throw new Error("If using an image, please provide an alt text for accessibility purposes!");
    var cardBackBackgroundColor = backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : "#ffffff";
    var cardBackTextColor = textColor !== null && textColor !== void 0 ? textColor : "#091e42";
    var cardBackColor = null;
    var contentBlockIconColor = iconColor !== null && iconColor !== void 0 ? iconColor : "#091e42";
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
        className: (0, $2vwrh.default)([
            "_2rkoyh40 _16qs1nta _1e0c1txw _2lx21bp4 _p12fg505 _7cca15wb _4t3i1osq",
            "_bfhk16d1 _syazn54i",
            className
        ]),
        style: {
            "--_1vkwvj7": (0, $bStPI.default)(cardBackBackgroundColor),
            "--_1dl5pj2": (0, $bStPI.default)(cardBackTextColor)
        },
        children: [
            colorBars == "top" || colorBars == "both" ? /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                style: {
                    backgroundColor: barColor,
                    borderTopRightRadius: "4px",
                    borderTopLeftRadius: "4px"
                },
                className: (0, $2vwrh.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq _4t3iftgi"
                ])
            }) : "",
            /*#__PURE__*/ (0, $1rY3h.jsx)((0, $4OHyT.ContentBlock), {
                cardStyle: true,
                aspectRatio: aspectRatio,
                orientation: orientation,
                headerType: headerType,
                headerText: headerText,
                bodyText: bodyText,
                imageLink: imageLink,
                imageAltText: imageAltText,
                eyebrowText: eyebrowText,
                footerHeader: footerHeader,
                footerText: footerText,
                iconColor: contentBlockIconColor,
                iconName: iconName,
                ctaProps: ctaProps,
                pictureProps: pictureProps,
                className: (0, $2vwrh.default)([
                    "_4t3i1osq"
                ])
            }),
            colorBars == "bottom" || colorBars == "both" ? /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                style: {
                    backgroundColor: barColor,
                    borderBottomRightRadius: "4px",
                    borderBottomLeftRadius: "4px"
                },
                className: (0, $2vwrh.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq _4t3iftgi"
                ])
            }) : ""
        ]
    });
};

});


parcelRegister("8MZtw", function(module, exports) {
$parcel$export(module.exports, "Video", function () { return (parcelRequire("bFWGH")).Video; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("bFWGH")).Video; });

var $bFWGH = parcelRequire("bFWGH");

});
parcelRegister("bFWGH", function(module, exports) {

$parcel$export(module.exports, "Video", function () { return $8cb53cab412dd1c6$export$ae01dedf5c052bb; });

var $do9pw = parcelRequire("do9pw");

var $1rY3h = parcelRequire("1rY3h");
var $8cb53cab412dd1c6$var$videoStyle = function(ratio) {
    var aspectRatioCSS = ratio && ratio !== "none" ? {
        aspectRatio: ratio,
        objectFit: "cover"
    } : {};
    return (0, $do9pw._)({
        maxWidth: "100%"
    }, aspectRatioCSS);
};
var $8cb53cab412dd1c6$export$ae01dedf5c052bb = function(param) {
    var videoLink = param.videoLink, videoType = param.videoType, videoPreviewImage = param.videoPreviewImage, _param_loop = param.loop, loop = _param_loop === void 0 ? true : _param_loop, _param_muted = param.muted, muted = _param_muted === void 0 ? true : _param_muted, aspectRatio = param.aspectRatio, alternativeSources = param.alternativeSources, className = param.className;
    return(// eslint-disable-next-line jsx-a11y/media-has-caption
    /*#__PURE__*/ (0, $1rY3h.jsxs)("video", {
        playsInline: true,
        muted: muted,
        preload: "auto",
        poster: videoPreviewImage,
        autoPlay: true,
        className: className,
        style: $8cb53cab412dd1c6$var$videoStyle(aspectRatio),
        loop: loop,
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsx)("source", {
                src: videoLink,
                type: "video/".concat(videoType ? videoType : "mp4")
            }),
            alternativeSources ? alternativeSources.map(function(source, index) {
                return /*#__PURE__*/ (0, $1rY3h.jsx)("source", {
                    src: source.videoLink,
                    type: "video/".concat(source.videoType ? source.videoType : "mp4")
                }, index);
            }) : null
        ]
    }));
};

});







parcelRegister("kPein", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02c53544e355261f$export$2e2bcd8739ae039; });
/* workflow.tsx generated by @compiled/babel-plugin v0.28.2 */ 
var $1rY3h = parcelRequire("1rY3h");
parcelRequire("1Mpn7");

var $2vwrh = parcelRequire("2vwrh");

var $dFwuF = parcelRequire("dFwuF");
var $8pPrt = parcelRequire("8pPrt");
parcelRequire("55RaN");
var $6mH68 = parcelRequire("6mH68");
parcelRequire("dLifx");
var $6WnuF = parcelRequire("6WnuF");
parcelRequire("faSeQ");
var $cosJC = parcelRequire("cosJC");
parcelRequire("2miCy");
var $7UzgT = parcelRequire("7UzgT");
var $hot2Q = parcelRequire("hot2Q");
parcelRequire("9DBuW");
var $dXeyw = parcelRequire("dXeyw");

var $bvCMH = parcelRequire("bvCMH");
var $02c53544e355261f$var$sectionStyles = null;
var $02c53544e355261f$var$h3Styles = null;
var $02c53544e355261f$var$WorkflowSection = function() {
    var intl = (0, $8pPrt.default)();
    var localizedImageSrc = (0, $bvCMH.getWorkflowSectionImage)(intl.locale);
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("section", {
        className: (0, $2vwrh.default)([
            "_4cvr1h6o _syazu67f _1e0c1txw _2lx21bp4 _1itkq02d _12vemgnk _quu71osq _4sdy1git _1ywg1g6a _17m61ssb _16nzmgnk _9r801dfr _fehp1txw _4fwavrvc _x1y5xjmg _1j0qkb7n _lei9kb7n _16arf1ug _10hl1406 _1uazkb7n _sjxrf1ug _f5z6nr4h _cx5866rk _bh331k92 _1s0mcjiy _tq29oxwj _1bap10nf _9izn12it _14sx1l9c _1kz6cs5v _19mv12it _1dne1h6o _bclw1txw _lqde1h6o _1qws1bp4 _14zohiv4 _16qj9by0 _dzynhiv4 _pdzvhiv4 _11ku1txw _ty5v1h6o _12451bp4 _1bgrhiv4 _151u9by0"
        ]),
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsx)("h2", {
                className: (0, $2vwrh.default)([
                    "_y3gn1h6o _k48p4jg8 _1wybahaf _1lzoviql _1cqs1k8s _q5ugidpf _7tldidpf _14adidpf _4uroidpf"
                ]),
                children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $dFwuF.default), {
                    id: "JiraSoftwarePageTemplate.workflowSection.header",
                    defaultMessage: "Easier than ever",
                    values: (0, $7UzgT.DEFAULT_VALUES)
                })
            }),
            /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
                className: "workflow-body",
                children: [
                    /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                        className: "icon-gradient",
                        children: /*#__PURE__*/ (0, $1rY3h.jsx)($02c53544e355261f$var$IconGradient, {})
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                        className: "workflow-container",
                        children: /*#__PURE__*/ (0, $1rY3h.jsxs)((0, $dXeyw.Row), {
                            layout: "6-6",
                            children: [
                                /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
                                    className: "workflow-center-left",
                                    children: [
                                        /*#__PURE__*/ (0, $1rY3h.jsx)("h3", {
                                            className: (0, $2vwrh.default)([
                                                "_y3gn1h6o _18s8fpvv _k48p4jg8 _1s181k8s _1cqs15x9"
                                            ]),
                                            children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $dFwuF.default), {
                                                id: "JiraSoftwarePageTemplate.workflowSection.templatesHeader",
                                                defaultMessage: "Templates give you a head start",
                                                values: (0, $7UzgT.DEFAULT_VALUES)
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $1rY3h.jsx)("p", {
                                            className: "workflow-paragraph",
                                            children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $dFwuF.default), {
                                                id: "JiraSoftwarePageTemplate.workflowSection.templatesSubheader",
                                                defaultMessage: "Get started with ready-made templates.",
                                                values: (0, $7UzgT.DEFAULT_VALUES)
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
                                            className: "template-items-container",
                                            children: [
                                                /*#__PURE__*/ (0, $1rY3h.jsx)($02c53544e355261f$var$TemplateItem, {
                                                    headerText: intl.formatMessage({
                                                        id: "JiraSoftwarePageTemplate.workflowSection.scrum",
                                                        defaultMessage: "Scrum"
                                                    }),
                                                    image: "https://wac-cdn.atlassian.com/dam/jcr:9567a40e-6541-4905-bf08-dfe201aa80e7/illustrations-spot-Agile.svg?cdnVersion=1194",
                                                    imageAltText: intl.formatMessage({
                                                        id: "JiraSoftwarePageTemplate.workflowSection.scrumImageAltText",
                                                        defaultMessage: "Agile illustration"
                                                    }),
                                                    href: (0, $hot2Q.useLocalizedHref)("/software/jira/templates/scrum")
                                                }),
                                                /*#__PURE__*/ (0, $1rY3h.jsx)($02c53544e355261f$var$TemplateItem, {
                                                    headerText: intl.formatMessage({
                                                        id: "JiraSoftwarePageTemplate.workflowSection.kanban",
                                                        defaultMessage: "Kanban"
                                                    }),
                                                    image: "https://wac-cdn.atlassian.com/dam/jcr:7d0e6516-361d-4ec3-bd0f-22d7c7d105b4/illustrations-spot-JIRA%20Board.svg?cdnVersion=1194",
                                                    imageAltText: intl.formatMessage({
                                                        id: "JiraSoftwarePageTemplate.workflowSection.kanbanImageAltText",
                                                        defaultMessage: "Kanban illustration"
                                                    }),
                                                    href: (0, $hot2Q.useLocalizedHref)("/software/jira/templates/kanban")
                                                }),
                                                /*#__PURE__*/ (0, $1rY3h.jsx)($02c53544e355261f$var$TemplateItem, {
                                                    headerText: intl.formatMessage({
                                                        id: "JiraSoftwarePageTemplate.workflowSection.bugTracking",
                                                        defaultMessage: "Bug tracking"
                                                    }),
                                                    image: "https://wac-cdn.atlassian.com/dam/jcr:a2b254dd-146a-4ea9-9ae0-ec5d250a9cbf/JSW_ProductTour_DarkModeIllustration_BugTracking_Spot.svg?cdnVersion=1194",
                                                    imageAltText: intl.formatMessage({
                                                        id: "JiraSoftwarePageTemplate.workflowSection.bugTrackingImageAltText",
                                                        defaultMessage: "Bug illustration"
                                                    }),
                                                    href: (0, $hot2Q.useLocalizedHref)("/software/jira/templates/bug-tracking")
                                                }),
                                                /*#__PURE__*/ (0, $1rY3h.jsx)($02c53544e355261f$var$TemplateItem, {
                                                    headerText: intl.formatMessage({
                                                        id: "JiraSoftwarePageTemplate.workflowSection.devops",
                                                        defaultMessage: "DevOps"
                                                    }),
                                                    image: "https://wac-cdn.atlassian.com/dam/jcr:6505f1fe-f628-460f-987b-c07fab309341/devops-spot-logo.svg?cdnVersion=1194",
                                                    imageAltText: intl.formatMessage({
                                                        id: "JiraSoftwarePageTemplate.workflowSection.devopsImageAltText",
                                                        defaultMessage: "Devops illustration"
                                                    }),
                                                    href: (0, $hot2Q.useLocalizedHref)("/software/jira/templates/devops")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                                            className: (0, $2vwrh.default)([
                                                "_2rko1msg _ahbq16gx"
                                            ]),
                                            children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $cosJC.Quote), {
                                                image: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $6mH68.Image), {
                                                    className: "quote-image",
                                                    src: "https://wac-cdn.atlassian.com/dam/jcr:5412ebd3-6135-4109-9ffc-666961b9bad2/quote.svg?cdnVersion=1220",
                                                    alt: intl.formatMessage({
                                                        id: "JiraSoftwarePageTemplate.workflowSection.quoteImage",
                                                        defaultMessage: "Quotation mark"
                                                    })
                                                }),
                                                quote: intl.formatMessage({
                                                    id: "JiraSoftwarePageTemplate.workflowSection.quote",
                                                    defaultMessage: "You can decide how you are working as a team first and then let the software work around you."
                                                }) + '"',
                                                name: intl.formatMessage({
                                                    id: "JiraSoftwarePageTemplate.workflowSection.name",
                                                    defaultMessage: "Maria Bonorchis"
                                                }),
                                                company: intl.formatMessage({
                                                    id: "JiraSoftwarePageTemplate.workflowSection.company",
                                                    defaultMessage: "Agile Delivery Manager, Cancer Research UK"
                                                }),
                                                colors: {
                                                    defaultBG: "#42526e",
                                                    defaultText: "#dfe1e6",
                                                    activeBG: "#57d9a3",
                                                    activeText: "#091e42",
                                                    hoverBG: "#172b4d",
                                                    hoverText: "#dfe1e6",
                                                    quoteColor: "#0065ff"
                                                }
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
                                    className: "workflow-center-right",
                                    children: [
                                        /*#__PURE__*/ (0, $1rY3h.jsx)("h3", {
                                            className: (0, $2vwrh.default)([
                                                "_y3gn1h6o _18s8fpvv _k48p4jg8 _1s181k8s _1cqs15x9"
                                            ]),
                                            children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $dFwuF.default), {
                                                id: "JiraSoftwarePageTemplate.workflowSection.customizeHeader",
                                                defaultMessage: "Then customize as you grow",
                                                values: (0, $7UzgT.DEFAULT_VALUES)
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $1rY3h.jsx)("p", {
                                            className: "workflow-paragraph",
                                            children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $dFwuF.default), {
                                                id: "JiraSoftwarePageTemplate.workflowSection.customizeSubheader",
                                                defaultMessage: "Jira adapts to the way you work, not the other way around. Start simple, customize as you go.",
                                                values: (0, $7UzgT.DEFAULT_VALUES)
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $1rY3h.jsx)((0, $6mH68.Image), {
                                            src: localizedImageSrc,
                                            alt: "Diagram showcasing an example workflow using Jira Software"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $02c53544e355261f$var$iconGradientStyles = null;
var $02c53544e355261f$var$IconGradient = function() {
    var intl = (0, $8pPrt.default)();
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
        className: (0, $2vwrh.default)([
            "_1e0c1txw _1bah1yb4 _p12fbxu3 _ouxl1ssb _12vemgnk _1gde1bp4 _1ywgi5dd _9r80vpnh _1u2q1x1l _xlt11x1l _476d1ssb _tnru22di _1lp7vrvc _7uciw5cs _1l1414tn _1wfq176h _15vt176h _1ywmx19p _1lvax19p _14b51nrf _qst38vuz"
        ]),
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsx)((0, $6mH68.Image), {
                className: "workflow-icon",
                src: "https://wac-cdn.atlassian.com/dam/jcr:ef95fe7f-398f-4690-83af-831ef07adf34/icon-templates.svg?cdnVersion=1216",
                alt: intl.formatMessage({
                    id: "JiraSoftwarePageTemplate.workflowSection.templatesIcon",
                    defaultMessage: "Templates icon"
                })
            }),
            /*#__PURE__*/ (0, $1rY3h.jsx)((0, $6mH68.Image), {
                className: "workflow-icon",
                src: "https://wac-cdn.atlassian.com/dam/jcr:99363e04-3456-415d-b2e1-b311cc0a8444/icon-workflow.svg?cdnVersion=1216",
                alt: intl.formatMessage({
                    id: "JiraSoftwarePageTemplate.workflowSection.workflowIcon",
                    defaultMessage: "Workflow icon"
                })
            })
        ]
    });
};
var $02c53544e355261f$var$templateStyles = null;
var $02c53544e355261f$var$TemplateItem = function(param) {
    var headerText = param.headerText, image = param.image, imageAltText = param.imageAltText, href = param.href;
    var intl = (0, $8pPrt.default)();
    var dataEventProps = {
        "data-event-component": "linkButton",
        "data-event-container": "workflowSection",
        "data-event": "clicked",
        "data-product-key": "jiraSoftware"
    };
    return /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
        className: (0, $2vwrh.default)([
            "_1e0c1txw _1mgfv2br _a9cgmbak _18s81o9i _1bsb1osq _1dfe1eps _l0kh1eps _jaedbfng _h1451k92 _qyzc1td8 _1reg1h6o _ornn1bqd _1c4j1txw _1dr3ap9k _jsbh1h6o _1ebyxjmg _18lj146b _1qmmmbak _1c1i1fhb _1twsalr3 _1d591txw _uuuv1bp4 _1nfs1h6o _juhrxjmg _c8eh1eps _1vcgxjmg _1hec1osq _1oqcidpf _1i6fidpf _x83zdlk8 _416xidpf _znp2i0pe _13fei0pe _rh7zi0pe _1oiii0pe _b2flx7w3 _hvglx7w3 _fza7x7w3 _1urxx7w3 _jds6i0pe _l3b8i0pe _54zzi0pe _15zui0pe _12591r31 _10e48stv _3zu2nqa1 _17ccvkbu"
        ]),
        children: [
            /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                className: "template-image-container",
                children: /*#__PURE__*/ (0, $1rY3h.jsx)((0, $6mH68.Image), {
                    src: image,
                    alt: imageAltText
                })
            }),
            /*#__PURE__*/ (0, $1rY3h.jsxs)("div", {
                className: "template-link-container",
                children: [
                    /*#__PURE__*/ (0, $1rY3h.jsx)("div", {
                        className: "template-header",
                        children: headerText
                    }),
                    /*#__PURE__*/ (0, $1rY3h.jsx)((0, $6WnuF.Link), {
                        text: intl.formatMessage({
                            id: "JiraSoftwarePageTemplate.workflowSection.learnMore",
                            defaultMessage: "Learn more"
                        }),
                        href: href,
                        bgColor: "bgDark",
                        dataEventProps: dataEventProps
                    })
                ]
            })
        ]
    });
};
var $02c53544e355261f$export$2e2bcd8739ae039 = $02c53544e355261f$var$WorkflowSection;

});





var $41f9d27ccd5957d1$exports = {};


(parcelRequire("bRvn3")).register((parcelRequire("6Aq0R")).getBundleURL("lqmve"), JSON.parse('["lqmve","jira-software-page.8701f186.js","kkiwx","ufo-create-payload.545b61e5.js","4F7y4","esm.ddb4fa51.js","6j3nX","atlassian-light.10b6ba8d.js","cWPTZ","atlassian-light-increased-contrast.4b39ef3c.js","b5bLO","atlassian-dark.15db2b60.js","3dF3X","atlassian-dark-increased-contrast.fa81a0f2.js","1MP1e","atlassian-legacy-light.0033302f.js","iPSug","atlassian-legacy-dark.7e5dcd50.js","7xQL9","atlassian-spacing.808048e5.js","betUP","atlassian-typography-adg3.55db12eb.js","3dWtk","atlassian-shape.530cf072.js","bu8X5","atlassian-light-new-input-border.5bdd01c8.js","6JKFD","atlassian-dark-new-input-border.6f100635.js","jqcFX","atlassian-typography.3540583e.js","OV2GL","atlassian-typography-minor3.17861b3c.js","fEfqe","custom-theme.87155462.js","fGmim","language-selector.1d5ee2fe.js","67RI7","app-switcher.bd38c900.js","bILJT","robot-error.a89bf4f4.js","1frsj","atlassian-switcher.8e26fd8c.js","8IX4X","jira-switcher.5f1f6b25.js","bTvGy","ufo.d31a75eb.js","7uWpt","confluence-switcher.bf56b23d.js","cSLUl","generic-switcher.3b5d253c.js","3kpQg","trello-switcher.b4f5f0e7.js","lz6mY","dropdown-import.7e05f58a.js","im0wQ","esm.322730dd.js","eU2gm","checkemail-page.58c41b61.css"]'));


var $gCajc = parcelRequire("gCajc");

var $6SrBz = parcelRequire("6SrBz");
(0, $gCajc.init)((0, $6SrBz.JiraSoftwarePage));

})();
//# sourceMappingURL=jira-software-page.8701f186.js.map
